export const COMPANY_NAME_OPTIONS = [
    'NAMAN FINLEASE',
    'HUEY TECH',
    'RELIANCE INDUSTRIES',
    'RELIANCE JIO',
    'AIRTEL',
    'VODAFONE IDEA',
    'ADANI ENTERPRISES',
    'LARSEN & TOUBRO',
    'TATA STEEL',
    'TATA MOTORS',
    'MAHINDRA & MAHINDRA',
    'MARUTI SUZUKI',
    'BAJAJ AUTO',
    'HERO MOTOCORP',
    'TVS MOTOR',
    'ASHOK LEYLAND',
    'ULTRATECH CEMENT',
    'ACC',
    'AMBUJA CEMENTS',
    'JSW STEEL',
    'HINDALCO',
    'VEDANTA',
    'COAL INDIA',
    'ONGC',
    'INDIAN OIL',
    'BHARAT PETROLEUM',
    'HINDUSTAN PETROLEUM',
    'NTPC',
    'POWER GRID',
    'TATA POWER',
    'ADANI POWER',
    'ADANI GREEN ENERGY',
    'SUN PHARMA',
    'DR REDDYS',
    'CIPLA',
    'LUPIN',
    'DIVIS LABORATORIES',
    'AUROBINDO PHARMA',
    'BIOCON',
    'APOLLO HOSPITALS',
    'FORTIS HEALTHCARE',
    'MAX HEALTHCARE',
    'ASIAN PAINTS',
    'BERGER PAINTS',
    'HINDUSTAN UNILEVER',
    'ITC',
    'NESTLE INDIA',
    'BRITANNIA',
    'DABUR',
    'GODREJ CONSUMER PRODUCTS',
    'COLGATE PALMOLIVE INDIA',
    'PIDILITE',
    'MARICO',
    'TITAN',
    'AVENUE SUPERMARTS',
    'DMART',
    'TRENT',
    'ZOMATO',
    'SWIGGY',
    'PAYTM',
    'PHONEPE',
    'RAZORPAY',
    'POLICYBAZAAR',
    'OLA ELECTRIC',
    'UBER INDIA',
    'FLIPKART',
    'AMAZON INDIA',
    'MEESHO',
    'NYKAA',
    'BYJUS',
    'UNACADEMY',
    'UPGRAD',
    'ZOHO',
    'FRESHWORKS',
    'ACCENTURE',
    'ACCENTURE SOLUTIONS',
    'INFOSYS BPM',
    'TCS DIGITAL',
    'TCS ION',
    'WIPRO DIGITAL',
    'HCL SOFTWARE',
    'CAPGEMINI ENGINEERING',
    'COGNIZANT DIGITAL ENGINEERING',
    'DXC TECHNOLOGY',
    'ATOS INDIA',
    'NTT DATA',
    'FUJITSU INDIA',
    'HITACHI VANTARA',
    'LENOVO INDIA',
    'DELL TECHNOLOGIES',
    'HP INDIA',
    'CISCO SYSTEMS INDIA',
    'VMWARE INDIA',
    'RED HAT INDIA',
    'ADOBE INDIA',
    'INTEL INDIA',
    'NVIDIA INDIA',
    'QUALCOMM INDIA',
    'ARM INDIA',
    'TEXAS INSTRUMENTS INDIA',
    'SYNOPSYS INDIA',
    'CADENCE INDIA',
    'BROADCOM INDIA',
    'PAYPAL INDIA',
    'AMERICAN EXPRESS TECHNOLOGY',
    'MASTERCARD INDIA',
    'VISA INDIA',
    'PHONEPE TECHNOLOGY',
    'RAZORPAY SOFTWARE',
    'CRED',
    'UPSTOX',
    'ZERODHA',
    'GROWW',
    'NAVI TECHNOLOGIES',
    'MONEYVIEW',
    'JUSPAY',
    'DREAM11',
    'OLA KRUTRIM',
    'SWIGGY TECHNOLOGIES',
    'ZOMATO INTERNET',
    'FLIPKART INTERNET',
    'AMAZON DEVELOPMENT CENTRE INDIA',
    'MICROSOFT CORPORATION INDIA',
    'GOOGLE OPERATIONS CENTER INDIA',
    'META INDIA',
    'APPLE INDIA',
    'SAMSUNG R&D INSTITUTE INDIA',
    'SONY INDIA SOFTWARE CENTRE',
    'MOTOROLA MOBILITY INDIA',
    'NETFLIX INDIA',
    'UBER TECHNOLOGIES INDIA',
    'BOOKMYSHOW',
    'MAKE MY TRIP',
    'CLEARTRIP',
    'PHILIPS INDIA SOFTWARE CENTRE',
    'BOSCH GLOBAL SOFTWARE TECHNOLOGIES',
    'KPIT TECHNOLOGIES',
    'TATA ELXSI',
    'L&T TECHNOLOGY SERVICES',
    'CYIENT',
    'BIRLASOFT',
    'SONATA SOFTWARE',
    'ZENSAR TECHNOLOGIES',
    'RAMCO SYSTEMS',
    'NEWGEN SOFTWARE',
    'INTELLECT DESIGN ARENA',
    'HAPPIEST MINDS',
    'THOUGHTWORKS',
    'PUBLICIS SAPIENT',
    'EPAM SYSTEMS INDIA',
    'GLOBANT INDIA',
    'SLK SOFTWARE',
    'UST GLOBAL',
    'BRILLIO',
    'MU SIGMA',
    'MATHCO',
    'LIC',
    'SBI CARDS',
    'ICICI SECURITIES',
    'HDFC SECURITIES',
    'MOTILAL OSWAL',
    'ANGEL ONE',
    '5PAISA CAPITAL',
    'IIFL FINANCE',
    'EDELWEISS FINANCIAL SERVICES',
    'M&M FINANCIAL SERVICES',
    'L&T FINANCE',
    'LIC HOUSING FINANCE',
    'PNB HOUSING FINANCE',
    'AAVAS FINANCIERS',
    'CAN FIN HOMES',
    'REC LIMITED',
    'PFC',
    'INDIAN RENEWABLE ENERGY DEVELOPMENT AGENCY',
    'NABARD',
    'SIDBI',
    'EXIM BANK',
    'NSE',
    'BSE',
    'CDSL',
    'NSDL',
    'UTI AMC',
    'HDFC AMC',
    'NIPPON LIFE INDIA AMC',
    'SBI MUTUAL FUND',
    'ICICI PRUDENTIAL AMC',
    'KOTAK MAHINDRA CAPITAL',
    'BAJAJ HOUSING FINANCE',
    'PIRAMAL ENTERPRISES',
    'PIRAMAL FINANCE',
    'TATA CAPITAL',
    'MIRAE ASSET',
    'AKUMS DRUGS AND PHARMACEUTICALS',
    'GLENMARK PHARMACEUTICALS',
    'TORRENT PHARMACEUTICALS',
    'ALKEM LABORATORIES',
    'IPCA LABORATORIES',
    'ZYDUS LIFESCIENCES',
    'ABBOTT INDIA',
    'PFIZER INDIA',
    'SANOFI INDIA',
    'GSK PHARMACEUTICALS',
    'LAURUS LABS',
    'NATCO PHARMA',
    'AJANTA PHARMA',
    'ERIS LIFESCIENCES',
    'JUBILANT PHARMOVA',
    'WOCKHARDT',
    'GLAND PHARMA',
    'SUVEN PHARMACEUTICALS',
    'NEULAND LABORATORIES',
    'STRIDES PHARMA SCIENCE',
    'SYNGENE INTERNATIONAL',
    'METROPOLIS HEALTHCARE',
    'LAL PATHLABS',
    'THYROCARE',
    'NARAYANA HEALTH',
    'APTUS VALUE HOUSING FINANCE',
    'CREDITACCESS GRAMEEN',
    'SPANDANA SPHOORTY FINANCIAL',
    'FUSION MICRO FINANCE',
    'AROHAN FINANCIAL SERVICES',
    'ICICI LOMBARD',
    'HDFC ERGO',
    'BAJAJ ALLIANZ',
    'SBI GENERAL INSURANCE',
    'RELIANCE GENERAL INSURANCE',
    'SOUTH INDIAN BANK',
    'KARUR VYSYA BANK',
    'CITY UNION BANK',
    'DCB BANK',
    'TAMILNAD MERCANTILE BANK',
    'MANKIND PHARMA',
    'JB CHEMICALS AND PHARMACEUTICALS',
    'ASTRAZENECA PHARMA INDIA',
    'MARKSANS PHARMA',
    'AARTI DRUGS',
    'VIJAYA DIAGNOSTIC CENTRE',
    'KRSNAA DIAGNOSTICS',
    'DR AGARWALS HEALTH CARE',
    'INMOBI',
    'SHARECHAT',
    'POSTMAN',
    'BROWSERSTACK',
    'RUPEEK',
    'CUMMINS INDIA',
    'SCHNEIDER ELECTRIC INDIA',
    'HONEYWELL AUTOMATION INDIA',
    'ADITYA BIRLA CAPITAL',
    'ADITYA BIRLA FINANCE',
    'SUNDARAM FINANCE',
    'CHOLA INVESTMENT AND FINANCE',
    'MAHINDRA FINANCE',
    'MOTILAL OSWAL FINANCIAL SERVICES',
    'INDIABULLS HOUSING FINANCE',
    'HDB FINANCIAL SERVICES',
    'HOME FIRST FINANCE',
    'SHRIRAM HOUSING FINANCE',
    'UTKARSH SMALL FINANCE BANK',
    'EQUITAS SMALL FINANCE BANK',
    'UJJIVAN SMALL FINANCE BANK',
    'ESAF SMALL FINANCE BANK',
    'JANA SMALL FINANCE BANK',
    'AU SMALL FINANCE BANK',
    'FINCARE SMALL FINANCE BANK',
    'NORTH EAST SMALL FINANCE BANK',
    'SURYODAY SMALL FINANCE BANK',
    'BANDHAN FINANCIAL SERVICES',
    'MAX LIFE INSURANCE',
    'BAJAJ ALLIANZ LIFE INSURANCE',
    'TATA AIG GENERAL INSURANCE',
    'ICICI PRUDENTIAL',
    'HDFC ERGO GENERAL INSURANCE',
    'GODREJ PROPERTIES',
    'DLF',
    'PRESTIGE ESTATES',
    'OBEROI REALTY',
    'LODHA DEVELOPERS',
    'BRIGADE ENTERPRISES',
    'PHOENIX MILLS',
    'SOBHA',
    'MINDSPACE BUSINESS PARKS REIT',
    'EMBASSY OFFICE PARKS REIT',
    'BHARTI HEXACOM',
    'TATA COMMUNICATIONS',
    'RAILTEL',
    'TEJAS NETWORKS',
    'HFCL',
    'STERLITE TECHNOLOGIES',
    'INDIAMART',
    'JUSTDIAL',
    'NAUKRI',
    'INFO EDGE',
    'CARTRADE',
    'CARDEKHO',
    'CARS24',
    'URBAN COMPANY',
    'NOBROKER',
    'LENSKART',
    'FIRSTCRY',
    'BIGBASKET',
    'GROFERS',
    'BLINKIT',
    'ZEPTO',
    'DUNZO',
    'DELHIVERY LIMITED',
    'EKA CARE',
    'PRACTO',
    'PHARMEASY',
    '1MG',
    'NETMEDS',
    'MEDPLUS HEALTH SERVICES',
    'ABBOTT HEALTHCARE',
    'NOVARTIS INDIA',
    'MERCK INDIA',
    'BAYER CROPSCIENCE',
    'GLENMARK LIFE SCIENCES',
    'SOLARA ACTIVE PHARMA SCIENCES',
    'SYNCOM FORMULATIONS',
    'TORRENT POWER',
    'JSW ENERGY',
    'TATA CHEMICALS',
    'DEEPAK NITRITE',
    'PI INDUSTRIES',
    'SRF',
    'AARTI INDUSTRIES',
    'BALKRISHNA INDUSTRIES',
    'APOLLO TYRES',
    'MRF',
    'CEAT',
    'JK TYRE',
    'BHARAT FORGE',
    'CROMPTON GREAVES CONSUMER',
    'HAVELLS INDIA',
    'DIXON TECHNOLOGIES',
    'AMBER ENTERPRISES',
    'VOLTAS',
    'BLUE STAR',
    'WHIRLPOOL INDIA',
    'LG ELECTRONICS INDIA',
    'SAMSUNG INDIA ELECTRONICS',
    'SIEMENS TECHNOLOGY AND SERVICES',
    'GE HEALTHCARE INDIA',
    'BOSCH LIMITED',
    'SKF INDIA',
    'THERMAX',
    'CUMMINS TECHNOLOGIES INDIA',
    'MIRAE ASSET GLOBAL INVESTMENTS',
    'AXIS SECURITIES',
    'KOTAK SECURITIES',
    'ICICI DIRECT',
    'HDFC CREDILA',
    'ADITYA BIRLA HOUSING FINANCE',
    'TATA INVESTMENT CORPORATION',
    'IIFL SECURITIES',
    'UNION ASSET MANAGEMENT COMPANY',
    'NIPPON INDIA MUTUAL FUND',
    'FRANKLIN TEMPLETON INDIA',
    'PGIM INDIA MUTUAL FUND',
    'HSBC ASSET MANAGEMENT INDIA',
    'SOCIETE GENERALE GLOBAL SOLUTION CENTRE',
    'BARCLAYS GLOBAL SERVICE CENTRE INDIA',
    'CITI INDIA',
    'WELLS FARGO INDIA',
    'BANK OF AMERICA INDIA',
    'CREDIT SUISSE SERVICES INDIA',
    'UBS INDIA',
    'MORGAN STANLEY ADVANTAGE SERVICES',
    'JIO PLATFORMS',
    'TATA DIGITAL',
    'PAYU INDIA',
    'PINE LABS',
    'MOBIKWIK',
    'FREECHARGE',
    'BHARATPE',
    'LENDINGKART',
    'CAPITAL FLOAT',
    'KISSHT',
    'EARLYSALARY',
    'AXIO',
    'CASHFREE PAYMENTS',
    'OPEN FINANCIAL TECHNOLOGIES',
    'OKCREDIT',
    'KHATABOOK',
    'PHONEPE BUSINESS SOLUTIONS',
    'CREDAVENUE',
    'YUBI',
    'SUGAR COSMETICS',
    'HONASA CONSUMER',
    'EMAMI',
    'BAJAJ CONSUMER CARE',
    'PATANJALI AYURVED',
    'MCDONALDS INDIA',
    'DOMINOS INDIA',
    'JUBILANT FOODWORKS',
    'WESTLIFE FOODWORLD',
    'DEvyANI INTERNATIONAL',
    'STARBUCKS INDIA',
    'CAFE COFFEE DAY',
    'ITC HOTELS',
    'INDIAN HOTELS COMPANY',
    'EIH LIMITED',
    'LEMONTREE HOTELS',
    'EASEMYTRIP',
    'YATRA ONLINE',
    'GOIBIBO',
    'OYO',
    'REDBUS',
    'POLYCAB INDIA',
    'KEI INDUSTRIES',
    'FINOLEX CABLES',
    'V GUARD INDUSTRIES',
    'BATA INDIA',
    'RELAXO FOOTWEARS',
    'PAGE INDUSTRIES',
    'ADITYA BIRLA FASHION AND RETAIL',
    'TRENT WESTSIDE',
    'SHOPPERS STOP',
    'V MART RETAIL',
    'CAMPUS ACTIVEWEAR',
    'INDIAMART INTERMESH',
    'HINDUSTAN AERONAUTICS',
    'BHARAT ELECTRONICS',
    'COCHIN SHIPYARD',
    'GARDEN REACH SHIPBUILDERS',
    'MAZAGON DOCK SHIPBUILDERS',
    'RAIL VIKAS NIGAM',
    'IRCON INTERNATIONAL',
    'NBCC INDIA',
    'NCC LIMITED',
    'KALPATARU PROJECTS INTERNATIONAL',
    'KEC INTERNATIONAL',
    'AFCONS INFRASTRUCTURE',
    'PNC INFRATECH',
    'SOBHA DEVELOPERS',
    'SUNTECK REALTY',
    'RITES LIMITED',
    'TEAMLEASE SERVICES',
    'QUESS CORP',
    'FIRSTSOURCE SOLUTIONS',
    'ECLERX SERVICES',
    'RATEGAIN TRAVEL TECHNOLOGIES',
    'ROUTE MOBILE',
    'TANLA PLATFORMS',
    'NEWGEN SOFTWARE TECHNOLOGIES',
    'SONA BLW PRECISION FORGINGS',
    'UNO MINDA',
    'MOTHERSON SUMI WIRING INDIA',
    'SAMVARDHANA MOTHERSON INTERNATIONAL',
    'TVS SUPPLY CHAIN SOLUTIONS',
    'CONCOR',
    'GATI',
    'TCI EXPRESS',
    'ALLCARGO LOGISTICS',
    'SAFEXPRESS',
    'XPRESSBEES',
    'ECOM EXPRESS',
    'DTDC',
    'TATA CONSULTING ENGINEERS',
    'L&T INFOTECH',
    'LTIMINDTREE',
    'MINDTREE',
    'MPHASIS',
    'PERSISTENT SYSTEMS',
    'COFORGE',
    'HEXAWARE',
    'ORACLE INDIA',
    'MICROSOFT INDIA',
    'GOOGLE INDIA',
    'SAP LABS INDIA',
    'SALESFORCE INDIA',
    'DELOITTE INDIA',
    'EY INDIA',
    'KPMG INDIA',
    'PWC INDIA',
    'GRANT THORNTON INDIA',
    'JPMORGAN CHASE INDIA',
    'GOLDMAN SACHS INDIA',
    'MORGAN STANLEY INDIA',
    'DEUTSCHE BANK INDIA',
    'HSBC INDIA',
    'STANDARD CHARTERED INDIA',
    'AXIS BANK',
    'KOTAK MAHINDRA BANK',
    'YES BANK',
    'IDFC FIRST BANK',
    'INDUSIND BANK',
    'FEDERAL BANK',
    'RBL BANK',
    'BANDHAN BANK',
    'STATE BANK OF INDIA',
    'PUNJAB NATIONAL BANK',
    'BANK OF BARODA',
    'CANARA BANK',
    'UNION BANK OF INDIA',
    'UCO BANK',
    'IDBI BANK',
    'BAJAJ FINSERV',
    'BAJAJ FINANCE',
    'SHRIRAM FINANCE',
    'CHOLAMANDALAM FINANCE',
    'MUTHOOT FINANCE',
    'MANAPPURAM FINANCE',
    'TATA AIA',
    'HDFC LIFE',
    'SBI LIFE',
    'ICICI PRUDENTIAL LIFE',
    'STAR HEALTH',
    'NEW INDIA ASSURANCE',
    'EICHER MOTORS',
    'SIEMENS INDIA',
    'ABB INDIA',
    'BHEL',
    'HAL',
    'BEL',
    'INDIGO',
    'AIR INDIA',
    'SPICEJET',
    'IRCTC',
    'DELHIVERY',
    'BLUEDART',
    'ADANI PORTS',
    'CONTAINER CORPORATION OF INDIA',
    'WIPRO PARI',
    'HCL INFOSYSTEMS',
    'TECH MAHINDRA',
    'TATA CONSULTANCY SERVICES',
    'INFOSYS',
    'WIPRO',
    'HCL TECHNOLOGIES',
    'ICICI BANK',
    'HDFC BANK',
    'Capgemini India Pvt. Ltd',
    'TCS',
    'Cognizant',
    'Cognizant Technology Solutions India Ltd',
    'IBM',
    'Capgemini',
    'CTS',
    'EY',
    'KPMG',
    'PwC',
    'Deloitte',
    'Capgemini Technology Services India Ltd',
    'Capgemini India Technology Services',
    'Fintech Cloud',
    'ACCENTURE INDIA',
    'GENPACT',
    'CONCENTRIX',
    'AMDOCS',
    'SERVICENOW INDIA',
    'ATLASSIAN INDIA',
    'PALO ALTO NETWORKS INDIA',
    'WORKDAY INDIA',
    'ORACLE FINANCIAL SERVICES SOFTWARE',
    'S&P GLOBAL INDIA',
    'CRISIL',
    'ICRA',
    'AMAZON SELLER SERVICES',
    'NVIDIA GRAPHICS',
    'PAYTM PAYMENTS BANK',
    'PHONEPE PRIVATE LIMITED',
    'CHOLAMANDALAM FINANCIAL HOLDINGS',
    'HERO FINCORP',
    'L&T FINANCIAL SERVICES',
    'TATA AIA LIFE INSURANCE',
    'SBI LIFE INSURANCE',
    'HDFC LIFE INSURANCE',
    'ICICI PRUDENTIAL LIFE INSURANCE',
    'STAR HEALTH INSURANCE',
    'NIVA BUPA HEALTH INSURANCE',
    'CARE HEALTH INSURANCE',
    'MARUTI SUZUKI INDIA',
    'HYUNDAI MOTOR INDIA',
    'HONDA CARS INDIA',
    'TOYOTA KIRLOSKAR MOTOR',
    'MAHINDRA AND MAHINDRA',
    'TVS MOTOR COMPANY',
    'ATHER ENERGY',
    'EXIDE INDUSTRIES',
    'AMARA RAJA ENERGY',
    'LARSEN AND TOUBRO',
    'TATA PROJECTS',
    'SHAPOORJI PALLONJI',
    'DILIP BUILDCON',
    'GMR AIRPORTS',
    'GVK POWER AND INFRASTRUCTURE',
    'IRB INFRASTRUCTURE',
    'STEEL AUTHORITY OF INDIA',
    'JINDAL STEEL AND POWER',
    'HINDALCO INDUSTRIES',
    'SHREE CEMENT',
    'ACC LIMITED',
    'DALMIA BHARAT',
    'BHARTI AIRTEL',
    'RELIANCE JIO INFOCOMM',
    'BSNL',
    'MTNL',
    'SIEMENS ENERGY INDIA',
    'GENERAL ELECTRIC INDIA',
    'TIMKEN INDIA',
    'DR REDDYS LABORATORIES',
    'SUN PHARMACEUTICAL INDUSTRIES',
    'EMCURE PHARMACEUTICALS',
    'APOLLO HOSPITALS ENTERPRISE',
    'MAX HEALTHCARE INSTITUTE',
    'MANIPAL HOSPITALS',
    'MEDANTA',
    'KIMS HOSPITALS',
    'UNITED SPIRITS',
    'UNITED BREWERIES',
    'ITC LIMITED',
    'DABUR INDIA',
    'BRITANNIA INDUSTRIES',
    'TATA CONSUMER PRODUCTS',
    'VARUN BEVERAGES',
    'PEPSICO INDIA HOLDINGS',
    'COCA COLA INDIA',
    'ADANI PORTS AND SEZ',
    'INDIAN OIL CORPORATION',
    'GAIL INDIA',
    'NTPC LIMITED',
    'POWER GRID CORPORATION OF INDIA',
    'BLUE DART EXPRESS',
    'EARTHEX',
    'BLACKBUCK',
    'MAHINDRA LOGISTICS',
    'AKASA AIR',
    'VISTARA',
    'TAJ HOTELS',
    'OBEROI HOTELS',
    'LEMON TREE HOTELS',
    'APOLLO PHARMACY',
    'MEDPLUS',
    'RELIANCE RETAIL',
    'PANTALOONS',
    'MANYAVAR',
    'JOCKEY INDIA',
    'ARVIND LIMITED',
    'RAYMOND',
    'NO BROKER',
    'URBANCLAP',
    'SNAPDEAL',
    'NAAUKRI COM',
    'ERUDITUS',
    'LTI MINDTREE',
    'HAPPiest MINDS TECHNOLOGIES',
    'HEXAWARE TECHNOLOGIES',
    'NIIT TECHNOLOGIES',
    'QUEST GLOBAL',
    'INFIBEAM AVENUES',
    'PATNI COMPUTER SYSTEMS',
    'SIERRA ATLANTIC',
    'CGI INDIA',
    'FIS GLOBAL INDIA',
    'FIDELITY NATIONAL INFORMATION SERVICES',
    'BROADRIDGE INDIA',
    'GOLDMAN SACHS SERVICES',
    'DEUTSCHE INDIA',
    'BARCLAYS INDIA',
    'HSBC ELECTRONIC DATA PROCESSING',
    'AMERICAN EXPRESS INDIA',
    'STANDARD CHARTERED GLOBAL BUSINESS SERVICES',
    'MOODYS ANALYTICS',
    'S&P GLOBAL',
    'THOMSON REUTERS INDIA',
    'STRIPE INDIA',
    'SBI SECURITIES',
    'JUST DIAL',
    'SULEKHA',
    'EASY TRIP PLANNERS',
    'OLA CABS',
    'RAPIDO',
    'HITACHI ENERGY INDIA',
    'MITSUBISHI ELECTRIC INDIA',
    'NEC INDIA',
    'REDINGTON INDIA',
    'INGRAM MICRO INDIA',
    'TECH MAHINDRA BUSINESS SERVICES',
    'SUTHERLAND GLOBAL SERVICES',
    'CONCENTRIX INDIA',
    'TELEPERFORMANCE INDIA',
    'GENPACT INDIA',
    'WNS GLOBAL SERVICES',
    'EXL SERVICE',
    'MCKINSEY KNOWLEDGE CENTRE INDIA',
    'BCG INDIA',
    'BAIN CAPABILITY NETWORK',
    'FRactal ANALYTICS',
    'LATENTVIEW ANALYTICS',
    'TIGER ANALYTICS',
    'COURSE5 INTELLIGENCE',
    'BRIDGEi2i ANALYTICS',
    'AIRTEL PAYMENTS BANK',
    'JIO PAYMENTS BANK',
    'KARNATAKA BANK',
    'BANK OF INDIA',
    'INDIAN BANK',
    'CENTRAL BANK OF INDIA',
    'INDIAN OVERSEAS BANK',
    'SMFG INDIA CREDIT',
    'MIRAE ASSET GLOBAL INVESTMENTS INDIA',
    'NIPPON LIFE INDIA ASSET MANAGEMENT',
    'UTI ASSET MANAGEMENT COMPANY',
    'ICICI PRUDENTIAL ASSET MANAGEMENT',
    'HDFC ASSET MANAGEMENT COMPANY',
    'SBI CARDS AND PAYMENT SERVICES',
    'RUPIFI TECHNOLOGY SOLUTIONS',
    'LENDINGKART FINANCE',
    'KISSHT FINANCE',
    'UNITY SMALL FINANCE BANK',
    'SLICE',
    'ONDC',
    'MOBILE PREMIER LEAGUE',
    'DREAM SPORTS',
    'GAMES24X7',
    'NAZARA TECHNOLOGIES',
    'PAYTM MONEY',
    'PAYU PAYMENTS',
    'FI MONEY',
    'OPEN',
    'ET MONEY',
    'CLEARTAX',
    'MENSA BRANDS',
    'BOAT LIFESTYLE',
    'NOISE',
    'LAVA INTERNATIONAL',
    'MICROMAX INFORMATICS',
    'DIXON TECHNOLOGIES INDIA',
    'SAIL',
    'NLC INDIA',
    'NHPC',
    'ADANI WILMAR',
    'AWL AGRI BUSINESS',
    'GODREJ INDUSTRIES',
    'SAPPHIRE FOODS INDIA',
    'TUBE INVESTMENTS OF INDIA',
    'JK TYRE AND INDUSTRIES',
    'KALYAN JEWELLERS INDIA',
    'MALABAR GOLD AND DIAMONDS',
    'TITAN COMPANY',
    'TIMEX GROUP INDIA',
    'SONATA SOFTWARE SOLUTIONS',
    'NUCLEUS SOFTWARE EXPORTS',
    '3I INFOTECH',
    'OFSS',
    'RAMCO CEMENTS',
    'THE INDIA CEMENTS',
    'JK CEMENT',
    'HEIDELBERGCEMENT INDIA',
    'RAMKRISHNA FORGINGS',
    'LLOYDS METALS AND ENERGY',
    'JINDAL STAINLESS',
    'NMDC',
    'MOIL',
    'HINDUSTAN ZINC',
    'NATIONAL ALUMINIUM COMPANY',
    'BALMER LAWRIE',
    'EIH',
    'CHALET HOTELS',
    'MAKE MYTRIP INDIA',
    'THOMAS COOK INDIA',
    'MANNAPPURAM FINANCE',
    'MUTHOOT MICROFIN',
    'FLEEK MOTORS PRIVATE LIMITED',
    'BITVYAS PRIVATE LIMITED',
    'PATEL CHOLOPURAM-THANJAVUR HIGHWAY PRIVATE LIMITED',
    'AQUNOVA PHARMA PRIVATE LIMITED',
    'RAPID METAL PRIVATE LIMITED',
    'YOUNGADULTS SOCIALTECH PRIVATE LIMITED',
    'SMARTTECH SECURE SOLUTION PRIVATE LIMITED',
    'WRKSPOT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BANDRAFOOTBALL CLUB GLOBAL PRIVATE LIMITED',
    'DRISHYAM REALTY CONSULTANT (OPC) PRIVATELIMITED',
    'FOLIFLEX CABLES (INDIA) PRIVATE LIMITED',
    'NUTRAFY WELLNESS PRIVATE LIMITED',
    'WERDH INFRATECH PRIVATE LIMITED',
    'FINEXPERTS ADVISORY SERVICES PRIVATE LIMITED',
    'TRENDWISE TECHNOLOGY LABS PRIVATE LIMITED',
    'NATUREDGE BEVERAGES PRIVATE LIMITED',
    'SOLITARY STAFFING PRIVATE LIMITED',
    'ELYTRA MOBILITY PRIVATE LIMITED',
    'CLOUD VANTAGE SOLUTIONS PRIVATE LIMITED',
    'RAFFISH COMMUNICATIONS PRIVATE LIMITED',
    'BIT PARK PRIVATE LIMITED',
    'REDUX CREDIT FINANCE PRIVATE LIMITED',
    'HMJ TRAVEL PRIVATE LIMITED',
    'MENDRIVE HEALTHCARE PRIVATE LIMITED',
    'AETS INDIA PRIVATE LIMITED',
    'DURAR WEB SOLUTIONS PRIVATE LIMITED',
    'REBO SOLUTIONS PRIVATE LIMITED',
    'MOBIFLICK TECHNOLOGIES PRIVATE LIMITED',
    'DW INFOTECH PRIVATE LIMITED',
    'CLOUD EDUCATION LEARNING PRIVATE LIMITED',
    'FABLIAN TECHNOLAB PRIVATE LIMITED',
    'REGULF OFFSHORE AND ONSHORE DESIGN SOLUTION INDIA PRIVATE LIMITED',
    'FLAVACO GLOBAL PRIVATE LIMITED',
    'BLUEBOLT ACCELERATOR PRIVATE LIMITED',
    'STORAGEBREW PRIVATE LIMITED',
    'XRIG SALES PRIVATE LIMITED',
    'YOSAID INNOVATION FOUNDATION',
    'ACUMEN E-DATA SERVICES PRIVATE LIMITED',
    'STORIYOH PRIVATE LIMITED',
    'FORTIA ENERGY PRIVATE LIMITED',
    'VNV LOGIXPACE PRIVATE LIMITED',
    'SAMARTH UDYOG TECHNOLOGY FORUM',
    'HATTRICK IMC PRIVATE LIMITED',
    'BONZER HOSPITALITY PRIVATE LIMITED',
    'SIDDHESH HEALTH VENTURES PRIVATE LIMITED',
    'AMA DESIGN SOLUTIONS PRIVATE LIMITED',
    'GREEK LOOKS COSMETIC PRIVATE LIMITED',
    'PD CONSULTING ENGINEERS PRIVATE LIMITED',
    'ADDINAL TECHNOLOGIES PRIVATE LIMITED',
    'ECOFORUS SUSTAINABLE PRIVATE LIMITED',
    'WALSHARP TECHNOLOGIES PRIVATE LIMITED',
    'HEALTHBEST PRIVATE LIMITED',
    'APEX STATUTORY COMPLIANCE ADVISORS PRIVATE LIMITED',
    'TORZ DIGITAL SERVICES PRIVATE LIMITED',
    'BORGWARNER INDIA PRIVATE LIMITED',
    'KEBRON BUILDERS PRIVATE LIMITED',
    'STRUCTIAL BUILDTECH PRIVATE LIMITED',
    'BAKEMAX FOODS PRIVATE LIMITED',
    'SOURCEVED TECHNOLOGIES PRIVATE LIMITED',
    'TRONX THINGS PRIVATE LIMITED',
    'SMARTHELPLINE TECHNOLOGY INNOVATIONS PRIVATE LIMITED',
    'PORSELVI SOFTWARE PRIVATE LIMITED',
    'GRANO69 BEVERAGES PRIVATE LIMITED',
    'DIGIPROPEL INDIA PRIVATE LIMITED',
    'CAFEBILITY FOUNDATION',
    'SDMS FOODS PRIVATE LIMITED',
    'TRONX HOME PRIVATE LIMITED',
    'LP INTERNET TECHNOLOGIES PRIVATE LIMITED',
    'EDUVIRTUCATION PRIVATE LIMITED',
    'DRONACHARIOTS CONCEPTECH PRIVATE LIMITED',
    'STRATIZANT INDIA PRIVATE LIMITED',
    'MODANGE ELECTRON PRIVATE LIMITED',
    'ACCESSIBLE ENGINEERING INNOVATION CORPORATION PRIVATE LIMITED',
    'VKART INFO SOLUTIONS PRIVATE LIMITED',
    'PGS TECHNO GREEN SOLUTIONS PRIVATE LIMITED',
    'NABBY PET VENTURES PRIVATE LIMITED',
    'KAMBAG METAL INDUSTRIES PRIVATE LIMITED',
    'BENGALURU PRR DEVELOPMENT CORPORATION LIMITED',
    'COCOTREE NATURAL PRODUCTS PRIVATE LIMITED',
    'SUVIDHI KPO (OPC) PRIVATE LIMITED',
    'VM LIVE PRIVATE LIMITED',
    'GOLDEN VISTA CONSULTANTS PRIVATE LIMITED',
    'EZEK DIGITAL PRIVATE LIMITED',
    'SAVEBUX ENTERPRISES PRIVATE LIMITED',
    'MOC SOFT TECHNOLOGIES PRIVATE LIMITED',
    'FROG PROFILES PRIVATE LIMITED',
    'EXOTIC ALLEY PRIVATE LIMITED',
    'CLOUDSTAR ELECTRONICS INDIA PRIVATE LIMITED',
    'WHIINS HR SOLUTIONS PRIVATE LIMITED',
    'CENTRE OF EXCELLENCE IN MARITIME & SHIPBUILDING (CEMS)',
    'CALCULUS INNOVATIONS PRIVATE LIMITED',
    'JJ WELLNESS NETWORK PRIVATE LIMITED',
    'GARINNO GLOBAL PRIVATE LIMITED',
    'FIRSTINSIGHT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'LONG LIFE SEED INDIA PRIVATE LIMITED',
    'ELACONS S.A PRIVATE LIMITED',
    'ARRISE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'AURICS GLOBAL CONSULTING PRIVATE LIMITED',
    'EASTSONS TOURISM PRIVATE LIMITED',
    'MARWARI MEDIA CORPORATIONPRIVATE LIMITED',
    'APPCRONIX INFOTECH PRIVATE LIMITED',
    'SCRIBBLING ARTS PRIVATE LIMITED',
    'SIMONE VENTURES PRIVATE LIMITED',
    'JUBILIANTS CONSULTING PRIVATE LIMITED',
    'SUBALKAN TECHNOLOGIES PRIVATE LIMITED',
    'NANOBNK PRIVATE LIMITED',
    'INCH CONSTRUCTIONS & CONSULTANTS PRIVATELIMITED',
    'AWOT GLOBAL LOGISTICS (INDIA) PRIVATE LIMITED',
    'DEX DISTRIBUTIONS PRIVATE LIMITED',
    'SISSCOL INFOSOLUTIONS PRIVATE LIMITED',
    'NETFRA SOLUTIONS PRIVATE LIMITED',
    'VERKOTE SPICES PRIVATE LIMITED',
    'INTROTALLENT PRIVATE LIMITED',
    'HARSHIL FOODS PRIVATE LIMITED',
    'VM CAN INDUSTRIES PRIVATE LIMITED',
    'ATRINA TECHNOLOGIES PRIVATE LIMITED',
    'FLOATYOURBOAT DESIGN AND BRANDING (OPC) PRIVATE LIMITED',
    'STERN INDIA IMPORTS AND EXPORTS PRIVATE LIMITED',
    'KERALA CASHEW BOARD LIMITED',
    'DUSTARA SOLUTIONS PRIVATE LIMITED',
    'LATENT-TALENT HR SOLUTIONS PRIVATE LIMITED',
    'INDIAN TRAVEL HOUSE PRIVATE LIMITED',
    'SLAM OUT LOUD ARTS PRIVATE LIMITED',
    'ELLIPSE INFRACON PRIVATE LIMITED',
    'OMNIA PROJECT CONSULTANTS PRIVATE LIMITED',
    'EBONY & IVORY ADVERTISING INDIA PRIVATE LIMITED',
    'SHRUSHA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ISMC SOLAR FAB PRIVATE LIMITED',
    'JOTTER.AI PRIVATE LIMITED',
    'MISFITS COMMUNICATIONS AND DIGITAL SERVICES PRIVATE LIMITED',
    'YASHOVAR DESIGNS PRIVATE LIMITED',
    'IBIZ LIFE CARE PRIVATE LIMITED',
    'RESOURCE NAVIGATOR PRIVATE LIMITED',
    'ALOKI ARTISAN PRIVATE LIMITED',
    'CLODPI LABS (INDIA) PRIVATE LIMITED',
    'JFROG INDIA PRIVATE LIMITED',
    'KAUMODAKI INFORMATION TECHNOLOGY PRIVATELIMITED',
    'HAPPY TURTLE PRIVATE LIMITED',
    'GROWTHNOMICS TECHNOLOGIES PRIVATE LIMITED',
    'PENNYWISE EDUCATION PRIVATE LIMITED',
    'HIVELOOP INTERNET PRIVATE LIMITED',
    'VAASUDEVA PROCESS MANAGEMENT PRIVATE LIMITED',
    'ASPIRE SOFTSERV PRIVATE LIMITED',
    'MARCOPOLO COMMUNICATIONS PRIVATE LIMITED',
    'DLF INFO CITY HYDERABAD LIMITED',
    'ATHARV HVAC SOLUTIONS PRIVATE LIMITED',
    'MOLITICS INFOMEDIA PRIVATE LIMITED',
    'DOBYIN TRADING PRIVATE LIMITED',
    'VALABHI INSTITUTE PRIVATE LIMITED',
    'TPAC PACKAGING INDIA PRIVATE LIMITED',
    'SENSORIUM CREATIONS PRIVATE LIMITED',
    'VIM-SAA TECHNOLOGIES PRIVATE LIMITED',
    'VMNR STONE CRUSHERS PRIVATE LIMITED',
    'AMARAVATI BOATING CLUB INDIA PRIVATE LIMITED',
    'ROCKSCHOOL (INDIA) AWARDING PRIVATE LIMITED',
    'EZIWAY WORKFORCE SOLUTIONS PRIVATE LIMITED',
    'WIND OZ (INDIA) VACATIONS PRIVATE LIMITED',
    'JAITRA MEDIA PRIVATE LIMITED',
    'EARNEST IDEATE PRIVATE LIMITED',
    'NEUTON AUTO PRIVATE LIMITED',
    'XYGEN EXECUTIVES PRIVATE LIMITED',
    'SERENE VENTURES PRIVATE LIMITED',
    'APIN IT INDIA PRIVATE LIMITED',
    'IKSHAMTA CLOUDWARE PRIVATE LIMITED',
    'ORAYAN GLOBAL TRADING PRIVATE LIMITED',
    'EDARA INFRA PRIVATE LIMITED',
    'ASIMEET INNOVATIONS (OPC) PRIVATE LIMITED',
    'CLOUDWOOD VENTURES PRIVATE LIMITED',
    'RAPID DIGITAL MARKETING PRIVATE LIMITED',
    'HKA VALVES PRIVATE LIMITED',
    'ALERTBOX VENTURES PRIVATE LIMITED',
    'KAJ MYJOOTA RETAIL PRIVATE LIMITED',
    'HAITIAN CHEM-PHARMA (INDIA) PRIVATE LIMITED',
    'HUWATS INDIA PRIVATE LIMITED',
    'BARCZAR TECHNOLOGIES PRIVATE LIMITED',
    'OFURNISH VENTURES PRIVATE LIMITED',
    'GOLDMINE HOUSING FINANCE PRIVATE LIMITED',
    'MONOLOM INDIA PHARMA PRIVATE LIMITED',
    'RELATIONSATWORK INDIA TRADING PRIVATE LIMITED',
    'SUPERKEY SKILL & LANGUAGE INSTITUTE PRIVATE LIMITED',
    'ASHWANI TYRES PRIVATE LIMITED',
    'SIGNATUREGLOBAL MARKETING SOLUTIONS PRIVATE LIMITED',
    'BUOYANT FABRECA PRIVATE LIMITED',
    'S. K. POLYFILLS PRIVATE LIMITED',
    'INTRAHEALTH INDIA FOUNDATION',
    'SMALL LABEL PRIVATE LIMITED',
    'TAJWEED UDYOG PRIVATE LIMITED',
    'APPORCHID INDIA PRIVATE LIMITED',
    'KINETICLOGICS SERVICES PRIVATE LIMITED',
    'NAREN FITNESS (MIYAPUR) PRIVATE LIMITED',
    'ACCOUNTSOFT INDIA PRIVATE LIMITED',
    'MTW LABS LOGISTICS INDIA PRIVATE LIMITED',
    'EQUENTIA FINANCIAL SERVICE PRIVATE LIMITED',
    'NCLUES INKLING OUTSOURCING PRIVATE LIMITED',
    'SWINGA TRAINING PRIVATE LIMITED',
    'SATCOP INDIA PRIVATE LIMITED',
    'GARANTIR ENGINEERING PRIVATE LIMITED',
    'APP-EX SEMI CONDUCTOR PRIVATE LIMITED',
    'ESPE EDUSOL INDIA PRIVATE LIMITED',
    'PURE TECH CODEX PRIVATE LIMITED',
    'AVENIR TECH VENTURES PRIVATE LIMITED',
    'GIRIK KITCHEN EQUIPMENTS PRIVATE LIMITED',
    'ADSOM GLOBALTECH PRIVATE LIMITED',
    'MAHABALI CARGO MOVERS PRIVATE LIMITED',
    'WI DIGITAL SERVICE PRIVATE LIMITED',
    'NETAIR TECHNOLOGIES PRIVATE LIMITED',
    'MSP TRAVELWORLD PRIVATE LIMITED',
    'LYONS RANGE SECURITIES CLEARING CORPORATION LIMITED',
    'QUADRANT 3S ERP SOLUTIONS PRIVATE LIMITED',
    'SACHISH ACADEMY PRIVATE LIMITED',
    'TZTL PRIVATE LIMITED',
    'FERNWAY TECHNOLOGIES LIMITED',
    'CADAZON PRIVATE LIMITED',
    'CYG SUNRI (INDIA) PRIVATE LIMITED',
    'ARITRAA FOODWORKS PRIVATE LIMITED',
    'ADMERE SELVYN PRIVATE LIMITED',
    'AVHA LIFESCIENCES PRIVATE LIMITED',
    'MAULI CAST TECH PRIVATE LIMITED',
    'ECHO EVENTS & ACTIVATIONS PRIVATE LIMITED',
    'BRITISH ASIAN INDIA FOUNDATION',
    'PIKABOO SOFTWARES PRIVATE LIMITED',
    'RUBIX DATA SCIENCES PRIVATE LIMITED',
    'EXPOSOFT EDUCATIONS LIMITED',
    'CLONE TELNET SERVICES PRIVATE LIMITED',
    'MELIODUS SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'STARTWITH BASICX PRIVATE LIMITED',
    'CREANZA TILES PRIVATE LIMITED',
    'INTELLITHINK INDUSTRIAL IOT LABS PRIVATELIMITED',
    '22BLU INDIA BEVERAGES (OPC) PRIVATE LIMITED',
    'WINVIC ENTERPRISES PRIVATE LIMITED',
    'SAKAVAS CORPORATE SERVICES PRIVATE LIMITED',
    'ELGI ULTRA PRIVATE LIMITED',
    'BREWIN CUP PRIVATE LIMITED',
    'JRK HOUSING PRIVATE LIMITED',
    'ANTAR IOT PRIVATE LIMITED',
    'ATHFLEX PRIVATE LIMITED',
    'INCESSANT POWER & INFRA PRIVATE LIMITED',
    'ENVITRAN SMART SYSTEMS PRIVATE LIMITED',
    'NOAAXIM TECHNOLOGIES PRIVATE LIMITED',
    'ECO-UNITED MARINE & CONSTRUCTIONS PRIVATE LIMITED',
    'ROOH ETERNAL MUSIC EVENTS & ENTERTAINMENT PRIVATE LIMITED',
    'TRASHCON LABS PRIVATE LIMITED',
    'CAMBRIDGE HOSPITALS PRIVATE LIMITED',
    'RIGVEDA NETWORKS PRIVATE LIMITED',
    'UPSURGE SEEDS OF AGRICULTURE LIMITED',
    'MALENADU NUTS AND SPICES PRODUCER COMPANY LIMITED',
    'TRANSCARE LABORATORIES PRIVATE LIMITED',
    'HARIKRUPA SOLAR AND ENGINEERING PRIVATE LIMITED',
    'PARTUM REALTORS PRIVATE LIMITED',
    'AV BAGMILLER PRIVATE LIMITED',
    'ANVI TECHNICAL ADVISORS INDIA PRIVATE LIMITED',
    'NORD-LOCK (INDIA) PRIVATE LIMITED',
    'MILVUS AERO SOLUTIONS PRIVATE LIMITED',
    'NICARE HEALTH SERVICES PRIVATE LIMITED',
    'BIOSMART DEVICES AND SOLUTIONS PRIVATE LIMITED',
    'RAEMA STAR SOLAR PRIVATE LIMITED',
    'AGASTON MOBILE PRIVATE LIMITED',
    'NIRJARA HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'POPULAS ENTERPRISES PRIVATE LIMITED',
    'SARK RETAIL SERVICES PRIVATE LIMITED',
    'PRASMIT INFRA PRIVATE LIMITED',
    'JOYVERSITY OVERSEAS EDUCATION PRIVATE LIMITED',
    'NINEPILLAR E-BUSINESS SOLUTIONS PRIVATE LIMITED',
    'BOXERY PRODUCTS PRIVATE LIMITED',
    'JSW UTKAL STEEL LIMITED',
    'RUDRA AEROSPACE & DEFENCE PRIVATE LIMITED',
    'CANVIN REAL ESTATE PRIVATE LIMITED',
    'GREYHEAD DIGITAL MARKETING PRIVATE LIMITED',
    'EXPERION INFOSYSTEMS PRIVATE LIMITED',
    'PMS POLY PLAST INDUSTRIES PRIVATE LIMITED',
    'KSD TECHNOLOGIES PRIVATE LIMITED',
    'ENLITE RESEARCH PRIVATE LIMITED',
    'KAVIKUYIL SECURITIES PRIVATE LIMITED',
    'HARODA WIND ENERGY PRIVATE LIMITED',
    'FAS-INERGEIA SOLAR PRIVATE LIMITED',
    'ROBOTA CORPORATION PRIVATE LIMITED',
    'QUALHON INFORMATICS PRIVATE LIMITED',
    'ASHIKHA SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'GYPTECH SYSTEMS PRIVATE LIMITED',
    'RATNA GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'KAVYAM ENERGY PRIVATE LIMITED',
    'EVALUABLE INFOSERVE PRIVATE LIMITED',
    'BOMBAY FACADE PRIVATE LIMITED',
    'OUBAO TRADING INDIA PRIVATE LIMITED',
    'ARBOR TECHNOLOGY DISTRIBUTION PRIVATE LIMITED',
    'SAMSUNG ELECTRO MECHANICS SOFTWARE INDIABANGALORE PRIVATE LIMITED',
    'BIGTRUCK TECHNOLOGIES PRIVATE LIMITED',
    'TYPHOON COMMUNICATION PRIVATE LIMITED',
    'THIRU CHE TECHNOLOGIES PRIVATE LIMITED',
    'PC PATEL MAHALAXMI SIMPLEX CONSORTIUM PRIVATE LIMITED',
    'BELGAUM RENEWABLE ENERGY PRIVATE LIMITED',
    'RIYAN GEMS JEWELLERY PRIVATE LIMITED',
    'FILOSHA INFOTECH PRIVATE LIMITED',
    'FORD SMART MOBILITY INDIA PRIVATE LIMITED',
    'KHATIYU WIND ENERGY PRIVATE LIMITED',
    'MEERESGRUEN DESIGN PRIVATE LIMITED',
    'ECOPEZ TECHNOLOGIES PRIVATE LIMITED',
    'HEMEN LIFE SCIENCES PRIVATE LIMITED',
    'PROLANTA HEALTHCARE PRIVATE LIMITED',
    'DARYA SHIPPING PRIVATE LIMITED',
    'HESKWON LOGISTICS PRIVATE LIMITED',
    'S9 MIND-TECH KNOWLEDGE PRIVATE LIMITED',
    'WHITE HEAT TECHNOLOGIES PRIVATE LIMITED',
    'INDIE CAPITAL MANAGEMENT PRIVATE LIMITED',
    'RUI LABORATORIES PRIVATE LIMITED',
    'SENTINEL MANAGEMENT SECURITY SERVICES (OPC) PRIVATE LIMITED',
    'EXIFILOS TECHNOLOGIES PRIVATE LIMITED',
    'HOMATICO SMART SOLUTIONS PRIVATE LIMITED',
    'NIYURA TECHNOLOGIES PRIVATE LIMITED',
    'XP TRAVELS PRIVATE LIMITED',
    'HWASEUNG IA AUTOMOTIVES PRIVATE LIMITED',
    'INSTORIED RESEARCH LABS PRIVATE LIMITED',
    'LUXXIS INFOTECH PRIVATE LIMITED',
    'SHUBAARAMBH NURTURING PRIVATE LIMITED',
    'KOMYO ENGINEERING PRIVATE LIMITED',
    'DSTC COMMERCIAL PRIVATE LIMITED',
    'WAXFORM (OPC) PRIVATE LIMITED',
    'MEEGAAN CONSULTING PRIVATE LIMITED',
    'INTERBUILD CONTRACTS PRIVATE LIMITED',
    'DYNOPII PRIVATE LIMITED',
    'ANTON AUTOMOBILES PRIVATE LIMITED',
    'SOPHIA ENERGIES PRIVATE LIMITED',
    'ACES TOBACCO PRIVATE LIMITED',
    'JIYA RIYA LOGISTICS PRIVATE LIMITED',
    'RIDEVVISE PRIVATE LIMITED',
    'KAMION SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'NUFORM SOCIAL PRIVATE LIMITED',
    'SIPPIN SOLUTIONS PRIVATE LIMITED',
    'KWH MOTORS PRIVATE LIMITED',
    'MURUGAN CAPITAL PRIVATE LIMITED',
    'LIQUIDSKY VENTURES PRIVATE LIMITED',
    'AREVIN LIFESCIENCES PRIVATE LIMITED',
    'STAR BEAUTY TECH PRIVATE LIMITED',
    'BAROHAN PREMIUM PRIVATE LIMITED',
    'OPTIPERSIST TECHNOLOGIES PRIVATE LIMITED',
    'WAO EDUCATION PRIVATE LIMITED',
    'PKAPA DRY FRUITS & SPICES INDUSTRIES PRIVATE LIMITED',
    'ANOMA TECH PRIVATE LIMITED',
    'HERBEGY PRIVATE LIMITED',
    'AMERALD CARE PRIVATE LIMITED',
    'HANSA SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'AWESOME MACHI MEDIA PRIVATE LIMITED',
    'JEEVAMRUT PRIVATE LIMITED',
    'ACROMONT PRIVATE LIMITED',
    'MAHALAXMI ENNORE COKE & POWER PRIVATE LIMITED',
    'GREENSHIELD CONSTROCHEM PRIVATE LIMITED',
    'BOB SHELTERS PRIVATE LIMITED',
    'BHAGWATI AGROCHEM PRIVATE LIMITED',
    'FINFORECA PRIVATE LIMITED',
    'EUROFINS AME IT SERVICES PRIVATE LIMITED',
    'JAMPOT FARMS PRIVATE LIMITED',
    'ONE FAMILY INDUSTRIES PRIVATE LIMITED',
    'ORANGE INTEGRATED TRANSPORT SOLUTIONS LIMITED',
    'PALLANWALA BASMATI FARMER PRODUCER COMPANY LIMITED',
    'Metalex commodities private limited',
    'A r trading house private limited',
    'Yafa marketing pvt ltd',
    'A.t.e. enterprises private limited.',
    'Durga bearings private limited',
    'Smag peiner grabs (india) private limited',
    'Roller skates private limited',
    'Spine med systems private limited',
    'Virtus exports & imports private limited',
    'Davis marketing private limited',
    'Navyoti (exports) pvt ltd',
    'Aqua treat private limited',
    'Century business private limited',
    'Clarity barter pvt ltd',
    'Adinath distributors private limited',
    'Golcha buildtech private limited',
    'Mermeritalia building products private limited',
    'RAAVEE MERCHANDISERS PRIVATE LIMITED',
    'Crypton electronices pvt ltd',
    'Lite o lite electricals private limited',
    'Nabira exports private limited',
    'Sandiya exports private limited',
    'Rajsons impex private limited',
    'Kapsons agencies private limited',
    'Venus tradecom private limited',
    'Dream vinimay private limited',
    'Touchmate india private limited',
    'Kritin technology private limited',
    'Allen enterprises private limited',
    'Quartz impex private limited',
    'ALVIO PHARMACEUTICALS PRIVATE LIMITED',
    'Sarda vyapaar private limited',
    'ACCORD PLANETS PRIVATE LIMITED',
    'Delight overseas private limited',
    'Dolphin mercantile private limited',
    'Walrus trading company private limited',
    'Saldanha trades private limited',
    'Kalim stores private limited',
    'Regent autopoints private limited',
    'Grama trading private limited',
    'Omega mercantile private ltd',
    'IDEAL ICE LIMITED',
    'Edelmann Packaging India Private Limited',
    'Primus indtech private limited',
    'Anand agencies private limited',
    'Vasai fort trading co pvt ltd',
    'Avril traders private limited',
    'OCEAN EXIM INDIA PRIVATE LIMITED',
    'Nischay steels private limited',
    'K.v. natural ingredients private limited',
    'Gt india private limited',
    'Shobhana traders ltd',
    'C & e limited',
    'Coirfoam (india) pvt ltd',
    'Essar landagents pvt ltd',
    'Billbergea ltd',
    'Topsel marketing pvt.ltd.',
    'Abi trading pvt ltd',
    'Swarnim engineering works pvt. ltd.',
    'Elhard marketing limited',
    'Ginodia impex private limited',
    'Johns electric trading private limited',
    'Pune pumps sales and services private limited',
    'Krcr trading (import & export) private limited',
    'Bally fabs international limited',
    'Kasturi mercantile private limited',
    'Shubham trexim private limited',
    'Om saptarshi international service private limited',
    'Western logistics private limited',
    'Proficient financial services private limited',
    'Sadashiv structurals private limited',
    'Kanha designs private limited',
    'Maple advisory services private limited',
    'Skyrise traders private limited',
    'Vnk merchandise private limited',
    'Sarada overseas private limited',
    'ACCUTIME TRUCKING SOLUTIONS PRIVATE LIMITED',
    'Area retail private limited',
    'Gemini geoss energy private limited',
    'Sharkz infotech private limited',
    'Sunfire technologies private limited',
    'Parashara software private limited',
    'Shakambari infotech private limited',
    'Verity management software private limited',
    'Indian webtechnologies private limited',
    'Dron infotech private limited',
    'LOGIRIX INFOSOFT PRIVATE LIMITED',
    'Incognito technologies private limited',
    'Orillion india software private limited',
    'International technology solutions asia private limited',
    'Uniglow infotech private limited',
    'Hane tech solutions private limited',
    'Atlantis e-link private limited',
    'Aroundtown com private limited',
    'Desein dot ventures private limited',
    'Iserve solutions & services private limited',
    'Eruvaka technologies private limited',
    'K y information technologies private limited',
    'Reena bpo technologies private limited',
    'Vaidik infotech private limited',
    'Immence e technologies private limited',
    'Access infotech private limited',
    'Metro solutions pvt ltd',
    'Rapid transpay private limited',
    'C2c technosoft private limited',
    'Celestos technologies private limited',
    'Impressico business solutions private limited',
    'Autram infotech private limited',
    'Prayan animation studio private limited',
    'Saslab technologies private limited',
    'Techno bytes information private limited',
    'Great eastern infotech private limited',
    'Vipul trade centre developers private limited',
    'Bees software solutions private limited',
    'Trioptimum systems private limited',
    'Century ventures private limited',
    'Espranza innovations private limited',
    'JOBILITY TALENT SOLUTIONS PRIVATE LIMITED',
    'Clipmy images private limited',
    'Waddaya solutions private limited',
    'SUPPORTMART GLOBAL SERVICES PRIVATE LIMITED',
    'QDIGI SERVICES LIMITED',
    'Jrkites consultants private limited',
    'Gladwev software private limited',
    'Channel fusion software and innovative marketing technologies private limited',
    'C.s.soft solutions (india) private limited',
    'Pm infosoft private limited',
    'Invansys informatics private limited',
    'Uniware it enabled services private limited',
    'Puma source (india) data services private limited',
    'Greenvision technologies private limited',
    'Cybernette india private limited',
    'Sft technologies private limited',
    'INTERSOFT DATA LABS & SOLUTIONS PRIVATE LIMITED',
    'Gemini geeks technologies private limited',
    'Antier solutions private limited',
    'Sai smart4 aviation private limited',
    'Amsoft innovations and it services private limited',
    'Quantxpress technologies private limited',
    'Prm soft solution private limited',
    'Absolute web ranking private limited',
    'Inkwired technologies private limited',
    'CAMPUS TECHNOLOGIES PRIVATE LIMITED',
    'Xpert net technologies private limited',
    'Knackforge soft solutions private limited',
    'Vmv systems private limited',
    'AGILISIUM CONSULTING INDIA PRIVATE LIMITED',
    'Planet express innovations private limited',
    'Dreamzcraft info solutions private limited',
    'Infer development consulting private limited',
    'Genmarc research private limited',
    'Prospance infotech private limited',
    'Mckinsol technologies private limited',
    'Codebase technologies private limited',
    'Ingate systems private limited',
    'Blue corpus solutions private limited',
    'Ddr technologies private limited',
    'Moong labs technologies private limited',
    'Smartprix web private limited',
    'Safeway technologies private limited',
    'DESKOTEL SOLUTIONS PRIVATE LIMITED',
    'Star x infotainment private limited',
    'J s b m logistics private limited',
    'Yog sports private limited',
    'Excel net solutions private limited',
    'Patani investments and financial consultancy private limited',
    'Fountainhead entertainment private limited',
    'Sukeshan technologies private limited',
    'En appetite private limited',
    'Murti information technology services private limited',
    'Thunderbird industries india private limited',
    'Smart analyst (india) private limited',
    'Imtiara resources private limited',
    'Futures first info services private limited',
    'Digital point solutions private limited',
    'Astra management services private limited',
    'Transpacific certifications limited',
    'Velocity consulting services private limited',
    'G.i. group network security technology private limited',
    'Rsb systems private limited',
    'Webacer software private limited',
    'Capaz infosystems private limited',
    'NOVA BIG DATA ANALYTICS PRIVATE LIMITED',
    'Bharat soft tech private limited',
    'Tpc technical projects consultants private limited',
    'Rwv alliance management private limited',
    'ETHNIC STOCK AND SHARES PRIVATE LIMITED',
    'Nrds farms private limited',
    'GRACE SNACKS & FOODS INDIA PRIVATE LIMITED',
    'Tmv natural oils and extracts private limited',
    'Uttam milk specialities private limited',
    'SARASWATI AGRI TRADING PRIVATE LIMITED',
    'SUNRISE QUARTZITE PRIVATE LIMITED',
    'Madia impex private limited',
    'Action minerals private limited',
    'Phoenix overseas limited',
    'Radharani natural marble private limited',
    'Vijayakrishna spices private limited',
    'Prasanthi cashew company private limited',
    'VENUS GARMENTS INNOVATIONS PRIVATE LIMITED',
    'PARVEEN BAKER',
    'S TWINTECH SOLUTIONS (OPC) PRIVATE LIMITED',
    'ABNC CAPITAL SERVICES PRIVATE LIMITED',
    'CYNCH CONSTRUCTION PRIVATE LIMITED',
    'GO-TO-MARKET BUDDY SOFTWARE PRIVATE LIMITED',
    'HEALTHSAPPHIRE PRIVATE LIMITED',
    'PUDDING APP INDIA PRIVATE LIMITED',
    'MIBHASHI ELECTRIC PRIVATE LIMITED',
    'SHAPING NEXT PRIVATE LIMITED',
    'SHIVAJEE HOSPITAL PRIVATE LIMITED',
    'ASTON GLASS PRIVATE LIMITED',
    'CANIT SOLUTIONS PRIVATE LIMITED',
    'MADDISOFT SOLUTIONS INDIA PRIVATE LIMITED',
    'TANTRAA AMG PRIVATE LIMITED',
    'TOP LIGHT TRIMS PRIVATE LIMITED',
    'IIM INDORE INCUBATION FOUNDATION',
    'MAVINLOGISTICS AND RESOURCES PRIVATE LIMITED',
    'SWABHIMAAN SAHAYOG NIDHI LIMITED',
    'SPECTRAL TECH PRIVATE LIMITED',
    'OASIS AGRI EQUIPMENT PRIVATE LIMITED',
    'UJALAA MILK PRODUCER COMPANY LIMITED',
    'NORTH STAR HOMES PRIVATE LIMITED',
    'LENZBUY OPTICS PRIVATE LIMITED',
    'SPECTRA MEP PROJECTS AND SERVICES PRIVATE LIMITED',
    'FINTECHISM PRIVATE LIMITED',
    'TOUCAN PAYMENTS (INDIA) PRIVATE LIMITED',
    'TONS2MILE PRIVATE LIMITED',
    'AYAS BUILDCON PRIVATE LIMITED',
    'MYBIA MANIFOLD PRIVATE LIMITED',
    'TRINE PROJECTS INDIA PRIVATE LIMITED',
    'HASMAN TAAGSOL PRIVATE LIMITED',
    'INFOPROSYS SOLUTIONS PRIVATE LIMITED',
    'SHAREALITTLE SOCIAL FOUNDATION',
    'MAEKERTRACKS TECHNOLOGY AND SERVICES PRIVATE LIMITED',
    'PRODEVANS TECHNOLOGIES PRIVATE LIMITED',
    'SLEEKFIN INDIA PRIVATE LIMITED',
    'SAMVAAD INFOTECH PRIVATE LIMITED',
    'WINDTEC POWER PRIVATE LIMITED',
    'WHITE GOLD FINANCE PRIVATE LIMITED',
    'NOGATECH IT SOLUTIONS INDIA PRIVATE LIMITED',
    'SB FELTS INDIA PRIVATE LIMITED',
    'EXPRESS FURNITURE PRIVATE LIMITED',
    'XCALIBRATE GLOBAL PRIVATE LIMITED',
    'E5 CAPITAL PRIVATE LIMITED',
    'GTTAPP GLOBAL INDIA PRIVATE LIMITED',
    'CADRAN ICP (INDIA) PRIVATE LIMITED',
    'MARKITA PRIVATE LIMITED',
    'SIGN SHOPPE INDIA PRIVATE LIMITED',
    'APPARATE TECHNOLOGIES PRIVATE LIMITED',
    'WINSKILL CONSULTING PRIVATE LIMITED',
    'QPICLOUD TECHNOLOGIES PRIVATE LIMITED',
    'ONCALLDUTY HEALTH CARE SERVICES PRIVATE LIMITED',
    'KARMAYOGI PRALHADRAO PATIL AGRO PRODUCERCOMPANY LIMITED',
    'BLUE HEX SOFTWARE PRIVATE LIMITED',
    'GOYAL CONSTRUCTIONS AND PROJECTS PRIVATELIMITED',
    'KANNAVAM GRANITES PRIVATE LIMITED',
    'ASILOMED PRIVATE LIMITED',
    'QUAFF EXIM PRIVATE LIMITED',
    'DEFINITION FINSERV & CONSULTANCY PRIVATELIMITED',
    'SAMAGRA HEALTHCARE SYSTEMS PRIVATE LIMITED',
    'ISHITA INFO SOLUTIONS PRIVATE LIMITED',
    'SKY TEXTILES INDIA PRIVATE LIMITED',
    'ANPHALE FRESH FRUIT FARMER AGRO PRODUCERCOMPANY LIMITED',
    'OCTOBER SECURITIES & ASSET MANAGEMENT PRIVATE LIMITED',
    'AMIKSHA TEXTILES PRIVATE LIMITED',
    'QASOLVE.AI (INDIA) PRIVATE LIMITED',
    'ADVISTA TECHNOSOLUTIONS PRIVATE LIMITED',
    'FLAVONOIDS NUTRACEUTICALS PRIVATE LIMITED',
    'OPPL SPV RAJ PRIVATE LIMITED',
    'ANNEX IT SOLUTIONS PRIVATE LIMITED',
    'TUTOPIA PRIVATE LIMITED',
    'VIBITEK ENGINEERING PRIVATE LIMITED',
    'AHH MEDIA PRIVATE LIMITED',
    'SHEDS&BEDS VENTURES PRIVATE LIMITED',
    'AECOM INDIA GLOBAL SERVICES PRIVATE LIMITED',
    'LONDON TEA EXCHANGE INDIA PRIVATE LIMITED',
    'ANNAVARAM INFRA VENTURES PRIVATE LIMITED',
    'APPADORE PRIVATE LIMITED',
    'VENSYS ENGINEERING SERVICES PRIVATE LIMITED',
    'ASWADH FARMER PRODUCER COMPANY LIMITED',
    'POETRYWALA FOUNDATION',
    'KESAR NATURALS PRIVATE LIMITED',
    'PTCG INDIA PRIVATE LIMITED',
    'TEALA FOODS AND BEVERAGES PRIVATE LIMITED',
    'E-NELLO CABS PRIVATE LIMITED',
    'SOUTH ASIA MULTIMODAL TRANSPORT PRIVATE LIMITED',
    'FAUCONE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CP-ENRICH SERVICES & SOLUTIONS PRIVATE LIMITED',
    'MIRACLE STONE IMPEX PRIVATE LIMITED',
    'SMARTINT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MECH DOOR HARDWARE PRIVATE LIMITED',
    'NCSP INDIA SOFTWARE PRIVATE LIMITED',
    'PROMATE SECURITY PRIVATE LIMITED',
    'JAANDAR AGRO LIMITED',
    'RISING OMEGA ADVISORS PRIVATE LIMITED',
    'PLATO VENTURES PRIVATE LIMITED',
    'LEND2MEND FOUNDATION',
    'MAGIKBOX ADVERTISING & MARKETING (OPC) PRIVATE LIMITED',
    'NOVABENEFITS PRIVATE LIMITED',
    'EARTH RHYTHM PRIVATE LIMITED',
    'UPCYCLELUXE PRIVATE LIMITED',
    'TRAVEL AND DESTINATIONS CORE PRIVATE LIMITED',
    'ECOVIA TECH PRIVATE LIMITED',
    'BEYONDCLOUD TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'KANAGAM TRADING INDIA PRIVATE LIMITED',
    'KHODIYAR INDUSTRIAL PRIVATE LIMITED',
    'LEARNTODAY DIGITAL PRIVATE LIMITED',
    'PICARRO TECHNOLOGIES PRIVATE LIMITED',
    'KEMAN OFC PRIVATE LIMITED',
    'SAMARTH AGRICULTURE PRIVATE LIMITED',
    'D-FORCE ALLOYS & METALS (OPC) PRIVATE LIMITED',
    'NEO POLY INDUSTRIES PRIVATE LIMITED',
    'LIVING LABS NETWORK & FORUM',
    'KREEDAK SPORTING EXCELLENCE & PERFORMANCE PRIVATE LIMITED',
    'REPALLEWADA HIGHWAYS LIMITED',
    'LAUNCHWEB DREAMS PRIVATE LIMITED',
    'TUSHTI ICPURE INTERNATIONAL PRIVATE LIMITED',
    'ARYAINFRATECH INDIA PRIVATE LIMITED',
    'DEVXSOFT PRIVATE LIMITED',
    'AMERICAN REMEDIES LIFESCIENCES LIMITED',
    'BENEVOLENT CORNER FOUNDATION',
    'GENUINE ESSENTIAL PRODUCTS PRIVATE LIMITED',
    'ADDRESS MAKER RESIDENCY PROJECTS PRIVATELIMITED',
    'ARCTIC HEAT EXCHANGER PRIVATE LIMITED',
    'RED CORAL TRAVEL EXPERIENCES PRIVATE LIMITED',
    'VISAMASTERS PRIVATE LIMITED',
    'LAXMI METAL & MACHINES PRIVATE LIMITED',
    'EMIRATES OCEAN EXPRESS SHIP PRIVATE LIMITED',
    'CENT DEGRES INDIA PRIVATE LIMITED',
    'BITKART LABS LIMITED',
    'SPICE GROUND HANDLING SERVICES PRIVATE LIMITED',
    'Information sharing and analysis center',
    'Great place research and consultancy private limited',
    'Dploi staffing private limited',
    'Tania-tapel events (india) private limited',
    'Evetan fintech private limited',
    'KAARYA FACILITIES AND SERVICES LIMITED',
    'BADRI',
    'LIFE HOME INTERIORS PRIVATE LIMITED',
    'Facade design house private limited',
    'Sajawat modular furniture private limited',
    'Space design furniture and fixtures india private limited',
    'Dynacorp engineering private limited',
    'Lakhi gems impex pvt ltd',
    'Mercury gems pvt ltd',
    'Excel overseas pvt ltd',
    'Chintamanis jewellery arcade private limited',
    'Dvl jewels private limited',
    'Raj gems and jewelry private limited',
    'Shital gems private limited',
    'Ciemme jewels limited',
    'Utssav cz gold jewels limited',
    'MKM DIAMONDS PRIVATE LIMITED',
    'Euro cubic creations private limited',
    'IGLOW LIGHTING SOLUTIONS PRIVATE LIMITED',
    'United fodder solutions private limited',
    'AMPED EVENT PRIVATE LIMITED',
    'Priyank cords and tassels private limited',
    'Mcr apparels private limited',
    'BALAJI WEFT PRIVATE LIMITED',
    'NIHARIKA THREADS PRIVATE LIMITED',
    'BIGINSPIRATIONZ PRIVATE LIMITED',
    'Adityapur waste management private limited',
    'JAMNAGAR UTILITIES & POWER PRIVATE LIMITED',
    'Tulip infratech private limited',
    'Aheer infratech private limited',
    'Ks propmart private limited',
    'Fortune one developers private limited',
    'Primeslots properties private limited',
    'Foliage real estate developers private limited',
    'Omshanti estates private limited',
    'Kairali estate and exports p ltd',
    'Arafath & associates private limited',
    'Golden hill builders and developers (india) private limited',
    'Ideal road builders private limited',
    'Rangoli estate and properties pvt ltd',
    'Bharat enterprises private limited',
    'TRIYAMBAKAM ENTERPRISES PRIVATE LIMITED',
    'Sivaswamy holdings private limited',
    'Prime global hi-tech developers private limtied',
    'Basudev builders private limited',
    'Earth developers private limited',
    'Nalanda estates private limited',
    'Precon estates private limited',
    'Rap estates private limited',
    'Shree banke bihari infracon private limited',
    'Optume marketing private limited',
    'Shriram mall infrastructure private limited',
    'Bagmane properties private limited',
    'Geown sparsh infrastructure private limited',
    'Abhiram infra projects private limited',
    'Packaging realtors pvt ltd',
    'Ultra tech property developers private limited',
    'Nebara property private limited',
    'Jadhao realty private limited',
    'Rks dream vision reality private limited',
    'Sp concare private limited',
    'Chamundeswari builders private limited',
    'Vasu realtors private limited',
    'Vensar meadows private limited',
    'Infinity villa private limited',
    'Devashilpi realtors private limited',
    'Greenview niwas private limited',
    'Greenview infraproperties private limited',
    'Neeru builders private limited',
    'Shantikrupa estates private limited',
    'Bhagya lakshmi properties private limited',
    'SWORN BROTHERS ASSETS PRIVATE LIMITED',
    'Saraswati abasan private limited',
    'Topflow buildcon private limited',
    'Ssamhitha farms & developers private limited',
    'Gp buildwell private limited',
    'Li - logistics india real estate private limited',
    'Consign builds (india) private limited',
    'Startree enclave private limited',
    'Snowblue conclave private limited',
    'Arval india private limited',
    'Nks equipments rentals private limited',
    'Giriraaj gensets private limited',
    'Trivium india software private limited',
    'E-travel dotcom (india) private limited',
    'World it consulting private limited',
    'Csi computech (india) private limited',
    'Sodel solutions private limited',
    'Accel bpo private limited',
    'Tunip info services private limited',
    'F9 info technologies private limited',
    'ICENTRIS SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'Rating4 it solutions private limited',
    'FITMOST TECHNOLOGIES PRIVATE LIMITED',
    'Vizag broadcasting company private limited',
    'Suntec web services private limited',
    'Acxiom consulting private limited',
    'Radius synergies international private limited',
    'Arcs technologies private limited',
    'As it consulting private limited',
    'Kh it web services private limited',
    'Interface network marketing private limited',
    'Shri ambica polymer private limited',
    'Mangalam information technologies private limited',
    'Cygnet infotech private limited',
    'Cybernation infotech private limited',
    'Vardhman info services private limited',
    'Shree visat designs private limited',
    'DATAMINE SERVICES PRIVATE LIMITED',
    'PRARAMBH PRINT AND PORTAL PRIVATE LIMITED',
    'Srinagar technology consultants private limited',
    'Fourtune computers technologies private limited',
    'Unilog content solutions private limited',
    'Aureole technologies private limited',
    'Relyon softech limited',
    'Sevasys technologies india private limited',
    'Delixus software india private limited',
    'Horner engineering india private limited',
    'Techmust software private limited',
    'Creative genius software india private limited',
    'Philogy consulting services private limited',
    'Sti infotech private limited',
    'Globogramee learning services private limited',
    'Centina systems (india) private limited',
    'Quadwave consulting private limited',
    'Tasc business solutions private limited',
    'Jp adroit consultants private limited',
    'PARSEL EXCHANGE PRIVATE LIMITED',
    'Orient spa limited',
    'Medwell ventures private limited',
    'NEXTGEN HEALTHCARE INDIA PRIVATE LIMITED',
    'San inventivesolutions private limited',
    'Kotbagi hospital private limited',
    'Ashraya foundation for children',
    'Kms health center private limited',
    'Modern nursing and medical training institute private limited',
    'Chhattisgarh medical services corporation limited',
    'A-LINE TRAVELS PRIVATE LIMITED',
    'Nova pulse ivf clinic ahmedabad private limited',
    'WELLNESS TECHNOLOGIES PRIVATE LIMITED',
    'CYTECARE HOSPITALS PRIVATE LIMITED',
    'Suvikram plastex private limited',
    'UNIMONI FINANCIAL SERVICES LIMITED',
    'Bharatiya reserve bank note mudran private limited',
    'Eagle consulting private limited',
    'Prameya health private limited',
    'Ribis health care private limited',
    'Sreyas holistic remedies private limited',
    'Novel medicare solutions private limited',
    'P. b. hospitality services private limited',
    'Amas medical services private limited',
    'Shreeji eye care private limited',
    'Bm english speaking institute private limited',
    'Mizzen marine private limited',
    'Maharashtra industries development institute private limited',
    'Social honor distinction foundation',
    'Fresh pet private limited',
    'E-swasthya mediserve private limited',
    'Vattikuti india foundation',
    'RAJSONS PHARMA PRIVATE LIMITED',
    'Onebreath india private limited',
    'Apollo lavasa health corporation limited',
    'Biosense technologies private limited',
    'Omnipresence academy of life private limited',
    'Radiance hospital private limited',
    'Motilal oswal foundation',
    'Ishwari healthcare private limited',
    'Medium healthcare consulting private limited',
    'Moon healthcare private limited',
    'Impetus healthcare skills private limited',
    'INNOVA SECURITIES & INVESTMENTS LIMITED',
    'Gangagen biotechnologies private limited',
    'Garbha gudi ivf centre private limited',
    'Inscience healthcare consulting private limited',
    'Cosmetic surgery institute (india) private ltd',
    'V.p.m.hospital and research centre private limited',
    'Udayam medical centre (trichy) private limited',
    'Trivitron healthcare private limited',
    'Dr. smilez healthcare private limited',
    'Accident relief care (india) private limited',
    'SRS THERAPEUTICS PRIVATE LIMITED',
    'Xenia healthcare services private limited',
    'Angels advanced clinic private limited',
    'Ajiwika society',
    'Nepra resource management private limited',
    'Bhuvaneswari lines & logistics private limited',
    'Parity media private limited',
    'Finecut entertainments private limited',
    'Gold entertainment private limited',
    'Nomad films limited',
    'SHOTFORMAT DIGITAL PRODUCTIONS PRIVATE LIMITED',
    'Indrani mukerjea news private limited',
    'Maverick media private limited',
    '4 LIONS FILMS PRIVATE LIMITED',
    'Planet support services india private limited',
    'Lakeshore watersports company limited',
    'Bhavnagar polo club',
    'Wonder waves entertainment private limited',
    'Navodaya mass entertainments limited',
    'ATULYE FOUNDATION',
    'Biocos life sciences private limited',
    'Information mapping india private limited',
    'Ensource consulting private limited',
    'SAMRUDDHA FOOD PRODUCTS PRIVATE LIMITED',
    'Jobtech hospitality & management services private limited',
    'Ideal job solutions private limited',
    'Bioaxis dna research centre private limited',
    'White fields c3 church of hyderabad',
    'LBR FOUNDATION INDIA',
    'Eips engineering consultants private limited',
    'Nu information technologies private limited',
    'Thielenhaus microfinish india private limited',
    'Fitness first india private limited',
    'Super technofab private limited',
    'ZENMER TECHNOLOGIES PRIVATE LIMITED',
    'Veena patil hospitality private limited',
    'Pioneer inspection solutions india private limited',
    'Om fabtech private limited',
    'Inventiv international pharma services private limited',
    'Accem industries private limited',
    'Genex exim ventures private limited',
    'J.g.m spinners private limited',
    'Bhoruka road lines limited',
    'Jajodia properties private limited',
    'Gansons marketing private limited',
    'Saka fashions private limited',
    'Jay elastomers private limited',
    'Seamates (india) private limited',
    'Mango holidays india private limited',
    'Pride hospitality limited',
    'Awatac container line private limited',
    'North east carriers private limited',
    'Lets travel private limited',
    'Gateway distriparks (kerala) limited',
    'Interport impex private limited',
    'Al-freight international private limited',
    'Faredeal shipping agencies (mumbai) private limited',
    'Value freight (mumbai) private limited',
    'Atz shipping trade and transport private limited',
    'Natchart shipping private limited',
    'Sbff logistics private limited',
    'Apex freight system private limited.',
    'Crimson logistics private limited',
    'Simi travels private limited',
    'Firstwin freight india private limited',
    'Pace freight services private limited',
    'Ifc despatch (india) private limited',
    'Swiss freight (india) private limited',
    'Veetee communications private limited',
    'Chemistree media & communications private limited',
    'Instanet technologies private limited',
    'Nano wicore labs private limited',
    'Vodafone global services private limited',
    'RELIANCE FINANCIAL ADVISORY SERVICES PRIVATE LIMITED',
    'Ucal finance private limited',
    'T.g.i. packaging private limited',
    'Alipta investments private limited',
    'Jaigopal consultancy services private limited',
    'Creative marketing and investment pvt ltd',
    'Dalal and shah fiscal services limited',
    'Carma venture services (i) private limited',
    'TOMORROW CAPITAL ENTERPRISES PRIVATE LIMITED',
    'Simony investments pvt ltd',
    'Kusumgar corporates private limited',
    'Dev-dip investments pvt.ltd.',
    'Satellite corporate services p ltd',
    'DYNOVO GLOBAL SOLUTIONS PRIVATE LIMITED',
    'Ahan investments private limited',
    'Reliance financial limited',
    'Progressive global finance private limited',
    'Dbd finance limited',
    'Eureka capital management private limited',
    'Vishala knit wear private limited',
    'INFOSEC FINANCIAL SERVICES PRIVATE LIMITED',
    'Fane chits private limited',
    'New trichur chits india private limited',
    'Radhe associates private limited',
    'L.d.c. holdings private limited',
    'A. k. capital corporation private limited',
    'Mw corp private limited',
    'Helios capital advisors private limited',
    'Reliance wealth management limited',
    'Dbd investments limited',
    'PROMINENT INFRASTRUCTURE PRIVATE LIMITED',
    'Triton insurance surveyors and loss assessors private limited',
    'Indiafirst life insurance company limited',
    'Silver stream equities private limited',
    'Infinity consultants limited',
    'Dsfs shares and stockbroking private limited',
    'Oraculo stockbrokers private limited',
    'Gulab credit and holding private limited',
    'Pegasus advisory services private limited',
    'ICAP IL India Private Limited',
    'Progressive share brokers private limited',
    'BASANT SECURITIES PRIVATE LIMITED',
    'Moneymart securities private limited',
    'Moolsons holdings private limited',
    'PAVITRA SECURITIES & SERVICES PRIVATE LIMITED',
    'Hype integracomm private limited',
    'Credit suisse securities (india) private limited',
    'RSMART RESOURCES AND ADVERTISEMENT NETWORK LIMITED',
    'Gurunam trading compnay pvt ltd',
    'AUTUS SECURITIES PRIVATE LIMITED',
    'Brickwork ratings india private limited',
    'Anson financial services (india) private limited',
    'Morwal fabrics private limited',
    'Credit suisse consulting (india) private limited',
    'Man investment services private limited',
    'Helios finserve private limited',
    'THRIVE CAPITAL INVESTMENT ADVISORS (INDIA) PRIVATE LIMITED',
    'BASIX FOREX & FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'Parami investments private limited',
    'Saimata infracon private limited',
    'Ashtamangal realty private limited',
    'HOSKOTE NEO HOMES LIMITED',
    'COWTOWN INFOTECH SERVICES PRIVATE LIMITED',
    'Alp properties private limited',
    'FORTUNEX VENTURES PRIVATE LIMITED',
    'Shree ganeshkrupa housing and development private limited',
    'Bhalchandra trading private limited',
    'Vidved properties and consultants private limited',
    'Siddhi raj housing projects private limited',
    'Mega fin (india) limited',
    'Prism informatics limited',
    'Prithvi information solutions limited',
    'Jainex aamcol limited',
    'Vaghani techno - build limited',
    'Mukta arts limited',
    'Mahesh agri exim private limited',
    'Selmax exports private limited',
    'Redleaf herbals private limited',
    'Valuable ag-bio private limited',
    'Victorymarvel seeds india private limited',
    'Koppert biological systems india private limited',
    'Aaa agrimatrix private limited',
    'Shanders agri enterprises private limited',
    'Aqua works private limited',
    'Hitech boi chem (bangalore) private limited',
    'Tufflite plastics private limited',
    'Shree datt aquaculture farms private limited',
    'RAYMECHATRONICS AND MACHINERY PRIVATE LIMITED',
    'Integrated presentation solutions india private limited',
    'Intermedia softech private limited (alteration)',
    'Ihseduagrochem private limited',
    'Aadi diamonds and jewellery private limited',
    'Anand systems engineering private limited',
    'Asia pacific marbles limited',
    'Touchstone granites private limited',
    'TENAX PIDILITE INDIA PRIVATE LIMITED',
    'Orient granites and marbles pvt ltd',
    'Regalia stones private limited',
    'Shree ram lime products private limited',
    'My diamond private limited',
    'Jainex foods private limited',
    'EVOLUTION TRADING AND DISTRIBUTION PRIVATE LIMITED',
    'Huvepharma sea (pune) private limited',
    'Creasakthi foods private limited',
    'Fruits and foods private limited',
    'MAGNUM SIZZLES PRIVATE LIMITED',
    'Poojan foods private limited',
    'Oryza exim private limited',
    'Vasudha builders limited',
    'Polson butter private limited',
    'Palaya kottai dairy private limited',
    'IDORI INDIA PRIVATE LIMITED',
    'Sweet confectionery private limited',
    'Dutch mill dairy and foods private limited',
    'Rajbhog foods private limited',
    'Sandwedges food services private limited',
    'Premier tobacco packers private limited',
    'Welco international private limited',
    'Roopa cotton mills private limited',
    'Sandeep texturisers private limited',
    'Kufner textiles (india) private limited',
    'Khandelwal polyester private limited',
    'Rohini mills private limited',
    'Sleek textiles industries limited',
    'Saraf yarn private limited',
    'Kapish yarns private limited',
    'TRIDENT TEXOFAB LIMITED',
    'Parvin cotton private limited',
    'Tarapur industries private limited',
    'BB COMMODITIES PRIVATE LIMITED',
    'CENTAUR HOLDINGS PRIVATE LIMITED',
    'MODERN METAALICS PRIVATE LIMITED',
    'Ramvijay clothing company private limited',
    'Aditya panels private limited',
    'Global textile alliance india private limited',
    'SHAKTHI KNITTING PRIVATE LIMITED',
    'Mohan spintex india limited',
    'Vinay hosiery private limited',
    'Akshaya apparels private limited',
    'V tex overseas private limited',
    'Cbc fashions (asia) private limited',
    'Sunham home fashions private limited',
    'Rpe fashions private limited',
    'Focus lifestyle private limited',
    'Kp tech nonwoven india private limited',
    'India shoes exports private limited',
    'Transworld wood private limited',
    'Corru-cartons (india) pvt ltd',
    'Sri ayyappa paper company private limited',
    'AANANDHAM LABELS PRIVATE LIMITED',
    'Paper bags (india) private limited',
    'Miranda equipments private limited',
    'Concept speciality pack private limited',
    'Anushri paper pack private limited',
    'Chemin controls and instrumentation private limited',
    'Cdc printers private limited',
    'Vj media works private limited',
    'Time ads industries (india) private limited',
    'Tnq books & journals private limited',
    'Everest publicity private limited',
    'Prapti graphics private limited',
    'Space ads (india) private limited',
    'Three-m-paper manufacturing company private limited',
    'Jyoti print and pack private limited',
    'Janapriya properties private limited (under part ix)',
    'Janapriya townships private limited',
    'Gradient estates private limited',
    'Vasathi housing limited',
    'WHISTLER LOGISTICS PRIVATE LIMITED',
    'Shreepati build infra investment limited',
    'Neelkanth infrarealty private limited',
    'Sahakar infracon projects private limited',
    'ANITECH INFRAA PROJECTS PRIVATE LIMITED',
    'Vie infratech india limited',
    'Absolute networks private limited',
    'Sofcon solutions private limited',
    'Paramount infosystem private limited',
    'Manek real property developers pvt ltd',
    'Alphatech software private limited',
    'Mastercard mobile transactions solutions private limited',
    'Vmukti solutions private limited',
    'Pmentire solutions private limited',
    'Aark infosoft private limited',
    'Krish technolabs private limited',
    'Truecom telesoft private limited',
    'Topchoice Computech Limited',
    'DELIVERHEALTH SOLUTIONS INDIA PRIVATE LIMITED',
    'Infolog solutions private limited',
    'NAVIS HUMAN RESOURCES PRIVATE LIMITED',
    'Dhanush infosol private limited',
    'Trianz holdings private limited',
    'Healthcare process solutions (india) private limited',
    'SATVAM SOFTWARES PRIVATE LIMITED',
    'Webaffinity technologies private limited',
    'Nuage compusys technologies private limited',
    'Neugen embedded solutions private limited',
    '8kpc (india) private limited',
    'Sprin technosys private limited',
    'Moolya software testing private limited',
    'Nusecond technologies private limited',
    'Inkoniq it solutions private limited',
    'Axionconnect infosolutions private limited',
    'Gopivotal software india private limited',
    'Q-dat it solutions private limited',
    'Jeeves information systems private limited',
    'Allsemi solutions private limited',
    'Quasys software & consultancy private limited',
    'Neolink technologies private limited',
    'NORTONLIFELOCK INDIA PRIVATE LIMITED',
    'Mascot automation private limited',
    'BEAVER SERVICES PRIVATE LIMITED',
    'FABLE FINTECH PRIVATE LIMITED',
    'Brainbird infotech private limited',
    'Ejourno com (india) private limited',
    'MUKTA CREATIVE VENTURES LIMITED',
    'Alchemy solutions private limited',
    'VALUABLE TECHNOLOGIES PRIVATE LIMITED',
    'Smart bio-office technologies private limited',
    'Smart data systems private limited',
    'Trsoft technologies private limited',
    'Valuable infotainment private limited',
    'Cloud manthan software solutions private limited',
    'Cakewalk i.t. solutions private limited',
    'USA INFOTECH ADVISORS PRIVATE LIMITED',
    'Bit brothers tech private limited',
    'Raddyx technologies private limited',
    'Tomtom india private limited',
    'Ebsolute technologies private limited',
    'Lumedx healthcare technologies (india) private limited',
    'Cloudeeva software private limited',
    'Career bridge consultants private limited',
    'Signon solutions private limited',
    'X2 PRIVATE LIMITED',
    'Clinasia labs private limited',
    'Micronet technicks (india) private limited',
    'Icronex technologies private limited',
    'Semanticbits india private limited',
    'Sreesaila networks private limited',
    'Avenir technologies private limited',
    'Scm data india private limited',
    'Icube consulting services india private limited',
    'Fugenic computer services private limited',
    'Diyotta india private limited',
    'Setuserv informatics private limited',
    'Osmosys software solutions private limited',
    'Creo tech solutions private limited',
    'Inclusive services and technologies private limited',
    'K.c.p technologies limited',
    'Summitworks technologies private limited',
    'Softsmith infotech private limited',
    'Softnik technologies private limited',
    'Information dynamics india private limited',
    'E-caard solutions private limited',
    'Elecdes systems private limited',
    'Ascenders technologies private limited',
    'Impower solutions private limited',
    'Redleaf technologies private limited',
    'Appsworld software private limited',
    'Willstrong solutions private limited',
    'Komatsu india private limited',
    'CONSTANT ENGINEERING PRIVATE LIMITED',
    'Bontaz automotive india private limited',
    'N e cranes private limited',
    'Anchor mark private limited',
    'Sonak engineering private limited',
    'Bsh household appliances manufacturing private limited',
    'GLOBAL SPARES & SEALS PRIVATE LIMITED',
    'RAJ INNOTECH PRIVATE LIMITED',
    'Rmm engineering products private limited',
    'Dri india relays private limited',
    'Tuskar manufacturing solutions private limited',
    'Andreas maier workholding technology private limited.',
    'Tirupur computer embroidery accessories limited',
    'Nessa illumination technologies private limited',
    'Enfrien technologies and solutions private limited',
    'Kovel engineering private limited',
    'Intraaction technology private limited',
    'Salvin instruments private limited',
    'IDEAL SYSTEMS LIMITED',
    'Eurotherm india private limited',
    'Prodapt solutions private limited',
    'Avion electronics private limited',
    'Mgm-varvel power transmission private limited',
    'Spectra battery industries private limited',
    'Wilson power and distribution technologies private limited',
    'Aerolex cables private limited',
    'Entelechy automation private limited',
    'Elektromag-joest vibration private limited',
    'Powercore industries india private limited',
    'Dea woong electrical india private limited',
    'Shrachi monofilament & fabrics private limited',
    'Star efi autoelectronics private limited',
    'Eeshvar switchgears private limited',
    'Krutam technosolutions private limited',
    'Elektromag-slp lighting private limited',
    'Usha electrocontrol private limited',
    'TVS SIRIUS CONTROLS PRIVATE LIMITED',
    'E-mac opto electronics private limited',
    'Flextronics technologies (india) private limited',
    'Orbis (india) private limited',
    'Lexmark international (india) private limited (trf. )',
    'Buljin elmec private limited',
    'Vision stencils private limited',
    'Globe scott motors pvt ltd',
    'Fourcee equipments and services private limited',
    'Diplomat electricals private limited',
    'Net connect private limited',
    'Shine scientific international private limited',
    'Meditech devices private limited',
    'Myvision medical private limited',
    'Staysee healthcare products private limited',
    'Intermedics devices private limited',
    'Expert vision labs private limited',
    'Nash metalsheets private limited',
    'IHD INDUSTRIES PRIVATE LIMITED',
    'Unipres india private limited',
    'Sarjak container lines private limited',
    'Kashyap shipping pvt ltd',
    'Prestogem vehicles private limited',
    'K e aero components private limited',
    'Ituk manufacturing india private limited',
    'Absl enterprises private limited',
    'Navratna gems private limited',
    'Alok impex pvt ltd',
    'Ratnalaya diamonds private limited',
    'Kothari diamond industries private limited',
    'Linus furnitures private limited',
    'SLN BULLION PRIVATE LIMITED',
    'R for rabbit baby products private limited',
    'The all india toy manufactures association.',
    'Span wall3 private limited',
    'Gcube go green global products private limited',
    'Wind world wind farms (jaisalmer) private limited',
    'Chango yangthang hydro power limited',
    'Chetana power private limited',
    'G b hydro power private limited',
    'Kw power private limited',
    'Miraaj bio power pvt. ltd.',
    'Transpower vidyut technics private limited',
    'B & s energy private limited',
    'B r hydro energy private limited',
    'Reagan energy ventures private limited',
    'Hul hydro power private limited',
    'Parvat hydro power private limited',
    'R m hydro power private limited',
    'PN Renewable Energy Limited',
    'Kyori infrastructure private limited',
    'Gurgaon construct well private limited',
    'Cube construction engineering limited',
    'Sanavi infrabuildcon private limited',
    'Hebron properties private limited',
    'Oxoniya constructions and engineering private limited',
    'Corpvale projects private limited',
    'Sai hospital and icu private limited',
    'INTERTECH TECHNOLOGIES PRIVATE LIMITED',
    'Tahal consulting engineers india private limited',
    'Corporate (india) facilities private limited',
    'Global discovery academy services private limited',
    'Fbf homogenizers (i) private limited',
    'Cosire design innovation private limited',
    'Ezswype business solutions private limited',
    'A2 hr consultants private limited',
    'Sgi engineers private limited',
    'Tritium consulting private limited',
    'Idea bubbles consulting services private limited',
    'Navvrnd consulting private limited',
    'Innosolv consultancy services private limited',
    'Pammvi consultancy services limited.',
    'Gartner india research & advisory services private limited',
    'Geometra survey india private limited',
    'A. k. wealth management private limited',
    'Dma yellow works limited',
    'India bond private limited',
    'Platinumone learning solutions private limited',
    'MGB ADVISORS PRIVATE LIMITED',
    'Deore consultancy services private limited',
    'Signum management solutions private limited',
    'BIZZO TECHNOLOGIES PRIVATE LIMITED',
    'Wwl centre for logistics excellence private limited',
    'Synergy maritime private limited',
    'Saibsolutions (india) private limited',
    'Wis-scot engineering private limited',
    'St.john freight systems limited',
    'FACILE MAVEN PRIVATE LIMITED',
    'Depa india private limited',
    'Swegon blue box private limited',
    'Dna architects designers private limited',
    'Design directions private limited',
    'Metey engineering & consultancy private limited',
    'Percept advertising and marketing services private limited',
    'Percept d mark (india ) private limited',
    'Matrix publicities and media india private limited',
    'MUDRA FINSERVE ADVISORS PRIVATE LIMITED',
    'Aaa media and entertainment private limited',
    'DBH INVESTMENT CAPITAL INDIA PRIVATE LIMITED',
    'K l bhrara and company private limited',
    'Perfect relations private limited',
    'Currie & brown (india) private limited',
    'Chandra oil & gas project services private limited',
    'Geo constech private limited',
    'Tech connect services private limited',
    'Trif gurgaon housing projects private limited',
    'Super industrial lining private limited',
    'Ypo (gujarat)',
    'AARYA GRAND HOTELS & RESORTS PRIVATE LIMITED',
    'Cart 2 india online retail private limited',
    'Image core lab private limited',
    'Uwin iwin incentives india private limited',
    'Aces global quality services india private limited',
    'Basic alloys india private limited',
    'Kasper ledlights private limited',
    'AXON EDUTAINMENT PRIVATE LIMITED',
    'Motwani international private limited',
    'Multiples equity fund trustee private limited',
    'J basu logistics private limited',
    'POSITIVE RAYS COMMUNICATIONS PRIVATE LIMITED',
    'Emproteam corporate support private limited',
    'ABANS METALS PRIVATE LIMITED',
    'BRAND BOX DIGITAL PRIVATE LIMITED',
    'Gala agencies private limited',
    'Mobisoft infotech private limited',
    'Mehta antibiotics private limited',
    'Soneta logistics private limited',
    'CONTINWUM FILMS PRIVATE LIMITED',
    'UDAY JOSHI ',
    'DESIGNS PRIVATE LIMITED',
    'Delta recruitment consultants private limited',
    'Si consultech private limited',
    'Schnell india machinery private limited',
    'Indian sports academy limited',
    'All world cargo lines private limited',
    'Votersmood research private limited',
    'Decimal factor bpo private limited',
    'Sneh eldercare private limited',
    'Maxsure engineering private limited',
    'Omfa agro private limited',
    'Jogihali wind energy private limited',
    'Corporate ladder consultants private limited',
    'Attic restaurants private limited',
    'Ashish hr solutions private limited',
    'Sk sourcing & management private limited',
    'Atharv intertrade private limited',
    'Son atul project developers private limited',
    'Monjin interviews private limited',
    'Studio coppre private limited',
    'Datalog controls and solutions private limited',
    'Peoplecart private limited',
    'MANAVI WEALTH PRIVATE LIMITED',
    'Hbh comfort solutions private limited',
    'Ace tech products india private limited',
    'Hasle refractories india private limited',
    'Solty dealer private limited',
    'Dieffenbacher india private limited',
    'Premji and sons trading india private limited',
    'Seoul store trading private limited',
    'BANARAS BHANG PRIVATE LIMITED',
    'MATHSONS RE-INSURANCE BROKERS PRIVATE LIMITED',
    'Suyog diagnostics private limited',
    'Alphion india private limited',
    'Simba toys india private limited',
    'Amtek dealer pvt ltd',
    'Automation tracom private limited',
    'Energy tracom private limited',
    'CJ BIO INDIA PRIVATE LIMITED',
    'Mahodaya hybrid seeds private limited',
    'Obsessions exports private limited',
    'Cube fashions private limited',
    'Megan impex private limited',
    'Pathway communications infrastructure private limited',
    'Amaya exim private limited',
    'Aaa diamonds private limited',
    'FLEMINGO TRAVEL RETAIL PRIVATE LIMITED',
    'Amazon timber industries private limited',
    'Intermarket india private limited',
    'Chakradhari exports private limited',
    'Pestalert chemicals pvt ltd',
    'Deraj enterprises private limited',
    'Entask consultancy services private limited',
    'Orb impex private limited',
    'Groovy trading private limited',
    'SHEFFLY ENTERPRISES PRIVATE LIMITED',
    'Shalimar distributors and investments private limited',
    'Sumo international private limited',
    'Avenue supermarts limited',
    'Grynflyche energy (india) private limited',
    'Panasia carpets and furnishings private limited',
    'Pasway clothing private limited',
    'Laxmika consumer care private limited',
    'N.k. digiprint private limited',
    'Shreejikrupa exports private limited',
    'S p chips potato private limited',
    'SNV DISTRIBUTORS PRIVATE LIMITED',
    'HELIOS-FUSION ENERGY PRIVATE LIMITED',
    'Winona impex private limited',
    'Comczar exports private limited',
    'HUBTOWN SOLARIS MAINTENANCE PRIVATE LIMITED',
    'Endo lighting accessories (india) private limited',
    'Artemide lighting india private limited',
    'Reindeer trading private limited',
    'Amulya corporation private limited',
    'Rubicon engineers private limited',
    'Theme ambience enterprises private limited',
    'INDOGAS PRIVATE LIMITED',
    'Elite commodities private limited',
    'Balaji retailers private limited',
    'Anand merchants private limited',
    'Pinkrose tradelink private limited',
    'Vtc tradewings private limited',
    'Fr solutions private limited',
    'Sonnet retail innovation private limited',
    'Gemma designer jewels private limited',
    'Action vanijya private limited',
    'Tjuk trade networks private limited',
    'RETRO REFLECTION PRIVATE LIMITED',
    'Snip impex private limited',
    'Vrisha pharmaceuticals private limited',
    'Unique sellings and marketing private limited',
    'Bestseller retail india private limited',
    'Veer jewels private limited',
    'Heerachand gems private limited',
    'Namac small salt producer company limited',
    'S d retail private limited',
    'Egenie order online private limited',
    'Cylinder liners agencies private limited',
    'Lion dates private limited',
    'Serenity trades private limited',
    'Molecule trading company private limited',
    'BELHEM INDIA PRIVATE LIMITED',
    'H p i hotels and properties private limited',
    'Shree swami leela hotels and resorts private limited',
    'Prc international hotels private limited',
    'Yum restaurants marketing private limited',
    'Transweld mechanical engineering works limited',
    'Rnr hotels private limited',
    'Meeti inns (anand) private limited',
    'Roadhouse blues hospitality & entertainment private limited',
    'Deshadan resorts and hotels private limited',
    'BIJI',
    'S ENGINEERING (INDIA) PRIVATE LIMITED',
    'Intellidecs private limited',
    'Independent business solutions gulf design private limited',
    'Alcon consulting engineers (india) private limited',
    'Future research design company private limited',
    'Krab consultancy & constructions private limited',
    'Mechci cadd engineering private limited',
    'Xicon international limited',
    'Inzane labs private limited',
    'Reprise media india private limited',
    'Conrad jung (india) pvt ltd',
    'Corporate travel private limited',
    'MECHNOTECH FORGING PRIVATE LIMITED',
    'Lifetree cyberworks private limited',
    'ADITYA BIRLA SUN LIFE TRUSTEE PRIVATE LIMITED',
    'HINDON RIVER RESORTS PRIVATE LIMITED',
    'NAVSHIP MARINE SERVICES PRIVATE LIMITED',
    'Greentech industries (india) private limited',
    'Celebi delhi cargo terminal management india private limited',
    'Usha stud and agricutural farms private limited',
    'Navaratna distributors private limited',
    'G10 logistics private limited',
    'Spiegel enterprises private limited',
    'Simpro business solutions private limited',
    'Menmentor facilities private limited',
    'Indian finishing technologies private limited',
    'Discover dollar technologies private limited',
    'Pi- comm (india) private limited',
    'Scott sports india private limited',
    'Pacewealth corporate advisory private limited',
    'Apex dialysis technologies private limited',
    'M s carhirers (india) private limited',
    'Vmc refractory solutions private limited',
    'Hilliard energy (india) private limited',
    'Sea speed cha services private limited',
    'Siddhi tradematrix private limited',
    'Focus fitness private limited',
    'About Face Aesthetics Private Limited',
    'Wisdom migration & immigration services private limited',
    'Multiamp engineers private limited',
    'Prudent energy saving solutions private limited',
    'Bhalerao towers maintenance centre private limited',
    'Focus datatech systems private limited',
    'Nawcon infrastructure private limited',
    'Wishpoint tech private limited',
    'Snehdeep precision components private limited',
    'George institute for global health',
    'KANSAS OVERSEAS CAREERS PRIVATE LIMITED',
    'Kameswari consultancy services private limited',
    'Four square multi logistics private limited',
    'Mgcm vidya private limited',
    'Surface treatment technology private limited',
    'Hospitality training institute india private limited',
    'Maa security services private limited',
    'Ud media private limited',
    'Ubique packaging systems pvt ltd',
    'Leading edge - m.i.c.e. management private limited',
    'Liquee seals private limited',
    'Cochlear medical device company india private limited',
    'Lq leadership development india private limited',
    'Inorbit tours private limited',
    'NUTRITI INGREDIENTS PRIVATE LIMITED',
    'KAPILS SALON INDIA PRIVATE LIMITED',
    'Talent porte advertising and events private limited',
    'Rosun natural products private limited',
    'Khanna and sawant interiors private limited',
    'Volar fashion private limited',
    'Den abc cable network ambarnath private limited',
    'Animal rahat',
    'Israel aerospace india private limited',
    'Aja factech services private limited',
    'Vega derivative solutions private limited',
    'The maharashtra executor and trustee company private limited',
    'Aerial services private limited',
    'Arctic hvac engineering private limited',
    'Executive centre india private limited',
    'Mega lifestyles private limited',
    'Mco winmark exhibitions private limited',
    'Dibd omii consulting private limited',
    'Falcon maritime india private limited',
    'SANTOSH NAIR',
    'S REALTY DREAM PRIVATE LIMITED',
    'Malabar builders india private limited',
    'Trinity arcade private limited',
    'Kalpaka builders private limited',
    'Suryamangal realty private limited',
    'Ananta landmarks private limited',
    'Pace aftermarket private limited',
    'SIVANA REALTY PRIVATE LIMITED',
    'Rising mountain properties private limited',
    'Swar land developers limited',
    'Apex realty private limited',
    'Seaspring builders private limited',
    'Premshree realestate private limited',
    'Arss damoh - hirapur tolls private limited',
    'V v phuge promoters and builders private limited',
    'Praful construction p. ltd.',
    'Silverline buildhome private limited',
    'Joshi buildestates private limited',
    'Sterling maintenance services private limited',
    'K k gupta constructions private limited',
    'APEKSHA HOUSING PRIVATE LIMITED',
    'Harsh macro buildhome private limited',
    'Dharmapuri constructions private limited',
    'Prathima multiplex private limited',
    'Ind-mark properties private limited',
    'Notus realtors private limited',
    'Aap infrastructure limited',
    'PARADIGM FACILITY AND PROPERTY MANAGEMENT PRIVATE LIMITED',
    'DBR',
    'S NEW PROSPERITY LAND DEVELOPERS & BUILDERS PRIVATE LIMITED',
    'Divyasree nsl infrastructure private limited',
    'Stevia shelters private limited',
    'Valerian promoters private limited',
    'Harshit heights private limited',
    'G. c. property private limited',
    'Cohesive constructions limited',
    'Inderlok buildwell limited',
    'Fetish realtor private limited',
    'Stonewell developers private limited',
    'Cygnus buildwell private limited.',
    'Aarcity infrastructure private limited',
    'Kutumbkam realtors limited',
    'Nitika propmart private limited',
    'Standard buildhomes private limited',
    'Awadh realtors limited',
    'Trandy buildtech private limited',
    'Amedeus town planners private limited',
    'Ampersand systems private limited',
    'Universal expositions limited',
    'HOMZNOW REALTY ADVISORS LIMITED',
    'Green field material handling private limited',
    'NAVAL GROUP INDIA PRIVATE LIMITED',
    'Ipurple media private limited',
    'INNOVEST WEALTH PRIVATE LIMITED',
    'Omega controls private limited',
    'Shree padmavati equities private limited',
    'Exceleon industries private limited',
    'Phronesiz marketing ventures private limited',
    'Ravin industrial infrastructure private limited',
    'Pi ideacom private limited',
    'Piramal packaging private limited',
    'Seashell exim services private limited',
    'Gerah enterprises private limited',
    'Piramal data integrity private limited',
    'Piramal natural resources private limited',
    'Piramal forging private limited',
    'Piramal security private limited',
    'Piramal media private limited',
    'Techgarner it services private limited',
    'Simitri india private limited',
    'Jmj greenolutions & services private limited',
    'Campusconnect technologies private limited',
    'Aakaar medical technologies private limited',
    'PHOENIX INNOVATIVE HEALTHCARE MANUFACTURERS PRIVATE LIMITED',
    'Assemblage entertainment private limited',
    'Bioaltus pharmaceuticals private limited',
    'Mason corporate services private limited',
    'FORTEDGE CARGO AND WAREHOUSING (PUNE) PRIVATE LIMITED',
    'Unique delta force e-security private limited',
    'Mscast engineering private limited',
    'Ashirwad innovative coatings private limited',
    'Vertois training and consultancy private limited',
    'Finwizz management consultants private limited',
    'Innovative techcentre private limited',
    'Falcon business solution private limited',
    'Orchid india medisolutions private limited',
    'Asg security india private limited',
    'Promobi technologies private limited',
    'ISY RELOCATION SERVICES PRIVATE LIMITED',
    'Kia business solutions private limited',
    'Icoat projects private limited',
    'Catpro events and entertainment limited',
    'Visakha solvents limited',
    'Tech o2 india private limited',
    'Estelle india private limited',
    'Moreschi asia doors private limited',
    'Rify hosting private limited',
    'Terra reserves determination technologies limited',
    'Senso security solutions private limited',
    'Eco pest care services private limited',
    'Prowess commercial ventures private limited',
    'Classe auto care solutions private limited',
    'Jss pro services private limited',
    'Gemstech international institute private limited',
    'Icube hr services india private limited',
    'Deco floors impex india private limited',
    'RANK INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED',
    'Voicetec business system india private limited',
    'Asibatech enterprises private limited',
    'Stan india private limited',
    'Ewall solutions private limited',
    'Sunmix network private limited',
    'Gardens & pools private limited',
    'Ocher lv solutions private limited',
    'Bg furnaces india private limited',
    'Techdigital india private limited',
    'Capsheaf solutions private limited',
    'Adroit design india private limited',
    'Laxmi jewellery chennai private limited',
    'Last forest enterprises private limited',
    'A1 force security private limited',
    'Finetune engineering services private limited',
    'Chandrani vinimay private limited',
    'Shriram ozone townships private limited',
    'Geovale services private limited',
    'RKM AGRO FRESH PRIVATE LIMITED',
    'Mars-power utilities private limited',
    'Saraswati placements private limited',
    'Radix hr solutions private limited',
    'Good relations consultants private limited',
    'Think future hr consulting private limited',
    'Sieger training consultants private limited',
    'IDEMIA IDENTITY & SECURITY INDIA PRIVATELIMITED',
    'UNIQ SECURITY SOLUTIONS PRIVATE LIMITED',
    'MODERN PROTECTION INDIA PRIVATE LIMITED',
    'Vedant fire and security systems private limited',
    'Unique delta force security private limited',
    'Unimax smart services private limited',
    'Vraj packaging private limited',
    'Aida india private limited',
    'Lexicon advisory services private limited',
    'Sapphire infra solutions private limited',
    'Damara gold private limited',
    'INDITA BENTEL REALTY CONSULTANTS PRIVATELIMITED',
    'SEA ROCK PORTS & PROJECTS PRIVATE LIMITED',
    'Zenita lifescience private limited',
    'Bayer zydus pharma private limited',
    'Tri-inception biosciences private limited',
    'LAURUS LABS LIMITED',
    'Neophar alipro limited',
    'Mega innovative crops private limited',
    'PIRAMAL CORPORATE SERVICES PRIVATE LIMITED',
    'Millennium lifecare limited',
    'Healthy life pharma private limited',
    'MARS THERAPEUTICS PRIVATE LIMITED',
    'Adonia cosmetics private limited',
    'Aaheli healthcare private limited',
    'Ocea marine cosmetics private limited',
    'Magnum pharmatech pvt ltd',
    'Nh cosmetics private limited',
    'VGA ALTACUS PRIVATE LIMITED',
    'Roselabs bioscience limited',
    'Aplab engichem private limited',
    'JB NAG WATER TECH PRIVATE LIMITED',
    'Cht (india) private limited',
    'United specialities private limited',
    'HATZ MANUFACTURING PRIVATE LIMITED',
    'Kodiyal rubber works private limited',
    'Preciflex insulations private limited',
    'Shakti sai tyres private limited',
    'Family plastics and thermoware private limited',
    'Jasmino polymertech private limited',
    'Ajmera tyres private limited',
    'Voxtur bio limited',
    '3d-seals private limited',
    'Lorven flex and sack india private limited',
    'K. patel drives system private limited',
    'Scorpion industrial polymers private limited',
    'ATTHARV SAI FLEXIPACK PRIVATE LIMITED',
    'Adhunik plastic and industries pvt ltd',
    'Surana plastic and paper private limited',
    'Systematic industries private limited',
    'Safal flexibond private limited',
    'Arrowhead engicon private limited',
    'Lead reclaim and rubber products limited',
    'Drts india private limited',
    'Vulcan polymers private limited',
    'Prince multiplast private limited',
    'Monica enterprises private limited',
    'Hasolon nylon products pvt ltd',
    'Ashish agro-plast pvt ltd',
    'Nishant mouldings private limited',
    'Pondicherry polymers private limited',
    'Velma plastos private limited',
    'Kalna plastic disposable private limited',
    'Ntf technik india private limited',
    'PRAGATI GLASS & INDUSTRIES PRIVATE LIMITED',
    'Shinemica laminate private limited',
    'Fiber optika technologies private limited',
    'Rose opticals private limited',
    'The central glass industries private limited',
    'Sunland ceramic private limited',
    'M a ceramics pvt ltd',
    'Sanford vitrified private limited',
    'Spentika ceramic private limited',
    'Arise ceramic private limited',
    'Panara ceramic private limited',
    'Core clay private limited',
    'KANERIA PLAST PRIVATE LIMITED',
    'Trumboo industries private limited',
    'Basant flooring private limited',
    'Shripad concrete private limited',
    'Saifco cements private limited',
    'Hari kirpa perfumes private limited',
    'Meenakshi cement-n-steel (bangluru) private limited',
    'SAVINO MICRON (INDIA) LIMITED',
    'Jlc electromet private limited',
    'Chhattisgarh metaliks and alloys private limited',
    'Agrasen iron and steels private limited',
    'Enershell alloys & steel private limited',
    'SONAL IRONS INDUSTRY PRIVATE LIMITED',
    'Metalkraft window accessories private limited',
    'Gunjan ispat private limited',
    'Sunland recycling industries limited',
    'Brazen arrow company private limited',
    'PARAS WIRES PRIVATE LIMITED',
    'Mod forge private limited',
    'Omega techniks india private limited',
    'Indigo metalloys private limited',
    'Gilco steels limited',
    'Veesons alloys private limited',
    'Vinayak steels ltd',
    'Narayani rail products private limited',
    'Meet shell s pvt ltd',
    'SUZLON GLOBAL SERVICES LIMITED',
    'Mbr metal solutions private limited',
    'Renold chain india private limited',
    'Chirag castings private limited',
    'Shakambhari ispat & power limited',
    'Alliance infratech private limited',
    'Marubeni-itochu steel india private limited.',
    'Titanium industries india private limited',
    'Polymech components private limited',
    'Dhr holding india private limited',
    'Pune industrial distributors private limited',
    'Hydromax technologies private limited',
    'Nilgiri mercantiles pvt. ltd.',
    'Indur developers and agencies private limited',
    'Adam smith trading private limited',
    'Shambhavi exim private limited',
    'Ito electronics (india) private limited',
    'Kakkanattu trading company private limited',
    'Philtech engineering private limited',
    'LORD KRISHNA HOME MART PRIVATE LIMITED',
    'S m mehta and company pvt ltd',
    'Business money solutions private limited',
    'Beeline commodities private limited',
    'Bigtree financial consulting private limited',
    'Dhanvriddhi finvest services private limited',
    'TRADEWELL SECURITIES LIMITED',
    'Investmentor securities limited',
    'Jagruti rubber enterprises pvt ltd',
    'Nirbhay capital services private limited',
    'Unidor wealth management private limited',
    'Farah securities private limited',
    'Karman investments private limited',
    'Doli trading and investments private limited',
    'Sudhanva investments and trading company private limited',
    'Lyon investment and industries private limited',
    'Ceetee trading and leasing pvt ltd',
    'J. p. morgan india private limited',
    'Shekhar holdings pvt ltd',
    'Rupa equities private limited',
    'Angel securities limited',
    'Weed investment and finance p ltd',
    'Conifer investments p ltd',
    'Pallazzio hotels & leisure limited',
    'Mudra share and stock brokers limited',
    'Truevalue capitals limited',
    'Hariyana ship demolition private limited',
    'Mangalam stock broking private limited',
    'Chartered traders private limited',
    'Latin manharlal securities private limited',
    'Finquest securities private limited',
    'Asset alliance securities private limited',
    'Saffron capital advisors private limited',
    'Premium equities and securities private limited',
    'KHASNIS PRIME WEALTH PRIVATE LIMITED',
    'Sai kirpa finvest private limited',
    'Sparton capital limited',
    'C. r. kothari & sons commodities private limited',
    'C r kothari and sons equities private limited',
    'Pankaj capfin private limited',
    'S.k. safety wings private limited',
    'FAST CAPITAL PRIVATE LIMITED',
    'Mohindra finvest private limited',
    'Shri khemisati polysacks private limited',
    'Snap securities private limited',
    'Seeders venture capital private limited',
    'Wisdom capital advisors private limited',
    'Altius capital india private limited',
    'Moonbeam capital managers private limited',
    'Muthoot forex limited',
    'Varma & varma financial consulting private limited',
    'Estrella consultancy private limited',
    'Svs securities private limited',
    'Transproz translation services india private limited',
    'INVESTOR SHOPPE PRIVATE LIMITED',
    'Sun capital advisory services private limited',
    'Fidelis management consultants private limited',
    'Capitalsquare projects consultants limited',
    'Capitalsquare financial services private limited',
    'Vetri corporate advisors private limited',
    'Saffron financial advisory & consultancy services private limited',
    'Violet arch capital advisors private limited',
    'Stockhifi advisory services private limited',
    'Shakthi associates financial services private limited',
    'Valamai benefit fund limited',
    'Graass holding private limited',
    'Indus net finvest resources private limited',
    'Senrysa financial services private limited',
    'K.D.K. SOFTWARES (INDIA) PRIVATE LIMITED',
    'S c n infrastructure private limited',
    'Bharat re-insurance brokers private limited',
    'Logix infrabuild private limited',
    'Logix buildestate private limited',
    'Citadel propcon private limited',
    'Sesko infrastructure and realtors india private limited',
    'Muthoot buildtech (india) private limited',
    'Muthoot properties (india) private limited',
    'Triveni real estate and developers private limited',
    'Thana properties private limited',
    'Kamlesh real estates private limited',
    'Black stone properties private limited',
    'Hitendra properties private limited',
    'Varun real properties and investments private limited',
    'Highness estates private limited',
    'Millennium developers private limited',
    'Kamadgiri real estate private limited',
    'Tekpoint properties private limited',
    'Sai park estate developers (india) private limited',
    'Evergreen habitats and realties private limited',
    'Chitre estate and hospitality services private limited',
    'Vishnoi buildcon private limited',
    'Gri homes private limited',
    'Sap estates private limited',
    'H s s real estate private limited',
    'H a properties private limited',
    'Bharti realty limited.',
    'Tulip realcon private limited',
    'Eagle buildcon private limited',
    'T.k. shyam and associates private limited',
    'Urs consulting (india) private limited',
    'HALLEYS BLUE STEELS PRIVATE LIMITED',
    'MILLER DESIGN PRIVATE LIMITED',
    'Starways engineers private limited',
    'Ocs services (india) private limited',
    'Montex properties and advertising private limited',
    'Gemsons precision engineering private limited',
    'Avinash techno-legal consultants private limited',
    'Bellpepper animation private limited',
    'Liquid space architecture & design private limited',
    'Zamil steel engineering india private limited',
    'Green evolution architectural consultancy private limited',
    'Intertek india private limited',
    'Mm marcom private limited',
    'Peacock advertising (india) private limited',
    'DENTSU COMMUNICATIONS INDIA PRIVATE LIMITED',
    'DENTSU MARKETING SOLUTIONS PRIVATE LIMITED',
    'Dhiraj communication and networking private limited',
    'Pooja communications (india) private limited',
    'Sunjeet communications private limited',
    'Uei media private limited',
    'Moms outdoor media solutions private limited',
    'Sincore steel homeware private limited',
    'Platinum advertising private limited',
    'WISHBERRY ONLINE SERVICES PRIVATE LIMITED',
    'FIELD SPORT PLAYER MANAGEMENT PRIVATE LIMITED',
    'Sead advertising private limited',
    'Sys india private limited',
    'Federation of india mineral industries',
    'Ace hardware private limited',
    'Exotic journeys private limited',
    'Pioneer fabricators private limited',
    'Aaa real estate private limited',
    'Xvarian auto industries private limited',
    'Express distributors private limited',
    'National backward classes finance and development corporation',
    'Facilitator financial services private limited',
    'ANAND BUTTONS PRIVATE LIMITED',
    'Palcom infotech private limited',
    'Nutra foods india private limited',
    'Garmex (india) private limited',
    'Ashir marketing (india) private limited',
    'M.f. properties private limited',
    'Nokia india private limited',
    'Parveen jain and company private limited',
    'Pa real estate private limited',
    'Pergo india private limited',
    'GLOBALLOGIC INDIA PRIVATE LIMITED',
    'Cinflex infotech private limited',
    'Seh foods and beverages (india) private limited',
    'Seh overseas (india) private limited',
    'Ha and sa developers private limited',
    'Brainspree infosystems private limited',
    'Karin priject management private limited',
    'Paru construction private limited',
    'Anushria buildcon private limited',
    'First esco india private limited',
    'Umang communications private limited',
    'NOVAERUM AUTOMOTIVE PRIVATE LIMITED',
    'Eagle express logistics india limited',
    'DIVINO INDIAN PRIVATE LIMITED',
    'Sawhney exim private limited',
    'Rkp global private limited',
    'Prabhu naivedyam events private limited',
    'Companion animal healthcare alphapets private limited',
    'Spur info consultancy private limited',
    'Sri mishrimalji rughnathmalji doshi charitable foundation',
    'Vina international private limited',
    'Divwy power solutions private limited',
    'FABULOUS MEDIA PRIVATE LIMITED',
    'Nyg energy solutions private limited',
    'Gmo globalsign certificate services private limited',
    'Satchitanand stencils private limited',
    'Honeycomb creative support private limited',
    'Nispana innovative platforms private limited',
    'Angaros management company private limited',
    'Columbia sportswear india sourcing private limited',
    'Hobvision technologies private limited',
    'BATH & BODY WORKS INDIA PRIVATE LIMITED',
    'Dynamo info technologies private limited',
    'Danske it and support services india private limited',
    'NITSHAW WOOD PANEL AND SURFACE TECHNOLOGIES PRIVATE LIMITED',
    'Amrithagiri ecolife private limited',
    'ARYEH VENTURES PRIVATE LIMITED',
    'Scripbox advisors private limited',
    'M-pledge services private limited',
    'Wolfpack outdoors private limited',
    'Rtc retail environments (india) private limited',
    'BINBAG ENVIRONMENTAL SERVICES PRIVATE LIMITED',
    'Lk excella decors private limited',
    'Bizenius business solutions private limited',
    'Finch it solutions private limited',
    'Sangsan home styler private limited',
    'Didactic systems india private limited',
    'Jos marine technical services private limited',
    'Ajs impex private limited',
    'NETWORK FOR ENGINEERING AND ECONOMICS RESEARCH AND MANAGEMENT PRIVATE LIMITED',
    'Schaefer systems international private limited.',
    'Soham polymers private limited',
    'Jpb chemical industries private limited',
    'Vipul chemicals (india) private limited',
    'Srs unistraw private limited',
    'Hindustan monomers (unit no. ii) private limited',
    'Jord international private limited',
    'Satruc appliances private limited',
    'Parkem dyes and chemicals private limited',
    'Sphinax chemical industries private limited',
    'Sdk chemicals (india) private limited',
    'Annexe chem private limited',
    'Penshibao wang private limited',
    'Greans india chemicals private limited',
    'Virupaksha laboratories private limited',
    'Lifescience laboratories private limited',
    'Rishi chemical works pvt ltd',
    'MYSORE AMMONIA AND CHEMICALS LIMITED',
    'S k oswal polymers private limited',
    'P.i.p. polymers private limited',
    'Icpa health products ltd',
    'Dr.acharya laboratories private limited',
    'RAM AGRO CHEMICAL INDUSTRIES PRIVATE LIMITED',
    'NISSIN ADVANCED COATING INDO CO. Private Limited',
    'Sbl colortech p ltd',
    'D r coats ink and resins private limited',
    'Modi life care industries limited',
    'Mirus pharma private limited',
    'VESTA PHARMACHEM PRIVATE LIMITED',
    'Alaunus pharmaceutical private limited',
    'CELEBRITY BIOPHARMA LIMITED',
    'EYECIRQUE PRIVATE LIMITED',
    'Lesanto laboratories private limited',
    'Hesh herbal private limited',
    'Fleming laboratories limited',
    'Shimmer chemicals private limited',
    'Ankit logistics private limited',
    'Aarya lifesciences private limited',
    'Ontop pharmaceuticals private limited',
    'ZENZI PHARMACEUTICAL INDUSTRIES PRIVATE LIMITED',
    'Veritaz healthcare limited',
    'Qualichem specialties private limited',
    'General drug private limited',
    'Sm innotech private limited',
    'Synapse labs private limited',
    'Biogenomics limited',
    'Bangalore best veterinary products private limited',
    'Entod healthcare private limited',
    'Sr medicare private limited',
    'Allengers global healthcare private limited',
    'Jarun pharmaceuticals private limited',
    'Swiss nutraceuticals private limited',
    'Lovincare cosmetics private limited',
    'Atlantic bio medical private limited',
    'Avesta pharma private limited',
    'Flora organics private limited',
    'Olivia cosmetics private limited',
    'Shree gautam multi chem private limited',
    'Oriental fragrances and flavours private limited',
    'Pearl coschem private limited',
    'Headrush marketing private limited',
    'EARTHGENIX PRO PRIVATE LIMITED',
    'Symrise private limited',
    'DON CONSTRUCTION CHEMICALS INDIA PRIVATELIMITED',
    'Zchem specialities private limited',
    'Afri ventures (india) private limited',
    'AARTI VENTURES PRIVATE LIMITED',
    'Buzil rossari private limited',
    'Sunchem marketing private limited',
    'Bulk liquid solutions private limited',
    'KIRAN GLOBAL CHEMS LIMITED',
    'SEACON ENERGY & INFRASTRUCTURE LIMITED',
    'Satyen polymers private limited',
    'Techser power solutions private limited',
    'Aditya thermopack private limited',
    'Maxan corporation private limited',
    'Mantralaya polymers private limited',
    'Nalin rubber private limited',
    'Srp synthetic rubber products private limited',
    'Niyuprene plastics company private limited',
    'G M POLYPLAST LIMITED',
    'Narendra plastic private limited (part ix)',
    'Eftec (india) private limited',
    'Upi polymers private limited',
    'HARBINGER DESIGN AND ENGINEERING PRIVATE LIMITED',
    'Bloom industrial plastics private limited',
    'Brajesh packaging private limited',
    'Varnada industries private limited',
    'Kvn polytech private limited',
    'Matrix polytech private limited .',
    'Raghav plastech private limited',
    'Diamond polyplast private limited',
    'Anil polymers private limited',
    'Narendra poly-prints limited',
    'Roongta polyfilm private limited',
    'Chemco plastic industries private limited',
    'Plastech international private limited',
    'Metco roof private limited',
    'Uday exports private limited',
    'Deluxe impex private limited',
    'SWAN INTERNATIONAL PRIVATE LIMITED',
    'SARIN INDUSTRIES PRIVATE LIMITED',
    'Suchetan exports p.ltd.',
    'Sukhsagar traders private limited',
    'ATHENA BPO PRIVATE LIMITED',
    'Sanjay kumar shankarlal export private limited',
    'Asis global limited',
    'Sweety exports private limited',
    'Recon exim india private limited',
    'Somochem india private limited',
    'Mercury maritime services private limited',
    'Avean international private limited',
    'Vasantrai petro-chemicals (india) private limited',
    'Rapid enterprises private limited',
    'Ashwin general merchants private limited',
    'Netwest trading company private limited',
    'Sahastraa exports private limited',
    'Kanha ventures private limited',
    'Aaress trading private limited',
    'GRAPHIC POLY PRINT ',
    'PACK PRIVATE LIMITED',
    'Red elephant tools india private limited',
    'Kascap glass private limited',
    'Pentland india trading private limited',
    'Rishabh tracom and commercial merchants private limited',
    'Afore tracom and merchants private limited',
    'Immaculate multi trade and commerce private limited',
    'City fame agencies private limited',
    'Hexagon metrology india private limited',
    'Ingenico international india private limited',
    'Hnh designs private limited',
    'E cube sales solutions private limited',
    'Statworks india private limited',
    'Martand enterprise private limited',
    'Add value solutions private limited',
    'Shree jagdamba texco-fab private limited',
    'Grow-wel engineering export private limited',
    'Trans diesel engineers private limited',
    'Kimmane betelnuts private limited',
    'Applied realtech systems private limited',
    'Renesas electronics india private limited',
    'Kurichithanam herbals private limited',
    'Value added tyre solutions private limited',
    'Ashly aluminium private limited',
    'Rayagad trading co pvt ltd',
    'Gullco international india private limited',
    'Sejal international limited',
    'Narendra exim private limited',
    'GREY',
    'NICHE INFOTECH SOLUTIONS PRIVATE LIMITED',
    'Grip technologies private limited',
    'Comtech asia limited',
    'SHILPIN MACHINE TOOLS PRIVATE LIMITED',
    'Saturn e-solutions private limited',
    'Om knowledgeshare private limited',
    'Ngenious solutions private limited',
    'Raisebill services private limited',
    'Benzy infotech private limited',
    'Crest it consulting private limited',
    'Chipmunk designs technologies private limited',
    'Touching services private limited',
    'Technocrats horizons compusoft private limited',
    'CYEMPTIVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Trendy online solutions private limited',
    'Sunup engineering private limited',
    'Sprance technologies private limited',
    'Ideametrics private limited',
    'Dbm infotech private limited',
    'Connecticus technologies private limited',
    'Altizon systems private limited',
    'Wiznucleus software private limited',
    'Synbuf technologies private limited',
    'Webteam private limited',
    'Futuretek esolutions india private limited',
    'Talentlogic info services private limited',
    'A2z waste management (nainital) private limited',
    'A2z waste management (dhanbad) private limited',
    'A2z waste management (ranchi) limited',
    'A2z waste management (ahmedabad) limited',
    'Punjab municipal infrastructure development company',
    'Fomento green and waste management services private limited',
    'A2z waste management (balia) limited',
    'A2z waste management (badaun) limited',
    'A2z waste management (mirzapur) limited',
    'A2z waste management (fatehpur) limited',
    'A2z waste management (sambhal) limited',
    'A2z waste management (ludhiana) limited',
    'A2z waste management (jaipur) limited',
    'MUMBAI COLOUR & CHEMICAL MERCHANTS ASSOCIATION',
    'International ayurveda foundation',
    'Heroes aids project',
    'Vnit nagpur alumni association',
    'All india cotton gin press association',
    'Ichalkaranji textile development clustar limited',
    'Tropic film private limited',
    'CHEMTECH FERTILISERS Private Limited',
    'Thinxworks pictures private limited',
    'Courtyard entertainment private limited',
    'One com media private limited',
    'Rockstar creative agency private limited',
    'Moksh events private limited',
    'AIPL FOUNDATION',
    'Cr retail malls (india) limited',
    'Shroom studios private limited',
    'Adarsh telemedia private limited',
    'Gujarat tourism opportunity limited',
    'Cloud 9 pictures private limited',
    'Parsvnath film city limited',
    'Authentic travels private limited',
    'International recreation and amusement limited',
    'Synqua games private limited.',
    'Holy basil productions private limited',
    'Abode media private limited',
    'Madras boat club',
    'Magadh cricket league',
    'Empower activity camps private limited',
    'Arl parivar multitrade limited',
    'Alston elliot india private limited',
    'Gold television network private limited',
    'Atluri career consultancy private limited',
    'De corporate consulting private limited',
    'Haskoningdhv consulting private limited',
    'Wellindia research & education private limited',
    'Edu assessment private limited',
    'Vhr professional services private limited',
    'Ivy facilman limited',
    'Dksd corporate services private limited',
    'Acacia training private limited',
    'Environmental resources foundation',
    'Interconnect media private limited',
    '3d vigilance services private limited',
    'Insperel meditech private limited',
    'Vythiri holiday villas private limited',
    'Savya engineering services private limited',
    'Ns tax services private limited',
    'Arcus india advisors private limited',
    'Kaycomm services private limited',
    'Iplace software services private limited',
    'Nantech power systems private limited',
    'Centroid motion capture private limited',
    'Agrim efilingservices.com private limited',
    'Mona beauty clinic private limited',
    'Ewi development initiative foundation',
    'AIPL ESTATE MANAGEMENT PRIVATE LIMITED',
    'Shalimar security and consultancy services private limited',
    'Acm shipping india limited',
    'Magnum bpmc private limited',
    'Sirius risk management services pvt ltd',
    'Fools paradise designworks private limited',
    'Dawn services private limited',
    'Vivek safe deposit lockers limited',
    'Flamagas india private limited',
    'Sundaram asset management company limited',
    'Cctv technologies private limited',
    'Vibro pharma private limited',
    'Prabhat udyog limited',
    'Orex pharma private limited',
    'Light house investments ltd',
    'Thakersey exports pvt ltd',
    'Stan cans private limited',
    'Sanjivani medical and general stores pvt. ltd.',
    'Runa chemicals pvt ltd',
    'Nova teletech private limited',
    'Flash forge private limited',
    'FASHION INDIA PRIVATE LIMITED',
    'Gws engineers & fabricators pvt ltd',
    'Aum securities private limited',
    'Paawan capital services limited',
    'Manpada builders and developers private limited',
    'J b home store private limited',
    'GRAUER & WEIL ENGINEERING PRIVATE LIMITED',
    'Integrral media private limited',
    'Greeps construction pvt ltd',
    'Tata toyo radiator limited',
    'Nmdc limited',
    'OCEAN AGRO INDUSTRIES PRIVATE LIMITED',
    'Tilaknagar industries limited',
    'SEEYOK TEA CO PRIVATE LIMITED',
    'Unimech systems (bangalore) private limited',
    'ESSEM AUTO ELECTRICALS PRIVATE LIMITED',
    'CEASEFIRE INDUSTRIES PRIVATE LIMITED',
    'ASHRAE CLEAN ROOM PRESENTATIONS PRIVATE LIMITED',
    'Elite thermal engineers p ltd',
    'Amol engineering private limited',
    'Eewa engineering company private limited',
    'Apple enterprises engineering private limited',
    'Sanhit automation technologies private limited',
    'Smb engineers private limited',
    'Witt india private limited',
    'Aspick engineering private limited',
    'Lapmaster wolters india private limited',
    'Saan engineers private limited',
    'Robland vebim machinery private limited',
    'Patel precision private limited',
    'Sharada technologies private limited',
    'DORMER PRAMET INDIA PRIVATE LIMITED',
    'Epes carbide tools india private limited',
    'Controls india private limited',
    'Chennai technomarketing private limited',
    'SOTEFIN PARKING PRIVATE LIMITED',
    'THE OXYGEN EQUIPMENT & ENGINEERING COMPANY PRIVATE LIMITED',
    'Force equipments private limited',
    'Diamond fire safety engineers private limited',
    'Sr process controls private limited',
    'Aramex appliances private limited',
    'Sriven autopac private limited',
    'Gopal & metzger technologies private limited',
    'Elattice automation private limited',
    'Mcc alcast private limited',
    'Gk techno synergies private limited',
    'Blum novotest measuring and testing technology private limited',
    'Minco malvern process equipment private limited',
    'Pragati control systems private limited',
    'Srikrishna industrial works india private limited',
    'Lex technoaid international private limited',
    'Kinematics machines private limited',
    'Vitech heavy equipments private limited',
    'Jal ecotech india private limited',
    'Mesura nirmal gas controls private limited',
    'Caf5 vending solutions private limited',
    'Global conveyor technologies private limited',
    'Solar energy equipments technologies private limited',
    'Niedax india cable management systems private limited',
    'Minarva machinery mfrs private limited',
    'D and h engineering (bharat) private limited',
    'Qms-pro engineering private limited',
    'Envytech systems (india) private limited',
    'M. k. morse company india private limited',
    'Paalsun engineers (india) private limited',
    'The acetech machinery components india private limited',
    'Analytical automation (india) private limited',
    'Firetech equipment and systems private limtied',
    'Ready genset solutions private limited',
    'Shri nath press equipments private limited',
    'Monte bianco diamond tools private limited',
    'GLOBALE SG DESIGNS PRIVATE LIMITED',
    'Tc maschinen pvt. ltd.',
    'Tetra india private limited',
    'Divx medical equipments and software technologies private limited',
    'Kothari pharma technologies private limited',
    'K mass control private limited',
    'Quicloc private limited',
    'Sunikh components private limited',
    'Felsomat india private limited',
    'Lean automation equipments private limited',
    'Unique industrial handlers pvt ltd',
    'Siddhi cnc private limited',
    'Conex avioauto private limited',
    'Naraiuran controls (india) private limited',
    'MARCUS HI-TECH ENGINEERING PRIVATE LIMITED',
    'Srinath plant and equipments private limited',
    'Accord tech private limited',
    'Integrated cleanroom technologies private limited',
    'Melstar manufacturing systems private limited',
    'Pro-med instruments private limited',
    'Prabha engineering private limited',
    'Shubham electrotech private limited',
    'Active carbon india private limited',
    'Qmax systems (india) private limited',
    'Kuruganti computers private limited',
    'Trends infonet solution private limited',
    'Menaka Mills Private Limited',
    'Silvertouch infotech limited',
    'Easi technolegies private limited',
    'VISTA MARITIME PRIVATE LIMITED',
    'R-logic technology services (india) private limited',
    'Tathasthu technologies private limited',
    'Digitron computers private limited',
    'Kepri computers private limited',
    'Suspa pneumatics india private limited',
    'Philson electric company private limited',
    'Nebula computers private limited',
    'Computer association of eastern india',
    'Korde electric private limited',
    'Emessam transtek company private limited',
    'Anandalok properties private limited',
    'Malvika commercial pvt ltd',
    'Pallet dealcom private limited',
    'Lance barter private limited',
    'Mangalam vinimay private limited',
    'Nandlal vinimay private limited.',
    'Eshanputra commercial private limited',
    'Vaibhav vyapaar private limited',
    'Surya cotex private limited',
    'Basukinath dealtrade private limited',
    'Anjaniputra commotrade private limited',
    'SIRMOURI PARTNERS PRIVATE LIMITED',
    'Me casa furnishings private limited',
    'M.l. natural colourless diamonds private limited',
    'Fx multitech private limited',
    'Karmyogi mart limited',
    'Jvg trades & hospitality private limited',
    'Alekip tradelink private limited',
    'Prathmik merchants private limited',
    'Concept printers & interiors private limited',
    'Kanika oil ventures private limited',
    'CRUISE PHARMACIA PRIVATE LIMITED',
    'DAMORE CONSULTING PRIVATE LIMITED',
    'Chandana fashion private limited',
    'ACCURACY SHIPPING LIMITED',
    'Dhandapani exports private limited',
    'Nike cotton traders private limited',
    'HITACHI RAIL STS INDIA PRIVATE LIMITED',
    'Rubinsha exports pvt ltd',
    'Higot systems private limited',
    'Qrs retail limited',
    'Zeta technologies private limited',
    'Hi-tech metrology private limited',
    'Psn construction equipment private limited',
    'Almas organics private limited',
    'Future pace enterprise private limited',
    'Bennishirur retail india private limited',
    'Pts powertronic solutions private limited',
    'Ilove diamonds private limited',
    'Gmg systems private limited',
    'Circular edge solution private limited',
    'Turquoise export private limited',
    'Motiwala jewellery exports private limited',
    'VRN GEMS AND JEWELLERY PRIVATE LIMITED',
    'Agneya agro and engineering limited',
    'Tisane beverages private limited',
    'Intrepid online retail private limited',
    'Team jstar enterprises private limited',
    'Simba shopping private limited',
    'Elico marketing private limited',
    'A & a international trading private limited',
    'Sparkle align mercantiles private limited',
    'Impresario event marketing company private limited',
    'Apex exports private limited',
    'Vrindavan telecoms (india) private limited',
    'Radiant electric agency private limited',
    'Complus systems private limited',
    'Raw mango private limited',
    'Madhuban inn private limited',
    'Manas hospitality private limited',
    'Lenexis foodworks private limited',
    'Hotel babylon continental private limited',
    'Dreamworld holidays (india) limited',
    'Mukut hotels and resorts pvt. ltd.',
    'Nupur hotels private limited',
    'Park balluchi hospitality private limited',
    'Glimpses holidays private limited',
    'IRIIS TRADING INDIA PRIVATE LIMITED',
    'Bon temps private limited',
    'El dorado motels private limited',
    'Good hotels & resorts private limited',
    'AHDOO',
    'S INDUSTRIES LTD.',
    'Nexira india private limited',
    'Abad exim private limited',
    'Sri rajam food industries private limited',
    'Indiania jewellery company private limited',
    'Manson enterprises india private limited',
    'Life line circuits private limited',
    'Nawli agro & infraspace private limited',
    'Manoj yarn processors limited',
    'ABT FOODS AGROVET LIMITED',
    'Mettupalayam agricultural research farm private limited',
    'Kayakarpa organic farm private limited',
    'Dhara farming private limited',
    'VERITAS INFRA & LOGISTICS PRIVATE LIMITED',
    'REDSON CROP SCIENCE PRIVATE LIMITED',
    'Anand hatcheries private limited',
    'Madhuting tea private limited',
    'Maris agro-products private limited',
    'Urbi enterprises private limited',
    'Lava plantations pvt ltd',
    'AXESTRACK SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ALPHA PLANTATIONS PRIVATE LIMITED',
    'Ramprastha greens private limited',
    'Vap agricultural products (bombay) pvt ltd',
    'Weldon fincap private limited',
    'Modern daily needs private limited',
    'Gopi dehydrates private limited',
    'Miracle food processors international ltd',
    'Clover foods pvt ltd',
    'Saawariya international private limited',
    'South india fruit plantation private limited',
    'PARTAP SPINTEX PRIVATE LIMITED',
    'KADER EXPORTS PRIVATE LIMITED',
    'Purbasha foods private limited',
    'Shanti oilpalm ind. private limited',
    'N k oil mills pvt ltd',
    'Cascade gelati private limited',
    'Aditi dairy and agro farms private limited',
    'Jangipur bengal mega food park limited',
    'Hyfun frozen foods private limited',
    'Parisons roller flour mills p ltd',
    'K k r agro mills private limited',
    'Ganga roller flour mills private limited',
    'Chempaka flour mills private limited',
    'Nav bharat infrastructures private limited',
    'Hrb agro private limited',
    'Gagan pulses private limited',
    'GPA CAPITAL FOODS PRIVATE LIMITED',
    'Aryavarth franchising private limited',
    'TANNA FOODS PRIVATE LIMITED',
    'Fresco foods private limited',
    'Joann foods and trading private limited',
    'Desai foods private limited',
    'Kamala consumer care private limited',
    'KANHAI FOODS LIMITED',
    'Somaiya agencies private limited',
    'Chadha sugars and industries private limited',
    'Sancorp confectionary private limited',
    'Om pack food private limited',
    'Gits food products private limited',
    'MJF EXPORTS LIMITED',
    'OCEANIC FOODS LIMITED',
    'Om oil and flour mills limited',
    'Stc spices projects private limited',
    'Golden fries limited',
    'Accelerated freeze drying co limited',
    'Shiv and co pvt ltd',
    'Kals distilleries private limited',
    'Grape to glass wine company private limited',
    'Kalis sparkling water private limited',
    '20 microns nano minerals limited',
    'Dholakia tobacco private limited',
    'Four seasons wines limited',
    'VALLON FARMDIRECT PRIVATE LIMITED',
    'Ambika india private limited',
    'Bengal beverages pvt ltd',
    'Mount everest breweries limited',
    'Sri mahalakshmi tobacco exporters private limited',
    'Sopariwala exports private limited',
    'Cigarette distributing centre private limited',
    'Pankaj spinners pvt ltd',
    'Kedar fabrics private limited',
    'TRILLIUM VENTURES PRIVATE LIMITED',
    'TEREBINTH VENTURES PRIVATE LIMITED',
    'SUMIL TRADING PRIVATE LIMITED',
    'Kedia synthetics private limited',
    'Nirmal spinning mills pvt ltd',
    'Yantraman automac private limited',
    'Arvind motors private limited',
    'Kbs motors private limited',
    'G.k. autowheels private limited',
    'PAULO TRAVELS PRIVATE LIMITED',
    'Dans energy consulting private limited',
    'Sfi parcel services private limited',
    'ENEL GREEN POWER INDIA PRIVATE LIMITED',
    'North chennai power company limited',
    'Dpk renewable energy private limited',
    'JEEVANTICA GREEN VENTURES PRIVATE LIMITED',
    'Rsb energy private limited',
    'Gujarat nre energy resources limited',
    'Supertech urja & power private limited',
    'Kartikay resources and powergen private limited',
    'Bharat surya energy limited',
    'U-solar clean energy solutions private limited',
    'Stellar energy technologies private limited',
    'Palvai solar energy private limited',
    'Chamundeeswari energy private limited',
    'Kadodara power private limited',
    'Vishnu energy sources private limited',
    'Era hydro biotech energy private limited',
    'Trn energy private limited',
    'Bharat light and power private limited',
    'PATNI - ENTERPRISES PRIVATE LIMITED',
    'NOV MFG INDIA PRIVATE LIMITED',
    'Sri venkateswaraa air products private limited',
    'Pearl green energy private limited',
    'Petrodia engineering international private limited',
    'Dahegaon coal and power private limited',
    'RIMROCK INFRASTRUCTURE PRIVATE LIMITED',
    'RIMROCK INFRATECH PRIVATE LIMITED',
    'KALISMA AEROSPACE SOLUTIONS DEFENSE PRIVATE LIMITED',
    'Dorado energy private limited',
    'Integrated business and technical consultants private limited',
    'LIVPURE PRIVATE LIMITED',
    'Finolex plasson industries private limited',
    'Dhruva realty projects limited.',
    'Offshore holdings private limited',
    'Dcs limited',
    'Vishwam constructions private limited',
    'Kla const.technologies private limited',
    'Lavender developers private limited',
    'Broomfield developers private limited',
    'Broomfield builders private limited',
    'Jindal realtech private limited',
    'Supertech realtech private limited',
    'Shree radhey colonisers private limited',
    'ADVIT VENTURES PRIVATE LIMITED',
    'Ramprastha buildwell private limited.',
    'H s infratech private limited',
    'Pioneer town planners private limited',
    'Trilok buildwell private limited',
    'Rudraksh buildwell private limited',
    'Superior infratech private limited',
    'Indraprastha metropolitan development limited',
    'Zest residency private limited',
    'Zest villas private limited',
    'Zest dwellings private limited',
    'Ascot green projects private limited',
    'Dms infrastructure private limited',
    'Vsv enterprises private limited',
    'J s r holdings private limited',
    'Blue house infra private limited',
    'Surveyors and company pvt ltd',
    'TATHAASTU INFRA AND PROPERTIES PRIVATE LIMITED',
    'Cosmos estate private limited',
    'Holly hock resorts & hospitality services private limited',
    'DAMOSUAM CARRIERS PRIVATE LIMITED',
    'Otters properties private limited',
    'Marvel infomedia private limited',
    'Shreeyam power and steel industries limited',
    'Flawless constructions private limited',
    'Prudential housing and infrastructure development limited',
    'Karan projects private limited',
    'Sunny apartments private limited',
    'Hicons constructions private limited',
    'Patel patron private limited',
    'Morries housing private limited',
    'Rak construction project private limited',
    'Titan agri developers private limited',
    'Underwater services company limited',
    'Chadha realtors private limited',
    'Petunia properties private limited',
    'Sri shyam projects private limited',
    'Yala construction co private limited',
    'Aab constructions private limited',
    'Jsd construction private limited',
    'Vl estates private limited',
    'Bnb constructions private limited',
    'Kallupura estate developers private limited',
    'Kumaon estates private limited',
    'Maan infrastructure private limited',
    'Konark buildwell private limited',
    'JAKSON VENTURES PRIVATE LIMITED',
    'Elsamex maintenance services limited',
    'Rani constructions private limited',
    'Sunstar construction company private limited',
    'Rocklines housing development private limited',
    'Pentagon constructions (india) private limited',
    'Divyesh engineers private limited',
    'Vatsala constructions and consultants private limited',
    'GOLDFINGER REALTY ADVISORS PRIVATE LIMITED',
    'Lucid travel solutions private limited (opc)',
    'POPULAR INDIA VACATIONS PRIVATE LIMITED',
    'INDIAN NETWORK FOR DEVELOPMENT EXCHANGE PRIVATE LIMITED',
    'Pyramid marine services private limited.',
    'Travel masters india private limited',
    'Agencies and cargo care limited',
    'Rasoi express pvt. ltd.',
    'Drs warehousing (north) private limited',
    'Earnest travel and hospitality private limited',
    'Safeco logistics private limited',
    'LOGIEDGE SYSTEMS PRIVATE LIMITED',
    'Taj mahal tours private limited',
    'Altrade minerals pvt ltd',
    'Kalisma logistics private limited',
    'Wov travel company private limited',
    'SIYARAM CITY CABS LIMITED',
    'Topmost enterprises private limited',
    'Procure logistics services private limited',
    'Tripmart international private limited',
    'Peace tours and travels private limited',
    'P d prasad and sons pvt.ltd.',
    'Tm international logistics limited',
    'Mega calibre enterprises private limited',
    'Spectra televentures private limited',
    'POWERMASTER SOLUTIONS PRIVATE LIMITED',
    'Dmj tours & travels private limited',
    'Coraz travel and trade links pvt ltd',
    'Kerala travels inter serve limited',
    'Gaganz.com limited',
    'Connoisseur infotech private limited',
    'PLANETCAST MEDIA SERVICES LIMITED',
    'Inner club tours and travels private limited',
    'Cyrus resorts private limited',
    'Ibrox estates private limited',
    'Bombino travels and tours private limited',
    'Varshika travels private limited',
    'Tirupur travels private limited',
    'S.s.mobile technologies private limited',
    'CORAL INFRATEL PRIVATE LIMITED',
    'Numero uno communications private limited',
    'Ardee resources private limited',
    'HUGHES COMMUNICATIONS INDIA PRIVATE LIMITED',
    'PLANETCAST TECHNOLOGIES LIMITED',
    'Prosys celnet private limited',
    'Protel communication (india) private limited',
    'Stafford information technology private limited',
    'Vision comptel private limited',
    'MAGIK CARGO INDIA PRIVATE LIMITED',
    'Incablenet (andhra) private limited',
    'Sawlani holdings india private limited',
    'Skylab investments pvt ltd',
    'R s finance pvt ltd',
    'SAAWARIYA FINANCIAL SERVICES PRIVATE LIMITED',
    'H and friends gtl (india) private limited',
    'DESAI AGRIFOODS PRIVATE LIMITED',
    'Poona warehousing pvt ltd',
    'Dynamic logistics private limited',
    'Vensar cold storages private limited',
    'Ice travels & tour private limited',
    'Compass india holidays private limited',
    'Team trans logistics private limited',
    'Associated road carriers ltd',
    'Bhumi tour and travels private limited',
    'Destination planners private limited',
    'Akanksha finance and investment private limited',
    'LOST WAX HITECH CASTINGS PRIVATE LIMITED',
    'Trust finstock private limited',
    'Anmol finsec limited',
    'Sahu brothers private limited',
    'Valar aditi social finance private limited',
    'KOMAF FINANCIAL SERVICES PRIVATE LIMITED',
    'SINGHI CAPITAL FINANCE PRIVATE LIMITED',
    'OLYMPUS SECURE PROCESS PRIVATE LIMITED',
    'Vertex broadcasting company private limited',
    'Airtime marketing and sales india private limited',
    'K.l.investment pvt. ltd.',
    'DIMENSIONAL ADVISORY SERVICES PRIVATE LIMITED',
    'ALL TIME COURIER',
    'S LABORATORIES LTD',
    'New delhi television limited',
    'Peirce leslie india limited',
    'TRESCON LIMITED',
    'CG POWER AND INDUSTRIAL SOLUTIONS LIMITED',
    'Trident group limited',
    'Goli finance limited',
    'Mukand industries private limited',
    'Akriti realtors private limited',
    'NTT INDIA SOLUTIONS PRIVATE LIMITED',
    'GOPISONS ATTIRES AND LIFESTYLES PRIVATE LIMITED',
    'Adhunik cooling system private limited',
    'Intelligaia technologies private limited',
    'Viram plantations limited',
    'Hi-tech natural products (india) limited',
    'United fine foods private limited',
    'Natureview landscape private limited',
    'Nvr agritech private limited',
    'Grove-tech infracon private limited',
    'Nane flortech private limited',
    'SUBAM AGRO VENTURES PRIVATE LIMITED',
    'Parasnath agro farm pvt. ltd.',
    'Ken agritech private limited',
    'Premier seals (india) private limited',
    'Shree shantadurga agro and foods private limited',
    'Boyce rubber estates private limited',
    'Rajapur plantations private limited',
    'Sangmeshwar plantations private limited',
    'Malvan plantations private limited',
    'Devgen seeds and crop technology private limited',
    'GOSHPADI GREEN FIELDS PRIVATE LIMITED',
    'PURVA REALTIES PRIVATE LIMITED',
    'Suttind seeds private limited',
    'Jaiprakash agri initiatives company limited',
    'Indus greens private limited',
    'Green agrifarms private limited',
    'Indrayani horticulture private limited',
    'Maval agrifarms private limited',
    'Indrayani flortech private limited',
    'Kamshet floritech private limited',
    'INTEGRATE OFFSHORE PRIVATE LIMITED',
    'Fresh greens private limited',
    'Shree agriculture private limited',
    'Shruti agro farms private limited',
    'Phulampur tea company private limited',
    'Anup (india) limited',
    'Aar bee tea company private limited',
    'VERKAR CARNATIONS LIMITED',
    'Jappaloupe equestrian centre private limited',
    'Sushant poultries private limited',
    'Shiva-parvati poultry feed private limited',
    'KALLAL HOLDINGS PRIVATE LIMITED',
    'Vinayaka vijay horticulture private limited',
    'Vn natural resources private limited',
    'Fe aagrochem private limited',
    'Fomento agro development private limited',
    'Sidhyayi greenview private limited',
    'Purnay greenfield private limited',
    'DHAVALA AGRIBUSINESS CONSORTIUM LIMITED',
    'Jph agro developers private limited',
    'N.k.p. pharma private limited',
    'Perfect agri-management company private limited',
    'Indrayani valley farms pvt ltd',
    'Kasara golf course and resorts private limited',
    'Kirtiman agrogenetics limited',
    'Sangam cultivators private limited.',
    'Vaneera agro - industries and research centre private limited',
    'Golden greeneries private limited',
    'Eminence harvest private limited',
    'Eminence agrifield private limited',
    'Eminence cropfield private limited',
    'Manifold agricrops private limited',
    'Anantay greenview private limited',
    'Megachip instrumentation private limited',
    'Victor switch gear private limited',
    'Pandav electricals private limited',
    'Curtis instruments india private limited',
    'Suxus systems ltd',
    'HAMMOND POWER SOLUTIONS PRIVATE LIMITED',
    'WM MCKINNON INDIA PRIVATE LIMITED',
    'Mec shot blasting equipments pvt.ltd.',
    'Rawelcom engineering private limited',
    'Asha electronic private limited',
    'Teamtech electronics limited',
    'Spi engineers pvt ltd',
    'Vtronix infotech private limited',
    'Slv electronic security solutions private limited',
    'JRS GLOBAL NETWORKS PRIVATE LIMITED',
    'Nifa electronics private limited',
    'Alpha duct private limited',
    'Gears and gear drives (india) private limited',
    'ZEPHIR RAIL EQUIPMENT PRIVATE LIMITED',
    'Raghunath dyechem private limited',
    'Sankalp electronics private limited',
    'Bell finvest(india) limited.',
    'Doshi heaters private limited',
    'Linear electronics private limited',
    'Mfr electronic components private limited',
    'NEXCO AUTOMATION TECHNOLOGIES PRIVATE LIMITED',
    'Kejriwal pratishthan private limited',
    'Sujana capital services limited',
    'Logic eastern india private limited',
    'K.shreyans electronics private limited',
    'Triple play broadband private limited',
    'Millennium telesystems private limited',
    'Irle kay jay rolls private limited',
    'Karnataka vidyuth karkhane limited',
    'Iac electricals pvt ltd',
    'Thermocool engineering private limited',
    'SHRI KRSNA SUDARSHAN URJA PRIVATE LIMITED',
    'Miraclus orthotech private limited',
    'Electro volt equipments pvt ltd',
    'Avon meters private limited',
    'Emi infratech private limited',
    'Satyam protech systems private limited',
    'Proton power control private limited',
    'Chromatoraphy and instruments co private limited',
    'Nutech electinstruments (india) private limited',
    'VISION RX LAB PRIVATE LIMITED',
    'Autofit private limited',
    'Autovue electronics (pune) p ltd',
    'Sangkaj engineering private limited',
    'Impact motors private limited',
    'Suyog autocast private limited',
    'Muskan automotives private limited',
    'B.u.bhandari auto lines private limited',
    'Saboo cars private limited',
    'Hero electric vehicles private limited',
    'Koiwai india private limited',
    'Jai paras manufacturing company private limited',
    'Global hydraulics private limited',
    'Mechfab engineering industries pvt ltd',
    'Friends auto (india) limited',
    'Manu auto components private limited',
    'DREAMLIGHT COMPUTECH PRIVATE LIMITED',
    'Multiline electronics private limited',
    'Card tec (india) private limited',
    'Celestica (india) private limited',
    'Electro impex private limited',
    'Ducati energia (india) private limited',
    'Mittal precision auto comps private limited',
    'Plastic omnium auto exteriors (india) private limited',
    'Balaji accu-preci parts private limited',
    'Kundan switch gears private limited',
    'Sec industries private limited',
    'Crestra communication private limited',
    'Tara marine syndicate pvt ltd',
    'ROSMERTA AUTO PLATES PRIVATE LIMITED',
    'MASL CONTROL CABLES PRIVATE LIMITED',
    'Drive lozics private limited',
    'Max aerospace and aviation private limited',
    'Ks aviation private limited',
    'ROSMERTA HSRP PRIVATE LIMITED',
    'ROSMERTA REGISTRATION PLATES PRIVATE LIMITED',
    'Himachal future cable and datacom private limited',
    'United lab supplies (india) private limited',
    'Link utsav ventures private limited',
    'DAIICHI FASTENERS INDIA PRIVATE LIMITED',
    'Nano impex private limited',
    'S a medical equipments private limited',
    'Biodenta india private limited',
    'Glossholz furniture private limited',
    'Nitto denko india private limited',
    'Jacsons furniture private limited',
    'Arvind coirfoam private limited',
    'Kagazkaar industries private limited',
    'CAPITAL AUTOWORLD PRIVATE LIMITED',
    'Pushyaragam jewellers (koyilandy) private limited',
    'Sunny diamonds private limited',
    'Rosy blue (india) private limited',
    'Pranda jewelry private limited',
    'Sree devi jewellers private limited',
    'Sonar sansar jewellers private limited',
    'A10 design private limited',
    'Hare keshav jay switches india private limited',
    'Standard friction components limited',
    'Lapl automotive private limited',
    'Evolutech networks private limited',
    'Kindell (india)pvt ltd',
    'Ag international logistics india private limited',
    'AWL India Private Limited',
    'Airport golf view hotels and suites private limited',
    'Hari om freight carriers private limited',
    'Dbs financial services private limited',
    'Kailas hotels private limited',
    'Abbott hotels private limited.',
    'Jakari shipping pvt ltd',
    'ARVIND AND COMPANY SHIPPING AGENCIES LIMITED',
    'SEROS SHIPPING PRIVATE LIMITED',
    'Aet tankers india private limited',
    'Reach dredging limited',
    'S n aviators private limited',
    'Airone support services private limited',
    'GVK AIRPORT HOLDINGS LIMITED',
    'Financial engineering solutions private limited',
    'Utc overseas india private limited',
    'Micro warehousing and allied services private limited',
    'Ocean pride logistics india private limited',
    'Nimble tours private limited',
    'Star clearing and forwarding services private limited',
    'Blues & jacks logistics private limited',
    'T4 initiatives private limited',
    'MAJESTIQUE COTTAGES PRIVATE LIMITED',
    'Matruchhaya sales and services private limited',
    'Germanus hotels and resorts private limited',
    'Aberdeen hotels & estates private limited',
    'NATHLEELA BULK CARRIERS PRIVATE LIMITED',
    'Utsav parivahan private limited',
    'G s r freight forwarders private limited',
    'Mount shivalik hotels and resorts private limited',
    'Zing restaurants private limited',
    'Comida ventures private limited',
    'Hazira port private limited',
    'Blr logistiks (i) limited',
    'Drk international freight forwarders private limited',
    'Accurate freight carriers private limited',
    'Pushpak logistics private limited',
    'OH-MAX ENTERTAINMENT PRIVATE LIMITED',
    'Ugc supply chain solutions private limited',
    'Msn logistics solution private limited',
    'TRAVEL AGE PRIVATE LIMITED',
    'DIGNITY TRAVELS PRIVATE LIMITED',
    'Tripoto travel private limited',
    'EAGLESTAR MARINE INDIA PRIVATE LIMITED',
    'Deep sea services (india) private limited',
    'Walking tours private limited',
    'Tourzing holidays private limited.',
    'Vivek travels private limited',
    'Libra tour and travels private limited',
    'Seaindia freight system private limited',
    'Mega movers logistics private limited',
    'Nilhat logistics & shipping private limited',
    'Foyer banquets private limited',
    'Pachar hotels private limited',
    'K.K.RETREAT PRIVATE LIMITED',
    'Hotel alankar private limited',
    'Sree annapoorna sree gowrishankar hotels private limited',
    'Golden retreats private limited',
    'Rithu destination management private limited',
    'Telstar travels private limited',
    'STERLING HOLIDAY RESORTS LIMITED',
    'TC TOURS LIMITED',
    'Hansol logistics india private limited',
    'Damani shipping pvt ltd',
    'Ok2go travel services private limited',
    'Tusker travels private limited',
    'Ap logistics india private limited',
    'Righteous global logistics private limited',
    'Cold products engineering private limited',
    'Shankar freight logistics private limited',
    'Morpheus supply chain solutions private limited',
    'Tamarinde holidays private limited',
    'Agarwal movers private limited',
    'Narendra exim logistics india private limited',
    'Shodha motors private limited',
    'Speedwings travel and cargo private limited',
    'Experience travel & living private limited',
    'Hi fly travels india private limited',
    'Peters tours and travels private limited',
    'India voyage travel pundits private limited',
    'Savvy logistic asia private limited',
    'Casby global air private limited',
    'Sunrich ship management private limited',
    'PAN LLOYD SHIPPING & LOGISTICS PRIVATE LIMITED',
    'Eisen supply chain solutions private limited',
    'Tapti waterways private limited',
    'Pccs logistics private limited',
    'Cruiseclub vacations private limited',
    'Ballnet global logistics india private limited',
    'Dream destinationz management private limited',
    'Starfin india private limited',
    'Writer logistics private limited',
    'Times express services private limited',
    'E2e global lines (india) private limited',
    'Blue moon logistics private limited',
    'Ashcom tele infra private limited',
    'Siti broadband services private limited',
    'Midland express private limited',
    'United business xpress india private limited',
    'B g somadder & sons pvt ltd',
    'Sky blue infotech private limited',
    'Avian tech solutions private limited',
    'Sitronics intracom india private limited',
    'Selfservit solutions private limited',
    'Web2school edusystems private limited',
    'Rnr technical services private limited',
    'Orangut labs private limited',
    'Space infolinks private limited',
    'Technogile solutions private limited',
    'BRADMAN TECHNOLOGIES PRIVATE LIMITED',
    'WEBTAP DIGITAL SOLUTIONS PRIVATE LIMITED',
    'Arcline technologies private limited',
    'Rubiq solutions private limited',
    'Technics infosolutions private limited',
    'Kiosk technologies private limited',
    'Track four infotec (i) private limited',
    'Web shuttle private limited',
    'G crew solutions private limited',
    'Giostar research private limited',
    'Cosmic industrial laboratories limited',
    'Bugworks research india private limited',
    'Ruchi hi-rich seeds private limited',
    'Magellan life sciences private limited',
    'Biomedical informatics private limited',
    'Gowrie research private limited',
    'Vector brook it solutions private limited',
    'Colston bath & spa private limited',
    'Lisianthus tech private limited',
    'VVR CONSULTANTS & ENTERPRISES PRIVATE LIMITED',
    'Rich capital solutions private limited',
    'Apoorva infolab private limited',
    'PUSHPAM CONSULTANCY & SOLUTIONS PRIVATE LIMITED',
    'Assisi vision private limited',
    'Independent purchasing company private limited',
    'Ananta vegetable seeds private limited',
    'Geeta alsysco private limited',
    'Amitasha towers private limited',
    'Valuemart supermarkets private limited',
    'SAGITTARIUS COMMERCIAL PRIVATE LIMITED',
    'Servensure solutions (india) limited',
    'SHOPPLUXE PRIVATE LIMITED',
    'Transtrade marketing pvt ltd',
    'Malda marketing private limited',
    'Competent professionals private limited',
    'Talwar and talwar consultants and services private limited',
    'XLSCOUT XLPAT PRIVATE LIMITED',
    'Dhavala consulting & advisory private limited',
    'Travel ace (india) private limited',
    'Showtime events (india) private limited',
    'Ann infotech private limited',
    'Rrh consultants private limited',
    'Singh corporate mantra private limited',
    'Williams consulting private limited',
    'Skymet weather services private limited',
    'Dreamcann foods private limited',
    'Transs technoconsultants private limited',
    'Mavcomm consulting private limited',
    'Mehrauli realty and consultants limited',
    'Sangyan advisory & consultancy services private limited',
    'Greycells research services private limited',
    'Scenario consulting private limited',
    'Sopan consultants private limited',
    'Purple audacity research & innovation private limited',
    'Arhant consulting private limited',
    'Pg strategic consultancy services private limited',
    'Techexcel software solutions private limited',
    'Amrita technologies (india) private limited',
    'Sharabh technologies private limited',
    'Abessys technologies india private limited',
    'Indosoft institute private limited',
    'Nimbylz technology solutions private limited',
    'Rev infotech private limited',
    'Clerisy solutions private limited',
    'Doric softech private limited',
    'Wave code logix private limited',
    'Doric multimedia private limited',
    'Businessaura.com private limited',
    'Centre for civil initiatives',
    'Biovascular devices research limited',
    'Panchajanya media private limited',
    'Indo office solutions private limited',
    'Vision 3k technologies (india) private limited',
    'K and p management services private limited',
    'Gold berries consulting private limited',
    'E2 infosystems private limited',
    'Emi erp india private limited',
    'Unipower technologies private limited',
    'Software conglomerate private limited',
    'Aviro vyapaar private limited',
    'Ultrapure aqua engineering india limited',
    'Luxor nano technology private limited',
    'Mavcomm advisory private limited',
    'Aristotle consultancy private limited',
    'GEOMETRIC RESULTS INTERNATIONAL INDIA PRIVATE LIMITED',
    'Hiring partners hr solutions private limited',
    'Utopian corporate services private limited',
    'Matex services private limited',
    'Jbm corporate services private limited',
    'AINOMIQ INDIA PRIVATE LIMITED',
    'Megatron technologies private limited',
    'Ep engineering private limited',
    'Concore business services private limited',
    'Oppo mobiles india private limited',
    'QZIAE CONSULTING PRIVATE LIMITED',
    'All india digital cable federation',
    'F5 digital marketing private limited',
    'Goldman fincorp private limited',
    'Sasas manpower services private limited',
    'Utkarsh placement private limited',
    'Amisco agro-chem limited',
    'Blossoms properties private limited',
    'Savida agri - com private limited',
    'Continental seeds and chemicals limited',
    'Wall flower agritech private limited',
    'BHARAT INDUSTRIAL ENTERPRISES PRIVATE LIMITED',
    'SURI AGRITECH SYSTEMS PRIVATE LIMITED',
    'Brahmaputra teak plantations of assam pvt ltd',
    'SRI SAI SWARUPA SEEDS PRIVATE LIMITED',
    'Tas hill pla ntations private limited',
    'Poabs estates private limited',
    'Poabs plantations pvt ltd',
    'Thachankary plantations private limited',
    'Poabs organic products private limited',
    'Beej sheetal research private limited',
    'K and s floritech private limited',
    'Biological e. limited',
    'ARAVIND SEEDS PRIVATE LIMITED',
    'Zakinl biotech private limited',
    'Karuturi floritech private limited',
    'Malaiyil plantations private limited',
    'Sylvan coffee company private limited',
    'Sudharshan plantations private limited',
    'THE MANAR ESTATES PRIVATE LIMITED',
    'Forestdale tea factory private limited',
    'Santipara tea company ltd.',
    'Sarala tea company private limited',
    'Poonawalla mystical stud private limited',
    'Sujala feeds private limited',
    'Power agro farms private limited',
    'YORK TECH PRIVATE LIMITED',
    'Elite agro products private limited',
    'Ananya seeds private limited',
    'Dwarka farms private limited.',
    'Kmit solutions private limited',
    'Nucore software solutions private limited',
    'Millennium online (india) limited',
    'Uffizio india software consultants private limited',
    'Irealities technology private limited',
    'Enterux solutions private limited',
    'Saama technologies (india) private limited',
    'Paysquare consultancy limited',
    'First insight software solutions india private limited',
    'ACI WORLDWIDE CONSULTING (INDIA) PRIVATE LIMITED',
    'Triyama software private limited',
    'Pinwheel technology private limited',
    'Techgene solutions private limited',
    'Smartbridge solutions private limited',
    'Coa network (india) private limited',
    'Sevenion soft systems private limited',
    'Sunera technologies private limited',
    'Xilinx india technology services private limited',
    'Innovative matrix softech private limited',
    'Dolcera information technology services private limited',
    'Eaiesb software solutions private limited',
    'Oztek software private limited',
    'Iss softtech private limited',
    'Kernelsphere technologies private limited',
    'Mygo consulting india private limited',
    'Biztron softech private limited',
    'Chemoil advanced management services private limited',
    'Professional access software development private limited',
    'Viswambara software systems private limited',
    'Y3 technologies (india) private limited',
    'Eapt solutions (india) private limited',
    'Fisher technologies private limited',
    'Solvedge technology services private limited',
    'Tenovia solutions private limited',
    'Gavs technologies private limited',
    'Calpion software technologies private limited',
    'Lorenz life sciences india private limited',
    'Quadra cloud india private limited',
    'Garmin india private limited',
    'Kserve bpo private limited',
    'Great place it services private limited',
    'Zt systems india private limited',
    'Anunta technology management services limited',
    'Techease systems private limited',
    'Izone digital private limited',
    'Globalspace healthcare technologies private limited',
    'Globalspace education technologies private limited',
    'OPTIMUM ISTRUCTURES PRIVATE LIMITED',
    'Hill-rom india private limited',
    'Kalpvriksha marketing private limited',
    'Vishvas tractors limited',
    'Akshata mercantile private limited',
    'Norscot trading private limited',
    'OPTIMYSTIX MEDIA PRIVATE LIMITED',
    'Longrange commodities private limited',
    'Maped india stationery products private limited',
    'Tritex private limited',
    'Viat instruments pvt.ltd.',
    'Rathi steel industries private limited',
    'Singhvahini distributors private limited',
    'Marina home interiors retail network private limited',
    'Arihant innochem private limited',
    'Priyanka wireless (india) private limited',
    'Office direct enterprises private limited',
    'Adams retailing private limited',
    'Syona cosmetics private limited',
    'Rsm commerce private limited',
    'SANJAY SOURCING PRIVATE LIMITED',
    'Spl exim private limited',
    'Q-mart retail ventures private limited',
    'GALAXY LEISURE Private Limited',
    'Metro lifescapes private limited',
    'Ten hotels private limited',
    'Shamiana restaurants private limited',
    'Santinos fast foods pvt ltd',
    'Sala thai foods and restaurants private limited',
    'Darwin platform hospitality limited',
    'TRACKTICAL CONCERTS PRIVATE LIMITED',
    'RXDATASCIENCE INDIA PRIVATE LIMITED',
    'LIO DISCOVERY SERVICES (INDIA) PRIVATE LIMITED',
    'GWC INDIA INSURANCE BROKING PRIVATE LIMITED',
    '5H LIFEXPRESSION PRIVATE LIMITED',
    'FASYS ENTERPRISES PRIVATE LIMITED',
    'AERANN INSTRUMENTS AND ENGINEERING SERVICES PRIVATE LIMITED',
    'ECOTRU PAPER PRODUCTS (OPC) PRIVATE LIMITED',
    'UGLARE AUTOMOTIVE (OPC) PRIVATE LIMITED',
    'LEARNTURE VENTURES PRIVATE LIMITED',
    'JDS WOODLAND PRIVATE LIMITED',
    'ZE1 ENERGY PRIVATE LIMITED',
    'ANANDCINE SERVICE PRIVATE LIMITED',
    'MAXTRONICS SMT SOLUTIONS PRIVATE LIMITED',
    'RADIAL IT PARK PRIVATE LIMITED',
    'FOUREZ MEDIA VENTURES PRIVATE LIMITED',
    'IAR TECHCORE PRIVATE LIMITED',
    'BLUEWEAVE CONSULTING & RESEARCH PRIVATE LIMITED',
    'HORNBILL FX PRIVATE LIMITED',
    'INNORENOVATE SOLUTIONS PRIVATE LIMITED',
    'UHEKSA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CLOCK HR SOLUTIONS PRIVATE LIMITED',
    'LINTCLOUD IT SERVICES PRIVATE LIMITED',
    'SOFTOMOTIVE ROBOTIC PROCESS AUTOMATION PRIVATE LIMITED',
    'QUANTIN ECOTECH PRIVATE LIMITED',
    'SITTRULI FOUNDATION',
    'TELANGANA FIBER GRID CORPORATION LIMITED',
    'TENPAO ELECTRONICS INDIA PRIVATE LIMITED',
    'DOER INTERNATIONAL TRADING & MANUFACTURING PRIVATE LIMITED',
    'TAIYUNG ENERGY PRIVATE LIMITED',
    'HILTEK ROBOTICS RESEARCH CENTRE PRIVATE LIMITED',
    'CREATIVE BUCKET SOFTWARE PRIVATE LIMITED',
    'PRODIAN SOLUTIONS PRIVATE LIMITED',
    'BITLOCK ONLINE SOLUTION PRIVATE LIMITED',
    'INTERNITY FOUNDATION',
    'STYLOPAY PRIVATE LIMITED',
    'IGNITE TRIBAL FOUNDATION',
    'AIC ISB ASSOCIATION',
    'MIXKIN PRIVATE LIMITED',
    'WIZARD BUSINESS SERVICES PRIVATE LIMITED',
    'SENSABYTE TECHNOLOGIES PRIVATE LIMITED',
    'GAMESTACY ENTERTAINMENT PRIVATE LIMITED',
    'MARSWOOD TRADING (OPC) PRIVATE LIMITED',
    'AB MEDIEMAGIX 24X7 PRIVATE LIMITED',
    'RAAB GRAND PRIVATE LIMITED',
    'ACEUSER PRIVATE LIMITED',
    '2KSTUDIOS PRIVATE LIMITED',
    'BYTEL TRANET PRIVATE LIMITED',
    'SMART CITY THIRUVANANTHAPURAM LIMITED',
    'CAONWEB ONLINE PRIVATE LIMITED',
    'SOLASTA ENTERPRISES PRIVATE LIMITED',
    'VERT ENVIROTECH PRIVATE LIMITED',
    'AZIMUTH BUSINESS ON WHEELS PRIVATE LIMITED',
    'NOCTO LABS PRIVATE LIMITED',
    'ANDRAGOGY IMPACT METHODOLOGY AND ANALYSIS PRIVATE LIMITED',
    'AUGMENTED LEARNING PRIVATE LIMITED',
    'DAILYPACK SOLUTION PRIVATE LIMITED',
    'NGB EDUCATION PRIVATE LIMITED',
    'SK HOLIDAYS PRIVATE LIMITED',
    'ACHINTYA MANAGEMENT PRIVATE LIMITED',
    'MTA DESTINATION EXPERTS PRIVATE LIMITED',
    'TUSKER BERRY EDUSOLUTIONS PRIVATE LIMITED',
    'GENWISE TALENTDEV PRIVATE LIMITED',
    'BHRTYA AUTOMATION PRIVATE LIMITED',
    'AMBER CONNECT PRIVATE LIMITED',
    'REDWOOD EDUTOURS PRIVATE LIMITED',
    'RAISE BPO PRIVATE LIMITED',
    'GYUNGPO P&C PRIVATE LIMITED',
    'OPPR SOFTWARE SOLUTION PRIVATE LIMITED',
    'BIGGBOXX MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'TRIDENT THOUGHTS ORIGINATION PRIVATE LIMITED',
    'ESQUAREM GLOBAL PRIVATE LIMITED',
    'SAHYADRI LOKSEVA FOUNDATION',
    'ZENITH GLOCALE PRIVATE LIMITED',
    'BATLIVALA & KARANI WEALTH ADVISORS PRIVATE LIMITED',
    'DOST TAX CONSULTANCY PRIVATE LIMITED',
    'FRENZYHASH CONCEPT AND CREATION PRIVATE LIMITED',
    'AVIK IT MANAGMENT SERVICES PRIVATE LIMITED',
    'PI JAM FOUNDATION',
    'WEIGANDT CONSULTING PRIVATE LIMITED',
    'TEJ SOLPRO DIGITAL PRIVATE LIMITED',
    'MOLVIZADAH SONS INDIA PRIVATE LIMITED',
    'ZYESEL TECH PRIVATE LIMITED',
    'SUPERB LAUNDRY SOLUTIONS PRIVATE LIMITED',
    'A.D.PRECISION FORGINGS PRIVATE LIMITED',
    'TRIHAWK INDIA PRIVATE LIMITED',
    'PLATED FOOD NETWORK PRIVATE LIMITED',
    'SWACHHA ECO SOLUTIONS PRIVATE LIMITED',
    'ONEIRIC APPLIANCES PRIVATE LIMITED',
    'WINSOME MUTUAL BENEFIT NIDHI LIMITED',
    'CONCORD BUZZ SERVICES PRIVATE LIMITED',
    'LAVEESH ENERGY CONSULTANCY SERVICES (OPC) PRIVATE LIMITED',
    'TOSSCLICK E-COMMERCE PRIVATE LIMITED',
    'JAYA CERGAS PRIVATE LIMITED',
    'I-CUE INDIA PRIVATE LIMITED',
    'VAYU RENEWABLE ENERGY (ARAVALLI) PRIVATELIMITED',
    'ASHRIYA INFOTECH PRIVATE LIMITED',
    'BIOSCAN RESEARCH PRIVATE LIMITED',
    'SPRAYSTREAM INDIA PRIVATE LIMITED',
    'TOONBRANDS SOLUTIONS PRIVATE LIMITED',
    'POI INDIA BIOTECH PRIVATE LIMITED',
    'BROADWAVE NETWORKS PRIVATE LIMITED',
    'CICON INFRASOLUTION PRIVATE LIMITED',
    'SVS AUTO COMP PRIVATE LIMITED',
    'BIONIC MEDICARE PRIVATE LIMITED',
    'FLAMEPOT (OPC) PRIVATE LIMITED',
    'APOCALYPSE STEEL AND POWER LIMITED',
    'RIVSO DIGITAL (OPC) PRIVATE LIMITED',
    'NLP TECHNOLOGIES PRIVATE LIMITED',
    'CSF TECHNOLOGIES PRIVATE LIMITED',
    'FIKERNOT LIFESTYLE PRIVATE LIMITED',
    'SILO GRANITES INDIA PRIVATE LIMITED',
    'CATCHYOURTOURS PRIVATE LIMITED',
    'MESMERIC MOMENTS PRIVATE LIMITED',
    'FERTINAGRO INDIA PRIVATE LIMITED',
    'WARMING ECOM PRIVATE LIMITED',
    'INDO-ASIA BULGARIAN CHAMBER OF COMMERCE',
    'FASPO FASHIONS LIMITED',
    'STEEL CITY VENTURES PRIVATE LIMITED',
    'QGLUE INNOVATION PRIVATE LIMITED',
    'REINFOLD PHYSICAL INNOVATION LABS PRIVATE LIMITED',
    'IN-LAND ENGINEERING INDUSTRIES PRIVATE LIMITED',
    'POINT OF CARE BIO MEDICAL PRIVATE LIMITED',
    'VAYU RENEWABLE ENERGY (NILGIRI) PRIVATE LIMITED',
    'SANSPRO INDIA PRIVATE LIMITED',
    'PILOT9 DIGITAL (OPC) PRIVATE LIMITED',
    'PRIMERAIL INFRALABS PRIVATE LIMITED',
    'LHI DIGITAL FOUNDATION',
    'ANP BRANDSYNERGI PRIVATE LIMITED',
    'PRISMARC DIAMONDS PRIVATE LIMITED',
    'PETUNT FOOD PROCESSORS PRIVATE LIMITED',
    'PVA METALS PRIVATE LIMITED',
    'GTEN CONSULTANCY DIGITAL PRIVATE LIMITED',
    'EXTENTO EVENTS PRIVATE LIMITED',
    'OSCILLA POWER PRIVATE LIMITED',
    'ASM KRISHIYOG AGRITECH PRIVATE LIMITED',
    'PRINTSTREET ONLINE RETAIL PRIVATE LIMITED',
    'RIHIM JAZZ TECHNICAL PRIVATE LIMITED',
    'YOUNGAMBITIOUSMINDS CONSULTING PRIVATE LIMITED',
    'OXEDENT TECHNOLOGIES PRIVATE LIMITED',
    'TVLK INDIA PRIVATE LIMITED',
    'BOHOMALE PRIVATE LIMITED',
    'KAARA DECOR PRIVATE LIMITED',
    'OCS INTEGRATED SOLUTIONS INDIA PRIVATE LIMITED',
    'EMERGING BRILLIANCE ACADEMY PRIVATE LIMITED',
    'VERIDOC GLOBAL TECHSERVICES INDIA PRIVATE LIMITED',
    'HYGGELIG CO-WORKING PRIVATE LIMITED',
    'MEDTRAIL TECHNOLOGIES PRIVATE LIMITED',
    'QMS MEDICAL ALLIED SERVICES LIMITED',
    'RIVER PUBLISHERS INDIA PRIVATE LIMITED',
    'PRAPAN INNS, HOTELS AND RESORTS PRIVATE LIMITED',
    'RABBIT VENTURES PRIVATE LIMITED',
    'SUSHRUTA DIGITAL LIFE PRIVATE LIMITED',
    'SHRI BADRINATH VAIKALPIK URJA LIMITED',
    'MAPLE ENVIRO PRIVATE LIMITED',
    'SARA HR CONSULTANTS PRIVATE LIMITED',
    'CONJUGATE ENERGY PRIVATE LIMITED',
    'CANOPI INDIA PRIVATE LIMITED',
    'THE ANUP ENGINEERING LIMITED',
    'VM PURI ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'HUEGLI TECH ENGINEERING PRIVATE LIMITED',
    'IOTA INFOTECH PRIVATE LIMITED',
    'BATI NORTH INDIA PRIVATE LIMITED',
    'ANU WORLES TECH PRIVATE LIMITED',
    'AMBICA CELEBRATION INDIA PRIVATE LIMITED',
    'AGILEMATE INNOVATION SERVICES PRIVATE LIMITED',
    'KUANTS WEALTH PRIVATE LIMITED',
    'DIGIIMENTO EDUCATIONAL SERVICES PRIVATE LIMITED',
    'BOTMINDS AI TECHNOLOGIES PRIVATE LIMITED',
    'SUPERDNA TECHNOLAB PRIVATE LIMITED',
    'TAPCEIPT IT SOLUTIONS PRIVATE LIMITED',
    'JINENDRA INFOTECH PRIVATE LIMITED',
    'RAFINDIA MEDECHO PRIVATE LIMITED',
    'TEMAKII MARKETING PRIVATE LIMITED',
    'MRIDA EVENTS AND DESIGNS (OPC) PRIVATE LIMITED',
    'MEDIONA WELLNESS PRIVATE LIMITED',
    'DECEUNINCK PROFILES INDIA PRIVATE LIMITED',
    'BANNARIAMMAN HANDLOOM SILK DYING AND WEAVING ASSOCIATION',
    'OSTER FOOD AND BEVERAGES PRIVATE LIMITED',
    'FRESHMART EXCLUSIVE RETAIL PRIVATE LIMITED',
    'OUTCLASS EVENTS PRIVATE LIMITED',
    'GEEYAE SYSTEMS PRIVATE LIMITED',
    'AARYAMAN GEO INFO SOLUTIONS PRIVATE LIMITED',
    'RAJ KHATRI FILMS PRIVATE LIMITED',
    'PINEAL QUOTIENT PRIVATE LIMITED',
    'VIRTUOUS LOOP ENTERTAINMENT AND MEDIA PRIVATE LIMITED',
    'SHUROUQ GLOBAL HEALTH PRIVATE LIMITED',
    'IK SHARMA E-VENTURES PRIVATE LIMITED',
    'BASIS MOLD INDIA PRIVATE LIMITED',
    'ATHARVA SYSPRO GLOBAL PRIVATE LIMITED',
    'POSITIVE FOOD VENTURES PRIVATE LIMITED',
    'AKT HEALTH ANALYTICS PRIVATE LIMITED',
    'ANMAY SOLUTIONS PRIVATE LIMITED',
    'EASTERN BAY VENTURES PRIVATE LIMITED',
    'FITNESSTREE PRIVATE LIMITED',
    'BHARTIPAY SERVICES PRIVATE LIMITED',
    'BITLINE TECHNOLOGIES PRIVATE LIMITED',
    'SNAPPER FUTURE TECH PRIVATE LIMITED',
    'ZUSAK EXIM PRIVATE LIMITED',
    'BIRDIE BOGEY PRIVATE LIMITED',
    'RNR INNOTECH PRIVATE LIMITED',
    'NEWLOOP APPS PRIVATE LIMITED',
    'UNITED FOR NATURE FOUNDATION',
    'RMJ TECHNOLOGIES PRIVATE LIMITED',
    'CAVERN SALOON AND SPA PRIVATE LIMITED',
    'INDIGENA HERBS AND ORGANICS PRIVATE LIMITED',
    'TEAMWORX BUSINESS CONSULTING SERVICES PRIVATE LIMITED',
    'RANGNATH ENTERTAINMENT PRIVATE LIMITED',
    'SSHE FOUNDATION',
    'APEIROFIN TECHNOLOGY PRIVATE LIMITED',
    'HIPPIE SOUL PRIVATE LIMITED',
    'BLUEPEARL RESOURCES PRIVATE LIMITED',
    'SYSARKS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MOKA RETAIL PRIVATE LIMITED',
    'MAUNA DHWANI FOUNDATION',
    'THAKRAL CLOTHING PRIVATE LIMITED',
    'MINDTUIT ANALYTICS PRIVATE LIMITED',
    'AUGGMIN LIFESCIENCES. PRIVATE LIMITED',
    'BAUENGURU INFRATECH PRIVATE LIMITED',
    'KERALAWATERWAYS AND INFRASTRUCTURES LIMITED',
    'MUSTARO TECHNOSERVE PRIVATE LIMITED',
    'V. R. THINKOVATIVE PRIVATE LIMITED',
    'STANPRO COATED STEELS PRIVATE LIMITED',
    'SILVERPEAK CENTER FOR INTERNATIONAL LANGUAGE AND CULTURE',
    'PERCEPTIVITI DATA SOLUTIONS PRIVATE LIMITED',
    'SMASHX STRATEGIES PRIVATE LIMITED',
    'HASHOUT SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'REBEL EDUTECH RISING PRIVATE LIMITED',
    'RIDGE LINKS PRIVATE LIMITED',
    'ASHJOE COLD CHAIN PRIVATE LIMITED',
    'CAELUMLORE IT SOLUTIONS PRIVATE LIMITED',
    'V-TECH MAKKERS PRIVATE LIMITED',
    'HELICORE INFO PRIVATE LIMITED',
    'KARVY NEXT LIMITED',
    'ATS COMMERCIAL REAL ESTATE PRIVATE LIMITED',
    'SHIVIAN TECH PRIVATE LIMITED',
    'OSWALDABLE TECHNOLOGY PRIVATE LIMITED',
    'JLOVES CHEM PRIVATE LIMITED',
    'VALUEDATA TECHNOLOGIES PRIVATE LIMITED',
    'GOBIDO HEALTHCARE PRIVATE LIMITED',
    'WEAGOG TECHNOLOGIES PRIVATE LIMITED',
    'ALTUM MINDS PRIVATE LIMITED',
    'LIGHTROOSTER ENTERTAINMENTS PRIVATE LIMITED',
    'BUMSA TALENT SOLUTIONS PRIVATE LIMITED',
    'STRANICH FANS AND DUSCON INDIA PRIVATE LIMITED',
    'INVENTION EVOLUTION COMPOSITION (INDIA) PRIVATE LIMITED',
    'CARVA DIGITAL INNOVATIONS PRIVATE LIMITED',
    'MBB LABS PRIVATE LIMITED',
    'THERMIN POWER SYSTEMS PRIVATE LIMITED',
    'FILTERNET FOUNDATION',
    'DEXTRO DATA DYNAMICS PRIVATE LIMITED',
    'DPIIND SERVICES PRIVATE LIMITED',
    'LOYALTY JUGGERNAUT INDIA PRIVATE LIMITED',
    'ALMONDZ INSOLVENCY RESOLUTIONS SERVICES PRIVATE LIMITED',
    'SAR SKILL EDUCATION PRIVATE LIMITED',
    'MAGNUS SHIPPING AND CLEARANCES PRIVATE LIMITED',
    'SMA INTERNATIONAL MAKEUP ACADEMY PRIVATELIMITED',
    'PERITUS AI PRIVATE LIMITED',
    'SHREESIDDHIVINAYAK INFRA-ESTATE PRIVATE LIMITED',
    'THOR CHEMICALS INDIA PRIVATE LIMITED',
    'FUTURECAE TECHNOLOGIES PRIVATE LIMITED',
    'DYNAMISITY PRIVATE LIMITED',
    'ARP DROITE (OPC) PRIVATE LIMITED',
    'CLEVERBIT SOLUTIONS PRIVATE LIMITED',
    'SUNGRACE CARTONS PRIVATE LIMITED',
    'GASTROLAB INDIA PRIVATE LIMITED',
    'INO TOOLTRIX SOLUTIONS (OPC) PRIVATE LIMITED',
    'MGM RESOURCES PRIVATE LIMITED',
    'FUTUREALLES GLOBAL PRIVATE LIMITED',
    'SANMATI PACKAGING (INDIA) PRIVATE LIMITED',
    'NPSE AUTOMATION PRIVATE LIMITED',
    'UPAYA INNOVATIONS PRIVATE LIMITED',
    'VANDYAM PRASADA FOODS PRIVATE LIMITED',
    'ACCURATE ROBOTIC SOLUTIONS PRIVATE LIMITED',
    'SAMHWA ACE INDIA HVAC PRIVATE LIMITED',
    'KRPC LISHEN BATTERY INDIA PRIVATE LIMITED',
    'KIGYAN SCHOOL OF DATA SCIENCE PRIVATE LIMITED',
    'FRANKOJULIA CREATIONS PRIVATE LIMITED',
    'VECTOR INFRASTRUCTURE PROJECT SOLUTIONS LIMITED',
    'STEMCORE TECH SOLUTIONS PRIVATE LIMITED',
    'AGRE & KONDE INDUSTRIES INDIA PRIVATE LIMITED',
    'SPRING HOTELS & RESORTS SERVICES (INDIA)PRIVATE LIMITED',
    'EVOLVING CULTURE FOUNDATION',
    'MEGAEXPRESS FREIGHT SERVICES PRIVATE LIMITED',
    'MILLION LIVES FOUNDATION',
    'KOOPID TECHNOLOGIES PRIVATE LIMITED',
    'SOLUBLE SYSTEM PRIVATE LIMITED',
    'ZOREZA GLOBAL BUSINESS PRIVATE LIMITED',
    'K&B WEB SOLUTION PRIVATE LIMITED',
    'SINDHUDURG FARMERS PRODUCER COMPANY LIMITED',
    'ASTRA CORPORATE LIVING PRIVATE LIMITED',
    'NIAPRAXIS PRIVATE LIMITED',
    'INMACS VALUERS PRIVATE LIMITED',
    'APPRENTICE WORLD PRODUCTS AND SERVICES PRIVATE LIMITED',
    'VASA RETAIL AND OVERSEAS LIMITED',
    'WIN VISION EYE HOSPITALS (AS RAO NAGAR) PRIVATE LIMITED',
    'IDHYAH FOODS INDIA PRIVATE LIMITED',
    'GOLDENAVATAR VENTURES PRIVATE LIMITED',
    'SUDARSAN TEXFAB MILLS PRIVATE LIMITED',
    'SATNA SMART CITY DEVELOPMENT LIMITED',
    'SAFARTASTIC TECHNOLOGIES PRIVATE LIMITED',
    'REYNAR ALLOYS & MINERALS PRIVATE LIMITED',
    'VIRUPAKSHA CONTROLS AND AUTOMATION PRIVATE LIMITED',
    'AVASURE TECHNOLOGIES PRIVATE LIMITED',
    'BLUELOTUS KNOWLEDGE VENTURES PRIVATE LIMITED',
    'AFTERNOW LAB PRIVATE LIMITED',
    'FLYHOMES RESIDENTIAL INDIA PRIVATE LIMITED',
    'BLOGIC SOFTWARE TECHNOLOGY PRIVATE LIMITED',
    'GKC FOOD PRODUCTS PRIVATE LIMITED',
    'EIFMS (OPC) PRIVATE LIMITED',
    'ANKRIS TECHNOLOGIES PRIVATE LIMITED',
    'GADRE FOODS AND BEVERAGES PRIVATE LIMITED',
    'AKABEA INFRASTRUCTURES PRIVATE LIMITED',
    'KEVNIT DIGITAL SOLUTIONS PRIVATE LIMITED',
    'APPATTUVILAI ST.ANTONY',
    'S CAFE PRIVATE LIMITED',
    'UDEELS TECHNOLOGIES PRIVATE LIMITED',
    'FORTITECH PRIVATE LIMITED',
    'CONSORTIUMM BUSINESS ADVISORS PRIVATE LIMITED',
    'ACA COMMODITIES PRIVATE LIMITED',
    'MYTRAH AINESH POWER PRIVATE LIMITED',
    'TRAKD INNOVATIONS PRIVATE LIMITED',
    'QUATERNION DIGITEK PRIVATE LIMITED',
    'WESTERLY RETAIL PRIVATE LIMITED',
    'JAI GIRIDHARI FARMER PRODUCER COMPANY LIMITED',
    'APPSTAC TECHNOLOGIES PRIVATE LIMITED',
    'RAMDHAN CONSULTING PRIVATE LIMITED',
    'DREAMWORLD SOLUTIONS PRIVATE LIMITED',
    'MAHANAIM MUSIC AND LANGUAGE PRIVATE LIMITED',
    'AFVAL WATER SOLUTIONS PRIVATE LIMITED',
    'TLT-TURBO INDIA PRIVATE LIMITED',
    'TEAMOXIO TECHNOLOGIES PRIVATE LIMITED',
    'CATHOLICON LIFESCIENCES PRIVATE LIMITED',
    'LEADOMATION TECH PRIVATE LIMITED',
    'AGNYA SOLUTIONS PRIVATE LIMITED',
    'TEMAC WEAVES INDIA PRIVATE LIMITED',
    'DHIIRA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ASCEND HR SOLUTIONS PRIVATE LIMITED',
    'NNK MARINE EXPORTS PRIVATE LIMITED',
    'KAUTILYA LEADERSHIP CENTRE PRIVATE LIMITED',
    'UNBOX2LEARN PRIVATE LIMITED',
    'AVAK ENTERTAINMENT PRIVATE LIMITED',
    'GLOBAL ATLAS TOURS & FOREX PRIVATE LIMITED',
    'INDIGRID SOLAR-II (AP) PRIVATE LIMITED',
    'TECHNOVALLEY SOFTWARE INDIA PRIVATE LIMITED',
    'NEOVANTAGE BIO-TECHNOLOGY PRIVATE LIMITED',
    'MARICON SHIPPING SERVICES PRIVATE LIMITED',
    'EXPONENTIAL EQUATIONS PRIVATE LIMITED',
    'VIVIFI INDIA FINANCE PRIVATE LIMITED',
    'VARITAS MPOWER SOLUTION PRIVATE LIMITED',
    'ZUKTI CONSULTING PRIVATE LIMITED',
    'VISMAYA PREMEDIA SERVICES PRIVATE LIMITED',
    'HPS CREATIVE SERVICES PRIVATE LIMITED',
    'MERAKI MUSIC INDIA PRIVATE LIMITED',
    'MALLET TECHNOLOGY PRIVATE LIMITED',
    'AUTOENGINIEA PRIVATE LIMITED',
    'INDIP INDUSTRIAL PARKS (VIZAG) PRIVATE LIMITED',
    'NEOVANTAGE INNOVATION PARK PRIVATE LIMITED',
    'ONEFLIT ADVERTISING PRIVATE LIMITED',
    'AHSAN ALLIANCE PRIVATE LIMITED',
    'FORDINDIA POWER PRIVATE LIMITED',
    'LHI NETWORK PRIVATE LIMITED',
    'PRODINNOV EDUTECH SOLUTIONS PRIVATE LIMITED',
    'RESPONSCITY SYSTEMS PRIVATE LIMITED',
    'Y.H. HEALTHCARE PRODUCTS PRIVATE LIMITED',
    'AVYUKTA AYURVEDA PRIVATE LIMITED',
    'CREMICA CONDIMENTS PRIVATE LIMITED',
    'PROCREATOR SOLUTIONS PRIVATE LIMITED',
    'KONNECTBHARAT IT SERVICES PRIVATE LIMITED',
    'ASCENDEUM PRIVATE LIMITED',
    'SNOTRA SOLUTIONS PRIVATE LIMITED',
    'VARENYAM HEALTHCARE PRIVATE LIMITED',
    'IIM UDAIPUR INCUBATION CENTRE',
    'MINTECK SOLUTIONS PRIVATE LIMITED',
    'VIMAN TECHPRO PRIVATE LIMITED',
    'DREAMTEAM FOOD CONCEPTS PRIVATE LIMITED',
    'GLABBR INDIA PRIVATE LIMITED',
    'VELOCITY FREIGHT PRIVATE LIMITED',
    'DOTCOM HOME FASHIONS PRIVATE LIMITED',
    'ASTRA FOUNDATION',
    'BEDFORD SQUARE KNOWLEDGE CENTRE PRIVATE LIMITED',
    'CORETEGRA TECHNOLOGIES PRIVATE LIMITED',
    'STHORA TECHNOLOGIES PRIVATE LIMITED',
    'AXONS TECHNOLOGY AND SOLUTIONS PRIVATE LIMITED',
    'TREELIFE VENTURES SERVICES PRIVATE LIMITED',
    'VOLTA WARE PRIVATE LIMITED',
    'SV PITTIE INDUSTRIES PRIVATE LIMITED',
    'AGOSTA ENTERPRISES PRIVATE LIMITED',
    'INDHEAL SOLUTIONS PRIVATE LIMITED',
    'TRICOLOR BUSINESS SERVICES PRIVATE LIMITED',
    'CRP COMMUNICATIONS PRIVATE LIMITED',
    'ANUVA RESOURCE SOLUTIONS INDIA PRIVATE LIMITED',
    'ZCLUS (INDIA) LIMITED',
    'TECVIVID SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'DATAFACTZ SOLUTIONS PRIVATE LIMITED',
    'HUMANA FINANCIAL SERVICES PRIVATE LIMITED',
    'AECON REALTY AND INFRA PRIVATE LIMITED',
    'KAJP UNIQUE COATING CHEMICAL PRIVATE LIMITED',
    'ACURA HEALTH SOLUTIONS PRIVATE LIMITED',
    'LIVE INFO UNITE PRIVATE LIMITED',
    'NORVIC SHIPPING INDIA PRIVATE LIMITED',
    'GROUND CARE PRIVATE LIMITED',
    'TEB SOLUTIONS PRIVATE LIMITED',
    'TRAKO INFRA INDIA PRIVATE LIMITED',
    'EXCELLENCE MOBILE TECH INDIA PRIVATE LIMITED',
    'RWDWMKHANG TEA PRODUCER COMPANY LIMITED',
    'CLIQUE AV PRIVATE LIMITED',
    'RWDWMSHA TEA PRODUCER COMPANY LIMITED',
    'METASKILL PRIVATE LIMITED',
    'DFM INFOANALYTICS PRIVATE LIMITED',
    'SKILLSURGE LEARNING PRIVATE LIMITED',
    'ELITE LIFESPACES PRIVATE LIMITED',
    'RETREAT BUSINESS PRIVATE LIMITED',
    'HINDOLI FARMER PRODUCER COMPANY LIMITED',
    'BRICKINFRA STRUCTURES PRIVATE LIMITED',
    'POLOTEL PRIVATE LIMITED',
    'CODEISTIC TECHNOLOGIES PRIVATE LIMITED',
    'AAR KAY AGRO PROTIENS PRIVATE LIMITED',
    'SOM MILK PRIVATE LIMITED',
    'FMS SOLUTIONS INDIA PRIVATE LIMITED',
    'PLASMACOATERS PRIVATE LIMITED',
    'ZENEXPRESS LOGISTICS PRIVATE LIMITED',
    'LUHARIA TECHNOLOGIES PRIVATE LIMITED',
    'ALLSTAR CONSERV PRIVATE LIMITED',
    'WRAPWELL PACKAGING PRIVATE LIMITED',
    'CODE MATRICES PRIVATE LIMITED',
    'ALLEGRO SOLUTION PRIVATE LIMITED',
    'FLIPIN INDIA PRIVATE LIMITED',
    'MAXWORTH MINERAL TRADING PRIVATE LIMITED',
    'BLOODMAN PRIVATE LIMITED',
    'CATV BUSINESS PROCESS AUTOMATION PRIVATELIMITED',
    'CAPTIVE AUDIENCE ADVERTISING NETWORK & RESEARCH PRIVATE LIMITED',
    'AGILEBOT AUTOMATION PRIVATE LIMITED',
    'TALKTOTECHIE SERVICES PRIVATE LIMITED',
    'NEW HAIR PALACE PRIVATE LIMITED',
    'CROYEZ IMMIGRATION SERVICE PRIVATE LIMITED',
    'MYAIR BOOKINGS PRIVATE LIMITED',
    'CENTRE FOR PERSONNEL DEVELOPMENT PRIVATELIMITED',
    'NOVI LOGISTICS PRIVATE LIMITED',
    'GRID91 PRIVATE LIMITED',
    'DIETICS HEALTHCARE AND NEUTRACEUTICALS PRIVATE LIMITED',
    'DATAREADS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SMV TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DEE TEC CERAMICS PRIVATE LIMITED',
    'SENKAY TRAVEL WITH DIFFERENCE PRIVATE LIMITED',
    'JAMAPUNJI SERVICES PRIVATE LIMITED',
    'INNOVATUS CONSULTANCY SERVICES PRIVATE LIMITED',
    'IBJA SKILL DEVELOPMENT COUNCIL',
    'SLS HITECH PRIVATE LIMITED',
    'AKIMAYA ENERGY SERVICES PRIVATE LIMITED',
    'IDEAL PRECISION COMPONENTS PRIVATE LIMITED',
    'LE MERITE FASHIONS PRIVATE LIMITED',
    'MEDEXCEL IMPEX PRIVATE LIMITED',
    'SITAC KABINI RENEWABLES PRIVATE LIMITED',
    'GK CAPITAL CONSULTANTS PRIVATE LIMITED',
    'METRIKA MODULER SOLUTIONS PRIVATE LIMITED',
    'SAPHIRE NIRMAN PRIVATE LIMITED',
    'EPIQUE WORLD PRIVATE LIMITED',
    'NMH REALTY SERVICES PRIVATE LIMITED',
    'SUNFLARE SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'NAVSON TECHNOLOGIES PRIVATE LIMITED',
    'GORUSTICX INDIA PRIVATE LIMITED',
    'YUKTITECH IT SERVICES PRIVATE LIMITED',
    'NORTH EAST SMALL FINANCE BANK LIMITED',
    'TRISHIR ENTERPRISES PRIVATE LIMITED',
    'NSV INVESTMENTS PRIVATE LIMITED',
    '30DAYS TECHNOLOGIES PRIVATE LIMITED',
    'ZENSKILL PRIVATE LIMITED',
    'GFS INDIA PRIVATE LIMITED',
    'JANTA CHICKEN FARMS PRIVATE LIMITED',
    'MANTRA FIESTA PRIVATE LIMITED',
    'CUBEB CONSULTING PRIVATE LIMITED',
    'FURNTECK ENGINEERS PRIVATE LIMITED',
    'FIRSTPARTNERS COMMUNICATIONS PRIVATE LIMITED',
    'NGC BROADBAND PRIVATE LIMITED',
    'RV ONLINE GAMING PRIVATE LIMITED',
    'WORKFORCE BUSINESS MANAGEMENT PRIVATE LIMITED',
    'UG TRAVEL RELATED SERVICES PRIVATE LIMITED',
    'EURO NEXTECH PRIVATE LIMITED',
    'SACHI ASSOCIATES PRIVATE LIMITED',
    'SECURIZO MANAGEMENT SERVICES PRIVATE LIMITED',
    'HYDRISE FOODS PRIVATE LIMITED',
    'INMOVIDU TECHNOLOGIES PRIVATE LIMITED',
    'REFERPLUS PRIVATE LIMITED',
    'CIRCLE OF MINDS INNOVATION PRIVATE LIMITED',
    'PALO ALTO NETWORKS (INDIA) TECHNOLOGIES PRIVATE LIMITED',
    'HELLOHEALTH PHARMACY PRIVATE LIMITED',
    'APLIQO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BTP SPORTS PRIVATE LIMITED',
    'AVON INFRABIZ PRIVATE LIMITED',
    'INSIGNYTICS TECHNOLOGIES PRIVATE LIMITED',
    'BUDDY (HARYANA) BOTTLERS PRIVATE LIMITED',
    'WISDOM INNOVATIONS PRIVATE LIMITED',
    'FASTWELL ENGINEERING PRIVATE LIMITED',
    'LOGICBOX INDIA PRIVATE LIMITED',
    'INTROHIVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PEPIQ HOMES PRIVATE LIMITED',
    'INBAY INNOVATIONS PRIVATE LIMITED',
    'SANSAAR HOUSING FINANCE LIMITED',
    'ORISSA ESPRESSO PRIVATE LIMITED',
    'ABTRAN INDIA PRIVATE LIMITED',
    'BPS GROUPS PRIVATE LIMITED',
    'NETMYSOFT PRIVATE LIMITED',
    'BT TECHLABS PRIVATE LIMITED',
    'BRISK MIND PRIVATE LIMITED',
    'SECRET SUPPER PROJECT PRIVATE LIMITED',
    'PUB GLOBAL PRIVATE LIMITED',
    'ADVAITA SHOWBIZ PRIVATE LIMITED',
    'SOLIDUS TECHNO POWER PRIVATE LIMITED',
    'INNOVENT TECHNOLOGIES PRIVATE LIMITED',
    'COMHEIGH IMPEX PRIVATE LIMITED',
    'DGC INFRASTRUCTURE PRIVATE LIMITED',
    'PRITI DISTRIBUTORS PRIVATE LIMITED',
    'BLUE PLANET YASASU SOLUTIONS PRIVATE LIMITED',
    'PRIMEDEQ INDIA PRIVATE LIMITED',
    'SHANMUKHA INNOVATIONS PRIVATE LIMITED',
    'I-SEC SECURITY SERVICES PRIVATE LIMITED',
    'PAPRSKY SERVICES PRIVATE LIMITED',
    'RANKCER TECHNOLOGIES PRIVATE LIMITED',
    'VICTORIOUS MARITIME PRIVATE LIMITED',
    'KRISTAL ADVISORS PRIVATE LIMITED',
    'AO SOLUTIONS PRIVATE LIMITED',
    'SPACELINE INFRA PRIVATE LIMITED',
    'SPEAKING MINDS KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'SPEC & CAL GASES PRIVATE LIMITED',
    'LEARNVERN PRIVATE LIMITED',
    'EDIO MEDIA NETWORKS PRIVATE LIMITED',
    'SYMETRIX ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'SEAFARADAYS DEFENCE SOLUTIONS PRIVATE LIMITED',
    'ALSHIFA HEALTHCARE SERVICES PRIVATE LIMITED',
    'DIGITALPUSHP PRIVATE LIMITED',
    'HEWLETT PACKARD ENTERPRISE GLOBALSOFT PRIVATE LIMITED',
    'VEEVEETEE IMPEX INDIA PRIVATE LIMITED',
    'ASPIGROW TECHNOLOGIES PRIVATE LIMITED',
    'ISCISTECH TRADINGS AND DISTRIBUTIONS PRIVATE LIMITED',
    'CEREBLIS TECHNOLOGIES PRIVATE LIMITED',
    'WAKENCODE TECHNOLOGIES PRIVATE LIMITED',
    'ELROY AUTOMOBILES PRIVATE LIMITED',
    'NEAT WIND INDUSTRIES LIMITED',
    'SEVEN INFOSERVICES PRIVATE LIMITED',
    'SKYTECH ROLLING MILL PRIVATE LIMITED',
    'HARSIDDH PHARMAMACH PRIVATE LIMITED',
    'SENKAY GLOBAL TOURS & EVENT MANAGEMENT PRIVATE LIMITED',
    'CONTAINER WALA INDIA PRIVATE LIMITED',
    'RIDHITECH INDIA PRIVATE LIMITED',
    'SATYARUDHRA PREMIUM IMPORTS AND EXPORTS PRIVATE LIMITED',
    'ALVIEEL TECHNOLOGIESS PRIVATE LIMITED',
    'INFIRENCON ENERGY PRIVATE LIMITED',
    'ARISTON GROUP INDIA PRIVATE LIMITED',
    'WILLINGDON SHIPPING LINE ( INDIA) PRIVATE LIMITED',
    'GK DEVELOPMENTS PRIVATE LIMITED',
    'LEAP AGRI LOGISTICS (GUWAHATI) PRIVATE LIMITED',
    'SYMPHYSIS VENTURES PRIVATE LIMITED',
    'TRIUMPHAL STAR PRIVATE LIMITED',
    'IMPERATIVE ASSOCIATES PRIVATE LIMITED',
    'ARIES RENEWABLES PRIVATE LIMITED',
    'SKRR PHARMA SOLUTIONS PRIVATE LIMITED',
    'WISELANE VENTURES PRIVATE LIMITED',
    'MASHRIKA PROJECTS PRIVATE LIMITED',
    'TATA STEEL FOUNDATION',
    'PAPAGOYA EDUCATION PRIVATE LIMITED',
    'KANAMADAGU RENEWABLE ENERGY PRIVATE LIMITED',
    'MADEIT INNOVATION FOUNDATION',
    'AARAAN SHIPPING & TRADING PRIVATE LIMITED',
    'UTS POWER SYSTEMS PRIVATE LIMITED',
    'LINK2SPHERE TECH SOLUTIONS PRIVATE LIMITED',
    'SUN CAP INVESTMENT PROFESSIONALS PRIVATE LIMITED',
    'TSO ANALYTICA PRIVATE LIMITED',
    'YELLOWS AND GREENS AGRI FRESH PRIVATE LIMITED',
    'HOSTELAVIE HOSPITALITY PRIVATE LIMITED',
    'HEAVY MINING SPARES PRIVATE LIMITED',
    'SIGMA ELECTRIC MANUFACTURING CORPORATIONPRIVATE LIMITED',
    'OM ATHARVA TECHNOFAB PRIVATE LIMITED',
    'ASPIRIFY ENTERPRISES PRIVATE LIMITED',
    'IMPULSE GREEN ENERGY PRIVATE LIMITED',
    'HIRE2RETIRE SERVICES PRIVATE LIMITED',
    'ELICZEN LIFESCIENCES PRIVATE LIMITED',
    'CIRCLE WEALTH ADVISORS PRIVATE LIMITED',
    'REFRACT CONSULTING PRIVATE LIMITED',
    'HAKICO FOODS PRIVATE LIMITED',
    'INTERJOIN MEDIA SERVICES PRIVATE LIMITED',
    'KAIRO5 MARCOM PRIVATE LIMITED',
    'ORGANIK MEDIA SERVICES PRIVATE LIMITED',
    'RAW PAINTS PRIVATE LIMITED',
    'VOLTCON INFRASTRUCTURE PRIVATE LIMITED',
    'RECKONER EXIM TRADING PRIVATE LIMITED',
    'TOM TECHNOLOGY SERVICES PRIVATE LIMITED',
    'CALISTO TECHNOCAST PRIVATE LIMITED',
    'ICUBOID PRIVATE LIMITED',
    'SIDMAX VENTURES PRIVATE LIMITED',
    'UEM PISTONS PRIVATE LIMITED',
    'RABRO SPECIALITY CHEMICALS PRIVATE LIMITED',
    'CUBELOGIC SOFTWARE (INDIA) PRIVATE LIMITED',
    'ATI EDUTECH INDIA PRIVATE LIMITED',
    'ADGRAM COMUNICATIONS PRIVATE LIMITED',
    'YORK PUBLISHING SOLUTIONS PRIVATE LIMITED',
    'TMT FITNESS PRIVATE LIMITED',
    'ASTUTO ENTERPRISE PRIVATE LIMITED',
    'CRECENT GARMENTS PRIVATE LIMITED',
    'IMPRESUB DIVING & MARINE INDIA PRIVATE LIMITED',
    'PLANETNINE TECHNOLOGIES PRIVATE LIMITED',
    'DREAM WIZ ECOMMERCE PRIVATE LIMITED',
    'LOOP REALITY PRIVATE LIMITED',
    'B-LOGIC INFOTECH PRIVATE LIMITED',
    'ATRIA SOLAR POWER (ANANTAPUR) PRIVATE LIMITED',
    'INTERNATIONAL COSMETOLOGY SCHOOL PRIVATELIMITED',
    'NURTURO NUTRIMENTS PRIVATE LIMITED',
    'BOOKINGFREE HOLIDAYS PRIVATE LIMITED',
    'STONEWOOD VENTURES PRIVATE LIMITED',
    'PAD PRO SOFTWARE PRIVATE LIMITED',
    'AURO INFRA PRIVATE LIMITED',
    'AQUA MARINE MARITIME ACADEMY PRIVATE LIMITED',
    'JETHEALTHVAL PRIVATE LIMITED',
    'JOSH SUPERVALUE PROPERTIES PRIVATE LIMITED',
    'BUDDYBITS MEDIA PRIVATE LIMITED',
    'KIMTIN MDF LAM PRIVATE LIMITED',
    'ACNAL INDUSTRIES PRIVATE LIMITED',
    'SCHOOGLINK PRIVATE LIMITED',
    'AAI CARGO LOGISTICS & ALLIED SERVICES COMPANY LIMITED',
    'CONTEXTUAL CONNECTIONS PRIVATE LIMITED',
    'HORIZON RENEWABLE POWER PRIVATE LIMITED',
    'JVKV PROPERTY DEVELOPERS PRIVATE LIMITED',
    'AZEEM INFINITE DWELLING INDIA PRIVATE LIMITED',
    'COTTON FAB CREATION PRIVATE LIMITED',
    'GOLDEN PLAY PRIVATE LIMITED',
    'LUMIN-ESSENCE LIGHTING SOLUTIONS PRIVATELIMITED',
    'RUPEETREES MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'ELIZE LIFESTYLE PRIVATE LIMITED',
    'SKIN PROJECT PRIVATE LIMITED',
    'FLAIR WRITING INDUSTRIES LIMITED',
    'SPREAD HOSPITALITY PRIVATE LIMITED',
    'GREENADS GLOBAL PRIVATE LIMITED',
    'MAKEEASYTRAVEL ONLINE PRIVATE LIMITED',
    'BUZYPRO TAXCLOUD PRIVATE LIMITED',
    'PRITHVI 360 DEGREES PRIVATE LIMITED',
    'GOKICKSTART FITNESS CLUB INDIA PRIVATE LIMITED',
    'INSPEN TECHNOLOGY PRIVATE LIMITED',
    'VIRTUE BABY LOUNGE PRIVATE LIMITED',
    'HEXACONCEPTS (INDIA) PRIVATE LIMITED',
    'SAMYAK INFORMATION INFRA PRIVATE LIMITED',
    'ZAGAZ PRIVATE LIMITED',
    'KROWD R&D INDIA PRIVATE LIMITED',
    'CEREBTEC TECHNOLOGIES PRIVATE LIMITED',
    'AUTO VALUE SYSTEMS PRIVATE LIMITED',
    'MOVEMATE LOGISTICS PRIVATE LIMITED',
    'GRAND SOLAR PRIVATE LIMITED',
    'SKILLPARTNERS INDIA PRIVATE LIMITED',
    'TSN MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'FLAIRWITZ SERVICES PRIVATE LIMITED',
    'NIRVANA LANDSCAPES PRIVATE LIMITED',
    'ECO DIVER INDIA PRIVATE LIMITED',
    'ARGAN PROPERTIES PRIVATE LIMITED',
    'AIRPRO PNEUMATICS INDIA PRIVATE LIMITED',
    'THINKMOBI SOLUTIONS PRIVATE LIMITED',
    'INNOVAGE TECHNOLOGIES PRIVATE LIMITED',
    'SYNCO ADVISORY PRIVATE LIMITED',
    'BELIN TECH SOLUTIONS PRIVATE LIMITED',
    'KULDEW TECHNOLOGIES PRIVATE LIMITED',
    'DURA COLOR PRIVATE LIMITED',
    'ULEKTZ LEARNING SOLUTIONS PRIVATE LIMITED',
    'LEAFIN GROCERY PRIVATE LIMITED',
    'INNOVATIVE DIGITAL MARKETING PRIVATE LIMITED',
    'SIMPLYFI SOFTECH INDIA PRIVATE LIMITED',
    'BLUE OCEAN DISTRIBUTORS PRIVATE LIMITED',
    'MOHOLOHOLO FARMS PRIVATE LIMITED',
    'PROAFFLUENCE ASSOCIATES PRIVATE LIMITED',
    'COMPREHENSIVE MANAGEMENT SERVICES PRIVATE LIMITED',
    'LINGA BASIC ELEMENTS SOLUTIONS PRIVATE LIMITED',
    'SSAJ RETAIL PRIVATE LIMITED',
    'KING STAR FREIGHT PRIVATE LIMITED',
    'ENERGYPRO ENGINEERING PRIVATE LIMITED',
    'AMD SOLAR PRIVATE LIMITED',
    'ASIATEK AUTOMOTIVE SOLUTIONS INDIA PRIVATE LIMITED',
    'HAWK EYE LOGISTICS PRIVATE LIMITED',
    'TANGENTIA TRAVANCORE PRIVATE LIMITED',
    'SANJAY SUSHIL BHOSALE INFRALIFE PRIVATE LIMITED',
    'WYVAA SOFTWARE LABS PRIVATE LIMITED',
    'KEYSTONE TALENT MANAGEMENT PRIVATE LIMITED',
    'IMMIGLOBAL SERVICES PRIVATE LIMITED',
    'CASTLE ADVANCED TECHNOLOGIES AND SYSTEMSPRIVATE LIMITED',
    'CALLISTUS TECH-GLOBAL PRIVATE LIMITED',
    'DEE HOLIDAYS PRIVATE LIMITED',
    'G-MOBILE DEVICES PRIVATE LIMITED',
    'CENTRIX PROJECT SOLUTION PRIVATE LIMITED',
    'ISMARTU INDIA PRIVATE LIMITED',
    'SHIVANSH LOGISTICS PRIVATE LIMITED',
    'VEGIN LOGISTICS PRIVATE LIMITED',
    'AKASHNANDI POWER GENERATORS PRIVATE LIMITED',
    'IDEAMAGINATIVE SOLUTIONS PRIVATE LIMITED',
    'NXTECH WEB SOLUTIONS (OPC) PRIVATE LIMITED',
    'MIYAMOTO GLOBAL EXPERTS INDIA PRIVATE LIMITED',
    'IPAYLINKS PRIVATE LIMITED',
    'MONDAY DOMAINS PRIVATE LIMITED',
    'PHOENIX ASSURANCE PRIVATE LIMITED',
    'A.P.K.S ORGANIC INDIA PRIVATE LIMITED',
    'HYCLONE LIFE SCIENCES SOLUTIONS INDIA PRIVATE LIMITED',
    'EQUUS SIGNALLING SYSTEMS PRIVATE LIMITED',
    'KRAFTMAID SERVICES INDIA PRIVATE LIMITED',
    'QUIKR EMPLOYMENT SOLUTIONS PRIVATE LIMITED',
    'RAREMINDS PRIVATE LIMITED',
    'EYN EXPORTS PRIVATE LIMITED',
    'MOSAIC WELLNESS PRIVATE LIMITED',
    'ZANSHIN HOLDINGS PRIVATE LIMITED',
    'IT SPECTRUM MEDIA PRIVATE LIMITED',
    'BOXTRON INTERNATIONAL PRIVATE LIMITED',
    'SAHIRISHTA.COM MATRIMONY PRIVATE LIMITED',
    'EMPIRE COMPRESSOR PRIVATE LIMITED',
    'MAX POWER SERVICES PRIVATE LIMITED',
    'ASTRASAGE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DIAGNOSTIC BIOSYSTEMS USA PRIVATE LIMITED',
    'WINVESTA INDIA TECHNOLOGIES PRIVATE LIMITED',
    'AWCHAT AND OLSEN DESIGN PRIVATE LIMITED',
    'RECOOTY TECH PRIVATE LIMITED',
    'VCFL EXPRESS PRIVATE LIMITED',
    'BASILEIA SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'STARTECK HOUSING FINANCE PRIVATE LIMITED',
    'AMICA FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'ORAFOL INDIA PRIVATE LIMITED',
    'NAVI INVESTMENT ADVISORS PRIVATE LIMITED',
    'EDUSAAS TECHNOLOGIES PRIVATE LIMITED',
    'MEGAMOVE ELECTRONIC PRIVATE LIMITED',
    'SUNTEC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'BAKHEDA STUDIOS PRIVATE LIMITED',
    'INFINITY LABS LIMITED',
    'FOMEX-HGHY PULP MOLDING MACHINES PRIVATELIMITED',
    'CULTECH WAVE PRIVATE LIMITED',
    'CEEBIT INDIA PRIVATE LIMITED',
    'DHWANI POLYMER INDIA PRIVATE LIMITED',
    'SG SHINAGAWA REFRACTORIES INDIA PRIVATE LIMITED',
    'HOGWARTS E-LEARNING UNIVERSE PRIVATE LIMITED',
    'GASL PRIVATE LIMITED',
    'PAYSHARP PRIVATE LIMITED',
    'KLOUD TECHNOLOGY WORKS PRIVATE LIMITED',
    'TEKWORKS ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'ADANI AIRPORT HOLDINGS LIMITED',
    'ACQUIRLAB SOLUTIONS PRIVATE LIMITED',
    'ONTIME GLOBE KYARRIER PRIVATE LIMITED',
    'WWC WAREHOUSE PRIVATE LIMITED',
    'TEQADDA SOLUTIONS PRIVATE LIMITED',
    'NAVI SECURITIES PRIVATE LIMITED',
    'SPECKLES DEVELOPERS PRIVATE LIMITED',
    'XGROWLAB SOLUTIONS PRIVATE LIMITED',
    'EBQ SQUARE PRIVATE LIMITED',
    'NETSPI INDIA PRIVATE LIMITED',
    'UNISERVICE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'HARINI INFOMATIC PRIVATE LIMITED',
    'VVENDI GLOBAL CONSULTING PRIVATE LIMITED',
    'CLUBR TECHNOLIGIES PRIVATE LIMITED',
    'MAXIMUS CONSULTANCY PRIVATE LIMITED',
    'HI TEMP SOLUTIONS PRIVATE LIMITED',
    '60 DECIBELS IMPACT PRIVATE LIMITED',
    'GALVIN MARKETING SOLUTIONS PRIVATE LIMITED',
    'ELQUE VENTURES PRIVATE LIMITED',
    'SKRM FOODS INDIA PRIVATE LIMITED',
    'P3C TECHNOLOGY AND SOLUTIONS PRIVATE LIMITED',
    'GREENNETIC RENEWABLE PRIVATE LIMITED',
    'MAULI PRIVATE LIMITED',
    'PAX ESTATES PRIVATE LIMITED',
    'INGOLD SOLUTIONS PRIVATE LIMITED',
    'SECUREFORCE SECURITY SERVICES PRIVATE LIMITED',
    'PMS FINTECH PRIVATE LIMITED',
    'RESEARCHFIN INDIA PRIVATE LIMITED',
    'TECHFICS PRIVATE LIMITED',
    'HIGHWAVES TECHNOLOGIES PRIVATE LIMITED',
    'UNIGLORE FOODS PRIVATE LIMITED',
    'MASYCODA SOLUTIONS PRIVATE LIMITED',
    'PINDILA CONSULTANCY PRIVATE LIMITED',
    'PK SECURITY SERVICES PRIVATE LIMITED',
    'LEARNOVATE SKILLS PRIVATE LIMITED',
    'WMG ELITE PRIVATE LIMITED',
    'ADEPT HUNTERS PRIVATE LIMITED',
    'SCALECREATIVE DIGITAL SERVICES PRIVATE LIMITED',
    'ZWEI POWER PRIVATE LIMITED',
    'ILP 3 INDIA 11 PRIVATE LIMITED',
    'CLUBDIARIES TECHNOLOGIES PRIVATE LIMITED',
    'SHREEJI AGRI COMMODITY PRIVATE LIMITED',
    'BLUEMINE MARINE SOLUTIONS PRIVATE LIMITED',
    'MODULAIRE POWER SYSTEM PRIVATE LIMITED',
    'NATURAYUVA INDIA PRIVATE LIMITED',
    'KAMATI SOLAR PRIVATE LIMITED',
    'ATRACTIVA TECHNOLOGY PRIVATE LIMITED',
    'ESTEEM XEN BUILDPROJECTS PRIVATE LIMITED',
    'MANDAL AQUA INTERNATIONALS PRIVATE LIMITED',
    'ASPERA ESTATES PRIVATE LIMITED',
    'ILP 3 INDIA 13 PRIVATE LIMITED',
    'FASHION PLATFORM RETAIL PRIVATE LIMITED',
    'SHIMODA TRADING INDIA PRIVATE LIMITED',
    'FUJITSU SOLUTIONS INDIA PRIVATE LIMITED',
    'INFLOWSOL TECH PRIVATE LIMITED',
    'REMOTEPRO ENGINEERING PRIVATE LIMITED',
    'INIYA AGROTECH PRIVATE LIMITED',
    'NAIL RITUALS PRIVATE LIMITED',
    'AUXILLO PHARMA PRIVATE LIMITED',
    'FLUIDSMART SYSTEMS PRIVATE LIMITED',
    'BIRKENSTOCK INDIA PRIVATE LIMITED',
    'RATNAAFIN BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KAYSTAR INDUSTRIAL CONTROLS PRIVATE LIMITED',
    'J. CREW SOURCING INDIA PRIVATE LIMITED',
    'BIOSPECIMEN SOLUTIONS PRIVATE LIMITED',
    'CIRO TRADE PRIVATE LIMITED',
    'TWB PRODUCTIONS PRIVATE LIMITED',
    'Z-COUNT TECHNOLOGIES PRIVATE LIMITED',
    'CAREBRIDGE HEALTH SERVICES PRIVATE LIMITED',
    'CZAR METRIC SYSTEM PRIVATE LIMITED',
    'AGF ORGANICS PRIVATE LIMITED',
    'ILP 3 INDIA 9 PRIVATE LIMITED',
    'DECCAN INFRAVENTURES PRIVATE LIMITED',
    'WATERGENIX SOLUTIONS PRIVATE LIMITED',
    'UGH-ESPORTS PRIVATE LIMITED',
    'SGM ITECH PRIVATE LIMITED',
    'BOBY CHEMMANUR ENTERTAINMENTS PRIVATE LIMITED',
    'LIVESTA LIVING PRIVATE LIMITED',
    'RVS QUALITY CERTIFICATIONS PRIVATE LIMITED',
    'IQVIA HEALTH TRANSFORMATION FOUNDATION',
    'BVALUE SERVICES PRIVATE LIMITED',
    'VESATOGO INNOVATIONS PRIVATE LIMITED',
    'LQI INFRA LIMITED',
    'NARRATIFY YOU MEDIA PRIVATE LIMITED',
    'PINNACLE SOFTWARE AND SERVICES PRIVATE LIMITED',
    'STRATMED SERVICES PRIVATE LIMITED',
    'FREEBOWLER PRIVATE LIMITED',
    'PARC INFOR PRIVATE LIMITED',
    'KM ASTROGURU PRIVATE LIMITED',
    'SIMPLEENERGY PRIVATE LIMITED',
    'HUAIHAI KSL AUTO PRIVATE LIMITED',
    'HUAFON INDIAN PRIVATE LIMITED',
    'KUKKR TECHNOLOGIES PRIVATE LIMITED',
    'MAHI MARINE PRIVATE LIMITED',
    'BRAINCURRY TECHNOLOGIES PRIVATE LIMITED',
    'TECH ENVIROZ PRIVATE LIMITED',
    'SIMAS EXPORTS PRIVATE LIMITED',
    'MEDIJOURN SOLUTIONS PRIVATE LIMITED',
    'ANURA INFOTECH PRIVATE LIMITED',
    'GRANVI IMPEX PRIVATE LIMITED',
    'IZOE SOLUTIONS PRIVATE LIMITED',
    'WILLBO ENGINEERING INDIA PRIVATE LIMITED',
    'ALLIANCE POLYTECH PRIVATE LIMITED',
    'S.P. RETAIL BRANDS LIMITED',
    'DATAWAVE NETWORKS PRIVATE LIMITED',
    'ESTEEM KINGS DWELLING PRIVATE LIMITED',
    'SUSNEH INFRAPARK PRIVATE LIMITED',
    'KANAKAVALLI RETAIL VENTURESS PRIVATE LIMITED',
    'KEYLOGIC AUTOMATIONS PRIVATE LIMITED',
    'EICHIBA PRIVATE LIMITED',
    'REAL BLOCKS PRIVATE LIMITED',
    'VERANTOS INDIA PRIVATE LIMITED',
    'LXTECH INDIA PRIVATE LIMITED',
    'OAYAW INDIA PRIVATE LIMITED',
    'VERITYTECH HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'LANCIFY CONNECT PRIVATE LIMITED',
    'FOUNDATION FOR INTEROPERABILITY IN DIGITAL ECONOMY',
    'HOTELBEDS INDIA PRIVATE LIMITED',
    'KEMP TECHNOLOGIES INDIA PRIVATE LIMITED',
    'UWORLD (INDIA) PRIVATE LIMITED',
    'ELOCITY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SRIXETRA TECHNOLOGIES PRIVATE LIMITED',
    'LOTUS TECHNICALS PRIVATE LIMITED',
    'MRN SUPERMARKET PRIVATE LIMITED',
    'RECTOR LOGISTICS PRIVATE LIMITED',
    'SHUNYA IOT AI RESEARCH PRIVATE LIMITED',
    'FARMEDIBLE PRODUCTS PRIVATE LIMITED',
    'VISIGHT TECHNOLOGIES PRIVATE LIMITED',
    'TRY AUTO GEARS PRIVATE LIMITED',
    'SEE IOT SOLUTIONS PRIVATE LIMITED',
    'ZENLAYER NETWORKS INDIA PRIVATE LIMITED',
    'EVQPOINT SOLUTIONS PRIVATE LIMITED',
    'ILP 3 INDIA 14 PRIVATE LIMITED',
    'FOXTRONIC REAL ESTATE DEVELOPERS PRIVATELIMITED',
    'LIVSCIENCE TECHNOLOGIES PRIVATE LIMITED',
    'EVISION INFOTECH SOLUTION PRIVATE LIMITED',
    'EXELLOR SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'JETATECH INFOSERVICES PRIVATE LIMITED',
    'EVIDYALOKA EDUCATION FOR ALL NETWORK FOUNDATION',
    'HOMEGROWN ARTISANAL BRANDS PRIVATE LIMITED',
    'MASCHINENBAU HERBERT INDIA PRIVATE LIMITED',
    'ROZ DESIGN LAB PRIVATE LIMITED',
    'SUSHA BRANDING SOLUTIONS PRIVATE LIMITED',
    'ENDEL DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SO INDIA CONSTRUCTION MANAGEMENT PRIVATELIMITED',
    'M-PANELS RESEARCH SERVICES PRIVATE LIMITED',
    'NETRI HEALTHCARE PRIVATE LIMITED',
    'BIOSENSORS MEDICAL INDIA PRIVATE LIMITED',
    'CORE TRADESERVE PRIVATE LIMITED',
    'MAHESH EDIBLE OIL MANUFACTURES PRIVATE LIMITED',
    'GRAIN ',
    'GRACE FOOD INGREDIENTS MANUFACTURING PRIVATE LIMITED',
    'END2END FACILITATORS GLOBAL PRIVATE LIMITED',
    'MARUTI SUZUKI TOYOTSU INDIA PRIVATE LIMITED',
    'RANJANS LI-ON ENERGY PRIVATE LIMITED',
    'ENCORA GEMILANG PRIVATE LIMITED',
    'RAP CUISINE PRIVATE LIMITED',
    'PRIME INFRADEVELOPERS MAINTENANCE SERVICES PRIVATE LIMITED',
    'JUSTMAC TECHNOLOGIES PRIVATE LIMITED',
    'FINGA TECHNOLOGIES PRIVATE LIMITED',
    'LOCKSTEP NETWORK INDIA PRIVATE LIMITED',
    'WINGS AGRICULTURE PRIVATE LIMITED',
    'HELPLAST BIOPLASTICS PRIVATE LIMITED',
    'AARISH PACCOR LIMITED',
    'GSTP (HFS) PRIVATE LIMITED',
    'SYNTEC SYSTEMS INDIA PRIVATE LIMITED',
    'RIGHT TITLE SERVICES PRIVATE LIMITED',
    'ODI JEWELS PRIVATE LIMITED',
    'VIROSH EXPORTS INDIA PRIVATE LIMITED',
    'AGAMANALYTICS PRIVATE LIMITED',
    'BANYAN HOSPITAL PRIVATE LIMITED',
    'BUKWANG TECH INDIA PRIVATE LIMITED',
    'BOLTT GAMES PRIVATE LIMITED',
    'OCTAGON PULSES PRIVATE LIMITED',
    'NIMBUSPOST PRIVATE LIMITED',
    'HIGGS BOSON SYSTEMS PRIVATE LIMITED',
    'MOUSE MEDIA CREATION PRIVATE LIMITED',
    'HIGEKI SERVICES PRIVATE LIMITED',
    'FINSTER BLACK PRIVATE LIMITED',
    'JUBILANT INGREVIA LIMITED',
    'SAMALA UDYOG PRIVATE LIMITED',
    'RALSON TYRES LIMITED',
    'BRINDAVAN PACKAIDS PRIVATE LIMITED',
    'RAMA KRISHNA PACKAGING PRIVATE LIMITED',
    'BSGLISSOME AUTOMATION ENERGY PRIVATE LIMITED',
    'ASKHOMEY INDIA PRIVATE LIMITED',
    'AIKENIST TECHNOLOGIES PRIVATE LIMITED',
    'BIONE VENTURES PRIVATE LIMITED',
    'ANNORATECH SOLUTIONS PRIVATE LIMITED',
    'WEARABOT INDIA PRIVATE LIMITED',
    'DFTTRAINING INSTITUTE PRIVATE LIMITED',
    'BITICS PRIVATE LIMITED',
    'TELEGATE ITC SERVICES PRIVATE LIMITED',
    'CENTIME TECHNOLOGY INDIA PRIVATE LIMITED',
    'PEOPLETECK DELTA IMPACTCHAIN PRIVATE LIMITED',
    'MOOKERJI FOUNDATION',
    'ZETTABYTES SOFTWARE PRIVATE LIMITED',
    'LEVEL NEXT CONSULTING SERVICES PRIVATE LIMITED',
    'ASSURED & PROTECTIVE INDIA PRIVATE LIMITED',
    'APPSDART SOLUTIONS PRIVATE LIMITED',
    'MAHARASHTRA MEDICAL TOURISM SERVICES LIMITED',
    'MADHUKAR LIVELIHOOD FOUNDATION',
    'WEST-IN AVO NURSERIES PRIVATE LIMITED',
    'AROMATRIX FLAVOURS AND FRAGRANCES PRIVATE LIMITED',
    'VIOS FOOD PRIVATE LIMITED',
    'JIMBH INDUSTRIES PRIVATE LIMITED',
    'UC COLOURS AND INTERMEDIATES PRIVATE LIMITED',
    'INVENTURIZ LABS PRIVATE LIMITED',
    'LEADINGEDGE FUTURING TECHNOLOGY PRIVATE LIMITED',
    'ROMMELAG ENGINEERING PRIVATE LIMITED',
    'FLOW P&E INDIA PRIVATE LIMITED',
    'VT TRONICS PRIVATE LIMITED',
    'HAMMER HEAD EXPERIENCES PRIVATE LIMITED',
    'PEPPER ADVANTAGE INDIA PRIVATE LIMITED',
    'EGEARZ PRIVATE LIMITED',
    'SAANIKA POLYTEX PRIVATE LIMITED',
    'S.K PAPER MILLS PRIVATE LIMITED',
    'ILP 3 INDIA 15 PRIVATE LIMITED',
    'ILP 3 INDIA 21 PRIVATE LIMITED',
    'SVAN AUTOTECH PRIVATE LIMITED',
    'BESPOKE BEAUTY PRIVATE LIMITED',
    'MOPP FOODS PRIVATE LIMITED',
    'VARNIKA KONDENSATORS PRIVATE LIMITED',
    'TCL CABLES PRIVATE LIMITED',
    'VIKHROLI BUSINESS CITY PRIVATE LIMITED',
    'RUSA GEMS INDIA PRIVATE LIMITED',
    'STAQO WORLD PRIVATE LIMITED',
    'KAMONK PROJECTS PRIVATE LIMITED',
    'PRO RETAIL ASSISTS PRIVATE LIMITED',
    'DOKONALY CARGO MANAGEMENT SERVICE PRIVATE LIMITED',
    'COLT NETWORK SERVICES INDIA PRIVATE LIMITED',
    'VIPRA AND SHIPRA SPACES PRIVATE LIMITED',
    'IDKIT DCI TECHNOLOGIES PRIVATE LIMITED',
    'VERICLE INDIA PRIVATE LIMITED',
    'XIOTA INDIA PRIVATE LIMITED',
    'ENVO-SUSTAINER PRIVATE LIMITED',
    'SPACECLAP PRIVATE LIMITED',
    'MICROPARK DISTRIBUTORS PRIVATE LIMITED',
    'ILP 3 INDIA 19 PRIVATE LIMITED',
    'HELLA INFRA MARKET RETAIL PRIVATE LIMITED',
    'GMONEY PRIVATE LIMITED',
    'VISHAL ALUMINIUM PRIVATE LIMITED',
    'SHYAMA POLYTEX PRIVATE LIMITED',
    'V2 SMART MANUFACTURING PRIVATE LIMITED',
    'CONTEMI TRADING SOLUTIONS (INDIA) PRIVATE LIMITED',
    'BLEND ADDITIVES & COMPOUNDS PRIVATE LIMITED',
    'UDITI DWELLINGS PRIVATE LIMITED',
    'NEOTREX STEEL LIMITED',
    'TECHCARROT INDIA PRIVATE LIMITED',
    'LIBERWIN TECHNOLOGIES PRIVATE LIMITED',
    'COMPATIO INDIA PRIVATE LIMITED',
    'LEGALPAY TECHNOLOGY PRIVATE LIMITED',
    'SQINTALK COSMECEUTICALS PRIVATE LIMITED',
    'PUNEET EDIFICE PRIVATE LIMITED',
    'AIRBUK PRIVATE LIMITED',
    'GSN GLOBAL FILMS PRIVATE LIMITED',
    'JUGAPRO INDIA PRIVATE LIMITED',
    'AVAADA SUNRAYS ENERGY PRIVATE LIMITED',
    'CRYSTAL CROP TECHNO SOLUTIONS PRIVATE LIMITED',
    'APURVA CONCEPTS PRIVATE LIMITED',
    'AERODYNE INDIA VENTURES PRIVATE LIMITED',
    'CREAFINA FASHIONS PRIVATE LIMITED',
    'VOHRA WOUND CARE PRIVATE LIMITED',
    'AVAADA SUSTAINABLE RJPROJECT PRIVATE LIMITED',
    'FOXX LIFE SCIENCES PRIVATE LIMITED',
    'NJA GARMENTS PRIVATE LIMITED',
    'ZIMBAROOS GEEKS PRIVATE LIMITED',
    'SIDDHAKALA STEEL PRIVATE LIMITED',
    'NAVOMI CLOUD SOLUTIONS PRIVATE LIMITED',
    'NIRYASA LIFE SCIENCE PRIVATE LIMITED',
    'INFINITYROOTS TECHNOLOGIES PRIVATE LIMITED',
    'SUNG SHIN TECH INDIA PRIVATE LIMITED',
    'TRINGO SOLUTIONS INDIA PRIVATE LIMITED',
    'ANATOMIC IRON INDIA PRIVATE LIMITED',
    'KOHBEE TECHNOLOGIES PRIVATE LIMITED',
    'JUNOMONETA FINSOL PRIVATE LIMITED',
    'SANTHOSH AGROPRODUCTS PRIVATE LIMITED',
    'ANALYTIQ INFOSERV PRIVATE LIMITED',
    'INGINOMICX TECHNOLOGIES PRIVATE LIMITED',
    'KWANGSUNG SANDHAR AUTOMOTIVE SYSTEMS PRIVATE LIMITED',
    'CASHBEE TECHNOLOGY INDIA PRIVATE LIMITED',
    'ISUNJET INDIA PRIVATE LIMITED',
    'HOUSEPITAL PRIVATE LIMITED',
    'SHAMBALLA WELLNESS PRIVATE LIMITED',
    'IMEDDOC SOFTWARE INDIA PRIVATE LIMITED',
    'TWODOTSEVEN TECHSERV PRIVATE LIMITED',
    'STACKSEER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CROWN AGENTS INSPECTIONS PRIVATE LIMITED',
    'MOOPLE ANIMATION PRIVATE LIMITED',
    'COMFORT GRID TECHNOLOGIES PRIVATE LIMITED',
    'PRAGYAWAN INDIA PRIVATE LIMITED',
    'AUTOMOBILE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GODABARI AGRO MACHINERY AND SERVICES INDIA PRIVATE LIMITED',
    'TOPHATTER SOFTWARE INDIA PRIVATE LIMITED',
    'AAANT TECHNOLOGIES PRIVATE LIMITED',
    'VENTUR8 SOFTWARE INDIA PRIVATE LIMITED',
    'VSL LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'PAWSNME CARE PRIVATE LIMITED',
    'ISCHOOLCONNECT TECHNOLOGIES PRIVATE LIMITED',
    'PALLAVA AGRI PRIVATE LIMITED',
    'NEWAGE PRODUCT DESIGNS PRIVATE LIMITED',
    'UNIQON CONSULTING PRIVATE LIMITED',
    'OPSERA (INDIA) PRIVATE LIMITED',
    'SALEM TECHNOLOGIES PRIVATE LIMITED',
    'THYNX LABS PRIVATE LIMITED',
    'SAMASTH LIVING PRIVATE LIMITED',
    'TANUSHKA AGRO PRIVATE LIMITED',
    'DESIGNTREE.COM LIMITED',
    'GVM RAIL PRIVATE LIMITED',
    'PROFORCE SOFTWARE SERVICES PRIVATE LIMITED',
    'ESS KAY COMPONENTS PRIVATE LIMITED',
    'SIMPLEASE SOLUTIONS PRIVATE LIMITED',
    'MOTILAL OSWAL BROKING AND DISTRIBUTION LIMITED',
    'CORSICA SOLUTIONS PRIVATE LIMITED',
    'BRIDGERA INDIA PRIVATE LIMITED',
    'PRIZOR SNACKS PRIVATE LIMITED',
    'AVALONMETA VENTURES PRIVATE LIMITED',
    'DRAWOUT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GREENERGY RENEWABLE SOURCE PRIVATE LIMITED',
    'UCI FREIGHT SOLUTIONS PRIVATE LIMITED',
    'ABC RENEWABLE ENERGY PRIVATE LIMITED',
    'CILA AGROTECH PRIVATE LIMITED',
    'STANZEKIEL SOFTWARE PRIVATE LIMITED',
    'KURMA MIRACLE DRUGS PRIVATE LIMITED',
    'HAPTEN BIOSYSTEMS PRIVATE LIMITED',
    'SRI SRI EXIM AGRO INDIA PRIVATE LIMITED',
    'KARTIKEYHARI FOODS PRIVATE LIMITED',
    'N.U.M.S TECHNOFASHIONS INDIA PRIVATE LIMITED',
    'OMSARTHI DAIRY PRODUCTS LIMITED',
    'PALM TREE TECHNICAL PRODUCTS PRIVATE LIMITED',
    'CAMPUS BUILD TECHNOLOGIES PRIVATE LIMITED',
    'ECOSSENTIAL CLOTHING PRIVATE LIMITED',
    'PURPLEFIRST TECHNOLOGIES PRIVATE LIMITED',
    'ORGANICCULT PRIVATE LIMITED',
    'CRIF CONNECT PRIVATE LIMITED',
    'DELVE AI INDIA PRIVATE LIMITED',
    'FROGXO EXIM PRIVATE LIMITED',
    'STAR IMPEX INDIA PRIVATE LIMITED',
    'VGOTTHIS MARKETING PRIVATE LIMITED',
    'HOLIDAY BREAKS LIMITED',
    'MANIPAL NATURAL PRIVATE LIMITED',
    'NETSETGO MEDIA PRIVATE LIMITED',
    'PRIME POWER SERVICES PRIVATE LIMITED',
    'WCUBE SOLUTIONS PRIVATE LIMITED',
    'SUPERNORMAL CONCEPTS PRIVATE LIMITED',
    'PUNARV RESOURCES PRIVATE LIMITED',
    'SAREDH SUPERFOODS PRIVATE LIMITED',
    'DREMIO SOFTWARE INDIA PRIVATE LIMITED',
    'WEBKNOT TECHNOLOGIES PRIVATE LIMITED',
    'DOOTH INTERNET SERVICES PRIVATE LIMITED',
    'RELIANCE FILMS DISTRIBUTION PRIVATE LIMITED',
    'MONEYPACKERS INDIA PRIVATE LIMITED',
    'BAOKE STATIONERY INDIA PRIVATE LIMITED',
    'BCSP SERVICES (OPC) PRIVATE LIMITED',
    'EBIQUITY INDIA PRIVATE LIMITED',
    'MOBIUS DEVELOPMENT STUDIO PRIVATE LIMITED',
    'HPLA ADVERTISING PRIVATE LIMITED',
    'PROMENANT INNOVATION LABS PRIVATE LIMITED',
    'JUNKRY TEXRETAIL PRIVATE LIMITED',
    'AIRLIFT TRANS PACIFIC PRIVATE LIMITED',
    'THINKTUB INTERACTIVES (OPC) PRIVATE LIMITED',
    'GOGAPPI PRIVATE LIMITED',
    'DCUBE AI RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'MCMARVIN PRIVATE LIMITED',
    'TQS LOGISTICS SERVICES PRIVATE LIMITED',
    'ASHISH RAILS PRIVATE LIMITED',
    'JSW VIJAYANAGAR METALLICS LIMITED',
    'SYNAPSICA HEALTHCARE PRIVATE LIMITED',
    'MUMBAI CITY FOOTBALL INDIA PRIVATE LIMITED',
    'NUMINDIA AUTOMATION PRIVATE LIMITED',
    'SHRIJIONE INFOTECH PRIVATE LIMITED',
    'NATUROCULTURE PRIVATE LIMITED',
    'INVENTONUS TECH PRIVATE LIMITED',
    'NAYMO INTERNATIONAL PRIVATE LIMITED',
    'INFRASOLS INDIA PRIVATE LIMITED',
    'RRM ENTERPRISES PRIVATE LIMITED',
    'THAPASSU GLOBAL IT SOLUTIONS PRIVATE LIMITED',
    'SHREEMAHAVEER HOME DECOR PRIVATE LIMITED',
    'SAKSHAM GRAM CREDIT PRIVATE LIMITED',
    'MEDISCOPE GLOBAL SERVICES PRIVATE LIMITED',
    'RAPIDKEN TECHNOLOGIES PRIVATE LIMITED',
    'DRCODE TECHNOLOGIES PRIVATE LIMITED',
    'OSV SOLUTIONS PRIVATE LIMITED',
    'FUTZEN ETECHNOLOGIES PRIVATE LIMITED',
    'BIOCON BIOSPHERE LIMITED',
    'PRAKRUTEES RESIDENCY PRIVATE LIMITED',
    'GAMA ROBOTICS PRIVATE LIMITED',
    'FARS ROBOSYS PRIVATE LIMITED',
    'SANCH MOTORS PRIVATE LIMITED',
    'METACOG INNOVATION PRIVATE LIMITED',
    'BLUESTREAM SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'MACIP SOLUTION (OPC) PRIVATE LIMITED',
    'SHRI RUDRAM TECHNOCRATS PRIVATE LIMITED',
    'BNC MOTORS PRIVATE LIMITED',
    'ZEELAB PHARMACY PRIVATE LIMITED',
    'CONVERTCART SOLUTIONS PRIVATE LIMITED',
    'AUK CUTTING HUB PRIVATE LIMITED',
    'LOHIA GLOBAL SOLUTIONS PRIVATE LIMITED',
    'VAVVE TECHNOLOGY SERVICES PRIVATE LIMITED',
    'ARAFIN FINANCIAL SERVICES PRIVATE LIMITED',
    'CART GEEK PRIVATE LIMITED',
    'SELLIGENCE SOLUTIONS PRIVATE LIMITED',
    'SINGH DIAMONDS PRIVATE LIMITED',
    'FAIRPLUM PRIVATE LIMITED',
    'ROBOBAI TECHNOLOGIES PRIVATE LIMITED',
    'WARTENS AUTOMATION PRIVATE LIMITED',
    'ENERGY EXEMPLAR INDIA PRIVATE LIMITED',
    'TALENTOLA SOLUTIONS PRIVATE LIMITED',
    'AQM INNOVALAB PRIVATE LIMITED',
    'CHHAPERIA CABLE MATERIAL PRIVATE LIMITED',
    'GOPANI FILTERS PRIVATE LIMITED',
    'SAMTEK ENGINEERING AND GIS SOLUTIONS PRIVATE LIMITED',
    'TECHNO PROCESS ENGINEERING (OPC) PRIVATELIMITED',
    'PEE GEE DIGI PRINTS PRIVATE LIMITED',
    'PETROBOT TECHNOLOGIES PRIVATE LIMITED',
    'PATH GLOW EDULAB PRIVATE LIMITED',
    'SWIREPAY TECHNOLOGIES PRIVATE LIMITED',
    'ASTRAVUE TECHNOLOGIES PRIVATE LIMITED',
    'GEOLOGIS CONSULTING PRIVATE LIMITED',
    'ABU FAISAL INTERNATIONAL PRIVATE LIMITED',
    'ALGORITHAM INFRASTRUCTURE PRIVATE LIMITED',
    'SYMBIOSIS ASSISTANCE PRIVATE LIMITED',
    'NUTRIFRESH FARM TECH INDIA PRIVATE LIMITED',
    'FLYLIFTS KSK INDIA PRIVATE LIMITED',
    'THUMBI LABS PRIVATE LIMITED',
    'CARBOCHEM PRODUCTS PRIVATE LIMITED',
    'UNIFII DELIVERY CENTER PRIVATE LIMITED',
    'TETRASOFT LABS PRIVATE LIMITED',
    'REALWORLD ONE STUDIO INDIA PRIVATE LIMITED',
    'ALTIVEN IMPEX PRIVATE LIMITED',
    'LAKHAPAR RENEWABLES PRIVATE LIMITED',
    'EMPTYCUP INNOVATION PRIVATE LIMITED',
    'ADARA EXPORTS PRIVATE LIMITED',
    'KINASA PRIVATE LIMITED',
    'MULLUR SOLAR PARKS PRIVATE LIMITED',
    'AGILECONTROLS AND AUTOMATION (OPC) PRIVATE LIMITED',
    'SKYHILL GAMES PRIVATE LIMITED',
    'FINAARA TECHNOLOGIES PRIVATE LIMITED',
    'BYTE AND GULP RESTAURANTS PRIVATE LIMITED',
    'ATMASAMMAN PRIVATE LIMITED',
    'BKF EXPORTS PRIVATE LIMITED',
    'SEKWANG HITECH INDIA PRIVATE LIMITED',
    'IDESA INDIA PRIVATE LIMITED',
    'STRATTON & CITYHALL PRIVATE LIMITED',
    'FOOFOO AGRITECH PRIVATE LIMITED',
    'ABHINAVA GLOBAL ACADEMY PRIVATE LIMITED',
    'GOTECHIN INFORMATION TECHNOLOGY (OPC) PRIVATE LIMITED',
    'VISAPROS PRIVATE LIMITED',
    'NURTURE AGTECH LIMITED',
    'CORNER2CORNER INTERIORS PRIVATE LIMITED',
    'AQUARIES COSMIC ENGINEERING PRIVATE LIMITED',
    'BRMK INDIA PRIVATE LIMITED',
    'GVNR HEALTH PRIVATE LIMITED',
    'LEOSTAR PACKAGING PRIVATE LIMITED',
    'RHYTHM AVIATION PRIVATE LIMITED',
    'SOPHISTIC NETWORKS TECHNOLOGIES PRIVATE LIMITED',
    'ALLEARTH ORGANIC FOODS PRIVATE LIMITED',
    'ELECTRON BRIDGE PRIVATE LIMITED',
    'AEROMUS TECHNOLOGY PRIVATE LIMITED',
    'MADHAV KRG HRC PRIVATE LIMITED',
    'EVENTBAJA DIGITAL SERVICES PRIVATE LIMITED',
    '360 ONE FOUNDATION',
    'LEGENDCALL TECHNOLOGY PRIVATE LIMITED',
    'PLENITUDE FINSERVE PRIVATE LIMITED',
    'EP BIOCOMPOSITES LIMITED',
    'ZUARIAN MANAGEMENT SERVICES PRIVATE LIMITED',
    'ANTHIVE TECHNOLOGIES PRIVATE LIMITED',
    'SANTOSHI PACKAGING PRIVATE LIMITED',
    'QBEX LOGISTICS PRIVATE LIMITED',
    'BM AUTOWORLD PRIVATE LIMITED',
    'JOSHI TECHNOLOGIES INTERNATIONAL INDIA PRIVATE LIMITED',
    'INFEEDO TECH PRIVATE LIMITED',
    'PARDOS GOLF AVENUE PRIVATE LIMITED',
    'HK BASICS PRIVATE LIMITED',
    'ATLBATTERY TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'SPYKE TRIP PRIVATE LIMITED',
    'VIDSON INDUSTRIES PRIVATE LIMITED',
    'EDEN RENEWABLE ALMA PRIVATE LIMITED',
    'AVON PACFO SERVICES PRIVATE LIMITED',
    'HARMAN SPECIALITY PRIVATE LIMITED',
    'HARYANK BUSINESS PRIVATE LIMITED',
    'SHREE JI JEWELLERY MANUFACTURERS PRIVATELIMITED',
    'SVASTAM HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'GAD IT SOLUTIONS PRIVATE LIMITED',
    'ATMAN HERBO INDIA PRIVATE LIMITED',
    'VEE TEE ENGINEERS CONSTRUCTIONS PRIVATE LIMITED',
    'KINGSLAY ENGINEERING PRIVATE LIMITED',
    'GRAMHAL RURAL DEVELOPMENT FOUNDATION',
    'BEYOND INFO TECHNOLOGIES PRIVATE LIMITED',
    'SAANVEE EDUVERSITY PRIVATE LIMITED',
    'ALAKART TECHNOLOGIES PRIVATE LIMITED',
    'MITRA MARRIAGES PRIVATE LIMITED',
    'ATELIER PINKCITY PRIVATE LIMITED',
    'BEES DATA AND IMAGING SOLUTIONS PRIVATE LIMITED',
    'EXCLUSIVE LINEN FABRIC PRIVATE LIMITED',
    'EHEREX MEGA SKILLS INDIA PRIVATE LIMITED',
    'ETIKAL PRIVATE LIMITED',
    'DOCTOR SAFE TOWEL FACTORY PRIVATE LIMITED',
    'BINWIN DESIGNS PRIVATE LIMITED',
    'LEPTONS ROBOTICS AND SPACE TECHNOLOGY PRIVATE LIMITED',
    'YCRAI PRIVATE LIMITED',
    'FUTECH IOT PRIVATE LIMITED',
    'TECHPRO CONSTRUCTIONS PRIVATE LIMITED',
    'EPICODE PRIVATE LIMITED',
    'SKILLKRAFT PRODUCTIONS PRIVATE LIMITED',
    'ALCOSTAR DISTILLERIES PRIVATE LIMITED',
    'ALIENION TECHNOLOGIES PRIVATE LIMITED',
    'BIOBERY LIFESCIENCES PRIVATE LIMITED',
    'AAYOVI PRODUCTIONS PRIVATE LIMITED',
    'BRONZ IQ IT PRIVATE LIMITED',
    'LUCERNE HEALTH & FOOD VENTURES PRIVATE LIMITED',
    'HENGLI HYDRAULIC INDIA SYSTEM SOLUTIONS PRIVATE LIMITED',
    'RIZEBEAR DISTRIBUTION PRIVATE LIMITED',
    'SJ GLOBE CAPITAL FINANCE LIMITED',
    'RK TRANSTEK PRIVATE LIMITED',
    'SAI LEELA METALS AND MINERALS PRIVATE LIMITED',
    'BHASIN TALENT STAFFING SOLUTIONS PRIVATELIMITED',
    'SRI BHARANI MOTORS PRIVATE LIMITED',
    'YERIK INTERNATIONAL PRIVATE LIMITED',
    'SIVASAKTHI FOODS (I) PRIVATE LIMITED',
    'K.L.J. POLYMERS PRIVATE LIMITED',
    'SUNDARAM PETRO CHEM PRIVATE LIMITED',
    'NATURES BIOCHEMICALS PRIVATE LIMITED',
    'TETRIQ SOLUTIONS PRIVATE LIMITED',
    'DEOTIC CLOUDSOLUTIONS PRIVATE LIMITED',
    'RIVER RHAPSODY PRIVATE LIMITED',
    'MRR LABS PRIVATE LIMITED',
    'CARGO MARKETING INTERNATIONAL PRIVATE LIMITED',
    'BDU RUSA RESEARCH INNOVATION AND CAREER HUB FOUNDATION',
    'ITAMOTO TRAVEL PRIVATE LIMITED',
    'REVATHI EQUIPMENT INDIA LIMITED',
    'SAMR FILTRATION PRIVATE LIMITED',
    'TLB MEDIA PRIVATE LIMITED',
    'CTRL S CONNECTIVITY SOLUTIONS PRIVATE LIMITED',
    'INTENTS MOBI PRIVATE LIMITED',
    'WINGSPAN MARKETING PRIVATE LIMITED',
    'NUKE COLD CARE AQUA PRIVATE LIMITED',
    'PEST FIRST SOLUTIONS PRIVATE LIMITED',
    'KENCARE APPLIANCES INDIA PRIVATE LIMITED',
    'KNAM INTERNATIONAL PRIVATE LIMITED',
    'RYTHM AUTOMATION PRIVATE LIMITED',
    'ECO 365 PRIVATE LIMITED',
    'SUMEET POLYPACKS INDIA PRIVATE LIMITED',
    'GBB SCIENTIFIC INSTRUMENTS PRIVATE LIMITED',
    'SAS POLYMERS PRIVATE LIMITED',
    'SOLID FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'POST MAYOR MEDIATECH PRIVATE LIMITED',
    'GREENCELL EXPRESS AGGREGATOR PRIVATE LIMITED',
    'HOMEGLARE E-COMMERCE PRIVATE LIMITED',
    'NANO CONNECTIONS PRIVATE LIMITED',
    'WRENCH INDIA TECHNOLOGIES PRIVATE LIMITED',
    'LEVRARA CONSULTING INDIA PRIVATE LIMITED',
    'CONCILLIUM AUTOMATIONS PRIVATE LIMITED',
    'NAVARITI INNOVATION PRIVATE LIMITED',
    'WILSHIRE NUTRIFOODS LIMITED',
    'SHRI KRISHNA SOLAR & AGRO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MUDUNURU ONE FINTECH PRIVATE LIMITED',
    'JSH PACKAGINGS PRIVATE LIMITED',
    'WINDMILL CAPITAL PRIVATE LIMITED',
    'NUATOM INNOVATIONS PRIVATE LIMITED',
    'JYOTIKIRAN ENERGY LUCKNOW PRIVATE LIMITED',
    'SAARTHI PEDAGOGY PRIVATE LIMITED',
    'CENTERLINE TECHNOLOGIES PRIVATE LIMITED',
    'JAYSHAL CREATIONS PRIVATE LIMITED',
    'PROCURA SOURCING PRIVATE LIMITED',
    'MAMARUTAM FOUNDATION',
    'SHRIDE INDIA PRIVATE LIMITED',
    'PRIMEART DECOR PRIVATE LIMITED',
    'ROBOYO HYPERAUTOMATION INDIA PRIVATE LIMITED',
    'EXIMIUS INNOVATIVE PRIVATE LIMITED',
    'CHEFCAPE ENTERPRISES PRIVATE LIMITED',
    'SQP ENGINEERING PRIVATE LIMITED',
    'TUNEHOME RETAILS PRIVATE LIMITED',
    'VITESTI RESEARCH PRIVATE LIMITED',
    'PAPERWORK ESOLUTIONS PRIVATE LIMITED',
    'STUNNING OUTSOURCE SERVICES PRIVATE LIMITED',
    'SHREEMI CAPITAL PRIVATE LIMITED',
    'SUM8 MARITIME PRIVATE LIMITED',
    'INJ MARKET INTELLIGENCE PRIVATE LIMITED',
    'CONVEYED LANGUAGE SOLUTIONS PRIVATE LIMITED',
    'ADDWALA PRIVATE LIMITED',
    'JYOTIKIRAN ENERGY CHENNAI PRIVATE LIMITED',
    'ZEON CINEMAS PRIVATE LIMITED',
    'ACADEMY OF CERTIFIED VALUATORS AND ANALYSTS PRIVATE LIMITED',
    'VRELITE LOGISTICS PRIVATE LIMITED',
    'REACHALL INDIA PRIVATE LIMITED',
    'EMERALD HAVEN TOWERS LIMITED',
    'VOYAGE TRIP PLANNER PRIVATE LIMITED',
    'APEX INTELLIGENTIA PRIVATE LIMITED',
    'SOPI SERVICES PRIVATE LIMITED',
    'NEELGIRI MACHINERY GLOBAL PRIVATE LIMITED',
    'PADAM PRAKASH COMMERCIALS PRIVATE LIMITED',
    'ADS GURU NETWORK PRIVATE LIMITED',
    'AHAMANI EV TECHNOLOGY INDIA PRIVATE LIMITED',
    'GREEN PC WORLD PRIVATE LIMITED',
    'INDUSAGE TECHAPP PRIVATE LIMITED',
    'VKOLLAB TECHNOLOGIES PRIVATE LIMITED',
    'PAVITRA INDUSTRY PRIVATE LIMITED',
    'CHARSIZE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DOMUM REDEVELOPMENT CONSULTANT PRIVATE LIMITED',
    'AVNIO SOFTWARE PRIVATE LIMITED',
    'SATHYADEEP RIGHT FIX ENGINEERING PRIVATELIMITED',
    'ENDURANCE ENGINEERING & PLASTICS PRIVATELIMITED',
    'NOBEL INNOVATURE TECHNOLOGY PRIVATE LIMITED',
    'MANGLAMG APPARELS PRIVATE LIMITED',
    'JAIN HOTEL & RESORTS PRIVATE LIMITED',
    'PARETO TREE PRIVATE LIMITED',
    'JW BRANDS PRIVATE LIMITED',
    'ZIFFY ELECTRICAL & CONTROLS PRIVATE LIMITED',
    'EXLCOMM SOLUTIONS PRIVATE LIMITED',
    'CRYSTAL CONSTRUCTION MALL PRIVATE LIMITED',
    'VEGANNOVATIVE SOLUTION PRIVATE LIMITED',
    'INTERNATIONAL CORPORATE SOLUTIONS ALLIANCE PRIVATE LIMITED',
    '82 STRATEGY CONSULTANTS AND ADVISORY SERVICES PRIVATE LIMITED',
    'INDCORP ADVISORY SERVICES PRIVATE LIMITED',
    'AXISAATREL ELEVATOR MOTORS PRIVATE LIMITED',
    'LAUNCHPAD FINTECH PRIVATE LIMITED',
    'VGS EXPORTS PRIVATE LIMITED',
    'ZOO MEDIA PRIVATE LIMITED',
    'INFINITE LOOP CAPITAL PRIVATE LIMITED',
    'TVS ENGINEERING LIMITED',
    'MTI FABRICTECH PRIVATE LIMITED',
    'MAKS ECO-MOBILITY PRIVATE LIMITED',
    'IB GLOBAL TENT ENGINEERS PRIVATE LIMITED',
    'UDNAG PRODUCTS PRIVATE LIMITED',
    'LINK ADMINISTRATION SERVICES PRIVATE LIMITED',
    'RSPN INFRATECH PRIVATE LIMITED',
    'MEDIA4U PRIVATE LIMITED',
    'SPACEGTECH PRIVATE LIMITED',
    'MOTION IDENTIX INDIA PRIVATE LIMITED',
    'DHARMIC FOODS PRIVATE LIMITED',
    'DVYA IT SOLUTION PRIVATE LIMITED',
    'PROPACE CONSULTING PRIVATE LIMITED',
    'SHRILEARNING MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'VANTAGE INDIA PRIVATE LIMITED',
    'KD GOLD AND DIAMONDS PRIVATE LIMITED',
    'RANGSONS SCHUSTER PRIVATE LIMITED',
    'BLOCKSURVEY TECHNOLOGIES PRIVATE LIMITED',
    'WITSQUAD AI LABS PRIVATE LIMITED',
    'BLUE TYGA FASHIONS PRIVATE LIMITED',
    'PALLETPERDAY LOGISTICS PRIVATE LIMITED',
    'MARCADONA FASHION MEDIA PRIVATE LIMITED',
    'GM FOXTRONIC DEVELOPERS PRIVATE LIMITED',
    'SOCCOTECH ONLINE PRIVATE LIMITED',
    'ANH TECHNOLOGIES PRIVATE LIMITED',
    'RODO INNOVATIONS PRIVATE LIMITED',
    'HT NOIDA (COMPANY) LIMITED',
    'SOFTONE HR SOLUTIONS PRIVATE LIMITED',
    'INDO TRANSWORLD CHAMBER OF COMMERCE',
    'SURELOCAL SUPPLY CHAIN PRIVATE LIMITED',
    'FACILITATE AND MANAGEMENT OUTSOURCE UTILITY SERVICES PRIVATE LIMITED',
    'KALISTA JEWELS (I) PRIVATE LIMITED',
    'YEWALE FOOD PRODUCTS PRIVATE LIMITED',
    'VIGNESH POLYMERS INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY THREE PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY EIGHT PRIVATE LIMITED',
    'BOLTON LOGISTICS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY THIRTY FOUR PRIVATE LIMITED',
    'CARPENTER TECHNOLOGY INDIA PRIVATE LIMITED',
    'MANAAKI HEALTHCARE PRIVATE LIMITED',
    'VMS WEAVING PRIVATE LIMITED',
    'WAWYA INVESTMENT SERVICES PRIVATE LIMITED',
    'VALVITE SOFTWARE SOLUTIONS (OPC) PRIVATELIMITED',
    'PRIYANKA ENGINEERING PROJECTS PRIVATE LIMITED',
    'ESTILO PROPERTY MANAGEMENT PRIVATE LIMITED',
    'PAVOREAL TEXTILE PRIVATE LIMITED',
    'GOVARDHAN PLASTO PACK PRIVATE LIMITED',
    'ABSOLUTE RG EQUIPMENTS PRIVATE LIMITED',
    'CATAPULTOPUS PRIVATE LIMITED',
    'KUNAL PRINTING & PACKAGING PRIVATE LIMITED',
    'RECSTONE WATER TECHNOLOGIES PRIVATE LIMITED',
    'MANCHUKONDA PRAKASHAM FOODS AND SPICES INDUSTRIES PRIVATE LIMITED',
    'IHRC SERVICES PRIVATE LIMITED',
    'TRRAIN CIRCLE TECHNOLOGIES PRIVATE LIMITED',
    'ELOI RACHMAN PRIVATE LIMITED',
    'URBAN PARIBAHAN CITY BUS SERVICES PRIVATE LIMITED',
    'CHULGIRI ENTERPRISES PRIVATE LIMITED',
    'EFAARMS SOLUTION PRIVATE LIMITED',
    'STUDIOPOD DESIGN PRIVATE LIMITED',
    'METRIC BULL INVESTMENTS PRIVATE LIMITED',
    'SRT SOFTECH PRIVATE LIMITED',
    'IDG CREATIVE DESIGNS PRIVATE LIMITED',
    'ROADGRID INDIA PRIVATE LIMITED',
    'EASTERN STEEL PRIVATE LIMITED',
    'SANVI INFRA SOLUTIONS PRIVATE LIMITED',
    'BIGBLUE SOFTWARES PRIVATE LIMITED',
    'KOLTE-PATIL REALTORS ESTATE PRIVATE LIMITED',
    'RYSLEV OUTDOOR PRIVATE LIMITED',
    'BEAUTY LIFESTYLES PRIVATE LIMITED',
    'NMG MARINE SERVICE PRIVATE LIMITED',
    'SPENDLABS INDIA PRIVATE LIMITED',
    'BRUYANT SERVICES PRIVATE LIMITED',
    'COSMO SPECIALITY CHEMICALS PRIVATE LIMITED',
    'FREE LATERAL PRIVATE LIMITED',
    'CAPER HOTELS AND RESORTS PRIVATE LIMITED',
    'MUZZLEFLASH DIGITAL PRIVATE LIMITED',
    'ASHINE GROUP PRIVATE LIMITED',
    'ARTURO SOFTWARE SYSTEMS INDIA PRIVATE LIMITED',
    'EVAGE MOBILITY PRIVATE LIMITED',
    'GLOBAL GROWTH ARREVIO PRIVATE LIMITED',
    'CLEANFIX-SCHEVARAN SYSTEMS PRIVATE LIMITED',
    'JAICHANDA TRADECOM PRIVATE LIMITED',
    'ELECTROLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'MIZUHO GLOBAL SERVICES INDIA PRIVATE LIMITED',
    'WH LOGISTICS PRIVATE LIMITED',
    'DESTINATIONNXT PRIVATE LIMITED',
    'PODAR RESIDENTIAL HOMES PRIVATE LIMITED',
    'VANTAGEO PRIVATE LIMITED',
    'EYEWEARLABS INNOVATIONS PRIVATE LIMITED',
    'SANCHAY WEALTH PRIVATE LIMITED',
    'VEDATRAYE INFRA PRIVATE LIMITED',
    'PANDIT SADHURAM SHARMA ESTATES PRIVATE LIMITED',
    'ADDON BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SIROCO HVAC INDIA PRIVATE LIMITED',
    'ELCIMECHS PRIVATE LIMITED',
    'QUALITY FOOD MANUFACTURERS AND TRADERS PRIVATE LIMITED',
    'MYSTICGOLDZ PRIVATE LIMITED',
    'KRIS MART (OPC) PRIVATE LIMITED',
    'GEETA SHIPPING AND CLEARING SERVICES PRIVATE LIMITED',
    'QED FINANCIAL TECHNOLOGY PRIVATE LIMITED',
    'BRIJWASI BAKERY PRIVATE LIMITED',
    'THURAIPAKKAM DEVELOPERS PRIVATE LIMITED',
    'RAIL MECHATRONICS PRIVATE LIMITED',
    'BATI MUMBAI PRIVATE LIMITED',
    'SEEDLOGIC TRADING PRIVATE LIMITED',
    'YESHODA ROSE BAZAAR RETAIL PRIVATE LIMITED',
    'TURNKEY HOSPITALITY PIONEERS PRIVATE LIMITED',
    'DREAM LIFE E-COMMERCE (OPC) PRIVATE LIMITED',
    'YELLOWSTONE FINE CHEMICALS PRIVATE LIMITED',
    'PHANTOM PROPERTIES PRIVATE LIMITED',
    'PIPECARE MANUFACTURING PRIVATE LIMITED',
    'POKITO VENTURES PRIVATE LIMITED',
    'AIRAMATRIX PRIVATE LIMITED',
    '3DEFINE TECHNOLOGIES PRIVATE LIMITED',
    'ANALYZE N CONTROL PRIVATE LIMITED',
    'ZEROFOX INDIA PRIVATE LIMITED',
    'GRANNUS WATER & ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'HIH HR SOLUTIONS PRIVATE LIMITED',
    'WISHMAKERS EVENTS PRIVATE LIMITED',
    'URBAN PASS PRIVATE LIMITED',
    'KC GLOBAL EDUTECH PRIVATE LIMITED',
    'SAKSANTEK PRIVATE LIMITED',
    'PROWORK SPACES PRIVATE LIMITED',
    'WISERFEED INDIA PRIVATE LIMITED',
    'LAGRAINE AGRO PRODUCER COMPANY LIMITED',
    'PUSHPMITRA MEDICAL (OPC) PRIVATE LIMITED',
    'NARIUS SERVICES PRIVATE LIMITED',
    'WEBJOY CONSULTING PRIVATE LIMITED',
    'INFINITYHIKE PRIVATE LIMITED',
    'HEXAGON GEOSYSTEMS SERVICES INDIA PRIVATE LIMITED',
    'CHEMIFS CHEMICAL PRIVATE LIMITED',
    'AL-MEHDIYAH PROPERTY PRIVATE LIMITED',
    'TORDA CHEM & COATING PRIVATE LIMITED',
    'FRINKS DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'BEAUTY RELAY PRIVATE LIMITED',
    'WOOD ELEGANCE PRIVATE LIMITED',
    'SKILLMONTE ENGINEERING PRIVATE LIMITED',
    'ALTER MARKETING SOLUTIONS PRIVATE LIMITED',
    'TECHMATE ENGINEERS PRIVATE LIMITED',
    'STERLING POWER VENTURES PRIVATE LIMITED',
    'BLISSCLUB FITNESS PRIVATE LIMITED',
    'MABHIKA ORGANIC CHEM PRIVATE LIMITED',
    'PRUDENTIAL TECHNOLOGY AND SERVICES INDIAPRIVATE LIMITED',
    'SOFTWARE BUSINESS SYSTEMS CONSULTING PRIVATE LIMITED',
    'SHREE 101 PRIVATE LIMITED',
    'FLOWZ DIGITAL PRIVATE LIMITED',
    'SLS CSR FOUNDATION',
    'JYVA ENGINEERING PRIVATE LIMITED',
    'EZ- ENGINEERS PRIVATE LIMITED',
    'QUOTEX CLOTHING PRIVATE LIMITED',
    'RADNEST RADIOLOGY SERVICES PRIVATE LIMITED',
    'LEVEL UP SPORTS PRIVATE LIMITED',
    'OSBORN TECHNOLOGY PRIVATE LIMITED',
    'VENKATA JAYANTH POULTRIES PRIVATE LIMITED',
    'EPS CONSULTANCY PRIVATE LIMITED',
    'FISCALATE ADVISORY SERVICES PRIVATE LIMITED',
    'CWC PLYBOARDS PRIVATE LIMITED',
    'MADURA CARBON INDIA LIMITED',
    'MADHUBAN GOLD PRIVATE LIMITED',
    'POLYMAGE LABS PRIVATE LIMITED',
    'AD2PRO GLOBAL CREATIVE SOLUTIONS PRIVATELIMITED',
    'NEARBYMART MERCANTILES PRIVATE LIMITED',
    'ENERPARC SOLAR POWER 2 PRIVATE LIMITED',
    'TEHKHAND WASTE TO ELECTRICITY PROJECT LIMITED',
    'XIPHER SOFTWARE PRIVATE LIMITED',
    'RUBESR AGRO PRIVATE LIMITED',
    'VALLEYSUN PHARMA PRIVATE LIMITED',
    'IFFCO KISAN FINANCE LIMITED',
    'RBSG CAPITAL PRIVATE LIMITED',
    '5PAISA P2P LIMITED',
    'CONCEPT INVESTWELL PRIVATE LIMITED',
    'MOKSHA REALTECH PRIVATE LIMITED',
    'COMMON WINDOWS CARE PRIVATE LIMITED',
    'MINTO REALTECH PRIVATE LIMITED',
    'GRABBIT MEDIA PRIVATE LIMITED',
    'BUZZEASY MARKETING PRIVATE LIMITED',
    'TEELOCK IT SOLUTIONS PRIVATE LIMITED',
    'BIZPACT CONSULTING PRIVATE LIMITED',
    'AMPSPARK TECHNOLOGIES PRIVATE LIMITED',
    'M.I.J. DESTINATION MANAGEMENT PRIVATE LIMITED',
    'RORI TECHNOLOGIESPRIVATE LIMITED',
    'BASHAR GROWEALTH NIDHI LIMITED',
    'CHAPERON SECURITY SERVICES PRIVATE LIMITED',
    'ANYAINFO CONSULTANCY SERVICES PRIVATE LIMITED',
    'CNI ETAIL SOLUTIONS PRIVATE LIMITED',
    'DELTABIZ IT SOLUTIONS PRIVATE LIMITED',
    'PAN ASIAN BRANDS PRIVATE LIMITED',
    'CANARA EDIBLES AND FATS PRIVATE LIMITED',
    'SYNC YU ENVIRONMENTAL AWARENESS FOUNDATION',
    'DORSET INDUSTRIES PRIVATE LIMITED',
    'SHASHIKANTH MOTION PICTURES PRIVATE LIMITED',
    'HANSRAJ LOGISTICS PRIVATE LIMITED',
    'SKERP MAIL PRIVATE LIMITED',
    'WELLOPATHY ENTERPRISES PRIVATE LIMITED',
    'SBC COOLING PRIVATE LIMITED',
    'HYUNDAI MATERIALS INDIA PRIVATE LIMITED',
    'REOPABLE CONSULTING PRIVATE LIMITED',
    'VRISA INNOVATION LIMITED',
    'A.A.TRAILERS PRIVATE LIMITED',
    'TUSKER BERRY LOGISTICS PRIVATE LIMITED',
    'KALAVANTI AUTOMOTIVE PRIVATE LIMITED',
    'AUSTRAX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CORBITEL TEST PRIVATE LIMITED',
    'BOXOVIA PRIVATE LIMITED',
    'PHYSIS MARKETING AND CONSULTANTS PRIVATELIMITED',
    'HAMARIEARTH MERCHANDISE PRIVATE LIMITED',
    'AJANTA ULTRAPLAST PRIVATE LIMITED',
    'ACETUM SOLUTIONS PRIVATE LIMITED',
    'SYSMMA MEDICOHEART HEALTHCARE PRIVATE LIMITED',
    'KURAO CHEMICALS PRIVATE LIMITED',
    'BIO-TECHNE INDIA PRIVATE LIMITED',
    'URIHK PHARMACEUTICAL PRIVATE LIMITED',
    'AFTOMAT INNOVATIONS PRIVATE LIMITED',
    'CRELIANT SOFTWARE PRIVATE LIMITED',
    'VIJETHA HOSPITALITY SERVICES PRIVATE LIMITED',
    'NAM HO DMC INDIA PRIVATE LIMITED',
    'MINANCE INVESTMENT ADVISORS PRIVATE LIMITED',
    'EZEBIT TECHNOLOGIES PRIVATE LIMITED',
    'COMSPADE ARTS PRIVATE LIMITED',
    'SANKGUJ SEMICONDUCTOR PRIVATE LIMITED',
    'CACHATTO INDIA PRIVATE LIMITED',
    'CAERUS SKILLMATIC INDIA PRIVATE LIMITED',
    'SOJATIA INFOCRAFTS PRIVATE LIMITED',
    'SVAYU IT PRIVATE LIMITED',
    'COREVYAN PRIVATE LIMITED',
    'JAKSH CASTOR PRODUCTS PRIVATE LIMITED',
    'VIGRO INFORMATION AND TECHNOLOGY PRIVATE LIMITED',
    'TURACO SPIRITS PRIVATE LIMITED',
    'HELIX DIAGNOSTICS PRIVATE LIMITED',
    'ONE OCEAN LOGISTICS AND SERVICES PRIVATELIMITED',
    'WANDERERS HOSPITALITY PRIVATE LIMITED',
    'AKSHARSHILP PIMAAS PRIVATE LIMITED',
    'GREYBEEZ PRIVATE LIMITED',
    'IILHI STUDIOS PRIVATE LIMITED',
    'PRAVIZ DEVELOPERS PRIVATE LIMITED',
    'GETERP BUSINESS TECH PRIVATE LIMITED',
    'LHG SPECIALITY STEEL INTERNATIONAL PRIVATE LIMITED',
    'NCOURAGE SOCIAL ENTERPRISE FOUNDATION',
    'GOOD NUTRITION 4 ALL FOUNDATION',
    'SEAIR GLOBAL PRIVATE LIMITED',
    'SEEKRUIT HR TECHNOLOGIES PRIVATE LIMITED',
    'FRR IMMIGRATION SERVICES PRIVATE LIMITED',
    'PACICORP ORGANICS PRIVATE LIMITED',
    'JOY INNOVATIONS PRIVATE LIMITED',
    'OLEFIN WHITE FILMS PRIVATE LIMITED',
    'MANOKAMANA NIDHI LIMITED',
    'CHASING VIRTUOSITY PRIVATE LIMITED',
    'GLYCOGYM HEALTH & LIFESTYLE SERVICES PRIVATE LIMITED',
    'TALK2USERS CONSULTANCY PRIVATE LIMITED',
    'SG BROADBAND INTERNET PRIVATE LIMITED',
    'VERODATATEX INDIA PRIVATE LIMITED',
    'FLIPFLEX HEALTH SOLUTIONS PRIVATE LIMITED',
    'VEVOLVE SOFTWARE PRIVATE LIMITED',
    'INOVEXIC BUSINESS COMMUNITIES INITIATIVES SERVICES PRIVATE LIMITED',
    'MENKOL INDUSTRIES PRIVATE LIMITED',
    'ACDC POWERCARE PRIVATE LIMITED',
    'SHAREMATE INTERNET PRIVATE LIMITED',
    'HEC INFRA PROJECTS LIMITED',
    'NOTATION SOFTWARE LABS PRIVATE LIMITED',
    'ZAPARE TECHNOLOGIES PRIVATE LIMITED',
    'DEALMONEY COMMODITIES PRIVATE LIMITED',
    'Torrent power limited',
    'Singhal fincap limited',
    'CLASSIC STRIPES PRIVATE LIMITED',
    'ORBUX FOREX & LEISURE SERVICES PRIVATE LIMITED',
    'ANNEXCY CONSULTING PRIVATE LIMITED',
    'KATAM TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'RAKE SEMICONDUCTORS PRIVATE LIMITED',
    'YQS INDIA PRIVATE LIMITED',
    'MIXTURE TECHNOLOGIES PRIVATE LIMITED',
    'REVSTART INCUBATION CENTRE',
    'DOTTAX ACCOUNTING PRIVATE LIMITED',
    'TOUGHLER HARDWARE PRIVATE LIMITED',
    'STARTOUS TECHNOLOGIES PRIVATE LIMITED',
    'MASAWORLD FOUNDATION',
    'MITTI SOCIAL INITIATIVES FOUNDATION',
    'GROOMNATURALS COSMETICS PRIVATE LIMITED',
    'SOTA SAFETY OFFICER TRAINING ACADEMY (OPC) PRIVATE LIMITED',
    'AVANTA GLOBAL ACADEMY PRIVATE LIMITED',
    'AKSHARAA CORPORATE SERVICES PRIVATE LIMITED',
    'I-CAN MENTORS PRIVATE LIMITED',
    'SKILLSPHERE EDUCATION PRIVATE LIMITED',
    'TIRUCHIRAPPALLI SMART CITY LIMITED',
    'TIRUNELVELI SMART CITY LIMITED',
    'ALSAMEER STEEL PRIVATE LIMITED',
    'VAGMINE SYSTEMS AND SALES PRIVATE LIMITED',
    'LIMITLESS INDIA IMPEX PRIVATE LIMITED',
    'INFLOCURIS CONSULTING PRIVATE LIMITED',
    'CONTROLCASE INFOSEC PRIVATE LIMITED',
    'PUNIA INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'WISHACLOUD PRIVATE LIMITED',
    'PRANVAYU AGRIBUSINESS AND RESEARCH HUB PRIVATE LIMITED',
    'FLASHMINTON INTERNATIONAL SPORTS ASSOCIATION',
    'OPX MEDICAL VISION PRIVATE LIMITED',
    'SHRI NARAYANI (KUMBAKONAM) NIDHI LIMITED',
    'HONGKE PACKAGING PRIVATE LIMITED',
    'KOALA MANAGEMENT PRIVATE LIMITED',
    'KOMARKA ADVERTISING AGENCY PRIVATE LIMITED',
    'KARRO SOLUTIONS PRIVATE LIMITED',
    'NISHKA BIOTECH PRIVATE LIMITED',
    '3 BIGG DOGS MARKETING INDIA PRIVATE LIMITED',
    'NORMAN ALTERNATE RECYCLING PRIVATE LIMITED',
    'DR. K. SRIDHHAR HEALTHCARE PRIVATE LIMITED',
    'SUNAINI ANGELS PRIVATE LIMITED',
    'JASAM TECHNOLOGIES PRIVATE LIMITED',
    'EKYAA GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'INTEGRATED RELIABILITY SERVICES PRIVATE LIMITED',
    'SHURE AUDIO TECHNOLOGIES PRIVATE LIMITED',
    'FICOSA INDIA ENGINEERING CENTER PRIVATE LIMITED',
    'SARVIKA INFOTECH PRIVATE LIMITED',
    'INCREDIBLE WEDDINGS PRIVATE LIMITED',
    'REPOS CORPORATE SERVICES PRIVATE LIMITED',
    'VIVOXA MARKET ANALYTICS PRIVATE LIMITED',
    'PTS EDUCATION (OPC) PRIVATE LIMITED',
    'OFFER18 TRACKING PLATFORM PRIVATE LIMITED',
    'ACUMEC TECHNO SERVICES PRIVATE LIMITED',
    'CHILL CREATIVE SERVICES PRIVATE LIMITED',
    'EQUALSIGN FOUNDATION',
    'ENDURANCE EDUTORIAL PRIVATE LIMITED',
    'ADTA ACADEMY PRIVATE LIMITED',
    'SRI GAJANAN CELLULAR PRIVATE LIMITED',
    'FREAVEN TECHNOLOGY PRIVATE LIMITED',
    'DHANVIR INDUSTRIES PRIVATE LIMITED',
    'MANIFEST LABS PRIVATE LIMITED',
    'EMHA PRODUCTS PRIVATE LIMITED',
    'ANAROCK GROUP BUSINESS SERVICES PRIVATE LIMITED',
    'EAZY ASSETS PRIVATE LIMITED',
    'SYNTAGS CONSULTANCY AND SERVICES PRIVATELIMITED',
    'SAFERIVER REVIVAL SYSTEMS PRIVATE LIMITED',
    'AEVUM CONSULTING SERVICES PRIVATE LIMITED',
    'ANTARIKSH WASTE VENTURES PRIVATE LIMITED',
    'MCPP INDIA PRIVATE LIMITED',
    'GLOBAL NETWORKS PRIVATE LIMITED',
    'VARION ADVISORS ANALYTICS PRIVATE LIMITED',
    'NAMAMI HOSPITALITY PRIVATE LIMITED',
    'VALKAM ONLINE SERVICES PRIVATE LIMITED',
    'FIORA ONLINE LIMITED',
    'READY2INNOVATE WORLDWIDE FORUM',
    'PROTEON PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'TEEZILY MARKETPLACE SERVICES PRIVATE LIMITED',
    'MT EXPO PRIVATE LIMITED',
    'HASHBOOSH DESIGNS PRIVATE LIMITED',
    'AUTIOT ENGINEERING & CONSULTING SERVICESPRIVATE LIMITED',
    'BAXTER INNOVATIONS AND BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KNOITHQ PRIVATE LIMITED',
    'HARIVU CREATIONS PRIVATE LIMITED',
    'AIYON INNOVATIONS PRIVATE LIMITED',
    'ENVITRANS PRIVATE LIMITED',
    'RADINET INFO SOLUTIONS PRIVATE LIMITED',
    'ZIVOTNI VEDA PRIVATE LIMITED',
    'SIGNOSYS TECHNOLOGY PRIVATE LIMITED',
    'OMNI ARTIFICIAL INTELLIGENCE AND ROBOTICS PRIVATE LIMITED',
    'BPMLINKS SOLUTIONS PRIVATE LIMITED',
    'SWOOPTALENT PRIVATE LIMITED',
    'AP PATIENTSENGAGE (INDIA) PRIVATE LIMITED',
    'LOGSCM E-MARKETPLACE PRIVATE LIMITED',
    'EXOLVO TECHNOLOGIES PRIVATE LIMITED',
    'MAXOHIRE CONSULTING SERVICES (I) PRIVATELIMITED',
    'MOTTO HR CONSULTING (OPC) PRIVATE LIMITED',
    'INFUSORY FUTURE TECH LABS PRIVATE LIMITED',
    'POLSKA PROJECT DEVELOPMENT & ENGINEERINGPRIVATE LIMITED',
    'HITACHI VANTARA INDIA PRIVATE LIMITED',
    'AI ASSETS HOLDING LIMITED',
    'INNOVATIOCURIS FOUNDATION OF HEALTHCARE AND EXCELLENCE',
    'PRYSMATO OPERATIONAL INTELLIGENCE PRIVATE LIMITED',
    'AVA DESIGN STUDIO (OPC) PRIVATE LIMITED',
    'ENABLING.WIN INDIA PRIVATE LIMITED',
    'KUNAL CONCEPTS INDIA PRIVATE LIMITED',
    'MARUPUDI SURENDRA BRAHMA ACADEMY',
    'NIRBANA CONJUNTO (OPC) PRIVATE LIMITED',
    'COMPOSITE INTERCEPTIVE MED-SCIENCE LABORATORIES PRIVATE LIMITED',
    'KASANA ENTERPRISES PRIVATE LIMITED',
    'SHRITIRUMALA PRODUCTION PRIVATE LIMITED',
    'JADE PETRO PRODUCTS PRIVATE LIMITED',
    'CMR WELFARE FOUNDATION',
    'NELCO SHIELDING SOLUTIONS PRIVATE LIMITED',
    'CARGOBASE SUPPORT INDIA PRIVATE LIMITED',
    'ASTONA PRIVATE LIMITED',
    'ECONOPACK INDIA PRIVATE LIMITED',
    'SANAM INDIA PRIVATE LIMITED',
    'JARVIS TECHNOS PRIVATE LIMITED',
    'KKG MANAGEMENT PRIVATE LIMITED',
    'USANA HEALTH SCIENCES INDIA PRIVATE LIMITED',
    'SAFRAN ELECTRICAL & POWER INDIA PRIVATE LIMITED',
    'NEW IT VENTURE (INDIA) PRIVATE LIMITED',
    'OPERCISE SOLUTION PRIVATE LIMITED',
    'ASUKU INDIA PRIVATE LIMITED',
    'RAY ALLEN INDIA PRIVATE LIMITED',
    'GEOLOGIX TECHNOSOFT PRIVATE LIMITED',
    'CEEKR CONCEPTS PRIVATE LIMITED',
    'GANESHI DEVI FOUNDATION',
    'CVC OPTICALS (OPC) PRIVATE LIMITED',
    'ZWAYLO SQUAD PRIVATE LIMITED',
    'INTELLIVOLT INFRASERVICES PRIVATE LIMITED',
    'EDITORJI TECHNOLOGIES PRIVATE LIMITED',
    'SUKE RETAIL INDIA PRIVATE LIMITED',
    'VINAYAKAM FASHIONHUT PRIVATE LIMITED',
    'INSTAPROCURE TECH INDIA PRIVATE LIMITED',
    'JABIT SOFT PRIVATE LIMITED',
    'KUCHVI CONSULTING PRIVATE LIMITED',
    'CONSEGIC CORPORATE SERVICES PRIVATE LIMITED',
    'SHIPOARS SHIPPING PRIVATE LIMITED',
    'ARCADE VISAS SERVICES PRIVATE LIMITED',
    'UNENDLICHE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SHAPEIT CONSULTING PRIVATE LIMITED',
    'PEPPYSKINOID PRIVATE LIMITED',
    'TIRANGA DESIGNS PRIVATE LIMITED',
    'CAPTIVO INSIGHTS PRIVATE LIMITED',
    'DEPANSUM SOLUTIONS PRIVATE LIMITED',
    'CARGONEXT SCM PRIVATE LIMITED',
    'CANS, CLOSURES AND LIDS MANUFACTURING PRIVATE LIMITED',
    'NEW DELHI ADVISORS PRIVATE LIMITED',
    'CGA ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'SPATIAL-EYES PRIVATE LIMITED',
    'SMC PUBLISHER AND DISTRIBUTORS PRIVATE LIMITED',
    'ATOMICLAUNCH SOLUTIONS PRIVATE LIMITED',
    'GILBANE BIOCHEM PRIVATE LIMITED',
    'RAINFOREST VENTURE NETWORK PRIVATE LIMITED',
    'MASTER FLOORS INDIA PRIVATE LIMITED',
    'KONUNGUR PHARMACEUTICAL PRIVATE LIMITED',
    'NEW EMERGING WORLD OF JOURNALISM LIMITED',
    'PH INSTRUMENTS PRIVATE LIMITED',
    'PRASHI WEALTH ADVISORY PRIVATE LIMITED',
    'FETCH CONSULTING PRIVATE LIMITED',
    'DEW LIFECARE PRIVATE LIMITED',
    'A-ONE ORGANIC PIGMENTS PRIVATE LIMITED',
    'ASWAFORCE PRIVATE LIMITED',
    'WEBCHANAKYA PRIVATE LIMITED',
    'THUNDERWELL INDIA PRIVATE LIMITED',
    'COGNYTE ANALYTICS INDIA PRIVATE LIMITED',
    'GMO MEDIA PRIVATE LIMITED',
    'MYSCHOOLSTUFFSOLUTIONS PRIVATE LIMITED',
    'EASY SELL SERVICE PRIVATE LIMITED',
    'MERAKI MARCOM PRIVATE LIMITED',
    'WORKWINGS ACCELERATORS PRIVATE LIMITED',
    'PEENAK BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SMCL MARINE CONSULTING PRIVATE LIMITED',
    'SANNESH ENTERPRISES PRIVATE LIMITED',
    'BUFFETTI INDIA PRIVATE LIMITED',
    'INTIGNIS MEDIA PRIVATE LIMITED',
    'BUSY BEE OVERSEAS PRIVATE LIMITED',
    'QUANTUMSOFTECH R&D PRIVATE LIMITED',
    'ARVIKA WEALTH CONSULTANCY PRIVATE LIMITED',
    'VERIZIT DATA TECHNOLOGIES PRIVATE LIMITED',
    'TRANSECUR TELEMATICS PRIVATE LIMITED',
    'ENTERO HEALTHCARE SOLUTIONS LIMITED',
    'PAPYRUS PROJECT MANAGEMENT PRIVATE LIMITED',
    'ZIMYO CONSULTING PRIVATE LIMITED',
    'SSDVANI DELIVERY PRIVATE LIMITED',
    'CUAD CONSULTING & TECHNOLOGIES PRIVATE LIMITED',
    'NIRDESA NETWORKS PRIVATE LIMITED',
    'SUPARNAS MANAGEMENT CONSULTING PRIVATE LIMITED',
    'NEUU LABS PRIVATE LIMITED',
    'NAQ FOODS INDIA PRIVATE LIMITED',
    'NIGHT JAR FREIGHT PRIVATE LIMITED',
    'CENTER FOR EXECUTIVE EDUCATION ECONOMICS& MANAGEMENT INDIA PRIVATE LIMITED',
    'PROXIMA ADVERTISING SOLUTION PRIVATE LIMITED',
    'CROSS TRADE SHIPPING PRIVATE LIMITED',
    'ACS ENGITECH PRIVATE LIMITED',
    'ANAROCK CAPITAL ADVISORS PRIVATE LIMITED',
    'JEEL ELITE EVENT MANAGEMENT PRIVATE LIMITED',
    'CAPEVIEW INVESTMENT MANAGERS PRIVATE LIMITED',
    'GURUPRASAD VENTURES PRIVATE LIMITED',
    'CUBEFORE SOLUTIONS PRIVATE LIMITED',
    'PRAGNASRI SYSTEMS PRIVATE LIMITED',
    'OPTIMUM INFORMATICS PRIVATE LIMITED',
    'UMWELT PEOPLETECH SOLUTIONS PRIVATE LIMITED',
    'JAZARI RESEARCH INSTITUTE OF ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'TULSA COMBUSTION & INFRASTRUCTURE PRIVATE LIMITED',
    'RDG BROADBAND PRIVATE LIMITED',
    'JAISALMER ADVENTURES PRIVATE LIMITED',
    'TUCSI FOUNDATION',
    'GUNSITE SERVICES PRIVATE LIMITED',
    'MNC CORPORATE SYSTEM INDIA PRIVATE LIMITED',
    'INTERNATIONAL ENERGY SUPPORT INDIA PRIVATE LIMITED',
    'MUHAMMADAR-RAHMAN CONSULTANCY PRIVATE LIMITED',
    'KONDGO INDIA (OPC) PRIVATE LIMITED',
    'BILLENNIUM DIVAS PRIVATE LIMITED',
    'YSP AGRI TECH PRIVATE LIMITED',
    'NEXTECH AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'MAGBINI HEAT SOLUTIONS PRIVATE LIMITED',
    'HANBIT TAISEI WATER SOLUTIONS PRIVATE LIMITED',
    'IYALIA ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED',
    'ESSEH TURNKEY EPC PRIVATE LIMITED',
    'RIEET TECHNO SOLUTIONS PRIVATE LIMITED',
    'ZEITIG TRADING SOLUTIONS PRIVATE LIMITED',
    'KONCEPT WINGS GLOBAL PRIVATE LIMITED',
    'KINNTEGRA WEALTH PRIVATE LIMITED',
    'FRIGERIO CONSERVA ALLANA PRIVATE LIMITED',
    'NATIONAL FERTILIZERS LIMITED',
    'WELSPUN LIVING LIMITED',
    'FUTURE LIFESTYLE FASHIONS LIMITED',
    'NAGARJUNA FERTILIZERS AND CHEMICALS LIMITED',
    'INGRAM MICRO INDIA PRIVATE LIMITED',
    'PROCTER & GAMBLE HOME PRODUCTS PRIVATE LIMITED',
    'FIAT INDIA AUTOMOBILES PRIVATE LIMITED',
    'INDUS TOWERS LIMITED',
    'HOAC FOODS INDIA LIMITED',
    'SANKETHI NUTRIMENTS PRIVATE LIMITED',
    'CAMPUS FORTIFY PRIVATE LIMITED',
    'MAA OM BUSINESS ENTERPRISES PRIVATE LIMITED',
    'CARMEL SPICES PRIVATE LIMITED',
    'NEURONET BOTS PRIVATE LIMITED',
    'HELKIN INDUSTRIES PRIVATE LIMITED',
    'SIMPLEWORKS ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'SADHANA ITNET SECURITY & SYSTEMS PRIVATELIMITED',
    'NOQUEUE TECHNOLOGIES PRIVATE LIMITED',
    'SUREVIN WEARTECH PRIVATE LIMITED',
    '5 STAR CONMAT PRIVATE LIMITED',
    'THEWOWBOX INDIA PRIVATE LIMITED',
    'STONEFLEX PRIVATE LIMITED',
    'SHOOTDART SOLUTIONS PRIVATE LIMITED',
    'COVALENSE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PROERPMINDS INDIA PRIVATE LIMITED',
    'IMAGNUM HEALTHCARE SOLUTION PRIVATE LIMITED',
    'AISECURE SOLUTIONS PRIVATE LIMITED',
    'ORENNDA GLOBAL CONSULTING PRIVATE LIMITED',
    'HWA NEE TECH SYSTEM PRIVATE LIMITED',
    'VANDAG HOSPITALITY PRIVATE LIMITED',
    'REDDHIPPO PRIVATE LIMITED',
    'OPTIPRENEUR SOFTWARE AND SERVICES PRIVATE LIMITED',
    'SAMIRAN UDYOG PRIVATE LIMITED',
    'ALLUVIUM IOT SOLUTIONS PRIVATE LIMITED',
    'QUADPLAY NETWORK SOLUTIONS PRIVATE LIMITED',
    'EMVIDYA EDUVATIONS INDIA PRIVATE LIMITED',
    'HOOS FOOD PRIVATE LIMITED',
    'AVIUS TECH PRIVATE LIMITED',
    'JM CINEPLEX PRIVATE LIMITED',
    'APAK SOLUTIONS PRIVATE LIMITED',
    'SCULP SOFTECH PRIVATE LIMITED',
    'RESOLUTE AI SOFTWARE PRIVATE LIMITED',
    'SIMPLIFAI COGNITIVE SERVICES PRIVATE LIMITED',
    'TATHAGATA INFOTECH PRIVATE LIMITED',
    'OPENSPACE SERVICES PRIVATE LIMITED',
    'MIMAS INFOTECH PRIVATE LIMITED',
    'PRIMATHON TECHNOLOGY VENTURES PRIVATE LIMITED',
    'FIRMUSOFT HPC SOLUTIONS PRIVATE LIMITED',
    'BETECHIE IT SOLUTIONS (OPC) PRIVATE LIMITED',
    'DEEPGRID DATA CENTER PRIVATE LIMITED',
    'DEVBOX SOFTWARE PRIVATE LIMITED',
    'CADS MAKEITBIM PRIVATE LIMITED',
    'JEMOND ANTICOR PRIVATE LIMITED',
    'SAMPANNATA HEALTH AND FOODS PRIVATE LIMITED',
    'REYGUR INDIA PRIVATE LIMITED',
    'DESIGNCO PRIVATE LIMITED',
    'AGIRO TECHNOLOGIES PRIVATE LIMITED',
    'KOIND FOODS PRIVATE LIMITED',
    'INDO BENNSYS PRIVATE LIMITED',
    'ZN MOBILITY PRIVATE LIMITED',
    'NOVARCH CONSULTANTS INDIA PRIVATE LIMITED',
    'REDEFINE EXPRESS PRIVATE LIMITED',
    'QOALIFE HEALTHWAYS PRIVATE LIMITED',
    'CARTHAGINIAN VENTURES PRIVATE LIMITED',
    'LEADING PURPOSE CAMPAIGNS (INDIA) PRIVATE LIMITED',
    'ICMAI REGISTERED VALUERS ORGANISATION',
    'FOUNDATION FOR COMMUNITY CONSENSUS',
    'SKN HEALTHCARE PRIVATE LIMITED',
    'WEBDYN INDIA PRIVATE LIMITED',
    'TREZOR FASHION PRIVATE LIMITED',
    'WINDHAWK INNOVATIONS PRIVATE LIMITED',
    'ARTIFICIAL COGNITION RESEARCH PRIVATE LIMITED',
    'KAS INSTITUTE OF RESEARCH PRIVATE LIMITED',
    'KOOL KRAFT ENGINEERS PRIVATE LIMITED',
    'ADANI ROAD TRANSPORT LIMITED',
    'DOORS BRAND SOLUTIONS & MEDIA PRIVATE LIMITED',
    'MADODI GLOBAL PRIVATE LIMITED',
    'STRATUS ENVIRONMENTAL PRIVATE LIMITED',
    'HAPPY MINDS CONSULTING SERVICES PRIVATE LIMITED',
    'ARTHA NATURALS PRIVATE LIMITED',
    'FENNEL LIVING PRIVATE LIMITED',
    'EVENMANI SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED',
    'SS DIGITAL SOLUTIONS PRIVATE LIMITED',
    'EMMBROS OVERSEAS LIFESTYLE PRIVATE LIMITED',
    'EREN CRYOGEL INDIA PRIVATE LIMITED',
    'ANYADWORD INDIA PRIVATE LIMITED',
    'GHANGOP APPARELS PRIVATE LIMITED',
    'CLOUDIT BACK OFFICE SERVICES PRIVATE LIMITED',
    'SUNGROW DEVELOPERS INDIA PRIVATE LIMITED',
    'CAPRELO MOBILITY SERVICES INDIA PRIVATE LIMITED',
    'FUTECH INTERNET PRIVATE LIMITED',
    'FORPLANET INGREDIENTS PRIVATE LIMITED',
    'DWARAKADISH SPORTING PRIVATE LIMITED',
    'AVINYA LIFESCIENCES PRIVATE LIMITED',
    'INFERNO E- COMMERCE PRIVATE LIMITED',
    'PINNAXIS IT SOLUTIONS AND CONSULTING PRIVATE LIMITED',
    'ROVIA SOLUTIONS PRIVATE LIMITED',
    'AVIGATION INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'GOLDEN EPAULETTES AVIATION PRIVATE LIMITED',
    'EDDHUB TECHNOLOGIES PRIVATE LIMITED',
    'ABHIGNA MACHINERIES PRIVATE LIMITED',
    'BIOMAX SAFETY AND SECURITY SYSTEMS PRIVATE LIMITED',
    'FIRSTMERIDIAN BUSINESS SERVICES LIMITED',
    'CAHOOT HEALTHCARE PRIVATE LIMITED',
    'SKYLARK FACILITY SERVICES PRIVATE LIMITED',
    'KUDZUINFOTECH PRIVATE LIMITED',
    'EK7 SOFTECH ANALYTICS PRIVATE LIMITED',
    'HABOG CONSULTANTS PRIVATE LIMITED',
    'JASSBYS EVENTS AND LOYALTY SOLUTIONS PRIVATE LIMITED',
    'NEXTELEMENT PRIVATE LIMITED',
    'VIRAASATH EXIM INDIA PRIVATE LIMITED',
    'CLEAR COMM INDIA DISTRIBUTORS PRIVATE LIMITED',
    'EUROPAMARK GLOBAL PRIVATE LIMITED',
    'FUREIN CONSTRUCTION ENGINEERING PRIVATE LIMITED',
    'WOLVES RECRUITMENT AND STAFFING PRIVATE LIMITED',
    'I2LC PRIVATE LIMITED',
    'WONE CREATIONS PRIVATE LIMITED',
    'RAWLPLUG PRODUCTS AND SERVICES INDIA PRIVATE LIMITED',
    'COUTURE AI PRIVATE LIMITED',
    'ISHAVI OPTRONIX PRIVATE LIMITED',
    'DIGITALBRAINS APP PRIVATE LIMITED',
    'TERRA BESPOKE BUILD PRIVATE LIMITED',
    'TRIUNE BUSINESS VENTURES PRIVATE LIMITED',
    'MYANATOMY INTEGRATION PRIVATE LIMITED',
    'PALLMALL PROPERTY EXPERTS PRIVATE LIMITED',
    'ADDPLANS SERVICES INDIA PRIVATE LIMITED',
    'SUNRISING STAFFING SERVICES PRIVATE LIMITED',
    'SCIENTIFIC RESEARCH SOLUTION PRIVATE LIMITED',
    'VERAPOLY NAVADARSAN EDUCATION NIDHI LIMITED',
    'BETTER PLACE TOURISM PRIVATE LIMITED',
    'OGGLE INTERIOR PRIVATE LIMITED',
    'SEVEN SIGMA HEALTHCARE SOLUTIONS PRIVATELIMITED',
    'DATHATHREYA HEALTH INSTITUTION PRIVATE LIMITED',
    'FACSO INTERNATIONAL PRIVATE LIMITED',
    'TWENTY EIGHT MEDIA PRODUCTIONS PRIVATE LIMITED',
    'MICROMIX LEARNING PRIVATE LIMITED',
    'SAMYAK BAZAAR PRIVATE LIMITED',
    '4CUBE TAILOR-MADE VOYAGES PRIVATE LIMITED',
    'SURAJDADA GREEN ENERGY PRIVATE LIMITED',
    'ADIENT ARVIND AUTOMOTIVE FABRICS INDIA PRIVATE LIMITED',
    'JALONGI RETAIL PRIVATE LIMITED',
    'MKN SKILL FORCE PRIVATE LIMITED',
    'SHEKHAWATI SOLAR POWER PRIVATE LIMITED',
    'UNITE STRANGERS PRIVATE LIMITED',
    'ACCURIO HEALTH PRIVATE LIMITED',
    'ZOE NUTRITION PRIVATE LIMITED',
    'SOVITRON INTERIORS PRIVATE LIMITED',
    'ARGUS COMPLIANCE INDIA PRIVATE LIMITED',
    'SOJO PLASTICS PRIVATE LIMITED',
    'SBRV AUTO COMPONENTS PRIVATE LIMITED',
    'THROTTLE SHROTTLE MOTO CAFE PRIVATE LIMITED',
    'RAYLOG AUTONETICS PRIVATE LIMITED',
    'JABM ONESOURCE PRIVATE LIMITED',
    'PARKER OVERSEAS PRIVATE LIMITED',
    'BIZOPLE SOLUTIONS PRIVATE LIMITED',
    'BIOCLIQ TECHNOLOGIES PRIVATE LIMITED',
    'PRABHI BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUCCESS ENABLERS PRIVATE LIMITED',
    'ASYMPTOTE DESIGN PRIVATE LIMITED',
    'SHANKH ADZONE PRIVATE LIMITED',
    'EXIDA CONSULTING INDIA PRIVATE LIMITED',
    'KESHET MEDIA PRIVATE LIMITED',
    'ONFIDO SERVICES INDIA PRIVATE LIMITED',
    'MERIEUX NUTRISCIENCES INDIA PRIVATE LIMITED',
    'MVVS MARITIME FOUNDATION',
    'ATUOFERT AGRIMATIONS EQUIPMENTS (OPC) PRIVATE LIMITED',
    'UNIVERSAL FIRE AND SAFETY SERVICES LIMITED',
    'ADAPT IDEATIONS PRIVATE LIMITED',
    'BOXLNG PRIVATE LIMITED',
    'GAP DATA LOGGERS PRIVATE LIMITED',
    'ZARSAI LOGISTICS PRIVATE LIMITED',
    'METAPIXEL STUDIOS PRIVATE LIMITED',
    'TANUN ELECTRICAL ENGINEERING WORKS PRIVATE LIMITED',
    'UGAOO AGRITECH PRIVATE LIMITED',
    'VAN GREEN TECHNOLOGY INFRA PRIVATE LIMITED',
    'PORBANDAR JETPUR TOLLWAY PRIVATE LIMITED',
    'VIJAY POWERCONTROL SYSTEMS PRIVATE LIMITED',
    'FABSPIN DRY CLEANERS PRIVATE LIMITED',
    'ZALZA CLOTHING PRIVATE LIMITED',
    'BAMANBORE TOLLWAY PRIVATE LIMITED',
    'GESCRAP INDIA PRIVATE LIMITED',
    'TRIDHAATU RENOVATORS PRIVATE LIMITED',
    'GLOBALTRIP HOLIDAYS PRIVATE LIMITED',
    'BRAINYACCOUNTANT SOLUTIONS PRIVATE LIMITED',
    'C4 INTEGRATED WELLNESS PRIVATE LIMITED',
    'BIHAR STATE EDUCATION FINANCE CORPORATION LIMITED',
    'LRS IT PRIVATE LIMITED',
    'PRAGMATISCH SOLUTIONS PRIVATE LIMITED',
    'ANVENTA GADGETIX PRIVATE LIMITED',
    'GIANTVIEW PRIVATE LIMITED',
    'GO ALUBUILD PRIVATE LIMITED',
    'HYDRAULIQUE PRODUCTION SYSTEMS INDIA PRIVATE LIMITED',
    'GLS ENGINEERING INDIA LIMITED',
    'HAMPUS INFRASTRUCTURE PRIVATE LIMITED',
    'PRAYOG SOCIAL FOUNDATION',
    'MEGAPHONE SOLUTIONS (OPC) PRIVATE LIMITED',
    'POLMON PROCESS CONTROLS PRIVATE LIMITED',
    'KANSAL MEDICAL SYSTEMS PRIVATE LIMITED',
    'REKARD LIVE PRIVATE LIMITED',
    'HOLISTIC MEDIA SERVICES PRIVATE LIMITED',
    'HOWZAT GAMES PRIVATE LIMITED',
    'SALTWORTH HOSPITALITY PRIVATE LIMITED',
    'LUMEDROID TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GLS STEEL INDIA LIMITED',
    'ORANGEBUCKET PLANNERS PRIVATE LIMITED',
    'CELES INDUSTRIES PRIVATE LIMITED',
    'KINNECT MEDIA PRIVATE LIMITED',
    'WESTCOURT REAL ESTATE ADVISORY PRIVATE LIMITED',
    'MOMENTSNAP INDIA PRIVATE LIMITED',
    'BEDIOT ATTRIBUTES PRIVATE LIMITED',
    'AFFLUENCE DIGITAL SOLUTIONS INDIA PRIVATE LIMITED',
    'GO4WEALTH INDIA PRIVATE LIMITED',
    'KANCHARLA & GIRIDHARI HOMES PRIVATE LIMITED',
    'AYUSH PROCON PRIVATE LIMITED',
    'Bansari agro tech private limited',
    'Bhargava agro foods private limited',
    'Greenzone agrotech private limited',
    'Trikaya township private limited',
    'Indigroz agricultural services private limited',
    'Simply fresh private limited',
    'Culinare agri ventures private limited',
    'Aadhimalai pazhangudiyinar producer company limited',
    'Ratnadwip agro india limited',
    'Sadashib cold storage private limited',
    'Bcil harvest private limited',
    'Barunei farm and nature resorts private limited',
    'Mac wood india pvt ltd',
    'Shishira prints private limited',
    'Kraft-hydrotec private limited',
    'Castle rock fisheries private limited',
    'Mangalore minerals private limited',
    'NECO MINING COMPANY PRIVATE LIMITED',
    'Aumsri coke india private limited',
    'Pegasus minerals and metalloys private limited',
    'Sidhant udyog private limited',
    'Aquarius estates private limited',
    'Pioneer khadan products private limited',
    'Poabs granite products private limited',
    'Land and maritime services private limited',
    'Indian quartzite private limited',
    'Ekamukhi minerals private limited',
    'Getech electronics private limited',
    'Jaipur marble emporium private limited',
    'Cherry agencies private limited',
    'Indo-spanish tasty foods private limited',
    'NPS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ARYAN FOOD INGREDIENTS LIMITED',
    'Ahuja roller flour mill private limited',
    'GIANI',
    'S BUILDERS AND DEVELOPERS(INDIA) PRIVATE LIMITED',
    'Appolo infraprojects limited',
    'Gandhali constructions private limited',
    'Hda buildcon private limited',
    'Spar geo infra private limited',
    'Smita properties and investments pvt ltd',
    'Ivrcl chengapalli tollways limited',
    'VADODARA BHARUCH TOLLWAY LIMITED',
    'Synergy development corporation private limited',
    'Sunsource builders pvt ltd',
    'Satguru premises private limited',
    'Shakun buildhome private limited',
    'Tuscan real estate private limited',
    'Grass field fire buildcon private limited',
    'Sna infratech private limited',
    'Adarsh ecstasy projects private limited',
    'Golflinks software park private limited',
    'Venkatesh agro estates private limited',
    'Loni builders private limited',
    'Horizon contracts private limited',
    'Radhegovindkripa developers private limited',
    'Newhigh developers private limited',
    'BRAND INDIA INFRASTRUCTURE PRIVATE LIMITED',
    'Unison infratech private limited',
    'Spark realcon private limited',
    'Cosmos infracon private limited',
    'Raghu raj palace private limited',
    'B. n. habitat private limited',
    'Paras propmart private limited',
    'Pyramid infratech private limited',
    'Sadhvi infradevelopers private limited',
    'Lgcl realty private limited',
    'Singhal contractors & builders pvt ltd',
    'Sarvottam properties pvt ltd',
    'Core metal krafts ltd',
    'Prime cardiac care private limited',
    'Mani pushpak nirman pvt ltd',
    'Unicorn enclave private limited',
    'Unicorn plaza private limited',
    'Accenture tower private limited',
    'Aashiyana constructions private limited',
    'Panorama enclave private limited',
    'Excel nirman private limited',
    'Subham realty private limited',
    'Subham estates private limited',
    'Mvk nirman private limited',
    'Pratik realcon private limited',
    'Maa ambe realtors private limited',
    'Piyush builders pvt ltd',
    'EMOTE CAPITAL LIMITED',
    'EMOTE FINANCE PRIVATE LIMITED',
    'Amita properties private limited',
    'Lakhdatar realty private limited',
    'Anubhavi realtors private limited',
    'Martina properties pvt ltd',
    'Rajdhani housing complex pvt ltd',
    'Ditya procon private limited',
    'Apeksha nirman private limited',
    'Wavelength builders private limited',
    'Sunroof enclave private limited',
    'Uplift builders private limited',
    'Uplift developers private limited',
    'Uplift enclave private limited',
    'Uplift residency private limited',
    'Trafalgar realty private limited',
    'Shroff developers private limited',
    'Relhuds pvt ltd',
    'Murti housing & finance pvt.ltd.',
    'Gangesh properties pvt ltd',
    'Saksham infrastructure private limited',
    'Optus developers private limited',
    'H m logistics private limited',
    'Outreach consultants private limited',
    'Bizprout corporate solutions private limited',
    'VIRTUS DISTRIBUTORS AND SERVICES PRIVATE LIMITED',
    'Akshaya wealth management private limited',
    'Crafitti consulting private limited',
    'Excetra workspace solutions private limited',
    'Ven consulting india private limited',
    'Procon tech consultants private limited',
    'Tecnimont Private Limited',
    'DATAMATICS BUSINESS SOLUTIONS LIMITED',
    'Multilink management consultants private limited',
    'Concept management consulting limited',
    'Advanced prakruti farms private limited',
    'Chlorophyll brand and communications consultancy private ltd.',
    'Choice consultancy private limited',
    'Unisearch consultants private limited',
    'Varmera resources private limited',
    'Tresvista financial services private limited',
    'Enarr advisors private limited',
    'Plada services & management private limited',
    'Asp investment consultants private limited',
    'Ergoform consulting private limited',
    'Ecommerce consultants private limited',
    'HUSYS CONSULTING Limited',
    'Zamstars management services (india) private limited',
    'Management and governance consulting private limited',
    'Netscape consultants & services private limited',
    'Lakshya strategic consultants private limited',
    'Tmi staffing services private limited',
    'Panorama advisors private limited',
    'D r design consultants private limited',
    'Seed engineering consultants private limited',
    'Narsi interior infrastructures private limited',
    'Architect narrayan & associates private limited',
    'Mimics east technologies private limited',
    'Cache peripherals private limited',
    'Ready soft private limited',
    'Trc engineering (india) private limited',
    'S d beverages private limited',
    'Hentech agrovet private limited',
    'Paras surti products private limited',
    'Akm global textile private limited',
    'Dhanshree fashions private limited',
    'LA-GAJJAR MACHINERIES PRIVATE LIMITED',
    'Chiripal industries limited',
    'Pratibha syntex limited',
    'Cibi textiles private limited',
    'B a fabricators and engineers private limited',
    'Sri lakshmi kantha spinners limited',
    'Thirupur suriya textiles private limited',
    'Tarapur synthetics private limited',
    'Sekhsaria impex private limited',
    'Corporate fashion private limited',
    'Hocage home decor private limited',
    'Om pile private limited',
    'Bhagwati paridhan private limited',
    'Meera threads private limited',
    'Sneha elastics private limited',
    'Ramgopal textiles limited',
    'Ramgopal synthetics limited',
    'Citizen fabrics private limited',
    'Gulab textile processors private limited',
    'Climax suiting private limited',
    'Fab international private limited',
    'D.n.h. spinners private limited',
    'Sattik textile private limited',
    'Namoshivai apparels private limited',
    'Bafna clothing company private limited',
    'Deegee cotsyn private limited',
    'Nallisilk creations private limited',
    'Kalanikethan textiles and retails (india) private limited',
    'Sports education development india limited',
    'Nasha designs india private limited',
    'S h apparels exim private limited',
    'Crystal knitters private limited',
    'Modish knitwears private limited',
    'Teamwork apparels private limited',
    'Procare ventures international private limited',
    'Screen-o-tex (india) private limited',
    'Mamta fabrics private limited',
    'Furore apparels india private limited',
    'Sefar india private limited',
    'Peches lifestyles private limited',
    'Mayflower exports private limited',
    'Nce fashions private limited',
    'Fedmac exports private limited',
    'Shreyshree selections private limited',
    'Rockstar fashions india private limited',
    'Contemporary leather private limited',
    'Maadhav overseas private limited',
    'Ryder india private limited',
    'Moravia tradeline private limited',
    'M.v.a leather works private limited',
    'Maypar leather manufacturing company private limited',
    'Prime international india private limited',
    '3DIMENSION CAPITAL SERVICES LIMITED',
    'UMANG BOARDS LIMITED',
    'Monal laminate private limited',
    'Shwet interior private limited',
    'Elrhino eco industries private limited',
    'VAMSHADHARA PAPER MILLS LIMITED',
    'Clearpack india private limited',
    'Tetra-pak india private limited',
    'AGROMATIC FOODS PRIVATE LIMITED',
    'Reyansh trade private limited',
    'Raj barcode systems private limited',
    'Sumeru labels pvt ltd',
    'VIKHYAT TECHNOLOGIES PRIVATE LIMITED',
    'Movie mag (india) private limited',
    'Aristo packers private limited',
    'Quest books company private limited',
    'Hhp broadcasting services private limited',
    'Mpcr broadcasting service private limited',
    'Ubj broadcasting private limited',
    'Kaleido communications private limited',
    'Sohum digi arts private limited',
    'Screen printers association of india',
    'Digital strategies cd printing private limited',
    'Kinige digital technologies private limited',
    'Imagic digital print services private limited',
    'True color digital private limited',
    'Cubes media & branding private limited',
    'Witmans petrochem private limited',
    'Arihant inorganics process private limited',
    'Hi-tech newchem private limited',
    'Altus hygienic products private limited',
    'OX-NRICH PRIVATE LIMITED',
    'Process plant and machinery association of india',
    'Onkology kombine private limited',
    'Arasan chemicals private limited',
    'AMEYA PRODUCTS AND SERVICES PRIVATE LIMITED',
    'Escientia advanced sciences private limited',
    'Sri sansar resources limited.',
    'Mahavir expochem limited',
    'A l a chemicals private limited',
    'Asian chemicls works (bombay) private limited',
    'Omtech chemical industries private limited',
    'Precise chemipharma p ltd',
    'Man realty limited',
    'VOGATT UNIVERA ASSOCIATES PRIVATE LIMITED',
    'Imax infra reality private limited',
    'Devendra buildcon private limited',
    'Sejal infraprojects private limited',
    'Ranjit life space private limited',
    'KARN BUILDERS & DEVELOPERS LIMITED',
    'Team one infra consultants private limited',
    'Hillpoint building solutions private limited',
    'Honey constructions pvt. ltd.',
    'Unicorn buildcon private limited',
    'Pragati 47 aerotropolis projects limited',
    'Ultimate abasan private limited',
    'Diagram estates private limited',
    'Rosewood exports private limited',
    'SHRIYA HOMES & VATIKAS PRIVATE LIMITED',
    'Om ultimate techno india private limited',
    'Spirited auto cars (i) limited',
    'Sgj motors private limited',
    'Sathya auto private limited',
    'Varun infra ventures private limited',
    'Friendly automotives (india) private limited',
    'Shashti car private limited',
    'Petronas lubricants (india) private limited',
    'Ace petro networks india private limited',
    'Vadilal marketing pvt ltd',
    'Arrow sales private limited',
    'Sw commodities private limited',
    'Avirat impex private limited',
    'Euro stone private limited',
    'Helpline impex private limited',
    'Hadoti mining and exports pvt. ltd.',
    'Rasavi enterprises private limited',
    'Onondaga agro investments private limited',
    'Sri gomat staragencies private limited',
    'V resources india pvt ltd',
    'Aapt distribution private limited',
    'Metals and metal electric p ltd',
    'Goodwill metal trading private limited',
    'RIIS INDIA IT SOLUTIONS PRIVATE LIMITED',
    'PRIME FRESH LIMITED',
    'Anand autotrade private limited',
    'JOLLY SPINNERS PRIVATE LIMITED',
    'Great fortune trading private limited',
    'Knowell realtors (india) private limited',
    'TRAVEL FOOD WORKS PRIVATE LIMITED',
    'GURUPRAGYA TRADERS PRIVATE LIMITED',
    'Sri khanij impex private limited',
    'Broadline computer systems private limited',
    'EASTERNBULK TRADING & SHIPPING PRIVATE LIMITED.',
    'G n distributors pvt ltd',
    'Lalwani metallics pvt.ltd.',
    'Darkin cosmetics pvt ltd',
    'Aristo texcon pvt ltd',
    'Snowline vanijya limited',
    'Molisati agencies private limited',
    'Kanchan suppliers pvt ltd',
    'Srijan suppliers pvt ltd',
    'Sargam agencies pvt ltd',
    'Chitrakoot vinimay private limited',
    'Nilmani distributors private limited',
    'Tentative marketing private limited',
    'Santirup distributors private limited',
    'Flax marketing private limited',
    'Jatropower bio-trading private limited',
    'Unimarine agencies private limited',
    'Amalgam frozen foods private limited',
    'Sai nidhi sales private limited',
    'Shree kedarnath sugar and agro products limited',
    'Spark business private limited',
    'Annapurna trade solutions private limited',
    'Winmark enterprises private limited',
    'Brijlal nathmal trading private limited',
    'LAWAND MARKETING & CONSULTANCY PRIVATE LIMITED',
    'Hassoun manufactures (india) private limited',
    'Excel lifecare private limited',
    'BEZEL JEWELLERY (INDIA) PRIVATE LIMITED',
    'Hvk international private limited',
    'Chainsons imports and exports private limited',
    'Liquidgaz energy private limited',
    'Nezone ispat marketing private limited',
    'First metal trading private limited',
    'Shri nath buildtech private limited',
    'Ctpl industries private limited',
    'Cyclic chemicals limited',
    'Chifron clothing private limited',
    'Aniket polymers private limited',
    'Jak printers private limited',
    'Scovill fasteners india private limited',
    'Maxfine industries private limited',
    'Vijayavani limited',
    'SUICH INDUSTRIES LIMITED',
    'ZYDUS HEALTHCARE LIMITED',
    'Irya enterprises private limited',
    'Maskara business solutions private limited',
    'Casabella international private limited',
    'Orient eco systems private limited',
    'Sbg distributors private limited',
    'TRIGENESIS BIOSCIENCES PRIVATE LIMITED',
    'Spaceway trades private limited',
    'Grovers private limited',
    'Benchmark broadcast systems private limited',
    'Iborderless india private limited',
    'Vulcantech software india private limited',
    'Caarpus technology services private limited',
    'Highpowerv software solutions and eprojects private limited',
    'Friday solutions private limited',
    'Zilogic systems private limited',
    'Enixs technology india private limited',
    'Nanotech integrated solutions private limited',
    'Sarvajeyam solutions private limited',
    'Ace applied software services private limited',
    'Unimity solutions private limited',
    'Infomirrors technologies private limited',
    'Wire line solution (india) private limited',
    'Kovai soft technologies private limited',
    'Kovair software private limited',
    'Keeves technologies private limited',
    'Lithasa technologies private limited',
    'Glare technocons private limited',
    'Lucid infotech private limited',
    'Boatman tech private limited',
    'Vidooly media tech private limited',
    'Electrocom software private limited',
    'Inkcadre technosoft private limited',
    'Cross matrix technologies private limited',
    'TRANSUNION CIBIL LIMITED',
    'Indusgeeks solutions private limited',
    'Pacmac solution private limited',
    'Episkope infotech private limited',
    'Hk wentworth (india) private limited',
    'Mercntech (india) private limited',
    'WESTERNACHER CONSULTING PRIVATE LIMITED',
    'Heptanesia it services private limited',
    'DIGIKREDIT FINANCE PRIVATE LIMITED',
    'Infozzle software solutions private limited',
    'Web town solutions private limited',
    'Phoenix american salesfocus solutions india private limited',
    'Integr8 software products & services private limited',
    'Mailsoft solutions private limited',
    'Florida software solutions private limited',
    'Isource i.t. enabled services private limited',
    'Anycommerce chennai private limited',
    'Astutech solutions (india) private limited',
    'Funds for ngos india private limited',
    'Balishtha e tech private limited',
    'Ashtik softech private limited',
    'LIBER SOLUTIONS PRIVATE LIMITED',
    'GUENSTIGER INDIA PRIVATE LIMITED',
    'Jellybean laptop spares private limited',
    'Vagus technologies private limited',
    'Cauvesoft technologies private limited',
    'Sap bpo e-services private limited',
    'Sws financial solutions private limited',
    'Gokul vyapaar private limited',
    'Tws systems private limited',
    'Moonshot technologies private limited',
    'INNOVATIVE AGRONOMY PRIVATE LIMITED',
    'On demand agility software private limited',
    'Sarsons technologies private limited',
    'Bt e-serv (india) private limited',
    'Applied mobile labs private limited',
    'K k software private limited',
    'Satellier technologies (india) private limited',
    'Tangent infocom private limited',
    'Boomtown it services private limited',
    'Softpro webtech private limited',
    'Edge infotel private limited',
    'Xapsoft technologies private limited',
    'Desire infonet private limited',
    'Credext technologies private limited',
    'Hypernet solutions private limited',
    'Dp technologies private limited',
    'Hex wireless private limited',
    'Tecsidel india private limited',
    'Agiline india private limited',
    'Visualnet private limited',
    'Preva systems private limited',
    'Jetavi engineering private limited',
    'Alackrity consols private limited',
    'ARCADIS CONSULTING INDIA PRIVATE LIMITED',
    'Itrosys technologies private limited',
    'Pranava online tax & software solutions private limited',
    'Nikhilon india private limited',
    'Alamy images india private limited',
    'Wysetek systems technologists private limited',
    'Nadiadwala entertainment and technologies limited',
    'Ratein infotech india private limited',
    'Ameya infovision private limited',
    'Ascentek solutions private limited',
    'Genesis online technologies private limited',
    'Vencore business solutions private limited',
    'Datastream research and anlysis private limited',
    'Netsilik software private limited',
    'Qualex consulting india private limited',
    'TELEPERFORMANCE BUSINESS SERVICES INDIA LIMITED',
    'Transpacific software private limited',
    'Panacea infocom private limited',
    'Global payment networks limited',
    'Lords ishwar hotels limited',
    'Dhanada corporation limited',
    'Foods and inns limited',
    'International travel house limited',
    'Hem holdings and trading ltd',
    'Muthoot capital services limited',
    'Crisil limited',
    'Transcon research and infotech limited',
    'Chandra prabhu housing limited',
    'Datamatics global services limited',
    'ANUPAM FINSERV LIMITED',
    'Uflex limited',
    'Icra limited',
    'Indoco remedies limited',
    'Hinduja global solutions limited',
    'Plastic export zundert (india) private limited',
    'Frontech system private limited',
    'Midland credit management india private limited',
    'Hardonics infotech private limited',
    'Ellora cereals limited',
    'Oceanic spirits private limited',
    'Varun agri infra services private limited',
    'Mat bio fuel plantations private limited',
    'Ramky - midc agro processing park limited',
    'Peeyush agro tech private limited',
    'Pods biotech private limited',
    'Sequoia biosciences private limited',
    'Cobblestone river farms private limited',
    'Sara tea private limited',
    'Kamepalli agro farms private limited',
    'Zamira lifesciences india private limited',
    'Diamond chicken products private limited',
    'Deejay enterprises private limited',
    'Greenex farms india private limited',
    'Agk agro private limited',
    'Meluha agro tech private limited',
    'Yireh farms private limited',
    'Damyanti agro foods private limited',
    'Mcml projects private limited',
    'BRIO AGRI PRODUCER COMPANY LIMITED',
    'First agro tech produce private limited',
    'Ivory agricultural limited',
    'Vedacom agricultural limited',
    'Adroit agri trade private limited',
    'Modern dairymaid private limited',
    'Bhumitra farms private limited',
    'Earthbound organic farms private limited',
    'Goouksheer farm fresh private limited',
    '15HERBS ORGANIC LABS PRIVATE LIMITED',
    'Saurabh farms limited',
    'Himachal pradesh state forest development corporation limited',
    'Italtecno india private limited',
    'Keas control systems india private limited',
    'INDIA THERMAL POWER PRIVATE LIMITED',
    'Saradhi farms private limited',
    'Venus fisheries private limited',
    'Silpam trade associates private limited',
    'Kropex india private limited',
    'Apsara innovations private limited',
    'Spr developers private limited',
    'Msr infotech private limited',
    'Ozone industries private limited',
    'Parsa kente collieries limited',
    'Kipro technologies private limited',
    'Nydel resources private limited',
    'J. kumar minerals & mines (india) private limited',
    'Elan power development and mining private limited',
    'SOUTH WEST PINNACLE EXPLORATION LIMITED',
    'Prime edge infra technologies private limited',
    'Ketan infrastructure private limited',
    'Besto mining india private limited',
    'Trivedi grani marmo private ltd',
    'D.k.trivedi granites pvt.ltd.',
    'R.r.stones private limited',
    'Toshniwal granites private limited',
    'AMARDEEP MINES & MINERALS PRIVATE LIMITED (OPC)',
    'Satguru minchem private limited',
    'Saviour mines and minerals private limited',
    'Kundan pestichem pvt ltd',
    'R. k. patel food private limited',
    'Tastel fine food private limited',
    'Sme agritechs private limited',
    'Aakriti super snacks private limited',
    'Sidhartha ahaar vihar udyan private limited',
    'Artisan Spirits Private Limited',
    'Gujarat agro infrastructure mega food park private limited',
    'KAGOME FOODS INDIA PRIVATE LIMITED',
    'Plr foods private limited',
    'Smart agro food park private limited',
    'Areve foods & beverages private limited',
    'Mangala marine exim india private limited',
    'India food company private limited',
    'Uks oils private limited',
    'P9 FARMS PRIVATE LIMITED',
    'Mees and rao foods private limited',
    'BHARAT GLUCOSE PRIVATE LIMITED',
    'Vasa foods & beverages private limited',
    'Securview systems private limited',
    'Monolith technologies private limited',
    'Redivivus technologies private limited',
    'Mobimedia technology services india private limited',
    'Deva consultancy services private limited',
    'Nax technologies private limited',
    'Four global technologies private limited',
    'Ikione systems private limited',
    'Nesecure networks private limited',
    'Infoshore software private limited',
    'Veesys infosolutions private limited',
    'Microsense private limited',
    'Nordic infosoft private limited',
    'Srini infotech private limited',
    'Eosoft solutions private limited',
    'Password technologies private limited',
    'Nalin soft private limited',
    'Lera technologies private limited',
    'Satnav technologies private limited',
    'Innopark (india) private limited',
    'ORVITO SMART SYSTEMS PRIVATE LIMITED',
    'Radgov solutions (india) private limited',
    'INDUCTIVE QUOTIENT ANALYTICS INDIA PRIVATE LIMITED',
    'BRYTESIDE TECHNOLOGIES PRIVATE LIMITED',
    'Omega value add solutions private limited',
    'Vilas business solutions private limited',
    'Q ventures private limited',
    'Affluent global services private limited',
    'Unwired labs (india) private limited',
    'Genzeon technology solutions private limited',
    'Cavalier it solutions private limited',
    'ZIGNA ANALYTICS PRIVATE LIMITED',
    'Nfolks software technologies private limited',
    'Synchronize business services private limited',
    'Jkk it solutions private limited',
    'Krish met tech private limited',
    'Goldmine infotech private limited',
    'Perficient india private limited',
    'Maarga information systems private limited',
    'Balaji prakash infotek private limited',
    'Tent software private limited',
    'Sysmix infotech private limited',
    'Prodapt technology holdings private limited',
    'HIGHWAY 905 TECHNOLOGIES PRIVATE LIMITED',
    'Ninteen hour i.t. private limited',
    'Pandian systems and solutions private limited',
    'Ibda enterprises private limited',
    'CLOUD RIPPLES PRIVATE LIMITED',
    'Quebec information services india limited',
    'Brightspot technology solutions private limited',
    'Pranas technologies private limited',
    'Netosting technologies private limited',
    'Raptor technologies india private limited',
    'Compu data services private limited',
    'Sparx technologies private limited',
    'Orion edutech private limited',
    'Cozy vision infotech private limited',
    'Primal logix india private limited',
    'Linxsmart technologies private limited',
    'Incrementors web solutions private limited',
    'Newgen ites private limited',
    'Tek- noss services private limited',
    'J.j.glastronics private limited',
    'Tholons knowledge management private limited',
    'Prodintel technologies private limited',
    'Nuvepro technologies private limited',
    'Spectrum networks solutions private limited',
    'Krish9 soft link private limited.',
    'Alpha finsoft private limited',
    'Wonderbiz technologies private limited',
    'Mobiuso technologies india private limited',
    'Green enabled it solutions private limited',
    'Thinkporch solutions private limited',
    'Bill trace infotech private limited',
    'Arithmetic systems and technologies private limited',
    'Mapyn technologies private limited',
    'It keysource solutions private limited',
    'Synchroserve it solutions private limited',
    'Vestrics solutions private limited',
    'Storemate mobile solutions private limited',
    'Technology frontiers (india) private limited',
    'Future focus infotech private limited',
    'Triad software private limited',
    'Apex transcripters private limited',
    'Obsi technologies private limited',
    'Jmn investments research private limited',
    'Clasticon solutions private limited',
    'Ygen communications private limited',
    'Phasorz technologies private limited',
    'Pathfinder business analysis private limited',
    'SKYNET E-SOLUTION PRIVATE LIMITED',
    'E-dify learning systems private limited',
    'Codelogicx technologies private limited',
    'Jalagharbha technical technologies private limited',
    'Vinclis technologies private limited',
    'Ikontel solutions private limited',
    'Profinch solutions private limited',
    'Fractal analytics private limited',
    'Flyington freighters private limited',
    'Shaolin tradechem private limited',
    'MEDALLION SOCIAL INNOVATORS PRIVATE LIMITED',
    'Magnet creations private limited',
    'Sml supervalue education private limited',
    'GOEL GANGA FOUNDATION',
    'Renaissance eduction private limited',
    'RINIRA INNOVATIONS PRIVATE LIMITED',
    'Mind genius education private limited',
    'Ice creative excellence private limited',
    'Anil goyal education & medical foundation',
    'Esperanza corporate private limited',
    'Virgo educare private limited',
    'Myriaads academy of excellence',
    'Flagship eduquest solutions private limited',
    'Swanil training foundation',
    'Solutions@infinite private limited',
    'Teachwell professionnal studies institute private limited',
    'REJUVENATING SYSTEMS PRIVATE LIMITED',
    'Eduwiz consulting services private limited',
    'SACHDEV RETAIL PRIVATE LIMITED',
    'Apeejay education association pvt. ltd.',
    'Chellaram foundation',
    'Chrysaalis i-maths india private limited',
    'Indian abacus private limited',
    'ASCENSIVE EDUCARE LIMITED',
    'Visual education aids private limited',
    'MOODLE INDIA INFORMATION SOLUTIONS PRIVATE LIMITED',
    'Ketan coaching education private limited',
    'Endeavor careers private limited',
    'Lta school of beauty private limited',
    'I care learning private limited',
    'Lexicon learning private limited',
    'Satnav preschools private limited',
    'APL GLOBAL SCHOOL',
    'Global institute of intellectual property private limited',
    'Apac consultants private limited',
    'Institute of international logistics management private limited',
    'FPA EDUTECH PRIVATE LIMITED',
    'Sama diagnostics and bio-medicals private limited',
    'W SHAKTI FOUNDATION',
    'Smart health labs private limited',
    'Niramaya pathlabs private limited',
    'Aatapi seva foundation',
    'Vivo healthcare private limited',
    'Thermet solutions private limited',
    'Achilles health care private limited',
    'Sna healthcare private limited',
    'Click heal private limited',
    'Vidarbha lifecare private limited',
    'Niya healthcare private limited',
    'Shrirampur super speciality hospital private limited',
    'KIMS HOSPITAL KURNOOL PRIVATE LIMITED',
    'Bioshield lifesciences private limited.',
    'Netra medilink private limited',
    'Innovative healing systems (india) private limited',
    'Hotel stay longer private limited',
    'Zenith precision private limited',
    'Pan office systems private limited',
    'M.g.metals private limited',
    'Oysters advertising private limited',
    'K reheja hotels and estates private limited',
    'Maruthi microcomponents private limited',
    'Aum property developement private limited',
    'SOUTHERN HIGHTECH CAPITAL Private Limited',
    'Ditrita developers private limited',
    'Umbel properties private limited',
    'Canbank venture capital fund limited',
    'ANASHRI FINVEST LIMITED',
    'EMBASSY HOUSING FINANCE AND DEVELOPMENTS PRIVATE LIMITED',
    'Ken computek private limited',
    'Oscar udyog private limited',
    'D m estates private limited',
    'Appollo distilleries and breweries private limited',
    'Soukya indian holistic health centre private limited',
    'Flowserve microfinish pumps private limited',
    'Pixel infotek private limited',
    'Tungabhadra power company private limited',
    'Troilus hospitality private limited',
    'Asha medical foundation private limited',
    'Ramakrishna eye care and research private limited',
    'Total environment hospitality private limited',
    'Sunrise institute of medical sciences private limited',
    'Ratika hospital and research centre private limited',
    'Tirupatitirumala family health care pvt ltd',
    'Rajan dental institute private limited',
    'Helios hospitals private limited',
    'Neurokrish consulting private limited',
    'Femelife fertility foundation private limited',
    'Cosmopolis hospitals private limited',
    'IDK RETAIL PRIVATE LIMITED',
    'Sms multi objective organisation',
    'Anandi eco farms association',
    'Srims emergency service foundation',
    'Sreejan livelihood development',
    'Waghanna vaidyakiya seva private limited',
    'Agnivesh health care centre private limited',
    'Tulip diagnostics private limited',
    'Astrum healthcare private limited',
    'Phicus social solutions',
    'Parikrma humanity foundation',
    'Basix municipal waste ventures limited',
    'A2z waste management (jaunpur) limited',
    'ECOGREEN ENVIROTECH SOLUTIONS LIMITED',
    'Ferro scrap nigam limited',
    'Gaurav paper mills limited',
    'Umsl limited',
    'Gal aluminium extrusion private limited',
    'Ami organisers private limited',
    'Met-lok hydro pneumatics private limited',
    'Chennai metco private limited',
    'Maan metaliks private limited',
    'Murzello metal finish systems private limited',
    'MAINI PRECISION PRODUCTS Limited',
    'Ranvik exports private limited',
    'Ski retail capital limited',
    'Abaran timeless jewellery private limited',
    'Sundar metal techno private limited',
    'Bindal smelting private limited',
    'Bell huayi spinning private limited',
    'Vamaja engineering private limited',
    'D p engineering industries limited',
    'Asian iron industries private limited',
    'Mechel ferro chem private limited',
    'K & k craftsman private limited',
    'Tyche diecast private limited',
    'Sri ramanjaneya ispat private limited',
    'Pitti castings private limited',
    'Vijaya engineering private limited',
    'Sidhi vinayaka fab engineering private limited',
    'Elken steel structures private limited',
    'Dynasty plastics private limited',
    'Ncr corporation india private limited',
    'R k metal & wood products pvt ltd',
    'Navnidhi metalogs private limited',
    'Aadi structural and engineers private limited',
    'S.s.n enterprises private limited',
    'M.l.s enterprises private limited',
    'Fabsmith india private limited',
    'Chitra insultec private limited',
    'Vee yes arr metals private limited.',
    'Viral prefab industries private limited',
    'Api heat transfer india private limited',
    'Rainbow components limited',
    'Haripriya cast and forge private limited',
    'Sheer gold private limited',
    'Reform metaliks private limited',
    'Manly silicon steel private limited',
    'Hha tank terminal private limited',
    'Ksh international private limited',
    'Advanced fittings private limited',
    'Cm equipments india private limited',
    'Fabtech industries private limited',
    'FRENZELIT INDIA PRIVATE LIMITED',
    'Ratnesh ispat services private limited',
    'Urbanarch sysfab private limited',
    'Turbo industries private limited',
    'Sankalp construction (pune) private limited',
    'BANARASWALA WIRE MESH PRIVATE LIMITED',
    'E c engineers pvt ltd',
    'Bid machines private limited',
    'C-met engineering india private limited',
    'Core and core private limited',
    'Brisloy tools india private limited',
    'Dhanashri tooling systems private limited',
    'B e c chemicals private limited',
    'Dhiraj diamond tools private limited',
    'Carver welding private limited',
    'V s equipments and automations private limited',
    'Alcomex springs private limited',
    'Venu engineering services private limited',
    'Sai auto components private limited',
    'A g c scaffolding private limited',
    'Meena jewellers & diamonds private limited',
    'Kant fasteners private limited',
    'Lanson lifestyle private limited',
    'Labh projects private limited',
    'M P STEEL (INDIA) PRIVATE LIMITED',
    'FABSAFE TECHNOLOGIES PRIVATE LIMITED',
    'Forgemax auto components private limited',
    'Eagleburgmann ke private limited',
    'Aabon smit alloys private limited',
    'Taeyang metal india private limited',
    'Prescient flow control india private limited',
    'Cimec technologies private limited',
    'Navrang machinery private limited',
    'Scalene engineers private limited',
    'Nitta corporation india private limited',
    'Mr cooling solutions private limited',
    'Newage scaffolds (p) ltd',
    'Inductotherm (india) private limited',
    'Active pumps private limited',
    'Hi-tech air power private limited',
    'Rotolok valves private limited',
    'Fepl eng private limited',
    'Pro tech valves private limited',
    'Static hydraulic pvt ltd',
    'Delrin products (india) private limited',
    'Shrinag autotools private limited',
    'Tata autocomp hendrickson suspensions private limited',
    'Durr india private limited',
    'Ifb automotive private limited',
    'Aestus induction (india) private limited',
    'INDUSTRIAL CONTROLS & DRIVES (INDIA) PRIVATE LIMITED',
    'Newcon tech corporation (india) private limited',
    'Helio engineering private limited',
    'Cold point private limited',
    'Bharat diamond bourse',
    'GSD CEMENTS PRIVATE LIMITED',
    'Elegant home gallery appliances private limited',
    'Dinesh trading (india) private limited',
    'Evershine timber international private limited',
    'Perfex impex private limited',
    'Buildcraft interior private limited',
    'Eco sense labs (india) private limited',
    'Nalini marketing private limited',
    'Kali plast private limited',
    'Gama leafin private limited',
    'FOCE INDIA LIMITED',
    'Himroo technologies private limited',
    'Eastman auto & power limited',
    'Electroarts (mumbai) private limited',
    'Pooja electrotech private limited',
    'Parshwanath ispat private limited',
    'ALIMAK GROUP INDIA PRIVATE LIMITED',
    'JARIWALA SALES PRIVATE LIMITED.',
    'Speciality retail private limited',
    'Taleb international ventures private limited',
    'Soma enterprise limited',
    'Citisolutions hospitality products private limited',
    'Disc technology services private limited',
    'Taste and trends hospitality private limited',
    'Navyug hotels and properties private limited',
    'Gayatri hotels and theatres pvt ltd',
    'Online it shoppe india private limited',
    'VIROGREEN INDIA PRIVATE LIMITED',
    'La mclean hotels and resorts private limited',
    'B D V',
    'S DIABETES SPECIALITIES CENTRE PRIVATE LIMITED',
    'Last wilderness foundation',
    'V.E.C INVESTMENT ADVISERS PRIVATE LIMITED',
    'Alenka media private limited',
    'Sree lakshmi gayatri hospitals private limited',
    '4b healthcare private limited',
    'Oyster and pearl hospitals private limited',
    'Motwani health care private limited',
    'Malpani infertility clinic private limited',
    'Rajgreen amusement park private limited',
    'Foonza media private limited',
    'Santa eventz and exhibitions pvt ltd',
    'Aarohi starz club private limited',
    'Bangalore dream united football club private limited',
    'Ferriswheel entertainment private limited',
    'Dreamcatcher events private limited',
    'Millennium fitness and spa pools private limited',
    'Veda legal resources private limited',
    'Abstech services private limited',
    'Nalini of nalini and yasmin salon private limited',
    'Jhilmil rock-n-rock private limited',
    'Velocity supply chain private limited',
    'Rupam entertainment private limited',
    'IMAGICAAWORLD ENTERTAINMENT LIMITED',
    'Elan celebrity & talent management private limited',
    'Bridge point skills & network private limited',
    'INDIA1 PAYMENTS LIMITED',
    'Aproact facility management services private limited',
    'MENON UNITED PRIVATE LIMITED',
    'Iggi resorts international limited',
    'NAOLIN PROJECTS PRIVATE LIMITED',
    'GJ ENGINEERING & SOLUTIONS PRIVATE LIMITED',
    'Hastham swasthi private limited',
    'Citi sterling facilities management private limited',
    'KUSALAVA FINANCE LIMITED',
    'Cico technologies limited',
    'Damanganga valley resorts pvt ltd',
    'Vaari salt and chemicals pvt ltd',
    'Canara lighting industries private limited',
    'Alpha matrix services private limited',
    'Ams comtel business process management services private limited',
    'Rang de india micro capital foundation',
    'Eudora consultants & services private limited',
    '3dprime designners private limited',
    'Nekkanti corporate consultants private limited',
    'TRAMBAK RUBBER INDUSTRIES PRIVATE LIMITED',
    'Amu investment and finance pvt ltd',
    'Planet production services private limited',
    'Rib matches private limited',
    'Sky wipers private limited',
    'Joisher colloids private limited',
    'NETMECH INDUSTRIES PRIVATE LIMITED',
    'Auto repowering works (india) private limited',
    'Dual metals private limited',
    'PLATINUM GUILD INDIA PRIVATE LIMITED',
    'Salzgitter mannesmann pentasteel international(india) private limited',
    'SUN & SAND INDUSTRIES AFRICA PRIVATE LIMITED',
    'Best spring forms private limited',
    'Excel metal engineering private limited',
    'Fabtech manufacturing private limited',
    'Pipefield india private limited',
    'Beninca automations private limited',
    'Cm envirosystems private limited',
    'Hansa metallics limited',
    'Arihant steel and metal wires private limited',
    'Osaw industrial products private limited',
    'Tristar consumable products and manufacturing india private limited',
    'Pack tight packing (india) private limited',
    'Valvematics engineering private limited',
    'Ganesh precicoms industries private limited',
    'Acs hydraulics private limited',
    'Hyderabad tulaman private limited',
    'Hi-tech engineers (guj) pvt ltd',
    'Vinil process controls private limited',
    'Ima boilers private limited',
    'Inno fab (india) private limited',
    'Orissa metaliks private limited',
    'Kumar wire mesh private limited',
    'R.d.engineers ( india) private limited',
    'Flame proof equipments private limited',
    'Victory gears pvt ltd',
    'Noel engineering private limited',
    'Accurate bearings pvt ltd',
    'T n s heavy engineering private limited',
    'Tusker cranes private limited',
    'We two engineering private limited',
    'Kompress india pvt ltd',
    'Mep equipments private limited',
    'Moosa haji patrawala pvt ltd',
    'Flake ice and refrigeration systems pvt. ltd.',
    'Allied radiators private limited',
    'Omshakti metalinks private limited',
    'Tdt copper limited',
    'Sangeetha engineering works private limited',
    'Intime fire appliances private limited',
    'Balawa agni controls private limited',
    'Neoairtech india private limited',
    'Roots emballage private limited',
    'Gems precision castings private limited',
    'Wooshin engineering private limited',
    'Zed valves company private limited',
    'Mg metallic springs pvt ltd',
    'SHIV SAHAI & SONS (INDIA) PRIVATE LIMITED',
    'S.k.m. technologies private limited',
    'Tinita engineering private limited',
    'Vivek equipments private limited',
    'Srk kitchen appliances private limited',
    'Kerala agro machinery corpn ltd',
    'Southern farm fabrications private limited',
    'Ta hydraulics private limited',
    'Wewin finishing equipments private limited',
    'Shubham tex-o-pack private limited',
    'Borgwarner cooling systems (india) private limited',
    'Ashtavinayaka technocrafts private limited',
    'Vasant steel and wire private limited',
    'Spectra geo-services private limited',
    'Mithra kyokuto special purpose vehicle company private limited',
    'Mb metallic bellows private limited',
    'Siddharth printing machines private limited',
    'J k engitech private limited',
    'Botek india private limited',
    'Westech process equipment india private limited',
    'Wow equipment & infra private limited',
    'Hydreco hydraulics india private limited',
    'Mipox abrasives india private limited',
    'Yellow stone engineers india private limited',
    'Pmp automation private limited',
    'Northern steel and general mills private limited',
    'Apollo wires private limited',
    'Gravity instruments private limited',
    'Pentair water treatment private limited',
    'CECO EMTROL BUELL INDIA PRIVATE LIMITED',
    'Sunil precision india private limited',
    'Ross process equipment private limited',
    'Saj water treat india private limited',
    'Blowtech (india) private limited.',
    'Saitech fire systems private limited',
    'Perfect alloy components private limited',
    'Pioneer tools and appliances private limited',
    'Ahire machine tools p ltd',
    'Double dee technology private limited',
    'Jinabakul forge private limited',
    'Gebbs foundation',
    'Perfect pharmaceuticals consultant private limited',
    'Radcliffe schools education limited',
    'Pinnacle competitive classes private limited',
    'Azyme biosciences private limited',
    'Uber project lighting private limited',
    '360 di designs private limited',
    'Kudos chemie limited',
    'H. JEELANI LEATHERS PRIVATE LIMITED',
    'Rsa industries private limited',
    'Alkelite intermediates pvt ltd',
    'Agsar paints private limited',
    'Murarka coatings pvt ltd',
    'Shree shyamkamal graphics pvt ltd',
    'Panorama aromatics limited',
    'Kanchan pharma private limited',
    'Sundaram salt and chemicals private limited',
    'Avtos life sciences private limited',
    'Ravenbhel pharmaceuticals private limited',
    'Biostar pharmaceuticals private limited',
    'Hemline flavours private limited',
    'S c a private limited',
    'CELON LABORATORIES Private Limited',
    'Sylon bio pharma private limited',
    'Czar lab private limited',
    'Nanotech pharma private limited',
    'Sheekharr starch private limited',
    'Omega drugs pvt ltd',
    'Pulse pharmaceuticals private limited',
    'Real time instrumentation private limited',
    'Shree dhootapapeshwar limited',
    'Pellets pharma limited',
    'Spa holdings private limited',
    'Fiemench perfumes india pvt ltd',
    'Harbinger trading company private limited',
    'Abc consolidated private limited',
    'Neha pharma pvt ltd',
    'Signature pharmaceuticals limited',
    'Vilas sales private limited',
    'Melzer chemicals private limited',
    'GLOBAL MATCH MAKERS PRIVATE LIMITED',
    'Mega graphics private limited',
    'Bio-pharma laboratories private limited',
    'Venus ethoxyethers pvt ltd',
    'Aims biotech private limited',
    'Softgel healthcare private limited',
    'Maral health care private limited',
    'Duncan pharma private limited',
    'Bentec organo clays private limited',
    'Saf fermion ltd.',
    'Alna biotech private limited',
    'Ar technoplast private limited',
    'Sapphire reclaim rubber private limited',
    'Lathia industrial roller private limited',
    'HUMBLE PLASTICS PRIVATE LIMITED',
    'Raini industries india private limited',
    'Prolife care systems private limited',
    'Jujo chemical (india) private limited',
    'Colour shine polycoats private limited',
    'Soham surface coatings private limited',
    'Shree anand life sciences limited',
    'Sudeep rub-chem private limited',
    'Gomma wood products private limited',
    'Vulkan elastoplastics private limited',
    'A1 polytrade & mfg private limited',
    'Nirmala polyropes india private limited',
    'Zenith rubber (calcutta) private limited',
    'Marutii quality products private limited',
    'Zenobio life sciences private limited',
    'Centis lifecare private limited',
    'L g system india private limited',
    'K g n twines and ropes private limited',
    'Bajaj superpack limited',
    'Lexine technochem private limited',
    'Interplamak plastic packs (india) private limited',
    'Therachem research medilab (india) private limited',
    'Sanraaj hoses private limited',
    'Supreme polyweave private limited',
    'Enclo industries private limited',
    'Sudarshan auto industries private limited',
    'Mensa medicare india private limited',
    'Sri bhoomidurga enterprises private limited',
    'Unimin india limited',
    'Swastik polyvinyls private limited',
    'DUTRON PLASTICS PRIVATE LIMITED',
    'Rainbow plastics india limited',
    'Kaveri metallising and coating industries private limited',
    'Colourplus polyurethanes private limited',
    'Vinit performance polymers pvt ltd',
    'Ekdant moulders and engineers private limited',
    'Ozone polyform private limited',
    'Baysil polymers private limited',
    'Arth impex private limited',
    'Polymer industries india limited',
    'Hi-tech plastics private limited',
    'Deejay multifilms private limited',
    'Extraco composites india private limited',
    'POLYHOSE KOHYEI INDIA PRIVATE LIMITED',
    'Auropol india private limited',
    'Trijal products private limited',
    'Samor cladding systems private limited',
    'Vigirom flavours and fragrances (india) private limited',
    'Aeropres (india) private limited',
    'Atlas colours private limited',
    'Roxul rockwool technical insulation india private limited',
    'SHREESHANTI HOME DECOR PRIVATE LIMITED',
    'Ashech product private limited',
    'NEPTUNE ROBOTICS PRIVATE LIMITED',
    'Shree salasar bricks private limited',
    'PRINCE PIPES AND FITTINGS LIMITED',
    'Arl infratech limited',
    'Dion infratech private limited',
    'DAS AND SONS INFRACON PRIVATE LIMITED',
    'Navalakha constructions pvt ltd',
    'Sapana sakar buildcon private limited',
    'Dar realty private limited',
    'Royal infraservices private limited',
    'Gupta infratec private limited',
    'Admire precast structures private limited',
    'Tirupati awas private limited',
    'Pune buildtech private limited',
    'Jai manda bhoomi vikas private limited',
    'DHANUKA AFFORDABLE HOUSING PRIVATE LIMITED',
    'Hpa infratech industries private limited',
    'Agrimony agro & infrastructure private limited',
    'Nspr kp road projects private limited',
    'PANIPAT JALANDHAR NH-1 TOLLWAY PRIVATE LIMITED',
    'SURAT HAZIRA NH-6 TOLLWAY PRIVATE LIMITED',
    'Acechamps industrial park private limited',
    'LASMI CHANDAR ENGINEERING COMPANY PRIVATE LIMITED',
    'Abm mechanical and electrical services private limited',
    'Avishkaar civil and infrastructure (india) private limited',
    'Kaleesuwari infratec private limited',
    'Chirag buildtec private limited',
    'MPSEZ UTILITIES LIMITED',
    'SATPURA TRANSCO PRIVATE LIMITED',
    'DHANUKA REALTY LIMITED',
    'VIHARSH INFRAPROJECTS PRIVATE LIMITED',
    'Mohan sons buildcon private limited',
    'Metro propcon private limited',
    'Aaryaman landmark private limited',
    'Tristar housing and developments private limited',
    'Vishuddhi developers private limited',
    'Vista constech private limited',
    'BELAIRE APARTMENTS PRIVATE LIMITED ,',
    'Apollo arcade private limited',
    'ONTRACK VENTURES INDIA PRIVATE LIMITED',
    'Acron estates private limited',
    'Shravan infras private limited',
    'Structural fibres and laminates private limited',
    'Shriram bioseed ventures limited',
    'Coral health care private limited',
    'Vithoba holiday resorts private limited',
    'Thirty six properties private limited',
    'Skyway buildtech limited',
    'Y t infrastructure private limited',
    'CEEDEEYES HEALTHCARE SERVICES PRIVATE LIMITED',
    'Krishna constructions (chennai) private limited',
    'Advaitaa homes india private limited',
    'D.k. project private limited',
    'Db man realty limited',
    'Ashna realtors private limited',
    'Acron housing private limited',
    'Everest infra energy limited',
    'Genesis infrastructure and power private limited',
    'S. n. housing private limited',
    'Value homz realtors private limited',
    'Bharuch industrial park private limited',
    'True wall realty private limited',
    'Sv megha infra-tech private limited',
    'Viva conscon private limited',
    'Rv infrastructure engineers private limited',
    'Uttar banga unayan private limited',
    'Krishna landmark infraprojects private limited',
    'Atharav landmark private limited',
    'Uttar banga realtors private limited',
    'Exxonmobil company india private limited',
    'Pemmasani properties and constructions private limited',
    'Spr & rg constructions private limited',
    'Vijaya reddy builders private limited',
    'Oyester homes chennai private limited',
    'Triver integrated services private limited',
    'Adwik homes private limited',
    'Ayyanna infra private limited',
    'Prem devi builders private limited',
    'Nspr kptwo road projects private limited',
    'Ulysta engineering services private limited',
    'Marshal buildcon private limited',
    'Om prosperity construction private limited',
    'Gracious buildcon private limited',
    'Penta-ocean construction (india) private limited',
    'Kreative index interior designs private limited',
    'MM ASAN AUTO PRIVATE LIMITED',
    'Jk multitech infrastructure private limited',
    'Bjm designs private limited',
    'Shlokee builders and developers private limited',
    'Varadvinayak project private limited',
    'Autoline industrial parks limited',
    'Rns infra projects private limited',
    'Anakin real estate private limited',
    'Adigad properties private limited',
    'P.p. autotek private limited',
    'Srinath ji estates private limited',
    'Mikado enterprise private limited',
    'CAPRICON REALTY PRIVATE LIMITED',
    'Uranus trading private limited',
    'Bhagwati agri commodity private limited',
    'Splendor realtors private limited',
    'Decorum hirise private limited',
    'Sibella private limited',
    'Odyssey realtors private limited',
    'Divine realdev private limited',
    'Amrit infradevelopers private limited',
    'Meghnath marketing private limited',
    'Ariisto realtors private limited',
    'Vardhan reality ventures private limited',
    'Pgl projekts limited',
    'J. j. muktesvara construction private limited',
    'Veer colonisers and builders private limited',
    'Gauree development and leasing private limited',
    'SHREE KRISHNA ABODES PRIVATE LIMITED',
    'Shivendra estate and reality private limited',
    'Paanini development and reality private limited',
    'Anjanaa reality and development private limited',
    'Gemstar constructions private limited',
    'Shekhar realtors private limited',
    'Wmp buildhome private limited',
    'Tachyon realty private limited',
    'Assetz property management services private limited',
    'Megacity apartments private limited',
    'Srtr realtors private limited',
    'Primrose realty projects (bangalore) private limited',
    'Geown developers private limited',
    'Ashquar infra developers private limited',
    'Mudra estates private limited',
    'Eric development and leasing private limited',
    'Brahma realty private limited',
    'Saphire landcraft private limited',
    'Virtuous plazas private limited',
    'Acquire buildcon private limited',
    'Devanshee realty (india) private limited',
    'Shreesena development and reality private limited',
    'Gemini commercial credits limited',
    'Legacy global infrastructure private limited',
    'Tanglin property developments (mumbai) private limited',
    'Uttaresh reality and development private limited',
    'Lovisha infrastructure private limited',
    'Godawari real estate (chhattisgarh) private limited',
    'Subhash polytex limited',
    'Shree raaj raajeshwari properties private limited',
    'Bhagyodaya real estate private limited',
    'Jas properties pvt ltd',
    'Sovereign businesses private limited',
    'Jai ambe land infrastructure private limited',
    'Better time realtors private limited',
    'KAPIL INFRA PROJECTS PRIVATE LIMITED',
    'Premier landmark ventures private limited',
    'Scarlett tech infra private limited',
    'Express newspapers private limited',
    'ALAMO XS REAL PRIVATE LIMITED',
    'Achaleshwar infrastructure private limited',
    'Veer realtors private limited',
    'Chettinad land and building development private limited',
    'Baashyaam properties private limited',
    'Ashray real estates pvt.ltd.',
    'Gegacorp enterprises pvt ltd',
    'Finest promoters private limited',
    'Av tradelink private limited',
    'Information tv private limited',
    'Enhance projects private limited',
    'Asm promoters private limited',
    'Skyhigh technobuild private limited',
    'Ramanashree shopping arcade private limited',
    'Navlok ventures private limited',
    'Polachirackel property holdings private limited',
    'Girisons retailing private limited',
    'Bkc property owners association',
    'Durja realty private limited',
    'Hbs view private limited',
    'Turbo infratech private limited',
    'Mss contracts private limited',
    'Rahna homes and developers private limited',
    'Hari dhaatu developers private limited',
    'Vaani estates private limited',
    'Oriana projects and development private limited',
    'Indus developers pvt ltd',
    'Castlerock projects and developers private limited',
    'Isheta realty private limited',
    'Navkar realtor private limited',
    'Indo asian buildcon private limited',
    'Stratos realty private limited',
    'Neozone properties private limited',
    'A r realtors properties & speciatlities private limited',
    'Trinity infradeveloper private limited',
    'Logix buildtech private limited',
    'Brahma center development private limited',
    'Hsr ventures private limited',
    'Brook realtors private limited',
    'Sai namo namah construction private limited',
    'Lova realtors private limited',
    'Sevoke builders private limited',
    'Neobeam agents private limited',
    'Acron realty private limited',
    'Prachin city developments private limited',
    'Apex township private limited',
    'Eurostar real holdings private limited',
    'Banka enterprises pvt. ltd.',
    'KORE COMMUNITIES INDIA PRIVATE LIMITED',
    'Tanglin retail reality developments private limited',
    'Vestian global work place services private limited',
    'LOB FACILITIES MANAGEMENT PRIVATE LIMITED',
    'Rd buildtech and developers (karnataka) private limited',
    'Neo infrastructure private limited',
    'Apurva organics ltd.',
    'Tapp bangalore holdings private limited',
    'Abn buildtech private limited',
    'Prajay retail properties private limited',
    'Warm connect solutions private limited',
    'Tefal india household appliances pvt ltd',
    'Shakun india private limited',
    'Unimarck healthcare limited',
    'Nscc software private limited',
    'Iss global tech products private limited',
    'Whiteboard consulting private limited',
    'Qbana designs private limited',
    'Locus infotainment private limited',
    'Reliance welfare association',
    'GHODAWAT VENTURES PRIVATE LIMITED',
    'PERMALIFE RESEARCH AND MARKETING PRIVATE LIMITED',
    'Bubble creations digital studios private limited',
    'Gravity home solutions private limited',
    'Pharmaforce reports private limited',
    'Rubika india private limited',
    'Essential five learning solutions private limited',
    'Plan b communications private limited',
    '3rd rock marketing services private limited',
    'Kentree consultants private limited',
    'Hr infratel india private limited',
    'Vuchi media private limited',
    'Nxg financial services private limited',
    'Sidson pharma distributors private limited',
    'SICAL CONNECT LIMITED',
    'Cusp consulting private limited',
    'Crafiti world-crafts private limited',
    'Dicedots private limited',
    'Lmcs infra holdings private limited',
    'FINSAFE INDIA PRIVATE LIMITED',
    'Jana urban services for transformation private limited',
    'Rahyals envergy india private limited',
    'Banyan management support services private limited',
    'Solartown energy solutions private limited',
    'COMFORT ELEVATORS & ESCALATORS PRIVATE LIMITED',
    'Ignas enterprises private limited',
    'Cispro technologies private limited',
    'Litelab consultants private limited',
    'Edge hydra ventures private limited',
    'Three sixty holidays private limited',
    'Aaa media network private limited',
    'NIPPON STEEL ENGINEERING INDIA PRIVATE LIMITED',
    'Nilank consultancy private limited',
    'Rocktec mining and construction private limited',
    'Absorgen traders private limited',
    'Jitamanyu dealtrade limited',
    'Jitakrodh tradelink limited',
    'Personal touch services (india) private limited',
    'Hrs consulting private limited',
    'Gsg logistics private limited',
    'Origin consultants private limited',
    'Risesmart hr services private limited',
    'Frank shields private limited',
    'Aida displays private limited',
    'Veeyu hr solutions private limited',
    'Covenant insurance surveyors and loss assessors private limited',
    'Kumar guards private limited',
    'Amset energy systems and solutions private limited',
    'Rajasthan association of security and detective agencies',
    'Nimbus harbor facilities management private limited',
    'Conpro enterprises private limited',
    'Sieun and b.a.g animation private limited.',
    'G. d. digital and movies private limited',
    'Incite power and analytics private limited',
    'Maxwell academy private limited',
    'Sree giri packagings ltd',
    'Beauty impex private limited',
    'Alliance outsourcing private limited',
    'Himalaya surveillance and solution private limited',
    'Primark travel house private limited',
    'Star dimensions india private limited',
    'Purple pebble entertainment co private limited',
    'CONSILIUM SAFETY INDIA PRIVATE LIMITED',
    'Deluxe interior infrastructure private limited',
    'Pegasus interactive private limited',
    'Steel carriers infrastructure private limited',
    'Ryan india tax services private limited',
    'Universal forwarders india private limited',
    'Regenti media private limited',
    'Mentor management and financial advisors private limited',
    'Hunger inc hospitality private limited',
    'Tate leadership consulting private limited',
    'Sanjeevani engineering projects private limited',
    'Excellent handling systems private limited',
    'Esskae management solutions private limited',
    'Genesis decor international private limited',
    'Finestar diamonds private limited',
    'Flycatcher adventures private limited',
    'Sixty four squares private limited',
    'Bhagwat energy private limited',
    'Tutus india automation private limited',
    'Lepl projects limited',
    'Jayaraj fortune packaging private limited',
    'Alternatives analysis & risk management private limited',
    'BIOVILLE SOLUTIONS PRIVATE LIMITED',
    'Arjan advisory private limited',
    'PROCLAIM INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED',
    'Alankit insurance brokers limited',
    'Agriculture insurance company of india limited',
    'TERAL-AEROTECH FANS PRIVATE LIMITED',
    'Change you mediacomms private limited',
    'Polo wealth creators private limited',
    'Shah paper mills limited',
    'Kandla packaging private limited',
    'OJI INDIA PACKAGING PRIVATE LIMITED',
    'TEAM MEDIA & HOSPITALITY PRIVATE LIMITED',
    'Chandra-corbox packaging private limited',
    'Ganesh cartons india private limited',
    'Syno packers private limited',
    'Flm entertainment networks private limited',
    'Dart info services private limited',
    'Glodyne pro media limited',
    'V pac cartons india private limited',
    'Carbon resources pvt ltd',
    'Coastal infrastructure private limited',
    'Pasby petrochemicals (india) private limited',
    'Gandhar oil refinery (india) limited',
    'Natural aerogas private limited',
    'Hpcl rajasthan refinery limited',
    'WYNN',
    'AND MARKETEERS',
    'S TUTORIALS PRIVATE LIMITED',
    'Highgrowth suppliers private limited',
    'Shelter pharma limited',
    'S n d life science private limited',
    'G p t pharmaceuticals private limited',
    'Tykhe chemicals private limited',
    'Unimarck bioethicals private limited',
    'SETT DEY & CO HOMOEO PVT LTD',
    'Patel structural private limited',
    'Crosslay remedies limited',
    'Abc nutraceuticals (india) private limited',
    'Warden surgical company private limited',
    'Tulips medicaments pvt ltd',
    'Manchanda herbal products private limited',
    'Core cosmetic private limited',
    'Gympac fitness systems private limited',
    'Hilite healthpro private limited',
    'Sundaravel fire works private limited',
    'Sood studio private limited',
    'Samde aromatic private limited',
    'Rambo packers india private limited',
    'Govindaraja mudaliar sons private limited',
    'Vidarbha grinders private limited',
    'JAGANNATH CHEMFOOD PRIVATE LIMITED',
    'Chemet chemicals private limited',
    'Ashutosh fibre private limited',
    'D g road safety private limited',
    'Solar synthetics private limited',
    'Prasad film labs (mumbai) private limited',
    'Kuber india sales private limited',
    'Rollin industries private limited',
    'Multiwall paper sack company private limited',
    'Saurashtra packaging pvt ltd',
    'KAMNATH PRIVATE LIMITED',
    'Vidyarambham press and book depot pvt ltd',
    'Fishfa rubbers limited',
    'Avr storage tank terminals private limited',
    'Coastal rubber equipment private limited',
    'Bengani exports (india) private limited',
    'Vishakha industries private limited',
    'J tchanrai industries private limited',
    'Indian peroxide limited',
    'Firm link pharma private limited',
    'Spectra plast india private limited',
    'Gupta polytubes private limited',
    'Venus polytex pvt. ltd',
    'EXCELLENT GRAVURE INDUSTRIES PRIVATE LIMITED',
    'Prompt packaging pvt.ltd.',
    'Bharat pet limited',
    'Adityam technoplast private limited',
    'Kanishka plasacs private limited',
    'Deep jyot enterprises private limited',
    'VISALAKSHI PLANTATIONS PRIVATE LIMITED',
    'Stallion laboratories pvt ltd',
    'Genius plastics private limited',
    'Tajpuriya techno plast private limited',
    'Megatech industries india private limited',
    'Labort fine-chem private limited',
    'Pranami drugs private limited',
    'Polyplastics auto components private limited',
    'Jaipur tuffen glass industries private limited',
    'Meditek life sciences private limited',
    'MCGEAN INDIA CHEMICALS PRIVATE LIMITED',
    'Erm beton private limited',
    'Silvenia ceramic private limited',
    'Purple bay home decors private limited',
    'Abyss pharma private limited',
    'Kuber recycle projects private limited',
    'Galaxy ceramics pvt ltd',
    'Aristo ceramic private limited',
    'PHOENIX INFRASPACE INDIA PRIVATE LIMITED',
    'PEHLARI TRADING PRIVATE LIMITED',
    'NATURECALLS SUSTAINABILITY SOLUTIONS PRIVATE LIMITED',
    'FINZOOM INVESTMENT ADVISORS PRIVATE LIMITED',
    'EXCELFRONT BIZCON PRIVATE LIMITED',
    'HASHBYTE STUDIO PRIVATE LIMITED',
    'IDYNAMICS SOFTWARE PRIVATE LIMITED',
    'TRUCKISHLABS SOFTWARE (OPC) PRIVATE LIMITED',
    'CITYGLIDE TRAVEL SOLUTIONS PRIVATE LIMITED',
    'ECESIS CARE PRIVATE LIMITED',
    'SAARA AFFORDABLE HOUSING FINANCE PRIVATELIMITED',
    'MADLEARN INDIA PRIVATE LIMITED',
    'SVN SYSTECH INDIA PRIVATE LIMITED',
    'CARLTON ONE ENGAGEMENT INDIA PRIVATE LIMITED',
    'MIDASTECH ORBIT PRIVATE LIMITED',
    'EVEREADY WEAVES PRIVATE LIMITED',
    'ALTHEAS FITNESS PRIVATE LIMITED',
    'RAJGURU ELECTRONICS (I) PRIVATE LIMITED',
    'SOLUTIONSATI CONSULTING INDIA PRIVATE LIMITED',
    'VEPS INDUSTRIES PRIVATE LIMITED',
    'LINGA AGRI TRADING AND MACHINERY PRIVATELIMITED',
    'CLUEZILLA SYSTEMS INDIA PRIVATE LIMITED',
    'DIWANTHAM TOLLWAY PRIVATE LIMITED',
    'FIDERE INFRA INDIA PRIVATE LIMITED',
    'BIOHEAVEN 360 GENOTEC PRIVATE LIMITED',
    'ANKAPALLI TOLLWAY PRIVATE LIMITED',
    'KL ABDUL SATHAR IMPEX PRIVATE LIMITED',
    'ICCHAPURAM TOLLWAY PRIVATE LIMITED',
    'PHOENIX INFRASOFT INDIA PRIVATE LIMITED',
    'VISHAVARI TOLLWAY PRIVATE LIMITED',
    'MOONCHILD MEDIA PRIVATE LIMITED',
    'S. KUSHALCHAND INTERNATIONAL PRIVATE LIMITED',
    'MULTITEK BELTINGS (OPC) PRIVATE LIMITED',
    'PK SPORTS VENTURES PRIVATE LIMITED',
    'ROSTAN TECHNOLOGIES PRIVATE LIMITED',
    'A1 SPACES PRIVATE LIMITED',
    'MEDIOZA ENTERTAINMENT PRIVATE LIMITED',
    'UBIXE INFOTECH PRIVATE LIMITED',
    'CAPGEMINI IT SOLUTIONS INDIA PRIVATE LIMITED',
    'ADIRA TECHNOLOGIES PRIVATE LIMITED',
    'STEPLADERS TRADES PRIVATE LIMITED',
    'INDITRADE TECHNOLOGIES LIMITED',
    'SYSITCO TECHNOLOGIES PRIVATE LIMITED',
    'PRESENCE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RANKKEYWORDS PRIVATE LIMITED',
    'SALT ',
    'BLUES INTERNATIONAL PRIVATE LIMITED',
    'RICO FRICTION TECHNOLOGIES LIMITED',
    'DEVKRAFT TECHNOLOGIES PRIVATE LIMITED',
    'HASOFT POWER ELECTRONICS PRIVATE LIMITED',
    'ACTUATE TECHNOLOGIES PRIVATE LIMITED',
    'EURROSEAS SHIPPING AGENCY PRIVATE LIMITED',
    'FAUSTIN SERVICES INDIA PRIVATE LIMITED',
    'PURE STORAGE INDIA PRIVATE LIMITED',
    'APEX INFRALINK LIMITED',
    'DIWANCHERUVU TOLLWAY PRIVATE LIMITED',
    'AARYA ECONNECT INTERCITY PRIVATE LIMITED',
    'MAPLETUNE FURNITURES PRIVATE LIMITED',
    'INDISUAN PHARMACEUTICALS PRIVATE LIMITED',
    'QUEACO EDUCATIONAL SERVICES PRIVATE LIMITED',
    'STANDEX ELECTRONICS INDIA PRIVATE LIMITED',
    'KPAY INNOVATION PRIVATE LIMITED',
    'PERCILCHOFE PRIVATE LIMITED',
    'TEAM INSPIR RETAILERS PRIVATE LIMITED',
    'SD LIFTING EQUIPMENTS PRIVATE LIMITED',
    'GLOBOTRANSPRO TERMINAL PRIVATE LIMITED',
    'PUREPAANI PORTABLE FILTERS PRIVATE LIMITED',
    'ISAKA INKS INDIA PRIVATE LIMITED',
    'LEOSTAR LOGISTICS PRIVATE LIMITED',
    'WAVEULTRA ENGINEERS AUTOMATION PRIVATE LIMITED',
    'RAWSOME FAMILYCARE PRODUCTS PRIVATE LIMITED',
    'UA DESIGN STUDIO PRIVATE LIMITED',
    'KAPIL KNOWLEDGE HUB PRIVATE LIMITED',
    'PARC ROBOTIC SYSTEMS PRIVATE LIMITED',
    'SCHNEIDER ELECTRIC PRIVATE LIMITED',
    'FINESOURCE SOLUTIONS PRIVATE LIMITED',
    'METHODPRESS MEDIA (OPC) PRIVATE LIMITED',
    'SHAKTI RECON PRIVATE LIMITED',
    'KKGOC INDUSTRIES LIMITED',
    'SHREE DARIYAV GLASSTECH PRIVATE LIMITED',
    'DGMARKET INDIA PRIVATE LIMITED',
    'VITAL OVERSEAS PRIVATE LIMITED',
    'FAITH SCAFFOLDING SERVICES PRIVATE LIMITED',
    'REDDENSOFT INFOTECH PRIVATE LIMITED',
    'BLOCKIMAGEX INDIA PRIVATE LIMITED',
    'SIDDHANTA INFOTECH PRIVATE LIMITED',
    'GITEC-IGIP INDIA PRIVATE LIMITED',
    'POWER BRIDGE SYSTEMS PRIVATE LIMITED',
    'VARREN MARITIME ACADEMY FOUNDATION',
    'LUZINSKY MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'MANDARK CONSULTANTS PRIVATE LIMITED',
    'PENCLOTEK PANELS PRIVATE LIMITED',
    'ATHMABANDHU CHIT FUNDS PRIVATE LIMITED',
    'DPC INDIA PRIVATE LIMITED',
    'COLORTEXT DIGITAL SOLUTIONS PRIVATE LIMITED',
    'DESPACITO ENGINEERS PRIVATE LIMITED',
    'ALTIOREM CONSULTANCY PRIVATE LIMITED',
    'MANA VENTURES PRIVATE LIMITED',
    'RADIANT SEMICONDUCTORS PRIVATE LIMITED',
    'NEELA FILM PRODUCTIONS PRIVATE LIMITED',
    'EASYGOING CHITS PRIVATE LIMITED',
    'FULLCYCLE PRIVATE LIMITED',
    'RENEWX SOLAR UMPIRE PRIVATE LIMITED',
    'FINFLUX FINANCIAL SERVICES PRIVATE LIMITED',
    'MEGREZ ESTATES PRIVATE LIMITED',
    'WEBZEMINI PRINT SOLUTION PRIVATE LIMITED',
    'GNFR SERVICES PRIVATE LIMITED',
    'MAHATTATTVA FOUNDATION',
    'INFINITE GRAPHIX TECHNOLOGIES PRIVATE LIMITED',
    'VANSH HOSES PRIVATE LIMITED',
    'SARMAYA ARTS FOUNDATION',
    'QNIQUE INDIA PRIVATE LIMITED',
    'KAUSTHUBHAM FABTECH PRIVATE LIMITED',
    'FLAWLESS LOGISTICS PRIVATE LIMITED',
    'SUCHAKRA PROJECTS PRIVATE LIMITED',
    'TRANSTORK AUTOMATION PRIVATE LIMITED',
    'PRACHLIT CONSULTING PRIVATE LIMITED',
    'MEGAVISORS PRIVATE LIMITED',
    'SUCCESS4 SOLUTIONS PRIVATE LIMITED',
    'OMAXE NEW FARIDABAD DEVELOPERS PRIVATE LIMITED',
    'LEONIS KORAMANGALA COMPLEX PRIVATE LIMITED',
    'SADBHAV MAINTENANCE INFRASTRUCTURE PRIVATE LIMITED',
    'AMROP INDIA PRIVATE LIMITED',
    'MANHA BUILD PRODUCTS PRIVATE LIMITED',
    'VGARCEDO ENERGY PRIVATE LIMITED',
    'REGGEL LIFESCIENCES PRIVATE LIMITED',
    'VFM BUILDCON PRIVATE LIMITED',
    'GIBSONS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AROVED HEALTHCARE PRIVATE LIMITED',
    'SRIKAM HITECH ENGINEERING PRIVATE LIMITED',
    'KRINTEK GLOBAL PRIVATE LIMITED',
    'TECHGROPSE PRIVATE LIMITED',
    'ATHENA SHIPS MANAGEMENT SERVICES PRIVATELIMITED',
    'ABDG INDIA PRIVATE LIMITED',
    'VK1 EXPRESSWAY LIMITED',
    'CERTAIM ISO BUSINESS SERVICES (OPC) PRIVATE LIMITED',
    'INTERCEDE MEDIA HOUSE PRIVATE LIMITED',
    'ZETTAMINE LABS PRIVATE LIMITED',
    'WOW WASTE MANAGEMENT PRIVATE LIMITED',
    'SMARTENVIRO SYSTEMS PRIVATE LIMITED',
    'VISATMA AGROTECH PRIVATE LIMITED',
    'MEDEXPERT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'FLAPS AIR AMBULANCE FOUNDATION',
    'BLUEROSE PUBLISHERS PRIVATE LIMITED',
    'FI ELLEMENTS PRIVATE LIMITED',
    'SENSEABLE SMART SOLUTIONS PRIVATE LIMITED',
    '4XFAST TECHNOLOGIES PRIVATE LIMITED',
    'URBANETEK HVAC ENG PRIVATE LIMITED',
    'AVL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'STONORTI MARKETPLACE PRIVATE LIMITED',
    'ABHAY JAISWAL 3D VISUALIZERS (OPC) PRIVATE LIMITED',
    'IHEALTH AND SAFETY FOUNDATION OF INDIA',
    'KICH HARDWARE PRODUCTS PRIVATE LIMITED',
    'GLOBAL IT HUB PRIVATE LIMITED',
    'TRICLAD BIOTECH PRIVATE LIMITED',
    'NINKI BUSINESS COMBINES PRIVATE LIMITED',
    'NYRI COAL TAR PITCH PRIVATE LIMITED',
    'NISCIT TECH PRIVATE LIMITED',
    'H.r.s. marketing private limited',
    'Vertex karma academy & training solutions private limited',
    'Dalmia decorus private limited',
    'Pentagon el - mech solutions private limited',
    'INTRAGLOBE TRANSPORT SOLUTIONS PRIVATE LIMITED',
    'R.a.v. dravya pvt. ltd.',
    'Sanket vyapar private limited',
    'Synergy commerce private limited',
    'Aakansha tradevin private limited',
    'Juliet tie-up private limited',
    'Q & d impex private limited',
    'Bams condiments impex private limited',
    'R s castor trading private limited',
    'Spice valley condiments private limited',
    'Primestart trading private limited',
    'Lensai ophthalmic private limited',
    'TEKNODOME INDIA PRIVATE LIMITED',
    'Splendina healthcare private limited',
    'Sheetal manufacturing company private limited',
    'MTV JEWELLERS PRIVATE LIMITED',
    'Green orbit apparels pvt ltd',
    'Construction solutions (bangalore) private limited',
    'Tanyo exports private limited',
    'Sahil impex private limited',
    'Syndicate exhaust systems private limited',
    'Arihant precision engineering private limited',
    'Power tools & appliances company private limited',
    'Trident material handling private limited',
    'GLOK FLUID CONNECTORS PRIVATE LIMITED',
    'Shree maa electronics private limited',
    'Mercury air conditioners private limited',
    'Dhawan surgical private limited',
    'Chapman exim private limited',
    'Chitra impex private limited',
    'Shakuntala devi trade and investments pvt ltd',
    'D.p.designs private limited',
    'C m jain impex and investments private limited',
    'Govind overseas limited',
    'Kotak overseas private limited',
    'Coronet impex private limited',
    'Greenburg mercantile private limited',
    'Abu jani sandeep khosla designers private limited',
    'Samruddha resources limited',
    'METALINK METALS PRIVATE LIMITED',
    'Rahul distributors private limited',
    'Viraat authentication systems private limited',
    'Technopurple it solutions private limited',
    'Veritasearth solutions private limited',
    'Technokrafts labs private limited',
    'Mind info services private limited',
    'Irevo multimedia india private limited',
    'Challenger technologies private limited',
    'Netclues technologies private limited',
    'Thinkinno technologies private limited',
    'Hol infosolutions private limited',
    'Iprogrammer solutions private limited',
    'Three-mediatech company private limited',
    'Afflaim technologies private limited',
    'Amiworks solutions private limited',
    'Coditas technologies private limited',
    '7hills logistics systems private limited',
    'Trillion it solutions (india) private limited',
    'Wapaar info private limited',
    'Coign edu & i t services private limited',
    'Conevo technologies private limited',
    'Sans bound solutions private limited',
    'Bow and baan technology solutions private limited',
    'Pr computer castle (india) private limited',
    'Jd software private limited',
    'Lapsys infotech private limited',
    'Fabric networks global private limited',
    'Edsix brainlab private limited',
    'Sterling software private limited',
    'Jeganee technologies private limited',
    'Jjmr technologies private limited',
    'Saboo e-solutions private limited',
    'Saat technologies private limited',
    'MEDEKOM VENTURES PRIVATE LIMITED',
    'Axio biosolutions private limited',
    'Credence analytics (india) private limited',
    'Alchem synthon private limited.',
    'Aaa researchone financial consultants private limited',
    'Foliage crop solutions private limited',
    'Molecular connections private limited',
    'Vidushi infotech software solutions provider private limited',
    'Parkview hotels private limited',
    'Catalyst corporate services private limited',
    'Astral advisory solutions private limited',
    'AHIMSA VENTURES PRIVATE LIMITED',
    'Just about sportz and showbiz private limited',
    'Libra decor private limited',
    'Athang expressions private limited',
    'Indus envirosolutions private limited',
    'Next big thing media private limited',
    'Parietal innovative solutions private limited',
    'Lichens environment private limited',
    'Padam interiors private limited',
    'Visions a+d projects private limited',
    'Ladegain solutions private limited',
    'Kittens india private limited',
    'M & a corp private limited',
    'Psl india private limited',
    'Praxworld exim private limited',
    'Brandsdaddy customer services private limited',
    'Ava marine yachts private limited',
    'J v seamless india private limited',
    'BRITISH INTERNATIONAL INVESTMENT INDIA ADVISERS PRIVATE LIMITED',
    'Accord security and allied services private limited',
    'S k fincap advisors private limited',
    'Miles india it solutions private limited',
    'Shanti shipping services private limited',
    'First edition arts private limited',
    'Agility e services private limited',
    'Gal logistics private limited',
    'Shri mahalakshmi e filing services private limited',
    'Areve financial consultancy private limited',
    'Cenox chemicals private limited',
    'LEX NIMBLE SOLUTIONS LIMITED',
    'Delcap financial services private limited',
    'Stanley consultants india private limited',
    'INTELLECT INVESTMENT SERVICES PRIVATE LIMITED',
    'Pfc consulting limited',
    'Language consultancy services private limited',
    'Telamon investment advisors and consultants private limited',
    'Knm corporate consultants private limited',
    'M & m multiservices private limited',
    'Jalan risk advisory private limited',
    'KOOZO COMMERCE PRIVATE LIMITED',
    'Exint solutions private limited',
    'The science and information (sai) organization private limited',
    'Target exhibitions private limited',
    'Amplus capital advisors private limited',
    'Passageways education private limited',
    'Unified financial solutions private limited',
    'VELTOSA PRIVATE LIMITED',
    'Ashwini kumar management consultants opc private limited',
    'Lutech resources india private limited',
    'Copart india private limited',
    'Iiq systems private limited',
    'Cvk mind source consulting services private limited',
    'Karmic consultants private limited',
    'Cartel network solutions private limited',
    'Psmi management india private limited',
    'EXPRESS PUBLICATIONS (CHENNAI) PRIVATE LIMITED',
    'Hypnautyx entertainment private limited',
    'Sagar scan private limited',
    'Arunodaya print pack private limited',
    'Manasi pressings private limited',
    'Lokshahi publications private limited',
    'Sfa print private limited',
    'S g print packs private limited',
    'Sun-electro gravures private limited',
    'Insight print communications private limited',
    'Priya graphics private limited.',
    'Bonzai digital private limited',
    'Imagine pictures private limited',
    'Av graphic designers private limited',
    'Durable gas private limited',
    'Essay petroleum india private limited',
    'Kotak petro-chem private limited',
    'Tiki tar danosa (india)private limited',
    'Petrochem middle east ( india) private limited',
    'Mars petrochem private limited',
    'Sunflag micro solutions private limited',
    'Brilliant bio pharma private limited',
    'Jay overseas private limited',
    'Swasan chemicals pvt ltd',
    'Titan laboratories private limited',
    'Hi-tech thermal insulations private limited',
    'Pristine aerosols private limited',
    'Macster india private limited',
    'Smaart pharmaceuticals private limited',
    'Innovassynth technologies (india ) limited',
    'Six-sigma gases india private limited',
    'Banchem intermediates (india) private limited',
    'Tanatex chemicals india private limited',
    'Navicare pharma private limited',
    'Sri chavadi pharma private limited',
    'Myk industries private limited',
    'Himachal polyolefins limited',
    '3Q PRINTING TECHNOLOGIES PRIVATE LIMITED',
    'Majorhub oleo chemicals private limited',
    'Effco finishes & technologies private limited',
    'MYK ARMENT PRIVATE LIMITED',
    'Deep colours private limited',
    'Interpharm biotech private limited',
    'Jaju chemicals pvt ltd',
    'Apicore pharmaceuticals private limited',
    'YASH CHEMEX Limited',
    'Smartech graphics private limited',
    'Standard reagents private limited',
    'Wacker metroark chemicals private limited',
    'Sellowrap epp india private limited',
    'Polyflex(india) private limited',
    'Priya blue industries private limited',
    'Agrosynth chemicals limited',
    'Adroit lifescience private limited',
    'SURYSHREE BLOCKS PRIVATE LIMITED',
    'Siro clinpharm private limited',
    'CREMED LABS PRIVATE LIMITED',
    'Synocule research labs private limited',
    'Acme diet care private limited',
    'Acme skin care private limited',
    'Bell flavors & fragrances (india) private limited',
    'PRIME PHARMACEUTICALS Private Limited',
    'Mercury healthcare private limited',
    'Dsm nutritional products india private limited',
    'Magene life sciences private limited',
    'M h medicus private limited',
    'VIDAS BIOTECH PRIVATE LIMITED',
    'Ayushakti ayurved private limited',
    'Fullife healthcare private limited',
    'Apollo ingredients india private limited',
    'Mother agri biotech laboratories india private limited',
    'PANTHERYX (INDIA) PRIVATE LIMITED',
    'Micropan pharmachem private limited',
    'Epione pharmaceuticals private limited',
    'Sreepathi pharmaceuticals limited',
    'Adisan biotechnologies private limited',
    'Bion therapeutics (india) private limited',
    'Chemizol additives private limited',
    'SAI FRAGRANCE & FLAVOURS PRIVATE LIMITED',
    'Purnadas ranchhoddas (perfumeries) pvt.ltd.',
    'Archroma india private limited',
    'Aumento pallinos private limited',
    'Roha dyechem sez private limited',
    'Hef- durferrit india private limited.',
    'SYNMR CHEMICALS PRIVATE LIMITED',
    'Sierra safety private limited',
    'Nisco aegis polymers private limited',
    'Accura polyplast private limited',
    'Anu rubber products private limited',
    'HITECH JOINTS & LININGS PRIVATE LIMITED',
    'Dolphin polyplast private limited',
    'Maa bimala polymers private limited',
    'Harmony laminates private limited',
    'Gorgeous extrusion technik private limited',
    'Mitsui prime advanced composites india private limited',
    'Anand polyurethanes private limited',
    'Venkateshwara technoplast and engg. works private limited',
    'Rudra marketing agency private limited',
    'Express equipment rental & logistics private limited',
    'Unique global logistics private limited',
    'Nucleus shipping company private limited',
    'Le trans logistics private limited',
    'Veena shipping agency private limited',
    'Marcons shipping services private limited',
    'Transcoastal cargo & shipping limited',
    'Seal freight forwarders private limited',
    'Alphaplus cargo logistics private limited',
    'United safeway india private limited',
    'Wish holidays private limited',
    'Aarvee cold chain logistics private limited',
    'Seahaul lines (india) private limited',
    'DELHI INTERNATIONAL AIRPORT LIMITED',
    'Sats (india) co. private limited',
    'Stimulus hospitality private limited',
    'Maxxfun holidays private limited',
    'La vacanza travel private limited',
    'Micar sharing technologies private limited',
    'Hope voyager private limited',
    'Razdan travel service private limited',
    'Quikjet cargo airlines private limited',
    'SILICON CITY TRANSPORT SERVICES PRIVATE LIMITED',
    'Trinity air travel and tours pvt ltd',
    'W t s travel services private limited',
    'Karvat cover-more assist private limited',
    'Lifestyle travel services private limited',
    'Insta tourism private limited',
    'Shreedestinations travel private limited',
    'Travstore travel management private limited',
    'Raven container lines private limited',
    'Surbhi holidays private limited',
    'Kameshwar tours and event consultancy private limited',
    'Karmic overseas limited',
    'ISH TRAVEL & TOURS LIMITED',
    'A n exim solution private limited',
    'Serve logistics private limited',
    'Herons logistics (india) private limited',
    'Aditi dream destinations private limited',
    'Speedex transcarriers private limited',
    'TOTAL TRANSPORT SYSTEMS LIMITED',
    'Tcf logistics private limited',
    'Cel logistics private limited',
    'Mariyam marine services private limited',
    'Agarwal packers and movers limited',
    'CARAVAN LOGIPARK PRIVATE LIMITED',
    'Ashte logistics private limited',
    'Nss logistics (india) private limited',
    'World destination management services private limited',
    'Guideline travels holidays india private limited',
    'Velocity global logistics private limited',
    'Balaji intermodal cargotech india private limited',
    'Travel cue management private limited',
    'Devam tours and travels private limited',
    'The q travel experiences private limited',
    'GRAMPUS SHIPPING & LOGISTICS PRIVATE LIMITED',
    'Rhr logistics private limited',
    'Coast-to-coast shipping limited',
    'Macsons shipping agencies private limited',
    'Subhas travellings pvt ltd',
    'Killick marine services private limited',
    'Pole-star digicom private limited',
    'Xantel corporation private limited',
    'Unity integrated solutions private limited',
    '9g tele solutions private limited',
    'Wan and lan internet private limited',
    'ACCEL OEM APPLIANCES LIMITED',
    'Gsma services india private limited',
    'Xion corporations private limited',
    'Home city systems private limited',
    'Kanchanmanik securities private limited',
    'Karaikal marketing private limited',
    'Wazir financial services private limited',
    'EAGLE WEALTH PRIVATE LIMITED',
    'Super handlers private limited',
    'TRADEBULLS CAPITAL LIMITED',
    'Ramtirth leasing and finance company private limited',
    'Chinta investments private limited',
    'Macquarie capital securities (india) private limited',
    'New india finvest private limited',
    'Sipani hire purchase and finance co pvt ltd',
    'Ibn lokmat news private limited',
    'Manifest investments private limited',
    'Pimpri finance private limited',
    'Sbi global factors limited',
    'Vedika finance pvt ltd',
    'Brics securities limited',
    'Bloom field holdings and finance private limited',
    'Dolat capital market pvt limited',
    'Sakuma finvest private limited',
    'Navgire holdings private limited',
    'K m l m chits india limited',
    'Loveshore chits private limited',
    'Ska chitfunds private limited',
    'Somayajulu & company limited',
    'Heilgers development & construction co. pvt. ltd.',
    'VC ONE VENTURES PRIVATE LIMITED',
    'Park medicity (haryana) private limited',
    'Neesa webylon private limited',
    'PRISHA BUSINESS SUPPORT PRIVATE LIMITED',
    'RSB INDUSTRIES PRIVATE LIMITED',
    'Horigine consulting private limited',
    'Lighthouse mall management company private limited',
    'Rmz consultancy services private limited',
    'Pure water management private limited',
    'Micromaster laboratories private limited',
    'Labh nirmal on line lottery private limited',
    'ICHESS EXTRACT PRIVATE LIMITED',
    'Premia solutionz private limited',
    'Ah ventures india private limited',
    'Linear exports private limited',
    'DIE-TEK SPRINGS PRIVATE LIMITED',
    'Argus zener system integrators private limited',
    'ARIHANT E-RECYCLING LIMITED',
    'Ugoc corporate services private limited',
    'Mtc ecom private limited',
    'Kerfuffle commercial solutions private limited',
    'Leadership boulevard private limited',
    'Rewardport corporate solutions private limited',
    'Rose rock real estate india private limited',
    'Personage corporation private limited',
    'IRC CREDIT MANAGEMENT SERVICES LIMITED',
    'Nivan habitats private limited',
    'Ambest prints private limited',
    'Bizsolindia services private limited',
    'Consolidated consultants and engineers private limited',
    'Lfs commodities private limited',
    'Aditi irrigation technologies private limited',
    'Stepon engineers private limited',
    'Tamanna hotels and resorts private limited',
    'Bon-viveur hospitality private limited',
    'Mother care holidays resorts private limited',
    'Cyma hospitality ventures private limited',
    'HOTEL AGASTHIYA PRIVATE LIMITED',
    'Pine lake villa hotels private limited',
    'K j m resorts india private limited',
    'Shantitheeram lakeside resort private limited',
    'Marriott hotels india private limited (trf.)',
    'Neo capricorn plaza private limited',
    'SPEEDY MULTIMODES LIMITED',
    'SYNERGIC TRANSPORTS & LOGISTICS INDIA PRIVATE LIMITED',
    '3vs logistics private limited',
    'SEAGULL CLEARING & FORWARDING AGENCIES PRIVATE LIMITED',
    'Sms onwheel logistics private limited',
    'Ens logistics india private limited',
    'TRANSTAR HANDLING & WAREHOUSING PRIVATE LIMITED',
    'Gks freight forwarders private limited',
    'Jesseena marine services private limited',
    'Raft shipping limited',
    'SUIJJIN SHIPPING PRIVATE LIMITED',
    'Bafna aviation private limited',
    'Canopus shipping and trading private limited',
    'S J LOGISTICS (INDIA) LIMITED',
    'Anj logistics private limited',
    'Crane worldwide logistics india private limited',
    'EXM PROJECT MOVERS PRIVATE LIMITED',
    'Lakka intercon logistic solutions private limited',
    'Ecomm freight private limited',
    'Hotline logistics private limited',
    'Express seaways logistics private limited',
    'Pn travels private limited',
    'Shah clearing & forwarding private limited',
    'P.B.L.TRANSPORT CORPORATION PRIVATE LIMITED',
    'Seaking cargo services india) private limited',
    'Shun shing india private limited',
    'R. s. logistics india private limited',
    'Genesis cargo private limited',
    'Cas industries private limited',
    'Big foot logistic private limited',
    'Bwc warehousing private limited',
    'OIL FIELD WAREHOUSE & SERVICES PRIVATE LIMITED',
    'Sbw logistics private limited',
    'Seastar ship management private limited',
    'Dooars transport ltd.',
    'Glory shipmanagement private limited',
    'Winex logistics india private limited',
    'Arista travels private limited',
    'Simran travels private limited',
    'Keralavoyages (india) private limited',
    'Royal tours (india) private limited',
    'Shreya corporate services private limited',
    'Nymphette tours private limited',
    'Aviana travels pvt ltd',
    'Logistic linkage india private limited',
    'Chanson car at call private limited',
    'Atw holidays private limited',
    'AMOS ENTERPRISE PRIVATE LIMITED',
    'Sai seair logistics private limited',
    'Sunworld travel solutions private limited',
    'Je shipping & logistics private limited',
    'MSK SHIPPING & LOGISTICS PRIVATE LIMITED',
    'Kishor transport services private limited',
    'Magnum cargo private limited',
    'Parekh cargo logistics private limited.',
    'Cenmar maritime agencies (india) private limited',
    'Searoute logistics private limited',
    'H.h.shipping agency private limited',
    'Aditya priya logistics limited',
    'Ab consociates private limited',
    'R square mlg logistics private limited',
    'Waavelite communication private limited',
    'On time international logistics private limited',
    'UNIFIED ELECTRO-TECH Private Limited',
    'EXELA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Vihaan telecommunication private limited',
    'Piramal investment advisory services private limited',
    'Le human resources services private limited',
    'Pan asia hr solution private limited',
    'Good samaritan global services private limited',
    'Masterguard protective services private limited',
    'Firewall security solutions private limited',
    'Agile security force private limited',
    'Matrix security and surveillance private limited',
    'Vgkn enterprises private limited',
    'Swastik productions private limited',
    'Proxinet technologies private limited',
    '360 ONE ASSET TRUSTEE LIMITED',
    'Eloquence enterprises private limited',
    'Effects tech s. l. t. private limited',
    'Effects tech sets private limited',
    'Orion scientific suppliers private limited',
    'Mgm global air private limited',
    'Twin top investments advisory services private limited',
    'Green force swm private limited',
    'Spectrum offshore & onshore services private limited',
    'Amanat advisors private limited',
    'EXELLIGENT TECHNOLOGIES PRIVATE LIMITED',
    'Subham corporation private limited',
    'Nanchil facilities private limited',
    'UDM COMMUNICATION PRIVATE LIMITED',
    'Kasim energy resources private limited',
    'Ibex energy private limited',
    'T c tubes private limited',
    'Somya furnisher private limited',
    'Om sai intex private limited',
    'Quality intext private limited',
    'Richie bags & fashions private limited',
    'EASTERN PETRO TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Pru and val strategic services private limited',
    'Affluence commodities private limited',
    'Sugam logistic private limited',
    'Seal clearing & transport private limited',
    'Indivar Beauty Private Limited',
    'Nagomi consulting private limited',
    'PRIME DRILLING PRIVATE LIMITED',
    'Worship trading private limited',
    'Unique tags private limited',
    'AMRAPALI FINCAP Limited',
    'Texshade prefabs private limited',
    'Oddroad holidays private limited',
    'Accure power technologies private limited',
    'EUROFINS HOODI RESOURCES PRIVATE LIMITED',
    'Purple turtles lighting ideas private limited',
    'Sandalwood hospitality private limited',
    'Maple engg-design services (india) private limited',
    'Centracrm solutions india private limited',
    'Sun traders bombay private limited',
    'THE BOMBAY STEVEDORES',
    'S FINE DINE RESTAURANTS PRIVATE LIMITED',
    'Chennai metro rail limited',
    'Nargol rail links private limited',
    'Confidence carriers and logistics private limited',
    'Zen shipping & ports india private limited',
    'Barwin shipping co. private limited',
    'Peak air private limited',
    'Utl movers private limited',
    'Grace global logistics private limited',
    'Cargo & logistics management (india) private limited',
    'A-star logistics (india) private limited',
    'Nippon express (india) private limited',
    'Star shipping services (india) private limited',
    'Essar bulk terminal (salaya) limited',
    'Balram shipping services private limited',
    'Fly wings aviation private limited',
    'Worldwide overseas travel private limited',
    'Gilpin tours and travel management india private limited',
    'Akquasun holidays (india) private limited',
    'Ballal jyoti travels private limited',
    'Zln (india) private limited',
    'Inter trans services (india) private limited',
    'Tls logistics private limited',
    'Orient express ship management limited',
    'BELIEVER MINDWORKS PRIVATE LIMITED',
    'Punna travels private limited',
    'Prime retail india limited',
    'Nw eraa telecom services india private limited',
    'Magnum networks support private limited',
    'Nirvana venture advisors private limited',
    'Aniya investment p ltd',
    'India emerging markets equity private limited',
    'Jai ganesh kuries private limited',
    'Dynemic holdings private limited',
    'AGRIWISE FINSERV LIMITED',
    'Aditya birla financial shared services limited',
    'The rami investments private limited',
    'DELHI INTERNATIONAL CARGO TERMINAL PRIVATE LIMITED',
    'Bookbyair (india) private limited',
    '"K" STEAMSHIP AGENCIES PRIVATE LIMITED',
    'Container movement (bombay) transport private limited',
    'PORTALL INFOSYSTEMS PRIVATE LIMITED',
    'Virat sea forwarder private limited',
    'Ryal logistics private limited',
    'NEPTUNE CONTAINER LINE & LOGISTICS PRIVATE LIMITED',
    'Malca-amit jk logistics private limited',
    'Medallion marine private limited',
    'Fretlog india private limited',
    'Foretell business solutions private limited',
    'Webahn internet solutions private limited',
    'Accuver tele communication private limited',
    'Il&fs infra asset management limited',
    'MONARCH NETWORTH FINSERVE PRIVATE LIMITED',
    'C j global network investment private limited',
    'MORE RETAIL PRIVATE LIMITED',
    'Plaza holding pvt ltd',
    'Rami holdings private limited',
    'Starwing developers private limited',
    'I-STAY REAL ESTATE PRIVATE LIMITED',
    'Networth financial services limited',
    'Inovative service providers private limited',
    'ST HELEN',
    'S MEDIA ANDENTERTAINMENT PRIVATE LIMITED',
    'K2 learning resources (india) private limited',
    'I-tech avionics india private limited',
    'Dscign biosys private limited',
    'Leading edge advisory services private limited',
    'Cosphi engineering india private limited',
    'D2l clinical solutions private limited',
    'Agarwal hospitality private limited',
    'ALLIED TERMINALS & INFRA LIMITED',
    'Karishma marine solutions private limited',
    'Digit 9.0 web marketing private limited',
    'Jvp palazzo private limited',
    'Alcor mergers and acquisitions private limited',
    'DILIGENS CORPORATE SERVICES PRIVATE LIMITED',
    'Cygnus power infra services private limited',
    'CALIMEX IT INDIA PRIVATE LIMITED',
    'HAMSAHARSHAA FILMS PRIVATE LIMITED',
    'Pinnacle manpower services private limited',
    'Mm corporate security services private limited',
    'Trig detectives pvt ltd',
    'Securesearch screening services private limited',
    'Universal verifications private limited',
    'ABC INTERIOR & EXTERIOR SOLUTIONS PRIVATE LIMITED',
    'Ace multifreight logistics private limited',
    'Srinathji glazings private limited',
    'MOVING PIXELS PRIVATE LIMITED',
    'Gray hat private limited',
    'Innovatia india knowledge management services private limited',
    'Recall india information management private limited',
    'Recall total information management (india) private limited',
    'Tsa process equipments private limited',
    'Bfc forex and financial services private limited',
    'Crh india management services private limited',
    'ANRO PETROCHEM LIMITED',
    'Shroff infraventures private limited',
    'HSAG CONSULTING PRIVATE LIMITED',
    'Research rating and communication private limited',
    'A&A BUSINESS CONSULTING PRIVATE LIMITED',
    'ADV PARTNERS INVESTMENT ADVISER INDIA PRIVATE LIMITED',
    'Prism biomed consultancy private limited',
    'Blue ocean transtrade private limited',
    'Pantomath investor awareness and csr foundation',
    'PENTAGON STOCK BROKERS PRIVATE LIMITED',
    'MINERVA INDIA ADVISORS PRIVATE LIMITED',
    'Nilons enterprises private limited',
    'Analogic automation private limited',
    'Can automotion private limited',
    'Steel plantech engineering india private limited',
    'Gamey security solutions private limited',
    'Edvance pre-schools private limited',
    'SHIAMAK DAVARâ€™S INSTITUTE FOR PERFORMING ARTS PRIVATE LIMITED',
    'GSDL SKILLS PRIVATE LIMITED',
    'Cellcys labs private limited',
    'White cross health initiatives private limited',
    'Centre for digestive and kidney diseases (india) private limited',
    'Sadhikaratha foundation',
    'Hyderabad institute of urology private limited',
    'Credence remedies private limited',
    'Excellent insurance broking services limited',
    'Avenue graphics private limited',
    'Red carpet entertainment & marketing private limited',
    'Whiteleaf entertainment media private limited',
    'ESKAY HOSPITALITY SERVICES INDIA PRIVATELIMITED',
    'NUMBERTREE VENTURES PRIVATE LIMITED',
    'Bandra west pictures private limited',
    'Brs entertainment private limited',
    'Umesh ved advisors private limited',
    'Platoz hr private limited',
    'Brandscapes india marketing advisory private limited',
    'Indus mega food park private limited',
    'Sarla s beauty solutions private limited',
    'Everyday facility services private limited',
    'Ellora project consultants private limited',
    'Credit suisse services (india) private limited',
    'Transworld garnet india private limited',
    'Novus professional services private limited',
    'AVIK PHARMACEUTICAL LIMITED',
    'Apeego marketing limited',
    'Omni cans and printers private limited',
    'Island star mall developers private limited',
    'Sanrachana structural strengthening private limited',
    'Nandan buildcon private limited',
    'LIKHITHA INFRASTRUCTURE LIMITED',
    'Delta steel structures private limited',
    'Harmony residences private limited',
    'West india infratech private limited',
    'M.s. khurana engineering limited',
    'Sompura stonecraft private limited',
    'Lohegaon integrated township development corporation private limited',
    'MANGALESH VENTURES PRIVATE LIMITED',
    'Ameet infrastructure private limited',
    'TRENCHLESS ENGINEERING AND SALES PRIVATELIMITED',
    'Shivalik ventures city developers private limited',
    'Hbs infraengineers india private limited',
    'Hubtown bus terminal (mehsana) private limited',
    'VH TOWNSHIP PRIVATE LIMITED',
    'Solaris properties private limited',
    'Ardham logistics and infrastructure private limited',
    'Prajani apartments private limited',
    'Narmada cars private limited',
    'Rajprabhu traders private limited',
    'Radix innovations private limited',
    'Flipkart internet private limited',
    'Risk care insurance broking services private limited',
    'Fortune kitchenware private limited',
    'Amca equipments private limited',
    'Ihc parts and services (india) private limited',
    'Hss traders private limited',
    'Paradox communications private limited',
    'Rosenberg ventilation systems india private limited',
    'Greenline energy equipments private limited',
    'Tata international limited',
    'Sat exporters private limited',
    'Flipkart india private limited',
    'MANE KANCOR INGREDIENTS PRIVATE LIMITED',
    'Bobst india private limited',
    'Retail detailz india private limited',
    'Customer centria enterprise solutions private limited',
    'SUN-POWER METALICS PRIVATE LIMITED',
    'Scintan india private limited',
    'Anima corporation private limited',
    'Subhiksha trading services limited',
    'Eswari exports private limited',
    'Rasapoorna foods private limited',
    'Panacea villas private limited',
    'Jayaleela corporation private limited',
    'CAFE D',
    'K',
    'S LABORATORIES PRIVATE LIMITED',
    'Elasto tapes limited',
    'THE ALLIED FOUNDERS PRIVATE LIMITED',
    'Cloud wave technologies private limited',
    'Southern metals and alloys private limited',
    'Kohinoor india private ltd',
    'RAVAGO SHAH POLYMERS PRIVATE LIMITED',
    'Prakash techno plast india private limited',
    'Arya iron and steel company private limited',
    'United rubber pvt ltd',
    'Dabur pharmaceutical ltd',
    'Suvik hitek pvt ltd',
    'VENKATESHWARA CHEMICALS & PLASTICS PRIVATE LIMITED',
    'Global poly bags industries private limited',
    'Vijaya mirror and glass works private limited',
    'Lasons india private limited',
    'KOTHARI METSOL PRIVATE LIMITED',
    'Madanlal steels & forgings private limited',
    'Gibraltar glass and ceramics private limited',
    'Jayshree ceramics pvt ltd',
    'RAIC INTEGRATED SPONGE & POWER PRIVATE LIMITED',
    'Metal-grace injection alloys private limited',
    'Tecon tiles private limited',
    'Shriram rubber products private limited',
    'Sanjay techno products private limited',
    'Hultec bhimrajka industries private limited',
    'Raviraj polymere pvt ltd',
    'Nandan steels and power limited',
    'Shivam hi-tech steels private limited',
    'Lakhani belmak steel limited',
    'Rajputana stainless limited',
    'Mala plast india private limited',
    'Manikandan automobile private limited',
    'Ace automobiles private limited',
    'MANIKSEM PRIVATE LIMITED',
    'D.d.i. motors private limited',
    'B k b transport private limited',
    'Batliboi impex limited',
    'AJMERA PHARMASURE Limited',
    'Navjeevan equity broking private limited',
    'Choicest enterprises ltd',
    'Chicky traders pvt ltd',
    'Zenith sales promotion pvt. ltd.',
    'Jiya exim private limited',
    'Luxurious car seats private limited',
    'Woojin automotive india private limited',
    'Signature automobiles india private limited',
    'Rankers international private limited',
    'Atco management pvt ltd',
    'Unicon marketing pvt ltd',
    'Select commodities private limited',
    'Nirala merchants private limited',
    'Barbarik commotrade private limited',
    'Ajanta suppliers private limited',
    'Innovative vinimay private limited',
    'Dealmark trading private limited',
    'Gouriputra consultants pvt ltd',
    'Unique vanijya pvt ltd',
    'Taxus infrastructure and power projects private limited',
    'Neotex yarns private limited',
    'Azad impex private limited',
    'Trutech constructions private limited',
    'Bramha bazaz inns private limited',
    'Nice dealers private limited',
    'S n h exports private limited',
    'Pkg steel private limited',
    'Suncity commotrade private limited',
    'Hosokawa micron india private limited',
    'Chamong tee exports pvt ltd',
    'EVERRISE FOOD & BEVERAGE PVT LTD',
    'Navjeevan trade and commodities private limited',
    'Kreem foods pvt ltd',
    'Vado products private limited',
    'Swayaka impex private limited',
    'Prateek garment accessories private limited',
    'Ma exports private limited',
    'Surprise suppliers private limited',
    'Standard refrigeration private limited',
    'Damodar mangalji and company limited',
    'Emami group of companies pvt ltd',
    'BRIGHT SOLAR LIMITED',
    'Kamnath impex private limited',
    'PENTA GOLD LIMITED',
    'Martins impex pvt. ltd.',
    'Vanamo care private limited',
    'Energy avenues private limited',
    'Shubham transoceanic private limited',
    'Taylor devices india private limited',
    'Mohak commodities private limited',
    'Adish tie-up pvt ltd',
    'Wellarea trading pvt.ltd.',
    'NRL CLAYBURN PRIVATE LIMITED',
    'Associated composite materials private limited',
    'Pioneer enliven impex private limited',
    'AGROTRADE ENTERPRISES LIMITED',
    'Minerva auto motors private limited',
    'Swift management pvt.ltd.',
    'Prestige vyapaar limited.',
    'Matashree mercantile pvt ltd',
    'Oxide tie-up private limited',
    'Shivshakti sealink private limited',
    'Amazing suppliers private limited',
    'Esprit techno design pvt ltd',
    'Eds instruments and systems private limited',
    'Sbp medicare systems private limited',
    'Nulife consultants and distributors private limited.',
    'Pragati business limited',
    'Trustline gold private limited',
    'GAMLAA BIOSCAPES PRIVATE LIMITED',
    'United properties & leasing private limited',
    'Raffles enterprises private limited',
    'Salient tex mill private limited',
    'Garden textiles private limited',
    'Exemplary trading and agencies ltd',
    'Alabama trading co pvt ltd',
    'Anksh trading private limited',
    'Jakari trading pvt ltd',
    'United alacrity (india) private limited',
    'ALLIED ELECTRONICS AND MAGNETICS PRIVATELIMITED',
    'Softel networks private limited',
    'Filwel products india private limited',
    'Empire impex private limited',
    'Neerja traders private limited',
    'Sunlord export private limited',
    'Rising future marketing limited',
    'Amtek medical systems private limited',
    'Safa gold pandikkad private limited',
    'Glacier trades private limited',
    'ACME GLOBAL BRANDS PRIVATE LIMITED',
    'Unity vayapaar private limited',
    'Deesan power limited',
    'Malchand dindayal salts private limited',
    'Shining star agencies private limited',
    'Spider pest control private limited',
    'Jain group ventures private limited',
    'Star ventures marketing private limited',
    'Jms marketing services pvt ltd',
    'Adwitiya property solutions private limited',
    'Lutyens habitat private limited',
    'Zinnia promoters & developers private limited.',
    'MAPSKO SHOES PRIVATE LIMITED',
    'Triveni buildwell private limited',
    'Ramprastha townships private limited',
    'GOPAL BUILDCON PRIVATE LIMITED',
    'Om jai jagdish infrastructure private limited',
    'SAMSARA ENERGY LIMITED',
    'Vs realprojects private limited',
    'Auspicious builders private limited',
    'Logical promoters private limited',
    'Auspicious developers private limited',
    'Palash building solutions private limited',
    'Fairview infrastructures private limited',
    'Cherry developers private limited',
    'SKH HOSPITALITY PRIVATE LIMITED',
    'MODEL ECONOMIC TOWNSHIP LIMITED',
    'Ninex dhoot developers private limited',
    'Time centre maintenance services private limited',
    'Beach gate tourism and hospitality services private limited',
    'Arya landscape and property private limited',
    'SIC ROBO AND INFO PRIVATE LIMITED',
    'Utsav infratech private limited',
    'Sugarh properties pvt ltd',
    'Irc infra & realty private limited',
    'Attalika builders pvt ltd',
    'Eureka stock & share broking services limited',
    'Wellington infrastructure private limited',
    'Nebula procon pvt ltd',
    'Navneet promoters private limited',
    'Sea-hill garden resorts private limited',
    'Ansh infraprojects private limited',
    'RADIK CHEMICALS PRIVATE LIMITED',
    'Jubilee hills residency limited',
    'Happychoices infra project private limited',
    'Winsome park private limited',
    'Lifewood developers private limited',
    'Hardsoft constructions private limited',
    'Alcore properties private limited',
    'Esagilla developers private limited',
    'Jagmata enclave private limited',
    'Leda projects private limited',
    'Tak buildtech private limited',
    'Golden bricks weekend homes private limited',
    'Sapam properties private limited',
    'KGV REALTORS PRIVATE LIMITED',
    'Shrim projects private limited',
    'Aryavart housing private limited',
    'Malvan real estates private limited',
    'Rajapur real estates private limited',
    'Sangmeshwar real estates private limited',
    'Devgad real estates private limited',
    'Summit developments private limited',
    'Richmond housing ventures private limited',
    'Ashish real estates pvt ltd',
    'BALEWADI TECHPARK PRIVATE LIMITED',
    'Germanus properties private limited',
    'Sai uvr properties private limited',
    'Nda property developers private limited',
    'Ra property developers (tirupur) private limited',
    'Rr evergreen developers (india) private limited',
    'Easiup rentals private limited',
    'Ferns n petals pvt ltd',
    'INTARVO TECHNOLOGIES PRIVATE LIMITED',
    'Dae instrument private limited',
    'Ids infotech limited',
    'U.t. electronics private limited',
    'Stellar data solutions private limited',
    'APPCORE LABS INDIA PRIVATE LIMITED',
    'EROSE EDUCATIONAL INFOTECH PRIVATE LIMITED',
    'Towards vision technologies private limited',
    'India cyberlearning private limited',
    'Padma computers private limited',
    'Anand computech private limited',
    'Access net it solutions private limited',
    'Dev it serv private limited',
    'Rah infotech private limited',
    'Simmtronics infotech private limited',
    'Ndtv labs limited',
    'ACOLAD CONTENT SOLUTIONS INDIA PRIVATE LIMITED',
    'P b tech impact solutions private limited',
    'Techtree i t systems private limited',
    'Mct india infotech private limited',
    'Servepro warranty services private limited',
    'Ps corporate solutions private limited',
    'CHRONICLE BOOKS PRIVATE LIMITED',
    'Acs global tech solutions private limited',
    'Mobishastra technologies private limited',
    'Apical consulting private limited',
    'Alpha enhanced data private limited',
    'Techpragma technologies solutions private limited',
    'Instaserv india private limited',
    'Newage living solutions private limited',
    'Raj info enterprise private limited',
    'Infodesk india private limited',
    'Add-e solutions private limited',
    'Techgrains technologies private limited',
    'Viewfinder technologies private limited',
    'Coreel technologies (india) private limited',
    'Melange systems private limited',
    'Unified gateways (india) private limited',
    'Sra india private limited',
    'S.s. bizcon private limited',
    'Indian paint and coating associaton',
    'April sourcing private limited',
    'P i forwarding company (india) private limited',
    'Jaypee meghalaya power limited',
    'Effectual knowledge services private limited',
    'Flow education and culture consultants private limited',
    'Skp corporate advisors private limited',
    'Dlp india edutech private limited',
    'Ajmani forex and customer services private limited',
    'Anti counterfeiting force private limited',
    'J curve ventures private limited',
    'Jrb eventz management private limited',
    'Ocean glass trading india private limited',
    'Optimal transnational india private limited',
    'Glorious elevators private limited',
    'Allied agritech private limited',
    'Novo management consulting private limited',
    'Ametheus commodities private limited',
    'Next level projects private limited',
    'Turacoz healthcare solutions private limited',
    'Pro eyetech elektrotekniks private limited',
    'Sequel logistics private limited',
    'Hays business solutions private limited',
    'CINNAMON MARKETING SERVICES PRIVATE LIMITED',
    'Shyn management services private limited',
    'Big boys lifestyle private limited',
    'Shaolin trusteeship private limited',
    'Pennington label solutions private limited',
    'Vahini irrigation private limited',
    'Bask hr consulting private limited',
    'Bbw brushes private limited',
    'Lepakshi science and technology park private limited',
    'Traks india safety solutions private limited',
    'Vishwa bharati foods private limited',
    'Gujarat sulphur ltd',
    'Dgp enterprises private limited',
    'Magus investment advisory private limited',
    'Raysons marketing private limited',
    'Asmacs contractors and consultancy service limited',
    'Sanjay techno plast private limited',
    'Matrix distributor private limited',
    'Micro petrochem private limited',
    'Cosmicmandala15 securities private limited',
    'Icon projects inspace private limited',
    'Rkca xat advisors private limited',
    'Suntej fabrics private limited',
    'Kja technologies private limited',
    'Cermet resistronics private limited',
    'A to z mech (india) private limited',
    'Kinetic auto parking systems private limited',
    'Satav bricks company private limited',
    'Shreegowardhan nutrayur private limited',
    'Viswas business synergies private limited',
    'Tca consultants private limited',
    'Sanpra projects & services private limited',
    'Lupin telepower private limited',
    'Hienfatech clads private limited',
    'Prashanth overseas supplies house private limited',
    'Institute for industry careers private limited',
    'Chennai mettex lab private limited',
    'Skr accounting private limited',
    'Vana vidyut private limited',
    'Mudra soft technologies private limited',
    'Kemutech india private limited',
    'Shri varalakshmi pride malls private limited',
    'HANS MACHINERIES PRIVATE LIMITED',
    'CALDERYS STEELCASTING INDIA PRIVATE LIMITED',
    'Magnum surveyors (i) private limited',
    'Eskillport hr services private limited',
    'Strategic air services private limited',
    'Mahakal dealtrade private limited',
    'Adarsh heights private limited',
    'Shimpo exports private limited',
    'Gruppent technologie private limited',
    'Vdma india services private limited',
    'Raidmax technologies private limited',
    'Rosy blue foundation',
    'Rvs shares stock broking services pvt.ltd.',
    'Innovative thought process private limited',
    'Emami education and research foundation',
    'North educational academy (india) private limited',
    'Oks education private limited',
    'Raffles educity (i) private limited',
    'Superlike educational solutions private limited',
    'Education pundits and training services private limited',
    'Auriga learning private limited',
    'Dream india edu management solutions private limited',
    'Compass education overseas academy private limited',
    'Bebo technical education services private limited',
    'Vera edu-manage private limited',
    'Vera edu-infra private limited',
    'Zenoxx knowledge services private limited',
    'Magic abacus education private limited',
    'SAI EDUCARE PRIVATE LIMITED',
    'Mechaero foundation for technical research and education excellence',
    'Eastman learning solutions private limited',
    'Himalayan gurukul ltd.',
    'Arcum technical services private limited',
    'Nifd institute of fashion design limited',
    'Jagannath educational institutions private limited',
    'American society for quality india private limited',
    'Kakini enterprises private limited',
    'Sunsat educational academy private limited',
    'Serenata del cuore hospitality and exim private limited',
    'Xllent cargo transports private limited',
    'Dey logistics and services private limited',
    'Sunira bulk agencies private limited',
    'Skand private limited',
    'Unity movers private limited',
    'Mint cabs private limited',
    'LX PANTOS SOLUTIONS INDIA PRIVATE LIMITED',
    'AMNS STEEL LOGISTICS LIMITED',
    'Iko hospitality private limited',
    'Wilderness resorts private limited',
    'Garden palace hotels and resorts private limited',
    'Millennium farm resorts (india) private limited',
    'THE CASTLE MOTELS PRIVATE LIMITED',
    'Moets aravali resorts private limited',
    'Jai bharat transport agency private limited',
    'Dacotrans india private limited',
    'Melrose port operations and infrastructure private limited',
    'Sea freight pvt ltd',
    'German express shipping agency (india) pvt ltd',
    'Altra forwarder private limited',
    'Trinity shipping and allied services private limited',
    'Cargopeople logistics & shipping private limited',
    'BIRD EXECUJET AIRPORT SERVICES PRIVATE LIMITED',
    'Sojourn vacations private limited',
    'BRACK CAPITAL LOGISTICS & INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'Lw shipping private limited',
    'Amal logistics services private limited',
    'Shriya raj resorts and farms private limited',
    'Savi resorts and farms private limited',
    'Lakend hotels and motels private limited',
    'Nanak hospitality private limited',
    'Jot hospitality private limited',
    'Route logistics india private limited',
    'Matsya sea storage private limited',
    'Vivek freight & logistics private limited',
    'Amrit seair express private limited',
    'Spg shipping private limited',
    'Unica logistics and services private limited.',
    'Rang-colours of india private limited',
    'Obhan warehousing private limited',
    'Mansai agro industries private limited',
    'Shiv restaurant and food private limited',
    'Savourites hospitality private limited',
    'PINKCITY TOURIST VILLAGE COMPLEX PRIVATE LIMITED',
    'Kairali ayurvedic health resorts private limited',
    'Coronation travels private limited',
    'Amar tours private limited',
    'Travelite holidays (india) private limited',
    'Zutshi travel world service private limited',
    'Kumaon resorts private limited',
    'Kas hospitality private limited',
    'Hkx logistics india private limited',
    'Supertrack logistics private limited',
    'Wynad holidays private limited',
    'Shriya shyam resorts and farms private limited',
    'Shree nandhi silks private limited',
    'Thalappakatti hotels private limited',
    'Disco enterprises private limited',
    'Incentive destinations private limited',
    'Radical freight services private limited',
    'Niko travels private limited',
    'Cloud nine hospitalities private limited',
    'Kibria india tours private limited',
    'Stic travia solutions private limited',
    'Catai india private limited',
    'Metropolitan transport corporation (chennai) limited',
    'Satvik enterprises limited',
    'Nls fleets private limited',
    'Lohit enterprises private limited',
    'Cogent logistics private limited',
    'Svdk logistics private limited',
    'Vanshika shipping and logistics private limited',
    'Desert friendly camps private limited',
    'Logistics plus india private limited',
    'Smv worldwide logistics private limited',
    'Krish road carriers private limited',
    'ASPAM CARAVAN LOGISTICS PARKS PRIVATE LIMITED',
    'Rajdoot logistics private limited',
    'J b t a logistics private limited',
    'Newfangled logistics private limited',
    'Wizard events and conferences private limited',
    'Lande patil transport private limited',
    'AEGIS VOPAK TERMINALS LIMITED',
    'Sai indent tradelink private limited',
    'Carewell tour and travels private limited',
    'Aegis terminal (pipavav) limited',
    'Fellys travels private limited',
    'Go ways travels & tours private limited',
    'Sriniwas fatehpuria pvt ltd',
    'Telephone systems (india) private limited',
    'Mudpie india communication private limited',
    'INSTA APPHANCED PRIVATE LIMITED',
    'Ace chemicals company private limited',
    'Janak cargo movers pvt ltd',
    'Navlakhi tours and travels private limited',
    'Patron agro services private limited',
    'Zeus travels private limited',
    'Nicco ventures limited',
    'Brandsum tech solutions private limited',
    'Blue hill technologies private limited',
    'Sondhi enterprises private limited',
    'Bout india tours private limited',
    'SUMITSU TRADE APPARELS PRIVATE LIMITED',
    'Viknesh travel and cargo private limited',
    'Jet setters limited',
    'Gujarat finance limited',
    'Mulji devshi export private limited',
    'Andhra pradesh state minorities finance corpn ltd',
    'Ecs globe air cargo india private limited',
    'Drishti cruise and ferries private limited',
    'Mithals enterprise pvt ltd',
    'Wingflow construction private limited',
    'Ganga export and marketing private limited',
    'Qfs consultancy private limited',
    'Interocean shipping (india) private limited',
    'Okhla polymers private limited',
    'Skyline associates private limited',
    'Express towers private limited',
    'Chronos richardson india private limited',
    'Rajhans infratech private limited',
    'Motilal banarsi dass publishers private limited',
    'Interconti projects pvt ltd',
    'AYUSH TAX & FINANCE CONSULTANTS PRIVATE LIMITED',
    'Roots air systems private limited',
    'R n towers pvt ltd',
    'J.s.nirman private limited',
    'Chawla leathers private limited',
    'Digitalforce online india private limited',
    'Smms engineering systems private limited',
    'Pew engineering private limited',
    'Colmar condominium private limited',
    'Dbx logistics private limited',
    'Aesthetik engineers private limited',
    'Kam auto engineering & validation private limited',
    'Zorba books private limited (opc)',
    'D.k.agencies private limited',
    'Indure louise private limited',
    'Pioneer aluminium private limited',
    'Siya ram bros (rajasthan) private limited.',
    'Orchid overseas private limited',
    'Unnath advertising private limited',
    'Superior drinks pvt ltd',
    'A s shoe accessories private limited',
    'Dr bishandas malhotra memorial hospital private limited',
    'Pine fabricators private limited',
    'Rng trading company private limited',
    'Malika overseas private limited',
    'Richa consultants private limited',
    'INCRED PRIME FINANCE LIMITED',
    'Arc security solutions private limited',
    'Maru investment and finance private limited',
    'Ipe global social services private limited',
    'Bhaumati constructions private limited',
    'Himalayan river runners india private limited',
    'Apsom infotex limited',
    'Tritronics india private limited',
    'Abc transformers private limited',
    'Aegis corporate solutions private limited',
    'Atal house and engg. works private limited',
    'Hintek electronics private limited',
    'Wahi enterprises private limited',
    'Passfield holdings private limited',
    'Verala leather exports private limited',
    'Rational it park private limited',
    'Rossland pharmaceuticals private limited',
    'Rajat plastic products private limited',
    'Elcom trading company private limited',
    'Cyber park india private limited',
    'Lotus trans travel private limited',
    'Sunny exports private limited',
    'Pioneer petro chem private limited',
    'Amici chits private limited',
    'Luthra metal industries pvt ltd',
    'Sai powerware marketing private limited',
    'Bittoo plastic products private limited',
    'Shama international private limited',
    'Dilwale properties private limited',
    'Ocean pearl hotels private limited',
    'Aesa air engineering private limited',
    'Ushank telecommunications limited',
    'K m holdings private limited',
    'Madhumuskan publication private limited',
    'Sophos engineering private limited',
    'S g quantum services private limited',
    'Amari investments private limited',
    'Cs continental marketing private limited',
    'Insight development consulting group private limited',
    'COMPACK ENTERPRISE INDIA PRIVATE LIMITED',
    'Triverse advertising private limited.',
    'Rawla and co private limited',
    'Reetika builders private ltd.',
    'Umendra exports private limited',
    'Bahisht farms private limited',
    'Agrim corporate services limited',
    'ZENITH ROLLERS PRIVATE LIMITED',
    'Wahi sons private limited',
    'Orient texfabs private limited',
    'Al-sapphire facade private limited',
    'Wazir properties pvt ltd',
    'G d x detectives private limited',
    'Padam electricals limited',
    'Haryana city gas distribution limited',
    'Skp intex private limited',
    'Trans link express (india) private limited',
    'Shikha polymers private ltd',
    'Summit aviation private limited',
    'Capri sales and services private limited',
    'Cipher buildtek private limited',
    'Infrahealth india private limited',
    'Shuveta leasing and finance private ltd',
    'Osgan realty services private limited',
    'Shital text private limited',
    'Nuvista technologies private limited',
    'Vacation resorts international hills private limited',
    'Roseview meadows private limited',
    'R f b latex limited',
    'Microweb solutions private limited',
    'Speed paints private limited',
    'Kissan bio fuel private limited',
    'Infonauts design private limited',
    'Naresh industries private limited',
    'Protectum consultants private limited',
    'Syngenta biosciences private limited',
    'ERIS HEALTHCARE PRIVATE LIMITED',
    'BRAMHACORP INFRASTRUCTURES PRIVATE LIMITED',
    'Glow paints private limited',
    'Multi fastners private limited',
    'Cachet pharmaceuticals private limited',
    'Falma laboratories private limited',
    'Promethean media private limited',
    'Welspun anjar sez limited',
    'Dezignare fashion private limited',
    'Sunstar expositions private limited',
    'Affiliated media company private limited',
    'A j coal private limited',
    'Shanti intermediates private limited',
    'Karan intermediates private limited',
    'INDO COLCHEM LIMITED',
    'Supreem pharmaceuticals mysore private limited',
    'Gennova biopharmaceuticals limited',
    'Stedman pharmaceuticals private limited',
    'Greenstar fertilizers limited',
    'Sarada starch & chemicals private limited',
    'Kbc solvex private limited',
    'Medpace clinical research india private limited',
    'Gujarat life sciences private limited',
    'Himalaya drug company private limited',
    'Chandigarh oxygen ltd',
    'Arlak biotech private limited',
    'Rmc med limited',
    'JAWA PHARMACEUTICALS (INDIA) PVT. LTD',
    'Admiron life sciences private limited',
    'Bay petroplast pvt ltd',
    'Estrich biomedic private limited',
    'Plastochem pvt ltd',
    'Sicaf private limited',
    'Sunshine fine chemsol india private limited',
    'Dee pee inks private limited',
    'Innocia lifesciences private limited',
    'Sunplant agro products private limited',
    'Holoflex limited',
    'Rigil biotech private limited',
    'Kairali herbal cures private limited',
    'MEDMATE PHARMA PRIVATE LIMITED',
    'Antrix healthcare private limited',
    'Vital biotechnologies private limited',
    'Syntho chirals private limited',
    'Shroff polycraft private limited',
    'Raj redef media private limited',
    'Sai surfactants pvt ltd',
    'Srvm chemical & soap private limited',
    'Rifas fragrances private limited',
    'Diamond products printing and processing limited',
    'Sbl energy limited',
    'Jai polymers co pvt ltd',
    'Rathi salt and grains private limited',
    'Arham petrochem private limited',
    'Labsupplies india private limited',
    'Indian foundry chemicals pvt ltd',
    'Future tyres private limited',
    'Alpharub trading and manufacturing private limited',
    'Karikode rubbers ltd',
    'Trac media private limited',
    'Assam printing works pvt ltd',
    'Atlantic research lab private limited',
    'BENEXI VINYL PRIVATE LIMITED',
    'Flamingo mould plastics pvt ltd',
    'Maruthi metals and plastics private limited',
    'Lyka packaging private limited',
    'Exotica global private limited',
    'Abdos lamitubes private limited',
    'PANCITY TECH PRIVATE LIMITED',
    'Trimurti autoplast private limited',
    'Solvochem intermediates private limited',
    'Biloree cast (india) pvt ltd',
    'Scott edil pharmacia limited',
    'Oncare pharmaceuticals private limited',
    'Veritas life sciences limited',
    'Vasa laboratories and chemicals pvt ltd',
    'Coin pharmaceuticals private limited',
    'Ack imaging tek private limited',
    'Tri star plastics pvt ltd',
    'Om plastomac industries private limited',
    'Thaikkattu mooss e t m oushadhasala india limited',
    'Vaidyaratnam oushadhasala private limited',
    'Innovare labs private limited',
    'Pearl polychem private limited',
    'RAD GLOBAL PRIVATE LIMITED',
    'Guardian plasticote ltd',
    'Churiwal technopack private limited',
    'Nimbus irrigation pvt. ltd.',
    'Suolificio linea italia (india) private limited',
    'Stc polymers private limited',
    'N K PROTEINS Private Limited',
    'Chorus pharmachem private limited',
    'Heramb thermoplastics pvt ltd',
    'Odyssey craft private limited',
    'Jain brothers sanitation private limited',
    'Maithan ceramic ltd',
    'Glossy ceramics private limited',
    'Tosc international private limited',
    'Jaipur ceramics private limited',
    'Ruparel cement limited',
    'Vidhata cement company private limited',
    'Ritman concrete private limited',
    'Reltech biomedical systems ltd',
    'Sahajanand soaps and chemicals pvt ltd',
    'Sol alloys private limited',
    'Alfin blowers private limited',
    'Sandoz private limited',
    'Gencare pharmaceuticals private limited',
    'Apan imex private limited',
    'A k d trade link private limited',
    'Arion vyapar private limited',
    'Kolhan trading private limited',
    'Kalash vyapaar private limited',
    'G.a. morgan dynamics private limited',
    'Murthy sales pvt ltd',
    'B v commercial pvt ltd',
    'Temple tradecom private limited',
    'Devansh vyapaar pvt ltd',
    'Godbalaji commercial pvt ltd',
    'Karanashok auto private limited',
    'Efl impex private limited',
    'Vedansh builders private limited',
    'Admire vyapaar private limited',
    'Worlds window wardha infrastructure private limited',
    'South india corporation travancore pvt ltd',
    'S koder private limited',
    'URSS TECHSERVICES PRIVATE LIMITED',
    'K u advani pvt ltd',
    'ADVAY ESTATES PRIVATE LIMITED',
    'Happy suppliers private limited',
    'Shagun vyapaar private limited',
    'Mahalakshmi dealcom private limited',
    'Adarsh tradecom private limited',
    'Hari marketing private limited',
    'Sidhi vinayak mobiles private limited',
    'Prabal dealcom private limited',
    'Sloke traders private limited',
    'Vedant dealcom private limited',
    'Diamond rock pvt ltd',
    'Pixel commercial private limited',
    'Accord barter private limited',
    'Mahavir tradevin private limited',
    'Booster vinimay private limited',
    'Action commotrade private limited',
    'SHRI KRISHNA DEALERS PVT. LTD',
    'Mukandlal motilal woollens private limited',
    'INDOSPIRIT BARS PRIVATE LIMITED',
    'INDOSPIRIT BEVERAGES PRIVATE LIMITED',
    'Golden estuary trading private limited',
    'Treta agro private limited',
    'Kapsons fashion private limited',
    'Ashi creation private limited',
    'HATS OFF ACCESSORIES PRIVATE LIMITED',
    'Muskan dealcomm pvt. ltd.',
    'Nortel vincom pvt.ltd.',
    'Ranital investments pvt ltd',
    'DENTORTH INDIA PRIVATE LIMITED',
    'J d marketing pvt ltd',
    'Peeyes petrofill services private limited',
    'Spectrum commodities pvt ltd',
    'Unijoints fabrication private limited',
    'GRAMEEN SHAKTI MICROFINANCE SERVICES PRIVATE LIMITED',
    'Blessings trades private limited',
    'Saiom marketing private limited',
    'Veenus auto fin insurance & properties private limited',
    'M. e energy private limited',
    'Shacom tex private limited',
    'Jbt greentech equipments and services private limited',
    'Asia engineering supply stores pvt ltd',
    'Netfinity technologies (india) private limited',
    'Sunlight merchandise pvt ltd',
    'Sungrace suppliers private limited',
    'R shankarlal sales private limited',
    'Ihm valves private limited',
    'Kalindi agency pvt ltd',
    'Dura chemical corporation private limited',
    'Sah and sanghi auto agencies private limited',
    'Patel holdings limited',
    'Aurungabad oil extraction company private limited',
    'Sanghvi brothers trading pvt. ltd.',
    'Umang vyapaar private limited',
    'Capable marketing company private limited',
    'Apple mines & minerals private limited',
    'Sana imports and exports private limited',
    'Logistics park (india) private limited',
    'Vertex corrotech solutions private limited',
    'Meghavi tie-up (p) ltd',
    'Apnapan merchandise private limited',
    'Guiness 16anna.com marketing private limited',
    'Seasons tradcomm private limited',
    'Baisakhi goods private limited',
    'Kohinoor goods private limited',
    'Saurabh marketing private ltd.',
    'Savana intrade private limited',
    'Cross world associates private limited',
    'Techno trexim (india) private limited',
    'S g informatics (india) private limited',
    'Cashco (india) private limited',
    'Royal tradelinks private limited',
    'Accurate exim private limited',
    'Hca garment machinery private limited',
    'Candid marketing private limited',
    'Stallone overseas private limited',
    'Supersonic marketing private limited',
    'Saksham impex private limited',
    'Strange exports private limited',
    'A r sales private limited',
    'C k sachit impex private limited',
    'Iq enterprises (india) private limited',
    'Bestway agencies private limited',
    'Shri dwarkadheesh enterprises private limited',
    'Woodpeckers euro lumbers private limited',
    'Sukhsagar dealers private limited',
    'Circle tracom private limited',
    'Star mobitel limited',
    'Cpl trading company private limited',
    'RESOL VINYLS AND CHLORIDES LIMITED',
    'Innocent commodities private limited.',
    'Fabulous properties private limited',
    'Badrinath infrabuild private limited',
    'Adinath infracon private limited',
    'Pinion developers private limited',
    'Paharpur asansol properties private limited',
    'Karukrit realty private limited',
    'Circle infra projects private limited',
    'CELICA AUTOMOTIVE PRIVATE LIMITED',
    'Howrah conclave pvt.ltd.',
    'Singhi finalease pvt ltd',
    'Alike properties private limited',
    'Overtop infrahomes private limited',
    'Muskan plazza private limited',
    'Fairtech resources private limited',
    'Safeway systems private limited',
    'Ginger complex private limited',
    'Premkunj niketan private limited',
    'Neminath nirman private limited',
    'Weblink .in private limited',
    'Foundation futuristic technologies pvt ltd',
    'UM AUTO SOLUTIONS PRIVATE LIMITED',
    'Omegacube techsystems private limited',
    'Bisquare systems private limited',
    'Shree riddhi siddhi buildwell limited',
    'Dhavalakeerti reality and finance private limited',
    'Edmonda development and leasing private limited',
    'Eaton estate and development private limited',
    'Dyuti reality and development private limited',
    'Sumangala industrial parks & investments private limited',
    'Divya jyoti softech private limited',
    'Prudent it services private limited',
    'Greenleaf it consulting private limited',
    'Us tech solutions private limited',
    'Verts services india private limited',
    'Dream soft infotech private limited',
    'Hsg technologies private limited',
    'Aminchand payarelal pvt ltd',
    'Lansdowne towers pvt ltd',
    'Momagic technologies private limited',
    'Shree hari tech solutions private limited',
    'Vartulz technologies private limited',
    'Digital telco network india private limited',
    'Brio interactive technologies private limited',
    'Lakshmi grasslands pvt ltd',
    'Mehandi properties private limited',
    'Siddha enclave private limited',
    'Connect india e-commerce services private limited',
    'Anant softtech private limited',
    'Anupam global-soft limited',
    'Kyra infotech private limited',
    'AASHNI GEOSYNTHETICS PRIVATE LIMITED',
    'POWERSOLV HOSPITALITY PRIVATE LIMITED',
    'Mysoft international private limited',
    'PERFORCE SOFTWARE PRIVATE LIMITED',
    'Enzen global solutions private limited',
    'Yes hardsoft info solutions private limited',
    'Mangalkripa developers private limited',
    'Dharmik awas private limited',
    'Fischer systems india private limited',
    'Inapp information technologies (india) private limited',
    'Cyspan systems private limited',
    'Forent infosolutions private limited',
    'Panchmurti infrastructure private limited',
    'Oval buildcon private limited',
    'FDR PROPERTY SERVICES PRIVATE LIMITED',
    'Systime computers limited',
    'Liberty infoware limited',
    'North media infotech (india) private limited',
    'Bayatree infocom private limited',
    'Thoughtspheres technologies private limited',
    'Q two india private limited',
    'Infoworld consultancy private limited',
    'Complete tech solutions private limited',
    'Tech next software private limited',
    'Inspire infotech private limited',
    'Cluster telecom private limited',
    'Shapoorji pallonji ports private limited',
    'Mega car pool private limited',
    'Lg finvest private limited',
    'Auriga it consulting private limited',
    'Intellipaat software solutions private limited',
    'INSIGHTSOFTWARE INTERNATIONAL PRIVATE LIMITED',
    'Hofincons international private limited',
    'V a solutions private limited',
    'Orangeone information system private limited',
    'Pace infosolutions private limited',
    'Pyramid professional services pvt ltd',
    'Kamal infocomm private limited',
    'Bits private limited',
    'Estel conversion labs private limited',
    'Ace brain technologies private limited',
    'Oab studios software private limited',
    'M g techno savvy private limited',
    'Partridge technologies private limited',
    'Vhs consulting india private limited',
    'Radicle software private limited',
    'Pv softech private limited',
    'Marine software pvt ltd',
    'Digital avenues limited',
    'Optirisk learning systems private limited',
    'Vignesh info-services private limited',
    'Fusion creations private limited',
    'Pursarth infotech private limited',
    'Oneteck automation private limited',
    'Inspiring-life technologies private limited',
    'Intigate technologies private limited',
    'Intelliplanner software system india private limited',
    'Max informatics private limited',
    'Magictel solutions private limited',
    'Maruva cosmeceuticals private limited',
    'BRENNUS PROJECTS PRIVATE LIMITED',
    'Innovative ideaz and events private limited',
    'Sports infratech private limited',
    'Capricorn health services private limited',
    'Ideal gymnasium private limited',
    'INDUCTUS LIMITED',
    'Rajasthan chamber of commerce and industry.',
    'Ajay foundation',
    'INFRASTRUCTURE ENGINEERING PROJECTS INDIA PRIVATE LIMITED',
    'Believe solution services private limited',
    'Inde livelihood foundation',
    'Emission reduction services private limited',
    'IE FOUNDATION FOR EXCELLENCE IN ARTS TECHNOLOGY',
    'C & k management limited',
    'Micro pension foundation',
    'Horizon market research private limited',
    'Rashiexperential marketing & events private limited',
    'Indian leather technologists association',
    'Rajkamal kalamandir private limited',
    'Commsys information system private limited',
    'Magka imaging and technology company private limited',
    'Modern fertility centres private limited',
    'I-dzire hospitality private limited',
    'Rr optinet private limited',
    'Kal cables private limited',
    'Geokno india private limited',
    'Acerhealth onesource private limited',
    'Unitech indraprastha tv limited',
    'REGENT POWER AND INFRAPROJECTS PRIVATE LIMITED',
    'News laundry media private limited',
    'Spt sports management private limited',
    'Gmr league games private limited',
    'Bodycare pathological services private limited',
    'Roads academy private limited',
    'Fabrikare private limited',
    'OMR SHIPPING INDIA PRIVATE LIMITED',
    'Meridian medical research & hospital ltd.',
    'Media nxt india private limited',
    'Imagine services 4 u private limited',
    'Burn gym & spa private limited',
    'Tooki solutions services private limited',
    'Seven3 sports private limited',
    'Novel patent services private limited',
    'Sara events and talent management private limited',
    'PIONEER DIGITAL NEWS PRIVATE LIMITED',
    'Rp waste management private limited',
    'Aaren advertising private limited',
    'Aromathai services private limited',
    'Galaxy cinema pvt ltd',
    'Karnataka wildlife resorts private limited',
    'Geo graphics interiors private limited',
    'Paharimata engineering private limited',
    'Hush india private limited',
    'Jai bajrang vyapar private limited',
    'Asia cranes private limited',
    'Eastern general indusries ltd',
    'THE SUKHJIT STARCH AND CHEMICALS LIMITED',
    'Spectrum foods limited',
    'Raw jute trading & industries limited.',
    'Tamilnadu petroproducts limited',
    'Jd orgochem limited',
    'Aarti industries ltd',
    'Omkar speciality chemicals limited',
    'Jaysynth dyestuff (india) limited',
    'Iol chemicals and pharmaceuticals limited',
    'Ind swift limited',
    'Gujarat themis biosyn ltd',
    'Sunflag iron and steel co ltd',
    'Vardhman special steels limited',
    'Ajmera realty & infra india limited',
    'Polymechplast machines limited',
    'Tpi india limited',
    'Solitaire machine tools limited',
    'KPT INDUSTRIES LIMITED',
    'Scan projects limited',
    'Ventura guaranty limited',
    'The southern gas limited',
    'Sai televisions ltd.',
    'Autolite (india) limited',
    'Cesc ltd',
    'Kore Foods Limited',
    'Kddl limited',
    'Arcotech limited',
    'Sporting syndicate private limited',
    'Best tours & forex private limited',
    'Esquire express (india) private limited',
    'Sri bhuvaneswari security services private limited',
    'O k hosiery mills pvt ltd',
    'Chairav prime data software private limited',
    'PSL MEDIA & COMMUNICATIONS LIMITED',
    'Ashok stores private limited',
    'Sankil investments private limited',
    'Vivek chemical industries private limited',
    'WALLET CIRCLE TECHNOLOGIES LIMITED',
    'Anthropower training private limited',
    'NICT SKILL DEVELOPMENT PRIVATE LIMITED',
    'Immortal corporate services private limited',
    'Roxanna consultancy services private limited',
    'Alkimos consultancy services private limited',
    'Archilab design solutions private limited',
    'Haryana engineering private limited',
    'Monroe impex pvt ltd',
    'Subham polymers pvt ltd',
    'Centroid design private limited',
    'Dreamsplus consulting private limited',
    'Galina consultancy services private limited',
    'Target innovative immigration consultants private limited',
    'Biotron healthcare (india) private limited',
    'Indo crystals private limited',
    'Rockwell automation india private limited',
    'Dextra india private limited',
    'Hygeia labs private limited',
    'Tycon medical devices private limited',
    'VRINDAVAN MEDICAL DEVICE PRIVATE LIMITED',
    'Vision medical devices (india) private limited',
    'Renadial medical private limited',
    'HINDPRAKASH GLOBAL PRIVATE LIMITED',
    'SANKO SVANCE JRG TOOLING INDIA PRIVATE LIMITED',
    'Bausch & lomb india private limited',
    'DR. B. LAL CLINICAL LABORATORY PRIVATE LIMITED',
    'Micro age instruments pvt ltd',
    'Gkb hi-tech lenses private limited',
    'Km wedding events management private limited',
    'Shreeji automobiles private limited',
    'Advance multiserv private limited',
    'Avm engineering india private limited',
    'Aegis elevator private limited',
    'Ramshanihi hydraulics private limited',
    'Gericke vacuum pumps private limited',
    'Budalur equipment manufacturing private limited',
    'Ranaul machinery private limited',
    'BELLMER INDIA PRIVATE LIMITED',
    'Super alloys and metals private limited',
    'Power drives (gujrat) pvt ltd',
    'Vivin switchgear private limited',
    'SAKI AUTO PRODUCTS PRIVATE LIMITED',
    'Sadhav shipping limited',
    'Yagnesh printing company pvt ltd',
    'Suryashakti energy resources private limited',
    'Salcom auto components private limited',
    'PRIDEL PRIVATE LIMITED',
    'Erbis engineering india private limited',
    'Sudharsan equipments private limited',
    'K.b. motors pvt ltd',
    'JRG AUTOMOTIVE INDUSTRIES INDIA PRIVATE LIMITED',
    'Vishnu vaibhav industries private limited',
    'Godawri motors private limited.',
    'San motors limited',
    'TRULIV PROPERTIES & SERVICES PRIVATE LIMITED',
    'PALLAWI RESOURCES PRIVATE LIMITED',
    'Kelson steel products private limited',
    'Jindal sanitaryware private limited',
    'Bell securitech private limited',
    'Essenzaa lifescience limited',
    'Fine platinum (india) limited',
    'Essel kitchenware limited',
    'M suresh company private limited',
    '4s synergies private limited',
    'Glisten electrica private limited',
    'Tade powertech private limited',
    'Vidyut controls and automation private limited',
    'Amrit plastronics private limited',
    'Remag electros private limited',
    'ROYAL INDIA JEWELLERY MANUFACTURING COMPANY PRIVATE LIMITED',
    'SHRI KRISHNA KRIPA JEWELLERS PRIVATE LIMITED',
    'Saga silver private limited',
    'DJIL GLOBAL (I) PRIVATE LIMITED',
    'Concord electricals india private limited',
    'Radium component and accessories private limited',
    'Cuboid infrastructure private limited',
    'Auroville labs private limited',
    'Duke industries private limited',
    'Cag construction equipment private limited',
    'Kasuma auto engineering private limited',
    'Shree maruti steel & energy private limited',
    'Tvh energy resource private limited',
    'Shwill medicom private limited',
    'CERAS INTECH PRIVATE LIMITED',
    'Av science and technologies private limited',
    'D y lab equipments private limited',
    'Khattar marine services private limited',
    'Gmr kamalanga energy limited',
    'BHADRESHWAR VIDYUT PRIVATE LIMITED',
    'Nirlon powercem limited',
    'Jarong hydro-electric power company limited',
    'Hind solar energy private limited',
    'Nabha power limited',
    'Sujana energy limited',
    'Jharkhand electric company limited',
    'Reliable manpower solutions limited',
    'Inter solar systems private limited',
    'SEMBCORP INDIA PRIVATE LIMITED',
    'Bharat power generation private limited',
    'SHAKTI AUTO VALVES & ENGINEERING COMPANY PRIVATE LIMITED',
    'Jost india auto component private limited',
    'AMAR WHEELS PVT LTD',
    'VAATA SMART PRIVATE LIMITED',
    'Wanfeng aluminum wheel (india) private limited',
    'Cmpl motors private limited',
    'Cosmic motors india private limited',
    'Jodhpur vidyut vitran nigam limited',
    'Opg power generation private limited',
    'Hps gases limited',
    'Mutha founders pvt ltd',
    'Diwansons jewellers private limited',
    'Jitf esipl cetp (sitarganj) limited',
    'Tube turn india private limited',
    'Sparkle clean tech private limited',
    'WESTERN ENVIRO SOLUTIONS PRIVATE LIMITED',
    'G.r.n. constructions private limited',
    'Meadows hotels and apartments private limited',
    'Gita power & infrastructure private limited',
    'Roura non conventional energy private limited',
    'Vaishali hydro project private limited',
    'Perfect integrated logistics private limited',
    'Trison international private limited',
    'Geetpriya hotels and resorts pvt.ltd.(trans.from nctofdelhi)',
    'B.d.g international (india) pvt. ltd',
    'Synchronized supply systems limited',
    'Vasant cargo movers private limited',
    'NAVAYUGA ENGICON PRIVATE LIMITED',
    'Ss supply chain solutions private limited',
    'Arkay sea logistics limited',
    'Seasky shipping and consulting private limited',
    'Soham maritime private limited',
    'Mags impex (shipping) pvt ltd',
    'Airone charters private limited',
    'Jamshedpur air-connect private limited',
    'Hfm logiware private limited',
    'Pragati india holidays private limited',
    'Trx logistics and support services private limited',
    'Aileron travels private limited',
    'Inter continental logistics private limited',
    'GURUKUL TOURS & TRAVELS LIMITED',
    'Parag travels private limited',
    'Durga world travel (india) private limited',
    'Mb leisure tours private limited',
    'Travel trails (india) private limited',
    'Sabnani travels pvt ltd',
    'West side catering services private limited',
    'International glashaus private limited',
    'Uma road carrier private limited',
    'Moving systems (india) pvt ltd',
    'TARA CHAND INFRALOGISTIC SOLUTIONS LIMITED',
    'Alianca logistics private limited',
    'Northwest travels private limited',
    'EARTH SONG TRAVELS PRIVATE LIMITED',
    'Aries xpress logistics private limited',
    'J h parabia (transport) private limited',
    'Gsl freight private limited',
    'Amk logistics private limited',
    'Tai-pan shipping private limited',
    'Jupiter logistics private limited',
    'RAJMUDRA INDUSTRIAL SERVICES PRIVATE LIMITED',
    'Pinkcity shipping and forwarding private limited',
    'URBAN GREENFIELD PROJECTS PRIVATE LIMITED',
    'IAL INDIA PRIVATE LIMITED',
    'Rajdoot roadways private limited',
    'Lexus business combines pvt.ltd.',
    'P r s business pvt ltd',
    'Jamuna transport corporation ltd',
    'Carewell express tours private limited',
    'Rajdoot parivahan private limited',
    'ATISHAY SUPER SPECIALIST HOSPITAL PRIVATE LIMITED',
    'Trans fleet limited',
    'FAIRSNOW AVIATION LIMITED',
    'Peak systems refrigeration private limited',
    'Bhupinder cold storage private limited',
    'Bwc forwarders private limited',
    'Vkm logistics private limited',
    'Embedded micro techniques private limited',
    'Surya reisedienst private limited',
    'Trans meridian travels private limited.',
    'Workplace synergies private limited',
    'Comnet travels private limited',
    'Chemtrols holdings private limited cn',
    'Ford credit india private limited',
    'M r finlease limited',
    'BORKAR PRINTERS PRIVATE LIMITED',
    'SOLUNARIS PRIVATE LIMITED',
    'Chorus tours and travels private limited',
    'Shukla capital and finance pvt ltd',
    'Spb comer india limited',
    'KLF ENTERPRISES PRIVATE LIMITED',
    'Ttp travels private. limited',
    'Suri travels private limited',
    'Smart journeys private limited',
    'Sunil exim private limited',
    'STAR FINSERV INDIA LIMITED',
    'Jainex finance limited',
    'Trishul infinlease limited',
    'Great lease finport private limited',
    'GIRNAR CAPITAL PRIVATE LIMITED',
    'Yvu financial services private limited',
    'AMRIT MALWA CAPITAL LIMITED',
    'Ramakrishna travels and tours private limited',
    'Travelad travel service pvt ltd',
    'Indus e-post technologies private limited',
    'Ncs travels & tours pvt.ltd.',
    'Swastic nirman pvt. ltd.',
    'Supreme fin-hold private limited',
    'Sadhusons infotech private limited',
    'Action overseas private limited',
    'Morris street advisors private limited',
    'Network logistics private limited',
    'Cosmos finserve private limited',
    'Flotilla finance private limited',
    'Yerrowda investments limited',
    'Swati industires private limited',
    'Crystal investment company private limited',
    'Ramanlal finance and investments pvt ltd',
    'Swarag logistics private limited',
    'Vassa holidays private limited',
    'Power investment private limited',
    'FLOREAT INVESTMENTS PRIVATE LIMITED',
    'RAGINI MANAGEMENT AND CONSULTANT PRIVATELIMITED',
    'Birch investment and finance private limited',
    'Veekay infin & holdings private limited',
    'Drs transport private limited',
    'Sea lord logistics private limited',
    'Ab fortune technology services private limited',
    'Migration holdings private limited',
    'Gain tradex private limited',
    'Viren telecom private limited',
    'Dwa media private limited',
    'Adview advertising private limited',
    'Nippon signage india private limited',
    'Iddc engineers private limited',
    'Sar management consultancy private limited',
    'PIPAVAV O & M SERVICES PRIVATE LIMITED',
    'Valora consulting private limited',
    'Spintex industries private limited',
    'Kanti kapur pvt ltd',
    'Deenar builders private limited',
    'Medline infotech private limited',
    'Superhaat online services private limited',
    'Fitmec services private limited',
    'Vox populi research private limited',
    'Polaris engineers (india) private limited',
    'Miki enterprises (india) private limited',
    'MOON SHINE ENTERTAINMENT LIMITED',
    'Navketan weld technologies private limited',
    'Skh media private limited',
    'VERMMILLION COMMUNICATION PRIVATE LIMITED',
    'BLACKIE & SON (CALCUTTA) PRIVATE LIMITED',
    'Stefab india limited .',
    'Pee empro exports pvt ltd',
    'Vaishno properties private limited',
    'A f f flavours pvt ltd',
    'Yugal chit fund and trading co private limited',
    'Panipat weaving and processing private limited',
    'Shearwaters engineers private limited',
    'Advance water digest private limited',
    'P S ADVERTISING & MKT PVT LTD',
    'Genesis advertising pvt ltd',
    'Position advertising solutions private limited',
    'MALHOTRA BROTHERS (EXHIBITORS) PRIVATE LIMITED',
    'France air private limited',
    'Singh refrigeration industries private ltd',
    'Arms communications private limited',
    'Bahri motors private limited',
    'STERLING INDO TECH CONSULTANTS PRIVATE LIMITED',
    'Gvs envicon tegnologies pvt. ltd.',
    'Kripa advisory services pvt ltd',
    'Hitech advisory services private limited',
    'Okhla steel industries private limited',
    'B r estates pvt ltd',
    'Chemical construction international pvt ltd',
    'Finsure management private limited',
    'Mettler auto private limited',
    'Vadukoot consultants private limited',
    'Future point private limited',
    'Ahuja agro industries private ltd',
    'Cl micromed private ltd',
    'Adroit technical services private limited',
    'G consultants and fabricators limited',
    'Sodicate (india) pvt ltd',
    'Shagun apparels private limited',
    'Super drilling private limited',
    'MAX VENTURES INVESTMENT HOLDINGS PRIVATE LIMITED',
    'Sterling transtel limited',
    'Shreejee associates private limited',
    'R p g overseas private limited',
    'New rama chair pvt ltd',
    'Marcos impex private limited',
    'Manav cables and wires ltd.',
    'Tech estates private limited',
    'SHREE POOJA OVERSEAS PRIVATE LIMITED',
    'Indebo (india) private limited',
    'BONTON OPTICIANS WORLD PRIVATE LIMITED',
    'Munni investment private limited',
    'R r holdings private limited',
    'Saya automobiles limited',
    'Jsps properties private limited',
    'USHA SHRIRAM PRODUCTS PRIVATE LIMITED',
    'Mayur air product private limited',
    'PALM INSURANCE BROKERS PRIVATE LIMITED',
    'A.r. credit information services private limited',
    'Pushpsons fibrol private limited',
    'Novel energy private ltd.',
    'M and a associates private limited',
    'Ashoka pharmachem private limited',
    'Amar elastomers private limited',
    'Essel international limited',
    'Nippon data systems limited',
    'AURIGA RESEARCH Private Limited',
    'Precious impex india private limited',
    'Action footwears private limited',
    'Nirmal handloom house private limited',
    'Voicecom technologies private limited',
    'Ssra consulting private limited',
    'Linear technologies private limited',
    'Msg strategic consulting private limited',
    'Boutique india overseas private limited',
    'Sab holdings (india) private limited',
    'Eca engineering private limited',
    'Jyoti india private limited',
    'Orient marine lines pvt ltd',
    'TRIMASTER PRIVATE LIMITED',
    'Atlanta systems private limited',
    'M.m.castings private limited',
    'Scan international private limited',
    'Vinman developers private limited',
    'Number one developers private limited',
    'Kalpataru farms private limited',
    'Luxor (india) private limited',
    'A .k. shorewala securities limited',
    'Bar code india limited',
    'Indian cricket league limited',
    'MILESTONE INNOVATIVE ENGINEERING & MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'Window magic india private limited',
    'Buniyad builders private limited',
    'Alok master batches private limited',
    'GAURANG PROFILES LIMITED',
    'Roshan hi-tech projects private limited',
    'YASH WEAVERS PRIVATE LIMITED',
    'Shivam cartons private limited',
    'Akkal paper mills pvt. ltd.',
    'Rational business corporation private limited',
    'SHREESHRUTI EDUCATION FOUNDATION',
    'Metalic impressions (india) private limited',
    'KAISHA PACKAGING PRIVATE LIMITED',
    'KTL TEXTILE MACHINES PRIVATE LIMITED',
    'Nec packaging limited',
    'Krishna tissues private limited',
    'Trish surfaces private limited',
    'Sachin corrugators and printers private limited',
    'Infiniti connect (india) private limited',
    'Primary plus media private limited',
    'Karpaga vinayaga textiles private limited',
    'Business india publications limited',
    'Keynote media private limited',
    'Neva garments limited',
    'Red tiger productions private limited',
    'Cygnus multimedia private limited',
    'M.a. prints private limited',
    'Ufo moviez india limited',
    'Parameshwari exports private limited',
    'Richa fashion private limited',
    'Advanced transfusion medicine research foundation',
    'Western group limited',
    'Binacatunes media private limited',
    'Jain sons industries private limited',
    'Kalajyothi process private limited',
    'Mahalakshmi media private limited',
    'Cirrus graphics private limited',
    'Clavis technologies private limited',
    'Vga digital printers private limited',
    'BRACECORP TECHNOLOGIES PRIVATE LIMITED',
    'Elegant publishing solutions private limited',
    'Base communication private limited',
    'Sandhya infoprint private limited',
    'Rajes art printers pvt ltd',
    '3s photoart private limited',
    'Dura synthetic fibers private limited',
    'Chola apparels private limited',
    'Chetana prakasani private limited',
    'SATYATOWER AFFORDABLES PROJECTS PRIVATE LIMITED',
    'SAMIT RAY PUBLISHERS PRIVATE LIMITED',
    'Swabhumi publication private limited',
    'Simran artprints private limited',
    'Ab shipping & forwarding private limited',
    'ADANI PETRONET (DAHEJ) PORT LIMITED',
    'Orchid shipping private limited',
    'Trio consolidators private limited',
    'Afs logistics international private limited',
    'SHRI FREIGHT & LOGISTICS PRIVATE LIMITED',
    'SHREE DHOLI SATI ENTERPRISES PRIVATE LIMITED',
    'Hitech warehouse private limited',
    'Jayant logistics private limited',
    'Mayur coldstorage private limited',
    'Blaumann industries private limited',
    'SUPREME BITUMIX CHEMICALS PRIVATE LIMITED',
    'Ssp warehousing & transportation private limited',
    'Peninsular business solutions private limited',
    'Gvk transportation private limited',
    'Pmg containers private limited',
    'Sharp logistics private limited',
    'Seahorse distribution & freight services private limited',
    'Oasis tours india private limited',
    'Caper travel company private limited',
    'Vava tourism and hospitality solutions private limited',
    'A r zet zone india private limited',
    'Bakshi transport service private limited',
    'GATEWAY NETWORK SYSTEM PRIVATE LIMITED',
    'Make my travel (india) private limited',
    'Majestic journey private limited',
    'Fernor transportation and tourism private limited',
    'Himalayan frontiers culture and adventure tours private limited',
    'Bangalore classic tours and travels private limited',
    'Sugal travels private limited',
    'SEAMLESS INNOVATION TECHNOLOGIES PRIVATE LIMITED',
    'Travelpack marketing and leisure services (india) limited',
    'Bhagyashri travels private limited',
    'Clearship travels and tours private limited',
    'Sterling tours and travels (india) private limited',
    'Skil travel private limited',
    'Career movez consultants private limited',
    'Dayajeet nimay bus logistics private limited',
    'Towers travels private limited',
    'Mdlr tours & travel private limited',
    'OLA Fleet Technologies Private Limited',
    'Enduring journeys private limited',
    'Aissa maritime private limited',
    'Okay logistics private limited',
    'Tej transportation private limited',
    'Sea air clearing private limited',
    'Mirya transport and courier private limited',
    'Ganesha carriers private limited',
    'Delta travel solutions private limited',
    'Edutours rising star private limited',
    'Srk global tours private limited',
    'Vsm supply chain solutions private limited',
    'Best shipping and clearing agency private limited',
    'GULLIVERS TOURS & TRAVELS (INDIA) PRIVATE LIMITED',
    'Southern mercantile services private limited',
    'Emgee infrastructure holdings (india) private limited',
    'Core shipping and logistics private limited',
    'Pagestitch technology private limited',
    'Univva business solutions private limited',
    'Empyra software solutions private limited',
    'Dsi technologies private limited',
    'It plus technologies private limited',
    'Acrodelon technologies private limited',
    'Wesra india private limited',
    'Cybernetik technologies private limited',
    'Gis information systems private limited',
    'ABR ENTREPRENEUR SERVICES PRIVATE LIMITED',
    'Compusoft advisors (india) private limited',
    'First european infotech india limited',
    'Nozomi infotech private limited',
    'Sohum business process outsourcing private limited',
    'F4 solutions private limited',
    'Mauj mobile private limited',
    'Thatz it private limited',
    'Netway software technologies private limited',
    'Accord fintech private limited',
    'Halma india private limited',
    'Flowing river technologies private limited',
    'Nevatia technologies private limited',
    'Gozoop online private limited',
    'Youtility technologies private limited',
    'Arpita infocomm private limited',
    'Astrika infotech private limited',
    'Orgadata india private limited',
    'Cloudwalker streaming technologies private limited',
    'Devak infomark private limited',
    'S E BIZ INFOTECH Private Limited',
    'Signity software solutions private limited',
    'MENROL SKILLS PRIVATE LIMITED',
    'ANSAMS VENTURES PRIVATE LIMITED',
    'Pcs positioning systems (india) limited',
    'Rankuno interactive technologies private limited',
    'H & r block (india) private limited',
    'Bluecrest software and consultancy services private limited',
    'Optra systems private limited',
    'Smartleaven technologies private limited',
    'Optinno mobitech private limited',
    'Xoptimo technologies private limited',
    'Pcs infotech limited',
    'Infoworld technologies private limited',
    'Insaas software private limited',
    'Druva data solutions private limited',
    'Talentick it solutions private limited',
    'Inven cubator private limited',
    'Icx infotech private limited',
    'PRAKASH HERITAGE PRIVATE LIMITED',
    'Inspiron info solutions ( india) private limited',
    'Griscon technology private limited',
    'A1 source logix private limited',
    'Citrine business software solutions private limited',
    'Reindeer technologies private limited',
    'Sgs internet services private limited',
    'Petra safety and security solutions private limited',
    'Ava software private limited',
    'Coromandel eservices limited',
    'Pixstone images private limited',
    'Indee software private limited',
    'Jiji technologies private limited',
    'Ethersky technologies private limited',
    'Iberis software solutions private limited',
    'Capeleaf technologies private limited',
    'Focuz mindz private limited',
    'Gbs india private limited',
    'Indixshop internet private limited',
    'Edgar efile solutions private limited',
    'Imahaguru technologies private limited',
    'CLOUDELABS TECHNOLOGIES PRIVATE LIMITED',
    'Flickraid network private limited',
    'Artha systems private limited',
    'Mic and mac solutions private limited',
    'Octoze technologies private limited',
    'Ziffity solutions private limited',
    'Ornate informatics private limited',
    'Shakun technologies private limited',
    'Honeyvick enterprises private limited',
    'Hemogenomics private limited',
    'Life cell technologies private limited',
    'Intermot hydraulic motors and drives india private limited',
    'Inventys advanced machines private limited',
    'Hari shankar singania elastomer and tyre research institute',
    'George clinical india private limited',
    'Sarvotham solutions limited',
    'Abirami technologies private limited',
    'Tcp marketing & research private limited',
    'Centre for green mobility ahmedabad',
    'E2e business solutions private limited',
    'Fm advisory services private limited',
    'D.k. overseas private limited',
    'Stork hkb india private limited',
    'SEWARD ESTATES PRIVATE LIMITED',
    'Source one buying services private limited',
    'Kutumbh builders private limted',
    'Indus institute for professional studies private limited',
    'Oxyent medical private limited',
    'Apeejay sez developers private limited',
    'Trucepts services private limited',
    'Htc india private limited',
    'Volen hr solutions private limited',
    'Klg stock brokers private limited',
    'Bmt consultants (india) private limited',
    'Godavari texfab private limited',
    'Pi global - brand id consultants private limited',
    'Tamil nadu industries captive power company limited',
    'Mega funds india limited',
    'Astropundit india private limited',
    'Atithi voyages private limited.',
    'SKMM SCHOOLS PRIVATE LIMITED',
    'Jas facilities private limited',
    'Amazing research laboratories limited',
    'Mayfair clinical education and research centre pvt. ltd.',
    'Aquaproof wallcare india private limited',
    'Hamilton industries private limited',
    'D c synthetics pvt ltd',
    'Teknic controlgear pvt ltd',
    'Dolphin inks pvt ltd',
    'Shivlaxmi land developers pvt ltd',
    'Jasmin estate developers private limited',
    'Cisons texknits india private limited',
    'Deeco industrial supplies pvt ltd',
    'Acharya research centre private limited',
    'Kasyap machineries private limited',
    'MEDIA RESEARCH USERS COUNCIL INDIA',
    'Jess prasad engineering and metallurgical services private limited',
    'Ventura texports private limited',
    'Yash media limited',
    'Kolkata it park association',
    'Celebrity corporate club',
    'Bhatia endo-surgery private limited',
    'Trackmybeat healthcare (india) private limited',
    'Medivision eye & health care centre private limited',
    'Pracsol health india private limited',
    'Repro health care mangalore private limited',
    'Park controls and communications private limited',
    '5 elements techno services private limited',
    'Samadhani vinimay consultants private limited',
    'Wayu health private limited',
    'Fluidyn consultancy private limited',
    'Fem sustainable social solutions',
    'Davar management private limited',
    'Bharat broadcasting network limited',
    'Vgp marine kingdom private limited',
    'Goa golf club private limited',
    'Aqua crest waterpark and resorts private limited',
    'Sinex systems private limited',
    'Logline production private limited',
    'Asahi global link private limited',
    'A1 avighna associates private limited',
    'Fides corporate solutions private limited',
    'Host restaurants private limited',
    'Sfa food and pharma ingredients private limited',
    'Charans life devices pvt. ltd.',
    'Shivbalaji management pvt ltd',
    'Salzer electronics limited',
    'SATCHMO HOLDINGS LIMITED',
    'Vijay solvex limited',
    'Interstate oil carrier ltd',
    'Trinethra infra ventures limited',
    'Balrampur chini mills ltd',
    'Subhash silk mills limited',
    'The bombay dyeing and manufacturing company limited',
    'GB GLOBAL LIMITED',
    'Rupa & company ltd',
    'Scanpoint geomatics limited',
    'Universal starch chem allied limited',
    'Phyto chem (india) limited',
    'Excel industries limited',
    'Mangalam drugs and organics limited',
    'Parmax pharma limited',
    'Mk aromatics limited',
    'Venus remedies limited',
    'Brooks laboratories limited',
    'Fredun pharmaceuticals ltd',
    'AVADH RAIL INFRA LIMITED',
    'FLEXITUFF VENTURES INTERNATIONAL LIMITED',
    'Uni-abex alloy products limited',
    'Jsw steel limited',
    'Hind aluminium industries limited',
    'Elecon engineering company limited',
    'Indo- national limited',
    'Quantum digital vision (india) limited',
    'Finolex industries limited',
    'Hbl power systems limited',
    'Twin roses trades and agencies limited',
    'Pragati vanijaya limited',
    'Som shiva (impex) limited',
    'Arman financial services limited',
    'Jagson airlines limited',
    'Kaveri projects ltd',
    'Repco home finance limited',
    'Marathon nextgen realty limited',
    'Finaventure capital limited',
    'Manjushree technopack limited',
    'Maharashtra corporation limited',
    'Rotographics (india) limited',
    'MAHAN EXIMP PRIVATE LIMITED',
    'Sunrise proteins limited',
    'ARIHANT MERCHANTS PRIVATE LIMITED',
    'Jsw energy limited',
    'Newever trade wings limited',
    'Centum electronics limited',
    'Dq entertainment (international) limited',
    'Arex industries limited',
    'V p civil surveying instruments private limited',
    'Nk filter fabrics private limited',
    'Tulja estate private limited',
    'Gayson rolling mills pvt ltd',
    'Vertex pneumatics private limited',
    'Burgeon engineering private limited',
    'Desmet ballestra rosedowns india private limited',
    'Megavent technologies private limited',
    'Avasarala automation private limited',
    'Pioneer nuts and bolts private limited',
    'Yanmar coromandel agrisolutions private limited',
    'Kich architectural products private limited',
    'Nmtg mechtrans techniques private limited',
    'ANI INTEGRATED SERVICES LIMITED',
    'Hazira engineering works private limited',
    'Engineering systems private limited',
    'Acetech foundry works india private limited',
    'Vijay tanks and vessels private limited',
    'AUTOPACK MACHINES PRIVATE LIMITED',
    'Metito pollution control india pvt ltd',
    'Flow process equipments private limited',
    'Synergy filtration private limited',
    'Sabash engineering (chennai) private limited',
    'Pl filtration private limited',
    'H r (paper) machinery private limited',
    'RIDGE INNOVATIONS PRIVATE LIMITED',
    'ERAM MAGNAFLUX SYSTEMS PRIVATE LIMITED',
    'Heatfil engineers (india) private limited',
    'Test and measurment solutions private limited',
    'Haat incinerators india private limited',
    'Canara hydraulics private limited',
    'EMUGE - FRANKEN INDIA PRIVATE LIMITED',
    'Rushiprabha engineers private limited',
    'Pioneer airbol private limited',
    'Daetwyler swisstec india private limited',
    'Amalgam adhesives private limited',
    'Blaze automation services private limited',
    'Ssi aeration private limited',
    'Aa tek robo private limited',
    'Shanmo engineering products india private limited',
    'Nitsuda engineering private limited',
    'Sns contracts private limited',
    'Propel industries private limited',
    'Kaybee powelec private limited',
    'BATLIVALA & KARANI FINSERV PRIVATE LIMITED',
    'Teslead equipments private limited',
    'Prabhuji vyaper pvt ltd',
    'Devraj computers private limited',
    'BARRLA SYSTEMS PRIVATE LIMITED',
    'STRIDE ONE CAPITAL PRIVATE LIMITED',
    'Opto eurocor healthcare limited',
    'Syscon microsystem private limited',
    'AVPRO SYSTEMS PRIVATE LIMITED',
    'Partex marking systems india private limited',
    'Star dot star software limited',
    'Intwel technologies limited',
    'Syscomp infotech pvt ltd',
    'Digital canvas (india) limited',
    'Rims designer optics private limited',
    'Morries securities private limited',
    'ELECTROPNEUMATICS DRIVES AND CONTROLS PRIVATE LIMITED',
    'Global transform private limited',
    'Potential equipments private limited',
    'Ti-pan engineering company private limited',
    'JSW ENERGY (BARMER) LIMITED',
    'Magnolia martinique clothing private limited',
    'Presstech (india) private limited',
    'Powerspack automation private limited',
    'Saini heavy electrical and engineering company private limited',
    'Jeet engineers private limited',
    'Rathi turboflex private limited',
    'Silicon semi conductors private limited',
    'M s k electricals pvt ltd',
    'Ccs ostem projects private limited',
    'Wiremann industries private limited',
    'Sharon insul india ltd',
    'Jalan wires pvt ltd',
    'Prime compressor services private limited',
    'V k polyshell cables private limited',
    'Mak pumps private limited',
    'Dimple kitchen accessories private limited',
    'Schoch reeds india private limited',
    'Sharpline automation private limited',
    'Pcss solutions private limited',
    'Brand aid private limited',
    'Dhaval electricals private limited',
    'Gilbert and maxwell transformers pvt.ltd.',
    'Basic arch products private limited',
    'Bentec bhartia engineers pvt ltd',
    'Inrom systems (india) private limited',
    'X-tech solutions private limited',
    'TORQON POWER DRIVES PRIVATE LIMITED',
    'Air break switchgear products private limited',
    'Bk chemtech engineering (india) private limited',
    'Sunrise technologies private limited',
    'Daspan industries limited',
    'Billets elektro werke private limited',
    'Ultra consumer products private limited',
    'Aatous international private limited',
    'Power track technology private limited',
    'Safe world lab private limited',
    'Vijai electricals limited',
    'Natraj forklifts private limited',
    'SYROTECH NETWORKS PRIVATE LIMITED',
    'PACIFIC ACCESSORIES (INDIA) PRIVATE LIMITED',
    'Triumph auto parts distributors private limited',
    'Intraco impex private limited',
    'Trimega power controls private limited',
    'Losma india private limited',
    'Klingspor india private limited',
    'Cutting edge agencies private limited',
    'Mouin export import private limited',
    'Sarthi impex private limited',
    'BR GREEN INDUSTRIES PRIVATE LIMITED',
    'Third millenium tradexim private limited',
    'Hyosung corporation india private limited',
    'Ism corporation private limited',
    'Heptakings impex private limited',
    'Saturn steels private limited',
    'Emaar fashions pvt. ltd.',
    'V k udyog ltd',
    'Raincom goods pvt.ltd.',
    'Bagamber dealers pvt ltd',
    'Naman trading pvt ltd',
    'Kecons tradecare pvt.ltd.',
    'INDIA RETAILS & HOSPITALITY PRIVATE LIMITED',
    'VARDHAMAN STAMPINGS PRIVATE LIMITED',
    'Japan cbm corporation (india) private limited',
    'Bharath infra exports and imports limited',
    'Shreeramji dealtrades private limited',
    'Lords distributors private limited',
    'Livingshine technologies private limited',
    'Mathewsons exports and imports private limited',
    'Argon impex private limited',
    'Prolink computers private limited',
    'Obtain suppliers private limited',
    'Superlite dealtrade private limited',
    'Yashvi trades private limited',
    'UBV SALES PRIVATE LIMITED',
    'Kamakshi traders and developers private limited',
    'Globex energia private limited',
    'Impact floors india private limited',
    'MODERA HR CONSULTANCY SERVICES PRIVATE LIMITED',
    'Roddic distributors private limited',
    'Chemonic exim private limited',
    'Vidhata industries private limited',
    'Solan minerals and metals private limited',
    'Capricorn resources private limited',
    'Parkashdeep enterprises private limited',
    'JOE',
    'S EYE INSTITUTE PRIVATE LIMITED',
    'Siva ent hospital private limited',
    'Uma eye clinic private limited',
    'Reach education private limited',
    'Octave business management services private limited',
    'Shikshangan education initiatives private limited',
    'My own english coaching private limited',
    'Educafe student solutions private limited',
    'Silverbullet learning solutions private limited',
    'Involute institute of technical training private limited',
    'Leaders learning house private limited',
    'R-TECH PROJECT (NEEMRANA) MAINTENANCE PRIVATE LIMITED',
    'EFFY INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'Kamadhenu welfare association',
    'ENKI WATER PRIVATE LIMITED',
    'Amritsar msw limited',
    'Effwa infra & research private limited',
    'IAPMO INDIA PRIVATE LIMITED',
    'Credi health private limited',
    'Dakshin human welfare and research foundation',
    'Cafe network limited',
    'WESTERN OUTDOOR INTERACTIVE PRIVATE LIMITED',
    'ANUBHUTI SEVA KENDRA',
    'Vishesh films private limited',
    'Nirmal events 2 excellence private limited',
    'Clarion broadcasting network private limited',
    'Banyan tree communications private limited',
    'India radio ventures private limited',
    'VISAKHA HEALTHCARE (INDIA) PRIVATE LIMITED',
    'Fountainhead experience private limited',
    'Tmi e2e academy private limited',
    'Amogha healthcare institute private limited.',
    'Entrayn education technologies private limited',
    'Creative india academies for art & culture',
    'Winners management academy private limited',
    'NARSINGH HOSPITAL & HEART INSTITUTE PRIVATE LIMITED.',
    'Good show events and exhibitions private limited',
    'Prince housing and hospitality private limited',
    'Fahrenheit fun and games private limited',
    'Great indian tamasha company private limited',
    'Amtech exim indoor recreations private limited',
    'Viva motor sports private limited',
    'Posh talent management private limited',
    'Go go trends private limited',
    'Indavara engineering company private limited',
    'Sri rajalakshmi commercial kitchen equipments private limited',
    'Galaxy infrastructure private limited',
    'Hyloc hydrotechnic private limited',
    'Sonoscan healthcare private limited',
    'Bass punkt entertainment private limited',
    'Arodent dental services private limited',
    'Wild dreams media and communications private limited',
    'Gosval ayurmed learner private limited',
    'Ayursoma ayurveda centre private limited',
    'Chetana social welfare foundation',
    'Childreach india',
    'Indira gopal institute of medical services private limited',
    'AGILUS PATHLABS PRIVATE LIMITED',
    'HEALTHVISTA INDIA LIMITED',
    'Vishwas foundation',
    'Jct employees welfare association',
    'Mustard oil producers association of india',
    'Cinecita private limited',
    'Infex biztech private limited',
    'Mindscape exhibitions private limited',
    'Art of charity organization',
    'Professional club and resorts private limited',
    'Livejam entertainment private limited',
    'Slaine medicare private limited',
    'Uniq skill development academy private limited',
    'Aduro consultants private limited',
    'D propshop india private limited',
    'Technergy engineering (india) private limited',
    'Sikhya entertainment private limited',
    'Sun medtech private limited',
    'Amicorp trustees (india) private limited',
    'Emerald isle luxe private limited',
    'Dsk shivajians football club private limited',
    'Rayudu vision media limited',
    'Meticulous market research private limited',
    'Allied media network private limited',
    'Bougainvilla design private limited',
    'Xebec hospitality private limited',
    'Sesame workshop initiatives (india) private limited',
    'Lma foundation',
    'Sambhav rating and reviews private limited',
    'I s constech private limited',
    'Techs to suit consultancy private limited',
    'STUPENDO TECHNO SERVICES PRIVATE LIMITED',
    'Wonder facility services india private limited',
    'Pan tellisense private limited',
    'End to end outsourcing solution private limited',
    'Indra plastics private limited',
    'Parasrampuria polytex limited',
    'Ratnajeet polycorp pvt.ltd.',
    'Oswal smelters private limited',
    'Capital ispat limited (transfer from delhi to rajasthan)',
    'Aquatech steelcon private limited',
    'SHALIMAR VENTURES PRIVATE LIMITED',
    'Vita granito private limited',
    'Sirmur allied and cement industries pvt ltd',
    'JAGDAMBA CUTLERY LIMITED',
    'B r and sons private limited',
    'Swajit abrasives private limited',
    'Y and m minerals (india) private limited',
    'Adhunik minchem private limited',
    'Gem precision tool private limited',
    'Suzy industries limited',
    'Walayar steels private limited',
    'Sam metal udyog private limited',
    'Bemisal metals pvt ltd',
    'K vishal wires pvt ltd',
    'General foundries pvt. limited',
    'Ahmednagar ferro alloys limited',
    'Bestindia roof products private limited',
    'Kalpataru ispat private limited',
    'ARANATH REAL ESTATE PRIVATE LIMITED',
    'Jay jagdamba profile private limited',
    'Flemingo jewellery india pvt ltd',
    'Madanlal steel industries ltd.',
    'Niton valve industries pvt ltd',
    'Ratnagiri aditya ceramics private limited',
    'Theis precision steel india private limited',
    'Sound castings pvt ltd',
    'Aasraa metalforms private limited',
    'Supermax personal care private limited',
    'Rituraj engifab private limited',
    'Vel castings private limited',
    'New era aluminum miills private limited',
    'Elt trading and contracting company private limited',
    'ITALICA FLOOR TILES PRIVATE LIMITED',
    'Hd engineering limited',
    'Autopress(india) p ltd',
    'K & k foundry private limited',
    'Anupam fabricators private limited',
    'Deem roll-tech limited',
    'Shree ram electro cast limited',
    'Ace bimetalliks india private limited.',
    'Tjsv steel fabrication and galvanizing (india) limited',
    'Amar knitmesh technologies private limited',
    'Rajmet engineering private limited',
    'Veljan shlcast limited',
    'GH INDIA AUTO PARTS PRIVATE LIMITED',
    'Nayan hardware private limited',
    'Gajanan iron private limited',
    'AMPL CLEANTECH PRIVATE LIMITED',
    'The crescent iron and steel corporation ltd',
    'I.k.m. industries private limited',
    'STONE MEDIA FILMS PRIVATE LIMITED',
    'K patel metal industries private limited',
    'Nishflex packaging private limited',
    'SUMO FORMS & PAPERS PRIVATE LIMITED',
    'AIREN COPPER PRIVATE LIMITED',
    'Maruti ropes private limited',
    'V s k extrusions private limited',
    'M.j. aluminium private limited',
    'Hienra fabtech private limited',
    'Oetiker india private limited',
    'Harrington hotels private limited',
    'Mahaguj metals private limited',
    'Perfect engineering products limited',
    'WESTROCK INDIA PRIVATE LIMITED',
    'PUSALKAR SU-RAK-SHA COMPONENTS PRIVATE LIMITED',
    'Mask polymers private limited',
    'Fabz fabricom (india) private limited',
    'S v ispat private limited',
    'Pcm alloys steels private limited',
    'Echaar equipments private limited',
    'North star tubes private limited',
    'Karma steels private limited',
    'Geometrics space structures private limited',
    'Sintonik equipments private limited',
    'Anmol stainless private limited',
    'Neemrana steel service center india private limited',
    'N s s engineering private limited',
    'TRUFORM TECHNO PRODUCTS PRIVATE LIMITED',
    'Bemci industries private limited',
    'ARYAN STRUCTURAL SOLUTIONS PRIVATE LIMITED',
    'Xomox sanmar limited',
    'Sagardeep engineers private limited',
    'Intouch engineering private limited',
    'Wash-master india private limited',
    'Incryo systems private limited',
    'Devcon equipments and tools private limited',
    'Poornima engineering company private limited',
    'Unic alutech private limited',
    'Green snow engineering private limited',
    'Unique roof private limited',
    'Aumtek engicons india private limited',
    'Sms flexitech corp private limited',
    'Fuelpac boilers and engineering company (india) private limited',
    'Aj cans private limited',
    'Maxitherm boilers pvt ltd',
    'Industrial boilers limited',
    'Consolidated metal finishing private limited',
    'Vds builders private limited',
    'Goodlife infrastructure private limited',
    'Sjr hotels and properties private limited',
    'Suraksha buildcon private limited',
    'LIMPIAR HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'Hmi projects private limited',
    'Sakthi auto motors limited',
    'Aadhi cars private limited',
    'Virgo marine shipyards private limited',
    'Gateway landscape private limited',
    'Clearwater pools private limited',
    'Sepset properties private limited',
    'Angarik conclave private limited',
    'Collate conclave private limited',
    'Credo assets private limited',
    'Sequel motors private limited',
    'Pvs automotive company private limited',
    'Candour auto tech private limited',
    'Sunrise autoworld private limited',
    'Ambe phytoextracts private limited',
    'Ramada impex private limited',
    'Nirgudkar infrastructures private limited',
    'Asankhya trading private limited',
    'Rosin jewels private limited',
    'Jaya infotech private limited',
    'Apple modular kitchen private limited',
    'Peer realty private limited',
    'Sew krishnagar baharampore highways limited',
    'Melinex traexim pvt. ltd.',
    'Belle-vous private limited',
    'Dmc industrial materials private limited',
    'Bangalore fluid system components private limited',
    'Sindya properties private limited',
    'Tirupati venkateshwar rasayan private limited',
    'Jayaadithya developers private limited',
    'Gayatri housing ventures private limited',
    'Swathi real estate developers private limited',
    'QTS INTERIOR HOUSING PRIVATE LIMITED',
    'Manakkulan promoters private limited',
    'P g mercantile private limited',
    'Shubh labh nirmaan private limited',
    'Chona commodity trading services private limited',
    'Legacy tower private limited',
    'SIDHISHREE INFRACON INDIA PRIVATE LIMITED',
    'Goodpoint projects private limited',
    'Kalyankari realtors private limited',
    'Texplas (india) private limited',
    'Allied autowheels siliguri private limited',
    'OSHO GARMENT FINISHERS & LAUNDERERS PRIVATE LIMITED',
    'Classic scoobikes private limited',
    'Vayuputra automobiles private limited',
    'S s b i exports private limited',
    'Shree vaidehi impex private limited',
    'Red orchid supply private limited',
    'Pinnacle motor works private limited',
    'Evelyn trading private limited',
    'Ansuya agencies private limited',
    'Joseph brothers marketing private limited',
    'U AND T TRACTOR SPARES PRIVATE LIMITED',
    'Vikas industrial suppliers pvt ltd.',
    'Badola automobiles private limited',
    'HYUNDAI POLYTECH INDIA PRIVATE LIMITED',
    'Caplin vinimay pvt ltd',
    'Manglam farms pvt ltd',
    'Sree ganesh enterprises pvt.ltd.',
    'B new mobiles private limited',
    'Kotvan traders private limited',
    'Bps overseas private limited',
    'Albert trading company private limited',
    'Mahadev vyapaar pvt ltd',
    'UMG INDEX TRADEFAIRS PRIVATE LIMITED',
    'JABRA CONNECT INDIA PRIVATE LIMITED',
    'Manor vyapaar pvt ltd',
    'Esarco enterprises private limited',
    'Hans ispat limited',
    'Epari jewels private limited',
    'EVM MOTELS PRIVATE LIMITED',
    'Ras energia gas supply private limited',
    'Kanchan steel and alloys private limited',
    'Mittal timber products private limited',
    'Pioneer marcantile india pvt ltd',
    'Karur sree rama trading private limited',
    'New metal vision private limited',
    'Levoir trades private limited',
    'Modaka global trade private limited',
    'Essel power edge marketing private limited',
    'Rollon hydraulics private limited',
    'Accutech power solutions private limited',
    'Wtc enterprises private limited',
    'Shreem electric limited',
    'White october technologies private limited',
    'Dentos (india) private limited',
    'Perfint healthcare private limited',
    'Manmohan properties private limited',
    'Kishoriji exim private limited',
    'Deema technomarketing private limited',
    'Rex industries india private limited',
    'TWINLINE TECHNOLOGIES PRIVATE LIMITED',
    'Impex (india) limited',
    'E a currim private limited',
    'K lalchand private limited',
    'Nessville trading private limited',
    'Jasmine trading company private limited',
    'Asim exports international limited',
    'Madhur securities pvt ltd',
    'Nikom laboratories private limited',
    'Niknim holdings private limited',
    'Jade securities private limited',
    'VALUETREE INGREDIENTS PRIVATE LIMITED',
    'BAY CAPITAL ADVISORS PRIVATE LIMITED',
    'INDIANIVESH SECURITIES Limited',
    'Orbimed advisors india private limited',
    'FCE LIFESTYLES PRIVATE LIMITED',
    'Jvs financial advisors private limited',
    'G T C VENTURES PRIVATE LIMITED',
    'LIBORD CONSULTANTS Private Limited',
    'VIJEM DESIGNS PRIVATE LIMITED',
    'Geyser finance and investment company private limited',
    'Element investment p ltd',
    'Coral solutins and trading private limited',
    'Helix investments advisors india private limited',
    'SINGULARITY VENTURES PRIVATE LIMITED',
    'SINGULARITY FURNITURE PRIVATE LIMITED',
    'Agile capital & management advisors private limited',
    'Govindram & company financial services private limited',
    'Rupa investments limited',
    'John fowler ocular lenses private limited',
    'FINMORE INVESTOR SERVICES PRIVATE LIMITED',
    'THINK FINANCIAL INTERMEDIARY SERVICES PRIVATE LIMITED',
    'Extra cover insurance brokers private limited',
    'Pacific holidays private limited',
    'Chittoda investment and trading private limited',
    'Deepak garden fresh private limited',
    'Innovations investment management india private limited',
    'Jaguar broking private limited',
    'Chirag stockbroker private limited',
    'Pankaj bohra consultants private limited.',
    'SHIVA INDUSTRIAL SECURITY AGENCY(GUJARAT) LIMITED',
    'Richard finance and development private limited',
    'Adwait holdings private limited',
    'Shiva shakti capital private limited',
    'FINE ESTATES PRIVATE LIMITED',
    'Nilesh developers private limited',
    'J d l stock broking services pvt ltd',
    'Shakun vinimay pvt. ltd.',
    'Babcock borsig limited',
    'Roxan properties private limited',
    'Navketan developers private limited',
    'Leela housing private limited',
    'Exchange holdings pvt ltd',
    'Sky commodities india private limited',
    'Wealth india financial services private limited',
    'Devagiri estate and investment private limited',
    'Gireesha estate and development private limited',
    'Ceepeek real estate private limited',
    'Primary real estate advisors private limited',
    'Sindya securities & investments private limited',
    'A v thomas investments co ltd',
    'Kilol finance and investment pvt ltd',
    'Calgary investment and trading company pvt ltd',
    'Abhijit periwal securities private limited',
    'Sonam finvest services private limited',
    'Wall street securities andinvestments (india) limited',
    'Camellia promoters private limited',
    'Carolina realtors private limited',
    'Nath securities limited',
    'Samriddhi investment services private limited',
    'Bella apartments private limited',
    'Ideal propbuilt private limited',
    'Ninex developers limited',
    'Meghna apartments private limited',
    'Navketan holdings and investments limited',
    'Spenta properties private limited',
    'Sangeeitaa development and reality private limited',
    'Magnet buildtech private limited',
    'Neelkamal realtors suburban private limited',
    'PAARTH CLOTHING PRIVATE LIMITED',
    'WONDER CITY BUILDCON LIMITED',
    'Eastman builders private limited',
    'Epsilon ventures private limited',
    'Ramakrishna housing private limited',
    'Maxworth infrastructures private limited',
    'Chinthala realty private limited',
    'Nest promoters and home makers private limited',
    'Conwood construction & developers private limited',
    'Real worth properties private limited',
    'Popcorn properties private limited',
    'Matruashish realty private limited',
    'Excon developers private limited',
    'Mehar estate and finance private limited',
    'Grand sunshine promoters & developers private limited.',
    'DAUPHIN SALES PRIVATE LIMITED',
    'Success homes (india) limited',
    'SHREE UNIQUE LIFESTYLE HOMES PRIVATE LIMITED',
    'Murano service apartments private limited',
    'Shreenathji realmart private limited',
    'UNIQUE MADHUBAN HOMES PRIVATE LIMITED',
    'Dream constructions private limited',
    'Praveera reality and development private limited',
    'Prabodha development and reality private limited',
    'Marine drive hospitality & realty private limited',
    'Yerik homes private limited',
    'Darode jog realities private limited',
    'Sankalp colonizers private limited',
    'Aikyam holdings private limited',
    'Windsor shelters private limited',
    'Dewberry realtors private limited',
    'Coax assets management private limited',
    'Vulcan forge private limited',
    'Kolkata realty management private limited',
    'G.p.k. engineering company private limited',
    'Vms engineering and design services pvt. ltd.',
    'Karnataka cnc tech private limited',
    'Ind global securities limited',
    'J s overseas pvt ltd',
    'Noble house tours private limited',
    'United envirotech private limited',
    'Rhythm architects private limited',
    'Graphic point private limited',
    'Maxis motion controls private limited',
    'Spectrum decors (chennai) private limited',
    'Vijay gems private limited',
    'Orange farms private limited',
    'CERADECOR INDIA PRIVATE LIMITED',
    'Ugp engineering private limited',
    'International development enterprises (india)',
    'AVDHESH CONSTRUCTION AND IMPEX PRIVATE LIMITED',
    'Real innerspring technologies private limited',
    'Ufo software technologies private limited',
    'JABRO ADVERTISING & MARKETING PRIVATE LIMITED',
    'Affinity interactions private limited',
    'Astalakshmi financial and investment services pvt ltd',
    'Tigers worldwide logistics private limited',
    'Distant horizon orchard pvt ltd',
    'ZYNA MEDTECH PRIVATE LIMITED',
    'Stellant communications private limited',
    'Jamuna enterprises pvt ltd',
    'Shree mahabir industries private limited',
    'P h periwal brothers private limited',
    'United chemiplast(india) pvt ltd',
    'Spark holidays private limited',
    'Mirkana engineering private limited',
    'Mas services ltd',
    'Punjab jewellers private limited',
    'Srf intercontinental investment pvt ltd',
    'Netcom ventures private limited',
    'Pacific maritime private limited',
    'Raghu electronics private limited',
    'Aman overseas private limited',
    'Otsima talent solutions private limited',
    'MTIC INTERCERT INDIA PRIVATE LIMITED',
    'Innomantra consulting private limited',
    'Pmcons engineering india private limited',
    'Globestayz india private limited',
    'Zugzwang chess school private limited',
    'Zendrive technologies india private limited',
    'Haldiram snacks private limited',
    'Pandit agro private limited',
    'Shirshty impex private limited',
    'B k yaru and chem private limited',
    'Carmen auto solutions private limited',
    'H s services private limited',
    'Vayu engineering solutions private limited',
    'Aadhiriyaa medical solutions private limited',
    'Ams electro consultants and contractors private limited',
    'Albustan fire systems & solutions private limited',
    'Amchem products private limited',
    'Jumps marketing private limited',
    'Silver rain media solutions private limited',
    'Meemain capital advisors private limited',
    'Vanishree commercials private limited',
    'ARDENT MASCHINFABRIK PRIVATE LIMITED',
    'KLIFF INDUSTRIAL SERVICES PRIVATE LIMITED',
    'Bollfilter india private lmited',
    'Sbi-sg global securities services private limited',
    'Go ip global services private limited',
    'Ns infopulse private limited',
    'Godrej garden city properties private limited',
    'Target tours (india) private limited',
    'Jagriti exim private limited.',
    'Finsys infotech limited',
    'Paltech cooling towers & equipments limited',
    'Abhimanya interio private limited',
    'Svd crown tradelink india private limited',
    'Radius equipment private limited',
    'Ecoved technologies private limited',
    'Sanctum infosolutions private limited',
    'Enlighted energy systems private limited',
    'Asn packaging private limited',
    'RHAPSODY VENTURES PRIVATE LIMITED',
    'Brightsquare technologies private limited',
    'Spectrum universal trade private limited',
    'Technicool marketing private limited',
    'Pathfinder international india',
    'Hartlyn dairies private limited',
    'Greenspan biotech private limited',
    'Zen techno engineering private limited',
    'Seismosys technologies private limited',
    'Green and good eco solutions private limited',
    'Global disbursement & accounting solutions private limited',
    'Hanuman enterprises (india) private limited',
    'Sohamsai human capital consulting private limited',
    'Ducit consulting private limited',
    'Prestige pursuits private limited',
    'Iante lpo private limited',
    'Rajguru adhesive tape company private limited',
    'Adroit facilities management services private limited',
    'Sr bizsciences technology and travel solutions private limited',
    'Moonstar lines private limited',
    'Ramya outsourcing solutions private limited',
    'Cams investor services private limited',
    'Tubeknit fashions limited',
    'Clifton export private limited',
    'Talluri spinning mills private limited',
    'Linear design private limited',
    'Lavender cotspin private limited',
    'Orchid cotex private limited',
    'Tathya texfab private limited',
    'Carnation texfab private limited',
    'Global shirtbox (india) private limited',
    'Mandala apparels private limited',
    'Pulaha textiles private limited',
    'A v thomas leather & allied products private limited',
    'Southern prime leahters p ltd.',
    'A l m industries limited',
    'Xo footwear private limited.',
    'Venezia leathers limited',
    'Gudiya industries private limited',
    'G n p apparels private limited',
    'West coast designs private limited',
    'Maandu textiles private limited',
    'Bhargav textiles private limited',
    'Valmiki textiles private limited',
    'Rapture india footcare company private limited',
    'Globe power & steel limited',
    'Lavis signature panel private limited',
    'Saffron cotex private limited',
    'Mbr flexibles limited',
    'Ebenezer printpack private limited',
    'Camellia cotspin private limited',
    'Iris fabrics private limited',
    'Asia pulp and papers private limited',
    'Sri parameswari spinning mills private limited',
    'Big apple exports private limited',
    'Chiripal lifestyle limited',
    'Hiva lifestyles private limited',
    'VENKATESVARA AGRO PAPER PRODUCTS PRIVATELIMITED',
    'Dare deer creations private limited',
    'Suvastra india private limited',
    'Vartika packaging private limited',
    'Aggarwal corrukrafts private limited',
    'Midas touch export private limited',
    'Megha dresses private limited',
    'Bharatkshetra sarees private limited',
    'Fascino exports private limited',
    'Eleventh direction media solutions private limited',
    'Goen consulting private limited',
    'Reddy media private limited',
    'Alankar lamination works private limited',
    'M+l shoes and accessories private limited',
    'HELIOS GLOBAL PRIVATE LIMITED',
    'RMX TOOLBARN PRIVATE LIMITED',
    'Win hide private limited',
    'Ram fashion exports private limited',
    'Saleem leather and shoe exports private limited',
    'JET CONTENT BOUTIQUE PRIVATE LIMITED',
    'Dhandora advertising services private limited',
    'Kemwell private limited',
    'SALASAR TECHNO ENGINEERING LIMITED',
    'Varun lubricants and specialities private limited',
    'MOTUL INDIA PRIVATE LIMITED',
    'Transworld petrochem middle east private limited',
    'Sulfozyme agro (india) private limited',
    'Aarav salt & chemicals private limited',
    'Morvin india health care private limited',
    'Libra paints private limited',
    'Galgo fine papers private limited',
    'Nandi vardhana textile mills limited',
    'Premier orgochem industries private limited',
    'Finornic chemicals (india) pvt ltd',
    'Dorf-ketal chemicals india private limited',
    'Mahendra rosin and turpentine p ltd',
    'Tuka tech (india) private limited',
    'J a textiles private limited',
    'N.s. creations private limited',
    'Seftech phosphate private limited',
    'Premier hydro carbons private limited',
    'Ary fashion private limited',
    'Star royal papers private limited',
    'Nnoweta performance chemicals private limited',
    'Bms packers private limited',
    'Savvy packaging private limited',
    'Icon chem private limited',
    'Dst chemicals india private limited',
    'Rototech packaging pvt. ltd.',
    'Swissol organics private limited',
    'Sri chakra containers private limited',
    'Rashi ferro-tech private limited',
    'Dynamic kraft paper private limited',
    'Diva enterprises private limited',
    'EXPRESS PUBLICATIONS (MADURAI) PRIVATE LIMITED',
    'Pictocorp media private limited',
    'M.a.k. (india) chemicals private limited',
    'Al-quran printers private limited',
    'Gujarat offset private limited',
    'Rmv av medianet private limited',
    'Prabhatam communications private limited.',
    'Kamal sponge steel and power limited',
    'Inexo cast metal solutions private limited',
    'Palriwal industries private limited',
    'ESSAR ADVISORY SERVICES LIMITED',
    'Hexon laboratories private limited',
    'Indian surfactants limited',
    'Sanmar group international limited',
    'Viva vikas realtors private limited',
    'Saroj global infrastructure private limited',
    'Dadbhawala builders pvt ltd',
    'Jasp engineering and construction company private limited',
    'Solitaire industrial infrastructure private limited',
    'Sukriti infrastructure private limited',
    'Parle bitumen pvt ltd',
    'Kunal spaces private limited',
    'Crystal infraspace private limited',
    'KKV AGRO POWERS Limited',
    'Bhandari infra projects india private limited',
    'Bkn developers private limited',
    'Sy ventures private limited',
    'Avidan infrastructures private limited',
    'Shri s. m. autade private limited',
    'Sew infrastructure limited',
    'KAUSALYA INFRA PROJECTS PRIVATE LIMITED',
    'Bakhtawar construction company private limited',
    'Citilights townships private limited',
    'Adrika developers private limited',
    'AMETHYST REALTORS & DEVELOPERS PRIVATE LIMITED',
    'Nrp projects private limited',
    'Lerida properties private limited',
    'Enrich infrastructures private limited',
    'Dipti housing & constructions private limited',
    'Prism infra and investment private limited',
    'Vashisth builders and engineers limited',
    'Svkl properties private limited',
    'Vidarbha energy & infrastructure private limited',
    'Rumanek estates private limited',
    'Gstaad estates private limited',
    'Bhishma builders private limited',
    'FP INDIA PROJECT MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'Sangwan developers private limited',
    'Serendipity buildtech private limited',
    'Sainath land developers private limited',
    'PENEST CONSTRUCTION PRIVATE LIMITED',
    'Darode jog redevelopment private limited',
    'Krishna habitat private limited',
    'Pmk estates private limited',
    'Cedar projects private limited',
    'Pragnya infrastructure investments private limited',
    'KUKATPALLY DEVELOPERS PRIVATE LIMITED',
    'Supreme star villa private limited',
    'BVR INFRACORP PRIVATE LIMITED',
    'Supreme lake view bungalows private limited',
    'Sarnar buildtech private limited',
    'REVOSSA INFRAVENTURE PRIVATE LIMITED',
    'Ananias construction private limited',
    'Radheshyam infrabuild private limited',
    'Buildquick infrastructure private limited',
    'Buildquick projects private limited',
    'WW INFRA PROJECT PRIVATE LIMITED',
    'Cubiq spaces private limited',
    'Nandi housing private limited',
    'Yoga builders private limited',
    'Krishvi projects private limited',
    'Gm spl infra developers private limited',
    'Swami samarth infracon projects private limited',
    'Shree swami samarth projects private limited',
    'Shubham housing developers private limited',
    'Prestige space solutions limited',
    'Jkm buildcon private limited',
    'Pinnacle buildtech private limited',
    'Futec shelters private limited',
    'Decent propbuild private limited',
    'Sahara india builders and developers private limited',
    'Gold castle realtors private limited',
    'ASPENA MERCHANTILE PRIVATE LIMITED',
    'Neutron enterprises private limited',
    'Kuval projects private limited',
    'GOLD WIND BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'IKIA DEVELOPERS & INFRASTRUCTURES PRIVATE LIMITED',
    'HBS AUTO AND ANC SEZ PRIVATE LIMITED',
    'Rogers design & build private limited',
    'Utkal realtors private limited',
    'Trade centre developers and builders pvt ltd',
    'Ishwar constructions pvt ltd',
    'Geeta constructions private limited',
    'Goel ganga realty private limited',
    'Madkar constructions private limited',
    'Kaustubh estate and developers private limited',
    'Rythem construction private limited',
    'United engineers alliance private limited',
    'Raven estate private limited',
    'Universal buildwell private limited',
    'R k buildestate private limited',
    'JODHANA CONSTRUCTION CO.PVT.LTD.',
    'Dhara organisers private limited',
    'A g s developers private limited',
    'Sun n moon realestates private limited',
    'Pinkcity landbase private limited',
    'NISHANT ORGANICS PRIVATE LIMITED',
    'Vishrambhai gorasia construction private limited',
    'GANGA BUILDCREATION PRIVATE LIMITED',
    'RUDRAKSH BUILDESTATE PRIVATE LIMITED',
    'Greater sitapura developers private limited',
    'Ummu construction & developers private limited',
    'Images buildmore private limited',
    'HERMES CLEAN ENERGY SOLUTIONS PRIVATE LIMITED',
    'Kalpik buildcon private limited',
    'Superglow estate management private limited',
    'Tajasvi estate private limited',
    'Canter b&b infrastructure private limited',
    'Pursuit capital market and investments limited',
    'Basiz fund service private limited.',
    'New tieup leasing and finance private limited',
    'Sivana insurance brokers private limited',
    'Way2wealth insurance brokers private limited',
    'Rich field leasing finvest private limited',
    'Chamundi finvest private limited',
    'Lalkar securities private limited',
    'Sadhbhavana holdings private limited',
    'Chanakya corporate services private limited',
    'Quipper research private limited',
    'MAHINDRA MANULIFE TRUSTEE PRIVATE LIMITED',
    'Ncc infrastructure holdings limited',
    'HOME FIRST FINANCE COMPANY INDIA LIMITED',
    'Madras pharma holdings private limited',
    'Choice finlease private limited',
    'Mahabir securities private limited',
    'Grovalue securities private limited',
    'Jel finance & investments limited',
    'Obul reddy investments private limited',
    'Vivro financial services private limited',
    'Pdr investments private limited',
    'Epur invesments private limited',
    'Karadivavi holdings private limited',
    'Hitaishi investments ltd',
    'Narnolia capital advisors private limited',
    'Dimensional securities pvt. ltd.',
    'Steadfast holding pvt ltd',
    'Khopoli investments limited',
    'Global card systems private limited',
    'Cd equifinance private limited',
    'Buffalo carbon pvt.ltd.',
    'Vanseti investments and holdings private limited',
    'Highrise finance and investmens private limited',
    'Shree ramdeoji holdings and leasing private limited',
    'Link - k insurance broker company private limited',
    'Infina insurance broking private limited',
    'Infocus investment private limited',
    'GADA & HARIA PRIVATE LIMITED',
    'Supportive insurance brokers limited',
    'Harjivandas nemidas securities private limited',
    'Bsv securities private limited',
    'Trade worth chits private limited',
    'Marikkuzhiyil chitty fund private limited',
    'Ludhiana capital services private limited',
    'Bajaj financial securities limited',
    'K.S.CAPITAL SERVICES PRIVATE LIMITED',
    'Kogta financial (india) ltd',
    'Aimurydhanam kuries private limited',
    'Shree mahesh housing and finance company private limited',
    'SUMANGAL APARTMENTS & FINANCE PVT LTD.',
    'Hinduja finance limited',
    'FINWISE SERVICES PRIVATE LIMITED',
    'ONLINE REPUTATION MANAGEMENT PRIVATE LIMITED',
    'Bsn investments pvt ltd',
    'Philos advisory services private limited',
    'M power capital advisors private limited',
    'Inditrade insurance broking private limited',
    'Acharya securities pvt ltd',
    'Glass polish india limited',
    'Amigo finstock private limited',
    'Navkar share and stock brokers private limited',
    'Devashish securities private limited',
    'Gemini shares and stocks private limited',
    'Karuna ventures private limited',
    'Viva global holdings private limited',
    'Alma finance & capital private limited',
    'Royal madras finance & investment corporation private ltd',
    'Ambattur estates and homes private limited',
    'MMG FARMS PRIVATE LIMITED',
    'Moneylicious capital & advisory services private limited',
    'Grovalue commodity private limited',
    'Omega intermodal container services private limited',
    'Gift holding pvt ltd',
    'Tatvadarshi investments and finance private limited',
    'Shriraj investments private limited',
    'Pact brokerage limited',
    'Madhusudangarh estates and investments private limited',
    'Trumonee financial limited',
    'Two roads trading private limited',
    'Reliable finhold limited',
    'Tradewell portfolios private limited',
    'SUREKA COMMODITIES & SECURITIES PRIVATE LIMITED',
    'India insure risk management and insurance broking services private limited',
    'Psr holdings private limited',
    'Rr fincap private limited',
    'Tangent holdings pvt ltd',
    'Equitydebt consultancies private limited',
    'Prestige equity and commodities private limited',
    'Prime shares and stocks pvt ltd',
    'DATACOMP BUSINESS ASSOCIATES PRIVATE LIMITED',
    'Theseus ventures limited',
    'Calculas financial consultants private limited',
    'Captus financial services private limited',
    'Vardhan estates pvt ltd',
    'ESSAR HOUSE Private Limited',
    'Rameshwar estates developers private limited',
    'Real trustee advisory company private limited',
    'Helios holdings private limited',
    'Wockhardt holdings limited',
    'Aartee real estate investments private limited',
    'Yashomitra estate and reality private limited',
    'Premaa estate and reality private limited',
    'Marine consultants and engineers private limited',
    'ARISTA MARBLE & GRANITE PRIVATE LIMITED',
    'Index media private limited',
    'Palm farmtech private limited',
    'Origin aromacraft private limited',
    'Ebees infotrain consultancy services private limited',
    'River of design private limited',
    'Ase automotive services private limited',
    'Orange finvest consultancy private limited',
    'Agrinos india private limited',
    'My home maker services private limited',
    'Innologix consulting private limited',
    'Greenhouse ventures private limited',
    'Spiritius consulting private limited',
    'Matrix quality verification services private limited',
    'Covert management services private limited',
    'Tcf consulting services (india) private limited',
    'Spire capital services private limited',
    'Sellbytel marketing services india private limited',
    'Directus consultants private limited',
    'Resource square solutions private limited',
    'Jse engineering private limited',
    'Primal patterns holistic fitness studio private limited',
    'DC CAPITAL ADVISORS PRIVATE LIMITED',
    'Voltech hr services private limited',
    'Sunrise finvest pvt ltd',
    'Vidya reckon solutions pvt ltd',
    'Landscape solutions private limited',
    'Mehta & padamsey insurance surveyors & loss assessors private limited',
    'Oystra concepts private limited',
    'Teknomic consultants private limited',
    'Rigel marine services private limited',
    'Diamond ndt inspection services private limited',
    'RAFBRIX PRIVATE LIMITED',
    '2m engineering india private limited',
    'Upl environmental engineers limited',
    'Koti education & learning private limited',
    'Landbase consulting india private limited',
    'Sivanandha consultants private limited',
    'Promanns management services private limited',
    'Spa technical services private limited',
    'Systems and components india private limited',
    'Ontwerp architects private limited',
    'PES ENGINEERS PRIVATE LIMITED',
    'Blue dot corporate solutions private limited',
    'Iconium consulting group (india) private limited',
    'Probit research & solutions private limited',
    'Brahmayya consultants private limited',
    'Mls business centres india private limited',
    'Onprocess technology india private limited',
    'ICONS PROJECTS INDIA PRIVATE LIMITED',
    'Space tech projects and systems pvt ltd',
    'Haldia energy limited',
    'KBS CERTIFICATION SERVICES LIMITED',
    'Air control engineering private limited',
    'Spectrum ad-vision private limited',
    'Comp advertising private limited',
    'Viva events management private limited',
    'Acumen marketing solutions private limited',
    'Right channel advertising agency private limited',
    'Wizard advisory services private limited',
    'SIGNPOST INDIA LIMITED',
    'Epigram outdoor media private limited',
    'Lead ads private limited',
    'ADINN ADVERTISING SERVICES LIMITED',
    'Lookad (india) private limited',
    'Psl corrosion control services limited',
    'Aimil limited',
    'TIKONA INFINET PRIVATE LIMITED',
    'Vico scientific sales private ltd',
    'Mundhra chemicals private ltd',
    'Gurara enterprises private limited',
    'Senco services private limited',
    'Amicorp advisory services private limited',
    'Nettantra technologies (india) private limited',
    'Websym solutions private limited',
    'Bapat engineers and valuers private limited',
    'Prime hr services private limited',
    'Itheme consulting private limited',
    'Calibre human resources private limited',
    'Adamek consultant (india) private limited',
    'R s estates private limited',
    'A m estates private limited',
    'Akshat autoline private limited',
    'Shinewell engineering private limited',
    'Carlton energy services private limited',
    'Eis technologies private limited',
    'Bang design private limited',
    'George projects private limited',
    'Avu engineers private limited',
    'Ganesh technologies private limited',
    'Mech engineers and erectors private limited',
    'Paracor capital advisors private limited',
    'Unison hotels private limited',
    'Accord international private limited',
    'Best comtrade private limited',
    'Elgi consultants and hospitality private limited',
    'Lucky global limited',
    'Vax consultants private limited',
    'Vanavil engineers private limited',
    'Arkie atelier design india private limited',
    'Thoughtrains designs private limited',
    'Leo institute of education private limited',
    'Wani coalfields private limited',
    'Indermani associates private limited',
    'MADANPUR (NORTH) COAL BLOCK PRIVATE LIMITED',
    'Tridem port and power company private limited',
    'PENTA COAL PRIVATE LIMITED',
    'Pavamana drilling private limited',
    'Vardhmaan ores private limited',
    'Goa sintered products private limited',
    'Vagha minerals private limited',
    'Billion wealth minerals private limited',
    'E.ramamurthy minerals and metals private limited',
    'Fomento resources private limited',
    'Delta rocks private limited',
    'Inaniya exports private limited',
    'Sarla marbles pvt ltd',
    'Midwest granite pvt ltd',
    'Kempsz trading private limited',
    'Beryll stone private limited',
    'MAG FEEDS PRIVATE LIMITED',
    'KOHINOOR GRANI MARMO INTERNATIONAL PRIVATE LIMITED',
    'Dholpur sand stone private limited',
    'Star earth minerals private limited',
    'Narcissus auto sheet metals private limited',
    'Encore engineering contracting and trading private limited',
    'Glorious auto roof liners private limited',
    'Gravity roof head liners private limited',
    'Ps arts private limited',
    'PARKIN AUTO ACCESSORIES PRIVATE LIMITED',
    'Chemhub tradelink private limited',
    'G. m. tea packers private limited',
    'Dpa hi-fashions private limited',
    'Spectrum seat trims private limited',
    'Sterling risk advisory & marketing services private limited',
    'Milestouch exim private limited',
    'Comfort car seats private limited',
    'Glazing auto mirror private limited',
    'Win multitrade private limited',
    'Gravita infotech limited',
    'Ran-vac technologies private limited',
    'Weldwell speciality pvt ltd',
    'Bhagwan technovations private limited',
    'Pico puro technologies india private limited',
    'Kushagra infrastructure private limited',
    'Modtech material handling projects private limited',
    'Stumpp schuele & somappa springs private limited',
    'Suprajit automotive private limited',
    'GREAVES FINANCE LIMITED',
    'Revathi instruments pvt ltd',
    'MEGATECH OVERSEAS (INDIA) PRIVATE LIMITED',
    'Richardson electronics india private limited',
    'Varner retail services south asia private limited',
    'PARKASH DYECHEM PRIVATE LIMITED',
    'Morsef pharmaceuticals private limited',
    'Vera india limited',
    'Hw wellness solutions private limited',
    'Gw impex private limited',
    'Tulsi impex pvt ltd',
    'KAFENEO STUDIO PRIVATE LIMITED',
    'DECIBELS & PIXELS SOLUTIONS PRIVATE LIMITED',
    'Phive rivers retail private limited',
    'Scallion exports private limited',
    'SANTKRIPA EQUIPMENTS PRIVATE LIMITED',
    'Golden relief resources (india) private limited',
    'Durlum india private limited',
    'NNE PRIVATE LIMITED',
    'Yuasa trading india private limited',
    'Gems shipspares private limited',
    'Unix electronics (india) private limited',
    'Microfine mercantile company private limited',
    'Thirdwave mercantile company private limited',
    'Primex mercantile company private limited',
    'Topmedia trading company private limited',
    'Oyester trading company private limited',
    'PLENITUDE BUSINESS PRIVATE LIMITED',
    'R s t innovations private limited',
    'Ridhi-sidhi trading and investments private limited',
    'CIGMA PROCESS SOLUTIONS PRIVATE LIMITED',
    'Tnt trading private limited',
    'Just-in-time trading private limited',
    'Space teletech private limited',
    'Sealand diesel pvt ltd',
    'Hanrag marketing pvt ltd',
    'CERIGO ADDITIVES PRIVATE LIMITED',
    'Boot exports (bombay) pvt ltd',
    'Anupam stationers private limited',
    'Rohnish stoichem private limited',
    'VIVAVOCE TECHNOLOGIES PRIVATE LIMITED',
    'HINDAIR INDUSTRIES INDIA PRIVATE LIMITED',
    'SANJEEVANIMAATI FARMERS PRODUCER COMPANYLIMITED',
    'CREATIVE PROPLAST LIMITED',
    'KRUSHAK BHARTI FARMER PRODUCER COMPANY LIMITED',
    'IHUB ANUBHUTI-IIITD FOUNDATION',
    'LOHCHAB AUTOCAR PRIVATE LIMITED',
    'JUNEGIRI FARMS PRIVATE LIMITED',
    'DEVSARAS STAINLESS PRIVATE LIMITED',
    'QWR RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED',
    'NINO FOODS PRIVATE LIMITED',
    'SHAMALA OVERSEAS PRIVATE LIMITED',
    'GEARHEAD TECHNOLOGIES PRIVATE LIMITED',
    'HUS LE FOUNDATION',
    'ASHTI VENTURES MMR PRIVATE LIMITED',
    'ASTAVASU SERVICES (OPC) PRIVATE LIMITED',
    'TORCHBEARERS FOUNDATION',
    'I-CONSULT SOLUTIONS PRIVATE LIMITED',
    'Y4 INTERNATIONAL PEACE FOUNDATION',
    'VIDDHAAN EXECUTIVE HOTELS PRIVATE LIMITED',
    'ZOLVE INNOVATIONS PRIVATE LIMITED',
    'TRADEX SYSTEMS PRIVATE LIMITED',
    'TATOS TECHNOLOGIES PRIVATE LIMITED',
    'CAFS INSURANCE BROKING PRIVATE LIMITED',
    'SUPERNOVAFX STUDIO',
    'S PRIVATE LIMITED',
    'LOANLAB FINANCIAL SERVICES LIMITED',
    'DEVEX HUB PRIVATE LIMITED',
    'BABU MOTOR PRIVATE LIMITED',
    'RAY GLOBAL CONSUMER PRODUCTS LIMITED',
    'HTB DEVELOPERS PRIVATE LIMITED',
    'EXCELUS MACHINERIES PRIVATE LIMITED',
    'AUTOFORMS INDIA PRIVATE LIMITED',
    'PRATAP AUTOCOM PRIVATE LIMITED',
    'PUYVAST SHIPPING PRIVATE LIMITED',
    'AKSHI TECHNOLOGIES PRIVATE LIMITED',
    'QUMACH ENG. PRIVATE LIMITED',
    'INJEN TECHNOLOGIES PRIVATE LIMITED',
    'ARUNODAY INNOVATIONS AND RESEARCH PRIVATE LIMITED',
    'WORKHALL PRIVATE LIMITED',
    'INGENUITY AND INNOVATION GLOBAL SPORTS ACADEMY PRIVATE LIMITED',
    'MYSAA ENTERPRISE PRIVATE LIMITED',
    'PVALUE SOLUTIONS PRIVATE LIMITED',
    'DIGIAPPFOUNDRY PRIVATE LIMITED',
    'THEME CAPSTONE PRIVATE LIMITED',
    'NUAMIZ LIFESTYLE PRIVATE LIMITED',
    'GINGER JERRY STUDIO PRIVATE LIMITED',
    'AMBROSIA24 HOSPITALITY PRIVATE LIMITED',
    'DCWS ENTERPRISES PRIVATE LIMITED',
    'CHEFWISE VENTURES PRIVATE LIMITED',
    'PCG BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TRUEWAY DIGITAL PRIVATE LIMITED',
    'SA3 MECHATRONICS (OPC) PRIVATE LIMITED',
    'M J SOLARTECH PRIVATE LIMITED',
    'KALA KHOJ PRODUCER COMPANY LIMITED',
    'ACR BUSINESS SERVICES PRIVATE LIMITED',
    'ALCOBULLS LIMITED',
    'GEGOSOFT TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'CARDINAL ENGINEERING CONSULTANT PRIVATE LIMITED',
    'JOBBOOSTER SOCIAL INDIA PRIVATE LIMITED',
    'TALENT SPOT ICE GLOBAL PRIVATE LIMITED',
    'VIAANMART PRIVATE LIMITED',
    'GROWTHJR DIGITAL SERVICES PRIVATE LIMITED',
    'NBS ARTS AND MOVIES PRIVATE LIMITED',
    'T-MED TECHNOLOGIES PRIVATE LIMITED',
    'BLUPEAK CAPITAL SERVICES PRIVATE LIMITED',
    'TECHNOACE CONSULTANCY SERVICES PRIVATE LIMITED',
    'TRIALSHOT FASHION PRIVATE LIMITED',
    'OMVI TECBIZ SOLUTIONS PRIVATE LIMITED',
    'MEDBIKRI TECHNOLOGIES PRIVATE LIMITED',
    'ESPRESSO FOODS PRIVATE LIMITED',
    'DFSEDGE SOLUTIONS PRIVATE LIMITED',
    'DFSL INDIA PRIVATE LIMITED',
    'GOWING INDUSTRIES PRIVATE LIMITED',
    'RAJSAMAND MSW PRIVATE LIMITED',
    'MUMBAI ASSOCIATION OF LUXURY EMBROIDERY EXPORTERS',
    'SUNPOLY PLASTICS PRIVATE LIMITED',
    'EVENTRO EVENTS AND TRAVELS PRIVATE LIMITED',
    'MYND FINTECH PRIVATE LIMITED',
    'PIRI.AI PRIVATE LIMITED',
    'SHREAS BIOLOGICALS PRIVATE LIMITED',
    'BUGSMIRROR RESEARCH PRIVATE LIMITED',
    'CLEVELAND BRIDGE STEEL INDIA PRIVATE LIMITED',
    'SHR TRADECORP PRIVATE LIMITED',
    'OTTVERSE PRIVATE LIMITED',
    'VISTA SPACES EARTH PRIVATE LIMITED',
    'BRAR FUTURISTICS INDIA PRIVATE LIMITED',
    'SHREE INDRA COTFAB PRIVATE LIMITED',
    'SIMPHEAL INFORMATICS PRIVATE LIMITED',
    'ACIC RGU FOUNDATION',
    'PREMIER RESEARCH GROUP (INDIA) PRIVATE LIMITED',
    'ACE TURTLE COMMERCE PRIVATE LIMITED',
    'SNOWCEM INDIA PRIVATE LIMITED',
    'ASSOCIATION OF FRESH PRODUCE',
    'OURGENIE TECHNOLOGIES PRIVATE LIMITED',
    'DASHCLICKS INDIA PRIVATE LIMITED',
    'FLYING DISC SPORTS FEDERATION (INDIA)',
    'SMARTIQ EDUCATIONAL SERVICES PRIVATE LIMITED',
    'OKR STARS PRIVATE LIMITED',
    'MINDTAXCE SOLUTIONS PRIVATE LIMITED',
    'N N HILLS PRIVATE LIMITED',
    'MICROBELLS PRIVATE LIMITED',
    'GAMUT FACILITY MANAGEMENT PRIVATE LIMITED',
    'ASMAA DIGITAL INDIA PRIVATE LIMITED',
    'AASRAA ADROIT FOUNDATION',
    'GODX MEDIA PRIVATE LIMITED',
    'RISKSUCCESS PRIVATE LIMITED',
    'RMB HEALTH FOODS PRIVATE LIMITED',
    'LEVELUP EDU PRIVATE LIMITED',
    'FUN2DO LABS PRIVATE LIMITED',
    'BYTE AUTOMATION PRIVATE LIMITED',
    'MCFARADAYS AND ASSOCIATES PRIVATE LIMITED',
    'GUNN SOLUTION INDIA PRIVATE LIMITED',
    '2G DIGITAL LOCALIZATION SERVICES PRIVATELIMITED',
    'ONEMERIT EDUTECH SERVICES PRIVATE LIMITED',
    'BMTNMART RETAIL PRIVATE LIMITED',
    'FAIRDEBT SOLUTIONS PRIVATE LIMITED',
    'PROJECT RANGEET PRIVATE LIMITED',
    'PHOENIX GLOBALTRANS SOLUTIONS PRIVATE LIMITED',
    'COOLING EQUIPMENTS PRIVATE LIMITED',
    'CARBON PHOENIX PRIVATE LIMITED',
    'OCIUZ INFOTECH PRIVATE LIMITED',
    'MIZTECH AI MINDS PRIVATE LIMITED',
    'MOMENTUM INDIA FACILITIES MANAGEMENT PRIVATE LIMITED',
    'UGLOBE TECHNOSOFT PRIVATE LIMITED',
    'TARU IT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SKITES RETAIL PRIVATE LIMITED',
    'FLICK IDEA PRIVATE LIMITED',
    'SHREE RJD MALLS AND HOTELS PRIVATE LIMITED',
    'LEARN & PROSPER PRIVATE LIMITED',
    'JYOTHIS HOTELS PRIVATE LIMITED',
    'ARCHITAGE PROPERTIES PRIVATE LIMITED',
    'NEXTEN SUPER GROWTH PRIVATE LIMITED',
    'MJSPR PRIVATE LIMITED',
    'ABHISATYA PRIVATE LIMITED',
    'INZPIRA EDU SOLUTIONS PRIVATE LIMITED',
    'RM AGRONATURE PRIVATE LIMITED',
    'SINGHANIA EDUCATION LIMITED',
    'BROOMEES INDIA PRIVATE LIMITED',
    'BULTAMINDS VENTURE PRIVATE LIMITED',
    'SOUTHGATE KASAULI SUITES PRIVATE LIMITED',
    'AMOGHAM DEVELOPERS PRIVATE LIMITED',
    'ACES INDIA PRIVATE LIMITED',
    'SPROUTEX PRIVATE LIMITED',
    'BLISSBOOKS TECHNOLOGIES PRIVATE LIMITED',
    'PLANTEX FLAVOURS PRIVATE LIMITED',
    'PRERAK GREENTECH PRIVATE LIMITED',
    'STHAAA LIFESTYLE PRIVATE LIMITED',
    'LAUNDRY CRAFT INDIA PRIVATE LIMITED',
    'VELUXE LIVING INDIA PRIVATE LIMITED',
    'NERBIO PRIVATE LIMITED',
    'HAO DIGITAL PRIVATE LIMITED',
    'VINIYOKTALAI PRIVATE LIMITED',
    'JMVKS CARE FOUNDATION',
    'SHI5DA TALENTIE PRIVATE LIMITED',
    'GOINGZERO INNOVATIONS PRIVATE LIMITED',
    'NICE KART PRIVATE LIMITED',
    'INVENTA CAR CARE PRIVATE LIMITED',
    'KRTEX RAWMATERIAL PRIVATE LIMITED',
    'BACK2SOIL (OPC) PRIVATE LIMITED',
    'APPSPIRE LABS PRIVATE LIMITED',
    'BM SCIENTIFIC PRIVATE LIMITED',
    'SYSTANGO ACCOUNT AGGREGATOR SERVICES PRIVATE LIMITED',
    'TELESOL INFRA AND PROJECTS PRIVATE LIMITED',
    'SWITCHTECH INCUBATOR FOUNDATION',
    'TRIPLE FOUR PRIVATE LIMITED',
    'BAY STEEDS PRIVATE LIMITED',
    'RKA ENGINEERING PRIVATE LIMITED',
    'BRANDMATIC TECHNOLOGIES PRIVATE LIMITED',
    'TECH SMC SQUARE INDIA PRIVATE LIMITED',
    'SOULFUEL COUNSELING AND THERAPY (OPC) PRIVATE LIMITED',
    'BRIGHTTELE RADIOLOGY (OPC) PRIVATE LIMITED',
    'A3JM PRIVATE LIMITED',
    'DEVIKA INDUSTRIES PRIVATE LIMITED',
    'KYLO EDUTECH PRIVATE LIMITED',
    'SIROHIESTORE INTERNET PRIVATE LIMITED',
    'EIGHTWE DIGITAL TRANSFORMATIONS PRIVATE LIMITED',
    'PROMINENT FIBRES PRIVATE LIMITED',
    'PIRINC TRADING PRIVATE LIMITED',
    'FTK EDUTECH PRIVAE LIMITED',
    'MYCELIUM SONA BIOTECH PRIVATE LIMITED',
    'PHOTONVOLT INDIA PRIVATE LIMITED',
    'BIOTRIK ORGANIZATION PRIVATE LIMITED',
    'AIHS INTERNATIONAL HOTELS AND RESORTS PRIVATE LIMITED',
    'BABY MAYA DEVI STEELS PRIVATE LIMITED',
    'FIVE SALTS PRIVATE LIMITED',
    'FARM TO FAMILY FARMER PRODUCER COMPANY LIMITED',
    'AGSYNERGY GENETICS PRIVATE LIMITED',
    'SOURCING BIRDS PRIVATE LIMITED',
    'CELL FORCE POWER PRIVATE LIMITED',
    'MACLIFE PHARMACEUTICAL PRIVATE LIMITED',
    'BAGHUNT PRIVATE LIMITED',
    'MINITOWN MART INDIA PRIVATE LIMITED',
    'HUMANISTA SERVICES PRIVATE LIMITED',
    'MIS INFOSERVE PRIVATE LIMITED',
    'CRAFTBYSUPRIYA PRIVATE LIMITED',
    'NEXT ANGLE PRIVATE LIMITED',
    'HONEST ECOHOMES PRIVATE LIMITED',
    'HYFIRST FOOD PRIVATE LIMITED',
    'SIMUNAUTIX INDIA PRIVATE LIMITED',
    'FOSTER PAYMENT NETWORKS PRIVATE LIMITED',
    'BUZZING BULBS PRIVATE LIMITED',
    'CODEZEND PRIVATE LIMITED',
    'CHITTOR PLASTFAB PRIVATE LIMITED',
    'V MOR HOLDING PRIVATE LIMITED',
    'VIGOROUS FOOD VENTURES PRIVATE LIMITED',
    'DENSITOR ENERGY STORAGE PRIVATE LIMITED',
    'GODSLAND FARMFRESH PRIVATE LIMITED',
    'NATUROGENIE AGRO SERVICES PRIVATE LIMITED',
    'MUMBAI SCHOOL OF CINEMATIC & PERFORMING ARTS EDUCATION FOUNDATION',
    'NIRALTEK SOLUTIONS PRIVATE LIMITED',
    'GREENLINE MOBILITY SOLUTIONS LIMITED',
    'ARIMAX GLOBAL PRIVATE LIMITED',
    'MAHESHTALA WASTE WATER MANAGEMENT PRIVATE LIMITED',
    'PRIDEINFRA SERVICES PRIVATE LIMITED',
    'CARDROP INDIA PRIVATE LIMITED',
    'ATHOM FOODS PRIVATE LIMITED',
    'HELLOOEXPERT PRIVATE LIMITED',
    'ASHOKA AUTOMOTIVES INDIA PRIVATE LIMITED',
    'HERMANO TECHNOLOGIES PRIVATE LIMITED',
    'BRAHM INNERBRAIN TECHNOLOGIES PRIVATE LIMITED',
    'FLYAGAIN ONLINE PRIVATE LIMITED',
    'SPIRITS & ALCHEMY PRIVATE LIMITED',
    'GOLD PARKS PRIVATE LIMITED',
    'CONTREXT PRIVATE LIMITED',
    'GLOBAL ACADEMY OF PROFESSIONAL ACCOUNTANTS WELFARE FOUNDATION',
    'ROYAL GUILD FINANCIAL SERVICES PRIVATE LIMITED',
    'EDUZPHERE E-SOLUTIONS PRIVATE LIMITED',
    'PLATERON PRIVATE LIMITED',
    'BUILD GEEKS PRIVATE LIMITED',
    'PWAT SOLUTIONS PRIVATE LIMITED',
    'ULTRA INTELLIGENT LIGHTS PRIVATE LIMITED',
    'ARISKEM PHARMACEUTICALS PRIVATE LIMITED',
    '360 RISING ZEST REALTORS PRIVATE LIMITED',
    'KREDITSERVE FINANCIAL ADVISORY SERVICES PRIVATE LIMITED',
    'MILOS AUTOMATION (INDIA) PRIVATE LIMITED',
    'DV AYUSH SAFETY AND MEDICARE PRIVATE LIMITED',
    'KARMA REHACARE PRODUCTS PRIVATE LIMITED',
    'JALPALLY ESTATES PRIVATE LIMITED',
    'ACCOVET INFOTECH PRIVATE LIMITED',
    'VEKTRON INDIA PRIVATE LIMITED',
    'REEVOY INDIA PRIVATE LIMITED',
    'GK TECH SYSTEMS PRIVATE LIMITED',
    'FOCUSKON TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GAYATRIDEVI GROUP PRIVATE LIMITED',
    'FLY BUK PRIVATE LIMITED',
    'SSRAMG ENVIRO CARE PRIVATE LIMITED',
    'TRIDHAATU MORYA DEVELOPERS PRIVATE LIMITED',
    'UKAMA PRIVATE LIMITED',
    'QUANTLOGIX INVESTMENTS PRIVATE LIMITED',
    'SLEEVETECHS PRIVATE LIMITED',
    'DIVYATATVA YOG FOUNDATION',
    'INAC MICROTEK PRIVATE LIMITED',
    'NANGAL INDUSTRIES PRIVATE LIMITED',
    'SPG PAPERS PRIVATE LIMITED',
    'PRAGATI FINSERV PRIVATE LIMITED',
    'NATURE & WILDLIFE CONSERVATION FOUNDATION',
    'DIGITAL DOCUMENTATION SYSTEMS PRIVATE LIMITED',
    'KES SECURITY PRIVATE LIMITED',
    'DR SANKARAN',
    'AGRO PROCESSORS',
    'S KNOT PRODUCT PRIVATE LIMITED',
    'VELAMMAL NEXUS FOUNDATION',
    'VIHAAN HEALTHCARE PRIVATE LIMITED',
    'OK MAMA PRIVATE LIMITED',
    'BAGGEDIT SOLUTIONS PRIVATE LIMITED',
    'ROULETTE TECHNOLOGIES PRIVATE LIMITED',
    'PAREKH FIRE SOLUTIONS PRIVATE LIMITED',
    'BUSINESS WISWORLD PRIVATE LIMITED',
    'TYPSA INDIA PRIVATE LIMITED',
    'EUREKA DIGITISATION & AUTOMATION SERVICES PRIVATE LIMITED',
    'STEPCARE WHITEFIELD PRIVATE LIMITED',
    'STEPCARE DIGITAL HEALTH PRIVATE LIMITED',
    'SAFTI PRIVATE LIMITED',
    'TRIPLE PLAY INFRA PRIVATE LIMITED',
    'YOUTH FREELANCERS (OPC) PRIVATE LIMITED',
    'INCRED.AI LIMITED',
    'KB CYCLES PRIVATE LIMITED',
    'RAGHUKUL MANAGEMENT SERVICES PRIVATE LIMITED',
    'KOSH WELLNESS PRIVATE LIMITED',
    'WEB TORA TECH (OPC) PRIVATE LIMITED',
    'ALLTHINGS TOMORROW SUSTAINABLE VENTURES PRIVATED LIMITED',
    'HAYAN CHEMS PRIVATE LIMITED',
    'SMOKEY LOUNGE CAFE PRIVATE LIMITED',
    'SEAT AT THE TABLE PRIVATE LIMITED',
    'CHENNAIGAMES STUDIO PRIVATE LIMITED',
    'METTLESEMI SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED',
    'SEYFERT NETWORKS PRIVATE LIMITED',
    'IMPERIAL ENGLISH UK PRIVATE LIMITED',
    'CAPSQUARE TECHNOLOGIES PRIVATE LIMITED',
    'SCALE TESTING LAB PRIVATE LIMITED',
    'AGRINEST FOOD CORPORATION PRIVATE LIMITED',
    'AARTI PACKWELL PRIVATE LIMITED',
    'GOTRAVELBLUE PRIVATE LIMITED',
    'ATSK TECHNOLOGY PRIVATE LIMITED',
    'MERGE BUILDTECH SOLUTIONS PRIVATE LIMITED',
    'SANMITHRA NIDHI LIMITED',
    'ELEVED LIFESTYLE PRIVATE LIMITED',
    'GLOWAR ORGANICS & INNOVATIONS PRIVATE LIMITED',
    'CELLUTIONS BIOSTORAGE PRIVATE LIMITED',
    'INNERKRAFT HEALTH PRIVATE LIMITED',
    'B.BOY BODYWEAR',
    'S FINSERV PRIVATE LIMITED',
    'PRAGHNA CENTRE FOR RESEARCH',
    'RAJAWAT BROTHERS SECURITY SERVICES INDIA PRIVATE LIMITED',
    'MOTLEY LOGISTICS PRIVATE LIMITED',
    'SARVE SAI EDIBLE OILS PRIVATE LIMITED',
    'JV MEDICENTRES PRIVATE LIMITED',
    'FADELESS ENTERPRISES (OPC) PRIVATE LIMITED',
    'MERAKI CARRIERS PRIVATE LIMITED',
    'PHARMARON LABS PRIVATE LIMITED',
    'PEGASUS OPULENCE FOUNDATION',
    'UNCLE DELIVERY EXPRESS PRIVATE LIMITED',
    'PLENITUDE ENTERPRISES PRIVATE LIMITED',
    'ADANI NEW INDUSTRIES LIMITED',
    'ZOMODA GLOBAL PRIVATE LIMITED',
    'AMG PACE PRIVATE LIMITED',
    'GO4 GIGA SERVICES PRIVATE LIMITED',
    'RASYA HEARING PRIVATE LIMITED',
    'BNI FOUNDATION INDIA',
    'DUNCAN AND ROSS TECHNOLOGY ENGINEERING INDIA PRIVATE LIMITED',
    'TEXASHIPPING PRIVATE LIMITED',
    'ECOLIFE CONCEPT PRIVATE LIMITED',
    'DEEL EOR PRIVATE LIMITED',
    'AAHAAR SEVA FOUNDATION',
    'STACKWORKS LABS PRIVATE LIMITED',
    'METRIX CONSULTING SERVICES PRIVATE LIMITED',
    'NISPRUHA FOODS PRIVATE LIMITED',
    'INNOVTECH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SOHO MART PRIVATE LIMITED',
    'SAMKIT TECHNOLOGIES PRIVATE LIMITED',
    'LEXICON INFOTAINMENT PRIVATE LIMITED',
    'BIKECART INDIA PRIVATE LIMITED',
    'PUNDITZ RISE PRIVATE LIMITED',
    'GREENWICH METALS INDIA PRIVATE LIMITED',
    'AVL SYSTEM PRIVATE LIMITED',
    'GAURAVI REALTY PRIVATE LIMITED',
    'SPANDAN INTEGRATED PRIVATE LIMITED',
    '4EVER4WARD PRIVATE LIMITED',
    'MAVAL INDUSTRIAL AND LOGISTICS PARKS PRIVATE LIMITED',
    'PAREA INDUSTRIES PRIVATE LIMITED',
    'YOG LOVE WELLNESS PRIVATE LIMITED',
    'EDUVOCATE TECHNOLOGIES PRIVATE LIMITED',
    'TORUS WEALTH PRIVATE LIMITED',
    'JEENOMICS LABORATORY PRIVATE LIMITED',
    'NANOCOMPS R&D (INDIA) PRIVATE LIMITED',
    'AXON DIGITAL SOLUTIONS PRIVATE LIMITED',
    'MOBILOGI TECHNOLOGIES PRIVATE LIMITED',
    'NEUBERG HOME TECHNOLOGIES PRIVATE LIMITED',
    'SPINHOLE MIDDLE EAST PRIVATE LIMITED',
    'TEPSOL ARKA SOLAR PRIVATE LIMITED',
    'AMNEAL HEALTHCARE PRIVATE LIMITED',
    'KUMAON ECO PRIVATE LIMITED',
    'POWERGRID GOMTI YAMUNA TRANSMISSION LIMITED',
    'TAM HANGERS PRIVATE LIMITED',
    'E S INFOTECH PRIVATE LIMITED',
    'H & G EBIZ PRIVATE LIMITED',
    'RMG MARKETING INDIA PRIVATE LIMITED',
    'SACRED DOT TOURS PRIVATE LIMITED',
    'PRIMEPLEX TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'GOGREEN PAINT FINISHING SYSTEMS PRIVATE LIMITED',
    'ZOCKET TECHNOLOGIES PRIVATE LIMITED',
    'PICI VENTURES PRIVATE LIMITED',
    'POOLA ENERGY PRIVATE LIMITED',
    'E3I HEALTH PRIVATE LIMITED',
    '1NEOFF INSTITUTE PRIVATE LIMITED',
    'UNISON GLOBUS AALLIANCES PRIVATE LIMITED',
    'SPM LIFECARE PRIVATE LIMITED',
    'INDRNA PRIVATE LIMITED',
    'LION ENERGY LITHIUM BATTERIES PRIVATE LIMITED',
    'K7 ESTORES PRIVATE LIMITED',
    'LAXMI HOT BAKERS PRIVATE LIMITED',
    'ENROLIN INFOTECH PRIVATE LIMITED',
    'UNICOHUB PRIVATE LIMITED',
    'DDSPLM PRIVATE LIMITED',
    'WARPVELOCITY TECHNOLOGY PRIVATE LIMITED',
    'WAFT-GLOBAL DIGITAL PRIVATE LIMITED',
    'HATCHLAB RESEARCH CENTRE',
    'CRIVENO PRIVATE LIMITED',
    'HANGRYCUB PRIVATE LIMITED',
    'REEARTH TECH PRIVATE LIMITED',
    'AFFORD LEARNINGS PRIVATE LIMITED',
    'SHEPAYS FINANCIAL SERVICES PRIVATE LIMITED',
    'ZABAAN PRODUCTIONS PRIVATE LIMITED',
    'RESORT RIO LUXURY HOTELS PRIVATE LIMITED',
    'AZLOGICS PRIVATE LIMITED',
    'REENVISION EVENTS PRIVATE LIMITED',
    'RAMASIS ENERGY LIMITED',
    'ADDEDU TECH LEARNING PRIVATE LIMITED',
    'NXT TECHNOLOGY & EQUIPMENT PRIVATE LIMITED',
    'SE WATER AND AIR PRIVATE LIMITED',
    'HILL FORT INVESTMENT MANAGERS INDIA PRIVATE LIMITED',
    'ES EM AUTOMOBILES PRIVATE LIMITED',
    'PRECISION INFOTECH PRIVATE LIMITED',
    'CITADEL SECURITIES INDIA MARKETS PRIVATELIMITED',
    'AQUAGENIXPRO PRIVATE LIMITED',
    'MTHELMETS INDIA PRIVATE LIMITED',
    'COSMO SPECIALITY POLYMERS PRIVATE LIMITED',
    'NESTED VENTURES PRIVATE LIMITED',
    'DT VENTURES PRIVATE LIMITED',
    'KOLKATA KITCHENS (OPC) PRIVATE LIMITED',
    'INSIGHT MARKATON PRIVATE LIMITED',
    'DLT APPS SOFTWARE SERVICES PRIVATE LIMITED',
    'BIZINBIZ TECHNOLOGIES PRIVATE LIMITED',
    'CONVERZAI RESEARCH AND DEVELOPMENT INDIAPRIVATE LIMITED',
    'CATALYZE ENTERPRISE PRIVATE LIMITED',
    'FINCORPIT CONSULTING PRIVATE LIMITED',
    'SOUTH STAR SOFTWARE PRIVATE LIMITED',
    'DUTCH LINES INDIA PRIVATE LIMITED',
    'UMBRELLASHIELD FOUNDATION',
    'VALUEDX TECHNOLOGIES PRIVATE LIMITED',
    'DAW TECHNOLOGY LABS PRIVATE LIMITED',
    'SUNDAYS FOREVER STAYS PRIVATE LIMITED',
    'EQUAFIN SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'ENERGYWIZ PRIVATE LIMITED',
    'SYSTOX PHARMA PRIVATE LIMITED',
    'STREAMHUB INDIA PRIVATE LIMITED',
    'SHIPCON MANUFACTURING PRIVATE LIMITED',
    'HR REMEDY INDIA PRIVATE LIMITED',
    'HEXAQUEST GLOBAL PRIVATE LIMITED',
    'EDIKSHA VENTURES PRIVATE LIMITED',
    'EASYGO PROPERTIES PRIVATE LIMITED',
    'COMACOE PRIVATE LIMITED',
    'SIL MECHATRONICS PRIVATE LIMITED',
    'OCTALABS TECHNOLOGIES PRIVATE LIMITED',
    'APPNAI TECHNOLOGIES PRIVATE LIMITED',
    'CLARUSTO PRIVATE LIMITED',
    'AUM COWORKING PRIVATE LIMITED',
    'BRIDGEUP TECH PRIVATE LIMITED',
    'HOME EGO PRIVATE LIMITED',
    'ART SQUARE ENTERTAINMENT PRIVATE LIMITED',
    'ARAGORN HEALTHCARE PRIVATE LIMITED',
    'AVAADA INDSOLAR PRIVATE LIMITED',
    'BLUFFF TECH PRIVATE LIMITED',
    'JOBTREES SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'KSYNERGY INTEGRATED MARKETING AND COMMUNICATIONS INDIA PRIVATE LIMITED',
    'BAADER SCHULZ LABORATORIES PRIVATE LIMITED',
    'KALAKAAR CASTLE PRIVATE LIMITED',
    'DIGI DELUXE STUDIO (OPC) PRIVATE LIMITED',
    'IDEAWISE TECHNOLOGIES PRIVATE LIMITED',
    'JAYSIS GREEN ENERGY INFRA PRIVATE LIMITED',
    'EPILLO HEALTH SYSTEMS PRIVATE LIMITED',
    'A2SG BIOFUELS PRIVATE LIMITED',
    'VENTURIQ SOLUTIONS INDIA PRIVATE LIMITED',
    'EDVENTURECLUB MEDIA TECHNOLOGIES PRIVATELIMITED',
    'FUNDFOLIO FINTECH PRIVATE LIMITED',
    'WENGER & WATSON BUSINESS SYSTEMS PRIVATELIMITED',
    'E-ASHWA AUTOMOTIVE (RAJ) PRIVATE LIMITED',
    'KATARIA HOLIDAYS PRIVATE LIMITED',
    'NESTA PRIME PRIVATE LIMITED',
    'MYJOBCART SOFTWARE PRIVATE LIMITED',
    'NEOBEE SOLUTIONS PRIVATE LIMITED',
    'WAR94 GAMING PRIVATE LIMITED',
    'SRNOME PRIVATE LIMITED',
    'VIRTUALTX REMOTE SPEECH PRIVATE LIMITED',
    'BISMARCK INDUSTRIES (OPC) PRIVATE LIMITED',
    'VADP DESIGN AND MFG TECHNOLOGIES PRIVATELIMITED',
    'INFOAXON INNOVATIONS PRIVATE LIMITED',
    'TRAJ CONTROLS PRIVATE LIMITED',
    'COMPETITIVE CRACKER PRIVATE LIMITED',
    'VATIKA BUSINESS CENTRES PRIVATE LIMITED',
    'VNATA INFRAESTATE (OPC) PRIVATE LIMITED',
    'REPLXE TECHNOLOGIES PRIVATE LIMITED',
    'MPJS INTERNATIONAL PRIVATE LIMITED',
    'LOPAN INDUSTRIES PRIVATE LIMITED',
    'FLAME EDUCARE PRIVATE LIMITED',
    'CROPSON AGRO PRODUCER COMPANY LIMITED',
    'SQROOT MEDIA PRIVATE LIMITED',
    'BLUEROCK ASSETS PRIVATE LIMITED',
    'DECIMATION DEVELOPER ASSOCIATES PRIVATE LIMITED',
    'VINAYAK AGRO-HERBAL PRIVATE LIMITED',
    'SREE KARIYATHAN CONSTRUCTION PRIVATE LIMITED',
    'NATURESUM (OPC) PRIVATE LIMITED',
    'ASTRO COMPUTERS INDIA PRIVATE LIMITED',
    'GRRATZ CONSULTING PRIVATE LIMITED',
    'PODPLANNER PRIVATE LIMITED',
    'MEWT ACCOUNT PRIVATE LIMITED',
    'MESON LABS PRIVATE LIMITED',
    'MOTHERS MEDICA PRIVATE LIMITED',
    'BEYOND HANDMADE PRIVATE LIMITED',
    'INNOWEAVE GLOBAL PACKAGING SOLUTIONS PRIVATE LIMITED',
    'TEK-HUMMINGBIRD PRIVATE LIMITED',
    'TECHNODREAM RESEARCH AND TRAINING FOUNDATION',
    'EVENSPEED TRADING PRIVATE LIMITED',
    'SYSTEMONEX PRIVATE LIMITED',
    'NEPOLITE CONCRETE SOLUTIONS PRIVATE LIMITED',
    'YOGAMRUTHA WELLNESS PRIVATE LIMITED',
    'RADICULT INNOVATIONS PRIVATE LIMITED',
    '4IBIZ TECHNO-SOLUTIONS PRIVATE LIMITED',
    'EQUIRESEARCH INVESTMENT ADVISORY SERVICES PRIVATE LIMITED',
    'PAPER PLANES PICTURES PRIVATE LIMITED',
    'GATS TELECOM PRIVATE LIMITED',
    'EXCLQUEST PRIVATE LIMITED',
    'ADVAITH AEROSPACE PRIVATE LIMITED',
    'CAN ANALYTICS PRIVATE LIMITED',
    'MEEAMI TECHNOLOGIES PRIVATE LIMITED',
    'SIEGERQ PRIVATE LIMITED',
    'M7 MEDIA PRIVATE LIMITED',
    'DOVEMED WELLNESS & ANALYTICS (INDIA) PRIVATE LIMITED',
    'DMP GLOBAL PRIVATE LIMITED',
    'MAVERX NETPRENEUR FOUNDATION',
    'VIANAAR DESIGNS PRIVATE LIMITED',
    'LEVATUR COMMUNICATIONS PRIVATE LIMITED',
    'RS INFRAREALITY PRIVATE LIMITED',
    'DOLPHIN POD PRIVATE LIMITED',
    'RAMANA INFRA SOLUTIONS PRIVATE LIMITED',
    'IMAST OPERATIONS PRIVATE LIMITED',
    'GRENEWABLE ENGINEERING SYSTEMS PRIVATE LIMITED',
    'UNI ONE INDIA PRIVATE LIMITED',
    'MISSION SAFE AND SMARTCITY INFRASTRUCTURE PRIVATE LIMITED',
    'NUTRITI BIOTECH PRIVATE LIMITED',
    'KLICQTECH IT SOLUTIONS PRIVATE LIMITED',
    'BINGE CAFE CONCEPTS PRIVATE LIMITED',
    'SANBARTA MANAGEMENT CONSULTING PRIVATE LIMITED',
    'RDP INFOTECH PRIVATE LIMITED',
    'ALFRESCO RENEWABLE ENERGY PRIVATE LIMITED',
    'INTOW PRIVATE LIMITED',
    'SEMESTA SOFTWARES PRIVATE LIMITED',
    'KEMEXEL VENTURES PRIVATE LIMITED',
    'UP SARILA URJA PRIVATE LIMITED',
    'COMBINE MOVERS PRIVATE LIMITED',
    'P&M MOVIES PRIVATE LIMITED',
    'VONDA TECHNOLOGY PRIVATE LIMITED',
    'MERCY FOR ANIMALS INDIA FOUNDATION',
    'AEROSTAR JET TRAINING ACADEMY PRIVATE LIMITED',
    'SILVERARCH INVESTMENT ADVISERS PRIVATE LIMITED',
    'PERFECT CHEM ENGINEERING PRIVATE LIMITED',
    'HVAC SPACE AIR PRIVATE LIMITED',
    'BONSAI ENTERPRISES PRIVATE LIMITED',
    'R-ESTATE SOLUTIONS PRIVATE LIMITED',
    'AUSTRALIAN ENERGY STORAGE SOLUTIONS PRIVATE LIMITED',
    'GRAMYA SANJYOG TECHNOLOGIES PRIVATE LIMITED',
    'AAURCRED PRIVATE LIMITED',
    'UINCEPT GLOBAL PRIVATE LIMITED',
    'KROLOG SOLUTIONS PRIVATE LIMITED',
    'FUTURE TRENDZ LIMITED',
    'DANANDA SERVICES PRIVATE LIMITED',
    'GRARRI PRIVATE LIMITED',
    'NOVITIUM LABS PRIVATE LIMITED',
    'UNIFIED CORPORATION PRIVATE LIMITED',
    'SNS SHIPPING SERVICES INDIA PRIVATE LIMITED',
    'LINKUS INFRATECH PRIVATE LIMITED (OPC)',
    'SJTECH SOLUTIONS PRIVATE LIMITED',
    'RENEWIN TECHNOLOGIES PRIVATE LIMITED',
    'AGNEXT TECHNOLOGIES PRIVATE LIMITED',
    'MAANAV MANDIR HERBALS PRIVATE LIMITED',
    'LAU KUSH PHARMACY PRIVATE LIMITED',
    'GOODDOT ENTERPRISES PRIVATE LIMITED',
    'UNIQTRONICS SOLUTIONS PRIVATE LIMITED',
    'COMMENCER SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SPORTSQ PRIVATE LIMITED',
    'BIZZ AT EASE INDIA PRIVATE LIMITED',
    'DECIPHER ZONE TECHNOLOGIES PRIVATE LIMITED',
    'VANDITA REALTORS PRIVATE LIMITED',
    'YES PROPERTY VENTURES PRIVATE LIMITED',
    'ESHWARI FABTECH INDUSTRIES PRIVATE LIMITED',
    'VASTHI INSTRUMENTS PRIVATE LIMITED',
    'CHRYSTAL CROWN CONSULTING AND SOLUTIONS PRIVATE LIMITED',
    'CUCKU CONSTRUCTIONS INDIA PRIVATE LIMITED',
    'TELEONE ONLINE VENTURE PRIVATE LIMITED',
    'SSS GLOBAL FREIGHT PRIVATE LIMITED',
    'SEAMLESS CORPORATE GIFTS (OPC) PRIVATE LIMITED',
    'MINDCRAWLLER GLOBAL PRIVATE LIMITED',
    'BYWAY EXPERIENCES PRIVATE LIMITED',
    'FLYNET TECHNOLOGIES PRIVATE LIMITED',
    'TEREOS INDIA PRIVATE LIMITED',
    'DHAN VRADDHI CREDIT NIDHI LIMITED',
    'RED ROSE ENGICON PRIVATE LIMITED',
    'STARLLY SOLUTIONS PRIVATE LIMITED',
    'WIPRO HR SERVICES INDIA PRIVATE LIMITED',
    'ALPHA NODUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'POLYOLS & POLYMERS PRIVATE LIMITED',
    'RUBIX-TECH SERVICES PRIVATE LIMITED',
    'KHAKHI JEANS PRIVATE LIMITED',
    'FSH BUSINESS VENTURES PRIVATE LIMITED',
    'TATTVALABS PRIVATE LIMITED',
    'INCUSPAZE SOLUTIONS PRIVATE LIMITED',
    'JEEVAN AADHAR AARAMBH ASSOCIATION',
    'NISABA GODREJ FOUNDATION FOR EDUCATION',
    'GAGELLAN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TATTVAM MEDIA PRIVATE LIMITED',
    'UVAAN INFOTECH PRIVATE LIMITED',
    'ROWTH TECHNOLOGY PRIVATE LIMITED',
    'BE BIRBAL DIGITAL MEDIA PRIVATE LIMITED',
    'SMARTSHIELD INDUSTRIES PRIVATE LIMITED',
    'INHOF TECHNOLOGIES PRIVATE LIMITED',
    'DATALIFEHEALTH SERVICES PRIVATE LIMITED',
    'MOSTLY HARMLESS (OPC) PRIVATE LIMITED',
    'AMAR HITECH ENGINEERING INDUSTRIES PRIVATE LIMITED',
    'POLYGON WEB SOLUTIONS (OPC) PRIVATE LIMITED',
    'INFINEUM INDIA ADDITIVES PRIVATE LIMITED',
    'KPN LABELS PRIVATE LIMITED',
    'APROPOSDRIVE TECHNOLOGIES PRIVATE LIMITED',
    'INDIA AVENUE INVESTMENT ADVISORS PRIVATELIMITED',
    'SANZYME BIOLOGICS PRIVATE LIMITED',
    'SUSHRUTA SURGICALS PRIVATE LIMITED',
    'IAIDC TECHNOLOGIES PRIVATE LIMITED',
    'METTANOX INFRATECK PRIVATE LIMITED',
    'SHAHI TEXTILES PRIVATE LIMITED',
    'GUILD ENGINEERING TURNKEY SOLUTIONS PRIVATE LIMITED',
    'KARYTECH PRIVATE LIMITED',
    'BN CORP PRIVATE LIMITED',
    'WINSPIRE TECH PRIVATE LIMITED',
    'TRIP TO MY DREAMS PRIVATE LIMITED',
    'ALLIED ENGINEERING AND INFRASTRUCTURE PRIVATE LIMITED',
    'AGARWAL ELECTROSAFE WORKS PRIVATE LIMITED',
    'LEBEN INDIA PRIVATE LIMITED',
    'ASTAREAL (INDIA) PRIVATE LIMITED',
    'ALTAN ENGINEERING PRIVATE LIMITED',
    'CYBERSHELTER INFOSEC PRIVATE LIMITED',
    'TABARAK TRAVEL SERVICES PRIVATE LIMITED',
    'TERRAFORM GLOBAL INDIA PRIVATE LIMITED',
    'ESERVECLOUD SOLUTIONS PRIVATE LIMITED',
    'APPLUS INDIA PRIVATE LIMITED',
    'SUGEE REALTY & DEVELOPERS (INDIA) PRIVATE LIMITED',
    'MUN BROTHERS PRIVATE LIMITED',
    'M. Y. ONELAKH SHOPPING INDIA PRIVATE LIMITED',
    'SHREE SARJAN INDUSTRIES PRIVATE LIMITED',
    'AUFBLUHEN PRIVATE LIMITED',
    'HONASA CONSUMER LIMITED',
    'DZ FRESH FOODS PRIVATE LIMITED',
    'AVIRAL TECHNOLOGY SOLUTIONS AND TELECOM PRIVATE LIMITED',
    'APPLESEED INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'HYPERWORKS IMAGING PRIVATE LIMITED',
    'EXAGOGI CONSULTING ENGINEERING PRIVATE LIMITED',
    'SILKWAYS WEB SHOPPIE PRIVATE LIMITED',
    'EYP CREATIONS PRIVATE LIMITED',
    'ABDULRAHMAN AL-NAIM CONSULTANT ENGINEERS(ACE) INDIA PRIVATE LIMITED',
    'DCM NOUVELLE LIMITED',
    'LBTEX PRIVATE LIMITED',
    'REEVIK EXPORTS PRIVATE LIMITED',
    'COMTE BEVERAGES PRIVATE LIMITED',
    'DELVIT SOLUTIONS PRIVATE LIMITED',
    'RAVI HORTICULTURE (INDIA) PRIVATE LIMITED',
    'BUDC INDIA PRIVATE LIMITED',
    'MADHUVAN SUGARS PRIVATE LIMITED',
    'GOVEGGY INDIA PRIVATE LIMITED',
    'AJTECH FOODS (OPC) PRIVATE LIMITED',
    'SHREE HARI FOOD PRODUCTS PRIVATE LIMITED',
    'UNIKITH AGRO FOODS PRIVATE LIMITED',
    'SIRI FOODS PRIVATE LIMITED',
    'POPULAR FOOD TECHNOLOGY PRIVATE LIMITED',
    'INSTANT RASOI (OPC) PRIVATE LIMITED',
    'AB HYGIENE PRODUCTS PRIVATE LIMITED',
    'CG SNACKS PRIVATE LIMITED',
    'PERFORMANCE SPECIALTY PRODUCTS (INDIA) PRIVATE LIMITED',
    'SOWTEX NETWORK PRIVATE LIMITED',
    'MAYORI CONSCIOUS CLOTHING PRIVATE LIMITED',
    'SARA SPICES PRIVATE LIMITED',
    'REDLABS CHEMICALS PRIVATE LIMITED',
    'ALVENTA PHARMA LIMITED',
    'COMET GLOBAL PRIVATE LIMITED',
    'COMET PERFORMANCE CHEMICALS PRIVATE LIMITED',
    'BATAVIA PHARMA PRIVATE LIMITED',
    'EISNER CROP SCIENCES PRIVATE LIMITED',
    'ISCA SYSTEMS INDIA PRIVATE LIMITED',
    'SUMWIN SOLUTIONS INDIA PRIVATE LIMITED',
    'KEYARA FRESH PRIVATE LIMITED',
    'UPSILON CHEMICALS PRIVATE LIMITED',
    'MALLIKARJUN AROMATICS PRIVATE LIMITED',
    'UNITED-RKEMA POLYMERS PRIVATE LIMITED',
    'ACTION INTERNATIONAL PRIVATE LIMITED',
    'AB LATEX PRODUCTS PRIVATE LIMITED',
    'BHAANGAR BHUIN PRIVATE LIMITED',
    'LIOLI CERAMICA PRIVATE LIMITED',
    'AB GROUP OF INDUSTRIES PRIVATE LIMITED',
    'IMELT EXTRUSIONS PRIVATE LIMITED',
    'LIKES AND SHARES PRIVATE LIMITED',
    'BHAGAWATI ELITE MOTORS PRIVATE LIMITED',
    'ADLEX SERVICES PRIVATE LIMITED',
    'LUSH GREEN PRODUCTIONS PRIVATE LIMITED',
    'UNIQUE ACADEMY PUBLICATIONS PRIVATE LIMITED',
    'KSS PRODUCTIONS & ENTERTAINMENT PRIVATE LIMITED',
    'FABIO GREENS PRIVATE LIMITED',
    'TEKNOFINE FOODS PRIVATE LIMITED',
    'LISUS GLASS & METAL PRODUCTS PRIVATE LIMITED',
    'RAMESH SUNWIRE PRIVATE LIMITED',
    'OMKAR BODY FABRICATION AND AUTO CARE PRIVATE LIMITED',
    'NECORP SYSTEMS PRIVATE LIMITED',
    'MIRASH INDUSTRIES PRIVATE LIMITED',
    'BRU SPECIALITY CHEMICALS PRIVATE LIMITED',
    'FLEXITECH ENGINEERS PRIVATE LIMITED',
    'ECOAMI TECHNOLOGY INDIA PRIVATE LIMITED',
    'B&B MACHINES PRIVATE LIMITED',
    'VIVIAN CONVEYORS PRIVATE LIMITED',
    'BIOQUEST PHARMACEUTICALS PRIVATE LIMITED',
    'UPGRADE ENTERPRISES PRIVATE LIMITED',
    'SURAKSHITHA BIOFUELS PRIVATE LIMITED',
    'PETROCAL INNOVA PRIVATE LIMITED',
    'ASK PHARMA INDIA PRIVATE LIMITED',
    'SKILLS LIFE SCIENCES PRIVATE LIMITED',
    'TAYBERRY MERCHANDISE PRIVATE LIMITED',
    'WARP-N-WEFT DESIGNS PRIVATE LIMITED',
    'EILA LIFE SCIENCES PRIVATE LIMITED',
    'EON ELEVATORS PRIVATE LIMITED',
    'SANGUINE SOLUTIONS SYSTEMS INDIA PRIVATELIMITED',
    'VISHTECH ELECTRIC PRIVATE LIMITED',
    'SMDPOWER SOLUTIONS PRIVATE LIMITED',
    'CREAR ELECTRONICS PRIVATE LIMITED',
    'SURVAT PRIVATE LIMITED',
    'ROOP RAM INDUSTRIES PRIVATE LIMITED',
    'HAWK GRANITO PRIVATE LIMITED',
    'CENTURION PACKAGING PRIVATE LIMITED',
    'ALLTA INDIA PRIVATE LIMITED',
    'GREEN TECHCONNECT PRIVATE LIMITED',
    'GENERONS ENERGY PRIVATE LIMITED',
    'RONDS TECHNOLOGIES PRIVATE LIMITED',
    'GHAINTPUNJAB MEDIA PRIVATE LIMITED',
    'SCHONLUFT ENGINEERING PRIVATE LIMITED',
    'R. S. ISPAT (RAIGARH) PRIVATE LIMITED',
    'PROFFLEX MACHINES INDIA PRIVATE LIMITED',
    'JAGANNATH CRANEWAYS PRIVATE LIMITED',
    'INMET TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'VAATSHAR MANUFACTURING SYSTEMS PRIVATE LIMITED',
    'SABOO VEHICLES PRIVATE LIMITED',
    'TOYOTSU AMBIKA AUTOMOTIVE SAFETY COMPONENTS INDIA PRIVATE LIMITED',
    'RLV SYSTEMS PRIVATE LIMITED',
    'WAHI SONS AUTOMOTIVE PRIVATE LIMITED',
    'FLOWSEP TECHNOLOGIES PRIVATE LIMITED',
    'GALAXY TAJMAC MACHINERY PRIVATE LIMITED',
    'SENSONICS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TECHFILT PRIVATE LIMITED',
    'ABIGAIL ENTERPRISES PRIVATE LIMITED',
    'KOVAI ELITE FURNITURE PRIVATE LIMITED',
    'SONMIL ENGINEERING PRIVATE LIMITED',
    'CO2 AND H2S SOLUTIONS PRIVATE LIMITED',
    'GALASSI & ORTOLANI INDIA PRIVATE LIMITED',
    'VANILLA INDUSTRIES PRIVATE LIMITED',
    'STUTA HR CONSULTING PRIVATE LIMITED',
    'DEBABRATA-AURO FOUNDATION',
    'TECHCOGNIA (OPC) PRIVATE LIMITED',
    'CHECKAPP HEALTHCARE TECHNOLOGY PRIVATE LIMITED',
    'BOMBAY BEDDING PRIVATE LIMITED',
    'KYVOR OVERSEAS PRIVATE LIMITED',
    'GREY HANGERS PRIVATE LIMITED',
    'SADHANA ENERGY PRIVATE LIMITED',
    'IARISTA ARTHA PRIVATE LIMITED',
    'ECOLOIDS R&D CENTRE AND LABORATORY PRIVATE LIMITED',
    'SQUARE SEQUEL CONSULTING PRIVATE LIMITED',
    'OXYBEE SOLUTIONS PRIVATE LIMITED',
    'EXCESO INFOTECH PRIVATE LIMITED',
    'SADIPALI SOLAR PRIVATE LIMITED',
    'PROALPHA CAPITAL PRIVATE LIMITED',
    'JAPANESE ASSOCIATION IN MUMBAI',
    'ASSOCIATION OF INDIAN MARITIME EDUCATIONAND TRAINING INSTITUTES',
    'ESM ENTERPRISES (INDIA) PRIVATE LIMITED',
    'ASSOCIATION FOR NUTRITION AND DEVELOPMENT ACTION',
    'BAY TREE VENTURES PRIVATE LIMITED',
    'INWRITING ONLINE CONSULTANCY PRIVATE LIMITED',
    'BOLLYWORM DIGITAL MEDIA PRIVATE LIMITED',
    'MUSCLEMANIA INDIA PRIVATE LIMITED',
    'IQGEN-X PHARMA PRIVATE LIMITED',
    'ROBOMATE EDUTECH PRIVATE LIMITED',
    'KWAN (SOUTH) CELEBRITY SERVICES PRIVATE LIMITED',
    'BRIDGE FINTECH SOLUTIONS PRIVATE LIMITED',
    'REDCARPET ASSIST PRIVATE LIMITED',
    'NITHI VENTURES PRIVATE LIMITED',
    'ASIAN BHUBANESWAR HOSPITALS AND HEALTHCARE PRIVATE LIMITED',
    'AVINS INDUSTRIES PRIVATE LIMITED',
    'METRO TRIGONO PROPERTIES PRIVATE LIMITED',
    'XYLEM INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'SITARAM INFRAPROJECT PRIVATE LIMITED',
    'WITTY INFRATECH PRIVATE LIMITED',
    'IRS GLOBAL CORE INVESTMENT PRIVATE LIMITED',
    'COWORKING SERVICES PRIVATE LIMITED',
    'SEAQUBE INDIA PRIVATE LIMITED',
    'SEPIO PRODUCTS PRIVATE LIMITED',
    'SENSORS & SYSTEMS INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'TOUCHSTONE REGULATORY ADVISORS PRIVATE LIMITED',
    'KSR MOTORS PRIVATE LIMITED',
    'TG STUDIOS PRIVATE LIMITED',
    'CHAKAACHAK CLEAN INDIA PRIVATE LIMITED',
    'ALLOY SOCIAL DEVELOPMENT PRIVATE LIMITED',
    'BLAZING STAR PROPERTIES PRIVATE LIMITED',
    'VJP SPORTS ONE SERVICES PRIVATE LIMITED',
    'SHAPOORJI PALLONJI RENEWABLES PRIVATE LIMITED',
    '',
    'ATZI',
    'MINING AND TRADING PRIVATE LIMITED',
    'PROMARC FOODS PRIVATE LIMITED',
    'KRYSTAL FAMILY HOLDINGS PRIVATE LIMITED',
    'YAMA RIBBONS & BOWS INDIA PRIVATE LIMITED',
    'APTPROD DEVELOPMENT PRIVATE LIMITED',
    'SOLARON HOMES PRIVATE LIMITED',
    'TRANSFORM YOURSELF PRIVATE LIMITED',
    'SYNERGY PHARMA CONSULTANCY PRIVATE LIMITED',
    'NGAGE MEDIA SERVICES PRIVATE LIMITED',
    'SK OUTSOURCING PRIVATE LIMITED',
    'KAPHS GLASS AND METAL PRODUCTS PRIVATE LIMITED',
    'MAHARASHTRA INFORMATION TECHNOLOGY CORPORATION LIMITED',
    'AKA PAINTSYSTEMS PRIVATE LIMITED',
    'INFOBYD SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TOTAL LOGISTICS & TRANSPORT PRIVATE LIMITED',
    'IMMOVABLE PROPERTY & SAFETY AGENCY PRIVATE LIMITED',
    'EDELWEISS MAIDS ENTERPRISES PRIVATE LIMITED',
    'KVS RESOURCES PRIVATE LIMITED',
    'ADR CONCEPTS PRIVATE LIMITED',
    'NOT JUST CAKES PRIVATE LIMITED',
    'TRELL EXPERIENCES PRIVATE LIMITED',
    'CONVEX FINCAP SERVICES PRIVATE LIMITED',
    'RUHFUS INDIA PRIVATE LIMITED',
    'PJ VALVES MANUFACTURING PRIVATE LIMITED',
    'PADMA & VIJAYKANT KOTHARI WELFARE FOUNDATION',
    'CSTPL FOUNDATION',
    'VITRO HOSPITALITY AND REALTY PRIVATE LIMITED',
    'CHIRAYU FOREX PRIVATE LIMITED',
    'BLITZKRIEG REMEDIES PRIVATE LIMITED',
    'TECHNO DEFENCE PRIVATE LIMITED',
    'AMAZING VENTURES PRIVATE LIMITED',
    'EXPONENTIA LEARNING SOLUTIONS (OPC) PRIVATE LIMITED',
    'CORDELIA SERVICES PRIVATE LIMITED',
    'HOBBYGIRI ONLINE SERVICES PRIVATE LIMITED',
    'NASCI ECOLOGY LIMITED',
    'GRN RESEARCH PRIVATE LIMITED',
    'D-AMMO IMAGINEERING PRIVATE LIMITED',
    'SWACHHA MAINTENANCE SERVICE PRIVATE LIMITED',
    'SIPOTECH LIGHT PRIVATE LIMITED',
    'SARMON TECHNOLOGIES PRIVATE LIMITED',
    'DETOUR ODISHA PRIVATE LIMITED',
    'NARMADA BOTTLED WATER PRIVATE LIMITED',
    'ROCKNIK SOLUTIONS PRIVATE LIMITED',
    'PHONEPE CREDIT SERVICES PRIVATE LIMITED',
    'AUTHENTICA VENTURES PRIVATE LIMITED',
    'BRANDMITRA ADVERTISING PRIVATE LIMITED',
    'DRONAMAPS PRIVATE LIMITED',
    'ITS MY OPINION ENTERTAINMENT PRIVATE LIMITED',
    'KWICK NEEDS PRIVATE LIMITED',
    'TECHFRESH PRIVATE LIMITED',
    'IMBAM DIGITAL MARKETING AGENCY PRIVATE LIMITED',
    'STIER SOLUTION PRIVATE LIMITED',
    'SHAYAN ITALIA PRIVATE LIMITED',
    'CREATIVE TECHNOINFRA SOLUTIONS PRIVATE LIMITED',
    'ITK EDUCATION SERVICES PRIVATE LIMITED',
    'MADHAV SYNERGIES PRIVATE LIMITED',
    'BMP HOTELS PRIVATE LIMITED',
    'NEXT GENERATION FILLERS PRIVATE LIMITED',
    'ABHYANSH LOGISTICS PRIVATE LIMITED',
    'HR KNIGHTS CONSULTING (OPC) PRIVATE LIMITED',
    'DENARY MEDIA PRIVATE LIMITED',
    'IKNACK SOLUTIONS PRIVATE LIMITED',
    'HIRINGNINJA CONSULTING PRIVATE LIMITED',
    'NAVADEEPTHI PRIVATE LIMITED',
    'PRIMESTEEL MANUFACTURE PRIVATE LIMITED',
    'ROSAN PROPERTIES PRIVATE LIMITED',
    'KANANAM RETREAT PRIVATE LIMITED',
    'INFEEDO PRIVATE LIMITED',
    'TASS & HAMJIT PRIVATE LIMITED',
    'BERKOWITS HAIR AND SKIN CLINIC (INDIA) PRIVATE LIMITED',
    'AXIS MOBILITY PRIVATE LIMITED',
    'ANVIAM SOLUTIONS PRIVATE LIMITED',
    'SAMRUDDHI TBI FOUNDATION',
    'WATERMARK CARS PRIVATE LIMITED',
    'JALARAM HEALTHCARE PRIVATE LIMITED',
    'SREE MAYURA MOTORS PRIVATE LIMITED',
    'KINGSMAN SOLUTIONS NIDHI LIMITED',
    'MUKTA A2 CINEMAS LIMITED',
    'TEKZONE WEB SOLUTIONS PRIVATE LIMITED (OPC)',
    'EDF RENEWABLES INDIA FINANCING PRIVATE LIMITED',
    'TOKAI ELECTRONICS INDIA PRIVATE LIMITED',
    'Sks power generation (madhya pradesh) limited',
    'Sri jayajothi power management company private limited',
    'Dhursar solar power private limited',
    'Sks power generation (chhattisgarh) limited',
    'Engineered customised control panel solutions and systems private limited',
    'Unielectrogen energy private limited',
    'Gemini instratech limited',
    'Kvk bio-energy private limited',
    'Lisi aerospace india private limited',
    'Nimoto solar private limited',
    'KAFNU OTIS BALI PRIVATE LIMITED',
    'SKYFRI ENERGY PRIVATE LIMITED',
    'SKRE PROJECTS PRIVATE LIMITED',
    'Fujin wind parks private limited',
    'Perennial wind farms private limited',
    'Marthanda wind power ap private limited',
    'Khagah wind power private limited',
    'Magnus power private limited',
    'Kadam realty private limited',
    'Aqualine Real Estate Private Limited',
    'Krc infrastructure and projects private limited',
    'Kvk energy ventures private limited',
    'Vishv energy private limited',
    'Quality biz naturalspring (india) private limited',
    'Gujarat precision cast private limited',
    'Gift sez limited',
    'Maac infraspace private limited',
    'Ravani developers private limited',
    'Kaypee homes private limited',
    'TRIFECTA PROJECTS PRIVATE LIMITED',
    'Fortuna buildcon india private limited',
    'Mfar infrastructure projects private limited',
    'O r d realties and developers private limited',
    'Mangaldas n verma private limited',
    'Afcons infrastructure limited',
    'Adhunik developers pvt ltd',
    'Jaycee homes private limited',
    'Brent properties investment private limited',
    'Cheshire properties investment private limited',
    'Jay krishna developers private limited',
    'Astra homes private limited',
    'Chandani residency private limited',
    'Swastik residency private limited',
    'Priya residency private limited',
    'Sanjog residency private limited',
    'Kamdhenu residency private limited',
    'Midtown realtors private limited',
    'MINDSPACE BUSINESS PARKS PRIVATE LIMITED',
    'Green bell construction house private limited',
    'K. raheja corporate services private limited',
    'TRION PROPERTIES PRIVATE LIMITED',
    'Stargaze properties private limited',
    'NATWEST INDIA FOUNDATION',
    'ATUL PROJECTS INDIA Private Limited',
    'Novel properties private limited',
    'Geek it solutions private limited',
    'Orangepeople infosoft india private limited',
    'Dotcom weavers solutions private limited',
    'Ctrl s (india) private limited',
    'Goahead software india private limited',
    'Shivam medisoft services private limited',
    'APEIRO SOFTWARE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Rdp workstations private limited',
    'Fortunapix private limited',
    'Diginode software solutions private limited',
    'Centillionz it solutions private limited',
    'Hilton software technologies private limited',
    'Hireredson technologies private limited',
    'Appscape (india) private limited',
    'Vasista enterprise solutions private limited',
    'Techclove technologies private limited',
    'Appensure india private limited',
    'Loyal telesystems private limited',
    'Enixta innovations private limited',
    'UNISLINK PRIVATE LIMITED',
    'Pointel solutions india private limited',
    'Jilaba software services private limited',
    'Hetrogenous communication technologies private limited',
    'Beyondex solutions private limited',
    'Originwave techsoft private limited',
    'KANINI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'Ip softcom (india) private limited',
    'Iopex technologies private limited',
    'Alfanar engineering services india private limited',
    'ENTOMO GTDIC PRIVATE LIMITED',
    'Quantabay lead services private limited',
    'Greeva software solutions private limited',
    'Knila it solutions india private limited',
    'Vis legis consult private limited.',
    'PENA4 TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'American epay services private limited',
    'Sapple systems private limited',
    'Sanvei overseas private limited',
    'Excel design technologies private limited',
    'Adamya technocrats private limited',
    'Verity technologies private limited',
    'Digital harbor private limited',
    'Channelsoftech private limited',
    'Aabasoft technologies (india) private limited',
    'Palantir shakti technologies private limited',
    'Step computers private limited',
    'Beehive tech solutions private limited',
    'Unovation digital technologies private limited',
    'Citrio technology solutions private limited',
    'Famic technologies private limited',
    'U3 infotech india private limited',
    'Integra software services private limited',
    'Lone soft technologies private limited',
    'T & as designtech services private limited',
    'K7 computing private limited',
    'E-celtic consulting services private limited',
    'Obliqe systems private limited',
    'Excel square tech private limited',
    'Itriangle infotech private limited',
    'Campus it solutions private limited',
    'Span thoughtworks private limited',
    'Sriseshaa technologies private limited',
    'Cmb portalogic solutions private limited',
    'Pelican it solutions private limited',
    'Springhive labs private limited',
    'Kays harbor technologies private limited',
    'Albion infotel limited',
    'Asg software private limited',
    'Cyberadius technologies private limited',
    'Aurven technologies india private limited',
    'Masterline technologies private limited',
    'Innate labs private limited',
    'Zero designs private limited',
    'Accelere infosoft private limited',
    'Tagsecure solutions private limited',
    'TOPIA TECHNOLOGIES PRIVATE LIMITED',
    'Talent technology private limited',
    'Aurigo software technologies private limited',
    'Wortal technologies private limited',
    'Mobisy technologies private limited',
    'Valcom it services private limited',
    'Navriti technologies private limited',
    'Infocore engineering & it services private limited',
    'Icon infotech private limited',
    'Quartette infotech private limited',
    'Tejora technologies limited',
    'Vistex asia-pacific private limited',
    'Focus shares & securities private limited',
    'Paramonos technologies pvt. ltd..',
    'Cellmark india private limited',
    'Health impetus private limited',
    'GUEST TEK INDIA PRIVATE LIMITED',
    'Acit education private limited',
    'Trata solutions private limited',
    'Convergence it services private limited',
    'Heckyl technologies private limited',
    'Lycast technology private limited',
    'Salvi chemical industries limited',
    'Agarwal bulkactives private limited',
    'Magnum chemi-gran private limited',
    'Briyosis soft caps private limited',
    'Vintage labs private limited',
    'Afd laboratories private limited',
    'Afd pharma private limited',
    'Arham drugs and chemicals private limited',
    'Kinesis pharmaceuticals private limited',
    'Verdant life sciences private limited',
    'Anthem biosciences private limited',
    'S.v. labs private limited',
    'Sgpl pharma private limited',
    'Ishita active pharma ingredients private limited',
    'Pegasus lifesciences private limited',
    'Merind limited',
    'Ups hygienes private limited',
    'Aizant drug research solutions private limited',
    'Rudvin corporation india private limited',
    'Tainwala healthcare products private limited',
    'AROMATAN PRIVATE LIMITED',
    'R.k.ecocare private limited',
    'Mnm composites private limited',
    'Seapearls industries private limited',
    'Salnik polytech private limited',
    'BHARATH RUBBER (INDIA) LIMITED',
    'Lakshmiwan polymers private limited',
    'The plastics export promotion council',
    'Sun pro-pack private limited',
    'Reliable disposable glass containers private limited',
    'Sunflex packagers (india) private limited',
    'Sunpack barrier films private limited',
    'Divman seals private limited',
    'Moli pack industries pvt ltd',
    'Safepropack limited',
    'Shinmatic precision productt private limited',
    'Alliance polysacks private limited',
    'Prince containers private limited',
    'Laminate inputs private limited',
    'Hi tek plastics limited',
    'Aroma treasures private limited',
    'Xicon engineering services private limited',
    'Makarana ceramics private limited',
    'PREFERRED CEMENT PRIVATE LIMITED',
    'Ava stones private limited',
    'Rwc cement india private limited',
    'BEC STEELS PRIVATE LIMITED',
    'Amro metals private limited',
    'Ravnar alloys private limited',
    'Atlandes industries private limited',
    'Mathura strips private limited',
    'Timexbond industries private limited',
    'AGRAVANSHI STEELLS PRIVATE LIMITED',
    'Hindustan wiremesh private limited',
    'Agravanshi private limited',
    'Forms and surfaces india private limited',
    'Popuri steels limited',
    'Balkrishna steel forge private limited',
    'Radical plastics private limited',
    'Sharpwire industries (india) private limited',
    'Vms tmt private limited',
    'Mph precision castings private limited',
    'SVASRI ENTERPRISES PRIVATE LIMITED',
    'Tandon data system services pvt ltd',
    'Tiger steel engineering (india) private limited',
    'Barga india private limited',
    'Jayram industries (india) private limited',
    'Chennai radha engineering works private limited',
    'R k metal and plastic private limited',
    'Yash plastomet private limited',
    'Navkar fittings and forgings private limited',
    'Autocrat automotive stamping private limited',
    'SIDDHIVINAYAK TUFF GLASS (INDIA) PRIVATELIMITED',
    'Vijay machine tools private limited',
    'Ital beauty tools (india) private limited',
    'Steel dimensions india private limited',
    'Cam duct india private limited',
    'Kinelectro lines india private limited',
    'Mts engineers private limited',
    'Globestar engineers (india) private limited',
    'Chartered auto components private limited',
    'Selvel machines private limited',
    'Mecs india private limited',
    'Premier pumps pvt ltd',
    'Cubic transmissions private limited',
    'Unique forgings (india) private limited',
    'Indus refrigeration private limited',
    'Techlink international process engineers private limited',
    'Fine filters private limited',
    'Galaxy chains private limited',
    'Gleason works (india) private limited',
    'Kamgar engineering works india private limited',
    'Satrac engineering private limited',
    'Grupo cosmos india private limited',
    'Pravesha industries private limited',
    'Kalson alcast private limited',
    'Western securities limited',
    'Akshaya holdings private limited',
    'Hincon finance ltd.',
    'Indsec securities and finance ltd',
    'HALIFAX PROPERTIES PRIVATE LIMITED',
    'Stone masters (india) private limited',
    'Darashaw securities private limited',
    'Darashaw capital private limited',
    'Jhp securities private limited',
    'Unique stockbro private limited',
    'Samurai securities private limited',
    'Deutsche india holdings private limited',
    'Aegis management & financial consulting india private limited',
    'Rupeetalk financial services private limited',
    'Hadoti punji vikas limited',
    'Highpowerv share trading and financial solutions private limited',
    'Fortune capital services private limited',
    'Seemran viniyog private limited',
    'RENASCENT BIZWISE INDIA PRIVATE LIMITED',
    'Mercury corporate services private limited',
    'Cheraman funds management limited',
    'Avtaran capital advisors private limited',
    'Tpg capital india private limited',
    'India sme asset reconstruction company limited',
    'Money honey consultants private limited',
    'K SERA SERA CINELINES & MINIPLEX PRIVATE LIMITED',
    'Deccan insurance & reinsurance brokers private limited',
    'Winfra green projects private limited',
    'Freo rentals and leasing private limited',
    'Macro soft technology private limited',
    'Mid-city bhoomi developers private limited',
    'Gurukrupa constructions private limited',
    'Esquire real estate and bio-infocom private limited',
    'Sahana properties and resorts private limited',
    'Nirmal lifestyle holding private limited',
    'Appropriate properties private limited',
    'Terrapolis buildcon private limited',
    'Maheshwari infratech private limited',
    'Choudhary international private limited',
    'Jasra graphics private limited',
    'Lifetime emerging markets private limited',
    'Srl jodhpur buildcon private limited',
    'Voora property developers private limited',
    'People estates private limited',
    'Anand citi centre holdings private limited',
    'Bose infrastructure limited',
    'Pragnya riverbridge developers limted',
    'UBA ESTATES & COMMERCE PRIVATE LIMITED',
    'Brahmaputra business park private limited',
    'Xchanging builders (india) private limited',
    'Cansa properties private limited',
    'Nutan builders private limited',
    'Atmosphere realty private limited',
    'KBJ DEVELOPERS PRIVATE LIMITED',
    'Samira lifestyles private limited',
    'Imperial land projects private limited',
    'Un reality private limited',
    'V.r.a. reality private limited',
    'Geld realtors private limited',
    'Asset india real estate private limited',
    'Eon-hinjewadi infrastructure private limited',
    'S k a realtors private limited',
    'Space vision edifice private limited',
    'JBT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Radiant structures private limited',
    'Manali realcon private limited',
    'Rukalpra realty private limited',
    'Green money infra & project consultants private limited',
    'Skj properties pvt ltd',
    'Rajat infrabuild private limited',
    'Rajat projects private limited',
    'Opg developers private limited',
    'Lets plan infrastructure private limited',
    'Asteroid shelters homes private limited',
    'BABASU REALTY PRIVATE LIMITED',
    'Risible real estate private limited',
    'B.k. consortium engineers private limited',
    'Hashcube technologies private limited',
    'Team one technologies private limited',
    'Lanware consulting private limited',
    'THALES DIS MCS INDIA PRIVATE LIMITED',
    'Gapvak technologies private limited',
    'Sevenhills e-health private limited',
    'Pometek system solutions private limited',
    'KOENIG SOLUTIONS PRIVATE LIMITED',
    'Genee solutions india private limited',
    'STRATACACHE INDIA PRIVATE LIMITED',
    'Msd telematics private limited',
    'Pratham trade link private limited',
    'Almighty software private limited',
    'Vora tech-venture private limited',
    'Space stem private limited',
    'Shifa infotech private limited',
    'MICRO FOCUS SOFTWARE INDIA PRIVATE LIMITED',
    'Neural networks private limited',
    'Northstar calcite private limited',
    'Shri bohra ganeshji tradelink private limited',
    'Neelikon food dyes and chemicals limited',
    'MONTE PACK PRIVATE LIMITED',
    'Comprehensive foods solutions private limited',
    'PEDIGREE TECHNOLOGIES PRIVATE LIMITED',
    'Euro grapes private limited',
    'BAIJAY INTERNATIONAL PRIVATE LIMITED',
    'Sri vet products pvt. ltd.',
    'Kjs india private limited',
    'ASIAN HEALTH AND NUTRI FOODS PRIVATE LIMITED',
    'Sathyam roller flour mills private limited',
    'Maxrotth foods limited',
    'Urmin foods private limited',
    'Iscon balaji foods private limited',
    'ZAUBA TECHNOLOGIES PRIVATE LIMITED',
    'British life sciences private limited',
    'Blueberry agro products private limited',
    'Gourmet fresh india private limited',
    'Shakun consumer products private limited',
    'Manek foods private limited',
    'Premia food additives (i) private limited',
    'VIJAY MAMRA PRIVATE LIMITED',
    'Eurostar beverages private limited',
    'J v yarn mills india private limited',
    'Arunaagold tex corporate private limited',
    'Macro polymers pvt ltd',
    'Pezalli creations private limited',
    'SUJE TEX PRIVATE LIMITED',
    'Protective textiles private limited',
    'Sharada designs private limited',
    'Intime knits pvt ltd',
    'Kism textile private limited',
    'Y2k fashions private limited',
    'Scotts knits private limited',
    'Maritime association of shipowners shipmanagers and agents',
    'Paradigm logistics & distribution private limited',
    'Mad (india) private limited',
    'Quality biz chem india private limited',
    'Samskara wellness products private limited',
    'Vfs india services private limited',
    'Arc and fusion (india) private limited',
    'Mud n water production private limited',
    'Brio energy private limited',
    'Eco rich cosmetic india private limited',
    'Indian media biz private limited',
    'ARCI DATA SERVICES PRIVATE LIMITED',
    'Indo engineering project corporate (india) private limited',
    'CARGO SERVICE CENTER SKILL & TRAINING ACADEMY PRIVATE LIMITED',
    'Adyna solutions private limited',
    'Blok design studio private limited',
    'Movietone digital entertainment private limited',
    'SOL COM & TRADE PRIVATE LIMITED',
    'Myaashiana management services private limited',
    'Margy tech private limited',
    'Jugaad advertising private limited',
    'Rioth healthcare private limited',
    'Cal-tech calibration services private limited',
    'Zf india private limited',
    'LIGHTHOUSE COMMUNITIES FOUNDATION',
    'Ingemetal solar india private limited',
    'Ariatech mobility solutions private limited',
    'Intesome solutions private limited',
    'United fire stopping solutions private limited',
    'Anmol systems housekeeping and allied services private limited',
    'RAMAKANTH BRAND & MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'Nski management consultancy private limited',
    'Saiplus sales and services private limited',
    'Purple infotech limited',
    'Naturefresh cold storage private limited',
    'Novature tech private limited',
    'Write2speak learning ventures private limited',
    'Bytes brothers technology private limited',
    'Takeme2theworld tours private limited',
    'Skp risk advisors private limited',
    'Jaso india private limited',
    'Asva power systems india private limited',
    'Pisa international private limited',
    'Vfs global services private limited',
    'Jalaram bappa spring field international foundation',
    'Little indigo kids academy private limited',
    'Knowledge horizon e-learning pvt ltd',
    'Yehchina education private limited',
    'International knowledge park private limited',
    'Transforming higher education gate academy private limited',
    'Dyota solutions private limited',
    'Sme business management institute',
    'Univision softech private limited',
    'Mindplus edutech academy private limited',
    'Boolean information systems private limited',
    'C s g educational institute',
    'IIT-IAN',
    'S HEALTHCARE INDIA PRIVATE LIMITED',
    'Agraja properties limited',
    'Team 10 march architects & graphic designers private limited',
    'Eastern gateway terminals private limited',
    'Neelkanth somnath realtors private limited',
    'Neelkanth vinayak realtors private limited',
    'Skyline realty private limited',
    'ASTRAPIA REMEDIES PRIVATE LIMITED',
    'RRAS TRADERS AND EXPORTS PRIVATE LIMITED',
    'KAITHAL TOLLWAY LIMITED',
    'KSHEER SAGAR DEVELOPERS PVT LTD',
    'Raj kamal buildcon pvt ltd',
    'J.h.builders pvt ltd',
    'Ksheer sagar buildcon private limited',
    'Adaequare projects private limited',
    'Hill country hotels and resorts india limited',
    'Saraswati promoters private limited',
    'Sidharth foundations and housing limited',
    'Radiance realty developers india limited',
    'Mahalakshmi towers private limited',
    'Shriram properties (coimbatore) private limited',
    'Kapis credit capital pvt.ltd.',
    'Bengal ambuja metro development limited',
    'Spl constructors private limited',
    'Moham projects private limited',
    'Darshita constructions private limited',
    'Jangid builders pvt ltd',
    'Shrikant real estates pvt ltd',
    'BRIJEEL FOODS & BEVERAGES PRIVATE LIMITED',
    'Analee buildcon private limited',
    'Asiastar city holdings private limited',
    'Ns patil developers private limited',
    'Jnd edu-realty private limited',
    'Imc infrastructure private limited',
    'Isha homes (india) private limited',
    'Agnimitra developers private limited',
    'Bengal shriram hitech city private limited',
    'Skylark arcadia private limited',
    'Nagpur highway infracons private limited',
    'Irb kolhapur integrated road development company private limited',
    'Sh developers private limited',
    'Mba heights and properties private limited',
    'Blue nile housing projects private limited',
    'Refcem refractories private limited',
    'Creaters infrastructure (s.g.) private limited',
    'Ivrcl patiala bathinda tollways limited',
    'Star infra design private limited',
    'A2z buildwell private limited',
    'Vasava engineers (india) private limited',
    'Hsr homes private limited',
    'Darshita lifestyle dwellings private limited',
    'Darshita build-tech private limited',
    'Green shapes developers (india) private limited',
    'Ithaca estates private limited',
    'Cadabam developers private limited',
    'Golden bric build estate private limited',
    'SUNOVATECH INDIA PRIVATE LIMITED',
    'Navkar lifespaces private limited',
    'Ebony developers private limited',
    'Am ajanthaa construction private limited',
    'Intellect heights private limited',
    'Forest bliss developers private limited',
    'Pawan edifice private limited',
    'Does projects private limited',
    'V square infrabuild private limited',
    'Pawanputra realty ventures private limited',
    'LEXICON INFRACON PRIVATE LIMITED',
    'Umang corporate park private limited',
    'Jvr croissance infrastructure co. private limited',
    'Marvel infraavenues india limited',
    'BRIDGE CONSTRUCTIONS PRIVATE LIMITED',
    'Jvr ventures private limited',
    'Samanyu infra projects private limited',
    'Vv-indbarath infrastructure limited',
    'Rock of adams private limited',
    'Kaizen power limited',
    'L7 infrastructure private limited',
    'Arkay glenrock private limited',
    'Vga developers private limited',
    'Canbuild precast solutions (india) private limited',
    'Shipra infratech private limited',
    'Sohay infra private limited',
    'Construction skill development council of india',
    'Kcc roads construction private limited',
    'Navstar peb and profile private limited',
    'ABELLON EPC & TECHNOLOGIES LIMITED',
    'Oceanus estates india private limited',
    'Darshita housing private limited',
    'Darshita properties private limited',
    'Darshita real estate private limited',
    'Neelanchal infratech private limited',
    'Sattva buildcon private limited',
    'Manani projects private limited',
    'Paville projects private limited',
    'Sms tolls and developers limited',
    'Damask projects private limited',
    'Altair infrastructure private limited',
    'Rika developers private limited',
    'Sunshine technobuild private limited',
    'GREEN INDIA BUILDING SYSTEMS & SERVICES PRIVATE LIMITED',
    'Remarkable abasan private limited',
    'Fabulous nirman private limited',
    'Skyspace infrastructure private limited',
    'Siddhibhumi housing private limited',
    'Richtouch realestate private limited',
    'Dazzling enclave private limited',
    'Rajat blisscity infrastructure private limited',
    'Bbc global news india private limited',
    'N c g real estate private limited',
    'N a developers private limited',
    'S c g real estate private limited',
    'Guptasons infra private limited',
    'Hanoch integrated facility & property services private limited',
    'Vision india infrastructure private limited',
    'Green hut pvt ltd',
    'Contemporary equipment and enterprises pvt ltd',
    'Metropolitan projects private limited',
    'Innovation infraestates private limited',
    'Srijan complex private limited',
    'Rosette properties private limited',
    'Shivrashi abasan private limited',
    'Subhlife real estate private limited',
    'Swarnachura properties private limited',
    'Ultrafocus properties private limited',
    'Sapnasuraha nirman private limited',
    'Subhkamana developers private limited',
    'Sukalyan properties private limited',
    'Fishman realty management services india private limited',
    'Ksp enterprises private limited',
    'Moon arc private limited',
    'Amona infrastructure private limited',
    'Gecorp realty private limited',
    'Value design and engineering associates private limited',
    'Sri sumeru housing private limited',
    'Lily pond properties private limited',
    'Hebbal project private limited',
    'Suresh sova property private limited',
    'Viewmore infrahomes private limited',
    'Antaeus rent-a-car private limited',
    'Encon impex private limited',
    'Leonardo automation (india) private limited',
    'SMR INNOVATIONS PRIVATE LIMITED',
    'BARRIERBREAK SOLUTIONS PRIVATE LIMITED',
    'Shubha systems and communications private limited',
    'Psitech consultancy services private limited',
    'Tech visions it services private limited',
    'Shebz dot com private limited',
    'Vega intelli soft private limited',
    'Sysbeats technologies private limited',
    'Compindia infotech private limited',
    'Vrinda technologies private limited',
    'Primesoft enterprise system integrators private limited',
    'Humanitics dimensions software private limited',
    'Quixot multimedia private limited',
    'ICCG INDIA PRIVATE LIMITED',
    'Aryan e-soft private limited',
    'Pinna infotech private limited',
    'Ecom dotcom (india) private limited',
    'Betanet consultancy private limited',
    'Webconnect pvt ltd',
    'Amba infotech private limited',
    'Spatial ideas web solutions private limited',
    'Radix software services private limited',
    'Innovify business intelligence services private limited',
    'CORETUS TECHNOLOGIES PRIVATE LIMITED',
    'Informatica business solutions private limited',
    'Tiarion software private limited',
    'Planetsurf creations private limited',
    'Gm software private limited',
    'Otbt infotech private limited',
    'Turmeric cloud technologies private limited',
    'B e solutions private limited',
    'Xiphias software technologies private limited',
    'Innova technology solutions mysore private limited',
    'Knowx innovations private limited',
    'Twin info solutions private limited',
    '1fb support services private limited',
    'Atimi software (india) private limited',
    'Infragistics india private limited',
    'Formulateip technolegal solutions private limited.',
    'Orva networks private limited',
    'Iposa consulting private limited',
    'Efileready india private limited',
    'Inz axis tech services private limited',
    'Ceptes software private limited',
    'FINNASTRA PRIVATE LIMITED',
    'Tacitine consulting private limited',
    'Lekha wireless solutions private limited',
    'Nt holdings private limited',
    'Credise technologies private limited',
    'Unbxd software private limited',
    'I4 global information technologies limited',
    'Morph digital solutions private limited',
    'Collaboration labs private limited',
    'Triveous technologies private limited',
    'Kenai technologies private limited',
    'SERVERSUPPLY PRIVATE LIMITED',
    'TELIA CYGATE INDIA PRIVATE LIMITED',
    'Opsveda asia private limited',
    'Hardik dealmark private limited',
    'Andwill softwares private limited',
    'Merlin green maintenance services private limited',
    'SWISS LAUNDRY PRIVATE LIMITED',
    'Teleminds infotech private limited',
    'Karnataka rural infrastructure development limited',
    'HER SHAKTI WOMEN EMPOWERMENT FOUNDATION',
    'Blue surmount education',
    'Kerala academy for skills excellence',
    'Shikhar foundation',
    'Yash accounting and e-services private limited',
    'Auctus knowledge house private limited',
    'Redbricks junior education limited',
    'Xcellon education limited',
    'Redbricks education foundation',
    'Institute of foreign language and culture private limited',
    'Chrysalis educare private limited',
    'Grad-dreams education consulting private limited',
    'CHITALE',
    'S EDUCATIONAL ACADEMY PRIVATE LIMITED',
    'INSPIRISYS SOLUTIONS IT RESOURCES LIMITED',
    'Aztec infrastructure private limited',
    'Bsl training company private limited',
    'Network fp knowledge solutions private limited',
    'Indian institute of politics private limited',
    'Cloudex health care private limited',
    'Sinura health information process solutions private limited',
    'Jupiter life line hospitals limited',
    'Spa comert private limited',
    'Hipra india private limited',
    'Jagshree ayurveda wellness private limited',
    'SEARCHLIGHT HEALTH PRIVATE LIMITED',
    'Matrix healthcare private limited.',
    'Akanksha stemcell private limited',
    'Eye care hospital private limited',
    'Ess enn auto cnc private limited',
    'Dfcl india limited',
    'Synectic telecom private limited',
    'Indiana polymers private limited',
    'Jamal bevel gears and transmissions private limited',
    'Ittina properties private limited',
    'Amboseli professional associates private limited',
    'Bangalore agrotech limited',
    'Arion technology limited',
    'Ace multi axes systems limited',
    'KROPEX AUTO PRIVATE LIMITED',
    'Premium constructions private limited',
    'Essilor manufacturing india private limited',
    'Caddons computer services private limited',
    'Omnesys tradenet private limited',
    'Nethradhama hospitals private limited',
    'DARSHITA INFOSOFT PRIVATE LIMITED',
    'Specialist health systems private limited',
    'Bandra diagnostic centre private limited',
    'SHREE KKASTURI MEDICARE PRIVATE LIMITED',
    'DR.MEHTA',
    'S GLOBAL IMPEX PRIVATE LIMITED',
    'Sukra distributors india private limited',
    'Monads furniture systems private limited',
    'Ellisbridge trading private limited',
    'App street software private limited',
    'V b fabric exports private limited',
    'Protek trade private limited',
    'Ratchet pharma private limited',
    'Sai silks (kalamandir) limited',
    'Canberra traders pvt ltd',
    'Doshi mediventures private limited',
    'Vintex safety solutions limited',
    'Marine pearl impex private limited',
    'Abil retail private limited',
    'Heaven distributors private limited',
    'Life line medisol private limited',
    'Medispray laboratories private limited',
    'Dye-chem overseas private limited',
    'Konark vincom private limited',
    'Swapanpuri tradelink private limited',
    'Highgrowth dealers private limited',
    'Natraj deltrade private limited',
    'Golden tracom private limited',
    'Highview vinimay private limited',
    'Desinos spacio interiors private limited',
    'Infocast systems private limited',
    'Adams distributions private limited',
    'Ecosens lighting private limited',
    'Sanvys india private limited',
    'Nand kishore enterprises private limited',
    'Surya agency private limited',
    'Injar (india) pvt. ltd.',
    'Mishanti engineers ltd',
    'Precision impex private limited',
    'Raptakos brett and company limited',
    '7NR RETAIL LIMITED',
    'Bharat aluminium co ltd',
    'Omega bright steel private limited',
    'Sherman international pvt ltd',
    'Advance ventilation pvt ltd',
    'Paras paper products private limited',
    'Haldiram marketing pvt ltd',
    'Ess u enterprises private limited',
    'Krim engineering services private ltd.',
    'Parijat crop protection (india) private limited',
    'Choice hospitality (india) private limited',
    'Vatika farms private limited',
    'Ria insurance brokers private limited',
    'Para lube (india) private limited',
    'A.G. ADVANCE CHEMICALS PRIVATE LIMITED',
    'M b tubes pvt ltd',
    'Simco services private limited',
    'JAMBUDVIPA HEARTCRAFT PRIVATE LIMITED',
    'Mars packaging private limited',
    'Sarlasons impex india private limited',
    'New concept information systems private limited',
    'Elite business machines private limited',
    'J ahuja fabrics private limited',
    'R k global finance private limited',
    'Shree nath shares private limited',
    'Indo canadian consultancy services limited',
    'PODDAR GLOBAL Private Limited',
    'Bhilwara green energy limited',
    'AGILUS DIAGNOSTICS LIMITED',
    'J.m.d. projects limited',
    'Pytex impex private limited',
    'Appu ghar entertainment private limited',
    'Dove impex (india) private limited',
    'Provestment securities pvt. ltd.',
    'G & g fincap private limited',
    'Navodaya properties private limited',
    'Nitika florabase private limited',
    'Bhadohi hotels limited',
    'Capital cars private limited',
    'Airworth travel and tours private limited',
    'NMTRONICS (INDIA) PRIVATE LIMITED',
    'Millennium instruments limited',
    'Force tech security (india) private limited',
    'Kox med and lab private limited',
    'Ansal buildwell real estate promoters pvt ltd',
    'Mikado realtors private limited',
    'Hunter douglas india pvt ltd',
    'Euro-a zipper india private limited',
    'Equalitas certifications limited',
    'Pryd consultants private limited',
    'Adglobal360 india private limited',
    'Nautanki films private limited',
    'Getarty communication private limited',
    'Ast telecom solar private limited',
    'Redi technologies private limited',
    'Select india holidays private limited',
    'ARTH MUSICAL PRIVATE LIMITED',
    'Meltronics business strategies private limited',
    'Rezonant design services private limited',
    'Automation specialists india private limited',
    'Vidal healthcare services private limited',
    'Pentawis innovations private limited',
    'Dealsnow consumer solutions private limited',
    'Magenta blues designs private limited',
    'Newarch design consultants private limited',
    'Gondavana services private limited',
    'Gamechanger business services (i) private limited',
    'Sedum soft private limited',
    'Advaya humanistic systems private limited',
    'Mydime systems private limited',
    'Zivatara impex private limited',
    'Ds hytech india private limited',
    'Kalyani automation private limited',
    'Archivos administracion private limited',
    'Cogbooks india private limited',
    'Vinyas consulting india private limited',
    'Dhriti corporate services private limited',
    'Sudhir shivaram photography private limited',
    'Woas technology private limited',
    'M-star satellite communications private limited',
    'A d plast private limited',
    'Sumaaya digital private limited',
    'Vhb life sciences limited',
    'Smit india marine services private limited',
    'Ibaazar retailers private limited',
    'Latent tech private limited',
    'Powermech services private limited',
    'PGIM INDIA ASSET MANAGEMENT PRIVATE LIMITED',
    'Elegant marine services private limited',
    'Beyond logistics private limited',
    'B2b brand solutions private limited',
    'Strong bridge enterprises private limited',
    'Rkb bearings private limited',
    'Asjs services private limited',
    'Threestar solutions and services private limited',
    'FINCLUSION DIGITAL PRIVATE LIMITED',
    'Nano job consultants private limited',
    'Vizag agriport private limited',
    'Red wall mediaworks private limited',
    'Sabre partners investment managers private limited',
    'SARA SERVICES & CONSULTANTS PRIVATE LIMITED',
    'Sspa consultants private limited',
    'J rajkumar textile private limited',
    'ADENIUM VENTURES PRIVATE LIMITED',
    'Sri lakshmi narasimha spinning mills(inda) private limited',
    'Shubh yarn private limited',
    'Atlas textiles export private limited',
    'SUNRAYS TEXTILES PROCESS PRIVATE LIMITED',
    'Demeter agri services private limited',
    'Salzer spinners limited',
    'Super sara textiles limited',
    'Anugraha fashion mill private limited',
    'M.r.c mills private limited',
    'Valeth hightech composites private limited',
    'Tex india enterprises private limited',
    'Atam apparels private limited',
    'Texport garments private limited',
    'Jagdamba sarees private limited',
    'Harmony silks private limited',
    'Sangeet syntex limited',
    'Bhagirath fibre pvt ltd',
    'Suryakiran polyfab pvt ltd',
    'Lyallpur uniforms private limited',
    'Raghukaushal textile private limited',
    'Balaji polycot private limited',
    'KHAA ORGANIC PRIVATE LIMITED',
    'Natural tex yarn private limited',
    'Kishinchand chellaram (india) private limited',
    'Vazir polymers private limited',
    'VIDHANI MANUFACTURER',
    'S RESOURCE TEXTILE PRIVATE LIMITED',
    'Closet clothing private limited',
    'Dicitex home furnishings private limited',
    'Toshniwal impex private limited',
    'Sree snehavalli textiles private limited',
    'Winter trends (india) limited',
    'CAPTAN CLOTHING PRIVATE LIMITED',
    'Spadeworks sourcing private limited',
    'S.p.apparels limited',
    'Goldenbell creations private limited',
    'Lf and d fashions private limited',
    'Dida brothers company private limited',
    'Peregrine clothing private limited',
    'Samurai exports private limited',
    'Eastern chrome tanning corporation private limited',
    'Satyam creations private limited',
    'Arcot soles private limited',
    'INNOVATIVE LEATHER CREATIONS PRIVATE LIMITED',
    'M. p. leathers private limited',
    'Al shokur (india) pvt ltd',
    'J k footwear private limited',
    'Soles fashions private limited',
    'Neo rubber footcrafts private limited',
    'Aadil - cunial components india private limited',
    'Royal touch fablon private limited',
    'Sunlight timber industries private limited',
    'International furniture brands private limited',
    'YELLOW PLY INDUSTRIES PRIVATE LIMITED',
    'Srl wood products private limited',
    'Vidyarthi enterprises private limited',
    'Mascot international private limited',
    'Impact metals ltd',
    'Ckdpack packaging private limited',
    'Parksons graphics private limited',
    'Panorama papers private limited',
    'Dewaki machineries manufacturing private limited',
    'Arjun health and hygiene private limited',
    'Amar cards private limited',
    'Mkm publishers private limited',
    'Beaute espace publications private limited',
    'Sheth publishers pvt ltd',
    'ORANGE HOUSE PRIVATE LIMITED',
    'Dhanam publications private limited',
    'D c press private limited',
    'Janahitha publicities private limited',
    'Research trends private limited',
    'Team-bhp community private limited.',
    'Bpi (india) private limited',
    'Mukta publishing house private limited',
    'Efficient buildcon private limited',
    'Unickon real estates private limited',
    'Salvia promoters private limited',
    'JHS SVENDGAARD RETAIL VENTURES PRIVATE LIMITED',
    'Shri giriraj buildestate private limited',
    'Sunsara infra private limited',
    'India polyroads private limited',
    'Welcome infrabuild private limited',
    'Rein constructions private limited',
    'Divyam developers private limited',
    'Ambition colonisers private limited',
    'Bhadra landmarks private limited',
    'Baya consultancy services private limited',
    'EKT DESIGN INFRA PRIVATE LIMITED',
    'Autumn leaves developers private limited',
    'M m builders private limited',
    'Lavina estates pvt ltd',
    'New look developers private limited',
    'Accord builders private limited',
    'KOCHRA DEVELOPERS PRIVATE LIMITED',
    'Padmapriya developers pvt ltd',
    'Link view building and tenements pvt ltd',
    'MONARCH REALTY & DEVELOPERS PRIVATE LIMITED',
    'Manthan estates private limited',
    'Samraj housing private limited',
    'Denver properties private limited',
    'Amal realtors private limited',
    'Unicorn contractors and developers private limited',
    'Sai shiva property developers private limited',
    'C m gandhi construction private limited',
    'Paas constructions private limited',
    'Shehla properties and trading private limited',
    'Yogayatan constructions private limited',
    'Bhavanika buildcon private limited',
    'Sanskar residency private limited',
    'Kwera lands private limited',
    'Aaryan structcon private limited',
    'Axis housing private limited',
    'Pearl mount propbuild private limited',
    'Springgrove projects private limited',
    'Ashtavinayak landmarks private limited',
    'Dhotre constructions infrastructure private limited',
    'Shanta sriram housing private limited',
    'MAX INFRA (I) PRIVATE LIMITED',
    'Gokuldeep estates private limited',
    'Gomedha estates private limited',
    'Gokulranga estates private limited',
    'Shantarang estates private limited',
    'Time projects private limited',
    'Sr peddi estates (india) private limited',
    'LIAFON SOFTWARE PRIVATE LIMITED',
    'Srr projects private limited',
    'Navtej infrastructure private limited',
    'Sree chakra realcon private limited',
    'Gvk bagodara vasad expressway private limited',
    'Aaram constructions private limited',
    'Arogya constructions private limited',
    'New era land developers private limited',
    'Kochar homes private limited',
    'Sri visthara infrastructures private limited',
    'Mmrf realty and infrastructure private limited',
    'Rrp ventures private limited',
    'Srd promoters private limited',
    'Muskan residency private limited',
    'Trinity developers private limited',
    'Century nirman private limited',
    'Libra estates private limited',
    'Pavani buildwell private limited',
    'Naman pharma private limited',
    'Namrata builders pvt ltd',
    'Balark metals private limited',
    'Bonivil builders pvt ltd',
    'CAMEX SPECIALITY PRIVATE LIMITED',
    'NORMA DEVELOPERS PRIVATE LIMITED',
    'JRA INFRASTRUCTURE LIMITED',
    'Pacifica hotels (gurgaon project) private limited',
    'Pacifica (sola project) developers private limited',
    'Pacifica hotels (baroda project) private limited',
    'Mahalaxmi infratrade private limited',
    'Hardik buildtech private limited',
    'Udhyaman investments private limited',
    'L E VATE PROCON REALTY PRIVATE LIMITED',
    'Suruchi properties private limited',
    'Millfields developers private limited',
    'YELLOW SERVICES PRIVATE LIMITED',
    'Daisy constructions private limited',
    'Total environment habitat private limited',
    'Total environment living spaces private limited',
    'Calicut developers private limited',
    'INDROYAL PROPERTIES PRIVATE LIMITED',
    'Qrs builders limited',
    'Rite developers private limited',
    'Tia construction company private limited',
    'Om shree sai labh constructions private limited',
    'Jmm infra projects private limited',
    'Vijayeta builders p. ltd.',
    'Dangayach colonizers private limited',
    'Stylish buildhome private limited',
    'Newtech buildhome private limited',
    'Vijayeta buildhome private limited',
    'Kanak dham builders private limited',
    'NM FINANCIERS PRIVATE LIMITED',
    'NAVKAM MARKETING & FINANCE PVT LTD',
    'Bonanza insurance broker private limited',
    'Nyce securities & derivatives limited',
    'Flexi forex private limited',
    'Vikram shares & stock broking private limited',
    'Iragecapital advisory private limited',
    'Maanaveeya development & finance private limited',
    'Shroff financial services pvt ltd',
    'Kirtivardhan finvest services limited',
    'Damika insurance broking company private limited',
    'Relleno insurance broking services private limited.',
    'Sthithi insurance services private limited',
    'Chandarana intermediaries brokers private limited',
    'Tradejini financial services private limited',
    'Tradejini commodity private limited',
    'Arjay sons holdings limited',
    'WADHAWAN GLOBAL CAPITAL LIMITED',
    'Pitti holdings private limited',
    'Aarohan holdings and advisors private limited',
    'Grover leasing limited',
    'Dwarkadhish finance and investment company private limited',
    'Parnami com trade private limited',
    'ACML CAPITAL MARKETS LIMITED',
    'Max bullions and commodities private limited',
    'PRAMESH WEALTH PRIVATE LIMITED',
    'NARNOLIA INVESTMENT ADVISORS PRIVATE LIMITED',
    'Composite investments private limited',
    'Aaa solutions private limited',
    'Niku investments and leasing pvt ltd',
    'Shah stone machines private limited',
    'Avanse financial services limited',
    'Fragrance investments private limited',
    'Mata securities india private limited',
    'Keynote fincorp limited',
    'Kedia shares and stocks brokers limited',
    'Basera securities services private limited',
    'Kesaria securities services private limited',
    'NIPRA TRADING PRIVATE LIMITED',
    'Thirani investment private limited',
    'Nirmal lifestyle realty private limited',
    'Anugrah stock and broking private limited',
    'Angel fincap private limited',
    'Sanjay anil fabrics private limited',
    'Arj securities private limited',
    'Jrm share and stock brokers private limited',
    'Uranus holdings private limited',
    'Gold armour risk management services private limited',
    'Phoenix share and stockbrokers private limited',
    'Techno global security private limited',
    'Libord advisors private limited',
    'Boras investment and trading company private limited',
    'Mittal capitals (india) private limited',
    'First futures and stocks private limited',
    'Finlinkers solutions private limited',
    'Mehta tradelink private limited',
    'Angel forex private limited',
    'Smp consulting india private limited',
    'Fundjini india private limited',
    'MONEYBASE FINSERV INDIA PRIVATE LIMITED',
    'VISAN HOLDINGS PRIVATE LIMITED',
    'Embryo financial services private limited',
    'Optima securities india private limited',
    'Pamac finserve private limited',
    'Pushkala development and finance private limited',
    'Association of indian investors',
    'Bellwether capital private limited',
    'First global securities private limited',
    'Tribune corporate and investment advisory services private limited',
    'BANK OF INDIA TRUSTEE SERVICES PRIVATE LIMITED',
    'JM FINANCIAL ASSET RECONSTRUCTION COMPANY LIMITED',
    'Aastha wealth creators private limited',
    'MATA WEALTH PRIVATE LIMITED',
    'Fairbridge capital private limited',
    'Moneyplex commodities private limited',
    'Shriram dth private limited',
    'ANNAMMAL NIDHI LIMITED',
    'Kotak mahindra prime limited',
    'Jaika insurance brokerage private limited',
    'Bhatawadekar insurance surveyors & loss assessors private limited',
    'Anugrah insurance brokers private limited',
    'STANDARD INFRA-DEVELOPERS PRIVATE LIMITED',
    'Adarsh insurance brokers corporation limited',
    'Johney walker premium residences private limited',
    'Westline constructions and developments private limited',
    'GEOWN CASPER PROPERTIES PRIVATE LIMITED',
    'AGANI PROJECTS PRIVATE LIMITED',
    'Chourasia infratech private limited',
    'Meerans properties private limited',
    'Careyes real estate management services private limited',
    'Shenaz properties private limited',
    'NANMA PROPERTIES LIMITED',
    'Venkateshwar estates pvt ltd',
    'Sika properties private limited',
    'Kripa properties private limited',
    'Ascent developers private limited',
    'Pluto housing development private limited',
    'Haware engineers and builders private limited',
    'Peeyusha estate and reality private limited',
    'Axis realty private limited',
    'Greatstar realtors private limited',
    'Expaanza access limited',
    'Technolutions projects private limited',
    'Carbon consultants private limited',
    'Fides advisory services private limited',
    'Finteglaw knowledge solutions private limited',
    'I2e consulting private limited',
    'Polaris talent management private limited',
    'Aspire advisors private limited',
    'Gyansaraswati consultants private limited',
    'Synapse advisory venture private limited',
    'Tsl consulting private limited',
    'Unisource corporate services private limited',
    'Summit mentoring consultancy private limited',
    'Talent management international private limited',
    'Indusage advisors limited',
    'G.e.t. water solutions private limited',
    'Alma mater training and consultancy private limited',
    'Thangam corporate services private limited',
    'P.r. glolinks consulting private limited',
    'Lone star holdings pvt ltd',
    'Adwealth stock broking private limited',
    'Rig consultants private limited',
    'Adv consultants private limited',
    'Rkb distribution private limited',
    'Ebony concepts private limited',
    'REDEV ADVISORY PRIVATE LIMITED',
    'BARAMATI AIRPORT LIMITED',
    'OSMANABAD AIRPORT LIMITED',
    'LATUR AIRPORT LIMITED',
    'NANDED AIRPORT LIMITED',
    'YAVATMAL AIRPORT LIMITED',
    'Sogex oman india private limited',
    'Swastik allied engineering private limited',
    'RAJSHEKHAR CONSTRUCTIONS PRIVATE LIMITED',
    'R.pandey consultants private limited',
    'Athena energy ventures private limited',
    'Smartbrains engineers & technologist private limited',
    'Woodsmith krafts private limited',
    'Gupta industrial maintenance services private limited',
    'Cpg consultants india private limited',
    'Maxpro engineers private limited',
    'Schori blasting and metal spraying private limited',
    'Prajakta engineering and construction pvt ltd',
    'Mccoy prob. engineers and contractors private limited',
    'MCCOY ARCHITECTURAL SYSTEMS PRIVATE LIMITED',
    'Dorsch consult (india) private limited',
    'Dpa consultants private limited',
    'Hbo+emtb architects and interiors private limited',
    'Dhara rail projects private limited',
    'Nexus applied engineering systems private limited',
    'G a bhilare consultants private limited',
    'PINNAC CONSULTING PRIVATE LIMITED',
    'Madhur engineers pvt ltd',
    'Synapse works (india) private limited',
    'Cool cloud communications private limited',
    'Creatigies marketing private limited',
    'V.r.finmarc private limited',
    'Tarantella pictures private limited',
    'IMANDI ASIA PRIVATE LIMITED',
    'Madison teamworks film promotions and entertainment private limited',
    'Vishal arts sign and graphics private limited',
    'Next level media network private limited',
    'Mad studios private limited',
    'Fifth estate communications private limited',
    'B.c.c. shipping & ship building ltd.',
    'Thinkpot advertising private limited',
    'Fertilizer corporation of india limited',
    'Utility forms private limited',
    'KJS CEMENT (I) LIMITED',
    'Bhilwara services private limited',
    'Amlo engineering products private limited',
    'Avon india private limited',
    'Synil investments limited',
    'Sidhartha gelatines pvt ltd',
    'Raghav agricultural services private limited',
    'Reliable travels and cargo private limited',
    'Silveroak estate private limited',
    'Friends connections private ltd',
    'Uniline energy systems private limited',
    'Saab travel and tours limited',
    'Shubham organics limited',
    'Woodward india private limited',
    'Divergent information technologies private limited',
    'Raj kattha products private limited',
    'SUREN AGRO PRIVATE LIMITED',
    'K c accumulators india pvt ltd',
    'Lnj power ventures limited',
    'Tata teleservices limited',
    'S s a international ltd',
    'Surasti enterprises private limited',
    'Kangaroo studies private limited',
    'Gda finvest and trade private limited',
    'Itp electronics private limited',
    'Stallion engineering systems private limited',
    'Dva technologies private limited',
    'Bhartiya samruddhi investments and consulting services limited',
    'Ajms engineers private limited',
    'Spring holidays limited',
    'NTPC GE POWER SERVICES PRIVATE LIMITED',
    'Omega technologies pvt.ltd.',
    'Sma city developers private limited',
    'Aahan dairy private limited',
    'ARAVALLY PROCESSED AGROTECH PRIVATE LIMITED',
    'Karthik enterprises pvt ltd',
    'Theni krishna mills private limited',
    'Indu nutri ingredients private limited',
    'Nk natural foods private limited',
    'Neulife nutrition india private limited',
    'Contemporary kitchens private limited',
    'BAULI BAKES & SWEETS CONSULTING PRIVATE LIMITED',
    'Jayant snacks and beverages private limited',
    'Spr sugars private limited',
    'Madhucon sugar and power industries limited',
    'Hameedha food and beverages private limited',
    'Sycotta tea co pvt ltd',
    'Kolony tea estate private limited',
    'Rathna coffee and commodities private limited',
    'Continental caterers & confectioners private limited',
    'Mane india private limited',
    'Saiguru foodgum manufacturer private limited',
    'Geschmack food ingredient solutions private limited',
    'GOODLIFE INVESTMENTS LIMITED',
    'S & j beverages private limited',
    'Enovize beverages private limited',
    'Haritha bio products india private limited',
    'Dynamic brands private limited',
    'Guardian water resources private limited',
    'GLASSRAMIC ARTIFACTS PRIVATE LIMITED',
    'Swadesh beverages private limited',
    'Sicom capital management private limited',
    'DECCAN TOBACCO EXPORTS PRIVATE LIMITED',
    'Purman cotton company private limited',
    'Nakoda dying and weaving mills limited',
    'Chirag silk mills private limited',
    'SANJOO DYEING & PRINTING MILLS PRIVATE LIMITED',
    'Act shipping ltd',
    'Gopal synthetics pvt ltd',
    'Deluxe textile mills limited',
    'Adam smith associates private limited',
    'Top man fabrics pvt ltd',
    'SRI DESIKANATHAR TEXTILES PRIVATE LIMITED',
    'Sree saravanabalaji textiles private limited',
    'K.M.KNITWEAR PRIVATE LIMITED',
    'Srinivasabalaji spinning mills india private limited',
    'Gokulanand polytech private limited',
    'R d parmanandka textiles limited',
    'Gandhi designers fabrics private limited',
    'Mercury fabrics private limited',
    'Barvala textiles pvt ltd',
    'ANOKHI DYEING AND PRINTING MILLS PRIVATE LIMITED',
    'SATYAM DESIGNERS PRIVATE LIMITED',
    'NIVIK INDUSTRIES PRIVATE LIMITED',
    'Ankit texo innovations private limited',
    'Arvind og nonwovens private limited',
    'Seiren india private limited',
    'Asiatic textile company limited',
    'Luvkkush silk mills private limited',
    'Ledo spinning (india) limited',
    'Raymond luxury cottons limited',
    'Raymond woollen outerwear limited',
    'Anika apparels private limited',
    'Jj retail private limited',
    'Sunbright industries private limited',
    'Achal spinning private limited',
    'Madhuvan commodities brokers private limited',
    'Jagadamba sarees private limited',
    'RATAN TEXTILES PRIVATE LIMITED',
    'Az fashionscape private limited',
    'Madhavkrishna textile mills private limited',
    'Sogani nexus private limited',
    'R s brothers retail india private limited',
    'TB KAWASHIMA AUNDE (INDIA) PRIVATE LIMITED',
    'Saj trimmings private limited',
    'Esgi garments private limited',
    'Saraf carpet private limited',
    'PELEMIX INDIA PRIVATE LIMITED',
    'Sona agrotex private limited',
    'Midgape apparels private limited',
    'Kan yarn private limited',
    'J.KORIN COCOON MANUFACTURING PRIVATE LIMITED',
    'Kar mercantiles private limited',
    'Shree mahalaxmi proteins private limited',
    'B r.apparels private limited',
    'Dogra sangam textiles private limited',
    'Vidit enterprises private limited',
    'Genx creations private limited',
    'Jasmine apparels private limited',
    'Grg fine foods private limited',
    'Carreman silvercrest clothing (india) private limited',
    'United fashion mart private limited',
    'Boutique fashions private limited',
    'Texas lifestyle furniture private limited',
    'Saija fashions private limited',
    'Kaybee pvt ltd',
    'CREDO BRANDS MARKETING LIMITED',
    'Modisch commodities private limited',
    'Mangal rich linens private limited',
    'Hispano apparels private limited',
    'Midway apparels india private limited',
    'Artha farms limited',
    'BILLWIN INDUSTRIES LIMITED',
    'Evershine india apparels private limited',
    'Panache home decor private limited',
    'Sachin texfab private limited',
    'Junagadh power projects private limited',
    'Reliance solar resources private limited',
    'Azure power india private limited',
    'Ndpl infra limited',
    'Applied solar projects private limited',
    'Reliance green power private limited',
    'Diwakar solar projects limited',
    'LANCO ENERGY TALENT SCHOOL FOR SKILLS PRIVATE LIMITED',
    'Omega solar projects private limited',
    'Lanco solar services private limited',
    'Mas solar systems private limited',
    'Raipur water supply private limited',
    'Dhamwari power company private limited',
    'Trinethra wind and hydro power private limited',
    'Jyoti energy limited',
    'Khaya solar projects private limited',
    'Tasra mining & energy company private limited',
    'Premier photovoltaic gajwel private limited',
    'Lanasol energy solutions private limited',
    'Reliance power transmission limited',
    'Reliance energy trading limited',
    'Nekkar power private limited',
    'ENGENRIN POWER LIMITED',
    'Premier photovoltaic medak private limited',
    'Synergy autogas private limited',
    'Metroline infrapower private limited',
    'Japs solutions private limited',
    'Montecarlo limited',
    'RPL PHOTON PRIVATE LIMITED',
    'RPL SUN TECHNIQUE PRIVATE LIMITED',
    'RPL SUN POWER PRIVATE LIMITED',
    'Lanco solar power projects private limited',
    'Arneb power private limited',
    'MANTENA INFRASOL PRIVATE LIMITED',
    'Avya energy ventures india private limited',
    'Hallmark energy limited',
    'X-treme(bangalore)private limited',
    'Clarity aqua systems private limited',
    'Watercare technologies private limited',
    'Vishwa utilities private limited',
    'Ch2m hill (india) private limited',
    'Raja housing limited',
    'Nikitha build-tech private limited',
    'RAMYA CONSTRUCTIONS LIMITED',
    'Prestige avenues limited',
    'Lakhan homes limited',
    'SKYLARK DESIGNER & ENGINEERS PRIVATE LIMITED',
    'Crci india private limited',
    'S s k dezine point private limited',
    'Green park infracon limited',
    'Eldeco sohna projects limited',
    'Bluebells homes private limited',
    'Grand buildcon private limited',
    'Pinnacle propmart private limited',
    'Elite townships private limited',
    'ALTERNATIVE HABITAT PRIVATE LIMITED',
    'Iris plaza private limited',
    'Osgan developers private limited',
    'Ce infratech private limited',
    'Perfect megastructure private limited',
    'Avichal reality private limited',
    'Dreamzland home infraspace private limited',
    'Ajramar developers private limited',
    'Skj infracon private limited',
    'Ambaji infraventures private limited',
    'MANOR LUXURY HOTELS & HOMES PRIVATE LIMITED',
    'Unitech realty builders private limited',
    'Unitech hi-tech builders private limited',
    'POSCO ECO & CHALLENGE INDIA PRIVATE LIMITED',
    'Reddy homes private limited',
    'Ngram infrastructures and constructions private limited',
    'Madelin builders and developers private limited',
    'NANDADEEP DESIGNERS & VALUERS PRIVATE LIMITED',
    'Clovis builders and developers p.ltd.',
    'Villa velloze premises private limited',
    'Fernscape properties private limited',
    'Lartech structurons limited',
    'Sun housing private limited',
    'Prabhat real estate and developers private limited',
    'Palm green properties private limited',
    'Siddhivinayak construction private limited',
    'Vinayaka structural engineers private limited',
    'INNOVATORS FACADE SYSTEMS LIMITED',
    'Balajee infratech and constructions private limited',
    'Sarveshhu construction private limited',
    'Mangalya township private limited',
    'Basanti realtors private limited',
    'Beau ganga developers and traders private limited',
    'Belmonte developers and traders private limited',
    'Hampshire developers and traders private limited',
    'Shubh grah pravesh private limited',
    'Structural specialities and projects (india) private limited',
    'Laguna developers private limited',
    'Kohinoor projects private limited',
    'Sachinam travels pvt. ltd.',
    'Shree saheli tours and travels private limited',
    'Tristar oceanic services private limited',
    'Shalom voyagers private limited',
    'Bs travels private limited',
    'Rajlaxmi roadlines private limited',
    'Khushi holidays pvt ltd',
    'JUPITER INTEGRATED SERVICES PRIVATE LIMITED',
    'Nirgunn overseas consultants private limited',
    'J d m aviation india private limited',
    'Atlantic road services private limited',
    'Supreme holidays (india) private limited',
    'Madura travel service private limited',
    'Idee globus tours private limited',
    'Ar.a.s. logistics and services private limited',
    'Geetika travels private limited',
    'Wilderness experience travels private limited',
    'Arya translogistics private limited',
    'Countrywide logistics india private limited',
    'J.S. ONLINE SERVICES PRIVATE LIMITED (OPC)',
    'MSR INFRA & LOGISTICS PRIVATE LIMITED',
    'Empower total business and cab solutions india private limited',
    'Yourcabs auto services private limited',
    'United global logistics private limited',
    'MARK',
    'S PODAR TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Den rajkot city communication private limited',
    'Dna infotel private limited',
    'Inland financial services private limited',
    'Shri valli traders and finance private limited.',
    'Bhavadharini finance private limited',
    'Betala global securities limited',
    'Subhashree infotech private limited',
    'Cs enterprises private limited',
    'Sukarma finance ltd.',
    'Suragini investments private limited',
    'Ambica leasing and estates private limited',
    'Gopinath chem-tech limited',
    'Dhall intergrated finance pvt ltd',
    'Sanidhya securities pvt ltd',
    'Shivalik resorts and properties private limited',
    'Aico foods limited',
    'Muthoot vehicle & asset finance limited',
    'Daga financial services private limited',
    'Dhami finance limited',
    'Handsome finvest private limited',
    'Modern dealers pvt ltd',
    'Mulamoottil financiers limited',
    'Megh sakariya international private limited',
    'Atlanta capital private limited',
    'Pinnacle consolidated private limited',
    'REX-TONE DIGITAL PRIVATE LIMITED',
    'Kriscore financial advisors private limited',
    'Vishwasarh finance private limited',
    'Rithwik holdings private limited',
    'RAGE FRAMEWORKS INDIA PRIVATE LIMITED',
    'Lunkar finance private limited',
    'Sebastian holdings (india) private limited',
    'Premcem gums private limited',
    'Toshniwal instruments manufacturing private limited',
    'Rushabh investment private limited',
    'Pitrani investment and trading co pvt ltd',
    'Sahid investments and trading co pvt ltd',
    'Pammvi investments private limited',
    'Fructus consultants private limited',
    'Mio design private limited',
    'Tru-fil limited',
    'Agron holdings limited',
    'Confidis advisory services private limited',
    'Sumer energy private limited',
    'Estire research & analytics private limited',
    'DOIT CREATIVE CONSUMER VENTURES (INDIA) PRIVATE LIMITED',
    'Vasturaviraj designs private limited',
    'ANGLO-EASTERN MARITIME SERVICES PRIVATE LIMITED',
    'Prepaid mall private limited',
    'Neebal technologies private limited',
    'VDH SUPPLY CHAIN PRIVATE LIMITED',
    'MANTARAY DIGICOM PRIVATE LIMITED',
    'Dakshin mercantile private limited',
    'J s b healthcare private limited',
    'Atlas learning private limited',
    'Leminos laboratories private limited',
    'Prasaar foods private limited',
    'Lex eye services private limited',
    'Corporate stars india training private limited',
    'Medall spark diagnostics nashik private limited',
    'Hanridh marketing consultants private limited',
    'Ksj techno services private limited',
    'Synergy advisory private limited',
    'Sigma business solutions private limited',
    'INCREDIBLE GROWTH SERVICES PRIVATE LIMITED',
    'P. s. finmart private limited',
    'Orchid corporate services india private limited',
    'Ava advisors & trainers india private limited',
    'Maddox investigation services private limited',
    'Golden rabbit communications private limited',
    'Bae systems india (ventures) private limited',
    'Apj associates private limited',
    'Four leaf clover agro private limited',
    'Sns mediquip private limited',
    'Bennett institute of higher education',
    'Futuristic audio visual designs private limited',
    'Damodar consultancy and services private limited',
    'Acva biz ideas private limited',
    'Upman consultants private limited',
    'Udgam educational consultancy private limited',
    'Bh performance management private limited',
    'Epiphania solutions private limited',
    'A g employvision private limited',
    'Sharda space adviser private limited',
    'Abacus technosolutions private limited',
    'AURA BUSINESS ENTERPRISE PRIVATE LIMITED',
    'Gepsi immigration services private limited',
    'Indus consultrans private limited',
    'Ifarm equity advisors private limited',
    'Namtech consultants private limited',
    'Indo vacuum technologies private limited',
    'Ipa marketing private limited',
    'TEKTRONIX (INDIA) PRIVATE LIMITED',
    'Miebach consulting india private limited',
    'Pride management services private limited',
    'Nobby nazareth associates private limited',
    'Oscar murphy life strategists private limited',
    'Expert outsource private limited',
    'Binyas contech private limited',
    'Eucentrik solutions private limited',
    'Chreos management solutions private limited',
    'Tatsat corporate solutions private limited',
    'Trueskill energen private limited',
    'VOPTIMISE INFRA SOLUTIONS PRIVATE LIMITED',
    'Entraine business services private limited',
    'Dm management consultants & services private limited',
    'Kicons limited',
    'Lobo staffing solutions private limited',
    'Icon advisory services private limited',
    'Amar consultants private limited',
    'Indian direct equity advisors private limited',
    'S r management private limited',
    'CLA INDUS VALUE CONSULTING PRIVATE LIMITED',
    'Hsbc asset management (india) private limited',
    'WISEINVEST PRIVATE LIMITED',
    'Halcyon resources & management private limited',
    'Sidman hospitality private limited',
    'Hohenstein india private limited',
    'Bharat parekh financial & insurance services private limited',
    'Abps infrastructure advisory private limited',
    '3S BUSINESS ADVISORS PRIVATE LIMITED',
    'Sweet dreams ideas private limited',
    'Ssmark consulting private limited',
    'Ask property investment advisors private limited',
    'United team hr consultants private limited',
    'Kudje management services private limited',
    'Design collaborative private limited',
    'Vakilsearch legal solutions private limited',
    'Lalani info tech ltd',
    'Kunal resources pvt ltd',
    'P c combines private limited',
    'Sharu advisors pvt. ltd.',
    'Kolla innovatives infotech private limited',
    'Lateral architectural services private limited',
    'Eesavyasa technologies private limited',
    'Bs environment consultants private limited',
    'Greentech wind energy services private limited',
    'Sowparnika integrated farms private limited',
    'Indus vegpro private limited',
    'Eiffel india infraprojects private limited',
    'N-axis biosciences private limited',
    'Kaveri microteck private limited',
    'Good earth crop science private limited',
    'Producemax agritech private limited',
    'Ace foods private limited',
    'Pristine organics private limited',
    'Nature 1 agro products india private limited',
    'Leecon chemicals private limited',
    'Shree ganesh laxmi industries private limited',
    'Rayen steels private limited',
    'Sutanutti farms pvt ltd',
    'SCHUTTE MEYER ASHWATH ALLOYS PRIVATE LIMITED',
    'Katra holding private limited',
    'Radel advanced technology private limited',
    'ABS FUJITSU GENERAL PRIVATE LIMITED',
    'Century hospitality holdings private limited',
    'Ashok peter jacob investments private limited',
    'Yesh real estates private limited',
    'Tubed coal mines limited',
    'Fuelcoal corporation india limited',
    'Wave geo-services private limited',
    'Shiv-vani energy limited',
    'Eurostar engineering private limited',
    'Mspl limited',
    'Green valley mining private limited',
    'Mahalakshmi rock metal private limited',
    'ORIENT ADVANCED MATERIALS PRIVATE LIMITED',
    'Ceracon ceramix india private limited',
    'STONE AGE PRIVATE LIMITED',
    'Sterling stonex private limited',
    'Rathod build mart private limited',
    'Great granites pvt. ltd.',
    'Hillstone granites private limited',
    'Swati mining private limited',
    'Starlite minchem private limited',
    'Starlight minores private limited',
    'Starlight metapower private limited',
    'Mineworks private limited',
    'GIMPEX METAL PRIVATE LIMITED',
    'Tim tom food products pvt ltd',
    'Golden jubilee foods private limited',
    'Wimwi foods private limited',
    'Bhagwati fats and edible oils private limited',
    'Kings dehydrated foods pvt. ltd',
    'Himesh foods private limited',
    'Bon appetit food chain private limited',
    'Vg engineers pvt ltd',
    'Siddhi oils limited',
    'Shree jagdish oil industries limited',
    'K K P WEAVING AND PROCESSING MILLS Private Limited',
    'Biomax fuels limited',
    'Tamilnadu breeding farm private limited',
    'Sri srinivas wheat industries private limited',
    'SHREE RAM HYDROCOLLOIDS PRIVATE LIMITED',
    'DAYAL ENERGY AND PROTEINS Private Limited',
    'Continental caterers private limited',
    'Liwayway foods india private limited',
    'Bakers kraft private limited',
    'RITVIJ INFRAPROJECT PRIVATE LIMITED',
    'Ganesh bhel and chaat products private limited',
    'Srini food park private limited',
    'Aachi spices and foods private limited',
    'VED JAGAT PRIVATE LIMITED',
    'Greenfizz beverages private limited',
    'Bp fresh fruit private limited',
    'Talbros foods private limited',
    'SREE ANGADI DUTT SUGARS LIMITED',
    'Trident sugars limited',
    'Limtex tea & industries ltd.',
    'Kayan agro industries & co private limited',
    'J.d.s food products private limited',
    'Saurashtra cotton and agro products private limited',
    'Nutrom dietics private limited',
    'Vintage bottlers private limited',
    'Bihar state beverages corporation limited',
    'Dte exports pvt ltd',
    'Akay filtips private limited',
    'Multifashions private limited',
    'HARIT EXPORTS PRIVATE LIMITED',
    'Komal filatex private limited',
    'Suryakiran rolling mills pvt ltd',
    'India denim limited',
    'NAINA',
    'S CHEMO PLAST PRIVATE LIMITED',
    'Aatmajyot chem private limited',
    'Dcl chemplast limited',
    'Harsh plasto metalizers private limited',
    'Pam labs india health care private limited',
    'Nav auxichem private limited',
    'Oren mud chemicals pulverising private limited',
    'Nex farm products india private limited',
    'Archie and jughead india private limited',
    'KANYAKA PACKAGING SOLUTIONS PRIVATE LIMITED',
    'Tolin rubbers private limited',
    'Vulcan components india private limited',
    'Fluidtherm technology private limited',
    'Kp polyolefin sacks private limited',
    'Pendo plast private limited',
    'U m cables limited',
    'Axiom ceramic private limited',
    'Wallcera tiles private limited',
    'Eshan minerals private limited',
    'Cast stones private limited',
    'TRELLEBORG INDIA PRIVATE LIMITED',
    'Np kore housing solutions private limited',
    'Fibro plast pvt ltd',
    'Srish corporation private limited',
    'Dryden private limited',
    'Multi organics private limited',
    'R and d multiples (metal-cast) private limited',
    'Naresh steel industries private limited',
    'Thyssenkrupp electrical steel india private limited',
    'Rohit iron and steel (india) private limited',
    'Jsk industries private limited',
    'Sainergy industrial products private limited',
    'Precision technoplast private limited',
    'Shyam steel metallics private limited',
    'Standard sintered products private limited',
    'Apple sponge & power limited',
    'Permasteelisa (india) private limited',
    'Vrm metazine private limited',
    'Diagems exports private limited',
    'Nowrangroy agro private limited',
    'Supreme electrotech private limited',
    'Mangalodayam pharmaceuticals private limited',
    'Vividh distributors pvt ltd',
    'Mittal corp limited',
    'Coral healthcare private limited',
    'Pacific international private limited',
    'PUNEET STEELS AND ALLOYS PRIVATE LIMITED',
    'Surbhi metals (india) private limited',
    'Three aar blade mannufacturing co private limited',
    'Snrco chemicals private limited',
    'Kamadgiri steel private limited',
    'Limra metals private limited',
    'Sree venkataratna metals pvt. ltd.',
    'Satya surya aluminium industries limited',
    'Young india prestress pvt ltd',
    'Asbesco (india) pvt ltd',
    'Crm steels pvt. ltd.',
    'CRM METALIKS PRIVATE LIMITED',
    'Trumax ispat private limited',
    'Brace iron & steel private limited',
    'Moon light metal industries pvt ltd',
    'MEHTA & MEHTA PLASTO PRINTERS (INDIA) PRIVATE LIMITED',
    'Golden polymex (india) limited',
    'Rathor engineers private limited',
    'Western metal industries private limited',
    'Mefco engineers private limited',
    'Chirakekaren glass house private limited',
    'Gajra glassfibre private limited',
    'Hoya lens india private limited',
    'Renuka interiors private limited',
    'Rockwood hotels and resorts limited',
    'Spire industries private limited',
    'Kaizen steel and energy private limited',
    'IMPERIA INTERNATIONAL PRIVATE LIMITED',
    'Asian mills private limited',
    'Banco aluminium limited',
    'Japsaw pvt ltd',
    'Sasco steel private limited',
    'Peekay steel castings private limited',
    'Reserve mines & infra private limited',
    'Mcl global steel private limited',
    'Metcraft steel private limited',
    'Aakash auto private limited',
    'Harsha auto agencies private limited',
    'Merind automotive private limited',
    'Jayanti nirman private limited',
    'Saas engineering co pvt ltd',
    'Radheykrishna infraprojects private limited',
    'Dhiman realtors private limited',
    'Kolhapur airochem private limited',
    'Sehgal wheels private limited',
    'HARSHA AUTO MARTS PRIVATE LIMITED',
    'Vishwa karma motor garage and service station private limited',
    'Proficient house private limited',
    'Crazy infrastructure private limited',
    'Moonview abasan private limited',
    'Ambey infra realty private limited',
    'Hrg construction private limited',
    'Eclair infraestate private limited',
    'Epistle realestate private limited',
    'Ibex builders private limited',
    'Kathakunj conclave private limited',
    'Dhunseri infrastructure limited',
    'N. f. impex private limited',
    'Mainframe energy solutions private limited',
    'Jain millennium bikes private limited',
    'Jahman dealers private limited',
    'Oscon industrial supplies private limited',
    'Kalptaru alloys private limited',
    'GOBLIN INDIA LIMITED',
    'Spl motors private limited',
    'Iauto components private limited',
    'Marvel infrabuild private limited',
    'Kanhiya metals private limited',
    'Madras garments private limited',
    'Ice boy machines private limited',
    'Yrp square imports & exports private limited',
    'Hhs india private limited',
    'Highpoint ventures private limited',
    'Katra auto engineering private limited',
    'Elite automobiles private limited',
    'Mileage auto private limited',
    'Naman tradelink private limited',
    'Impulse direct sales private limited',
    'Nsw biotech private limited',
    'Mitul marketing private limited',
    'Shriank enterprise private limited',
    'Triada technologies india private limited',
    'Purple pony lifestyle private limited',
    'Tajir private limited',
    'W r talwalker engineering private limited',
    'Bisleri advertising private limited',
    'Omar agencies private limited',
    'Deta trading private limited',
    'Ashwani cars private limited',
    'Proav solutions private limited',
    'Pacific import export india private limited',
    'Navratan distributors private limited',
    'G.n. vogue sales private limited',
    'Dingo commodeal pvt.ltd.',
    'Mantri engineering company private limited',
    'Karp jewellery private limited',
    'Ardelis infraprojects private limited',
    'Dml world trade private limited',
    'Nakoda hankies pvt ltd',
    'SPONGE ENTERPRISES PRIVATE LIMITED',
    'Bagadiya brothers private limited',
    'Jaltarang advisory pvt. ltd.',
    'Niket constructions pvt ltd',
    'Adhunik merchandise pvt ltd',
    'Unickon commodities private limited',
    'Harsha auto enterprises private limited',
    'Golden wish trading private limited',
    'Jalori trade services private limited',
    'Vb commodities private limited',
    'Monalisa tie-up private limited',
    'Afford tie-up private limited',
    'Jhilmil tieup private limited',
    'Suryavanshi vyapaar private limited',
    'Yamnotri vyapaar pvt ltd',
    'Sheetla vyapaar private limited',
    'Mata vaishnodevi mercantile private limited',
    'Shree yukta vanijya private limited',
    'Landmark shoppers private limited',
    'Somani tradelink private limited',
    'Happy barter private limited',
    'Happy commodities private limited',
    'Shagul travels pvt ltd',
    'Aditya fairdeal limited',
    'Satin media solutions limited',
    'Peakward enterprises india private limited',
    'Radha raman tradecom private limited',
    'Vishwamurti vinimay private limited.',
    'Zion logistics india private limited',
    'Vpc comtrade private limited',
    'Chetna saree emporium private limited',
    'Kabini river plantations private limited',
    'R.l. commodditties private limited',
    'Tristar edibles private limited',
    'Nextbrick technologies private limited',
    'Levi tradelink private limited',
    'Extract engineering works private limited',
    'Channel foods private limited',
    'Jude foods india private limited',
    'Lightsquare designs private limited',
    'Ishita craft essentials private limited',
    'Rahul sidhu enterprises private limited',
    'Tirupati feeds private limited',
    'Mogae media private limited',
    'Drolia mineral industries private limited.',
    'VISA COKE LIMITED',
    'Chemistik private limited',
    'Bitumen corporation india private limited',
    'Gaspoint petroleum (india) limited',
    'Dhanlaxmi coatings private limited',
    'Sandhya chemplast private limited',
    'Bansal alkalies private limited',
    'Astrica biomedics private limited',
    'Rav chem specialties private limited',
    'Biotron biotech private limited',
    'Nerka chemicals private limited',
    'Mahek agro mineral private limited',
    'Denim colourchem private limited',
    'EVONIK CATALYSTS INDIA PRIVATE LIMITED',
    'Rama industries limited',
    'Raireshwar organic chemicals private ltd',
    'Rama chemicals india private limited',
    'Angre chemicals private limited',
    'Laxachem organics private limited',
    'Sellon dynamics private limited',
    'Fin-line polymers private limited',
    'Cosmas research lab limited',
    'Salicylates & chemicals private limited',
    'Ashrae filters private limited',
    'Vijayshri agro chemicals pvt ltd',
    'Thomas baker (chemicals) private limited',
    'INDIGO PAINTS LIMITED',
    'Himachal terepene products pvt ltd',
    'Goyal proteins limited',
    'Navochem india private limited',
    'Avon refractories private limited',
    'Beijing luckystar chemicals (india) private limited',
    'Hornbell chemicals and plastics private limited',
    'Colour chromes private limited',
    'K.P.R.AGROCHEM LIMITED',
    'Kuber fertilisers private limited',
    'Labland biotechs private limited',
    'Nectar organics private limited',
    'Prayagh nutri products private limited',
    'Phoenix conveyor belt india private limited',
    'Climax automotive private limited',
    'Sarala real estate limited',
    'Aditya polychem private limited',
    'Castle colour process pvt ltd',
    'Jindal chemtech india private limited',
    'Royal spectrum private limited',
    'Comapct guesthouse (india )private limited',
    'Esdee paints limited',
    'Vedant industries private limited',
    'ONEIRO LIFECARE PRIVATE LIMITED',
    'Babuline pharma private limited',
    'Britacel silicones limited',
    'Kopran laboratories limited',
    'Vac pharmaceuticals pvt. ltd.',
    'S kant chemicals private limited',
    'Ashonuj chem private limited',
    'Fusion cosmeceutics private limited',
    'Aryaansh bionaturals private limited',
    'Bharat biotech international limited',
    'Princeps pharmaceuticals private limited',
    'Meek pharma private limited',
    'Nikhil drugs and chemicals private limited',
    'Hindusthan miswaco limited',
    'Elysium pharmaceuticals ltd',
    'Interseas finechem private limited',
    'Leo life sciences private limited',
    'Emcure pharmaceuticals limited',
    'Gr cheminn pharma private limited',
    'PLASTOBATCH PRIVATE LIMITED',
    'Godson healthcare private limited',
    'Navin meditech private limited',
    'ELKRAFT ENGINEERING PRIVATE LIMITED',
    'Chandra life sciences private limited',
    'Karyotica biologicals private limited',
    'Chempure pvt ltd',
    'Oncquest laboratories limited',
    'Consortium clinical research private limited',
    'Siddhayu ayurvedic research foundation pvt ltd',
    'Cellbion lifesciences private limited',
    'Nest pharma private limited',
    'Vinayaka agro fertilizers india private limited',
    'Praveen scientific glassware and instruments private limited',
    'TK ELEVATOR INDIA PRIVATE LIMITED',
    'Waves bio-tech pvt ltd',
    'Aquarius pharma services private limited',
    'Great scientific supplies pvt. ltd',
    'Biotech desk private limited',
    'Ensure biotech private limited',
    'Ultima cosmetics private limited',
    'High street tobacco private limited',
    'Praveen aroma private limited',
    'Argus cosmetics limited',
    'Neelkanth coal manufacturing private limited',
    'Unilux films private limited',
    'Rbp technology (india) private limited',
    'Santosh starch products limited',
    'Shree ambica decoprints private limited',
    'Altret industries private limited',
    'Saboo cemtech engineers private limited',
    'Saneesa chemicals and equipments private limited',
    'Poddar tyres limited',
    'Royal hydraulics pvt ltd',
    'Samrat tyres private limited',
    'Tolins tyres private limited',
    'Kineco alte train technologies private limited',
    'Sepset constructions limited',
    'Arya power service private limited',
    'Ncc urban ventures private limited',
    'Concoct buildcon private limited',
    'Zynergy solar projects and services private limited',
    'Gckc projects and works private limited',
    'Paranthaman overseas drillers private limited',
    'Sealand infrastructure private limited',
    'AMOLIKA PROJECTS PRIVATE LIMITED',
    'Pramur constructions private limited',
    'Unity contracting private limited',
    'DEIFY INFRASTRUCTURES PRIVATE LIMITED',
    'Rainbow infraprojects limited',
    'Kind & kare reality limited',
    'Rudra nirman private limited',
    'Rudra navnirman private limited',
    'Marg swarnabhoomi port private limited',
    'Kashyap infraprojects private limited',
    'Engineers india infrastructural services private limited',
    'Dee vee projects limited',
    'Siel industrial estate limited',
    'Shree chitrakut buildcon private limited',
    'Dwarkadish builders private limited',
    'Cs developers & promoters private limited',
    'Nidhi prime infraprojects private limited',
    'Bioko developers private limited',
    'Positive buildcon private limited',
    'Rof housing and infrastructure private limited',
    'Emerald city developers private limited',
    'Globecom infra ventures india private limited',
    'Earthy dealcom private limited',
    'Elfin buildcon private limited',
    'Wily developers private limited',
    'Gati projects private limited',
    'C l developers pvt ltd',
    'Subhlakshmi projects private limited',
    'Howrah developers private limited',
    'Madhyamgram infracon private limited.',
    'Confitech niwas private limited',
    'KENT CERAMIC TILES & CO.PRIVATE LIMITED',
    'Gar infraproject private limited',
    'Coral projects private limited',
    'K.t.s. automotors private limited',
    'Induct infraproject private limited',
    'Mahalaxmi prodev private limited',
    'Goodfaith developers private limited',
    'Chanson cozy coach private limited',
    'Parshwanath impex private limited',
    'Vpk motors private limited',
    'Mahalaxmi automotives private limited',
    'Effort construction private limited',
    'Elect devcon private limited',
    'Endorse builders private limited',
    'Muktar automobiles private limited',
    'Dsk mototrucks private limited',
    'Globe cv private limited',
    'Induct realestate private limited',
    'Weighty devcon private limited',
    'Akc motors private limited',
    'Phoenix motors private limited',
    'Bhavna auto wheels private limited',
    'Genext precision auto india private limited',
    'B.u.bhandari motors private limited',
    'Bc equipment trading company private limited',
    'Pps motors private limited',
    'NOURITRANS EXIM LIMITED',
    'Safe harvest private limited',
    'Dutyfree distribution services private limited',
    'Vishnu trading and investment co.pvt.ltd.',
    'United infra minerals private limited',
    'Metropolitan distributors private limited',
    'Greatful mercantile private limited',
    'Sanskar dealcom private limited',
    'Sparkle commotrade private limited',
    'Scrabble agency private limited',
    'Nanda commodeal private limited',
    'Bloom distributors private limited',
    'Saraswati vinimay private limited',
    'Uniwest petrochem private limited',
    'Image specialities india private limited',
    'Southern clothing private limited',
    'Msj trades impex limited',
    'Maxima motion & controls private limited',
    'Style auto components private limited',
    'United india marketing private limited',
    'Hpn marketing services private limited',
    'N e p d marketing private limited',
    'Kalptaru exim private limited',
    'M techno international private limited',
    'Welsome construction private limited',
    'Incredible devcon private limited',
    'Team infrabuild private limited',
    'D h contracts private limited',
    'Identical builders private limited',
    'Wise developers private limited',
    'Insist realcon private limited',
    'Ivory complex private limited',
    'Safalta developers private limited',
    'Eeshvi infrastructure private limited',
    'Gladiolus abasan private limited',
    'Corporate accomodation solutions private limited',
    'Adinath autogas private limited',
    'The star cars private limited',
    'Ghosh brothers motors private limited',
    'HLK INDUSTRIES PRIVATE LIMITED',
    'Goel motors private limited',
    'Snk consultants private limited',
    'Allfin marketing services private limited',
    'Allfin distributions private limited',
    'Allfin insurance specialities private limited',
    'Allfin insurance services private limited',
    'Homeland ventures private limited',
    'Brahmaputra industrial park private limited',
    'Varali real estate limited',
    'Salton developers private limited',
    'Kalvin realtech private limited',
    'VATIKA INXT 2 PRIVATE LIMITED',
    'Flowmore limited',
    'S m s associates private limited',
    'Allena auto industries private limited',
    'Ihhr hospitality private limited',
    'Ramprastha builders private limited',
    'Nalini sarees private limited',
    'Ram prastha properties private limited',
    'Asian trans controls pvt ltd',
    'Ram prastha construction private limited',
    'Deolalikar consultants private limited',
    'Vettoor construction engineers private limited',
    'Universal consortium of engineers pvt ltd',
    'Wapeka professional services private limited',
    'Super cassettes industries private limited',
    'GREAT EASTERN IDTECH PRIVATE LIMITED',
    'Indo dynamics private limited',
    'B jain publishers private limited',
    'Essen paints private limited',
    'WAAREE PV TECHNOLOGIES PRIVATE LIMITED',
    'Progressive development facilitators private limited',
    'A line consulting private limited',
    'Amiya corpn india pvt ltd',
    'Matix fertilisers and chemicals limited',
    'Calcutta bone mills and fertilizers pvt. ltd.',
    'Jayashree polymers private limited',
    'Udyogi plastics pvt ltd',
    'BETTER & BRIGHTER HOMECARE PRIVATE LIMITED',
    'Rubicon formulations private limited',
    'Rani syndicate private limited',
    'Capital legal solutions private limited',
    'Snehal impex private limited',
    'Chelawasia agrotech private limited',
    'Venkateshwara bioproducts private limited',
    'Memory graphics private limited',
    'Digi xpress printing technologies private limited',
    'Farmson pharmaceutical gujarat private limited',
    'Oscar remedies pvt ltd',
    'Vistaar mediaworks limited',
    'Omal organics limited',
    'Gowan india private limited',
    'Maheshrajka pharmaceuticals private limited',
    'Dynamic dish india private limited',
    'Palmo industrial silicones private limited',
    'Ish medicos private limited',
    'G.d. pharmaceuticals private limited',
    'Conti metal private limited',
    'Arcl petrochemicals limited',
    'Salgaocar industrial gases private limited',
    'Reddy pharmaceuticals limited',
    'Hindustan hydraulics pvt ltd',
    'Grace davison chemicals india private limited',
    'CHABRO CHEMIE INDIA LIMITED',
    'R.c. sons pharma private limited',
    'Spice media private limited',
    'DEY',
    'BEST COMMERCE PRIVATE LIMITED',
    'GUARDIANS HUMAN RESOURCES (OPC) PRIVATE LIMITED',
    'INTLLSPACE SOLUTIONS PRIVATE LIMITED',
    'MOONROCK POWER SOLUTIONS PRIVATE LIMITED',
    'ASECSOLUTIONS PRIVATE LIMITED',
    'DELSEN DISTRIBUTION PRIVATE LIMITED',
    'SANTRIC TECHNOLOGIES PRIVATE LIMITED',
    'MANJEERA HOSPITALITY (VIJAYAWADA) PRIVATE LIMITED',
    'ARBS INFOTECH PRIVATE LIMITED',
    '2GETHR HUB PRIVATE LIMITED',
    'HIMALAYAN UNIVERSAL EDUCATION FOUNDATION',
    'DAIREN COMPOSITES PRIVATE LIMITED',
    'BLUECHIP GULF IT SERVICES PRIVATE LIMITED',
    'SENSABYTE EDUSOFT PRIVATE LIMITED',
    'TURNING-POINT HEALTH CARE PRIVATE LIMITED',
    'SPOTRIX INDIA WEB SOLUTIONS PRIVATE LIMITED',
    'SILICON RD IDEATION LABS PRIVATE LIMITED',
    'UKEY SMART SOLUTIONS PRIVATE LIMITED',
    'SAPFRESH NUTRAVITALS PRIVATE LIMITED',
    'ARVIK PHARMA PRIVATE LIMITED',
    'MARUVAN FOUNDATION',
    'VITRIOLIUM AYURVEDA TRAILS PRIVATE LIMITED',
    'IMPERALABS INFOTECH PRIVATE LIMITED',
    'GREENLINKS GROUP PRIVATE LIMITED',
    'SGPIPL CHANDRAPUR POMBHURNA PROJECTS PRIVATE LIMITED',
    'KHANNBA ENTERPRISES PRIVATE LIMITED',
    'DAIICHI INFOTAINMENT SYSTEMS PRIVATE LIMITED',
    'EDNS SOLUTIONS PRIVATE LIMITED',
    'SIX DIMENSION WELLNESS PRIVATE LIMITED',
    'GBNEUHAUS INDIA PRIVATE LIMITED',
    'DRUMBUFFER ANALYTICS PRIVATE LIMITED',
    'ROSAOUI HOTELCO PRIVATE LIMITED',
    'NAYNEES E-STORE PRIVATE LIMITED',
    'ATLANTA WORLD HOLIDAYS PRIVATE LIMITED',
    'CAPRI EVENTS PRIVATE LIMITED',
    'DARBY TELEMATICS INDIA PRIVATE LIMITED',
    'SHERIFF INDUSTRIES PRIVATE LIMITED',
    'INTYGRITTY MONEYTREE PRIVATE LIMITED',
    'INDINOX STEELS PRIVATE LIMITED',
    'EASY LANE MANAGEMENT PRIVATE LIMITED',
    'KIMAX CONTROLS PRIVATE LIMITED',
    'AISTRINGS SOLUTIONS PRIVATE LIMITED',
    'SINGX CROSS BORDER SOLUTIONS PRIVATE LIMITED',
    'ASPINO SPINTEX PRIVATE LIMITED',
    'AXIOM TECHNOLOGIES SERVICES PRIVATE LIMITED',
    'LEVERAGE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GOODHUMS LIFESCIENCES PRIVATE LIMITED',
    'WOXA LIFECARE PRIVATE LIMITED',
    'EGO PREMIUM PRODUCTS PRIVATE LIMITED',
    'SUNDARAM INVESTMENT PRIVATE LIMITED',
    'MJ DIGITAL SERVICES PRIVATE LIMITED',
    'LAVIVA OFFICE SPACES (OPC) PRIVATE LIMITED',
    'CREDOCHAIN TECHNOLOGIES PRIVATE LIMITED',
    'TTE TECHNOLOGY INDIA PRIVATE LIMITED',
    'AKRIVIS PACKAGING PRIVATE LIMITED',
    'SOUTH ASIAN DRUGS AND ADDICTIONS RESEARCH COUNCIL',
    'HARDROCK CLUB PRIVATE LIMITED',
    'INTERAKT TECHSOL PRIVATE LIMITED',
    'WELLAND INDUSTRIES PRIVATE LIMITED',
    'FENFEO AUTOMATION PRIVATE LIMITED',
    'RMFT PRIVATE LIMITED',
    'PLATINUM FINWEALTH PRIVATE LIMITED',
    'SRI MUTHUVINAYAGAR CHITS PRIVATE LIMITED',
    '19TH HOLE STUDIOS PRIVATE LIMITED',
    'JDIA RETAIL PRIVATE LIMITED',
    'IMPACT NUTS PRIVATE LIMITED',
    'LEARNING DESIGN & RESOURCES PRIVATE LIMITED',
    'INFINITY GLOPACK INDIA PRIVATE LIMITED',
    'SBESTOW SERVICES PRIVATE LIMITED',
    'VIRENA INDIA HYDRAULIC AND COOLING SYSTEMS PRIVATE LIMITED',
    'ACE ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED',
    'COVALSYSOFT SOLUTIONS PRIVATE LIMITED',
    'RD INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'BUZZBITES MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'GREENTICK FOOD TECH PRIVATE LIMITED',
    'CULTURELYTICS PRIVATE LIMITED',
    'WHIZKIDZZ MARKETING PRIVATE LIMITED',
    'AORATAS TECHNICA ENGINEERING PRIVATE LIMITED',
    'VRONE CONSULTANCY PRIVATE LIMITED',
    'INSTAIVY TECHNOLOGIES AND EDUCATION PRIVATE LIMITED',
    'REVIN LABS PRIVATE LIMITED',
    'ROHUMA INDIA INFO SOLUTIONS PRIVATE LIMITED',
    'SAMTAIYO TECH INDIA PRIVATE LIMITED',
    'AVIYEN RISK MANAGEMENT SERVICES PRIVATE LIMITED',
    'BLITE INDUSTRIES (OPC) PRIVATE LIMITED',
    'ASTRUS RETAIL SOLUTIONS PRIVATE LIMITED',
    'CAREDOVE INDIA SOFTWARE PRIVATE LIMITED',
    'SYSCOM ORGANIC WORLD PRIVATE LIMITED',
    'DOST DEALCOM PRIVATE LIMITED',
    'ANUPAVAN RENEWABLES PRIVATE LIMITED',
    'KATHIWADA BRANDS PRIVATE LIMITED',
    'DIYA EDULABS PRIVATE LIMITED',
    'KREATIVE MAGNITUDES PRIVATE LIMITED',
    'HAPPY LEARNING PRIVATE LIMITED',
    'ENERZENITH ENTERPRISES PRIVATE LIMITED',
    'THEA CARE FEMTECH LABS PRIVATE LIMITED',
    'SSRCR ENTERPRISES PRIVATE LIMITED',
    'ALURAYS LIGHTING TECHNOLOGY INDIA PRIVATE LIMITED',
    'KAWASHIMA RUBBER INDUSTRIES PRIVATE LIMITED',
    'ROADWAY SOLUTIONS NARAYANPUR ROADS PROJECT PRIVATE LIMITED',
    'AMERICAN LEGALNET INDIA PRIVATE LIMITED',
    'NITRODYNAMICS AEROSPACE AND DEFENCE PRIVATE LIMITED',
    'SOLIS RENEWABLE ENERGY PRIVATE LIMITED',
    'ABITA INNOVATIONS PRIVATE LIMITED',
    'GENUGRITY PHARMA SERVICES PRIVATE LIMITED',
    'OJIS EXIM PRIVATE LIMITED',
    'ISOURCE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SPRINGMED HEALTHIT SOLUTIONS PRIVATE LIMITED',
    'BRACKISH INDUSTRIES PRIVATE LIMITED',
    'INDIRANAGAR GYMNASTIC CENTER PRIVATE LIMITED',
    'CONOR COSMO INDIA PRIVATE LIMITED',
    'TAPI FRUIT PROCESSING LIMITED',
    'SUDESH HEALTH CARE FOUNDATION',
    'ARGONPOWER SEMICONDUCTORS PRIVATE LIMITED',
    'NASSCO SPORTS & EVENTS PRIVATE LIMITED',
    'CVRCE TECHNOLOGY INCUBATOR FOUNDATION',
    'HYDROFLUX SOLUTION PRIVATE LIMITED',
    'ACQUAIR VENTURES PRIVATE LIMITED',
    'BULLETPROOF ENTERTAINMENT PRIVATE LIMITED',
    'BHADRA GROUP PRIVATE LIMITED',
    'BCHIMP TECHNOLOGIES PRIVATE LIMITED',
    'FUNNEL SIMPLIFIED PRIVATE LIMITED',
    'HUGO NETWORKS PRIVATE LIMITED',
    'TOPBELLS HR SOLUTIONS PRIVATE LIMITED',
    'SILVERSWING FACILITY PRIVATE LIMITED',
    'JAIKO CONVERTING MACHINE PRIVATE LIMITED',
    'BROWNDOVE FORMULATIONS PRIVATE LIMITED',
    'SUVEDAN INTEGRATED DEVELOPMENT FOUNDATION',
    'DBL BELLARY BYRAPURA HIGHWAYS LIMITED',
    'HARSHAD CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'EMEDSURE PRIVATE LIMITED',
    'CARBON ELECTRONICS PRIVATE LIMITED',
    'SANTOSH STEEL AND PIPES INDIA PRIVATE LIMITED',
    'SMILEBEES PHOTOGRAPHY PRIVATE LIMITED',
    'AGARWAL TECHNOPLAST PRIVATE LIMITED',
    'SWISS GARNIERS GENEXIAA SCIENCES PRIVATE LIMITED',
    'COORG HS PRIVATE LIMITED',
    'LINXON INDIA ENGINEERING PRIVATE LIMITED',
    'MARKET HOURZ BUSINESS SOLUTION PRIVATE LIMITED',
    'DHEEMAT EDUCATIONAL SERVICES (OPC) PRIVATE LIMITED',
    'FARHANS CAREERS LEAGUE PRIVATE LIMITED',
    'ARNISH LABORATES PRIVATE LIMITED',
    'TSIN TRADING PRIVATE LIMITED',
    'WILDLION TECHNOLOGIES PRIVATE LIMITED',
    'SHREESHYAM OLEO CHEMICALS PRIVATE LIMITED',
    'TOUCHLESS ID PRIVATE LIMITED',
    'RUTAM ENVIRO SYSTEMS PRIVATE LIMITED',
    'RANDER CORPORATION LIMITED',
    'SITI NETWORKS LIMITED',
    'IDBI BANK LIMITED',
    'GENESYS INTERNATIONAL CORPORATION LIMITED',
    'BRAND CIRCLE COMMUNICATIONS PRIVATE LIMITED',
    'GIGACHARGE SOLUTIONS PRIVATE LIMITED',
    'ABM KNOWLEDGEWARE LIMITED',
    'ZENSAR TECHNOLOGIES LIMITED',
    'HEXAWARE TECHNOLOGIES LIMITED',
    'SERUM BIOTEC LIMITED',
    'PARIKRAM IT SOLUTIONS PRIVATE LIMITED',
    'STAR POWERZ DIGITAL TECHNOLOGIES PRIVATELIMITED',
    'MAKCUR LIFESCIENCE PRIVATE LIMITED',
    'LION ESTATES PRIVATE LIMITED',
    'VRIKS TELECOM PRIVATE LIMITED',
    'AMCHAN PLASTOMAKE PRIVATE LIMITED',
    'BANSAL ORE AND METALS PRIVATE LIMITED',
    'COSCEND COMMUNICATIONS PRIVATE LIMITED',
    'PANTHOR AGRO PRIVATE LIMITED',
    'HYBRID AGRI BIOTECH PRIVATE LIMITED',
    'INCUBIX UNIFIED SOLUTIONS PRIVATE LIMITED',
    'BRIIISK MERCANTILE PRIVATE LIMITED',
    'KREATIVSARG HEALTHCARE PRIVATE LIMITED',
    'JCS HEALTHCARE PRIVATE LIMITED',
    'COUNTRY CLUB HOSPITALITY & HOLIDAYS LIMITED',
    'RAO FARMS LIMITED',
    'CIRCAR TOBACCO TRADERS PVT. LTD.',
    'PROGRESSIVE CONSTRUCTIONS LIMITED',
    'RRIL LIMITED',
    'WOMEN',
    'S MARK INDUSTRIES LIMITED',
    'SKY COURIERS PRIVATE LIMITED',
    'RADHAKRISHNA PAPER MILLS PRIVATE LIMITED',
    'ECOPACK INDIA PAPER CUP PRIVATE LIMITED',
    'PIYUSH SUGAR AND POWER PRIVATE LIMITED',
    'PAVAN POPLAR LIMITED',
    'ALLANA COFFEE PRIVATE LIMITED',
    'ARAGON PLANTATIONS PRIVATE LIMITED',
    'SHEETAL HYBRID SEEDS PRIVATE LIMITED',
    'HORIZON FLORA INDIA LIMITED',
    'KASTORKING (INDIA) PRIVATE LIMITED',
    'ARASAMPALAYAM FARMS PRIVATE LIMITED',
    'CALIBRE CHEMICALS PRIVATE LIMITED',
    'JAINCO FASHIONS PRIVATE LIMITED',
    'BRINTONS CARPETS ASIA PRIVATE LIMITED',
    'ELECTRON COLOUR-CHEM PRIVATE LIMITED',
    'NAIKNAVARE CHEMICALS LIMITED',
    'JINDAL SHIRTINGS PRIVATE LIMITED',
    'SPLICE BIO TECH PRIVATE LIMITED',
    'BOXERI TECH INDIA PRIVATE LIMITED',
    'POLYONE POLYMERS INDIA PRIVATE LIMITED',
    'ELEGANT APPARELS PRIVATE LIMITED',
    'PARLE (EXPORTS) PRIVATE LIMITED',
    'HELIOS FOOD IMPROVERS PRIVATE LIMITED',
    'MEGA LIFESCIENCES PRIVATE LIMITED',
    'ARTEMIS BIOTECH LIMITED',
    'TOYO VENTURES PRIVATE LIMITED',
    'CATALYST SPECIALITY CHEMICALS PRIVATE LIMITED',
    'WEST COAST INDUSTRIES (EXPORT) PRIVATE LIMITED',
    'PARADISE FITNESS & HEALTH PRIVATE LIMITED',
    'RAYMOND APPAREL LIMITED',
    'UNITECH CARTONS PRIVATE LIMITED',
    'CHENNAI IDREAM HOMES & ENTERTAINMENTS PRIVATE LIMITED',
    'KARWA RETAIL PRIVATE LIMITED',
    'APRICITAS INSTITUTE OF TECHNOLOGIES PRIVATE LIMITED',
    'VISTA INTERNATIONAL PRIVATE LIMITED',
    'EMCO PAPERS PRIVATE LIMITED',
    'LITTLE FROG BOOKS PRIVATE LIMITED',
    'CHETTINAD E-PUBLISHING PRIVATE LIMITED',
    'KASYAP PUBLICATION PRIVATE LIMITED',
    'KASYAP PRINTERS PRIVATE LIMITED',
    'J B METAL INDUSTRIES PRIVATE LIMITED',
    'SAMPARK MULTIMEDIA LIMITED',
    'MARINE TEX ENGINEERS PRIVATE LIMITED',
    'ADREEK MEDIA PRIVATE LIMITED',
    'NIMITTA PETROCHEM PRIVATE LIMITED',
    'FAURECIA AUTOMOTIVE SEATING INDIA PRIVATE LIMITED',
    'TISYA BUILDING PRODUCTS PRIVATE LIMITED',
    'T K FUELS (INDIA) PRIVATE LIMITED',
    'GSL NOVA PETROCHEMICALS LIMITED',
    'CADIOX LIFE CARE PRIVATE LIMITED',
    'LIBERO INDUSTRIES PRIVATE LIMITED',
    'PANKAJ OVERSEAS PRIVATE LIMITED',
    'SKIPPING STONES ENTERTAINMENT PRIVATE LIMITED',
    'INDIAN DIRECT SELLING ASSOCIATION',
    'AVIAT NETWORKS (INDIA) PRIVATE LIMITED',
    'DOOSAN POWER SYSTEMS INDIA PRIVATE LIMITED',
    'MARQUIS HOTELS LIMITED',
    'SOMIC ZF COMPONENTS PRIVATE LIMITED',
    'SWASTI POWER PRIVATE LIMITED',
    'SADHARAN KISAN PRODUCER COMPANY LIMITED',
    'CLASSIC CARTONS PRIVATE LIMITED',
    'VIR STUDDIO PRIVATE LIMITED(OPC)',
    'SPARK TECHNOLOGIES PRIVATE LIMITED',
    'FORTUNE MARKETING PRIVATE LIMITED',
    'DEEMA HOLIDAY APARTMENTS PRIVATE LIMITED',
    'WHARTON REAL ESTATE PRIVATE LIMITED',
    'BERKSHIRE REAL ESTATE PRIVATE LIMITED',
    'LA COSTA ENTERPRISES PRIVATE LIMITED',
    '5 CORE ACOUSTICS PRIVATE LIMITED',
    'VSERV INSURANCE SERVICES PRIVATE LIMITED',
    'INDAR MODELS PRIVATE LIMITED',
    'AFFLUENT GRISEL INDIA PRIVATE LIMITED',
    'SCG INTERNATIONAL INDIA PRIVATE LIMITED',
    'BRITTO AMUSEMENTS PRIVATE LIMITED',
    'SYMGRO CHEMICALS PRIVATE LIMITED',
    'CONDOR POLYMERIC PRIVATE LIMITED',
    'MANGAL IRON PRIVATE LIMITED',
    'GRAND BELLEVUE HOTELS & RESORTS PRIVATE LIMITED',
    'DIFD INDUSTRIES PRIVATE LIMITED',
    'SNKMDR INDIA PRIVATE LIMITED',
    'FIDROX TECHNOLOGIES PRIVATE LIMITED',
    'KAZAYA PRIVATE LIMITED',
    'MONKSVILLA ORGANICS PRIVATE LIMITED',
    'PAYAL FARSHAN PRIVATE LIMITED',
    'GUJARAT NARMADA KNITWEAR LTD',
    'HUBERGROUP INDIA PRIVATE LIMITED',
    'MUKESH TRENDS LIFE STYLE LIMITED',
    'SHREE ADDITIVES (PHARMA AND FOODS) PRIVATE LIMITED',
    'KAALNABHA EDUTECH PRIVATE LIMITED',
    'PALLAVI FASHION PRIVATE LIMITED',
    'NITYANAND TEXTILE INDUSTRIES PVT LTD',
    'RY TOURS AND TRAVELS PRIVATE LIMITED',
    'OTSUKA PHARMACEUTICAL INDIA PRIVATE LIMITED',
    'BAY CLOUD SOLUTIONS PRIVATE LIMITED',
    'PARKSHED INDIA PRIVATE LIMITED',
    'SUDEEP PHARMA PRIVATE LIMITED',
    'BIMTECH ENGINEERING SERVICES PRIVATE LIMITED',
    'PANHEERA SOLUTIONS (OPC) PRIVATE LIMITED',
    'L.B. POLYMERS PRIVATE LIMITED',
    'THAMARASSERY ESTATE PRIVATE LIMITED',
    'EVH TECHNOLOGIES PRIVATE LIMITED',
    'ICE DATA SERVICES INDIA PRIVATE LIMITED',
    'ENDUREAIR SYSTEMS PRIVATE LIMITED',
    'MALAYORAM CRUSHER PRIVATE LIMITED',
    'ELOISE ENERGY PRIVATE LIMITED',
    'RUBY REALTORS PRIVATE LIMITED',
    'RAJEEV CHLORIDES AND CARBONICS PRIVATE LIMITED',
    'SKI SPECIALITIES PRIVATE LIMITED',
    'CNFULO (INDIA) PRIVATE LIMITED',
    'ORING INDUSTRIAL NETWORKING PRIVATE LIMITED',
    'TFN ENTERPRISE (OPC) PRIVATE LIMITED',
    'IRSHAD UNITED EXIM PRIVATE LIMITED',
    'BIOFI MEDICAL HEALTHCARE INDIA PRIVATE LIMITED',
    'ENCHANTING TALES HOTELS AND RESORTS PRIVATE LIMITED',
    'JAAZ CORPORATION PRIVATE LIMITED',
    'AUREATE TRADDE PRIVATE LIMITED',
    'LBD LED PRIVATE LIMITED',
    'BOBCAT VALUECHAIN PRIVATE LIMITED',
    'SATHYA WEB SERVICES PRIVATE LIMITED',
    'MANGOBITE HOSPITALITY PRIVATE LIMITED',
    'SWMABHAN COMMERCE PRIVATE LIMITED',
    'STARCO AROCHEM PRIVATE LIMITED',
    'BUDHIMAN ENTERPRISE PRIVATE LIMITED',
    'TRIBHUVAN INDUSTRIES PRIVATE LIMITED',
    'CHEMOCID (INDIA) PRIVATE LIMITED',
    'NEW KANDLA SALT AND CHEMICAL COMPANY PRIVATE LIMITED',
    'DIAMOND SERVICES INDIA PRIVATE LIMITED',
    'TCR ADVANCED ENGINEERING PRIVATE LIMITED',
    'SAHANA & BHARATHI BUSINESS VENTURES PRIVATE LIMITED',
    'ALIAXIS UTILITIES AND INDUSTRY PRIVATE LIMITED',
    'SACMI ENGINEERING (INDIA) PRIVATE LIMITED',
    'TRAMO TECHNOLAB PRIVATE LIMITED',
    'ESSAR POWER (ORISSA) LIMITED',
    'SAMKING MOBILES TECHNOLOGY PRIVATE LIMITED',
    'POWER BUILD PRIVATE LIMITED',
    'OPTIMA DIAMOND TOOLS PRIVATE LIMITED',
    'MAPLE INFRA INVIT INVESTMENT MANAGER PRIVATE LIMITED',
    'REVEST SOLUTIONS PRIVATE LIMITED',
    'KP SOR-URJA LIMITED',
    'ITERA AUTOMOTIVE SOLUTIONS INDIA PRIVATELIMITED',
    'SANKET PROPERTIES PRIVATE LIMITED',
    'KEN FLEXIPACK PRIVATE LIMITED',
    'PRASHANT DEVELOPERS PVT LTD',
    'WORLDWIDE IMPEX PRIVATE LIMITED',
    'ALLRIGHT TRADING PRIVATE LIMITED',
    'GIRIRAJ FIBRES PVT LTD',
    'ROYAL TILES PVT LTD',
    'AJMERA CEMENTS PRIVATE LIMITED',
    'PATEL TECHNOMATION PRIVATE LIMITED',
    'RAINOX WIREMESH PRIVATE LIMITED',
    'OPEX ANALYTICS PRIVATE LIMITED',
    'POLLUX LOGISTICS PRIVATE LIMITED',
    'RAVI LIFESCIENCES PRIVATE LIMITED',
    'VK JEWELS PRIVATE LIMITED',
    'TALENT MAYA (OPC) PRIVATE LIMITED',
    'VISSOL VASSU TECH SERVICES PRIVATE LIMITED',
    'AMSS DEFINE URBAN ECOLOGICAL DESIGN PRIVATE LIMITED',
    'SPARK INFRABUILD PRIVATE LIMITED',
    'AMERICAN MEGATRENDS INTERNATIONAL INDIA PRIVATE LIMITED',
    'BITECQ TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'SKL DEMAND PRIVATE LIMITED',
    'DREAMFUSION TECHNOLOGIES PRIVATE LIMITED',
    'EDIFYING VOYAGES PRIVATE LIMITED',
    'PWR HYDRAULICS AND SYSTEM PRIVATE LIMITED',
    'BLAKOMI PRIVATE LIMITED',
    'FLYFOX FOREX PRIVATE LIMITED',
    'GREENLINE MEDIA SERVICES PRIVATE LIMITED',
    'TRISO VIDEO INDIA PRIVATE LIMITED',
    'FERRGRA ENTERPRISES PRIVATE LIMITED',
    'MARACANA SDC PRIVATE LIMITED',
    'NIAM VENTURES PRIVATE LIMITED',
    'AEKOM MARINE PRIVATE LIMITED',
    'ETHDC TECHNOLOGIES PRIVATE LIMITED',
    'INAAY INFOTECH PRIVATE LIMITED',
    'CHEVICHEF PRIVATE LIMITED',
    'UTTAMENERGY PHILANTHROPIC FOUNDATION',
    'BIZDATA ADVANCED SOFTWARE PRIVATE LIMITED',
    'MAGMAR LOGISTICS PRIVATE LIMITED',
    'HOYA BELLA DISTRIBUTION PRIVATE LIMITED',
    'DPHT CONSULTANCY SERVICES PRIVATE LIMITED',
    'FANPORT NEWS MEDIA PRIVATE LIMITED',
    'DROR LABS PRIVATE LIMITED',
    'OXYPC COMPUTERS PRIVATE LIMITED',
    'AEII PRIVATE LIMITED',
    'CODESK VENTURE PRIVATE LIMITED',
    'TEAL DOOR DESIGNS PRIVATE LIMITED',
    'INCLUSION FIRST CONSULTANCY PRIVATE LIMITED',
    'EUDOXIA EDUCATION PRIVATE LIMITED',
    'GREENSHIFT INITIATIVES PRIVATE LIMITED',
    'MOTIONLAB TECHNOLOGIES PRIVATE LIMITED',
    'SAMGO ENGINEERING PRIVATE LIMITED',
    'LETSMARK TRADECO PRIVATE LIMITED',
    'BLUECON INFRA DEVELOPMENT PRIVATE LIMITED',
    'DVG SUPPORTIVE INDIA HR SOLUTIONS PRIVATE LIMITED',
    'AVO ENERGY INDIA PRIVATE LIMITED',
    'ALPHAAVITTOS (OPC) PRIVATE LIMITED',
    'CHESHTA CARE FOUNDATION',
    'MVALU TECHNOLOGY SERVICES PRIVATE LIMITED',
    'NK REMEDIES PRIVATE LIMITED',
    'FLS ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'DHARWAD BIG MISHRA PEDHA PRIVATE LIMITED',
    'KMEEN AGRO PRIVATE LIMITED',
    'VOICERA ANALYTICS PRIVATE LIMITED',
    'GRAPHENE TECHPRO INDIA PRIVATE LIMITED',
    'DVYYUH XPERTIN PRIVATE LIMITED',
    'BLEMOT AUTOMOBILE TECHNOLOGY PRIVATE LIMITED',
    'ADAMS INDUSTRIES & LOGISTICS LIMITED',
    'PARP AGRITECH PRIVATE LIMITED',
    'UTSARG FARMER PRODUCER COMPANY LIMITED',
    'TOPSYS IT PRIVATE LIMITED',
    'IMPROBABLE SOLUTIONS (OPC) PRIVATE LIMITED',
    'HASHFUSE SOLUTIONS PRIVATE LIMITED',
    'PRANJAL CAR RENTAL SERVICES PRIVATE LIMITED',
    'UPTOWN INFINITY PRIVATE LIMITED',
    'UPWORD FOUNDATION',
    'GANDHAR COALS & MINES PRIVATE LIMITED',
    'ISHITVA ROBOTIC SYSTEMS PRIVATE LIMITED',
    'AREION ASSETS MANAGEMENT PRIVATE LIMITED',
    'FUNTA NETWORK SERVICE PRIVATE LIMITED',
    'COIND ANTI-POLLUTION SYSTEMS PRIVATE LIMITED',
    'ASY ENGINEERING PRIVATE LIMITED',
    'INYT TECHNOLOGIES PRIVATE LIMITED',
    'WAASANG SOLAR ONE PRIVATE LIMITED',
    'NUCLEAR COMMUNICATIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'TOPPEQ TECH PRIVATE LIMITED',
    'RAFAY SYSTEMS PRIVATE LIMITED',
    'FUTURE BIM PRIVATE LIMITED',
    'KREEZ NIDHI LIMITED',
    'NURTURE MERIT PRIVATE LIMITED',
    'PENPENNY INFOTECH PRIVATE LIMITED',
    'ART URBA LANDSCAPE INDIA PRIVATE LIMITED',
    'CHAPTERONE BOOKSTORES AND INTERNET PRIVATE LIMITED',
    'MELLONA TRADING PRIVATE LIMITED',
    'IONIC FINTECH PRIVATE LIMITED',
    'AIRBLUE SHIPPING PRIVATE LIMITED',
    'ARPAN EDUTECH PRIVATE LIMITED',
    'ZOMEX DIGITAL PRIVATE LIMITED',
    'SEAWAYS SUPPLY CHAIN PRIVATE LIMITED',
    'ESJAYPEE MERCANTILE GLOBAL PRIVATE LIMITED',
    'RFPIO INDIA PRIVATE LIMITED',
    'GORAX ORGANICS PRIVATE LIMITED',
    'GPC AGROCHEMICALS PRIVATE LIMITED',
    'NISAR UNNABI KHAN FOUNDATION',
    'KICKBACK INNOVATIONS BEVERAGES PRIVATE LIMITED',
    'GRITTY FOODWORKS PRIVATE LIMITED',
    'AVASANT ADVISORY INDIA PRIVATE LIMITED',
    'ACINONYX TECHNOLOGIES PRIVATE LIMITED',
    'NAVICLICKS PRIVATE LIMITED',
    'BELLKUNDA CONSTRUCTION PRIVATE LIMITED',
    'ARCHISMAN INFRATECH INDIA PRIVATE LIMITED',
    'WISDOM OILS & FATS EXPORTS PRIVATE LIMITED',
    'DIGITOP DIGITAL TRANSFORMATION CONSULTING SERVICES PRIVATE LIMITED',
    'TECL TECHNOLOGIES PRIVATE LIMITED',
    'AVER CONSULTING AND OUTSOURCING PRIVATE LIMITED',
    'SHARMA AGRICULTURE PRODUCTS PRIVATE LIMITED',
    'E-WAY FURNITURE SYSTEMS PRIVATE LIMITED',
    'MYCLASSROOM LEARNING SERVICES PRIVATE LIMITED',
    'CREDENCA DATA SOLUTIONS PRIVATE LIMITED',
    'SPACES AND BETWEEN PRIVATE LIMITED',
    'GRATIZE VENTURE CONSULTING SERVICES PRIVATE LIMITED',
    'APARNA INSYS PRIVATE LIMITED',
    'VARV SOLUTIONS PRIVATE LIMITED',
    'VMUGHILSAI TELECOMMUNICATION PRIVATE LIMITED',
    'FLOWINDATA TECHNOLOGY PRIVATE LIMITED',
    'ADVANCED MARITIME TRANSPORTS INDIA PRIVATE LIMITED',
    'FARSIGHT WELFARE FOUNDATION',
    'NAICON FMS PRIVATE LIMITED',
    'GERALD CHEMICALS AND TRADING PRIVATE LIMITED',
    'NEEV ENERTECH INTERNATIONAL PRIVATE LIMITED',
    'CODOID INNOVATIONS PRIVATE LIMITED',
    'DV ARENA BUILDTECH PRIVATE LIMITED',
    'FARMONIC BIOTECH PRIVATE LIMITED',
    'AUBRIETIA PHARMACEUTICALS PRIVATE LIMITED',
    'ES NEPTUNE SOLAR PRIVATE LIMITED',
    'ONE CHAMPIONSHIP INDIA PRIVATE LIMITED',
    'EDISAFE LOGISTICS PRIVATE LIMITED',
    'CORROSION CURES PRIVATE LIMITED',
    'JAYASURIYA AERO PRIVATE LIMITED',
    'SAMBHUTI ADVISORY SERVICES PRIVATE LIMITED',
    'PALASA FARMS PRIVATE LIMITED',
    'IDOMIT SOLUTIONS PRIVATE LIMITED',
    'ZUINK SMART MOBILITY SOLUTIONS PRIVATE LIMITED',
    'DENOUER MMC PRIVATE LIMITED',
    'UD DIGILINE PRIVATE LIMITED',
    'HRC RECREATION CHAMBERS',
    'RIDHAN TECHNOLOGIES PRIVATE LIMITED',
    'EVALGO PRIVATE LIMITED',
    'ORION NUTRITIONALS PRIVATE LIMITED',
    'AURUM FACILITY MANAGEMENT PRIVATE LIMITED',
    'GRANTEK SYSTEMS INDIA PRIVATE LIMITED',
    'LMN SYSTEMS PRIVATE LIMITED',
    'SAPTAMI INFOTECH PRIVATE LIMITED',
    'CAVIAAR FASHION PRIVATE LIMITED',
    'VAMAZA RETAIL INDIA PRIVATE LIMITED',
    'CBP SOLUTIONS PRIVATE LIMITED',
    'AJATH INFOTECH PRIVATE LIMITED',
    'PARTHIV CAPITAL PRIVATE LIMITED',
    'SHORTSTV NETWORKS INDIA PRIVATE LIMITED',
    'BLUENEBA TECHNOLOGIES PRIVATE LIMITED',
    'SCINTELLECT SERVICES PRIVATE LIMITED',
    'GOLDEN EYE DIAMOND MINING PRIVATE LIMITED',
    'MEG RUBBER SEALING TECHNOLOGIES PRIVATE LIMITED',
    'SUBH LABH ENGINEERING PRIVATE LIMITED',
    'CREDITREPAIRCLOUD INDIA PRIVATE LIMITED',
    'SUNSPLASH ENTERTAINMENT PRIVATE LIMITED',
    'ADANI NYK AUTO LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'QUANTUMTEQ DISTRIBUTION INDIA PRIVATE LIMITED',
    'BEDRE WEB TECHNOLOGIES PRIVATE LIMITED',
    'DINCLIX GROUNDWORKS PRIVATE LIMITED',
    'FACILE LEARNING PRIVATE LIMITED',
    'LUCRATIVE FOODS PRIVATE LIMITED',
    'CRAVE INFORMATION PRIVATE LIMITED',
    'REMBARRIER ADVISORS PRIVATE LIMITED',
    'FOUNTANE MAKERSPACE PRIVATE LIMITED',
    'SACHIN TENDULKAR FOUNDATION',
    'FILOSGEOMETRIA TECHNOLOGIES PRIVATE LIMITED',
    'SUNTECT PRODUCTION INDIA PRIVATE LIMITED',
    'DISHA ECOLOC PAVERS PRIVATE LIMITED',
    'ALANTA EXIM PRIVATE LIMITED',
    'MANDRILL INTERIORS & DESIGNS PRIVATE LIMITED',
    'MAD ASN PHARMA PRIVATE LIMITED',
    'FOSHAN TEEHOO H INOX PRIVATE LIMITED',
    'TUTOROOT TECHNOLOGIES PRIVATE LIMITED',
    'MINDOSE CONSULTING SERVICES PRIVATE LIMITED',
    'GREENATIVE PETROCHEM PRIVATE LIMITED',
    'LPEC INDIA PRIVATE LIMITED',
    'TORRAUTOMATION SYSTEMS PRIVATE LIMITED',
    'CUBE SHIPPING PRIVATE LIMITED',
    'EDISN MEDIA AND TECH SOLUTIONS PRIVATE LIMITED',
    'NEUBERG A. G DIAGNOSTICS PRIVATE LIMITED',
    'SINGAPORE SYNCHROSKILLS PRIVATE LIMITED',
    'EONAIR TECHNOLOGIES PRIVATE LIMITED',
    'AIRASIA TECHNOLOGY CENTRE INDIA PRIVATE LIMITED',
    'KAY BEE EXPORTS HOLDINGS PRIVATE LIMITED',
    'AANURAJ FASTENERS PRIVATE LIMITED',
    'DHONE WHEELS PRIVATE LIMITED',
    'OEPP INNOVATIONS PRIVATE LIMITED',
    'JEE-CARTER FOODTECH PRIVATE LIMITED',
    'ECOKSHETRA PRIVATE LIMITED',
    'UPSIDE LMS HRTECH PRIVATE LIMITED',
    '4PI INFOTECH INDIA PRIVATE LIMITED',
    'BASK FASHIONS INDIA PRIVATE LIMITED',
    'GOLDEN BRIDGE FILMS & ENTERTAINMENT PRIVATE LIMITED',
    'GREENIUS FOOD RECYCLER PRIVATE LIMITED',
    'HEMANG SCHNELL GLOBAL PRIVATE LIMITED',
    'BRINGAR RESEARCH & DEVELOPMENT (OPC) PRIVATE LIMITED',
    'YUZEN MOBILITY PRIVATE LIMITED',
    'VOKA COFFEE PRIVATE LIMITED',
    'CARS24 FINANCIAL SERVICES PRIVATE LIMITED',
    'AV MATTERS DISTRIBUTION PRIVATE LIMITED',
    'AROGYA MEALS PRIVATE LIMITED',
    'QOGNO DIGITAL INFRASTRUCTURE PRIVATE LIMITED',
    'OLON ACTIVE PHARMACEUTICAL INGREDIENTS INDIA PRIVATE LIMITED',
    'FORSTAR HARIOM AGRO FOODS PRIVATE LIMITED',
    'POWERGRID BHIND GUNA TRANSMISSION LIMITED',
    'SEERA WOOD ENTERPRISES PRIVATE LIMITED',
    'TB BUSINESS ADVISORY PRIVATE LIMITED',
    'AAK MARKETING SERVICES PRIVATE LIMITED',
    'METLUCK CONSTRUCTION PRIVATE LIMITED',
    'MYLAPRA HOSPITALITY PRIVATE LIMITED',
    'BNB CONCEPTS PRIVATE LIMITED',
    'MOONLAB TECHNOLOGIES PRIVATE LIMITED',
    'PRAMOD CHAUDHARY MANAGEMENT SERVICES PRIVATE LIMITED',
    'RIYASA INNOVATIONS PRIVATE LIMITED',
    'DELICATESSEN ENGINEERING SERVICES PRIVATE LIMITED',
    'PONTUS FREIGHT INDIA PRIVATE LIMITED',
    'NATHANIYA FOODS PRIVATE LIMITED',
    'SUDARSHANFAMILY MALL PRIVATE LIMITED',
    'BUNAAI WHITEOFFICIAL PRIVATE LIMITED',
    'CORAL PERFUMES PRIVATE LIMITED',
    'VYUSHTI WAREHOUSING PRIVATE LIMITED',
    'BENSAW TECHNOLOGIES PRIVATE LIMITED',
    'DEZHAB DESIGN AND CONSTRUCTION PRIVATE LIMITED',
    'EMDEE AVIATION PRIVATE LIMITED',
    'VALTUTE MEDIA PRIVATE LIMITED',
    'KRIYATEK DELIVERY SERVICES PRIVATE LIMITED',
    'SUDHAMOY AGRO INDUSTRY PRIVATE LIMITED',
    'XETLYNX AUTOCORP PRIVATE LIMITED',
    'ZEDILAB SOFTWARE SYSTEMS PRIVATE LIMITED',
    'DEBQEE BIOTEC PRIVATE LIMITED',
    'MENRICO LIFESTYLE PRIVATE LIMITED',
    'SG CAPHOLDING INDIA PRIVATE LIMITED',
    'LOOPXS MUSIC PRIVATE LIMITED',
    'FLYD AEROSPARES PRIVATE LIMITED',
    'FITEC HYDRAULIC PRIVATE LIMITED',
    'SAYANI STEEL PRIVATE LIMITED',
    'ALG INDIA ENTERPRISES PRIVATE LIMITED',
    'FULLSCOOP DIGITAL PRIVATE LIMITED',
    'MINDSMIRATUS TECHNOLOGIES PRIVATE LIMITED',
    'NIVAHATA TECHNOLOGIES PRIVATE LIMITED',
    'LUNA APPARELS PRIVATE LIMITED',
    'GALEFORD FASHION PRIVATE LIMITED',
    'MAHAVEER DISPOTECH PRIVATE LIMITED',
    'AMSTRAD CONSUMER INDIA PRIVATE LIMITED',
    'MAUVE ENGINEERING AND SERVICES PRIVATE LIMITED',
    'ARVENSIS JAYAAM INDIA PRIVATE LIMITED',
    'JOKER FOAM PRIVATE LIMITED',
    'AVAADA CLEAN KNPROJECT PRIVATE LIMITED',
    'NATEMS POWER ANANTAPUR PRIVATE LIMITED',
    'NATEMS POWER MAHA PRIVATE LIMITED',
    'NATEMS POWER TADIPATRI PRIVATE LIMITED',
    'YOGAYATAN E-WASTE RECYCLING PRIVATE LIMITED',
    'AGP CGD INDIA PRIVATE LIMITED',
    'KIRTAN HOLIDAYS PRIVATE LIMITED',
    'FOLLOWFOOTS VACATION PRIVATE LIMITED',
    'BLEIOTECH PRIVATE LIMITED',
    'SZS TECH PRIVATE LIMITED',
    'PSD LIFE SCIENCES PRIVATE LIMITED',
    'KEYGAP SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PANTOMATH ASSET MANAGEMENT HOLDINGS PRIVATE LIMITED',
    'GREENRX INDIA PRIVATE LIMITED',
    'NAKKSHATRA HOUSING FINANCE PRIVATE LIMITED',
    'PANTOMATH CAPITAL MANAGEMENT PRIVATE LIMITED',
    'THRIVERA STAFFING SERVICES PRIVATE LIMITED',
    'MAK LIFE PRODUCER COMPANY LIMITED',
    'LUCENTA SOLUTIONS TECHNOLOGIES PRIVATE LIMITED',
    'HASHTAGME APPAREL AND FASHION PRIVATE LIMITED',
    'SAKHSHAM KNOWLEDGE SERVICES PRIVATE LIMITED',
    'SINUOS INFRA PRIVATE LIMITED',
    'KSS MEDICALCARE PRIVATE LIMITED',
    'ESSENAS ENTERPRISES PRIVATE LIMITED',
    'OYSTER CRM PRIVATE LIMITED',
    'SIDDHU CONSULTANCY SERVICES PRIVATE LIMITED',
    'KYOG MENTOR NETWORK PRIVATE LIMITED',
    'MAITRA MARKET RESEARCH PRIVATE LIMITED',
    'DGLIGER CONSULTING PRIVATE LIMITED',
    'CHALOJEE HOSPITALITY PRIVATE LIMITED',
    'VOKAB TECHNOLOGIES PRIVATE LIMITED',
    'KOSEI MINDA MOULD PRIVATE LIMITED',
    'SVAYA ROBOTICS PRIVATE LIMITED',
    'TENCOM VENTURES PRIVATE LIMITED',
    'INNOBUILD ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'CRESTEC DIGITAL SOLUTION INDIA PRIVATE LIMITED',
    'EMPEZAR SOFTWARE LABS PRIVATE LIMITED',
    'CONTINENTAL LIGHTING INDIA PRIVATE LIMITED',
    'BBCO RETAIL PRIVATE LIMITED',
    'IELDTECH CONSULTANCY PRIVATE LIMITED',
    'JJG AERO PRIVATE LIMITED',
    'SIBIN VENTURES PRIVATE LIMITED',
    'SASK ENGINEERING PRIVATE LIMITED',
    'BNP PARIBAS INDIA FOUNDATION',
    'VN AGRO SCIENCE PRIVATE LIMITED',
    'PI DIGITAL MEDIA NETWORK PRIVATE LIMITED',
    'SCIGENOM LIFESCIENCES PRIVATE LIMITED',
    'EMURON TECHNOLOGIES PRIVATE LIMITED',
    'OM SATYANARAYAN BUILDCON PRIVATE LIMITED',
    'AMPSOLAR RENEWABLE ENERGY PRIVATE LIMITED',
    'DIGSYCOM DATA INDIA PRIVATE LIMITED',
    'ISTAKAPAZA PRIVATE LIMITED',
    'TOP SHELF ONLINE MARKETING (INDIA) PRIVATE LIMITED',
    'EIGHTY22 ENGAGEMENT SERVICES PRIVATE LIMITED',
    'MERILENT INTERACTIVE INSIGHT PRIVATE LIMITED',
    'LIVEPERSON INDIA PRIVATE LIMITED',
    'ANTIFRAGILE ENERGY PRIVATE LIMITED',
    'UPLAY DUCATE SOLUTIONS PRIVATE LIMITED',
    'TELEPRESENT VR PRIVATE LIMITED',
    'ADVENTUM ADVANCED SOLUTIONS PRIVATE LIMITED',
    'WORKINGDOM OFFICE SOLUTIONS PRIVATE LIMITED',
    'ALTRADIMENSION TECHNOLOGIES PRIVATE LIMITED',
    'NEWMO ADVISERS PRIVATE LIMITED',
    'DIGIBLADE STRATEGIC ADVISORY PRIVATE LIMITED',
    'FULFILMENT EXECUTION SERVICES PRIVATE LIMITED',
    'CHC NAVIGATION INDIA PRIVATE LIMITED',
    'MOBIDISCOVER DIGITAL MEDIA PRIVATE LIMITED',
    'RO ASSETS AND REALTY PRIVATE LIMITED',
    'NEKITECH BIZHUB PRIVATE LIMITED',
    'PPG INNOVATIONS (OPC) PRIVATE LIMITED',
    'HIMNI RESIDENCY PRIVATE LIMITED',
    'SANIGEN GLOBAL CHEMICALS PRIVATE LIMITED',
    'MADHAV NATURAL STONE SURFACES PRIVATE LIMITED',
    'EDUMAVEN ACADEMY PRIVATE LIMITED',
    'ELEKTRINA INDIA PRIVATE LIMITED',
    'SENSITIVE SUPPLY CHAIN LOGISTICS LIMITED',
    'EXPRS TECHNO LOGISTICS PRIVATE LIMITED',
    'BEETRULES INTERNATIONAL PRIVATE LIMITED',
    'AJSS INNOVATORS PRIVATE LIMITED',
    'FOURTREK HEALTHCARE PRIVATE LIMITED',
    'ANAPURNA SHIPPING PRIVATE LIMITED',
    'TANWAR POLL SERVICES PRIVATE LIMITED',
    'NEUGEN BIOLOGICALS PRIVATE LIMITED',
    'FOXGLOVE CONNECT PRIVATE LIMITED',
    'HEALTHTAP SOFTWARE PRIVATE LIMITED',
    'SARVEKA COLLECTIVE PRIVATE LIMITED',
    'PET CT ST DIAGNOSTIC PRIVATE LIMITED',
    'NAWAH ADVANCED MEDICAL SOLUTIONS PRIVATELIMITED',
    'ONETOWN ENGINEERING PRIVATE LIMITED',
    'ACQUISTA CONSULTING PRIVATE LIMITED',
    'KONKAN TECHNICAL PRIVATE LIMITED',
    'BLUECORE SOFTWARE PRIVATE LIMITED',
    'TSS STAFFING SOLUTIONS PRIVATE LIMITED',
    'TEAMLEASE REGTECH PRIVATE LIMITED',
    'DARI CONSULTANCY PRIVATE LIMITED',
    'REDSEAL MOTION PICTURES PRIVATE LIMITED',
    'ESARJEY MEDIA VENTURE PRIVATE LIMITED',
    'PINE COLLECTIONS PRIVATE LIMITED',
    'PARYAPT SOLAR ENERGY PRIVATE LIMITED',
    'EUPEP TECHNOLOGIES PRIVATE LIMITED',
    'TECHNATIVE CONSULTANCY SERVICES PRIVATE LIMITED',
    'AGRIREV TECHNOLOGIES PRIVATE LIMITED',
    'RHOBIX TECHNOLOGIES PRIVATE LIMITED',
    'SPINNZ FOODS PRIVATE LIMITED',
    'TVS EDUCATIONAL AND TRAINING SERVICES PRIVATE LIMITED',
    'RURBAN CLEANTECH PRIVATE LIMITED',
    'HARISON GENERATORS PRIVATE LIMITED',
    'GAYALI SOFTWARE PRIVATE LIMITED',
    'APOLLO PHARMALOGISTICS PRIVATE LIMITED',
    'DIRE SURVEILLANCE PRIVATE LIMITED',
    'CLAY TECHSYSTEMS CONSULTING PRIVATE LIMITED',
    'MORLATIS ENGINEERING AND CONSTRUCTION PRIVATE LIMITED',
    'LIVSYSDEVICES INDIA PRIVATE LIMITED',
    'BTCPL MUMBAI PRIVATE LIMITED',
    'TACTOTA (OPC) PRIVATE LIMITED',
    'SWARNA SATNAM TRANSPORT SERVICES PRIVATELIMITED',
    'ARDENTLEARNING PRIVATE LIMITED',
    'SMARD BUILDING SOLUTIONS PRIVATE LIMITED',
    'GENIEROBO LEARNING PRIVATE LIMITED',
    'TRANSERVES MANAGEMENT PRIVATE LIMITED',
    'DINSUN INFRAPROJECTS PRIVATE LIMITED',
    'VITARTHA TRADING PRIVATE LIMITED',
    'VARA FINANCE PRIVATE LIMITED',
    'AMPSOLAR CLEAN POWER PRIVATE LIMITED',
    'SYNAPTICS LABS PRIVATE LIMITED',
    'PEEK AND CLOPPENBURG FASHION INDIA PRIVATE LIMITED',
    'BIDANI BUILDERS PRIVATE LIMITED',
    'ALKA PHARMACY PRIVATE LIMITED',
    'SUGATU INFRA PRIVATE LIMITED',
    'GOOD POWER INDUSTRIES PRIVATE LIMITED',
    'OPEN ART PROJECT DIGITAL PRIVATE LIMITED',
    'HUDSON ADVISORS (INDIA) PRIVATE LIMITED',
    'GENO CONSULTING SERVICES PRIVATE LIMITED',
    'BTB TRAVEL TECH PRIVATE LIMITED',
    'EKLOUDYY DATAMATICS PRIVATE LIMITED',
    'STELLARSN IT SERVICES PRIVATE LIMITED',
    'ACTMODE TELECOM PRIVATE LIMITED',
    'PRATAP DIGITAL COMMUNICATIONS PRIVATE LIMITED',
    'BUCKZY PAYMENTS PRIVATE LIMITED',
    'VEERWAL GETWORK SERVICES PRIVATE LIMITED',
    'VINCLAN TECHNOLOGIES PRIVATE LIMITED',
    'CREDICON INDUSTRIES PRIVATE LIMITED',
    'ELSHADDAI ENGINEERING (INDIA) PRIVATE LIMITED',
    'SHKAVA CONTAINER LINE PRIVATE LIMITED',
    'PADAH SOLUTIONS PRIVATE LIMITED',
    'VIKASH FLEXIPACK PRIVATE LIMITED',
    'ADANI SOLAR ENERGY CHITRAKOOT ONE LIMITED',
    'GIMATIC AUTOMATION INDIA PRIVATE LIMITED',
    'SHARMA HOMETEX PRIVATE LIMITED',
    'INTERNATIONAL HOTEL SUPPLY (INDIA) PRIVATE LIMITED',
    'BHUJ WIND ENERGY PRIVATE LIMITED',
    'ANAHATA ART AND DESIGN PRIVATE LIMITED',
    'AGILITICS EDUTECH PRIVATE LIMITED',
    'KEYOTECH PRIVATE LIMITED',
    'SATYAMEV INFOTECH PRIVATE LIMITED',
    'ANOMALOUS INFRA PRIVATE LIMITED',
    'INTELLIGENT DIGITAL NETWORK PRIVATE LIMITED',
    'MEKASA PRODUCTS PRIVATE LIMITED',
    'MONESTO PLAST PRODUCTS PRIVATE LIMITED',
    'BOUNTY CONTAINER LINES PRIVATE LIMITED',
    'PARAENT TECHNICAL PRODUCTS INDIA PRIVATELIMITED',
    'ALIFCON PHARMACEUTICAL PRIVATE LIMITED',
    'CSE SOLAR SUNPARK TAMIL NADU PRIVATE LIMITED',
    'EMBEBO HEALTHCARE SERVICES PRIVATE LIMITED',
    'INNOVAE3D PRIVATE LIMITED',
    'FLASH CAPITAL PRIVATE LIMITED',
    'OPTIPERSYS CONSULTING PRIVATE LIMITED',
    'TAGNOS-IND PRIVATE LIMITED',
    'GRAINSPAN FOODS PRIVATE LIMITED',
    'F2T SUPERFRESH PRIVATE LIMITED',
    'UNDER ARMOUR INDIA TRADING PRIVATE LIMITED',
    'TORTA FOODS PRIVATE LIMITED',
    'ESTERLINA SOLAR ENGINEERS PRIVATE LIMITED',
    'ARCUS VENTURES PRIVATE LIMITED',
    'QBLER TECHNOLABS PRIVATE LIMITED',
    'PROFITPLUS INFRA PRIVATE LIMITED',
    'FOUNTAIN9 PRIVATE LIMITED',
    'INA CASTINGS PRIVATE LIMITED',
    'SUHESH TECHNOLOGIES PRIVATE LIMITED',
    'PARANTAPA SCIENCES PRIVATE LIMITED',
    'DEALMONEY REAL ESTATE PRIVATE LIMITED',
    'SIMPLE BOAT CLUB INDIA PRIVATE LIMITED',
    'VESUVIUS IT AND SHARED SERVICES PRIVATE LIMITED',
    'MOBIL80 SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'AUTOSTRINGS PRIVATE LIMITED',
    'DVISUS INTERNET (OPC) PRIVATE LIMITED',
    'MYPREFERRED TRANSFORMATION AND HOSPITALITY PRIVATE LIMITED',
    'TMS ALOXIN GLOBAL MANUFACTURING PRIVATE LIMITED',
    'BOOKMYSHOW VENUES MANAGEMENT PRIVATE LIMITED',
    'MOBILIX SOLUTIONS PRIVATE LIMITED',
    'MARICHI INVESTMENTS PRIVATE LIMITED',
    'KBROS ARISTO PRIVATE LIMITED',
    'TRIANGLE WEAVERS PRIVATE LIMITED',
    'FOUNDATION FOR REINVENTING GOVERNANCE',
    'AMOS TRAVEL MARKETING PRIVATE LIMITED',
    'UDDHARANA TECH PRIVATE LIMITED',
    'SPRIGGEN GARDENER PRIVATE LIMITED',
    'UTRACON CONSTRUCTION PRIVATE LIMITED',
    'AFFIH NETWORK PRIVATE LIMITED',
    'ASSEMTICA ROBOTICS PRIVATE LIMITED',
    'OKTOBER6 INSIGHT PRIVATE LIMITED',
    'NEOVATIC TECHNOLOGIES PRIVATE LIMITED',
    'IROHUB INFOTECH PRIVATE LIMITED',
    'RANLIN REMEDIES PRIVATE LIMITED',
    'CAPSYSTEMATIC TECHNOLOGIES PRIVATE LIMITED',
    'LOTTE CHEMICAL ENGINEERING PLASTICS (HARYANA) PRIVATE LIMITED',
    'VINDERAA ROBOTICS (OPC) PRIVATE LIMITED',
    'ADM FOUNDATION',
    'BLASER SWISSLUBE SOLUTIONS PRIVATE LIMITED',
    'CURRY STONE DESIGN FOUNDATION',
    'TRILOKESH MANAGEMENT CONSULTING PRIVATE LIMITED',
    'TOPSOCIAL COMMUNICATION PRIVATE LIMITED',
    'VOLTREZ TECH PRIVATE LIMITED',
    'ANAVCLOUDS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PARAGON FINE AND SPECIALITY CHEMICAL LIMITED',
    'INDIE VIBES HOSPITALITY PRIVATE LIMITED',
    'RACE2EXCELLENCE PRIVATE LIMITED',
    'PROSPECTIVE ANALYTICS PRIVATE LIMITED',
    'GIARDINO ARCADIA FOUNDATION',
    'INTERSHIPPING SERVICES HUB PRIVATE LIMITED',
    'ASIAN-AFRICAN CHAMBER OF COMMERCE & INDUSTRY FOUNDATION',
    'TUG OF TOONZ PRIVATE LIMITED',
    'TRIPEPS MANAGEMENT PRIVATE LIMITED',
    'PAWANSH INTERNATIONAL PRIVATE LIMITED',
    'CONFIDAYS HYGIENE PRODUCTS PRIVATE LIMITED',
    'FUTURELIFE SUPER FOODS PRIVATE LIMITED',
    'LIRISOFT INDIA PRIVATE LIMITED',
    'HORIZON REFRACTORIES PRIVATE LIMITED',
    'CONSORT HARDWARE PRIVATE LIMITED',
    'XUVI TECHNOLOGY LABS PRIVATE LIMITED',
    'INTELLICRUNCH PRIVATE LIMITED',
    'THEOXENY HOSPITALITY PRIVATE LIMITED',
    'AQYSTA IRRIGATION INDIA PRIVATE LIMITED',
    'INVERGENCE ANALYTICS PRIVATE LIMITED',
    'MASSTRANS TECHNOLOGIIES PRIVATE LIMITED',
    'ICHICARE FOUNDATION',
    'EDIMV PRIVATE LIMITED',
    'GERIZIM TECHNOLOGIES PRIVATE LIMITED',
    'ELYON DIVINE COMPONENTS PRIVATE LIMITED',
    'SUISSE RANKS PRIVATE LIMITED',
    'ACCTEEZ SERVICES INDIA PRIVATE LIMITED',
    'ESOMOIRE PRIVATE LIMITED',
    'BIG LOYALTY INDIA PRIVATE LIMITED',
    'SUNON MODULAR INDIA PRIVATE LIMITED',
    'ANGYAL (OPC) PRIVATE LIMITED',
    'SHERLOCK TRADELINK PRIVATE LIMITED',
    'TELMA INDUCTION BRAKES PRIVATE LIMITED',
    'PRATAP FOUNDATIONS PRIVATE LIMITED',
    'BARRON TECH SERVE PRIVATE LIMITED',
    'QUINTEZE TRAVELS INDIA PRIVATE LIMITED',
    'DEWESOFT INDIA PRIVATE LIMITED',
    'BOOKMAFIYA STUDY SOLUTIONS PRIVATE LIMITED',
    'HERB ARTIZAN PRIVATE LIMITED',
    'ARIHANT PANEL FITTINGS PRIVATE LIMITED',
    'CULTUREGRADE TECHNOLOGIES PRIVATE LIMITED',
    'FINTUPLE TECHNOLOGIES PRIVATE LIMITED',
    'GALLIVE INFOTECH LIMITED',
    'BONGOSIKHA PRIVATE LIMITED',
    'DWAARKESH EXIM (OPC) PRIVATE LIMITED',
    'SAMPURNATA SUSTAINABLE SOLUTIONS PRIVATELIMITED',
    'IKSEER SKIN ESSENTIALS PRIVATE LIMITED',
    'TASAN INDUSTRIAL PRIVATE LIMITED',
    'INDIC FOUNDATION AND INSTITUTE',
    'SKROMAN TECHNOLOGIES PRIVATE LIMITED',
    'WAY BEYOND RETAILS PRIVATE LIMITED',
    'GABHASTI TECHNOLOGY PRIVATE LIMITED',
    'ARICO INFRATECH PRIVATE LIMITED',
    'SWEEDESI TECHNOLOGIES PRIVATE LIMITED',
    'ROBIN SOFTWARE DEVELOPMENT CENTER INDIA PRIVATE LIMITED',
    'FAE BEAUTY PRIVATE LIMITED',
    'RICHVID FOOD AND BEVERAGES PRIVATE LIMITED',
    'S.S EXIM AND TRADING INDIA PRIVATE LIMITED',
    'SMARTENOUGH SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'CITI SOLUTIONS FREIGHT FORWARDING PRIVATE LIMITED',
    'TOP FORCE SECURITY SOLUTIONS INDIA PRIVATE LIMITED',
    'ARZNEI-ALFA PHARMA PRIVATE LIMITED',
    'ANIMUS VENTURES PRIVATE LIMITED',
    'HEWITECH PLASTICS PRIVATE LIMITED',
    'XONGL CLOUD PRIVATE LIMITED',
    'ANVA STYLES PRIVATE LIMITED',
    'TTD LOGISTICS PRIVATE LIMITED',
    'KALSON HOLIDAYS AND SUITES PRIVATE LIMITED',
    'WELDOMAC ENGINEERING PRIVATE LIMITED',
    'SKICE DECOR PRIVATE LIMITED',
    'MAAN-PRATAP MOBILITIES PRIVATE LIMITED',
    'JSW PROCESSORS & TRADERS PRIVATE LIMITED',
    'CABLE AND WIRE MACHINERY MANUFACTURER ASSOCIATION OF INDIA',
    'IOJO FASHION PRIVATE LIMITED',
    'SPECTAR DIGI SERVICES PRIVATE LIMITED',
    'ACDC ALLIANCE PRIVATE LIMITED',
    'SYMBIOTE HEALTHTECH PRIVATE LIMITED',
    'SHUBHAMINDS SOLUTIONS PRIVATE LIMITED',
    'WS GLOBAL CONSULTANCY PRIVATE LIMITED',
    'MCAST MEDIA PRIVATE LIMITED',
    'SILVER TIGER INDIA PRIVATE LIMITED',
    'MOMAGIC FOUNDATION',
    'HAMSTEDE LIVING PRIVATE LIMITED',
    'CORECON TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PURECROP AGRO PRIVATE LIMITED',
    'GOODHEALTH INDUSTRIES PRIVATE LIMITED',
    'NTERONE INDIA PRIVATE LIMITED',
    'RIORA PRIVATE LIMITED',
    'CLARISEL HEALTHCARE PRIVATE LIMITED',
    'NERDS HUB (E) PRIVATE LIMITED',
    'SATYAB GEMS AND JEWELS PRIVATE LIMITED',
    'XMPLIFY TECHNO LABS PRIVATE LIMITED',
    'SHOOTWORDS TECHNOLOGIES PRIVATE LIMITED',
    'BELLMAN LOGISTICS INDIA PRIVATE LIMITED',
    'AMAZELIFE ONLINE SERVICES PRIVATE LIMITED',
    'WERNHER AEROSPACE TECHNOLOGIES PRIVATE LIMITED',
    'ARVIND ENGINEERED COMPOSITE PANELS PRIVATE LIMITED',
    'COMMERCE FABRIC SOLUTIONS PRIVATE LIMITED',
    'UNITRANS MOBILITY SOLUTIONS PRIVATE LIMITED',
    'PEDALOGY ENTERPRISES PRIVATE LIMITED',
    'OBJECTIVO LOGISTICS PRIVATE LIMITED',
    'TP POLYMER PRIVATE LIMITED',
    'VANVIA CONSTRUCTIONS & PROJECTS PRIVATE LIMITED',
    'INDESIAN DIGITAL PRIVATE LIMITED',
    'VIXMART PRIVATE LIMITED',
    'NEOM TRADING AND TECHNOLOGY SERVICES PRIVATE LIMITED',
    'TEAMVIEWER INDIA PRIVATE LIMITED',
    'MANN DESHI KISAN PRODUCER COMPANY LIMITED',
    'ADDEV MATERIALS PRIVATE LIMITED',
    'CHERAG',
    'S FOOTWEAR PRIVATE LIMITED',
    'FRIENDS & FAMILY ESPORTS PRIVATE LIMITED',
    'CHARGEXO BATTERY TECHNOLOGY PRIVATE LIMITED',
    'ACTELIUM PHARMACEUTICAL PRIVATE LIMITED',
    'SHANTI ANALYTICS AND TECHNOLOGY PRIVATE LIMITED',
    'WSAT INDIA PRIVATE LIMITED',
    'MRE SERVICES INDIA.COM PRIVATE LIMITED',
    'KOSH INNOVATIONS PRIVATE LIMITED',
    'SONG CHUAN AUTOMOTIVE PARTS (INDIA) PRIVATE LIMITED',
    'SHYEN TRADE AND CONSULTANCY PRIVATE LIMITED',
    'ARKSOLUTIONSINK STAFFING PRIVATE LIMITED',
    'CYARA TECHNOLOGIES PRIVATE LIMITED',
    'AMBROTOS ENTERPRISES PRIVATE LIMITED',
    'NUPUR RECYCLERS LIMITED',
    'ALLY SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'TERRAVISION INFRA PRIVATE LIMITED',
    'EFOL INDIA PRIVATE LIMITED',
    'BIZTURN TECHNOLOGIES PRIVATE LIMITED',
    'ARTHASHASTRA EPAYLATER FINANCIAL PRIVATELIMITED',
    'COLLINS HEALTH PRIVATE LIMITED',
    'MUTTHA TOWERS II PRIVATE LIMITED',
    'SMARTVEDA TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'QE SYNTHESIS (OPC) PRIVATE LIMITED',
    'INSHAPE PRECISION COMPONENT PRIVATE LIMITED',
    'KRIPTECH SYSTEMS ENGINEERING PRIVATE LIMITED',
    'SURYA ROSHNI LED LIGHTING PROJECTS LIMITED',
    'HESTER AVIATION SERVICES PRIVATE LIMITED',
    'MOSS SOLAR SOLUTIONS PRIVATE LIMITED',
    'FCSG INDIA PRIVATE LIMITED',
    'NF BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WONDER SIGNS INDIA PRIVATE LIMITED',
    'JIT TECHLABS PRIVATE LIMITED',
    'LOGIKA SYSTEMS INDIA PRIVATE LIMITED',
    'UPSOUTH RESTAURANTS PRIVATE LIMITED',
    'ALTVIEWS TECHNOLOGIES PRIVATE LIMITED',
    'SOURCEABILITY INDIA PRIVATE LIMITED',
    'BAYAPUNENI INVESTMENTS GLOBAL PRIVATE LIMITED',
    'LIBI TECHNOLOGIES PRIVATE LIMITED',
    'LEADERAMP INDIA PRIVATE LIMITED',
    'KREDIFI SOFTWARE PRIVATE LIMITED',
    'WATTS & VOLTS MOBILITY PRIVATE LIMITED',
    'AMRITSAGAR FORMULATION PRIVATE LIMITED',
    'NSENERGY TECHNO SERVICES PRIVATE LIMITED',
    'TASK PRECISION INDUSTRIES PRIVATE LIMITED',
    'APPDOC MEDICAL SERVICES PRIVATE LIMITED',
    'LASTMIN ADVISORS PRIVATE LIMITED',
    'AGIO SUPPORT SOLUTIONS PRIVATE LIMITED',
    'HITIKSHA TECHNOCRATES PRIVATE LIMITED',
    'CODEBASE STAFFING INDIA PRIVATE LIMITED',
    'STAR EDI SOLUTIONS PRIVATE LIMITED',
    'SHANKHESH SALES PRIVATE LIMITED',
    'SOCMO CARS PRIVATE LIMITED',
    'MAX INDIA LIMITED',
    'REAL VIRTUAL WORKS PRIVATE LIMITED',
    'THIRD EYE DISTILLERY HOLDINGS PRIVATE LIMITED',
    'REYBHAV TECHNOLOGIES PRIVATE LIMITED',
    'ASKRA TECHNOSYS (INDIA) PRIVATE LIMITED',
    'RADIANT APPLIANCES AND ELECTRONICS PRIVATE LIMITED',
    'APARNA-CRAFT EXTERIORS PRIVATE LIMITED',
    'LAMBERT LIGHTING PRODUCT PRIVATE LIMITED',
    'INTIGUS PHARMACEUTICAL PRIVATE LIMITED',
    'VRIT TECHNO SOFT PRIVATE LIMITED',
    'STORIA FOODS & BEVERAGES PRIVATE LIMITED',
    'BRZO VIMANA PRIVATE LIMITED',
    'QLEVERLABS TECHNOLOGIES PRIVATE LIMITED',
    'COGNISITE TECHNOLOGIES PRIVATE LIMITED',
    'NLI HEALTHCARE (INDIA) PRIVATE LIMITED',
    'SSE WATER SOLUTIONS PRIVATE LIMITED',
    'ROYAL11 GAMESPORTS PRIVATE LIMITED',
    'ANASUYA DECOR PRIVATE LIMITED',
    'DHOLPUR CGD PRIVATE LIMITED',
    'ARRIVAE LIFESTYLE PRIVATE LIMITED',
    'DIVYANK INDUSTRIES PRIVATE LIMITED',
    'TITODI INFOTECH PRIVATE LIMITED',
    'MTOUGH ENTERPRISES PRIVATE LIMITED',
    'DATABRICKS INDIA PRIVATE LIMITED',
    'ELATION TRIATHLON FOUNDATION',
    'REOR CONSULTING PRIVATE LIMITED',
    'AEONIC EDGE PRIVATE LIMITED',
    'PSN MENTOR AND CAREER PRIVATE LIMITED',
    'ITFAS INDIA FASHION PRIVATE LIMITED',
    'JCB FINANCIERS PRIVATE LIMITED',
    'FINRAJA CONSULTANCY PRIVATE LIMITED',
    'PROMANTRA PROJECTS PRIVATE LIMITED',
    'PEFIN INDIA PRIVATE LIMITED',
    'XIXTH INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'IVL INDIA ENVIRONMENTAL R&D PRIVATE LIMITED',
    'ADVANCEDWARE TECHNOLOGIES PRIVATE LIMITED',
    'MIWON SPECIALTY CHEMICAL INDIA PRIVATE LIMITED',
    'EXE PRECISE PROCESS EQUIPMENT PRIVATE LIMITED',
    'MPM FASHION PRIVATE LIMITED',
    'SPECTRUM EXOTICA HOTELS AND RESORTS PRIVATE LIMITED',
    'DELTASPHARMA INDIA PRIVATE LIMITED',
    'MEMCO INDUSTRIES PRIVATE LIMITED',
    'ANALYTIQ SPORTS TECHNOLOGY PRIVATE LIMITED',
    'SONVIKAASHMITA SOLUTIONS PRIVATE LIMITED',
    'QUALITY CREST HEALTHCARE CONSULTANTS PRIVATE LIMITED',
    'KUSHAL',
    'S LIFE SCIENCES PRIVATE LIMITED',
    'GMFC Labs Private Limited',
    'A.P.EXPLO CHEM PRIVATE LIMITED',
    'VEDHA ENTECH INDIA PRIVATE LIMITED',
    'LRM Engineering Private Limited',
    'SHANTI TECHNO FAB PRIVATE LIMITED',
    'SITS Cooling Systems Private Limited',
    'VELJAN PNEUMATICS PRIVATE LIMITED',
    'CHARAN AERO TECH PRIVATE LIMITED',
    'AL FITCO INDUSTRY PRIVATE LIMITED',
    'THANDON POWER PRIVATE LIMITED',
    'K.K.Rao Green Energy Private Limited',
    'AVI WIND PARKS PRIVATE LIMITED',
    'S and T Healthcare Technologies Private Limited',
    'EVOLVO SYSTEMS MARKETING INDIA PRIVATE LIMITED',
    'JERSEY JO AGENCY INDIA PRIVATE LIMITED',
    'ebuyeazy Online Trading Private Limited',
    'CITY VIVA BEVERAGES PRIVATE LIMITED',
    'BANNARI AMMAN LOGISTICS PRIVATE LIMITED',
    'KWELA TRADING PRIVATE LIMITED',
    'EMS CARGO PRIVATE LIMITED',
    'MULTIPLAY NETWORKS PRIVATE LIMITED',
    'PICK MY COURIER AND LOGISTICS PRIVATE LIMITED',
    'CHERAN FINANCE LIMITED',
    'CHERRY HOLDINGS PRIVATE LIMITED',
    'Tao Capital Private Limited',
    'BANNARI AMMAN PROPERTIES PRIVATE LIMITED',
    'S.MALARVIZHI PROPERTY HOLDINGS PRIVATE LIMITED',
    'SHANMUGHAM MALARVIZHI PROPERTY HOLDINGS PRIVATE LIMITED',
    'S.M.V HOLDING PRIVATE LIMITED',
    'SPAN SHELTERS PRIVATE LIMITED',
    'FUJIPURE INFRASTRUCTURES AND DEVELOPERS INDIA PRIVATE LIMITED',
    'S.M.ADITHYA PROPERTY HOLDINGS PRIVATE LIMITED',
    'S.M.A PROPERTY HOLDINGS PRIVATE LIMITED',
    'GMan Tech Labs Private Limited',
    'IDEAHELIX INDIA PRIVATE LIMITED',
    'HARNESS DIGITECH PRIVATE LIMITED',
    'TECHNODUCE INFO SOLUTIONS PRIVATE LIMITED',
    'JEM IT SOLUTION PRIVATE LIMITED',
    'CYPAL SOLUTIONS PRIVATE LIMITED',
    'SCOTO SYSTEC PRIVATE LIMITED',
    'WHITE DATA SYSTEMS INDIA PRIVATE LIMITED',
    'GRAYRADIANT DATA SERVICES PRIVATE LIMITED',
    'PARK DIGITRONICS PRIVATE LIMITED',
    'DRITTO TECHNOLOGIES PRIVATE LIMITED',
    'Technome software solutions private limited',
    'Mathologic technologies private limited',
    'Spree technologies private limited',
    'Milsoft technologies limited',
    'Coretech infosystems private limited',
    'Ecs business solutions private limited',
    'REDBLACK SOFTWARE PRIVATE LIMITED',
    'Cutesys technologies private limited',
    'Experion technologies (india) private limited',
    'Transcribe business solutions private limited',
    'Escube it services (india) private limited',
    'Foundingminds software private limited',
    'Poornam software services (india) private limited',
    'Sygul technologies private limited',
    'Hoovai technologies private limited',
    'Iomarket software services private limited',
    'Nroot labs private limited',
    'Angel infospace corporation private limited',
    'Smartstream technologies india private limited',
    'Salt river info systems private limited',
    'Hybrid cyber solutions private limited',
    'Textronics design systems (india) private limited',
    'Cos phi technologies private limited',
    'T&m software consulting private limited',
    'Osiris infotech private limited',
    'Apar technologies private limited',
    'Version next technologies private limited',
    'Future tech computers private limited',
    'Freestone infotech private limited',
    'Evolutionco digital and interactive consultancy private limited',
    'Saketsoft technologies private limited',
    'Ingeni info systems private limited',
    'Baroc technologies private limited',
    'SARGAM SUPERMARKETS PRIVATE LIMITED',
    'Educe solutions private limited',
    'Netpulse communications (india) private limited',
    'Aditya peripherals private limited',
    'Saicon technologies india private limited',
    'E-governance solutions private limited',
    'Biz 4 solutions private limited',
    'Eywa solutions private limited',
    'Shoptimize india private limited',
    'Testbytes software private limited',
    'Cloudaction technology services private limited',
    'Aryavrat infotech private limited',
    'Kappa e-ventures private limited',
    'Veda institute of information technology private limited',
    'Global infovision private limited',
    'Vicisoft technologies private limited',
    'Business technology solutions private limited',
    'Sreeven infocom limited',
    'Nipun net solutions private limited',
    'Bizpulse software systems private limited',
    'Neumeric technologies private limited',
    'ADIYOGI TECHNOLOGIES PRIVATE LIMITED',
    'Softpal technologies private limited',
    'Dot logic web solutions private limited',
    'Edvenswa tech private limited',
    'Embedded it solutions (india) private limited',
    'Mygo informatics private limited',
    'Bipsum software solutions private limited',
    'Kapil it solutions private limited',
    'Iten softech solutions private limited',
    'Appstek information services private limited',
    'Solus informatics private limited',
    'Eternal consulting (india) private limited',
    'Minfy technologies private limited',
    'Virpie info technologies private limited',
    'Traffika digital solutions private limited',
    'Eminent software solutions private limited',
    'Kubical technosoft private limited',
    'Ioak technology solutions private limited',
    'Sphere soft solutions india private limited',
    'ZENWORK LABS INDIA PRIVATE LIMITED',
    'Arrowpoint technologies private limited',
    'Blue lotus technologies private limited',
    'PREDICTIVE TECHNOLOGIES PRIVATE LIMITED',
    'Factors association of india (u/s. 25)',
    'Gst india consultants private limited',
    'Weavings manpower solutions private limited',
    'Hitech guarding private limited',
    'E-eighteen.com limited',
    'Subodh engineering pvt.ltd.',
    'Madhvilata granite (india) ltd',
    'Yakshita trading and marketing private limited',
    'Drshti strategic research services private limited',
    'Amoto engineers private limited',
    'Suprapti finvest private limited',
    'Metaphor communications private limited',
    'Oceanic nets private limited',
    'Bkv industries limited',
    'Kothari petrochemicals limited.',
    'Rajapalayam mills limited',
    'INTEGRA ESSENTIA LIMITED',
    'Next mediaworks limited',
    'Gujarat petrosynthese limited',
    'RAJASTHAN GASES LIMITED',
    'Syncom formulations (india) limited',
    'Eastern treads limited',
    'Shree rama multi-tech limited',
    'Xpro india limited',
    'DALMIA DSP LIMITED',
    'GUJARAT METAL CAST INDUSTRIES PRIVATE LIMITED',
    'Steel strips infrastructures limited',
    'Anukaran commercial enterprises limited',
    'Asutosh enterprises ltd',
    'Winro commercial (india) ltd',
    'Transcorp international limited',
    'Saraswati commercial (india) ltd',
    'India home loan limited',
    'Citizen infoline limited',
    'Roselabs finance limited',
    'Tridev finance co. ltd.',
    'CARE RATINGS LIMITED',
    'Bengal steel industries ltd',
    'Tulip star hotels limited',
    'Radaan media works india limited',
    'Responsive industries limited',
    'Geneva industries limited',
    'Daftari agro biotech private limited',
    'Shree krishna agro industrial services pvt ltd',
    'Brindavan roller flour mills private limited',
    'Consolidated crop protection private limited',
    'Lamhe agro farms private limited',
    'Stilgar agro farms private limited',
    'Royal herbal land private limited',
    'Royal nature land private limited',
    'Srikar seeds private limited',
    'ARMAYA CELESTE PRIVATE LIMITED',
    'Ayush herbs private limited',
    'Greens organics (india) private limited',
    'Barrix agro sciences private limited',
    'Western agri food park private limited',
    'Konkan agri developers private limited',
    'Swarnim farms india private limited',
    'Goneshbari tea co pvt ltd',
    'Snowview tea co pvt ltd',
    'Kamakhyabari tea co pvt ltd',
    'A.s. horticulture private limited',
    'Sree rajeswari dairy products (india) private limited',
    'Rainyland plantations and farms private limited',
    'Aruvikkara plantations and farms private limited',
    'Wisdom agricare private limited',
    'Seawood agriculture megacrop private limited',
    'Gajanan agritech private limited',
    'Shidhi vinayak agricultural private limited',
    'Verginland plantations and farms private limited',
    'Agron global private limited',
    'Isha agro developers private limited',
    'Algae bio-tech india private limited',
    'Eight constructions private limited',
    'Navalji cotspin limited',
    'Qed agro systems private limited',
    'Durga agro park private limited',
    'Selwin healthcare private limited',
    'Alnesh agro farms private limited',
    'Jiwani agro farms private limited',
    'Dovetail furniture private limited',
    'Surya vamsi fisheries private limited',
    'Advantage overseas private limited',
    'Shell apparels private limited',
    'Padmashil hospitality and leisure private limited',
    'Jupiter concrete blocks and allied products private limited',
    'Coretech realty private limited',
    'A p d estates private limited',
    'Spectron safety systems private limited',
    'B.m.m. ispat limited',
    'Trimex heavy minerals private limited',
    'Trimex barite private limited',
    'Jps metals private limited',
    'Shanti vinayak natural stone private limited',
    'SHREE RAM GRANIMARMO PRIVATE LIMITED',
    'Satguru granites private limited',
    'Hargobind buildcon private limited',
    'Professional colonizers private limited',
    'Unique dream builders private limited',
    'Shivshakti propcon private limited',
    'Pearl prime realestate private limited',
    'Sashwath constructions private limited',
    'Bharat engineering construction company private limited',
    'BMR RETAIL PRIVATE LIMITED',
    'Pmc projects (india) private limited',
    'Rohtak-panipat tollway private limited',
    'Binwa power company pvt limited',
    'Awa power company pvt. limited',
    'Neogal power company pvt limited',
    'Iqu power company pvt limited',
    'Murphy road business centre private limited',
    'Favourite constructions private limited',
    'Santogen exports limited',
    'Shirely real estates pvt ltd',
    'P&P BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'Bishan infrastructure private limited',
    'Goodlife constructions private limited',
    'Sahana developers private limited',
    'Skylark build properties private limited',
    'Exclusive home developers private limited',
    'Neilsmith buildsys private limited',
    'Odisha biotech park private limited',
    'AURANGABAD - JALNA TOLL WAY PRIVATE LIMITED',
    'Hyderabad-yadgiri tollway private limited',
    'Bangalore international airport limited',
    'Somegh investments private limited',
    'Goodlife dwellers private limited',
    'DBR DEVELOPERS PRIVATE LIMITED',
    'KATYAL VENTURES PRIVATE LIMITED',
    'Mep hyderabad bangalore toll road private limited',
    'ESR NAGPUR WAREHOUSING AND INDUSTRIAL PARK PRIVATE LIMITED',
    'Smit kishore infrastructural links private limited',
    'Gift ict services limited',
    'Om power transmission private limited',
    'GAMMON TRANSMISSION LIMITED',
    'Columbia developers private limited',
    'Hsquare projects private limited',
    'Ghogarpalli integrated power company limited',
    'Shilpa high rise private limited',
    'Malabar castle private limited',
    'Sunway mak international private limited',
    'ALEKHYA HOMES GREEN MANTHRA DEVELOPERS PRIVATE LIMITED',
    'Mannam constructions private limited',
    'Sri sri mansions india private limited',
    'Indian small scale paint association',
    'Gvr behari hanumana tollway private limited',
    'Crystal palace properties private limited',
    'Morgan infrastructures developers private limited',
    'Sunshine tradetower private limited',
    'Ecotech infratech private limited',
    'Zen matrix private limited',
    'Mirchandani and company private limited',
    'Geecee business private limited',
    'Maxbhumi developers limited',
    'Nexus project solutions private limited',
    'Sarveshwar properties private limited',
    'Sahana buildcon private limited',
    'Nandi vardhan realtors limited',
    'Goodlife realtors private limited',
    'Sahej constructions private limited',
    'Skylark build infrastructures private limited',
    'Mbm precast india private limited',
    'Nanis infracon private limited',
    'Vindhyavasini toll infrastructure private limited',
    'Ishaan infradwellers private limited',
    'Hyperformance infra private limited',
    'Ramnath real estate private limited',
    'Moonrock infra projects private limited',
    'Vijay raja homes private limited',
    'Varivas properties private limited',
    'Om sri sai rk developers private limited',
    'Sanbrix infrastructures private limited',
    'Maa amba towers limited',
    'Shailesh real estate private limited',
    'Kriishnavi infra realtors private limited',
    'Meantime buildcon private limited',
    'Mangalmayee realtors private limited',
    'Dios realtors private limited',
    'Vedvani residency private limited',
    'Anju promoters private limited',
    'Zaljog complex private limited',
    'Bnt motors private limited',
    'BHARAT AUTO TECH PRIVATE LIMITED',
    'Mithra auto agencies private limited',
    'Suyash auto press components and assemblys pvt ltd',
    'Marjan motors private limited',
    'B.n. talwar and bros private limited',
    'Myoung shin india automotive private limited',
    'Mobis india limited',
    'T b agri impex private limited',
    'Alphaplus commodities private limited',
    'PUISSANCE DE L',
    'OREAL INDIA PRIVATE LIMITED',
    'Rayh charitable foundation',
    'Point hospitals private limited',
    'Fisabilillah hunger relief foundation',
    'Streamlined medical solutions private limited',
    'NEUBERG EHRLICH LABORATORY PRIVATE LIMITED',
    'It trailblazers consulting private limited',
    'SANI CLEAN PRIVATE LIMITED',
    'RESYS LIFESCIENCES PRIVATE LIMITED',
    'First stp private limited',
    'Kutch corporate forum',
    'Pranic healing foundation for children',
    'Mohanlal dayal charitable foundation',
    'G2 communications private limited',
    'Frames production company private limited',
    'Mitashi edutainment private limited',
    'Deep cineplex private limited',
    'Bollywood corporation private limited',
    'Annu kapoor films private limited',
    'Go fish entertainment private limited',
    'Fourth dimension film studio private limited',
    'Internet television private limited',
    'Vega entertainment private limited',
    'Nine eleven marketing and events private limited',
    'Effects tech total event production private limited',
    'Aggarwal entertainment private limited',
    'Total productions private limited',
    'Panorama entertainment private limited',
    'Storm amusements private limited',
    'SPI MUSIC PRIVATE LIMITED',
    'Vision hire entertainments private limited',
    'Rajsonia consultancy services private limited',
    'Ian mentoring and incubation services',
    'Greengeo engineering consultants private limited',
    'LIVE INDIA TOURS PRIVATE LIMITED',
    'Refam wealth and asset management private limited',
    'Odisha infrapower limited',
    'RRA FINSERV PRIVATE LIMITED',
    'Hetal management services private limited',
    'TERRE',
    'S INSTITUTE OF LIFE SCIENCES',
    'Synectix enclosure systems private limited',
    'Essae technologys private limited',
    'F & R DATA ANALYTICAL SYSTEM AND SOLUTIONS PRIVATE LIMITED',
    'Biomoneta research private limited',
    'Inrea research solutions private limited',
    'Narkar and associates private limited',
    'Prabhu associates consultants private limited',
    'Ach management consultants private limited',
    'Kochhar lexserve private limited',
    'H5 asia pacific private limited',
    'Kochhar accounting services private limited',
    'Mobilecomm technologies india private limited',
    'Chowdhry rubber & chemical private limited',
    'Total strategic solutions india private limited',
    'Fidelity management and services private limited',
    'Broadway malyan india private limited',
    'Ysc india business psychologists private limited',
    'Flowing ink communications private limited',
    'Gss hr solutions private limited',
    'Unique fitness private limited',
    'Amfa climatech solutions private limited',
    'ALFA FINCON PRIVATE LIMITED',
    'Nalanda commodities private limited',
    'Pricewaterhousecoopers aims support services india private limited',
    'Vidyan biocommerce private limited',
    'Accura machine tools private limited',
    'Vr food tech private limited',
    'HACTCOM AGRO PRIVATE LIMITED',
    'Dr howards way diet private limited',
    'Master marine electronics services private limited',
    'Ocean waves leisure private limited',
    'Etania ventures private limited',
    'Feedforward media & marketing solutions private limited',
    'KOCHHAR CARE CONNECT PRIVATE LIMITED',
    'Lexedge services private limited',
    'SOLAR TRAINING & HR SERVICES PRIVATE LIMITED',
    'Ascenso enviro private limited',
    'Behuria consulting private limited',
    'Anusha management services private limited',
    'Sunglow insurance surveyors & loss assessors private limited',
    'Ajayvision education private limited',
    'Ab corpsmanagement private limited',
    'Unique techno services private limited',
    'Delf consulting engineers (india) private limited',
    'Vdp corporate advisory private limited',
    'Iplex india private limited',
    'V v patel consultants private limited',
    'XANADU FOODS PRIVATE LIMITED',
    'Finbiz services private limited',
    'NEOSAY TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED',
    'SHORTAILS TECHNOLOGY PRIVATE LIMITED',
    'TRIDHAM TECHNOLOGIES PRIVATE LIMITED',
    'HYBRID 360 ART TECH PRIVATE LIMITED',
    'GREEN ORANGE INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'SRI KORAKA TECHNOLOGIES PRIVATE LIMITED',
    'FOSS INFOTECH PRIVATE LIMITED',
    'ENTHU TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'PRIMORIS SYSTEMS INDIA PRIVATE LIMITED',
    'ARIES BIOMED TECHNOLOGY PRIVATE LIMITED',
    'STEMI CARE INDIA PRIVATE LIMITED',
    'REVELATION MANAGEMENT CONSULTING INDIA PRIVATE LIMITED',
    'Avanti Accounting Services Private Limited',
    'K AND J CONSULTING PRIVATE LIMITED',
    'HAPPY RETURNS INVESTMENT ADVISORS PRIVATE LIMITED',
    'M-Power Jobs Services Private Limited',
    'AS QUALITY CHECKING SERVICES PRIVATE LIMITED',
    'MATRIX FACILITY SERVICES INDIA PRIVATE LIMITED',
    'IPPOFIX HOME SERVICES PRIVATE LIMITED',
    'VINFORMAX TECHNOLOGY SYSTEMS PRIVATE LIMITED',
    'A.N.Y Liquitreat Solutions Private Limited',
    'NAVALAN INFOSEC PRIVATE LIMITED',
    'INHOUSE MEDICARE PRIVATE LIMITED',
    'REMMY SUBSTRATES INDIA PRIVATE LIMITED',
    'SPAN EDUTECH VENTURES PRIVATE LIMITED',
    'TIPS ONE PRIVATE LIMITED',
    'CHERAN HOSPITALS LIMITED',
    'HAIRBITAT HAIR TREATMENT INDIA PRIVATE LIMITED',
    'SKM SHREES FARMS INDIA PRIVATE LIMITED',
    'AMIRTHAA DAIRY PRIVATE LIMITED',
    'DEVI COTTON MILLS PRIVATE LIMITED',
    'JAI ANJANEYA INDUSTRIES PRIVATE LIMITED',
    'SILVERLINE ROTARY PRINTERS PRIVATE LIMITED',
    'IE TRUSTINDUSTRY PRIVATE LIMITED',
    'REINVENT APPARELS PRIVATE LIMITED',
    'SKM SHREE HERBALS INDIA PRIVATE LIMITED',
    'GREENCEM PRODUCTS PRIVATE LIMITED',
    'VINVELI AUTOMATED SYSTEMS PRIVATE LIMITED',
    'UNITY ELECTRO SYSTEMS PRIVATE LIMITED',
    'K K S K GREEN POWER ASSOCIATES PRIVATE LIMITED',
    'SKM SHREE ENERGY INDIA PRIVATE LIMITED',
    'SKM SHREE DEVELOPERS INDIA PRIVATE LIMITED',
    'SKM SHREES PROPERTIES INDIA PRIVATE LIMITED',
    'NAANAL TECHNOLOGIES PRIVATE LIMITED',
    'Astrotech Equipments Private Limited',
    'ZAPPY CONSULTS PRIVATE LIMITED (OPC)',
    'Sapna book house private limited',
    'B.jain pharmaceuticals private limited',
    'Vasu healthcare private limited',
    'Midland pharmaceuticals private limited',
    'Kadillac chemicals pvt ltd',
    'Goran pharma pvt ltd',
    'Anupam rasayan india limited',
    'Golcha minerals (india) private limited',
    'Mine chemicals private limited',
    'Zeal corporation india private limited',
    'Mehta medicare pvt.ltd.',
    'Chaitanya barium (india) private limited',
    'MODI-MUNDIPHARMA HEALTHCARE PRIVATE LIMITED',
    'Bajaj salt private limited',
    'Khedut bio-organics private limited',
    'Dalas biotech limited',
    'Affy pharma private limited',
    'Kay amines and sugars private limited',
    'Kph cosmos private limited',
    'Shivmangal pharma private limited',
    'Palsons derma private limited',
    'Electrochem orissa ltd',
    'Shakun mintech private limited',
    'Vedic broadcasting limited',
    'Jaikapeesh capital private limited',
    'Akums drugs and pharmaceuticals limited',
    'BHAGAT FORGE PRIVATE LIMITED',
    'Arihanta siddha laboratories pvt ltd',
    'Bago laboratories private limited',
    'Paharpur corpn ltd',
    'Silva pharmaceuticals private limited',
    'Mercury synthetic resins private limited',
    'Blessings wellness private limited',
    'Malancha polymers (pvt.) ltd',
    'Geist research private limited',
    'Polygal india private limited',
    'Future innovations pvt ltd',
    'Innova rubbers private limited',
    'Huntin organics private limited',
    'Appolo chemicals private limited',
    'Svaks biotech india private limited',
    'Kinesis laboratories private limited',
    'Trident laboratories pvt ltd.',
    'Adley lab limited',
    'Hues india private limited',
    'Texplas composites (india) private limited',
    'R.r.s.rubber company private limited',
    'Kothari spinners private limited',
    'Surya masterbatches private limited',
    'Bansal polyplast private limited',
    'DSC CLOTHING PRIVATE LIMITED',
    'Bhikshu commercial pvt ltd',
    'Uitc (india) private limited',
    'R. k. fuels private limited',
    'FPS FLEXIBLES INDIA PRIVATE LIMITED',
    'Vitabiotics (india ) private limited',
    'Edge healthcare private limited',
    'King fisher polymers private limited',
    'Vasu packs private limited',
    'BONY FLUID SYSTEMS PRIVATE LIMITED',
    'Ambica taptex private limited',
    'Reddy limited',
    'Medizest pharmaceuticals private limited',
    'Kunnath pharmaceuticals private limited',
    'Smilax pharmaceuticals private limited',
    'Vedicare ayurveda private limited',
    'NAYATI HEALTHCARE & RESEARCH NCR PRIVATELIMITED',
    'REDDY BIOTEC LIMITED',
    'Inland cement company private limited',
    'Neo cement private limited',
    'Rex ceramic private limited',
    'Leose cosmetics private limited',
    'VECTECH ENERGY SYSTEMZS PRIVATE LIMITED',
    'Heveacrumb rubber private limited',
    'Rubco tyres india private limited',
    'Excel precision manufacturing limited',
    'Mangala ispat (jaipur) limited',
    'JRK INDUSTRIES PRIVATE LIMITED',
    'Ranjan tutorials private limited',
    'High computer learning centre private limited',
    'Aster hospitals private limited',
    'Bakson homoeopathy private limited.',
    'Chelmsford club ltd',
    'First step projects private limited',
    'Asns infrastructure private limited',
    'Darksun technologies private limited',
    'Jayshree chemicals limited',
    'Alembic limited',
    'Orissa industries ltd',
    'Investment & precision castings limited',
    'Ag industries (bawal) private limited',
    'Khosla agro industries pvt ltd',
    'Winsome tea plantation (p) ltd',
    'Malpani tea company pvt ltd',
    'The jorehaut agro limited',
    'Sonajuli plantations private limited',
    'Trident plantations private limited',
    'Dee development engineers limited',
    'Sun designs and interiors private limited',
    'OLIFANTT RESOURCES LIMITED',
    'Ram metacop private limited',
    'Task technologies private limited',
    'TRINITY FRUCTA PRIVATE LIMITED',
    'Pratham corporation private limited',
    'Cremica food industries limited',
    'La belle helene trading private limited',
    'Delicious agro india private limited',
    'MRS BECTOR',
    'ORTO INDIA PRIVATE LIMITED',
    'O.s.motors private limited',
    'I p b plastics private limited',
    'Eagle liquors pvt ltd',
    'Hi-tech bottling limited',
    'Trilig energy private limited',
    'Atul clean energy limited',
    'Udipta energy & equipment private limited',
    'Gaursons promoters private limited',
    'Gaursons developers private limited',
    'Golden oak infrastructure private limited',
    'Up township infrastructure private limited',
    'New planet promoters private limited',
    'Radiant footcare private limited',
    'Himgiri sales private limited',
    'I.p. estates private limited',
    'Shakuntalam housing private limited',
    'Success buildwell private limited',
    'GRAFAX KNITWEARS LIMITED',
    'Sogno office furniture india private limited',
    'Dayal alloys limited',
    'SUBRATA SASMAL & COMPANY PVT LTD.',
    'Tds infrastructure private limited',
    'Ald promoters private limited',
    'Snsp developers private limited',
    'Passive infra projects private limited',
    'Infra cool private limited',
    'Metro technobuild private limited',
    'Shri aadinath developers private limited',
    'ANANDVRDDHI EXIM PRIVATE LIMITED',
    'Sheffield and vermark consultants private limited',
    'Km infrastructures private limited',
    'MOUNT GREEN HEALTH FOODS AND DRINKS PRIVATE LIMITED',
    'Timblo industries private limited.',
    'T r sawhney automobiles private limited',
    'ALEMBIC CITY LIMITED',
    'Afc overseas private limited',
    'Morvin international private limited',
    'Glorious vanijya private limited',
    'Omsons marketing private limited',
    'Coombergram limited',
    'Bloom florists private limited',
    'Gee emm bros distributors private limited',
    'Viraj exports private limited',
    'Apppli consulting private limited',
    'Fab lifestyle private limited',
    'TOSHIBA WATER SOLUTIONS PRIVATE LIMITED',
    'Spiritual luxury living private limited',
    'Rajdhani tubes private limited',
    'Sarla exports pvt ltd',
    'Vandana graphics private limited',
    'Seerat capital limited',
    'Surgikon india private limited',
    'Qutab buildwell private limited',
    'GAURSONS INDIA PRIVATE LIMITED',
    'ANAND POWER Private Limited',
    'Sahyog realcon limited',
    'Sandeep geeta and associates private limited',
    'Sunrise computer systems private limited',
    'Classic buildwell private limited',
    'A.s.a. engineers private limited',
    'Cmk engineering private limited',
    'Radius marketing private limited',
    'Sai creations private limited',
    'Dynacon projects private limited',
    'Jkg construction private limited',
    'Neelkanth weld private limited',
    'S d auto componets private limited',
    'Design team consultants private limited',
    'Richa environmental services private limited',
    'Asn global communications private limited',
    'Myco soil (india) private limited',
    'Stately suites private limited',
    'Malwa images private limited',
    'Shree maa roll wrap private limited',
    'Times internet limited',
    'Jyotech engineering co private limited',
    'T r sawhney shopping mall private limited',
    'P&C 1 INDIA PRIVATE LIMITED',
    'HUNNER NETWORK TECHNOLOGIES PRIVATE LIMITED',
    'A.m.s. inform research services private limited',
    'Chroma power systems india private limited',
    'Achyutam international private limited',
    'BROWN BIRD LOGISTICS PRIVATE LIMITED',
    'Cs land traders india private limited',
    'Touax texmaco railcar leasing private limited',
    'Grade stack learning private limited',
    'Ai education systems private limited',
    'Basils india private limited',
    'The mangalore trading association private limited',
    'Nutriwel health (india) private limited',
    'Eazyways healthcare private limited',
    'Satyakiran healthcare private limited',
    'BIOTIC WASTE LIMITED',
    'TATVA GLOBAL ENVIRONMENT Private Limited',
    'PLAYNLIVE SPORTS WELFARE ASSOCIATION',
    'Meroform (india) private limited',
    'Workaholics event solutions private limited.',
    'D it solutions india private limited',
    'SPECTRUM AERO PRIVATE LIMITED',
    'Trident institute of social sciences',
    'Brandbaron marketing private limited',
    'Mafatlal industries limited',
    'AMJ LAND HOLDINGS LIMITED',
    'Alembic pharmaceuticals limited',
    'Gennex laboratories limited',
    'Jindal stainless limited',
    'Assam roofing limited',
    'JINDAL STEEL & POWER LIMITED',
    'Blue coast hotels limited',
    'Alchemist limited',
    'Sicagen india limited',
    'Leelaka grains limited',
    'JHILL FARMS LIMITED',
    'Shree shyam tea pvt ltd',
    'Imperial credit pvt ltd',
    'Assam gas company ltd',
    'SYN RENEWABLE PRIVATE LIMITED',
    'Sidh petrochem private limited',
    'SEA BLISS PRIVATE LIMITED',
    'Aarpee hygiene private limited',
    'Lanco agro foods india private limited',
    'Texas woollen mills pvt ltd',
    'G.g.valves private limited',
    'Pala decor private limited',
    'Rentech designs india private limited',
    'Arihant foam private limited',
    'KOHINOOR INTERNATIONAL PRIVATE LIMITED',
    'Hazel commercial pvt ltd',
    'Designwise india private limited',
    'Spark printpack private limited',
    'Khandagiri pulp private limited',
    'Sarwan print pack private limited',
    'Petrox private limited',
    'An essence private limited',
    'Menezes pharmaceuticals limited',
    'Zeiss pharma limited',
    'UPL GLOBAL BUSINESS SERVICES LIMITED',
    'Yokohama india private limited',
    'Jsr plasto tools private limited',
    'Neokraft global private limited',
    'Renuka polysacks private limited',
    'Micron polysleep private limited',
    'Fibreglass and insulation services private limited',
    'Winspir creations private limited',
    'Ved appearels private limited',
    'Shubhi steel private limited',
    'Anand steel rolling works ltd',
    'ESSAR STEEL METAL TRADING LIMITED',
    'G biswas biri pvt ltd',
    'ENCORE MODULAR FURNITURE PRIVATE LIMITED',
    'K.l. concast private limited',
    'B c sen & company ltd',
    'Swastik pigments private limited',
    'Charummood cashew factory private limited',
    'Adarsh asia pacific private limited',
    'Boiler and components (india) limited',
    'Debson pumps pvt ltd',
    'Hicon products india private limited',
    'Zois charge air coolers private limited',
    'SPAL AUTOMOTIVE TECHNOLOGY INDIA PRIVATE LIMITED',
    'Brahmaputra property management services private limited',
    'Fci aravali gypsum and minerals india limited',
    'Singhanama bamboo initiative private limited',
    'Up town travels private limited',
    'Suvidha mega mall private limited',
    '1-0 advisors india private limited',
    'Decent securities private limited',
    'Door training and knowledge consulting private limited',
    'Le comptoir des indes private limited',
    'SVARA PURE GRAINS PRIVATE LIMITED',
    'Proflex electricals private limited',
    'Ujala investments private limited',
    'Mangalmay holdings private limited',
    'Skytrain freight forwarders private limited',
    'K g projects and equipmemt marketing company private limited',
    'Chimes private limited',
    'Nav engineers private limited',
    'Onassis axles private limited',
    'Shram consulting private limited',
    '3x engineering private limited',
    'Elipsis consulting private limited',
    'Surya hi-tech services private limited',
    'Mba associates private limited',
    'Delta maintenance agency private limited',
    'Bravura packers private limited',
    'T a c design private limited',
    'Kmgs road signs private limited',
    'A.r. relocations private limited',
    'Optsoft it business solutions private limited',
    'Samanata private limited',
    'Delhi plastic moulders private limited',
    'Select ventures private limited',
    'Select investconsult private limited',
    'Gc web ventures private limited',
    'Letul investments private limited',
    'Qss color processors private limited',
    'Multi interiors private limited',
    'Unistone interiors private limited',
    'A. saurabh and company private limited',
    'SPRING OVERSEAS PRIVATE LIMITED',
    'C n m p investments private limited',
    'Iaan creation pvt ltd',
    'Ficus e logic private limited',
    'Eastern metal and rubber products pvt.ltd.',
    'Malabar institute of medical sciences ltd',
    'SADGURU MEDICAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'THE DELHI GOLF CLUB',
    'Techpro (india) private limited',
    'Rain man productions private limited',
    'SAGRADOS MERCADEO PRIVATE LIMITED',
    'Chaudhary international private limited',
    'Indian surgical equipment company private ltd',
    'Adwel advertising private ltd',
    'G and g fabrics private ltd',
    'Ajit financial services private limited',
    'Sky high capitals private limited',
    'Spaceage security systems limited',
    'Sohan lal commodity management private limited',
    'Maxwell textile pvt. ltd.',
    'Malbro appliances private limited',
    'Down town hospital limited',
    'Modern steel ltd.',
    'Steel cast limited',
    'Pg electroplast limited',
    'Port shipping co ltd',
    'Zuari agro chemicals limited',
    'Multicon realty limited',
    'Max heights infrastucture limited',
    'Pantagan finance limited',
    'ENCODE PACKAGING INDIA LIMITED',
    'Mideast portfolio management limited',
    'Leasco limited',
    'Anupam mercantile limited',
    'Pankaj power solutions private limited',
    'Daya engineering works private limited',
    'Bm gupta hospital private limited',
    'Rashi entertainment pvt ltd',
    'SARVKAUSHAL SKILL ENHANCER PRIVATE LIMITED',
    'Scg sporting initiatives private limited',
    'Finman executive search private limited',
    'Ts tradsol services private limited',
    'Century arts exports private limited',
    'Perceptors academy studies private limited',
    'Sarla foundation',
    'Cybiz learning services private limited',
    'Premier indoplast private limited',
    'Lawrencedale agro processing (india) private limited',
    'Poppys agriculture private limited',
    'Kunssh beverages private limited',
    'Nagaland agro industries pvt ltd',
    'V.s.dempo mining corporation private limited',
    'Sharpedge education',
    'Talesara marble and tiles private limited',
    'A & A MINES AND MINERALS PRIVATE LIMITED',
    'Infinite health studios private limited',
    'Suryadeep hospitals india private limited',
    'Gimmick consultancy private limited',
    'Indus healthcare services private limited',
    'Raj bagh farms private limited',
    'Vip oil products limited',
    'Green gardens private limited',
    'Ess ell farms private limited',
    'Sunandaram foods private limited',
    'Srd nutrients private limited',
    'Malabar spices company limited',
    'Indo grains private limited',
    'VIKRAM PROTIENS PRIVATE LIMITED',
    'Accolade amusement private limited',
    'Wiseman knitfab private limited',
    'Shree vallee enterprises private limited',
    'Triveni events private limited',
    'Sri krishna greenadge resorts india limited',
    'SHREE BALKISHAN DYEING AND PRINTING MILLS PRIVATE LIMITED',
    'Star cotspin limited',
    'Barley agro foods private limited',
    'Vgnc business solutions private limited',
    'Triveni clothing private limited',
    'Freeland india consultants private limited',
    'Srajan agritech private limited',
    'Sookerating tea estate pvt ltd',
    'K.k.p. fine linen private limited',
    'Shree bankey behari rice mills limited',
    'Belle lingeries private limited',
    'White champa fashion private limited',
    'Punit enterprises private limited',
    'Sangam labels private limited',
    'Pappu textiles pvt.ltd.',
    'MIDAS AGROFOODS PRIVATE LIMITED',
    'Shree feedstuffs private limited',
    'Fragnant finnvest pvt.ltd.',
    'Lodna colliery company (1920) limited',
    'Siddhartha apparels private limited',
    'IDEAL CREATIONS PRIVATE LIMITED',
    'Ravi industrial chemicals private limited',
    'Gwl properties limited',
    'Unistar shoes private limited',
    'Baluram agro industries private limited',
    'R P MALHAN AND COMPANY PRIVATE LIMITED(OPC)',
    'Godavari coal fields pvt ltd',
    'Pacific mines and construction private limited',
    'Omaxe forest spa and hills developers limited',
    'Shriji land promoters private limited.',
    'Shri shyam oil extractions private limited',
    'Asia motorworks limited',
    'Garima beach world private limited',
    'Five by seven solutions private limited',
    'Mixed bag media private limited',
    'Forth estate media private limited',
    'Zubaan publishers private limited',
    'SPACECAST TELEPORTS PRIVATE LIMITED',
    'Biotechayur private limited',
    'Vaishali publicity private limited.',
    'Joydurga library private limited',
    'Skg fiscals ltd',
    'ALCOBREW DISTILLERIES INDIA LIMITED',
    'Reed and pick impex private limited',
    'Taaza infotainment private limited',
    'Multiples packing private limited',
    'Vasundhara holdings ltd',
    'Oxy glow cosmetics private limited',
    'Kba care cosmetics private limited',
    'Yed chemical private limtied',
    'Weld alloy products private limited',
    'Dadu developers private limited',
    'Rb builders private limited',
    'MANILA PROCESSORS PVT LTD',
    'Urilab systems private limited',
    'Ravi pharmaceuticals pvt ltd',
    'Bharat parenterals limited',
    'India tele-comp limited',
    'Will health care private limited',
    'Pfc pharma focus india private limited',
    'Avecia biological private limited',
    'Valeda herbal private limited',
    'SITARAM AYURVEDA PRIVATE LIMITED',
    'Aved ayurved private limited',
    'Christine hoden (india) private limited',
    'Sutte design private limited',
    'Anand motor products private ltd.',
    'Anand industrial products private limited',
    'Ga auto fabric private limited',
    'Madura coats private limited',
    'Karrs creations private limited',
    'Uppal apparels private limited',
    'R j wood and co pvt ltd',
    'HARDIP PLYWOOD & VENEERS PRIVATE LIMITED',
    'Suraj wood products private limited',
    'Comic con india private limited',
    'Creative curve communication private limited',
    'Mbd enterprises private limited',
    'Composite materials industries private limited',
    'Sms asia private limited',
    'Connect international private limited',
    'Bajrang refractories private limited',
    'Akio-shireen cement co. private limited',
    'A.s. fashions private limited.',
    'Spring garments private limited',
    'Amt international private limited',
    'Ashwani metals private limited',
    'Svr creations private limited',
    'PURSARTH INFRASTRUCTURES PRIVATE LIMITED',
    'Meeraj apparel private limited',
    'Spvk metals private limited',
    'Slr metaliks limited',
    'Mcnally bharat equipments limited',
    'Arp pharmaceuticals private limited',
    'Chackosons chemicals pvt ltd',
    'Ashoka polyart private limited',
    'Hira plastics pvt ltd',
    'Bhabani offset private limited',
    'Ipp services training and research private limited',
    'Shriram hariram (skg) diamonds private limited',
    'Cast master enterprises private limited',
    'Deepak iron and steels pvt ltd',
    'GANESHA ECOVERSE LIMITED',
    'UTTAM CYLINDERS PRIVATE LIMITED',
    'Kishore ampoules pvt ltd',
    'J r strips private limited',
    'Unitorq engineers private limited',
    'R.n.gupta and company limited',
    'CALCUTTA DIES & TOOLS MFG. CO PVT LTD',
    'KAY INTERNATIONAL PRIVATE LIMITED',
    'Indmark formtech private limited',
    'Ridvan fasteners india private limited',
    'Excel printers private limited',
    'Premierworld technology limited',
    'Next gen. packaging private limited',
    'Meeraj plast pvt ltd',
    'Gujarat enviro-protection and infrastructure(haryana) private limited',
    'Laxmi pipes ltd',
    'K.c. jain traders private limited',
    'K2 cadem technologies private limited',
    'S t p ltd',
    'Lmd hitech india private limited',
    'Dee emm giken private limited',
    'Am medisys consultancy private limited',
    'Marc display private limited',
    'Aishwarya garden private limited',
    'The kamla company ltd.',
    'Supriya tea limited',
    'Prayag medicare private limited',
    'Jiva ayurvedic pharmacy limited',
    'ATUL AAROGYA LIMITED',
    'R h agro overseas private limited',
    'South eastern coalfields limited',
    'Bhootal khaniz udyog private limited',
    'Sanya earth mining private limited',
    'Sanya minerals mining private limited',
    'Crackers india infrastructure limited',
    'Mak sons rock products private limited',
    'A exports private limited',
    'Bundi silica private limited',
    'Sri trivikrama mines and properties limited',
    'Sri madhusudana mines and properties limited',
    'DALMIA BHARAT REFRACTORIES LIMITED',
    'Gotan lime stone khanij udyog private limited',
    'Gem corporation of orissa limited',
    'Arpit agro industries private limited',
    'Mapro foods private limited',
    'Greenhouse and hestoft foods private limited',
    'Indus culinary team private limited',
    'Vaighai agro products limited',
    'Mahila udyog limited',
    'Kogta international private limited',
    'Olea europaea trading private limited',
    'Hub health services private limited',
    'Nutrimed healthcare private limited',
    'Mayur roller flour mills pvt ltd',
    'High street food services private limited',
    'Winzen care private limited',
    'D records international private limited',
    'Aarkay extractions private limited',
    'Lalla mookh tea co pvt ltd',
    'LANFEST PRIVATE LIMITED',
    'Instamaze infotainments private limited',
    'Sreedharan and company pvt ltd',
    'Bajaj spirits private limited',
    'Pataka industries private limited',
    'Suchitra chemicals private limited',
    'Poddar cotton dealers pvt ltd',
    'East end silks private limited',
    'Vision amusement park private limited',
    'C mail infotech pvt. ltd.',
    'IBOOKS INSTITUTE PRIVATE LIMITED',
    'Suman filament pvt ltd',
    'Kalpesh cotton industries private limited',
    'Intelligraph technology private limited',
    'Vitthal textiles private limited',
    'Dhanalakshmi weaving works (kannur) private limited',
    'Fantasy furnishings private limited',
    'Golden floor furnishing private limited',
    'Tru-thread gauges and tools pvt ltd',
    'Orchid medical centre private limited',
    'UNISTAR EXPORTS PRIVATE LIMITED',
    'Seacorp impex private limited',
    'UPPER CLASS FASHIONS Private Limited',
    'Healthy hospitals private limited',
    'Malik radix healthcare private limited',
    'Kay jain wears pvt ltd',
    'Ambience apparels private limited',
    'Centex international private limited',
    'Pawan sachdeva vogue international private limited',
    'Vishvas international private limited',
    'Creativart garments and jewellery private limited',
    'Orient craft knitwear private limited',
    'Omtara studio private limited',
    'Sanj designs private limited',
    'Curesa leather products private limited',
    'Morbido vinyl private limited',
    'Nico orgo biotech private limited',
    'Telu ram foods private limited',
    'Trac agrofoods private limited',
    'Fortune multitech private limited',
    'Shreya shudh food packagings private limited',
    'Ginni packaging private limited',
    'Saf filter pvt.ltd.',
    'Jaya packaging pvt ltd',
    'Khemka packagings private limited',
    'Shree krishna packaging co pvt ltd',
    'Creative products pvt ltd',
    'Gandhi spices private limited',
    'Benzfab foods private limited',
    'Har-anand publications private limited',
    'D k publishers distributors pvt ltd',
    'Roshni publishers pvt ltd',
    'Lokavani southern printers private limited',
    'Northern india consultants private limited',
    'B r a textile pvt ltd',
    'LUXURY HOME FURNISHINGS PRIVATE LIMITED',
    'Qsource international private limited',
    'Ad-well international private limited',
    'Swank services private limited',
    'Jj imprints private limited',
    'Multi-flex lami-print limited',
    'Gogad fabrics private limited',
    'Cura farma private limited',
    'Ashutosh suitings private limited',
    'Addi exports pvt ltd',
    'Qst fabrics and accessories india private limited',
    'Bharat oxytech private limited',
    'Sagar infra rail international limited',
    'Clb pharmaceuticals private limited',
    'HINDON INDIA PRIVATE LIMITED',
    'ACETO CHEM PRIVATE LIMITED',
    'Unity dyechem private limited',
    'SURANA DYECHEM PRIVATE LIMITED',
    'Metaworth interiors (india) private limited',
    'Selvasuba paper mills private limited',
    'Girdhar exim private limited',
    'PAAVANI INFRADEV PRIVATE LIMITED',
    'Apollo capital consultancy private limited',
    'Accountantanywhere services private limited',
    'Nysa consultancy services private limited',
    'Vishwa industrial co ltd',
    'Jaguar advisory services private limited',
    'Thd maintenance company private limited',
    'Medanta holdings private limited',
    'Plaksa solutions private limited',
    'United ceramics processing pvt ltd',
    'Progilence capability development private limited',
    'Genuine management services private limited',
    'COMPLY4HR CONSULTANTS PRIVATE LIMITED',
    'ICOM ANALYTICS LIMITED',
    'Sparks thread private limited',
    'Delhi cold storage private limited',
    'Munshi ram manohar lal publishers private ltd',
    'Kaisons constructions private limited',
    'NAARI PHARMA PRIVATE LIMITED',
    'SWAM PNEUMATICS PRIVATE LIMITED',
    'Parmod plastic industries private limited',
    'Rockwin flowmeter (india) private limited',
    'Anand brakelinings and chemicals private limited',
    'Esms esource consulting private limited',
    'EMPWELL ENTERPRISE PRIVATE LIMITED',
    'Krishan medical centre',
    'Pure feeds and foods private limited',
    'Suave enterprises private limited',
    'D.j.s. printers private limited.',
    'R d chemicals private limited',
    'Lkt engineering consultants limited',
    'Techno designers private limited',
    'Synergic trailer & auto solutions private limited',
    'DG TECH',
    'S AYURVEDAVAIDYASALA PRIVATE LIMITED',
    'K. s. automotive private limited',
    'Adigohar engineers and consultants private limited',
    'Shikha distributors private limited',
    'Duet electronics enterprise private limited',
    'Pepco machinery pvt.ltd.',
    'Edcons automobiles private limited',
    'Laxmi sales and service private limited',
    'Srk automobile and marketing private limited',
    'Thar motor company private limited',
    'Audit diagnostics india private limited',
    'Sairam commercial private limited',
    'Anmol barter private limited',
    'Astha barter private limited',
    'Rbg retail private limited',
    'SCL DEVELOPERS PRIVATE LIMITED',
    'Mehak enterprises private limited',
    'Pratibha garments private limited',
    'KAPS VEHICLE & SPARES (INDIA) PRIVATE LIMITED',
    'Uttranchal overseas private limited',
    'WORLDONE PRIVATE LIMITED',
    'Kaarau collections private limited',
    'D.r. distributors private limited',
    'Vitthaldas govardhandas ginners private limited',
    'Shah nanji nagsi exports private limited',
    'Nm merchantiles limited',
    'Ncg enterprises limited',
    'Kingston impex private limited',
    'Preeti enclave pvt ltd',
    'Sarvottam goods private limited',
    'Su import services private limited',
    'S f steels pvt ltd',
    'Hpc export private limited',
    'Gutenberg communications private limited',
    'A .r. s. enterprises private limited',
    'Raghuvanshi enterprises private limited',
    'SNB MINERALS PRIVATE LIMITED',
    'Yamsi intertrade private limited',
    'SARVESHVAR COMMODITIES (INDIA) LIMITED',
    'Spark markbuildcap private limited',
    'Sourcing bym private limited',
    'Star electronic world private limited',
    'Richmel life sciences private limited',
    'DIVYANSH AUTOMOBILES PRIVATE LIMITED',
    'Lionel edwards ltd',
    'Aardee agencies pvt ltd',
    'Videotex international private limited',
    'ANDERSON GREENWOOD CROSBY SANMAR LIMITED',
    'SCL CONSULTANCY AND TRADING PRIVATE LIMITED',
    'Fort infrastructure development private limited',
    'JAGADISH & ASSOCIATES IMPEX PVT. LTD.',
    'Him overseas pvt ltd',
    'Akasva associates private limited',
    'Truevalue trade-links private limited',
    'Sharma exim private limited',
    'Sms impex private limited',
    'Metalex office system private limited',
    'Muskan commodeal private limited',
    'Genius suppliers private limited',
    'Srijan commercial private limited',
    'Rahul chains private limited',
    'Kanjimull lachhman dass jewellers private limited',
    'Monsoon impex private limited',
    'Funidea vinimay private limited',
    'Sasmal marcom private limited',
    'Satyalaxmi vanijya private limited',
    'Certified accountants academy',
    'Shubham accounting services private limited',
    'Aviom medcare at home private limited',
    'Corporate legal and taxation advisory private limited',
    'Busch family foundation',
    'Unique id (india) private limited',
    'Om fire safety company private limited',
    'IFINGLOBAL CORP PRIVATE LIMITED',
    'Aequitas consulting private limited',
    'Spandan eco foundation',
    'Indchem software technologies (india) limited',
    'Russell reynolds associates india private limited',
    'FONG',
    'S FOODS PRIVATE LIMITED',
    'BE SWASTH HEALTHCARE LIMITED',
    'Deepa trade & commerce ltd',
    'Concicon construction private limited',
    'Elkom enterprises pvt ltd',
    'S m bakers private limited',
    'Indras agencies private limited',
    'Shivashakti sugars limited',
    'Menoka tea estate pvt ltd',
    'Newby teas overseas private limited',
    'Royalmalabar foods private limited',
    'WEST LAND BUILDCON LIMITED',
    'Hindustan spirits limited',
    'Romana distillery industries private limited',
    'V & V BEVERAGES PRIVATE LIMITED',
    'Kohinoor grain processing private limited',
    'Vistar facility management private limited',
    'Brahmaputra projects private limited',
    'Sahiba frozen foods export private limited',
    'A b cotspin india limited',
    'Puran chand rice mills private limited',
    'Ub foods private limited',
    'Suriya spintex private limited',
    'Udayak agro products private limited',
    'Ratnam securities private limited',
    'Kuldhara investments private limited',
    'SUNDARAM FINANCE HOLDINGS LIMITED',
    'SUNDARAM FUND SERVICES LIMITED',
    'Herbert holdings ltd',
    'Birdie trading private limited',
    'Amatra travel & leisure private limited',
    'Shatakshi mudra investment pvt ltd',
    'Venimadhav commodities private limited',
    'Kanav capital advisors private limited',
    'VERDANT HORIZONS PRIVATE LIMITED',
    'MULTI AMBIT PRIVATE LIMITED',
    'Vriddhi infin private limited',
    'Lgf services limited',
    'Greta investments private limited',
    'Shree ganesh stock pvt. ltd.',
    'U tourizmo private limited',
    'Ka ventures private limited',
    'XOHA STAYS PRIVATE LIMITED',
    'Chirag vinimay private limited',
    'Jet express clearing agency private limited',
    'Aakar technobuild private limited',
    'Lupin buildcap private limited',
    'Vci hospitality limited',
    'Choice real estate developers private limited.',
    'Vipri promoters holding private limited',
    'Alpine reality private limited',
    'Vinterla logistics private limited',
    'Morphogenesis realty private limited',
    'Asf facility management private limited',
    'Radheyshyam township and developer private limited',
    'Diamond business solutions private limited',
    'MAVERICK DREAM BUILDERS PRIVATE LIMITED',
    'White house properties private limited',
    'Aks information technology services private limited',
    'Manash estates pvt. ltd.',
    'Avenue builders pvt ltd',
    'Nawal investment pvt. ltd.',
    'Mount shivalik investments limited',
    'Jagjan nivesh private limited',
    'Padrone promoters pvt ltd',
    'Eureka retail services private limited',
    'Ray enclave pvt ltd',
    'Tetra asset co pvt ltd',
    'Christopher estates pvt ltd',
    'Rsb global private limited',
    'Kay finvest private limited',
    'Surat fincap pvt ltd',
    'Jubin finance and investment limited',
    'Brahm sikha investment private limited',
    'Sahyog kuries private limited',
    'Cherupushpam kuries olarikkara pvt ltd',
    'Ashray hi-rise private limited',
    'Bengal ben-fort aqua ltd',
    'Azimganj estates pvt ltd',
    'Haripuri estate private limited',
    'Godriwala real estate private limited',
    'Ultimate realty private limited',
    'Theolia wind energy private limited',
    'Agsons real estates private limited',
    'SARJAN REALITIES PRIVATE LIMITED',
    'The central calcutta investments pvt ltd',
    'Starline buildwell private limited',
    'Rise projects private limited',
    'New era planners private limited',
    'Vascoda housing & realtech private limited',
    'Zocalo realtech private limited',
    'Sportz & live entertainment private limited',
    'ORANGE TREE TECHNOLOGIES PRIVATE LIMITED',
    'Garima properties pvt ltd',
    'Jiwan sagar promotors pvt. ltd.',
    'Varapradha real estates private limited',
    'Ved nirman limited',
    'Ashmani developers limited',
    'Orbit abasan private limited',
    'Aadarsh infrapromoters private limited',
    'Shivalik infradevelopers private limited',
    'Orbit niketan private limited',
    'ELECTRONICA INDIA LIMITED',
    'Sarvaga infra advisory private limited',
    'Julex commercial company ltd.',
    'Settlement realtors private limited',
    'Pink palace construction private limited',
    'Hawks town planners private limited',
    'Capable buildtech private limited',
    'Forever buildtech private limited',
    'Shrida propmart private limited',
    'Navkar commercials private limited',
    'Park street properties pvt ltd',
    'Ramani projects private limited',
    'Avant garde ventures private limited',
    'Guarantors infrastructure private limited',
    'Majerhat estates & developers ltd',
    'Premier merchants pvt ltd',
    'Ramani housing private limited',
    'Swabhumi construction & estate developers private limited',
    'Priyam infrastructure private limited',
    'Sunshine valley private limited',
    'Trimurti vatika private limited',
    'Trimurti villa private limited',
    'Trimurti aavas private limited',
    'Overtop infra projects private limited',
    'Panagarh projects private limited',
    'Bengal p s housing limited',
    'Satyalaxmi promoters private limited',
    'Snowblue towers private limited',
    'Schon realtors private limited',
    'Radhey infracon private limited',
    'Magiciti developers private limited',
    'Inaya infrastructure private limited',
    'Smriti apparels private limited',
    'Tics hospitality private limited',
    'RANAS COUTURE PRIVATE LIMITED',
    'Mangalam fashions limited',
    'Magma foods private limited',
    'Vasari india private limited',
    'Cosmic garments private limited',
    'Kudos spices private limited',
    'Ark innovations private limited',
    'Qualfis foodz private limtied',
    'Peregrine saraya organics private limited',
    'Haryana drinks private limited',
    'DIAMOND BEVERAGES PRIVATE LIMITED',
    'Tirupati tradelinks private limited',
    'Coorg veneers and laminates private limited',
    'Alishan veneer & plywood pvt.ltd.',
    'Faith lumber private limited',
    'Geetanjali ply and veneers private limited',
    'Bhikusa yamasa kshatriya private limited',
    'Kalpana biri manufacturing co private limited',
    'Ruhatiya spinners private limited',
    'Golden terry fab private limited',
    'Blueline apparels private limited',
    'Primrose paper mills pvt ltd',
    'R k goyal paper products private limited',
    'At home india private limited',
    'JEEVAN UTTHAN FINANCIAL SERVICES PRIVATE LIMITED',
    'Marmonite (india) pvt. ltd.',
    'Jaybee drilling private limited',
    'Promising exports ltd',
    'Celestial knits & fabs private limited',
    'CHEMPLAST CUDDALORE VINYLS LIMITED',
    'Hare krishna entertainment & media private limited',
    'D n embroideries private limited',
    'Techno flex india pvt ltd',
    'Yashvi fashions private limited',
    'Ultratech township developers private limited',
    'Best golden developers private limited',
    'Mysore logistics private limited',
    'Formz builders private limited',
    'Noahark propertiez private limited',
    'Mulund properties developers pvt ltd',
    'Mehul properties private limited',
    'Mehul estate pvt ltd',
    'South india properties private limited',
    'Dakshin developers private limited',
    'Suditi developers private limited',
    'Mars estates private limited',
    'Galiakotwala properties private limited',
    'White knight real estate private limited',
    'Hamlin constructions private limited',
    'Sukhm infrastructures private limited',
    'Eurostar realtors private limited',
    'Bonus suppliers private limited',
    'Bonus tradelink private limited',
    'Brahmaputra resorts private limited',
    'Talwandi estates pvt ltd',
    'Sona infrapark private limited',
    'B and s realtors private limited',
    'Tiara estates private limited',
    'Birbal international private limited',
    'United masonary private limited',
    'A k shelters private limited',
    'Ananti builders & construction private limited',
    'NILGIRI COMMERCIAL ESTATE PRIVATE LIMITED',
    'Worlds window estate private limited',
    'Value realtors private limited',
    'Technocraft developers private limited',
    'Technoultra engineers private limited',
    'Willbrose hitech infrastructure private limited',
    'Acacia buildcon private limited',
    'Tron infra tech private limited',
    'Siva realty ventures private limited',
    'Laguna real estates private limited',
    'Ganaraj real estates private limited',
    'Palaceio property developers private limited',
    'Adarsh realty and hotels private limited',
    'Malayalam industries limited',
    'Potential builders pvt ltd',
    'Mruga properties p ltd',
    'Vandan properties private limited',
    'Poojan properties p ltd',
    'Maulik properties p ltd',
    'Matrushree developers pvt ltd',
    'Krishna housing and finance (india) p.ltd.',
    'Sahil real estate private limited',
    'Sarthak properties private limited',
    'Sumeru properties private limited',
    'Atul properties pvt ltd',
    'Shree bal properties and finance private limited',
    'RICHWELL ENTERPRISES PRIVATE LIMITED',
    'S.b. apartments pvt. ltd.',
    'Shiv parvati land developer private limited',
    'Tripura sundari builders private limited',
    'Ganpati landbase private limited',
    'Wagar infrastructure private limited',
    'Cupid properties private limited',
    'Kasturi estates private limited',
    'City capital foundation limited',
    'Mangal tirth estate limited',
    'Ritechoice foundations & engineering private limited',
    'Dey commercial (holdings) pvt ltd',
    'Tolly properties pvt ltd.',
    'Sneha ashiana private limited',
    'Greenfield realty private limited',
    'Pacific realtors private limited',
    'Suncity nirman pvt ltd',
    'Garia housing private limited',
    'New age realty private limited',
    'SUPERVALUE CONSTRUCTIONS PRIVATE LIMITED',
    'Aman enclave private limited',
    'Equinox land projects india limited',
    'Upasana developers and promoters private limited',
    'Azure realty private limited',
    'Rof infratech and housing private limited',
    'Nat infra private limited',
    'Shakuntalam buildcon private limited',
    'Mj homes private limited',
    'Aama greens private limited',
    'Capital real estate developer private limited',
    'Mk infra holdings private limited',
    'West coast ventures (india) private limited',
    'Suntec infrastructure private limited',
    'VIRTUOSO REALTY-CONSTRUCTION PRIVATE LIMITED',
    'Equinox business parks private limited',
    'Ilex developers & resorts limited',
    'Dwarka realties private limited',
    'NIRMIT EPC SERVICES PRIVATE LIMITED',
    'Sasmita estates private limited',
    'Mars enclave private limited',
    'Clas realty private limited',
    'Ibrox real estate development private limited',
    'Signet garments private limited',
    'ATRIUM PLACE DEVELOPERS PRIVATE LIMITED',
    'Galaxy instruments pvt ltd',
    'Spintex impex private limited',
    'PRAGYA INTERNATIONAL CENTRE FOR DEVELOPMENT ACTION & RESEARCH',
    'Unisys india pvt ltd',
    'Kalyan aqua & marine exports india private limited',
    'K.p.r universal holdings private limited',
    'Eventoss entertainment private limited',
    'Link online private limited',
    'Ace invest private limited',
    'Sanganeriya spinning mills limited',
    'Woodidea floorings private limited',
    'Mita india private limited',
    'Abs aluminates private limited',
    'Tnbt marketing services private limited',
    'L.m. polymers private limited',
    'Medisurge technologies private limited',
    'B four express services private limited',
    'Inxero technologies private limited',
    'Knowledge process services private limited',
    'Ipm learning india private limited',
    'Mak infotek private limited',
    'Everest vaults private limited',
    'Concourse consultancy services private limited',
    'Avn travels & exhibitions private limited',
    'Muktar logistics (india) private limited',
    'Muktar shipping (india) private limited',
    'Xec blue metals private limited',
    'Praxis services private limited',
    'Neumck strategy & advisory private limited',
    'Seek research solutions private limited',
    'Omegafortune travels private limited',
    'Indus infraservices private limited',
    'Globalaxis engineering services private limited',
    'Techloid integrated solutions private limited',
    'Chams branding solutions india private limited',
    'Trade and technology exposition company (india) pvt ltd',
    'Three d enterprises private limited',
    'Cosmicmandala15 spa private limited',
    'Imz media solutions private limited',
    'Ad scaffolds private limited',
    'Researchbytes corporate services .private limited',
    'Nxt design solutions private limited',
    'Evron services private limited',
    'Amber softtech systems private limited',
    'Save pune traffic movement',
    'Cosign india private limited',
    'Orion instruments private limited',
    'Parus instruments private limited',
    'Volare technologies private limited',
    'Dhruva shipping consultants and services private limited',
    'Blue dot transform consulting private limited',
    'U s biomedical systems india private limited',
    'Sreeji coastal shipping private limited',
    'Vijay durga windoors private limited',
    'Byas foto retail private limited',
    'Green time projects private limited',
    'Birthplace healthcare private limited',
    'Remedium health technologies private limited',
    'First choice forex & services private limited',
    'Integrated assessment services private limited',
    'Macrocomm advanced applied technologies private limited',
    'Bluebugs communications private limited',
    'Cool care india private limited',
    'Blushing cherry private limited',
    'Anova corporate services private limited',
    'Talentease business solutions private limited',
    'Akshaya services private limited',
    'Serama logistics private limited',
    'Omrudra portfolio management private limited',
    'ADVENTZ INDUSTRIES INDIA PRIVATE LIMITED',
    'RESPONSE METALCRAFTS PRIVATE LIMITED',
    'Hariksha enterprises private limited',
    'Capacloud trading solutions private limited',
    'Intercon international private limited',
    'Reach abroad recruitment consultants private limited',
    'Siign-in placement consultancy private limited',
    'ROCK INTELLIGENCE & SECURITIES PRIVATE LIMITED',
    'CDI SECURITY INDIA PRIVATE LIMITED',
    'Tal secure systems private limited',
    'Surbhi z-plus security private limited',
    'Predator security services private limited',
    'Varsed facility management services private limited',
    'Kabir cleaning specialities private limited',
    'Global ip services private limited',
    'Ipp india limited',
    'Ace finepack private limited',
    'Rimple packaging private limited',
    'Champion gaskets private limited',
    'Bbf industries limited',
    'Coastal packagers pvt ltd',
    'Enterpreneur resourcing private limited',
    'Hera shipping solutions private limited',
    'Anand diaries private limited',
    'Nilpeter india private limited',
    'Findoc investmart private limited',
    'Nature morte art limited',
    'Dream scape interiors and exteriors private limited',
    'Lucid design (india) private limited',
    'Xillion design studio private limited',
    'SAFFRON DECORATIVES PRIVATE LIMITED',
    'Rustic arts private limited',
    'Westtek enterprises private limited',
    'Comart lithographers private limited',
    'Saraa mediaworks private limited',
    'Four runners electronics pvt ltd',
    'Spicy entertainment and media limited',
    'Nns events & exhibitions private limited',
    'Growth life media private limited',
    'Ksl media limited',
    'Commune marketing and events private limited',
    'Bla coke private limited',
    'SKF ENGINEERING AND LUBRICATION INDIA PRIVATE LIMITED',
    'Aditya coke private limited',
    'Prime power corporation limited',
    'Jason oil and engineering company private limited',
    'Carbon pod india limited',
    'LIFE LINE FOODS PRIVATE LIMITED',
    'Marketwave meditech private limited',
    'Join leader chemtech private limited',
    'NUBERG INDUSTRIES LIMITED',
    'Ankit multichem private limited',
    'Asolution pharmaceuticals private limited',
    'Bharat sprays private limited',
    'Novarus discoveries private limited',
    'Navrathi industries private limited',
    'Black diamond explosives private limited',
    'Cazita healthcare private limited',
    'Gufic private limited',
    'Beepee coatings private limited',
    'Mahalaxmi calchem private limited',
    'Shiv silica pvt ltd',
    'Shalibhadra dye-chem private limited',
    'Somaiya chemical industries private limited',
    'Robin chemicals private limited',
    'Aradhana gases pvt ltd',
    'Asha dispersions private limited',
    'Metcon coatings and chemicals (india) private limited',
    'Biocell technology private limited',
    'Nilefos chemicals india private limited',
    'Srinivasa cystine private ltd',
    'Prosol chemicals private limited',
    'Sarvotham care limited',
    'C. j. chemicals private limited',
    'HALANI FOODS PRIVATE LIMITED',
    'Jamipol limited',
    'Loxim industries limited',
    'Pushpendra dyechem pvt ltd',
    'P.k.chlorochem private limited',
    'Vardhman chemtech limited',
    'Millennium chemi pharma (mysore) private limited',
    'Chemie organic chemicals (india) private limited',
    'EM SQUARE HOMES PRIVATE LIMITED',
    'Super anchor india private limited',
    'Jai earth clay chemicals private limited',
    'Jairamdass and sons private limited',
    'Anirox pigments ltd',
    'Eastern resources pvt ltd',
    'Hindustan krishi bio-tech limited',
    'Vidhi polychem private limited',
    'Russell integrated pest management (india) private limited',
    'Maxrich foods limited',
    'Avitus india pest management private limited',
    'Ultratech textures paints private limited',
    'Anupam coatings private limited',
    'Hitech litho private limited',
    'BETA DRUGS LIMITED',
    'ALINTOSCH PHARMACEUTICALS PRIVATE LIMITED',
    'ENALTEC PHARMA RESEARCH PRIVATE LIMITED',
    'Mahavir laboratories private limited',
    'Neospark pharma private limited',
    'STYRAX PHARMA PRIVATE LIMITED',
    'Global nutraceuticals private limited',
    'Kekule pharma limited',
    'Rajlok diagnostic systems private limited',
    'Prexus health india private limited',
    'Shree ram gaox pvt ltd',
    'Shree swati texdyes private limited',
    'Adani pharmachem private limited',
    'AMNEAL PHARMACEUTICALS PRIVATE LIMITED',
    'Mcneil and argus pharmaceuticals limited',
    'Avesta biotherapeutics and research private limited',
    'Jacsons meditech private limited',
    'Lifetech laboratories private limited',
    'Life and health technologies private limited',
    'Apple therapeutics private limited',
    'Rkkr biotechnology private limited',
    'Phoenix remedies private limited',
    'Cebon india limited',
    'Sequent research limited',
    'Parakh chemicals pvt ltd',
    'Mak labs private limited',
    'Franco indian therapeutics pvt. ltd.',
    'Sanex pharmaceuticals limited',
    'Indo baijin chemicals private limited',
    'Bipha ayur sciences private limited',
    'HIRAN AGROCEUTICALS PRIVATE LIMITED',
    'D k pharma chem private limited',
    'Airovac pumps & engineering private limited',
    'ROSS LIFESCIENCE LIMITED',
    'SANJEEVANI AYUSHCARE PRIVATE LIMITED',
    'Fams consumer products private limited',
    'Avees biocos private limited',
    'Cosmo herbals limited',
    'Suntara cosmetics private limited',
    'Classic aromatics private limited',
    'Salasar balaji land developers private limited',
    'Equinox realty private limited',
    'Five k properties private limited',
    'Kjmc platinum builders private limited',
    'Vardhman residency private limited',
    'Aakash accomodations private limited',
    'Aksharesh constructions private limited',
    'VAGAD BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Mujat & arethiya constructions private limited',
    'Macrolite infraprojects private limited',
    'Xrbia north hinjewadi developers private limited',
    'Eiffel landmarks private limited',
    'Eiffel shelters private limited',
    'Anishwar infra private limited',
    'KPE PRIVATE LIMITED',
    'VARUN HOSPITALITY PRIVATE LIMITED',
    'Nivee property developers private limited',
    'Jaagruthi foundations private limited',
    'Vastu infrastructures private limited',
    'Yeswanth industrial infrastruture projects private limited (u/s 21)',
    'Grene robotics (india) private limited',
    'Kranti projects private limited',
    'VAMA INFRASTRUCTURE AND EQUIPMENT PRIVATE LIMITED',
    'M. b. corpn private limited',
    'TEKFARM PROJECT PRIVATE LIMITED',
    'Ppb construction private limited',
    'Scope enterprises private limited',
    'Medallion properties private limited',
    'Na divine habitat private limited',
    'Frontier housing private limited',
    'Vst projects private limited',
    'V l promoters private limited',
    'Metro civil technologies private limited',
    'B.r. infrapro private limited',
    'Multistar projects private limited',
    'Habitech infrastructure limited',
    'Prominent buildwell private limited',
    'Focus computech private limited',
    'I k infrastructure private limited',
    'Habitat buildtech private limited',
    'Rmg builders and developers private limited',
    'Silvertech construction private limited',
    'Bigway estate private limited',
    'Indraesh developers private limited',
    'Intra city developers private limited',
    'Pioneer procon private limited',
    'Collage estates private limited',
    'Sukhdham buildcon private limited',
    'Ambar buildcon private limited',
    'Bhiwani builders private limited',
    'Snow view buildcon private limited',
    'Positive buildwell pvt ltd',
    'SUNWORLD CITY PRIVATE LIMITED',
    'At dreams infra buildcon private limited',
    'GEO REALTORS PRIVATE LIMITED',
    'PARSHWANATH REALTY PRIVATE LIMITED',
    'Sun builders private limited',
    'Gujarat growth centres development corporation ltd',
    'PATEL INFRASTRUCTURE LIMITED',
    'SHASHIJIT INFRAPROJECTS LIMITED',
    'Jai salasar hanuman land private limited',
    'Arise realties private limited',
    'Diamond tmt & procon private limited',
    'Millenium conpro private limited',
    'Garur builders private limited',
    'Orchids apartments private limited',
    'BRAHMAS ENGINEERING AND CONSTRUCTION COMPANY PRIVATE LIMITED',
    'Rg-lakeside properties private limited',
    'Nalappad constructions pvt ltd',
    'Sree gokulam housing company private limited',
    'Tomar engineering solutions private limited',
    'Ashoka path nirman ( nasik ) private limited',
    'White knight constructions (india) private limited',
    'Ambrosial developers private limited',
    'Abhikrish properties private limited',
    'Starshine land developers private limited',
    'Abode homelands private limited',
    'Ashoka concessions limited',
    'CAYANA INFRATECH PRIVATE LIMITED',
    'Abnco logistics private limited',
    'Devenjai estates private limited',
    'Tushita developers pvt ltd',
    'Sheldon developers private limited',
    'ENERGIFY WASTE PRIVATE LIMITED',
    'Atharva consortium & realty private limited',
    'Seven oaks real estate private limited',
    'N.k.estates private limited',
    'Estilo moderno realty private limited',
    'TREASURE GRACE SHIPPING PRIVATE LIMITED',
    'Prominent portfolio private limited',
    'SADRAVYA RESEARCH PRIVATE LIMITED',
    'Techno auto components (india) private limited',
    'Hydra form (india) private limited',
    'Mayar infrastructure development private limited',
    'Abhishek fincap service pvt. ltd.',
    'Micro-azure computers private limited',
    'Cactus clothing private limited',
    'Khanna agencies private limited',
    'Mindmill software limited',
    'Tatva marketing and services private limited',
    'Vaishali (india) limited',
    'Fameco engineering contractors private limited',
    'Hari raj investments and consultants private limited',
    'Rayala papers private limited',
    'Zed-axis technologies private limited',
    'Mayar health resorts limited',
    'Srushti creations private limited',
    'IN-FORM ARCHITECTS PRIVATE LIMITED',
    'Techpark hotels private limited',
    'Skk estates private limited',
    'Argu soft india limited',
    'JYOTI BROKING PRIVATE LIMITED',
    'Tavant technologies india private limited',
    'SPRAYTEC (INDIA) LIMITED',
    'Holy holdings private limited',
    'Ratnakar impex private limited',
    'Swift corporation limited',
    'Ispark dataconnect private limited',
    'Tcq texport private limited',
    'Ak ecological farm private limited',
    'Craftech exports private limited',
    'G g advisory services private limited',
    'Exhibitions india (gujarat) private limited',
    'Viva holidays tours and travels private limited',
    'Fsl software technologies limited',
    'Nks financial services limited',
    'Ivory designs private limited',
    'Talent hired-the job store private limited',
    'Periyar energy limited',
    '99rpm web private limited',
    'Ada business services private limited',
    'Cis facility management private limited',
    'Ganesha personal care products private limited',
    'Mayar securities limited',
    'Nts navrattan jewellers private limited',
    'Raci spacers india private limited',
    'Sohal immigration consultant private limited',
    'Tru audio visuals private limited',
    'Plan-a designtec solutions private limited',
    'Kaptco talent solutions private limited',
    'Communication media products (india) private limited',
    'Elmech pneumetic industries private limited',
    'Adishree chemicals and fertilizers private limited',
    'Fashionite impex private limited',
    'J c textiles private limited',
    'MAA KALI STEELS PRIVATE LIMITED',
    'Furbo security solutions private limited',
    'Viable design consulting private limited',
    'Knack systems and services private limited',
    'Sepia venture private limited',
    'Curio glass wares private limited',
    '3P IDEAL GEOTECHNICAL SERVICES PRIVATE LIMITED',
    'Jsw techno projects management limited',
    'Vision twenty three garments pvt.ltd.',
    'Peak adventure tours private limited',
    'Unibros manufacturing company private limited',
    'DTU HOTELS PRIVATE LIMITED',
    'Planet farmtech private limited',
    'Palm aromacraft private limited',
    'Westinghouse electric india private limited',
    'Viva marine india private limited',
    'OMOTENASHI TECHLABS PRIVATE LIMITED',
    'Kundan fastners & multitrade private limited',
    'Osu global gateway india private limited',
    'ONEMAHANET INTERTAINMENT PRIVATE LIMITED',
    'Defcorp enterprises private limited',
    'Sovik events private limited',
    'Viva marine pelagic private limited',
    'Equinox lifecycle marketing private limited',
    'Parasrampuria engineers private limited',
    'MALAUDH AGRO LIMITED',
    'Jk design studio private limited',
    'Came india automation solutions private limited',
    'Cypress industries india private limited',
    'Tpm depot private limited',
    'Ftl cargo solutions private limited',
    'Mazel india private limited',
    'Advantek fuel technologies private limited',
    'Solidaridad network india private limited',
    'Mpaani solutions private limited',
    'Aura innovations private limited',
    'Transforme learning & leadership solutions private limited',
    'Pro-am business solutions private limited',
    'Jason pramodhan world private limited',
    'Rainsmart solutions private limited',
    'Spectacular mmt digital private limited',
    'Network property management services private limited',
    'Softalk infocom private limited',
    'Goodluck publishers limited',
    'In touch solutions private limited',
    'Vs offset engineers private limited',
    'Insight collaborative logistics private limited',
    'Bafna ginning and pressing private limited',
    'Teamco private limited',
    'C king tea consultancy private limited',
    'Lanson foods private limited',
    'Apricot foods private limited',
    'Sol ventures private limited',
    'CHITWAN BLENDERS & BOTTLERS PRIVATE LIMITED',
    'Mahendra cotton mills private limited',
    'Fashion impex private limited',
    'Crest clothing private limited',
    'Yamuna beverages private limited',
    'SURYA ETHNIC FASHION (INDIA) PRIVATE LIMITED',
    'V v decor private limited',
    'Gopi texfab private limited',
    'SARAF TEXTILE MILLS PVT LTD',
    'Sidha jutex limited',
    'Mangalam weavetech private limited',
    'Jainco aqua solutions private limited',
    'Sushila fabrics private limited',
    'K lite fashions private limited',
    'Eastern mattresses private limited',
    'Heneken creations private limited',
    'Adarsh ginning private limited',
    'Grace spinning mills private limited',
    'Sudarshan jeans private limited',
    'Lifestyle yarns private limited',
    'Rajaram mills private limited',
    'TIRUPUR COTTON SPINNING AND WEAVING MILLS PRIVATE LIMITED',
    'Jask invogue private limited',
    'Sri nukala rama koteswara rao textiles private limited',
    'Angiras textiles private limited',
    'Kutsa cotex private limited',
    'Niharika fabrics (india) private limited',
    'PFH MALL & RETAIL MANAGEMENT PRIVATE LIMITED',
    'Amoda spintex limited',
    'Aarna clothing private limited',
    'Anubha industries private limited',
    'Surya clothing private limited',
    'Precise seamless apparels private limited',
    'KISAN VIKAS GINNING PRESSING AND AGRICULTURE LIMITED',
    'Samundar fabrics pvt ltd',
    'Acme yarns private limited',
    'Strawberry lenceria private limited',
    'Kerala state textile corporation limited',
    'EXCEL GARMENTS MANUFACTURING PRIVATE LIMITED',
    'Mahajan silk mills pvt ltd',
    'Fab images india private limited',
    'INDIA FASHIONS PRIVATE LIMITED',
    'Maharshi cotex private limited',
    'Sri valli knitters private limited',
    'PENGUIN GARMENTS PRIVATE LIMITED',
    'GEMLAND PROPERTIES PRIVATE LIMITED',
    'Fabtech international hosieries private limited',
    'Rhythm knit india private limited',
    'Indarsen shamlal private limited',
    'Young cloth enterprises private limited',
    'Amrit cotton mills private limited',
    'Goenka fabs private limited',
    'Montage garments private limited',
    'Maa nellore parandaalamma industrial park private limited',
    'Amrit processors private limited',
    'D',
    'CORPORATE SOLUTIONS PRIVATE LIMITED',
    'FINANCIAL EDGE FINTECH PRIVATE LIMITED',
    'HVAC MARSONS POWER PRIVATE LIMITED',
    'Mana life care private limited',
    'Premium advisors private limited',
    'Docsuns services pvt ltd',
    'Prabodh artha wardhini private limited',
    'Empowered learning systems private limited',
    'Blue orion management solutions private limited',
    'Harshini epc private limited',
    'Om shiv shakti iron industries private limited',
    'Legacy global projects private limited',
    'Gipfel and schnell consultings private limited',
    'Pebble branding private limited',
    'V. m . woodcadd designing services private limited',
    'Nag infrastructure consulting engineers private limited',
    'Pollinate energy india private limited',
    'Beeshma advisory private limited',
    'Finmark trainers india private limited',
    'Perfect hands solutions private limited',
    'Hestia designs private limited',
    'Kavanal engineering company private limited',
    'Kadri consultants private limited',
    'Indage engineering private limited',
    'Rajaram management services private limited',
    'V-three designs private limited',
    'MTJR ENTERPRISES PRIVATE LIMITED',
    'P e engineers pvt ltd',
    'Elsytec controls private limited',
    'Modarchs consultants chennai private limited',
    'Kundan services and consultancy private limited',
    'Space solutions private limited',
    'Archer management services private limited',
    'FCBINTERFACE COMMUNICATIONS PRIVATE LIMITED',
    'Mareech advertising private limited',
    'FIJITA OUTDOOR ADS AND NETWORKS PRIVATE LIMITED',
    'Reflections advertising and marketing private limited',
    'Omnicom Media Group India Private Limited',
    'GOLDMINE ADVERTISING PRIVATE LIMITED',
    'Gopani iron and power (india) private limited',
    'Resource management group plus private limited',
    'Filereturn.com private limited.',
    'Rmg communications private limited',
    'Vcare engineering private limited',
    'Hotstuff advertising private limited',
    'Varadhi advertisers private limited',
    'Rillusion media private limited',
    'SKYLINES ADVERTISING PRIVATE LIMITED,',
    'Oncofocus solutions private limited',
    'Syama dynamic project developers private limited',
    'Thalikkunnil engineering services private limited',
    'Desionics project designs private limited',
    'Akasam consulting private limited',
    'Jnj powercom systems limited',
    'Crocus chattels private limited',
    'Mars cargo private limited',
    'Venus stampings private limited',
    'Sie-brains technology services private limited',
    'Sura leathers private limited',
    'Harihar granimarmo private limited',
    'Brilliant granite private limited',
    'Steril-gene life sciences private limited',
    'Kusum salt and minerals private limited',
    'Imerys minerals (india) private limited',
    'Vibrant engineers private limited',
    'Zen projects and constructions private limited',
    'Lumino industries limited',
    'Heavy industrial minerals india private limited',
    'Seksaria confectionaries private limited',
    'Conergy energy systems (india) private limited',
    'Amity aquatech private limited',
    'Om ushab impex private limited',
    'Avati impex private limited',
    'Mandeep grani marmo private limited',
    'Concab travel services private limited',
    'Unitech valdel valmark private limited',
    'Mama mia foods private limited',
    'A.v. shelters private limited',
    'Greenleaf projects private limited',
    'Merchant Agri Global Private Limited',
    'Penn frozen foods private limited',
    'DEL MONTE FOODS PRIVATE LIMITED',
    'Expert realtors private limited',
    'Infolink technologies private limited',
    'Mansarovar health club private limited',
    'Dhiraj offshore services private limited',
    'Aditya air products private limited',
    'SRI JAIBALAJEE AGRO PRODUCTS PRIVATE LIMITED',
    'V k offshore services india private limited',
    'Resources mining company private limited',
    'Elegant structurals private limited',
    'Ebro india private limited',
    'Arvind pickle india private limited',
    'Mand valley minerals private limited',
    'Upeksha sustainable products private limited',
    'Unistil alcoblends private limited',
    'Preesa foods and spices (india) private limited',
    'Western india bakers private limited',
    'Imperial food biz private limited',
    'Anil mines and minerals limited',
    'Surya bakery and confectionery private limited',
    'Chitra stonex private limited',
    'AADIV TRADING PRIVATE LIMITED',
    'Satra mines and minerals private limited',
    'BLOOMSBURY',
    'S CARGO LOGISTICS PRIVATE LIMITED',
    'Seascape shipping logistics private limited',
    'Circle clearing and shipping services private limited',
    'Rts logistics private limited',
    'NOATUM LOGISTICS INDIA PRIVATE LIMITED',
    'Vichi it solutions private limited',
    'Mogo crm solutions private limited',
    'Spudweb optisols private limited',
    'CORONIS AJUBA SOLUTIONS PRIVATE LIMITED',
    'Megamind computing solutions private limited',
    'Mark softech private limited',
    'Reliasoft india private limited',
    'Pivotix software private limited',
    'Sree vinayaka technology and business solutions private limited',
    'Jean martin systems india private limited',
    'Sim infosystems private limited',
    'SUN & XBOTS TECHNOLOGIES PRIVATE LIMITED',
    'Computer transworld (it) private limited',
    'Datamax technologies private limited',
    'Teknip technologies private limited',
    'Kaspon techworks private limited',
    'Matrix multimedia technologies india private limited',
    'PRIMO AQUA GREEN PRIVATE LIMITED',
    'Corpuslabs solutions private limited',
    'THIRAN HUB PRIVATE LIMITED',
    'Aveon infotech private limited',
    'Aim technologies private limited',
    'Hexcode technologies private limited',
    'Netwings infotech private limited',
    'LEXCELLENT LEGAL ASSOCIATES PRIVATE LIMITED',
    'Clematis software technologies private limited',
    'Sscs infotech private limited',
    'S2c network private limited',
    'Iguru software solutions private limited',
    'Paradigm infoways private limited',
    'IGT SOLUTIONS PRIVATE LIMITED',
    'Mdeverywhere india private limited',
    'Zync world private limited',
    'Saaranya hospitality technologies private limited',
    'Evollab technologies private limited',
    'Tessolve semiconductor private limited',
    'Bharathi mediscribe private limited',
    'FIME INDIA PRIVATE LIMITED',
    'Yups tech solutions private limited',
    'Orion tele services private limited',
    'INFINTRIX GLOBAL LIMITED',
    'Gazon communications india limited',
    'Paathshala learning solutions private limited',
    'Smartnet networks private limited',
    'Indian eagle private limited',
    'Rsalesarm it servicesprivate limited',
    'Foxtel telecommunications private limited',
    'Poseidon design systems private limited',
    'Adylan technologies private limited',
    'Dots broadcast solutions private limited',
    'CHARTER GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'Unnati info solution private limited',
    'Monotype solutions india private limited',
    'Synergy informatics (services) pvt ltd',
    'Trikaal tech enterprises private limited',
    'Sen cybertech private limited',
    'Vc solutions private limited',
    'Infoface technologies private limited',
    'Ballistic learning private limited',
    'Remindnmore info.com private limited',
    'Mins technologies private limited',
    'Tactical value technology solutions private limited.',
    'Yoctel solutions private limited',
    'Rms risk management solutions india private limited',
    'TRYFACTA CONSULTING PRIVATE LIMITED',
    'Soft4u solutions private limited',
    'Trignodev softwares private limited',
    'Realtech infosolutions private limited',
    'Tvastar engineering solutions private limited',
    'Dw customer support private limited',
    'BRICKSTEEL ENTERPRISES INFO TECH PRIVATE LIMITED',
    'Belltrox infotech services private limited',
    'Sassafras infotech private limited',
    'Shroff information technology services private limited',
    'ODOO IN PRIVATE LIMITED',
    'Wittybee technologies limited',
    'BCT DIGITAL PRIVATE LIMITED',
    'Valley creek software services (india) private limited',
    'V care communications private limited',
    'Deltatec solutions private limited',
    'Data software research co.(international)private ltd',
    'Telescreen communications private limited',
    'Toluna india private limited',
    'TRES CARE PRIVATE LIMITED',
    'Egramserve bpo services private limited',
    'Ucweb mobile private limited',
    'Kumi labs private limited',
    'Paxcom india private limited',
    'Satcom ground systems private limited',
    'Saimed systems private limited',
    'SMARSH INDIA PRIVATE LIMITED',
    'MOTOROLA SOLUTIONS KODIAK NETWORKS INDIA PRIVATE LIMITED',
    'Wisdom it services india private limited',
    'Saransh software solutions private limited',
    'Virtubridge embedded technologies private limited',
    'Tycoon financiers private limited.',
    'Dnyandeep infotech private limited',
    'Interface commustar private limited',
    'Casby logistics private limited',
    'Skh education private limited.',
    'Educational initiatives private limited',
    'Farry educational foundation private limited',
    'Catalysis education private limited',
    'FIRESPIKE EDUCATION & TECHNOLOGIES PRIVATE LIMITED',
    'Mint educity private limited',
    'Stones2milestones (south) edu private limited',
    'Bonanza medical tourism private limited',
    'Ibooks school private limited',
    'Star flight training educare private limited',
    'Meta-i technologies private limited',
    'Sg institute of management studies private limited',
    'Aeon learning private limited',
    'KEEP LEARNING RESOURCES PRIVATE LIMITED',
    'Giis k12 education private limited',
    'AMPS DIGITAL PRIVATE LIMITED',
    'GTD TECHNOLOGIES PRIVATE LIMITED',
    'ASIAN PACIFIC LEARNING LEVERAGE PRIVATE LIMITED',
    'LABORATORY FOR ENVIORNMENT TECHNOLOGY PRIVATE LIMITED',
    'Sylvant advisors private limited',
    'Am edumedia private limited',
    'EDUCATIONAL RATING AND ASSESSMENT FOUNDATION',
    'Pcba tools private limited',
    'DIALEC MEDICAL SERVICES PRIVATE LIMITED',
    'ALTERNATIVE LEARNING SYSTEMS Limited',
    'Rockfurd education private limited',
    'Wedas corporation private limited',
    'Skilltree knowledge consortium private limited',
    'Europe study centre private limited',
    'TTC SCHOOL OF HEALTH AND SAFETY PRIVATE LIMITED',
    'MYLAW LEARNING RESOURCES PRIVATE LIMITED',
    'Surgeine healthcare (india) private limited',
    'Shridhar shriram foundation',
    'Minority development council',
    'Good hopes hospitals limited',
    'Bangalore chemical and manufacturing company private limited',
    'Champion properites private limited',
    'Sansha system limited',
    'DR.SHETTYâ€™S NEW MEDICAL CENTRE PRIVATE LIMITED',
    'Aswati inns private limited',
    'Narayan eye foundations private limited',
    'Uae exchangeandfinance limited',
    'Suryodai builders private limited',
    'CDYMAX (INDIA) PHARMA PRIVATE LIMITED',
    'Laxmi agrotech private limited',
    'Genco holdings private limited',
    'Nandi engineering limited',
    'Nandi highway developers limited',
    'KALYANI INFRASTRUCTURE PROJECTS LIMITED',
    'Pride and expert properties private limited',
    'Bvg domestic services private limited',
    'Higher life fellowship centre',
    'Mazumdar shaw medical foundation',
    'Altron hotels private limited',
    'Hospital guide foundation',
    'Ajanta academic foundations',
    'Suvidya institute of technology private limited',
    'Ivy health and life sciences private limited',
    'Grewal clinics private limited',
    'Ivy healthcare infrastructure private limited',
    'Interglobe education foundation',
    'Dstor technologies private limited',
    'Rwl healthworld limited',
    'Cygnus medicare private limited',
    'Hariman laboratories pvt ltd',
    'Speedacc learning systems private limited',
    'Expert developers private limited',
    'Joy of giving global foundation',
    'Youcanfree.us human rights protection services private limited',
    'Bentley investments private limited',
    'S.p.e.e.d. consulting private limited',
    'Valdel power private limited',
    'Encompass software and systems private limited',
    'Metcut toolings private limited.',
    'Tristar charitable foundation',
    'Indian ammonium nitrate manufacturers association',
    'Auto cluster development and research institute',
    'Syngenta foundation india',
    'Sri raghavendra marketing services private limited',
    'Lifecare enterprises private limited',
    'Spenta color lab pvt ltd',
    'Viacom 18 media private limited',
    'Excel productions audiovisuals private limited',
    'Benzz media private limited.',
    'Hospisoft private limited',
    'ARTEM HEALTHTECH PRIVATE LIMITED',
    'Canvera digital technologies private limited',
    'Trancefx studios private limited',
    'Percept limited',
    'Pvp media ventures private limited',
    'Madhyamam broadcasting limited',
    'Macro infotech private limited',
    'Cyberdyne software orchard private limited',
    'Corporate events (i) pvt.ltd.',
    'L7h life resources overseas private limited',
    'Future sports foundation',
    'Cbs entertainment private limited',
    'Padukone sports management private limited',
    'LIFE',
    'CLOCK WHOLESALE PRIVATE LIMITED',
    'RAVELEJA PRIVATE LIMITED',
    'HPCONTINENTAL BI-WHEELERS PRIVATE LIMITED',
    'AMEERS HITECH BUILDERS PRIVATE LIMITED',
    'CESOURCE TECHNICAL PRIVATE LIMITED',
    'UTSUKUSHII INTERIORS PRIVATE LIMITED',
    'KARJIGI INFRATECH PRIVATE LIMITED',
    'ECHTE PROJECTS PRIVATE LIMITED',
    'CIAO GREEN PRIVATE LIMITED',
    'SHIV NIWAS DEVELOPERS PRIVATE LIMITED',
    'D.S.E.S. INFRATECH PRIVATE LIMITED',
    'MAGENTA POWER PRIVATE LIMITED',
    'ADITYA BIRLA RENEWABLES SPV 1 LIMITED',
    'BANGALORE SOLAR POWER PRIVATE LIMITED',
    'EN ASKI WINDFARMS PRIVATE LIMITED',
    'P.C. SNEHAL CONSTRUCTION PRIVATE LIMITED',
    'DREMART E-SELLERGURU INFO SOLUTIONS PRIVATE LIMITED',
    'SHROFF IMPEX PRIVATE LIMITED',
    'GS PEB AND CIVIL WORKS PRIVATE LIMITED',
    'PUNEET GROUP PRIVATE LIMITED',
    'MD AIR & OCEAN FREIGHT INDIA PRIVATE LIMITED',
    'ENTRADIO SOLUTIONS PRIVATE LIMITED',
    'AJ INCUBATION FORUM',
    'PISON IMPEX PRIVATE LIMITED',
    'SOLARGENCO ELECTRICITY PRIVATE LIMITED',
    'SURAT INTERNATIONAL DIATRADE CENTER',
    'INSTELLARS GLOBAL CONSULTING PRIVATE LIMITED',
    'AIREXPERTS FRAGRANCES INDIA PRIVATE LIMITED',
    'EPARK PLACES PRIVATE LIMITED',
    'SPRNG VAYU VIDYUT PRIVATE LIMITED',
    'SPRNG AGNITRA PRIVATE LIMITED',
    'DIGITALAPICRAFT PRIVATE LIMITED',
    'VALVE AUTOMATION INDIA PRIVATE LIMITED',
    'LECTURENOTES TECHNOLOGIES PRIVATE LIMITED',
    'QUINTICSURGE TECHNOLOGIES PRIVATE LIMITED',
    'FREAKY INNOVATORS PRIVATE LIMITED',
    'SANDEVIN ANALYTICS PRIVATE LIMITED',
    'ARMAF LUXURY FRAGRANCE INDIA PRIVATE LIMITED',
    'COUVERTURES INDIA PRIVATE LIMITED',
    'RAMAMANDIRAM MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'CODEFLIES TECHNOLOGIES PRIVATE LIMITED',
    'FLATWORLD HEALTHCARE SERVICES PRIVATE LIMITED',
    'PREZENTIUM INDIA PRIVATE LIMITED',
    'YAHA LIFE PRIVATE LIMITED',
    'BHARATHI & ASSOCIATES ASSET BUILDING PRIVATE LIMITED',
    'VYAM DEVELOPMENT FOUNDATION',
    'VIENCEE PHARMA SCIENCE PRIVATE LIMITED',
    'PRESTIGE RETAIL VENTURES LIMITED',
    'LIFESAATHI PRIVATE LIMITED',
    'FK LIFE PRIVATE LIMITED',
    'QBD BIOSCIENCES PRIVATE LIMITED',
    'SUHANIL ANALYTICS PRIVATE LIMITED',
    'POLSTRAT COMMUNICATION PRIVATE LIMITED',
    'CITYFRAME INFRA - DEVELOPERS PRIVATE LIMITED',
    'DAIICHIKOUTSU INDIA PRIVATE LIMITED',
    'UQUIFA INDIA PRIVATE LIMITED',
    'MONKSAYS SUPERFOODS PRIVATE LIMITED',
    'RUDRA SPICES & DRY FRUITS PRIVATE LIMITED',
    'SWIRL LAB HOSPITALITIES PRIVATE LIMITED',
    'VAER SOLUTIONS PRIVATE LIMITED',
    'PREXUS GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TRUE WANDERER PRIVATE LIMITED',
    'MFS LOGISTICS PRIVATE LIMITED',
    'KARM SALES AND SERVICES PRIVATE LIMITED',
    'MEDULANCE HEALTHCARE PRIVATE LIMITED',
    'VIPUL HOMES INDIA PRIVATE LIMITED',
    'PROWIZ SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'VINEY AGGARWAL INDUSTRIES PRIVATE LIMITED',
    'EXCELGOODIES TRAINING AND CONSULTING SERVICES PRIVATE LIMITED',
    'QUINTON AIR & ODOR MANAGEMENT PRIVATE LIMITED',
    'VIVRITI NEXT PRIVATE LIMITED',
    'SVIKRTI TECHNOLOGIES PRIVATE LIMITED',
    'CELLHUB TECHNOLOGIES PRIVATE LIMITED',
    'MINKO PLATFORMS PRIVATE LIMITED',
    'IP PLASTOTECH PRIVATE LIMITED',
    'YAMUNA NAGAR GYMKHANA CLUB LIMITED',
    'MAESTRO TRAVEL VENTURES PRIVATE LIMITED',
    'PASHYANTI TECHNOLOGIES PRIVATE LIMITED',
    'GDR AGRO INDUSTRIES PRIVATE LIMITED',
    'VARTA LABS PRIVATE LIMITED',
    'SPRNG ALT ENERGY PRIVATE LIMITED',
    'GMN EVENTS PRIVATE LIMITED',
    'SPRNG SOURA KIRAN VIDYUT PRIVATE LIMITED',
    'GREATEST COMMON FACTOR PRIVATE LIMITED',
    'VARADA VEHICLES PRIVATE LIMITED',
    'CLIENCE PRIVATE LIMITED',
    'ASHIKA INVESTMENT MANAGERS PRIVATE LIMITED',
    'NEISA TRACKING SERVICES PRIVATE LIMITED',
    'ASEARCH ONLINE MEDIA PRIVATE LIMITED',
    'S2 SIGNPOST INDIA PRIVATE LIMITED',
    'TIRUMALLA HAIR OIL INDIA PRIVATE LIMITED',
    'SV PITTIE INTERNATIONAL PRIVATE LIMITED',
    'VIOLET AUTOMATION PRIVATE LIMITED',
    'ATC WEDDING PRIVATE LIMITED',
    'SUMHR SOFTWARE PRIVATE LIMITED',
    'SIGFIG INDIA PRIVATE LIMITED',
    'ANUAKSH RENEWABLE ENERGY PRIVATE LIMITED',
    'AUTONOVIRE SERVICES PRIVATE LIMITED',
    'RAYS INVESTMENT ADVISER PRIVATE LIMITED',
    'NIFLR TECHNOLOGIES PRIVATE LIMITED',
    'BIZZCAT TECH SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'BLISS WELNESS PRIVATE LIMITED',
    'AEROSTROVILOS ENERGY PRIVATE LIMITED',
    'EZY MOV SYSTEMS PRIVATE LIMITED',
    'MKTS GLOBAL PRIVATE LIMITED',
    'TOVERTO SOLUTIONS PRIVATE LIMITED',
    'SMARTLYTICS INNOVATIONS PRIVATE LIMITED',
    'EPIROCKS CONSULTING (OPC) PRIVATE LIMITED',
    'WORKPULSE SOFTWARE PRIVATE LIMITED',
    'SHAURYAM LIFETECH PRIVATE LIMITED',
    'YAKSHA HOLIDAY HOME PRIVATE LIMITED',
    'CURRY WESTERN MOVIES PRIVATE LIMITED',
    'MICROWATT ENERGY SYSTEMS PRIVATE LIMITED',
    'ACTIVIN CHEMICALS AND PHARMACEUTICALS PRIVATE LIMITED',
    'GIOIELLI ARGENTO PRIVATE LIMITED',
    'STRAFOX TECH VENTURES PRIVATE LIMITED',
    'BRUNCHBITES PRIVATE LIMITED',
    'NEMOCARE WELLNESS PRIVATE LIMITED',
    'PIMPRI CHINCHWAD SMART CITY LIMITED',
    'VIGNANA JYOTHI FOUNDATION FOR ENTREPRENEURIAL EXCELLENCE',
    'LOKAM FOUNDATION',
    'HOOKSTICK AUTOMATION PRIVATE LIMITED',
    'BANSAL PATHWAYS (MANGAWAN-CHAKGHAT) PRIVATE LIMITED',
    'INDOOR SYSTEMS SOLUTIONS PRIVATE LIMITED',
    'KEARA ENTERPRISES PRIVATE LIMITED',
    'HYDRISE FOODS AND BEVERAGES PRIVATE LIMITED',
    'SENETIC INDIA PRIVATE LIMITED',
    'NB SOLAR SOLUTIONS PRIVATE LIMITED',
    'SADARATHOME COMMERCE (OPC) PRIVATE LIMITED',
    'COCONUT BUNCH CREATIONS PRIVATE LIMITED',
    'TOMTOP TRADING PRIVATE LIMITED',
    'JANA ANALYSIS PRIVATE LIMITED',
    'OPTOBIZZ SOFTWARE PRIVATE LIMITED',
    'POLLUCARE ENGINEERS INDIA PRIVATE LIMITED',
    'AUSTENITE FORGE PRIVATE LIMITED',
    'GOADRIGE SOFT SOLUTIONS PRIVATE LIMITED',
    'RND OPTIMIZAR PRIVATE LIMITED',
    'PROGRESSIVE FEDERATION OF INTERNATIONAL SCHOOLS',
    'VAYAK PRIVATE LIMITED',
    'AMTERP SOLUTIONS INDIA PRIVATE LIMITED',
    'NOSTALGIC LEATHER AND YOU REATAIL PRIVATE LIMITED',
    'SPRUCE GOLF & RESORTS LIMITED',
    'M. N. SHETTY INDUSTRIES PRIVATE LIMITED',
    'VENCEL MEDIA & COMMUNICATIONS PRIVATE LIMITED',
    'NAVALADI TRADE LINKS PRIVATE LIMITED',
    'OSPREY RELOCATION PRIVATE LIMITED',
    'ELYSIAN INFO SOLUTIONS PRIVATE LIMITED',
    'ZAKTI DIGITAL SERVICES PRIVATE LIMITED',
    'PANACHE RESORTS PRIVATE LIMITED',
    'OMROX GREEN POWER PRIVATE LIMITED',
    'NUTRITE HEALTHCARE PRIVATE LIMITED',
    'AJV BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'FLOWCODE AUTOMATION PRIVATE LIMITED',
    'GRAND INDIAN OVERSEAS POULTRY PRIVATE LIMITED',
    'DEVAKI VENTURES PRIVATE LIMITED',
    'SANGEETH DAIRY PRODUCTS PRIVATE LIMITED',
    'OXYLIV PRODUCTS PRIVATE LIMITED',
    'EDGROW OVERSEAS PRIVATE LIMITED',
    'TECHSAMVAAD PRIVATE LIMITED',
    'ELECTROGATOR GREEN ENERGY PRIVATE LIMITED',
    'VAINAV TECHNOLOGY SOLUTIONS (OPC) PRIVATE LIMITED',
    'INTERNATIONAL SCHOOLS SPORTS ORGANISATION',
    'TECHNOTRON DIGITAL PRIVATE LIMITED',
    'HARIDHEEPSAI KITCHEN INNOVATIONS PRIVATELIMITED',
    'AJV VENTURES PRIVATE LIMITED',
    'GLOBAAS FASTENERS PRIVATE LIMITED',
    'INFIMETRICS INFO SOLUTIONS PRIVATE LIMITED',
    'KRISHAANGI AGRO FOODS PRIVATE LIMITED',
    'YOUNGSHIN MOTHERSON AUTO TECH LIMITED',
    'TAHBERT HEALTHCARE PRIVATE LIMITED',
    'AJV INFRASTRUCTURE PRIVATE LIMITED',
    'OCTAGON FREIGHT EXPRESS PRIVATE LIMITED',
    'ASAG ANDROAPPS TECHNOLOGY PRIVATE LIMITED',
    'TRIPTICIAN TOUR PRIVATE LIMITED',
    'PARSHVA ENTERPRISES LIMITED',
    'ANIKA BREWERIES PRIVATE LIMITED',
    'ARTINCI ARTISANAL FOODS PRIVATE LIMITED',
    'CHEGU IMPERIUM PRIVATE LIMITED',
    'BIOMIMICRY TECHNOLOGIES PRIVATE LIMITED',
    'MINDBLU TECHNOLOGIES PRIVATE LIMITED',
    'PROMKS GLOBAL TRADING PRIVATE LIMITED',
    'PAN BAHAR FRAGRANCES PRIVATE LIMITED',
    'BLIZZCRAFT INFOTECH PRIVATE LIMITED',
    'HAPPYBUY ETRADE PRIVATE LIMITED',
    'IPCO PROCESS & BELT TECHNOLOGY INDIA PRIVATE LIMITED',
    'RADICON ELECTRIC EQUIPMENT PRIVATE LIMITED',
    'PREVALENT NEWS PRIVATE LIMITED',
    'TAKSHASHILA HEIGHTS INDIA PRIVATE LIMITED',
    'DERIVE MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'REDPEPPER MEDIA SOLUTIONS PRIVATE LIMITED',
    'KINGJIMS TEXTILE PRIVATE LIMITED',
    'VERVETA PROJECTS PRIVATE LIMITED',
    'PRECYZ POLYMERS PRIVATE LIMITED',
    'PRINGLE IT VENTURES PRIVATE LIMITED',
    'SUPRALAX ELECTRONICS PRIVATE LIMITED',
    'AXIS RENEWABLE ENERGY PARK (PENNA) PRIVATE LIMITED',
    'POSIVIEW CREATIVE COMMUNICATIONS PRIVATELIMITED',
    'SHF DESIGN ENGINEERING PRIVATE LIMITED',
    'ANCHAKO CONSULTANCY SERVICES PRIVATE LIMITED',
    'GOLUJI INDIA PRIVATE LIMITED',
    'POINTBLANK BUSINESS CONSULTING PRIVATE LIMITED',
    'ACCRETION SPICE GARDEN PRIVATE LIMITED',
    'JOBSWAY CONSULTANTS (OPC) PRIVATE LIMITED',
    'BOTWORX TECHNOLOGIES PRIVATE LIMITED',
    'DHAWAL MINCHEM PRIVATE LIMITED',
    'SHWET MINCHEM PRIVATE LIMITED',
    'ELOQUENT MACHINOTECH PRIVATE LIMITED',
    'TO70 INDIA PRIVATE LIMITED',
    'NFM RESOURCES PRIVATE LIMITED',
    'CISCO QUALITY ASSESSORS PRIVATE LIMITED',
    'MXNS IT SERVICES PRIVATE LIMITED',
    'AFFLOSPARK PRIVATE LIMITED',
    'PAYRULE SERVICES PRIVATE LIMITED',
    'ZIBUYU NETWORK PRIVATE LIMITED',
    'SAILVAN NETWORK PRIVATE LIMITED',
    'JSNWORLD MECHANICA PRIVATE LIMITED',
    'AXIS RENEWABLE ENERGY PARK (KRISHNA) PRIVATE LIMITED',
    'DSS OIL&GAS WELDING INSTITUTE PRIVATE LIMITED',
    'RETWEAKS PRIVATE LIMITED',
    'EASYREWARDZ SOFTWARE SERVICES PRIVATE LIMITED',
    'ANCORA TECHNOLOGIES PRIVATE LIMITED',
    'PIXELANALYTICS PRIVATE LIMITED',
    'ZINIER TECHNOLOGIES PRIVATE LIMITED',
    'VIDURAMA SOLUTIONS PRIVATE LIMITED',
    'HEVO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SYM RPA PRIVATE LIMITED',
    'JAZA SOFTWARE (OPC) PRIVATE LIMITED',
    'AROHAKA TECHNOLOGIES PRIVATE LIMITED',
    'NEW STREET TECHNOLOGIES PRIVATE LIMITED',
    'YUTU ELECTRONICS PRIVATE LIMITED',
    'FOFI IOT LABS LIMITED',
    'KARPAGA ASSESSMENT APP MATRIX SERVICES PRIVATE LIMITED',
    'AGILINE SOFTWARE PRIVATE LIMITED',
    'DAMRU LIVING SOLUTIONS PRIVATE LIMITED',
    'ROUTE MENTOR LABS PRIVATE LIMITED',
    'RAJPRIYA INFOSURE SERVICES PRIVATE LIMITED',
    'E-VERCEPT SOFTWARE PRIVATE LIMITED',
    'VELMENNI RESEARCH & DEVELOPMENT PRIVATE LIMITED',
    'STREAK AI TECHNOLOGIES PRIVATE LIMITED',
    'ELECTREPS PRIVATE LIMITED',
    'DIGISCAPE TECH SOLUTIONS LIMITED',
    'APNOVATE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'GHAAS TECHNOLOGIES PRIVATE LIMITED',
    'WMS SOLUTIONS PRIVATE LIMITED',
    'RAZORSHARP TECHNOLOGIES PRIVATE LIMITED',
    'MJ CITES PRIVATE LIMITED',
    'EUNOIA INFO SERVICES PRIVATE LIMITED',
    'CONEXUS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VINCA CYBERTECH PRIVATE LIMITED',
    'EXCLCLOUD SOLUTIONS PRIVATE LIMITED',
    'NEXSEMI SYSTEMS PRIVATE LIMITED',
    'ACUBEG INFORMATICS PRIVATE LIMITED',
    'KAMBALA SOLUTIONS PRIVATE LIMITED',
    'NEXQUARE EDUCATION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'COMPUTEMINIONS PRIVATE LIMITED',
    'FOXGLOVE BUSINESS SERVICES PRIVATE LIMITED',
    'LIFELINE BUSINESS SOLUTIONS AND SERVICESPRIVATE LIMITED',
    'ATSUYA TECHNOLOGIES PRIVATE LIMITED',
    'TYT STUDIO PRIVATE LIMITED',
    'ATP INFRATECH PRIVATE LIMITED',
    'EQUONIX TECH LAB PRIVATE LIMITED',
    'WATZ MANN INSTITUTE OF APPLIED INTELLIGENCE PRIVATE LIMITED',
    'CONNAISSANT CONSULTANCY SERVICES PRIVATELIMITED',
    'ZEDEDA INDIA PRIVATE LIMITED',
    'WHITEANGEL INFOSOLUTIONS PRIVATE LIMITED',
    'ZITASOFT INFOTECH PRIVATE LIMITED',
    'FAMACASH INDIA PRIVATE LIMITED',
    'MEDANALYSE HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'TECLIVE TECHNOLOGY PRIVATE LIMITED',
    'JUPO WEBTECH PRIVATE LIMITED',
    'MAHAYANTRA SAMHATI MAHAGOSH INDIA PRIVATE LIMITED',
    'CODE OPTIMAL SOLUTIONS PRIVATE LIMITED',
    'UP2MARK TECHNOLOGIES PRIVATE LIMITED',
    'NAVIDIUM INDIA PRIVATE LIMITED',
    'VADINI INFOCENTER.IO PRIVATE LIMITED',
    'CONVIRZA PRIVATE LIMITED',
    'PRODFITSOLS INFOTECH (OPC) PRIVATE LIMITED',
    'MTSG IT SERVICE PRIVATE LIMITED',
    'BLUEBERRY SEMICONDUCTORS PRIVATE LIMITED',
    'REVENTECH ENGINEERING SERVICES PRIVATE LIMITED',
    'CRANES VARSITY PRIVATE LIMITED',
    'DOREMING SERVICES PRIVATE LIMITED',
    'SWAYAAN DIGITAL SOLUTIONS PRIVATE LIMITED',
    'AVADHUTA TECHNOLOGIES PRIVATE LIMITED',
    'REPLETE HEALTH IT SERVICES PRIVATE LIMITED',
    'CYONE MED SOLUTIONS (OPC) PRIVATE LIMITED',
    'VION CONSULTING PRIVATE LIMITED',
    'DOPTALE INTERACTIVE PRIVATE LIMITED',
    'IROV TECHNOLOGIES PRIVATE LIMITED',
    'CONCEPT CARTON TECHNOLOGIES PRIVATE LIMITED',
    'E-RISK SOLUTIONS PRIVATE LIMITED',
    'XELLSERV PRIVATE LIMITED',
    'HYBRID CODING PRIVATE LIMITED',
    'MANTHANAM NETSOL PRIVATE LIMITED',
    'CREOPEDIA BUSINESS INTELLIGENCE PRIVATE LIMITED',
    'ADDINFI DIGITECH PRIVATE LIMITED',
    'VALUABLE INFORMATICS PRIVATE LIMITED',
    'TINY TACTICS PRIVATE LIMITED',
    'GANJI TECHNOLOGIES PRIVATE LIMITED',
    'NJS WEB PUBLISHING SYSTEMS PRIVATE LIMITED',
    'ALLPS DIGITAL PRIVATE LIMITED',
    'TRELION BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RUBYSOFT SYSTEM PRIVATE LIMITED',
    'HELIOS IOT SYSTEMS PRIVATE LIMITED',
    'MPASS SOLUTIONS PRIVATE LIMITED',
    'SWAYAMSHRESHTH SHRIWEB RESEARCH PRIVATE LIMITED',
    'ELECTUS CONSULTING (OPC) PRIVATE LIMITED',
    'DHISMART PULSE SERVICES PRIVATE LIMITED',
    'WRIGHTFONT DIGITAL PRIVATE LIMITED',
    'POKET TECHNOLOGIES PRIVATE LIMITED',
    'QUCENTIS TECHNOLOGIES PRIVATE LIMITED',
    'INTIMAZIONE GLOBAL CONSULTING PRIVATE LIMITED',
    'PARADIGMSOFT IT SOLUTIONS PRIVATE LIMITED',
    'QUERYNOW TECHNOLOGIES PRIVATE LIMITED',
    'ARCSINE SOFTWARE PRIVATE LIMITED',
    'REQOLENTQUALITY LABS PRIVATE LIMITED',
    'AANDB BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANAIRAKANGSHA VENTURES PRIVATE LIMITED',
    'RELOOK CORPORATION PRIVATE LIMITED',
    'LEARNSLATE EDUVENTURES PRIVATE LIMITED',
    'JUVENTAAS HEALTH2CORE PRIVATE LIMITED',
    'NULURN EDUTECH PRIVATE LIMITED',
    'DIGIUNIT TECHNOLOGIES PRIVATE LIMITED',
    'VESALIUS HELPLINE INDIA PRIVATE LIMITED',
    'REVABA INFERTILITY CLINICS PRIVATE LIMITED',
    'VISSCO HEALTHCARE PRIVATE LIMITED',
    'IIIEM GLOBAL TRAINING PRIVATE LIMITED',
    'UNIVERSE SIMPLIFIED FOUNDATION',
    'SUBYAN EDUCON PRIVATE LIMITED',
    'REALIZATION CUSTOMER SERVICES PRIVATE LIMITED',
    'TALNEO MEDIA PRIVATE LIMITED',
    'ANUKUL RESIDENTS WELFARE ASSOCIATION',
    'SAVYOM LIFE SCIENCES PRIVATE LIMITED',
    'KA DISTRIBUTIONS PRIVATE LIMITED',
    'LITTLE BUDDY KINDERGARTEN PRIVATE LIMITED',
    'SHAKAMBHARI RECREATION CLUB',
    'NAYATI HEALTHCARE & RESEARCH AGRA PRIVATE LIMITED',
    'KRITHIYAA INTEGRATED BUSINESS SERVICES PRIVATE LIMITED',
    'JAYAMMANYAVAR HEALTH CARE LIMITED',
    'DECODE DESIGN STUDIO PRIVATE LIMITED',
    'DR.K.M. CHERIAN HEALTHCARE PRIVATE LIMITED',
    'RAYS OF BELIEF PRIVATE LIMITED',
    'CLEARBRIDGE MEDICENTRE PRIVATE LIMITED',
    'X-BILLION IMPACT FOUNDATION',
    'FITSKILL TRAINING FOUNDATION',
    'WEDARE GLOBAL ASSOCIATION',
    'CODEX HEALTHCARE PRIVATE LIMITED',
    'NEWAGE CLEAN SOLUTIONS PRIVATE LIMITED',
    'INCLUSIVE SKILLS FOUNDATION',
    'DR LALCHANDANI LABS LIMITED',
    'QOGENT LEARNING SOLUTIONS (OPC) PRIVATE LIMITED',
    'MISHMASH EDUCATION SERVICES PRIVATE LIMITED',
    'FOOTPRINTS PRESCHOOLS AND DAYCARE PRIVATE LIMITED',
    'GLOBALSPACE STUDY ABROAD PRIVATE LIMITED',
    'ADOOR LIFELINE MEDICAL SOLUTIONS PRIVATELIMITED',
    'BHUMIRAJ BHUPENDRA KASTURI CHARITABLE FOUNDATION',
    'DSTA EDUCATION FOUNDATION',
    'NISHANYA FOUNDATION',
    'SHRISTI CARGO WAREHOUSE PRIVATE LIMITED',
    'RPS HOSPITALS PRIVATE LIMITED',
    'VOW FOR RED FOUNDATIONS',
    'TAKALKAR EDUHUB PRIVATE LIMITED',
    'FITOFREAK HEALTH SOLUTIONS PRIVATE LIMITED',
    'SUNCOV TECHNOLOGY PRIVATE LIMITED',
    'APLITE ADVISORS PRIVATE LIMITED',
    'MYSWA VENTURES PRIVATE LIMITED',
    'GLOBIVA SERVICES PRIVATE LIMITED',
    'ROBONOMICS AI INDIA PRIVATE LIMITED',
    'ANAPPRAISER TECHNOLOGICAL SERVICES INDIAPRIVATE LIMITED',
    'SAMSARA STUDIO PRIVATE LIMITED',
    'NETWORKKINGS IT SERVICES PRIVATE LIMITED',
    'ZILKER LEARNING TECHNOLOGIES PRIVATE LIMITED',
    'I. & I. FINANCIAL SERVICES PRIVATE LIMITED',
    'SAMVIBHAG TRUSTEESHIP PRIVATE LIMITED',
    'AVEMA AERO SERVICES PRIVATE LIMITED',
    'SWA SIDDHI VASTU PRIVATE LIMITED',
    'MAVERICKING STRATEGIC PRIVATE LIMITED',
    'TECHNICHE IMUNITA PRIVATE LIMITED',
    'SAFCOS COSMOCEUTICALS PRIVATE LIMITED',
    'UNIVERSAL CANCER CONQUEST INDIA PRIVATE LIMITED',
    'SHAPEWELL TECHNOLOGIES PRIVATE LIMITED',
    'UNIKIND SECURE SOLUTIONS PRIVATE LIMITED',
    'MAXDERMCARE SKIN AND LASER PRIVATE LIMITED',
    'AGARWAL DIGITAL SOLUTIONS PRIVATE LIMITED',
    'RAGVIM ONLINE SERVICES (OPC) PRIVATE LIMITED',
    'VCLOUDX INFOTECH PRIVATE LIMITED',
    'MAVIN INDIA SOURCING PRIVATE LIMITED',
    'REGULARLI TECHNOLOGIES PRIVATE LIMITED',
    'JEEXPERT CAMPUS PRIVATE LIMITED',
    'NEXTERG ENERGY INFRA PRIVATE LIMITED',
    'ROWAN INTERNATIONAL PRIVATE LIMITED',
    'DEEPALI EXHIBITORS PRIVATE LIMITED',
    'YOHO TRAVELS PRIVATE LIMITED',
    'JRTC CONSULTANCY PRIVATE LIMITED',
    'UMP INFRA SERVICES INDIA PRIVATE LIMITED',
    'NAOS SPA & WELLNESS PRIVATE LIMITED',
    'TPW LOGISTICS INDIA PRIVATE LIMITED',
    'PATIO PATISSERIES (OPC) PRIVATE LIMITED',
    'CHANDIWALA ENTERPRISES PRIVATE LIMITED',
    'GREKON INFRATECH PRIVATE LIMITED',
    'NETRUT DIGITAL MARKETING PRIVATE LIMITED',
    'MUSEIN CREATIVE SERVICES PRIVATE LIMITED',
    'GLAZE TECHNO FACADE SYSTEMS PRIVATE LIMITED',
    'MSGAJAA PROPERTIES PRIVATE LIMITED',
    'NATIVECREATIV COMMUNICATIONS PRIVATE LIMITED',
    'BEHANCED HEALTHCARE PRIVATE LIMITED',
    'PVLNB PRIVATE LIMITED',
    'CRONOS FITNESITY PRIVATE LIMITED',
    'VELO SERVICES PRIVATE LIMITED',
    'WINGMAN TECHNOLOGY PRIVATE LIMITED',
    'PANACEA GEOSPATIAL SOLUTIONS PRIVATE LIMITED',
    'DRQ HOSPITALITY SERVICES PRIVATE LIMITED',
    'UNI MODERN TOOLING SOLUTION CHENNAI PRIVATE LIMITED',
    'COLDWAVE A&R PRIVATE LIMITED',
    'NEXT DOOR PACKERS AND MOVERS PRIVATE LIMITED',
    'IBG CARBON PRIVATE LIMITED',
    'VISUAL HULL DIGITAL MARKETING (OPC) PRIVATE LIMITED',
    'WLARET CONSULTANTS (OPC) PRIVATE LIMITED',
    'SHULIN INSURANCE BROKERS PRIVATE LIMITED',
    'VASUDHA ENVIRO SOLUTIONS PRIVATE LIMITED',
    'DARA CONVERTING INDIA PRIVATE LIMITED',
    'RAINDROP FAASHIONS PRIVATE LIMITED',
    'TUSKERS SPORTS & EVENTS PRIVATE LIMITED',
    'MOIRA LINENS PRIVATE LIMITED',
    'VINAYAK PLUMBING ENGINEERING PRIVATE LIMITED',
    'ENWISEN ADVISORY SERVICES PRIVATE LIMITED',
    'PRANAVA YOGA PRIVATE LIMITED',
    'KANGRA VALLEY ADVENTURES PRIVATE LIMITED',
    'OGAAN RETAIL PRIVATE LIMITED',
    'HUSTLE INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'ISHOM ESTATE PRIVATE LIMITED',
    'INQUEST BIOPHARM PRIVATE LIMITED',
    'ACLIRE PROJECTS INTERNATIONAL PRIVATE LIMITED',
    'FICUS REALTIME PRIVATE LIMITED',
    'WONLEE ELECTRIC SOLUTIONS PRIVATE LIMITED',
    'OVALLEY FOODS PRIVATE LIMITED',
    'BBCS SECURITY SERVICES PRIVATE LIMITED',
    'ICAD RESOURCES PRIVATE LIMITED',
    'INNOVANT ENERGOTECH SOLUTIONS PRIVATE LIMITED',
    'MINTZIP SOLUTIONS PRIVATE LIMITED',
    'YASHADA ENGINEERING SERVICES PRIVATE LIMITED',
    'ANWITA EATABLES PRIVATE LIMITED',
    'ELECTRO CURIETECH PRIVATE LIMITED',
    'BIOTICSGEN PRIVATE LIMITED',
    'COWNPOR GLOBAL SERVICE TECHNOLOGIES PRIVATE LIMITED',
    'KONCEPT CLOUD PRIVATE LIMITED',
    'RALOE KOTHARI ELEVATOR ENGINEERING PRIVATE LIMITED',
    'UNITRUE ESTATES PRIVATE LIMITED',
    'CODISM INDIA PRIVATE LIMITED',
    'TIBLOH TECHNOLOGIES PRIVATE LIMITED',
    'SANGILI TEXTILES PRIVATE LIMITED',
    'WOOLLY FARMS PRIVATE LIMITED',
    'RIVI VENTURES PRIVATE LIMITED',
    'WELLBERG CAPTEC PRIVATE LIMITED',
    'PREMADE INNOVATIONS PRIVATE LIMITED',
    'COMPAERO INDIA PRIVATE LIMITED',
    'ALKYMIA TECH PRIVATE LIMITED',
    'P3 FREIGHT LOGISTICS INDIA (OPC) PRIVATELIMITED',
    'DAOMING REFLECTIVE MATERIAL INDIA PRIVATE LIMITED',
    'SQUIRREL HI-TECH PRIVATE LIMITED',
    'ATHACHI PHARMACEUTICAL PRODUCTS PRIVATE LIMITED',
    'SRES SOLAR ENERGY PRIVATE LIMITED',
    'VRUNDAVAN PUSHPA FARMERS PRODUCER COMPANY LIMITED',
    'DELECT SPICES AND HERBS PRIVATE LIMITED',
    'FICKLE FORMULA PRIVATE LIMITED',
    'SLANG LABS PRIVATE LIMITED',
    'BLUEBERRY BUSINESS CONSULTING PRIVATE LIMITED',
    'NOS SUPPORT SERVICES PRIVATE LIMITED',
    'YALAMANCHILI ENGINEERS PRIVATE LIMITED',
    'SIGMI EXPORTS PRIVATE LIMITED',
    'XOLOPAK INDIA LIMITED',
    'EZY PROPTECH PRIVATE LIMITED',
    'BYON CARE PRIVATE LIMITED',
    'NOLWA PRIVATE LIMITED',
    'ABLOR ENGINEERING SERVICE PRIVATE LIMITED',
    'SBP DREAM CITY PRIVATE LIMITED',
    'AIRPOL XPRESS PRIVATE LIMITED',
    'ASTROGATE LABS PRIVATE LIMITED',
    'SHINE INFRA CONSULTING PRIVATE LIMITED',
    'TRIKUTA HILLS ESSENTIALS DIVINE PRODUCTS PRIVATE LIMITED',
    'DHARMRAJ LOGISTICS INDIA PRIVATE LIMITED',
    'ESCAPADE JOURNEYS INDIA EXPEDITION PRIVATE LIMITED',
    'MITRON CAPITAL PRIVATE LIMITED',
    'GACK BILLING SERVICES (OPC) PRIVATE LIMITED',
    'OHPHISH TECHNOLOGIES PRIVATE LIMITED',
    'WATTPLUS ENERGY PRIVATE LIMITED',
    'TEKNIKER TRIVIALA PRIVATE LIMITED',
    'SECUREMENT PACKAGING PRIVATE LIMITED',
    'AROGYAMARG HEALTHCARE DIAGNOSTICS PRIVATE LIMITED',
    'CARADORA HEALTH SOLUTIONS PRIVATE LIMITED',
    'INCLOTECH CONSULTANCY SERVICES PRIVATE LIMITED',
    'UMBAR SYMBIOTICS INDIA PRIVATE LIMITED',
    'AAIC TECHNOLOGIES PRIVATE LIMITED',
    'SKYROCKET KNOWLEDGE INDIA PRIVATE LIMITED',
    'ABRISH ADVISORY PRIVATE LIMITED',
    'VIMPRA DIGITAL SERVICES PRIVATE LIMITED',
    'ONIBUS TECHNOLOGIES PRIVATE LIMITED',
    'PLICSOFT SOLUTIONS PRIVATE LIMITED',
    'FLATWORLD BILLING SERVICES PRIVATE LIMITED',
    'CAPITALIST YARD INDIA PRIVATE LIMITED',
    'CIFL HOLDINGS PRIVATE LIMITED',
    'ACCREDITED MEDITEST SERVICES PRIVATE LIMITED',
    'WHITE DWARF INSURANCE ADVISOR PRIVATE LIMITED',
    'AGOC TRAVELS PRIVATE LIMITED',
    'JJRS FOUNDATION',
    'MONDESSO PACKAGING PRIVATE LIMITED',
    'TECHMAKE ELECTRONICS & COMMUNICATIONS PRIVATE LIMITED',
    'MERAK SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VAUCH INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'HOMELY BUILDOFIY PRIVATE LIMITED',
    'UNI COLLABTECH PRIVATE LIMITED',
    'RESONANCE REALTORS & INFRA DEVELOPERS PRIVATE LIMITED',
    'GR ORGANIC FARMS LIMITED',
    'WHITE OPAL EXPOTRADE PRIVATE LIMITED',
    'FLORICAN ENTERPRISES PRIVATE LIMITED',
    'SBP HOUSING PRIVATE LIMITED',
    'YANA SOLAR PRIVATE LIMITED',
    'SUN RESOLUTION PROFESSIONALS PRIVATE LIMITED',
    'QUANT AI DATA PRIVATE LIMITED',
    'SEPIO INNOVATIONS PRIVATE LIMITED',
    'CDAK EDUCATION SERVICE PRIVATE LIMITED',
    'NDJ SOLAR POWER PRIVATE LIMITED',
    'YASHMIT HUMAN RESOURCE MANAGEMENT SERVICES PRIVATE LIMITED',
    'GNJ ENGINEERING PRIVATE LIMITED',
    'INNOVATIVIEW INDIA PRIVATE LIMITED',
    'MODEST APPAREL PRIVATE LIMITED',
    'KANKYO CLEANTECH (INDIA) PRIVATE LIMITED',
    'BALBHAS BUSINESS SYSNOMICS PRIVATE LIMITED',
    'INTELLIGNOSYS SOLUTIONS PRIVATE LIMITED',
    'ROWAN INFRA PRIVATE LIMITED',
    'ASIAN EXCLUSIVE TRAVEL PRIVATE LIMITED',
    'PENTATEUCH TECHNOLOGIES INDIA (OPC) PRIVATE LIMITED',
    'HYUNDAI TRANSYS INDIA PRIVATE LIMITED',
    'FANSMARK INFO MEDIA PRIVATE LIMITED',
    'ELYSIAN SKILL TRAINING PRIVATE LIMITED',
    'INTERGY CONSULTING (INDIA) PRIVATE LIMITED',
    'CHINT POWER (INDIA) PRIVATE LIMITED',
    'YESORYES PRIVATE LIMITED',
    'INTEGRITY RESEARCH LABS PIPE LINE INSPECTIONS PRIVATE LIMITED',
    'TECHAFFAIRS PRIVATE LIMITED',
    'BANANA CLUB TRENDS PRIVATE LIMITED',
    'INTELLIGENT CONSUMER PRODUCTS PRIVATE LIMITED',
    'DASX FARMTECH PRIVATE LIMITED',
    'PIATIKA (INDIA) PRIVATE LIMITED',
    'CAPITAEDGE ADVISORY PRIVATE LIMITED',
    'SALETANCY CONSULTING PRIVATE LIMITED',
    'BLOCKWORKS TECHNOLOGIES PRIVATE LIMITED',
    'PLASTONE UPVC PROFILES PRIVATE LIMITED',
    'INCONDUCT MARKET RESEARCH PRIVATE LIMITED',
    'SOFTCHIMP PRIVATE LIMITED',
    'ROWAN FOUNDATION',
    'GRAPHUS CYBER SECURITY INDIA PRIVATE LIMITED',
    'MIRARE INTERACTTIVE PRIVATE LIMITED',
    'AURAMECH SOLUTIONS PRIVATE LIMITED',
    'TRIPOCK INFOTECH PRIVATE LIMITED',
    'GODREJ UEP PRIVATE LIMITED',
    'DETERGEO CHEM PRIVATE LIMITED',
    'BRAVEHEART COMPACTS PRIVATE LIMITED',
    'AELATION LIFELONG LEARNING RESEARCH COUNCIL',
    'NATIVEFOLKS PRIVATE LIMITED',
    'GETCHELL PROFESSIONAL SERVICES PRIVATE LIMITED',
    'WEZENN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TECH BRAHAS (OPC) PRIVATE LIMITED',
    'PRAKASH AIR SERVICES PRIVATE LIMITED',
    'VINIFEX AGRO PRODUCER COMPANY LIMITED',
    'PERENNIALS INDIA PRIVATE LIMITED',
    'PHUNDO FINTECH INDIA PRIVATE LIMITED',
    'MALIK AIRCON PRIVATE LIMITED',
    'BODINA NATURALS PRIVATE LIMITED',
    'NAAD NONWOVEN PRIVATE LIMITED',
    'ARTHA CARRIERS PRIVATE LIMITED',
    'BETOKEN HEALTHCARE PRIVATE LIMITED',
    'JUNMUK TECH INDIA PRIVATE LIMITED',
    'KFM SOLUTIONS PRIVATE LIMITED',
    'SCALEUP STREET TECHNOLOGIES PRIVATE LIMITED',
    'EMSIGPRO EDU PRIVATE LIMITED',
    'ANABIA CONSULTANCY SERVICES PRIVATE LIMITED',
    'ZENEDL CNS PRIVATE LIMITED',
    'STIRADO DIGITAL PRIVATE LIMITED',
    'MIRAE ASSET CAPITAL MARKETS (INDIA) PRIVATE LIMITED',
    'DLF INFO CITY CHENNAI LIMITED',
    'AZURE POWER MAPLE PRIVATE LIMITED',
    'IMFITECH IT SOLUTION PRIVATE LIMITED',
    'CODEPARVA TECHNOLOGIES PRIVATE LIMITED',
    'LATIK AUTO COMPONTS PRIVATE LIMITED',
    'MACROID APP SERVICES PRIVATE LIMITED',
    'DOON DREAMS NIDHI LIMITED',
    'INDULGENZE BAKES & DIETS (OPC) PRIVATE LIMITED',
    'WEDDINGS ONLY PRIVATE LIMITED',
    'BEONEXPERT TECHNOLOGIES PRIVATE LIMITED',
    'FROYO TECHNOLOGIES PRIVATE LIMITED',
    'TECHTRIX PROJECTS PRIVATE LIMITED',
    'MASHOORI MARKETING PRIVATE LIMITED',
    'MOBIFUN TECHNOLOGY INDIA PRIVATE LIMITED',
    'DATASEC PERIPHERALS PRIVATE LIMITED',
    'SCINTILLA KREATIONS PRIVATE LIMITED',
    'APEX EATING HOUSE PRIVATE LIMITED',
    'REGENT LOGICARE PRIVATE LIMITED',
    'AI ADVERTISING INTELLIGENCE PRIVATE LIMITED',
    'BELLE TRIPS PRIVATE LIMITED',
    'INTELLIGENT INSIGHTS PRIVATE LIMITED',
    'ASJ GLOBAL LOGISTICS (INDIA) PRIVATE LIMITED',
    'RADHIKA BUILDMATICS PRIVATE LIMITED',
    'MARIGOLD CREATIVE PRIVATE LIMITED',
    'TRITHI ROBOTICS PRIVATE LIMITED',
    'RYSTAD ENERGY INDIA PRIVATE LIMITED',
    'CREATEZA MARKETING PRIVATE LIMITED',
    'SHRESHT AQUVO LABS INDIA PRIVATE LIMITED',
    'STL TRANSWORLD PRIVATE LIMITED',
    'TAIYUNG SOLARENERGY PRIVATE LIMITED',
    'DHARINI GLOBAL ENGINEERING PRIVATE LIMITED',
    'APOGEE DIGITECH PRIVATE LIMITED',
    'SARVAGUNAUSHDHI PRIVATE LIMITED',
    'EMPRESS GLOBAL LOGISTICS PRIVATE LIMITED',
    'ALPHABET HOSPITALITY PRIVATE LIMITED',
    'AUTUMODATA TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AYSWAR ENTERPRISE PRIVATE LIMITED',
    'ZOLUX LIGHTING (I) PRIVATE LIMITED',
    'ABAD DELICACIES PRIVATE LIMITED',
    'AZURE POWER ROOFTOP EIGHT PRIVATE LIMITED',
    'EAZYLINK ACADEMY PRIVATE LIMITED',
    'TROUPE TECHNOLOGIES PRIVATE LIMITED',
    'JAKARU INNOVATION PRIVATE LIMITED',
    'MATHFLUX BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FOIRFE PLANTATIONS PRIVATE LIMITED',
    'CRR BIZ SOLUTIONS PRIVATE LIMITED',
    'MTOR LIFE SCIENCES PRIVATE LIMITED',
    'TASTING INDIA FOUNDATION FOR INTERNATIONAL NETWORKING',
    'MOC DIES AND MOULDS PRIVATE LIMITED',
    'EME CIRCUITS PRIVATE LIMITED',
    'BULBUL COMMERCIAL PRIVATE LIMITED',
    'YGDRASIL PREVENTIVE HEALTHCARE PRIVATE LIMITED',
    'CANDIDUS TECHNOLOGIES PRIVATE LIMITED',
    'NEXGEN FUTURUS PRIVATE LIMITED',
    'CUTTING-EDGE HEALTHCARE ANALYTICS PRIVATE LIMITED',
    'SAI PLAY ',
    'CAFE SERVICES PRIVATE LIMITED',
    'DORNE REALTY PRIVATE LIMITED',
    'MILAX ONLINE TECHNOLOGY SERVICES PRIVATELIMITED',
    'JODAS CONSUMER CARE PRIVATE LIMITED',
    'VSRL ENERGY & RESOURCES PRIVATE LIMITED',
    'EDVIZO MEDIA PRIVATE LIMITED',
    'TRUE ACCOUNTING SERVICE AND CONSULTANCY PRIVATE LIMITED',
    'SPHERULE FOUNDATION',
    'PM TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ENFINI LABS TECH CONSULTANT PRIVATE LIMITED',
    'RACLOOP TECHNOLOGIES PRIVATE LIMITED',
    'ZTEX (OPC) PRIVATE LIMITED',
    'VEDAH AGROLIFE PRIVATE LIMITED',
    'GEGADYNE ENERGY LABS PRIVATE LIMITED',
    'SKYLUX ENERGY SOLUTIONS PRIVATE LIMITED',
    'YKNOT SYSTEMS PRIVATE LIMITED',
    'MOVIN FRESHUP HOSPITALITY PRIVATE LIMITED',
    'LFC AUTO PRIVATE LIMITED',
    'VKBSI SECURITY INDIA PRIVATE LIMITED',
    'GSS-TRAINING PRIVATE LIMITED',
    'VERDURE WELLNESS PRIVATE LIMITED',
    'TRUVETA SOLAR ENERGY PRIVATE LIMITED',
    'VANDAC PROPERTIES PRIVATE LIMITED',
    'GAMYAM BIO AND RENEWABLE SOLUTIONS PRIVATE LIMITED',
    '7UMBS IMEXMART PRIVATE LIMITED',
    'SAMAYPRA INFRA PROJECT PRIVATE LIMITED',
    'DBA VERTEX ENGINEERING SOLUTION PRIVATE LIMITED',
    'MIRZAPUR DECOR PRIVATE LIMITED',
    'DIKIYA TECHNOLOGY SERVICE PRIVATE LIMITED',
    'HRVITE SERVICES PRIVATE LIMITED',
    'ENERZINX INDIA PRIVATE LIMITED',
    'CONVERSIGHT.AI INDIA PRIVATE LIMITED',
    'ABEEBE IT AND DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SAPRAYA TECHNOLOGIES PRIVATE LIMITED',
    'AQUALIB MARKETING PRIVATE LIMITED',
    'KRIS CHAKRA TURBO MACHINERY PRIVATE LIMITED',
    'NVH INDIA ANANTAPUR AUTO PARTS PRIVATE LIMITED',
    'FISHEYE SURVEILLANCE SYSTEMS PRIVATE LIMITED',
    'VIKJS HOSPITALITY PRIVATE LIMITED',
    'DIA INNOVATION & TECHNOLOGY PRIVATE LIMITED',
    'MFAR SERVICES PRIVATE LIMITED',
    'NOGYO TECHNOLOGIES PRIVATE LIMITED',
    'SAYA EDUTECH FOUNDATION',
    'XIANGRUI INDUSTRY PRIVATE LIMITED',
    'ABHISHEK PROPBUILD PRIVATE LIMITED',
    'FLUIDSCAPES CONSULTANTS (OPC) PRIVATE LIMITED',
    'EXCELEX LOGISTICS PRIVATE LIMITED',
    'LUXURICO GLOBIZ (OPC) PRIVATE LIMITED',
    'RAHERI AGRO PRIVATE LIMITED',
    'HOOFR INDUSTRIES PRIVATE LIMITED',
    'PAZER NETWORK SOLUTIONS PRIVATE LIMITED',
    'ANUMAY INDUSTRIES PRIVATE LIMITED',
    'NAVTOR (INDIA) PRIVATE LIMITED',
    'PARROT FILMS PRIVATE LIMITED',
    'RAKSHA INDUSTRIAL BUILDING SYSTEMS PRIVATE LIMITED',
    'P&M LINER AND LOGISTICS PRIVATE LIMITED',
    'ECOPROSUS INDIA PRIVATE LIMITED',
    'QANALYSTS SERVICES INDIA PRIVATE LIMITED',
    'RENU SB CREATION SOFTWARE PRIVATE LIMITED',
    'SATIRTH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'COLLUDIUM EVENTS MANAGEMENT PRIVATE LIMITED',
    'CELLCURE CANCER CENTRE PRIVATE LIMITED',
    'BLACKBOARD EDUCATION AND RESEARCH FOUNDATION',
    'CENTILLION RESEARCH PRIVATE LIMITED',
    'AIRSHED PLANNING PROFESSIONALS PRIVATE LIMITED',
    'VALUEVEST SERVICES PRIVATE LIMITED',
    'GANGADI INVESTMENTS PRIVATE LIMITED',
    'SARISH INFOTEL PRIVATE LIMITED',
    'MAKHOUSE REAL INFRA PRIVATE LIMITED',
    'INTEGRATED GLOBAL SERVICES CONSULTANCY NOW PRIVATE LIMITED',
    'BRITZ YD PRIVATE LIMITED',
    'HYUNDAI STEEL ANANTAPUR PRIVATE LIMITED',
    'PVKL TECH SERVICES PRIVATE LIMITED',
    'CLAVZONE PHARMA LIMITED',
    'KAIZENCASA HARD GOODS PRIVATE LIMITED',
    'CORADIUS TECHNOLOGIES PRIVATE LIMITED',
    'STEBBINS INDIA PRIVATE LIMITED',
    'ALS TESTING SERVICES INDIA PRIVATE LIMITED',
    'HAMSA SHIPS PRIVATE LIMITED',
    'ABHIRAJ OVERSEAS PRIVATE LIMITED',
    'MOVIN LABS PRIVATE LIMITED',
    'JST BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUNGEAR ENERGIES PRIVATE LIMITED',
    'DKC TEAHOUSE PRIVATE LIMITED',
    'OUTLOOK DESIGNHEED CONSULTANTS PRIVATE LIMITED',
    'STELLARTEC CONSULTING PRIVATE LIMITED',
    'KANOES ECOM PRIVATE LIMITED',
    'JETTINGBUYING ONLINE TRADE PRIVATE LIMITED',
    'FINDINBOX PRIVATE LIMITED',
    'CREATIVE ASSOCIATES SOLUTIONS PRIVATE LIMITED',
    'MOVERS INTERNATIONAL CARES FOUNDATION',
    'VENKATA DHARMA POULTRIES PRIVATE LIMITED',
    'SENSOVIUM TECHNOLOGIES PRIVATE LIMITED',
    'SSRDP PRIVATE LIMITED',
    'EBN ECOMMERCE PRIVATE LIMITED',
    'PRIME FREIGHT SOLUTIONS PRIVATE LIMITED',
    'HAPPY TEAMS 366PI TECH PRIVATE LIMITED',
    'MEENAKSHI DIXIT WELFARE FOUNDATION',
    'PUBLICCLOUD IT TECHNOLOGIES PRIVATE LIMITED',
    'GOMO DIGITAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HALLUR CONSTRUCTION PRIVATE LIMITED',
    'DEUTSCHE CARS PRIVATE LIMITED',
    'ATIBHA TECHNOLOGIES AND SERVICES PRIVATELIMITED',
    'COWBELL FILMS PRIVATE LIMITED',
    'ARTBURT LIFESPACES PRIVATE LIMITED',
    'CRYPTRON SYSTEMS PRIVATE LIMITED',
    'JOBMOSIS TALENT SOLUTIONS PRIVATE LIMITED',
    'WORKPOOL INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'ALOT WAVES PRIVATE LIMITED',
    'LAMDA ENGINEERING & TECHNOLOGIES PRIVATELIMITED',
    'VANDISCAR TRADING PRIVATE LIMITED',
    'GIOTTUS TECHNOLOGIES PRIVATE LIMITED',
    'BIGWIN INFOTECH PRIVATE LIMITED',
    'RAMAGIRI FOOD AND TECHNOLOGY PRIVATE LIMITED',
    'CROFTERS AGRITECH PRIVATE LIMITED',
    'CURVESTITCH EXPORTS PRIVATE LIMITED',
    'CHIRANG RURAL WOMEN AGRICULTURAL PRODUCER COMPANY LIMITED',
    'GOALCRYST INDIA PRIVATE LIMITED',
    'DIAZTRAV PRIVATE LIMITED',
    'ECOHOME TRADEXIM PRIVATE LIMITED',
    'MAHICKRA CHEMICALS LIMITED',
    'AMBIT SEMICONDUCTORS PRIVATE LIMITED',
    'HOR KIDDA FOODS PRIVATE LIMITED',
    'LATESTLY MEDIA PRIVATE LIMITED',
    'RICHA SKYLINE REALTORS PRIVATE LIMITED',
    'RICHERLINK COMMUNICATIONS PRIVATE LIMITED',
    'RASD TECHNOLOGIES PRIVATE LIMITED',
    'GOODDOT SPICES PRIVATE LIMITED',
    'NALLAMMAL ENGINEERING INDIA PRIVATE LIMITED',
    'PROJECT GYPSY ADVENTURES PRIVATE LIMITED',
    'HEALTHEA WELLNESS PRIVATE LIMITED',
    'LE SONORAN FARMS PRIVATE LIMITED',
    'COMICOSY TRADING PRIVATE LIMITED',
    'TENK INDIA PRIVATE LIMITED',
    'INTCOS SOLUTIONS PRIVATE LIMITED',
    'COOLCROP TECHNOLOGIES PRIVATE LIMITED',
    'SL AP PRIVATE LIMITED',
    'GARWARE FULFLEX SOCIAL FOUNDATION',
    'LUBIX INDIA SOFTECH PRIVATE LIMITED',
    'JEFGO INDUSTRIES PRIVATE LIMITED',
    'HERZ HEALTHCARE SYSTEMS PRIVATE LIMITED',
    'LUCEAT REALTORS PRIVATE LIMITED',
    'UFFRO LOGISTICS PRIVATE LIMITED',
    'PHICOMM INDIA PRIVATE LIMITED',
    'PROTAIGA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUBALLIANCE SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED',
    'SIRANSKN RESEARCH AND MARKETING SOLUTIONS PRIVATE LIMITED',
    'AADNYA CAPITAL PRIVATE LIMITED',
    'ROYALBLISS HOLIDAYS AND HOSPITALITY PRIVATE LIMITED',
    'SHOEI-EXECUTIVE CREW MANAGEMENT PRIVATE LIMITED',
    'EKAL GRAMOTHAN UTPAD FOUNDATION',
    'PCC BRAND SUTRA PRIVATE LIMITED',
    'CHIGROO LABS PRIVATE LIMITED',
    'MOLINARI RAIL TECHNOLOGY INDIA PRIVATE LIMITED',
    'ENERSUM SOLUTIONS PRIVATE LIMITED',
    'BONVISTA FINANCIAL SERVICES PRIVATE LIMITED',
    'GRAEPEL PERFORATIONS INDIA PRIVATE LIMITED',
    'EVAREAP NETWORK PRIVATE LIMITED',
    'CONSTELLI SIGNALS PRIVATE LIMITED',
    'VENKATADRI POULTRIES PRIVATE LIMITED',
    'PNY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HASH CYBER SECURITY SOLUTIONS PRIVATE LIMITED',
    'TALE HOSTEL PRIVATE LIMITED',
    'JAI ARMAMENTS LIMITED',
    'BELMAC EDUCATION ACADEMY',
    'ORAKOR FACILITIES PRIVATE LIMITED',
    'OKUNYL PRIVATE LIMITED',
    'RIVER LEADERSHIP CONSULTANCIES INDIA PRIVATE LIMITED',
    'ZENEROM CREATIVE LAB PRIVATE LIMITED',
    'MITIE DESIGNERS AND PLANNERS PRIVATE LIMITED',
    'SBK BRIGHT STEELS PRIVATE LIMITED',
    'HCEMIN PRIVATE LIMITED',
    'ICURATE SEARCH PRIVATE LIMITED',
    'APLUS TECHNO BUILD PRIVATE LIMITED',
    'HYCONOSYS TECHNOLOGIES PRIVATE LIMITED',
    'TALENT HOUSE SERVICES (OPC) PRIVATE LIMITED',
    'NOXON NUTRITION PRIVATE LIMITED',
    'SKY BIRDS SHIPPING PRIVATE LIMITED',
    'EINSTEIN ENERGY LABS PRIVATE LIMITED',
    'APRAZER HEALTHCARE PRIVATE LIMITED',
    'AIILA INNOVATIONS PRIVATE LIMITED',
    'BIGSUN HOSPITALITY PRIVATE LIMITED',
    'NIVI RECRUTMENTS PRIVATE LIMITED',
    'AMIAS ASSOCIATES PRIVATE LIMITED',
    'GLOPOSYS TECHNOLOGIES PRIVATE LIMITED',
    'TACTFUL SYSTEMS PRIVATE LIMITED',
    'CUTTINGEDGE SOLAR SOLUTIONS PRIVATE LIMITED',
    'SIMPLYSMART TECHNOLOGIES PRIVATE LIMITED',
    'RELATIENT INDIA PRIVATE LIMITED',
    'NEXT DOOR DIGITAL PRIVATE LIMITED',
    'TECHMETRO SOLUTIONS PRIVATE LIMITED',
    'CHHAND INNOVATIONS PRIVATE LIMITED',
    'ADEPTUS TECHNOLOGIES PRIVATE LIMITED',
    'REVENT TECHNOLOGIES PRIVATE LIMITED',
    '3409TECH VENTURES PRIVATE LIMITED',
    'TILL IT CLICKS STUDIO PRIVATE LIMITED',
    'PROVATOSOFT PRIVATE LIMITED',
    'VROOMBLE SERVICES PRIVATE LIMITED',
    'SATTVARISE TECHNOLOGIES PRIVATE LIMITED',
    'NAVASHISH MOTORS PRIVATE LIMITED',
    'PEDDLETECH SOLUTIONS PRIVATE LIMITED',
    'TRAINONIC SOLUTIONS PRIVATE LIMITED',
    'MINDBODY SOFTWARE PRIVATE LIMITED',
    'RIOMED TECHNOLOGIES INDIA PRIVATE LIMITED',
    'FORTE SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'JHAMOBI TECHNOLOGIES PRIVATE LIMITED',
    'KONZEPT FABRICA TECHNOLOGY PRIVATE LIMITED',
    'CLOUDREDUX CONSULTANCY SERVICES PRIVATE LIMITED',
    'PARSEQ ASIA PRIVATE LIMITED',
    'REEFIN SOLUTIONS INDIA PRIVATE LIMITED',
    'GM MANUFACTURING SERVICES PRIVATE LIMITED',
    'GDB TECHNOLOGIES PRIVATE LIMITED',
    'CLISTE SOFTWARE PRIVATE LIMITED',
    'ACCLIVIS TECHNOLOGIES PRIVATE LIMITED',
    'EXADATUM SOFTWARE SERVICES PRIVATE LIMITED',
    'DREAMZ SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DISCOVER IDEAS (OPC) PRIVATE LIMITED',
    'PSA DIGITAL INDIA LIMITED',
    'EUNIVERSAL ADSMEDIA PRIVATE LIMITED',
    'SKYLINE INFONET PRIVATE LIMITED',
    'FLIT WEBS PRIVATE LIMITED',
    'MEGWIN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'BRISKMINDS TECHNOLOGIES PRIVATE LIMITED',
    'BLAZONLABS ITECH PRIVATE LIMITED',
    'APPSPUNDIT INFOTECH PRIVATE LIMITED',
    'ORGAMATION TECH PRIVATE LIMITED',
    'UNISERVE TECHNOLOGIES PRIVATE LIMITED',
    'DEKHO NETWORK PRIVATE LIMITED',
    'NET ICODE TECHNOLOGIES PRIVATE LIMITED',
    'ROBO INDIA ROBOTICS PRIVATE LIMITED',
    'CRESITATECH IT SOLUTIONS PRIVATE LIMITED',
    'ENDIVE SOFTWARE PRIVATE LIMITED',
    'COMPUSYS E SOLUTIONS PRIVATE LIMITED',
    'PROXCE TECHNOLOGIES PRIVATE LIMITED',
    'DRIBBLE SOFTWARE PRIVATE LIMITED',
    'BAREFOOT LIGHTNING INDIA PRIVATE LIMITED',
    'SNERA GLOBAL SOLUTIONS PRIVATE LIMITED',
    'INNOVATIVE LOGIC SOLUTIONS PRIVATE LIMITED',
    'INTERGLOBE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'BEYOND THE BOX SOLUTIONS PRIVATE LIMITED',
    'BHAWANI SATCOM PRIVATE LIMITED',
    'METACUBE SOLUTIONS PRIVATE LIMITED',
    'ATOM HEALTHCARE INDIA PRIVATE LIMITED',
    'ANGELTECH LOGISOL PRIVATE LIMITED',
    'SCIENTIAMOBILE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HUNGER APPS INDIA PRIVATE LIMITED (OPC)',
    'MELVAULT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VITWIT TECHNOLOGIES PRIVATE LIMITED',
    'JULIEN INNOVATIONS INDIA PRIVATE LIMITED',
    'INCYGYS GLOBAL CONSULTING PRIVATE LIMITED',
    'COGNITUS CONSULTING IT SERVICES PRIVATE LIMITED',
    'ADF DATA SCIENCE PRIVATE LIMITED',
    'GAMMA PROCESS HUB INDIA LIMITED',
    'INNOPAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    '10 DECODERS CONSULTANCY SERVICES PRIVATE LIMITED',
    'VIRRAN TECH SOLUTIONS PRIVATE LIMITED',
    'V4 INTELLEKT MART PRIVATE LIMITED',
    'ZMED HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'FLEET STUDIO TECHNOLOGIES PRIVATE LIMITED',
    'ZEPTOH SOLUTIONS PRIVATE LIMITED',
    'INTUIT MICRO TECHNOLOGY PRIVATE LIMITED',
    'FINSIGMA INCLUSIVE SERVICES PRIVATE LIMITED',
    'XTRACUT SYSTEMS PRIVATE LIMITED',
    'CFI COPIERS PRIVATE LIMITED',
    'CARETECH SOLUTIONS (INDIA) PRIVATE LIMITED',
    'QUBERCOMM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DERIVATIVES IT SERVICES PRIVATE LIMITED',
    'TECHNOGRID IT SYSTEMS PRIVATE LIMITED',
    'SOLIDTRUST TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MAINTWIZ TECHNOLOGIES PRIVATE LIMITED',
    'KILUVAI TECH SOLUTIONS PRIVATE LIMITED',
    'BIZPLUS TECH SERVICES PRIVATE LIMITED',
    'HIMATE SOFT SOLUTIONS PRIVATE LIMITED',
    'VILLAGE VISUAL EFFECTS PRIVATE LIMITED',
    'VIVA SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED',
    'GLEANTECH SOLUTIONS PRIVATE LIMITED',
    'K675 SOLUTIONS PRIVATE LIMITED',
    'FREETECHCAFE TECHNOLOGIES PRIVATE LIMITED',
    'ARMTECH COMPUTER SERVICES PRIVATE LIMITED',
    'AGIRA GPMV SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'ABEO INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'CONTEC INDIA PRIVATE LIMITED',
    'RADIAL OMNICHANNEL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ABOTTS CONSULTING INDIA PRIVATE LIMITED',
    'SPARKY ENTERTAINMENT INDIA PRIVATE LIMITED',
    'EMIS HEALTH INDIA PRIVATE LIMITED',
    'TTS BUSINESS SERVICES PRIVATE LIMITED',
    'ALPHA ORI INDIA PRIVATE LIMITED',
    'H-GARB INFORMATIX PRIVATE LIMITED',
    'DUCIMA ANALYTICS PRIVATE LIMITED',
    '3H HEALTH CARE PRIVATE LIMITED',
    'WESSEL CONSULTANCY PRIVATE LIMITED',
    'ASTRO HEAL PRIVATE LIMITED',
    'AUM WEALTH PRIVATE LIMITED',
    'BILATERAL SOLUTIONS PRIVATE LIMITED',
    'ALPHA FIT INSTITUTE PRIVATE LIMITED',
    'ASTRO E-VENTURES PRIVATE LIMITED',
    'ANAMMYAA WELLNESS PRIVATE LIMITED',
    'NEWFANGLED INFOTECH PRIVATE LIMITED',
    'MAD PRODUCTION PRIVATE LIMITED',
    'BUSINESS MENTORS PRIVATE LIMITED',
    'SENBONZAKURA CONSULTANCY PRIVATE LIMITED',
    'SUPER SLEUTH SECURITY AGENCY & ALLIED SERVICES PRIVATE LIMITED',
    'ALPSPURE LIFESCIENCES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP SIX PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY DEVCO PRIVATE LIMITED',
    'DD LIFESTYLE PRIVATE LIMITED',
    'OFB TECH PRIVATE LIMITED',
    'MDG SUPPLY CHAIN SERVICES PRIVATE LIMITED',
    'STHI GROUP PRIVATE LIMITED',
    'ABSOLUTE IPR SERVICES PRIVATE LIMITED',
    'PITZO INDIA PRIVATE LIMITED',
    'DINKAR TECHNOLOGIES PRIVATE LIMITED',
    'SURAJKIRAN SOLAR TECHNOLOGIES PRIVATE LIMITED',
    'ZR MANAGEMENT PRIVATE LIMITED',
    'EQUICAP ASIA MANAGEMENT PRIVATE LIMITED',
    'OSSUR INDIA PRIVATE LIMITED',
    'DOOZY REALTORS PRIVATE LIMITED',
    'CHANDRA EXTRUSIONS PRIVATE LIMITED',
    'ROFL TECHNOLOGIES PRIVATE LIMITED',
    'SPRING PRODUCTIONS PRIVATE LIMITED',
    'INTEGRATIVE DESIGN SOLUTIONS PRIVATE LIMITED',
    'BRAIN OAK GLOBAL SOLUTIONS PRIVATE LIMITED',
    'CORPORATE SECURE SERVICE PRIVATE LIMITED',
    'LINES & SCALES PRODUCTIONS PRIVATE LIMITED',
    'SMITHCRAFTS PRIVATE LIMITED',
    'RSV FACILITY SERVICES PRIVATE LIMITED',
    'EAT MY NEWS COMMUNICATIONS PRIVATE LIMITED',
    'INSTITUTE OF COMPLIANCE MANAGEMENT OF INDIA PRIVATE LIMITED',
    'EON CAPITAL PRIVATE LIMITED',
    'GRCVAULT CONSULTING PRIVATE LIMITED',
    'CAPS & SHELLS CREATIVES PRIVATE LIMITED',
    'CODE5 PRIVATE LIMITED',
    'RAVK CAPITAL CONSULTANTS PRIVATE LIMITED',
    'GISCON ENGINEERING SERVICES PRIVATE LIMITED',
    'BUZZ ART PRIVATE LIMITED',
    'MCT BRATTBERG INDIA PRIVATE LIMITED',
    'ZIFFY TECHNOLOGIES PRIVATE LIMITED',
    'ALMA MATER MATTERS PRIVATE LIMITED',
    'MAX FIELD SERVICES PRIVATE LIMITED',
    'IMPECCABLE FACILITY MANAGEMENT PRIVATE LIMITED',
    'BLUE CARAVAN COMMODITIES PRIVATE LIMITED',
    'APPIGIZER TECHNOLOGIES PRIVATE LIMITED',
    'IDEAGAMI PRIVATE LIMITED',
    'MINDSCAPE TELE MARKETING PRIVATE LIMITED',
    'AWIDIT SYSTEMS PRIVATE LIMITED',
    'LUCID HOLDINGS INDIA PRIVATE LIMITED',
    'WERT INTERVENTIONS SERVICES PRIVATE LIMITED',
    'DOCQUITY SERVICES PRIVATE LIMITED',
    'UNICO SOLAR PRIVATE LIMITED',
    'ROLLING FRAMES ENTERTAINMENT PRIVATE LIMITED',
    'CROSSBORDER EDUTECH PRIVATE LIMITED',
    'BIHARI BAZAAR PRIVATE LIMITED',
    'CFOGLOBAL SOLUTIONS PRIVATE LIMITED',
    'MAIN VALUE TRAINING & CONSULTING PRIVATE LIMITED',
    'HS BUSINESS SERVICES PRIVATE LIMITED',
    'SURYAUDAY RETREATS PRIVATE LIMITED',
    'VOLKSMANN INDIA PRIVATE LIMITED',
    'AASHIRWAD IMPEX PRIVATE LIMITED',
    'GOLDEN RECTANGLE DESIGNS PRIVATE LIMITED',
    'BIGHAT EVENTS & COMMUNICATIONS PRIVATE LIMITED',
    'ALGO8 AI PRIVATE LIMITED',
    'KATALIST TECHCONNECT PRIVATE LIMITED',
    'GOLDMINE MEDIA HOUSE PRIVATE LIMITED',
    'ND INFO SYSTEMS PRIVATE LIMITED',
    'ZUPPIT TECH SOLUTIONS PRIVATE LIMITED',
    'KAVYA SKILLS PRIVATE LIMITED',
    'BOOTSTRAP FOUNDRY PRIVATE LIMITED',
    'PROFFER IT CONSULTANCY PRIVATE LIMITED',
    'M2K TECHNOLOGIES PRIVATE LIMITED',
    'E T H CONSULTANTS PRIVATE LIMITED',
    'ORTHODONTIC SUPPLIES PRIVATE LIMITED',
    'UTOPIA INNOVATIONS PRIVATE LIMITED',
    'LEGAL RAASTA TECHNOLOGIES PRIVATE LIMITED',
    'NINE NETWORK PRIVATE LIMITED',
    'UNISON ADVERTISING (PUNJAB) PRIVATE LIMITED',
    'EASTSIDE CONSULTANCY SERVICES PRIVATE LIMITED',
    'TINAMINE INDIA PRIVATE LIMITED',
    'FORSURE HEALTHCARE PRODUCTS PRIVATE LIMITED',
    'HANUGAN LOGISTICS INDIA PRIVATE LIMITED',
    'SHEER COMMERCIAL ADVISORY PRIVATE LIMITED',
    'VAHIIMANS SOLUTION PRIVATE LIMITED',
    'IDIGISYS PRIVATE LIMITED',
    'CISTA TECHNOLOGIES AND CONSULTING PRIVATE LIMITED',
    'MAGPPIE GLOBAL HOUSEWARE PRIVATE LIMITED',
    'INTERNATIONAL AUTOMOBILE CENTRE OF EXCELLENCE (IACE)',
    'CLASSHOP TECHNOLOGIES PRIVATE LIMITED',
    'GNOVATIONS TECHNOLOGIES PRIVATE LIMITED',
    'MUDRA INFO CONSULTING PRIVATE LIMITED',
    'CORPORATE ACCRETION CONSULTANTS PRIVATE LIMITED',
    'QUICK PAY PRIVATE LIMITED',
    'BASSANTECH SOLUTIONS PRIVATE LIMITED',
    'HUBCO TECHNOLOGIES PRIVATE LIMITED',
    'NEOLOTEX BUSINESS SOLUTIONS PRIVATE LIMITED',
    'STATLOGIC INDIA PRIVATE LIMITED',
    'SASHIMI FOODS PRIVATE LIMITED',
    'LEANONME COUNSELLING SERVICES PRIVATE LIMITED',
    'CATCHPOINT SYSTEMS PRIVATE LIMITED',
    'ICONIC ENERGY & AUTOMATION SERVICES PRIVATE LIMITED',
    'INFION ADVANCED LASER SYSTEMS PRIVATE LIMITED',
    'FINNEW SOLUTIONS PRIVATE LIMITED',
    'ONETECH VENTURES INDIA PRIVATE LIMITED',
    'STRAVENTURE SOLUTIONS PRIVATE LIMITED',
    'SOCDV TECHNOLOGIES PRIVATE LIMITED',
    'CREATHIVES E-SERVICES PRIVATE LIMITED',
    'PINKBLUE SUPPLY SOLUTIONS PRIVATE LIMITED',
    'AUTOMOVILL TECHNOLOGIES PRIVATE LIMITED',
    'EASYTAAZA AGRI SOLUTIONS PRIVATE LIMITED',
    'GLASSROOM LEARNING SOLUTIONS PRIVATE LIMITED',
    'CRATIS DESIGNERS PRIVATE LIMITED',
    'HASGEEK LEARNING PRIVATE LIMITED',
    'R.R.S. PEOPLE WORKS PRIVATE LIMITED',
    'VAIVIK COMMERCE PRIVATE LIMITED',
    'PROSUPPLYR GLOBAL PRIVATE LIMITED',
    'APPRIKART DIGITAL SOLUTIONS PRIVATE LIMITED',
    'EFREYA DTS PRIVATE LIMITED',
    'CONVISTA CONSULTING INDIA PRIVATE LIMITED',
    'V-NOVA BUSINESS GROWTH SERVICES PRIVATE LIMITED',
    'EDUDENT LEARNING PRIVATE LIMITED',
    'BOOKYOURGYM FITNESS PRIVATE LIMITED',
    'REDDY SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'GLITZ BLITZ PROMOTIONS PRIVATE LIMITED',
    'INTESSENCE SOLUTIONS PRIVATE LIMITED',
    'DICHTOMATIK INDIA SEALS PRIVATE LIMITED',
    'SIMPLY HOME FOOD INTERNET TECHNOLOGY PRIVATE LIMITED',
    'NEXERA PEOPLE SOLUTIONS PRIVATE LIMITED',
    'CORRUS CLOUD SERVICES PRIVATE LIMITED',
    'VAGXMI INNOVATIVE TECHNO PRIVATE LIMITED',
    'AGACQUISITIONS MGT PRIVATE LIMITED',
    'BEEROUTE RESEARCH PRIVATE LIMITED',
    'AASHEHA TECHNOLOGY SERVICES PRIVATE LIMITED',
    'ACMEEXPERIENCE MARKETING PRIVATE LIMITED',
    'BEAVER MARKETING SOLUTIONS PRIVATE LIMITED',
    'PROTOCENTRAL ELECTRONICS PRIVATE LIMITED',
    'VFS TECHNOLOGIES PRIVATE LIMITED',
    'MARCGRC SOLUTIONS PRIVATE LIMITED',
    'INDIASTARTUP CONSULTING PRIVATE LIMITED',
    'QIWORKS CREATIONS PRIVATE LIMITED',
    'MEDISUN MEDICAL SOLUTIONS PRIVATE LIMITED',
    'INTEROP CONSULTING PRIVATE LIMITED',
    'ANCIENT CREATIONS PRIVATE LIMITED',
    'FASH LOGISTICS PRIVATE LIMITED',
    'PIOCTAVE SOLUTIONS PRIVATE LIMITED',
    'PRINTREE CUSTOM CREATIONS PRIVATE LIMITED',
    'BLUE AIR SOLUTIONS PRIVATE LIMITED',
    'SAMARTH LIFE MANAGEMENT PRIVATE LIMITED',
    'TMH CONSULTANTS PRIVATE LIMITED',
    'ANANYA DRISHTEE SUSTAINABLE COMMUNITIES PRIVATE LIMITED',
    'CHARMSDAY JEWELLERY PRIVATE LIMITED',
    'PLASTIC TECHNOLOGY PRIVATE LIMITED',
    'ZYETA STUDIOS PRIVATE LIMITED',
    'ARTOMATE STUDIO PRIVATE LIMITED',
    'ADNAKS MARKETING SOLUTIONS PRIVATE LIMITED',
    'FUNSTAY SERVICES PRIVATE LIMITED',
    'ZEUTEC OPTO-ELEKTRONIK (INDIA) PRIVATE LIMITED',
    'NETWORGS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EUPRIME CONSULTING PRIVATE LIMITED',
    'LEAN TRANSFORMATION CONSULTANCY PRIVATE LIMITED',
    'SUPERTEXT TECHNOLOGIES PRIVATE LIMITED',
    'OZONEGREEN AGROW COMMODITIES PRIVATE LIMITED',
    'PIXCELLENCE TECHNOLOGIES PRIVATE LIMITED',
    'THAR WORX PRIVATE LIMITED',
    'ACTAX CORPORATE STRATEGIES PRIVATE LIMITED',
    'TESSERACT LEARNING PRIVATE LIMITED',
    'MICROSTEP MONITORING INFORMATION SYSTEMS INDIA PRIVATE LIMITED',
    'APSG ENGINEERING PRIVATE LIMITED',
    'ARETE CAREERS (OPC) PRIVATE LIMITED',
    'GREETS BUILDING SERVICES PRIVATE LIMITED',
    'INQUINITI TECHNOLOGIES PRIVATE LIMITED',
    'HAQDARSHAK EMPOWERMENT SOLUTIONS PRIVATE LIMITED',
    'THROTTLE AEROSPACE SYSTEMS PRIVATE LIMITED',
    'SWINCS CONSULTANTS PRIVATE LIMITED',
    'SPARKYO TECHNOLOGY PRIVATE LIMITED',
    'GUTURI CONSULTING PRIVATE LIMITED',
    'NAARWARE EXIM PRIVATE LIMITED',
    'UNIFIED BILLXCOMMERCE PRIVATE LIMITED',
    'ADVISETREE CONSULTING PRIVATE LIMITED',
    'IIVY MARKETING SERVICES PRIVATE LIMITED',
    'DEVSYS EMBEDDED TECHNOLOGIES PRIVATE LIMITED',
    'VYNATH WIRELESS PRIVATE LIMITED',
    'INFRASCHOOL SERVICES CHINTAMANI PRIVATE LIMITED',
    'AREVUK ADVISORY SERVICES PRIVATE LIMITED',
    'VIJAYA OOHMEDIA SOLUTIONS PRIVATE LIMITED',
    'KLEENCO ON-DEMAND SERVICES PRIVATE LIMITED',
    'STORESPACE STORAGE SOLUTIONS PRIVATE LIMITED',
    'SMI GLOBAL LEARNING PRIVATE LIMITED',
    'ES AIRCONDITION AND REFRIGERATION PRIVATE LIMITED',
    'BURLINGTON ENGLISH TRAINING (INDIA) PRIVATE LIMITED',
    'OLAHIVE INNOVATIONS LAB PRIVATE LIMITED',
    'SATALATRAX COMMUNICATION PRIVATE LIMITED',
    'FIBAS EXCLUSIVE KITCHENWARE PRIVATE LIMITED',
    'FUJIKURA GRAPHICS INDIA PRIVATE LIMITED',
    'KAHM REALTY PRIVATE LIMITED',
    'INDEEDCARE WELLNESS PRIVATE LIMITED',
    'ZETTAINDIA TECHNOLOGIES PRIVATE LIMITED',
    'IININGS VENTURES PRIVATE LIMITED',
    'ANUTHAM EXIM PRIVATE LIMITED',
    'PROGRESSIVE TECHNOLOGY & BUSINESS SOLUTION PRIVATE LIMITED',
    'EARLYPAD CONSULTING SERVICES PRIVATE LIMITED',
    'CHESSY ESTATE VETERANS PRIVATE LIMITED',
    'TRADELLA E-COM PRIVATE LIMITED',
    'SMARTWORKS COWORKING SPACES PRIVATE LIMITED',
    'BITXOXO BITCOINS ONLINE PRIVATE LIMITED',
    'NETGURU ENGINEERING PRIVATE LIMITED',
    'ADQVEST CAPITAL ADVISORS PRIVATE LIMITED',
    'TALENTALL RECRUITMENT SERVICES PRIVATE LIMITED',
    'SRIJAN CHARITABLE ASSOCIATION',
    'BONGS PRAYUKTI INTERNATIONAL PRIVATE LIMITED',
    'AGLO EXPORTS PRIVATE LIMITED',
    'MAYBRIGHT VENTURES PRIVATE LIMITED',
    'BHAVANI HEALTH & LIFESTYLE PRIVATE LIMITED',
    'ROCKWAYS IT SOLUTIONS PRIVATE LIMITED',
    'WHITE LOTUS ADVISORY SERVICES PRIVATE LIMITED',
    'MOTIF POLITIK PRIVATE LIMITED',
    'JMT INVESTMENT PRIVATE LIMITED',
    'GENESIS INTELLECTUALS PRIVATE LIMITED',
    'EXEMPLARY CONSULTANTS PRIVATE LIMITED',
    'INDUSTRIAL FORGING INDUSTRIES PRIVATE LIMITED',
    'KEYWEALTH ADVISOR PRIVATE LIMITED',
    'ANTHYESTI FUNERAL SERVICES PRIVATE LIMITED',
    'COLLEGE APPLICATION PRIVATE LIMITED',
    'PROMARG CONSULTANTS PRIVATE LIMITED',
    'DEWPURE ENGINEERING PRIVATE LIMITED',
    'SREEMANTRA TECHNOLOGIES PRIVATE LIMITED',
    'SNT REMOTE PRIVATE LIMITED',
    'ROYALBENGAL PACKAGING PRIVATE LIMITED',
    'AARBUR POINT MAINTENANCE PRIVATE LIMITED',
    'ASPA PLYWOOD PRIVATE LIMITED',
    'PRAXIS BUSINESS SCHOOL FOUNDATION',
    'PATHFINDERS GLOBAL PRIVATE LIMITED',
    'MY 247 SERVICES PRIVATE LIMITED',
    'FORRET INDIA PRIVATE LIMITED',
    'CADVICA ENGINEERING PRIVATE LIMITED',
    'TALENTSTEEN HR & IT CONSULTANCY PRIVATE LIMITED',
    'ASHVA TOURS INDIA PRIVATE LIMITED',
    'TNW SOLUTIONS PRIVATE LIMITED',
    'INDINET SERVICE PRIVATE LIMITED',
    'SNEPRA SECURE SERVICES PRIVATE LIMITED',
    'GITSPL PRIVATE LIMITED',
    'SB SAFEGUARD SERVICES PRIVATE LIMITED',
    'ORPHICARD TECH PRIVATE LIMITED',
    'KARTELLY EXIM PRIVATE LIMITED',
    'DIGITAL APTECH PRIVATE LIMITED',
    'JJR CONSULTANCY PRIVATE LIMITED',
    'SURESHIELD SECURITY PRIVATE LIMITED',
    'BROADWAYS LEGAL CONSULTING PRIVATE LIMITED',
    'SYNTHESIZE STAFFING AND RECRUITMENT PRIVATE LIMITED',
    'SIMPLIFYS DIGITAL PRIVATE LIMITED',
    'GREXTER HOUSING SOLUTIONS PRIVATE LIMITED',
    'COSMIC DIGITAL PRIVATE LIMITED',
    'ACULEAD (INDIA) PRIVATE LIMITED',
    'BIGCRUNCH GAMING PRIVATE LIMITED',
    'AK DREAM ESTATE DEVELOPERS PRIVATE LIMITED',
    'YIBEAL TRADEX PRIVATE LIMITED',
    'QENCH STUDIOZ PRIVATE LIMITED',
    'CONSULTIVO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FURRIOUS PROTECTIVE SECURITY PRIVATE LIMITED',
    'VIRTUALTECH OUTSOURCING SERVICES PRIVATE LIMITED',
    'JAGARI PUBLICATION PRIVATE LIMITED',
    'HONOUR LANE LOGISTICS (INDIA) PRIVATE LIMITED',
    'FERN AVIATION INDIA PRIVATE LIMITED',
    'SIMPLISTIC SOLUTIONS (INDIA) PRIVATE LIMITED',
    'K-NINE SPARES PRIVATE LIMITED',
    'AV FINVEST UNICORN PRIVATE LIMITED',
    'COLOR STROKE PRINT SOLUTION PRIVATE LIMITED',
    'CARGOMASTERS LOGISTICS PRIVATE LIMITED',
    'SHRI SAI FACILITY MANAGEMENT PRIVATE LIMITED',
    'INTERCOSTAL MANAGEMENT SERVICES PRIVATE LIMITED',
    'BUZZSTOP INTEGRATED COMMUNICATIONS PRIVATE LIMITED',
    'MAERSK TRAINING SERVICES INDIA PRIVATE LIMITED',
    'CHG IT CONSULTANCY PRIVATE LIMITED',
    'H A GADHIYA EDUCATION FOUNDATION',
    'EADCOSMOS MEDIA AND COMMUNICATION PRIVATE LIMITED',
    'ROCKWELL FACILITY MANAGEMENT PRIVATE LIMITED',
    'CREATIVE ANTENNA MEDIAWORKS PRIVATE LIMITED',
    'CLOUD TECH PRIVATE LIMITED',
    'HUNAR PLACEMENT SERVICES PRIVATE LIMITED',
    'INSTEON CONSULTANTS PRIVATE LIMITED',
    'SIVA ENTERPRISES PRIVATE LIMITED',
    'VOXELJET INDIA PRIVATE LIMITED',
    'DIAL ITV SERVICES PRIVATE LIMITED',
    'MYTH OCEAN CONSULTING PRIVATE LIMITED',
    'GEOADS MEDIA PRIVATE LIMITED',
    'MASTERSTROKE TECHNOSERVICES (OPC) PRIVATE LIMITED',
    'CORPORATE GURUKUL LEARNING PRIVATE LIMITED',
    'BHONDVE WAREHOUSING INDIA PRIVATE LIMITED',
    'VINIT INDUSTRIES LIMITED',
    'CHERISHTRIP HOLIDAYS PRIVATE LIMITED',
    'ONE LOGISTICS PRIVATE LIMITED',
    'D & G HOLIDAYS PRIVATE LIMITED',
    'BODYZONE FITNESS & SPA PRIVATE LIMITED',
    'AMPLUS SOLAR POWER PRIVATE LIMITED',
    'VYAAH SHYAA SERVICES PRIVATE LIMITED',
    'LEELAM CONSULTANCY SERVICES PRIVATE LIMITED',
    'AAR INDAMER TECHNICS PRIVATE LIMITED',
    'SOOPERFLY MEDIA PRIVATE LIMITED',
    'QUADRANT FUTURE TEK LIMITED',
    'WAZZEER INTERNET PRIVATE LIMITED',
    'IGLOBE SOLUTIONS PRIVATE LIMITED',
    'ZIRKEL INFRACA PRIVATE LIMITED',
    'UBS BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'TERRY',
    '& FURNISHERS',
    'ASSOCIATION',
    'Sevana foundation',
    'Royal western india turf club limited',
    'Aarm healthcare private limited',
    'Indian by blood foundation',
    'Lakhmichand arya social welfare foundation',
    'Elephant eye productions private limited',
    'Wave adventure holdings private limited',
    'Niramay distributors private limited',
    'Niraksh event strategists private limited',
    'Big shows enetertainments private limited',
    'Capital retreat private limited',
    'Trac india private limited',
    'EUPHORIA INFOTECH (INDIA) LIMITED',
    'Ishakti foundation',
    'THE GUJARAT FLYING CLUB.',
    'Glamanand entertainment private limited',
    'Mantha events management private limited',
    'Suresh wadkars music at ajivasan private limited',
    'Jaipur riding and poloclub private limited',
    'Kettela tea company private limited',
    'Trikaya events & entertainment private limited',
    'Wave premier sports private limited',
    'Satabdee associates pvt ltd',
    'TALSON TRADING PRIVATE LIMITED',
    'PRIME TIME LOGISTICS TECHNOLOGIES PRIVATE LIMITED',
    'Bmk maintenance & services private limited',
    'Nlb services private limited',
    'Mepl maintenance private limited',
    'Smart brain limited',
    'VVC HOSPITATLITY PRIVATE LIMITED',
    'Oriole dr. fresh hotels private limited',
    'Srivastava medicare private limited',
    'Desun healthcare & research institute limited',
    'Scitech specialities private limited',
    'Kairali ayurvedic products private limited',
    'Reach infratech consultants private limited',
    'TESSA STONES PRIVATE LIMITED',
    'DR PAUL',
    'S CHRISTIAN ASSOCIATION OF INDIA.',
    'The indian newspaper society.',
    'Professional biotech private limited',
    'P s highrise developers private limited',
    'P s plaza private limited',
    'P s real estate private limited',
    'P s niwas private limited',
    'P s infrodev private limited',
    'P s griha nirman private limited',
    'P s adhunik buildings private limited',
    'Swatantra builders and developers private limited',
    'Riveria commercial developers limited',
    'Space homebuild private limited',
    'Jupiter apartments private limited',
    'Shilpa structure and designs private limited.',
    'Shilpkar construction private limited',
    'Capital wizard real estate private limited',
    'Omega multiplex private limited',
    'Sdl real estates private limited',
    'Talish agroestates private limited',
    'Simmro infrastructure and developers private limited',
    'Sangupt developers private limited',
    'Kamalika developers and infrastructures private limited',
    'Garv realtors private limited',
    'Property ventures (india) private limited',
    'P s buildcon private limited',
    'P s properties developer private limited',
    'P s quality nirman private limited',
    'R.a. projects private limited',
    'BEGUR OMR HOMES PRIVATE LIMITED',
    'Chandrajyoti estate developers private limited',
    'P s ashray private limited',
    'Savli infra management',
    'Chirag organics private limited',
    'Galaxy procon private limited',
    'Samanvay properties private limited',
    'PRIMUS LIFESPACES PRIVATE LIMITED',
    'Shahi realtech private limited',
    'Simar infrastructures limited',
    'Electrofronts interfaces private limited',
    'P v sheti engineers and contractors private limited',
    'Primex infrastructure private limited',
    'Hinditron services private limited',
    'Kundan builders pvt ltd',
    'Pinnacle builders and engineers private limited',
    'Stylish buildcon private limited',
    'Shipra towers private limited',
    'Govindam colonizers private limited',
    'Deepal township private limited',
    'Doon heights developers private limited',
    'Nirmal propcon private limited',
    'Goyal flatbuild private limited',
    'Radiance housing and properties private limited',
    'Saluja construction company limited',
    'Ats infrastructure limited',
    'Enarc builders pvt ltd',
    'Celsia hotels private limited',
    'Lifestyle buildcon private limited',
    'C m projects private limited',
    'Saluja developers private limited',
    'Starshine realtors private limited',
    'Prakash infrastucture private limited',
    'Goldstar buildcon private limited',
    'Rajasthan precon private limited',
    'Valueworth infratech private limited',
    'Kartikeya promotors private limited',
    'Crosshome developers private limited',
    'Adarsh haven private limited',
    'Adarsh nest private limited',
    'Aboli constructions private limited',
    'Jethani projects private limited',
    'Deepaangan realtors private limited',
    'Adarsha palace private limited',
    'Akarsh residence private limited',
    'Akarsh avenue private limited',
    'Navketan constructions pvt ltd',
    'Gopa builds pvt ltd',
    'Shine infraventures limited',
    'Amrapalli advanced ashiana private limited',
    'Meghavi promoters private limited',
    'Meghavi awas private limited',
    'Adarsh nivaas private limited',
    'Shyama power india limited',
    'Anil contractors private limited',
    'Rajdeep road developers private limited',
    'Rajdeep publicity private limited',
    'Parry infrastructure company private limited',
    'Senthil infrastructure private limited',
    'BIRLA GTM ENTREPOSE Private Limited',
    'Ganapati infradev private limited',
    'Kgk infrastructure private limited',
    'Vikson commodities pvt ltd',
    'Swastic farms pvt ltd',
    'Marigold buildtech private limited',
    'Jain amar clothing private limited',
    'RISHABH TELELINK INFRACON PRIVATE LIMITED',
    'DASMESH COMBINES PRIVATE LIMITED',
    'Bhasin infrastructure developers private limited',
    'Nirman construction contracts private limited',
    'Sas housing and infrastructure limited',
    'Jaydeep associates private limited',
    'N k regancy pvt ltd',
    'N k niketan pvt ltd',
    'Ats township private limited',
    'Span furnishers private limited',
    'Sur industries pvt ltd',
    'Kamakhya builders pvt ltd',
    'Vedika properties pvt ltd',
    'Manila enclave private limited',
    'World square infra private limited',
    'Perfect promoters pvt ltd',
    'Jai karani realty private limited',
    'Skyscraper heights private limited',
    'Daytona realty private limited',
    'Soumita construction private limited',
    'Skillful merchant private limited',
    'Pal infocom technologies private limited',
    'Ariana dealcom private limited',
    'Brilliant builders private limited',
    'Lifelong maintenance private limited',
    'Lifestyle maintenance services private limited',
    'Akona infrastructure private limited',
    'Starlet infratech private limited',
    'Jurassic infra private limited',
    'Shubham infradevelopers private limited',
    'S GUPTA HOMES PRIVATE LIMITED',
    'Vision comptech integrators limited',
    'Right shopping private limited',
    'Electra design automation private limited',
    'KRISUMI CORPORATION PRIVATE LIMITED',
    'Busysoft systems private limited',
    'Shiv shanti infoline private limited',
    'Advance softech infosystem private limited',
    'HCL SOFTWARE PRODUCTS LIMITED',
    'Tracker solutions private limited',
    'Click grafix (india) private limited',
    'Youth i t solutions private limited',
    'Binsys technologies private limited',
    'Bits n bytes soft private limited',
    'Torrid networks private limited',
    'Ldi graphics private limited',
    'All e consulting private limited',
    'Ms future training private limited',
    'Aapna infotheek private limited',
    'Edge computech private limited',
    'Omega itech services private limited',
    'Nine-west infotech private limited',
    'Zigya technology labs private limited',
    'AMBISON INDUSTRIES PRIVATE LIMITED',
    'XETECH PRIVATE LIMITED',
    'Qaser consultancy and software services private limited',
    'Pioneer process automation private limited',
    'Mobisoft telesolutions private limited',
    'Druta solutions private limited',
    'STUDYPAD INDIA PRIVATE LIMITED',
    'ZUPE TECHNOLOGY PRIVATE LIMITED',
    'Sunsoft erp solutions private limited',
    'Ingenuity gaming private limited',
    'Angelus infotech private limited',
    'Three-d solutions private limited',
    'ALLWONDERS TRAVEL PRIVATE LIMITED',
    'Vr virtual.com private limited.',
    'Precursor solutions private limited',
    'Aexent technologies private limited',
    'G g s information services india private limited',
    'Alstonia township private limited',
    'Redwood infotech private limited',
    'MICROBRAIN RETAIL SERVICES PRIVATE LIMITED',
    'Beganto software systems private limited',
    'Zytx software india private limited',
    'Delphi infosolutions private limited',
    'Omni outsourcing private limited',
    'Fare portal india private limited',
    'Eclectus interactive private limited',
    'Eon telesystems private limited',
    'Vag infotech private limited',
    'Lester infoservices private limited',
    'TRISTAR SOFTWARE AND SOLUTIONS PRIVATE LIMITED',
    'Anpee digital media private limited',
    'Reve systems india private limited',
    'Dc web services private limited',
    'Tc infotech private limited',
    'M m designs network private limited',
    'Exotica infocom private limited',
    'Exotica infotainment private limited',
    'Cloud operation private limited',
    'Smart square technologies private limited',
    'I-soft computers private limited',
    'Ardor info solution private limited',
    'Hyper quality (india) private limited.',
    'Q3 infotech private limited',
    'Avigma technologies private limited',
    'Padath infotainment private limited',
    'Business algorithms private limited',
    'Accord computers private limited',
    'Indivar software solutions private limited',
    'Siera infosystem private limited',
    'I-DREAM SOLUTIONS PRIVATE LIMITED',
    'Readyedge technologies private limited',
    'Ambit software private limited',
    'Ecosuite private limited',
    'Geeta technologies private limited',
    'Progile infotech private limited',
    'Nworks technologies india private limited',
    'HARBINGER TECHAXES PRIVATE LIMITED',
    'Logicspice consultancy private limited',
    'Bhootnath infotech private limited',
    'Graphx solution india private limited',
    'Afford medical technologies private limited',
    'Vanse infotech private limited',
    'R v s infotech limited',
    'Imperial communication enterpreneurs private limited',
    'Digital metering technologies private limited',
    'Laxmi infoweb private limited',
    'Avalon esolutions private limited',
    'Pure one labs private limited',
    'Global transgenes limited',
    'Metropolis healthcare limited',
    'Brainchamber research & development private limited',
    'Clinsync clinical research private limited',
    'Socius legal solutions private limited',
    'Law crux advisors private limited',
    'Sharp accountants private limited',
    'Current technical literature company private limited',
    'Pure drinks new delhi limited',
    'Bajrang factory ltd',
    'Modern cotton yarn spinners limited',
    'Alaghu siva textiles private limited',
    'Durga processors private limited',
    'SIVA INOTEC LIMITED',
    'PARAGON IRRIGATION PRIVATE LIMITED',
    'RAINBOW TEXFAB PRIVATE LIMITED',
    'Biermans card co pvt ltd',
    'Seagull books pvt ltd',
    'Purnima printers pvt.ltd.',
    'Herb tree commercial printing private limited',
    'SUNITA PROCESSORS PRIVATE LIMITED',
    'Hariom ginning industries private limited',
    'Trimurti coal supply pvt.ltd.',
    'Madkai refining private limited',
    'Pure oil industries pvt ltd',
    'Saggi knits private limited',
    'Kissan petro oils private limited',
    'TCG REFINERIES PRIVATE LIMITED',
    'Synochem organics private limited',
    'Supple rubber chemicals private limited',
    'Kish fashions private limited',
    'Simaaya ensembles private limited',
    'Tashkent petrochem private limited',
    'Shreeji air products private limited',
    'Imaans shoes private limited',
    'Alteus biogenics private limited',
    'Ace footmark private limited',
    'Ica international private limited',
    'Om maruti chemical works private limited',
    'Cyrus chemicals private limited',
    'Chemax multikotes (india) private limited',
    'Meta medicare private limited',
    'Samman lal sher singh papers private limited',
    'Pro labels private limited',
    'Aastha apparels private limited',
    'Sharma and bhati garments private limited',
    'Asineeman fashions private limited',
    'Luxury apparels private limited',
    'Smag retails private limited',
    'VIJAY INTERNATIONAL PRIVATE LIMITED',
    'Paushak impex private limited',
    'Fibretec exim private limited',
    'Patidar polymers pvt ltd',
    'Akross synthetics pvt ltd',
    'Sgm publications private limited',
    'Readers stores india private limited',
    'Crystal tissues private limited',
    'Sharda offset printers private limited',
    'PRIYADARSHINI PRINTERS PVT.LTD,',
    'FINERA CONSULTANTS PRIVATE LIMITED',
    'Emmar paints pvt ltd',
    'FIABILA INDIA PRIVATE LIMITED',
    'Marwar motors private limited',
    'Metak healthcare india private limited',
    'Adventus laboratories (india) private limited',
    'B a and brothers(bombay) private limited',
    'Synergy medicines private limited',
    'Shivpujan chemicals private limited',
    'Rahul calchem pvt ltd',
    'Rosalee colours private limited',
    'Heranba industries limited',
    'USHANTI COLOUR CHEM LIMITED',
    'Maheshraj chemicals private limited',
    'Siddharth interchem private limited',
    'Aronex life sciences private limited',
    'DKSORTHO & SHARMA PHARMACEUTICAL PRIVATE LIMITED',
    'Light pharma private limited',
    'J.k. fenner (india) limited',
    'EAST INDIA PHARMACEUTICAL WORKS LIMITED',
    'Franco indian medicare pvt ltd',
    'Banner research & medical service pvt ltd',
    'The bhavnagar salt and industrial works private limited',
    'Neel gagan pigments private limited',
    'Swapnil organics private limited',
    'Mlew eng private limited',
    'Kishore pharma products pvt ltd',
    'Merit polychem pvt. ltd.',
    'Xenon pharma private limited',
    'J and j kalan pharmacy private limited',
    'Divine meditech private limited',
    'Croplife chemicals pvt ltd',
    'Kontest chemicals ltd',
    'Guru kripa bio fertilizers private limited',
    'HI-POWER FERTILIZERS & CHEMICALS PRIVATE LIMITED',
    'PRIMACY INDUSTRIES PRIVATE LIMITED',
    'Tansy paints india private limited',
    'Jiwan lime chemicals pvt ltd',
    'XTRACARE PRODUCTS PRIVATE LIMITED',
    'RAVI DYEWARE COMPANY Private Limited',
    'Mosaic india private limited',
    'B d khaitan & co ltd',
    'Pitra agro chem private limited',
    'Future leather chemicals private limited',
    'Blue ink media private limited',
    'Gee dee tyres private limited',
    'Calco poly technik private limited',
    'DIVIJ ALUCAST PRIVATE LIMITED',
    'Abirami ecoplast private limited',
    'Kanta devi polymers private limited',
    'Indo global commercials private limited',
    'Persang alloy industries private limited',
    'Zenith rubber private limited',
    'Shanti patra plastics pvt ltd',
    'Barnett polypet private limited',
    'Apras polymers and engineering company private limited',
    'Sidmak laboratories (india) private limited',
    'Goldrock vinimoy pvt ltd',
    'Gilbert agencies pvt ltd',
    'West bengal mfg. co pvt ltd',
    'Ponderosa holdings ltd.',
    'Rohit commercial pvt ltd',
    'Eagle vanijya pvt ltd',
    'Venkateswar fiscal services pvt ltd.',
    'Suchitra impex pvt ltd',
    'Bright star trexim & finvest pvt ltd',
    'Chirag dealers pvt ltd',
    'Rajani vincom pvt.ltd.',
    'Paceman sales promotion pvt ltd',
    'Wizaman impex private limited',
    'Madalsa commercial pvt ltd',
    'Flowline services private limited',
    'Mohvogue apparels private limited',
    'Rangs credit pvt ltd',
    'Rubayat kadir trading private limited',
    'Kb dealers private limited',
    'Bonita traders private limited',
    'CRAFT & COMMERCE PRIVATE LIMITED',
    'Tulsi merchandise private limited',
    'Gemus dealers private limited',
    'Splendour tracom private limited',
    'Northstar tie-up private limited',
    'Yashi industries private limited',
    'Resurgent assets advisory private limited',
    'U j exim private limited',
    'Camellia dealers private limited',
    'Sanskriti goods private limited.',
    'R.k.vintrade private limited',
    'Aamogh tradex private limited',
    'Karamdhara vyapaar pvt ltd',
    'Dhansagar vanijya private limited',
    'Arshia global tradecom private limited',
    'Alvis commotrade private limited',
    'Helpful supplier private limited',
    'Omnipresent retail india private limited',
    'Shree lakshmi dal mills private limited.',
    'Indian press exchange ltd',
    'Scroll trexim pvt ltd',
    'Hanuman investment (p) ltd.',
    'Shivbhakti marketing private limited',
    'Rajesh dealtrade private limited',
    'Medallious businesses private limited',
    'Shevanti impex private limited',
    'RAGHUSHREE APPAREL AND SUCCESS PRIVATE LIMITED',
    'Hanurang dealers pvt.ltd.',
    'Vxl digital private limited',
    'Delicious coco water private limited',
    'Abp power solutions private limited',
    'Suntime traders private limited',
    'Pranidhi sales private limited',
    'Anand f & b distributions private limited',
    'AUDDY GEMS & JEWELLERY PRIVATE LIMITED',
    'Shri ram techno engineering private limited',
    'Worldwide traxim private limited',
    'Gurera udhyog limited (tfd from west bengal)',
    'ELECOM COSMETICS PRIVATE LIMITED',
    'Met globe india private limited',
    'Ikat exports private limited',
    'Citizen global private limited',
    'Nitya dealcom private limited',
    'M s retail private limited',
    'Krishna dealtrade private limited',
    'Lingam dealers private limited',
    'Orient dealmark private limited',
    'Gurukripa vincom private limited',
    'Deserve vincom private limited',
    'Gujjadi swarna jewellers private limited',
    'Midshelf web services private limited',
    'L',
    'XYKNO ENTERPRISES PRIVATE LIMITED',
    'Dhanin enterprise private limited',
    'Abhyudaya multitrade (india) private limited',
    'Mma calabs tech limited',
    'Adityan marketing private limited',
    'Reitz india limited',
    'Gmvr hi-tech enterprises private limited',
    'Hysec exim private limited',
    'FORGE 2000 PRIVATE LIMITED',
    'Adams engineering projects private limited',
    'Blackhole technologies private limited',
    'Sonthalia capital private limited',
    'Grd finance private limited',
    'Edmond emporium pvt.ltd.',
    'Aspective commodeal pvt ltd',
    'Sylpack vincom pvt ltd',
    'Drishti merchandise pvt ltd',
    'Shakambari vyapaar private limited',
    'Axisrooms travel distribution solutions private limited',
    'Industrial logic solutions india private limited',
    'Streamoid technologies private limited',
    'Concept realization and it solutions private limited',
    'Aura global information services private limited',
    'Milaap social ventures india private limited',
    'Hfn it services private limited',
    'Traana technologies private limited',
    'Rightbrain technologies private limited',
    'Mubble networks private limited',
    'Unish corp india private limited',
    'Infratab bangalore private limited',
    'Netskope software india private limited',
    'Insonline india private limited',
    'Entlogics technologies private limited',
    'MARGMAKER SOLUTIONS PRIVATE LIMITED',
    'Es varuna triton software solutions and services private limited',
    'Aerosys softwares private limited',
    '3y3 digital labs private limited',
    'Muraai information technologies private limited',
    'Alsbridge advisory private limited',
    'OS HRS INDIA PRIVATE LIMITED',
    'Ubercore data labs private limited',
    'Smarter biz technologies private limited',
    'Total accounting software private limited',
    'Telcosolve systems private limited',
    'Cloudbash technologies private limited',
    'Whizdm innovations private limited',
    'Highwave infotech private limited',
    'Optipace technologies private limited',
    'Netsynergy information technology private limited',
    'Transversal e networks private limited',
    'Vinirma consulting private limited',
    'Systalent software private limited',
    'Visual iq techno services india private limited',
    'Sparkling design and infotech private limited',
    'Qrs software solutions private limited',
    'Mebron technologies private limited',
    'Claysys technologies private limited',
    'Inruss technologies private limited',
    'Tryzens india private limited',
    'Jasmail solutions private limited',
    'Tekgile solutions private limited',
    'Aspros technologies private limited',
    'Eztansa technologies private limited',
    'Cosmere technologies private limited',
    'Sixsquare technologies private limited',
    'Micro chip consultants (bombay) pvt ltd',
    'Dynaware software systems private limited',
    'Excel software consultancy private limited',
    'JJIT FINTECH PRIVATE LIMITED',
    'Reality web india private limited',
    'Buildbazaar technologies (india) private limited',
    'BLUEMATRIX CONSULTANCY PRIVATE LIMITED',
    'Cd infotech private limited',
    'Digindia technologies private limited',
    'Software smiths infotech (india) private limited',
    'Aconex (india) private limited',
    'Menzel vision & robotics private limited',
    'HONEYBEE TECH SOLUTIONS PRIVATE LIMITED',
    'Ctl infotech private limited',
    'Sylvesa infotech private limited',
    'Singham ventures private limited',
    'Webneos ventures private limited',
    'Aakanksha logistics private limited',
    'Rohan buildcon private limited',
    'Caepro technologies private limited',
    'Bramasol india private limited',
    'Omnibridge technologies private limited',
    'Ncorpuscle technologies private limited',
    'Mezzure software technology private limited',
    'WU TECHNOLOGY ENGINEERING SERVICES PRIVATE LIMITED',
    'Avant insights private limited',
    'IND-BARATH COMMODITIES PRIVATE LIMITED',
    'Jelton systems (india) pvt ltd',
    'Aries information systems private limited',
    'Magnaquest technologies limited',
    'Digiquest (india) limited',
    'India softima services private limited',
    'Shanta sriram infotech private limited',
    'Ajel technologies india private limited',
    'Pragati micro instruments private limited',
    'Kellton dbydx software private limited',
    'Wisdom technologies pvt ltd',
    'Zeta interactive systems india private limited',
    'Itpc technology services india private limited',
    'It people corporation india private limited',
    'Aerial topographic services private limited',
    'Saince technology services private limited',
    'B4b it solutions private limited',
    'Appshark software private limited',
    'Atachi software systems private limited',
    'Bloom soft private limited',
    'Infologitech (india) private limited',
    'Actifio technologies (india) private limited',
    'Great andhra softtech private limited',
    'Dhii health tech private limited',
    'ADVENT INFOTECH SERVICES INDIA PRIVATE LIMITED',
    'Princeton it services private limited',
    'Dana india private limited',
    'Bvg india limited',
    'Fleetguard separation solutions private limited',
    'Rochi engineers private limited',
    'ATIDIV (INDIA) PRIVATE LIMITED',
    'Profiroll technologies (india) private limited',
    'SAGE AUTOMATION GROUP (INDIA) PRIVATE LIMITED',
    'Entelki systems and solutions private limited',
    'Shenbaka cars private limited',
    'Digi trans private limited',
    'Genome agritech private limited',
    'Hytech seed india private limited',
    'Parexel international (india) private limited',
    'Unudurru enterprises private limited',
    'HYDE ENGINEERING & CONSULTING INDIA PRIVATE LIMITED',
    'Addefy advertising services private limited',
    'Pitti components limited',
    'Tekedge strategic sales solutions private limited',
    'Road safety club private limited',
    'Prakash security lockers private limited',
    'Rameesh associates private limited',
    'Excel people-centric solutions private limited',
    'Capital logic advisory services private limited',
    'PROPOTENTIA SERVICES PRIVATE LIMITED',
    'Shanson logistics private limited',
    'Fluidpower hydraulics india private limited',
    'Techno frames india private limited',
    'Anahata bpo services private limited',
    'Manas warehousing private limited',
    '3a business consulting private limited',
    'Mind storm media private limited',
    'Anji engineering solutions private limited',
    'Samarthana corporate services private limited',
    'Empowering assurance systems private limited',
    'Mukesh projects private limited',
    'Vj sourcing private limited',
    'Kristaa clean carbon private limited',
    'Eiffel property management limited',
    'Upmc relocation & logistics private limited',
    'Vardhan business consultants private limited',
    'Sreeharsh financial consultants private limited',
    'Narnolia velox advisory limited',
    'Chlorophyll energy private limited',
    'Inner voyage communication private limited',
    'Attune realty private limited',
    'Iilm education private limited',
    'Ams education (pvt) ltd.',
    'MOON ARTIFICIAL INTELLIGENCE TECHNOLOGY PRIVATE LIMITED',
    'Right track admizzionz campuz private limited',
    'AJEENKYA D.Y. PATIL INFRA PRIVATE LIMITED',
    'Maha laxmi education foundation',
    'Navyug eduventures private limited',
    'Shining star education private limited',
    'Skillsonics india private limited',
    'Trainingcentral solutions private limited',
    'Afcl training solutions private limited',
    'Avasara leadership institute',
    'Iaec consultants private limited',
    'Niit education services',
    'Tkw skill development private limited',
    'Nict computer education private limited',
    'Halo technologies and training private limited',
    'Wisdomware technology private limited',
    'Spearhead learning & development private limited',
    'Niit institute of finance banking and insurance training limited',
    'Tlp edusys private limited',
    'Pythagurus education private limited',
    'Aureole education foundation',
    'Eklavya educations private limited',
    'Content flow technologies private limited',
    'MARLINS MARITIME TRAINING FOUNDATION',
    'Mount litera education foundation',
    'Quantinsti quantitative learning private limited',
    'Amrit meditune pvt ltd',
    'Medlis healthcare private limited',
    'Nayati healthcare & research private limited',
    'Health and wellness india private limited',
    'Guardian angel homecare private limited',
    'Clinical aesthetics and investigative management service private limited',
    'SHAISHAV CHILDREN',
    'S METLURGICA (INDIA) PRIVATE LIMITED',
    'Rgtl industries limited',
    'CSCI STEEL CORPORATION INDIA PRIVATE LIMITED',
    'Shree radheshyam ispat private limited',
    'Metalchem india pvt ltd',
    'Mahavir hydraulics private limited',
    'Brightview engineering products india private limited',
    'ALFA PRECISION TECHNOLOGIES PRIVATE LIMITED',
    'Hifab aluminium private limited',
    'A r g aluminium private limited',
    'R.s.brothers jewellers private limited',
    'Fusion foils private limited',
    'Sripad steels private limited',
    'Baroda hi-tech alloys private limited',
    'Tkt hightech cast private limited',
    'Ksa steel and solutions private limited',
    'Sandfits foundries private limited',
    'United foundries private limited',
    'INTERCHROME LIMITED',
    'Shree sai oto tubes mill limited',
    'Osiris impex private limited',
    'Jaichittra infrastructure private limited',
    'Tropical industries international private limited',
    'Abhirav engineering private limited',
    'Selection aluminium wires private limited',
    'Sadbhava fabricators private limited',
    'Masselin suma springs india private limited',
    'Jsa hi-tech roof india private limited',
    'J v d fuel systems private limited',
    'Ensys engineers private limited',
    'Meena jewellers exclusive private limited',
    'Sun gold packaging private limited',
    'Mafor engineering (india) private limited',
    'ELEMENTS TECHNOFAB PRIVATE LIMITED',
    'Lakshmi pressings private limited',
    'Indiana engineering works (bombay) pvt ltd',
    'Precise equipments private limited',
    'Saitech hvac projects private limited',
    'Modern engineering plastics private limited',
    'Jk talabot limited',
    'Seco tools india private limited',
    'Chitram engineering private limited',
    'Cogeme precision parts india private limited',
    'Accord laser machining private limited',
    'Delta storage systems private limited',
    'Circlips india pvt ltd',
    'Ferro magnets & allied products ltd.',
    'Sophia automotive private limited',
    'Atfah packaging private limited',
    'Kg bright enterprises india private limited',
    'AVP INFRACON PRIVATE LIMITED',
    'Highland valley corporation private limited',
    'Jagati ventures private limited',
    'Gopala housing private limited',
    'Sundaram niwas private limited',
    'Faithfull nirman private limited',
    'Bhavna realestate private limited',
    'Neelgagan infrastructure private limited',
    'Diamond nirman private limited',
    'Grand abode developers private limited',
    'Kamaldhan residency private limited',
    'Startree buildcon private limited',
    'Solapur tollways private limited',
    'Wavelet infra private limited',
    'Wavelet infratech private limited',
    'Cozy interiors private limited',
    'Lisa home solutions private limited',
    'Astra interiors private limited',
    'Silicon automobiles private limited',
    'Pothen motors private limited',
    'Jyote premier private limited',
    'Maharaja cars private limited',
    'KALYANI ASSOCIATES PRIVATE LIMITED',
    'Platinum autoworks private limited',
    'Regent autotrade pvt. ltd.',
    'Konark earthmovers private limited',
    'Satyam autoserve private limited',
    'Index automotive solutions private limited',
    'Kolektor technologies india private limited',
    'Supama commodities limited',
    'Gateway intermediaries private limited',
    'Kesava seeds private limited',
    'D. tanishka impex private limited',
    'Abhi-asmi international private limited',
    'Prime multitask private limited',
    'Rakshita commercials private limited',
    'Netravati commercials private limited',
    'Prakhar commercials private limited',
    'Nirja commercials private limited',
    'Standard retail private limited',
    'Pos dynamics private limited',
    'Allpharm technologies private limited',
    'Sahaj interactive solutions (india) private limited',
    'Sams advanced climatic technologies private limited',
    'Mbg commodities private limited',
    'Ennexx services private limited',
    'Sakhi associates private limited',
    'Origin commodeal private limited',
    'M s namiex chemical pvt l t d',
    'Sakamichi perfumes private limited',
    'Rivenda exports private limited',
    'Pharma trek private limited',
    'S r nova commercial private limited',
    'World connect private limited',
    'Brisk electro components private limited',
    'Ags retail private limited',
    'Three sixty exports private limited',
    'Tanay trade links private limited',
    'GOLDSTONE STEEL & SHIPPING AGENCY PRIVATE LIMITED',
    'Julie (india) marketing private limited',
    'Kaniska commercials private limited',
    'Chander commercials private limited',
    'Rajul mercantile private limited',
    'Leaf trading private limited',
    'TARSONS PRODUCTS LIMITED',
    'Lalani and company pvt ltd',
    'MIRONDA MINMETALS PRIVATE LIMITED',
    'Marcopolo products pvt ltd',
    'Godavari leasing and finance ltd',
    'Pawandoot vyapaar pvt ltd',
    'Citizen securities pvt.ltd.',
    'Peeramadi tracon pvt ltd',
    'Waycon commerce pvt ltd',
    'Vicom security private limited',
    'Abovepar commercial pvt.ltd.',
    'Gainwell agents pvt ltd',
    'Zoom tieup private limited',
    'Ngs solutions private limited',
    'Simplex suppliers pvt ltd',
    'Aastha vincom private limited',
    'DUGAR INDVENT PRIVATE LIMITED',
    'Muskan commotrade private limited',
    'Swarnalaxmi mercantile private limited',
    'Star cigarette centre private limited',
    'Asian herbex limited',
    'Innobuzz marketing solutions private limited',
    'Bhavya exports private limited',
    'Am synergy private limited',
    'KARL MAYER STOLL INDIA PRIVATE LIMITED',
    'Ecco india trading private limited',
    'Infant trading and services private limited',
    'Euro traditions india private limited',
    'Immunex pharmaceuticals private limited',
    'Essilor india private limited',
    'Deccan medisales private limited',
    'Tista impex private limited',
    'Phyto marketing private limited',
    'Wardex pharmaceuticals private limited',
    'Planet pharma warehouse private limited',
    'Mediplus healthcare pharmacy india private limited',
    'C d b 24 karat international jewellers private limited',
    'Vital marketing and finance pvt ltd',
    'Avigna housing private limited',
    'Quickee infra private limited',
    'Topsia estates pvt ltd',
    'Thiess india private limited',
    'Sambit developers private limited',
    'Sen infrastructure private limited',
    'Makp developers private limited',
    'Asn realcon private limited',
    'Jetage properties private limited',
    'Neelgeet construction private limited',
    'SG REALTOR PRIVATE LIMITED',
    'Boost sheet metal private limited',
    'Galaxy coils private limited',
    'Apv realty limited',
    'Banyantree developers private limited',
    'Mayin matra infrastructures private limited',
    'Gerealty developers private limited',
    'Divyasree buildtech contractors private limited',
    'Hmg ambassador property management private limited',
    'Kumarakom builders and realtors india private limited',
    'Neelkanth real estate developers private limited',
    'Ratnin investment and finance private limited',
    'Shwetha development and leasing private limited',
    'Madhuri reality and leasing private limited',
    'Magan development and reality private limited',
    'Vaagadevi investment and development private limited',
    'Verna estate and investment private limited',
    'Utkarsha reality and development private limited',
    'Amity properties private limited',
    'Absolute homes private limited',
    'Amruta developers private limited',
    'Dior 5 homes private limited',
    'Carzonrent (india) private limited',
    'Sai aadhar services private limited',
    'Netlink software private limited',
    'Indapoint technologies private limited',
    'Padakis inett value private limited',
    'EKLAKSHYA INNOVATION LABS PRIVATE LIMITED',
    'Mobileum (india) private limited',
    'Ultramax infonet technologies private limited',
    'Enhira software services limited',
    'F a systems private limited',
    'Master computer services private limited',
    'Blazeclan technologies private limited',
    'EGOSITE PROPERTIES & INVESTMENTS PRIVATE LIMITED',
    'Capital technologies limited',
    'Satyam venture engineering services private limited',
    'Sree tammina software solutions private limited',
    'Soham it services private limited',
    'Engaging search india private limited',
    'Start up farms it private limited',
    'Arkaaye softech private limited',
    'Pyramid it consulting private limited',
    'R d wireless solutions india private limited',
    'Kaplan (india) private limited',
    'SIGMA DIGITECH PRIVATE LIMITED',
    'Parkash software private limited',
    'Half dome internet private limited',
    'Briston infotech private limited',
    'Sahaj infotech private limited',
    'Wingify software private limited',
    'Sriram soft solutions private limited',
    'Digihive solutions private limited',
    'Ethical web solutions private limited',
    'Shrishail technologies private limited',
    'Regard network solution private limited',
    'Vizexec transformation private limited',
    'Mobigossip infotech private limited',
    'Elite infonet services private limited',
    'REWARDPAY SERVICES PRIVATE LIMITED',
    'Regulus marketing pvt ltd',
    'Academy for computer training (guj) private limited',
    'Spectra dynamics limited',
    'Madhuvan infotech private limited',
    'Datalyst (india) private limited',
    'Digital science web technologies private limited',
    'MEGH TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Krafty solutions private limited',
    'Jaarwis technologies private limited',
    'Manipal medi records private limited',
    'DUCONT INDIA SYSTEMS PRIVATE LIMITED',
    'Pairee infotech private limited',
    'Smart it-solutions private limited',
    'Vaps technosoft private limited',
    'Cosmic it services private limited',
    'Xenon software solutions private limited',
    'Uttara infosolutions private limited',
    'Cete software private limited',
    'Summit strategic software consulting private limited',
    'Yodasoft technologies private limited',
    'KNOWLEDGEWORKS INNOVATIVE LINGUISTIC SOLUTIONS PRIVATE LIMITED',
    'Satwic software solutions private limited',
    'Vanu india private limited',
    'Netflow technologies (india) private limited',
    'Omkar software private limited',
    'Comsol multiphysics private limited',
    'Technologyport software (india) private limited',
    'G7 synergon private limited',
    'Bizense software technologies private limited',
    'Atom8 it solutions private limited',
    'Coextrix technologies private limited',
    'Whacky films private limited',
    'Three sixty packaging private limited',
    'Solar packaging private limited',
    'Vicmet india private limited',
    'Gf toll road private limited',
    'Mesa (india) private limited',
    'Sutra services private limited',
    'ASCENDAS PANVEL FTWZ PRIVATE LIMITED',
    'Omega energy private limited',
    'DELOITTE INDIA ADVISORY SERVICES PRIVATELIMITED',
    'Templegate technologies & services private limited',
    'Radha madhav holdings private limited',
    'Triplus tradeconnect private limited',
    'Cozy furnitek private limited',
    'Mido lumiere private limited',
    'SGL LABS PRIVATE LIMITED',
    'Reliance paul & shark fashions private limited',
    'Qun interiors private limited',
    'Proed training private limited',
    'Bakelite hylam limited.',
    'MOHSIN SURFACE COATINGS PRIVATE LIMITED',
    'DEV BHUMI COLD CHAIN Private Limited',
    'B r bee products private limited',
    'Dhruv infosystems private limited',
    'Virus design studio private limited',
    'Patios furniture private limited',
    'Infoverge communication private limited',
    'Jt urja private limited',
    'CREATIVE SYSTEMS INTEGRATION SOLUTIONS INDIA PRIVATE LIMITED',
    'Oasis geosolution private limited',
    'Pedal tours india private limited',
    'Jetcord india private limited',
    'Surabhi trade connections private limited',
    'Sangeeta audio private limited',
    'Hiimpact consultants private limited',
    'It world web.com private limited',
    'Andromeda packaging private limited',
    'Pepperl & fuchs (india) private limited',
    'Visbin management associates private limited',
    'Content media (india) private limited',
    'Smile interiors private limited',
    'Uni power technical services and consultancy private limited',
    'TARKETT FLOORING INDIA PRIVATE LIMITED',
    'URBAN LADDER HOME DECOR SOLUTIONS LIMITED',
    'GLOBAL BUSINESS INROADS PRIVATE LIMITED',
    'TOONZ ANIMATION INDIA PRIVATE LIMITED',
    'KLR FACILITY MANAGEMENT PRIVATE LIMITED',
    'Jayems parkim private limited',
    'WILHELMSEN PORT SERVICES INDIA PRIVATE LIMITED',
    'A1 placements consultants private limited',
    'Ahura engineering bombay pvt ltd',
    'Advance motion control systems private limited',
    'Japro international international pvt ltd',
    'Advance tech energy additives private limited',
    'MANJUL RUBBER & POLYMER INDUSTRIES PRIVATE LIMITED',
    'Valentine estate and reality private limited',
    'Omkar heavy engineering limited',
    'Thdc management services limited',
    'Writer safeguard private limited',
    'Association of finance professionals of india.',
    'Vcs quality services private limited',
    'Kwan environmental solutions india private limited',
    'Chrysalis hrd private limited',
    'Elite brands private limited',
    'Halcyon enterprises private limited',
    'Einsten commercials private limited',
    'Parinita commercials private limited',
    'Su toll road private limited',
    'S. k. forex (india) private limited',
    'Bohra ventures private limited',
    'Five elements environment ventures private limited',
    'Baggit india private limited',
    'Om printing and flexible packaging private limited',
    'Dighi logistics private limited',
    'Ignite infotainment private limited',
    'Gunina commercials private limited',
    'SCROLLSTACK PRIVATE LIMITED',
    'Emnet electronic security solutions private limited',
    'Magic kraft private limited',
    'Water mass systems private limited',
    'Labour law consultants (india) private limited',
    'Reflexion interior designers & turnkey private limited',
    'Classic fits fashion private limited',
    'Rh factor corporate solution private limited',
    'Red line logistics private limited',
    'Skven technologies private limited',
    'Innovcare lifesciences private limited',
    'Maxim biz solutions private limited',
    'Bling style private limited',
    'FRAMES PROCESS & ENERGY SYSTEMS INDIA PRIVATE LIMITED',
    'Geoepc management advisors private limited',
    'Intertium automotive private limited',
    'Colortonic studios private limited',
    'Vita scientia globus private limited',
    'Indoko engineers private limited',
    'Ms electronics marketing private limited',
    'Sai swarnamandir jewellers private limited',
    'Phoebe trading private limited',
    'Integrated rail services private limited',
    'Sumages pharma private limited',
    'AURIGENE ONCOLOGY LIMITED',
    'Mega fine pharma private limited',
    'Thinq pharma-cro limited',
    'CHOWHAN VENTURES PRIVATE LIMITED',
    'CIREX PHARMACEUTICALS PRIVATE LIMITED',
    'Nezone herbals private limited',
    'Kwantum chemicals and polymers private limited',
    'Synthetic detergents ltd',
    'KJM ENGINEERING TOOLS PRIVATE LIMITED',
    'Health and beauty care private limited',
    'Valin cosmetics private limited',
    'Pathanamthitta estates private limited',
    'Swathi organics & specialities private limited',
    'Punia zinox private limited',
    'Imerys newquest (india) private limited',
    'G.g. organics private limited',
    'Varahi pharma private limited',
    'Shreeji well brine private limited',
    'Jindal imaging limited',
    'Sicgil industrial gases limited',
    'Avo carbon india private limited',
    'Navadurga surgicals india private limited',
    'SHREE SAI CALNATES INDIA PRIVATE LIMITED',
    'Anmol rubber products pvt ltd',
    'Eastern retreads pvt ltd',
    'Trident international private limited',
    'Vaid elastomer processors private limited',
    'Kunal forge company private limited',
    'Nimbus rubber private limited',
    'Vimsons rubbers pvt ltd',
    'Raksha polycoats private limited',
    'Shree sampath plastics private limited',
    'Delta industrial resing private limited',
    'CREATIVE PLASTICS LIMITED',
    'Kms plastworld private limited',
    'RADICI PLASTICS INDIA PRIVATE LIMITED',
    'S B PACKAGINGS PRIVATE LIMITED',
    'Nilkanth poly plast private limited',
    'Lunar technoplast private limited',
    'Glasso pack private limited',
    'Karthigeya plastics and technologies private limited',
    'Clastek engineering private limited',
    'Sampark industries limited',
    'CENTUARY FIBRE PLATES PRIVATE LIMITED',
    'Dura-line india private limited',
    'Add polymers private limited',
    'Duke plasto technique private limited',
    'Sonneberg plastic systems india private limited',
    'Span plastics private limited',
    'Gurudev plastics private limited',
    'Prashanthi polymers (india) private limited',
    'Asb international private limited',
    'Pradeep masterbatches private limited',
    'B. p. fin - rubchem private limited',
    'Shapers india private limited',
    'Polyex pvt ltd',
    'Saibaba polymer technologies private limited',
    'Surfland composites private limited',
    'SURFBOARD INDIA PRIVATE LIMITED',
    'Angel ceramics private limited',
    'Comet granito private limited',
    'Magnum ceramics private limited',
    'Sisam ceramics private limited',
    'Heelcera tiles private limited',
    'Shapoorji pallonji cement (gujarat) private limited',
    'Adeshwar infrabuild limited',
    'Khyber industries private limited',
    'SOUTHERN CEMENTS & ENGINEERS PRIVATE LIMITED',
    'VAISHNAV INFRASTRUCTURE PRIVATE LIMITED',
    'SUPERTRADE INFOTECH PRIVATE LIMITED',
    'Indo nippon choseki private limited',
    'Sant eknath rolling mills pvt ltd',
    'Anand engineering and metal casting private limited',
    'ADITYA ULTRA STEEL LIMITED',
    'Pazheri steels and metals india private limited',
    'Molax tubes private limited',
    'Accelcia business services india pvt ltd',
    'Ailsinghani hospital and educational insititution',
    'Faculty of architecture alumni association',
    'CONSILIENCE EDUCATION FOUNDATION',
    'Krishnaswamy associates private limited',
    'Skywork studios pvt.ltd.',
    'Lifezone media private limited',
    'Virgin records india private limited',
    'Accord equips private limited',
    'Big screen entertainment private limited',
    'My mango mobile apps private limited',
    'Yogayatan media and publications private limited',
    'THE MODERN THEATRES PRIVATE LIMITED',
    'PRASAR CREATIONS PRIVATE LIMITED',
    'C r mass communications limited',
    'Vaartha broadcasting limited',
    'Mallemaala tele entertainers private limited',
    'DE TERRAIN ESTATES PRIVATE LIMITED',
    'Ignite entertainment private limited',
    'Doit creations (india) private limited',
    'Deepkamal enterprise private limited',
    'Kangabeat entertainment private limited',
    'Bioscope cinemas private limited',
    'EURO DESTINATIONS INDIA PRIVATE LIMITED',
    'Essem entertainment private limited',
    'SCOTCH ',
    'WATER INNOVATIONS PRIVATE LIMITED',
    'J j arts and entertainments private limited',
    'Sadhoo entertainments private limited',
    'Happy planet amusement private limited',
    'Gym solutions india private limited',
    'Newwave services private limited',
    'Headless hippies graphic design and films private limited',
    'Icl lions private limited',
    'BZINGA TECHNOLOGIES PRIVATE LIMITED',
    'One more dimension entertainment private limited',
    'Avr way watch amenities and entertainments private limited',
    'Fusion sporting ventures private limited',
    'Equiwings sports and events private limited',
    'Andaman island travels private limited',
    'Green fields power services private limited',
    'Crescendo manpower consultancy private limited',
    'Preceptor marketing services private limited',
    'Aakhya media services private limited',
    'The circus entertainment private limited',
    'GTID SOLUTIONS DEVELOPMENT PRIVATE LIMITED',
    'Aakar social ventures',
    'Novusluxus r hospitality private limited',
    'Bloggers mind digital marketing private limited',
    'Endeavor hr private limited',
    'Greenfern leadership & strategic consulting private limited',
    'Fire flex private limited',
    'Recruitsmart staffing private limited',
    'Jai bharat technical services private limited',
    'Alfaccurate advisors private limited',
    'Sss interior construction private limited',
    'Heera & jckrc spa lines private limited',
    'Karamtara financial services private limited',
    'Aparna industrial promotion council',
    'CONTINUITY 1 TECHNOLOGIES PRIVATE LIMITED',
    'Sunshine facilities private limited',
    'Eco services india private limited',
    'INVESTORS FINANCIAL EDUCATION ACADEMY',
    'Uttar banga micro finance corporation',
    'Gardenia cosmocare private limited',
    'FORUM FOR SPORTS AND FREEDOM OF EXPRESSION',
    'Meditorch technologies private limited',
    'Kailasa analytics and services private limited',
    'Revive electronic waste private limited',
    'Onefold solutions private limited',
    'Wisync technologies private limited',
    'I-peritus solutions and services private limited',
    'Kauman gyan private limited',
    'Indian forum of corporate communicators',
    'Kyross human resource consultants private limited',
    'Infracon engineering services india private limited',
    'NIPPON STEEL INDIA PRIVATE LIMITED',
    'Bandekar industrial and mining screens pvt ltd',
    'Prashant ferber logistics automation private limited',
    'Ekadantha automation and weldtech private limited',
    'Basar global private limited',
    'Ulka instruments and controls private limited',
    'Lucent (i) energy conversion private limited',
    'Ananya technologies private limited',
    'Diamond engineering (chennai) private limited',
    'Steam equipments private limited',
    'Faster hydraulics private limited',
    'Umc engineering pvt ltd',
    'Garuda vaccum and refining technologies private limited',
    'Vita technology private limited',
    'Deutz engines (india) private limited',
    'Bkwt trading and invest private limited',
    'Elgi sauer compressors limited',
    'Rameshwar bearing private limited',
    'Prasad nc machine systems private limited',
    'Rialto engineering private limited',
    'Progen systems and technologies limited',
    'Natco products india private limited',
    'Jupiter comtex private limited',
    'Precision mass products private limited',
    'Jagannath energy and minerals private limited',
    'Q2q solutions private limited',
    'Advance cooling systems private limited',
    'Siddhitec comforts private limited',
    'Sovereign engineers private limited',
    'Shilpakruti marketings private limited',
    'Aad tech (india) private limited',
    'Manoj fire equipments private limited',
    'Banyan engineering technologies private limited',
    'Deccan pumps private limited',
    'Cosmos water solutions private limited',
    'Wave energy private limited',
    'Accwa enviro private limited',
    'BOLDROCCHI INDIA PRIVATE LIMITED',
    'Tech power (india) private limited',
    'Parker engineering (india) private limited',
    'Jhs svendgaard mechanical and warehouse private limited',
    'Dolphin tools industries private limited',
    'Devi turnomatics private limited',
    'Mektron manufacturing india private limited',
    'Hemkund precision engineering private limited',
    'Maxima boilers pvt ltd',
    'Advance labelling private limited',
    'Goliya instruments pvt ltd',
    'NALANDA AUTOMECH PRIVATE LIMITED',
    'V.k. engitech private limited',
    'Dyna engineering projects private limited',
    'Tubetech equipment private limited',
    'Guhring (india) private limited',
    'CNH INDUSTRIAL (INDIA) PRIVATE LIMITED',
    'Jaycee engineering private limited',
    'Bullows paint equipment private limited',
    'Protech engineering private limited',
    'Micro flat datums private limited',
    'Zeus engitech private limited',
    'Aura industrial equipment and projects private limited',
    'Upr engineering private limited',
    'Srishtis engitech private limited',
    'Golechha equipment private limited',
    'Suved encon private limited',
    'MKRN AUTOMACH SOLUTIONS PRIVATE LIMITED',
    'Snpc machines private limited',
    'Benengg design & manufacturing private limited',
    'Thk india private limited',
    'Intend technologies india private limited',
    'Leak proof steel plant projects private limited',
    'Limark engineers private limited',
    'Rajan dua engineers (offshore) private limited',
    'Jurchen technology india private limited',
    'Escon parking systems private limited',
    'Watertech services private limited',
    'Sonner feeding systems india private limited',
    'Rm applied engineers private limited',
    'Esa manufacturing private limited',
    'Cheng hua engineering (india) private limited',
    'Multifab engineers private limited',
    'Knightfield engines private limited',
    'Gmv india private limited',
    'BARSCAN SYSTEMS & RIBBONS PRIVATE LIMITED',
    'Magnus engineering private limited',
    'Exzakta meccanica limited',
    'Damco engineering india private limited',
    'Eesa fabricator private limited',
    'Sieger spintech equipments private limited',
    'Adinath machinery spares marketing pvt ltd',
    'Tounetsu india private limited',
    'Mongia tooltech private limited',
    'Raigarh electrodes ltd',
    'Newsweb engineers private limited',
    'A m designs private limited',
    'Sarita die works private limited',
    'Chaitanya preci-tech private limited',
    'Flash ventures private limited',
    'Nectar cng private limited',
    'Namal petroleum private limited',
    'Sonkamal enterprises private limited',
    'Gem emerging markets private limited',
    'R.s jhaveri steels private limited',
    'PAHAL HOLDINGS AND ESTATES PRIVATE LIMITED',
    'K b c build tech india private limited',
    'Dortech trading private limited',
    'Truelock hydromatics private limited',
    'A k m polyfab private limited',
    'R.k.r plastics private limited',
    'Deutsche motoren private limited',
    'Quilaban pharma trading private limited',
    'Glotech engineering private limited',
    'Patra power solutions private limited',
    'R sanghavi mercantile private limited',
    'BHARGAVA',
    'HOTEL HOUSE BOAT RESORTS RESTAURANT PRIVATE LIMITED',
    'Chariot valley resorts private limited',
    'EKYAM VENTURES PRIVATE LIMITED',
    'Panoramic leisure getaways private limited',
    'SARGA HOTEL PRIVATE LIMITED',
    'BVR MALLS PRIVATE LIMITED',
    'MEGHDOOT RESORTS PRIVATE LIMITED',
    'Honest dormitory private limited',
    'Gastro pub private limited',
    'Mountain trail foods private limited',
    'Dam good restaurants private limited',
    'Brl logistic private limited',
    '1st shivam trans movers private limited',
    'A3 logistics private limited',
    'Khaitan logistics private limited',
    'Leaap forwarders private limited',
    'Abr logistics private limited',
    'Karnataka roadlines private limited',
    'Sakkara tours india private limited',
    'Dts travels private limited',
    'Arete services private limited',
    'Jayem logistics private limited',
    'Mahendra roadlines private limited',
    'TRIMURTI CLEARING & FORWARDING AGENTS PRIVATE LIMITED',
    'Dilesh logistics (india) private limited',
    'Star track logistics private limited',
    'Western imaginary transcon private limited',
    'Mitcorr cathodic protection private limited',
    'Lilly maritime private limited',
    'Rajaram bandeker and sons (shipping) private limited',
    'Trice shipping agency private limited',
    'Ocean cargo shipping and logistics private limited',
    'Maricon (i) private limited',
    'Sujan maritime limited',
    'Varun global limited',
    'Pcl shipping private limited',
    'Flyjet air ways private limited',
    'Bangalore aircraft industries private limited',
    'The metroes express cargo private limited',
    'Kal airways private limited',
    'Venus rent a car private limited',
    'Agarwal packers and movers (international) private limited',
    'Newpunjab tourist transport private limited',
    'Jaiswal import cargo services limited',
    'TRAILER AND OPEN TRUCK SERVICES PRIVATE LIMITED',
    'Carex cargo express private limited',
    'Bansard india private limited',
    'Legend travels india private limited',
    'SEAFLAG GLOBAL SHIPPING PRIVATE LIMITED',
    'Lexicon freight international private limited',
    'Manilal patel freight services private limited',
    'Pyramid shipping private limited',
    'Star track shipping private limited',
    'Sunita logistic private limited',
    'Aeeroworld tours and travels private limited',
    'Bharat supply chain solutions private limited',
    'Tittons cargo management systems private limited',
    'S p s marine private limited',
    'Fame cargo private limited',
    'Geetee carriers private limited',
    'Mcc container lines private limited',
    'Trans lanka air travels private limited',
    'Masterstroke freight forwarders private limited',
    'CARGO CARE SHIPPING & FORWARDING ( INDIA) PRIVATE LIMITED',
    'Manilal patel clearing forwarding private limited',
    'ORBIIGO HEAVY LIFTERS PRIVATE LIMITED',
    'Doview holidays india private limited',
    'Palm travels private limited',
    'Nanak clearing and forwarding agent private limited',
    'Sudhanshu travels private limited',
    'Trip showcase private limited',
    'Akansha shipping and logistics private limited',
    'Fleet personnel private limited',
    'Saika maritime private limited',
    'Sabari container terminals private limited',
    'Aviapro logistic services private limited',
    'Handsome tours and travels private limited',
    'Excel freight private limited',
    'Goyam travelpoint private limited',
    'Airticket online limited',
    'Enrich web technologies private limited',
    'Oracle (ofss) processing services limited',
    'Esskay compuservices private limited',
    'Meka parc private limited',
    'Neurotech consulting private limited',
    'Beeline technologies private limited',
    'Cyberace infovision private limited',
    'Alltimeit solutions private limited',
    'Global advertising media private limited',
    'Six o two venture web private limited',
    'CHALO MOBILITY PRIVATE LIMITED',
    'Encrust it solutions private limited',
    'Cubix automation private limited',
    'Keya anand solutions private limited',
    'Dns erp private limited',
    'Arvan technologies private limited',
    'Lonar consulting services private limited',
    'Conexstra technologies private limited',
    'Prayuj tech solutions private limited',
    'Texcel infotech private limited',
    'Sahay datatech private limited',
    'FORTUNE STEEL INDUSTRIES PRIVATE LIMITED',
    'Thredz information technology private limited',
    'Sevya multimedia technologies private limited',
    'Indeed india operations private limited',
    'A & T VIDEO NETWORKS PRIVATE LIMITED',
    'Sulekha .com new media private limited',
    'Grandtech india private limited',
    'Accsource knowledge process outsourcing private limited',
    'Annexmed private limited',
    'Got softwares private limited',
    'Ogs payment technologies and solutions private limited',
    'Dynamic netsoft technologies private limited',
    'Colan infotech private limited',
    'A.g it solutions private limited',
    'Ratech technology solutions private limited',
    'TOUCH DOWN TRAVELS PRIVATE LIMITED',
    'Redtech network india private limited',
    'EXIJENT INFORMATION & TECHNOLOGIES PRIVATE LIMITED',
    'Nkc conveyor india private limited',
    'Siksha training and development private limited',
    'Merlinhawk aerospace private limited',
    'ACUITY KNOWLEDGE CENTRE (INDIA) PRIVATE LIMITED',
    'Multifacet technical center private limited',
    'Kluminos technology solutions private limited',
    'Aditya birla management corporation private limited',
    'Microbial technologies india limited',
    'Hyflux lifestyle products (india) private limited',
    'Anazeal analyticals & research private limited',
    'TCG LIFESCIENCES Private Limited',
    'Design unit architects private limited',
    'Caparo engineering india limited',
    'Bhi capital advisors private limited',
    'Alfa solvents private limited',
    'Scl logistics (india) private limited',
    'Nsl real estates private limited',
    'STELLA ALLOYS STEELS PRIVATE LIMITED',
    'Hrsd informatics private limited',
    'Saanvi lifecare private limited',
    'Innovative erp solutions limited',
    'United 12 trading private limited',
    'Planquadrat india private limited',
    'Teyma india private limited',
    'Credit suisse business management (india) private limited',
    'E- GLOBAL TRADING LIMITED',
    'Satguru corporate services private limited',
    'Telawne cromptek electricals private limited',
    'SSA FINSERV PRIVATE LIMITED',
    'Udaipur builders private limited',
    'Deshdeepak constructions private limited',
    'Sirohia properties & trading co pvt ltd',
    'Shimizu corporation india private limited',
    'Shailja infrastructure developers private limited',
    'Bally high properties pvt ltd',
    'Hitech housing development private limited',
    'Snowfall developers private limited',
    'Ska infrastructure private limited',
    'SIVA AUTOMOTIVE TRADING PRIVATE LIMITED',
    'ATRICA TRADEX PRIVATE LIMITED',
    'Suhana auto private limited',
    'Durable train seats private limited',
    'Capital commercials pvt ltd',
    'Tvs motor services limited',
    'Peekay credit services pvt ltd',
    'Premier nirman private limited',
    'VARDAAN LIFESTYLE LIMITED',
    'Lykos india private limited',
    'COMFORT SHARE TRADING PRIVATE LIMITED',
    'Topstar commotrade private limited',
    'Titanium tie-up private limited',
    'Abhay projects private limited',
    'Ar tradex private limited',
    'Crs builders private limited',
    'Trisha buildwell private limited',
    'Mahabali enclave private limited.',
    'S m enclave private limited.',
    'GSN GAMES INDIA PRIVATE LIMITED',
    'Sri krishna commercial co ltd',
    'Essel mining & industries ltd.',
    'American merchandising limited.',
    'Indotan chemicals ltd',
    'Kripa agents pvt ltd',
    'Travol tie-up private limited',
    'Berylline labs private limited',
    'BASU & BASU ENGINEERS PVT. LTD.',
    'Wilcox merchants pvt ltd',
    'S m griha nirman private limited.',
    'Fort realty private limited',
    'Topline products private limited',
    'Gsnsubh merchandise private limited',
    'Rice realty private limited.',
    'Classic home furnishing private limited',
    'Crest design private limted',
    'Shubeksha trading pvt ltd',
    'Kusum metals private limited',
    'Rinac impex private limited',
    'A. b. p. enterprises private limited',
    'Natural enclave private limited',
    'Cs retail private limited',
    'INDUSLEAF VINTRADE PRIVATE LIMITED',
    'Satyam tie-up private limited',
    'Farrini trade-link private limited',
    'Cheap shoe store (india) private limited',
    'BTL EPC LIMITED',
    'Shreyas cashew company pvt ltd',
    'Timblo planting private limited',
    'Kashmir tyre house private limited',
    'Bahubali dealmark private limited',
    'KASHI VISHWANATH TEXTILE MILL Private Limited',
    'Narnoli apparels private limited',
    'Synthico marketing pvt.ltd.',
    'Tirumala mart pvt ltd',
    'Accent vyapaar private limited',
    'Nakshtra vanijya private limited',
    'Pushraj puranmull pvt ltd',
    'Saphire housing private limited',
    'Crescent infracon private limited',
    'Chrometan exports private limited',
    'Sarada enclave private limited',
    'Siggma motors private limited',
    'Garuda vahan private limited',
    'Panna lal shri krishan dass private limited',
    'Fibretech leathers private limited',
    'Shrikant vinimay private limited',
    'RALLIWOLF INDUSTRIES LIMITED',
    'Whippet infrastructure private limited',
    'Jogmaya infra projects private limited',
    'Ahimsa trading co private limited',
    'Abharan motors private limited',
    'Angira sales private limited',
    'Vakil property services private limited',
    'Steadfast tie up pvt ltd',
    'Bhumi vinimay pvt ltd',
    'PASTEL VANIJYA PRIVATE LIMITED',
    'Nightnagle dealcom private limited',
    'Accord dealcom private limited',
    'Shivanjali prints private limited',
    'Gajendra mercantiles pvt ltd',
    'Allied automation engineering services private limited',
    'Chadha super cars private limited',
    'B m autosales private limited',
    'ASPPEN OVERSEAS LIMITED',
    'Veeteejay marine private limited',
    'BHUTORIA AGROTECH PRIVATE LIMITED',
    'Maroon projects pvt ltd',
    'Parayil food products private limited',
    'Ravigeeth hitech manufacturers and infrastructures private limited',
    'Sundstrand fashion overseas private limited',
    'AVIRAJ EDUCATION RESOURCES PRIVATE LIMITED',
    'Sahu exports private limited',
    'Orange fashion designs private limited',
    'Shivam global apparels private limited',
    'Uppl foams private limited',
    'Delco electronics limited',
    'Msj resources (india) private limited',
    'Sva paper trading private limited',
    'Iva healthcare private limited',
    'Super diesels hitech engineering private limited',
    'Singhvi jewels private limited',
    'Aar kay forge pvt. ltd.',
    'Golden metal private limited',
    'Cinterion wireless modules india private limited',
    'Convotherm india private limited',
    'Charu merchandising private limited',
    'Forest essentials emarketing private limited',
    'Swiss voice india private limited',
    'Connectindia digital private limited',
    'Vaibhavlaxmi exports private limited',
    'Eepc india',
    'Sitara barter pvt ltd',
    'Lakshya distributors pvt ltd',
    'Ralson (india) limited',
    'Premier trading pvt ltd',
    'Sab agencies private limited',
    'S s india private limited',
    'Alwar power company private limited',
    'GRAND SHERATON INDIA HOSPITALITY PRIVATE LIMITED',
    'Mahek infoarts private limited',
    'Shringaar exports private limited',
    'Watrana traction private limited',
    'Worldfa exports private limited',
    'Abaneri art and craft private limited',
    'Kiri exports private limited',
    'Celsius healthcare private limited',
    'Malwa carzone private limited',
    'Nuwud vincom pvt ltd',
    'Tramark vyapaar pvt ltd',
    'Hanurang vinimay pvt ltd',
    'Smile merchandising private limited',
    'Catalyst exim private limited',
    'Surya-shakti vincom pvt ltd',
    'Thoughts & expressions impex private limited',
    'U.s.merchants private limited',
    'Rolex merchants private limited',
    'Sanewal trading house private limited',
    'Go green building private limited',
    'Gharana exports private ltd',
    'Novel telenet private limited',
    'Moonlight tools private limited',
    'Miraj products private limited',
    'Jenirich agro products private limited',
    'Ynm pan global trade private limited',
    'Discovery 21st century agencies private limited',
    'S p brothers pvt ltd',
    'A p fashions private ltd',
    'Navam enterprises private limited',
    'Safex merchandise pvt ltd',
    'Premier irrigation enterprises pvt ltd',
    'Govardhan overseas private limited',
    'Esquire mercantile pvt ltd',
    'Tatpar tradelink pvt ltd',
    'Gangol commodities pvt ltd',
    'Riddhi siddhi trexim private limited',
    'Tv agencies india private limited',
    'Zenith merchandise private limited',
    'Tirupati consumer goods private limited',
    'Shivam retailers private limited',
    'Kamrup commercial private limited',
    'Gokul dealers private limited',
    'Mayfair vyapaar private limited',
    'Gokul commotrade private limited',
    'Atindra enclave (puri) pvt ltd',
    'Pearl valley tie up private limited',
    'Mahima commotrade pvt. ltd.',
    'Jfc hire-purchace pvt. ltd.',
    'Quadtech grafiks (i) private limited',
    'Majula pvt ltd',
    'Pine vintrade private limited',
    'Everlasting trade-link private limited',
    'Wallstreet sales private limited',
    'Bansal realtors ltd',
    'A-tech computer private limited',
    'Visa infrastructure limited',
    'Amravati mercantile private limited',
    'Janpriya mercantile private limited',
    'Rameshwar tradelink private limited',
    'Createum real estates private limited',
    'KARMANYA EDUCATION FOUNDATION',
    'Nitant fabrications private limited',
    'FAIR DEAL PREMIUM WHEELS PRIVATE LIMITED',
    'Value barter private limited',
    'Kgc consulting private limited',
    'SMILE INTERNET TECHNOLOGIES PRIVATE LIMITED',
    'Vedansh consulting private limited',
    'KLEAN W2E PRIVATE LIMITED',
    'COUPA SOFTWARE INDIA PRIVATE LIMITED',
    'SARVADNYA ELECTROTECH PRIVATE LIMITED',
    'MOONVEDA INFOTECH PRIVATE LIMITED',
    'TALENT ASSESSMENT AND ANALYTICS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CENTRE FOR TECHNOLOGY INNOVATION AND ECONOMIC RESEARCH',
    'APTLOGICA TECHNOLOGIES PRIVATE LIMITED',
    'LINQ THERAPEUTICS PRIVATE LIMITED',
    'BLUE FEATHER INFOTECH PRIVATE LIMITED',
    'SIGNZY TECHNOLOGIES PRIVATE LIMITED',
    'WIPER INDIA SERVICES PRIVATE LIMITED',
    'AARA INDUSTRY SOLUTIONS PRIVATE LIMITED',
    'ENLIGHT KNOWLEDGE NETWORK PRIVATE LIMITED',
    'POWER VISION INFOSERVICES PRIVATE LIMITED (OPC)',
    'EDNA VAWSER TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'BLACKBAG HR SERVICES PRIVATE LIMITED',
    'WOLF REGALOS PRIVATE LIMITED',
    'THE JABBERWOCKIES ADVERTISING PRIVATE LIMITED',
    'SAVERA ENERGY PRIVATE LIMITED',
    'MOBICLOUD TECHNOLOGIES PRIVATE LIMITED',
    'COOL SPRING PROMOTIONS PRIVATE LIMITED',
    'SUKAIN INFOWAY PRIVATE LIMITED',
    'THINGSMEET SOLUTIONS PRIVATE LIMITED',
    'VARIOUS SOLUTIONS PRIVATE LIMITED',
    'LIFESCHOOL DIGITAL PRIVATE LIMITED',
    'IN2THINGS AUTOMATION PRIVATE LIMITED',
    'BKC MALL MANAGEMENT PRIVATE LIMITED',
    'RENEW SOLAR ENERGY (JHARKHAND THREE) PRIVATE LIMITED',
    'MS FINCAP PRIVATE LIMITED',
    'NIMITTA MATRA FOUNDATION',
    'BEARINGPOINT INDIA PRIVATE LIMITED',
    'ASHRAM PARAMPARA FOUNDATION',
    'LOOP AGENCY DIGITAL INDIA PRIVATE LIMITED',
    'KARGO SURGE PRIVATE LIMITED',
    'STEERSMAN TALENT ACQUISITION PRIVATE LIMITED',
    'HEART N SOUL HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'JALANDHAR RNG PRIVATE LIMITED',
    'SIGFYN FINANCIAL SERVICES PRIVATE LIMITED',
    'SITARAM ISPAT PRIVATE LIMITED',
    'PAKODAS FOODS PRIVATE LIMITED',
    'NAVAVEDAM MOBILITY PRIVATE LIMITED',
    'JOLLY CLAMPS PRIVATE LIMITED',
    'NDR UNIQUE SPACE PRIVATE LIMITED',
    'SREE DHANALAKSHMI CONSULTANCY SERVICES PRIVATE LIMITED',
    'ROFZI PACIFIC PRIVATE LIMITED',
    'SPLYT MONEY PRIVATE LIMITED',
    'VGROW BUSINESS ADVISORS PRIVATE LIMITED',
    'BLOOMING GARDEN FOUNDATION',
    'CUDDLE MY DOG PRIVATE LIMITED',
    'BLUE-RIBBON FOOD WORKS PRIVATE LIMITED',
    'PETOMATE IT SOLUTIONS PRIVATE LIMITED',
    'CNJ BUSINESS SOLUTIONS PRIVATE LIMITED',
    'NEOBIUM ENVIRO SOLUTIONS PRIVATE LIMITED',
    'EXCELLORS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'ACOFINO PRIVATE LIMITED',
    'IBD GLOBAL SERVICES PRIVATE LIMITED',
    'BSC TEXTILES PRIVATE LIMITED',
    'NANOKANAKBIOTECH PRIVATE LIMITED',
    'PURETROP FOODS PRIVATE LIMITED',
    'BIZNOTION RESTO PRIVATE LIMITED',
    'PETRICHOR SPIRITS PRIVATE LIMITED',
    'NDR HOLDINGS PRIVATE LIMITED',
    'BPN HOSPITALITY PRIVATE LIMITED',
    'ANALYTIXHIRE INDIA PRIVATE LIMITED',
    'S C N PROJECTS PRIVATE LIMITED',
    'SGURRCARE FOUNDATION',
    'NUTRIGLOW GBL LIFESCIENCES PRIVATE LIMITED',
    'TELEIOS FINANCIAL SERVICES PRIVATE LIMITED',
    'AATAPATA TECH INDIA PRIVATE LIMITED',
    'MRAA (OPC) PRIVATE LIMITED',
    'V STRAP PACKAGING PRIVATE LIMITED',
    'FPEL MITRA PRIVATE LIMITED',
    'ELP SOLAR FOUR PRIVATE LIMITED',
    'ONFLEEK MARKETING PRIVATE LIMITED',
    'INFRAVOLT PROJECTS PRIVATE LIMITED',
    'HERA CONSUMER INDIA PRIVATE LIMITED',
    'DIONYSUS CONSUMER INDIA PRIVATE LIMITED',
    'MEAL FOR INDIA FEDERATION',
    'MIZA LABS PRIVATE LIMITED',
    'SIMPLIFIED OUTSOURCED SOLUTIONS INDIA PRIVATE LIMITED',
    'SRI VEL COMMODITIES INDIA PRIVATE LIMITED',
    'EVERNEST INDUSTRIAL PARK PRIVATE LIMITED',
    'AKSHIPTIKA INFOTECH (OPC) PRIVATE LIMITED',
    'MIC CHEMICALS PRIVATE LIMITED',
    'SECURE FORTUNE PRIVATE LIMITED',
    'AIRBOUND AEROSPACE PRIVATE LIMITED',
    'GKN AUTOMOTIVE BENGALURU PRIVATE LIMITED',
    'QUALTEK STEEL DETAILING PRIVATE LIMITED',
    'EXPONENT FINSERV PRIVATE LIMITED',
    'PASEO GREEN PRIVATE LIMITED',
    'HAPPY INDIGENOUS PETS PRIVATE LIMITED',
    'DKH SOLUTIONS PRIVATE LIMITED',
    'SVRN TECHNOLOGIES PRIVATE LIMITED',
    'SHIPSPARE FORWARDER MARINETRANS PRIVATE LIMITED',
    'RENTLA PRIVATE LIMITED',
    'ASTOUNDED PROPERTIES PRIVATE LIMITED',
    'KNR RAMAGIRI INFRA PRIVATE LIMITED',
    'NAFEES FASHION PRIVATE LIMITED',
    'MPL LOGISTICS HUB PRIVATE LIMITED',
    'ASHWIN MITTAL FOUNDATION',
    'GH MARKETING SERVICES PRIVATE LIMITED',
    'SYMATRIX GLOBAL IT SERVICES PRIVATE LIMITED',
    'SIL POWER STORAGE SOLUTIONS PRIVATE LIMITED',
    'QUANFLUENCE PRIVATE LIMITED',
    'GREENHIGHRANGE FARMERS PRODUCER COMPANY LIMITED',
    'INDITECH HEALTH SOLUTIONS PRIVATE LIMITED',
    'OPRIMES SOLUTIONS PRIVATE LIMITED',
    'NEXOMS INDIA PRIVATE LIMITED',
    'ELIMO IMPEX (OPC) PRIVATE LIMITED',
    'RADIANCE MH SUNRISE SEVENTEEN PRIVATE LIMITED',
    'GSL CREATIVES PRIVATE LIMITED',
    'SAARTHI POLYMERS PRIVATE LIMITED',
    'BRANDFIRST CREATIONS PRIVATE LIMITED',
    'INDIA SEAL PACKAGING PRIVATE LIMITED',
    'KHAYATI PIPES AND POWER PRIVATE LIMITED',
    'NEBILLIO ELECTRONICS INDIA PRIVATE LIMITED',
    'AVAADA KNSHORAPUR PRIVATE LIMITED',
    'LUX FLAVOURS INDIA PRIVATE LIMITED',
    'ICOST APEX CONSULTANTS INDIA PRIVATE LIMITED',
    'BETTER WORLD STUDY PRIVATE LIMITED',
    'NEBRASKA ENTERPRISES PRIVATE LIMITED',
    'SRKA FOUNDATION',
    'PRIME MS PRIVATE LIMITED',
    'ABERDEEN RETAIL PRIVATE LIMITED',
    'AARTVA ENTERPRISE PRIVATE LIMITED',
    'HIBIZ CONSULTING PRIVATE LIMITED',
    'WIT BY BIT PRIVATE LIMITED',
    'FOGAAN PRIVATE LIMITED',
    'PREM INDUSTRIES INDIA LIMITED',
    'BIO FRIENDLY PACKS PRIVATE LIMITED',
    'SHABAD TRAVEL SERVICES PRIVATE LIMITED',
    'EQOMOS PRIVATE LIMITED',
    'BUKAKA THREE D PRIVATE LIMITED',
    'EXPO STAND SERVICES PRIVATE LIMITED',
    'D N Y S BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'KNIGHT SKY PRIVATE LIMITED',
    'LABHANTE PRIVATE LIMITED',
    'AKSUM TRADEMART PRIVATE LIMITED',
    'PLIVO SERVICES INDIA PRIVATE LIMITED',
    'BOOTES WIRELESS TECHNOLOGIES PRIVATE LIMITED',
    'HUMAN HORIZON PRIVATE LIMITED',
    'HAYAT INTERNATIONAL IT SERVICES PRIVATE LIMITED',
    'IVI VENTURES PRIVATE LIMITED',
    'ACE ENMAS RENEWABLES PRIVATE LIMITED',
    'MUNDRISOFT SOLUTIONS PRIVATE LIMITED',
    'LOGHIKE CONSULTANCY PRIVATE LIMITED',
    'STS.AI SOFTWARE SYSTEMS PRIVATE LIMITED',
    'NOVOBLISS RESEARCH PRIVATE LIMITED',
    'JOFOLLOWPLUS INDUSTRIES PRIVATE LIMITED',
    'RANPAT DEV INFRASTRUCTURE PRIVATE LIMITED',
    'KINECO EXEL COMPOSITES INDIA PRIVATE LIMITED',
    'SIRASLEWALA FOUNDATION',
    'DEFCOL GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'RCT SOLUTIONS INDIA PRIVATE LIMITED',
    'PLACE ASSURED CONSULTANTS PRIVATE LIMITED',
    'LARTISAN PRODUCTS PRIVATE LIMITED',
    'HANSTECH VENTURE PRIVATE LIMITED',
    'KRISHNA OCEAN PRIVATE LIMITED',
    'PHARMAWALL PRIVATE LIMITED',
    'HOMFEEL VEGH AUTOMOBILES PRIVATE LIMITED',
    'PRABHA DEVI ENTERPRISES PRIVATE LIMITED',
    'MYGATEDSOCIETY SERVICES PRIVATE LIMITED',
    'NEXXUS PETRO INDUSTRIES LIMITED',
    'CONCEPT KART PRIVATE LIMITED',
    'TIGERS GLOBAL FORWARDING PRIVATE LIMITED',
    'ARYAJUN MARITIME SERVICES PRIVATE LIMITED',
    'RISHI SHIPSECURE PRIVATE LIMITED',
    'BELLCO INFRA PRIVATE LIMITED',
    'PET EDGE PRIVATE LIMITED',
    'SAMRUDH BHARAT SOCIAL WELFARE FOUNDATION',
    'I MED SOLUTIONS INDIA PRIVATE LIMITED',
    'JOIN VENTURES SOLUTIONS PRIVATE LIMITED',
    'RADCOMDEV INDIA PRIVATE LIMITED',
    'VALITY AUTOMATION PRIVATE LIMITED',
    'CAUVERY SOLUTIONS PRIVATE LIMITED',
    'OMI IOT TECHNOLOGY PRIVATE LIMITED',
    'NOBIS LABS PRIVATE LIMITED',
    'NEUBERG SAI SRIDEVI DIAGNOSTICS PRIVATE LIMITED',
    'BSK REAL ESTATE PRIVATE LIMITED',
    'ADVENTURE CONSULTANCY SOLUTIONS INDIA PRIVATE LIMITED',
    'DAYBEST SABRO AERIAL INTELLIGENCE PRIVATE LIMITED',
    'EASY HIRING SOLUTIONS SERVICES INDIA PRIVATE LIMITED',
    'CARIOT AUTO PRIVATE LIMITED',
    'ECO ORBIT CONSULTANCY PRIVATE LIMITED',
    'UNITBIRWELCO IISP THERMAL EQUIPMENT PRIVATE LIMITED',
    'SANDEEP SHIKRE ASSOCIATES CONSULTANTS PRIVATE LIMITED',
    'KRYSALIS HEALTHCARE & SERVICES PRIVATE LIMITED',
    'GKN FOOD PRODUCTS PRIVATE LIMITED',
    'RAYA FOODS PRIVATE LIMITED',
    'EMMPOWER GLOBIANS EXIM PRIVATE LIMITED',
    'RASPBERRY HEALTH PRIVATE LIMITED',
    'APSONIC PRIVATE LIMITED',
    'FRINJALS (OPC) PRIVATE LIMITED',
    'WELLMADE PANELS PRIVATE LIMITED',
    'TALENT MINING SOLUTIONS INDIA PRIVATE LIMITED',
    'AMPI PACKAGING PRIVATE LIMITED',
    'ACCELANE PRIVATE LIMITED',
    'ALPINEXPRESS RETAIL PRIVATE LIMITED',
    'EVANO MOBILITY PRIVATE LIMITED',
    'ADET PRIVATE LIMITED',
    'GET MAX VALUE PRIVATE LIMITED',
    'ZELECLOUD PRIVATE LIMITED',
    'INDMONEY PRIVATE LIMITED',
    'PINK SAMURAIS INDIA PRIVATE LIMITED',
    'AQEX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NEW TRENDS COMMERCE PRIVATE LIMITED',
    'MECHTRON ENGINEERING PRIVATE LIMITED',
    'LET',
    'S BEAUTY LOUNGE (OPC) PRIVATE LIMITED',
    'CVIAC TECHNOLOGIES PRIVATE LIMITED',
    'VIGNESHWAR AERO MARINE PRIVATE LIMITED',
    'AIMEX INDUSTRIES PRIVATE LIMITED',
    'CREDINCIOS TECH PRIVATE LIMITED',
    'JSR ECR ROAD PROJECT PRIVATE LIMITED',
    'RESILIENCE SOLUTIONS AND RESEARCH (OPC) PRIVATE LIMITED',
    'LONG SHOT INNOVATIONS PRIVATE LIMITED',
    'ISONLINE MARKETING PRIVATE LIMITED',
    'MADIKERI CONSTRUCTION PRIVATE LIMITED',
    'GROWMATE VENTURES PRIVATE LIMITED',
    'TECHCORAL SOLUTIONS AND SERVICES INDIA PRIVATE LIMITED',
    'RBV LIFESTYLE PRIVATE LIMITED',
    'AROTE ALLIANCE PRIVATE LIMITED',
    'DROPIK PRIVATE LIMITED',
    'MIKE BAGS MANUFACTURERS INDIA PRIVATE LIMITED',
    'FACTIVEMINDS CONSULTING PRIVATE LIMITED',
    'LEBAMART RETAIL PRIVATE LIMITED',
    'NEOINVENTRONIX PRIVATE LIMITED',
    'MINDZVUE TECHNOLOGIES PRIVATE LIMITED',
    'TRANSHEALTH PRIVATE LIMITED',
    'TARK AI PRIVATE LIMITED',
    'POWERRICH ENGINEERING PRIVATE LIMITED',
    'AURODESIGN PRIVATE LIMITED',
    'S.R. DRUGS AND INTERMEDIATES (UNIT 3) PRIVATE LIMITED',
    'IQUANTM TECHNOLOGIES PRIVATE LIMITED',
    'CHINMASTIKA CARES FOUNDATION',
    'REMOTE INFOSYSTEM PRIVATE LIMITED',
    'ZIDHARATHUL MUNTHAHA PRIVATE LIMITED',
    'ERIS PHARMACEUTICALS PRIVATE LIMITED',
    'ST. MARY',
    'S TECH PRIVATE LIMITED',
    'HELTHDOSE LIFESCIENCES (OPC) PRIVATE LIMITED',
    'SMV AGENCIES AND RETAIL PRIVATE LIMITED',
    'HEALTHTECH SERVICES PRIVATE LIMITED',
    'SOLUGO RESEARCH PRIVATE LIMITED',
    'VERANA NETWORKS (INDIA) PRIVATE LIMITED',
    'ZEROSHOTS FILMS PRIVATE LIMITED',
    'FAIRMONEY FINANCIAL SERVICES PRIVATE LIMITED',
    'VBG REALCON PRIVATE LIMITED',
    'KIRANAA EXPRESS FOODS PRIVATE LIMITED',
    'UNIFAB DEFENCE PRIVATE LIMITED',
    'TEAMKOLLYWOOD NETWORKS PRIVATE LIMITED',
    'RAAS EQUIPMENT PRIVATE LIMITED',
    'GRASSWAY FARMS PRIVATE LIMITED',
    'AMBHIRE GLOBAL SERVICES (OPC) PRIVATE LIMITED',
    'SHREE RAMA TRADING PRIVATE LIMITED',
    'THINK REAL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ARTHYA WEALTH AND INVESTMENTS PRIVATE LIMITED',
    'PULSE COMMS INDIA PRIVATE LIMITED',
    'VASUNDHRA MINING & RESOURCES PRIVATE LIMITED',
    'COGNIWIZE INFOSYSTEMS PRIVATE LIMITED',
    'NEWJAISA TECHNOLOGIES LIMITED',
    'DOON FOOD VENTURES PRIVATE LIMITED',
    'NASIK FARM VENTURES PRIVATE LIMITED',
    'GLOBAL WINGS MEDIA PRIVATE LIMITED',
    'SAGARASIA RENEWABLES & ACCESS EQUIPMENT PRIVATE LIMITED',
    'SOULTECHINNOVATIONS PRIVATE LIMITED',
    'GXG PUBLISHING HOUSE PRIVATE LIMITED',
    'AMPUESTO CONSULTANCY PRIVATE LIMITED',
    'BITFLYER TECHNOLOGIES PRIVATE LIMITED',
    'MONALISA STORES PRIVATE LIMITED',
    'TECHSUN BIO PRIVATE LIMITED',
    'SEISIO TECHNOLOGIES PRIVATE LIMITED',
    'IBEST SERVICES AND MAINTENANCE PRIVATE LIMITED',
    'ECOSCIENCE INNOVATION PRIVATE LIMITED',
    'VSA3B PRIVATE LIMITED',
    'ZARAKE PRIVATE LIMITED',
    'ABHISHEK SHAH CREATIONS PRIVATE LIMITED',
    'MANGOLEAP PRIVATE LIMITED',
    'AYOSHYA TECHNOLOGIES PRIVATE LIMITED',
    'MOHINI HYGIENE CARE PRODUCTS PRIVATE LIMITED',
    'DEVSIG TECHNOLOGIES PRIVATE LIMITED',
    'WCDT BRANDS PRIVATE LIMITED',
    'ICODET PRIVATE LIMITED',
    'JUVOLABS INDIA PRIVATE LIMITED',
    'MANAKATTAMPALLY BIO SCIENCES PRIVATE LIMITED',
    'EMPOWER ACTION SPACE PRIVATE LIMITED',
    'CHEMMAN LABS PRIVATE LIMITED',
    'IITM PRAVARTAK TECHNOLOGIES FOUNDATION',
    'FINNABLE TECHNOLOGIES PRIVATE LIMITED',
    'AEGIS ELECTRONICS PRIVATE LIMITED',
    'ZM DIGITECH COMMUNICATIONS PRIVATE LIMITED',
    'ARJUN DESIGN LABS PRIVATE LIMITED',
    'GEEKLURN INFO SOLUTIONS PRIVATE LIMITED',
    'EARTH CRUST PRIVATE LIMITED',
    'LNKD PRIVATE LIMITED',
    'MELECS TECHNOLOGIES PRIVATE LIMITED',
    'QRDLAB PRIVATE LIMITED',
    'PREIMAGE PRIVATE LIMITED',
    'PRO-TELLIGENT INDIA PRIVATE LIMITED',
    'ENUMERATE AI PRIVATE LIMITED',
    'KHUSHEIM TECH AND SERVICES PRIVATE LIMITED',
    'AIRPATH SOLUTIONS PRIVATE LIMITED',
    'MORREX LOGISTICS PRIVATE LIMITED',
    'GOONCHA PROPERTIES PRIVATE LIMITED',
    'VAULTY PRIVATE LIMITED',
    'ESSENTIAL4 WORK INDIA PRIVATE LIMITED',
    'PACKSO TECHNOLOGY PRIVATE LIMITED',
    'OUTFITFUSION ECOMMERCE AND SERVICE (OPC)PRIVATE LIMITED',
    'TECH REFLECTS PRIVATE LIMITED',
    'MADHDA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ENTREPRENEURIAL INNOVATORS PRIVATE LIMITED',
    'VSE COMPUTERS PRIVATE LIMITED',
    'LOVEFROM PRIVATE LIMITED',
    'BUSINESS KARMA MARKETING PRIVATE LIMITED',
    'AGVESTO INDIA PRIVATE LIMITED',
    'TRADEOPEDIA INDIA PRIVATE LIMITED',
    'DIGISELLBUY DIGITAL MARKETPLACE PRIVATE LIMITED',
    'VEERAJ UNIHERBS PRIVATE LIMITED',
    'THIO TECH SOLUTIONS PRIVATE LIMITED',
    'BRIDGETREE RESEARCH SERVICES PRIVATE LIMITED',
    'DEENTAX BUSINESS PROCESS PRIVATE LIMITED',
    'PRODESI CONSULTING PRIVATE LIMITED',
    'MORPHO HOTELS AND RESORTS INDIA PRIVATE LIMITED',
    'VANAMATRE PRIVATE LIMITED',
    'ABC DIARIES PRODUCTION HOUSE PRIVATE LIMITED',
    'VALUNOVA LIFESCIENCES PRIVATE LIMITED',
    'AYURLUSH NATURALS PRIVATE LIMITED',
    'S4 CONSULTANTS & SERVICES PRIVATE LIMITED',
    'GMD PHARMA PRIVATE LIMITED',
    'KEYLOOP INDIA PRIVATE LIMITED',
    'SSQUARED MEDITECH PRIVATE LIMITED',
    'DIAMONIC JEWELS PRIVATE LIMITED',
    'TASKOPAD SOLUTIONS PRIVATE LIMITED',
    'TWENTIES ENTERTAINMENT PRIVATE LIMITED',
    'ARTHAK TOURS MANAGEMENT INDIA PRIVATE LIMITED',
    'FINANALYTIC CAPITAL MANAGEMENT PRIVATE LIMITED',
    'VIDEN ITPRO PRIVATE LIMITED',
    'RETAILWOLF PLATFORMS PRIVATE LIMITED',
    'WATER-HAND PRIVATE LIMITED',
    'HAVENLEY INDUSTRIES LIMITED',
    'VARUP TECHNOLOGIES PRIVATE LIMITED',
    'JAEC INTERNATIONAL PRIVATE LIMITED',
    'URZUV LIFESTYLE PRIVATE LIMITED',
    'ATOJ LABS INDIA PRIVATE LIMITED',
    '5W1H MEDIA PRIVATE LIMITED',
    'ATUS TECHNOLOGIES PRIVATE LIMITED',
    'GRADRAISE PRIVATE LIMITED',
    'POLYMED SUPPLIES PRIVATE LIMITED',
    'SLASHTHEORY PRIVATE LIMITED',
    'INSIGHT-AWP INDIA PRIVATE LIMITED',
    'INFINITY MOTORS PRIVATE LIMITED',
    'NAPCO ENTERPRISES INDIA PRIVATE LIMITED',
    'BHADRA PRODUCTIONS LIMITED',
    'KDC TEK PRIVATE LIMITED',
    'TRUEIDM PRIVATE LIMITED',
    'BHUJA MAL FOODS AND AGRO INDUSTRIES PRIVATE LIMITED',
    'AUROUS PETRO PRIVATE LIMITED',
    'MALLINGTON SOLUTIONS PRIVATE LIMITED',
    'KRAFTFULL SHIELDS PRIVATE LIMITED',
    'MOTHERSON SUMI WIRING INDIA LIMITED',
    'WEALTHBIZZ ADVISORS PRIVATE LIMITED',
    'ARYAMOND INDUSTRIES PRIVATE LIMITED',
    'DHOLERA MIDTOWN PRIVATE LIMITED',
    'TRISHAKTHI VARAHI FOODS PRIVATE LIMITED',
    'KINELABS PRIVATE LIMITED',
    'PLUSNINEONE DEVELOPMENTS PRIVATE LIMITED',
    'FRISK CONSULTING PRIVATE LIMITED',
    'AARYAVRAT INDIA LIMITED',
    'OXION IT (OPC) PRIVATE LIMITED',
    'OPPORTUNE VENTURES PRIVATE LIMITED',
    'ASHMITA FOOD PRODUCTS PRIVATE LIMITED',
    'SIGA FUTURE CONSULTING PRIVATE LIMITED',
    'INCNUT STYLECRAZE PRIVATE LIMITED',
    'TRILLION INDUSTRIES PRIVATE LIMITED',
    'RFP TECHNOLOGIES PRIVATE LIMITED',
    'AZAD HIND UDYOG PRIVATE LIMITED',
    'TECHZZLER INTERNATIONAL PRIVATE LIMITED',
    'SYMBIANS ENERSOL PRIVATE LIMITED',
    'MYYTAKE PRIVATE LIMITED',
    'SWATSAN TECH PRIVATE LIMITED',
    'KLUSTR SPACE TECH PRIVATE LIMITED',
    'SALUS PRODUCTS PRIVATE LIMITED',
    'ASPIREJAZP TECHNOLOGIES PRIVATE LIMITED',
    'LACOSA PROFESSIONAL COSMETICS PRIVATE LIMITED',
    'ROMAN SPIRITS PRIVATE LIMITED',
    'KAIRISH INNOTECH PRIVATE LIMITED',
    'FAST RUPIYA AGRO TECHNOLOGY SERVICES PRIVATE LIMITED',
    'UTTAMVISHNU SNACKS PRIVATE LIMITED',
    'SOMYA WHEELS PRIVATE LIMITED',
    'EURO7 BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WISEHIVE SOLUTIONS PRIVATE LIMITED',
    'CAFEPLEX ENTERTAINMENT PRIVATE LIMITED',
    'ALL INDIA IT AND CYBER SECURITY RESEARCH ASSOCIATION',
    'AJEYA TECH SOLUTIONS PRIVATE LIMITED',
    'JETFOUR SECURITY SERVICES PRIVATE LIMITED',
    'TECHULTRA SOLUTIONS PRIVATE LIMITED',
    'COMPEST SOLUTIONS INDIA PRIVATE LIMITED',
    'VOSTEK CAREERS PRIVATE LIMITED',
    'PAYODA PANCHGAVYA AYURVED PRIVATE LIMITED',
    'STUDIEEN ACADEMY OF FINANCIAL MANAGEMENT(OPC) PRIVATE LIMITED',
    'PHONEQ TECH PRIVATE LIMITED',
    'APPNMEDIA INTERNET PRIVATE LIMITED',
    'TOPSACK EXPORTS PRIVATE LIMITED',
    'GLOBALCODE TECHNOLOGIES PRIVATE LIMITED',
    'REXELPAY INDIA PRIVATE LIMITED',
    'MANARR AGRIFARMS AND NURSERIES PRIVATE LIMITED',
    'MATDEV INVESTMENT ADVISERS PRIVATE LIMITED',
    'ASPIRE FINTECH PRIVATE LIMITED',
    'LIFESPICE INDIA PRIVATE LIMITED',
    'AVIRATA DEFENCE SYSTEMS LIMITED',
    'NAGORIK SOMONNOY MANCHA FOUNDATION',
    'ASTU TECHNOLOGIES PRIVATE LIMITED',
    'HIND CREATIVE AND ADVERTISING SOLUTIONS PRIVATE LIMITED',
    'TARGET DIGITAL PRIVATE LIMITED',
    'SKYGLIDER REALTOR PRIVATE LIMITED',
    'MULTITECH-EDA SYSTEMS PRIVATE LIMITED',
    'SUVRIDDHI DEVELOPERS PRIVATE LIMITED',
    'METERON TECHNOLOGIES PRIVATE LIMITED',
    'AIKENKA TECHNOLOGIES PRIVATE LIMITED',
    'SURI CONSUMER PRIVATE LIMITED',
    'UDAIPUR SOLAR PRIVATE LIMITED',
    'RENT N FLAUNT PRIVATE LIMITED',
    'YUVA INDIA FOUNDATION',
    'GODLY CLOUD PRIVATE LIMITED',
    'GLOBAL COLLIANCE OVERSEAS EDUCATION PRIVATE LIMITED',
    'KHALATKAR CONSTRUCTION INFRA PRIVATE LIMITED',
    'GINGIIS PRIVATE LIMITED',
    'DRYWALL SYSTEMS INDIA PRIVATE LIMITED',
    'POSH INDIA OFFSHORE PRIVATE LIMITED',
    'HARDIK INTERNATIONAL PRIVATE LIMITED',
    'MOFFI CLOTHING PRIVATE LIMITED',
    'HILLSTEP FARMS PRIVATE LIMITED',
    'RECREATIONS LAB PRIVATE LIMITED',
    'MEERA SOCIAL FOUNDATION',
    'PERT IMPEX PRIVATE LIMITED',
    'SCOAR EDTECH PRIVATE LIMITED',
    'INDUSCANN BIOGROWTH PRIVATE LIMITED',
    'SUNRISE PHARMACHEM PRIVATE LIMITED',
    'CONFIAS PRIVATE LIMITED',
    'PRASAD ROADS AND INFRA PRIVATE LIMITED',
    'GCAP WORLD SOFTECH PRIVATE LIMITED',
    'EUMAN THERAPEUTICS PRIVATE LIMITED',
    'WALKING TREE BRANDS PRIVATE LIMITED',
    'MASHI AGRO INDIA PRIVATE LIMITED',
    'PEGATRON TECHNOLOGY INDIA PRIVATE LIMITED',
    'AIR DROBOTICS & INTELLIGENCE PRIVATE LIMITED',
    'DIAMOND FOOD AND BEVERAGES PRIVATE LIMITED',
    'SKYKITCHEN FOOD TECH PRIVATE LIMITED',
    'V2X SECURITY SOLUTIONS PRIVATE LIMITED',
    'TECKVALLEY INDIA PRIVATE LIMITED',
    'PAYMINT FINTECH PRIVATE LIMITED',
    'REBEL MARKETPLACE INDIA PRIVATE LIMITED',
    'MORPHO COATINGS PRIVATE LIMITED',
    '7INGH CODE LABS PRIVATE LIMITED',
    'OPENHAUS TECHNOLOGIES PRIVATE LIMITED',
    'TALPRO INDIA PRIVATE LIMITED',
    'COOX ONLINE PRIVATE LIMITED',
    'OCTOVIGINT PRIVATE LIMITED',
    'DYNANET ONLINE SUPPORT PRIVATE LIMITED',
    'NATUREEXPERT AYURVEDIC PRIVATE LIMITED',
    'UNWILD PLANET TRAVELS PRIVATE LIMITED',
    'PICOTECH ENERGY PRIVATE LIMITED',
    'MASSIF RECRUITMENTS PRIVATE LIMITED',
    'GANESH MOHITE FOOD AND SPICES INDUSTRIES(OPC) PRIVATE LIMITED',
    'MARQUE MEUBLES PRIVATE LIMITED',
    'ACCURA TECHNOLABS PRIVATE LIMITED',
    'GLOBAL ATTRI FACILITY MANAGEMENT PRIVATE LIMITED',
    'ACCOUNTURE SOLUTIONS PRIVATE LIMITED',
    'GLEE ENTERPRISES PRIVATE LIMITED',
    'VAIDHUDYAM CHAMBER OF COMMERCE AND INDUSTRY',
    'UGR SILOS LALITPUR PRIVATE LIMITED',
    'ALLSPACE FINVEST PRIVATE LIMITED',
    'JRC VENTURES PRIVATE LIMITED',
    'NIRMAL VASUNDHARA PRIVATE LIMITED',
    'VIBEZ AGROTECH SOLUTION PRIVATE LIMITED',
    'CHHEDA FINE JEWELLERY PRIVATE LIMITED',
    'PRUDENT HEALTHCARE SERVICES PRIVATE LIMITED',
    'ACIC MIET MEERUT FOUNDATION',
    'TECH SHIPPING (OPC) PRIVATE LIMITED',
    'SPROUTO INFOSOLUTIONS PRIVATE LIMITED',
    'VRIDDHI MANAGEMENT SERVICES PRIVATE LIMITED',
    'ACCESS BPO PRIVATE LIMITED',
    'SNVISION TECHNOCRATS PRIVATE LIMITED',
    'ALPOSH PRIVATE LIMITED',
    'CURV TECHNOLOGIES PRIVATE LIMITED',
    'HAYAAIPRO INDIA PRIVATE LIMITED',
    'DESIGNOGC (INDIA) PRIVATE LIMITED',
    'VALUE DESIGN INFRA PRIVATE LIMITED',
    'VALUE CENTRUM RETAIL PRIVATE LIMITED',
    'MCDAS PRIVATE LIMITED',
    'TEKFORTUNE MEDIA NETWORK PRIVATE LIMITED',
    'AHMADHUSSAIN MANUFACTURING & TRADING PRIVATE LIMITED',
    'URJA CSSD ENGINEERS PRIVATE LIMITED',
    'VEHPAL INDIA PRIVATE LIMITED',
    'MICROPACK VENTURES PRIVATE LIMITED',
    'LODHI FRESH FARMS PRIVATE LIMITED',
    'BYTEQUARK SOLUTIONS PRIVATE LIMITED',
    'SG ALCARGO LOGISTICS PRIVATE LIMITED',
    'EKAA BEAUTY PRIVATE LIMITED',
    'SOCIAL LISTENING PRIVATE LIMITED',
    'NSK SHIP MANAGEMENT PRIVATE LIMITED',
    'TERRA VERDE FOODS PRIVATE LIMITED',
    'HEALTOUCH ENTERPRISE PRIVATE LIMITED',
    'SQUAREFIN PRIVATE LIMITED',
    'THENI KAMADHENU FARMER PRODUCER COMPANY LIMITED',
    'UTISTHATA FOUNDATION',
    'NANZ HEALTHCARE PRIVATE LIMITED',
    'DAILYCHOICE INTERNATIONAL PRIVATE LIMITED',
    'NEOWARE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'WOBA ECOMMERCE PRIVATE LIMITED',
    'TP KIRNALI SOLAR LIMITED',
    'BLUE AVOCADO SOLUTIONS PRIVATE LIMITED',
    'AGNIMITRA SIKSHASADAN PRIVATE LIMITED',
    'DENTAL FACTS (OPC) PRIVATE LIMITED',
    'BUSINESSONBOT PRIVATE LIMITED',
    'AMPYR RENEWABLE ENERGY RESOURCES SIX PRIVATE LIMITED',
    'MRN CANEPOWER AND BIOREFINERIES PRIVATE LIMITED',
    'ART OF SOURCING (OPC) PRIVATE LIMITED',
    'ORCH PHARMA PRIVATE LIMITED',
    'BIZPROF PLATFORM PRIVATE LIMITED',
    'SVARAM PHARMA PRIVATE LIMITED',
    'EMPCLOUD INDIA PRIVATE LIMITED',
    'DESI N ANGREZI CONSULTING PRIVATE LIMITED',
    'HOSROY CONSTRUCTION TECHNOLOGIES PRIVATE LIMITED',
    'SITALAKSHMI ACADEMY PRIVATE LIMITED',
    'ACROPOLIS INFRAPORT PRIVATE LIMITED',
    'MERLA SONS PRIVATE LIMITED',
    'OZLO IT SERVICES PRIVATE LIMITED',
    'AIRIFIC SYSTEMS PRIVATE LIMITED',
    'AROGYA LIFESCIENCES PRIVATE LIMITED',
    'PACIFIC ENGINEERED SURFACES PRIVATE LIMITED',
    'PRIDETECH ENGINEERING SERVICES PRIVATE LIMITED',
    'GAHAN AI PRIVATE LIMITED',
    'LENKA SPARES LIMITED',
    'SETP-UPA MANAGEMENT SERVICES (OPC) PRIVATE LIMITED',
    'IW FIREWALK PRIVATE LIMITED',
    'SAKURA ROBOTICS ACADEMY PRIVATE LIMITED',
    'SYDPACK SOLUTIONS PRIVATE LIMITED',
    'SHRIVAARI ELECTROTECH PRIVATE LIMITED',
    'ZOO LABS INDIA PRIVATE LIMITED',
    'OSCAR LIFESCIENCES PRIVATE LIMITED',
    'MANUFAC ANALYTICS PRIVATE LIMITED',
    'STERLING PETROLEUM PRIVATE LIMITED',
    'ZUV FOUNDATION',
    'LETS SKILL INDIA FOUNDATION',
    'PROPLUS DATA PRIVATE LIMITED',
    'MARIWALA CONSULTANCY PRIVATE LIMITED',
    'CIRCLE E INTERNATIONAL PRIVATE LIMITED',
    'ZEN MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'AUROSTARINVESTMENT ADVISORY PRIVATE LIMITED',
    'STARSHOT TECHNOLOGIES PRIVATE LIMITED',
    'GENUS PAPER AND COKE LIMITED',
    'SPRING VALLEY FINANCIAL ADVISORS PRIVATE LIMITED',
    'ZAVERBEN DAHYALAL KORANI FOUNDATION',
    'ELUCIIDAATE TECH PRIVATE LIMITED',
    'UNITED BROTHERS SHIPPING SERVICES PRIVATE LIMITED',
    'PRASANNA ELECTRIC PRIVATE LIMITED',
    'CHEBIZZ ONLINE SERVICES PRIVATE LIMITED',
    'DORABHAI PRIVATE LIMITED',
    'METJOY TECHNOLOGIES PRIVATE LIMITED',
    'PRO IMFUNDO PRIVATE LIMITED',
    'SEVEN PROCUREMENT PRIVATE LIMITED',
    'KIAAN WIRES AND STEELS PRIVATE LIMITED',
    'VINDECARE SYSTEMS PRIVATE LIMITED',
    'IUGOFI NETWORKING PRIVATE LIMITED',
    'PRAVARSHA MART PRIVATE LIMITED',
    'IPOLARITY TECHNOLOGIES PRIVATE LIMITED',
    'IZING LUXURY (OPC) PRIVATE LIMITED',
    'GOLDMINE CORPORATE INVESTMENT PRIVATE LIMITED',
    'SURVEILLANCE SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED',
    'NOVELSYNERGY ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'TATA MEDICAL AND DIAGNOSTICS LIMITED',
    'ZUPPPY TECH SERVICES PRIVATE LIMITED',
    'PATNA AYURVEDIA PHARMACY PRIVATE LIMITED',
    'ADJECTUS SERVICES PRIVATE LIMITED',
    'YUP INFOTECH PRIVATE LIMITED',
    'TRENZY INDUSTRIES PRIVATE LIMITED',
    'ANTON AUTOMATION PRIVATE LIMITED',
    'NATIONAL HIGHWAYS INFRA PROJECTS PRIVATE LIMITED',
    'READYCLIENT SOLUTIONS PRIVATE LIMITED',
    'SKYLEAPS INDUSTRIES PRIVATE LIMITED',
    'G EMPOWER BROADCASTING PRIVATE LIMITED',
    'OHGAGGLE PRIVATE LIMITED',
    'KEGS AND BARRELS VENTURES PRIVATE LIMITED',
    'LEARNING LINKUPS PRIVATE LIMITED',
    'HEMMERSBACH KIDS FAMILY FOUNDATION',
    'JSD FITNESS SERVICES PRIVATE LIMITED',
    'ANANDA HOLISTICS PRIVATE LIMITED',
    'RADIANCE TN SOLAR POWER PRIVATE LIMITED',
    'AYUVI HEALTH PRIVATE LIMITED',
    'YOG INFRA ADVISORY PRIVATE LIMITED',
    'AK TEXTILE WELFARE FOUNDATION',
    'ASUREMART PRIVATE LIMITED',
    'MATIZ SOLUTIONS PRIVATE LIMITED',
    'ELIXIR INNOVATIONS PRIVATE LIMITED',
    'TEZDEV TECHNOLOGIES INDIA PRIVATE LIMITED',
    'EVI FINISHING INDIA PRIVATE LIMITED',
    'RISEAI VENTURES PRIVATE LIMITED',
    'USHODAYA SUPER MARKETS PRIVATE LIMITED',
    'LUSSO INTERNO (OPC) PRIVATE LIMITED',
    'PIPALTREE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'AKANKSHA LIVING PRIVATE LIMITED',
    'ZOEK APPLICATIONS PRIVATE LIMITED',
    '3R ZEROWASTE PRIVATE LIMITED',
    'TM INVESTMENT TECHNOLOGIES PRIVATE LIMITED',
    'INDINSURTECH ASSOCIATION',
    'BVG INNOVATIONS PRIVATE LIMITED',
    'PERCEPTA CONSULTANCY PRIVATE LIMITED',
    'ECARTER TECHNOLOGIES PRIVATE LIMITED',
    'EO BRIDGE FORUM',
    'RASPA PHARMA PRIVATE LIMITED',
    'FRONT INFRATEL PRIVATE LIMITED',
    'LEARNING FEATHER PRIVATE LIMITED',
    'NIFTEM TECHNOLOGY INNOVATION AND BUSINESS INCUBATION FOUNDATION',
    'CHRYSALLIS KO INDIA PRIVATE LIMITED',
    'BURNCAL HEALTHCARE PRIVATE LIMITED',
    'CADMEA PRIVATE LIMITED',
    'D2D INTERNATIONAL PRIVATE LIMITED',
    'ACIER ALLOYS INDIA PRIVATE LIMITED',
    'JWL SOLUTIONS PRIVATE LIMITED',
    'BASILBLOOMS INTERNATIONAL PRIVATE LIMITED',
    'FINWELLNESS TECHNOLOGY PRIVATE LIMITED',
    'Q-MEDICA PHARAMACEUTICALS (OPC) PRIVATE LIMITED',
    'KOLF HOUSEWARE INDIA PRIVATE LIMITED',
    'UUTU TECHNOLOGY PRIVATE LIMITED',
    'TOOTER PRIVATE LIMITED',
    'ALPHANAV INDIA PRIVATE LIMITED',
    'NJ TRUSTEE PRIVATE LIMITED',
    'FUTURE SECUREWEALTH NIDHI LIMITED',
    'JAILAXMI HOLDINGS PRIVATE LIMITED',
    'ALIEN TECHNOLOGY TRANSFER INDIA PRIVATE LIMITED',
    'TAX VYAPAR SOLUTIONS PRIVATE LIMITED',
    'IPFLAIR CONSULTING PRIVATE LIMITED',
    'METS SEAFOOD HOLDINGS PRIVATE LIMITED',
    'FARM 2 PRESERVE ORGANIC FOOD PRIVATE LIMITED',
    'MPOWERASSIST TECHNOLOGIES PRIVATE LIMITED',
    'CELONA NETWORKS PRIVATE LIMITED',
    'PAYAZZURE TECHNOLOGIES PRIVATE LIMITED',
    'OFOFO PRIVATE LIMITED',
    'VELOX VIRTUAL WORLD PRIVATE LIMITED',
    'HONEYWELL CREATION INDIA PRIVATE LIMITED',
    'JAIN SHIV SAGAR PRIVATE LIMITED',
    'PLANTEX E-COMMERCE PRIVATE LIMITED',
    'BLUESYNC ELECTRONICS PRIVATE LIMITED',
    'GROWER BIOFERTILIZER (OPC) PRIVATE LIMITED',
    'FGS SOLUTIONS PRIVATE LIMITED',
    'SPICE N MICE PRIVATE LIMITED',
    'AXIAL AERO PRIVATE LIMITED',
    'IPNET BROADBAND NETWORK PRIVATE LIMITED',
    'JINGLEBID PRIVATE LIMITED',
    'RENT PE PRIVATE LIMITED',
    'MAKDAT DATA SOLUTIONS PRIVATE LIMITED',
    'SHREE HARI EDUCATION CONSULTANT PRIVATE LIMITED',
    'EPSILON GRAPHITE PRIVATE LIMITED',
    'ENERGETIC PNEUMATIC PRIVATE LIMITED',
    'BORED BEVERAGES PRIVATE LIMITED',
    'FOOD SPACE TECHNOLOGY PRIVATE LIMITED',
    'LABTECH RESEARCH SOLUTIONS PRIVATE LIMITED',
    'CODERTRAILS PRIVATE LIMITED',
    'YATRA ONLINE FREIGHT SERVICES PRIVATE LIMITED',
    'KAROBARSATHI SERVICES PRIVATE LIMITED',
    'IMPRESS STRATEGIC COMMUNICATIONS PRIVATE LIMITED',
    'TECHWOLVES PRIVATE LIMITED',
    'SHELTER LAYOUTS PRIVATE LIMITED',
    'DURACA PLAST CREATION PRIVATE LIMITED',
    'WELL FREIGHT SHIPPING PRIVATE LIMITED',
    'HEALTH FACTORY PRIVATE LIMITED',
    'SARK PIPELINE TECHNOLOGIES PRIVATE LIMITED',
    'ECHOBOOOM MANAGEMENT & ENTREPRENEURIAL SOLUTIONS PRIVATE LIMITED',
    'HERDSMAN ORGANIC PRIVATE LIMITED',
    'VIZTAR INTERNATIONAL GROUP PRIVATE LIMITED',
    'SAHIBTEK PRIVATE LIMITED',
    'POWERONBIO TECHNOLOGY PRIVATE LIMITED',
    'PAYTI INDIA INFOTECH PRIVATE LIMITED',
    'IDEAS TO IMPACTS DIGITAL PRIVATE LIMITED',
    'OMEGA ELEVATORS & ESCALATORS PRIVATE LIMITED',
    'GREEN CATALYSATOR IT INDIA PRIVATE LIMITED',
    'DRSYA TECHNOLOGIES PRIVATE LIMITED',
    'ISECURE IT PRIVATE LIMITED',
    'LUTHER & KARCHER PRIVATE LIMITED',
    'TT FRIENDLY SUPER LEAGUE ASSOCIATION',
    'OXPER MARTECH (OPC) PRIVATE LIMITED',
    'AK HEALTH TECH PRIVATE LIMITED',
    'ACA CARGO TERMINALS PRIVATE LIMITED',
    'WEB WERKS FIBER PRIVATE LIMITED',
    'HOMECHEF INDIA VENTURES PRIVATE LIMITED',
    'MANJUSHREE SPNTEK PRIVATE LIMITED',
    'HFL CONSUMER PRODUCTS PRIVATE LIMITED',
    'KANTI SWEETS PRIVATE LIMITED',
    'FOEINIX BUSINESS TERRITORIES PRIVATE LIMITED',
    'RS AVANT-GARDE PRIVATE LIMITED',
    'BENGALURU AIRPORT SERVICES LIMITED',
    'REVUP VENTURES PRIVATE LIMITED',
    'RIANSH CORPORATE PRIVATE LIMITED',
    'SOCIAL SWAG TECHNOLOGY PRIVATE LIMITED',
    'CONFIAR HOLIDAYS AND EVENTS INDIA PRIVATE LIMITED',
    'INTRAGLOBE DIGITAL PRIVATE LIMITED',
    'YASHAMM INDIA PRIVATE LIMITED',
    'PRANAV TECHONE PRIVATE LIMITED',
    'DARWIN PLATFORM MONETARY FINANCIAL LIMITED',
    'NATIVE PICK PRIVATE LIMITED',
    'ESG DATA SOLUTIONS PRIVATE LIMITED',
    'KAUSALYAM FINANCIAL SERVICES PRIVATE LIMITED',
    'BUSINESS CORRESPONDENT RESOURCE COUNCIL',
    'PYNART BIOTECH PHARMACEUTICALS (OPC) PRIVATE LIMITED',
    'LUDO VENTURES PRIVATE LIMITED',
    'SKYZ GRANITES PRIVATE LIMITED',
    'CMR-KATARIA RECYCLING PRIVATE LIMITED',
    'ASTRAL AERIAL SOLUTIONS PRIVATE LIMITED',
    '1SILVERBULLET PLATFORMS PRIVATE LIMITED',
    'RVV NUTRITIOUS PRIVATE LIMITED',
    'VIKRAMA ADVISORS PRIVATE LIMITED',
    'FLAVOURMATE PRIVATE LIMITED',
    'FINSERVATIVE CONSULTANCY PRIVATE LIMITED',
    'DOMINIX GLOBAL DESIGN PRIVATE LIMITED',
    'C2C IMPORTERS PRIVATE LIMITED',
    'ALLABOUT INNOVATIONS PRIVATE LIMITED',
    'LEELA LOGISTICS PRIVATE LIMITED',
    'STALWART BATTERIES LIMITED',
    'ZEBORO TECHNOLOGIES PRIVATE LIMITED',
    'ARYSS FAB-TECH PRIVATE LIMITED',
    'OZEO IT BUSINESS SERVICES PRIVATE LIMITED',
    'CANDLE ELECTRIC SOLUTIONS PRIVATE LIMITED',
    'FLYBUNCH VENTURES PRIVATE LIMITED',
    'NUA DESIGN PRIVATE LIMITED',
    'ANGELCRAFTS INDIA PRIVATE LIMITED',
    'AISHVIK INFOTECH PRIVATE LIMITED',
    'AADHIYARAN AGRARIAN SERVICES PRIVATE LIMITED',
    'PREMIURLY ONLINE PRIVATE LIMITED',
    'SOULKARI VENTURES PRIVATE LIMITED',
    'FOOD TROVE PRIVATE LIMITED',
    'PHYSICO ORGANIC MATERIAL SOLUTIONS INDIA PRIVATE LIMITED',
    'ETHICAL WAREHOUSING AND PEST MANAGEMENT PRIVATE LIMITED',
    'OCHRON INTERIORS PRIVATE LIMITED',
    'ALPYUS TECHNOLOGIES PRIVATE LIMITED',
    'AYAAN SOLARWORLD PRIVATE LIMITED',
    'VISHAKA RAISINS PRIVATE LIMITED',
    'SCG CAREER PRIVATE LIMITED',
    'TECHALLY VENTURES PRIVATE LIMITED',
    'SIX SAILS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'IIIT-H DATA I-HUB FOUNDATION',
    'I.FARM APPLICATIONS PRIVATE LIMITED',
    'FIRST DOCUMENT PRIVATE LIMITED',
    'OPENSHOPEE TECHNOLOGIES PRIVATE LIMITED',
    'TARA SUPPORT SERVICES PRIVATE LIMITED',
    'EMPETUS ELECTRIC PRIVATE LIMITED',
    'MANTONE PRINTPACK PRIVATE LIMITED',
    'ASEEMIT SOCIAL PROJECTS FOUNDATION',
    'DHIMAT TECH PRIVATE LIMITED',
    'JC ELETRONICA PRIVATE LIMITED',
    'ROUTENOW FINTECH INDIA PRIVATE LIMITED',
    'ZOOK SOAP WORKS PRIVATE LIMITED',
    'SPICEMORE EXIM PRIVATE LIMITED',
    'HSR TECH PARK PRIVATE LIMITED',
    'INVICTA WORKS PRIVATE LIMITED',
    'MAKEMYSTORE PRODUCTS INDIA PRIVATE LIMITED',
    'DANNFIN LIFESCIENCES PRIVATE LIMITED',
    'SQUADRA MEDIA PRIVATE LIMITED',
    'NISKO PINNACLE TELEMATICS PRIVATE LIMITED',
    'PIKVEEL INDIA PRIVATE LIMITED',
    'APT WATSUN INDUSTRIES PRIVATE LIMITED',
    'CAPSQUERY PRIVATE LIMITED',
    'MANDALA BIOWORKS PRIVATE LIMITED',
    'HASHBUGS SOLUTIONS PRIVATE LIMITED',
    'KADANT INDIA PRIVATE LIMITED',
    'PREMIER ENERGIES INTERNATIONAL PRIVATE LIMITED',
    'RST FUEL DELIVERY PRIVATE LIMITED',
    'DUX TECHNOLOGIES PRIVATE LIMITED',
    'VIBA GLOBAL LOGISTICS PRIVATE LIMITED',
    'LIVING STRONG AGRO FOODS PRIVATE LIMITED',
    'INERCO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INSERTEK BAZAR PRODUCTS (OPC) PRIVATE LIMITED',
    'AIHP EXECUTIVE CENTRES PRIVATE LIMITED',
    'KADAMBA LANDSCAPES PRIVATE LIMITED',
    'DSPACE TECHNOLOGIES PRIVATE LIMITED',
    'WHITELION INFOSYSTEMS PRIVATE LIMITED',
    'TECHREADY SOLUTIONS PRIVATE LIMITED',
    'VILINA FOODS PRIVATE LIMITED',
    'MAIRA FITNESS PRIVATE LIMITED',
    'ACELOT INNOVATION PRIVATE LIMITED',
    'CSB AGRIVET PRIVATE LIMITED',
    'DHAKSHAN TEXTILES PRIVATE LIMITED',
    'SMARTER DHARMA SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'LOGIFY CARGO SERVICES PRIVATE LIMITED',
    'WCB ROBOTICS INDIA PRIVATE LIMITED',
    'OCULOTRONICS TECHNOLOGY PRIVATE LIMITED',
    'NAVTARK SOLUTIONS PRIVATE LIMITED',
    'WELFLEX POLYMER INDUSTRIES PRIVATE LIMITED',
    'EXIGENT VRX GAMES PRIVATE LIMITED',
    'RELIANCE ENTERTAINMENT STUDIOS PRIVATE LIMITED',
    'INDIUMPLUS FINANCIAL SERVICES PRIVATE LIMITED',
    'T-SCALE WEIGHING INDIA PRIVATE LIMITED',
    'IM TECHNOLOGIES PRIVATE LIMITED',
    'GLOREC INTERNATIONAL PRIVATE LIMITED',
    'ENRICHDIGITAL TECH SOLUTIONS PRIVATE LIMITED',
    'MANOJ MANCHU CITY PRIVATE LIMITED',
    'SRI LOHITHA FOODS PRIVATE LIMITED',
    'SATYA KNITS PRIVATE LIMITED',
    'BUGMEN AND BADGERER PRIVATE LIMITED',
    'LIFE A SCHOOL OF ATTITUDE AND VALUES PRIVATE LIMITED',
    'SPOTNANA TECHNOLOGY PRIVATE LIMITED',
    'STANDAV LABS PRIVATE LIMITED',
    'MISOCHAIN TECHNOLOGIES PRIVATE LIMITED',
    'AENTEC INDIA PRIVATE LIMITED',
    'MBH TECHNOLOGIES PRIVATE LIMITED',
    'HITACHI ENERGY INDIA LIMITED',
    'CREDITECH SOLUTIONS PRIVATE LIMITED',
    'ROLLING FILTERS (OPC) PRIVATE LIMITED',
    'ART OF EVENTS PRIVATE LIMITED',
    'SAHI MEDIA TECH PRIVATE LIMITED',
    'AKROMEN SOLUTIONS PRIVATE LIMITED',
    'RISE OPERATIONS INDIA PRIVATE LIMITED',
    'SAYA COLOUR FRAGRANCE PRIVATE LIMITED',
    'DR SB AESTHETICS PRIVATE LIMITED',
    'VITRAYA TECHNOLOGIES PRIVATE LIMITED',
    'CRESCENDO GLOBAL LEADERSHIP HIRING INDIAPRIVATE LIMITED',
    'BUZZARK SIMULATIONS PRIVATE LIMITED',
    'WANDERFREE TRADERS PRIVATE LIMITED',
    'CEF BUDHANA ENERGY PRIVATE LIMITED',
    'LIGHTSPEED LOGISTICS PRIVATE LIMITED',
    'SCHLOSS CHANAKYA PRIVATE LIMITED',
    'BAALYAM HEALTHCARE PRIVATE LIMITED',
    'VISTAN NEXTGEN PRIVATE LIMITED',
    '4PEL MEGA LIGHT PRIVATE LIMITED',
    'JOHNS HOPKINS INDIA FOUNDATION',
    'ALTUS PEAK PRIVATE LIMITED',
    'SENOGET TECHNOLOGIES PRIVATE LIMITED',
    'ITXITPRO PRIVATE LIMITED',
    'KSR TEXTILES INDIA PRIVATE LIMITED',
    'AKSHAY SWACHH JAL FOUNDATION',
    'SIMPLE INTEGRAL PRIVATE LIMITED',
    'SUN PHARMA DISTRIBUTORS LIMITED',
    'VJOURNO TECHNOLOGY PRIVATE LIMITED',
    'BRIGHT INDIA STAINLESS STEEL PRIVATE LIMITED',
    'BHAVALBEN DHARAMSHI SAVLA FOUNDATION',
    'SUPER TRACTOR INDUSTRIES PRIVATE LIMITED',
    'XLRI COUNCIL FOR ENTREPRENEURSHIP EXCELLENCE AND DEVELOPMENT',
    'STOUTAIR ENGINEERING PRIVATE LIMITED',
    'TECEZE CONSULTANCY SERVICES PRIVATE LIMITED',
    'NEULEAF AGRO (OPC) PRIVATE LIMITED',
    'SHREEKANTHAY AADI PRIVATE LIMITED',
    'UUDS MAGNUM AERO PRIVATE LIMITED',
    'MASAYA SOLAR ENERGY PRIVATE LIMITED',
    'VISAKHA HOTELS AND CONVENTION CENTRE PRIVATE LIMITED',
    'SEAVANTEK SHIPPING SERVICES PRIVATE LIMITED',
    'HTNS LOGISTICS INDIA PRIVATE LIMITED',
    'FRUIT-TECH SOLUTIONS PRIVATE LIMITED',
    'SSVP & SONS PRIVATE LIMITED',
    'ROOM TO READ GLOBAL SERVICES PRIVATE LIMITED',
    'SUNLINE OFFICE FURNITURE PRIVATE LIMITED',
    'QBOID IOTECH PRIVATE LIMITED',
    'POWERGRID AJMER PHAGI TRANSMISSION LIMITED',
    'MPHASE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SRI GANAIKA MUDRANALAYA PRIVATE LIMITED',
    'YAGAM WELLNESS PRIVATE LIMITED',
    'INFINITY CORPORATE SOLUTIONS PRIVATE LIMITED',
    '1024X INNOVATIONS PRIVATE LIMITED',
    'APEX INFOTECH INDIA PRIVATE LIMITED',
    'GENZY ECOMMERCE PRIVATE LIMITED',
    'FORMONIC TECHNOLOGIES PRIVATE LIMITED',
    'LEARNIRA TECHNOLOGIES PRIVATE LIMITED',
    'RX HEALTH MANAGEMENT INDIA PRIVATE LIMITED',
    'MATCHMOVE PAYTECH INDIA PRIVATE LIMITED',
    'INITO TECHNOLOGIES PRIVATE LIMITED',
    'YOAATMA DESIGNS PRIVATE LIMITED',
    'BLUE SQUARE TECH SOLUTIONS PRIVATE LIMITED',
    'YOUNGSEONG INDIA PRIVATE LIMITED',
    'OLIRIA FOODS AND BEVERAGES LIMITED',
    'YELLOWFELLOW COMFORTS PRIVATE LIMITED',
    'GLOBAL TECH INTEGRATED SYSTEMS PRIVATE LIMITED',
    'EQUINOX',
    'S AIRCON PRIVATE LIMITED',
    'TECHXOTICA ANALYTICS PRIVATE LIMITED',
    'CYBERMERU TECHNOLOGIES PRIVATE LIMITED',
    'DAMAO PHARMACEUTICAL PRIVATE LIMITED',
    'FLOWDUCT ENGINEERING PRIVATE LIMITED',
    'CHEFNOX PRIVATE LIMITED',
    'DKSORTHO & MEDICAL DEVICES PRIVATE LIMITED',
    'BROCHILL INTERNET PRIVATE LIMITED',
    'SPECLOID SOLUTIONS PRIVATE LIMITED',
    'AMMAYAPPER ROADWAYS PRIVATE LIMITED',
    'EVERVA LIFECARE PRIVATE LIMITED',
    'REDINOX ENTERTAINMENT PRIVATE LIMITED',
    'BYRASANDRA THAVAREKERE MADIWALA FOOTBALLCLUB (BTMFC) PRIVATE LIMITED',
    'FSP POWER ELECTRONICS INDIA PRIVATE LIMITED',
    'TIBROX TECH SOLUTIONS (OPC) PRIVATE LIMITED',
    'WONDERBOTZ INDIA PRIVATE LIMITED',
    'TANDT REALTECH PRIVATE LIMITED',
    'INSIDRI DECISIONS PRIVATE LIMITED',
    'RIGHT SIGNALS SERVICES PRIVATE LIMITED',
    'SHERA BUILDING SOLUTIONS INDIA PRIVATE LIMITED',
    'SAVANNA FOODS HOLDINGS PRIVATE LIMITED',
    'AUI SYSTEMS PRIVATE LIMITED',
    'GEBI PRODUCTS PRIVATE LIMITED',
    'CSY RESOURCES PRIVATE LIMITED',
    'CERVIN FAMILY OFFICE & ADVISORS PRIVATE LIMITED',
    'THINKVATE TECHNOLOGIES PRIVATE LIMITED',
    'WAKUK TECHNOLOGIES PRIVATE LIMITED',
    'FOIWE INFO GLOBAL SOLUTIONS PRIVATE LIMITED',
    'UNIX LOGISTICS PRIVATE LIMITED',
    'ESTEEM SOUTH PARKS PRIVATE LIMITED',
    'BAO THACH INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'AYURMANAHA CHIKITSALAYA PRIVATE LIMITED',
    'APESTUFF E-COMMERCE PRIVATE LIMITED',
    'KELMER INDIA PRIVATE LIMITED',
    'ECTD GLOBAL PRIVATE LIMITED',
    'RUTAKSHI TECHNOLOGIES PRIVATE LIMITED',
    'EUROPA EDUCATIONAL SOLUTIONS PRIVATE LIMITED',
    'LAPROTECH SYSTEMS INDIA PRIVATE LIMITED',
    'GREENCHEM NANO PRIVATE LIMITED',
    'UNBOXROBOTICS LABS PRIVATE LIMITED',
    'GREENZEST SOLAR PRIVATE LIMITED',
    'SANDHU MOTO PRIVATE LIMITED',
    'RENOSEN PHARMACEUTICALS PRIVATE LIMITED',
    'BENIR ONE SOURCE SOLUTIONS PRIVATE LIMITED',
    'TSW INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'CIGAM DEVELOPERS PRIVATE LIMITED',
    'REDGROVE PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'NORDICFLEXHOUSE TECHNOLOGY INNOVATION INDIA PRIVATE LIMITED',
    'AXIVON SOLUTIONS PRIVATE LIMITED',
    'CLIQTAX TECHNOLOGIES PRIVATE LIMITED',
    'DAMSUN INDIA PRIVATE LIMITED',
    'WRYTIN TECHNOLOGIES PRIVATE LIMITED',
    '3S TEMPLE PROJECTS PRIVATE LIMITED',
    'LET ALLIANCE TECH HUB PRIVATE LIMITED',
    'ASTON PROCESSORS LIMITED',
    'AREVIN NUTRITIONS INDIA PRIVATE LIMITED',
    'BOTTMAC INDIA PRIVATE LIMITED',
    'ARRISE BPO SOLUTIONS PRIVATE LIMITED',
    'GALIOT SYSTEMS PRIVATE LIMITED',
    'VOCALLEA NETWORKS PRIVATE LIMITED',
    'DINERO INNOVATIONS PRIVATE LIMITED',
    'MERCATUS SOLUTIONS INDIA PRIVATE LIMITED',
    'POSHKNIT TEX PRIVATE LIMITED',
    'REVERSO SOLUTIONS PRIVATE LIMITED',
    'RUSECO CHEMICALS INDIA PRIVATE LIMITED',
    'GREEN TURTLE GAMING TECHNOLOGIES PRIVATELIMITED',
    'ZEBU ANIMATION STUDIOS PRIVATE LIMITED',
    'URBAN ORCHARDS PRIVATE LIMITED',
    'INNIVE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUSTAINABLE LUXURY - GRAVITY GLOBAL PRIVATE LIMITED',
    'VRGEEKS TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'SALNO TECH PRIVATE LIMITED',
    'AI-GENIX INTERNATIONAL PRIVATE LIMITED',
    'ENGROW CARBON ENERGY PRIVATE LIMITED',
    'WESTSCALE IMPEX PRIVATE LIMITED',
    'KOUNTBI SOLUTIONS PRIVATE LIMITED',
    'GALAXY INTERNATIONAL TRAVELS PRIVATE LIMITED',
    'HIGHSKY IT SOLUTIONS PRIVATE LIMITED',
    'HARRI SOFTWARE DEVELOPMENT AND SOLUTIONSINDIA PRIVATE LIMITED',
    'FOCUSPOINT GLOBAL RISK SERVICES INDIA PRIVATE LIMITED',
    'BUOYANTWORX SOLUTIONS PRIVATE LIMITED',
    'NIZONA MARINE PRODUCTS PRIVATE LIMITED',
    'PRAXKO RETAIL PRIVATE LIMITED',
    'TECHNOCRATS SAFETY & SECURITY SYSTEMS PRIVATE LIMITED',
    'PRONIXA SYSTEMS INDIA PRIVATE LIMITED',
    'ANTIGRA SYSTEMS PRIVATE LIMITED',
    'INDOSING EDUCATION SERVICES PRIVATE LIMITED',
    'ALPHA VARIANCE SOLUTIONS INDIA PRIVATE LIMITED',
    'ALLBOUND PRM PRIVATE LIMITED',
    'ROBOMED INNOVATIONS PRIVATE LIMITED',
    'PAKKAPROFILE PSYCHOMETRICS PRIVATE LIMITED',
    'ESPACIO AERONEXT PRIVATE LIMITED',
    'SELSIL SEALANTS INDIA PRIVATE LIMITED',
    'CURATED LIVING SOLUTIONS PRIVATE LIMITED',
    'NETRONICS SOLUTIONS PRIVATE LIMITED',
    'PACORR TESTING INSTRUMENTS PRIVATE LIMITED',
    'CTR HOUSEHOLD TECHNOLOGIES INDIA PRIVATELIMITED',
    'KRISHPRE CLOTHLINE PRIVATE LIMITED',
    'SUZHOU NANOMICRO TECH INDIA PRIVATE LIMITED',
    'AHWSPL INDIA PRIVATE LIMITED',
    'ASEEM INFRASTRUCTURE FINANCE LIMITED',
    'SMART FACTORY SOLUTIONS (INDIA) PRIVATE LIMITED',
    'UPKAR RESIDENCES PRIVATE LIMITED',
    'GTGF INDIA PRIVATE LIMITED',
    'VR KONKAN PRIVATE LIMITED',
    'M2NXT SOLUTIONS PRIVATE LIMITED',
    'CVK CONSTRUCTIONS PRIVATE LIMITED',
    'FAMY FINVEST PRIVATE LIMITED',
    'OBEMAR AIRPORT SYSTEM INDIA PRIVATE LIMITED',
    'SUSHI ANIMAL NUTRITION PRIVATE LIMITED',
    '1D1S ENTERCON PRIVATE LIMITED',
    'NUCOMET VENTURES PRIVATE LIMITED',
    'GUYTONS HEALTHCARE PRIVATE LIMITED',
    'SWAN WEAVES PRIVATE LIMITED',
    'ARORIAN SOLUTION CENTER INDIA (OPC) PRIVATE LIMITED',
    'LIVEKETO PRIVATE LIMITED',
    'EVENTBEEP TECHNOSERVICES PRIVATE LIMITED',
    'SLINTEL INDIA PRIVATE LIMITED',
    'KAYPEE POLYFAB PRIVATE LIMITED',
    'VENDOSMART TECHNOLOGIES PRIVATE LIMITED',
    'ALPHA1 IT SOLUTIONS AND CONSULTING PRIVATE LIMITED',
    'ZEEMRAH ENTERPRISES PRIVATE LIMITED',
    'MORESTEP PATHLABS PRIVATE LIMITED',
    'STATLABS ANALYTICS VENTURES PRIVATE LIMITED',
    'ADBOND INDUSTRIES PRIVATE LIMITED',
    'ARGENTI INNOTECH PRIVATE LIMITED',
    'VOZANA HOMES (OPC) PRIVATE LIMITED',
    'FUNDSAXIS INDIA PRIVATE LIMITED',
    'EUCIT SYSTEMS PRIVATE LIMITED',
    'SUN FOOD TECH PRIVATE LIMITED',
    'FULLSTACK EDUCATION PRIVATE LIMITED',
    'FABRICO CLEANING SOLUTIONS PRIVATE LIMITED',
    'VANASTHA AGRO FOODS PRIVATE LIMITED',
    'VR SOUTH ASIA PRIVATE LIMITED',
    'ANANDJANGID AND ASSOCIATES ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'VRLOCAL INDUSTRIES PRIVATE LIMITED',
    'CRAYOND DIGITAL PRIVATE LIMITED',
    'LOGITRUST VOYAGES PRIVATE LIMITED',
    'PEPTRIS TECHNOLOGIES PRIVATE LIMITED',
    'AUQUAN INDIA PRIVATE LIMITED',
    'MARWARI CATALYSTS PRIVATE LIMITED',
    'SEAL FOR LIFE INDIA PRIVATE LIMITED',
    'LUBESERV INDIA PRIVATE LIMITED',
    'ODRWAYS SOLUTIONS PRIVATE LIMITED',
    'OCTAMICRO TECHNOLOGIES PRIVATE LIMITED',
    'ASSETMONK PROPERTIES PRIVATE LIMITED',
    'ULTRAVIBRANT SOLAR ENERGY PRIVATE LIMITED',
    'FINEFACILIS MANAGEMENT PRIVATE LIMITED',
    'MIRAE ASSET VENTURE INVESTMENTS (INDIA) PRIVATE LIMITED',
    'DESIGNQANDY PRIVATE LIMITED',
    'CHETANA IRRIGATION PRIVATE LIMITED',
    'AEROARC PRIVATE LIMITED',
    'MIRA WOVENS (OPC) PRIVATE LIMITED',
    'PHILADELPHIA MIXING SOLUTIONS ASIA PRIVATE LIMITED',
    'YIZUMI ADVANCED PROCESSING TECHNOLOGY PRIVATE LIMITED',
    'WAHLSTEEL TRADING PRIVATE LIMITED',
    'MUNRO SILVER CREST PRIVATE LIMITED',
    'DUO RESTAURANTS PRIVATE LIMITED',
    'BARSAN GLOBAL LOGISTICS PRIVATE LIMITED',
    'MUDRANTAR SOLUTIONS PRIVATE LIMITED',
    'AD.NET DEVELOPMENT INDIA PRIVATE LIMITED',
    'LUMAX JOPP ALLIED TECHNOLOGIES PRIVATE LIMITED',
    'NIJA TECHNOLOGIES PRIVATE LIMITED',
    'LORHAN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MEGNITY TECHNOLOGIES PRIVATE LIMITED',
    'OLYMPIA ELEVATORS PRIVATE LIMITED',
    'SPORTJUNKI FANTASY PRIVATE LIMITED',
    'DEEPJI PUMPS PRIVATE LIMITED',
    'ADHOLIC ADWORLD PRIVATE LIMITED',
    'GYMS FOR ALL (INDIA) LIMITED',
    'TRUEBROWNS LIFESTYLE PRIVATE LIMITED',
    'SACCUS PRODUCTS PRIVATE LIMITED',
    'ZAPDESK ITES SOLUTIONS PRIVATE LIMITED',
    'SALTU CREATIVE SUITE PRIVATE LIMITED',
    'AKERIA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SYNCWORKS SOLUTIONS PRIVATE LIMITED',
    'ZEAL MEDI SOLUTIONS PRIVATE LIMITED',
    'GMDH CURING WORKS PRIVATE LIMITED',
    'ECANVAS PRIVATE LIMITED',
    'GREEN CANOPY INITIATIVES PRIVATE LIMITED',
    'CORPORATEACCESS TECHNOLOGY PRIVATE LIMITED',
    'CLOUDZEE ANIMATION AND RESEARCH PRIVATE LIMITED',
    'IOTREADY TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'NETS N SPIKES INDIA PRIVATE LIMITED',
    'NINEELEMENTS BUILDTECH PRIVATE LIMITED',
    'JISHNU INFOTECH PRIVATE LIMITED',
    'ITW DIGITAL OUT OF HOME INDIA PRIVATE LIMITED',
    'VATAYU PRIVATE LIMITED',
    'EVERFORCE SOFTWARE INDIA PRIVATE LIMITED',
    'DORIGIN TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'DB-AIRE INDIA PRIVATE LIMITED',
    'BREITHORN CONSULTING & TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MASHAA RADPRO PRIVATE LIMITED',
    'APEX MOBILE APP PRIVATE LIMITED',
    'MOTIVATION DIRECT (INDIA) PRIVATE LIMITED',
    'SBM OFFSHORE INDIA PRIVATE LIMITED',
    'COREDS DESIGN STUDIO INDIA PRIVATE LIMITED',
    'ACCOUNTSWHIZ INDIA PRIVATE LIMITED',
    'RMZ UNIFIED SERVICES PRIVATE LIMITED',
    'FUL HAUS SOLUTIONS (OPC) PRIVATE LIMITED',
    'MYLANG BOOKS DIGITAL PRIVATE LIMITED',
    'VAJRASENA FOODS PRIVATE LIMITED',
    'VIDMAN BIZ CONSULTING PRIVATE LIMITED',
    'AKTIVOLT CELTEK PRIVATE LIMITED',
    'CRATOFLOW INDIA PRIVATE LIMITED',
    'EMBASSY REAL ESTATE DEVELOPMENTS AND SERVICES PRIVATE LIMITED',
    'UPRAISED TECHNOLOGY PRIVATE LIMITED',
    'NEXMET INDIA PRIVATE LIMITED',
    'LONGVIEW AVIATION INDIA PRIVATE LIMITED',
    'VIMAAN ROBOTICS INDIA PRIVATE LIMITED',
    'MASH EDUTECH PRIVATE LIMITED',
    'CARTRADE FINANCE PRIVATE LIMITED',
    'DEALMONEY FINANCIAL SERVICES PRIVATE LIMITED',
    'V-CONNECT ENTERPRISES PRIVATE LIMITED',
    'STIGMERGY SOLUTIONS PRIVATE LIMITED',
    'YOUDEE MERCHANDISING SOLUTIONS PRIVATE LIMITED',
    'AASHAPURA RENEWABLES PRIVATE LIMITED',
    'WED UPP PRIVATE LIMITED',
    'KEM LIGHT SPECHEM LABS PRIVATE LIMITED',
    'HIRINGLY TECHNOLOGIES PRIVATE LIMITED',
    'SHLOKAZ RETAIL PRIVATE LIMITED',
    'ONELAP TELEMATICS PRIVATE LIMITED',
    'JAJAL MEDICAL SERVICES PRIVATE LIMITED',
    'ALX SOLUTIONS INDIA PRIVATE LIMITED',
    'TRIO MOTION TECHNOLOGY INDIA PRIVATE LIMITED',
    'ALTONEXUS TECHNOLOGIES PRIVATE LIMITED',
    'GIFT CHANGE SOCIAL VENTURES PRIVATE LIMITED',
    'FRESHCONNECT TECHNOLOGIES PRIVATE LIMITED',
    'ESCALE INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'JRSPF TECHNOLOGIES PRIVATE LIMITED',
    'TRINITY DESIGN AND COMMUNICATIONS PRIVATE LIMITED',
    'CHARMACY INDIA PRIVATE LIMITED',
    'NVT-ISME SPACE INNOVATION FOUNDATION',
    'FARMGENUS PRIVATE LIMITED',
    'ICHIBANYA INDIA PRIVATE LIMITED',
    'LH TRANSPORTATION HUB (INDIA) PRIVATE LIMITED',
    'SWIFTLEARNINGS GLOBAL MANAGEMENT SERVICES PRIVATE LIMITED',
    'MASUMA FACILITY SERVICES PRIVATE LIMITED',
    'SAIVA SYSTEM INDIA PRIVATE LIMITED',
    'FRIDAY FILM HOUSE PRIVATE LIMITED',
    'SK AGARWAL STEEL PRIVATE LIMITED',
    'GLASSCO LABORATORY INSTRUMENTS PRIVATE LIMITED',
    'STERLING PRECISION PRIVATE LIMITED',
    'OBERON AUTOMATION PRIVATE LIMITED',
    'MADURAI ALAGAR ENTERPRISES PRIVATE LIMITED',
    'BECKER ROBOTIC EQUIPMENT INDIA PRIVATE LIMITED',
    'SATURNPYRO SOLUTIONS PRIVATE LIMITED',
    'LIFESTARTER PROJECT PRIVATE LIMITED',
    'EZDISE TECHNOLOGY PRIVATE LIMITED',
    'TEJ SUPPLY CHAIN PRIVATE LIMITED',
    'OKANE CHITS PRIVATE LIMITED',
    'ZEROZILLA INFOTECH PRIVATE LIMITED',
    'TECHBOURN INNOVATIONS PRIVATE LIMITED',
    'QODE QUAY TECHNOLOGIES PRIVATE LIMITED',
    'IBEXLABS CLOUD CONSULTING PRIVATE LIMITED',
    'NORLOX SOLUTIONS PRIVATE LIMITED',
    'IPLTECH ELECTRIC PRIVATE LIMITED',
    'STPC INDIA PRIVATE LIMITED',
    'COULOMB EV SOLUTIONS PRIVATE LIMITED',
    'GROWTH ACCELERATOR TECHNOLOGIES PRIVATE LIMITED',
    'WAPPNET SYSTEMS PRIVATE LIMITED',
    'ELIXIR DIAGNOSTICS PRIVATE LIMITED',
    'ELITE MEDICAL MANAGEMENT PRIVATE LIMITED',
    'BHARTI KHER STUDIO PRIVATE LIMITED',
    'FLIPZEE FOODS INDIA PRIVATE LIMITED',
    'EYSYS PHARMACEUTICAL PRIVATE LIMITED',
    'THREADQ SOLUTIONS (OPC) PRIVATE LIMITED',
    'HEXAN TECHNOLOGIES PRIVATE LIMITED',
    'CURIEAI TECH SOLUTIONS PRIVATE LIMITED',
    'FOODIAGO INDIA PRIVATE LIMITED',
    'GASTRONOMYLEGACY FRESH FOOD PRIVATE LIMITED',
    'FLIXSTOCK INDIA PRIVATE LIMITED',
    'RAINDROPS BOOKS PRIVATE LIMITED',
    'IVYPODS TECHNOLOGY PRIVATE LIMITED',
    'JADEMOLDS AND TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'NMDC DATA CENTRE PRIVATE LIMITED',
    'TROM INDUSTRIES LIMITED',
    'ELLA FOODS PRIVATE LIMITED',
    'KNR INFRA DEVELOPERS PRIVATE LIMITED',
    'LIGHTNINGCHART SOLUTIONS PRIVATE LIMITED',
    'SCITARA TECHNOLOGIES PRIVATE LIMITED',
    'UNILODE AVIATION SOLUTIONS INDIA PRIVATELIMITED',
    'KORN CONSULT GROUP INDIA PRIVATE LIMITED',
    'HRCS SERVICES PRIVATE LIMITED',
    'STERLITE EDINDIA FOUNDATION',
    'ONEGEN SOCIAL INNOVATION LABS PRIVATE LIMITED',
    'FENG HUA NEW ENERGY PRIVATE LIMITED',
    'POWERTECH ENERGY SOLUTIONS INDIA PRIVATE LIMITED',
    'MINSOLAR PRIVATE LIMITED',
    'MODIFI SERVICES PRIVATE LIMITED',
    'DAIKI EARTH WATER PRIVATE LIMITED',
    'XOPPLE INFOTECH PRIVATE LIMITED',
    'AVES SHOPPING NETWORK PRIVATE LIMITED',
    'EIGA HEALTH INNOVATIONS PRIVATE LIMITED',
    'TRANGILE SERVICES PRIVATE LIMITED',
    'DKP EXPLORE WEB PRIVATE LIMITED',
    'BUILDERFLY (INDIA) PRIVATE LIMITED',
    'BIGMINT TECHNOLOGIES PRIVATE LIMITED',
    'BAG2BAG TRAVELS AND HOSPITALITY SERVICESINDIA PRIVATE LIMITED',
    'SEPPIC SPECIALITY INGREDIENTS PRIVATE LIMITED',
    'VISTATEQ VIRTUOSITY INDIA PRIVATE LIMITED',
    'RAYANTLER SERVICES PRIVATE LIMITED',
    'PETZAPP PRIVATE LIMITED',
    'NAMMUR PRIVATE LIMITED',
    'INSPIRIA TALENT SOLUTIONS PRIVATE LIMITED',
    'KHANIJ BIDESH INDIA LIMITED',
    'GATEWAY HEALTHTECH FIDELITY PRIVATE LIMITED',
    'SUMMIT MEDICAL MANAGEMENT PRIVATE LIMITED',
    'PKI INFOSEC PRIVATE LIMITED',
    'EVERGREEN LOGISTICS (INDIA) PRIVATE LIMITED',
    'SRMG STONE PRIVATE LIMITED',
    'ZHEN JOY TECHNOLOGY PRIVATE LIMITED',
    'RIGBOT SOLUTIONS PRIVATE LIMITED',
    'DEPASOLUTIONS PRIVATE LIMITED',
    'MWIZ TECHNOLOGIES PRIVATE LIMITED',
    'SREE GOKULAM MOBILES PRIVATE LIMITED',
    'KHETRA AGRITECH PRIVATE LIMITED',
    'ENVEDA THERAPEUTICS INDIA PRIVATE LIMITED',
    'SPLOOT PRIVATE LIMITED',
    'HRDOTCOM SOLUTIONS INDIA PRIVATE LIMITED',
    'COMBINED AUTOMOTIVES PRIVATE LIMITED',
    'ROCK DOVE AVIATION PRIVATE LIMITED',
    'STEELHAWK ELEVATORS PRIVATE LIMITED',
    'TELETWEET MARKETIX PRIVATE LIMITED',
    'LITM FINANCIAL PRIVATE LIMITED',
    'HYUNDAI HEAVY INDUSTRIES TECHNOLOGY CENTER INDIA PRIVATE LIMITED',
    'RAINBOW ADVANCED HEALTH SCIENCES PRIVATELIMITED',
    'CANYON PROPERTIES PRIVATE LIMITED',
    'LOGWARD SYSTEMS PRIVATE LIMITED',
    'ROBOYO AUTOMATION INDIA PRIVATE LIMITED',
    'SITEMINDER (INDIA) PRIVATE LIMITED',
    'ANALOGYX BI PRIVATE LIMITED',
    'PULISI TECHNOLOGY PRIVATE LIMITED',
    'ASKI TECHNOLOGIES PRIVATE LIMITED',
    'CEREBLE PRIVATE LIMITED',
    'RAVINDRA AIRPRODUCTS PRIVATE LIMITED',
    'DEEPEDGE AI INDIA PRIVATE LIMITED',
    'AGENCE GCG PRIVATE LIMITED',
    'IMZ CORPORATE PRIVATE LIMITED',
    'PROTARK PRIVATE LIMITED',
    'CREDIFY ADVISORY SERVICES PRIVATE LIMITED',
    'SERAPIS KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'TWEEK LABS PRIVATE LIMITED',
    'PENTA EXTRUSIONS INDIA PRIVATE LIMITED',
    'PUNJAB RICELAND AGRO FOODS PRIVATE LIMITED',
    'DRILLMEC INTERNATIONAL PRIVATE LIMITED',
    'ONELIFE NUTRISCIENCE PRIVATE LIMITED',
    'DRAGONFRUIT AI INDIA PRIVATE LIMITED',
    'OXYGARDEN PRIVATE LIMITED',
    'TORNA DEVELOPERS PRIVATE LIMITED',
    'GV ENERGY SOLUTION PRIVATE LIMITED',
    'IRCOIT TECHNOLOGIES PRIVATE LIMITED',
    'LIMEN LEAP LABS PRIVATE LIMITED',
    'ATTAQUANT ENTERPRISES PRIVATE LIMITED',
    'QAPITA FINTECH INDIA PRIVATE LIMITED',
    'S.P. INTERNATIONAL LEATHER PRIVATE LIMITED',
    'VNS METALS PRIVATE LIMITED',
    '3A ITECHQORE (OPC) PRIVATE LIMITED',
    'FERGAS INDIA PRIVATE LIMITED',
    'SHRI RATAN PRIYA EXIM PRIVATE LIMITED',
    'CLOUDEPEND SYSTEMS PRIVATE LIMITED',
    'PACHAIYAPPAS SILKS PRIVATE LIMITED',
    'ECOMMDESK SERVICES PRIVATE LIMITED',
    'KODO TECHNOLOGIES PRIVATE LIMITED',
    'DIGITAL SCHOLAR PRIVATE LIMITED',
    'IFEDORA SERVICES PRIVATE LIMITED',
    'VLS SOURCING PRIVATE LIMITED',
    'BR INNOVATIONS PRIVATE LIMITED',
    'AURIGENE PHARMACEUTICAL SERVICES LIMITED',
    'TEKVOCATION PRIVATE LIMITED',
    'SMARTTECH INFRA SERVICES PRIVATE LIMITED',
    'CONSULT HPA PRIVATE LIMITED',
    'RP CUBE PRIVATE LIMITED',
    'TURTEE FASHION PRIVATE LIMITED',
    'MACMERISE CELFIE DESIGN PRIVATE LIMITED',
    'GRANDWAY TESTING INSTRUMENTS INDIA PRIVATE LIMITED',
    'AI WORKS PRIVATE LIMITED',
    'WORLDTRON LOGISTICS INTERNATIONAL PRIVATE LIMITED',
    'WONDERQUILL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GLOCASYS INFO PRIVATE LIMITED',
    'ASPER.AI TECHNOLOGIES PRIVATE LIMITED',
    'AIEMSOL PRIVATE LIMITED',
    'BLUE ORCA LABS PRIVATE LIMITED',
    'MICROTREE TECH SOLUTIONS PRIVATE LIMITED',
    'NETXD SOFTWARE INDIA PRIVATE LIMITED',
    'VARTHACAP SOFTWARE SERVICES PRIVATE LIMITED',
    'DER ADLER ENTERPRISE PRIVATE LIMITED',
    'AGSARYA GLOBAL SOLUTION PRIVATE LIMITED',
    'SOLULEVER INDIA PRIVATE LIMITED',
    'PROTOEZY DESIGNS PRIVATE LIMITED',
    'MOBILESTYX CONSULTING PRIVATE LIMITED',
    'EARLY AUTISM SERVICES PRIVATE LIMITED',
    'FORCE10 INTEGRATED SERVICES PRIVATE LIMITED',
    'TRUVISORY GLOBAL SERVICES PRIVATE LIMITED',
    'SMARTZ WEAR TECHNOLOGY PRIVATE LIMITED',
    'AYSIT SOLUTIONS PRIVATE LIMITED',
    'DIGISAHAMATI FOUNDATION',
    'OVONTS TECHNOLOGIES PRIVATE LIMITED',
    'HEALTHFAB PRIVATE LIMITED',
    'TCO RELIANCE INDIA PRIVATE LIMITED',
    'SHRIM ORGANICS & HERBALS PRIVATE LIMITED',
    'ATTICA REAL VALUE GOLD PRIVATE LIMITED',
    'WHITECLOUD HOSPITALITY PRIVATE LIMITED',
    'TECH ORTAK PRIVATE LIMITED',
    'REFLOGY INFO SERVICES PRIVATE LIMITED',
    'ELE5 SOLUTIONS PRIVATE LIMITED',
    'MAGIC DATA TECHNOLOGY PRIVATE LIMITED',
    'BRANDBURP DIGITAL PRIVATE LIMITED',
    'PURAMATE INDIA PRIVATE LIMITED',
    'SHRI GANESH ADHESIVE PRIVATE LIMITED',
    'KREBS & RIEDEL ABRASIVES INDIA PRIVATE LIMITED',
    'VOYLITE DESIGNS PRIVATE LIMITED',
    'KINETIC GREEN TONINO LAMBORGHINI PRIVATELIMITED',
    'KUDOSWALL PRIVATE LIMITED',
    'MAST-JAEGERMEISTER SERVICES (INDIA) PRIVATE LIMITED',
    'AUREOLE PROCESS EQUIPMENTS PRIVATE LIMITED',
    'AMP ENERGY GREEN PRIVATE LIMITED',
    'PURUSILI HOUSING PRIVATE LIMITED',
    'ZEVAK ANIMAL HEALTH CARE PRIVATE LIMITED',
    'SARLAL WAREHOUSES PRIVATE LIMITED',
    'TRULYTRIPS AND EVENTS PRIVATE LIMITED',
    'TRAVEL BLISS INDIA PRIVATE LIMITED',
    'BUNK INFOTECH PRIVATE LIMITED',
    'RUPAM FOOD MAKERS PRIVATE LIMITED',
    'FABEX STEEL STRUCTURES PRIVATE LIMITED',
    'TAANTRIKA STUDIOS PRIVATE LIMITED',
    'PREX INDIA AUTOMATION PRIVATE LIMITED',
    'SHIPCON LOGISTICS AND SUPPLY CHAIN PRIVATE LIMITED',
    'PICK DEL EXPRESS CARGO PRIVATE LIMITED',
    'RELITRADE INSURANCE BROKING PRIVATE LIMITED',
    'CAPSA INVESTMENTS PRIVATE LIMITED',
    'CYBERNX TECHNOLOGIES PRIVATE LIMITED',
    'WAREIQ LOGISTICS PRIVATE LIMITED',
    'INFUSAI SOLUTIONS PRIVATE LIMITED',
    'AUTHLAYER LABS PRIVATE LIMITED',
    'INDARTU TECHNOLOGIES PRIVATE LIMITED',
    'AIRMEET NETWORKS PRIVATE LIMITED',
    'GOLDEN DIGITECH PRIVATE LIMITED',
    'BALBIX INDIA PRIVATE LIMITED',
    'NAMRATA HEMPCO LIMITED',
    'GREENLANE MEDIA PRIVATE LIMITED',
    'PROXCEL ADVISORY SERVICES PRIVATE LIMITED',
    'BLUE COLLAR MANPOWER MANAGEMENT PRIVATE LIMITED',
    'AVISYS SERVICES PRIVATE LIMITED',
    'IV IT SOLUTIONS PRIVATE LIMITED',
    'KRAYON INFOTECH PRIVATE LIMITED',
    'NAVITAS ALPHA RENEWABLES PRIVATE LIMITED',
    'SKY2HOME ENTERPRISES PRIVATE LIMITED',
    'SHRAMISTA TECH PRIVATE LIMITED',
    'INKVERT TECHNOLOGIES PRIVATE LIMITED',
    'ROLL AND CAST TECHNOLOGIES PRIVATE LIMITED',
    'JANVI LGD PRIVATE LIMITED',
    'TRUEDIGITAL CONSULTING INDIA PRIVATE LIMITED',
    'HASHKON EXPORTS PRIVATE LIMITED',
    'PAPER PLATE PICTURES PRIVATE LIMITED',
    'ARTISAN MEDIA SOLUTIONS PRIVATE LIMITED',
    'NIMSHA INDUSTRIES PRIVATE LIMITED',
    'ROSES & ANGELS PRIVATE LIMITED',
    'GRAPHIC ADS PRIVATE LIMITED',
    'TRUFEDU BUDGETARY EDUCATION PRIVATE LIMITED',
    'TALBOTFORCE SERVICES PRIVATE LIMITED',
    'CLOUDBRINK INDIA PRIVATE LIMITED',
    'RENON INDIA PRIVATE LIMITED',
    'COSPOWER INDIA NEW ENERGY PRIVATE LIMITED',
    'CY4 DIGITAL TWIN PRODUCTS & SOLUTIONS PRIVATE LIMITED',
    'DATACORE SOFTWARE INDIA PRIVATE LIMITED',
    'YARA DIGITAL FARMING INDIA PRIVATE LIMITED',
    'TRIDENT MEDIQUIP LIMITED',
    'RAPTEE ENERGY PRIVATE LIMITED',
    'INVOLOGIX SOFTWARE PRIVATE LIMITED',
    'EMOTE ELECTRIC PRIVATE LIMITED',
    'MADHAV KRG ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'TVASTA PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'ODDITY HEALTHCARE PRIVATE LIMITED',
    'MAJULAH INFOTECH PRIVATE LIMITED',
    'MYSTIQUE INFOTECH PRIVATE LIMITED',
    'AMPLE RETAIL PRIVATE LIMITED',
    'ABDS MART PRIVATE LIMITED',
    'IPV ADVISORS PRIVATE LIMITED',
    'POSHNOSH LOUNGE & BAR PRIVATE LIMITED',
    'ASAHI TENNANTS COLOR PRIVATE LIMITED',
    'CCS SPACEMAKER SI PRIVATE LIMITED',
    'AEQUS CONSUMER PRODUCTS PRIVATE LIMITED',
    'AANJANEY RAIL PRIVATE LIMITED',
    'GERMAN OSTEO PROTECTION CENTERS PRIVATE LIMITED',
    'NBAW ASSOCIATION',
    'DECBECTOCHEM ENGINEERING PRIVATE LIMITED',
    'ONE WORLD CENTER PRIVATE LIMITED',
    'CUMBERLAND ELECTROCHEMICAL PRIVATE LIMITED',
    'CARERAY DIGITAL MEDICAL INDIA PRIVATE LIMITED',
    'STYLEIIN INDIA PRIVATE LIMITED',
    'COORGLE COMMERCE PRIVATE LIMITED',
    'VIVRUT DEVELOPERS PRIVATE LIMITED',
    'INFINITIED LABS PRIVATE LIMITED',
    'ZUJO TECH PRIVATE LIMITED',
    'PLUS HEALTH TECH VENTURES PRIVATE LIMITED',
    'ITECHNOTION PRIVATE LIMITED',
    'TAU LOTUS MOTORS INDIA PRIVATE LIMITED',
    'PARDY PANDA STUDIOS PRIVATE LIMITED',
    'ISA ERP PRIVATE LIMITED',
    'AVALOQ INDIA PRIVATE LIMITED',
    'ZAVETECH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VINTECH COMPUTERS PRIVATE LIMITED',
    'YAYATI SOLUTIONS PRIVATE LIMITED',
    'TKCHAIN PRIVATE LIMITED',
    'AXIOMGLOBAL OIL AND GAS TRADING PRIVATE LIMITED',
    'SHREE NAKODA PIPE IMPEX PRIVATE LIMITED',
    'GEMCORP RECYCLING & TECHNOLOGIES PRIVATELIMITED',
    'BOZHON PRECISION INDUSTRY INDIA PRIVATE LIMITED',
    'SHOMI LIBATT PRIVATE LIMITED',
    'GENOCARE PHARMA PRIVATE LIMITED',
    'ARTEVET THERAPEUTICS PRIVATE LIMITED',
    'WHOPPL GLOBAL PRIVATE LIMITED',
    'UI INTERNATIONAL PRIVATE LIMITED',
    'YACLASS TECH PRIVATE LIMITED',
    'VRK WAREHOUSING PRIVATE LIMITED',
    'PAWRULZ E-SOLUTIONS PRIVATE LIMITED',
    'SRI NISTY PRIVATE LIMITED',
    'ONEBANC TECHNOLOGIES PRIVATE LIMITED',
    'SHAKTIMAN GRIMME ROOT CROP SOLUTIONS PRIVATE LIMITED',
    'GILLSEITH TESTING AND CONTROL INDIA PRIVATE LIMITED',
    'UNI CORPORATE SOLUTIONS PRIVATE LIMITED',
    'DELTABULK SHIPPING INDIA PRIVATE LIMITED',
    'ADVENTUM STUDENT LIVING PRIVATE LIMITED',
    'HARIS MARINE PRODUCTS PRIVATE LIMITED',
    'LINEN AND LINENS PRIVATE LIMITED',
    'L.S. SPINNING MILLS PRIVATE LIMITED',
    'TWILIO TECHNOLOGY INDIA PRIVATE LIMITED',
    'KHOSLA ASSENT PRIVATE LIMITED',
    'ENVIPRO GAS CLEANING TECHNOLOGIES PRIVATE LIMITED',
    'INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED',
    'TAMCHERRY TECHNOLOGIES PRIVATE LIMITED',
    'AZISTA BST AEROSPACE PRIVATE LIMITED',
    'EMPE DIAGNOSTICS PRIVATE LIMITED',
    'GODAWARI ELECTRIC MOTORS PRIVATE LIMITED',
    'RAMA PURE WATER PRIVATE LIMITED',
    'CLEAN SOLAR POWER (BHAINSADA ) PRIVATE LIMITED',
    'DHIRA TECHNOLOGIES PRIVATE LIMITED',
    'DIGSYN INDIA PRIVATE LIMITED',
    'WILDERWORLD PRIVATE LIMITED',
    'TECHSOIL SERVICES PRIVATE LIMITED',
    'AUDAARYA MOBILITY SERVICES PRIVATE LIMITED',
    'RYSA INFRATECH PRIVATE LIMITED',
    'KRISTAL.AI CAPITAL PRIVATE LIMITED',
    'ALPHADOJO PRIVATE LIMITED',
    'SENTIENT SOLUTIONS FOR ACCOUNTING PRIVATE LIMITED',
    'FIELDXCEL TECHNOLOGIES PRIVATE LIMITED',
    'ATHENASOWL TECHNOLOGIES PRIVATE LIMITED',
    'HITAYU AGRO FOODS PRIVATE LIMITED',
    'ACCURATE BACKGROUND INDIA PRIVATE LIMITED',
    'KAVS TECHNOCRAFT PRIVATE LIMITED',
    '4R PACIFIC HOLIDAYS PRIVATE LIMITED',
    'WINWAYS VENTURES PRIVATE LIMITED',
    'CHAMPION STERLING MANUFACTURING PRIVATE LIMITED',
    'ADHIKOSH FINANCIAL ADVISORY PRIVATE LIMITED',
    'KAASHTKAARI PRODUCTS PRIVATE LIMITED',
    'AARTI PHARMALABS LIMITED',
    'SHREEJI HOLIDAY HOTELS PRIVATE LIMITED',
    'HAGIWARA ELECTRONICS INDIA PRIVATE LIMITED',
    'CORROHEALTH INFOTECH PRIVATE LIMITED',
    'UPSWING COGNITIVE HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'SEBIA DIAGNOSTICS INDIA PRIVATE LIMITED',
    'ARY TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'ATMOSPHERE WORKSPACE SOLUTIONS PRIVATE LIMITED',
    'COGNITIVE INTERCEPT INDIA PRIVATE LIMITED',
    'DESAOT ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'MEDTERM HEALTHCARE PRIVATE LIMITED',
    'BGSE FINANCE LIMITED',
    'DOFORT TECH-SOLUTION PRIVATE LIMITED',
    'BI-MART INDIA SERVICES PRIVATE LIMITED',
    'CIGFIL RETAIL PRIVATE LIMITED',
    'AKRITI PRECISION SYSTEMS PRIVATE LIMITED',
    'WASAN E-MOBILITY SOLUTIONS PRIVATE LIMITED',
    'RAYAFEEL TECHNOLOGIES PRIVATE LIMITED',
    'ZOTEZO COM ENTERPRISE PRIVATE LIMITED',
    'AVISDA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SHREE ASHTAVINAYAK THEATRE VENTURES PRIVATE LIMITED',
    'AVAADA MHBULDHANA PRIVATE LIMITED',
    'IMAGEGRAFIX ENTERPRISES SOLUTIONS PRIVATE LIMITED',
    'BONT TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'HYFUN FOODS PRIVATE LIMITED',
    'RIDDHESIDDHE RICE INDUSTRIES PRIVATE LIMITED',
    'SANDHAR HAN SHIN AUTO TECHNOLOGIES PRIVATE LIMITED',
    'FBBK INFOTECH PRIVATE LIMITED',
    'CAPELEC INDIA PRIVATE LIMITED',
    'BVK EXPORTS INDIA PRIVATE LIMITED',
    'KRIARZ VOIXSAI SOLUTIONS PRIVATE LIMITED',
    'KRISHNA EXCLUSIVE PRIVATE LIMITED',
    'BELLFLOWER AUTO INDIA PRIVATE LIMITED',
    'GROWTHGEN PRIVATE LIMITED',
    'WAY2NEWS PRIVATE LIMITED',
    'NDS ECO DRIVES PRIVATE LIMITED',
    'SPHEREBOX INFRA PRIVATE LIMITED',
    'INSTANT SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'PERFECT DAY INDIA PRIVATE LIMITED',
    'INFOWEB IT SOLUTIONS INDIA PRIVATE LIMITED',
    'RAMANI AUTO PRIVATE LIMITED',
    'OUTFIT7 STUDIOS PRIVATE LIMITED',
    'EVERGREEN LITHIUM RECYCLING PRIVATE LIMITED',
    'FERCO SHUTTERS AND SEATING SYSTEMS PRIVATE LIMITED',
    'NAVBHARAT WATER PRIVATE LIMITED',
    'CHANGING TREE COMMUNICATIONS PRIVATE LIMITED',
    'DHIWAY NETWORKS PRIVATE LIMITED',
    'DEEPAK & SAHIL REALTY PRIVATE LIMITED',
    'CASHGRAIL PRIVATE LIMITED',
    'URBAN NEST VENTURES PRIVATE LIMITED',
    'INNOLEAGUE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SAFE HEALTH LABS PRIVATE LIMITED',
    'FINALYCA TECHNOLOGIES PRIVATE LIMITED',
    'PANYUAN INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'MS CUBE SYSTEMS PRIVATE LIMITED',
    'VIMOVE FOUNDATION',
    'RMQ WINNERS PRIVATE LIMITED',
    'DLXINFINITY DRIVELINE PRIVATE LIMITED',
    'MOC SHIPYARDS PRIVATE LIMITED',
    'SHEMAR POWER ENGINEERING (INDIA) PRIVATELIMITED',
    'KEEPTRUCKIN INDIA PRIVATE LIMITED',
    'MAHABIR MULTI TECH PRIVATE LIMITED',
    'EKOTECHNIK MANUFACTURING PRIVATE LIMITED',
    'SEVERN GLOCON VALVES PRIVATE LIMITED',
    'RESOLUTION TECHNOLOGIES PRIVATE LIMITED',
    'CENTUM INDIA TRADING PRIVATE LIMITED',
    'RELIABLE CONTROL SYSTEMS PRIVATE LIMITED',
    'TROPOGO TECHNOLOGIES PRIVATE LIMITED',
    'AGNESPOINT TECHNOLOGIES PRIVATE LIMITED',
    'JRG HEALTHCARE INDIA PRIVATE LIMITED',
    'LANASOL ENTERTAINMENT PRIVATE LIMITED',
    'PNEUMATIC VACUUM ELEVATORS AND LIFTS-INDIA PRIVATE LIMITED',
    'TRACEABLE LUXURY SOLUTIONS PRIVATE LIMITED',
    'CERCLE COMPLET PRIVATE LIMITED',
    'ARKWIZ INFRASTRUCTURE PRIVATE LIMITED',
    'BHAVE TECHNOLOGIES PRIVATE LIMITED',
    'S4JS SOLUTIONS AND NETWORK PRIVATE LIMITED',
    'PREKARI LABS INDIA PRIVATE LIMITED',
    'EMAGESOFT PRIVATE LIMITED',
    'SAPREVOFFSHORE KPO SERVICES PRIVATE LIMITED',
    'MASQATI DAIRY PRODUCTS LIMITED',
    'STABLESOFT TECHNOLOGIES PRIVATE LIMITED',
    'AVAADA SATARAMH PRIVATE LIMITED',
    'JSW SHAKTI FOUNDATION',
    'TECHXHUB TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TANISHIA FINTECH IMF PRIVATE LIMITED',
    'ATM SOLUTIONS PRIVATE LIMITED',
    'MAT FOUNDRY INDIA PRIVATE LIMITED',
    'TRILLBIT SOLUTIONS PRIVATE LIMITED',
    'EDJX INDIA PRIVATE LIMITED',
    'INSTABASE INDIA PRIVATE LIMITED',
    'CHUTNEY RETAIL SERVICES PRIVATE LIMITED',
    'PRIMARTIS INDIA PRIVATE LIMITED',
    'EDGENEURAL AI PRIVATE LIMITED',
    'INNOPAC CROWNPACKAGING PRIVATE LIMITED',
    'IPOWER BATTERIES PRIVATE LIMITED',
    'SIFF VENTURES PRIVATE LIMITED',
    'HIREX.AI PRIVATE LIMITED',
    'SAIGEWARE TECHNOLOGIES PRIVATE LIMITED',
    'ORTHOLITE INDIA PRIVATE LIMITED',
    'UNCOMPAHGRE BHARATH ANALYTICS PRIVATE LIMITED',
    'ZEUS CREW SERVICES PRIVATE LIMITED',
    'VALORANT CONSULTING PRIVATE LIMITED',
    'FOUR ACES FASHION HOUSE PRIVATE LIMITED',
    'IOT4EDGE PRIVATE LIMITED',
    'COFFER INTERNET SERVICES PRIVATE LIMITED',
    'DISTRICO INDIA PRIVATE LIMITED',
    'KIRNAL TECHNOLOGIES PRIVATE LIMITED',
    'ESSE 3D TECHNOLOGIES PRIVATE LIMITED',
    'INCRESCO TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'TSSDG INDIA PRIVATE LIMITED',
    'KALYANI CENTRE FOR PRECISION TECHNOLOGY LIMITED',
    'WILSON WINGS PRIVATE LIMITED',
    'AZBAN FIXATION PRIVATE LIMITED',
    'CFE-HS TECHNOLOGY PRIVATE LIMITED',
    'MELEXIA HEALTHCARE (I) PRIVATE LIMITED',
    'PRAJNA INSURETECH PRIVATE LIMITED',
    'ALTERNATIV BEAUTY PRIVATE LIMITED',
    'DANA TM4 INDIA PRIVATE LIMITED',
    'SIL-MORE TRADE PRIVATE LIMITED',
    'BIGBAG POLYMER PRIVATE LIMITED',
    'TAKSHATECH PRIVATE LIMITED',
    'TECHSILO TECHNOLOGIES PRIVATE LIMITED',
    'ALI BADANI PRIVATE LIMITED',
    'DENEB ELECTRONICS PRIVATE LIMITED',
    'BIBHA SUPPLY CHAIN SERVICES PRIVATE LIMITED',
    'LAKSAT JOURNEYS PRIVATE LIMITED',
    'JBM GREEN ENERGY SYSTEMS PRIVATE LIMITED',
    'RESELLMALL TECHNOLOGIES PRIVATE LIMITED',
    'CALFNERO PRIVATE LIMITED',
    'SATISFIC SOFTWARE SYSTEMS PRIVATE LIMITED',
    'INNVONIX TECH SOLUTIONS PRIVATE LIMITED',
    'TOTA FRESH ENTERPRISES PRIVATE LIMITED',
    'INFOCODEK IT HUB PRIVATE LIMITED',
    'OPENORGS TECHNOLOGIES PRIVATE LIMITED',
    'CASHING PLUS TECHNOLOGY PRIVATE LIMITED',
    'BOMBAY TRADEX PRIVATE LIMITED',
    'VARANASI EMBROIDERIES AND FASHION PRIVATE LIMITED',
    'ZYDUS PHARMACEUTICALS LIMITED',
    'SKW TAQNIQ PRIVATE LIMITED',
    'ZAGRO PREMIER RAIL SOLUTIONS PRIVATE LIMITED',
    'MIRABELLE AGRO MANUFACTURING PRIVATE LIMITED',
    'CLOUDFIRST TECHNOLOGY PRIVATE LIMITED',
    'ADSYNC VALERIOTTA COMMUNICATIONS (OPC) PRIVATE LIMITED',
    'ZPAY SOLUTIONS PRIVATE LIMITED',
    'JAD SETU TECH PRIVATE LIMITED',
    'FARMTHEORY PRIVATE LIMITED',
    'FASHION TV INDIA PRIVATE LIMITED',
    'MADHUMAY POULTRY EQUIPMENTS PRIVATE LIMITED',
    'EARTHFOKUS EARTHWISE PRIVATE LIMITED',
    'M11 INDUSTRIES PRIVATE LIMITED',
    'J&M HEATH TECH PRIVATE LIMITED',
    'AGROCROPS SPICES PRIVATE LIMITED',
    'LUVCITE TECHNOLOGY PRIVATE LIMITED',
    'DENALI AI INDIA PRIVATE LIMITED',
    'ELEVA ELEVATORS & ESCALATORS PRIVATE LIMITED',
    'CHARGEXO LITHIUM ENERGY PARK PRIVATE LIMITED',
    'PRABAL LEARNING INNOVATIONS PRIVATE LIMITED',
    'KVP ELECTRICALS PRIVATE LIMITED',
    'SPICEXPRESS AND LOGISTICS PRIVATE LIMITED',
    'ECOCUT MACHINING SOLUTIONS PRIVATE LIMITED',
    'WAAREE ESS PRIVATE LIMITED',
    'JAMBHEKAR AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'AARORN TECHNOLOGIES PRIVATE LIMITED',
    'BRING BACK GREEN FOUNDATION',
    'AEROLAM INSULATED SHEETS PRIVATE LIMITED',
    'INSPIRE-TECH INDIA PRIVATE LIMITED',
    'DESIGN THINKING TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GITHUB INDIA PRIVATE LIMITED',
    'LAST 3 FEET MARKETING SOLUTIONS PRIVATE LIMITED',
    'BALAJI PRECISION COMPONENTS PRIVATE LIMITED',
    'I-RAY IT SOLUTIONS PRIVATE LIMITED',
    'PRAKHYAAT VDCSE PRIVATE LIMITED',
    'FOMO FOODS INTERNATIONAL PRIVATE LIMITED',
    'SOCIAL POWER INDIA PRIVATE LIMITED',
    'FARMEASY TECHNOLOGIES PRIVATE LIMITED',
    'AGRIYODA INNOVATIONS PRIVATE LIMITED',
    'KNSOFT TECHNOLOGIES PRIVATE LIMITED',
    'VENA ENERGY CLEAN POWER PRIVATE LIMITED',
    'SHREEKHETRA ELECTRICALS PRIVATE LIMITED',
    'B- ABLE FOUNDATION',
    'BMT TRAVELS INDIA PRIVATE LIMITED',
    'VOLKSWSHOP AUTOMOTIVE INDIA PRIVATE LIMITED',
    'ELECTRO PLAZA PROJECTS PRIVATE LIMITED',
    'ADVANCE WEB SOFTWARE PRIVATE LIMITED',
    'SVK TAX CONSULTANT PRIVATE LIMITED',
    'ADIDEV COMMERCIALS PRIVATE LIMITED',
    'HAN COWELL INDIA PRIVATE LIMITED',
    'RAJENDRA GEARS PRIVATE LIMITED',
    'DST TECH PRIVATE LIMITED',
    'ROHIRA DESIGNS PRIVATE LIMITED',
    'SAOHKHA PRODUCTION AND SERVICES PRIVATE LIMITED',
    'UNIVTECH PRIVATE LIMITED',
    'RANAR TRADING PRIVATE LIMITED',
    'BOMBAY COATED AND SPECIAL STEELS PRIVATELIMITED',
    'ECOLASTIC PRODUCTS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY SIX PRIVATE LIMITED',
    'ANSHUL INNOVATIVE CHEMISTRY PRIVATE LIMITED',
    'UNIVERSALFORCES INDUSTRIES PRIVATE LIMITED',
    'MITHRAM VENTURES PRIVATE LIMITED',
    'PENTVENT PRIVATE LIMITED',
    'SPENNY FINTECH PRIVATE LIMITED',
    'YAMUNA INTERNATIONAL AIRPORT PRIVATE LIMITED',
    'FORTHCODE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GGK PROPERTIES PRIVATE LIMITED',
    'GADEES PRIVATE LIMITED',
    'PAYNTR BRAND INDIA PRIVATE LIMITED',
    'CHEM ACADEMY PRIVATE LIMITED',
    'ANAND TRAVEL SERVICES PRIVATE LIMITED',
    'BITARA PRIVATE LIMITED',
    'RUPIFI TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'IDIGITALISE CONSULTANCY PRIVATE LIMITED',
    'NVEST CAMPUS PRIVATE LIMITED',
    'HMC E-VALLEY PRIVATE LIMITED',
    'WERTMARK TECHNOLOGIES PRIVATE LIMITED',
    'SLB CLEAN POWER PRIVATE LIMITED',
    'DALMIA POLYAMIDE PRIVATE LIMITED',
    'SARUS GLOBAL SOLUTIONS PRIVATE LIMITED',
    'RKA GLOBAL SERVICES PRIVATE LIMITED',
    'BRIDGE HEALTH MEDICAL AND DIGITAL SOLUTIONS PRIVATE LIMITED',
    'VICOPLAST PACKING INDUSTRIES PRIVATE LIMITED',
    'KIN PRODUCTIONS INDIA PRIVATE LIMITED',
    'LEVENDER GARMENTS PRIVATE LIMITED',
    'SPIDEYMANAGE PRIVATE LIMITED',
    'LOTUS FITNESS CENTRE PRIVATE LIMITED',
    'AUTORELLI MOTORS PRIVATE LIMITED',
    'DEUTSCHE TELEKOM DIGITAL LABS PRIVATE LIMITED',
    'GOOGLE IT SERVICES INDIA PRIVATE LIMITED',
    'REDTEAM HACKER ACADEMY PRIVATE LIMITED',
    'PHUYAL PRIVATE LIMITED',
    'PV CLEAN MOBILITY TECHNOLOGIES PRIVATE LIMITED',
    'PROFILE DATA CENTER SOLUTIONS PRIVATE LIMITED',
    'HARSH PRANJAL INSTRUMENT & POWER PRIVATE LIMITED',
    'SMARTEDDY TECHNOLOGIES PRIVATE LIMITED',
    'INCREDERE SERVICES PRIVATE LIMITED',
    'CAMFYVISION INNOVATIONS PRIVATE LIMITED',
    'KEMPZURICH PRIVATE LIMITED',
    'IDEC CONTROLS INDIA PRIVATE LIMITED',
    'BALAJI TECHNO SYSTEMS PRIVATE LIMITED',
    'VIIKRAM MOTOR CRAFT PRIVATE LIMITED',
    'EMPAQUE INTERNATIONAL PRIVATE LIMITED',
    'GOLDEN RATIO KNOWLEDGE AND TECHNOLOGY SERVICES PRIVATE LIMITED',
    'MIRAI-DRONE PRIVATE LIMITED',
    'GOWOW CLUB PRIVATE LIMITED',
    'BENGALURU AIRPORT CITY LIMITED',
    'SHAK MANUFACTURING PRIVATE LIMITED',
    'VETE ASSOCIATES TAX & INVESTMENTS SERVICES PRIVATE LIMITED',
    'IQS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'CIRCLE INFINITY PRIVATE LIMITED',
    'ACLINE MEP PRIVATE LIMITED',
    'KRAFT BPO SOLUTIONS PRIVATE LIMITED',
    'GOWATR PRIVATE LIMITED',
    'MM STAFFING & CAREER CONSULTANTS PRIVATELIMITED',
    'AERODOME EXPERIENCES PRIVATE LIMITED',
    'BOBSONS TOURS PRIVATE LIMITED',
    'SKC FILMS AND TV PRODUCTIONS PRIVATE LIMITED',
    'CREDI MANAGEMENT SERVICES PRIVATE LIMITED',
    'COLLAB ACCOUNTING (AU) PRIVATE LIMITED',
    'B.B.D BAG PROFESSIONAL ASSOCIATION',
    'YELLOW DWELLING PRIVATE LIMITED',
    'SETHIA JUTE UDYOG PRIVATE LIMITED',
    'SELUCON PRIVATE LIMITED',
    'TBM LIFESTYLE PRIVATE LIMITED',
    'GRAPSENSE CONSULTING PRIVATE LIMITED',
    'CATTERFLY TRAVEL PRIVATE LIMITED',
    'SAME DAY DENTISTRY PRIVATE LIMITED',
    'MERCURY ENSEMBLES AND TEXTILES PRIVATE LIMITED',
    'CBS VENTURE PRIVATE LIMITED',
    'ASB RESOURCES TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GADAG CLINICAL DATA (OPC) PRIVATE LIMITED',
    'STARPORT CONTAINER LINE PRIVATE LIMITED',
    'BAMBINOS LEARNING SOLUTIONS PRIVATE LIMITED',
    'TRITONVALVES FUTURE TECH PRIVATE LIMITED',
    'BEDA PAAR HEALING TOURS PRIVATE LIMITED',
    'SKYGREEN INFRATECH PRIVATE LIMITED',
    'NEWTON CINEMA PRIVATE LIMITED',
    'FORTUNE SHIPPING PRIVATE LIMITED',
    'THINQ ADVERTISING PRIVATE LIMITED',
    'EXELNS ONLINE SERVICES PRIVATE LIMITED',
    'VKAIRE RETAILS PRIVATE LIMITED',
    'SPEAKING MIRROR MEDIA PRIVATE LIMITED',
    'INSATA HOSPITALITY SERVICES PRIVATE LIMITED',
    'INOAUG ORACLE APEX USER CONFEDERATION',
    'ALLA MODA KNITWEAR PRIVATE LIMITED',
    'HARIHARAN POWER PRIVATE LIMITED',
    'CLOUDPLINTH TECHNOLOGIES PRIVATE LIMITED',
    'BIOTEXUS ENERGY PRIVATE LIMITED',
    'CANVALOOP FIBRE PRIVATE LIMITED',
    'WEBINVENTIV TECHNOLOGIES PRIVATE LIMITED',
    'BRASKEM INDIA PRIVATE LIMITED',
    'FRIEMANN & WOLF INDIA PRIVATE LIMITED',
    'AAALAM PROMOTERS PRIVATE LIMITED',
    'TRENDING TRUX PRIVATE LIMITED',
    'CHAUDHARY ENTERPRISES TURNKEY INDIA PRIVATE LIMITED',
    'EMART XPRESS PRIVATE LIMITED',
    'LOGICHUB INDIA PRIVATE LIMITED',
    'JM CAPITAL PRIVATE LIMITED',
    'AMK GROUP OF COMPANIES (GENERAL INSTRUMENTS CON) PRIVATE LIMITED',
    'NEW STANDARD SECURITY SERVICES PRIVATE LIMITED',
    'DESQWORX SHARED OFFICES PRIVATE LIMITED',
    'TECH ENGINEERS MANUFACTURING INDIA PRIVATE LIMITED',
    'REDHUNT LABS INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY TWO PRIVATE LIMITED',
    'AGS RETAILS (INDIA) LIMITED',
    'TECHPROLOGUE PRIVATE LIMITED',
    'SHAADIDOST PRIVATE LIMITED',
    '411 LOCALS BPO PRIVATE LIMITED',
    'CHEST RESEARCH AND TRAINING PRIVATE LIMITED',
    'ASPEK INDIA PRIVATE LIMITED',
    'DISB INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED',
    'VEGA DIGITAL SERVICES PRIVATE LIMITED',
    'OTIUN INTERNATIONAL PRIVATE LIMITED',
    'COGNIZANCE INTERNATIONAL ACADEMY PRIVATELIMITED',
    'ADIRA COLLECTIVE APPARELS PRIVATE LIMITED',
    'MEERA LASER SOLUTIONS PRIVATE LIMITED',
    'QUARTERFOLD PRINTABILITIES PRIVATE LIMITED',
    'LABQUE SYSTEM PRIVATE LIMITED',
    'SAIS CAPITAL SERVICES PRIVATE LIMITED',
    'SAMARTH JEWELLERY LIMITED',
    'SWACH APPS PRIVATE LIMITED',
    'JEEVAN JYOTI MEDICARE PRIVATE LIMITED',
    'RSPGS TECH PRIVATE LIMITED',
    'INDAPP IT PRIVATE LIMITED',
    'MENTORS POOL IT SERVICES PRIVATE LIMITED',
    'MASSON MARINE TECHNOLOGIES PRIVATE LIMITED',
    'ASAA TECHSOLUTIONS PRIVATE LIMITED',
    'DEJOUR RETAIL PRIVATE LIMITED',
    'OPALTECH INTEGRATED PRIVATE LIMITED',
    'MEDISCH LIFESCIENCES PRIVATE LIMITED',
    'SCOREME ACCOUNT AGGREGATION SOLUTIONS PRIVATE LIMITED',
    'WEBCOTEC TECHNOLOGY PRIVATE LIMITED',
    'KL AMOUR INVESTMENTS PRIVATE LIMITED',
    'AYANA RENEWABLE POWER SIX PRIVATE LIMITED',
    'LEAPUS TECHNOLOGIES PRIVATE LIMITED',
    'SHIVA PERFORMANCE SOLUTIONS PRIVATE LIMITED',
    'GLAMP WILDERNESS PRIVATE LIMITED',
    'URVASHI SKILL FOUNDATION',
    'WEBTENIUM VENTURES WORLDWIDE PRIVATE LIMITED',
    'CLOUDFY ECOMMERCE INDIA PRIVATE LIMITED',
    'KLOUD CONNECT TECH PRIVATE LIMITED',
    'DONGBANG FTL INDIA PRIVATE LIMITED',
    'TEAMAIMED TECHNOLOGIES PRIVATE LIMITED',
    'CARVERSE MOBILITY SOLUTIONS PRIVATE LIMITED',
    'C-NETWORKS & COMMUNICATIONS PRIVATE LIMITED',
    'CHELA CLOTHING (OPC) PRIVATE LIMITED',
    'AYUSMAN BUSINESS CONSULTANTS PRIVATE LIMITED',
    'TEAM GROWTH PRIVATE LIMITED',
    'INTEGRELLA IT CONSULTING PRIVATE LIMITED',
    'SILVEREDGE EVENTS & RETAIL PRIVATE LIMITED',
    'JS CLEANING SOLUTIONS PRIVATE LIMITED',
    'MCITS TECHNOLOGIES PRIVATE LIMITED',
    'EXTRAVAGANZA TOURS AND TRAVELS PRIVATE LIMITED',
    'LOGILYTICS PRIVATE LIMITED',
    'ANANT DEFENCE SYSTEMS PRIVATE LIMITED',
    'NEONCHAKRA CREATIONS PRIVATE LIMITED',
    'GRAPEADS MEDIA PRIVATE LIMITED',
    'SAMUDRA PUMPS INDIA PRIVATE LIMITED',
    'SECLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'IDEESEC SERVICES PRIVATE LIMITED',
    'FASTNOTE BIOFUELS PRIVATE LIMITED',
    'MYJINI MANAGEMENT PRIVATE LIMITED',
    'ADVITH ITEC PRIVATE LIMITED',
    'IZADO SOLUTIONS PRIVATE LIMITED',
    'CPROFIT WEALTH MANAGEMENT PRIVATE LIMITED',
    'INDREAMZ GLOBAL FOUNDATION',
    'TABLEWORTH HOSPITALITY PRIVATE LIMITED',
    'AGRATAM INDIA SECURITY SERVICES PRIVATE LIMITED',
    'INWINQ INFRA PRIVATE LIMITED',
    'SKYEO ANALYTICS PRIVATE LIMITED',
    'RENEW SURYA ROSHNI PRIVATE LIMITED',
    'SATIYA NUTRACEUTICALS PRIVATE LIMITED',
    'GSN UDYOG PRIVATE LIMITED',
    'GREENOVOC SPECIALTY COATINGS PRIVATE LIMITED',
    'ATG BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUPAKSH PRIVATE LIMITED',
    'PRAGATI PRAKRUTHI MATHA FOUNDATION',
    'STARFIELD INFRACON PRIVATE LIMITED',
    '2020 MOTORS PRIVATE LIMITED',
    'NORDIC WELLNESS PRIVATE LIMITED',
    'MAKE A BIG BUSINESS PRIVATE LIMITED',
    'SAMEER LAUNDRY CARE PRIVATE LIMITED',
    'LFC DIGITAL SOLUTIONS PRIVATE LIMITED',
    'CRADLE LIFE SCIENCES (PHARMA) PRIVATE LIMITED',
    'TICKIOT PRIVATE LIMITED',
    'UNICRAFT APPLIANCES PRIVATE LIMITED',
    'BARSHIP BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'WORKAHOLICS ENTERTAINMENT SOLUTIONS PRIVATE LIMITED',
    'RASHMINBHAI SHANTILAL ZINZUWADIA PRIVATELIMITED',
    'VIDYASHREE HOUSE PRIVATE LIMITED',
    'WOXTO INDUSTRIES PRIVATE LIMITED',
    'TECH BROTHERS PRIVATE LIMITED',
    'ONE DOLLAR WALLET PRIVATE LIMITED',
    'VITRA BATHROOMS INDIA PRIVATE LIMITED',
    'LEARNENGG PRIVATE LIMITED',
    'LBRCE-IC FOUNDATION',
    'AUGMONT GOLDTECH PRIVATE LIMITED',
    'CREDSE BILL PAYMENTS PRIVATE LIMITED',
    'ANITAB WOMENS TECHNOLOGY PROGRAMMES PRIVATE LIMITED',
    'MATRIX HR TECHNOLOGIES PRIVATE LIMITED',
    'ELAPP POWER PRIVATE LIMITED',
    'THEAM HEALTHCARE PRIVATE LIMITED',
    'SARVAVIYABI SAIBABA CONSTRUCTION (OPC) PRIVATE LIMITED',
    'ADRASTYLE INDUSTRIES PRIVATE LIMITED',
    'IONTECH CYBER SECURITY PRIVATE LIMITED',
    'EATAS FISHERY PRIVATE LIMITED',
    'GET HAPPY JOURNEY CAR RENTAL INDIA PRIVATE LIMITED',
    'ANDE INDUSTRIES PRIVATE LIMITED',
    'EVAGE AUTOMOTIVE PRIVATE LIMITED',
    'DIZO INNOVATION PRIVATE LIMITED',
    'CALCULUS LOGISTECH PRIVATE LIMITED',
    'GEOMANUS PRIVATE LIMITED',
    'HANDTEX INDUSTRIES PRIVATE LIMITED',
    'FARIS GENERAL CONTRACTING PRIVATE LIMITED',
    'TRUBOARD PRIVATE LIMITED',
    'PHARMACHEMIE ENGINEERING AND CONSULTANTSPRIVATE LIMITED',
    'ROLLOVER BROADBAND PRIVATE LIMITED',
    'EDALL SYSTEMS AND SERVICES PRIVATE LIMITED',
    'ASTRAVIEW TECHNOLOGIES PRIVATE LIMITED',
    'CYGAI PRIVATE LIMITED',
    'REXON HYDRAULICS PRIVATE LIMITED',
    'PROVIDENTIA ADVISORS PRIVATE LIMITED',
    'MAITREY ELEVATORS INDIA PRIVATE LIMITED',
    'COINFINITIVE SOLUTIONS PRIVATE LIMITED',
    'WAVES TECHX SOLUTIONS PRIVATE LIMITED',
    'ADHAV PACKS PRIVATE LIMITED',
    'MAGIC CAPITAL SERVICES PRIVATE LIMITED',
    'EVERNEST COMMERCIAL PARKS PRIVATE LIMITED',
    'ASPIRARE TECHNOLOGIES PRIVATE LIMITED',
    'RATANDEEP CONCAST PRIVATE LIMITED',
    'SOLETECH PRIVATE LIMITED',
    'JSW RENEW ENERGY LIMITED',
    'ACCORDIA TECHNOLOGIES PRIVATE LIMITED',
    'CANOPY & SKY INDIA PRIVATE LIMITED',
    'HEWITTROBINS INTERNATIONAL PRIVATE LIMITED',
    'SCHLEP GAMES INDIA PRIVATE LIMITED',
    'VIDACARE LIFE PRIVATE LIMITED',
    'ULTRAFINE MINERAL & ADMIXTURES PRIVATE LIMITED',
    'ATHAANG INFRASTRUCTURE PRIVATE LIMITED',
    'ZELL EDUCATION PRIVATE LIMITED',
    'MUSIC MULAKATEIN FOUNDATION',
    'OMICROM SOLUTIONS PRIVATE LIMITED',
    'SAVVANNA INFRA GLOBAL PRIVATE LIMITED',
    'MODICLE STUDIOS PRIVATE LIMITED',
    'PIDILITE C-TECHOS WALLING LIMITED',
    'BUSARA CENTER FOR BEHAVIORAL ECONOMICS PRIVATE LIMITED',
    'WILLOWOOD INDUSTRIES PRIVATE LIMITED',
    'PESTILENCE SOLUTIONS PRIVATE LIMITED',
    'PRADUS HEALTH PRIVATE LIMITED',
    'TTC ROBOTRONICS PRIVATE LIMITED',
    'PIRAMAL PHARMA LIMITED',
    'TIES THAT BIND FOUNDATION',
    'SAMSARA FACILITY MANAGEMENT PRIVATE LIMITED',
    'YB SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'ADDITION BARODA NIDHI LIMITED',
    'ACCUPAYD TECH PRIVATE LIMITED',
    '7T TECHNOLOGIES PRIVATE LIMITED',
    'TRANSMARINELINE GLOBAL PRIVATE LIMITED',
    'FRESHMEN TECH SOLUTIONS PRIVATE LIMITED',
    'ENVIROCOOL TECH PRIVATE LIMITED',
    'SENDRIYA JEEVAN PRIVATE LIMITED',
    'INOX WIND ENERGY LIMITED',
    'AARREE LOGISTCS (OPC) PRIVATE LIMITED',
    'SPLIWO PRIVATE LIMITED',
    'SOCH RETAIL PRIVATE LIMITED',
    'ALEXIA COMPOSITE PANELS PRIVATE LIMITED',
    'AXPONENT MEDIA PRIVATE LIMITED',
    'SUBLIMIS TECHNOLOGIES PRIVATE LIMITED',
    'XEON WASTE MANAGERS PRIVATE LIMITED',
    'VALUE FASHION RETAIL LIMITED',
    'LONAR DAILY SOLUTIONS PRIVATE LIMITED',
    'RAJPUTANA SMART SOLUTIONS LIMITED',
    'TATA INDIAN INSTITUTE OF SKILLS',
    'ADLINKS TECHNOLOGIES PRIVATE LIMITED',
    'SPLURGE PRODUCTION PRIVATE LIMITED',
    'MYK LATICRETE BUILDING MATERIALS PRIVATELIMITED',
    'SANDALWOOD EDUSERVE PRIVATE LIMITED',
    'DEBT ANGELS VENTURE PRIVATE LIMITED',
    'LUCIDWORKS TECHNOLOGY PRIVATE LIMITED',
    'RAVENBECK GLOVES INTERNATIONAL PRIVATE LIMITED',
    'SWRE POWER PRIVATE LIMITED',
    'MAVENSINFO TECHNOLOGY PRIVATE LIMITED',
    'PFEC GLOBAL INDIA PRIVATE LIMITED',
    'JETZ GLOBAL LOGISTICS PRIVATE LIMITED',
    'BUYPASSNOW PRIVATE LIMITED',
    'VELOCE FINTECH PRIVATE LIMITED',
    'VDC OIL LIMITED',
    'DEVELOPMENT IMPACT FOUNDATION',
    'FIRSTSPACE DEVELOPMENT MANAGEMENT PRIVATE LIMITED',
    'HIMAN SOLUTIONS PRIVATE LIMITED',
    'LUMONT VENTURES PRIVATE LIMITED',
    'KEMPEGOWDA INTERNATIONAL AIRPORT FOUNDATION',
    'SUVIRA INDUSTRIES PRIVATE LIMITED',
    'SUCCESS POINT OVERSEAS EDUCATION CONSULTANCY PRIVATE LIMITED',
    'CHEMKART INDIA PRIVATE LIMITED',
    'CHORDIA GEMS PRIVATE LIMITED',
    'STRONGMAN INDIA SPORTS PRIVATE LIMITED',
    'XPANDION INDIA PRIVATE LIMITED',
    'TERRA-X WORLDWIDE PRIVATE LIMITED',
    'FINVIN INVESTOR PRIVATE LIMITED',
    'SECUGATOR TECHNOLOGY PRIVATE LIMITED',
    'AKM COMMERCIAL PRIVATE LIMITED',
    'MACANS INFOTECH PRIVATE LIMITED',
    'PIONEER COMPUTER BUSINESS APPLICATIONS PRIVATE LIMITED',
    'MANTHAN THERAPEUTICS AND TECHNOLOGIES PRIVATE LIMITED',
    'FAME REALTORS PRIVATE LIMITED',
    'KENT VALVE PRIVATE LIMITED',
    'IMMERSE INFOCOM PRIVATE LIMITED',
    'SANKALP FAMILY BUSINESS ADVISORY SERVICES PRIVATE LIMITED',
    'NOBLEGAS ENERGY PRIVATE LIMITED',
    'NMT TECHNOLOGIES PRIVATE LIMITED',
    'PYRAMID FACILITY MANAGEMENT SERVICES (IND.) PRIVATE LIMITED',
    'BLUEFEEDS PRIVATE LIMITED',
    'TALAIPALLI COAL MINING PRIVATE LIMITED',
    'MIRACLE VENTURES PRIVATE LIMITED',
    '100KEYS TRADECOM PRIVATE LIMITED',
    'RECREATE AIR SCIENCE PRIVATE LIMITED',
    'VSST SELLER CONCEPTS (OPC) PRIVATE LIMITED',
    'PHENOXY TOURS & TRAVELS PRIVATE LIMITED',
    'LOGIC INTELLIGENCE TECHNOLOGIES PRIVATE LIMITED',
    'INCAETEK SOLUTIONS PRIVATE LIMITED',
    'WIDESPREAD CREATION PRIVATE LIMITED',
    'ANUKUL CHANDRA FOODS PRIVATE LIMITED',
    'ASMAKAM INFRA PROJECTS PRIVATE LIMITED',
    'ADAM VACATIONS PRIVATE LIMITED',
    'GREAT VALLEY PROJECTS PRIVATE LIMITED',
    'TIGEEN COMPUTING PRIVATE LIMITED',
    'CHATOYER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CFIBER COMMUNICATIONS PRIVATE LIMITED',
    'FORXAR INDUSTRIES PRIVATE LIMITED',
    'INDIFUSION APPARELS INDIA PRIVATE LIMITED',
    'A2MS LOGISTICS AND WAREHOUSING INDIA PRIVATE LIMITED',
    'OUTFOX SPORTS PRIVATE LIMITED',
    'PRAJNATHINGS TELECOMMUNICATIONS PRIVATE LIMITED',
    'PRECIOUS FINSERVE INDIA LIMITED',
    'TRUST ASSET MANAGEMENT PRIVATE LIMITED',
    'MOHAM CAPITAL PRIVATE LIMITED',
    'KRISAP SECURITIES PRIVATE LIMITED',
    'GLOVIS INDIA ANANTAPUR PRIVATE LIMITED',
    'DEVAKINANDAN SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'WOOYOUNG AUTOMOTIVE INDIA PRIVATE LIMITED',
    'ARPORTABLE CABINS INDIA PRIVATE LIMITED',
    'ODWOLF INFRASTRUCTURE PRIVATE LIMITED',
    'NAVSAR ENGINEERING INTERNATIONAL PRIVATELIMITED',
    'ATOLLX TECHNOLOGIES PRIVATE LIMITED',
    'DIANAPPS TECHNOLOGIES PRIVATE LIMITED',
    'SUBHAMJYOTI INFRA PRIVATE LIMITED',
    'MOHAN MOTOR CAR PRIVATE LIMITED',
    'BHARAT ENTREPRENEURS NETWORK PRIVATE LIMITED',
    'SIMPLY DHANARI E-COMMERCE PRIVATE LIMITED',
    'JUNIPER NETWORKS SOLUTION INDIA PRIVATE LIMITED',
    'INNOVANTAGE SOLUTIONS PRIVATE LIMITED',
    'AYAT IMPEX INDIA PRIVATE LIMITED',
    'AIRKOMM MEDIA PRIVATE LIMITED',
    'MAXINIQUE CROSS BORDER TRADE PRIVATE LIMITED',
    'OMVA DATA SOLUTIONS PRIVATE LIMITED',
    'RIGOR LAB PRIVATE LIMITED',
    'BRINC CORPORATE SOLUTIONS PRIVATE LIMITED',
    'TRIANGULO VENTURES PRIVATE LIMITED',
    'TOXMINDS INDIA CONSULTING PRIVATE LIMITED',
    'BUSICO CONSULTANTS PRIVATE LIMITED',
    'COLORACTIVE MEDIA PRIVATE LIMITED',
    'PROMANTIA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FERILL DYNAMICS PRIVATE LIMITED',
    'VSL MARINE TECHNOLOGY PRIVATE LIMITED',
    'RANGE SHOOTING SOLUTIONS PRIVATE LIMITED',
    'PATANKAR CONSULTANTS PRIVATE LIMITED',
    'REANNON PHARMA LIMITED',
    'EERIMA DIGITOOLS PRIVATE LIMITED',
    'CODEGRID TECHNOLOGIES PRIVATE LIMITED',
    'SUMSKAR SYSTEMS PRIVATE LIMITED',
    'SORCERER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BADBAHAL SOLAR PRIVATE LIMITED',
    'REPORT HUB PRIVATE LIMITED',
    'KAPIL DESIGN CONSULTANTS PRIVATE LIMITED',
    'MANTARO NETWORK PRIVATE LIMITED',
    'AIQM BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SHASAMCO INTERNATIONAL PRIVATE LIMITED',
    'UTHIRA MIHIRA CREATIONS PRIVATE LIMITED',
    'EASY DATA ANALYTICS TECHNOLOGY PRIVATE LIMITED',
    'ARG SKILL DEVELOPMENT PRIVATE LIMITED',
    'OJASATTVIC SCIENCES PRIVATE LIMITED',
    'LANCE LABS PRIVATE LIMITED',
    'RYAAN PUBLICITY PRIVATE LIMITED',
    'ALG INTERNATIONAL GEOLOGICAL SERVICES PRIVATE LIMITED',
    'NETRA REALTY SOLUTIONS PRIVATE LIMITED',
    'DEVELGRAM TECHNOLOGIES PRIVATE LIMITED',
    'CITISKAPE MEDIACOM PRIVATE LIMITED',
    'CAPPERE SOLUTIONS PRIVATE LIMITED',
    'PRECIREX MACHINE TOOLS (OPC) PRIVATE LIMITED',
    'TYM FYV CONCEPTZ PRIVATE LIMITED',
    'IPSITA TECHNO LABS PRIVATE LIMITED',
    'ZINPRO ANIMAL NUTRITION INDIA PRIVATE LIMITED',
    'DUDHESHWAR ENGINEERS PRIVATE LIMITED',
    'SHAHEEN SPIRIT MOTORING PRIVATE LIMITED',
    'VANAPRAJNAA INTERIORS PRIVATE LIMITED',
    'UNIQUE NHIR INDUSTRIES PRIVATE LIMITED',
    'VIJAYAPURA TOLLWAY PRIVATE LIMITED',
    'SADAR BIOTECH PRIVATE LIMITED',
    'VIMOB DIGITAL MEDIA PRIVATE LIMITED',
    'RAJGARH STEEL PRIVATE LIMITED',
    'DPL VALVES & SYSTEMS PRIVATE LIMITED',
    'ANGRIYA SEA EAGLE LIMITED',
    'DROAMERS EXPERIENTIAL HOSPITALITY (OPC) PRIVATE LIMITED',
    'SONAK SHIPPING SERVICES PRIVATE LIMITED',
    'EAZY GYM PRIVATE LIMITED',
    'UNITO EXCAVATORS PRIVATE LIMITED',
    'SUGIH ENERGY INDIA PRIVATE LIMITED',
    'LIBRA PRODUCTIONS PRIVATE LIMITED',
    'UNIOX DIGITAL SOLUTIONS INDIA PRIVATE LIMITED',
    'LEO DIGITAL COMMUNICATIONS PRIVATE LIMITED',
    'ZEALOUS HEALTH PRIVATE LIMITED',
    'PROCODE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ADRA IDEAS PRIVATE LIMITED',
    'SIMPLIWORK OFFICES PRIVATE LIMITED',
    'SURYAVARMANNAGARI FOUNDATION',
    'PARAS HEALTHCARE (RANCHI) PRIVATE LIMITED',
    'TRAYAM CONSULTANCY SERVICES PRIVATE LIMITED',
    'TRANQUIL CREATIONS PRIVATE LIMITED',
    'ILAA PHOTOGRAPHY (OPC) PRIVATE LIMITED',
    'L7H ACHARYA EDUCATION FOUNDATION',
    'MINDFULNESS TRAINING INSTITUTE',
    'VISUAL DATA MEDIA SERVICES PRIVATE LIMITED',
    'RAPIDITAS CONSULTANTS PRIVATE LIMITED',
    'NDC EDUCATION CONSULTANCY PRIVATE LIMITED',
    'IDEAPARADISE TECHNOLOGY PRIVATE LIMITED',
    'INGENIOUS REPORTS PRIVATE LIMITED',
    'IEF FARMS PRODUCER COMPANY LIMITED',
    'RBZ CHEM CONSULTING PRIVATE LIMITED',
    'TECHNOGEN IT BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'INDO FORGING COMPONENTS PRIVATE LIMITED',
    'MINERALS REFINING INDIA PRIVATE LIMITED',
    'NOBLE HOUSE CONSULTING INDIA PRIVATE LIMITED',
    'GREENYARD OPERATIONS & MAINTENANCE PRIVATE LIMITED',
    'IKAMATE HR INDIA PRIVATE LIMITED',
    'ISAFAL INTERGLOBE CONSULTANTS PRIVATE LIMITED',
    'CREFIN INDIA MANAGEMENT PRIVATE LIMITED',
    'NORTHSTAR WORLDWIDE PRIVATE LIMITED',
    'PAY2WEB TECHNOLOGIES PRIVATE LIMITED',
    'EXELINK MANAGEMENT PRIVATE LIMITED',
    'WOBOT INTELLIGENCE PRIVATE LIMITED',
    'RIGHT AIR PRODUCTS PRIVATE LIMITED',
    'MDAP INNOVATIONS PRIVATE LIMITED',
    'PROGRESSIVE CORE GYM PRIVATE LIMITED',
    'ULKAGEARZ ADVENTURE PRIVATE LIMITED',
    'CHHOTU TECHNOLOGIES PRIVATE LIMITED',
    'AYUSV TECHNOLOGIES PRIVATE LIMITED',
    'ACCELERATE MEDIA PRIVATE LIMITED',
    'ROADPIN TECHNOLOGIES PRIVATE LIMITED',
    'TAXI DESIGNS PRIVATE LIMITED',
    'ANFARND INFOTECH PRIVATE LIMITED',
    'INVERTUS VENTURES PRIVATE LIMITED',
    'KEEDA MEDIA PRIVATE LIMITED',
    'DEFY NORMS PRIVATE LIMITED',
    'STONES CONSULT INDIA PRIVATE LIMITED',
    'INDUGOMA RUBBER PRIVATE LIMITED',
    'BGPS MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'BRICKFOLIO SOLUTIONS PRIVATE LIMITED',
    'KALZOOM ADVISORS PRIVATE LIMITED',
    'AVERA NEW AND RENEWABLE ENERGY MOTOCORPTECH PRIVATE LIMITED',
    'S-ONE MARINE ACCOMM & SERVICES (INDIA) PRIVATE LIMITED',
    'STEPHER CONSULTANCY SERVICES PRIVATE LIMITED',
    'XALT ANALYTICS PRIVATE LIMITED',
    'DUARZ HR SERVICES PRIVATE LIMITED',
    'VARAISYS PRIVATE LIMITED',
    'DOT BOX CONCEPTION PRIVATE LIMITED',
    'KNTX TRADING SOLUTIONS INDIA PRIVATE LIMITED',
    'SYNTAX PARK PRIVATE LIMITED',
    'STECK STREAMS PRIVATE LIMITED',
    'TEKOALYN LABS INNOVATIVE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'STIC SOFT E-SOLUTIONS PRIVATE LIMITED',
    'PITAMBAR CERELACS PRIVATE LIMITED',
    'BRAINLINES SOLUTIONS PRIVATE LIMITED',
    'DIGITALMAIN PRIVATE LIMITED',
    'REJOIN WEBSOLUTION PRIVATE LIMITED',
    'ZENSUNG SOFTWARE PRIVATE LIMITED',
    'ADONIA OFFSHORE CONSULTANTS PRIVATE LIMITED',
    'ENVISIOR CONSULTING PRIVATE LIMITED',
    'COMPLETE CARE VISA CONSULTANTS PRIVATE LIMITED',
    'SPANNINGTREE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'NORATECH PRIVATE LIMITED',
    'HOPEFLOATS TECHNOLOGIES PRIVATE LIMITED',
    'CLICKCRAFTY TECHNOLOGIES PRIVATE LIMITED',
    'PICFY TECHNOLOGIES PRIVATE LIMITED',
    'PANVA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'RAIN MAKER DISTRIBUTION PRIVATE LIMITED',
    'AKASI NETWORKS PRIVATE LIMITED',
    'VITNE TECHNOLOGIES PRIVATE LIMITED',
    'JIDDU INDIA PRIVATE LIMITED',
    'SOUVENIR APPS PRIVATE LIMITED',
    'P4U BUILDTECH PRIVATE LIMITED',
    'SAMUNNATI AGRI INNOVATIONS LAB PRIVATE LIMITED',
    'GNOSCH FOODS PRIVATE LIMITED',
    'RUBIX ENTERPRISES PRIVATE LIMITED',
    'DATAROOMS STERLING PRIVATE LIMITED',
    'EKITAI SOLUTIONS PRIVATE LIMITED',
    'LETSPIE ENTERTAINMENT PRIVATE LIMITED',
    'SKAJN MARKETING TECHNOLOGIES PRIVATE LIMITED',
    'BYTESTORM TECHNO SOLUTIONS PRIVATE LIMITED',
    'BRAVIN REALTORS PRIVATE LIMITED',
    'BIRLA ESTATES PRIVATE LIMITED',
    'PRESTIGE EXORA BUSINESS PARKS LIMITED',
    'PALVIK FINANCE PRIVATE LIMITED',
    'SCAN STEELS LIMITED',
    'MENTRIC TRAINING AND CONSULTING PRIVATE LIMITED',
    'GSFL TRUE FINANCE PRIVATE LIMITED',
    'FLIGHT FARE DEALS PRIVATE LIMITED',
    'DONIAS MEGALINK PRIVATE LIMITED',
    'TIARA TRAVEL NETWORKS PRIVATE LIMITED',
    'SG EXOTIC DESTINATION PLANNERS PRIVATE LIMITED',
    'AFFLUENT CONSULTRADE PRIVATE LIMITED',
    'ANEMO PROJECTS PRIVATE LIMITED',
    'DRAMI COMMUNICATIONS PRIVATE LIMITED',
    'LIKO-S INDIA PRIVATE LIMITED',
    'HWL ADVANCED TECHNOLOGIES PRIVATE LIMITED',
    'PEECH STUDIO INDIA PRIVATE LIMITED',
    'STEELEYE INDIA PRIVATE LIMITED',
    'AIE SOFTWARE INDIA PRIVATE LIMITED',
    'LEADICS CONSULTING INDIA PRIVATE LIMITED',
    'PROBO VISION DAIRY PRIVATE LIMITED',
    'FANDORO TECHNOLOGIES PRIVATE LIMITED',
    'ANALOGAN AUDIO (OPC) PRIVATE LIMITED',
    'REMOTE AGE NOMAD SOLUTIONS (OPC) PRIVATELIMITED',
    'ACTIFY DATA LABS PRIVATE LIMITED',
    'B. V. H. MANUFACTURING INDIA PRIVATE LIMITED',
    'INTELLIVOLT IOT PRIVATE LIMITED',
    'EMPORIO OWNERS ASSOCIATION',
    'VN FEEDS INDIA PRIVATE LIMITED',
    'TRXIEA PLATFORMS AND SOLUTIONS PRIVATE LIMITED',
    'ADWITYA SHASWAT PRIVATE LIMITED',
    'JACARANDAS MANAGEMENT PRIVATE LIMITED',
    'TANVIKA INNOVATION PRIVATE LIMITED',
    'CRESCERE TECHNOLOGIES PRIVATE LIMITED',
    'FLYING KITE SOLUTIONS PRIVATE LIMITED',
    'ATOM BRICKS PRIVATE LIMITED',
    'DECLAN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'MARKOWATE TECHNOLOGIES PRIVATE LIMITED',
    'LOSUNG AUTOMOTIVE PRIVATE LIMITED',
    'PURELEARN EDUINFRA KANAKAPURA PRIVATE LIMITED',
    'MS SAIGAB PROCESSING PRIVATE LIMITED',
    'FOLKTALE EVENTS AND MANAGEMENT PRIVATE LIMITED',
    'ALIFEROUS TECHNOLOGIES PRIVATE LIMITED',
    'HAPPILO INTERNATIONAL PRIVATE LIMITED',
    'DASK POWER PRIVATE LIMITED',
    'SOBUS INSIGHT FORUM',
    'COSMOADZ DIGITAL MEDIA PRIVATE LIMITED',
    'TKN ADVISORS PRIVATE LIMITED',
    'JAANAVI SOCIAL WELFARE FOUNDATION',
    'IMEMFLO FILTRATION PRIVATE LIMITED',
    'CISNER TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'ETS MEDIA PRIVATE LIMITED',
    'CALYPSO LABS PRIVATE LIMITED',
    'GTCE TAX AND CONSULTING PRIVATE LIMITED',
    'WAVELINK NETWORKS (OPC) PRIVATE LIMITED',
    'A.H. MARKET ACCESS TRANSFORMATION PRIVATE LIMITED',
    'VUDAANTEK PRIVATE LIMITED',
    'CURIOUS KIDS MEDIA TECH PRIVATE LIMITED',
    'BOWHEAD CAPITAL ADVISORS PRIVATE LIMITED',
    'DOREWEL FOODS & BEVERAGES PRIVATE LIMITED',
    'Indian science & technology research foundation',
    'Core advisory and accounting private limited',
    'Capitalwest advisors private limited',
    'Alliance legal services private limited',
    'Paperchase accountancy india private limited',
    'KEEMAYA REALCON PRIVATE LIMITED',
    'Sofia marine private limited',
    'Rider levett bucknall india private limited',
    'Htg engineering private limited',
    'Shiplift techno solutions private limited',
    'Vans scientific information private limited',
    'Vaisan petroleum private limited',
    'Airpack express private limited',
    'Shubh labh ace infratech limited',
    'Ekstop shop private limited',
    'S f s allianz private limited',
    'Vishva protech private limited',
    'Adz edge communications private limited',
    'Bridgeastern consulting private limited',
    'Arwen fragrances private limited',
    'Skarma consultancy private limited',
    'Bni sales & services private limited',
    'Gtm support solutions private limited',
    'Arthavest advisors private limited',
    'Mellora infrastructure private limited',
    'Ankit shiny mechanicals india private limited',
    'Vile industries private limited',
    'ANS DESIGNS & FITOUTS PRIVATE LIMITED',
    'Sj surfine private limited',
    'Osm capital advisors private limited',
    'Triangular dots creative solutions private limited',
    'Innovative speciality ingredients private limited',
    'Nextgen tech initiatives private limited',
    'Vitar enterprises private limited',
    'Admirus marksol private limited',
    'Media events and advertising (india) private limited',
    'Aag engineering technologies private limited',
    'Belvedere management and services private limited',
    'Indrex private limited',
    'Asona india private limited',
    'Doni polo infraconsultants private limited',
    'Headstart business solutions private limited',
    'D-tech management resource india private limited',
    'Orbis hospitality services private limited',
    'Team security and hr solutions private limited',
    'R a d consultancy private limited',
    'Fastech projects private limited',
    'Delonex energy india private limited',
    'Ethos hr management and projects private limited',
    'Pegasus corporate solutions private limited',
    'Orris consultancy private limited',
    'Vinolya services private limited',
    'Infomark marketing private limited',
    'Sirius connect private limited',
    'Memg international india private limited',
    'Sea horse vanijya private limited',
    'Allegis services (india) private limited',
    'Musigma business solutions private limited',
    'Safety catch safety training and consulting private limited',
    'Calibre consultants private limited',
    'Ksa management services private limited',
    'MBMC CONSULTING PRIVATE LIMITED',
    'Options group strategic consulting (india) private limited',
    'Ramkripa enterprises private limited',
    'Az techno engineering services private limited',
    'Saint treasuries private limited',
    'V-magnum opus strategic solutions private limited',
    'Infracap india advisers private limited',
    'Vaishnavi management private limited',
    'BRIKHOT HOME PRIVATE LIMITED',
    'Pratham international private limited',
    'Media exhibitors private limited',
    'A2z online services private limited',
    'Yen capital advisors private limited',
    'ABSOLUT FUTURE TECH PRIVATE LIMITED',
    'Elitser it solutions india private limited',
    'Ecs insurance consultants private limited',
    'G2 trade centre private limited',
    'MA CONSULTING SERVICES PRIVATE LIMITED',
    'PELICAN FINANCIAL SERVICES PRIVATE LIMITED',
    'Impetus analytic e-solutions private limited',
    'Alpha micro finance consultants private limited',
    'Greatoo (india) private limited',
    'Startup centre and management private limited',
    'Jmp solutions limited',
    'Ranli mousi management services private limited',
    'PADREA GLOBAL SERVICES LIMITED',
    'Rotary mec engineering (india) private limited',
    'Unity projects private limited',
    'SHAYNE CONSULTANTS PRIVATE LIMITED',
    'Vernekar associates private limited',
    'Kundur constructions private limited',
    'Studio gsa architects private limited',
    'Japro engineering pvt ltd',
    'Prabhu envirotec private limited',
    'Smilesville care private limited',
    'Cutech consulting engineers private limited',
    'Jobby engineers private limited',
    'Mission aerospace foundation of india',
    'Meeta machine tools private limited',
    'Loyal industrial gears ltd.',
    'Lapp india private limited',
    'Kostwein india company private limited',
    'RE EQUIPMENTS (INDIA) PRIVATE LIMITED',
    'Krishna auxiliaries private limited',
    'Viridis engineering india private limited',
    'Lexus hycon private limited',
    'Base vibration isolators private limited',
    'Avon hydraulics & eng. private limited',
    'Pentagon machines and services private limited',
    'NSK BEARINGS INDIA PRIVATE LIMITED',
    'Wam india private limited',
    'Ankita brass components private limited',
    'Hira technologies private limited',
    'Sepack india private limited',
    'Accu pack engineering private limited',
    'Prismtech packaging solutions private limited',
    'HIND FILTERS PRIVATE LIMITED',
    'Sap filter private limited',
    'Aes (india) engineering limited',
    'Amp rose private limited',
    'Gvm engineering solutions private limited',
    'Trumpf (india) private limited',
    'HOWDEN AIR AND GAS INDIA PRIVATE LIMITED',
    'Suyog engineers private limited',
    'Accurate pms private limited',
    'Quality systems and equipments private limited',
    'Vibromech engineers & services limited',
    'Vedant tools private limited',
    'Wolf precision tools india private limited',
    'Messer cutting systems india private limited',
    'Yogi cab insulation private limited',
    'Model infra corporation private limited',
    'Mindrill systems & solutions private limited',
    'Dowel machinery private limited',
    'Berkel industries private limited',
    'Finehope allied engineering private limited',
    'R. s. industech private limited',
    'Sumukha automation private limited',
    'Regport technologies private limited',
    'Dynalec controls private limited',
    'Vign engineering and services private limited',
    'Casagrande (india) piling & geotechnical equipment private limited',
    'Gayatri engineering co pvt ltd',
    'Infiniit software solutions private limited',
    'Snt equipments private limited',
    'Gem equipments private limited',
    'Shree matangi cooling towers private limited',
    'Infinite aqua private limited',
    'Unicorn denmart limited',
    'Wang hospitality equipment private limited',
    'Kran rader private limited',
    'Shrijee heavy projects works limited',
    'Vapson jewellery equipments private limited',
    'Ats conveyors india private limited',
    'AFFORDABLE ROBOTIC & AUTOMATION LIMITED',
    'Bomafa special valve solutions private limited',
    'Vem technologies private limited',
    'Emmvee green power private limited',
    'Pace renewable energies private limited',
    'Csk electronics and automation private limited',
    'Nowelco industries private limited',
    'ACQUEON TECHNOLOGIES PRIVATE LIMITED',
    'Tru informations and systems private limited',
    'Microport infotech private limited',
    'Coffee day consolidations private limited',
    'Rsg solutions private limited',
    'Silverlake information systems private limited',
    'Abs instruments private limited',
    'Sands instrumentation private limited',
    'Cosmonet solutions private limited',
    'Timeless learning technologies private limited',
    'Vishal jingke electric company private limited',
    'Pebbles (india) pvt ltd',
    'Adiga transformers and coils private limited',
    'Brosbel engineering private limited',
    'Rosh elevators private limited',
    'Adisoft technologies private limited',
    'Gravity india technologies private limited',
    'Unipower transformers private limited',
    'Citel surge protection private limited',
    'Optic liting private limited',
    'Visma instruments and technologies private limited',
    'Transrail lighting limited',
    'Mahavir interface private limited',
    'Pinran energy conservator private limited',
    'Neel controls private limited',
    'Secured engineers private limited',
    'SHREETECH DATA LIMITED',
    'Global enviro air systems private limited',
    'Electro care (india) private limited',
    'Lakhani vardaan auto private limited',
    'Aahana realty private limited',
    'Ishani realty private limited',
    'Sneha realty private limited',
    'Eshita builcon private limited',
    'Ispita realty private limited',
    'Liases foras real estate rating & research private limited',
    'Seven city developers private limited',
    'Supreme innovative building projects private limited',
    'Gkp constructions india private limited',
    'Leverage buildcon private limited',
    'Shreesha estates private limited',
    'Dpn bansal brothers private limited',
    'Terrapolis international private limited',
    'Sahara agro land management corporation limited',
    'Leverage infrastructures private limited',
    'DPN THE REAL ESTATE DEVELOPMENT SERVICESPRIVATE LIMITED',
    'Raiaskaran infrastructure private limited',
    'Leverage developers private limited',
    'Ascent projects management private limited',
    'AJAYDEEP ENTERPRISES PRIVATE LIMITED',
    'MEGASTONE LOGIPARKS PRIVATE LIMITED',
    'Sunrise infratec private limited',
    'Ashray premises private limited',
    'Alpha avenues private limited',
    'Eta star property developers ltd.',
    'Shankarsuwan infracon private limited',
    'BOP REALTY PRIVATE LIMITED',
    'Neelkanth land developers private limited.',
    'WSB REAL ESTATE PARTNERS PRIVATE LIMITED',
    'Suram realtors private limited',
    'Mayfair infra realty private limited',
    'Bhimsaria realty private limited',
    'Inka constructions private limited',
    'Pioneer property zone services private limited',
    'Samira realty projects private limited',
    'Mayfair meridian developers private limited',
    'Jaisingh builders private limited',
    'Spar realtors private limited',
    'Leverage realtors private limited',
    'Clasto realty private limited',
    'B b exim private limited',
    'Vouchagram india private limited',
    'Inner strength infinite private limited',
    'Murari tie up private limited',
    'Parvati tradelink private limited',
    'Pro security services private limited',
    'Z k investments private limited',
    'Ssdn marketing private limited',
    'Newstar consulting private limited',
    'Gvp it services private limited',
    'Electrophoto equipments private limited',
    'Cottage9 enterprises private limited',
    'Berkshire hathaway services india private limited',
    'KLASS PACK LIMITED',
    'Mirajkar saraf & gems private limited',
    'Aakriti professional services private limited',
    'LOTUS HOMETEXTILES LIMITED',
    'JAYA HIND INDUSTRIES PRIVATE LIMITED',
    'KANMECH PRIVATE LIMITED',
    'Corrodyne coatings private limited',
    'Le mirror shine granites private limited',
    'Stargate enterprises private limited',
    'Shalini television network private limited',
    'Best aditi corporation private limited',
    'Roads untravelled private limited',
    'A n john pvt ltd',
    'Ram kanta properties pvt ltd',
    'DWARKA OWNERS',
    'WELFARE ASSOCIATION',
    'Elek-tek (india) private limited',
    'Tyroon tea co ltd',
    'Super sales india limited',
    'Zenith enterprises limited',
    'Haryana texprints overseas limited',
    'Malwa cotton spinning mills ltd',
    'Sangam (india) limited',
    'Awanti fibre and industries ltd',
    'KALLAM TEXTILES LIMITED',
    'Tamilnadu newsprint & papers limited',
    'Isgec heavy engineering limited',
    'Newton engineering and chemicals limited',
    'THE YAMUNA SYNDICATE LIMITED',
    'Gujarat narmada valley fertilizers & chemicals limited',
    'Paramount cosmetics (india) limited',
    'Iag glass company limited',
    'Sarda energy & minerals limited',
    'Panchmahal steel ltd',
    'Tribhovandas bhimji zaveri limited',
    'Bkg corp limited',
    'Panacea biotec limited',
    'Force motors limited',
    'Bajaj holdings & investment limited.',
    'South east industrial developments limited',
    'Mm forgings limited',
    'Seiko commercial ltd',
    'Kadambini commercial ltd.',
    'Damodar ropeways & infra limited',
    'Sandeep (india) ltd',
    'Soma textiles & industries ltd',
    'MORGAN WALKER AND CO. LTD',
    'Satyam trading co ltd',
    'Eduwave private limited',
    'A mentor for intelligence group private limited',
    'Brainedge education private limited',
    'Costa sports systems private limited',
    'PREMBICK PLASTIC SUPPLIERS PRIVATE LIMITED',
    'Purti colors owners association',
    'Tech pourri private limited',
    'S.s medical systems ( india) private limited',
    'Yash raj and puri co private limited',
    'Orissa telefilms private limited',
    'Gloria world vision private limited',
    'Purple model management private limited',
    'Chokhi dhani resorts private limited',
    'SGARG ENTERPRISES PRIVATE LIMITED',
    'Mohan motor sales private limited',
    'ALOM ALUMINIUM PRIVATE LIMITED',
    'Banded suppliers private limited',
    'WINDSOR SPECIALTY SERVICES PRIVATE LIMITED',
    'Alma mater agencies private limited',
    'Spotme tracon pvt ltd',
    'Uthana sales pvt.ltd.',
    'Speciality merchandising services private limited',
    'Asra tie-up private limited',
    'Nextgen commotrade private limited',
    'British electric insulating co pvt ltd',
    'Mapple commerce pvt ltd',
    'Arco business pvt ltd',
    'Kali impex pvt ltd',
    'Vijayeswari commodities pvt. ltd.',
    'Ashika sarees ltd',
    'Fizza dealers ltd',
    'SOLCEN INFRA PRIVATE LIMITED',
    'Konark steel industries pvt ltd',
    'Ashita mercantile private limited',
    'Agrozan india private limited',
    'Caplin barter pvt ltd',
    'Irc industries ltd.',
    'Ritz suppliers private limited',
    'NIMBUS TOURS & TRAVELS PVT. LTD.',
    'Coronation commerce pvt ltd',
    'Maheep barter pvt ltd',
    'Woodburn estate private limited',
    'Wonderland vanijya pvt ltd',
    'Kippy commercial pvt ltd',
    'Orion technocraft pvt ltd',
    'Paradise marketing private limited',
    'Govardhan fashions private limited',
    'Simco commotrade private limited',
    'Skylark vincom private limited',
    'Mountview dealers private limited',
    'Rupnarayan dealers private limited',
    'Neelkamal commodeal private limited',
    'Brilliant commosales private limited',
    'K k r products and marketing private limited',
    'Neeraj traders private limited',
    'THE ASSOCIATED AUTO PARTS Private Limited',
    'Malbros impex p. ltd.',
    'Sahibabad impex pvt. ltd.',
    'H s exim private limited',
    'Cold gold syntex pvt ltd',
    'Panchanan mercantile private limited',
    'Trilok commercial private limited',
    'Suraj components private limited',
    'Warren steels private limited',
    'Samrat agency private limited',
    'Ahnik goods private limited',
    'Raigarh jute & textile mills ltd',
    'Jfc impex pvt. ltd.',
    'O. p. traders limited',
    'Trustline commodities private limited',
    'Ambient systems private limited',
    'MESSALS OVERSEAS (INDIA) PRIVATE LIMITED',
    'Business search india private limited',
    'Sangmeshwar international private limited',
    'Vertical vyapaar private limited',
    'Geetanjali vyapaar pvt ltd',
    'Akriti vyapaar private limited',
    'Progressive suppliers pvt ltd',
    'Venkatesh merchandise private limited',
    'Dewan exporters pvt ltd',
    'Protocol commotrade pvt ltd',
    'Maa tarapith mercantile pvt ltd',
    'Manglam alloys & ispat private limited',
    'Khazana marketing pvt ltd',
    'Packwell commercial private limited',
    'Glb parfums & beaute india private limited',
    'Multitech merchandise private limited',
    'Placent commercial private limited',
    'New samrat metal company private limited',
    'Multi color steels (india) private limited',
    'Ayush toys marketing private limited',
    'Nilos rubcon private limited',
    'Xcel business solutions private limited',
    'Pragati fabricators pvt ltd',
    'Regnant trading private limited',
    'Sanghavi enterprises private limited',
    'Indicool innovations private limited',
    'Yuthika commercial private limited',
    'Sns sales private limited',
    'Eminent trade consultants private limited',
    'Mahalaxmi continental limited',
    'Arun and rajive private limited',
    'Cube exports private limited',
    'Barrina impex (india) private limited',
    'Shobha industries private limited',
    'R k enterprises pvt ltd',
    'ZULU TELE SERVICES PRIVATE LIMITED',
    'Intouch mobicare private limited',
    'Wild rose commercials private limited',
    'Betterdeal machineries private limited',
    'N.d. products private limited',
    'Katsun automation private limited',
    'KSBM OVERSEAS PRIVATE LIMITED',
    'Kyra enterprises private limited',
    'R j cama and co pvt ltd',
    'Welco export private limited',
    'PB FINTECH LIMITED',
    'SOUTH INDIAN CREDITS LIMITED',
    'S.gopal kamath (cochin) private limited',
    'True value traders limited',
    'Sac impex private limited',
    'RELIANCE RITU KUMAR PRIVATE LIMITED',
    'Deokiran merchandise pvt ltd',
    'S r traders pvt ltd',
    'Venkateshwar impex pvt ltd',
    'Verispring engineering solutions (india) private limited',
    'PRAVIRYA SYNERGIES & SOLUTIONS PRIVATE LIMITED',
    'Nitin strips private ltd',
    'YUGAL REALTY PRIVATE LIMITED',
    'Dcs construction private limited',
    'Ultra consultants private limited',
    'Sumangalam steels private ltd',
    'Baba iron company private limited',
    'Sunrise freight forwarders private limited',
    'Ridhi estates private limited',
    'Glofab pvt ltd',
    'Securipax india private limited',
    'Precision testing machines private limited',
    'La-medicca (india) private limited',
    'Pickwick poultry private limited.',
    'Superb security private limited',
    'Scope promoters private limited',
    'Vasco weddings and event management private limited',
    'TRIPAT VENTURES LIMITED',
    'Fornax financial services private limited',
    'ORCHID INFRASTRUCTURE & HOME DEVELOPERS PRIVATE LIMITED',
    'Sleepwell enterprises private limited',
    'Ambience hotels & resorts private limited',
    'Lagnam procon private limited',
    'Geotrackers mobile resource management private limited',
    'Bakshi estate pvt ltd',
    'Usha fabs private ltd',
    'Sawhney builders pvt ltd',
    'Divya and co private limited',
    'Strategic alliance management services private limited',
    'Mahagun (india) private limited',
    'Crayon retail private limited',
    'Priyanka investment private limited',
    'Meenakshi capital services private limited',
    'Surya processors private limited',
    'Flexo foam private limited',
    'M intergraph systems private limited',
    'B.s. industries private limited',
    'Ssb impex private limited',
    'VANSH INDUSTRIES PRIVATE LIMITED',
    'Aldoka exports private limited',
    'Alm housing and construction company private limited',
    'Nirvan construction and finlease private limited',
    'Vgi power systems private limited',
    'Bhargava phytolab private limited',
    'Iycworld softinfrastructure private limited',
    'Yati overseas private limited',
    'Mahavira tents (india) private limited',
    'Everest business advisory india private limited',
    'Devats india private limited',
    'Rcs impex private limited',
    'Indo-polygraph machinery private limited',
    'STELLAR PLATINUM ASSETS PRIVATE LIMITED',
    'P.r. packagings limited',
    'Texla plastics and metals pvt. ltd.',
    'A v estates private limited',
    'Montana impex private limited',
    'Divya kapur holding private limited',
    'Sidhant holding private limited',
    'Raghav farms and resorts private limited',
    'ADL COURIER & CARGO PRIVATE LIMITED',
    'Abm digital media private limited',
    'Crystal eyes marketing services private limited',
    'Ciencia solutions private limited',
    'Unipack multiproduct private limited',
    'BUNIYAD FINCAP PRIVATE LIMITED',
    'On time technologies private limited',
    'Impulse foods private limited',
    'Snacket technologies private limited',
    'Cabe springs and fasteners india private limited',
    'Precision shafts private limited',
    'Fine grace officesystems private limited',
    'S. malhotra & co. private limited',
    'Manupatra information solutions private limited',
    'Sribir technologies limited',
    'Vishal colour roofs private limited',
    'Ashirbad intcon private limited',
    'Taurlube petrochemicals private limited',
    'Kratin solutions private limited',
    'Adamis ventures private limited',
    'INTERSPACE CONNECT PRIVATE LIMITED',
    'Freshways dairy private limited',
    'Jens india management services private limited',
    'Cmj investments private limited',
    'Victoria consultants private limited',
    'Nest nirman private limited',
    'Impulse international private limited',
    'At par laundry services private limited',
    'Weaver bird mall and property management consultants private limited',
    'Suraj refractories private limited',
    'Lancer securitas services private limited',
    'Delta human resources consultants private limited',
    'Million minds management services limited',
    'Peregrine guarding private limited',
    'Martinet facility management services private limited',
    'Sajavat group private limited',
    'Madan packaging pvt ltd',
    'Genesis facilities management private limited',
    'Sgs infosystems private limited',
    'Apranje capital services private limited',
    'Dev devi aadhkatyani commercial private limited',
    'KASHMIR COLLECTIONS PRIVATE LIMITED',
    'Space matrix design consultants private limited',
    'Shrai fashion studios limtied',
    'Mmg designers private limited',
    'Kitchen decor & interiors private limited',
    'Orarham creations private limited',
    'Sentinel infotech private limited',
    'SUNNYGARG ENTERPRISES PRIVATE LIMITED',
    'City maintenance services private limited',
    'MGM ADVISORY PRIVATE LIMITED',
    'Chippendale (exports) private limited',
    'Caravan buildcon private limited',
    'Platinum land developers private limited',
    'Intime developers private limited',
    'Saral awas infrastructure limited',
    'Aarzoo technobuild private limited',
    'French buildmart private limited',
    'White windows infrastructure private limited',
    'Bhasin associate projects private limited',
    'Spacewood office solutions private limited',
    'Buildstar projects private limited',
    'Atmos power private limited',
    'Shashi power projects private limited',
    'Morgan towers private limited',
    'Ensemble promotions private limited',
    'Meena elastomers private limited',
    'Abs vintners private limited',
    'Nk wind farms (india) private limited',
    'Punjab state transmission corporation limited',
    'Goodwin realtors private limited',
    'Bindhyawasini buildcon india private limited',
    'Wpa clean energy private limited',
    'Unitech pioneer nirvana recreation private limited',
    'Sunvolt energy private limited',
    'Shital shilpi foods private limited',
    'Kaushalya energy private limited',
    'Kamarhatty power limited',
    'Amas land developers pvt ltd',
    'CRS INN PRIVATE LIMITED',
    'Mmn estates private limited',
    'Avl infrastructure private limited',
    'Sga realtors private limited',
    'Sansun contractors private limited',
    'SUN-UP INFRASTRUCTURE PRIVATE LIMITED',
    'Parth homes private limited',
    'Paras realtors private limited',
    'Hotel sahar palace pvt ltd',
    'Perfect house private limited',
    'Reva builders private limited',
    'MOHIT ENVIRO INFRA PRIVATE LIMITED',
    'Sunshine arcade private limited',
    'Premier plant services & engineers private limited',
    'Calibre colonisers private limited',
    'Z estates private limited',
    'Elysium properties india private limited',
    'Truworth buildcon private limited',
    'Chitrakut tex-con private limited',
    'Shrishti buildwell private limited',
    'Niharika buildestate private limited',
    'Growmore builders private limited',
    'Nilayam projects private limited',
    'Sanida properties private limited',
    'SHRI VEER TEJA REAL ESTATE AND DEVELOPERS PRIVATE LIMITED',
    'SATYA MICRO HOUSING FINANCE PRIVATE LIMITED',
    'Goodwill advance construction company private limited',
    'Akhil buildcon private limited',
    'Alana builders & developers private limited',
    'Sagar properties pvt ltd',
    'Yash developers pvt ltd',
    'Lily griha nirman private limited',
    'Terrace and top (india) private limited',
    'Acropolis properties private limited',
    'Sree shylam contracting and real estate private limited',
    'Overseas resources limited',
    'Milhard sales private limited',
    'Buildcon india private limited',
    'INTERSTAR EDU- SERVE PRIVATE LIMITED',
    'Shaan infra private limited',
    'Sanchaya infraprojects limited',
    'Mahavira electricals pvt. ltd.',
    'Saraf electricals private limited',
    'BIMPACT DESIGNS PRIVATE LIMITED',
    'Mesco construction private limited',
    'Subrat properties private limited',
    'Builcon constructions pvt ltd',
    'BEETEL ENGINEERING CONSTRUCTION PRIVATE LIMITED',
    'KABLIWALAS FOODS PRIVATE LIMITED',
    'Comex infratech private limited',
    'Indiaemerging infrastructure private limited',
    'Jaguar buildcon private limited',
    'Primatech infrastructure private limited',
    'Swastic real home private limited',
    'A p realtech private limited',
    'S. s. inframetalco private limited',
    'Obelisk design private limited',
    'Edge studios private limited',
    'H.C. GUPTA EDUCATIONAL FOUNDATION',
    'Kamrup housing projects private limited',
    'Rg appartments private limited',
    'Incoda worldwide private limited',
    'Salasar towers private limited',
    'Calgary estate private limited',
    'Lemon constructions private limited',
    'Unique farmestate private limited',
    'Seaward buildcon private limited',
    'Mangalbhawan infrastructure private limited',
    'Vanity propbuild private limited',
    'Bhargav builders private limited',
    'Devoke developers private limited',
    'Swadeshi civil infrastructure private limited',
    'K & j jewellers private limited',
    'Asdc construction & infrastructure private limited',
    'Eminence realtech private limited',
    'Angels build well private limited',
    'Confluence build private limited',
    'Vivek infracon private limited',
    'Ads developers private limited',
    'Khosla realty private limited',
    'Balaji development pvt. ltd.',
    'Mrj properties private limited.',
    'Goodwin builders private limited',
    'INTECSEA ENGINEERING INDIA PRIVATE LIMITED',
    'A to z telecom private limited',
    'Real time management consultancy services private limited',
    'Anindus consultants private limited',
    'Tokyo consulting firm private limited',
    'Apostle trading consultants private limited',
    'Precision advisory services private limited',
    'Arcs advisors private limited',
    'Kare india development services private limited',
    'I3 consulting private limited.',
    'Vision b2b advisory services private limited',
    'Tree of knowledge dot com private limited',
    'Techworkx it innovations private limited',
    'Heritage computers private limited',
    'Qsix india private limited',
    'P k geotech solutions private limited',
    'Ambience facilities management private limited',
    'GLOBUS AGRI WAREHOUSING PRIVATE LIMITED',
    'Ireflecton solutions private limited',
    'Deltastar advisory private limited',
    'Cementforce impex private limited',
    'Holisol talent solutions private limited',
    'Bigfoot retail solutions private limited',
    'Aim systems & solutions private limited',
    'Pahle india foundation',
    'Carrot communication private limited',
    'Creditum finserv private limited',
    'Centre for cellular and mollecular platforms',
    'Eduoutlook consultancy private limited',
    'Edusky consulting private limited',
    'Nirma management services pvt ltd',
    'Jmd astrological consultancy services private limited',
    'Blend consulting & training india private limited',
    'Expat direction consultancy services private limited',
    'Nanosniff technologies private limited',
    'Civitas consultancies private limited',
    'Mentorguru professional services private limited',
    'Aditya bansal creations private limited',
    'INDOTECH INFORMATION SYSTEMS PRIVATE LIMITED',
    'INRECO ENTERTAINMENT PRIVATE LIMITED',
    'Tirupati & associates pvt ltd',
    'Pragati services pvt. ltd.',
    'Fairfest media ltd',
    'Wynncom digital devices private limited',
    'ELBIT SYSTEMS OF INDIA PRIVATE LIMITED',
    'Ocean star ships management private limited',
    'D s home construction private limited',
    'HAP RETROFIT AND ENGINEERING INFRASTRUCTURE PRIVATELIMITED',
    'AMVIS SYSTEMS INDIA LIMITED',
    'Mint infotech private limited',
    'System 3 net technologies private limited',
    'Vds design private limited',
    'Evaprov cooling technologies private limited',
    'Urjayant engineering private limited',
    'Trishul engineering solutions private limited',
    'Cost engineering (india) private limited',
    'Groz engineering tools private limited',
    'Stefanini india private limited',
    'E travelvalue india private limited.',
    'Mfi infotech private limited',
    'Bushel technologies private limited',
    'Lally infotech private limited',
    'GREEN GEM ASSAYING LABORATORIES PRIVATE LIMITED',
    'Advance marketing and trading limited',
    'Viki computech private limited',
    'Richest technologies private limited',
    'Help on wheels private limited',
    'Rishabh communication private limited',
    'Assure quality management certification services private limited',
    'Krbta - unison consultancy private limited',
    'PSP FINTECH CONSULTANTS PRIVATE LIMITED',
    'Planet consultants private limited',
    'Devang management private limited',
    'Pyramids staffing solutions private limited',
    'Ikonet research and consultants private limited',
    'Taxmann publications private limited',
    'Svam engineering services private limited',
    'Ambrosia management solutions private limited',
    'Trustline insurance brokers private limited',
    'B2 advisory services private limited',
    'GLENDALE MARKETING SERVICES PRIVATE LIMITED',
    'Xtord designs private limited',
    'Ohm encon private limited',
    'Poysha oxygen private limited',
    'Eastern shipchandlers private limited',
    'Lawpath services india private limited',
    'Mera job india private limited',
    'Ala-mona properties pvt ltd',
    'Sunflame enterprises private limited',
    'True color laboratories private ltd',
    'Vikas consultants pvt ltd',
    'Trade and technology pvt ltd',
    'BHUMIKA REALTY PRIVATE LIMITED',
    'Karma lakelands private limited',
    'Tulip 3p media private limited',
    'Aditac solutions & services private limited',
    'Konkan visual communication private limited',
    'Jane and jones pvt ltd',
    'Wesco auto products (india) private limited',
    'Infy info solutions private limited',
    'The indure private limited',
    'Dr. measurements and control dynamics private limited',
    'Balaji wires private limited',
    'Shaktiman properties private limited',
    'Oberoi electronics private limited',
    'Agrawal drugs private limited',
    'Ratupun engineers pvt ltd',
    'Medini pumps pvt ltd',
    'National bearing company (jaipur) limited',
    'Rexon strips limited',
    'Unimet profiles private limited',
    'Seven hills opticommunication private limited',
    'Neo wires and allied products private limited',
    'Ht systems private limited',
    'Air ventil india private limited',
    'Prakash impex private limited',
    'SUEZ PROJECTS PRIVATE LIMITED',
    'Hari abrasives private limited',
    'Noida fabcon machines private limited',
    'EIGHTY JEWELLERS LIMITED',
    'TEX CORP PRIVATE LIMITED',
    'Vij engineering infrastructure private limited',
    'Nirmiti stampings private limited',
    'OSAW AGRO INDUSTRIES PRIVATE LIMITED',
    'Ferro foundries private limited',
    'Sreeram iron works pvt ltd',
    'Ashoka machine tools international pvt ltd',
    'Saras techparts private limited',
    'Dg corporation private limited',
    'Sudha forge private limited',
    'Welpro (india) private limited',
    'Kanishka india pvt ltd',
    'Unicac converters private limited',
    'Tech7 automation systems (india) private limited',
    'Emicon india private limited',
    'J d casting & forging pvt ltd',
    'Shashi cables ltd',
    'Gmt industries limited',
    'J.m. overseas india private limited',
    'Autoshell electromech private limited',
    'Sayantrik engineer india private limited',
    'Teknovation engineers pvt. ltd',
    'Tarway international pvt ltd',
    'Alikraft engineers private limited',
    'Super precision ball and rollers private limited',
    'Sk bearings private limited',
    'DOCKING & ENGG CO (VISHAKAPATNAM) PVT LTD',
    'ADVANCE WELDING INDIA PRIVATE LIMITED',
    'Isc tex-tech private limited',
    'Muralo chemicals and paints private limited',
    'Tarachandra engineering private limited',
    'Centroid engineers india private limited',
    'Benzear equipments india private limited',
    'Conair equipments private limited',
    'Srp automation private limited',
    'Vidarbha star industrial escorts p ltd',
    'Rdevis engineers private limited',
    'Coral equipments private limited',
    'Ferreterro hoists private limited',
    'Anu worles solutions private limited',
    'Hnl instruments and controls private limited.',
    'Utsav elctro-mech private limited',
    'Stanelec pvt ltd',
    'PETROGOLD HEAVY ENGINEERING LIMITED',
    'Gujarat stemmech pvt ltd',
    'Trinket engineering pvt ltd',
    'SRI VASAVI PIGMENTS PRIVATE LIMITED',
    'Trefileries wire india private limited',
    'Advance-tech controls private limited',
    'PRERANA ENGINEERS & CONSULTANTS PVT.LTD.',
    'VARA TECHNOLOGY PRIVATE LIMITED',
    'E lcc info.com limited',
    'Omso orient printing machines private limited',
    'Auckland marketing pvt ltd',
    'SHERA ENERGY LIMITED',
    'Medha servo drives pvt ltd',
    'Emco switchgears pvt ltd',
    'Minas e minerais de goa private limited',
    'Kalsi machinery company pvt ltd',
    'Spd autofab & engineers private limited',
    'ENPRO ENVIRO TECH AND ENGINEERS PRIVATE LIMITED',
    'Kyb-conmat private limited',
    'Swati arcon private limited',
    'POLYCAB INDIA LIMITED',
    'Saurashtra wire healds manufacturing co pvt ltd',
    'Deejay capacitors private limited',
    'Tube expansion equipments private limited',
    'Indica industries private limited',
    'Autolite manufacturing limited',
    'Ensto india private limited',
    'Men at work exports private limited',
    'Aakar machines private limited',
    'ASM THERMAL SPRAY PRIVATE LIMITED',
    'Susang mac private limited',
    'Radiant safeway private limited.',
    'Vishwa cnc technologies private limited',
    'Rolson equipments private limited',
    'KIMPLAS PIPING SYSTEMS PRIVATE LIMITED',
    'Seinumero nirman private limited',
    'EnergySolution Labs Private Limited',
    'Bel optronic devices limited',
    'Sigma power control systems private limited',
    'Labour craft private limited',
    'Nihon denkei india private limited',
    'Compton computers private limited',
    'Gujarat plug-in devices pvt ltd',
    'Citrus technologies private limited',
    'Mcc digital innovations private limited',
    'Arthron implants private limited',
    'Wizkid computers systems pvt ltd',
    'Jupiter forgings & steel private limited.',
    'Timeless infoteck private limited',
    'Systems and controls(sangli)pvt ltd',
    'Lawrence and mayo (india) private limited',
    'Sanjay diesel energy systems private limited',
    'Koncept automobiles private limited',
    'Super structures private limited',
    'QH TALBROS PRIVATE LIMITED',
    'Utkal automotive private limited',
    'Dalhousie holdings ltd',
    'Goldfish spaces private limited',
    'Kaino infra development private limited',
    'Arvind khaitan pvt ltd',
    'Masao electronics private limited',
    'Loadmaster securities private limited',
    'Black rain investments private limited',
    'Champion packaging industries pvt ltd',
    'Khetawat properties ltd',
    'TANDON HOUSING & CONSTRUCTIONS PRIVATE LIMITED',
    'SAMRIDHI BUILDMART PRIVATE LIMITED',
    'Silverado infratech private limited',
    'RAMESWARA HOMES & APARTMENTS PVT LTD',
    'Eagle tower pvt. ltd.',
    'LUXMI TOWNSHIP & HOLDINGS LIMITED',
    'Saltee infrastructure limited',
    'Elgin hotels pvt.ltd.',
    'Satvic projects pvt.ltd.',
    'S.roy realtors and investors private limited',
    'Supraja properties private limited',
    'Orangesky projects private limited',
    'SOWBARNIKA ENTERPRISES PRIVATE LIMITED',
    'Roysons engineers pvt ltd',
    'Rameswara projects limited',
    'Lush estates pvt ltd',
    'Sadabahar properties private limited',
    'Anumodan projects pvt ltd',
    'Shivangini builders pvt ltd',
    'Arpee builders & promoters pvt ltd',
    'Navashree estates pvt ltd',
    'Sukhsagar complexes pvt. ltd',
    'Esquire realtors private limited',
    'Evershine infradevelopers private limited',
    'Goodworth infracon private limited',
    'VV RESTAURANTS PRIVATE LIMITED',
    'S. r. town developers private limited',
    'Samak nature resorts private limited',
    'Kaparthy infotech private limited',
    'Pvk koramangala development private limited',
    'Nanak building concepts private limited',
    'Home & soul developers private limited',
    'Devon real estate and construction private limited',
    'Muskaan manor private limited',
    'Superview constructions private limited',
    'Buildwise housing developers private limited',
    'Somani housing private limited',
    'HEM ONLINE SECURITIES PRIVATE LIMITED',
    'Dewal reality private limited',
    'Ambience i.t. developers private limited',
    'Sakthi realty and infrastructure limited',
    'Zephyr projects private limited',
    'Abt foundation limited',
    'S. D. CONSTRUCTION & TOBACCO PRIVATE LIMITED',
    'Shree ganesh griha private limited',
    'Martin burn housing estate private limited',
    'Futureworld greenhomes private limited',
    'Aspire infratech private limited',
    'Pact buildtech india private limited',
    'Greentech it city private limited',
    'Rajmata realtors private limited',
    'Moonlight buildwell private limited',
    'Mother housing private limited',
    'Jfc developers private limited',
    'Aarpee infrarealty limited',
    'Desire sales private limited',
    'Shri vriddhi infraproperties private limited',
    'Purnasatya developers private limited',
    'Derby infrastructure private limited',
    'Avaneesh nirman private limited',
    'Avaneesh enclave private limited',
    'Avighna nirman private limited',
    'Aggarwal propmart private limited',
    'Maruti real estate pvt ltd',
    'Evos design living private limited',
    'Avighna complex private limited',
    'Anulekha builders private limited',
    'Navyug infra-dev private limited',
    'Carlton land developers pvt ltd',
    'Astra build tech private limited',
    'AMBIENCE CORPORATE TOWERS PRIVATE LIMITED',
    'Fusion buildtech private limited',
    'Sudeep projects private limited',
    'SAMRIDHI INFRA SQUARE PRIVATE LIMITED',
    'Zara buildcon private limited',
    'Rd devcon private limited',
    'Finevalue developers private limited',
    'North by north estates private limited',
    'Camden realty private limited',
    'Avaneesh aavas private limited',
    'Lavanya projects private limited',
    'Emerald highrise private limited',
    'Aamod villa private limited',
    'Aamod niwas private limited',
    'Shil technologies private limited',
    'Tatia chemical corporation private limited',
    'Arena superstructures private limited',
    'Cogniter technologies private limited',
    'OCUS SKYSCRAPERS REALTY PRIVATE LIMITED',
    'Ambience projects private limited',
    'Hyacinth projects private limited',
    'Ska estates private limited',
    'P.g. micro systems private limited',
    'Shivansh infra projects & techocrates private limited',
    'Sane green informatic private limited',
    'Tridex solutions private limited',
    'Horizon projects and infrastructure private limited',
    'EXTREME LABS INDIA PRIVATE LIMITED',
    'Mitbots systems private limited',
    'Esq management solutions india private limited',
    'BULLISH ENCLAVE & DEVELOPERS PVT LTD.',
    'Vatsal real estate private limited',
    'Suchita rentals private limited',
    'Pithambar farms private limited',
    'Malabar milk buds private limited',
    'Ponni hatcheries private limited',
    'Kayji real estate private limited.',
    'Cear farms pvt ltd',
    'SHROOT ELECTRIGNI PRIVATE LIMITED',
    'Gautam techagro india private limited',
    'PANAMA AGRICULTURE PRIVATE LIMITED',
    'ROYAL GREEN OIL REFINERIES PRIVATE LIMITED',
    'Shrusmi technologistics private limited',
    'CRYSTAL CROP PROTECTION LIMITED',
    'Sunshine agrisystem private limited',
    'Flora and animal resources management private limited',
    'Ascent agri-plantations private limited',
    'Derby dairy private limited',
    'Nath royal seeds limited',
    'Emerald seeds private limited',
    'Om india trading company private limited',
    'IMT TECHNOLOGIES PRIVATE LIMITED',
    'Bengani commodities private limited',
    'Sunny farms private limited',
    'Chimique (india) limited',
    'Merlin buildcon private limited',
    'ALAGENDRAN AUTO AGENCIES PRIVATE LIMITED',
    'Imeco limited',
    'Assam hydro- carbon & energy company limited',
    'SARUS EXPLORATION & PRODUCTION PRIVATE LIMITED',
    'K c pradhan mineral private limited',
    'FITZROY RESOURCES PRIVATE LIMITED',
    'Agrawal minerals (goa) private limited',
    'Poabs rock mines private limited',
    'Vpr mining infrastructure private limited',
    'Mulpuri aqua processors private limited',
    'Nasvi street foods private limited',
    'Paithan mega food park private limited',
    'Cosmic kitchen private limited',
    'Vinayak agrotech limited',
    'Sun oil co pvt ltd',
    'Osia dairy limited',
    'Ram dev international limited',
    'Skylark foods private limited',
    'Shalimar pellet feeds limited.',
    'Hira sweets & confectionary private limited',
    'Bubble teas private limited',
    'Saa vishnu bakers private limited',
    'Parrys sugar limited',
    'Aakash restaurant and foods private limited',
    'Shree jagdamba agrico exports private limited',
    'Amar tea private limited',
    'Trishul company private limited',
    'Mission row tea brokers pvt ltd',
    'Camaro marketing pvt ltd',
    'ORIGIN COFFEE PRIVATE LIMITED',
    'Swiss gourmessa foodbakers private limited',
    'Mahashian di hatti private limited',
    'Sterling groceries private limited',
    'Herbal isolates pvt ltd',
    'Ark biosciences private limited',
    'Navhari food products private limited',
    'INTERGROW BRANDS PRIVATE LIMITED',
    'Agribiotech industries limited',
    'Shivalik beverages private limited',
    'Muthu spinning mills private limited',
    'THE KADRI MILLS (CBE) PRIVATE LIMITED',
    'V thangavel and sons private limited',
    'Ellen industries private limited',
    'Fairy food products private limited',
    'CHANNDRIKA AGRO FOODS PRIVATE LIMITED',
    'Mohni woollens private limited',
    'Sharda spuntex private limited',
    'Net4nuts limited',
    'Sujata synthetics limited',
    'Oswal knitting and spinning industries limited',
    'DEWAR',
    'S SAARATHY ENTERPRISES PRIVATE LIMITED',
    'A.d.s. hitech polymers private limited',
    'Aghin agro food industries private limited',
    'Rdg enterprise private limited',
    'ARISHT INDUSTRIES PRIVATE LIMITED',
    'Portoftrust trading private limited',
    'Kapoor industries limited.',
    'Oriental furnishers pvt ltd',
    'Victory polyfoams private limited',
    'Sunheri texcraft private limited',
    'Malwa industries ltd',
    'Sfatec private limited',
    'Sambandam fabrics private limited',
    'M r decor private limited',
    'Shimna engineering pvt. ltd.',
    'TERRA FINANCIAL SERVICES PRIVATE LIMITED',
    'Bio jutex private limited',
    'Brothers coir mills private limited',
    'Srm spinners limited',
    'Roy apparels private limited',
    'PASUPATI BREEDING FARM PRIVATE LIMITED',
    'Jayant castors private limited',
    'Nidhi knitwears private limited',
    'Shyam resources india private limited',
    'Chowgule and company (salt) private limited',
    'Sri ram spinning mills ltd',
    'Dhruv polychem private limited',
    'Sbgoc textile private limited',
    'L affaire designs private limited',
    'O.c.fashion apparel private limited',
    'Orient craft brands limited',
    'O c crochets private limited',
    'Helix garments private limited',
    'Toptrack dresses private limited',
    'Csa clothex company private limited',
    'Sigma minerals limited',
    'Harkajas export private limited',
    'Subhlakshmi vanijya private limited',
    'SAINI DIESAL POWER SERVICE PRIVATE LIMITED',
    'Tvh consumer products private limited',
    'Amber commercial pvt ltd',
    'Homtek india pvt ltd',
    'Dipti cattle feed private limited',
    'VISHKUL ENTERPRISES PRIVATE LIMITED',
    'Prachi enterprises pvt ltd',
    'Glotech exim private limited',
    'Aagile business associates private limited',
    'Rosy commercial pvt.ltd.',
    'BARAGHARIA REALTORS PRIVATE LIMITED',
    'Mernill tie-up ltd',
    'Pyrotech workspace projects private limited',
    'Gold telecommunications india private limited',
    'August agents ltd',
    'Mayank merchants pvt ltd',
    'Off-shore india ltd',
    'Home trotter india private limited',
    'Bharat steel (chennai) private limited',
    'BLUE METALS COMPANY PRIVATE LIMITED',
    'RAJA TRADE & CREDIT PVT LTD',
    'Zzonm forgings private limited',
    'Basera commercial pvt ltd',
    'Anand tie-up pvt ltd',
    'Amrit tradelink pvt ltd',
    'Cross agencies private limited',
    'Lila furnishings private limited',
    'Exotic sales private limited',
    'Ask overseas private limited',
    'Jeet earthmovers private limited',
    'Magenta tradelink private limited',
    'Aakansha vintrade private limited',
    'Dyna creation private limited',
    'Rts exports private limited',
    'Instoremasters worldwide marketing private limited',
    'Vasi shums and co private limited',
    'Great pacific exports private limited',
    'MATCON EXPORT ENTERPRISES PRIVATE LIMITED',
    'J b m textiles private limited',
    'PRAKASH SOLAR INDUSTRIES PRIVATE LIMITED',
    'Global wool alliance private limited',
    'Flex exim private limited',
    'CHANDRAS',
    'S MACHINING INDIA PRIVATE LIMITED',
    'First dental training institute private limited',
    'Kriti event solutions private limited',
    'Pr & em candid communication private limited',
    'Institute of skill development and training private limited',
    'Club hibernia private limited',
    'Apropos professional educare private limited',
    'Academy of indian marketing professionals',
    'Seastar educare private limited',
    'REGENESYS INSTITUTE OF MANAGEMENT PRIVATE LIMITED',
    'Jdfs education private limited',
    'Bravo careers private limited',
    'Rumi education foundation',
    'SCHOOL SHOP PRIVATE LIMITED',
    'Able educare private limited',
    'Fsm education private limited',
    'B-cube consulting private limited',
    'Conscience business solutions private limited',
    'Sknl foundation',
    'Smiths medical india private limited',
    'Konark super speciality hospital private limited',
    'Slim n shine private limited',
    'Adamas clinical quality consulting private limited',
    'Zodhita health solutions private limited',
    'Index finlease services limited',
    'Vnc housing private limited',
    'Ravicab cables private limited',
    'Nandi economic corridor enterprises limited.',
    'Svan elastomer solutions private limited',
    'Precision rubber industries private limited',
    'Gujarat ion exchange and chemicals limited',
    'Scud marfin private limited',
    'INFINIUM PHARMACHEM LIMITED',
    'Octavius pharma private limited',
    'AUMGENE BIOSCIENCES PRIVATE LIMITED',
    'R.p. plastomers private limited',
    'Cd pharma india private limited',
    'Synnat pharma private limited',
    'Jatia cotton mills ltd',
    'Thaikkattu mooss vaidyaratnam oushadhasala private limited',
    'K.S. VARIER',
    'N',
    'S SHIPPING & LOGISTICS PRIVATE LIMITED',
    'EKAA ENGINEERS AND INFRASTRUCTURE PRIVATE LIMITED',
    'DLC FORWARDERS PRIVATE LIMITED',
    'Poona ranchi cargo movers private limited',
    'Icon freight and logistics private limited',
    'Waymark logistics india private limited',
    'Multiline freight services private limited',
    'New india maritime agencies private limited',
    'Matheran rope-way private limited',
    'Papazzz cafe private limited',
    'Global kitchens private limited',
    'Paramount restaurants private limited',
    'Angre hotels pvt ltd',
    'Prithvi hotels (gujarat) pvt ltd',
    'Chanakyapuri resorts private limited',
    'Compressor hardware store private limited',
    'Copper castle resorts pvt ltd',
    'Hotel niranjana private limited',
    'Golden star hotel and resorts private limited',
    'Hotel jaclyn private limited',
    'Nala hotels private limited',
    'Amr prime hospitality private limited',
    'Killa bhawan resorts private limited',
    'Basant hotels pvt ltd',
    'ZAHEER KHAN',
    'S DRESS LIMITED',
    'SHREE RESHAM TEXTILE MILLS PRIVATE LIMITED',
    'Perfect filaments limited',
    'Kaytee apparels private limited',
    'Sarnita compactors private limited',
    'ARMSTRONG TEXTILES PROCESSING PRIVATE LIMITED',
    'Elegance silks private limited',
    'Rkt lifestyle private limited',
    'Cotton country textiles private limited',
    'Seven hills fabrics private limited',
    'Jk fabtex industries private limited',
    'Nidra textiles private limited',
    'Fabbtex international private limited',
    'Qualiance international private limited',
    'Sunflower apparels private limited',
    'Seams fab (india) private limited',
    'Benaka clothing private limited',
    'Tip top fashions private limited',
    'Trylo industries private limited',
    'Oxemberg clothing private limited',
    'Palme fashions private limited',
    'Rupana silk mills private limited',
    'Althaf shoes private limited',
    'Bader leather india private limited',
    'Vascular therapeutics (india ) private limited',
    'ALLWIN MEDICAL DEVICES PRIVATE LIMITED',
    'Thulir tech solutions private limited',
    'Biolinx labsystems private limited',
    'Nortan electricals private limited',
    'Pioneer lifesciences enterprises private limited',
    'Formoplastic controls private limited',
    'Therelek equipments private limited',
    'VINSHEK PRIVATE LIMITED',
    'Sri vijayalakshmi automobiles private limited',
    'Transmodal services private limited',
    'Ts tech (mandal) private limited',
    'Nasa fiberglass private limited',
    'Koyama precision works india private limited',
    'Pratik hytech works private limited',
    'Ts interseats india private limited',
    'Vibgyor automotive private limited',
    'SIMAR PORT Private Limited',
    'Bansal ship breakers pvt ltd',
    'Toniy impex private limited',
    'Kheria autocomp limited',
    'Aranis business process services private limited',
    'Adviceamerica software development centre private limited',
    'Tescra software private limited',
    'Employee based software private limited',
    'EGDK INDIA PRIVATE LIMITED',
    'VERITEAM SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Zolipe solutions private limited',
    'Silk media technologies private limited',
    'Bizframe technologies private limited',
    'Ibs fintech india private limited',
    'Emax technologies private limited',
    'Breakwalls technologies private limited',
    'Ahana systems and solutions private limited',
    'Envac environmental technology private limited',
    'Bfi technologies private limited',
    'Centum technologies private limited',
    'Ic pro solutions private limited',
    'NEAR INDIA PRIVATE LIMITED',
    'NABERLY TECHNOLOGIES PRIVATE LIMITED',
    'Zunaa software private limited',
    'I4 communication private limited',
    'AIMSENRICH GLOBAL EDUCATION PRIVATE LIMITED',
    'Zentron labs private limited',
    'Mindwaytech consulting services private limited',
    'Nextorbit platforms and solutions private limited',
    'Prueba india software private limited',
    'Acemicromatic manufacturing intelligence technologies private limited',
    'Big sourcing technologies private limited',
    'Window west technologies private limited',
    'Swayantra solutions private limited',
    'Atoll solutions private limited',
    'Datadelve technologies private limited',
    'Ccs technologies private limited',
    'Itraitz it solutions private limited',
    'Zeta it innovations india private limited',
    'OPHIR VENTURES PRIVATE LIMITED',
    'Infobricks technology (india) private limited',
    'Aphelion software private limited',
    'Millennium business machines private limited',
    'Idbi intech limited',
    'Octane communications private limited',
    'C-net solutions (india) private limited',
    'CJK KNOWLEDGEWORKS GLOBAL INDIA PRIVATE LIMITED',
    'Iken solutions private limited',
    'Sharp i-tech solutions private limited',
    'INNOTERRA BIOSCIENCE PRIVATE LIMITED',
    'SPEEDGAZE TECHNOLOGIES SOLUTIONS PRIVATELIMITED',
    'Izel technologies private limited',
    'One network enterprises (india) private limited',
    'INTEGRICHAIN PRIVATE LIMITED',
    'PLUG2FIELD SOLUTIONS PRIVATE LIMITED',
    'South matrix computers private limited',
    'Vitp private limited',
    'COEMPT EDU TECK PRIVATE LIMITED',
    'Dhanush computer services private limited',
    'Gp infotech private limited',
    'Pilog india private limited',
    'Fin infocom private limited',
    'Synchrony international services private limited',
    'Gait view technophiles private limited',
    'Rebus soft-sys private limited',
    'Vagn info solutions private limited',
    'GRAMENER MANAGEMENT HOLDING PRIVATE LIMITED',
    'Tigeen solutions private limited',
    '247DIGITIZE SERVICES PRIVATE LIMITED',
    'Cosima consulting private limited',
    'Appsguru business it consulting private limited',
    'Saanvad ventures private limited',
    'Nuovo solutions private limited',
    'Ebazzar it solutions private limited',
    'Sunit infosol india private limited',
    'Xenovus software solutions india private limited',
    'Er techno solutions private limited',
    'Betawave solutions private limited',
    'Ellaar infotek solutions private limited',
    'Mobius knowledge services private limited',
    'Rv matrix software technologies private limited',
    'Expertus infrastructure private limited',
    'Il&fs tamil nadu power company limited',
    'Anubavam technologies private limited',
    'L&t thales technology services private limited',
    'Solarwinds india private limited',
    'Ticketgoose.com india private limited',
    'Virya infotech private limited',
    'Pm square soft services private limited',
    'Cal2cal (india) limited',
    'Greenwave technologies india private limited',
    'VIECHEMIE SKICORP TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Databazaar infinity info private limited',
    'Exonyms knowledge systems private limited',
    'Aseema softnet technologies private limited',
    'EIT SERVICES INDIA PRIVATE LIMITED',
    'Sharacs consultancy service private limited',
    'Chanakya international private limited',
    'Knowledge network (india) private limited',
    'Indeus life sciences private limited',
    'Corporate channels (india) pvt. ltd',
    'Precision biomed private limited',
    'Westcoast pharmaceutical works limited',
    'GENEI LABORATORIES PRIVATE LIMITED',
    'Jowat adhesives india private limited',
    'Suraj air (india) private limited',
    'Korten pharmaceuticals private limited',
    'Farmacross india private limited',
    'Srg herbal private limited',
    'Shingar cosmetics private limited',
    'Crown tapes private limited',
    'Techmat enterprises india p ltd',
    'Plastene polyfilms limited',
    'Polytech millennium (india) private limited',
    'Milestone plastics private limited',
    'Mmt polypacks private limited',
    'Swastik flexipack private limited',
    'Plastwel polymers india private limited',
    'Alliance oil field products private limited',
    'Inprocorp india private limited',
    'Plastene india limited',
    'Leitz tooling systems india private limited',
    'Venture instrumentation technologies private limited',
    'Jas aluplast private limited',
    'Nano polymers india private limited',
    'SHIVMIITH POLYMER PRIVATE LIMITED',
    'Act plast paints private limited',
    'Shamvik glasstech private limited',
    'Western thomson (india) ltd',
    'Duravit india private limited',
    'Piccolo mosaic limited',
    'Technotherma furnaces private limited',
    'Supertech engineering & trade pvt ltd',
    'Uncle ceramic private limited',
    'Samudra cements private limited',
    'Bangalore protech controls private limited',
    'Batuk mines & minerals private limited',
    'TATA STEEL TECHNICAL SERVICES LIMITED',
    'Bhushan steel (south) limited',
    'TATA STEEL SUPPORT SERVICES LIMITED',
    'Solar technocast private limited',
    'DESAI METALINKS LIMITED',
    'Emerson forge private limited',
    'Uttam galva ferous limited',
    'Bipsi blades and turners private limited',
    'Krishna sheet processors private limited',
    'DEVASHILPI ESTATE DEVELOPERS PRIVATE LIMITED',
    'Jaiambe forge engineers private limited',
    'Vipul bright steels private limited',
    'VIPUL ADVISORY SERVICES PRIVATE LIMITED',
    'S.v. aluext profile private limited',
    'Nagina steel & alloys private limited',
    'LOHMAN CASTINGS PVT LTD',
    'Zinco-lab pvt ltd',
    'Hope india diamond trading company private limited',
    'LOFTEN INDIA PRIVATE LIMITED',
    'Megatechs cold forgings private limited',
    'Ars infrasteel private limited',
    'Gayathri structural & roofing private limited',
    'Alpha security instruments (india) private limited',
    'Jfe shoji steel india private limited',
    'Paradise packaging private limited',
    'Asoka sky metals private limited',
    'Peco valves private limited',
    'Sumangal forgings pvt ltd',
    'RAREWALA STEELS & ALLOYS PRIVATE LIMITED',
    'Agraeta technik private limited',
    'M.s. tools and mfg company private limited',
    'George rao and company engg private limited',
    'Granges india private limited',
    'Spring dynamics private limited',
    'BASAR TACKS & MERCHANDISE PRIVATE LIMITED',
    'COVENTRY SPRINGS PRIVATE LIMITED',
    'Marlex appliances private limited',
    'Paul mueller india packaging solutions private limited',
    'Shree rope solutions private limited',
    'Nirvana hammocks private limited',
    'Hardy smith designs private limited',
    'Technosave products private limited',
    'Servotech india limited',
    'Resonance power systems private limited',
    'Shivalik auto engineering private limited',
    'Sai diesels private limited',
    'Cameron manufacturing (india) private limited',
    'G n a axles limited',
    'M k aircon systems private limited',
    'Yogi aircon private limited',
    'Aqua chill systems india private limited',
    'Fire cease out safety solutions limited',
    'Accuweigh automation and solutions private limited',
    'Peregrine technologies private limited',
    'Enggsol engineering india private limited',
    'Konark filters private limited',
    'Linktech engineering private limited',
    'Jain heavy industries private limited',
    'Trilochan technologies private limited',
    'FROLIC AND ROISTER PRIVATE LIMITED',
    'Amarketforce (india) private limited',
    'It action gujarat private limited',
    'Nutec infotech private limited',
    'Sufalam technologies private limited',
    'Savitriya technologies private limited',
    'VICPASS (INDIA) PRIVATE LIMITED',
    'E2m solutions private limited',
    'E2logy software services private limited',
    'Hotraco technologies india private limited',
    'Nobel software systems private limited.',
    'Sonim technologies (india) private limited',
    'Vinjey software systems private limited',
    'Mirafra software technologies private limited',
    'PAREXEL INTERNATIONAL INDIA SAFETY SERVICES PRIVATE LIMITED',
    'Ig infotech (india) private limited',
    'Bls software private limited',
    'Tatva networks private limited',
    'Innoversant solutions private limited',
    'Ei technologies private limited',
    'Fossilshale embedded technologies private limited',
    'Alethea communications technologies private limited',
    'ADVARRA INDIA PRIVATE LIMITED',
    'EVERGE SOFTWARE & TECHNOLOGY SERVICES PRIVATE LIMITED',
    'Streamline healthcare solutions (india) private limited',
    'Netapp india marketing and services private limited',
    'Manipal software & e-com private limited',
    'Nanobi data and analytics private limited',
    'Zarantech software private limited',
    'Aseuro technologies private limited',
    'It4bve consulting services private limited',
    'Commstor tech private limited',
    'Inops it solutions private limited',
    'Syncbyte innovations private limited',
    'Vunet systems private limited',
    'Srishti innovative computer systems private limited',
    'Reflections info systems private limited',
    'Negocios it solutions private limited',
    'Tutor comp infotech (india) private limited',
    'Aakit technologies private limited',
    'Indisoft consultancy services private limited',
    'G-TEC JAINX EDUCATION LIMITED',
    'Cdc global services (india) private limited',
    'Net biz systems private limited',
    'Physicians interactive india private limited',
    'Ulysses systems (india) private limited',
    'Paramatrix technologies private limited',
    'Tricom data processing private limited',
    'Creative it india private limited',
    'Techteam technologies private limited',
    'QUANTIPLY TECHNOLOGIES PRIVATE LIMITED',
    'Benelux software private limited',
    'Digital group infotech private limited',
    'Cadcamguru solutions private limited',
    'Sunrise computer software private limited',
    'Logical dna it solution private limited',
    'Saankhya technosystems private limited',
    'Om compusoft systems private limited',
    'Win information technology private limited',
    'Active brains technologies private limited',
    'Super cybertech park private limited',
    'IDEALOOM VENTURES PRIVATE LIMITED',
    'Iconma professional services and solutions private limited',
    'Nukg business solutions private limited',
    'Tektree software services private limited',
    'Logicplanet it services (india) private limited',
    'VALUERAJ ASSOCIATES PRIVATE LIMITED',
    'Neotech data solutions private limited',
    'Ojus software labs private limited',
    'Healthnet global limited',
    'Fortuity infotech private limited',
    'Voxvalley technologies private limited',
    'PROINF NETWORKS PRIVATE LIMITED',
    'ASTRIA LIFE PRIVATE LIMITED',
    'THALASSA ENTERPRISES PRIVATE LIMITED',
    'Mirabel technologies india private limited',
    'Ph technologies private limited',
    'Henceforth software technologies private limited',
    'Pc control systems (india) private limited',
    'Votary computer technologies private limited',
    'Madikonda it private limited',
    'Bigdata software solutions private limited',
    'B2b commerce private limited',
    'Omulus infotech private limited',
    'Tychon solutions private limited',
    'Oriental solutions private limited',
    'Axe bpo services private limited',
    'Kallos solutions private limited',
    'Aynara technology solutions private limited',
    'Quads prepress private limited',
    'Macs info solution india private limited',
    '365 media private limited',
    'V CREATE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Tecnova technologies private limited',
    'Dare infotech private limited',
    'Aspam petrochem private limited',
    'Psm energy private limited',
    'FABINO LIFE SCIENCES LIMITED',
    'Alkush industries private limited',
    'Windson chemical private limited',
    'Noble medichem private limited',
    'Himalaya terpenes private limited',
    'Pallav chemicals & solvents private limited',
    'J.r speciality chemicals private limited',
    'Sivira organiks private limited',
    'Keaum organics private limited',
    'Vannsh life sciences private limited',
    'Harsh geo chem private limited',
    'Unilink chemicals private limited',
    'Clov chem (india) private limited',
    'Rane rao reshamia laboratories private limited',
    'Munish industrial chemicals pvt ltd',
    'Praxair india private limited',
    'Ankit raj organo chemicals limited',
    'Anco india chemicals private limited',
    'Sterjet trading company private limited',
    'Crop life science limited',
    'GLOBAL ROAD TECHNOLOGY MANUFACTURING PRIVATE LIMITED',
    'Arbuda agrochemicals private limited',
    'KOPPERT SUSTAINABLE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Jotun india private limited',
    'IRIS PHARMACHEM (INDIA) PRIVATE LIMITED',
    'Nascent lifescience private limited',
    'Medreich life care limited',
    'Puneet laboratories private limited',
    'Kanad labs private limited',
    'J duncan healthcare private limited',
    'Pell tech health care private limited',
    'Lcgc radwag weighing solutions private limited',
    'Wyeth pharmaceuticals india private limited',
    'Sirak pharmaceuticals private limited',
    'Pole-star medichem private limited',
    'Sanjivni herbal care private limited',
    'Asahi modi materials private limited',
    'Rawji fine fragrances private limited',
    'Ankitraj expotrade private limited',
    'Vijay chemical industries private limited',
    'Global agrigenetics india private limited',
    'Fertin india private limited',
    'Teckbond laboratories private limited',
    'Jharkhand grind-chem private limited',
    'Quick turn consultancy solutions private limited',
    'PALAT SUPERMARKETS PRIVATE LIMITED',
    'Shmeet chem impex private limited',
    'Simond fibertech limited',
    'Fortune elastomers private limited',
    'Tilara polyplast private limited',
    'Sapana home products pvt ltd',
    'Shah packwell private limited',
    'Nirmal poly plast private limited',
    'Basar technomould private limited',
    'Excel vinyl coatings private limited',
    'Ansa polymers limited',
    'United contractors pvt ltd',
    'Nu-tech concrete products private limited.',
    'Value packaging industries private limited',
    'Aristoplast enterprises private limited',
    'Unp polyvalves (india) private limited',
    'Furus polychem private limited',
    'Gamma technoplast private limited',
    'SUNHILL CERAMIK PRIVATE LIMITED',
    'GURUVAANI FOUNDATION',
    'EUROPEM INDIA PRIVATE LIMITED',
    'YES GLOBE LOGISTICS PRIVATE LIMITED',
    'Ambience First Steps Private Limited',
    'MY COTTAGE INTERIOR & CONSTRUCTION PRIVATE LIMITED',
    'MockBank Learning Private Limited',
    'ONE NORTH CONSULTING (INDIA) PRIVATE LIMITED',
    'SHREE SHYAM CORPORATE SERVICES PRIVATE LIMITED',
    'Grassroots Social Enterprises Private Limited',
    'ALPHA MANTRA CONSULTING PRIVATE LIMITED',
    'PORT PAIR LOGISTICS INDIA PRIVATE LIMITED',
    'SLS Designs India Private Limited',
    'PAN EURASIAN TRADING HOUSE PRIVATE LIMITED',
    'VSR AERO ENGINEERING PRIVATE LIMITED',
    'PM 360 solutions Private Limited',
    'STAR BUSINESS INVESTMENT SERVICES LIMITED',
    'YOUNG EDSPLORER PRIVATE LIMITED',
    'CREATNET EDUCATION',
    'Geo Eco-Initiative India Private Limited',
    'JABALPUR TRADE CENTRE PRIVATE LIMITED',
    'ASHI JEWELLERY PRIVATE LIMITED',
    'DEVI ANUSUIYA VIDYA SANSTHAN',
    'NEOLUX CHEMICALS PRIVATE LIMITED',
    'ILS VENTURES PRIVATE LIMITED',
    'Indore Public School Private Limited',
    'AURO VISION INFOTECH AND MARKETING PRIVATE LIMITED',
    'PHELIA COMMODITIES PRIVATE LIMITED',
    'D.K. MODULAR FURNITURE PRIVATE LIMITED',
    'ACQUAINT MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'MEDILUX HEALTHCARE PRIVATE LIMITED',
    'MEDILUX DIAGNOSTICS PRIVATE LIMITED',
    'CARRYFAST LOGISTICS PRIVATE LIMITED',
    'SHREE ENGINEERS & CONTRACTORS PRIVATE LIMITED',
    'BANSAL BUILDERS AND PROJECTS PRIVATE LIMITED',
    'Stalwart Management Consultancy Services Private Limited',
    'CAREER ESSENTIALS TRAINING AND DEVELOPMENT SOLUTIONS PRIVATE LIMITED',
    'UNITED ENGINEERING INDUSTRIES PRIVATE LIMITED',
    'Tridecimal Information Technology Private Limited',
    'FYI FOODS PRIVATE LIMITED',
    'GEETA GLASSES (INDIA) PRIVATE LIMITED',
    'KALYAN HOLDINGS PRIVATE LIMITED',
    'KALMSTROM SOFTWARE PRIVATE LIMITED',
    'MDP INFRA (INDIA) PRIVATE LIMITED',
    'Colossal Tech Sol Infrastructure Private Limited',
    'UNIINFO TELECOM SERVICES LIMITED',
    'PRIME CAR PRIVATE LIMITED',
    'RECHARGE DIGITAL CONTENT PRIVATE LIMITED',
    'Steam Point Boilers & Heaters Private Limited',
    'GREENCODE BUSINESS SOFTWARE PRIVATE LIMITED',
    'EFFICACY INFORMATICS PRIVATE LIMITED',
    'LIFE CARE INFRASTRUCTURES INDIA LIMITED',
    'XCEL POLYMER PRODUCTS PRIVATE LIMITED',
    'Emorphis Software Technology Solutions Private Limited',
    'HYGEIA CLEANSE FACILITY SERVICES PRIVATE LIMITED',
    'ARIBA FOODS PRIVATE LIMITED',
    'WORLD HINDU ECONOMIC FORUM',
    'NEWTOWN BUILDTECH PRIVATE LIMITED',
    'BADRI VISHAL AGRO PRIVATE LIMITED',
    'MADHYA PRADESH TODAY MEDIA LIMITED',
    'FIRST SOURCE ENERGY INDIA PRIVATE LIMITED',
    'SANWER ROAD INDUSTRIAL COMMON EFFLUENT TREATEMENT PLANT COMPANY PRIVATE LIMITED',
    'SANDHU TRANSLOGISTICS INDIA PRIVATE LIMITED',
    'SRG ALUMINIUM PRIVATE LIMITED',
    'MIXER LABS IT SERVICES PRIVATE LIMITED',
    'Energy Solutions Private Limited',
    'ATHENA INFRATECH PRIVATE LIMITED',
    'GEE PEE HI TECH INDUSTRIES LIMITED',
    'PERPETUITY COMMERCIALS PRIVATE LIMITED',
    'THINKING BEANS ADVERTISING INDIA PRIVATE LIMITED',
    'FUTURE INFRAESTATES PRIVATE LIMITED',
    'MONEY CAPITALHEIGHT RESEARCH INVESTMENT ADVISERS PRIVATE LIMITED',
    'DAULAT RAM NREC LOCOMOTIVES PRIVATE LIMITED',
    'VEXL ENVIRON PROJECTS PRIVATE LIMITED',
    'PEHEL SOFTTECH PRIVATE LIMITED',
    'KHANNA BUILDCON PRIVATE LIMITED',
    'CHETARU WEB LINK PRIVATE LIMITED',
    'GLOBAL INSTITUTE OF MEDICAL SCIENCE & HEALTH CARE',
    'GTS TELECOM SERVICES(I) PRIVATE LIMITED',
    'KDS HOSPITALITY PRIVATE LIMITED',
    'HEAVEN TECHNO SYSTEM PRIVATE LIMITED',
    'Vibrant Realbuild Private Limited',
    'Great Family Commodities Private Limited',
    'INDORE HOT PROPERTIES INDIA PRIVATE LIMITED',
    'THE GREEN FIELD PHOSPHATES PRIVATE LIMITED',
    'SHREE VARDHAN WAREHOUSING INDIA PRIVATE LIMITED',
    'WEBRICKS INNOVATIONS PRIVATE LIMITED',
    'CapitalStars Financial Research Private Limited',
    'LIFE CARE WARE HOUSING PRIVATE LIMITED',
    'EMAX GLOBAL MEDIA PRIVATE LIMITED',
    'INHIBEO WATER SOLUTION AND TECHNOLOGIES PRIVATE LIMITED',
    'SRK DEVBUILD PRIVATE LIMITED',
    'JALWA INFRASTRUCTURES PRIVATE LIMITED',
    'DEEPA TEXTILES PRIVATE LIMITED',
    'MEDIEX HEALTHCARE PRIVATE LIMITED',
    'KRATI TEXTILE MILLS PRIVATE LIMITED',
    'RECHARGE TALENT SEARCH PRIVATE LIMITED',
    'SUPERCON REALITY PRIVATE LIMITED',
    'XTRANET BPO PRIVATE LIMITED',
    'SAFESPACE WAREHOUSING (INDIA) PRIVATE LIMITED',
    'BELIEF SQUARE CONSULTANCY PRIVATE LIMITED',
    'MAMLESHWAR AGRO FUEL PRIVATE LIMITED',
    'STARBRU TECHSYSTEMS PRIVATE LIMITED',
    'EION TRAVELCARE PRIVATE LIMITED',
    'CHOKSI TOXLAB PRIVATE LIMITED',
    'SANWARIYA PACKAGING PRIVATE LIMITED',
    'KIND & KARE DEVCON LIMITED',
    'Saibaba Agrilink Private Limited',
    'BRUCKE CONSULTING PRIVATE LIMITED',
    'RECONNECT ENERGY SOLUTIONS LIMITED',
    'HIWAKI PUMPS PRIVATE LIMITED',
    'PUNJAB JEWELS PRIVATE LIMITED',
    'RANVEER REALTY CONSULTANT PRIVATE LIMITED',
    'AADI PIPES PRIVATE LIMITED',
    'G D A PACKINFRA PRIVATE LIMITED',
    'SEOBEAM INFOTECH PRIVATE LIMITED',
    'FORESIGHT INFRATECH PRIVATE LIMITED',
    'ADITYA CUSTOM CLEARING PRIVATE LIMITED',
    'HTTPOOL DIGITAL PRIVATE LIMITED',
    'ARIHANT INSTITUTE OF FINANCIAL EDUCATION PRIVATE LIMITED',
    'REALTY GURU CONSULTANT PRIVATE LIMITED',
    'VEC CONSTRUCTIONS (INDIA) PRIVATE LIMITED',
    'BACCHUS INDUSTRIES PRIVATE LIMITED',
    'VEMA HOSPITALITY PRIVATE LIMITED',
    'PANDA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'KOCHHAR GLASS (INDIA) PRIVATE LIMITED',
    'JYOTI HEALTHCARE PRIVATE LIMITED',
    'LOKWANI SALES PRIVATE LIMITED',
    'GARIMA MOTORS PRIVATE LIMITED',
    'INDO MICRO NUTRIENTS PRIVATE LIMITED',
    'C.J.ONLINE PRIVATE LIMITED',
    'MCW HEALTHCARE PRIVATE LIMITED',
    'WIN FOCUS PRIVATE LIMITED',
    'EBUSINESS DOTCOM PRIVATE LIMITED',
    'CHARU AGROPLAST PRIVATE LIMITED',
    'IMPETUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'REALTOR BUILDCON PRIVATE LIMITED',
    'INFOCRATS WEB SOLUTIONS PRIVATE LIMITED',
    'ARCPL DEVELOPERS PRIVATE LIMITED',
    'SUPREME ROLLS AND SHEARS PRIVATE LIMITED',
    'BHAGAWATI COOLS PRIVATE LIMITED',
    'COMMANDER INDUSTRIES PRIVATE LIMITED',
    'NVS CONSULTANTS PRIVATE LIMITED',
    'BHARAT LIFESPACE PRIVATE LIMITED',
    'AKANKSHA SALES PROMOTERS (INDIA) PRIVATE LIMITED',
    'SUYOG SECURITIES PRIVATE LIMITED',
    'SURAJ IMPEX (INDIA) PRIVATE LIMITED',
    'TULSI AMRIT PRIVATE LIMITED',
    'AAKANKSHA DISTRIBUTORS PRIVATE LIMITED',
    'PRAGYA EQUIPMENTS PRIVATE LIMITED',
    'TRIVENI SPONGE IRON PRIVATE LIMITED',
    'INGENIOUS CONSULTANTS SERVICES (POWER AND TRANSPORTATION)P. LTD',
    'BETA INFOTECH LIMITED',
    'ZINC INTERNATIONAL INDIA PRIVATE LIMITED',
    'AG8 VENTURES LIMITED',
    'GBP COTTON PRIVATE LIMITED',
    'HEART CARE INSTITUTE AND RESEARCH CENTRE (INDORE)PVT LTD',
    'Indore AgriSystem Private Limited',
    'ACCRETION GLOBAL LIMITED',
    'ABHIKALP DESIGN STUDIO PRIVATE LIMITED',
    'A.N.K.SECURITIES PRIVATE LIMITED',
    'SHREYANS ENERGY PRIVATE LIMITED',
    'ARAYANNA TECHNOLEGAL SOLUTIONS PRIVATE LIMITED',
    'R.B.HOME APPLIANCES INDIA PRIVATE LIMITED',
    'CES INFRA INDIA PRIVATE LIMITED',
    'CHAHAT INFRASTRUCTURE PRIVATE LIMITED',
    'RAGHUNANDAN COMMODITIES PRIVATE LIMITED',
    'NEW GOLDEN BOARDING PRIVATE LIMITED',
    'MADHYA BHARAT PHOSPHATE PRIVATE LIMITED',
    'FENNY REAL ESTATE PRIVATE LIMITED',
    'ARIHANT FINANCIAL SERVICES LIMITED',
    'Century 21 Town Planners Private Limited',
    'KETI SANGAM INFRASTRUCTURE (INDIA) LIMITED',
    'LIGHT GUIDE OPTICS PRIVATE LIMITED',
    'HARSH TRANSPORT PRIVATE LIMITED',
    'ANJUSHREE HOTEL & RESORTS PRIVATE LIMITED',
    'SIGMA CHEMTRADE PRIVATE LIMITED',
    'ANAND METAL ENGINEERING PRIVATE LIMITED',
    'M.P. AGRO BRK ENERGY FOODS LIMITED',
    'QUANTUM URJA PRIVATE LIMITED',
    'TROPILITE FOODS PRIVATE LIMITED',
    'PRANJAL AGROTECH PRIVATE LIMITED',
    'PEGASUS CUSTOM HOUSE AGENCY PRIVATE LIMITED',
    'K. S. REAL ESTATE PRIVATE LIMITED',
    'DILIP BUILDCON LIMITED',
    'AAVANTIKA GAS LIMITED',
    'TESMO MOTORCAST PRIVATE LIMITED',
    'I MEDIA CORP LIMITED',
    'TEJAS AGROTECH PRIVATE LIMITED',
    'ANJALP AGROTECH PRIVATE LIMITED',
    'CITYWALA INFOTECH PRIVATE LIMITED',
    'DIGITAL MICRON ROTO PRINT PRIVATE LIMITED',
    'KAMAL COTSPIN PRIVATE LIMITED',
    'KALANTAR AGROTECH PRIVATE LIMITED',
    'SILVER REALTIES AND INFRASTRUCTURE PRIVATE LIMITED',
    'SYSTEMATIX INFOTECH PRIVATE LIMITED',
    'S.S. WEALTH CONSULTANTS PRIVATE LIMITED',
    'GLR PROPERTIES PRIVATE LIMITED',
    'TRISHUL TEXTRADE PRIVATE LIMITED',
    'BANSAL AGROTECH PRIVATE LIMITED',
    'VANI AUTOMOBILES PRIVATE LIMITED',
    'JABALPUR ENTERTAINMENT COMPLEXES PRIVATE LIMITED',
    'SOFTWIN TECHNOLOGIES PRIVATE LIMITED',
    'NIRMESH ENTERPRISES PRIVATE LIMITED',
    'DINDAYAL MALL MANAGEMENT PRIVATE LIMITED',
    'SEAES EDUCATION PRIVATE LIMITED',
    'CYBER INFRASTRUCTURE PRIVATE LIMITED',
    'LIFESPAN BIOTECH PRIVATE LIMITED',
    'HI TECH BUTTERFLY VALVES INDIA PRIVATE LIMITED',
    'ASHKOM MEDIA INDIA PRIVATE LIMITED',
    'SHRI CRUSHTONE MANUFACTURING COMPANY PRIVATE LIMITED',
    'KUSHAL POLYCOATS PRIVATE LIMITED',
    'ULTRATECH ENERGY LIMITED',
    'JAANHVI HOTELS PRIVATE LIMITED',
    'ZEBRA FASHION PRIVATE LIMITED',
    'AR INFRASTRUCTURE PRIVATE LIMITED',
    'GREEN STAR TECHNOLOGIES PRIVATE LIMITED',
    'COVETUS TECHNOLOGIES PRIVATE LIMITED',
    'SAJDHAJ MARRIAGE DECORATORS PRIVATE LIMITED',
    'AGARMIN COALWASHERY PRIVATE LIMITED',
    'TEREX INDUSTRIES PRIVATE LIMITED',
    'JAIDEEP ISPAT AND ALLOYS PRIVATE LIMITED',
    'PACKAGING SOLUTIONS PRIVATE LIMITED',
    'GAYATRI PEST MANAGEMENT PRIVATE LIMITED',
    'LBF PUBLICATIONS PRIVATE LIMITED',
    'MANIKARAN COMMERCIALS PRIVATE LIMITED',
    'S. K. JHA INFRASTRUCTURE PRIVATE LIMITED',
    'VACCICARE LIFE SCIENCES PRIVATE LIMITED',
    'STAR INDIA CONTAINER LINE PRIVATE LIMITED',
    'iGear Holdings Private Limited',
    'PATEL WEALTH ADVISORS PRIVATE LIMITED',
    'MAHAK CREATEX PRIVATE LIMITED',
    'REKART INNOVATIONS PRIVATE LIMITED',
    'Hazelknight Media & Entertainment Private Limited',
    'Ziva Lifestyle India Private Limited',
    'ALLIEDHUNT NETWORK PRIVATE LIMITED',
    'PHARCOS SPECIALITY PRIVATE LIMITED',
    'MOTORACCESS PRIVATE LIMITED',
    'S & S ROTATION SYSTEM SERVICES PRIVATE LIMITED',
    'INDIANIVESH FIRST BRIDGE FUND MANAGERS PRIVATE LIMITED',
    'UGAM EDUCATION FOUNDATION',
    'COSMIC DIGITAL MEDIA PRIVATE LIMITED',
    'PICASSO FLEXIBLES LIMITED',
    'LOOKMYTICKET TOURS AND TRAVELS PRIVATE LIMITED',
    'SYNPRO SYSTEMS PRIVATE LIMITED',
    'Nihit Logistics Park Private Limited',
    'JOBBY ENTERPRISES PRIVATE LIMITED',
    'STEELICON TECHNOLOGIES PRIVATE LIMITED',
    'BURMAN LABORATORIES PRIVATE LIMITED',
    'Pragati Schutzen Private Limited',
    'SMARTECH SAFETY SOLUTIONS PRIVATE LIMITED',
    'BANMORE FOAM PVT LTD',
    'PECO PROJECTS PRIVATE LIMITED',
    'Ghatge Academy of Technology & Science Private Limited',
    'Leadadroit Services Private Limited',
    'KRESCENT SOFT-SKILLS PRIVATE LIMITED',
    'UJAAS E AUTO PRIVATE LIMITED',
    'BELL FIRE ENGINEERING PVT. LTD',
    'ASEPCO SOLUTIONS PRIVATE LIMITED',
    'LIFESAVING FEDERATION OF INDIA',
    'MALWA WHEAT PRODUCTS PRIVATE LIMITED',
    'OCTANE TECHNOLOGIES PRIVATE LIMITED',
    'SHENOYS INFRA MART PRIVATE LIMITED',
    'Diaspark Infotech Private Limited',
    'SANCHI CHEMICALS PVT LTD.',
    'MATSON ACMEPLAST PVT LTD.',
    'TeamPlus Staffing Solution Private Limited',
    'NVIPANI TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'BAL CORPORATE SERVICES PRIVATE LIMITED (OPC)',
    'IMAGINEST HOME INTERIORS PRIVATE LIMITED',
    'SolaireGen Energy Private Limited',
    'AAA FUN-N-FOOD PRIVATE LIMITED',
    'HOTEL SONALI PVT LTD.',
    'SOCRUS PHARMACEUTICALS LIMITED',
    'CRENOVATIVE IDEAS PRIVATE LIMITED',
    'VISHAL ELECTRICALS COMPANY PVT LTD.',
    'EMKAY AUTO (INDORE) PRIVATE LIMITED',
    'DIGITAL MARKETING SYSTEMS PVT. LTD.',
    'PRESTIGE CHERITABLE FOUNDATION',
    'GAGAN GASES LIMITED.',
    'H D WIRE PRIVATE LIMITED',
    'RAJ PIONEER LABORATORIES INDIA PRIVATE LIMITED',
    'PATWA ABHIKARAN RATLAM PVT. LTD.',
    'HIRALAL NATHULAL CHARITABLE ASSOCIATION',
    'M.P. OVERHEAD LINES PVT. LTD.',
    'RUPAK CONSULTANTS PRIVATE LIMITED',
    'PRISM MARKETING PVT LTD',
    'KAILA DEVI PUBLICATIONS PRIVATE LIMITED',
    'SRIJAN ENERGY SYSTEMS PRIVATE LIMITED',
    'SONALI AGRO PRIVATE LIMITED',
    'SPACE RUBBERS PRIVATE LIMITED',
    'EMESA INDIA ELEVATOR COMPONENTS PRIVATE LIMITED',
    'ITL INDUSTRIES LIMITED',
    'Ascent India Foundation',
    'GALACTICO CORPORATE SERVICES LIMITED',
    'TWISTED ENTERTAINMENT (M) PRIVATE LIMITED',
    'GFL FINANCIALS INDIA LIMITED',
    'DINDAYAL ENTERPRISES PVT LTD',
    'ERAWAT PHARMA LIMITED',
    'PUSHPAK FINCON PVT LTD',
    'J.M.CHEMICALS PRIVATE LIMITED',
    'JABALPUR MOTORS LIMITED',
    'ESPIC CONSULTING PRIVATE LIMITED',
    'LOHAKRATI ENGINEERS PVT LTD',
    'INTER METAL TRADE LIMITED',
    'PANTH INFINITY LIMITED',
    'HARDEO DISTILLERIES PVT LTD',
    'CONVENIENT HOSPITALS LIMITED',
    'KEHEMS SOURJA PRIVATE LIMITED',
    'SHREE MAHESHWAR HYDEL POWER CORPORATION LIMITED',
    'KHANDELA SECURITIES PRIVATE LIMITED',
    'SAN INDUSTRIES PVT LTD',
    'SANCHI ORGANICS PVT LTD',
    'INEL PHARMACEUTICAL SYSTEMS PRIVATE LIMITED',
    'MARAL OVERSEAS LIMITED',
    'ABSENTIA VIRTUAL REALITY PRIVATE LIMITED',
    'CROWN HORTICULTURE PRIVATE LIMITED',
    'SITEC BIOSCIENCES PRIVATE LIMITED',
    'KRISH MAHI LOGISTIC PRIVATE LIMITED',
    'M C W PHARMA PVT LTD',
    'PERFECT TECH-AIDS PVT LTD',
    'HOTEL SOFITEL PVT LTD',
    'INDUSTRIAL FILTERS & FABRICS PRIVATE LIMITED',
    'HOTLINE TELETUBE AND COMPONENTS LIMITED',
    'GARLICO INDUSTRIES LIMITED',
    'VEEMA HOLDINGS PVT LTD',
    'SWIFT INTERMEDIA CONVERGENCE Private Limited',
    'SAI MACHINE TOOLS PVT LTD',
    'FANCY TEX GLOBAL PRIVATE LIMITED',
    'PURPLE FOCUS PRIVATE LIMITED',
    'JHAVERI INFRAPROJECTS PRIVATE LIMITED',
    'PANCHSHEEL ORGANICS LIMITED',
    'Skeleton Consultants Private Limited',
    'GREENKO OMC OORJA (NORTH) PRIVATE LIMITED',
    'Premium Lifestyle and Fashion India Private Limited',
    'STRATISTICS MARKET RESEARCH CONSULTING PRIVATE LIMITED',
    'Annomap Technologies Private Limited',
    'ARIHANT MAXSELL TECHNOLOGIES PRIVATE LIMITED',
    'IFIXTECHGLOBAL PRIVATE LIMITED',
    'JERRY JOHN POWERS PRIVATE LIMITED',
    'VALLUVAR KUZHUMAM PRIVATE LIMITED',
    'ABODE INHERITANCE PRIVATE LIMITED',
    'TECKNOLOGICS WEB ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED',
    'NELLAI JJ CHIT FUNDS PRIVATE LIMITED',
    'SATTVA PROPERTIES AND INFRASTRUCTURE PRIVATE LIMITED',
    'RAJEEV HOSPITAL PRIVATE LIMITED',
    'ROBOTEK BUILDCON PRIVATE LIMITED',
    'SKILLCRAT CONSULTANCY SERVICES PRIVATE LIMITED',
    'PROLYSI SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'ICE WEAR CREATION PRIVATE LIMITED',
    'Aardhra Builders Private Limited',
    'HETHI BUSINESS SERVICES PRIVATE LIMITED',
    'TRIAGRO COMMODITIES TRADING PRIVATE LIMITED',
    'IONTEL NETWORKS PRIVATE LIMITED',
    'FEATHERLITE BUILDCON PRIVATE LIMITED',
    'VOGO AUTOMOTIVE PRIVATE LIMITED',
    'MAGAZINE PACKAGING INDUSTRIES PRIVATE LIMITED',
    'SANSCO TECHNOLOGIES PRIVATE LIMITED',
    'SKP KNOWLEDGE SERVICES PRIVATE LIMITED',
    'AssessMachine Technologies Private Limited',
    'CEPRO POLYMERS PRIVATE LIMITED',
    'Talent Rover India Private Limited',
    'PERIGORD PREMEDIA (INDIA) PRIVATE LIMITED',
    'DECCAN BIOLIFE ENTERPRISES PRIVATE LIMITED',
    'Efocus Tekiknow services India Private Limited',
    'A.S. INFRASTRUCTURE AND WAREHOUSING PRIVATE LIMITED',
    'EQuad Engineering Services Private Limited',
    'ABRA INDUSTRIES PRIVATE LIMITED',
    'MITRAKSHA TECHNOLOGIES PRIVATE LIMITED',
    'K P R MEDIA PRIVATE LIMITED',
    'INDRANI INVESTMENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'SITICS TECHNOLOGIES PRIVATE LIMITED',
    'KRISHANG INFRASTRUCTURE PRIVATE LIMITED',
    'PS CAMSHAFTS PRIVATE LIMITED',
    'Expanse Hotels and Resorts Private Limited',
    'CPS LOGISTICS INDIA PRIVATE LIMITED',
    'Red Rose Buildcon Private Limited',
    'Netlife Infosolutions Private Limited',
    'TRI SOLAR PRIVATE LIMITED',
    'Limitless Coaching Private Limited',
    'COUCH COMMERCE PRIVATE LIMITED',
    'COHERENT INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED',
    'Ethika Insurance Broking Private Limited',
    'WHITE CLOUD INFOTECH PRIVATE LIMITED',
    'TALENTSERV SPORTS PRIVATE LIMITED',
    'ASIAN MOTHER AND CHILD HEALTH CARE PRIVATE LIMITED',
    'SULTANPURE TEXTILE MILLS PRIVATE LIMITED',
    'Ayur Valley Healthcare Private Limited',
    'ADITSA HEALTHCARE INDIA PRIVATE LIMITED',
    'Sharda Infrabuild Private Limited',
    'JAYA LAXMI FREIGHT FORWARDERS PRIVATE LIMITED',
    'EFFULGENCE TRADING AND SERVICES PRIVATE LIMITED',
    'BERGWERFF ORGANIC INDIA PRIVATE LIMITED',
    'ALLIED MINERALS INDUSTRIES PRIVATE LIMITED',
    'B.R.GOYAL INFRASTRUCTURE LIMITED',
    'WHITE CAPITAL MANAGEMENT CONSULTANTS LIMITED',
    'DiabetOmics Medical private Limited',
    'Anupam Fuels Private Limited',
    'WERTWALL CONSULTING PRIVATE LIMITED',
    'NARMADA TRIDEV HEALTHCARE AND SERVICES PRIVATE LIMITED',
    'TRANSFLEX CONVEYORS PRIVATE LIMITED',
    'BRAINCHAMBER POLYSACKS PRIVATE LIMITED',
    'S CUBE SOLUTIONS PRIVATE LIMITED',
    'JINAN WELLNESS PRIVATE LIMITED',
    'AWZPACT TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'RINI LIFE SCIENCE PRIVATE LIMITED',
    'Citilife Realty Private Limited',
    'BUMBERRY BABY PRODUCTS PRIVATE LIMITED',
    'GAJ TRANSPORT PRIVATE LIMITED',
    'CITI Solutions Warehousing & Distribution Private Limited',
    'CEMCON CONCRETE INDIA PRIVATE LIMITED',
    'Godrej Prakriti Facilities Private Limited',
    'Verbat Technologies (INDIA) Private Limited',
    'MASTERMIND MONEY SOLUTIONS PRIVATE LIMITED',
    'Quadtri Technologies Private Limited',
    'ASAIES AUTOMATION PRIVATE LIMITED',
    'AEC TRAVEL AND LEISURE SOLUTIONS PRIVATE LIMITED',
    'Rhino Nuts & Bolts Private Limited',
    'ROHTASH MARKETING PRIVATE LIMITED',
    'JIVAP ADVISORS PRIVATE LIMITED',
    'FIRST STEP ONLINE PRIVATE LIMITED',
    'Jetmint Distribution Private Limited',
    'TJ CAPITAL ADVISORY SERVICES PRIVATE LIMITED',
    'CODEXAR PRIVATE LIMITED',
    'GREENIVA RECYCLER PRIVATE LIMITED',
    'SAUDAGAR AGRO INDUSTRIES PRIVATE LIMITED (OPC)',
    'FIZZIBLE TECH PRIVATE LIMITED',
    'Pentagon India Retail Private Limited',
    'Vebbler Technologies Private Limited',
    'VIMAAN AEROSPACE PRIVATE LIMITED',
    'CALL ME INFORMATION SERVICES PRIVATE LIMITED',
    'SCIATIVE SOLUTIONS PRIVATE LIMITED',
    'VIVA INFOCOM PRIVATE LIMITED',
    'HINDUSTHAN MUSIC PUBLISHING PRIVATE LIMITED',
    'SPACENET ENTERPRISES INDIA LIMITED',
    'ZOOM INDUSTRIAL SERVICES LTD',
    'RAMKY INFRASTRUCTURE LIMITED',
    'SANDHYA ENVIRONS (INDIA) LTD,',
    'Onesource Ideas Venture Limited',
    'AMRUTHAVAHINI AGRO TECH PLANTATIONS PRIVATE LIMITED',
    'OC SALES PVT.LTD.',
    'NEO SEEDS INDIA Private Limited',
    'THE KOHINOOR TEA COMPANY LIMITED',
    'AKHIVI TEA PLANTATIONS AND AGRO INDUSTRIES LTD.',
    'SOUTHERN ONLINE BIO TECHNOLOGIES LIMITED',
    'AXORA RESOURCES LIMITED',
    'JOINTECA EDUCATION SOLUTIONS LIMITED',
    'KUMARAGIRI SPINNERSS Private Limited',
    'SOFTSOL INDIA LIMITED',
    'K P TRADING CO PVT LTD',
    'TOPSUN RIM IRON ORE INDUSTRIES PRIVATE LIMITED',
    'VILLAGE EXPORTS PRIVATE LIMITED',
    'Rockwool India Private Limited',
    'V.G.N. TRADING PRIVATE LIMITED',
    'BK SYSTEMS PRIVATE LIMITED',
    'AYUSHMAN MERCHANTS PRIVATE LIMITED',
    'S.V.G. GRANITES Private Limited',
    'RAJDARBAR REAL ESTATE PRIVATE LIMITED',
    'SABNAM EDIBLE OILS LIMITED',
    'FREEZING PRODUCTS PRIVATE LIMITED',
    'VIJAY-SHREE IMPEX PVT LTD',
    'GENUS INNOVATION LIMITED',
    'PENGUIN DISTRIBUTERS PRIVATE LIMITED',
    'ORIANA AGRO INFRA LIMITED',
    'DIVYAR GARMENTS INDIA Private Limited',
    'MULTIWAY TEXTILES PRIVATE LIMITED',
    'FACIT VYAPAAR PVT.LTD.',
    'SHITAL COMMERCIAL LTD',
    'CHITRAKOOT MERCHANDISE PVT LTD',
    'APARNA ENTERPRISES LIMITED',
    'Terex India Private Limited',
    'SILVERSON INFRASTRUCTURE LIMITED',
    'ASCON INFRASTRUCTURE (INDIA) Limited',
    'SUNRIPE AGRO PRODUCTS LIMITED',
    'ONEUP PLANTATIONS PRIVATE LIMITED',
    'SUN JUTE PRESS PVT LTD',
    'RAPGROW PLANTERS PRIVATE LIMITED',
    'World Star Bag Private Limited',
    'SOMANY IMPRESA LIMITED',
    'BLJ VYAPAAR PRIVATE LIMITED',
    'PRIORITY DEALER PRIVATE LIMITED',
    'CHITRAKOOT TIE-UP PRIVATE LIMITED',
    'TRADEX Private Limited',
    'ACCESS INTRA NETWORK MARKETING PRIVATE LIMITED',
    'HONESTY VINTRADE PRIVATE LIMITED',
    'ADSENSORS (INDIA) PRIVATE LIMITED',
    'S.V.HI-TECH BEARING (INDIA) PRIVATE LIMITED',
    'KRISHNA INSTITUTE OF MEDICAL SCIENCES LIMITED',
    'DELIGHTZ STAYCATION PRIVATE LIMITED',
    'KANYA RESORTS PRIVATE LIMITED',
    'JITF INFRALOGISTICS LIMITED',
    'ADANI CONTAINER MANUFACTURING LIMITED',
    'JITF COMMODITY TRADEX LIMITED',
    'GVK AIRPORT DEVELOPERS Limited',
    'B.T.CARRIERS INDIA PRIVATE LIMITED',
    'INDEV IN TIME AIR CARGO SERVICES PRIVATE LIMITED',
    'MUHANA COLD STORAGE AND ICE FACTORY PRIVATE LIMITED',
    'CGR COLLATERAL MANAGEMENT Limited',
    'OMKAR CARRIERS & MOVERS PRIVATE LIMITED',
    'INDEV SHIPPING SERVICES PRIVATE LIMITED',
    'MATRIMONY.COM Limited',
    'M B FREIGHT MOVERS PVT LTD',
    'INDIA DOMAIN WEB SERVICES PRIVATE LIMITED',
    'THE MADRAS DIOCESAN TRUST ASSOCIATION',
    'ARTH MICRO FINANCE PRIVATE LIMITED',
    'RAVIKAANTH PORTFOLIO SERVICES PRIVATE LIMITED',
    'ARIS CAPITAL PRIVATE LIMITED',
    'NAMDEV FINVEST PRIVATE LIMITED',
    'VENKATESWARA FINANCIERS HYDERABAD PRIVATE LIMITED',
    'VAISHNAVI BIO TECH INTERNATIONAL LIMITED',
    'MEDINOVA DIAGNOSTIC SERVICES LIMITED',
    'S K M ANIMAL FEEDS AND FOODS (INDIA) Private Limited',
    'GEMM ECONOMIC ZONES PRIVATE LIMITED',
    'AL-FOZAN MEATEX EXPORT PRIVATE LIMITED',
    'BRIGHT CHANCE STEEL PRIVATE LIMITED',
    'BRAND ALLOYS Private Limited',
    'YES LOTUS PRIVATE LIMITED',
    'MEWAR MARBLES LIMITED',
    'NVR FOOD PRODUCTS PRIVATE LIMITED',
    'BHAGIRATHI BARAF SAMITY PVT LTD',
    'SALASAR BEVERAGES PRIVATE LIMITED',
    'RAJDARBAR PAN MASALA PRIVATE LIMITED',
    'K K P SPINNING MILLS Private Limited',
    'PALLAVA TEXTILES PRIVATE LIMITED',
    'VSM WEAVESS INDIA PRIVATE LIMITED',
    'K K P TEXTILES Private Limited',
    'SHIVGYAN DEVELOPERS PRIVATE LIMITED',
    'OPTOMA PROJECTORS INDIA PRIVATE LIMITED',
    'RAMJI GOPALJI PVT LTD',
    'SHREE SANGHVI MILLS PRIVATE LIMITED',
    'K.SCHUBERT FIBER WORLD PRIVATE LIMITED',
    'PRABHA MERCANTILE COMPANY LIMITED',
    'SWASTIKA WOOLLEN INDUSTRIES PRIVATE LIMITED',
    'S.J.R. AUTO FINANCIERS PRIVATE LIMITED',
    'NEWS NATION NETWORK PRIVATE LIMITED',
    'NEWSPRINT PACKAGING INDIA PRIVATE LIMITED',
    'Newt Global India Private Limited',
    'PRE-FLIGHT AVIATION SERVICES PRIVATE LIMITED',
    'NEXGEN EXHIBITIONS PRIVATE LIMITED',
    'PRODUCT REACH PRIVATE LIMITED',
    'PURPLEUNIT DESIGNS PRIVATE LIMITED',
    'NetImpact Solutions Private Limited',
    'Network for Quality Education Foundation',
    'NEURAL DEVELOPERS PRIVATE LIMITED',
    'NIABI BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'NIAGARA HOTELS AND BUILDERS PRIVATE LIMITED',
    'NEW AGE INSTRUMENTS AND MATERIALS PRIVATE LIMITED',
    'PASHMINA HOLDINGS LIMITED',
    'NEW AGE INTERNATIONAL PRIVATE LIMITED',
    'ZIM LABORATORIES LIMITED.',
    'NEW AGE MACHINES AND INSTRUMENTS PRIVATE LIMITED',
    'RAJESH ENGINEERING COMPANY PRIVATE LIMITED',
    'NEW DELHI FOODS AND RECREATIONS PRIVATE LIMITED',
    'NEW DELHI YOUNG MEN',
    's Sohn India Private Limited',
    'FORTUNE GSJ REALTRADE PRIVATE LIMITED',
    'First Data Development Private Limited',
    'FOS DESIGNS & SERVICES PRIVATE LIMITED',
    'FRITZMEIER MOTHERSON CABIN ENGINEERING Private Limited',
    'FRIULAIR INDIA PRIVATE LIMITED',
    'FOUNDATION TO EDUCATE GIRLS GLOBALLY',
    'FOX DETECTIVES AND SECURITY SOLUTIONS PRIVATE LIMITED',
    'FRAGRANCE FINANCE AND INVESTMENT PRIVATE LIMITED',
    'FORSIGHT HOUSING AND CONSTRUCTIONS PRIVATE LIMITED',
    'FORT COCHIN HOSPITALITY SERVICES PRIVATE LIMITED',
    'FORTE FINANCIAL SERVICES PRIVATE LIMITED',
    'Fortum India Private Limited',
    'FRIENDS HOSPITALITY SERVICES PRIVATE LIMITED',
    'FRIENDSHIPTIME.COM PRIVATE LIMITED',
    'NHK SPRING INDIA LIMITED',
    'Frontfoot Sports Management Private Limited',
    'PIONEER MACHINERY AND STRUCTURES PRIVATE LIMITED',
    'FLORENCE HOTEL PRIVATE LIMITED',
    'FINSTEM INDIA PRIVATE LIMITED',
    'FUTURE KIDS PUBLICATIONS PRIVATE LIMITED',
    'FRANCIS WACZIARG AGENCIES PRIVATE LIMITED',
    'FUTUROME Constructions Private Limited',
    'G C COSMETICS PRIVATE LIMITED',
    'Franklin Electric India Private Limited',
    'FIOS DATA CHECK ASIA PRIVATE LIMITED',
    'FLOVEL TACKE PRIVATE LIMITED',
    'FLURRY FOODS PRIVATE LIMITED',
    'FRESH AIR FARMS PRIVATE LIMITED',
    'Friction Metal Fibres ( India ) Private Limited',
    'FRIENDS BUILDERS AND CONTRACTORS PRIVATE LIMITED',
    'FGR LOGISTICS PRIVATE LIMITED',
    'G N TIJARAT CRAFTS INTERNATIONAL LIMITED',
    'G R ESTATES PRIVATE LIMITED',
    'G S B FOOTWEAR PRIVATE LIMITED',
    'NAGATA INDIA PRIVATE LIMITED',
    'LALIT MINING IMPEX PRIVATE LIMITED',
    'G.D.GOENKA INDIA LIMITED',
    'FUTURAGE CORPORATE SOLUTIONS PRIVATE LIMITED',
    'FULCRUM MARKETING PRIVATE LIMITED',
    'GABLES INFRASTRUCTURE PRIVATE LIMITED',
    'POWERGRID Warora Transmission Limited',
    'POWERGRID Parli Transmission Limited',
    'GADGET BUILDERS LIMITED',
    'GAGAN BUILDTECH LIMITED',
    'GAGAR HOLDINGS LIMITED',
    'GAIETY BUILDCON PRIVATE LIMITED',
    'GAIETY HOUSING AND LAND DEVELOPMENT PRIVATE LIMITED',
    'Fulki Communications Private Limited',
    'FULL CIRCLE PUBLISHING PRIVATE LIMITED',
    'G.KUMAR ELECTRO PRIVATE LIMITED',
    'FUTURESOFT SOLUTIONS PRIVATE LIMITED',
    'FULL SLEEVES TECHNOLOGIES PRIVATE LIMITED',
    'ACME Cleantech Solutions Private Limited',
    'Fundron Fintech Services Private Limited',
    'Furniture & Interior Rental Private Limited',
    'FURUKAWA SANGYO KAISHA INDIA PRIVATE LIMITED',
    'DEGANIA MEDICAL DEVICES PRIVATE LIMITED',
    'G. S. P BUILDWELL PRIVATE LIMITED',
    'Yusen Logistics (India) Private Limited',
    'CONSULTING ENGINEERING SERVICES (INDIA) PRIVATE LIMITED',
    'KHANNA PAPER MILLS LIMITED',
    'BTL Holding Company Limited',
    'ACTION CONSTRUCTION EQUIPMENT LIMITED',
    'G. S. P. TEXTILES PRIVATE LIMITED',
    'VATIKA LIMITED',
    'STAR FINVEST PRIVATE LIMITED',
    'HAMP PROPERTIES PRIVATE LIMITED',
    'Bucher Hydraulics Private Limited',
    'AESTHETIC LIVING MERCHANTS PRIVATE LIMITED',
    'Gharonda Assotech Projects Private Limited',
    'GOGIA COMMODITY TRADING PRIVATE LIMITED',
    'RANJIT KRISHNA PROPERTIES PRIVATE LIMITED',
    'MERITECH SOFTWARE PRIVATE LIMITED',
    'G.S. AND CO. PRIVATE LIMITED',
    'G.S.P. POWER SYSTEMS PRIVATE LIMITED',
    'FORTIS HOSPOTEL LIMITED',
    'DAIFUKU INDIA PRIVATE LIMITED',
    'GAINFUL DEVELOPMENTS PRIVATE LIMITED',
    'GENESIS COLORS LIMITED',
    'GALA ENERGY PRIVATE LIMITED',
    'GALACTIC PROJECTS PRIVATE LIMITED',
    'GALAXY DWELLERS PRIVATE LIMITED',
    'LAANS PORTFOLIOS PRIVATE LIMITED',
    'ZUARI MAROC PHOSPHATES Private Limited',
    'G M S AUTOMOBILES PRIVATE LIMITED',
    'G N G AUTO AIDS PRIVATE LIMITED',
    'G N N PRAKASHAN PRIVATE LIMITED',
    'GAMMA PIZZAKRAFT (OVERSEAS) PRIVATE LIMITED',
    'GAMMA PIZZAKRAFT PRIVATE LIMITED',
    'DESIGN DYNAMICS INDIA PRIVATE LIMITED',
    'GANGA OVERSEAS PRIVATE LIMITED',
    'GANGA PROJECTS PRIVATE LIMITED',
    'ASTRA FASHIONS PRIVATE LIMITED',
    'TORRINS ANTHEM PRIVATE LIMITED',
    'Maruichi Kuma Steel Tube Private Limited',
    'VSI SECURITY PRIVATE LIMITED',
    'PREMAS BIOTECH PRIVATE LIMITED',
    'Latest IT Solutions Limited',
    'BALAR IMPEX PRIVATE LIMITED',
    'Bangalore Airport Hotel Limited',
    'BANGALORE FORT FARMS LIMITED',
    'COEVOLVE ESTATES PRIVATE LIMITED',
    'KALAKRITI COMMUNICATIONS PRIVATE LIMITED',
    'KARAMSAR ELECTRONICS PRIVATE LIMITED',
    'KARIKA (INDIA) PRIVATE LIMITED',
    'KARMA TEX-PRINTS PRIVATE LIMITED',
    'K C ASTIR AND CO PRIVATE LTD',
    'K C TOWERS PRIVATE LIMITED',
    'KARPI INDIA PRIVATE LIMITED',
    'K K S K APPARELS PRIVATE LIMITED',
    'K K SECURITIES LIMITED',
    'K K TALWAR FABRICS PRIVATE LTD',
    'KARUNA PRAGYA FOUNDATIONS',
    'KARWA AGENCIES PRIVATE LIMITED',
    'KARWA MARKETING PRIVATE LIMITED',
    'KASHI VISHWANATH STEELS Private Limited',
    'KASHIF INFRATECH PRIVATE LIMITED',
    'KASSA FINVEST PRIVATE LIMITED',
    'KATARA ESTATES PRIVATE LIMITED',
    'KATRA WILHELMSEN LOGISTICS PRIVATE LIMITED',
    'KALPTARU FINCAP LIMITED',
    'KAUSAR ESTATES PRIVATE LIMITED',
    'KAUTIK HOTELS AND RESORTS LIMITED',
    'KAUTILYA CAPINVEST LEAHOLD PRIVATE LIMITED',
    'KAV ENGINEERING AND MARKETING PRIVATE LIMITED',
    'KAVINTA EXPORTS PRIVATE LIMITED',
    'KAVITA ENGINEERING INDUSTRIES PVT LTD',
    'KAY JAY PROJECTS PRIVATE LIMITED',
    'KAY KAY INFRASTRUCTURE PRIVATE LIMITED',
    'KAYS KITCHEN CUISINE PRIVATE LIMITED',
    'KAYTEE SHIPPING & REALTY PRIVATE LIMITED',
    'KazStroy Engineering India Private Limited',
    'KB WOOLLEN & SILK MILLS PRIVATE LIMITED',
    'KBC INDIA PRIVATE LIMITED',
    'KBC NANO PUBLICATION PRIVATE LIMITED',
    'KBL TEXTILES PRIVATE LIMITED',
    'KBM EXPORTS PRIVATE LIMITED',
    'BIKANNA COMMERCIAL CO PRIVATE LIMITED',
    'BPE BIOTREE India Private Limited',
    'KALRA FORGINGS & ALLOYS PRIVATE LIMITED',
    'KALRA HOSPITAL PRIVATE LIMITED',
    'KD ASSOCIATES PRIVATE LIMITED',
    'KDH TRAVELS PRIVATE LIMITED',
    'KDR FORGINGS PRIVATE LIMITED',
    'JUP SOFT TECHNOLOGIES PRIVATE LIMITED',
    'BRIGHTMATTER DESIGN AND INCUBATION PRIVATE LIMITED',
    'KAMAL TOWERS PRIVATE LIMITED',
    'KEJRIWAL FOUNDATION FOR RURAL DEVELOPMENT',
    'KAMROPH GUARDIAN MEDZ PRIVATE LIMITED',
    'KENDA FARBEN INDIA PRIVATE LIMITED',
    'KENMORE VIKAS (INDIA) PRIVATE LIMITED',
    'KENNITH PARKERS APPARELS PRIVATE LIMITED',
    'Kenrick Developers Private Limited',
    'KANAV BUILDWELL PRIVATE LIMITED',
    'KANHA ENTERPRISES PRIVATE LIMITED',
    'Kepler Cannon International Private Limited',
    'KERALA CARS PRIVATE LIMITED',
    'KANHAIYA COMMUNICATION PRIVATE LIMITED',
    'KESHAV ARJUN AUTOMOBILES PRIVATE LIMITED',
    'KESHAV OIL & COTTON GINNING INDUSTRIES PRIVATE LIMITED',
    'KESHAV POWER LIMITED',
    'KAPSONS ENGINEERS PRIVATE LIMITED',
    'KESHO RAM ROSHAN LAL AHUJA PVT LTD',
    'Kesinga Mining Company Private Limited',
    'KESSELS ENGINEERING WORKS PRIVATE LIMITED',
    'KARAKORAM BUILDWELL LIMITED',
    'KEU INTERNATIONAL PRIVATE LIMITED',
    'KEVIN INFOTECH PRIVATE LIMITED',
    'KARAKORAM PROPERTIES LIMITED',
    '1ICT INDIA PRIVATE LIMITED',
    'Kezia Mining Private Limited',
    'KARMATH INFRASTRUCTURE PRIVATE LIMITED',
    'KARMSHIL CONSTRUCTION PRIVATE LIMITED',
    'KHANDELWAL COMMERCIAL PRIVATE LIMITED',
    'KHANDELWAL OVERSEAS PRIVATE LTD',
    'KARSHNI ALUMINIUM COMPANY PRIVATE LIMITED',
    'KHATU JI EXPORT PRIVATE LIMITED',
    'KHATUWALA HOLDINGS PRIVATE LIMITED',
    'KARSOG VALLEY HYDEL PROJECTS PRIVATE LIMITED',
    'KALINDI PROMOTERS PRIVATE LIMITED',
    'KALINGA BUILDTECH PRIVATE LIMITED',
    'KHURMI ASSOCIATES PRIVATE LTD',
    'KALINGA REALTORS LIMITED',
    'KALPI METALS PRIVATE LIMITED',
    'K N INFRACON PRIVATE LIMITED',
    'BVP INDIA INVESTORS PRIVATE LIMITED',
    'KINDLE DEVELOPERS PRIVATE LIMITED',
    'NAVI FINSERV LIMITED',
    'CHANTILLY SYSTEMS PRIVATE LIMITED',
    'KINGDOM CONSTRUCTION PRIVATE LIMITED',
    'KEB TECHNOLOGY INDIA PRIVATE LIMITED',
    'KEEP IN TOUCH CLOTHING PRIVATE LIMITED',
    'KEN BUILDCON PRIVATE LIMITED',
    'KENTZ HEALTHCARE LIMITED',
    'KIRAN UDYOG PRIVATE LIMITED',
    'Kepa Developers Private Limited',
    'KESAR JEWELS PRIVATE LIMITED',
    'KESHIKA EXPORTS PVT LTD',
    'KITCHEN AIDS DISTRIBUTORS PRIVATE LIMITED',
    'KIWI COMMODITIES PRIVATE LIMITED',
    'KIWI MARKETING PRIVATE LIMITED',
    'KETAN BUTTONS PRIVATE LIMITED',
    'KEW PRECISION PARTS PRIVATE LIMITED',
    'KGDG FINANCIAL SERVICES PRIVATE LIMITED',
    'KLJ ORGANIC LIMITED',
    'KHAITAN LAMPS LIMITED',
    'KLN PROPERTIES PRIVATE LIMITED',
    'KLONE INFRASTRUCTURE PRIVATE LIMITED',
    'AXIMPROVE SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'EXPERTISEFACILITY SERVICES PRIVATE LIMITED',
    'TECHXIM IT SERVICES PRIVATE LIMITED',
    'EPX POLYMERS PRIVATE LIMITED',
    'ANCHOR BOND PRIVATE LIMITED',
    'KASTECH SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'ADDEDSPORT INDIA PRIVATE LIMITED',
    'TRACKZ SOLUTIONS & TECHNOLOGIES PRIVATE LIMITED',
    'GO LORRY PRIVATE LIMITED',
    'WAHID BIRYANI PRIVATE LIMITED',
    'RA TECHNICAL SERVICES PRIVATE LIMITED',
    'SEEKERS TECH PRIVATE LIMITED',
    'GPSDESK INFOTECH PRIVATE LIMITED',
    'ACCORD212 HUMAN RESOURCE SOLUTIONS PRIVATE LIMITED',
    'ATRIA WIND POWER (BIJAPUR 1) PRIVATE LIMITED',
    'PRECISION MASS HOLDINGS PRIVATE LIMITED',
    'JARAMED HEALTHCARE PRIVATE LIMITED',
    'AZAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'DYNATEAM RESOURCE MANAGEMENT PRIVATE LIMITED',
    'QUANTSAPP PRIVATE LIMITED',
    'APOSTLETECH INDIA PRIVATE LIMITED',
    'SHRI DUTTGURU MEDIA PRIVATE LIMITED',
    'INVEL TECHNOLOGIES PRIVATE LIMITED',
    'INVOKING MINDS PRIVATE LIMITED',
    'ACROPOLIS INFOTECH PRIVATE LIMITED',
    'CUREFIT HEALTHCARE PRIVATE LIMITED',
    'GENERILIFE PRIVATE LIMITED',
    'SANE RETAILS PRIVATE LIMITED',
    'WORKXMART BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PC RACING FOUNDATION',
    'PLAZO TECHNOCRATS PRIVATE LIMITED',
    '24E-SERVICES PRIVATE LIMITED',
    'AUTNEX ALIGN PRIVATE LIMITED',
    'SAKTHI HOMEWARE PRIVATE LIMITED',
    'CATCH ONN LEGAL SERVICES PRIVATE LIMITED',
    'RAVAL IMMIGRATION PRIVATE LIMITED',
    'SHREYAM CONSULTANTS PRIVATE LIMITED',
    'SHIVAARNA TECHNOFOAMS PRIVATE LIMITED',
    'SIEMAC AUTOMATION PRIVATE LIMITED',
    'WAPINDICO RETAIL PRIVATE LIMITED',
    'VIJAYANT PROPERTIES INDIA PRIVATE LIMITED',
    'VYAASH LOGISTICS PRIVATE LIMITED',
    'MAZZETTI INDIA ENGINEERING PRIVATE LIMITED',
    'APPYFY TECHNOLOGIES PRIVATE LIMITED',
    'GLOBAL KREATIONS PRIVATE LIMITED',
    'TUOR AND ASSOCIATES PRIVATE LIMITED',
    'EONIAN CONSULTANCY PRIVATE LIMITED',
    'EVAA HAIR & GROOMING PRIVATE LIMITED',
    'INDY NETWORK PRIVATE LIMITED',
    'BIZTEK ADVISORS PRIVATE LIMITED',
    'THANOS TECHNOLOGIES PRIVATE LIMITED',
    'ISOLS GROUP PRIVATE LIMITED',
    'RHODA COGNAX PRIVATE LIMITED',
    'NAVIA LIFE CARE PRIVATE LIMITED',
    'PNV FINSERV PRIVATE LIMITED',
    'MODEL INFO SOLUTIONS PRIVATE LIMITED',
    'SOWEDID SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'INFOREL INNOVATION & RESEARCH PRIVATE LIMITED',
    'ALPHATUB INNOVATIONS PRIVATE LIMITED',
    'GLEECUS TECHLABS PRIVATE LIMITED',
    'SUNPOWER INDIA VENTURES KARNATAKA PRIVATE LIMITED',
    'BULK MRO INDUSTRIAL SUPPLY PRIVATE LIMITED',
    'CAPACITA CONNECT PRIVATE LIMITED',
    'RAINMATTER FOUNDATION',
    'DYLANS ENTERPRISES PRIVATE LIMITED',
    'KHETAN CORRU CASE PRIVATE LIMITED',
    'WASEF ENGINEERS PRIVATE LIMITED',
    'BRIJ HONEY PRIVATE LIMITED',
    'AGRICHOICE FOOD PRODUCTS PRIVATE LIMITED',
    'MEP SANJOSE ARAWALI KANTE ROAD PRIVATE LIMITED',
    'MOR INFRATECH PRIVATE LIMITED',
    'KIAAN HR SERVICES PRIVATE LIMITED',
    'WEZBITS TECHNOLOGIES PRIVATE LIMITED',
    'GOINFINITY TECHNOLOGIES PRIVATE LIMITED',
    'DAMINI PUMPS PRIVATE LIMITED',
    'D-AIVA ENGINEERING PRIVATE LIMITED',
    'GOOD-BEE INTEGRATED MARKETING SERVICES PRIVATE LIMITED',
    'MUSICEARN PRIVATE LIMITED',
    'ACCLAIM INDUSTRIAL SUPPLIES & SERVICES PRIVATE LIMITED',
    'ZEETEX KNITS PRIVATE LIMITED',
    'LETZPAY SOLUTION PRIVATE LIMITED',
    'FAIRAIR ENGINEERS (MUMBAI) PRIVATE LIMITED',
    'CREDRIGHT PRIVATE LIMITED',
    'VINTEGRA SOLUTIONS PRIVATE LIMITED',
    'NIRMALVILLA HOSPITALITY PRIVATE LIMITED',
    'INNERVE POWER SOLUTIONS PRIVATE LIMITED',
    'AEGISKO TECHNOLOGIES PRIVATE LIMITED',
    'VYONICS HEALTHCARE INDIA PRIVATE LIMITED',
    'SPROUTLOGIX PRIVATE LIMITED',
    'REVMAX TECHNOLOGIES PRIVATE LIMITED',
    'CROI MEDIA PRIVATE LIMITED',
    'NJP DEVELOPERS PRIVATE LIMITED',
    'NASHAR PROPERTY DEVELOPERS PRIVATE LIMITED',
    'REVERI FOOD DESIGN PRIVATE LIMITED',
    'SARGAM INSURANCE BROKERS PRIVATE LIMITED',
    'INFINITUM VENTURES PRIVATE LIMITED',
    'DYNAMIS VENTURES PRIVATE LIMITED',
    'HEIRLOOM KASHMIR PRIVATE LIMITED',
    'FOSCHIA RESORTS PRIVATE LIMITED',
    'MAHESH INTERIORS PRIVATE LIMITED',
    'SITCORP SOURCING (OPC) PRIVATE LIMITED',
    'PDS ENGINEERING SOLUTION PRIVATE LIMITED',
    'MAPPD SYSTEMS PRIVATE LIMITED',
    'INFOSKATERS TECHNOLOGIES PRIVATE LIMITED',
    'MAXTHERM (INDIA) PRIVATE LIMITED',
    'PANMEDICAL SERVICES PRIVATE LIMITED',
    'OILFIELD EQUIPMENTS PRIVATE LIMITED',
    'LEADERSHIP ENTREPRENEURSHIP AND ACCELERATION FOUNDATION',
    'DIGITALSKUNKS TECHNOLOGIES PRIVATE LIMITED',
    'CLOMOSO TECHNOLOGIES PRIVATE LIMITED',
    'RUSTIC HUE CREATIONS (OPC) PRIVATE LIMITED',
    'DUANE PARK PRIVATE LIMITED',
    'BRANDROOF ELECTRO TRADING PRIVATE LIMITED',
    'MAGNIFIQ SERVICES PRIVATE LIMITED',
    'DATAGROKR ANALYTICS PRIVATE LIMITED',
    'D.C.MEDIA NETWORKS PRIVATE LIMITED',
    'BENCITI TECHNOLOGY PRIVATE LIMITED',
    'RACKS CONNECT (INDIA) PRIVATE LIMITED',
    'CHAMPION INFOMETRICS PRIVATE LIMITED',
    'YTILIGA PRIVATE LIMITED',
    'SWARASHTRA GLOBAL PRIVATE LIMITED',
    'LAZER INDIA PRIVATE LIMITED',
    'PATERSON ENERGY PRIVATE LIMITED',
    'SFL GYMS PRIVATE LIMITED',
    'ETHEREAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VARCHASV CORPORATE ADVISORS LIMITED',
    'NGC TRANSMISSION INDIA PRIVATE LIMITED',
    'DOCTALK SOLUTIONS INDIA PRIVATE LIMITED',
    'SANKALPIT SERVICES PRIVATE LIMITED',
    'TEKION INDIA PRIVATE LIMITED',
    'CYWARE LABS INDIA PRIVATE LIMITED',
    'RABBIT AND TORTOISE TECHNOLOGY SOLUTIONSPRIVATE LIMITED',
    'RICH VITRIFIED PRIVATE LIMITED',
    'TRENDARROW TECHNOLOGIES PRIVATE LIMITED',
    'CRYO PRECISION TECHNOLOGIES PRIVATE LIMITED',
    'SPAWOZ TECHNOLOGIES PRIVATE LIMITED',
    'OLIVE MOUNTAIN GOODS PRIVATE LIMITED',
    'SANSKAR MEDICA INDIA LIMITED',
    'OPTIKS KARKHANA INDIA PRIVATE LIMITED',
    'JGB AGROFRESH PRIVATE LIMITED',
    'RESONANCE AUDIO PRIVATE LIMITED',
    'SECURELAYER7 TECHNOLOGIES PRIVATE LIMITED',
    'DAFTAR COWORKING PRIVATE LIMITED',
    'TGS FOODZ PRIVATE LIMITED',
    'BHUJANG INNOVATIONS PRIVATE LIMITED',
    'LIVEWORLD HEALTHTECH PRIVATE LIMITED',
    'PARADISE SERVICES AND PROPERTY SOLUTIONSPRIVATE LIMITED',
    'VAKKY IDEAS PRIVATE LIMITED',
    'BLEND WELLNESS PRIVATE LIMITED',
    'CIRCLE SQUARE TECHNOLOGIES PRIVATE LIMITED',
    'VALVUM PRO SCIENCES PRIVATE LIMITED',
    'SOLINNOS AGRO SCIENCES PRIVATE LIMITED',
    'TECO ELECTRICAL INDUSTRIES PRIVATE LIMITED',
    'ALVI AUTOMATION (INDIA) PRIVATE LIMITED',
    'TESSERACT GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'EARCONS ACOUSTIC BUILDING SYSTEM PRIVATELIMITED',
    'IRREGULARITY MEDIA PRIVATE LIMITED',
    'KANDOVIN PRIVATE LIMITED',
    'BAKBAK TECHNOLOGIES INDIA PRIVATE LIMITED',
    'KASTUGY DENIMS PRIVATE LIMITED',
    'AUTODYNAMIC TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED',
    'WELLNESS EXECUTORS & ESTATE MANAGERS PRIVATE LIMITED',
    'INFOMAGNUM IT SOLUTIONS PRIVATE LIMITED',
    'DIGIHIVE TECHNOLOGY PRIVATE LIMITED (OPC)',
    'REDELEGANT TECHNOLOGIES PRIVATE LIMITED',
    'PRAYUTA TECHNOLOGIES PRIVATE LIMITED',
    'XIHI TECHNOLOGY PRIVATE LIMITED',
    'TECOY INDIA PRIVATE LIMITED',
    'CADVINS FACILITY MANAGEMENT PRIVATE LIMITED',
    'INDRAPRASTHA ACADEMY PRIVATE LIMITED',
    'JAI SEVA FARMER PRODUCER COMPANY LIMITED',
    'GRAM AARANYAKA ENTERPRISES PRIVATE LIMITED',
    'MELITA INDUSTRIES PRIVATE LIMITED',
    'SP HOSPITALITY PRIVATE LIMITED',
    'RX DIGI HEALTH PLATFORM PRIVATE LIMITED',
    'NOS CORPORATE SOLUTIONS PRIVATE LIMITED',
    'CANADIAN AGRO INDIA PRIVATE LIMITED',
    'NEW WORLD INVENTIONS PRIVATE LIMITED',
    'AMTECH DIGITAL PRIVATE LIMITED',
    'SWIFTSY FREIGHT PRIVATE LIMITED',
    'METEODYN CLIMATOLOGY AND DYNAMICS INDIA PRIVATE LIMITED',
    'WEBOIR PRIVATE LIMITED',
    'SPIRITUAL ESSENTIALS PRIVATE LIMITED',
    'SOUFFLET MALT ALWAR PRIVATE LIMITED',
    'ZAPATI PRIVATE LIMITED',
    'INVY SOFTECH PRIVATE LIMITED',
    'WORDWAVE EDUCATION PRIVATE LIMITED',
    'ORGANICHOME PRIVATE LIMITED',
    'ORGANIC ORCHARDS PRIVATE LIMITED',
    'MBL (GSY) ROAD LIMITED',
    'ANUR CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'FOXTROT BEVERAGES PRIVATE LIMITED',
    'CRUSO GRANITO PRIVATE LIMITED',
    'MERIEUX NUTRISCIENCES BANGALORE PRIVATE LIMITED',
    'ASN HYDRO SYSTEMS INDIA PRIVATE LIMITED',
    'LENCO INDIA HOROLOGICAL PRIVATE LIMITED',
    'PURSUIT VENTURES PRIVATE LIMITED',
    'VEDA MODE PRIVATE LIMITED',
    'SMARTINFRA SERVICES PRIVATE LIMITED',
    'YONEX INDIA PRIVATE LIMITED',
    'RAMU BROTHERS CONSTRUCTIONS PRIVATE LIMITED',
    'NANOYOTTA TECHNOLOGIES PRIVATE LIMITED',
    'KUNJ TOUGHEN GLASS PRIVATE LIMITED',
    'SOLAVIO LABS PRIVATE LIMITED',
    'KEY COMMUNICATIONS PRIVATE LIMITED',
    'RESOURCEKART TECHNOLOGIES PRIVATE LIMITED',
    'AFFCO EXIM PRIVATE LIMITED',
    'HIVESOLAR ENERGY PRIVATE LIMITED',
    'QUICKINSURE INSURANCE BROKERS PRIVATE LIMITED',
    'REVANTH INFOTECH PRIVATE LIMITED',
    'NIDIALABS INDIA PRIVATE LIMITED',
    'CREDO INDIA SOFTECH PRIVATE LIMITED',
    'UNEED SOLUTIONS PRIVATE LIMITED',
    'PARALLEL PLAIDS UNIFORMS PRIVATE LIMITED',
    'EXITO INDIA PRIVATE LIMITED',
    'DRUCARE PRIVATE LIMITED',
    'HEALTH EXPLORA PRIVATE LIMITED',
    'MOLDE ANALYTICS INDIA PRIVATE LIMITED',
    'SUISSE SILICON SPECIALTIES PRIVATE LIMITED',
    'NORA FLUORO COLORS PRIVATE LIMITED',
    'TECHNOMENS INDIA PRIVATE LIMITED',
    'ARK POLYCHEM PRIVATE LIMITED',
    'FLEXINNOVA PRINTPACK PRIVATE LIMITED',
    'SIGNET AUTOMATION ENGINEERS PRIVATE LIMITED',
    'HADOTI POWER TRANSMISSION SERVICE LIMITED',
    'DILIGENT FORCE LABS INDIA PRIVATE LIMITED',
    'VAUTID INDIA PRIVATE LIMITED',
    'CONSTECNER TECHNOLOGIES PRIVATE LIMITED',
    'MORGENALL MANAGEMENT CONSULTANTS PRIVATELIMITED',
    'HAVSTRUCK SOLUTIONS PRIVATE LIMITED',
    'DAIJIWORLD TECHNOLOGIES PRIVATE LIMITED',
    'ALARIS PRIME PRIVATE LIMITED',
    'SKILLATE LABORATORIES PRIVATE LIMITED',
    'HARINDRA PROPERTIES PRIVATE LIMITED',
    'CLOVERLEAF ECOM PRIVATE LIMITED',
    'KAMADHENU JEWELLERY PRIVATE LIMITED',
    'WELCOME MACHAN RESORTS PRIVATE LIMITED',
    'TELLIUS INDIA PRIVATE LIMITED',
    'T3 TOUCHSTONE SERVICES PRIVATE LIMITED',
    'FRESHLY GROUND ENTERTAINMENT PRIVATE LIMITED',
    'BITBUFFS TECHNOLOGIES PRIVATE LIMITED',
    'SUNGROW (INDIA) PRIVATE LIMITED',
    'HELPEAZE INFRATECH INDIA PRIVATE LIMITED',
    'CIL LABORATORIES PRIVATE LIMITED',
    'SYNERGYPHARMA FORMULATIONS (INDIA) PRIVATE LIMITED',
    'NAF FACILITY MANAGEMENT AND SECURITY PRIVATE LIMITED',
    'HOCHSTE HEALTH CARE PRIVATE LIMITED',
    'SVENTL INDIA PRIVATE LIMITED',
    'LIVE LIFE INFRATECH PRIVATE LIMITED',
    'BENZY PLANTATION PRIVATE LIMITED',
    'ASSOCIATION FOR DEVELOPMENT OF SECURITIES MARKET',
    'OM HANDLING MATERIAL PRIVATE LIMITED',
    'TRANSIENT HR SOLUTIONS PRIVATE LIMITED',
    'MEDCALL HEALTH SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SERVETEK PRIVATE LIMITED',
    'SARDANA CREATIVE CONSULTANCY PRIVATE LIMITED',
    'MOTIPRABHA SB INDUSTRIES PRIVATE LIMITED',
    'BESTDOC TECHNOLOGY PRIVATE LIMITED',
    'THINKERBELL LABS PRIVATE LIMITED',
    'INTERSNACK CASHEW INDIA PRIVATE LIMITED',
    'HERD TECSOL PRIVATE LIMITED',
    'MICROWORLD INFOSOL PRIVATE LIMITED',
    'COMPETENZA INNOVARE PRIVATE LIMITED',
    'AXPS ( FREIGHT ) PRIVATE LIMITED',
    'MISA SECURITY (I) PRIVATE LIMITED',
    'EMA PARTNERS EXECUTIVE SEARCH PRIVATE LIMITED',
    'KINGS GLOBAL BIOTECH LIMITED',
    'DNYANESHWAR TANKS SERVICES PRIVATE LIMITED',
    'BIZVONE TECH PRIVATE LIMITED',
    'BRIDGEI2P TELECOMMUNICATIONS PRIVATE LIMITED',
    'COMPLETE AUTOMATION TECHNOLOGIES PRIVATELIMITED',
    'HSAG INDIA PRIVATE LIMITED',
    'JAGORE LIFE SCIENCES PRIVATE LIMITED',
    'JAPS HOLDINGS IMPEX PRIVATE LIMITED',
    'JASPER CONCEPTS PRIVATE LIMITED',
    'SEA TURTLE PRIVATE LIMITED',
    'PROASPIRE INFOTECH PRIVATE LIMITED',
    'TALFORCE SERVICES PRIVATE LIMITED',
    'SIEVA NETWORKS SOLUTIONS PRIVATE LIMITED',
    'ZOFTSOLUTIONS PRIVATE LIMITED',
    'CHANGZHOU HAIJI INDIA PRIVATE LIMITED',
    'INDUSTRIAL STORE PRIVATE LIMITED',
    'ABL COWORKING PRIVATE LIMITED',
    'GREINER PACKAGING INDIA PRIVATE LIMITED',
    'SS COMMUNICATION & SERVICES PRIVATE LIMITED',
    'CODECONVERGENCE IT SERVICES PRIVATE LIMITED',
    'CHIRASTHAAYEE SAURYA LIMITED',
    'COORG CONSULTING PRIVATE LIMITED',
    'ITOCHU WORLDWIDE TECHNOLOGY PRIVATE LIMITED',
    'DECENT REAL ESTATE PROJECTS PRIVATE LIMITED',
    'VELOCITY MR SOLUTIONS PRIVATE LIMITED',
    'N EVENTS CLUB LIMITED',
    'CULTURAL CENTRE OF AMARAVATI',
    'MEDIFEE HEALTHCARE PRIVATE LIMITED',
    'HINDUSTAN URVARAK & RASAYAN LIMITED',
    'ECSO GLOBAL PRIVATE LIMITED',
    'YAAL SYSTEMS PRIVATE LIMITED',
    'TRIBUS INDUSTRIES PRIVATE LIMITED',
    'MAR SAPIENT PRIVATE LIMITED',
    'GREAT VALUE STORE PRIVATE LIMITED',
    'LOHPATH RAIL TECHNOLOGIES PRIVATE LIMITED',
    'ELEMASTER INDIA PRIVATE LIMITED',
    'MAAI WORLD ELECTRICALS & ELECTRONICS PRIVATE LIMITED',
    'SRIDHAM MAYAPUR DEVELOPMENT FOUNDATION',
    'MAKE MY BRAND STORY PRIVATE LIMITED',
    'ITSMYMART SYNERGY PRIVATE LIMITED',
    'YASHSRI FOODS PRIVATE LIMITED',
    'UNISWEN PHARMACEUTICALS PRIVATE LIMITED',
    'MORGAN REAL INFRATECH PLANNERS PRIVATE LIMITED',
    'TRANZEVO TECHNOLOGIES PRIVATE LIMITED',
    'VEC SOLAR PRIVATE LIMITED',
    'NETRIX WORLDWIDE PRIVATE LIMITED',
    'MAITREYI CREDIT & PAYMENT SYSTEMS PRIVATE LIMITED',
    'SPRM ENERGY INFRASTRUCTURE PRIVATE LIMITED',
    'CRAZZLE PLUS INFOTECH PRIVATE LIMITED',
    'PIRAMAL CORPORATE & MANAGEMENT SERVICES PRIVATE LIMITED',
    'N K CAR PARK SOLUTIONS PRIVATE LIMITED',
    'HASHECM TECHNOLOGIES PRIVATE LIMITED',
    'SHRI RAVINDER JOSHI CHARITABLE FOUNDATION',
    'FACADE GLOBAL PRIVATE LIMITED',
    'SOCIALCTR SOLUTIONS PRIVATE LIMITED',
    'ARDENT MINING PRIVATE LIMITED',
    'PEPPER HEALTH PRIVATE LIMITED',
    'PUBPORT PUBLISHING SERVICES PRIVATE LIMITED',
    'AMISHI CONSUMER TECHNOLOGIES PRIVATE LIMITED',
    'AROGYAM MEDISOFT SOLUTION PRIVATE LIMITED',
    'SKY WAVES SECURITY PRIVATE LIMITED',
    'NEXUS TEST LABS PRIVATE LIMITED',
    'DHAVAL GADA ENTERPRISES PRIVATE LIMITED',
    'RKC INFRABUILT (MEHSANA-HIMATNAGAR) ROADPROJECT PRIVATE LIMITED',
    'STARTERS',
    'S OWN KIDS PRIVATE LIMITED',
    'XPAY LIFE PRIVATE LIMITED',
    'ROBOMATIC PRECON PRIVATE LIMITED',
    'JR ELITES PRIVATE LIMITED',
    'BOUNCE ELECTRIC 1 PRIVATE LIMITED',
    'TREATGO PRIVATE LIMITED',
    'DELTAONE SPIRITS PRIVATE LIMITED',
    'HBMK HEALTHCARE PRIVATE LIMITED',
    'SUNRICH CHARTERING PRIVATE LIMITED',
    'PROVINO TECHNOLOGIES PRIVATE LIMITED',
    'VIZARA TECHNOLOGIES PRIVATE LIMITED',
    'HUMAN RIGHTS PROTECTION GROUP AND MFP FEDERATION',
    'CLOUD ITINERARIES PRIVATE LIMITED',
    'AMBROTII INTERNATIONAL PRIVATE LIMITED',
    'SAGARMALA DEVELOPMENT COMPANY LIMITED',
    'AFFINITY TRANS LOGISTICS PRIVATE LIMITED',
    'NEEMRANA LAND PRIVATE LIMITED',
    'ADIONA INFRA SOLUTIONS PRIVATE LIMITED',
    'LIONHEAD SPORTS CLUB PRIVATE LIMITED',
    'MJS BIDKARO SERVICES PRIVATE LIMITED',
    'ASHOKA ENDURANCE ROAD DEVELOPERS PRIVATELIMITED',
    'NATIVITY PRIVATE LIMITED',
    'JUNGA FRESHNGREEN PRIVATE LIMITED',
    'SUPERCRAFT3D WELLNESS PRIVATE LIMITED',
    'EUROPEAN MUD CHEMICALS INDIA PRIVATE LIMITED',
    'PLATFORMX SOLUTIONS PRIVATE LIMITED',
    'AGRANI MILESTONE PRIVATE LIMITED',
    'WISE ENGAGE PRIVATE LIMITED',
    'GEMAL ORGANIC IMPORTS PRIVATE LIMITED',
    'HIGA DIGITAL PRIVATE LIMITED',
    'SEASONZ INDIA HOLIDAYS PRIVATE LIMITED',
    'ARS SOLARTECH PRIVATE LIMITED',
    'VISIONARY LIFE SCIENCES PRIVATE LIMITED',
    'RELSTOW PRIVATE LIMITED',
    'SREGH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CASA GRANDE GRACE PRIVATE LIMITED',
    'INDUSGLOBE FREIGHT LINES PRIVATE LIMITED',
    'GEMSTONES JEWELRY STORE PRIVATE LIMITED',
    'SENGEN SOFTWARE PRIVATE LIMITED',
    'HALAPLAY TECHNOLOGIES PRIVATE LIMITED',
    'CONVORA TECHNOLOGIES PRIVATE LIMITED',
    'LGT BUSINESS CONNEXTIONS PRIVATE LIMITED',
    'VALUSTAT INDIA PRIVATE LIMITED',
    'TRIPLEONE DEVELOPMENTS PRIVATE LIMITED',
    'EDWIZA SOLUTIONS PRIVATE LIMITED',
    'DAIRY HEALTH AND NUTRITION INITIATIVE INDIA FOUNDATION',
    'MIANTIC AV DISTRIBUTION PRIVATE LIMITED',
    'FFL MARKETING PRIVATE LIMITED',
    'CORONATION ENERGY PRIVATE LIMITED',
    'SYSTROME NETWORKS (INDIA) PRIVATE LIMITED',
    'NAES TECH SERVICES PRIVATE LIMITED',
    'BPEA SERVICES PRIVATE LIMITED',
    'JAI SUSPENSIONS LIMITED',
    'VALENCY4 COMPOSITE SOLUTIONS PRIVATE LIMITED',
    'LIVE SMART SOLUTIONS PRIVATE LIMITED',
    'CYBERLOBE TECHNOLOGIES PRIVATE LIMITED',
    'TECHNORIP INNOVATIONS PRIVATE LIMITED',
    'QUANTASIS PRIVATE LIMITED',
    'NARAYANA GLOBAL EDUCATIONAL INITIATIVES PRIVATE LIMITED',
    'FORESOFT TECHNOLOGIES PRIVATE LIMITED',
    'BELICIA ENTERPRISES PRIVATE LIMITED',
    'MANJEERA HOSPITALITY (RAJAHMUNDRY) PRIVATE LIMITED',
    'KHWAISH JEWELS (OPC) PRIVATE LIMITED',
    'SFL HEARING SOLUTIONS PRIVATE LIMITED',
    'INOVARK TECHNOLOGIES PRIVATE LIMITED',
    'BORRI POWER INDIA PRIVATE LIMITED',
    'LILABATI CONSTRUCTION AND DEVELOPER PRIVATE LIMITED',
    'JEMOND RUBBER PRIVATE LIMITED',
    'TRIDHAA WORLDWIDE LOGISTICS PRIVATE LIMITED',
    'HOLIDAY BASKET SERVICES PRIVATE LIMITED',
    'SHOPAHOLICS E-COMMERCE PRIVATE LIMITED',
    'TARC LIMITED',
    'SAWANT PATEL & SINDHUDURG FARMERS PRODUCER COMPANY LIMITED',
    'SPEEDY INDUSTRIAL SERVICES PRIVATE LIMITED',
    'REGENTI INFOTECH PRIVATE LIMITED',
    'TAKEMOTO YOHKI INDIA PRIVATE LIMITED',
    'PIPELINE FNB PRIVATE LIMITED',
    'WELASSURE PRIVATE LIMITED',
    'TWIC MOTORCYCLES PRIVATE LIMITED',
    'APT PROCUREMENT MANAGEMENT PRIVATE LIMITED',
    'FANAIR INDIA PRIVATE LIMITED',
    'ZINGBI LIFESTYLE INDIA PRIVATE LIMITED',
    'DEEP CHAND ONCOLOGY SERVICES PRIVATE LIMITED',
    'GOSREE INVESTMENT AND RISK SERVICES PRIVATE LIMITED',
    'JUXTAPOSE CREATIVE SERVICES AND SPACES PRIVATE LIMITED',
    'PARAG MEGA FABCOAT PRIVATE LIMITED',
    'PNP TECH SOLUTION PRIVATE LIMITED',
    'MEDIANT BROADBAND PRIVATE LIMITED',
    'DRAVEYNA ADVISORY PRIVATE LIMITED',
    'NATUREKARE MULTI TRADE PRIVATE LIMITED',
    'DALMIA MINING AND SERVICES PRIVATE LIMITED',
    'TOKO TRADING AND SERVICES PRIVATE LIMITED',
    'GODREJ REAL VIEW DEVELOPERS PRIVATE LIMITED',
    'UP KORAUN URJA PRIVATE LIMITED',
    'CUREFOODS PRIVATE LIMITED',
    'CLOFUS INNOVATIONS PRIVATE LIMITED',
    'POWERSKILL ENGINEERING SOLUTIONS PRIVATELIMITED',
    'ADBOULEVARD MEDIA PRIVATE LIMITED',
    'GWC CORPORATE SOLUTIONS PRIVATE LIMITED',
    'THIRUKKALUKUNDRAM FARMERS PRODUCER COMPANY LIMITED',
    'THESUBLIMEIT PRIVATE LIMITED',
    'ADITI POWER EQUIPMENTS PRIVATE LIMITED',
    'VIDYABHARATHI SKILLS PRIVATE LIMITED',
    'VISPAN SOLUTIONS PRIVATE LIMITED',
    'AUGUSTA CLUB PRIVATE LIMITED',
    'BLUESKIES MULTITRADE PRIVATE LIMITED',
    'AMVIK SOLUTIONS PRIVATE LIMITED',
    'SPURR PROXIMITY TECHNOLOGY PRIVATE LIMITED',
    'PURVA OAK PRIVATE LIMITED',
    'HIND GEONODES PRIVATE LIMITED',
    'WIPADIKA INNOVATIONS PRIVATE LIMITED',
    'TRACK & TRACE EXPRESS PRIVATE LIMITED',
    'RAGA SHIVRANJANI PRIVATE LIMITED',
    'APUS APPS PRIVATE LIMITED',
    'FORTUNEXT TEXTILES PRIVATE LIMITED',
    'PP PROCESSING SERVICES INDIA PRIVATE LIMITED',
    'DESHLAN INFOTECH PRIVATE LIMITED',
    'RIVER ROCK HOTELS PRIVATE LIMITED',
    'DEVARPAN FOODS PRIVATE LIMITED',
    'BPEA INVESTMENT MANAGERS PRIVATE LIMITED',
    'GSS QUICK GARAGE INDIA PRIVATE LIMITED',
    'PRINTLINE MEDIA PRIVATE LIMITED',
    'GECE PRIVATE LIMITED',
    'ROTOMOTION BALANCING INDIA PRIVATE LIMITED',
    'FAB FAMILY LIFE CARE SERVICES PRIVATE LIMITED',
    'GREEN WAVE ORGANIC PRIVATE LIMITED',
    'EDOCS SOLUTIONS LIMITED',
    'ZEKKO TECH PRIVATE LIMITED',
    'JBM EV TECHNOLOGIES PRIVATE LIMITED',
    'SIGMA REFRACTORY PRIVATE LIMITED',
    'ZENASIA LIFE SCIENCES PRIVATE LIMITED',
    'NOVICK BIO-SCIENCES PRIVATE LIMITED',
    'EDURANET EDUCATION SYSTEM PRIVATE LIMITED',
    'WARRANTO SERVICES PRIVATE LIMITED',
    'ACCELALPHA SOFTWARE PRIVATE LIMITED',
    'CREST CAPITAL AND INVESTMENT PRIVATE LIMITED',
    'HICE TELEMEDIA PRIVATE LIMITED',
    'URUKRAMA SEMICON PRIVATE LIMITED',
    'KOZINE ENGINEERING PRIVATE LIMITED',
    'VDL PINNACLE ENGINEERING INDIA PRIVATE LIMITED',
    'SPANTECH ENGINEERING INDUSTRIES PRIVATE LIMITED',
    'SHRISTIKARTA BUILDCON PRIVATE LIMITED',
    'ALSWIS NUTRITION PRIVATE LIMITED',
    'TPLUSA TRANSFORMING ENTERPRISES PRIVATE LIMITED',
    'MOTILAL OSWAL CAPITAL LIMITED',
    'PARINAAMA TECHNOLOGIES PRIVATE LIMITED',
    'U3S TRADERS PRIVATE LIMITED',
    'OWLERY BOOK WORLD PRIVATE LIMITED (OPC)',
    'QUAD42 MEDIA PRIVATE LIMITED',
    'OPULUS BIZSERVE PRIVATE LIMITED',
    'DSHALCYON HR CONSULTING SERVICES PRIVATELIMITED',
    'ANZEN INSURANCE BROKING PRIVATE LIMITED',
    'ARM HEALTHCARE PRIVATE LIMITED',
    'GLN LABORATORIES PRIVATE LIMITED',
    'S.K.SHIPPING CLEARING AND FORWARDING AGENCY PRIVATE LIMITED',
    'DAKSHIN ODISHA URJA PRIVATE LIMITED',
    'SHAMIR OPTICAL INDIA PRIVATE LIMITED',
    'SKEIRON RENEWABLE ENERGY KUSTAGI PRIVATELIMITED',
    'IPA TECHNOLOGIES PRIVATE LIMITED',
    'THE RED BANGLE FILM COLLABORATIVE PRIVATE LIMITED',
    'HIGH PROSPERITY INFRA PRIVATE LIMITED',
    'MUKAND HEAVY MACHINERY PRIVATE LIMITED',
    'REARK DIGITAL PRESERVATIONS PRIVATE LIMITED',
    'VISION BIOSCIENCES PRIVATE LIMITED',
    'DOMAIN REGISTRATION INDIA PRIVATE LIMITED',
    'GO CONNECT PRIVATE LIMITED',
    '4PE DISTRIBUTED SOLAR SERVICES PRIVATE LIMITED',
    'LUCK MAKER INDIA PRIVATE LIMITED',
    'PITTSBURGH ENTERPRISES PRIVATE LIMITED',
    'ESGEE DESIGN AND BUILD PRIVATE LIMITED',
    'ARCHARIEL JEWELS (OPC) PRIVATE LIMITED',
    'SHULKE CONSULTING IND PRIVATE LIMITED',
    'SHAHI FABRICS PRIVATE LIMITED',
    'MARKET RESEARCH HUB PRIVATE LIMITED',
    'ANIB - ESSEL INSURANCE BROKERS PRIVATE LIMITED',
    'SHAHI MILLS PRIVATE LIMITED',
    'GOQUO TECHNICAL SERVICES PRIVATE LIMITED',
    'PETRAM ENTERPRISES PRIVATE LIMITED',
    'SABAL INDIA MARKETING PRIVATE LIMITED',
    'BIG DROP PRIVATE LIMITED',
    'NESTAVERA EDUCATION MANAGEMENT PRIVATE LIMITED',
    'DDS MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'SIGSERVICE TECHNOLOGIES PRIVATE LIMITED',
    'ZTFLOOR PRIVATE LIMITED',
    'APPIT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PENN INFRA PRIVATE LIMITED',
    'LEAFTRONIX ANALOGIC SOLUTIONS PRIVATE LIMITED',
    'VARTAK PLACE PROJECTS PRIVATE LIMITED',
    'MEDCORDS HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'D. WAMADEO LOGISTICS SERVICES PRIVATE LIMITED',
    'DLS INNOTECH PRIVATE LIMITED',
    'MUNDRA CUSTOM BROKER ASSOCIATION',
    'NS ECO SOLUTION PRIVATE LIMITED',
    'ORWI TRAVELS PRIVATE LIMITED',
    'UNNAYATI PRIVATE LIMITED',
    'JINIL SPINNING PRIVATE LIMITED',
    'ACPEOPLE HVAC PRIVATE LIMITED',
    'UPVISION SOFTWARE SERVICES PRIVATE LIMITED',
    '4PEL DISTRIBUTED SOLAR ENERGY PRIVATE LIMITED',
    'INTELLIGENT GPS SOLUTIONS PRIVATE LIMITED',
    'ZENCHASE VENTURES PRIVATE LIMITED',
    '4PEL DISTRIBUTED SOLAR POWER PRIVATE LIMITED',
    'CHANDRAMAULI EXPORT PRIVATE LIMITED',
    'QLASRAFT TECHNOLOGIES PRIVATE LIMITED',
    'RIGPA TECH PRIVATE LIMITED',
    'BHAWANI EPC PRIVATE LIMITED',
    'GERMAN HOMOEO CARE & CURE PRIVATE LIMITED',
    'COMIC HUB PRIVATE LIMITED',
    'ARYANSH EXPORTS PRIVATE LIMITED',
    'NEXT MOVE CORPORATE SOLUTIONS PRIVATE LIMITED',
    'REDLOOP TECHNOLOGIES PRIVATE LIMITED',
    'WALKING TURTLE SERVICES PRIVATE LIMITED',
    'LENOVO GLOBAL TECHNOLOGY (INDIA) PRIVATELIMITED',
    'ORIENT ELECTRIC LIMITED',
    'NAUBASTA INDUSTRIES PRIVATE LIMITED',
    'PINGGAO GROUP POWER INDIA PRIVATE LIMITED',
    'INCEVE ELECTRONICS PRIVATE LIMITED',
    'SKP GLOBAL MEDICINES PRIVATE LIMITED',
    '4PEL SURYA MITRA PRIVATE LIMITED',
    '4PEL SAUR VIDYUT PRIVATE LIMITED',
    'ORANGE BELGAUM WIND POWER PRIVATE LIMITED',
    'CLEAN WIND POWER (BABLESHWAR) PRIVATE LIMITED',
    'ANAXLABORATORIES PRIVATE LIMITED',
    'HEXAGON GEOSYSTEMS INDIA PRIVATE LIMITED',
    'ENVIRO THUBA INDIA PRIVATE LIMITED',
    'PROAGRO NUTRIFOODS PRIVATE LIMITED',
    'LEVIM BIONOVACE PRIVATE LIMITED',
    'PACE PLACCATURA PRIVATE LIMITED',
    'SURYADESH ENERGY PRIVATE LIMITED',
    'ALUR RENEWABLE ENERGY PRIVATE LIMITED',
    'KOVAI ENERGY SOLUTIONS PRIVATE LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (JAIPUR) LIMITED',
    'VERBIO INDIA PRIVATE LIMITED',
    'ANUBAL RENEWABLE ENERGIES PRIVATE LIMITED',
    'RAO TESLA RELAYS PRIVATE LIMITED',
    'ORANGE GADAG WIND POWER PRIVATE LIMITED',
    'AMPLUS ANDHRA POWER PRIVATE LIMITED',
    'SRI UGRAPPA SOLAR PRIVATE LIMITED',
    'SEPL INDIA LIMITED',
    'MARICA CHEMICALS PRIVATE LIMITED',
    'SUNFRONT ENERGY PRIVATE LIMITED',
    'JAIKON REFRIGERATION INDIA PRIVATE LIMITED',
    'KIYAARA ELECTRONICS PRIVATE LIMITED',
    'FIDELIS HEALTHCARE PRIVATE LIMITED',
    'IOS COMMERCE PRIVATE LIMITED',
    'ROYALOAK INCORPORATION PRIVATE LIMITED',
    'ENVIRONMENTORS PERPETUITY SOLUTIONS & SERVICES PRIVATE LIMITED',
    'ULTICYCLE SOLUTIONS INDIA PRIVATE LIMITED',
    'SURBINE RECYCLING PRIVATE LIMITED',
    'STEPSSTONE INFRAS PRIVATE LIMITED',
    'GRANPELL INDIA PRIVATE LIMITED',
    'BMH CONCARE TECHNOLOGY PRIVATE LIMITED',
    'G&C VALVES INDIA PRIVATE LIMITED',
    'BERALMAR INDIA COMBUSTION ENGINEERING & EQUIPMENT PRIVATE LIMITED',
    'MEL WINDMILLS PRIVATE LIMITED',
    'RAIGARH PATHALGAON EXPRESSWAY LIMITED',
    'MYTRAH VAYU (HEMAVATI) PRIVATE LIMITED',
    'SOLARIN SOLAR POWER SOLUTIONS PRIVATE LIMITED',
    'INTEGRAL ESTATES & DEVELOPERS PRIVATE LIMITED',
    'NEWLITE ENERGY SOLUTIONS PRIVATE LIMITED',
    'ANNA POWER PROJECTS PRIVATE LIMITED',
    'STONETEK ENERGY PRIVATE LIMITED',
    'GOTHE RENEWABLE ENERGY PRIVATE LIMITED',
    'FLEXARDEA PRIVATE LIMITED',
    'JUHI INFRACON PRIVATE LIMITED',
    'GREENSTATE BUILDERS PRIVATE LIMITED',
    'UCHIT EXPRESSWAYS PRIVATE LIMITED',
    'SATELLITE AEDIFEX PRIVATE LIMITED',
    'CUBATIC ARCADES PRIVATE LIMITED',
    'FUTURETECH NIRMAAN PRIVATE LIMITED',
    'SQUARES AND SPACES PROJECTS PRIVATE LIMITED',
    'BLISS AQUA PRIVATE LIMITED',
    'CG TOLLWAY LIMITED',
    'SADBHAV BANGALORE HIGHWAY PRIVATE LIMITED',
    'UDAIPUR TOLLWAY LIMITED',
    'R.L. AUTOMOBILES PRIVATE LIMITED',
    'S.A. GLOBAL PRIVATE LIMITED',
    'WHITECUBE TURNKEY SOLUTION PRIVATE LIMITED',
    'LEE BUILDERS PRIVATE LIMITED',
    'VIKASH GREEN INFRATECH PRIVATE LIMITED',
    'CONVOCON INFRAPROJECTS PRIVATE LIMITED',
    'BENCHMARRK PROMOTERS & BUILDERS PRIVATE LIMITED',
    'CLUB ICON VENTURES PRIVATE LIMITED',
    '4PEL SURYA PRAKASH PRIVATE LIMITED',
    'MLK PROJECTS PRIVATE LIMITED',
    'MACRO-COSM INFRA (OPC) PRIVATE LIMITED',
    'FORMAN MEDICS PRIVATE LIMITED',
    'CUE DEE INDIA PRIVATE LIMITED',
    'JG-RS (INDIA) PRIVATE LIMITED',
    'CARNIVAL INFRASTRUCTURE MADHYA PRADESH PRIVATE LIMITED',
    'AP COMMODITY SPACE PRIVATE LIMITED',
    'AVALANCHE IMPEX PRIVATE LIMITED',
    'HOCHSTEIN INTERNATIONAL TRADING PRIVATE LIMITED',
    'GAMUT IMPEX PRIVATE LIMITED',
    'ASHREY INTERNATIONAL TRADING PRIVATE LIMITED',
    'BLOOMFIELD AGRO PRODUCTS PRIVATE LIMITED',
    'SURYABALA MOTORS AND WHEELS PRIVATE LIMITED',
    'DEEPSENSE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'BHAVYA TRADEMART PRIVATE LIMITED',
    'BENCHMARK MOTORS PRIVATE LIMITED',
    'BETA AV SYSTEMS PRIVATE LIMITED',
    'DHONE CARS PRIVATE LIMITED',
    'MEL PROPERTIES PRIVATE LIMITED',
    'MYTRAH VAYU (NARMADA) PRIVATE LIMITED',
    'TEAPINS INDIA PRIVATE LIMITED',
    'BODHIVRIKSHA LIFESTYLE PRIVATE LIMITED',
    'AVISHAKTI ROOFTOP SOLAR PRIVATE LIMITED',
    'MAAJANKIE ESTATES PRIVATE LIMITED',
    'STEELITE WIND PRIVATE LIMITED',
    'VNG CHAMRIA AYURVED LAB PRIVATE LIMITED',
    'ILANDLO SERVICES PRIVATE LIMITED',
    'IDEX SERVICES PRIVATE LIMITED',
    'ACCELARATING EDUCATION AND DEVELOPMENT PRIVATE LIMITED',
    'A. G. CONCEPTS PRIVATE LIMITED',
    'FRAMESBUY COMMERCE PRIVATE LIMITED',
    'UNITELY EDUPLAY PRIVATE LIMITED',
    'WHITE COPPER ENTERTAINMENT PRIVATE LIMITED',
    'CELEBOFEST ONLINE SERVICES PRIVATE LIMITED',
    'TRINAS CHEMICALS PRIVATE LIMITED',
    'IXORA CORPORATE SERVICES PRIVATE LIMITED',
    'MANNURU EDU SERVICES PRIVATE LIMITED',
    'NICEFIT INNOVATIONS PRIVATE LIMITED',
    'UV LINK TECHNOMATICH PRIVATE LIMITED',
    'AARA ENERGY INNOVATIONS PRIVATE LIMITED',
    'SYS3E TECHNOLOGIES PRIVATE LIMITED',
    'SERO MARKETING PRIVATE LIMITED',
    'BRAVITEK SOLUTIONS PRIVATE LIMITED',
    'REVINE TECHNOLOGIES PRIVATE LIMITED',
    'KCLEAN AIR SOLUTIONS PRIVATE LIMITED',
    'DIFFSTUFF E-COMMERCE PRIVATE LIMITED (OPC)',
    'SKILLS ALPHA LEARNING PRIVATE LIMITED',
    'STEAM TECH CONTROLS PRIVATE LIMITED',
    'HANDC POLYMATE PRIVATE LIMITED',
    'PRIMACON INDUSTRIES PRIVATE LIMITED',
    'ISF FACILITY SERVICES PRIVATE LIMITED',
    'STANPLUS TECHNOLOGIES PRIVATE LIMITED',
    'MSI CONSULTING PRIVATE LIMITED',
    'MACKENAS PROJECTS PRIVATE LIMITED',
    'AUTOGENIUS PRIVATE LIMITED',
    'FBE INDIA PRIVATE LIMITED',
    'SPARK PLUG EXPERIENTIAL INDIA PRIVATE LIMITED',
    'STS VALVES INDIA PRIVATE LIMITED',
    'PRICHE GENERICS PRIVATE LIMITED',
    'BASTEX CONSULTANCY SERVICES PRIVATE LIMITED',
    'ONLIEST SOURCE PRIVATE LIMITED',
    'KRATE FASHION TECHNOLOGIES PRIVATE LIMITED',
    'TOPPERS CIVILS ACADEMY PRIVATE LIMITED',
    'CORMAC CONSULTANCY SERVICES PRIVATE LIMITED',
    'CASA GRANDE ZEST PRIVATE LIMITED',
    'SRI SALASAR BALAJI COMTRADE PRIVATE LIMITED',
    'PIXALOT LABS PRIVATE LIMITED',
    'KETTE ENTERPRISES PRIVATE LIMITED',
    'DARK HORSE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'ASHA LUBE SOLUTIONS PRIVATE LIMITED',
    'STRAMM SERVICES PRIVATE LIMITED',
    'KLEAR COMMERCE PRIVATE LIMITED',
    'MICANSINFOTECH PRIVATE LIMITED',
    'WYZIBILITY CONSULTING PRIVATE LIMITED',
    'UCHITH TECHCON INDIA PRIVATE LIMITED',
    'MAHOGANY LOGISTICS SERVICES PRIVATE LIMITED',
    'PRAKRUTHI MANAGEMENT SERVICES PRIVATE LIMITED',
    'BIG FOOT MARKETING PRIVATE LIMITED',
    'YARDLEY INDUSTRIES PRIVATE LIMITED',
    'AWAKEY TECH PRIVATE LIMITED',
    'ANTAR ART PRIVATE LIMITED',
    'IVISIO 360 SOLUTIONS PRIVATE LIMITED',
    'VOYAGE VISA GUIDER PRIVATE LIMITED (OPC)',
    'SINGHANIA FLEXO PACK PRIVATE LIMITED',
    'RIYANS PUBLICATION PRIVATE LIMITED',
    'CIBR WELLNESS SERVICES PRIVATE LIMITED',
    'CINE FILE PRIVATE LIMITED',
    'ZEMER BUSINESS DEVELOPMENTS PRIVATE LIMITED',
    'BRONTOBYTE ANALYTICS PRIVATE LIMITED',
    'SELECTCHEMIE SERVICES PRIVATE LIMITED',
    'CIARPRO TECH PRIVATE LIMITED',
    'KAPPAL LOGISTICS PRIVATE LIMITED',
    'SHAMBHO SOLAR PRIVATE LIMITED',
    'SUNCE RENEWABLES PRIVATE LIMITED',
    'TECHNOSURG SALES INDIA PRIVATE LIMITED',
    'LA VIDA INNOTEC PRIVATE LIMITED',
    'COGITAXIS CONSULTANCY SERVICES PRIVATE LIMITED',
    'MUST IT SERVICES PRIVATE LIMITED',
    'SUSHIKSHA INTERVENTION CENTRE PRIVATE LIMITED',
    'IDROIDHUB SOFTTECH PRIVATE LIMITED',
    'SUNWORLD SOFT PRIVATE LIMITED',
    'DILIGENCE BIO PRIVATE LIMITED',
    'VARIDH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SAMUNNATI AGRO SOLUTIONS PRIVATE LIMITED',
    'VISION GROUP RETAIL TECHNOLOGIES PRIVATE LIMITED',
    'MARIGAN INDUSTRIAL TRAINING INSTITUTE PRIVATE LIMITED',
    'HIGHBROW DILIGENCE SERVICES PRIVATE LIMITED',
    'Y. P. TRAVEL SERVICES PRIVATE LIMITED',
    'NLGIC SUPPORT SERVICES PRIVATE LIMITED',
    'EXCELLENT GASKET PRIVATE LIMITED',
    'FA SOFTWARE SERVICES PRIVATE LIMITED',
    'VERACT CONSULTANCY PRIVATE LIMITED',
    'TFT INDIA EXPORTS PRIVATE LIMITED',
    'SREE AMOHA FOOD GALERY PRIVATE LIMITED',
    'VARANASI SMART CITY LIMITED',
    'ALDER BIOCHEM PRIVATE LIMITED',
    'GHH INDIA MINING AND TUNNELLING EQUIPMENT PRIVATE LIMITED',
    'VACVR THINKONFEET (OPC) PRIVATE LIMITED',
    'ADITIA REALITY PRIVATE LIMITED',
    'BRAND ENFORCEMENT INDIA PRIVATE LIMITED',
    'INFINITYPMC PRIVATE LIMITED',
    'SOLOIDC TECHNOLOGIES PRIVATE LIMITED',
    'SHAHIN MANNAN PRIVATE LIMITED',
    '7D BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ENECO TECH SOLAR SOLUTIONS PRIVATE LIMITED',
    'NUTRI-BEING PRIVATE LIMITED',
    'RANA BROADCASTING PRIVATE LIMITED',
    'CLINIMED PHARMA PRIVATE LIMITED',
    'ARTECION ECOMMERCE PRIVATE LIMITED',
    'HCO HOTEL AND HOME CONCEPTS PRIVATE LIMITED',
    'MANGALSONS OPTICS PRIVATE LIMITED',
    'MASSIL TECHNOLOGIES PRIVATE LIMITED',
    'SPORTSVILLA VENTURES PRIVATE LIMITED',
    'DEVADI ETECHNOLOGIES PRIVATE LIMITED',
    'JAGRATI EDUCATIONAL ACADEMY PRIVATE LIMITED',
    'SIRIMAN CHEMICALS INDIA PRIVATE LIMITED',
    'AMLA CONSULTANCY PRIVATE LIMITED',
    'YOGLAND INDIA PRIVATE LIMITED',
    'BIOLITE INDIA PRIVATE LIMITED',
    'NITYAGATA ADVISOR & MANAGEMENT CONSULTANT PRIVATE LIMITED',
    'NETSENTRIES INFOSEC SOLUTIONS PRIVATE LIMITED',
    'IDEXX LABORATORIES PRIVATE LIMITED',
    'EQUINOX PETROCHEMICAL LIMITED',
    'NEXA ELEVATOR PRIVATE LIMITED',
    'WALLET FINSERVE PRIVATE LIMITED',
    'COVENANT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TRAVELLOS HOLIDAYS PRIVATE LIMITED',
    'DECURE CONNECT PRIVATE LIMITED',
    'PREFERRED MEDICARE PRIVATE LIMITED',
    'FIDA (OPC) PRIVATE LIMITED',
    'AITS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'DIGITALSPACE PRIVATE LIMITED',
    'MFF CONSULTANT SERVICES PRIVATE LIMITED',
    'TURE TEX TRADING & AGENCY PRIVATE LIMITED',
    'PRAVAM DIGITAL MEDIA PRIVATE LIMITED',
    'RELIANCE BALLY INDIA PRIVATE LIMITED',
    'ETN SOLUTIONS PRIVATE LIMITED',
    'MTEXT DIGITAL MEDIA PRIVATE LIMITED',
    'TINOSYS INDIA PRIVATE LIMITED',
    'CATORI INFOTECH PRIVATE LIMITED',
    'HAULER LOGISTICS PRIVATE LIMITED',
    'BIOCOCTION MANUFACTURING PRIVATE LIMITED',
    'LEANSYS PRIVATE LIMITED',
    'PRISYS INFOTECH PRIVATE LIMITED',
    'GRANORA CROP SEED SCIENCE PRIVATE LIMITED',
    'GUL INTERNATIONAL INDUSTRIAL SERVICES PRIVATE LIMITED',
    'SYNERGYNX FASHIONS PRIVATE LIMITED',
    'KIKO ENTERTAINMENT PRIVATE LIMITED',
    'SPRICS ENTERPRISE PRIVATE LIMITED',
    'ZIV AUTOMATION INDIA PRIVATE LIMITED',
    'KOBOLT ROBOTICS PRIVATE LIMITED',
    'ZEB INTERNATIONAL PRIVATE LIMITED',
    'NIXMA TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'Steam flow private limited',
    'Future point edu-tech private limited',
    'United professionals private limited',
    'Pm megha consultant private limited',
    'VAITARNI COMMERCIAL PRIVATE LIMITED',
    'Shopping glory private limited',
    'Slr infotech private limited',
    'Landmark immigration consultants private limited',
    'Net 4 india limited',
    'Sagarsoft (india) limited',
    'Persistent systems limited',
    'Fine-line circuits limited',
    'Shalimar wires industries limited',
    'Lumax industries limited',
    'Selan exploration technology limited',
    'Bhartiya international limited',
    'Manaksia limited',
    'Trinity league india limited',
    'Ion exchange (india) limited',
    'The sandur manganese and iron ores limited',
    'Kovai medical center and hospital limited',
    'Kavi commercial company limited',
    'Apcotex industries limited',
    'Lakshay international private limited',
    'Durga polysters private limited',
    'Continental hardware private limited',
    'Shiva consultancy services private limited',
    'Kumar machines private limited',
    'Axis crop science private limited',
    'Arpit limited',
    'ENCEE FRAGRANCES PRIVATE LIMITED',
    'EXOTIC HOSPITALITY (NAGPUR) PRIVATE LIMITED',
    'Ion exchange enviro farms limited',
    'Agritradex commodities india private limited',
    'Kalp agritech private limited',
    'Agrimpex india private limited',
    'Kilimanjaro agro enterprises private limited',
    'Swastik agricare private limited',
    'Mahadev pulses private limited',
    'Chemmanur plantations pvt ltd',
    'Joint agro concept private limited',
    'Eiffel exim private limited',
    'Pinkrose realty private limited',
    'M.r.scion agri processors private limited',
    'Imf agro private limited',
    'RAJDARBAR TELEVENTURE PRIVATE LIMITED',
    'India international coffee private limited',
    'Nagai milk producer company limited',
    'Tasty world private limited',
    'Renaissance winery private limited',
    'Krishna plantations private limited',
    'Vak exim private limited',
    'Meh flowers private limited',
    'DHUMAL INDUSTRIES INDIA PRIVATE LIMITED',
    'Fortune hatcheries private limited',
    'Varuna hatcheries private limited',
    'Srinivasa farms private limited',
    'ASHOK NATURAL FARMS PRIVATE LIMITED',
    'Wave agro private limited',
    'Aalgro foods private limited',
    'Agtec innovations private limited',
    'Vedic agro science private limited',
    'Shreeja mahila milk producer company limited',
    'Atul crop care limited',
    'Atria agri ventures private limited',
    'Ava seeds private limited',
    'Titan farms private limited',
    'Ncs green earth private limited',
    'RUCHI AGRI FRESH PRIVATE LIMITED',
    'Naturo seedtech private limited',
    'Tower agro service private limited',
    'Nagai agricultural producer company limited',
    'Husk power systems private limited',
    'Sputnik agro & resorts private limited',
    'BG CROP SCIENCE AND TECHNOLOGIES PRIVATE LIMITED',
    'Avesta good earth foods private limited',
    'Bhawna agro limited',
    'Greenth plantscaping private limited',
    'P j chemicals and investing co private limited',
    'Koyas polymers private limited',
    'Lexis tooling systems private limited',
    'Vishal precision products private limited',
    'Sreeragam exports private limited',
    'Anar enterprises private limited',
    'Nekkanti sea foods ltd.',
    'Suraj agro infrastructure (india) private limited',
    'E-city giant screen (india) private limited',
    'Kasthuri medias private limited',
    'Acc mineral resources limted',
    'Konkan agro marine industries private limited',
    'Gupta domestic fules ( nagpur) limited',
    'Acb (india) limited',
    'Goenka mining resources private limited',
    'Ganpati orchid private limited',
    'Siddha oilfield engineering private limited',
    'Nimco rata iron ore & minerals exports private limited',
    'S & T MINING COMPANY LIMITED',
    'M s talaulicar and sons private limited',
    'Madachem bat mines private limited',
    'R.k.s.motor pvt ltd',
    'TOPLAND MECHATRONICS PRIVATE LIMITED',
    'Vivek marmo india private limited',
    'Sumit quality marbles private limited',
    'Poabs rock products pvt ltd',
    'Casa greens maintenance services private limited',
    'Mangal global marbles private limited',
    'Sanchya minerals private limited',
    'United metamin private limited',
    'Rajhansa mineral private limited',
    'Shobha natural resources private limited',
    'Mahesh minerals pvt ltd',
    'Meenakshi bio -tech private limited',
    'Transformers and electricals kerala ltd',
    'Suyog transformers private limited',
    'Pavi electrical industries pvt ltd',
    'Nextfirst engineering technologies private limited',
    'Janatics india private limited',
    'Oriental plants and equipments private limited',
    'Tecumseh products india private limited',
    'R c energy metering private limited',
    'SUDHIR SALES & SERVICES LIMITED',
    'Micro interconnexion private limited',
    'Rishabh business pvt ltd',
    'Digital electric private limited',
    'Sinicon controls pvt ltd',
    'Kbs computers private limited',
    'Saket devices private limited',
    'DIVINE POWER ENERGY LIMITED',
    'Flare luminaires private limited',
    'Devanshi powers limited',
    'Beam energy systems private limited',
    'Amaryllis appliances (india) private limited',
    'PS GLOBAL ENGINEERING PRIVATE LIMITED',
    'Srm electricity and power limited',
    'Kingsignal technologies (india) private limited',
    'Radhika somana designers private limited',
    'Shree mahalakshmeya general trading company private limited',
    'Hitech lights limited',
    'WONDER ELECTRICALS LIMITED',
    'Kapoor lamp shades limited',
    'Sdsl electronics private limited',
    'PCP POWER PRIVATE LIMITED',
    'Robo inventions private limited',
    'Cherokee india pvt ltd',
    'Macpaul starters private limited',
    'Ges switchgear private limited',
    'Jalaja technologies private limited',
    'Srm global energy resources limited',
    'Lumax cornaglia auto technologies private limited',
    'V-MARC INDIA LIMITED',
    'ROSMERTA SAFETY SYSTEMS LIMITED',
    'Jawala vidyut accessories limited',
    'Teknic electromeconics private limited',
    'Engenesis engineering technologies private limited',
    'Acoustic control private limited',
    'Vegakit (india) private limited',
    'CORE EYE WAREHOUSING INDIA PRIVATE LIMITED',
    'Electroparts (india) private limited',
    'Polyplastics mechatronics private limited',
    'Pec potentiometers private limited',
    'Lamco industries private limited',
    'Tirumala music centre pvt. ltd.',
    'Isotech electrical and civil projects private ltd',
    'Epoch electronica limited',
    'Vee tech valves private limited',
    'Southern chips and circuits private limited',
    'Samriddhi automations private limited',
    'Sennheiser electronics india private limited',
    'Suchitra components private limited',
    'EPACK PETROCHEM SOLUTIONS PRIVATE LIMITED',
    'Ost electronics private limited',
    'Pioneer india electronics private limited',
    'Sureworks electronics private limited',
    'Shri hans electricals pvt ltd',
    'Precious electronics private limited',
    'E o s power india private limited',
    'Modular electronics private limited',
    'OMEGA TECHNOLOGIES PRIVATE LIMITED',
    'Letape india private limited',
    'Magicon impex private limited',
    'Threec it consulting private limited',
    'VARETO ELECTRO PRIVATE LIMITED',
    'Boston it solutions(india) private limited',
    'Comsat nstpl teleport private limited',
    'Aiuto communications private limited',
    'Srm pharmaceuticals (india) private limited',
    'Transe vision care private limited',
    'Lambda electric private limited',
    'OJEWEL INDUSTRIES PRIVATE LIMITED',
    'Fair logic devices private limited',
    'Bantom laboratories private limited',
    'Medicept dental india private limited',
    'South india surgical co limited',
    'SANMAR MATRIX METALS LIMITED',
    'Pyrra sutures private limited',
    'Apna scientific supplies private limited',
    'Apnaa projects private limited',
    'JAGDALE INDUSTRIES Private Limited',
    'Life therapeutics private limited',
    'Smc medical manufacturing private limited',
    'Silklens private limited',
    'Khanna watches limited',
    'K watch private limited',
    'Star teleinfomatics private limited',
    'Rotomag motors and controls private limited',
    'Tata autocomp systems limited',
    'Umasons auto compo private limited',
    'Sri durga auto coach body builders private limited',
    'Lasko engineers pvt ltd',
    'Eon auto industries private limited',
    'Caculo cars private limited',
    'Mahavir commercial auto(india) private limited',
    'Amul auto components private limited',
    'Daido india private limited',
    'Country auto cast private limited',
    'Hilux auto electric private limited',
    'Vortex springs and components private limited',
    'Zf hero chassis systems private limited',
    'Sunny trexim pvt.ltd.',
    'Godavari coal agency pvt ltd',
    'Trinetra tracon pvt.ltd.',
    'AYUSRI HEALTH PRODUCTS LIMITED',
    'Pushpak dealcom pvt ltd',
    'Nirkon industries private ltd',
    'Arrow aviation services private limited',
    'Tyron agency private limited',
    'E.d.enterprises private limited',
    'Nikhar suppliers private limited',
    'Bhagwanlal tejaji kharawala pvt ltd',
    'Gmb tradecom private limited',
    'Bagla agro limited',
    'PR ECOENERGY LIMITED',
    'TRANSCHEM AGRITECH PRIVATE LIMITED',
    'Chariot vinimay private limited.',
    'MARK TECHNOLOGIES PRIVATE LIMITED',
    'Veer overseas limited',
    'ZSL PRIVATE LIMITED',
    'Balhanuman commodities private limited',
    'Alappat agencies pvt ltd',
    'Ritushree tradelink private limited',
    'Therelek furnaces private limited',
    'Superways enterprises private limited',
    'Aum irya marketing services private limited',
    'Weizmann international limited',
    'Girishan traders private limited',
    'Argh multitrade private limited',
    'Geetu overseas private limited',
    'Applied digital micrologics india private limited',
    'Niti enterprises private limited',
    'Dharwad traders private limited',
    'Surajbari traders private limited',
    'GNRE INFRA PRIVATE LIMITED',
    'Naaori impex private limited',
    'Roseberry dealmark private limited',
    'Sidh trading private limited',
    'B. shah impex private limited',
    'Synapse marketing consultancy private limited',
    'Global wind power limited',
    'Lakshya management services private limited',
    'Centralogic consultancy private limited',
    'Suvin advisors private limited',
    'Tiedot consulting private limited',
    'Entrib technologies private limited',
    'Vikvins consultants private limited',
    'Seed management services private limited',
    'Mpta education limited',
    'MK GRANDZENITH PRIVATE LIMITED',
    'Genstru consultants private limited',
    'M y financial management consultancy private limited',
    'Squeamish support services private limited',
    'RELSAFE PRA CONSULTING PRIVATE LIMITED',
    'G.A. VASANT FINANCIAL',
    'S GREEN DAYS AGRO PROJECTS PRIVATE LIMITED',
    'Vinjaai agro farms private limited',
    'Sra farms private limited',
    'Star shoes (india) private limited',
    'P.v.bio-chem india private limited',
    'Devkiran paper mills private limited',
    'Nano ceramics and systems private limited',
    'Tj marine products private limited',
    'FARMICO COMMODITIES PRIVATE LIMITED',
    'Oceanus dwellings private limited',
    'A g ashtavinayaka petrochem private limited',
    'Kongsberg oil and gas technologies private limited',
    'Kariganur mineral mining industry private limited',
    'De beers india private limited',
    'Alif granites private limited',
    'Sati stones private limited',
    'PRABAL MOTORS PRIVATE LIMITED',
    'Raja automation private limited',
    'Anantcars auto private limited',
    'Shirsha tech private limited',
    'LIFETIME OXYCARE PRIVATE LIMITED',
    'Shelter enterprise co pvt ltd',
    'INDO BRINE INDUSTRIES LIMITED',
    'Libra (agencies) private limited',
    'Rajdeep raheja exports private limited',
    'Prayag agencies pvt ltd',
    'TAPRANG HYDROCARBON TECHNOLOGIES PRIVATE LIMITED',
    'Reliance commodities limited',
    'Olive steel private limited',
    'India atlantic chemicals trading private limited',
    'Felder woodworking machines private limited',
    'Shilpa trade link private limited',
    'Kns overseas private limited',
    'Zigma goods private limited',
    'Aditrishyam textiles private limited',
    'Magasin distributors private limited',
    'Maximator india private limited',
    'Sohamma international private limited',
    'Tide water advanced materials limited',
    'Koshe exim private limited',
    'Sanika multitrade private limited',
    'Innovacion retail private limited',
    'Argus techno (india) private limited',
    'Cogent exports private limited',
    'MIRACLE WONDER SALES & MARKETING LIMITED',
    'N R MERCANTILES PVT LTD',
    'Basuki credit & finvestment pvt ltd',
    'Imtihan commercial pvt.ltd.',
    'Starpoint financial services private limited',
    'Preeti vanijya pvt ltd',
    'Intercon impex private limited',
    'Tml india private limited',
    'Infodrive india private limited',
    'Amanat merchants private limited',
    'Chandra vyapaar private limited',
    'Kamakhya vincom private limited',
    'Prime mover engineering company private limited',
    'L7 vintrade private limited',
    'Sekhsaria cotton exports private limited',
    'Texperts india private limited',
    'VEDANT FASHIONS LIMITED',
    'Vector systems private limited',
    'ARGUS PROJECTS PRIVATE LIMITED',
    'Asok brothers private limited',
    'Gentech global pharma private limited',
    '4EVERCLOUD RESOURCES & TECHNOLOGIES PRIVATE LIMITED',
    'Sanjeevani bio-tech exim private limited',
    'HERBIX INDIA PRIVATE LIMITED',
    'Neelesh industrial agency private limited',
    'APOLLO DE VALEUR PRIVATE LIMITED',
    'Aesera jewels private limited',
    'Tradex international private limited',
    'Metallium impex private limited',
    'Nostrum marketing private limited',
    'Tradeniger impex private limited',
    'Yadav impex private limited',
    'Eeetech infonet private limited',
    'Madhuli export private limited',
    'Apsnp technologies private limited',
    'Dlecta foods private limited',
    'Shree bajrang sales private limited',
    'Femstex trading company private limited',
    'Beacon mercantile private limited',
    'G. m. k. system and logistics private limited',
    'Gamut properties pvt ltd',
    'Clarico-fpc (india) private limited',
    'Manhar trading private limited',
    'New world trading (india) private limited',
    'Ipm india wholesale trading private limited',
    'A s ferrum private limited',
    'Fall arrest systems & technologies private limited',
    'Nabi engitech private limited',
    'Yash exports (india) private limited',
    'Peshavaria exports private limited',
    'Chandresh marketing pvt ltd',
    'Sucha exports private limited',
    'Sikko trade link private limited',
    'Agena international private limited',
    'Confident sales india private limited',
    'ISLEWORTH TRADELINKS LIMITED',
    'Neo art repository private limited',
    'Aakash equities private limited',
    'Marks marine radio private limited',
    'Betelnut fashions private limited',
    'BEAUTY WORKS PRIVATE LIMITED',
    'Dare fashion private limited',
    'Rna lifestyle private limited',
    'Vijayshri texcom private limited',
    'Locator marketing services private limited',
    'HOESCH METALLURGIE INDIA PRIVATE LIMITED',
    'Offshore trade india private limited',
    'M. pallonji enterprises private limited',
    'Deccan import and export private limited',
    'Esjaypee mercantile & marketing private limited',
    'Sri harismitha devi enterprises private limited',
    'Dialit services private limited',
    'Orange city hydraulic works private limited',
    'Finessense advisors private limited',
    'Oxford instruments india private limited',
    'Smith stone walters private limited',
    'MOE',
    'S HOSPITAL PRIVATE LIMITED',
    'REVVITY HEALTH SCIENCES PRIVATE LIMITED',
    'Indian institute of psychodrama private limited',
    'MANAV RAKSHAK HOSPITALS PRIVATE LIMITED',
    'Shiv jyoti hospitality private limited',
    'L.r.s. health care private limited',
    'Vani organics private limited',
    'TS FLOW CONTROLS PRIVATE LIMITED',
    'Imperial hospital and research centre limited',
    'C. krishniah chetty jewellers private limited',
    'AAREN BESPOKE LIVING PRIVATE LIMITED',
    'Phoenix holdings private limited',
    'Kaynes hotels private limited',
    'HEALTH SECURE HOSPITAL CARE & SOLUTIONS PRIVATE LIMITED',
    'Edappal hospitals p ltd',
    'Modern hospital kodungallur ltd',
    'Parco institute of medical sciences private limited',
    'JOTHYDEV',
    'APOLLO HOSPITALS NORTH LIMITED',
    'Midwest hospital and medical institute private limited',
    'Valas health centre private limited',
    'CURADEN DENTAL CLINICS INDIA PRIVATE LIMITED',
    'Koya health care private limited',
    'North bengal eye centre private limited',
    'World pranic healing india private limited',
    'Bengal speech & hearing private limited',
    'Puducherry adidravidar development corporation limited',
    'Creative eco-recycle port private limited',
    'Antony lara enviro solutions private limited',
    'Antony infrastructure and waste management services private limited',
    'ANTONY RECYCLING PRIVATE LIMITED',
    'DHANBAD FUELS PRIVATE LIMITED',
    'Cee pee veneers private limited',
    'Sbm welfare club limited',
    'A n global limited',
    'Movie times cineplex private limited',
    'Adlabs shringar multiplex cinemas private limited',
    'Skyline radio network limited',
    'Showworks eventz private limited',
    'Rangashree media communications private limited',
    'BLUEKITE AUDIOVISUALS PRIVATE LIMITED',
    'AGP WORLD PRODUCTIONS PRIVATE LIMITED',
    'HYDERABAD SOLAR PRIVATE LIMITED',
    'Im entertainment private limited',
    'Arcadia media & entertainment private limited',
    'One up media private limited',
    'Dna entertainment networks private limited',
    'Kotahwala enterprises private limited',
    'Mewar health management private limited',
    'Royal orchid garden private limited',
    'Patliputra entertainment private limited',
    'P & r films private limited',
    'Royal challengers sports private limited',
    'Premier leisure private limited',
    'Amaazia world theme park private limited',
    'Astro sports private limited',
    'Wackytoon studio private limited',
    'Sevents consultants private limited',
    'Indian automotive racing club limited',
    'Peppers media private limited',
    'Mahen distribution limited',
    'Grover sons holdings private limited',
    'Colossal infraservices private limited',
    'Nine dimension marketing private limited',
    'Park sintech company private limited',
    'Pari alloys private limited',
    'Laempe foundry technology private limited',
    'Chain tools and products private limited',
    'Aic iron industries private limited',
    'Ashish brass components private limited',
    'Veena die casters and engineers private limited',
    'Shri hari metal extruders (india) limited',
    'Arp complex private limited',
    'Nahata data products private limited',
    'Ajmera industries pvt ltd',
    'Rima transformers and conductors private limited',
    'Usmani tubes and valves company private limited',
    'Vms metal works private limited',
    'Harve metals india private limited',
    'Electromate components private limited',
    'Nord-schrott india private limited',
    'Metal forms private limited',
    'Foretek engineers private limited',
    'C p engineering (india) private limited',
    'B.d.castings ltd',
    'Kartavya mercantile private limited',
    'G b tools & forgings limited',
    'Jagdamba value steels private limited',
    'Greenearth engineering and infratech private limited',
    'L n technocast private limited',
    'Virat special steels private limited',
    'Siddhi forge pvt ltd',
    'Ascent cast tech private limited',
    'MITTAL FORGINGS AND COMPONENTS PRIVATE LIMITED',
    'Secan invescast india private limited',
    'ALUCAST INDIA PRIVATE LIMITED',
    'Lal baba seamless tubes private limited',
    'AAF ENTERPRISES PRIVATE LIMITED',
    'Aress metals private limited',
    'Pws towers private limited',
    'Krushi rebars services private limited',
    'Sreevaas roofing private limited',
    'Indian stores supplying company private limited',
    'Indo chains (raipur) private limited',
    'Tayal technologies limited',
    'Semco forge private limited',
    'Step cables private limited',
    'Tool fab engineering industries private limited',
    'Modular storage systems private limited',
    'Uci coatings private limited',
    'Universal heat exchangers limited',
    'JYOTI GLOBAL PLAST PRIVATE LIMITED',
    'Thermo solutions (india) private limited',
    'Mahendra dished ends private limited',
    'Mosaic houseware private limited',
    'Ace technomold private limited',
    'Sunmet metallurgical pvt ltd',
    'Sant gyaneshwar steels private limited',
    'ARM FASTENERS PRIVATE LIMITED',
    'Popley & sons jewellers private limited',
    'TULJA BHAVANI STAMPINGS PRIVATE LIMITED',
    'Reunion engineering compay private limited',
    'Elmot direct current machines private limited',
    'Jaivic electromech engineering private limited',
    'Naath industries private limited',
    'Interface engineering private limited',
    'Shobha engineering company private limited',
    'Royal brushes private limited',
    'Mikronix gauges private limited',
    'Mantri metallics private limited',
    'Bar corr coatings private limited',
    'Super auto enterprises private limited',
    'Spot electrotech systems private limited',
    'Bellis hardware private limited',
    'Comet tools (guj ) pvt ltd',
    'Perfect sealing systems pvt ltd',
    'Yoshika engineering private limited',
    'Micromax instruments private limited',
    'Kitagawa india private limited',
    'Suntrust aluminium private limited',
    'Pulsar coating equipments private limited',
    'Atharv welding technologies (india) private limited',
    'Mak clean air systems private limited',
    'Sterling fabricating engineers private limited',
    'Micro screw manufacturing company private limited',
    'Magnatherm alloys private limited',
    'Sangeeta tools private limited',
    'Pee kay scaffoldings and shutterings limited',
    'French engineering works pvt.ltd.',
    'Artifex machinery private limited',
    'Ventura pumps private limited',
    'P.r. acoustical and engineering works private limited',
    'Flojet engineers private limited',
    'Varron auto comp private limited',
    'DEL PD PUMPS & GEARS PRIVATE LIMITED',
    'Neptune industries limited',
    'Pune fin tube pvt ltd',
    'Jdm hydro pneumatics limited.',
    'Hi-bond bearings pvt ltd',
    'Goliya electricals private limited',
    'Simuli engineering solution private limited',
    'Smile automation private limited',
    'Anlinda gear technologies private limited',
    'Shri ram multicom private limited',
    'Nsw india limited',
    'Telekonnectors limited',
    'Scb engineers private limited',
    'Power arm india private limited',
    'Sky elevators private limited',
    'Apco cars private limited',
    'Signature automobiles kasargod private limited',
    'Gargya autocity private limited',
    'K S AGRO SERVICES PRIVATE LIMITED',
    'Susee trucks private limited',
    'Ghosh brothers auto sales private limited',
    'Advaitha projects & trade private limited',
    'Indus motor company private limited',
    'I ride enterprises private limited',
    'Orbit auto components private limited',
    'Parveen automobiles private limited',
    'SRI CHAKRA AUTOMOTIVES PRIVATE LIMITED',
    'Rohan auto sales private limited',
    'Hm international private limited',
    'Shanti automobiles company private limited',
    'LULU PROJECTS AND DEVELOPERS PRIVATE LIMITED',
    'SHRI MAHALAXMI AUTOPARTS PRIVATE LIMITED',
    'Kaysons associates private limited',
    'Velocity automotives private limited',
    'Velocity autolinks private limited',
    'S.t.s. auto private limited',
    'Ghosh brothers autoriders private limited',
    'Rr kalyankar hotels and resorts private limited',
    'Fairmate trading private limited',
    'Konark overseas private limited',
    'Shantinath motors private limited',
    'Walchand kamdhenu commercials private limited',
    'Dalal and broacha commodities private limited',
    'SAP SWISS SOLUTIONS PRIVATE LIMITED',
    'EMBASSY EAST BUSINESS PARK PRIVATE LIMITED',
    'Indo wire industries private limited',
    'Dasmaya multitrading private limited',
    'Sarovar enterprises private limited',
    'Alluri overseas private limited',
    'Asha vincom private limited',
    'Bilakes consulting private limited',
    'Multitek agencies private limited',
    'Nalli silk private limited',
    'Shree sharda trade comm private limited',
    'New frontier marketing and medical services private limited',
    'Sukhsagar vyapaar private limited',
    'Travel today india private limited',
    'World technological products private limited',
    'OSWAL POLY CHEM PRIVATE LIMITED',
    'Ndtv worldwide limited',
    'P.m. impex private limited',
    'Vayudoot impex private limited',
    'Jil trading private limited',
    'Mfl trading private limited',
    'Contractor and sons marketing private limited',
    'Tirupati enterprises (ranchi) private limited',
    'Satyatej mercantile private limited',
    'BHAGYANAGAR COPPER PRIVATE LIMITED',
    'Minerva merchandising company private limited',
    'Jotirdhar trading private limited',
    'Maaran multitrading private limited',
    'Collectibles antiques (india) private limited',
    'Elegant multiservices limited',
    'Green view impex private limited',
    'Poddar udyog limited',
    'G k trading pvt ltd',
    'Digvijay commodities pvt ltd',
    'Prc niyojan pvt. ltd.',
    'Nac travels pvt ltd',
    'Bhandari automobiles private limited',
    'Rajami barter pvt. ltd.',
    'Gorica auto ltd.',
    'Ajayhari textrade pvt.ltd.',
    'BLUMENOTICS PRIVATE LIMITED',
    'Skg coal traders pvt.ltd.',
    'Jalan packaging pvt ltd',
    'Roselab commodities pvt ltd',
    'Megha forwarders private limited',
    'Vagapra industries private limited',
    'Bpr overseas limited',
    'Secure express (india) private limited',
    'Jyothi commercial private limited',
    'Pharmachem traders private limited',
    'Suraj tie-up private limited',
    'Primerose vinimay private limited',
    'Compare commercial pvt ltd',
    'Shining merchants pvt ltd',
    'Marubhumi dealer pvt ltd',
    'Avon commodities private limited',
    'Outlook dealcom private limited',
    'Avikar tradecom private limited',
    'Saras vanijya private limited',
    'Peanuts retail private limited',
    'Evershine commodities private limited',
    'Virat international private limited',
    'Biostar vanijya private limited',
    'V-three fashion pvt.ltd.',
    'Ankita global india private limited',
    'Greenhouse cardamom marketing india private limited',
    'MADAN',
    'S EARTH PRIVATE LIMITED',
    'Sachet infrastructure private limited',
    'Sameeksha estate private limited',
    'Greystar buildcon private limited',
    'Hanuman heritage real estate private limited',
    'Antares properties private limited',
    'Abhiruchi realtors private limited',
    'Ajmera builders (banglore) private limited',
    'Metro builders orissa pvt ltd',
    'ADIILAKSMI INTERNATIONAL LIMITED',
    'Topline build-tech private limited',
    'Arg land developers private limited',
    'Royal ensign realtech private limited',
    'Dynasty construction private limited',
    'SSBC REALESTATE PRIVATE LIMITED',
    'Keerthi estates private limited',
    'Bhisham infrastructure private limited',
    'Spr buildtech limited',
    'Adbhoot estates private limited',
    'Mehak realtech private limited',
    'Magad realtors private limited',
    'Puja apartments pvt ltd',
    'Lakhi estates & holdings pvt ltd.',
    'P p developers pvt ltd',
    'Rochita towers and estates private limited',
    'Trambak multicon pvt.ltd.',
    'S m complex pvt ltd',
    'Edlin developers private limited',
    'MINING & DRILLING SERVICES PRIVATE LIMITED',
    'Craton estates private limited',
    'Beekay plaza private limited',
    'Bodhan infrastructure private limited',
    'Lnj realty private limited',
    'Viral ventures private limited',
    'Golden glow estates private limited',
    'Sri hari buildwell private limited',
    'Barter properties pvt ltd',
    'Guiding force developers private limited',
    'Arizona developers private limited',
    'Raikva developers pvt ltd',
    'Pincha griha nirmaan private limited',
    'Vrindavan realbuild private limited',
    'Godawari realbuild private limited',
    'CLIENT FIRST WEALTH MANAGEMENT PRIVATE LIMITED',
    'Narayan heritage realmart private limited',
    'Manogayan estates private limited',
    'Manilal properties private limited',
    'Gaaia developers private limited',
    'Tribhavan properties private limited',
    'Hormaze property private limited',
    'Vikruti estate private limited',
    'Nandana propbuild private limited',
    'Unibera developers private limited',
    'Shraddha auromira properties private limited',
    'Khushi landcon pvt ltd',
    'Mantri resi structures private limited',
    'Cavim realty private limited',
    'Sherhood properties private limited',
    'CHATTELS REALTY CONSULTANTS PRIVATE LIMITED',
    'Indivar properties pvt ltd',
    'Satsang yoga and meditation consultancy private limited',
    'Free power technology private limited',
    'P c consultancy pvt ltd',
    'Technomec solutions private limited',
    'Panchdeep medi-care private limited.',
    'Copious marketing pvt. ltd.',
    'AM UNICORN PROFESSIONAL PRIVATE LIMITED',
    'VISHWANVI ENGINEERING PRIVATE LIMITED',
    'LIFESTYLE & MEDIA HOLDINGS LIMITED',
    'Pams corporate advisory and management services private limited',
    'Unnati fortune holdings limited',
    'Brandrogen services private limited',
    'SILARIS INFORMATIONS PRIVATE LIMITED',
    'Nitisha flexo private limited',
    'Pixpert media solutions private limited',
    'Famcom rubbers products india private limited',
    'Insight financial services private limited',
    'Truptiatul investments services private limited',
    'Induslynk training services private limited',
    'Tratec engineers private limited',
    'Innocoat systems (india) private limited',
    'Target multipack india private limited',
    'Alvogen pharma (india) private limited',
    '7EDGE PRIVATE LIMITED',
    'Career bulls solutions private limited',
    'Shikhar international private limited',
    'Good luck capital private limited',
    'Spenta consultants private limited',
    'Neumann laraon communication systems private limited',
    'PIN CLICK PROPERTY MANAGEMENT PRIVATE LIMITED',
    'Rural engineers empowerment foundation',
    'Brilliance automation dynamics private limited',
    'Restore design private limited',
    'Global unified source for technology integration private limited',
    'Wemen financial services private limited',
    'Minerva properties private limited',
    'J.d. exim private limited',
    'Chemtrols solar private limited',
    'Avis technocrats private limited',
    'Lovable lifestyles private limited',
    'Arlon graphics private limited',
    'Worth services private limited',
    'TIMES EDUTECH AND EVENTS LIMITED',
    'Brooks brothers india private limited',
    'MALABAR AIF MANAGERS PRIVATE LIMITED',
    'Pranay traders and suppliers private limited',
    'C n k polymer products private limited',
    'Udyam foods limited',
    'NAUKRI INTERNET SERVICES LIMITED',
    'Samit spectrum eit private limited',
    'Jtg infotech services private limited',
    'Santa fe moving services private limited',
    'Sahiren builders and property developers private limited',
    'Arrow distribution (rajasthan) private limited',
    'R-tech properties private limited',
    'Spv enterprises private limited',
    'DEHU INDUSTRIES PRIVATE LIMITED',
    'Sharth engineers private limited',
    'SSM FORGE PRIVATE LIMITED',
    'Maestrotek innovations private limited',
    'Allied communication private limited',
    'Vab developers lab private limited',
    'Godaddy india web services private limited',
    'Aishan technologies india private limited',
    'Fesolve engineering services private limited',
    'Wendt holdings private limited',
    'Cellix bio private limited',
    'Autosys engineering private limited',
    'Mindscapes enhance communications private limited',
    'Dm consulting (india) private limited',
    'Redwoods logistics private limited',
    'Reefco container services (india) private limited',
    'Veda lighting design and systems private limited',
    'Yos sports and entertainment private limited',
    'Palco manufacturing (india) private limited',
    'Mmb vinimay private limited',
    'Panache immigration & education consultant private limited',
    'Prina era energy resources private limited',
    'Globalminds advisory services private limited',
    'JND LEADERSHIP SYSTEMS PRIVATE LIMITED',
    'Spectrum outsourcing solutions private limited',
    'HERO PBG CYCLES PRIVATE LIMITED',
    'Finobal services private limited',
    'Arks-edge corporate solutions (india) private limited',
    'Primajuris advisors private limited',
    'Surge tech solutions private limited',
    'ALLIANCE FACILITY MANAGEMENT PRIVATE LIMITED',
    'Prezantim creative services india private limited',
    'Olive films private limited (opc)',
    'Valiant india private limited',
    'Avenging security private limited',
    'Superfine photo company p.ltd.',
    'Personnel staffing solutions private limited',
    'Navistar international private limited',
    'Deesha trade endeavours pvt. ltd.',
    'Benign consultancy private limited',
    'Banco foundation',
    'Shrotra enterprises private limited',
    'Credit agricole cib services private limited',
    'Ogas equipments private limited',
    'Lucifer lights limited',
    'Shimbi computing laboratories private limited',
    'Blueline management services private limited',
    'Sactech automation india private limited',
    'Talentserv consulting private limited',
    'Praestans private limited',
    'Stallion fashions india private limited',
    'Dimple drums and barrels private limited',
    'SIDHARTH PAPERS Private Limited',
    'Benesome apparel private limited',
    'Golden designs india private limited',
    'Krafts printographics private limited',
    'DSM STEEL & WIRES PRIVATE LIMITED',
    'Dhansu engineering private limited',
    'Shri adhya educational books private limited',
    'Rubber publications (bombay) private limited',
    'Divya himachal prakashan private limited',
    'Pathfinder publishing private limited',
    'Rkdk publishers private limited',
    'Golden fashions india private limited',
    'Spanish millstream leathers private limited',
    'Navvikas trading pvt ltd',
    'Funtimes edutainment private limited',
    'Ferror designs (india) private limited',
    'N.s. international private limited',
    'Rustom projects private limited',
    'Shreysha creations private limited',
    'Vivo holdings international private limited',
    'Shree ganesh knit (india) limited',
    'AGUAS EXIM LIMITED',
    'BBK EXPORTS PRIVATE LIMITED',
    'Iris fashions private limited',
    'Axiom apparels private limited',
    'Maxima fashions exports private limited',
    'Pol publishers private limited',
    'Vimbri media private limited',
    'Saroj prints (chennai) private limited',
    'Strat-media partners private limited',
    'Coordinates media private limited',
    'Lettershop india private limited',
    'Don and julio apparels worldwide private limited',
    'Gspc lng limited',
    'Sungroup enterprises private limited',
    'Ipv eco-projects (gmp) private limited',
    'Altaroma chemicals private limited',
    'Helsa - icon india private limited',
    'Elaion oleochemicals private limited',
    'AMI ORGANICS LIMITED',
    'Kejriwal fashions private limited',
    'P.p. sheth aromas private limited',
    'LUPIN DIAGNOSTICS LIMITED',
    'CHEMBOND BIOSCIENCES LIMITED',
    '1UP LIFE CARE PRIVATE LIMITED',
    'Zucchini india r & d chemicals private limited',
    'Escientia biopharma private limited',
    'Imedic medical solutions private limited',
    'Klassik garments private limited',
    'Karle packaging private limited',
    'Santosh packaging private limited',
    'Narayan organics pvt ltd',
    'Health and hygiene products(india)limited',
    'A K FORMALINE (I) PRIVATE LIMITED',
    'Indo nippon chemical company limited',
    'Everest chemicals and minerals private limited',
    'Unitop chemicals private limited',
    'Aristo laminates private limited',
    'Agma packaging private limited',
    'Anand emballage private limited',
    'JPH PUBLISHING HOUSE PRIVATE LIMITED',
    'S.amit speciality chemicals private limited',
    'Memba chem industries private limited',
    'Cs bio - sciences private limited',
    'Imagico india private limited',
    'Thiocom speciality chemicals private limited',
    'Novo nordisk india private limited',
    'Epe process filters and accumulators private limited',
    'Bhanu dyes private limited',
    'Arunachal times publications pvt ltd',
    'Reliable advertising private limited',
    'Prayag chemicals private limited',
    'Apac sourcing solutions limited',
    'Orio shanghai colours private limited',
    'Govind furnishings private limited',
    'KINECO LIMITED',
    'Artfirst publications private limited',
    'Sankalp printers private limited',
    'Nandu chemicals private limited',
    'Abohar gold grow private limited',
    'Sonara sanitary wares private limited',
    'Avon fashions pvt ltd',
    'Deys graphics private limited',
    'Plantag coatings india private limited',
    'Avance healthcare private limited',
    'Farichem laboratories private limited',
    'Medisearch laboratories (bombay) private limited',
    'Idea printcity private limited',
    'Varion lifesciences private limited',
    'Smilax laboratories limited',
    'Mavenvista technologies private limited',
    'Ban labs private limited',
    'Maji coatings private limited',
    'New era press private limited',
    'ELI ARREVIO PRIVATE LIMITED',
    'Astra lifecare (india) private limited',
    'Americos chemicals private limited',
    'Anphar organics private limited.',
    'Shakti keypads private limited',
    'Medopharm private limited',
    'CIBI BIO PRODUCTS INDIA PRIVATE LIMITED',
    'Sun farmaceutical pvt ltd',
    'Euclid constructions limited',
    'CHOICE ESTATES AND CONSTRUCTIONS Private Limited',
    'Kanoos business india private limited',
    'Trisys communications pvt ltd',
    'Shrachi developers pvt ltd',
    'Ascent housing private limited',
    'Paradise infra-con private limited',
    'Ashtavinayak infrastructures private limited',
    'Integrated mumbai business park (india) private limited',
    'Sai kripa infrastructures private limited',
    'Saffron home developers private limited',
    'Rohan builders (india) private limited',
    'Jp structures private limited',
    'Sridhar constructions private limited',
    'Locus constructions private limited',
    'Baisiwala builders and developers pvt. ltd',
    'Aco realty private limited',
    'Gopalan enterprises (india) private limited',
    'Brij buildestates private limited',
    'Gmr ambala-chandigarh expressways private limited',
    'Suyaan infrastructure private limited',
    'Mittal infrastructure private limited',
    'Triayudh constructions private limited',
    'Regent metropolitan services private limited',
    'Geotech infrahomes private limited',
    'Reyami electro mechanical (india) private limited',
    'Karle infra private limited',
    'Rewa projects private limited',
    'Lido malls management private limited',
    'Econstruct design & build private limited',
    'Jsw organics private limited',
    'Knitcitiy developerss private limited',
    'Sa property management private limited',
    'Tricolour properties private limited',
    'Sharma housing (india) private limited',
    'PHOENIX TECH ZONE PRIVATE LIMITED',
    'Tirupati grih & promoters pvt ltd',
    'Mpc properties private limited',
    'Shail nirman limited',
    'Gr tech services private limited',
    'Kinfra international apparel parks limited',
    'Greenfield creations private limited',
    'Pcm strescon international private limited',
    'Agrim realtech private limited.',
    'Niwas realtech private limited.',
    'Namish projects pvt ltd',
    'Ramani promoters private limited',
    'K. k .enclave pvt. ltd.',
    'Vicon imperial (i) private limited',
    'T-series motion pictures private limited',
    'Shinde holdings private limited',
    'Unishire promoters private limited',
    'KN REALTY VENTURES PRIVATE LIMITED',
    'Asl realties private limited',
    'Mithleash infrastructure private limited',
    'Kartik buildcon private limited',
    'B s realty (india) private limited',
    'Ascendas it park (pune) private limited',
    'Kurukshetra expressway private limited',
    'Pragati warehousing private limited',
    'Mayan infrastructure private limited',
    'Sainadu infrasturcture private limited',
    'Star automotors private limited',
    'CYQUREX SYSTEMS PRIVATE LIMITED',
    'Goldendunes builders and developers private limited',
    'Abr infrasolutions private limited',
    'RELIABLE HOMEMAKERS & INFRASTRUCTURE PRIVATE LIMITED',
    'Supreme best value kolhapur(shiroli) sangli tollways private limited',
    'Sumer reality (india) private limited',
    'Jasdan construction private limited',
    'Mudda propbuild private limited',
    'VAIDYA SPACES PRIVATE LIMITED',
    'Mahim realty private limited',
    'Southern investments private limited',
    'Apex foundations private limited',
    'Sri krishna builders & engineers private limited',
    'Rrbun shapes private limited',
    'Keshthana infrastructure private limited',
    'Padmalaya developers private limited',
    'Biswanath real estate private limited',
    'Growth buildwell private limited',
    'Bharat heights limited',
    'Shail industries limited',
    'Right infrastructure private limited',
    'Greenfinity getaways private limited',
    'Helios infrapro private limited',
    'Bluesky projects private limited',
    'BNE INFRATECH LIMITED',
    'Pine air private limited',
    'Hyptis infrastructure private limited',
    'Shiv krishna construction private limited',
    'Kelvin buildcon private limited',
    'Vk ready mix concrete private limited',
    'Buraq infra private limited',
    'Sourabh constructions private limited',
    'Rmj developers private limited',
    'RAJDARBAR HIGHTECH CITY PRIVATE LIMITED',
    'Abhijit auto agency india private limited',
    'Ava properties private limited',
    'Jaika automobiles and finance pvt ltd',
    'Joshi automotives private limited',
    'Viva western developers private limited',
    'Banka constructions private limited',
    'Cosmo infratel private limited',
    'Moongipa share brokers private limited',
    'Jv capital services private limited',
    'Zion money changers private limited',
    'Foreign exchange dealers association of india',
    'JAINAM BROKING LIMITED',
    'Jsons holding private limited',
    'R r chit funds vuyyuru private limited',
    'Haryana saving units private limited',
    'Vakksh trusteeship services private limited',
    'Annilna investment pvt ltd',
    'CHOLAMANDALAM HOME FINANCE LIMITED',
    'Yodelsim holdings pvt. ltd.',
    'ARIHANT',
    'JUNCTION PRIVATE LIMITED',
    'Ridgecone technologies private limited',
    'Vtpl solutions private limited',
    'Compulink (india) pvt ltd',
    'System international private limited',
    'Thru-put management systems private limited',
    'Ultimate computech private limited',
    'Rgba studios private limited',
    'Mindgate solutions private limited',
    'Dealogic support services india private limited',
    'TESTBOOK EDU SOLUTIONS PRIVATE LIMITED',
    'Wefe technology private limited',
    'FAREYE TECHNOLOGIES PRIVATE LIMITED',
    'Sas research and development (india) private limited',
    'Nor-link it solutions private limited',
    'Iwork technologies private limited',
    'Cameo digital systems private limited',
    'Varstreet software (india) private limited',
    'Cygnus e-solutions private limited',
    'Compserv technologies private limited',
    'V synergize outsourcing private limited',
    'Purpleradiance technologies private limited',
    'Lexicon networks india private limited',
    'M3bi india private limited',
    'Savetime technologies private limited',
    'Eiza technologies india private limited',
    'TRAVEAZY TECHNOLOGIES PRIVATE LIMITED',
    'Satkar software solution private limited',
    'Gofusion software private limited',
    'Bioserve biotechnologies (india) private limited',
    'Techsmart india private limited',
    'V-empower solutions private limited',
    'Cistron infotek private limited',
    'Shaster technologies private limited',
    'Guru gowri krupa technologies private limited',
    'Sritech electronics and systems private limited',
    'Talent pool india solutions private limited',
    'Adroitent ites private limited',
    'Yotta technologies private limited',
    'Aim computer consulting private limited',
    'Pentagon rugged systems (india) private limited',
    'Tangent solutions (india) private limited',
    'Sapio solutions private limited',
    'Sarga software solutions private limited',
    'Aster minds enterprise solutions private limited',
    'Ivoice networks private limited',
    'Rushil micro it solutions private limited.',
    'Expertease software (india) private limited',
    'Revevol technologies india private limited',
    '3pleplay web solutions private limited',
    'Iadore transtech private limited',
    'Exaact compusoft global solutions private limited',
    'DEXTER SYSTEMS PRIVATE LIMITED',
    'Hydoodle techonologies private limited',
    'Genems systems private limited',
    'Focal cxm private limited',
    'Vector visual magic private limited',
    'Gembrill technologies india private limited',
    'Edupoint solutions private limited',
    'Carizen software private limited',
    'Softcrylic technology solutions india private limited',
    'Thapovan info systems private limited',
    'Trayee business solutions private limited',
    'Eighthills software private limited',
    'Itss (india) private limited',
    'Sahasra solutions private limited',
    'D-tools development center private limited',
    'Staunch technologies private limited',
    'Dotsolved india private limited',
    'Kaar technologies india private limited',
    'Nila innovatives private limited',
    'Emvee information technologies private limited',
    'Haliscape business solutions private limited',
    'Marmore mena intelligence private limited',
    'Xcode life sciences private limited',
    'Alpha facility services private limited',
    'Casa interior studio private limited',
    'Precious intelligence india private limited',
    'Rf wave technologies private limited',
    'Grand banyan ventures private limited',
    'Arrow serviced offices private limited',
    'CMJ REFRACTORIES & MINERALS PRIVATE LIMITED',
    'Integra healthcare systems private limited',
    'Navsan vyapaar private limited',
    'Brain management consultants (india) private limited',
    'Fitkids education and training private limited',
    'Motivational trainers association',
    'Usha martin education private limited',
    'Christiani sharpline technical training private limited',
    'Digital keyboard private limited',
    'Educator h2o private limited',
    'Greenwoods edu facilities private limited',
    'Edufice education services private limited',
    'I-VISTA WEB SOLUTIONS PRIVATE LIMITED',
    'Gem education systems international limited',
    'Chrysalis learning private limited',
    'GAUTAM BANERJEE',
    'ASSOCIATIONS OF INDIA',
    'All india association of industries',
    'Indian association of amusement parks and industries',
    'Anudip foundation for social welfare',
    'Developing internet safe community foundation',
    'Hirani foundation u s 25',
    'INTERNATIONAL CHAMBER OF GST PROFESSIONALS',
    'Raheja icon entertainment private limited',
    'Happy and ruby cinemas private limited',
    'Rajmudra films and entertainment private limited',
    'Culture company (india) private limited',
    'City studio private limited',
    'Id8 films private limited',
    'GEMINI ENGI-FAB PRIVATE LIMITED',
    'Advance compseals private limited',
    'Ams bhargava machining private limited',
    'Sigma tools and accessories private limited',
    'Sai tools private limited',
    'Imet tooling india private limited',
    'Rigi cut tools private limited',
    'Rbh alukad private limited',
    'Kj steeltek designs and products private limited',
    'Arshee auto private limited',
    'Sainest tubes private limited',
    'Sirius zip fasteners private limited',
    'AMGLO RESOURCES PRIVATE LIMITED',
    'Starways auto private limited',
    'Primo automation systems private limited',
    'Dazzle robotics private limited',
    'ENERGY-MISSION MACHINERIES (INDIA) LIMITED',
    'Lancer fab tech private limited',
    'Ehwa diamond india private limited',
    'Servo hydraulics private limited',
    'Flowserve microfinish valves private limited',
    'Hydromachanic transmission india private limited',
    'W. hunger hydraulics india private limited',
    'LAXMI BEARINGS PRIVATE LIMITED',
    'Maruti needle bearings private limited',
    'Vikson spring private limited',
    'Fec india private limited',
    'Innotrans systems india private limited',
    'Suryadev alloys and power private limited',
    'Harshal control systems private limited',
    'Mcm flexi cladding (india) private limited',
    'R r soura shakti private limited',
    'BorgWarner Emissions Talegaon Private Limited',
    'Tristar container services (asia) private limited',
    'Bajaj appliances limited',
    'Aircare technologies india private limited',
    'COPELAND INDIA PRIVATE LIMITED',
    'Fair pack machineries private limited',
    'NEW AMBICA CRANES PRIVATE LIMITED',
    'Paloma turning co private limited',
    'Vispo alternate energy private limited',
    'Prompt energy system private limited',
    'Go engineering private limited',
    'SASTEC INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'Warmex engineering private limited',
    'Budenberg gauge private limited',
    'Planodrives asia private limited',
    'Master levi services (india) private limited',
    'Benninger india private limited',
    'Wirtgen india private limited',
    'Tafe motors and tractors limited',
    'Indpro engineering systems private limited',
    'Kansawala tools and hardware private limited',
    'Skanda machine tools private limited',
    'Integral system and components private limited',
    'Poly drill engineers pvt ltd',
    'Opptum engineering solutions private limited',
    'M m gears private limited',
    'Flow well precision products private limited',
    'Sterling rotating systems private limited',
    'Galvano centricast private limited',
    'United engitech private limited',
    'Tritorc equipments private limited',
    'ASHTBHUJ ENTERPRISES PRIVATE LIMITED',
    'VASU TELE MARKETING PRIVATE LIMITED',
    'Atn engineering private limited',
    'Eurobelt belting solutions private limited',
    'Kelvolt (india) private limited',
    'Flucon engineering india private limited',
    'Raut industries private limited',
    'Airon corporation private limited',
    'Sparold technologies private limited',
    'Sumanam engineering services private limited.',
    'Perkins india private limited',
    'Conquip n cast private limited',
    'Techno crescent private limited',
    'Pesmel packaging india private limited',
    'Pinnacle equipments private limited',
    'Ppt aero hydraulics private limited',
    'Victory plant and machinery private limited',
    'Shakti component ventures private limited',
    'Kllifton forge private limited',
    'Jakob muller (india)private limited',
    'Gujrat lathe manufacturing company private limited',
    'Hydrochem engineers (bombay) pvt.ltd.',
    'Labcon scientific instruments p ltd',
    'KIRAN MACHINE TOOLS PRIVATE LIMITED',
    'Sai vending solutions private limited',
    'Elpie engineers private limited',
    'Melco engraving india private limited',
    'Trimurti stainlink equipments private limited',
    'Mack pharmatech private limited',
    'Fette compacting machinery india private limited',
    'Modular tanks private limited',
    'Madhu machines & systems private limited',
    'Earthcare enviro solutions private limited',
    'Homag india private limited',
    'REL-METH CONSULTANTS & ENGINEERS PRIVATE LIMITED',
    'Vulkan technologies private limited',
    'Wohr parking systems private limited',
    'Horizon chutes private limited',
    'EXCEL MARITIME & LOGISTICS PRIVATE LIMITED',
    'Saidatta logistics private limited',
    'Chandra maritime private limited',
    'Eagle trans shipping & logistics (india) private limited',
    'G r shipping private limited',
    'Snp shipping services pvt ltd',
    'Pearl shipping private limited',
    'Ocean blue management private limited',
    'Sea shine shipping services private limited',
    'Infinity shipping private limited',
    'Port logistics management private limited',
    'Spar logistics services private limited',
    'Airline promotion group india private limited',
    'Hadid india services private limited',
    'Swift freight moovers india private limited',
    'Luxe destinations private limited',
    'AEROCRUZ LOGISTICS PRIVATE LIMITED',
    'KULIN KUMAR TRAVELS PRIVATE LIMITED',
    'Sevenseas global freight systems private limited',
    'Sv freight and logistics private limited',
    'Yuam crew management private limited',
    'Age shipping and logistics private limited',
    'BEECH MARINE & LOGISTICS PRIVATE LIMITED',
    'Adinath cargo care private limited',
    'Arrkay tranship forwarders private limited',
    'All india clearing and forwarding private limited',
    'Gateway maritime private limited',
    'Global ocean clearing private limited',
    'Shuvam clearing agency private limited',
    'Hind carriers private limited',
    'Dp logistics private limited',
    'Mithila marine agency private limited',
    'Multimodal logistic systems private limited',
    'Safe and sure marine services private limited',
    'Go cargo private limited',
    'Shertrans shipping private limited',
    'HYHT ENTERPRISES PRIVATE LIMITED',
    'Agl shipping company private limited',
    'A.r.s. international private limited',
    'Polar cold storage private limited',
    'Finesse shipping lines private limited',
    'Logiwiz logistics india private limited',
    'Matrix warehousing private limited',
    'Imperial journey private limited',
    'Vyomayan travel management and hospitality company private limited',
    'Hind terminals private limited',
    'Alauddin logistics private limited',
    'Indiska india imp-ex private limited',
    'Prodapt logistics holdings private limited',
    'Shivam seatrans private limited',
    'Sart services (india) private limited',
    'Argosy shipping agency private limited',
    'O s s air management private limited',
    'Yes travels and hospitality limited',
    'Travel operators for tigers india wildlife association',
    'Ashwin logistics private limited',
    'Ran tourista travels private limited',
    'Kaizen shipping private limited',
    'Acumen travels (india) private limited',
    'Arv holidays private limited',
    'Lta tours private limited',
    'Movex relocations private limited',
    'Global wings tours (india) private limited',
    'ANP TRAVELS AND LOGISTICS INDIA PRIVATE LIMITED',
    'Destino travel world private limited',
    'Satyam international placements private limited',
    'Banyan tours and travels private limited',
    'HALAR SHIP & FREIGHT FORWARDERS PRIVATE LIMITED',
    'S & f financial services private limited',
    'Atlas aviation (i) private limited',
    'Traveloptionz holidays private limited',
    'Newstar tours & travels private limited',
    'Sv3 tours private limited',
    'Orbit travel and tours private limited',
    'Pathy travels and tours india private limited',
    'Ntl india private limited',
    'United visa services private limited',
    'Aeeroworld aviation private limited',
    'SAFETRANS MULTIMODAL PRIVATE LIMITED',
    'Transpeed logistics private limited',
    'Maaruti logistic services private limited',
    'Recpangar art of bicycle trips private limited',
    'Trailroot holidays private limited',
    'Regalindia tours and travels private limited',
    'Transatlantic shipmanagement limited',
    'Ggi clearing and forwarding private limited',
    'R and y logistics private limited',
    'Paramount forwarders private limited',
    'Relogistics (india ) private limited',
    'QUADRALYST PRIVATE LIMITED',
    'CUPTEA MEDIA (OPC) PRIVATE LIMITED',
    'VEDISTRY PRIVATE LIMITED',
    'HORIZON LUMINOUS LIMITED',
    'CRESLA PRIVATE LIMITED',
    'AARADHYA MULTI SERVICES INDIA PRIVATE LIMITED',
    'NAZZIO MEDICAL SYSTEMS PRIVATE LIMITED',
    'SANDHYA CHEMICALS PRIVATE LIMITED',
    'SREE BHARATHI NARAYANA REDDY BREEDING FARM PRIVATE LIMITED',
    'DOUBLEO SHARED SERVICES PRIVATE LIMITED',
    'DOC4CARE INFOSOLUTIONS PRIVATE LIMITED',
    'OMVAPT PRIVATE LIMITED',
    'ADLOID TECHNOLOGIES PRIVATE LIMITED',
    'SHIKHAR AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'DINAKAR POWER PROJECTS PRIVATE LIMITED',
    'GENIOCODE INNOVATIONS PRIVATE LIMITED',
    'EVOTAR TECHNOLOGIES PRIVATE LIMITED',
    'INTEGRATED ACTIVE MONITORING PRIVATE LIMITED',
    'LUBRILOG INDIA PRIVATE LIMITED',
    'D.V.I. SOLUTIONS (G) PRIVATE LIMITED',
    'CHOICE LAKEALIVE ENVIRON ENGINEERS PRIVATE LIMITED',
    'SAGARMALA COASTAL LIMITED',
    'ZERMATT PHARMACEUTICALS PRIVATE LIMITED',
    'METSURFIN PRIVATE LIMITED',
    'SAMTEK CLEAN & CLEAR SYSTEMS PRIVATE LIMITED',
    'AQUASOLI ENGINEERING INDIA PRIVATE LIMITED',
    'GENPRO LIFE SCIENCES INDIA PRIVATE LIMITED',
    'VENTURAWORLD PRIVATE LIMITED (OPC)',
    'SIHL GLOBAL INVESTMENTS (IFSC) PRIVATE LIMITED',
    'SMARTOFFICE PAYROLL AND BIOMETRICS SOLUTIONS PRIVATE LIMITED',
    'IDB POWER SOLUTIONS PRIVATE LIMITED',
    'SABER TRAVELS PRIVATE LIMITED',
    'AMPRI ORANGE PRODUCER COMPANY LIMITED',
    'MANDARK TECHNOLOGIES PRIVATE LIMITED',
    'CRAYO TECH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'D.R. PLASTO TECH PRIVATE LIMITED',
    'RELIUS LIFESCIENCES PRIVATE LIMITED',
    'KORSCH INDIA PRIVATE LIMITED',
    'GERON ENGINEERING PRIVATE LIMITED',
    'DHARAM DIGITAL PRIVATE LIMITED',
    'AABOLI INDIA PRIVATE LIMITED',
    'TEAM TALENT FACTORY PRIVATE LIMITED',
    'PRINCEADVERTISING PRIVATE LIMITED',
    'HEALTH WEALTH MANAGEMENT PRIVATE LIMITED',
    'WEALTHSTREET FINANCIAL SERVICES PRIVATE LIMITED',
    'BALAJI TRIPS PRIVATE LIMITED',
    'DORI HEALTH PRIVATE LIMITED',
    'SIS SYNERGISTIC ADJACENCIES VENTURES PRIVATE LIMITED',
    'FENEPLAST MANUFACTURING (INDIA) PRIVATE LIMITED',
    'JAYPEE CAPITAL SERVICES IFSC PRIVATE LIMITED',
    'JM FINANCIAL HOME LOANS LIMITED',
    'HAPPY LOAN MANAGEMENT PRIVATE LIMITED',
    'HUMSAFAR CHIT FUNDS PRIVATE LIMITED',
    'TOTAL SECURITIES (IFSC) PRIVATE LIMITED',
    'GO DIGIT GENERAL INSURANCE LIMITED',
    'REALFIN IMF PRIVATE LIMITED',
    'HIVELOOP CAPITAL PRIVATE LIMITED',
    'VOZILO INVESTMENTS PRIVATE LIMITED',
    'SERVICOMATIC SERVICES PRIVATE LIMITED',
    'CREDIT4YOU FINANCE PRIVATE LIMITED',
    'ENERFRA (INDIA) PRIVATE LIMITED',
    'GRAMYA SANJYOG MICRO FINANCE FOUNDATION',
    'ARVED AJWA THEME PARK PRIVATE LIMITED',
    'CLIX HOUSING FINANCE LIMITED',
    'MIRPUR NIDHI LIMITED',
    'ANUTHAM REALTY PRIVATE LIMITED',
    'SREEKOVIL REALTY PRIVATE LIMITED',
    'TATHAWADE LAND DEVELOPER PRIVATE LIMITED',
    'SHANTI INFRAHEIGHTS PRIVATE LIMITED',
    'SRI VENKATESWARA INFRA DEVELOPERS PRIVATE LIMITED',
    'KASHI CAPITAL PRIVATE LIMITED',
    'RAHEJA LIVE PRIVATE LIMITED',
    'RAJVIR HOMES PRIVATE LIMITED',
    'SPOTLITE PROJECTS PRIVATE LIMITED',
    'SWASTIKA INVESTMART (IFSC) PRIVATE LIMITED',
    'GLOBE CAPITAL (IFSC) LIMITED',
    'DAYCO SECURITIES (IFSC) PRIVATE LIMITED',
    'MODEX INTERNATIONAL SECURITIES IFSC PRIVATE LIMITED',
    'SILVER STREAM EQUITIES (IFSC) PRIVATE LIMITED',
    'TRADEAIR (IFSC) PRIVATE LIMITED',
    'COPE PROPERTY PRIVATE LIMITED',
    'STAR FINVEST (IFSC) PRIVATE LIMITED',
    'ATHENA ABODE PRIVATE LIMITED',
    'NITHYAM REALTY PRIVATE LIMITED',
    'AFFINITY GLOBAL (IFSC) PRIVATE LIMITED',
    'GANESH INTERNATIONAL FINANCIAL SERVICES (IFSC) PRIVATE LIMITED',
    'SPEED VENTURES PRIVATE LIMITED',
    'APARNA AFFORDABLE HOUSING PRIVATE LIMITED',
    'APARNA VALUE HOUSING PRIVATE LIMITED',
    'APARNA GREEN PASTURES PRIVATE LIMITED',
    'INCOR REAL VENTURES PRIVATE LIMITED',
    'ESTEE IFSC PRIVATE LIMITED',
    'SPACEMAZE PRIVATE LIMITED',
    'GREEN VIRIDITY PRIVATE LIMITED',
    'NUVAMA CAPITAL SERVICES (IFSC) LIMITED',
    'SMARTEX COGNITIVE PRIVATE LIMITED',
    'ALCOR SOLUTIONS INDIA PRIVATE LIMITED',
    'ASPIREEDGE SOLUTIONS PRIVATE LIMITED',
    'DYNAKODE SPORTS TECHNOLOGY PRIVATE LIMITED',
    'TALKCHARGE TECHNOLOGIES PRIVATE LIMITED',
    'BAJILLION LABS PRIVATE LIMITED',
    'GRD SECURITIES IFSC LIMITED',
    'DISTRESS BRICKS PRIVATE LIMITED',
    'ABHRANT PROPERTY COUNSELING SERVICES PRIVATE LIMITED',
    'SUNVENN ADVISORS PRIVATE LIMITED',
    'PPMS UBER ESTATES PRIVATE LIMITED',
    'NAVABHYUDAYA NAGAR DEVELOPMENT PRIVATE LIMITED',
    'IGT FINANCIAL SERVICES PRIVATE LIMITED',
    'APARNA GREEN VICINITIES PRIVATE LIMITED',
    'IVN CONSTRUCTIONS PRIVATE LIMITED',
    'EVERMORE GLOBAL (IFSC) PRIVATE LIMITED',
    'ASSUREPLUZ CONSUMER SERVICES PRIVATE LIMITED',
    'TRUEFILL SOFTWARE PRIVATE LIMITED',
    'LUMBINI PROPERTIES PRIVATE LIMITED',
    'ROMELL REAL ESTATE BUILDERS PRIVATE LIMITED',
    'CIRCLE EDGES PRIVATE LIMITED',
    'ANIDRA RAKSHA PRIVATE LIMITED',
    'APARNA MALLS PRIVATE LIMITED',
    'B2B TRAVEL AGENCY INDIA PRIVATE LIMITED',
    'MIND SPORTS LEAGUE PRIVATE LIMITED',
    'AUTOGRID INDIA PRIVATE LIMITED',
    'BIRDEYE SOFTWARE INDIA PRIVATE LIMITED',
    'PRESCINTO TECHNOLOGIES PRIVATE LIMITED',
    'SQUINT METRICS PRIVATE LIMITED',
    'NTT INDIA GDC PRIVATE LIMITED',
    'GOWELL INFRASTRUCTURE PRIVATE LIMITED',
    'VISTAR HEIGHTS PRIVATE LIMITED',
    'TESTINGWHIZ SOLUTION PRIVATE LIMITED',
    'VISTAR SUPERSTRUCTURES PRIVATE LIMITED',
    'DNN INFRA AND AGRO DEVELOPMENT PRIVATE LIMITED',
    'INFOFAC LABS PRIVATE LIMITED',
    'HYDE PARK SOLUTIONS PRIVATE LIMITED',
    'KYEPOT TECHNOLOGIES PRIVATE LIMITED',
    'DIGITECH ELECTRONIC SYSTEMS PRIVATE LIMITED',
    'SYNAPTEIN SOLUTIONS PRIVATE LIMITED',
    'PWAVE TECHNOLOGIES PRIVATE LIMITED',
    'TEKZEE TECHNOLOGIES PRIVATE LIMITED',
    'DHI TATTVA SOLUTIONS PRIVATE LIMITED',
    'ADGLOB INFOSYSTEM PRIVATE LIMITED',
    'VIRGO INNOVATION PRIVATE LIMITED',
    'NOWCOM GLOBAL SERVICES INDIA PRIVATE LIMITED',
    'OWNSTYLE TECHNOLOGIES PRIVATE LIMITED',
    'BE BOUND INDIA PRIVATE LIMITED',
    'BRAINY IOT PRIVATE LIMITED',
    'GROWEL TECHSOFT PRIVATE LIMITED',
    'LIFEMATE RETAILS PRIVATE LIMITED',
    'INSTITUTE OF NUTRITION AND FITNESS SCIENCES PRIVATE LIMITED',
    'GO DIGIT INFOWORKS SERVICES PRIVATE LIMITED',
    'AMRITSAR SMART CITY LIMITED',
    'LIVON PAINTS PRIVATE LIMITED',
    'PULSEBAY PRIVATE LIMITED',
    'APNAYAT FOUNDATION',
    'ANILEE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'AODH LIFESCIENCES PRIVATE LIMITED',
    'SKILLSPOC SERVICES PRIVATE LIMITED',
    'EYEDENTIFY SYSTEMS PRIVATE LIMITED',
    'ASTEROID INNOVATIONS INDIA PRIVATE LIMITED',
    'BUTLAS CONSULTING ENGINEERS PRIVATE LIMITED',
    'DRUTA DESIGNS PRIVATE LIMITED',
    'IITH TECHNOLOGY RESEARCH PARK FOUNDATION',
    'RHYTHM VFX STUDIOS PRIVATE LIMITED',
    'HATIGEN CONSULTING SERVICES PRIVATE LIMITED',
    'OPENWIFI LABS PRIVATE LIMITED',
    'HYDERABAD EVENTS INDUSTRY PRIVATE LIMITED',
    'ACUTUS ANALYTICS PRIVATE LIMITED',
    'PWOG PLANT ENGINEERING PRIVATE LIMITED',
    'UEF CHAMBER OF COMMERCE',
    'ESD TECHCON (OPC) PRIVATE LIMITED',
    'EASEASSIST INFORMATION SOLUTIONS PRIVATELIMITED',
    'SCALE LABS MULTI CHANNEL PRIVATE LIMITED',
    'AMERI RESEARCH INDIA PRIVATE LIMITED',
    'ADAPS IT PRIVATE LIMITED',
    'SHREEHATKESHWARA HOLDINGS PRIVATE LIMITED',
    'MAXIML LABS PRIVATE LIMITED',
    'ADITYA HOTELS AND HOSPITALITIES PRIVATE LIMITED',
    'BUSINESS EXCELLENCE ASSESSMENT PRIVATE LIMITED',
    'PETRICHOR ELIXIRS PRIVATE LIMITED',
    'LEMURIA DIGITAL MARKETING PRIVATE LIMITED',
    'VOZILO COMMODITIES PRIVATE LIMITED',
    'FLEXOPLAST ENGINEERING INDIA PRIVATE LIMITED',
    'FALOODA BIZZ HUB INDIA PRIVATE LIMITED',
    'NEBESKIE LABS PRIVATE LIMITED',
    'GREENNSURE POWER PRIVATE LIMITED',
    'HIKERS HIRING SOLUTIONS PRIVATE LIMITED',
    'TRIO MAGIC INFRA-PROJECTS PRIVATE LIMITED',
    'FRONTLINESYSTEMS INDIA PRIVATE LIMITED',
    'VINTEK AIR TECHNOLOGY PRIVATE LIMITED',
    'S RETAIL LIMITED',
    'HOLDING HANDS PEOPLE MANAGEMENT PRIVATE LIMITED',
    'SHRI SAI KHEMANAND AGRO ENERGY PRODUCER COMPANY LIMITED',
    'LUCIDA TECHNOLOGIES PRIVATE LIMITED',
    'KARVY BROKING (IFSC) LIMITED',
    'MIND LEADERS LEARNING INDIA PRIVATE LIMITED',
    'FMC LABS PRIVATE LIMITED',
    'TAKE ME HOME E-SOLUTION PRIVATE LIMITED',
    'RXMEDIKART TECHNOLOGY PRIVATE LIMITED',
    'STUTI GLOBAL VENTURES PRIVATE LIMITED',
    'VACUS TECH PRIVATE LIMITED',
    'BSIT SOFTWARE SERVICES PRIVATE LIMITED',
    'NOPAPERFORMS SOLUTIONS PRIVATE LIMITED',
    'JILBEE ENGINEERING SERVICES PRIVATE LIMITED',
    'GENOVA MULTISOLUTIONS PRIVATE LIMITED',
    'NANOCLEAN GLOBAL PRIVATE LIMITED',
    'CARTERPORTER PRIVATE LIMITED',
    'GROVILL EDUCATION PRIVATE LIMITED',
    'REPUTE LOGITECH PRIVATE LIMITED',
    'INVACO PRIVATE LIMITED',
    'IRIDE TECHNOLOGIES PRIVATE LIMITED',
    'AKSHAR SCHOOL SOLUTIONS PRIVATE LIMITED',
    'SREE KOTEESHWAR AERO-DEF INDUSTRY PRIVATE LIMITED',
    'EMERALD HAVEN PROPERTY DEVELOPMENT LIMITED',
    'BTW BUILDTHEWORLD PRIVATE LIMITED',
    'JUDA COURIERS PRIVATE LIMITED',
    'SISTINE POWER PRIVATE LIMITED',
    'ALOMPCM INFRASTRUCTURAL & LOGISTICS PRIVATE LIMITED',
    'KARANDIKARS PHARMACHEM PRIVATE LIMITED',
    'SPLENDRE EYEMAG PRIVATE LIMITED',
    'OKURA HOTELS PRIVATE LIMITED',
    'BIOTENSIDES PRIVATE LIMITED',
    'LIFESTYLE AND SPACES PRIVATE LIMITED',
    'HOLO PUNDITS PRIVATE LIMITED',
    'ANAEK SOFT PRIVATE LIMITED',
    'TELCOMET GLOBAL SOLUTIONS PRIVATE LIMITED',
    'HIKAHO SYSTEM PRIVATE LIMITED',
    'ELITE TEKNICA PRIVATE LIMITED',
    'NS BONDED WAREHOUSE PRIVATE LIMITED',
    'STELLOID INFRASTRUCTURE PRIVATE LIMITED',
    'NEXIVO CONSULTING PRIVATE LIMITED',
    'ZENCON INFOTECH PRIVATE LIMITED',
    'MACLEC CLEAN TECHNOLOGIES PRIVATE LIMITED',
    'VIENTO RENEWABLES PRIVATE LIMITED',
    'UNIQUE CREATIONS SOFTWARE INDIA PRIVATE LIMITED',
    'SHANTI HOSPITALITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'RESONANT CLOUD SERVICES PRIVATE LIMITED',
    'NATUREKART ECOMMERCE SOLUTIONS PRIVATE LIMITED',
    'LUNAR',
    'S ADORNMENT PRIVATE LIMITED',
    'FAMPRO AGRI BUSINESS PRIVATE LIMITED',
    'KYANI GLOBAL INDIA PRIVATE LIMITED',
    'PAHARIMATA AGRO TRADING LIMITED',
    'DISCURE FORMULATIONS PRIVATE LIMITED',
    'IK OVERSEAS PRIVATE LIMITED',
    'RATANGIRI INNOVATIONS PRIVATE LIMITED',
    'AMF TEX VENTURES PRIVATE LIMITED',
    'FLAURA HIGH-TECH APPLIANCES PRIVATE LIMITED',
    'VISHWAS MULTITECH SYSTEM PRIVATE LIMITED',
    'RICHLINE BULLION GOLD PRIVATE LIMITED',
    'VELOX LABS PRIVATE LIMITED',
    'SHARMITA SUPPLIERS LIMITED',
    'GEUDER INDIA OPHTHALMICS PRIVATE LIMITED',
    'NATURALINE NUTRACEUTICALS PRIVATE LIMITED',
    'KG DISTRIBUTORS PRIVATE LIMITED',
    'CORDIS INDIA MEDICAL DEVICES PRIVATE LIMITED',
    'OPTIMUM GOLD AND DIAMONDS PRIVATE LIMITED',
    'PRATYARPANA SERVICES PRIVATE LIMITED',
    'BELAZIO TRADING PRIVATE LIMITED',
    'SHIVAY BROKERS PRIVATE LIMITED',
    'DIAMETER TRADING PRIVATE LIMITED',
    'VEDIC EVOLUTION PRIVATE LIMITED',
    'N. P. BEARINGS (INDIA) PRIVATE LIMITED',
    'CFB PRODUCTS PRIVATE LIMITED',
    'QUVIX INDIA PRIVATE LIMITED',
    'AVXELLENCE TECHNOLOGIES PRIVATE LIMITED',
    'RUNIVAA DIGITAL MARKETING PRIVATE LIMITED',
    'OZ EXIM AND TRADING INDIA PRIVATE LIMITED',
    'FLAPBOX DESIGNS PRIVATE LIMITED',
    'STARKENN BIKES PRIVATE LIMITED',
    'EXFO SALES & SERVICES (INDIA) PRIVATE LIMITED',
    'IRIS FERTISEEDS PRIVATE LIMITED',
    'GREATLAND HOSPITALITY PRIVATE LIMITED',
    'NSG HOSPITALITY PRIVATE LIMITED',
    'JC SILVER STAR FASHION PRIVATE LIMITED',
    'JC CLOTHINGS PRIVATE LIMITED',
    'BELLS AND BITES PRIVATE LIMITED',
    'UNISTAR POWER PRIVATE LIMITED',
    'HAPPY HEAD BREWERY PRIVATE LIMITED',
    'INDUSVIVA AYURVEDIC RESORTS PRIVATE LIMITED',
    'PRANAM HOSPITALITIES AND SERVICES PRIVATE LIMITED',
    'Assistanz networks private limited',
    'Macronimous web solutions private limited',
    'Ndot technologies private limited',
    'Cyberswift infotech private limited',
    'INDUSNET COMPUTECH PRIVATE LIMITED',
    'One by one design private limited',
    'Cyrybral soft tech private limited',
    'Independent integrated computer services private limited',
    'Cellos software systems private limited',
    'Ideal invent technologies private limited',
    'Udan recreation services private limited',
    'Ultimate guru music private limited',
    'Sixteen by sixty-four productions private limited',
    'L7 media private limited',
    'Indivibe entertainment private limited',
    'Kanakadurga amusements and resorts private limited',
    'Hyderabad birdpark and gardens private limited',
    'Centre for sports excellence private limited',
    'Complete sports and management india private limited',
    'Truenature learning consultancy private limited',
    'ANGEL DIGITECH SERVICES PRIVATE LIMITED',
    'Soil tree marketing services private limited',
    'L7 entertainment private limited',
    'Sejal entertainment and media india limited',
    'Shortreel private limited',
    'Cricket academy of pathans private limited',
    'Dhan gaming solution (india) private limited',
    'Apostrophe films private limited',
    'King securitas private limited',
    'Goodweave certification private limited',
    'Earthood services private limited',
    'BODYCRAFT SALON SKIN & COSMETOLOGY PRIVATE LIMITED',
    'CALISTA WELLNESS PRIVATE LIMITED',
    'Enable india solutions private limited',
    'Team india managers limited',
    'Waterman freight (india) private limited',
    'Sequence communications private limited',
    'Etyka clinical solutions private limited',
    'Prerna foundation',
    'Quest certification private limited',
    'Statutory service system (india) private limited',
    'Intellitots learning private limited',
    'Sahara ind capsac limited',
    'Livedarshan india private limited',
    'Switchme technologies and services private limited',
    'United accrual services private limited',
    'KHANIJA RECYCLING INDIA PRIVATE LIMITED',
    '4i hospitality services private limited',
    'Live helper pest control services private limited',
    'Doss technologies private limited',
    'Airport retail private limited',
    'Rah legal knowledge process private limited',
    'Federation of motor sports club of india private limited',
    'Keld ellentoft india private limited',
    'Mem engineering private limited',
    'Alagu security services private limited',
    'Atheos infra solutions private limited',
    'Smisen controls private limited',
    'Denver packaging private limited',
    'Indo-krishna green fields limited',
    'Cineyug entertainment private limited',
    'Perfect aggregates private limited',
    'Madhuban trade-steels private limited',
    'Citrex products limited',
    'Multibase india limited',
    'MKVENTURES CAPITAL LIMITED',
    'Udaipur cotton mills co ltd',
    'Shree ajit pulp and paper limited',
    'The sandesh limited',
    'Mps limited',
    'JYOTHY LABS LIMITED',
    'Zenotech laboratories limited',
    'Gujarat natural resources limited',
    'National standard (india) limited',
    'Artson engineering limited',
    'Gem cables and conductors ltd.',
    'Parnax lab limited',
    'MOHITE INDUSTRIES LIMITED',
    'NEUEON TOWERS LIMITED',
    'Hercules hoists limited',
    'Empower india limited',
    'S p investrade (india) limited',
    'PANABYTE TECHNOLOGIES LIMITED',
    'Firstsource solutions limited',
    'Axis bank limited',
    'SHRIRAM FINANCE LIMITED',
    'Scintilla commercial & credit ltd',
    'QGO FINANCE LIMITED',
    'Virat leasing limited',
    'Vipul limited',
    'Sagar systech limited',
    'Landmarc leisure corporation limited',
    'YOGI LIMITED',
    'Meenakshi mercantiles ltd',
    'Lohia securities ltd',
    'Cybertech systems and software limited',
    'Sonata software limited',
    'Nexxoft infotel limited',
    'Raminfo limited',
    'J. kumar infraprojects limited',
    'Gromax infonet limited',
    'ABANS ENTERPRISES LIMITED',
    'Bangalore softsell limited',
    'Amrapali industries limited',
    'Kumaka industries limited',
    'Sandeep minerals private limited',
    'JAMPALA ENTERPRISES INDIA PRIVATE LIMITED',
    'Garnier seeds (india) private limited.',
    'Imk agro developers private limited',
    'Imk agro-tech properties private limited',
    'Irb sindhudurg airport private limited',
    'Karda buildcon private limited',
    'Dreams construction (pune) private limited',
    'Vision ventures limited',
    'Adilok resorts private limited',
    'Dakshin infrastructures private limited',
    'Kaypee interior projects private limited',
    'Timber leaf properties private limited',
    'Ns realty private limited',
    'Chirastai constructions private limited',
    'Suchirindia colossal holdings private limited',
    'Viviana infra developers private limited',
    'CERRTANANT PRIVATE LIMITED',
    'Bonway construction products (india) private limited',
    'Ans apartments private limited',
    'Tatva interiors and contractors private limited',
    'Oriental pathways (indore) private limited',
    'Kailash buildtech private limited',
    'Realcare management services private limited',
    'Neeldeep developers private limited',
    'Basant bahar properties private limited',
    'Gift district cooling systems limited',
    'Jayshri propack private limited',
    'Gmp infra build private limited',
    'Kml infrastructure private limited',
    'Vinayak devcon private limited',
    'Dynasty buildwell private limited',
    'Alliance villas private limited',
    'Alliance inn (india) private limited',
    'Sporturf construction (india) private limited',
    'ALLIANCE GRANDEUR HOMES PRIVATE LIMITED',
    'INDUS BUILDCORP PRIVATE LIMITED',
    'Robinson properties international private limited',
    'Navbharat estate developments private limited',
    'Rachana construction company (nagpur) private limited',
    'Gitanjali infratech limited',
    'Rps infra projects private limited',
    'Everest sudarshan private limited',
    'Fekari infrastructure private limited',
    'Gd thana constructions & realtors private limited',
    'Panchbhoomi build con private limited',
    'Lotus multicon private limited',
    'Shree shyam vatika private limited',
    'Suchir koralreef properties private limited',
    'Cheloor property development projects limited',
    'Credai bengal',
    'Vol builders private limited',
    'Shanti build-well private limited',
    'Sadbhav infrastructure project limited',
    'Silverline real estate and invements private limited',
    'Alliance buildwell projects private limited',
    'URBANRISE LIFESTYLES PRIVATE LIMITED',
    'BLUE MOANA DEVELOPERS PRIVATE LIMITED',
    'Woodland theatres private limited',
    'Link realtors p.ltd.',
    'IRB MP EXPRESSWAY PRIVATE LIMITED',
    'Citywood builders private limited',
    'GLASS BUILDING SYSTEMS (I) PRIVATE LIMITED',
    'Vu enterprises private limited',
    'Bscpl infrastructure limited',
    'Oceanus infrastructure private limited',
    'Modern road makers p ltd',
    'India ports limited',
    'Thane ghodbunder toll road private limited',
    'Idfc projects limited',
    'IRB PATHANKOT AMRITSAR TOLL ROAD LIMITED',
    'IRB TALEGAON AMRAVATI TOLLWAY LIMITED',
    'IRB JAIPUR DEOLI TOLLWAY LIMITED',
    'Clastic rock realtors private limited',
    'Advaith infraprojects private limited',
    'D p jain dariapur-jasondhi (annuity) road projects private limited',
    'Vikram teleinfra private limited',
    'Rewa tollway private limited',
    'Vijayawada tollway private limited',
    'Kamarajar port limited',
    'Estancia it park private limited',
    'Vws building solutions private limited',
    'Neelanchal technocrats private limited',
    'Vr patil vividh vidyuth nirman private limited',
    'Samskruti maurya eco village private limited',
    'Nova life space private limited',
    'Silverline power infrastructure private limited',
    'Avanti wind systems india private limited',
    'Paras re facilities management private limited',
    'Panvelkar infrastructures private limited',
    'Rnang industrial & development projects private limited',
    'Om infradwellings private limited',
    'H and l properties private limited',
    'Park view properties pvt ltd',
    'Alliance infrabuild private limited',
    'Mjr builders private limited',
    'Neelanchal skyskape private limited',
    'Rnang projects & group development private limited',
    'YAPROTIL SERVICES PRIVATE LIMITED',
    'Planet dreams corporation private limited',
    'Meenamani estates private limited',
    'Onepoint global india private limited',
    'Onedelta synergies private limited',
    'Keinen techne solutions private limited',
    'Vaazu india private limited',
    'Healthmacro technologies private limited',
    'Cherrylabs technology private limited',
    'Sri pradhyumna technologies private limited',
    'Theatro labs india private limited',
    'Vidyo software and hardware development india private limited',
    'Seajin technology private limited',
    'Snefotics technologies private limited',
    'Bitloka solutions private limited',
    'Aerodyne design & infoengineering private limited',
    'TECH MAHINDRA CERIUM PRIVATE LIMITED',
    'Eduplexus softsol private limited',
    'Citrya innovations private limited',
    'Translab innovations private limited',
    'Smuuth innovative solutions private limited',
    'Kaho labs private limited',
    'Dalogix technologies private limited',
    'Nortech infonet private limited',
    'Quest innovative solutions private limited',
    'Escube technologies private limited',
    'Triassic solutions private limited',
    'Safe software and integrated solutions private limited',
    'Ctl infocom private limited',
    'Fingent technology solutions private limited',
    'AURIONPRO TRANSIT TECHNOLOGIES PRIVATE LIMITED',
    'Imr infotech private limited',
    'ADHARVA FINTECH PRIVATE LIMITED',
    'Netroxe it solutions private limited',
    'Loremine technologies private limited',
    'Riafy technologies private limited',
    'Hodo medical informatic solutions private limited',
    'Media wide labs private limited',
    'Essen vision software private limited.',
    'Netweb solutions private limited',
    'Desire 4 india private limited',
    'AML REALTIES PRIVATE LIMITED',
    'Arti web-developers private limited',
    'Agogue technologies private limited',
    'Mk web-tech private limited',
    'Dk web-tech private limited',
    'Enthought scientific software solutions private limited',
    'Algorhythms consultants private limited',
    'Syspro infotech private limited',
    'Vyom labs private limited',
    'SPRINGER NATURE TECHNOLOGY AND PUBLISHING SOLUTIONS PRIVATE LIMITED',
    'Quantumid technologies (india) private limited',
    'Devita engineering (india) private limited',
    '21st century cloud computing private limited',
    'Schnell informatics private limited',
    'Innoac technologies private limited',
    'Universal steel information technology (india) private limited',
    'Geonovate technologies private limited',
    'GUMPTION LABS FINSERVE PRIVATE LIMITED',
    'Dev technosys private limited',
    'B-iq technologies private limited',
    'Rocsys technologies private limited',
    'Esoft consulting limited',
    'Quintessence enterprises private limited',
    'Triniti advanced software labs private limited',
    'Net india private limited',
    'Ces information systems private limited',
    'Redson consultancy services private limited',
    'Adeptech systems private limited',
    'Aclat technologies private limited',
    'SYSTECHCORP PRIVATE LIMITED',
    'Gaian solutions india pvt ltd',
    'Lasys technologies private limited',
    'Envision enterprise solutions private limited',
    'Bloom solutions private limited',
    'Hydus technologies (india) private limited',
    'Right path computer technologies private limited',
    'Neobric it solutions private limited',
    'Arija software private limited',
    'DHANUSH HEALTHCARE SYSTEMS PRIVATE LIMITED',
    'Maq software hyderabad private limited',
    'Microspark software solutions private limited',
    'Promokap it solutions private limited',
    'TRC SOLUTIONS PRIVATE LIMITED',
    'Manomay consultancy services (india) private limited',
    'T COMMERCIALIZATION GLOBAL PRIVATE LIMITED',
    'Helical it solutions private limited',
    'Fugenic engineering services ( india ) private limited',
    'Ryna technologies private limited',
    'Glitterpoint solutions private limited',
    'SJ MEDIA LABS PRIVATE LIMITED',
    'Osoft labs private limited',
    'GROUNDHOG APPS PRIVATE LIMITED',
    'BLUSAPPHIRE CYBER SYSTEMS PRIVATE LIMITED',
    'Syntizen technologies private limited',
    'Sibre systems & services private limited',
    'Locus technologies private limited',
    'Ez vidya private limited',
    'Sanmarg news and allied services private limited',
    'Snow white laundrette private limited',
    'Styleguru trade private limited',
    'Chemprotech india expo private limited',
    'Voice candy sound studio private limited',
    'Idea shop designs private limited',
    'Vishal waterworld private limited',
    'VSRK CAPITAL PRIVATE LIMITED',
    'Reliable warehousing india private limited',
    'Federation of ship-agents association of india',
    'Syntis india consulting private limited',
    'Ahan destination management private limited',
    'Challa legal services private limited',
    'Sumathi corporate services private limited',
    'K ramabrahmam and sons pvt ltd',
    'Pranjal investments pvt. ltd.',
    'Topack fittings limited',
    'Yodaa capital market private limited',
    'Issues analysis and research private limited',
    'Morgan stanley india securities private limited',
    'Firecon engineers private limited',
    'Perfect cardamom and spices marketing company private limited',
    'Agri net solutions limited',
    'Farsight investment service private ltd',
    'Davangere sugar company limited',
    'Flex foods limited',
    'Gujarat ambuja exports limited',
    'Gayatri sugars limited',
    'Bharat textiles & proofing industries limited',
    'Avanti leathers limited',
    'Liberty shoes limited',
    'Infomedia press limited',
    'Stilbene chemicals limited',
    'Navin fluorine international limited',
    'ASTRAL LIMITED',
    'WELSPUN SPECIALTY SOLUTIONS LIMITED',
    'Shilp gravures limited',
    'Enterprise international ltd',
    'Gkw ltd',
    'Psts heavy lift and shift limited',
    'Td power systems limited',
    'Zicom electronic security systems limited',
    'Poly medicure limited',
    'Nila infrastructures limited',
    'Gujarat apollo industries limited',
    'Reliance communications limited',
    'Arihant multi commercial limited',
    'Mahaveer infoway limited',
    'Lic housing finance ltd',
    'Marda commercial & holdings ltd',
    'Ascent exim (india) limited',
    'Step two corporation ltd',
    'Kaashyap technologies limited',
    'DUCON INFRATECHNOLOGIES LIMITED',
    'Pentamedia graphics limited',
    'Alchemist corporation limited',
    'CLARIANT SERVICES INDIA PRIVATE LIMITED',
    'Use time (india) private limited',
    'PRAG AGRO FARM LIMITED',
    'Expert horticulture and culinary institute private limited',
    'Aarti bio-tech limited',
    'Elite green private limited',
    'Sdu agritech private limited',
    'Shivshakti orchards private limited',
    'Pavithra dairy products private limited',
    'Farmer harvest (india) private limited',
    'Farmersfortune (india) private limited',
    'Swathy hi-tech agro private limited',
    'Basil agriculture private limited',
    'Karnataka breeding farm private limited',
    'Banda broiler breeder farm private limited',
    'BHARAT EGG PRODUCERS',
    'S AAMRIIT ONLINE PRIVATE LIMITED',
    'RADMA SERVICES PRIVATE LIMITED',
    'THREELINE CARGO INDIA PRIVATE LIMITED',
    'AEROCORE AVIATION PRIVATE LIMITED',
    'TRIENVIRO 360 BUSINESS SOLUTION PRIVATE LIMITED',
    'W2W SERVICE PRIVATE LIMITED',
    'NEWLOKSEVA URBAN MULTIPLE NIDHI LIMITED',
    'SMARTFOODSAFE INDIA PRIVATE LIMITED',
    'AGRIPONICS INDIA PRIVATE LIMITED',
    'TRISARGA HEALTH AND WELLNESS PRIVATE LIMITED',
    'MY PURA VIDA WELLNESS PRIVATE LIMITED',
    'ZYPLE ACADEMY PRIVATE LIMITED',
    'NEXAGRID TECHNOLOGY PRIVATE LIMITED',
    'INWOIN TECHNOLOGIES PRIVATE LIMITED',
    'BLUE ENERGY COMMERCIAL VEHICLES PRIVATE LIMITED',
    'KKHUSHI HOME DECOR PRIVATE LIMITED',
    'KALPTARU GLOBAL VENTURE PRIVATE LIMITED',
    'SATKARTAR FASHION WORLD PRIVATE LIMITED',
    'AEVLAM COSMETICS PRIVATE LIMITED',
    'GASOREX INDIA PRIVATE LIMITED',
    'BINARY RENTALZ PRIVATE LIMITED',
    'ARTHUR FLURY INDIA PRIVATE LIMITED',
    'CRAFTSUTRA PRIVATE LIMITED',
    'LABELEX PRIVATE LIMITED',
    'SAFA VENTURES PRIVATE LIMITED',
    'TAXZONE ADVISORY PRIVATE LIMITED',
    'HOME DX PRIVATE LIMITED',
    'AYUSH TV PRIVATE LIMITED',
    'HRIS SERVICES INDIA PRIVATE LIMITED',
    'ALLIANZ OFFSHORE SERVICES PRIVATE LIMITED',
    'AGRAVANSHI INDIA PRIVATE LIMITED',
    'HR INDUSTRY (PUNE) PRIVATE LIMITED',
    'SAI INVESTOR EDUCATION FORUM',
    'MOHANKUMAR BUSINESS INFRASTRUCTURE PRIVATE LIMITED',
    'SAISHAKTI EVOLUTIONARY DESIGNS PRIVATE LIMITED',
    'LI ELEMENTS PRIVATE LIMITED',
    'GREE CONSUMER PRIVATE LIMITED',
    'RELSUS INDIA PRIVATE LIMITED',
    'LINKUPAGRO PRIVATE LIMITED',
    'SEVEN M PICTURES PRIVATE LIMITED',
    'SOUTHERN PEARL REFINERY AND PETROCHEMICALS PRIVATE LIMITED',
    'BEYOND BELIEF PRIVATE LIMITED',
    'HAMSTECH FILMS PRIVATE LIMITED',
    'DINERO FINSERV PRIVATE LIMITED',
    'KAMNATH HOSPITALITY PRIVATE LIMITED',
    'ACHINTYA ORGANIC RESEARCH PRIVATE LIMITED',
    'ROOTS CREATIVE SERVICES PRIVATE LIMITED',
    'ODI FARMS PRIVATE LIMITED',
    'BROADWALK DEVELOPERS PRIVATE LIMITED',
    'BROADSOURCE INDIA PRIVATE LIMITED',
    'V PLUS TECHNOLOGY PRIVATE LIMITED',
    'INFLUENZR LIFESTYLES PRIVATE LIMITED',
    'CHEF PIN PRIVATE LIMITED',
    'INITIAL IQ (OPC) PRIVATE LIMITED',
    'DIGIZOD TECHNOLOGY (OPC) PRIVATE LIMITED',
    'INSPIREXT CONSULTING INDIA PRIVATE LIMITED',
    'CKINDUS PRIVATE LIMITED',
    'DLLM PRIVATE LIMITED',
    'CHAMBAL AGRITECH INCUBATOR PRODUCER COMPANY LIMITED',
    'MODERNIZE CHIP SOLUTIONS PRIVATE LIMITED',
    'AGRIFINITY INDUSTRIES PRIVATE LIMITED',
    'KYMIK INDUSTRIES PRIVATE LIMITED',
    'AVANI HELPO FOUNDATION',
    'TECHZERA INFOLOGICS PRIVATE LIMITED',
    'GOPAL IMPERIAL PRIVATE LIMITED',
    'F & P VALVES PRIVATE LIMITED',
    'DATALYTICS TECHNOLOGIES PRIVATE LIMITED',
    'GETMYINDIA CAPITALS PRIVATE LIMITED',
    'AE INTEGRITY PRIVATE LIMITED',
    'GG METROPOLIS PRIVATE LIMITED',
    'TEAM ORANGE SERVICES & MAINTENANCE PRIVATE LIMITED',
    'KETOLECIOUZ PRIVATE LIMITED',
    'ENTRUPY INDIA PRIVATE LIMITED',
    'KARGO KING EXPRESS PRIVATE LIMITED',
    'DEC-CODE SERVICES PRIVATE LIMITED',
    'VIRYA HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'ORAL TECHNOLOGIES PRIVATE LIMITED',
    'SENSEFLY INNOVATIONS PRIVATE LIMITED',
    'JS PROCESS EQUIPMENT PRIVATE LIMITED',
    'GLOBUS HOSPITALITY PRIVATE LIMITED',
    'LA GREEN INNOVATIONS PRIVATE LIMITED',
    'GUARDIAN GREEN TECH PRIVATE LIMITED',
    'TOP GROW EXIM PRIVATE LIMITED',
    'SMARAMI PROJECTS PRIVATE LIMITED',
    'IRA STEEL CORPORATION PRIVATE LIMITED',
    'WE ASSURE STORES PRIVATE LIMITED',
    'IMPERIAL PLATFORMS PRIVATE LIMITED',
    'GLOBAL VISION DIRECT PRIVATE LIMITED',
    'MUTUALL SERVE INTEGRATED FOUNDATION',
    'ANALOG INFOTAINMENT PRIVATE LIMITED',
    'GLOCAL SPECIALITIES PRIVATE LIMITED',
    'MECHTRACK INDIA PRIVATE LIMITED',
    'ALEXIDA FURNITURE INDIA PRIVATE LIMITED',
    'ATOMSTATE TECHNOLOGIES PRIVATE LIMITED',
    'ATTICA GOLD BUYERS PRIVATE LIMITED',
    'VAH VAH INSTITUTE PRIVATE LIMITED',
    'MADURA GROWTH PARTNERS PRIVATE LIMITED',
    'PACXUS PRIVATE LIMITED',
    'DDHC PRIVATE LIMITED',
    'CUENTAS TECHNOLOGIES PRIVATE LIMITED',
    'KROMA PAINTS PRIVATE LIMITED',
    'LIGERO LOGISTICS PRIVATE LIMITED',
    'TRUFID ADVISORS PRIVATE LIMITED',
    'ASSETFINX TECHNOLOGIES PRIVATE LIMITED',
    'PETROMECH INDUSTRIES PRIVATE LIMITED',
    'SHOPPIN VENTURES PRIVATE LIMITED',
    'YOUNWE STRATEGIC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GO GREEN ECO TECH SOLUTIONS PRIVATE LIMITED',
    'AHAHA FOOD INDUSTRY PRIVATE LIMITED',
    'PAPER CROWD INTERNATIONAL PRIVATE LIMITED',
    'CLEAN BIOTECH PRIVATE LIMITED',
    'BRAND WARS PRIVATE LIMITED',
    'VEERAL ORGANICS PRIVATE LIMITED',
    'MY APS TRINITY SOLUTIONS PRIVATE LIMITED',
    'PRIMUS HATCHERY PRIVATE LIMITED',
    'RAPS PROFESSIONAL SERVICES PRIVATE LIMITED',
    'DELPIONE LIFECARE PRIVATE LIMITED',
    'MAVERICK BULK MANAGEMENT SERVICES PRIVATE LIMITED',
    'ACIC EXPLORRA FOUNDATION',
    'AKSAA CREATIONS PRIVATE LIMITED',
    'EVA GROW PACKAGING PRIVATE LIMITED',
    'MYTHINK TANK MULTIMEDIA PRIVATE LIMITED',
    'SPARKLE WELLNESS EDUSERVICES PRIVATE LIMITED',
    'KAUSHEYAM NATURAL TEXTILES PRIVATE LIMITED',
    'CHOPRA ADVISORY PRIVATE LIMITED',
    'AMAIDHI SCHOOL FOR TRANSFORMATION PRIVATE LIMITED',
    'JETPLAST PRIVATE LIMITED',
    'HADID MICROCARE FEDERATION',
    'PLANETSMARTCITY SERVICE INDIA PRIVATE LIMITED',
    'S SQUARE BRANDING PRIVATE LIMITED',
    'KALRA APPAREL PRIVATE LIMITED',
    'NOSTER CONCEPTS PRIVATE LIMITED',
    'MATSCOPE MATERIAL TESTING LABS PRIVATE LIMITED',
    'GLOWARM TECHNOLOGIES PRIVATE LIMITED',
    'AMBER PARI ENTERPRISES PRIVATE LIMITED',
    'USG INFOTECH PRIVATE LIMITED',
    'LIBERTY STEEL INDIA LIMITED',
    'REXODA INDIA PRIVATE LIMITED',
    'ALFEC STRUCTURES PRIVATE LIMITED',
    'PITTI RAIL AND ENGINEERING COMPONENTS LIMITED',
    'ROBUS INDIA INDUSTRIES PRIVATE LIMITED',
    'LD MITTAL AND SONS PRIVATE LIMITED',
    'AFROARAB ENTERPRISE PRIVATE LIMITED',
    'REJIG DIGITAL PRIVATE LIMITED',
    'SOFTWARECASTER PRIVATE LIMITED',
    'ARTHAWARE TECHNOLOGIES PRIVATE LIMITED',
    'JUPITURN SOLUTION PRIVATE LIMITED',
    'MEDNITUDE PRIVATE LIMITED',
    'NARAYANI BUSINESS VENTURES PRIVATE LIMITED',
    'NEOTERIC RLG CARE FOUNDATION',
    'RAISING SUPERSTARS ENTERPRISES PRIVATE LIMITED',
    'EDUVISION INDIA PRIVATE LIMITED',
    'SKILLR TECHNOLOGIES PRIVATE LIMITED',
    'WE AR SPORTS PRIVATE LIMITED',
    'BIOFLORAE PRIVATE LIMITED',
    'PINIQUE SOLUTIONS PRIVATE LIMITED',
    'REKHAS SEVA FOUNDATION',
    'TROMKO PRIVATE LIMITED',
    'ASTERIX PHARMA PRIVATE LIMITED',
    'NIRAAMAYA MADIRA PRIVATE LIMITED',
    'RAD DATA COMMUNICATIONS MARKETING INDIA PRIVATE LIMITED',
    'BOAZ AGRI ANALYTICS PRIVATE LIMITED',
    'BECKON REALESTATE DEVELOPERS PRIVATE LIMITED',
    'YOHO DESIGNS PRIVATE LIMITED',
    'HI-BOND CEMENT (MAH) PRIVATE LIMITED',
    'ODD VENTURES FOUNDATION',
    'GMEET ELECTRONICS PRIVATE LIMITED',
    'SFK INDUSTRIES PRIVATE LIMITED',
    'GOGRAMIN PRIVATE LIMITED',
    'SAURA COTTAGES PRIVATE LIMITED',
    'COLVIN CARE PRIVATE LIMITED',
    'SYSCORP INTEGRATED INFRA INFUSION PRIVATE LIMITED',
    'VEEFIN SOLUTIONS LIMITED',
    'G-ART PRIVATE LIMITED',
    'METAWELD ENGINEERING PRIVATE LIMITED',
    'SPIFFY BUILDERS PRIVATE LIMITED',
    'EPEEL INDUSTRIES PRIVATE LIMITED',
    'RAYS ROOFTOP PRIVATE LIMITED',
    'CUBE27 IT PRIVATE LIMITED',
    'SHRIBALAJI ADDITIVES PRIVATE LIMITED',
    'MOTOCAST POWER ALLOYS PRIVATE LIMITED',
    'ADSUM ECO SOLUTION PRIVATE LIMITED',
    'FIRST PENNY EDUCATION PRIVATE LIMITED',
    'GRIMET TOOLS PRIVATE LIMITED',
    'E STUDY PAL PRIVATE LIMITED',
    'IGNATIUSLAB PRIVATE LIMITED',
    'ACCESSIBLE TECH SOLUTIONS PRIVATE LIMITED',
    'REFILL KESAR PRIVATE LIMITED',
    'REALPLUS TECHNOLOGIES PRIVATE LIMITED',
    'NUAGESOL PRIVATE LIMITED',
    'ARYAN TELECOMMUNICATION & INFOTECH PRIVATE LIMITED',
    'GARWARE TECHNICAL TEXTILE PRIVATE LIMITED',
    'ANH JEWELS PRIVATE LIMITED',
    'BUS 360 DEGREE PRIVATE LIMITED',
    'PHARMCOS HEALTHCARE PRIVATE LIMITED',
    'SNIFFS & PURRS INDIA PRIVATE LIMITED',
    'VAILEXA TECHNOLOGY PRIVATE LIMITED',
    'WB ELECTRONICS INDIA PRIVATE LIMITED',
    'UNITEKNIC PRIVATE LIMITED',
    'BOX FOR HOPE PRIVATE LIMITED',
    'CUBESIMPLE PRIVATE LIMITED',
    'ZLURI TECHNOLOGIES PRIVATE LIMITED',
    'VIDEOMEET PRIVATE LIMITED',
    'PRIME POLYTRADE PRIVATE LIMITED',
    'MOTHERSOUL PRIVATE LIMITED',
    'PRASHANTI WELLNESS SOLUTIONS PRIVATE LIMITED',
    'SARANS SIGNATURE PRIVATE LIMITED',
    'SERVEAMC LIMITED',
    'RUPEEFIN CONSULTANCY SERVICES (OPC) PRIVATE LIMITED',
    'WONDRLAB CONTENT PRIVATE LIMITED',
    'EDUVERN TECHNOLOGIES PRIVATE LIMITED',
    'THOUGHTQUAD PRIVATE LIMITED',
    'VELOCE WELLNESS PRIVATE LIMITED',
    'OASIS EPC (NORTH) PRIVATE LIMITED',
    'COEMERGE PRIVATE LIMITED',
    'MAPLE LEAF EDUCATION PRIVATE LIMITED',
    'ALLENGERS OEM PRIVATE LIMITED',
    'GLC HOPES FOUNDATION',
    'SWENLOG SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'AISH TECHNOLOGIES PRIVATE LIMITED',
    'DM5 SUBSEA ENGINEERING PRIVATE LIMITED',
    'SUNNYDAY CONSULTING PRIVATE LIMITED',
    'BITXOXO TECHNOLOGIES PRIVATE LIMITED',
    'RMTREE INFRA PRIVATE LIMITED',
    'INSTA MEDIA ADVERTISING PRIVATE LIMITED',
    'UPNORTH TECHNOLOGIES PRIVATE LIMITED',
    'NUTRIHUB TECHNOLOGY BUSINESS INCUBATOR STARTUPS CONFEDERATION',
    'ALYGENCE SOLUTIONS PRIVATE LIMITED',
    'VALTEX INFOTECH PRIVATE LIMITED',
    'PROBAYAN WEAVES PRIVATE LIMITED',
    'AVI ALIMCHANDANI FOUNDATION',
    'AARAMBAN AGRO PRIVATE LIMITED',
    'GRAFIKCOLS EXPERTS PRIVATE LIMITED',
    'LIGHT HOUSE SECURITY SERVICES PRIVATE LIMITED',
    'TECHNOCRAFT FASHIONS LIMITED',
    'INDUCTUS HUMAN CAPITAL SOLUTIONS PRIVATE LIMITED',
    'HRDI GROUP PRIVATE LIMITED',
    'KAISER RESUNG ENERGIES PRIVATE LIMITED',
    'CS-HUB SOLUTIONS PRIVATE LIMITED',
    'CYBER CORPORATION MANIPUR LIMITED',
    'VG ELECTRONICS PRIVATE LIMITED',
    'SRI VIBHAVE FARMS PRIVATE LIMITED',
    'KING POLYPLAST PRIVATE LIMITED',
    'NAVRATNA MINERALS AND CHEMICALS PRIVATE LIMITED',
    'YERA FITNESS PRIVATE LIMITED',
    'PAYOBILL97 TECHNOLOGIES PRIVATE LIMITED',
    'STAYWAY HOMES PRIVATE LIMITED',
    'GRANDIS MARKETING SOLUTIONS PRIVATE LIMITED',
    'IPCSGLOBAL SOLUTIONS PRIVATE LIMITED',
    'ETHICARE CLINICAL TRIAL SERVICES (OPC) PRIVATE LIMITED',
    'ACCELOGICA PRIVATE LIMITED',
    'WEBVOOM PRIVATE LIMITED',
    'ARR STUDIO PRIVATE LIMITED',
    '2SRJ MAGNUS SHEEP PARK PRIVATE LIMITED',
    'ARTH PADARTH FACTORS AND FINANCE PRIVATELIMITED',
    'QUALITY & TESTING INFOSOLUTION PRIVATE LIMITED',
    'MARDS HEALTH CARE PRIVATE LIMITED',
    'NIRVITTA PHARMACEUTICALS PRIVATE LIMITED',
    'ASHAVARI FOOD PRODUCTS PRIVATE LIMITED',
    'TECHADEMY LEARNING SOLUTIONS PRIVATE LIMITED',
    'DDC DATA CENTRE PRIVATE LIMITED',
    'U FORCE FOUNDATION',
    'MURA ITALIA KAMPENI PRIVATE LIMITED',
    'SEETECH EARTHMOVING EQUIPMENTS PRIVATE LIMITED',
    'FUSION CONSUMER HEALTHCARE PRIVATE LIMITED',
    'AMMS TECHONOLOGY INDIA PRIVATE LIMITED',
    'PAYSYS TECHNOLOGIES PRIVATE LIMITED',
    'SISINTY PRIVATE LIMITED',
    'SANJAY FERRO METAL PRIVATE LIMITED',
    'MANSU CHEMICAL INDUSTRIES PRIVATE LIMITED',
    'IMSUCCESS PRIVATE LIMITED',
    'EONEPAY LSP PRIVATE LIMITED',
    'AQUILAI SOLUTIONS PRIVATE LIMITED',
    'FINDINDEED PRIVATE LIMITED',
    'MOONLIGHT WELLNESS FOUNDATION',
    'JUPITER ENERGY SOLUTIONS AND PROJECTS PRIVATE LIMITED',
    'NITYAKARMA PRIVATE LIMITED',
    'AIRDRIVEN AVIATION PRIVATE LIMITED',
    'RK CONCAST PRIVATE LIMITED',
    'SENNELEYS TECHNOLOGIES PRIVATE LIMITED',
    'TOAST TAB PRIVATE LIMITED',
    'PRAVIT TECH LABS PRIVATE LIMITED',
    'POWER BRIDGE TECHNOLOGIES PRIVATE LIMITED',
    'VASAK INDUSTRIES PRIVATE LIMITED',
    'AYYAN TECH-EDU SYSTEMS PRIVATE LIMITED',
    'UPCLOUD SOLUTIONS PRIVATE LIMITED',
    'DHAMPUR BIO ORGANICS LIMITED',
    'OUROWN MULTITRADE PRIVATE LIMITED',
    'MAHENDRA FRESH PRIVATE LIMITED',
    'ELEST PRIVATE LIMITED',
    'OPENBRACKETS FOUNDATION',
    'AIDE TECHNOLOGIES PRIVATE LIMITED',
    'MAYAMATAYA PRIVATE LIMITED',
    'PAYZED PAYMENTS SOLUTION PRIVATE LIMITED',
    'LEXORB PRIVATE LIMITED',
    'SUPREME MINDS TECHNO SERVICES PRIVATE LIMITED',
    'DSP LAB PRIVATE LIMITED',
    'PLAYYDATE TECHNOLOGIES PRIVATE LIMITED',
    'FOURFOX SOLUTIONS PRIVATE LIMITED',
    'VEER PROFAB PRIVATE LIMITED',
    'VESURE TECHNOLOGIES PRIVATE LIMITED',
    'HARMONIC ROTOTECH PRIVATE LIMITED',
    'BRAI TECHNOFORGE PRIVATE LIMITED',
    'NANDIKA TRANSPORT PRIVATE LIMITED',
    'WEBTOOLS TECHNOLOGY SERVICES (OPC) PRIVATE LIMITED',
    'BHIMA RIDDHI BROADBAND PRIVATE LIMITED',
    'DAVADOST RETAIL PRIVATE LIMITED',
    'BLUE TITLE 365 (OPC) PRIVATE LIMITED',
    'GET MY STRATEGY CONSULTING PRIVATE LIMITED',
    'TALOD FOODS RETAIL PRIVATE LIMITED',
    'ABANTI INDUSTRIES PRIVATE LIMITED',
    '3CHEM SURFACES PRIVATE LIMITED',
    '7TH REALM PRIVATE LIMITED',
    'ECIRCLES PRIVATE LIMITED',
    'SHRI KANHA STAYS PRIVATE LIMITED',
    'FUELLAO PRIVATE LIMITED',
    'LEADFUNCTION (OPC) PRIVATE LIMITED',
    'FLOMONEY PRIVATE LIMITED',
    'LAMA SCHOOL (OPC) PRIVATE LIMITED',
    'NAMMAFLIX PRIVATE LIMITED',
    'MONTECARLO VADODARA MUMBAI EXPRESSWAY PRIVATE LIMITED',
    'IIM AHMEDABAD ENDOWMENT MANAGEMENT FOUNDATION',
    'MAVIO SOLUTIONS PRIVATE LIMITED',
    'FICUS ELASTICA PRIVATE LIMITED',
    'SECTOR SQUAD REALTY PRIVATE LIMITED',
    'KSHMAA FOUNDATION',
    'BORN TECHIES PRIVATE LIMITED',
    'GRAPE MASTER ORGANIC FARMERS PRODUCER COMPANY LIMITED',
    'WESTERN INDIA BONDED WAREHOUSE ASSOCIATION',
    'PRAWAH MAHILA KISAN PRODUCER COMPANY LIMITED',
    'BHARUWA AGRI SCIENCE PRIVATE LIMITED',
    'UNIHIRE PRIVATE LIMITED',
    'GALASAR SOLUTION PRIVATE LIMITED',
    'INFIALLIANCE PRIVATE LIMITED',
    'ORGANICCHILLY FOOD PRODUCTS PRIVATE LIMITED',
    'RIDHIYANA ENERGY PRIVATE LIMITED',
    'NEXT CENTURY SPIRITS INDIA PRIVATE LIMITED',
    'VRUDDHI ENGINEERING WORKS LIMITED',
    'HR KAVERI PRIVATE LIMITED',
    'SIMPLY SOLAR SOLUTION PRIVATE LIMITED',
    'PUNKTURR MEDIA PRIVATE LIMITED',
    'PROTOUCHPRO SERVICES PRIVATE LIMITED',
    'NETZON TECH INDIA PRIVATE LIMITED',
    'GRG GLOBAL TEXTILES LIMITED',
    'LAHARI ENTERPRISES INDIA PRIVATE LIMITED',
    'CLOUDTRADE TECHNOLOGIES PRIVATE LIMITED',
    'REGEN POWER PRIVATE LIMITED',
    'M BAGLA SPECIALITY PRODUCTS (OPC) PRIVATE LIMITED',
    'ZLOPES SOLUTIONS PRIVATE LIMITED',
    'HEALTHQUORA PRIVATE LIMITED',
    'RACON MARINE PRIVATE LIMITED',
    'UMMULQURA FOUNDATION',
    'VAS ASSOCIATES INDIA PRIVATE LIMITED',
    'MPBDS AGRO PRIVATE LIMITED',
    'TIMAC AGRO INDIA PRIVATE LIMITED',
    'VGR POWERINFRA PRIVATE LIMITED',
    'YEIDA GLOBAL MANUFACTURING PRIVATE LIMITED',
    'XUBBA ITECH PRIVATE LIMITED',
    'HEALTHNOW TECHNOLOGIES PRIVATE LIMITED',
    'SECURE METERING AND SERVICES (BANSWARA) PRIVATE LIMITED',
    'INDYO ORGANIC PRIVATE LIMITED',
    'SRI ADISASH TEACHCONNECT PRIVATE LIMITED',
    'LIFENESS SCIENCE INSTITUTE AND WELFARE FOUNDATION',
    'NIEUWEN PROJECT MANAGEMENT AND WORKFORCE PRIVATE LIMITED',
    'EARTHNME PRIVATE LIMITED',
    '4N AGRI VENTURES PRIVATE LIMITED',
    'SHANTHA NAGARAJ PROPERTIES (OPC) PRIVATE LIMITED',
    'SATYAM LOGISYS PRIVATE LIMITED',
    'INVESQ INVESTMENT ADVISORS PRIVATE LIMITED',
    'BANWARILAL PREMLATAA PODDAR FOUNDATION',
    'MOG ASUN DISTILLERS INDIA (OPC) PRIVATE LIMITED',
    'ENIGMATY TECH SOLUTIONS PRIVATE LIMITED',
    'ZAKYSOFT SOLUTIONS PRIVATE LIMITED',
    'ECU WORLDWIDE INDIA PRIVATE LIMITED',
    'SALNWIN STEELS PRIVATE LIMITED',
    'BANIBRO IT SOLUTIONS PRIVATE LIMITED',
    'HMS INFRA SOLUTIONS PRIVATE LIMITED',
    'ALUMELT PRIVATE LIMITED',
    'MISHKA CREATION PRIVATE LIMITED',
    'OSSATURE MANAGEMENT PRIVATE LIMITED',
    'THOTASOFT (OPC) PRIVATE LIMITED',
    'VRIKSH IMPACT PRIVATE LIMITED',
    'SVASTIK RETAILS AND EXPORTS PRIVATE LIMITED',
    'AGAMVANI UNIVERSAL PRIVATE LIMITED',
    'ARTEVA AGRITECH PRIVATE LIMITED',
    'MYACE INDIA EDUCATION PROMOTION FOUNDATION',
    'SAGAR SERVICES & RESOURCES PRIVATE LIMITED',
    'GPAC EDUCATION PRIVATE LIMITED',
    'TAX FUSION FINANCIAL ADVISORY PRIVATE LIMITED',
    'SRI NAYANA EYE HOSPITAL PRIVATE LIMITED',
    'JOY ASSET PRIVATE LIMITED',
    'BOLLANT LABORATORIES PRIVATE LIMITED',
    'BASQUE MEDIA PRIVATE LIMITED',
    'CRAFTBRAIN MEDIA PRIVATE LIMITED',
    'CAPITALONE INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'STAGLORY TRADING INDIA PRIVATE LIMITED',
    'KOCHI CYBER GREENS PRIVATE LIMITED',
    'ACOUSTRY (OPC) PRIVATE LIMITED',
    'OBJECTIF HEALTHCARE PRIVATE LIMITED',
    'SINTRIZEN TECHNOLOGIES PRIVATE LIMITED',
    'ARKISION AI PRIVATE LIMITED',
    'INGB VENTURES PRIVATE LIMITED',
    'TANISI DIGITAL INDIA PRIVATE LIMITED',
    'UNICO FOUNDATION',
    'SIMPHINITY PRIVATE LIMITED',
    'ARTEVA INFRATECH PRIVATE LIMITED',
    'VIDVED BUSINESS PARK PRIVATE LIMITED',
    'AGILEDEV PRIVATE LIMITED',
    'TANJER INFO SYSTEMS PRIVATE LIMITED',
    'EEKI FARMS PRIVATE LIMITED',
    'JMC INFOTECH PRIVATE LIMITED',
    'KRITIINTS PRIVATE LIMITED',
    'WATERJET SYSTEMS INTERNATIONAL PRIVATE LIMITED',
    'WEBSTORY PRIVATE LIMITED',
    'PARINISHTAA ECO SOLUTIONS PRIVATE LIMITED',
    'LAKSHAYA INFO SOLUTIONS PRIVATE LIMITED',
    'PRIMUS SAM PRIVATE LIMITED',
    'GCXG INDIA PRIVATE LIMITED',
    'CLSQ PRODUCTS PRIVATE LIMITED',
    'VIDVEDAA ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED',
    'TECH REACH IT SOLUTIONS PRIVATE LIMITED',
    'REFSOL MARKETING PRIVATE LIMITED',
    'EXIGOTECH TSP INDIA PRIVATE LIMITED',
    'LONE FURROW INVESTMENTS PRIVATE LIMITED',
    'SHRI DUTTATREYA TRADING AND MANUFACTURING PRIVATE LIMITED',
    'BRACE PORT LOGISTICS LIMITED',
    'CLASSIC CARE ASSIST PRIVATE LIMITED',
    'SYNPULSE INDIA PRIVATE LIMITED',
    'ERTIKA ENGINEERS PRIVATE LIMITED',
    'TELEWIRE SOLUTIONS PRIVATE LIMITED',
    'S CREATIVE TURNKEY PROJECTS PRIVATE LIMITED',
    'FAT TO FAB DIETCLINIC PRIVATE LIMITED',
    'SHIVANI TRUPACK PRIVATE LIMITED',
    'JAN-LOK SEVA FOUNDATION',
    'EW HABICON PRIVATE LIMITED',
    'JHELUM HUMAN RESOURCES PRIVATE LIMITED',
    'PRAAGYA EDUCATION INDIA PRIVATE LIMITED',
    'SEVENTYNINE DIGITAL PRIVATE LIMITED',
    'SYNERGY HEALTHEDTECH PRIVATE LIMITED',
    'AISRI DEVELOPERS PRIVATE LIMITED',
    'MOBILITY AFTERMARKET PRIVATE LIMITED',
    'ASIM HOSPITALITY PRIVATE LIMITED',
    'NAIMAIDS WELFARE FOUNDATION',
    'KALPTARU AGRO INPUTS PRIVATE LIMITED',
    'APLUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'AJVA FINTECH PRIVATE LIMITED',
    'DUNZO MERCHANT SERVICES PRIVATE LIMITED',
    'ALTHURAYA PRIVATE LIMITED',
    'MAKRAMIM PRIVATE LIMITED',
    'RECAP INDIA ENERGY SOLUTIONS PRIVATE LIMITED',
    'STOGI BEVERAGES PRIVATE LIMITED',
    'ACELION ENERGY STORAGE SOLUTION PRIVATE LIMITED',
    'OLDCHILD FOUNDATION',
    'PNR PROJECTS PRIVATE LIMITED',
    'GMACKS INFIN PRIVATE LIMITED',
    'SURAT DREAMS TECH PRIVATE LIMITED',
    'KATARIA FAMBIZ PRIVATE LIMITED',
    'MSPACE INDIA PRIVATE LIMITED',
    'NIVEDAN TECH LABS PRIVATE LIMITED',
    'V SAF ADVERTISING PRIVATE LIMITED',
    'MJF INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED',
    'TOYFOREST INDUSTRIES (OPC) PRIVATE LIMITED',
    'ADAN HOSPITALITY PRIVATE LIMITED',
    'BIRLA OPEN MINDS EDUCATION PRIVATE LIMITED',
    'TECHNOCITTA IT SOLUTIONS PRIVATE LIMITED',
    'EKNITI INDIA PRIVATE LIMITED',
    'RESPONSIVE BUSINESS PRIVATE LIMITED',
    'PAYSPRINT PRIVATE LIMITED',
    'CONGRUENCE TECHNOLOGIES PRIVATE LIMITED',
    'MSPL UNIT 3 LIMITED',
    'TRIPOOR SCIENCES PRIVATE LIMITED',
    'KANCO FINANCE PRIVATE LIMITED',
    'VARS ENGINEERS INDIA PRIVATE LIMITED',
    'ORIENTAL INTEGRATED FACILITY SERVICES PRIVATE LIMITED',
    'SPEXMOJO TECHNOLOGIES PRIVATE LIMITED',
    'NABTECH ENGINEERING PRIVATE LIMITED',
    'DREAMSTACK PRIVATE LIMITED',
    'EDUVANTI ABROAD CONSULTING SERVICES PRIVATE LIMITED',
    'FIT IN CONSULTANTS (OPC) PRIVATE LIMITED',
    'SKETCHMONK PRIVATE LIMITED',
    'SRI HAR GHAR SOLAR PRIVATE LIMITED',
    'HOMELER TECHNOLOGIES PRIVATE LIMITED',
    'COMMUNITY CAFE PRIVATE LIMITED',
    'CAFS MONEY MANAGEMENT PRIVATE LIMITED',
    'DAL-LAGO PRIVATE LIMITED',
    'INTJR PRECISION TECHNOLOGY PRIVATE LIMITED',
    'TIANYI TECHNOLOGY PRIVATE LIMITED',
    'AGROSHIP FOODS PRIVATE LIMITED',
    'COSMO ECOSYSTEM CARE PRIVATE LIMITED',
    'DWI-KAUSHALYA ACADEMY PRIVATE LIMITED',
    'EMDY PLAST PRIVATE LIMITED',
    'ATHEN HOSPITAL PRIVATE LIMITED',
    'EVOLVWISE TECHNOLOGIES PRIVATE LIMITED',
    'DATUM DECIPHER ANALYTICS PRIVATE LIMITED',
    'DREAMCAPES STUDIOS PRIVATE LIMITED',
    'PRASUK INFRA PRIVATE LIMITED',
    'AMAY MEP ENGINEERING SERVICES PRIVATE LIMITED',
    'EROOR INDUSTRIES PRIVATE LIMITED',
    'EXPLOREIT NEXTGEN SOLUTIONS PRIVATE LIMITED',
    'PERORAL BIO PRIVATE LIMITED',
    'RINOVA SOLAR POWER PRIVATE LIMITED',
    'MAKEMYBOT PRIVATE LIMITED',
    'SMASH TOURS & TRAVELS PRIVATE LIMITED',
    'QUIDNUNC INFOTAINMENT PRIVATE LIMITED',
    'RAJDHANI PETROCHEMICALS PRIVATE LIMITED',
    'SALACIA EXIM PRIVATE LIMITED',
    'GENKIDZ ED-TECH PRIVATE LIMITED',
    'AMP ENERGY DISTRIBUTED GENERATION TWO PRIVATE LIMITED',
    'IW3 INFRASTRUCTURE PRIVATE LIMITED',
    'INFOSYNC IT SOLUTIONS PRIVATE LIMITED',
    'EVOST FOODS PRIVATE LIMITED',
    'RR & EIPL PRIVATE LIMITED',
    'MOVIE MONKEY PRODUCTIONS PRIVATE LIMITED',
    'MOUNTIRE MACHINERY AND COMPONENTS PRIVATE LIMITED',
    'TRUEDONE LABS (OPC) PRIVATE LIMITED',
    'LEARNXT (OPC) PRIVATE LIMITED',
    'AUMHUM PRIVATE LIMITED',
    'VOUCHPAY TECHNOLOGIES PRIVATE LIMITED',
    'THINKSMART ELECTRONICS PRIVATE LIMITED',
    'MDWAI FOUNDATION',
    'DUV HEALTHCARE PRIVATE LIMITED',
    'VARUN MEDIA NETWORK PRIVATE LIMITED',
    'MILLIL INDUSTRIES PRIVATE LIMITED',
    'COPPERMIND IO (OPC) PRIVATE LIMITED',
    'HOK RETAIL PRIVATE LIMITED',
    'GUILD MODULAR SYSTEMS PRIVATE LIMITED',
    'HASHTECHY TECHNOLOGIES PRIVATE LIMITED',
    'FARM GARDEN E COMMERCE INDIA PRIVATE LIMITED',
    'NAMAH YATRA INDIA PRIVATE LIMITED',
    'VIDYASHILP EDUCATION GROUP PRIVATE LIMITED',
    'NAGA EDUCATION PRIVATE LIMITED',
    'INFOTOP SOLUTIONS PRIVATE LIMITED',
    'FD BUSINESS SERVICES PRIVATE LIMITED',
    'ABODETECHZONE PRIVATE LIMITED',
    'PATDEL ANALYTICS PRIVATE LIMITED',
    'FINNHOUSE CONSULTANTS PRIVATE LIMITED',
    'ARCOT IT SOLUTIONS PRIVATE LIMITED',
    'SEIKOR CAREERS PRIVATE LIMITED',
    'ROHAN KATARIA VENTURES PRIVATE LIMITED',
    'RAYO HEALTHCARE PRIVATE LIMITED',
    'ROCKPECKER ECOTILE PRIVATE LIMITED',
    'SKYSYS INFOSOLUTIONS (OPC) PRIVATE LIMITED',
    'SPEED GLOBE LOGISTICS PRIVATE LIMITED',
    'APV ENVIRO PRODUCTS PRIVATE LIMITED',
    'PARAM MEDASSIST PRIVATE LIMITED',
    'ONTEQ IT SERVICES PRIVATE LIMITED',
    'BOZO ENERGY PRIVATE LIMITED',
    'SQUAREPOINT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GIFFY RETAIL PRIVATE LIMITED',
    'BORA TECHNOVATION PRIVATE LIMITED',
    'ORGANISMIC TECHNOLOGIES PRIVATE LIMITED',
    'EMPENNAGE SOLUTIONS PRIVATE LIMITED',
    'MBC CORPORATION PRIVATE LIMITED',
    'SPECIALITY MEDICINES PRIVATE LIMITED',
    'AMINO TECH HEALTH AND WELLNESS PRIVATE LIMITED',
    'ALKOSH GLOBAL SOLUTIONS PRIVATE LIMITED',
    'DHARA PROCON PRIVATE LIMITED',
    'VOLTAR GREEN VEHICLES PRIVATE LIMITED',
    'TETHYS BUSINESS AND PILING PROJECTS PRIVATE LIMITED',
    'MAGS ENERGY SOLUTIONS PRIVATE LIMITED',
    'MINDKOSH TECHNOLOGIES PRIVATE LIMITED',
    'EXPRESEATS PRIVATE LIMITED',
    'INNOVENTIAL TECHNOLOGIES PRIVATE LIMITED',
    'PERFECT AGRO BEVERAGES PRIVATE LIMITED',
    'HEMKIRTI ASSOCIATES PRIVATE LIMITED',
    'PALKI CONSULTANCY SERVICES PRIVATE LIMITED',
    'TRISHULA INNOVATION PRIVATE LIMITED',
    'MIDNIGHT DIGITAL PRIVATE LIMITED',
    'N-SCOPE NETWARE PRIVATE LIMITED',
    'MOBIONIX AI PRIVATE LIMITED',
    'AAKATIR PRIVATE LIMITED',
    'PLASTICENT MARKETING PRIVATE LIMITED',
    'PRB AGRO AND FOODS PRIVATE LIMITED',
    'YAMI UNITED SERVICES PRIVATE LIMITED',
    'WM TRAVEL SOLUTIONS PRIVATE LIMITED',
    'QANTTYS SOFTWARE SOLUTIONS INDIA PRIVATELIMITED',
    'FRISSON HOTELS & RESORTS INDIA PRIVATE LIMITED',
    'ELJO LOGISTICS PRIVATE LIMITED',
    'F9 INFOTECH IT SOLUTIONS PRIVATE LIMITED',
    'ANSHIKA MULTICHEM PRIVATE LIMITED',
    'GENLEAP ECOSYSTEM PRIVATE LIMITED',
    'SUNTEK CHLORIDES PRIVATE LIMITED',
    'ADD4CART PRIVATE LIMITED',
    'SYNERGY TEV CONSULTING PRIVATE LIMITED',
    'VITTALACHARYA MAYAJALA SITRALU PRIVATE LIMITED',
    'NEXTEN INFRA GROWTH PRIVATE LIMITED',
    'ARV MULTIMEDIA PRIVATE LIMITED',
    'AMIYAA INNOVATIONS PRIVATE LIMITED',
    'GBT GOLD INDIA PRIVATE LIMITED',
    'HYPERFACE TECHNOLOGIES PRIVATE LIMITED',
    'EDSTRUMENTS INDIA PRIVATE LIMITED',
    'PEOPLEDECK PROFESSIONALS PRIVATE LIMITED',
    'GREEN ENERGY FINANCE PRIVATE LIMITED',
    'AICANC PRIVATE LIMITED',
    'LEARNCO INDIA PRIVATE LIMITED',
    'AIMEDAT SOLUTIONS PRIVATE LIMITED',
    'VISMA GLOBAL TRADING PRIVATE LIMITED',
    'ROBOZ DOTIN TECH PRIVATE LIMITED',
    'AISRM MULTIMETALS PRIVATE LIMITED',
    'ELSOL GLOBAL MERCHANDISE PRIVATE LIMITED',
    'BRCCA SERVICES PRIVATE LIMITED',
    'CODE24X7 PRIVATE LIMITED',
    'VUPRA INFRA PRIVATE LIMITED',
    'SENSUI FINSERV PRIVATE LIMITED',
    'SSBC CONCRETE PRIVATE LIMITED',
    'SATYAVIDYA WOODCHEM PRIVATE LIMITED',
    'ONX HOMES INDIA PRIVATE LIMITED',
    'ACHINTYA AGRISCIENCES PRIVATE LIMITED',
    'TNC360 FITNESS SOLUTION PRIVATE LIMITED',
    'LEMLEAF VENTURES PRIVATE LIMITED',
    'PETABYTE SYSTEMS PRIVATE LIMITED',
    'NOVITY FINTECH PRIVATE LIMITED',
    'SPECTRAA CARE PRIVATE LIMITED',
    'SLR SHIPPING PRIVATE LIMITED',
    'EARTH ROASTERY PRIVATE LIMITED',
    'VITHI IT SOLUTIONS PRIVATE LIMITED',
    'YUG-P INDIA PRIVATE LIMITED',
    'CERTICK (OPC) PRIVATE LIMITED',
    'SRN RECYCLING PRIVATE LIMITED',
    'INDXXING MANAGEMENT SERVICES PRIVATE LIMITED',
    'SWITCHY TECHNOLOGIES PRIVATE LIMITED',
    'BANGALORE ELECTRIC BUS PRIVATE LIMITED',
    'THINKVIBES SOFTWARE PRIVATE LIMITED',
    'RRE STUDIOS PRIVATE LIMITED',
    'N SQUARED TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DRP LABS PRIVATE LIMITED',
    'OX COMMERCE INDIA (OPC) PRIVATE LIMITED',
    'KUNZITE FOODS PRIVATE LIMITED',
    'BEEKAY SEE INFRAVENTURES PRIVATE LIMITED',
    'ECOTRONICS ENERGY SOLUTIONS PRIVATE LIMITED',
    'LUCID MUSIC EDUCATION PRIVATE LIMITED',
    'V3SPARK PRIVATE LIMITED',
    'TSAROLABS PRIVATE LIMITED',
    'GREENADVISE TECHNOLOGIES PRIVATE LIMITED',
    'JUSTVEND PRIVATE LIMITED',
    'VIRAT BIOFUELS PRIVATE LIMITED',
    'ELEVEN ELEVEN COSMETICS PRIVATE LIMITED',
    'JINDAL INFRAPROJECTS PRIVATE LIMITED',
    'PARAMANAND WELLNESS YATRA PRIVATE LIMITED',
    'REAL BUY CASH N CARRY PRIVATE LIMITED',
    'SROTAS HEALTHCARE PRIVATE LIMITED',
    'TOUCHWOOD TECHNOLOGIES PRIVATE LIMITED',
    'ROSEC JEWELS PRIVATE LIMITED',
    'VERANDA IAS LEARNING SOLUTIONS PRIVATE LIMITED',
    'ALTRAVEDIC HEALTHCARE PRIVATE LIMITED',
    'SPEEDBURY SOLUTIONS PRIVATE LIMITED',
    'IMBROX INFOTECH PRIVATE LIMITED',
    'W3ELITES PRIVATE LIMITED',
    'AYURSH TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'GREENGEN ENERGY PRIVATE LIMITED',
    'DOSE MEDICARE PRIVATE LIMITED',
    'MEDULLUS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'VILLBRIGHT LEARNING PRIVATE LIMITED',
    'CYBOARD EDTECH PRIVATE LIMITED',
    'SIX PACK PACKAGING PRIVATE LIMITED',
    'LEARNFLUENCE EDUCATION PRIVATE LIMITED',
    'WAYFR TECHNOLOGIES PRIVATE LIMITED',
    'NETNEX GLOBAL PRIVATE LIMITED',
    'SAI BANKA SPV PRIVATE LIMITED',
    'ICONIC FACILITY SERVICES PRIVATE LIMITED',
    'SUDAKSHA EDUCATION PRIVATE LIMITED',
    'DHARINI EDUCATIONAL FOUNDATION',
    'SHILPI GOLDCRAFT PRIVATE LIMITED',
    'RASPBERRY PI EDUCATIONAL SERVICES PRIVATE LIMITED',
    'CYBOARD FOUNDATION',
    'SHIVIKA RETAIL VENTURES PRIVATE LIMITED',
    'TEAM D ENGINEERING PRIVATE LIMITED',
    'NEXTEN INFRA PRIVATE LIMITED',
    'VSA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ABNW PRODUCTS AND SERVICES PRIVATE LIMITED',
    'GLOBUS CONSULTING SERVICES PRIVATE LIMITED',
    'NAYAMYLK PRODUCTS PRIVATE LIMITED',
    'VINATA AEROMOBILITY PRIVATE LIMITED',
    'MARKET PULSE SECURITIES PRIVATE LIMITED',
    'SHRIACHTYUTA SERVICES PRIVATE LIMITED',
    'SCHOOLHOUSE PROJECT MANAGERS PRIVATE LIMITED',
    'GOPI TRANS AND CLEARING AGENCY PRIVATE LIMITED',
    'AQUA PARADISE PRIVATE LIMITED',
    'SKALABIL TECHNOLOGIES PRIVATE LIMITED',
    'MRT TOURS AND TRAVELS PRIVATE LIMITED',
    'RETAILIGENCE SOLUTIONS PRIVATE LIMITED',
    'SABAIDEE COUTURE PRIVATE LIMITED',
    'CHOIC11 FANTASY SPORTS PRIVATE LIMITED',
    'CHOWGULE LAVGAN SHIPREPAIR PRIVATE LIMITED',
    'LEAPPOINT CONSULTING SERVICES PRIVATE LIMITED',
    'CHOWGULE PRESTIGE PRIVATE LIMITED',
    'EDUPOLIS EDUCATION TECHNOLOGY PRIVATE LIMITED',
    'TATA ELECTRONICS PRIVATE LIMITED',
    'JLS LABORATORIES PRIVATE LIMITED',
    'GREEN WEB MEDIA PRIVATE LIMITED',
    'EQOVA HEALTHCARE PRIVATE LIMITED',
    'ORBIT INFOWAYS PRIVATE LIMITED',
    'J. K. PROTOMAX PAINTS PRIVATE LIMITED',
    'ESGI ADVANCED TECHNOLOGIES PRIVATE LIMITED',
    'ARUNODEEP FINSERV PRIVATE LIMITED',
    'N D TECHLAND PRIVATE LIMITED',
    'SUPARSHWA HEALTHCARE PRIVATE LIMITED',
    'ZENMAC SOLUTIONS PRIVATE LIMITED',
    'C3RL (OPC) PRIVATE LIMITED',
    'MOMENTUM CONTROLS SOFTWARE AND SERVICES PRIVATE LIMITED',
    'JPP ALUMNI FOUNDATION',
    'BEDOFF PRIVATE LIMITED',
    'PLINTHSTONE NETWORKS PRIVATE LIMITED',
    'QBO TRADING INDIA PRIVATE LIMITED',
    'BUILTUP ENGINEERING PRIVATE LIMITED',
    'CHEERHUG EDUCATION PRIVATE LIMITED',
    'CINEMASEN FILMS PRIVATE LIMITED',
    'WEHEAR INNOVATIONS PRIVATE LIMITED',
    'REALIZZAZIONI TECNOLOGICHE AVANZATE RTA INDIA PRIVATE LIMITED',
    'SHYAM GOEL FOUNDATION',
    '4OUR TECHNOLOGIES PRIVATE LIMITED',
    'PI-GRASS LABS PRIVATE LIMITED',
    'ENIGMASOFT TECHNOLOGIES PRIVATE LIMITED',
    'RADIANCE MH SUNRISE ONE PRIVATE LIMITED',
    'UNACREATORS PRIVATE LIMITED',
    'IMPULSEBYTE PRIVATE LIMITED',
    'VRRDDHI EXPRESS PRIVATE LIMITED',
    'FLOUR STORY HOSPITALITY (OPC) PRIVATE LIMITED',
    'GAMIX LABS PRIVATE LIMITED',
    'MOZART HR FABRIKS PRIVATE LIMITED',
    'DIGIO INTERNET PRIVATE LIMITED',
    'VEGAN TOBACCO PRIVATE LIMITED',
    'MINDRIOT RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'VEVESTA LABS PRIVATE LIMITED',
    'SATAT SAMADHAN FOUNDATION',
    'BAKESTER STUDIO (OPC) PRIVATE LIMITED',
    'WIZDEM TECHNOPACK PRIVATE LIMITED',
    'RUBIX IT SOLUTION PRIVATE LIMITED',
    'APPBEEZ INFOTECH PRIVATE LIMITED',
    'ELLIOTT SCOTT HR RECRUITMENT INDIA PRIVATE LIMITED',
    'INTUIWISE HEALTHTECH INDIA PRIVATE LIMITED',
    'MERIT POLYMERS PRIVATE LIMITED',
    'GEETEE COLD CHAIN PRIVATE LIMITED',
    'COHORTECH HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'INICHEPRO IT SOLUTIONS PRIVATE LIMITED',
    'TVISHA COMMUNICATIONS PRIVATE LIMITED',
    'PARGO INTERACTIVE PRIVATE LIMITED',
    'TOPIOX RESEARCH CENTRE PRIVATE LIMITED',
    'STAREDGE COMMUNICATIONS PRIVATE LIMITED',
    'ASTROC AS TECHNOLOGY PRIVATE LIMITED',
    'PICKLED ONION FOODS PRIVATE LIMITED',
    'GUNNAM AGRO TECH PRIVATE LIMITED',
    'STYLCOVE MODULARS PRIVATE LIMITED',
    'SDP CONTINGENT WORKFORCE SOLUTIONS PRIVATE LIMITED',
    'MAGNUM FOODS AND SNACKS PRIVATE LIMITED',
    'TRUE VALUE GREEN RENEWABLE PRIVATE LIMITED',
    'IDEACAP PRODUCTIONS PRIVATE LIMITED',
    'EVERNEST COMMERCIAL PROPERTIES PRIVATE LIMITED',
    'NESTWELL TECHNOLOGIES PRIVATE LIMITED',
    'DIGITALZONE MEDIA PRIVATE LIMITED',
    'RBML SOLUTIONS INDIA LIMITED',
    'HINGLAJ TRANSPORT SOLUTION PRIVATE LIMITED',
    'RECTERS CONSULTANCY SERVICES PRIVATE LIMITED',
    'JUPITER BUSINESS SERVICES PRIVATE LIMITED',
    'GREENHUB SYSTEMS PRIVATE LIMITED',
    'NITYA CONSUMER PRODUCTS PRIVATE LIMITED',
    'DMAN PRODUCTS INDIA PRIVATE LIMITED',
    'EIRA SPECIALITY PRIVATE LIMITED',
    'TICKLE RIGHT EDUVENTURES PRIVATE LIMITED',
    'DATABRASS PRIVATE LIMITED',
    'TAXING MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'INFUUE TECHNOLOGIES PRIVATE LIMITED',
    'PLANIFY CAPITAL LIMITED',
    'WEALTHIAN PRIVATE LIMITED',
    'CHANAN COMPONENTS PRIVATE LIMITED',
    'MBARK REAL ESTATE AND HOSPITALITY PRIVATE LIMITED',
    'MINIKLUB RETAIL PRIVATE LIMITED',
    'CYAN COLORZ PRIVATE LIMITED',
    'OUMUAMUA FOUNDATION',
    '3B HOMES PRIVATE LIMITED',
    'ZAINULABDIN GARMENTS PRIVATE LIMITED',
    'VENUS DATA PRODUCTS PRIVATE LIMITED',
    'ARISTO INFRA SERVICES (OPC) PRIVATE LIMITED',
    'TRIGON INDUSTRIES PRIVATE LIMITED',
    'PRODIGY EDUTECH PRIVATE LIMITED',
    'RAMRAM SOCIAL FOUNDATION',
    'HOME DIRECT RETAIL SOLUTIONS PRIVATE LIMITED',
    'AGVESTO INDIA IMF PRIVATE LIMITED',
    'NEOTEC ENTERPRISES LIMITED',
    'SOLIDARY FAIRTRADERS PRIVATE LIMITED',
    'EUROTECH PIVOT SOLUTIONS PRIVATE LIMITED',
    'TECHCONPRO PRIVATE LIMITED',
    'POORNATHA PARTNERING ENTREPRENEURS PRIVATE LIMITED',
    'TECHNOLOGIRE PRIVATE LIMITED',
    'SIGNO LABS PRIVATE LIMITED',
    'INKEY IT SOLUTIONS PRIVATE LIMITED',
    'KVPL GREENRANCH PRIVATE LIMITED',
    'SPRAYTECH AUTOMATION INDIA PRIVATE LIMITED',
    'QUANTIC AUTO PARTS PRIVATE LIMITED',
    'MUFFET RETAIL PRIVATE LIMITED',
    'SHANTINATH TECHNOLOGY PRIVATE LIMITED',
    'ANASHA FOODCRAFT (OPC) PRIVATE LIMITED',
    'DIXON TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'TORIN SERVICES PRIVATE LIMITED',
    'ESTATE FORT REALTY PRIVATE LIMITED',
    'INTERNATIONAL SCIENTIFIC INSTRUMENT PRIVATE LIMITED',
    'BHAVYANSH INTERIORS PRIVATE LIMITED',
    'CONTIUM TECH PRIVATE LIMITED',
    'BPS ACCESSORIES PRIVATE LIMITED',
    'FENIKS CONTROL INSTRUMENTS PRIVATE LIMITED',
    'FOUSES BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CONTENT-WHALE PRIVATE LIMITED',
    'SAA AB ENGINEERING PRIVATE LIMITED',
    'PAYGLOCAL TECHNOLOGIES PRIVATE LIMITED',
    'TERRARIUM AGRITECH PRIVATE LIMITED',
    'ZLIGHT RESEARCH PRIVATE LIMITED',
    'VINIT CONSULTING SERVICES PRIVATE LIMITED',
    'GENMOT COILS PRIVATE LIMITED',
    'HAWKSTACK TECHNOLOGIES PRIVATE LIMITED',
    'MERITAGE INFRA PRIVATE LIMITED',
    'VELLORA SOLAR POWER PARK PRIVATE LIMITED',
    'RAM ASTHA MISSION FOUNDATION',
    'VISTA SPACES AQUA PRIVATE LIMITED',
    'PIXELCOMPOSER PRIVATE LIMITED',
    'RANDER HOSPITALITY PRIVATE LIMITED',
    'POLO PACKAGING PRIVATE LIMITED',
    'CAELINA BIOTECH PRIVATE LIMITED',
    'BIOQ ECO SOLUTIONS PRIVATE LIMITED',
    'CHARM LOGISTICS PRIVATE LIMITED',
    'CONPLAST INDUSTRIES PRIVATE LIMITED',
    'EKAGYA EXPORTS PRIVATE LIMITED',
    'ARNI WHEELS PRIVATE LIMITED',
    'VMAN AVIATION SERVICES IFSC PRIVATE LIMITED',
    'COSMOS DIAMONDS (OPC) PRIVATE LIMITED',
    'BEES AND BITES AGRO PRIVATE LIMITED',
    'EXPLURGER PRIVATE LIMITED',
    'CASTOR INFRASTRUCTURE PRIVATE LIMITED',
    'RAMATRI FOODS PRIVATE LIMITED',
    'I-HUB QUANTUM TECHNOLOGY FOUNDATION',
    'BARAY INDIA PRIVATE LIMITED',
    'AVNI HOSPITALITY SERVICES PRIVATE LIMITED',
    'VALADD BEVERAGES (OPC) PRIVATE LIMITED',
    'YAIMA EYE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'SURYAMITRA RENEWABLES PRIVATE LIMITED',
    'RAGE FAN SPORTS TECHNOLOGIES PRIVATE LIMITED',
    'WECODELIFE PRIVATE LIMITED',
    'PETERS WORLDWIDE PRIVATE LIMITED',
    'INFOTEL IT CONSULTING PRIVATE LIMITED',
    'MIDHURAM HEALTHCARE PRIVATE LIMITED',
    'AMPLINK LOGISTICS PRIVATE LIMITED',
    'DATA FACADE PRIVATE LIMITED',
    'GLOBESTAR GROUPAGE SERVICES PRIVATE LIMITED',
    'VENT INFOTECH PRIVATE LIMITED',
    'MODER SOLUTIONS INDIA PRIVATE LIMITED',
    'RECYCLIB PRIVATE LIMITED',
    'PIXBOTS PRIVATE LIMITED',
    'PARTH POLY FUSION PRIVATE LIMITED',
    'SUPERCHARGE ENERGY (OPC) PRIVATE LIMITED',
    'SMARTDUST TECHNOLOGIES PRIVATE LIMITED',
    'CONTACTCURE HEALTHCARE SERVICES PRIVATE LIMITED',
    'TECTABS INDIA PRIVATE LIMITED',
    'CANOPUS TOWNSHIP DEVELOPMENT PRIVATE LIMITED',
    'SIRIUS REAL ESTATE PRIVATE LIMITED',
    'SOLARON HOMEPAY PRIVATE LIMITED',
    'ADITI INFRA AND AGRI PRODUCTS PRIVATE LIMITED',
    'INNOVATEKEYS (OPC) PRIVATE LIMITED',
    'PHASTAR CRO PRIVATE LIMITED',
    'CLOSELOOP TECHNOLOGIES PRIVATE LIMITED',
    'WYSWA DIGITAL SERVICES (OPC) PRIVATE LIMITED',
    'TRUADVOS SOLUTIONS PRIVATE LIMITED',
    'M Y ORGANICS PRIVATE LIMITED',
    '315 WORK AVENUE HYD SPACES PRIVATE LIMITED',
    'LINGUAPHILE SKILLS HUB PRIVATE LIMITED',
    'TORNOTRON E-COMMERCE PRIVATE LIMITED',
    'TCG SOUTHERN STAR PRIVATE LIMITED',
    'YOTRIBE LEARNING PRIVATE LIMITED',
    'VENUELINK PRIVATE LIMITED',
    'APG ELECTRICAL PRIVATE LIMITED',
    'SURGEONSLAB (OPC) PRIVATE LIMITED',
    'DORPIE PRIVATE LIMITED',
    'LML CONSULTING PRIVATE LIMITED',
    'ALTEUS SONS PRIVATE LIMITED',
    'DANG INVESTMENTS PRIVATE LIMITED',
    'DIGITAL INOVATION SOFTWARE SOLUTION PRIVATE LIMITED',
    'IVY MOBITECH SERVICES PRIVATE LIMITED',
    'BTS INNOVATION PRIVATE LIMITED',
    'DK INFOSYSTEM (OPC) PRIVATE LIMITED',
    'PRAVRIDH TECHNOLOGIES PRIVATE LIMITED',
    'YSYSINFO SERVICES PRIVATE LIMITED',
    'ANNAMAYYA INFOTAINMENT STUDIOS PRIVATE LIMITED',
    'NIKUNJ HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'IMEMORI TECHNOLOGIES PRIVATE LIMITED',
    'THINKLY MEDIA SERVICES PRIVATE LIMITED',
    'OZONELAND AGRO PRIVATE LIMITED',
    'DIGITOSAURUS (OPC) PRIVATE LIMITED',
    'ZRENIE HEALTHCARE PRIVATE LIMITED',
    'K. C. CREATIONS FABRICS PRIVATE LIMITED',
    'PIENZA TECH INDIA PRIVATE LIMITED',
    'THOUGHTWHIZ SOFTWARE PRIVATE LIMITED',
    'P4LOGICS TECHNOLOGIES PRIVATE LIMITED',
    'ABSOLUTELY YUMMY PRIVATE LIMITED',
    'APTYN HOSPITALITY PRIVATE LIMITED',
    'SBH INDUSTRIES PRIVATE LIMITED',
    'TGP PROJECTS INDIA PRIVATE LIMITED',
    'COSMOS PUMPS PRIVATE LIMITED',
    'KNAV SERVICES PRIVATE LIMITED',
    'AGROCHEM INTERMEDIARIES PRIVATE LIMITED',
    'KRISHA IT SERVICES PRIVATE LIMITED',
    'TECHENSEFIER (OPC) PRIVATE LIMITED',
    'ASSOCIATION OF ETER NIS FLAT OWNERS',
    'BLACKWING SOFT-TECH PRIVATE LIMITED',
    'SKAD ADVISORY SERVICES PRIVATE LIMITED',
    'FASHION FUTURES CONSULTANTS PRIVATE LIMITED',
    'CYPHERSTREAM SOFTWARE PRIVATE LIMITED',
    'PREMIER ENERGIES GLOBAL ENVIRONMENT PRIVATE LIMITED',
    'AVAADA MHVIDARBHA PRIVATE LIMITED',
    'SAASTHA GLOBAL LOGISTICS PRIVATE LIMITED',
    'KCC BETHAMANGALA EXPRESSWAY PRIVATE LIMITED',
    'CROWNSTONE CONSTRUCTIONS PRIVATE LIMITED',
    'AAHELI GOLD NIDHI LIMITED',
    'BARGAINMART PRIVATE LIMITED',
    'MUTHRA INDUSTRIES PRIVATE LIMITED',
    'RAJPROTIM ART VENTURES PRIVATE LIMITED',
    'QUEST W TALENT SOLUTIONS PRIVATE LIMITED',
    'VAISHANTH SOLUTIONS PRIVATE LIMITED',
    'ROOTS & MORE PRIVATE LIMITED',
    'CENTERPIECE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MAHINDRA SOLARIZE PRIVATE LIMITED',
    'UNIQUE DOSING SYSTEMS PRIVATE LIMITED',
    'RISINGS PROPMART & INTERIOR PRIVATE LIMITED',
    'RAVI ENGINEERS PRIVATE LIMITED',
    'BREATHING PLANET FOUNDATION',
    'OUTSYSTEMS INDIA PRIVATE LIMITED',
    'FEROZE AND SONS VENTURES PRIVATE LIMITED',
    'ACCOMREAL BUILDERS PRIVATE LIMITED',
    'SCIENS LOGISTICS INDIA PRIVATE LIMITED',
    'GRUHAMTIAMORE PRIVATE LIMITED',
    'KOBOLT CASTINGS PRIVATE LIMITED',
    'XYZALL PROPERTY MANAGEMENT PRIVATE LIMITED',
    'POTTERS TECHNOLOGIES PRIVATE LIMITED',
    'LEKTUS INFRASTRUCTURE PRIVATE LIMITED',
    'DP COCOA PRIVATE LIMITED',
    'DIGIZION PRIVATE LIMITED',
    'ZYMECK INDIA PRIVATE LIMITED',
    'VG TEK CHEMICAL ENTERPRISES PRIVATE LIMITED',
    'HTF FOUNDATION',
    'HIND YUGM PRIVATE LIMITED',
    'RAIN VERTICALS LIMITED',
    'KAMAKSHII PROFESSIONAL SERVICES PRIVATE LIMITED',
    'VEDICCORP SERVICES PRIVATE LIMITED',
    'SPEART LANE INVESTMENTS PRIVATE LIMITED',
    'XPERT TECHWARE PRIVATE LIMITED',
    'TENSION TECHNOLOGY INDIA PRIVATE LIMITED',
    'GET PAZ INSURANCE BROKERS PRIVATE LIMITED',
    'CTC PRAEZISION TOOLS PRIVATE LIMITED',
    'SUPERCAP FINANCE TECHNOLOGY INDIA PRIVATE LIMITED',
    'AVRIKA LIFE INDIA PRIVATE LIMITED',
    'YASHODA PATHOLOGY PRIVATE LIMITED',
    'NMP READYMADES PRIVATE LIMITED',
    'RKE ENGINEERS PRIVATE LIMITED',
    'UMANG ENCAPSULATION SOLUTIONS PRIVATE LIMITED',
    'SECURA SOURCE PRIVATE LIMITED',
    'AQUAREGIA CONSULTING SERVICES PRIVATE LIMITED',
    'MAVERICK GURUS PRIVATE LIMITED',
    'NSR ADVISORS PRIVATE LIMITED',
    'EXAFLUENCE GLOBAL ANALYTICS PRIVATE LIMITED',
    'GOOD TRIBE PRIVATE LIMITED',
    'REDEFINIT TECHNOLOGIES PRIVATE LIMITED',
    'NUH KRISHI PRODUCER COMPANY LIMITED',
    'REM42 TECHNOLOGIES PRIVATE LIMITED',
    'ZUME IT SOLUTIONS PRIVATE LIMITED',
    'RAASVIN UNIVERSAL POLYMERS PRIVATE LIMITED',
    'ZENMARC ECOFIRM PRIVATE LIMITED',
    'TRINAV RL INFRA PRIVATE LIMITED',
    'PTG VENTURES PRIVATE LIMITED',
    'ANJAR TMT STEEL PRIVATE LIMITED',
    'TANTIA RENEWABLE ENERGY PRIVATE LIMITED',
    'MYRELAX FOAM PRIVATE LIMITED',
    'AGMA HEALTH FOODS AND MERCHANDISING PRIVATE LIMITED',
    'AM2PM SUPPORT PRIVATE LIMITED',
    'GAMEHUNT SPORTS INDIA PRIVATE LIMITED',
    'GEMAZE PRODUCTS PRIVATE LIMITED',
    'GOHIL TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'CZARR VILLAS PRIVATE LIMITED',
    'MAEYARE HOSPITALITY PRIVATE LIMITED',
    'KRUPA INTEGRATED SOLUTIONS INDIA PRIVATELIMITED',
    'PURPLYIELD SOLUTIONS PRIVATE LIMITED',
    'PROSERA ANALYTICS PRIVATE LIMITED',
    'VBB BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ISOCRATES MADTECH PRIVATE LIMITED',
    'KISIKO STUDIOS PRIVATE LIMITED',
    'SHRESTAA SILKS PRIVATE LIMITED',
    'RYBBON DIGITAL REWARDS INDIA PRIVATE LIMITED',
    'SYNAEGIS HEALTHTECH PRIVATE LIMITED',
    'IMPEL LABS PRIVATE LIMITED',
    'ODIES STRATEGIC HR INNOVATIONS PRIVATE LIMITED',
    'INVIOT SYSTEMS INDIA PRIVATE LIMITED',
    'DIGICFO BUSINESS ADVISORS PRIVATE LIMITED',
    'ELAENOR SMART SOLUTIONS PRIVATE LIMITED',
    'INTREPID TIGER TECHNOLOGY PRIVATE LIMITED',
    'ZEPNUR PRIVATE LIMITED',
    'BETTER TEAM HIRING TECHNOLOGIES PRIVATE LIMITED',
    'INFRAMART REALTECH INDIA PRIVATE LIMITED',
    'REMOTE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NSOFT INDIA AMI SOLUTIONS PRIVATE LIMITED',
    'RAPTURE INNOVATION LABS PRIVATE LIMITED',
    'QUMENT TECHNOLOGIES PRIVATE LIMITED',
    'JETTY VENTURES ADVISORS PRIVATE LIMITED',
    'RAPIDMIND TECHNOLOGIES PRIVATE LIMITED',
    'MAGNIBOT TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'FOURSOURCE INDIA PRIVATE LIMITED',
    'FIVETIX PROFESSIONAL SERVICES PRIVATE LIMITED',
    'OPENGROWTH MEDIA PRIVATE LIMITED',
    'MARKEL SERVICES INDIA PRIVATE LIMITED',
    'MELOT TECHNOLOGIES PRIVATE LIMITED',
    'CAPITALLOG (INDIA) PRIVATE LIMITED',
    'AIR GAS ELECTRONIC MATERIALS INDIA PRIVATE LIMITED',
    'ORALLA DENTAL PRIVATE LIMITED',
    'INDIA JEWELLERY PARK MUMBAI',
    'SHALIMAR INCENSE PRIVATE LIMITED',
    'ZAHIRDAMASO (INDIA) PRIVATE LIMITED',
    'MAKTOOB MEDIA PRIVATE LIMITED',
    'NES MEDICORP PRIVATE LIMITED',
    'MISPRAS FURNISHINGS PRIVATE LIMITED',
    'SPANV MEDISEARCH LIFESCIENCES PRIVATE LIMITED',
    'CYNOSYS IT SOLUTIONS PRIVATE LIMITED',
    'BALEINE SHIPPING SERVICES (INDIA) PRIVATE LIMITED',
    'ITIHASA PRODUCTIONS PRIVATE LIMITED',
    'LABHDHI CORPORATE SERVICES PRIVATE LIMITED',
    'EQUITRON MEDICA PRIVATE LIMITED',
    'BELLEE SPACE EDGE PRIVATE LIMITED',
    'YODLEE FINSOFT PRIVATE LIMITED',
    'LAND OPTIMIZER INTERNATIONAL PRIVATE LIMITED',
    'ANTZMEDIA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'WELLNESSTA PRIVATE LIMITED',
    'PROTECT LIFE MEDICAL TOURISM PRIVATE LIMITED',
    'ABHIRU MEDICAL PRIVATE LIMITED',
    'HELLO VERIFY INDIA PRIVATE LIMITED',
    'LIVEFROMEARTH MEDIA (OPC) PRIVATE LIMITED',
    'CONTRACTING PLUS CONSULTANCY SERVICES PRIVATE LIMITED',
    'ANOIXE MEDIA PRIVATE LIMITED',
    'HEPTARC TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'DEP DYNAMIC ENERGY PLUS PRIVATE LIMITED',
    'AASR COLLABORATIVE PRIVATE LIMITED',
    'PIP ENGINEERS & TECHNOCRATS PRIVATE LIMITED',
    'SAANCHIT TRANSPORT SERVICE PRIVATE LIMITED',
    'HOSPALS INDIA PRIVATE LIMITED',
    'DINERAMA PRIVATE LIMITED',
    'INNODEX TECHNOLOGIES PRIVATE LIMITED',
    'NOVOGENIE SERVICES PRIVATE LIMITED',
    'TESQUIREL SOLUTIONS PRIVATE LIMITED',
    'IBERRY',
    'S FACTORY PRIVATE LIMITED',
    'MAHLE ENGINEERING SERVICES INDIA PRIVATELIMITED',
    'ITSACOLLAB PRIVATE LIMITED',
    'BOLDITALIC BRAND COMM PRIVATE LIMITED',
    'OWN YOUR DEMAND PRIVATE LIMITED',
    'DESIGNS IN CHANGE TECHNOLOGY PRIVATE LIMITED',
    'GV RESEARCH PLATFORM PRIVATE LIMITED',
    'DEELAKSHYA ELECTRICALS PRIVATE LIMITED',
    'SWIO CORPORATE AND ITES PRIVATE LIMITED',
    'BTCORP GENERIQUE NANO PRIVATE LIMITED',
    'DIZIMONK SOLUTION PRIVATE LIMITED',
    'VISIONTECH DECOR PRIVATE LIMITED',
    'TIBRO TOURS PRIVATE LIMITED',
    'GYMNASTICS SPORTS AND EVENTS PRIVATE LIMITED',
    'DELLNER BUBENZER INDIA PRIVATE LIMITED',
    'KILO AMPERE PRIVATE LIMITED',
    'CORPSEED ITES PRIVATE LIMITED',
    'APERTUM ONLINE PRIVATE LIMITED',
    'LAKSHVEDHI MASS MEDIA PRIVATE LIMITED',
    'DIPLOMATS SUMMIT PRIVATE LIMITED',
    'INNOPLATS INFOTECH PRIVATE LIMITED',
    'RADITE RENEWABLES PRIVATE LIMITED',
    'DAIICHI JITSUGYO INDIA PRIVATE LIMITED',
    'VIVACHEM INTERMEDIATES PRIVATE LIMITED',
    'FRIZBEE COMMUNICATIONS PRIVATE LIMITED',
    'ANASHVISION CONSULTANCY PRIVATE LIMITED',
    'NEOSCIENCE INSTRUMENTS PRIVATE LIMITED',
    'OCEANIA WORLD TRADEROUTES PRIVATE LIMITED',
    'SOLENT AUTOSYS PRIVATE LIMITED',
    'WAKE-UP TECHNOLOGY PRIVATE LIMITED',
    'AOSTAF FOODS PRIVATE LIMITED',
    'LAXMISATYAM VENTURES PRIVATE LIMITED',
    'WINNOW LEARNING SOLUTIONS PRIVATE LIMITED',
    'ACTG COMPUTING SERVICES PRIVATE LIMITED',
    'PIM INDIA EVENT MANAGEMENT PRIVATE LIMITED',
    'HANGAR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TRANSITING CONSULTANCY SERVICES PRIVATE LIMITED',
    'BKM AGROTECH PRIVATE LIMITED',
    'SANSEC PHARMA SOLUTIONS PRIVATE LIMITED',
    'ALATION INDIA PRIVATE LIMITED',
    'NORBULK SHIPPING PRIVATE LIMITED',
    'RETRAH KLNTEK SOLUTIONS PRIVATE LIMITED',
    'CABOT INNOVATIONS PRIVATE LIMITED',
    'TARASVA SOLUTIONS PRIVATE LIMITED',
    'BINPLUS TECHNOLOGIES PRIVATE LIMITED',
    'CORE TECHIES INDIA PRIVATE LIMITED',
    'KJR-ECTRON INDIA PRIVATE LIMITED',
    'TALENT SMART SOFT SOLUTIONS PRIVATE LIMITED',
    'OWIT SERVICES INDIA PRIVATE LIMITED',
    'EDSENSE TECHNOLOGIES PRIVATE LIMITED',
    'ULTIWEB TECHNOLOGIES PRIVATE LIMITED',
    'TEKCLAN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SOLINAS INTEGRITY PRIVATE LIMITED',
    'MAVENICK CONSULTING PRIVATE LIMITED',
    'GETRAVS TECHNOLOGIES PRIVATE LIMITED',
    'AD HOC SCIENTIFIC PRIVATE LIMITED',
    'MAK TECHNOLABS PRIVATE LIMITED',
    'COPPERTAURUS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'AVC SYSTEMS SOLUTIONS PRIVATE LIMITED',
    'WEBZONE MEDIA PRIVATE LIMITED',
    'ANAS TEC INDIA PRIVATE LIMITED',
    'LAUNCHMYCAREER PRIVATE LIMITED',
    'L. B. ENGINEERING PRIVATE LIMITED',
    'FLAT DIGITAL PRIVATE LIMITED',
    'TRAILBYTRAIL TOURS PRIVATE LIMITED',
    'LIFEADVANTAGE TECHNOLOGY SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'FITFACTORY TECHNOLOGY INDIA PRIVATE LIMITED',
    'IDLTECH INDIA PRIVATE LIMITED',
    'OVERALL IT SERVICES PRIVATE LIMITED',
    'City corporation limited',
    'Ng dwelling private limited',
    'Sumangal real estate builders pvt ltd',
    'Kasturi housing private limited',
    'Merlin multitech private limited',
    'Unitech infopark limited',
    'NATIONAL AFFORDABLE HOUSING LIMITED',
    'Simplex envirosciences and infradevelopment private limited',
    'Unitech landmark developers limited',
    'Ivr vaanaprastha private limited',
    'Gangour nirman private limited',
    'G&a infrastructure india private limited',
    'Andees infratech private limited',
    'Kumar electcon private limited',
    'Vimsan realtors private limited',
    'H s projects private limited',
    'Landmark housing projects (india) private limited',
    'Mageba bridge products private limited',
    'Veenish realtors private limited',
    'Nishka properties private limited',
    'M. g. promoter private limited',
    'Sumangalam plaza pvt ltd',
    'Genten infra projects private limited',
    'Ivrcl indore gujarat tollways limited',
    'Tidel park coimbatore limited',
    'CHENGALAMMA PROPERTY DEVELOPMENT PRIVATE LIMITED',
    'Kushal kunj builders pvt ltd',
    'Geet buildhome private limited',
    'Berkshire land holdings private limited',
    'Shardul builders private limited',
    'Him leathers pvt ltd',
    'Manglam apartments ltd',
    'Ontime infrasolutions private limited',
    'Excel sports pvt ltd',
    'Suma shilp limited',
    'Satvik hitech builders private limited',
    'North east infrabuild private limited',
    'Sand rock developers private limited',
    'Chona build mantra services private limited',
    'Shreerampur complex pvt ltd',
    'Ashray infrabuild private limited',
    'Greencountry developers private limited',
    'Anant realcon private limited',
    'Solitaire infradevelopers private limited',
    'Mihir buildwell private limited',
    'Hometrail buildtech private limited',
    'Multimax capital projects private limited',
    'Star city buildhome private limited',
    'Worlds window urja private limited',
    'Shreyans buildtech private limited',
    'Neelgagan infracon private limited',
    'Prime infrapark private limited',
    'Re india infratech limited',
    'Atelier infrastructure private limited',
    'Atkin construction private limited',
    'Re india projects private limited',
    'Arki infra projects (india) private limited',
    'Mita nirman properties private limited',
    'Equitypandit financial services private limited',
    'Capiflex financial consultants private limited',
    'Overseas corpn. pvt ltd',
    'Bhartia holdings pvt ltd',
    'Skr properties consortium private limited',
    'MUSKAN EMPIRE & DEVELOPERS PRIVATE LIMITED',
    'Sidhi vinayak buildestate private limited',
    'Hebbal holdings private limited',
    'Badrinath industries limited',
    'Mohanbari investment company private limited',
    'Behubor investments ltd',
    'Eskay mercantile commercial & holding pvt ltd.',
    'Pranjal estates private limited',
    'Samar estates private limited',
    'Unique receivable management private limited',
    'Sheshjee marketing private limited',
    'Bhalcom holdings pvt. ltd.',
    'Quadrangle estates private limited',
    'Unitech build tech limited',
    'Woodhouse developers limited',
    'Ruby promoters private limited',
    'Vgsg realtors private limited',
    'Prestigious developers and infrastructures private limited',
    'Vpm projects private limited',
    'Delight propmart private limited',
    'Ilc infracon private limited',
    'Mandi valley infra private limited',
    'Utc infradevelopers private limited',
    'Manguru property management & solutions private limited',
    'First century capital management private limited',
    'Kentou management services private limited',
    'Sultan brothers private limited',
    'HILLSIDE INDUSTRIES PRIVATE LIMITED',
    'Chandan estates and trading co pvt ltd',
    'Mittal brothers pvt ltd',
    'Pinnac housing private limited',
    'Finprop advisory services limited',
    'Anand money changers private limited',
    'MAHESHWARI FABTEX PRIVATE LIMITED',
    'Pranay creations private limited',
    'Vastukar coloniser private limited',
    'Vaishnavkripa realty private limited',
    'PEARL INSTITUTE OF FINANCIAL MARKET PRIVATE LIMITED',
    'Sahil realtors private limited',
    'Piveta estates private limited',
    'Re india property management private limited',
    'Madav devadhidev colonizers india private limited',
    'Goldendunes buildhome private limited',
    'Goldendunes dreamcity private limited',
    'Goldendunes residency private limited',
    'Scion real estates private limited',
    'Mac infraheights private limited',
    'Franklin infratech private limited',
    'MILLION MILLS BUILDWELL PRIVATE LIMITED',
    'Wings realtors private limited',
    'Siruvani shopping malls private limited',
    'Palladam holdings private limited',
    'Thennampalayam holdings private limited',
    'Neelambur holdings private limited',
    'Akshara promoters india private limited',
    'Indian city properties ltd',
    'Navrang estates pvt ltd',
    'Khaitan estates pvt ltd',
    'Sahu estate private limited',
    'Priya promoters pvt. ltd.',
    'Total home secure property management services private limited',
    'Metro house private limited',
    'Earl development and reality private limited',
    'Dinesha reality and development private limited',
    'HIGH POINT PROPERTIES PRIVATE LIMITED',
    'Bangalore terrace holdings private limited',
    'Bengal swastik infra limited',
    'City infrapromoters private limited',
    'S d s properties pvt ltd',
    'Gee kay narain constructions (pvt) ltd',
    'Status niketan pvt ltd',
    'Sugam builders pvt. ltd.',
    'Rajokri builders and developers private limited',
    'Swastika holdings pvt ltd',
    'On the house private limited',
    'Pioneer property management limited',
    'Friends nirman private limited',
    'Arch enclave private limited',
    'Canopy projects limited',
    'ADHUNIK SHRISTI & POWER TRADING COMPANY LIMITED',
    'Ramesh enterprises private limited',
    'Sky top builders private limited',
    'Mrj projects private limited',
    'UNIQUE AFFORDABLE HOMES PRIVATE LIMITED',
    'Leonine estates private limited',
    'Bengal kdc housing development limited',
    'Aastha niketan pvt ltd',
    'Canopy infrastructure development (p) ltd',
    'Sarada niketan pvt ltd',
    'ARG INFRA DEVELOPERS PRIVATE LIMITED',
    'ARG HOUSING PRIVATE LIMITED',
    'Upasna realty private limited',
    'Shree riddhi siddhi realtech private limited',
    'Eastern centre pvt. ltd.',
    'Vinimay developers private limited',
    'Superstone properties private limited',
    'Doshi infrastructure private limited',
    'Delphi properties private limited',
    'Kuvawala properties private limited',
    'Manor stud farm private limited',
    'Pawan complex pvt. ltd.',
    'BVG JAL PRIVATE LIMITED',
    'Amrutha estate pvt ltd',
    'Ezeerooms accomodation private limited',
    'Noveulux lighting private limited',
    'Sahil media private limited',
    'Udan media and communications private limited',
    'W s fitness private limited',
    'Initiative31 consulting private limited',
    'COMMODEX TRADEWELL PRIVATE LIMITED',
    'Talentpro india hr private limited',
    'Interpro resource management services private limited',
    'Blue ocean personnel & allied services private limited',
    'People connect placements private limited',
    'Gdx facility and management services private limited',
    'Satyanarayan fraud management & investigation services private limited.',
    'Elen blossoms and greens limited',
    'Express housekeeper private limited',
    'Core solucomm limited',
    'Venor pharma limited',
    'Meps packaging and wares private limited',
    'TOUR INDIA HOSPITALITY LIMITED',
    'Aditya packaging and consulting services private limited',
    'Prayag corporate solutions private limited',
    'Assiduous consulting private limited',
    'S d service management private limited',
    'S.D. SAMATA NAGAR PROPERTY MAINTENANCE PRIVATE LIMITED',
    'Sahara global mastercraft limited',
    'Inkpot films private limited',
    'Kinetic fgtecnopolo engineering services private limited',
    'Flexi careers india private limited',
    'Kun capital automotive private limited',
    'Oneplace web solution private limited',
    'Jrb packers private limited',
    'Allspheres entertainment private limited',
    'Citius management consultants private limited',
    'Associated industrial development co pvt ltd',
    'Topnotch retail private limited',
    'Ngs designs private limited',
    'A design indi private limited',
    'Dg designs private limited',
    'Kangaroo wings digital marketing private limited',
    'REERACOEN INDIA PRIVATE LIMITED',
    'Navachetana enterprises haveri private limited',
    'Erudite financial services private limited',
    'Msl holdings private limited',
    'Bips systems limited',
    'Religare commodities limited',
    'Tee kay organics private limited',
    'Shubhi agencies private limited',
    'Wacorp hyundai india limited',
    'Adept designs private limited',
    'Bikaner power partners private limited',
    'Arise reinforcement private limited',
    'Pabsta engineers india limited',
    'Mera interiors private limited',
    'Holisol environment solutions private limited',
    'Proem hospitality private limited',
    'Aryan hr consulting private limited',
    'Hawk eye securities and facilities private limited',
    'Apeiron projects private limited',
    'Mb photoindia.com private limited',
    'Sansrack publishing solutions private limited',
    'Kalvi infrastructure private limited',
    'Niraj logistics private limited',
    'Tvl engineers private limited',
    'Mindfield resources india private limited',
    'Avangarde enterprises private limited',
    'Vocman india private limited',
    'Posterity consulting private limited',
    'JALEIDOSCOPE TECHNOLOGIES PRIVATE LIMITED',
    'Samishti infotech private limited',
    'Engineering graphic services private limited',
    'Ascian paperplus private limited',
    'IVORY CASA LIMITED',
    'Samka holdings private limited',
    'RAVINDRA TUBES Private Limited',
    'New life hotels and resorts private limited',
    'Jodhpur design company private limited',
    'L&t valves limited',
    'Shree bhagwan fabrics limited',
    'Shiva capital peddar consulting private limited',
    'Maxim electronics pvt ltd',
    'Kinetic marketing and services limited',
    '3 cube bio-med services private limited',
    'RASIKLAL MANEKLAL PRIVATE LIMITED',
    'Adiurja private limited',
    'Aloft aviation private limited',
    'VERSATILE ENTERPRISES PRIVATE LIMITED',
    'Blueland media and services private limited',
    'Swarn corp private limited',
    'Autus financial consultants private limited',
    'Jindal trading company private limited',
    'K dhandapani and co limited',
    'Earth sense recycle private limited',
    'Mtv gold private limited',
    'BOMBAY BUSINESS CONSULTING PRIVATE LIMITED',
    'Vibazone private limited',
    'AIWIN COMMODITY BROKER PRIVATE LIMITED',
    'EKO IMPORTING & RETAILING PRIVATE LIMITED',
    'Bharatheeyam security services private limited',
    'Greenergy research private limited',
    'C s s automation private limited',
    'Krish biotech research private limited',
    'Mvp consultancy services international private limited',
    'Vaanya travels private limited',
    'Dv re-rolling mills private limited',
    'Hyperion accounting & analytics private limited',
    'Pinnacle decor private limited',
    'Colonial crafts private limited',
    'Vedaang ventures private limited',
    'Sintech precision products limited',
    'Suvi international private limited',
    'Gangalaxmi industries limited',
    'KISCOL BLU METTAL PRIVATE LIMITED',
    'RATNAVEER PRECISION ENGINEERING LIMITED',
    'Rathi saria limited',
    'Worldtech industries private limited',
    'Shyam sel and power limited',
    'Vns industries private limited',
    'A.p. explosives private limited',
    'S k oil field equipment company private limited',
    'FATHIMUTHU AMMA MILLS PRIVATE LIMITED',
    'Jewel profile pvt ltd',
    'Digha steel industries pvt ltd',
    'ICORE IRON & STEEL PRIVATE LIMITED',
    'Kesri metal limited',
    'Echjay alloy and special steel private limited',
    'Alpha founders private limited',
    'Ulhas jewellers private limited',
    'Abharan jewellers private limited',
    'VAISHALI METALS PRIVATE LIMITED',
    'Shri vishnu refractories limited',
    'Orient gems & ornaments private limited',
    'Oak india private limited',
    'Eurokon global exports private limited',
    'Walzen strips private limited',
    'Maa usha urja limited',
    'Msp sponge iron limited',
    'R.s. engineering solutions private limited',
    'Aldowin industries private limited',
    'Iceburg technocast private limited',
    'Pooja castings pvt.ltd.',
    'Bajrang ispat pvt ltd',
    'Rajhans impex private limited',
    'Arpit engineers private limited',
    'Maha laxmi saws private limited',
    'Steel shoppe india private limited',
    'Amman-try sponge and power private limited',
    'Elkayem auto ancillaries private limited',
    'Active metals private limited',
    'Tirumalabalaji exim private limited',
    'Rajesh metal industries private limited',
    'Surabhi steels private limited',
    'G b r metals private limited',
    'WARDEN EDUCATION TECHNOLOGIES PRIVATE LIMITED',
    'KELVION INDIA PRIVATE LIMITED',
    'M-secure hr services private limited',
    'Vinod manufacturing private limited',
    'Zenith forge private limited',
    'Somesh forge pvt ltd',
    'Devidayal rolling mills private limited',
    'Duro shox pvt ltd',
    'Suraj pressings private limited',
    'Seiko plastic woven sack private limited',
    'Warana industries limited',
    'Auto glass traders private limited',
    'Sharpedge machine tools pvt ltd',
    'Wonder cars private limited',
    'C. commens & sons ltd',
    'Toho manu machine parts private limited',
    'LAKSHMI PRECISION TECHNOLOGIES LIMITED',
    'Des sons fittings private limited',
    'Global composites and structurals limited',
    'Libra appliances pvt ltd',
    'Sp aluminium systems private limited',
    'ADITYA ALUMINIUM PRIVATE LIMITED',
    'Atc precision components private limited',
    'Dhariwal industries private limited',
    'Emtex engineering private limited',
    'Heatex technologies (india) private limited',
    'Gang engineering private limited',
    'Savera precision engineering private limited',
    'Anchor industries (india) pvt ltd',
    'Alclad fabrication private limited',
    'Chandan wire products private limited',
    'Diamondere private limited',
    'Innovative engi-impex private limited',
    'Abhijat equipments private limited',
    'DANFOSS SYSTEMS LIMITED',
    'Vispark jewellery manufacturers private limited',
    'Rotocast industries limited',
    'Stelco limited',
    'Vak heattreaters manufacurers pvt ltd',
    'Kannappan alloy and steel company private limited',
    'Japan metal building systems private limited',
    'Shri balaji industrial products limited',
    'ENMAS ENVIRO PROJECTS PRIVATE LIMITED',
    'P p s. steels india private limited',
    'Anand concast limited',
    'Technotherm projects pvt ltd',
    'Thomas mouget & co india ltd',
    'Goa handling controls private limited',
    'Weco elevator private limited',
    'Akay valves private limited',
    'Mrc cranes private limited',
    'V T INDUSTRIES PVT LIMITED',
    'Case components industries private limited',
    'Miracle foils private limited',
    'Echjay industries private limited',
    'RAASHRI PAINTS & BARRELS PRIVATE LIMITED',
    'Swan engitech works private limited',
    'VENUS PRECISION TOOLS & COMPONENTS PRIVATE LIMITED',
    'Madras hardtools private limited',
    'Ramsays corporation private limited',
    'Edgetech air systems private limited',
    'Enviro roots devices private limited',
    'Membrane filters (india) private limited',
    'R.r. rolling mills pvt ltd',
    'WORLD OF STONES PRIVATE LIMITED',
    'Precicom private limited',
    'Chougule machines p.ltd.',
    'Ripples fountains private limited',
    'Welkin telecom infra private limited',
    'Vanilla fields pvt ltd',
    'Ganges steel mfg co india pvt ltd',
    'Trootrac media private limited',
    'Rsv klothield impex private limited',
    'Sushant sales private limited',
    'J.h. jewels private limited',
    'Trade (worldwide) pvt. ltd',
    'Ttc marketing pvt ltd',
    'Burman vessels private limited',
    'Protex computer pvt ltd',
    'Ynm impex private limited',
    'N s n biotech private limited',
    'Agc enterprises private limited',
    'Srk overseas pvt ltd',
    'J.s.m. enterprises pvt. ltd.',
    'Futureplan enterprises private limited',
    'Alex multani commodities india private limited',
    'Padmavati tradelink limited',
    'Gunnayak vyapaar private limited',
    'Ellora mercantile private limited',
    'Gunnayak vanijya private limited',
    'Intregal distributors private limited',
    'Hesky suppliers private limited',
    'Muskan commercial private limited',
    'Gautam commercial private limited',
    'Sesderma india private limited',
    'Soham overseas private limited',
    'AVI MARKETING & SERVICE PRIVATE LIMITED',
    'JAGDHATRI VINIMAY PRIVATE LIMITED',
    'Hertz trade centre private limited',
    'Kamrup vanijya private limited',
    'Sunstrike telecom private limited',
    'Advent dealcomm private limited',
    'Venus tie-up private limited',
    'Jaldham vanijya private limited',
    'Mars dealcomm private limited',
    'Corset wholesale limited',
    'Muskaan tradex private limited',
    'Sunder impex private limited',
    'L.s pacific wood tech pvt ltd',
    'Pescainde private limited',
    'Bacchus enterprises limited',
    'Designer health private limited',
    'Kanoria co pvt ltd',
    'BIHAR MERCANTILE UNION PRIVATE LIMITED',
    'Caravan commercial co ltd',
    'Heralds agencies ltd.',
    'Wonderdecor pvt. ltd.',
    'Elecom exports p. ltd.',
    'Vidushi vincom ltd.',
    'MILIT FOOD PRODUCTS PRIVATE LIMITED',
    'Jajodia commodities private limited',
    'Sterling finvest private limited',
    'Park real con private limited',
    'Primesoft vintrade private limited',
    'Baleshwar commercial pvt ltd',
    'West win textile pvt ltd',
    'Hytone impex private limited',
    'Nutshell vyapaar pvt ltd',
    'Subham sales private limited',
    'HIRAGAURI INFRATECH PRIVATE LIMITED',
    'Kishaloy vyapar private limited',
    'Vaap international private limited',
    'Mangalrashi tie up private limited',
    'Anvin electronics private limited',
    'Infra sales pvt ltd',
    'Sri ram tie-up private limited',
    'Dreamvalley distributors private limited',
    'Anc tradecomm co. private limited',
    'Mayank vanijya private limited',
    'S. h. retail private limited',
    'Goldmax trade n biz private limited',
    'Everlink vanijya private limited',
    'New hind silk house private limited',
    'Subhmangal suppliers private limited',
    'Crossroad barter private limited',
    'Rishi commercial private limited',
    'Basundhara infracon private limited',
    'Rajshree bussinness private limited',
    'Vb exclusives private limited',
    'Uplabdhi tracom pvt ltd',
    'Sakriya commodeal pvt ltd',
    'Kamaldeep vanijya private limited',
    'Zephyr dealcom private limited',
    'Bravo tradelinks private limited',
    'Skipper distributors private limited',
    'Amritvani merchants private limited',
    'Upbright industrial supply private limited',
    'Platinum tradelinks private limited',
    'ANNAPURNA FINANCE PRIVATE LIMITED',
    'Crystal vintrade private limited',
    'Sanjay distributors private limited',
    'Rose goods private limited',
    'Shree gannayak infrastructure private limited',
    'H t exports private limited',
    'Styleone retail concepts private limited',
    'Elde electrical agencies private limited',
    'Teenlok impex private limited',
    'Valiramsons dye works private limited',
    'Relevant e-solutions private limited',
    'Shreetech life sciences private limited',
    'SUPREME FINCORP PRIVATE LIMITED',
    'Shivamani pharma pack private limited',
    'Krishni exports private limited',
    'Kamdhenu management consultants private limited',
    'Zeecare marketing private limited',
    'Real shoppee retail private limited',
    'Crown enterprises private limited',
    'S3 infotech private limited',
    'Accord it services private limited',
    'Promunt online services private limited',
    'Hi lead infotech private limited',
    'Manleen infotech private limited',
    'Anchal technovations private limited',
    'Kross innovations private limited',
    'Pemari technology private limited',
    'Pheuture studio private limited',
    'Voicetec networks private limited',
    'Aim techsoft private limited',
    'Esec forte technologies private limited',
    'EBIX CORPORATE SERVICES PRIVATE LIMITED',
    'HEURISTTIC MINDS PRIVATE LIMITED',
    'Dvayweb consultancy services private limited',
    'NETLINK INTELLIGENCE PRIVATE LIMITED',
    'Cattlefield technologies india private limited',
    'Sarvatra technologies private limited',
    'Funnelxpert solutions private limited',
    'Globtier infotech private limited',
    'PURE ITES LIMITED',
    'Youlogix infotech private limited',
    'Kamadhenu technology private limited',
    'Spactro media private limited',
    'Getvee technologies private limited',
    'Ethernetxpress india private limited',
    'Shri prakash infosys private limited',
    'AIRFINS PRIVATE LIMITED',
    'Ilex softhub private limited',
    'Accent softech private limited',
    'Concord technosoft private limited',
    'Unikove technologies private limited',
    'Yentha digital network private limited',
    'Silicontech solutions (india) private limited',
    'Legalpundits international services private limited',
    'Neorithm technologies private limited',
    'Elde info solutions private limited',
    'Kapsons solutions private limited',
    'Logiciel solutions private limited',
    'Uberall solutions (india) limited',
    'MARKMYDIARY TECHNOLOGIES PRIVATE LIMITED',
    'EXCELLARATE SOFTECH PRIVATE LIMITED',
    'Nomadic solutions private limited',
    'Macreel info soft private limited',
    'Toradex systems (india) private limited',
    'Oz infotech private limited',
    'Gallop networks india private limited',
    'Volante software private limited',
    'Lohia bio-energy farms and realties private limited',
    'Enisys management private limited',
    'Framebench technologies private limited',
    'Group10 technologies private limited',
    'Webpulse solution private limited',
    'Virtual pages private limited',
    'KKN HOLDINGS PRIVATE LIMITED',
    'Nouveau infotech private limited',
    'Suvidha infotech com services private limited',
    'Abacus digital private limited',
    'Desicrew services kaup private limited',
    'Spinoff technopark private limited',
    'Opg computer aided design private limited',
    'ANVEERA TECH PRIVATE LIMITED',
    'Vipragen biosciences private limited',
    'Prakruti life science private limited',
    'Soukhyaveda foundation',
    'Quality plants and technology private limited',
    'I-one tech labs private limited',
    'Tejas innovative solutions private limited',
    'Gd stopp technologies private limited',
    'RIPLEY & COMPANY STEVEDORING & HANDLING PVT LTD',
    'Amudit info systems private limited',
    'Style solutions private limited',
    'R. s. softweb private limited',
    'Ascent buildtech private limited',
    'Ibroad7 communication private limited',
    'Paxcel technologies private limited',
    'Fortuna computech private limited',
    'Dextrous infosolutions private limited',
    'Emarson network services private limited',
    'Heimdall advisory private limited',
    'Mcube capital advisors private limited',
    'TOUCHLIFE ENTERPRISES PRIVATE LIMITED',
    'Optimist computers private limited',
    'PRADEEP SHARMA ASSOCIATES PRIVATE LIMITED',
    'Arlington information systems private limited',
    'Dynamic outsourcing solutions private limited',
    'Hero power private limited',
    'Research and development initiative private limited',
    'Iworld business solutions private limited',
    'Procyon business consulting private limited',
    'Jainico coatings private limited',
    'METHODEX SYSTEMS Private Limited',
    'Tyfort sales promotion pvt.ltd.',
    'Imtiara consultants private limited',
    'Rgl ecopak limited',
    'A t kearney india pvt ltd',
    'Integrated outsourcing solutions private limited',
    'Hr quest private limited',
    'D. a. technologies private limited',
    'SOLARMAN TECHNOLOGY PROJECT PRIVATE LIMITED',
    'Incognito worldwide india private limited',
    'Team india advisory limited',
    'Impetus hr consultants private limited',
    'Vvs consultants private limited',
    '3-arrows financial advisory private limited',
    'Infoprism solutions private limited',
    'Kuling technologies private limited',
    'Universal learn today private limited',
    'Evalueserve .com private limited',
    'Hindustan infrastructure construction corporation limited',
    'Mahindra knowledge park mohali limited',
    'Needles texwool (india) private limited',
    'Candela enterprises private limited',
    'Phooltas transmotives pvt ltd',
    'J.l. autoparts private limited',
    'SHIVA CARGO MOVERS PRIVATE LIMITED',
    'Kak infotech private limited',
    'Neon security agency private limited',
    'Indicure health tours private limited tfr. from maharashtra to delhi',
    'Asopalav plantations pvt ltd',
    'Sangam krishi private limited',
    'Bbm infra limited',
    'Gai chhap jarda private limited',
    'Badshaha jarda private limited',
    'Maharajganj agro industries pvt ltd',
    'Arihant farms private limited',
    'Pahuja takii seed limited',
    'Saya plantations and resorts private limited',
    'Globe agritech private limited',
    'Rejuve organics private limited',
    'Gopalan enterprises international private limited',
    'Intellectual farming private limited',
    'Bisalpur agriculture farm private limited',
    'Biyaban agri limited',
    'Kedarnath kisan agro producer company limited',
    'Enbee enterprises pvt ltd',
    'Kaisha realty private limited',
    'Ktc ltd',
    'Sumran agro private limited',
    'Baramati agro limited',
    'Shanthi fortune india private limited',
    'Adarsh bio agro ferticons private limited',
    'Utsav lehher agro foods private limited',
    'Wingreens farms private limited',
    'Earth-100 biofuels private limited',
    'Sagar bio tech private limited',
    'Overseas warehousing private limited',
    'Acme visa solutions private limited',
    'Sri akhs green lands private limited',
    'BELL CURVE STRATEGIC CONSULTANCY PRIVATE LIMITED',
    'J j agro finance pvt ltd',
    'Times global private limited',
    'MRIDA GREENS & DEVELOPMENT PRIVATE LIMITED',
    'V.n.r.farms private limited',
    'Grow rich agroforestry private limited',
    'SPHERE MINERAL RESOURCES PRIVATE LIMITED',
    'Premier evolvics private limited',
    'Kingsway projects private limited',
    'Vimla infrastructure (india) private limited',
    'Irc fishco private limited',
    'J.umashankar and company pvt. ltd.',
    'RAJESH CORPORATION PRIVATE LIMITED',
    'SAKET HOUSING PRIVATE LIMITED',
    'RELIANT DRILLING PRIVATE LIMITED',
    'Choudhary agencies pvt ltd',
    'VARELI TECHSOFT PRIVATE LIMITED',
    'Srap minerals private limited',
    'Sp armada oil exploration private limited',
    'Rsb developers private limited',
    'Superfine industrial gases private limited',
    'Jaya microminerals private limited',
    'Minexel mining and marketing private limited',
    'VISTARA NETWORK PRIVATE LIMITED',
    'Sagar ventures private limited',
    'J. t. agro foods private limited',
    'R. p. gourmet foods private limited',
    'Nyagatare agro ventures private limited',
    'Evox confectioneries private limited',
    'MONOPOLY INNOVATIONS PRIVATE LIMITED',
    'Nekkanti sugars private limited',
    'Champa impex private limited',
    'Jadli international foods limited',
    'Shivaji foods private limited',
    'G.s. consumer products private limited',
    'Shri saptashring oil mills private limited',
    'Gaurav vegpro private limited',
    'Graviss foods private limited',
    'Oswal exim trade ltd',
    'B g chitale dairies pvt ltd',
    'Dairy india private limited',
    'Primo foods private limited',
    'Shree mamta milkdairy private limited',
    'Roxy roller flour mills pvt ltd',
    'Bengani roller flour mills private limited',
    'Bhattad agri private limited',
    'Jaithra exim private limited',
    'Our food private limited',
    'Tripura wood products private limited',
    'Dadu food products private limited',
    'Ready roti india private limited',
    'K.l.f. brands private limited',
    'Himalayan hideaways private limited',
    'Desire foods private limited',
    'Continental coffee private limited',
    'Foremost friendly foods private limited',
    'Shah food processing private limited',
    'Ankit biscuits private limited',
    'Uni - coke private limited',
    'JOSSAN GRAINS PRIVATE LIMITED',
    'Shantikrupa foods private limited',
    'Paramount beverages private limited',
    'SRI VARSHA FOOD PRODUCTS INDIA PRIVATE LIMITED',
    'Suidihi distillery private limited',
    'Prestige autoworld private limited',
    'Sigma automotive materials private limited',
    'Shubh automotive accessories private limited',
    'Amvian automotive private limited',
    'Abhi automotives private limited',
    'Utopia solar solutions private limited',
    'S b electrotech services private limited',
    'Nhk f. krishna india automotive seating private limited',
    'Nutech office system private limited',
    'Bodyline international private limited',
    'FLOWCHEM ENGINEERING PRIVATE LIMITED',
    'Kasim textile mills private limited',
    'Zemoda technologies private limited',
    'Energy efficiency services limited',
    'Yamuna power and infrastructure limited',
    'Bombay gas company limited',
    'Bhagyanagar gas limited',
    'Poysha power projects private limited',
    'Poysha power generation private limited',
    'Espire infoserve private limited',
    'Samriddhi energy private limited',
    'NORMAN AQUA SOLUTIONS PRIVATE LIMITED',
    'Surindera cycles private limited',
    'P.i. softek limited',
    'Omaxe buildwell limited',
    'Singhal sintered private limited',
    'Sar gems and jewels private limited',
    'OMAXE REALTORS LIMITED',
    'Omaxe orissa developers limited',
    'Naman developers private limited',
    'High strength projects private limited',
    'Arcadia projects private limited',
    'Unitech buildwell private limited',
    'Divine developwell private limited',
    'Vishal gems and jewels private limited',
    'NACRE GARDENS HYDERABAD LIMITED',
    'Usetech buildwell private limited',
    'Prudent developers private limited',
    'Udaipur craft exports private limited',
    'Bairaj enterprises private limited',
    'Vedansh jewel private limited',
    'Essel jewels private limited',
    'Rebbon isosystems private limited',
    'Virmueller architects private limited',
    'Linc property developers limited',
    'Morksons pharmaceuticals (india) private limited',
    'Scorpio engineering private limited',
    'AJIT SOLAR PRIVATE LIMITED',
    'MISHIKA KRISHI UTPAD PRIVATE LIMITED',
    'Jairaj projects private limited',
    'Verandah retirement homes (india) limited',
    'H k warehousing (india) private limited',
    'Hanco property developers private limited',
    'Navketan industrial construction pvt ltd',
    'Falcon progressive ventures private limited',
    'Bhansali construction and finance private limited',
    'Fazlani exports private limited',
    'Kolland developers private limited',
    'Flooraise developers private limited',
    'Relationship properties private limited',
    'Orbit apartment construction private limited',
    'Deccan infrabuild private limited',
    'Rays power experts private limited',
    'Siva green energy india private limited',
    'Gee aar kaush energy private limited',
    'Clean energy resources private limited',
    'Nawanshahr power private limited',
    'Sagar powertex private limited',
    'Marco polo properties private limited',
    'Yule electrical limited',
    'Kashmir renewables energy private limited',
    'Chandradeep promoters and developers private limited',
    'Ruhi construction company limited',
    'Bhawna realters private limited',
    'Live-life buildcon private limited',
    'Bpb builders private limited',
    'Primrose developers private limited',
    'Sun nirman infrastructure private limited',
    'MIGSUN INFRAHOMES PRIVATE LIMITED',
    'Yg estates pvt ltd',
    'Kanta properties pvt. ltd.',
    'Sublime estates private limited',
    'Swastik motors india private limited',
    'Btm developers private limited',
    'Dream technobuild private limited',
    'Epa home private limited',
    'Vanya construction private limited',
    'Bmk infrastructure and developers private limited',
    'Randhawa infrastructure private limited',
    'Manipal energy & infratech limited',
    'Siva windturbine india private limited',
    'Elegant highrise private limited',
    'Green field niketan private limited',
    'Sunrays niketan private limited',
    'Blueorchid projects private limited.',
    'Jsr infrastructures private limited',
    'Pragati nirman private limited',
    'Alag buildwell private limited',
    'Hope realtors private limited',
    'Advantage housings private limited',
    'Grand reality private limited',
    'Real capital towers private limited',
    'Punjab project and construction pvt ltd',
    'Ess vee contractors private limited',
    'Swajan housing private limited',
    'Sar organizers private limited',
    'National builders infrastructures private limited',
    'Skymars technologies private limited',
    'United commercial and hotel enterprises private limited',
    'Solux telesolution private limited',
    'Auto mughals private limited',
    'Tuticorin sathya park & resorts private limited',
    'Ruchi agro cooling private limited',
    'Mobiltrain knowledge services private limited',
    'Sc communications and graphics private limited',
    'VERTEL DIGITAL PRIVATE LIMITED',
    'Intermedia cable communication private limited',
    'Gujarat state investment limited',
    'Tamilnad mercantile bank limited',
    'Infinity business solutions private limited',
    'Shree nursingsahay mudungopal private limited',
    'Destinations of the world (subcontinent) private limited',
    'Freedom aero services private limited',
    'Unitech vizag projects limited',
    'Sga financial resources private limited',
    'Tanmaya investments pvt ltd',
    'Abuzu holdings private limited',
    'First tours india pvt. ltd.',
    'Lotus destinations private limited',
    'Chartered leasing private limited',
    'Khandepar investments private limited',
    'Western india logistics company private limited',
    'Sai suraj leasing and finance private limited',
    'Amex leasing and finance limited',
    'Varuna offshore transport services private limited',
    'Park travels (india ) private limited',
    'Span tours and travels private limited',
    'Ivory finvest ltd',
    'SHAPOORJI PALLONJI FINANCE PRIVATE LIMITED',
    'Paras hire purchase company india ltd',
    'SHREE NAKODA GLOBAL PRIVATE LIMITED',
    'Antaral finance and investment private limited',
    'RAVLAK DESIGNERS LIMITED',
    'Eagle freight forwarders p ltd',
    'Napolitan travel agency company private limited',
    'Aye finance private limited',
    'Supreme facility management private limited',
    'CHOUDHARY YATRA COMPANY PRIVATE LIMITED',
    'GLOBAL JOURNEY TOURS & TRAVELS PRIVATE LIMITED',
    'Chemmanur credits and investments limited',
    'High seas logistics private limited',
    'Fadte marine services private limited',
    'Transafe freight systems private limited',
    'SURYALAY INVESTMENT AND TRADING COMPANY PRIVATE LIMITED',
    'DESHRAJ INVESTMENT AND TRADING COMPANY PRIVATE LIMITED',
    'Bengal shapoorji housing development private limited',
    'Hosanna investments private limited',
    'Advanced leasing and finance private limited',
    'Neco holdings private limited',
    'Blackhill investments private limited',
    'Vaitarna investments pvt ltd',
    'NAVI TRUSTEE LIMITED',
    'NAVI AMC LIMITED',
    'Riviera logistics private limited',
    'Alpha clearing and forwarding agencies private limited',
    'Gng logistics private limited',
    'Shresht corporate advisors private limited',
    'Subhadra local area bank limited',
    'Credit sudhaar finance private limited',
    'Parikamma investments pvt ltd',
    'Shreenath commercial and financial pvt ltd',
    'Stonescape holdings private limited',
    'Rsb metaltech private limited',
    'Aditya resources limited',
    'AMBARELLA CAP FIN PRIVATE LIMITED',
    'SARALA DEVELOPMENT & MICROFINANCE PRIVATE LIMITED',
    'Kandoi finance pvt ltd',
    'SPRAY & SAVE PVT LTD',
    'Harissgunj investments pvt ltd',
    'Sarau holdings pvt ltd',
    'Sekhavati leasing pvt ltd',
    'Mallcom holdings pvt ltd',
    'Gmr airports limited',
    'Sustainable agro-commercial finance limited',
    'Kay ess hire purchase private limited',
    'VALGAA FINANCIAL SERVICES LIMITED',
    'Magnolia properties pvt ltd',
    'Bora housing & finance limited',
    'AVANTHA CONSULTING SERVICES LIMITED',
    'Cl holdings private limited',
    'Damani finvest private limited',
    'Ivory holdings limited',
    'Megha finance private limited',
    'Raj shipping agencies limited',
    'Dharma sastha printing and publishing co pvt ltd',
    'Leela trade-link private limited',
    'The nellai finance private limited',
    'Francis shipping agency private limited',
    'Mnp interconnection telecom solutions india private limited',
    'Asc consulting private limited',
    'TALENTEX SERVICES PRIVATE LIMITED',
    'Ambi investments & finance private limited',
    'Sulaxmi finance private limited',
    'D.p.b. holdings private limited',
    'Global jindal fin-invest limited',
    'MELVILLIE FINVEST LIMITED',
    'Jay amal investment private limited',
    'Kalpathi investments private limited',
    'Venture investments private limited',
    'Aspire investments pvt. ltd.',
    'Bagaria finance ltd',
    'Satya finance pvt. ltd.',
    'Avs ventures private limited',
    'Roman securities private limited',
    'Kamal apartments private ltd.',
    'Right guard rubber private ltd.',
    'Sarr freights limited',
    'Venus agro products pvt ltd',
    'Sigma bros motor car company private limited',
    'Sopan overseas private limited',
    'Rohit services private ltd',
    'Appolo computers private limited',
    'Right guard rollers and castors private limited',
    'Malhotra electronics private ltd',
    'Sun tours private ltd.',
    'Srk mining services (india) private limited',
    'Rpl forests private ltd',
    'Thoms marketing private ltd',
    'Stic travels private ltd',
    'Ahc infotek private limited',
    'Connect cousultants (india) private limited',
    'K k farms private limited',
    'ZOBOTEX GARMENTS PRIVATE LIMITED',
    'Saurabh exports private limited',
    'M p portfolio private limited',
    'G s promoters pvt ltd',
    'Bikanervala foods private limited',
    'Northern consultants private ltd.',
    'Lancer exports private limited',
    'Space heating and cooling private limited',
    'Vibgyor international private limited',
    'Parkash monomers private limited',
    'Beyondbasiks infotech private limited',
    'Kamal colonisers pvt ltd',
    'Kamal international private limited',
    'Neptune systems pvt. ltd.',
    'Flash electronics (india) private limited',
    'Expeditions tours private limited',
    'TECHNICAL ASSOCIATES INDUSTRIES LIMITED',
    'I.C.I PROJECTS (INDIA) PRIVATE LIMITED',
    'Ellenbarrie projects private limited',
    'Shree forwarding and clearing agents private limited',
    'Shatabdi chemicals private limited',
    'Kvm consulting private limited',
    'Ginni energy private limited',
    'WATTMART ENERGY STORES PRIVATE LIMITED',
    'Atf infrastructure private limited',
    'Garg electronics private limited',
    'Scientific international private limited',
    'Kamal continental private limited',
    'Bcl realcon private limited',
    'Modipur devices private limited',
    'Principle investment advisory private limited',
    'Umang business consultant private limited',
    'Techfour engineering solutions private limited',
    'Enereff engineers private limited',
    'Firetronics (india) private limited',
    'Shree bhikshu components private limited',
    'Sokari india private limited',
    'India power partners private limited',
    'Shrutee exports private limited',
    'Hpl mercantile private limited',
    'Lokesh polymers private limited',
    'Sai media ventures private limited',
    'AII NIISH FASHIONS PRIVATE LIMITED',
    'Gold coin maritronics private limited',
    'MICROMATIC GRINDING TECHNOLOGIES PRIVATE LIMITED',
    'Bright and shine micro products private limited',
    'Adcon instruments private limited',
    'Cheviot international limited',
    'Panther overseas pvt ltd',
    'A.r.alloys private limited',
    'Koniva tours and travels private limited',
    'K.m. properties private limited',
    'Speedex overseas private limited',
    'Bnb investment and properties limited',
    'Atul paper pvt. ltd.',
    'Passion studio-g private limited',
    'Genesis infosoft private limited',
    'Nirman engineering cosultants pvt ltd',
    'Xperience films private limited',
    'Tnm media private limited',
    'Indigenous professionals help line private limited',
    'Choicest media private limited',
    'UNIQUE-OUTDOOR ADVERTISING & MARKETING PRIVATE LIMITED',
    'Clips communications private limited',
    'Sunrays overseas private limited',
    'Manmachine works private limited',
    'Nuclotec remedies private limited',
    'S. MEHTA PROPERITES PRIVATE LIMITED',
    'Mj global private limited',
    'URBTECH FINVEST PRIVATE LIMITED',
    'Parasnath electronics private limited',
    'MASTER CONTROL INDIA PRIVATE LIMITED',
    'Prakash colours private limited',
    'Manog securities private limited',
    'Jmd digital art xchange private limited',
    'Indeera builders private limited',
    'J m d buildwell private limited',
    'Vinman buildwell private limited',
    'Ideal breweries private limited',
    'Shivom filaments private limited',
    'Png holdings private limited',
    'DREAMZ INTERNATIONAL PRIVATE LIMITED',
    'Hi-tech accurate communication private limited',
    'World phone infrastructure services private limited',
    'Sonam regency inn private limited',
    'Manorites capital management private limited',
    'World phone internet services private limited',
    'TRIDENT TECHLABS LIMITED',
    'Hpl investments limited',
    'AUREUS FINANCIAL SERVICES LIMITED',
    'AVANT GARDE CARPETS PRIVATE LIMITED',
    'Spinks india private limited',
    'Shinco overseas private limited',
    'Patwari exports pvt ltd',
    'PASSPORT JEANS PRIVATE LIMITED',
    'Ganpat lal pawan kumar traders private limited',
    'BLUE WAVE CLOTHING PRIVATE LIMITED',
    'Vogue international agencies private limited',
    'Siddhi vinayak knots & prints private limited',
    'Microstitch fashions private limited',
    'Hpa apparel private limited',
    'Hpa garments private limited',
    'Kishco enterprises private limited',
    'Mahotsav creation private limited',
    'Readywear casuals private limited',
    'Amit polychrome pvt ltd',
    'SHIRRIN DESIGN CO PRIVATE LIMITED',
    'Solar processors (bhilwara) ltd',
    'BAAZAR STYLE RETAIL LIMITED',
    'Ishwarya azoics limited',
    'KILOL FABRICS PRIVATE LIMITED (TRANSFERRED FROM M.P.)',
    'Exodus knitwear pvt ltd',
    'Padmash leathers and exports private limited',
    'Kanoria udyog limited',
    'Super skin craft private limited',
    'Aark digital private limited',
    'North india leather products cluster private limited',
    'Oasis leathers private limited',
    'S k leather bags private limited',
    'Nagreeka integrated textile park private limited',
    'D.c footwear private limited',
    'Jai ganesh enterprises private limited',
    'Barnet india private limited',
    'Vogue fabtex private limited',
    'Faiz tanning company private limited',
    'Hitaishi fine kraft industries pvt ltd',
    'Euro design private limited',
    'Organic apparels private limited',
    'Ahp apparel private limited',
    'Jainendra industries private limited',
    'Fabulous threads private limited',
    'Shiva pulp and paper private limited',
    'GENUS MOBILITY SOLUTIONS LIMITED',
    'Jupiter paper trading company private limited',
    'Manorama paper mills limited',
    'Shree shyam coatings limited',
    'Naseeb fashions clothing private limited',
    'Wecan services . com limited',
    'Jalan printpack private limited',
    'Akar corrugators private limited',
    'F t textiles private limited',
    'SAARTHAK VANIJYA INDIA PRIVATE LIMITED',
    'U. k. paper converters private limited',
    'Care pack pvt ltd',
    'Hi-style india private limited',
    'Beautiful garments private limited',
    'Jaipur rugs company private limited',
    'Vineetaz exports pvt ltd',
    'Rishi fabrics limited',
    'Akv textiles limited',
    'Diamond magazines private limited',
    'CHHAYA PRAKASHANI LIMITED',
    'Ganuchi fashions private limited',
    'Diadora shoes private limited',
    'Shivalik teak land private limited',
    'M.k. wood india private limited.',
    'Green grove agro industries private limited',
    'Sai press (india) pvt ltd',
    'Jetroll private limited',
    'Mahesh industries private limited',
    'Manipal utility packaging solutions private limited',
    'Cosmic fashions private limited',
    'Modindia exim private limited',
    'Ahp garments private limited',
    'Unix clothing private limited',
    'Madreel films private limited',
    'Saurashtra exim private limited c/n',
    'Hebe sports lifestyle private limited',
    'IRIS CLOTHINGS LIMITED',
    'Familia fashion ventures private limited',
    'French trendz private limited',
    'Unico retail private limited',
    'Crystal hues limited',
    'Grace castings ltd',
    'Jay ace technologies limited',
    'Fountainhead solutions private limited',
    'R.r. sheth & co. private limited',
    'Artfirst enterprises private limited',
    'Agarwal containers private limited',
    'NEOGRAFIKS (INDIA) PRIVATE LIMITED',
    'Ankush publications private limited',
    'Shravya publications private limited',
    'Heetu chemicals and alkalies limited',
    'Delta finochem private limited',
    'DINDAYAL COLLOIDS PRIVATE LIMITED',
    'Ellora printers private limited',
    'Ram advertising limited',
    'IPG ASIA PRIVATE LIMITED',
    'Crystal quinone pvt ltd',
    'Kohinoor colours pvt ltd',
    'Zephyr synthesis pvt ltd',
    'Spectrochem pvt ltd',
    'Makrupa chemicals pvt limited',
    'TECHNOFORCE SOLUTIONS (I) PRIVATE LIMITED',
    'C j s specialty chemicals private limited',
    'Asian paints ppg private limited',
    'Chemical and metallurgical design company limited',
    'The financial times (india) private limited',
    'Ajay organics pvt ltd',
    'Fourth dimension media solutions private limited',
    'FINE ORGANIC INDUSTRIES LIMITED',
    'City shoppe estates limited',
    'A.r. stanchem pvt. ltd.',
    'Se-ka-ra organics private limited',
    'P s tower private limited',
    'Door king shelter private limited',
    'Building blocks private limited',
    'Growmore contractors and buildwell private limited',
    'Greyhound engineers india private limited',
    'Alferez private limited',
    'SYNERGEN PROJECTS PRIVATE LIMITED',
    'Atam associates private limited',
    'Anirudh properties private limited',
    'Rahazone property developers private limited',
    'Alpine environmental engineers limited',
    'Warden infra projects private limited',
    'Bhargava estates private limited',
    'Clover housing developments private limited',
    'Niskarsh properties private limited',
    'Opus international india private limited',
    'Ishaan hi-tech projects india private limited',
    'Mathias construction private limited',
    'Kapurwala properties pvt ltd',
    'Vinayak buildhome private limited',
    'Trimurty colonizers and builders india private limited',
    'Nikon engg private limited',
    'Sai vignesh properties private limited',
    'ASOKSONS CONSULTING PRIVATE LIMITED',
    'Oceana heights private limited',
    'CEREBROS NEUROSCIENCES PRIVATE LIMITED',
    'Madeka properties private limited',
    'Goldiam realhome private limited',
    'Goldendunes colonizers private limited',
    'Goldendunes constructions private limited',
    'Goldendunes realestate private limited',
    'VINAYAK MAHIMA COLONIZERS PRIVATE LIMITED',
    'Jaipur green homes private limited',
    'Amit dream homes private limited',
    'Rudra infradevelopers private limited',
    'THE OASIS PRIME PROJECTS (INDIA) PRIVATE LIMITED',
    'Noel construction company private limited',
    'Ishaan infraestates india private limited',
    'Baruni properties private limited',
    'Nyati builders private limited',
    'Tenatra chemie private limited',
    'ETERNAL AMNV FOUNDATION',
    'J m mhatre infra private limited',
    'Swarna sakha estates and builders private limited',
    'Sapphire promoters and developers private limited.',
    'Navjeevan buildestate private limited',
    'Moonlite global private limited',
    'Alta vista estate private limited',
    'Silicon valley promoters private limited',
    'Terminal developers private limited',
    'Suncity landcon private limited',
    'Unique lifestyle homes private limited',
    'Sunland housing private limited',
    'Flores properties limited',
    'Ha infrastructure private limited',
    'Girnar infrastructures private limited',
    'Ramprastha punj lloyd developers private limited',
    'Macknight infrastructure private limited',
    'MAHINDRA BLOOMDALE DEVELOPERS LIMITED',
    'Industrial township (maharashtra) limited',
    'Ajmera realty ventures private limited',
    'Rkd construction private limited',
    'Pariya developers private limited',
    'EMBASSY MAVERICK MALLS PRIVATE LIMITED',
    'Global infrastructure services and solutions (t.n.) private limited',
    'Sarang infrastructure limited',
    'Saahi infratech india private limited',
    'Khivraj tech park private limited',
    'Gilt properties pvt ltd.',
    'I-nova real estate limited',
    'Maangalya estates private limited',
    'Ulundurpet expressways private limited',
    'Eila properties private limited',
    'Konar developers private limited',
    'Clover projects private limited',
    'Manas realtors private limited',
    'Erica projects private limited',
    'Cordia projects private limited',
    'Devon builders private limited',
    'Minda realty & infrastructure limited',
    'Mandarin developers private limited',
    'Robinia developers private limited',
    'Millennium propcon private limited',
    'Kerria projects private limited',
    'Purus projects private limited',
    'Jagat buildtech private limited',
    'Ascent developwell private limited',
    'Third wave building technologies private limited',
    'Panchvati builders pvt ltd',
    'Ss buildworth private limited',
    'Sparsh infratech private limited',
    'Sgk projects private limited',
    'Brahma projects private limited',
    'G tech rebar technology private limited',
    'Snp infratech private limited',
    'Aspirations and dreams infrastructure private limited',
    'V s technobuild private limited',
    'Savy ville de project services private limited',
    'Ascent basera private limited',
    'Sewak infradevelopers private limited',
    'Rohan rajdeep infra projects limited',
    'Cape developers private limited',
    'ADVIK RENEWABLE ENERGY PRIVATE LIMITED',
    'Martin infra ventures private limited',
    'LKP WEALTH ADVISORY LIMITED',
    'Shere punjab forex private limited',
    'Finmart investments (india) private limited finmart',
    'Kamal kumar jalan securities private limited',
    'Yes capital (india) private limited',
    'Crag martin financial solutions private limited',
    'Pragati holdings pvt ltd',
    'Grandiose holdings co pvt ltd',
    'Rainbow holding and trading pvt ltd',
    'B j holdings private limited',
    'Cashco holdings private limited',
    'J.N.M. REALTY AND MARKETING LIMITED',
    'Anuja property developers private limited',
    'Vanhim finance and holdings private limited',
    'S b r constructions pvt ltd',
    'Prime estates pvt ltd',
    'Pukhraj capital and share broking private limited',
    'Unitech colossal projects private limited',
    'Halley projects private limited',
    'G s buildtech private limited',
    'Sefw projects private limited',
    'Indiv (india) pvt ltd',
    'Kb capital markets pvt ltd',
    'Prithvi infraprojects private limited',
    'DAMASK TEXTILES PRIVATE LIMITED',
    'ARTIMAS FASHIONS PRIVATE LIMITED',
    'Huts and houses private limited',
    'Creative holdings pvt ltd',
    'COSMOS INFRA ENGINEERING (INDIA) PRIVATELIMITED',
    'Msh properties private limited',
    'S.m.b. holdings private limited',
    'Pebbles infradevelopers private limited',
    'Samarjit investments private limited',
    'Panatone finvest limited',
    'Tinsula investments private limited',
    'P and a estates private limited',
    'H L BUILDWELL PRIVATE LIMITED',
    'Mahoba builders limited',
    'Bianca investments private limited',
    'Thakker money multipliers pvt ltd',
    'SAHYOG TAX & FINANCE ADVISORY LIMITED',
    'JLT INDEPENDENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'Graviss brands private limited',
    'Rashi equisearch private limited',
    'Uniglobe economic park private limited',
    'Zycon properties private limited',
    'Unirock enclavers private limited',
    'R1 habitats india private limited',
    'Sarnath realtors limited.',
    'Townmaster promoters and developers private limited',
    'Jkm human resources private limited',
    'Akshay buildprop private limited',
    'Duroflex apartments private limited',
    'Gerbera properties private limited',
    'Aklima properties private limited',
    'Idika properties private limited',
    'Amartya properties private limited',
    'Topmost realtors private limited',
    'Kakad realty private limited',
    'Kirti properties private limited',
    'GIANNA AGRO PRIVATE LIMITED',
    'Vighnaharta properties private limited',
    'Vastu siddhi promoters and developers private limited',
    'J.r. doda estates private limited',
    'Zip realty private limited',
    'Divine buildearth private limited',
    'Dhairya properties private limited',
    'ZEZTATE PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Satyavani homes private limited',
    'Rams property developers & investments private limited',
    'Fortis properties private limited',
    'Jayaswathy constructions private limited',
    'Sumel buildtech private limited',
    'Sumel developers private limited',
    'Subhasree estates private limited',
    'Buildwell promoters p. ltd.',
    'Harit properties pvt. ltd.',
    'EXPERION STUDENT HOUSING PRIVATE LIMITED',
    'Radhe krishna real infra private limited',
    'Mgm pushpam chits private limited',
    'Vardhan real estates private limited',
    'Iguazu real estate private limited',
    'Ahp properties private limited',
    'Belani housing development limited',
    'Limelight towers private limited',
    'Bishopsgate services private limited',
    'BRICK & MORTAR REALTY PRIVATE LIMITED',
    'Pink city heights private limited',
    'Kumar infraprojects private limited',
    'Greenland township private limited',
    'San buildwell private limited',
    'Shanti niwas infrastructure private limited',
    'Sawhney textilels private limited',
    'Hind air link private limited',
    'Shri parasram estates private limited',
    'Libintia real estate private limited',
    'Magnolia estates private limited',
    'Abm buildinfra private limited',
    'Mother villas private limited',
    'Deluris buildtech india private limited',
    'Shakuntalam creations private limited',
    'Mj realtech private limited',
    'Madison builders private limited',
    'Great home developers private limited',
    'Techarnav infra private limited',
    'Alps infratech private limited',
    'Orion infrarealtors private limited',
    'Win power infra private limited',
    'Unitech hotels private limited',
    'TOUCHSTONE GEMS & JEWELLERY (INDIA) PRIVATE LIMITED',
    'Neel metal products limited',
    'Rmg polyvinyl india limited',
    'Goodwear fashions private limited',
    'Pioneer fincap private limited',
    'A.l. enterprises private limited',
    'Subhuti life styles pvt ltd',
    'Yoga laxmi living arts pvt ltd',
    'Softage information technology ltd.',
    'Supermac industries (india) limited',
    'Iffco-tokio general insurance company limited',
    'Presto info solutions private limited',
    'Unger india private limited',
    'Consortium hi-tech private limited',
    'Datavision systems private limited',
    'Piezo technology india private limited',
    'D k finvest private limited',
    'Trans yamuna communication network private limited',
    'Prasha technologies limited',
    'Mithun securities private limited',
    'Apace rent a car private limited',
    'Holiday links private limited',
    'Vidur and company private limited',
    'Zaw outsourcing solutions private limited',
    'Libra high quality advisors & consultants private limited',
    'Kundli spinners private limited',
    'DISHA INDUSTRIES Private Limited',
    'Rsv capital services private limited',
    'Goshiv hospitality private limited',
    'Stanford life sciences private limited',
    'S p refrigeration and food products private limited',
    'Aavas software private limited',
    'Elevare training ventures private limited',
    'Aecs engineering & geotechnical services private limited',
    'Mansfield impex private limited',
    'Pro ideas integrated marketing private limited',
    'Ashoka finsec private limited',
    'Poly glass fibre industries private limited',
    'Gms services private limited',
    'Superb enterprises private limited',
    'Software dioxide private limited',
    'Cinestaan entertainment private limited',
    'Umbrella aegis private limited',
    'Novus insights private limited',
    'Action capital private limited',
    'Digitex medical systems private limited',
    'Malik finvest private limited',
    'Jay vee textiles private limited',
    'Hind fincap private limited',
    'Young street capital services private limited',
    'Rubicon stampings private limited',
    'Alba smart automation private limited',
    'Virtue green energy private limited',
    'Canyam constructions private limited',
    'Purevolt products private limited',
    'Mare software devlopment private limited',
    'Espire infrastructure private limited',
    'Ikkavala consultancy services private limited',
    'Save solutions private limited',
    'Sahyog development services',
    'Providence solutions private limited',
    'Osp consulting india private limited',
    'Wissen research private limited',
    'Visitbritain services india private limited',
    'Dreeshti aircon private limited',
    'Mrida renergy & development private limited',
    'Divya restaurants and hotels private limited',
    'Psp packaging private limited',
    'Charu crafts center private limited',
    'Legal talent management private limited',
    'LA SCENTEUR FRAGRANCE TECHNOLOGIES PRIVATE LIMITED',
    'Kos ben laboratories private limited',
    'Arka britton services private limited',
    'Electronica automations private limited',
    'CREATIVE INSOLVENCY RESOLUTION PROFESSIONALS PRIVATE LIMITED',
    'GREENVALE CAPITAL LIMITED',
    'Kadamba projects private limited',
    'Treknocom engineering private limited',
    'Suzlon foundation',
    'Gowrie healthcare private limited',
    'Skymap global (india) private limited',
    'TEJAYS DYNAMIC LIMITED',
    'D ULTIMATE BUILDEARTH PRIVATE LIMITED',
    'Vishwamber cements limited',
    'Aero composites solutions private limited',
    'PALFINGER INDIA PRIVATE LIMITED',
    'Dellner (india) private limited',
    'Universal relocations india private limited',
    'Optilan (india) private limited',
    'Freeelective network private limited',
    'Kals breweries private limited',
    'Dynamic agri & foodbiz consultants private limited',
    'Shivani a2z solutions private limited',
    'Accurex marketing and consulting private limited',
    'FOURTHFORCE SURVEILLANCE INDO PRIVATE LIMITED',
    'Btm investments private limited',
    'Avini advisors private limited',
    'Evon technologies private limited',
    'Infinity realcon limited',
    'Radhey shyam securities private limited',
    'Editfx studios private limited',
    'Indiana international corporation flooring private limited',
    'Rezorce managed solutions private limited',
    'Orion associates private limited',
    'Poweron technologies private limited',
    'B d s diamond enterprises private limited',
    'Pacomatic packers private limited',
    'Carter containers company pvt ltd',
    'Pacard (manufacturing) pvt ltd',
    'Aggarwal corrugators india private limited',
    'Ideas visible india private limited',
    'Shrirang prakashan private limited',
    'Sterling publishers pvt ltd',
    'Pralayankar publications private limited',
    'Prachi india private limited',
    'Arrow head media private limited',
    'Infinity publications and media international private limited',
    'Courier publications private limited',
    'Vasan publications private limited',
    'EARTH SENSE PROPERTIES PRIVATE LIMITED',
    'Nav jyothi publications private limited',
    'Bbsm films private limited',
    'Narielwala synythetics private limited',
    'Silicon fabrics private limited',
    'J b marzban and co pvt ltd',
    'I-tech media private limited',
    'Printers alliance private limited',
    'International print-o-pac limited',
    'Ronak cotton private limited',
    'Fashion factory (international) private limited',
    'Paradigm designs limited',
    'Krea designs private limited',
    'SAN MEDIA PRIVATE LIMITED',
    'MOHAMAD IDRIS BROS SONS FABRIC PRIVATE LIMITED',
    'Glamour creations private limited',
    'Jogur apparel and clothing private limited',
    'MARKET NINETY NINE PRIVATE LIMITED',
    'Hyper space music private limited',
    'Inspire media works private limited',
    'Tritan leather works private limited',
    'Contec impex private limited',
    'Haldia minerals limited',
    'Wellman carbo metalicks india limited',
    'Hemkunt petroleum limited',
    'Sarvesh exports private limited',
    'Signa medi solutions private limited',
    'Hpl innovation private limited',
    'New leather belts company india private limited',
    'Perfect resins & polymers (india) private limited',
    'Gheli international private limited',
    'South east footwear private limited',
    'PC COTTON AND OIL MILL PRIVATE LIMITED',
    'Taurus timber private limited',
    'Supreme shutters private limited',
    'Sicpa india private limited',
    'Take-my-word media strategies private limited',
    'Multi shaper (india) pvt ltd',
    'Print shop engineers (india) private limited',
    'Supreme borochem private limited',
    'Rashi rasayan private limited',
    'Kosmochem private limited',
    'Sorbo monni chemicals private limited',
    'Hue kem chemicals p ltd',
    'Suhans chemicals private limited',
    'Western chemical industries private limited',
    'V.v.titanium pigments private limited',
    'Okhla chemicals limited',
    'Msc crewing services private limited',
    'J v s logistics private limited',
    'Index transport private limited',
    'Kites travel private limited',
    'SIMONS LOGISTICS PRIVATE LIMITED',
    'Ninety nine travels private limited',
    'Kales airline services india private limited',
    'Jfs freight services private limited',
    'Arya logistics private limited',
    'Continental inter link private limited',
    'Seagull logistik private limited',
    'Bharat logistic solutions private limited',
    'Cogent connect private limited',
    'Vy systems private limited',
    'Cyber security works private limited',
    'Neemtec solutions private limited',
    'Formative software solutions private limited',
    'Alpharithm technologies private limited',
    'Nesh technologies private limited',
    'Ss information systems private limited',
    'Texellation software private limited',
    'Ezypay online services private limited',
    'Karni soft solutions private limited',
    'Analytique research private limited',
    'Reametrix india private limited',
    'Anarghya innovations and technology private limited',
    'Anchrom test lab private limited',
    'NSE INDICES LIMITED',
    'Ajay bio-tech (india) limited',
    'Atri pharma research (india) private limited',
    'Ephicacy lifescience analytics private limited',
    'Athiya organizational competencies private limited',
    'Mad street den systems private limited',
    'Hr consultants private limited',
    'SEATRACK TRADEX & SHIPPING PRIVATE LIMITED',
    'Seabuck ayurveda private limited',
    'Jgarg economic advisors private limited',
    'Axon outsourcing private limited',
    'Qx corporate advisors india private limited',
    'K & z facilities management private limited',
    'Kaspar capital advisory services private limited',
    'Kanwal industries private limited',
    'Easy accountants private limited',
    'Sterling pest control services private limited',
    'Foxymoron media solutions private limited',
    'Vistaas mobility private limited',
    'Zephyr financial publishers private limited',
    'American plastics engineering corporation limited',
    'Institute of supply chain and management private limited',
    'Piramal retail private limited',
    'Ndk mozaic medical private limited',
    'AURA OVERSEAS PRIVATE LIMITED',
    'DOIT URBAN VENTURES (INDIA) PRIVATE LIMITED',
    'Basar holdings private limited',
    'Lekhraj corp private limited',
    'Credence interactive services private limited',
    'Merc logistics (india) private limited',
    'EDUC-ASIA TRAINING & CONSULTANCY PRIVATE LIMITED',
    'Sumo arena private limited',
    'Pec solutions green designs private limited',
    'Reuben industries private limited',
    'Piramal e-shopping private limited',
    'Vopak india private limited',
    'Mergermarket (india) private limited',
    'Allied project services private limited',
    'Simplus information services private limited',
    'Janoschka graphic services india private limited',
    'Medicounts lifesciences private limited',
    'Bow chicka wow wow films private limited',
    'Mercantile advertising private limited',
    'Keystone lifespaces capital holding private limited',
    'Orca management consulting & services private limited',
    'Maksel engineers private limited',
    'I choice retail private limited',
    'BASTIAN ADVISORY SERVICES PRIVATE LIMITED',
    'ARRDY ENGINEERING INNOVATIONS PRIVATE LIMITED',
    'Preside engineering services private limited',
    'Genext advisory private limited',
    'Bharti (rm) resources private limited',
    'Bharti (rbm) services private limited',
    'Bharti (rm) services private limited',
    'Bharti (sbm) resources private limited',
    'YAMADA CONSULTING SPIRE INDIA PRIVATE LIMITED',
    'Vdoit4u event management private limited',
    'Hinsui international private limited',
    'Vinci concessions india private limited',
    'ACT1 AGILE1 INDIA PRIVATE LIMITED',
    'VPGCO PRIVATE LIMITED',
    'Xplosiv events & promotions private limited',
    'Uretouch photos private limited',
    'CREDOLA SOLUTIONS PRIVATE LIMITED',
    'Hetuh consultancy private limited',
    'Comtechrim india private limited',
    'Breakthru consulting private limited',
    'Jsn freight solutions private limited',
    'Kardo design private limited',
    'Clarico financial & advisory services private limited',
    'Indic connect private limited',
    'Sunenergy infrastructure private limited',
    'Statworld research solutions private limited',
    'Dorin india private limited',
    'Shalini tradewell india private limited',
    'Semantics trans private limited',
    'Goforth adventures private limited',
    'Raman development consultants private limited',
    'Navkar consultancy pvt ltd',
    'EASY GOODS SERVICE TAX ONLINE DOT COM PRIVATE LIMITED',
    'Ajmera corporate services private limited',
    'Stemmons business services private limited',
    'Login infocom private limited',
    'Panash consultancy private limited',
    'B.n. rathi securities limited',
    'Anima investments limited',
    'Ajel limited',
    'SASKEN TECHNOLOGIES LIMITED',
    'Oracle financial services software limited',
    'BIRLASOFT LIMITED',
    'Goldstone technologies limited',
    'Vaishnavi gold limited',
    'Bharti airtel limited',
    'Bal pharma limited',
    'DR. AGARWAL',
    'S ASYLUM INNOVATION PRIVATE LIMITED',
    'Jmd consultants private limited',
    'Darrick insecticides limited',
    'INTEGRAL COMPUTER PRIVATE LIMITED',
    'Associated appliances limited',
    'Bikaner assam roadlines india limited',
    'Benlon india limited',
    'Spearhead communications pvt ltd',
    'Vinyl tubes private ltd',
    'Dominant web private limited',
    'Misha textiles private limited',
    'ALACRITY EXPORTS PRIVATE LIMITED',
    'Assam state weaving and mfging co ltd',
    'Manish silk fab pvt ltd',
    'Apexx texpro private limited',
    'Sneh fabrics pvt ltd',
    'IR EXPORTS PRIVATE LIMITED',
    'Venus garments (india) limited',
    'P g o processors private limited',
    'CARTIGO PRIVATE LIMITED',
    'Firemount textiles india limited',
    'P a r k non-woven private limited',
    'Harshad estate enterprise private limited',
    'K.a.s. shoes private limited',
    'Itares shoes private limited',
    'VAISHALI SILK MILLS PRIVATE LIMITED',
    'Kumar concern private limited',
    'Sun interiowoods private limited',
    'Ha fashions private limited',
    'C.r. clothing private limited.',
    'Conoron creations private limited',
    'N d clothing private limited',
    'Ekta industrial products private limited',
    'Bharat papers limited',
    'Aparna paper processing industry pvt ltd',
    'Ssd print graphics private limited',
    'Sharp hometex private limited',
    'Essay corporation private limited',
    'Sakk collections limited',
    'Manglam arts private limited',
    'Associated publishers (madras) private limited',
    'MALAR PUBLICATIONS LIMITED',
    'Trail blazer media private limited',
    'Sp guide publications private limited',
    'R.k.brothers private limited',
    'NEELKANTH PUBLISHERS PRIVATE LIMITED',
    'Diamond world india private limited',
    'Indigo publishing private limited',
    'DIVINE SPARKS HOSPITALITY PRIVATE LIMITED',
    'Shiny knitwear private limited',
    'Ice fire clothing company private limited',
    'Sunbeam films private limited',
    'MARVEL DECOR LIMITED',
    'KEJRIWAL INDUSTRIES PRIVATE LIMITED',
    'Blue jay texowad private limited',
    'Marc signage private limited',
    'Shyam sundar satyanarayan textiles private limited',
    'Sterling graphics private limited',
    'ARTHMATE FINANCING INDIA PRIVATE LIMITED',
    'Irrh specialty chemicals india limited',
    'Sujal dyechem private limited',
    'Heranba agro science limited',
    'B s s apparels private limited',
    'Elppe chemicals private limited',
    'Omega-kemix private limited',
    'Lrc speciality chemicals private limited',
    'Jcu chemicals india private limited',
    'Asv multichemie private limited',
    'Shashi techno pack private limited',
    'Chemtex speciality limited',
    'Cs specialty chemicals private limited',
    'Rudolf atul chemicals limited',
    'Tikitar industries (india) limited',
    'PRS CARRIAGE TECHNOLOGIES PRIVATE LIMITED',
    'Industrial solvents and chemicals private limited',
    'Pcp chemicals private limited',
    'Chinar chemicals private limited',
    'Kairav chemo farbe industries limited',
    'Durvesh rasayan private limited',
    'Fermi chemicals pvt ltd',
    'Shah products limited',
    'Prima private limited',
    'Vis viva packaging private limited',
    'Rushvi finechem private limited',
    'Bidhata industries private limited',
    'Gemag chemicals private limited',
    'Nassolkem private limited',
    'SBS RECYCLING PRIVATE LIMITED',
    'Magnum books private limited',
    'Heralds marketing ltd',
    'Niharika paints & chemicals pvt ltd',
    'Hindcon chemicals limited',
    'Reino industrial organics private limited',
    'Nv organics private limited',
    'TRUBOND INDUSTRIES PRIVATE LIMITED',
    'Micro life sciences private limited',
    'Jai bharat gum and chemicals ltd',
    'Swastik industrial gases p ltd',
    'Northman chemical company private limited',
    'Fine intermediates private limited',
    'Cetex petrochemicals limited',
    'Gcs chemicals pvt. ltd.',
    'Szymotech biosolutions private limited',
    'Sai fertilizers & phosphates private limited',
    'MICNELF MICRONUTRIENTS PRIVATE LIMITED',
    'Variable print solution technologies private limited',
    'Skoch media private limited',
    'Cyber managers software services private limited',
    'Kumar printers pvt ltd',
    'Advanced laser systtems limited',
    'MIND & MATTER MARKETING SOLUTIONS PRIVATE LIMITED',
    'H.m. graphics private limited',
    'Shishir finstock private limited',
    'Voxco pigments and chemicals private limited',
    'Shyam oxides private limited',
    'Renhart health products private limited',
    'Simzen pharmachem private limited',
    'Yashram lifestyle brands private limited',
    'Toyochem pharma (bombay) private limited',
    'Tecnicas reunidas engineers india private limited',
    'Dsp infraventures private limited',
    'Navjyoti infradevelopers private limited',
    'Navlok infradevelopers private limited',
    'Siddhi vinayak premium homes private limited',
    'Matouria builders private limited',
    'Laroc buildestates private limited',
    'Make home realty and construction private limited',
    'Devine realty and construction private limited',
    'Gallops developers private limited',
    'Simplex prefab infrastructure ( india ) private limited',
    'JAYKALI DEVELOPERS PRIVATE LIMITED',
    'Sumedha estates private limited',
    'Aradhana apartments ltd',
    'Ashoka farms ltd',
    'Yatish builders pvt ltd',
    'Siddha real estate development pvt ltd',
    'Devbhoomi awas limited',
    'Apollo inffratech private limited',
    'Songadh infrastructure & housing limited',
    'O.p.builders and hotels pvt ltd',
    'Bassiwala builders private limited',
    'Aishwarya complex pvt ltd',
    'Sunrise infraprojects private limited',
    'Kolkata metropolitan south city development limited',
    'Tanveer properties private limited',
    'Merlin acropolis projects private limited',
    'Pawan putra properties private limited',
    'Bastab realcon (india) limited',
    'UPASANA COLONISERS AND RESORTS PRIVATE LIMITED',
    'CYRUS AUTOMATION INDIA LIMITED',
    'Prime realcon private limited',
    'Solar highrise private limited',
    'Gajraj conclave private limited',
    'Shantiniketan infrasturucture pvt ltd',
    'Shivkripa realbuild private limited',
    'STELLEX WATT- SUN ENERGY PRIVATE LIMITED',
    'Savco india consultants private limited',
    'Saundarya builders private limited',
    'Action infraestate developers private limited',
    'Urbtech india developers private limited',
    'ARTICULATE PROPERTY GRANDE INDIA PRIVATE LIMITED',
    'Ascent heights private limited',
    'VALION DEVELOPERS PRIVATE LIMITED',
    'AMHERST LOGISTICS PRIVATE LIMITED',
    'Surya cons private limited',
    'Kaysons automotive pvt ltd',
    'Berkeley motors limited',
    'Kerala automobiles limited',
    'Focuz corporation private limited',
    'Roshan impex private limited',
    'Bhagwati autozone private limited',
    'Continex tradeline (india) private limited',
    'Jaikrishnaa auto private limited',
    'Ideal dealers pvt ltd',
    'Unique villas private limited',
    'Bhagat cars private limited',
    'Sankalp vincom private limited',
    'Bellad motors private limited',
    'Synergy commodities private limited',
    'WARDEN INTERNATIONAL PRIVATE LIMITED',
    'Octane marketing private limited',
    'Suman management consultants private limited',
    'Nayanchiru exports private limited',
    'Kamdhenu tradelinks private limited',
    'Kpd impex private limited',
    'Rockfort eco constructions private limited',
    'Lighthouse vintrade private limited',
    'Forum retail private limited',
    'Rajdoot properties private limited',
    'Shagunshree properties private limited',
    'Wildflower estate and resorts private limited',
    'Jinendra commercials company pvt ltd',
    'Radha krishna impex private limited',
    'Multiple contrade international private limited',
    'Dimension niryaat private limited',
    'Happy valley properties and investments pvt ltd',
    'Thalaj resorts and realtors private limited',
    'S r projects india pvt ltd',
    'NICHIRIN IMPERIAL AUTOPARTS INDIA PRIVATE LIMITED',
    'Pasa (india) private limited',
    'Vincere education and infrastructures private limited',
    'Bowline management services private limited',
    'Abhinandan towers private limited',
    'Green acre developers private limited',
    'Arrowline realestate private limited',
    'Cmpl automobiles private limited',
    'GANGANAGAR TECHFAB PRIVATE LIMITED',
    'Oswal co pvt ltd',
    'West bengal projects ltd',
    'Susant crafts pvt. ltd.',
    'J m (traders & investors) pvt ltd',
    'Tara finvest private limited',
    'Rajesh motors (agencies) private limited',
    'Kalatmak exports pvt ltd.',
    'Infar tie-up pvt. ltd.',
    'Ritman commercial pvt ltd',
    'Snehapusph tie up pvt ltd',
    'Lyons range dealer pvt. ltd.',
    'Santayani vincom pvt ltd',
    'Parraj motors private limited',
    'Canning mercantiles pvt.ltd.',
    'Traxpo trading pvt ltd',
    'Rival commerce pvt ltd',
    'Radhamani exports private limited',
    'Sakhi barter pvt ltd',
    'Sanei motors private limited',
    'Regent autolinks pvt. ltd.',
    'RAJESH MOTORS MOTOCORP PRIVATE LIMITED',
    'Jain cars & auto sales private limited',
    'Skm realcon private limited',
    'Das realtech private limited',
    'Pollux realtech private limited',
    'Ems realtech private limited',
    'Anmol realty builders private limited',
    'Puliakulam holdings private limited',
    'East gate properties private limited',
    'Merlin infra projects private limited',
    'South city property management private limited',
    'PYRAMID PROPCON PRIVATE LIMITED',
    'Np blockhouse real estate private limited',
    'S d corporation private limited',
    'Awesome properties private limited',
    'Rochita construction private limited',
    'Spardha finance pvt. ltd.',
    'Shree vihar properties ltd',
    'Nandanam estates ltd',
    'Paramount land and developers pvt ltd',
    'Bagaria holdings pvt.ltd.',
    'PAHARPUR REALTY PRIVATE LIMITED',
    'Sudharma properties pvt.ltd.',
    'Arvind developers pvt ltd',
    'Vaishno apartments private limited',
    'Matangi apartments private limited',
    'Sun city properties private limited',
    'Cascade builders private limited',
    'Dhariwal infrastructure limited',
    'Vidhi promoters private limited',
    'Vedant housing private limited',
    'Manohar infraproperties private limited',
    'Abyaar real estate development private limited',
    'Rangoli plaza private limited',
    'Empire niketan private limited',
    'Siya infracon private limited',
    'PLEXOWARE TECH SOLUTIONS PRIVATE LIMITED',
    'DCMA SOFTECH PRIVATE LIMITED',
    'CANOPENERS PRIVATE LIMITED',
    'UNIVERSAL APP TOUCH PRIVATE LIMITED',
    'OPCOMMERCE ONLINE PRIVATE LIMITED',
    'CPSP TECHNOLOGIES PRIVATE LIMITED',
    'HELPSURE HEALTHCARE PRIVATE LIMITED',
    'MAHATTA ART PRIVATE LIMITED',
    'AVA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'GREENANO TECHNOLOGIES PRIVATE LIMITED',
    'KARTBITES PRIVATE LIMITED',
    'GREEN SHUTTLE TECHNOLOGY PRIVATE LIMITED',
    'GRIT SPATA TECHNOLOGY PRIVATE LIMITED',
    'INDOSPIRIT INDUSTRIES PRIVATE LIMITED',
    'STACKFUSION PRIVATE LIMITED',
    'HEALTHFIRST TECHNOLOGIES PRIVATE LIMITED',
    'CAMRON FEEDS PRIVATE LIMITED',
    'COLONIAL FILMS PRIVATE LIMITED',
    'HIGHPOINT OFFSET PRIVATE LIMITED',
    'ENDROIT DESIGNS PRIVATE LIMITED',
    'MORINGA FRONTIERS PRIVATE LIMITED',
    'FCA TURNKEY PROJECTS PRIVATE LIMITED',
    'HWELL24 BUSINESS SERVICES PRIVATE LIMITED',
    'DIGIAVIDITY PRIVATE LIMITED',
    'COSMOS GREEN INDIA BROADCAST PRIVATE LIMITED',
    'MAKWIN GIFTING SOLUTIONS INDIA PRIVATE LIMITED',
    'ELEVARSE ELEVATOR PRIVATE LIMITED',
    'ZTOA MARKETING SOLUTIONS PRIVATE LIMITED',
    'SEARO PRIVATE LIMITED',
    'AUSEMPORIUM PRIVATE LIMITED',
    'ABAKKUS EXPERT PROFESSIONALS PRIVATE LIMITED',
    'GHANDAT POWER WIND & SOLAR PROJECTS DEVELOPERS PRIVATE LIMITED',
    'VOLANT INFOSERVE PRIVATE LIMITED',
    'PURVA ASSET MANAGEMENT PRIVATE LIMITED',
    'PRANJAL INTERNATIONAL RESOLUTIONS PRIVATE LIMITED',
    'POWERTRON INDIA PRIVATE LIMITED',
    'VERIGOLD JEWELLERY INDIA PRIVATE LIMITED',
    'ESSEM COMPLIANCE SOLUTIONS PRIVATE LIMITED',
    'CREATIFOX VENTURE PRIVATE LIMITED',
    'EUROPEAN DESIGN COLLECTIVE PRIVATE LIMITED',
    'METAFIN CLEANTECH FINANCE PRIVATE LIMITED',
    'UMBO IDTECH PRIVATE LIMITED',
    'DIGERATIE XP PRIVATE LIMITED',
    'WEBEDESK SEO SERVICES PRIVATE LIMITED',
    'ONE KOSMOS TECHNOLOGY PRIVATE LIMITED',
    'PRIYA OFFSHORE PRIVATE LIMITED',
    'WDA SERVICES PRIVATE LIMITED',
    'HELLA EQUIPMENTS PRIVATE LIMITED',
    'HOMES FOR INDIA PRIVATE LIMITED',
    'KAILASH PARBAT HOLIDAYS PRIVATE LIMITED',
    'LADOOG HALWAI PRIVATE LIMITED',
    'PANITBOX SOLUTIONS PRIVATE LIMITED',
    'VARVARA INDIA PRIVATE LIMITED',
    'DTRS CONSULTANCY SERVICES PRIVATE LIMITED',
    'BLMO PRIVATE LIMITED',
    'SRI SAISADHANA SECURITIES PRIVATE LIMITED',
    'HAP GANTRY AND ENGINEERING SERVICES PRIVATE LIMITED',
    'AEROQUANT AVIATION SERVICES PRIVATE LIMITED',
    'MY BRANCH INFRASTRUCTURE PRIVATE LIMITED',
    'ESSENS WELLNESS TECHNOLOGIES PRIVATE LIMITED',
    'INDIUMTECH ANALYTICS AND SOLUTIONS PRIVATE LIMITED',
    'CL TECHNOLOGIES PRIVATE LIMITED',
    'HIGHSPEED GIGA FIBERNET PRIVATE LIMITED',
    'BILLBOX TECH SOLUTIONS PRIVATE LIMITED',
    'ARKVY PERFUMERIES AND COSMETICS PRIVATE LIMITED',
    'BECTIVE AND WESLEY PRIVATE LIMITED',
    'MONKWISH (OPC) PRIVATE LIMITED',
    'DEVOIR TRADING LIMITED',
    'SUSAN AUTOMATIONS INDIA PRIVATE LIMITED',
    'ACCVEIL SOLUTIONS PRIVATE LIMITED',
    'ACCOONIO CUBE PRIVATE LIMITED',
    'BRAHMAN UNITY FOUNDATION',
    'SARDESHMUKH FOUNDATION',
    'NAMOKAR EDUTECH (OPC) PRIVATE LIMITED',
    'RADIUM INTERACTIVES PRIVATE LIMITED',
    'CREAXT INNOVATIONS PRIVATE LIMITED',
    'GLEANORE INDIA PRIVATE LIMITED',
    'INOZ LIFESTYLE PRIVATE LIMITED',
    'BLUE AIR AND GAS TECHNOLOGIES PRIVATE LIMITED',
    'INDGLORY TECHNOLOGIES PRIVATE LIMITED',
    'AESMOVE GLOBAL MOBILITY SERVICES PRIVATELIMITED',
    'SUSHRUT DESIGNS PRIVATE LIMITED',
    'PHARMONIX BIOLOGICALS PRIVATE LIMITED',
    'PICK & CHASE PRIVATE LIMITED',
    'ANZIL SOFT PRIVATE LIMITED',
    'BASK RESEARCH FOUNDATION',
    'DUALITY ADVERTISERS PRIVATE LIMITED',
    'AGRONIC FOOD PRIVATE LIMITED',
    'SERMENT INFOTECH PRIVATE LIMITED',
    'NIAN MEDIA PRIVATE LIMITED',
    'VIRTUS PRO LOGISTICS PRIVATE LIMITED',
    'DECELER VIBROTEK CONTROLS PRIVATE LIMITED',
    'BATOR TECHNOLOGIES PRIVATE LIMITED',
    'TECHPARAMOUNT MED PRO PRIVATE LIMITED',
    'MICROLAW CORPORATE SERVICES PRIVATE LIMITED',
    'GRIT ENVIRONMENTAL EQUIPMENT PRIVATE LIMITED',
    'PINK LOTUS LOGISTICS PRIVATE LIMITED',
    'BILLIONTAGS ENTERPRISE PRIVATE LIMITED',
    'ASSYST CAREER GENERATING PRIVATE LIMITED',
    'IPON NUOVO PRIVATE LIMITED',
    'BRUHAT INSIGHTS GLOBAL PRIVATE LIMITED',
    'ANNAMALAI CONSULTANCY PRIVATE LIMITED',
    'EFM DESIGN SERVICES PRIVATE LIMITED',
    'STARKWAYS SPECIALITY MATERIALS PRIVATE LIMITED',
    'SPACE AND BEAUTY CREATIONS PRIVATE LIMITED',
    'SARVAJITH FINANCIAL SERVICES PRIVATE LIMITED',
    'NAMAKKAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'JYOTIKIRAN ENERGY BHILWARA PRIVATE LIMITED',
    'KOGNITIVE ANALYTICS PRIVATE LIMITED',
    'SETRA51 INNOVATIVE DATA CENTER (OPC) PRIVATE LIMITED',
    'GMS FIRE AND SAFETY PRIVATE LIMITED',
    'RICHMOUNT VENTURES PRIVATE LIMITED',
    'KSHEMA HOLDINGS PRIVATE LIMITED',
    'ORGAEARTH CLEANSOL PRIVATE LIMITED',
    'SUCHAKRA INFRACON PRIVATE LIMITED',
    'RAASTAFILMS PRIVATE LIMITED',
    'YUGDEEP BPM GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TEKKR EXPORTS AND IMPORTS PRIVATE LIMITED',
    'LUCID MEDICAL CENTER PRIVATE LIMITED',
    'SCRATCH TO INFINITY DIGITAL PRIVATE LIMITED',
    'ANTARR TALENT UNIVERSE PRIVATE LIMITED',
    'VNF IDEAS PRIVATE LIMITED',
    'TG SHOP PRIVATE LIMITED',
    'FROZEN FOOD PROCESSING PRIVATE LIMITED',
    'CONTIBAZAAR VENTURES PRIVATE LIMITED',
    'AUTOFRIDGE INDIA PRIVATE LIMITED',
    'BLUEFACE TECHNOLOGIES PRIVATE LIMITED',
    'KOERBER PHARMA PRIVATE LIMITED',
    'PROFESSIONAL TRAINERS AND DESIGN ENGINEERS PRIVATE LIMITED',
    'NEW GENERATION JOBS PRIVATE LIMITED',
    'SHRIAABHARANA CHITS PRIVATE LIMITED',
    'AAS FACILITY PRIVATE LIMITED',
    'GR GUNDUGOLANU DEVARAPALLI HIGHWAY PRIVATE LIMITED',
    'PLUTONOMIC SAVTECH PRIVATE LIMITED',
    'SAISRUSHTI (ABACHIKKANAHALLI) PROJECTS PRIVATE LIMITED',
    'RAZR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TALENTPRO INDIA FOUNDATION',
    'DARJUV9 ENTERPRISES PRIVATE LIMITED',
    'MAIEUTIC CONSULTANT PRIVATE LIMITED',
    'DEV MANTRA ONLINE SERVICES PRIVATE LIMITED',
    'HPR SYNERGY ENGINEERING PRIVATE LIMITED',
    'SUNDARAM AAROGYAM & VITALITY ENDOWMENT FOUNDATION',
    'ACE HUMAN CAPITAL LIMITED',
    'DHI TECHNOLOGIES PRIVATE LIMITED',
    'IRSO PRIVATE LIMITED',
    'ALEKOS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TRIATURE DIGITAL MARKETING AND TECHNOLOGY PRIVATE LIMITED',
    'YASH FANS & APPLIANCES LIMITED',
    'CASA FOREVER PRIVATE LIMITED',
    'VENTUS AIRCONDITIONING PRIVATE LIMITED',
    'TOTALDIGILUTION PRIVATE LIMITED',
    'VAYUP PRIVATE LIMITED',
    'MLIT - SOL PRIVATE LIMITED',
    'ENLIGNE SURVEY PRIVATE LIMITED',
    'SAISRUSHTI (DEVANAHALLI-LAKSHMIPURA) PROJECTS PRIVATE LIMITED',
    'LPARK SOLUTIONS PRIVATE LIMITED',
    'SONJAY HOSPITALS PRIVATE LIMITED',
    'AIC-GIM FOUNDATION',
    'BREADTH-FIRST TECHNOLOGIES PRIVATE LIMITED',
    'KALKI CULTURE EVENTS & PROMOTIONS PRIVATE LIMITED',
    'MZMCARE FOUNDATION',
    'G&P WORKFORCE MANAGEMENT PRIVATE LIMITED',
    'POWER HEATERS PRIVATE LIMITED',
    'WECASH INDIA PRIVATE LIMITED',
    'WEBOMATIC LEARNING SOLUTIONS PRIVATE LIMITED',
    'CARVEMYLIFE COACHING SERVICES PRIVATE LIMITED',
    'KALYR RETAIL PRIVATE LIMITED',
    'CHATURVITT CONSULTING PRIVATE LIMITED',
    'SWISTER ACADEMY PRIVATE LIMITED',
    'DIRK PHOENIX PRIVATE LIMITED',
    'G&P GENEROSITY MANAGEMENT PRIVATE LIMITED',
    'GENMA (INDIA) PRIVATE LIMITED',
    'MEVIR SOLUTIONS PRIVATE LIMITED',
    'DISRUPT ADVISORS PRIVATE LIMITED',
    'GARAGE COWORK PRIVATE LIMITED',
    'SOSYO HAJOORI BEVERAGES PRIVATE LIMITED',
    'REYNISH PHARMACHEM PRIVATE LIMITED',
    'PREEMINENCE ENGINEERS PRIVATE LIMITED',
    'J.S.T. CONNECTORS INDIA PRIVATE LIMITED',
    'SWIPE DESIGNS PRIVATE LIMITED',
    'SILOHU TECHNOLOGIES PRIVATE LIMITED',
    'BODHILEAF TECHNOLOGIES PRIVATE LIMITED',
    'ABHA BIOTECHNOLOGY PRIVATE LIMITED',
    'ADANI SOLAR ENERGY RJ ONE PRIVATE LIMITED',
    'BSOCHILL TECHNOLOGIES PRIVATE LIMITED',
    'SJJ TEXTILES PRIVATE LIMITED',
    'SAVAN GREEN ENERGY SOLUTIONS LIMITED',
    'PRVAK TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'CHOOYAL PRIVATE LIMITED',
    'ASHOKA KHAIRATUNDA BARWA ADDA ROAD LIMITED',
    'AMBRO IOT SERVICES PRIVATE LIMITED',
    'ALPHAPEOPLE STAFFING SOLUTIONS PRIVATE LIMITED',
    'IANNIM BOUQUETS PRIVATE LIMITED',
    'ANAVEEY ENGINEERING PRIVATE LIMITED',
    'ERATRONICS PRIVATE LIMITED',
    'EASTMAN ENGINEERING PRIVATE LIMITED',
    'ROUTE CONNECT PRIVATE LIMITED',
    'OUSARY PROJECTS & FACILITIES PRIVATE LIMITED',
    'CLOUDTECIES TECHNOLOGIES PRIVATE LIMITED',
    'KHERUB INTERIOR DESIGN AND CONSTRUCTION PRIVATE LIMITED',
    'OXYGEN PLASTICARE PRIVATE LIMITED',
    'RKRM INTERNATIONAL PRODUCTS PRIVATE LIMITED',
    'SMARTFACTORY - ROBOTICS & AUTOMATION INDIA PRIVATE LIMITED',
    'KRAM BHUMI CEMENT PRIVATE LIMITED',
    'ENGAGENOW DATA SCIENCES PRIVATE LIMITED',
    'SHAKRAYA GARMENT FABRICATORS PRIVATE LIMITED',
    'EUGENE SOLUTION (OPC) PRIVATE LIMITED',
    'MATTER OF SPACE PRIVATE LIMITED',
    'RICH MARINE MATES SHIPPING & INFRA PRIVATE LIMITED',
    'DATAMATICS INFOTECH SERVICES PRIVATE LIMITED',
    'CWAT APPS PRIVATE LIMITED',
    'AMBULATION INFOTECH PRIVATE LIMITED',
    'ASIANCLASSIC TRAVELS INDIA PRIVATE LIMITED',
    'ABSC ENTERTAINMENT PRIVATE LIMITED',
    'CENQ SYSTEMS PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR FIVE PRIVATE LIMITED',
    'SODA FILMS PRIVATE LIMITED',
    'MOTOJOJO PRIVATE LIMITED',
    'EPOWERX LEARNING TECHNOLOGIES PRIVATE LIMITED',
    'ACZ GLOBAL PRIVATE LIMITED',
    'LINESIGHT CONSULTING PRIVATE LIMITED',
    'AHARAM FOODS PRIVATE LIMITED',
    'FUVINO PRIVATE LIMITED',
    'GHN LIFESTYLE PRIVATE LIMITED',
    'MIL INDUSTRIES & AEROSPACE LIMITED',
    'COSMOS SOFTECH PRIVATE LIMITED',
    'VORKBOX ENTERTAINMENT PRIVATE LIMITED',
    'ROZGADI FRESH PRIVATE LIMITED',
    'ENVIRO INFRAFACILITY PRIVATE LIMITED',
    'INFERENCE LABS PRIVATE LIMITED',
    'AGAMA ANURAKSATI BUSINESS PROMOTION PRIVATE LIMITED',
    'EVENTILATORS PRIVATE LIMITED',
    'SUISEN HOSPITALITY PRIVATE LIMITED',
    'SURIFRESH EXTRACT PRIVATE LIMITED',
    'TRICHIKAVERI FOODS PRIVATE LIMITED',
    'RAFAY EVENT MANAGEMENT SERVICES PRIVATE LIMITED',
    'SHARMA CONTRACTORS PRIVATE LIMITED',
    'VAJRAIT SERVICES PRIVATE LIMITED',
    'VARP SOLAR SKYLIGHT PRIVATE LIMITED',
    'MEDIPFLEGE PRIVATE LIMITED',
    'APCO NAVKALYAN EXPRESSWAY PRIVATE LIMITED',
    'LIFESIGHT TECHNOLOGIES PRIVATE LIMITED',
    'DREAM ROAD TECHNOLOGIES PRIVATE LIMITED',
    'STRIATUM TECHNOLOGIES PRIVATE LIMITED',
    'ROOTEDOBJECTS PRIVATE LIMITED',
    'AVAXPRO TECH PRIVATE LIMITED',
    'B.S.ENGINEERING COMPOSITE PRIVATE LIMITED',
    'AWINSA LIFE SCIENCES PRIVATE LIMITED',
    'CARICO SYSTEMS PRIVATE LIMITED',
    'PANGEAA ITES PRIVATE LIMITED',
    'ASWINI MULTI AGRO INDUSTRIES PRIVATE LIMITED',
    'QUICKSPACE TECHNOLOGIES F1 WORKS PRIVATELIMITED',
    'LOGVITE SOLUTIONS PRIVATE LIMITED',
    'RIVIGO FOUNDATION',
    'NAC CORPORATE ADVISORS PRIVATE LIMITED',
    'PANKHURI LOGISTICS PRIVATE LIMITED',
    'SIDDHANTHAM TOLLWAY PRIVATE LIMITED',
    'RIDGETOP HEALTHCARE PRACTICE PRIVATE LIMITED',
    'FORTUNOSAATHI PRIVATE LIMITED',
    'YUMIENT FOODS AND BEVERAGES PRIVATE LIMITED',
    'HORNED OWL SOFTWARE PRIVATE LIMITED',
    'PYGMALION RENAISSANCE PRIVATE LIMITED',
    'SUCCESSTHUMB HR SERVICES PRIVATE LIMITED',
    'SKYFULL MAINTENANCE SERVICES PRIVATE LIMITED',
    'BLOOPBOX PRIVATE LIMITED',
    'GORO ( INDIA ) PRIVATE LIMITED',
    'CKPL CONSULTING KREW PRIVATE LIMITED',
    'ET INFO SOLUTIONS PRIVATE LIMITED',
    'RUDANI ENTERPRISES PRIVATE LIMITED',
    'QUADCAN SOLUTIONS PRIVATE LIMITED',
    'MOTIVE REALTECH PRIVATE LIMITED',
    'AADHYA GLOBAL ADVISORY PRIVATE LIMITED',
    'TEXOFIL INDUSTRIES PRIVATE LIMITED',
    'WYNPRO TRADING PRIVATE LIMITED',
    'DIGIFEEL TECHNOLOGIES PRIVATE LIMITED',
    'ARDONAN PACKAGING INDUSTRIES PRIVATE LIMITED',
    'SREE GOKULAM BENEFIT CHIT FUNDS PRIVATE LIMITED',
    'AUTOCREST AUTOMOBILE SERVICES AND INTERNATIONAL TRAINING PRIVATE LIMITED',
    'RNAUX GLOBAL INDIA PRIVATE LIMITED',
    'EILAN MOTION PICTURES PRIVATE LIMITED',
    'BHOZN4U CUISINE INDIA PRIVATE LIMITED',
    'LEVERTON SOFTWARE INDIA PRIVATE LIMITED',
    'OMK ADVISORS PRIVATE LIMITED',
    'VAGMINE DIGITAL SERVICES PRIVATE LIMITED',
    'PM STAFFING SERVICES PRIVATE LIMITED',
    'KHODIYAR MARKETING PRIVATE LIMITED',
    'ANTASTIC INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'PRIMASELLER INDIA PRIVATE LIMITED',
    'MEDTELERAD TECHNOLOGIES PRIVATE LIMITED',
    'OLGA EN FAB PRIVATE LIMITED',
    'WYNOMY INFOTECH PRIVATE LIMITED',
    'KABILIYET TRAINING SERVICES PRIVATE LIMITED',
    'CHILDREN OF THE SOIL',
    'MYSTERY TRIPS PRIVATE LIMITED',
    'ILLIMITATUS TECHNOLOGY TRANSFER FOUNDATION',
    'AVS SHIPPING INDIA PRIVATE LIMITED',
    'LCG ALUMINIUM INDUSTRIES PRIVATE LIMITED',
    'SKT WEB THEMES PRIVATE LIMITED',
    'IRB HAPUR MORADABAD TOLLWAY LIMITED',
    'VAIJAPUR HASTA TOLLWAYS PRIVATE LIMITED',
    'PRASANNOSTU PROJECTS PRIVATE LIMITED',
    'ECOZARA INITIATIVES PRIVATE LIMITED',
    'BELINDA PRIVATE LIMITED',
    'BULVVARK FRAGRANCES (OPC) PRIVATE LIMITED',
    'SHIVDHAN COMMUNITY HOUSING PRIVATE LIMITED',
    'SKRETTING AQUACULTURE INDIA PRIVATE LIMITED',
    'AMBIKA REALCON DEVELOPERS PRIVATE LIMITED',
    'STXYZ SOLUTIONS PRIVATE LIMITED',
    'PATH CODERS PRIVATE LIMITED',
    'MTX IT CONSULTING SERVICES PRIVATE LIMITED',
    'TEV AUDIT AND TECH SOLUTIONS PRIVATE LIMITED',
    'ENTRIVI ECOMMERCE PRIVATE LIMITED',
    'TPHRC PRIVATE LIMITED',
    'LENSTA TECHNOLOGIES PRIVATE LIMITED',
    'TINYTESTY FOODS INDIA PRIVATE LIMITED',
    'TAYLOR SOFTWARE PRIVATE LIMITED',
    'EBISU LOGISTICS PRIVATE LIMITED',
    'MATWAN DAIRY FARM PRIVATE LIMITED',
    'GRAPHHENE SOFTWARE PRIVATE LIMITED',
    'SHASAKT UDYOG INDIA PRIVATE LIMITED',
    'CHINENSIS HEALTH CARE PRIVATE LIMITED',
    'MECHELEK MEP PROJECTS PRIVATE LIMITED',
    'TA',
    'S MINES AND MINERALS PRIVATE LIMITED',
    'MITASU DEVELOPERS PRIVATE LIMITED',
    'SPECTROVISION INSTRUMENTS PRIVATE LIMITED',
    'KGS DIAMOND TOOLS (INDIA) PRIVATE LIMITED',
    'NEWLAND STATIONERS PRIVATE LIMITED',
    'APL ANALYST IT SOLUTIONS PRIVATE LIMITED',
    'YASHODAPLUS PHARMACIES INDIA PRIVATE LIMITED',
    'APTA FOOTSECURE PRIVATE LIMITED',
    'GENIQ HOME DECORE PRIVATE LIMITED',
    'WEIBU INFORMATION INDIA PRIVATE LIMITED',
    'SPA BIOTECH PHARMA PRIVATE LIMITED',
    'BLAKOL INFOTECH PRIVATE LIMITED',
    'BLACKSTRAW TECHNOLOGIES PRIVATE LIMITED',
    'AKNA MEDICAL PRIVATE LIMITED',
    'TELVICA INDIA PRIVATE LIMITED',
    'CODEZEROS TECHNOLOGY PRIVATE LIMITED',
    'SWM MONITORING SYSTEM PRIVATE LIMITED',
    'SAISRUSHTI (BUDIGERE) PROJECTS PRIVATE LIMITED',
    'FORTUNE MALAYALAM AUTOMOBILES PRIVATE LIMITED',
    'WELPAR PHARMBIZZ LIMITED',
    'ACP IT SOLUTIONS PRIVATE LIMITED',
    'JSV DIGITAL NETWORKS PRIVATE LIMITED',
    'QUADA PMC PRIVATE LIMITED',
    'SCG DIGITAL PRIVATE LIMITED',
    'SRIOWN INTERNATIONAL PRIVATE LIMITED',
    'NEXUSLINK SERVICES INDIA PRIVATE LIMITED',
    'QUANINT TECHSOFT PRIVATE LIMITED',
    'MONISHA & SHWETA LUXE DESIGN PRIVATE LIMITED',
    'CCENTRIC LEARNING EDGE PRIVATE LIMITED',
    'REDMIL BUSINESS MALL PRIVATE LIMITED',
    'TRAOX INDIA LIMITED',
    'MASTERFLEXO CABLES PRIVATE LIMITED',
    'PANTHERLEAP PRIVATE LIMITED',
    'ARROW STAFFING SOLUTION PRIVATE LIMITED',
    'MPS INTERACTIVE SYSTEMS LIMITED',
    'ZAHRA HOSPITALITY PRIVATE LIMITED',
    'GENUINE FACILITY MALL PRIVATE LIMITED',
    'DOLLOR TECHNOLOGIES PRIVATE LIMITED',
    'SPEAKAPP SOCIAL MEDIA PRIVATE LIMITED',
    'ASHOK JEWELS PRIVATE LIMITED',
    'RED ROAD HEALTH SOLUTIONS PRIVATE LIMITED',
    'WMI INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'NMDC CSR FOUNDATION',
    'JHAMTANI REALTY PRIVATE LIMITED',
    'VARDHMAN MACHINERY EQUIPMENTS PRIVATE LIMITED',
    'DESIGNS. COM PRIVATE LIMITED',
    'DRAGIT TECHNOLOGIES PRIVATE LIMITED',
    'SECURONIX INDIA PRIVATE LIMITED',
    'PROELIUM LEARNING SOLUTIONS PRIVATE LIMITED',
    'ALPARGATAS INDIA FASHIONS PRIVATE LIMITED',
    'AUTO AIDC PRODUCTS INDIA PRIVATE LIMITED',
    'RADIANT AGRITECH LIMITED',
    'AAN HEALTHYAIR SYSTEM PRIVATE LIMITED',
    'NCPL SERVICES PRIVATE LIMITED',
    'KRUVS INDUSTRIES PRIVATE LIMITED',
    'AVANTE EXPO RETAIL PRIVATE LIMITED',
    'OVOLO IT BUILDING SOLUTIONS PRIVATE LIMITED',
    'UFS PROTECTS INDIA PRIVATE LIMITED',
    'UDC ENTERPRISES PRIVATE LIMITED',
    'AKM DISTRIBUTIONS PRIVATE LIMITED',
    'DUOLOGUE INFOTECH PRIVATE LIMITED',
    'WORKFREAKS CORPORATE SERVICES PRIVATE LIMITED',
    'SNILLRIK INTERNATIONAL PRIVATE LIMITED',
    'KHAMMAA GHANI MOVING IMAGES PRIVATE LIMITED',
    'FTMARG CONSULTING PRIVATE LIMITED',
    'ASDN INFOSPACE SERVICES PRIVATE LIMITED',
    'ECG EASY CONNECT LOGISTICS PRIVATE LIMITED',
    'OWNBACKUP INDIA PRIVATE LIMITED',
    'URBAN ESSENTIALS INDIA PRIVATE LIMITED',
    'ADDP DESIGN AND CONSTRUCTIONS PRIVATE LIMITED',
    'ASAM SHOPMET PRIVATE LIMITED',
    'SANDTECH CONTRACTING PRIVATE LIMITED',
    'TC WIRE & CABLES PRIVATE LIMITED',
    'NOVACARE HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'YOLO HEALTH FOUNDATION',
    'RELIABLE ACCESSORIES PRIVATE LIMITED',
    'HPDLS ENERGY PRIVATE LIMITED',
    'ALOGIC ELECTRONICS INDIA PRIVATE LIMITED',
    'VARDHAMAN ENGIMECH PRIVATE LIMITED',
    'TORRENT GAS LIMITED',
    'TENDERLINE TECHNOLOGIES PRIVATE LIMITED',
    'LIBERTY INDUSTRIES PRIVATE LIMITED',
    'SEVON INKOR TECHNOLOGIES PRIVATE LIMITED',
    'BRAINSTRONG SECURITY SERVICES PRIVATE LIMITED',
    'RICARIA SUPPORT SERVICES PRIVATE LIMITED',
    'VW FOOD PRIVATE LIMITED',
    'COGENERATE TECHNOLOGIES PRIVATE LIMITED',
    'BLUE HORIZONS STRATEGIC ENGINEERING PRIVATE LIMITED',
    'BSB DATA AND INFORMATION PROCESSING SERVICES PRIVATE LIMITED',
    'EMAGINE INFOTECH SOFTWARE PRIVATE LIMITED',
    'NOSOTROS SOLUTIONS PRIVATE LIMITED',
    'HRIDHAM TECHNOLOGY & SERVICES PRIVATE LIMITED',
    'BUNCH MICROTECHNOLOGIES PRIVATE LIMITED',
    'PRONTGEN HEALTH REMEDIES PRIVATE LIMITED',
    'UPMOVE CAPITAL PRIVATE LIMITED',
    'KARNAS CONLUBE PRIVATE LIMITED',
    'NG EDUWIZER PRIVATE LIMITED',
    'MOBTREE DIGITAL PRIVATE LIMITED',
    'SAMATECH FOUNDATION',
    'NEUMETRIC INDIA PRIVATE LIMITED',
    'NITCON SOCIAL FOUNDATION',
    'CALCUS CONSULTANCY PRIVATE LIMITED',
    'PARA ENTERPRISES PRIVATE LIMITED',
    'MICHELIN INDIA PRIVATE LIMITED',
    'SUPER SPRINGS PRIVATE LIMITED',
    'NEEL INDUSTRIES PRIVATE LIMITED',
    'DANFOSS INDUSTRIES PRIVATE LIMITED',
    'VAZES INSTITUTE OF STUDIES AND EDUCATIONAL RESEARCH PRIVATE LIMITED',
    'URBAN DABBA (OPC) PRIVATE LIMITED',
    'PASSION RESTAURANT PRIVATE LIMITED',
    'LAXMIKA ORBIS PRIVATE LIMITED',
    'RVM AGRI SOLUTIONS INDIA PRIVATE LIMITED',
    'ALPHA SYSTEMS PRIVATE LIMITED',
    'SHESHADRI INDUSTRIES LIMITED',
    'NAVABHARAT LIMITED',
    'ROKIN GRANITES INDIA PRIVATE LIMITED',
    'VAYHAN COFFEE LIMITED',
    'ORIGINS ACCELERATOR PRIVATE LIMITED',
    'SF-INOVATEX INDIA PRIVATE LIMITED',
    'MAVERICK MANGOYATRA (OPC) PRIVATE LIMITED',
    'GAR TECHNOLOGIES PRIVATE LIMITED',
    'NETTLINX LIMITED',
    'GOLKONDA ENGINEERING ENTERPRISES LIMITED',
    'SAMSRITA LABS LIMITED',
    'GAYATRI PROJECTS LIMITED',
    'PORTIA PROPERTIES PRIVATE LIMITED',
    'LIMAGRAIN INDIA PRIVATE LIMITED',
    'SHREE NIDHI SECURE PRINT PRIVATE LIMITED',
    'S M ROTOFLEX PRIVATE LIMITED',
    'PLATINUM PROPERTIES PRIVATE LIMITED',
    'SERENE ESTATES PRIVATE LIMITED',
    'OMEGA SHELTERS PRIVATE LIMITED',
    'ASSOCIATED ROADWAYS PRIVATE LIMITED',
    'SHAKTI HORMANN PRIVATE LIMITED',
    'INDIAN SCHOOL OF BUSINESS',
    'SUPER SPINNING MILLS LIMITED',
    'AUTOMOBILE PRODUCTS OF INDIA LIMITED',
    'SHIVA TEXYARN LIMITED',
    'EYE FOUNDATION LIMITED',
    'NEERAJ ENTERPRISES PRIVATE LIMITED',
    'TVS CAPITAL FUNDS PRIVATE LIMITED',
    'PRAJAY ENGINEERS SYNDICATE LTD',
    'BOUNTIFUL SOFTWARE INDIA PRIVATE LIMITED',
    'PINT LAB TECHNOLOGIES PRIVATE LIMITED',
    'REFLECT HEALTHCARE AND RETAIL PRIVATE LIMITED',
    'CFO ANGLE AI SOLUTIONS PRIVATE LIMITED',
    'DIRAC INDUSTRIES PRIVATE LIMITED',
    'DEION SYSTEMS AND SERVICES PRIVATE LIMITED',
    'ALMUS INFRATECH PRIVATE LIMITED',
    'SEOUL INDUSTRIES PRIVATE LIMITED',
    'VIVAZEN TECHNO PRIVATE LIMITED',
    'WIKAAD IT SYSTEMS PRIVATE LIMITED',
    'TAPROGGE INDITECH PRIVATE LIMITED',
    'ATRIVISH CONSULTING PRIVATE LIMITED',
    'MELVANO EDUCATION PRIVATE LIMITED',
    'WAANEEP SOLAR ONE PRIVATE LIMITED',
    'SAMBEET EQUIPMENTS PRIVATE LIMITED',
    'ILET SOLUTIONS PRIVATE LIMITED',
    'NAX AIR SOLUTIONS INDIA PRIVATE LIMITED',
    'FIBERAN TELECOM PRIVATE LIMITED',
    'DASKALOS VIRTUAL ACADEMY PRIVATE LIMITED',
    'UNDOKAI DREAMS ASSOCIATION',
    'SURESH BIZGLOBE (OPC) PRIVATE LIMITED',
    'VIKI SOFTWARE (OPC) PRIVATE LIMITED',
    'LABSTECHNIA INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED',
    'SUBHARAM HEALTHCARE PRIVATE LIMITED',
    'FEELS GOOD CREATIONS ITES PRIVATE LIMITED',
    'NETSWEEPER DIGITAL SECURITY PRIVATE LIMITED',
    'KAIHATSU PRO PRIVATE LIMITED',
    'ACCELSAP CONSULTING SERVICES PRIVATE LIMITED',
    'ZENTRAAC ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'XR CINEMA PRIVATE LIMITED',
    'CHINTPURNI IMMIGRATION SERVICES PRIVATE LIMITED',
    'SEMIQOLON SOLUTIONS PRIVATE LIMITED',
    'TARMED INDIA PRIVATE LIMITED',
    'JET FREIGHT EXPRESS PRIVATE LIMITED',
    'ATLANTIC URJA PRIVATE LIMITED',
    'QUADRECKO DATA LABS PRIVATE LIMITED',
    'ENERGEC ENGINEERS AND PLANNERS PRIVATE LIMITED',
    'AVV BRANDING SOLUTIONS PRIVATE LIMITED',
    'PRIMEDEAL REALTY PRIVATE LIMITED',
    'QIX CLOTHING PRIVATE LIMITED',
    'BLICK SYSTEM INDIA PRIVATE LIMITED',
    'TOQFACTOR TECHNOLOGIES PRIVATE LIMITED',
    'INAMOS ONLINE SOLUTIONS PRIVATE LIMITED',
    'AIC-RNTU FOUNDATION',
    'LAKHDATAR TECHNOLOGY PRIVATE LIMITED',
    'WPA VENTURES PRIVATE LIMITED',
    'PARKCORPS SOFTWARE SERVICES PRIVATE LIMITED',
    'D2W APPAREL PRIVATE LIMITED',
    'WILDFLOWER CLUB & RESORT PRIVATE LIMITED',
    'YKSK ELEGANT PRIVATE LIMITED',
    'TRAWELME TOURS PRIVATE LIMITED',
    'MYNDTREE INVESTMENT PRIVATE LIMITED',
    'ROWAN FARMS PRIVATE LIMITED',
    'STARKWELT NUTRITION PRIVATE LIMITED',
    'MEPSERVE INDIA PRIVATE LIMITED',
    'ZWINNY SOLUTIONS PRIVATE LIMITED',
    'DEXUS MEDIA PRIVATE LIMITED',
    'PUNE RUBBER CLUSTER AND RESEARCH FOUNDATION',
    'WHITE STAR HOMEWARE PRIVATE LIMITED',
    'VIJPASAR RENEWABLE ENERGY PRIVATE LIMITED',
    'EMPI ENERGY LAB PRIVATE LIMITED',
    'FAUSTINE IMPORT PRIVATE LIMITED',
    'NEXTRON ENGINEERING PRIVATE LIMITED',
    'MINDSTONE MALL DEVELOPERS PRIVATE LIMITED',
    'FROLIC STEELS PRIVATE LIMITED',
    'AARTI SURFACTANTS LIMITED',
    'CROTON TECHNOLOGIES PRIVATE LIMITED',
    'ADVANCE STAR INDIA PRIVATE LIMITED',
    'ZOZAL INDUSTRIES PRIVATE LIMITED',
    'SPOTLINE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'RENORK INDIA PRIVATE LIMITED',
    'SPECMOVE PRIVATE LIMITED',
    'FUROH FASHION PRIVATE LIMITED',
    'GAJOD RENEWABLE ENERGY PRIVATE LIMITED',
    'RATNAAFIN ENTERPRISE PRIVATE LIMITED',
    'SUNMI INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY SIXTEEN PRIVATE LIMITED',
    'BRILLIANT TECHNOFAB PRIVATE LIMITED',
    'AADONA COMMUNICATION PRIVATE LIMITED',
    'BAXY ARCHSTONE PRIVATE LIMITED',
    'GUDLIG SERVICES (OPC) PRIVATE LIMITED',
    'VALENDOR INDIA PRIVATE LIMITED',
    'KINEXIN CONVENTION MANAGEMENT PRIVATE LIMITED',
    'PRISKA LIFESCIENCES PRIVATE LIMITED',
    'ECAV MULTIVENTURE PRIVATE LIMITED',
    'LMANDALA GROUP PRIVATE LIMITED',
    'ADVIKA UNICO HOSPITALITY PRIVATE LIMITED',
    'EDUMENT CONSULTANCY PRIVATE LIMITED',
    'SOFTICES ACADEMY PRIVATE LIMITED',
    'KNINE IMPEX PRIVATE LIMITED',
    'STARKDIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'EKAGGATA TECHNOLOGIES & CONSULTANCY SERVICES PRIVATE LIMITED',
    'VALUE CAPRISE PRIVATE LIMITED',
    'LOGICASH INFRASTRUCTURE PRIVATE LIMITED',
    'FACTELL CONSULTING PRIVATE LIMITED',
    'AIC - MUJ INCUBATION FOUNDATION',
    'AZTEC PROCESS AUTOMATION PRIVATE LIMITED',
    'SUNKOTS HEALTHY FOOD PRIVATE LIMITED',
    'HERTEN TECHNOLOGIES PRIVATE LIMITED',
    'KRIGO AUTOMATION INDIA PRIVATE LIMITED',
    'FRS MANAGEMENT PRIVATE LIMITED',
    'KNOWLEDGE ASSOCIATES SOLUTIONS PRIVATE LIMITED',
    'INCUGLOBE SOLUTIONS PRIVATE LIMITED',
    'ARTIVISM COLLABORATIONS PRIVATE LIMITED',
    'MAHOUT GLOBAL CORPORATE SERVICES PRIVATELIMITED',
    'SK TOWERS OWNERS PRIVATE LIMITED',
    'JOGMAYA SHAKTI PRODUCER COMPANY LIMITED',
    'NEOVAE BIO MEDICS PRIVATE LIMITED',
    'METALTEK ENERGY PRIVATE LIMITED',
    'REGENCY TMT PRIVATE LIMITED',
    'SHAHPURA HOSPITALITY PRIVATE LIMITED',
    'EZ BUY PRIVATE LIMITED',
    'VALLEY TECH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ERE INSURTECH INDIA PRIVATE LIMITED',
    'CANADIAN CENTRE FOR SUCCESS PRIVATE LIMITED',
    'ASIAN AMBROSIA INDIA PRIVATE LIMITED',
    'DEEPDIVE DIGITAL PRIVATE LIMITED',
    'BITE MII SOFTWARE PRIVATE LIMITED',
    'RIGEN PACKAGING PRIVATE LIMITED',
    'JAZLEEN TRAVELS PRIVATE LIMITED',
    'FROTAMILES PRIVATE LIMITED',
    'LVS GRANITES PRIVATE LIMITED',
    'INDUJAA MAHILA MILK PRODUCER COMPANY LIMITED',
    'VIYOM FARMLAND PRIVATE LIMITED',
    'ARALIAS HOSPITALITY PRIVATE LIMITED',
    'SARVAYAM FOOD PRODUCTS PRIVATE LIMITED',
    'W2D SOLUTIONS (OPC) PRIVATE LIMITED',
    'SEPTA INFOTECH PRIVATE LIMITED',
    'ALLYGRAM SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED',
    'ORIONMOON PRIVATE LIMITED',
    'KACO SMART SUPPLY CHAIN MANAGEMENT INDIAPRIVATE LIMITED',
    'FILE-IT CONSULTANCY SERVICES PRIVATE LIMITED',
    'ABODEX PROCESS SYSTEMS PRIVATE LIMITED',
    'NULLPOINTER ANALYTICS PRIVATE LIMITED',
    'VPCS TECHNOLOGY PRIVATE LIMITED',
    'NAVIGATIO TRAVEL SOLUTIONS PRIVATE LIMITED',
    'STRADA TECHNOLOGIES PRIVATE LIMITED',
    'JACOBBROS SUPPORT SERVICES PRIVATE LIMITED',
    'CLEAVENSKY RESELLER AND SERVICES PRIVATELIMITED',
    'BALULI ADVENTURES PRIVATE LIMITED',
    'DESSORONO COMMERCE PRIVATE LIMITED',
    'WEST INDIA GLOBAL PRIVATE LIMITED',
    'SEGER OVERSEAS PRIVATE LIMITED',
    'GAMETION TECHNOLOGIES PRIVATE LIMITED',
    'DENKEN SOLUTIONS INDIA PRIVATE LIMITED',
    'PEPELWERK TECHNOLOGY INDIA PRIVATE LIMITED',
    'AKONI SOFTWARE SERVICES (OPC) PRIVATE LIMITED',
    'BEEPRENEURS FOODS PRIVATE LIMITED',
    'KEPLER AEROSPACE PRIVATE LIMITED',
    'APMSE SOFTWARE SERVICES PRIVATE LIMITED',
    'STAROPS SYSTEMS PRIVATE LIMITED',
    'ALLYYC BIZ SOLUTIONS PRIVATE LIMITED',
    'GOENKA AUTOMOBILITY PRIVATE LIMITED',
    'MUTTOM GRANITES INDIA PRIVATE LIMITED',
    'AVL BIG DATA INDIA PRIVATE LIMITED',
    'SHAULA INFRASTRUCTURE FACILITIES PRIVATELIMITED',
    'CHEMDIST MEMBRANE SYSTEMS PRIVATE LIMITED',
    'ALTTECH RENEWABLES PRIVATE LIMITED',
    'SUNERGIZE ENERGY SOLUTIONS PRIVATE LIMITED',
    'CIMERO INFRASTRUCTURE PRIVATE LIMITED',
    'PRG SOFTWARES PRIVATE LIMITED',
    'BMDG INTERNATIONAL PRIVATE LIMITED',
    'ADL TRANSPORT SERVICES PRIVATE LIMITED',
    'TIDINGS DIGITAL PUBLICATIONS PRIVATE LIMITED',
    'SULOCHANA TECHNOLOGICAL PRIVATE LIMITED',
    'CENTRAL GAS VENTURES INDIA ESCO PRIVATE LIMITED',
    'DEVI DESIGNERS AND DECORATORS PRIVATE LIMITED',
    'NEW GEN PACKPOOL PRIVATE LIMITED',
    'LOOM SOLAR PRIVATE LIMITED',
    'AGO TRAVELINGFUNS HOLIDAYS PRIVATE LIMITED',
    'TRANSTEK HEALTHCARE SERVICES PRIVATE LIMITED',
    'ECSTATIC CLOTHING PRIVATE LIMITED',
    'SPTCS SOLAR POWER TECHNOLOGY CONSULTANCYSERVICES PRIVATE LIMITED',
    'IESA MINING CONSTRUCTION PRIVATE LIMITED',
    'NCSI TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'VUPPULURI INTEGRATED PRIVATE LIMITED',
    'TANEJA FINANCIAL CONSULTANTS PRIVATE LIMITED',
    'DOMIN TRIP PRIVATE LIMITED',
    'TRENDLOUD DIGITAL INDIA PRIVATE LIMITED',
    'SRI CHITRAGUPTA JAN KALYAN FOUNDATION',
    'AMMU ENTERPRISES PRIVATE LIMITED',
    'BOOST CONSULTING PRIVATE LIMITED',
    'WEFIXIT ENTERPRISE COMPUTER SOLUTIONS PRIVATE LIMITED',
    'SAISRUSHTI (AKKUPETE) PROJECTS PRIVATE LIMITED',
    'S K GUPTA & SONS RETAIL PRIVATE LIMITED',
    'GACRUX PROPERTIES PRIVATE LIMITED',
    'PDRG PRODUCER COMPANY LIMITED',
    'ZILOGIC TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'NEOPATH TECHNOLOGIES PRIVATE LIMITED',
    'DISHA HABITAT VENTURES PRIVATE LIMITED',
    'MINEMATICS SOLUTIONS PRIVATE LIMITED',
    'TRANZO DIGITAL SERVICES PRIVATE LIMITED',
    'MANIERE ELEGANTE ONLINE SERVICES (OPC) PRIVATE LIMITED',
    'ADVANCED VETERINARY CARE FOUNDATION',
    'AMWAY GLOBAL SERVICES INDIA PRIVATE LIMITED',
    'DOLCI INVESTOR ADVISORS PRIVATE LIMITED',
    'VOXTUR CLINICAL RESEARCH PRIVATE LIMITED',
    'DALTON INVESTMENT ADVISORY SERVICES PRIVATE LIMITED',
    'SWAPPL INTELLECT SOL PRIVATE LIMITED',
    'ZOT WORKS PRIVATE LIMITED',
    'EXPERNIZE INNOVATIONS PRIVATE LIMITED',
    'WELCOME RAINBOW MARKETING PRIVATE LIMITED',
    'DOUXNET IT SOLUTIONS PRIVATE LIMITED',
    'MUBEEN AHMED AND SONS LEATHER EXPORTS PRIVATE LIMITED',
    'IFIXEDIT PRIVATE LIMITED',
    'NWSD TECHNOLOGIES PRIVATE LIMITED',
    'KVAYAT MEDICAL PRIVATE LIMITED',
    'GRAPE EVENTS PRIVATE LIMITED',
    'SARAL TOWER TELECOMMUNICATION SERVICES PRIVATE LIMITED',
    'ECCEL EXPORTS PRIVATE LIMITED',
    'SGP R&D INDIA PRIVATE LIMITED',
    'PURITZ CHEM PRIVATE LIMITED',
    'ARCHETIVE SOLUTIONS PRIVATE LIMITED',
    'NAVKAR ENGINEERS PRIVATE LIMITED',
    'EURO PANEL PRODUCTS LIMITED',
    'SAMRUDDHA MINERALS & METALS PRIVATE LIMITED',
    'CUMMINS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'POONA RUBBER MANUFACTURERS PRIVATE LIMITED',
    'RELIANCE GEOTHERMAL POWER PRIVATE LIMITED',
    'EUROPA CHEMICALS ASIA PRIVATE LIMITED',
    'DR. SCHUMACHER INDIA PRIVATE LIMITED',
    'MULLER-BBM ACOUSTIC TECHNOLOGY PRIVATE LIMITED',
    'C AND F POLYMERS PRIVATE LIMITED',
    'EMUDHRA CONSUMER SERVICES LIMITED',
    'CASBY GLOBAL TECHNOLOGY PRIVATE LIMITED',
    'NUPOWER TECHNOLOGIES PRIVATE LIMITED',
    'KAY CHANDRA IRON ENGINEERING WORKS PRIVATE LIMITED',
    'PENNANT ENGINEERING PRIVATE LIMITED',
    'QUBIC SUNTRACK ENERGY SYSTEM PRIVATE LIMITED',
    'XYTEL INDIA PRIVATE LIMITED',
    'HALCYON LABS PRIVATE LIMITED',
    'MATRIX SOLUTIONS PRIVATE LIMITED',
    'INFINX SERVICES PRIVATE LIMITED',
    'CHEMSTAR ORGANICS (INDIA) LIMITED',
    'CUMMINS GENERATOR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ART PACK PRIVATE LIMITED',
    'CROWN CLOSURES PRIVATE LIMITED',
    'OMEGA PRODUCTS PRIVATE LIMITED',
    'RAJDEEP AUTOMATION PRIVATE LIMITED',
    'SPACECOM TECHNOLOGIES PRIVATE LIMITED',
    'ARCO ELECTRO TECHNOLOGIES PRIVATE LIMITED',
    'METROPOLITAN CEMENTS & TILES COMPANY PRIVATE LIMITED',
    'HITACHI ASTEMO INDIA PRIVATE LIMITED',
    'VENTILE COMPANY PRIVATE LIMITED',
    'MAHLE ANAND THERMAL SYSTEMS PRIVATE LIMITED',
    'SPECIAL STEELWIRE ROPES LIMITED',
    'TRANSPARENT TECHNOLOGIES PRIVATE LIMITED',
    'ANK PHARMA PRIVATE LIMITED',
    'PONDS EXPORTS LIMITED',
    'PUNE URBAN RECYCLERS PRIVATE LIMITED',
    'BAIDYANATH POWER PRIVATE LIMITED',
    'PKJ ENERGY PRIVATE LIMITED',
    'CHETTINAD AQUA RESOURCES PRIVATE LIMITED',
    'WELDFAST ELECTRODES PRIVATE LIMITED',
    'DIVINE MARKETING PRIVATE LIMITED',
    'LOKHANDWALA CONSTRUCTION INDUSTRIES PRIVATE LIMITED',
    'POOJA PROPERTIES PRIVATE LIMITED',
    'MEENAKSHI STEEL ROLLING MILLS PRIVATE LIMITED',
    'SUPREME OFFSHORE CONSTRUCTIONS AND TECHNICAL SERVICES LIMITED',
    'BALBIR ROLLING MILLS PRIVATE LIMITED',
    'ROCKWELL OVERSEAS PRIVATE LIMITED',
    'GLORIA ENTERPRISES LIMITED',
    'DAFFODIL CONSTRUCTIONS PRIVATE LIMITED',
    'NSSL PRIVATE LIMITED',
    'ASHIRWAD MINMET TRADING COMPANY PRIVATE LIMITED',
    'PROVINCIAL AUTOMOBILE COMPANY PRIVATE LIMITED',
    'CMS INFO SYSTEMS LIMITED',
    'AQUATECH SYSTEMS (ASIA) PRIVATE LIMITED',
    'SHREE BAL LAND DEVELOPERS PRIVATE LIMITED',
    'LANDSCAPE CONSTRUCTIONS PRIVATE LIMITED',
    'NL INFRASTRUCTURE AND PROJECTS PRIVATE LIMITED',
    'CONCO REALTY PRIVATE LIMITED',
    'SHREE SAWAN SPACES PRIVATE LIMITED',
    'KRE INFRA PRIVATE LIMITED',
    'KOKAN INFO SERVICES AND DEVELOPERS PRIVATE LIMITED',
    'VR VIDARBHA LIMITED',
    'R.M.BHUTHER & CO DEVELOPERS PRIVATE LIMITED',
    'SUVIRON PRODUCTS PRIVATE LIMITED',
    'VR MAJHA LIMITED',
    'L&T SEAWOODS LIMITED',
    'TETRON LA PRODUCTS PRIVATE LIMITED',
    'RELIANCE REALTY LIMITED',
    'PYROTEK INDIA PRIVATE LIMITED',
    'SIEMENS RAIL AUTOMATION PRIVATE LIMITED',
    'VNV ECO PROJECTS PRIVATE LIMITED',
    'HAITECH MEDICAL SOLUTIONS PRIVATE LIMITED',
    'INGRAM MICRO INDIA SSC PRIVATE LIMITED',
    'COLORPLUS REALTY LIMITED',
    'PARKEEN PNEUMATICS PVT LTD',
    'FORBES CAMPBELL FINANCE LIMITED',
    'INDYITALIA AUTO PRIVATE LIMITED',
    'MAGNUM DISTRIBUTORS PRIVATE LIMITED',
    'CABOCHON CREATIONS PRIVATE LIMITED',
    'PEPE JEANS INDIA LIMITED',
    'GF RENEWABLE ENERGY PRIVATE LIMITED',
    'KAY INDUSTRIAL GASES PRIVATE LIMITED',
    'PHEONIX IMPEX PRIVATE LIMITED',
    'THETA CONTROLS PRIVATE LIMITED',
    'HYDRO INDIA PRIVATE LIMITED',
    'TULIP INN CONSTRUWELL PRIVATE LIMITED',
    'HEMANT BUILDERS PRIVATE LIMITED',
    'STRONGBUILT CONSTRUCTIONS PRIVATE LIMITED',
    'DAVE IMPEX PRIVATE LIMITED',
    'AMBROSIA RESTAURANTS PRIVATE LIMITED',
    'CHIMERA INDUSTRIAL AND DEVELOPMENT PRIVATE LIMITED',
    'TOZAI SAFETY PRIVATE LIMITED',
    'VAMA MOTORS PRIVATE LIMITED',
    'CHETTINAD ELECTRONICS PRIVATE LIMITED',
    'K.CHHAGANLAL COMMODITIES PRIVATE LIMITED',
    'BIRLA GOLD AND PRECIOUS METALS LIMITED',
    'JACK & JILL APPAREL PRIVATE LIMITED',
    'SHREE NAGANI MERCANTILE PRIVATE LIMITED',
    'EXPORTERS (INDIA) LIMITED',
    'KUNDAN JEWELLERS PRIVATE LIMITED',
    'RAWLLEY HUMANCARE PROJECTS FOR LIFE FOUNDATION',
    'AFCAN IMPEX PRIVATE LIMITED',
    'CINETICO TECHNOLOGY PRIVATE LIMITED',
    'TEJI VINIMAY PRIVATE LIMITED',
    'TELYPORT TECHNOLOGIES PRIVATE LIMITED',
    'WAYDECOR TRADERS PRIVATE LIMITED',
    'NISPRATAPA CONSULTANCY SERVICES PRIVATE LIMITED',
    'KRISHNAPATNAM LOGISTICS PRIVATE LIMITED',
    'SHREYAA MEDILIFE PRIVATE LIMITED',
    'GALAXY TRADELINK PRIVATE LIMITED',
    'DHANI LOANS AND SERVICES LIMITED',
    'SAVAS ENGINEERING COMPANY PRIVATE LIMITED',
    'GRENEW EWASTE PRIVATE LIMITED',
    'ABHINANDAN TRADEX LIMITED',
    'GENNEXT INSURANCE BROKERS PRIVATE LIMITED',
    'ISHAAN MARKETING PRIVATE LIMITED',
    'RAJHANS PROCON PRIVATE LIMITED',
    'MALIN ONE APPLIED TECHNOLOGIES PRIVATE LIMITED',
    'SYNOPTEK INDIA PRIVATE LIMITED',
    'GLOBAL TECH (INDIA) PRIVATE LIMITED',
    'SHREE KAMDHENU ELECTRONICS PRIVATE LIMITED',
    'SAURABH SOFTSOURCING PRIVATE LIMITED',
    'TECSO RENEWABLE ENERGY INDIA PRIVATE LIMITED',
    'AARUSHI PACKAGING PRIVATE LIMITED',
    'ZEN PROPERTIES PVT LTD',
    'TULIP EXIM PRIVATE LIMITED',
    'ELDEE RESTAURANTS AND RESORTS PRIVATE LIMITED',
    'N STAR COMMOTRADE PVT LTD',
    'MBM TUBES PRIVATE LIMITED',
    'WINDAR RENEWABLE ENERGY PRIVATE LIMITED',
    'ASUTOSH INSTITUTE OF MEDICAL AND PARAMEDICAL SCIENCES PRIVATE LIMITED',
    'APEX DISTRIBUTORS PVT LTD',
    'TRADERS PRIVATE LIMITED',
    'HIGHWAY PROPERTIES PRIVATE LIMITED',
    'BHAGYA DEALTRADE PRIVATE LIMITED',
    'TALBROS AUTOMOTIVE COMPONENTS LIMITED',
    'PRAKASH INDUSTRIES LIMITED',
    'GODOLPHINE INDIA PRIVATE LIMITED',
    'VANSH ORGANICS LIMITED',
    'AVON BEAUTY PRODUCTS INDIA PRIVATE LIMITED',
    'BRILLON CONSUMER PRODUCTS PRIVATE LIMITED',
    'OSG (INDIA) PRIVATE LIMITED',
    'RAJU STORES PRIVATE LIMITED',
    'CHHATRALA INDIA HOTEL GROUPS PRIVATE LIMITED',
    'CATERPILLAR CARGO SOLUTIONS INDIA PRIVATE LIMITED',
    'G. N. G. INVESTMENT LIMITED',
    'NIDHI INVESTMENTS PRIVATE LIMITED',
    'ZYDUS INFRASTRUCTURE PRIVATE LIMITED',
    'TEADIT PACKING AND GASKETS PRIVATE LIMITED',
    'KRISH FERRO INDUSTRIES PRIVATE LIMITED',
    'BIMALDEEP MINERALS PRIVATE LIMITED',
    'URMI SOLAR SYSTEMS LIMITED',
    'SARLA MARKETING PRIVATE LIMITED',
    'CRANES SOFTWARE INTERNATIONAL LIMITED',
    'PURNIMA SECURITIES PRIVATE LIMITED',
    'EPSILON ENGINEERING LIMITED',
    'GTPL SK NETWORK PRIVATE LIMITED',
    'CRAIGMORE TEXTILES PRIVATE LIMITED',
    'LITELON PRIVATE LIMITED',
    'MOLEX (INDIA) PRIVATE LIMITED',
    'BEIL RESEARCH AND CONSULTANCY PRIVATE LIMITED',
    'S AND V EDUTRAINMENT VENTURES PRIVATE LIMITED',
    'ACCURATE SECURITIES AND REGISTRY PRIVATE LIMITED',
    'PRAKASH FOTOLAB LIMITED',
    'TRINETRA CONSTRUCTIONS PRIVATE LIMITED',
    'PCI MARKETING PVT LTD',
    'VAIGAI INVESTMENTS PRIVATE LIMITED',
    'BURNET INVESTMENTS PRIVATE LIMITED',
    'TIPCO INDUSTRIES PRIVATE LIMITED',
    'THAKRAL COMPUTERS PRIVATE LIMITED',
    'VECTRA INVESTMENTS PRIVATE LIMITED',
    'ALTAIR ENGINEERING INDIA PRIVATE LIMITED',
    'SUN-SIP LIMITED',
    'HILAB EQUIPMENTS PRIVATE LIMITED',
    'IMUSTI (INDIA) PRIVATE LIMITED',
    'EHES LIMITED',
    'S3 SOLUTIONS PRIVATE LIMITED',
    'JAMNA AUTO INDUSTRIES LIMITED',
    'SANTOSH PROPERTIES PRIVATE LTD',
    'SUNRIDER INDIA PRIVATE LIMITED',
    'EVERGREEN INTERNATIONAL LIMITED',
    'CAPSUGEL HEALTHCARE PRIVATE LIMITED',
    'SOFTWARE INDIA PRIVATE LIMITED',
    'KOTHARI INFOTECH PRIVATE LIMITED',
    'BALAJI TOOLS PRIVATE LIMITED',
    'WORLDTEL SPORTS INDIA PRIVATE LIMITED',
    'JOBSTREET.COM INDIA PRIVATE LIMITED',
    'G-CORP LOTUS MALL PRIVATE LIMITED',
    'MAHITI TECHNOLOGIES PRIVATE LIMITED',
    'INFITECH REALITY PRIVATE LIMITED',
    'ANKO CONSTRUCTION PRIVATE LIMITED',
    'EPSILON ELECTRONICS PRIVATE LIMITED',
    'ATRIA WIND POWER (AN) PRIVATE LIMITED',
    'JBJ PERFUMES PRIVATE LIMITED',
    'LEGEND RESORTS PRIVATE LIMITED',
    'DELTA CARRIERS PRIVATE LIMITED',
    'SENATOR INNS PRIVATE LIMITED',
    'PANCHWATI PROMOTERS PRIVATE LIMITED',
    'HVAC SYSTEMS PRIVATE LIMITED',
    'SUDMO-HMT PROCESS ENGINEERS (INDIA) LIMITED',
    'VIKRAM INFRATECH DEVELOPERS PRIVATE LIMITED',
    'DOTSMARK SYSTEMS INDIA LIMITED',
    'FORESTREE INDIA PRIVATE LIMITED',
    'PROPSHARE CAPITAL ADVISORS PRIVATE LIMITED',
    'TVS INVESTMENTS PRIVATE LIMITED',
    'PREDOMIX TECHNOLOGIES PRIVATE LIMITED',
    'LALIBA TECHNOLOGIES PRIVATE LIMITED',
    'MHASPL SERVICES PRIVATE LIMITED',
    'MEZZARIA JEWELS PRIVATE LIMITED',
    'ABODOS TECHNOLOGIES PRIVATE LIMITED',
    'MANIPAL NUTRACEUTICAL AND AGRO TECH PRIVATE LIMITED',
    'AGIN WEBSITE PRIVATE LIMITED',
    'APEXO PACKING MACHINE PRIVATE LIMITED',
    'KIDZLET PLAY STRUCTURES PRIVATE LIMITED',
    'TLH SERVICES PRIVATE LIMITED',
    'KHADYAM SPECIALITY FOODS PRIVATE LIMITED',
    'NYSH INNOVENTURES PRIVATE LIMITED',
    'KADAKKETH FARM PRODUCTS PRIVATE LIMITED',
    'FRISCO ORGANIC PRIVATE LIMITED',
    'SUCAFINA INDIA PRIVATE LIMITED',
    'INDIAPERSONAL TOURS PRIVATE LIMITED',
    'TROIS INFOTECH PRIVATE LIMITED',
    'FEDERATE CONTROLS INDIA PRIVATE LIMITED',
    'ALLSEAS LINE PRIVATE LIMITED',
    'MATCHING PANTS PRIVATE LIMITED',
    'VEDISTYA PRIVATE LIMITED',
    'CADILLAC LIFESCIENCES PRIVATE LIMITED',
    'EKO AIR FILTRATION INDIA PRIVATE LIMITED',
    'FABCON FENESTRATION PRIVATE LIMITED',
    'KPASM PRIVATE LIMITED',
    'SUBMIT CORE PRIVATE LIMITED',
    'PRODOQ INNOVATION PRIVATE LIMITED',
    'INNOVITI SMELENDING PRIVATE LIMITED',
    'UNIPADS INDIA PRIVATE LIMITED',
    'ALLCARGO WAREHOUSING MANAGEMENT PRIVATE LIMITED',
    'ADAM SCREW COMPRESSORS PRIVATE LIMITED',
    'AMMARA CRAFT MAESTROS PRIVATE LIMITED',
    'MANDORI REALTY PRIVATE LIMITED',
    'INVETERATE SOLUTIONS PRIVATE LIMITED',
    'ESTHER MARINE PRIVATE LIMITED',
    'MASG VALUATION SERVICES PRIVATE LIMITED',
    'NOTAMEDIA PRIVATE LIMITED',
    'MERCADEO MULTIVENTURES PRIVATE LIMITED',
    'GENEFIED BRAND PROTECTION SOLUTIONS PRIVATE LIMITED',
    'OXYS BEAUTY PRIVATE LIMITED',
    'SYGO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'EQ BIOMECHANICS PRIVATE LIMITED',
    'JJRS CONSTRUCTION PRIVATE LIMITED',
    'R.J. WAREHOUSING PRIVATE LIMITED',
    'EXICAA SERVICES PRIVATE LIMITED',
    'VIHIT FINANCERA PRIVATE LIMITED',
    'TB SPORTS NETWORK PRIVATE LIMITED',
    'EMPIRE BAKERY MACHINES PRIVATE LIMITED',
    'OPTIMISTA TRAINING & DEVELOPMENT INDIA PRIVATE LIMITED',
    'JACQUARD HARNESS CORD PRIVATE LIMITED',
    'TWAUDIO INDIA PRIVATE LIMITED',
    'ROVONIZE POWER SOLUTIONS PRIVATE LIMITED',
    'WEJOY PHONFIX PRIVATE LIMITED',
    'ID TECH FOUNDATION',
    'SRILAKSHMI AUTO ENTERPRISES INDIA PRIVATE LIMITED',
    'TIRUNVELI KAYATHAR PROJECT PRIVATE LIMITED',
    'GREENORB TRAVEL LIMITED',
    'SUN VISTA SPACES PRIVATE LIMITED',
    'DAANISH AVIATION & HR SOLUTIONS PRIVATE LIMITED',
    'FRISCO NUTRITION PRIVATE LIMITED',
    'SCINOX FINTECH LIMITED',
    'GOLDEN WARPING & SIZING FACILITY PRIVATELIMITED',
    'NUVOLT CHARGE PRIVATE LIMITED',
    'GROUNDTRUTH INDIA PRIVATE LIMITED',
    'BHIWANDI MULTIMODAL PRIVATE LIMITED',
    'TEJASWI SPACE SOLUTIONS PRIVATE LIMITED',
    'DATASOCLE TECHNOLOGIES PRIVATE LIMITED',
    'PLUS OFFICE SOLUTION PRIVATE LIMITED',
    'RVP STARCH PRODUCTS PRIVATE LIMITED',
    'TECVEC GLOBAL SOLUTIONS PRIVATE LIMITED',
    'BETAFLUX CONSULTING PRIVATE LIMITED',
    'DMAIC INNOVATIONS PRIVATE LIMITED',
    'LAKECITY HOSPITALITIES PRIVATE LIMITED',
    'SMILOVITIS SOLUTIONS PRIVATE LIMITED',
    'RENEWABLE WEG PARTS INDIA PRIVATE LIMITED',
    'ZIEVA FARM PRIVATE LIMITED',
    'INDCON MANUFACTURING PRIVATE LIMITED',
    'REALTY BUZZ PRIVATE LIMITED',
    'SOLZA SOFTWARE PRIVATE LIMITED',
    'VALUE SPACES LOGISTICS & INDUSTRIAL PARKPOLIVAKKAM PRIVATE LIMITED',
    'GOLDEN HORNCONTAINERS HUB PRIVATE LIMITED',
    'ETRIBE OFFICE SPACE SOLUTIONS PRIVATE LIMITED',
    'DBL PACHHWARA COAL MINE PRIVATE LIMITED',
    'IPETRONIK INDIA PRIVATE LIMITED',
    'WORTGAGE TECHNOLOGIES PRIVATE LIMITED',
    'CREATIGRITY TECHNOLOGIES PRIVATE LIMITED',
    'ARGENTS INFOSYSTEMS PRIVATE LIMITED',
    'ALVARION SECURITY SYSTEMS PRIVATE LIMITED',
    'FOUNDERPASSION FOUNDATION',
    'CANVIN INNOVATION PRIVATE LIMITED',
    'SWR WASTE MANAGEMENT PRIVATE LIMITED',
    'EPCOT DOWNTOWN VENTURES PRIVATE LIMITED',
    'SAMARK LEGAL SERVICES PRIVATE LIMITED',
    'APP IDEAS INFOTECH PRIVATE LIMITED',
    'ARTELLI SYSTEMS PRIVATE LIMITED',
    'JAYVIN MANAGEMENT SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'EMPENOFORE TECHNOLOGIES PRIVATE LIMITED',
    'PLUSTRADE HOLDING (IFSC) PRIVATE LIMITED',
    'AUTOMAGICALLY PERFECT SOLUTIONS PRIVATE LIMITED',
    'AMBEGEN PHARMACEUTICAL AND SERVICES PRIVATE LIMITED',
    'EPR DIGITAL SOLUTIONS PRIVATE LIMITED',
    'EDSTEAD INDIA PRIVATE LIMITED',
    'SWEET DREAMS OF ALBANY INDIA PRIVATE LIMITED',
    'FERRETTI EPC SOLUTIONS PRIVATE LIMITED',
    'DROOM EXPRESS PRIVATE LIMITED',
    'DILIGENCE FINTECH PRIVATE LIMITED',
    'SUNLIFE DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'KENKOH MASSAGE FOOTWEAR INDIA PRIVATE LIMITED',
    'BHATAI AUTOMATION (OPC) PRIVATE LIMITED',
    'CEA SOLUTIONS PRIVATE LIMITED',
    'MITHRA INCREST PRIVATE LIMITED',
    'ASS REFRIGERATOR PRIVATE LIMITED',
    'ACPC HEALTHCARE PRIVATE LIMITED',
    'BLACK TULIP INFOTECH PRIVATE LIMITED',
    'LAMPRE INDUSTEEL PRIVATE LIMITED',
    'PERE CONSULTANTS PRIVATE LIMITED',
    'VIAGGIO SERVICES PRIVATE LIMITED',
    'GOEL GANGA CORPORATION PRIVATE LIMITED',
    'ADMINWARE SOFTWARE PRIVATE LIMITED',
    'VYMANIKA CONSULTING PRIVATE LIMITED',
    'DEEPSTACK SOFTWARE PRIVATE LIMITED',
    'SUTRA TECH LABS PRIVATE LIMITED',
    'ENGENRIN ENERGY PRIVATE LIMITED',
    'FENIKKUSU INFRAPRO PRIVATE LIMITED',
    'ROYAL INNOVATION INDIA PRIVATE LIMITED',
    'THESIS SOCIAL INNOVATION STUDIO FOUNDATION',
    'NTGR INFRATECH PRIVATE LIMITED',
    'IDHYAH AGRI CROP SCIENCES PRIVATE LIMITED',
    'TRIPPING VIBE DIGITAL PRIVATE LIMITED',
    'ARECDL TECHNOLOGY PRIVATE LIMITED',
    'FORTIATE DATA SOLUTIONS PRIVATE LIMITED',
    'SLANTURE TECHNOLOGY PRIVATE LIMITED',
    'NDQUBE TECHNOLOGIES PRIVATE LIMITED',
    'AXON INFRALINK PRIVATE LIMITED',
    'PGI INDUSTRIES LIMITED',
    'DECORAX INDUSTRIES PRIVATE LIMITED',
    'SILVER STAR CITY MAINTENANCE ASSOCIATION',
    'SONREIR 4 U FOREX PRIVATE LIMITED',
    'ZIVONICS DIGITAL INDIA PRIVATE LIMITED',
    'NIRMITEE PROMAC CONSULTANTS PRIVATE LIMITED',
    'PHALANI FRESH PRIVATE LIMITED',
    'HALLMARK GREEN VENTURES PRIVATE LIMITED',
    'IORAS NETWORKS PRIVATE LIMITED',
    'XTERMINATE SOLUTIONS PRIVATE LIMITED',
    'ALPHACLARTE TRADING PRIVATE LIMITED',
    'MIKAS STAINLESS STEELS INDIA PRIVATE LIMITED',
    'HIPE BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'ASCENSION MULTIVENTURES PRIVATE LIMITED',
    'FASTPAY ONLINE INDIA PRIVATE LIMITED',
    'YOUNGACE PLASTIC AND FIBRE PRIVATE LIMITED',
    'TENCIL STRUCTURES INDIA PRIVATE LIMITED',
    'BOGU BUSINESS SERVICES PRIVATE LIMITED',
    'MEGHNAD INFRASPACES PRIVATE LIMITED',
    'NAMKALAM ONLINE MARKETPLACE AND SERVICESPRIVATE LIMITED',
    'MYSTIQUE BREWERIES PRIVATE LIMITED',
    'GRANIRE IMPEX (OPC) PRIVATE LIMITED',
    'ANAHAT FOR CHANGE FOUNDATION',
    'HONE STRUCTURAL HEALTH MONITORING (INDIA) PRIVATE LIMITED',
    'VYMIGRATE MIGRATION AND EDUCATION CONSULTANTS INDIA PRIVATE LIMITED',
    'SHEKHAWATI SOLAR PARK PRIVATE LIMITED',
    'HQL SOLUTIONS PRIVATE LIMITED',
    'AUSTRALASIAN MAIL SERVICES INDIA PRIVATELIMITED',
    'GATEWAY CONSTRO PRODUCTS PRIVATE LIMITED',
    'RSUCESS LADDER EVENT PRIVATE LIMITED',
    'HAG DEVELOPERS PRIVATE LIMITED',
    'ALPHACLARTE MULTIVENTURES PRIVATE LIMITED',
    'TEJAX SUPPORT SERVICES PRIVATE LIMITED',
    'SRINIVASA PAPER AGENCIES PRIVATE LIMITED',
    'KRAMERS CONSULTING PRIVATE LIMITED',
    'ZULA PROMOTERS PRIVATE LIMITED',
    'AEROLIFT FLYING SERVICES PRIVATE LIMITED',
    'INCYBITGLOBAL INFOTEC PRIVATE LIMITED',
    'CRUDO JUICERY PRIVATE LIMITED',
    'CHITRADURGA HATCHERIES PRIVATE LIMITED',
    'QUETZCO PRIVATE LIMITED',
    'LAMEL COVE PRIVATE LIMITED',
    'SOURCE DOCK PRIVATE LIMITED',
    'TECHWEDGE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MELIORISM SWITCHISM PRIVATE LIMITED',
    'TRIPPY WHEELS INTERNATIONAL PRIVATE LIMITED',
    'JAKSON GREEN RENEWABLE SERVICES PRIVATE LIMITED',
    'PROGATE ONLINE EDUCATION PRIVATE LIMITED',
    'A&M AGRI VENTURES PRIVATE LIMITED',
    'LZWL MOTORS INDIA PRIVATE LIMITED',
    'SARAIGHAT HERBAL AND ORGANIC PRODUCT PRIVATE LIMITED',
    'PADME HUM VENTURES PRIVATE LIMITED',
    'YUGASMITA INNOVATIONS PRIVATE LIMITED',
    'PUKKA FOODS AND SPIRITS PRIVATE LIMITED',
    'MARKET LOGIC SOFTWARE INDIA PRIVATE LIMITED',
    'SOUK MEDIA PRIVATE LIMITED',
    'MIRAJ RETAILS PRIVATE LIMITED',
    'NOVUM NAMPALLY PARKING PRIVATE LIMITED',
    'VEDICROOTS HOLISTIC LIVING PRIVATE LIMITED',
    'SWAEZER TECHNOLOGIES PRIVATE LIMITED',
    'GAJANAN MINING INDIA PRIVATE LIMITED',
    'OJAS SMART HOMES PRIVATE LIMITED',
    'ALQO SOLAR INDIA PRIVATE LIMITED',
    'KNOIT COMMUNITY CONNECT PRIVATE LIMITED',
    'CLICKNTAX CONSULTANCY PRIVATE LIMITED',
    'FEYNMAN PARTICLES PRIVATE LIMITED',
    'ACCELUR INTEGRATED PRIVATE LIMITED',
    'SUPER ADS CREATIVE MEDIA PRIVATE LIMITED',
    'VALUE SPACES ESTATES PRIVATE LIMITED',
    'REIRED BLS INTERNATIONAL SERVICES PRIVATE LIMITED',
    'INNER CIRCLE INVESTMENTS IMF PRIVATE LIMITED',
    'FOX DEAN ESTATES PRIVATE LIMITED',
    'MAGELLAN EXPRESS LOGISTICS PRIVATE LIMITED',
    'ASTREK INNOVATIONS PRIVATE LIMITED',
    'O2F CLOUD SERVICES PRIVATE LIMITED',
    'BERRYLUSH DESIGNS PRIVATE LIMITED',
    'RSYA DHANBAD AUTO PRIVATE LIMITED',
    'ABHIPRAJ INNOVATIVE FRUITS PRIVATE LIMITED',
    'GOONCHA MOTORS PRIVATE LIMITED',
    'OMBHU KRISHIYOGI INDIA PRIVATE LIMITED',
    'YANASEN INDIA PRIVATE LIMITED',
    'OILTANKING INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'BIZSUITZ TECHNOLOGIES PRIVATE LIMITED',
    'MUKUL GUPTA MARKETING PRIVATE LIMITED',
    'JOBSYAHAN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PLUNGE CAPITAL PRIVATE LIMITED',
    'TRIP JACK PRIVATE LIMITED',
    'SNIPEBRIDGE INDIA PRIVATE LIMITED',
    'RAKSHA AVENUES PRIVATE LIMITED',
    'PANKAJ PLASTIC INDUSTRIES PRIVATE LIMITED',
    'ARMIDRA PRIVATE LIMITED',
    'NEXG IOT SOLUTIONS PRIVATE LIMITED',
    'THINKITIVE GLOBAL CONSULTING PRIVATE LIMITED',
    'VENKADAMBAL PROPERTY MANAGEMENT PRIVATE LIMITED',
    'VIVID ART FLAVOURS PRIVATE LIMITED',
    'INTRON LIFE SCIENCES PRIVATE LIMITED',
    'TSOTE FOODS PRIVATE LIMITED',
    'PEOPLE HELPING PEOPLE IMF PRIVATE LIMITED',
    'EXCELLENCE MARINE RESOURCES AND SERVICESPRIVATE LIMITED',
    'AIC-SELCO FOUNDATION',
    'DOIT SMART TRANSIT DEVELOPMENT (INDIA) PRIVATE LIMITED',
    'CUMINT TECHNOLOGIES PRIVATE LIMITED',
    'SHEBOSS PRIVATE LIMITED',
    'SMALL TOWN STARTUPS PRIVATE LIMITED',
    'WELSPUN ROAD INFRA PRIVATE LIMITED',
    'KULFI VENTURES PRIVATE LIMITED',
    'CAPT. SHAILESH RIALCH FOUNDATION',
    'INFINIDAT IT INDIA PRIVATE LIMITED',
    'MKS CORPORATE SERVICES PRIVATE LIMITED',
    'WWW WEOFFER INDIA PRIVATE LIMITED',
    'AHAA PRODUCTIONS (OPC) PRIVATE LIMITED',
    'REDPRO CONSUMER PRODUCTS PRIVATE LIMITED',
    'HA INFRACON PRIVATE LIMITED',
    'AWLENCAN INNOVATIONS INDIA LIMITED',
    'ARKFIN HOUSING FINANCE PRIVATE LIMITED',
    'DFAB STAINLESS SYSTEM PRIVATE LIMITED',
    'MEYN INDIA PRIVATE LIMITED',
    'SAMVARDHANA MOTHERSON MAADHYAM INTERNATIONAL LIMITED',
    'VASTU FINSERVE INDIA PRIVATE LIMITED',
    'NIKIAS INTEGRATED SOLUTIONS (OPC) PRIVATE LIMITED',
    'VIRTUAL VERITY SCALE PRIVATE LIMITED',
    'TABLETS GLOBALCARE PRIVATE LIMITED',
    'POCKET FM PRIVATE LIMITED',
    'DYOCENSE TECHNOLOGIES PRIVATE LIMITED',
    'QUADRILLION FINANCE PRIVATE LIMITED',
    'RUPAREL BUILDMAX PRIVATE LIMITED',
    'HAFTE DENK MOTOREN INDIS PRIVATE LIMITED',
    'VINEGARDEN FILMS PRIVATE LIMITED',
    'ADHIIPA TECHNOLOGIES PRIVATE LIMITED',
    'CONNECTWISE INDIA PRIVATE LIMITED',
    'REMIT INFOSYSTEMS PRIVATE LIMITED',
    'KIRTAN OVERSEAS PRIVATE LIMITED',
    'MINMETCOM TRADING PRIVATE LIMITED',
    'CEREBRA SKILLS ACADEMY PRIVATE LIMITED',
    'BAZANA FOODS PRIVATE LIMITED',
    'VINWORLD HEALTHCARE PRIVATE LIMITED',
    'WHOLE SOLAR PRIVATE LIMITED',
    'CLOSETTRUNK PRIVATE LIMITED',
    'BIM SOFTECH ENGINEERING CONSULTANT PRIVATE LIMITED',
    'TAHA CARBO MODIFIERS PRIVATE LIMITED',
    'EGISS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'LACKEYS MULTIVENTURE PRIVATE LIMITED',
    'VIKTWA SOLUTIONS PRIVATE LIMITED',
    'KHG HEALTH SERVICES PRIVATE LIMITED',
    'TOMINI SHIPPING PRIVATE LIMITED',
    'KULARIA BROTHERS TURNKEY PROJECTS PRIVATE LIMITED',
    'KELVIN NATURAL MINT PRIVATE LIMITED',
    'MAHEBA BUILDCON PRIVATE LIMITED',
    'EAGLE REGENCY HIGHWAYS PRIVATE LIMITED',
    'IFID INSTITUTE OF FASHION & INTERIOR DESIGN PRIVATE LIMITED',
    'THALUS TECHNOLOGIES PRIVATE LIMITED',
    'SUPERDESK E-THRUST SERVICES PRIVATE LIMITED',
    'INMACO MARITIME COUNCIL',
    'KVRIKSH TECHNOLOGIES PRIVATE LIMITED',
    'OAKRIDGE ROOFTOPS PRIVATE LIMITED',
    'IABA HOUSING PRIVATE LIMITED',
    'BORANK ENTERPRISES PRIVATE LIMITED',
    'NEOASTRA SYSTEMS INDIA PRIVATE LIMITED',
    'STRING METAVERSE LIMITED',
    'EXIDE ENERGY PRIVATE LIMITED',
    'ADVIVIFY MEDIA PRIVATE LIMITED',
    'GLOBSYNC INFRASTRUCTURE PRIVATE LIMITED',
    'GREENFINCH DEVELOPERS PRIVATE LIMITED',
    'FIDDOLIN MUSICAL GOODS PRIVATE LIMITED',
    'ANATOMIZ3D MEDTECH PRIVATE LIMITED',
    'APPL DEFENCE AND TELECOMMUNICATIONS PRIVATE LIMITED',
    'FINIF LABORATORIES PRIVATE LIMITED',
    'WALKING TREE RESOURCES PRIVATE LIMITED',
    'CARAPACE FACIMAN PRIVATE LIMITED',
    'DALISAY BAKERS INDIA PRIVATE LIMITED',
    'TENSOR DYNAMICS PRIVATE LIMITED',
    'HATCH PROJECT PRIVATE LIMITED',
    'DIETES BIOTECH (OPC) PRIVATE LIMITED',
    'TRILLIUM BEVERAGES PRIVATE LIMITED',
    'GUNNO APPARELS PRIVATE LIMITED',
    'C3WARE MULTICALL TECHNOLOGIES PRIVATE LIMITED',
    'ARTEMIS CARS INDIA PRIVATE LIMITED',
    'YESENVEE BUSINESS SERVICES PRIVATE LIMITED',
    'ILP PRIVATE LIMITED',
    'SINGHI IP SOLUTIONS PRIVATE LIMITED',
    'QOLARIS DATA INDIA PRIVATE LIMITED',
    'INDOPHIL JETTECH ENERGY PRIVATE LIMITED',
    'SUCCESS SHOWS PRIVATE LIMITED',
    'RANKONE FACILITIES SERVICES PRIVATE LIMITED',
    'NBS DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'INSTARAMA TECHNOLOGIES PRIVATE LIMITED',
    'ELMIN MEDIA PRIVATE LIMITED',
    'NIZEROLLES SYSTEMS ELECTRONICS INDIA PRIVATE LIMITED',
    'BOOK MY BIKE PRIVATE LIMITED',
    'AMPDILTIX LABS PRIVATE LIMITED',
    'BABAJI SNACKS PRIVATE LIMITED',
    'TEK NINJAS PRIVATE LIMITED',
    'CENTIUM HOMES PRIVATE LIMITED',
    'CONSENTA(INDIA) OUTSOURCING PRIVATE LIMITED',
    'SRK BHARAT VIDYUT PRIVATE LIMITED',
    'FINEVO GROWTH VENTURES PRIVATE LIMITED',
    'AZENDOR CONSULTING PRIVATE LIMITED',
    'FIRSTSQUAWK INFO SOLUTIONS PRIVATE LIMITED',
    'TRABELL TECHNOLOGIES PRIVATE LIMITED',
    'MAYUMANI AEROTECH PRIVATE LIMITED',
    'JASNO SOLUTIONS (OPC) PRIVATE LIMITED',
    'SHAKAMBHARI BRIJMAN PRIVATE LIMITED',
    'SACHI SUPERMARTS PRIVATE LIMITED',
    'RAJESH KHANNA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'LAVEGA RESORTS (OPC) PRIVATE LIMITED',
    'AIRYSOLE FOOTWEAR PRIVATE LIMITED',
    'PODAR EDUCATION PRIVATE LIMITED',
    'AMERIC TECHNOLOGY CONSULTING PRIVATE LIMITED',
    'RATHIK INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED',
    'EMOGIK TECHNOLOGICAL SOLUTIONS PRIVATE LIMITED',
    'LOGISYZ TECH PRIVATE LIMITED',
    'MIRELZ AI PRIVATE LIMITED',
    'VISHUDDHA MEDIA PRIVATE LIMITED',
    'INTGENI SMARTTECH PRIVATE LIMITED',
    'REFPAY MEDIA PRIVATE LIMITED',
    'VALUES SPACES REALTORS PRIVATE LIMITED',
    'OCM INDIA OPPORTUNITIES ARC MANAGEMENT PRIVATE LIMITED',
    'BENKI TECHNOLOGIES PRIVATE LIMITED',
    'KARNAL PHARMA PARK PRIVATE LIMITED',
    'FOCUSPOINT ADVISORS PRIVATE LIMITED',
    'CARING XL CONSULTANTS PRIVATE LIMITED',
    'KITEX KIDSWEAR LIMITED',
    'INTACT360 INDUSTRIES PRIVATE LIMITED',
    'SRRS PUBLISHING INFINITY PRIVATE LIMITED',
    'DADANA TECHNOLOGIES PRIVATE LIMITED',
    'PHAROX GLOBAL PRIVATE LIMITED',
    'BALAJI MEDVISTA INDIA PRIVATE LIMITED',
    'RGLOBITS INDIA PRIVATE LIMITED',
    'JAK INFRA REAL ESTATE PRIVATE LIMITED',
    'RADICAL AFTERMARKET SERVICES PRIVATE LIMITED',
    'SWEETCHILLIE TECHNOLOGIES PRIVATE LIMITED',
    'QUAL2QUANT STRATEGY AND CONSULTING (OPC)PRIVATE LIMITED',
    'AUDIX TECHNO CONSULTING SOLUTIONS PRIVATE LIMITED',
    'VPS PROFESSIONALS PRIVATE LIMITED',
    'BILLIONOVATIVE MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'EINSOL CONTROL SOLUTIONS PRIVATE LIMITED',
    'GGRM INNOVATIONS INDIA PRIVATE LIMITED',
    'ELYSIREALITY PRIVATE LIMITED',
    'KTC CONSULTING & ADVISORY (OPC) PRIVATE LIMITED',
    'SHIRINA INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED',
    'TWIN PIXCEL TECHNOLOGIES PRIVATE LIMITED',
    'ZEYE SECURITY SOLUTION PRIVATE LIMITED',
    'ZARIA PHARMACEUTICALS PRIVATE LIMITED',
    'INDEEVER INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED',
    'COGNIGIC INFOTECH PRIVATE LIMITED',
    'TOPSUN LEARNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'SAXAM AUTO-TECH PRIVATE LIMITED',
    'INVEN STANDARD PROJECTS PRIVATE LIMITED',
    'DIGICITI ONLINE IMC (OPC) PRIVATE LIMITED',
    'SORBITOL TRANSMISSION PRIVATE LIMITED',
    'BBGIAN VENTURES PRIVATE LIMITED',
    'DEWDRY ENGINEERS PRIVATE LIMITED',
    'ADISHWAR TELE-NETWORKS PRIVATE LIMITED',
    'KRABON ENTERPRISES PRIVATE LIMITED',
    'COREDEVIANT TECHNOLOGIES PRIVATE LIMITED',
    'CLEANLABEL ORGANICS PRIVATE LIMITED',
    'DATAVOX PRIVATE LIMITED',
    'MEYLAH TECHNOLOGIES PRIVATE LIMITED',
    'IVRBOX COMMUNICATIONS PRIVATE LIMITED',
    'MULTIADS GLOBAL PRIVATE LIMITED',
    'J.C.BAMFORD INVESTMENTS PRIVATE LIMITED',
    'NDEDGE INFORMATICS PRIVATE LIMITED',
    'TECHNO 5 MEDIA INDUSTRIES (I) PRIVATE LIMITED',
    'ACTIGEAR VENTURES PRIVATE LIMITED',
    'MR QUICKSERV INDIA PRIVATE LIMITED',
    'DEEKSHANT INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED',
    'TUNERLABS CONSULTING PRIVATE LIMITED',
    'VANSUN MEDIATECH PRIVATE LIMITED',
    'HOLIDAY BY JOURNEY SELLERS PRIVATE LIMITED',
    'HOLIDAYZZZ INTERNATIONAL AND DOMESTIC TOUR OPERATORS (OPC) PRIVATE LIMITED',
    'PROJECT91 ADVANCE TECHNOLOGIES PRIVATE LIMITED',
    'CONTEZY MEDIA PRIVATE LIMITED',
    'CLOUDCHEF PRIVATE LIMITED',
    'DARKHORSE LINK PRIVATE LIMITED',
    'FABUS PHARMACEUTICALS PRIVATE LIMITED',
    'NIRVAAN FOUNDATION OF SKILL DEVELOPMENT',
    'AMBICON VENTURES PRIVATE LIMITED',
    'SCHROCKEN INDIA PRIVATE LIMITED',
    'AFTERBURNER DENTAL TECHNOLOGIES PRIVATE LIMITED',
    'EGME ENERGY ECOSYSTEMS (INDIA) PRIVATE LIMITED',
    'SENSEBITE DESIGN STUDIOJ PRIVATE LIMITED',
    'SUVEN PHARMACEUTICALS LIMITED',
    'CUSAK PHARMA PRIVATE LIMITED',
    'RAIVAT IMPEX PRIVATE LIMITED',
    'VASYSTRON TECKNOWLOGIES PRIVATE LIMITED',
    'MICKLU TECHNOLOGY PRIVATE LIMITED',
    'CLOUDGEN DIGITAL PRIVATE LIMITED',
    'UNISQUAD SOLUTIONS PRIVATE LIMITED',
    'PHYTRON MOBILITY PRIVATE LIMITED',
    'FLYWORK INNOVATIONS PRIVATE LIMITED',
    'BUDDING BRANDS PRIVATE LIMITED',
    'MADGENIUS BRANDWORKS PRIVATE LIMITED',
    'EDUGAON EDUCATION AND INNOVATION LABS PRIVATE LIMITED',
    'ARABELLA ONCO CARE PRIVATE LIMITED',
    'PHENOM FASHION PRIVATE LIMITED',
    'THRIVESOL RENEWABLES (RANCHI) PRIVATE LIMITED',
    'SOLINO HOME PRIVATE LIMITED',
    'FLAVINLABS PRIVATE LIMITED',
    'TANDEM MEDIA PRIVATE LIMITED',
    'LOXY INFRASTRUCTURE PRIVATE LIMITED',
    'MORSAP PRIVATE LIMITED',
    'SQUAD CITY INFRA PRIVATE LIMITED',
    'GHS INFRASTRUCTURE PRIVATE LIMITED',
    'CUREBOAT HEALTHCARE PRIVATE LIMITED',
    'URBAN PEACE PRIVATE LIMITED',
    'FATIMA INTERIOR SOLUTION PRIVATE LIMITED',
    'PALMATE TECHNOLOGIES PRIVATE LIMITED',
    'ALGOBRAINS TECHNOLOGIES PRIVATE LIMITED',
    'NESTAVERA VENTURES PRIVATE LIMITED',
    'TRUEBLUE IT CONSULTING SERVICES PRIVATE LIMITED',
    'QUANTUMWIZ ADVISORY SERVICES PRIVATE LIMITED',
    'MARK & JOE ENGINEERING INDUSTRIES PRIVATE LIMITED',
    '3D PRINTING ASSOCIATION OF INDIA',
    'THREEFOLD BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VISIONARCH TECHNOLOGIES PRIVATE LIMITED',
    'NIDHI FREIGHT LINES PRIVATE LIMITED',
    'GLOBAL WATER PROJECTS PRIVATE LIMITED',
    'CONCORD COMFORT SERVICES PRIVATE LIMITED',
    'TECHFINIX PRIVATE LIMITED',
    'MYPULSE.IO PRIVATE LIMITED',
    'COEP ENVIRO SOLUTIONS PRIVATE LIMITED',
    'WETEC AUTOMATION INDIA PRIVATE LIMITED',
    'ZBC BEARINGS INDIA PRIVATE LIMITED',
    'AASHU TELECOM PRIVATE LIMITED',
    'SECUREDIBS TECHNOLOGIES PRIVATE LIMITED',
    'BENCARDO BATHWARE INDIA PRIVATE LIMITED',
    'SERVLYNK RESOURCES PRIVATE LIMITED',
    'DENZAI INNOVATIONS & THERAPEUTICS PRIVATE LIMITED',
    'WISE GYPSIES PRIVATE LIMITED',
    'VEDAM TECHNOLOGIES PRIVATE LIMITED',
    'ZEFFU TECHNOLOGIES PRIVATE LIMITED',
    'COGNITEO CONSULTANTS PRIVATE LIMITED',
    'SUNTRION TECHNOSOL PRIVATE LIMITED',
    'NEW ERA FILMS PRODUCTION (OPC) PRIVATE LIMITED',
    'TRIKONA ENERGY PRIVATE LIMITED',
    'STELLARYS INFOTECH PRIVATE LIMITED',
    'ADANI SKILL DEVELOPMENT CENTRE',
    'HOSTING WORLD PRIVATE LIMITED',
    'BLUENILE REALTY PRIVATE LIMITED',
    'BOXANIA INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'JAX BELLEZA PRODUCTS PRIVATE LIMITED',
    'BUSINESS AIRCRAFT MANAGEMENT SERVICES PRIVATE LIMITED',
    'RESOURCES CAREER PORTAL PRIVATE LIMITED',
    'VMAK MULTIMEDIA PRIVATE LIMITED',
    'EPA2 TECHNOLOGY PRIVATE LIMITED',
    'SKEDOOL IT PRIVATE LIMITED',
    'FPL NOKERO INDIA PRIVATE LIMITED',
    'SCUBE ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'KAPL CHEMICALS PRIVATE LIMITED',
    'SAVINAYA INFRATECH PRIVATE LIMITED',
    'TRANSCOAL IMPEX PRIVATE LIMITED',
    'TCIS (INDIA) PRIVATE LIMITED',
    'ALLEGIANCE GLOBAL IMF PRIVATE LIMITED',
    'REALITYTIGER MARKETING SERVICES PRIVATE LIMITED',
    'OMNINO SOLUTIONS PRIVATE LIMITED',
    'SMOLLAN INDIA TECHNOLOGY PRIVATE LIMITED',
    'BRAND ICON PRIVATE LIMITED',
    'BHUGOL ANALYTICS PRIVATE LIMITED',
    'GELCON INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'TECHBERRY INFOTECH PRIVATE LIMITED',
    'ABM TRANSLINE PRIVATE LIMITED',
    'NOVYY TECHNOLOGIES PRIVATE LIMITED',
    'WIKTA IT SERVICES PRIVATE LIMITED',
    'MAC STATION PRIVATE LIMITED',
    'ISQUARE ABSOLUTE PRIVATE LIMITED',
    'SIGMATIX TECHNOLOGIES PRIVATE LIMITED',
    'EMRAIL ENGINEERING AND CONSTRUCTION PRIVATE LIMITED',
    'HAMMER PRICE ADVISERS PRIVATE LIMITED',
    'SPRUCE PAX PRIVATE LIMITED',
    'TERRA BLUE EXPLORATION TECHNOLOGIES PRIVATE LIMITED',
    'SATVANA SUPPLY PRIVATE LIMITED',
    'LEAF PHARMA PRIVATE LIMITED',
    'AARIHA ENTERPRISE PRIVATE LIMITED',
    'REVATURE CONSULTANCY SERVICES PRIVATE LIMITED',
    'SUNAURA TECHNOLOGIES PRIVATE LIMITED',
    'GESIA IT ASSOCIATION',
    'DELOSTYLE STUDIO PRIVATE LIMITED',
    'SYNERGIC SAFETY (INDIA) PRIVATE LIMITED',
    'VALVOLINE LUBRICANTS & SOLUTIONS INDIA PRIVATE LIMITED',
    'FINSTONE GRANITO PRIVATE LIMITED',
    'SPOWERZ SOLUTIONS PRIVATE LIMITED',
    'J.S.LEADS TECHNOLOGIES PRIVATE LIMITED',
    'SADBHAV RUDRAPUR HIGHWAY LIMITED',
    'TVISHA SYSTEMS PRIVATE LIMITED',
    'ADVINTEL MEDICARE PRIVATE LIMITED',
    'SRIJAY ENGINEERING AND CONSULTANTS PRIVATE LIMITED',
    'VCM AGENCIES PRIVATE LIMITED',
    'AZURE POWER THIRTY THREE PRIVATE LIMITED',
    'KTM ENERGY EXPERTS (INDIA) PRIVATE LIMITED',
    'CASHLESS BAZAR PRIVATE LIMITED',
    'EXPERTDARTS SERVICES PRIVATE LIMITED',
    'CHANDRAKANTANDCO TRADE SERVICES PRIVATE LIMITED',
    'VARION FOODSCIENCES PRIVATE LIMITED',
    'BLUEPINEFOODS PRIVATE LIMITED',
    'MASTI ORGANIC FARMS PRIVATE LIMITED',
    'SCOUT AGRO INDUSTRIES PRIVATE LIMITED',
    'MALIHABAD MANGO FARMER PRODUCER COMPANY LIMITED',
    'VEGSO FOODS PRIVATE LIMITED',
    'ACME DEOGHAR SOLAR POWER PRIVATE LIMITED',
    'ALPS BEST EXPORTS PRIVATE LIMITED',
    'PROPELLERS TRADE & TRANSITION PRIVATE LIMITED',
    'RSD DAIRY PRIVATE LIMITED',
    'UTKARSH SMALL FINANCE BANK LIMITED',
    'MRT INFO TECHNOLOGIES PRIVATE LIMITED',
    'PROTONCLOUD TECHNOLOGIES PRIVATE LIMITED',
    'AVIYO MEDISYS PRIVATE LIMITED',
    'CARE DATA INFOMATICS PRIVATE LIMITED',
    'VISHWAK PROJECTS PRIVATE LIMITED',
    'ARC INFOSYSTEMS INDIA PRIVATE LIMITED',
    '64 CODON PRIVATE LIMITED',
    'DIVRIT CONSULTANCY PRIVATE LIMITED',
    'RIGHT STEPS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'METADESIGN SUGAR PRIVATE LIMITED',
    'ELOGICSQUARE ANALYTICS PRIVATE LIMITED',
    'EMPRESSA LEGAL PRIVATE LIMITED',
    'KREATE LIGHTS PRIVATE LIMITED',
    'CLINICAL INFOTECH PRIVATE LIMITED',
    'RUBANBRIDGE PRIVATE LIMITED',
    'EUNIMART MULTICHANNEL PRIVATE LIMITED',
    'ONE POINT PROPERTIES AND AUCTION SERVICES PRIVATE LIMITED',
    'ZEPTO ZETTA SOLUTIONS PRIVATE LIMITED',
    'EPRODTECH SERVICES PRIVATE LIMITED',
    'NAVAYUGA AGRICROP PRIVATE LIMITED',
    'PHI PROPERTY MANAGEMENT SERVICES PRIVATELIMITED',
    'KAYMAN VENTURES PRIVATE LIMITED',
    'ELEMENT VALUE PRIVATE LIMITED',
    'SAKSHAM INTERIORS PRIVATE LIMITED',
    'WATSON GLOBAL LOGISTICS PRIVATE LIMITED',
    'OMSL INTERNATIONAL PRIVATE LIMITED',
    'VITTA BUSINESS CONSULTING PRIVATE LIMITED',
    'SMARTEK21 PRIVATE LIMITED',
    'YOGHEM PACKAGING INDIA PRIVATE LIMITED',
    'OJAS TOWNSHIPS PRIVATE LIMITED',
    'COUPLOR TECHNOLOGIES PRIVATE LIMITED',
    'LOKYAM AGRO PRODUCTS AND FOODS PRIVATE LIMITED',
    'LTECH SOLUTIONS PRIVATE LIMITED',
    'THOUGHTGENESIS TECHNOLOGIES PRIVATE LIMITED',
    'AQUILLA DIGITAL PRIVATE LIMITED',
    'VAC DIGITAL COMMUNICATIONS PRIVATE LIMITED',
    'SHIRETECHNIK SOLUTIONS PRIVATE LIMITED',
    'HOSCONS HEALTHCARE INDIA PRIVATE LIMITED',
    'SILVERAPPLE ENTERTAINMENT PRIVATE LIMITED',
    'SWIFTACE TECHNOLOGIES PRIVATE LIMITED',
    'EASTON MEDIA PRIVATE LIMITED',
    'MOOL PROJECT FOUNDATION',
    'ANVAYAA KIN CARE PRIVATE LIMITED',
    'ISB BEARING INDIA PRIVATE LIMITED',
    'MAA OM LOGISTICS MUMBAI EXPORTS PRIVATE LIMITED',
    'SPLODE PRIVATE LIMITED',
    'VISENS FOOD & BEVERAGES PRIVATE LIMITED',
    'AIPS REAL ESTATE & ADVISORY SERVICES PRIVATE LIMITED',
    'KN TECH INFRA PRIVATE LIMITED',
    'KHH BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'BALBHADRA DEVELOPERS PRIVATE LIMITED',
    'CLADDWELL SOLUTIONS PRIVATE LIMITED',
    'PHYMATIC TECHNOLOGIES PRIVATE LIMITED',
    'OPELOX TECHNOLOGIES PRIVATE LIMITED',
    'DARWIN TRAVEL TECH PRIVATE LIMITED',
    'NEXT PAGE TECHNOLOGIES PRIVATE LIMITED',
    'BM EKTA INDUSTRIES INDIA LIMITED',
    'EDUCATION MAXIMUM PRIVATE LIMITED',
    'INSTACUPPA SERVICES PRIVATE LIMITED',
    'TECHBONGO INFORMATICS PRIVATE LIMITED',
    'BOUNDLESS ENVIRONMENT RESOURCE SOLUTIONSPRIVATE LIMITED',
    'FANTASY STUDIO INDIA PRIVATE LIMITED',
    'NEWSONRUN MEDIA PRIVATE LIMITED',
    'ARIS BRANDS PRIVATE LIMITED',
    'NISTAPP (INDIA) PRIVATE LIMITED',
    'DLF POWER & SERVICES LIMITED',
    'ES SUN POWER PRIVATE LIMITED',
    'PHILI-ORIENT LOGISTICS PRIVATE LIMITED',
    'FOODLINK F&B HOLDINGS (INDIA) PRIVATE LIMITED',
    'INSTERACT TECHNOLOGIES PRIVATE LIMITED',
    'PROVENIO CAPITAL ADVISORS PRIVATE LIMITED',
    'KITCHEN HOUSE SOLUTIONS PRIVATE LIMITED',
    'ONE PLACE INDIA SALES PRIVATE LIMITED',
    'WORLD SILVER COUNCIL',
    'GOOFOOTY INTERACTIVE PRIVATE LIMITED',
    'PLAY MY MOVIE PRIVATE LIMITED',
    'G&CC MANAGEMENT SERVICES PRIVATE LIMITED',
    'CERES BIOSYSTEMS UP PRIVATE LIMITED',
    'INTANDEM SOLUTIONS PRIVATE LIMITED',
    'ARM & HAMMER ANIMAL NUTRITION PRIVATE LIMITED',
    'START ADMISSION PRIVATE LIMITED',
    'GTSS INFRASTRUCTURE PRIVATE LIMITED',
    'SPACEMYSTIQUE PRIVATE LIMITED',
    'CAREERPLUS PLACEMENTS PRIVATE LIMITED',
    'WAAYS & SOLUTIONS PRIVATE LIMITED (OPC)',
    'UNIWORTH COMPLEX PRIVATE LIMITED',
    'NEARBY TECHNOLOGIES PRIVATE LIMITED',
    'PANELLA FOODS AND BEVERAGES PRIVATE LIMITED',
    'GAMEPLAN TOWER PRIVATE LIMITED',
    'DRISHTI NIWAS PRIVATE LIMITED',
    'OPT-SOURCE TECHNOLOGIES PRIVATE LIMITED',
    'WOWTRUCK TECHNOLOGIES PRIVATE LIMITED',
    'MAGHARAM KULARIA FOUNDATION',
    'UNIVERSAL SEAT COVERS LIMITED',
    'AGARAA FOOD AND BEVERAGES PRIVATE LIMITED',
    'SHAMBHAVI SINGH DESIGNS PRIVATE LIMITED',
    'DIES DEVCON PRIVATE LIMITED',
    'CIRCULAR NIWAS PRIVATE LIMITED',
    'REBANTA DESIGN AND SOURCING SOLUTIONS PRIVATE LIMITED',
    'SHRISIDDHIVINAYAK MICRO FINANCE FOUNDATION',
    'RENTAL STAY PRIVATE LIMITED',
    'CAFS INDIA GLOBAL PRIVATE LIMITED',
    'SBM GREENWORLD PRIVATE LIMITED',
    'JALANKUR FARMS INDIA PRIVATE LIMITED',
    'BRANDSPOKE (INDIA) PRIVATE LIMITED',
    'SIMONA INDIA PRIVATE LIMITED',
    'KYNETEC DATA SERVICES PRIVATE LIMITED',
    'RESPONSIBLE FILMS FOUNDATION',
    'CANON MANPOWER SERVICES PRIVATE LIMITED',
    'AV XPLORE PRIVATE LIMITED',
    'INFINITY SPARK INDIA PRIVATE LIMITED',
    'ARKYMINDS SOLUTIONS PRIVATE LIMITED',
    'TECHPOWER ENERGY SERVICES PRIVATE LIMITED',
    'TECHILA GLOBAL SERVICES LIMITED',
    'AUREOLA TRADEMAN PRIVATE LIMITED',
    'CHIRAMEL NIDHI LIMITED',
    'GIRNAR INSURANCE BROKERS PRIVATE LIMITED',
    'SITARAM HEALTHCARE PRIVATE LIMITED',
    'SINDHU FLORAA PRIVATE LIMITED',
    'ACCORD DISPLAY SERVICES PRIVATE LIMITED',
    'TA RULE TECHNOLOGY PRIVATE LIMITED',
    'KOMPRISE INDIA PRIVATE LIMITED',
    'INDISPARROW TECHNOLOGIES PRIVATE LIMITED',
    'DIVRT (INDIA) PRIVATE LIMITED',
    'ONE.IN DIGITECH MEDIA PRIVATE LIMITED',
    'TECHMANYATA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SWIFT TECHNO CRAFTS PRIVATE LIMITED',
    'WALDNER INDIA PRIVATE LIMITED',
    'TELEMARINE PRIVATE LIMITED',
    'MTS EASY FIN SOLUTIONS PRIVATE LIMITED',
    'CAPEX FINVEST SERVICES PRIVATE LIMITED',
    'S. V. ENGINEERING & EQUIPMENTS PRIVATE LIMITED',
    'BLUM INDIA PRIVATE LIMITED',
    'FURTADOS HIGH MUSIC PRIVATE LIMITED',
    'BHUBANESWAR SMART CITY LIMITED',
    'GOMA PROCESS TECHNOLOGIES PRIVATE LIMITED',
    'SOLARIZE RENEWABLES PRIVATE LIMITED',
    'KSW INDIA PRIVATE LIMITED',
    'GOMA CLEANTECH PRIVATE LIMITED',
    'VVAAN LIFESCIENCES PRIVATE LIMITED',
    'WISOFTDIGI SERVICES PRIVATE LIMITED',
    'BRISK MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'SOMAIYA FOUNDATION',
    'MEDICI TECHNOLOGIES PRIVATE LIMITED',
    'KODEN INTL PRIVATE LIMITED',
    'MASON BRICKMANN ONLINE SOLUTIONS PRIVATELIMITED',
    'ALBION LIFECARE PRIVATE LIMITED',
    'REDEFINE ONLINE EXPRESS (OPC) PRIVATE LIMITED',
    'MANAGEMENT RESOURCE OUTSOURCING INDIA PRIVATE LIMITED',
    'FAMIAN HEALTHCARE PRIVATE LIMITED',
    'JAGER-SMITH INDIA PRIVATE LIMITED',
    'HEALTHY PEOPLE PRODUCER COMPANY LIMITED',
    'TIBBS FOODS PRIVATE LIMITED',
    'SECHERON HASLER (INDIA) PRIVATE LIMITED',
    'MANIBHAVNAM HOME FINANCE INDIA PRIVATE LIMITED',
    'TURTLEBOWL CONSULTING PRIVATE LIMITED',
    'ZERO DEGREE COOLING SYSTEM PRIVATE LIMITED',
    'SEABRIDGE TERMINALS PRIVATE LIMITED',
    'MAX-XPRESS LOGISTICS PRIVATE LIMITED',
    'BREAKBAG HOLIDAYS PRIVATE LIMITED',
    'NAMRATA MOTORS PRIVATE LIMITED',
    'MACON ENVIRO TECHNOLOGIES PRIVATE LIMITED',
    'LINKCXO GLOBAL PRIVATE LIMITED',
    'HR NEETI PRIVATE LIMITED',
    'AAPKA ADVISER PRIVATE LIMITED',
    'NEWLY EVERRISE ELECTRONICS INDIA PRIVATE LIMITED',
    'VEGAPHARM LIFE SCIENCES PRIVATE LIMITED',
    'BRISIM ECOMMERCE PRIVATE LIMITED',
    'SEHYOG GOLD TRADING PRIVATE LIMITED',
    'SKYLARK CAGERS INDIA PRIVATE LIMITED',
    'VAIDHRAJ LOGISTICS PRIVATE LIMITED',
    'GLOBAL DANCE TUBE INDIA PRIVATE LIMITED',
    'TS CARGO PRIVATE LIMITED',
    'MUBINA VAZIRALLI PRODUCTIONS PRIVATE LIMITED',
    'AMERICAN WAVE INDIA PRIVATE LIMITED',
    'TYECE INDIA MARKETING PRIVATE LIMITED',
    'PATRONAGE FILTEX INDIA PRIVATE LIMITED',
    'PWW DISTRIBUTION INDIA PRIVATE LIMITED',
    'PAPERPLANE CINEMAS PRIVATE LIMITED',
    'HACKFORCHANGE FOUNDATION',
    'PRAGMATIC INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'PHILIPPINE GUARDING PRIVATE LIMITED',
    'XPAN LOGISTICS PRIVATE LIMITED',
    'BIGBREAKS TRAVELS PRIVATE LIMITED',
    'MSK INDUSTRIES & PRODUCTS PRIVATE LIMITED',
    'UNIQUEMINDZ TECHNOLOGIES PRIVATE LIMITED',
    'TPF ENGINEERING PRIVATE LIMITED',
    'APPLIED PRECISION TOOLING (INDIA) PRIVATE LIMITED',
    'ZANINI INDIA PRIVATE LIMITED',
    'PHARMACHOL CHEMICALS PRIVATE LIMITED',
    'DEVANSH INFRAVISION PRIVATE LIMITED',
    'SUKSHA MARKETING PRIVATE LIMITED',
    'BIEN MODE CONCEPTS PRIVATE LIMITED',
    'KENYT TECHNOLOGIES PRIVATE LIMITED',
    'NEWTEK SOLUTIONS PRIVATE LIMITED',
    'EEXPEDISE TECHNOLOGIES PRIVATE LIMITED',
    'K-TECHNOCRATS PRIVATE LIMITED',
    'ENRISSION INDIA PRIVATE LIMITED',
    'SMS ONWHEEL LOGISTICS & ROADLINES PRIVATE LIMITED',
    'ZAK VENTURE PRIVATE LIMITED',
    'COCHIN FOOD TECH PRIVATE LIMITED',
    'EASY FINANCIAL DEVELOPMENT GROUP PRIVATE LIMITED',
    'STONE & CHALK SOFTECH PRIVATE LIMITED',
    'DASVANI RESIDENCY PRIVATE LIMITED',
    'FENCE PROMOTERS PRIVATE LIMITED',
    'PREWAL STUDIO PRIVATE LIMITED',
    'DELTASOFT TRADING PRIVATE LIMITED',
    'TEJ IT SOLUTIONS INDIA PRIVATE LIMITED',
    'TONGYU TECHNOLOGY INDIA PRIVATE LIMITED',
    'BSE CSR INTEGRATED FOUNDATION',
    'MACAW HOLDINGS PRIVATE LIMITED',
    'MEMKO SYSTEMS PRIVATE LIMITED',
    'INNOVSOURCE SERVICES PRIVATE LIMITED',
    'FATHER WORLDWIDE PRIVATE LIMITED',
    'CFE BUSINESS CENTRE PRIVATE LIMITED',
    'GOODLUCK AYURVEDA PRIVATE LIMITED',
    'WEETECH INFO SOLUTION PRIVATE LIMITED',
    'ANDROX SOLUTION AND SERVICES PRIVATE LIMITED',
    'BOLTTECH DEVICE PROTECTION INDIA PRIVATE LIMITED',
    'INNOVATION BIOLOGICALS PRIVATE LIMITED',
    'HARP TECHNOLOGIES & SERVICES PRIVATE LIMITED',
    'VVAA FILMS PRIVATE LIMITED',
    'TANA VENTURES PRIVATE LIMITED',
    'PIE VALUE CONCEPT INDUCTION PRIVATE LIMITED',
    'DEVRABBIT IT SOLUTIONS PRIVATE LIMITED',
    'GLOCON TRAINING AND RESEARCH CENTER (OPC) PRIVATE LIMITED',
    'SEVA FACILITY SERVICES PRIVATE LIMITED',
    'MADE IN INDIA ONLINE SERVICES PRIVATE LIMITED',
    'SLINOX INDIA PRIVATE LIMITED',
    'KRIPTON GRANITO PRIVATE LIMITED',
    'SPARTAN INFRAPROJECTS PRIVATE LIMITED',
    'DICIQUEST SOLUTIONS PRIVATE LIMITED',
    'VALMA CREATIONS PRIVATE LIMITED',
    'GLENDALE BIOMED PRIVATE LIMITED',
    'SPIELWARENMESSE INDIA PRIVATE LIMITED',
    'MFB GEOTECH PRIVATE LIMITED',
    'MI LAB LIFESCIENCES PRIVATE LIMITED',
    'FLEXI STAFFING SERVICES PRIVATE LIMITED',
    'YOURFLIGHTSHOP TRAVELS INDIA PRIVATE LIMITED',
    'UNITED LOGITECH INDIA PRIVATE LIMITED',
    'ISMART TRAINING AND CONSULTING PRIVATE LIMITED',
    'CAMBRIDGE ASSESSMENT INDIA PRIVATE LIMITED',
    'LIQUIGAS POWER PRIVATE LIMITED',
    'COGENT SAFETY AND SECURITY PRIVATE LIMITED',
    'SPECTRUM MANPOWER AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'TRANS IQ TECHNOLOGIES PRIVATE LIMITED',
    'SUDHA ORTHOPAEDIC & GYNEC HOSPITAL PRIVATE LIMITED',
    'M&S CONTAINER LINES PRIVATE LIMITED',
    'FACTOR HEALTHCARE SERVICES PRIVATE LIMITED',
    'AMRIT GANGA FARMERS PRODUCER COMPANY LIMITED',
    'MANAMADURAI FARMERS PRODUCER COMPANY LIMITED',
    'NILAKOTTAI MALLIGAI FARMERS PRODUCER COMPANY LIMITED',
    'DREAMPIXELS TECHNOLOGIES PRIVATE LIMITED',
    'ARCHATELIE INDIA PRIVATE LIMITED',
    'GRAMCOVER INSURANCE BROKERS PRIVATE LIMITED',
    'POSITRON AUTOMOTIVE SERVICES PRIVATE LIMITED',
    'MAGNIFIQUE WORLD SOLUTIONS PRIVATE LIMITED',
    'LIBERTY MED SUPPLIES PRIVATE LIMITED',
    'REMAC BUSINESS MART PRIVATE LIMITED',
    'HAMLET TRADING PRIVATE LIMITED',
    'TREAD TRAILS REJSE PRIVATE LIMITED',
    'ADC DEVELOPERS PRIVATE LIMITED',
    'CONNIXT SYSTEMS PRIVATE LIMITED',
    'SCIFFER ANALYTICS PRIVATE LIMITED',
    '3T INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'ANJAAR SOLUTIONS PRIVATE LIMITED',
    'MONEYDIAL (DOT) COM PRIVATE LIMITED',
    'FIRST CORE TERTIARY CARE HOSPITAL PRIVATE LIMITED',
    'FINSTAT EDUCATION SERVICES PRIVATE LIMITED',
    'HYDERABAD INSTITUTE OF NEURO SCIENCES PRIVATE LIMITED',
    'SLVS EGOVERNANCE SOLUTIONS PRIVATE LIMITED',
    'RESILIO TECHNOLOGIES PRIVATE LIMITED',
    'EZY MOV SOLUTIONS PRIVATE LIMITED',
    'BLUENGREEN DRUGS & SURGICALS PRIVATE LIMITED',
    'INNOVATION INCUBATOR ADVISORY PRIVATE LIMITED',
    'TAARAKA TECHNOLOGIES PRIVATE LIMITED',
    'SMART AIR FILTERS PRIVATE LIMITED',
    'GRAMSS RETAIL TRADING PRIVATE LIMITED',
    'TRIDHAATU HOMES DEVELOPERS INDIA PRIVATE LIMITED',
    'DS FINWORLD PRIVATE LIMITED',
    'T.EN GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'ALPHAMERIC TECHNOLOGIES PRIVATE LIMITED',
    'BNT AUTOSOFT PRIVATE LIMITED',
    'AESTHETIC NUTRITION PRIVATE LIMITED',
    'SUNSHAKTI BRIGHTSTAR POWER PRIVATE LIMITED',
    'CEARA INTERNATIONAL PRIVATE LIMITED',
    'BASIL LOGISTIC DEVELOPERS PRIVATE LIMITED',
    'VERIRARE ESSENTIAL OILS AND SPICES PRIVATE LIMITED',
    'MSA LOGISTICS PRIVATE LIMITED',
    'CWC IMPORT PRIVATE LIMITED',
    'TRANSTECH SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'JAPAN GAUGE INDIA PRIVATE LIMITED',
    'V-METROLOGIX BRAND MEASUREMENT SERVICES PRIVATE LIMITED',
    'C.H. TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'ABCO INFOTECH INTERNATIONAL PRIVATE LIMITED',
    'TREASURANCE TRAINING & CAPACITY BUILDING PRIVATE LIMITED',
    'HAUTERFLY DIGITAL MEDIA PRIVATE LIMITED',
    'AUTO-MATE INDIA PRIVATE LIMITED',
    'TOTAL FINSERV PRIVATE LIMITED',
    'VYAS CANCER RESEARCH PRIVATE LIMITED',
    'VIGI AGRIFILMS PRIVATE LIMITED',
    'FIRST IDEA ELECTROTHERM PRIVATE LIMITED',
    'ALPHA AROGYA INDIA PRIVATE LIMITED',
    'DRES ENERGY PRIVATE LIMITED',
    'RENEW SAUR SHAKTI PRIVATE LIMITED',
    'RENEW AGNI POWER PRIVATE LIMITED',
    'RENEW MEGA SOLAR POWER PRIVATE LIMITED',
    'HIND ADSOFT PRIVATE LIMITED',
    'MY OWN ROOMS DOT IN PRIVATE LIMITED',
    'POONAWALLA PROPERTIES PRIVATE LIMITED',
    'URJA CONSULTANCY & ENGINEERING SERVICES PRIVATE LIMITED',
    'ACADECRAFT PRIVATE LIMITED',
    'JAIN EMPOWERMENT INTERNATIONAL WELFARE ORGANISATION',
    'SPECIAL OCCASIONS LIMITED',
    'HELLO TEN BRANDS PRIVATE LIMITED',
    'HMW COMMUNICATIONS PRIVATE LIMITED',
    'VANTEL TECHNOLOGIES LIMITED',
    'SUPERB FORMULATIONS PRIVATE LIMITED',
    'WORKILA HR SOLUTIONS PRIVATE LIMITED',
    'LOGISTIXIAN TECHNOLOGIES PRIVATE LIMITED',
    'URMILA INTERNATIONAL SERVICES PRIVATE LIMITED',
    'IOPTIBIZ SOLUTIONS PRIVATE LIMITED',
    'DHYANA ADVISORY SERVICES PRIVATE LIMITED (OPC)',
    'BREMELS ZINGA TYRE SERVICES PRIVATE LIMITED',
    'RS HARVESTING PRODUCER COMPANY LIMITED',
    'FARMKART TECHNOLOGIES PRIVATE LIMITED',
    'ICEDREAM GLOBAL PRIVATE LIMITED',
    'WORKAPPS SOLUTIONS PRIVATE LIMITED',
    'GREENPURE AQUAFRESH PRIVATE LIMITED',
    'INTERSPED LOGISTICS INDIA PRIVATE LIMITED',
    'POONAWALLA ESTATES PRIVATE LIMITED',
    'KOSHI RAJMA FARMERS PRODUCER COMPANY LIMITED',
    'KANOPY AGRI TECH INDIA PRIVATE LIMITED',
    'UDYAN AGRO PRIVATE LIMITED',
    'CHALKA AGRITECH PRIVATE LIMITED',
    'CRAFTING FUTURES PRIVATE LIMITED',
    'MINHAJ-UL-QURAN FOUNDATION',
    'HILLDALE PLANTATIONS INDIA PRIVATE LIMITED',
    'BRAT AGRO PRIVATE LIMITED',
    'CHOICE CONNECT PRIVATE LIMITED',
    'LOTUS GRANGES (INDIA) LIMITED',
    'ODIA KUKUDA FARMERS PRIVATE LIMITED',
    'SUPREME SILAGE INDIA PRIVATE LIMITED',
    'ARYAN ESSENTIALS PRIVATE LIMITED',
    'NALANDA DAIRY PROJECT PRIVATE LIMITED',
    'RK POULTRIES PRIVATE LIMITED',
    'BIJSON INNOVATIONS PRIVATE LIMITED',
    'FLYBIRD FARM INNOVATIONS PRIVATE LIMITED',
    'PANDHANA PASHUPALAK PRODUCER COMPANY LIMITED',
    'MADHYA PRADSH & MAHARASHTRA MINERALS & CHEMICALS LTD',
    'AUTECHTRA PROPERTIES MANAGEMENT PRIVATE LIMITED',
    'NATARAMPALLI FARMERS PRODUCER COMPANY LIMITED',
    'TIRUMANGALAM FARMERS PRODUCER COMPANY LIMITED',
    'VAM AGRO (INDIA) PRIVATE LIMITED',
    'GREENDNA INDIA PRIVATE LIMITED',
    'RAKIYA INFORMATION TECHNOLOGY SOLUTION PRIVATE LIMITED',
    'MONDIAL GENNEXT SOLUTIONS PRIVATE LIMITED',
    'UNIBAIT FEEDS PRIVATE LIMITED',
    'EAST COAST COCONUT PRODUCTS PRIVATE LIMITED',
    'AGROLLIANCE NATURALS AND IMPEX PRIVATE LIMITED',
    'HARLAL SEEDS PRIVATE LIMITED',
    'KATNI KISAN ABHIRUCHI PRODUCER COMPANY LIMITED',
    'S.M. AGRI EXPORTS PRIVATE LIMITED',
    'RAGHUNATH AGRO INDUSTRIES PRIVATE LIMITED',
    'SANPRA SYNTHESIS PRIVATE LIMITED',
    'WYTECH PHARMACEUTICALS PRIVATE LIMITED',
    'INGEVITY INDIA PRIVATE LIMITED',
    'BLUEBASIC INDIA LIMITED',
    'REALM PHARMACEUTICALS PRIVATE LIMITED',
    'REFCOAT CHEMICALS PRIVATE LIMITED',
    'STALLION TYRES LIMITED',
    'AVA NATURALS PRIVATE LIMITED',
    'METRO TECHNOPARK PRIVATE LIMITED',
    'POLLEN HEALTHCURE PRIVATE LIMITED',
    'PROGENERICS PHARMA PRIVATE LIMITED',
    'ELAVIN CHEMTECH PRIVATE LIMITED',
    'ORIX PACKAGING PRIVATE LIMITED',
    'INDICA BELTING PRIVATE LIMITED',
    'VIVSONS INDUSTRIES PRIVATE LIMITED',
    'FPI AUTO PARTS INDIA PRIVATE LIMITED',
    'CASPER PHARMA PRIVATE LIMITED',
    'BAPL ROTOTECH PRIVATE LIMITED',
    'TRIKONA PHARMACEUTICALS PRIVATE LIMITED',
    'BHARATI POLYCHEM PRIVATE LIMITED',
    'COMET POLYPLAST PRIVATE LIMITED',
    'MUTUAL STYL MONDE PRIVATE LIMITED',
    'SHAKTI IRRIGATION PRIVATE LIMITED',
    'JAANH CNP INDIA PRIVATE LIMITED',
    'SANZYME Private Limited',
    'LEE MORTEN LIFE SCIENCES PRIVATE LIMITED',
    'TALBROS GARDX PERFORMANCE PRODUCTS PRIVATE LIMITED',
    'K B K GLOBAL PRIVATE LIMITED',
    'MICROTEX CLOTHING PRIVATE LIMITED',
    'TEXCARP CONSULTING PRIVATE LIMITED',
    'VASISTA PHARMA CHEM PRIVATE LIMITED',
    'VEM TOOLING (INDIA) PRIVATE LIMITED',
    'GD DESIGN & PACKAGING PRIVATE LIMITED',
    'DRBEST PHARMACEUTICALS PRIVATE LIMITED',
    'RAWASSA LAMINATES (INDIA) PRIVATE LIMITED',
    'CALREN CARE LIFESCIENCES PRIVATE LIMITED',
    'HI-TECH ZENITH DIE PRIVATE LIMITED',
    'FOAM SPECIALTIES INDIA PRIVATE LIMITED',
    'GRANULA MASTERBATCHES INDIA PRIVATE LIMITED',
    'CHEMIECORP POLYMER SOLUTIONS PRIVATE LIMITED',
    'NIPB INDUSTRIAL BRUSHES INDIA PRIVATE LIMITED',
    'SAINT-GOBAIN INDIA Private Limited',
    'PI RUBBER PRIVATE LIMITED',
    'ORIF RUBBERTECH PRIVATE LIMITED',
    'SHREE PLAST ENGINEERING PRIVATE LIMITED',
    'ARROWMAX PACKAGING PRIVATE LIMITED',
    'HYDERABAD CHEMICAL PRODUCTS Private Limited',
    'SRIAM LABS PRIVATE LIMITED',
    'BONZA VITRIFIED PRIVATE LIMITED',
    'SUNFRIO CHEMICALS PRIVATE LIMITED',
    'GRANICER TILES PRIVATE LIMITED',
    'AEROGEL ONE PRIVATE LIMITED',
    'REVA MEDICARE PRIVATE LIMITED',
    'FLOURISH AGROBIOTECH PRIVATE LIMITED',
    'SUDHIR LIFE SCIENCES PRIVATE LIMITED',
    'WHITE PEARL WALLTEXTURES PRIVATE LIMITED',
    'VIJAYA POLYMERS INDIA PRIVATE LIMITED',
    'GREENCELL RUBBER INDIA PRIVATE LIMITED',
    'FORTUNE MIX INDIA PRIVATE LIMITED',
    'POLYHOSE TOFLE PRIVATE LIMITED',
    'DECCANO CASEMENTS PRIVATE LIMITED',
    'NOVA ENZO POLYMERS PRIVATE LIMITED',
    'TIMWOOD PLASTICS PRIVATE LIMITED',
    'IVL DHUNSERI PETROCHEM INDUSTRIES PRIVATE LIMITED',
    'COOL CAPS INDUSTRIES LIMITED',
    'VIRTUE PLAST PRIVATE LIMITED',
    'ROSH INDUSTRIES PRIVATE LIMITED',
    'ADVANTEC CASTING PRIVATE LIMITED',
    'STEEL ON CALL INDIA PRIVATE LIMITED',
    'TIGER STEEL INDUSTRIES (INDIA) PRIVATE LIMITED',
    'AJS GALVA ISPAT PRIVATE LIMITED',
    'ALOK INFRACON PRIVATE LIMITED',
    'SANDEEP ENTERPRISES PRIVATE LIMITED',
    'TIRUMALA BALAJI SMELTERS PRIVATE LIMITED',
    'KYODO YUSHI INDIA PRIVATE LIMITED',
    'ISKO STRIP PRIVATE LIMITED',
    'SOL INNOCAB PRIVATE LIMITED',
    'RNG EXPORTS PRIVATE LIMITED',
    'U.P. CERAMICS & POTTERIES Private Limited',
    'SIEG PAVERS PRIVATE LIMITED',
    'ROCKTECH MINERAL DEVELOPMENT (GUJ.) PRIVATE LIMITED',
    'MODERN AGE METAL PROCESSORS PRIVATE LIMITED',
    'HEPO INDIA PRIVATE LIMITED',
    'SUNAV INDUSTRIES PRIVATE LIMITED',
    'GURUKUL FITTINGS PRIVATE LIMITED',
    'COLOR GRANITO PRIVATE LIMITED',
    'ASTILA CERAMIC PRIVATE LIMITED',
    'VISHAL PIPES LIMITED',
    'RINL POWERGRID TLT PRIVATE LIMITED',
    'HADRON CLEAN ENERGY SPARES PRIVATE LIMITED',
    'MAGOD FUSION TECHNOLOGIES PRIVATE LIMITED',
    'ZIXIN CYLINDERS PRIVATE LIMITED',
    'SUPREMEPACKS PLASTIC PRIVATE LIMITED',
    'MAGNUM UPVC WINDOW SYSTEMS PRIVATE LIMITED',
    'RADHARANI INTERNATIONALS PRIVATE LIMITED',
    'SSDP PLASTOPAK PRIVATE LIMITED',
    'SHRI AMBICA MASTERBATCH PRIVATE LIMITED',
    'SOULWEAVES PRIVATE LIMITED',
    'ACME MAHBUBNAGAR SOLAR ENERGY PRIVATE LIMITED',
    'PADMAJIWADI SOLAR PRIVATE LIMITED',
    'FABA ECO CLEAN ENERGY VENTURES PRIVATE LIMITED',
    'SCALD ENERGY PRIVATE LIMITED',
    'ADITYA BIRLA RENEWABLES LIMITED',
    'SUPA WINDFARM LIMITED',
    'NIVADE WINDFARM LIMITED',
    'GAUTAM LABDHI PORTFOLIO MANAGEMENT SERVICES PRIVATE LIMITED',
    'SEW New Melling Power Corporation Limited',
    'TOYOP ENERGY PRIVATE LIMITED',
    'KINETA FUELS & ENERGY PRIVATE LIMITED',
    'ZUVAN ENERGY PRIVATE LIMITED',
    'UNISON ENVIRO PRIVATE LIMITED',
    'DHANLAXMI VIDYUT PRIVATE LIMITED',
    'POOLAVADI WINDFARM LIMITED',
    'RAJIB POWER PRIVATE LIMITED',
    'VIVIDWIND ENERGY PRIVATE LIMITED',
    'SUNTERRACE ENERGY ONE PRIVATE LIMITED',
    'JYOTIRMAY SOLAR PRIVATE LIMITED',
    'AIRPOWER WINDFARMS PRIVATE LIMITED',
    'RAIPAR RENEWABLE ENERGY PRIVATE LIMITED',
    'ATHENA KARNAL SOLAR POWER PRIVATE LIMITED',
    'ADHYA GLOBAL POWER PRIVATE LIMITED',
    'MACLEAN POWER (INDIA) PRIVATE LIMITED',
    'RAMANAGARAM ENTERPRISES PRIVATE LIMITED',
    'INTEGRATED GAS CONTROLS TECHNOLOGIES PRIVATE LIMITED',
    'MYTRAH AAKASH POWER PRIVATE LIMITED',
    'ARYAVAAN RENEWABLE ENERGY PRIVATE LIMITED',
    'BIRDS EYE ENERGY TECHNOLOGIES PRIVATE LIMITED',
    'ESHWAR ENERGY PRIVATE LIMITED',
    'JILESH POWER PRIVATE LIMITED',
    'NISANTH POWER PRIVATE LIMITED',
    'DINAK POWER PRIVATE LIMITED',
    'OSTRO AP WIND PRIVATE LIMITED',
    'SKYLA POWER AND INFRA PRIVATE LIMITED',
    'KINETIC ENERGY (INDIA) PRIVATE LIMITED',
    'RE POWER TRADING INDIA PRIVATE LIMITED',
    'MULANUR RENEWABLE ENERGY LIMITED',
    'JITF URBAN INFRASTRUCTURE SERVICES LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (TIRUPATI) LIMITED',
    'SANYA ENERGY PRIVATE LIMITED',
    '.HARYANA CITY GAS DISTRIBUTION (BHIWADI)LIMITED',
    'GEOCUBE SOLUTIONS PRIVATE LIMITED',
    'AVADHRAJ ENERGY PRIVATE LIMITED',
    'GUMMADIDALA SOLAR PRIVATE LIMITED',
    'ACCORD ELECTROPOWER PRIVATE LIMITED',
    'SYANDANA ENERGY PRIVATE LIMITED',
    'CEF AGRO COMMODITIES PRIVATE LIMITED',
    'EFFICIENT SOLAR ENERGY PRIVATE LIMITED',
    'CHIRAYU POWER PRIVATE LIMITED',
    'SOLARGEN INDIA PRIVATE LIMITED',
    'SHARV ENERGY PRIVATE LIMITED',
    'ADISUN SOLAR INDIA PRIVATE LIMITED',
    'SHIPRICH SHIPPING SOLUTIONS PRIVATE LIMITED',
    'KODANGAL SOLAR PARKS PRIVATE LIMITED',
    'VANI VINAYAK CONSTRUCTION PRIVATE LIMITED',
    'KBM MULTIBUILD PRIVATE LIMITED',
    'ENERSOL INFRA PRIVATE LIMITED',
    'SUN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AEG GREEN POWER INDIA PRIVATE LIMITED',
    'MYTRAH AGRIYA POWER PRIVATE LIMITED',
    'MYTRAH ADARSH POWER PRIVATE LIMITED',
    'JSW ADVAITH POWER PRIVATE LIMITED',
    'MYTRAH ABHINAV POWER PRIVATE LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (VISAKHAPATNAM) LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (GUNTUR) LIMITED',
    'MIECO SOLUTIONS PRIVATE LIMITED',
    'FRV POWER INDIA PRIVATE LIMITED',
    'TAIYOU GREEN SOLUTIONS PRIVATE LIMITED',
    'PARAMOUNT WINDFARMS PRIVATE LIMITED',
    'PARAMOUNT SOLAR POWER PRIVATE LIMITED',
    'VAN AMRIT ORGANICS PRIVATE LIMITED',
    'UAV INNOVATIONS & COMMERCIAL SOLUTIONS PRIVATE LIMITED',
    'IFIELD ENERGY PRIVATE LIMITED',
    'CJS BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'KEEKKADAN PROPERTY MANAGEMENT PRIVATE LIMITED',
    'JITF WATER INFRA (NAYA RAIPUR) LIMITED',
    'SRIJAN ECOLOGICAL UPLIFTMENT PRIVATE LIMITED',
    'TARA STRUCTURE PRIVATE LIMITED',
    'MEER DEVELOPERS NAGPUR PRIVATE LIMITED',
    'FLAGSHIP HOUSING DEVELOPMENT PRIVATE LIMITED',
    'ARREDO DESIGNS PRIVATE LIMITED',
    'ROTODYNE ENGINEERING SERVICES PRIVATE LIMITED',
    'INSEE SYSTEMS PRIVATE LIMITED',
    'SHAKUNTALA TOWNSCAPE PRIVATE LIMITED',
    'ABIEL LANDMARKS PRIVATE LIMITED',
    'VISIONARIO LIFE SCIENCES PRIVATE LIMITED',
    'CREASTATE INFRAHOMES PRIVATE LIMITED',
    'PRASAD ESTATES PVT.LTD.',
    'AALIYAS HOME PRIVATE LIMITED',
    'TASK MASTERS ENGINEERING AND PROJECT SOLUTIONS PRIVATE LIMITED',
    'VASANTH NIVAS PRIVATE LIMITED',
    'ASTRIYA HOMES PRIVATE LIMITED',
    'R.R. DESIGNS PRIVATE LIMITED',
    'TALLAMRAJU DEVELOPERS (OPC) PRIVATE LIMITED',
    'JHARKHAND INFRASTRUCTURE IMPLEMENTATION CO LIMITED',
    'FIVE ELEMENTS RETAIL PRIVATE LIMITED',
    'GLOCOM RETAIL PRIVATE LIMITED',
    'DOUBLE DOWN RETAIL PRIVATE LIMITED',
    'RIMART INTERNATIONAL PRIVATE LIMITED',
    'GAPA FURNISHING PRIVATE LIMITED',
    'STANDARD GLOBAL SUPPLY PRIVATE LIMITED',
    'INTEGROW LIFE SCIENCES PRIVATE LIMITED',
    'XMEDCO COMMERCE PRIVATE LIMITED',
    'JSP TRADINGS & SOLUTIONS PRIVATE LIMITED',
    'VSERVE ECOMMERCE SALES AND SERVICES PRIVATE LIMITED',
    'LUXURY PRODUCTS TRENDSETTER PRIVATE LIMITED',
    'ESSEMM FOODTECH INNOVATIONS PRIVATE LIMITED',
    'SHUDH JIVAN RETAIL PRIVATE LIMITED',
    'ARVIND FASHIONS LIMITED',
    'KIVO SOLUTIONS PRIVATE LIMITED',
    'KETEKI MOBILE TRADING PRIVATE LIMITED',
    'BIGBEST INFOTECH PRIVATE LIMITED',
    'APEX ELECTROWORLD PRIVATE LIMITED',
    'SECURAPLUS SAFETY PRIVATE LIMITED',
    'MEPET TRADERS PRIVATE LIMITED',
    'JMJ SEAFOODS RETAIL PRIVATE LIMITED',
    'SMARTWAY INDIA SUPERSTORES PRIVATE LIMITED',
    'GINGERPAN SWAPCART PRIVATE LIMITED',
    'LYCA DIGITAL PRIVATE LIMITED',
    'AVISHYA TRADING PRIVATE LIMITED',
    'FL TRADERS PRIVATE LIMITED',
    'CARVEL FASHIONS INDIA PRIVATE LIMITED',
    'AURA LABTECH PRIVATE LIMITED',
    'CRUIT ONLINE SOLUTIONS PRIVATE LIMITED',
    'USMANIA DISTRIBUTORS PRIVATE LIMITED',
    'SWAYS TRADING AND MARKETING PRIVATE LIMITED',
    'ANTHEM RETAIL PRIVATE LIMITED',
    'GO FOR SOLUTION PRIVATE LIMITED',
    'HYGRID SOLAR PRIVATE LIMITED',
    'VSOLV ENGINEERING INDIA PRIVATE LIMITED',
    'ASAAN ECOMMERCE PRIVATE LIMITED',
    'VOSTRO DESIGN & FASHION PRIVATE LIMITED',
    'ONLINESENSOR ECOM INDIA PRIVATE LIMITED',
    'SAKSHAM CONNECT PRIVATE LIMITED',
    'AKSHKIRAN STORES PRIVATE LIMITED',
    'KACHOLIYA TRADE LINK PRIVATE LIMITED',
    'HALCYON SALES PRIVATE LIMITED',
    'REMITAP FINTECH SOLUTIONS PRIVATE LIMITED',
    'EXOTIC FINDS PRIVATE LIMITED',
    'TEJOSH E-COMMERCE PRIVATE LIMITED',
    'AAIDEA SOLUTIONS LIMITED',
    'KHUS ONLINE SOLUTIONS PRIVATE LIMITED',
    'WOAV INNOVATION PRIVATE LIMITED',
    'ABHI LIFESTYLE PRIVATE LIMITED',
    'RSA NATURALS PRIVATE LIMITED',
    'SCORP ENERGY PRIVATE LIMITED',
    'ARVIND PREMIUM RETAIL LIMITED',
    'ADI INSTAPACK PRIVATE LIMITED',
    'MYPETBUDDY SERVICES PRIVATE LIMITED',
    'MAZENTA RETAIL PRIVATE LIMITED',
    'WAYCOOL FOODS AND PRODUCTS PRIVATE LIMITED',
    'VALUE ASSETS MANAGEMENT PRIVATE LIMITED',
    'VANTAGE KART ONLINE SERVICES PRIVATE LIMITED',
    '3PLATE FOODS PRIVATE LIMITED',
    'TRAGLO ECOMMERCE PRIVATE LIMITED',
    'THIN STROKES MERCHANDISE PRIVATE LIMITED',
    'AKASAKI RETAIL PRIVATE LIMITED',
    'GEENOVA TECHNOPLAST PRIVATE LIMITED',
    'GATEWAY2SITES RETAILS PRIVATE LIMITED',
    'OMEGA FLOORS & CARPETS PRIVATE LIMITED',
    'DEEPS INTERNATIONAL PRIVATE LIMITED',
    'CUSTOMIZED GIFT KART PRIVATE LIMITED',
    'SOUL SHOP (OPC) PRIVATE LIMITED',
    'DYNAMIC TOBACCO PRIVATE LIMITED',
    'PUJA SANSKARAM COMMERCE PRIVATE LIMITED',
    'KAAPUS FASHION RETAILER PRIVATE LIMITED',
    'TRINA SOLAR ENERGY INDIA PRIVATE LIMITED',
    'DIVUS E COMMERCE PRIVATE LIMITED',
    'UPABHAMASA SOLUTION PRIVATE LIMITED',
    'SOCH APPARELS PRIVATE LIMITED',
    'URDOORSTEP ERETAIL PRIVATE LIMITED',
    'WHISTLING WINDS RETAIL PRIVATE LIMITED',
    'BOOKSBEKA ONLINE SOLUTIONS PRIVATE LIMITED',
    'INVENTUM POWER PRIVATE LIMITED',
    'TRAILBLAZE RETAIL PRIVATE LIMITED',
    'NEBYULA INTERIORS & ELECTRICALS PRIVATE LIMITED',
    'BOUTIQUE BAKERY PRIVATE LIMITED',
    'SOURCINGBEE RETAIL PRIVATE LIMITED',
    'OSTELLO HOTELS AND RESORTS PRIVATE LIMITED',
    'MANDYA ORGANIC FOODS PRIVATE LIMITED',
    'ZECORATE PRIVATE LIMITED',
    'HAPPYMONGO ONLINE SOLUTION PRIVATE LIMITED',
    'LAMBRE COSMETICS PRIVATE LIMITED',
    'PUGOS PRODUCTS PRIVATE LIMITED',
    'AQUAYS HOTELS & RESORTS PRIVATE LIMITED',
    'NV CONCEPTS AND DESIGNS (OPC) PRIVATE LIMITED',
    'PAULCART E COMMERCE PRIVATE LIMITED',
    '1908 E-VENTURES PRIVATE LIMITED',
    'R.K.P. BUSINESS CONCEPTS PRIVATE LIMITED',
    'QIK TECHSOFT SOLUTIONS PRIVATE LIMITED',
    'RAWAT HOSPITALITY SERVICES PRIVATE LIMITED',
    'INTERGRANDE HOTELS PRIVATE LIMITED',
    'TRIPPDEALS ONLINE SERVICES PRIVATE LIMITED',
    'IHHR HOSPITALITY ANANDA PRIVATE LIMITED',
    'ZZEPTA FARMS PRIVATE LIMITED',
    'RUNWAL REAL ESTATES PRIVATE LIMITED',
    'UTTHAN VISION MICRO FINANCE FOUNDATION',
    'CAPITAL HOUSING PROJECTS PRIVATE LIMITED',
    'ANTRIKSH TOWERS PRIVATE LIMITED',
    'ANTRIKSH REAL ESTATE BUILDERS PRIVATE LIMITED',
    'LORD BUDDHA REALTY PRIVATE LIMITED',
    'ANTRIKSH REAL ESTATES PRIVATE LIMITED',
    'ANTRIKSH RESIDENTIAL SPACE PRIVATE LIMITED',
    'AVENUES ENTERPRISES PRIVATE LIMITED',
    'ERNESTO REALTORS PRIVATE LIMITED',
    'ANTRIKSH GREENS PRIVATE LIMITED',
    'CAPDEAL REALTY CARE PRIVATE LIMITED',
    'TRIPURESHWARI PROPERTIES PRIVATE LIMITED',
    'SD POWAI REDEVELOPMENT PRIVATE LIMITED',
    'TWILIGHT INFRASTRUCTURE PRIVATE LIMITED',
    'TRANSFORMATIONAL PROPERTIES PRIVATE LIMITED',
    'SAIP REAL ESTATE PRIVATE LIMITED',
    'VISHWADEEP PROJECTS PRIVATE LIMITED',
    'RA SUPERSTRUCTURES PRIVATE LIMITED',
    'INTERNATIONAL INFRABUILD PRIVATE LIMITED',
    'H K S REALTY PRIVATE LIMITED',
    'TATTVA & MITTAL DEVELOPERS PRIVATE LIMITED',
    'REALIZUM ENTERPRISES PRIVATE LIMITED',
    'ASHIYANA DREAM HOMES PRIVATE LIMITED',
    'PM REALTY INVENTURE PRIVATE LIMITED',
    'ESSEL HOME PRIVATE LIMITED',
    'SANGVI LIFESPACE PRIVATE LIMITED',
    'MUMBAIPROPERTIES CONSULTING PRIVATE LIMITED',
    'ARORA REAL CORP PRIVATE LIMITED',
    'INTERGLOBE REAL ESTATE VENTURES PRIVATE LIMITED',
    'NANDANA ESTATE & RESORTS PRIVATE LIMITED',
    'NEBULA RESORTS PRIVATE LIMITED',
    'INVESTORS GURUKUL REAL ESTATE SERVICES PRIVATE LIMITED',
    'MGR PROJECTS PRIVATE LIMITED',
    'REDDY AVENUE PRIVATE LIMITED',
    'NRI RENTAL SERVICES PRIVATE LIMITED',
    'PROPERTY CROW SERVICES PRIVATE LIMITED',
    'VIDHIRACHANA DEVELOPERS PRIVATE LIMITED',
    'ST. ANGELO',
    'ASSOCIATIONS',
    'Gujarat safai kamdar vikas nigam',
    'Association of hospitals of eastern india',
    'Shreya creations private limited',
    'Greenthumb studios private limited',
    'Infinitum productions private limited',
    'Ideacount education private limited',
    'Twenty four frames factory private limited',
    'CHANGE AGENTS MEDIA SERVICES PRIVATE LIMITED',
    'Cinecita technologies private limited',
    'CIEL TECHNOLOGIES PRIVATE LIMITED',
    'Esp entertainment (india) private limited',
    'Bars and tone television private limited',
    'Shipra entertainment private limited',
    'Jam multiplex private limited',
    'Crossover films india private limited',
    'THRRILL PARK LIMITED',
    'Den nashik city cable network private limited',
    'Blue haven entertainment private limited',
    'We media (india) private limited',
    'Dreamcatchers films private limited',
    'Vaamika island resorts private limited',
    'Sawaria pipes private limited',
    'Freewheel sports private limited',
    'SALGAOCAR SPORTS CLUB',
    'India polo promotion foundation',
    'Skylark entertainment and resorts india pvt ltd',
    'Digisoul controls private limited',
    'Cadtech consultants private limited',
    'Sofcon india private limited',
    'Kreativevistas solutions private limited',
    'Cipsa tec india private limited',
    'Intelliob technologies private limited',
    'BHASKERA COMPONENTS & PRINTS PRIVATE LIMITED',
    'Sipra tek automation private limited',
    'Informatics technologies private limited',
    'K-FINS PUMPS PRIVATE LIMITED',
    'Greenwire power solutions private limited',
    'ONKAR ENGINE & GENERATOR PRIVATE LIMITED',
    'Swaki electrical private limited',
    'Passion wires & cables private limited',
    'Btw - atlanta transformers india private limited',
    'Avaco engineering (india) private limited',
    'Arempee compressors private limited',
    'Tech-on engineers private limited',
    'Electromech material handling systems (india) private limited',
    'Blossom industries limited',
    'GLOBAL ACTIVES PRIVATE LIMITED',
    'Enertech electronics private limited',
    'Teamwork cables private limited',
    'Chandresh cables limited',
    'Leebo metals private limited',
    'Vi-son wiring systems (india) private limited',
    'Wc & c engineering private limited',
    'Artheon battery company private limited',
    'Kalinga lighting pvt ltd',
    'Om fixtures private limited',
    'Ruby metrology private limited',
    'Transcon engineers private limited',
    'Aatash norcontrol ltd.',
    'Gpr india private limited.',
    'Mpp technologies private limited',
    'Universal electronic solutions (india) private limited',
    'Sowparnika thermistors and hybrids private limited',
    'TRANSPARENT TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'Eltech services private limited',
    'A -1 gadget world private limited',
    'Signalchip innovations private limited',
    'Iwai electronics pvt ltd',
    'Rapport productions private limited',
    'Prysm displays (india) private limited',
    'Saarc masts tech private limited',
    'YASHNA NATURALS PRIVATE LIMITED',
    'Clear communication systems limited',
    'Tristar electronics private limited',
    'Archana opitcaldisc private limited',
    'Eskay heat transfers private limited',
    'Euro overseas exports india private limited',
    'Ascent networks private limited',
    'Ever electronics private limited',
    'Katlax enterprises private limited',
    'Infomerics valuation and rating private limited',
    'Speedon network limited',
    'Cellcomm solutions limited',
    'Savim technologies private limited',
    'Nicheken technologies private limited',
    'Platinum communications private limited',
    'Impel audiotronix private limited',
    'Kalisons telvent private limited.',
    'Hydac (india) private limited',
    'Mb lifesciences private limited',
    'Unicorn hands and needles private limited',
    'Superior electric machines private limited',
    'Sewing systems private limited',
    'NIDAN LABORATORIES AND HEALTHCARE LIMITED',
    'Telser electronics private limited',
    'Saklaspur engineering private limited',
    'Applied and integrated manufacturing (india) private limited',
    'Klenzaids contamination controls private limited',
    'Gemini medical networks private limited',
    'Smr ophthalmic private limited',
    'USEI ENTERPRISES INDIA PRIVATE LIMITED',
    'Pegasys systems private limited',
    'Eltek overseas private limited',
    'Airways surgicals private limited',
    'Vitalmed solutions and services private limited',
    'Sobha applieddsp private limited',
    'Shanti instruments private limited',
    'Multiquadrant industrial controls (india) private limited',
    'Saha watches private limited',
    'C s diesel engineering pvt ltd',
    'Imasen manufacturing india private limited',
    'REFLEXALLEN INDIA PRIVATE LIMITED',
    'KAMAL COACH WORKS PRIVATE LIMITED',
    'Whale enterprise private limited',
    'Meneta automotive components private limited',
    'Alliance friction technology private limited',
    'Mat brakes india private limited',
    'Newturn automation private limited',
    'Packwell gaskets private limited',
    'Vishwas auto engineers private limited',
    'Lanson cars private limited',
    'Gokul autotech private limited',
    'Bmk private limited',
    'DP WORLD MULTIMODAL LOGISTICS PRIVATE LIMITED',
    'Model logistics private limited',
    'Psn container line private limited',
    'Inditrans shipping company private limited',
    'Opal asia logistics (india) private limited',
    'Abc marine private limited',
    'Corporate n leisure destination tour private limited',
    'Horizon destination management company private limited',
    'Aviation solutions (india) private limited',
    'Royal world tours private limited',
    'Yashraj logistics private limited',
    'Omw logistics private limited',
    'D v r freight forwarders private limited',
    'Bullet logistics india private limited',
    'Inmar shipping and logistics private limited',
    'Trans power maritime india private limited',
    'Guardian intermodal and distribution private limited',
    'Five star cargo shipping private limited',
    'Udayshankar r.m. consulting private limited',
    'Principal global services private limited',
    'Gigantic infotel private limited',
    'Bharti airtel services limited',
    'Rhombus communications private limited',
    'Telsource software labs private limited',
    'Award solutions (india) private limited',
    'SmartERP Consulting Private Limited',
    'Intelsat india private limited',
    'Mobi serve private limited',
    'SITI SAISTAR DIGITAL MEDIA PRIVATE LIMITED',
    'UTIMACO TECHNOLOGIES PRIVATE LIMITED',
    'PAFT FINANCE LIMITED',
    'FORTRESS INFRACON LIMITED',
    'UTI ALTERNATIVES PRIVATE LIMITED',
    'Gurukripa finance & consultancy private limited',
    'Banyan tree financial solutions private limited',
    'Pine labs private limited.',
    '360 degree consultancy private limited',
    'Express bpo services private limited',
    'B r d finance limited',
    'WHAM ECO POWER PRIVATE LIMITED',
    'Magnum fincom broking private limited',
    'Centrum financial services limited',
    'Shreeramanjaneya leasing and finance p ltd',
    'Nisum credit and capital limited',
    'Electronica finance limited',
    'ESAF FINANCIAL HOLDINGS PRIVATE LIMITED',
    'Grm finance & leasing company pvt ltd',
    'Dave leasing and holdings private limited',
    'Ajcon finance limited',
    'Swarnodhayam credits private limited',
    'AMBUJA FOREX PRIVATE LIMITED',
    'Gunjar finance and investment private limited',
    'Clove capital services private limited',
    'Shubham trading private limited',
    'Kosamattam finance limited',
    'Vijay latex products private limited',
    'Intelligent financial services private limited',
    'Abhiraj trading and investments private limited',
    'Stallion investments pvt ltd',
    'Albany investment company p ltd',
    'Apian finance and investment ltd',
    'Ramniranjan kedia rent a car private limited',
    'Emil holdings private limited',
    'Emerging equities private limited',
    'J.p. morgan securities india private limited',
    'The clearing corporation of india limited',
    'Mangal keshav capital limited',
    'Mangal keshav securities limited',
    'Sejal finance limited',
    'Arthveda fund management private limited',
    'Alpha alternatives holdings private limited',
    'Chordia holdings and construction private limited',
    'Robust finvest private limited',
    'AU MUTUALS FINANCIAL SERVICES PRIVATE LIMITED',
    'ENAM ASSET MANAGEMENT COMPANY PRIVATE LIMITED',
    'Idbi trusteeship services limited',
    'Shree raghavendra chit fund private limited',
    'Ucal securities private limited',
    'Kadampanad kuries private limited',
    'Sree jaya nathan chits private limited',
    'Rvr estates private limited',
    'RENEWABLE POWER VENTURE PRIVATE LIMITED',
    'Gajanand mittal investments private limited',
    'Shareworth finances private limited',
    'Vmms holdings private limited',
    'Bajaj aviation private limited',
    'Latin manharlal finance & securities private limited',
    'Mahajani investments private limited',
    'Charys investments private limited',
    'D n j investment advisors private limited',
    'Karvy holdings limited',
    'Eldorado holdings pvt ltd',
    'K u v investments private limited',
    'Jubilee insurance broking services private limited',
    'Vector risk management services private limited',
    'Icici prudential pension funds management company limited',
    'Composite insurance brokers and advisors private limited',
    'I-base services private limited',
    'ISHWARSHAKTI SECURITIES PRIVATE LIMITED',
    'Forever living products (india) private limited',
    'Img advisory private limited',
    'Nectar loyalty management india limited',
    'WELTWEIT TRADING AND EXPORT PRIVATE LIMITED',
    'Aedage private limited',
    'Resnet services india private limited',
    'Rajlaxmi giltedge private limited',
    'Om shri sai cranes (india) private limited',
    'Career catalysts hrc private limited',
    'Centre of recognition and excellence private limited',
    'Rica technologies private limited',
    'IHYDRO INFRASTRUCTURE PROJECTS PRIVATE LIMITED',
    'Mectech exim private limited',
    'Axiom finsol (india) private limited',
    'Exact advisors & consulting private limited',
    'Mascot capital and marketing private limited',
    'Confianca advisory private limited',
    'Antfarm business incubator private limited',
    'FORK MEDIA GROUP PRIVATE LIMITED',
    'S-ANCIAL GLOBAL SOLUTIONS PRIVATE LIMITED',
    'Malabar lines private limited',
    'Theta audio private limited',
    'Seoul corporate services private limited',
    'Good earth maintenance private limited',
    'BT & BT MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'ARUNSHANTI ENTERPRISES PRIVATE LIMITED',
    'Sj engineers renewable energy private limited',
    'DESCON PRIVATE LIMITED',
    'Indcap advisors private limited',
    'Micro market research private limited',
    'Swift consumer search private limited',
    'Unived corporate research private limited',
    'Arisaig partners (india) private limited',
    'Indiva marketing private limited',
    'Siddhya services private limited',
    'Ksr financial and management services private limited',
    'Vaishali management and services private limited',
    'Spc management services private limited',
    'WD PARTNERS INDIA PRIVATE LIMITED',
    'Seven n consulting private limited',
    'HINES INDIA REAL ESTATE PRIVATE LIMITED',
    'Rvalue consulting private limited',
    'Mat india technologies private limited',
    'Edan medical india private limited',
    'Bharti enterprises (holding) private limited',
    'Autofocus consultants india private limited',
    'Apple facility services private limited',
    'Whiz meeting india private limited',
    'Balle tech services private limited',
    'Apex integrated marketing private limited',
    'Ample events & exhibitions private limited',
    'MDG CONSULTANTS AND ENGINEERS PRIVATE LIMITED',
    'Euphoria world travels private limited',
    'Ntop infosec private limited',
    'ARHAM BIOCHEM PRIVATE LIMITED',
    'AGSRV (INDIA) PRIVATE LIMITED',
    'Trizzone design consultancy services private limited',
    'BSPL OUTSOURCING PRIVATE LIMITED',
    'ANWAY INNOVENTURES LIMITED',
    'Ethnosynth consulting private limited',
    'Abha enviro care private limited',
    'GRIFFIN NAYZA ECO CONSTRUCTION PRIVATE LIMITED',
    'Original 21st century discoveries private limited',
    'Vaisons private limited',
    'Gbrn projects india private limited',
    'Anweshak intelligence investigation research and legal solutions private limited',
    'CORTEVA AGRISCIENCE SERVICES INDIA PRIVATE LIMITED',
    'Three sixty business strategic intelligence private limited',
    'Arks multiservices private limited',
    'CALSCIENTIFIC (INDIA) PRIVATE LIMITED',
    'Devapp tech solutions private limited',
    'TRADE2ONLINE PRIVATE LIMITED',
    'Shanta sriram property management services private limited',
    'Clientscape services india private limited',
    'Heiligen (worldwide) services private limited',
    'Hansa direct private limited',
    'Well kraft consulting private limited',
    'Mobiswipe technologies private limited',
    'Reach solar consulting private limited',
    'Corellis consultancy services private limited',
    'Bliss flow systems private limited',
    'GSH UTILITIES SERVICES PRIVATE LIMITED',
    'International waste management private limited',
    'Shiksha financial services india private limited',
    'Silicogene informatics private limited',
    'Contract pharmacal corporation india private limited',
    'Rina india private limited',
    'METRIC FINSERVE PRIVATE LIMITED',
    'Versatilist consulting india private limited',
    'Gem engserv private limited',
    'Alternate angle architects private limited',
    'Vivan aggregates private limited',
    'Viviana malls private limited',
    'Amity shipping enterprises private limited',
    'Blueshift education and training private limited',
    'SEAGATE SPECIALITY PRODUCTS PRIVATE LIMITED',
    'Finorion pharma india private limited',
    'Stell sign projects india private limited',
    'Nanjing iron and steel india private limited',
    'UNIORBIT PAYMENT SOLUTIONS PRIVATE LIMITED',
    'VERTOZ ADVERTISING LIMITED',
    'Sahaana digital music private limited',
    'Compact impex private limited',
    'Ph management services private limited',
    'Tanya educational management services private limited',
    'Rapid (india) logistics private limited',
    'Fashion coliseum private limited',
    'Raydans supplies private limited',
    'Sheth aviation private limited',
    'ONIV BEVERAGES PRIVATE LIMITED',
    'Digital ebrandz network private limited',
    'Ams freight solutions private limited',
    'Achieveee design & development private limited',
    'Stargems exports private limited',
    'CBREX TECHNOLOGIES PRIVATE LIMITED',
    'DOS MONKEYS MEDIA PRIVATE LIMITED',
    'Vfs data processing private limited',
    'Effective pmc private limited',
    'BESPOKE PLASTICS PRIVATE LIMITED',
    'FINSMART ACCOUNTING PRIVATE LIMITED',
    'Hyderabad angels forum for entrepreneurship development',
    'Vidgas science & technologies private limited',
    'Fair & faith consultants private limited',
    'INSTANTLY RESEARCH (INDIA) PRIVATE LIMITED',
    'I4 video analysis private limited',
    'True solve consultants private limited',
    'AKAG CONSULTING PRIVATE LIMITED',
    'City hawks manpower services and consultancy private limited',
    'V p r business advisory private limited',
    'Progen sas technologies india private limited',
    'Printemporio corporation private limited',
    'Glory consultancy private limited',
    'Snk solutions private limited',
    'RSM ASTUTE CONSULTECH PRIVATE LIMITED',
    'Sujav business private limited',
    'China telecom (india) private limited',
    'Izenbridge consultancy private limited',
    'Embee consultants private limited',
    'Modus information systems private limited',
    'Pm power consulting private limited',
    'Add energy management company private limited',
    'Associated search professionals private limited',
    'Icon cadsoft and surveyors (india) private limited',
    'Onebit consult private limited',
    'Lifeintelect consultancy private limited',
    'Afc corporate advisors private limited',
    'De valor management consultants private limited',
    'Macroscan management solutions private limited',
    'Biz2legal solutions private limited',
    'K. raheja services private limited',
    'Vedant consultancy pvt. ltd.',
    'Ema partners india private limited',
    'Selectema consulting india private limited',
    'VFS GLOBAL EDU SUPPORT SERVICES PRIVATE LIMITED',
    'Amideep investment consultants private limited',
    'Jefferies india private limited',
    'Laurus it solutions private limited',
    'Gungan consultancy private limited',
    'Khodiyar consultants private limited',
    'Luther corporate services private limited',
    'Aar consulting & services private limited',
    'White infrastructure private limited',
    'Surve infotech private limited',
    'Mrm corporate advisor private limited',
    'Ksp projects and consultants private limited',
    'RE SUSTAINABILITY IWM SOLUTIONS LIMITED',
    'Akshaya infra consultants private limited',
    'Maha hydraulics private limited',
    'Kriyaa consultants and engineers private limited',
    'Vector decision support services private limited',
    'Genius consultants ltd',
    'Shriram power & steel private limited',
    'Csi consulting private limited',
    'Sandeep technologies private limited',
    'Calex marine and industrial services private limited',
    'Techno specialist consulting engineers (kerala) private limited',
    'Tech india engineers private limited',
    'American unit (india) private limited',
    'Rolls-royce operations (india) private limited',
    'Dynatron private limited',
    'AURIONPRO TOSHI AUTOMATIC SYSTEMS PRIVATE LIMITED',
    'Protek projects private limited',
    'Aakshee elec solution private limited',
    'Saptarshi process private limited',
    'Adcon automation private limited',
    'Venson electric private limited',
    'Magtel power systems private limited',
    'Precitec precision machineries private limited',
    'Space office systems (india) private limited',
    'Delite systems engineering (india) private limited',
    'Gt electronic (india) private limited',
    'Levergent technologies india private limited',
    'Bellset entertainment private limited',
    'P.c.process private limited',
    'Ionidea infotech private limited',
    'Nextech electronics private limited',
    'Anshuman tech private limited',
    'CANARA STAR COMMUNICATIONS PRIVATE LIMITED',
    'Ramakrishna electro components private limited',
    'Veltron electronic devices private limited',
    'Tibrewala electronics ltd',
    'Accessteq systems private limited',
    'Persang entertainment private limited',
    'Euroscope communications private limited',
    'United telecoms limited',
    'Bhargava musik and krafts private limited',
    'Aarkay instruments private limited',
    'Labquip (india) private limited',
    'Solco biomedical co. india private limited',
    'Suyog medical private limited',
    'C j medical india private limited',
    'Hemodiaz life sciences private limited',
    'Process technique electronics private limited',
    'AMNEX INFOTECHNOLOGIES PRIVATE LIMITED',
    'Surgi aid lifecare private limited',
    'Southern surgicals private limited',
    'Sidd life sciences private limited',
    'Labinco instruments private limited',
    'Venus orthocare private limited',
    'MOHAM RETAIL PRIVATE LIMITED',
    'Jamsons health care private limited',
    'Chromous biotech private limited',
    'Optiline optics private limited',
    'Hourglass essentials private limited',
    'Calcutta south sales private limited',
    'Dkm online private limited',
    'Dharmeet automation private limited',
    'Pca motors private limited',
    'BEEAAR INFRA PRIVATE LIMITED',
    'Ghe automotive india private limited',
    'FENI PROJECT PRIVATE LIMITED',
    'ADIENT INDIA PRIVATE LIMITED',
    'Karmyog engineers private limited',
    'AKWEL AUTOMOTIVE PUNE INDIA PRIVATE LIMITED',
    'KUMARS FORGE & VALVES PRIVATE LIMITED',
    'Annai enterprises private limited',
    'Bnt marine crafts (india) private limited',
    'Andromeda shipping (india) private limited',
    'Safe and sure shipyard limited',
    'Afl private limited',
    'Legend technologies (india) private limited',
    'Dash auto engineering private limited',
    'Madhus garage equipments private limited',
    'Arpan international limited',
    'Orrlion gear hobs private limited',
    'Target furnitures private limited',
    'PRAVEEDH DECOR PRIVATE LIMITED',
    'DELLA LUXURY PRODUCTS PRIVATE LIMITED',
    'Seating world india private limited',
    'Pinnacle cases (india) private limited',
    'LA',
    'Mindbiz enterprise private limited',
    'Arpi enterprises (india) private limited',
    'Kwality ergo private limited',
    'Rnr facilities private limited',
    'Ringfeder power transmission india private limited',
    'FABRIC CONSULTANCY SERVICES PRIVATE LIMITED',
    'Phybusol computer solutions private limited',
    'Laayak corporate support solutions private limited',
    'Reveira marketing services private limited',
    'Innowell engineering international private limited',
    'ADBHUT JEWELLS PRIVATE LIMITED',
    'Sanghavi jewellery manufacturing company private limited',
    'Chain-n-chains jewels limited',
    'Varuna d jani fine jewellery private limited',
    'Avon tuff glass private limited',
    'Arya sports venture private limited',
    'Sure logistic control private limited',
    'Sulthan gold classic private limited',
    'MARUTI INTERIOR PRODUCTS LIMITED',
    'Inara exclusive handicrafts private limited',
    'Green it recycling centre private limited',
    'Ceeyes engineering industries private limited',
    'Bose infra energy india private limited',
    'Substation engineering services private limited',
    'Shs powers private limited',
    'BRUHAT ENERGY SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'Zen power india private limited',
    'Shree venus energy system private limited',
    'Enersan power private limited',
    'Brindavan hydropower private limited',
    'Dhar wind energy private limited',
    'Amboli power private limited',
    'Nilgiri power private limited',
    'Kalsubai power private limited',
    'SUNALPHA PROJECTS PRIVATE LIMITED',
    'Jamshedpur finance private limited',
    'VIKAS MONEY LIMITED',
    'RELIANT CREDITS (INDIA) LIMITED',
    'Ortem credit pvt.ltd.',
    'Ktvr enterprises limited',
    'Rajgul securities private limited',
    'Sunflower broking private limited',
    'Radhakrishna finance private limited',
    'Prince poly plast private limited',
    'RAJASTHAN STATE POWER FINANCE AND FINANCIAL SERVICES CORPORATION LIMITED',
    'Dhananjay international ltd',
    'Inzi controls india limited',
    'Gujarat road and infrastructure company limited',
    'AMER (BOMBAY) PRIVATE LIMITED',
    'Man global limited',
    'Meghraj financial consultants private limited',
    'AGRASHA ALLOYS AND METALS PRIVATE LIMITED',
    'N.bhau (jewellers) private limited',
    'Mahavir cotton private limited',
    'Goyam holdings limited',
    'Harshit finlease & investments private limited',
    'Brain point investment centre private limited',
    'Akshar fincom private limited',
    'J p r investments and trading private limited',
    'Deutsche equities india private limited',
    'ARTHASHASTRA FINSEC PROVIDERS PRIVATE LIMITED',
    'Realty investments private limited',
    'MUSTANG TRADING & INVESTMENTS PRIVATE LIMITED',
    'Kapil consultancy services private limited',
    'Anson chits india private limited',
    'Swaarjana chit funds private limited',
    'Rao brothers chit-fund (india) private limited',
    'Sadbhav realty private limited',
    'Nirantara finaccess private limited',
    'S & y advisory services private limited',
    'Alternative investments and credits limited',
    'Gas and power investment company limited',
    'A.p.i.d.c. venture capital private limited',
    'S.r.t.investments private limited',
    'A.n.investments private limited',
    'Permian investments private limited',
    'Chona financial services limited',
    'Silvestril iinvestments pvt ltd',
    'Nvs wealth managers private limited',
    'Jasper securities private limited',
    'Five rivers portfolio managers private limited',
    'Abhiram marketing services limited',
    'Makhathi insurance broker private limited',
    'Landmark insurance brokers private limited',
    'Aon fintech private limited',
    'M t r holdings private limited',
    'Asia pragati capfin private limited',
    'SHAH INVESTOR',
    'S CROP CARE LIMITED',
    'Ramky life sciences limited',
    'Vanamali organics private limited',
    'Vital syntheticlabs private limited',
    'Sorgen healthcare private limited',
    'Zoetic ayurvedics private limited',
    'Microchem silliker private limited',
    'SANSKAR AYURVEDIC LIFE CARE PRIVATE LIMITED',
    'Arbuda plastochem private limited',
    'Nuflower foods and nutrition private limited',
    'Martin and harris laboratories limited',
    'Acg arts and properties private limited',
    'Samrudh pharmaceuticals private limited',
    'Nikita transphase adducts pvt ltd',
    'Bio-ved pharmaceuticals private limited',
    'Serena pharma private limited',
    'Jash pharma private limited',
    'Kakinada seaports limited',
    'Vishnu industries private limited',
    'Aura soaps private limited',
    'Mafatlal enterprises limited',
    'Tainwala personal care products private limited',
    'Patcos cosmetics (india) pvt ltd',
    'Chettinad morimura semiconductor material private limited',
    'GAIL MANGALORE PETROCHEMICALS LIMITED',
    'Imperial oilfield chemicals private limited',
    'Basf chemicals india private limited',
    'Umano healthcare private limited',
    'Ashish synthetics private limited',
    'ACE TYRES PRIVATE LIMITED',
    'POLYPLASTICS DECORATIVE PRIVATE LIMITED',
    'Roulunds braking india private limited',
    'Shri geeta sacks private limited',
    'Standard polymers private limited',
    'Silverstone rubber india private limited',
    'Tex year industrial adhesives private limited',
    'Bansal plastopack private limited',
    'Pankaj polytec private limited',
    'Fenner conveyor belting private limited',
    'Speed plastics healthcare (india) private limited',
    'Guy plasts p.ltd.',
    'Wellmac plastics private limited',
    'Biotec bags india private limited',
    'Ketan plastic industries private limited',
    'AALISHAN PETRO PRODUCTS PRIVATE LIMITED',
    'Sneha packers private limited',
    'Surabhi latex private limited',
    'Falcon pipes private limited',
    'Eschmann textures india private limited',
    'Ameenji rubber private limited',
    'Allied global plastics private limited',
    'Safepack lamination and liners limited',
    'Vactech composites private limited',
    'Ssf plastics india private limited',
    'Vipul plastic pvt ltd',
    'Sree plast private limited',
    'Saksham engineering private limited',
    'Samyu glass private limited',
    'Fg glass industries private limited',
    'Jb rolling mills limited',
    'Ntf (india) private limited',
    'Goa glass fibre limited',
    'Kushal timber private limited',
    'Trimex aggregates and binders private limited',
    'BOROSIL LIMITED',
    'Solaris ceramics private limited',
    'Iolite cube inframaterial limited',
    'P-LINE ELECTRICAL PRIVATE LIMITED',
    'Arora refractories private limited',
    'Konark infrastructure limited',
    'MOUR MARBLE INDUSTRES PRIVATE LIMITED',
    'Dhairya mercantile private limited',
    'Rushabh lifestyle private limited',
    'Hetal chem impex pvt.ltd.',
    'Edgecube private limited',
    'Premier health care products private limited',
    'Gautam zen international private limited',
    'Aavicular tensile structures private limited',
    'India techs limited',
    'PUNE GAS PROJECTS PRIVATE LIMITED',
    'Ksn impex private limited',
    'Bss worldwide private limited',
    'Tirupati agencies pvt ltd',
    'Sopan merchants pvt ltd',
    'Trikaya electricals & electronics private limited',
    'Tarita trading private limited',
    'Pragyaat trading private limited',
    'Canyon tradeplace private limited',
    'Zipper mercantiles pvt.ltd.',
    'EXPREZY LOGISTICS PRIVATE LIMITED',
    'Swiss park vanijya pvt ltd',
    'Goldfield commodities pvt ltd',
    'Cornet commotrade pvt. ltd.',
    'Atithi dealers pvt ltd',
    'Bpg agencies pvt.ltd.',
    'Ashish vinimay private limited',
    'Narottamka trade & vyapaar pvt ltd',
    'Kaleidoscope events private limited',
    'Abdos oils pvt ltd',
    'Gourmet logistics private limited',
    'Suminter india organics private limited',
    'Rich fruits private limited',
    'Rashi agro industries private limited',
    'Crust n crumb food ingredients private limited',
    'JAY BHARAT FOOD PROCESS PRIVATE LIMITED',
    'Sfg exports (india) private limited',
    'Ons creation private limited',
    'Goverdhan india private limited (t)',
    'Nahar textiles pvt ltd',
    'Pragati stockcom private limited',
    'Transpol impex private limited',
    'TRANSTEL UTILITIES PRIVATE LIMITED',
    'Grace sales private limited',
    'Realm intermediates private limited',
    'KCK DIRECT PRIVATE LIMITED',
    'Rhr medicare private limited',
    'F n z jewels private limited',
    'Katti-ma exports private limited',
    'Mavani synthetic lubricants private limited',
    'Krishna transnational marbles private limited',
    'Goyal dhatu udyog private limited',
    'Shree jaysurya steels private limited',
    'Nandadeep precast prestressed concretes private limited',
    'Adnani exports limited',
    'BANG PAPER & BOARDS PRIVATE LIMITED',
    'Knit-fab technics p ltd',
    'Wonder commercial private limited',
    'Jmd all-car-mall private limited',
    'Avsar automotive private limited',
    'Danblock brakes india private limited',
    'True count systems private limited',
    'TIRUPATI ELECTRIFY SHOPS PRIVATE LIMITED',
    'Sysconnect technologies (india) private limited',
    'Shade flex india private limited',
    'Brijraj auto private limited',
    'Sugam securities pvt ltd',
    'VARUN BROKING INDIA LIMITED',
    'Behat holdings limited',
    'Azure capital advisors private limited',
    'Moonbeam advisory private limited',
    'Shan international money exchange private limited',
    'Spur cable and datacom private limiited',
    'Manohar capital markets limited',
    'Ambfs private limited',
    'J. p. morgan advisors india private limited',
    'MASITIA CAPITAL SERVICES Private Limited',
    'Travelex india private limited',
    'Piramal fund management private limited',
    'Ask wealth advisors private limited',
    'SBFC FINANCE LIMITED',
    'Trimurti towers private limited',
    'Gsc intime services private limited',
    'Bihariji share trading private limited',
    'Solidarity advisors private limited',
    'S-ancial finserv private limited',
    'Nabriya financial services private limited',
    'SATTWA ADVISORY PRIVATE LIMITED',
    'INTEGRATED INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'SAMEER INFRAPOWER PRIVATE LIMITED',
    'Enticement infrastructure private limited',
    'Everzone constructions private limited',
    'Bpk holdings private limited',
    'Anand azco infracon india private limited',
    'ARDENTE TOWNSHIPS PRIVATE LIMITED',
    'Sizzle properties private limited',
    'Frontier living greenfield developers private limited',
    'Preserve property solutions private limited',
    'Valleyview realtors and construction private limited',
    'Queens villa developers private limited',
    'Karbors estate private limited',
    'Silver complex private limited',
    'Neelyog builders private limited',
    'Pankti housing private limited',
    'Exotica realtors private limited',
    'Mangalnath developers (india) private limited',
    'Vishnoi realty private limited',
    'Northface housing & marketix india private limited',
    'Gajoa realters private limited',
    'V m estate private limited',
    'Skylark mansions private limited',
    'The fringford estates ltd',
    'Torse holdings private limited',
    'Kumar properties private limited',
    'Sandhurst builders private limited',
    'Dpn realty deals private limited',
    'Annapurna infracon private limited',
    'VIRAT BUILDHOME PRIVATE LIMITED',
    'Ryc properties limited',
    'Lancor maintenance & services limited',
    'Srikar & associates private limited',
    'Madras madurai properties private limited',
    'Sri durga foundations private limited',
    'Pragati 47 development limited',
    'Zodiac reprographics private limited',
    'Enablers property services private limited',
    'Nautical lines private limited',
    'Matrix lines private limited',
    'Megha pro facility management private limited',
    'Savant automation private limited',
    'Arthasri impex private limited',
    'Ark blueprint enterprises private limited',
    'Hyaline enviro engineers private limited',
    'Global hoppers private limited',
    'Srb distribution house private limited',
    'Arostar enterprises private limited',
    'Prime testing services private limited',
    'Unirobo solutions private limited',
    'Sriv testing consultants hub private limited',
    'Tranz india corporate network private limited',
    'Poorvanchal lifecare private limited',
    'Komax embossing private limited',
    'Voiture agencies private limited',
    'Shree ram electrocast (jharkhand) private limited',
    'Shree krishna chambers facility management private limited',
    'Sea bird commosale private limited',
    'Onsite electro services private limited',
    'Bpc consultant india private limited',
    'Mirams training services (india) private limited',
    'Prolific hr consultants (india) limited',
    'Ace search consultants private limited',
    'B maps advisory services private limited',
    'Reis staffing and hr services private limited',
    'TALENT SYSTEMS INDIA PRIVATE LIMITED',
    'TEAM HR SERVICES PRIVATE LIMITED',
    'Job cookies india private limited',
    'Aditi placement services private limited',
    'Vectra glosec private limited',
    'Integrity verification services private limited',
    'CONVOY SECURE LIMITED',
    'Sharks safety (chennai) private limited',
    'Lockheed martin india private limited',
    'Babydoll and wizkid communication pvt. ltd.',
    'Shree arun packaging company private limited',
    'Athena superpack private limited',
    'Vir auto part brands private limited',
    'Hempel paints (india) private limited',
    'Firescan safety systems private limited',
    'Reva shipping private limited',
    'Vibhatsu services private limited',
    'PEPPERFRY LIMITED',
    'Prov infotech systems private limited',
    'Kshirsagar wealth management advisors private limited',
    'International traceability systems limited',
    'Mape securities private limited',
    'Vogue career options private limited',
    'Mam interiors private limited',
    'Tahiliani design private limited',
    'Super creations interiors & exteriors private limited',
    'Mmc doortech services private limited',
    'Pan godavari lace facilities and services private limited',
    'Ctm india limited',
    'Swatch group (india) private limited',
    'Motherson innovative technologies and research',
    'Oxfam india',
    'Maxam india private limited',
    'Endure software solutions private limited',
    'Melea outsourcing services private limited',
    'Shubhram hospital solutions private limited',
    'Universal electrical services and maintenance private limited',
    'Cnb commodities private limited',
    'Oneten mobility services private limited',
    'Aquimo sports private limited',
    'Aron universal limited',
    'San solution (india) private limited',
    'Exalt consulting placement services private limited',
    'Astrapia upvc tech private limited',
    'Mobi esprits software technologies private limited',
    'Brightfort security & allied services private limited',
    'CROSSGROW PRIVATE LIMITED',
    'Irene hifab contracts private limited',
    'Damani impex private limited',
    'Paradigm services private limited',
    'Clearcorp dealing systems (india) limited',
    'ROTHSHIELD INSURANCE TPA LIMITED',
    'All services global private limited',
    'Rosoboronservice (india) limited',
    'SEATRIUM ENGINEERING MUMBAI PRIVATE LIMITED',
    'Svan analytical instruments private limited',
    'Market city management private limited.',
    'Vishvaraj environment private limited',
    'Arena india private limited',
    'Brandstik solutions private limited',
    'Advait medicom & research institute private limited',
    'Alpha terminals private limited',
    'Dhhanish advisors private limited',
    'International institute of diamond grading and research india private limited',
    'Unicorp utilities strainers private limited',
    'Swastik terminals private limited',
    'Ukay valves and founders private limited',
    'Technospan structures private limited',
    'Pacific forgings and fasteners pvt ltd',
    'Optech engineering private limited',
    'Neo sun industries limited',
    'Fort consultants private limited',
    'Gansons engineers private limited',
    'Sinner engineering file works private limited',
    'Sutantra engineering private limited',
    'Techniques surfaces india private limited',
    'Maruti hardware products private limited',
    'Sonic weld private limited',
    'Precision adhesive tapes private limited',
    'Duro-finish engineering private limited',
    'Dynamic engitech private limited',
    'Indutch composites technology private limited',
    'Ashirwad mechtech private limited',
    'Econ machinery private limited',
    'Vesta equipment private limited',
    'JENDAMARK INDIA PRIVATE LIMITED',
    'Iew cranes private limited',
    'Swastik cutmac and lubes private limited',
    'Fortpoint automotive pvt ltd',
    'Sira engineering private limited',
    'Avr valves private limited',
    'Process pumps ( india ) private limited',
    'Liberty pipe accessorirs pvt ltd',
    'Vijai hydraulik (india) private limited',
    'Ingwenya mineral tech private limited',
    'Sarjan energytech private limited',
    'Delco machines private limited',
    'Jv roulements international private limited',
    'Aditya cranes private limited',
    'Futurepump (india) private limited',
    'Technosys equipments private limited',
    'Symtec engineers private limited',
    'Communications and systems engineering (case) private limited',
    'TECH ELECON PRIVATE LIMITED',
    'Reliance fabrications private limited',
    'Ducool india private limited',
    'Kpf engineers private limited',
    'Amtrex equipments private limited',
    'Value refrigerants private limited',
    'Ankit cooling systems private limited',
    'Ut pumps and systems private limited',
    'Vimal fire controls private limited',
    'Alpha helical pumps private limited',
    'Fabcon technologies private limited',
    'S.s.heat recover engineers india private limited',
    'AIMS INDUSTRIES PRIVATE LIMITED',
    'Shivam computers pvt ltd',
    'Pragati automation private limited',
    'Schumak equipment india private limited',
    'Zetor india private limited',
    'HELMER ELECTRICALS LIMITED',
    'Cirus solar private limited',
    'Makvin automation private limited',
    'Minifab enterprises private limited',
    'Thermoplay india private limited',
    'Surefire die-casting technologies private limited',
    'Maha x-ray equipments private limited',
    'HAVER & BOECKER INDIA PRIVATE LIMITED',
    'Icare lifts private limited',
    'Sealwell systems private limited',
    'Tiny controls private limited',
    'Apollo hawkeye pedershaab concrete technologies private limited',
    'West india equipments private limited',
    'Decker devices private limited',
    'Dopag india private limited',
    'Solarsys photonic energy private limited',
    'Lubsa multilub systems private limited',
    'Infra automotive services india private limited',
    'Gce india private limited',
    'Sri parijatha machinery works private limited',
    'Snskar systems india private limited',
    'Komal chemiequip private limited',
    'Sutantra machines private limited',
    'Wetzel technologies private limited',
    'Ids technologies india private limited',
    'Gtf marine technology india private limited',
    'Xinhu pumps private limited',
    'Steel process equipments private limited',
    'Pharma spares private limited',
    'Eha ventures private limited',
    'Zion precision private limited',
    'B & c machinery limited',
    'National heat pumps private limited',
    'Kartar engineering works india private limited',
    'Mamata machinery private limited',
    'Airvak blowers private limited',
    'Jergens india private limited',
    'Tej engineering private limited',
    'Oleo buffers india private limited',
    'JNK INDIA LIMITED',
    'Duratech automation private limited',
    'SUSHMA ENGINEERING PRIVATE LIMITED',
    'Bep engineering private limited',
    'Vivin instruments private limited',
    'Dalal machine tools agency private limited',
    'Mineman management systems private limited',
    'Asymmetrix solutions private limited',
    'Reliable it services private limited',
    'Adonis systemz private limited',
    'Roambee services (india) private limited',
    'Advantics solutions private limited',
    'Blue diamond infotech private limited',
    'Instigence technology private limited',
    'Pebstone infotech private limited',
    'ULTRIA SOFTWARE PRIVATE LIMITED',
    'Transtrac technology services private limited',
    'Aew infotech private limited',
    'Boghi engineering & software technologies private limited',
    'Spino technologies private limited',
    'LEADIT INDIA PRIVATE LIMITED',
    'Vyapin software systems private limited',
    'Wells fargo international services private limited',
    'Lorven technologies private limited',
    'Audex solutions and technology private limited',
    'Gts systems (india) private limited',
    'Tiatros technologies private limited',
    'Unigrow solutions private limited',
    'Bluebell engineering solutions private limited',
    'Miraci technology private limited',
    'Intec technologies private limited',
    'Intec customer relationship management private limited',
    'Ar network nuts private limited',
    'Id technologies private limited',
    'Estro web services private limited',
    'Wasabi digital private limited',
    'Anoop concepts private limited',
    'Seobaba services private limited',
    'Molded bits technologies private limited',
    'Vansh infomedia private limited',
    'Revitas technologies private limited',
    'Banu web technologies private limited',
    'Full stop technologies private limited',
    'Informage techno solutions private limited',
    'Cerebrum systems private limited',
    'United techno projects private limited',
    'Star cable infonet private limited',
    'Frontier hr and payroll private limited',
    'Textual analytics solutions private limited',
    'Conceptia software technologies private limited',
    'Manrulan engineering and innovations private limited',
    'Mangrove integrated solutions private limited',
    'Cvc network india private limited',
    'INFINODO TECHNOLOGY PRIVATE LIMITED',
    'Vuelogix technologies private limited',
    'Hifx learning services private limited',
    'Supply chain management it services private limited',
    'Phi creative solutions private limited',
    'Asymmetrique communications private limited',
    'Vitae international accounting services private limited',
    'Trunkoz technologies private limited',
    'Mak techserve private limited',
    'Digi jodhpur network private limited',
    'Digi samlakha network private limited',
    'Optimus it services private limited',
    'Digi om network private limited',
    'Isg esolutions private limited',
    'Microcom solution private limited',
    'Digital hi-ways private limited',
    'Gep solutions private limited',
    'Beyond future interactive private limited',
    'Zeto information technologies private limited',
    'Interactive info-com (india) private limited',
    'PAYNX TECHNOLOGIES PRIVATE LIMITED',
    'Vilva infotech private limited',
    'Myconnect internet marketing private limited',
    'Real infotechnologies private limited',
    'Orane infotech private limited',
    'Logiio technologies private limited',
    'SQUAREONE INSIGHTS PRIVATE LIMITED',
    'Opentech ventures private limited',
    'Careerpath technologies (india) private limited',
    'MDINDIA HEALTH INSURANCE TPA PRIVATE LIMITED',
    'Sela technology solutions (india) private limited',
    'Ackcezione technologies private limited',
    'ACCOPS SYSTEMS PRIVATE LIMITED',
    'Parallel wireless india private limited',
    'Hindavi technologies private limited',
    'Semicolon technologies private limited',
    'Hitha design science private limited',
    'Grit-innovation software private limited',
    'Classle knowledge private limited',
    'WOLTERS KLUWER ELM SOLUTIONS PRIVATE LIMITED',
    'I-elementz it consultancy services private limited',
    'Omega it resources private limited',
    'Vdart software services private limited',
    'XEBIA NDS INDIA PRIVATE LIMITED',
    'Eone technologies private limited',
    'Brigosha technologies private limited',
    'Lorentz india private limited',
    'Apotex research private limited',
    'Genelon institute of life science private limited',
    'Aashraya technologies private limited',
    'Andaman aviation private limited',
    'Girisons airways private limited',
    'L.g.brothers logistics private limited',
    'Gdpk returnable solutions india private limited',
    'Orange destinations private limited',
    '24 hours travel services private limited',
    'Air guru travel solutions private limited',
    'Ant logistics private limited',
    'Lima shipping and dredging private limited',
    'Sterling sea air freight express private limited',
    'Egl supplychain private limited',
    'Zener maritime solutions private limited',
    'Trp logistics private limited',
    'Bulktrans logistics private limited',
    'YATHARTH NETWORK SOLUTIONS PRIVATE LIMITED',
    'Apl logistics (india) private limited',
    'Hercules logistics private limited',
    'Om freight forwarders private limited',
    'Balaji seaways private limited',
    'Oasis express cargo and logistics private limited',
    'Paras power and coal benefication limited',
    'Nagapattinam energy private limited',
    'Auro mira bio systems kanyakumari private limited',
    'Adani power dahej limited',
    'Samples corporate gifting (india) private limited',
    'MANAPPURAM CONSTRUCTION AND CONSULTANTS LIMITED',
    'Nirvana crafthouse private limited',
    'Losange jewels private limited',
    'GENERA ONLINE PRIVATE LIMITED',
    'Igl gemstones private limited',
    'JEWEELKRAFT CREATIONS PRIVATE LIMITED',
    'Fast commodity markets limited',
    'Pewturman decor private limited',
    'ROOPSHRI RESORTS LIMITED',
    'Auro furniture & fitouts private limited',
    'Trishul erectors p ltd',
    'Sudarshan builders private limited',
    'HARICHANDANA DEVELOPERS PRIVATE LIMITED',
    'Trendsetter constructions private limited',
    'Mks industries limited',
    'Saks energy trading private limited',
    'Shree hydropower private limited',
    'Jayshe gas power private limited',
    'Snehvardhini properties private limited',
    'Ramsons refractories private limited',
    'Swapnadhara project private limited',
    'Ray property developers private limited',
    'Klassic construction (gujarat) private limited',
    'Cosmo integrated solarz private limited',
    'Himalaya technocrate and security services private limited',
    'Achal infrastructure private limited',
    'Kgk creations private limited',
    'Shaurya-veer constructions private limited',
    'Chambal infrastructure ventures limited',
    'Radium projects private limited',
    'Gap associates private limited',
    'J. p. infra (mumbai) private limited',
    'J.p.infra (india) private limited',
    'Kothari and kanakia land developers private limited',
    'Viva poddar housing private limited',
    'Sarvasadhu realtors private limited',
    'Lak realty and infrastructures private limited',
    'BANDAY HOSPITALITY PRIVATE LIMITED',
    'SEEDSTATION PRIVATE LIMITED',
    'Hov infrastructure private limited',
    'T AND T INFRA LIMITED',
    'Abhijit pethkar constructions private limited',
    'Raj realty private limited',
    'Isitva ventures private limited',
    'Vk projects private limited',
    'Ho hup construction company (india) private limited',
    'Paramount building solutions private limited',
    'NEOVANTAGE TECH PARK PRIVATE LIMITED',
    'MN GACHIBOWLI II TECH PARK PRIVATE LIMITED',
    'Sri jayam housing & constructions private limited',
    'Sabari infopark private limited',
    'Windsor villas private limited',
    'Miras properties private limited',
    'S b m shelters private limited',
    'Gae projects private limited',
    'Jacaranda properties private limited',
    'Vriddhi realtors private limited',
    'Shree rsh projects private limited',
    'Lalganga builders private limited',
    'Navbharat dwellings private limited',
    'Moolchand industrial estates pvt ltd',
    'Acorn buildtech private limited',
    'Ai infrastructures private limited',
    'Ruhil promoters private limited',
    'Haamid real estates private limited',
    'Gl homes private limited',
    'Dwarkesh realty private limited',
    'BAYO AGRO VET PRIVATE LIMITED',
    'Sarjan construction private limited',
    'Pride organisers private limited',
    'Mascot infrastructure (i) private limited',
    'Amsoft projects private limited',
    'Elhanan management services private limited',
    'Aryabhangy builders private limited',
    'Marymatha constructions private limited',
    'Sunil developers private limited',
    'Manmandir properties private limited',
    'Network developers private limited',
    'Adarsh residency private limited',
    'Sonie india construction private limited',
    'M constructions private limited',
    'Kanika developers private limited',
    'Bhausaheb saloni ninath lata land developers private limited',
    'Four d estates private limited',
    'Deccan plateau projects private limited',
    'Bedi infrastructure private limited',
    'CASADEL AND SPACETON BUILDERS PRIVATE LIMITED',
    'Caravan freight carrier private limited',
    'Maskati shipping and logistics private limited',
    'NAVEEN WAREHOUSING & LOGISTICS PRIVATE LIMITED',
    'Premier transport limited',
    'Mse forwarders india private limited',
    'Tci hi-ways private limited',
    'Transocean freight services private limited',
    'Wan hai lines (india) private limited',
    'Neo logistics private limited',
    'B.s.v.shipping agencies private limited',
    'WILH LOESCH SEA LAND INDIA PRIVATE LIMITED',
    'M and c aviation india private limited',
    'Menzies aviation bobba (bangalore) private limited',
    'Conceptum logistics india private limited',
    'Air cargo integrators private limited',
    'Darpan transport private limited',
    'Connect warehousing private limited',
    'Sai samhita storages private limited',
    'Pds logistics centre private limited',
    'NIYAMA EQUIPMENTS PRIVATE LIMITED',
    'Acme warehousing private limited',
    'Cpc logistics limited',
    'E to e consultancy private limited',
    'Bvm storage solutions private limited',
    'E to e operations and maintenance private limited',
    'E to e transportation training services private limited',
    'Pawar logistics solutions private limited',
    'Creative port development private limited',
    'Glentrans shipping & logistics (i) private limited',
    'YAK GLOBAL SERVICES PRIVATE LIMITED',
    'Magical holidays private limited',
    'ABHINAV IMMIGRATION SERVICES PRIVATE LIMITED',
    'INTERGLOBE ENTERPRISES PRIVATE LIMITED',
    'Emu lines private limited',
    'Aa bee resort and travel pvt ltd',
    'Delmos aviation private limited',
    'Discovery journeys india private limited',
    'Quovadis travels private limited',
    'Chetak international private limited',
    'Riding house travels private limited',
    'Blue carpet conferences & events private limited',
    'Blissful world tours private limited',
    'Inbound india holidays private limited',
    'Tourism corporation of gujarat limited',
    'Ace resorts and infrastructure private limited',
    'Nippon konpo india private limited',
    'Suhalaya travels private limited',
    'Northstar hospitality private limited',
    'Focuz voyages private limited',
    'SOMAN',
    'S GLOBAL TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'AKRITRIM TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'SEDANI DIGITAL PRIVATE LIMITED',
    'MADBEE MOBILITY SOLUTIONS PRIVATE LIMITED',
    'JIVA DIGITAL SERVICES PRIVATE LIMITED',
    'CONFIDOSOFT SOLUTIONS PRIVATE LIMITED',
    '3SG ONLINE SOLUTIONS PRIVATE LIMITED',
    'POZITIVE INFOCOM PRIVATE LIMITED',
    'SCUTI TECH LABS PRIVATE LIMITED',
    'AMOEBOIDS TECHNOLOGIES PRIVATE LIMITED',
    'QUANTRELLO DIGITAL PRIVATE LIMITED',
    'EFFICACE SOFTWARE PRIVATE LIMITED',
    'ARLAN TECHNOLOGIES PRIVATE LIMITED',
    'NECURITY SOLUTIONS NETWORK SECURITY PRIVATE LIMITED',
    'SPARSKILLS TECHNOLOGIES PRIVATE LIMITED',
    'RAJAN & RAJAN ONLINE SERVICES PRIVATE LIMITED',
    'SHEEN TELECOM CONSULTANTS PRIVATE LIMITED',
    'APOXY MEDIA PRIVATE LIMITED',
    'KSPOTFI SYSTEMS INDIA PRIVATE LIMITED',
    'KONTIKI SOFTWARE LABS PRIVATE LIMITED',
    'ZAINARCO LABS PRIVATE LIMITED',
    'MOBIPAY SECURISERVICES PRIVATE LIMITED',
    'OMNICARE DRUGS INDIA PRIVATE LIMITED',
    'CFMID LIMITED',
    'COUNTWHEEL SOLUTIONS PRIVATE LIMITED',
    'BIGGERIT PRIVATE LIMITED',
    'GLOBALIZATION HR SOLUTIONS INDIA PRIVATELIMITED',
    'GETON INFOTECH PRIVATE LIMITED',
    'OLIVER INHOUSE INDIA PRIVATE LIMITED',
    'MGO INDIA PRIVATE LIMITED',
    'TOPS SECURITY PRIVATE LIMITED',
    'RIVERSTREAMS COMMUNICATIONS PRIVATE LIMITED',
    'LEXIAL AEROSPACE PRIVATE LIMITED',
    'INDO-DUTCH CHAMBER OF BUSINESS AND SCIENCES',
    'AMPSOLAR PROJECTS PRIVATE LIMITED',
    'INSIGHTGEEKS SOLUTIONS PRIVATE LIMITED',
    'PPN SOLUTIONS PRIVATE LIMITED',
    'ENGRAVE SOFT SOLUTIONS PRIVATE LIMITED',
    'PARASOFT INDIA PRIVATE LIMITED',
    'TEAMSID GAMING SOLUTIONS PRIVATE LIMITED',
    'ARDENT MAINTENANCE TECHNOLOGIES PRIVATE LIMITED',
    'PRAGNAA SHREE VENTURE INDIA PRIVATE LIMITED',
    'MAKEPATH TECHNOLOGIES PRIVATE LIMITED',
    'HOZI DIGITAL INDIA PRIVATE LIMITED',
    'JUNE GAMING PRIVATE LIMITED',
    'D.M. E-COMMERCE PRIVATE LIMITED',
    'QUALPRO COMPLIANCE SERVICES PRIVATE LIMITED',
    'NUMENTICA PRIVATE LIMITED',
    'ARCANE ASSURED SERVICES PRIVATE LIMITED',
    'KARUNYA HEAVY ENGINEERING PRIVATE LIMITED',
    'TEACHERPRAXIS FOUNDATION',
    'AFFNIX DIGITAL MEDIA PRIVATE LIMITED',
    'DEFRAG SOFTWARE LABS PRIVATE LIMITED',
    'WIMD TECHNOLOGIES PRIVATE LIMITED',
    'AMEEGO LABS PRIVATE LIMITED',
    'AUTOMATAPI SOLUTIONS PRIVATE LIMITED',
    'KAFAL SOFTWARE PRIVATE LIMITED',
    'RECORP GLOBAL SERVICES PRIVATE LIMITED',
    'NICOS CORPORATE SERVICES PRIVATE LIMITED',
    'THAYA CONSULTING PRIVATE LIMITED',
    'INCULCATION EXIM PRIVATE LIMITED',
    'WELTECH DESIGNERS PRIVATE LIMITED',
    'PAHADI GOODNESS PRIVATE LIMITED',
    'CREDWOLF CONSULTANCY SERVICES PRIVATE LIMITED',
    'WIHOMESMART SOLUTIONS PRIVATE LIMITED',
    'HNW SOLUTIONS PRIVATE LIMITED',
    'HANAENI SERVICES PRIVATE LIMITED',
    'FARISHTEY LOGISTICS PRIVATE LIMITED',
    'REALTA APPLICATIONS PRIVATE LIMITED',
    'REDCLIFFE HYGIENE PRIVATE LIMITED',
    'UGAM MANAGEMENT PRIVATE LIMITED',
    'EDUWORK INTERNATIONAL SERVICES PRIVATE LIMITED',
    'TILEKART PRIVATE LIMITED',
    'AMPSOLAR ENERGY PRIVATE LIMITED',
    'HOPAKA TECHNOLOGIES PRIVATE LIMITED',
    'VGMINDS TECHSTUDIOS PRIVATE LIMITED',
    'NUOFOX LABS PRIVATE LIMITED',
    'KALIBROIDA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'BLG CONSULTING INDIA PRIVATE LIMITED',
    'JEEVAN JYOTI CORPORATE MICRO FEDERATION',
    'CONSCENDO INDIA PRIVATE LIMITED',
    'RAKUTEN TRAVEL SOLUTIONS INDIA PRIVATE LIMITED',
    'ELBON CONFERENCES AND EVENTS PRIVATE LIMITED',
    'MULTI NANO SENSE TECHNOLOGIES PRIVATE LIMITED',
    'NJT NETWORK PRIVATE LIMITED',
    'INTEGRATED CITY O&M SERVICES PRIVATE LIMITED',
    'QAFIE PROJECTS PRIVATE LIMITED',
    'MADHYA PRADESH TOURISM BOARD',
    'SHAN DIAGNOSIS PRIVATE LIMITED',
    'SURAJGARH FARMS PRIVATE LIMITED',
    'WINFORT SERVICES PRIVATE LIMITED',
    'DBL MAHAGAON YAVATMAL HIGHWAYS PRIVATE LIMITED',
    'THREE SIXTY TRIP LEISURE PRIVATE LIMITED',
    'GENESIS UTILITIES PRIVATE LIMITED',
    'VN GLOBAL EDUCATIONAL CONSULTANTS PRIVATE LIMITED',
    'PAUL EQUITY HOLDINGS PRIVATE LIMITED',
    'MOBILITY INFRASTRUCTURE PROJECTS PRIVATELIMITED',
    'MEGBUILD DEVELOPERS PRIVATE LIMITED',
    'AMEEBA INFRASTRUCTURE MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'MONTECARLO HUBLI HAVERI HIGHWAY PRIVATE LIMITED',
    'SUMMIT RESIDENCY PRIVATE LIMITED',
    'MONTECARLO SINGHARA BINJHABAHAL HIGHWAY PRIVATE LIMITED',
    'VARANASI SANGAM EXPRESSWAY PRIVATE LIMITED',
    'NAYOSHA DEVELOPERS PRIVATE LIMITED',
    'OPTELLIGENT TECHNOLOGIES PRIVATE LIMITED',
    'SATTAM INFRATECH PRIVATE LIMITED',
    'NAGPUR INTEGRATED TOWNSHIP PRIVATE LIMITED',
    'SADBHAV VIDARBHA HIGHWAY LIMITED',
    'APCO CHETAK ULTRAWAY PRIVATE LIMITED',
    'SHAPOORJI PALLONJI REAL ESTATE PRIVATE LIMITED',
    'WIDE ANGLE INFRASPACE PRIVATE LIMITED',
    'KAASYAPA DEVELOPERS PRIVATE LIMITED',
    'KATAKSHA VENTURES PRIVATE LIMITED',
    'TP AJMER DISTRIBUTION LIMITED',
    'WIND FIVE RENERGY LIMITED',
    'MADDIMADUGU POWER PRIVATE LIMITED',
    'VASUPRADA RENEWABLES PRIVATE LIMITED',
    'TRANSATLANTIC INFRAPROJECTS PRIVATE LIMITED',
    'LOMA CO-DEVELOPERS 1 PRIVATE LIMITED',
    'WIND ONE RENERGY LIMITED',
    'AZURE POWER ROOFTOP PRIVATE LIMITED',
    'KR SOLAR POWER PRIVATE LIMITED',
    'WIND THREE RENERGY LIMITED',
    'TRANSATLANTIC CONSTRUCTION PRIVATE LIMITED',
    'DBL WARDHA BUTIBORI HIGHWAYS PRIVATE LIMITED',
    'CASME INDUSTRIAL AND COMMERCIAL DEVELOPMENT PRIVATE LIMITED',
    'AACP INFRASTRUCTURE SYSTEMS PRIVATE LIMITED',
    'ASHOKA AEROSPACE PRIVATE LIMITED',
    'AXIS WIND FARMS (KALYANDURG) PRIVATE LIMITED',
    'RACANAA INNOVATIVE SOLUTIONS ENERGY PRIVATE LIMITED',
    'AXIS WIND FARMS (AMIDYALA) PRIVATE LIMITED',
    'AXIS WIND FARMS (BELUGUPPA) PRIVATE LIMITED',
    'RISLAND DEVELOPMENT PRIVATE LIMITED',
    'S&T DEVELOPERS (KERALA) PRIVATE LIMITED',
    'ASHOKA RANASTALAM ANANDAPURAM ROAD LIMITED',
    'SP-NMJ PROJECT PRIVATE LIMITED',
    'ECOGREEN ENERGY GWALIOR PRIVATE LIMITED',
    'WIND TWO RENERGY PRIVATE LIMITED',
    'LOMA CO-DEVELOPERS 2 PRIVATE LIMITED',
    'DBL YAVATMAL WARDHA HIGHWAYS PRIVATE LIMITED',
    'SUSWIND POWER PRIVATE LIMITED',
    'RIPUDAMAN URJA PRIVATE LIMITED',
    'INDIS VENTURA HOLDINGS PRIVATE LIMITED',
    'BHUTRA FINANCE AND TRADING PRIVATE LIMITED',
    'SATIN HOUSING FINANCE LIMITED',
    'SARVAPRIYA HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'BHAVAN INFRASTRUCTURES PRIVATE LIMITED',
    'WHITEOAK CAPITAL ASSET MANAGEMENT LIMITED',
    'OHMY LOAN PRIVATE LIMITED',
    'AXIS WIND FARMS (KRISHNA) PRIVATE LIMITED',
    'SANFORD C. BERNSTEIN (INDIA) PRIVATE LIMITED',
    'AXIS WIND FARMS (GOLLA) PRIVATE LIMITED',
    'MU WIND POWER PRIVATE LIMITED',
    'THREE WHEELS CAPITAL PRIVATE LIMITED',
    'DIVA TRAVELS PRIVATE LIMITED',
    'OHM DOVETAIL PRIVATE LIMITED',
    'AXIS WIND FARMS (RAKETLA) PRIVATE LIMITED',
    'CNTC INDIA CONSTRUCTION PRIVATE LIMITED',
    'ARVI INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'DJT INSURANCE BROKERS PRIVATE LIMITED',
    'ABAS ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'PRAKRUTI DREAM ESTATES PRIVATE LIMITED',
    'ABY INFRASOLUTION PRIVATE LIMITED',
    'WIND HEAVEN PRIVATE LIMITED',
    'TAYSTE CHOCOLAT (OPC) PRIVATE LIMITED',
    'AXIS WIND FARMS (GODAVARI) PRIVATE LIMITED',
    'AMAZING AMBROSIA PRIVATE LIMITED',
    'GRAINOTCH SPIRIT INDIA PRIVATE LIMITED',
    'GETKRRACKIN PRIVATE LIMITED',
    'TERROIR FOODS PRIVATE LIMITED',
    'KIRKE CHEESE PRIVATE LIMITED',
    'THAIGER NUTRACEUTICALS PRIVATE LIMITED',
    'STEVIATECH LIFE PRIVATE LIMITED',
    'VIRTUAL-WHITE FLAME PRIVATE LIMITED',
    'AZURE POWER ROOFTOP TWO PRIVATE LIMITED',
    'AZURE POWER ROOFTOP ONE PRIVATE LIMITED',
    'WIND FOUR RENERGY PRIVATE LIMITED',
    'HOI FOOD CONCEPTS PRIVATE LIMITED',
    'EXPOFAB NATURAL POWER PRIVATE LIMITED',
    'FINCFRIENDS PRIVATE LIMITED',
    'BLACKSOIL ASSET MANAGEMENT PRIVATE LIMITED',
    'SUMO PROPERTIES AND HOUSING PRIVATE LIMITED',
    'PREFERRED HEALTHCARE PRIVATE LIMITED',
    'INNOVATIVE GADGETS AND TECH SOLUTIONS PRIVATE LIMITED',
    'RIZZAR (OPC) PRIVATE LIMITED',
    'LUXURY VACATIONS AND HOLIDAYS PRIVATE LIMITED',
    'ORBITANT JOURNEY PRIVATE LIMITED',
    'SPECIAL PRICE GOODS PRIVATE LIMITED',
    'PLINNTH BIM & CONSTRUCTION TECHNOLOGY CONSULTANTS PRIVATE LIMITED',
    'VS KERAMIC FRESH PRIVATE LIMITED',
    'AKN ENERGY SOLUTIONS PRIVATE LIMITED',
    'ASSOCIATED FREIGHT AND LOGISTICS PRIVATELIMITED',
    'MUZIRIS HOTELS AND RESORTS INDIA PRIVATELIMITED',
    'BOWLOPEDIA RESTAURANTS INDIA LIMITED',
    'WLA CONSULTANTS AND LOGISTICS PRIVATE LIMITED',
    'IQI SHIPPING PRIVATE LIMITED',
    'AMPLUS LOGISTICS INDIA PRIVATE LIMITED',
    'NEELANJAN LOGISTICS PRIVATE LIMITED',
    'GULMARG MOTOR FOUR WAY SERVICES PRIVATE LIMITED',
    'PRASANNA TRANSPORT SOLUTIONS PRIVATE LIMITED',
    'RELOCARE GLOBAL MOVING SERVICES PRIVATE LIMITED',
    'GOLDUCKS MART PRIVATE LIMITED',
    'VEGITHA LOGISTICS PRIVATE LIMITED',
    'SAAM TOURIST PRIVATE LIMITED',
    'GREENHOPPER HOLIDAYS PRIVATE LIMITED',
    'DHWARAK MANUFACTURERS INDIA PRIVATE LIMITED',
    'CAPL MOTOR PARTS PRIVATE LIMITED',
    'WEAPPTIVATE LINK TECHNOLOGIES PRIVATE LIMITED',
    'OMNIA ONE INTERNET PRIVATE LIMITED',
    'CLIX LOANS PRIVATE LIMITED',
    'MONEDO FINANCIAL SERVICES PRIVATE LIMITED',
    'KALINGA INTERNATIONAL COAL TERMINAL PARADIP PRIVATE LIMITED',
    'SRNG FINANCE PRIVATE LIMITED',
    'CITIZEN SOLAR PRIVATE LIMITED',
    'ATLANTAS CREW MANAGEMENT PRIVATE LIMITED',
    'AUSTERE SHIPPING & LOGISTICS PRIVATE LIMITED',
    'WHITEOAK CAPITAL TRUSTEE LIMITED',
    'APAC HOUSING FINANCE PRIVATE LIMITED',
    'APAC FINANCIAL SERVICES PRIVATE LIMITED',
    'VESTIS FINSERV PRIVATE LIMITED',
    'MEENAMANI GOEL CAPITAL PRIVATE LIMITED',
    'TWN LOGISTICS PRIVATE LIMITED',
    'RELIANCE HEALTH INSURANCE LIMITED',
    'JIVA HEALTH INSURANCE LIMITED',
    'AIRJET TRAINING SERVICES LIMITED',
    'AIRJET SECURITY AND ALLIED SERVICES LIMITED',
    'TRAVEL BLASTERS PRIVATE LIMITED',
    'FINOPLE CHITS PRIVATE LIMITED',
    'RSG TOURISM REPRESENTATIONS PRIVATE LIMITED',
    'SC TRAVELS AND EXCURSION PRIVATE LIMITED',
    'OPEN FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'PIRAMAL TRUSTEESHIP SERVICES PRIVATE LIMITED',
    'SIEMENS FACTORING PRIVATE LIMITED',
    'AV INSOLVENCY PROFESSIONALS PRIVATE LIMITED',
    'HIGH POT PRIVATE LIMITED',
    'GIRISH AVENUES PRIVATE LIMITED',
    'OMLAXMI CONSOLIDATORS INDIA PRIVATE LIMITED',
    'GOKRAL VENTURES PRIVATE LIMITED',
    'VISAERO INDIA PRIVATE LIMITED',
    'AIRJET ENGINEERING SERVICES LIMITED',
    'ACCEX SUPPLY CHAIN PRIVATE LIMITED',
    'CAERUS TRAVELLERS SOLUTIONS PRIVATE LIMITED',
    'SREE TRAVELS AND FACILITY SOLUTION PRIVATE LIMITED',
    'KAABIL FINANCE PRIVATE LIMITED',
    'ALANKIT IFSC LIMITED',
    'VINDRA CITY VENTURES PRIVATE LIMITED',
    'DAGA BUSINESS (INTERNATIONAL) STOCK BROKERS (IFSC) PRIVATE LIMITED',
    'ISUN COMMERCIAL & INSURANCE MARKETING PRIVATE LIMITED',
    'HNS PROCON PRIVATE LIMITED',
    'PRAVAS TRAVEL SERVICES (OPC) PRIVATE LIMITED',
    'HOMELAND REALTOR PRIVATE LIMITED',
    'YAMUNA BUILTECH PRIVATE LIMITED',
    'OMKAR REALTORS SPACE DEVELOPMENT PRIVATELIMITED',
    'AYAAN CABS PRIVATE LIMITED',
    'IYETEC SYSTEMS PRIVATE LIMITED',
    'PYTHIAN TECHNOLOGIES PRIVATE LIMITED',
    'URBANDOOR INFRA-HEIGHTS PRIVATE LIMITED',
    'IWORLD PREMIER ASSETS PRIVATE LIMITED',
    'GALACTIC CITY PRIVATE LIMITED',
    'FLIXTEL COMMUNICATION PRIVATE LIMITED',
    'ROCKET SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED',
    'POWERSCHOOL INDIA PRIVATE LIMITED',
    'AIHP PRIVATE LIMITED',
    'RAINMAKER REAL ESTATE SERVICES PRIVATE LIMITED',
    'MNKS GREEN WORLD LOGISTICS PRIVATE LIMITED',
    'AERTRIP INDIA LIMITED',
    'AROOHA TOURS AND TRAVELS PRIVATE LIMITED',
    'WINSOME TRAVEL CHILLI TOURS PRIVATE LIMITED',
    'CYQUREX TECHNOLOGIES PRIVATE LIMITED',
    'MAHEN TECHNOLOGIES PRIVATE LIMITED',
    'REOFT TECHNOLOGIES PRIVATE LIMITED',
    'BESTPEERS INFOSYSTEM PRIVATE LIMITED',
    'PORTICADE PROPERTIES DEVELOPER PRIVATE LIMITED',
    'HERON HOLIDAYS INDIA PRIVATE LIMITED',
    'COLEDA PRIVATE LIMITED',
    'NEWDAY INDIA SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'SQUAREWOOD HOUSING PRIVATE LIMITED',
    'PROFRONT INFRASTRUCTURE INDIA LIMITED',
    'SACRAMENT INSTITUE OF INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'SAMRIDHHI SAKSHAM JIVAN NIDHI LIMITED',
    'RANK MATE PRIVATE LIMITED',
    'AUTUS CORPORATE ADVISORS PRIVATE LIMITED',
    'ABSOLUTECONCEPTS EVENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'ENRECOVER ENERGY RECOVERY SOLUTIONS PRIVATE LIMITED',
    'MOVETECH CONVEYORS PRIVATE LIMITED',
    'CONMOVE PRIVATE LIMITED',
    'AMWICK TECHNOLOGIES PRIVATE LIMITED',
    'TELEPORTER SOFTWARE PRIVATE LIMITED',
    'SEATECH INTEGRATED TECHNOLOGY PRIVATE LIMITED',
    'KOLHAPUR HI-TECH STEELS PRIVATE LIMITED',
    'SYNEXTIC GLOBAL BUSINESS SOLUTION PRIVATE LIMITED',
    'CUECLAD MEDIA PRIVATE LIMITED',
    'REWELLONLINE TRADING PRIVATE LIMITED',
    'ZUMOSUN INTERNATIONAL RESEARCH & CONSULTANCY (INDIA) PRIVATE LIMITED',
    'RIGHTBRAIN CREATIONS PRIVATE LIMITED',
    'UDAI INTELLIGENCE SECURITY (OPC) PRIVATELIMITED',
    'GRUHA IBC PRIVATE LIMITED',
    'DAUJI MILK FOOD PRIVATE LIMITED',
    'PIONEER RESEARCH SOLUTIONS (INDIA) PRIVATE LIMITED',
    'FACTORYAL BUSINESS INCUBATOR PRIVATE LIMITED',
    'KOVERUP DIGITAL PRIVATE LIMITED',
    'INCREDIBLE AM PRIVATE LIMITED',
    'VOLFRAM SYSTEMS INDIA PRIVATE LIMITED',
    'MACROSPARK ENGINEERING PRIVATE LIMITED',
    'PCS IT SOLUTIONS PRIVATE LIMITED',
    'BILVA DESIGN CONSULTANTS PRIVATE LIMITED',
    'RASAVVY CONNECT SERVICES PRIVATE LIMITED',
    'TSMETAPHOR TECHNOLOGIES PRIVATE LIMITED',
    'LILO RIDERZ PRIVATE LIMITED',
    'GATHI ANALYTICS PRIVATE LIMITED',
    'AKARSH MARKETING PRIVATE LIMITED',
    'CELBLOOM FARMS PRIVATE LIMITED',
    'WORKAPPS PRODUCT SOLUTIONS PRIVATE LIMITED',
    'INTELEX COMMUNICATIONS PRIVATE LIMITED',
    'SBD AUTO ELECTRONICS PRIVATE LIMITED',
    'R4 ENTERPRISES PRIVATE LIMITED',
    'HUNTER-Z RESEARCH PRIVATE LIMITED',
    'ARIMAN TECHNOLOGIES PRIVATE LIMITED',
    'MACROMEDIA DIAMOND DISPLAY PRIVATE LIMITED',
    'GVRC INDIA PRIVATE LIMITED',
    'FLEET ALYTICS PRIVATE LIMITED',
    'SWG SOLUTIONS INDIA PRIVATE LIMITED',
    'UPPERCUT CREATIVE SOLUTIONS PRIVATE LIMITED',
    'ICE AND SODA BRAND CULINARY SOLUTIONS PRIVATE LIMITED',
    'SYC ONLINE SOLUTIONS (OPC) PRIVATE LIMITED',
    'DIGITAMIZE INNOVATIONS PRIVATE LIMITED',
    'BIGG GOAAL IMF PRIVATE LIMITED',
    'QSN TECHNICAL SOLUTIONS PRIVATE LIMITED',
    'TRADEVISER CONSULTANCY PRIVATE LIMITED',
    'FITGROW PHYSICAL EDUCATION PRIVATE LIMITED',
    'ROBOMQ PRIVATE LIMITED',
    'GAURI SHANKER AND NIRMALA AGARWAL FOUNDATION',
    'STARTRACK AGRO AND WAREHOUSE PRIVATE LIMITED',
    'MOCERO HEALTH SOLUTIONS PRIVATE LIMITED',
    '100MB DIGITAL PRIVATE LIMITED',
    'MAIWAND TECHNOLOGIX PRIVATE LIMITED',
    'AASTHA RENEWABLE ENERGY MANAGEMENT PRIVATE LIMITED',
    'ADRIOT CADENATECH PRIVATE LIMITED',
    'TECHSBIZ IT DEVELOPMENT PRIVATE LIMITED',
    'PUSHP HENNA PRIVATE LIMITED',
    'SIQUIS ADVERTISING PRIVATE LIMITED',
    'ECO CLEAN PEST CONTROL PRIVATE LIMITED',
    'DGMUSIKA CREATIONS PRIVATE LIMITED',
    'SMBSURE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CHAKRAA RESIDENCY PRIVATE LIMITED',
    'INFINITE PERSPECTIVE RESEARCH AND ADVISORY PRIVATE LIMITED',
    'SUSTAINABILITY NETWORK SOLUTIONS PRIVATELIMITED',
    'IGROW GLOBAL SOLUTIONS PRIVATE LIMITED',
    'MONKS AND BOTS SOLUTIONS PRIVATE LIMITED',
    'PMA SCHOOL OF MUSIC PRIVATE LIMITED',
    'STONE BENCH PRIVATE LIMITED',
    'MAKERSAN INDIA PRIVATE LIMITED',
    'TRIO MARINE SUPPLIES PRIVATE LIMITED',
    'TALENTTRIBE CONSULTING PRIVATE LIMITED',
    'QUALITY PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED',
    'VENSO TECHNOLOGIES PRIVATE LIMITED',
    'TANDT SOCIAL FOUNDATION',
    'MITANIN FOUNDATION',
    'AK INFOPARK PRIVATE LIMITED',
    'SHRIENT ANALYTICAL & RESEARCH LABS PRIVATE LIMITED',
    'SONDREL INDIA PRIVATE LIMITED',
    'HXCO INDIA PRIVATE LIMITED',
    'MAXCARE FACILITY SERVICES PRIVATE LIMITED',
    'INDEXINFO CONSULTANCY SERVICES PRIVATE LIMITED',
    'ASHVIN RESEARCH AND EDUCATION FOUNDATION',
    'PRATIQUE CFO SERVICES PRIVATE LIMITED',
    'SMIDTH TECH PACKAGING PRIVATE LIMITED',
    'VSION TECH PARK PRIVATE LIMITED',
    'DIGITAL SEO MARKETING PRIVATE LIMITED',
    'SKYLARK HR SOLUTIONS PRIVATE LIMITED',
    'RAJANS HOSPITALS PRIVATE LIMITED',
    'QUALITY INTERNATIONAL CERTIFICATIONS PRIVATE LIMITED',
    '8 O PAHER INDIA PRIVATE LIMITED',
    'AMZ LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'NFW INDIA SOCIAL VENTURES PRIVATE LIMITED',
    'JASON SCIENCE AND TECHNOLOGY PRIVATE LIMITED',
    'SDC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PANDAJE WEB SERVICES PRIVATE LIMITED',
    'APRECIA PHARMACEUTICALS PRIVATE LIMITED',
    'BFS TECHNOLOGIES PRIVATE LIMITED',
    'TELESTO ENERGY PRIVATE LIMITED',
    'BROOKS FACILITY MANAGEMENT PRIVATE LIMITED',
    'KLARKE AGRI LOGISTICS PRIVATE LIMITED',
    'JITO INCUBATION AND INNOVATION FOUNDATION',
    'MYROOTS RURAL INITIATIVES FOUNDATION',
    'KOKAN WELFARE FOUNDATION',
    'ROTARY ROYALES FOUNDATION',
    'PROYUGA ADVANCED TECHNOLOGIES LIMITED',
    'HITODI INFRASTRUCTURE PRIVATE LIMITED',
    'CONVERGE ENGINEERING PRIVATE LIMITED',
    'INDO CANNABINOID PRIVATE LIMITED',
    'ALMANSOORI PRODUCTION SERVICES INDIA PRIVATE LIMITED',
    'CELTIC BUSINESS CENTRE PRIVATE LIMITED',
    'ESR ADVISERS INDIA PRIVATE LIMITED',
    'CJS SOLUTIONS GROUP (INDIA) PRIVATE LIMITED',
    'CAPSICUM GLOBAL ADVISORY PRIVATE LIMITED',
    'RIVERUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'BEYONDNMORE DESIGNS PRIVATE LIMITED',
    'WHATSHALLIGET TECHNOLOGIES PRIVATE LIMITED',
    'STERGY CLEANTECH PRIVATE LIMITED',
    'WHITE HORSE AGENCY PRIVATE LIMITED',
    'COPIOUSMINDS PRIVATE LIMITED',
    'HITUMET CORPORATION PRIVATE LIMITED',
    'DEVS BIOSCIENCES PRIVATE LIMITED',
    'SAND NETWORK PRIVATE LIMITED',
    'REBANKO VENTURE PRIVATE LIMITED',
    'ELECTROSAN TECHNOLOGIES PRIVATE LIMITED',
    'CLOUT MOBITECH PRIVATE LIMITED',
    'SAMEEP PADORA AND ASSOCIATES DESIGN CONSULTANTS PRIVATE LIMITED',
    'SUNCONSULT TECHNOLOGIES PRIVATE LIMITED',
    'TNP CONSULTANCY PRIVATE LIMITED',
    'CTARA BUSINESS INDIA PRIVATE LIMITED',
    'SKILLDATUM PRIVATE LIMITED',
    'KLOTHLAB TECHNOLOGIES PRIVATE LIMITED',
    'MERAKIE EXPERIENTIAL SOLUTIONS PRIVATE LIMITED',
    'VISHWA M.E.P. ENGINEERS PRIVATE LIMITED',
    'CHIKMAGULURU MARKETLEAP PRIVATE LIMITED',
    'MEDAX MEDICAL DEVICES INDIA PRIVATE LIMITED',
    'SUSHEEL HOLIDAYS AND FOREX PRIVATE LIMITED',
    'BYTAMORPH ZONA PRIVATE LIMITED',
    'VISHISHTA COMMUNICATIONS PRIVATE LIMITED',
    'GCT PHARMA RESEARCH (INDIA) PRIVATE LIMITED',
    'CAESAR BUSINESS CENTRE PRIVATE LIMITED',
    'GENROBOTIC INNOVATIONS PRIVATE LIMITED',
    'SCHALTERZ PRIVATE LIMITED',
    'EIDIKOS BUSINESS ENTERPRISES PRIVATE LIMITED',
    'HACHI-BEE CONSULTING (OPC) PRIVATE LIMITED',
    'EDCHEMY SOLUTIONS INDIA PRIVATE LIMITED',
    'ALACRITY BUSINESS CENTRE PRIVATE LIMITED',
    'ANSELL INDIA PROTECTIVE PRODUCTS PRIVATELIMITED',
    'GEO MARINE ANALYTICAL LABORATORY PRIVATELIMITED',
    'CHAMS PHYGITAL MEDIA PRIVATE LIMITED',
    'MASTRO METALS PRIVATE LIMITED',
    'KORI FACILITY PRIVATE LIMITED',
    'PREDNALYTICS HEALTH PRIVATE LIMITED',
    'SAFEROCK INDIA PRIVATE LIMITED',
    'GOLDENPI TECHNOLOGIES PRIVATE LIMITED',
    'DEENLA LIFESTYLES PRIVATE LIMITED',
    'AKAASH CONNECTIVITY SOLUTIONS PRIVATE LIMITED',
    'ZEROSTLE SERVICES PRIVATE LIMITED',
    'AIRMYDUS INNOVATIONS PRIVATE LIMITED',
    'QUADOLTEN PRIVATE LIMITED',
    'ZOVOZ TECHNOLOGIES PRIVATE LIMITED',
    'NEWTOK AUTOMATION PRIVATE LIMITED',
    'ORION STUDY ABROAD PRIVATE LIMITED',
    'ARSB ADVISORY SERVICES PRIVATE LIMITED',
    'AYURMUDRA WELLNESS PRIVATE LIMITED',
    'SPUR DTDS MICROWAVE PRIVATE LIMITED',
    'EARTHSAVE PRIVATE LIMITED',
    'KAYESS SQUARE CONSULTING PRIVATE LIMITED',
    'CONFLUENCE FOR HEALTH ACTION AND TRANSFORMATION FOUNDATION',
    'HUI CHANG ADVERTISING PRIVATE LIMITED',
    'PULPKEY MEDIATECH PRIVATE LIMITED',
    'QURIDGE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'GUJJUBHAI FOODS PRIVATE LIMITED',
    'CO-CREATE TOMORROW PRIVATE LIMITED',
    'NEU ELEMENTS PRIVATE LIMITED',
    'ADITYAVANI PORTER SERVICES PRIVATE LIMITED',
    'YD TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'ALLORA ENTERTAINMENT PRIVATE LIMITED',
    'LIBERTY GLENTEC ENGINEERING STRUCTURAL DESIGNS PRIVATE LIMITED',
    'GEM PETRO E&P PRIVATE LIMITED',
    'UNOSTAR BIOCHEM INDIA PRIVATE LIMITED',
    'SATHYAS ADVISORY PRIVATE LIMITED',
    'ZENIGENT PRODUCTS INDIA PRIVATE LIMITED',
    'DOC90 SOLUTIONS PRIVATE LIMITED',
    'JON CAPSTONE STRATEGIES INDIA PRIVATE LIMITED',
    'WEBWIZ NEW MEDIA PRIVATE LIMITED',
    'VV EVENTS INDIA PRIVATE LIMITED',
    'SETTLRS VENTURE PRIVATE LIMITED',
    'INTEGRATED TRASH MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'HDSENSE GEOSPATIAL TECHNOLOGIES PRIVATE LIMITED',
    'OPENTHRIVE SERVICES PRIVATE LIMITED',
    'PROMINENCE BRAND SERVICES PRIVATE LIMITED',
    'UMMAH NETWORKS PRIVATE LIMITED',
    'COLTFOX PRIVATE LIMITED',
    'TECHASK CONSULTING PRIVATE LIMITED',
    'KURMAR RESEARCH PRIVATE LIMITED',
    'EFG SOCIAL PURSUIT PRIVATE LIMITED',
    'ACCELERATOR ENTERPRISE PRIVATE LIMITED',
    'AANTHRA HOME SOLUTIONS PRIVATE LIMITED',
    'AEGIS BUILDCON PRIVATE LIMITED',
    'GEEYEM PROPERTIES PRIVATE LIMITED',
    'MYTRAH VAYU (CHITRAVATI) PRIVATE LIMITED',
    'MYTRAH VAYU (KAVERI) PRIVATE LIMITED',
    'MYTRAH VAYU (BHAVANI) PRIVATE LIMITED',
    'CONSOCIATE RENEWABLES PRIVATE LIMITED',
    'MAHINDRA WASTE TO ENERGY SOLUTIONS LIMITED',
    'LEELA GREENSHIP RECYCLING PRIVATE LIMITED',
    'MYTRAH VAYU (AMARAVATI) PRIVATE LIMITED',
    'MYTRAH VAYU (TAPTI) PRIVATE LIMITED',
    'DA GREEN AGROTECH PRIVATE LIMITED',
    'LIBER URJA TECHNOLOGIES PRIVATE LIMITED',
    'DUSTARA TECHNOLOGIES PRIVATE LIMITED',
    'KONCRETEPLANET (OPC) PRIVATE LIMITED',
    'CKB CONCEPTS PRIVATE LIMITED',
    'HAGEN AQUA PRIVATE LIMITED',
    'SHILPA COOLER AND FURNITURE PRIVATE LIMITED',
    'DIVCARE PC&H PRIVATE LIMITED',
    'SANDHAR AUTOMOTIVE SYSTEMS PRIVATE LIMITED',
    'WIL CAR WHEELS LIMITED',
    'ANSOX INDUSTRIES PRIVATE LIMITED',
    'AMARA ENGINEERING WORKS PRIVATE LIMITED',
    'AVANITH CONSTRUCTIONS PRIVATE LIMITED',
    'AFIA PROPERTIES PRIVATE LIMITED',
    'AIKN-INGENIOUS EC PRIVATE LIMITED',
    'VERDANT RENEWABLES PRIVATE LIMITED',
    'MYTRAH VAYU (PALAR) PRIVATE LIMITED',
    'MYTRAH VAYU (ADYAR) PRIVATE LIMITED',
    'BALLESHWAR ARCADE PRIVATE LIMITED',
    'KARUR SRI RAMA WIND ENERGY PRIVATE LIMITED',
    'EPIC ELEVATORS PRIVATE LIMITED',
    'PRAKHAR FASTENERS PRIVATE LIMITED',
    'SPHIRO INFRATECH PRIVATE LIMITED',
    'GROWEVER INFRA PRIVATE LIMITED',
    'TIRUNVELI SOLAR PROJECT PRIVATE LIMITED',
    'RAJ COOLING SYSTEMS PRIVATE LIMITED',
    'EN SRINIDHI WINDFARMS PRIVATE LIMITED',
    'SHK INDIA PRIVATE LIMITED',
    'TECKNOWLEDGE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PRODI DESIGN AND CREATIONS PRIVATE LIMITED',
    'ERENCO (INDIA) LIMITED',
    'BHAVYA FURNI-SOLUTIONS PRIVATE LIMITED',
    'CRIMSON LOUNGE PRIVATE LIMITED',
    'IDHS RESEARCH PRIVATE LIMITED',
    'SOURCE OF LIFE TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'MEDICAP HEALTHCARE LIMITED',
    'DHITI BIOSCIENCE DIAGNOSTIC TECHNOLOGY PRIVATE LIMITED',
    'MYTRAH VAYU (PARBATI) PRIVATE LIMITED',
    'SUNVEC CONSULTING PRIVATE LIMITED',
    'ALTOSTRATUS WATERTEK PRIVATE LIMITED',
    'VIKA PRECISION ENGINEERING INDIA PRIVATELIMITED',
    'BIERREBI CUTTING SOLUTIONS PRIVATE LIMITED',
    'GOSOLGEN RENEWABLES PRIVATE LIMITED',
    'PANCHATARA INDUSTRIES PRIVATE LIMITED',
    'JASCAL-PRO PRIVATE LIMITED',
    'IMMACULATE SURGICAL INNOVATIONS PRIVATE LIMITED',
    'GINAT WAVE INDIA PRIVATE LIMITED',
    'HARI HARIBOL DAIRY PRODUCTS PRIVATE LIMITED',
    'NCR WIRES AND CABLE PRIVATE LIMITED',
    'CARBCUT INDIA PRIVATE LIMITED',
    'POSITIVE LIFTS AND ENGINEERING PRIVATE LIMITED',
    'JSUN CNC SOLUTIONS PRIVATE LIMITED',
    'RUNWAY CREATION PRIVATE LIMITED',
    'ZEMA AUTOMATION AND CONTROLS PRIVATE LIMITED',
    'NEOTRIC INDUSTRIAL TECHNOLOGY PRIVATE LIMITED',
    'KRISHNA ENGIMECH PRIVATE LIMITED',
    'PROBITY VENTURES PRIVATE LIMITED',
    'MAXHEAT INDUSTRIES PRIVATE LIMITED',
    'INCH POWER CONTROLS PRIVATE LIMITED',
    'VERITO ENGINEERING PRIVATE LIMITED',
    'NOVELTY AUTO SALES PRIVATE LIMITED',
    'ALCHEMY ENERSOL INTERNATIONAL PRIVATE LIMITED',
    'ATB EQUIPMENT PRIVATE LIMITED',
    'TELEVAC PRIVATE LIMITED',
    'BRISK ELEVATORS & ESCALATORS PRIVATE LIMITED',
    'AUTOEDGE MANUFACTURING TECHNOLOGIES PRIVATE LIMITED',
    'AUTOEDGE PROJECTS AND SYSTEMS PRIVATE LIMITED',
    'RENK GEARS PRIVATE LIMITED',
    'INCH ACTUATA PRIVATE LIMITED',
    'ACCORD VITRIFIED PRIVATE LIMITED',
    'PVET PRIVATE LIMITED',
    'RMZ OILFIELD ENGINEERING PRIVATE LIMITED',
    'HEX FASTENERS PRIVATE LIMITED',
    'NOVELTY CARS PRIVATE LIMITED',
    'DHUNI POLYMERS PRIVATE LIMITED',
    'EXCELLING 3DP PRIVATE LIMITED',
    'GANIX RUBBER RECYCLING PRIVATE LIMITED',
    'RIBAL METFAB INDIA PRIVATE LIMITED',
    'GLOTEX SOLUTIONS PRIVATE LIMITED',
    'AUSTRO WATER TECHNOLOGIES PRIVATE LIMITED',
    'AYPOLS POLYMERS PRIVATE LIMITED',
    'VEINSTONE PRIVATE LIMITED',
    'ALWAYS DRY CHEMICALS AND COATINGS PRIVATE LIMITED',
    'SHREE RANGKALA GLASS DESIGN PRIVATE LIMITED',
    'NORREL PHARMA PRIVATE LIMITED',
    'GO4LIFE BIOTECH PRIVATE LIMITED',
    'BIOCHEM PHARMACEUTICAL PRIVATE LIMITED',
    'FORGE POINT LIMITED',
    'BANSARI ALLOYS PRIVATE LIMITED',
    'REPLAY INDIA PRIVATE LIMITED',
    'SRC ECOTEX (INDIA) PRIVATE LIMITED',
    'AION PIPES PRIVATE LIMITED',
    'ELEGANT POWER SYSTEMS & CONTROLS PRIVATELIMITED',
    'SAAOL HEALTHCARE PRIVATE LIMITED',
    'RAJNEER ENVITECH PRIVATE LIMITED',
    'AVFX SOLUTIONS PRIVATE LIMITED',
    'VTOL AVIATION INDIA PRIVATE LIMITED',
    'SPINOFF DIGITAL INDIA PRIVATE LIMITED',
    'BAEL LEAF ENTERPRISES PRIVATE LIMITED',
    'SARITA PLACEMENT SERVICES PRIVATE LIMITED',
    'TIBU NIRMAN PRIVATE LIMITED',
    'KOZHENCHERRY INFRA DEVELOPERS PRIVATE LIMITED',
    'CEEAR LIFESTYLE PRIVATE LIMITED',
    'MATHRU PRO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'INFINITIVE HOST TECHNOLOGIES PRIVATE LIMITED',
    'HIFIVE INNOVATIONS PRIVATE LIMITED',
    'IDEATION CONCEPTS & DESIGN HOUSE PRIVATELIMITED',
    'SPEEDKING INFOTECH PRIVATE LIMITED',
    'DIGNITY MANAGEMENT PRIVATE LIMITED',
    'PUZIA TECHNOLOGIES PRIVATE LIMITED',
    'SUYUKTA TAX N TECH PRIVATE LIMITED',
    'INCHSTEP TECHNOLOGIES PRIVATE LIMITED',
    'SKILANCER SOLAR PRIVATE LIMITED',
    'NAVDEEP SHIPPING PRIVATE LIMITED',
    'WANDERUNG GUIDES PRIVATE LIMITED',
    'ASSURANCE INTL LIMITED',
    'SPRNG NATURAL POWER SOURCE PRIVATE LIMITED',
    'PURPLELABS SEARCH PRIVATE LIMITED',
    'DC SUPPORT PRIVATE LIMITED',
    'TRIMAX SMART INFRAPROJECTS PRIVATE LIMITED',
    'RISHITA BHAWAN NIRMAN PRIVATE LIMITED',
    'JNANPEET NIDHI LIMITED',
    'CRAVER LABS PRIVATE LIMITED',
    'FILLRACKS TECHNOLOGIES PRIVATE LIMITED',
    'TRICOLOUR FINANCIAL SERVICES PRIVATE LIMITED',
    'GPC-GIS EAST PRIVATE LIMITED',
    'BEAUTY ORIGINS PRIVATE LIMITED',
    'ASTAR NET SOLUTIONS PRIVATE LIMITED',
    'TRACOTECH INDIA PRIVATE LIMITED',
    'ECOSPEAR ENERGY PRIVATE LIMITED',
    'PEGADROID IQ SOLUTIONS PRIVATE LIMITED',
    'EPIONE HEALTHCARE PRIVATE LIMITED',
    'FIELDTRACK EARTHMOVERS PRIVATE LIMITED',
    'NAGSA BUSINESS CENTER PRIVATE LIMITED',
    'MEETHADABBA PRIVATE LIMITED',
    'AMBIKAA DAIRYLAND AND RICH FOODS PRIVATELIMITED',
    'BEAR HOLIDAYS PRIVATE LIMITED',
    'AUGA TECH PRIVATE LIMITED',
    'PT ECOLOGICAL SERVICES PRIVATE LIMITED',
    'KAYMAS POSTECH CONSTRUCTIONS PRIVATE LIMITED',
    'PINK MEE HOSPITALITY PRIVATE LIMITED',
    'BFLIX MEDIA PRIVATE LIMITED',
    'HOOLOCK TECHNOLOGIES PRIVATE LIMITED',
    'SARVADNYA POWERTECH PRIVATE LIMITED',
    'CAZAN CATSOL PRIVATE LIMITED',
    'PHILLIP VENTURES IFSC PRIVATE LIMITED',
    'UNPLUG INFINITY MEDIA PRIVATE LIMITED',
    'AMBIAR HERITAGE PRODUCTS PRIVATE LIMITED',
    'SHAPOORJI PALLONJI PANDOH TAKOLI HIGHWAYPRIVATE LIMITED',
    'INVENTIVE NANO STONE (INDIA) PRIVATE LIMITED',
    'SETRAC HOSPITALITY PRIVATE LIMITED',
    'FERRA-BRS PRIVATE LIMITED',
    'ADISTALO INDIA PRIVATE LIMITED',
    'DURBAN TECHNOLOGIES PRIVATE LIMITED',
    'COPTER TECHNOLOGIES PRIVATE LIMITED',
    'AREION ARC PRIVATE LIMITED',
    'KONTEMPORARY REAL ESTATES PRIVATE LIMITED',
    'BIORE BEAUTY ACCESSORIES PRIVATE LIMITED',
    'BCC REALTY PRIVATE LIMITED',
    'TANGERINE SKIES PRIVATE LIMITED',
    'COMEX ENGGICON PRIVATE LIMITED',
    'GAR CORPORATE PARKS PRIVATE LIMITED',
    'S.J.V. TOOLS PRIVATE LIMITED',
    'AUTODEUS TECHNOLOGIES PRIVATE LIMITED',
    'WHITE LABEL E-SYSTEMS PRIVATE LIMITED',
    'TERRA INTERIORS INDIA PRIVATE LIMITED',
    'JIT NETWORK PRIVATE LIMITED',
    'SOFTRE INDIA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EXOPLANET TRAVEL & EDUCATION SERVICES PRIVATE LIMITED',
    'NIRVIGNAM ENTERPRISES PRIVATE LIMITED',
    'GREENRICH GROW INDIA PRIVATE LIMITED',
    'SHRI PRANAV TEXTILE CREATIONS PRIVATE LIMITED',
    'HIRAMEKI SOLUTIONS INDIA PRIVATE LIMITED',
    'MANNSCHAFT INFOTECH PRIVATE LIMITED',
    'GTM CATALYST PRIVATE LIMITED',
    'BULKLINER LOGISTICS LIMITED',
    'BLINKEYELABS ELECTRONICS PRIVATE LIMITED',
    'INNVENZO IT SOLUTIONS PRIVATE LIMITED',
    'AXEN SOFTWARE PRIVATE LIMITED',
    'ALPHONSO LABS PRIVATE LIMITED',
    'VAST ANGLE HR SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'S.N. GOODS CARGO PRIVATE LIMITED',
    'STET MEDIA PUBLISHERS PRIVATE LIMITED',
    'H&B HR SOLUTIONS PRIVATE LIMITED',
    'IEIMPACT MEDICAL TRANSCRIPTION SERVICES PRIVATE LIMITED',
    'CROSS GRID STRUCTURES PRIVATE LIMITED',
    'VICIT INFOT TECH PRIVATE LIMITED',
    'SEGMAP ICT CONSULTING AND SOLUTIONS PRIVATE LIMITED',
    'PRONTEFF IT SOLUTIONS PRIVATE LIMITED',
    'SUIKRAFT DZYNS PRIVATE LIMITED',
    'VERSIONX INNOVATIONS PRIVATE LIMITED',
    'VITUSCARE MEDLIFE PRIVATE LIMITED',
    'PRABHATH AUDITORIUMS PRIVATE LIMITED',
    'FARADIGM ULTRACAPACITORS PRIVATE LIMITED',
    'HB GOODLIFE PRIVATE LIMITED',
    'RHIBHU ROOFTOP SOLAR SOLUTIONS LIMITED',
    'COMPETANT GLOBAL SOLUTIONS PRIVATE LIMITED',
    'WIMOXEZ SYSTEMS PRIVATE LIMITED',
    'VENOL INDIA PRIVATE LIMITED',
    'BRAVE CELLS FOUNDATION',
    'BAKERI LANDDEVELOPERS PRIVATE LIMITED',
    'ARCHFIEND STUDIO PRIVATE LIMITED',
    'TSN EXPERT SERVICES PRIVATE LIMITED',
    'REACH DREDGING BARAK SPV PRIVATE LIMITED',
    'B.G. INSURANCE BROKERS PRIVATE LIMITED',
    'NATSPARK ENERGY PRIVATE LIMITED',
    'PLACARD COMMUNICATION (INDIA) PRIVATE LIMITED',
    'IMPEL REALTY & INFRA PRIVATE LIMITED',
    'JEFE SAFETY SOLUTIONS PRIVATE LIMITED',
    'FUELFORTECH PRIVATE LIMITED',
    'MACH CONVENTIONS AND VOYAGES PRIVATE LIMITED',
    'KAROMS SOFTWARE PRIVATE LIMITED',
    'GNIUS FRONTIER LIFE SUPPORT SYSTEM PRIVATE LIMITED',
    'LIVEC STAFFING SERVICES PRIVATE LIMITED',
    'PALATIAL HOSPITALITY PRIVATE LIMITED',
    'UNIVERSAUX CREATIONS DELCO PRIVATE LIMITED',
    'TRADITIONAL KNIT PRIVATE LIMITED',
    'BIGWORKS TECHNOLOGIES PRIVATE LIMITED',
    'DERIVE TRAVELWALA PRIVATE LIMITED',
    'KATALYST LABS PRIVATE LIMITED',
    'CHO & ASSOCIATE CREATIV SERVICES PRIVATELIMITED',
    'INFRANITY BUILDCON PRIVATE LIMITED',
    'SRISWASTIKA SECURE MANAGEMENT SERVICES PRIVATE LIMITED',
    'BELGAUM HOTELS PRIVATE LIMITED',
    'SHAPERZ INDIA GRAIN PRIVATE LIMITED',
    'FSRU VENTURE INDIA ONE PRIVATE LIMITED',
    'SHOPEASY FASHION & RETAIL PRIVATE LIMITED',
    'RAS BHARTI INDORE FOUNDATIONS',
    'TRUE FORTITUDE PRIVATE LIMITED',
    'BROADFASHION ECOM PRIVATE LIMITED',
    'BRINMOR CONSTRUCTIONS PRIVATE LIMITED',
    'TURQUOISE VENTURES PRIVATE LIMITED',
    'SAMVEDA LOGISTICS INFRARESOURCES PRIVATELIMITED',
    'QUINSTINCT ADVISORY PRIVATE LIMITED',
    'EXAKTHEIT TECHNOLOGIES PRIVATE LIMITED',
    'AVNISH BUSINESS PRIVATE LIMITED',
    'WORKFLOWLABS PRIVATE LIMITED',
    'VALUESPACES PRIVATE LIMITED',
    'REELNRG PRIVATE LIMITED',
    'VISCOTEC INDIA PRIVATE LIMITED',
    'MIVAAN REALTORS PRIVATE LIMITED',
    'MF MEDIA INDIA PRIVATE LIMITED',
    'SWEEPSMART WASTE MANAGEMENT PRIVATE LIMITED',
    'ARION SCAFFOLDING PRIVATE LIMITED',
    'AURUM BREWWORKS PRIVATE LIMITED',
    'PAVANPUTRA POLYPLAST PRIVATE LIMITED',
    'ATOS INDIA HYDRAULICS PRIVATE LIMITED',
    'ALECTRONA IMPEX PRIVATE LIMITED',
    'GENERAL INSTRUMENT CONSORTIUM PRIVATE LIMITED',
    'RAJASTHAN NEWS PRIVATE LIMITED',
    'CNTC INDIA TRADING PRIVATE LIMITED',
    'INQUISITOR MEDIA ANALYSIS & DATA RESEARCH PRIVATE LIMITED',
    'ETERNAL ESSENCE (OPC) PRIVATE LIMITED',
    'AHASOLAR TECHNOLOGIES LIMITED',
    'ORDINAX PRIVATE LIMITED',
    'JOE AND YOUNGS PRIVATE LIMITED',
    'BAGGAS DEALS AND WHEELS PRIVATE LIMITED',
    'KALEIDOFIN PRIVATE LIMITED',
    'KIMBERLITE WATER PLUS PRIVATE LIMITED',
    'REVAYU SYSTEMS PRIVATE LIMITED',
    'SAMSPRA AEROSPACE SYSTEMS PRIVATE LIMITED',
    'JIASJE HAIR & SKIN SOLUTIONS PRIVATE LIMITED',
    'HOLOGIC SOFTWARE TECHNOLOGY PRIVATE LIMITED',
    'TRANSLINER STRATEGIC SOLUTIONS PRIVATE LIMITED',
    'ASPIRE & INNOVATIVE ADVERTISING PRIVATE LIMITED',
    'DR SHOPCART PRIVATE LIMITED',
    'LAMBDADIGITAL PRIVATE LIMITED',
    'CHUANG XING ENGINEERING PRIVATE LIMITED',
    'FIBCORP POLYWEAVE PRIVATE LIMITED',
    'RADIUS INFOTECH SERVICES PRIVATE LIMITED',
    'BENARAS HERITAGE PRIVATE LIMITED',
    'POWERBLUE INTERNATIONAL ECOTECH PRIVATE LIMITED',
    'YNT SUPPLY CHAIN PRIVATE LIMITED',
    'BRIX HUNT PRIVATE LIMITED',
    'SEERAJ INDUSTRIES PRIVATE LIMITED',
    'YASHIKA EVENT & DANCE PERFORMING ARTS PRIVATE LIMITED',
    'PRAJ NETWORK PRIVATE LIMITED',
    'SKYMINES CONSULTANCY PRIVATE LIMITED',
    'HANNA DIGITAL TECHNOLOGY PRIVATE LIMITED',
    'TENSAR GEOSYNTHETICS INDIA PRIVATE LIMITED',
    'ASHVITA FINE ART & COLLECTIBLES PRIVATE LIMITED',
    'ORAKOR CONSULTANTS PRIVATE LIMITED',
    'GOMEDII TECHNOLOGIES PRIVATE LIMITED',
    'PARUL HEALTH CARE PRIVATE LIMITED',
    'ZOPEUS TECHNOLOGIES PRIVATE LIMITED',
    'BRIOGEM BIOGENICS PRIVATE LIMITED',
    'AURINKO MANAGEMENT INDIA PRIVATE LIMITED',
    'OCTAVUS CONSULTING PRIVATE LIMITED',
    'VB LOGISTICS EXIM PRIVATE LIMITED',
    'CHAKARA DESIGN AND CONSTRUCTION ENGINEERS PRIVATE LIMITED',
    'IQSCHOLAR JOURNAL PRIVATE LIMITED',
    'ULTIUOS SERVICES PRIVATE LIMITED',
    'NOVE AGROMATIC PRIVATE LIMITED',
    'COWPER LABS PRIVATE LIMITED',
    'SURELIA INFOSYSTEMS PRIVATE LIMITED',
    'TAUANALYTICS PRIVATE LIMITED',
    'RAYLES AND ROOBIE TECHNOLOGIES PRIVATE LIMITED',
    'STRONGBOX IT PRIVATE LIMITED',
    'GESTALTI SOFTWARE PRIVATE LIMITED',
    'NEW INSPIRE TECH SOLUTIONS PRIVATE LIMITED',
    'ITORIZIN TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MSOURCING E-SOLUTIONS PRIVATE LIMITED',
    'VINGYANI ANALYTICS PRIVATE LIMITED',
    'BOON REALTORS PRIVATE LIMITED',
    'TALENKART TECHNOLOGIES PRIVATE LIMITED',
    'NEEDYIN TECHNOLOGIES PRIVATE LIMITED',
    'XETADATA SOFTWARE PRIVATE LIMITED',
    'BOOK MYT SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'BENEVOLENCE TECHNOLOGIES PRIVATE LIMITED',
    'PRECO SMART SOLUTIONS PRIVATE LIMITED',
    'CODESIZZLER INDIA PRIVATE LIMITED',
    'IRUMAM SOFTWARE PRIVATE LIMITED',
    'RESEDA LIFESCIENCES PRIVATE LIMITED',
    'VITALMED IT SOLUTIONS PRIVATE LIMITED',
    'CLICKER TECHNOLOGIES PRIVATE LIMITED',
    'YUGTI SMART SOLUTIONS PRIVATE LIMITED',
    'SHRI BHAIRAV SUPER SERVICES PRIVATE LIMITED',
    'MAXWELL ENERGY SYSTEMS PRIVATE LIMITED',
    'A1 SELECTORS PRIVATE LIMITED',
    'TRANSPACKS TECHNOLOGIES PRIVATE LIMITED',
    'GRADLE INFOTECH CONSULTANCY PRIVATE LIMITED',
    'MU PROGRAMS INDIA PRIVATE LIMITED',
    'TECMAESTRO IT SOLUTIONS PRIVATE LIMITED',
    'MONTEAGE IT SOLUTIONS PRIVATE LIMITED',
    'ELAPP TECHNOLOGIES PRIVATE LIMITED',
    'AKAMARA BIOMEDICINE PRIVATE LIMITED',
    'VYOME THERAPEUTICS LIMITED',
    'IIAS RESEARCH FOUNDATION',
    'TIDAS AGROTECH PRIVATE LIMITED',
    'BRILL SOFT PRIVATE LIMITED',
    'EPISODE BELL EVENT MANAGEMENT PRIVATE LIMITED',
    'CANNY COMPUTING SOLUTIONS PRIVATE LIMITED',
    'TOSOINDIA CONSTRUCTION PRIVATE LIMITED',
    'FOZZY HOSTING INDIA PRIVATE LIMITED',
    'TRUEDO AGROKULT WORLD PRIVATE LIMITED',
    'BVM RESEARCH AND DEVELOPMENT FOUNDATION',
    'INQUBEDREAM RESEARCH AND DEVELOPMENT FOUNDATION',
    'PROHLP SOLUTIONS PRIVATE LIMITED',
    'BRAJBAHU SERVICES PRIVATE LIMITED',
    'CDP HCM GROUP PRIVATE LIMITED',
    'N.I. VENTURES PRIVATE LIMITED',
    'DATAIR TECHNOLOGY PRIVATE LIMITED',
    'AMPS TOWERS PRIVATE LIMITED',
    'MYGHOSLA DESIGNS PRIVATE LIMITED',
    'ENTRADA SOLUTIONS PRIVATE LIMITED',
    'NANO IOL OPHTHALMIC PRIVATE LIMITED',
    'CLINVIGILANT RESEARCH PRIVATE LIMITED',
    'TECHPOLI FILMS LIMITED',
    'CONVIVA APAC PRIVATE LIMITED',
    'GREENCELL EV PRIVATE LIMITED',
    'CATERSPOINT FOODS & BEVERAGES PRIVATE LIMITED',
    'CONNEL SPORTS MANAGEMENT PRIVATE LIMITED',
    'LUCDO TECHNOLOGIES PRIVATE LIMITED',
    'INJECTO INNOVATIONS PRIVATE LIMITED',
    'VLIGHTUP INDUSTRIES (OPC) PRIVATE LIMITED',
    'ROADIS CONCESSIONS INDIA PRIVATE LIMITED',
    'UNIHUB EDUCATION CONSULTANT (OPC) PRIVATE LIMITED',
    'PERSONALIZED MEDICINE INSTITUTE PRIVATE LIMITED',
    'PATRONUS BUSINESS CONSULTANTS (OPC) PRIVATE LIMITED',
    'FOUNDATION FOR INNOVATORS IN SCIENCE ANDTECHNOLOGY',
    'EDUMORPHS CONSULTANCY SERVICES PRIVATE LIMITED',
    'LEADERCROP PRIVATE LIMITED',
    'VATS91 PRODUCTS AND SERVICES PRIVATE LIMITED',
    'RATHOUR WAHANCHAYA MOTORS PRIVATE LIMITED',
    'SPJNAV RECRUITMENT PRIVATE LIMITED',
    'SCINTILLATING SOFTWARE SYSTEMS PRIVATE LIMITED',
    'MSKD COMPUTER PRIVATE LIMITED',
    'PROMAX POWER LIMITED',
    'TRIGONO TECH PRIVATE LIMITED',
    'FIDELITY INFRACON & ENGINEERING PRIVATE LIMITED',
    'MEYER HOUSEWARES INDIA PRIVATE LIMITED',
    'AK MISHRA FOUNDATION',
    'MEERA WOMEN WEAVERS ASSOCIATION',
    'SHIV NADAR AIC RESEARCH FOUNDATION',
    'JIVAP FOUNDATION',
    'TICTAC DIGITAL MARKETING PRIVATE LIMITED',
    'JUNGLECITI HOSPITALITY INDIA PRIVATE LIMITED',
    'ASC SOURCING SOLUTIONS PRIVATE LIMITED',
    'NINE TRIANGLES DIGITAL PRIVATE LIMITED',
    'EDINNO TECH LABS PRIVATE LIMITED',
    'LSI RESOLUTION PRIVATE LIMITED',
    'SCHOLAR ALLEY PRIVATE LIMITED',
    'XGRO TECHNOLOGIES PRIVATE LIMITED',
    'GENSTAR SALES AND MARKETING PRIVATE LIMITED',
    'ICSL CONSULTING PRIVATE LIMITED',
    'FINANCONS PRIVATE LIMITED',
    'FLYING BIRDS SPORTS MANAGEMENT PRIVATE LIMITED',
    'MATEOS IP MANAGEMENT PRIVATE LIMITED',
    'RISHIKIRTI TECHNOLOGIES PRIVATE LIMITED',
    'TRAWISH PRIVATE LIMITED',
    'ADDENDA CHEMICAL INDIA PRIVATE LIMITED',
    'FOURNAUTS PRIVATE LIMITED',
    'WEALTHTREE TECHNOLOGIES PRIVATE LIMITED',
    'SCORE LIVELIHOOD FOUNDATION',
    'SARMAN VENTURES PRIVATE LIMITED',
    'ELLANKY DIGITAL PRIVATE LIMITED',
    'DIGIO TWENTYONE COMMUNICATIONS PRIVATE LIMITED',
    'LACONIC ENTERPRISE PRIVATE LIMITED',
    'SOWARE INNOVATIONS PRIVATE LIMITED',
    'BALAJI STAFFING SOLUTIONS PRIVATE LIMITED',
    'VJB ESTATES PRIVATE LIMITED',
    'KALBRO FOREX PRIVATE LIMITED',
    'GENPRO ANALYTICS PRIVATE LIMITED',
    'ROUNDWORLD IMMIGRATION PRIVATE LIMITED',
    'ASOM TECHNOLOGIES PRIVATE LIMITED',
    'CITO VISION INDIA PRIVATE LIMITED',
    'STERROFOX PRIVATE LIMITED',
    'BRANDWORKS TECHNOLOGIES PRIVATE LIMITED',
    'MYNUKAD IT SOLUTIONS PRIVATE LIMITED',
    'FMT INFOTECH PRIVATE LIMITED',
    'SHREESHA FOOD AND BEVERAGES PRIVATE LIMITED',
    'TIYAS CONSULTANCY AND INFRASTRUCTURE PRIVATE LIMITED',
    'DIGIDENT DIAGNOSTIC PRIVATE LIMITED',
    'DEREKNROSE PRIVATE LIMITED',
    'ADTECHCORP TECHNOLOGIES PRIVATE LIMITED',
    'OPERA CHEMISOL INDIA PRIVATE LIMITED',
    'UWC CRAFTS PRIVATE LIMITED',
    'KATYA & ARIELLE HOME DÃ‰COR PRIVATE LIMITED',
    'EQROYAL INDIA PRIVATE LIMITED',
    'NDUES SOLUTION PRIVATE LIMITED',
    'SAMAR KHAN PICTURES (OPC) PRIVATE LIMITED',
    'GODDIVA FINE JEWELS PRIVATE LIMITED',
    'HORNBILL VENTURES PRIVATE LIMITED',
    'HUMONICS GLOBAL PRIVATE LIMITED',
    'TRIGONELLA LABS PRIVATE LIMITED',
    'NEXTFELLOW PRIVATE LIMITED',
    'STERLITE GRID 7 LIMITED',
    'SKILLFLOOR SOLUTIONS PRIVATE LIMITED',
    'ENERGIM SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'REDCLIFFE LIFESCIENCE PRIVATE LIMITED',
    'GENU PATH LABS LIMITED',
    'EXOTIC ESCAPES INDIA PRIVATE LIMITED',
    'GRS HOMES PRIVATE LIMITED',
    'INNOVADIS CONSULTANCY SERVICES (OPC) PRIVATE LIMITED',
    'GRAVITY GLOBAL HOSPITALITY PRIVATE LIMITED',
    'KOHINOOR REALTY MANAGEMENT PRIVATE LIMITED',
    'DHYEY TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'QNAP CORPORATION (INDIA) PRIVATE LIMITED',
    'SHIVAAYAMBIKA INFRACON PRIVATE LIMITED',
    'HSP OFFICE BASICS PRIVATE LIMITED',
    'ARIES WORLDWIDE SUPPLY CHAIN PRIVATE LIMITED',
    'RARI ARGENTINO LUXE JEWELLERY PRIVATE LIMITED',
    'EMG FASHIONS PRIVATE LIMITED',
    'INSPRIDE LAB PRIVATE LIMITED',
    'FUEL ACTIVE INDIA PRIVATE LIMITED',
    'BLOOMTREE BUSINESS ADVISORS PRIVATE LIMITED',
    'ORIENTAL CONTAINERS LIMITED',
    'STIPRUS BUILDTECHNIX PRIVATE LIMITED',
    'REAL VARIABLE DIGITAL ASSETSERVICES PRIVATE LIMITED',
    'INVITREK SOFTWARE PRIVATE LIMITED',
    'RICKUL INTERNATIONAL PRIVATE LIMITED',
    'TECHLOYOLA ORGANICS FOUNDATION',
    'MARK BIOMEDICALS PRIVATE LIMITED',
    'ADROIT TECHNOLOGIES INNOVATIVE SOLUTIONSPRIVATE LIMITED',
    'SAVERA TRAINING CENTER ASSOCIATION',
    'MUKHWAAS HOSPITALITY VENTURES PRIVATE LIMITED',
    'NEMESIS INTERNATIONAL PRIVATE LIMITED',
    'RATHINAVEL LOGISTICS PRIVATE LIMITED',
    'GRKMS PRIVATE LIMITED',
    'KAMAT LANDS PRIVATE LIMITED',
    'DIAMA BUSINESS VENTURES PRIVATE LIMITED',
    'RUANI MEDIA SERVICE PRIVATE LIMITED',
    'HAPPII DIGITAL & BROADCASTING NETWORK PRIVATE LIMITED',
    'DRK INFOTECH PRIVATE LIMITED',
    'KRINI FURNITURE PRIVATE LIMITED',
    'BLUETECH DESIGN PRIVATE LIMITED',
    'EVENTAGRATE LAB PRIVATE LIMITED',
    'DEJASHVI TECHNOLOGIES PRIVATE LIMITED',
    'BIG VISION TECHNOLOGY PRIVATE LIMITED',
    'CLEARTRIP PACKAGES & TOURS PRIVATE LIMITED',
    'MUMBAI GWALAS PRIVATE LIMITED',
    'NEXTDESK SOLUTIONS PRIVATE LIMITED',
    'FLYING ANTS STUDIOS AND GAME SERVICES PRIVATE LIMITED',
    'ALTERBASICS TECHNOLOGIES PRIVATE LIMITED',
    'VSK MEDICAL EQUIPMENT PRIVATE LIMITED',
    'LEXPRO MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'TWARITANANYA SERVICES INTERNATIONAL PRIVATE LIMITED',
    'LEQUITY TECHNOLOGIES PRIVATE LIMITED',
    'HOOPOUN INFOTECH PRIVATE LIMITED',
    'LINKEXPRESS LOGISTICS PRIVATE LIMITED',
    'HOMEHAPP TECHNOLOGIES PRIVATE LIMITED',
    'AURINKO LABS PRIVATE LIMITED',
    'MSUPPLY COMMERCE SERVICES INDIA PRIVATE LIMITED',
    'PRISTINE INFOSOLUTIONS PRIVATE LIMITED',
    'SEABRIN LOGISTICS PRIVATE LIMITED',
    'NAMPARAMBARIYAM AGRO PRIVATE LIMITED',
    'EURO POWER HYDRAULIC TECHNOLOGIES PRIVATE LIMITED',
    'FWCLOUD TECHNOLOGIES PRIVATE LIMITED',
    'PLANNER HOSPITALITY PRIVATE LIMITED',
    'CWA CONTENT WRITING ASSOCIATION',
    'SIS-BMS INFORMATION SYSTEMS PRIVATE LIMITED',
    'CHEMICASOFT GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SENTIENT SCRIPTS PRIVATE LIMITED',
    'JIVA BUSINESS VENTURES PRIVATE LIMITED',
    'SOLUZY TECHSOLUTIONS PRIVATE LIMITED',
    'VWEB HR SOLUTIONS PRIVATE LIMITED',
    'SKILLOMANIA SOLUTIONS PRIVATE LIMITED',
    'SPECTACULAR POWER TRADERS PRIVATE LIMITED',
    'UNDTS CORROSION SERVICES PRIVATE LIMITED',
    'ROYO KOTHARI VANITY INDIA PRIVATE LIMITED',
    'BIOSPAN CONTAMINATION CONTROL SOLUTIONS PRIVATE LIMITED',
    'HANDZAP SOFTWARE PRIVATE LIMITED',
    'GENIE LAMP PRIVATE LIMITED',
    'GARDEN POWER TECHNOLOGIES PRIVATE LIMITED',
    'AVEGA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'INDUSPLAY ONLINE SOLUTIONS PRIVATE LIMITED',
    'ROTOFAB MACHINERY PRIVATE LIMITED',
    'INKBLOT LABS PRIVATE LIMITED',
    'CYNOR MEDIA SERVICES PRIVATE LIMITED',
    'SPADE VENTURES PRIVATE LIMITED',
    'AJ AGROTECH IMPEX PRIVATE LIMITED',
    'IMMERSA LOGIC PRIVATE LIMITED',
    'ETTEL MEDIA PRIVATE LIMITED',
    'RSK DESIGN PRIVATE LIMITED',
    'OSSTF TECHNOLOGIES PRIVATE LIMITED',
    'SLUSBY TECHNOLOGIES PRIVATE LIMITED',
    'INGEX LAB PRIVATE LIMITED',
    'SHEEL HARDWARE PRIVATE LIMITED',
    'SHIGAN EVOLTZ LIMITED',
    'XFORM LEARNING PRIVATE LIMITED',
    'DCK MANAGEMENT SERVICES PRIVATE LIMITED',
    'TRIPPR WORLD INDIA PRIVATE LIMITED',
    'LUDETONG INDIA ELECTRONIC TECHNOLOGY PRIVATE LIMITED',
    'MAXWOOD FURNITURE PRIVATE LIMITED',
    'RESPONSIBLE E-WASTE MANAGEMENT PRIVATE LIMITED',
    'BESTOWED ADVISORS PRIVATE LIMITED',
    'SAA & SUDITI RETAIL PRIVATE LIMITED',
    'RAKSON ELECTRICALS INDIA PRIVATE LIMITED',
    'ARATEK INNOVATION PRIVATE LIMITED',
    'LINEAR LINES INTERIORS PRIVATE LIMITED',
    'ANSH SOLAR PRIVATE LIMITED',
    'REGALIS WEDDINGWORX (OPC) PRIVATE LIMITED',
    'UBY CONSULTING AND ADVISORY SERVICES PRIVATE LIMITED',
    'PRATIAN DIGITAL PRIVATE LIMITED',
    'ZHONGCAI INDIA CHEMICAL BUILDING MATERIAL PRIVATE LIMITED',
    'TRAVANCORE MARINE CORPORATION PRIVATE LIMITED',
    'GRAFAR TECHNOLOGY PRIVATE LIMITED',
    'GRAEDIAL ELECTRONIC SECURITY SOLUTIONS PRIVATE LIMITED',
    'SHREEMTK COTTON AND FIBERS PRIVATE LIMITED',
    'MORBIDO ECO TECHNOLOGIES PRIVATE LIMITED',
    'KALLUVARAMBIL HOMES PRIVATE LIMITED',
    'GRG MINES & CRASHERS PRIVATE LIMITED',
    'ARCANUM HR SOLUTIONS PRIVATE LIMITED',
    'DURGESH MOTORS PRIVATE LIMITED',
    'GOLDQUEST GLOBAL HR SERVICES PRIVATE LIMITED',
    'NYMBLE LABS PRIVATE LIMITED',
    'SYMBIANCE AI PRIVATE LIMITED',
    'PROVISION SOFT PRIVATE LIMITED',
    'SUNTRUPTI SPICES AND FOOD PRODUCTS PRIVATE LIMITED',
    'CASTLIGHT HEALTH INDIA PRIVATE LIMITED',
    'GENTEX GLOBAL EXPORTS PRIVATE LIMITED',
    'SRI NRUSINGHADEV & COLONIZERS PRIVATE LIMITED',
    'ABHINANDAN TRAVELS AND LOGISTIC PRIVATE LIMITED',
    'MODI BIOTECH PRIVATE LIMITED',
    'RELICX.AI INDIA PRIVATE LIMITED',
    'AADHI SOLAR ENERGY PRIVATE LIMITED',
    'SYKLON LABS PRIVATE LIMITED',
    'ISLAH EDUCATIONAL FOUNDATION',
    'KARAMADAI FARMER PRODUCER COMPANY LIMITED',
    'GURUCOOL FUN PRIVATE LIMITED',
    'EQUINOX SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED',
    'SINCX TECHNOLOGIES PRIVATE LIMITED',
    'VMVCUBE INFOSYSTEM INDIA PRIVATE LIMITED',
    'APPZ GLOBAL TECH PRIVATE LIMITED',
    'DESIGNXOVER PRIVATE LIMITED',
    'E-THREE GAMING PRIVATE LIMITED',
    'ABU RENEWABLES INDIA PRIVATE LIMITED',
    'WATER VEGGIE FARMS PRIVATE LIMITED',
    'TECHNOSYS CONSULTING PRIVATE LIMITED',
    'UCC ENGINEERING INDIA PRIVATE LIMITED',
    'INDUCTOHM TECHNOLOGIES PRIVATE LIMITED',
    'LIONSHARE INVENTION (OPC) PRIVATE LIMITED',
    'KNR RAMANATTUKARA INFRA PRIVATE LIMITED',
    'BELABLOOM PROJECTS AND FACILITY MANAGEMENT PRIVATE LIMITED',
    'TWIN PEAKS INNOVATIONS PRIVATE LIMITED',
    'SECURIN PRIVATE LIMITED',
    'BRAWNSTEEL ENGINEERS PRIVATE LIMITED',
    'SPORTECH INNOVATION LAB PRIVATE LIMITED',
    'PRAVARTAKA TOOLING SERVICES PRIVATE LIMITED',
    'RIGHTFIT RESOURCES (OPC) PRIVATE LIMITED',
    'WAARI TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'COMTRADE BIZTECH PRIVATE LIMITED',
    'ALMA JOURNEYS INDIA PRIVATE LIMITED',
    'AXION TECH SYSTEMS PRIVATE LIMITED',
    'VECTOR97 SOFTWARE AND SERVICE PRIVATE LIMITED',
    'KANDARP TRADERS & SUPPLIERS PRIVATE LIMITED',
    'VEDIKANT HOSPITALITY PRIVATE LIMITED',
    'LM CAPITAL ADVISORS PRIVATE LIMITED',
    'DECON INDUSTRIES INDIA PRIVATE LIMITED',
    'JRL HEALTHCARE PRIVATE LIMITED',
    'AAYRUSH SOFTEDU PRIVATE LIMITED',
    'ARS CONSCIOUS COLLECTIVE PRIVATE LIMITED',
    'L3 DATA SERVICES INDIA PRIVATE LIMITED',
    'SELVAMADHU DEVELOPERS PRIVATE LIMITED',
    'JAG INNOVATIONS PRIVATE LIMITED',
    'KAMAL JYOTI HEALTH FOOD FOUNDATION',
    'SSK IREX PRIVATE LIMITED',
    'CHEFX LABS INDIA PRIVATE LIMITED',
    'SKYZ STONES INDIA PRIVATE LIMITED',
    'FORNAX PLATFORMS PRIVATE LIMITED',
    'S2W MEDIA PRIVATE LIMITED',
    'THINKPLAY BOX PRIVATE LIMITED',
    'MIZEO FRESH PRIVATE LIMITED',
    'UKNOWVA SOFTWARES PRIVATE LIMITED',
    'YANTRANSH AUTO HINGES PRIVATE LIMITED',
    'LOCALEAI TECHNOLOGIES PRIVATE LIMITED',
    'KOSHUR STORE PRIVATE LIMITED',
    'WASABI LABS PRIVATE LIMITED',
    'FINE VISION INDIA EQUIPMENTS PRIVATE LIMITED',
    'GUIDESLY INDIA PRIVATE LIMITED',
    'LANKAN TRADERS PRIVATE LIMITED',
    'SPEKOND TECHNOLOGY CONSULTING SERVICES PRIVATE LIMITED',
    'SHOP BONANZA PRIVATE LIMITED',
    'EATO FOODTECH (OPC) PRIVATE LIMITED',
    'FITSURANCE INDIA PRIVATE LIMITED',
    'ROOTANIC PRIVATE LIMITED',
    '1.618 E-COMMERCE PRIVATE LIMITED',
    'STAR CEMENT (I) LIMITED',
    'TRAKDEM SOLUTIONS PRIVATE LIMITED',
    'CARELAN HEALTHCARE PRIVATE LIMITED',
    'PURELEARN EDUSERVE BANGALORE PRIVATE LIMITED',
    'NEU EDGE SOFTWARE PRIVATE LIMITED',
    'GREEN GRIT PRIVATE LIMITED',
    'LBDENIM PRIVATE LIMITED',
    'SUKHITVA ACADEMY (OPC) PRIVATE LIMITED',
    'LERA INVESTMENT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MOCAPAY INFOTECH INDIA PRIVATE LIMITED',
    'UNNAYAN GLOBAL VENTURES PRIVATE LIMITED',
    'ALY EXPORTS PRIVATE LIMITED',
    'MZADCOM IT SOLUTIONS INDIA PRIVATE LIMITED',
    'KNP RETAIL PRIVATE LIMITED',
    'PINEAPPLE VIEW MEDIA PRIVATE LIMITED',
    'SMH RAIL INDIA PRIVATE LIMITED',
    'KANOONS LAW AND TAX CONSULTANTS PRIVATE LIMITED',
    'MOFYDA TECHNOLOGIES PRIVATE LIMITED',
    'DYNAMIC WORLD EDUCATION COMMUNITY PRIVATE LIMITED',
    'SKYETA PRIVATE LIMITED',
    'HALFABYTE DIGITAL COMMUNICATIONS PRIVATELIMITED',
    'KVIKU FINANCE PRIVATE LIMITED',
    'ARORA RESEARCH AND WELFARE FOUNDATION',
    'IDCM INDUSTRIES (OPC) PRIVATE LIMITED',
    'MALUS GREENLEAF PRIVATE LIMITED',
    'REIMBURSE PROTECT TECHNOLOGY PRIVATE LIMITED',
    'LEANDEV SOLUTIONS PRIVATE LIMITED',
    'NEOTEQ SOFTWARE PRIVATE LIMITED',
    'RIDDHI SIDDHI HARMONY FOUNDATION',
    'SMILE91 HAPPINESS FOUNDATION',
    'SHISHT SEEDS (OPC) PRIVATE LIMITED',
    'VROZART FINANCE MANAGEMENT PRIVATE LIMITED',
    'JSW RENEW ENERGY (RAJ) LIMITED',
    'KLOUDLE CLOUD NATIVE SECURITY MONITORINGPRIVATE LIMITED',
    'ROSA SERVICES PRIVATE LIMITED',
    'TAMIA CONSULTING ADVISORS PRIVATE LIMITED',
    'KULKARNI WINCHES INDIA PRIVATE LIMITED',
    'ATYUTTAMA TECHNOLOGIES PRIVATE LIMITED',
    'LUPIN DIGITAL HEALTH LIMITED',
    'V2 SALON PRIVATE LIMITED',
    'CONTEXT.RESORTS PRIVATE LIMITED',
    'SKRD ENERGY SERVICES PRIVATE LIMITED',
    'MAYAA VEDA HERBAL PRIVATE LIMITED',
    'RELANTO GLOBAL PRIVATE LIMITED',
    'HIGHTOWN CONSTRUCTIONS PRIVATE LIMITED',
    'HFTP INDIA ASSOCIATION',
    'MURILLO & KLEE PRIVATE LIMITED',
    'ELIXR LABS TECHNOLOGIES PRIVATE LIMITED',
    'RAVI SIKKA MEMORIAL FOUNDATION',
    'AIMVISION SCIENTIFIC PRIVATE LIMITED',
    'ALLUVIUM CONSULTING INDIA PRIVATE LIMITED',
    'GURPREET SALUJA FINANCIAL SERVICES PRIVATE LIMITED',
    'SKYLOC DENTEC PRIVATE LIMITED',
    'TEKNO-TORIN DEVELOPMENTS PRIVATE LIMITED',
    'WATTAPP TECHNOLOGIES PRIVATE LIMITED',
    'NIWIAI PRIVATE LIMITED',
    'IQOO JM PRIVATE LIMITED',
    'HV CAPS PRIVATE LIMITED',
    'HAH TRANSPORT SERVICES PRIVATE LIMITED',
    'COGNIMINDS PRIVATE LIMITED',
    'MSDB PRIVATE LIMITED',
    'C.S. WORKFORCE PRIVATE LIMITED',
    'AMSONS OVERSEAS DYES & CHEMICALS PRIVATELIMITED',
    'WOOTAG INDIA PRIVATE LIMITED',
    'GENIE MENSCH PRIVATE LIMITED',
    'NOURITURE AGRI PRODUCTS PRIVATE LIMITED',
    'AMAZINGCROP SCIENCE PRIVATE LIMITED',
    'RAWAT INFRASTRUCTURES AND PROJECTS PRIVATE LIMITED',
    'RADIANCE KA SUNSHINE FOUR PRIVATE LIMITED',
    'FINTECH CARE INDIA PRIVATE LIMITED',
    'CLUB CAR ENGINEERING CENTRE PRIVATE LIMITED',
    'PINK STILETTO FILMS PRIVATE LIMITED',
    'H8 MONDAYS PRIVATE LIMITED',
    '91U DISCS & COACHING PRIVATE LIMITED',
    'FINZAGE PRIVATE LIMITED',
    'MERAGI EVENTS E-COMMERCE PRIVATE LIMITED',
    'AJLU DIGITAL PRIVATE LIMITED',
    'CYGNII AUTOMATION PRIVATE LIMITED',
    'DEESTANDE CONSULTING (OPC) PRIVATE LIMITED',
    'LIVE LINE PRIVATE LIMITED',
    'LOTUSDEW SECURITIES PRIVATE LIMITED',
    'GETRIA TECHNOLOGY PRIVATE LIMITED',
    'SKYTEK DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PRABHAT HEALTHBURG PRIVATE LIMITED',
    'AYRAA LABS INDIA PRIVATE LIMITED',
    'SPECTEK INSTRUMENTS PRIVATE LIMITED',
    'HRTA PLANNING NETWORK PRIVATE LIMITED',
    'MORPHRE FOXTROT PRIVATE LIMITED',
    'POLLEN DIGITAL SOLUTIONS PRIVATE LIMITED',
    'RBD CASTECH PRIVATE LIMITED',
    'EXABEAM INDIA PRIVATE LIMITED',
    'AREION CREDITTECH PRIVATE LIMITED',
    'OSTTRA INDIA SERVICES PRIVATE LIMITED',
    'TRL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RUDRANSH FOUNDATION',
    'KOCHAR INNOVATIONS PRIVATE LIMITED',
    'MITTSURE SCHOOL AT HOME PRIVATE LIMITED',
    'PURE SOURCE NUTRITION PRIVATE LIMITED',
    'PROGRESSIVE EPC SERVICES PRIVATE LIMITED',
    'SIGRA WORLDWIDE PRIVATE LIMITED',
    'FENWAY PHARMACEUTICALS PRIVATE LIMITED',
    'RXP FACILITIES MANAGEMENT PRIVATE LIMITED',
    'CALIBRAY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'LEAF HYDROPONIC FARMS PRIVATE LIMITED',
    'SARV WAVE PRIVATE LIMITED',
    'BARCO SHIPPING PRIVATE LIMITED',
    'ESG MINDS PRIVATE LIMITED',
    'IES HEALTHCARE PRIVATE LIMITED',
    'JHAGADIA ENVIRO PRIVATE LIMITED',
    'DDS ENGINEERING (INDIA) PRIVATE LIMITED',
    'SOLINSIGHT RESOURCES PRIVATE LIMITED',
    'REARING EDU FACILITIES PRIVATE LIMITED',
    'OKIYO TERRACES PRIVATE LIMITED',
    'GOODDEED RELIEF FOUNDATION',
    'SATRUPA GLOBAL SERVICES PRIVATE LIMITED',
    'ANADI CONSULTANTS PRIVATE LIMITED',
    'SHRIJAL WELFARE FOUNDATION',
    'OYSTER PEOPLE SERVICES PRIVATE LIMITED',
    'NOVELGENE TECHNOLOGIES PRIVATE LIMITED',
    'ALUPAC VENTURES PRIVATE LIMITED',
    'TECH DESIGNWORKS PRIVATE LIMITED',
    'RENEW SAMIR URJA PRIVATE LIMITED',
    'THETA90 TECHNOLOGIES PRIVATE LIMITED',
    'TECHNO NAVA PRIVATE LIMITED',
    'OPENER MEDIA PRIVATE LIMITED',
    'GOODLEVEN HEALTH IT PRIVATE LIMITED',
    'BAPU DIGITAL CLASSES PRIVATE LIMITED',
    'MAKEMYAPP CENTER PRIVATE LIMITED',
    'OXY21 INTERNATIONAL PRIVATE LIMITED',
    'MAYTRA NOESIS FOUNDATION',
    'EASY IMPRESS INDIA PRIVATE LIMITED',
    'CAPITALGRID TECHNOLOGIES PRIVATE LIMITED',
    'CLOUDFENCE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'K.J STEEL STRIPS PRIVATE LIMITED',
    'MEASUREONE SOLUTIONS PRIVATE LIMITED',
    'INNOVATIVEHEADS CONSULTANCY SERVICES PRIVATE LIMITED',
    'WINKLIX FOUNDATION',
    'SEMPER CENTRUM HEALTHCARE PRIVATE LIMITED',
    'PROJECT PACO FOUNDATION',
    'TELEWAW INDIA PRIVATE LIMITED',
    'CINEWA PRIVATE LIMITED',
    'PUDHARI RELIEF FOUNDATION',
    'AT&A VISA HUB (OPC) PRIVATE LIMITED',
    'LIBRE TOURS & TRAVELS PRIVATE LIMITED',
    'UNOWIZ TECHNOLOGIES PRIVATE LIMITED',
    'DIGISPACE NINJA INDIA PRIVATE LIMITED',
    'INDO ANGLO MINING PRIVATE LIMITED',
    'MANGAL RATNA SECURITIES PRIVATE LIMITED',
    'WOODCRES PRIVATE LIMITED',
    'XLR KONNECT PRIVATE LIMITED',
    'TELIMEDIC TECHNOLOGIES PRIVATE LIMITED',
    'TATTVANET BROADBAND PRIVATE LIMITED',
    'FOLDY PACKAGING PRIVATE LIMITED',
    'MYRPLUS REALTY PRIVATE LIMITED',
    'DIGI-KEY ELECTRONICS & AUTOMATION TRADING PRIVATE LIMITED',
    'MINOM CREATIONS PRIVATE LIMITED',
    'RETHINKLEDGERS EC INDIA PRIVATE LIMITED',
    'SYNERGYM INDIA PRIVATE LIMITED',
    'BET TECH SOLUTIONS PRIVATE LIMITED',
    'SHARADABEN PARSHOTTAMBHAI PATEL FOUNDATION',
    'RESH MANPOWER CONSULTING PRIVATE LIMITED',
    'SALTED SOCIAL PRIVATE LIMITED',
    'FISKER VIGYAN INDIA PRIVATE LIMITED',
    'MSL ONE DEVELOPERS PRIVATE LIMITED',
    'TURASH INTERNATIONAL PRIVATE LIMITED',
    'OMEGA ALGO ADVISORS INDIA PRIVATE LIMITED',
    'ZALDIA (OPC) PRIVATE LIMITED',
    'CREATIVE GALILEO EDTECH PRIVATE LIMITED',
    'SHREE CEMENT SOUTH PRIVATE LIMITED',
    'CORE POINT PRIVATE LIMITED',
    'ADANI CEMENT INDUSTRIES LIMITED',
    'VRKP ISPAT PRIVATE LIMITED',
    'SECUINFOTECH (OPC) PRIVATE LIMITED',
    'Q AND Q SOLUTIONS INDIA PRIVATE LIMITED',
    'AGRIPROJUNCTION VENTURES PRIVATE LIMITED',
    'SHREE CEMENT NORTH PRIVATE LIMITED',
    'HER-MONY SERVICES PRIVATE LIMITED',
    'CHAITANYASRI GREENTECH PRIVATE LIMITED',
    'SKILOCODE TECHNOLOGIES PRIVATE LIMITED',
    'OJHAS MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'DIGITAL DECODERS IT SOLUTIONS PRIVATE LIMITED',
    'MY LITTLE BABY WORLD PRIVATE LIMITED',
    'ZOGA WELLNESS PRIVATE LIMITED',
    'KESHARDEO AGARWAL FOUNDATION',
    'BAXTER PLANNING SYSTEMS INDIA PRIVATE LIMITED',
    'STOCKS EMOJI ADVISORY PRIVATE LIMITED',
    'SHREE GAJANAN PROPULSION MARINE SERVICESPRIVATE LIMITED',
    'HILL TOP INDIA LOGISTICS PARKS PRIVATE LIMITED',
    'BONNAFLEX INDUSTRIES PRIVATE LIMITED',
    'ARHUM ERECTORS PRIVATE LIMITED',
    'AZALP TECHNOLOGIES PRIVATE LIMITED',
    'LA MER FOODS PRIVATE LIMITED',
    'TRIZ AUTOMATIONS AND ROBOTICS PRIVATE LIMITED',
    'SAMPOORN BHARAT SKILLS ASSOCIATION',
    'SKILLPLUG SOLUTIONS (OPC) PRIVATE LIMITED',
    'CONNECTMYB2B PRIVATE LIMITED',
    'HISHAB INDIA PRIVATE LIMITED',
    'YANTRA AUTO COMP INDIA PRIVATE LIMITED',
    'INSTA CUISINE PRIVATE LIMITED',
    'SMARTVISIBILITY EDUTECH PRIVATE LIMITED',
    'INFINITE INGENIOUS CONSULTANTS INDIA PRIVATE LIMITED',
    'DIGITIBLE PRIVATE LIMITED',
    'MAC INFRATECH METAL PRIVATE LIMITED',
    'SALVATOR GLOBAL PRIVATE LIMITED',
    'WELLINGTONE PROJECT MANAGEMENT (INDIA) PRIVATE LIMITED',
    'ILM ELECTRONICS PRIVATE LIMITED',
    'SAICHAINS SANGLI PRIVATE LIMITED',
    'RAJDECORATORS PRIVATE LIMITED',
    'FORSTA MEDTECH PRIVATE LIMITED',
    'ENERGETIC PEOPLE PRIVATE LIMITED',
    'ANAND DHYAN FOUNDATION',
    'ASL MOTORS PRIVATE LIMITED',
    'GNP TECHPRO PRIVATE LIMITED',
    'JACH GOURMET FOODS PRIVATE LIMITED',
    'ALOVS RETAIL INDIA PRIVATE LIMITED',
    'OCEANUS EXPORTS PRIVATE LIMITED',
    'GREENKO KA01 IREP WIND PRIVATE LIMITED',
    'OMANTA NURSING SERVICES PRIVATE LIMITED',
    'ENVIRO INTEGRATED FACILITY SERVICES PRIVATE LIMITED',
    'DEMEANOR EQUIPMENT',
    'S FAMILY TREE FOODS PRIVATE LIMITED',
    'PKACE SOLUTIONS PRIVATE LIMITED',
    'MILK O BELL PRIVATE LIMITED',
    'ORIGA TECHNOLOGIES PRIVATE LIMITED',
    'CRYPTONIUM FINTECH PRIVATE LIMITED',
    'LIGHTBITS INFOTECH PRIVATE LIMITED',
    'KISAN4U MARKETING PRIVATE LIMITED',
    'NUCASH SECURITIES PRIVATE LIMITED',
    'BLENDED EDTECH PRIVATE LIMITED',
    'OCENO TECH PRIVATE LIMITED',
    'BIZPILOT FINANCIAL TECHNOLOGY PRIVATE LIMITED',
    'THRITHAARA ENTERPRISES PRIVATE LIMITED',
    'YOGAYATAN SHIPPING AND LOGISTIC PRIVATE LIMITED',
    'QDD PRIVATE LIMITED',
    'STRATOS STUDIOS PRIVATE LIMITED',
    'NPT TECHNOLOGIES PRIVATE LIMITED',
    'ACSL INDIA PRIVATE LIMITED',
    'ONEWRK MEDIA PRIVATE LIMITED',
    'EVENTOSTARS ENTERTAINMENT PRIVATE LIMITED',
    'MOGA RNG PRIVATE LIMITED',
    'VISHWA ASHA FOUNDATION',
    'ORISH J BIOWORKS PRIVATE LIMITED',
    'SRI MAHAKALESHWARAR FARMER PRODUCER COMPANY LIMITED',
    'SLUMSCARE INDIA FOUNDATION',
    'VRINDU LIFESTYLE INDIA PRIVATE LIMITED',
    'EHL ADVISORY SERVICES PRIVATE LIMITED',
    'SEMITA RF SYSTEMS PRIVATE LIMITED',
    'ONE POINT WAREHOUSE PRIVATE LIMITED',
    'TACKERSONS FOUNDATION',
    'RPRB TECHSOL PRIVATE LIMITED',
    'BARGAD AGRO PRIVATE LIMITED',
    'MANZEN HEALTHCARE PRIVATE LIMITED',
    'ACCESS INFINITY APAC PRIVATE LIMITED',
    'TECH E-STEEL MARKET LIMITED',
    'NEWOT ECOTECH PRIVATE LIMITED',
    'SCHMERSAL GLOBAL COMPETENCE CENTER PRIVATE LIMITED',
    'SENTINI BIO-SPIRIT PRIVATE LIMITED',
    'NEARSHORE ALLY PRIVATE LIMITED',
    'LUDHIANA RNG PRIVATE LIMITED',
    'LINGARO INDIA PRIVATE LIMITED',
    'BHASIN FITNESS PRIVATE LIMITED',
    'SONGPRO DIGITAL PRIVATE LIMITED',
    'NICON MARINE LOGISTICS PRIVATE LIMITED',
    'STUDO PRO-HEALTH SERVICES PRIVATE LIMITED',
    'POWERSTRIP TECHNOLOGIES PRIVATE LIMITED',
    'CRM TEAM INNOVATION PRIVATE LIMITED',
    'ARBOLUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NOTJUSTASHOPPER RETAIL PRIVATE LIMITED',
    'Brigade hotels private limited',
    'SPACE CLICK PRIVATE LIMITED',
    'Palaka hospitality private limited',
    'Siesta restaurants and catering services private limited',
    'Spread vanijya private limited',
    'Brightflow engineers private limited',
    'Yung energyefficiency & controls private limited',
    'Svnt infotech private limited',
    'Quicksilver systems and consulting private limited',
    'Aitia infotech private limited',
    'Ilensys technologies private limited',
    'Corecompete private limited',
    'Strattek consulting private limited',
    'Mapdata sciences india private limited',
    'Azonic infotech private limited',
    'PADMADGSOFT PRIVATE LIMITED',
    'Micro plus networking soluctions private limited',
    'Secude solutions india private limited',
    'Kadamba technologies private limited',
    'Invictus technology solutions private limited',
    'Ncs soft solutions private limited',
    'Velveer corporate solutions private limited',
    'Core lead interactive private limited',
    'Senrysa technologies private limited',
    'Pujasoft technologies private limited',
    'Creative web mall (india) private limited',
    'Infinity data technologies private limited',
    'Comsoft infotech private limited',
    'Pari computers private limited',
    'Unisoft computrade private limited',
    'Komal systems private limited',
    'Barberry infosystems private limited',
    'Greenwave solutions private limited',
    'Camerton infoline private limited',
    'Basis technologies private limited',
    'Civitech solutions private limited',
    'Bng infotech private limited',
    'CSOIGNE PRIVATE LIMITED',
    'Ids logic private limited',
    'Samin tekmindz india private limited',
    'Dunnhumby it services india private limited',
    'Layher scaffolding systems private limited',
    'Sr tekbox private limited',
    'Spaceguru infotech private limited',
    'CHARU MINDWORKS (INDIA) PRIVATE LIMITED',
    'Valuelabs services private limited',
    'Pcs cullinet private limited',
    'Softdel systems private limited',
    'Fairdeal studios private limited',
    'Aarav ites private limited',
    'AXONATOR PRIVATE LIMITED',
    'Codon software private limited',
    'Comake it software private limited',
    'Raykor technologies private limited',
    'Astir it solutions private limited',
    'M d computers private limited',
    'Webskitters technology solutions private limited',
    'POLUS SOLUTIONS PRIVATE LIMITED',
    'ENCAPSULATED NEWGEN SOLUTIONS PRIVATE LIMITED',
    'Factentry data solutions private limited',
    'Brainchip technologies private limited',
    'Schneide solutions private limited',
    'S s internet technologies private limited',
    'Trikaal mediinfotech private limited',
    'Sivasakthi software services private limited',
    'Caprice technologies private limited',
    'Riva systems private limited',
    'Banyan learning solutions india private limited',
    'In frame technology pvt ltd',
    'Peetel solutions private limited',
    'Rite infotech private limited.',
    'Sam tech datasys private limited',
    'CASHGRO DIGITAL PLATFORM PRIVATE LIMITED',
    'Manvik technologies private limited.',
    'Smart web solutions private limited',
    'CONCUR IP CONSULTING PRIVATE LIMITED',
    'Wiz soft technologies private limited',
    'Eresource info solutions private limited',
    'EKAMTEC SYSTEMS PRIVATE LIMITED',
    'Xs infosol private limited',
    'Asearch online technology private limited',
    'Accede business solutions private limited',
    'Globorgs technologies private limited',
    'Igrenenergi services private limited',
    'Acuity it solutions private limited',
    'Brainbyte techno solutions private limited',
    'Clientcurve infosystems private limited',
    'Togglenow software solutions private limited',
    'Expand software solutions private limited',
    'Globus eight net private limited',
    'Prophecis technologies private limited',
    'Highgig technology india private limited',
    'Eazycorp india private limited',
    'Byte to bit technologies (chennai) private limited',
    'BUTTONPAY TECHNOLOGIES PRIVATE LIMITED',
    'Sanelib solutions private limited',
    'Creative sense private limited',
    'Urdhva tech private limited',
    'Horizon etek private limited',
    'Gemini solutions private limited',
    'Infobit solution private limited',
    'Shelk software private limited',
    'Sidvin core-tech (india) private limited',
    'J.p.tools & technologies private limited',
    'Celstream technologies private limited',
    'Superseva services private limited',
    'Akots india private limited',
    'I-3 integrated co. private limited',
    'Vintron convergys limited',
    'Vsm venture control systems private limited',
    'HML CONSULTING PRIVATE LIMITED',
    'Greenleaf hospital servies private limited',
    'Mahabirprasad jatia foundation',
    'Medall healthcare private limited',
    'Systopic laboratories private limited',
    'Bulk systems international private limited',
    'Sparrow electronics limited',
    'M and g impex (india)private limited',
    'Gcc biotech (india) private limited.',
    'Mos healthcare holding private limited',
    'ABBVIE HEALTHCARE INDIA PRIVATE LIMITED',
    'Exper executive education private limited',
    'Metropolitan scan centre limited',
    'Industree skills transform private limited',
    'COGNIZANCE CYBER INTELLIGENCE PRIVATE LIMITED',
    'Bobtrade education consultants private limited',
    'Itel industries limited',
    'Aas healthcare private limited',
    'BHANSALI CHEMICALS PRIVATE LIMITED',
    'The advertising standards council of india',
    'Aditya exposition private limited',
    'Rhiti entertainment private limited',
    'Care india solutions for sustainable development',
    'DAKSHIN UTILITIES WORKS LIMITED',
    'Generation three entertainment private limited',
    'Connect.1 limited',
    'New video private limited.',
    'Wings brand activations india private limited',
    'Peerless fabrikkerne (india) limited',
    'South india digital music management private limited',
    'Eka archiving services private limited',
    'Dazzle events and exhibitions private limited',
    'Biorex healthcare private limited',
    'Mediff pharma private limited',
    'HARI BHARI DHARA FOUNDATION',
    'QUEST TALENT & EVENTS PRIVATE LIMITED',
    'Manjila & singh innotech private limited',
    'Labindia life sciences private limited',
    'Viva entertainments private limited',
    'KYRA HEALTH & WELLNESS PRIVATE LIMITED',
    'Sports park india private limited',
    'Neb sports entertainment private limited',
    'Srs sporting skills private limited',
    'Hosmac india private limited',
    'Mount multispeciality hospitals private limited',
    'Thriven hospitals and research institute private limited',
    'Medifit consultants private limited',
    'Semler research center private limited',
    'Indya clinical research private limited',
    'Lakeshore hospital and research centre limited',
    'Aryans dreamz gateways india private limited',
    'Doctor and doctor associates private limited',
    'Preserve faciliteez private limited',
    'Sahyog foundation',
    'Headstart international private limited',
    'Federation of beauty and hair council of india',
    'Adsizzler media private limited',
    'Affordable constructions private limited',
    'Divine event management private limited',
    'Somatheeram research institute and ayurveda hospital private limited',
    'Manomithra institute of medical sciences private limited',
    'Nextwealth entrepreneurs private limited',
    'Pro corporate services and events private limited',
    'Steinberg india advisors private limited',
    'Techsecure electronic security systems private limited',
    'SWARUP HOSPITALS PRIVATE LIMITED',
    'Virkoh facility management services private limited',
    'Kamala speciality hospitals private limited',
    'Moxx music private limited',
    'Rhiti charitable foundation',
    'Samskruta kalakshetra private limited',
    'Nytec beauty international private limited',
    'MAX HOSPITALS AND ALLIED SERVICES LIMITED',
    'Finechem logistics private limited',
    'Home protection services private limited',
    'Yab yum resorts private limited',
    'I25 OUTREACH PRIVATE LIMITED',
    'Media 360 concept india private limited',
    'Tata communications transformation services limited',
    'Top-notch health care products pvt ltd',
    'Canadian global life and educare private limited',
    'Fitternity health e-solution private limited',
    'DETOX INDIA PRIVATE LIMITED',
    'Modern sixteen cine laboratory private limited',
    'B. R. HERMAN & MOHATTA (INDIA) PRIVATE LIMITED',
    'Amritlal chemaux private limited',
    'Rerock entertainment private limited',
    'MACHWAN CHILDREN',
    'Mundakayam planters association',
    'ENTREPRENEURS',
    'ASSOCIATION OF INDIA',
    'Super sales automobiles pvt ltd',
    'Epigeneres biotech private limited',
    'L M UCAL ENGINEERING PRIVATE LIMITED',
    'Robertshaw controls private limited',
    'Sas automation private limited',
    'Otoklin global business limited',
    'Dynemech systems private limited',
    'Asiatic steel industries limited',
    'Eie instruments private limited',
    'Mvd engineering private limited',
    'M-w2e ecoventures private limited',
    'Stg heating private limited',
    'Apex advanced geospatial private limited',
    'Leogen energy private limited',
    'Tekni engg pvt ltd',
    'Turbomachinery engineering industries limited',
    'Earthmaster equipment private limited',
    'Yokins instruments private limited',
    'Erection instrumentation private limited',
    'Kuber automotive private limited',
    'V.k.boards and papers private limited',
    'Arrow digital private limited',
    'Ashlyn chemunnoor instruments private limited',
    'Kalyani transmission technologies private limited',
    'Appolo cranes private limited',
    'Shivpra cranes pvt ltd',
    'Saca (india) private limited',
    'Nish techno solution private limited',
    'Isgec engineering and projects limited',
    'Shagoya private limited',
    'Gauges bourdon (india) pvt ltd',
    'Miller groundbreaking india private limited',
    'Pan autocomp private limited',
    'Push engineering private limited',
    'Gladiance automation private limited',
    'Infinity automation systems private limited',
    'ISRI ADIENT AUTOMOTIVE SEATING LIMITED',
    'Aerocision aerocomp india private limited',
    'Alpine accsys private limited',
    'Synflo valves private limited',
    'Kabadi shankarsa textiles limited',
    'Chokhani silk mills private limited',
    'Swastik urban resources private limited',
    'Rudra mercantile private limited',
    'Janpad textiles pvt ltd.',
    'Combine commodities pvt.ltd.',
    'VIKRAM CAPITAL MANAGEMENT PRIVATE LIMITED',
    'Pranav eximp private limited',
    'Vitson steel corp private limited',
    'Gws fabricators private limited',
    'Shubhlaxmi metals and tubes private limited',
    'Rajkamal intrades private limited',
    'Roofco trading company private limited',
    'Better building products private limited',
    'Falgun export pvt ltd',
    'Kapoor designer exports private limited',
    'Spfl commodities private limited',
    'Ganapati stocks and securities pvt ltd',
    'Manush distributors ltd.',
    'Anmolik tradelink pvt.ltd.',
    'Frisky vincom pvt.ltd.',
    'J.k.sons engineers private limited',
    'Ikon copier services private limited',
    'ROCKWELL INDUSTRIAL SERVICES PRIVATE LIMITED',
    'Wares & wants trading private limited',
    'Raaga syntex private limited',
    'Purple meadow retail private limited',
    'Pannalal manicklal trading company private limited',
    'JANIT COMMERCIAL PRIVATE LIMITED',
    'Divine collection exports private limited',
    'Global brand promoters private limited',
    'BEAMEX MEDICAL SYSTEMS PRIVATE LIMITED',
    'Vishal-rajiv diamonds private limited',
    'R tulsidas exports pvt ltd',
    'Kalpaj sales and agencies pvt ltd',
    'Vigneshh pharma impex private limited',
    'Tork fastners ( india) pvt ltd',
    'Blueview trade-link private limited',
    'Star premises private limited',
    'Sreepada trading company private limited.',
    'Maxim commerce private limited',
    'Jagdamba tradecom private limited',
    'Svr retail private limited',
    'Eloquent tradelinks private limited',
    'Promising tradelinks private limited',
    'Longview tradelinks private limited',
    'Advent exim private limited',
    'Doshi medicare private limited',
    'Real mercantile services (mumbai) private limited',
    'Taco visions private limited',
    'Vanijya impex private limited',
    'Trade line enterprises private limited',
    'Aahaa stores private limited',
    'Poly dist india private limited',
    'Manas merchandise private limited',
    'P. praful and company distributors private limited',
    'Keracon equipments private limited',
    'Telmat materials and technologies (india) private limited',
    'Amc services & engineers private limited',
    'Newgen engineers private limited',
    'Shutham electric limited',
    'Inexus biotech private limited',
    'Ganpati additives private limited',
    'Crystal granite & marble private limited',
    'Premier consultant and traders limited',
    'Genie infotainment private limited',
    'INTYGRAT BUSINESS ADVISORY PRIVATE LIMITED',
    'Fouress marketing (international) private limited',
    'Capital ventures private limited',
    'Saryu impex pvt ltd',
    'Jariwala trading private limited',
    'Protect tradelink private limited',
    'Cdp computers private limited',
    'Falcon scientific engineering private limited',
    'Metalogic system private limited',
    'Mark and phillip sales private limited',
    'My van private limited',
    'Jayem trade private limited',
    'Toshbro private limited',
    'Samag true enterprises limited',
    'Gumberg india private limited',
    'Niera impex private limited',
    'PLASORON BIOTECH PRIVATE LIMITED',
    'KAVANA',
    'S INVESTMENT COMPANY INDIA PRIVATE LIMITED',
    'Srk credit services private limited',
    'ELECTRUM FINANCIAL SERVICES PRIVATE LIMITED',
    'Manar leasing and investments private limited',
    'Manmit investments and trading co pvt ltd',
    'P h credit and capital services private limited',
    'Vashi finvest private limited',
    'RAVIDAS SAFETY SHOES PRIVATE LIMITED',
    'CREST OPPORTUNITIES PRIVATE LIMITED',
    'Nuklik financial services private limited',
    'Matrix india asset advisors private limited',
    'Anur investments private limited',
    'Firstcapital financial advisors private limited',
    'Aarayaa advisory services private limited',
    'Agio stocks and shares private limited',
    'Wai insurance broking services private limited',
    'NARNOLIA INSURANCE BROKERS LIMITED',
    'Sinhasi financial advisors private limited',
    'Sinhasi consultants private limited',
    'Amrapali centurian park private limited',
    'Pandora builders private limited',
    'Minorca developers private limited',
    'Vipul infratech private limited',
    'Way2wealth brokers private limited',
    'Blue ridge realtors private limited',
    'Godsown properties and developers private limited',
    'Lucky investment managers private limited',
    'Shakuntalam fiscal services private limited',
    'Ssj finance and securities private limited',
    'DINSHAW',
    'S LAND DEVELOPERS PRIVATE LIMITED',
    'Woodlands housing private limited',
    'Jrc resources private limited',
    'Vivek realty & resorts private limited',
    'Emgeen estates private limited',
    'Zenith reality private limited',
    'New era realty private limited',
    'Castle media private limited',
    'Think grey ads private limited',
    'Design group project consultants private limited',
    'Isherdas sahni and bros private limited',
    'Spenswell property management private limited',
    'Anurup designs pvt.ltd.',
    'Sas epc solution private limited',
    'Sage publications india private limited',
    'MENTHA AND ALLIED PRODUCTS Private Limited',
    'S mehta investments private limited',
    'Mm it vision private limited',
    'SHEEN CORPORATE SERVICE PRIVATE LIMITED',
    'Lohia brothers pvt ltd',
    'K.t.c. (india) private limited',
    'Hgs (india) limited',
    'J b aluminium industries private limited',
    'Olympic pharmacare private ltd',
    'Aroma organics ltd',
    'Pandori electronics private ltd',
    'Metalogic spatial research centre private limited',
    'Kleenoil filtration india private limited',
    'Vibrant solutions private limited',
    'Vidula consultancy services limited',
    'Vardhan finvest limited',
    'Mercury fabric creations private limited',
    'KISH EXPORTS PRIVATE LIMITED',
    'Global e travel solutions private limited',
    'Multiplex fincap limited',
    'A e telelink systems limited',
    'Arjun fininvest limited',
    'Netedge it incubator solutions private limited',
    'Purvanchal construction works private limited',
    'Arms securities private limited',
    'Newage credits private limited',
    'Elecon conductors limited',
    'Aero promoters private limited',
    'G.t.s. exports private limited',
    'Skg engineering private limited',
    'Vsg investments private limited',
    'Gray matters consulting private limited',
    'PROTECH TEXTILES AND TRIMS PRIVATE LIMITED',
    'Rohde & schwarz india private limited',
    'L i and fung india private limited',
    'Niyojit farms private limited',
    'SUZUKI MOTORCYCLE INDIA PRIVATE LIMITED',
    'Clintus network limited',
    'People for the ethical treatment of animals india u s 25',
    'Emedlife insurance broking services limited',
    'Gauri shankar paints and chemicals private limited',
    'Ideal broadcasting (india) private limited',
    'ISAP INDIA FOUNDATION',
    'CANDOR KOLKATA ONE HI-TECH STRUCTURES PRIVATE LIMITED',
    'Pace marketing solutions private limited',
    'V3 publishers private limited',
    'Print studio (india) private limited',
    'Bagai golden transport co private ltd',
    'Bayer bioscience private limited',
    'Shunyata productions private limited',
    'Urja communications private limited',
    'Identiti design private limited',
    'Digital info media private limited',
    'SUGS LLOYD PRIVATE LIMITED',
    'Ota new delhi private limited',
    'Sanitary and allied industries private limited',
    'Lms integration india private limited',
    'REVA INDUSTRIES INDIA PRIVATE LIMITED',
    'Chemtex global engineers private limited',
    'General atlantic private limited',
    'Alximix waste management private limited',
    'Varun hydrotech consultants private limited',
    'Cotlon estates private limited',
    'Usha shriram enterprises private limited',
    'Shimla satellite cable private limited',
    'K c city centre private limited',
    'Ruckus wireless private limited',
    'Divum corporate services private limited',
    'Elliott ebara turbomachinery india private limited',
    'TRANZ-COM BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Asta communications private limited',
    'Ixoraa media private limited',
    'Abisol enterprises private limited',
    'Bluejay enterprises private limited',
    'Trasccon interconnection systems private limited',
    'Electronic product services (india) private limited',
    'Advantedge healthcare solutions private limited',
    'Intralox (india) private limited',
    'Ideas ahead av solutions private limited',
    'Entrupy technologies private limited',
    'Mach 1 global supply chain services india private limited',
    'Clean4u services private limited',
    'Edgate technologies private limited',
    'Bp events private limited',
    'Shreya philanthropic foundation',
    'Girias childrens explorium private limited',
    'DHIMINDS BUSINESS SERVICES PRIVATE LIMITED',
    'Innate enterprise private limited',
    'Ahb financial advisors private limited',
    'Mapplinks digital private limited',
    'FINCARE BUSINESS SERVICES LIMITED',
    'Annapoorna entertainment world developers private limited',
    'Emed human resources india private limited',
    'Aditya birla ahura centre management private limited',
    'Gujarat guardian limited',
    'Anubha polyweaves pvt ltd',
    'Yard house brewery private limited',
    'WOL 3D INDIA LIMITED',
    'Mustang apparels private limited',
    'Raj international limited',
    'Haritag exports private limited',
    'Premier tex products private limited',
    'Sree mookambika textiles private limited',
    'Karpagam weaves private limited',
    'Veen waters (india) private limited',
    'KUM DESIGN PRIVATE LIMITED',
    'Prassanna spinning mills private limited',
    'Roshan fruits india private limited',
    'Blue-fin frozen foods private limited',
    'Scotic designs private limited',
    'Triumph foods private limited',
    'WIPRO ENTERPRISES Private Limited',
    'Cnc dia jewels private limited',
    'Lincon polymers private limited',
    'Kogta grain private limited',
    'Jap apparels private limited',
    'Bombay fibre industries private limited',
    'Krislon synthetics private limited',
    'Unique seeds private limited',
    'Patco foods private limited',
    'Unitec fibres private limited',
    'Rays creations private limited',
    'J.m. style & design private limited',
    'ARVIND SUIT MANUFACTURING PRIVATE LIMITED',
    'Kothari cotton mills private limited',
    'G m s processors private limited',
    'West bengal knitwear park private limited',
    'Modesto fabrics pvt ltd',
    'Payal flakes private limited',
    'S. g. mittal enterprises private limited',
    'Xl naturals private limited',
    'Shankar embroidery private limited',
    'Magic clothing private limited',
    'Brandix india apparel city private limited',
    'D k shell button industries private limited.',
    'Mahavira collections private limited',
    'B s apparel exports private limited',
    'Aachi spices and condiments private limited',
    'Biking food products private limited',
    'Aaksh beverages private limited',
    'A.b. grain spirits private limited',
    'Signora woven stuff private ltd',
    'OMTEX SPORTS INTERNATIONAL PRIVATE LIMITED',
    'Anushree fabrics private limited',
    'Glowfab industries private limited',
    'Kgi clothing private limited',
    'Tushya overseas private limited',
    'Natural intima private limited',
    'Sentra yarns limited',
    'Lakshmi narasimha textiles private limited',
    'Shree vallabh creations private limited',
    'Kct textiles limited',
    'The ahmedabad mill and gin stores merchants association',
    'Jivraj industries limited',
    'Chique fashion private limited',
    'Farida classic shoes private limited',
    'Arkay leathers private limited',
    'Anand texturisers private limited',
    'Clim leather manufacturing private limited',
    'Krafti leather trading house private limited',
    'Navigator enterprises private limited',
    'Jain hitex creations private limited',
    'Metmill footwear private limited',
    'Ub international trading limited',
    'MAYUR GLOBAL PRIVATE LIMITED',
    'Ethiraj timbers private limited',
    'Dholka plywood industries private limited',
    'Associate decor limited',
    'Deekay pine board private limited',
    'Importex international private limited',
    'Kachins clothing private limited',
    'Kashmir distillaries private limited',
    'Chhattisgarh paper box private limited',
    'Emgee holidays private limited',
    'Paper packs private limited',
    'Glencol colours private limited',
    'Shakti textile engineers private limited',
    'Madhuram fabrics private limited',
    'Jal exports private limited',
    'Udaya cartons private limited',
    'Gajaananda apparel company india private limited',
    'Compass tex india private limited',
    'Milano impex private limited',
    'Nappa dori private limited',
    'Sgs export private limited',
    'Angus and graphers publishers private limited',
    'Murugan magazine distributors private limited',
    'Tapio yfm designs private limited',
    'Lt apparel private limited',
    'Aathava garments india private limited',
    'Ada news in shorts private limited',
    'Indspire media private limited',
    'Saintwater communications private limited',
    'Off road films private limited',
    'AXIS MY INDIA LIMITED',
    'Mahaa energy india private limited',
    'SOLAPUR SOLAR ENERGY PRIVATE LIMITED',
    'Abil energy private limited',
    'Ecosol power private limited',
    'Rupa jal vidyut private limited',
    'Shree ganesh epc private limited',
    'Teamtronix (india) private limited',
    'K.u.n.motorcycles private limited',
    'Laksh power private limited',
    'Regen powertech private limited',
    'Mas gasair systems private limited',
    'Hiteco tool management services india private limited',
    'A2v energie private limited',
    'GERON GREEN FUEL PRIVATE LIMITED',
    'VENA ENERGY FATANPUR POWER PRIVATE LIMITED',
    'VENA ENERGY JMD POWER PRIVATE LIMITED',
    'Power and energy technologies private limited',
    'Shashwati power private limited',
    'Nica technologies (india) private limited',
    'Controlwellindia pvt ltd',
    'NP KUNTA RENEWABLES PRIVATE LIMITED',
    'Puto energy infrastructure private limited',
    'CHIRON ADVERTISING AND MARKETING PRIVATE LIMITED',
    'Cape electric power production private limited',
    'DHOLI EFFLUENT TREATMENT PLANT PRIVATE LIMITED',
    'Qua water technologies private limited',
    'Water treatments technology (india) private limited',
    'CONTEMPORARY FURNITURES PRIVATE LIMITED',
    'Opera holdings private limited',
    'TORQ COMMODITIES PRIVATE LIMITED',
    'Fire townships private limited',
    'Parsvnath hb projects private limited',
    'Raju contractors private limited.',
    'KDP RESIDENCY PRIVATE LIMITED',
    'Soni nanalal bechardas jewellers private limited',
    'Gem star company private limited',
    'Siddham infratech private limited',
    'KISHANGARH BEAWAR NH-8 TOLLWAY PRIVATE LIMITED',
    'Kotkapura muktsar tollways private limited',
    'Supreme vasai bhiwandi tollways private limited',
    'Nilgai furniture private limited',
    'Fyffar projects private limited',
    'Precious infraprojects private limited',
    'Cheloor housing & infrastructure private limited',
    'Tecknode packaging solutions private limited',
    'K. PATEL & CO. PRIVATE LIMITED',
    'Sonal properties private limited',
    'Goodwill properties private limited',
    'Rajendra castor private limited',
    'MELAN HYDRO POWER PRIVATE LIMITED',
    'Sharp tanks and structurals private limited',
    'Roongta developers private limited',
    'Abu developers p ltd',
    'VISHVARAJ INFRASTRUCTURE PRIVATE LIMITED',
    'Whitsun contractors and builders private limited',
    'Ayg edifices private limited',
    'VAIKUNTA WEAVES PRIVATE LIMITED',
    'Ashoka housing constructions private limited',
    'Kusha development and reality private limited',
    'Ecogreen energy private limited',
    'Rayala corporation private limited',
    'Samitan electropowers private limited',
    'SAHARA INDIA POWER CORPORATION LIMITED',
    'Cms india operations and maintenance company private limited',
    'Svs realty private limited',
    'VENA ENERGY KN WIND POWER PRIVATE LIMITED',
    'Uniflex projects private limited',
    'Nani s buildcon private limited',
    'Inspira martifer solar limited',
    'Green edifice infraventures private limited',
    'Dev nrgee resource private limited',
    'Modi cityscape private limited',
    'Innovela building solutions private limited',
    'Jairaj shelters private limited',
    'Golden leaf constrotech & infra private limited',
    'Sunmoksha power private limited',
    'Mecprosys machine tools private limited',
    'Aera gas control systems private limited',
    'K d building solutions private limited',
    'Sbc realty private limited',
    'Sitanshu realtors private limited',
    'Sspdl infra projects india private limited',
    'Sspdl resorts private limited',
    'Sspdl realty india private limited',
    'Basant aerospace private limited',
    'Doors and doors systems private limited',
    'Designwell land solutions private limited',
    'Anri builders private limited',
    'Meso prime spaces private limited',
    'Samvit impex private limited',
    'Fountainhead procon private limited',
    'HSK LOGISTICS ASSETS (INDIA) PRIVATE LIMITED',
    'Sunpaul properties private limited',
    'Madurai business services private limited',
    'TOFL INFRASTRUCTURE LIMITED',
    'KGEYES PATHANAMTHITTA INFRA LIMITED',
    'Singhvi developers private limited',
    'Eskays constructions pvt ltd',
    'Klassic constructions pvt ltd',
    'Excel infra n realty private limited',
    'Parshwanath enterprises private limited',
    'Vinit realties private limited',
    'Shubhay builders and developers private limited',
    'ADIE BROSWON PINNACLE PRIVATE LIMITED',
    'Lv india capital private limited',
    'Oriental finstock services private limited',
    'Kerala transport development finance corpn ltd',
    'L. c. raheja forex private limited',
    'NILA SPACES LIMITED',
    'Varma security solution private limited',
    'SHRIRAM INVESTMENT HOLDINGS PRIVATE LIMITED',
    'PERUVAMBA ENGINEERING LIMITED',
    'Unicorp advisors private limited',
    'Eprss prepaid recharge services india private limited',
    'Varchas holdings private limited',
    'Subal securities p ltd',
    'Hexolabs interactive technologies private limited',
    'Arun selvan logistics private limited',
    'Kotak mahindra trustee company limited',
    'Chika private limited',
    'Kellton securities private limited',
    'Karvy forex & currencies private limited',
    'Deus financial capital private limited',
    'ENDIYA TRUSTEE PRIVATE LIMITED',
    'Assetz premier wealth advisory private limited',
    'Maben nidhi limited',
    'Kotak mahindra asset management company limited',
    'Aries management services private limited',
    'Habitat micro build india housing finance company private limited',
    'Raja agencies india private limited',
    'D.A LOGISTICS & FARMING PRIVATE LIMITED',
    'CHENNAI TESTING LABORATORY PRIVATE LIMITED',
    'Pai chits private limited',
    'International clearing & shipping agency(india) private limited',
    'Mtl marine trans logistics private limited',
    'Ananya investment consulting private limited',
    'Vr1 telecom private limited',
    'Clover holdings and trading private limited',
    'ALTICO ADVISORS LIMITED',
    'CENTRUM HOLDINGS LIMITED',
    'SCAPERS REALTY INDIA PRIVATE LIMITED',
    'Arpita telecom and computer services private limited',
    'Sun telematics private limited',
    'Ficus telecom private limited',
    'PERUVAMBA ESTATES PRIVATE LIMITED',
    'CONNECTED AUDIO PRIVATE LIMITED',
    'R.v. investment and dealers ltd',
    'THAR COMMERCIAL FINANCE PRIVATE LIMITED',
    'Greshma finvest private limited',
    'Easyaccess financial services limited',
    'Mahamaya forex private limited',
    'Indira financial services private limited',
    'Chunnamal financial resources limited',
    'Rentex weavers limited',
    'Iep fund advisors private limited',
    'Profitplus stocktrade private limited',
    'Avikal tradelink private limited',
    'Venkatlakshmy holdings private limited',
    'Vlm projects private limited',
    'Mount shikhar stock broking services private limited',
    'National securities pvt ltd',
    'D.c.investments and finance private limited',
    'Radheshyam finvest private limited',
    'Gawande consultants private limited',
    'Total holdings finvest private limited',
    'Aasman financial services private limited',
    'Egs computers india private limited',
    'V.e.c investment management (india) private limited',
    'Finco holdings private limited',
    'Mnr bhavitha chits private limited',
    'J.n. chit funds private limited',
    'MIKITOSH TRADING PRIVATE LIMITED',
    'Bidhata investment and finance private limited',
    'Cons holding ltd',
    'CLICK INVESTMENTS AND TRADING COMPANY PRIVATE LIMITED',
    'Pande investments pvt ltd',
    'R raheja investments private limited',
    'Sanand investments and trading co pvt ltd',
    'LML SPACE FILLER PRIVATE LIMITED',
    'Allsec securities limited',
    'Dsrc consultants private limited',
    'Band holdings private limited',
    'Shalimar industries ltd',
    'K g fashioners pvt ltd',
    'Shiv shakti embroideries private limited',
    'B l k lifestyle limited',
    'Nldk timbers private limited',
    'Mpi papers private limited',
    'KTL LOGISTICS & SERVICES PRIVATE LIMITED',
    'Sri balaji papers international private limited',
    'P.s.pack solutions private limited',
    'Bharat petrolubes private limited',
    'Ritu petro industries private limited',
    'Shilpa agarbatti company private limited',
    'Kunal conchem private limited',
    'Pharmazz india private limited',
    'Coatseal polymers private limited',
    'Mj corp private limited',
    'Amana literature private limited',
    'Jk gypsum private limited',
    'Pranava lab solutions private limited',
    'Nascent chemical industries limited',
    'Elkay chemicals pvt ltd',
    'Yogeshwari petrochemicals private limited',
    'Pmd chemicals private limited',
    'Silverline fertilisers private limited',
    'Sandhya organic chemicals pvt ltd',
    'Makson formulations pvt ltd',
    'Canton laboratories private limited',
    'Sunshine organics pvt ltd',
    'Salex india private limited',
    'Dynamic speciality chemicals limited',
    'Assam air products pvt ltd',
    'Xron gases private limited',
    'Chemsworth private limited',
    'News line publications private limited',
    'Shri kali media private limited',
    'Alternative news network private limited',
    'Acme chem ltd',
    'Torque pharmaceuticals private limited',
    'Shri indtex boiler pvt ltd',
    'ABBEY ADVISORY PRIVATE LIMITED',
    'New delhi print media private limited',
    'Ink publications private limited',
    'Lancer footwear india private limited',
    'KIECITE MICRONUTRIENTS PRIVATE LIMITED',
    'SATRITE MANUSEC PRIVATE LIMITED',
    'CRIS PHARMA (INDIA) LIMITED',
    'Rajasthan gum private limited',
    'Tradebase chemicals private limited',
    'Stilla enterprises india private limited',
    'RHEIN SHOES LIMITED',
    'Sanghvi plywood and timber pvt ltd',
    'Balaji prelams private limited',
    'Fabulous creations private limited',
    'Cremica food specialities limited',
    'Lyra laboratories private limited',
    'Avecon healthcare pvt ltd',
    'Essp meditek pvt ltd',
    'PIONEER AGRO INDUSTRIES SANVIN LABORATORIES PRIVATE LIMITED',
    'Mosil lubricants private limited',
    'Mithros chemicals private limited',
    'Vaishno devi height & promoters private limited',
    'Ratroi maa builders private limited',
    'Abohar builders private limited',
    'Amur developers private limited',
    'Arahan properties private limited',
    'Ascent promoters and developers private limited.',
    'Intellect projects private limited',
    'Unitech wireless (tamilnadu) private limited',
    'Antal properties private limited',
    'Sai harikrupa builders private limited',
    'Naiknavare housing developments private limited',
    'Evalueserve sez (gurgaon) private limited',
    'Naiknavare constructions private limited',
    'Sga projects private limited',
    'Indra buildcon private limited',
    'Woodpecker apartments & suites private limited',
    'A and r buildmart private limited',
    'Sunrise durobuild private limited',
    'Usg buildcon private limited',
    'Apoorva infraproject private limited',
    'Prime infradevelopers private limited',
    'H j properties pvt ltd',
    'Sukhvarsha developers private limited',
    'Pythoss developers private limited',
    'Bagga link infrastructures private limited',
    'Usg estate private limited',
    'Great india builders private limited',
    'S D CORPORATION HOLDINGS PRIVATE LIMITED',
    'Svm infrastructure private limited',
    'Scee infrastructure private limited',
    'Solux infratel private limited',
    'MONAARC CORPORATION PRIVATE LIMITED',
    'Renaissance commerce private limited',
    'Wega developers private limited',
    'DSK Infra Private Limited',
    'Navayuga infrastructure corporation private limited',
    'Gnostic developers private limited',
    'Landmark housing projects chennai private limited',
    'Velvet developers private limited',
    'Anandamayee developers private limited',
    'VSM INFRASTRUCTURE & DEVELOPERS PRIVATE LIMITED',
    'Nmn developers private limited',
    'Avon infracon private limited',
    'Purus properties private limited',
    'Neelgagan impex private limited',
    'Mohit nirman private limited',
    'Pratik infra developers private limited',
    'Robot developers private limited',
    'Shivdhan realtors private limited',
    'Presidency projects private limited',
    'Unitech real-tech properties limited',
    'Unitech high vision projects limited',
    'Venerate construction private limited',
    'Bebanco northern contracts limited',
    'Living creations private limited',
    'Sconce global private limited',
    'Sincere construction company private limited',
    'Soul space realty limited',
    'Fabking solutions private limited',
    'U d infrastructures private limited',
    'Hem bhattad realty private limited',
    'Bhattad construction private limited',
    'Bhattad infrastructure private limited',
    'A s motors private limited',
    'S7 cars india private limited',
    'Frontier roadways private limited',
    'Future infraindia private limited',
    'Wbi engineering private limited',
    'Uttaranchal automobiles private limited',
    'SMART VALUE PRODUCTS AND SERVICES LIMITED',
    'FOCUZ AUTOMOBILE SERVICES PRIVATE LIMITED',
    'Vora automotives private limited',
    'Jash impex private limited',
    'SIKCO AUTOMOTIVE PRODUCTS LIMITED',
    'Rajmandir auto private limited',
    'Arvia constructions private limited',
    'Evo con private limited',
    'Abhyudaya developers private limited',
    'IGI REALSTONE PRIVATE LIMITED',
    'Dynamic enclave private limited',
    'I-RED PROJECTS LIMITED',
    'Heritage infra solutions private limited',
    'Asim industries private limited',
    'Arunabh conclave private limited',
    'Debajam realty private limited',
    'Poddar tradecom private limited',
    'Vinayak autotrade private limited',
    'Gt eurogroove private limited',
    'Jsr buildwell private limited',
    'Padam motors private limited',
    'Spj commercials private limited',
    'Bhattad enterprises private limited',
    'Jain cars private limited',
    'Janaki international private limited',
    'Bhakat bhai electronics pvt ltd',
    'Chimmaneshwar exim private limited',
    'Sanya automobiles private limited',
    'Deep autotec private limited',
    'Girdhari automobiles private limited',
    'Zem overseas private limited',
    'Sanjayraj autolink private limited',
    'Dhanlabh tradelinks private limited',
    'Jay smelter limited',
    'Sreenivas shoes private limited',
    'H m c equipments private limited',
    'Nuberg exports private limited',
    'Solitaire merchandising private limited',
    'Premier roadlines limited',
    'Eminence engineering services private limited',
    'Nihal fiscal services pvt ltd',
    'Anuraj securities pvt ltd',
    'Mak realtors private limited',
    'Apm construction private limited',
    'Panshil developers private limited',
    'Yash buildcon private limited',
    'Rudrani construction private limited',
    'Unique nirman private limited',
    'M. k. n. projects private limited',
    'Randhawa buildtech private limited',
    'Randhawa realtors private limited',
    'Randhawa buildwell private limited',
    'Cig developers private limited',
    'August habitats private limited',
    'Rishi enclave pvt ltd',
    'Sukhsagar hirise pvt ltd',
    'Bengal merlin infrastructure limited',
    'Ambit infrabuild private limited',
    'Unitech golf resorts limited',
    'Anupam estate & trading private limited',
    'Netambit home options private limited',
    'Green meadows constructions and real estates private limited.',
    'Knightsbridge real estate and construction private limited',
    'Randhawa realcon private limited',
    'Pee iie investments pvt ltd',
    'Ssr townships private limited',
    'Darshan appartments private limited',
    'Seaward realty private limited',
    'Arena stud farm private limited',
    'Bigsearch properties private limited',
    'Neil properties private limited',
    'Mileage properties private limited',
    'Gossip properties private limited',
    'Precaution properties private limited',
    'SHAPOORJI PALLONJI DEVELOPMENT MANAGERS PRIVATE LIMITED',
    'Shatranj properties private limited',
    'Blue riband properties private limited',
    'S. d. svp nagar redevelopment private limited',
    'Sasmita realties private limited',
    'Silver stream realty private limited',
    'Trend setter realty private limited',
    'Greatbuild realty private limited',
    'Greatdesign realty private limited',
    'Khvafar property developers private limited',
    'Mirth property developers private limited',
    'Sahej infraprojects private limited',
    'Raghunath panda & sons private limited',
    'Kartar colonizers private limited',
    'Arnav properties private limited',
    'H m estates private limited',
    'Mayank niketan pvt ltd',
    'A. m. software solutions private limited',
    'Xtra maintenance services private limited',
    'Rishika promoters private limited',
    'KCT FINANCIAL & MANAGEMENT SERVICES PRIVATE LIMITED',
    'BENGAL PARK CHAMBERS HOUSING DEVELOPMENTLIMITED',
    'Bengal united credit belani housing limited',
    'DRISHTI LAND & INFRASTRUCTURE PRIVATE LIMITED',
    'M.s. hirise private limited',
    'BOUGAINVILLA HOUSING & INFRASTRUCTURE PRIVATE LIMITED',
    'RDB JAIPUR INFRASTRUCTURE PRIVATE LIMITED',
    'Prodigy consultants private limited',
    'Waterfall plaza private limited',
    'Satori property developers private limited',
    'Netambit valuefirst services private limited',
    'ADVIONS INFRA & BASIC AMENITIES LIMITED',
    'An infracon private limited',
    'INDORUS OPTO SIGHTS PRIVATE LIMITED',
    'M.k.r. buildwell private limited.',
    'Contours infrastructure private limited',
    'Neelmani construction private limited',
    'C s buildwell private limited',
    'Neon buildwell private limited',
    'Dantas properties private limited',
    'Viarn infrastructure private limited',
    'Radhapriya properties private limited',
    'Manhattan enterprises (india) private limited',
    'Cig realtors private limited',
    'Nineyards realty private limited',
    'Lavitra developers private limited',
    'Sansaar prime real estate private limited',
    'Ryh real estates private limited',
    'Naran lala estate private limited',
    'Pvk realty private limited',
    'JOYVILLE SHAPOORJI HOUSING PRIVATE LIMITED',
    'Blessing properties private limited',
    'S. d. town development private limited',
    'S.d. suburban development private limited',
    'Cottoncity farm houses private limited',
    'Bengal park realty private limited',
    'Blue berry holding private limited',
    'AYUSH PROPERTIES & DEVELOPERS PVT.LTD.',
    'Neelkanth infrapromoters private limited',
    'Blossom dealers private limited',
    'Anirdesh projects limited',
    'Tanvi niwas private limited',
    'Hrj global private limited',
    'Shayog heights private limited',
    'IRC CAPITAL SERVICES PRIVATE LIMITED',
    'Utc softech private limited',
    'Kanasar projects private limited',
    'Shivsai tower private limited',
    'Amikab enterprises private limited',
    'Randhawa buildcon private limited',
    'Legend highlands private limited',
    'Acropolis maintenance services private limited',
    'Waterfall complex private limited',
    'Tel-abridge (international) limited',
    'Swiss cert private limited',
    'Transaegis systems private limited',
    'Sundar eye hospital private limited',
    'Shokeen developers private limited',
    'AMMADOES TRADING AND CONSULTANTS PRIVATELIMITED',
    'VASU BANQUET & CATERERS PRIVATE LIMITED',
    'Banyan corporate advisors private limited',
    'PEARL BEACH HOSPITALITY PRIVATE LIMITED',
    'Integrated centre for consultancy private limited',
    'Artisan decor private limited',
    'MARUTI SUZUKI INSURANCE BROKING PRIVATE LIMITED',
    'Mtm-caresoft manufacturing consultancy private limited',
    'RAYMUND LOBO CORPORATE SERVICES PRIVATE LIMITED (OPC)',
    'Inter land developers private limited',
    'City network broadcast convergence private limited',
    'Avizva solutions private limited',
    'Natasha executive network private limited',
    'Karni industries private limited',
    'Eminence exhibition solutions private limited',
    'Na human resource solution private limited',
    'Careercruise hr private limited',
    'Nu-clean infra services private limited',
    'Design deal india private limited',
    'AMAZON SMART COMMERCE SOLUTIONS PRIVATE LIMITED',
    'MONDEO CONSULTING ENGINEERS PRIVATE LIMITED',
    'Toshiba logistics india private limited',
    'Business correspondent federation of india',
    'Xs productions india private limited',
    'Prototyze services private limited',
    'Gea process engineering (india) private limited',
    'Global extrusions private limited',
    'Blue hawk security services private limited',
    'Wellindia commodities private limited',
    'Sivanta luxmi forex private limited',
    'Radiant hues consultancy services private limited',
    'Smart automation technologies private limited',
    'Office street private limited',
    'Bond human resources private limited',
    'Maestro human resources private limited',
    'Global connect solutions private limited',
    'Industrial general products pvt ltd',
    'G r poly papers private limited',
    'Hoshang trading private limited',
    'Bmss steel industries pvt.ltd.',
    'Kainya and associates private limited',
    'Sumedh tools private limited',
    'A.T.E. HUBER ENVIROTECH PRIVATE LIMITED',
    'Marsman india cranes private limited',
    'SQUIRREL ENTERPRISES PRIVATE LIMITED',
    'Mercury advisors private limited',
    'Shutham industries limited',
    'Rehau polymers private limited',
    'Ebz advisory services private limited',
    'A to z housekeeping solutions private limited',
    'Logical outsourcing services private limited',
    'Tintometer india private limited',
    'INFINITY EXPO PRIVATE LIMITED',
    'Prisam infotech private limited',
    'Maa sheetla autowheels private limited',
    'Deifik automations pvt ltd',
    'Glitz logistics private limited',
    'Nilkanth barter private limited',
    'BAISAKHI',
    'S SOLUTIONS LIMITED',
    'Brothers polypack pvt limited',
    'Govinda educational services',
    'Wlc education foundation',
    'Alyss edusolutions private limited',
    'BRIGHT STAR LIFE SPACE PRIVATE LIMITED',
    'Venture skillindia private limited',
    'Progressive curriculum management p ltd',
    'Associated learning private limited',
    'Polyprint packaging products pvt ltd',
    'Orko knowledge ventures private limited',
    'Institute of scientific education and learning private limited',
    'Boston university foundation - india',
    'Kanazia telecommunication development centre',
    'Knowledge station (india) private limited',
    'Island travel education private limited',
    'PROCAREER EDUCARE PRIVATE LIMITED',
    'Dream health ventures private limited',
    'GERAD INTERNATIONAL RESOURCES PRIVATE LIMITED',
    'Zat automobiltechnik india private limited',
    'Satzee technologies private limited',
    'Express insurance academy private limited',
    'SAIBA APPARELS LIMITED',
    'Kaasni crafts and creations private limited',
    'Apar fashion private limited',
    'Omaxe pragati maidan exhibition limited',
    'Botree communications private limited',
    'Shriniwasa Marketing & Logistics Private Limited',
    'Nivedita engineering enterprises private limited',
    'Sri lalitha plastic industries private limited',
    'Biosynth life sciences india limited',
    'Nanoceut therapeutics private limited',
    'Sigma glasstech private limited',
    'Prime medica promotion private limited',
    'Fortune biotech ltd',
    'Koundinya pharmaceuticals and foods private limited',
    'Sark healthcare private limited',
    'Nulux machine tools exports pvt ltd',
    'Higlance laboratories private limited',
    'Klintoz pharmaceuticals private limited',
    'Maxwin chemtech private limited',
    'Ambica pharma machines private limited',
    'Laurent tiles private limited',
    'Prateek agropipes private limited',
    'Hemsen rubber private limited',
    'C.c.s. projects and equipments private limited',
    'SHRIVALLABH PITTIE RESEARCH AND TRAINING PRIVATE LIMITED',
    'Indrox steel services india private limited',
    'Globus steel & power private limited',
    'Drolia electrosteels private limited',
    'Vaishnodevi international private limited',
    'S & h manufacturing & trading private limited',
    'Mehta herbals pvt ltd',
    'G.R. KRISHNA FERRO ALLOYS PRIVATE LIMITED',
    'Davesmen india private limited',
    'Nova dyestuff industries private limited',
    'A p i ispat and powertech private limited',
    'Tejas strips private limited',
    'Anchor fabcon private limited',
    'VARAHI PLASTICS & PACKAGING PRIVATE LIMITED',
    'M s chhabra plastech private limited',
    'Bajaj plastics private limited',
    'Tirupati plastomatics pvt ltd',
    'Tijaria industries limited',
    'Western precicast p ltd',
    'Akshara ferro-tech private limited',
    'Shakthiman extrusions private limited',
    'Narsingh ispat limited',
    'B d sponge iron private limited',
    'Gautam stainless private limited',
    'Bekaert industries private limited',
    'Electrocast sales india ltd',
    'Vipra ferro alloys private limited',
    'First wardha steel limited',
    'SHARP CHUCKS AND MACHINES LIMITED',
    'Mahalakshmi profiles private limited',
    'Thermosol glass india private limited',
    'Trimuriti glass containers limited',
    'Hi-tec rockfibre private limited',
    'Bravo industries limited',
    'Kanoi tea pvt ltd',
    'Western india ceramics private limited',
    'Makson ceramics private limited',
    'Thermotech systems limited',
    'Sree metaliks ltd.',
    'Renuka cement limited',
    'Thermit alloys private limited',
    'Minox metal private limited',
    'Construma met-equip private limited',
    'Agarwal prime metals private limited',
    'MUTHA METAL PRODUCTS PVT, LTD',
    'Anugraha valve castings limited',
    'East coast enterprisers limited',
    'Saraf agencies private limited',
    'Maithan ispat limited',
    'Precision plastic engineering private limited',
    'Plast master batches limited',
    'Unnati fortune industries private limited',
    'Polycon industries private limited',
    'Hermes steel enterprises private limited',
    'NEW MANAK METALLOYS LIMITED',
    'Gold metal and alloy extrusion private limited',
    'Brass arts (india) pvt ltd',
    'Mesco steels limited',
    'Metlonics industries private limited',
    'Blue forgings pvt ltd',
    'Automotive steel co pvt ltd',
    'M.j. structures private limited',
    'Kadimi international private limited',
    'Ti steels private limited',
    'Jindal stainless steelway limited',
    'Progressive stamping private limited',
    'Pari metcast pvt ltd',
    'AASTROPURE CHEMICALS PRIVATE LIMITED',
    'Se forge limited',
    'Uni-metal systems private limited',
    'Riflex industries private limited',
    'Pipl minmetal private limited',
    'Himadri steel private limited',
    'Global castings private limited',
    'Cymose metals pvt ltd',
    'Ameet metaplast private limited',
    'Madanlal forge private limited',
    'UNITED MOTORS (INDIA) Private Limited',
    'Bhrigu metals private limited',
    'GOKARN SPONGE AND POWER PRIVATE LIMITED',
    'Sprech tenso-structures private limited',
    'V-tech instrumentation (india) private limited',
    'Technoshell automations private limited',
    'TMKI MACHINE PARTS PRIVATE LIMITED',
    'SHRI KARA ENGINEERING PRIVATE LIMITED',
    'New era steels ltd',
    'Karo coils private limited',
    'Smith industrial corporation private limited',
    'Joy architronic products private limited',
    'Alok wires pvt ltd',
    'A p s containers pvt ltd',
    'Adarsh infraprojects private limited',
    'Resilient exports private limited',
    'Siemens syntex pvt. ltd.',
    'Lawrence merchants pvt ltd',
    'K. s. automobiles private limited',
    'Saffire marketing private limited',
    'Daksh auto (india) private limited',
    'Hari distributors private limited',
    'Rg saga exports private limited',
    'Pilot 2 wheelers private limited',
    'Remik trading company private limited',
    'Yes trading private limited',
    'Kct trading private limited',
    'Aashirwad tieup pvt ltd',
    'Purplecrow enterprises private limited',
    'Rkm projects private limited',
    'Manaco exim private limited',
    'Sudarshan vincom private limited',
    'S h commerce private limited',
    'Pnk properties private limited',
    'Kay hi-tech engineers private limited',
    'Blue triangle infrastructures private limited',
    'Jindal vincom private limited',
    'Trishul vanijya private limited',
    'Express dealcom private limited',
    'B m developers private limited',
    'Altop constructions private limited',
    'Luxury india impex private limited',
    'Ambrosia natural products (india) private limited',
    'Loil international foods limited',
    'Pinkcity tea company private limited',
    'East commercial p ltd.',
    'Goan liquor products private limited',
    'Roger motors private limited',
    'Cygnus investments &finance private limited',
    'Jkm overseas pvt. ltd.',
    'S m r businesses pvt ltd',
    'Priyanka impex private limited',
    'Lindex impex private limited',
    'Bilawal exports private limited',
    'Sunman vincom pvt ltd',
    'Pranami estates pvt. ltd.',
    'Apollo interior solutions private limited',
    'Efcalon tie-up private limited',
    'Mukund international private limited',
    'Exim distributors private limited',
    'Fusion life sciences private limited',
    'Vitan medical systems private limited',
    'MICROBAN INDIA PRIVATE LIMITED',
    'Adonis medical systems private limited',
    'Unitednaturex dot com private limited',
    'Pure vyapaar private limited',
    'Normak fashions private limited',
    'Vishv exim private limited',
    'Premier tradecom private limited',
    'Salgaocar metals and minerals private limited',
    'Blackstone multi trading limited',
    'Pacharia exports pvt ltd',
    'Qvc international private limited',
    'Rudraksh dealcom private limited',
    'Pack paper agencies private limited',
    'Mahashakti mercantile private limited',
    'Kerala balers private ltd',
    'Yarner marketing private limited',
    'Jindal vanijya private limited',
    'Zeo-tec adsorbents private limited',
    'Changemasters management consulting private limited',
    'SAYA REALCOM PRIVATE LIMITED',
    'Rashmi sales private limited',
    'Nirvan merchandise pvt. ltd.',
    'Sargo impex pvt ltd',
    'Medivision diagnostics private limited',
    'Yire exim & hotels private limited',
    'Internet merchandise private limited',
    'ASTRUM PETRO ADDITIONS PRIVATE LIMITED',
    'JOHNS ELECTRIC COMPANY PRIVATE LIMITED',
    'Rajan enterprises private limited',
    'Protech exim (india) private limited',
    'Indo perlite private limited',
    'WARDEN AERONAUTICS ACADEMY PRIVATE LIMITED',
    'Vinco sales and services private limited',
    'Raghvani exports private limited',
    'TOPAZ INGREDIENTS PRIVATE LIMITED',
    'Kesar gift mart private limited',
    'OLWYN PHARMA PRIVATE LIMITED',
    'Green land fertilizers limited',
    'Sunfine trading company private limited',
    'Diacore india private limited',
    'Jannat enterprises pvt ltd',
    'Coloured rocks trading private limited',
    'Sdt consultants private limited',
    'Trissur sand and gravel pvt ltd',
    'Jalousies (india) private limited',
    'N m birla stone international private limited',
    'MURARKA PAINT & VARNISH WORKS LTD',
    'Essjay mercantile private limited',
    'Sevcon (india) private limited',
    'Alliance infotech private limited',
    'Unisource trading (india) private limited',
    'Enn ess trades private limited',
    'BEST INTERNATIONAL PRIVATE LIMITED',
    'Fcml distributors private limited',
    'Jhanji exports private limited',
    'Cannels exports private limited',
    'SANJAY KUMAR AND COMPANY EXIM PRIVATE LIMITED',
    'Shreyam fashion designers private limited',
    'Trueform exports private limited',
    'GLOWRIA LIFECARE PRIVATE LIMITED',
    'Allure impex private limited',
    'DP WORLD RAIL LOGISTICS PRIVATE LIMITED',
    'Aegis estates private limited',
    'Hacienda infradevelopers private limited',
    'Cig estates private limited',
    'Akp infra private limited',
    'Ramprastha realty private limited',
    'Geotech homz private limited',
    'Sai saburi consulting services private limited',
    'Beech projects limited',
    'Equinox promoters private limited',
    'Nature heights infra limited',
    'Vera developers private limited',
    'RAJESH MOTORS PINKCITY PRIVATE LIMITED',
    'Capital infracon private limited',
    'Steady mercantile company pvt ltd',
    'VICTOR MAGNETICS PRIVATE LIMITED',
    'Raw power solution private limited',
    'Checktronix india private limited',
    'Kenla systems private limited',
    'Mamta corporate services private limited',
    'Karuna software private limited',
    'Zaloni technologies india private limited',
    'Ideliver software solutions private limited',
    'Sparc infotech private limited',
    'Multilink computers private limited',
    'MILA GLOBAL TRADE PRIVATE LIMITED',
    'People com consultants india private limited',
    'SANT AUTOCRAFT PRIVATE LIMITED',
    'SBFT ENTERPRISES PRIVATE LIMITED',
    'PUJARA GLOBAL EXPORTS PRIVATE LIMITED',
    'CULTHOUSE RAGTRADE (OPC) PRIVATE LIMITED',
    'DHARAMPUR POWER EVACUATION INFRASTRUCTURE PRIVATE LIMITED',
    'KANARY STAFFING PRIVATE LIMITED',
    'KGNSOFT SOLUTION PRIVATE LIMITED',
    'RENAISSANCE GLOBAL MARKETING AND CONSULTING PRIVATE LIMITED',
    'OHA COMMUTE PRIVATE LIMITED',
    'BIZLOGIX CONSULTANCY SERVICES PRIVATE LIMITED',
    'M. CHAUDHARY MANAGMENT SERVICES PRIVATE LIMITED',
    'HC ROBOTICS PRIVATE LIMITED',
    'MASUU GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TEALOGY CAFE PRIVATE LIMITED',
    'JAISHNAVI EMINENCE PRIVATE LIMITED',
    'ALIIF VENTURES PRIVATE LIMITED',
    'HIGHLAND DE LA MER PRIVATE LIMITED',
    'METAFAABEX INDUSTRIES PRIVATE LIMITED',
    'REACH TO TEACH FOUNDATION',
    'KARYANITYA SERVICES INDIA PRIVATE LIMITED',
    'FOLK NIDHI LIMITED',
    'SIMPLIFORGE 3-D CREATION PRIVATE LIMITED',
    'CYNICAL MARKETER PRIVATE LIMITED',
    'BARREJA DESIGN (OPC) PRIVATE LIMITED',
    'CISIVE INDIA PRIVATE LIMITED',
    'HYDERABAD FINWORKS PRIVATE LIMITED',
    'SYPHON AUTOMATION PRIVATE LIMITED',
    'EUROFINS ADVINUS BIOPHARMA SERVICES INDIA PRIVATE LIMITED',
    'INNOVATIVE TECHNOCARE PRIVATE LIMITED',
    'PERIMETER ECOMMERCE PRIVATE LIMITED',
    'MTC RECYCLING PRIVATE LIMITED',
    'INVESTEC CREDIT FINANCE PRIVATE LIMITED',
    'INTEGRATED SOLAR POWER PRIVATE LIMITED',
    'RTB TECHNOLOGIES PRIVATE LIMITED',
    'SYMANTICS EDUMEDIA PRIVATE LIMITED',
    'MOBWOLF ADVERTISEMENT PRIVATE LIMITED',
    'SUDHIR ENGG. WORKS PRIVATE LIMITED',
    'REVASITAM PRIVATE LIMITED',
    'FLOWCHEM PHARMA PRIVATE LIMITED',
    'FINDOOZ HUB PRIVATE LIMITED',
    'FINE BUNCH PRIVATE LIMITED',
    'FCAP TECHNOLOGIES PRIVATE LIMITED',
    'M3 TOILET RESOURCES INDIA PRIVATE LIMITED',
    'YIREH OLAM DEVELOPERS PRIVATE LIMITED',
    'SWAPNO UDAAN PRIVATE LIMITED',
    'CSY FISHERIES PRIVATE LIMITED',
    'SIMPLIAXIS SOLUTIONS PRIVATE LIMITED',
    'DASHRATH PRASAD ORGANIC FOODS PRIVATE LIMITED',
    'MPL STEEL INDUSTRIES PRIVATE LIMITED',
    'ALLIANZ FMCG PRIVATE LIMITED',
    'PAULS 3DE TECHNOLOGY INDIA PRIVATE LIMITED',
    'VRUKSH ECOSYSTEM FOUNDATION',
    'MUDSKIPPER LABS PRIVATE LIMITED',
    'BUZINESSWARE CLOUD SERVICES PRIVATE LIMITED',
    'PURPLEGRIDS TECHNOLOGIES PRIVATE LIMITED',
    'ITORIX SYSTEMS PRIVATE LIMITED',
    'AMAI CONSULTING PRIVATE LIMITED',
    'KOSSIDO PROJECTS PRIVATE LIMITED',
    'PAVILIONDATA SYSTEMS INDIA PRIVATE LIMITED',
    'PLANMY TOUR INDIA PRIVATE LIMITED',
    'TECHEFFICIO SOLUTIONS PRIVATE LIMITED',
    'DOMORE SOLUTIONS PRIVATE LIMITED',
    'ESS LIFE SCIENCES INDIA PRIVATE LIMITED',
    'YANMAR ENGINE MANUFACTURING INDIA PRIVATE LIMITED',
    'ANANDHIYA INTERNATIONAL MARKETING PRIVATE LIMITED',
    'GEACOM LOGISTICS PRIVATE LIMITED',
    'MG LEGAL INDIA PRIVATE LIMITED',
    'ESSENTUM PRIVATE LIMITED',
    'DWALDIE PAINTS PRIVATE LIMITED',
    'CANDW SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'EDRISHTI MOVIES PRIVATE LIMITED',
    'UTENIX TECHNOLOGIES PRIVATE LIMITED',
    'AMETHEUS HOLDINGS PRIVATE LIMITED',
    'IKCON DIGITAL IT SERVICES PRIVATE LIMITED',
    'NEXTCOWORKS OFFICE SPACE PRIVATE LIMITED',
    'SENSUSSOFT SOFTWARE PRIVATE LIMITED',
    'TRIGUN INFOLABS PRIVATE LIMITED',
    'NATALINAS WEDDINGS (OPC) PRIVATE LIMITED',
    'URINALYTICS HEALTHCARE PRIVATE LIMITED',
    'KASNI FARMERS PRODUCER COMPANY LIMITED',
    'QBOTICA ARTIFICIAL INTELLIGENCE SERVICESPRIVATE LIMITED',
    'VOSSLOH FASTENING SYSTEMS INDIA PRIVATE LIMITED',
    'ARISTA SECURITY SOLUTIONS PRIVATE LIMITED',
    'CLEANAIRASIA INDIA FOUNDATION',
    'BAIRN BOARDINGEDU PRIVATE LIMITED',
    'DR. LAL VENTURES PRIVATE LIMITED',
    'PFIFFNER INSTRUMENT TRANSFORMERS PRIVATELIMITED',
    'SAMOR CULTURE LABS PRIVATE LIMITED',
    'JSONS SOLICITORS PRIVATE LIMITED',
    'NAVI TECHNOLOGIES LIMITED',
    'KARISHYA SOLUTIONS (OPC) PRIVATE LIMITED',
    'GISDICE DATA INTERPRETATION CONSULTANCY ESERVICES PRIVATE LIMITED',
    'AGRIMIN CONTROL INTERNATIONAL PRIVATE LIMITED',
    'MECHATROSYS TECHNOLOGIES PRIVATE LIMITED',
    'KARDI TRADING PRIVATE LIMITED',
    'BADSHAH LOGISTICS (INDIA) PRIVATE LIMITED',
    'ASANDAS AND SONS PRIVATE LIMITED',
    'TECLOGOS AUTOMATION PRIVATE LIMITED',
    'KRAFT HEINZ INDIA PRIVATE LIMITED',
    'BLUECLIF APPARELS INDIA PRIVATE LIMITED',
    'IGNISSTA TECHNOLOGIES PRIVATE LIMITED',
    'BODAL CHEMICALS TRADING PRIVATE LIMITED',
    'WAGAR FORTUNE NIDHI LIMITED',
    'COREFLEX SOLUTIONS PRIVATE LIMITED',
    'PRAYAAN CAPITAL PRIVATE LIMITED',
    'DEEPSYNC TECHNOLOGIES PRIVATE LIMITED',
    'ESPRIM SYSTEMS PRIVATE LIMITED',
    'SWASTHCHAIN PRIVATE LIMITED',
    'RVHFS INFOTECH PRIVATE LIMITED',
    'HERBAKRITI NATURALS PRIVATE LIMITED',
    'SDMD INFOTECH PRIVATE LIMITED',
    'VSTS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HOUSR SERVICES PRIVATE LIMITED',
    'WALLETZ INTERNATIONAL PRIVATE LIMITED',
    'MARS HIGHWAYS PRIVATE LIMITED',
    'ONCONET MEDICAL SERVICES PRIVATE LIMITED',
    'MACHITRON TECHNOLOGIES PRIVATE LIMITED',
    'WATERFOWL MEDIA PRIVATE LIMITED',
    'FOSSILEX CHEMTECH PRIVATE LIMITED',
    'AIC- NOVA FOUNDATION FOR AGRICULTURE INNOVATION AND RESEARCH',
    'MAGICA FACILITY MANAGEMENT SERVICES (I) PRIVATE LIMITED',
    'UNISURAKSHA TRACKING SYSTEMS PRIVATE LIMITED',
    'LENDEN CLUB TECHSERVE PRIVATE LIMITED',
    'ZERP LABS INDIA PRIVATE LIMITED',
    'AUXOCHROMOFOURS SOLUTIONS PRIVATE LIMITED',
    'DREAM VALLEY BEACH RESORTS PRIVATE LIMITED',
    'VISNIC CONSULTANT PRIVATE LIMITED',
    'INTEGRATED SYSTEMS TECHNOLOGIES PRIVATE LIMITED',
    'BHAIRAVA CAPITAL PRIVATE LIMITED',
    'VEDA NEXTGEN ENERGY PRIVATE LIMITED',
    'PSIM INDUSTRIES PRIVATE LIMITED',
    'LOGICS AND CIRCUITS PRIVATE LIMITED',
    'SNOWTEX SYNTHETICS PRIVATE LIMITED',
    'WALSIN ELECTRONICS INDIA PRIVATE LIMITED',
    'WIPRO PERSONAL CARE PRIVATE LIMITED',
    'SES SATELLITES INDIA PRIVATE LIMITED',
    'DIFFRENZ BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MEGALLANIC EDUCATION SERVICES PRIVATE LIMITED',
    'DEPADMHE TECHNOLOGIES PRIVATE LIMITED',
    'NIRAARYA LIFE SCIENCES PRIVATE LIMITED',
    'BENLING INDIA ENERGY AND TECHNOLOGY PRIVATE LIMITED',
    'MOBIUS RESEARCH AND KNOWLEDGE SERVICES INDIA PRIVATE LIMITED',
    'NL7 INDIA PRIVATE LIMITED',
    'TRINITY BIO BAGS PRIVATE LIMITED',
    'GLEMDERMA PHARMACEUTICAL PRIVATE LIMITED',
    'CAPLIN STERILES LIMITED',
    'DAIKI ALUMINIUM INDUSTRY INDIA PRIVATE LIMITED',
    'AKN RENEWABLE ENERGY AND POWER PRIVATE LIMITED',
    'CARMEL POINT INVESTMENTS INDIA PRIVATE LIMITED',
    'DEVKI LAL EDUCATION EMPOWERING FOUNDATION',
    'VYOMINI SOCIAL FOUNDATION',
    'NEEMUCH SOLID WASTE MANAGEMENT PRIVATE LIMITED',
    'EIFERS PROCESS AUTOMATION PRIVATE LIMITED',
    'ADANI ELECTRICITY NAVI MUMBAI LIMITED',
    'EARTHONOMIC ENGINEERS PRIVATE LIMITED',
    'BID MY STAY (INDIA) PRIVATE LIMITED',
    'OSM ENTERTAINMENTS PRIVATE LIMITED',
    'BACHXEN PHARMACEUTICALS PRIVATE LIMITED',
    'AVS UNIVERSAL NETWORK PRIVATE LIMITED',
    'ETHER GAMES PRIVATE LIMITED',
    'CIGATI VENTURES PRIVATE LIMITED',
    'VANFLY PRIVATE LIMITED',
    'ZPE SYSTEMS INDIA PRIVATE LIMITED',
    'HI-LEX DOOR INDIA PRIVATE LIMITED',
    'NASR SEALS PRIVATE LIMITED',
    'CELLA WAREHOUSING PRIVATE LIMITED',
    'KRABWHEEL TECHNOLOGIES PRIVATE LIMITED',
    'DR. MACH INDIA PRIVATE LIMITED',
    'RETRIEVE EXIM PRIVATE LIMITED',
    'UNIPOWER ENERGY SYSTEMS PRIVATE LIMITED',
    'YANTRAKSH LOGISTICS PRIVATE LIMITED',
    'SINTRA PROPERTIES PRIVATE LIMITED',
    'HIMALAYAN ROPEWAY PRIVATE LIMITED',
    'GMG INFRATECH PRIVATE LIMITED',
    'BAPA HOUSE PREMISES PRIVATE LIMITED',
    'ADPIX TECHNOLOGIES PRIVATE LIMITED',
    'DNGK IT CONSULTANCY SERVICES (OPC) PRIVATE LIMITED',
    'YENDLURU EDUCATIONAL SERVICES PRIVATE LIMITED',
    'MAHESHWAR LAXMI MEMORIAL FOUNDATION',
    'HYFUN AGRILINK PRIVATE LIMITED',
    'GEOTACT PRIVATE LIMITED',
    'TROPICALES HEALTHFOODS PRIVATE LIMITED',
    'GLOBAL SYSRESS PRIVATE LIMITED',
    'SIIMECO HIGHRISE SERVICES PRIVATE LIMITED',
    'NUNTIARE PROMOTIONS PRIVATE LIMITED',
    'AELIUS SOFTECH PRIVATE LIMITED',
    'SUMEL RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'HEMAL INFOTRONICS PRIVATE LIMITED',
    'EZYSPIT SOLUTIONS PRIVATE LIMITED',
    'ZEENTRIP GLOBAL TOURISM PRIVATE LIMITED',
    'BALI FINLEASE PRIVATE LIMITED',
    'HK KRISHI MART PRIVATE LIMITED',
    'LEI AFFILIATED PRIVATE LIMITED',
    'CMR SURGICAL INDIA PRIVATE LIMITED',
    'NEGEN POLYSOLUTIONS PRIVATE LIMITED',
    'BADERIA HEALTHCARE PRIVATE LIMITED',
    'BADERIA INFRA PRIVATE LIMITED',
    'KALE BRAYAN MANUFACTURING INDIA PRIVATE LIMITED',
    'SUN MOBILITY EV INFRA PRIVATE LIMITED',
    'VIVADHI FILMS PRIVATE LIMITED',
    'HEUNGKUK INDIA PRIVATE LIMITED',
    'GOH ESTATE PRIVATE LIMITED',
    'KAYAKALP CARS PRIVATE LIMITED',
    'ALANKAARA DESIGNS PRIVATE LIMITED',
    'ENTRAMAN INTERNATIONAL PRIVATE LIMITED',
    'RIGS SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'KYROSPARK PHARMA PRIVATE LIMITED',
    'BM INFOSOLUTIONS (OPC) PRIVATE LIMITED',
    'HORNET ELECTRIC AND PLUMBING PRODUCTS PRIVATE LIMITED',
    'THYSUN TECHNOLOGIES PRIVATE LIMITED',
    'SRI ADHVITHI BUILDERS AND INTERIORS PRIVATE LIMITED',
    'VIRTUAL SENSE GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'MALPANI VENTURE PRIVATE LIMITED',
    'N19 FOODS AGRO PRIVATE LIMITED',
    'BAYFIELD FOOD INGREDIENTS PRIVATE LIMITED',
    'IKTK DESIGN PRIVATE LIMITED',
    'ZICURO TECHNOLOGIES PRIVATE LIMITED',
    'PEDELEC BIKES PRIVATE LIMITED',
    'VISHUS PRODUCTIONS PRIVATE LIMITED',
    'YSD INFRACITY PRIVATE LIMITED',
    'JSP ENVIRO PRIVATE LIMITED',
    'UNILABEL ID SERVICE INDIA PRIVATE LIMITED',
    'SOFIMA FILTERS INDIA PRIVATE LIMITED',
    'SENDECOM SOLUTIONS PRIVATE LIMITED',
    'BMU TOUR AND TRAVEL SERVICES PRIVATE LIMITED',
    'ASSOCIATION OF REGISTERED INVESTMENT ADVISERS',
    'PRIWEST GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SIRI 1 TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ZENON ANALYTICS PRIVATE LIMITED',
    'ENETRIC TECHNOLOGY SOLUTION PRIVATE LIMITED',
    'AMETECS INDIA PRIVATE LIMITED',
    'KESAR EXTRUSIONS PRIVATE LIMITED',
    'SILVERDENE EXPORTS PRIVATE LIMITED',
    'NAVICURE SOLUTIONS PRIVATE LIMITED',
    'STAR BOVINE FARM MANAGEMENT PRIVATE LIMITED',
    'PICU AGRI PRIVATE LIMITED',
    'CAREWARE IT SOLUTIONS PRIVATE LIMITED',
    'BRAND NETWORKS APAC SOLUTIONS PRIVATE LIMITED',
    'TECHOOKKU SERVICES LIMITED',
    'OPTIFY INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'NEXTGEN SEALS PRIVATE LIMITED',
    'RETAILWHIZZ SOLUTIONS PRIVATE LIMITED',
    'KRAFT SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'BAJRANG FYNAMICS PRIVATE LIMITED',
    'SABIR ENGINEERS PRIVATE LIMITED',
    'DCHICA FASHION LIFESTYLE PRIVATE LIMITED',
    'EMURGO LEARNING SOLUTIONS PRIVATE LIMITED',
    'OPSCRUISE TECHNOLOGIES PRIVATE LIMITED',
    'PUREWAY E-SOLUTIONS PRIVATE LIMITED',
    'TASKUS INDIA PRIVATE LIMITED',
    'DEVERP SOLUTIONS PRIVATE LIMITED',
    'REMITTMED HEALTHCARE PRIVATE LIMITED',
    'RHAPSODY APPAREL PRIVATE LIMITED',
    'KESHAV SMART WEALTH PRIVATE LIMITED',
    'MOHANKUMAR CONSTRUCTIONS PRIVATE LIMITED',
    'VS ACCOUNTO PRIVATE LIMITED',
    'CHIPSTOP ELECTRONICS SERVICE PRIVATE LIMITED',
    'SSMT PHARMACEUTICALS PRIVATE LIMITED',
    'BOBS SHRIMP SHACK PRIVATE LIMITED',
    'MMG CREDIT MARKETING SERVICES PRIVATE LIMITED',
    'QUICKLYMARRY MATRIMONIAL PRIVATE LIMITED',
    'UTIZ GLOBAL VENTURES PRIVATE LIMITED',
    'KYNDLEIT CONSULTING PRIVATE LIMITED',
    'FERRYMILL FINANCIAL TECHNOLOGY PRIVATE LIMITED',
    'JANVEDA FORMULATION PRIVATE LIMITED',
    'VILLENIAL VENTURES PRIVATE LIMITED',
    'DIRASA PRIVATE LIMITED',
    'PIXTECH LABS PRIVATE LIMITED',
    'MYRA FOILS PRIVATE LIMITED',
    'MINDBRINK MEDIA PULSE PRIVATE LIMITED',
    'ULLU DIGITAL LIMITED',
    '5QMEDIA INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'RSB ARCH PROJECT CONSULTANTS PRIVATE LIMITED',
    'CNCA CONSULTING PRIVATE LIMITED',
    'ELMECH AUTOMATIONS PRIVATE LIMITED',
    'KRR HEALTHCARE PRIVATE LIMITED',
    'AGNI PROBAL SERVICE PRIVATE LIMITED',
    'CEDRO SYSTEMS PRIVATE LIMITED',
    'SALENA IT INFRA SERVICES PRIVATE LIMITED',
    'GH DIGITAL MEDIA PRIVATE LIMITED',
    'ASCENDRON TECHNOLOGIES PRIVATE LIMITED',
    'NIROHI SUPPLIERS PRIVATE LIMITED',
    'SECONDOPINE SOLUTIONS PRIVATE LIMITED',
    'SHAKTI SIGNS & LABELS PRIVATE LIMITED',
    'ASNL INDIA PRIVATE LIMITED',
    'ADINTECHA PRIVATE LIMITED',
    'OO7 TRADE INTERNATIONAL PRIVATE LIMITED',
    'DECOMET INDUSTRIES PRIVATE LIMITED',
    'INFOPLUS MDM PRIVATE LIMITED',
    'BALINEE MILK PRODUCER COMPANY LIMITED',
    'SAFENEST TECHNOLOGIES PRIVATE LIMITED',
    'OBEROI PEST CONTROL PRIVATE LIMITED',
    'XPO SOLUTIONS WORLDWIDE PRIVATE LIMITED',
    'APAV INDUSTRIES PRIVATE LIMITED',
    'RHOME KONSTRUKT PRIVATE LIMITED',
    'YUVRAJ HOUSING PRIVATE LIMITED',
    'CONTAQUE CLOUD PRIVATE LIMITED',
    'DLS LOGISTICS PRIVATE LIMITED',
    'NEOPONICS PROJECTS INDIA PRIVATE LIMITED',
    'AOA CONSULTANTS PRIVATE LIMITED',
    'BRICLAY TECHNOLOGIES PRIVATE LIMITED',
    'SHAMBHALA SAMATHVAM PRIVATE LIMITED',
    'PROVISO INFRASTRUCTURES PRIVATE LIMITED',
    'CHNO MEDIA PRIVATE LIMITED',
    'IMAGINATIVE MINDS TRADERS PRIVATE LIMITED',
    'BADA BUSINESS PRIVATE LIMITED',
    'SEASHELL INTEGRATED SERVICES PRIVATE LIMITED',
    'JPW ENGINEERING SERVICES PRIVATE LIMITED',
    'UNFOLDING SKIES PRIVATE LIMITED',
    'ACSA FREIGHT LINES PRIVATE LIMITED',
    'RHCGLOBAL EXPORTS PRIVATE LIMITED',
    'SUBSCRIBEIT SOLUTIONS PRIVATE LIMITED',
    'INNOVEE CONSULTING PRIVATE LIMITED',
    'SAPTAGIR LIFE SCIENCES PRIVATE LIMITED',
    'MPL BUILDCON PRIVATE LIMITED',
    'PENTANAMI TECHNOLOGIES PRIVATE LIMITED',
    'SCRUM DIGITAL PRIVATE LIMITED',
    'RAJDOOT SPECIALITIES PRIVATE LIMITED',
    'SHIVORA APPARELS PRIVATE LIMITED',
    'KLIZO SOLUTIONS PRIVATE LIMITED',
    'RST BOOKING PRIVATE LIMITED',
    'REASON COSMETICS PRIVATE LIMITED',
    'MAHAARNAVA SHIPPING PRIVATE LIMITED',
    'GOC SERVICES INDIA PRIVATE LIMITED',
    'OSF COMMERCE INDIA PRIVATE LIMITED',
    'JIZHI MECHATRONIC INDIA PRIVATE LIMITED',
    'DVIATION SOLUTIONS INDIA PRIVATE LIMITED',
    'VPJ ENTERTAINMENT PRIVATE LIMITED',
    'DD HOMES PRIVATE LIMITED',
    'FAIRDINKUM BUSINESS SERVICES PRIVATE LIMITED',
    'MEADOW EDUCATION PRIVATE LIMITED',
    'PROFUNDA CONSULTING PRIVATE LIMITED',
    'OPTIMO TALENT MANAGEMENT PRIVATE LIMITED',
    'PRISTOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'GREENBOOK VERVE PRIVATE LIMITED',
    'GOLDMAN SACHS (INDIA) ALTERNATIVE INVESTMENT MANAGEMENT PRIVATE LIMITED',
    'ANBA ARTS PRIVATE LIMITED',
    'ACCERNAI SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'ILOUGE MEDIA PRIVATE LIMITED',
    'CREDEX TECHNOLOGY PRIVATE LIMITED',
    'ACCENTERRA PRIVATE LIMITED',
    'EASYPROSOL SERVICES PRIVATE LIMITED',
    'DEVDELA GLOBAL SERVICES PRIVATE LIMITED',
    'ROXYCARE PRIVATE LIMITED',
    'UNIQUE HYDRA (INDIA) PRIVATE LIMITED',
    'MAKSONS GLOBAL MOVEMENTS PRIVATE LIMITED',
    'DHANBAD INTEGRATED MSW LIMITED',
    'VEMBA MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'YOCNEX CHEMICALS PRIVATE LIMITED',
    'SAHAL WEBADS PRIVATE LIMITED',
    'CRUNK INFRASTRUCTURE LIMITED',
    'PEGASUS CREST INTERNATIONAL PRIVATE LIMITED',
    'METEOXPERTS SOLUTIONS PRIVATE LIMITED',
    'OPENCYON TECHNOLOGIES PRIVATE LIMITED',
    'FUSAQ TECHNOLOGIES PRIVATE LIMITED',
    'GVBS TECH PARKS PRIVATE LIMITED',
    'APPLE FITNESS SOLUTION PRIVATE LIMITED',
    'RAGHAVA BIO-MEDICALS PRIVATE LIMITED',
    'REDGREENS TECHNOLOGIES PRIVATE LIMITED',
    'SHETISEVA TECHNO SERVICE PRIVATE LIMITED',
    'TCA TECHNOLOGIES PRIVATE LIMITED',
    'B2B DESIGNERS PRIVATE LIMITED',
    'SVASA FASHION & LUXURY PRIVATE LIMITED',
    'JSP MOTORRAD HYD PRIVATE LIMITED',
    'NM INGENIOUS MANAGEMENT SERVICES PRIVATELIMITED',
    'PATTAMMAL FOODS PRIVATE LIMITED',
    'INDUSIQ SOLUTIONS PRIVATE LIMITED',
    'VESTANAM SOLUTIONS PRIVATE LIMITED',
    'SAMYAK COMPUTER PRIVATE LIMITED',
    'LI ENERGY PRIVATE LIMITED',
    'SOFTRADIX TECHNOLOGIES PRIVATE LIMITED',
    'KENA PLASTO PRIVATE LIMITED',
    'MUTHOOT TRUSTEE PRIVATE LIMITED',
    'GSE RENEWABLES INDIA PRIVATE LIMITED',
    'VEDAANTA SENIOR LIVING PRIVATE LIMITED',
    'HUBENGAGE INDIA PRIVATE LIMITED',
    'AQUITAINE INGENIERIE INDUSTRIELLE INDE PRIVATE LIMITED',
    'DETOX TECHNOLOGIES PRIVATE LIMITED',
    'APEX AIR FILTERS PRIVATE LIMITED',
    'INTERNEURON PRIVATE LIMITED',
    'AXELIA SOLUTIONS PRIVATE LIMITED',
    'INFINITYLOOP SYSTEMS PRIVATE LIMITED',
    'HETI TECHNOSOFT PRIVATE LIMITED',
    'TECHVISTAR IT SOLUTIONS PRIVATE LIMITED',
    'TEKCENTRIC SOFTWARE PRIVATE LIMITED',
    'STAVTAR SOLUTIONS INDIA PRIVATE LIMITED',
    'RSD MEDLEX PHARMACEUTICALS PRIVATE LIMITED',
    'HCX GLOBAL PRIVATE LIMITED',
    'SCANDICSOFT PRIVATE LIMITED',
    'RURASH FINANCIALS PRIVATE LIMITED',
    'SCLOWY (EMP) PRIVATE LIMITED',
    'NXTREE TECHNOLOGIES PRIVATE LIMITED',
    'FAIRWAY TECHNOLOGIES PRIVATE LIMITED',
    'COASTGLOBAL SYSTEMS PRIVATE LIMITED',
    'HIMALAYAN MOTORS PRIVATE LIMITED',
    'SIBROS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'FINEZZA INFORMATION TECHNOLOGIES PRIVATELIMITED',
    'FANGAGE LABS PRIVATE LIMITED',
    'K-SOURCE FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'PIXFRA PRODUCTIONS PRIVATE LIMITED',
    'ADVOLT MEDIA PRIVATE LIMITED',
    'DELIGENT IMPEX PRIVATE LIMITED',
    'MYTRAH VAYU (SWARNAMUKHI) PRIVATE LIMITED',
    'SEJ FURNISHINGS PRIVATE LIMITED',
    'PK BUILDINFRA PRIVATE LIMITED',
    'ANSHIKA RESTATE PRIVATE LIMITED',
    'APFT AVIATION PRIVATE LIMITED',
    'CONCRETE SHOP INDIA PRIVATE LIMITED',
    'E-CHARGEUP SOLUTIONS PRIVATE LIMITED',
    'VAHANA MOBILITY SOLUTIONS PRIVATE LIMITED',
    'PREPBYTES TECHNOLOGIES PRIVATE LIMITED',
    'JWH GLOBAL PRIVATE LIMITED',
    'AGASTIH ANALYTICS PRIVATE LIMITED',
    'BALLER ATHLETIK PRIVATE LIMITED',
    'CINESHINE FILMS PRIVATE LIMITED',
    'INNOBOON TECHNOLOGIES PRIVATE LIMITED',
    'AITESS NETWORKS PRIVATE LIMITED',
    'STONETRADING EXPORT PRIVATE LIMITED',
    'TECH-LONG PACKAGING MACHINERY INDIA PRIVATE LIMITED',
    'MERINO CONSULTING SERVICES LIMITED',
    'ZEROGRAVITY AERO SYSTEMS PRIVATE LIMITED',
    'TRUE AGROROOTS PRIVATE LIMITED',
    'CERBERUS CAPITAL SERVICES PRIVATE LIMITED',
    'MEGA-CANTATA COMPUTER SOLUTIONS PRIVATE LIMITED',
    'TWISTING SCOOPS PRIVATE LIMITED',
    'RED PETAL BEVERAGES PRIVATE LIMITED',
    'PCSINFINITY PRIVATE LIMITED',
    'ZENKEM KINETICS PRIVATE LIMITED',
    'INDIUM SOLDER PRIVATE LIMITED',
    'NELLAI BUSINESS CORPORATION LIMITED',
    'KAWMAN PHARMA PRIVATE LIMITED',
    'SRI VAYUPUTHRA INDUSTRIES PRIVATE LIMITED',
    'TRU DWELLINGS PRIVATE LIMITED',
    'STK HOLIDAYS PRIVATE LIMITED',
    'RDES ENGINEERING PRIVATE LIMITED',
    'RFC EQUIPMENT RENTALS PRIVATE LIMITED',
    'MSV OIL AND GAS CONSULTANTS PRIVATE LIMITED',
    'NEOMATICS ENGINEERING MACHINES PRIVATE LIMITED',
    'QUINTICS MANAGEMENT CONSULTANCIES PRIVATE LIMITED',
    'STRANDREBAR & ENGINEERING PRIVATE LIMITED',
    'GETPROS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SUUMAYA INDUSTRIES LIMITED',
    'MIREYA SYSTEMS PRIVATE LIMITED',
    'FABEL SERVICES PRIVATE LIMITED',
    'KRIHAAN TEXCHEM PRIVATE LIMITED',
    'GIBF ASSOCIATES PRIVATE LIMITED',
    'DHANIRAM TECHNOLOGY INDIA PRIVATE LIMITED',
    'BLACK LOTUS TECHNOLOGIES PRIVATE LIMITED',
    'HYQOO SOLUTIONS PRIVATE LIMITED',
    'DHRITI RAINA AGRO PRODUCTS PRIVATE LIMITED',
    'MEGTRI ADHESIVES PRIVATE LIMITED',
    'AABASOFT GLOBAL SERVICES PRIVATE LIMITED',
    'NOVA ROYALE COLLECTION PRIVATE LIMITED',
    'SIRA AGRO INDUSTRIES PRIVATE LIMITED',
    'STATCOMP TECHNOLOGY PRIVATE LIMITED',
    'INFINIOT SOLUTIONS PRIVATE LIMITED',
    'OIVI TECH PRIVATE LIMITED',
    'VIYASH LIFE SCIENCES PRIVATE LIMITED',
    'EMPOHUB E-STORE PRIVATE LIMITED',
    'FAIRCARE EXHIBITIONS PRIVATE LIMITED',
    'AJANTHA SILK MILLS PRIVATE LIMITED',
    'PROSCHOOL SKILL DEVELOPMENT PRIVATE LIMITED',
    'SOCIALHOOP INDIA PRIVATE LIMITED',
    'SONAFINE CORPORATION PRIVATE LIMITED',
    'DELPHIX SOFTWARE PRIVATE LIMITED',
    'SAMAARU FINANCE PRIVATE LIMITED',
    'QUE PROCESSING SERVICES PRIVATE LIMITED',
    'NOVA GLOBAL SECURITY SOLUTIONS PRIVATE LIMITED',
    'EU EVENTS PRIVATE LIMITED',
    'ALACER SYSTEMS AND TECHNOLOGY PRIVATE LIMITED',
    'FARMHIVE PRIVATE LIMITED',
    'HUMAIN HEALTHTECH PRIVATE LIMITED',
    'BRILLTECH E MOTORS PRIVATE LIMITED',
    'MIDESK SERVICES PRIVATE LIMITED',
    'SATHAVAHANA INSTITUTE OF ONCOLOGY PRIVATE LIMITED',
    'SCIPL INTELLIGENT TRANSPORTATION SYSTEM PRIVATE LIMITED',
    'BERGENIA RELOCATIONS PRIVATE LIMITED',
    'KSHATRAINFOTECH PRIVATE LIMITED',
    'ZAXENIC RESEARCH (OPC) PRIVATE LIMITED',
    'EUREKA AI INDIA PRIVATE LIMITED',
    'VIGA ENTERTAINMENT TECHNOLOGY PRIVATE LIMITED',
    'VAYAM FORUM FOR CITIZENSHIP',
    'NOVA GLOBAL BEVERAGES PRIVATE LIMITED',
    'RESOTEL HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'SCAN IT OVERSEAS PRIVATE LIMITED',
    'ARCOT MEDIA PRIVATE LIMITED',
    'SKYLIGHT EXPRESS PRIVATE LIMITED',
    'ANLYZ CYBERSECURE PRIVATE LIMITED',
    'SPHH PEACEFUL ESCAPE PRIVATE LIMITED',
    'RRMEL INDIA PRIVATE LIMITED',
    'ACHIEVEX SOLUTIONS PRIVATE LIMITED',
    'CEF PLAZA BAWAL PRIVATE LIMITED',
    'ATHARVANI GLOBAL FOUNDATION',
    'DUROGREEN WASTE MANAGEMENT PRIVATE LIMITED',
    'WOCKHARDT MEDICINES LIMITED',
    'JKS PRECISION ENGINEERING PRIVATE LIMITED',
    'GLEAN CYBERSOFT PRIVATE LIMITED',
    'SAVANNA ZOO CREATIONS INDIA PRIVATE LIMITED',
    'LIGHTSTORM DATA CENTERS PRIVATE LIMITED',
    'KINGSOFT OFFICE SOFTWARE INDIA PRIVATE LIMITED',
    'LOCOFAST ONLINE SERVICES PRIVATE LIMITED',
    'ROJUCO PRECISION ACCESSORIES INDIA PRIVATE LIMITED',
    'SCREL INFO PRIVATE LIMITED',
    'FYSIS CHEMTECH PRIVATE LIMITED',
    'ENDOENERGY SYSTEMS PRIVATE LIMITED',
    'LACOLAM INDIA PRIVATE LIMITED',
    'K2V2 TECHNOLOGIES PRIVATE LIMITED',
    'SIERA IT SERVICES PRIVATE LIMITED',
    'VIRTUOUS SCREENING PRIVATE LIMITED',
    'EXHAUST TECHNOLOGY PRIVATE LIMITED',
    'BONDEVALUE SOFTWARE LABS PRIVATE LIMITED',
    'ORGANIC MANDYA DESI FARMS PRIVATE LIMITED',
    'SECUREZAPP INDIA PRIVATE LIMITED',
    'KHVATEC INDIA PRIVATE LIMITED',
    'SOUTHERN SALVAGE PRIVATE LIMITED',
    'ALBORZ DEVELOPERS LIMITED',
    'ALKIN GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'HISENSE INDIA PRIVATE LIMITED',
    'CHOYZ GLOBAL INDIA PRIVATE LIMITED',
    'KARVAM INFOTECH PRIVATE LIMITED',
    'AFN SUPPLY CHAIN INDIA PRIVATE LIMITED',
    'APPZEN LABS INDIA PRIVATE LIMITED',
    'YOKEIN SOLUTIONS PRIVATE LIMITED',
    'DIGICOLLECTIVE FOR EMPOWERMENT FORUM',
    'THINK EBIKEGO PRIVATE LIMITED',
    'JPIN CAPVENTURES PRIVATE LIMITED',
    'CULKEY FOUNDATION',
    'SHERATOVE REAL ESTATES PRIVATE LIMITED',
    'PLUGXR REALITY PRIVATE LIMITED',
    'APLI AILAB PRIVATE LIMITED',
    'JET2 TRAVEL TECHNOLOGIES PRIVATE LIMITED',
    'BRAAVOS REALTY PRIVATE LIMITED',
    'MALPANI PRODUCTS PRIVATE LIMITED',
    'TVV ELECTRIC FLEET TECHNOLOGIES PRIVATE LIMITED',
    'PUMA ENERGY INDIA PRIVATE LIMITED',
    'PROPSHARE COMMERCIAL PARKS PRIVATE LIMITED',
    'CS FINE INTERCHEM PRIVATE LIMITED',
    'CINEMEDIA NETWORK PRIVATE LIMITED',
    'JOHNU-EL TECHNOLOGIES PRIVATE LIMITED',
    'XING MAX PRIVATE LIMITED',
    'DUST VALUE PRIVATE LIMITED',
    'OCEM AIRFIELD INDIA PRIVATE LIMITED',
    'RUNNET BROADBAND SERVICES PRIVATE LIMITED',
    'WRSS XXI (A) TRANSCO LIMITED',
    'GAONKAR TECHNOLOGY (OPC) PRIVATE LIMITED',
    'GR DWARKA DEVARIYA HIGHWAY PRIVATE LIMITED',
    'EUSTON INSURANCE ADVISORS PRIVATE LIMITED',
    'MAMI SOCIAL FOUNDATION',
    'AIC ENTERPRISES PRIVATE LIMITED',
    'PREVISE CONSTRUCTION AND ENGINEERING PRIVATE LIMITED',
    'HUMANWIT CONSULTING PRIVATE LIMITED',
    'CIMCORP INDUSTRIAL AUTOMATION INDIA PRIVATE LIMITED',
    'FOUR FOUND TRADE PRIVATE LIMITED',
    'ARVI HITECH PRIVATE LIMITED',
    'ARYAAVART LIFESTYLES PRIVATE LIMITED',
    'GEM ELECTRICAL TECHNOLOGIES PRIVATE LIMITED',
    'ICAPO TECH PRIVATE LIMITED',
    'KUSHBHARGAVA MGMT AND HR CONSULTING PRIVATE LIMITED',
    'S3CLOUD IT CONSULTANCY PRIVATE LIMITED',
    'UNIFLY SUPPORT PRIVATE LIMITED',
    'FFM INSIGHTS PRIVATE LIMITED',
    'UPSCALER SALESTECH PRIVATE LIMITED',
    'WNJ TECHNOLOGY PRIVATE LIMITED',
    'JHUNSONS POLYMERS PRIVATE LIMITED',
    'COTRUCKING LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'FSP DESIGN PRIVATE LIMITED',
    'ICONICA HOTELS AND CONVENTION CENTRE PRIVATE LIMITED',
    'RED TORTOISE DIGITAL MEDIA PRIVATE LIMITED',
    'SAMA NEXTGEN INDIA PRIVATE LIMITED',
    'TRIDUS INTERIORS PRIVATE LIMITED',
    'AIRBLACK TECHNOLOGIES PRIVATE LIMITED',
    'INTERCARE TECH PRIVATE LIMITED',
    'NGENUX SOLUTIONS PRIVATE LIMITED',
    'FOOD ONE AGRO PRODUCTS PRIVATE LIMITED',
    'MAUVEON INTERNATIONAL PRIVATE LIMITED',
    'ARMOURCOAT PRIVATE LIMITED',
    '3DI TECHNOLOGIES PRIVATE LIMITED',
    'MAYSQUARE LIFESTYLE PRIVATE LIMITED',
    'ADR E-SARVATRA PRIVATE LIMITED',
    'FAIRCHEM ORGANICS LIMITED',
    'GREATIVE SOLUTIONS PRIVATE LIMITED',
    'GAINCAFE TECHNOLOGIES PRIVATE LIMITED',
    'CHIRAG MEDICARE SOLUTIONS PRIVATE LIMITED',
    'UTTERLY ALLIED (INDIA) PRIVATE LIMITED',
    'ALMOGI PRIVATE LIMITED',
    'EVIOX ELECTRO PRIVATE LIMITED',
    'WEBOSYS SOFTWARE PRIVATE LIMITED',
    'EGYSTAR AGROTECH PRIVATE LIMITED',
    'FORSAN FOODS & CONSUMER PRODUCTS INDIA PRIVATE LIMITED',
    'FAMORE SOLUTIONS PRIVATE LIMITED',
    'MUNDKUR HEALTHCARE PRIVATE LIMITED',
    'TJANDA GLOBAL ONLINE PRIVATE LIMITED',
    'GLASMAC PRIVATE LIMITED',
    'SEATRACK INTERNATIONAL TRADEX PRIVATE LIMITED',
    'SRI PAAMBAN INTERIORS PRIVATE LIMITED',
    'KHY ELECTRONIC INDIA PRIVATE LIMITED',
    'UKTENTACLE SOLUTIONS PRIVATE LIMITED',
    'AGRIHAWK TECHNOLOGIES PRIVATE LIMITED',
    'CSY HATCHERY PRIVATE LIMITED',
    'SEAHAWK WEB SERVICES PRIVATE LIMITED',
    'PAVNA MARKETING PRIVATE LIMITED',
    'DBRE INDIA PRIVATE LIMITED',
    'STODICT TECHNOLOGIES PRIVATE LIMITED',
    'PASKON (INDIA) PRIVATE LIMITED',
    'EXIM ROUTES PRIVATE LIMITED',
    'NEXPARK SOLUTIONS PRIVATE LIMITED',
    'OSHITSU HAZ TECHNOLOGIES PRIVATE LIMITED',
    'ANAR APP PRIVATE LIMITED',
    'MERNOT INDIA PRIVATE LIMITED',
    'SSMF LEATHER TREND PRIVATE LIMITED',
    'ICCIN CLEANING CHEMICAL PRIVATE LIMITED',
    'MIYAMA ELECTRIC INDIA PRIVATE LIMITED',
    'PARKLAND EXPORTS PRIVATE LIMITED',
    'PREDERA TECHNOLOGIES PRIVATE LIMITED',
    'EVERY VOICE MATTERS PRIVATE LIMITED',
    'INMODE INDIA PRIVATE LIMITED',
    'SESOTA WARRANTYGUD PRIVATE LIMITED',
    'SKOEGLE FOOTWEAR PRIVATE LIMITED',
    'RCA TECHMART PRIVATE LIMITED',
    'AURI DECOR PRIVATE LIMITED',
    'MTK TECHNOLOGIES PRIVATE LIMITED',
    'OCTORITE TECHNOLOGIES PRIVATE LIMITED',
    'ZONO TRADETECH PRIVATE LIMITED',
    'ACTYV.AI PLATFORMS INDIA PRIVATE LIMITED',
    'ZINGBUS TECHNOLOGY PRIVATE LIMITED',
    'FRUTIGER INDIA PRIVATE LIMITED',
    'JLV ENERGY PRIVATE LIMITED',
    'ARANGAN AGRO EXIM PRIVATE LIMITED',
    'RISKSPOTLIGHT COE PRIVATE LIMITED',
    'GMETRI TECHNOLOGIES PRIVATE LIMITED',
    'NCS AUTOCARS PRIVATE LIMITED',
    'HILLSPEAK INTERNET PRIVATE LIMITED',
    'KOUZINA FOOD TECH PRIVATE LIMITED',
    'EPNOSYS TECHNOLOGIES PRIVATE LIMITED',
    'FORTITUDE NICSA GLOBAL PRIVATE LIMITED',
    'RASHE LIFESCIENCES PRIVATE LIMITED',
    'TRIMURTI WALL CARE PRODUCTS PRIVATE LIMITED',
    'NVISION PRODUCTS PRIVATE LIMITED',
    'PRITHVI SCIENCE AND TECHNOLOGIES PRIVATELIMITED',
    'SKURREL EWENTURE PRIVATE LIMITED',
    'HILIGHT LOGISTICS INDIA PRIVATE LIMITED',
    'DHVANI INSPECTION TECHNOLOGIES PRIVATE LIMITED',
    'RMK SANDS PRIVATE LIMITED',
    'NOETIC STEP INDIA PRIVATE LIMITED',
    'THINKCUBE INNOVATIONS PRIVATE LIMITED',
    'ZAPI INDIA PRIVATE LIMITED',
    'PYROGENIC ENGINEERINGS (I) PRIVATE LIMITED',
    'CHARISMATIC ELECTRICALS PRIVATE LIMITED',
    'HIGH PERFORMANCE PLASTICS INDIA PRIVATE LIMITED',
    'WATERLABS AI TECHNOLOGIES PRIVATE LIMITED',
    'AAVISHKAAR INVESTMENT ADVISERS (IFSC) PRIVATE LIMITED',
    'WYBE SPACES PRIVATE LIMITED',
    'TRADIART ACADEMY PRIVATE LIMITED',
    'SANCARA SHAMPAD PRIVATE LIMITED',
    'BLUEWHIRL TECHNOLOGIES PRIVATE LIMITED',
    'COIR - ON FOAM PRODUCTS PRIVATE LIMITED',
    'EASTCORP POLYMERS PRIVATE LIMITED',
    'LYNKIT SOLUTIONS PRIVATE LIMITED',
    'FLEXLI TECHNOLOGIES PRIVATE LIMITED',
    'INNOMET ADVANCED MATERIALS LIMITED',
    'DIGITALROOAR PRIVATE LIMITED',
    'SUPERV TECHNOLOGIES PRIVATE LIMITED',
    'PRASIDDHI SOLAR PRIVATE LIMITED',
    'CONTLUXI INTERNATIONAL PRIVATE LIMITED',
    'HIVE CARBON-ZERO DEVELOPERS PRIVATE LIMITED',
    'TECHEDGE SPE INDIA PRIVATE LIMITED',
    'INDO U K HEALTHCARE INNOVATIONS PRIVATE LIMITED',
    'STEP AHEAD LOGISTICS PRIVATE LIMITED',
    'AALINO INDIA PRIVATE LIMITED',
    'NEXTROVE IT SOLUTIONS PRIVATE LIMITED',
    'KTI SOLUTECH PRIVATE LIMITED',
    'JUC ECYCLERS PRIVATE LIMITED',
    'GLOBAL SEAMLESS TUBES & PIPES PRIVATE LIMITED',
    'PRAJVALIT PERFORMANCE INDIA PRIVATE LIMITED',
    'LOG2BASE2 EDUTECH MEDIA PRIVATE LIMITED',
    'INDEPENDENT PURCHASING (IPC) PRIVATE LIMITED',
    'DRN INFRASTRUCTURE PRIVATE LIMITED',
    'IYKON FIDELITY SOLUTIONS INDIA PRIVATE LIMITED',
    'INSTATENDERS SOLUTIONS PRIVATE LIMITED',
    'TASKFLOW ANSWER PRIVATE LIMITED',
    'PATEL JEWELLERS INDIA PRIVATE LIMITED',
    'KLOK SYSTEMS INDIA PRIVATE LIMITED',
    'CODEBIOS TECHNOLOGIES PRIVATE LIMITED',
    'FOXNINE ENERGY PRIVATE LIMITED',
    'MIRAH BELLE NATURALS & APOTHECARY PRIVATE LIMITED',
    'TIINLAB ACOUSTIC TECHNOLOGY INDIA PRIVATE LIMITED',
    'SRP DIGITAL SERVICES PRIVATE LIMITED',
    'ENKINLAB INDIA PRIVATE LIMITED',
    'TAGHIVE INDIA PRIVATE LIMITED',
    'DIGIBLING INFOTECH PRIVATE LIMITED',
    'WISE VISION ACADEMY PRIVATE LIMITED',
    'JSC IA VOZROZHDENIE INDIA PRIVATE LIMITED',
    'DIJLA SHIPPING PRIVATE LIMITED',
    'FOODIEVERSE INDIA PRIVATE LIMITED',
    'EXPERTTAG ECOMMERCE PRIVATE LIMITED',
    'OFYPETS INDIA PRIVATE LIMITED',
    'TOSCO PHARMACHEM PRIVATE LIMITED',
    'AUGUST ASSORTMENTS PRIVATE LIMITED',
    'FITSHIT HEALTH SOLUTIONS PRIVATE LIMITED',
    'PRODIGAL SOFTTECH INDIA PRIVATE LIMITED',
    'CHALSIMPLIFY PRIVATE LIMITED',
    'GL-TURBO INDIA PRIVATE LIMITED',
    'IOLITIX SOLUTIONS PRIVATE LIMITED',
    'SAR TELEVENTURE LIMITED',
    'JW AUTOMAKEUP PRIVATE LIMITED',
    'OATAIK TECHNOLOGIES PRIVATE LIMITED',
    'DATAINC GLOBAL TECH SOLUTIONS PRIVATE LIMITED',
    'HUMBL APPAREL PRIVATE LIMITED',
    'GRP HOTELS INDIA PRIVATE LIMITED',
    'VAP PRECISION PRIVATE LIMITED',
    '4MATION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'IB VOGT SOLAR FOUR PRIVATE LIMITED',
    'CONQRITY SERVICES PRIVATE LIMITED',
    'ASCENT WELLNESS AND PHARMA SOLUTIONS PRIVATE LIMITED',
    'WHITEAPRON HEALTH STATION PRIVATE LIMITED',
    'RELEX HEALTHCARE SERVICES INDIA PRIVATE LIMITED',
    'PIKTOR INNOVATION LABS INDIA PRIVATE LIMITED',
    'STRATXG CONSULTING PRIVATE LIMITED',
    'COLLABRAINS DEVOPS PRIVATE LIMITED',
    'FLOWTRIK TECHNOLOGIES PRIVATE LIMITED',
    'SHOSPRATT ASSOCIATES PRIVATE LIMITED',
    'LEVITEK PLM SOLUTIONS PRIVATE LIMITED',
    'BEATS JOBS PRIVATE LIMITED',
    'GMR HERITAGE MANAGEMENT',
    'ACCULEAP ADVISORS PRIVATE LIMITED',
    'ADITYA BIRLA RENEWABLES UTKAL LIMITED',
    'AIO IMPEX PRIVATE LIMITED',
    'FINPLEX TECHNOLOGIES PRIVATE LIMITED',
    'DIGITAL CASTLE WEB SOLUTIONS PRIVATE LIMITED',
    'FASCINER REALTY (I) PRIVATE LIMITED',
    'ZKONSULT INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'WESCO LIFESTYLE PRIVATE LIMITED',
    'FUJISOFT VARA PRIVATE LIMITED',
    'ACRE INDUSTRIAL SOLUTIONS INDIA PRIVATE LIMITED',
    'FITTERFLY TECHNOLOGIES PRIVATE LIMITED',
    'SUNILKIRAN EXPORTS PRIVATE LIMITED',
    'TEAM HIRE STAFFING SERVICES PRIVATE LIMITED',
    'PETAMIKO SERVICES PRIVATE LIMITED',
    'TECHWISE DIGITAL PRIVATE LIMITED',
    'FOUR SEASONS FLOWER DEPOT PRIVATE LIMITED',
    'CRYPTOMIZE PRIVATE LIMITED',
    'GLANCE DIGITAL EXPERIENCE PRIVATE LIMITED',
    'MAXWARE TECHNOLOGIES PRIVATE LIMITED',
    'CROUZET MECHATRONICS INDIA PRIVATE LIMITED',
    'INSPERON AUTOCRAFT INDUSTRIES PRIVATE LIMITED',
    'ROSS TECHNOLOGIES PRIVATE LIMITED',
    'SRI SHIVSAKTHI MERCANTILE PRIVATE LIMITED',
    'RIPPLE AERONAUTICS PRIVATE LIMITED',
    'ROMIO TECHNOLOGIES PRIVATE LIMITED',
    'FOXENA TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'FUJION TECHNICA PRIVATE LIMITED',
    'NEEDFILL PRIVATE LIMITED',
    'TALERANG ONLINE PRIVATE LIMITED',
    'PRIME DIGITRONICS SERVICES PRIVATE LIMITED',
    'CRITERIONSCREENERS GLOBAL PRIVATE LIMITED',
    'PEEVEEO ENTERPRISES PRIVATE LIMITED',
    'SGICON INFINITY SOLUTIONS PRIVATE LIMITED',
    'AGFERM INNOVATIONS PRIVATE LIMITED',
    'RENA EXPORTS PRIVATE LIMITED',
    'CASA TORTUGA SUSTAINABLE HOMES PRIVATE LIMITED',
    'ENGINEERED COMPONENTS AND SYSTEMS INDIA PRIVATE LIMITED',
    'SHREE CHANDRAMANGAL SUNCITY MARKETING PRIVATE LIMITED',
    'SWASTIK BIZ PRIVATE LIMITED',
    'SAVEO HEALTHTECH PRIVATE LIMITED',
    'COLSTAY PRIVATE LIMITED',
    'CONVOY TRUCKING PRIVATE LIMITED',
    'MAANGALYA VENTURES PRIVATE LIMITED',
    'MAGIKLE VENTURES PRIVATE LIMITED',
    'AXEGIS (INDIA) PRIVATE LIMITED',
    'DATOSMIND PRIVATE LIMITED',
    'MEINIGAR TECHNOLOGIES PRIVATE LIMITED',
    'MEDILIVESCARE MANUFACTURING PRIVATE LIMITED',
    'DIGISIGNALS INDIA PRIVATE LIMITED',
    'VOLANTI SPACES PRIVATE LIMITED',
    'NITROAIR ENGINEERS PRIVATE LIMITED',
    'AASHI HOUSEWARE INDIA PRIVATE LIMITED',
    'PROBUDDY SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SEED AGRITECH PRIVATE LIMITED',
    'ANTOZYME BIOTECH PRIVATE LIMITED',
    'FOREFRONT HEALTHCARE PRIVATE LIMITED',
    'ENETBUDDY TECHNOLOGIES PRIVATE LIMITED',
    'CAMPBELL SCIENTIFIC INDIA PRIVATE LIMITED',
    'GETGO LOGISTICS PRIVATE LIMITED',
    'MASTER',
    'S COUTURE PRIVATE LIMITED',
    'UK POWER ENGINEERS INDIA PRIVATE LIMITED',
    'LOGIGO VENTURES PRIVATE LIMITED',
    'CAREAVA PRIVATE LIMITED',
    'OSSL AGRI LOGISTICS PRIVATE LIMITED',
    'LIGHT SPEED BUSINESS SERVICES PRIVATE LIMITED',
    'PACKNBACK SOLUTIONS PRIVATE LIMITED',
    'FIFTH AVENUE IMPEX PRIVATE LIMITED',
    'BYTEXL INDIA PRIVATE LIMITED',
    'LION ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'HASTWELL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'JUNIPER GREEN THREE PRIVATE LIMITED',
    'FLAKE REALTECH PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR EIGHT PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR TEN PRIVATE LIMITED',
    'KUBER MART INDUSTRIES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR NINE PRIVATE LIMITED',
    'MAA KUDARGARHI POWER AND ISPAT PRIVATE LIMITED',
    'HARM REDUCTION POLICY & RESEARCH PRIVATELIMITED',
    'AVIATIONGEEKS PRIVATE LIMITED',
    'ARHAT LIFESTYLE RETAIL PRIVATE LIMITED',
    'EVERETT PROPERTIES PRIVATE LIMITED',
    'KIRLOSKAR MANAGEMENT SERVICES PRIVATE LIMITED',
    'SYSCOICT TECHNOLOGIES PRIVATE LIMITED',
    'TECBLIC PRIVATE LIMITED',
    'BELLSTONE HITECH INTERNATIONAL LIMITED',
    'ARSHIKA E-RETAIL INDIA PRIVATE LIMITED',
    'SMART OWL EDUCATION PRIVATE LIMITED',
    'DANISCO NUTRITION AND BIOSCIENCES INDIA PRIVATE LIMITED',
    'GREENZEST SUN PARK PRIVATE LIMITED',
    'INVENTE INNOVATION LABS PRIVATE LIMITED',
    'SEVENOS INFRATECH PRIVATE LIMITED',
    'TEKTTARGET SYSTEMS INDIA PRIVATE LIMITED',
    'FIFTY ROCKS LIFESTYLE PRIVATE LIMITED',
    'RAPIDEV TECHNOLOGIES PRIVATE LIMITED',
    'GURUMAA MANISHA DIDI FOUNDATION',
    'EVEY TRANS (IDR) PRIVATE LIMITED',
    'ONDESK VENTURES PRIVATE LIMITED',
    'INDO MONEY INFOTECH PRIVATE LIMITED',
    'ADVANCED MONOLITHIC POWER SEMICONDUCTOR PRIVATE LIMITED',
    'THESCHNELL APPS PRIVATE LIMITED',
    'STACKSAVE VENKATA SOLUTIONS PRIVATE LIMITED',
    'UNBEND INFRA PRIVATE LIMITED',
    'HENGLI HYDRAULIC INDIA PRIVATE LIMITED',
    'TECHNANZIA INFOTECH PRIVATE LIMITED',
    'GOFLYON PRIVATE LIMITED',
    'MEPA SOLUTIONS PRIVATE LIMITED',
    'SHIVENK TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'FINTOTA (OPC) PRIVATE LIMITED',
    'SMART BILAL INDIA HOUSING PRIVATE LIMITED',
    'TRUE-BLUE REALTY PRIVATE LIMITED',
    'FAB INDUSTRIES PRIVATE LIMITED',
    'QUEPINCH TECHNOLOGIES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR SEVEN PRIVATE LIMITED',
    'ROCKSENSOR INDIA PRIVATE LIMITED',
    'BIZZVITALS TECHNOLOGIES PRIVATE LIMITED',
    'RAGHAVI VENTURES PRIVATE LIMITED',
    'ROCKWATER DECOR PRIVATE LIMITED',
    'SESAME SOLAR PRIVATE LIMITED',
    'DHOOT AUTOMOTIVE SYSTEMS PRIVATE LIMITED',
    'R.F. TECHNOLOGY INDIA PRIVATE LIMITED',
    'LEXLEGACYBLOC (OPC) PRIVATE LIMITED',
    'RELIABLE LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'INTENTHEALTH TECHNOLOGIES PRIVATE LIMITED',
    'LINEAL SERVICES PRIVATE LIMITED',
    'DESIGNINDYA ADVERTISING PRIVATE LIMITED',
    'TRUSTED COMMUNITIES ORGANIZATION PRIVATELIMITED',
    'DLS PROFESSIONAL SERVICES PRIVATE LIMITED',
    'SABY EXPORTS PRIVATE LIMITED',
    'ARCHOZ TRADELINK PRIVATE LIMITED',
    'QUARTERFOLD MEDIA PRIVATE LIMITED',
    'PRISMA RENEWABLE ENERGY (DEWAS) PRIVATE LIMITED',
    'FLUCON PROPERTIES PRIVATE LIMITED',
    'CORETEAM GLOBAL CONTRACTING AND TRADING PRIVATE LIMITED',
    'S.S.CROP CARE Private Limited',
    'INKES Trade Centre Limited',
    'Kool Home Builders Private Limited',
    'KOOL HOME PROPERTIES & DEVELOPERS PRIVATE LIMITED',
    'SPAZIO DESIGNER HOMES PRIVATE LIMITED',
    'BABYMARINE SEAFOOD RETAIL PRIVATE LIMITED',
    'BHIMA JEWELS KOCHI PRIVATE LIMITED',
    'BLUEST METTLE SOLUTIONS PRIVATE LIMITED',
    'WHITESANDS GLOBAL CONSULTANTS PRIVATE LIMITED',
    'Bismi Hypermart Private Limited',
    'KOVAX ABRASIVES SOUTH ASIA PRIVATE LIMITED',
    'Kodspider Technologies Private Limited',
    'UPARROW SYSTEMS PRIVATE LIMITED',
    'LULU TRIVANDRUM MALL PRIVATE LIMITED',
    'TUTTIFRUTTI GAMES PRIVATE LIMITED',
    'METSAND TECHNO SOLUTIONS PRIVATE LIMITED',
    'Tandem Data Processing Private Limited',
    'TWENTY FOURTEEN HOTELS INDIA PRIVATE LIMITED',
    'ANTHRAPER WATERWAYS PRIVATE LIMITED',
    'ONET DIGITAL NETWORKS PRIVATE LIMITED',
    'SKILLS MANTRA EDUTECH CONSULTING INDIA PRIVATE LIMITED',
    'Collier Shipping & Logistics Services Private Limited',
    'LINKITES ELRISE PRIVATE LIMITED',
    'KHAJAN - SITA PARMARTHIK TRUST',
    'REFTECK SOLUTION PRIVATE LIMITED',
    'MATHRUKA PRACHARANALAYAM LTD',
    'ROSA BUILDERS PRIVATE LIMITED',
    'FAP INDIA CHEMICAL SOLUTIONS PRIVATE LIMITED',
    'NETLINK ICT PRIVATE LIMITED',
    'WAXWING AVIONICS RESEARCH AND PRODUCT DEVELOPMENT PRIVATE LIMITED',
    'CTL Healthcare Private Limited',
    'fonePaisa Payment Solutions Private Limited',
    'NEEWEE ANALYTICS PRIVATE LIMITED',
    'OmniWare Technologies Private Limited',
    'RESONOUS TECHNOLOGIES PRIVATE LIMITED',
    'SIPGATE SERVICES PRIVATE LIMITED',
    'MMRFIC TECHNOLOGY PRIVATE LIMITED',
    'EDUSHIRE TECHNOLOGIES PRIVATE LIMITED',
    'Aidaio Software Solutions Private Limited',
    'TOOKITAKI TECHNOLOGIES PRIVATE LIMITED',
    'Cooey Technologies Private Limited',
    'JustKlick Technologies Private Limited',
    'TrapSoft Solutions India Private Limited',
    'UNIKK APPS SOLUTIONS PRIVATE LIMITED',
    'Sunbay Apps Private Limited',
    'INAVANTAGE SOLUTIONS PRIVATE LIMITED',
    'NXTIFY TECHNOLOGIES PRIVATE LIMITED',
    'Shipdesk Solutions Private Limited',
    'SANTROTECH SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'Nicox IT Solutions Private Limited',
    'Growtech Innovations India Private Limited',
    'DIGILEUM TECHNOLOGIES PRIVATE LIMITED',
    'INEXOFT TECHNOLOGIES PRIVATE LIMITED',
    'ITSOLI INDIA PRIVATE LIMITED',
    'ERINOME INFO INDIA PRIVATE LIMITED',
    'MICELIO MOBILITY PRIVATE LIMITED',
    'Pink Lemonade Communications Private Limited',
    'VARANA DESIGN PRIVATE LIMITED',
    'Cognitree Technologies Private Limited',
    'Ekagga Technology & Services Private Limited',
    'DIGITERA TECHNOLOGIES PRIVATE LIMITED',
    'NxTk Solutions Private Limited',
    'REQS Technologies India Private Limited',
    'ANTERN TECHNOLOGIES PRIVATE LIMITED',
    'EXPIAN TECHNOLOGIES PRIVATE LIMITED',
    'INFOCRAWLERS DATAHUNT PRIVATE LIMITED',
    'Kalpakosh Software Solutions Private Limited',
    'CeOne Infosolutions Private Limited',
    'UMATIC INDIA PRIVATE LIMITED',
    'TalentMicro Innovations Private Limited',
    'ENTUNE IT CONSULTING PRIVATE LIMITED',
    'Nirayana Labs Private Limited',
    'worxogo Solutions Private Limited',
    'INVITREK SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'SoftLayer Technologies India Private Limited',
    'Gadflyzone India Private Limited',
    'Zuken India Private Limited',
    'TE CONSULTING (INDIA) PRIVATE LIMITED',
    'FireEye Technologies India Private Limited',
    'HP PPS Services India Private Limited',
    'ResolveTech Solutions India Private Limited',
    'Offer Happiness 365 India Private Limited',
    'YATIS TELEMATICS PRIVATE LIMITED',
    'Cleo Software India Private Limited',
    'EZE CASTLE INTEGRATION INDIA PRIVATE LIMITED',
    'FULLCONTACT TECHNOLOGIES PRIVATE LIMITED',
    'TE Connectivity Services India Private Limited',
    'MONOID SYSTEMS Private Limited (OPC)',
    'vPersonalize Technology India Private Limited',
    'Silvermine Software India Private Limited',
    'MINDS ARTIFICIAL INTELLIGENCE TECHNOLOGIES PRIVATE LIMITED',
    'TANDEMINFO TECHNOLOGIES PRIVATE LIMITED',
    'MERITSQUAD TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Julia Computing India Private Limited',
    'MDS Pacific India Private Limited',
    'KEN INTERACTIVE (INDIA) PRIVATE LIMITED',
    'CAAVO LABS INDIA PRIVATE LIMITED',
    'B12 CONSULTING (INDIA) PRIVATE LIMITED',
    'PROMPTCLOUD TECHNOLOGIES PRIVATE LIMITED',
    'A2M Technologies Private Limited',
    'AMICK BROWN INDIA PRIVATE LIMITED',
    'Sensara Technologies India Private Limited',
    'LikePurple Interactive India Private Limited',
    'CARMEL IT SOLUTIONS PRIVATE LIMITED',
    'TechChefs Software Private Limited',
    'Lavelle Networks Private Limited',
    'TERRALOGIC DIGITAL CREATIVES PRIVATE LIMITED',
    'CLUSTER INFO SOLUTIONS PRIVATE LIMITED',
    'TECHCLYDE SERVICES PRIVATE LIMITED',
    'Almug Technologies Private Limited',
    'FicusTexas Technologies Private Limited',
    'IMCRINOX TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'RESEARCHON SYSTEMS PRIVATE LIMITED (OPC)',
    'NICANOR TECH PRIVATE LIMITED',
    'Annona IT Solutions Private Limited',
    'Streamingo Solutions Private Limited',
    'HOUSE OF BLUE BEANS INTERACTIVE MEDIA PRIVATE LIMITED',
    'Hapstronics Technology Private limited',
    'Vadamalai Business Solutions Private Limited',
    'QGEN OPERATIONS PRIVATE LIMITED',
    'Avoor Networks Private Limited',
    'Touchkin eServices Private Limited',
    'DevuSuccess Rate Solutions Private Limited',
    'WorldInformatix Cyber Security India Private Limited',
    '10i Commerce Services Private Limited',
    'DotWeb Solutions Private Limited',
    'FETEK ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'FLUID COMPUTER GRAPHICS PRIVATE LIMITED',
    'ADITA BIO SYS PRIVATE LIMITED',
    'HEM',
    'S MUSIC PRIVATE LIMITED',
    'Manitee Pet Services Private Limited (OPC)',
    'OCTOPUS CONSTRUCTION PRIVATE LIMITED',
    'JHY TECHSERVE PRIVATE LIMITED',
    'VYODA SOLAR PRIVATE LIMITED',
    'VARISAN IMEX PRIVATE LIMITED',
    'DHATU ORGANICS AND NATURALS PRIVATE LIMITED',
    'GHATS AND MURTHY REALTY PRIVATE LIMITED',
    'NINJAAS LABS PRIVATE LIMITED',
    'DMS Electronics Private Limited',
    'DIGIDON LABS INDIA PRIVATE LIMITED',
    'JAY DEE INFRA DEVELOPERS PRIVATE LIMITED',
    'SHIVDUTI AUTOMOBILES PRIVATE LIMITED',
    'CLOUDZEN SOFTWARE LABS PRIVATE LIMITED',
    'Penstack Solutions Private Limited',
    'CHIGURUPATI VINEYARDS PRIVATE LIMITED',
    'TT Recycling Management India Private Limited',
    'INNOVATIVE FILM ACADEMY PRIVATE LIMITED (OPC)',
    'SWAROOHA ENTERTAINMENT PRIVATE LIMITED',
    'Voyzek Technologies Private Limited',
    'ALMUQEET SYSTEMS PRIVATE LIMITED',
    'VALETRON SYSTEMS PRIVATE LIMITED',
    'Uforya Media Private Limited',
    'N B R AGRO EXPORTS PRIVATE LIMITED',
    'KGF POWER LOOM PARK PRIVATE LIMITED',
    'ASHOK SECURE BROADBAND NETWORK PRIVATE LIMITED',
    'FAWKIMS ENGINEERING PRIVATE LIMITED',
    'SANGAM JEEVAN MICRO FINANCE FOUNDATION',
    'JHARKHAND STATES MINERAL DEVELOPMENT CORPORATION LIMITED',
    'MELIORATE LUBES PRIVATE LIMITED',
    'TENUGHAT VIDYUT NIGAM LIMITED',
    'FACT EDUCATION SOLUTION PRIVATE LIMITED',
    'THE J & K PROJECTS CONSTRUCTION CORPORATION LIMITED',
    'ATTIFY MOBILE SECURITY PRIVATE LIMITED',
    'VISION XTRA PRIVATE LIMITED',
    'Superior Marine Security Consultants Private Limited',
    'KESHAV BIKE WORLD PRIVATE LIMITED',
    'DREAMWORKS INFOTECH PRIVATE LIMITED',
    'SRI SHIV BAIDYANATH CONSTRUCTION AND COMPANY PRIVATE LIMITED',
    'GANESH ONLINE. COM PRIVATE LIMITED',
    'SHEEN AUTOMOBILES PRIVATE LIMITED',
    'ShamaMatrix Cars Private Limited',
    'MANGALORE SCENTS PRIVATE LIMITED',
    'Faaya Lifestyle Private Limited',
    'Willow Infratech Private Limited',
    'NIMANI INFO SOLUTIONS PRIVATE LIMITED',
    'RAJHANS AUTOMOBILES PRIVATE LIMITED',
    'SnehSanskriti OPC Private Limited',
    'TREHAN INDUSTRIES PRIVATE LIMITED',
    'PUREGAS CARBONICS PRIVATE LIMITED',
    'AIRMESH SURF PRIVATE LIMITED',
    'S&S COMPUTERTECH PRIVATE LIMITED',
    'HI TECH AGRO ENERGY PRIVATE LIMITED',
    'SYSKO ASIA HEALTHCARES PRIVATE LIMITED',
    'SWASTIK AUTOMECH PRIVATE LIMITED',
    'Jammu Cricket League',
    'BANOLA POWER PRIVATE LIMITED',
    'ATS BUILDING SYSTEMS PRIVATE LIMITED',
    'NEW ERA DESIGNS PRIVATE LIMITED',
    'ITECH SECURITIES GLOBAL PRIVATE LIMITED',
    'K2 GREEN FARMS PRIVATE LIMITED',
    'SOFFIS INDIA EXPORTS PRIVATE LIMITED',
    'RIMO EXPEDITIONS PRIVATE LIMITED',
    'REAL STONE CONSTRUCTIONS PRIVATE LIMITED',
    'Fox Express Private Limited',
    'Promesa Infrastructures Private Limited',
    'KARV STAFFING & ENGINEERING SERVICES LIMITED',
    'Unico Technologies Private Limited',
    'APPFLOW SOLUTIONS PRIVATE LIMITED',
    'ISHANT TECHNOLOGIES AND SOLOUTIONS PRIVATE LIMITED',
    'DIGITAL IMPRESSIONS PRIVATE LIMITED',
    'CSS PLAYER IT SOLUTIONS PRIVATE LIMITED',
    'VERISPIRE TECHNOLOGIES PRIVATE LIMITED',
    'Federated Mart Systems Private Limited',
    'HYDROMORE POWER PRIVATE LIMITED',
    'Snowmicro Technologies private Limited',
    'CREST TOPICALS PRIVATE LIMITED',
    'Grand prospect international communication Private Limited',
    'ESTO BROADBAND PRIVATE LIMITED',
    'ESCORTS SKILL DEVELOPMENT',
    'COSMOS BROADCAST SOLUTIONS PRIVATE LIMITED',
    'MANGALAM CORPORATE SOLUTIONS PRIVATE LIMITED',
    'VEN TRADE PRIVATE LIMITED',
    'Eximat Consulting Private Limited',
    'IA MULTI VENTURES PRIVATE LIMITED',
    'LONESTAR KASHMIR FOOTBALL CLUB PRIVATE LIMITED',
    'SARVESHWAR OVERSEAS LIMITED',
    'HIMALAYAN ANCIENT FOODS PRIVATE LIMITED',
    'HIMALAYAN BIO ORGANIC FOODS LIMITED',
    'Navdeep Tools Private Limited',
    'AMROC BREMSE OIL TOOLS PRIVATE LIMITED',
    'ICECRAFT CREATIONS PRIVATE LIMITED',
    'TRIUMPH SPORTSWEAR DESIGN STUDIO PRIVATE LIMITED',
    'SHREE SIMANDHAR STEEL PRIVATE LIMITED',
    'SABARMATI NETWORK PRIVATE LIMITED',
    'EXPRO EVENTS & EXHIBITS PRIVATE LIMITED',
    'AMD Integral Services Private Limited',
    'IISFT SKILLS PRIVATE LIMITED',
    'WELLHEAD EQUIPMENT ENGINEERS PRIVATE LIMITED',
    'Endatio Services (India) Private Limited',
    'DR. AMBEDKAR ANTYODAYA DEVELOPMENT CORPORATION',
    'DEVASHREE ALUMINUM PRIVATE LIMITED',
    'GANDHAR HAZIRA TRANSMISSION LIMITED',
    'UNIQUE INTERNATIONAL IMMIGRATION SERVICES PRIVATE LIMITED',
    'CAPRAZO PRIVATE LIMITED',
    'AHMEDABAD INSTITUTE OF DRILLING TECHNOLOGY',
    'PROFERO TECHNO PRIVATE LIMITED',
    'DYNADOR ENTRANCE SOLUTIONS PRIVATE LIMITED',
    'PRATHAM EXPERT SERVICES (OPC) PRIVATE LIMITED',
    'JALARAM AGRICO EXPORTS PRIVATE LIMITED',
    'HARDIK INFRAPROJECTS PRIVATE LIMITED',
    'REXTILE LEATHER PRIVATE LIMITED',
    'SUNSHINE BUILDARCH PRIVATE LIMITED',
    'BIOS LAB PRIVATE LIMITED',
    'MAHESHWARI INFRAPRO PRIVATE LIMITED',
    'SPIRAL DEVELOPERS PRIVATE LIMITED',
    'NEXION INTERNATIONAL PRIVATE LIMITED',
    'EMCER TILES PRIVATE LIMITED',
    'AMBANI VITRIFIED PRIVATE LIMITED',
    'PASSION VITRIFIED PRIVATE LIMITED',
    'BLUEZONE VITRIFIED PRIVATE LIMITED',
    'ESSENCE BUILDWARE PRIVATE LIMITED',
    'AMAZON TECHNOCAST PRIVATE LIMITED',
    'ETERNAL ALLOY CAST PRIVATE LIMITED',
    'ADROIT AGRO PRIVATE LIMITED',
    'OCEANAXIS CONTAINER LINES (INDIA) PRIVATE LIMITED',
    'PARAMOUNT SEALINK PRIVATE LIMITED',
    'HARMONY PLY-LAM LIMITED',
    'NIF INCUBATION AND ENTREPRENEURSHIP COUNCIL',
    'SOLEX ENERGY LIMITED',
    'SARVODAY MARINE SERVICES PRIVATE LIMITED',
    'OM EDUCON PRIVATE LIMITED',
    'N L EXTRUSION PRIVATE LIMITED',
    'ASIAN TRANSPORT PRIVATE LIMITED',
    'GALE SOLARFARMS LIMITED',
    'PRATHAMESH SOLARFARMS LIMITED',
    'ENERGENIUS PRIVATE LIMITED',
    'RUDRA SOLARFARMS PRIVATE LIMITED',
    'ABHA SOLARFARMS LIMITED',
    'AMUN SOLARFARMS LIMITED',
    'AALOK SOLARFARMS LIMITED',
    'TORNADO SOLARFARMS LIMITED',
    'VAYUDOOT SOLARFARMS LIMITED',
    'SHREYAS SOLARFARMS LIMITED',
    'MEHSANA DAIRY AND FOOD PRODUCTS LIMITED',
    'Serviceforce Auto India Private Limited',
    'TORQUE AUTOMOBILES PRIVATE LIMITED',
    'RATAK INDUSTRIAL PRODUCTS PRIVATE LIMITED',
    'Elkins Tradelink Limited',
    'DIVYANG INFOWORLD PRIVATE LIMITED',
    'HAITIAN HUAYUAN MACHINERY (INDIA) PRIVATE LIMITED',
    'EMIPRO TECHNOLOGIES PRIVATE LIMITED',
    'Balaji Infra Ray Private Limited',
    'TRIMS PHARMA PRIVATE LIMITED',
    'BRIGHTNESS SOFTWARE DEVELOPMENT (I) PRIVATE LIMITED',
    'GOKUL AGRI MARKETS INFRASTRUCTURE PRIVATE LIMITED',
    'HERB ELEMENTZ NATURECEUTICALS PRIVATE LIMITED',
    'SENSO FOODS PRIVATE LIMITED',
    'RESONANCE PAPER MILL PRIVATE LIMITED',
    'AXI LAM PRIVATE LIMITED',
    'SOXA FORMULATIONS AND RESEARCH PRIVATE LIMITED',
    'BHUVA POLYPLAST PRIVATE LIMITED',
    'AQUANZA PROJECTS PRIVATE LIMITED',
    'SYMBOSA GRANITO PRIVATE LIMITED',
    'SHACHA TECHNOFORGE PRIVATE LIMITED',
    'CENTURY AQUA CULTURE PRODUCTS PRIVATE LIMITED',
    'SUKHKAND HARDWARE PRIVATE LIMITED',
    'HILTON VALVES PRIVATE LIMITED',
    'AGLON INDUSTRIES PRIVATE LIMITED',
    'NIJ TEXTILES PRIVATE LIMITED',
    'CHANAKYA WEAVETECH PRIVATE LIMITED',
    'VIS TECHNOSERVE PRIVATE LIMITED',
    'VARNIRAJ FILATEX PRIVATE LIMITED',
    'Aarya Infonet Private Limited',
    'DZIRE SURGICAL INDIA PRIVATE LIMITED',
    'D V DIAM PRIVATE LIMITED',
    'SHIV MULTIPORT PRIVATE LIMITED',
    'SUPRAJH INDUSTRIES PRIVATE LIMITED',
    'UNIVISION ELECTROTECH PRIVATE LIMITED',
    'BIZOTIC LIFESCIENCE PRIVATE LIMITED',
    'ENERGY TECHNOCAST PRIVATE LIMITED',
    'AVIGHNA SOLARFARMS LIMITED',
    'TDK GREEN ENVIRO PRIVATE LIMITED',
    'VENUS PIPES & TUBES LIMITED',
    'SHREEJI LIQUID STORAGE TERMINALS PRIVATE LIMITED',
    'EquipTrans Logistics Private Limited',
    'SKY CELEBRATIONS PRIVATE LIMITED',
    'FLITZEN TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'BIGSCAL TECHNOLOGIES PRIVATE LIMITED',
    'SECUREMETASYS INFOTECH PRIVATE LIMITED',
    'DGR NETSOL PRIVATE LIMITED',
    'BLUECHIP INFOCORP PRIVATE LIMITED',
    'PurplePatch Online Services Private Limited',
    'R K Associates Valuers & Techno Engineering Consultants Private Limited',
    'BTN-INSULO INDIA PRIVATE LIMITED',
    'SANDEEP LAMINATORS PRIVATE LIMITED',
    'ESTEEM INVESTMENTS PRIVATE LIMITED',
    'CSAT SYSTEMS PRIVATE LIMITED',
    'JAI JAWAN COAL CARRIERS PRIVATE LIMITED',
    'CONTEL MEDICARE SYSTEMS PRIVATE LIMITED',
    'PRAKASH LABELS PRIVATE LIMITED',
    'DHANAM IMPEX PRIVATE LIMITED',
    'LSQA INDIA CERTIFICATION PRIVATE LIMITED',
    'EMBELLISH PRODUCT CREATION PRIVATE LIMITED',
    'PHARMA SYNTH FORMULATIONS LIMITED',
    'AUTONIX AUTO INDUSTRIES PRIVATE LIMITED',
    'DECENT FOODS PRIVATE LIMITED',
    'M S CORRIDOR MANAGEMENT PRIVATE LIMITED',
    'SAARTHI HARSHA CHITS PRIVATE LIMITED',
    'PUNCH RATNA FASTENERS PRIVATE LIMITED',
    'DAKSH SCOOTERS PRIVATE LIMITED',
    'AMIGO INFOSOFT PRIVATE LIMITED',
    'LSS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FOUNDLAY TECHNOLOGIES PRIVATE LIMITED',
    'RUCHIKA E-LEARNING SERVICES PRIVATE LIMITED',
    'ALTITUDE SERVICES PRIVATE LIMITED',
    'Boundless Management Solutions Private Limited',
    'MEDIANT CABLE NETWORK PRIVATE LIMITED',
    'Integrated iPaathshala Training & Consulting (OPC) Private Limited',
    'ORANGE FISH EVENTS PRIVATE LIMITED',
    'HNKT Recruitment Private Limited',
    'PRESCIENT EDUCATION SERVICES PRIVATE LIMITED',
    'Pietos Solutions Private Limited',
    'TPI STAFFING PRIVATE LIMITED',
    'MTH PROJECT PRIVATE LIMITED',
    'AREEM TECHNO INDIA PRIVATE LIMITED',
    'YKS Designs Private Limited',
    'RISING SUN ENERGY PRIVATE LIMITED',
    'TECHENCEPHALON SOFTWARES PRIVATE LIMITED',
    'SPS EDUCARE PRIVATE LIMITED',
    'STROLAR MOUNTING SYSTEMS PRIVATE LIMITED',
    'Garnet Learning Private Limited',
    'SRC ACADEMICS PRIVATE LIMITED',
    'ONCE AGAIN ECOMM PRIVATE LIMITED',
    'ASHPRA SKILLS PRIVATE LIMITED',
    'ADR DATA MANAGEMENT SERVICES PRIVATE LIMITED',
    'MANAV BREWERIES PRIVATE LIMITED',
    'RELIANCE A&T FASHIONS PRIVATE LIMITED',
    'UNIQUE ENGINEERS PRIVATE LIMITED',
    'RAJNEESH GUPTA FOUNDATION',
    'KOTESHWAR MARKETING PRIVATE LIMITED',
    'PAMPOSH CHEMICALS PRIVATE LIMITED',
    'BlueLakes Management Services OPC Private Limited',
    'SYNERGY SOFTWARE LIMITED',
    'TATYNERDS PRIVATE LIMITED',
    'Golden Palms Facility Management Private Limited',
    'MAHENDRA SKILLS TRAINING & DEVELOPMENT PRIVATE LIMITED',
    'CMCSERVICES INDIA PRIVATE LIMITED',
    'MILLENNIUM SEVEN SEAS SERVICES PRIVATE LIMITED',
    'LESS THAN EQUALS THREE SERVICES PRIVATE LIMITED',
    'CENTUM CONSULTING PRIVATE LIMITED',
    'MS Language World OPC Private Limited',
    'Quick Rays Private Limited',
    'GREENHAWK FACILITY MANAGEMENT PRIVATE LIMITED',
    'BRIOSHOPPY INFOTECH PRIVATE LIMITED',
    'IMMUNOCONCEPT INDIA PRIVATE LIMITED',
    'iAlitus info solutions private limited',
    'GENIEHR SOLUTIONS PRIVATE LIMITED',
    'CYPRESS EDU-SKILLS PRIVATE LIMITED',
    'HOUZILLA INTERIORS PRIVATE LIMITED',
    'FUTUREICONS LEARNING ACADEMY (OPC) PRIVATE LIMITED',
    'HELIOS EDUCORE PRIVATE LIMITED',
    'JEEN SOCIAL DEVELOPMENT FOUNDATION',
    'KANHA MILK TESTING EQUIPMENTS PRIVATE LIMITED',
    'CREDEX LIFE SYSTEMS PRIVATE LIMITED',
    'AARIYA REGULATORY SERVICES PRIVATE LIMITED',
    'FLYING FISH EVENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'Renure Creations Private Limited',
    'MYNGN Automation Private Limited',
    'UNIVOE INNOVATIONS PRIVATE LIMITED',
    'P2 LOGITECH PRIVATE LIMITED',
    'YORK OIL AND FATS Private LIMITED',
    'SAROBE FASHIONS PRIVATE LIMITED',
    'V-MODE FASHIONS PRIVATE LIMITED',
    'PATLIPUTRA SOLUTIONS PRIVATE LIMITED',
    'CONTINUUM CONTENT SOLUTIONS INDIA PRIVATE LIMITED',
    'AGRIM RURAL SOLUTIONS PRIVATE LIMITED',
    'WADA CONCRETES PRIVATE LIMITED',
    'MONASH INTERNATIONAL LIMITED',
    'SPACK AUTOMOTIVES Private Limited',
    'UNITY POWER AND SECURITY TECHNOLOGIES PRIVATE LIMITED',
    'JETSETGO AVIATION SERVICES PRIVATE LIMITED',
    'SYNERGY LABELS & PRINT SOLUTIONS PRIVATE LIMITED',
    'PIS PRINT INDIA SOLUTION PRIVATE LIMITED',
    'Ignovision Solutions Private Limited',
    'Rise India Association',
    'Growth India Foundation',
    'ATS DREAMZONE PRIVATE LIMITED',
    'ZINNIA EQUITY CONSULTANT LIMITED',
    'MAGAZINE TRADERS PRIVATE LIMITED',
    'Great Capital Investments Private Limited',
    'ACCUPROBE HEALTHCARE AND DIAGNOSTICS PRIVATE LIMITED',
    'LEGEND GOURMET HUB PRIVATE LIMITED',
    'Whitewater Logistics Private Limited',
    'GITROH GLOBAL EXHIBITIONS & CONFERENCE PRIVATE LIMITED',
    'AMICUS LEGAL OUTSOURCING PRIVATE LIMITED',
    'VENTRAL LEARNING PRIVATE LIMITED',
    'KGC Skill Development Private Limited',
    'Glector Global Enterprises Private Limited',
    'DIRECT CREATE PRIVATE LIMITED',
    'JSK TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'AGNITY Communications Private Limited',
    'ProExcel Technologies Private Limited',
    'K4 INFOTECH PRIVATE LIMITED',
    'Shapecrunch technology Private Limited',
    'Emperks Web Technologies Private Limited',
    'SAICOM INFOTECH PRIVATE LIMITED',
    'AdvantEDGE Incubators Private Limited',
    'Kivu Developers Private Limited',
    'Walif Developers Private Limited',
    'CALANGUTE ADVISORY SERVICES PRIVATE LIMITED',
    'PAHLE INDIA PRIVATE LIMITED',
    'INDUS VALLEY IT PARKS PRIVATE LIMITED',
    'AMCS INDIA PRIVATE LIMITED',
    'Myish Technology Private Limited',
    'FABXPRO SOLUTIONS PRIVATE LIMITED',
    'Anigo Infosystem Private Limited',
    'CASANSAAR WEB SOLUTIONS PRIVATE LIMITED',
    'GIGABIT IT SOLUTIONS PRIVATE LIMITED',
    'ETELLIGENS TECHNOLOGIES PRIVATE LIMITED',
    'SEMITECH OPTO SOLUTIONS PRIVATE LIMITED',
    'Yashtech Information Private Limited',
    'HAICHENG MOBILE (INDIA) PRIVATE LIMITED',
    'Retention Nine Technologies Private Limited',
    'TREVION IT SYSTEMS INDIA PRIVATE LIMITED',
    'STERK STAFFING PRIVATE LIMITED',
    'Fivesky India Private Limited',
    'Matrix Secure Applications (OPC) Private Limited',
    'THINKRUCIBLE SOLUTIONS PRIVATE LIMITED',
    'SELECT CITYWALK MALL MANAGEMENT PRIVATE LIMITED',
    'AquGen Technologies Private Limited',
    'Venturous Business Ventures Private Limited',
    'SELECT CITYWALK E-COM PRIVATE LIMITED',
    'ADELANTE TECHNOLOGIES PRIVATE LIMITED',
    'BINJJ SYSTEMS PRIVATE LIMITED',
    'SYSLINK TECHTRONICS PRIVATE LIMITED',
    'ARTS HOSPITALITY PRIVATE LIMITED',
    '72 NETWORKS PRIVATE LIMITED',
    'Boston Scientific Technology & Engineering Services Private Limited',
    'URBANCLAP TECHNOLOGIES INDIA PRIVATE LIMITED',
    'REACT INDIA PRIVATE LIMITED',
    'KODAN SOLUTIONS PRIVATE LIMITED',
    'RAPOO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Climate Policy Initiative India Private Limited',
    'First Global Business Chambers',
    'LADY BAMFORD FOUNDATION',
    'TRUE NORTH CENTRE FOR CONTEMPORARY STUDIES OPC PRIVATE LIMITED',
    'EW Nutrition India Private Limited',
    'Perfekt Sense Digital Ventures Private Limited',
    'FREECHARGE PAYMENT TECHNOLOGIES PRIVATE LIMITED',
    'CLARCOR India Private Limited',
    'SNJ TECHNOLOGY PRIVATE LIMITED',
    'Elements Infra Consulting Private Limited',
    'Regus Magnum Business Centres Private Limited',
    'M.B.A. QT BPO PRIVATE LIMITED',
    'I.Q. MED HEALTHCARE PRIVATE LIMITED',
    'UPR eCommerce Private Limited',
    'IGLESIA NI CRISTO (CHURCH OF CHRIST)',
    'MAVERICK KNOWLEDGE PROCESSORS PRIVATE LIMITED',
    'NVS Technologies Limited',
    'Melody Events & Promotions Private Limited',
    'GLOBAL OPPORTUNITIES PRIVATE LIMITED',
    'AMANDLA SERVICES PRIVATE LIMITED',
    'AASH MARITIME SERVICES PRIVATE LIMITED',
    'GEEKS & BEASTS CONSULTING PRIVATE LIMITED',
    'Neo Universe Pharmaceuticals Private Limited',
    'VIN GRACE SOLUTIONS PRIVATE LIMITED',
    'DYWIDAG BRIDGECON INDIA PRIVATE LIMITED',
    'CARLTON LEISURE TRAVELS PRIVATE LIMITED',
    'NICE INDIA TOUR PRIVATE LIMITED',
    'Allied Grow Tech Solutions Private Limited',
    'Gerizim HR Solutions Private Limited',
    'Interglobal Capital Advisers Private Limited',
    'Cuberoot Technologies Private Limited',
    'SMITH & ARNER FACILITY SERVICES PRIVATE LIMITED',
    'SUNLIGHT FUELS PRIVATE LIMITED',
    'STRINGER MEDIA PRIVATE LIMITED',
    'Human Circle Enlightened Minds Private Limited',
    'Uber Latin Talents Private Limited',
    'TECHCONGLOMERATE PRIVATE LIMITED',
    'Charteredman Consulting Private Limited',
    'Startup Investments (Holding) Limited',
    'KAIROS KRIMSON PRIVATE LIMITED',
    'IT POWER PRIVATE LIMITED',
    'AVEENA COLD STORAGE PRIVATE LIMITED',
    'EXTENDED WARRANTY INDIA PRIVATE LIMITED',
    'AL KABIR SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'GOENKA ESTATES (DELHI) PRIVATE LIMITED',
    'INTEGRA PRODUCTS PRIVATE LTD.',
    'RUNEECHA FABRICS PRIVATE LIMITED',
    'American Express Business Solutions (India) Private Limited',
    'GPA 8OM INTERNET PRIVATE LIMITED',
    'Brand Conversations Private Limited',
    'Kaizen Supply Chain (India) Private Limited',
    'Angelheart Business Solutions Private Limited',
    'Cutting Edge Digital Private Limited',
    'DVS WORLDWIDE SERVICES PRIVATE LIMITED',
    'GAPESEED CONSULTING PRIVATE LIMITED',
    'STEPWHEEL OUTSOURCING PRIVATE LIMITED',
    'Experience Global Mobile Technologies Private Limited',
    'SnS Services & Solutions Private Limited',
    'CELESTIAL ELECTRICITY PRIVATE LIMITED',
    'JINDAL DEFENCE SOLUTIONS LIMITED',
    'YourKamaan Legal Solutions Private Limited',
    'TRANSPORT MITRA SERVICES PRIVATE LIMITED',
    'SoftAge Healthcare Private Limited',
    'ARCTURUS ENGINEERING PRIVATE LIMITED',
    'URJA GLOBAL LIMITED',
    'KWALITY LIMITED',
    'Pioneer Facility Management Limited',
    'Combat Industries Limited',
    'BRL Consulting Private limited',
    'PAHWA AUTOWORLD PRIVATE LIMITED',
    'MAHA GANESH FASHIONS PRIVATE LIMITED',
    'QUICKSHIP GLOBAL EXPRESS PRIVATE LIMITED',
    'INFINYPOOL ONLINE PAYMENT SOLUTIONS INDIA PRIVATE LIMITED',
    'KAG BAGS PRIVATE LIMITED',
    'K C TIMBER TRADERS PRIVATE LIMITED',
    'DIGIETS INDIA PRIVATE LIMITED',
    'FELIX GENERICS PRIVATE LIMITED',
    'ILS FOUNDATION',
    'AGILUS PATHLABS REACH LIMITED',
    'ARCHNA WADHWA GALLERY PRIVATE LIMITED',
    'KAP PLAST PRIVATE LIMITED',
    'NOBLE MOULDS PRIVATE LIMITED',
    'SPERRY PLAST LIMITED',
    'SUDEVA SPORTS PRIVATE LIMITED',
    'DAZZLING DESIGNS OPC PRIVATE LIMITED',
    'FASTLINE XPRESS WORLDWIDE (OPC) PRIVATE LIMITED',
    'MAPS TRAINING AND CORPORATE COACHING PRIVATE LIMITED',
    'SUNDSTRAND PAPERS & PACKAGING OPC PRIVATE LIMITED',
    'RINSTRUM SMART WEIGHING PRIVATE LIMITED',
    'GALLAY INDIA PRIVATE LIMITED',
    'UNIVERSAL TECH TRADE PRIVATE LIMITED',
    'Helios Precision Controls Private Limited',
    'ALE HOUSE PRIVATE LIMITED',
    'VANGUARD DIAGNOSTICS PRIVATE LIMITED',
    'ALLENGERS MEDICAL SYSTEMS LIMITED',
    'JS MOBILEON PRIVATE LIMITED',
    'Break Glass Ceiling Leadership Private Limited',
    'ANSH GLOBAL PRIVATE LIMITED',
    'INDIAN INSTITUTION OF ENGINEERS',
    'UNIQUE WELLNESS PRIVATE LIMITED',
    'Anondita Healthcare Products Private Limited',
    'Disruptive Health Solutions Private Limited',
    'JINDUS SPECIALTY CHEMICALS PRIVATE LIMITED',
    'LKS Home Making Solution Private Limited',
    'GRACURE PHARMACEUTICALS LIMITED',
    'ASPIRING BRAINS CONSULTING PRIVATE LIMITED',
    'A.L. INTERNATIONAL TRADEX PRIVATE LIMITED',
    'I Pack India Private Limited',
    'IHW MEDIA PRIVATE LIMITED',
    'Silversparro Technologies Private Limited',
    'RANOSON PRODUCTS PRIVATE LIMITED',
    'Lord Krishna Security Systems Private Limited',
    'VEWTRON INDIA ELECTRONICS PRIVATE LIMITED',
    'EMINENT AUTOPARTS PRIVATE LIMITED',
    'RIVA APPLIANCES PRIVATE LIMITED',
    'AVNG INFRASTRUCTURES PRIVATE LIMITED',
    'Xuark Technologies OPC Private Limited',
    'MERCURE HOSPITALITY PRIVATE LIMITED',
    'REALCASH TECHNOLOGIES LIMITED',
    'India Social Investment Ventures Private Limited',
    'MULTI MODAL OVERSEAS PRIVATE LIMITED',
    'CZECH AVIATION TRAINING CENTRE INDIA PRIVATE LIMITED',
    'UNITED ARTLOGISTICS INDIA PRIVATE LIMITED',
    'QSEAL AGRITECH PRIVATE LIMITED',
    'PRAKRITI AGRO PRODUCTS PRIVATE LIMITED',
    'JMV LOGISTICS PRIVATE LIMITED',
    'Antariksh Warehousing and Logistic Parks Private Limited',
    'MALLEKAN DAIRY AND AGRO PRIVATE LIMITED',
    'ARCLEY PRIVATE LIMITED',
    'COLORZ N STYLE PRIVATE LIMITED',
    'UBITHERA PHARMA PRIVATE LIMITED',
    'CONCORD MEDISYS PRIVATE LIMITED',
    'WILDLIFE EXPLORER INDIA PRIVATE LIMITED',
    'GREENZONE ENGINEERING PRIVATE LIMITED',
    'Tradine Commodities Private Limited',
    'SELFIN INDIA FINANCIAL SERVICES PRIVATE LIMITED',
    'POWERNAT EXPORTS PRIVATE LIMITED',
    'PRJ ELECTRONICS PRIVATE LIMITED',
    'ISS SUPPLIERS PRIVATE LIMITED',
    'OM BHAGWATI FINSERVE PRIVATE LIMITED',
    'CROWN GLOBAL TRADING PRIVATE LIMITED',
    'GLOBEIN TRADING PRIVATE LIMITED',
    'J H REALTECH PRIVATE LIMITED',
    'SHASTRA SECURITY PRIVATE LIMITED',
    'DEVASTRA ENTERPRISES PRIVATE LIMITED',
    'STIC MOULDS PRIVATE LIMITED',
    'INA ENERGY PRIVATE LIMITED',
    'YUVAN INFOMEDIA (OPC) PRIVATE LIMITED',
    'G-TECH INFO INDIA PRIVATE LIMITED',
    'DiCentre Technologies Private Limited',
    'Teleon Solutions Private Limited',
    'MRINC Business Private Limited',
    'GROVER BUILDWELL PRIVATE LIMITED',
    'ISHAR INFRATECH PRIVATE LIMITED',
    'DESTINASIA TOURS & TRAVEL PRIVATE LIMITED',
    'THOMAS GLOBAL LOGISTICS PRIVATE LIMITED',
    'Gomobile Tele Services Private Limited',
    'FONEBELL COMMUNICATIONS PRIVATE LIMITED',
    'Aakash Finsecure Private Limited',
    'FUNDREAMZ GLOBAL MARKETING PRIVATE LIMITED',
    'Oyster Learning Private Limited',
    'AccountSight Software Private Limited',
    'Shantipalace Hotels & Resorts Private Limited',
    'ERIKA BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'KALYAN INFRACON PRIVATE LIMITED',
    'SOLUZIONE IT SERVICES PRIVATE LIMITED',
    'GEOMIN INDUSTRIES PRIVATE LIMITED',
    'HUTECH TECHNOLOGIES PRIVATE LIMITED',
    'WINNER HOTELS PRIVATE LIMITED',
    'HILL ENERGY PRIVATE LIMITED',
    'TURNAROUND MANAGMENT CONSULTANTS PRIVATE LIMITED',
    'PICON INFOTECH PRIVATE LIMITED',
    'ROYAL GRAINS PRIVATE LIMITED',
    'PADMAVATI RETAIL (INDIA) PRIVATE LIMITED',
    'IMPEX CLEARING SERVICES PRIVATE LIMITED',
    'VVS DEVCON PRIVATE LIMITED',
    'TRIM LIFE INFRATECH LIMITED',
    'PUNIT ADVERTISING PRIVATE LIMITED',
    'Doshi Automobiles Private Limited',
    'BHAGAWATI GLOBUS PRIVATE LIMITED',
    'DBL SILWANI-SULTANGANJ TOLLWAYS PRIVATE LIMITED',
    'MONEY MAKER RESEARCH & INVESTMENT ADVISOR PRIVATE LIMITED',
    'FLIPCHIP ELECTRONICS PRIVATE LIMITED',
    'ICONIC ENVIROTECH PRIVATE LIMITED',
    'AC CORP PRIVATE LIMITED',
    'NEIIL LEARNING RESOURCES PRIVATE LIMITED',
    'MAPAEX GLOBAL PRIVATE LIMITED',
    'BIO MEDICAL SYSTEMS PRIVATE LIMITED',
    'Novel Exiccon Private Limited',
    'GEEK ONLINE VENTURES PRIVATE LIMITED',
    'AW TECHNOLOGIES PRIVATE LIMITED',
    'VEDANJAY POWER PRIVATE LIMITED',
    'BEE AAR CONTROLS & ENGINEERING PRIVATE LIMITED',
    'DB POWER (MADHYA PRADESH) LIMITED',
    'MERCURY MINES AND MINERALS PRIVATE LIMITED',
    'MOSAIC WORKSKILLS PRIVATE LIMITED',
    'K-LITE INDUSTRIES PRIVATE LIMITED',
    'Texmo Pipes and Products Limited',
    'BARWAHA PIPES PRIVATE LIMITED',
    'NEXT STEPS-MEDIA SOLUTIONS PRIVATE LIMITED',
    'SHREE NAKODA INFRASTRUCTURE PRIVATE LIMITED',
    'SAHIL INFRAREAL PRIVATE LIMITED',
    'F.K. INFRASTRUCTURE PRIVATE LIMITED',
    'CRESCENT PPG LINING PRIVATE LIMITED',
    'TANYA JEWELLERS PRIVATE LIMITED',
    'SURYAVANSHI MINERALS PRIVATE LIMITED',
    'Finextra Financial Consultants Private Limited',
    'VISHAL GS ENGINEERING AND ASSOCIATES PRIVATE LIMITED',
    'UNIKO PLAST PRIVATE LIMITED',
    'SHIKHAR HOUSING DEVELOPMENT PRIVATE LIMITED',
    'FRONTIER CARS (INDIA) PRIVATE LIMITED',
    'MAHUA HOTELS PRIVATE LIMITED',
    'GREEN EARTH POWER GENERATION PRIVATE LIMITED',
    'WALKOVER WEB SOLUTIONS PRIVATE LIMITED',
    'Abhishek Gang Management Services Private Limited',
    'SRL LOGISTICS PRIVATE LIMITED',
    'READS MAINTENANCE SERVICES PRIVATE LIMITED',
    'BALAJI NATH MEGA DEVELOPERS PRIVATE LIMITED',
    'AURUS NETWORK INFOTECH PRIVATE LIMITED',
    'FINCA LAND DEVELOPERS PRIVATE LIMITED',
    'DHANRAJ FOODS PRIVATE LIMITED',
    'VS ENVIROCARE PRIVATE LIMITED',
    'ECOKEM TECHNOLOGIES PRIVATE LIMITED',
    'RIDDHI SIDDHI SHIPPING PRIVATE LIMITED',
    'K. P. WOVEN PRIVATE LIMITED',
    'HILL POWER PRIVATE LIMITED',
    'SoftGrid Computers Private Limited',
    'NAMCO REALITY PRIVATE LIMITED',
    'EURO FORMULATIONS PRIVATE LIMITED',
    'ATHENA TRADEWINDS PRIVATE LIMITED',
    'ALLIANCE MEDITECH PRIVATE LIMITED',
    'RAJSHRI PLASTIWOOD PRIVATE LIMITED',
    'PRIMUS COMMERCIALS PRIVATE LIMITED',
    '6 DEGREES IT PRIVATE LIMITED',
    'SKGARG INFRACON PRIVATE LIMITED',
    'NAJMI HOUSING PROJECT PRIVATE LIMITED',
    'FUSION 3PL LOGISTIC PARK PRIVATE LIMITED',
    'KALYAN TOLL HIGHWAYS PRIVATE LIMITED',
    'INDUS EXIMTECH CHEMICALS PRIVATE LIMITED',
    'H CONCEPTS EDUCORP PRIVATE LIMITED',
    'SSG NAV-NIRMAN PRIVATE LIMITED',
    'Plastisack India Private Limited',
    'Unosack Flexible Packaging Private Limited',
    'VACCINE HOUSE INDIA PRIVATE LIMITED',
    'SOMDEEP CONSTRUCTIONS AND HOTELS PRIVATE LIMITED',
    'SIGMA PLASTOCHEM PRIVATE LIMITED',
    'Inventi Journals Private Limited',
    'TATMEEM PRIVATE LIMITED',
    'PENTAGON MEDIA PRIVATE LIMITED',
    'Indodyog Developers Private Limited',
    'NANDINEE CORPORATION PRIVATE LIMITED',
    'VIDUR AGRITECH PRIVATE LIMITED',
    'LUHADIYA SONS SHAHPURA PRIVATE LIMITED',
    'NAVYA SALES PRIVATE LIMITED',
    'BANSAL CONSTRUCTION WORKS PRIVATE LIMITED',
    'DELTA MINES PRIVATE LIMITED',
    'HEALTHICO QUALITY PRODUCTS PRIVATE LIMITED',
    'LE DIEU INSURANCE BROKERS PRIVATE LIMITED',
    'REFRACARE ENGINEERS PRIVATE LIMITED',
    'VISTAR VILLAS PRIVATE LIMITED',
    'FINXCESS OPPORTUNITY SERVICES PRIVATE LIMITED',
    'ITBIZCON PRIVATE LIMITED',
    'FACTORIAN LABS PRIVATE LIMITED',
    'ABHISHEK INFRACON PRIVATE LIMITED',
    'HOSPITALITY ESSENTIALS PRIVATE LIMITED',
    'BELKENN LOCO PARTS PRIVATE LIMITED',
    'Corporate developers (India) Private Limited',
    'BEYOND KEY SYSTEMS PRIVATE LIMITED',
    'SEOVALLEY SOLUTIONS PRIVATE LIMITED',
    'PARADIGM PRIME PRIVATE LIMITED',
    'MEDGEL PRIVATE LIMITED',
    'ARTH REAL DEVELOPERS (M. P.) PRIVATE LIMITED',
    'MARSHAL TEST LABS (INDORE) PRIVATE LIMITED',
    'SEASURE SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'DUKE THOMSONS INDIA PRIVATE LIMITED',
    'E-BIZ TECHNOCRATS PRIVATE LIMITED',
    'VISION INVEST TECH PRIVATE LIMITED',
    'Synergy Optic Private Limited',
    'SHAURYA BUILDCON PRIVATE LIMITED',
    'PM PROJECTS AND SERVICES PRIVATE LIMITED',
    'SAVIOUR CAPS PRIVATE LIMITED',
    'SUYASH COMMODITIES PRIVATE LIMITED',
    'NIDAN TECHNOLOGIES PRIVATE LIMITED',
    'ARYA ELECTRICALS(INDIA) PRIVATE LIMITED',
    'SKS FARMS AND HOTELS PRIVATE LIMITED',
    'AHILYA PAPERS PRIVATE LIMITED',
    'OMEGA MANUFACTURING COMPANY PRIVATE LIMITED',
    'MADHYA PRADESH AGRO FOOD INDUSTRIES LIMITED',
    'D P WIRES LIMITED',
    'ACME FABRIK PLAST PRIVATE LIMITED',
    'ASTHA CREDIT AND SECURITIES PRIVATE LIMITED',
    'HERBS AND HERBALS EXPORT PROMOTION ASSOCIATION OF INDIA',
    'KNC INTRADE PRIVATE LIMITED',
    'INDO THAI COMMODITIES PRIVATE LIMITED',
    'SIMTRAD OVERSEAS PRIVATE LIMITED',
    'IDEAVATE SOLUTIONS PRIVATE LIMITED',
    'TRAVEL INDIA TOURISM PRIVATE LIMITED',
    'RAGHUNANDAN INSURANCE BROKERS PRIVATE LIMITED',
    'SPLENDID TRADE LINK PRIVATE LIMITED',
    'CALDERYS INDIA REFRACTORIES LIMITED',
    'DCPL LIFE SCIENCE PRIVATE LIMITED',
    'MICRO INTEGRATED SEMICONDUCTORS SYSTEMS PRIVATE LIMITED',
    'ALOKIK ESTATE AND FINVEST PRIVATE LTD',
    'SHIVGANGA DRILLERS PRIVATE LIMITED',
    'SYSTEMATIX TECHNOLOGIES PRIVATE LIMITED',
    'DOSHI CONSULTANTS PRIVATE LIMITED',
    'Paper Trade Links Private Limited',
    'SURUCHI ELECTRONICS PRIVATE LIMITED',
    'DSP FINPRINT LIMITED',
    'DKG FINVEST PRIVATE LIMITED',
    'PRAKASH ASPHALTINGS AND TOLL HIGHWAYS (INDIA) LIMITED',
    'VYANKTESH CORRUGATORS PRIVATE LIMITED',
    'SHRIJI POLYMERS (INDIA) LIMITED',
    'DIABETES THYROID HORMONE RESEARCH INSTITUTE PRIVATE LIMITED',
    'WORTH PERIPHERALS LIMITED',
    'TDS Fincap Private Limited',
    'V & H FABRICATORS PRIVATE LIMITED',
    'PADMA HOMES PRIVATE LIMITED',
    'KALPATARU MULTIPLIER LIMITED',
    'D.S.C.TEXTILES PRIVATE LIMITED',
    'SITA SHREE FOOD PRODUCTS LIMITED',
    'SOJATIA AUTO PRIVATE LIMITED',
    'RAJWANI EXPORTS PRIVATE LIMITED',
    'DISA INFORMATIOIN SYSTEMS PRIVATE LIMITED',
    'CENTRONIX COMPUTERS PRIVATE LIMITED',
    'XTRANET TECHNOLOGIES PRIVATE LIMITED',
    'FXBYTES TECHNOLOGIES PRIVATE LIMITED',
    'MANJUL PUBLISHING HOUSE PRIVATE LIMITED',
    'MEXICAN AGRO CHEMICAL LIMITED',
    'SIMFA LABS PRIVATE LIMITED',
    'ALVEOR PLASTIC TECHNOLOGIES PRIVATE LIMITED',
    'MAHIMA FIBRES PRIVATE LIMITED',
    'NETLINK SOFTWARE GROUP PRIVATE LIMITED',
    'AVM INFOTECH (INDIA) PRIVATE LIMITED',
    'MADHURAM PULSES PRIVATE LIMITED',
    'SANDHYA SALES AGENCIES PRIVATE LIMITED',
    'MIRASH INFOTECH PRIVATE LIMITED',
    'NETWORK CARGO TOURS TRAVELS (INDIA) PRIVATE LIMITED',
    'DEFT ORGANICS LIMITED',
    'TEKNO SOLUTIONS PRIVATE LIMITED',
    'SHREEPATI PHARMACEUTICALS PVT LTD',
    'KHALSA FINVEST PRIVATE LIMITED',
    'SWAN ANGEL INVESTORS PRIVATE LIMITED',
    'ESPIC IMPEX PVT LTD',
    'DWARKA CASTINGS AND ENGINEERING PVT LTD',
    'RAIGARH ENERGY GENERATION LIMITED',
    'DAULAT RAM ENGINEERING SERVICES PRIVATE LIMITED',
    'REMEI INDIA LIMITED',
    'REXORT CONSULTANCY PRIVATE LIMITED',
    'BHARAT PETROPRODUCTS COMPANY PRIVATE LIMITED',
    'BONTON TECHNOMAKE PVT LTD',
    'AMG MANAGEMENT SERVICES PVT LTD',
    'RAVI SECURITY ORGANISATION PVT LTD',
    'PITHAMPUR POLY PRODUCTS LIMITED',
    'YASH TECHNOLOGIES PRIVATE LIMITED',
    'JVJ PHARMACEUTICALS PRIVATE LIMITED',
    'AKM WEALTH PRIVATE LIMITED',
    'EXCLUSIVE BROKING HOUSE LIMITED',
    'MANGLA ENGINEERING LIMITED',
    'INDUS EXIMTECH LIMITED',
    'RADHIKA SALES AND SAREES PRIVATE LIMITED',
    'DISTINCT AUTOMOBILES PVT LTD',
    'ASEEM TECHNOLOGIES PRIVATE LIMITED',
    'SARUPAM FINVEST PRIVATE LIMITED',
    'VELTRONICS SOFTWARE PRIVATE LIMITED',
    'SHUBHLAABH REAL ESTATE PRIVATE LIMITED',
    'CAPCO INDUSTRIES PRIVATE LIMITED',
    'CREDIBLE BUILDERS PRIVATE LIMITED',
    'AVAILABLE FINANCE LIMITED',
    'TRI STAR DECOR INDIA PRIVATE LIMITED',
    'CHITRA REALTORS AND SECURITIES PRIVATE LIMITED',
    'MANGLA ENTERPRISES PRIVATE LIMITED',
    'SIENA ENGINEERING PRIVATE LIMITED',
    'EXCLUSIVE SECURITIES LIMITED',
    'Jeskon Systems Private Limited',
    'DEEPESH FARMS & PLANTATIONS PRIVATE LIMITED',
    'MADHURI REFINERS PRIVATE LIMITED',
    'VIPPY SPIN PRO LIMITED',
    'ARIHANT CAPITAL MARKETS LIMITED',
    'BIRLA CABLE LIMITED',
    'BARWAHA AGRO PLANTATION PRIVATE LIMITED',
    'SAVITT UNIVERSAL LIMITED',
    'SHRI NARESH TECHNO PRIVATE LIMITED',
    'NITASHA TOURS AND TRAVELS PRIVATE LIMITED',
    'ESS BEE POLY TARPS PVT LTD',
    'MAHAVEER KRISHI KENDRA Private Limited',
    'Staqu Technologies Private Limited',
    'AGGREGATE INNOVATIONS PRIVATE LIMITED',
    'LIFE CARE HOSPITAL LIMITED',
    'Gadiel Technologies Private Limited',
    'Kairos Digital Private Limited',
    'CLASSIC FINANCE AND INVESTMENT PRIVATE LIMITED',
    'R S AGRO CHEMICALS PRIVATE LIMITED',
    'NAVRATAN TECHBUILD PRIVATE LIMITED',
    'MOENUS TEXTILE PRIVATE LIMITED',
    'QUANTALASE ENTERPRISES PRIVATE LIMITED',
    'SPUNDAN CONSULTANCY AND IT SOLUTIONS PRIVATE LIMITED',
    'KORRUN INDIA PRIVATE LIMITED',
    'N S MEDIA SOLUTIONS PRIVATE LIMITED',
    'India Insulation Private Limited',
    'PRABHAVI BIOTECH AND TRADING PRIVATE LIMITED',
    'DBL SARDARPUR BADNAWAR TOLLWAYS PRIVATE LIMITED',
    'S.S. AANGAN PRIVATE LIMITED',
    'TRAVANCORE FOODS INDIA PRIVATE LIMITED',
    'AARIKA HR PROFESSIONALS PRIVATE LIMITED',
    'KAMUTHI SOLAR POWER LIMITED',
    'RAMNAD SOLAR POWER LIMITED',
    'CLARIS CAPITAL LIMITED',
    'KRISHNA MUNSHI',
    'CHAMBER OF COMMERCE AND INDUSTRY',
    'AUCUPIA ONLINE SERVICES PRIVATE LIMITED',
    'PANDAVAAS CREATIONS PRIVATE LIMITED',
    'EPOWER VEHICLES PRIVATE LIMITED',
    'CRUISE TECHPLUS PRIVATE LIMITED',
    'AUSPICE TRANSITOS PRIVATE LIMITED',
    'CARTFACE TECHNOLOGIES PRIVATE LIMITED',
    'Mediatech Communication Private Limited',
    'SAI GURU MAHARASHTRA AGRO FOOD INDUSTRIES PRIVATE LIMITED',
    'LAMET PHARMA PRIVATE LIMITED',
    'iGrameen Mandi Private Limited',
    'BANDAI NAMCO INDIA PRIVATE LIMITED',
    'INNOVATIVE EXPLICATION PRIVATE LIMITED',
    'PLAYY INNOVATIONS PRIVATE LIMITED',
    'SAURANSH VANIJYA PRIVATE LIMITED',
    'MAGENTA BUILDERS PRIVATE LIMITED',
    'EMPACT SOLUTIONS PRIVATE LIMITED',
    'NETTARE BEVERAGES PRIVATE LIMITED',
    'ADKNOWLEDGE ASIA PACIFIC (INDIA) PRIVATE LIMITED',
    'Elders LifeCare Services Private Limited',
    'RELISH MERCANTILE PRIVATE LIMITED',
    'ARISER ENGINEERING PRIVATE LIMITED',
    'SM STAR HOLDINGS PRIVATE LIMITED',
    'ARUNIMA EVENT MANAGEMENT SERVICES PRIVATE LIMITED',
    'Pura Vida Sleep Solutions Private Limited',
    'FIN LABS AUDIO PRIVATE LIMITED',
    'Sambac eServices Private Limited',
    'DEWBERRY EXIM INDIA PRIVATE LIMITED',
    'CELLAR DOOR PRODUCTIONS PRIVATE LIMITED',
    'Sidqam Technologies Private Limited',
    'KRIMANSHI TECHNOLOGIES PRIVATE LIMITED',
    'ANZEN PROJECTS PRIVATE LIMITED',
    'VASUPRADA INTERNATIONAL PRIVATE LIMITED',
    'HAPPY 2 HELP U TECHNOLOGY PRIVATE LIMITED',
    'OMANA TRENDZ PRIVATE LIMITED',
    'LENNOX SOFTWARE PRIVATE LIMITED OPC',
    'Withwishes Retail Private Limited',
    'GLOBETEK INFOWAY PRIVATE LIMITED',
    'E.SELVAN TEXTILES PRIVATE LIMITED',
    'Indetools Private Limited',
    'ThinkInnov Solution Technologies Private Limited',
    'STARMILK PRODUCTS PRIVATE LIMITED',
    'ACE FASTENING SOLUTIONS PRIVATE LIMITED',
    'SIDNET MEDIA PRIVATE LIMITED',
    'LOGINWORKS SOFTWARES PRIVATE LIMITED',
    'TECHNICAL SPIRIT INFOSOLUTIONS PRIVATE LIMITED',
    'Cygnet Industries Limited',
    'HNG ENGINEERING ENTERPRISES PRIVATE LIMITED',
    'BRIX AND BEAMS REALTY PRIVATE LIMITED',
    'DAIRYLIKS NATURAL ICE CREAM PRIVATE LIMITED',
    'LUNETEK SOFTWARE PRIVATE LIMITED',
    'Ishagr Overseas Consultants Private Limited',
    'INNOVACCER TECHNOLOGIES PRIVATE LIMITED',
    'Aanandita Trends Private Limited',
    'Gravity Chick Farms Private Limited',
    'RIGHTLINK MANPOWER SOLUTIONS PRIVATE LIMITED',
    'GLORIOR BIOTECH PRIVATE LIMITED',
    'NAREENA LIFESCIENCES PRIVATE LIMITED',
    'SNOWDROP INFRACON PRIVATE LIMITED',
    'SOLID WASTE ENERGY PRIVATE LIMITED',
    'GLOBAL NANOTECH PRIVATE LIMITED',
    'Verveland Technologies Private Limited',
    'VYAPAARLIST INFO INDIA PRIVATE LIMITED',
    'TECHASTRUM IT SERVICES PRIVATE LIMITED',
    'SHREEGLOBAL LANDHOLDINGS PRIVATE LIMITED',
    'Go Tell Systems Private Limited',
    'AMAR INFRATRADE LIMITED',
    'PINKCITY TOURS & TRAVELS LIMITED',
    'DOMUS PLUSH SOLUTIONS PRIVATE LIMITED',
    'USHMA ELECTRO-TECH PRIVATE LIMITED',
    'WIN VISION EYE HOSPITALS PRIVATE LIMITED',
    'PRIMARC TOWER ASSOCIATION',
    'ACP Creations Private Limited',
    'CEED INDIA DEVELOPMENT PRIVATE LIMITED',
    'DCT INFOTECH PRIVATE LIMITED',
    'AKROS DESIGNS PRIVATE LIMITED',
    'DEPANSU SECURITIES (INDIA) PRIVATE LIMITED',
    'V.G.N. HOLDINGS PRIVATE LIMITED',
    'MODEL CHIT CORP LIMITED',
    'BHARATH CORP HOUSE LIMITED',
    'POKHRAN INVESTMENTS PRIVATE LIMITED',
    'IND-BARATH POWER INFRA LIMITED',
    'GEOSANSAR GLOBAL SOLUTIONS PRIVATE LIMITED',
    'EXDONO LTD',
    'BADJATE COMMODITIES PRIVATE LIMITED',
    'COMTRADE WEALTH MANAGEMENT PRIVATE LIMITED',
    'RAKINDO KOVAI TOWNSHIP Private Limited',
    'SATHYA STUDIOS PRIVATE LIMITED',
    'NATESAN PROPERTIES PRIVATE LIMITED',
    'SPACE SCAPE ESTATES PRIVATE LIMITED',
    'RAJDARBAR NINE VENTURES PRIVATE LIMITED',
    'RUNCHORDAS PVT LTD',
    'MEHTA AGENCIES Private Limited',
    'CELICA PROPERTIES PRIVATE LIMITED',
    'BANDHAN FINANCIAL SERVICES Limited',
    'ARTH CERAMICS Private Limited',
    'ORCHID NIKET PVT.LTD.',
    'LEELA ESTATES PVT.LTD.',
    'MINT ESTATES PVT.LTD.',
    'MAKSONS ESTATES PVT.LTD.',
    'MAKSONS BUILDERS PVT.LTD.',
    'MAPLE HOTELS & RESORTS Limited',
    'ASHIANA INFRASTRUCTURE DEVELOPMENTS PRIVATE LIMITED',
    'SANDEEPG. REALESTATE Limited',
    'BD VENTURES PRIVATE LIMITED',
    'JPS DEVELOPERS PRIVATE LIMITED',
    'SARLA INFRASTRUCTURE PRIVATE LIMITED',
    'CITYSCAPE DEVELOPERS PVT LTD',
    'TULLY PROPERTIES PVT.LTD.',
    'AGASTYA MICROTEK LIMITED',
    'SONUS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'AMILIONN TECHNOLOGIES PRIVATE LIMITED',
    'SMART ERP TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SWAJA LABS PRIVATE LIMITED',
    'NETENRICH TECHNOLOGIES PRIVATE LIMITED',
    'E2 LABS INFORMATION SECURITY PRIVATE LIMITED',
    'MEDISYS EDUTECH PRIVATE LIMITED',
    'WEST BENGAL TEXT BOOK CORPORATION LIMITED',
    'SURE INFOTECH PRIVATE LIMITED',
    'SKY COMPUSOFT COM PRIVATE LIMITED',
    'SANJAY SHELTERS PVT LTD',
    'TULSAN PROPERTIES Private Limited',
    'TURBO REALTORS PRIVATE LIMITED.',
    'RAJDARBAR HEIGHTS PRIVATE LIMITED',
    'Kredo Commercial Limited',
    'Kredo Venture Limited',
    'iMedX Information Services Private Limited',
    'AMALGAM KNOWLEDGE SERVICES PRIVATE LIMITED',
    'ATLURI TECHNOLOGIES PRIVATE LIMITED',
    'ZOOM VANIJYA PVT LTD',
    'JITF URBAN INFRASTRUCTURE LIMITED',
    'DIGISOURCE SOLUTIONS PRIVATE LIMITED',
    'ONV INDIA PRIVATE LIMITED',
    'ATRIBS SOFTWARE SYSTEMS PRIVATE LIMITED',
    'Dhyan Networks and Technologies Private Limited',
    'eQuadriga Software Private Limited',
    'HELPLINE SOLUTIONS PRIVATE LIMITED',
    'COMPUCRAFTERS SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'Hamon Research Cottrell India Private Limited',
    'SONIKS CONSULTING SERVICES PRIVATE LIMITED',
    'AVAR BUSINESS CONSULTING PRIVATE LIMITED',
    'MUTHA ONLINE MART PRIVATE LIMITED',
    'G14 RESEARCH LABS PRIVATE LIMITED',
    'MED-LINK COMPUTER SCIENCES (INDIA) PRIVATE LIMITED',
    'SpectraSoft Technologies Private Limited',
    'EAST VILLAGE TECHNOLOGIES PRIVATE LIMITED',
    'THICKDATA SOLUTIONS PRIVATE LIMITED',
    'VASONOMICS (INDIA) PRIVATE LIMITED',
    'POWER MECH PROJECTS LIMITED',
    'CRVJ INVESTMENT SERVICES PRIVATE LIMITED',
    'VOLIO TECHNOLOGIES LIMITED',
    'KAIROS CORPORATE SERVICES Limited',
    'ENTERSOFT INFORMATION SYSTEMS PRIVATE LIMITED',
    'SRS MANAGEMENT SERVICES PRIVATE LIMITED',
    'BrainWave Biotechnology Private Limited',
    'HARD SHELL TECHNOLOGIES PRIVATE LIMITED',
    'RAJDARBAR INFOTECH PRIVATE LIMITED',
    'EKDANT CONSULTANTS PRIVATE LIMITED',
    'ASSIGN TECHNOSOFT LIMITED',
    'KAUTILYA TECHNICAL SERVICES PRIVATE LIMITED',
    'KANAGIRI INFOTECH PRIVATE LIMITED',
    'GLOBAL DATAMART SYSTEMS INDIA PRIVATE LIMITED',
    'IGEN TECHNOLOGIES PRIVATE LIMITED',
    'TNBC DIGITAL (INDIA) PRIVATE LIMITED',
    'GENPACT INDIA PRIVATE LIMITED',
    'HINDUSTHAN VIDYUT CORPORATION LIMITED',
    'NAGAARJUNA SHUBHO GREEN TECHNOLOGIES PRIVATE LIMITED',
    'MS AGARWAL FOUNDRIES PRIVATE LIMITED',
    'MARUTI ISPAT & ENERGY PRIVATE LIMITED',
    'INDUS RENEWABLE ENERGY INDIA PRIVATE LIMITED',
    'Innovision Life Sciences Private Limited',
    'DICTASOL (INDIA) PRIVATE LIMITED',
    'EDMOND SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'KIMMAAYA BEVERAGES PRIVATE LIMITED',
    'ECOSMART COMMERCE PRIVATE LIMITED',
    'DONUM HEALTHCARE PRIVATE LIMITED',
    'SunBorne Energy Jaipur Solar Private Limited',
    'INTELLISOL INTEGRATED SERVICES PRIVATE LIMITED',
    'PENINSULAR ENGINEERING AND PROJECT CONSULTANTS PVT LTD',
    'NOVOTECH CLINICAL RESEARCH INDIA PRIVATE LIMITED',
    'NOWLAKHA PLASTIC PRIVATE LIMITED',
    'NORTH DELHI METRO MALL PRIVATE LIMITED',
    'NORTH EAST HOTELS PRIVATE LIMITED',
    'Posh Hospitality Private LImited',
    'NRA ESTATES PRIVATE LIMITED',
    'NORTH EASTERN CARRYING CORPORATION LIMITED',
    'NORTH END FOODS MARKETING PRIVATE LIMITED',
    'NSD PRINTERS PRIVATE LIMITED',
    'NORTH SOFTEK PRIVATE LIMITED',
    'NORTH STAR INDIA PVT LTD',
    'Birthright Games & Entertainment Private Limited',
    'NORTHERN AROMATICS LIMITED.',
    'RIVERDALE HOUSING PRIVATE LIMITED',
    'ROAD LINKS(INDIA)PRIVATE LIMITED',
    'JARAJ CONSULTANCY SERVICES PRIVATE LIMITED',
    'S.J MAX GOLDEN-KO LIMITED',
    'CITY LIFTS (INDIA) LIMITED',
    'PHARMACEUTICAL RESEARCH ASSOCIATES INDIA PRIVATE LIMITED',
    'NOUVELLE CREDITS PRIVATE LIMITED',
    'NOUVELLE OVERSEAS PRIVATE LIMITED',
    'NOVA ENERGY PVT LTD',
    'NOVA PADS PRIVATE LIMITED',
    'NOVEL BUILDMART PRIVATE LIMITED',
    'NUCLEUS SOFTWARE ENGINEERS PRIVATE LIMITED',
    'NUCLEUS SOFTWARE EXPORTS LIMITED',
    'NUCLEUS SOFTWARE LIMITED',
    'NUCLEUS SOFTWARE WORKSHOP PRIVATE LIMITED',
    'NOVEL HOUSING PRIVATE LIMITED',
    'NOVELTIES INTERNATIONAL PVT LTD',
    'VEDAMI CONSUMER CARE PRIVATE LIMITED',
    'SAT INDUSTRIES LIMITED.',
    'NUTAN GROWTH FUND PRIVATE LIMITED',
    'NUTAN UNIVERSAL ACADEMY PRIVATE LIMITED',
    'NUTECH JETTING EQUIPMENTS INDIA PRIVATE LIMITED',
    'NRN INFRABUILT PRIVATE LIMITED',
    'NUVISION AUTOTECH PRIVATE LIMITED',
    'Nuvo ChrysCapital Advisors Private Limited',
    'NRSS XXXI (B) TRANSMISSION LIMITED',
    'NSF Safety and Certifications India Private Limited',
    'NSTAR INTERACTIVE PRIVATE LIMITED',
    'SANDUR POWER COMPANY Private Limited',
    'SANFAB INDIA PRIVATE LIMITED',
    'NORTHERN INDIA BUILDERS PRIVATE LIMITED',
    'NYAS INFRABUILD PRIVATE LIMITED',
    'NYEQ TECHNOLOGIES PRIVATE LIMITED',
    'NYT NEWS BUREAU (INDIA) PRIVATE LIMITED',
    'O A COMPSERVE PRIVATE LIMITED',
    'NORTHERN TRADING PRIVATE LIMITED',
    'NORTHINDIA TOURISM PRIVATE LIMITED',
    'O.C.Tanner India Private Limited',
    'NORTHSTAR MANAGEMENT SERVICES PRIVATE LIMITED',
    'OASIS INTERNATIONAL PVT LTD',
    'OASIS REALTECH PRIVATE LIMITED',
    'NORTHSTAR TRADELINKS PRIVATE LIMITED',
    'NORTHWIRE TRIPLEX PVT LTD',
    'NTS COMPUTERS PRIVATE LIMITED',
    'NTS GLOBAL SERVICES PRIVATE LIMITED',
    'NU GAS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NUCLEION RISK CONSULTING PRIVATE LIMITED',
    'NUCON METALS PRIVATE LIMITED',
    'NUMBER ONE EXPORTS PRIVATE LIMITED',
    'OH TRAVEL EXPERIENCES PRIVATE LIMITED',
    'NUOVO ACCESSORIES PRIVATE LIMITED',
    'NUPUR ENGINEERING PRIVATE LIMITED',
    'NUTEK OVERSEAS PRIVATE LIMITED',
    'ASAGO CONSULTANTS & TRADING PRIVATE LIMITED',
    'ORANGE GOAT CONSULTANTS AND MARKETING PRIVATE LIMITED',
    'OM AUTO TRADING PRIVATE LIMITED',
    'OM CARRYING CORPORATION LIMITED',
    'NVS BUILDERS PRIVATE LIMITED',
    'OM NANOTECH PRIVATE LIMITED',
    'OM PRAKASH BALDEV KRISHAN ENGINEERS CONTRACTORS PRIVATE LIMITED',
    'NWCC LOGISTICS PRIVATE LIMITED',
    'NWCC RETAIL SUPPLY SOURCING SOLUTIONS PRIVATE LIMITED',
    'NWCC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'TSR DARASHAW Limited',
    'SCHNEIDER ELECTRIC PRESIDENT SYSTEMS LIMITED',
    'HARMONY INVESTMENTS PVT LTD',
    'Omega IceHill Private Limited',
    'OMEGA INFO PROJECTS PRIVATE LIMITED',
    'Accura Recruiters Private Limited',
    'O P B K CONSTRUCTIONS PRIVATE LIMITED',
    'O P K WOOLLEN MILLS PVT LTD',
    'OMNI MARG TRAVELS PRIVATE LIMITED',
    'INDENTA CHEMICALS (INDIA) PRIVATE LIMITED',
    'Omnivore Capital Management Advisors Private Limited',
    'Oakridge Energy Private Limited',
    'ON-DOT COURIERS AND CARGO LIMITED',
    'NTP TOURISM AFFAIRS LIMITED',
    'OCTAGON ESTATES PRIVATE LIMITED',
    'ONE HEIGHT COLONIZERS PRIVATE LIMITED',
    'ONE LIFE EVENTS PRIVATE LIMITED',
    'OCUS HOSPITALITY PROJECTS PRIVATE LIMITED',
    'OGAAN CANCER FOUNDATION',
    'OGAAN INDIA PRIVATE LIMITED',
    'Ogaan Media Private Limited',
    'OHMI INDUSTRIES ASIA PRIVATE LIMITED',
    'ONIONS CREATIVE MEDIA PRIVATE LIMITED',
    'ONKAR INFOTECH PRIVATE LIMITED',
    'ONS SNACKS PRIVATE LIMITED',
    'OJASVI INVESTMENT AND MERCANTILE COMPANY',
    'OKUMA INDIA PRIVATE LIMITED',
    'OLIVE GLOBAL HOLDINGS PRIVATE LIMITED',
    'OLYMPUS INDUSTRIES PRIVATE LIMITED',
    'OM GANPATI MARKETING PRIVATE LIMITED',
    'OM SHAILSHUTA LOGISTICS PRIVATE LIMITED',
    'GREENKO BERCHA WIND POWER PRIVATE LIMITED',
    'Adsila Builders & Developers Private Limited',
    'ADVENT PROPINVEST MANAGEMENT (INDIA) PRIVATE LIMITED',
    'Adventure Marketing Private Limited',
    'ADVENTURE WORLD ( INDIA) PRIVATE LTD',
    'ADTEL INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'Advance Contributors Private Limited',
    'Advocaci Marketing Private Limited',
    'ADVANCED APPLIANCES PVT. LTD.',
    'POORAM FINSERV PRIVATE LIMITED',
    'PUSHPANJALI CAPS PRIVATE LIMITED',
    'PVR MULTIMEDIA PRIVATE LIMITED.',
    'PVS MARKETING & PROPMART PRIVATE LIMITED',
    'Qabil Builders & Developers private Limited',
    'AERIE PROPERTIES PRIVATE LIMITED',
    'AERO CHARTER SERVICES INDIA PRIVATE LIMITED',
    'AERO CLUB OF INDIA',
    'AERO FABS PRIVATE LIMITED',
    'AERO FOOTWEAR COMPONENTS PRIVATE LIMITED',
    'AERO LEATHER PRIVATE LIMITED',
    'QEJ ELECTRONICS INTERNATIONAL PRIVATE LIMITED',
    'AERONET TRAVTOUR PRIVATE LIMITED',
    'AEROSTAR AVIATION PRIVATE LIMITED',
    'AEROTECH INDIA PRIVATE LIMITED',
    'AES CHHATTISGARH ENERGY PRIVATE LIMITED',
    'AES INDIA PRIVATE LIMITED',
    'QIAGEN INDIA PRIVATE LIMITED',
    'QSR EXPORTS PRIVATE LIMITED',
    'QSS INVESTORS PRIVATE LIMITED',
    'QTEL COMTECH LIMITED.',
    'QUALIKEMS LIFESCIENCES PRIVATE LIMITED',
    'QUALITY AGRI FARMS PRIVATE LIMITED',
    'QUALMARK SOFT SOLUTION ARCH PRIVATE LIMITED',
    'AG CRITIMED SYSTEMS AND SERVICES PRIVATE LIMITED',
    'AG FURNACE IMPROVEMENTS PRIVATE LIMITED',
    'AGA KHAN AGENCY FOR HABITAT INDIA',
    'AGA KHAN RURAL SUPPORT PROGRAMME (INDIA)',
    'QUANTM LIMITED',
    'QUANTX TECHNOLOGY PRIVATE LIMITED',
    'ADITYA PROMOTERS LIMITED.',
    'ADM ESTATES PRIVATE LIMITED',
    'QUEST SECURITIES LIMITED',
    'ADVERTISING AND DISPLAY SERVICES (INDIA) PRIVATE LIMITED',
    'AGROW ALLIED VENTURES PRIVATE LIMITED',
    'AGS BUILDTECH PRIVATE LIMITED',
    'ADVITIYA INFOSYSTEMS PRIVATE LIMITED',
    'R B KISSAN KENDRA PRIVATE LIMITED',
    'ADWET WAREHOUSING PRIVATE LIMITED',
    'R C K LEASING AND FINANCING PRIVATE LIMITED',
    'ADWORLD GRAPHICS PRIVATE LIMITED',
    'R K AND COMPANY MANPOWER PRIVATE LIMITED',
    'AE ABRASIVES EDGE PRIVATE LIMITED',
    'AEC DIGITAL STUDIO PRIVATE LIMITED',
    'Aeon India Consulting Private Limited',
    'R K GLOBAL INSURANCE BROKERS LIMITED.',
    'R K GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'R K GLOBAL TOURS & TRAVELS PRIVATE LIMITED',
    'R K IMPORT PRIVATE LIMITED',
    'AEQUOR INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'R K S (INDIA) PVT LTD',
    'AEROL FORMULATIONS PRIVATE LIMITED',
    'R L K L JEWELS PRIVATE LIMITED',
    'R L TRAVELS PRIVATE LIMITED',
    'AEY JEY EQUIPMENTS PRIVATE LIMITED',
    'AFA EXPORTS PRIVATE LIMITED',
    'Afaaf Builders & Developers Private limited',
    'AFFITO GAS PRIVATE LIMITED',
    'DREAMS FOAM PRODUCTS PRIVATE LIMITED',
    'R P FOAM HOME PVT LTD',
    'AFM INDIA LIMITED',
    'AFSAN HEALTH RESORT PRIVATE LIMITED',
    'AG BUILDWELL PRIVATE LIMITED',
    'AHUJASONS SHAWLWALE PRIVATE LIMITED',
    'AGENCY 18 MARKETING PRIVATE LIMITED',
    'AGGARWAL & AGGARWAL FINANCIAL MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'QUICK FOREX LIMITED',
    'AIMIL PHARMACEUTICALS(INDIA) LIMITED',
    'QUICK GRAPHICS PRIVATE LTD',
    'AIR CHARTER SERVICES PRIVATE LIMITED',
    'AI AIRPORT SERVICES LIMITED',
    'AIR INDIA LIMITED',
    'Air India SATS Airport Services Private Limited',
    'YATRA FOR BUSINESS PRIVATE LIMITED',
    'ADVENT CORPORATE SERVICES PRIVATE LIMITED',
    'AHLCON READY MIX CONCRETE PRIVATE LIMITED',
    'R B RAMNATH LAMBAH AND SONS PRIVATE LIMITED',
    'AIREF ENGINEERS PRIVATE LIMITED',
    'R D DUTTA AND CO PRIVATE LIMITED',
    'R K ENGINEERING COMPANY PVT LTD',
    'R K GLOBAL COMMODITY BROKING LIMITED',
    'R K GLOBAL IMPEX LIMITED.',
    'R K PROJECTS PRIVATE LIMITED',
    'R L AVIATION SERVICES PRIVATE LIMITED',
    'R M E-SERVICES PRIVATE LIMITED',
    'R N GUPTA WELL EQUIPMNTS PVT LTD',
    'R N INTERCON INFRASTURCTURE PRIVATE LIMITED',
    'R N POLY PLAST PRIVATE LIMITED',
    'R P MALHAN & COMPANY CONSULTANTS PRIVATE LIMITED',
    'POPULAR VEHICLES AND SERVICES LIMITED',
    'AJAX INDUSTRIAL PRODUCTS PRIVATE LIMITED',
    'AJAY READYMADES PRIVATE LIMITED',
    'AJAY TRAVELS PRIVATE LIMITED',
    'DRAGON MARITIMO PRIVATE LIMITED',
    'AHUJA BOOK COMPANY PRIVATE LIMITED.',
    'AIDEQUATE INDIA PRIVATE LIMITED',
    'AIE APPAREL PRIVATE LIMITED',
    'AIM ADVISORY SERVICES PRIVATE LIMITED',
    'AGGARWAL GUPTA CONSTRUCTIONS PRIVATE LIMITED',
    'SOFTBAY TECHNOLOGIES PRIVATE LIMITED',
    'AMERICAN HOTELS AND RESTAURANTS PRIVATE LIMITED',
    'BERRY TRADECHEM PRIVATE LIMITED',
    'BERRYS AUTO ANCILLARIES PRIVATE LIMITED',
    'WALTER BUSHNELL LIFE CARE PRIVATE LIMITED',
    'AMIT AGRO TRADE PRIVATE LIM ITED',
    'AMIT APARTMENTS LTD',
    'AMIT INVESTMENTS PRIVATE LIMITED',
    'BEHARI LAL DARSHAN LAL PRIVATE LIMITED',
    'BEI CONFLUENCE COMMUNICATION LIMITED',
    'Sudhir Technologies Private Limited',
    'BEST VALUE BUILDCON PRIVATE LIMITED',
    'BESTOCHEM FORMULATIONS (INDIA) LIMITED',
    'BELA ENGINEERS LIMITED',
    'BETTEROPTION ESTATES PRIVATE LIMITED',
    'BETUL WIND FARMS PRIVATE LIMITED',
    'Belkin India Private Limited',
    'BELLANCA BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'BEACON COURIER AND CARGO INDIA PRIVATE LIMITED',
    'BEAUTE ESPACE MEDIA PRIVATE LIMITED',
    'BGA VOCATIONAL STUDIES PRIVATE LIMITED',
    'Bechtel Engineering and Construction India Private Limited',
    'BECHTEL INDIA PRIVATE LIMITED',
    'Bhagat General Cyber Private Limited',
    'BEDI EXPORTS PRIVATE LIMITED',
    'BHAGVATI ELECTRONICS PRIVATE LIMITED',
    'Bhagwati Bardana Trading Private Limited',
    'BHAGWATI SOFTECH PRIVATE LIMITED',
    'ANA CNG STATION PRIVATE LIMITED',
    'ANACRA MERCHANDISE PRIVATE LIMITED',
    'BEETA ESTATES PRIVATE LIMITED',
    'BEETA INFOCOM PRIVATE LIMITED',
    'ANAISHA BUILDCON PRIVATE LIMITED',
    'BEHARI LAL BENI PERSHAD EXPORTS AND IMPORTS PRIVATE LIMITED',
    'Best General Insurance Company Limited',
    'ANAND BUILDWAY PRIVATE LIMITED',
    'BEST HEALTHCARE PRIVATE LIMITED',
    'ANANDA KRISHNA INFRADEVELOPMENT PRIVATE LIMITED',
    'ANANDESHWAR JEWELLERS PRIVATE LIMITED',
    'ANANDMAY PROMOTERS PRIVATE LIMITED',
    'ANANNYA INFRABUILD PRIVATE LIMITED',
    'ANANT COLD STORAGE PRIVATE LIMITED',
    'ANANT ETHNIC WEARS PRIVATE LIMITED',
    'ANANT EXIM PRIVATE LIMITED',
    'Anant Healthcare Technology Solutions Private Limited',
    'ANANT RAJ CONS. & DEVELOPMENT PRIVATE LIMITED',
    'ANANT RAJ FARMS PRIVATE LIMITED',
    'ANANT RAJ HOTELS PRIVATE LIMITED',
    'ANANT RAJ HOUSING LIMITED',
    'BETA FINANCE AND TRADING PRIVATE LIMITED',
    'BG INDIA ENERGY PRIVATE LIMITED',
    'BG INDIA ENERGY SERVICES PRIVATE LIMITED',
    'ANCHAL FINTRADE PRIVATE LIMITED TRS.FROM W.B',
    'BG INDIA ENERGY SOLUTIONS PRIVATE LIMITED',
    'BELWAL HOTELS LIMITED',
    'ANEST IWATA MOTHERSON Private Limited',
    'ANF 360 DESIGN PRIVATE LIMITED',
    'ANFILCO LIMITED',
    'AGTEC INDUSTRIES PRIVATE LIMITED',
    'BELWAL SPINNING MILLS LIMITED',
    'ANGEL ADMARK PRIVATE LIMITED',
    'ANGEL BOOK HOUSE PRIVATE LIMITED',
    'BG LNG REGAS INDIA PRIVATE LIMITED',
    'ANGEL TOWN PLANNERS PRIVATE LIMITED',
    'ANGELANTONI TEST TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SONIR JEWELS PRIVATE LIMITED',
    'Bend It like Anglian',
    'Bennett Broadcasting & Distribution Services Limited',
    'ANI MEDIA PRIVATE LIMITED',
    'Benseron Information Technologies India Private Limited',
    'BEOWORLD PRIVATE LIMITED',
    'BERGEN SYSTEMS PRIVATE LIMITED',
    'BERVIN INVESTMENT AND LEASING LIMITED',
    'ANJANI REALTORS PRIVATE LIMITED',
    'Best Aromatics Limited',
    'BEST BROADCASTING COMPANY LIMITED',
    'ANKA EXPORTS PRIVATE LIMITED',
    'BEST BUILDTECH PRIVATE LIMITED',
    'ANNA ENTERPRISES PRIVATE LIMITED',
    'ANNAPURNA STEELS Private Limited',
    'Annex Finsolutions Private Limited',
    'ANAND PULP IMPEX PRIVATE LIMITED',
    'BHALLA TECHTRAN INDUSTRIES LTD',
    'ROCKFIELD HOMES PRIVATE LIMITED',
    'ANANTA GROUP PRIVATE LIMITED',
    'ANBROS H0LDINGS PRIVATE LIMITED',
    'BHARAT HOTELS LIMITED',
    'Bestscribe transcription private limited',
    'MRCC TRANSFORMATION SOLUTIONS PRIVATE LIMITED',
    'Fidelity information services india private limited',
    'Trusted info systems private limited',
    'Mindworks global media services private limited',
    'Fis payment solutions & services india private limited',
    'Express infocom private limited',
    'Mosaic ites services private limited',
    'Xceed i t solutions private limited',
    'D.j.a. impex private limited',
    'Puri software solutions private limited',
    'Ha softech private limited',
    'Modern ultra home solutions private limited',
    'Progneur technologies private limited',
    'Yukti solutions private limited',
    'Unitech commercial and residential properties private limited',
    'Sanjeevani infrabuild private limited',
    'Cig unitech realty ventures private limited',
    'Cig unitech real estate ventures private limited',
    'JBM PROPERTIES PRIVATE LIMITED',
    'Aller properties private limited',
    'Sumologic technologies private limited',
    'Ideus concepts information technologies private limited',
    'Sanskrut software systems pvt ltd',
    'Desh infotech private limited',
    'Zepher infotech private limited',
    'E-connect management services private limited',
    'Angul properties private limited',
    'Elbe builders private limited',
    'Erode projects private limited',
    'IKRAFT ENGINEERS INDIA PRIVATE LIMITED',
    'GENESIS IT INNOVATIONS PRIVATE LIMITED',
    'Compusol software private limited',
    'Softspace network private limited',
    'Agent technologies software private limited',
    'WAISL LIMITED',
    'Iiht technologies private limited',
    'Manipal business solutions private limited',
    'Urbangreen developments private limited',
    'Caspiadew it innovations private limited',
    'Hashroot technologies private limited',
    'Techversant infotech private limited',
    'Shree lekha apartments pvt. ltd.',
    'Ramray. com private limited',
    'Dialogic networks (india) private limited',
    'Prodigy infomatics private limited',
    'Vu technologies private limited',
    'NEMHANS SOLUTIONS PRIVATE LIMITED',
    'Andolasoft (india) private limited',
    'JPJ PROPERTIES PRIVATE LIMITED',
    'PIN POINT CONSTRUCTION & INVESTMENT COMPANY PVT. LTD.',
    'N.s. prometers pvt. ltd.',
    'Unitech samus projects private limited',
    'Smart softtech solutions private limited',
    'Brilliant info systems private limited',
    'Xanadutec data solutions private limited',
    'Whitehedge technologies private limited',
    'Practice consulting institute private limited',
    'Indiaproperties.com private limited',
    'Pinnacle infosolutions private limited',
    'Zentest software private limited',
    'NIFA INFOCOMP SERVICES PRIVATE LIMITED',
    'All cad services private limited',
    'Natural support consultancy services private limited',
    'Umang apartments pvt.ltd.',
    'Nleague technologies private limited',
    'Factor h software solutions private limited',
    'Shah housing stones pvt.ltd.',
    'Frizcon real estate private limited',
    'Reyna infracon private limited',
    'Wrightspaces india private limited',
    'Atma realty management services private limited',
    'Ambakeshwar realtors private limited',
    'Jkm projects private limited',
    'Bridge itech systems private limited',
    'Raas intratech private limited',
    'Arjava advisors private limited',
    'Naturon healthcare limited',
    'Laghu udyog bharati',
    'HAMSTECH INDIA LIMITED',
    'Indcon boilers limited',
    'Segen systems private limited',
    'Dr maths private limited',
    'Ha educational academy private limited',
    'Sa educational systems private limited',
    'Forum project holdings private limited',
    'Crealent education management services private limited',
    'Virtue international private limited',
    'Silurian tech private limited',
    'Netware fibretech private limited',
    'Alchemist asset reconstruction company limited',
    'Maruhatsu exporters (india) private limited',
    'Ki thomas educational consultants private limited',
    'Vortex international private limited',
    'Samson controls private limited',
    'Alpha flock (india) pvt ltd',
    'Mitra technology foundation',
    'Oriana advisors private limited',
    'Indomer coastal hydraulics private limited',
    'Lbs academy international private limited',
    'Modwin networks private limited',
    'Rupal leminates limited',
    'Fumigation services private limited',
    'Campus eai india private limited',
    'RIRA E-VEHICLES PRIVATE LIMITED',
    'Jacobi carbons india private limited',
    'Munjal hydro power private limited',
    'Hanumant atelier private limited',
    'STORMEDUGO CONSULTING INDIA PRIVATE LIMITED',
    'Dnyansadhana pratishthan educational institution',
    'Bips educational & social foundation',
    'Excel educare private limited',
    'Tringula online education private limited',
    'Dreamz mount consultant private limited',
    'DAKSH HEALTHCARE PRIVATE LIMITED',
    'Dileep lifestyle private limited',
    'ATOS SYNTEL PRAYAS FOUNDATION',
    'Howrah sarvasiksha foundation',
    'CELLUGEN BIOTECH PRIVATE LIMITED',
    'Nuova manaro aviation refueling equipments ( india ) private limited',
    'M. pallonji logistics private limited',
    'A.S.K.BROTHERS .PRIVATE LIMITED',
    'Dtdc express limited',
    'M.s. ramaiah investments and properties private limited',
    'MURUDESHWAR POWER CORPORATION PRIVATE LIMITED',
    'Mahindra hotels and resorts limited',
    'Garcicon (india) private limited',
    'NABFINS LIMITED',
    'Vikram hospital private limited',
    'V s d medical solution private limited',
    'Fashion factory design and art institute private limited',
    'Kapp edge solutions private limited',
    'Smaran vocational education private limited',
    'Suraksha diagnostic & eye centre private limited',
    'AMBUJA NEOTIA HEALTHCARE VENTURE LIMITED',
    'Star dental centre private limited',
    'Impel dental private limited',
    'Advanced lifesciences private limited',
    'Wellscience health private limited',
    'Ranchi information technology centre private limited',
    'ARTELIA NAMASTE LIMITED',
    'Khaitan eduserve private limited',
    'Nitara india private limited',
    'H.g. accessories private limited',
    'LUMENS LEATHERS INDIA PRIVATE LIMITED',
    'Ferrero vinyl technologies private limited',
    'Bang papers private limited',
    'Levcon jaykay machinery pvt. ltd.',
    'My inbox media private limited',
    'Kasturilal harlal ltd.',
    'Jng chemicals private limited',
    'Adi bpo services limited',
    'Regal carpets private limited',
    'Rishi securities & finance pvt ltd',
    'Ultracon infrachem private limited',
    'Marc surface coatings private limited',
    'Soneka chemicals private limited',
    'Medgensys laboratories private limited',
    'ROOPAM FASHIONS PRIVATE LIMITED',
    'Graphic reproduction syndicate private limited',
    'A r sulphonates private limited',
    'Gujarat cheminex limited',
    'Adi media private limited',
    'SHREE RAM GUMS PRIVATE LIMITED',
    'Axalta coating systems india private limited',
    'Orange bio science products private limited',
    'Pulsar chem private limited',
    'Colour complex pvt ltd',
    'Relax biotech private limited',
    'John oil and gas ltd',
    'Archana press private limited',
    'Kesari kuteeram private limited',
    'Wimbledon publishing company india private limited.',
    'Indian progressive publishing co pvt ltd',
    'D.c.books private limited',
    'Pharmaffiliates analytics and synthetics private limited',
    'Oxypal labs private limited',
    'KRITICAL MEDICAL HELP PRIVATE LIMITED',
    'Sree narasimha textiles private limited',
    'R.g. scientific enterprises private limited',
    'Precept pharma limited',
    'Vipal health care private limited',
    'Divine international private limited',
    'CG ADHESIVE PRODUCTS LIMITED',
    'Itspossible nutraceuticals limited',
    'Green books private limited',
    'ADVERTISER',
    'REALTOR PVT LTD',
    'Cochin share registry and software consultants pvt ltd',
    'Edstem technologies private limited',
    'Arihant realcon private limited',
    'Dhanvijay realtors private limited',
    'Alkyone realtors private limited',
    'Gepdec infratech limited',
    'Indus urban infrapark private limited',
    'OPTIMAX ACES PRIVATE LIMITED',
    'HRH NEXT SERVICES LIMITED',
    'Mgc infratech private limited',
    'Greenfield software private limited',
    'Sukhsagar infotech pvt ltd',
    'Msr it solution pvt ltd',
    'Peopleconnect solutions private limited',
    'Harita housing constructions limited',
    'Aradhana multimax ltd',
    'Atash properties & finance pvt ltd',
    'S b nirman private limited',
    'J.c. developers private limited',
    'Riverside resorts and holiday homes private limited',
    'Hazaribagh coal syndicate pvt ltd',
    'E SQUARE SYSTEM & TECHNOLOGIES PRIVATE LIMITED',
    'Cris tech (india) private limited',
    'Satelite compusoft private limited',
    'Exotica it and projects private limited',
    'Tpf technologies private limited',
    'Simtron software private limited',
    'Substratal solutions private limited',
    'Earthcon systems india private limited',
    'Dci pharmaceuticals private limited',
    'Maksons fine chem private limited',
    'Pnp and associates private limited',
    'Hindustan antibiotics limited',
    'SANMAR SHIPPING LIMITED',
    'Sanya pharma private limited',
    'Mahalasa polyplast private limited',
    'MYKRON PLUS INDIA PRIVATE LIMITED',
    'Ur1 india private limited',
    'Shiv narian periwal & sons private limited',
    'ISCON SURGICALS LIMITED',
    'Apex healthcare limited',
    'Inventive packaging private limited',
    'Stadmed pvt ltd',
    'Ksp fibre products private limited',
    'YORK PRINT & PACK PRIVATE LIMITED',
    'Indian core oils private limited',
    'Glosil international private limited',
    'Hovid life science private limited',
    'Picadelly trans logistics private limited',
    'Charkha detergents and soap enterprises private limited',
    'Shantinath detergents private limited',
    'Mathabhanga detergents & chemicals private limited',
    'Sookias international pvt ltd',
    'Abr petro products ltd',
    'Narsipur chemicals p ltd',
    'Vetrivel explosives private limited',
    'Unitech business parks limited',
    'Shiv petro products private limited',
    'Multi chemical industries pvt ltd',
    'Saurashtra solid industries private limited',
    'SANOH INDIA PRIVATE LIMITED',
    'Alstone industries private limited',
    'Safeguard contraceptives private limited',
    'Vania furniture private limited',
    'ALBGARN MICRONUTRIENTS PRIVATE LIMITED',
    'Neelima synthetics private limited',
    'Satara polymers pvt ltd',
    'Swasti chem private limited',
    'Royal plastocraft private limited',
    'VIVA PACK PRIVATE LIMITED',
    'SHAKTI FINE ORGOCHEM PRIVATE LIMITED',
    'Shiva analyticals (india) private limited',
    'Raj & ranji coal private limited',
    'Smg plastics private limited',
    'Muskaan rotopack private limited',
    'HARTMANN INDIA LIMITED',
    'Yash precision plastics private limited',
    'Jindal industries private limited',
    'Speculum plast private limited',
    'Sequoia safety products private limited.',
    'Kirti gold limited',
    'Indobell insulations ltd',
    'PACIFIC NANO PRODUCTS INDIA PRIVATE LIMITED',
    'Safetech safety solutions private limited',
    'Nityanand udyog private limited',
    'Vijosh garments private limited',
    'Sumangala steel private limited',
    'Harsh spring company pvt ltd',
    'Amiya steel private limited',
    'Avtar steel limited',
    'Copco india limited.',
    'Dhaaturuttama minerals and alloys private limited',
    'Madani salt works private limited',
    'Tawakkal salt works private limited',
    'SAGACIOUS CAPITAL PRIVATE LIMITED',
    'AAKAR ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'VIBHOR STEEL TUBES LIMITED',
    'SURANA WIRES PVT LTD,',
    'Calcast steel ltd.',
    'GOLDENCROSS PHARMA LIMITED',
    'Uni world pharma private limited',
    'Deorala home products private limited',
    'Ssf cosmetics (herbal) private limited',
    'Baroda copper tubes pvt ltd',
    'H AND H MECHTECH PRIVATE LIMITED',
    'Namoha foundries pvt ltd',
    'Jimmi resorts private limited',
    'Hitemp filters private limited',
    'A.t. plastotech private limited',
    'Evergood agro industries limited',
    'VRUNDA VITTHAL POLYNET LIMITED',
    'Sash logistics and travels private limited',
    'Arsh india company pvt ltd',
    'AJAY INDUSTRIAL PACKAGINGS PRIVATE LIMITED',
    'SHRI BAJRANG AGRO PROCESSING LIMITED',
    'Mascot forge pvt ltd',
    'Actor rotex controls private limited',
    'Gourav industries building systems private limited',
    'Dimple bags and synthetics private limited',
    'Hi-tech induction private limited',
    'Universal machines ltd',
    'Micro labs limited',
    'Mac master tools private limited',
    'Svs metals private limited',
    'Espee enterprises pvt ltd',
    'Reliable fasteners pvt ltd',
    'Push-up tools udyog pvt ltd',
    'Naini exports private limited',
    'Mint life sciences private limited',
    'Vee excel drugs and pharmaceuticals private limited',
    'CIPLA PHARMA AND LIFE SCIENCES LIMITED',
    'Everest castings pvt ltd',
    'Swastik plaschem private limited',
    'Sterling ferro alloys pvt ltd',
    'Shree nakoda ispat limited',
    'Hobb international pvt.ltd.',
    'Jtc hydrolines private limited',
    'Vikas equipments (india) private limited',
    'Shri laxmi udyog pvt ltd',
    'Sunusa industries private limited',
    'J MAX FOOD PROCESS SOLUTIONS PRIVATE LIMITED',
    'Arya oilfield services private limited',
    'Floral finance private limited',
    'Valar vikas chits private limited',
    'R.s. credits pvt. ltd.',
    'Lsi financial services private limited',
    'Sushil insurance brokers private limited',
    'ANCHOR RESIDENT',
    'S MEDICAL AESTHETICS PRIVATE LIMITED',
    'Om wellness private limited',
    'PRAYUKTA FOR PROMOTING HEALTH PRIVATE LIMITED',
    'Dr. a s clinic private limited',
    'Abhay narendra lodha foundation',
    'Intellectual federation of india',
    'Shri sukta consultants private limited',
    'Rise services private limited',
    'City surf vouchers private limited',
    'Veriassurance knowledge services private limited',
    'Midson advisors private limited',
    '4s international limited',
    'Qasar healthcare private limited',
    'Active acres residents welfare association',
    'Crish healthcare private limited',
    'Shubh aarambh charitable foundation',
    'E z bioxcel solutions private limited',
    'Twenty four systems private limited',
    'Anandaloke medical centre private limited',
    'Cybersys infotech limited',
    'Sagar agro products private limited',
    'Diffusion engineers limited',
    'Graphite india limited',
    'THE MADRAS VANASPATHI PRIVATE LIMITED',
    'Raj oil mills limited',
    'Shri dinesh mills limited',
    'Kesoram textile mills limited',
    'Jindal cotex limited',
    'Eastern silk industries limited',
    'I SECURE CREDIT & CAPITAL SERVICES LIMITED',
    'Antarctica limited',
    'Sharon bio-medicine limited',
    'Oriental carbon & chemicals ltd',
    'Grp limited',
    'Norplex oak india ltd',
    'Gkb ophthalmics limited',
    'Vesuvius india ltd',
    'Saurashtra cement limited',
    'Aditya forge limited',
    'Electro steel castings ltd',
    'Pine wood commercial ltd',
    'MRO-TEK REALTY LIMITED',
    'Hind rectifiers limited',
    'Kirloskar pneumatic company limited',
    'Bimetal bearings limited',
    'Jagan lamps limited',
    'Havells india limited',
    'G s auto international limited',
    'PURAVANKARA LIMITED',
    'SAL AUTOMOTIVE LIMITED',
    'Waldorf india ltd',
    'Newclear visions private limited',
    'Savbri health care private limited',
    'Illustrious technologies india private limited',
    'Sairam media net work private limited',
    'Pbj associates private limited',
    'Chronical special events and promotions india private limited',
    'Altek beissel needles limited',
    'Siyaram sales private limited',
    'Lindstrom services india private limited',
    'Minda spectrum advisory limited.',
    'Aafreens foods private limited',
    'Ncubate india services private limited',
    'Athah industries private limited',
    'Manipal gold co limited',
    'Sri gokulam hospitals private limited',
    'Wellbeing beauty services private limited',
    'Brain4ce education solutions private limited',
    'Indian education foundation',
    'S. chand edutech private limited',
    'Six red marbles learning private limited',
    'Webcom associates private limited',
    'Bansal classes private limited',
    'HERMES ACADEMY OF TRAINING PRIVATE LIMITED',
    'Ambedkar institute of business management private limited',
    'Tarmat limited',
    'French motor car co ltd',
    'Betul commercial ltd',
    'MYSORE PAINTS AND VARNISH LIMITED',
    'Haldyn glass limited',
    'River front hotels limited',
    'Balurghat technologies limited',
    'Tourism finance corporation of india limited',
    'Santon finance and investment co ltd',
    'Flamingo finance and investment co ltd',
    'Sacred trading and investment company ltd',
    'Neo dynamics limited',
    'Chain investment ltd',
    'Balmer lawrie investments limited',
    'Bhartia bright & seamless steels ltd',
    'Innovative tech pack limited',
    'Trident limited',
    'JAGAN INDUSTRIES PRIVATE LIMITED',
    'Dharma properties pvt ltd',
    'Shaan admark consultant private limited',
    'Vishivkarma industries pvt ltd',
    'Galvanic construction and management services private limited',
    'Cosmopolite agro processing private limited',
    'Shiv vegpro private limited',
    'INDEEN BIO POWER LIMITED',
    'S g evershine farms private limited',
    'Actech agro private limited',
    'Chaudhari cars private limited',
    'Shapra exports limited',
    'Ganesh expotrade private limited',
    'Tanya cars private limited',
    'Karle homes private limited',
    'Scitech healthcare private limited',
    'Panacea warehousing and infrastructures private limited',
    'Isbe infrastructure private limited',
    'Kbk buildwell private limited',
    'Allied tradex private limited',
    'Austro labs limited',
    'Rbg vyapar private limited',
    'Lakecity enterprises pvt ltd',
    'BANARAS GLASS BEADS PRIVATE LIMITED',
    'Shree bhawani tradelink private limited',
    'Shree krishna agency limited',
    'Speedtheam conveyors private limited',
    'Remote trading private limited',
    'Eureka exim private limited',
    'Ultratech services private limited',
    'Kathuria builders private limited',
    'Matrix vanijya private limited',
    'Gopala tower private limited',
    'Sagar ratna developers private limited',
    'Third eye builders private limited',
    'Jia properties private limited',
    'Preet realcon private limited',
    'Preet infracon private limited',
    'Devise properties private limited',
    'Intellect vanijya private limited',
    'Naresh exim pvt. ltd.',
    'Martel mercants pvt ltd',
    'Jyoti niryat private limited',
    'Ruhani infradev private limited',
    'SRINANDA BUILDERS PRIVATE LIMITED',
    'Sikka kars global private limited',
    'Jagdamba exim pvt ltd',
    'Sikka motors private limited',
    'Dhruvanam automobiles private limited',
    'G s solvent private limited',
    'Lagan merchants private limited',
    'Unnati vinimoy private limited',
    'Utsav vinimay private limited',
    'Anugraha highrise private limited',
    'B stractors private limited',
    'Ventures designer exports private limited',
    'Asbs industries private limited',
    'Verve automotives private limited',
    'Munshiram trading company private limited',
    'Allene overseas private limited',
    'Myra enterprises private limited',
    'Hamabo india private limited',
    'PAL LIFEWARE PRIVATE LIMITED',
    'Seaside agencies private limited',
    'Impact agencies private limited',
    'Ganpati texere private limited',
    'Sorte products private limited',
    'Jain realty limited',
    'ALCOI BUILDING SYSTEMS PRIVATE LIMITED',
    'Abhivridhi metals private limited',
    'Superlink trades india pvt.ltd.',
    'Sunap commotrade pvt ltd',
    'Frontier raas private limited',
    'J s designer limited',
    'SIMEX GST ADVISORY PRIVATE LIMITED',
    'Teekoy mercantile pvt ltd',
    'RAJDARBAR ICONIC VENTURE PRIVATE LIMITED',
    'K biologicals private limited',
    'Bengal unitech universal infrastructure private limited',
    'Panchsheel dwellings private limited',
    'Victora stock-invest private limited',
    'Amrapali enterprises private limited',
    'D.t.c.intertrade pvt ltd',
    'Oom tradex private limited',
    'Parwati tradecom private limited',
    'Beetle tie-up private limited',
    'Sreepriya exports private limited',
    'SAI SUBSTRATES PRIVATE LIMITED',
    'Ramprastha sare landholding company five private limited',
    'Ambience private limited',
    'Cobra instalaciones y servicios india private limited',
    'INFRAMECH POWER SOLUTIONS PRIVATE LIMITED',
    'ANOPCHAND TILOKCHAND JEWELLERS PRIVATE LIMITED',
    'Gpl exports limited',
    'Shrishti overseas private limited',
    'Lords dealers private limited',
    'Shashi foods (india) pvt. ltd.',
    'Aquamarine trading and investments pvt ltd',
    'Gogate sales (nasik) private limited',
    'Czars glocal private limited',
    'Ue trade corporation (india) private limited',
    'Autorama private limited',
    'TEA CONSULTANCY & PLANTATION SERVICES (INDIA) PVT LTD',
    'Radhakrishna bimalkumar private limited',
    'SPEED TOWN PLANNERS PRIVATE LIMITED',
    'Churiwal mercantiles private limited',
    'Oslo international private limited',
    'Prajpati vinimay pvt ltd',
    'Zakaria shahid impex private limited',
    'Livingpoint sales private limited',
    'U p telelinks limited',
    'Sudarshan distributors private limited',
    'Satyanarayani tradecom private limited',
    'Shreeyukta tradecom private limited',
    'Tulsyan trading company private limited',
    'Jacaranda textiles private limited',
    'Shagun exim private limited',
    'Ferreterro india private limited',
    'SATYA RANI GARMENT ACCESSORIES PRIVATE LIMITED',
    'Dex enterprises private limited',
    'Montstar global private limited',
    'Hlkr trading co. private limited',
    'Servo electronics private limited',
    'Shivalik apparels private limited',
    'Super delicacies private limited',
    'Eastern organic fertilizer private limited',
    'Bicon consultants private limited',
    'Cogentech management consultants private limited',
    'Hella india automotive private limited',
    'Vimokas consultantsand engineersprivate limited',
    'Kanak agencies pvt ltd',
    'Raghupati consultants limited',
    'Gtfs multi services limited',
    'Amp retail services pvt ltd',
    'Bloom creation private limited',
    'Konectors consulting private limited',
    'Sherana investments private limited',
    'Au fait consultants private limited',
    'Incoda media services pvt ltd',
    'Gms integrated systems private limited',
    'ADL AGROTECH LIMITED',
    'Pal and associates private limited',
    'Indiana enterprises pvt ltd',
    'J t engineering private limited',
    'RESISTOFLEX PRIVATE LIMITED',
    'United automation private limited',
    'Hbd packaging private limited',
    'Encom energy india private limited',
    'Harjas management consultants private limited',
    'Lstech ventures private limited',
    'Ashlin travels private limited',
    'Kanchenjunga services private limited',
    'Hilux automotive private limited',
    'Tandon consultants private ltd',
    'Shiva consultants private limited',
    'Aargee consultants private limited',
    'Aakaar turnkey services private limited',
    'Bajaj pharmaceuticals private limited',
    'International minelmech private limited',
    'Intelab equipments private limited',
    'Alpha creations private limited',
    'Ramnika estates pvt ltd',
    'Vitthal properties private limited',
    'Tosh apartments private limited',
    'Paramarsh informatics private limited',
    'Goodwill apartments private limited',
    'Sds security private limited',
    'Luminous power technologies private limited',
    'Cryostar tanks and vessels private limited',
    'K.k. promoters and contractors private limited',
    'Indian insulators (delhi) private limited',
    'Nina international private ltd',
    'Global consultants and designers private limited',
    'Gurmat construction company private limited',
    'Shivansi investments private limited',
    'Sarvjit farms and foods private limited',
    'Shree alloy industries pvt ltd',
    'Y.i. international private limited',
    'Shashi carriers private limited',
    'Vasco travel private limited',
    'PLAYTOOL PRIVATE LIMITED',
    'Pravar electronics private limited',
    'Shree laxmi associates private limited',
    'Sara estates private limited',
    'Samak landscape private limited',
    'Sharad advertising pvt ltd',
    'Harvel irrigations private limited',
    'Spectra consultancy pvt ltd',
    'Peoplepro management services private limited',
    'Network 4 greenearth.com private limited',
    'Pallonji industrial finishers private limited',
    'Anu overseas private limited',
    'Strag designers private limited',
    'International land development private limited',
    'Ample containers private limited',
    'D.P.S.ADVERTISING & MARKETING PVT.LTD.',
    'Packart image private limited',
    'GUNHILL VENTURES PRIVATE LIMITED',
    'Megatech marketing private limited',
    'Sawbros industries private limited',
    'Ayl holdigns private limited',
    'Shyamtex garments private limited',
    'Empowera technorganics private limited',
    'Aap media private limited',
    'Premdhil farms private limited',
    'Pujas shilpkala private limited',
    'Personal graphics and advertiser private limited',
    'Ufl portfolio limited',
    'Pace financial services limited',
    'Horizon infoplay limited',
    'Sarvmanglam builders and developers private limited',
    'Hess hospitality private limited',
    'Add on securities private limited',
    'Ramprastha sare landholding company two private limited.',
    'Kay jay forgings private limited',
    'Polite properties private limited',
    'Shakti orthopaedic sales private limited',
    'Aadharshila designs private limited',
    'Mrig management consultants private limited',
    'Tanya automobiles private limited',
    'Jaybee fincap private limited',
    'Vrindavan finvest private limited',
    'Jaybee impex private limited',
    'Sunny spintex private limited',
    'Trustline securities limited',
    'A n y services private limited',
    'HOME DIGITAL NETWORKS PRIVATE LIMITED',
    'Indira banquets private limited',
    'Super floorings private limited',
    'Mini-ate systems private limited',
    'Ultimate services private limited',
    'Intec holdings private limited',
    'Mittal leasing private limited',
    'A s v gears pvt ltd',
    'Marathwada auto compo private limited',
    'Needle roller bearing company private limited',
    'Venus dies and moulds private ltd',
    'Simpletec automatics pvt.ltd.',
    'S.n. castings limited',
    'Ghaziabad concast private limited.',
    'Kalsi engineering works private limited',
    'North star equipment corporation private limited',
    'Elite air techniques private limited',
    'Rabbit automation private limited',
    'Avery india ltd',
    'Spectrum filtration private limited',
    'Goa precision stamping private limited',
    'Vihan engineering private limited',
    'Pipefit engineers private limited',
    'Jsk steel private limited',
    'Fidelity forge private limited',
    'Kartar agro engineers private limited',
    'AGARWAL TRACTORS PVT LTD',
    'Kanta steels pvt ltd',
    'Agarwal sponge and energy private limited',
    'Asr met tech private limited',
    'Sagar castings pvt ltd',
    'V s p ispat private limited',
    'Raunaq steels trading private limited',
    'T r flongs pvt ltd',
    'Sato pooja fasteners private limited',
    'Tushar precicomp private limited',
    'Nizhoni tools private limited',
    'Kdn tools pvt ltd',
    'Belgaum cnc applications private limited',
    'Trident fabricators private limited',
    'Drilbits international private limited',
    'JAISALMER ENGINEERS PRIVATE LIMITED',
    'Belliss india ltd',
    'Ganga rk industries private limited',
    'Eurobearings india private limited',
    'Pcs metal private limited.',
    'Synergy metals private limited',
    'Shanker forge pvt ltd',
    'Baf germany private limited',
    'Madhu industries private limited',
    'Horizon polymer engineering private limited',
    'Gmw engineers private limited',
    'Pappilon exports limited',
    'Mehala technologies india private limited',
    'Hd fire protect private limited',
    'R.m.s. pack systems private limited',
    'Hollister medical india private limited',
    'MEERA INDUSTRIES LIMITED',
    'Vivek bulb industries pvt ltd',
    'Balkishan dass subhash chand ispat private limited',
    'Bray controls india private limited',
    'Eastern india ball bearing merchants association.',
    'Peiner smag machinery (india) private limited',
    'Vivial forge private limited',
    'Met heat engineers private limited',
    'Douglas fraser(india) private limited',
    'Rameshwara engineering co pvt ltd',
    'Amargun overseas private limited',
    'S. ABBAS & COMPANY PRIVATE LIMITED',
    'Modi engineering industries private limited',
    'Omega printopack private limited',
    'Dikibi technologies private limited',
    'Essem refills private limited',
    'Keen and able computers private limited',
    'Hmi technologies private limited',
    'Ansun system consulting pvt ltd',
    'Unimech lifting equipments pvt ltd',
    'Power engineering (india) private limited',
    'Mahalasa powergen private limited',
    'L&T - MHI POWER TURBINE GENERATORS PRIVATE LIMITED',
    'Abbott toolfast private limited',
    'Rushas engineering company private limited',
    'Unix switchgear private limited',
    'Mitra precision fastners pvt limited',
    'Hind engineers india pvt ltd',
    'Sanmac electricals and electronics private limited',
    'Precision accumulators and engineers pvt ltd',
    'SHANT TRANSMISSIONS PRIVATE LIMITED',
    'Ginter engineering private limited',
    'UNICORN INDUSTRIES PRIVATE LIMITED',
    'COMTROL INDUSTRIES PRIVATE LIMITED',
    'Parco traders pvt ltd',
    'Asp engineering products pvt ltd',
    'Bells electrotech pvt.ltd.',
    'Balarka fabricon private limited',
    'M s industrial components private limited',
    'Shiba components private limited',
    'G.s.p. electronics private limited',
    'Elymer electrics private limited',
    'Surbhi broadband private limited',
    'Greenwire infocom solutions private limited',
    'Flourish electronics private limited',
    'Milben electronics private limited',
    'Xtend electronics private limited',
    'Saurshakti solar private limited',
    'Triess engineering company pvt. ltd.',
    'Ghosh brothers electronics private limited',
    'Startron video private limited',
    'Essen energy conversion devices private limited',
    'Senor telecom private limited',
    'Asiatelco india private limited',
    'Zeal engineering equipments tradeco private limited',
    'ENERBANC POWER SYSTEMS PRIVATE LIMITED',
    'Siddarth mechanical works private limited',
    'Galaxy process automation private limited',
    'Roko linings (india) private limited',
    'Priya capacitors private limited',
    'Vision world private limited',
    'Jena holdings pvt ltd',
    'Dhanvikash leafin pvt ltd',
    'Sungrowth share & stocks limited.',
    'Vidya finvest ltd',
    'Pradip credit pvt ltd',
    'Pace insurance brokers private limited',
    'ASTHA INSURANCE SERVICES PRIVATE LIMITED',
    'Aum bima suraksha broking private limited',
    'HDFC ERGO GENERAL INSURANCE COMPANY LIMITED',
    'HEM INSURANCE BROKERS PRIVATE LIMITED',
    'Pcs insurance broking private limited',
    'DAR',
    'S CENTER AND HOSPITALS PRIVATE LIMITED',
    'Green meadows golf academy',
    'Getwell health and research private limited',
    'Medileaves ayurveda private limited',
    'Kodath resorts private limited',
    'Udai-omni hospitals private limited',
    'PROCAM INTERNATIONAL Private Limited',
    'Diamond pipes & tubes private limited',
    'Sarda polypack industries pvt ltd',
    'Pensla steels private limited',
    'Impel forge and allied industries limited',
    'Madhav stelco private limited',
    'Hindustan wire metal products private ltd',
    'Bhakarh alloys private limited',
    'QUALITY FOILS (INDIA) LIMITED',
    'Haldia down stream polymers (p) ltd.',
    'Accordd organics private limited',
    'Vaswani cement limited',
    'W.g.steel and casting private limited',
    'Shyam steels private limited',
    'Parmar metals private limited',
    'Texwico poly-cast pvt ltd',
    'RKM REALTORS LIMITED',
    'Divyansh steel private limited',
    'MODA ELEMENTI INDIA PRIVATE LIMITED',
    'Aavya industries private limited',
    'Agrasen steel tubes pvt ltd',
    'Mittal biotech limited',
    'Authentic steel and alloys limited',
    'Pramod energy controls private limited',
    'Diwanka iron and steel company private limited',
    'Savera india riding systems company private limited',
    'Bagaria businees pvt ltd',
    'KRITIKA WIRES LIMITED',
    'Varun eximp private limited',
    'Shree parashnath re-roolling mills limited',
    'Shamli steels private limited',
    'Vishal wire products private limited',
    'Ne cables limited',
    'Uttranchal metals private limited',
    'Mohit steel industries private limited',
    'PSP DYNAMIC LIMITED',
    'Eswari global metal industries private limited',
    'Solar ceramic private limited',
    'Gobain ceramic private limited',
    'Vishant metal rerollers private limited',
    'Navjivan minerals and mines private limited',
    'Triyog vanijya sangthan pvt ltd',
    'SAKAR GRANITO (INDIA) PRIVATE LIMITED',
    'Disposafe health and life care limited',
    'Yamato scale india private limited',
    'Sri arumuga brick works private limited',
    'Kevin ceramic private limited',
    'AXOLI TILES PRIVATE LIMITED',
    'R.v.s. fabricators private limited.(trs. co. delhi to hary.)',
    'Rahul industrial enterprises pvt. ltd',
    'Bharat hardware pvt ltd',
    'Vision projects & finvest pvt ltd',
    'Alom housing & infrastructure limited',
    'Superon schweisstechnik india limited',
    'Sandhar han sung technologies private limited',
    'A v brothers private limited',
    'Atul metfab private limited',
    'Superkab engineering private limited',
    'C.p. re-rollers limited',
    'Ultra alluminium private limited',
    'Green facade solutions private limited',
    'Sino india metallurgical engineering & supply pvt ltd',
    'Hardik steels private limited',
    'Konark tanks vessels pvt ltd',
    'Bharat containers pvt ltd',
    'FRANKLIN WADCORPP INDIA PRIVATE LIMITED',
    'Bharat containers (nagpur) pvt ltd',
    'SIDMA ENGINEERING PRIVATE LIMITED',
    'Veauli engineers private limited',
    'Narshima auto components private limited',
    'Sebros industries private limited',
    'Goldy auto stampings (india) private limited',
    'Manisha pharmo plast private limited',
    'Kapilansh dhatu udyog private limited',
    'Precision photofabricators private limited',
    'QUICKWORK TECHNOLOGIES PRIVATE LIMITED',
    'LALIT PIPES & PIPES PRIVATE LIMITED',
    'Pratap re-rollers private limited',
    'Gabmus jewels private limited',
    'Wizard enterprises private limited',
    'Orange city steel industries private limited',
    'Viki industries private limited',
    'Supreme pressfab private limited',
    'F S ADVERTISING PRIVATE LIMITED',
    'Enpar steels private limited',
    'Ashoka engineers pvt ltd',
    'Punjab hammers pvt ltd',
    'Durocrete engineering services private limited',
    'Precision fabtech private limited',
    'Vishal containters pvt ltd',
    'Oswal castings private limited',
    'Vindec tinbox company private limited',
    'ARVIND ENVISOL LIMITED',
    'Millennium metalloys private limited',
    'Ambica steels limited',
    'Pentax engineering private limited',
    'Dynomerk controls india private limited',
    'Avock engineering private limited',
    'Suraj foundries private limited',
    'Hodek vibration technologies private limited',
    'CONTROLS AND SCHEMATICS PRIVATE LIMITED',
    'Dynamic valves private limited',
    'Greens gears private limited',
    'I fab steel private limited',
    'Sarojini steel limited',
    'Agni steels private limited',
    'Green planet machines private limited',
    'J kelly s exports pvt ltd',
    'Seers sales private limited',
    'Renaissance creations private limited',
    'Achievers sales private limited',
    'Glycosic merchants pvt.ltd.',
    'Landmark commercial pvt ltd',
    'Al gayathri trading company pvt ltd',
    'Geneous trading and marketing company private limited',
    'Deepkamal multitrade private limited',
    'Pst trading company private limited',
    'Ramdev vyapaar private limited',
    'Patson global limited',
    'Gandheswari vanijya private limited',
    'JONJUA OVERSEAS LIMITED',
    'Emson overseas private limited',
    'Mangalam supply co. private limited',
    'Vaishnomata commercial private limited',
    'Amg retail private limited',
    'Vossloh cogifer turnouts india private limited',
    'Mahr metrology india private limited',
    'Jasmine commodeal private limited',
    'BAID & NAHATA TRADERS PRIVATE LIMITED',
    'M.sons exim private limited',
    'ENVIROPOL HYDROSOLS PRIVATE LIMITED',
    'Sakshem exim private limited',
    'Arora industrial traders private limited',
    'Everfresh stores private limited',
    'ESCONET TECHNOLOGIES LIMITED',
    'Highpoint commotrade private limited',
    'Excel experiential marketing private limited',
    'Grace suppliers pvt. ltd.',
    'Sivanta vanijya pvt. ltd.',
    'Anther Vinimay Private Limited',
    'Starshine vincom private limited',
    'S.A INTERNATIONAL PROJECTS PRIVATE LIMITED',
    'Bj trading private limited',
    'Maximus enterprises india private limited',
    'Moonview vincom private limited',
    'Jatashiv impex private limited',
    'Jemat speedtex private limited',
    'Ashika commodities & derivatives private limited',
    'PAREEK TRADE & COMMERCE PRIVATE LIMITED',
    'Beximco international private limited',
    'Kingfisher exim private limited',
    'Bakool venture private limited',
    'Elegant trexim private limited',
    'Kalash overseas private limited',
    'INDOSPIRIT LOGINEXT PRIVATE LIMITED',
    'Spg global distribution private limited',
    'Aditya dealcom private limited',
    'Sigma safety devices pvt ltd.',
    'Pch telecom (india) private limited',
    'Jaguar trexim pvt ltd',
    'Rosewood mercantile private limited',
    'Welkin agencies pvt. ltd.',
    'Sunlike agencies private limited',
    'J mitra and co private limited',
    'Tropex commercial private limited',
    'Shree gr exports pvt ltd',
    'Nimbus agencies private limited',
    'Matrika creations private limited',
    'Yogya dealcom private limited',
    'Ganeshvani trexim private limited',
    'Tedium sales private limited',
    'DHANVRIDHI POLYFABS PRIVATE LIMITED',
    'Bateshwarnath private limited',
    'Stream vincom private limited',
    'REDICLE CONSULTANTS PRIVATE LIMITED',
    'Ritudhan suppliers private limited',
    'FANATIC AGROTECH PRIVATE LIMITED',
    'Helios exports limited',
    'Guardian nutrition and health supplements private limited',
    'Ashish exim pvt ltd',
    'Paramount fashions private limited',
    'Jyestha vyapaar private limited',
    'Minilec (india) private limited',
    'V k mall private limited',
    'Chandra trading and investment pvt. ltd.',
    'Vsr ventures private limited',
    'Greenland suppliers private limited',
    'Topone india private limited',
    'Fourfold vanijya private limited',
    'Shaivi vinimay private limited',
    'Navtantra retail private limited',
    'Helios mercantile limited',
    'Namoh retails private limited',
    'QC MAX CALIBRATION & SERVICES PRIVATE LIMITED',
    'Alokik trade link private limited',
    'Prajay agencies private limited',
    'Espire retail private limited',
    'Siddhi chloroexim private limited',
    'Fairmacs catering company private limited',
    'Venus surgicals private limited',
    'Bacans biotech private limited',
    'Sarada dealers private limited',
    'Blue rock hospitality ventures private limited',
    'Miraj hotels private limited',
    'Magsons aparthotel private limited',
    'Millenium motels and restaurant pvt ltd',
    'Vista hospitality private limited',
    'Prn hospitality services private limited',
    'G.and s. sarovar park plaza hospitality private limited',
    'Evershine hospitality private limited',
    'Camping retreats of india private limited',
    'Shimmer hotels & resorts private limited',
    'Bhattacharya merchandise private limited',
    'Eaccountants services (india) private limited',
    'Wordpro computer consultancy services private limited',
    'Contentra technologies (india) private limited',
    'Bluechip compusoft private limited',
    'Millennium information technologies (india) private limited',
    'Wellisen Nutraceuticals Private Limited',
    'Netlab solutions (india) private limited',
    'Jambuster technologies private limited',
    'Amplify mindware private limited',
    'Ashore systems private limited',
    'Conscience information technologies private limited',
    'A k outsourcing services private limited',
    'PNQ TECHNOLOGIES PRIVATE LIMITED',
    'Lira digital communications services private limited',
    'Dmacq software private limited',
    'K.s. technosoft private limited',
    'Mechlin software technology private limited',
    'Tulip infoweb solutions private limited',
    'Olive technology limited',
    'Choice software limited',
    'Iic geosurveys private limited',
    'Indosoft application services private limited',
    'NEOSTREAM INNOVATIONS PRIVATE LIMITED',
    'Innova technologies private limited',
    'Facemap infotechnologies private limited',
    'Exceloid soft systems private limited',
    'Freyr software services private limited',
    'Amrutha systems private limited',
    'Metamorph it systems private limited',
    'Amitysoft technologies private limited',
    'Precision galaxy private limited',
    'Sba info solutions private limited',
    'Indes engineering and it services private limited',
    'Prosoft information systems private limited',
    'Krion computer services private limited',
    'I-tech infonet private limited',
    'Bips powercom limited',
    'Zinfi software systems private limited',
    'Issac technologies private limited',
    'Promact infotech private limited',
    'MNA MARKETPLACE PRIVATE LIMITED',
    'Samtronics data products limited',
    'NEST DIGITAL PRIVATE LIMITED',
    'Swami cyber solutions private limited',
    'Cosmic nutracos solutions private limited',
    'Max-digi infotech private limited',
    'Ziel infosolutions private limited',
    'Wisilica india private limited',
    'Autofit technologies private limited',
    'Riddhi softech private limited',
    'Shrishti info solutions private limited',
    'Neumann systems consultancy private limited',
    'Swaran soft support solutions private limited',
    'Elixir 360 solutions private limited',
    'Promatics technologies private limited',
    'Indiqus technologies private limited',
    'Cinestaan digital private limited',
    'Printech sales and services private limited',
    'Cachebox (india) private limited',
    'Qsg technologies private limited',
    'Infosmart technologies private limited',
    'Sunjeet advertising pvt ltd',
    'Catalyst advertising and marketing private limited',
    'Acg inspection systems private limited',
    'Chemtrols infotech private limited',
    'Nsi solutions private limited',
    'Decurtis software solutions private limited',
    'Pratham solutions private limited',
    'FUTURETHOUGHTS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Atrity info solutions private limited',
    'Ultramain software india private limited',
    'Smargav solutions private limited',
    'Hardsoft information systems private limited',
    'Images access multimedia private limited',
    'Dreamstel communications private limited',
    'Us techdata solutions private limited',
    'Extentia information technology private limited',
    'Version software solutions private limited',
    'Devyog solutions private limited',
    'Ark call target private limited',
    'Pack web hosting private limited',
    'Wizard e-marketing private limited',
    'Brandsoft solutions ( india) private limited',
    'Wizard consulting private limited',
    'Noriant software solutions private limited',
    'Sunlight insurance agencies private limited',
    'Techondesk private limited',
    'Saigun technologies private limited',
    'CPM INDIA SALES & MARKETING PRIVATE LIMITED',
    'Edvanta technologies private limited',
    'Mlogica infotech software private limited',
    'Malhaar i-marketing advantage solutions private limited',
    'Seven 3 rockers technologies private limited',
    'R h international limited',
    'H3 infotech private limited',
    'Sharedreach mobility services private limited',
    'Net4uonline private limited',
    'Sequentec solutions private limited',
    'A and m digi5 studios private limited',
    'Muon computing private limited',
    'Esperto technologies private limited',
    'Netvega solutions private limited',
    'Agile data solutions private limited',
    'ANGARA ECOMMERCE PRIVATE LIMITED',
    'Spectrum data system services private limited',
    'Ozonegroup football academy private limited',
    'New acropolis cultural association',
    'Trojan creations private limited',
    'Nisargalaya herbal company private limited',
    'Infinity bpo services private limited',
    'Believe securities private limited',
    'Padmini vna securities private limited',
    'Parkcity sporting ventures private limited',
    'Sun alphatec moulds (india) private limited',
    'Shopping centres association of india',
    'Lions workforce solutions india private limited',
    'Dhathri abs health clinics private limited',
    'Alpha family foundation',
    'INDRAPRASTHA SKILL INITIATIVE PRIVATE LIMITED',
    'STHREE MANAGEMENT SERVICES PRIVATE LIMITED',
    'Think india hospitality services private limited',
    'Gyvenimo skills & arts private limited',
    'Vidhi centre for legal policy',
    'Sparksfly relocation services private limited',
    'Skilld india private limited',
    'Blue hire india private limited',
    'Kimiya consulting private limited',
    'Hitechpeople technology india private limited',
    'Healthassure private limited',
    'Rollon bearings private limited',
    'Deshana finlease services limited',
    'Mullackals medicare private limited',
    'Pd e education private limited',
    'Ishan vidya prep private limited',
    'HUGHES GLOBAL EDUCATION INDIA PRIVATE LIMITED',
    'Bridgeintelia knowledge solutions private limited',
    'Wellcorp health services private limited',
    'BBGL MERCANTILE PRIVATE LIMITED',
    'Dcm vigilance & maintenance services private limited',
    'KUMRAKHALI FLAT OWNERS ASSOCIATION',
    'Jeevanrekha medihealth services private limited',
    'Heartcare associates private limited',
    'Dr g b healthcare private limited',
    'Indo european business forum',
    'Diverse hotels marketing private limited',
    'Kapadia health club pvt ltd',
    'TULASI BROADCASTING NETWORK LIMITED',
    'Mashal sports private limited',
    'Pocket aces pictures private limited',
    'Saan foundation',
    'Sm productions private limited',
    'Gandhidham developers private limited',
    'TATA SONS PRIVATE LIMITED',
    'Kamala mills limited',
    'Softesule private limited',
    'COVERED WIRES PRIVATE LIMITED',
    'Suparna chemicals limited',
    'Ravi frozen foods pvt ltd',
    'Alue india private limited',
    'Chandan steel limited',
    'Trimec machinery manufacturing company pvt ltd',
    'Indomobil sales and services private limited',
    'Nagpur business centre (india) private limited',
    'Zoad technology services limited',
    'Swadeshi electoral trust',
    'Decibel media private limited',
    'Silly entertainment and media private limited',
    'Rajvi entertainment private limited',
    'Kcil ltd',
    'Modi naturals limited',
    'Rishabh digha steel and allied products limited',
    'Pioneer agro extracts limited',
    'Rana sugars limited',
    'DHUNSERI VENTURES LIMITED',
    'AJANTA SOYA LIMITED',
    'Diana tea co ltd',
    'Associated alcohols & breweries ltd.',
    'Asian granito india limited',
    'Jai corp limited',
    'Sportking india limited',
    'Kukar sons (indo-french) exports limited',
    'Sri bhagavathi textiles ltd',
    'Rama phosphates limited',
    'Vinati organics limited',
    'Adinath biolabs limited',
    'Nectar life sciences limited',
    'Tribology india limited',
    'Ceat limited',
    'Tvs srichakra limited',
    'The nilambur rubber company limited',
    'Neycer india limited',
    'Creative castings limited',
    'P g foils limited',
    'National aluminium co ltd',
    'Siemens limited',
    'JTEKT INDIA LIMITED',
    'Skf india limited',
    'HINDUSTAN HARDY LIMITED',
    'Alfa transformers limited',
    'Exide industries limited',
    'Sippy films private limited',
    'Redmaple designs private limited',
    'Filmistan exhibitors private ltd',
    'Duniya vision india private limited',
    'Caregrowth broking private limited',
    'Delta troops private limited',
    'Shantha electricals and engineers private limited',
    'SIEMENS LOGISTICS INDIA PRIVATE LIMITED',
    'Nithya shanti foundation',
    'Hotel arun private limited',
    'RIPLEY & COMPANY LIMITED',
    'Sree victory shrimp products pvt ltd',
    'Sss sports india private limited',
    'Eros furniture private limited',
    '2m lifts and escalators private limited',
    'Autowin systems private limited',
    'River techno-plast private limited',
    'Omega appliances private limited',
    'Modern home care products limited',
    'Haresh extrusion private limited',
    'Pragati polyplast india private limited',
    'Jay instruments and systems private limited',
    'Atco controls (india) private limited',
    'Connectwell industries private limited',
    'Gemplus india private limited',
    'Cads software india private limited',
    'Logic plus plus india private limited',
    'Sterco digitex private limited',
    'Sysnet global technologies private limited.',
    'SOFTRON E-RETAIL PRIVATE LIMITED',
    'Ag measurematics private limited',
    'Supreme technologies pvt ltd',
    'Amloz infra mart private limited',
    'Parman enterprises private limited',
    'BOYSEN INDIA PRIVATE LIMITED',
    'Mabs hydro engineering private limited',
    'Hi-precision alloys private limited',
    'Yantraman infrasolutions private limited',
    'Adarin engineering technologies private limited',
    'Munni lal tandoors private limited',
    'Eros infrastructures private limited',
    'Maya surgicals private limited',
    'Servo packaging limited',
    'Su-kam batteries limited',
    'Sree chand electrical industries pvt ltd',
    'Tecnova india private limited',
    'Raj process equipments and systems private limited',
    'Emerald engineers private limited',
    'Pushkaraj engineering enterprises private limited',
    'Sri ram cables private limited',
    'Mew electricals limited',
    'AGNI FIBER BOARDS PRIVATE LIMITED',
    'Chetan ketan private limited',
    'Alok wires pvt.ltd.',
    'Tirumala seven hills pvt ltd',
    'HITACHI HIGH-TECH INDIA PRIVATE LIMITED',
    'Chloride international limited',
    'Shonan engineering works private limited',
    'Sane equipments private limited',
    'Breeze tools private limited',
    'Electro crimp contacts (india) private limited',
    'Huphen fabricators private limited',
    'New amp and ohm applications private limited',
    'BALAA SANMUGA POWER INFRAA PRIVATE LIMITED',
    'Veljan hydrair limited',
    'Frizair private limited (part ix)',
    'Regent electro-mech private limited',
    'Power carbons pvt ltd',
    'V m k electronics private limited.',
    'USHA PRECISION PRODUCTS PRIVATE LIMITED',
    'Mewar hi-tech engineering limited',
    'Famex coating india private limited',
    'Starion india pvt. ltd.',
    'Advance panels and switchgears private limited',
    'Maa tripur sales private limited',
    'Sinhal metal india private limited',
    'BIBUS INDIA PRIVATE LIMITED',
    'Sp engineers autotech india private limited',
    'Durga transformers private limited',
    'Ganesh transmission private limited',
    'AVG MOTORS PRIVATE LIMITED',
    'POOMKUDY ZAAN PRIVATE LIMITED',
    'Prem colour lab private limited',
    'Amrova power private limited',
    'Acd communications private limited',
    'Rotomac switchgear pvt ltd',
    'Herald publications pvt. ltd.',
    'Cosme bio-tech private limited',
    'Hytech induction heaters p ltd',
    'Bg li-in electricals limited',
    'Infinity advertising services pvt. ltd.',
    '3d technologies private limited',
    'Vishay semiconductor india private limited',
    'Authentic controls private limited',
    'Spectris technologies private limited',
    'Sahney kirkwood private limited',
    'Pratul electronics private limited',
    'Sanstar microsystems p ltd',
    'Akanksha international private limited',
    'Nimble wireless private limited',
    'Brentlec electrogears private limited',
    'Erd technologies private limited',
    'Jasnav infotech service private limited',
    'VIHAAN NETWORKS PRIVATE LIMITED',
    'Sai telecom limited',
    'Magnum telesystem private limited',
    'News24 broadcast india limited',
    'HCIL COMTEL PRIVATE LIMITED',
    'Acl components limited',
    'Unique technosolutions private limited',
    'Soignee fashion private limited',
    'Optimus lighting solutions private limited',
    'Arn systems private limited',
    'Reynolds sound and lighting services private limited',
    'Evolet healthcare private limited',
    'Bruker india scientific private limited',
    'Medigraph (india) private limited',
    'Mediva health care private limited',
    'Nubic india private limited',
    'Activent engineering private limited',
    'Multi kilfire private limited',
    'Jesco e systems private limited',
    'Gunpatroy pvt ltd',
    'Libra exporters limited',
    'K.r. investments pvt. ltd.',
    'Fortune park housing projects private limited',
    'Niagara impex pvt ltd',
    'Badiberi marketing private limited',
    'Badiberi trading private limited',
    'Dadimata marketing private limited',
    'Shailandra enterprises private limited',
    'Snap marketing pvt ltd',
    'Sheraton traders private limited',
    'Aspen international private limited',
    'Bazaar decor india private limited',
    'Yaduvir dealers private limited',
    'Balin agencies private limited',
    'Outright impex private limited',
    'Apollo developers private limited',
    'Pvj marketing private limited',
    'LBIC ENGINEERING PRIVATE LIMITED',
    'Majority distributors private limited',
    'Brotex tradelinks private limited',
    'Vs tradecom private limited',
    'Highrise commodeal private limited',
    'Cornish aluminium india private limited',
    'EAST WEST BROTHERS LIMITED',
    'Atlanta dealmark private limited',
    'Smita tradecom private limited',
    'Durva brands india private limited',
    'Rukmani dealers private limited',
    'Mahajan overseas private limited',
    'Twenty four seven retail stores private limited',
    'Aryan barter private limited',
    'Mittal concrete private limited',
    'Anandamoyee tracom private limited',
    'Escort vintrade private limited',
    'Dadimata dealers private limited',
    'Sursadhana tradevin private limited',
    'Darpad dealers private limited',
    'Buildmat trades private limited',
    'PRIDEX MEDICARE PRIVATE LIMITED',
    'Aav import export private limited',
    'Jhilmil commodities private limited',
    'Gourisut sales private limited',
    'Symbiont commercial private limited',
    'Jai gup marketing private limited',
    'Badiberi dadimata mercantile private limited',
    'Lord dealcom private limited',
    'Auto sales private limited',
    'Kabade electronics (pune) pvt ltd',
    'Z-power impex private limited',
    'Viceroy industries private limited',
    'Pollock traders pvt ltd',
    'Imperia life sciences private limited',
    'Calix marketing private limited',
    'Forum vintrade private limited',
    'Adams exim private limited',
    'Primus it solutions private limited',
    'New eros tradecom limited',
    'Mavcomm media & entertainment retail private limited',
    'Higginbothams private limited',
    'Samannat retail private limited',
    'Ice logistics private limited',
    'Rang bandhej retail private limited',
    'Merino centmark private limited',
    'Burberry india private limited',
    'System engineers cutting and welding private limited',
    'Fairdeal diamond private limited',
    'Proten exim private limited',
    'Indospirit retail private limited',
    'Bizarre business corporation limited',
    'Luthria & lalchandani hotel & properties private limited',
    'Rahman properties ltd',
    'Devpujan mercantile private limited',
    'Mahatru trading company private limited',
    'Gardenia resorts private limited',
    'GOLDEN GALAXY HOTELS AND RESORTS PRIVATE LIMITED',
    'Indrason hospitalities private limited',
    'Rajan hospitality private limited',
    'BB&HV PRIVATE LIMITED',
    'PMA RESORTS AND REALTORS PRIVATE LIMITED',
    'Rhw bestech hospitalities private limited',
    'Richmond hospitality private limited',
    'Astro food services private limited',
    'JAKSON ENTERPRISES PRIVATE LIMITED',
    'Shaan resorts private limited',
    'Forum hospitality & services private limited',
    'Moredadi dealers private limited',
    'Autorelli marketing limited',
    'Headway products private limited',
    'Janaki eholdings private limited',
    'Moonview sales private limited',
    'GN TRENDS & TRADE PRIVATE LIMITED',
    'Intent vincom private limited',
    'UPBRIGHT SUBSISTENCE PRIVATE LIMITED',
    'Narangs international hotels private limited',
    'ATMASANTULANA VILLAGE PRIVATE LIMITED',
    'Mehta resorts and development pvt ltd',
    'Sarovar business and leisure hotels private limited',
    'Shri vitthal safari resorts private limited',
    'Odisha tourism development corporation limited',
    'Aaltrade hotel private limited',
    'Rajpal brothers electronics private limited',
    'Molecular cyclotrons private limited',
    'Janaki printing private limited',
    'Sri subbramania spinning private limited',
    'Toreto retail private limited',
    'Mobien technologies private limited',
    'Naya jobs consulting private limited',
    'Leadtech solutions private limited',
    'EXTO PROJECT SOLUTIONS PRIVATE LIMITED',
    'Pentagon tech solutions private limited',
    'Pioneer info solutions india private limited',
    'Vheeds technology solutions private limited',
    'Information evolution india private limited',
    'Avelator solutions india private limited',
    'Vtf solutions private limited',
    'Shivalik hills development private limited',
    'Cell technologies private limited',
    'Seedac systems private limited',
    'Optiologic technologies private limited',
    'Anderson technology private limited',
    'Linde global support services private limited',
    'Mascon internet pvt ltd',
    'Trulogix information systems private limited',
    'Ideation technology solutions private limited',
    'Venus it solutions private limited',
    'K. w. consulting private limited',
    'Durocrete infotech private limited',
    'Nex-g exuberant solutions private limited',
    'Systools software private limited',
    'Mospay infotech(india) private limited',
    'Aditi it services private limited',
    'Carmel info systems private limited',
    'Integrated tech9labs private limited',
    'Cloudcodes software private limited',
    'Ten times online private limited',
    'Square dotcom private limited',
    'Linklabs technology solutions private limited',
    'Dhanada clean energy (india) private limited',
    'Virtuoso infotech private limited',
    'BG IT SOLUTIONS PRIVATE LIMITED',
    'Eco tech software private limited',
    'Cube9 infotech private limited',
    'Logixgrid technologies private limited',
    'TERNION INFOTECH PRIVATE LIMITED',
    'Prapurna impex limited',
    'PERITO TECHNO SOLUTIONS PRIVATE LIMITED',
    'Pragati multi tech private limited',
    'Ibex infratek private limited',
    'Logic erp sales private limited',
    'Peocit technologies private limited',
    'Venta technologies private limited',
    'Radiss tech services india private limited',
    'World e-commerce pvt ltd',
    'Trident infosol private limited.',
    'Eureka it solutions private lmited',
    'BASS ENTERPRISES DATA SOLUTIONS PRIVATE LIMITED',
    'Jaybtee computer solutions pvt ltd',
    'Batchmates com private limited',
    'Cyber infoservices private limited',
    'Plasma softech private limited',
    'Emirates technologies private limited',
    'ART & BEYOND PRIVATE LIMITED',
    'R.p.info systems limited',
    'Dreamweavers infocom private limited',
    'My box technologies private limited',
    'Think tank infotech private limited',
    'ORBIT TECHSOL (W) PRIVATE LIMITED',
    'Zenesys technosys private limited',
    'CREATIVE DATABASE PRIVATE LIMITED',
    'V5 global services private limited',
    'Maavadi soft tech ventures (india) private limited',
    'Lexolution it services private limited',
    'Rsm technologies private limited',
    'Telexcell infranet solutions private limited',
    'Atharva syscom private limited',
    'Linc wise software private limited',
    'KINETIC HANKUK ELECTRICALS & ELECTRONICS PRIVATE LIMITED',
    'Tooltech global engineering private limited',
    'Eshopbox e-commerce private limited',
    'Auric techno services private limited',
    'Dans energy private limited',
    'Sun micro networks private limited',
    'Ittiam systems private limited',
    'Keynote capitals limited',
    'Kotak mahindra capital company limited',
    'Valsons securities limited',
    'Wellworth share and stock broking limited',
    'Virutcham microfinance limited',
    'Poonawalla investments private limited',
    'Comart investments private limited',
    'Nnm securities private limited',
    'U.l.j.k securities private limited',
    'Jaymit security systems private limited',
    'Jm financial services limited',
    'CIENS INVESTMENT ADVISORY SERVICES PRIVATE LIMITED',
    'GFSPL PRIVATE LIMITED',
    'MEHTA VENTURES PRIVATE LIMITED',
    'Rest assured insurance broking private limited',
    'Black gold holdings private limited',
    'G u financial services private limited',
    'Ram commodities private limited',
    'Max stock broking private limited',
    'MEHTA WEALTH LIMITED',
    'Deesons private limited',
    'Abhinandan investments private limited',
    'Cameo corporate services limited',
    'Cascade systems & communication private limited',
    'Abhishek estates p. ltd.',
    'Suparash nath developers private limited',
    'ROYAL LIVING HOMES PRIVATE LIMITED',
    'Jwala logistic private limited',
    'Avanta business centre (gurgaon) private limited',
    'Bt global business services private limited',
    'Pipara consultants private limited',
    'TRANSFUTURE ACCOUNTANTS AND CONSULTANTS PRIVATE LIMITED',
    'Jm services company private limited',
    'MONARCH NETWORTH INVESTMENT ADVISORS PRIVATE LIMITED',
    'Moneta resource and consulting private limited',
    'Swara education properties private limited',
    'Voyants solutions private limited',
    'Mestric consultants private limited',
    'Isqaa sourcing private limited',
    'Qvc certification services private limited',
    'International quality management services private limited',
    'Tempindia staffing services private limited',
    'Blueman support services private limited',
    'Kandoth consulting private limited',
    'Kranium hr services private limited',
    'Desbuild kris cooper private limited',
    'SOROCO INDIA PRIVATE LIMITED',
    'Abanel management consulting private limited',
    'Sun shine corporate solutions private limited',
    'Versys consultants and services private limited',
    'M far enterprises private limited',
    'Orion projects private limited',
    'Muller and phipps (industrial services) limited',
    'Genesis membrane sepratech private limited',
    'Domex business information private limited',
    'Resume management consultants private limited',
    'SANGHRAJKA BUSINESS CONSULTING PRIVATE LIMITED',
    'Loylty rewardz management private limited',
    'Malpani construction company private limited',
    'Dunhill development p ltd',
    'Jangid construction private limited',
    'Jangid developers private limited',
    'Saroj home markers and finance limited',
    'Manav builders private limited',
    'Ekta housemakers private limited',
    'Shikara constructions private limited',
    'RUBBERWALA HOUSING & INFRASTRUCTURE LIMITED',
    'Viral developers private limited',
    'Paresh infrastructure private limited',
    'Merino shelters private limited',
    'Prashanti land developers private limited',
    'Shreeanant construction private limited',
    'SKYSCRAPER REALTY PRIVATE LIMITED',
    'Integrated home solutions private limited',
    'Amber real estate limited',
    'Apl realtors private ltd.',
    'Gordon house properties private limited',
    'Ambrosia real estate private limited',
    'Arimas real estate private limited',
    'Shree naman rehab private limited',
    'Jailaxmi realty and developers limited',
    'Ashoka realty and developers limited',
    'Shriyash estates private limited',
    'Sun star spaces private limited',
    'Chakote infra private limited',
    'V9 avenues private limited',
    'Av dwellings private limited',
    'A9 homes private limited',
    'I d uppal private limited',
    'Aparna realty private limited',
    'Propiedades realties private limited',
    'Sanita realties private limited',
    'Cmcl commercial plaza private limited',
    'TAKASHI LOGISTICS PRIVATE LIMITED',
    'Pce developers private limited',
    'Arthveda northstar (bangalore) realty private limited',
    'Arthveda northstar (vadodara) realty private limited',
    'PCH WORK SPACES PRIVATE LIMITED',
    'G v b constructions private limited',
    'Kac developers private limited',
    'Luv kush buildcon private limited',
    'Shipra estate limited',
    'CONIFER FOODS AND BEVERAGES PRIVATE LIMITED',
    'Sasha estate private limited',
    'P k b buildcon private limited',
    'Pkbk buildwell private limited',
    'Kst buildwell private limited',
    'Samridh real estates private limited',
    'Shipra malls private limited',
    'Ramcons realtors private limited',
    'KRISON REALTIES PRIVATE LIMITED',
    'Hardik naik property clinic opc private limited',
    'Aryan greentech private limited',
    'Seiken property developers private limited',
    'Radhakrishna ramnarain private limited',
    'Ajit developers private limited',
    'VISHVEKSHVARAAYA HOUSES PRIVATE LIMITED',
    'Bhumi raj homes limited',
    'Eknath realtors private limited',
    'Rock solid builders private limited',
    'S&o realtors private limited',
    'Concept infra business private limited',
    'Global realtors private limited',
    'Marveledge realtors private limited',
    'Shubham green colonizers private limited',
    'R. S. INFRASOLUTIONS PRIVATE LIMITED',
    'Shubhashish realestate services private limited',
    'GAYATRI HIGHWAYS LIMITED',
    'RPS INDUSTRIES PRIVATE LIMITED',
    'Hanu reddy realty india private limited',
    'Hills and vales real estate private limited',
    'Sheetal chaya properties pvt. ltd.',
    'S k j developers private limited',
    'Vintage nirman private limited',
    'Uday niwas pvt ltd',
    'Vajram estates private limited',
    'Brio homes private limited',
    'Pp infracon private limited',
    'Xpert homez private limited',
    'EMENOX INFRATEK PRIVATE LIMITED',
    'Seven star infratech private limited',
    'Valion realty private limited',
    'Amitronics properties private limited',
    'Moon day realtors private limited',
    'V r holdings private limited',
    'Mahendra homes private limited',
    'Azven realty ventures private limited',
    'Guardian builders and realtors private limited',
    'Parsn built well private limited',
    'Sudarshan properties private limited',
    'PARASHAKTI HOUSES PRIVATE LIMITED',
    'Krupa land limited',
    'NOVELTY REALTY & DEVELOPERS LIMITED',
    'Iconic realtors limited',
    'Abacus real estate private limited',
    'Arihant paradise realty private limited',
    'Nidhaan buildcon private limited',
    'Springhills enterprises private limited',
    'Waltz properties private limited',
    'Gyana properties private limited',
    'Kesar infracon private limited',
    'PRPL ENTERPRISES PRIVATE LIMITED',
    'AASAN CORPORATE SOLUTIONS PRIVATE LIMITED',
    'Nival developers private limited',
    'Rad properties private limited',
    'Arthveda northstar (pune) realty private limited',
    'Arthvedastar (vijayawada) realty private limited',
    'Arthvedastar (jamnagar) realty private limited',
    'Arthvedastar (jaipur) realty private limited',
    'Arthveda northstar (raipur) realty private limited',
    'Solid landmarks private limited',
    'KARHA DEVELOPERS & MINERS PRIVATE LIMITED',
    'Susi infrastructure private limited',
    'Godavari homes ltd',
    'Manikya corporation limited',
    'Rangalakshmi estates private limited',
    'Jandhyala infrastructure private limited',
    'Ksv developers private limited',
    'Rajesh devcon private limited',
    'Blueland promoters private limited',
    'Debson housing infra projects private limited',
    'Alchemy leisure and resorts private limited',
    'Shipra leasing private limited',
    'Natalia estates private limited',
    'Fast track realtors private limited',
    'Belgravia projects private limited',
    'Shipra reality private limited',
    'Doric homes private limited',
    'Vipul modern buildcon private limited',
    'White pigeon estate private limited',
    'Baya weaver limited',
    'Global sources exhibitions & events (india) private limited',
    'Jesco projects (india) private limited',
    'Invt electric india private limited',
    'Ashirwad shippping & logistics private limited',
    'R.r.sons valuers and consultants private limited',
    'Claycan business solutions private limited',
    'Nereus consultants private limited',
    'Prudence analytics and software solutions private limited',
    'Msa global logistics private limited',
    'Alia premedia services private limited',
    'Windlass sons private limited',
    'Regreen enterprises private limited',
    'Ss eduks management consultants private limited',
    'Apogee process control consulting private limited',
    'Nail spa private limited',
    'Nkb technovations private limited',
    'Coreview systems private limited',
    'Kent intelligent transportation systems (india) private limited',
    'Associated partners private limited',
    'Global insurance consultants private limited',
    'Megdap innovation labs private limited',
    'Trio agri solutions private limited',
    'Vervetronics imagineering private limited',
    'AVANOS MEDICAL INDIA PRIVATE LIMITED',
    'ECAP EQUITIES LIMITED',
    'Medi mart india private limited',
    'Startupoxygen.com private limited',
    'VAYA ADVISORY SERVICES PRIVATE LIMITED',
    'Ritvik digitech private limited',
    'Gk marcomm india private limited',
    'Seasons biologicals private limited',
    'Sepra exim private limited',
    'Regus office centre services (chennai) private limited',
    'Icm insurance brokers private limited',
    'Gamma insurance brokers private limited',
    'Gaps ventures private limited',
    'Securo facility management private limited',
    'RESILIENT AGENCIES PRIVATE LIMITED',
    'Melker finance and leasing private limited',
    'ESBEE INFRA RESOURCES PRIVATE LIMITED',
    'Elite properties & facility management services private limited',
    'Shriram vyapar private limited',
    'GREENVIRONMENT INNOVATION & MARKETING INDIA PRIVATE LIMITED',
    'Cachet innovation and transformation private limited',
    'Mpr technique (india) private limited',
    'Chase energy (india) private limited',
    'Vme logistics private limited',
    'Amaze tech solutions private limited',
    'Iris techsolve india private limited',
    'Truetech solutions private limited',
    'Archimedis healthcare private limited',
    'Cleon optobiz private limited',
    'Gusto systems private limited',
    'Koyel agencies private limited',
    'Custodian corporate services private limited',
    'ELEANORA LEGAL SOLUTION PRIVATE LIMITED (OPC)',
    'Sitics logistic solutions private limited',
    'Key profiles (india) private limited',
    'ICECOAT PAINTS PRIVATE LIMITED',
    'Rize @ people konnect private limited',
    'Manpower resources india private limited',
    'Talent maximus india private limited',
    'Vibrant screen private limited',
    'Vcsme ratings private limited',
    'R. s. hitech security private limited',
    'Sks capital & research private limited',
    'Eximo tek india private limited',
    'Hometech services private limited',
    'Kemtec india photographic co pvt ltd',
    'Gls films industries private limited',
    'Shinde packaging private limited',
    'Emcor packaging private limited',
    'Hindustan facilities private limited',
    'Igi investments private limited',
    'C g parivar foundation and research centre',
    'V-ensure pharma technologies private limited',
    'EXHICON EVENTS MEDIA SOLUTIONS LIMITED',
    'Focus 360 degrees media private limited',
    'Tam logistics private limited',
    'Aimm freight forwarders india private limited',
    'AARJA BUILDCON PRIVATE LIMITED',
    'Mnb digital solutions private limited',
    'Xebec design and facilities private limited',
    'Rachna diamond house private limited',
    'Shradha designtech private limited',
    'Morphosis arkitectural designs private limited',
    'Aishwarya design studio private limited',
    'DWARKA ART EXPORTS PRIVATE LIMITED',
    'Sophia 203 designs private limited',
    'Cfm aircraft engine support south asia private limited',
    'THE ASTROBUDDY ASTROLOGY COMPANY OF INDIA PRIVATE LIMITED',
    'Poco loco hospitality private limited',
    'SARIPUDI AUTO MOTIVES PRIVATE LIMITED',
    'Aft hsrp solutions private limited',
    'Corporate impex consultants pvt. ltd.',
    'Moody international certification india limited',
    'Ernst & young services private limited',
    'Rail vikas nigam limited',
    'K m s constructions pvt ltd',
    'Bhabha ceramic private limited',
    'Super tiles and marble pvt ltd',
    'Duratech cements india limited',
    'Birla cement (assam) limited',
    'Mahaphant fibre-cement (south asia) private limited',
    'ULTRATECH NATHDWARA CEMENT LIMITED',
    'Shree maateshwari mercantile private limited',
    'Nimco prefab private limited',
    'APEXX CREATIVE INFRA PRIVATE LIMITED',
    'Precision cups private limited',
    'Seaga india private limited',
    'UNIFRAX INDIA PRIVATE LIMITED',
    'Aristo transmission private limited',
    'MOMIFY FOODS PRIVATE LIMITED',
    'Karneet enterprises(india)private limited',
    'Key products private limited',
    'VISTARA INDUSTRIES (I) PRIVATE LIMITED',
    'Dhv fitting private limited',
    'Magnum unitube private limited',
    'Kanoria tools private limited',
    'Mahadev forge private limited',
    'Sri salasar balaji metals private limited',
    'Yazdani steel & power limited',
    'Surya smelters private limited',
    'Pankaj metal centre pvt. ltd.',
    'Shakambhari overseas trades private limited',
    'Vir alloys and steel company private limited',
    'ETCO TELECOM Private Limited',
    'Smita steels rolling mills private limited',
    'Viswacon engineers private limited',
    'Europan metals pvt. ltd.',
    'ROCKTEC INFRA AND MINING PRIVATE LIMITED',
    'Shyam ferro alloys ltd.',
    'Rattan ispat private limited',
    'Eastland exports company private limited',
    'Integrated alloys private limited.',
    'Metal power (india) private limited',
    'Akshaet engineering and construction services private limited',
    'Concord wire form private limited',
    'Malabar extrusions private limited',
    'Infinite metals private limited',
    'Instawall aluminium private limited',
    'United roofing systems private limited',
    'Jayachandran industries private limited',
    'Govind solvents private limited',
    'Edayar Zinc Limited',
    'Metal arts creation private limited',
    'Aanal aluminium private limited',
    'CAPTAIN TECHNOCAST LIMITED',
    'MODI ASSET MANAGEMENT PRIVATE LIMITED',
    'NVENT THERMAL INDIA PRIVATE LIMITED',
    'Sunvik steels private limited',
    'Belgaum ferro cast (india) private limited',
    'Kiron hydraulic needs private limited',
    'Nagappa springs private limited',
    'Pulkit metals private limited',
    'Integrated equipment (india) private limited',
    'Nbr engineering private limited',
    'Acumac machine tools private limited',
    'Jun india jigs manufacturers private limited',
    'Mallik engineering (india) private limited',
    'DAJIBHAI KIKA & SONS ENGINEERS PRIVATE LIMITED',
    'Trend technologies india pune private limited',
    'Forming india private limited',
    'Sesha tools private limited',
    'Qpoint engineering solutions private limited',
    'Slingco india private limited',
    'Magod laser machining private limited',
    'Precision mouldings private limited',
    'Lee spring company india private limited',
    'Shraddha ispat private limited',
    'Maillefer extrusion india private limited',
    'Sri sastha precision products private limited',
    'Whitford india private limited',
    'Canbake engineering works private limited',
    'Warren & brown technologies india private limited',
    'Technovision engineers private limited',
    'Jay precision products (india) private limited',
    'Omco enterprises private limited',
    'Sobha trading private limited',
    'ALUMATIC CANS PRIVATE LIMITED',
    'Transafe services ltd.',
    'Adaptive technology (india) private limited',
    'Wilman associates (india) private limited',
    'Manish machinery private limited',
    'Altenmo technologies private limited',
    'Fastenal india sourcing it and procurement private limited',
    'GOYAL IRON & STEEL (NAGPUR) PRIVATE LIMITED',
    'Subhiksham engineering private limited',
    'Anmol safety products private limited',
    'Usha compressors private limited',
    'Db pump tech industries private limited',
    'Sealexcel india pvt ltd',
    'Ascent aquajack india private limited',
    'Lakshmi valves private limited',
    'Motherson consultancies service limited',
    'Xangbo trading (india) private limited',
    'Hariti enterprises private limited',
    'Prestomac finishers private limited',
    'Hudson imports private limited',
    'Plasmagen biosciences private limited',
    'Rainproof exports private limited',
    'Zenith barter private limited',
    'Ajramar impex private limited',
    'Gennex marketing solutions private limited',
    'Shree vallabh marketing private limited',
    'H k s impex private limited',
    'Rashi global private limited',
    'Layon international private limited',
    'Dixon asia pacific private limited',
    'Aimer trading private limited',
    'JAINCO FABRICS PRIVATE LIMITED',
    'Hbc-radiomatic india private limited',
    'Saab india trading enterprises private limited',
    'George maijo exports private limited',
    'Pentagon associates private limited',
    'Velavan impex private limited',
    'Peevees oil company private limited',
    'Samtech engineering services private limited',
    'Dra builders private limited',
    'Cmj services private limited',
    'Spasht marketing (p) ltd',
    'Ajay vinimay private limited',
    'Suresh vinimay private limited',
    'Decent suppliers private limited',
    'Darsh tradecom private limited',
    'Shivkripa commercial private limited',
    'Panchparv commodeal private limited',
    'Randata commercial private limited',
    'Rashiamrit vintrade private limited',
    'Shivrashi exports private limited',
    'Congius tradecom limited',
    'Leuco commercial limited',
    'STEALTH MODE PRIVATE LIMITED',
    'Prayosha expo private limited',
    'CEDAR RETAIL PRIVATE LIMITED',
    'Jadstone trading private limited',
    'Ideal brands private limited',
    'A a motiwala jewellers private limited',
    'R r universal private limited',
    'Subhang trading private limited',
    'Icarus agency private limited',
    'Neelakshi multitrade private limited',
    'Sriz enterprise solutions private limited',
    'Shivratri vyapaar private limited',
    'Grace drinks private limited',
    'Phoenix retail private limited',
    'Madison specialist communication services private limited',
    'IMAGINE MARKETING LIMITED',
    'S t prithima trading private limited',
    'Polytrend impex private limited',
    'Lipin exports private limited',
    'Millionaire fashion private limited',
    'Vijay shoes private limited',
    'LAKSHMI AIRCONS MEP INDIA PRIVATE LIMITED',
    'Intersol projects chennai private limited',
    'Lifestyle impex private limited',
    'Sras india private limited',
    'Rose plastic india private limited',
    'WILDCRAFT INDIA LIMITED',
    'Virtual automation services private limited',
    'A & v jewels private limited',
    'Vardhaman megatech private limited',
    'Waterfield retail private limited',
    'Fizdi ecommerce private limited',
    'Airplaza retail holdings private limited',
    'MANNDOLA E-TRADE PRIVATE LIMITED',
    'GUTS ELECTRO-MECH LIMITED',
    'Papillon market innovators private limited',
    'Phoolwala.com private limited',
    'Shalin online stores private limited',
    'Ashnam retail private limited',
    'Kaveri tradex private limited',
    'HYKON INDIA LIMITED',
    'Cpc diagnostics private limited',
    'Janaki enterprises private limited',
    'SRI ANNAMALAIYAR MATCH WORKS PRIVATE LIMITED',
    'Sadavir trading private limited',
    'Graffiti ventures limited',
    'Sai palace hotels private limited',
    'Vasu hotels private limited',
    'Arkith hotels private limited',
    'Goldfinch resorts private limited',
    'Shri sthal resorts private limited',
    'DANGEE DUMS LIMITED',
    'Delight hotels private limited',
    'Komarala hotelsandresorts private limited',
    'Tristar hotels private limited',
    'Vikat hotels private limited',
    'Guha hotels and resorts limited',
    'Courtyard hotels and resorts private limited',
    'Eatrepeat india private limited',
    'Hotel millennium continental private limited',
    'Hotel corporation of india limited',
    'Sahara hospitality limited',
    'Pranavah taste buds restaurant private limited',
    'Carnoustie resorts private limited',
    'Carnoustie eco-resorts private limited',
    'Mars hospitality services private limited',
    'Blackstone group technologies private limited',
    'Serene infrastructure private limited',
    'Expertus infotech private limited',
    'VERNALIS ENGINEERING SOFTWARE PRIVATE LIMITED',
    'Sukraa software solution private limited',
    'Merit software services private limited',
    'Alpha business solutions private limited',
    'Tekoncall technology services private limited',
    'Flexi code technologies private limited',
    'DATATRACKS SERVICES PRIVATE LIMITED',
    'Alfalogic solutions india private limited',
    'Gbc technologies private limited',
    'Hexacorp technical services private limited',
    'Di mextreme software private limited',
    'Codify info solutions private limited',
    'Galaxy multimedia ( india ) private limited',
    'Vizzitec solutions private limited',
    'Cable partner call solutions india private limited',
    'Adorn consultants private limited',
    'Skew infotech private limited',
    'S. r. data services private limited',
    'Ebizindia consulting private limited',
    'Medi-net services private limited',
    'Millennium info-management private limited',
    'Metston technologies private limited',
    'BHARTI ENTERPRISES LIMITED',
    'Bharti overseas private limited',
    'Mvd technologies private limited',
    'Keysight technologies international india private limited',
    'Aerocraft engineering (india) private limited',
    'DOTGO PRIVATE LIMITED',
    'Atic data systems private limited',
    'Zeus consulting private limited',
    'Better builders and developers private limited',
    'Parth knowledge network private limited',
    'Quetzal online private limited',
    'Ananta infotech private limited',
    'Ppms networks private limited',
    'Infinity inet solutions private limited',
    'Farsoft infotech private limited',
    'Thinkcode technologies private limited',
    'Unlock technologies private limited',
    'Alc indy cbma private limited',
    'Apmosys technologies private limited',
    'Profitbooks solutions private limited',
    'SRISYS ENTERPRISES PRIVATE LIMITED',
    'Modak analytics software private limited',
    'Enterprise softlabs private limited',
    'S3mak technology solutions private limited',
    'Iplanetsoft global solutions private limited',
    'Real value systems india private limited',
    'Mmc infotech services private limited',
    'Leaap logics private limited',
    'Rjp infotek private limited',
    'Way2smile solutions private limited',
    'Ros engineering private limited',
    'Gautam zen zoetrope private limited',
    'Zones corporate solutions private limited',
    'Omega analytics private limited',
    'Prism artec india private limited',
    'Super nube it services private limited',
    'Exceed management private limited',
    'Arbiva technologies private limited',
    'Computer planet chennai private limited',
    'Hyperverge technologies private limited',
    'Rabwin industries private limited',
    'Innostax software labs private limited',
    'Journeymart private limited',
    'Strivex consulting private limited',
    'Goip global solutions private limited',
    'Dreamdax technology private limited',
    'Bitcubeinsight solutions private limited',
    'Webvirtue technology private limited',
    'Rajivihaan consultants private limited',
    'Mint bird technologies private limited',
    'Upayas infotech private limited',
    'Sns solutions private limited',
    'Et medialabs private limited',
    'Jamsons computers private limited',
    'Ace computer education private limited',
    'Epitome corporation private limited',
    'Livebird technologies private limited',
    'Proparent solutions private limited',
    'White butter private limited',
    'Ideogram technology solutions private limited',
    'Alpha technocon private limited',
    'Rooman technologies private limited',
    'Envision network technologies private limited',
    'Aiplex software private limited',
    'Fiberlink software private limited',
    'Moham infosolutions private limited',
    'Cellworks research india private limited',
    'Invent softlabs (india) private limited',
    'ANCIENT PHARMACUETICAL INDUSTRIES LIMITED',
    'ANDAAZ ESTATE AND DEVELOPERS PRIVATE LIMITED',
    'BHARAT RASAYAN LIMITED',
    'ANGAD IMPEX PRIVATE LIMITED',
    'Angel Quality Solutions Private Limited',
    'ANGLE FASHIONS PRIVATE LIMITED',
    'BHAUMIK BUILDWELL PRIVATE LIMITED',
    'BGSB CONCRETE SOLUTIONS PRIVATE LIMITED',
    'BHAWANA CAPITAL PRIVATE LIMITED',
    'Bhodhi Dharma Entertainment & Productions Private Limited',
    'BHOLA NATH KHANNA AND CO PVT LTD',
    'Bhoomipooja Shelters Private Limited',
    'BH ARCHITECTS INDIA PRIVATE LIMITED',
    'Bhubaneshwar Expressways Private Limited',
    'BHUPINDER HOLDINGS PRIVATE LIMITED',
    'BHUVANESH BUILDWELL PRIVATE LIMITED.',
    'ANGLES CONSTRUCTIONS LIMITED',
    'BIGBROTHER NUTRA CARE PRIVATE LIMITED',
    'ANAEMICA FIN-SEC PRIVATE LIMITED',
    'SURVAICO CONSULTING PRIVATE LIMITED',
    'ANS CONSTRUCTIONS Private Limited',
    'ANAMIKA ADVERTISERS PRIVATE LIMITED',
    'GOPAL GEMS & JEWELS PRIVATE LIMITED',
    'GOPAL NUTS PRIVATE LIMITED',
    '7TH PILLAR INFO TECH PRIVATE LIMITED',
    'MAMTA ENTERTAINMENT PRIVATE LIMITED',
    'GOPALA SOFTECH PRIVATE LIMITED',
    'ANANDA INDUSTRIES PRIVATE LIMITED',
    'GOPALJEE CLEAN MILK PRODUCTION PRIVATE LIMITED',
    'ANANDA DAIRY LIMITED',
    'GOLDSTAR ESTATES PRIVATE LIMITED',
    'GOOD LUCK STRUCTURE PRIVATE LIMITED',
    'GOODRICH GLOBAL FURNISHING INDIA PRIVATE LIMITED',
    'GOYAL PUBLISHERS AND DISTRIBUTORS PRIVATE LIMITED',
    'COGNIC SYSTEMS PRIVATE LIMITED',
    'DESATAN IRON & STEEL PRIVATE LIMITED',
    'TOPGRAIN MANAGEMENT PVT LTD',
    'GOODS AND SERVICES TAX NETWORK',
    'AAKRUTI MARKETING PRIVATE LIMITED',
    'CLICK TO TRAVEL PRIVATE LIMITED',
    'CLICKS THRU NETWORK PRIVATE LIMITED',
    'AEGIS INFOTECH PRIVATE LIMITED',
    'JAMES LIND INSTITUTE PRIVATE LIMITED',
    'BALAJI SECURITY SERVICES PRIVATE LIMITED',
    'NARDHANA INFRASTRUCTURE LIMITED',
    'Cloudzilla India Private Limited',
    'CARGO LOGISTICS (INDIA) PRIVATE LIMITED',
    'GOODWORD BOOKS PRIVATE LIMITED',
    'GOLDEN APPARELS EXPORTS PRIVATE LIMITED',
    'GOODWORTH OVERSEAS PRIVATE LIMITED',
    'PARAKKAT RESORTS PRIVATE LIMITED',
    'iDataLytics Private Limited',
    'BEST INDIA FOOD PROCESSING PRIVATE LIMITED',
    'Coldex Logistics Private Limited',
    'OOPS INFOMATICS PRIVATE LIMITED',
    'Colorful Media Private Limited',
    'Colors Infracon Private Limited',
    'COLT TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'Columbus Integration Services Private Limited',
    'COMET SURGICALS PRIVATE LIMITED',
    'BITULINK WAYMARK PRIVATE LIMITED',
    'SCHEMA TECHNOLOGIES PRIVATE LIMITED',
    'AZE INFINITY PRIVATE LIMITED',
    'S2 ENGINEERING INDUSTRY PRIVATE LIMITED',
    'ETHICL FASHION & ACCESSORIES PRIVATE LIMITED',
    'CHOCKALINGAM FOUNDATION',
    'NATURALMARK LAB PRIVATE LIMITED',
    'ARANCARE INDIA PRIVATE LIMITED',
    'ASK TANKER (INDIA) PRIVATE LIMITED',
    'SOLARCRAFT POWER INDIA 5 PRIVATE LIMITED',
    'BENVANZ IT SOLUTIONS (OPC) PRIVATE LIMITED',
    'HIRANYAMAI MARKETING PRIVATE LIMITED',
    'ACME SURYA POWER PRIVATE LIMITED',
    'SMARTWISDOM TECHNICAL SERVICES PRIVATE LIMITED',
    'INVISION REALITY AND VENTURES PRIVATE LIMITED',
    '10BUCKS DESIGNS (OPC) PRIVATE LIMITED',
    'SS PRIMEONE SERVICES PRIVATE LIMITED',
    'MEDICITY RESEARCH INSTITUTE (OPC) PRIVATE LIMITED',
    'MYSTIC KINGDOM PRIVATE LIMITED',
    'SEVA INFOTECH PRIVATE LIMITED',
    'INTERNATIONAL TEAM FOR IMPLANTOLOGY (INDIA) PRIVATE LIMITED',
    'LYTX INDIA TECHNOLOGIES PRIVATE LIMITED',
    'FINSUN ADVISOR PRIVATE LIMITED',
    'HYBRID INKS STUDIO PRIVATE LIMITED',
    'CONTLO TECHNOLOGIES PRIVATE LIMITED',
    'JALAN MICA EXPORTS PRIVATE LIMITED',
    'GHENT HOSPITALITY PRIVATE LIMITED',
    'AADITHEV INFRATECH LIMITED',
    'REOSIT PRIVATE LIMITED',
    'PLUS SAW INDIA PRIVATE LIMITED',
    'CMBR BIOTECH PRIVATE LIMITED',
    'KK & SON CONSTRUCTIONS PRIVATE LIMITED',
    'PROVIDENCE PROVEST PRIVATE LIMITED',
    'LOOKBOOK TRAVELS (OPC) PRIVATE LIMITED',
    'AIONIZ TECHNOLOGIES PRIVATE LIMITED',
    'NDR TRADEHOUSE PRIVATE LIMITED',
    'JUSTO E-COMMERCE PRIVATE LIMITED',
    'AEGTE LIFESCIENCE PRIVATE LIMITED',
    'MY PACK PRIVATE LIMITED',
    'YAS DIGIKRAF PRIVATE LIMITED',
    'VILLAGE SHOW PRIVATE LIMITED',
    'SM SQUARE CREDIT SERVICES PRIVATE LIMITED',
    'BIONIC IMPRINTS PRIVATE LIMITED',
    'AMPLO GLOBAL STRATEGY AND ANALYTICS PRIVATE LIMITED',
    'FINANCE BRAIN PRIVATE LIMITED',
    'INTRICS SOLUTIONS PRIVATE LIMITED',
    'VIA JURE ADVISORS PRIVATE LIMITED',
    'OFFSET GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'FINQUICK TECHNOLOGY PRIVATE LIMITED',
    'ARASPORT RACING PRIVATE LIMITED',
    'PLANTSNPEBBLES (OPC) PRIVATE LIMITED',
    'SAFA SYSTEMS & TECHNOLOGIES LIMITED',
    'INTEGRAL BIO SERVICES PRIVATE LIMITED',
    'ENVOFIX INTERNATIONAL PRIVATE LIMITED',
    'VITAL B2B PRIVATE LIMITED',
    'NEIMAN MARCUS GLOBAL TECHNOLOGY SERVICESPRIVATE LIMITED',
    'EKAA PACKAGING AND INDUSTRIES PRIVATE LIMITED',
    'ENINE REMEDIES PRIVATE LIMITED',
    'PHARMACARE AURA PRIVATE LIMITED',
    'PAGGDANDI TOURS & TRAILS (OPC) PRIVATE LIMITED',
    'ALPHAGROWTH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EVVIVA RETAIL (OPC) PRIVATE LIMITED',
    'SPG RICE MILLS PRIVATE LIMITED',
    'AINITI INDIA FOUNDATION',
    'ASHRAY NIWAS PRIVATE LIMITED',
    'TRIO-S SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'ARCHIAN FOODS PRIVATE LIMITED',
    'BIRD AIRPORT SERVICES (IMPHAL) PRIVATE LIMITED',
    'SRINIWASA ORGANIC FOOD AND HEALTH PRODUCTS PRIVATE LIMITED',
    'PURAMIO INDIA PRIVATE LIMITED',
    'ASCENT FUND SERVICES (INDIA) PRIVATE LIMITED',
    'ANURITI LIFE FOUNDATION',
    'VRAJ CARE FOUNDATION',
    'OZONE ENGINEERS PRIVATE LIMITED',
    'PINAKI TOURS PRIVATE LIMITED',
    'KASHYAP MEDICAL & EDUCATIONAL FOUNDATION',
    'UPPERHANDOPS PRIVATE LIMITED',
    'EMIDAS TECHNOLOGY PRIVATE LIMITED',
    'GYMPOINT STUDIO PRIVATE LIMITED',
    'BADEE PHARMACEUTICAL (OPC) PRIVATE LIMITED',
    'ALLANA CONSUMER PRODUCTS PRIVATE LIMITED',
    'PROGRAD TALENT SOLUTIONS PRIVATE LIMITED',
    'ENCHAPPILLIL FINSERV PRIVATE LIMITED',
    'CLUTTERBOT TECHNOLOGIES PRIVATE LIMITED',
    'TRIWAY COMMUNICATIONS PRIVATE LIMITED',
    'DIGIAI SOLUTIONS PRIVATE LIMITED',
    'MAGNIFY IT PRIVATE LIMITED',
    'INSPIRE ANALYTICS PRIVATE LIMITED',
    'GLOOBAL MEDIA OUTDOOR PRIVATE LIMITED',
    'DIGNITAS AQUATECH ENGINEERS PRIVATE LIMITED',
    'SN HIRING LAB PRIVATE LIMITED',
    'QUDITBRAIN PRIVATE LIMITED',
    'TECHIEEGY PRIVATE LIMITED',
    'JIYOLIFEBINDASS ONLINE CONSULTING (OPC) PRIVATE LIMITED',
    'HELLO AI PRIVATE LIMITED',
    'STROLLOCK INDIA PRIVATE LIMITED',
    'SHUGOSHA BLOCKCHAIN LABS PRIVATE LIMITED',
    'ONEZTECH ELECTRICALS PRIVATE LIMITED',
    'VISIONTECH INFRA SOLUTION PRIVATE LIMITED',
    'TRENCHES DISPOTEX PRIVATE LIMITED',
    'JANUDYAM CONSUMER WELFARE COUNCIL',
    'AVAAP IT SERVICES PRIVATE LIMITED',
    'TRANSLINGOWORLD PRIVATE LIMITED',
    'ROAD PILOT TECHNOLOGIES PRIVATE LIMITED',
    'VARCH HEALTHCARE (OPC) PRIVATE LIMITED',
    'CROPLN INDIA PRIVATE LIMITED',
    'APTENCE EDTECH PRIVATE LIMITED',
    'FLOWLYF INDIA PRIVATE LIMITED',
    'QUIVIVE AUTOMATA PRIVATE LIMITED',
    'RB INFO SERVICES PRIVATE LIMITED',
    'GUNAVAN FOODS PRIVATE LIMITED',
    'ND BUILDCON PRIVATE LIMITED',
    'SKYDOR GROOMING PRIVATE LIMITED',
    'STUDIO MAHATTA PRIVATE LIMITED',
    'NANDANA MAGNOLIOUS PRIVATE LIMITED',
    'CARGO HAWK PRIVATE LIMITED',
    'POWERGRID ER NER TRANSMISSION LIMITED',
    'ESSENDON FORMULATIONS PRIVATE LIMITED',
    'ABN ELECTRIC PRIVATE LIMITED',
    'ALMASA BUSINESS SERVICES PRIVATE LIMITED',
    'BANG AGRO INDUSTRIES PRIVATE LIMITED',
    'RESIDUOS RECYCLING PRIVATE LIMITED',
    'SL CARGO PRIVATE LIMITED',
    'CRECER ENTERTAINMENT PRIVATE LIMITED',
    'KALVI CAREER EDUCATION PRIVATE LIMITED',
    'THAJES TECHNOCRAFT PRIVATE LIMITED',
    'YOUYOG HEALTH AND HUMAN WELLBEING PRIVATE LIMITED',
    'GH CRM SERVICES PRIVATE LIMITED',
    'BB COMTRADE PRIVATE LIMITED',
    'MUSKAN NUTRITION PRIVATE LIMITED',
    'ALTLAUNCH SERVICES PRIVATE LIMITED',
    'CHOICECAMPAIGNS STUDY ABROAD PRIVATE LIMITED',
    'COMPUTERCARE (4RITZ INDIA) PRIVATE LIMITED',
    'SEPLA FOODS LIMITED',
    'DIGITAL ANALYTIQ SOLUTIONS (OPC) PRIVATELIMITED',
    'INCOGNIA INFO TECH PRIVATE LIMITED',
    'BEGUILES DEVELOPMENT PRIVATE LIMITED',
    'RAJWARE SERVICES PRIVATE LIMITED',
    'MANINDA NIRMAN PRIVATE LIMITED',
    'MET SIMULATION PRIVATE LIMITED',
    'MAAS ERP SOLUTIONS PRIVATE LIMITED',
    'GROUND HOLDING CONSTRUCTIONS PRIVATE LIMITED',
    'INDYFIN TECHNOLOGY PRIVATE LIMITED',
    'RELIAQUEST INDIA PRIVATE LIMITED',
    'NWT GLOBAL SOLUTIONS PRIVATE LIMITED',
    'KEMIA TAU INDIA PRIVATE LIMITED',
    'RENTACO (OPC) PRIVATE LIMITED',
    'BEGUILES PROJECTS PRIVATE LIMITED',
    'WALDOM ELECTRONICS PRIVATE LIMITED',
    'REL RURAL WAREHOUSING LIMITED',
    'RETAIL PULSE LABS PRIVATE LIMITED',
    'ASQUIRE GLOBAL FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'WORKBELL TECHNOLOGIES PRIVATE LIMITED',
    'WOW CONSTRUCTION AND INTERIORS PRIVATE LIMITED',
    'DEFESA TECHNOLOGIES PRIVATE LIMITED',
    'BANGALORE TOWER PRIVATE LIMITED',
    'INNOVITES INDIA PRIVATE LIMITED',
    'NANOANTIMICROBIAL PRIVATE LIMITED',
    'KANSYAM METAL PRIVATE LIMITED',
    'TECHNOLINE MACHINES AND SOLUTION PRIVATELIMITED',
    'ART AVENUE PRIVATE LIMITED',
    'GROWBIT BUSINESS SERVICES PRIVATE LIMITED',
    'FP ORKA PRIVATE LIMITED',
    'VJ SECURITY AND PROPERTY SOLUTIONS PRIVATE LIMITED',
    'BOOSTMYCHILD PRIVATE LIMITED',
    'KARTYA TEXTILES PRIVATE LIMITED',
    'CISTRON STEEL TECHNOLOGIES PRIVATE LIMITED',
    'BALANCE AIR EQUIPMENTS PRIVATE LIMITED',
    'AWSM TECH INDIA PRIVATE LIMITED',
    'TPF GETINSA EUROESTUDIOS SL JV TPF ENGINEERING PRIVATE LIMITED',
    'WATERLOO PETROCHEM PRIVATE LIMITED',
    'ADU INFOCORP (OPC) PRIVATE LIMITED',
    'ABITI BELLA PRIVATE LIMITED',
    'MSPEC MANUFACTURING SOLUTIONS PRIVATE LIMITED',
    'IRAJ INTERNATIONAL PRIVATE LIMITED',
    'AITHIHA APPARELS PRIVATE LIMITED',
    'NANOMAGNETITE PRIVATE LIMITED',
    'PSYSWARM PRIVATE LIMITED',
    'PRANAT COMMODITIES PRIVATE LIMITED',
    'SEVEN TURNS PRIVATE LIMITED',
    'SPG BIO FUEL PRIVATE LIMITED',
    'HEVEA REVELATION TECHNOLOGIES PRIVATE LIMITED',
    'AIRMEDIA BROADCAST SOLUTIONS PRIVATE LIMITED',
    'FURGONOMICS BY UNTITLED PRIVATE LIMITED',
    'NABS DWELLING PRIVATE LIMITED',
    'NABS VILLAS PRIVATE LIMITED',
    'GLAM GUIDANCE PRIVATE LIMITED',
    'NABS TECHPARK PRIVATE LIMITED',
    'QR AGRI MARKETING PRIVATE LIMITED',
    'VALUON STRATEGIC (OPC) PRIVATE LIMITED',
    'KKYZER INTERNATIONAL OVERSEAS SERVICES PRIVATE LIMITED',
    'WAHCOMMERCE TECHNOLOGIES PRIVATE LIMITED',
    'K R SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'RIVDX SYSTEMS PRIVATE LIMITED',
    'DILIP SONIGARA JEWELLERS PRIVATE LIMITED',
    'VEGMA FARM FRESH PRIVATE LIMITED',
    'BONPHUL FOODS PRIVATE LIMITED',
    'OSSWAL BUSINESS SERVICES PRIVATE LIMITED',
    'GFFCO GLOBAL PRIVATE LIMITED',
    'FLUMESTACK PRIVATE LIMITED',
    'ARIVIYA DEEP TECH PRIVATE LIMITED',
    'TECHEMANTH IT SOLUTIONS PRIVATE LIMITED',
    'ZIVALO CONSULTANCY SERVICES PRIVATE LIMITED',
    'AVIS BUSINESS AVIATION SERVICES PRIVATE LIMITED',
    'IAECMIND PRIVATE LIMITED',
    'SIVASHAKTI FUTURETECH PRIVATE LIMITED',
    'DIOWISE PRIVATE LIMITED',
    'LMDMAX INDIA PRIVATE LIMITED',
    'SWIFTFISH PRIVATE LIMITED',
    'OLIVEGREEN LIFESTYLE PRIVATE LIMITED',
    'CENTER FOR EMBODIED KNOWLEDGE',
    'CRS REAL ESTATE DEVELOPERS PRIVATE LIMITED',
    'AAMARA LOGISTICZ PRIVATE LIMITED',
    'BALLALESHWAR HOUSING PRIVATE LIMITED',
    'EASSYBAGG.IN (OPC) PRIVATE LIMITED',
    'NAMASTE MANAKAMANA TOURS AND TRAVELS PRIVATE LIMITED',
    'INVISOR INSTITUTE OF MANAGEMENT PRIVATE LIMITED',
    'DPW INDUSTRY PRIVATE LIMITED',
    'PRACHAARWALA MARKETING SOLUTIONS PRIVATELIMITED',
    'ACHIEVERS TECHNOLOGIES PRIVATE LIMITED',
    'APER MARKETPLACE SOLUTIONS INDIA PRIVATELIMITED',
    'GEEENIUS EVOLUTIONS PRIVATE LIMITED',
    'ARROWPHOSCHEM PRIVATE LIMITED',
    'PRIVADO APPARELS PRIVATE LIMITED',
    'EKKLAVYA TECH INSPIRE PRIVATE LIMITED',
    'XTRAPOWER TOOLS MANUFACTURING PRIVATE LIMITED',
    'BLOWN MARKET PRIVATE LIMITED',
    'TRAINE HEALTH TECH PRIVATE LIMITED',
    'HEMPTEX INDIA PRIVATE LIMITED',
    'NEW GENERATION FACILITY PRIVATE LIMITED',
    'MALCOMKNIGHTS INDUSTRIES & INFRA PRIVATELIMITED',
    'ASSURED INSURTECH SERVICES PRIVATE LIMITED',
    'TAXPLANNERS ASSOCIATES PRIVATE LIMITED',
    'ALGEB TECHNOLOGIES PRIVATE LIMITED',
    'INOUE MFG.& ENGINEERING INDIA PRIVATE LIMITED',
    'BLOOMBAY ENTERPRISES PRIVATE LIMITED',
    'CLEAN AIR CLEAN LUNG FOUNDATION',
    'ALEVANT WELLNESS PRIVATE LIMITED',
    'BELIEV-IN TECHNOLOGIES PRIVATE LIMITED',
    'NIEUWE TECH SERVE PRIVATE LIMITED',
    'INVACT SCHOOL PRIVATE LIMITED',
    'MADHU SILICA FOUNDATION',
    'LORIEN BUSINESS MANAGEMENT PRIVATE LIMITED',
    'CPE TECH PRIVATE LIMITED',
    'TEK HUMANITY PRIVATE LIMITED',
    'PURELIFE CLINIC MANAGEMENT PRIVATE LIMITED',
    'KINASA ENERGY PRIVATE LIMITED',
    'INNRESEARCH MARKET SOLUTION PRIVATE LIMITED',
    'MAA SHAKUMBARI AGRO TOURISM PRIVATE LIMITED',
    'ECOMHEROES INFOTECH PRIVATE LIMITED',
    'BUILD YOUR OWN BRAND PRIVATE LIMITED',
    'PRESTIGE ACRES PRIVATE LIMITED',
    'INSOLUTES PRIVATE LIMITED',
    '1 FINANCE PRIVATE LIMITED',
    'SRI BHUVANESWARI ELECTRICALS PRIVATE LIMITED',
    'SATURDAY TECHNOLOGIES PRIVATE LIMITED',
    'ABYS FASHION PRIVATE LIMITED',
    'RB FINSOL PRIVATE LIMITED',
    'BIMCLUES SOLUTIONS PRIVATE LIMITED',
    'ONAIZA PRIVATE LIMITED',
    'HEALTHACO PRIVATE LIMITED',
    'NISMAAYA FURNDEC PRIVATE LIMITED',
    'KINAB CONSULTING PRIVATE LIMITED',
    'SKAT ORGANICS PRIVATE LIMITED',
    'MUSKOX FARMS PRIVATE LIMITED',
    'FUSSY MESSY VENTURES PRIVATE LIMITED',
    'ETH BIOFUELS PRIVATE LIMITED',
    'WYTEFIELD FURNITURE PRIVATE LIMITED',
    'MANUKA FARMS PRIVATE LIMITED',
    'STARNEXX MANAGEMENT SERVICES PRIVATE LIMITED',
    'SAMPURNA PATHSHALA PRIVATE LIMITED',
    'SHRINIDHI VIPANAN (OPC) PRIVATE LIMITED',
    'ODDBOX BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CONVERA INDIA PRIVATE LIMITED',
    'I EDUCATE MYSELF DAILY FOUNDATION',
    'MANGLAM CONCEPT PRIVATE LIMITED',
    'REINDEER FARMS PRIVATE LIMITED',
    'BAHADURPUR PATORY NIDHI LIMITED',
    'HALO HUES STUDIOS PRIVATE LIMITED',
    'K WASAN INSURANCE BROKING PRIVATE LIMITED',
    'THARAYIL INSTRUMENTATION DEVICES PRIVATELIMITED',
    'CON10T LABS PRIVATE LIMITED',
    'SAVII NEW CROSS TECHNOLOGY PRIVATE LIMITED',
    'INF ESPORTS PRIVATE LIMITED',
    'GENIETALK MONEY PRIVATE LIMITED',
    'MSRAI',
    'IT ROBOTAI & SOLUTIONS PRIVATE LIMITED',
    'Machinfabrik industries private limited',
    'Millennium precision auto india private limited',
    'Efseon engineering private limited',
    'Proteck precision private limited',
    'Anval valves private limited',
    'Veyyon power solutions private limited',
    'Coninven engineering private limited',
    'Piab vacuum technology private limited',
    'Thermopac boilers private limited',
    'Goldstar polymers limited',
    'Karv devices private limited',
    'VISHAKHA PLASTIC PIPES PRIVATE LIMITED',
    'Suveswaru enterprises private limited',
    'Flash point equipments private limited',
    'PERFORM ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'Amspa engineering private limited',
    'Gowra aerospace technologies private limited',
    'SILENT COOLING SYSTEMS PRIVATE LIMITED',
    'D.p.k.engineers private limited',
    'Yalamanchili manufacturing private limited',
    'Tanmay computer & software private limited',
    'P.b.systems (india) private limited',
    'Confident electronics private limited',
    'Natech solutions (india) private limited',
    'Srd infotech private limited',
    'Salcomp manufacturing india private limited',
    'Unicorn uptime power private limited',
    'Vilas transcore limited',
    'Rajgarh windpark private limited',
    'ATLAS TRANSFORMERS INDIA LIMITED',
    'Aditya vidyut appliances ltd',
    'Accurate weldarc private limited',
    'Consolidated cables private limited',
    'Nordic (india) solutions private limited',
    'Linepro controls private limited',
    'Winspect infosystem private limited',
    'Vishay precision transducers india private limited',
    'Kwk resistors india private limited',
    'Stanley electric sales of india private limited',
    'Roltech conveyors private limited',
    'Slimlites electricals pvt ltd',
    'URAVI T AND WEDGE LAMPS LIMITED',
    'Aura bright light india private limited',
    'Skylight enterprises private limited',
    'Shubham automation private limited',
    'B & C ENERGY INFRA LIMITED',
    'Supinco automation private limited',
    'Avon building solutions private limited',
    'Thames side sensors india private limited',
    'Shrooqal energy private limited',
    'Pigeon appliances private limited',
    'Swemed biomedicals private limited',
    'Cst 2000 (india) private limited',
    'Rapid application methodologies private limited',
    'Mag web technologies private limited',
    'Vitech systems asia private limited',
    'OSI DIGITAL PRIVATE LIMITED',
    'Xiotech india private limited',
    'Prima impact informatics solutions and consultancy private limited',
    'Val technologies private limited',
    'Acuvate software private limited',
    'Vinsys software technologies private limited',
    'B.i.r solutions india private limited',
    'Infoane technologies private limited',
    'Perceptive analytics private limited',
    'Siritek technologies private limited',
    'Synchroserve global solutions private limited',
    'SUBHUJO TECHNOLOGIES PRIVATE LIMITED',
    'Trillion it services private limited',
    'Lavu soft private limited',
    'Wenable technologies private limited',
    'Acurus solutions private limited',
    'Hma starware private limited',
    'Eg innovations private limited',
    'ORANGESCAPE TECHNOLOGIES PRIVATE LIMITED',
    'Trpc service team private limited',
    'Bon ton softwares private limited',
    'Swaas systems private limited',
    'Gnana software consulting private limited',
    'Ikure techsoft private limited',
    'Eximprise technologies private limited',
    'Smilax solutions private limited',
    'Opiant tech solutions private limited',
    'Vyshnavi information technologies (india)private limited',
    'Tarang software technologies private limited',
    'Qness software private limited',
    'Phamax analytic resources private limited',
    'Comet solutions (india) private limited',
    'Openedex india private limited',
    'BRINDLEY TECHNOLOGIES LIMITED',
    'A2g civil engineering services private limited',
    'PLANET NEXTGEN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Kanix infotech private limited',
    'Prog9 softtech private limited',
    'Customer analytics india private limited',
    'Netaxis it solutions private limited',
    'Lumendata solutions india private limited',
    'Bluelilys internet private limited',
    'Synergy datalinks private limited',
    'Akshaya global informatics private limited',
    'Gewandt consulting service limited',
    'Bizlink interconnect technology ( india ) private limited',
    'Urvara agro biotech private limited',
    'Minimill technologies services international private limited',
    'Panoptic consulting & services private limited',
    'Boss webtech private limited',
    'Digilogix technologies private limited',
    'Startele tech private limited',
    'Fusioni technologies private limited',
    'Eclat engineering private limited',
    'Metrobit networks private limited',
    'Jintech solution limited',
    'Silicon ithub private limited',
    'Electroware infotech private limited',
    'Sonar softech (india) private limited',
    'Speed air live broadband services private limited',
    'Mindlogicx infotech limited',
    'Promyx outsource services private limited',
    'Compnova solutions india private limited',
    'Ide infotech private limited',
    'PCB APPS GLOBAL PRIVATE LIMITED',
    'Ducere softech private limited',
    'Tirdis technologies private limited',
    'Ysecit softwares india private limited',
    'Chipware technologies private limited',
    'UPSTART BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Svapas tech private limited',
    'Idos india private limited',
    'Travancore analytics private limited',
    'Subhosting innovations private limited',
    'Bayasys infotech private limited',
    'Cms engineering services pvt ltd',
    'Itsource technologies limited',
    'Reliance exchangenext limited',
    'Systematics infotech private limited',
    'Neon solutions private limited',
    'Makshi infotech private limited',
    'Infiniti digitech private limited',
    'Seygen technologies india private limited',
    'Snapwork technologies private limited',
    'Mofirst solutions private limited',
    'My city technology limited',
    'K SERA SERA DIGITAL CINEMA LIMITED',
    'Bigsun technologies private limited',
    'Insync gp advisory private limited',
    'Veracity software private limited',
    'GAURAV TEX PRIVATE LIMITED',
    'Atomberg technologies private limited',
    '63 MOONS TECHNOLOGIES LIMITED',
    'SAMVARDHANA MOTHERSON INTERNATIONAL LIMITED',
    'Garnet construction ltd',
    'Mynk1906 industries india limited',
    'Baaz trading and investment limited',
    'Yes bank limited',
    'Network18 media & investments limited',
    'GACM TECHNOLOGIES LIMITED',
    'Xchanging solutions limited',
    'Intergrated digital info services limited',
    'Mudunuru Limited',
    'Camlin fine sciences limited',
    'ELDER PRROJECT LIMITED',
    'Skp securities ltd.',
    'Srs finance limited.',
    'BALU FORGE INDUSTRIES LIMITED',
    'Fast track entertainment limited',
    'Arthos breweries limited',
    'Priya limited',
    'Ring agro private limited',
    'Relic biotechnology private limited',
    'Avn commodities private limited',
    'Snehapragathi agro-tech private limited',
    'Sajeev plantations pvt ltd',
    'Charoen pokphand seeds (india) private limited',
    'Auroch agro products private limited',
    'Pollen seeds private limited',
    'Nanz med science pharma private limited',
    'Multicomm industries limited',
    'Hosachiguru agri tech private limited',
    'Innovest agrotech private limited',
    'Star cultivation private limited',
    'Pankaj cotton company private limited',
    'Hylasco bio-technology (india) private limited',
    'Mediclone biotech private limited',
    'Sanjay green farms private limited',
    'Utsav agro-products limited',
    'Appu nutritions private limited',
    'Oswal commodities private limited',
    'Drytech processes (india) p ltd',
    'Atrimed pharmaceuticals private limited',
    'Saibhya oceanics private limited',
    'H b farm products pvt ltd',
    'Sky onboard marine services private limited',
    'Suraj homes private limited',
    'Hinduja realtors private limited',
    'Bhaskarpara coal company limited',
    'North dhadhu mining company private limited',
    'Aakash minning private limited',
    'Petropath fluids (india) private limited',
    'Leader gas and petrochem limited',
    'CLRK INDUSTRIES PRIVATE LIMITED',
    'Balaji mahima granite private limited',
    'D. bali infrastructures & developers limited',
    'Kakatiya minerals private limited',
    'Cube mines and minerals private limited',
    'Yentop manickam edible oils private limited',
    'Sri vijaya visakha milk producers company limited (part - ix a )',
    'Mahalakshmi alloys and metals private limited',
    'Naveena quality foods private limited',
    'Khopoli roller flour mills pvt ltd',
    'Supreme nutri grain private limited',
    'Bapashree foods private limited',
    'Snow lion foods private limited',
    'Ajmer food products pvt. ltd.',
    'Plus instant beverages and vending private limited',
    'Precious alco and petro india pvt ltd',
    'Fiza agri and farm products private limited',
    'Narendra textiles private limited',
    'FIBRE2FASHION PRIVATE LIMITED',
    'V m yarns private limited',
    'Shubhalakshmi polyesters limited',
    'Dhanuka private limited',
    'Pondicherry textile corporation limited',
    'Jaya varma textiles private limited',
    'Bks textiles private limited',
    'Shri santhosh meenakshi textiles private limited',
    'Member texturisers pvt ltd',
    'M h textile private limited',
    'ITHI ADVISORS PRIVATE LIMITED',
    'Jindal fabrics private limited',
    'Aman infratex limited',
    'Myriad textiles private limited',
    'Ricco raccolto private limited',
    'Sage medihygiene private limited',
    'MG PROCESSORS PRIVATE LIMITED',
    'N. j. textile industries private limited',
    'Bags & sacks india private limited',
    'Weavetex technology and services private limited',
    'Jay deekay dyeing and weaving private limited',
    'Dhc marketing private limited',
    'Primetex apparels india private limited',
    'Adithya designs private limited',
    'Nuvocraft apparels india private limited',
    'S.p. textworld private limited',
    'Sumolo trendz private limited',
    'Singhania fabexports private limited',
    'L LIFESTYLE SERVICES PRIVATE LIMITED',
    'Shigan export private limited',
    'Perinor exports private limited',
    'Aadivighnesh chem private limited',
    'S zhaveri pharmakem private limited',
    'Rahyals med india private limited',
    'ALLFINE INDUSTRIES PRIVATE LIMITED',
    'Alapatt gold den private limited',
    'Reliable fashions india private limited',
    'Mansarovar vyapaar pvt ltd',
    'STALLION INDIA FLUOROCHEMICALS LIMITED',
    'Villeroy & boch sales india private limited',
    'BIC CELLO (INDIA) PRIVATE LIMITED',
    'Selp india private limited',
    'Elite inks private limited',
    'Die-plast private limited',
    'Prem dyechem industries private limited',
    'Onward chemicals private limited',
    'Collective trade links private limited',
    'Shashi dhawal hydraulics private limited',
    'Digiflic controls (india) private limited',
    'Turbo mot india private limited',
    'S sara impex private limited',
    'Green linen private limited',
    'Systea analytical technologies private limited',
    'Kahan trade-links private limited',
    'Redorange general trading private limited',
    'Rameshram exim private limited',
    'Jp & gp marketers and consultants private limited',
    'Iteng engineering private limited',
    'New india exports private limited',
    'M n g business enterprises private limited',
    'Titus trading and agencies limited',
    'Khurana exports pvt ltd',
    'Ramanad properties and agencies private limited',
    'Denis exports p ltd',
    'Vmpl dairy limited',
    'Dachser india private limited',
    'Euroline domestic appliances private limited',
    'G.c. chemie pharmie limited',
    'Mayrose trading and investments private limited',
    'Maha hotel projects private limited',
    'Rishichem distributors private limited',
    'Sipa india private limited',
    'Lavero gifts private limited',
    'Gunmala vinimay pvt ltd',
    'Rava agri chemicals private limited',
    'BDI CITY CENTRE PRIVATE LIMITED',
    'Kapis traders private limited',
    'Blackberry india private limited',
    'Dbm marketing (india) private limited',
    'Mgi ummi manufacturing company private limited',
    'Ajay industrial corporation limited.',
    'Bluebell buying services private limited',
    'Style sports private limited',
    'Jupion electric private limited',
    'Vantage overseas private limited',
    'Sewa trade facilitation centre',
    'Avean marketing and distributors private limited',
    'Urai impex private limited',
    'Parsik traders private limited',
    'Praline leasing and infotech private limited',
    'SAINATH PRESSURE VESSELS PRIVATE LIMITED',
    'Nirav impex private limited',
    'Lamer trade com private limited',
    'Rasmus impex private limited',
    'Lora tradex private limited',
    'Amrit raj metals & minerals private limited',
    'ELITE GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'Adval chemicals private limited',
    'Skywood trading private limited',
    'Pritam singh and sons pneumatics pvt ltd',
    'Arr ess industries private limited',
    'Seamless autotech private limited',
    'K.v. steel and pipes private limited',
    'Biosphere life sciences private limited',
    'Bhs corrugated india private limited',
    'GREENKO (BORAMPALLE) WIND PROJECTS PRIVATE LIMITED',
    'Global cast solutions private limited',
    'Cookson india private limited',
    'P r exports ltd',
    'WESTWIN TRACOM PVT LTD',
    'Trade city barter private limited',
    'Pankaj impex pvt ltd',
    'Tanvee marketing private limited',
    'Moxie media private limited',
    'Gokul suppliers private limited',
    'Scanpoint infoware private limited',
    'Scorpio marketing private limited',
    'Indostar capital finance limited',
    'Orange commosales private limited',
    'Subhdhan agency private limited',
    'Krishiv suppliers private limited',
    'IMPRESSION MOTORS PRIVATE LIMITED',
    'Gurukripa barter private limited',
    'Looklike vyapaar private limited',
    'Aasaan retail private limited',
    'Lloyds medical solutions private limited',
    'Dvs software technologies private limited',
    'ENTELECHY GLOBAL TECHNOLOGY PRIVATE LIMITED',
    'Fourth generation consultancy services private limited',
    'Digindia infotech private limited',
    'Substance infotech solutions private limited',
    'Emportant technologies private limited',
    'Intelligencenode consulting private limited',
    'Crystal logic private limited',
    'Ash infotech private limited',
    'Unb 9 solutions private limited',
    'Rumani technologies private limited',
    'Conrep solutions private limited',
    'Gainsight software private limited',
    'Siyaton software solutions private limited',
    'Gavs information service private limited',
    'Highdata software india private limited',
    'Trimble information technologies india private limited',
    'Softteam solutions private limited',
    'Experage consultancy services (chennai) private limited',
    'Innospace automation services private limited',
    'Ironcode gaming private limited',
    'B-transform consulting private limited',
    'Technology xpress info solutions private limited',
    'Tecordeon software private limited',
    'Technomatics software india private limited',
    'SUNWELLS OXYGEN INDIA PRIVATE LIMITED',
    'Cain technologies india private limited',
    'Healthcare infoxchange india private limited',
    'Shunya technologies private limited',
    'Akrb technologies private limited',
    'Calipus software private limited',
    'KATH FACTORY PRIVATE LIMITED',
    'Bestine digital solutions private limited',
    'Satma technologies private limited',
    'Phozeca digital services private limited',
    'Concept learning technologies private limited',
    'Ved technoserve india private limited',
    'Dazzle technolab private limited',
    'Biztechnosys infotech private limited',
    'CASEPOINT PRIVATE LIMITED',
    'Transvista bpm private limited',
    'Diverse infotech services private limited',
    'N-tech solutions private limited',
    'Cse systems and engineering (india) private limited',
    'Adecco india private limited',
    'Brar properties and holdings private limited',
    'CIMS MEDICA INDIA PRIVATE LIMITED',
    'Trilogy e-business software india private limited',
    'Smruthi technologies private limited',
    'Synectic telecom exports private limited',
    'Infinera india private limited',
    'Tecknodreams software consulting private limited',
    'EDKAL TECHNOLOGIES PRIVATE LIMITED',
    'Technobind solutions private limited',
    'Bookmytrainings.com private limited',
    'Gigsky india private limited',
    'Appiness interactive private limited',
    'Quiver digital solutions india private limited',
    'Verimatrix video security solutions india private limited',
    'Zestech global private limited',
    'Cirrus it commerce private limited',
    'Naico information technology services private limited',
    'Toobler technologies private limited',
    'Orisysindia techconsultancy private limited',
    'Electromag wireless solutions private limited',
    'Amro management pvt ltd',
    'Ramayana technologies private limited',
    'Delta networks private limited',
    'Alfa e-solutions private limited',
    'Mx information systems private limited',
    'Globally managed services india private limited',
    'DEUTSCHE INDIA PRIVATE LIMITED',
    'Ebony electronics private limited',
    'Aegix technologies private limited',
    'Ebony sales and services private limited',
    'Symcom tech private limited.',
    'Next info solutions private limited',
    'Jephersons communications private limited',
    'Barphani card commerce private limited',
    'Efacts solutions private limited',
    'Energy design private limited',
    'Ideastack solutions private limited',
    'Orane media private limited',
    'Maniar technologies private limited',
    'Open firms consulting private limited',
    'Lamp hub infosoft private limited',
    'Time line infotech private limited',
    'Raw engineering india private limited',
    'Sonsy techsolutions private limited',
    'Seed infotech limited',
    'KALPAVRUKSH SYSTEMS PRIVATE LIMITED',
    'Hover technologies private limited',
    'Primus techsystems private limited',
    'Loylogic technologies india private limited',
    'Dynamisch it private limited',
    'Cazaayan software labs private limited',
    'J p global foods private limited',
    'Ghanwat agro foods private limited',
    'Pennwalt xeda agro-chem private limited',
    'High fly farms private limited',
    'Gogreen nursery private limited',
    'Avro industries pvt ltd',
    'Poinsettia private limited',
    'Neptune farming private limited',
    'Mysore livestock & breeding company private limited',
    'Vasu broiler research and breeding farm private limited',
    'Srivenk broiler research and breeding farm private limited',
    'Uttara broiler breeder farm private limited',
    'AL NOOR AGRI FRESH PRIVATE LIMITED',
    'Riverbed agro private limited',
    'Hetal agriculture private limited',
    'Nand gopal agro industries private limited',
    'As air systems private limited',
    'Agri fiber limited',
    'Sunnleks agro private limited',
    'New method agriplant private limited',
    'N R N ADVISORS PRIVATE LIMITED',
    'Agriculture rural development & environmental awarness foundation',
    'Bangalore seeds private limited',
    'Deccan grainz private limited',
    'Bentoli agrinutrition india private limited',
    'GREENS TOWNESS PRIVATE LIMITED',
    'GREENS RETAIL VENTURES PRIVATE LIMITED',
    'Gujarat state forest development corporation limited',
    'Mallya fine-chem private limited',
    'Mecolam engineering private limited',
    'Danish steel cluster private limited',
    'Bilz tool private limited',
    'Neri machine tools private limited',
    'HEALTHIUM MEDTECH LIMITED',
    'Kokankinara agro and aqua private limited',
    'Bengal marines private limited',
    'Kamepalli aqua farms private limited',
    'Inno projects private limited',
    'Tms india private limited',
    'Alliance infrastructure projects private limited',
    'Naini coal company limited',
    'Oceanic explorations private limited',
    'DHATRI MINES & MINERALS PRIVATE LIMITED',
    'Chem lube india private limited',
    'Neil holding private limited',
    'Empire lead refineries private limited',
    'Intermin mines private limited',
    'Sankalpan architects private limited',
    'RASHI GRANITE EXPORTS INDIA LIMITED',
    'Garima natural resources private limited',
    'Sangeetha minerals private limited',
    'Sphera minerals private limited',
    'Rayban foods private limited',
    'Global brand resources private limited',
    'Electra impex private limited',
    'ETERNIA PLASTOCHEM PRIVATE LIMITED',
    'West coast refrigeration and food engineering pvt ltd',
    'QUALITY SPICES & FOOD EXPORTS PRIVATE LIMITED',
    'Dhiraj agro private limited',
    'Tamil naadu edible oils private limited',
    'Amrutha coconut substances india private limited',
    'Solae company india private limited',
    'Murji meghan services private limited',
    'Mistair health and hygiene private limited',
    'Swan sweets pvt ltd',
    'Hike agro foods private limited',
    'Broski beverages private limited',
    'Shree behari ji rice mill private limited',
    'Khemka flour mills private limited',
    'Evialis india limited',
    'Jaika hospitality ventures private limited',
    'E k foods private limited',
    'SAYAJI FOODS PRIVATE LIMITED',
    'Sukhdata foods private limited',
    'ANMOL INDUSTRIES LIMITED',
    'Shanti snacks private limited',
    'Keventer agro ltd.',
    'Stern ingredients india private limited',
    'Rajhans nutriments private limited',
    'RAMA TOFFEE PRIVATE LIMITED',
    'Y-cook india private limited',
    'Absolutee foods private limited',
    'Grenera nutrients private limited',
    'Hospitality initiatives india private limited',
    'Mamatha speciality foods private limited',
    'Yenepoya gourmet private limited',
    'Golden infracon private limited',
    'Fobeoz india private limited',
    'Mdl industries limited',
    'Zen industries private limited',
    'GEMINI DYEING AND PRINTING MILLS PRIVATE LIMITED',
    'Briar knoll mills private limited',
    'Madhu india deco limited',
    'Supel tex limited',
    'J.j. fabtex private limited',
    'Swaraj equipment private limited',
    'Krofta papers private limited',
    'INFIILOOM INDIA PRIVATE LIMITED',
    'Decent fabrics pvt ltd',
    'Devika fibres pvt ltd',
    'SEARIDER LOGISTICS PRIVATE LIMITED',
    'Kamco engineering private limited',
    'Sriram infratech private limited',
    'Mounthill realty private limited',
    'YEDESHI AURANGABAD TOLLWAY LIMITED',
    'Snj e designs private limited',
    'Life constructions private limited',
    'Dhanya infrastructure private limited',
    'Vaish builders private limited',
    'Vatican builders private limited',
    'Yamuna infratech private limited',
    'Ultimate infratech private limited',
    'Bcc infrastructures private limited',
    'Macle infraventure private limited',
    'Realtime integrated infratech private limited',
    'Zire realty limited',
    'Western realty services private limited',
    'Riverstone educational academy private limited',
    'KBC GLOBAL LIMITED',
    'Kaushal infrastructure private limited',
    'Super value properties private limited',
    'Rose realtors private limited',
    'Erudite developers private limited',
    'Sml properties private limited',
    'Jnd realcon private limited',
    'Fern realtors private limited',
    'LANDKRAFT SPACES PRIVATE LIMITED',
    'UNIQUE PROPERTY ENTERPRISES PRIVATE LIMITED',
    'Shree sainath land & development (india) private limited',
    'S.g.p real estates private limited',
    'Blackplinth realtors private limited',
    'Virar townships private limited',
    'Sahrish constructions private limited',
    'IRB WESTCOAST TOLLWAY LIMITED',
    'Roop ratan heritage private limited',
    'SOLAPUR YEDESHI TOLLWAY LIMITED',
    'Abhinav landmarks private limited',
    'Kaviyan construction private limited',
    'M s charan builders private limited',
    'Ascent engineers & infrastructures india private limited',
    'Sevenstar infracon private limited',
    'Sanbrix properties private limited',
    'Realtech nirman private limited',
    'Primo estates north east private limited',
    'Vaishnodevi buildcon private limited',
    'Luckydhan properties private limited',
    'Yogadhipa estates private limited',
    'Petunia home private limited',
    'Micra infrastructure private limited',
    'Mohini residency private limited',
    'Solar designs private limited',
    'Cms marshall limited',
    'Dream vehicles private limited',
    'Jmd marketing private limited',
    'Shaman used cars private limited',
    'Dolphin autowheels private limited',
    'Shriram automall india limited',
    'M.G.BROTHERS ENTERPRISES PRIVATE LIMITED',
    'Granule enterprise private limited',
    'Veera vahana udyog private limited',
    'Trident auto enterprises private limited',
    'Spark motors private limited',
    'Shazzam automobiles private limited',
    'Pytex automobiles private limited',
    'Vedha motors private limited',
    'K p cars private limited',
    'MOVIE TIME MULTIPLEX PRIVATE LIMITED',
    'M.s.motors private limited',
    'J and k automobiles private limited',
    'Srijai autos private limited',
    'Rushabh autocomponents private limited',
    'Mokshaa motorbike company private limited',
    'Harmony finex pvt ltd',
    'Global pacific nominees(india) private limited',
    'Anshul exim private limited',
    'Nissan enterprises limited',
    'CARYSIL ONLINE LIMITED',
    'Anushkan mercantile private limited',
    'VERTEX ENGINEERS PRIVATE LIMITED',
    'Sicame india connectors private limited',
    'Hiya overseas private limited',
    'KASUMA INTERNATIONAL PRIVATE LIMITED',
    'Rst consumer care private limited',
    'DARJEELING POWER PRIVATE LIMITED',
    'Proman infrastructure services private limited',
    'GUARD SPECIALITY PRODUCTS LIMITED',
    'Galvawire agencies private limited',
    'Longshine global enterprises private limited',
    'THE ABK INDUSTRIES LIMITED',
    'AL-HADEED MANUFACTURING & TRADING PRIVATE LIMITED',
    'Navsun marketing pvt ltd',
    'Akitex private limited',
    'Shivam commodities private limited',
    'Sidhi vinayak suppliers pvt ltd',
    'Rangila distributors private limited',
    'Dev dairy products private limited',
    'F h daruwalla traders private limited',
    'Brandix apparel india private limited',
    'Sealy india trading private limited',
    'Veryx technologies private limited',
    'Srin soft technologies private limited',
    'Saggezza india private limited',
    'Black magic i.t. solution private limited',
    'Tidal wave infotech private limited',
    'Chain-sys software exports private limited',
    'SAISYSTEMS HEALTH TECH PRIVATE LIMITED',
    'Thinkpalm technologies private limited',
    'K.L.M.N.GLOBAL VENTURES PRIVATE LIMITED',
    'Cloudnet technologies private limited',
    'Augusta hitech soft solutions private limited',
    'Iexemplar software india private limited',
    'Linlax infotech private limited',
    'NOTIVA INNOVENTURES PRIVATE LIMITED',
    'Millennium systel private limited',
    'Manpro experts private limited',
    'Onshore comptech private limited',
    'Incise infotech private limited',
    'Anjaybee infotech private limited.',
    'Arieon technology private limited',
    'Sevenseas supplychain solutions private limited',
    'Intellinet systems private limited',
    'THEME CREATORS STUDIOS AND INTERIORS PRIVATE LIMITED',
    'Appbits technologies private limited',
    'Delta infosolutions private limited',
    'Spider software private limited',
    'Hexatech it ventures private limited',
    'Chanakya infocom private limited',
    'Inka entworks (india) private limited',
    'Smartstream technologies india distributor private limited',
    'Red mango analytics private limited',
    'Tech morphosis private limited',
    'Paccar india private limited',
    'Brigade global services private limited',
    'Ftd india private limited',
    'Coppernine soft tech private limited',
    'Carmel softech private limited',
    'Software ag chennai development center india private limited',
    'Methodos solutions private limited',
    'Vel micro systems private limited',
    'STOCKEDGE WEALTH PRIVATE LIMITED',
    'Choiceforce infotech private limited',
    'Centillion solutions and services private limited',
    'Management and advanced resourcing services private limited',
    'Cnergyis infotech india private limited',
    'Nsdl database management limited',
    'Wire and wireless tisai satellite limited',
    'Rap technologies private limited',
    'Ebsco information services india private limited',
    'Enrichware technologies private limited',
    'Keka technologies private limited',
    'Mitosis technologies private limited',
    'English helper education technologies private limited',
    'INTELLIKA HITECH SYSTEMS PRIVATE LIMITED',
    'Agile media lab private limited',
    'Computer junction private limited',
    'Star touch india private limited',
    'Io machine.com private limited',
    'Kyzen technotrade private limited',
    'Skj technologies private limited',
    'Azcom infosolutions (india) private limited',
    'Safe navigation software private limited',
    'Dejero logix private limited',
    'Actolap solutions india private limited',
    'Skylabs solution india private limited',
    'Dream professionals consultancy service private limited',
    'Bluelupin technologies private limited',
    'Aartissan design media private limited',
    'Prudent technoserve private limited',
    'Itcg solutions private limited',
    'Smit digital marketing private limited',
    'Innovation beyond imagination research solutions private limited',
    'Byte consulting private limited',
    'Ionx services private limited',
    'Greynium information technologies private limited',
    'Goal information technology solutions private limited',
    'Mango technologies private limited',
    'Outdu holdings private limited',
    'Tli knowledge services private limited',
    'Tataatsu idealabs private limited',
    'ASTCRM SYSTEMS PRIVATE LIMITED',
    'Karmikoncepts india private limited',
    'Crypters infosystems and solutions private limited',
    'Nuevalgo solutions private limited',
    'Cmcs india private limited',
    'NELITO SYSTEMS PRIVATE LIMITED',
    'Hathway sonali om crystal cable private limited',
    'Zenvision infoworks private limited',
    'SANGLE AGRO EXPORT PRIVATE LIMITED',
    'Robosol software private limited',
    'Primeleaf consulting private limited',
    'Compsoft bpo services india private limited',
    'HEMLATA HOME SOLUTIONS PRIVATE LIMITED',
    'Sang infotech private limited',
    'HI-TECH GLOBAL SERVICES PRIVATE LIMITED',
    'Hitachi data systems india private limited',
    'Titania technology private limited',
    'SONICWALL TECHNOLOGY SYSTEMS INDIA PRIVATE LIMITED',
    'Dechen enterprises private limited',
    'GUM MANUFACTURERES',
    'LECHE DAIRY FARMS PRIVATE LIMITED',
    'Aravind milkfoods private limited',
    'Reliance research and development services private limited',
    'Pitamber flour mills private limited',
    'Sam agro processors private limited',
    'Multigrain food private limited',
    'Sree viswaas agro biotech india limited',
    'Daylight foods & retail private limited',
    'Zoha foods private limited',
    'PRANI AGRO',
    'SURESH EXPORTS PRIVATE LIMITED',
    'Effel exports private limited.',
    'Prayagaa enterprises private limited',
    'Bharosemand vyapaar pvt.ltd.',
    'Bhrosemand commercial pvt.ltd.',
    'NTT DATA PAYMENT SERVICES INDIA LIMITED',
    'Venturelabour.com india private limited',
    'Affinity global advertising private limited',
    'Indosource solutions private limited',
    'Three sixty degrees software solutions private limited',
    'Panassia infotech private limited',
    'Idee fixe designs & communication private limited',
    'Unistanz software private limited',
    'Optec labs private limited',
    'Comflex technologies private limited',
    'Aletheia technologies private limited',
    'Encore techsol private limited',
    'Horizon outsource solutions private limited',
    'Global payex private limited',
    'DNETX NETWORK SOLUTIONS & TELECOMMUNICATION PRIVATE LIMITED',
    'Smartnet infotech & services private limited',
    'Xmitter technologies (india) private limited',
    'Aureus analytics private limited',
    'April broadcast private limited',
    'Arachnomesh technologies private limited',
    'Netsurf communications private limited',
    'Boomerang soft private limited',
    'Headfitted solutions private limited',
    'Caladium technology solutions private limited',
    'Crb tech solutions private limited',
    'Global techno software solutions ( india) private limited',
    'Auisy technologies private limited',
    'Infrabeat technologies private limited',
    'Finnova infotech private limited',
    'Ibirds software services private limited',
    'Spatial networks private limited',
    'Itreen data and systems (india) private limited',
    'Chevronne softech private limited',
    'Nisarga information technology solutions private limited',
    'Invilogic software private limited',
    'Triguna constructions private limited',
    'Unlimited innovations (india) private limited',
    'Team mango media private limited',
    'Rttnews india private limited',
    'Newhorn technology solutions private limited',
    'Icom data systems private limited',
    'Gaddiel technologies private limited',
    'Maktek steel solutionn private limited',
    'Cheersbye technologies private limited',
    'Indus novateur softech private limited',
    'Mcoxley infotech & intellect management private limited',
    'Neel technologies private limited',
    'Izaap technologies private limited',
    'Exponentia datalabs private limited',
    'Shimi research center private limited',
    'National high power test laboratory private limited',
    'Sabarmati river front development corporation limited',
    'Cliantha research limited',
    'Inverika bioresearch private limited',
    'Probe Information Services Private Limited',
    'Scienceadda learning innovations private limited',
    'Kuantum technologies private limited',
    'Sevenhills medical foundation',
    'Bioklone biotech private limited',
    'Weitzman advocates private limited',
    'Ams college of advanced studies private limited',
    'Shaan integrated services private limited',
    'Golden m.p. chit fund private limited',
    'Accent consultants private limited',
    'Jewelsouk Marketplace Limited',
    'A-line automobiles (india) private limited',
    'Saad manpower services private limited',
    'Bombay fruits and vegetables import export private limited',
    'Jetpur somnath tollways private limited',
    'Zicom saas private limited',
    'PLASMA BIOTAL INDIA PRIVATE LIMITED',
    'Deepak insulation services (i) private limited',
    'Razorblade films private limited',
    'OKIE VENTURES PRIVATE LIMITED',
    'Art escape resorts private limited',
    'Biotech solutions & pharmaceuticals limited',
    'Svatantra microfin private limited',
    'Dar cineraas private limited',
    'R. s. interbuild private limited',
    'DA MAKEUP LAB PRIVATE LIMITED',
    'Hygienetech india private limited',
    'Jb claims and contracts solutions private limited',
    'World of wonders travel private limited',
    'Mapmyresource.com private limited',
    'Crescendo transcription private limited',
    'Learners & winners training & consultancy private limited',
    'Prag resources private limited',
    'Hoyden exim private limited',
    'Omsys business solutions private limited',
    'INAM EDUCATIONS PRIVATE LIMITED',
    'Triune energy services private limited',
    'CFM FACILITIES PRIVATE LIMITED',
    'FORTUNE GSJ INFRAMART PRIVATE LIMITED',
    'Axletech india private limited',
    'AERIUS MARINE INDIA PRIVATE LIMITED',
    'Brainsearch consulting private limited',
    'Emgee media integrated services private limited',
    'The printers (mysore) private limited',
    'Vijay nicole imprints private limited',
    'Bhanu paper mills limited',
    'Arnav print private limited',
    'Embros printers private limited',
    'Mangalam packaging private limited',
    'Innova printing and packaging company private limited',
    'Mermaid print concepts private limited',
    'Paradise multimedia pvt ltd',
    'Siddhivinayak infomedia private limited',
    'Printapack india private limited',
    'Omnimedia publications india private limited',
    'Dhan properties private limited',
    'Confidence lpg bottling private limited',
    'Bhooma energy ventures private limited',
    'Bharat petroresources limited',
    'Heat trace india private limited',
    'Roland polysurf private limited',
    'SAMRAT REMEDIES INDIA PRIVATE LIMITED',
    'Aizher fine chem private limited',
    'Kusum silicones private limited',
    'Lakshya pharma private limited',
    'DELVIN KLARVOYANT BIOGENICS PRIVATE LIMITED',
    'SK CHEM INDUSTRIES PRIVATE LIMITED',
    'Minerva flavours and fragrances private limited',
    'Krishna alkali (bombay) private limited',
    'Nirchem dyes & chemicals private limited',
    'Psa chemicals and pharmaceuticals pvt ltd',
    'Mehta petro-refineries ltd',
    'Manoramya realtors private limited',
    'Hindustan monomers private limited',
    'Polygon chemicals private limited',
    'Espi industries and chemicals pvt ltd',
    'Shri narahari chemicals private limited',
    'DYNATECH SYSTEMS PRIVATE LIMITED',
    'ARITRAA WEDOIT PROJECTS PRIVATE LIMITED',
    'MADANLAL ESTATES PRIVATE LIMITED',
    'TRIDENT LASER PRIVATE LIMITED',
    'FERMENTIS LIFE SCIENCES PRIVATE LIMITED',
    'MAMADAPUR SOLAR PRIVATE LIMITED',
    'SAFEGUARD WORLD SUPPORT SERVICES PRIVATELIMITED',
    'DIODEMODE SYSTEMS PRIVATE LIMITED',
    'MENON RENEWABLE RESOURCES (INDIA) PRIVATE LIMITED',
    'PATEL LIQUOR PRIVATE LIMITED',
    'INOPLAST TECHNO PRIVATE LIMITED',
    'EVERBEST (M) INDIA PRIVATE LIMITED',
    'NGGAWE NIRMAN TECHNOLOGIES PRIVATE LIMITED',
    'MONKSHOOD MULTIMEDIA (OPC) PRIVATE LIMITED',
    'FROMAGERIES BEL INDIA PRIVATE LIMITED',
    'QUALTIME CONSULTANCY PRIVATE LIMITED',
    'SIOTEL PRIVATE LIMITED',
    'DEFTOUCH INTERACTIVE ART PRIVATE LIMITED',
    'SENTIACARE INDIA PRIVATE LIMITED',
    'REHBAR EQUIPMENT RENTAL PRIVATE LIMITED',
    'SANVIONICS HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'ADVANCED SYSTEM IN PACKAGE TECHNOLOGIES PRIVATE LIMITED',
    'NIWAN IMPEX PRIVATE LIMITED',
    'RANCHI HEALTH CARE PRIVATE LIMITED',
    'SIX SEASONS READY MIX CONCRETEX PRIVATE LIMITED',
    'KONGBULY ECOM TRADING PRIVATE LIMITED',
    'APPEND LIFESTYLE INNOVATIONS PRODUCTS PRIVATE LIMITED',
    'GUIDING MINDS CONSULTANCY PRIVATE LIMITED',
    'EZIT CONNECT INDIA PRIVATE LIMITED',
    'HAGGS IT SOLUTIONS PRIVATE LIMITED',
    'IFENSYS INFOTECH PRIVATE LIMITED',
    '3QI LABS INDIA PRIVATE LIMITED',
    'YULANTO WEB CREATIONS PRIVATE LIMITED',
    'AMIT GLOBAL SOLUTIONS PRIVATE LIMITED',
    'CITTABASE SOLUTIONS PRIVATE LIMITED',
    'RESMED TECHNOLOGY INDIA PRIVATE LIMITED',
    'JADE PAYMENT SOLUTIONS PRIVATE LIMITED',
    'WINAPP IT SOLUTIONS PRIVATE LIMITED',
    'QUBBY LABS PRIVATE LIMITED',
    'APPSTECH AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'SERVIMOS TECHNOLOGIES PRIVATE LIMITED',
    'HEXON SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'T2S SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'AKSANS TECHNOLOGIES PRIVATE LIMITED',
    'ORDINAL TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ADROIT SOFT INDIA PRIVATE LIMITED',
    'AQUILAE TECHNOLOGIES PRIVATE LIMITED',
    'XSOSYS TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'SENNIGHT TECHNOLOGIES PRIVATE LIMITED',
    'SUMMATION IT PRIVATE LIMITED',
    'MCINTELLECT SOFT SERVICES PRIVATE LIMITED',
    'INSTANT ACCESS HEALTH IT PRIVATE LIMITED',
    'HOSTCIRCLE IT SOLUTIONS PRIVATE LIMITED',
    'RAPPORT IT SERVICES PRIVATE LIMITED',
    'CONECTAR TECHNOLOGIES PRIVATE LIMITED',
    'AURAMINT TECHNOLOGIES PRIVATE LIMITED',
    'GINAR WEB SOLUTIONS PRIVATE LIMITED',
    'COOVUM SMART SYSTEMS AND SERVICES PRIVATE LIMITED',
    'TANTIV4 TECHNOLOGIES PRIVATE LIMITED',
    'PENTAFOX TECHNOLOGIES PRIVATE LIMITED',
    'S2M HEALTH PRIVATE LIMITED',
    'MINFINTECH SERVICES PRIVATE LIMITED',
    'HADDOWS TECHNOLOGIES PRIVATE LIMITED',
    'APPSCOMP WIDGETS PRIVATE LIMITED',
    'OPENDOORS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'INSUPPORRT SOLUTION PRIVATE LIMITED',
    'AARA TECH PRIVATE LIMITED',
    'BLACKMOUNT TECHNOLOGIES PRIVATE LIMITED',
    'MEARK ENTERPRISE PRIVATE LIMITED',
    'NOVACIS DIGITAL PRIVATE LIMITED',
    'SM SMARTYGEN MEDIA NETWORKS PRIVATE LIMITED',
    'UPASS BUSINESS PROCESS AUTOMATION PRIVATE LIMITED',
    'CURONIS HEALTHCARE PRIVATE LIMITED',
    'FOUNDATION FOR INNOVATIVE NEW DIAGNOSTICS INDIA',
    'VT LABS (OPC) PRIVATE LIMITED',
    'SENTRO TECHNOLOGY PRIVATE LIMITED',
    'WORLD RESOURCES INSTITUTE INDIA PRIVATE UNLIMITED',
    'PAANI FOUNDATION',
    'NEETI RESEARCH PRIVATE LIMITED',
    'AGC APPS PRIVATE LIMITED',
    'EXTENDO TECHNOLOGIES PRIVATE LIMITED',
    'MYSORE SCIENCE AND TECHNOLOGY SERVICES PRIVATE LIMITED',
    'INDIA FLEXOGRAPHIC TECHNICAL LIMITED',
    'PIERIANDX INDIA PRIVATE LIMITED',
    'SURAJ ADVANCED RESEARCH AND ANALYTICAL LABORATORIES PRIVATE LIMITED',
    'AGRIGENOME LABS PRIVATE LIMITED',
    'CAROT LABS PRIVATE LIMITED',
    'VOXFOREM TECHNOLOGIES PRIVATE LIMITED',
    'KANSDEE PLACEMENT SERVICES PRIVATE LIMITED',
    'ZUMUTOR BIOLOGICS PRIVATE LIMITED',
    'JIVA SCIENCES PRIVATE LIMITED',
    'INSTAT CLINICAL RESEARCH PRIVATE LIMITED',
    'LONELY CLOUD CONSULTING PRIVATE LIMITED',
    'DIVE MANTRA PRIVATE LIMITED',
    'GOAP ONLINE PUBLISHERS PRIVATE LIMITED',
    'KRR TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'MUNCHEM INDIA PRIVATE LIMITED',
    'CMR ENTERPRISES PRIVATE LIMITED',
    'FINDING PATH EZSHOPPY GOODS AND SERVICES PRIVATE LIMITED',
    'GAAYATHRI CITY EYE HOSPITAL PRIVATE LIMITED',
    'YESCOM INDIA SOFTECH PRIVATE LIMITED',
    'BLUE ALPHA IT PRIVATE LIMITED',
    'HEAVY CONSULTANCY SERVICES PRIVATE LIMITED',
    'NARAYANI HR SERVICES PRIVATE LIMITED',
    'DHAVALA ASSOCIATE MANAGEMENT SERVICES PRIVATE LIMITED',
    'STATEN INDIA PRIVATE LIMITED',
    'AD 4 U COMMUNICATIONS PRIVATE LIMITED',
    'PAN INDIA CHARMS & JEWELLERY PRIVATE LIMITED',
    'FIVE K CONSULTING PRIVATE LIMITED',
    'SPATIUM DESIGNS PRIVATE LIMITED',
    'HUB OF ELEVATION CONSULTANCY PRIVATE LIMITED',
    'SIS INTERLOGISTICS INDIA PRIVATE LIMITED',
    'KARA ORGANICS OPC PRIVATE LIMITED',
    'LIMBER INTERNET SOLUTIONS PRIVATE LIMITED',
    'TELCO COMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'BRODOS INDIA PRIVATE LIMITED',
    'IIIEM EXIM TRAINING PRIVATE LIMITED',
    'TAMMY TRADE PRIVATE LIMITED',
    'SOMANI BUSINESS INFRA PRIVATE LIMITED',
    'MAGENTA LIFECARE LIMITED',
    'WE RESEARCH MARKET SOLUTIONS PRIVATE LIMITED',
    'SILVERFERN TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'EPG ECONOMICS PRIVATE LIMITED',
    'SUNNYDAY SPA PRIVATE LIMITED',
    'VEDANT FINCORP PRIVATE LIMITED',
    'WORLD CLASS HOME PRODUCTS PRIVATE LIMITED',
    'WORLD CLASS JEWELLERY PRIVATE LIMITED',
    'ABEER TECHNOLOGIES PRIVATE LIMITED',
    'LEVIN FINTECH PRIVATE LIMITED',
    'JUSTKAPTURE INNOVATIONS PRIVATE LIMITED',
    'NUWAVE COMMUNICATIONS PRIVATE LIMITED',
    'GENIAL TESTING & SURVEY CERTIFICATION PRIVATE LIMITED',
    'MAGLARE TECHNOLOGIES PRIVATE LIMITED',
    'PRATIBHA ANALYTICS PRIVATE LIMITED',
    'IFIRMS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PROSPECT IT SERVICES PRIVATE LIMITED',
    'VAKANA CONSULTANCY PRIVATE LIMITED',
    'BRANDAD EMEDIA SOLUTIONS PRIVATE LIMITED',
    'ARTHAM FINOMETRY PRIVATE LIMITED',
    'AS FINANCE SOLUTIONS PRIVATE LIMITED',
    'PRABHAV BROADBAND SERVICES PRIVATE LIMITED',
    'ARYA WORLDWIDE PRIVATE LIMITED',
    'DEV INSIGHTS PRIVATE LIMITED',
    'ADANI INFRASTRUCTURE PRIVATE LIMITED',
    'MEDIGENCE SOLUTIONS PRIVATE LIMITED',
    'CYGNETO APPS PRIVATE LIMITED',
    'NGCONN SMART SOLUTIONS PRIVATE LIMITED',
    'CFM ASSET RECONSTRUCTION PRIVATE LIMITED',
    'TRIUM DESIGNS PRIVATE LIMITED',
    'PURPLE SQUIRREL RECRUITERS PRIVATE LIMITED',
    'FOURTHWHEEL SOCIAL IMPACT PRIVATE LIMITED',
    'PUNYA SYSTEMS PRIVATE LIMITED',
    'LORENZ SNACKS INDIA PRIVATE LIMITED',
    'ATIKA WELFARE FOUNDATION',
    'VISHWAS AUTOMATION PRIVATE LIMITED',
    'BLUEWISDOM BUSINESS MANAGEMENT PRIVATE LIMITED',
    'AFFINITY LINENS PRIVATE LIMITED',
    'KARUMBI CONSULTANCY PRIVATE LIMITED',
    'ADJIA TECHNOLOGIES LIMITED',
    'KSHAMYA LIFESTYLE PRIVATE LIMITED',
    'KONEMET PRODUCT PRIVATE LIMITED',
    'MEHTA HOLIDAYS PRIVATE LIMITED',
    'VIABLE SERVICES PRIVATE LIMITED',
    'SEAFOLK DIVING CONTRACTORS & ENGINEERING SERVICES PRIVATE LIMITED',
    'FOLLY SYSTEMS PRIVATE LIMITED',
    'KHYATI SHIPPING SERVICES PRIVATE LIMITED',
    'TRAMILY HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'COUCH PERRY & WILKES INDIA PRIVATE LIMITED',
    'ULTIMETRIC SOLUTIONS PRIVATE LIMITED',
    'ENTELLUS ENTERPRISES PRIVATE LIMITED',
    'MARS PLANNING AND ENGINEERING SERVICES INTERNATIONAL PRIVATE LIMITED',
    'AMM INDIA PRIVATE LIMITED',
    'KOBELCO COMPRESSORS INDIA PRIVATE LIMITED',
    'TACO PRESTOLITE ELECTRIC PRIVATE LIMITED',
    'ADMITAD MEDIA PRIVATE LIMITED',
    'EPHESOFT INDIA PRIVATE LIMITED',
    'GRACO INDIA PRIVATE LIMITED',
    'SOLEOS SOLAR PRIVATE LIMITED',
    'SHAYONA LEGAL SERVICES PRIVATE LIMITED',
    'M K TECHNOSYS PRIVATE LIMITED',
    'QWINZI EXPERIENCES PRIVATE LIMITED',
    'ECHELON NETWORKS PRIVATE LIMITED',
    'FEEGENIE ONLINE SERVICES PRIVATE LIMITED',
    'PRIMEJOBS MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'TANTRA COMPOSITE TECHNOLOGIES PRIVATE LIMITED',
    'ALLIES INDIA PRIVATE LIMITED',
    'JUBY TECHNOLOGIES PRIVATE LIMITED',
    'RISHIKA SERVICES PRIVATE LIMITED',
    'VISA ZONE EDUCATION & IMMIGRATION SERVICES PRIVATE LIMITED',
    'DAHEJ ECO CARE PRIVATE LIMITED',
    'DOCTOR INSTA PRIVATE LIMITED',
    'E S SYSTEMS & ELECTRONICS PRIVATE LIMITED',
    'HAMZAVI SOLUTIONS PRIVATE LIMITED',
    'KELVIN WATER TECHNOLOGIES PRIVATE LIMITED',
    'SCIENTITY DESIGN INNOVATIONS PRIVATE LIMITED',
    'TALENTILY TECHNOLOGIES PRIVATE LIMITED',
    'ADITYAM INFOANALYTICS PRIVATE LIMITED',
    'RAAG INNOVATIONS PRIVATE LIMITED',
    'DULZURA DESSERTS PRIVATE LIMITED',
    'GENIUS PRESENTATION PRIVATE LIMITED',
    'KEMEXEL ECOMMERCE PRIVATE LIMITED',
    'STAR TECHNO ENGINEERING PRIVATE LIMITED',
    'SAYESHA ENTERPRISES PRIVATE LIMITED',
    'SP CINECORP CINEMATIC VENTURE LIMITED',
    'MORE GROUP ACCOUNTING INDIA PRIVATE LIMITED',
    'UDGHATAN RESELLER SERVICES PRIVATE LIMITED',
    'ECO GREEN PEST CONTROL PRIVATE LIMITED',
    'D-KMBRISH IMMIGRATION PRIVATE LIMITED',
    'LOTTAMICRO WEB SOLUTIONS (OPC) PRIVATE LIMITED',
    'MEDI MANTRA HEALTH CARE SOLUTIONS PRIVATE LIMITED',
    'TECHWATTPEAK RENEWABLES PRIVATE LIMITED',
    'PEOPLE STEAD INDIA PRIVATE LIMITED',
    'GKASOFT TECHNOLOGIES PRIVATE LIMITED',
    'CNCS ENABLING EXCELLENCE SERVICES PRIVATE LIMITED',
    'IQRA AIRCON PRIVATE LIMITED',
    'WRIGHT SHORE TECHNOLOGIES PRIVATE LIMITED',
    'CUSLO MANAGEMENT SERVICES PRIVATE LIMITED',
    'OMNIVORE ADVISORS PRIVATE LIMITED',
    'SAWAN OIL TOOLS PRIVATE LIMITED',
    'PICKRR TECHNOLOGIES PRIVATE LIMITED',
    'MARKITHOOD DEALS INDIA PRIVATE LIMITED',
    'SHIKHAR TAXSHILAW CONSULTANCY PRIVATE LIMITED',
    'METALBULLS VENTURES PRIVATE LIMITED',
    'SYZYGY LIVING PRIVATE LIMITED',
    'AM INFOWAYS PRIVATE LIMITED',
    'PROTINUS FASHION NETWORKING PRIVATE LIMITED',
    'CONSUS GLOBAL PRIVATE LIMITED',
    'PKS CORPORATE SERVICES PRIVATE LIMITED',
    'ENTRUST FAMILY OFFICE LEGAL AND TRUSTEESHIP SERVICES PRIVATE LIMITED',
    'SAMRUDHYA ELEVATORS PRIVATE LIMITED',
    'QCD GLOBAL SERVICES PRIVATE LIMITED',
    'TEGOLA TEMA INDIA PRIVATE LIMITED',
    'DIAGEO BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'RIGHT GIFTING SOLUTION PRIVATE LIMITED',
    'TAGFACT SERVICES PRIVATE LIMITED',
    'GOKARE LPO PRIVATE LIMITED',
    'CAREER BUCKET VENTURES (OPC) PRIVATE LIMITED',
    'INFRASCHOOL SERVICES KADIRI PRIVATE LIMITED',
    'REBATT SOUTH INDIA PRIVATE LIMITED',
    'ALLONZY MARKETING SOLUTIONS PRIVATE LIMITED',
    'LYKORA CONSULTING SERVICES PRIVATE LIMITED',
    'INFRASCHOOL SERVICES TUMKUR PRIVATE LIMITED',
    'SAFINA VENTURES PRIVATE LIMITED',
    'INFRASCHOOL SERVICES KORBA PRIVATE LIMITED',
    'CELEBSOFFICIAL MEDIATECH PRIVATE LIMITED',
    'HAPPYHEALTHYME ORGANICS PRIVATE LIMITED',
    'INDYSOFT ECOMMERCE PRIVATE LIMITED',
    'REDCAGE ATHLETIC STRENGTH PRIVATE LIMITED',
    'METHODHUB SOFTWARE PRIVATE LIMITED',
    'MODULA AUTOMATED WAREHOUSES INDIA PRIVATE LIMITED',
    'POWERSHIELD APAC PRIVATE LIMITED',
    'EMPIRIX SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TRANSFORMATIVE PHARMACEUTICAL SOLUTIONS INDIA PRIVATE LIMITED',
    'SUVITH INVESTMENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'ANVAYA BUSINESS SERVICES PRIVATE LIMITED',
    'PEPROMENO ENGINEERING & DESIGN INDIA PRIVATE LIMITED',
    'OPEN SOURCE PHARMA FOUNDATION',
    'MANASVINI WOMEN EMPOWERMENT FOUNDATION',
    'ARTSTREET INTERNATIONAL SOLUTIONS PRIVATE LIMITED',
    'UTKAL TUBERS INDIA PRIVATE LIMITED',
    'JAIN GLOBAL EDUCATION SERVICES PRIVATE LIMITED',
    'PRATIMAARTS PRIVATE LIMITED',
    'IGNITE EDUCATIONAL CONTENT MAKERS (OPC) PRIVATE LIMITED',
    'QUALTAL CONSULTING (OPC) PRIVATE LIMITED',
    'ELYSIAN STUDIO PRIVATE LIMITED',
    'TEHACOM INDIA PRIVATE LIMITED',
    'GOINGNUTS TRADING INDIA PRIVATE LIMITED',
    '99 WATTS ENERGY SOLUTIONS PRIVATE LIMITED',
    'MINDESCAPES CLUB PRIVATE LIMITED',
    'WINTRANS CONSULTANCY PRIVATE LIMITED',
    'DNH ADVISORS PRIVATE LIMITED',
    'ORIENTAL RELOCATIONS PRIVATE LIMITED',
    'TRIVONE MEDIA NETWORK PRIVATE LIMITED',
    'CLOVERLEAF IP CONSULTANCY AND SERVICES PRIVATE LIMITED',
    'LAB TO MARKET INNOVATIONS PRIVATE LIMITED',
    'SALESFUSE TECHNOLOGIES PRIVATE LIMITED',
    'SOFTPRINTS MEDIA VENTURES PRIVATE LIMITED',
    'TRESCON GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HAMMERJAW BENGALURU PRIVATE LIMITED',
    'B2BSPHERE INDIA PRIVATE LIMITED',
    'EVENRANK DATASCIENCES PRIVATE LIMITED',
    'ECO SMART ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'APOLLO FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'IRELIEF SERVICES PRIVATE LIMITED',
    'PXWE INDIA PRIVATE LIMITED',
    'SEARCH CATALYST PRIVATE LIMITED',
    'BUMPADUM MANUFACTURING AND TRADERS PRIVATE LIMITED',
    'SHAKE ONLINE SERVICES PRIVATE LIMITED',
    'ISPAGRO ROBOTICS PRIVATE LIMITED',
    '5WHEELER SOLUTIONS PRIVATE LIMITED',
    'SANDPAPER ENTERPRISES PRIVATE LIMITED',
    'IRON & STRENGTH FITNESS PRIVATE LIMITED',
    'BRIDGE EVENTS AND EXPERIENCES PRIVATE LIMITED',
    'WEALTHAPP FINANCIAL ADVISORS PRIVATE LIMITED',
    'MASTEK INTEGRATED SYSTEMS PRIVATE LIMITED',
    'KLISTII ONLINE INDIA PRIVATE LIMITED',
    'MACADAM MANAGEMENT SERVICES PRIVATE LIMITED',
    'ONTRACK TECHNOLOGIES PRIVATE LIMITED',
    'RELICARE TECH SERVICES PRIVATE LIMITED',
    'PROACT IMS PRIVATE LIMITED',
    'SAGAREEYAM CONSULTING PRIVATE LIMITED',
    'RENTPROP4U MGT SERVICES PRIVATE LIMITED',
    'SCHOOLFEEZ SOLUTIONS PRIVATE LIMITED',
    'YOUROWNROOM PRIVATE LIMITED',
    'LAANTEK SOLUTIONS PRIVATE LIMITED',
    'BRAIN SPEED INDIA PRIVATE LIMITED',
    'NETWORKCITY INNOVATIONS PRIVATE LIMITED',
    'MEINHARDT EPCM (INDIA) PRIVATE LIMITED',
    'FYLE TECHNOLOGIES PRIVATE LIMITED',
    'WHYFLEX TECHNOLOGIES PRIVATE LIMITED',
    'YUVEN ADVISORY & TECHNOLOGIES INDIA PRIVATE LIMITED',
    'M.E.MEERAN MANAGEMENT PRIVATE LIMITED',
    'VERTIS INFRA VENTURES PRIVATE LIMITED',
    'EXALCA TECHNOLOGIES PRIVATE LIMITED',
    'ASAR SOCIAL IMPACT ADVISORS PRIVATE LIMITED',
    'STECH AUTOMATION PRIVATE LIMITED',
    'WHYFLEX INCORPORATION PRIVATE LIMITED',
    'BEESTECH LABS PRIVATE LIMITED',
    'SURYAA BATTERIES PRIVATE LIMITED',
    'QS QUACQUARELLI SYMONDS INDIA PRIVATE LIMITED',
    'B&E DIAGNOSTICS INDIA PRIVATE LIMITED',
    'UE LIFESCIENCES (INDIA) PRIVATE LIMITED',
    'MEDIADONUTS INDIA PRIVATE LIMITED',
    'PEAK INFRASTRUCTURE MANAGEMENT SERVICES PRIVATE LIMITED',
    'ANARGHYAA ETECH SOLUTIONS PRIVATE LIMITED',
    'SCIENCE ASHRAM EDUCATION & RESEARCH PRIVATE LIMITED',
    'GETSETSMART EDUTECH PRIVATE LIMITED',
    'HINFOWAYS HEALTHCARE PRIVATE LIMITED',
    'AL BAKSH CONSTRUCTIONS PRIVATE LIMITED',
    'UNNAYAN EDUCATIONAL SERVICES PRIVATE LIMITED',
    'ADANI NAVAL DEFENCE SYSTEMS AND TECHNOLOGIES LIMITED',
    'MANUSNOVA LIFESTYLE PRIVATE LIMITED (OPC)',
    'BEESPHERE CONSULTANCY SERVICES PRIVATE LIMITED',
    'GLOBO SOURCE PRIVATE LIMITED',
    'P.P. JEWELLERS RETAIL PRIVATE LIMITED',
    'SAMSHEK FASHION PRIVATE LIMITED',
    'TEMPLATE TRADING AND CONTRACTING PRIVATE LIMITED',
    'CONCEPT LIFESTYLE PRIVATE LIMITED',
    'LIBERO APP SPORTS SOLUTIONS PRIVATE LIMITED',
    'TRENCH SHORING RENTAL PRIVATE LIMITED',
    'BOND INTERIORS INTERNATIONAL PRIVATE LIMITED',
    'ORGANIC BRAND PROMOTION SERVICES PRIVATE LIMITED',
    'ANTIER SCHOOL OF BLOCKTECH PRIVATE LIMITED',
    'EXTRAAEDGE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'INDUSUNO ONLINE PRIVATE LIMITED',
    'ITM COASTAL ENGINEERING COLLEGE',
    'FP TECH SCIENCE PRIVATE LIMITED',
    'MANOAH INTERNATIONAL PRIVATE LIMITED',
    'HEPTAGON LOGISTICS PRIVATE LIMITED',
    'FIBOLOGIC TECHNOLOGY PRIVATE LIMITED',
    'ZTRIC INDIA PRIVATE LIMITED',
    'TRENDZLINK TECHNOLOGY PRIVATE LIMITED',
    'SMART SOFTWARE SERVICES (I) PRIVATE LIMITED',
    'FLIPSOFT TECHNOLOGIES PRIVATE LIMITED',
    'OPTICAL COMMERCE PRIVATE LIMITED',
    'MULTI DISCIPLINARY ENGINEERING ACADEMY (I) PRIVATE LIMITED',
    'UNITED AIRLINES BUSINESS SERVICES PRIVATE LIMITED',
    'INSHORTS INDIA ADVERTISING AND SERVICES PRIVATE LIMITED',
    'SUPERGROUP INDIA PRIVATE LIMITED',
    'ONCAM SERVICES INDIA PRIVATE LIMITED',
    'AEL BERKMAN GLOBAL BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'IDEALPREPAID INDIA PRIVATE LIMITED',
    'GEISTLICH PHARMA INDIA PRIVATE LIMITED',
    'GLOBAL MARKET INSIGHTS RESEARCH PRIVATE LIMITED',
    'DIGITAL ART VIRTUAL REALITY EXPERIENCE PRIVATE LIMITED',
    'TRAVIND INSTITUTE OF TRAVEL & TOURISM MANAGEMENT INDIA PRIVATE LIMITED',
    'HOUSSUP SERVICES PRIVATE LIMITED',
    'AM FOUNDATION',
    'GROUPON SHARED SERVICES PRIVATE LIMITED',
    'SARASWATI BHUVAN ALUMNI ASSOCIATION',
    'VECTOR GREEN SUNRISE LIMITED',
    'RED PIXELS VENTURES LIMITED',
    'FIFTH GEAR VENTURES LIMITED',
    'LABEL KISS RETAIL PRIVATE LIMITED',
    'BIG MOTORCYCLE PRIVATE LIMITED',
    'ANSELM PHARMACEUTICALS PRIVATE LIMITED',
    'VALLEY POINT INDIA PRIVATE LIMITED',
    'VALUE ADDED RESEARCH TRADECON PRIVATE LIMITED',
    'VICTRONICS COMMUNICATIONS PRIVATE LIMITED',
    'MEDORAH MEDITEK PRIVATE LIMITED',
    'NASIR KHAN DESIGNS PRIVATE LIMITED',
    'INDCENTRIC FASHIONS PRIVATE LIMITED',
    'BLUEHAWKS TECHNOLOGIES PRIVATE LIMITED',
    'NINE RED PRIVATE LIMITED',
    'CEMTICS SOLUTIONS PRIVATE LIMITED',
    'WEBRISES IMAGING TECHNOLOGY PRIVATE LIMITED',
    'BIOROLES AUTOMATION SYSTEMS PRIVATE LIMITED',
    'LEMON SQUARE CREATIONS PRIVATE LIMITED',
    'SRI GARIMA PUBLICITY PRIVATE LIMITED',
    'SIESTA CONSULTANTS PRIVATE LIMITED',
    'REBOOT SOFTWARE PRIVATE LIMITED',
    'NIRAJ CHANDI RAJ SECURITY AND SERVICES PRIVATE LIMITED',
    'ARROWIT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GOOGLE CAPITAL ADVISORS INDIA PRIVATE LIMITED',
    'SUHANO E-COMMERCE PRIVATE LIMITED',
    'CODEC INFOTEC (OPC) PRIVATE LIMITED',
    'BRITE LED PRIVATE LIMITED',
    'TCTT TOURISM PRIVATE LIMITED',
    'ONE SOURCE CONSULTANCY PRIVATE LIMITED',
    'SME REALTECH PRIVATE LIMITED',
    'C P E C APOLLO PRIVATE LIMITED',
    'DHOBIO LAUNDRY PRIVATE LIMITED',
    'BUZZ INTERACTION PRIVATE LIMITED',
    'ACUMEET TECHNOLOGIES PRIVATE LIMITED',
    'ESCHWEILER MICROMED INDIA PRIVATE LIMITED',
    'JOGO TECHNOLOGIES PRIVATE LIMITED',
    'ELATION EDTECH PRIVATE LIMITED',
    'BISADO SECURITY SOLUTIONS PRIVATE LIMITED',
    'MPG SECURITY GROUP PRIVATE LIMITED',
    'KONNECTING BUSINESS ADVISORS PRIVATE LIMITED',
    'MARQUE MARKETING SERVICES PRIVATE LIMITED',
    'IBROAD CONNECT PRIVATE LIMITED',
    'AIMSFORCE SECURITY SERVICES PRIVATE LIMITED',
    'PROTECHMIND SOLUTIONS PRIVATE LIMITED',
    'ESGAUGE PRIVATE LIMITED',
    'RINA CONSULTING PRIVATE LIMITED',
    'MEDICOVER HEALTHCARE PRIVATE LIMITED',
    'PRATEEK FOUNDATION',
    'ALL INDIA SILOBAG STORAGE SERVICE PROVIDERS ASSOCIATION',
    'RAM KOHLI FOUNDATION',
    'STRATEGIC CSR ALLIANCE',
    'SHTC LOGISTICS PRIVATE LIMITED',
    'ONART QUEST LIMITED',
    'RADIANT ECOMMERCE PRIVATE LIMITED',
    'TIGER SECURITAS PRIVATE LIMITED',
    'SEVEN SEAS BRAND SOLUTION PRIVATE LIMITED',
    'GEFSI TECH PRIVATE LIMITED',
    'DISCOVERY MANAGEMENT CONSULTANT PRIVATE LIMITED',
    'CAMIONS LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'AQC MANAGEMENT PRIVATE LIMITED',
    'WORKFORCE PROFESSIONAL SERVICES PRIVATE LIMITED',
    'AXONET EMSYS PRIVATE LIMITED',
    'CATALEYA INDIA PRIVATE LIMITED',
    'SNAPPYDATA TECHNOLOGIES PRIVATE LIMITED',
    'ALFA BIOMED INDIA PRIVATE LIMITED',
    'PHYNART TECHNOLOGIES PRIVATE LIMITED',
    'BIG BINARY SOLUTIONS PRIVATE LIMITED',
    'SSG RENEW-TECH PRIVATE LIMITED',
    'TECHCUBE INFO SOLUTIONS PRIVATE LIMITED',
    'I-SOFT NETWORKS PRIVATE LIMITED',
    'AUTOKATTA SOLUTIONS PRIVATE LIMITED',
    'INFOVILLE SOLUTIONS INDIA PRIVATE LIMITED',
    'KAHAAN LUBRICANT PRIVATE LIMITED',
    'STARTUPWALA PRIVATE LIMITED',
    'ECLATSOL TECHNOLOGIES PRIVATE LIMITED',
    'GENIE DELIVERS PRIVATE LIMITED',
    'MIMIC INFOTECH PRIVATE LIMITED',
    'SAVEECO ENERGY INDIA PRIVATE LIMITED',
    'SNEHA INTERTRADE SERVICES PRIVATE LIMITED',
    'HYDERABAD C & D WASTE PRIVATE LIMITED',
    'HUNGRY OGRE TECHNOLOGIES PRIVATE LIMITED',
    'SB SURVEILLANCE PRIVATE LIMITED',
    'INSTRUMENTATION ENGINEERS PRIVATE LIMITED',
    'HRXCHANGE PRIVATE LIMITED',
    'MOON CLEARING AND FORWARDERS PRIVATE LIMITED',
    'DRIVE CARE SYSTEMS PRIVATE LIMITED',
    'EQUIP INFOTECH PRIVATE LIMITED',
    'HELIOS STRATEGIC SYSTEMS LIMITED',
    'NDE FLAW TECHNOLOGIES PRIVATE LIMITED',
    'INCLUESIV REAL ESTATE ADVISORY (INDIA) PRIVATE LIMITED',
    'RARS PROJECTS INDIA PRIVATE LIMITED',
    'WEDTREE ESTORE PRIVATE LIMITED',
    'JANATI BIO POWER PRIVATE LIMITED',
    'CASA GRANDE HOMES PRIVATE LIMITED',
    'UNITED TAS EXIM PRIVATE LIMITED',
    'KEY ACCOUNT MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'JEEVAN HEALTHCARE SERVICES PRIVATE LIMITED',
    'COMFOTEC ENGINEERING CONSULTING PRIVATE LIMITED',
    'GS GLOBAL VENTURES PRIVATE LIMITED',
    'MADRAS ACCOUNTANCY PRIVATE LIMITED',
    'SANJEEVAN NETWORKS SERVICES PRIVATE LIMITED',
    'CFS HEALTH CARE SERVICE PRIVATE LIMITED',
    'PRORELIX LIFESCIENCES PRIVATE LIMITED',
    'IBHA SYSTEMS PRIVATE LIMITED',
    'OPHTHO DIGITAL EYE CLINIC PRIVATE LIMITED',
    'DNYAN AUTOMATION PRIVATE LIMITED',
    'MPLIER HEALTHCARE VENTURES PRIVATE LIMITED',
    'CEE DEE EUTIT INDIA PRIVATE LIMITED',
    'KALAAGE CREATIONS PRIVATE LIMITED',
    'DH ARCHITECTURE STUDIO PRIVATE LIMITED',
    'SEMBA VALLEY FARMS PRIVATE LIMITED',
    'ELEVATE INDIA BUSINESS CONSULTANTS PRIVATE LIMITED',
    'AEROMAOZ RAJDEEP ILLUMINATION & CONTROLS INDIA PRIVATE LIMITED',
    'GLOBAL THERMAL CONTROL SYSTEMS PRIVATE LIMITED',
    'NETREXO COMMUNICATIONS PRIVATE LIMITED',
    'OCEAN BRIDGE CARRIER PRIVATE LIMITED',
    'CINDREL TECHNOLOGIES PRIVATE LIMITED',
    'GREAT FORTUNE SUPPLIERS PRIVATE LIMITED',
    'NORTHERLY AUTOMOTIVE SOLUTIONS PRIVATE LIMITED',
    'SEAHAWK RIVCON PRIVATE LIMITED',
    'ANTHLIN SMART SOLUTION PRIVATE LIMITED',
    'RUSHMORE TECHNOLOGIES PRIVATE LIMITED',
    'HYPEX ENGINEERING (INDIA) PRIVATE LIMITED',
    'INVENTCARE SYSTEMS PRIVATE LIMITED',
    'ARACEN SECURITY SERVICES PRIVATE LIMITED',
    'GLAMS INTERNATIONAL PRIVATE LIMITED',
    'ANCLA TECHNOLOGY SOLUTIONS INDIA PRIVATELIMITED',
    'FABHEADS AUTOMATION PRIVATE LIMITED',
    'ROSHAN INTERIOR PRIVATE LIMITED',
    'IOP MARKETING AND PROMOTION SERVICES PRIVATE LIMITED',
    'PIPECANDY TECHNOLOGIES PRIVATE LIMITED',
    'JAKS GLOBAL SERVICES PRIVATE LIMITED',
    'GLIMPSE FIVE SOLUTIONS PRIVATE LIMITED',
    'MARINE INFRASTRUCTURE DEVELOPER PRIVATE LIMITED',
    'INFLEXION ANALYTIX PRIVATE LIMITED',
    'SPIN FITNESS PRIVATE LIMITED',
    'MEDICAL ELECTRONIC SYSTEMS (INDIA) PRIVATE LIMITED',
    'RADIANCE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'YOURO SOLUTIONS PRIVATE LIMITED',
    'VIAAN CONSULTING SERVICES PRIVATE LIMITED',
    'SEER MINDS TECHNOLOGIES PRIVATE LIMITED',
    'EDBROOK CONSULTANCY PRIVATE LIMITED',
    'HILL INTERNATIONAL COST CONSULTANCY (INDIA) PRIVATE LIMITED',
    'PODHIGAI ADS PRIVATE LIMITED',
    'PONTUS PACK PRIVATE LIMITED',
    'RAY HOLIDAYS PRIVATE LIMITED',
    'BHINGOOZ TECHEX SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SEMECH TECHNOLOGIES PRIVATE LIMITED',
    'SANSCO TECHNOLOGIES (KERALA) PRIVATE LIMITED',
    'ZOKU DESIGN AND TECHNOLOGIES PRIVATE LIMITED',
    'NY MEDIA SOLUTIONS PRIVATE LIMITED',
    'OMNITECH LIGHTING PRIVATE LIMITED',
    'FARM MAKERS (INDIA) PRIVATE LIMITED',
    'N DOT FINANCE CONSULTANT & REALTORS PRIVATE LIMITED',
    'MADHYA PRADESH METRO RAIL CORPORATION LIMITED',
    'RAY VENTURES PRIVATE LIMITED',
    'SUCCESS MATRIMONY SERVICE PRIVATE LIMITED',
    'SHIVALIK DISTRIBUTION PRIVATE LIMITED',
    'TRIPADA FOUNDATION',
    'BHAVANI CENTRE FOR LEARNING',
    'GILES BROOKER ACADEMY PRIVATE LIMITED',
    'TECHNOARETE RESEARCH AND DEVELOPMENT ASSOCIATION',
    'VIDYASHAKTI EDUSYSTEMS PRIVATE LIMITED',
    'CALIXIR FREIGHT AND LOGISTICS PRIVATE LIMITED',
    'RUKKAAS WORLD TRANSPORT PRIVATE LIMITED',
    'VITALSENSE PRIVATE LIMITED',
    'XELIUMTECH SOLUTIONS PRIVATE LIMITED',
    'TIRUMALLA TRADEMARTS INDIA PRIVATE LIMITED',
    'OG PLUS SERVICES PRIVATE LIMITED',
    'PRANAVA CREATIONS PRIVATE LIMITED',
    'JUMBOTAIL WHOLESALE PRIVATE LIMITED',
    'MORETASKS BUSINESS SOLUTION PRIVATE LIMITED',
    'SATTVAQWATH TECHNOLOGIES PRIVATE LIMITED',
    'JAPAN JINDAL ELEVATOR SERVICE PRIVATE LIMITED',
    'LIONHEAD CREATIONS PRIVATE LIMITED',
    'EIGHTYEIGHT PICTURES MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'REALIZUM DEVELOPERS PRIVATE LIMITED',
    'TYCOON BROTHERS PRIVATE LIMITED',
    'VAY NETWORK SERVICES PRIVATE LIMITED',
    'GUARDIAN NUTRITION AND HEALTHCARE PRIVATE LIMITED',
    'KVH MEDIA GROUP INDIA PRIVATE LIMITED',
    'ORANGE RAJKOT WIND POWER PRIVATE LIMITED',
    'HYBRENES PRIVATE LIMITED',
    'SRINIDHI CREDIT PRIVATE LIMITED',
    'BETEL LEAF HOSPITALITY PRIVATE LIMITED',
    'MIMOTO TECHNOLOGIES PRIVATE LIMITED',
    'VIDARBHA TECHNO ENGINEERS PRIVATE LIMITED',
    'SLATE AND LADDER EDUCATION PRIVATE LIMITED',
    '360 DEGREE SIMS PRIVATE LIMITED',
    'BAYVIEW DIGITAL SOLUTIONS PRIVATE LIMITED',
    'S.L. KIRLOSKAR CSR FOUNDATION',
    'CHISELKRAFT DESIGN LABORATORY PRIVATE LIMITED',
    'CUSMAT TECHNOLOGIES PRIVATE LIMITED',
    'AMARANTE BULK CARRIERS PRIVATE LIMITED',
    'HERO HOUSING FINANCE LIMITED',
    'SOCIAL NXT TECHNOLOGIES PRIVATE LIMITED',
    'TRADEBANYA TECHNOLOGIES PRIVATE LIMITED',
    'ATHA FOODS PRIVATE LIMITED',
    'MICROVISTA TECHNOLOGIES PRIVATE LIMITED',
    'JAGJIT INSTITUTE OF SKILLS PRIVATE LIMITED',
    'VIOLA SERVICES (INDIA) PRIVATE LIMITED',
    '20 WATTS PRIVATE LIMITED',
    'DIGI SQUARE PRIVATE LIMITED',
    'MARKS & KRONERS FOREX PRIVATE LIMITED',
    'TEAMPOWER ENGINEERING WORKS PRIVATE LIMITED',
    'COMTUSTEC INDIA PRIVATE LIMITED',
    'DIVINE BUSINESS NETWORK LIMITED',
    'GOYAL TOWERS PRIVATE LIMITED',
    'LNJ SKILLS & ROZGAR PRIVATE LIMITED',
    'IMERGE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SOFTMATRIX SOLUTIONS PRIVATE LIMITED',
    'SSENTIALIST CLOTHING PRIVATE LIMITED',
    'RENEW POWER SERVICES PRIVATE LIMITED',
    'MORGAN LAND DIVISION PRIVATE LIMITED',
    'TM BUILDING MATERIALS PRIVATE LIMITED',
    'KHUSHI SOFTWARE SERVICES PRIVATE LIMITED',
    'RAMASA CRANES PRIVATE LIMITED',
    'COOLBOOTS MEDIA PRIVATE LIMITED',
    'MOBILOITTE FOUNDATION',
    'ESSOR IT SOLUTIONS PRIVATE LIMITED',
    'ELEGANZ IT SOLUTIONS PRIVATE LIMITED',
    'RIYA SOCIAL WELFARE FOUNDATION',
    'APEX LOGISOLUTIONS PRIVATE LIMITED',
    'GLOBAL NOV PRIVATE LIMITED',
    'SHAILJA INFRATECH PRIVATE LIMITED',
    'AMITY GLOBAL EDUCATION ORGANISATION',
    'VINAYAK HOLIDAYS INDIA PRIVATE LIMITED',
    'AMBIENCE FOUNDATION',
    'UNLEASH MVMT PRIVATE LIMITED',
    'LEBEN LIFE SCIENCES PRIVATE LIMITED',
    'REQUITY APPLIED SCIENCES PRIVATE LIMITED',
    'GEO COMMERCE PRIVATE LIMITED',
    'STARC ENERGY SOLUTIONS PRIVATE LIMITED',
    'TAIYOU AUTOMATION PRIVATE LIMITED',
    'TAPTI LAXMI PASHUPALAK PRODUCER COMPANY LIMITED',
    'ZUNROOF TECH PRIVATE LIMITED',
    'PRINCE HOTELS AND MALLS PRIVATE LIMITED',
    'ARKECODE PRIVATE LIMITED',
    'JASH DIAJEWELS PRIVATE LIMITED',
    'SANT SOPANKAKA CHARITABLE FOUNDATION',
    'TOFFEE RIDE INNOVATIONS PRIVATE LIMITED',
    'MAXIMUS ENVIROTECH PRIVATE LIMITED',
    'TILANIK TECHNOLOGY PRIVATE LIMITED',
    'SKYBIN TECHNOLOGY PRIVATE LIMITED',
    'LAXSONS SOLAR SOLUTIONS PRIVATE LIMITED',
    '24 X 7 SUPPLY CHAIN PRIVATE LIMITED',
    'ORIOLE REAL ESTATE ADVISORS PRIVATE LIMITED',
    'VOYZANT TRAVEL SERVICES PRIVATE LIMITED',
    'DIALOGUEMAKERS PRIVATE LIMITED',
    'TARKEYBEIN EDUCATION FOUNDATION',
    'EZ BUILDCON PRIVATE LIMITED',
    'MASSIVE EARTH FOUNDATION',
    'KALAYARKOVIL FARMERS PRODUCER COMPANY LIMITED',
    'ARTIDOME CREATIONS PRIVATE LIMITED',
    'DIGISAT SKILL INDIA PRIVATE LIMITED',
    'S. PUDUR FARMERS PRODUCER COMPANY LIMITED',
    'BAGARIA MOTORS PRIVATE LIMITED',
    'SHEOPALS PRIVATE LIMITED',
    'MEERUTZONE NEUROSURGICAL PRIVATE LIMITED',
    'SPORTS ROOTS FOUNDATION',
    'CUBE WELLNESS PRIVATE LIMITED',
    'PPK GLOBAL LIMITED',
    'VSR IT CONSULTANCY SERVICES PRIVATE LIMITED',
    'CONTIFY TECHNOLOGIES PRIVATE LIMITED',
    'CLOUDINTEGRTR SOFTWARE SERVICES PRIVATE LIMITED',
    'ISPARROW DIGITAL INDIA PRIVATE LIMITED',
    'INVENTIVE HOLIDAYS PRIVATE LIMITED',
    'BHAGWATI E COMMERCE INDIA PRIVATE LIMITED',
    'RVM RECYCLE PRIVATE LIMITED',
    'CRE8 ENTERTTAINMENT & HOSPITTALITY PRIVATE LIMITED',
    'BHADRA HUMAN RESOURCES PRIVATE LIMITED',
    'MOBIVISITS MEDIA PRIVATE LIMITED',
    'MR EVENT MANAGEMENT SERVICES PRIVATE LIMITED',
    'TRAVELMADDY TOURS PRIVATE LIMITED',
    'SPEECHLOGIX TECHNOLOGIES PRIVATE LIMITED',
    'PACKWORLD INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'VCM MOTORS AGENCIES PRIVATE LIMITED',
    'VALUATIONKART PRIVATE LIMITED',
    'OXFORD - II MANAGEMENT SERVICES ASSOCIATION',
    'COGITO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'EQUITOS SERVICES PRIVATE LIMITED',
    'SKYRAS PRIVATE LIMITED',
    'STARONE GLOBAL PRIVATE LIMITED',
    'LOHCHABKRISHNA MOTORS PRIVATE LIMITED',
    'MONARCHJAIS HUMAN RESOURCE CONSULTANCY PRIVATE LIMITED',
    'TERRAPRO RECYCLING SOLUTIONS PRIVATE LIMITED',
    'ICENTRIC PROFESSIONAL SERVICES PRIVATE LIMITED',
    'GENERAL AERONAUTICS PRIVATE LIMITED',
    'TERRAMINE ENTERPRISES PRIVATE LIMITED',
    'MACSHELL INFORMATICS PRIVATE LIMITED',
    'KRYPTOS TECHNOLOGIES PRIVATE LIMITED',
    'QUINTEZE FACILITY MANAGEMENT INDIA PRIVATE LIMITED',
    'KINTEL INCOMM PRIVATE LIMITED',
    'AIMTUS SERVICES PRIVATE LIMITED',
    'YESTE MIGRATION AND EDUCATION CONSULTINGPRIVATE LIMITED',
    'BRILLMAX PRIVATE LIMITED',
    'COGEN SOFT TECH PRIVATE LIMITED',
    'PI STATISTICAL ANALYSIS SERVICES PRIVATELIMITED',
    'ASHMEET AUTOMOBILES PRIVATE LIMITED',
    'LA CAVE ENTERPRISES PRIVATE LIMITED',
    'AVCOM INFOTECH PRIVATE LIMITED',
    'KALVI WORLD SOLUTIONS PRIVATE LIMITED',
    'CREDIMORE SERVICES PRIVATE LIMITED',
    'LEGEND LOGISTICS (INDIA) PRIVATE LIMITED',
    'ANUBHA BRANDS PRIVATE LIMITED',
    'EVOLVE GREEN POWER PRIVATE LIMITED',
    'AL QEBLA AL WATYA PRIVATE LIMITED',
    'TIMES SHIPPING AGENCIES PRIVATE LIMITED',
    'WINSPIRE EDUCATIONAL SOLUTIONS PRIVATE LIMITED',
    'CUSTOMER INSIGHT 360 TECHNOLOGIES PRIVATE LIMITED',
    'SCANBEE TECHNOLOGIES PRIVATE LIMITED',
    'INTEGRALZONE INDIA PRIVATE LIMITED',
    'TECHMAN SYSTEMS PRIVATE LIMITED',
    'TORCENTE MOTORS PRIVATE LIMITED',
    'BRANDZONE ENTERTAINMENT PRIVATE LIMITED',
    'MPN ASSOCIATES PRIVATE LIMITED',
    'ADVA BUSINESS PRIVATE LIMITED',
    'PYTHEOS HEALTH SYSTEMS PRIVATE LIMITED',
    'APS-ASB PRIVATE LIMITED',
    'PROXIMOVE TECHNOLOGIES PRIVATE LIMITED',
    'SUVARCHAS SOLAR POWER PRIVATE LIMITED',
    'IFCPL HOSPITALITY PRIVATE LIMITED',
    'CRASS INFOTECH PRIVATE LIMITED',
    'ODEW CLOUDS PRIVATE LIMITED',
    'NAVRASA DUENDE PRIVATE LIMITED',
    'IMPLEMENT IMPEX PRIVATE LIMITED',
    'AIESYS PRIVATE LIMITED',
    'TECHCEM CONSULTING AND ENGINEERING PRIVATE LIMITED',
    'VISHVARUPA SOLAR POWER PRIVATE LIMITED',
    'QRT LABS PRIVATE LIMITED',
    'POLAR QUALITY INDIA PRIVATE LIMITED',
    'TECNONATION MEDIA PRIVATE LIMITED',
    'FASDERMA INDIA PRIVATE LIMITED',
    'INULITE NUTRACEUTICALS PRIVATE LIMITED',
    'FOOD CHAUPAL INDIA PRIVATE LIMITED',
    'PAYTM SERVICES PRIVATE LIMITED',
    'MTEL NETWORKS PRIVATE LIMITED',
    'TECHNOHOSTE SERVICES PRIVATE LIMITED',
    'INFRIT TECHNOLOGIES PRIVATE LIMITED',
    'INFUSE VALUE SOLUTIONS PRIVATE LIMITED',
    'KAUNIS MARKETING SERVICES PRIVATE LIMITED',
    'RAZORTHINK TECHNOLOGIES PRIVATE LIMITED',
    'ARDESHIR B. CURSETJEE PROPERTIES PRIVATELIMITED',
    'POLYCO CHEM PRIVATE LIMITED',
    'DOCIETY TECHNOLOGIES PRIVATE LIMITED',
    'CLICKON TECHNOLOGIES PRIVATE LIMITED',
    'CSS FOUNDER PRIVATE LIMITED',
    'SANVIKA RENEWABLE ENERGY SYSTEMS PRIVATELIMITED',
    'DURASUN SOLAR SOLUTIONS PRIVATE LIMITED',
    'KRISHI SUNPOWER PRIVATE LIMITED',
    'BANYAN ROOTS ORGANICS PRIVATE LIMITED',
    'PEN MUSIC PRIVATE LIMITED',
    'BSA FUTURE TECHSKILLS FOUNDATION',
    'AEZIS GLOBAL PRIVATE LIMITED',
    'LIMEPROPCARE SOLUTIONS PRIVATE LIMITED',
    'TELECOMATICS TECHNOLOGIES PRIVATE LIMITED',
    'FIBERINQ INFOTAINMENT SOLUTIONS PRIVATE LIMITED',
    'AV RESOLUTION AGENTS PRIVATE LIMITED',
    'SIGMAFLOW PRODUCTION SOLUTIONS PRIVATE LIMITED',
    'GRANDPICK PRIVATE LIMITED',
    'STHI REPRESENTATIONS PRIVATE LIMITED',
    'SNIIKS MARKETPLACE PRIVATE LIMITED',
    'TECHIN GAUGES AND INSTRUMENT PRIVATE LIMITED',
    'SURYODAY RENEWABLES LIMITED',
    'GRINIBHRIT SOLAR POWER PRIVATE LIMITED',
    'SML GOODEARTH PRIVATE LIMITED',
    'WEBDEW PRIVATE LIMITED',
    'GOASIS PRIVATE LIMITED',
    'JAGUAR LAND ROVER TECHNOLOGY AND BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'VCORP VENTURES PRIVATE LIMITED',
    'GOCARGO FORWARDING PRIVATE LIMITED',
    'J2TMEDIA WEB SOLUTIONS (OPC) PRIVATE LIMITED',
    'SWIPFE INFOTECH PRIVATE LIMITED',
    'POLSO PRODUCT PRIVATE LIMITED',
    'APS TECHSOFT PRIVATE LIMITED',
    'MERAKISAN PRIVATE LIMITED',
    'IN2IT ENTERPRISE BUSINESS SERVICES PRIVATE LIMITED',
    'AROKEE ONLINE SOLUTIONS PRIVATE LIMITED',
    'TRANSZONE CARGO EXPRESS PRIVATE LIMITED',
    'AGRA CHAIN FOUNDATION',
    'BUENO LABS PRIVATE LIMITED',
    'SUCCESS AUTOMOBILE PRIVATE LIMITED',
    'BUILTSIMPLE TECHNOLOGIES PRIVATE LIMITED',
    'ABR CAFE AND BAKERS PRIVATE LIMITED',
    'CELESTE ENTERPRISES PRIVATE LIMITED',
    'INEX INTERNATIONAL EDUCATION EXPERTS PRIVATE LIMITED',
    'BHARAT ENERGY STORAGE TECHNOLOGY PRIVATELIMITED',
    'PLAST-CONTROL INDIA PRIVATE LIMITED',
    'ISERA BIOLOGICAL PRIVATE LIMITED',
    'MULTIREACH BROADBAND SERVICES PRIVATE LIMITED',
    'KAKINADA GATEWAY PORT LIMITED',
    'CAPITAL CULTURAL CLUB',
    'ROCHESTON PRIVATE LIMITED',
    'PURVALAND PRIVATE LIMITED',
    'FUTURE NINE INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'SHIVOM DAYAL ENERGIES PRIVATE LIMITED',
    'RAYAH IMPEX PRIVATE LIMITED',
    'BOOMTRAIN APAC PRIVATE LIMITED',
    'SOMEHSA GEO-COASTAL PRIVATE LIMITED',
    'XSP TECHNOLOGIES PRIVATE LIMITED',
    'BLUEBANYAN TECHNOLOGIES PRIVATE LIMITED',
    'CAMPUS STUDENTS COMMUNITIES PRIVATE LIMITED',
    'CRICHEROES PRIVATE LIMITED',
    'NATURALS TRAINING CENTRE PRIVATE LIMITED',
    'IOTA OBJECTS PRIVATE LIMITED',
    'INDIGRID SOLAR-I (AP) PRIVATE LIMITED',
    'STEER DAVIES GLEAVE INDIA PRIVATE LIMITED',
    'NOVAN TRADE CHEM PRIVATE LIMITED',
    'HEALTH UNIFIED TECHNOLOGIES PRIVATE LIMITED',
    'CLEAN SOLAR POWER (GULBARGA) PRIVATE LIMITED',
    'TECH UDYAM SOLUTIONS PRIVATE LIMITED',
    'HUBBALLI DHARWAD WATER SUPPLY PROJECT LIMITED',
    'LEADBRAINS TECHSERVICES PRIVATE LIMITED',
    'RISHDEV INVESTMENTS PRIVATE LIMITED',
    'OCROLUS EAST PRIVATE LIMITED',
    'APPY TIMES RETAIL AND SERVICES PRIVATE LIMITED',
    'WORKING MINDS TECHNOLOGY PRIVATE LIMITED',
    'ECOAIR COOLING SYSTEMS PRIVATE LIMITED',
    'SAPRECISION PRIVATE LIMITED',
    'SIMONS HOLIDAYS PRIVATE LIMITED',
    'INNOAPPS TECHNOLOGIES PRIVATE LIMITED',
    'MEHTA DREAMS REALTY PRIVATE LIMITED',
    'TESSACT PRIVATE LIMITED',
    'QUINTEL DIGITAL TELECOMMUNICATIONS PRIVATE LIMITED',
    'ILV DISTRIPARK (MWC) PRIVATE LIMITED',
    'BKG RESOURCES PRIVATE LIMITED',
    'DIGICOLLECT INDIA PRIVATE LIMITED',
    'AMREEN ELECTRICALS PRIVATE LIMITED',
    'ALTEGIC MANAGEMENT CONSULTING PRIVATE LIMITED',
    'IGNITHO TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    '3D EVANT SOLUTIONS PRIVATE LIMITED',
    'INICU MEDICAL PRIVATE LIMITED',
    'SRS COMBINED CARGO PRIVATE LIMITED',
    'XFACTORY SOLUTIONS PRIVATE LIMITED',
    '6TEEN RETAIL PRIVATE LIMITED',
    'AIRBORNE AERO SERVICES PRIVATE LIMITED',
    'LOMOSO SOLUTIONS PRIVATE LIMITED',
    'EMMESS TECHNOLOGIES PRIVATE LIMITED',
    'SIM AND SAM',
    'S ( KOMPALLY ) PRIVATE LIMITED',
    'PORUS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'GIRL RISING INDIA FOUNDATION',
    'SIRI SAMPADA INFRASTRUCTURE PRIVATE LIMITED',
    'ASSOCIATION OF PRODUCT LEADERS',
    'SWIFTBEAM INDUSTRIES PRIVATE LIMITED',
    'AARVY HEALTHCARE PRIVATE LIMITED',
    'X-BILLION ACTION LAB PRIVATE LIMITED',
    'TECHCANOPY SOFTWARE LABS PRIVATE LIMITED',
    'FELICITOUS ENTERPRISES PRIVATE LIMITED',
    'YOMA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'LEASEACCELERATOR INDIA PRIVATE LIMITED',
    'FIYOGI PRIVATE LIMITED',
    'CHRYSANTHE NATURALS PRIVATE LIMITED',
    'HIKEON TECHNOLOGIES PRIVATE LIMITED',
    'RUSSAIR TECHNOLOGIES PRIVATE LIMITED',
    'ASHA FIRODIA EDUCATIONAL FOUNDATION',
    'APONIAR SOLUTION PRIVATE LIMITED',
    'MEKASU PRIVATE LIMITED',
    'INFRATECH TECHNOLOGIES PRIVATE LIMITED',
    'JJ REALIS INDIA PRIVATE LIMITED',
    'VRELAY ONLINE PRIVATE LIMITED',
    'KEYA CREATIVE DESIGNS PRIVATE LIMITED',
    'APELO CONSULTING PRIVATE LIMITED',
    'PARABOLE INDIA PRIVATE LIMITED',
    'CAMBRIDGE INDIA RESEARCH FOUNDATION',
    'ONFIELDIN PRIVATE LIMITED',
    'VTR INDUSTRIES PRIVATE LIMITED',
    'KALYANI MEDITIMES PRIVATE LIMITED',
    'SUMMIT HOTELS & RESORTS PRIVATE LIMITED',
    'VIDMED HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'PEBBLEWORKS REAL ESTATES PRIVATE LIMITED',
    'SURESHOT CONNECT PRIVATE LIMITED',
    'LAYMEN AGRO VENTURES PRIVATE LIMITED',
    'SIMPLY GROW TECHNOLOGIES PRIVATE LIMITED',
    'NEW DELHI MUNICIPAL COUNCIL SMART CITY LIMITED',
    'BON FRESH FOODS PRIVATE LIMITED',
    'ACLAT PROP PRIVATE LIMITED',
    'TRABAAJO SOFTWARE LABS PRIVATE LIMITED',
    'STELLA ALLOYS PRIVATE LIMITED',
    'ASR EXPRESS PRIVATE LIMITED',
    'CYBERENUE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'MYTRAH BHAANUJ POWER PRIVATE LIMITED',
    'ORANGEBITS SOFTWARE TECHNOLOGIES (INDIA)PRIVATE LIMITED',
    'NATURE AND NURTURE AGRO HOMES PRIVATE LIMITED',
    'KRAFTMAN PACKAGING PRIVATE LIMITED',
    'INVEST ON HEALTH PRIVATE LIMITED',
    'JAPMAN TECHNOLOGIES PRIVATE LIMITED',
    'TOPYA INDIA PRIVATE LIMITED',
    'UNOVEL INDUSTRIES PRIVATE LIMITED',
    'FIRST CUT DESIGN STUDIO INDIA PRIVATE LIMITED',
    'ADVOICE ADVERTISING PRIVATE LIMITED',
    'JUBEERICH PROPERTIES PRIVATE LIMITED',
    'ICUBESWIRE TECHNOLOGIES PRIVATE LIMITED',
    'KUTUMBH CARE SOLUTIONS PRIVATE LIMITED',
    'INSTA MARK PRIVATE LIMITED',
    'SNAPCOMMUTE LABS PRIVATE LIMITED',
    'SPONSIFYME TECHNOLOGIES PRIVATE LIMITED',
    'TECHNOCENTRIC SOLUTIONS PRIVATE LIMITED',
    'PRAGNYA RETAIL PRIVATE LIMITED',
    'HIMANAD MANAGEMENT SERVICES PRIVATE LIMITED',
    'ORIANA KPO SERVICES PRIVATE LIMITED',
    'CONTEXT BI INDIA PRIVATE LIMITED',
    'DIVINESEAIR LOGISTICS PRIVATE LIMITED',
    'SHREE SAMARTH LOGISTICS & WAREHOUSING PRIVATE LIMITED',
    'HIRVEPUNYA PRIVATE LIMITED',
    'ARVIND SPORTS FASHION PRIVATE LIMITED',
    'DEZTIEGO RENTALS PRIVATE LIMITED',
    'SPAWN VENTURES SERVICES PRIVATE LIMITED',
    'FAIRVALUE ADVISORS PRIVATE LIMITED',
    'QUBYTE CONSOLIDATE PRIVATE LIMITED',
    'ROCKFOREST TECHNOLOGIES INDIA PRIVATE LIMITED',
    'EDSMART EDU SERVICES PRIVATE LIMITED',
    'CHANAKYAISM PRIVATE LIMITED (OPC)',
    'EXDION SOLUTIONS PRIVATE LIMITED',
    'SHARK TECH INTELLIGENCE PRIVATE LIMITED',
    'YAUM DESIGN PRIVATE LIMITED',
    'INFERSTRAT PRIVATE LIMITED',
    'OTSE ELEVATORS AND ESCALATORS PRIVATE LIMITED',
    'SEVEN MILES TOURS AND TRAVELS PRIVATE LIMITED',
    'ENHANCED COMMUNICATIONS & TECHNOLOGIES PRIVATE LIMITED',
    'MARS ENTERPRISES & HOSPITALITY PRIVATE LIMITED',
    'LM BIOMEDICAL PRIVATE LIMITED',
    'PRIFACT SOLUTIONS PRIVATE LIMITED',
    'IDEALISTJACK PRIVATE LIMITED',
    'CFC INTEGRATED TRANSPORT SERVICES PRIVATE LIMITED',
    'SHREEGEETA IT INFRA PRIVATE LIMITED',
    'ADAPTIO FACILITY MANAGEMENT PRIVATE LIMITED',
    'GOSREE INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'ANB FUELS PRIVATE LIMITED',
    'SERVOTECH GLOBAL PRIVATE LIMITED',
    'CHISELON TECHNOLOGIES PRIVATE LIMITED',
    'QUINTE FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'BESTSELLERS FILMS PRIVATE LIMITED',
    'CONFEDERATION OF REAL ESTATE BROKER',
    'S BRIDGE IT PRIVATE LIMITED',
    'Anomishere design company private limited',
    'Simpson soft services private limited',
    'MEREDITH INDIA SERVICES PRIVATE LIMITED',
    'Totient business solutions private limited',
    'HAPPIEST MINDS TECHNOLOGIES LIMITED',
    'Gega infotech private limited',
    'AZALEAS STUDIOS PRIVATE LIMITED',
    'Thousand island entertainment private limited',
    'Carnoustie entertainment private limited',
    'Digital miles entertainment private limited',
    'Rugby associaton of maharashtra',
    'Arnav media and entertainment private limited',
    'Bombay amusement rides private limited',
    'Tarantella sports private limited',
    'Punjab cricket league',
    'Swar tradelink limited',
    'Anjali mukerjee health total private limited',
    'Palestra enterprise private limited',
    'Kutch district rifle association',
    'Fantain sports private limited',
    'Carnoustie sports private limited',
    'Assam cricket league',
    'Gelkaps sports private limited',
    'Carnoustie management (india) private limited',
    'NIELSEN SPORTS INDIA PRIVATE LIMITED',
    'Fagun co private limited',
    'Excavate research & analysis private limited',
    'Gold coin engineers private limited',
    'Aatash management services private limited',
    'Fracton technologies private limited',
    'CORE AUTOMATION INDIA PRIVATE LIMITED',
    'Sonique property management solutions private limited',
    'Studio abd design services private limited',
    'Anchor offshore services limited',
    'Barclays wealth trustees (india) private limited',
    'Aarav offshore services private limited',
    'Maestros equipments services private limited',
    'Teleprudence telecom management private limited',
    'Blue water offshore (india) private limited',
    'Supremus worli private limited',
    'Mumbai mile regeneration association',
    'Genex corporate services private limited',
    'Deasra foundation',
    'Wagons learning private limited',
    'Life slimming and cosmetic private limited',
    'Suryaa facilities services private limited',
    'Aum consulting private limited',
    'Ace skill development private limited',
    'Siti royal heritage communications private limited',
    'Siti singhbhum cable net company private limited',
    'Arv advisory services private limited',
    'Da advisory private limited',
    'Clinico diagnostic centre india private limited',
    'Dynamics legal and financial consultants private limited',
    'Maison de luxe services private limited',
    'Isoqar (india) private limited',
    'Entrust communications private limited',
    'Aditya facility services private limited',
    'Jalaram veneers & floors private limited',
    'Optima money managers private limited',
    'POTENTIA GROWTH TECHNOLOGIES PRIVATE LIMITED',
    'Ram e and i systems p ltd',
    'Siti darshan cable net company private limited',
    'PUNJ FOODS AND FACILITY MANAGEMENT PRIVATE LIMITED',
    'GREEN IVY VENTURES PRIVATE LIMITED',
    'Pankaj dyes and chemicals private limited',
    'Vijay elastomer processors pvt ltd',
    'Liladhar pasoo forwarders pvt ltd',
    'Tropical securities and investments private limited',
    'Mech-india engineers pvt.ltd.',
    'Ostwal plantation (india) ltd',
    'Techno process equipments (india) private limited',
    'Jas jog consolidated trading private limited',
    'Hamon india thermal engineers and contracttors private limited',
    'Soboro exports private limited',
    'Shantiraj foods private limited',
    'Seaworld shipping and logistics private limited',
    'Shrinivasa agro foods private limited',
    'Proficient realty private limited',
    'Sonam management solution pvt ltd',
    'Simplex realty limited',
    'Shri jagdamba polymers limited',
    'Kakatiya textiles ltd',
    'Shetron limited',
    'Bheema cements limited',
    'Austin engineering company limited',
    'Amforge industries limited',
    'Patels airtemp (india) limited',
    'FIVE CORE EXIM LIMITED',
    'Rama vision limited',
    'Hindustan motors ltd',
    'Mldc combines ltd',
    'Jumbo bag limited',
    'Stanpacks (india) limited',
    'Suzlon energy limited',
    'Cni research limited',
    'Adani enterprises limited',
    'The indian hume pipe company limited',
    'Ashoka mercantile limited',
    'Stl global limited',
    'Hathway cable and datacom limited',
    'Sidh management corporate services limited',
    'Desara design private limited',
    'Theyyampattil ventures private limited',
    'Posh recycling scraps private limited',
    'Palava city management private limited',
    'Ujjawala power private limited',
    'Ad hydro power limited',
    'Power transmission corporation of uttarakhand limited',
    'Techsine equipments private limited',
    'Juwi india renewable energies private limited',
    'The seksaria biswan sugar factory limiited',
    'Nagai power private limited',
    'Jala shakti limited',
    'Tn solar power energy private limited',
    'Nuclear power corporation of india limited',
    'Npcil - indianoil nuclear energy corporation limited',
    'GENERACION EOLICA INDIA PRIVATE LIMITED',
    'APRAAVA RENEWABLE ENERGY PRIVATE LIMITED',
    'Anu solar power private limited',
    'Khaga energy private limited',
    'Meenakshi suban siri power private limited',
    'Premier green energy products private limited',
    'Cinch power and infrastructure private limited',
    'Basilica power and infrastructure private limited',
    'Allgreen energy india private limited',
    'Tata power green energy limited',
    'Gowthami green energy private limited',
    'Surana solar systems private limited',
    'Velmurugan energy farm private limited',
    'Scm green power private limited',
    'Satellite cng services private limited',
    'Athani sugars limited',
    'NATL POWER PRIVATE LIMITED',
    'Meenakshi power private limited',
    'Shakun gases pvt ltd',
    'Confidence go gas energy limited',
    'Tatva global water technologies private limited',
    'Natural aqua beverages private limited',
    'Orange city water private limited',
    'GOLDEN JUBILEE HOTELS Private Limited',
    'Smr ventures private limited',
    'Brampton infrastructure india private limited',
    'Tarkeshwar realtors private limited',
    'Icc projects private limited',
    'Surat parle point developers private limited',
    'Ratna infracon private limited',
    'Mindcomp tech park private limited',
    'Maverick property investments private limited',
    'Al ansari power technologies india private limited',
    'Xmark builders and developers private limited',
    'Farzana developers private limited',
    'Farida developers private limited',
    'Femi developers private limited',
    'Embee construction company private limited',
    'Shroff and associates (engineers) private limited',
    'Mahindra construction company limited',
    'SUKAMAL IMPEX PRIVATE LIMITED',
    'Psc realtors private limited',
    'Landmark industrial constructions private limited',
    'Neon innovative private limited',
    'Bygging infrastructure private limited',
    'Rajdarshan properties private limited',
    'Better builders and infrastructure private limited',
    'Maruti dwellers private limited',
    'VIRTUOSO REALTY-ESTATE PRIVATE LIMITED',
    'Ahuja mansions developers and constructions private limited',
    'Colossal realty private limited',
    'Urban rupi infrastructure private limited',
    'Marvel properties private limited',
    'Balsam developers private limited',
    'Speed 4 prefab solutions private limited',
    'Lalbaug buildings private limited',
    'Benchmark infratech private limited',
    'AQAAB REALTY PRIVATE LIMITED',
    'AQAAB INFRASTRUCTURE PRIVATE LIMITED',
    'Cornice realty private limited',
    'Sri lalita construction private limited',
    'Sri lalita landmarks private limited',
    'Supra ventures private limited',
    'Indu techzone private limited',
    'M.a.k projects private limited',
    'E and a constructions private limited',
    'Kapil precast and infra private limited',
    'APARNA CERAMIC TILES PRIVATE LIMITED',
    'Shs infrastructure private limited',
    'Vrc constructions (india) private limited',
    'Raghav buildcon private limited',
    'Gold river realtors private limited',
    'Pisces developers and promoters private limited',
    'Skh constructwell private limited',
    'Automat irrigation private limited',
    'I p constructions pvt ltd',
    'Spl infratech private limited',
    'Priyansh buildwell india private limited',
    'Wizard buildwell india private limited',
    'Sundry real projects india private limited',
    'Goyal arcade private limited',
    'Adeshwar properties private limited',
    'Eldorado estates private limited',
    'Prudential realtors private limited',
    'Francisco hospitality private limited',
    'Cornerstone property investments private limited',
    'Ds-max properties private limited',
    'Good earth eco futures private limited',
    'Rosetta projects private limited',
    'Shriprop infrastructure private limited',
    'Shriprop realities private limited',
    'Grun developers private limited',
    'Moham infra private limited',
    'Tez zahra properties private limited',
    'Sai sharan real estate private limited',
    'Kumar properties consultants private limited',
    'Palmtree developments private limited',
    'Excellex realtors private limited',
    'Coilaho land developers private limited',
    'R.c. realtors private limited',
    'YOLA STAYS LIMITED',
    'A. patni realty private limited',
    'Ashvik real estate private limited',
    'Ft projects limited',
    'MANKALESHWAR AGRO PRIVATE LIMITED',
    'Vva infin private limited',
    'Asrani infrastructure private limited',
    'Loktrayashray infra private limited',
    'Mredco realestate advisors private limited',
    'Rajesh estate ventures private limited',
    'Waive premises private limited',
    'Kripa oneness private limited',
    'Skg corporation private limited',
    'Dpn green world earth movers private limited',
    'Rajpal realty private limited',
    'Morya buildcon private limited',
    'Bonanza projects private limited',
    'Virtual assets india private limited',
    'Aps property solutions private limited',
    'Sun metals and alloys private limited',
    'Gspr developers private limited',
    'Automax constructions limited',
    'G s r realtors private limited',
    'SKYMETTLE INFRASTRUCTURES PRIVATE LIMITED',
    'Anupriaa associates private limited',
    'Lucina realtors private limited',
    'Limitless contracting private limited',
    'Pushpak housing estates pvt ltd',
    'STONE DOOR RESOURCES PRIVATE LIMITED',
    'Snowblue infrastructures private limited',
    'Newtech shelters private limited',
    'Jhum developers private limited',
    'Apk buildhomes private limited',
    'Manzil developers private limited',
    'Urs infra private limited',
    'Blossom estates private limited',
    'Autumn properties private limited',
    'Mansoon properties private limited',
    'Fort residency private limited',
    'Vishnoi construction company private limited',
    'Oracle finex ltd.',
    'Rentasset initiatives private limited',
    'Pcnet infotech private limited',
    'Clinet it solution private limited',
    'Megha compusoft private limited',
    'Morwal nirman private limited',
    'Direct information private limited',
    'Acoris research limited',
    'Amur infotech private limited',
    'GALAXY MEGA FOOD PARK PRIVATE LIMITED',
    'ENOIA BABCOCK BORSIG PRIVATE LIMITED',
    'Laila infotech limited',
    'Sumadhura geomatica private limited',
    'Interactive media private limited',
    'Pranet infosoft private limited',
    'Skh info services private limited',
    'H. m. informatics private limited',
    'Matchmove india private limited',
    'SHOOGLOO DIGITAL MARKETING PRIVATE LIMITED',
    'INVENTURUS KNOWLEDGE SOLUTIONS LIMITED',
    'Inbetween software development private limited',
    'Innova systems (india) private limited',
    'Icenet private limited',
    'Rangam infotech private limited',
    'Rapidradio solutions private limited',
    'Nascent info technologies private limited',
    'Skyy createch services private limited',
    'HEALTHSUITE PRIVATE LIMITED',
    'Constellation software and consulting private limited',
    'Atreya instruements private limited',
    'Thinkin soft solutions private limited',
    'Brightsword technologies private limited',
    'Value information technology solutions private limited',
    'CUBOT BUSINESS INTELLIGENCE PRIVATE LIMITED',
    'Antrax technologies private limited',
    'Techzone technologies private limited',
    'TRUEBLUE INDIA IT PRIVATE LIMITED',
    'Thoughtfocus information technologies private limited',
    'Gofrugal technologies private limited',
    'Prithvi digitech private limited',
    'Zyme solutions private limited',
    'Mediajenie softech private limited',
    'Alpen asset advisors india private limited',
    'Auctus industries private limited',
    'Sus enterprises private limited',
    'Forever lifestyle private limited',
    'Nsk advisors private limited',
    'Krishiya commercials private limited',
    'Algorhythm tech private limited',
    'Consortium architects private limited',
    'Ankekshan consulting private limited',
    'Firebolt entertainment private limited',
    'Spencer and company limited',
    'RANDSTAD TECHNOLOGIES PRIVATE LIMITED',
    'Trans pacific logistics private limited',
    'Viswire simulation and training private limited',
    'SKEPL ENTERPRISES PRIVATE LIMITED',
    'I FIVE TECHNOLOGY PRIVATE LIMITED',
    'Vokian localisation private limited',
    'Rbia minerals and metals private limited',
    'Esy tech resources india private limited',
    'AGMELCO TECHNO SERVICES PRIVATE LIMITED',
    'Cloudnow technologies private limited',
    'Johal automobiles pvt. ltd.',
    'Advent commodities pvt ltd',
    'Subhvani marcom private limited',
    'Sws india management support and service private limited',
    'Disha india education foundation',
    'SPRINGBOARD EDUCATION PRIVATE LIMITED',
    'Kingfisher aviation training limited',
    'Geebee education private limited',
    'School for e education research and innovation private limited',
    'Edinvent education and training private limited',
    'Bluetiger learning services private limited',
    'Hab learning private limited',
    'Graposs edutech private limited',
    'Triway learning private limited',
    'SMAARTINDIA INFOTECH SYSTEMS PRIVATE LIMITED',
    'Talentos (india) private limited',
    'ASPIRE KNOWLEDGE VENTURES PRIVATE LIMITED',
    'Go harness india private limited',
    'Pioneer bfactory consultancy & services private limited',
    'Gerry martin conservation education private limited',
    'Phi education solutions private limited',
    'Zeusk network private limited',
    'M3m india private limited',
    'Exercise strategist private limited',
    'Auxano technologies private limited',
    'Naandi education support and training private limited',
    'Piyush foundation and education research',
    'Pratham institute for literacy education and vocational training',
    'Percept holdings private limited',
    'EMERGENCY DHATRI SISHU CARE FOUNDATION',
    'Amplifon (india) private limited',
    'MY FROYOLAND PRIVATE LIMITED',
    'Bkpmg health solutions private limited',
    'Hearing solutions private limited',
    'Annaiarul healthcare private limited',
    'Care continuum private limited',
    'PRAMODINI MEDICARE PRIVATE LIMITED',
    'ARUNODAYA HOSPITALS PRIVATE LIMITED',
    'Hcg medi-surge hospitals private limited',
    'Sharavathy conductors private limited',
    'BHADRA PAPER MILLS LIMITED',
    'Mummy foods private limited',
    'Rifco swarnagiri developers private limited',
    'Eta technology private limited',
    'SPARTAN TECHNOLOGY SERVICES AND SOLUTIONS PRIVATE LIMITED',
    'Bhandari spinning mills limited',
    'Pinnacle electrodes private limited',
    'Trident interwood private limited',
    'S p s intrad private limited',
    'Yukthi systems private limited',
    'Nationwide primary healthcare services private limited',
    'Mir holistics private limited',
    'Fairdeal haleness solutions private limited',
    'Precise eye care private limited',
    'Ashra mental health & research private limited',
    'Versed healthcare private limited',
    'SPECTRA HOSPITAL SERVICES PRIVATE LIMITED',
    'B m hospitals private limited',
    'Centronic (india) diagnostics private limited',
    'Kidz healthcare pvt ltd',
    'Vijai dental depot private limited',
    'Eye-q vision private limited',
    'Flying stars informatics private limited',
    'Step up charitable foundation',
    'Karma healing & wellness private limited',
    'OJAS FBC PRIVATE LIMITED',
    'Ojb herbals private limited',
    'Precitech laboratories private limited',
    'Lifecare diagnostic and research centre private limited',
    'A2z waste management (aligarh) limited',
    'Abs enviro tech india private limited',
    'A2z waste management (merrut) limited',
    'Hyderabad integrated msw limited',
    'Swedish chamber of commerce india',
    'Pentagon charitable foundation',
    'All india association of authorized money changers and money transfer agents',
    'Gujarat thakor and koli vikas nigam',
    'Bd agriculture (india) private limited',
    'Standard automotive machines (india) private limited',
    'Emka india panel accessories private limited',
    'Dynamic machines private limited',
    'Suraj filtration separation private limited',
    'Deshkul chlorination private limited',
    'Enviiro bulkk handling systems private limited',
    'Fine dies and moulds (india) private limited',
    'Altair industrial technologies private limited',
    'Amul crankshaft private limited',
    'Grenzebach machinery (india) private limited',
    'Excel plants and equipment private limited',
    'Unisource engineering private limited',
    'Durferrit asea private limited',
    'Korea fuel-tech india private limited',
    'Kanoi appliances pvt ltd',
    'Avneel electricals private limited',
    'ADYANI INFRAVENTURES PRIVATE LIMITED',
    'Enpro industrial automation private limited',
    'Synergistix (india) private limited',
    'Sunram systems (india) private limited',
    'Ark peripherals private limited',
    'RASHI PERIPHERALS LIMITED',
    'SURONIK OVERSEAS PRIVATE LIMITED',
    'Markss infotech limited',
    'Megasoft computer services private limited.',
    'SYRMA SGS TECHNOLOGY LIMITED',
    'Sunnet solutions private limited',
    'Annam software private limited',
    'Yale electronic services private limited',
    'Pragati computers limited',
    'Eng software pvt ltd',
    'Silkaans electricals manufacturing company private limited',
    'Beico industries private limited',
    'G-1 energy solutions private limited',
    'Sendhamarai engineering private limited',
    'Ak transcharger private limited',
    'Marshah industrial electronics company private limited',
    'Nik -san engineering company limited',
    'Indigenous control electricals private limited',
    'Tiny fuse private limited',
    'Alpha techno systems private limited',
    'Binix electrosystems private limited',
    'Nuclieonz tech-systems private limited',
    'Hi-vac wares private limited',
    'Miracle cables (india ) private limited',
    'Sreesolder manufacturing company private limited',
    'Constant wire engineering private limited',
    'Omega natural polarity private limited',
    'IDEAFORGE TECHNOLOGY LIMITED',
    'Aditya electricals and power savers private limited',
    'Captain engineering private limited',
    'ANS PROJECTS INDIA PRIVATE LIMITED',
    'Enpro secan india limited',
    'Vizio digital electronics private limited',
    'Amtek instruments private limited',
    'Thermosen technologies private limited',
    'Schweitzer systemtek india private limited',
    'Cipl resurge private limited',
    'Tathastu financial advisory services private limited',
    'Tribhovandas bhimji zaveri and sons india private limited',
    'Connectors hr consulting private limited',
    'CORVI LED LIMITED',
    'Batimat insulations private limited',
    'Earth solutions private limited',
    'Fluxonix educational services private limited',
    'Miracle smart card private limited',
    'Summation services private limited',
    'Flairmen lifestyle services private limited',
    'Anc industries private limited',
    'CRESTWORTH MANAGEMENT PARTNERS PRIVATE LIMITED',
    'Tn packaging private limited',
    'Chitale genus abs (india) private limited',
    'Promech automation private limited',
    'Enhance knowledge services private limited',
    'Add interior private limited',
    'Gravitech business solutions private limited',
    'Srajan ventures private limited',
    'Lvs corporation private limited',
    'Aaa business solutions india private limited',
    'B n rathi comtrade private limited',
    'Select arc (india) private limited',
    'Corporate aesthetic refurbishing enterprise private limited',
    '3ns capital ventures private limited',
    'Vijay racing and farms private limited',
    'ENPRODE ENGINEERING & CONSULTING INDIA PRIVATE LIMITED',
    'Action guarding services private limited',
    'Kicking savings e com private limited',
    'Wordsmyths content solutions private limited',
    'INVENTO LABS PRIVATE LIMITED',
    'Smart world city infrastructure private limited',
    'Nayantara holdings private limited',
    'Avs cargo management services private limited',
    'Radianz energy private limited',
    'Pranams corporate consulting private limited',
    'Fair beat herbals cosmetics private limited',
    'ALPHAPRIME ENGINEERING PRIVATE LIMITED',
    'Skmc business ventures private limited',
    'ORANGE RISE PRIVATE LIMITED',
    'Saradha consulting private limited (opc)',
    'Nonstop courier and cargo private limited',
    'Cares renewables private limited',
    'Mahila umang producers company limited',
    'Vinayak switchgear private limited',
    'Panelart decor private limited',
    'Frontend arts private limited',
    'Shivaasha niketan limited',
    'Omkar human resource private limited',
    'Greyflex hr consulting services private limited',
    'Ingwenya mineral operations private limited',
    'Odigotech solutions private limited',
    'Exl workplace management services private limited',
    'Carinae consultants private limited',
    'Irefr recruitment solutions private limited',
    'Horizon staffing solutions private limited',
    'Maxx security operations private limited',
    'Metroz detectives services private limited',
    'Shining star security services private limited',
    'Monitron security private limited',
    'Clear secured services private limited',
    'Mansi packaging pvt ltd',
    'Synergy packaging pvt ltd',
    'Network couriers private limited',
    'Zoomlion india private limited',
    'Brainovations education excellence private limited',
    'Dinu gems private limited',
    'Anubhav vacations private limited',
    'ADVANTUS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Arabian ocean drilling supplies & services private limited',
    'Inditech technology services private limited',
    'Astron systems private limited',
    'Relimed pharmaceuticals private limited',
    'Emgee integrated logistics private limited',
    'Sushe marine services private limited',
    'Kisan ramchandra auctioneers pvt ltd',
    'Conquest commercial co pvt ltd',
    'G.d. goenka global india private limited',
    'BROADWAY RECRUITERS AND CONSULTANTS PRIVATE LIMITED',
    'Thomas baker (biosciences) private limited',
    'PENANCE OVERSEAS PRIVATE LIMITED',
    'Screenline embellishers (india) private limited',
    'Development environergy services limited',
    'I f p petro products private limited',
    'K&m garmenguardini (india) private limited',
    'Sun commodity and derivative private limited',
    'Synergy telecom private limited',
    'Rihim pharma consultancy private limited',
    'Sai sayo sanitary private limited',
    'Rockstand digital private limited',
    'Rasta ventures private limited',
    'Hatchcube solutions private limited',
    'Klariant business solutions private limited',
    'Acme excellent management private limited',
    'S LIFELINE INSTITUTE OF MEDICAL SCIENCE & RESEARCH CENTRE PRIVATE LIMITED',
    'Britannia employees educational welfare association private limited',
    'Britannia employees general welfare association private limited',
    'Starone projects private limited',
    'Sanjeevan intensive care unit private limited',
    'Millennium health resorts (india) private limited',
    'Meditech speciality services private limited',
    'Suwarn path edutech ventures private limited',
    'Apollo nellore hospital limited',
    'Vasan dental hospitals private limited',
    'Open sky festival productions private limited',
    'Rajalakshmi universal education private limited',
    'Ebd educational private limited',
    'Aadrika commercial private limited',
    'Aadrika distributors private limited',
    'Dhanprayog tradecom private limited',
    'Kare4u healthcare solutions private limited',
    'Mind edutainment private limited',
    'Spml utilities limited',
    'NANDGOPALA ENTERPRISES PRIVATE LIMITED',
    'Urvesh psyllium industries limited',
    'The rajasthan small industries corporation ltd',
    'Britannia employees medical welfare association private limited',
    'Ambuja cement foundation',
    'Vsd eduventures private limited',
    'Erc eye care private limited',
    'Cancare foundation',
    'Priority health private limited',
    'CLUOTECH ENERGIES (INDIA) PRIVATE LIMITED',
    'Noble broadcasting corporation private limited',
    'Together events private limited',
    'Priyanka health care and allied products pvt ltd',
    'Mehfil hospitality limited',
    'Ccic india private limited',
    'Rudram market development services private limited',
    'Vijayshree heritage village private limited',
    'Millenium amusement park private limited',
    'Institute for global development',
    'Cindrebay institute of designs private limited',
    'Penguin education private limited',
    'Quick clean healthcare private limited',
    'Goyal auto products private limited',
    'Eurovision edusolutions private limited',
    'Eden career services private limited',
    'Auraa coordination and productions private limited',
    'Ido sport private limited',
    'Madhulata infotech private limited',
    'Purple thoughts india private limited',
    'A-mad productions private limited',
    'Trimurti films private limited',
    'Vistaar pictures limited',
    'Vistaar entertainment limited',
    'Evergreen cineservices private limited',
    'Mausam films limited',
    'Sulk services private limited',
    'Vistaar films limited',
    '99 degree fitness studios private limited',
    'Bams marine services private limited',
    'Indian refractory makers association',
    'Green fire hospital private limited',
    'TECHNOSYS INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'United india insurance company limited',
    'Apollo med skills limited',
    'Entec industrial fernaces private limited',
    'D.s. ductofab systems private limited',
    'Precision power products (india) private limited',
    'Opto instruments pvt ltd',
    'BASANT FIBERTEK PRIVATE LIMITED',
    'J and s wirelinks private limited',
    'Suncraft energy private limited',
    'Metascan electronics private limited',
    'Bhor engineering private limited',
    'Fireshield engineers (india) limited',
    'Acm cartridge rechargers private limited',
    'Litex electricals private limited',
    'Kaizen electric equipment private limited',
    'Tekstar global private limited',
    'Pelton power technologies private limited',
    'PROSE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Perto india private limited',
    'Amphenol interconnect india private limited',
    'Astral informatics private limited',
    'Tribhuwan electronics pvt. ltd.',
    'Gyro power systems and communications private limited',
    'Third wave systems pvt ltd',
    'Low loss products private limited',
    'ABHA POWER PROJECT PRIVATE LIMITED',
    'Godot entertainment and media private limited',
    'Piyano sound industries private limited',
    'Vasanthi electricals private limited',
    'LATERAL MGT. SERVICES PRIVATE LIMITED',
    'Suntrex engineering private limited',
    'Techmart systems company private limited',
    'SUBHAA HEALTHCARE PRIVATE LIMITED',
    'Divya control elements pvt ltd',
    'Caltherm thermostats private limited',
    'Accurate gauging and instruments pvt ltd',
    'BHANDER POWER LIMITED',
    'Oswal electricals private limited',
    'Marathon heater (india) private limited',
    'Precision auto components private limited',
    'Annapurna electronics and services private limited',
    'Haiku motors private limited',
    'Shreyans automobiles private limited',
    'Olympus motors private limited',
    'Rajarshi auto deals private limited',
    'Finotex fibrecast private limited',
    'Jcbl limited',
    'Marshall auto engg ltd',
    'Solo components private limited',
    'Aadhunik enercon private limited',
    'Napa autoforge private limited',
    'Se shoes private limited',
    'K.k.rao engineering works private limited',
    'Enginetech systems private limited',
    'Walia auto ancillaries private limited',
    'Ranvik autocomponents private limited',
    'Endura controls and automation private limited',
    'Deepak divya jyoti private limited',
    'Segen engineers private limited',
    'R.VIC TECHNOLOGY PRIVATE LIMITED',
    'Siddhi kabel corporation private limited',
    'Santacruz electronics export manufacturers association',
    'Opto marketing co pvt ltd',
    'Alpha maier private limited',
    'Sam autopro private limited',
    'Jayem auto industries private limited',
    'Alvi wood crafts private limited',
    'Deepakshi display devices private limited',
    'Agnoor electronics limited',
    'Futura apsol private limited',
    'Charankattu coir manufacturing co pvt ltd',
    'Delta furniture private limited',
    'Eagle roofings limited',
    'Prime mine-o-jewels pvt ltd',
    'Aspire automobiles private limited',
    'Karmath infotech private limited',
    'Suhag gems and jewels india private limited',
    'Elettromeccanica india private limited',
    'Vertel infotel private limited',
    'Elmex controls pvt ltd',
    'Vinayak jewels (india) private limited',
    'Kota jewellers private limited',
    'Surovi mansion jewellers private limited',
    'ANA JEWELLERS PRIVATE LIMITED',
    'Kraft outdoor media private limited',
    'Nandu pharma private limited',
    'Rabro sports india private limited',
    'Tib creations private limited',
    'M E X',
    'DESIR COSMETICS PRIVATE LIMITED',
    'Tee cee interiors private limited',
    'Suvidha forex private limited',
    'Nijji healthcare private limited',
    'Bad films private limited',
    'Orphius healthcare private limited',
    'Northeast holidays private limited',
    'Ronak optik india private limited',
    'Ecospace merchants private limited',
    'PANNALAL MAHABIR PRASAD EXIM PRIVATE LIMITED',
    'Rotary techskill (india) private limited',
    'Siddhartha das productions private limited',
    'Moser baer solar limited',
    'Srk aviacom (india) private limited',
    'Adbridge communications india private limited.',
    'NITARA PROJECTS LIMITED',
    'Teltroy tradings private limited',
    'Tricky business private limited',
    'Lakhdatar dealtrade private limited',
    'Dasbhuja dealtrade private limited',
    'White fox support services private limited',
    'Lawmax merchant services private limited',
    'MAJESTIC DOCKYARD PRIVATE LIMITED',
    'Narnix technolabs private limited',
    'Woodstick advisory private limited',
    'SAKTHI PELICAN INSURANCE BROKING PRIVATELIMITED',
    'Cash ur drive marketing private limited',
    'Religare finvest limited',
    'Rollform equipment private limited',
    'Unimax granites private limited',
    'Vishwkarma laminates private limited',
    'Scientimed solutions private limited',
    'S.M. PILFER PROOF CAPS Private Limited',
    'Shapoorji data processing private limited',
    'STANDARD CHARTERED FINANCE PRIVATE LIMITED',
    'Alchemie gases and chemicals pvt.ltd.',
    'I e media private limited',
    'Om techno-crat private limited',
    'Rekvina pharmaceuticals (india) private limited',
    'Joy skin care private limited',
    'Ishita steel traders private limited',
    'Ishu steel traders private limited',
    'Franco indian remedies private limited',
    'Lg polymers india private limited',
    'Wrg steel industries private limited',
    'Hari impex private limited',
    'Nisa pre engineered metal buildings private limited',
    'Lohman manufacturing private limited',
    'JINDAL ALUFOILS PRIVATE LIMITED',
    'Kcp mines private limited',
    'Sagar irrigation private limited',
    'Vrc plastomould (india) private limited',
    'JAI POLYPAN PRIVATE LIMITED',
    'Bhavika plas-tek private limited',
    'Bhilai iron foundry private limited',
    'Marshall foundry works private limited',
    'Maithan steel and power limited',
    'Prosperity steels limited',
    'Mookambika metal crafts private limited',
    'Sree rengaraj ispat industries private limited',
    'Mridu plastics private limited',
    'METALROD Private Limited',
    'Jain doors private limited',
    'Paramhans wires private limited',
    'Sba recycling private limited',
    'Sataksi polymers pvt ltd',
    'Saurabh strips private limited',
    'Synergy steels limited',
    'TARINI STEEL COMPANY Private Limited',
    'Kohinoor metals private limited',
    'Shree prithvi steel rolling mills private limited',
    'Elite steels pvt. ltd.',
    'Jaibros steel tubes private limited',
    'ESS N ESS AGENCIES PRIVATE LIMITED',
    'Saiom polymers private limited',
    'Mask rubber products private limited',
    'APEX PHENOLIC PRIVATE LIMITED',
    'Quick cut services pvt. ltd.',
    'B d j glass industries pvt ltd',
    'Platinum ceramic private limited',
    'M g t cements private limited',
    'Siporex india private limited',
    'G.g. polytubes private limited',
    'Bengal polymers pvt. ltd.',
    'JAGANNATH INDUSTRIES PRIVATE LIMITED',
    'Parshavanath metacast private limited',
    'Standard alloys (india) private limited',
    'Bathla aluminium private limited',
    'Aurora pure metal india private limited',
    'Vidhatri aluminium private limited',
    'BIUM INDUSTRIES PRIVATE LIMITED',
    'High quality steels ltd',
    'Surabhi steel rolling mills private limited',
    'R.v.steels and power private limited',
    'Thirani commodities private limited',
    'Turbo tools private limited',
    'Sairaj industries private limited',
    'Skyheights engineers private limited',
    'Mahodari iron private limited',
    'Vijay foundry and machine works pvt ltd',
    'MAHAVIR CASTINGS PRIVATE LIMITED',
    'CRYSTAL SLEEVES MFG PRIVATE LIMITED',
    'Rollwell forge private limited',
    'Fortune metaliks limited',
    'Saroj foundry private limited',
    'Vasitva ispat limited',
    'K.r.s.s. metals private limited',
    'Alok ferro alloys limited',
    'ASTRA METAL SYSTEMS PRIVATE LIMITED',
    'Dynaweld engineering company private limited',
    'Dunung industries private limited',
    'THE BRAITHWAITE BURN AND JESSOP CONSTRUCTION COMPANY LIMITED',
    'Alstrong acp manufacturing india private limited',
    'M.j.coaters private limited',
    'Oswal die casters pvt ltd',
    'Anchit engineering limited',
    'Alstrong enterprises india private limited',
    'Maharashtra forge pvt ltd',
    'Dyna-k-automotive stampings private limited',
    'Indo sap engineers private limited',
    'National refinery private limited',
    'Indradhanu coats private limited',
    'Helios syscom private limited',
    'Unique structures & towers limited',
    'Anheena engineering private limited',
    'Sidh tools limited',
    'Akal spring ltd',
    'Ambey vaishno steels private limited',
    'Hrushikesh water sciences private limited',
    'T and d galiakot containers private limited',
    'JALANI ENTERPRISES PRIVATE LIMITED',
    'Abacus metals private limited',
    'Vinayak international housewares private limited',
    'Maksteel wire healds pvt ltd',
    'Alcorp metals and tubes private limited',
    'Swastik vishaka steels private limited.',
    'Nidec india private limited',
    'P s p soilsearch equipment private limited',
    'Ahmed tannery private limited',
    'Sps securitron systems private limited.',
    'Great eastern machine house pvt ltd',
    'BHASKAR STEEL AND FERRO ALLOY PRIVATE LIMITED',
    'Enfield ispat limited',
    'Rkr graphite private limited',
    'Shree ram smelters private limited',
    'Jaypee (india) ltd',
    'Senken engineering india private limited',
    'Surprise sales private limited',
    'VINCCENT BIOTECH PRIVATE LIMITED',
    'Worlds window trading private limited',
    'Raj aryan export private limited',
    'Pioneer computronix private limited',
    'Magnifico minerals private limited',
    'Thomsen comfort products private limited',
    'Vyoneeshrosebank engineering private limited',
    'ROBOBULL TECHNOLOGIES PRIVATE LIMITED',
    'BLUE LION DISTRIBUTION PRIVATE LIMITED',
    'Sayaji iron works contracts private limited',
    'Bontek marketing private limited',
    'TULSUN RESOURCES LIMITED',
    'Bhavin impex private limited',
    'Masterstroke traders private limited',
    'Squarem electra private limited',
    'Clubside traders pvt. ltd.',
    'TRUWORTH IMPEX PVT LTD',
    'Av integration distribution (india) private limited',
    'Southern borewells private limited',
    'Antarctica trading company private limited',
    'Roshan housing projects pvt ltd',
    'Action drilling private limited',
    'Spark eighteen lifestyle private limited',
    'METAWIRE PRIVATE LIMITED',
    'Globalite retail private limited',
    'Fishfa world trade limited',
    'Stock traders private limited',
    'A k gandhi marketing private limited',
    'Osi steel private limited',
    'Himadri tieup pvt ltd',
    'K r traders pvt ltd',
    'Great eastern stores pvt ltd',
    'Bharat krishan pvt ltd',
    'Apeejay private limited',
    'Abdos trading co pvt ltd',
    'Malay commercial enterprises ltd',
    'Amrit business pvt ltd',
    'Rhino industrial equipments private limited',
    'Madgul services pvt ltd',
    'Macemem exim pvt. ltd.',
    'B b rubbers pvt ltd',
    'Specturm vanijya pvt ltd',
    'Ohm value services limited',
    'Sampurn impex pvt ltd',
    'Rimjhim dealcom private limited',
    'INDOSPIRIT MARKETING PRIVATE LIMITED',
    'A h shah and co pvt ltd',
    'THE MAITRI METALS PRIVATE LIMITED',
    'ELECTRO FORCE (INDIA) LIMITED',
    'Bst exports private limited',
    'Ipcca sales agency pvt ltd',
    'Carnex barter pvt.ltd.',
    'Cosy dealcom & services pvt.ltd.',
    'Watertech engineers pvt. ltd.',
    'Pushpak suppliers pvt ltd',
    'Needs (india) private limited',
    'Kashmiri lal tarun khanna pvt ltd',
    'Hindon Metaforms Private Limited',
    'M d bio coals private limited',
    'Kamrup distributors private limited',
    'W & F COMMERCIAL PRIVATE LIMITED',
    'Peshwa exports (pune) private limited',
    'Aquiline infomedia private limited',
    'Amber technopark infrastructure private limited',
    'Pioneer khaitan trading private limited',
    'Helix impex private limited',
    'Namona exports private limited',
    'R s trims point private limited',
    'Glow crafts private limited',
    'ETRELUXE INDIA PRIVATE LIMITED',
    'Basiks sterilisation concepts private limited',
    'Mahesh distributors private limited',
    'NINESTEPS (INDIA) PRIVATE LIMITED',
    'Vision telecommunications india private limited',
    'Bdi india private limited',
    'Stylo commotrade pvt ltd',
    'Brijdham vyapaar pvt ltd',
    'Viewpoint agency private limited',
    'Churiwal commercial company pvt ltd',
    'Aaryaman infra private limited',
    'Speedwell vyapaar pvt. ltd.',
    'Grapco trading pvt ltd',
    'Horizon tie-up private limited.',
    'Allied commosale private limited',
    'Dayanidhi distributors private limited',
    'Accept suppliers private limited',
    'Apoorva tradelink private limited',
    'Larceny mercantiles pvt. ltd.',
    'Haridra commercial private limited',
    'BVK INFRASOFT SERVICES PRIVATE LIMITED',
    'Monisa trading pvt ltd',
    'Labh vinimay pvt.ltd.',
    'Booster merchandise private limited',
    'Everlink commercial private limited',
    'Linkpoint sales private limited',
    'Seaview merchants private limited',
    'Starpoint tie-up private limited',
    'Biostar sales private limited',
    'Adarsh commodeal private limited',
    'Shivshakti distributors private limited',
    'Gkd india limited',
    'Janjivan trading pvt ltd',
    'Billenium commercial private limited',
    'Splended suppliers private limited',
    'Meghna overseas private limited',
    'Emerald vinimay private limited',
    'Dinbandhu commerce private limited',
    'Ninja chip studios private limited',
    'Wirefoot (india) technology private limited',
    'Flickon international private limited',
    'Vs geospatial technologies private limited',
    'Vectrae infotech private limited',
    'Shri shantinath bhagwan software private limited',
    'Sternsystem solutions private limited',
    'Maruti technology limited',
    'Kodari games private limited',
    'Isiri technologies private limited',
    'Akarsh business consulting private limited',
    'Chizrinz infoway private limited',
    'Kenpro technologies private limited',
    'Spa software pvt ltd',
    'Bewo technologies private limited',
    'Ascenso telecom solutions private limited',
    'Xybion india private limited',
    'SRI MOOKAMBIKA INFOSOLUTIONS PRIVATE LIMITED',
    'Mark software systems private limited',
    'Hrm technologies private limited',
    'Mahavir systems and controls private limited',
    'World fashion exchange (india) private limited',
    'SIRIUS GLOBAL LIMITED',
    'H a solutions (india) private limited',
    'Spring infomatics private limited',
    'Magnum technology solutions private limited.',
    'Elentec technologies private limited',
    'Jaishila infotech private limited',
    'INFOCON SYSTEMS (INDIA) PRIVATE LIMITED',
    'J.d.softech private limited',
    'ENGINEER.AI INDIA PRIVATE LIMITED',
    'E-SMART SYSTEMS LIMITED',
    'Orbit informatics private limited',
    'Centrum media tech private limited',
    'Maco it services private limited',
    'ASHMAR TECHNOLOGIES & RESEARCH PRIVATE LIMITED.',
    'Saffron tech private limited',
    'MAGNOX LABS PRIVATE LIMITED (OPC)',
    'Vaahini software private limited',
    'Srm learning tree private limited',
    'Airavath technologies private limited',
    'Element94 media solutions private limited',
    'Success info solutions private limited',
    '50 HERTZ LIMITED',
    'Md infosystems private limited',
    'Talent unlimited online services private limited',
    'Unikwan innovations private limited',
    'Silicon comnet private limited',
    'Xiphos technology solutions private limited',
    'M & e design combine private limited',
    'DRONA INFOTECH IT SERVICES PRIVATE LIMITED',
    'Narvar india private limited',
    'Imentors technologies private limited',
    'ATLAN TECHNOLOGIES PRIVATE LIMITED',
    'Elegant business solutions private limited',
    'Teamarcs technologies private limited',
    'Iceconfluence solutions private limited',
    'Elysium technologies private limited',
    'Purpleteal technologies india private limited',
    'Vikilinks software and web solutions private limited',
    'Mayur technosoft private limited',
    'Vtaurus technologies private limited',
    'Acap solutions india private limited',
    'Hire indians infotech private limited',
    'CODIFY APPS PRIVATE LIMITED',
    'Majestic it services limited',
    'Membrane creative consultancy private limited',
    'Terrestrial software private limited',
    'Zyan technologies private limited',
    'Os3 infotech private limited',
    'One business consulting group private limited',
    'Krest solutions private limited',
    'Unfoldu online solutions private limited',
    'Ec infosolutions private limited',
    'Alchemist softwares private limited',
    'Padma infocom private limited',
    'Tech savvy engineers private limited',
    'Censhare india private limited',
    'Dynamis mentors private limited',
    'Ap2v solutions private limited',
    'Roundabout technologies private limited',
    'Dice infocom private limited',
    'Avizare analytical and technology solutions private limited',
    'Odyssey computer services pvt. ltd.',
    'TALKESPORT MEDIA AND BROADCASTING PRIVATE LIMITED',
    'Itsl limited',
    'NET AVENUE TECHNOLOGIES LIMITED',
    'FRIENDSLEARN PRIVATE LIMITED',
    'SIRAHU TECHNOLOGIES PRIVATE LIMITED',
    'Virtualmaze softsys private limited',
    'Sawalka technical services private limited',
    'Experis it private limited',
    'Aforeserve. com limited',
    'Qualitas ae services private limited',
    'Dynavision technologies private limited',
    'Unique links private limited',
    'Ms computech private limited',
    'METADESIGN TECHNOLOGIES PRIVATE LIMITED',
    'Netbios technologies private limited',
    'St infosolutions private limited',
    'I s e education media (india) private limited',
    'Ace infotexis private limited',
    'Mouthshut . com (india) private limited',
    'Vma software solutions (india) private limited',
    'CYMPL STUDIOS PRIVATE LIMITED',
    'COGENT E-SERVICES LIMITED',
    'Platinum stones private limited',
    'Vriksh advisors private limited',
    'Menon pistons limited',
    'Lakshmi precision screws limited',
    'Denim developers limited',
    'Rajesh exports limited',
    'Vaibhav global limited',
    'ANSAL HOUSING LIMITED',
    'Bihani rajasthan company limited',
    'Tinna rubber and infrastructure limited',
    'Mkj enterprises ltd',
    'Jay ushin limited',
    'The federal bank ltd',
    'LIBRA CONSTRUCTIONS & FINANCE PRIVATE LIMITED',
    'Varistha leasing international limited',
    'Pasupati fincap limited',
    'Comfort intech limited',
    'Alpine commercial co ltd.',
    'Innovassynth investments limited',
    'AXISCADES TECHNOLOGIES LIMITED',
    'Eider technologies limited',
    'Trigyn technologies limited',
    'La multi info systems limited',
    'Megasoft limited',
    'Hind industries limited',
    'Titan company limited',
    'Pekon electronics ltd',
    'Kama holdings limited',
    'Jcbl india private limited',
    'Libra high seas merchants pvt ltd',
    'Netaxcess communications limited',
    'Three sixty life style private limited',
    'Bajrang bali transport company private limited',
    'Mahamaya agrotech private limited',
    'Bapu agriculture private limited',
    'Navin nurseries pvt ltd',
    'Crystal agro private limited',
    'Technico agri sciences limited',
    'GOYAL GRAMIN VIKAS SANSTHAN',
    'Rajasthan orgofarm private limited',
    'Marwar food industries private limited',
    'Parry agro industries limited',
    'Havukal tea and produce company private limited',
    'Tuttapullam tea and produce company private limited',
    'Aryan tea plantation private limited',
    'The manjri stud farm private limited',
    'Baramati cattlefeeds pvt ltd',
    'The equus stud pvt ltd',
    'BHAIRAVNATH HITECH AGRO PRIVATE LIMITED',
    'Laxmi irrigation pumps pvt ltd',
    'Alibaug horticulture private limited',
    'Siddarth hi-tech agro private limited',
    'Farm fresh india agro tech private limited',
    'Parul farms pvt. ltd.',
    'Tas agro private limited',
    'Supreme equipments private limited',
    'Unique trees private limited',
    'Flanders greenfield private limited',
    'Assam agrotech private limited',
    'Cms overseas pvt ltd',
    'Palakkad coconut producer company limited',
    'SAI COCOPEAT EXPORT PRIVATE LIMITED',
    'Indian designs exports private limited',
    'Holy land agroforestry private limited',
    'Drumella plantations private limited',
    'Pariyath estates private limited',
    'OCILIM ADVISORY SERVICES PRIVATE LIMITED',
    'Raunak agro product private limited',
    'Apani saheli producer company limited',
    'Sahyadri agriculture producer company limited',
    'Yamuna farms private limited',
    'Uma horticulture private limited',
    'Newton farms private limited',
    'P. duraisamy maharajha rice mills private limited',
    'Golden valley plantations pvt ltd',
    'VIKAS ROAD CARRIERS LIMITED',
    'Gnc fabrics private limited',
    'ALLMAC INFRATECH PRIVATE LIMITED',
    'Universal mine developers and service providers private limited',
    'Coalsale company limited',
    'Arpejay oils private limited',
    'B. G. SHIRKE REDEVELOPMENT AND GAS PRIVATE LIMITED',
    'Jay nikki industries limited',
    'Devi farms p ltd',
    'Cauvery mining company private limited',
    'Vienna it solutions private limited',
    'Kihim horticulture private limited',
    'Singdeep estate developers private limited',
    'Newage horticulture private limited',
    'Natural stoneage private limited',
    'Sakshi innovations private limited',
    'J & k mineral development corporation limited.',
    'Malpro silica private limited',
    'Kumar agro products private limited',
    'Suroop fresh private limited',
    'Kalash seeds private limited',
    'Novagreen horticulture private limited',
    'Pallawi trading and manufacturing co ltd',
    'Amrit hatcheries private limited',
    'Kuldev mining company private limited',
    'Plg agrotech limited',
    'Odisha forest development corporation limited',
    'Nortex realty limited',
    'Cu-v-kar genetic medicine private limited',
    'Sandhya aqua exports private limited',
    'Jaybee foods private limited',
    'Adf foods (india) limited',
    'Agarsen rerollers pvt ltd',
    'Bagavathi machine works private limited',
    'Integrated tooling systems private limited',
    'Park town realty private limited',
    'RPS SUNCITY PROMOTERS & DEVELOPERS PRIVATE LIMITED',
    'Summerfields infra private limited',
    'Sri balaji green heights private limited',
    'ANKUR BUILDCON LIMITED',
    'Amb constructions private limited',
    'Advance buildcon private limited.',
    'OMAXE HERITAGE PRIVATE LIMITED',
    'BANDHU BUILDTECH PRIVATE LIMITED',
    'Arman builders private limited',
    'Arjit builders private limited',
    'R. s. infrapromoters private limited',
    'Arcop design and construction systems private limited',
    'PARKASH OMAXE AMUSEMENT PARK PRIVATE LIMITED',
    'Subodh buildwell private limited',
    'Shamba developers private limited',
    'Aneesh buildtech private limited',
    'Meghmala builders private limited',
    'Radhika buildwell private limited',
    'Ekansh buildtech private limited',
    'Abhas realcon private limited',
    'Atria brindavan power private limited',
    'SHRI SIDHIVINAYAK INFRATECH PRIVATE LIMITED',
    'Jyoti sarup mittal infratech private limited',
    'Hlk infrastructure private limited',
    'Imperial golf properties private limited',
    'S & t infrabuild private limited',
    'Om shanti wind farms private limited',
    'Mascot electrical services private limited',
    'Hasmukh furniture private limited',
    'Gmr pochanpalli expressways limited.',
    'AYATANA HOSPITALITIES PRIVATE LIMITED',
    'Nagree private limited',
    'Track enterprises india private limited',
    'Zealtech projects private limited',
    'Polymarble manufacturing company private limited',
    'Neon shelter private limited',
    'Niketan shelter private limited',
    'Sterling ornaments private limited',
    'Subhash jewels (india) private limited',
    'Zaveri and company jewellers private limited',
    'Sheesh mahal developers limited',
    'C h jewellers private limited',
    'Alps remedies private limited',
    'I&PCL VACUUM CAST LIMITED',
    'Supermax metal private limited',
    'Naranlala private limited',
    'Jindaljyoti prefab private limited',
    'Bhaskar metal finishing equipments private limited',
    'Bhoruka extrusions private limited',
    'Anandmayee forgings (p)ltd',
    'Sai green metafin coating technology private limited',
    'Ssj metal equipments private limited',
    'Jrew engineering limited',
    'MIVEN AUTOMATION TECHNOLOGIES PRIVATE LIMITED',
    'Navnidh techpro private limited',
    'Technos prazise engineering private limited',
    'J p fabricators and engineers private limited',
    'Supreme sintered products pvt ltd',
    'Parksons engineering co. private limited',
    'UTSAV ELECTRICAL PRIVATE LIMITED',
    'Shapes products private limited',
    'Acme automation private limited',
    'Lakeland village private limited',
    'MAA RUKMANI DEVI AUTO Private Limited',
    'Bharaj auto private limited',
    'ALPSPURE NUTRACEUTICALS PRIVATE LIMITED',
    'Dharam stainless steel private limited',
    'SYAMA DYNAMIC ENGINEERING PRIVATE LIMITED',
    'Devyu ventures private limited',
    'Tecna weldcon india private limited',
    'Niksan industries private limited',
    'Nucon pneumatics private limited',
    'Wim india private limited',
    'Technomax engineering private limited',
    'Mamc industries limited',
    'Ab techno private limited',
    'Rotex automation limited',
    'ARAN MANUFACTURING & EXPORTS PRIVATE LIMITED',
    'Shree jayambe minechem private limited',
    'Krupa tech private limited',
    'Elcen machines private limited',
    'Qcd engineering india private limited',
    'Regent hitech private limited',
    'Bajaj processpack limited',
    'Lubricare engineering and services private limited',
    'Niksan pumps india private limited',
    'Pentagon industries private limited',
    'F.m.t.engineers private limited',
    'Natural products export corporation ltd.',
    'Deevee fire & security solutions (india) pvt ltd',
    'Jaycee castalloys private limited',
    'Sagar machine tools pvt ltd',
    'Shree ram electronics (india) pvt ltd',
    'APEX METCHEM PRIVATE LIMITED',
    'New vision imaging private limited',
    'Eastern logica infoway limited',
    'Rhythmsoft robotics and automations private limited',
    'Rajdeep energies private limited',
    'CSH POWER HIMOINSA PRIVATE LIMITED',
    'Rotomotive powerdrives india limited',
    'Ghatge patil industries limited',
    'Mehala castings and components private limited',
    'Brake parts india private limited',
    'G.m wire and ropes private limited',
    'DYNAMIC CABLES LIMITED',
    'Nissan commodities pvt ltd',
    'Ashoka switchgear private limited',
    'Jagatjit engineering works pvt ltd',
    'Aastha autotech private limited',
    'Bhagwan sons engineers private limited',
    'Kuvawala core drill eqpt private limited',
    'Bubber industries private limited',
    'Fortuna engineering private limited',
    'Spectra energy systems private limited',
    'Vividh hi-fab private limited',
    'SHARDA INFRASOLUTIONS PRIVATE LIMITED',
    'Russelz greenpower limited',
    'Unisert machines (india) private limited',
    'Delseal india private limited',
    'Varun electrodes private limited',
    'Hydrotech paryavaran india private limited',
    'C&s electric limited',
    'Corep lighting india private limited',
    'Elmex electricals and electronics pvt ltd',
    'Krohne marshall pvt ltd',
    'TALBROS INDIPARTS PRIVATE LIMITED',
    'Divine metals and profiles private limited',
    'Preltex solutions private limited',
    'Pdr videotronics (india) private limited',
    'Stmicroelectronics private limited',
    'TECHNO INDUSTRIES PRIVATE LIMITED',
    'Textel technologies private limited',
    'Nouveau systematix ti private limited',
    'Supertron electronics private limited',
    'Mirc electro trade private limited',
    'Groovy machines limited',
    'Gaurava electronics pvt ltd',
    'Ratan plantations limited',
    'B.a.g business ventures limited',
    'Wellmet (calcutta) pvt.ltd.',
    'AUTOMARK INDUSTRIES (INDIA) PRIVATE LIMITED',
    'Fil sep equipments private limited',
    'Dhaval engineering works private limited',
    'Jieco quality testing services pvt ltd',
    'Indo scientific & surgicals private limited',
    'Regency guest house pvt ltd',
    'Bengal investments limited',
    'Patton finvest limited',
    'India mortgage guarantee corporation private limited',
    'Shashwat holdings private limited',
    'Kalpataru housefin & trading pvt ltd',
    'Kutub properties private limited',
    'ALIPORE CONDOMINIUMS & INVESTMENTS PVT LTD',
    'North eastern development finance corporation limited',
    'Rishipal investments and finance private limited',
    'Pace fincap private limited',
    'SHIVTARA GRAIN MILLING PRIVATE LIMITED',
    'R n d travel solutions private limited',
    'Mps systems private limited',
    'A t o (i) ltd',
    'Speed cargo movers pvt ltd',
    'Pennon shipping pvt ltd',
    'Tarsan mvas private limited',
    'Adobe marketing private limited',
    'Airstate express and logistics private limited',
    'Ridhi sidhi financial services pvt.ltd.',
    'Intell invofin india private limited',
    'Chiraj stock and securities private limited trs from w.b',
    'Ambience financial services private limited',
    'ZUARI INTERNATIONAL LIMITED',
    'Money factor financial services private limited',
    'Mathrani securities private limited',
    'Rausheena telecom private limited',
    'Linde engineering india private limited',
    'Capital ltd',
    'Vidarshana finance & investments pvt ltd',
    'Rtm investment & trading co. ltd.',
    'Shikhar holdings pvt ltd',
    'Kunal finance & credit pvt ltd',
    'Alps viniyog pvt ltd',
    'Vishwas fincap services private limited',
    'Manglam apparels private limited',
    'Deep capital management private limited',
    'Shakti fincap private limited',
    'Eastern financiers ltd',
    'Edge telecommunications private limited',
    'Bibby financial services (india) private limited',
    'SAVE HOUSING FINANCE LIMITED',
    'Dynamic financial management services private limited',
    'Actuate enhance investment consultants private limited',
    'Garden city residences finance limited',
    'Gujarat state seeds corpn ltd',
    'Pripan investment private limited',
    'Rahulvir mercantile private limited',
    'Kirtej investments pvt ltd',
    'Just trade securities limited',
    'VKMG ENTERPRISES PRIVATE LIMITED',
    'Galaxy capital services limited',
    'Chaitali investment pvt. ltd',
    'Day star trading private limited',
    'EVAM FINANCE PRIVATE LIMITED',
    'PIVOTAL ENTERPRISES PRIVATE LIMITED',
    'PBS MERCANTILE PRIVATE LIMITED',
    'Solumiks herbaceuticals limited',
    'Sharvik general finance company pvt. ltd',
    'HEM SHARE BROKERS PRIVATE LIMITED',
    'Muthoot pappachan chits (india) private limited',
    'Radiant equity management private limited',
    'Sri ramadas motor transport ltd.',
    'B m gandhi securities private limited',
    'Aum commodity services private limited',
    'Mideast securities private limited',
    'Par excellence securities private limited',
    'Magenta real estate private limited',
    'Ats housing private limited',
    'Assertive infrastructure private limited',
    'Steel city securities limited',
    'Bspl india pvt ltd',
    'SHYAMPREM ESTATE PRIVATE LIMITED',
    'United hibuildtech private limited',
    'Proximity real estates private limited',
    'Rarities investments private limited',
    'Asb investments pvt ltd',
    'Net brokeres private limited',
    'Darshana stock broking private limited',
    'Intergrow holdings private limited',
    'Magma estates private limited',
    'Zoom estates private limited',
    'Abhavi investments private limited',
    'Vineera colonisers private limited',
    'Multitone investrade private limited',
    'NOBLE BUSINESS SOLUTIONS LIMITED',
    'SHREE ENERGY DEVELOPEWELL PRIVATE LIMITED',
    'Exotica housing private limited',
    'Exotica housing & infrastructure projects private limited',
    'Amber credit company ltd',
    'Yashovardhan investment & trading company limited',
    'Elite landbase private limited',
    'Ratnakar sales promotion pvt. ltd.',
    'Mandarin buildwell private limited',
    'Did infratech private limited',
    'Nobility estates private limited',
    'Amba vijaya private limited',
    'Opus propbuild private limited',
    'Satya developers private limited',
    'Shree navkar inframart private limited',
    'Comt constructions private limited',
    'Kanchanaburi properties and real estates development private limited',
    'Brisk infrastructure and developers private limited',
    'Tapasaya farms private limited',
    'Calsens pvt ltd',
    'Arcus estates private limited',
    'EVOS BUILDCON PRIVATE LIMITED',
    'Krishna build projects private limited',
    'Trident infrarealty india private limited',
    'Calcutta international club',
    'Approach films and television limited',
    'Sambhav learning private limited',
    'VYDEHI SUPER SPECIALITY HOSPITAL LIMITED',
    'Arka healthcare private limited',
    'SPARSH HOSPITALS & CRITICAL CARE PRIVATE LIMITED',
    'Udaipur health care private limited',
    'Abyss management consultancy private limited',
    'Careesma india private limited',
    'Unique homecare services private limited',
    'Technopak skills foundation',
    'Om human resource agency private limited',
    'Rajnish hospital private limited',
    'Raahat health care private limited',
    'Kamineni hospitals private ltd.',
    'Kgvk social enterprises limited',
    'Apa services private limited',
    'Lifewood advisory private limited',
    'Tasker virtual assistance services private limited',
    'Parvati garden owners welfare association',
    'Tamil nadu medical services corporation limited',
    'Park hospitals',
    'Abhiejeet construction and services private limited',
    'Rcdc securities and investments private limited',
    'Steadfast healthcare private limited',
    'Kalathil resorts private limited',
    'THE MAYO PRIVATE LIMITED',
    'Universal empire educational & health care services',
    'Wavecare foundation',
    'Uranus electro technik private limited',
    'Southern alkalies and marine products private limited',
    'Gogate electrosystems (nasik) private limited',
    'Kangaro industries limited',
    'Gorav investment private limited',
    'EASTERN INDUSTRIAL WORKS & SERVICES LIMITED',
    'THE COCHIN PLANTATIONS LTD',
    'The chamong tea co ltd',
    'Vedanta Limited',
    'Agro tech foods limited',
    'Adf foods limited',
    'SHARMAN WOOLLEN MILLS PRIVATE LIMITED',
    'Rajshree exports ltd',
    'Sil investments limited',
    'NATH INDUSTRIES LIMITED',
    'Prateek coke limited',
    'Panama petrochem limited',
    'Kanoria chemicals & industries ltd',
    'Shiva global agro industries limited',
    'Asian paints limited',
    'Emami frank ross limited',
    'Naga limited',
    'Nyle aqua systems private limited',
    'Asewater technologies private limited',
    'Next generation content delivery network private limited',
    'Parijat entertainment private limited',
    'Suraj industries ltd',
    'Oswal industries limited',
    'Kumar autocast limited',
    'Cosmo ferrites limited',
    'Kamper concast limited',
    'Hilton metal forging limited',
    'BF INDUSTRIAL TECHNOLOGY & SOLUTIONS LIMITED',
    'Mazda limited',
    'NATIONAL ENGINEERING INDUSTRIES LIMITED',
    'Lokesh machines ltd',
    'Simmonds marshall limited',
    'Shilchar technologies limited',
    'Diamond power infrastructure limited',
    'Panasonic energy india company limited',
    'Bajaj electricals limited',
    'Munjal auto industries limited',
    'Ravindra energy limited',
    'BF UTILITIES LIMITED',
    'Brandman media private limited',
    'Absolute entertainment private limited',
    'Electro polychem limited',
    'Sethia jain & co ltd',
    'Bally jute company ltd',
    'India convention and culture center private limited',
    'Norr architects and engineers private limited',
    'Nuage advisors private limited',
    'Cts express logistics private limited',
    'Macnur infrastructure private limited',
    'Indian capital corporation ltd',
    'Sreeleathers limited',
    'Lee & nee softwares (exports) ltd',
    'SUPRA PACIFIC FINANCIAL SERVICES LIMITED',
    'Relaxo footwears limited',
    'Rubal agro enterprises limited',
    'Prestige agro-tech limited',
    'Sai capital limited',
    'Tata elxsi limited',
    'Larsen and toubro limited',
    'Innocorp limited',
    'Saluja motors private limited',
    'J.d. electrical engineering services private limited',
    'Tirupati laundry private limited',
    'Kunchals stores private limited',
    'Socomec india private limited',
    'Macnur enterprises private limited',
    'Core careers private limited',
    'Nandkishor real estates private limited tfr. from mumbai to delhi',
    'Jain facility management private limited',
    'Sanskar agro processors private limited',
    'H hero agro industries private limited',
    'Vinyoflex limited',
    'LERTHAI FINANCE LIMITED',
    'Suchirindia biotech private limited',
    'P.k.m. projects private limited',
    'Exotica housing & infrastructure company private limited',
    'Aman buildwell private limited',
    'Aman buildtech private limited',
    'A s proptech private limited',
    'Marble arch infrastructure private limited',
    'Vinayak infratech private limited',
    'Shells engineering private limited',
    'A.k. tower private limited',
    'ANERI CONSTRUCTION PRIVATE LIMITED',
    'Micromega infrastructures private limited',
    'Madhav heights private limited',
    'Modern archiinfrastructure private limited',
    'Sarvatra infrastructure private limited',
    'Sugam buildcon private limited',
    'Gop infra private limited',
    'Karnataka state police housing and infrastructure development corporation limited',
    'Eon commercial complex private limited',
    'Markup builders and developers limited',
    'Gold beam construction private limited',
    'Vera avenues private limited',
    'HI-TECH KUTIRA & PROMOTERS PRIVATE LIMITED',
    'MASTER PROJECTS PRIVATE LTD',
    'Tachyon infraventures private limited',
    'Baleshwar properties private limited',
    'Corporate professionals infrastructure private limited',
    'Rachna complex private limited',
    'Nb buildcon private limited',
    'Padam buildwell private limited',
    'Royal realmart private limited',
    'Excellence engineering private limited',
    'Ansal kgk developer private limited',
    'SOGANI REAL ESTATE PRIVATE LIMITED',
    'Avadh infrastructure private limited',
    'Little world constructions private limited',
    'Luke builders private limited',
    'R.e. constructions private limited',
    'Oasis engineering pvt ltd',
    'Russell properties pvt ltd',
    'Hi-tech edifice private limited',
    'Hi-tech multiplex private limited',
    'Jaypee developers private limited',
    'Aurum estates private limited',
    'Varsha enclaves private limited',
    'Arch high rise private limited',
    'Admac pharma limited',
    'Popular infraprojects private limited',
    'Vision india colonizers private limited',
    'Malhotra bhavan property private limited',
    'Jetley properties and promoters private limited',
    'Pooja buildcon private limited',
    'Classic buildtech private limited',
    'Siddha griha nirman pvt.ltd.',
    'Sm engineers india limited',
    'Rajat buildtech private limited',
    'Omaxe infrastructure limited',
    'Kia infrastructures development limited',
    'GARDENVIEW ABODE PRIVATE LIMITED',
    'Ashoka-dsc katni bypass road limited',
    'Rukmini properties pvt ltd',
    'Radix properties private limited',
    'Happy kutir private limited',
    'Gomtesh realtors private limited',
    'Insolare energy private limited',
    'Meghavaram power private limited',
    'V s apartments private limited',
    'Ashoka industrial park private limited',
    'ALFA MAXWORTH PRIVATE LIMITED',
    'Trimurti buildhome private limited',
    'Sbp buildcon private limited',
    'K m residency private limited',
    'Real revolution infrastructure private limited',
    'Glaze engicon private limited',
    'Fateh buildtech private limited',
    'Micro infrastructure india private limited',
    'Shreshta apartments private limited',
    'Choudhary infrabuild private limited',
    'S s infratech solutions private limited',
    'Ultra technobuild private limited',
    'Prabal developers private limited',
    'Puru builders private limited',
    'Greatbrothers infra projects private limited',
    'Kap india projects and constructions private limited',
    'Ace structures private limited',
    'Balesh technobuild private limited',
    'Icon developwell private limited',
    'Victor profperties (p) ltd',
    'Anand rural housing infrastructure development private limited',
    'Almond infrabuild private limited',
    'Gopika projects pvt ltd',
    'Miglani construction private limited',
    'Hi-tech build tech private limited',
    'Fujitsu india private limited',
    'Goldmine homes private limited',
    'Kohinoor buildcon private limited',
    'Valley view landholdings private limited',
    'Vtc projects private limited',
    'Triban construction pvt. ltd.',
    'Upakrama infrastructure private limited',
    'Pegasus infra estates private limited',
    'Propel properties private limited',
    'Colossal projects private limited',
    'Kapsons realtech private limited',
    'Shinu properties private limited',
    'Technocrats projects private limited',
    'Citystar towers private limited',
    'Nightangle promoters private limited',
    'Vishveshwar infrastructure private limited',
    'Gul properties private limited',
    'Simplex housing projects private limited',
    'Jagannath infraproperties private limited',
    'Mahabali realty intelligence private limited',
    'S.s. alliance comfort solutions private limited',
    'Spectra computech private limited',
    'BIJLI REALTY PRIVATE LIMITED',
    'Lets engineering and technology services private limited',
    'ANANYA COMPUTER & BUILDCAP PRIVATE LIMITED',
    'Roselife projects private limited',
    'Times realty and negotiators limited',
    'Olympia cairnhill developement private limited',
    'Diwansons real estate private limited',
    'Birdres technologies private limited',
    'Syven technologies private limited.',
    'Diwansons properties private limited',
    'Free look software private limited',
    'SRK D.D.D PRIVATE LIMITED',
    'DEVON SOFTWARE SERVICES PRIVATE LIMITED',
    'Brain technosys private limited.',
    'Dataflow services (india) private limited',
    'Starlit technologies private limited',
    'Damco advanced solutions private limited',
    'Pimpri chinchwad eservices limited',
    'Vital wires consulting private limited',
    'New tech conclave private limited',
    'Panchshree enclave private limited',
    'Viewmore complex private limited',
    'Ksm niketan private limited',
    'S cube storage systems private limited',
    'Influence technolabs private limited',
    'Plm logix private limited',
    'Maheshwaram projects private limited',
    'Aradhya buildcon private limited',
    'Dynamic success projects private limited',
    'Phi business solutions limited',
    'Om education (it) private limited',
    'Janaula info networks private limited',
    'Abhivyakti infotech private limited',
    'Sd softech india private limited',
    'Trident realtech private limited',
    'Srb estates private limited',
    'Infotrellis india private limited',
    'Onezone facilities private limited',
    'Indo-spanish chamber of technology private limited',
    'One india technologies private limited',
    'Wizni software private limited',
    'Hcl infotech limited',
    'Writerbabu online services private limited',
    'Madhav technologies private limited',
    'Techpassion technologies private limited',
    'LEADING EDGE NETWORK & PRODUCTS PRIVATE LIMITED',
    '3r recycler private limited',
    'Elxire it services private limited',
    'Experia media private limited',
    'Thoughtsarena solutions private limited',
    'Bc web wise private limited',
    'Games2win india private limited',
    'Futuretek machines private limited',
    'Pcyantra computer solutions private limited',
    'PHOTON AI PRIVATE LIMITED',
    'Plm infotech private limited',
    'Buena logica technologies private limited',
    'Megatrend systems private limited',
    'The brand weavers private limited',
    'Infoobjects software ( india) private limited',
    'Sigint soft private limited',
    'Sarv webs private limited',
    'Swift solutions private limited',
    'Nhance engineering solutions private limited',
    'Grmi technology and services private limited',
    'Winnou systems and services private limited',
    'Consummate technologies private limited',
    'Ipsr solutions limited',
    'Gemtech solutions private limited',
    'Cns it solutions private limited',
    'Knexus software development centre private limited',
    'Techzag solutions private limited',
    'Tathya software private limited',
    'Truecopy credentials private limited',
    'Ga software technologies private limited',
    'Dynamic digital technology pvt ltd',
    'Control desk solutions private limited',
    'Kernel solutions private limited',
    'Triple a solutions private limited',
    '17routes it services private limited',
    'Agreeta solutions private limited',
    'ST INFOSYS PRIVATE LIMITED',
    'Lapenton technologies private limited',
    'Three d integrated solutions limited',
    'Gapblue software labs private limited',
    'Indiawali com private limited',
    'CORPORATE PROFESSIONALS (INDIA) PRIVATE LIMITED',
    'Kg infosystem private limited',
    'Sapphire computech private limited',
    'Xicom technologies limited',
    'Gtech web marketing private limited',
    'Xavient infotech private limited',
    'Jt solutions private limited',
    'Dynamicnext technologies private limited',
    'Sathya technosoft india private limited',
    'Swaraj software and tech solutions private limited',
    'Mspark solutions private limited',
    'Konnect systems private limited',
    'Pinnacle kpo solutions private limited',
    'PTS CONSULTING SERVICES PRIVATE LIMITED',
    'Turnkey infotel (india) private limited',
    'Adone technologies private limited',
    '6th sense infrastructurre private limited',
    'Kwick soft solutions private limited',
    'Smi traders and distributors private limited',
    'Saraswati sugar mills limited',
    'Pyramid farms private limited',
    'Nanu resorts private limited',
    'Jindal nandanavana kendra private limited',
    'Shri ram farming pvt ltd',
    'Golden vegpro private limited',
    'Blue city agro private limited',
    'Ranjita agencies private limited',
    'Bemolapur tea co pvt ltd',
    'Thakarshi tea processors and packers private limited',
    'M k shah exports ltd',
    'Nyasylee tea estate private limited',
    'Sylee tea estate private limited',
    'Zantye and company private limited',
    'Maharashtra state seeds corporation limited',
    'Hindusthan distilleries (karnataka) private limited',
    'Madurai soft drinks private limited',
    'BHAGWATI AGRO PRODUCTS PRIVATE LIMITED',
    'Suman tea & plywood industries pvt ltd',
    'Svarna horticulture limited',
    'Fal power ventures private limited',
    'Esvee express logistics private limited',
    'Edulink private limited',
    'Radhikapur (west) coal mining private limited',
    'Indian coal merchants association',
    'Hanuman coal mines pvt ltd',
    'Mining associates private limited',
    'V-CON INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'Icc chemtec private limited',
    'Sopan o and m company private limited',
    'Numaligarh refinery ltd',
    'AMNS PORTS HAZIRA LIMITED',
    'Viral founders pvt ltd',
    'Kanha granites private limited',
    'Nutech garnetts private limited',
    'Lihansh technocom laser private limited',
    'Shree mintech private limited',
    'Gimpex ap barytes beneficiation private limited',
    'Lucky minmat ltd',
    'The international mineral industries limited',
    'Sourcewell flours private limited',
    'Nature-tech foods private limited',
    'Sahuwala grains private limited',
    'Amrit fresh private limited',
    'Amar agarwal foods (india) private limited',
    'MIDA & COMPANY PRIVATE LIMITED',
    'Arihant solvex private limited',
    'Manoharamma dairy products private limited',
    'H.i. dairy & agro products limited',
    'Manekraj minerals private limited',
    'Padiyath dairy private limited',
    'Tirupati balaji foods private limited',
    'Vinod rice mill private limited',
    'Shree biswanath rice mills pvt ltd',
    'Gopesh foods private limited',
    'Sarnam mining exports private limited',
    'Hi-tech gypsum private limited',
    'Anu quarries private limited',
    'Maharaja stones private limited',
    'Sachchade food private limited',
    'KALAYATAN TECH LIMITED',
    'Supple tek industries private limited',
    'Toshan foods private limited',
    'Savitri foods private limited',
    'B n healthcare private limited',
    'Sunshine marbles (india) private limited',
    'Milestone minerals private limited',
    'Camellia processors pvt ltd',
    'Ginni tea industries limited',
    'Saisha commodities private limited',
    'Indo riv clinical private limited',
    'Edrington kyndal india private limited',
    'M k agrotech private limited',
    'FARM FRESH ICECREAMS PVT.LTD.',
    'Foundation for organic agriculture and rural development',
    'N p s cold storage private limited',
    'B k threshers private limited',
    'Creative dyeing and printing mills private limited',
    'Vijay synthetics private limited',
    'Dwarkadas jhamandas textile industries private limited',
    'Sunlite india agro producer company limited',
    'All colour garments private limited',
    'Valli yarn processors private limited',
    'Krithiga spinning mills private limited',
    'RAJANARAYAN TEXTILES PRIVATE LIMITED',
    'Boutique holdings private limited',
    'Avaneetha textiles private limited',
    'JIWANRAM SHEODUTTRAI INDUSTRIES LIMITED',
    'Jayram textiles private limited',
    'Chemico synthetics ltd',
    'Kalyani tea co ltd',
    'Cloudlands estates private limited',
    'Sunita textiles limited',
    'Talayar tea company limited',
    'ENCASA HOMES PRIVATE LIMITED',
    'Sai gensets private limited',
    'Dhiman foods pvt ltd',
    'Zabatex textiles india private limited',
    'Star mint fields private limited',
    'Mi spirits india private limited',
    'Maksi agro cool chains private limited',
    'Monsun foods private limited',
    'Angel starch & food private limited',
    'Arunodya feeds private limited',
    'NUTRIX INDIA PRIVATE LIMITED',
    'COUTURE SWEETS & DESIGNS PRIVATE LIMITED',
    'NATURASIA INGREDIENTS PRIVATE LIMITED',
    'M r poly-yarns private limited',
    'Arul migu sivaskti spinning mills private limited',
    'Istuti realcon private limited',
    'Dwarka homes private limited',
    'Metropark infratech and realty developments private limited',
    'Model industrial park amritsar',
    'Crossland engineering and infrastructure private limited',
    'Shilpkar superstructures and infra private limited',
    'S.s.r.infra -projects private limited',
    'Vijaywargi infra engineers private limited',
    'Adar chemicals pvt ltd',
    'Times construction pvt ltd',
    'Technomax building solution india private limited',
    'Tulshan realtors private limited',
    'Akj engineers private limited',
    'Specturm complex private limited',
    'Oasis buildmart (india) private limited',
    'Lodhi enclave private limited',
    'Earth apex infra projects private limited',
    'Swarnaratna infrastructure private limited',
    'Morris construction private limited',
    'Oxford heights private limited',
    'PAHARPUR 3P PRIVATE LIMITED',
    'Great eastern energy corporation limited',
    'Northward motors private limited',
    'Srs tractors private limited',
    'Elegant cars private limited',
    'Dpc motors private limited',
    'MANIKANDAN MOTOR PRIVATE LIMITED',
    'Kinetic hyundai elevator and movement technologies limited',
    'Swapna motors private limited',
    'Talera motors private limited',
    'Sunyata properties private limited',
    'Eureka properties private limited',
    'Nitesh automobiles private limited',
    'Hospitalia eastern private limited',
    'Annira properties private limited',
    'Ayush builders pvt. ltd.',
    'Vismaya developers private limited',
    'Neev contractors private limited',
    'Delta vehicle support private limited',
    'Empire buildtech private limited',
    'Hastinapur infratech private limited',
    'OASIS PROJECTS LIMITED',
    'Avr ss construction private limited',
    'Babian trades private limited',
    'S.J.K. DEVELOPERS & BUILDERS PRIVATE LIMITED',
    'Mahavir logistics private limited',
    'Stuti vinimay private limited',
    'Arch apartments private limited',
    'Citystar infraprojects limited',
    'CAMKARL INDUSTRIES PRIVATE LIMITED',
    'Deepaangan land developers private limited',
    'Unique group realty private limited',
    'AZAD COACH BUILDERS PRIVATE LIMITED',
    'Lm autocars private limited',
    'Ride automobiles private limited',
    'Paul & company steel merchants private limited',
    'Associated brokers pvt ltd',
    'Noddy motors pvt.ltd.',
    'Asb auto engineering private limited',
    'Popular auto spares pvt ltd',
    'Bongaigaon concrete industries private limited',
    'Eminence townships (india) private limited',
    'Mawiya overseas private limited',
    'BORA HOUSING PRIVATE LIMITED',
    'Celebrity builders private limited',
    'Imagine dealcom private limited',
    'Mortal sales private limited',
    'Unity tradecomm private limited',
    'Superlite distributors private limited',
    'Axon trading and manufacturing co ltd',
    'Sarvamanngal distributors pvt ltd',
    'EPITECH INTERNET PRIVATE LIMITED',
    'Silvertoss dealtrade private limited',
    'Extent suppliers private limited',
    'Masterlook tracon pvt ltd',
    'Accent overseas private limited',
    'Atash suppliers pvt. ltd.',
    'Priyamvada finvest pvt ltd',
    'Anand tracom pvt ltd',
    'Trenchless engineering services private limited.',
    'Dada motors private limited',
    'Noble protective systems pvt ltd',
    'Flamingo farms private limited',
    'United villages networks private limited',
    'Aeon airconditioning private limited',
    'Mangesh construction pvt ltd',
    'Buttepatil developers private limited',
    'Hotel paraag limited',
    'Matribhumi dealers pvt ltd',
    'Shivganga commodeal pvt ltd',
    'Wales tradecom pvt ltd',
    'Devsar vyapaar pvt ltd',
    'Haraparbati commercial pvt ltd',
    'Godbalaji tradelink pvt ltd',
    'Satyam vanijya pvt ltd',
    'Orbit tie- up private limited',
    'Twenty one century studio facility private limited',
    'Lama vinimay pvt ltd',
    'Sadabahar suppliers private limited',
    'Butterfly vyapaar private limited',
    'Redrose tie-up private limited',
    'Dinram holdings private limited',
    'Aparna distributors pvt ltd',
    'Alkmai trading private limited',
    'Pawansut marketing pvt ltd',
    'Shivling impex private limited',
    'Whiteline barter limited',
    'Well plan tradelink private limited',
    'N S N HEALTH CARE PRIVATE LIMITED',
    'Pacific tie-up private limited',
    'Diamond flanges and fittings private limited',
    'Adinath vincom private limited',
    'Stacs technologies private limited',
    'SAMRIDHI TAX ADVISORS PRIVATE LIMITED',
    'Bnk infotech private limited',
    'Inde burst networks private limited',
    'Balaji highrise pvt ltd',
    'South city garden property management private limited',
    'Sur sangam electromedia private limited',
    'Operant communications systems private limited',
    'Technousa consulting services private limited',
    'M k info systems private limited',
    'Junction tv india private limited',
    'Ind innovations private limited',
    'Epb it services private limited',
    'KEIMED PRIVATE LIMITED',
    'Noybl infotech private limited',
    'Kamla worldwide private limited',
    'Taxtools infotech private limited',
    'Jpac technologies private limited',
    'VIJAY SAINI & ASSOCIATES PRIVATE LIMITED',
    'Analytical technologies limited',
    'Maruti 3pl private limited',
    'ETRADE MARKETING PRIVATE LIMITED',
    'Wavenet solutions private limited',
    'Appzcloud technologies private limited',
    'Nikulsan technologies private limited',
    'Uv technologies private limited',
    'Raxon technologies private limited',
    'Flights guru infotech services private limited',
    'Virtual software and training private limited',
    'Premier it solutions india private limited',
    'Improvement interactive india private limited',
    'Webcommerce india private limited',
    'Devlease technologies private limited',
    'Maverick solution & consultancy private limited',
    'Arouba technologies private limited',
    'Baabte system technologies private limited',
    'S g planet model com private limited',
    'Hunch software private limited',
    'Mayanks it solutions private limited',
    'S k v infotech private limited',
    'Satya infrabuilders private limited',
    'Waviz technologies private limited',
    'One e info private limited',
    'Smh solutions india private limited',
    'Jst infotech private limited',
    'Ace brain systems and software private limited',
    'Nathan ark software private limited',
    'BLUE RAMP MANAGEMENT PRIVATE LIMITED',
    'Gayatri infotech private limited',
    'Tetraskelion softwares private limited',
    'Sushil and manish software technologies private limited',
    'Phoenix advanced softwares private limited',
    'Logicpace technologies private limited',
    'Santech technosoft private limited',
    'Gayatri software services private limited',
    'Informatic computech private limited',
    'BINARY INFOSOLUTIONS PRIVATE LIMITED',
    'Razorpay software private limited',
    'MICROCARE COMPUTERS PRIVATE LIMITED',
    'Moonstone info tech private limited',
    'Gyansys infotech private limited',
    'Prime racks private limited',
    'Addsoft technologies private limited',
    'Evos solutions private limited',
    'AUTORABIT SOFTWARE PRIVATE LIMITED',
    'Zifo technologies private limited.',
    'BULIMOS TECHNOLOGIES PRIVATE LIMITED',
    'Palnar transmedia private limited',
    'B cast media private limited',
    'Finaxys consultancy services private limited',
    'Orbit animate pvt ltd',
    'Azure end to end solutions private limited',
    'Coffye innovations private limited',
    'Naba diganto ites private limited',
    'Xigmapro software private limited',
    'Visionaire technologies india private limited',
    'Ishi csl info systems private limited',
    'VALUEONSHORE ADVISORY SERVICES PRIVATE LIMITED',
    'SOFUELED MEDIA PRIVATE LIMITED',
    'Gps multi solution private limited',
    'Exciera technologies private limited',
    'Wiztelsys server technologies private limited',
    'Thoughtripples technologies private limited',
    'Infinity management services (india) pvt ltd',
    'Zacks research private limited',
    'Pge info solutions private limited',
    'Capp systems (india) private limited',
    'Cts technologies private limited',
    'Diagonal software private limited',
    'Bas engineering private limited',
    '3p technologies india private limited',
    '6simplex software solutions private limited',
    'Ingage technologies private limited',
    'Capricorn computers private limited',
    'Pyramid cyberway limited',
    'KREDENT INFOEDGE PRIVATE LIMITED',
    'Urban web edge private limited',
    'Citi solutions private limited',
    '5Y BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Stp web hosting private limited',
    'Coitor it tech private limited',
    'Soulstice software solutions private limited',
    'PSYCHERA SERVICES PRIVATE LIMITED',
    'RENFOS TECHNOLOGIES PRIVATE LIMITED',
    'JEHOVASOFT PRIVATE LIMITED',
    'VERIFWORKS PRIVATE LIMITED',
    'STONEMOBILE INDIA PRIVATE LIMITED',
    'STATIONERY ISLAND PRIVATE LIMITED',
    'MICROSCALE TECHNOLOGY PRIVATE LIMITED',
    'MARGO NETWORKS PRIVATE LIMITED',
    'AN BAZAAR PRIVATE LIMITED',
    'JOSH EDUCON FOUNDATION',
    'TENORY TECHNOLOGIES PRIVATE LIMITED',
    'VAAG GLOBAL APPARELS PRIVATE LIMITED',
    'FLEEK IT SOLUTIONS PRIVATE LIMITED',
    'SMACTARA TECHNOLOGIES PRIVATE LIMITED',
    'SAILORS WELFARE ASSOCIATION',
    'ORYX CLOUD INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'RND NIRMAN PRIVATE LIMITED',
    'SUCCOUR SKILLS PRIVATE LIMITED',
    'GIP TECHNOLOGIES PRIVATE LIMITED',
    'SYNEGRA EMS LIMITED',
    'INDIA POST PAYMENTS BANK LIMITED',
    'PROFESSIONAL TPA HEALTHCARE SERVICES PRIVATE LIMITED',
    'SONIYA BUSINESS GUIDE PRIVATE LIMITED',
    'JOSH EDUSOLUTIONS FOUNDATION',
    'PREMIER ENERGIES PHOTOVOLTAIC PRIVATE LIMITED',
    'UNICUM INDIA PRIVATE LIMITED',
    'SKILLZPOT GLOBAL PRIVATE LIMITED',
    'DAVO FOODS PRIVATE LIMITED',
    'CATALYST ASSET RECONSTRUCTION PRIVATE LIMITED',
    'TURBAN STUDIOZ PRIVATE LIMITED',
    'MINERVA INTEGRATED LOGISTICS PRIVATE LIMITED',
    'DIGISOL SYSTEMS LIMITED',
    'TUBEKRAFT PRECISION PRIVATE LIMITED',
    'CHENNAI ELASTOMER AND PLASTICS PRIVATE LIMITED',
    'AARNA SYSTEMS AND WELLNESS PRIVATE LIMITED',
    'MATKRAFT BUILDING SOLUTIONS PRIVATE LIMITED',
    'AINDRA LABS PRIVATE LIMITED',
    'NETNCR TECHNOLOGY PRIVATE LIMITED',
    'DEFTEC INDIA TECHNICAL COMMUNICATIONS PRIVATE LIMITED',
    'SUMHITHA POLYFABRICS PRIVATE LIMITED',
    'SREENIKETANA LOGISTICS LIMITED',
    'OREMUS DATA SERVICES PRIVATE LIMITED',
    'TRANSMED COMMUNICATIONS PRIVATE LIMITED',
    'RIJUVEN MEDICARE INDIA PRIVATE LIMITED',
    'HODEK VENTURES PRIVATE LIMITED',
    'GLOBAL BROADCASTING SOLUTIONS (OPC) PRIVATE LIMITED',
    'AIRTIMES CONTENT SOLUTIONS (OPC) PRIVATELIMITED',
    'PIXEL3I PRIVATE LIMITED',
    'SNOW PLANET SERVICES PRIVATE LIMITED',
    'WHYTE AUTOMATIONS PRIVATE LIMITED',
    'KIRI TUBULAR SERVICES (INDIA) PRIVATE LIMITED',
    'EVIROCOR PACKAGING INDIA PRIVATE LIMITED',
    'TECHINVENTION LIFECARE PRIVATE LIMITED',
    'AEQUS FOUNDATION',
    'SOLUTION POINT AUTOMATION PRIVATE LIMITED',
    'MINDS CREATIVE SOLUTIONS PRIVATE LIMITED',
    'CREDITLEARN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AMSYS INFOCOM PRIVATE LIMITED',
    'COSTBO SERVICES PRIVATE LIMITED',
    '5E INVESTMENT ADVISORS PRIVATE LIMITED',
    'TEJTEL TELECOM PRIVATE LIMITED',
    'NUGA INDIA ENTERPRISES PRIVATE LIMITED',
    'DAPS INFRA PRIVATE LIMITED',
    'MAHAYOGI ORGANIC PRODUCTS (INDIA) PRIVATE LIMITED',
    'FLUID TOUCH PRIVATE LIMITED',
    'ABS AVIATION PRIVATE LIMITED',
    'QUICKEN SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'NNM FILMS PRIVATE LIMITED',
    'SFK ENGINEERING PRIVATE LIMITED',
    'INVENIRE ENERGY PRIVATE LIMITED',
    'ENLIVE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'FLEECA INDIA PRIVATE LIMITED',
    'FIVE TECHNOLOGIES PRIVATE LIMITED',
    'SPASHTA TECHNOLOGIES PRIVATE LIMITED',
    'DOIT RESORT (GOA) PRIVATE LIMITED',
    'TROICA PIGMENTS PRIVATE LIMITED',
    'GO2CLOUD SOLUTIONS PRIVATE LIMITED',
    'NETIFI PRIVATE LIMITED',
    'ANIKA BUSINESS SERVICES PRIVATE LIMITED',
    'TIRUMALLA GROUNDNUTS INDUSTRIES INDIA PRIVATE LIMITED',
    'KNACKHOOK IT SERVICES PRIVATE LIMITED',
    'ALTIN HEALTH CARE PRIVATE LIMITED',
    'ALFA KITCHEN EQUIPMENTS PRIVATE LIMITED',
    'ANANTA KRRIYAA CREATIVE HUB PRIVATE LIMITED',
    'EGO MEDIA PRIVATE LIMITED',
    'ANYEMI ONLINE SERVICES PRIVATE LIMITED',
    'NKARS ONLINE PRIVATE LIMITED',
    'NATURO INDIABULL LIMITED',
    'KARTLA SOLUTIONS PRIVATE LIMITED',
    'ADITREE NATURALS PRIVATE LIMITED',
    'ESKAY GLOBAL LOGISTICS PRIVATE LIMITED',
    'SAATHI ECO INNOVATIONS INDIA PRIVATE LIMITED',
    'CELESPHERE TECHNOLOGIES PRIVATE LIMITED',
    'KOIPL SERVICES PRIVATE LIMITED',
    'AMOLIKA COMMERCE PRIVATE LIMITED',
    'SKYWAY TRANS SOLUTIONS PRIVATE LIMITED',
    'COFFEE DYNAMICS PRIVATE LIMITED',
    'SAMEX INDIA PRIVATE LIMITED',
    'WRENCHITUP FACILITY MANAGEMENT PRIVATE LIMITED',
    'WECARE FOODS AND BEVERAGES PRIVATE LIMITED',
    'ECOVALLEY SILICONES PRIVATE LIMITED',
    'IMAGINE MULTI SERVICES PRIVATE LIMITED',
    'ANURITHRA CLOTHING PRIVATE LIMITED',
    'ADROITSTREAM SOLUTIONS PRIVATE LIMITED',
    'BLUESWIFT EXPORTS PRIVATE LIMITED',
    'MACKLY LIFE SCIENCE PRIVATE LIMITED',
    'PAYSCOUT INDIA PRIVATE LIMITED',
    'VASUPRADA SERVICES (OPC) PRIVATE LIMITED',
    'KOUSHIKA ENTERPRISES PRIVATE LIMITED',
    'ENTERPRISEBOT SOLUTIONS PRIVATE LIMITED',
    'PEARLITE REAL PROPERTIES PRIVATE LIMITED',
    'RELIANCE SERVICES AND HOLDINGS LIMITED',
    'SUNDAE CAPITAL ADVISORS PRIVATE LIMITED',
    'UNITEDLAYER (INDIA) PRIVATE LIMITED',
    'WELCOME RETAIL PRIVATE LIMITED',
    'INTER SMART TECHNOLOGIES PRIVATE LIMITED',
    'DARLING HOMES INDIA (OPC) PRIVATE LIMITED',
    'AUGRAY PRIVATE LIMITED',
    'JEWELXY MARKETPLACE PRIVATE LIMITED',
    'SAMODAGAM LEARNING PRIVATE LIMITED',
    'MAVENTUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'REHACART ONLINE PRIVATE LIMITED',
    'GEOALGO TECHNOLOGIES PRIVATE LIMITED',
    'V2K HOSPITALITY PRIVATE LIMITED',
    'ATLANTIS PERFORMANCE MATERIALS INDIA PRIVATE LIMITED',
    'STEPHANIE ODEGARD HANDMADE ENVIRONMENTS PRIVATE LIMITED',
    'VECTOR GLOBAL LINES PRIVATE LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (AHMEDABAD) LIMITED',
    'HIOKI INDIA PRIVATE LIMITED',
    'PRIDE OF LIONS HOSPITALITY PRIVATE LIMITED',
    'FF BIOWORKS (INDIA) PRIVATE LIMITED',
    'BACT INDUSTRIES PRIVATE LIMITED',
    'UP MEHRAUNI - I URJA PRIVATE LIMITED',
    'A&A CORPCON PRIVATE LIMITED',
    'BDK INTERNATIONAL PRIVATE LIMITED',
    'KRBS AGRO VENTURE PRIVATE LIMITED',
    'BLUELINE E-SOLUTIONS PRIVATE LIMITED',
    'SKYTEX UNMANNED AERIAL SOLUTIONS PRIVATE LIMITED',
    'RAGHU VAMSI SIRI AEROSPACE PRIVATE LIMITED',
    'IORBIT DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'ISPROUT BUSINESS CENTRE PRIVATE LIMITED',
    'ALEKHYA HOMES BUILDING SYSTEMS PRIVATE LIMITED',
    'VETMAYA HEALTHCARE PRIVATE LIMITED',
    'SPRINGHOUSE COWORKING PRIVATE LIMITED',
    'CAPONGA BPO PRIVATE LIMITED',
    'DIGITALES INDIA MEDIA SOLUTIONS PRIVATE LIMITED',
    'BBG GLOBAL SOLUTIONS PRIVATE LIMITED',
    'GEMSCAP GLOBAL ANALYST PRIVATE LIMITED',
    'JAIYANT TECHNOLOGIES PRIVATE LIMITED',
    'ORIGO MARKETS PRIVATE LIMITED',
    'GBT TECH SOLUTIONS PRIVATE LIMITED',
    'FESPRO FOODS PRIVATE LIMITED',
    'GDIGITAL MEDIA SOLUTIONS INDIA PRIVATE LIMITED',
    'CENTRE FOR TALENT TEST FOUNDATION',
    'WILLSFLY TECHNOLOGIES PRIVATE LIMITED',
    'CHACKRA MILK FARM PRIVATE LIMITED',
    'OVEARTH PRIVATE LIMITED',
    'GUPTA INFOSOLUTIONS PRIVATE LIMITED',
    'VERSURA SHIKSHA SERVICE PRIVATE LIMITED',
    'SOMDATT LANDMARK GOLF CLUBS & RESORTS PRIVATE LIMITED',
    'EFICAA ENSMART SOLUTIONS PRIVATE LIMITED',
    'MART BUILDERS PRIVATE LIMITED',
    '24X7 CONNECT INDIA PRIVATE LIMITED',
    'VEDITUM INDIA FOUNDATION',
    'FIELDMI TECHNOLOGIES PRIVATE LIMITED',
    'IDYLLIC SERVICES PRIVATE LIMITED',
    'ARODEK TECHNOLOGY CONSULTING PRIVATE LIMITED',
    'MALL BULDTECH PRIVATE LIMITED',
    '3STRYPS SOLUTIONS PRIVATE LIMITED',
    'SAVIOUR EDUCATION ABROAD (OPC) PRIVATE LIMITED',
    'ONGIL PRIVATE LIMITED',
    'ADITI OUTSOURCING SOLUTIONS PRIVATE LIMITED',
    'ADVIK TECNOCOMMERCIAL PRIVATE LIMITED',
    'ELIFEDOCTOR SERVICES PRIVATE LIMITED',
    'EPL EDUTECH PRIVATE LIMITED',
    'GPS CONNECTIONS PRIVATE LIMITED',
    'REALESTATE DEKHO PRIVATE LIMITED',
    'TGSS PRIVATE LIMITED',
    'SELLNSHIP SOLUTIONS PRIVATE LIMITED',
    'THROWBILL SYSTEMS PRIVATE LIMITED',
    'UDAYASHM OUTSOURCING PRIVATE LIMITED',
    'CASA GRANDE AXIOM PRIVATE LIMITED',
    'GFEE PERFORMANCE SOLUTIONS PRIVATE LIMITED',
    'SADGURU SRI SRI AGRO FARMERS PRODUCER COMPANY LIMITED',
    'RIGITEC PRIVATE LIMITED',
    'DR. D.Y.PATIL ACADEMIC EXCELLENCE PRIVATE LIMITED (OPC)',
    'CLAY CONSULTING SERVICES INDIA PRIVATE LIMITED',
    'MEDIWERT HEALTHCARE PRIVATE LIMITED',
    'SIMMEERA INDIA PRIVATE LIMITED',
    'MITTAL CONFIN ADVISORY SERVICES PRIVATE LIMITED',
    'FIN RISE SOFTECH PRIVATE LIMITED',
    'IDEASFACTORY VENTURES PRIVATE LIMITED',
    'BYCERO SOLUTIONS PRIVATE LIMITED',
    'TRASHIN RECYCLING PRIVATE LIMITED',
    'MAXVY TECHNOLOGIES PRIVATE LIMITED',
    'CHEMICAL SHOPPE PRIVATE LIMITED',
    'AXITA EXPORTS PRIVATE LIMITED',
    'INFIMONK CONSULTANCY PRIVATE LIMITED',
    'OMNIWYSE TECHNOLOGIES PRIVATE LIMITED',
    'SHIKSHANTAR LEARNING FOUNDATION',
    'LAKSSHYA TRANSLINK LOGISTICS PRIVATE LIMITED',
    'ITV ANIMATION STUDIOS PRIVATE LIMITED',
    'QUICKFORMAT SERVICES PRIVATE LIMITED',
    'KAP GLOBAL FORWARDERS PRIVATE LIMITED',
    'OXYZO FINANCIAL SERVICES PRIVATE LIMITED',
    'TSMT TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'BLU-9 ASSOCIATES PRIVATE LIMITED',
    'PROTEINGAINZ PRIVATE LIMITED',
    'CAST TECH PRIVATE LIMITED',
    'CYBASE TECHNOLOGIES PRIVATE LIMITED',
    'SKYBROWSER PRIVATE LIMITED',
    'KAAMKHOJ DATA CREATORS PRIVATE LIMITED',
    'DOVETAIL CAPITAL PRIVATE LIMITED',
    'VEDANTAA LEISURE HOLIDAYS INDIA PRIVATE LIMITED',
    'QBOX RETAIL VENTURES PRIVATE LIMITED',
    'MELON TELECOM INDIA PRIVATE LIMITED',
    'QUNU LABS PRIVATE LIMITED',
    'EXPONENTIAL DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PSA COUNSELLING SERVICES PRIVATE LIMITED',
    'JOIN NATURALS PRIVATE LIMITED',
    'EKAKSHA CONSTRUCTION PRIVATE LIMITED',
    'ARCHIVE HOUSE PRIVATE LIMITED',
    'MICRO GENOMICS INDIA PRIVATE LIMITED',
    'REFFCO AH PRIVATE LIMITED',
    'AVRP FOUNDATION',
    'HI FASHIONS INDUSTRIES PRIVATE LIMITED',
    'SIGNANT HEALTH PRIVATE LIMITED',
    'FINNOVATE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'AKAY FASTENERS PRIVATE LIMITED',
    'THINGTRONICS INNOVATIONS PRIVATE LIMITED',
    'FOUNDATION FOR DISEASE ELIMINATION AND CONTROL OF INDIA',
    'OPERA WIND PRIVATE LIMITED',
    'SKILLFINITY TECHNOLOGIES PRIVATE LIMITED',
    'WATERTIGHT DEVELOPERS PRIVATE LIMITED',
    'PROPTENSION INDIA PRIVATE LIMITED',
    'BSRI SOLUTIONS PRIVATE LIMITED',
    'CROWDSOURCE GLOBAL PRIVATE LIMITED',
    'POLYMATH BPO SERVICES PRIVATE LIMITED',
    'ARYAVEER MOTORS PRIVATE LIMITED',
    'MGM HEALTHCARE PRIVATE LIMITED',
    'TREK BICYCLE INDIA PRIVATE LIMITED',
    'YELLOW AND GRAY STUDIO PRIVATE LIMITED',
    'NAVISHA PROPERTIES PRIVATE LIMITED',
    'YOUNGBRAINZ INFOTECH PRIVATE LIMITED',
    'AVISERV AIRPORT SERVICES INDIA PRIVATE LIMITED',
    'DESK NINE PRIVATE LIMITED',
    'GR PHAGWARA EXPRESSWAY LIMITED',
    'EALEARN SOLUTIONS PRIVATE LIMITED',
    'WEISMACHER ECO PRIVATE LIMITED',
    'DAILY BARGAIN HOLIDAYS PRIVATE LIMITED',
    'VITRIC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DISCOVER ENTREPRENEURSHIP PRIVATE LIMITED',
    'MAGNIFIQUE DECOR PRIVATE LIMITED',
    'MARS AVENTIS LIFE CARE PRIVATE LIMITED',
    'MARIGAN TRADING PRIVATE LIMITED',
    'TRUMED LIFESCIENCE SOLUTIONS PRIVATE LIMITED',
    'AVTIX HEALTH (INDIA) PRIVATE LIMITED',
    'SYZYGY INNOVATIONS (OPC) PRIVATE LIMITED',
    'MILLMAN (INDIA) PRIVATE LIMITED',
    'VASANT COSTRUCTIONS PRIVATE LIMITED',
    'BARKING DEER HOSPITALITY PRIVATE LIMITED',
    'SHREE NAMAN RESORT GOA PRIVATE LIMITED',
    'MAGICBOWL HOSPITALITY PRIVATE LIMITED',
    'WILD CHEF PRIVATE LIMITED',
    'CLASS WORLDWIDE PRIVATE LIMITED',
    'ARUN EXCELLO COMPACT HOMES PRIVATE LIMITED',
    'DECENT SHIPPING PRIVATE LIMITED',
    'KONY LOGISTICS PRIVATE LIMITED',
    'EMPEZAR GLOBAL MARINE SERVICES PRIVATE LIMITED',
    'EVERGY ENGINEERING INDIA PRIVATE LIMITED',
    'ANTEF TECHNOLOGIES PRIVATE LIMITED',
    'WHITE CANVAS GROOMING AND BEAUTY PRODUCTS PRIVATE LIMITED',
    'OFFBEAT VACATIONS PRIVATE LIMITED',
    'DUBIZZLE TRAVEL AND TOURISM (OPC) PRIVATE LIMITED',
    'LOGISTICS KART (INDIA) PRIVATE LIMITED',
    'ODISHA HOLIDAYS PRIVATE LIMITED',
    'GMR GOA INTERNATIONAL AIRPORT LIMITED',
    'FARES DADDY PRIVATE LIMITED',
    'SOHAL HOLIDAYS PRIVATE LIMITED',
    'CUREFIT SERVICES PRIVATE LIMITED',
    'MITIL POLYMER PRIVATE LIMITED',
    'MEDIANT SYSTEMS PRIVATE LIMITED',
    'FLOOHOO TRAVEL SERVICES INDIA PRIVATE LIMITED',
    'YO SMART TRAVELS PRIVATE LIMITED',
    'JET LOGISTIX (OPC) PRIVATE LIMITED',
    'RIFAAH TRADERS PRIVATE LIMITED',
    'AGRIPLEX PRIVATE LIMITED',
    'YATTYA TECHNOLOGIES PRIVATE LIMITED',
    'GHANSHYAM HOLIDAYS PRIVATE LIMITED',
    'MYTRAVEL JUNCTION INDIA PRIVATE LIMITED',
    'DOUBLE TWO INDIA PRIVATE LIMITED',
    'TRIJAL ENTERPRISE PRIVATE LIMITED',
    'WILD PLANET PRIVATE LIMITED',
    'FOUR STALLION REFRESHMENT PRIVATE LIMITED',
    'MARTAND BHAIRAV PRIVATE LIMITED',
    'INTERASIA SHIPPING LINES INDIA PRIVATE LIMITED',
    'MELODRAMA MOVIES PRIVATE LIMITED',
    'MEDDEY TECHNOLOGIES PRIVATE LIMITED',
    'BRIGHTSPARK LEISURE SERVICES PRIVATE LIMITED',
    'SHOP4SPECIALS PRIVATE LIMITED',
    'DRIVEZY INDIA TRAVELS PRIVATE LIMITED',
    'HERODOTUS CONSUMER LIMITED',
    'VEEYEM DISTRIBUTORS PRIVATE LIMITED',
    'MAHESH EMERGING FINANCE PRIVATE LIMITED',
    'AVANTI MICROFINANCE PRIVATE LIMITED',
    'TRUST SECURITIES SERVICES PRIVATE LIMITED',
    'TOONSKART RETAIL PRIVATE LIMITED',
    'PERIHELION GENERAL FINANCE PRIVATE LIMITED',
    'AUXILO FINSERVE PRIVATE LIMITED',
    'BND WEALTH MANAGEMENT PRIVATE LIMITED',
    'DMI CONSUMER CREDIT PRIVATE LIMITED',
    'ITI MUTUAL FUND TRUSTEE PRIVATE LIMITED',
    'AML FINANCIAL SERVICES PRIVATE LIMITED',
    'PRIME PLUS INSURANCE MARKETING PRIVATE LIMITED',
    'COVERMITRA INSURANCE BROKING PRIVATE LIMITED',
    'ANNA PROPERTIES AND DEVELOPERS PRIVATE LIMITED',
    'RAPIDELO LOGISTICS PRIVATE LIMITED',
    'MANKUTIMMA STUDIOS PRIVATE LIMITED',
    'KAMACHI CAR RENTAL PRIVATE LIMITED',
    'VOYAGES OVERLAND PRIVATE LIMITED',
    'WEALTHAGE INSURANCE MARKETING PRIVATE LIMITED',
    'FRITTA INDIA PRIVATE LIMITED',
    'EASTBOUND JOURNEYZ PRIVATE LIMITED',
    'ARCHON BUILDTECH PRIVATE LIMITED',
    'YEXPLORE PRIVATE LIMITED',
    'VIGOROUS INDUSTRIES PRIVATE LIMITED',
    'BAROTA FINANCE LIMITED',
    'ART INSURANCE VENTURES (INDIA) PRIVATE LIMITED',
    'ECO-CONNECT VENTURES PRIVATE LIMITED',
    'RAMSREE CHARI REALTY SERVICES PRIVATE LIMITED',
    'HASTAMALAKA PROPERTIES PRIVATE LIMITED',
    'RADHA RAMAN DEV VENTURES PRIVATE LIMITED',
    'TROTAKACHARYA PROPERTIES PRIVATE LIMITED',
    'WHISPERING HEIGHTS REAL ESTATE PRIVATE LIMITED',
    'LOTUS TELE INFRA PRIVATE LIMITED',
    'VALENTE LIFESPACE CREATORS PRIVATE LIMITED',
    'NET-ON BROADBAND SERVICES PRIVATE LIMITED',
    'SAKSHAM TELECOM PRIVATE LIMITED',
    'DEVYA PROPCON PRIVATE LIMITED',
    'SUPERTECH ORB PROJECT PRIVATE LIMITED',
    'AFFORDABLE INDIA HOUSING FINANCE LIMITED',
    'EDEN FINVEST PRIVATE LIMITED',
    'DAKSFIRST ADVISORS PRIVATE LIMITED',
    'JANASHA FINANCE PRIVATE LIMITED',
    'KALIKAPURI ESTATES PRIVATE LIMITED',
    'INDIANIVESH CORPORATE FINANCE PRIVATE LIMITED',
    'AARUSH LOGISTICS PARK PRIVATE LIMITED',
    'DWELLINGS STAR DEVELOPERS PRIVATE LIMITED',
    'FORTUNO GLOBAL REALTY PRIVATE LIMITED',
    'ADPL PROJECTS (INDIA) PRIVATE LIMITED',
    'MANDDO MEDICAL SERVICES PRIVATE LIMITED',
    'SMARTLUTH SOLUTION AND SERVICE PRIVATE LIMITED',
    'BENGALBOX SERVICES PRIVATE LIMITED',
    'TANDS PROJECT MANAGEMENT SERVICES PRIVATE LIMITED',
    'GREENSTATE MEDICARE PRIVATE LIMITED',
    'DINDARPAN PUBLICATION PRIVATE LIMITED',
    'ETU BUSINESS RESEARCH PRIVATE LIMITED',
    'MAHAA CAUVERY EXPORTS PRIVATE LIMITED',
    'PLUS MAX DUTY FREE (MADURAI) PRIVATE LIMITED',
    'BEYONDSKOOL INNOVATIONS PRIVATE LIMITED',
    'ARASAR TECHNOLOGIES PRIVATE LIMITED',
    'JYOTHY SKILL ACADEMY PRIVATE LIMITED',
    'STUDY SQUARE PRIVATE LIMITED',
    'PROF. DR. VISHWANATH D. KARAD WORLD PEACE FOUNDATION',
    'OSLERS ACADEMY EDUCATION SERVICES PRIVATE LIMITED',
    'ISHAANAV NUTRACEUTICALS PRIVATE LIMITED',
    'ANITEJ SERVICES PRIVATE LIMITED',
    'BIOAYURVEDA PRIVATE LIMITED',
    'EXOTON FOUNDATION',
    'GAIKWAD HOSPITAL AND RESEARCH CENTER PRIVATE LIMITED',
    'ILOVE 9 MONTHS FITNESS SOLUTIONS PRIVATELIMITED',
    'NOURISHING SCHOOLS FOUNDATION',
    'VESUVIUS REFRACTORY INDIA PRIVATE LIMITED',
    'UP TELEVISION NETWORK PRIVATE LIMITED',
    'HAMARA REMEDIES PRIVATE LIMITED',
    'EVERIN INDIA PRIVATE LIMITED',
    'TOP2D3D STUDIOS PRIVATE LIMITED',
    'NOVOSTACK PRIVATE LIMITED',
    'MADOVER PRINT PRIVATE LIMITED',
    'EBEST IOT TECHNOLOGIES PRIVATE LIMITED',
    'QUINTESSELEAD TRAINING & CONSULTING (OPC) PRIVATE LIMITED',
    'GETI INSTITUTE PRIVATE LIMITED',
    'BSHAN INDUSTRIES PRIVATE LIMITED (OPC)',
    'IMGENIE DIGITAL PRIVATE LIMITED',
    'ONE STOP ENERGY SOLUTIONS PRIVATE LIMITED',
    'ARAN FUNDACIONE PRIVATE LIMITED',
    'JHM IMPORT EXPORT PRIVATE LIMITED',
    'ENTREPRENEURS ORGANIZATION KOLKATA',
    'GET YOUR VENUE EVENTS PRIVATE LIMITED',
    'PIPERS CONSULTING INDIA PRIVATE LIMITED',
    'BRANDSHOOTS VENTURES PRIVATE LIMITED',
    'WSE ENTERTAINMENT PRIVATE LIMITED',
    'GOA CLINIC HEALTHCARE PRIVATE LIMITED',
    'HEALTHCLAIM TECHNOLOGIES PRIVATE LIMITED',
    'INNOTECH INTERVENTIONS PRIVATE LIMITED',
    'DIGITAL LENDERS ASSOCIATION OF INDIA',
    'CLARION AND TRUMPETS ENTERTAINMENT PRIVATE LIMITED',
    'THANE SMART CITY LIMITED',
    'DMCFS SKILL DEVELOPMENT FOUNDATION',
    'TRAILBLAZERS BPO SERVICES PRIVATE LIMITED',
    'KARAV INFO SOLUTIONS PRIVATE LIMITED',
    'SKYHIGH ARTS PRIVATE LIMITED',
    'GWALIOR SMART CITY DEVELOPMENT CORPORATION LIMITED',
    'DATARATI PRIVATE LIMITED',
    'NYX HOSPITALITY PRIVATE LIMITED',
    'CRICKETSOCIAL (INDIA) PRIVATE LIMITED',
    'VAIDEHI PROJECTS PRIVATE LIMITED',
    'KDP TECHNOLOGIES PRIVATE LIMITED',
    'VERTIGOO TRAINING PRIVATE LIMITED',
    'HOTFOOT TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'TARGETPLUS EDUCATION PRIVATE LIMITED',
    'ECOURBAN REALTY PRIVATE LIMITED',
    'RKV ENTERPRISES PRIVATE LIMITED',
    'PITON SYSTEMS PRIVATE LIMITED',
    'DEFY EDUCATIONAL ORGANISATION',
    'SKILLBOXES (INDIA) PRIVATE LIMITED',
    'EDISON EDUCATION PRIVATE LIMITED',
    'NUJSTER FITNESS STUDIOS PRIVATE LIMITED',
    'R. S. CONCAST (DURGAPUR) PRIVATE LIMITED',
    'TEACHSUB TECHNO SOLUTIONS PRIVATE LIMITED',
    'IDEAS AND JOURNEYS PRIVATE LIMITED',
    'BRAHMAND EDUCATION SERVICES PRIVATE LIMITED',
    'BBP STUDIO VIRTUAL BHARAT PRIVATE LIMITED',
    'BILLITON SERVICES PRIVATE LIMITED',
    'OCEAO-ENVIRO MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED',
    'HEALTHDEKHO HEALTHCARE PRIVATE LIMITED',
    'A.S. HEALTHCARE ASSISTANCE PRIVATE LIMITED',
    'SHAMOOR PRIVATE LIMITED',
    'SREE KARTHIKEYA INFRA AND ENVIRO SERVICES PRIVATE LIMITED',
    'SSMOMMY INTERNATIONAL PRIVATE LIMITED',
    'VEROCONTI SOLUTIONS PRIVATE LIMITED',
    'MK ISTORES PRIVATE LIMITED',
    'BEST TELECOMMUNICATION PRIVATE LIMITED',
    'EMEDIWRITE PRIVATE LIMITED',
    'MNR EDUCATIONAL COUNCIL',
    'AZAZO DIVIDERS PRIVATE LIMITED',
    'WINZO GAMES PRIVATE LIMITED',
    'DEEPAK BISHT FILMS PRIVATE LIMITED',
    'GENISYS COMMUNICATION PRIVATE LIMITED',
    'NURECA LIMITED',
    'QUALITY CARE JHARSUGUDA PRIVATE LIMITED',
    'GTRONX SERVICES PRIVATE LIMITED',
    'ADAMS APPLIANCES AND ELECTRONICS PRIVATELIMITED',
    'HOMEPECKED E-MARKETPLACE SERVICES PRIVATE LIMITED',
    'MUKUND CORRUPACK PRIVATE LIMITED',
    'MEGHMITRA SOLUTIONS PRIVATE LIMITED',
    'MOBISKRIBE TECHNOLOGIES PRIVATE LIMITED',
    'DILKHUSH VENTURES PRIVATE LIMITED',
    'MARVELOGIC CONSULTANCY SERVICES PRIVATE LIMITED',
    'EXPERTINI WORLDTECH PRIVATE LIMITED',
    'ASHAAMA PRINTING SOLUTIONS PRIVATE LIMITED',
    'EFFISOL ENERGY SOLUTIONS PRIVATE LIMITED',
    'AAKRITI CEMENTATION PRIVATE LIMITED',
    'SZK GLOBAL CONSULTING INDIA PRIVATE LIMITED',
    'PCUBE ADVISORS PRIVATE LIMITED',
    'MOUNTAINEERZ LEISURE AND ADVENTURE PRIVATE LIMITED',
    'KAPACTR TECH CONTROLS PRIVATE LIMITED',
    'SHREE VAIBHAVLAKSHMI MICROCREDIT FOUNDATION',
    '3RDI TECHNOLOGIES PRIVATE LIMITED',
    'SIMPLY RECRUIT SYSTEMS PRIVATE LIMITED',
    'CAPTURING WEDDINGS PRIVATE LIMITED',
    'CAUSSA TEC SOLUTIONS PRIVATE LIMITED',
    'THOUGHTSTARTERS (OPC) PRIVATE LIMITED',
    'BEAUTYSTORY ONLINE INDIA PRIVATE LIMITED',
    'KITESPLINE PRIVATE LIMITED',
    'HAMSA SOHAM HEALTHCARE PRIVATE LIMITED',
    'NXT ECOMMERCE SOLUTIONS INDIA PRIVATE LIMITED',
    'DDP SPECIALITY PRODUCTS INDIA PRIVATE LIMITED',
    'NIVESHA TECHNOLOGIES PRIVATE LIMITED',
    'LEO GLOBAL EXPRESS LOGISTICS INDIA PRIVATE LIMITED',
    'FY FORWARD MANAGEMENT SERVICES PRIVATE LIMITED',
    'WEAVELABS TECHNOLOGIES PRIVATE LIMITED',
    'SUYOG AQUATECH PRIVATE LIMITED',
    'GTSINC PRIVATE LIMITED',
    'COURSELEAP EDUCATION PRIVATE LIMITED',
    'SARTHI DIGITAL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ANCAP SOLUTIONS PRIVATE LIMITED',
    'KRUSHIVAL AGRO SCIENCE PRIVATE LIMITED',
    'DHAVALA TECHNOLOGIES PRIVATE LIMITED',
    'NISWA ENGG SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SMOOTHGRAPH CONNECT PRIVATE LIMITED',
    'PACIFIC FREIGHT FORWARDERS PRIVATE LIMITED',
    'ENSURECORP PRIVATE LIMITED',
    'CENTER OF DIGITAL EXCELLENCE (CODE) PRIVATE LIMITED',
    'GREENILAI TECHNOLOGIES PRIVATE LIMITED',
    'TECH BERATER PRIVATE LIMITED',
    'KIBBCOM INDIA PRIVATE LIMITED',
    'SARANGAPANI PRIVATE LIMITED',
    'VF LEISURE HOLIDAYS PRIVATE LIMITED',
    'WHITEHEN PRIVATE LIMITED',
    'MULTI INFRASTRUCTURE & ENGINEERING PRIVATE LIMITED',
    'IBIMEDIA TECHNOLOGIES PRIVATE LIMITED',
    'UNIQGRID PRIVATE LIMITED',
    'SRIKARA UNDERCARRIAGE SPARES PRIVATE LIMITED',
    'ARHAN POWER PRIVATE LIMITED',
    'QWENTIC CONSULTING PRIVATE LIMITED',
    'NTF GUJARAT PRIVATE LIMITED',
    'VSV MARINE MANAGEMENT PRIVATE LIMITED',
    'FAIRCONNECT BUSINESS ADVISORS PRIVATE LIMITED',
    'NARMADA DIAMOND WORKS PRIVATE LIMITED',
    'EXCELUS LEARNING SOLUTIONS PRIVATE LIMITED',
    'NHANSMEDIA PRIVATE LIMITED',
    'TRIOPHS MEDICAL SERVICES PRIVATE LIMITED',
    'REVERSEURBAN ECOSYSTEMS PRIVATE LIMITED',
    'SKYHIGH ARTS CLUB PRIVATE LIMITED',
    'PURIN FOODS PRIVATE LIMITED',
    'VSJ FOUNDATION',
    'TDW TECHNOLOGIES PRIVATE LIMITED',
    'FRONS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'AMALGAM DESIGN LAB PRIVATE LIMITED',
    'LONE CYPRESS VENTURES PRIVATE LIMITED',
    'SWARA BABY PRODUCTS PRIVATE LIMITED',
    'ALL METAL SERVICES INDIA PRIVATE LIMITED',
    'RAMAUX INDIA CHEM PRIVATE LIMITED',
    'LAXYO FINANCE LIMITED',
    'SPS EVENTS PRIVATE LIMITED',
    'CONSISTENT NETWORKS PRIVATE LIMITED',
    'SPIROIDS INFORMATION SERVICES PRIVATE LIMITED',
    'GODREJ SKYLINE DEVELOPERS PRIVATE LIMITED',
    'PERCEIVESTAR INDIA PRIVATE LIMITED',
    'CYBACE SOLUTIONS PRIVATE LIMITED',
    'SHRI DATTAPRABHU AGRO INDUSTRIES PRIVATELIMITED',
    'WISEKEY INDIA PRIVATE LIMITED',
    'NAVPAD STEEL PRIVATE LIMITED',
    'MANOTR TECHLABS PRIVATE LIMITED',
    'AURAFOX SOLUTIONS PRIVATE LIMITED',
    'PINNACLE MACHINERY PRIVATE LIMITED',
    'BIJOOR SPORTS PROMOTION INSTITUTE',
    'ROUND INFINITY PRIVATE LIMITED',
    'SPORTZWIKI MEDIA PRIVATE LIMITED (OPC)',
    'INDIABUILD PREMISES PRIVATE LIMITED',
    'CAMDEN TOWN TECHNOLOGIES PRIVATE LIMITED',
    'CLOVE LIGHTING PRIVATE LIMITED',
    'SUNVO TECHNOLOGIES PRIVATE LIMITED',
    'PROPHOENIX SOLUTIONS TECHNOLOGIES PRIVATE LIMITED',
    'DESHKAL NETWORK PRIVATE LIMITED',
    'MAX SECURE OUTSOURCE PRIVATE LIMITED',
    'SPRO CARE PRIVATE LIMITED',
    'BRAHMASUTRA AYURVAIDYASALA (OPC) PRIVATELIMITED',
    'ASN INDIA FINCORP PRIVATE LIMITED',
    'BHARATH HEALTHCARE LABORATORIES PRIVATE LIMITED',
    'INDIATHINK COUNCIL',
    'RIFTMOTION PRIVATE LIMITED',
    'OMNIFICENT TECHNOLOGIES PRIVATE LIMITED',
    'GOPAL POWERGEN PRIVATE LIMITED',
    'GOPAL SONS EXPORTS PRIVATE LIMITED',
    'GOVIVEKGO SOCIAL MEDIA MARKETING PRIVATE LIMITED',
    'COMPETENT AUTOMOBILES COMPANY LIMITED',
    'COMPETENT BUILDERS PVT LTD',
    'COMPETENT CARGO PRIVATE LIMITED',
    'GOYAL CAPITAL LIMITED',
    'COMPETENT FILMS PRIVATE LIMITED',
    'GOLDWYN LIMITED',
    'GOYAL ENGINEERING POLYMERS PRIVATE LIMITED',
    'GPS ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'GPS GREEN BUILDING PRIVATE LIMITED',
    'GPS India Networks Private Limited',
    'GPS TECHNOLOGIES PRIVATE LIMITED',
    'COMPUNNEL TECHNOLOGY INDIA PRIVATE LIMITED',
    'COMPUTER CHIPS (INDIA) PRIVATE LIMITED',
    'GR8 FutureBrands Private Limited',
    'CLIFF SCAFFOLDINGS PRIVATE LIMITED',
    'GOLDEN JEWEL CRAFT (INDIA) PRIVATE LIMITED',
    'CONCEPT AGROTECH CONSULTANTS LIMITED',
    'CONCEPT WEAVERS PRIVATE LIMITED',
    'CONCEPTPLUS INFOSOLUTIONS PRIVATE LIMITED',
    'GRADE ONE EVENTS PRIVATE LIMITED',
    'GOLDEN OVERSEAS Private Limited',
    'GRAMIN BHANDARAN CORPORATION LIMITED',
    'GRAN INTERNATIONAL PRIVATE LIMITED',
    'GOLDEN TOUCH ARTWARE PRIVATE LIMITED',
    'COMMERCIAL HOSPITALITY LIMITED',
    'GRANDPARK BUILDTECH PRIVATE LIMITED.',
    'Grands Technobuild Private Limited',
    'GRANDSTAR REALTY PRIVATE LIMITED',
    'COMMUNIQUE MARKETING SOLUTIONS PRIVATE LIMITED',
    'COMPETENT DYESTUFF AND ALLIED PRODUCTS PRIVATE LIMITED',
    'GREAT AID MARKETING PRIVATE LIMITED',
    'CLIPLOK SIMPAK (INDIA) PRIVATE LIMITED',
    'Cloos India Welding Technology Private Limited',
    'Great Rocksport Private Limited',
    'GREAT WSI NET PRIVATE LIMITED',
    'GREATWALL CONSTRUCTION AND DEVELOPERS PRIVATE LIMITED',
    'GREATWAY ESTATES Private Limited',
    'GREATWAYS BUILDTECH LIMITED',
    'GREAVES TRAVEL INDIA PRIVATE LIMITED',
    'CNS COMNET SOLUTION PRIVATE LIMITED',
    'MISSION SYSTEMS INDIA PRIVATE LIMITED',
    'Cobitis Real Estate Limited',
    'Coca-Cola India Foundation',
    'GREEN INFRA BTV LIMITED',
    'GREEN INFRA PROFILES PRIVATE LIMITED',
    'GREEN INFRA WIND ENERGY THENI LIMITED',
    'COCHIN HERBALS PRIVATE LIMITED',
    'COGNITION STRATEGY PRIVATE LIMITED',
    'GREEN LEAF PROPERTIES PVT LTD',
    'TARC GREEN RETREAT LIMITED',
    'GREEN VALLEY BUILDERS PRIVATE LIMITED',
    'GREEN VALLEY PRODUCTS PRIVATE LIMITED',
    'COLMAR HOSPITALITY PRIVATE LIMITED',
    'Commeasure Solutions India Private Limited',
    'GRAPHIC REALTORS PRIVATE LIMITED',
    'GRAPHONIX INFOTECH PRIVATE LIMITED',
    'GREENDOT HEALTH FOODS PRIVATE LIMITED',
    'GREAT AID TECHNICAL SERVICES PRIVATE LIMITED.',
    'COMPETENT INFRAPROMOTERS PRIVATE LIMITED',
    'GREENLINE BUILDCON PRIVATE LIMITED',
    'GREENLINE PROMOTERS PRIVATE LIMITED',
    'GREENVALLEY REALTORS PRIVATE LIMITED',
    'COMPETENT INTERNATIONAL RESORTS & HOTELS LIMITED',
    'GREENWOOD PROPERTIES PRIVATE LIMITED',
    'Grey Head Media Private Limited',
    'GREY HEADS FOREX PRIVATE LIMITED',
    'GREYSHAM INTERNATIONAL PRIVATE LIMITED',
    'DIPTI FARMS PRIVATE LTD',
    'DOYPACK SYSTEMS PRIVATE LIMITED',
    'HIGHFIVE GLOBAL NETWORKS PRIVATE LIMITED',
    'DIMENSION TOWN PLANNERS PRIVATE LIMITED',
    'DIMPLE ENTERPRISES PRIVATE LIMITED',
    'DISHA INDIA KHOJ EXPEDITIONS PRIVATE LIMITED',
    'DISHA INVESTMENT CENTRE PRIVATE LIMITED',
    'DJB INFRASTRUCTURES & DEVELOPERS INDIA PRIVATE LIMITED',
    'DR. SABHARWAL',
    'S SEED TECHNOLOGIES PRIVATE LIMITED',
    'MADHURAI JASMINE FARMERS PRODUCER COMPANY LIMITED',
    'PUDAMI AGRI BIOTECH PRIVATE LIMITED',
    'SIVANAGAMANI AGRO FARMS PRIVATE LIMITED',
    'JURALA FARMERS PRODUCER COMPANY LIMITED',
    'NETTEMPADU FARMERS PRODUCER COMPANY LIMITED',
    'SRI GANGA FISHERIES PRODUCER COMPANY LIMITED',
    'KHEYTI TECH PRIVATE LIMITED',
    'FARMART SERVICE PRIVATE LIMITED',
    'PAVAGADA FARMS PRIVATE LIMITED',
    'HARITHAKAILASH AGRO PRIVATE LIMITED',
    'RAVI INTEGRATED LOGISTICS (INDIA) PRIVATE LIMITED',
    'KALLIKUDI FARMERS PRODUCER COMPANY LIMITED',
    'CHINTAN AGRO FARMS PRIVATE LIMITED',
    'THALLY OUTBACK AGRI PRIVATE LIMITED',
    'NIPUN GREENGROCERS PRIVATE LIMITED',
    'AGROWON AGROTECH INDUSTRIES PRIVATE LIMITED',
    'HARUR FARMERS PRODUCER COMPANY LIMITED',
    'RAPTI ROHIN SABJI PRODUCER COMPANY LIMITED',
    'KAPILA AGRO INDUSTRIES PRIVATE LIMITED',
    'ARANYAK ECOHARVEST PRIVATE LIMITED',
    'ANANYA HI-TECH FARMS PRIVATE LIMITED',
    'SHERISHA BIKANER SOLAR POWER PRIVATE LIMITED',
    'REFEX POWER TRADING PRIVATE LIMITED',
    'STPL HORTICULTURE PRIVATE LIMITED',
    'SHERISHA POWERTECH PRIVATE LIMITED',
    'SEVAIYOOR TRADITIONAL CROP PRODUCER COMPANY LIMITED',
    'VILATHIKULAM FARMERS PRODUCER COMPANY LIMITED',
    'T.KALLUPATTI FARMERS PRODUCER COMPANY LIMITED',
    'SUMA AGRO INDIA PRIVATE LIMITED',
    'PUDUR NADU FARMERS PRODUCER COMPANY LIMITED',
    'KRISHI VIKAS FARMER PRODUCER COMPANY LIMITED',
    'MRITTIKA PRODUCER COMPANY LIMITED',
    'KISAN JANKALYAN PRODUCER COMPANY LIMITED',
    'PROSPERITY ORGANICS PRIVATE LIMITED',
    'HILL SIDE PLANTATION AND FARMS PRIVATE LIMITED',
    'SANSIBHA MANUFACTURERS PRIVATE LIMITED',
    'KONGU HERBAL CHICKEN PRIVATE LIMITED',
    'MANGOMEADOWS AGRICULTURAL PLEASURE LAND PRIVATE LIMITED',
    'JANS BAMBOO PRODUCTS PRIVATE LIMITED',
    'PURELAND PLANTATIONS AND FARMS PRIVATE LIMITED',
    'SRIDHAR FISHERIES PRIVATE LIMITED',
    'JMJ SEAFOODS PRIVATE LIMITED',
    'GREENSHRIMP AQUAFARMS PRIVATE LIMITED',
    'MICROBI AGROTECH PRIVATE LIMITED',
    'CATCH OF NORWAY SEAFOOD PRIVATE LIMITED',
    'FARMFOLKS AGRO PRIVATE LIMITED',
    'ECHORA CONSTRUCTIONS PRIVATE LIMITED',
    'NIMBLEGROWTH CONSULTANCY SERVICES PRIVATE LIMITED',
    'SKY MINING SERVICES INDIA PRIVATE LIMITED',
    'BENGAL BIRBHUM COALFIELDS LIMITED',
    'KONKAN LNG LIMITED',
    'JIVABHUMI AGRI TECH PRIVATE LIMITED',
    'NORTH MALABAR FARMERS PRODUCER COMPANY LIMITED',
    'SHOBHA RETAILS PRIVATE LIMITED',
    'SASSY GARMENTS PRIVATE LIMITED',
    'GREENSTONE GRANITO PRIVATE LIMITED',
    'ACECON VITRIFIED PRIVATE LIMITED',
    'RAILTECH INDUSTRIES PRIVATE LIMITED',
    'WELSPUN WASCO COATINGS PRIVATE LIMITED',
    'VIVIANA VITRIFIED PRIVATE LIMITED',
    'QURO VITRIFIED PRIVATE LIMITED',
    'DUMORE GAUGING SYSTEMS P LTD',
    'SWETADRI ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'NCC CROWNS PRIVATE LIMITED',
    'M.N.R. AUTOMOTIVE PRIVATE LIMITED',
    'METROLAB ENGINEERING PRIVATE LIMITED',
    'KAREN STEEL PRIVATE LIMITED',
    'V-LOCK ENGINEERING PRIVATE LIMITED',
    'MONITOR LIFTS PRIVATE LIMITED',
    'RAASI GREEN EARTH ENERGY ONE PRIVATE LIMITED',
    'BRAND STEEL & POWER Private Limited',
    'RAJASTHANI FILTERS PRIVATE LIMITED',
    'LANDTRAC TRACTORS PRIVATE LIMITED',
    'TRISTONE FLOWTECH INDIA PRIVATE LIMITED',
    'GAYATRI FACILITIES AND CORPORATE SERVICES PRIVATE LIMITED',
    'REAL TECHNOLOGIES MACHINES PRIVATE LIMITED',
    'BHADRA CASTALLOY PRIVATE LIMITED',
    'VISTAR ALLOYS PRIVATE LIMITED',
    'AGRABANDHU METALS PRIVATE LIMITED',
    'SWASTIK GRC AND FRP COMPONANTS PRIVATE LIMITED',
    'WHITE ROOF BUILDING SYSTEMS PRIVATE LIMITED',
    'SUPREME TECHNOCRATS PRIVATE LIMITED',
    'LAMBDA CLINICAL SERVICES LIMITED',
    'AAVIN STAINLESS PRIVATE LIMITED',
    'VARIFAB ENGINEERING PRIVATE LIMITED',
    'OMKAR ENGINEERING INDIA PRIVATE LIMITED',
    'CHAUDHARI ENGINEERING WORKS PRIVATE LIMITED',
    'DOLPHIN HEAT TRANSFER PRIVATE LIMITED',
    'APARNA VENSTER INDIA PRIVATE LIMITED',
    'CHINNAPPA ENGINEERING PRIVATE LIMITED',
    'MILAP MACHINES (I) PRIVATE LIMITED',
    'JINDAL QUALITY TUBULAR LIMITED',
    'ICAT INDUSTRIES INDIA PRIVATE LIMITED',
    'EDGEFLEX ENGINEERING PRIVATE LIMITED',
    'SURETECH PROJECTS PRIVATE LIMITED',
    'TOOLORBIT METAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HNI AUTOTECH PRIVATE LIMITED',
    'MIRHAE ENGINEERING INDIA PRIVATE LIMITED',
    'AKSH MANUFACTURING PRIVATE LIMITED',
    'VENTURI VALVE TECH PRIVATE LIMITED',
    'SUPER TECH PUMPS & EQUIPMENTS PRIVATE LIMITED',
    'NIPPON OIL PUMP INDIA PRIVATE LIMITED',
    'SPAN INSPECTION SYSTEMS PRIVATE LIMITED',
    'POOJAHEATEX ENGINEERING PRIVATE LIMITED',
    'DENYO MANUFACTURING INDIA PRIVATE LIMITED',
    '3M TECHNO SKILL PRIVATE LIMITED',
    'CAMTAP AUTOCOMP PRIVATE LIMITED',
    'FUNKE HEATEX ENGINEERING INDIA PRIVATE LIMITED',
    'AAYUSHRE POLYMERS PRIVATE LIMITED',
    'SURA AUTOMOTIVE PRIVATE LIMITED',
    'RAJKOT DIES AND FIXTURES PRIVATE LIMITED',
    'EXCEL TECHNO STEEL CASTINGS PRIVATE LIMITED',
    'BLUEPACIFIC ELEVATORS PRIVATE LIMITED',
    'EXTREMUS EPC PRIVATE LIMITED (OPC)',
    'TECHNO KITCHENWARE PRIVATE LIMITED',
    'LAKHOTIA (INDIA) PRIVATE LIMITED',
    'UNSEEN ERA TECHNOLOGIES PRIVATE LIMITED',
    'GOSTOL TST INDIA PRIVATE LIMITED',
    'COFFEE DAY SCHAERER TECHNOLOGIES PRIVATE LIMITED',
    'GEIOSIS EARTHING PRIVATE LIMITED',
    'MASUVIC INDSUP PRIVATE LIMITED',
    'TECHSOL INSTRUMENTS PRIVATE LIMITED',
    'TANFILT ENGINEERING AND TECHNOLOGY PRIVATE LIMITED',
    'DE LA RUE INDIA PRIVATE LIMITED',
    'KAHO SOLAR LIMITED',
    'BICELLI GECO HYDRAULICS INDIA PRIVATE LIMITED',
    'AVALORS ADVANCED SYSTEMS PRIVATE LIMITED',
    'SWAN TECHNICAL SERVICES PRIVATE LIMITED',
    'SPEEDLAM ELECTROMATERIALS PRIVATE LIMITED',
    'VIBRANT CONSTRUCTION EQUIPMENTS PRIVATE LIMITED',
    'VIBHA AUTOMATION TECHNOLOGY PRIVATE LIMITED',
    'JENS ENVIRO TECHNOLOGIEN PRIVATE LIMITED',
    'HUAHENG AUTOMATION PRIVATE LIMITED',
    'LORVEN HYDRAULIC PRIVATE LIMITED',
    'STAR AEROSPACE PRIVATE LIMITED',
    'OLI VIBRATORS INDIA PRIVATE LIMITED',
    'COMER INDUSTRIES INDIA PRIVATE LIMITED',
    'JAIN INDIA STEELCOORP PRIVATE LIMITED',
    'STRAMA-SUMMIT MACHINERY PRIVATE LIMITED',
    'PASHUPATI RUBTECH PRIVATE LIMITED',
    'MAHIJ EXIM PRIVATE LIMITED',
    'JAPAN ELEVATOR SERVICE INDIA PRIVATE LIMITED',
    'TRADEPORT GLOBE PRIVATE LIMITED',
    'YOUNGMAN MANUFACTURING INDIA PRIVATE LIMITED',
    'INTERBRAKE SYSTEMS PRIVATE LIMITED',
    'ABSOLUTE WATER PRIVATE LIMITED',
    'ZERO DISCHARGE TECHNOLOGIES PRIVATE LIMITED',
    'CRIAMOS ENGINEERING PRIVATE LIMITED',
    'SHINE MECH TECHNOLOGY PRIVATE LIMITED',
    'SAFE ACT ENGINEERING PRIVATE LIMITED',
    'FORFEND CYBERNATICS PRIVATE LIMITED',
    'SHRIVISION HITECH CITY PRIVATE LIMITED',
    'LEANTARTIS DEVELOPERS PRIVATE LIMITED',
    'DRAGONSTONE REALTY PRIVATE LIMITED',
    'RIO LUXURY HOMES PRIVATE LIMITED',
    'AMRAVATI CHIKHLI EXPRESSWAY LIMITED',
    'FAGNE SONGADH EXPRESSWAY LIMITED',
    'SCC INFRASTRUCTURE PRIVATE LIMITED',
    'TAKSHASHILA DEVELOPERS PRIVATE LIMITED',
    'SRUSHTI INFRA LINK PRIVATE LIMITED',
    'LEELA HARI BUILDCON PRIVATE LIMITED',
    'PSPN SYNERGY PRIVATE LIMITED',
    'KARUNA GREENTECH PRIVATE LIMITED',
    'MANIKARAN RENEWABLES LIMITED',
    'SHRIPROP PROPERTIES PRIVATE LIMITED',
    'ACOTECH CONSULTANTS PRIVATE LIMITED',
    'PRIMEMERIDIAN INFRASTRUCTURE PRIVATE LIMITED',
    'GREEN BRICK PROJECT PRIVATE LIMITED',
    'REAL ESTATE DEVELOPMENT & CONSTRUCTION CORPORATION OF RAJASTHAN LIMITED',
    'WE CONSTRUCT (INDIA) PRIVATE LIMITED',
    'CAPZCON INFRA PROJECTS PRIVATE LIMITED',
    'EN',
    'S RESORTS PRIVATE LIMITED',
    'MEXIN HOSPITALITY PRIVATE LIMITED',
    'CG SPECIALITY RESTAURANTS PRIVATE LIMITED',
    'GEO HOSPITALITY AND TOURS PRIVATE LIMITED',
    'EMPIRICAL VENTURES PRIVATE LIMITED',
    'PROMOTING DREAMS PRIVATE LIMITED',
    'LIONSGATE F&B PRIVATE LIMITED',
    'KITCHNZA FOODS AND HOSPITALITY PRIVATE LIMITED',
    'MANASWINI FOODS PRIVATE LIMITED',
    'SIGMIS BREWERIES & HOSPITALITY PRIVATE LIMITED',
    'ASHVILLE HOSPITALITY PRIVATE LIMITED',
    'ABSOLUTE CRAFTWORKS PRIVATE LIMITED',
    'ACCESS RETAIL PRIVATE LIMITED',
    'OYOMART INTERNET PRIVATE LIMITED',
    'FTD FLORAL PRIVATE LIMITED',
    'KRIZZAN RETAIL PRIVATE LIMITED',
    'CAMPUSSUTRA RETAIL PRIVATE LIMITED',
    'DWARKA LIFESTYLE RESORTS PRIVATE LIMITED',
    'BREWSKY HENNUR BREWERY PRIVATE LIMITED',
    'BLACKCURRANT FOODCOM PRIVATE LIMITED',
    'VRR & HC JEWELLERY PRIVATE LIMITED',
    'BREADBOX HOSPITALITY PRIVATE LIMITED',
    'INDMAR HORECA PRIVATE LIMITED',
    'MAXXVALUE HOTELS AND HOSPITALITY PRIVATE LIMITED',
    'VISHAV HOSPITALITY PRIVATE LIMITED',
    'ANTZCO RETAIL PRIVATE LIMITED',
    'PRABHATI FOODS PRIVATE LIMITED',
    'FLEX RETAIL & LOGISTICS INDIA PRIVATE LIMITED',
    'AL-DAAZ FOODS PRIVATE LIMITED',
    'HOTBOX HOSPITALITY PRIVATE LIMITED',
    'SHRAVIN HOSPITALITY PRIVATE LIMITED',
    'ZEN HOTELS AND RESORTS PRIVATE LIMITED',
    'THE GRANDMARUTI LUXOTIS PRIVATE LIMITED',
    'WISHERY ONLINE PRIVATE LIMITED',
    'KHILWANI ASSOCIATES PRIVATE LIMITED',
    'SHIVDHARA RESORTS LIMITED',
    'LAST DROP HOSPITALITY PRIVATE LIMITED',
    'GLADE DESTINATION PRIVATE LIMITED',
    'DOUGH AND BATTER HOSPITALITY PRIVATE LIMITED',
    'TAXIONCALL PRIVATE LIMITED',
    'NATIONAL HIGH SPEED RAIL CORPORATION LIMITED',
    'FLYING TURTLES FOODS AND BEVERAGES INDIA PRIVATE LIMITED',
    'RUBAB HOSPITALITY PRIVATE LIMITED',
    'EXPERIENTIAL INDIA PRIVATE LIMITED',
    'PRASANNA PURPLE (GOA) TRANSIT PRIVATE LIMITED',
    'JNR ROADWAYS PRIVATE LIMITED',
    'LYNKS LOGISTICS LIMITED',
    'SHIFTCO SHIPPING & LOGISTICS INDIA PRIVATE LIMITED',
    'SRI MURUGAN TRANSPORTS PRIVATE LIMITED',
    'HST HOSPITALITY PRIVATE LIMITED',
    'HIGH PROFILE TRANSPORTATION SERVICES PRIVATE LIMITED',
    'CHARTERED BIKE PRIVATE LIMITED',
    'SHHA RESTAURANTS PRIVATE LIMITED',
    'SPICY SIGDI PRIVATE LIMITED',
    'STRAITS LAUNDRY (INDIA) PRIVATE LIMITED',
    'SRI LAKSHMI CORPORATE SERVICES PRIVATE LIMITED',
    'QUALITY LOGISTICS SERVICES PRIVATE LIMITED',
    'V7 HOTEL PRIVATE LIMITED',
    'ABUNDANCE HOSPITALITIES PRIVATE LIMITED',
    'WGI TRADERS (INDIA) PRIVATE LIMITED',
    'MADHUKRISH AFFABILITY PRIVATE LIMITED',
    'GERACAO FOOD & BEVERAGES PRIVATE LIMITED',
    'ERP HOSPITALITY & ENTERTAINMENT (INDIA) PRIVATE LIMITED',
    'GRID LOGIC HOTELS AND RESORTS PRIVATE LIMITED',
    'SNEH VENTURES PRIVATE LIMITED',
    'INDIAN PORT RAIL & ROPEWAY CORPORATION LIMITED',
    'ALCHEMY INDIA PRIVATE LIMITED',
    'BNB COMMERCIAL REALTY PRIVATE LIMITED',
    'TAAL WALE BABA INFRA DEVELOPERS PRIVATE LIMITED',
    'URBANA FACILITY MAINTENANCE PRIVATE LIMITED',
    'LEVEN REALTY PRIVATE LIMITED',
    'SANDMAN REALCON PRIVATE LIMITED',
    'RAMADHUTA PROPERTIES PRIVATE LIMITED',
    'SHIVMANI CONCLAVE PRIVATE LIMITED',
    'EVERBLINK HIGHRISE PRIVATE LIMITED',
    'GLADSTONE CONCLAVE PRIVATE LIMITED',
    'MONTEC NIRMAN PRIVATE LIMITED',
    'COACTIVE CONSTRUCTION PRIVATE LIMITED',
    'SERIKOS ENCLAVE PRIVATE LIMITED',
    'STREEDOM REAL ESTATE PRIVATE LIMITED',
    'TRIPACK CONSTRUCTION PRIVATE LIMITED',
    'UTZSHO HOUSING DEVELOPMENT PRIVATE LIMITED',
    'PLENTYVALLEY PROPERTIES PRIVATE LIMITED',
    'AMITJOYTI REAL ESTATE PRIVATE LIMITED',
    'TRIWAVE DEVELOPERS PRIVATE LIMITED',
    'PANCHLOK REALTORS PRIVATE LIMITED',
    'SOUTH CITY RETREAT PROPERTY MANAGEMENT PRIVATE LIMITED',
    'NAVYOG DEVELOPERS PRIVATE LIMITED',
    'WINDSTROM REALTORS PRIVATE LIMITED',
    'YOUNGEST REALCON PRIVATE LIMITED',
    'SUBHSHIV DEVELOPERS PRIVATE LIMITED',
    'SHIVPAM REALTORS PRIVATE LIMITED',
    'GREENWALL INFRACON PRIVATE LIMITED',
    'OVERWEEN ESTATES PRIVATE LIMITED',
    'TREELINE CONSTRUCTION PRIVATE LIMITED',
    'BELIEVER ESTATE DEVELOPER PRIVATE LIMITED',
    'SUBINAY INFRASTRUCTURE PRIVATE LIMITED',
    'WINTERLAND PROPERTIES PRIVATE LIMITED',
    'YELLOWLINE INFRASTRUCTURE PRIVATE LIMITED',
    'ABSTAR INFRACON PRIVATE LIMITED',
    'GLASSEYE DEVELOPERS PRIVATE LIMITED',
    'GURUNAM REALTORS PRIVATE LIMITED',
    'HOLEMART PROPERTIES PRIVATE LIMITED',
    'INDONEP DEVELOPERS PRIVATE LIMITED',
    'KESURI REALTY PRIVATE LIMITED',
    'JYOTSHNADIP REALTY PRIVATE LIMITED',
    'LEMONGRASS REALTORS PRIVATE LIMITED',
    'LOSSEN REALTY PRIVATE LIMITED',
    'MOTIHARI REAL ESTATES PRIVATE LIMITED',
    'WELLPAN INFRACON PRIVATE LIMITED',
    'MAHALON CONSTRUCTION PRIVATE LIMITED',
    'SUPERWELL REAL ESTATES PRIVATE LIMITED',
    'TRINABH INFRASTRUCTURE PRIVATE LIMITED',
    'WELLPAN PROPERTIES PRIVATE LIMITED',
    'SUBHPAH PROJECTS PRIVATE LIMITED',
    'HEADWAY PROJECTS PRIVATE LIMITED',
    'UPFRONT BUILDERS PRIVATE LIMITED',
    'PRIYANKA NIKETAN PRIVATE LIMITED',
    'RAMKRIPA CONSTRUCTIONS PRIVATE LIMITED',
    'SHIV AMAR REALTY PRIVATE LIMITED',
    'ACCRO DEVELOPERS PRIVATE LIMITED',
    'ANTRIKSH INDIA PRIVATE LIMITED',
    'MISHAN INFRAPROPERTIES PRIVATE LIMITED',
    'EKONKAR ENCLAVE PRIVATE LIMITED',
    'REDDY DWELLINGS PRIVATE LIMITED',
    'IBID HOME PRIVATE LIMITED',
    'SURYAANVI BUILDERS PRIVATE LIMITED',
    'ONETOUCH REALCON PRIVATE LIMITED',
    'DIGGERS PROPERTIES PRIVATE LIMITED',
    'ECO SOLUTIONS PROJECT PRIVATE LIMITED',
    'KEVENTER',
    'S GURU MANTRA PRIVATE LIMITED',
    'HARAPPA LEARNING PRIVATE LIMITED',
    'RAAHI FOODS PRIVATE LIMITED',
    'AAKOB TECHNOLOGIES PRIVATE LIMITED',
    'GS ELECTROCONTROLS PRIVATE LIMITED',
    'SUPAASI SOLAR AUTO TRACKING SYSTEMS PRIVATE LIMITED',
    'PROGRESSO RESEARCH AND ANALYTICS PRIVATELIMITED',
    'GCEC GLOBAL PRIVATE LIMITED',
    'SETWORLD EXPRESS PRIVATE LIMITED',
    'TIGERBROTHERS SERVICES PRIVATE LIMITED',
    'JBLGEO TECHNOLOGIES PRIVATE LIMITED',
    'SRCNS PRIVATE LIMITED',
    'SKYLUXE ASSETS ADVISORS PRIVATE LIMITED',
    'ATLANTIC CROP SCIENCE PRIVATE LIMITED',
    'BKC MACHINERY IMPORT PRIVATE LIMITED',
    'DAITAI ENERGY & INFRA PRIVATE LIMITED',
    'DESUN HEALTH CITY FOUNDATION',
    'PARAMETER LEARNINGS INDIA PRIVATE LIMITED',
    'SAS NORTHERN PRIVATE LIMITED',
    '3RDFLIX VISUAL EFFECTS PRIVATE LIMITED',
    'HIPPO CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'MOS IMMIGRATION PRIVATE LIMITED',
    'IDEOPEDIA FOUNDATION',
    'AKMA TALENT KHOJ INDIA PRIVATE LIMITED',
    'FINBEE CONSULTANCY SERVICES PRIVATE LIMITED',
    'PANSARI ELECTRONICS PRIVATE LIMITED',
    'DEYEH ENTERPRISE PRIVATE LIMITED',
    'MODULUS RESEARCH AND ANALYSIS PRIVATE LIMITED',
    'MGS ENVIRON PRIVATE LIMITED',
    'FINLAND CHAMBER OF COMMERCE IN INDIA',
    'CHENNAIANGELS NETWORK ASSOCIATION',
    'DUNAMIS ENTERTAINMENT PRIVATE LIMITED',
    'ROUNDGLASS SPORTS PRIVATE LIMITED',
    'ONNIVATION VENTURES PRIVATE LIMITED',
    'ART INDIA FOUNDATION',
    'IMAAYA SPORTS PRIVATE LIMITED',
    'PROJECT CONCERN INTERNATIONAL INDIA FOUNDATION',
    'ALTERNATE LEARNING FOUNDATION',
    'VJ WELFARE FOUNDATION',
    'OLIVEBRANCH ORIENTATION AND LANGUAGE SERVICES PRIVATE LIMITED',
    'RIVERON INFOTECH PRIVATE LIMITED',
    'ANKIYA WELFARE FOUNDATION',
    'JEMONA JEWELLERS PRIVATE LIMITED',
    'SECOND ROUND PRIVATE LIMITED',
    'HIGH LEARN INSTITUTE PRIVATE LIMITED',
    'EDIFICATION ACADEMY PRIVATE LIMITED',
    'ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY (VIZAG) PRIVATE LIMITED',
    'KIRAN INFERTILITY CENTRE (BENGALURU) PRIVATE LIMITED',
    'MOTHERHOOD WOMEN',
    'SPRINK MEDIA PRIVATE LIMITED',
    'FINALYZIS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FUTURE AGRI & FOODS PRIVATE LIMITED',
    'BLUE SKY ANALYTICS PRIVATE LIMITED',
    'INTELLIRO INFRATECH PRIVATE LIMITED',
    'DEVELEARN TECHNOLOGIES PRIVATE LIMITED',
    'ERUDITION BUILDERS PRIVATE LIMITED',
    'TEN FINERY PRIVATE LIMITED',
    'JIOMEX AUTO (INDIA) PRIVATE LIMITED',
    'AAAK ADVISORY SERVICES PRIVATE LIMITED',
    'VIRENTIATECH PRIVATE LIMITED',
    'WOW BROADBAND PRIVATE LIMITED',
    'JANANOM PRIVATE LIMITED',
    'RAVIKAS AUTOMOTIVE SYSTEMS PRIVATE LIMITED',
    'RECYCLE TRACK INDUSTRIES PRIVATE LIMITED',
    'PIVOT MANAGEMENT CONSULTING (OPC) PRIVATE LIMITED',
    'WRITER',
    'FARM PRIVATE LIMITED',
    'Greenleaf extractions private limited',
    'Woodbriar estate limited',
    'Royal agricultural company private limited',
    'Sureshnagar tea plantation private limited',
    'Innovative mines and minerals limited',
    'Arunoday tea company pvt ltd',
    'Atul rajasthan date palms limited',
    'Tropical fruits international limited',
    'Atria holdings private limited',
    'Golcha minerals pvt ltd',
    'Kyanite mining (india) private limited',
    'Majithia salt and chemicals works pvt ltd',
    'Shenbaga vinayagar salterns limited',
    'Reddy dairy private limited',
    'ARVOG FOREX PRIVATE LIMITED',
    'BAHUBALI MOTORS PRIVATE LIMITED',
    'Mtl industries private limited',
    'Caspian caviar and fine food private limited',
    'African agro products private limited',
    'Baba entrepreneurs private limited',
    'Pataka agro private limited',
    'New leaf tea plantation private limited',
    'Sparsh automobiles private limited',
    'Yaps n belly food products private limited',
    'Liberty oil mills limited',
    'Nu-chem oils private limited',
    'Agron oil and refinery private limited',
    'Manipal prakashan limited',
    'Cauvery boards private limited',
    'West bengal forest development corpn ltd',
    'Reliable flour mills private limited',
    'Vaishnavi rice mill private limited',
    'Amrit agrovet private limited',
    'North eastern regional agricultural marketing corpn ltd',
    'Pratibha realtors private limited',
    'Manish food products private limited',
    'Modi illva india private limited',
    'Jadhao layland private limited',
    'N p fresh foods private limited',
    'Vijay home foods private limited',
    'Kissan agro fuel private limited',
    'Pioneer eserve private limited',
    'Badami sugars limited',
    'Reddy ayurveda herbal private limited',
    'National chikki mart private limited',
    'DHENDAI TEA & INDUSTRIES Private Limited',
    'Koyenco expellers kerala private limited',
    'G.t.products private limited',
    'Vaibhav liquors private limited',
    'Anpra farms developers private limited',
    'Ppl holdings private limited',
    'Akshat agro milling company private limited',
    'PRADAKSHANA FINTECH PRIVATE LIMITED',
    'Nandi tobaccos private limited',
    'AAREM AUTO (INDIA) PRIVATE LIMITED',
    'NEDKAAS CHEESE & DAIRY PRODUCTS PRIVATE LIMITED',
    'Balmukund diamonds private limited',
    'GIMA COTEX INDUSTRIES PRIVATE LIMITED',
    'V k texchem private limited',
    'Komal yarn industries private limited',
    'Jai gurdave spinning mills pvt ltd',
    'Vinland pearl spirits private limited',
    'Ankita agro and food processing private limited',
    'Duo impex private limited',
    'Modi granites private limited',
    'Sky cotex india private limited',
    'Network industries limited',
    'Child world private limited',
    'Stile clothing private limited',
    'Oswal knit india limited',
    'Grover spinners pvt ltd',
    'Chemical limes mundwa private limited',
    'ANKUR MINERAL PRIVATE LIMITED',
    'Crown woollen mills pvt ltd',
    'Adinath yarns limited',
    'Rajdhani universal fabrics private limited',
    'DALMIA MINERALS & PROPERTIES LIMITED',
    'Emars mining & construction pvt ltd',
    'R. k. quarry works private limited',
    'Neuerth coal mining private limited',
    'Jaipur mineral development syndicate pvt ltd',
    'Udaipur mineral development syndicate pvt ltd',
    'THE RAJARATNA MILLS PRIVATE LIMITED',
    'KRISSNIDHI INDUSTRIES PRIVATE LIMITED',
    'THE CHILDREN',
    'S DIAGNOSTICS PRIVATE LIMITED',
    'Biogenuix medsystems private limited',
    'Total environment resorts private limited',
    'Dew medicare and research foundation private limited',
    'Interactive medical tourism private limited',
    'Clinworld private limited',
    'Medlab research private limited',
    'School of ayurvedic and maha yoga private limited',
    'Samadhan welfare foundation.',
    'Intercooperation social development india u/sce.25',
    'Indian grameen services',
    'Vivek outsourcing services private limited',
    'Kandamkulathil lonappan charities',
    'Eco care engineering private limited',
    'SHOWCASE TRADE FAIRS AND BUSINESS MEDIA PRIVATE LIMITED',
    'Maharashtra foundation india',
    'Percept profile private limited',
    'Advanced technologies centre for design and sustainability',
    'CANH INFRASTRUCTURE LIMITED',
    'Sri venkateshwara digital home entertainment private limited',
    'Dharma productions private limited',
    'Mindseye entertainment private limited',
    'Nadiadwala grandson entertainment private limited',
    'Vichaar television network limited',
    'Alchemy studios private limited',
    'Sarthak films private limited',
    'Sumo video games private limited',
    'International amusement limited',
    'Mash audio visuals private limited',
    'Pinkcity exhibitors private limited',
    'Ken films private limited',
    'Sgx minerals private limited',
    'Pine tree pictures private limited',
    'BACKWATER ORIGINS PRIVATE LIMITED',
    'Green gold pictures private limited',
    'Mandapeta digital entertainment private limited',
    'Jeevan telecasting corporation limited',
    'Pegasus events private limited',
    'Little ustaads arts private limited',
    'Wheelieboy adventures (i) limited',
    'PDA TRADE FAIRS PRIVATE LIMITED',
    'Cima gallery private limited',
    'Gulmohar greens-golf and country club limited',
    'Aim expositions private limited',
    'Eyecatcher entertainment private limited',
    'ISLAND HOMES PRIVATE LIMITED',
    'Apca media resources pvt. ltd.',
    'Ninedigit technologies private limited',
    'Vintage creations private limited',
    'Powermax fitness india private limited',
    'VINFORMAX DIMENSIONS TECHNOLOGY PRIVATE LIMITED',
    'Indian tennis players association',
    'Evershine gymkhana and healthcentre pvt ltd',
    'R2 fitness revolution private limited',
    'IN10 MEDIA PRIVATE LIMITED',
    'Equinox productions private limited',
    'Clay station art studios private limited',
    'Smaaash entertainment private limited',
    'Tao art foundation',
    'The association of electrical contractors',
    'Sanrakshan heritage consultants private limited',
    'Consumer metrics informatics private limited',
    'Miracle foundation india',
    'Wisdom tree entertainment and events private limited',
    'Ace recruitment & placement consultants private limited',
    'Aamc training india private limited',
    'Karnataka state industrial and infrastructure development corporation limited',
    'Creative factor integrated marketing private limited',
    'CORNER OFFICE CONSULTING SOLUTIONS PRIVATE LIMITED',
    'Kernox learning systems private limited',
    'Aha entertainment private limited',
    'Xtend industrial designers and engineers private limited',
    'Aha parks limited',
    'Athena advisory services private limited',
    'Gir holiday resorts private limited',
    'Suvira real estate private limited',
    'Magna cleaning systems private limited',
    'Yoboho new media private limited',
    'Centre point events private limited',
    'GARAGE WORLDWIDE PRIVATE LIMITED',
    'Penta hr solutions private limited',
    'Fincrest information services private limited',
    'Talentmandi services private limited',
    'Kosher engineering & consultancy private limited',
    'ORCHID DMC PRIVATE LIMITED',
    'Jv resume india private limited',
    'Nexify services private limited',
    'Macquarie global services private limited',
    'SARAYA MYSTAIR HYGIENE PRIVATE LIMITED',
    'Review risk management services private limited',
    'Naik business services private limited',
    'Sg global impex private limited',
    'Gencoval strategic services private limited',
    'Enormass project logistiks private limited',
    'M',
    'TRAINING SOLUTIONS PRIVATE LIMITED',
    'AIBONO SMART FARMING PRIVATE LIMITED',
    'Tiltro advisory private limited',
    'Worldsource healthcare (india) private limited',
    'Asvins care solutions private limited',
    'Miway resources private limited',
    'Adroit learning and manpower private limited',
    'MANIPAL RAKSHITH LABOUR AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'Naz marine services pvt ltd',
    'Ace employment services private limited',
    'Clr facility services private limited',
    'Bishan jobs private limited',
    'Expertus hr private limited',
    'Alternate hr solutions private limited',
    'Argus electronic security systems private limited',
    'Q3 SERVICES INDIA PRIVATE LIMITED',
    'Celestial india trading private limited',
    'Dreamgains financials india private limited',
    'Digital asset management private limited',
    'BOKU NETWORK SERVICES IN PRIVATE LIMITED',
    'Avicom media private limited',
    'Energy pack private limited',
    'Secure packaging private limited',
    'ACN HEALTHCARE RCM SERVICES PRIVATE LIMITED',
    'Ne mobile services (india) private limited',
    'Weten enterprises private limited',
    'Greentech services private limited',
    'Acrux shipping private limited',
    'TFCI EVENTS PRIVATE LIMITED',
    'Soft lite impex private limited',
    'GRENERGY INNOVATIONS PRIVATE LIMITED',
    'Igl gemlab (india) private limited',
    'Vega technology (india) private limited',
    'Compass energy india private limited',
    'Gayathri and namith architects private limited',
    'Kino designs private limited',
    'Dc design company private limited',
    'Jess trading india private limited',
    'Unigenetics instruments private limited',
    'DYNAMIC DRILLING & SERVICES PRIVATE LIMITED',
    'Accord teleservices private limited',
    'A.r. softwares (private limited',
    'Software giants pvt ltd',
    'SABRE TRAVEL NETWORK (INDIA) PRIVATE LIMITED',
    'Mass infonet private limited',
    'V.g. tech computers private limited',
    'Bioenable technologies private limited',
    'Leapswitch networks private limited',
    'Rialto enterprises private limited',
    'KIRTI TELNET PRIVATE LIMITED',
    'Sharp power and communication equipments (india ) private limited',
    'Toshiba jsw power systems private limited',
    'Virginia transformer india private limited',
    'Ceekolack insulation private limited',
    'Kems auto components limited',
    'Kayaar (thermo) instruments pvt ltd',
    'Sirveen control systems private limited',
    'Suryakiran lite industries private limited',
    'Arteche smartgrid india private limited',
    'Vega solar energy private limited',
    'CHROMALOX INDIA PRECISION HEAT & CONTROL PRIVATE LIMITED',
    'Sharad industrial products private limited',
    'Rst air conditioning systems private limited',
    'Powertrans electric co. private limited',
    'Contrinex automation private limited',
    'Security vision (india) private limited',
    'Clyde bergemann india private limited',
    'Switchgear manufacturing company private limited',
    'Fairdeal process automation private limited',
    'Micon automation systems private limited',
    'Sanpar microfilter private limited',
    'KEL ELECTRICAL MACHINES LIMITED',
    'Mecord electronics and engineering private limited',
    'BYD INDIA PRIVATE LIMITED',
    'Electronics corporation of india limited',
    'Genex electricals pvt ltd',
    'Sundeep technologies private limited',
    'Microqual global services private limited',
    'BIO-RAD LABORATORIES (INDIA) PRIVATE LIMITED',
    'Power-one micro systems private limited',
    'Pegasus power devices private limited',
    'Shagun technocrats private limited',
    'FLYTBASE LABS PRIVATE LIMITED',
    'Devilog robotron private limited',
    'Axis video systems india private limited',
    'Mahabali Innovative Technologies Private Limited',
    'Mecord systems and services private limited',
    'Triton engineering private limited',
    'Ehealth technology business incubator (india)',
    'Chiron instruments (india) p ltd',
    'Edwards lifesciences (india) private limited',
    'Genrich membranes private limited',
    'B&a best health care private limited',
    'OXERA PRECISION TECH PRIVATE LIMITED',
    'Matrix ultra joints private limited',
    'Ital beauty nippers (india) private limited',
    'Molbio diagnostics private limited',
    'ACZET PRIVATE LIMITED',
    'Keyence india private limited',
    'Specific assignments india private limited',
    'TIMES COMTRADE PRIVATE LIMITED',
    'Rajesh motors (maharashtra) private limited',
    'Supreme rollform private limited',
    'A.v. automotives private limited',
    'Kalaria autoforge private limited',
    'Synergy oceanic services india private limited',
    'Dalwin marine and power services private limited',
    'Ras tek private limited',
    'Vessel management private limited',
    'Cross freight india private limited',
    'Yamaha motor electronics india private limited',
    'CHIMERA HOLDINGS PRIVATE LIMITED',
    'Vivanti private limited',
    'Falcon doors & windows private limited',
    'PARIN FURNITURE LIMITED',
    'Goldcoin packaging private limited',
    'Elixir met form private limited',
    'Tec workshop interiors india private limited',
    'Polywood profiles private limited',
    'Green sol synergies private limited',
    'Gsfc agrotech limited',
    'Mast climber equipement india private limited',
    'R b cutters private limited',
    'KALYAN JEWELLERS INDIA LIMITED',
    'ROSY BLUE DIAMONDS PRIVATE LIMITED',
    'Pushti jewels private limited',
    'Chattar impex private limited',
    'Arihant mattress private limited',
    'Priti gems exports private limited',
    'Orient aluminiums private limited',
    'Sigma flow control india limited',
    'Decora cotton exports private limited',
    'Marine consultants and surveyors private limited',
    'Neha power-lines private limited',
    'Gmr bajoli holi hydropower private limited',
    'Green cosmos energy solutions private limited',
    'RABAAJCO INDUSTRIES PRIVATE LIMITED',
    'Acquaint technologies private limited',
    'Logicrain technologies private limited',
    'Aray systems private limited',
    'Niti services private limited',
    'Ratnakala software private limited',
    'COGNITUD ADVISORY SERVICES PRIVATE LIMITED',
    'Konverge technologies private limited',
    'Proland softwares private limited',
    'Analytix systems private limited',
    'Ttk services private limited',
    'Midwest infotech private limited',
    'S.n. informatics private limited',
    'Kaps it solutions private limited',
    'CSG Systems International (India) Private Limited',
    'Genisys information systems (india) private limited',
    'Mclansys solutions private limited',
    'ADTHEOREM INDIA PRIVATE LIMITED',
    'Ace tech sys private limited',
    'Isol softech private limited',
    'Reyleon services private limited',
    'EVERBRIDGE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Edinture services private limited',
    'Clozon technologies private limited',
    'Mindsoft infotech (i) private limited',
    'Unifylabs systems private limited',
    'Goodworklabs services private limited',
    'Ethinkcells software solutions and services private limited',
    'Malghan business solutions private limited',
    'FREIGHTSPHERE SOFTWARE PRIVATE LIMITED',
    'P i t solutions private limited',
    'Us technology resources private limited',
    'Tuxinfonomist software and consultancy private limited',
    'Exodesoft technologies private limited',
    'Gnotis systems private limited',
    'Good methods techno health solutions hub private limited',
    'Exactus corporation private limited',
    'Quick Heal Technologies Limited',
    'NSEIT LIMITED',
    'Fairdeal software consultants private limited',
    'Reliance bpo private limited',
    'Integreon managed solutions (india) private limited',
    'Red carpet management private limited',
    'Omnipayments software private limited',
    'Triumph systems and solutions private limited',
    'Feast software private limited',
    'Vegayan systems private limited',
    'AFFIRMATIVE CAPITAL PRIVATE LIMITED',
    'Indepth soft solutions private limited',
    'Osiris it projects private limited',
    'Archies technologies private limited',
    'Ah web solutions private limited',
    'Knowledge-divine information technology private limited',
    'Grc innovations private limited',
    'Senate technologies (india) private limited',
    'Bizsolindia it services private limited',
    'OLIVE DESIGN AND COMMUNICATION PRIVATE LIMITED (OPC)',
    'Fidelity life sciences private limited',
    'Clarus life sciences private limited',
    'Jay precision pharmaceuticals private limited',
    'Pyther innovations private limited',
    'Seasons medicare private limited',
    'MY HEALTH WELLNESS PRIVATE LIMITED',
    'American ortho-tech private limited',
    'SAHAJANAND MEDICAL TECHNOLOGIES LIMITED',
    'Medinippon healthcare private limited',
    'Goldfinch engineering systems private limited',
    'Makino auto industries private limited',
    'Etak corporation limited',
    'Autokrom india private limited',
    'Indico motors private limited',
    'Kent car lounge(india) private limited',
    'Siddheshwar transmission private limited',
    'Tower automotive india private limited.',
    'Dhruvanshi automobiles private limited',
    'KIRLOSKAR SYSTEMS PRIVATE LIMITED',
    'Aditya motors (india) private limited',
    'Uniparts technologies private limited',
    'PINSTAR AUTOMOTIVE INDIA PRIVATE LIMITED',
    'Sm ship management private limited',
    'Waterways shipyard private limited',
    'Suhan aviation private limited',
    'Ankit aerospace private limited',
    'Cavotec india private limited',
    'Maharshi motors private limited',
    'Brose india automotive systems private limited',
    'Arr kay steel trading private limited',
    'Harsha glass ventures india private limited',
    'Luk bricks private limited',
    'Magnaa modules & systems private limited',
    'Bpc infra solutions private limited',
    'Retail fixtures and furniture private limited',
    'Georg fischer piping systems private limited',
    'Regalia jewels private limited',
    'Jewelcountry gemstones private limited',
    'Nikita jewellers private limited',
    'Marvel products and exim private limited',
    'Millenium fine jewels private limited',
    'LEMON TECHNOMIST PRIVATE LIMITED',
    'Bravo cable trays private limited',
    'Sara diamonds private limited',
    'Satyam cards n gifts private limited',
    'Bollywood diet private limited',
    'Smoke and fire curtains india private limited',
    'Bonisons equipment private limited',
    'Synergy art foundation limited',
    'Celex technologies private limited',
    'Jai sai metals (india) private limited',
    'Litebreeze infotech private limited',
    'Thavorath systems private limited',
    'Eram technologies private limited',
    'Airo global software private limited',
    'Indigo telesolutions private limited',
    'Vast india private limited',
    'Kernel tech networks private limited',
    'Quagnitia systems private limited',
    'Circle infotech private limited',
    'Vrisa infotech private limited',
    'Shreepati infotech private limited',
    'KWANTA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Alfatech systems private limited',
    'Oceans connect india private limited',
    'Isynergy techsys private limited',
    'Eximiuus solutions private limited',
    'VINSYS IT SERVICES INDIA LIMITED',
    'CONTENTSERV TECHNOLOGIES PRIVATE LIMITED',
    'Peocit software solutions private limited',
    'Logicbits systems private limited',
    'Extreme webtech private limited',
    'Soctronics technologies private limited',
    'Ixora global services private limited',
    'Itech it projects (india) private limited',
    'Resonate software solutions private limited',
    'TECHNICAL STRATEGIES (INDIA) PRIVATE LIMITED',
    'Centillion networks private limited',
    'Instancy software india private limited',
    'Votary softech solutions private limited',
    'ACCELLOR SOFTWARE PRIVATE LIMITED',
    'Inovies consulting private limited',
    'Paradigm creative solutions private limited',
    'HARVEY NASH INDIA PRIVATE LIMITED',
    'Celebron solutions private limited',
    'V.r.p. soft private limited',
    'Kaara info systems private limited',
    'Renovize it consulting india private limited',
    'Smartfolks info solutions private limited',
    'Ambidexter informatics private limited',
    'Furor technologies private limited',
    'Akashaganga technologies private limited',
    'Cyber space abacus private limited',
    'Sixsigma softsolutions private limited',
    'Vbizap soft solutions private limited',
    'Confluence consultancy services private limited',
    'Sunsmart technologies private limited',
    'Arcadia consulting services private limited',
    'Organicapex technologies private limited',
    'FRESHWORKS TECHNOLOGIES PRIVATE LIMITED',
    'Netensity information systems india private limited',
    'Sierra odc private limited',
    'PARK INTELLI SOLUTIONS PRIVATE LIMITED',
    'Eazibiz technologies private limited',
    'Mistral networks india private limited',
    'Corelynx solutions private limited',
    'Fidelus solutions private limited',
    'Wireless solutions private limited',
    'Kci computing private limited',
    'Star information technology communication and entertainment management private limited',
    'Morningstar india private limited',
    'Advanced iq solutions private limited',
    'Advanced infoquality private limited',
    'Colvill research private limited',
    'Pavitra technologies private limited',
    'Vriddhi logitech private limited',
    'I2eye interactive private limited',
    'Samvik infotek (nagpur) private limited',
    'Pavitra commodities & derivatives private limited',
    'Appex technologies private limited',
    'Yasham software services private limited',
    'Feat systems private limited',
    'Vertilex infotech private limited',
    'Geonet it mall private limited',
    'CATTLEYA TECHNOSYS PRIVATE LIMITED',
    'Swabhav techlabs solutions private limited',
    'Vera solutions private limited',
    'Opendr business services private limited',
    'Proteus technologies private limited',
    'Cima business solutions private limited',
    'Eclature technologies (india) private limited',
    'Telesis global solutions limited',
    'Amada soft india p ltd',
    'Global software solutions( tvl) private limited',
    'Thinksynq solutions private limited',
    'Glorieux infosystem private limited',
    'Letse software and services private limited',
    'Iglobal impact ites private limited',
    'Intersect innovations private limited',
    'QXPRESS INDIA PRIVATE LIMITED',
    'Sda outsourcing private limited',
    'Tuv rheinland (india) private limited',
    'Aquarian soft (india) private limited',
    'Andeva software services private limited',
    'DATA SYSTEM CONTROL & COMMUNICATION PRIVATE LIMITED',
    'TIGMAMINDS PRIVATE LIMITED',
    'Planet e-com solutions private limited',
    'Softone solutions private limited',
    'Gokul agro resources limited',
    'Omex oils india private limited',
    'Sreeja food products private limited',
    'ASSIGN INDUSTRIES LIMITED',
    'K r bakes private limited',
    'Kemps foods private limited',
    'Tree of life private limited',
    'Kathlekhan estates private limited',
    'Sushma namkeen private limited',
    'Danone narang beverages private limited',
    'Growdyne techzone services limited',
    'Alternate clothing company private limited',
    'Premier knit processors pvt ltd',
    'SREE AYYANAR SPINNING AND WEAVING MILLS PRIVATE LIMITED',
    'Trk textile india private limited',
    'Jayanthi garments and textiles private limited',
    'Pal fashions private limited',
    'Harness manufacturing & exports private limited',
    'Karnavati synthetics pvt ltd',
    'Saroj weavers private limited',
    'Kalpesh synthetics pvt ltd',
    'Kaytee corporation private limited',
    'Hilman tex private limited',
    'Jaisingh industries private limited',
    'Best knitting mills private limited',
    'GOWRI TEXTILES INDIA PRIVATE LIMITED',
    'Chennai home tex private limited',
    'Annapurna spintex private limited',
    'Pramod international private limited',
    'CANBERG GLOBAL SOURCING PRIVATE LIMITED',
    'Concorde knitwears private limited',
    'Lakshmi teja garments private limited',
    'Lakhani fashion (india) private limited',
    'Lakhani platinum lifestyle private limited',
    'ACTION ACCESSORIES AND APPARELS PRIVATE LIMITED',
    'Shabari cottons private limited',
    'Rasvick apparels private limited',
    'Varshraj exports private limited',
    'Ace point manufacturing company private limited',
    'Sai supreme textiles private limited',
    'Opus fashions private limited',
    'Mode creations international private limited',
    'Fashion suitings private limited',
    'Sisbro motor and workshop private limited',
    'Elitestring apparels private limited',
    'Womenza the design studio private limited',
    'Beantown lifestyle private limited',
    'AVIRAL CROP SCIENCE PRIVATE LIMITED',
    'Madras mechatronics private limited',
    'Lakhani hitech rubber private limited',
    'Hm megabrands private limited',
    'Walkon footwear india private limited',
    'Cedar decor private limited',
    'Pyramid retail services private limited',
    'Vibgyor packwell systems private limited',
    'Box pack paper industries private limited',
    'Kraft box containers (india) private limited',
    'HEXAGON PRINT & PACK PRIVATE LIMITED',
    'Ascend media private limited',
    'Noble research publishers private limited',
    'A.p.print n pack private limited',
    'VIRTUOUS FOUNDATION',
    'Health media publishing private limited',
    'Four square printers private limited',
    'Bansi publicity private limited',
    'Yourstory media private limited',
    'Mosco prints india private limited',
    'San printech private limited',
    'MULTI VISTA GLOBAL Private Limited',
    'Total print solutions private limited',
    'Mudrika sang bong foils (india) private limited',
    'ASTERIX REINFORCED LIMITED',
    'Dura build care private limited',
    'Ardor global private limited',
    'Welvin care private limited',
    'Advanced bio-agro tech limited',
    'Kam-vit chemicals private limited',
    'Ashland india private limited',
    'SIGNET CAPITAL PRIVATE LIMITED',
    'Ruk chemicals private limited',
    'Rosetta life care private limited',
    'ELLAA CHEMICALS LIMITED',
    'Auropol specialities private limited',
    'Airoil flaregas private limited',
    'IDEMITSU FINE COMPOSITES (INDIA) PRIVATE LIMITED',
    'Vivi orgo-chem industries pvt ltd',
    'Remi chem (india) pvt ltd',
    'Emco dyestuff private limited',
    'Eternal chemicals private limited',
    'Beezaasan explotech private limited',
    'S chems and allied producers private limited',
    'Narmada organics private limited',
    'Coramandel infrastructure private limited',
    'Dvs biolife limited',
    'The ethical pharmaceutical co. private limited',
    'NEXON PAINTS PRIVATE LIMITED',
    'Confident airlines (india) private limited',
    'Madurai trans carrier limited',
    'Air menzies international (india) private limited',
    'Prakasam airport private limited',
    'Turbo megha airways private limited',
    'SMART TRIP TOUR & TRAVELS LIMITED',
    'Viber mobility and hospitality private limited',
    'Airlift global carriers private limited',
    'AMNS PORTS PARADIP LIMITED',
    'Knott shipping private limited',
    'Sarayu maritime private limited',
    'Enercon logistics & solutions private limited',
    'Adel shipping & logistics limited',
    'Aj travels private limited',
    'Cargo international (india) private limited',
    'Seven h logistics private limited',
    'Wilson sandhu logistics (india) limited',
    'NARANG CONNECT PRIVATE LIMITED',
    'Abistar worldwide shipping and logistics private lmited',
    'Tci india limited',
    'BAPU',
    'S K3 EDUCATION PRIVATE LIMITED',
    'CONFIAVEL HOSPITALITY PRIVATE LIMITED',
    'KAIZEN TECHNIKS PRIVATE LIMITED',
    'KURUVI AND KURUVI RESORTS INDIA PRIVATE LIMITED',
    'ARYA FILAMENTS PRIVATE LIMITED',
    'BHARAT FINANCIAL INCLUSION LIMITED',
    'KHANDELWAL AUTOCORP PRIVATE LIMITED',
    'SANGHI FOUR WHEELS PRIVATE LIMITED',
    'DDEN TV PRIVATE LIMITED',
    'UPCELLENT TRAINING & CONSULTING PRIVATE LIMITED',
    'MAGNUM FITNESS PRIVATE LIMITED',
    'CRESCENT TECHNOLOGIES PRIVATE LIMITED',
    'CHETAK BUILDERS PVT LTD',
    'SPARTA HOLDINGS PRIVATE LIMITED',
    'AIC-CCRI FOUNDATION FOR ENTREPRENEURSHIPDEVELOPMENT',
    'NAFA BARTER PRIVATE LIMITED',
    'SYNECTIC INFOTECH PRIVATE LIMITED',
    'CHANDRA CREATIVE & CONTENT SOLUTIONS PRIVATE LIMITED',
    'OMNI ASTRA PRIVATE LIMITED',
    'ACON INNOVATIONS PRIVATE LIMITED',
    'PANVEL WAREHOUSING PRIVATE LIMITED',
    'DENEBOLA TOWNSHIP DEVELOPMENTS PRIVATE LIMITED',
    'DAIRYWELL ENGINEERING INDIA PRIVATE LIMITED',
    'MEEKSTAR BIZGOAL CONSULTANCY PRIVATE LIMITED',
    'V3CUBE APPLABS PRIVATE LIMITED',
    'LIBERTY WIRELESS TECHNOLOGIES PRIVATE LIMITED',
    'MARCELLUS INVESTMENT MANAGERS PRIVATE LIMITED',
    'TRIVENDENT TECHNOLOGIES PRIVATE LIMITED',
    'OJASVINLIFE REALTORS PRIVATE LIMITED',
    'HESTON BUILDERS PRIVATE LIMITED',
    'HOOLI HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'BISSBAY PRIVATE LIMITED',
    'FINAKON TECHNOLOGIES PRIVATE LIMITED',
    'PRINAV FABRIC INDIA PRIVATE LIMITED',
    'WYSTRO SOFT SOLUTIONS PRIVATE LIMITED',
    'REVERGON SOLUTIONS PRIVATE LIMITED',
    'SPACONS EPC PRIVATE LIMITED',
    'EDUSTREAM SOFTWARE PRIVATE LIMITED',
    'ROADMATICS TECHNOLOGIES PRIVATE LIMITED',
    'CINTRAM SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'INOVUM COMMUNICATION PRIVATE LIMITED',
    'EMS MACHINES GLOBAL INDIA PRIVATE LIMITED',
    'ALSEONAX PRIVATE LIMITED',
    'CLEMENTINE SECURITY SOFTWARE PRIVATE LIMITED',
    'INSTAZEN SOLUTIONS PRIVATE LIMITED',
    'ICOHORT BUSINESS VENTURES PRIVATE LIMITED',
    'ED SOLUTIONS INDIA PRIVATE LIMITED',
    'WORKLOOPER CONSULTANTS PRIVATE LIMITED',
    'ADAPPT INTELLIGENCE PRIVATE LIMITED',
    'MEDAS ENGGDESIGN PRIVATE LIMITED',
    'ORDERFUL LABS PRIVATE LIMITED',
    'ASCENDAS FLEXOFFICE INDIA PRIVATE LIMITED',
    'MCVU VENTURES PRIVATE LIMITED',
    'SHAANSTACK TECHNOLOGIES PRIVATE LIMITED',
    'FORCE MTU POWER SYSTEMS PRIVATE LIMITED',
    'G.G. TRONICS INDIA PRIVATE LIMITED',
    'DECENTRALISED ENERGY SYSTEMS INDIA PRIVATE LIMITED',
    'PREMIER APARTMENTS PRIVATE LIMITED',
    'ESS JAY GLOBAL VENTURES PRIVATE LIMITED',
    'GLORIFARM BOTANICALS PRIVATE LIMITED',
    'NBURY MEDIA PRIVATE LIMITED',
    'MEC EXPRESS PLUS PRIVATE LIMITED',
    'IMATURE EDTECH PRIVATE LIMITED',
    'DAVIS JACOBSON PRIVATE LIMITED',
    'SAVOY INTERNATIONAL PRIVATE LIMITED',
    'NHTC (INDIA) PRIVATE LIMITED',
    'SKYWAY I-NET SOLUTIONS PRIVATE LIMITED',
    'ACCIOJOB PRIVATE LIMITED',
    'DOOWON CLIMATE CONTROL INDIA PRIVATE LIMITED',
    'BEING ACCOUNTANT PRIVATE LIMITED',
    'ICEBLUE BIO PHARMA PRIVATE LIMITED',
    'GKN FACILITY MANAGEMENT SERVICES PRIVATELIMITED',
    'SAGED RETAIL SOLUTIONS PRIVATE LIMITED',
    'COHERENT RMC PRIVATE LIMITED',
    'MACHDATUM PRIVATE LIMITED',
    'UNBIASED P2P PRIVATE LIMITED',
    'EMPIRICAL DATA PRIVATE LIMITED',
    'QUINTPRO TECHNOLOGIES PRIVATE LIMITED',
    'BANTWAL WAREHOUSING PRIVATE LIMITED',
    'PLUSHVIE RETAIL PRIVATE LIMITED',
    'DRJ PLASTTECH PRIVATE LIMITED',
    'DE GRANDE SPORTS PRIVATE LIMITED',
    'BONHEUR EVENT MANAGEMENT PRIVATE LIMITED',
    'MINIMAX VIDEOS PRIVATE LIMITED',
    'AIECOSYS INNOVATIONS PRIVATE LIMITED',
    'BIZGO INDIA PRIVATE LIMITED',
    'DEVA PRESERVATION SERVICES PRIVATE LIMITED',
    'STARKWELT HEALTH SCIENCES PRIVATE LIMITED',
    'ROVIRI INNOVATIONS PRIVATE LIMITED',
    'ADLC CREATIONS PRIVATE LIMITED',
    'DHIYAN HEALTHCARE PRIVATE LIMITED',
    'SURCOT INDUSTRIES PRIVATE LIMITED',
    'YASHASVI RECYCLERS PRIVATE LIMITED',
    'GREENVEDIC AYURVEDA PRODUCTS PRIVATE LIMITED',
    'PAGE STUDIO PRIVATE LIMITED',
    'MULTIFLEX POLYFILMS PRIVATE LIMITED',
    'VAIGHAI CHEMICAL INDUSTRIES LIMITED',
    'Hemani industries limited',
    'Pvc converters india private limited',
    'Sri balaha chemicals private limited',
    'Ravi plant biotechnologies limited',
    'Elixir soltek private limited',
    'Godavari explosives ltd',
    'Bells organics pvt ltd',
    'Bio genex surgicals india pvt ltd',
    'Evantas biotec private limited',
    'MKP POLYMERS PRIVATE LIMITED',
    'Thor polymers private limited',
    'Deccan chronicle marketeers private limited',
    'Lesion care private limited',
    'MEDO SPECIA LABORATORIES PRIVATE LIMITED',
    'Kanoria chembond private limited',
    'Sparkle speciality coatings & trading private limited',
    'PROLIFE CHEMOPHARMA PRIVATE LIMITED',
    'BAJAJ HERBALS Limited',
    'Milan laboratories (india) private limited',
    'Glowderma lab private limited',
    'Quasar labs private limited',
    'Mahashakti rasayan pvt ltd',
    'Kemit chemicals pvt ltd',
    'Armech chemicals private limited',
    'Ratnamani bio-chemicals and pharmaceuticlas private ltd',
    'ARVEE LABORATORIES (INDIA) LIMITED',
    'JOHNSON & JOHNSON SURGICAL VISION INDIA PRIVATE LIMITED',
    'INDUS BIOTECH LIMITED',
    'Sun chem products private limited',
    'Chromo medcare private limited',
    'Aauracare pharmaceutical private limited',
    'Vhb medi sciences limited',
    'Cureworth drugs & intermediates private limited',
    'SHREE KRISHNAKANTA PHARMACEUTICALS AND FINE CHEMICALS PRIVATE LIMITED',
    'Mindlocus pharma private limited',
    'Rs bajaj organo chem private limited',
    'SANHOC LABS LIMITED',
    'Delhi aviation services private limited',
    'Saffron therapeutics private limited',
    'Azimuth drugs and pharmaceuticals private limited',
    'Senestech india private limited',
    'Sarda bio polymers private limited',
    'Prudent chemical technology solutions private limited',
    'Aap pharma technologies india private limited',
    'Ashtavaidyan thaikkattu mooss vaidyaratnam oushadhalayam private limited',
    'Metrochem api private limited',
    'Divinne sbr international private limited',
    'Vasudeva vilasam herbal remedies private limited',
    'SMITH & NEPHEW HEALTHCARE PRIVATE LIMITED',
    'Lokbeta laboratories private limited',
    'Kiran infertility centre private limited',
    'Vb medicare private limited',
    'Snowhite soaps and allied products private limited',
    'G d paridhan private limited',
    'Makevale acrylics private limited',
    'Floressence perfumes private limited',
    'Premier match company private limited',
    'Yuvraj fireworks private limited',
    'Novo krafts private limited',
    'Boudh Distillery Private Limited',
    'Shambhu vincom private limited',
    'Saps power equipments private limited',
    'Goodearth impex limited',
    'Krishna futuretrade private limited',
    'Steel mac controls private limited',
    'Koyo engineering india private limited',
    'Radhe krishna arts private limited',
    'PROZONE DEVELOPERS & REALTORS PRIVATE LIMITED',
    'Clar aqua private limited',
    'Stinging bees agency private limited',
    'Innovative enerpro private limited',
    'S K AGRI EXPORTS PRIVATE LIMITED',
    'Best practice washrooms private limited',
    'Rubik infotech private limited',
    'Ika yoga wear private limited',
    'Zeroone technologies private limited',
    'Lodestar precious jewels private limited',
    'Silverstone elastomers private limited',
    'Indo african industries private limited',
    'Patodia fabrics limited',
    'Delight services and maintenance private limited',
    'PKH VENTURES LIMITED',
    'Peace park hotels private limited',
    'Radheshyam hotels pvt ltd',
    'Gateway gourmet private limited',
    'Prashanth hotels private limited',
    'Rs hospitality services limited',
    'COUNTERCULTURE ENTERTAINMENT PRIVATE LIMITED',
    'Drn hospitalities private limited',
    'Munnar hospitalities private limited',
    'Sunrise resort and health care private limited',
    'Oxbow properties private limited',
    'Mirah hospitality & food solutions private limited',
    'Maredia resorts private limited',
    'Sidman and g. hospitality private limited',
    'Sumix club and resorts private limited',
    'Splendour country club and resorts private limited',
    'Magic cuisines hospitality private limited',
    'Vedansh hospitality & resorts private limited',
    'Herbal hills wellness resorts private limited',
    'Sitaram indraj agrawal resorts private limited',
    'Mangii cafes private limited',
    'Hotel mass private limited',
    'Minerva resorts private limited',
    'M.g.m.diamond beach resorts private limited',
    'Pih finvest company limited',
    'Jungle lodges and resorts limited',
    'Aarusha homes private limited',
    'VISHWATEJ VENTURES PRIVATE LIMITED',
    'Zann commodities private limited',
    'White castle hospitality private limited',
    'Palate foods private limited',
    'Paul logistics (india) private limited',
    'Lotus integrated logistics private limited',
    'Ganpati carrying corporation limited',
    'Fame global logistics private limited',
    'Shyam salasar logistic private limited',
    'GLOBE INTERNATIONAL CARRIERS Limited',
    'Advance scientific equipments private limited',
    'Nautex maritime private limited',
    'EXEMPLAR INDUSTRIES PRIVATE LIMITED',
    'Micro logistics (india) private limited',
    'Star aviation private limited',
    'Travsol worldwide private limited',
    'Securex logistics private limited',
    'Enriching journeys private limited',
    'B. s. shipping private limited',
    'ROYALMINT LEISURE PRIVATE LIMITED',
    'CARGOVISION AVIATION INDIA PRIVATE LIMITED',
    'Freightbridge logistics private limited',
    'Radiant maritime india private limited',
    'Shipping world services private limited',
    'Afford freight services private limited',
    'Kms logistics & shipping private limited',
    'Shakti vacations private limited',
    'Omega travel consultants private limited',
    'Via logistics private limited',
    'Vital logisitics private limited',
    'ATLANTIC AIR & OCEANFREIGHT SERVICES PRIVATE LIMITED',
    'Magnum freight private limited',
    'Bwc logistics private limited',
    'Ans express services private limited',
    'Victory freight services private limited',
    'Sealand carriers & logistics private limited',
    'Opal asia line (india) private limited',
    'Annapoorani cold storage private limited',
    'Hsm international private limited',
    'Savani transports private limited',
    'Edge logistics private limited',
    'Navalmar shipping (india) private limited',
    'Oscar marine services private limited',
    'Csm tech and logistics private limited',
    'Hwt travels private limited',
    'Pragema travels private limited',
    'Tripplanner travel shop private limited',
    'Viva destinations and tours private limited',
    'Infosolz consultancy services private limited',
    'S.K.SINGHI & CO (CONSULTANTS) PRIVATE LIMITED',
    'Primus global solutions private limited',
    'Pnl engineering consultants private limited',
    'Sampath kumar associates private limited',
    'ADITYA BIRLA SCIENCE AND TECHNOLOGY COMPANY Private Limited',
    'Sat infotech private limited',
    'Infiquity auto technologies private limited',
    'Astha energy services private limited',
    'Vasavi power services private limited',
    'Centre for asia pacific aviation india private limited',
    'New edge infrastructure private limited',
    'Dash inspectorate private limited',
    'Kellogg brown & root engineering & construction india private limited',
    'Nigoka engineering works private limited',
    'Ceramed engineers limited',
    'Domex technical information private limited',
    'Grit architectural consultancy private limited',
    'Archetype consultants (india) private limited',
    'Crayons properties designer private limited',
    'Mutual engineering private limited',
    'Unique electro engineers private limited',
    'K s m consultants private limited',
    'Adonis staff services private limited',
    'Synapse consultants (india) limited',
    'DEVIKA RESOURCES PRIVATE LIMITED',
    'MINERALS LAB SERVICES PRIVATE LIMITED',
    'Omni media communications private limited',
    'Cheil india private limited',
    'Autumn advertising private limited',
    'Options communications (india) private limited',
    'Primetime international services private limited',
    'Havas worldwide india private limited',
    'Batey india private limited',
    'Stc india private limited',
    'Mirchi adlabs private limited',
    'Mediahouse marketing and advertising private limited',
    'Matex india private limited',
    'Ferrous alloy forgings private limited',
    'Sri nath ji ispat limited',
    'Raj impex private limited',
    'Security information systems india limited',
    'Telerex etech private limited',
    'Loesche india private limited',
    'Rgv fininvest private limited',
    'Dimension next infocom private limited',
    'Ykk india private limited',
    'Simec indus resources private limited',
    'E m technologies india private limited',
    'Rototron impex private limited',
    'Emc technology india private limited',
    'FIRST OBJECT INDUSTRIES PRIVATE LIMITED',
    'Mediviz pharma services private limited',
    'Sarvpriya finvest private limited',
    'Meja urja nigam private limited',
    'Insight plm consulting private limited',
    'Elk education consultants private limited',
    'White eagle entertainment private limited',
    'Nanobills online services private limited',
    'Sarva info solutions private limited',
    'Indian detective agency private limited',
    'Jmv technosol private limited',
    'Gift power company limited',
    'Gift waste management services limited',
    'Gift water infrastructure limited',
    'Iss (india) consultancy services private limited',
    'Arora broadcasting corporation private limited',
    'Firstbase media private limited',
    'Himalaya steel mill services private limited',
    'Pjr cdm (india) private limited',
    'Valueleaf services (india) private limited',
    'Redwood associates business solutions private limited',
    'Azim premji trust services private limited',
    'Admire architects private limited',
    'Elevate business solutions private limited',
    'Mila star retail private limited',
    'Bluemind solutions private limited',
    'RADARR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Talent mosaic private limited',
    'E-info ventures india private limited',
    'Kns concrete products private limited',
    'Amitus interior solutions private limited',
    'Criterion networks india private limited',
    'Excubator consulting private limited',
    'Shumee toys private limited',
    'Riskonnect services private limited',
    'Jetpack machines private limited',
    'Distichemi process engineering private limited',
    'DVARA HOLDINGS',
    'Technocraft architectural project management private limited',
    'Maestros electronics & telecommunications systems limited',
    'Absotherm energy solutions private limited',
    'Sahej entertainment private limited',
    'Matchless tele systems private limited',
    'Petrikor refreshing healthcare solutions private limited',
    'Monk payment services private limited',
    'Jaypee forge private limited',
    'Bizerba india private limited',
    'Aarav industries private limited',
    'Varun pressings private limited',
    'Shantilal and company private limited',
    'Fai engineering private limited',
    'G m engineering solutions private limited',
    'Gem granites private limited',
    'SAMICRON PRECISION TECHNOLOGIES PRIVATE LIMITED',
    'B. r. metal and alloys (guj) private limited',
    'HYDRO BS INDIA PRIVATE LIMITED',
    'Progate automations private limited',
    'Minami metals private limited',
    'Accura weldrods kovai private limited',
    'Dave engineers private limited',
    'Sap industries limited',
    'Falbin engineering private limited',
    'Indamer aviation private limited',
    'Turbotech energy services international private limited',
    'Emdep test boards private limited',
    'Nachiket engineering private limited',
    'Indira damper industries private limited',
    'Imi norgren herion private limited',
    'Swan turbine services private limited',
    'Perfect actuators and controls private limited',
    'Francois compressors india private limited',
    'Nirmal pumps private limited',
    'KEC BEARINGS PRIVATE LIMITED',
    'Danieli india limited',
    'Kemco elevators private limited',
    'Kijeka engineers private limited',
    'Groth continental manufacturing private limited',
    'Vraj machinetools private limited',
    'Devi technocraft private limited',
    'Prax aircon private limited',
    'Signum fire protection (india) pvt ltd',
    'Newbharat fire protection system private limited',
    'Advent envirocare technology pvt ltd',
    'Transline conveyors private limited',
    'S.mark oil field engineering private limited',
    'Peenya fine comp private limited',
    'Murali engineering private limited',
    'Accord enviro systems (india) private limited',
    'ASMPT INDIA PRIVATE LIMITED',
    'Rions india biotech solutions private limited',
    'Ritebanc green agro solutions private limited',
    'Ultra febtech private limited',
    'Agro engineers private limited',
    'Global engi-tech private limited',
    'Mactech engineers private limited',
    'Marvel tools and accessories private limited',
    'Nikki india fuel systems private limited',
    'Caterpillar india private limited',
    'Eurotrack systems india private limited',
    'Phoenix dairy tech solutions private limited',
    'Bestobell valves (india) private limited',
    'Mallik multitechnologies private limited',
    'Amp rose packaging private limited',
    'Modtech equipments private limited',
    'Precision scalemodels india private limited',
    'Amt enviraclean technologies private limited',
    'DOIT INDUSTRIES INDIA PRIVATE LIMITED',
    'Ellume solar private limited',
    'Ylm tube solutions and service private limited',
    'Shree-laxmi engineering private limited',
    'Advance systems controls (india) private limited',
    'Cams technology limited',
    'Sun n wind renewables private limited',
    'Gluetech engineering private limited',
    'Navitas worldwide (i) private limited',
    'Verder scientific private limited',
    'Balu auto components private limited',
    'Indira industries private limited',
    'Inventure engineering india private limited',
    'Swadeshi machine tools pvt ltd',
    'UNISPIN CARD CLOTHING INDIA PRIVATE LIMITED',
    'Jeanologia india textile machines private limited',
    'Millenium caribonum limited',
    'Manometer (india) private limited',
    'Enproducts private limited',
    'Bestmen welders private limited',
    'Ognibene india private limited',
    'Kongsberg automotive (india) private limited',
    'Kjk meister honen private limited',
    'Laxmi lahoti engineering ventures private limited',
    'Perfura technologies (india) private limited',
    'Konark combustion private limited',
    'Ray force greentech private limited',
    'Excess renew tech private limited',
    'Sparrow television private limited',
    'Babin technologies private limited',
    'Intellicom systems private limited',
    'Nestlinks home appliances private limited',
    'Nippon thermostat (india) limited',
    'Viraat technology labs private limited',
    'Hi-tech computers services (nashik) private limited',
    'Satya telecom private limited',
    'Skylink telecommunications private limited',
    'Chennai cable vision network private limited',
    'Ybu investment advisors private limited',
    'Surmount business advisors private limited',
    'Kataria infrastructure private limited',
    'Ashutosh finsec limited',
    'Praveen laboratories private limited',
    'Trishla finance limited',
    'PRITHVIRAJ RESTAURANTS LIMITED',
    'Shank investments private limited',
    'Intensive fiscal services private limited',
    'Chintalapati holdings private limited',
    'Taurus hire purchase private limited',
    'KDS CAPITAL PRIVATE LIMITED',
    'NECTAR LABORATORIES PRIVATE LIMITED',
    'Manba fincorp private limited',
    'INFI MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'Ebasco finance co pvt ltd',
    'The interactors investment participations india private limited',
    'Centaurus trading and investments private limited',
    'Bipiraj finance pvt ltd',
    'M b trade-link private limited',
    'Paresh k mehta investment pvt ltd',
    'Frontier medi-tech (india) private limited',
    'Chang ching investments private limited',
    'Reliance securities limited',
    'Vijayajyothi investmentsandagencies private limited',
    'Della enclave private limited',
    'Shelter (india) holdings private limited',
    'Si fintech private limited',
    'Taurus treasury management services private limited',
    'ANAR INSURANCE BROKERS LIMITED',
    'ETHOS WEALTH PRIVATE LIMITED',
    'Angelprime strategies private limited',
    'Mission holdings private limited',
    'Rvt holdings private limited',
    'Kesri shares and securities private limited',
    'Moistclay broking private limited',
    'Subhsan propman private limited',
    'Khetan business corporation pvt ltd',
    'Getner trading and investment pvt ltd',
    'Couriers association of india',
    'Sykes and ray equities (india ) ltd',
    'Nitiket investments private limited',
    'Shri tirupati vighnahar consultancy private limited',
    'Aarshi investment private limited',
    'Bridge equities private limited',
    'Taurus corporate advisory services limited',
    'Taurrus finsec private limited',
    'Oasis share trading private limited',
    'Veda equity services private limited',
    'Pacific properties pvt ltd',
    'Kakaria fintrade services private limited',
    'Gras associates private limited',
    'Ceepee consultants private limited',
    'Equilink capital management services limited',
    'Phoenix arc private limited',
    'Prosales financial services private limited',
    'Investocap advisors private limited',
    'Adheswara (exports) private limited',
    'System-ethic insurance brokers private limited',
    'Centurion promoters and developers private limited',
    'Sdu estates private limited',
    'Nasscon infra private limited',
    'Arpanna properties private limited',
    'Darvesh infrastructures private limited',
    'Naval development and reality private limited',
    'Kopra estate private limited',
    'Norman estates private limited',
    'O2 supply incubator private limited',
    'Sri swastik home land agencies private limited',
    'Anvam properties private limited',
    'Prijyoti projects and consultancy services private limited',
    'Celebrity lifespace private limited',
    'Right value infraproperties private limited',
    'Pdpt properties private limited',
    'Canyon estates private limited',
    'Ambika infrabuild pvt. ltd.',
    'Saksham shelters private limited',
    'Abhijay infrastructure private limited',
    'Acreage builders private limited',
    'Yasoraminfra developers private limited',
    'Gigeo construction company private limited',
    'Vyapti properties private limited',
    'Silver shine builders private limited',
    'STAY HOMELY HOSPITALITY PRIVATE LIMITED',
    'Govind kripa build avenue private limited',
    'Gkb infrastructures private limited',
    'CASAGRAND PREMIER BUILDER LIMITED',
    'Adler enterprises private limited',
    'Bestmen realtors private limited',
    'Merlin greens properties pvt ltd',
    'Rakesh builders private limited',
    'Greentop realators private limited',
    'Ramky estates and farms limited',
    'Asd infratech private limited',
    'Moonstone realcon private limited',
    'Adinath landhauser private limited',
    'ARLIGA NORTH STAR PROJECTS PRIVATE LIMITED',
    'Se transstadia private limited',
    'YEPSHOW EXPERIENTIAL MARKETING PRIVATE LIMITED',
    'Grey faalcons search private limited',
    'Bizminder advisory group private limited',
    'Alisier enterprises private limited',
    'Campbell shipping private limited',
    'Just4u financial services private limited',
    'Mantrana maritime advisory private limited',
    'Nalanda capital india advisors private limited',
    'H s pathology private limited',
    'Yellow umbrella services private limited',
    'George circulation (i) private limited',
    'Igaming technical solutions private limited',
    'Unimo exports private limited',
    'HARMONEY FINSERV INDIA PRIVATE LIMITED',
    'Dhwaja commodity services private limited',
    'China petroleum pipeline bureau india private limited',
    'New jack printing press private limited',
    'Fitness and fairies dancewear private limited',
    'E-sutra chronicles private limited',
    'Advance tech services private limited',
    'Twenty first testing and services private limited',
    'Pacific accounting services private limited',
    'Flowstar engineering private limited',
    'Bsr holdings private limited',
    'Kromtek systems india private limited',
    'Amtek precision technology (india) private limited',
    'ZYREX ENTERPRISE PRIVATE LIMITED',
    'Mira inform pvt ltd',
    'Roche products (india) private limited',
    'Adroit industries (india) limited',
    'Bramhadev consultancy private limited',
    'Ace polybond private limited',
    'Franchising association of india',
    'Saibaba information technologies private limited',
    'A.s. moloobhoy & sons private limited',
    'Pns upkeep services private limited',
    'Nine enterprises private limited',
    'Bonace engineers private limited',
    'Fillon technologies india private limited',
    'Puregold trading company private limited',
    'Taylormade outsourcing solutions private limited',
    'COLLINSON LOYALTY & BENEFITS PRIVATE LIMITED',
    'Shirley technologies private limited',
    'Freshfab textiles private limited',
    'Paytronic network private limited',
    'Cfr engine services private limited',
    'Labdhi wealth care private limited',
    'Emerald vitro muro private limited',
    'BLUEFIELD MULTISERVICES PRIVATE LIMITED',
    'VARSO MEDIA PRIVATE LIMITED',
    'Access platform equipments limited',
    'Excellect facility management private limited',
    'Dainik consultancy private limited',
    'Concept packaging international private limited',
    'NETSCOUT SYSTEMS INDUSTRIAL PRIVATE LIMITED',
    'Check n click learning and technologies private limited',
    'Cfosme corporate services private limited',
    'Narayani corrubox private limited',
    'Flin technologies private limited',
    'Syncore consulting private limited',
    'Vogue fashion fund india',
    'Thome shipping (india) private limited',
    'Nandan equipment services private limited',
    'SHINKA TECHNOLOGIES PRIVATE LIMITED',
    'Kaydee advertising private limited',
    'Emerge finvest services private limited',
    'CX VENTURES PRIVATE LIMITED',
    'Hex cable accessories private limited',
    'Perito analytical india private limited',
    'BRILINO SOLUTIONS PRIVATE LIMITED',
    'Nineonenine integrated solutions private limited',
    'Triature digital marketing private limited',
    'Janzin container lines private limited',
    'Elespry fashion private limited',
    'Magic pictures and entertainments private limited',
    'Pune fashion week private limited',
    'Reddvise realty advisors private limited',
    'Shree sai fleet services private limited',
    'Extrapreneurs india private limited',
    'Pabrai india private limited',
    'Cv designers india private limited',
    'Csr talent staffing private limited',
    'Trans aviacons private limited',
    'Instillmotion consulting private limited',
    'Ramco agencies private limited',
    'Bashgo maintenance services private limited',
    'Wco consultants private limited',
    'Wensar weighing scales limited',
    'Vdime innovative works private limited',
    'Tirwin management services private limited',
    'NIPPON STEEL CHEMICAL & MATERIAL INDIA PRIVATE LIMITED',
    'Baron minerals private limited',
    'Jjb freight logistics private limited',
    'Chola power private limited',
    'Samanta communications private limited',
    'Yorozu jbm automotive tamil nadu private limited',
    'Graziano trasmissioni india private limited',
    'Suyash engine comp private limited',
    'Vizag general cargo berth private limited',
    'Porttrade shipping agencies private limited',
    'Legend maritime private limited',
    'RCC LIMITED',
    'HYUNDAI TRANSYS LEAR AUTOMOTIVE INDIA PRIVATE LIMITED',
    'Toyota kirloskar auto parts private limited',
    'Manoj motors private limited',
    'Vega auto accessories private limited',
    'Kokama international private limited',
    'Dtale decor private limited',
    'Aakar geomatrix private limited',
    'SONANI INDUSTRIES PRIVATE LIMITED',
    'Parker bullion private limited',
    'Apollo gold vatakara private limited',
    'Tikamdas motiram jewellers private limited',
    'Jahanvi gems private limited',
    'Nikshe multiproducts private limited',
    'Kapoor books and stationary company private limited',
    'Prolite autoglo limited',
    'Unilite electrix private limited',
    'BOCK COMPRESSORS INDIA PRIVATE LIMITED',
    'Valecha power limited',
    'Grid power conversion private limited',
    'Nextgen city energy private limited',
    'Pipavav energy private limited',
    'Nexzone utilities private limited',
    'Sma solar india private limited',
    'Sks vidhyut private limited',
    'TRANQUIL FOREX SOLUTIONS PRIVATE LIMITED',
    'Gaston energy india private limited',
    'Astonfield solar (ajmer) private limited',
    'Powertrac solar projects limited',
    'Nidhi wind farms private limited',
    'Enerzea power solution private limited',
    'Cbc solar technologies private limited',
    'Aan energies private limited',
    'DLF IT OFFICES CHENNAI PRIVATE LIMITED',
    'Mithalal shelter and power limited',
    'Sankalpan design derivatives private limited',
    'Hyperion green energy india private limited',
    'Phlox energy private limited',
    'Vyomaa energy private limited',
    'Matrix water management private limited',
    'Nextgen city water management private limited',
    'Ng water systems private limited',
    'Mechmann water solution systems private limited',
    'Greeno projects private limited',
    'Wonderkids india private limited',
    'Sea-crest developers private limited',
    'Avechi constructions private limited',
    'Savera realtors private limited',
    'Aerens goldsouk projects (hissar) private limited',
    'MARUTINANDAN CAPITAL PRIVATE LIMITED',
    'Balaji adlabs private limited',
    'Shree umiya infrastructure pvt ltd',
    'Palacious infrastructure private limited',
    'Palacious projects private limited',
    'M. r. shah construction private limited',
    'Ethenic buildwell private limited',
    'Ethenic realtors private limited',
    'Wire developers private limited',
    'Bava infrastructure developers private limited',
    'Naman construction private limited',
    'Earth pillar construction private limited',
    'Golden guild properties private limited',
    'Omshivam buildcon private limited',
    'R & B INFRA PROJECT LIMITED',
    'Pushpdeep properties private limited',
    'Element developers private limited',
    'Advantage raheja realty private limited',
    'Nexzone land private limited',
    'Nextgen land private limited',
    'Bbj verona constructions private limited',
    'Sadguru buildspaces private limited',
    'Vaga industries private limited',
    'AVIOR MAJESTIQUE TOWNSHIP PRIVATE LIMITED',
    'Aicon intalia realty private limited',
    'Urban landmarks private limited',
    'SRAVANTHI CONSTRUCTIONS PRIVATE LIMITED',
    'RISHI',
    'S ACADEMY PRIVATE LIMITED',
    'The rishabh velveleen limited',
    'GURUDEV MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'Vms fabrics private limited',
    'Vishwamaya syntex private limited',
    'Dhama innovations private limited',
    'Attarchand trading company private limited',
    'Jiwarajka polyster private limited',
    'Baldev textile mills private limited',
    'Vikram ahuja exports private limited',
    'Shaym ahuja carpets private limited',
    'Gm embroidery private limited',
    'Spica technitex private limited',
    'Synergy lifestyles private limited',
    'Ratanshi kheraj sarees private limited',
    'Dasna developers private limited',
    'Usha spincoat private limited',
    'Anora fashions private limited',
    'Kaurub exports limited',
    'Jij apparels private limited',
    'Kuraray india private limited',
    'Sweet dreams loungewear (india) private limited',
    'Xsis promotions (india) private limited',
    'Jiwarajka industries private limited',
    'Fashion lifestyles (india) private limited',
    'Pratibha fabrics limited',
    'Saertex india private limited',
    'Jaagrit fashions private limited',
    'Laado textile private limited',
    'Sanjay products private limited',
    'Anutone acoustics limited',
    'Larkad paper industries private limited',
    'K and s packaging dynamics private limited',
    'Soft touchline products private limited',
    'Clear media (india) private limited',
    'Monga strayfield private limited',
    'Institute of language management private limited',
    'Aladin advertising private limited',
    'Rich offset (india) private limited',
    'Orange printers private limited',
    'Print retail india private limited',
    'Jeevandeep prakashan private limited',
    'Instill design private limited',
    'GNANAKSHI SUPPLY CHAIN PRIVATE LIMITED',
    'Techno graphic services india private limited',
    'Colour dot (madras) private limited',
    'MICRO INFRATECH PRIVATE LIMITED',
    'Turmeric vision private limited',
    'Icconol properties private limited',
    'Taraa lpg bottling private limited',
    'Gujarat pickers industries limited',
    'Zas chem india private limited',
    'Vincit lifesciences private limited',
    'Good herb therapeutics private limited',
    'Visen industries limited',
    'Zenith speciality private limited',
    'Shuban pharmaceuticals private limited',
    'Eco fluids cheme (india) private limited',
    'Ami riddhi chem private limited',
    'Smi newquest india private limited',
    'FINE ORGOKEM PRIVATE LIMITED',
    'Clearsynth labs limited',
    'Sakam fine chem private limited',
    'THE LAKE PALACE HOTELS & MOTELS PRIVATE LIMITED',
    'Gayatri hi-tech hotels limited',
    'FRESH AND HONEST CAFE PRIVATE LIMITED',
    'SIPANI SOFT STONES PRIVATE LIMITED',
    'Ksk foods private limited',
    'Adrian hotels private limited',
    'Chesterton hotels private limited',
    'Jespa shipping agencies private limited',
    'Seven islands shipping limited',
    'Seaways offshore marine india private limited',
    'Collicare logistics india private limited',
    'Air titan (india) private limited',
    'Camlon freight forwardings (india) private limited',
    'Buddy aviation private limited',
    'Gmr airport developers limited',
    'Khyaath design holidays private limited',
    'Bharath international travels (mysore) private limited',
    'Magadh transports private limited',
    'Inchcape shipping services india private limited',
    'Oocl logistics (india) private limited',
    'Afford logistics private limited',
    'GOPICO PROJECTS PRIVATE LIMITED',
    'Rarefield shipping agency private limited',
    'Gallant freight and travels p.ltd.',
    'Siddhivinayak clearing and carriers private limited',
    'ANUJ PHARMACHEM PRIVATE LIMITED',
    'JEENA CRITICARE LOGISTICS PRIVATE LIMITED',
    'Surface cargo services private limited',
    'Toll global forwarding (india) private limited',
    'Grace worldwide movers private limited',
    'Concord express logistics (india) private limited',
    'Hind freight services private limited.',
    'Exim logistics private limited',
    'Transystem logistics international private limited',
    'Classic car rental services private limited',
    'Reliable trans and impex services private limited',
    'Ekata shipping private limited',
    'Bridges worldwide (india) private limited',
    'Rarefield shipyard private limited',
    'Seal logistics limited',
    'Sun and moon travels (india) private limited',
    'Nomadier escapades private limited',
    'Vishwas shipping private limited',
    'VISVAS VOYAGES (INDIA) PRIVATE LIMITED',
    'Compact travels pvt ltd',
    'Rank logistics private limited',
    'Soulscapes destinations private limited',
    'Srk holidays private limited',
    'Odyssey vacations private limited',
    'Silver tone tours private limited',
    'Imad travel private limited',
    'Tourlandish online ventures private limited',
    'Mgm entertainments private limited',
    'FLY ALBATROSS TRAVEL & TOURS PRIVATE LIMITED',
    'Hidesign india private limited',
    'Rarefield shipping private limited',
    'Aashirvad shipping and allied private limited',
    'Urmi tours and travels private limited',
    'Sankyu india logistics & engineering private limited',
    'Blue planet logistics private limited',
    'Zoomcar india private limited',
    'Manlog logistics (south india) private limited',
    'Bombay allied contractors private limited',
    'Paras clearing and forwarding agencies private limited',
    'Sharda clearing and forwarding agency private limited',
    'Millennium logistics private limited',
    'Apt international shipping private limited',
    'Komplete supply chain solutions private limited',
    'Fec global logistics private limited',
    'Orhan shipping private limited',
    'Dnx cargo india private limited',
    'GNV LOGISTICS PRIVATE LIMITED',
    'W.W. SHIPPING & FORWARDING PRIVATE LIMITED',
    'Sandhhya shipping services private limited',
    'CAPRICORN SCM PRIVATE LIMITED',
    'Hexa communications private limited',
    'Station satcom private limited',
    'Lamhas satellite services limited',
    'Digi anand network private limited',
    'Uni-com enterprises india private limited',
    'Janya converged solutions limited',
    'Digi jpr networks private limited',
    'Digi shimoga network private limited',
    'Digi east delhi network private limited',
    'Digi western network private limited',
    'Digi konkan network private limited',
    'EK ONKAR NETWORKS PRIVATE LIMITED',
    'Digi navi mumbai network private limited',
    'Visiontek telesystems private limited',
    'Radius m2m synergies private limited',
    'Spoorthi communications private limited',
    'Pnb investment services limited',
    'Tamarai selvi finance private limited',
    'Ecs financial services (india) private limited',
    'DLL GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'Indian railway finance corporation limited',
    'Navratra distributors private limited',
    'Glory financial consultants private limited',
    'Retouch reform engineering private limited',
    'Progressive manpower private limited',
    'Infinite staffing solutions private limited',
    'Tra-augment people.solutions private limited',
    'SAFEGUARD INDUSTRIAL & SECURITY SERVICES PRIVATE LIMITED',
    'Sng security services private limited',
    'Best career leap private limited',
    'Varna grafics private limited',
    'Etap automation private limited',
    'National payments corporation of india',
    'Freedom wealth solutions private limited',
    'Bluet enterprises private limited',
    'Sil retails private limited',
    'Green valley corporate consultants private limited',
    'Real time interactive media private limited',
    'Technology &engineering solutions private limited',
    'Pavitra associates private limited',
    'Future destination and careers private limited',
    'Scoregetter test preparation private limited',
    'Premier supply chain management solutions private limited',
    'K-bit brave sourcing private limited',
    'Indian armour systems private limited.',
    'VEGAZVA PRODUCT ENGINEERING PRIVATE LIMITED',
    'Senior india private limited',
    'Virtuosos solutions private limited',
    'Nav jyoti tourism private limited',
    'Aza engineers private limited',
    'Silver vine capital private limited',
    'Talentmint consulting private limited',
    'Stellarrays consulting private limited',
    'Gbs holdings private limited',
    'Home fundraising (india) private limited',
    'Equinox mahimtura venture private limited',
    'Medibiz solutions private limited',
    'Aplus enterprises pvt ltd',
    'Sadhana technical works private limited',
    'Delta filters and separators private limited',
    'Baerlocher india additives private limited',
    'Messe frankfurt trade fairs india private limited',
    'Moody international (india) private limited',
    'D p m c k management services private limited',
    'Nd s art world private limited',
    'Nabard consultancy services private limited',
    'REVVITY HEALTHCARE (INDIA) PRIVATE LIMITED',
    'Versatile electrical services private limited',
    'Merint molecular imaging private limited',
    'Neeshal merchandising private limited',
    'Chloris enterprises (india) private limited',
    'Media magic retail private limited',
    'J. P. PLASCHEM PRIVATE LIMITED',
    'Rdp television company private limited',
    'Pranjee assets holding private limited',
    'BNP INTERIORS PRIVATE LIMITED',
    'Mount meru india private limited',
    'Parth facade solutions private limited',
    'Zs microtech private limited',
    'Fc marketing services private limited',
    'ANCHOR DEFENCE INTEGRATOR PRIVATE LIMITED',
    'Turner consulting and management services private limited',
    'Chamberz international (india) private limited',
    'India business solutions (ibs) private limited',
    'Hiq techknowworks private limited',
    'Cheftalk food and hospitality services private limited',
    'Auro controls private limited',
    'Proconvis consultants private limited',
    'Carrokay solutions private limited',
    'Roedl & partner consulting private limited',
    'Samcruz consulting private limited',
    'Gp strategies india private limited',
    'Pro-lite engineers private limited',
    'Agqr certifications private limited',
    'Mansion student(india) private limited',
    'Walla walla logistics private limited',
    'Sevendotz building solutions private limited',
    'My rain irrigation private limited',
    'Associated auto solutions international private limited',
    'M. tech informatics limited',
    'Podar education network private limited',
    'Operation blessing india',
    'Red education india private limited',
    'K s academy private limited',
    'Vedmath academy private limited',
    'Bangalore school of english private limited',
    'Muthoot m george institute of technology',
    'Freedom charter services private limited',
    'Mnemonic education private limited',
    'Royal skytech aviation private limited',
    'Asia pacific flight training academy limited',
    'Stem academy private limited',
    'Paul asset consultant private limited',
    'Pluto education private limited',
    'Seer akademi private limited',
    'Rishi vocational education private limited',
    'Tutelmids educational solutions private limited',
    'Coramandel energy private limited',
    'Rvk energy (rajahmundry) private limited',
    'Danu wind parks private limited',
    'Nsl renewable power private limited',
    'Vaayu renewable energy (meghna) private limited',
    'India gas solutions private limited',
    'Vaayu renewable energy (mahanadi) private limited',
    'Vaayu renewable energy (netravati) private limited',
    'Vaayu renewable energy (tapti) private limited',
    'Clean sustainable solar energy private limited',
    'Mahabubnagar energy projects private limited',
    'Rangareddy energy projects private limited',
    'Eyar technologies private limited',
    'Magnate builders private limited',
    'Lotus infraconstruction private limited',
    'Baba projects private limited',
    'Mysore realty private limited',
    'Qvc star realty private limited',
    'TRUE NORTH VENTURES PRIVATE LIMITED',
    'Garware holdings limited',
    'Ford estate private limited',
    'Creative rentals private limited',
    'Frontier resources private limited',
    'Blue sky retail private limited',
    'Cosmic rentals private limited',
    'Esharpedge solutions private limited',
    'Health innovation solutions private limited',
    'BR TECHNOLOGIES PRIVATE LIMITED',
    'H&s software development and knowledge management centre private limited',
    'N.k.e. electronics and communications private limited',
    'Jsw steel processing centres limited',
    'Malnad projects private limited',
    'Emil coal mining limited',
    'Goldline milkfood and allied industries limited',
    'Total food solutions private limited',
    'Vanguard clothing company private limited',
    'Srihari exports private limited',
    'Dankuni food products private limited',
    'Coromandel sqm (india) private limited',
    'Alidac Pharmaceuticals Limited',
    'Indu formulations private limited',
    'Sanofi pasteur india private limited',
    'Gsd paints private limited',
    'Omni wellness and nutrition limited',
    'Zion steel limited',
    'Indian metals and carbides limited',
    'Universal comfort products limited',
    'Marvel sanifit private limited',
    'Shikargah engineers private limited',
    'Nagpur transwell power private limited',
    'Universal lifeline private limited',
    'M.h. electronics private limited',
    'Ferro agro park private limited',
    'SURAT LOGISTIX INDIA PRIVATE LIMITED',
    'Sicgilsol gases private limited',
    'Ranias garden and hotels private limited',
    'Shuptashringi estates private limited',
    'Rajam estates private limited',
    'Cosmo realmart private limited',
    'Rose farms (delhi) private limited',
    'Godrej buildcon private limited',
    'Sai brilliance realty private limited',
    'Godrej landmark redevelopers private limited',
    'Tigerhill merchants private limited',
    'Radiant coral digital technologies private limited',
    'KANANI TRADING PRIVATE LIMITED',
    'Pratik merchants private limited',
    'Hu software india private limited',
    'Dhanlakshmi vyapaar private limited',
    'Intersil analog services private limited',
    'Grant investrade limited',
    'Nichelon infotech services private limited',
    'RELIANCE JIO MESSAGING SERVICES LIMITED',
    'Interroll drives and rollers india private limited',
    'Ncs renewable energies limited',
    'Fasto engineering private limited',
    'SAGAR CEMENTS (R) LIMITED',
    'Rumao constructions pvt.ltd.',
    'Turakhia properties private limited',
    'DUSHYANT GHATALIA DESIGNS PRIVATE LIMITED',
    'Astha developers and organisors pvt ltd',
    'Trisa jewellery private limited',
    'MELOY METALS PRIVATE LIMITED',
    'Smile builders private limited',
    'Agarwal mittal concast private limited',
    'RACE SHIPPING AND TRANSPORT PRIVATE LIMITED',
    'Ethical energy solutions private limited',
    'Simic multimanagement services private limited',
    'Polyplast agencies (india) private limited',
    'Sibsagar vyapaar pvt ltd',
    'Sri jay pharma exim private limited',
    'Sparkk organics private limited',
    'Sdi smartbox (india) solutions private limited',
    'Dolvi minerals & metals private limited',
    'PRINCETON LANDS PRIVATE LIMITED',
    'BAGARIA NIVESH PRIVATE LIMITED',
    'Strategic management and marketing consultancy services limited',
    'Quality waves private limited',
    'Medall scans and labs mayiladudurai private limited',
    'Acre street (india) private limited',
    'Sahyog properties private limited',
    'Param exim limited',
    'Ariston advisors private limited',
    'Ads corpconsultants private limited',
    'Nebbiolo solutions private limited',
    'Jbr interio technologies private limited',
    'Medall scans and labs chengalpattu private limited',
    'Medall scans and labs private limited',
    'Medall scans and labs kumbakonam private limited',
    'Unique mantra projects private limited',
    'ARMENIAN VENTURES LIMITED',
    'EKA ENTERPRISES LIMITED',
    'Kensource information services p.ltd.',
    'K n vyapar private limited',
    'Hinduja investments private limited',
    'Kovid investments private limited',
    'Reminco resources private limited',
    'Physio-control india sales private limited',
    'R.V.METROPOLIS DIAGNOSTIC & HEALTH CARE CENTER PRIVATE LIMITED',
    'OLIVE SPECIALITY SERVICES PRIVATE LIMITED',
    'Uniworld insurance agency private limited',
    'Divine windfarm private limited',
    'S n realties private limited',
    'Mahadev infrastructure private limited',
    'R. raheja properties private limited',
    'R b r estates and finance pvt ltd',
    'Akalpitam land developers private limited',
    'Clam properties private limited',
    'Arihant retail properties (india) private limited',
    'Kintech realty private limited',
    'SAJESH ENTERPRISES PRIVATE LIMITED',
    'Ameeta grihnirman private limited',
    'Vijay shanti buildcon limited',
    'Vyom exim private limited',
    'Sunlight vinimay private limited',
    'Garemohan tie-up pvt. ltd.',
    'Valio merchants limited',
    'Panasonic india private limited',
    'Sameta exports pvt ltd',
    'Gstaad trading company pvt ltd',
    'Fawn trading company private limited',
    'Sunnidhi trading private limited',
    'Aban electronics private limited',
    'Chamomile retail private limited',
    'Cyberneme private limited',
    'Starshine mercantile private limited',
    'Sujata tradecom private limited',
    'Unigroup resources private limited',
    'Trans global hotels private limited',
    'Deedi resorts private limited',
    'Universal cold storage private limited',
    'Kay kay properties private limited',
    'Atmcs india limited',
    'Eyo solutions india private limited',
    'E-class education system limited',
    'Embassy services private limited',
    'Master staffing solutions private limited',
    'Brio bliss life science private limited',
    'Jagruk investments private limited',
    'Occ offshore projects private limited',
    'Piramal phytocare limited',
    'Enzigma solutions private limited',
    'Shubhalakshmi india commerce private limited',
    'Swastik commotrade pvt ltd',
    'Anushree clubs and resorts limited',
    'Saket holidays resorts private limited',
    'Devi hotels and motels pvt ltd',
    'SAPPHIRE HOSPITALITY AND RECREATION PRIVATE LIMITED',
    'A-diet express hospitality service limited',
    'Magna warehousing & distribution private limited',
    'Travel and business solutions (india) pvt ltd',
    'ESSAR INFRASTRUCTURE SERVICES Private Limited',
    'Alcatel-lucent managed solutions india private limited',
    'M.m. painting systems (india) private limited',
    'Rbn securities private limited',
    'Von roll (india) private limited',
    'Shruti financial services private limited',
    'Celebrus capital limited',
    'Manali investment and finance pvt ltd',
    'Eta township developers private limited',
    'Smriti realtech private limited',
    'Argus infrastructure & developers private limited',
    'Dior 6 residences private limited',
    'Seven heaven buildcons private limited',
    'Sahitya real estate private limited',
    'Mazbat properties pvt. ltd.',
    'Hemmo pharmaceuticals private limited',
    'K n textiles private limited',
    'Everest synthetics pvt ltd',
    'Shri hari filaments private limited',
    'SHRADDHA CLOTHING PRIVATE LIMITED',
    'Voilet fashions private limited',
    'NAVAM TECHNOLOGY VENTURES PRIVATE LIMITED',
    'Haas chemicals pvt ltd',
    'Nutech colors private limited',
    'All indian origin chemists & distributors ltd.',
    'Laziz ceramics private limited',
    'Sunrise containers limited',
    'Bemco precitech private limited',
    'Marshall gears pvt ltd',
    'Gujarat elektromag industries private limited',
    'Lmt (india) private limited',
    'Caparo vehicle products india limited',
    'Asian star jewels private limited',
    'SOLAR INTEGRATION SYSTEMS INDIA PRIVATE LIMITED',
    'Mihundon hydro power private limited',
    'Amulin hydro power private limited',
    'MAHESHWARI INFRASTRUCTURE & SKYSCRAPERS PRIVATE LIMITED',
    'Aparna projects private limited',
    'Heavenly city constructions private limited',
    'BIC-CELLO EXPORTS PRIVATE LIMITED',
    'Forum retail & entertainment pvt ltd',
    'Sherisha technologies private limited',
    'Aspire buildcon private limited',
    'Caparo engineering and construction limited',
    'Bharti enterprises limited.',
    'Slate enterprises private limited',
    'Motilal oswal real estate investment advisors private limited',
    'Sherwin-williams coatings india private limited',
    'Wellknown technologies private limited',
    'Ht education limited',
    'Kor investments private limited',
    'NEUBERG SUPRATECH REFERENCE LABORATORIES PRIVATE LIMITED',
    'Topmovies entertainment limited',
    'FCEL FOOD PROCESSORS LIMITED',
    'House of tales event gallery private limited',
    'WAVELENGTH TELEVISION PRIVATE LIMITED',
    'Bulwark business services private limited',
    'Rose mary plantations ltd.',
    'BARKUR EXPORTS PRIVATE LIMITED',
    'Wellknown synthetics private limited',
    'Jothikannan textiles private limited',
    'D3 textiles private limited',
    'Farm cot fiber private limited',
    'Kavita fashions private limited',
    'STRIDES EMERGING MARKETS LIMITED',
    'Navyug roof industries limited',
    'Trishan metals private limited',
    'G.b. farms pvt ltd',
    'Hike Messenger Limited',
    'J c tex mach marketing private limited',
    'SUJASH VENTURES PRIVATE LIMITED',
    'India education services private limited',
    'Trinity edutech private limited',
    'Healthnext limited',
    'Highway hospitality private limited',
    'Sterling generators private limited',
    'Northern projects ltd',
    'Tushar impex enterprises limited',
    'MANULI PSI HYDRAULICS PRIVATE LIMITED',
    'Heinz india private limited',
    'Okey fabrications private limited',
    'Shanaya sarees private limited',
    'Xform labs private limited',
    'TCUBE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Amoghsiddhi realties private limited',
    'Invensys development centre india private limited',
    'Medplexus india private limited',
    'Igenero web solutions private limited',
    'First pass semiconductors private limited',
    'Orange semiconductors private limited',
    'SAFARI COMMERCIAL PRIVATE LIMITED',
    'Apl institute of clinical laboratory & research private limited',
    'Syonara realtors private limited',
    'MMR SOCIAL HOUSING PRIVATE LIMITED',
    'Am futures private limited',
    'Eduboxx education private limited',
    'KMVK AGRI PRODUCTS PRIVATE LIMITED',
    'Corp solute india private limited',
    'Amity consultants private limited',
    'Quick lithographers private limited',
    'Pinetops enterprise private limited',
    'Deluxe zippers private limited',
    'G r k securities private limited',
    'Idfc trustee company limited',
    'JEEVANA MITRA CONSTRUCTIONS PRIVATE LIMITED',
    'Elecom investments pvt ltd',
    'Liva pharmaceuticals limited',
    'Swati capitals private limited',
    'Sovereign global finance private limited',
    'Idfc alternatives limited',
    'Della constructions private limited',
    'Sky bio-pharma (india ) limited',
    'Gufic stridden bio-pharma private limited',
    'Grk nirman private limited',
    'Rentokil india private limited',
    'Grk developers private limited',
    'Ogen nutrition limited',
    'Rateintegration software technologies private limited',
    'HATHWAY SOFTWARE DEVELOPERS LIMITED',
    'Acs technologies limited',
    'Scorpio merchandise private limited',
    'Emulex communications private limited',
    'Aol interactive media india private limited',
    'Tech mahindra business services limited',
    'Rosetta stone consulting services private limited',
    'Scat media and consultancy private limited',
    'Petromax pictures private limited',
    'Aditya safe deposit vaults private limited',
    'Srikalahasthi pipes limited',
    'Tlpl shipping and logistics private limited',
    'COLUMBIA GLOBAL PRIVATE LIMITED',
    'Farm picks (india) private limited',
    'TAGOOR CHEMICALS PRIVATE LIMITED',
    'Jaqua industries & sales co. private limited',
    'Ashapura china clay pvt ltd',
    'Bhagyalaxmi metals private limited',
    'Homag machinery bangalore private limited',
    'Mechvac india limited',
    'Ace shipping private limited',
    'Alpha villas private limited',
    'Neelkamal realtors and complex private limited',
    'Blue jeans network india private limited',
    'Intrex india private limited',
    'Navini networks private limited',
    'Inque overseas private limited',
    'Broadcom semiconductors india private limited',
    'Dream real home services private limited',
    'Twenty twenty media private limited',
    'Covai packaging private limited',
    'Sum advisory services private limited',
    'Jagdale developers private limited',
    'Industeel plates india private limited',
    'Connect (india) mobile technologies private limited',
    'SEMBCORP GAYATRI POWER LIMITED',
    'Ichha constructions pvt ltd',
    'Adhivitiya properties limited',
    'Vishal nirman (india) ltd',
    'Fourjone realtors private limited',
    'VISHAL MEGA MART PRIVATE LIMITED',
    'Dpp trading private limited',
    'Downtown retail private limited',
    'GODLAND ENTERPRISES PRIVATE LIMITED',
    'Zircon hospitality private limited',
    'Saiyana warehouse private limited',
    'Mailing lists (india) private limited',
    'Woodstock commodities private limited',
    'Erudite shares and securities private limited',
    'Tranzlease automobile management solutions private limited',
    'Volkswagen group sales india private limited',
    'Gandhi merchandise private limited',
    'Future mobile and accessories limited',
    'Future consumer products limited',
    'Italia impex private limited',
    'Peter wolters precision solutions (india) private limited',
    'Innoveer solutions india private limited',
    'MEADOWS-1 GRANDE EXOTICA RESIDENTS MAINTENANCE LIMITED',
    'D P JAIN BANGALORE-CHENNAI EXPRESSWAYS PRIVATE LIMITED',
    'GVJ IMPORTS PRIVATE LIMITED',
    'ILS LABS INDIA PRIVATE LIMITED',
    'YOU NEED CONTENTS PRIVATE LIMITED',
    'KOLLBAK INNOVATIONS PRIVATE LIMITED',
    'HILOGICSOLUTIONS PRIVATE LIMITED',
    'SIERRA PLAZA PRIVATE LIMITED',
    'ACRUX INNOVATIONS PRIVATE LIMITED',
    'ORTUS DIGITAL TECH INDIA PRIVATE LIMITED',
    'INGRIDIA GLOBAL PRIVATE LIMITED',
    'DEEPSPECTRUM ANALYTICS PRIVATE LIMITED',
    'GVB CLOUD LABS PRIVATE LIMITED',
    'ANAND SPIRITUAL FOUNDATION',
    'SQUARE WORLD FOUNDATION',
    'BROWN GLASS STUDIOS PRIVATE LIMITED',
    'ILS INDIA PRIVATE LIMITED',
    'DOTCONN PRIVATE LIMITED',
    'KARDIFY CUSTOMS PRIVATE LIMITED',
    'AKV TECHNOLOGIES PRIVATE LIMITED',
    'GREEN MATTER TECHNOLOGIES PRIVATE LIMITED',
    'SWADHARMA LEARNING TECHNOLOGIES PRIVATE LIMITED',
    'PRIME RENFRA INDIA PRIVATE LIMITED',
    'MADHULI INFRASPACE PRIVATE LIMITED',
    'SRI SHOBHANACHALA VYAGRA NARASIMHA SWAMYFARMERS PRODUCER COMPANY LIMITED',
    'RIGID BOX SIVAKASI PRIVATE LIMITED',
    'BHIVE REGULUS PRIVATE LIMITED',
    'MARA COSMECARE PRIVATE LIMITED',
    'LAZARUS BUSINESS PARK 1 PRIVATE LIMITED',
    'TIBBI KRISHI FED PRODUCER COMPANY LIMITED',
    'SHAREWARE TECHNOLOGY PRIVATE LIMITED',
    'ROYALMILES BUILDER PRIVATE LIMITED',
    'OAN CHEMICALS PRIVATE LIMITED',
    'DECODETEK SOFTWARE PRIVATE LIMITED',
    'AIKYAM GALAXY PRIVATE LIMITED',
    'RED AND WHITE INTERNATIONAL EDU PRIVATE LIMITED',
    'ICAMP PRIVATE LIMITED',
    'LUMINOSITY EDUTECH PRIVATE LIMITED',
    'AAWHOZ TECHNOLOGIES PRIVATE LIMITED',
    'BCBUZZ TECHNOLOGIES PRIVATE LIMITED',
    'MIRACLES FINSTOCK SERVICES PRIVATE LIMITED',
    'STATUS EYEWEAR PRIVATE LIMITED',
    'WEBENTIAL TECHNOLOGIES PRIVATE LIMITED',
    'ASTRO GEO SERVICE (OPC) PRIVATE LIMITED',
    'SRM2 BUSINESS SUPPORT SERVICES INDIA PRIVATE LIMITED',
    'CLOUDFLARE INDIA PRIVATE LIMITED',
    'AMRIT-FILTRATION PRIVATE LIMITED',
    'MYSVASTH PRIVATE LIMITED',
    'JUSTKARE TECHNOLOGIES PRIVATE LIMITED',
    'APPOINTO TECH HEALTH SERVICE PRIVATE LIMITED',
    'MICROLINK DEVICES INDIA PRIVATE LIMITED',
    'LYRICAL BINARY SYSTEMS (OPC) PRIVATE LIMITED',
    'CGE II HYBRID ENERGY PRIVATE LIMITED',
    'HOUSR COLIVING PRIVATE LIMITED',
    'DODOVY PRIVATE LIMITED',
    'AASTHY OPPORTUNITY 2 PRIVATE LIMITED',
    'TRANSINDIA REAL ESTATE LIMITED',
    'LIFEHETU TECHNOLOGY PRIVATE LIMITED',
    'METACIPHER LABS PRIVATE LIMITED',
    'MORJAR RENEWABLES PRIVATE LIMITED',
    'ATREYI DEVELOPERS (OPC) PRIVATE LIMITED',
    'CRIMSON AI PRIVATE LIMITED',
    'CHAKRAVYUHA ENGINEERS PRIVATE LIMITED',
    'GMR LOGISTICS PRIVATE LIMITED',
    'MGMPUSHPAM PROPERTIES PRIVATE LIMITED',
    'EMI TUFBAR PRIVATE LIMITED',
    'KAYVIPS SALES SQUAD (OPC) PRIVATE LIMITED',
    'CARRYWINGS LINES PRIVATE LIMITED',
    'SUTIRTH MULTI SERVICES PRIVATE LIMITED',
    'CHEMPACKS PACKAGING PRIVATE LIMITED',
    'EDUWORQ ACADEMY PRIVATE LIMITED',
    'STAKE BINARY (OPC) PRIVATE LIMITED',
    'GEEKTOOL ENGINEERING PRIVATE LIMITED',
    'LEARN2LEARNMUSIC PRIVATE LIMITED',
    'VELOXCORE PRIVATE LIMITED',
    'DRUID KITCHEN (OPC) PRIVATE LIMITED',
    'AJITNATH HEALTHCARE PRIVATE LIMITED',
    'MADRAS AERONAUTICAL RESEARCH FOUNDATION',
    'INFIILOOM TEXTILES PRIVATE LIMITED',
    'BLACK DOT POLICY ADVISORS PRIVATE LIMITED',
    'MAYE-G PLYBOARDS PRIVATE LIMITED',
    'HUOBAN ENERGY 8 PRIVATE LIMITED',
    'ASIATICO VISION GLOBAL LOGISTICS PRIVATELIMITED',
    'VALSOC SEMICONDUCTOR PRIVATE LIMITED',
    'FP ANDROMEDA PRIVATE LIMITED',
    'GREEN BUTWAL TOURS AND TRAVELS PRIVATE LIMITED',
    'SIMNOVUS INDIA PRIVATE LIMITED',
    'LEOS MARITIME SOLUTIONS (OPC) PRIVATE LIMITED',
    'DIAMODIS ENTERPRISES (OPC) PRIVATE LIMITED',
    'SHINE ITES PRIVATE LIMITED',
    'EURO BUDDY PRIVATE LIMITED',
    'ROYAL PRISTINE MANAGEMENT PRIVATE LIMITED',
    'KALASHRI AUTOMATION PRIVATE LIMITED',
    'GROWTHBUK ADVISORY PRIVATE LIMITED',
    'SANGAM VENTURES LIMITED',
    'ORIONWATER TECHNOLOGIES PRIVATE LIMITED',
    'V-ETICO SERVICES PRIVATE LIMITED',
    'SKYLER BUILDCOM PRIVATE LIMITED',
    'MITE FOUNDATION FOR INNOVATION RESEARCH AND STARTUPS THROUGH TECHNOLOGY',
    'CHAAT PUCHKA FOODS PRIVATE LIMITED',
    'KJ FINSERV PRIVATE LIMITED',
    'SAMURAI 2K INDIA PRIVATE LIMITED',
    'GPVL ENTERPRISES PRIVATE LIMITED',
    'ART2HIRE STAFFING SOLUTIONS PRIVATE LIMITED',
    'BHOLENATH PHARMA PRIVATE LIMITED',
    'HIGHNTALL TECHNOLOGIES PRIVATE LIMITED',
    'GRAND GROCERIA SP PRIVATE LIMITED',
    'ACCUFFY LIFESCIENCES PRIVATE LIMITED',
    'TRI-OM ADAPTIVE SOLUTIONS PRIVATE LIMITED',
    'DEV DESAI FITNESS (OPC) PRIVATE LIMITED',
    'LIGHTSPRING NEW ENERGIES PRIVATE LIMITED',
    'RENEW GREEN (MHP THREE) PRIVATE LIMITED',
    'CRICUT INDIA PRIVATE LIMITED',
    'NETWEB BHARAT PRIVATE LIMITED',
    'TECH MASTERS SOFTWARE SERVICES PRIVATE LIMITED',
    'SPERTON CHRISTOS CONSULTING PRIVATE LIMITED',
    'TRAINTRIPPER FILMS PRIVATE LIMITED',
    'TECHSIGNS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VEDANTA ZINC FOOTBALL & SPORTS FOUNDATION',
    'EDURSE TECHNOLOGIES PRIVATE LIMITED',
    'VELAA INDUSTRIES PRIVATE LIMITED',
    'AISENSY COMMUNICATIONS PRIVATE LIMITED',
    'SAVITEK INFRA PRIVATE LIMITED',
    'ALK HEALTHCARE (OPC) PRIVATE LIMITED',
    'INPHOG RESEARCH FOUNDATION',
    'PRUDENT EQUITY PRIVATE LIMITED',
    'VITAAN FINANCIALS PRIVATE LIMITED',
    'BIG PLANS TECHNOLOGIES PRIVATE LIMITED',
    'KUNAKANI PRIVATE LIMITED',
    'DENALI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'RM INSURANCE BROKING PRIVATE LIMITED',
    'ABN LIFECARE PATHLAB PRIVATE LIMITED',
    'AIRPAY VENTURES PRIVATE LIMITED',
    'DPS TRADELINK PRIVATE LIMITED',
    'CHALEIT SHARED SERVICES PRIVATE LIMITED',
    'TRADOXI PRIVATE LIMITED',
    'INNOVATION INTELLECT (OPC) PRIVATE LIMITED',
    'V RAHEJA REALTY PRIVATE LIMITED',
    'DP PLATFORM PRIVATE LIMITED',
    'TERA IMPULSE PRIVATE LIMITED',
    'GUARDINEX INDIA PRIVATE LIMITED',
    'MILOUISA MANAGEMENT INDIA PRIVATE LIMITED',
    'QCC LAB SOLUTIONS PRIVATE LIMITED',
    'PARSHURAM POLYMER PRIVATE LIMITED',
    'FERNANDES GLOBAL RECRUITMENT PRIVATE LIMITED',
    'JAYAKEERTHI TECHNOLOGY SERVICES PRIVATE LIMITED',
    'THINKWIK TECHNOLOGY PRIVATE LIMITED',
    'HADMS SOLUTIONS PRIVATE LIMITED',
    'BRIJRAJ TECHNOLOGIES PRIVATE LIMITED',
    'SNS GREENMINT INDIA PRIVATE LIMITED',
    'MICRO ANIMAL HEALTH CARE PRIVATE LIMITED',
    'MINTIQ TECHNOLOGIES PRIVATE LIMITED',
    'KETCH EXPERIENCE PRIVATE LIMITED',
    'CDSS DETECTIVE AND SECURITY SERVICES PRIVATE LIMITED',
    'NUTROVE TECHNOLOGIES PRIVATE LIMITED',
    'PLAYROLL INDIA PRIVATE LIMITED',
    'IMPACTUM LANDS PRIVATE LIMITED',
    'TAIVAS HOSPITALITY AND WELLNESS PRIVATE LIMITED',
    'AMAN SECURITY INDIA PRIVATE LIMITED',
    'GUJARAT E-AUTO PRIVATE LIMITED',
    'VAJR SECURITY SYSTEMS PRIVATE LIMITED',
    'REGROW MANPOWER SOLUTIONS PRIVATE LIMITED',
    'RAJAB FATHIMA PRIVATE LIMITED',
    'DUREDEV SOFTWARES PRIVATE LIMITED',
    'MULTI MODEL CARGO LINE PRIVATE LIMITED',
    'ML NIKETAN PRIVATE LIMITED',
    'FINAL99 SYSTEMS PRIVATE LIMITED',
    'GEM LOGISTICS SERVICES PRIVATE LIMITED',
    'JG ENCLAVE PRIVATE LIMITED',
    'KLP HEALTH TECH PRIVATE LIMITED',
    'AXINAN SERVICES PRIVATE LIMITED',
    'EASTERN DECCAN LIFESCIENCES PRIVATE LIMITED',
    'SUPERPURE KRISHI FED PRODUCER COMPANY LIMITED',
    'RIK GLOBAL PRIVATE LIMITED',
    'ADANI DATA NETWORKS LIMITED',
    'SMART OWLS INNOVATIONS PRIVATE LIMITED',
    'TAILSUP PETCARE PRIVATE LIMITED',
    'EVERYDOSE INNOVATIONS PRIVATE LIMITED',
    'ARDE HOME PRIVATE LIMITED',
    'KSL LIFESTYLE PRIVATE LIMITED',
    'SKYWIN EDUCATION PRIVATE LIMITED',
    'FETL TECH PRIVATE LIMITED',
    'MARFATIA TEX FAB PRIVATE LIMITED',
    'PNP INDUSTRIES INDIA PRIVATE LIMITED',
    'WELLNOID YOGAKARO HOLISTIC HEALTH AND TECHNOLOGY PRIVATE LIMITED',
    'ACME INDIA INDUSTRIES PRIVATE LIMITED',
    'GIC EDUVISION PRIVATE LIMITED',
    'YENOMRAH TECHNOLOGIES PRIVATE LIMITED',
    'MASTERKEY VENTURES PRIVATE LIMITED',
    'VALOR ADVISORY (INDIA) PRIVATE LIMITED',
    'KAN TECHNOLOGY LABS PRIVATE LIMITED',
    'MICROLAB INSTRUMENTS PRIVATE LIMITED',
    'POLICY GURU INSURANCE SERVICES PRIVATE LIMITED',
    'DREAM AVIJAAN INDIA PRIVATE LIMITED',
    'AMALTAS HOSPITALITY PRIVATE LIMITED',
    'ALGOPERK INDIA PRIVATE LIMITED',
    'STAR STALLION COMMODITIES PRIVATE LIMITED',
    'CAPITALVIA FINTECH PRIVATE LIMITED',
    'PATH FAMILY ADVISORY PRIVATE LIMITED',
    'RONYS TRADING (OPC) PRIVATE LIMITED',
    'CONTROLSHIFT TALENT PRIVATE LIMITED',
    'FIBER TEC PRIVATE LIMITED',
    'VISEO INDIA PRIVATE LIMITED',
    'VEVA REALTY PRIVATE LIMITED',
    'PHARMAFLEX INDIA PRIVATE LIMITED',
    'KILACHAND RETAIL PRIVATE LIMITED',
    'HELLY CHEM INDUSTRIES PRIVATE LIMITED',
    'SAROBE INFRAHOLDINGS PRIVATE LIMITED',
    'TIRUPATI AUTOMECH PRIVATE LIMITED',
    'Skyline tracom private limited',
    'Distripark tradeplace private limited',
    'Riko forge private limited',
    'Wind shine hospitality private limited',
    'Bosch electrical drives india private limited',
    'Phoenix hospitality company private limited',
    'Ved skills academy private limited',
    'EQUITAS HOLDINGS Limited',
    'R v mansions private limited',
    'Market-hub commodities private limited',
    'Integral interface management consultancy private limited',
    'GREENBACK CONSULTANTS AND ADVISORS PRIVATE LIMITED',
    'Bhartia securities private limited',
    'BOOKER SATNAM WHOLESALE LIMITED',
    'Euroschool properties & infrastructure private limited',
    'Idl buildware limited',
    'Witco enterprises private limited',
    'Syniverse mobile solutions private limited',
    'Broadcom communications technologies private limited',
    'Rm hospitality private limited',
    'SWARNIM ADVISORY SERVICES LIMITED',
    'Avanti conductors ltd',
    'Shashank enterprises private limited',
    'MVG AUTOMOBILES PRIVATE LIMITED',
    'SADHANA AUTOMOBILE PRIVATE LIMITED',
    'Disharsh estates pvt ltd',
    'Mangalam carbide ltd',
    'M.s.p. electronics private limited',
    'Pudumjee holding limited',
    'Cham chemicals private limited',
    'Radhey bihari exports private limited',
    'South delhi constructions private limited',
    'AGRI NEWGEN VENTURES PRIVATE LIMITED',
    'NEZONE MERCHANDISERS PRIVATE LIMITED',
    'Ativeer properties limited',
    'Mirchi properties limited',
    'Bondwell insurance brokers private limited',
    'Paras motorcoaches private limited',
    'Rishi container freight station private limited',
    'Prism realtech private limited',
    'Goa medical research private limited',
    'Steady management solutions private limited',
    'Yellow hut properties private limited',
    'Kalani properties private limited',
    'Guru technologies pvt ltd',
    'Viewline business private limited',
    'Lotus deal com private limited',
    'Ramanujan education & research services private limited',
    'Alka vinimay private limited',
    'Intrend lifestyle private limited',
    'Snk holdings private limited',
    'Indo-canadian foods private limited',
    'Anshu garments private limited',
    'Umr agencies private limited',
    'Eklavya commercial private limited',
    'Sambhav detergents private limited',
    'Anjaniputra distributors private limited',
    'Rdb iota visual arts private limited',
    'J j motors private limited',
    'Se solar limited',
    'Alfa town and projects private limited',
    'Enakshi residency private limited',
    'New era heights private limited',
    'P.g. propmart private limited',
    'Sundaram bpo india limited',
    'Woodstick trexim private limited',
    'Skups films pvt ltd',
    'Golcha comtech granites private limited',
    'Muskan tie-up private limited',
    'Excel tea trading private limited',
    'Ziaxa exim private limited',
    'Allied deals precious metals private limited',
    'Scope vinimoy private limited',
    'Blossom distributors private limited',
    'Snt merchants private limited',
    'Alishan vinimay private limited',
    'Nextgen dealtrade private limited',
    'KOTIRATAN TRADING PRIVATE LIMITED',
    'Moontree retailers limited',
    'Gurumukh suppliers limited',
    'Shinestar vanijya limited',
    'Roserise vyapaar limited',
    'Overgrow trading limited',
    'Pioneer resins & aromatics private ltd',
    'Pride hotels private limited',
    'Sowbarniha resorts private limited',
    'Indian roadways corporation limited',
    'Upgrah investments pvt ltd.',
    'Seeyok niwas & nivesh pvt ltd',
    'Lodestar financial services limited',
    'Dhruva holdings pvt ltd',
    'DR.REDDY',
    'S BIOSCIENCES PRIVATE LIMITED',
    'Relief pharmaceuticals private limited',
    'Accutest research laboratories india private limited',
    'AIOCD PHARMA LIMITED',
    'Imgenex india private limited',
    'Taurus chemicals pvt ltd',
    'Nektar therapeutics (india) private limited',
    'Shree jaya laboratories private limited',
    'Heranba crop care limited',
    'Srikara parenterals private limited',
    'Sephora cosmetics private limited',
    'Harmony distributors private limited',
    'Sundaravel match industries private limited',
    'Bharat oil and chemical industries ltd',
    'Fumakilla india private limited',
    'BPREX PHARMA PACKAGING INDIA PRIVATE LIMITED',
    'Maasti products private limited',
    'Armaco chemical process systems private limited',
    'S.k. chemical industries (mumbai) private limited',
    'Asian solvochem private limited',
    'Synpure labs india private limited',
    'Sulabh colour and chemicals pvt ltd',
    'A1 clamps india private limited',
    'INFAHS PRIVATE LIMITED',
    'Khemka glass products private limited',
    'GOMTI RESEARCH AND PHARMACHEM PRIVATE LIMITED',
    'Udhbhav polymers private limited',
    'Skill dye chem private limited',
    'Modifoam latex private limited',
    'R & t houseware private limited',
    'Sanwa synergy holdings india private limited',
    'Yng steels limited',
    'Swage systems private limited',
    'Mahodara estates private limited',
    'Avyukta polymers private limited',
    'Galaxy forms limited.',
    'Adidev polymers private limited',
    'Abhijeet polymers private limited',
    'Ans conveyor and rubber products private limited',
    'Stellar plastics (india) private limited',
    'Sakshi polymers private limited',
    'Danta polymers private limited',
    'Khajuraho estates private limited',
    'Glorious plastics private limited',
    'Prominent plastics limited',
    'Yogini plastics private limited',
    'CELLOTAPE INDUSTRIES PRIVATE LIMITED',
    'Jayalakshmi poly packs private limited',
    'Information technology park limited',
    'Utopia infrastructure private limited',
    'Rmz business park (india) private limited',
    'N d properties private limited',
    'Urbana scapes (india) private limited',
    'Newbury ventures private limited',
    'Bap constructions private limited',
    'Mountain view agri estates private limited',
    'Neelkanth agri villas private limited',
    'Expression infra-projects private limited',
    'Horizon dream homes private limited',
    'K b a infrastructure private limited',
    'Greentown estate private limited',
    'Ganesham infratech developers private limited',
    'Looksons developers private limited',
    'Mars lifespaces (yash) private limited',
    'Aster premises private limited',
    'Rohan landmarks private limited',
    'Rathinam techzone india private limited',
    'GOLKONDA HOTELS VIZAG PRIVATE LIMITED',
    'Abco steel international private limited',
    'KONSTELEC ENGINEERS LIMITED',
    'Tk toll road private limited',
    'Rose land infrastructure private limited',
    'Jr toll road private limited',
    'Km toll road private limited',
    'Ps toll road private limited',
    'Akshay star towers private limited',
    'Viva infrastructure limited',
    'Swarna tollway private limited',
    'Montag infrastructure private limited',
    'Chaitanya foundations private limited',
    'Ducon contractors private limited',
    'Carbon constructions (india) private limited',
    'Preca solutions india private limited',
    'Devas habitats private limited',
    'J r urban infracon private limited',
    'Rajapushpa properties private limited',
    'Reliant advanced product solution private limited',
    'Solar turbines india private limited',
    'N.d.r. infrastructure private limited',
    'Nspr constructions (india) private limited',
    'Skanda infra projects india private limited',
    'Metroline townships private limited',
    'Metroline promoters private limited',
    'Jr infra engineering private limited',
    'Comfort infracity private limited',
    'Arka integrated projects management solutions private limited',
    'Ark infra developers private limited',
    'Phoenix multiplex private limited',
    'Goldfish abode private limited',
    'Interia infrastructure private limited',
    'Dolphin complex private limited',
    'Multi realtors private limited',
    'Hearth industries private limited',
    'Stedman developers private limited',
    'Malibu estate dispensary private limited',
    'Ebenezer technologies private limited',
    'Aparna colonizers private limited',
    'Ag aircon private limited',
    'Steefab engineering co pvt ltd',
    'RELIANCE AIRPORT DEVELOPERS LIMITED',
    'Design centre engineers private limited',
    'Vindhyavasini buildcon private limited',
    'Touchstone infrastructure and solutions private limited',
    'ELDECO REAL ESTATE LIMITED',
    'ELDECO MAKSAD PROPERTIES LIMITED',
    'Iris mansions private limited',
    'Inder creator construction private limited.',
    'Vastukalp projects private limited',
    'Lincoln developers private limited',
    'Bhomaye real estate private limited',
    'Oriental nagpur bye pass construction private limited',
    'Adonis buildtech private limited',
    'Roadstab technologies private limited',
    'Primrose constech private limited',
    'Emerald organisers private limited',
    'Veer shuttering private limited',
    'Saanguine infradevelopers private limited',
    'Bux-ranka developers private limited',
    'G m infinite dwelling (india) private limited',
    'Sowparnika homes private limited',
    'Td toll road private limited',
    'Shakti realities private limited',
    'Rma architects private limited',
    'Spenta buildcon private limited',
    'Maninath builders private limited',
    'Mittal universal limited',
    'Ndcv realty private limited',
    'NUCLEUS LIFESTYLE PRIVATE LIMITED',
    'Bhartia multistructure private limited',
    'Navkar groups private limited',
    'Indian properties private limited',
    'Manav reality & infrastructure private limited',
    'Eagle deep infra india private limited',
    'ARM INFRA & UTILITIES PRIVATE LIMITED',
    'Castle floors project management services private limited',
    'Kolhapur construction corporation private limited',
    'NCL VEKA PRIVATE LIMITED',
    'Building crafts (india) private limited',
    'Acron developers private limited',
    'Saif properties and multi trading private limited',
    'Vasav enterprises private limited',
    'ACKRUTI STAR MAINTENANCE PRIVATE LIMITED',
    'APARNA REALTY PROPERTIES PRIVATE LIMITED',
    'APARNA REALTY PROJECTS PRIVATE LIMITED',
    'Apple avenues private limited',
    'YALSCO REAL ESTATE & AGRO FARMING LIMITED',
    'ANDHERI PROPERTIES AND DEVELOPERS PRIVATE LIMITED',
    'EVERLAST PROJECTS PRIVATE LIMITED,',
    'Reliant estates private limited',
    'Eldeco greens limited',
    'Mansarover realtors limited',
    'Ghaziabad aligarh expressway private limited',
    'REVERSE AGE HEALTH SERVICES PRIVATE LIMITED',
    'Riviera constructions private limited',
    'Arris estates private limited',
    'Synthesis agricon private limited',
    'Ashwitha property developers private limited',
    'Arya commercial spaces private limited',
    'GOM GANPATI TECHBUILD PRIVATE LIMITED',
    'Prisunic builders private limited',
    'Veekaylal investment company private limited',
    'Abhishek apartments private limited',
    'Villar builders private limited',
    'Sarthi properties private limited',
    'Planet properties private limited',
    'Technopolis knowledge park limited',
    'Well-wisher construction private limited',
    'Trueworth properties private limited',
    'DOIT ABODE (GOA) PRIVATE LIMITED',
    'Riyasat realty private limited',
    'Vatsa realty private limited',
    'New delhi house services limited',
    'Karan realities private limited',
    'Centurions housing & constructions private limited',
    'Sree balaji hi-tec promoter private limited',
    'Zulu realty private limited',
    'Miller promoters private limited',
    'R & A BUSINESS VENTURES PRIVATE LIMITED',
    'Ambrosia promoters private limited',
    'Mersey promoters private limited',
    'Jonquil promoters private limited',
    'Edelweiss promoters private limited',
    'Calubura promoters private limited',
    'Maksons projects pvtltd.',
    'De con projects private limited',
    'Devavrat builders private limited',
    'Jalan builders private limited',
    'Homeland avenues private limited',
    'Swabhiman buildtech limited',
    'CENTILLION INSURANCE BROKERS LIMITED',
    'Ethenic real estate private limited',
    'Kdp infratech private limited',
    'Blue fox farms private limited',
    'Nestkeys infratech private limited',
    'Easy real estate private limited',
    'Dhansri estates private limited',
    'Nanjangud projects private limited',
    'Total environment projects (india) private limited',
    'Urbana projects (india) private limited',
    'INTELLVE SOLUTIONS PRIVATE LIMITED',
    'Piramal properties private limited',
    'Dipti builders universal private limited',
    'Castle homes project management services private limited',
    'V-zones realities private limited',
    'Swadesh infrastructure private limited',
    'Sunkersett realties private limited',
    'Khoobsurat infra private limited',
    'Delara tourism corporation lim ited',
    'Janaharsha estates n constructions private limited',
    'Sigma avenues private limited',
    'Goodearth villas private limited',
    'Libra avenues private limited',
    'Pieces estates private limited',
    'Uber realtors private limited',
    'Yuvidhi estates private limited',
    'SWORDLILY CULTURAL AND SPORTS PRIVATE LIMITED',
    'Trend properties private limited',
    'Murray promoters private limited',
    'Viscaria promoters private limited',
    'Gudland properties private limited',
    'Upper wood street services private limited',
    'Kolkata homes & projects private limited',
    'Omway india limited',
    'ELDECO INFRABUILD LIMITED',
    'Hi-pride infracon limited',
    'Omway housing & infrastructure private limited',
    'Blossom properties private limited',
    'Concord infrastructure private limited',
    'Iris real estate private limited',
    'Iris infratech private limited',
    'Best view infracon limited',
    'BURMAN BUILDCON PRIVATE LIMITED',
    'Tirupati buildplaza private limited',
    'S n s infratech private limited',
    'Andromida real estate consortium private limited',
    'Rlf projects private limited',
    'Landmark hospitality private limited',
    'Saat rasta properties private limited',
    'Pinnapu estates private limited',
    'Generix info private limited',
    'Bookbuzzr book marketing technologies private limited',
    'Deskala research and design consulting private limited',
    'J.s.f. holdings private limited',
    'Vim healthcare solutions private limited',
    'Mokanro realty private limited',
    'Atp consultants private limited',
    'Technocomm instruments private limited',
    'Dream:in social networks private limited',
    'Arnold consulting private limited',
    'Ide consulting services private limited',
    'TECH DESIRE INFRA PRIVATE LIMITED',
    'Nrack accessories private limited',
    'Techxandria software private limited',
    'Df3d creations private limited',
    'Shri banashankari pharma private limited',
    'Shine touch services private limited',
    'Papercats creative solutions private limited',
    'Rudhra solar and aqua india private limited',
    'Pro compliance experts india private limited',
    'CAPITALMIND FINANCIAL SERVICES PRIVATE LIMITED',
    'Ashwani apparels and properties private limited',
    'Vensoft films private limited',
    'FIORINA ADVISORY SERVICES PRIVATE LIMITED',
    'Akk financial advisory services private limited',
    'Ashar locker (india) private limited',
    'LIBORD IRP ADVISORS PRIVATE LIMITED',
    'Grandmother india design private limited',
    'Shalibhadra exports private limited',
    'Pratham resources private limited',
    'MASTERCARD LOYALTY SOLUTIONS INDIA PRIVATE LIMITED',
    'Acendo capital advisors private limited',
    'Teapot entertainment private limited',
    'Capvital advisors private limited',
    'Digital pace education private limited',
    'Complisec consulting services private limited',
    'Infrastructure advisors private limited',
    'Baran india private limited',
    'Hue retail private limited',
    'I-am mumbai branding and interior designs private limited',
    'Sobo films holding private limited',
    'Green era management private limited',
    'Oliana consultants private limited',
    'Digital satellite holdings private limited',
    'Rson technomedia private limited',
    'Data trac research private limited',
    'Fresh produce value creation services private limited',
    'Flying saucer pictures private limited',
    'Planedge consultants private limited',
    'International institute for energy conservation-india',
    'Masco home products private limited',
    'OM SAI CREDIT COLLECTION SERVICESS PRIVATE LIMITED',
    'Krystalvision image systems private limited',
    'Ask energy solutions private limited',
    'Airkonnect networks private limited',
    'Boyd and moore executive search india private limited',
    'Adyaguru concepts private limited',
    'Procetech automation private limited',
    'Search & sell india private limited',
    'OSX TECHLABS PRIVATE LIMITED',
    'Lanco solar private limited',
    'PRAGDISA EPC LIMITED',
    'Prathama hr solutions india private limited',
    'Nspira management services private limited',
    'Ulrich integrated technologies and consulting private limited',
    'Gmk research laboratories private limited',
    'Shan infotainment private limited',
    'Rapidwall building systems india private limited',
    'Krome led lighting technologies private limited',
    'A. s. vasan shipping services private limited',
    'Waldemar link india private limited',
    'Zn synergies private limited',
    'Hsenid business solutions (india) private limited',
    'Logiciels info solutions private limited',
    'Dove tale india private limited',
    'I2 distribution private limited',
    'Goggles energy private limited',
    'Statcom accounting services private limited',
    'Icsa investments & realty private limited',
    'Swastik infra equipments private limited',
    'Customerlabs digital solutions private limited',
    'Aurous marketing private limited',
    'Kutung design labs private limited',
    'Gsm sourcing private limited',
    'Metro retail private limited',
    'Bluesky educational services private limited',
    'Prime process consultants india private limited',
    'PASUPATI FOOD PRODUCTS PRIVATE LIMITED',
    'Unihunt consulting private limited',
    'Plexus professionals network private limited',
    'Convergeon hr services (india) private limited',
    'Teampace business solutions private limited',
    'Venator search private limited',
    'BRANDMELA EVENTS AND MORE PRIVATE LIMITED',
    'Meekam career consultants private limited',
    'Reliance group support services private limited',
    'Property guards security services private limited',
    'Investigation and security services india pvt ltd',
    'Jui print technology private limited',
    'Bhavik publication private limited',
    'Paulmary media solutions private limited',
    'Grafika printers private limited',
    'Freeda enterprises private limited',
    'Aspade systems private limited',
    'RAYA MEDIA PRIVATE LIMITED',
    'Thoughtspace designs private limited',
    'Thoughtcells consultants private limited',
    'Allied labels private limited',
    'Shraddha associates (guj) private limited',
    'Atb riva calzoni india private limited',
    'Kinol lubes private limited',
    'J.j.petrochemicals pvt ltd',
    'Kandla impex limited',
    'Metrite lubes & specialities private limited',
    'Kiri peroxide limited',
    'Excess chemicals private limited',
    'Akrur chemicals private limited',
    'Neon laboratories limited',
    'Renentech laboratories private limited',
    'Swissol specialities private limited',
    'Kusumoto chemicals (india) private limited',
    'Zifam pinnacle healthcare private limited',
    'Shubham specialty products (india) private limited',
    'Sivas s & s products private limited',
    'Vapi spectrochem pvt ltd',
    'Pax polysynth private limited',
    'Navyug chemicals private limited',
    'Urmila chemopharma pvt ltd',
    'Akry organics pvt ltd',
    'Neolite polymer industries p.ltd.',
    'Srikem laboratories private limited',
    'DEEPAK CHEMTEX LIMITED',
    'Recent pac chemical industry private limited',
    'Hetero labs limited',
    'Island veer chemie pvt ltd',
    'Srivaari chemicals private limited',
    'Neosun biotech (india) private limited',
    'Aries gases private limited',
    'Yesbee carbonic private limited',
    'BALAJI PRESSURE VESSELS Private Limited',
    'Jayco global private limited',
    'Gee gee kay private limited',
    'Giri organic villages private limited',
    'Essem metachem industries pvt. ltd.',
    'Genesis e tech limited',
    'FOOTMATE POLYMERS INDIA PRIVATE LIMITED',
    'Advance addmine private limited',
    'Diamalt colloids private limited',
    'S REALITY & EDUCATION PRIVATE LIMITED.',
    'Vegsutra hospitality private limited',
    'Proactive family solutions private limited',
    'Next door learning solutions private limited',
    'Dr tvacha private limited',
    'Sab professional services private limited',
    'Ribhus research private limited',
    'ELBIT MEDICAL DIAGNOSTICS PRIVATE LIMITED',
    'Clisim aircon private limited',
    'National skill development corporation',
    'INDO ENVIRO INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'SEWERAGE & INFRASTRUCTURAL DEVELOPMENT CORPORATION OF GOA LIMITED',
    'Vedic maths forum private limited',
    'Vibrant education services private limited',
    'Legend sanicure private limited',
    'Cochin chamber of commerce and industry',
    'Gopast centre for learning private limited',
    'Ideal experiential learning private limited',
    'Coldex foundation',
    'Bremels rubber industries private limited',
    'Hi-tech ventures private limited',
    'Varkey educational services private limited',
    'Saphire hospitality management private limited',
    'Mugneeram ramcoowar bangur charitable & religious company',
    'Federation of churchgate residents',
    'Hairline diagnostics and health care private limited',
    'White swan foundation for mental health',
    'Aspire fitness private limited',
    'Bappaditya roy pictures private limited',
    'RELIANCE JIO MEDIA LIMITED',
    'Gunasekaran hospitals private limited',
    'ASSOCIATION OF BILLION MINDS',
    'Khushi pediatric therapy centre',
    'Tata foundation',
    'Orind exports limited.',
    'The british metal corporation (india) private limited',
    'Orange city alloys private limited',
    'Shree arya lakshmi steel private limited',
    'Megha herbals healthcare private limited',
    'Essen multipack limited',
    'Shankar brother plastindia private limited',
    'Wilson plastics private limited',
    'Mundeth storage systems private limited',
    'Gamzen plast private limited',
    'MAHALAXMI ROPE WORKS PRIVATE LIMITED',
    'Chaudhry steel and alloys limited',
    'Neptune steel strips limited',
    'Shree vaishnav alloys private limited',
    'Super furnace works (india) private limited',
    'Champalal motilal steel company private limited',
    'Sam alloys private limited',
    'Bholaram metal industries private limited',
    'Metals united alloys and fusion products limited',
    'Rajasthan engitech private limited',
    '3d foamcut private limited',
    'Manaksia aluminium company limited',
    'Manaksia coated metals & industries limited',
    'Deejay multipacks private limited',
    'APIL POLY INDUSTRIES LIMITED',
    'Eco green industries private limited',
    'Shree ashtavinayak glass private limited',
    'Amitronics private limited',
    'Parasakti cement industries limited',
    'Sakthi ferro alloys (india) private limited',
    'Arvind press caps limited',
    'Manaksia steels limited',
    'Starlight energy limited',
    'Garg iron & energyy private limited',
    'Diana shutters private limited',
    'Mekhraz marble & sandstone private limited',
    'Aakriti industries limited',
    'Dtmg packaging private limited',
    'KRRIYAN KONTAINERS PRIVATE LIMITED',
    'Furus packaging private limited',
    'RELIABLE LASER WORKS PRIVATE LIMITED',
    'Galaxy thermo plast private limited',
    'Anand seamless tubes private limited',
    'Emge cylinders private limited',
    'Asha cellulose (india) private limited',
    'Ramsons castings private limited',
    'Plansee india high performance materials private limited',
    'Sonal non ferrous metals private limited',
    'CHETTINAD STRUCTURAL & ENGINEERING PRIVATE LIMITED',
    'Focus die cast private limited',
    'Lans metals private limited',
    'Shrameya engineers p ltd',
    'NVENT ENCLOSURES INDIA PRIVATE LIMITED',
    'EMD SCAFFOLDING INDIA PRIVATE LIMITED',
    'Innovative clad solutions private limited',
    'Ramesh castwell pvt ltd',
    'Kridhan infra solutions private limited',
    'Ashley alteams india limited',
    'Vishakha ispat private limited',
    'Nava karnataka steels private limited',
    'Ski engineering private limited',
    'A k e infra structure private limited',
    'Galco extrusions private limited',
    'Azco steels india private limited',
    'Asian extrusions private limited',
    'Southern stainless steel fabrication india private limited',
    'Newtech traders & erectors india private limited',
    'Asiaan metals & aluminium casting private limited',
    'Skg refractories limited',
    'Vjm ceramics private limited',
    'Bhavi tubes and containers pvt ltd',
    'Chemtex engineering of india private limited',
    'Sikka n sikka engineers private limited',
    'Roton vitrified private limited',
    'Ahmedabad strips private limited',
    'Jrd steelpac private limited',
    'Toyo metallurgicals limited',
    'CARYSIL STEEL LIMITED',
    'Ishmeet forgings private limited',
    'VARSHA FORGINGS PRIVATE LIMITED',
    'Capart industries private limited',
    'Armstrong acmite india manufacturing private limited',
    'Sakthi spring forms private limited',
    'Autogistic engineering private limited',
    'GREAVES TECHNOLOGIES LIMITED',
    'AMRO AIRCRAFT CONSUMABLES PRIVATE LIMITED',
    'Maa alu panel (india) private limited',
    'Samarthya engineering private limited',
    'Vision engineering (madras) private limited',
    'Sri sivasakthi engineers p ltd',
    'VCT TOOLING & AUTOMATION PRIVATE LIMITED',
    'Dimo-castings private limited',
    'Cam-pro technologies private limited',
    'Sadanand dies and moulds private limited',
    'Adarsh stainless private limited',
    'A-1 fence products company private limited',
    'CFF FLUID CONTROL LIMITED',
    'Sarwar steel private limited',
    'Manaksia ferro industries limited',
    'ARIEN GLOBAL LIFESTYLE PRIVATE LIMITED',
    'Rkm infotech & developers private limited',
    'Umika tradelink private limited',
    'S.p. fill station private limited',
    'Atman impex private limited',
    'Anil technoplus limited',
    'Ajay natavarlal commodities private limited',
    'Podar organization private limited',
    'SHIVESH UDYOG PRIVATE LIMITED',
    'Maven marketing private limited',
    'Maple exports pvt ltd',
    'Bhartia commodities private limited',
    'Overseas scrap trading company pvt ltd',
    'S p global impex private limited',
    'Gsp impex private limited',
    'Infinijewel synergies private limited',
    'Ranbaxy merchandise pvt ltd',
    'Fast capital markets ltd.',
    'Rika global impex limited',
    'Shakers appliances private limited',
    'Esarco holdings private limited',
    'S square marketing private limited',
    'Acme vyapaar private limited',
    'Goodwill vanijya private limited',
    'Ratnakar vyapaar pvt ltd',
    'Roli om tradecom private limited',
    'Richmond exports private limited',
    'Btb marketing private limited',
    'APEX INFRA ENGINEERING PRIVATE LIMITED',
    'Swift fabrics private limited',
    'Masimo medical technologies india private limited',
    'Teleglobal distributors private limited',
    'Baba basuki commercial pvt ltd',
    'Neelikattu food imports and exports private limited',
    'Aroma horticulture products private limited',
    'Tan business ventures private limited',
    'Silver cross mercantile and exporters private limited',
    'Sparkle syntex private limited',
    'Sudha metal printers private limited',
    'Chime polymers private limited',
    'Omax watches india private limited',
    'East west seeds india private limited',
    'Vasudhara mercantile private limited',
    'Onkyo sight & sound india private limited',
    'Printers supply co private limited',
    'SHRENIK LIMITED',
    'Alfa medisol private limited',
    'Medipaams india private limited',
    'Sarisha commercials private limited',
    'Dhandeep mercantile private limited',
    'Utasvi sales agency private limited',
    'Eastern treasure (india) tours private limited',
    'Arar engineering private limited',
    'Pooja industries private limited',
    'Kpai india private limited',
    'Servetech private limited',
    'Eximpipes private limited',
    'The cotton corporation of india limited',
    'Advent automobiles pvt. ltd.',
    'Mccoy apparels private limited',
    'SAISHKAR APPLIED TECHNOLOGIES PRIVATE LIMITED',
    'Dinesh polyfab private limited',
    'Rck impex private limited',
    'Colourstars dyes trading company private limited',
    'Shri brij commodities private limited',
    'Eureka traders private limited',
    'Longlife export & finance pvt ltd',
    'Ameri-source engineering india private limited',
    'Nivedan mercantiles pvt. ltd',
    'Andromeda fashions ltd',
    'Lakshminarayan gaurishanker enterprises private limited',
    'Jainam electronics private limited',
    'Master integrators private limited',
    'Kanishka industries private limited',
    'Parwati commodity market pvt ltd',
    'Spincotech private limited',
    'Area importers and exporters private limited',
    'Nuvo medsurg private limited',
    'Primerose dealers pvt ltd',
    'Uma vinimay private limited',
    'Reception tracom private limited',
    'Pradman engineering private limited',
    'Dhanlaxmi tieup private limited',
    'Sayonara commerce private limited',
    'Argo tech india private limited',
    'Dml agro trade private limited',
    'Swiss time zone private limited',
    'Vishal amusements limited',
    'Maharshi medipharma marketing private limited',
    'Kanakdhara traders private limited',
    'Gifts 2 you (india) private limited',
    'Composite petroleum services private limited',
    'Riverwaays mines and minerals limited',
    'Sun tex mercantile private limited',
    'Deeco mechatron marketing private limited',
    'Selwel enterprises private limited',
    'Premium mint and herbs private limited',
    'R h power utilities private limited',
    'Ralco synergy private limited',
    'Seksaria enterprises pvt ltd',
    'Sprint exports private limited',
    'Sangrail commercial limited',
    'Harness overseas private limited',
    'Rounak marketing pvt. ltd.',
    'Rani sati impex private limited',
    'Vimas enterprises pvt ltd',
    'Noble business ventures (india) private limited',
    'Bengal kyal housing development limited',
    'Paranjape estate and development company private limited',
    'Ratilal bhagwandas construction company p ltd',
    'Shalini sangeeta developers private limited',
    'CORIANDER INDUSTRIES PRIVATE LIMITED',
    'Ssk landmark private limited',
    'Balaji conclave private limited',
    'Mataji promoter private limited',
    'Tablez properties private limited',
    'Faldayani realtors private limited',
    'Zak real estates private limited',
    'Chiraayu estate and development private limited',
    'Tariq development and leasing private limited',
    'Binodini estate and reality private limited',
    'Karvinda estate and finance private limited',
    'Pranava shelters private limited',
    'Chaarvi reality and development private limited',
    'Shelcon properties pvt ltd',
    'Sumaran projects private limited',
    'Spmk estates private limited',
    'Kt villas pvt ltd',
    'Dynamic infrastructure pvt ltd',
    'D k jain properties private limited',
    'Divine spring real estate private limited',
    'Watermarke residency limited',
    'B.j.s. builders private limited',
    'Bhavesh properties private limited',
    'Embassy developers private limited',
    'Embassy housing private limited',
    'Penta properties private limited',
    'Rockline developers private limited',
    'Elicit realtech private limited',
    'Shri shirdi sai infra and engineers private limited',
    'Native buildcon private limited',
    'River dale estates private limited',
    'Nandi intellectual properties private limited',
    'Embassy apartments private limited',
    'Bitrag properties private limited',
    'Maxolin developers private limited',
    'Arushi realtors pvt ltd',
    'Bhaveshwar properties private limited',
    'Blue river projects private limited',
    'Wbn infrastructure private limited',
    'Ganaraya land private limited',
    'Shrinet and shandilya construction private limited',
    'Kejriwal real-infra projects private limited',
    'Mrg developers private limited',
    'Dpn megacity infraprojects private limited',
    'Oshian realtors india private limited',
    'Opm promoters private limited',
    'Leopard infratech private limited',
    'Jayadarsini constructions private limited',
    'Jayadarsini properties private limited',
    'Implex infrastructure private limited',
    'Ramky wavoo developers private limited',
    'Amar prakaash developerss private limited',
    'D2d homes private limited',
    'DREAMS LADDER BUILDERS LIMITED',
    'Rajam property management services private limited',
    'Prakash estates pvt ltd',
    'Akc developers limited',
    'Ahmed estates private limited',
    'Ruhil properties private limited',
    'Rimjhim properties pvt ltd',
    'Srh infrastructure private limited',
    'Salasar properties pvt ltd',
    'Rosewood agencies private limited',
    'Lecon engineers and contractors private limited',
    'Muskan projects private limited (trf.)',
    'RELIANT TOWNSHIP PRIVATE LIMITED',
    'Madras eco-build private limited',
    'Ssb realtech projects limited',
    'CONNOISSEUR FOODS PRIVATE LIMITED',
    'SKETCH HOMES PRIVATE LIMITED',
    'Brainwave applications ltd',
    'Shrine buildtech private limited',
    'Celerity infrastructure private limited',
    'Valdel real estate private limited',
    'Tdi realcon private limited',
    'Maravilloso realtors private limited',
    'Noida towers private limited',
    'Coral brio inframanagement private limited',
    'Bansidhara reality and estate private limited',
    'Haripriya buildcon private limited',
    'Mayur shops private limited',
    'Kunj real estate and investment private limited',
    'Asteroid realty private limited',
    'Sspdl retreat private limited',
    'Standard enclave private limited',
    'Wellfare buildings and estates private limited',
    'Carroll reality and finance private limited',
    'Hari estate and development private limited',
    'Chaalaka development and reality private limited',
    'Shree chakra properties and investment private limited',
    'Aashti realtors private limited',
    'Rachit realcon private limited',
    'Nalanda estates southern india private limited',
    'Abet buildcon private limited',
    'Arising estates private limited',
    'Dreamlight towers private limited',
    'Civtech projects (i) private limited',
    'Abani nirman pvt.ltd.',
    'Pawa industries private limited',
    'Dynamic tours private limited',
    'Armstrong rubber limited',
    'Turbovent industries private limited',
    'Hi speed movers private limited',
    'Metrowheel tyres private limited',
    'Multimedia features private limited',
    'J b media private limited',
    'Wan - ifra south asia private limited',
    'Little feet services private limited',
    'Indian technological products private limited',
    'Logicsoft international private limited',
    'Meridian hospital services private limited',
    'Immunolab (india) private limited',
    'Foampack india private limited',
    'System network private limited',
    'Hlm associates consultants private limited',
    'Labotron instruments private limited',
    'Abr auto private limited',
    'Reckers automation india pvt ltd',
    'National contracting company india private limited',
    'Unique air services pvt ltd',
    'Epsilon india private limited',
    'Guntur industries private limited',
    'DUHY LOGISTICS PRIVATE LIMITED',
    'Rksv securities india private limited',
    'Perennial lifesciences private limited',
    'Futureworks consulting private limited',
    'Ecco electronics private limited',
    'Vibrant advertising pvt ltd',
    'Ecorys india private limited',
    'Vishwas bawa advertising private limited',
    'Insight lifecycle software & consulting private limited',
    'Eurind resources private limited',
    'Apex aim retail private limited',
    'Stanford biosciences private limited',
    'Gestor advisors private limited',
    'Selvel publicity and consultants private limited',
    'Crescent 3m gymkhana private limited',
    'TECHNIGENT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Global esspak private limited',
    'Spirit of outdoors private limited',
    'Beaumanoir india private limited',
    'Unitus capital private limited',
    'Parallel track mhe private limited',
    'Radha mohan innovative services private limited',
    'Values centered innovation enablement services private limited',
    'Marketspade sales and marketing private limited',
    'Design ventures engineering consultants (india) private limited',
    'PEC PROJECTS & ENGINEERING PRIVATE LIMITED',
    'Travel pals india private limited',
    'Jmd cargo private limited',
    'Farvision electronics (india) private limited',
    'Sunflower finlease private limited',
    'Aadhar securities private limited',
    'COGOPORT FREIGHT FORCE PRIVATE LIMITED',
    'Sony india private limited',
    'WAGO Private Limited',
    'QUANT CAPITAL TRUSTEE LIMITED',
    'Aztec infotech private limited',
    'Synergypro promotions and events india private limited',
    'Nordic light india private limited',
    'Monaro z securite private limited',
    'Universal law publishing co . private limited',
    'ATHARV INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'Ankit services private limited',
    'Kongsberg maritime india private limited',
    'Institute for excellence in services and planning private limited',
    'Brick and byte innovative products private limited',
    'Sumarth refractories private limited',
    'Saksham analytical instruments private limited',
    'Pawansut credits private limited',
    'Foto planet private limited',
    'Galleon instru-tech private limited',
    'Nexus enterprises private limited',
    'Science olympiad foundation',
    'Pannest integrated services private limited',
    'Saksham digital private limited',
    'Seaborne maritime india private limited',
    'HLS-SJM ADVISORS INDIA PRIVATE LIMITED',
    'Orpak systems india private limited',
    'Skp title search private limited',
    'Easy medi-claim reviews private limited',
    'Cogent emr solutions limited',
    'Hardcastle gis solutions private limited',
    'Thinking dimensions india private limited',
    'Satnam haegens limited',
    'Innov controls technology india private limited',
    'Docpulse technologies private limited',
    'Ascb(e) accreditation private limited',
    'Brainlifescience research institute private limited',
    'Skylink express services private limited',
    'Careerstack innovations private limited',
    'VCNR TECHNOLOGIES PRIVATE LIMITED',
    'Seedfire venture advisors private limited',
    'LIGHTROCK CORPORATE SERVICES PRIVATE LIMITED',
    'Business intelli solutions india private limited',
    'Ultrawater solutions & services private limited',
    'Genome valley tech parks & incubators private limited',
    'MINDCOMP PROPERTIES PRIVATE LIMITED',
    'ENTRUST ENCORE SERVICES PRIVATE LIMITED',
    'M.ashokkumar fabrics private limited',
    'Vishwakarma mines and building materials private limited',
    'Gkv international private limited',
    'Amalgam foods limited',
    'Sjlt spinning mills private limited',
    'Ayush food product private limited',
    'VIJAYANAGAR FOOD & NUTRACEUTICALS PRIVATE LIMITED',
    'Dwarikadhish spinners limited',
    'Gpi textiles ltd',
    'RATHIK NATURE FARMS PRIVATE LIMITED',
    'Uniform blenders private limited',
    'Shree girivar enterprises private limited',
    'Mafatlal impex private limited',
    'Rustic-urban food park private limited',
    'KHYBER RESIDENCES PRIVATE LIMITED',
    'Oceanking texfab private limited',
    'Bison mills (india) private limited',
    'Pioneer textiles corporation private limited',
    'Seksaria industries private limited',
    'Mehratex india private limited',
    'Geeta silk mills private limited',
    'Paharia silk mills private limited',
    'Masturlal fabrichem private limited.',
    'Reeti exim and application private limited',
    'Acme care international private limited',
    'Sh food processing private limited',
    'MUDRA DENIM PRIVATE LIMITED',
    'Chiripal poly films limited',
    'Madura industrial textiles limited',
    'Ganapati polytex limited',
    'Vibrant cotfab private limited',
    'Creative kids wear (india) private limited',
    'Lineage agro industries private limited',
    'Dugar insulations india private limited',
    'Gadarigudda mining services private limited',
    'Marble centre international private limited',
    'Angadi ventures private limited',
    'PODAR SPINNING MILLS, PVT LTD',
    'Leen international fabrics private limited',
    'Jaisar spintex private limited',
    'Standards international precision engineers private limited',
    'Kaizen cnc centre private limited',
    'IPSAA ALLURE PRIVATE LIMITED',
    'Aztecs technologies private limited',
    'Royalex fashions (india) private limited',
    'MEDICOCORP LIFE CARE PRIVATE LIMITED',
    'Ruia garments private limited',
    'Nbs international limited',
    'Ardy international pvt ltd',
    'TRADITIONAL GALLERY PRIVATE LIMITED',
    'Southern tex exports india limited',
    'Penguin apparels private limited',
    'Valli garments private limited',
    'Royal classic mills private limited',
    'Aaa textiles private limited',
    'Sarvesh polyesters pvt ltd',
    'Keenara filaments private limited',
    'Sadguru sri sri sakhar karkhana limited',
    'MDK CHEMTEX PRIVATE LIMITED',
    'Adm agro industries kota & akola private limited',
    'Shree g. m. thaokar (tobacco) private limited',
    'Sacred lotus designs private limited',
    'Pecanz fashion private limited',
    'Ozel clothing india private limited',
    'Camden apparel solutions private limited',
    'JOLIE INFRASTRUCTURE HOLDINGS PRIVATE LIMITED',
    'Rajani fashions private limited',
    'Kanti beverages private limited',
    'Kaycee kala finvest pvt.ltd.',
    'Sachin leathercrafts pvt ltd',
    'Penguins promo products private limited',
    'Arviyas fashions private limited',
    'AEROS FOOTCARE PRIVATE LIMITED',
    'Anand fabricators private limited',
    'Nirvana india private limited',
    'Siyaram grain services private limited',
    'Pap-print (india) private limited',
    'Deluxe recycling (india) private limited',
    'Sbt spintex private limited',
    'South city projects (kolkata) limited',
    'Vijay anand kraft papers private limited',
    'Crystal print and pack private limited',
    'Super coats carbonless paper mills private limited',
    'Stratpost media private limited',
    'Cotlon india private limited',
    'Siltex international limited',
    'S.m.garments private limited',
    'Bmp steels private limited',
    'Kbc marble and granite private limited',
    'In entertainment (india) limited',
    'S.m.apparels private limited',
    'New horizons cottex private limited',
    'Network clothing company private limited',
    'W w apparels india private limited',
    'Jenco cotfab private limited',
    'UNIVERSAL THREADS PRIVATE LIMITED',
    'Ninaad textiles private limited',
    'Khemka klothings private limited',
    'Orissa artisans and weavers limited',
    'V s r printers private limited',
    'Neovation graphics private limited',
    'Vs lignite power private limited',
    'Vss clean technologies private limited',
    'AMR SPACE PRODUCTS PRIVATE LIMITED',
    'Hks automobiles private limited',
    'Jayshree motors private limited',
    'Srikara sagar freight services private limited',
    'East coast energy private limited',
    'GRETA POWER LIMITED',
    'Solar semiconductor private limited',
    'Vaishnavi urja private limited',
    'Hov energy private limited',
    'PANAMA RENEWABLE ENERGY PRIVATE LIMITED',
    'Dynamic infroat private limited',
    'Kgn bio-fuels private limited',
    'Blue star power solutions private limited',
    'Rochem green energy private limited',
    'Kanoda energy systems private limited',
    'Chiripal energy limited',
    'Kotak power private limited',
    'Scalene energy - water corporation limited',
    'Valley shipbuilding co private limited',
    'Della tecnica office systems private limited',
    'Jyoti architectural products private limited',
    'Nornament designers private limited',
    'Dakshesh energy private limited',
    'Meenakshi odisha power private limited',
    'Laurus green power private limited',
    'GUJARAT GAS LIMITED',
    'ROCHEM SERVICES PRIVATE LIMITED',
    'Solariz regen technologies private limited',
    'Gp wind (jangi) private limited',
    'Il&fs energy development company limited',
    'Birla terrajoule private limited',
    'Harsh energy private limited',
    'Rge pune waste processing private limited',
    'Kolhapur green energy private limited',
    'Hartex rubber private limited',
    'MCFILLS ENTERPRISES PRIVATE LIMITED',
    'Comet car sales and service private limited',
    'Jewelex india private limited',
    'Soni fine jewelry india private limited',
    'ACHAL JEWELS PRIVATE LIMITED',
    'ARMEE INFOTECH PRIVATE LIMITED',
    'Dhawal giri estates private limited',
    'S.v.c. projects private limited',
    'Ggi softech limited',
    'Devi plasto pack private limited',
    'Visoka engineering private limited',
    'Budhia constructions private limited',
    'Blue sky buildcon private limited',
    'Rajaram steel industries private limited',
    'Kutchh power generation limited',
    'Shivom infraestates private limited',
    'PENCH THERMAL ENERGY (MP) LIMITED',
    'Northselect engineers private limited',
    'Sampanya infrastructure private limited',
    'Bhoruka power corporation limited',
    'Parkson tarini power projects limited',
    'Msg power private limited',
    'Big sun power private limited',
    'Madhav infra projects limited',
    'Ketan construction limited',
    'Royal plots (india) private limited',
    'Solarkiran energy private limited',
    'Super plastic coats private limited',
    'Mechuka hydro power private limited',
    'Reddy housing private limited',
    'Kangtangshiri hydro power private limited',
    'Theatre solutions (india) private limited',
    'Meenakshi arunachal power private limited',
    'C d s construction co pvt ltd',
    'Jpm constructions private limited',
    'Kanyakumari builders pvt ltd',
    'Meenakshi solar power private limited',
    'AG ESTATES LIMITED',
    'Master chain private limited',
    'Joothawat constructions private limited',
    'Trambak homes private limited',
    'Indrajit power private limited',
    'Gharonda construction private limited',
    'Saiprem holding and estate developers private limited',
    'Ashoka errectors private limited',
    'Pravara estate and development private limited',
    'Deepak jewellers and accessories private limited',
    'Counter measures technologies private limited',
    'Makwana properties private limited',
    'SREE VAIBHAVI INFRASTRUCTURES PRIVATE LIMITED',
    'Ultra avenues private limited.',
    'Kenstro - a builders and developers private limited',
    'Meeti developers private limited',
    'Ashtavinayak properties private limited',
    'Rachana homes private limited',
    'Akshar infratech private limited',
    'I-tech developers private limited',
    'Hgcl- niraj-supreme infrastructure private limited',
    'Aballaba developers private limited',
    'Gajra mega structures private limited',
    'Sadguru realspaces private limited',
    'Prakhar estates private limited',
    'Bvg infrastructure limited',
    'Ipt travel private limited',
    'World escapes india private limited',
    'Ishverlal madanlal and company private limited',
    'Mahamaruti logistics private limited (part ix)',
    'Kailash carriers limited',
    'Travelglitz india private limited',
    'Space international air travels private limited',
    'Keerti cargo services private limited',
    'B.b. cargo movers private limited',
    'Air cargo connections (india) private limited',
    'Rhein cargo movers private limited',
    'Oceanking logistics private limited',
    'Karnataka transport co private limited',
    'Tirupati travel network private limited',
    'Maa air ticket centre private limited',
    'Banyan tours private limited',
    'Rainbow aviation private limited',
    'Sathjyot voyageurs private limited',
    'SPARROW TOURS & TRAVEL PRIVATE LIMITED',
    'Svitzer india private limited',
    'ALGO INTELLECT PRIVATE LIMITED',
    'Csn logistics private limited',
    'Gonsai logistics private limited',
    'Topper & router logistics private limited',
    'Bom gim cargo private limited',
    'FIESTA CAR RENTALS & LOGISTICS PRIVATE LIMITED',
    'Total marine (india) private limited',
    'Concord shipping private limited',
    '4u cabs private limited',
    'Velji dosabhai and sons private limited',
    'ZAM ENGG AND LOGISTICS PRIVATE LIMITED',
    'Shree mahalaxmi movers private limited',
    'Universal express travels and tours private limited',
    'Codognotto logistics india private limited',
    'Travel india private limited',
    'Coastal services private limited',
    'Sri mvr logistics private limited',
    'Ryk freight forwarders private limited',
    'GAERISH LOGISTICS PRIVATE LIMITED',
    'Granada air services pvt. ltd.',
    'Tranquility online private limited',
    'Go logistics private limited',
    'Iris cable and broadband private limited',
    'Honesty telecom (india) private limited',
    'Mdc corporation (india) private limited',
    'BLUEFROG MOBILE TECHNOLOGIES PRIVATE LIMITED',
    'Qualcomm india private limited',
    'C-tel infosystems private limited',
    'Fourth generation mobiles retailing and broadband services private limited',
    'Poojara telecom private limited',
    'Outforce services private limited',
    'Cable & wireless networks india private limited',
    'Karuna telelink private limited',
    'Singhal telecommunication private limited',
    'Ell kay yes private limited',
    'MILAHA SHIP MANAGEMENT INDIA PRIVATE LIMITED',
    'Stone travels private ltd',
    'GTPL ABHILASH COMMUNICATION PRIVATE LIMITED',
    'Gtpl space city private limited',
    'Gtpl smc network private limited',
    'Gtpl dahod television network private limited',
    'Den malayalam telenet private limited',
    'Nr switch-n-radio services private limited',
    'Hyderabad cable digital services private limited',
    'Tamilnadu arasu cable t.v. corporation public limited',
    'Bmw india leasing private limited',
    'Mars share broking house private limited',
    'Kannan finance co private limited',
    'Network tours private limited',
    'GD WATER CONSULT PRIVATE LIMITED',
    'Next world india private limited',
    'A j investments pvt ltd',
    'Marvel indenting private limited',
    'GLOBE TEXTILES (INDIA) LIMITED',
    'Vaibhav realty development limited',
    'Saurashtra travels private limited',
    'Namaskar holidays private limited',
    'Ramesh tours and travels private limited',
    'Alchemie financial services ltd',
    'Curlew finlease and investments pvt ltd',
    'Deesha leasecon private limited',
    'Omar finance and leasing private limited',
    'Maheshwari development and leasing private limited',
    'Svitzer hazira private limited',
    'Anvita tours2health private limited',
    'Hospitality finance company india private limited',
    'Way2wealth capital private limited',
    'Greenchannel holidays (india) private limited',
    'Intensive finance private limited',
    'D s l finance private limited',
    'SUA DEVELOPERS LIMITED',
    'MSM MICROFINANCE LIMITED',
    'Shivom holdings private limited',
    'Cellpap finvest private limited',
    'AMBIT PRIVATE LIMITED',
    'PRAGMA BUSINESS VENTURES PRIVATE LIMITED',
    'Investwell securex private limited',
    'Vimal forwarders private limited',
    'Express logistics and trade private limited',
    'AKANA SERVICES PRIVATE LIMITED',
    'Promodome communications private limited',
    'Nostrum technologies private limited',
    'Nexsales solutions private limited',
    'Planet design creative (india) private limited',
    'Scalene cybernetics limited',
    'Swift solution private limited',
    'Allerin tech private limited',
    'Techies infotech private limited',
    'Sequentia software solutions private limited',
    'Compile india private limited',
    'Cartel infosystems private limited',
    'Zynot software private limited',
    'Svs technology services private limited',
    'TOWNHUB INTERNATIONAL SERVICES PRIVATE LIMITED',
    'Anmol technomart private limited',
    'DATAVAL ANALYTICS INDIA PRIVATE LIMITED',
    'Techrel technologies private limited',
    'Myvishwa technologies private limited',
    'EMBOLD SOFTWARE PRIVATE LIMITED',
    'Monarch it solutions private limited',
    'Computer sky it consultancy private limited',
    'Thinktanc innovation labs private limited',
    'Crayons web technologies private limited',
    'Consyst technologies (india) private limited',
    'Chetana technology solutions private limited',
    'Edgematics consulting private limited',
    'Blurbpoint media private limited',
    'INREALITY PRIVATE LIMITED',
    'Axv technologies private limited',
    'Genex healthcare private limited',
    'Chillar payment solutions private limited',
    'Eligible research and development center private limited',
    'Pioneer elabs limited',
    'Uni browsewire consulting private limited',
    'Simplex esolutions private limited',
    '9roots.com private limited',
    'Intercept design solutions private limited',
    'C-edge technologies limited',
    'Rta technologies private limited',
    'Alexia technologies private limited',
    'Ssd web solutions private limited',
    'FUTX IT PRIVATE LIMITED',
    'Voonik technologies private limited',
    'Instamojo technologies private limited',
    'Kst infotech private limited',
    'Tranzlogix info solutions private limited',
    'Software solutions infra private limited',
    'Macrew technologies private limited',
    'Monarch technologies (pune) private limited',
    'Performix solutions private limited',
    'Leo technosoft private limited',
    'Jigishu capital advisors private limited',
    'Keshan infotech private limited',
    'Maven infotech private limited',
    'Cerillion technologies india private limited',
    'Denet software solutions private limited',
    'Team indus foundation for excellence',
    'Association of diagnostics manufacturers of india',
    'Anka technology solutions private limited',
    'ELCIA ESDM CLUSTER PRIVATE LIMITED',
    'Stowe research india private limited',
    'Ftb communications private limited',
    'Eleopard design studios private limited',
    'DP INDUSTRIAL DESIGN & SERVICES (INDIA) PRIVATE LIMITED',
    'Hd medical services (india) private limited.',
    'Magnum estates limited',
    'Samanthu business forms private limited',
    'Time equipment private limited',
    'Cosmos precision engineering private limited',
    'Silver spark apparel limited',
    'Rafaga infoknowledge private limited',
    'Amzel infotech private limited',
    'Kl software technologies private limited',
    'Lifo technologies private limited',
    'Bhumati consultancy services private limited',
    'Sankofa advisors private limited',
    'Nws digital india private limited',
    'Ethnic food products solution limited',
    'Tangp designs private limited',
    'Navkar wheels private limited',
    'Blue lion cloud solutions private limited',
    'Netcalyx software technologies private limited',
    'Softborne technology solutions private limited',
    'Swide technologies private limited',
    'Rm converters private limited',
    'Winner international climbing systems private limited',
    'Avant garde advisory private limited',
    'Securew2 india private limited',
    'Omnex software solutions private limited',
    'Sierra support centre private limited',
    'Dd web vision private limited',
    'Vedula technology private limited',
    'Global innovation & technology alliance',
    'Global gene corp private limited',
    'XINRONGSHENG MOBILE DEVICES PRIVATE LIMITED',
    'Bnt soft private limited',
    'Multi mantech international private limited',
    'Spring convergence services private limited',
    'Icf consulting india private limited',
    'Rural management consultants private limited',
    'Healing hands lifecare private limited',
    'Tradition n trendz event management private limited',
    'Molecular multispeciality hospitals private limited',
    'S n m nursing home pvt. ltd.',
    'Aakar exhibition private limited',
    'Never grow up workshops private limited',
    'Subbu and company private limited',
    'Kriya studios private limited',
    'Ezemrx india private limited',
    'Smec (india) private limited',
    'Fortis emergency services limited',
    'Fortis hospitals limited',
    'Tridiva ergonomic interiors private limited',
    'Map certifications private limited',
    'Sun infrasystem private limited',
    'Crimson hotels private limited',
    'Chennai school of music therapy private limited',
    'Fragrant nature film creations private limited',
    'VANAVEDA LIFESTYLE PRIVATE LIMITED',
    'GOOD FELLOW FOREIGN SERVICE PRIVATE LIMITED',
    'L.s.c enterprises private limited',
    'RAJSHRI PICTURES PVT LTD',
    'HYPAETHRAL MEDIA PRIVATE LIMITED',
    'A.s. chowdhri nava bharat foundation',
    'Dove imaging private limited',
    'Swaraj facility management private limited',
    'Shimadzu analytical (india) private limited',
    'RGN SOLIDIANCE PRIVATE LIMITED',
    'Holy water entertainment private limited',
    'Shrinathji eco aqua private limited',
    'TRACEBEE LEARNING PRIVATE LIMITED',
    'Movida india private limited',
    'Greshma wealth advisors private limited',
    'ALMA LOGISTICS PRIVATE LIMITED',
    'HRXL 360 PRIVATE LIMITED',
    'Yreach media private limited',
    'Fincon taxation and solutions private limited',
    'Kinduz business consulting private limited',
    'Oorja energy engineering services (hyderabad) private limited',
    'Integrated pest management solutions (india) private limited',
    'Sdk advisory and consultants private limited',
    'Orbit staffing innovision private limited',
    'Harley street medical park theraputics private limited',
    'Arohana seva foundation',
    'Cargo consol india private limited',
    'Saciva services private limited',
    'Elecom fiesta entertainment private limited',
    'Atharav sanglikar entertainment & media private limited',
    'Mira integrated marcom services private limited',
    'Maxgrowth capital private limited',
    'Devavani lifestyle private limited',
    'Oysterz entertainment private limited',
    'Anchor management services private limited',
    'Lakeland gloves and safety apparel private limited',
    'Nvt quality certification private limited',
    'Ramarapu marketing private limited',
    'Footworks india private limited',
    'PRIME NEWS24 WEB CHANNEL PRIVATE LIMITED',
    'Roofnride travel services private limited',
    'Magnanimous ventures private limited',
    'Balaji tambe health care private limited',
    'Motor vehicles allied industries association',
    'Automotive component manufacturers association of india',
    'Mastercard india services private limited',
    'Eurrestra industries limited',
    'Platoon securitas private limited',
    'Ivarene technologies private limited',
    'Cinevista eagle plus media private limited',
    'Santech safety engineers private limited',
    '24x7 facility service connect private limited',
    'I-land sports academy',
    'Triune exhibitors private limited',
    'Sainath granite and marble private limited',
    'Unilazer ventures private limited',
    'Bhupendra impex private limited',
    'Furnova polymers ltd',
    'Siddhi property developrs pvt ltd',
    'Layer exports private limited',
    'Bangla entertainment private limited',
    'Pmi organization centre private limited',
    'Freakouts adventure solutions private limited',
    'Drishti special response services private limited',
    'YAGNM INDUSTRIES PRIVATE LIMITED',
    'HIRANYA RESORTS PRIVATE LIMITED',
    'Celestial steel structures private limited',
    'Sanap agroanimals private limited',
    'Kem oil private limited',
    'Aravali hi-tech private limited',
    'Outsourced solutions private limited',
    'Jsw bengaluru football club private limited',
    'Otco international limited',
    'Celebrity fashions limited',
    'Tetron commercial ltd',
    'Ritesh exports limited',
    'Suryalata spinning mills limited',
    'Ruchira papers limited',
    'Fineotex chemical limited',
    'Riddhi siddhi gluco biols limited',
    'Vision corporation limited',
    'Godavari drugs limited',
    'Pfizer limited',
    'Dickinson fowler private limited',
    'Lubing india private limited',
    'Prasad acumeter pvt ltd',
    'Auto ref system private limited',
    'Ekso hydro clean tech private limited',
    'Rupkala engineers private limited',
    'Kaushik cesan equipments india private limited',
    'Ascend fluid tools private limited',
    'Smart hydrolink equipment private limited',
    'Affluent tools private limited',
    'Adico spares private limited',
    'Airtech private limited',
    'Ductmaster (india) private limited',
    'RADIANT POWER SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Weavetech engineers limited',
    'Dada fire works pvt ltd',
    'A P C SYSTEM & PRODUCTS PVT LTD',
    'Shell-n-tube private limited',
    'M k brothers manufacturers private limited',
    'Hawe hydraulics private limited',
    'Kejriwal machineries pvt ltd',
    'Climaveneta climate technologies private limited',
    'SAVELLI MACHINERY INDIA PRIVATE LIMITED',
    'Mb crusher india private limited',
    'Mahavir submersibles private limited',
    'E-motion power limited',
    'Vsr auto engineering private limited',
    'Tejfire safety india private limited',
    'Getech equipments international private limited',
    'Ariv technologies private limited',
    'Hercules structural systems private limited',
    'Avco tech india private limited',
    'Ishwar technocrats private limited',
    'SRP GEARS PRIVATE LIMITED',
    'Watermaker (india) private limited',
    'Tespa tools private limited',
    'Zetko-dkv technik (india) private limited',
    'Hine hydraulics india private limited',
    'New imperial associates exim private limited',
    'Reco transformers private limited',
    'Rashmi mechatronics company private limited',
    'Astun technologies private limited',
    'Tpsc (india) private limited',
    'Samcal cutting solutions (india) private limited',
    'Chrystec machine tools private limited',
    'Avon data cables private limited',
    'Skanda manufacturing systems private limited',
    'Pmi process systems private limited',
    'Schuf speciality valves india private limited',
    'RAMANA SAFETY AND SYSTEMS (INDIA) LIMITED',
    'Secure seals (india) private limited',
    'Safe packaging private limited',
    'Shellex services private limited',
    'Bilaspur mining industries private limited',
    'Minecs finvest private limited',
    'Jmg telecom infra solutions private limited',
    'Canflex engineering private limited',
    'Powermag control systems private limited',
    'Ssec foundry equipment private limited',
    'Ifm engineering private limited',
    'PRIMA POWER INDIA PRIVATE LIMITED',
    'Omkar engineering works private limited',
    'Dsk milkotronics private limited',
    'Mkp engineers (india) private limited',
    'Modine thermal systems private limited',
    'Mutha precision private limited',
    'Nutek technologies private limited',
    'Sparrows offshore services india private limited',
    'Stilonn engineering private limited',
    'Eurogear asia private limited',
    'MATHESON BOSANQUET ENTERPRISES Private Limited',
    'L cube innovative solutions private limited',
    'Uniware systems private limited',
    'WEB NETWORKS MADRAS P LTD',
    'Sensiple software solutions private limited',
    'Dharma systems private limited',
    'Ansata computer systems private limited',
    'Cimtrix systems private limited',
    'Xpress computers limited',
    'Benteler engineering chennai private limited',
    'Pinter fa.ni asia private limited',
    'Ace climate control technologies private limited',
    'P r e machines (india) private limited',
    'Seetharam mechatronics private limited',
    'Crossroads systems private limited',
    'Shani peripherals private limited',
    'Unitech transformers private limited',
    'Lift and lash private limited',
    'Ceaze fire safety systems private limited',
    'Capeindustrial services private limited',
    'Prism surface coatings private limited',
    'Veeram pack private limited',
    'Khare engineering and tools pvt ltd',
    'Olivine mercantiles pvt ltd',
    'Mark computers private limited',
    'Pioneer elecmech (india) private limited',
    'Polyhydron systems private limited',
    'Devson switchgear and controls pvt ltd',
    'Messung systems private limited',
    'Severn glocon india private limited',
    'NIRAYU LIMITED',
    'SAMRICK INDIA PRIVATE LIMITED',
    'Keshri infotech private limited',
    'Tti electronics asia (india) private limited',
    'Sun power controls and services private limited',
    'Dakshin trades and commerce private limited',
    'Abad exports pvt ltd',
    'Harley carmbel india private limited',
    'Straits trading company private limited',
    'Salzer exports limited',
    'Sharon solutions limited',
    'Stardom trading company private limited',
    'BHAIRAV EXPORTS INDUSTRY PRIVATE LIMITED',
    'Newleader mercantile company private limited',
    'Nariman commodity services private limited',
    'Bions medical systems private limited',
    'Kalyani radiotherapy specialty india private limited',
    'L.n.exim private limited',
    'Intellivest india private limited',
    'Fukui accent trading (india) pvt. ltd.',
    'Jagdamba threads private limited',
    'Home depot sourcing india private limited',
    'Az trading private limited',
    'Mahaveer exports private limited',
    'Sppl marketing private limited',
    'Yasheka impex private limited',
    'Idd distribution private limited',
    'Satellite multicomm private limited',
    'Sri balaji castings private limited',
    'Masterpiece merchandise private limited',
    'Aeropol trading and finance pvt ltd',
    'System control & automation pvt ltd',
    'Axis polychrome private limited',
    'Way2wealth commodities private limited',
    'Hi life traders pvt ltd',
    'La monde trading & investments private limited',
    'Urban infra nirmaan private limited',
    'Salasar distributors private limited',
    'Zest commercial private limited',
    'North east consumer goods private limited',
    'Shivam consumer goods private limited',
    'Kamrup marketing private limited',
    'Daffodil vyapar private limited',
    'Amrita vyapaar pvt ltd',
    'Manju vyapaar private limited',
    'Shreeparna vinimay private limited',
    'Bestview vinimay private limited',
    'Zenstar commercial private limited',
    'Exclusive commotrade private limited',
    'Instyle distributors private limited',
    'Skipper merchandise private limited',
    'Akshara vincom private limited',
    'Cairful suppliers private limited',
    'Jasper suppliers private limited',
    'Greenwell specialty healthcare private limited',
    'Krish murari impex private limited',
    'Ab mobile standards alliance india private limited',
    'Kishan murari trade private limited',
    'Surya motocorp private limited',
    'Alma mater store private limited',
    'G s e-commerce private limited',
    'Net distribution services private limited',
    'Carpenters classics(exim)private limited',
    'Radics healthcare private limited',
    'Me n moms private limited',
    'Sina chemtrade private limited',
    'Mangalshiv retailers private limited',
    'Suvridhi dealtrade private limited',
    'Rnb music private limited',
    'Atrium textiles private limited',
    'Germon steels global private limited',
    'Hi-choice collections private limited',
    'Avit digital private limited',
    'Online instruments (india) private limited',
    'KURLON TRADE & INVESTMENT LIMITED',
    'Valy impex private limited',
    'ZULAIKHA HOTELS PRIVATE LIMITED',
    'Am trident technologies private limited',
    'Alp system india private limited',
    'Vibhit enterprises private limited',
    'Sonen impex private limited',
    'Rise n shine imports & exports private limited',
    'SAAKSHI MEDTECH AND PANELS LIMITED',
    'Window technologies private limited',
    'Chemstar marketing private limited',
    'Kena marketing private limited',
    'Gifts forever private limited',
    'Prajay developers private limited',
    'Annapoorna agencies private limited',
    'SRIARANATH LOGISTICS LIMITED',
    'ATYAM MINING PRIVATE LIMITED',
    'Eden exim limited',
    'M l s marketing private limited',
    'OILEX TRADING PRIVATE LIMITED',
    'Lifeway solar devices private limited',
    'Clover dealers private limited',
    'Signature apl enterprise private limited',
    'Phoneshop lifestyles (india) private limited',
    'M.r.g. tradelinks private limited',
    'Technoex trading corporation private limited',
    'Arihant holdings limited',
    'BALWARIA HOTELS AND RESORTS PRIVATE LIMITED',
    'Thevanitycase.com (india) private limited',
    'Tulsiyat tek private limited',
    'CREST FINCAP ADVISORS PRIVATE LIMITED',
    'Odessa solutions private limited',
    'Ideal technosoft private limited',
    'Galaxy technologies private limited',
    'Dew info-systems private limited',
    'FINICITY TECHNOLOGIES PRIVATE LIMITED',
    'Ec interactive india private limited',
    'Its 4 solutions private limited',
    'PANACHE DIGILIFE LIMITED',
    'Ascom infotech private limited',
    'Abak infotech private limited',
    'Prosys-micron softech private limited',
    'Silicon netsecure private limited',
    'Soft-tech consultants private limited',
    'Hb solutions private limited',
    'Soft prodigy system s0lutions private limited',
    'Indiacom limited',
    'Mlogica computech (india) private limited',
    'Espoir technologies private limited',
    'Sandnya software private limited',
    'Ignite solutions india private limited',
    'Byg soft technologies private limited',
    'Leoforce india private limited',
    'Sunstar infotech private limited',
    'Software testing certification board',
    'Cogxim technologies private limited',
    'Briskminds software solutions private limited',
    'IIC TECHNOLOGIES PRIVATE LIMITED',
    'SAMPADA BUSINESS SOLUTIONS LIMITED',
    'Navayuga infotech private limited',
    'Clivesysnet private limited',
    'Trellisys.net private limited',
    'Chip integration technologies limited',
    'Dew drop career solutions private limited',
    'Travtech software private limited',
    'Peepal technology and management consulting private limited',
    'San it solutions private limited',
    'Nexshore technologies private limited',
    'Inde systems india private limited',
    'Indus consulting it services private limited',
    'Micromob solutions private limited',
    'Regent computronics private limited',
    'TTEC INDIA CUSTOMER SOLUTIONS PRIVATE LIMITED',
    'Vicky infotech private limited',
    'Eagle creek ventures private limited',
    'Reqtics technologies private limited',
    'Samplytics technologies private limited',
    'Goachiev technologies private limited',
    'Hitouch technologies private limited',
    'Accudata tech solutions private limited',
    'Emigo network experts private limited',
    'Stepson web consultancy services private limited',
    'Innoneur it ventures private limited',
    'Gold systems and communications private limited',
    'Broadgate software solutions private limited',
    'Mapworld technologies limited',
    'M.t.s. medi soft systems private limited',
    'Peers technologies private limited',
    'Itp software (india) private limited',
    'Inooga solutions private limited',
    'PARADIGMIT TECHNOLOGY SERVICES PRIVATE LIMITED',
    'Oriens solutions private limited',
    'Varsun etechnologies private limited',
    'Garnet technologies private limited',
    'Uiser innovations private limited',
    'Mpraxis technologies private limited',
    'Hansa solutions india private limited',
    'Cbay infotech ventures private limited',
    'Prime softtech india private limited',
    'TECHSOPHY INFORMATION SOLUTIONS PRIVATE LIMITED',
    'Fission computer labs private limited',
    'Zenith consultants & software private limited',
    'Neemus software solutions private limited',
    'Keshav information technology solutions private limited',
    'Tekishub consulting services private limited',
    'Egram it services private limited',
    'Surya data management and network technologies private limited',
    'Ies indian engineering services private limited',
    'Ikya technovations private limited',
    'Rational technosoft private limited',
    'Kairos technologies private limited',
    'Inooga business consulting private limited',
    'K2b online private limited',
    'Twilight it professionals private limited',
    'Changepond technologies private limited',
    'Chain-sys (india) private limited',
    'Cellarstone india private limited',
    'Broadline technologies private limited',
    'Synergetic engineering solutions private limited',
    'Sysbiz technologies private limited',
    'Spectrum innovative technologies private limited',
    'Samran tech private limited',
    'Minuscule technologies private limited',
    'Damaka communication and collaboration private limited',
    'Hipro it solutions private limited',
    'Sourcesol interactive technologies private limited',
    'Ardelisys technologies private limited',
    'Qualitime software private limited',
    'Equivas capital private limited',
    'Venkatesa tyagarajan private limited',
    'Mavis satcom limited',
    'Astroved . com private limited',
    'Jaya wood packers private limited',
    'Pna consultancy private limited',
    'Ace hotel brokers india private limited',
    'Sardonyx technologies private limited',
    'Ab business enterprises private limited',
    'Aanoor global corporate solutions private limited',
    'GLOMATRIZ TECHNOLOGIES PRIVATE LIMITED',
    'Liberty carriers private limited',
    'Pgm electro private limited',
    'Zcodia technologies private limited',
    'Esskay design and structures private limited',
    'Ontrack hr services private limited',
    'O gen infosystem private limited',
    'Uniworth laminates ltd.',
    'Corbis solutions private limited',
    'Bhawani digital systems private limited',
    'INTERSTELLAR BUILDCON LIMITED',
    'HI-TECH FILM & BROADCAST ACADEMY PRIVATE LIMITED',
    'Interstate liquid logistics limited',
    'Gujarat urban development company limited',
    'Van oord india private limited',
    'Apple blosom education institute private limited',
    'Online topper learning private limited',
    'Shishukunj international foundation',
    'Govind knowledge ventures private limited',
    'River view health care private limited',
    'Origen test research and implementation bureau private limited',
    'Shanti innovation and research foundation',
    'Linkstreet learning private limited',
    'Coderinstitute training private limited',
    'Biomedical foundation of india',
    'Eduguru india private limited',
    'T.i.m.e. kids private limited',
    'T.i.m.e. education bangalore private limited',
    'Atul institutions of learning',
    'Kirtidhara academic institutions',
    'Mukta academic institutions private limited',
    'AFCOM HOLDINGS LIMITED',
    'Indian institute for food safety',
    'Vatika education services private limited',
    'Riverside education foundation',
    'Goyam diamond institute private limited',
    'Divya knowledge process management limited',
    'Opulentus overseas careers private limited',
    'Institute for research in management and advanced technology',
    'Bansal learning private limited',
    'Voruan education private limited',
    'Costal institute of technology and management',
    'Regent global services (india) private limited',
    'Pipal tree foundation',
    'Potential coaching institute private limited',
    'Dhyeya educational services private limited',
    'Star coaching and learning private limited',
    'Aecc india private limited',
    'Gateway education and training private limited',
    'AMARA LEARNING SPACES PRIVATE LIMITED',
    'Logic management training institutes private limited',
    'Little angel academia private limited',
    'Edusharp finishing school private limited',
    'Viddyarth international academy private limited',
    'Cies academic services private limited',
    'Wardhaman institute of technology and management',
    'Schulke india private limited',
    'Pinkwhale healthcare services private limited',
    'Narayana hrudayalaya surgical hospital private limited',
    'Xact vision medicare private limited',
    'Aspire health care solutions private limited',
    'SURYA CHILDREN',
    'S RESORT PRIVATE LIMITED',
    'Busabong & co. private limited',
    'Kala niketan retails pvt.ltd.',
    'Machad resorts private limited',
    'Gj freedom fashions limited',
    'Stallion hotel supplies private limited',
    'Truway enterprises private limited',
    'Millard trexim india private limited',
    'Goldenpoint hotel private limited',
    'Zostel hospitality private limited',
    'Eshwar retailing & exports private limited',
    'Zinc cochin hotel private limited',
    'Spot hospitality private limited',
    'Avza enterprises private limited',
    'Savshanti motels pvt ltd',
    'Jyot overseas private limited',
    'Maple finedine private limited',
    'Jmv holiday resort private limited',
    'ECO CAMPS & LODGES PRIVATE LIMITED',
    'Sanctuary hospitality private limited',
    'Mecmag hotels private limited',
    'Windsor gardens private limited',
    'Hotel ashwin private limited',
    'Kingsbridge india private limited',
    'Kapico kerala resorts private limited',
    'KAMATHS SPECIALITY HOTELS PRIVATE LIMITED',
    'Vipra enterprises private limited',
    'Shaw hotels and consultancy services private limited',
    'Hug foods private limited',
    'Vatika homes and hotels private limited',
    'Delta transportation private limited',
    'True logistics private limited',
    'Aarone resorts private limited',
    'Uei global education private limited',
    'Iggi highway motels limited',
    'Tommaso hotels & resorts private limited',
    'KGL NETWORK PRIVATE LIMITED',
    'Qbs logistics private limited',
    'Sigma supply chain solutions private limited',
    'Nallathambbi resort private limited',
    'Passion hotels private limited',
    'Borneo resorts limited',
    'Teak valley resorts pvt ltd',
    'Thachankary estates and resorts private limited',
    'S priyadarshini hotel india private limited',
    'Marline marine services private limited',
    'Evangrove shipping mumbai private limited',
    'Impulse logistics private limited',
    'Veer shipping private limited',
    'Luan airways private limited',
    'Makjai airlines limited',
    'Interglobe air transport limited',
    'Grand hotel (bombay) pvt ltd',
    'Yuvaraj inns & motels private limited',
    'Aviotech private limited',
    'Swajas air charters limited',
    'Meadows holidays and resorts private limited',
    'Acron hospitality private limited',
    'Ville valley holiday resorts private limited',
    'Elefantasy journeys private limited',
    'Track holidays private limited',
    'Amco cargo systems (india ) private limited',
    'Bharati freight forwarders private limited',
    'Vap translift private limited',
    'Air-sea-line logistics private limited',
    'Makharia hospitality private limited',
    'Little river club and resorts india private limited',
    'Sas residency hotel private limited',
    'Gem stone beach resorts private limited',
    'Nisha roadways private limited',
    'Infinity logistics & supply chain private limited',
    'Expo freight private limited',
    'Orient marine lines logistics & warehousing private limited',
    'TVS SUPPLY CHAIN SOLUTIONS LIMITED',
    'Tidel cargo logistics private limited',
    'Five star shipping agency private limited',
    'Dts cargo private limited',
    'Dex cargo services private limited',
    'Seaport lines (india) private limited',
    'Esskay shipping services private limited',
    'Express industrial services private limited',
    'Challengers aviation private limited',
    'Concor air limited',
    'Ayush international hotels private limited',
    'Fish curry rice private limited',
    'Amalgamated property developers private limited',
    'Deccan resorts (mahad) pvt ltd',
    'SAUMYA CONSTRUCTION PRIVATE LIMITED',
    'Five star logistics private limited',
    'Dmc global logistics (india) private limited',
    'Grand india travel advisors private limited',
    'Boxman logistics private limited',
    'Contrans cargo private limited',
    'APURVA NATVAR PARIKH & CO PRIVATE LIMITED',
    'Aita carriers private limited',
    'Scenic journeys private limited',
    'CEDAR AVIATION TRADINGS PRIVATE LIMITED',
    'Chapri cruises india private limited',
    'Kddi india private limited',
    'Purple wave infocom private limited',
    'Thinvent technologies private limited',
    'Newage infocom private limited',
    'Pantel technologies private limited',
    'Nimbus adcom private limited',
    'Mongodb software india private limited',
    'Slick digital private limited',
    'Achala it solutions private limited',
    'DCS INDUSTRIES PRIVATE LIMITED',
    'J.v. abacus net-comm private limited',
    'Navit software solutions private limited',
    'Reliable technosystems india private limited',
    'Virscent technologies private limited',
    'Rao computer consultants private limited',
    'Getronics solutions india private limited',
    'Zycus infotech private limited',
    'Bizruntime it services private limited',
    'Impression systems & software private limited',
    'Aria digital solutions private limited',
    'Mwebware software services private limited',
    'Edgefx technologies private limited',
    'Freaquer corporation private limited',
    'E-CYCLE SOLUTIONS PRIVATE LIMITED',
    'Bahwan cybertek private limited',
    'Pho-com-net private limited',
    'Regal cad services private limited',
    'Blob infotech private limited',
    'Edomotics smart systems private limited',
    'Mar info solutions private limited',
    'Square network solutions private limited',
    'Auriga private limited',
    'Professional digisign e-services private limited',
    'Brainmine web solutions private limited',
    'Vembu systems private limited',
    'Mybusiness visual india private limited',
    'Kompsos media private limited',
    'Techence it solutions private limited',
    'Solartis technology services private limited',
    'Bolegaindia.com web private limited',
    'Enercomp solutions private limited',
    'Nath outsourcing solutions private limited',
    'Tech revo india private limited',
    'Gateway softech private limited',
    'Midas technosystem private limited',
    'Payguru technosoft private limited',
    'Convexicon software solutions india private limited',
    'Ehorizons soft tech private limited',
    'Gmt infotech private limited',
    'Furstlook techno solutions private limited',
    'Mediology software private limited',
    'Threesixty logica testing services private limited',
    'Garg technologies & concepts private limited',
    'Techtronics consulting private limited',
    'BIZCLOCK DIGITAL MEDIA PRIVATE LIMITED',
    'Victory eservices private limited',
    'Maximizer e-services private limited',
    'I-genius global services private limited',
    'Msbc solutions (india) private limited',
    'Mwi india private limited',
    'Origin global services private limited',
    'Syncapps online ventures private limited',
    'Prismetric technologies private limited',
    'Vision smartlink networking private limited',
    'HAPPY E ZON PRIVATE LIMITED',
    'Elecom toon private limited',
    'World certification institute india private limited',
    'Jnanalok infotech private limited',
    'Prakash technologies private limited',
    'Esskey outsourcing private limited',
    'Fortumo mobile services private limited',
    'My mobile infomedia private limited',
    'Haut it solutions private limited',
    'BRAINLABSDIGITAL INDIA PRIVATE LIMITED',
    'Madhu infotech (india) private limited',
    'DJAX TECHNOLOGIES PRIVATE LIMITED',
    '1message technology private limited',
    'Benchmark professionals private limited',
    'Cadmaxx solutions private limited',
    'Shivansh solutions private limited',
    'Illuminati software private limited',
    'Webliance private limited',
    'Moonfrog labs private limited',
    'Starone it solutions (india) private limited',
    'Bytefive info solutions private limited',
    'Agilent bpo private limited',
    'Madrone software technologies india private limited',
    'Radware india private limited',
    'Hypotenuse corporation private limited',
    'Shree sai computer concept india private limited',
    'DWELLSMART PRIVATE LIMITED',
    'Crac infosystems private limited',
    'Atomic it solutions private limited',
    'M v infotech systems private limited',
    'Boral infotech private limited',
    'Venus infocom private limited',
    'Computer source (india) private limited',
    'Omnie solutions (india ) private limited',
    'Xultant organosynth private limited',
    'Directi internet solutions private limited',
    'Vista infosec private limited',
    'Bookmytruck private limited',
    'Digital ventures private limited',
    'Edusmart academy private limited',
    'Ecogreen international private limited',
    'Express dailycare services private limited',
    'Liberty maritime services private limited',
    'ADAYU MINDFULNESS LIMITED',
    'SKANRAY HEALTHCARE GLOBAL PRIVATE LIMITED',
    'Kickstart services private limited',
    'Prosperita medi 360 private limited',
    'Steps knowledge services private limited',
    'Sv solar private limited',
    'Aumento cotex industries private limited',
    'New gen skills institute private limited',
    'Neocare diagnostics private limited',
    'Aaria bio - lifesciences research private limited',
    'J. c. education foundation',
    'Crackverbal edutech private limited',
    'Redbridge juniors education private limited',
    'Amor pune steiner school',
    'Genc learning solutions private limited',
    'International oncology services private limited',
    'Fortis health management limited',
    'Sny cosmos overseas educonsultants private limited',
    'Career mosaic private limited',
    'SHALBY INTERNATIONAL LIMITED',
    'Impetus wellness private limited',
    'Prime tele extrusions limited',
    'Karnataka turned components private limited',
    'NAMTECH PROPERTIES LIMITED',
    'Sri nakoda construction limited',
    'Si2 microsystems private limited',
    'Bna flexinet systems limited',
    'Deccan creations private limited',
    'Vardhman health specialities private limited',
    'MANIPAL HOSPITALS (BENGALURU) PRIVATE LIMITED',
    'Healthtree services private limited',
    'Muralya hospitals private limited',
    'Iflame institute private limited',
    'AARYANANDI FINCAP LIMITED',
    'Seasons healthcare limited',
    'Anand eye institute private limited',
    'Apollo health and lifestyle limited',
    'Vibgyor knowledge learning private limited',
    'Kaya kalp drugless healing private limited',
    'Fortis health management (east) limited',
    'Top gear education private limited',
    'Quagnitia learning private limited',
    'Hosur super speciality hospitals private limited',
    'RANDALL-WIND ENGINEERING INDIA PRIVATE LIMITED',
    'Sadguru healthcare services private limited',
    'Indu drugs private limited',
    'Kappans school of accountancy and management private limited',
    'Fortis healthstaff limited',
    'Medi contrivers (india) private limited',
    'PENTRISE DEVELOPERS PRIVATE LIMITED',
    'Trios development support private limited',
    'Vibrant healthcare private limited',
    'Apollo telemedicine networking foundation',
    'Tenshi assisted living private limited',
    'Shailaja nair foundation',
    'Ce-chem pharmaceuticals private limited',
    'V-care foundation',
    'Gujarat gopalak development corporation limited',
    'Goldwin health care private limited',
    'Ag enviro infra projects private limited',
    'Water and sanitation for urban poor (india)',
    'INDIAN CUTTING TOOL MANUFACTURERS',
    'Dhanpriya textiles private limited',
    'Lombards private limited',
    'Prabha exports private limited',
    'Prescient biosciences private limited',
    'Shriniwas electro steel limited',
    'Jayalaxmi multi trade private limited',
    'Golsil exim private limited',
    'Tashu impex private limited',
    'SABOORI COLLEZIONE INTERNATIONAL PRIVATE LIMITED',
    'Vr restaurants private limited',
    'Namaste india aviation private limited',
    'Expo century logistics private limited',
    'Bass clothing private limited',
    'Halitious developer limited',
    'Accendere knowledge management services private limited',
    'Etsinta advisory private limited',
    'Vanity fintrade private limited',
    'Nalwa fintrade private limited',
    'Dhamankhol fintrade private limited',
    'Ranksheet online services private limited',
    'Comparex india private limited',
    'Windlas healthcare private limited',
    'Tata advanced materials limited',
    'Sands entertainment private limited',
    'Pratishthan alloys private limited',
    'Jmc projects (india) limited',
    'Gruh finance limited',
    'Bheera agro private limited',
    'Agravanshi agro farms private limited',
    'Saps landmark private limited',
    'Kudasan agro pvt ltd',
    'Orion agencies limited',
    'Dynamic oils and oleoresins limited',
    'Harvest gold industries private limited',
    'CASIL HEALTH PRODUCTS PRIVATE LIMITED',
    'Pushpkunj trading company private limited',
    'Maple life style pvt ltd',
    'Techno equity broking private limited',
    'Panalpina world transport (india) private limited',
    'Stallion freight systems private limited',
    'Consolidated photo & finvest limited',
    'Rainy fiscal services pvt ltd',
    'Madhuri investments private limited',
    'HORIZON INVESTMENT COMPANY PRIVATE LIMITED',
    'Kamat holdings private limited',
    'Chandrasen securities private limited',
    'Mjd share and stock brokers private limited',
    'Demris finvest pvt ltd',
    'Hampton investments private limited',
    'Goga builders pvt. ltd.',
    'Goel ganga estates and properties private limited',
    'Trishakti nirman private limited',
    'REYANSH REALTIES PRIVATE LIMITED',
    'Saahil impex private limited',
    'Rishkul properties private limited',
    'Sona promoters pvt ltd',
    'Karaoke amusements private limited',
    'Quatrro processing services private limited',
    'Ellora investment company private limited',
    'Royalsoft services limited',
    'Kamdhenu overseas limited',
    'Avyukta commerce limited',
    'Medall scans and labs tiruvannamalai private limited',
    'Medall scans and labs kallakurichi private limited',
    'Medall scans and labs arupukottai private limited',
    'Medall scans and labs aranthangi private limited',
    'Maharashtra ambuja exports limited',
    'Ncs sugars (nellore) limited',
    'Mahavir weaves pvt ltd',
    'Sri harini textiles limited',
    'SARTHAK ENTERTAINMENT PRIVATE LIMITED',
    'Aarone projects private limited',
    'Dilli karigari limited',
    'POPULAR POLYPACK PRIVATE LIMITED',
    'SHANKU',
    'S PRAKRITIK KHANA PRIVATE LIMITED',
    'ARCHIDPLY DECOR LIMITED',
    'AESTHETIC INTERNATIONAL PRODUCTS PRIVATELIMITED',
    'ARROW BROGUES PRIVATE LIMITED',
    'SKIPPER HOSIERY PRIVATE LIMITED',
    'ORI VENTURES PRIVATE LIMITED',
    'FAITH APPARELS INDIA PRIVATE LIMITED',
    'ALBITONY LIFESTYLE PRIVATE LIMITED',
    'ALPINEHILL GARMENTS PRIVATE LIMITED',
    'CLOTEQ APPARELS PRIVATE LIMITED',
    'AMBATTUR FASHION INDIA PRIVATE LIMITED',
    'MOBOZIN MICRONUTRIENTS PRIVATE LIMITED',
    'RISHIKESHWAR MILLS PRIVATE LIMITED',
    'TRIMURTI FRAGRANCES & FLAVOURS PRIVATE LIMITED',
    'SKC BROADCAST1 PRIVATE LIMITED',
    'VTP RAIRAH FOODS PRIVATE LIMITED',
    '20MED DIGITAL SERVICES PRIVATE LIMITED',
    'CAKEZONE FOODTECH PRIVATE LIMITED',
    'CRAVEMORE FOOD SERVICES PRIVATE LIMITED',
    'NISWIN FOODS PRIVATE LIMITED',
    'NUTRIAH NOURISH PRIVATE LIMITED',
    'CHAKHLE DILLI PRIVATE LIMITED',
    'CRAFTEA CAFE INDIA PRIVATE LIMITED',
    'SKKU MINERALS INDIA PRIVATE LIMITED',
    'MAGICTAIL WORKS PRIVATE LIMITED',
    'WINWAYS DIGITECH MULTISERVICES PRIVATE LIMITED',
    'AMAR INFRAMECH SOLUTIONS PRIVATE LIMITED',
    'HIND LUMINA GEO-SOLUTIONS PRIVATE LIMITED',
    'AUTOCENTRIC SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED',
    'PASHUPATI COTSPIN LIMITED',
    'OCEANIA AQUA (INDIA) PRIVATE LIMITED',
    'SONKUL AGRO INDUSTRIES PRIVATE LIMITED',
    'ADIOMM PRIVATE LIMITED',
    'ALBERO GREEN ORGANICZ PRIVATE LIMITED',
    'RPA AGRICULTURE INFRASTRUCTURE AND SOLUTIONS PRIVATE LIMITED',
    'JGB FARMER PRODUCER COMPANY LIMITED',
    'HELP US GROW INDIA PRIVATE LIMITED',
    'BELLA EXOTICA PRIVATE LIMITED',
    'BREWITCH PRIVATE LIMITED',
    'FUNGISED SOLUTIONS PRIVATE LIMITED',
    'SWARG AGRITECH PRIVATE LIMITED',
    'STANSON AGRI FARMS PRIVATE LIMITED',
    'SERVE SMILE PRIVATE LIMITED',
    'WANTSTATS RESEARCH AND MEDIA PRIVATE LIMITED',
    'VINVISH INNOVATIONS PRIVATE LIMITED',
    'YNA HEALTH CARE SOLUTIONS PRIVATE LIMITED',
    'DATABEAT CONSULTING PRIVATE LIMITED',
    'IRIDIUM PROJECTS PRIVATE LIMITED',
    'CANICUS PROFESSIONAL SERVICES PRIVATE LIMITED',
    'ARTISANS FOR SUSTAINABLE DEVELOPMENT FOUNDATION',
    'VOIP TRAINERS (OPC) PRIVATE LIMITED',
    'RANJAN SOLAR DUNIYA PRIVATE LIMITED',
    'SHRIMAD FOREX PRIVATE LIMITED',
    'CS HR SERVICES PRIVATE LIMITED',
    'EN LUXURY EXPERIENCES PRIVATE LIMITED',
    'WAO HOLIDAYS PRIVATE LIMITED',
    'TWHOUSE SOURCING PRIVATE LIMITED',
    'PROSCEND COMMUNICATIONS INDIA PRIVATE LIMITED',
    'FRONTENDERS HEALTH MANAGEMENT PRIVATE LIMITED',
    'AIDLE PRIVATE LIMITED',
    'C.H. NIDHI LIMITED',
    'IBIOSCIENCES PRIVATE LIMITED',
    'COGNIER INSIGHTS PRIVATE LIMITED',
    'ILLICIUM VERUM HOSPITALITY PRIVATE LIMITED',
    'ZESUGO TECHNOLOGIES PRIVATE LIMITED',
    'MOBASA REALTY PRIVATE LIMITED',
    'SINENG ELECTRIC (INDIA) PRIVATE LIMITED',
    'FATFISH ENTERTAINMENT PRIVATE LIMITED',
    'SYMPHONY TALENT INDIA PRIVATE LIMITED',
    'DOCMODE HEALTH TECHNOLOGIES LIMITED',
    'SIGOSOFT PRIVATE LIMITED',
    'BRUNEL LOGISTICS (WI) PRIVATE LIMITED',
    'NAMKI TECHNOLOGIES PRIVATE LIMITED',
    'STORYEXPERIENCES PRIVATE LIMITED',
    'AGRAHYAH TECHNOLOGIES PRIVATE LIMITED',
    'AB LIFECARE PRIVATE LIMITED',
    'EUAANDROS HOSPITALITY PRIVATE LIMITED',
    'BLAZING HIVE TECHNOLOGIES PRIVATE LIMITED',
    'PAPER & INK PRODUCTIONS PRIVATE LIMITED',
    'APPTINO SOFTWARE PRIVATE LIMITED',
    'PIXEL PUNDITS PRIVATE LIMITED',
    'TIRUMALLA INDIA STOREHOUSE PRIVATE LIMITED',
    'TECHNIK INFINITE SOLUTIONS PRIVATE LIMITED',
    'SIGNIFICANT ONLINE PRIVATE LIMITED',
    'AMV IT SOLUTIONS PRIVATE LIMITED',
    'JCS SOFTWARE PRIVATE LIMITED',
    'EFFISTACK INDIA PRIVATE LIMITED',
    'NEXTGEN SMART TRANSFORMATIONS SERVICES PRIVATE LIMITED',
    'MERIDIAN HUMAN RESOURCES SERVICES LIMITED',
    'SANCRAFT INDUSTRIES PRIVATE LIMITED',
    'TOJO VIKAS NATURALS PRIVATE LIMITED',
    'CALCUTTA HARDWARE & TOOLS PRIVATE LIMITED',
    'EZYLOADS LOGISTICS PRIVATE LIMITED',
    'HONSOL INFOTECH PRIVATE LIMITED',
    'LORVOS INDIA PRIVATE LIMITED',
    'REVATI ESSENTIALS PRIVATE LIMITED',
    'ORO FINANCIAL CONSULTANTS PRIVATE LIMITED',
    'SERVHIGH GLOBAL SERVICES PRIVATE LIMITED',
    'NAPINO CONTROL SYSTEMS PRIVATE LIMITED',
    'TRUECOVER CONSUMER SOLUTION PRIVATE LIMITED',
    'M. N. SHETTY TECHNOLOGIES PRIVATE LIMITED',
    'KESHAVNATH ENGINEERS PRIVATE LIMITED',
    'VITALTICKS PRIVATE LIMITED',
    'IZZBY SOLUTIONS PRIVATE LIMITED',
    'SUMAAROH PRODUCTIONS PRIVATE LIMITED',
    'PISCIUM HEALTH SCIENCES PRIVATE LIMITED',
    'DEVGENESIS PRIVATE LIMITED',
    'VCISLIVE TECHNOLOGIES PRIVATE LIMITED',
    'AFIN HEALTH CARE SOLUTIONS PRIVATE LIMITED',
    'AMCI EDTECH PRIVATE LIMITED',
    'INNOCTIVE TECHNOLOGIES PRIVATE LIMITED',
    'GNC CONSULTING PRIVATE LIMITED',
    'BAPA SITARAM OFFSET PRIVATE LIMITED',
    'CURRY STONE DESIGN COLLABORATIVE PRIVATELIMITED',
    'CIPPELE MULTISTORE (OPC) PRIVATE LIMITED',
    'AYZ MARITIME NAVIGATION PRIVATE LIMITED',
    'WILMAX COLLECTIONS PRIVATE LIMITED',
    'RFE ELECTRIC PRIVATE LIMITED',
    'SAPAAD SOFTWARE PRIVATE LIMITED',
    'AMEXS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'READERSHUB JOBS PRIVATE LIMITED',
    'WANCURA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'WATERWOOD COLD CHAIN SOLUTIONS PRIVATE LIMITED',
    'SMRTI ACADEMY PRIVATE LIMITED',
    'AVYUKT HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'STARKA INNOVATIVESYSTEMS PRIVATE LIMITED',
    'SYMPHONYINCUBATOR BUSINESS SERVICES PRIVATE LIMITED',
    'NORTHERN SOFT ACADEMY PRIVATE LIMITED',
    'TURNIP TECHNOLOGIES PRIVATE LIMITED',
    'FPT INDIA PRIVATE LIMITED',
    'SREEDEVI WIND FARM INDIA PRIVATE LIMITED',
    'AFV HOSPITALITY PRIVATE LIMITED',
    'MEKASTER ENGINEERING SERVICES PRIVATE LIMITED',
    'COLSENT TECHNOLOGIES PRIVATE LIMITED',
    'ICABLE PRIVATE LIMITED',
    'BUSINESSBRAHMA WORLDWIDE MEDIA PRIVATE LIMITED',
    'ORKASH LABS PRIVATE LIMITED',
    'WEDOECONSULT PRIVATE LIMITED',
    'ATS HEALTH CARE SERVICES PRIVATE LIMITED',
    'OAKY WEB PRIVATE LIMITED',
    'OPUS SOLUTIONS PRIVATE LIMITED',
    'WOOVLY INDIA PRIVATE LIMITED',
    'MADE EASY LEARNINGS PRIVATE LIMITED',
    'RVG LOGISTICS PRIVATE LIMITED',
    'OPTIMISE MEDIA GROUP SERVICES PRIVATE LIMITED',
    'DURAROCK PRODUCTS PRIVATE LIMITED',
    'GARE PELMA III COLLIERIES LIMITED',
    'ALTICOR MEDIA SOLUTIONS PRIVATE LIMITED',
    'VOOTRENDS ESOLUTIONS AND MEDIA PRIVATE LIMITED',
    'MAATWERK IT SOLUTIONS PRIVATE LIMITED',
    'CV RENEWABLES PRIVATE LIMITED',
    'ABSTRAKT VIDEO PRIVATE LIMITED',
    'DOMS IT SOLUTIONS PRIVATE LIMITED',
    'JANUS CONCEPTS AND SOLUTIONS PRIVATE LIMITED',
    'CNIM MARTIN PRIVATE LIMITED',
    'VITRUVIAN EDUCATION INDIA PRIVATE LIMITED',
    'QUPRO ENGINEERS & MANAGERS PRIVATE LIMITED',
    'REDBUSH TECHNOLOGIES PRIVATE LIMITED',
    'NEULEAF LIFESPACE PRIVATE LIMITED',
    'RENACLE CYCLING PRIVATE LIMITED',
    'SHELLIOS TECHNOLABS PRIVATE LIMITED',
    'PROADWISE COMMUNICATIONS PRIVATE LIMITED',
    'SASSIST IO INDIA PRIVATE LIMITED',
    'NUMAX CLOUDTECH PRIVATE LIMITED',
    'HERITAGE LANDMARKS AUTOWORLD PRIVATE LIMITED',
    'EASYST SOURCING MULTISERVICES PRIVATE LIMITED',
    'MAALAV MAHILA MILK PRODUCER COMPANY LIMITED',
    'SHALOM ENGINEERING PRIVATE LIMITED',
    'JACOB AND SONS FASHION & RETAIL PRIVATE LIMITED',
    'BOSONTECH IT SERVICES PRIVATE LIMITED',
    'JOECONS SEAFOODS PRIVATE LIMITED',
    'LOVE AND CARE FOUNDATION',
    'NICE BIOLOGICALS PRIVATE LIMITED',
    'ACB MINING PRIVATE LIMITED',
    'RUDRAKSH MICRONS PRIVATE LIMITED',
    'PUVI ORGANICS PRIVATE LIMITED',
    'GUDUCHI MARKETING INDIA PRIVATE LIMITED',
    'ANKASUMMOR FOODS PRIVATE LIMITED',
    'LUMAX FAE TECHNOLOGIES PRIVATE LIMITED',
    'SCIMOX PRODUCT AND SERVICES PRIVATE LIMITED',
    'ARINOVA EXIM PRIVATE LIMITED',
    'AURDINATE GLOBAL PRIVATE LIMITED',
    'INNOV8 CAFFEINE WORKS PRIVATE LIMITED',
    'SRD CAKES PRIVATE LIMITED',
    'DAALCHINI FOODS & BEVERAGES PRIVATE LIMITED',
    'G.S SKIES PRIVATE LIMITED',
    'INVINCIBLEBULLS TECHNOLOGIES PRIVATE LIMITED',
    'TPS TEA PRIVATE LIMITED',
    'ELAVO ENERGY PRIVATE LIMITED',
    'JGG FARM FOOD INDUSTRIES PRIVATE LIMITED',
    '4A CORPACE ADVISORY PRIVATE LIMITED',
    'MAR CIELO MARITIME PRIVATE LIMITED',
    'MFRE ESTATE PRIVATE LIMITED',
    'FNI FARMERS PRODUCER COMPANY LIMITED',
    'SHRIFRESH FOODS FARMERS PRODUCER COMPANYLIMITED',
    'SINGH SHAKTI GROUP MULTIVENTURES LIMITED',
    'SWARAN TEXTILES PRIVATE LIMITED',
    'MUKTAA MAHILA MILK PRODUCER COMPANY LIMITED',
    'JAYGARMENTS INDIA PRIVATE LIMITED',
    'ISHVED CROP SCIENCE PRIVATE LIMITED',
    'UNIQUEIT ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'CHAKRADHARA AGRO FARMS PRIVATE LIMITED',
    'LONGPING HIGH-TECH INDIA SEED PRIVATE LIMITED',
    'SEBROF INTERNATIONAL PRIVATE LIMITED',
    'DEENAR AGRI TECHNOLOGIES PRIVATE LIMITED',
    'PERFECT PREMIUM DAIRY PRODUCTS PRIVATE LIMITED',
    'KALPANA AGROTECH PRIVATE LIMITED',
    'SHERRISH INTERNATIONAL FASHIONS PRIVATE LIMITED',
    'SAAHASH FOOTWEAR INDUSTRIES PRIVATE LIMITED',
    'M. U. BAGS PRIVATE LIMITED',
    'REGAS VENTURE INDIA ONE PRIVATE LIMITED',
    'HARSHU OIL TOOLS PRIVATE LIMITED',
    'DHANLAKSHMI PACKAGING INDUSTRIES PRIVATELIMITED',
    'TETRAD GLOBAL BEVERAGES PRIVATE LIMITED',
    'DHOLPUR DAIRIES PRIVATE LIMITED',
    'SUDH BHOG PRIVATE LIMITED',
    'SHIVASHRIT FOODS PRIVATE LIMITED',
    'TIMES AQUA BEVERAGES PRIVATE LIMITED',
    'EUROVILLE PRIVATE LIMITED',
    'BRPL - BAKETECH PRIVATE LIMITED',
    'KRIDHAY HABITAT PRIVATE LIMITED',
    'TAMARILLO PRIVATE LIMITED',
    'NAMOSHIVA KNITFAB PRIVATE LIMITED',
    'AMIT PETRO SPECIALITY OILS PRIVATE LIMITED',
    'ARUSAN LIFE SCIENCE PRIVATE LIMITED',
    'RAJBADSHAH (OPC) PRIVATE LIMITED',
    'GLOBALE TESSILE PRIVATE LIMITED',
    'RANGSUBBS PHARMACEUTICALS (INDIA) PRIVATE LIMITED',
    'JIGS CHEMICAL LIMITED',
    'BULAT PHARMACEUTICAL PRIVATE LIMITED',
    'SUNLUKE TEXTILE INDIA PRIVATE LIMITED',
    'ANANDHI TEXSTYLES PRIVATE LIMITED',
    'OMKAR PEST CONTROL (INDIA) PRIVATE LIMITED',
    'ZENFOLD SPECIALITY CHEMICALS LIMITED',
    'EIFFEL-ULTIMATE FASHIONS PRIVATE LIMITED',
    'CARNATION CREATIONS PRIVATE LIMITED',
    'YWC FASHION PRIVATE LIMITED',
    'OZA PIPING SYSTEM PRIVATE LIMITED',
    'FLEXITUFF TECHNOLOGY INTERNATIONAL LIMITED',
    'SPERENE COMPOUNDING PRIVATE LIMITED',
    'DAUPHIN GALAXY PRIVATE LIMITED',
    'NEXTILE MARBOSYS PRIVATE LIMITED',
    'ENOCHIAN DESIGNS PRIVATE LIMITED',
    'PATCHWORK WEARS PRIVATE LIMITED',
    'FERNSWEAR PRIVATE LIMITED',
    'ALTIM METALS PRIVATE LIMITED',
    'KAPHAJA MODULAR FURNITURES PRIVATE LIMITED',
    'AGILE PREFABS PRIVATE LIMITED',
    'PURINA PETCARE INDIA PRIVATE LIMITED',
    'ANANTADRISHTI SMART INDIA PRIVATE LIMITED',
    'CULINARY STUDIO PRIVATE LIMITED',
    'KAMAX AUTOMOTIVE INDIA PRIVATE LIMITED',
    'LINCHPIN INDUSTRIES PRIVATE LIMITED',
    'CHARNOCK INDUSTRIES PRIVATE LIMITED',
    'SAMVARDHANA MOTHERSON ADSYS TECH LIMITED',
    'SYNEDYNE SYSTEMS PRIVATE LIMITED',
    'MAKS AUTOMOTIVE PRIVATE LIMITED',
    'ADVANCED HVAC SERVICES PRIVATE LIMITED',
    'METKORP EQUIPMENTS PRIVATE LIMITED',
    'FORMOSA MACHINERY & EQUIPMENT PRIVATE LIMITED',
    'W&M SERVICES PRIVATE LIMITED',
    'ADVOTT MEDIA PRIVATE LIMITED',
    'PACK FOR TRIP PRIVATE LIMITED',
    'ISENSESCALE TECHNOLOGY PRIVATE LIMITED',
    'DI SPUN PIPE RESEARCH AND DEVELOPMENT ASSOCIATION',
    'MEDTRANS DIGITAL TRANSCRIPT INDIA (OPC) PRIVATE LIMITED',
    'DIGICONTENT LIMITED',
    'SRX INDIA PRIVATE LIMITED',
    'MOTION PAINTS PRIVATE LIMITED',
    '101CORPORATE STRENGTH SERVICES PRIVATE LIMITED',
    'AVR INTERNET PRIVATE LIMITED',
    'MATEOS INDIA PRIVATE LIMITED',
    'GET GRUBS CAFES PRIVATE LIMITED',
    'BUOYANT STOCKPILE PRIVATE LIMITED',
    'QP EDUCATIONAL SERVICES PRIVATE LIMITED',
    'WEBCORP SOLUTIONS PRIVATE LIMITED',
    'DHARMA IT SOLUTIONS PRIVATE LIMITED',
    'RARE SOLUTIONS PRIVATE LIMITED',
    'SOURCE LEAD (INDIA) PRIVATE LIMITED',
    'SVAPPS SOFT SOLUTIONS PRIVATE LIMITED',
    'NUMERO TECH SOLUTIONS PRIVATE LIMITED',
    'MTW LABS INNOVATIONS INDIA PRIVATE LIMITED',
    'CAARYA INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'ALBESUN INDIA PRIVATE LIMITED',
    'VEJARS TECHNOLOGIES PRIVATE LIMITED',
    'SORGEN SYSTEMS INDIA PRIVATE LIMITED',
    'JASTHY SYSTEMS PRIVATE LIMITED',
    'REINVISION LABS PRIVATE LIMITED',
    'GATEWAYGROUP IT TECHNOLOGIESINDIA PRIVATE LIMITED',
    'CUBOFT MARKETING & SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ZIRAS TECHNOLOGIES PRIVATE LIMITED',
    'NETLOGON TECHNOLOGIES PRIVATE LIMITED',
    'STATUSBREW PRIVATE LIMITED',
    'SQUAREBYTES TECHNOLOGIES PRIVATE LIMITED',
    'CITY BUSINESS SERVICES PRIVATE LIMITED',
    'MEVATRON SOLUTIONS PRIVATE LIMITED',
    'REDANDBLUE APPLIED INNOVATIONS PRIVATE LIMITED',
    'INFOREPOS TECHNOLOGIES PRIVATE LIMITED',
    'NCR INDIVISION TECH VENTURES PRIVATE LIMITED',
    'CABALLO TECHNOLOGIES PRIVATE LIMITED',
    'GLOSSARY SOFTTECH PRIVATE LIMITED',
    'UNIC SOL INDIA PRIVATE LIMITED',
    'NSM SERVICES PRIVATE LIMITED',
    'LEVELFIVE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'NANOTECH WEB SOLUTIONS INDIA PRIVATE LIMITED',
    'CYBERNOOR INDIA PRIVATE LIMITED',
    'TRIDYPOP SOLUTIONS PRIVATE LIMITED',
    'TECH ORBIT SOFT SYSTEMS PRIVATE LIMITED',
    'GOLDFINGER SOFTWARE INDIA PRIVATE LIMITED',
    'DESIGNSWALA PRIVATE LIMITED',
    'CHANGEWAVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INTELYTICA BUSINESS ANALYTICS PRIVATE LIMITED',
    'INNOPIVOT TECH PRIVATE LIMITED',
    'SAFETRACEHUB TECHNOLOGIES PRIVATE LIMITED',
    'TECHDENALI INDIA PRIVATE LIMITED',
    'TRAKITNOW TECHNOLOGIES PRIVATE LIMITED',
    'RIG ENTERPRISE APPLICATIONS PRIVATE LIMITED',
    'BEYONDSCALE TECHNOLOGIES PRIVATE LIMITED',
    'BRAVIITHI TECHNOLOGIES PRIVATE LIMITED',
    'LATLON TECHNOLOGIES PRIVATE LIMITED',
    'CREOSEN SERVICES PRIVATE LIMITED',
    'HDGTL INDIA PRIVATE LIMITED',
    'DECILLION DEVICES INDIA PRIVATE LIMITED',
    'BILLEES TECHNOLOGIES PRIVATE LIMITED',
    'BIG E BRAINS PRIVATE LIMITED',
    'PROCESS BRICKS TECHNOLOGIES PRIVATE LIMITED',
    'FARAZON SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'VERSATILE MOBITECH PRIVATE LIMITED',
    'SAVETUR DIGITAL PRIVATE LIMITED',
    'NOCSMART SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TEGAIN PRIVATE LIMITED',
    'IFUFOCUS TECHNOLOGIES PRIVATE LIMITED',
    'KAWIKA TECHNOLOGIES PRIVATE LIMITED',
    'NEX INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'DIAGNAL TECHNOLOGIES PRIVATE LIMITED',
    'BOMBINATE TECHNOLOGIES PRIVATE LIMITED',
    'SNORTECH SOLUTIONS PRIVATE LIMITED',
    'WEBTRIGON TECHNOLOGIES PRIVATE LIMITED',
    'SIDDSOFT IT SOLUTIONS PRIVATE LIMITED',
    'CLOUTE TECHNOLOGIES PRIVATE LIMITED',
    'PREDMAC TECHNOLOGIES PRIVATE LIMITED',
    'FLEXICAL SOLUTIONS PRIVATE LIMITED',
    'E. FINITE SILUTIONS PRIVATE LIMITED',
    'PARIKH TECHNOLOGIES PRIVATE LIMITED',
    'IT CONFIG (INDIA) PRIVATE LIMITED',
    'PEARLDROP TECHNOLOGIES PRIVATE LIMITED',
    'UNIFYND TECHNOLOGIES PRIVATE LIMITED',
    'EMBRAVE TECH SOLUTIONS PRIVATE LIMITED',
    'REMAH IT SOLUTIONS PRIVATE LIMITED',
    'Hightee Hotels Private Limited',
    'BRAVO ENCLAVE INFRACON PRIVATE LIMITED',
    'MIDEX VASHI MARKETING PRIVATE LIMITED',
    'MAKSON HEALTH CARE PRIVATE LIMITED',
    'SAVRON LUBRICANTS PRIVATE LIMITED',
    'Ensuing Learning Private Limited',
    'Treasure Town Residents Welfare Association',
    'GREEN ERA EXIM INCORPORATION PRIVATE LIMITED',
    'Analytics Vidhya Educon Private Limited',
    'ALPHA INFOLAB PRIVATE LIMITED',
    'ALPHA GLAMOUR PRIVATE LIMITED',
    'JINENDRA FOOD INDUSTRIES PRIVATE LIMITED',
    'Battari Maa Building Material Manufacturing Private Limited',
    'DYNAMIC LINER AND CONTAINER SERVICES PRIVATE LIMITED',
    'RAJRATAN INDUSTRIES PRIVATE LIMITED',
    'SURYA HOSPITALITY & HOTEL INDIA PRIVATE LIMITED',
    'CONATIVE IT SOLUTIONS PRIVATE LIMITED',
    'SUPERSOURCING TECHNOLOGIES PRIVATE LIMITED',
    'MONESHWAR FARMER PRODUCER COMPANY LIMITED',
    'Synergytop Softlab Private Limited',
    'Rajoriya Food Industries Private Limited',
    'AVP Powerinfra Private Limited',
    'Locus Professional Studies Information Network Private Limited',
    'AHINSA LIFESPACE INFRAHEIGHT LIMITED',
    'PISCES SOLUTIONS PRIVATE LIMITED',
    'Arboreal Agro Innovations Private Limited',
    'ORCOMM ADVERTISING PRIVATE LIMITED',
    'Auspice Infratel Private Limited',
    'NIMBUS SHIPPING SERVICES PRIVATE LIMITED',
    'ANNI INDUSTRIES PRIVATE LIMITED',
    'BRAND INDIA TRADEX PRIVATE LIMITED',
    'SAWALIYA FOOD PRODUCTS PRIVATE LIMITED',
    'GYPSY SHACK HOLIDAYS PRIVATE LIMITED',
    'SHRISAMARTH INFRAWAY (INDIA) PRIVATE LIMITED',
    'AGRA-GWALIOR PATHWAYS PRIVATE LIMITED',
    'HUTUTU GAMES SOFTWARE PRIVATE LIMITED',
    'SHRI REWA RICE MILLS PRIVATE LIMITED',
    'SOWIN ENERGY SOLUTIONS PRIVATE LIMITED',
    'CITYNET INFOTELE PRIVATE LIMITED',
    'SAISUN OUTSOURCING SERVICES PRIVATE LIMITED',
    'KALYANESHWAR REAL TRADE PRIVATE LIMITED',
    'PERIYAR GAUSHALA FOUNDATION',
    'SOAQ LIFESTYLE PRIVATE LIMITED',
    'M.S. E-SOLUTIONS PRIVATE LIMITED',
    'KAMBY IMPEX & FOODS PRIVATE LIMITED',
    'ANANT INFRA GLASSES INDIA PRIVATE LIMITED',
    'GDKN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BUENA VISTA SCM PRIVATE LIMITED',
    'MEMTECH FILTRATION INDUSTRIES PRIVATE LIMITED',
    'DBL TIKAMGARH-NOWGAON TOLLWAYS LIMITED',
    'VIBS INFOSOL PRIVATE LIMITED',
    'FAST TRANSLATION AND MULTI LANGUAGE SOLUTIONS PRIVATE LIMITED',
    'TechVantage IT Solutions Private Limited',
    'JS TechAlliance Consulting Private Limited',
    'MINALAY FILM PRODUCTION PRIVATE LIMITED',
    'Sacred Products India Private Limited',
    'GREATLIFE FOODS & NUTRACEUTICAL PRIVATE LIMITED',
    'INFRA-FUSION PRECAST PRIVATE LIMITED',
    'URRJA EDUCATION AND MARKETING PRIVATE LIMITED',
    'Automation Textile Services Private Limited',
    'MANAL SOFTECH PRIVATE LIMITED',
    'Midwest Autosales Private Limited',
    'FLEXTON BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Environmentfirst Energy Services Private Limited',
    'GREENMILLER FOODS PRIVATE LIMITED',
    'AVENTUS INFRATECH PRIVATE LIMITED',
    'VAAU ENERGY SOLUTION PRIVATE LIMITED',
    'ASWAD CONSTRUCTION COMPANY LIMITED',
    'REVERBERANT PUBLICATION PRIVATE LIMITED',
    'BRAVO REALTIES PRIVATE LIMITED',
    'STREAMLINE FOREX CURRENCY EXCHANGE & CONSULTANCY PRIVATE LIMITED',
    'CVS WEBWARE PRIVATE LIMITED',
    'BIOCERT INTERNATIONAL PRIVATE LIMITED',
    'Samaira Agriculture Private Limited',
    'CARNIVAL MOTION PICTURES PRIVATE LIMITED',
    'VAKKSH FOUNDATION',
    'EPIQ SOFTECH PRIVATE LIMITED',
    'BRAVO INFRABUILD PRIVATE LIMITED',
    'UK PUBLICATIONS PRIVATE LIMITED',
    'UNOVEO SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'AARTEK SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MY PROJECT DEVELOPERS PRIVATE LIMITED',
    'Game Neeti Technology Private Limited',
    'BOLSTER ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'Amjay Hospitality Private Limited',
    'Bhagawati India Motorizer Private Limited',
    'RWC INFRATECH PRIVATE LIMITED',
    'DIGIBOOK TECHNOLOGIES PRIVATE LIMITED',
    'Quasesoft Technologies Private Limited',
    'Industrial Staffing Services (India) Private Limited',
    'OXZIN INFOTECH PRIVATE LIMITED',
    'Penseur Services Private Limited',
    'NISHVEE INFRACON PRIVATE LIMITED',
    'TravelSafe Travel Services Private Limited',
    'Deshbandhu Impex Private Limited',
    'RIGHTFUL LABS PRIVATE LIMITED',
    'ADVANTAGE OILS PRIVATE LIMITED',
    'CHHATARPUR CONSTRUCTION PRIVATE LIMITED',
    'PWG IT SERVICES PRIVATE LIMITED',
    'UJJAYINI HIGHWAYS PRIVATE LIMITED',
    'SAGARSHREE HOSPITAL & RESEARCH INSTITUTE PRIVATE LIMITED',
    'Parshvanath Superstructures Private Limited',
    'WHITE HORSE INDUSTRIES LIMITED',
    'AFCONS SENER LNG CONSTRUCTION PROJECTS PRIVATE LIMITED',
    'AYG DEVELOPERS PRIVATE LIMITED',
    'FOURH ESTATE PROJECTS PRIVATE LIMITED',
    'AADITRI ESTATE PROJECTS PRIVATE LIMITED',
    'AADITRI CONSTRUCTIONS PRIVATE LIMITED',
    'AADITRI ESTATE DEVELOPERS PRIVATE LIMITED',
    'PARSHVANATH INFRA PROJECTS (INDIA) PRIVATE LIMITED',
    'PRIME GLOBAL INFRA PRIVATE LIMITED',
    'ALMECH FACADES PRIVATE LIMITED',
    'SAN PROPERTIES PRIVATE LIMITED',
    'INDOSPACE CHITTOOR II PRIVATE LIMITED',
    'Ikshita Logistics Park Private Limited',
    'SCHUTZEN CARE PRIVATE LIMITED',
    'Incredible Technologies Private Limited',
    'Farmlink Agri Distribution and Market Linkage Private Limited',
    'TRIENDO IMPEX PRIVATE LIMITED',
    'SAKSHAM SCIENTIFIC INSTRUMENTS PRIVATE LIMITED',
    'IMCD India Private Limited',
    'FSD WOOD PRIVATE LIMITED',
    'WILSON HOLDINGS PRIVATE LIMITED',
    'ALDAN HEALTHCARE PRIVATE LIMITED',
    'HGEL Integrated Private Limited',
    'PureAg India Private Limited',
    'SINGH MUSIC PRIVATE LIMITED',
    'NAKODA OVERSEAS PVT LTD',
    'SUDARSHAN TEX-PORT PRIVATE LIMITED',
    'Ortho Clinical Diagnostics India Private Limited',
    'EXCEL ALLOYS PRIVATE LIMITED',
    'KREIT PHARMA PRIVATE LIMITED',
    'BULL RESOURCES PRIVATE LIMITED',
    'AJEETS ENGINEERING SECURITY AND DEVELOPMENT PRIVATE LIMITED',
    'RUDRA PHARMA DISTRIBUTORS PRIVATE LIMITED',
    'RELISH TRADING PVT LTD',
    'C S S DISTRIBUTORS PRIVATE LIMITED',
    'BJS INTERNATIONAL AGENCY PRIVATE LIMITED',
    'SaPrem Distributors Private Limited',
    'SONACHI PHARMA PRIVATE LIMITED',
    'RENEW WINSUN TRADERS PRIVATE LIMITED',
    'SHIV TRISHUL EXIM PRIVATE LIMITED',
    'ACTIFIT (INDIA) PRIVATE LIMITED',
    'WHITE PINE INDIA PRIVATE LIMITED',
    'MTC STRATEGIC ALLOYS PRIVATE LIMITED',
    'S CUBE Trans Continental Trading India Private Limited',
    'Raschig PMC India Private Limited',
    'AGRISEAFOOD EXIM OPC PRIVATE LIMITED',
    'ORIANA INTERNATIONAL LIMITED',
    'LIGHTBOOK RETAIL PRIVATE LIMITED',
    'RIGHT CHOICE GLOBAL PRIVATE LIMITED',
    'G N RETAIL SERVICES PRIVATE LIMITED',
    'STARDUST IMPEX PRIVATE LIMITED',
    'EZ Life Retail Private Limited',
    'Aura Art eConnect Private Limited',
    'Luxepolis Retail Services Private Limited',
    'STEREO TREND PRIVATE LIMITED',
    'WACOAL INDIA PRIVATE LIMITED',
    'Mas Sueno Optika Private Limited',
    'INFURNIA HOLDINGS LIMITED',
    'Akbarallys Stores Private Limited',
    'MUMBAI AIRPORT LOUNGE SERVICES PRIVATE LIMITED',
    'KOCAZO HOLIDAYS PRIVATE LIMITED',
    'Meltz Treats India Private Limited',
    'Brio Hospitality Private Limited',
    'LHW - India Private Limited',
    'PRINCE CREAMERY PRIVATE LIMITED',
    'ARAIYA HOSPITALITY PRIVATE LIMITED',
    'Happy Grub Hospitality Private Limited',
    'PHANTOM RESOURCES PRIVATE LIMITED',
    'Ssapphires Hospitality Business Private Limited',
    'International Airport Hotels and Resorts Private Limited',
    'Russell Resorts & Aparts Private Limited',
    'ASPECT HOSPITALITY (INDIA) PRIVATE LIMITED',
    'ISHAAN CLUBOTELS PRIVATE LIMITED',
    'Trifecta Catering Services Private Limited',
    'INTERNATIONAL CARGO TERMINAL AND FOOD PARK PRIVATE LIMITED',
    'Orient Star Transport International Private Limited',
    'SCOOTSY LOGISTICS PRIVATE LIMITED',
    'SATGURU HOSPITALITY PRIVATE LIMITED',
    'ASSAM BOMBAY CARRIERS PRIVATE LIMITED',
    'KOOL- EX WAREHOUSING LIMITED',
    'Arya Ship Charterers Private Limited',
    'Paradip International Cargo Terminal Private Limited',
    'Arya Steamship Private Limited',
    'OCEAN WAVES MARITIME PRIVATE LIMITED',
    'JOIZONE VENTURES PRIVATE LIMITED',
    'RNT DISTRIBUTORS PRIVATE LIMITED',
    'Eco-Rain Systems India Private Limited',
    'Endeavour Initiatives Private Limited',
    'AAVANTAM RETAIL PRIVATE LIMITED',
    'Ulex Provider of Indoor and Outdoor Services Private Limited',
    'Big Charter Private Limited',
    'U.Y. AVIATION PRIVATE LIMITED',
    'Travelling Solutions Private Limited',
    'DESTINATION DISCOVERIES PRIVATE LIMITED',
    'KOHARR TECHNOLOGIES PRIVATE LIMITED',
    'ENAAR INFINITY SOLUTIONS PRIVATE LIMITED',
    'Cam Pak India Private Limited',
    'OCEAN COGNIZANCE PRIVATE LIMITED',
    'CUBIC TURNKEY PRIVATE LIMITED',
    'EXCEL HR SOLUTIONS PRIVATE LIMITED',
    'Valiance Healthcare System Private Limited',
    'UR CFO CONSULTANCY PRIVATE LIMITED',
    'Reliance Defence and Aerospace Private Limited',
    'Reliance Defence Technologies Private Limited',
    'Reliance Defence Systems Private Limited',
    'Green Era Online Ventures Private Limited',
    'Maxwell Health & Hygiene Private Limited',
    'REROUT PRIVATE LIMITED',
    'ANVIRA SOLUTIONS PRIVATE LIMITED',
    'K J SHIPPING & LOGISTICS PRIVATE LIMITED',
    'VEEVA SOFTWARE SYSTEMS INDIA PRIVATE LIMITED',
    'The Packshot (India) Private Limited',
    'Livingston International India Private Limited',
    'UBIQUITI TECHNICAL SERVICES PRIVATE LIMITED',
    'HARRITT UTTHAN AGRO PRIVATE LIMITED',
    'Synergasia Business Solutions Private Limited',
    'SKILLSdox India Private Limited',
    'WORLDTAG INNOVATIONS PRIVATE LIMITED',
    'NIUM INDIA PRIVATE LIMITED',
    'Bridgespan India Private Limited',
    'CANIAS ERP PRIVATE LIMITED',
    'Monetago India Private Limited',
    'ACE TRUSTEESHIP SERVICES PRIVATE LIMITED',
    'IMC International ADR Centre',
    'Zalor India International Photography Foundation',
    'VOCATIO CAREER EDUCATION COUNCIL',
    'ORGANIZATION FOR SUSTAINABLE COMMUNITIES',
    'VIJAY DEVRAJ GUPTA FOUNDATION',
    'NATURAL STREETS FOR PERFORMING ARTS FOUNDATION',
    'GREEN VILLAGES FOUNDATION',
    'Harish & Bina Shah Foundation',
    'DATAR CANCER FOUNDATION',
    'TCS Foundation',
    'WORLD TRADE CENTRE (GOA) ASSOCIATION',
    'WORLD TRADE CENTRE JAIPUR (RAJASTHAN) ASSOCIATION',
    'AYG EDUCATION FOUNDATION',
    'SWAMI SWAPRAKASHANANDA EDUCATION AND HEALTHCARE FOUNDATION',
    'RESEARCH RATING FOUNDATION',
    'S R IYER AND SRILATA IYER MUSIC FOUNDATION',
    'VITEK HEALTHCARE PRIVATE LIMITED (OPC)',
    'ELLIVEN EXPORTS PRIVATE LIMITED',
    'EMERY CAPITAL ADVISORS PRIVATE LIMITED',
    'ANANTA INFINITE SOLUTIONS PRIVATE LIMITED (OPC)',
    'Scalebuzz Solutions Private Limited (OPC)',
    'APARNA BHASIN CONSULTING PRIVATE LIMITED (OPC)',
    'Febbrisia Internet Services Private Limited (OPC)',
    'CODOTTE ADVISORY LIMITED',
    'SAIBHUMI TRADING PRIVATE LIMITED',
    'KRIAN PICTURES LIMITED',
    'Reliance Defence Limited',
    'CAPWISE FINANCE PRIVATE LIMITED',
    'FARAH CONSULTANTS INDIA PRIVATE LIMITED',
    'AHAD Auto Technologies Private Limited',
    'BHN MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'PEREGRINE EXPRESS TECHNOLOGIES PRIVATE LIMITED',
    'Stealth Integrated Services Private Limited',
    'Softech Medical Marketing Private Limited',
    'TRAVELIBRO ONLINE PRIVATE LIMITED',
    'SRUSHTIDHARA EXIM PRIVATE LIMITED',
    'INFINITY INTERNET PRIVATE LIMITED',
    'Upper Edge Media Solutions Private Limited',
    'Live Oak Engineering Private Limited',
    'White Collar Hippie Journeys Private Limited',
    'GRIHASTI ENTERPRISES PRIVATE LIMITED',
    'MAHARASHTRA INDUSTRIAL TOWNSHIP LIMITED',
    'CINEMACRAFT INDIA PRIVATE LIMITED',
    'The FD Centre Services (India) Private Limited',
    'Environmental Clean Technologies Development And Services India Private Limited',
    'DMG EVENTS INDIA PRIVATE LIMITED',
    'UNICO LOGISTICS INDIA PRIVATE LIMITED',
    'LA-MONNAIE SKILLS PRIVATE LIMITED',
    'ONLINEBECHO SOLUTIONS (INDIA) PRIVATE LIMITED',
    'MPOWER Consumer Solutions Private Limited',
    'AMP COMMUNICATIONS PRIVATE LIMITED',
    'Reliance Helicopters Limited',
    'Reliance Defence Infrastructure Limited',
    'Reliance Land Systems Limited',
    'Reliance Propulsion Systems Limited',
    'RELIANCE DEFENCE SYSTEMS & TECH LIMITED',
    'Reliance SED Limited',
    'HDFC Capital Advisors Limited',
    'PIRINC ENTERPRISES PRIVATE LIMITED',
    'Professional Knowledge and Career Guidance Private Limited',
    'Life In Lens Production Private Limited',
    'MOHALLA TECH PRIVATE LIMITED',
    'SHIPDELIGHT LOGISTICS TECHNOLOGIES PRIVATE LIMITED',
    'PENINSULA PICTURES PRIVATE LIMITED',
    '4sight Global Ventures Private Limited',
    'ADAPTY SOLUTIONS PRIVATE LIMITED',
    'THE GOOD FOOD RESTAURANTS PRIVATE LIMITED',
    'INTANGLES LAB PRIVATE LIMITED',
    'EOM TECHNOLOGY PRIVATE LIMITED',
    'NUVOLO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MIBA ENGINEERING CENTER INDIA PRIVATE LIMITED',
    'Security Innovation India Private Limited',
    'MINDWAVE MEDIA PRIVATE LIMITED',
    'Badve Sons Private Limited',
    'SPARROWS NEST HOSPITALITY PRIVATE LIMITED',
    'KYPIPE Engineering Private Limited',
    'UNITED HEALTH & FITNESS FEDERATION',
    'MCCIA Electronic Cluster Foundation',
    'AUDAX INDIA RANDONNEURS FOUNDATION',
    'DSK World Education Council',
    'BTW VISA SERVICES (INDIA) PRIVATE LIMITED',
    'Shree AL Panel Private Limited',
    'WUDMIN ENERGY PRIVATE LIMITED',
    'Gooru India Foundation for Learning Innovation',
    'BVG FOUNDATION',
    'Yardi India Foundation',
    'SMACLIFY TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'CakeSoft Technologies Private Limited',
    'NEIL AUTOMATION PRIVATE LIMITED',
    'TWIN STAR TECHNOLOGIES LIMITED',
    'BAJAJ ALLIANZ STAFFING SOLUTIONS LIMITED',
    'SIGNASIS TECHNOLOGIES PRIVATE LIMITED',
    'Persistence Market Research Private Limited',
    'Future Market Insights Global & Consulting Private Limited',
    'SIDSA ENVIRONMENTAL PRIVATE LIMITED',
    'TIME LEGEND REALINFRACON SOLUTIONS PRIVATE LIMITED',
    'MAGNUS RESOURCES PRIVATE LIMITED',
    'CLOUDCOVER CONSULTANCY PRIVATE LIMITED',
    'GREEN WATER REVOLUTION PRIVATE LIMITED',
    'TOOLING PLANET PRIVATE LIMITED',
    'PLATINUM SMART TECH INDIA PRIVATE LIMITED',
    'Treeni Sustainability Solutions Private Limited',
    'Jampot Photonics Private Limited',
    'SERIGEN MEDIPRODUCTS PRIVATE LIMITED',
    'NIRJARA SOLAIRE URJA PRIVATE LIMITED',
    'COMBAT ROBOTICS INDIA PRIVATE LIMITED',
    'QUALITY FUMIGATION SOLUTIONS PRIVATE LIMITED',
    'Stylus Events India Private Limited',
    'HEALING HANDS CLINIC PRIVATE LIMITED',
    'Cerulean Enviro Tech Private Limited',
    'PARATUS KNOWLEDGE VENTURES PRIVATE LIMITED',
    'MCUBE CONSTRUCTION QUALITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'ANK Holdings Private Limited',
    'WAGONS SKILL FOUNDATION',
    'Shantilal Muttha Foundation',
    'Sudarshan CSR Foundation',
    'Agricultural Development and Facilitation Services Center',
    'PARANOID AUTOMATION SYSTEMS PRIVATE LIMITED (OPC)',
    'COGNITION TECHSYSTEMS PRIVATE LIMITED',
    'MONAKUS CONSULTING PRIVATE LIMITED',
    'RAMEKA Asset Reconstruction Private Limited',
    'Ino-Solar Energy Private Limited',
    'DPS CORPORATE SERVICES PRIVATE LIMITED',
    'CareFirst Diagnostics Private Limited',
    'Backlit Technologies Private Limited',
    'SOLAIRE URJA PRIVATE LIMITED',
    'SOLAIRE POWER PRIVATE LIMITED',
    'GLO IND LOGISTICS PRIVATE LIMITED',
    'Floor Space (India) Private Limited',
    'SOLAIRE SURYA URJA PRIVATE LIMITED',
    'CONSTRUCTION DIAGNOSTIC CENTRE PRIVATE LIMITED',
    'CALYX WELLNESS PRIVATE LIMITED',
    'ALPHABET EDUCATION INSTITUTES PRIVATE LIMITED',
    'DIGITALEDU IT SOLUTIONS PRIVATE LIMITED',
    'BAU PANEL SYSTEMS INDIA PRIVATE LIMITED',
    'ROBOKIDZ EDUVENTURES PRIVATE LIMITED',
    'INDOCEAN MARITIME SERVICES PRIVATE LIMITED',
    'VALASYS MEDIA PRIVATE LIMITED',
    'Spero Healthcare Innovations Private Limited',
    'OM RAKSHA SECURITY & LABOUR SERVICES PRIVATE LIMITED',
    'Atreya Innovations Private Limited',
    'Sanopeutics Research Private Limited',
    'Trading Technologies India Private Limited',
    'STRICKLAND TRACK SYSTEMS INDIA PRIVATE LIMITED',
    'VIVIRA PROCESS TECHNOLOGIES PRIVATE LIMITED',
    'SK Fleet Solutions Private Limited',
    'CrescoHR Private Limited',
    'WARDWIZ INDIA SOLUTIONS PRIVATE LIMITED',
    'EMREC TECHNOLOGIES PRIVATE LIMITED',
    'STALLION WORLDWIDE PRIVATE LIMITED',
    'REMOTE DATA SOLUTIONS PRIVATE LIMITED',
    'KARTAR CRUMBS PRIVATE LIMITED',
    'ACUTECH SOLAR PRIVATE LIMITED',
    'VAIBHAV TECH SOLUTIONS PRIVATE LIMITED',
    'BrandM Advertising & Entertainment Private Limited',
    '3S INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'PAWAR DELTA FORCE PRIVATE LIMITED',
    'TECNOSMART FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'PACIFIC CORPORATE SOLUTIONS PRIVATE LIMITED',
    'HONEST SHELTERS PRIVATE LIMITED',
    'Heading North HR Consulting Private Limited',
    'Inceptive Consulting Private Limited',
    'RETURNONWEB CONSULTING SERVICES PRIVATE LIMITED',
    'PORTER Drive Solutions Private Limited',
    'RUDRASEN INFRASTRUCTURE PRIVATE LIMITED',
    'SHARDA CABLE TRAYS PRIVATE LIMITED',
    'LIFE SPACE PROPERTY SOLUTIONS PRIVATE LIMITED',
    'ORTUS PROPERTIES AND PROJECTS PRIVATE LIMITED',
    'Sree Mount Builders and Developers Private Limited',
    'Singnet Software Solutions Private Limited',
    'Infovirtu Solutions (India) Private Limited',
    'NINTRIVA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Auberon Technology Private Limited',
    'TURBOLAB TECHNOLOGIES PRIVATE LIMITED',
    'Backwater Technologies Private Limited',
    'KEYVALUE SOFTWARE SYSTEMS PRIVATE LIMITED',
    'STARTMYSAFARI INNOVATIONS PRIVATE LIMITED',
    'BLENSYS SYSTEMS PRIVATE LIMITED',
    'Ssquad Information Systems Private Limited',
    'INTELLILABS TECHNO SOLUTIONS PRIVATE LIMITED',
    'Heidelsoft Technologies Private Limited',
    'Samraksha Habitat Private Limited',
    'Red Panthers Software Solutions Private Limited',
    'SUPPORTSAGES CONSULTANCY SERVICES PRIVATE LIMITED',
    'ELOIT INNOVATIONS PRIVATE LIMITED',
    'CODELYNKS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'YASORAM BUILDERS PRIVATE LIMITED',
    'CASADELO DEVELOPERS PRIVATE LIMITED',
    'HAFISOFT TECHNOLOGIES PRIVATE LIMITED',
    'Dataforbes Integrated Solutions Private Limited',
    'EPICON TECHNOLOGIES PRIVATE LIMITED',
    'CRAFTSMAC LABORATORIES PRIVATE LIMITED',
    'Atwic Research & Development Private Limited',
    'BIANSA TRADES INDIA PRIVATE LIMITED',
    'MGS Associates Ready Mix Trading Private Limited',
    'BUCKLER INDIA LIMITED',
    'INNOCLEAN ENTERPRISES PRIVATE LIMITED',
    'VIXA CORPORATE CONSULTANCY SERVICES PRIVATE LIMITED',
    'MATCHVALLEY BUSINESS SERVICES PRIVATE LIMITED',
    'FinLead International Services Private limited',
    'Haijin Trade India Private Limited',
    'EDUBEX LEARNING PRIVATE LIMITED',
    'Good Voyage Shipping Services Private Limited',
    'Continental Human Resources Private Limited',
    'All India Chilled and Frozen Food Processors Association',
    'SGV FLUID CONTROLS PRIVATE LIMITED',
    'SAFE BOAT TRIP PRIVATE LIMITED',
    'C S CREAMERY PRIVATE LIMITED',
    'PACIFY SYSTEMS PRIVATE LIMITED',
    'SUDARSANAN & SONS REPROGRAPHICS PRIVATE LIMITED',
    'BRAND CREATIVE DESIGN CONSULTANTS PRIVATE LIMITED',
    'INTERNATIONAL PILGRIMAGE REVOLUTION PRIVATE LIMITED',
    'RATIONALS INFRASTRUCTURE ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'AWESOMEDADDIES INTERACTIVE PRIVATE LIMITED',
    'BILLIONLIVES BUSINESS INITIATIVES PRIVATE LIMITED',
    'MONLASH SOLUTIONS PRIVATE LIMITED',
    'GALITO',
    'Birla concepts india private limited',
    'Sun beam facilities private limited',
    'Sumer infrastructure private limited',
    'Argo trade logistics private limited',
    'Florista india private limited',
    'Bharat organics private limited',
    'Nirmal lifestyle (mulund) private limited',
    'Multi commodity exchange clearing corporation limited',
    'Corporate safety solutions private limited',
    'Elite plus business services private limited',
    'Ansys engineering private limited',
    'Innovative antares private limited',
    'Purple iris knowledge services private limited',
    'Diamex sourcing private limited',
    'Professional document storage company private limited',
    'First time us pharmaceuticals (india) private limited',
    'Quantiphi analytics solutions private limited',
    'UVAN CONSUMER PRIVATE LIMITED',
    'Verite india systems private limited',
    'Caliber mercantile private limited',
    'Skj juris services private limited',
    'Atharav sanglikar sugar mill gugawad private limited',
    'Igema india private limited',
    'Livfuture automation & security private limited',
    'Modl power quality solutions private limited',
    'Andhra pradesh industrial development corporation limited',
    'Avitronics projection private limited',
    'Studentmug india private limited',
    'Eucare pharmaceuticals p ltd',
    'Hdv chempharm (india) private limited',
    'Rama gums private limited',
    'LAZULINE BIOTECH PRIVATE LIMITED',
    'Vokin biotech private limited',
    'Hira print solutions private limited',
    'Rsd graphics private limited',
    'Sheen healthcare private limited',
    'Bioplus life sciences private limited',
    'Manan healthcare private limited',
    'Sanify healthcare private limited',
    'RESONAC MATERIALS INDIA PRIVATE LIMITED',
    'Comart retail solutions private limited',
    'Shark advertising private limited',
    'Foid media private limited',
    'Chemsynth drugs & pharmaceuticals private limited',
    'Auramine dyestuff private limited',
    'Croient pharma private limited',
    'Og corporation india private limited',
    'Krishna teflon & chemicals private limited',
    'Nano tech chemical brothers private limited',
    'Pagson pest control private limited',
    'R r paint private limited',
    'Mediworld pharma private limited',
    'Euromed international private limited',
    'Hinjewadi techpark private limited',
    'Triveni formulations limited',
    'Nivea india private limited',
    'Shree radhe hygiene products private limited',
    'Agrimmcor limited',
    'Mul health care products private limited',
    'Perfect products and appliances private limited',
    'Ciron drugs and pharmaceuticals private limited',
    'Clarion cosmetics private limited',
    'Lotus beauty care products private limited',
    'Gujarat ports infrastructure and development company limited',
    'Renown pharmaceuticals private limited',
    'Worth medicines india private limited',
    'PREMIER MEDICAL CORPORATION Private Limited',
    'Metlok private limited',
    'N b laboratories private limited',
    'ARCHEAN CHEMICAL INDUSTRIES LIMITED',
    'Sud chemie india private limited',
    'Jayapriya chemical industries limited',
    'Auro industries ltd.',
    'Auro electropower pvt.ltd.',
    'Ashirwad shelters private limited',
    'Oryx fisheries private limited',
    'Nandlal enterprises limited',
    'Vasa pharma chem pvt ltd',
    'Takasago international india private limited',
    'Welnet polymers private limited',
    'Varada polymers private limited',
    'Sadashiva polymers private limited',
    'Pentax pharma pvt ltd',
    'Urbane industries limited',
    'Manza polymers private limited',
    'Girivar polymers private limited',
    'D c mills private limited',
    'Taylor rubber private limited',
    'Oliver valves india private limited',
    'Beeta poly coats private limited',
    'NOVALITE LIMITED',
    'Etios polymers private limited',
    'Patradharini polymers private limited',
    'Adipurush polymers private limited',
    'Advanced enzytech solutions limited',
    'Pharmanza herbal private limited',
    'Sinsui india private limited',
    'Venkateshwara detergents pvt ltd',
    'United carbon solutions private limited',
    'Shri maruti infratech india private limited',
    'Sidvin plastech private limited',
    'Shyam synthetics private limited',
    'Trimpacks services private limited',
    'Everest menthol private limited',
    'Ardee industries private limited',
    'North american fire guardian india private limited',
    'Swasti vinayaka realestate development private limited',
    'V3 moulding private limited',
    'DE DIAMOND CRAFT MOLD (I) PRIVATE LIMITED',
    'Coim india private limited',
    'Royal tyres private ltd',
    'Acton pharma private limited',
    'Gls polymers private limited',
    'Shyam fincom private limited',
    'Sprint plastics private limited',
    'Global flexi systems india private limited',
    'Mahesh hardware & pipes private limited',
    'Aparajeet polymers private limited',
    'Universal crop care private limited',
    'Sai nikhil pharma private limited',
    'Overseas polymers private limited',
    'Mehul colours and masterbatches private limited',
    'Sampada laboratories private limited',
    'Sapala life sciences private limited',
    'MIRAA LABORATORIES & CHEMICALS PRIVATE LIMITED',
    'Subraa polymers private limited',
    'Chalama infraproperties private limited',
    'Bul infradevelopers private limited',
    'Vanessa home private limited',
    'Abil corporation private limited',
    'Abil infrastructure private limited',
    'PRANAVA INFRASTRUCTURE PRIVATE LIMITED',
    'Sri siddharth infratech & services (i) private limited',
    'Hkr roadways limited',
    'Magnumopus infrastructure private limited',
    'Seven hills landmark private limited',
    'Singhvi foundations private limited',
    'Bepl infraprojects private limited',
    'Xync structural solutions private limited',
    'Vrep construction and consultants private limited',
    'C&s designs & constructions (india) private limited',
    'Pranava constructions private limited',
    'Khawja garib nawaz ventures private limited',
    'Zelan construction (india) private limited',
    'Image imprints infra private limited',
    'Pawansut promoters & estate private ltd',
    'Sarang infradevelopers private limited',
    'All time promoters private limited',
    'Ushta infinity construction company private limited',
    'Griha promoters private limited',
    'Lulu properties private limited',
    'MARKOLINES INFRA PRIVATE LIMITED',
    'Arss developers limited',
    'Aloukik developers private limited',
    'Aras developers private limited',
    'Atmaja developers private limited',
    'Apratim developers private limited',
    'Primus global infrastructure private limited',
    'Nanolite infratech private limited',
    'Ancon constructions india private limited',
    'Superbond building technologies private limited',
    'Budding leaf infratech private limited',
    'Virinchi infra and realty private limited',
    'Radhey constructions india private limited',
    'Ceedeeyes software technology park private limited',
    'Ornate universal developers private limited',
    'Pdl assets limited',
    'Soni infratech private limited',
    'Ace infradevelopers private limited',
    'Sh tech park developers private limited',
    'Parsvnath hessa developers private limited',
    'Parsvnath promoters and developers private limited',
    'Parsvnath estate developers private limited',
    'KPT PIPING SYSTEM PRIVATE LIMITED',
    'Fire capital townships private limited',
    'Espo developers private limited',
    'Parsvnath buildwell private limited',
    'KDP BUILDCON PRIVATE LIMITED',
    'Kdp green home private limited',
    'Robust buildcon private limited',
    'S.t.b.j. developers private limited',
    'Rockstrong constructions private limited',
    'Mohol kurul kamati mandrup tollways private limited',
    'Sanjose mahavir supreme consortium private limited',
    'Supreme tikamgarh orchaa annuity private limited',
    'Chandrashekhar advisory private limited',
    'Charisma builders limited',
    'Iplus realty private limited',
    'Basil realmart private limited',
    'Different squares ventures private limited',
    'Kfc construction private limited',
    'M. s. mistry & construction india private limited',
    'Pankh properties private limited',
    'Shashank mehendale consultants private limited',
    'Infiniti building products private limited',
    'Swagat buildspace developers private limited',
    'North star realty private limited',
    'Udani and sons corporation private limited',
    'Shrivatsa realty private limited',
    'Akshada realty privatelimited',
    'Bollineni castings and steel limited',
    'Gvr projects india limited.',
    'NOVALIS LABS PRIVATE LIMITED',
    'Uphar conclave private limited',
    'Pinnacle highrise private limited',
    'Cringe infrastructure private limited',
    'Rudramukhi realestate private limited',
    'Takshaka interiors private limited',
    'Nirmal designs private limited',
    'Mancini enterprises private limited',
    'Mohite automotive private limited',
    'Pinkcity motors private limited',
    'OLIVE AUTO PRIVATE LIMITED',
    'Beyrisch auto experts private limited',
    'Amcon estates private limited',
    'Axis seats services private limited',
    'D. V. BRAHME & SONS SALES & SERVICE PRIVATE LIMITED',
    'TRIPWHEELS AND DRIVE PRIVATE LIMITED',
    'Epsilon marketing and consultancy private limited',
    'Biosafe lifecare private limited',
    'Across network private limited',
    'Italian machine trader private limited',
    'Dm commodity trading private limited',
    'Abhyudita trading private limited',
    'Shrumani steels private limited',
    'Vedant fair trade private limited',
    'Greenko zenith energy solutions private limited',
    'Bharath salt refineries limited',
    'Padmavathi developers private limited',
    'RESILIENT VENTURES PRIVATE LIMITED',
    'Sinecure infrastructure private limited',
    'Kishan chand ferro steels private limited',
    'Eighth south ventures private limited',
    'U.k.n. properties private limited',
    'Manyata promoters private limited',
    'Christu arasar benefit fund limited',
    'Jrl advisors private limited',
    'Muralya properties private limited',
    'COUNTRYWIDE PROJECTS PRIVATE LIMITED',
    'Parsvnath realty ventures limited',
    'Dosti realty limited',
    'Gokarna estates private limited',
    'Black gold realtors private limited',
    'Affinity commodity derivatives private limited',
    'Ariisto realtors infrastructure private limited',
    'Ela realty private limited',
    'Samit realty private limited',
    'Sanchita realty private limited',
    'Adhita realty private limited',
    'Ekamedha estates private limited',
    'Aum insurance brokers private limited',
    'Vatika seven elements private limited',
    'Sandstone builders private limited',
    'Snowbird conclave private limited',
    'Sunroof plaza private limited',
    'Daytime enclave private limited',
    'Daytime plaza private limited',
    'Daytime residency private limited',
    'Vidyaavati development and reality private limited',
    'B p k developers private limited',
    'S J DEVELOPERS AND HOUSING PRIVATE LIMITED',
    'Pristine promoters private limited',
    'Meridien promoters private limited',
    'Highland park enclave pvt ltd',
    'Famous dwellers private limited',
    'Aspire promoters private limited',
    'G r e housing private limited',
    'SHRUB BUILDCON PRIVATE LIMITED',
    'Mendell developers private limited',
    'South west land consortium private limited',
    'Futureworld constructions private limited',
    'Zonasha estate & projects private limited',
    'Commune properties india private limited',
    'M b properties and projects private limited',
    'Hitech realty private limited',
    'Fintel homes private limited',
    'Skj finserve private limited',
    'Spatium developers private limited',
    'Rasam enterprise private limited',
    'Mature realtors private limited',
    'Palm tree buildcon private limited',
    'Admired height projects private limited',
    'Perfect housing solutions private limited',
    'Madkaikar realtors private limited',
    'Serendipity real estate private limited',
    'Topline estate and properties private limited',
    'Hemanth homes private limited',
    'Paras seasons haven private limited',
    'Radvin infraspace private limited',
    'Manjri projects private limited',
    'AIPL HOUSING AND URBAN INFRASTRUCTURE LIMITED',
    'Lily estates private limited',
    'International amusement and infrastructures limited',
    'Laban real estates private limited',
    'Apple properties limited',
    'Rightedge infrastructures private limited',
    'Shivendra estate and investment private limited',
    'Niroopa reality and finance private limited',
    'Badrinaath development and reality private limited',
    'Puneeta reality and finance private limited',
    'Samraksh enterprise private limited',
    'Vatika sovereign park private limited',
    'Sarv estate private limited',
    'Maddysown homes and resorts private limited',
    'Sspdl real estates india private limited',
    'Mira estates private limited',
    'Rsl estates private limited',
    'Rukmini realtors private limited',
    'Madhavi assets private limited',
    'Umak investment companyprivate limited',
    'Larc software private limited',
    'Sankalp semiconductor private limited',
    'Harjai computers private limited',
    'Seven hills infotech private limited',
    'Eprosoft india private limited',
    'WOLFBERG DWELLERS PRIVATE LIMITED',
    'Snw smith consultants private limited',
    'Parsvnath realcon private limited',
    'Suksma buildtech private limited',
    'Rojas realtors private limited',
    'DARJEELING TRADING PRIVATE LIMITED',
    'SAMPARK GROWTH CONSULTANCY PRIVATE LIMITED',
    'Pukhraj estate developers pvt ltd',
    'Embody healthcare private limited',
    'Bcsi projects private limited',
    'Multisoft systems technology consultancy private limited',
    'RAM IT SOLUTIONS PRIVATE LIMITED',
    'Stelling technologies private limited',
    'One cube solutions private limited',
    'Bcsi constructions private limited',
    'Prakriti trading p ltd',
    'Nathani exports pvt ltd',
    'Hassaram exports pvt ltd',
    'Glint exim limited',
    'Palar Home Textiles Private Limited',
    'Selective exports private ltd',
    'Libord exports private limited',
    'Indiashoppingmal.com private limited',
    'Orlando trading private limited',
    'Noordin ebrahim impex private limited',
    'TRENT HYPERMARKET PRIVATE LIMITED',
    'Dtp trading private limited',
    'Bloom health and life sciences private limited',
    'Deccan stainless bharath private limited',
    'Surakanti corporation private limited',
    'Dsm agencies private limited',
    'Team commotrade (india) private limited',
    'Punjab agri export corporation limited',
    'Triune international private limited',
    'Indraprastha petro-products private limited',
    'Naveen mechanical works private limited',
    'Gtl adhesive tapes india private limited',
    'Satin (india) limited',
    'Daksh exim solutions private limited',
    'Pee jay impex private limited',
    'Designwell holidays private limited',
    'Mastermind merchandising services private limited',
    'BYRL MEDICAL INDIA PRIVATE LIMITED',
    'Nsc international private limited',
    'Budenheim india private limited',
    'Tejashi trade and services private limited',
    'AKMY BUILDCON PRIVATE LIMITED',
    'Shri sidhivinayak overseas private limited',
    'Mtekpro technologies private limited',
    'Brandconnect marketing private limited',
    'Hugs and kisses customcrafts private limited',
    'Moneypalm commodities private limited',
    'Choice laboratories limited',
    'Prashansha ceramics limited',
    'Fuji marketing private limited',
    'Hrishi exports pvt ltd',
    'CHOONKAR ORGANICS PRIVATE LIMITED',
    'PALVI INDUSTRIES LIMITED',
    'Indosaw exports private limited',
    'Pv3 enterprises private limited',
    'Patalganga distributor pvt. ltd.',
    'Kc kopar energy solutions private limited',
    'Miaja design private limited',
    'Al- rkayan apparels and exports private limited',
    'Goodearth minchem private limited',
    'Engson ventures private limited',
    'Compac technologies india limited',
    'Fantastic commercial private limited',
    'Shivratna udyog limited',
    'Anuron enterprises private limited',
    'Sas applied research and lab materials private limited',
    'Sri bhoomi durga marketing private limited',
    'Snrm marketing india private limited',
    'Just change india producer company limited',
    'Everett exports pvt ltd',
    'Bansal naturevest limited',
    'T garg & co pvt ltd',
    'OLIVETREE INTERNET PRIVATE LIMITED',
    'Spotlight commercial company pvt ltd',
    'Stichwell exports pvt. ltd.',
    'Vitro commodities pvt ltd',
    'Jhilo vyapaar pvt.ltd.',
    'An industries limited',
    'Vanraj suppliers pvt.ltd.',
    'Nikhar trading pvt ltd',
    'Dynasty vanijya pvt ltd',
    'Chinar tie-up private limited',
    'EQUIVALENCE INFRASTRUCTURE & LOGISTICS PRIVATE LIMITED',
    'Lakshya commercial private limited',
    'Basuki vyapaar private limited',
    'Jaya dealers private limited',
    'Potential distributors private limited',
    'Ambrish vyapar private limited',
    'Auro sales private limited',
    'Utility vinimay private limited',
    'Regal container line private limited',
    'Liberty marbles & granites private limited',
    'Kuntal granites private limited',
    'Westfields collieries limited',
    'Indian vegetable oil export association',
    'Neeli sea foods private limited',
    'Gaur foods private limited',
    'Vkc nuts private limited',
    'Extal international exports private limited',
    'Mccain foods india private limited',
    'Benny product private limited',
    'Tara heart care products limited',
    'Kaleesuwari refinery private limited',
    'Mosons extractions private limited',
    'Lakshmi balaji oils private limited',
    'Amrit clothing private limited',
    'CSK MARKET SERVICES PRIVATE LIMITED',
    'U. k. agritech products private limited',
    'Ivory food grains private limited',
    'Tirumala oilchem india private limited',
    'Rachana agro industries limited',
    'Hygeeias foodsz private limited',
    'Piyush sugar and agro industries private limited',
    'Roca bathroom products private limited',
    'Anamika sugar mills private limited',
    'Adie broswon sugars & industries private limited',
    'Shree swami samarth energy and sugar private limited',
    'Sri family biznet private limited',
    'YAYA FOODS LIMITED',
    'Varun agro processing foods private limited',
    'Nutricia international private limited',
    'Sri family enterprises private limited',
    'Travancore agro services india private limited',
    'Sri nuthatch nutricare technologies private limited',
    'TULSIAN GLOBAL PRIVATE LIMITED',
    'Theos food private limited',
    'Siddhidayak agro foods private limited',
    'Tasa foods private limited',
    'Paras nutritions private limited',
    'Satyom enterprises private limited',
    'Gandhar food products private limited',
    'Clint wines pvt ltd',
    'DHASABUJA BREWERIES PRIVATE LIMITED',
    'Madhulika foods private limited',
    'Sriba agro limited',
    'M l industrial and agricultural products private limited',
    'Bommidala purnaiah holdings private limited',
    'Pandiyan dairy farms private limited',
    'Anand veena twisters private limited',
    'Purity textile private limited',
    'Rainbow home fab private limited',
    'Ap confectionary private limited',
    'Subhash fabrics pvt ltd',
    'Brillanto synthetics private limited',
    'Vicotex fabrics private limited',
    'F m hammerle textiles limited',
    'S.r.thorat milk products private limited',
    'Marshall produce brokers company private limited',
    'Savadi spinning mills private limited',
    'Rainbow texcolour processors private limited',
    'Bedekar pickles private limited',
    'Jay jay mills india private limited',
    'Trichy dairy products private limited',
    'Navratanmal ashok kumar surana woollen private limited',
    'Mahamantra textile mills private limited',
    'Srv knittech private limited',
    'Travancore fibres private limited',
    'Godrej tyson foods limited',
    'Tamilnadu minerals limited',
    'Geeta resources private limited',
    'Palmar mills private limited',
    'Lakra industries limited',
    'Belaz-enrika mining equipments services private limited',
    'Gopani offshore mining private limited',
    'S k international stones private limited',
    'Mk international mining private limited',
    'Mangaldas mehta and company limited',
    'International marketing corporation private limited',
    'Jaipur enclave private limited',
    'Bhoruka capital limited',
    'South east textiles private limited',
    'Unique sugars limited',
    'Inverness medical shimla private limited',
    'Sceptre medical (india) private limited',
    'Shree ambica surgical private limited',
    'QUADIO LABS PRIVATE LIMITED',
    'Aashis bio ortho private limited',
    'Azbil telstar india private limited',
    'S. g. finepunch private limited',
    'Sheltron insulations private limited',
    'Vaspan texturisers private limited',
    'Passco environmental solutions private limited',
    'Pyro electric cables and sensors private limited',
    'Astro optics private limited',
    'GKB VISION PRIVATE LIMITED',
    'VVBG PRIVATE LIMITED',
    'Wysiwyg communications pvt ltd.',
    'Doon optical systems private limited',
    'Svs instruments and control systems (india) private limited',
    'Arudaavis labs private limited',
    'DUCH ELECTROGUARD PRIVATE LIMITED',
    'Saumin process controls private limited',
    'Vard electrical installation and engineering (india) private limited',
    'Selec automation private limited',
    'Powersol infra services private limited',
    'Lake systems private limited',
    'TRAFO POWER & ELECTRICALS (P) LTD',
    'Shree navkar tradecom private limited',
    'Lmp motors private limited',
    'Super circle auto limited',
    'KYOCERA AVX COMPONENTS (NEW DELHI) PRIVATE LIMITED',
    'Sanghi automotive private limited',
    'Saraf motor co pvt ltd.',
    'Rams telesystems private limited',
    'Sairaj logistics private limited',
    'Eicher goodearth private limited.',
    'Sankar jp sealing technologies private limited',
    'B.r.motors private limited',
    'Mari aerotech private limited',
    'Undercarriage and tractor parts private limited',
    'Deedi motors private limited',
    'Dasan cycle private limited',
    'Rohan automotive equipments private limited',
    'Varun vehicles private limited',
    'Varsha vehicles private limited',
    'Madras engineering industries private limited',
    'Southern accessories private limited',
    'Intersil semiconductors private limited',
    'Mrk healthcare private limited',
    'Bhise infoelec private limited',
    'Indianapoli Hospitality Private Limited',
    'Volex interconnect (india) private limited',
    'Trutek products private limited',
    'Octopus medical technologies private limited',
    'Clinicare (india) private limited',
    'Devanshi electronics private limited',
    'Phd comm private limited',
    'Cllasic vehicles and components limited',
    'MEGA JEWELS PRIVATE LIMITED',
    'P. mangatram jewellers private limited',
    'Sonitech india private limited',
    'J.r.diamonds private limited',
    'India kawasaki motors private limited',
    'Renewsys india private limited',
    'Anupam stationery limited',
    'Needumbra industries private limited',
    'Artiqulate lifestyle private limited',
    'Haulmaxx engineering india private limited',
    'Punarnawa crafts private limited',
    'Satyam collection greetings and gifts private limited',
    'Unisign modular signage private limited',
    'Amrit crafts private limited',
    'Unique waste processing company limited',
    'ISLEWORTH MANAGEMENT PRIVATE LIMITED',
    'Smi amtek crankshaft private limited',
    'Elegant auto india private limited',
    'Evolgence telecom systems private limited',
    'Pelican telecom private limited',
    'Apex marintrans private limited',
    'Armstrong power private limited',
    'Armstrong power systems private limited',
    'Solitaire btn solar private limited',
    'Parikh power private limited',
    'Adani transmission (india) limited',
    'Neri lighting (india) private limited',
    'Featherline furnitures (india) private limited',
    'BINA MINES AND SUPPLY LIMITED',
    'JSW HYDRO ENERGY LIMITED',
    'Ambuthirtha power private limited',
    'Emco power limited',
    'Indelsol (industrial electronics solutions) (i) private limited',
    'Bihar smart energy services limited',
    'LIVIENCE LIFESPACE PRIVATE LIMITED',
    'Mahalaxmi konal urja private limited',
    'Nav energy private limited',
    'Ind-barath energies (chhattisgarh) limited',
    'Aryan chhattisgarh power generation private limited',
    'Fgv lifestyles india private limited',
    'Jayaswal neco energy private limited',
    'Kleiber modular systems private limited',
    'Adona woods private limited',
    'Asian wind energy private limited',
    'Atria power corporation private limited',
    'Holiday homes pvt ltd',
    'Pen holiday resorts private limited',
    'Rock bottom cafe private limited',
    'Boxmoor shipping private limited',
    'Mimco logistics india private limited',
    'Zts logistics (india) private limited',
    'J.k. car rental services private limited',
    'Swayambhu logistics private limited',
    'Phoneix cargo services private limited',
    'Kushum express services private limited',
    'Galene shipping private limited',
    'Enrico tea and snacks bar private limited',
    'Acron logistics and lodging private limited',
    'Nfa marvel logistics solutions private limited',
    'Oak shipping services private limited',
    'Famous transport company private limited',
    'Tsr cargo private limited',
    'Spar air and sea services private limited',
    'ADANI WAREHOUSING SERVICES LIMITED',
    'Turner logistics india private limited',
    'Supreme transport solutions private limited',
    'Oceanic dolphin transchart private limited',
    'Neha bus services private limited',
    'Indira container terminal private limited',
    'Shaurya travels private limited',
    'Apl logistics vascor automotive private limited',
    'Ats cargo private limited',
    'Ashmi road carriers private limited',
    'Balaji freight logistics private limited',
    'Shri vinaik logistics private limited',
    'Sharda ma logistics private limited',
    'Shakti tourism (india) private limited',
    'Orchid tours private limited',
    'Ekno tours and travels private limited',
    'Emirates shipping agencies (india) private limited 100% for.sub.co.',
    'Saini travels private limited',
    'Kangra valley garden hotels private limited',
    'Brahamputra cargo carriers private limited',
    'Prominent tours and travels private limited',
    'Trust travel and tours private limited',
    'Censeo tours private limited',
    'Angel logistics private limited',
    'Binaza travels pvt ltd',
    'Newaskar logistics private limited',
    'Ventura holidays private limited',
    'Exotic locations and vacations private limited',
    'Aero world travels india private limited',
    'SPENCER',
    'S TRAVEL (INDIA) PRIVATE LIMITED',
    'Goel ganga fortune infrastructure private limited',
    'Anand trichy logistics private limited',
    'Taal enterprises limited',
    'Royal bike riders private limited',
    'Connectm technology solutions private limited',
    'Konekt marketing systems private limited',
    'Productdossier solutions (india) private limited',
    'Vritti solutions limited',
    'EQUINOX EPC ENGINEERING (INDIA) PRIVATE LIMITED',
    'Proventeq india private limited',
    'Telematic comsec private limited',
    'Royal ecommerce solutions private limited',
    'Refine interactive private limited',
    'Sarvara technologies private limited',
    'R a computer systems private limited',
    'Ameya infocom private limited',
    'Jayadarshini technologies private limited',
    'Syscom computers private limited',
    'Strategic infosystems private limited',
    'Versasia infosoft private limited',
    'Proto3d solutions private limited',
    'Hinode technologies private limited',
    'Npedia technologies private limited',
    'Ram - nath technology services private limited',
    'Arinos infosolutions private limited',
    'Svp laser technologies private limited',
    'TANQAA PAYROLL PRIVATE LIMITED',
    'Iportal automation private limited',
    'Rckr software private limited',
    'Skybasenet solutions (india) private limited',
    'Hakuna matata solutions private limited',
    'Radam technologies private limited',
    'X-value technologies private limited',
    'C2e software solutions private limited',
    'IDEAS2IT TECHNOLOGY SERVICES PRIVATE LIMITED',
    'Best of breed software solutions india private limited',
    'Nesote outsourcing services private limited',
    'Maheshwari infosolution private limited',
    'Diverse lynx india private limited',
    'JBASTIN PRIVATE LIMITED',
    'Bscic certifications private limited',
    'Sterling analytical solutions india private limited',
    'Midas research and development centre india private limited',
    'Reseapro scientific services private limited',
    'I5 clinical research private limited',
    'Da-iict centre for entrepreneurship and incubation',
    'Mccreade software asia private limited',
    'VSB ADVISORY SERVICES PRIVATE LIMITED',
    'Perfact envirosolutions private limited',
    'Azure hospitality private limited',
    'Bluelotus strategy consulting private limited',
    'Icam solution private limited',
    'Apna car.com private limited',
    'Square bits private limited',
    'VASAVI PROSOFT TRANSCRIPTION PRIVATE LIMITED',
    'Green leaf business solutions private limited',
    'Dhara it solutions private limited',
    'Meera cleanfuels limited',
    'Solitaire marine & offshore private limited',
    'Monocept consulting private limited',
    'Satvat infosol private limited',
    'Neptune business solutions private limited',
    'Ilogics software technology private limited',
    'Infinity infomatic private limited',
    'Gujarat institute of film and television pvt ltd',
    'Tranquil tours private limited',
    'Medyug technology private limited',
    'Epigram digital media private limited',
    'Fab infotech private limited',
    'Veeyu financial consultants private limited',
    'Innovative india tourism private limited',
    'Siddeshwar multipurpose heemghar private limited',
    'STATESTREET GLOBAL ADVISORS INDIA PRIVATE LIMITED',
    'Third eye qualitative researchers private limited',
    'Young enterpreneurs organisation (delhi chapter)',
    'Mvg techno consultants private limited',
    'Xander advisors india private limited.',
    'Smit enterprises private limited',
    'KANAK RESOURCES MANAGEMENT PRIVATE LIMITED',
    'Legend it solutions private limited',
    'Ambro asia private limited',
    'Slv rozgar private limited',
    'Quolam business solutions private limited',
    'SASHAKTA INDIA PRIVATE LIMITED',
    'Knr management consultants private limited',
    'JIO HAPTIK TECHNOLOGIES LIMITED',
    'Webbutterjam digital solutions private limited',
    'Horizon tax advisors private limited',
    'Timelessmind solutions private limited',
    'Sphier infotech private limited',
    'Telecomwatch private limited',
    'Dcube project management private limited',
    'Glimmerus infotech private limited',
    'Top greenhouse technologies private limited',
    'Marmo solutions private limited',
    'Q-das software private limited',
    'Montaplast india private limited',
    'Kesar multimodal logistics limited',
    'Ways and means advisory private limited',
    'Echt conglomerate private limited',
    'Alliance foreign exchange private limited',
    'Cebex solutions private limited',
    'Awa vision private limited',
    'Kkp petchem private limited',
    'Brugg cables (india) private limited',
    'Geobrugg india private limited',
    'S.s. electroengineers private limited',
    'DAKSHYN FOODS PRIVATE LIMITED',
    'Haryana capfin limited.',
    'Gujarat containers ltd',
    'Rolcon engineering company limited',
    'Remi sales and engineering limited',
    'Suyog telematics limited',
    'Chemcaps limited',
    'Remsons industries limited',
    'Remi elektrotechnik limited',
    'Helpage finlease limited',
    'Neha resources limited (transferred from west bengal)',
    'MINT X',
    'S TELEKOM PRIVATE LIMITED',
    'Mars bioanalytical private limited',
    'Biomedix optotechnik and devices private limited',
    'Rhone poulenc labs private limited',
    'Paras miracle poly products private limited',
    'Toshniwal hyvac private limited',
    'Modi graph indian private limited',
    'Syscon instruments private limited',
    'QVI INDIA PRIVATE LIMITED',
    'Julabo siskin (asea) private limited',
    'Hbs realtors private limited',
    'Tradliynk marketing private limited',
    'Terra motors india private limited',
    'New swan multitech limited',
    'S m kannappa automobiles private limited',
    'Cars and carriages (india) private limited',
    'Autopia motors p ltd',
    'Rsb transmissions (i) ltd',
    'Aditya wheels (india) private limited',
    'GLOBALPDS PRIVATE LIMITED',
    'Newline autotrack private limited',
    'Pius krishna traders and developers private limited',
    'Rohana commercials private limited',
    'Dango & dienenthal (india) private limited',
    'Biren commercials private limited',
    'Dasmesh aerofrost infra private limited',
    'Skylark (hotels) pvt ltd',
    'Vinlock tie up pvt ltd',
    'Cosmos merchandise private limited',
    'Akkute tropical innovations private limited',
    'Imeco overseas private limited',
    'APSARA SELECTIONS LIMITED',
    'Mindtrack dealmark private limited',
    'Cte tea private limited',
    'Ascent lifestyle private limited',
    'Avnita commercials private limited',
    'Khwaahish diamonds private limited',
    'Olympus commercial private limited',
    'Skylift cargo private limited',
    'Silicon impex private limited',
    'Sidheshwari commotrade private limited',
    'Charan vincom private limited',
    'Nilambar suppliers private limited',
    'Ap3 business solutions (india) private limited',
    'Shaurya trade impex private limited',
    'Safal tradecom private limited',
    'Powerful tradecom private limited',
    'Welltime tie-up private limited',
    'Orangesky dealers private limited',
    'Asal dealcom private limited',
    'Priority jewels private limited',
    'Atithi tradecom private limited',
    'Aspire dealers private limited',
    'Orchid exim (india) private limited',
    'Everrise vyapaar private limited',
    'Stallone industries limited',
    'Padma raga commercials private limited',
    'Futura commercials private limited',
    'Sagun sales private limited',
    'Ein technology ventures (india) private limited',
    'Sapphire trade associates private limited',
    'Kaltech energy private limited',
    'Frontline gourmets private limited',
    'Kruti ami rup resort private limited',
    'J.d. resorts private limited',
    'RADISSON BESTECH MANAGEMENT SERVICES PRIVATE LIMITED',
    'Dholpur business ventures private limited',
    'Pammvi exports private limited',
    'Hello india digital & electronics private limited',
    'Jal mahal resorts private limited',
    'Goblin agri projects and hospitalities private limited',
    'Cinnamon agri development and hospitalities private limited',
    'GUINDY PROPERTIES PRIVATE LIMITED',
    'Nikitasha home appliances private limited',
    'Inpac hotels and resorts private limited',
    'Shree shyamkamal hotels and resorts private limited',
    'Interglobe hotels private limited',
    'Foresight edutech private limited',
    'Pg purity foods private limited',
    'Aipl hospitality limited',
    'Philauvia healing spa and resort private limited',
    'Sorrel hospitality private limited',
    'Moksha hospitality private limited',
    'Viaterra travel gear private limited',
    'LIBERTY EMBRO EXIM PRIVATE LIMITED',
    'HEADS UP VENTURES LIMITED',
    'Voice snap products private limited',
    'Shivangan sales private limited',
    'Sujaya investments private limited',
    'Valdel management services private limited',
    'R.r.residency private limited',
    'Sandhill hotels private limited',
    'SAWAN',
    'S CAKE & CONFECTIONERY PRIVATE LIMITED',
    'Rosebay gardens private limited',
    'Oriental extractions private limited',
    'Bio resource biotech private limited',
    'Vishal surgical equipment company private limited',
    'Target productions private limited',
    'Unison communications private limited',
    'Apd drugs & diagnostics private limited',
    'Bioplus healthcare private limited',
    'Azico biophore india private limited',
    'Devi cropscience private limited',
    'Rubo-synth impex pvt ltd',
    'Sequent penems private limited',
    'Alopa herbal healthcare private limited',
    'Sbm ayur natural care private limited',
    'Aglocure labs private limited',
    'Periyar polymers private limited',
    'Jonarin pigments private limited',
    'Sunanda speciality coatings pvt ltd',
    'Sureet propkem private limited',
    'Kee pharma limited',
    'Genome diagnostics private limited',
    'K patel dye-chem industries private limited',
    'Y s prabhoo and sons private limited',
    'Sumo medexim limited',
    'TRROY LIFE SCIENCES PRIVATE LIMITED',
    'Centaur pharmaceuticals private limited',
    'Vital therapeutics and formulations private limited',
    'Kyros therapeutics (india) limited',
    'Dieu industries limited',
    'Adept pharma and bioscience excellence private limited',
    'Eumark pharmaceuticals pvt ltd',
    'Merlin pharma private limited',
    'Aura personal products private limited',
    'Jasmine concrete exports private limited',
    'Azafran innovacion limited',
    'Fragranz india perfumes private limited',
    'Shalimar agarbatti company private limited',
    'K patel phyto extractions private limited',
    'Arihant remedies private limited',
    'Redson laboratories private limited',
    'Durga toys manufacturing private limited',
    'Micafab export private limited',
    'SRIVASAVI ADHESIVE TAPES LIMITED',
    'Chemex organochem private limited',
    'Inter continent chemicals (india) limited',
    'Hyderabad pollution controls limited',
    'Crystal voxx limited',
    'PURE TONERS AND DEVELOPERS PRIVATE LIMITED',
    'Devi biotech private limited',
    'Carbonassociates services private limited',
    'Hydrocarbon solutions (india) private limited',
    'Lucid colloids limited',
    'Hindustan tyres pvt ltd',
    'R k reclaim and rubber products private limited',
    'Surendra elastomers private limited',
    'TJP MATS PRIVATE LIMITED',
    'Earth containers private limited',
    'Fpi industries private limited',
    'Crystal polytech private limited',
    'Mahabir polyfabs private limited',
    'Natural rubber and fibre products manufacturers consortium private limited',
    'K-LON TEKNO POLYMERS PRIVATE LIMITED',
    'Gruppo biokimica india private limited',
    'Suvidha parklift limited',
    'Chemtron science laboratories private limited',
    'S. s. mills private limited',
    'Jayco specialities private limited',
    'Klene paks limited',
    'V n plastics private limited',
    'Wiz plast private limited',
    'Bankim polymers private limited',
    'Vin agplast india private limited',
    'HILLARIOUS APPLIANCES PRIVATE LIMITED',
    'Entremonde polycoaters limited',
    'MAX LEARNING VENTURES PRIVATE LIMITED',
    'MEL FLOORINGS PRIVATE LIMITED',
    'WILLOWOOD AGRO CHEM PRIVATE LIMITED',
    'Gulshan lamee pack private limited',
    'Flexiflow industries private limited',
    'Natur tec india private limited',
    'DHI INNOVATIONS PRIVATE LIMITED',
    'Central tyres private limited',
    'RECKON ORGANICS PRIVATE LIMITED',
    'UNIQUE EXTRUSION & INNOVATIVE PRODUCTS PRIVATE LIMITED',
    'Aerodry (india) private limited',
    'Swadesh essfil private limited',
    'Sintron polymers private limited',
    'Transpac asia private limited',
    'Hitesh plastics private limited',
    'Samarpan converters private limited',
    'Nan pao resins india private limited',
    'Kalpsutra terpenoids private limited',
    'Shreya pet private limited',
    'Sukhindram pharmaceutical trading private limited',
    'Innovo glassworks private limited',
    'Monal potteries and ceramics pvt ltd',
    'Ais adhesives limited',
    'Garg process glass india private limited',
    'Agbros glass works (india) private limited',
    'KAPOOR GLASS (INDIA) PRIVATE LIMITED',
    'Prabhat sanitaryware private limited',
    'Derewala infracon private limited',
    'Pathi builders private limited',
    'Rup-rekha enclave private limited',
    'Smile finvest private limited',
    'Aarudra builders private limited',
    'Viswapriya realty services private limited',
    'Ramesh rajann constructions private limited',
    'G dot g builders & promoters private limited',
    'Kodai hill properties private limited',
    'Ranbar storage pvt ltd',
    'Ludhani estates pvt ltd',
    'Arundel properties private limited',
    'Rishina constructions p ltd',
    'Banyan properties private limited',
    'Primo realtors private limited',
    'Enviro build resources private limited',
    'Parmatma power projects private limited',
    'Bright villas private limited',
    'Kaybee developers private limited',
    'Adarsh towers private limited',
    'Rishiraj developers private limited',
    'Somu real estates private limited',
    'Tjn construction private limited',
    'Abci infrastructures private limited',
    'Shashank real estates private limited',
    'Minu developers private limited',
    'Aviohelitronics b2b private limited',
    'Sl plotted development projects private limited',
    'Alok enclave private limited',
    'Priyanka enclave private limited',
    'Forstar realtors private limited',
    'Designo project & infrastructure private limited',
    'Kavya realtors private limited',
    'Ventura buildcon private limited',
    'Krishnae infrastructure private limited',
    'Sew transportation networks limited',
    'Malaxmi highway private limited',
    'Jishu developers private limited',
    'Trans home realtors private limited',
    'Thdc india limited',
    'Nikita enclave private limited',
    'Majestic industrial park private limited',
    'Lumiere projects and developers private limited',
    'Ortus builders private limited',
    'First key developers private limited',
    'Pratick enclave private limited',
    'Akshat enclave private limited',
    'Hira enclave private limited',
    'Shree bhomiya builders private limited',
    'Happy realcon private limited',
    'Iot utkal energy services limited',
    'Sanjay enclave private limited',
    'Jeet enclave private limited',
    'Dahej sez limited',
    'Bhartia infra projects limited',
    'Ahmedabad vadodara expressway company limited',
    'CONCORD ENVIRO SYSTEMS LIMITED',
    'Asp infraprojects private limited',
    'Jay pee rubber industries pvt ltd',
    'G & c global consortium private limited',
    'H.m.infratech private limited',
    'Oriana realty private limited',
    'Nucam builders private limited',
    'Nockel india private limited',
    'Signa infrastructure india limited',
    'Omnex infrastructure private limited',
    'L&t metro rail (hyderabad) limited',
    'ZAF',
    'S MEDICAL DEVICES AND SERVICES PRIVATE LIMITED',
    'Impressive interior fitout private limited',
    'Mahenoshi exports private limited',
    'Sadanam personal products limited',
    'Polycore process conveyor belting private limited',
    'Khaitan paper & packaging pvt ltd',
    'Accura shelving systems private limited',
    'Renewable energy (phoolwadi) private limited',
    'Pentagon modular system private limited',
    'Pitroda furniture private limited',
    'Western urja private limited',
    'Gangdari hydro power private limited',
    'Essar electric power development corporation limited',
    'Shivalik renewable energy private limited',
    'Punjab non conventional energy private limited',
    'ROLLZ INDIA RECYCLABLES PRIVATE LIMITED',
    'Ecogreen multifuel private limited',
    'Genial energy house private limited',
    'Simhapuri energy limited',
    'Hayen hydel power company private limited',
    'Shyam metalics and energy limited',
    'VALENS MOLECULES PRIVATE LIMITED',
    'Rupa hydel power private limited',
    'Amrit green power private limited',
    'Costra retail and commercial solutions private limited',
    'South glass private limited',
    'Decal in - italian graphics industry private limited',
    'Link energy private limited',
    'Jbm solar power private limited',
    'Gujarat clean development mechanism projects private limited',
    'SUMICOT LIMITED',
    'Madhav urja private limited',
    'Ecogreen energy trading private limited',
    'Octagreen nano products india private limited',
    'Renco technologies private limited',
    'Regen infrastructure and services private limited',
    'Cummins cogeneration india private limited',
    'Star gold private limited',
    'Prytek modular systems private limited',
    'Crosslink shipbreakers private limited',
    'Exmar shipmanagement india pvt. ltd.',
    'Gujarat-dwarka portwest limited',
    'SHIROKI AUTOMOTIVE INDIA PRIVATE LIMITED',
    'Siddheshwar diamonds private limited',
    'Ind-barath energies (thoothukkudi) limited',
    'Varun bio energy private limited',
    'Berkeley energy renewables india private limited',
    'ADANI BUNKERING PRIVATE LIMITED',
    'JBM RENEWABLES PRIVATE LIMITED',
    'Kurukshetra automobiles private limited',
    'Pioneer power-infra limited',
    'Rapum hydro power private limited',
    'Techright solar energy private limited',
    'Sungold energy private limited',
    'Bhagalpur electricity distribution company private limited',
    'P p automotive private limited',
    'Rjd technologies ites sez private limited',
    'Max aqua limited',
    'SAMARTH ENGINEERING COMPANY PRIVATE LIMITED',
    'Kmb designs private limited',
    'Ojash construction private limited',
    'Parsvnath infra limited',
    'Gark infra private limited',
    'Ethenic projects private limited',
    'Ashford properties private limited',
    'Mak pack private limited',
    'Pashupati polytex private limited',
    'Godawari energy limited',
    'Vatika infracon private limited',
    'PACIFICA BUILDERS PRIVATE LIMITED',
    'Abhigam infrastructure development private limited',
    'RATNABHUMI DEVELOPERS LIMITED',
    'KANDLA COMMODITIES PRIVATE LIMITED',
    'Transcon freight system private limited',
    'Applied smart logistics private limited',
    'Point 2 point logistics (india) private limited',
    'Target freight services (i) pvt.ltd.',
    'Allport cargo private limited',
    'Arora logistix private limited',
    'Vita private limited',
    'GREENKO SUMEZ HYDRO ENERGIES PRIVATE LIMITED',
    'Paradigm logistics and warehousing private limited',
    'M k r foods private limited',
    'Capital city hospitality private limited',
    'SCARLETT HOTELS & RESORTS PRIVATE LIMITED',
    'City pulse entertainments private limited',
    'NEPTUNE LEISURE & HOLIDAYS PRIVATE LIMITED',
    'Bari properties private limited',
    'Anumanthai beachside resorts private limited',
    'Conbar india private limited',
    'Utility logistic private limited',
    'Shanker logistics pvt ltd',
    'Ultra fairwood india private limited',
    'Cartel india logistics private limited',
    'Aban hotels and resorts p ltd',
    'Atlas de cargo (india) private limited',
    'Radiant agencies private limited',
    'Limestone sales private limited',
    'Seabird dealers private limited',
    'Future vision aide private limited',
    'Quality dealtrade private limited',
    'Atcorp global private limited',
    'Navyug commosales private limited',
    'Attraction vinimay private limited',
    'Solidity tie-up private limited',
    'Schmersal india private limited',
    'Omc chemicals and allied chromatography private limited',
    'NEIPUN INFORMATICS PRIVATE LIMITED',
    'Steelcon impex private limited',
    'Avinash techno solutions private limited',
    'Vee gee pee impex private limited',
    'Hugo trading private limited',
    'Ramak enterprises pvt ltd',
    'P.manoharlal and sons jewellers private limited',
    'Manimala suppliers private limited',
    'Nulon india limited',
    'D c johar and sons private limited',
    'Sri lakshmi venkateswara trading company private limited',
    'S raja export private limited',
    'Magarpatta retail private limited',
    'Mooskick solutions private limited',
    'NURON NETWORKS INDIA PRIVATE LIMITED',
    'Cicada info solutions private limited',
    'Jump global digital solutions private limited',
    'Olmec technologies private limited',
    'Kapnovate technologies private limited',
    'Endurance web solutions private limited',
    'I-exist technology solutions private limited',
    'QUALITY THEOREM PRIVATE LIMITED',
    'Sankheki analytics and research private limited',
    'Mfx infotech private limited',
    'Tratum technologies private limited',
    'Datec systems private limited',
    'Progressive cybernetics private limited',
    'Astro vision futuretech private limited',
    'Ohile technologies private limited',
    'Jmr infotech india private limited',
    'Ardaeon technologies private limited',
    'Zetozone technologies (india) private limited',
    'Burndy technology & global business services private limited',
    'Descpro technologies private limited',
    'Jd infolabs systems and solutions private limited',
    'Grandson technologies private limited',
    'Eglobe it solutions private limited',
    'Portrave solutions private limited',
    'Igost technologies private limited',
    'Travanleo info solutions ( india) private limited',
    'Comcube integrated solutions private limited',
    'Yazata business consulting private limited',
    'Futech computers pvt ltd',
    'Cygnus software private limited',
    'Aerodiam software (bombay) private limited',
    'Rockhard tech solutions private limited',
    'Omega systems and services private limited',
    'EDUCLAAS PRIVATE LIMITED',
    'Maheshwari infomatic private limited',
    'Star itech private limited',
    'Maq india private limited',
    'Haware infotech limited',
    'Qtech software private limited',
    'Ranadive consultancy services private limited',
    'Modulesoft solutions private limited',
    'Cinet it solutions private limited',
    'Bestray infotech private limited',
    'Netset software private limited',
    'Santulan projects private limited',
    'Synise technologies limited',
    'Silver technologies private limited',
    'India engineering private limited',
    'Pillar it services private limited',
    'Graphinet solutions private limited',
    'WIPRO LINECRAFT AI PRIVATE LIMITED',
    'Vaksrujan linguasoft private limited',
    'Linsyssoft technologies private limited',
    'Innova infologics private limited',
    'Forefront technologies private limited',
    'Spring computing technologies private limited',
    'Harbinger group software private limited',
    'Jaguar solutions private limited',
    'Prestine techsystems private limited',
    'Rahi systems private limited',
    'Sharda integrated systems private limited',
    'Brainchamber kakrika private limited',
    'Catalyze systems private limited',
    'Rishab infotech private limited',
    'Aster techno pack systems private limited',
    'Choice precitech india private limited',
    'Starlite fashions private limited',
    'Iridium interactive limited',
    'Internet trucking india private limited',
    'Globrin systems and solutions limited',
    'Graylogic technologies private limited',
    'Anjalee business solutions private limited',
    'Intelligraphics technologies (india) private limited',
    'Young india information technology services private limited',
    'Avni tech ventures private limited',
    'E2e analytix technologies private limited',
    'Ez minds i.t solutions private limited',
    'Rivi consultancy services private limited',
    'Itechmanage cybermatics private limited',
    'Safertek it solutions private limited',
    'Techno brain india private limited',
    'Delexcent systems private limited',
    'Innovare technologies private limited',
    'Shell networks & solutions limited',
    'Ameripro solutions private limited',
    'Glovision techno services private limited',
    'Jagsar international technolabs private limited',
    'Techicon it services india private limited',
    'Alliance pro it private limited',
    'Effigent software solutions private limited',
    'Cloudalp technologies private limited',
    'Photon infotech private limited',
    'Polysoft technologies private limited',
    'Leonex systems private limited',
    'Chakrika technosolutions private limited',
    'Synaptris decisions private limited',
    'Opus info serve private limited',
    'Integratech india private limited',
    'Mapps infotech private limited',
    'Spinesoft infotech private limited',
    'Tekflair consultants private limited',
    'Infinitek engineers & consultants private limited',
    'Adyam international private limited',
    'Alltech biotechnology private limited',
    'Aquanautics system private limited',
    'Broadening horizons services private limited',
    'Ether design private limited',
    'Micro energy credits corporation private limited',
    'Tristar assurance services private limited',
    'The freyssinet pre-stressed concrete company limited',
    'Hindustan platinum private limited',
    'New fire engineers private limited',
    'Gartels werke limited',
    'Liberty international limited',
    'IMPERIAL WATERPROOFING INDUSTRIES PRIVATE LIMITED',
    'Chintamani diesel sales and service private limited',
    'Rashmi writing aids private limited',
    'Synergy infotech private limited',
    'Merint developers private limited',
    'Balaji glaziers private limited',
    'Solas safety service station private limited',
    'Miracle knowledge resources private limited',
    'Telos consultancy services private limited',
    'Diamond and gem laboratories of america private limited',
    'Jsw projects limited',
    'Technecon healthcare private limited',
    'Silica tool manufacturing and allied services private limited',
    'Ssj consultancy private limited',
    'Supreme instrument technology private limited',
    'GYRFALCON ENTERPRISES PRIVATE LIMITED',
    'Balaji institute of technical training limited',
    'Dat enggserve private limited',
    'Savera kothari india private limited',
    'Jeena scriptech alpha advisors private limited',
    'Fractal ink design studio private limited',
    'Beanstalk retail private limited',
    'E14 technologies private limited',
    'INTELLIBUZZ PRIVATE LIMITED',
    'ORCA CORPORATE SERVICES PRIVATE LIMITED',
    'Addinol lube oil india private limited',
    'Mittal infocom private limited',
    'Air vent engineering projects private limited',
    'Reyna steels limited',
    'KNACK GLOBAL PRIVATE LIMITED',
    'KIMBERLY-CLARK INDIA PRIVATE LIMITED',
    'Kisan forum private limited',
    'Walmikee surveyors and contractors private limited',
    'Holtec asia private limited',
    'Unicus advisors private limited',
    'Finora technologies private limited',
    'Sanriya investment advisors private limited',
    'Pharmaace analytics private limited',
    'Cee engineering private limited',
    'Ujjvalatejas solaire urja private limited',
    'Sutradhar casting agency private limited',
    'Valmiki consultants private limited',
    'West pharmaceutical packaging india private limited',
    'Southern carparkings limited',
    'Dsm technocon private limited',
    'Focus ventures (india) private limited',
    'D1 mohan bio oils limited',
    'Abc techno labs india private limited',
    'Knr engineers (india) private limited',
    'Indospace skcl industrial park private limited',
    'Zoe advertising private limited',
    'Seasky freight systems india private limited',
    'Drona ventures india private limited',
    'Vass softwares & solutions private limited',
    'Dialectics services private limited',
    'R.k.p.a logistics services private limited',
    'Jersey engineering solutions private limited',
    'Xenon automotive india private limited',
    'Acuity india resorts private limited',
    'Archana kapil associates private limited',
    'SOVA SOLAR LIMITED',
    'NARAYANI PUBLISHERS & MEDIA SUPPORT PRIVATE LIMITED',
    'Saosis biotech private limited',
    'KALYANI ADITYA MINERAL LIMITED',
    'Alastair commosales private limited',
    'Msde engineering private limited',
    'Webzemini software private limited',
    'Sit solutions private limited',
    'WABI SABI BISTRO & TREASURE TROVE PRIVATE LIMITED',
    'Neue allianz corporate services private limited',
    'Disha communications private limited',
    'Options executive search private limited',
    'THERMAX FOUNDATION',
    'Embassy knowledge infrastructure projects private limited',
    'Skillsoft software services india private limited',
    'Middlesex education private limited',
    'Varkey international schools private limited',
    'Vk academy of education private limited',
    'Brain pace consultancy private limited',
    'Baldev and raj handa devlopment foundation',
    'MWT GLOBAL ACADEMY PRIVATE LIMITED',
    'Youth empowerment skills foundation',
    'Concepts eduserv private limited',
    'Neotech education foundation',
    'Bharat panchal education private limited',
    'Shri guru gyan private limited',
    'PANCHAKSHARI',
    'S EDUCATIONAL CONSULTANCY PRIVATE LIMITED',
    'NG Production & Media Private Limited',
    'HAWS INDIA PRIVATE LIMITED',
    'ALVESS INDIA PRIVATE LIMITED',
    'DEERAK SOLUTIONS PRIVATE LIMITED',
    'ONESOURCE MANAGEMENT CONSULTING INDIA PRIVATE LIMITED',
    'ENERGY PLUS SPECIALIZED SERVICES PRIVATE LIMITED',
    'JINDAL ITF LIMITED',
    'BSBK Engineers Private Limited',
    'BRAINHUNTER RECRUITING (INDIA) PRIVATE LIMITED',
    'PURNA TECHSOL LIMITED',
    'ADROIT PUBLIC RELATIONS PRIVATE LIMITED',
    'VALINGRO PRIVATE LIMITED',
    'Cycure Solutions Private Limited',
    'NAMPA INFRA & AGRO (INDIA) PRIVATE LIMITED',
    'HAND IN HAND CONSULTING SERVICES PRIVATE LIMITED',
    'CYBER PEARL INFORMATION TECHNOLOGY PARK PRIVATE LIMITED',
    'GVR MEDIA ARTS PRIVATE LIMITED',
    'SYSGEN SOLUTIONS TECHNOLOGIES PRIVATE LIMITED',
    'ZAGG NETWORK PRIVATE LIMITED',
    'DHATRI ADVERTISSING PRIVATE LIMITED',
    'VISHAL BHARATH COMNET',
    'SAI GANESH EXPORTS PRIVATE LIMITED',
    'NANO FINANCIAL SERVICES INDIA PRIVATE LIMITED',
    'VERTICURL MARKETING PRIVATE LIMITED',
    'Gnosys Skill Bridge Private Limited',
    'LIA WAREHOUSING AND LOGISTICS PRIVATE LIMITED',
    'UNIQUE RESEARCH AND INFORMATION PRIVATE LIMITED',
    'Great land builders and infratech private limited',
    'Chaitanya property developers private limited',
    'Anjis developers private limited',
    'Fine touch construction private limited',
    'Bhumika properties private limited',
    'Manali development and finance private limited',
    'Rahi estates private limited',
    'Jeel builders private limited',
    'Antim estates private limited',
    'Manohar properties private limited.',
    'Matador housing private limited',
    'MUKESH KIMTANI ESTATES PRIVATE LIMITED',
    'New era dwellers and constructions private limited',
    'Elder developers private limited',
    'Om sai developers private limited',
    'Ernest worthing realty private limited',
    'HCC CONTRACT SOLUTIONS LIMITED',
    'Bhoomi erectors private limited',
    'Nanalal chaganlal developers private limited',
    'Ssn promoters and builders private limited',
    'Cmg infrastructure private limited',
    'PITTIE AYURVED PRIVATE LIMITED',
    'Kushal landmarks private limited',
    'SARTHAK HOUSING PRIVATE LIMITED',
    'C.s.reddy constructions private limited',
    'Vishaka ship building private limited',
    'Futureage infrastructure india limited',
    'Beccun infrastructures limited',
    'Tecton international engineering construction company private limited',
    'Sk heavenly homes private limited',
    'Ramendra housing private limited',
    'Amazing developers private limited',
    'Lakhani apparel private limited',
    'Pataso builders and infrastructure private limited',
    'Pshc realter private limited',
    'Starcon infra projects india private limited',
    'Baakir real estates private limited',
    'Swagat infrastructure private limited',
    'PRIYANKA INFRA PRIVATE LIMITED',
    'Vastuchakra housing and management private limited',
    'Valiant constructions private limited',
    'LANOZ REAL ESTATE & INFRASTRUCTURE PRIVATE LIMITED',
    'Gurudev realty private limited',
    'Shree matangi developers private limited',
    'Shivalik plaza private limited',
    'Vision infra creations private limited',
    'Galaxy mall private limited',
    'ADVAIT INFRATECH LIMITED',
    'Dlf projects limited.',
    'Saibalaji enterprises private limited',
    'Champion infratech private limited',
    'PLUTONIC ENTERPRISES INDIA PRIVATE LIMITED',
    'Dubex engineering and constructions private limited',
    'Muez - hest india private limited',
    'VENKY INDUSTRIES PRIVATE LIMITED',
    'Pashmina realty private limited',
    'Supreme housing and hospitality private limited',
    'Dbm projects private limited',
    'Mayfair urban developers private limited',
    'Biopharmax india private limited',
    'Chirag buildcon private limited',
    'CREATIVE REALMART PRIVATE LIMITED',
    'Shri shyam baba constructions limited',
    'JAYABHERI PROPERTIES & SERVICES PRIVATE LIMITED',
    'Ecoworld infrastructure private limited',
    'Marc properties constructions pvt ltd',
    'Jk surface coatings private limited',
    'Seven eleven corporation limited',
    'AXON CORPORATE SERVICES INDIA PRIVATE LIMITED',
    'GRY COSMETICS PRIVATE LIMITED',
    'SALDAR INFRASTRUCTURE & CONTRACTS PRIVATE LIMITED',
    'Darsshan infracon private limited',
    'Brilliant landcon private limited',
    'Perfect nivesh infra private limited',
    'Runwal housing & townships private limited',
    'Valasai vettikadu realtors private limited',
    'Vmak it services private limited',
    'Bindu soft tech private limited',
    'Rig informatics private limited',
    'Numero graphic creative solutions private limited',
    'Topnotch enterprises p ltd',
    'M&S SOFTWARE INDIA PRIVATE LIMITED',
    'Rich international (india) private limited',
    'Athreya business solutions private limited',
    'C soft marketing private limited',
    'Basuki it solutions private limited',
    'Eternity innovations & technologies private limited',
    'Tsquare software private limited',
    'Saras software services private limited',
    'Veetee technologies private limited',
    'Foxteq services india private limited',
    'Ingeco gears private limited',
    'Foresolve technologies private limited',
    'Beyond applications (india) private limited',
    'Milestone technocrat private limited',
    'Syphar technosoft private limited',
    'Systems domain private limited',
    'Espi power products private limited',
    'SAFEPRO AI VIDEO RESEARCH LABS PRIVATE LIMITED',
    'Aeroway networks private limited',
    'Taurus powertronics private limited',
    'Csg solutions india private limited',
    'Exotel techcom private limited',
    'Estomi technologies private limited',
    'NETCUBE TECHNOLOGIES PRIVATE LIMITED',
    'Frrole tech private limited',
    'Purple art media solutions private limited',
    'ISPRAVA VESTA PRIVATE LIMITED',
    'DATAMATICS INFORMATION SOLUTIONS LIMITED',
    'Nds infotech limited',
    'J. p. morgan services india private limited',
    'SAMESPACE LABS PRIVATE LIMITED',
    'Edr continuous information private limited',
    'Arrk solutions private limited',
    'Westex infotech private limited',
    'Gradatim i.t. ventures (india) private limited',
    'Dadajee dhackjee infotech private limited',
    'Nine dots technologies private limited',
    'Flytxt mobile solutions private limited',
    'Furnatech solutions private limited',
    'Tag computek private limited.',
    'Digi vistaar network private limited',
    'KTI INTELLIGENT SYSTEMS PRIVATE LIMITED',
    'SYNERGY INVESCO PRIVATE LIMITED',
    'Pentagon network solutions private limited',
    'Connect future it consulting private limited',
    'B3 infotech private limited',
    'Aditi tracking support private limited',
    'Lnv digital systems private limited',
    'Realise hayagreeva technology services private limited',
    'Syntrosys technologies private limited',
    'Increed technologies private limited',
    'Zouka solutions private limited',
    'Global wave systems private limited',
    'Qupod technovations private limited',
    'General globaltechnologies private limited',
    'Terbium solutions private limited',
    'Vaal triangle systems private limited',
    'I-deb accountancy private limited',
    'Inecom technology private limited',
    'Sigmatek systems india private limited',
    'Jayashree tubestech component private limited',
    'Cscworld (india) private limited',
    'Weshine tech private limited',
    'S p advantech systems private limited',
    'Oneclick it consultancy private limited',
    'Programmr technologies private limited',
    'Datametica solutions private limited',
    'Smart net india private limited',
    'Ilabs hyderabad technology centre private limited',
    'Transdyne it services private limited',
    'Kanna technologies private limited',
    'Nat it services private limited',
    'Kameshwari e services private limited',
    'Blazedream technologies private limited',
    'Dacam systems private limited',
    'Karya technologies (india) private limited',
    'Jm integrated solutions private limited',
    'Iscistech business solutions private limited',
    'IYKONS BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'Iavi india',
    'VEEDA CLINICAL RESEARCH LIMITED',
    'OCIIMUM TRADING & INVESTMENTS PRIVATE LIMITED',
    'Cept research & development foundation',
    'RURABI VENTURES PRIVATE LIMITED',
    'Airpro engineers private limited',
    'Dr. anjali morris education & health foundation',
    'MANCOMP OVERSEAS EDUCATION PRIVATE LIMITED',
    'Idea lab (india) private limited',
    'GENOME INTERNATIONAL INDIA PRIVATE LIMITED',
    'Prerna consultants private limited',
    'ARL TYRES LIMITED',
    'AHIMSA INDUSTRIES Limited',
    'Meeta packaging private limited',
    'S. kumar multiproducts private limited',
    'Brentwood industries india private limited',
    'Insight care polyplast private limited',
    'Shivam packaging industries private limited',
    'Decap closures private limited',
    'MEDTECH LIFE PRIVATE LIMITED',
    'Harra polyflex private limited',
    'Autodynamic engineering private limited',
    'Saino polymers private limited',
    'Atika reinforced plastic products private limited',
    'Sidel india private limited',
    'Star global endura limited',
    'Coromandel packaging private limited',
    'POLYSPIN PRIVATE LIMITED',
    'Hi-tech flyash (india) private limited',
    'Arihant build - mart private limited',
    'Rajat impex private limited',
    'Giant realty private limited',
    'Laxcon steels limited',
    'Super quali cast (india) private limited',
    'Paras bhavani steel private limited',
    'Shravak overseas private limited',
    'Devi iron and power private limited',
    'Salasar alloy and steel industries private limited',
    'Bluescope steel india private limited',
    'Nachiketa power & steel private limited',
    'Amit ferro-alloys & steel private limited',
    'MADHAV FORGINGS PRIVATE LIMITED',
    'Athi sivan steels private limited',
    'Rahee track technologies private limited',
    'Pramukh forge private limited',
    'Vijay ferromet private limited.',
    'Aggarwal soundcast private limited',
    'Somani ispat private limited',
    'Global color steels private limited',
    'Hackbridge-hewittic & easun ltd',
    'Sabari alloys & metals india private limited',
    'AVATOR STEEL PRIVATE LIMITED',
    'Aurangabad metal products private limited',
    'Paradiso jewels private limited',
    'Ishan industries private limited',
    'Jans copper private limited',
    'LIVING FOODS INDIA PRIVATE LIMITED',
    'Chetana metals private limited',
    'Vspn alloys private limited',
    'Aryavart metals private limited',
    'Diason advertising private limited',
    'Usra udyog private limited',
    'Ashar lockeys private limited',
    'United steel building systems private limited',
    'Nipman auto components private limited',
    'RUDRA GLOBAL INFRA PRODUCTS LIMITED',
    'M. s. facades private limited',
    'ACE FOILS PRIVATE LIMITED',
    'Viraj technocast private limited',
    'Meet control panel private limited',
    'U s high-tech engineering private limited',
    'Agh wires private limited',
    'Vipras corporation limited',
    'Steel strong valves (india) private limited',
    'Shreeji industrial engineers (bombay) private limited',
    'Santo engineering company private limited',
    'Clean coats private limited',
    'Pushpshree surface coating private limited',
    'Yogashri heavy engineering private limited',
    'De-or metal industries private limited',
    'Vacman sanitation solutions private limited',
    'Vintop products private limited',
    'Kanchan kitchenaid private limited',
    'Advik precision private limited',
    'Prodesign engineering services private limited',
    'Shree tanishq machineries private limited',
    'Deeba engineers and marketing private limited',
    'Sri surya solarisers private limited',
    'Poduval engineering company private limited',
    'Tecnik valves private limited',
    'Shree saikrupa hydraulics (gujarat) private limited',
    'Classic solvents pvt ltd',
    'Investa pumps private limited',
    'Guindy machine tools limited',
    'Mercury fittings private limited',
    'BASIC ENGINEERING PRIVATE LIMITED',
    'Gloline equipments private limited',
    'Hi-tech apparatus private limited',
    'A.k. genset private limited',
    'Zephyr fire equipments india private limited',
    'HEELIX TECHNOLOGY & CONSULTANCY PRIVATE LIMITED',
    'Abhishek engineers pvt ltd',
    'GAEKWAR ENTERPRISE PRIVATE LIMITED',
    'Saiesh technologies private limited',
    'Rex steam products private limited',
    'Garison electro mechanical systems private limited',
    'Kleenair systems p ltd',
    'Mayfair housing private limited',
    'Capricorn realty private limited',
    'Amideep wealth management private limited',
    'Amro real estates private limited',
    'Multiplier real estates private limited',
    'Sandip educational infrastructures private limited',
    'Sheth infra estate private limited',
    'ISHAYU BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Add realty limited',
    'Naseema properties private limited',
    'ATISHAY LIMITED',
    'Rajasthan cereals private limited',
    'A.r. builders and developers private limited',
    'SANDHYA INFOCITY LIMITED',
    'Rge constructions and development private limited',
    'Anmol projects private limited',
    'Sdb developers private limited',
    'F-one infrastructure private limited',
    'Amidhara arcade private limited',
    'AMIKRUPA INCH PRIVATE LIMITED',
    'Greenbrix infra ventures private limited',
    'Rare townships private limited',
    'Flagship real estate private limited',
    'Good luck real estate private limited',
    'Multiplier properties private limited',
    'Mystical restaurants & properties private limited',
    'Pawansut realtors private limited',
    'Ekta shubham housing projects private limited',
    'Sahib realty private limited',
    'Do it property services private limited',
    'Trips infrastructure private limited',
    'Ayansh properties private limited',
    'Hema realty private limited',
    'Mhaiskar landmarks private limited',
    'Silver properties and infrastructure private limited',
    'Vilas javdekar eco developers private limited',
    'Jayadarsini housing private limited',
    'Imax developers private limited',
    'VEPTOR PROJECTS PRIVATE LIMITED',
    'Building blocks projects india private limited',
    'Saudhaa developers india private limited',
    'VKG EQUIPMENTS PRIVATE LIMITED',
    'Bsp infratech private limited',
    'Silver-x projects india private limited',
    'Kiva estates private limited',
    'Aniki estates private limited',
    'Swarnalatha infratech private limited',
    'SUKRA HOMES PRIVATE LIMITED',
    'Ls asset holding private limited',
    'Yamuna infradevelopers private limited',
    'Excel dwellings oxigen private limited',
    'Square feet property consultant private limited',
    'Babitha conveyance solutions private limited',
    'Platinum rent a car (india) private limited',
    'Cardworks private limited',
    'USEREADY TECHNOLOGY PRIVATE LIMITED',
    'ASIS CORPORATE ADVISORS LIMITED',
    'Techatalyst software private limited',
    'Spectrum computer and management consultancy private limited',
    'Rox technology and solution private limited',
    'Cognex technology private limited',
    'Trikona technologies private limited',
    'Insights of data private limited',
    'Techouts solutions india private limited',
    'Sc infotech private limited',
    'Royalle community networks private limited',
    'Vinflag direct private limited',
    'Hyaline infotech private limited',
    'Servilink systems limited',
    'LEMON TECHNOLOGIES PRIVATE LIMITED',
    'E-procurement technologies limited',
    'SAPSOL TECHNOLOGIES PRIVATE LIMITED',
    'Digital infoware private limited',
    'NHANCE DIGITAL PRIVATE LIMITED',
    'Yugtia technologies private limited',
    'Altruist technologies private limited',
    'First advantage global operating center private limited',
    'Automated workflow solutions private limited',
    'Lancesoft india private limited',
    'Bridgeline digital private limited',
    'Unitforce technologies consulting private limited',
    'Globals ites private limited',
    'Sdl technologies india private limited',
    'Concurrent tech india private limited',
    'Gieom business solutions private limited',
    'Prokosha systems private limited',
    'Panso solutions private limited',
    'Datawood consulting private limited',
    'TRANSUNION GLOBAL CAPABILITY CENTER PRIVATE LIMITED',
    'Foradian technologies private limited',
    'Tismo technology solutions private limited',
    'User experience design consulting private limited',
    'Plavaga software solutions private limited',
    'Nsi nextwealth it services private limited',
    'Aaneel technology solutions private limited',
    'Cogent data solutions private limited',
    'Comfort geosynthetics and marketing private limited',
    'KOTAK GLOBAL PROJJECT PRIVATE LIMITED',
    'Impres india cable & pipe supports private limited',
    'Century sanitaryware india private limited',
    'Crane seals india pvt ltd',
    'Butterfly impex pvt ltd',
    'J p dyechem private limited',
    'Olivia impex private limited',
    'Bhavyanidhi enterprise private limited',
    'FREYDIYA EDUCARE SERVICES PRIVATE LIMITED',
    'Liveminds solutions private limited',
    'Kanungo impex private limited',
    'Viva industries limited',
    'SHREE EMERGENCE ENTERPRISES PRIVATE LIMITED',
    'Rubix trading private limited',
    'SHREM ENTERPRISES PRIVATE LIMITED',
    'Mpp trading private limited',
    'Bontoux naturals private limited',
    'Span overseas private limited',
    'Inficon india private limited',
    'Rasi exports private limited',
    'Shri renuga refineries private limited',
    'Ashique exports private limited',
    'Maijo exports limited',
    'Pole-star ventures private limited',
    'Milmarkk agencies private limited',
    'Zedd commercial pvt ltd',
    'Ayeasha commo trade private limited',
    'Agarwal trading company private limited',
    'AADARSH TRADLINK LIMITED',
    'Globus trade links private limited',
    'Lomi enterprise private limited',
    'SDSS EVENTS AND MARKETING PRIVATE LIMITED',
    'White and purple works private limited',
    'Trendline commercials private limited',
    'Unlimited nutrition private limited',
    'Aqsa telecom private limited',
    'R shantilal network private limited',
    'Shopalo retail private limited',
    'MIL INDIA PRIVATE LIMITED',
    'Baroda superstore private limited',
    'Align retail trades private limited.',
    'Burmester india private limited',
    'JADOUN INTERNATIONAL PRIVATE LIMITED',
    'Unijules life sciences limited',
    'Landmark designers studio private limited',
    'Naramit apparel private limited',
    'Bafna retail private limited',
    'Abhijeet ferrotech limited',
    'Tecxotic exim and trades private limited',
    'Kazage home fashions private limited',
    'Inatia natural products private limited',
    'Kamaths natural retail private limited',
    'Mersey eventures private limited',
    'HARMONY LEATHER IMPEX PRIVATE LIMITED',
    'Universal lss exports india private limited',
    'Eyematic electronics private limited',
    'K raheja corp private limited',
    'Live oak resorts private limited',
    'Mgn estates private limited',
    'Roots corporation limited',
    'Grange hotels and properties private limited',
    'Vrx hospitality services private limited',
    'AMRITARA HOTELS AND RESORTS PRIVATE LIMITED',
    'Mfar elite resorts private limited',
    'Pardesi guest house private limited',
    'MOTEL DAMJI',
    'S HEALTHCARE PRIVATE LIMITED',
    'Idea india ka innovations private limited',
    'Obox hr solutions private limited',
    'Bankers quotient learning solutions private limited',
    'Valueroam technologies private limited',
    'Ctrl m print management india private limited',
    'Mf utilities india private limited',
    'Sagar weddings & events private limited',
    'Ceres hospitality private limited',
    'Wolfcrow private limited',
    'Flat dot to technologies private limited',
    'Jyoti agro feeds private limited',
    'Salexi h.r. solutions private limited',
    'ARETE MARINE AND OFFSHORE SERVICES PRIVATE LIMITED',
    'Ubik film private limited',
    'Ms 5 foods private limited',
    'Krishar multitrade private limited',
    'Desimobile voice lab communications private limited',
    'Identity outdoor india private limited',
    'Versatile marketing private limited',
    'Gist advisory private limited',
    'K H FACILITY SOLUTIONS INDIA PRIVATE LIMITED',
    'Excelorr services private limited',
    'Arm consultants private limited',
    'Thales india private limited',
    'Inspireone technologies private limited',
    'AE-RESEARCH PRIVATE LIMITED',
    'Spike advertising private limited',
    'Sainik surveillance and security services private limited',
    'KARUMADI STUDIOS PRIVATE LIMITED',
    'ALPHABET FARMS & RESORTS PRIVATE LIMITED',
    'Nrs advisors private limited',
    'Kn management consultants private limited',
    'Gallup india private limited',
    'STRATEGIC INFRA SERVICES PRIVATE LIMITED',
    'Direm marketing services (bangalore) private limited',
    'Zephyr peacock management india private limited',
    'International institute for learning (india) private limited',
    'Cluso infolink private limited',
    'Mercuri urval business consulting private limited',
    'Quizz merchandising company private limited',
    'Xm services (india) private limited',
    'Reliable consultancy services pvt ltd',
    'Pransa international private limited',
    'Genesis management consultancy services private limited',
    'Red apple travel private limited',
    'Alpha business consultants private limited',
    'Leapfrog strategy consulting private limited',
    'Strategic growth advisors private limited',
    'AUMMCHI ADVISOR PRIVATE LIMITED',
    'Uxmal marine services private limited',
    'Transforma management partners private limited',
    'Rank team constructions private limited',
    'Career path solutions private limited',
    'Web synergies (india) private limited',
    'Matrix technical services private limited',
    'Bellwether solutions private limited',
    'UCAL TECH SOLUTIONS PRIVATE LIMITED',
    'Phi advisors private limited',
    'Phi research private limited',
    'Crystal credit risk management services private limited',
    'Venus management consultants private limited',
    'INTEGRATED PERSONNEL SERVICES LIMITED',
    'Gns engineering india private limited',
    'Necx private limited',
    'Tripro technologies private limited',
    'Nirman consultants private limited',
    'Aalaya engineering project private limited',
    'Sartorius stedim india private limited',
    'Nesara creationss private limited',
    'VASSAM SOLUTIONS PRIVATE LIMITED',
    'Fi desighn & development private limited',
    'Aag india private limited',
    'G m kakde engineering consultants private limited',
    'Chemseals engineering private limited',
    'Universal consulting india private limited',
    'Magcons consulting engineers private limited',
    'Checkpoint systems india private limited',
    'Ida engineering private limited',
    'Brueckner machinery and service india private limited',
    'Fso designs private limited',
    'Knowledge partner technologies private limited',
    'Vector power engineering consultants private limited',
    'Zeba lab furniture private limited',
    'Rastogi segma furnitech private limited',
    'Alankritha interio limited',
    'Dharam export (india) private limited',
    'Goldiam jewellery limited',
    'V r jewel makers private limited',
    'SHEEL DIAMOND EXPORTS PRIVATE LIMITED',
    'Sundaram diamond private limited',
    'Pure platinum jewellery private limited',
    'Red digital india private limited',
    'Vyas jewellers private limited',
    'Strathspey labs private limited',
    'S s distilleries private limited',
    'Olympic sportsware & equipments private limited',
    'Regal castors private limited',
    'Suntechno international limited',
    'Respose waste management and research private limited',
    'Astra power private limited',
    'Shan solar power ventures private limited',
    'WALWHAN SOLAR ENERGY GJ LIMITED',
    'Solar fields energy photo voltaic india private limited',
    'TERRALIGHT SOLAR ENERGY TINWARI PRIVATE LIMITED',
    'TERRALIGHT SOLAR ENERGY CHARANKA PRIVATE LIMITED',
    'Winindia ventures private limited',
    'SAMIRAN JAISALMER WINDFARMS PRIVATE LIMITED',
    'AMPLUS JYOTIMANGAL ENERGY PRIVATE LIMITED',
    'K ramachandra rao transmission and projects private limited (part.ix)',
    'Chhattisgarh energy consortium (india) private limited',
    'Sei sitara private limited',
    'Sei green flash private limited',
    'Sei arushi private limited',
    'RENEW PRIVATE LIMITED',
    'Nsl wind power company (phoolwadi) private limited',
    'Nsl nagapatnam power ventures private limited',
    'Sei adityashakti private limited',
    'Sei suncells private limited',
    'Sei suryalabh private limited',
    'Tn oxygen private limited',
    'Envicare technologies private limited',
    'Garnet developers private limited',
    'Mirchandani projects private limited',
    'Sme buildtech (india) private limited',
    'Gulmohar park mall private limited',
    'Kailashpati property holders private limited',
    'Sujyot infrastructure private limited',
    'Azaro project private limited',
    'Shanti life space private limited',
    'Indel infra private limited',
    'Shanta mangesh developers private limited',
    'Prakruti constructions pvt ltd',
    'Rajdulari builders and developers private limited',
    'Harmony developers private limited',
    'Means infrastructure india private limited',
    'Lifetime realty private limited',
    'Abhishek millennium contracts private limited',
    'Sadguru-krupa constructions private limited',
    'Prithvi homes and hotels private limited',
    'Alp acres & landlines private limited',
    'Integrated spaces limited',
    'Pegaus properties private limited',
    'Jade constructions private limited',
    'Autostrade indian infrastructure development private limited',
    'Giri prime housing and properties private limited',
    'Dcube ventures & developers private limited',
    'Kshitiraj estates private limited',
    'Gulab valley homes private limited',
    'Grd infraprojects private limited',
    'Tamboli infraprojects private limited',
    'Rmd buildcon private limited',
    'Divya homes private limited',
    'Madras escon private limited',
    'Chennai cybercity private limited',
    'Trr housing and resorts private limited',
    'Venkatrama techno city private limited',
    'Dhx infratech private limited',
    'D.s.r. infrastructure private limited',
    'Abbundu interiors and constructions private limited',
    'Hitech civil engineers private limited',
    'Interarch building products private limited',
    'Swaran ratan estates private limited',
    'Vikas planner pvt ltd',
    'Kw infrabuild private limited',
    'Desai construction private limited',
    'Infinite civil solutions private limited',
    'B.r. land developers private limited',
    'Prasthan buildcare private limited',
    'Neptune infraspace private limited',
    'Ontime constructions private limited',
    'MELLOW BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'Royal outlook developers (mumbai) private limited',
    'Swaraj infrastructure private limited',
    'Sunman infrastructures private limited',
    'CENTRIO LIFESPACES LIMITED',
    'September moons accessories private limited',
    'Travel home private limited',
    'Power software & infotech private limited',
    'Daxter polymers private limited',
    'Sai net services private limited',
    'Chrysos edge consultants private limited',
    'Rufaro estates private limited',
    'Y. k. logistics private limited',
    'Spuul digital entertainment private limited',
    'Fts india private limited',
    'Crossasyst technologies private limited',
    'Meghdoot wealth management private limited',
    'AUGMONT ENTERPRISES PRIVATE LIMITED',
    'Adid atelier private limited',
    'Techmentis global services private limited',
    'Contrarian capital india partners private limited',
    'Hindi tech private limited',
    'Pipetech engineering solution private limited',
    'Applied pavement engineering consultants private limited',
    'Manaanch media private limited',
    'Cgl logistics private limited',
    'Dnm trustee services private limited',
    'Rachnoutsav events private limited',
    'Aidan electromac private limited',
    'Boe research private limited',
    'Bhavishya advisory and comtrade (india) private limited',
    'North eastern management and company consultants pvt ltd',
    'Sindra microfin',
    'Ecstatic infotel private limited',
    'Samara india advisors private limited',
    'Knowledge centre for success educate private limited',
    'Vizry services private limited',
    'Megarth institute for societal transcendence private limited',
    'Innovative valuers and engineers consultant private limited',
    'Hsb international (india) private limited',
    'Fervent consultancy services private limited',
    'Focal corporate services private limited',
    'Vinayak engimech private limited',
    'Pulsar knowledge centre private limited',
    'Phikon biotech private limited',
    'Vaibhava enterprises private limited',
    'Appnomic systems private limited',
    'Prolific finvest private limited',
    'Raj office solutions private limited',
    'Fiscal solutions (mangalore) private limited',
    'Blue & gray management consultant (india) private limited',
    'Knowise learning academy india private limited',
    'Veersoft solutions private limited',
    'Nrn holdings private limited',
    'Crc human resources consulting private limited',
    'Merrymen management consulting private limited',
    'Unique consultants and contractors pvt ltd',
    'Kpmg india private limited',
    'Kpmg advisory services private limited',
    'Clea public relations india private limited',
    'Kpmg resource centre private limited',
    'Macvin consultancy private limited',
    'E and m consultants private limited',
    'Pankti management consultancy private limited.',
    'Hyatt india consultancy private limited',
    'Indrani incon private limited',
    'Pride management and consultancy services private limited',
    'Kenserve business solutions private limited',
    'Corporec search private limited',
    'Sejpal management services private limited',
    'Sophie terrisse communications india private limited',
    'Kymr management & consultancy private limited',
    'Pharmadesk solutions private limited',
    'Newport investment advisors private limited',
    'Vihar financial services private limited',
    'Zawar somani consultancy services private limited',
    'Anivig consultants private limited',
    'Urjal consultants private limited',
    'SIMPLICITY INVESTING INDIA PRIVATE LIMITED',
    'C3i consultants india private limited',
    'Violet structures & event services private limited',
    'Pcm management services private limited',
    'Smiling star advisory private limited',
    'Pravin techno private limited',
    'Sark epc projects private limited',
    'Nufaih designers and interiors private limited',
    'Kay bee tech engineers and contractors private limited',
    'Benelec infotech private limited',
    'Nishchint engineering consultants private limited',
    'Northwest creative team private limited',
    'Sarabai enterprises private limited',
    'Abv engineers and consultants private limited',
    'Sycon constructions private limited',
    'Black & veatch private limited',
    'Norburry consultants private limited',
    'Focusz designs private limited',
    'PIZO PROJECT & ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'Credence interior private limited',
    'Concept engineering projects private limited',
    'C & c infrastructure private limited',
    'QPRO DESIGN CONSULTANTS PRIVATE LIMITED',
    'Clear point instrumentation private limited',
    'Gandhi automations private limited',
    'K. m. electronic cables private limited',
    'Cms - ditl limited',
    'Telenet instrumentation private limited',
    'Jagat rf solutions (india) private limited',
    'Dynalog india limited',
    'Times global broadcasting company limited',
    'Comus electronics and technologies india private limited',
    'Parth electricals & engineering private limited',
    'Laser telesystems private limited',
    'Usha martin telematics ltd',
    'Perfect engitech & healthcare solutions private limited',
    'Mehra eyetech private limited',
    'Flexicare medical (india) private limited',
    'Unicorn medident pvt ltd',
    'Liverpool retail india limited',
    'Vi microsystems private limited',
    'Acme fitness private limited',
    'Darco medical india private limited',
    'HOLMARC OPTO-MECHATRONICS LIMITED',
    'Aic lab equipments private limited',
    'Ducon technologies (i) private limited',
    'Deepti electronics and electro optics private limited',
    'Dehradoon hospitality private limited',
    'Saffron coach private limited',
    'Manipal motors private limited',
    'Ge power conversion india private limited',
    'Afford marine controls private limited',
    'Space magnum equipment private limited',
    'Sai point automobiles private limited',
    'Wabco foundation brakes private limited',
    'Shaw floors india private limited',
    'Compo advics (india) private limited',
    'Exubero sealing technology private limited',
    'Vijaydimon diamond (india) private limited',
    'Goldiam jewels limited',
    'Saffron jewels private limited',
    'ZAR JEWELS PRIVATE LIMITED',
    'ATAM DIAM PRIVATE LIMITED',
    'Tecca furnitures private limited',
    'P&B RELAYS & SERVICES INDIA PRIVATE LIMITED',
    'International money matters private limited',
    'Sikkim hydro power ventures limited',
    'Armreache airconditioning india private limited',
    'KOSE POWER PRIVATE LIMITED',
    'Genergie power control private limited',
    'Keezharkuthu power private limited',
    'Warasgaon power supply limited',
    'Global wedge india private limited',
    'Tuppadahalli energy india private limited',
    'Ss indus solar energy private limited',
    'Go green solar private limited',
    'Twincity sunlife private limited',
    'Sun photo voltaic energy india private limited',
    'Ravi urja energy india private limited',
    'Nsl wind power company (sira-tumkur) private limited',
    'Nsl wind power company (gubbi-tumkur) private limited',
    'Nsl wind power company (holalkere-chitradurga) private limited',
    'Rsr power private limited',
    'SIEMENS GAMESA RENEWABLE ENERGY PROJECTSPRIVATE LIMITED',
    'Chamundeshwari electricity supply corporation limited',
    'Nsl orissa power and infratech private limited',
    'SEAWAY LINE VENTURES PRIVATE LIMITED',
    'Choksi energy & infrastructure private limited',
    'Avya esco private limited',
    'E-mug energy private limited',
    'Rain water concepts india private limited',
    'Varun constructions private limited',
    'Indu shree housing private limited',
    'Saikam estates & projects private limited',
    'Vaaan infra private limited',
    'D v buildwell india private limited',
    'Dnt developers private limited',
    'M & b engineering limited',
    'Pushpak construction private limited',
    'S. raheja realty private limited',
    'S. raheja infrastructure private limited',
    'Mazda construction company private limited',
    'Radha krishna properties private limited',
    'Shri sati builders and developers private limited',
    'Abhini developers private limited',
    'Gunjan properties private limited',
    'RDJ CONSTRUCTIONS LIMITED',
    'Shri sadguru shivram constructions private limited',
    'Eternity construction private limited',
    'Prabhat plaza private limited',
    'Shivam sundaram developers and realtors private limited',
    'Tanna housing private limited',
    'Nashik township developers limited',
    'Maan township developers limited',
    'Kazage lifestyles limited',
    'Bluestone lifespaces india private limited',
    'Boss brands retail private limited',
    'Holistic remedies pvt ltd',
    'Cameo garments india private limited',
    'East coast clothing company private limited',
    'Sapphire clothing company india private limited',
    'Onip lifestyle private limited',
    'Dev t- shirts private limited',
    'Shri chakra udyog limited',
    'Ajay components (pvt) limited',
    'Halcyon footwears private limited',
    'COLLOSSAL SPACEZ PRIVATE LIMITED',
    'Manav packaging industries pvt ltd',
    'Kraftpro marketing private limited',
    'Ab publication (india) private limited',
    'Tourism india publications private limited',
    'Sita books and periodicals private limited',
    'Conceptual pictures worldwide private limited',
    'Nutan printers private limited',
    'Canara labels private limited',
    'Printol enterprise private limited',
    'Red moments giftings private limited',
    'Atritex technologies private limited',
    'Aakruti digipress private limited',
    'Brahmaputra carbon limited',
    'POWER BIKES PRIVATE LIMITED',
    'Futura petro solutions private limited',
    'Aristo oil chem private limited',
    'Tecnik fluid controls pvt. ltd.',
    'Kakinada refinery and petrochemicals private limited',
    'Animax health care private limited',
    'FLUORO REFRIGERANTS PRIVATE LIMITED',
    'ENDLA ENTERPRISE LIMITED',
    'Adroit pharmachem private limited',
    'Tyche bio-medica limited',
    'Wincoat colours and coatings private limited',
    'Natural petrochemicals private limited',
    'R-brands lifestyle private limited',
    'Fibrol non - ionics private limited',
    'Lgc petrochemical india private limited',
    'Faayah products private limited',
    'Agrisol (india) private limited',
    'Metal lab enterprise private limited',
    'Green lifestyles developers private limited',
    'CHEMBOND WATER TECHNOLOGIES LIMITED',
    'Orgo chem (gujrat) pvt ltd',
    'Shri vinayak chemex (india) pvt.ltd.',
    'SAMS INDUSTRIES PRIVATE LIMITED',
    'Nirmal chem-plast private limited',
    'Applied bioscience india private limited',
    'Mazda colours limited',
    'Vrinda chemicals (india) private limited',
    'Polymorphic systems private limited',
    'MALDEEP CATALYSTS PRIVATE LIMITED',
    'Annex pharmaceutical & chemicals private limited',
    'KUKREJA PLASTICS PRIVATE LIMITED',
    'Chemintele techno private limited',
    'Arkema chemicals india private limited',
    'Komtech plastic technologies india private limited',
    'Stypack polyfoams private limited',
    'Aishwarya paints private limited',
    'Behr process paints (india) private limited',
    'NUSHAR INDIA FUTURE TECH PRIVATE LIMITED',
    'JRS PHARMA & GUJARAT MICROWAX PRIVATE LIMITED',
    'Kandla energy and chemicals limited',
    'Srt pharma private limited',
    'Dolphin pharmaceutical limited',
    'Prism life sciences limited',
    'Richfeel health and beauty private limited',
    'Komal health care private limited',
    'Clesstra healthcare private limited',
    'Rensun pharmaceuticals private limited',
    'Nippon pharmaceuticuals (india) private limited',
    'Asian gases ltd',
    'Gujarat parachlor pvt ltd',
    'Crmo pharmatech private limited',
    'Regency lifesciences (india) private limited',
    'CEVA POLCHEM PRIVATE LIMITED',
    'Esterkote private limited',
    'Liberty pharma ltd.',
    'Ddreg pharma private limited',
    'Inexios pharmaceuticals private limited',
    'Pariksha biotech private limited',
    'GREENSIGNAL BIO PHARMA PRIVATE LIMITED',
    'Parth engineering private limited',
    'Baxom healthcare private limited',
    'Chemlayer limited',
    'Micals pharma private limited',
    'Srs pharmaceuticals private limited',
    'Unitex tenamyd canada private limited',
    'Ibc pharmaceuticals private limited',
    'Madhav consumer care private limited',
    'Aakash gases private limited',
    'Pharmazell (india) private limited',
    'SAGAR LIFE SCIENCES PRIVATE LIMITED',
    'Satyam rasayan private limited',
    'CRYOTECH REFRIGERATION & HOSPITALITY PRIVATE LIMITED',
    'Viveoli retail private limited',
    'Lakeview dealtrade private limited',
    'KAPIL INFRA AVENUES PRIVATE LIMITED',
    'Indo invest vision private limited',
    'Naaptol online shopping private limited',
    'Balaji tradechem private limited',
    'S ELECTORAL TRUST',
    'NEBEL TECHNOCRATS PRIVATE LIMITED',
    'EVOLUTION ACCESS TECHNOLOGIES PRIVATE LIMITED',
    'AOSL ENERGY SERVICES LIMITED',
    'SILVERDOOR PRIVATE LIMITED',
    'MIKAYA BRANDS PRIVATE LIMITED',
    'REVOTEC POWER PRIVATE LIMITED',
    'INNOVANTIX SYSTEMS PRIVATE LIMITED',
    'TECHMARBLES WEB SOLUTIONS PRIVATE LIMITED',
    'BFC TECHNOLOGIES PRIVATE LIMITED',
    'QUADITO PRIVATE LIMITED',
    'ZINOTA REMEDIES PRIVATE LIMITED',
    'RAJVEER SUSTAINABLE ENERGY PRIVATE LIMITED',
    'PALLAVARAM LEATHER AND PRODUCTS SERVICES',
    'YUSUN ESTATES PRIVATE LIMITED',
    'VALUE SPACES LOGISTICS PRIVATE LIMITED',
    'MZRA TRAVEL PRIVATE LIMITED',
    'SHIVOHM SOFTECH PRIVATE LIMITED',
    'VALLUVAN MARACHEKKU OIL MILLS PRIVATE LIMITED',
    'INVOLUTE SKILL ACADEMY PRIVATE LIMITED',
    'HARMEET CARS PRIVATE LIMITED',
    'OSSOM HYGIENE DUNIA PRIVATE LIMITED',
    'COGNICX IT SOLUTIONS PRIVATE LIMITED',
    'FISHIN',
    'S QUALITY FOODS PRIVATE LIMITED',
    'Transnational drilling & mining associates private limited',
    'Uranium corporation of india limited',
    'Gmt ice & cream art (india) private limited',
    'Deepak vegpro private limited',
    'Madhav agro foods private limited',
    'S. B. MULTIMEDIA PRIVATE LIMITED',
    'Bss mines and minerals private limited',
    'Divyash granites private limited',
    'Tirupati proteins private limited',
    'Upadrasta dairy specialities limited',
    'Ag granites private limited',
    'Yakult danone india private limited',
    'NAMBISAN ',
    'S HAMMER & MOP SERVICES PRIVATE LIMITED',
    'Connect one facility service private limited',
    'Pan finetech private limited',
    'Samrat corporate consultants private limited',
    'Generic business solutions private limited',
    'N m finance and investment consultancy ltd',
    'Fomento engineering and constructions private limited',
    'Fisher biopharma services (india) private limited',
    'Kaltech building controls private limited',
    'GIONEE INDIA PRIVATE LIMITED',
    'Marlie consulting services private limited',
    'Avp research foundation',
    'Nqa certification private limited',
    'Pure research private limited',
    'Sequencher tech private limited',
    'Eti karle clinical private limited',
    'Faction communication private limited',
    'Dma capital advisors private limited',
    'AINFI ENTERPRISES PRIVATE LIMITED',
    'Accolet advisors private limited',
    'Balram corporate services private limited',
    'Pinkapple studio private limited',
    'Uha india private limited',
    'Headway informatics private limited',
    'Rafael india services private limited',
    'Uniqleads research private limited',
    'Advanced technical and management consultants private limited',
    'Mega services and consultancy pvt ltd',
    'Hiranya financial and management services pvt ltd',
    'Shaily idc (india) private limited',
    'Mahendra and ardneham consulting private limited',
    'V3it consulting private limited',
    'Khazanah india advisors private limited',
    'I-sourcing technologies private limited',
    'Venire consulting private limited',
    'Sis cash services private limited',
    'Innovative financial management private limited',
    'Accelerator advisors private limited',
    'Bahwan project management private limited',
    'Silver linings synergies private limited',
    'Santane consultants private limited',
    'Macro kiosk (india) private limited',
    'Saffire consulting service private limited',
    'Benchmark sales private limited',
    'Spa it solutions private limited',
    'Visista insurance broking services private limited',
    'Vedanta consulting private limited',
    'Dcsi human resource services india private limited',
    'Vanuston intelligence private limited',
    'I-point consulting services private limited',
    'SADHBHAVANA INSTITUTE FOR RESEARCH IN EDUCATION PRIVATE LIMITED',
    'Ingerem india project management private limited',
    'Wayline management consultants private limited',
    'MAILHEM ENVIRONMENT PRIVATE LIMITED',
    'ICAN AFFILIATES PRIVATE LIMITED',
    'Our connections management solutions private limited',
    'Ideal placement and consultants private limited',
    'Mahamaya merchants private limited',
    'Dynamic tie-up private limited',
    'First climate (india) private limited',
    'Cognolabs systems private limited',
    'Sree pradha management services private limited',
    'Lotte engineering and construction india private limited',
    'Jurong consultants (india) private limited',
    'Stimulus consulting private limited',
    'In4 velocity systems private limited',
    'Technocraft power private limited',
    'Ion exchange projects and engineering limited',
    'Clark lloyd designers private limited',
    'Integrated project services international private limited',
    'Tosei engineering private limited.',
    'Geo engineering co private limited',
    'Kamdar private limited',
    'Nilraj engineering works private limited',
    'Ppg technochem private limited',
    'Indcon engineering consultants private limited',
    'Facade engineers private limited',
    'Sudhanshu engineering pvt ltd',
    'AZAD ENGINEERING LIMITED',
    'Shriramfortune solutions limited',
    'CALCUTTA TECHNICIANS & ADVISERS PRIVATE LIMITED',
    'Jobcorp solutions private limited',
    'Square communications private limited',
    'Imagic communications pvt. ltd.',
    'Akshini advertising private limited',
    'Tricon media private limited',
    'Thinkcomm marketing and media services private limited',
    'Buildhr management consultants private limited',
    'Deepak services pvt ltd',
    'Batlivala & karani resources management pvt ltd',
    'Gamut infosystems limited',
    'Malaney consultants private limited',
    'Enthrall media private limited',
    'Aida marketing services private limited',
    'AQUAPROOF BUILDING SOLUTIONS PRIVATE LIMITED',
    'Frenny projects private limited',
    'Khandelia udyog private limited',
    'The indmac (india) private limited',
    'Stalwart exports pvt ltd',
    'International cargo carriers private limited',
    'ASMACS SUPPORT SERVICE PRIVATE LIMITED',
    'Checkmate equipref services pvt ltd',
    'S s refineries pvt ltd',
    'Chiron lasting solutions private limited',
    'Auro maritech private limited',
    'Eos ventures private limited',
    'Manoj multi foods private limited',
    'Seabuckthorn indage limited',
    'Calypso bengal foods private limited',
    'Brahmins foods india private limited',
    'VIRAKI BROTHERS FOODS LIMITED',
    'MSP MINES & MINERALS LIMITED',
    'Purna fisheries private limited',
    'Parthvimeda panchgavy utpad private limited',
    'Mb agro private limited',
    'Goodman projects private limited',
    'Orient agro foods limited',
    'Prompt paper products private limited',
    'Konika industries private limited',
    'Rungta sons pvt ltd',
    'Alterneit life styles private limited',
    'Kerry ingredients india private limited',
    'OJAS INTERIO PRIVATE LIMITED',
    'R k weaving private limited',
    'Apaar foods industries limited',
    'Tgb infra developers private limited',
    'Bakewell biscuits private limited',
    'Associated biscuit company limited',
    'Tech bla solutions private limited',
    'Shirala agro food processing private limited',
    'Jiten foods and flavours private limited',
    'AMBO AGRITEC LIMITED',
    'Pavizham healthier diet private limited',
    'Nutrine confectionery company private limited',
    'Ml information and technology parks private limited',
    'Shree dwarkadhish ginning & pressing private limited',
    'Amrithapan agro farms private limited',
    'CG AGRO ENTERPRISES & TRADERS PRIVATE LIMITED',
    'MASTERTRUST WEALTH PRIVATE LIMITED',
    'A. j. tea house private limited',
    'Sark spice products pvt ltd',
    'Mums mega food park private limited',
    'Ramdev food products private limited',
    'IGNITE CLASSES PRIVATE LIMITED',
    'Kataria snack pellets private limited',
    'Frrutto fresh india private limited',
    'Sams sales private limited',
    'Vallonne vineyards private limited',
    'Pranav food processors india private limited',
    'Ramdev spices private limited',
    'Sahara universal minings corporation limited',
    'Gogeneni tobaccos limited',
    'Kaziranga power & steel private limited',
    'Hexven iron trading private limited',
    'Elana lifestyles private limited',
    'Sushma fabrics private limited',
    'Galaxy fabrics private limited',
    'PRATEEK MINES & MINERALS PRIVATE LIMITED',
    'Riyotex private limited',
    'Surat weaves pvt ltd',
    'Neptune syntex pvt ltd',
    'Rajkob silk mills pvt ltd',
    'Beetee textile industries limited',
    'Spinwell valliappa private limited',
    'Tessitura monti india private limited',
    'Umed tex-fab private limited',
    'Nalli chinnasami chetty private limited',
    'Sri kamakoti kamakshi enterprises private limited',
    'Coimbatore holdings private limited',
    'Mynah industries limited',
    'Select gaarments private limited',
    'Promises instruments pvt ltd',
    'Akash processors private limited',
    'Exim silks (india) private limited',
    'Raksarita impex private limited',
    'Arrow clothing private limited',
    'A b design habit and company private limited',
    'EASTMAN INTERNATIONAL PRIVATE LIMITED',
    'Psa textile processors private limited',
    'Khyber kareems silk private limited',
    'Mallinath texturisers pvt ltd',
    'Shyam polyspin pvt ltd',
    'C a patel textiles pvt ltd',
    'Saysan manufacturing private limited',
    'Vishwa vishal textiles private limited',
    'Supreme nonwoven industries private limited',
    'Shreedham silk industries private limited',
    'Hrishikesh industrial fabrics private limited',
    'Deesan tex fab private limited',
    'Ketty apparels india private limited',
    'Narayani Pellets Private Limited',
    'The abu marble mining private limited',
    'Satav stone company private limited',
    'GMR SMART ELECTRICITY DISTRIBUTION PRIVATE LIMITED',
    'Shilloi energy services private limited',
    'S k sarawagi & co pvt ltd',
    'Chandra agri impliments pvt ltd',
    'Devendran coal international private limited',
    'SAATAREM ALTERNATIVE FUEL AND ENERGY PRIVATE LIMITED',
    'Shanthi chandran enterprisers private limited',
    'Kaur cookies private limited',
    'P GURU TECHSERVICES PRIVATE LIMITED',
    'SAAVY AGRO FRESH PRIVATE LIMITED',
    'ML TOBACCO DEVELOPERS PRIVATE LIMITED',
    'Hitkari cigarette components private limited',
    'Gopal corpco limited',
    'Eske tex (india) pvt ltd',
    'Mits mega food park limited',
    'Laxmi cakezone private limited',
    'MANPASAND NUTRITIONS PRIVATE LIMITED',
    'Barefeet analytics private limited',
    'Twinkle diamond jewellery (india) private limited',
    'Ganesh jewellery (india) private limited',
    'Classic fashion exports private limited',
    'Urja impex private limited',
    'Sri krishna gems and watches limited',
    'Karan kothari jewellers private limited',
    'Heerachand jewellers private limited',
    'Trinity rejuvenators int private limited',
    'HERITAGE PRIME FURNITURE PRIVATE LIMITED',
    'NIGAM JEWELS PRIVATE LIMITED',
    'MARS ART AND CRAFT PRIVATE LIMITED',
    'Vishnukripa jewels india private limited',
    'Mepco industries limited',
    'Demas jewellery private limited',
    'Asian star diamonds international private limited',
    'TECHNO KITCHENS PRIVATE LIMITED',
    'Shree gajapati paints private limited',
    'Groze tech (india) private limited',
    'TEE VENTURES (INDIA) PRIVATE LIMITED',
    'CHRYSO INDIA PRIVATE LIMITED',
    'Reyami interiors private limited',
    'COMPAL ELECTRONICS INDIA PRIVATE LIMITED',
    'Intech systems pvt ltd',
    'Intellicon private limited',
    'Infiniti engineers private limited',
    'Eurostar network private limited',
    'Sudha bio power private limited',
    'Amrit environmental technologies india private limited',
    'Wind world wind farms (samana) private limited',
    'Wind world wind farms (cauvery) private limited',
    'Wind world wind farms (gadag) private limited',
    'Gujarat state energy generation limited',
    'Nate commercial laundry equipment private limited',
    'ZENITH MEDIA SCOPE PRIVATE LIMITED',
    'Cvg seating (india) private limited',
    'Micronova telesystems private limited',
    'Abir renewable energy private limited',
    'Acb (india) power limited',
    'UDBHEDA TECHNOLOGIES PRIVATE LIMITED',
    'Active medical and rehabilitation services private limited',
    'ABAN POWER LIMITED',
    'Tripura state electricity corporation limited',
    'Benson medical equipments india private limited',
    'Innovative ortho-surgicals private limited',
    'P.s. steam and power private limited',
    'Leader medical systems private limited',
    'Litchfield baroda motors private limited',
    'Prathijna sustainable solutions private limited',
    'TRANSLITE ENERGY LIMITED',
    'Ayana energy private limited',
    'Bharatiya nabhikiya vidyut nigam limited',
    'Ne hills hydro limited',
    'Gopal ecofuels private limited',
    'Rns power limited',
    'Bridge to india energy private limited',
    'Powergrid nm transmission limited',
    'Powergrid kala amb transmission limited',
    'Konkan renewables private limited',
    'Adept renewable energy private limited',
    'SGE RETAIL SERVICES PRIVATE LIMITED',
    'SATAREM ENTERPRISE PRIVATE LIMITED',
    'Patel coach manufacturing private limited',
    'Castle ships private limited',
    'SAI BANDHAN INFINIUM PRIVATE LIMITED',
    'Seaswan marine services private limited',
    'Jisnu solar private limited',
    'APEX PARIVAR INFRA AND SOLAR POWER PRIVATE LIMITED',
    'Athena kynshi power private limited',
    'TRUWELD INDUSTRIES LIMITED',
    'Sai teja energies private limited',
    'SAI WARDHA POWER GENERATION PRIVATE LIMITED',
    'Muskan container lines private limited',
    'Mal auto products private limited',
    'Vaidehi exim private limited',
    'Hf metalart private limited',
    'A.j.stationery private limited',
    'Fox mandal services private limited',
    'Horizon paper box private limited',
    'Cbf components pvt ltd',
    'VIZAG TRANSMISSION LIMITED',
    'Mapro gases limited',
    'Rithwik energy generation private limited',
    'Transstroy power projects private limited',
    'SATAREM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Intelligent analytic solutions private limited',
    'Kd power limited',
    'Jeedimetla effluent treatment limited.',
    'Cosmos purification systems private limited',
    'G AND B CONTRACTING LIMITED',
    'Vijayalakshmi hydro power private limited',
    'Srm power private limited',
    'Barcol-power controls private limited',
    'Vijay processors private limited',
    'Adventure buildwell private limited',
    'Aquagreen engineering management private limited',
    'GET SANITIZEIT PRIVATE LIMITED',
    'Xebec property management private limited',
    'Renergy developers private limited',
    'Windsor arrow infratech private limited',
    'CORE COMPETENCY TRAINING & SERVICES PRIVATE LIMITED',
    'ARC TRANSLOGISTIC INDIA PRIVATE LIMITED',
    'Kandla container terminal private limited',
    'Seaman logistics solutions private limited',
    'Velji marketing and management private limited',
    'Tulsi logistics private limited',
    'Puyvast maritime india private limited',
    'National freight exchange limited',
    'Indelox services private limited',
    '50+ voyagers travel and adventure club private limited',
    'Indo island shipping pvt ltd',
    'Great sea shipping private limited',
    'Adi logistics and warehousing private limited',
    'Volkart fleming shipping and services limited',
    'Ghatge logistics private limited',
    'Satya giri shipping company limited',
    'Annamar hotels private limited',
    'V.inns and resorts private limited',
    'Vacations travels and tours private limited',
    'Mayco freight and travels private limited',
    'Arian air travel private limited',
    'Rsvr technologies private limited',
    'Mvr shipping services private limited',
    'UTAZZO SERVICES PRIVATE LIMITED',
    'Signature vacations private limited',
    'ACTIVE MARATHON HOLIDAYS PRIVATE LIMITED',
    'Majic brothers tourism private limited',
    'Ramniranjan kedia tours and travels pvt ltd',
    'Jtc carriers ltd',
    'Trimurti cargo movers private limited',
    'Zodiac express private limited',
    'Kenstel communications private limited',
    'Viceroy travels private limited',
    'Parveen travels private limited',
    'Sathyam airtravel services private limited',
    'Sprint telecom india private limited',
    'Modi telecommunications limited',
    'E. delivery systems private limited',
    'Jesuit technologies private limited',
    'Shree satyanarayan properties private limited',
    'Amar tours and travels private limited',
    'Force logistics private limited.',
    'AADYA IMPORTS PRIVATE LIMITED',
    'Happy starstell.com private limited',
    'Gt cargo fittings india private limited',
    'Rural and urban innovative social entrepreneurship (rise)',
    'Emmar trades and finance private limited',
    'Seatrans movers private limited',
    'Chaube farms private limited',
    'Bespoke (india) marketing private limited',
    'Maxwell logistics private limited',
    'Sds cargo solutions private limited',
    'Pnp maritime services private limited',
    'VSJ INVESTMENTS PRIVATE LIMITED',
    'Geojit credits private limited',
    'BRESCON REALTY PRIVATE LIMITED',
    'Kandathil real estate development and construction company pvt ltd',
    'GALIAKOTWALA INVESTMENT SERVICES PRIVATE LIMITED',
    'Vibgyor leasing private limited',
    'Alta leasing and finance limited',
    'Green ocean shipmanagement private limited',
    'Cenin tours & travels company private limited',
    'Pole-star logistics (chennai) private limited',
    'Chennai marine trading private limited',
    'Virsun investments pvt ltd',
    'ENNORE COAL TERMINAL PRIVATE LIMITED',
    'Dacon logistics india private limited',
    'Grandeur logistics private limited',
    'Udan enterprise private limited',
    'Dacunha communications private limited',
    'Primetech holdings private limited',
    'Pgf holdings (coimbatore) private limited',
    'Deeplok securities limited',
    'Rajat fiscal services pvt ltd',
    'NIDO HOME FINANCE LIMITED',
    'Gauriputra international private limited',
    'Edel investments limited',
    'Golden ikon fleet management private limited',
    'Reliance freight forwarders private limited',
    'Manoharlal santram hiring private limited',
    'MSFIN CREDIT PRIVATE LIMITED',
    'Interport global logistics private limited',
    'Magnolia hospitality private limited',
    'PRACTUS ADVISORS PRIVATE LIMITED',
    'THE ESTATE INVESTMENT COMPANY PRIVATE LIMITED',
    'Swan investment and trading private limited',
    'Vishwadeep investments and finance pvt ltd',
    'Altona investments private limited',
    'Trapu investments pvt ltd',
    'Al kabeer investments private limited',
    'Merry time credits private limited',
    'PANORA ADVISORS PRIVATE LIMITED',
    'Masuma tradecorp private limited',
    'Cell com teleservices private limited',
    'Savitri telecom private limited',
    'Krishnateja telecom private limited',
    'PINK BROADBAND SERVICE PRIVATE LIMITED',
    'CARNIVAL TECHNO PARK PRIVATE LIMITED',
    'Shitij investments private limited',
    'Icici investment management company limited',
    'EDELWEISS SECURITIES AND INVESTMENTS PRIVATE LIMITED',
    'Bmd securities limited',
    'Gepl finance private limited',
    'Saphire holdings private limited',
    'Sayi rupa forex private limited',
    'Qutubminar investments and trading private limited',
    'SPOT SOFTWARE & INFO SOLUTIONS PRIVATE LIMITED',
    'Tfs business advisors india private limited',
    'Channelplay limited',
    'Rhiti sports management private limited',
    'Baryon info solutions private limited',
    'Msquare innotech solutions private limited',
    'Synapse communications private limited',
    'Symo genesis india private limited',
    'Vs professionals private limited',
    'Fuel source manpower solutions private limited',
    'I.p. infrapower private limited',
    'Pathbreakers services private limited',
    'Teemac technology solutions private limited',
    'Anwesha customer relations marketing private limited',
    'Greymatters communications & consulting private limited',
    'Flying fox security & management services private limited',
    'TERRALIGHT SOLAR ENERGY GADNA PRIVATE LIMITED',
    'Regent climate connect knowledge solutions private limited',
    'Alankit brands private limited',
    'Hpg consulting india private limited',
    'Ihrs consultancy india private limited',
    'Onspot management services private limited',
    'Picante mexican grill private limited',
    'R b synergy private limited',
    'Prismatic softwares private limited',
    'Solutionshead global services private limited',
    'Wizard managment consultants private limited.',
    'PALLADIUM CONSULTING INDIA PRIVATE LIMITED',
    'Draphant consultants private limited',
    'RVAG CENTURION INFRASOLUTION PRIVATE LIMITED',
    'Bhf international private limited',
    'Resource management (india) pvt ltd',
    'Mapro ventures limited',
    'Imprint automation services private limited',
    'ZED GEOTECH PRIVATE LIMITED',
    'Clear maze consulting private limited',
    'Calm seas shipping and maritime services private limited',
    'Metrix research and analytics private limited',
    'Amm consultants private limited',
    'V k s infratech management private limited',
    'Bops security and allied services private limited',
    'Aries wealth private limited',
    'Freedom holdings private limited',
    'Synergiz global services private limited',
    'Dish infra services private limited',
    'Avis esolutions private limited',
    'Conscientia consultancy private limited',
    'Aquariuz corporate communications private limited',
    'Matrix credit risk controls private limited',
    'Younion focused marketing services private limited',
    'Chrysalis communications private limited',
    'Ricardo india private limited',
    'Sarjan consultants pvt ltd',
    'Vertueux consulting private limited',
    'Rising edge automation private limited',
    'Sheth financial services private limited',
    'PREMIER TECH BRISANZIA PRIVATE LIMITED',
    'Nrm international private limited',
    'Vakksh commodities company private limited',
    'Confluence consulting (india) private limited',
    'Gaaia facilities management private limited',
    'Sun technosolution india private limited',
    'Tak consulting private limited',
    'Edelweiss investment adviser limited',
    'Inega model management private limited',
    'INDUSTECH ENGINEERING SERVICES PRIVATE LIMITED',
    'Gajam india private limited',
    'Posiview consulting partners private limited',
    'C4d consultants private limited',
    'Absolute consultants pvt ltd',
    'Chaudhary consultants pvt.ltd.',
    'Innate medical consultancy services private limited',
    'Iris bizcon private limited',
    'Rhiti talent management private limited',
    'Motivforce marketing and incentives private limited',
    'Shrey advisory services private limited',
    'A.m. marketplaces private limited',
    'Five benches promotions and advisory services private limited',
    'E-it professionals india private limited',
    'Gestione consulting india private limited',
    'Perfect office management services private limited',
    'Backend support systems private limited',
    'Door training and consulting india private limited',
    'Simply project consultants private limited',
    'Mantra infrasolutions private limited',
    'Sammaitrii consulting private limited',
    'E7 processing services private limited',
    'Philip -melorr holdings private limited',
    'H.r. cornucopia private limited',
    'Sanmati technologies private limited',
    'Graphical monitoring & information systems consultants private limited',
    'Silicon business solutions private limited',
    'Theron consultants private limited',
    'Elevar advisors private limited',
    'Lara tech consultancy services private limited',
    'Silicon coast consultancy services private limited',
    'Javad k hassan consultancy private limited',
    'YOSA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Santech engineers private limited',
    'Wotek engineering services private limited',
    'Transcend mt services private limited',
    'ATELIER D',
    'Production performance monitor private limited',
    'Samco commodities limited',
    'PEGASUS UTILITY MAINTENANCE & SERVICES PRIVATE LIMITED',
    'AAVAN DEVELOPERS PRIVATE LIMITED',
    'Laxmi estate developers private limited',
    'MALAPARAMBA OLIVE ARCADE PRIVATE LIMITED',
    'Studd projects private limited',
    'Vector industrial manufacturers india private limited',
    'Ganesh ventures private limited',
    'Myco steel agencies private limited',
    'Kmf management and consultants private limited',
    'Willow trading company private limited',
    'Sharun exports private limited',
    'Blb global business limited',
    'Fermenta biotech limited',
    'Computer factory (india) private limited',
    'NILKAMAL STORAGE SYSTEMS PRIVATE LIMITED',
    'Omez real estates private limited',
    'Daljita financial and technical services private limited',
    'Olive therapeutics private limited',
    'Foto flux private limited',
    'Sigma corporate solutions limited',
    'Oasis home holdings private limited',
    'Msm discovery private limited',
    'Raja rajeshwari entertainment private limited',
    'Sp biofuel ventures private limited',
    'Durga dairy ltd.',
    'Reliance lifestyle holdings limited',
    'Gopika technologies private limited',
    'Pioneer veneers pvt ltd',
    'Industele services private limited',
    'GULF CAROSSERIE INDIA LIMITED',
    'Harichem pvt ltd',
    'Aquagel chemicals private limited',
    'Jas paints & coatings specialities private limited',
    'Bandekar investment & trading private limited',
    'Gujarat digi com private limited',
    'Dalmia investmart private limited',
    'GARGI MERCANTILE PRIVATE LIMITED',
    'Pri holdings pvt. ltd',
    'Moksh consulting private limited',
    'Techno insurance private limited',
    'Lodha builders private limited',
    'Brookefields Real Estates and Projects Private Limited',
    'Shilus properties private limited',
    'Britona properties private limited',
    'Varya vega infrastructure private limited',
    'Suyojan realty private limited',
    'Sri sai srinivasa agro farms and developers private limited',
    'Adhunik realators private limited',
    'Sikara avenues private limited',
    'Gecko technologies private limited',
    'ARICENT TECHNOLOGIES PRIVATE LIMITED',
    'Collaborative infotech systems private limited',
    'Youngmonk technologies private limited',
    'Magenta computer software private limited',
    'Incube solutions private limited',
    'Quartesian clinical research private limited',
    'Falcon suppliers pvt ltd',
    'Rudra agencies pvt ltd',
    'Citra vyapaar private limited',
    'Keshav agencies pvt ltd',
    'EFSL TRADING LIMITED',
    'FLUIDRA INDIA PRIVATE LIMITED',
    'Zeus minerals trading private limited',
    'Unicom multitrade private limited',
    'MAXWELL STRUCTURES AND PILLARS PRIVATE LIMITED',
    '20cube logistics private limited',
    'Marine container services(south) private limited',
    'HATHWAY INTERNET SATELLITE LIMITED',
    'Dytint specialities private limited',
    'Wellknown chemicals private limited',
    'Manjushree fincap private limited.',
    'Efsl comtrade limited',
    'Aparajitha capital growth private limited',
    'Jai realty ventures limited',
    'Wellknown hitech projects private limited',
    'Preactor software india private limited',
    'WIPFLI INDIA PRIVATE LIMITED',
    'Clogeny technologies private limited',
    'Aparna infra private limited',
    'Green infra wind assets limited',
    'Banday infratech private limited',
    'Bharti realty holdings limited',
    'ANDRITZ EUROSLOT INDIA PRIVATE LIMITED',
    'Sembcorp Green Infra Limited',
    'Apurva holiday homes private limited',
    'Reliance world trade pvt ltd',
    'Arunil commerce pvt ltd',
    'Anand buttons gallery private limited',
    'Vedant marketing private limited',
    'Mudra vincom private limited',
    'Dhanvan impex private limited',
    'Sugati beach resort private limited',
    'Se shipping india private limited',
    'Lcl logistix (india) private limited',
    'Dalhousie leasing and financial services pvt ltd',
    'Swapnil financial pvt ltd',
    'ASHOK GROWTH VENTURE PRIVATE LIMITED',
    'Tar vin trading and investment pvt ltd',
    'Padmapriyan capital markets private limited',
    'Elpee peripherals private limited',
    'Active estates private limited',
    'Posiedon hotels private limited',
    'Kastech engineering private limited',
    'Thyssenkrupp engine components india private limited',
    'Orient precision engineering private limited',
    'Akash ganga marketing private limited',
    'Planetary gear drives india private limited',
    'Vks healthclub equipments private limited',
    'Camp tech private limited',
    'Abellon energy limited.',
    'Patel energy assignment private limited',
    'Patel energy projects private limited',
    'Patel energy operations private limited',
    'Patel energy resources limited',
    'Gandhar yarn private limited',
    'Krishnakali couture private limited',
    'Maruti probuild private limited',
    'National tiles and industries private limited',
    'Integrated coreinfra limited',
    'Sanghavi foods private limited',
    'Acro exports trade private limited',
    'Prompt vanijya private limited',
    'Titanium imports and exports private limited',
    'Solem tradelink private limited',
    'TASSEL TRADING LIMITED',
    'Colt hydromatics private limited',
    'Bloom energy international (india) private limited',
    'Comstar automotive technologies private limited',
    'Ecoren energy andhra pradesh private limited',
    'Shivalik developers private limited',
    'HATHWAY KRISHNA CABLE LIMITED',
    'Mindworks realty private limited',
    'Vikash trade link india private limited',
    'Agricore commodities private limited',
    'Agility logistics private limited',
    'James mccartney software technologies private limited',
    'Oneworld teleservices private limited',
    'WIN CABLE AND DATACOM LIMITED',
    'SIDDHANT ICECREAMS PRIVATE LIMITED',
    'Capital18 fincap private limited',
    'Laxmi r.a. holdings and investments private limited',
    'Riddhi siddhi recyclers private limited',
    'Afilado technology private limited',
    'Lm wind power technologies (india) private limited',
    'Turtleyogi technologies private limited',
    'Modern india property developers limited',
    'Omnesys it solutions private limited',
    'Kanti bijlee utpadan nigam limited',
    'Aig data services private limited',
    'Ithaca informatics private limited',
    'AASAN INFO SOLUTIONS (INDIA) PRIVATE LIMITED',
    'HATHWAY NEW CONCEPT CABLE & DATACOM LIMITED',
    'Seraja technologies private limited',
    'Glorious buildhome private limited',
    'Mumbai vastra kala limited',
    'Venkateshwara enterprises private limited',
    'Samet estates private limited',
    'Melody land developers private limited',
    'Goverdhan cultivators private limited',
    'Aristo sales agency private limited',
    'Sri shirdi commodity and derivatives services private limited',
    'AHANA HOSPITALITY PRIVATE LIMITED',
    'Latitudes health private limited',
    'Sanda holidays private limited',
    'Menzies bobba ground handling services private limited',
    'Manzil real estates private limited',
    'Neha propinvest private limited',
    'Versant technologies private limited',
    'Dazsi systems (india) private limited',
    'Ciphercloud india private limited',
    'Eurotrade textiles private limited',
    'Cresendo infra build private limited',
    'People combine amenities private limited',
    'Modern die casting private limited',
    'Delta computer prints pvt ltd',
    'Advance power devices private limited',
    'Advance motors technology private limited',
    'HATHWAY ENJOY CABLE NETWORK LIMITED',
    'Visplay india private limited',
    'Spg realty private limited',
    'Hcc power limited',
    'Adani land developers private limited',
    'Mishri ils foundation private limited',
    'Hcc concessions limited',
    'Valeo service india auto parts private limited',
    'Ornis trading company private limited',
    'Ballast trading company private limited',
    'Rine trading company private limited',
    'Galt pharma exports private limited',
    'Wavelink commercials private limited',
    'Itx trading and financial services private limited',
    'Gtpl shivshakti network private limited',
    'HATHWAY GWALIOR CABLE & DATACOM LIMITED',
    'HATHWAY JMD FARUKHABAD CABLE NETWORK LIMITED',
    'ARCHER CRANES & EQUIPMENT (INDIA) PRIVATE LIMITED',
    'KOTHARI INTERNATIONAL TRADING PRIVATE LIMITED',
    'Greenstone energy advisors private limited',
    'Amx products and solutions private limited',
    'Rockfield trading private limited',
    'Street talk connect private limited',
    'Hotel rahat palace private limited',
    'GRASIM PREMIUM FABRIC PRIVATE LIMITED',
    'Velan properties private limited',
    'Velan enterprises private limited',
    'Limelight securities pvt. ltd.',
    'DEALMONEY SECURITIES PRIVATE LIMITED',
    'Viteb solutions private limited',
    'Hi-class buildcon private limited',
    'Collasys global services private limited',
    'NTT DATA BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'PROKARMA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Cra explortation ( india ) private limited',
    'Hamkunt portfolio and securities private limited',
    'KURLIS INDIA PRIVATE LIMITED',
    'ELDECO INFRACON REALTORS LIMITED',
    'BLUCHIP LOGISTICS AND SHIPPING PRIVATE LIMITED',
    'COTERIE PRODUCTIONS PRIVATE LIMITED',
    'GROWTH HELIUM PRIVATE LIMITED',
    'DRPL CAPTIVE HYBRID PRIVATE LIMITED',
    'FUNCTIONAL MEDICINE E-VENTURES PRIVATE LIMITED',
    'ADEVIFY LABS PRIVATE LIMITED',
    'ENHERIYA AGRO PRIVATE LIMITED',
    'SPRENTZO SPORTS PRIVATE LIMITED',
    'FINBOARD MANAGEMENT PRIVATE LIMITED',
    'CGE SHREE DIGVIJAY CEMENT GREEN ENERGY PRIVATE LIMITED',
    'SAM MANEKSHAW POSTING OUT SERVICES PRIVATE LIMITED',
    'BHANVI ENTERPRISES PRIVATE LIMITED',
    'ABSTRACT TECH ASIA PRIVATE LIMITED',
    'ETIQUETTE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'DECENTRALIZEDBULL (OPC) PRIVATE LIMITED',
    'SR HEALTH FOUNDATION',
    'STAKEGROVE PRIVATE LIMITED',
    'SHRI BALAJI INTERNATIONAL PRIVATE LIMITED',
    'STOREY INDIA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RELYTEK TECHNOLOGIES PRIVATE LIMITED',
    'ECOMMAP PRIVATE LIMITED',
    'KORP SOFTWARE PRIVATE LIMITED',
    'OM NAVODHYAM PRIVATE LIMITED',
    'ITARSIA INDIA LIMITED',
    'SCHOOLHOME EDUCARE PRIVATE LIMITED',
    'IIVH DERMAFLOW HEALTH SOLUTIONS PRIVATE LIMITED',
    'TECHESSENCE LABS PRIVATE LIMITED',
    'OPTIMAL PETRO PRIVATE LIMITED',
    'MS-PRG AUTOMATION PRIVATE LIMITED',
    'LAND INVES AND INFRA PRIVATE LIMITED',
    'LITHOS TECHNOSOFT PRIVATE LIMITED',
    'AIRSTATION PRIVATE LIMITED',
    'SHREE ARIHANT MULTIMETALS PRIVATE LIMITED',
    'PASK INDUSTRIES PRIVATE LIMITED',
    'SUBMARINE PENS PRIVATE LIMITED',
    'HR VAIGAI PRIVATE LIMITED',
    'GLF CONSUMER PRODUCTS PRIVATE LIMITED',
    'RITECHEEZ PRIVATE LIMITED',
    'ASCOT CHOCOLATE PRIVATE LIMITED',
    'JSR GREEN TECH (OPC) PRIVATE LIMITED',
    'FACILIS VITAE DIGITECH PRIVATE LIMITED',
    'FAIRMATIC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'JOBADDA TECHNOLOGY PRIVATE LIMITED',
    'SHANTI NATURAL EXTRACTS PRIVATE LIMITED',
    'TESTING MINDS PRIVATE LIMITED',
    'GO DEVIL PRIVATE LIMITED',
    'MAA MANSA IRON AND POWER PRIVATE LIMITED',
    'SHAILPUTRI HEALTHCARE PRIVATE LIMITED',
    'REDTAPE LIMITED',
    'PATHTEST LABS (OPC) PRIVATE LIMITED',
    'ASIABROWN AGRI RESOURCES PRIVATE LIMITED',
    'RISTAL PANELS PRIVATE LIMITED',
    'SYNERGY PATHWAYS INDIA (OPC) PRIVATE LIMITED',
    'YHI ENTERPRISES (OPC) PRIVATE LIMITED',
    '3BMS DIAGNOSTICS PRIVATE LIMITED',
    'TRISHTI SOCIAL WELFARE FOUNDATION',
    'LEISURELY TECHNOLOGIES PRIVATE LIMITED',
    'ESCON SHIPPING SERVICES PRIVATE LIMITED',
    'RANUCLE PRIVATE LIMITED',
    'ERTHE PAPER SOLUTIONS PRIVATE LIMITED',
    'VAISHNAVACARE108 FOUNDATION',
    'GFCL EV PRODUCTS LIMITED',
    'INART CONSULTING INDIA (OPC) PRIVATE LIMITED',
    'HIREIUM ENTERPRISES PRIVATE LIMITED',
    'ZIVAH ELECTRIVA PRIVATE LIMITED',
    'NEATGLOBAL SERVICES PRIVATE LIMITED',
    'TCPL HALMA PRIVATE LIMITED',
    'SOCIALPE ITES PRIVATE LIMITED',
    'EFFICIENT EV PRIVATE LIMITED',
    'MOVEMENT GLOBAL FOUNDATION',
    'API HOLDINGS LIMITED',
    'JOHN BROS FINANCIAL SERVICES PRIVATE LIMITED',
    'BROWNSVILLE REALTORS PRIVATE LIMITED',
    'PRAB RETAIL PRIVATE LIMITED',
    'TRICHEMIE PLANT ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'SHREESIDDHI VINAYAK DEVSTHAN FOUNDATION',
    'GETKEEL MIGRATION SERVICES INDIA PRIVATELIMITED',
    'DURACARE DOORS & WINDOWS PRIVATE LIMITED',
    'ADLINE INFRATECH PRIVATE LIMITED',
    'INADEV INDIA PRIVATE LIMITED',
    'SYMBIOTICS SOUTH ASIA PRIVATE LIMITED',
    'LOG 9 MOBILITY PRIVATE LIMITED',
    'PARABLEAI PRIVATE LIMITED',
    '3MAX TECHNOLOGY PRIVATE LIMITED',
    'FARM 2 FAM INDIA PRIVATE LIMITED',
    'RGK SILICON SCIENCES PRIVATE LIMITED',
    'ELJASU TECHNOLOGIES PRIVATE LIMITED',
    'AKLK TASTY FOOD PRIVATE LIMITED',
    'YASHVRIDDHI DEVELOPERS PRIVATE LIMITED',
    'QC CONSULTING INDIA PRIVATE LIMITED',
    'ACUBE VENTURES GLOBAL PRIVATE LIMITED',
    'JAMANKIRA FED FARMERS PRODUCER COMPANY LIMITED',
    'AMB LIVSSTIL SOLUTIONS PRIVATE LIMITED',
    'SANSKRUTISONA40 AGRIPRODUCTS PRIVATE LIMITED',
    'TERRASON AGRO KRISHI FED PRODUCER COMPANY LIMITED',
    'VALUETRUST CAPITAL SERVICES PRIVATE LIMITED',
    'NYRAIN SOLUTIONS PRIVATE LIMITED',
    'ATOTECH GLOBAL SERVICES PRIVATE LIMITED',
    'PROTO D INDUSTRIES PRIVATE LIMITED',
    'SWYTCHD MOBILITY PRIVATE LIMITED',
    'SWAGURUKULAM SERVICES PRIVATE LIMITED',
    'SENTINELONE INDIA PRIVATE LIMITED',
    'NSPIRE AUTOMATION PRIVATE LIMITED',
    'DE-RIX PRIVATE LIMITED',
    'RENEW GREEN (GJ NINE) PRIVATE LIMITED',
    'VAASIST VACATION HOMES PRIVATE LIMITED',
    'ROMKAY NATURALS (OPC) PRIVATE LIMITED',
    'HERMITIAN TECHNOLOGIES PRIVATE LIMITED',
    'ZENFORD INFRA PRIVATE LIMITED',
    'AES INDIA ENERGY SOLUTIONS PRIVATE LIMITED',
    'ASSURED POWER SERVICES (OPC) PRIVATE LIMITED',
    'DOV INDIA FOUNDATION',
    'HILITE HOMES PRIVATE LIMITED',
    'MOTORCON SOLUTIONS PRIVATE LIMITED',
    'PROGBIZ PRIVATE LIMITED',
    'EATCO HOME PRIVATE LIMITED',
    'WELMO HEALTHCARE PRIVATE LIMITED',
    'NEUBERG BOSE LABORATORIES PRIVATE LIMITED',
    'GROWTHFATHER PRIVATE LIMITED',
    'G.O.D. INDIA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BEST OCEAN SHIPPING SERVICES PRIVATE LIMITED',
    'BATRA DEFENCE ACADEMY PRIVATE LIMITED',
    'ONE GREEN ENVIRO SOLUTIONS PRIVATE LIMITED',
    'HUBBLEHOX TECHNOLOGIES PRIVATE LIMITED',
    'DESEO FINTECH PRIVATE LIMITED',
    'ETABLISSEMENTS GALLOIS INDIA PRIVATE LIMITED',
    'RAINTECH FINANCE PRIVATE LIMITED',
    'SPECIALSMELT INDUSTRIES PRIVATE LIMITED',
    'MYSTIC MANN PANELS PRIVATE LIMITED',
    'HAILA CONSULTING INDIA PRIVATE LIMITED',
    'ALINOZ ENERGY PRIVATE LIMITED',
    'SIGMACORE TECHNOLOGIES PRIVATE LIMITED',
    'KRATI CONSULTANCY & SOLUTIONS PRIVATE LIMITED',
    'KAMBRIL HEALTHCARE PRIVATE LIMITED',
    'ANALOGUE TECHNOSOL PRIVATE LIMITED',
    'STARNEXT INNOVATIONS PRIVATE LIMITED',
    'ARJOBEX POLYART INDIA PRIVATE LIMITED',
    'CCOLUMBUS HEALTHCARE SERVICES PRIVATE LIMITED',
    'TOPFINPRO SERVICES PRIVATE LIMITED',
    'SK FASTENER MACHINERY AND METALS PRIVATE LIMITED',
    'HOME KUISINES INDIA PRIVATE LIMITED',
    'ADRIA MEDICARE PRIVATE LIMITED',
    'AGORA LABS INDIA PRIVATE LIMITED',
    'DNS FOODS INTERNATIONAL PRIVATE LIMITED',
    'PLANETSTAR TRADE PRIVATE LIMITED',
    'MARDAMED HEALTHCARE PRIVATE LIMITED',
    'GREEN GENE RECYCLERS PRIVATE LIMITED',
    'SWALAMBHA AI SOLUTIONS (OPC) PRIVATE LIMITED',
    'SCHEPPER METAL CEILINGS PRIVATE LIMITED',
    'DEWAN CHAMAN LAL ANAND LEGACY FOUNDATION',
    'BANSAL PATHWAYS KHURAI PRIVATE LIMITED',
    'TEMPLE HERITAGE CONSTRUCTIONS PRIVATE LIMITED',
    'DHANVEE HOMES PRIVATE LIMITED',
    'LOTUS ENTERPRISES INFRA PRIVATE LIMITED',
    'D-SOURCE ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'NORTH INDIA COMPRESSORS PRIVATE LIMITED',
    'HDEC INFRASTRUCTURES (I) PRIVATE LIMITED',
    'MAROON DOT GLOBAL PRIVATE LIMITED',
    'ONMESECURITY SOLUTIONS PRIVATE LIMITED',
    'CECA STUDY ABROAD SERVICES PRIVATE LIMITED',
    'DIGITS WORLD PRIVATE LIMITED',
    'JIJI',
    'S DAIRY FOODS (CG) PRIVATE LIMITED',
    'Reflexion trading private limited',
    'Hooghly printing co ltd',
    'Integration point consulting private limited',
    'Allgo embedded systems private limited',
    'Sonodyne electronics co. private limited',
    'Manipal printronics private limited',
    'Six sigma consulting private limited',
    'Parnassus publishers and printers private limited',
    'M j international private limited',
    'Check in clothing private ltd',
    'Arihant unitech realty projects limited',
    'Sp nano products private limited',
    'Ika fashions private ltd',
    'Nilam chempack pvt ltd',
    'OASIS OVERSEAS EXPORTS PRIVATE LIMITED',
    'Mahindra engineering and chemical products limited',
    'Bhagya vyapaar private limited',
    'Bnk commodities private limited',
    'Bindal commodities pvt ltd',
    'Frisee tradecom private limited',
    'Aptar beauty & home india private limited',
    'Ivision media india private limited',
    'Procam running private limited',
    'Sterling laundry services private limited',
    'Dalmia refractories limited',
    'Devyani food street private limited',
    'Spurthi hotels private limited',
    'Vaidurya hotels private limited',
    'ASEEM SANRACHANA DESIGN PRIVATE LIMITED',
    'Venkatesh leisure private limited',
    'Mohit resorts pvt ltd',
    'Span support services private limited',
    'TVS COMMUTATION SOLUTIONS LIMITED',
    'BIRD DATA SERVICES PRIVATE LIMITED',
    'Bipra investments and trusts pvt ltd',
    'AMPHITRITE TRADING PRIVATE LIMITED',
    'TRADEDEAL COMMODITIES SERVICES PRIVATE LIMITED',
    'Bhupinder investment company private limited',
    'G m b investments pvt ltd',
    'L&t infrastructure finance company limited',
    'Westend propmart private limited',
    'Redstar infra private limited',
    'Shadal properties private limited',
    'ADYASHAKTI REALTORS LIMITED',
    'Jyothi ventures private limited',
    'Cactus land developers private limited',
    'Bengal portland infra developers private limited',
    'Alankar logistics pvt. ltd.',
    'Salasar apartments private limited',
    'Bengal land conglomerate private limited',
    'Ratnagiri landagents private limited',
    'New rising promoters private limited',
    'Silver sands buildmart private limited',
    'Sanskriti land conglomerate private limited',
    'Swastic land conglomerate private limited',
    'Wallace estates private limited',
    'Silverline shelters india limited',
    'IDEASPACE SOLUTIONS Private Limited',
    'Demandsensing software private limited',
    'Data patterns (india) private limited',
    'ANDRITZ SEPARATION AND PUMP TECHNOLOGIESINDIA PRIVATE LIMITED',
    'Numac india pvt ltd',
    'Neuron biomed equipments private limited',
    'KAUTEX PLASTIC TECHNOLOGY GUJARAT PRIVATE LIMITED',
    'N.k.m.jewels private limited',
    'SRI GOVIND GEMS PRIVATE LIMITED',
    'INDO GLOBAL INNOVATIVE SOLUTIONS PRIVATELIMITED',
    'Tanish developers private limited',
    'Phedra projects pvt. ltd.',
    'Kumar kering properties private limited',
    'SHADAL REALTORS PRIVATE LIMITED',
    'UMEED URBAN SOLUTIONS PRIVATE LIMITED',
    'Sentia properties limited',
    'SHREE BALARKA DISTRIBUTORS PRIVATE LIMITED',
    'INVENTAGE MATERIALS PRIVATE LIMITED',
    'Shivdarbar housing private limited',
    'Modakpriya realtors private limited',
    'Tech-aid engineering private limited',
    'Simon Electric Private Limited',
    'Zingy marketing ventures private limited',
    'Aamir exim private limited',
    'Vishnu cloth agencies private limited',
    'Peace river traders pvt ltd',
    'Concept agencies pvt ltd',
    'Alchemie agencies private limited',
    'Madhavdas manilal and co pvt ltd',
    'Bajrangbali vanijya pvt ltd',
    'Devika sales private limited',
    'Kalyan jewellers mini stores private limited',
    'Mkdk consultants private limited',
    'Duroflex exports private limited',
    'Sandarbha scinfotech private limited',
    'Auroma logistics private limited',
    'Aquamarine leisure private limited',
    'Pioneer protec ltd.',
    'Periwal industrial corpn. ltd',
    'SORIL INFRA RESOURCES LIMITED',
    'Sunrise foods private limited',
    'Vishvas expo international private limited',
    'Pudumjee hygiene products limited',
    'Keva chemicals private limited',
    'ASHOK SAHNI FILMS PRIVATE LIMITED',
    'Aroma chemical agencies (india) private limited',
    'Icpl platech engineering private limited',
    'A&a infraprojects private limited',
    'Proteck metals private limited',
    'Anex engineering private limited',
    'KOTHARI-BARMECHA TRADING AND INVESTMENT LIMITED',
    'TAMBOLI TRADING PRIVATE LIMITED',
    'Clue leasing and finance private limited',
    'Daulat ram rameshwarlall private limited',
    'Dimexon (india) holding private limited',
    'Insat finance pvt ltd',
    'Ecoflex surfaces private limited',
    'Gnd infravest private limited',
    'Cleta developers private limited',
    'Realty business intelligence private limited',
    'Esspal infratech private limited',
    'Esspal projects private limited',
    'Chakradev infraproject private limited',
    'Chakradev city home private limited',
    'Janmbhumi buildcon private limited',
    'Janmbhumi awas private limited',
    'Sja developers private limited',
    'Cleta buildcon private limited',
    'Nccc infrastructure private limited',
    'Cleta builders private limited',
    'Shubhalakshmi petro-yarns private limited',
    'Zep software services private limited',
    'Harbinger knowledge products private limited',
    'E - mat solutions private limited',
    'Ad2pro media solutions private limited',
    'Becabo networks private limited',
    'Mahindra vehicle manufacturers limited',
    'Chirag jewellers private limited',
    'Facor power limited',
    'Rbm solar energy private limited',
    'Shivika awas private limited',
    'Abis organic fertilizer private limited',
    'Uml engineers pvt ltd',
    'Vm suburban realty private limited',
    'Aegean properties limited',
    'Shubh shelters (india) pvt ltd',
    'Jas propbuild private limited',
    'Saljas construction private limited',
    'Bhagirathi greenfield real estate limited',
    'Diamond niketan private limited',
    'Mahesh conbuild private limited',
    'Ayj conbuild private limited',
    'Hermanos zubadi holdings pvt ltd',
    'Mid-town realty private limited',
    'Maplewood homes private limited',
    'Core infinity services private limited',
    'Era pvt ltd',
    'Alishan tracom private limited',
    'Kalindi commodeal private limited',
    'Rimjhim commotrade private limited',
    'Greenline distributors private limited',
    'Tirumala vintrade private limited',
    'Rangoli exim private limited',
    'Bill forge private limited',
    'Jainath infraprojects private limited',
    'Rapid general agencies pvt ltd',
    'Citadelle agencies private limited',
    'Ankur agencies private limited',
    'Sanchar consultants private limited',
    'Thrust investment and management consultants private limited',
    'Gourmet estates private limited',
    'Delphina consultants private limited',
    'MAGNIPHI ENTERPRISES PRIVATE LIMITED',
    'Atease mercantile private limited',
    'PATREX VYAPAAR PRIVATE LIMITED',
    'Amaze infracon private limited',
    'Diana estates private limited',
    'Apee aar enterprises private limited',
    'HOICHOI MEDIA PRIVATE LIMITED',
    'ENAM ADVISORS AND INVESTMENT CONSULTANTSPRIVATE LIMITED',
    'Lab one metropolis healthcare services private limited',
    'Ashpin holdings private limited',
    'Arrow textiles limited',
    'Midland services limited',
    'Atc beverages private limited',
    'INDO FRENCH SHELLFISH PRIVATE LIMITED',
    'Eminds legal consulting private limited',
    'Sanwa finance private limited',
    'Prs shares and finance private limited',
    'Prime commodities broking (india) limited',
    'Ibm business consulting services private limited',
    'Sard (india) pvt ltd',
    'Shaft investments private limited',
    'Flower vincom private limited',
    'Royalton builders & developers private limited',
    'GRISM BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Luvkush builders private limited',
    'Anuroop builders and developers private limited',
    'Merino exports pvt ltd',
    'Industrial parks (india) private limited',
    'Varun manian realty & construction private limited',
    'Transcendental rentals private limited',
    'Markem imaje software development centre private limited',
    'Vnxtl tech services private limited',
    'Olive outsourcing private limited',
    'Eurominds e-resources private limited',
    'Harbinger interactive learning private limited',
    'Malabar trustee company private limited',
    'Radar securities ltd.',
    'PHISAR MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'Alexis infrastructures private limited',
    'Ranthambhor tradelink private limited',
    'Aerocity traders private limited',
    'Ribo business consortium private limited',
    'Blue circle organics private limited',
    'Midas polypack private limited',
    'Sudhakar plastic private limited',
    'A b m steels private limited',
    'Mamata extrusion systems private limited',
    'Standard nagema machines india private limited',
    'Harsha liners private limited',
    'MJB TEA PROCESSING PRIVATE LIMITED',
    'N.b. space private limited',
    'Ascent construction private limited',
    'Abg realty and infrastructure company private limited',
    'Mahindra residential developers limited',
    'Ambition developers private limited',
    'Rajika estate developers private limited',
    'Mujaddid builders & developers private limited',
    'Vkarma capital trustee company private limited',
    'Menthol developers private limited',
    'Mrg infrabuild private limited',
    'Next events private limited',
    'Percept waterproofing services limited',
    'Ultraweld engineers private limited',
    'Redline automotive private limited',
    'Advert infomedia private limited',
    'Vandeep hotels private limited',
    'Exotic management consultants private limited',
    'VALMET AUTOMATION PRIVATE LIMITED',
    'Pushya trading private limited',
    'Paul wurth india private limited',
    'Prodelin india pvt ltd',
    'ZEE NETWORK DISTRIBUTION LIMITED',
    'Lyons properties pvt. ltd.',
    'Aba builders ltd',
    'Pereira holdings private limited',
    'Pranati development private limited',
    'APS TECH SUPPORT PRIVATE LIMITED',
    'Spi infrastructure private limited',
    'Aanwika construction private limited',
    'Indo-japan apparels private limited',
    'General wood industries private limited',
    'Novel plastic private limited',
    'Palmsprings realities private limited',
    'Harmony lifestyle habitats private limited',
    'Arihant dream builders private limited',
    'Colonnade housing private limited',
    'Vasundhara ecofriendly agroproducts private limited',
    'Universe heights (india) private limited',
    'Jsw logistics infrastructure private limited',
    'KRITDHAN TRADERS PRIVATE LIMITED',
    'Saptrangi craft limited',
    'Essilor sankar & co optics private limited',
    'Vision finlease private limited',
    'Ganjam trading company private limited',
    'RAJDARBAR CONSULTANCY PRIVATE LIMITED',
    'G b s marketing private limited',
    'Suchirindia projects private limited',
    'Sensec systems (india) limited',
    'Equator trading enterprises private limited',
    'SULOG TRANSSHIPMENT SERVICES Limited',
    'Honeycomb logistics private limited',
    'Crossover productions private limited',
    'Notch media private limited',
    'Tuni interiors private limited',
    'Prabodh artha sampada private limited',
    'Jindal photo investments limited',
    'FLM ENTERTAINMENT AND MARKETING SOLUTIONS PRIVATE LIMITED',
    'TARAASHNA FINANCIAL SERVICES LIMITED',
    'Gallantt ispat limited',
    'Housing development finance corporation limited',
    'Chettinad earth movers private limited',
    'V. s. multi metal private limited',
    'Eastman spinning mills private limited',
    'DRYCHEM SOLUTIONS PRIVATE LIMITED',
    'Remi international limited',
    'Amilia exports and investments pvt ltd',
    'Shivshankar tradecomm private limited',
    'Mangal multi trade private limited',
    'Parallel construction systems india private limited',
    'Deluxe tie up private limited',
    'Abacus accounting private limited',
    'Bhadra raj holding private limited',
    'ANANYA CONSTRUCTION PRIVATE LIMITED',
    'Aol online india private limited',
    'Gtpl city channel private limited',
    'KHYATI COMMODITIES AND TRADING PRIVATE LIMITED',
    'Colonnade contractors and developers private limited',
    'Kaunteya contractors and developers private limited',
    'Narbadeshwar investrade private limited',
    'UNMAJ ENTERPRISES LIMITED',
    'Pranay holdings limited',
    'Ria holdings ltd',
    'FANTASIA ENTERPRISES PRIVATE LIMITED',
    'Ashadeep holdings (india) private limited',
    'Happy aangan private limited',
    'Maa vaishnov vyapaar private limited',
    'Equatorial private limited',
    'Utkal merchandise pvt ltd',
    'Karpasa export private limited',
    'RENSONS BROTHERS PRIVATE LIMITED',
    'A.j. polymers private limited',
    'Vidhar management & consultancy services private limited',
    'Ipl gujarat port limited',
    'Aaniya traders limited',
    'Premier marine products private limited',
    'MILLTEC MACHINERY LIMITED',
    'DESAI METROPOLIS HEALTH SERVICES PRIVATE LIMITED',
    'Snoways laundrers & drycleaners private limited',
    'Kader investment and trading company private limited',
    'Grandeur products limited',
    'Abc bearings limited',
    'A p m investments limited',
    'Sultania enterprises limited',
    'Aryan coalfield private limited',
    'Exacta fluid engineering co. private limited',
    'Howden air & gas india private limited',
    'BLUEGATE CHARITABLE FOUNDATION',
    'Les ateliers de pondicherry private limited',
    'Pacifica construction private limited',
    'Spenta habitat private limited',
    'Indus valley partners (india) private limited',
    'Mphinite technologies private limited',
    'MICROSEMI STORAGE SOLUTIONS INDIA PRIVATE LIMITED',
    'Berkeley design automation india private limited',
    'SILICON AND BEYOND PRIVATE LIMITED',
    'Cuelogic technologies private limited',
    'Amazon it services (india) private limited',
    'TVS NEXT PRIVATE LIMITED',
    'Krishna bakers private limited',
    'Mccormick support services private limited',
    'Amenity software private limited',
    'India webportal private limited',
    'Arcadia technologies private limited',
    'Lurgi india international services private limited',
    'Synergy property development services private limited',
    'Himratna terpenes private limited',
    'Ripple fragrances private limited',
    'J.j. polyplast private limited',
    'Kpl logistics limiited',
    'Mestech services private limited',
    'Vaid die casting pvt ltd',
    'Asian containers pvt ltd',
    'Aeropure uv systems private limited',
    'Vasundara manufacturing systems private limited',
    'J c tex-tech private limited',
    'Megtec systems india private limited',
    'Lumicom technologies private limited',
    'Highstreet constructions private limited',
    'Oriental floriculture private limited',
    'Via redd concepts private limited',
    'Amrin constructions private limited',
    'Wellknown enterprises private limited',
    'Dior housing private limited',
    'Surawali realties private limited',
    'Shapoorji pallonji infrastructure (gujarat) private limited',
    'New kakinada developers private limited',
    'Aparna villas private limited',
    'Pacific landmarks private limited',
    'Addon enterprises private limited',
    'Teesta retail private limited',
    'Prism multitrade private limited',
    'ACCO COMMERCIAL PRIVATE LIMITED',
    'Epsilon international consulting services private limited',
    'Precision components private limited',
    'Caparo facility management services private limited',
    'Thyssenkrupp marine systems (india) private limited',
    'Kmc road holdings private limited',
    'Ask your deal procurement private limited',
    'DATAMINE SOLUTIONS PRIVATE LIMITED',
    'AVANZA MANAGEMENT CONSULTING PRIVATE LIMITED',
    'Commodity online (india)limited',
    'Niche health options private limited',
    'DGTAG SOLUTIONS PRIVATE LIMITED',
    'ROSEVILLE EDUNUT PRIVATE LIMITED',
    'ARCUM GLOBAL VENTURES PRIVATE LIMITED',
    'NAKSHATRA VIDYA PRIVATE LIMITED',
    'END TO END ENGINEERING PRIVATE LIMITED',
    'CLASIS CORPORATE SERVICES PRIVATE LIMITED',
    'INBOUND BLESS TRAVELS PRIVATE LIMITED',
    'TROFI IMPEX PRIVATE LIMITED',
    'RIGHT MOVE CONNOISSEURS PRIVATE LIMITED',
    'HAMARA INDUSTRIES PRIVATE LIMITED',
    'SHIVAAYAMBIKA ACADEMY OF SPORTS PRIVATE LIMITED',
    'PROMEGH TECHNOLOGIES PRIVATE LIMITED',
    'SYNORIQ R&D PRIVATE LIMITED',
    'CODESPUR TECHNOLOGIES PRIVATE LIMITED',
    'HOMESCONNECT STORES PRIVATE LIMITED',
    'BAROLIA CONSULTANTS PRIVATE LIMITED',
    'UNIDIS HEALTHCARE PRIVATE LIMITED',
    'WASFA IMPEX PRIVATE LIMITED',
    'SWARAJYA INNOVATIONS PRIVATE LIMITED',
    'SPC ENVIORNMENT PROTECTION TECH PRIVATE LIMITED',
    'TEAM CORE GYMS PRIVATE LIMITED',
    'LASFAB SOLUTIONS PRIVATE LIMITED',
    'RADIATE DIGITAL SERVICES PRIVATE LIMITED',
    'ILWOOTEC INDIA PRIVATE LIMITED',
    'FTA ENGINEERING PRIVATE LIMITED',
    'MO VENTURES PRIVATE LIMITED',
    'TREXTON INDIA PRIVATE LIMITED',
    'HR TECHNICAL TRADE CENTRE PRIVATE LIMITED',
    'JILIAN CONSULTANTS INDIA PRIVATE LIMITED',
    'S. P. JAGANNATH INDUSTRIES PRIVATE LIMITED',
    'SHILPBODH KNOWLEDGEWORKS PRIVATE LIMITED',
    'MAVEN TECHNOSOFT PRIVATE LIMITED',
    'DIGIVERIFI PRIVATE LIMITED',
    'GPA TEA FLOOR PRIVATE LIMITED',
    'CROLOGIC SOLUTIONS PRIVATE LIMITED',
    'BRIVAN DIGISOL PRIVATE LIMITED',
    'RENOUS EXTENSERVE PRIVATE LIMITED',
    'AJOONI IMPACT INVESTMENT ADVISORS PRIVATE LIMITED',
    'AGELIX CONSULTING PRIVATE LIMITED',
    'BODHITREE R&R PRIVATE LIMITED',
    'INFIEYE SECURITY HUB PRIVATE LIMITED',
    'RIDHI SIDHI SAFETY & INDUSTRIAL TOOLS PRIVATE LIMITED',
    'MYBUSINESS CONSULTING (INDIA) PRIVATE LIMITED',
    'GLOBEDGE HEALTHCARE & WELLNESS SERVICES PRIVATE LIMITED',
    'ARAVALI DAIRY & AGRO PRODUCTS PRIVATE LIMITED',
    'HADES INFO SYSTEMS PRIVATE LIMITED',
    'COGENT HOSPITALITY PRIVATE LIMITED',
    'IGNITERS HUB PRIVATE LIMITED',
    'EXPONUS EVENTS PRIVATE LIMITED',
    'SHRI AVIGHNA BUSINESS ASSOCIATES PRIVATELIMITED',
    'IRQM SERVICES PRIVATE LIMITED',
    'SANA SKILLPROMISE EDUCATION PRIVATE LIMITED',
    'TECHKRITI WEBCARE SERVICES PRIVATE LIMITED',
    'THEAEC GLOBAL ASSOCIATES PRIVATE LIMITED',
    'TAVROHI ANIMATIONS PRIVATE LIMITED',
    'AMPSOLAR GENERATION PRIVATE LIMITED',
    'DILIGENT RENTAL SERVICES PRIVATE LIMITED',
    '6WRESEARCH & DATABASE SERVICES PRIVATE LIMITED',
    'MATCH MY TALENT PRIVATE LIMITED',
    'CONNECTING WINGS OVERSEAS PRIVATE LIMITED',
    'GARNET CONCEPTS PRIVATE LIMITED',
    'INDIFOOT SPORTS PRIVATE LIMITED',
    'GALAXY FLOOR CARE PRIVATE LIMITED',
    'UNIPAHAL ENERGY PRIVATE LIMITED',
    'AUSTYN SQUAD PRIVATE LIMITED',
    'S. MARK ENGINEERING (I) PRIVATE LIMITED',
    'PM CAPITAL LIMITED',
    'JES & BEN GROUPO PRIVATE LIMITED',
    'KIWHODE LEARNING PRIVATE LIMITED',
    'DANIELS GT INDIA PRIVATE LIMITED',
    'TIEBREAKER SOLUTIONS PRIVATE LIMITED',
    'ADDBIV SECURER PRIVATE LIMITED',
    'ADJ UTILITY APPS PRIVATE LIMITED',
    'PIANO MAN EVENTS AND ARTIST MANAGEMENT PRIVATE LIMITED',
    'ASYLUM INNOVATION PRIVATE LIMITED',
    'ZOTLAY MOBILITY PRIVATE LIMITED',
    'HPRT INDIA PRIVATE LIMITED',
    'BYCYSHARE TECHNOLOGIES PRIVATE LIMITED',
    'HALOLIT INDUSTRIES PRIVATE LIMITED',
    'HUES LIFESTYLE SERVICES (INDIA) PRIVATE LIMITED',
    'RHEALIVE INTERNATIONAL PRIVATE LIMITED',
    'SKS AGRO EXIM PRIVATE LIMITED',
    'POWER JACKS (INDIA) PRIVATE LIMITED',
    'NATECO FOUNDATION',
    'XPEDIZE VENTURES PRIVATE LIMITED',
    'PEONY SERVICES PRIVATE LIMITED',
    'AKACHAN RECYCLERS INDIA PRIVATE LIMITED',
    'HOMEPUNCH PRIVATE LIMITED',
    'EXTRAMILES CONSULTANTS PRIVATE LIMITED',
    'SILLAGE DISTRIBUTORS PRIVATE LIMITED',
    'PONTIKA AEROTECH LIMITED',
    'JPY BUILDCON PRIVATE LIMITED',
    'INNORE LIGHTING PRIVATE LIMITED',
    'AVITRA INTERNATIONAL PRIVATE LIMITED',
    'PHYTOCOM PHARMACEUTICALS PRIVATE LIMITED',
    'SETLMINT TECHNOLOGY PRIVATE LIMITED',
    'AVIATE LOGISTICS INDIA PRIVATE LIMITED',
    'FRUGALON TECHNOLOGIES PRIVATE LIMITED',
    'MINTOAK INNOVATIONS PRIVATE LIMITED',
    'YECHTE SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'BIBAWO MEDICAL PRIVATE LIMITED',
    'WME CONSULTANTS INDIA PRIVATE LIMITED',
    'ASSOCIATION FOR PROMOTION OF PROMINENT SCHOOLS',
    'NAREN FITNESS PRIVATE LIMITED',
    'RELIANCE CONTENT DISTRIBUTION LIMITED',
    'CRETAL SOLUTIONS PRIVATE LIMITED',
    'IVKONNECT SOLUTIONS PRIVATE LIMITED',
    'JIO INFRASTRUCTURE MANAGEMENT SERVICES LIMITED',
    'PLANSFORM TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ZAKSPACES & INTERIORS PRIVATE LIMITED',
    'AELITE VENTURES PRIVATE LIMITED',
    'HOUSEGROOM PRIVATE LIMITED',
    'XCRAFT ONLINE PRIVATE LIMITED',
    'MOOHRAT INDUSTRIES PRIVATE LIMITED',
    'FIRSTSTACK TECHNOLOGIES PRIVATE LIMITED',
    'DI POLE SOLUTIONS PRIVATE LIMITED',
    'NAMAN STAY PRIVATE LIMITED',
    'TECHLAND METALS AND MINERALS PRIVATE LIMITED',
    'MYBUTLER FACILITY MANAGEMENT PRIVATE LIMITED',
    'EZHOMZ SOLUTIONS PRIVATE LIMITED',
    'ALPHA ALTERNATIVE ASSET ADVISORS PRIVATELIMITED',
    'BRG CONSULTING (INDIA) PRIVATE LIMITED',
    'ASCENT RISK & RESILIENCE SOFTWARE PRIVATE LIMITED',
    'LEAFYLAND AGRO AND MARINE INDUSTRIES PRIVATE LIMITED',
    'MILLANO IT SOLUTIONS PRIVATE LIMITED',
    'CLICK2DIGITALLY VIRAL SERVICES PRIVATE LIMITED',
    'JYOTHIS ASSOCIATES PRIVATE LIMITED',
    'LADIES YOUTH ASSOCIATION',
    'MVG DIGITAL CONSULTING PRIVATE LIMITED',
    'POSINDA INTERNATIONAL TRADING PRIVATE LIMITED',
    'AXIS WIND FARMS (POTTIPADU) PRIVATE LIMITED',
    'OMNIST TECHHUB SOLUTIONS PRIVATE LIMITED',
    'INCH DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'SHAFORD ENGINEERING PRIVATE LIMITED',
    'VITAL FORCE & FACILITIES MANAGEMENT PRIVATE LIMITED',
    'PRO CRICKET LEAGUE PRIVATE LIMITED',
    'AMBASSADOR PRIME HOSPITALITY PRIVATE LIMITED',
    'DIGITRANSIT INTERACTIVE MEDIA SOLUTIONS PRIVATE LIMITED',
    'ZEFI LABS PRIVATE LIMITED',
    'HKART BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VANAPURNA PRIVATE LIMITED',
    'EGALITARIAN TECH CONNECTIVITY PRIVATE LIMITED',
    'NIM LOOK FASHIONS PRIVATE LIMITED',
    'SAFFRONLEAF HOSPITALITY INDIA PRIVATE LIMITED',
    'KALKINE SOLUTIONS PRIVATE LIMITED',
    'SYNRAM SOFTWARE SERVICES PRIVATE LIMITED',
    'SHIVALAYA ENERGY PRIVATE LIMITED',
    'CENTRE FOR SKILL DEVELOPMENT IN TOURISM',
    'VIVACIOUS ENTERTAINMENT AND HOSPITALITY PRIVATE LIMITED',
    'TRUE CREDITS PRIVATE LIMITED',
    'BLUELITE HOLDINGS LIMITED',
    'AUDVIO TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AXCRYPT SOFTWARE PRIVATE LIMITED',
    'TUTORS PRIDE EDUTECH PRIVATE LIMITED',
    'TARA BLOOMS PRIVATE LIMITED',
    'ARCHISHA MINES PRIVATE LIMITED',
    'IMR SOFTWARE PRIVATE LIMITED',
    'AXIS WIND FARMS (CHAPIRI) PRIVATE LIMITED',
    'SYNERGETIC RELIABLE ADVISORS PRIVATE LIMITED',
    'SUNKRISH GLOBECONS PRIVATE LIMITED',
    'AXIS WIND FARMS (ATMAKUR) PRIVATE LIMITED',
    'MYTOULO TRAVEL TECH PRIVATE LIMITED',
    'SOMVANSHI ADVISORY SERVICES PRIVATE LIMITED',
    'ZUVAN INTERNATIONAL TRANSPORT LIMITED',
    'AXIS WIND FARMS (NUTHIMADUGU) PRIVATE LIMITED',
    'ITRIFID PRIVATE LIMITED',
    'SHASHA INNOVATIONS PRIVATE LIMITED',
    'HELP U PRODUCTS & SERVICES PRIVATE LIMITED',
    'KADALAI MITTAI PRIVATE LIMITED',
    'AGNIINTERACTIVE MEDIA SOLUTIONS PRIVATE LIMITED',
    '121 HIRING PRIVATE LIMITED',
    'SPURX INTERNATIONAL PRIVATE LIMITED',
    'LOGICVALLEY TECHNOLOGIES PRIVATE LIMITED',
    'VISHAL PATTERNS AND PRINTS PRIVATE LIMITED',
    'PULASTAYA INDIA PRIVATE LIMITED',
    'SOCRATIC EDUCATION PRIVATE LIMITED',
    'SHALLY EDUCATION FOUNDATION',
    'RADICLE TECHNICAL SERVICES PRIVATE LIMITED',
    'SKYMINAR TOUR AND TRAVEL PRIVATE LIMITED',
    'IMPECCABLE ADVISORS PRIVATE LIMITED',
    'SOFMOB CONNECT SOLUTIONS PRIVATE LIMITED',
    'KHALOOM TEXTILES INDIA PRIVATE LIMITED',
    'DREXSPORT INDIA (OPC) PRIVATE LIMITED',
    'ROYAL CONNECT SOLUTIONS PRIVATE LIMITED',
    'S4W NETWORKS PRIVATE LIMITED',
    'ADANI HOUSING FINANCE PRIVATE LIMITED',
    'REGROW THERAPEUTICS PRIVATE LIMITED',
    'ICP FACILITY MANAGEMENT & SERVICES PRIVATE LIMITED',
    'PURE PURPOSE FOUNDATION',
    'TJR TRAINING SOLUTIONS PRIVATE LIMITED',
    'SUJAIN TEXTILES PRIVATE LIMITED',
    'KULTURZENTRUM EDUCARO INDIA PRIVATE LIMITED',
    'CODEBUCKET SOLUTIONS PRIVATE LIMITED',
    'SEIDO TECHNOLOGIES PRIVATE LIMITED',
    'EMIRERRI STEEL MANUFACTURER PRIVATE LIMITED',
    'WTE BIO-SOLUTIONS INDIA PRIVATE LIMITED',
    'VEDANSHI INFOTECH PRIVATE LIMITED',
    'MIURA DYNAMICS PRIVATE LIMITED',
    'MAXAR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SANSAFE REMEDIES PRIVATE LIMITED',
    'HIDDENSMITH DECOR PRIVATE LIMITED',
    'UNIFRO TEXTILES PRIVATE LIMITED',
    'EDVENT SOLUTIONS PRIVATE LIMITED',
    'IGREENIK PRIVATE LIMITED',
    'KOALA LEARNING PRIVATE LIMITED',
    'TRYOLO COMPUTECH PRIVATE LIMITED',
    'ARM MEDIA WORKS PRIVATE LIMITED',
    'AVIOMAS PRIVATE LIMITED',
    'AYANT SOLAR PRIVATE LIMITED',
    'KSHITIJ SECURITY AND FACILITY MANAGEMENTPRIVATE LIMITED',
    'SCASA ORGANICS PRIVATE LIMITED',
    'IMA BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'RANN ACRES PRIVATE LIMITED',
    'WEVIO GLOBAL PRIVATE LIMITED',
    'SINGH POLYPET PRIVATE LIMITED',
    'IDEAX LABELS AND ACCESSORIES PRIVATE LIMITED',
    'MNR DATAMIGHT PRIVATE LIMITED',
    'PAYTM MONEY LIMITED',
    'MIND SPEAKS TECHNOLOGY PRIVATE LIMITED',
    'BURAQ MEDICAL TOURISM PRIVATE LIMITED',
    'DHANAJAYA AGRO FARMS PRIVATE LIMITED',
    'EUROPEAN DECOATING AND ENVIRO TECHNOLOGIES PRIVATE LIMITED',
    'WINGLO SOLUTIONS PRIVATE LIMITED',
    'AVIOTA TECHNOLOGIES PRIVATE LIMITED',
    'BOXO BURGER FOODS PRIVATE LIMITED',
    'RGM MACHINES INDIA PRIVATE LIMITED',
    'FACTEYE TECH LABS PRIVATE LIMITED',
    'TUUPLE TECHNOCRAFT PRIVATE LIMITED',
    'EZYREACH INFOCOM PRIVATE LIMITED',
    'RAPID ACCELERATION INDIA PRIVATE LIMITED',
    'PREMIER CONSULTANTS & PLACEMENTS PRIVATELIMITED',
    'RATNAGIRI REFINERY AND PETROCHEMICALS LIMITED',
    'CARICON BUILDING SERVICES PRIVATE LIMITED',
    'OXYCON MEDIA PRIVATE LIMITED',
    'AGHASTYA ELECTROTECH PRIVATE LIMITED',
    'CENERGIST ENERGY PRIVATE LIMITED',
    'QUEST DIAGNOSTICS HTAS INDIA PRIVATE LIMITED',
    'TSM THESAFETYMASTER PRIVATE LIMITED',
    'KIBITZ RESOURCES PRIVATE LIMITED',
    'MKH IMPERIAL PRIVATE LIMITED',
    'STEYR ARMS PRIVATE LIMITED',
    'JIGGLE DE VENTURE PRIVATE LIMITED',
    'CHIFFONADE VENTURES PRIVATE LIMITED',
    'HANVI IRIS COMMUNICATIONS PRIVATE LIMITED',
    'SHARPJADE LIFTS PRIVATE LIMITED',
    'QA BIM PRIVATE LIMITED',
    'POLICY MASTER INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'HAVILAH PROJECT PRIVATE LIMITED',
    'BROADSWORD COMMUNICATIONS PRIVATE LIMITED',
    'CARBONWATCH INDIA PRIVATE LIMITED',
    'KAUSHIKEE MAHILA MILK PRODUCER COMPANY LIMITED',
    'NEUVONIQUE RESEARCH REMEDIES PRIVATE LIMITED',
    'ROCKLIEN TECHNOLOGIES PRIVATE LIMITED',
    'HUNKY DORY TRAVEL PRIVATE LIMITED',
    'HOXBRIDGE PREPARATIONINFO PRIVATE LIMITED',
    'TGD MARKETING PRIVATE LIMITED',
    'NISMAH TECHNOLOGIES PRIVATE LIMITED',
    'SILVERSTAR AVIATION PRIVATE LIMITED',
    'FFL AGRO PRIVATE LIMITED',
    'KASETTI TECHNOLOGIES PRIVATE LIMITED',
    'INCEDE SOFTWARE AND CONSULTING (OPC) PRIVATE LIMITED',
    'MY HOLIDAY POINT PRIVATE LIMITED',
    'LOOKS HERBAL PRIVATE LIMITED',
    'SELTZER ENGINEERING SERVICES PRIVATE LIMITED',
    'RELISCALE CONSULTING PRIVATE LIMITED',
    'LAB SULPHONATE PRIVATE LIMITED',
    'PAISACLOUD INSURANCE MARKETING PRIVATE LIMITED',
    'INNO STONE INDIA PRIVATE LIMITED',
    'BOFFINS IT SOLUTIONS PRIVATE LIMITED',
    'EMPOWER SPORTS PRIVATE LIMITED',
    'BTU CREATIVES PRIVATE LIMITED',
    'SUPREME SPORTS STUDIO PRIVATE LIMITED',
    'INNOVATED GS MAGNA PRECISIONS PRIVATE LIMITED',
    'SNOVUS TECHNOLOGY PRIVATE LIMITED',
    'NIMBLEBUY PRIVATE LIMITED',
    'ARCAD SOFTWARE PRODUCTS PRIVATE LIMITED',
    'INDOCAYS PRIVATE LIMITED',
    'FARGO SHIPPING AND LOGISTICS ( INDIA) PRIVATE LIMITED',
    'SATSURE ANALYTICS INDIA PRIVATE LIMITED',
    'BOTTLENOSE CONSULTANTS INDIA PRIVATE LIMITED',
    'FOLK PRODUCTS AND DESIGN PRIVATE LIMITED',
    'RIVERFOREST IMAGINET TECHNOLOGIES PRIVATE LIMITED',
    'CHERRYROAD SERVICES INDIA PRIVATE LIMITED',
    'SHAN CORPORATE SERVICES PRIVATE LIMITED',
    'INVINCIBLE ADVISORS PRIVATE LIMITED',
    'LESSO HOME IT DEVELOPMENT (INDIA) PRIVATE LIMITED',
    'WALRUS SOLUTIONS PRIVATE LIMITED',
    'AIRPRO FRAGRANCE PRIVATE LIMITED',
    'DURU COOPERATION PRIVATE LIMITED',
    'SRAJ PRODUCTIONS PRIVATE LIMITED',
    'ROKANE INFRACON PRIVATE LIMITED',
    'KAD VIRTUAL CONSTRUCTION SERVICES PRIVATE LIMITED',
    'TRUMARK HOMES PRIVATE LIMITED',
    'HNH PLACEMENT PRIVATE LIMITED',
    'ABSTRAT IDEAS AND SOLUTIONS PRIVATE LIMITED',
    'PRAVEGAM SHIPPING PRIVATE LIMITED',
    'SANJOS HOLIDAYS INDIA PRIVATE LIMITED',
    'ZELAR SOFT PRIVATE LIMITED',
    'SYNE DIGITAL PRIVATE LIMITED',
    'KARTIK SPECIALITY COATINGS PRIVATE LIMITED',
    'INION DATA TECHNOLOGIES PRIVATE LIMITED',
    'REETI DAIRY AND PRODUCTS PRIVATE LIMITED',
    'ASHPLAN PRIVATE LIMITED',
    'CORBITAL BPO TECH PRIVATE LIMITED',
    'CHINTAMONEY FINTECH PRIVATE LIMITED',
    'JASHA IMPEX INDIA PRIVATE LIMITED',
    'ACROSS ASSIST PRIVATE LIMITED',
    'JH FASHIONS PRIVATE LIMITED',
    'SIKKA LOCOMOTIVES PRIVATE LIMITED',
    'THALESAT INNOVATIONS PRIVATE LIMITED',
    'PNP FLEXIPACK PRIVATE LIMITED',
    'ANSA TRAINING & QUALITY ASSURANCE PRIVATE LIMITED',
    'SURFACE ENTERPRISES PRIVATE LIMITED',
    'SUNBRILO TECHNOLOGIES PRIVATE LIMITED',
    'TERRALS TECHNOLOGIES PRIVATE LIMITED',
    'DST LOGIPACK SOLUTIONS INDIA PRIVATE LIMITED',
    'IIF ANALYST PRIVATE LIMITED',
    'WESHAREHAPPINESS PRIVATE LIMITED',
    'FLAVARA GRUB INDIA PRIVATE LIMITED',
    'SUTVACHA SKINCARE PRIVATE LIMITED',
    'FAKEEH TECHNOLOGIES PRIVATE LIMITED',
    'DOLPHIN LASER TECH PRIVATE LIMITED',
    'NAUSHEHRA AUTO PRIVATE LIMITED',
    'RAM TECHROBOTS IT SERVICES PRIVATE LIMITED',
    'ABHIKUND ADVISORY SERVICES PRIVATE LIMITED',
    'CARGOSITE LOGISTICS PRIVATE LIMITED',
    'TECHRACK CONCEPTS PRIVATE LIMITED',
    'URDHVAM ENVIRONMENTAL TECHNOLOGIES PRIVATE LIMITED',
    'KARNATAKA RESCO ROOFTOP SOLAR PRIVATE LIMITED',
    'TECHGRADIENT MARKET ANALYSIS PRIVATE LIMITED',
    'ISMC ANALOG FAB PRIVATE LIMITED',
    'MAHARASHTRA RESCO ROOFTOP SOLAR PRIVATE LIMITED',
    'OCS ENERGY SERVICES INDIA PRIVATE LIMITED',
    'VALENTA KPO PRIVATE LIMITED',
    'GOHINA FOODS PRIVATE LIMITED',
    'INDEL MONEY FIN-TECH PRIVATE LIMITED',
    'THRIVE UNITED VENTURES PRIVATE LIMITED',
    'WADHA SPICES PRIVATE LIMITED',
    'TEMPER EATERY PRIVATE LIMITED',
    'RIBBSTYLE INDIA PRIVATE LIMITED',
    'ALTILIS TECHNOLOGIES PRIVATE LIMITED',
    'BAYBEL LANGUAGE SERVICES PRIVATE LIMITED',
    'FAMOCO SOLUTIONS PRIVATE LIMITED',
    'INVENTICURE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'INTEGRATED BUSINESS PROCESSING PRIVATE LIMITED',
    'KAIROSS XCHANGE LIMITED',
    'ASOKA PROJECTS PRIVATE LIMITED',
    'VRUKSHA VEDH FOUNDATION',
    'FRITEL TRANSMISSION PRIVATE LIMITED',
    'ASHBERRY RESEARCH AND CONSULTING PRIVATELIMITED',
    'MANPREET NUTRIAPT HEALTHCARE PRIVATE LIMITED',
    'AURELIA INNOVATIVES PRIVATE LIMITED',
    'RM AQUA PRIVATE LIMITED',
    'QUBE DIGITAL CINEMA PRIVATE LIMITED',
    'AUDME ENGINEERING & CONSULTANTS PRIVATE LIMITED',
    'JISA SOFTECH PRIVATE LIMITED',
    'GEOMS DIGITAL HOUSE PRIVATE LIMITED',
    'CLICK AND KATCH PRIVATE LIMITED',
    'ANDHRA PRADESH RESCO ROOFTOP SOLAR PRIVATE LIMITED',
    'AFI NIDHI LIMITED',
    'URBAN MONK PRIVATE LIMITED',
    'BLEEXY SOFTWARE PRIVATE LIMITED',
    'ESPERANZA GAMING PRIVATE LIMITED',
    'BRAND LABS INDIA PRIVATE LIMITED',
    'CHARCOALLINES PRIVATE LIMITED',
    'LIBRA VALUERS PRIVATE LIMITED',
    'SPIL HOSPITALITY PRIVATE LIMITED',
    'PHARMACHEM BIOTECH (I) PRIVATE LIMITED',
    'TEPSOL PROJECTS PRIVATE LIMITED',
    'TROY MILLING AND SOLAR ENERGY (I) PRIVATE LIMITED',
    'CMES JUPITER PRIVATE LIMITED',
    'INFIMONEY VENTURES PRIVATE LIMITED',
    'SUNEX STONES PRIVATE LIMITED',
    'SUPERHERO TECH PRIVATE LIMITED',
    'STERLITE GRID 8 LIMITED',
    'MEIOMITO BUSINESS PRIVATE LIMITED',
    'ANSAN TECHNOLOGIES PRIVATE LIMITED',
    'UCC SYSTEMS PRIVATE LIMITED',
    'INTERSCRIPTS SOFTWARE PRIVATE LIMITED',
    'PUREBLUE AUTOMOTIVE SOLUTIONS PRIVATE LIMITED',
    'ZACCO INDIA R&D PRIVATE LIMITED',
    'STEEL INFRA SOLUTIONS PRIVATE LIMITED',
    'IIT BHUBANESWAR RESEARCH AND ENTREPRENEURSHIP PARK',
    'WOODEN CLOCK INDUSTRIES PRIVATE LIMITED',
    'HPV BREWERIES PRIVATE LIMITED',
    'EMPEROR MIGRATION SERVICES PRIVATE LIMITED',
    'CURENGINE INDIA PRIVATE LIMITED',
    'BIOTAGE INDIA PRIVATE LIMITED',
    'RDS SYSTEMS PRIVATE LIMITED',
    'ATHINGZ SOLUTIONS PRIVATE LIMITED',
    'SSBD HOSPITALITY PRIVATE LIMITED',
    'COGFAB AI INCULATOR PRIVATE LIMITED',
    'INQUISITIVE CREW PRIVATE LIMITED',
    'TAGOSH MEDIA SOLUTIONS PRIVATE LIMITED',
    'COTTONCONNECT FARMER COMMUNITY FOUNDATION',
    'CLIMATE POLICY FOUNDATION',
    'EAGLES FREIGHT PRIVATE LIMITED',
    'ELWINT LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'BMN INFOTECH PRIVATE LIMITED',
    'PN RESOURCEZONE PRIVATE LIMITED',
    'PAMEX LOGISTICS INDIA PRIVATE LIMITED',
    'SURVIN IT SOLUTIONS PRIVATE LIMITED',
    'NBS PATRONAGE PRIVATE LIMITED',
    'KORLOY INDIA MANUFACTURING PRIVATE LIMITED',
    'AIRVEL TOURS AND TRAVELS PRIVATE LIMITED',
    'AVISCO ENTERPRISES PRIVATE LIMITED',
    'JWM SOLUTIONS PRIVATE LIMITED',
    'SCIOALL CONSULTING PRIVATE LIMITED',
    'XCELPROS TECHNOLOGIES PRIVATE LIMITED',
    'ACHINTYA INTERACTIVE PRIVATE LIMITED',
    'GREEN COVE OFFSHORE SERVICES PRIVATE LIMITED',
    'HARPHIL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'INDO HEMP PRIVATE LIMITED',
    'GAURISHAKTI TEXTILE TRADING PRIVATE LIMITED',
    'VILANI SOFTTECH PRIVATE LIMITED',
    'HIACC ENGINEERING AND SERVICES PRIVATE LIMITED',
    'CAPITAIRE CONSULTING PRIVATE LIMITED',
    'VERITASIUM REALTY PRIVATE LIMITED',
    'MSZ LOGISTICS PRIVATE LIMITED',
    'BHOOMANTRA SERVICES PRIVATE LIMITED',
    'PEBBLE SIERRA ACADEMY PRIVATE LIMITED',
    'BLACKPOND GLOBAL DIGITAL SYSTEMS PRIVATELIMITED',
    'NKZ TECHNOLOGIES PRIVATE LIMITED',
    'VNB INFO TECH PRIVATE LIMITED',
    'CLYBAY PRIVATE LIMITED',
    'ROLLING ROCK SOFTWARE PRIVATE LIMITED',
    'JACKPOT PIZZAS PRIVATE LIMITED',
    'RCS INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED',
    'ADSKAR MEDIA PRIVATE LIMITED',
    'SVAMAAN FINANCIAL SERVICES PRIVATE LIMITED',
    'SENSEDGE TRANSPORTATION SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'NXM INDIA PRIVATE LIMITED',
    'SUSTAINABLE SMART SOLUTIONS PRIVATE LIMITED',
    'DIGATO (OPC) PRIVATE LIMITED',
    'ZASTI INDIA PRIVATE LIMITED',
    'GLOSS STUDIO PRIVATE LIMITED',
    'DHARAM DARSHNA CHARITABLE FOUNDATION',
    'QUANTIPLY MANAGEMENT PRIVATE LIMITED',
    'COGFAB.AI SPACES PRIVATE LIMITED',
    'FABFACT HEAVY ENGINEERING PRIVATE LIMITED',
    'INDOSPIRIT MANUFACTURING PRIVATE LIMITED',
    'BYNEMARA ESTATES PRIVATE LIMITED',
    'RIZORT TECHNOLOGIES PRIVATE LIMITED',
    'TOU CABS & TAXI PRIVATE LIMITED',
    'SUNALPHA ENERGY CLEANTECH PRIVATE LIMITED',
    'KEYWEST EDUINFRA & SERVICES PRIVATE LIMITED',
    'LILLIPPUTT TRADING PRIVATE LIMITED',
    'APPIFY SYSTEMS PRIVATE LIMITED',
    'APPLAUNCH BANGALORE PRIVATE LIMITED',
    'SHIVERA LIFESTYLE PRIVATE LIMITED',
    'VITTI RESEARCH FOUNDATION',
    'SRI SALASAR BALAJI TEXTILES PRIVATE LIMITED',
    'BIM TECHNICAL TRAINING SOLUTIONS PRIVATELIMITED',
    'WORKSLOGIC SOFTWARE PRIVATE LIMITED',
    'VESSCO UHE PRIVATE LIMITED',
    'FLORINTREE MANAGERS PRIVATE LIMITED',
    'REDEFINEDRIGHTCLOUD PRIVATE LIMITED',
    'VLR CORPORATE SOLUTIONS PRIVATE LIMITED',
    'MALABAR INNOVATION ENTREPRENEURSHIP ZONE',
    'QUBIX INTEGRATED MEDIA SERVICES PRIVATE LIMITED',
    'PINKBALL CRICKET FEDERATION (INDIA)',
    'AUFBAU TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AMIGA ADVERTISEMENTS PRIVATE LIMITED',
    'GCP HOSPITALITY PRIVATE LIMITED',
    'BOXHAM ENTERPRISES PRIVATE LIMITED',
    'WEBEAZ TECHNOLOGIES PRIVATE LIMITED',
    'MALCANA AUTOMATION PRIVATE LIMITED',
    'BARIYAN OIL & LUBRICANTS PRIVATE LIMITED',
    'SRI VENKATACHALAPATHY TRADING PRIVATE LIMITED',
    'ELEMAR LIFESCIENCES PRIVATE LIMITED',
    'BK INFRASERVICES PRIVATE LIMITED',
    'PASR BAKING SOLUTIONS PRIVATE LIMITED',
    'AEROTIDE INFRASTRUCTURE ENGINEERING PRIVATE LIMITED',
    'KRYPTON PEST CONTROL PRIVATE LIMITED',
    'INDIA Y-NOT DESIGN AND MANUFACTURING PRIVATE LIMITED',
    'AKKAM OVERSEAS SERVICES PRIVATE LIMITED',
    'LUXZURI SPORTSWEAR PRIVATE LIMITED',
    'LAKSHYA ENERGSTORAGE SYSTEMS PRIVATE LIMITED',
    'PRANMANWORKS GLOBAL PRIVATE LIMITED',
    'LOLAROSA PUBLISHING (OPC) PRIVATE LIMITED',
    'HINDWARE LIMITED',
    'SANRON ENERGY PRIVATE LIMITED',
    'CENTILLION INFOTECH PRIVATE LIMITED',
    'H&G IT PRIVATE LIMITED',
    'BHAUKAAL BABA TECHNOLOGIES PRIVATE LIMITED',
    'NANGHAVI CHROMATOGRAPHY SOLUTIONS PRIVATE LIMITED',
    'XL DIGITAL INNOVATION PRIVATE LIMITED',
    'ARBHAR CONSULTING PRIVATE LIMITED',
    'KULDEEP WEBSOFT PRIVATE LIMITED',
    'AGILANTE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'IHUB MULTI STORES PRIVATE LIMITED',
    'ENABLER ESSENTIAL FOUNDATION',
    'ENREAP SYSTEMS PRIVATE LIMITED',
    'EZOFIS SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'CULINARY BRANDS PRIVATE LIMITED',
    'KELENO LABS PRIVATE LIMITED',
    'VIRK INDIA EXPORTS PRIVATE LIMITED',
    'CPAS TECHNOLOGIES PRIVATE LIMITED',
    'SUHAS MOVIE CUBES PRIVATE LIMITED',
    'YELLOWBUG TECHNOLOGIES PRIVATE LIMITED',
    'SAADHYA CONSULTING PRIVATE LIMITED',
    'ENGROSS DATA MANAGEMENT SERVICES PRIVATELIMITED',
    'PURELEARN EDUINFRA BANGALORE PRIVATE LIMITED',
    'PEGASOS DIGITAL INSURANCE WEB AGGREGATORLIMITED',
    'AUDIOPHILE DISTRIBUTION INDIA PRIVATE LIMITED',
    'STRING FELLAS PRIVATE LIMITED',
    'BLOCKNOMIC TECHNOLOGIES PRIVATE LIMITED',
    'FLATWORLD BOOKS PRIVATE LIMITED',
    'TATA SMARTFOODZ LIMITED',
    'GOARTI LIVESTOCK TECHNOSOLUTIONS PRIVATELIMITED',
    'MCTRANS GLOBAL LOGISTICS PRIVATE LIMITED',
    'AESTHETIC CONCEPT PRIVATE LIMITED',
    'ARBC PRIVATE LIMITED',
    'PROSK SERVICES INDIA PRIVATE LIMITED',
    'GARDLER MANUFACTURING & TECH SERVICES PRIVATE LIMITED',
    'RSP WINGS PRIVATE LIMITED',
    'NANI VIRANI WIND ENERGY PRIVATE LIMITED',
    'SAJOPATI WIRES PRIVATE LIMITED',
    'POSIDON INFRATEL SOLUTIONS PRIVATE LIMITED',
    'LAJWANTI PROPERTIES PRIVATE LIMITED',
    'RTRIO TECHNOLOGIES PRIVATE LIMITED',
    'SIBA ECOM PRIVATE LIMITED',
    'PATEL BEER PRIVATE LIMITED',
    'BVISHAL OIL AND ENERGY LIMITED',
    'AADVIKA INFOTECH (OPC) PRIVATE LIMITED',
    'AMERICA FUJIKURA INDIA PRIVATE LIMITED',
    'ARDENT INFRA EQUIPMENTS PRIVATE LIMITED',
    'GOODWATTS WTE SURAT PRIVATE LIMITED',
    'ZAPBYTES COMMUNICATIONS PRIVATE LIMITED',
    'PARKSLEY GLOBAL PRIVATE LIMITED',
    'NESTAWAY INDIA PRIVATE LIMITED',
    'BN TRAINING PRIVATE LIMITED',
    'HYPHENATE DESIGN & ROBOTICS PRIVATE LIMITED',
    'GLOBAS CITIZENSHIP PROFESSIONALS PRIVATELIMITED',
    'SUMERU GLOBAL SUPPORT SOLUTIONS PRIVATE LIMITED',
    'NURARITY MARKETING PRIVATE LIMITED',
    'TALWIN HR SOLUTIONS PRIVATE LIMITED',
    'STARWARTZ CONSULTING SERVICES PRIVATE LIMITED',
    'SCL HEALTHCARE PRIVATE LIMITED',
    'KIPEKEE AGRO (OPC) PRIVATE LIMITED',
    'GNG AGRITECH & WASTE MANAGEMENT PRIVATE LIMITED',
    'NUNKI MALESIDDESHWARA (NMS) PRODUCER COMPANY LIMITED',
    'WSGU ENGINEERING & CONSTRUCTION PRIVATE LIMITED',
    'ALYTSEE TECHNOLOGIES PRIVATE LIMITED',
    'VALUEATTICS REINSURANCE LIMITED',
    'PITTIE MONEY PRIVATE LIMITED',
    'SOURCENET IT SERVICE PROVIDER PRIVATE LIMITED',
    'PROMERAKI DEVELOPMENTS PRIVATE LIMITED',
    'SIFY INFINIT SPACES LIMITED',
    'ANANTA PHARMACY DISTRIBUTORS PRIVATE LIMITED',
    'DREAMSTER SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'REDLEMON DIGITAL PRIVATE LIMITED',
    'PARVATHI PARAMESHWARA TRANSLOGISTICS PRIVATE LIMITED',
    'CODEBLAZE TECHNOLOGIES PRIVATE LIMITED',
    'VEGANARKE ENTERPRISES PRIVATE LIMITED',
    'FUSION BUILDING MATERIALS (VIZAG) PRIVATE LIMITED',
    'AXPLORE TRAVELPLUS PRIVATE LIMITED',
    'RAVAPAR WIND ENERGY PRIVATE LIMITED',
    'PRULITICS TECHNOLOGIES PRIVATE LIMITED',
    'RRS WEDDING AND EVENTS (OPC) PRIVATE LIMITED',
    'APPSTECH SOLUTION ENTITY PRIVATE LIMITED',
    'NELAMANGALA DEVIHALLI EXPRESSWAY PRIVATELIMITED',
    'FORCE IDENTIFICATION PRIVATE LIMITED',
    'TRATO INDUSTRIES PRIVATE LIMITED',
    'CIAN VISION TECHNOLOGIES PRIVATE LIMITED',
    'SIDDHA CAPITALS LIMITED',
    'FF AGRO TECHNOLOGIES PRIVATE LIMITED',
    'KHCPA CONSULTANCY PRIVATE LIMITED',
    'SANCTUM WEALTH ADVISORS PRIVATE LIMITED',
    'HIMAN CONSULTANTS & ENGINEERS PRIVATE LIMITED',
    'AHAM HOUSING FINANCE PRIVATE LIMITED',
    'AIRESINDIA MOBILITY SOLUTIONS PRIVATE LIMITED',
    'PKT HOLIDAYS PRIVATE LIMITED',
    'NUTRITAP TECHNOLOGIES PRIVATE LIMITED',
    'EXECUTION STUDIO PRIVATE LIMITED',
    'NETRAVATHI ESTATES PRIVATE LIMITED',
    'OMNIPROEDGE SOFTWARE SERVICES PRIVATE LIMITED',
    'ORANGECROSS HOMEHEALTH PRIVATE LIMITED',
    'FNS PRODUCTIONS (OPC) PRIVATE LIMITED',
    'KIDDOS STATIONERY PRIVATE LIMITED',
    'DASSAULT SYSTEMES FOUNDATION',
    'RITAUM INFO SOLUTIONS PRIVATE LIMITED',
    'T3D LABS PRIVATE LIMITED',
    'SAKARIYA MINES & MINERALS PRIVATE LIMITED',
    'GURGAON PAPER MILLS LIMITED',
    'ALGORIN TECHLABS PRIVATE LIMITED',
    'SJF PHILANTHROPIC ORGANISATION',
    'PARIJAT ARTS & MEDIA PRIVATE LIMITED',
    'VIGODI WIND ENERGY PRIVATE LIMITED',
    'VYOMDISK MEDIA PRIVATE LIMITED',
    'ANDROMEDA CONSULTANCY PRIVATE LIMITED',
    'CLEAN MOBILITY SOLUTION (I) PRIVATE LIMITED',
    'CG AGRO PROJECTS PRIVATE LIMITED',
    'NOUVEAU SOFTWARE PRIVATE LIMITED',
    'CLOUD EXPRESS SOLUTIONS PRIVATE LIMITED',
    'VERAMARI TECHNOLOGIES PRIVATE LIMITED',
    'TOUCHCLOUD SYSTEMS PRIVATE LIMITED',
    'GNBTECH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'EREVU VENTURES PRIVATE LIMITED',
    'SMARTSYNC INNOVATIONS PRIVATE LIMITED',
    'LASVIT INDIA PRIVATE LIMITED',
    'FLEXCON INDIA PRIVATE LIMITED',
    'MIS SUPPORT CENTER PRIVATE LIMITED',
    'ROCHE DIABETES CARE INDIA PRIVATE LIMITED',
    'XSPLATFORMS INDIA PRIVATE LIMITED',
    'TRANSWORLD GLOBAL LOGISTICS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'OLETHIA LABS PRIVATE LIMITED',
    'HAPPYSEED INDIA PRIVATE LIMITED',
    'AQUIS SEARCH PRIVATE LIMITED',
    'UNIVERSE CITY MIKAEL (UCM) FOUNDATION OF INDIA',
    'Orion conmerx private limited',
    'Moon light ranch private limited',
    'Incom cables private limited',
    'Bhagirathi developers private limited',
    'Chaudhary labels private limited',
    'V r k consultants private limited',
    'Savera properties private limited',
    'Franco export private limited',
    'Nichiplast india private limited',
    'Knitex india private limited',
    'Dynamic movers india private limited',
    'Candico (i) limited',
    'LAMPSAT MOTORS PRIVATE LIMITED',
    'Pure rice india limited',
    'Indserve infotech private limited',
    'Trend setter promoters private ltd',
    'Sharda containers private limited',
    'Shahji financial services private limited',
    'Vision india consumer elecctronics private limited',
    'Livvel products private limited',
    'Taco consultants private limited',
    'Bihani manufacturing company private limited',
    'Indralok orchards and estates private limited',
    'DYNA WEGMANS SECURITIES LIMITED',
    'Aditya infotech limited',
    'Aadhar financial services limited',
    'Santosh timber trading company limited',
    'Iai industries limited',
    'Dishti industries private limited',
    'Maspar industries private limited',
    'Creative line international private limited',
    'ADWAITH TEXTILES PRIVATE LIMITED',
    'Surya prabha mills private limited',
    'Srivignesh yarns private limited',
    'Meera textiles private limited',
    'Santha spinning mills private limited',
    'Vishnu cotton mills ltd',
    'India spintex limited',
    'Haro-paliwal private limited',
    'S k c fabric impex private limited',
    'Psa silks private limited',
    'Kandhari textile mills private limited',
    'Bodycare international limited.',
    'Sekhani industries private limited',
    'Shashaco chucks pvt ltd',
    'Pws engineers private limited',
    'ASHIM KAR & INDUSTRIES PRIVATE LIMITED',
    'Laxminarayan rayon private limited',
    'Satyam fibres(india)pvt ltd',
    'Shrijee cotton mills limited',
    'Geetanjali textiles industries private limited',
    'Filmlab (i) private limited',
    'Knitcraft apparels international private limited',
    'OSMAT INDIA LIMITED',
    'Rors finance private limited',
    'Weaverly jute mills private limited',
    'Karam thread (india) private limited',
    'Sarla hosiery & apparel private limited',
    'H p doshi clothing private limited',
    'Babathings india private limited',
    'K p exports pvt ltd',
    'Kali fabrics pvt ltd.',
    'Palsana textile park private limited',
    'Lila cement india private limited',
    'SANSKRITI PACKAGING PRIVATE LIMITED',
    'T.j communications private limited',
    'Silver spring spinners india private limited',
    'Gupta exim india private limited',
    'Frontier textiles private limited',
    'Ivory palace private limited',
    'Dalton fashions (india) pvt ltd',
    'Rama spinners pvt. ltd.',
    'Romano fashions private limited',
    'Recliners india private limited',
    'Ultimate fashion maker limited',
    'Bha associates pvt ltd',
    'Prayas exports private limited',
    'Akriti apparels private limited',
    'Kailash packaging private limited.',
    'Alpen fashion & tracht private limited',
    'Prashansa apparels private limited',
    'Muskan garments private limited',
    'Shahi exports private limited',
    'Shapes clothing company private limited',
    'New diamond fabtrends private limited',
    'Jstitch fashion private limited',
    'A.J. Shrink Wrap Private Limited',
    'Meenu creations private limited',
    'Batavia exim private limited',
    'Minerva apparels private limited',
    'Goyal knitwears private limited',
    'REGISTHAN PRIVATE LIMITED',
    'Pentagon garments private limited',
    'SRG APPARELS LIMITED',
    'JANGLOO',
    'LORD',
    'Vikas buildestate private limited',
    'Spas infrastructures private limited',
    'Sri city infrastucture development private limited',
    'Rockstone infrastructure private limited',
    'Khinchi and khatri builders and developers private limited',
    'Ms resizone developers private limited',
    'POOJA CRAFTED HOMES PRIVATE LIMITED',
    'GREEN VALLEY',
    'S CLINIC PRIVATE LIMITED',
    'Vinod medical systems private limited',
    'Jbr advance exam system private limited',
    'UNLIMITED UNNATI PRIVATE LIMITED',
    'Rkkr shiksha foundation',
    'I r multi-media solutions private limited',
    'Bhoruka textiles limited',
    'Vishwaraj sugar industries limited',
    'Indian institute of hardware technology limited',
    'Tanglin developments limited',
    'Cortera software private limited',
    'Sri bhagyalakshmi agro foods private limited',
    'G.m. healthcare private limited',
    'Sysinformation healthcare india private limited',
    'I-point interactive solutions private limited',
    'Hed experts private limited',
    'Palvanjali education private limited',
    'APEX HOSPITAL MANSAROVAR PRIVATE LIMITED',
    'Skylight educare private limited',
    'Vas knowledge growth initiatives private limited',
    'Transcend education private limited',
    'Pasteur healthcare india private limited',
    'VEDANAYAGAM HOSPITAL PRIVATE LIMITED',
    'Gem hospital and research centre private limited',
    'Mullai srinivasam hospitals private limited',
    'FINS NURSING HOME & RESEARCH PVT LTD',
    'Techathene solutions private limited',
    'SIVANTOS INDIA PRIVATE LIMITED',
    'Snap fitness (india) private limited',
    'CAPITALG HEALTHCARE MULTIVENTURES PRIVATE LIMITED',
    'Green well care foundation',
    'Venus diagnostics ltd',
    'VIJAYA DIAGNOSTIC CENTRE LIMITED',
    'Apex laboratories private limited',
    'SANJEEVANI OLD AGE MANAGEMENT ASSOCIATION',
    'Naandi community water services private limited',
    'Derek o brien associates private limited',
    'Pristine natural health and research centre (india) private limited',
    'Baidyanath life sciences private limited',
    'PATNI HEALTHCARE PRIVATE LIMITED',
    'URBAN ENVIRO WASTE MANAGEMENT LIMITED',
    'BASIC CHEMICALS COSMETICS & DYES EXPORT PROMOTION COUNCIL',
    'MASTI HEALTH AND BEAUTY PRIVATE LIMITED',
    'Rajasthan shram sarathi association',
    'Blue nucleus data solutions private limited',
    'Clinicea healthcare india private limited',
    'Asclepius hospitals & health care private limited',
    'Infotainment television private limited',
    'Sacona entertainment india private limited',
    'EXCEL CENTRE HEALTH AND RESEARCH PRIVATE LIMITED',
    'India renal foundation',
    'Flaberry services private limited',
    'L h entertainment company private limited',
    'Mumbai mantra media limited',
    'Sarb multiplex private limited',
    'Ashwani entertainment private limited',
    'The cricket club of india limited',
    'Nikita moulds private limited',
    'Samarth fablon private limited',
    'Sigma scientific glass private limited',
    'T k steel rolling mills private limited',
    'Vinayaka alloys private limited',
    'Jaybanas metals private limited',
    'R.g. loha private limited',
    'Jayachandran alloys private limited',
    'Rungta mines limited',
    'Uma polymers limited',
    'Sethia polymers private limited',
    'India seah precision metal private limited',
    'Matangi polymers and products private limited',
    'Diamond metal screens private limited',
    'Tri-millennial design and service engineers private limited',
    'KUMINEX STEELS PRIVATE LIMITED',
    'Holostik multipack private limited',
    'SEIKI FINVEST PRIVATE LIMITED',
    'S s electro mech engineers pvt ltd',
    'Nipha steels ltd',
    'Nabajivan steels pvt. ltd.',
    'Rajeshwari metpro private limited',
    'Mohini metals and alloys industries pvt ltd',
    'Satellite metals and tubes limited',
    'COASTAL WIRE ROPES PRIVATE LIMITED',
    'Ganga extrusion private limited',
    'Associated aluminium industries private limited.',
    'Fair field pressings pvt ltd',
    'CHETAN METALS PRIVATE LIMITED',
    'N.s.rathinam & sons private limited',
    'Kuber foundry pvt ltd',
    'MAP IRON & STEEL COMPANY LIMITED',
    'Shree omkar jewellers private limited',
    'Lbh expansion joints india private limited',
    'Alpump limited',
    'Orient components private limited',
    'Wesman simpson technologies private limited',
    'MOHIT ISPAT PRIVATE LIMITED',
    'Navyug ispat industries limited',
    'Pristine commercials private limited',
    'TATA STEEL ADVANCED MATERIALS LIMITED',
    'Jr metal chennai limited',
    'Shree hari sponge private limited',
    'Nezone tubes (assam) limited',
    'Nice ceramic private limited',
    'Gaurav ceramics private limited',
    'Himani steels pvt ltd',
    'Vaman prestressing company private limited',
    'Tapi prestressed products limited',
    'Sidhi vinayak logistics private limited',
    'Flowtech industrial projects private limited',
    'MEDIVAC SURGICAL PRIVATE LIMITED',
    'SAKAR INDUSTRIES PRIVATE LIMITED',
    'Nezone ispat tubes limited',
    'Bhunit engineering co. private limited',
    'SUNSHINE FASTECH LIMITED',
    'Sudhir power projects limited',
    'Holostik infrastructure private limited.',
    'Dove real estate private limited',
    'Aakrusht realtors private limited',
    'Catalyst2xcelerate success coaching private limited',
    'Graphene semiconductor services private limited',
    'Smasung agro products (india) private limited',
    'Vks finvest private limited',
    'Productive technologies private limited',
    'Retail hub solutions limited',
    'Orasi media private limited',
    'Majortrend capital private limited',
    'Nirmal lifestylecity services private limited',
    'PGI TECHNOLOGIES PRIVATE LIMITED',
    'Unique industrial packings private limited',
    'Manuj enterprises private limited',
    'One dream villas private limited',
    'Cps foods private limited',
    'Edgetech automation private limited',
    'Worldwide small diamonds manufacturing private limited',
    'Phoenix worldtrans private limited',
    'Selective realtors private limited',
    'MKM LUXE LUDHIANA PRIVATE LIMITED',
    'Evisions teleinfra private limited',
    'Dometech art private limited',
    'Diehl metal india private limited',
    'Share my route cab hire solutions private limited',
    'Kedar borgaonkar securities private limited',
    'Executive81 hr solutions private limited',
    'Dheya career mentors (india) private limited',
    'Servepriya trading and builders private limited',
    'Devisons private limited',
    'Sharp corp limited',
    'Pious water private limited',
    'Lakhani jordan engineers and architects private limited',
    'Neelanchal aquafarms private limited',
    'Amil mining india private limited',
    'Avt holdings private limited',
    'N & D COMMUNICATIONS PRIVATE LIMITED',
    'Paramount digital business systems private limited',
    'Success promos & events private limited',
    'Ds scientific solutions private limited',
    'Ribo industries private limited',
    'Vertex interiors private limited',
    'Actlink logistics private limited',
    'EQUIPR TECHNOLOGIES LIMITED',
    'BRIDGE PEOPLE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Affigenix biosolutions private limited',
    'House of kyrav private limited',
    'Sai baba business machines private limited',
    'Manam dental hospitals private limited',
    'Kalki automations private limited',
    'Texvalley weekly market limited',
    'Texvalley market limited',
    'Gatrad cal-test laboratories and research private limited',
    'Zenica cars india private limited',
    'Innotech engineering consult private limited',
    'Airtron consulting engineers private limited',
    'Jobskills solutions private limited',
    'Aikat management services private limited',
    'Torero corporation private limited',
    'Magnamind ventures private limited',
    'Apm infrastructure private limited',
    'Winsum wears private limited',
    'MANGONEL TRADERS PRIVATE LIMITED',
    'Zodiac buildcons private limited',
    'Vaibhav geospatial technologies private limited',
    'Purple hr consulting private limited',
    'Vensri multitech private limited',
    'Fireball securitas systems private limited',
    'Onestep corporate solutions private limited',
    'Kunal air charter private limited',
    'Mukundhaa network private limited',
    'Qrt 24x7 security private limited',
    'Security and personnel services private limited',
    'Amdoshi wangani services private limited',
    'Pers enterprises private limited',
    'Lexicon vanijya private limited',
    'Alliance packagings private limited',
    'Champion seals (india) private limited',
    'Green packaging industries private limited',
    'Diamond ad-ventures india limited',
    'Kripal earth & environment technologies private limited',
    'Comsol energy private limited',
    'Ava cholayil health care private limited',
    'Shreeya warehousing and logistics private limited',
    'Apricot consulting private limited',
    'Interport multimodal private limited',
    'Hinge tech india private limited',
    'Greenpay outsourcing services private limited',
    'Cinzac engineers (india) private limited',
    'Devaayanam network private limited',
    'R b gears private limited',
    'STUDIOKOOK PRIVATE LIMITED',
    'Vm edulife private limited',
    'Sanwree bawree fashions private limited',
    'Kesseboehmer interior solutions (india) private limited',
    'A p management consultants private limited',
    'Knr ads private limited',
    'Oprs enterprises private limited',
    'Symphony vyapaar private limited',
    'Tanushree marketing private limited',
    'Headstrong services india private limited',
    'Special spring (india) pvt ltd',
    'RAJDARBAR OVERSEAS PRIVATE LIMITED',
    'Opv packaging private limited',
    'Bhartiya international sez limited',
    'Arrcom fine arts private limited',
    'Fintellect consultancy services private limited',
    'Haryana petrochemicals limited',
    'Radiant health care (india) private limited',
    'P. b. tradelink private limited',
    'Amrapali biotech india private limited.',
    'Nanoway engineering private limited',
    'Western chlorides and chemicals private limited',
    'Crish metal works private limited',
    'Cospha care chemicals private limited',
    'Multichem specialities private limited',
    'Bioderm therapeutics private limited',
    'FINECHEM INDUSTRIES PRIVATE LIMITED',
    'Suvarna additives private limited',
    'Petro batis chemicals & equipment private limited',
    'Ar med chem private limited',
    'Molecules drugs and research laboratory private limited',
    'Molclone labs private limited',
    'Bhowmik dyeing and bleaching private limited',
    'Anand chem industries pvt ltd',
    'Hari orgochem pvt ltd',
    'SINKHAI VENTURES PRIVATE LIMITED',
    'DHVANI TEREFABS EXPORTS Private Limited',
    'Pemco process equipments (india) private limited',
    'Patchems p ltd',
    'CHAMPIONX DAI-ICHI INDIA PRIVATE LIMITED',
    'Phthalo colours and chemicals (india) limited',
    'Kubo chemicals pvt ltd',
    'Nesan colours private limited',
    'Karnataka terpene chemicals private limited',
    'Popawala chemicals private limited',
    'Sanosil biotech private limited',
    'Newpark drilling fluids india private limited',
    'S b organics ltd',
    'Jay ambe gowri chem limited',
    'Poona fine chem private limited',
    'MAHALAXMI FABRIC MILLS PRIVATE LIMITED',
    'CTX LIFESCIENCES PRIVATE LIMITED',
    'Samira chemicals private limited',
    'Aromatics india private limited',
    'Novo thermoset private limited',
    'Stahl india private limited',
    'BRAHMAPUTRA BIOCHEM PRIVATE LIMITED',
    'Vimax crop science limited',
    'Auro impex pvt ltd',
    'Emrald biofertilizers private limited',
    'Spin-tech fittings india private limited',
    'ARAYMOND INDIA PRIVATE LIMITED',
    'Pearim pharmaceuticals private limited',
    'Triochem laboratories pvt ltd',
    'Phoenix inns private limited',
    'Pharmed limited',
    'Asvik pharma and chemicals private limited',
    'D vijay pharma private limited',
    'Radian chemical products private limited',
    'Shri laxmi surfactants private limited',
    'Adven biotech private limited',
    'LG CHEM LIFE SCIENCES INDIA PRIVATE LIMITED',
    'May and baker pharmaceuticals limited',
    'Sunpure extracts private limited',
    'Harson labs pvt ltd',
    'Rangani engineering private limited',
    'Shelter pharmacy private limited',
    'RECKITT BENCKISER HEALTHCARE INDIA Private Limited',
    'Sance laboratories private limited',
    'Brilliant polymers private limited',
    'Chimera gentec private limited',
    'Blackbryont pharmaceuticals private limited',
    'SYNOVIA LIFE SCIENCES PRIVATE LIMITED',
    'NOVA SUD PHARMACEUTICALS PRIVATE LIMITED',
    'Sai sridhar pharma private limited',
    'Vivobio discovery services private limited',
    'Serlentis research private limited',
    'Surya herbal limited',
    'Diamond remedies private limited',
    'Skymap pharmaceuticals private limited',
    'Radix biotech private limited',
    'Custom capsules private limited',
    'Jubilee medicare limited',
    'Vimal crop care private limited',
    'Janak chem private limited',
    'Globrin healthcare private limited',
    'Novacare drug specialities private limited',
    'Kt cimpex private limited',
    'VISAKHA PHARMACITY LIMITED',
    'SHILPA THERAPEUTICS PRIVATE LIMITED',
    'Karnani laboratories limited',
    'Origo cosmeceuticals private limited',
    'Veeprho laboratories private limited',
    'HEART CARE LIFESCIENCE PRIVATE LIMITED',
    'Ark golden india private limited',
    'White cliffs hair studio private limited',
    'T m v aromatics pvt ltd',
    'GOPAL GLASS WORKS LIMITED',
    'Spectrum auxi-chem private limited',
    'Olpherts pvt ltd',
    'Citro calcoat private limited',
    'Chettinad enterprises private limited',
    'Vvf (india) limited',
    'Antique marbonite private limited',
    'Orchid paints private limited',
    'Npc consumer products limited',
    'K.a.prevulcanised latex private limited',
    'SOL INDIA PRIVATE LIMITED',
    'DIMPLE CHEMICALS & SERVICES PRIVATE LIMITED',
    'Shalx foam private limited',
    'Prestige bidadi holdings private limited',
    'Nalukettu builders private limited',
    'Oceanic infrastructure park private limited',
    'P-span construction technologies private limited',
    'Viswanathan constructions private limited',
    'Unidesign builders and developers private limited',
    'HEMPS INFRASTRUCTURE PRIVATE LIMITED',
    'Patel bridge nirman private limited',
    'Mantri geo structures private limited',
    'K.s.t. constructions private limited',
    'SONAWALA & MEHTA CONSTRUCTIONS PRIVATE LIMITED',
    'Gerarie enterprises and developers private limited',
    'Mahavir spinning mills private limited',
    'Kumar properties and real estate private limited',
    'Navbharat buildcon private limited',
    'Tirupati complexes private limited',
    'Usha breco limited',
    'Dholera infrastructure private ltd',
    'Patel highway management private limited',
    'Meehit engineering private limited',
    'S g infrastructure private limited',
    'Spaacio conceptions private limited',
    'Wizard infraprojects private limited',
    'Naina infraprojects developers private limited',
    'Bombay city development corporation private limited',
    'XENDER ENTERPRISE PRIVATE LIMITED',
    'Sanco estates and farms private limited',
    'Prince foundations limited',
    'Ten square realty private limited',
    'Forum shopping centres private limited',
    'Transstroy hoskote-dobbaspet tollways private limited',
    'Transstroy bhopal-berasia-sironj tollways private limited',
    'Mitul construction private limited',
    'Clover realty and infrastructure private limited',
    'Cassini projects private limited.',
    'Bhumiraj infrastructure private limited',
    'Shree infra properties private limited',
    'Southern engineering & enterprises madras private limited',
    'Iconet communication private limited',
    'Impact properties pvt ltd',
    'Gangwal developers private limited',
    'SRI KRISHNA SWEETS GLOBAL PRIVATE LIMITED',
    'Cg developers india private limited',
    'Empire landcon private limited',
    'Tushar buildhome private limited',
    'Manu colonizers private limited',
    'Star landbase private limited',
    'Toonga real estate private limited',
    'Goyal infraprojects private limited',
    'Red sand builder & developer private limited',
    'CERAPAVE CERAMICS PRIVATE LIMITED',
    'Trinity prime business solutions private limited',
    'SHIV KRIPA BUILD ESTATE PRIVATE LIMITED',
    '21 knots design & consulting private limited',
    'Techops buildcon private limited',
    'Raj infrastructural technologies (india) private limited',
    'Silver jubilee infrastructure limited',
    'Rohan rajdeep toll roads limited',
    'Raj infrastructure private limited',
    'FACILITY AND MAINTENANCE SERVICES PRIVATE LIMITED',
    'Chennai elevated tollway limited',
    'Pillai heights private limited',
    'Transstroy bhopal-biaora tollways private limited',
    'Adroit infoactive services private limited',
    'Marathon builcons private limited',
    'Skil shipyard holdings private limited',
    'World electrical hub private limited',
    'EDISONS INFRAPOWER & MULTIVENTURES PRIVATE LIMITED',
    'Sairung developers and promoters private limited',
    'Transstroy obedullaganj-betul tollways private limited',
    'Fabtech building systems private limited',
    'Watertec (india) private limited',
    'Stress concrete products pvt ltd',
    'Simplexprojects road and highway constructions pvt ltd',
    'Myscape properties private limited',
    'EMPRESS INFRA PROJECTS PRIVATE LIMITED',
    'Geoworks realty private limited',
    'Blockbuster united services private limited',
    'SEVEN STARS RESTAURANTS PRIVATE LIMITED',
    'Portrait infrastructure & developers private limited',
    'Wellworth housing private limited',
    'Raj realtech private limited',
    'Aveda ventures private limited',
    'Uday buildwell private limited',
    'Maniveera structure private limited',
    'Euphoria sports city private limited',
    'Vascroft infratech private limited',
    'Hollysys automation india private limited',
    'SHRI GAUTAM AUTOMOTIVE PRIVATE LIMITED',
    'Flower boom builders private limited',
    'Neoland projects private limited',
    'Ngv infrastructures private limited',
    'Sagista realty advisors private limited',
    'Koyna realty private limited',
    'Spr construction private limited',
    'Kk lifespaces private limited',
    'Aryabhata infrastructure and hospitality private limited',
    'Transstroy north cargo berth port private limited',
    'Sea hawk housing private limited',
    'Adarsh line accessories private limited',
    'Orissa steel expressway private limited',
    'Shree sai power control private limited',
    'Raj marg private limited',
    'KARVY REALTY & SERVICES LIMITED',
    'S. v. finvest private limited',
    'Dharmesh constructions private limited',
    'Kapcon builders and developers private limited',
    'Si investments and broking private limited',
    'Gepl commodities private limited',
    'Goyal capital services (india) private limited',
    'Suvision holdings private limited',
    'MOAT CONSULTANCY SERVICES PRIVATE LIMITED',
    'New commercial investment and trading co ltd',
    'Principal investments private limited',
    'Cade realty private limited',
    'Violet properties private limited',
    'Radiant premises private limited',
    'Sig properties private limited',
    'Konkan promoters private limited',
    'Contura trading co pvt ltd',
    'Seel investment private limited',
    'Hassomal and sons holdings private limited',
    'Parshvanath share broking private limited',
    'Daksh share brokers private limited',
    'Preetam forex private limited',
    'Gee city builders private limited',
    'Csj infrastructure private limited.',
    'Sigmawamco infratech limited',
    'Vishal land scapings private limited',
    'Strategic projects and technical services private limited',
    'Wealth managers (india) private limited',
    'Mehak infrastructure private limited',
    'Grands infrastructure private limited',
    'Fiducial insurance brokers india private limited',
    'Apeejay insurance broking services private limited',
    'Resource infratech private limited',
    'Mahendra infratech private limited',
    'Richmond real estate private limited',
    'Rhiti infrastructure private limited',
    'Skynor properties private limited',
    'Ravi real estate developers private limited',
    'Pune-dynasty projects private limtied',
    'Harmonious softech private limited',
    'Financial beam consultancy private limited',
    'Micrograam social development foundation',
    'Nahar design & development private limited',
    'SHREE NAMAN DEVELOPERS Private Limited',
    'Am realty private limited',
    'Tuscany properties private limited',
    'Simone poonawalla constructions and stud private limited',
    'Marda estates private limited',
    'Ffc landmark private limited',
    'Seawoods estates limited',
    'Bp wealth management private limited',
    'GEM BUILDHOMES PRIVATE LIMITED',
    'Radiance real estate and investments private limited',
    'Gepl investment advisors private limited',
    'Swad property private limited',
    'J. h. buildcon private limited',
    'Colorful estates private limited',
    'Globus realcon private limited',
    'Swastik shelters private limited',
    'Enable property consultants private limited',
    'Dhara realtech private limited',
    'Anzera properties private limited',
    'Pushpanjali estates private limited',
    'Inspire realtors (india) private limited',
    'Mirones builders and developers private limited',
    'Suman property pvt.ltd.',
    'Shivalik estates pvt. ltd.',
    'Kaveri finvest private limited',
    'Arihant kutir private limited',
    'Keshav priya homes private limited',
    'Eden realty ventures private limited',
    'Crescent power limited',
    'Renman & kays properties private limited',
    'Ratnawali infrastructure private limited',
    'Vav properties pvt ltd',
    'Derby properties pvt ltd',
    'Derby realty private limited',
    'Chiron commodities trading company private limited',
    'Mgr estates private limited',
    'Vajreshwari estates private limited',
    'Silvex realty private limited',
    'Kapidhawaja realestate private limited',
    'Bucon infratech private limited',
    'Dlf city centre limited',
    'Neelkamal realtors and builders private limited',
    'Skyline living private limited',
    'Sahara green shelter private limited',
    'Sahara metro estates private limited',
    'Sahara prime realtors private limited',
    'Sahara primedream development private limited',
    'Nisarga dhama estates private limited',
    'D.a. developers private limited',
    'Nava vishwa sashi vijaya krishna properties private limited',
    'Futurise builders and developers private limited',
    'Amun builders and developers private limited',
    'Weizmann corporate services limited',
    'Shri siddharth developers & constructions private limited',
    'Nirmal lifestyle city development corporation private limited',
    'Emnet infraventures private limited',
    'Vee real estates private limited',
    'Acme avenue infrastructure private limited',
    'Sathvik infrastructure and property developers private limited',
    'Rosewood developers private limited',
    'Selva developers private limited',
    'Tristar creators private limited',
    'Blue marine builders private limited',
    'Phoenix it city private limited',
    'Ganpati fin-lease private limited',
    'Jharokha soft furnishings private limited',
    'Ms technology private limited',
    'Badhwar universal constructors private limited',
    'Safe speed carriers private limited',
    'Gu bpo india private limited',
    'Hillview properties private limited',
    'Ovees consultancy services private limited',
    'Tapti farms private limited',
    'Bajaj capital financial services limited',
    'Servoll enterprises private limited',
    'Sector access people engagement private limited',
    'ANGLIAN INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED',
    'Ras developments private limited',
    'Sequence apartments private limited',
    'Saksham bharat skills limited',
    'Ideation design studio private limited',
    'Neelam thread private limited',
    'LUMAX INTEGRATED VENTURES PRIVATE LIMITED',
    'Magnum maintenance services private limited',
    'Sawhney india private limited',
    'A s malhotra and associates private limited',
    'Ans designs private limited',
    'Niche corporate advisors private limited',
    'Max solution private limited',
    'Moradabad design & consulting private limited',
    'Efacec india private limited',
    'Fenace auto limited',
    'POLESTAR TECHSERVE PRIVATE LIMITED',
    'Analyz research solutions private limited',
    'Media backoffice india private limited',
    'LIFESIGNALS INDIA PRIVATE LIMITED',
    'Bsc interiors private limited',
    'Avant garde healthcare engg. solutions private limited',
    'Suchir lighting exports private limited',
    'Rhiti msd alamode private limited',
    'Vectoscalar technologies private limited',
    'Santhigram kerala ayurvedic company limited',
    'Sunlit electro controls private limited',
    'ENDRESS+HAUSER (INDIA) AUTOMATION INSTRUMENTATION PRIVATE LIMITED',
    'Enstreet technologies private limited',
    'Apollo energy company limited',
    'Divine stores limited',
    'Yka media private limited',
    'Brite neonsigns private limited',
    'Fortuneight private limited',
    'AG&P INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'Pyramid-eservices private limited',
    'Aaxis nano technologies private limited',
    'NYAASA SERVICES PRIVATE LIMITED',
    'JSW MANGALORE CONTAINER TERMINAL PRIVATELIMITED',
    'Sigma inspection and testing private limited',
    'OXIGEN ONLINE SERVICES (INDIA) PRIVATE LIMITED',
    'Krishiv consultancy services private limited',
    'Super shine cleaning services private limited',
    'Eternal management services private limited',
    'Genext international private limited',
    'Leehan retails private limited',
    'Maven resources private limited',
    'VEDANSH INFRAENERGY PRIVATE LIMITED',
    'Mint commodity private limited',
    'Achievers hr solutions private limited',
    '4semi technology india private limited',
    'Carbon clean solutions private limited',
    'Perennial designs international private limited',
    'Hrfort manpower services private limited',
    'Coromandel ship management private limited',
    'Patson legal knowledge process private limited',
    'Ensemblon automation design and entertainment private limited',
    'Tesla electric and engineering (india) private limited',
    'Zoomrx healthcare technology solutions private limited',
    'Accesspeople solutions india private limited',
    'Protocol ten digital marcom private limited',
    'Multi portfolio business ventures private limited',
    'Ampaq technologies private limited',
    'P f p services private limited',
    'Tis labs private limited',
    'Asansol astha it projects private limited',
    'Quest offices private limited',
    'Arunavati industries private limited',
    'Aras business ventures private limited',
    'Baltimore aircoil india private limited',
    'DAVADOST PHARMA PRIVATE LIMITED',
    'Support elders private limited',
    'Jaiet aircon private limited',
    'Kriestall solvochem private limited',
    'Hexa technocraft (india) private limited',
    'Sumika polymer compounds (india) private limited',
    'Innovasia media solutions private limited',
    'Transformation training services private limited',
    'Lefutura healthcare products private limited',
    'DIKSHA CORPORATE SERVICES PRIVATE LIMITED',
    'Omsai professonal detective and security services private limited',
    'Make easy support services private limited',
    'Svs guarding services private limited',
    'Envisage mercantile private limited',
    'Purv films private limited',
    'Namoshivam commosales private limited',
    'Ikfm management services private limited',
    'Paramount secutors private limited',
    'Denzong leisure private limited',
    'Relbel protection india private limited',
    'R.s. publications private limited',
    'Jeevan times publications private limited',
    'A.M. FASHIONS (INDIA) PRIVATE LIMITED',
    'Hindustan signagess private limited',
    'Little yellow beetle media private limited',
    'Tia media private limited',
    'New prabhat publications pvt ltd',
    'SCARECROW M&C SAATCHI LIMITED',
    'Bombay master printers association',
    'Varnaa silk industries private limited',
    'Vns accessories private limited',
    'Amg printers private limited',
    'E-SYSTEMIZER TECH PRIVATE LIMITED',
    'Sd garments private limited',
    'Sns starch limited',
    'Eastern trading company crewels private limited',
    'S d s stationers private limited',
    'Eskay flexible packaging industries pvt ltd',
    'Sangam solvent extracts limited',
    'BUTYFUL PRODUCTS & SERVICES PRIVATE LIMITED',
    'Manvik packaging private limited',
    'Maple publications private limited',
    'R r hosiery private limited',
    'Leen fashions private limited',
    'Wikas printing and carriers private limited',
    'Gnanam films private limited',
    'Sigma scan systems pvt.ltd.',
    'Eric apparel private limited',
    'Esteem bio fuel private limited',
    'Mohta hydroquip private limited',
    'BIRLA CARBON INDIA PRIVATE LIMITED',
    'Pharos media & publishing private limited',
    'Chhabra syncotex private limited',
    'Surabhi publishing house private limited',
    'Ied communications limited',
    'Shree ganesh print-fab private limited',
    'JAIPUR TEXFAB PRIVATE LIMITED',
    'Tectyl oil and chemicals (india) private limited',
    'Chemiloids life sciences private limited',
    'Universal oilfield chemicals private limited',
    'Powergrace industries limited',
    'Jps tex world private limited',
    'Clothesline & colours apparels private limited',
    'Ventura products private limited',
    'Amritsar times private limited',
    'Jotis green chemicals private limited',
    'Bdj oxides private limited',
    'Chennai expo prints private limited',
    'Belami fine chemicals pvt ltd',
    'Turbhe chemicals private limited',
    'Roop rasayan industries private limited',
    'Kwality labels private limited',
    'Focus medica india private limited',
    'SHIVA DYESTUFF PRIVATE LIMITED',
    'Performance polymers and chemicals private limited',
    'Dorling kindersley publishing private limited',
    'Spenta multimedia private limited',
    'Manipal media network limited',
    'Amgen technology private limited',
    'Dhumketu chemical industries private limited',
    'ALR LABS PRIVATE LIMITED',
    'Trushape precision castings private limited',
    'Worldwide records limited',
    'Shlokaa creations private limited',
    'PIXSTORY INTERFACE NETWORK & IT PRIVATE LIMITED',
    'Swastik lubricants private limited',
    'ATLAS LIFE SCIENCES PRIVATE LIMITED',
    'Abhajay trade and commerce pvt ltd',
    'PIDILITE VENTURES PRIVATE LIMITED',
    'Abhijeet dies and tools private limited',
    'SUNRISE METACHEM INDIA Private Limited',
    'VISHRUDH ORGANICS PRIVATE LIMITED',
    'Deccan fine chemicals (india) private limited',
    'Axon drugs private limited',
    'Caxton offset private limited',
    'Stypack petro products private limited',
    'U like creative private limited',
    'Lokmangal bio-tech private limited',
    'Amazon papyrus chemicals private limited',
    'Synergy petrochem and minerals private limited',
    'Evergreen fincap market pvt. ltd.',
    'Chandawat udyog (cylinders) limited',
    'Indo australian hose manufacturing private limited',
    'Confidence technologies private limited',
    'Sf dyes private limited',
    'Sf chemical industries private limited',
    'Megi agro chem limited',
    'CHEMOLIN DYES AND CHEMICALS PRIVATE LIMITED',
    'Trans yamuna fertilizers private limited',
    'Silky paints private limited',
    'MANIRATNA INDUSTRIES PRIVATE LIMITED',
    'Nandan impex pvt ltd',
    'ENVISION SCIENTIFIC PRIVATE LIMITED',
    'Anant pharmaceuticals private limited',
    'Maithri drugs private limited',
    'Cibien drugs and pharmaceuticals pvt ltd',
    'Shreenath orgochem private limited',
    'INSPIRA LEISURE AND HOSPITALITY PRIVATE LIMITED',
    'Ishijas chemicals pvt ltd',
    'Mukund export private limited',
    'VARDHAMAN DYE-STUFF INDUSTRIES PRIVATE LIMITED',
    'SARA RESEARCH & DEVELOPMENT CENTRE PRIVATE LIMITED',
    'Promag foundations and structures private limited',
    'The rajasthan construction co pvt ltd',
    'Tulsiani builders and textiles private limited',
    'M n p construction private limited',
    'Shiraz builders private limited',
    'Sita real estate developers private limited',
    'Vashupunjay construction private limited',
    'Vimalnath properties private limited',
    'Nami properties private limited',
    'Ss buildcon private limited',
    'Hemko patents development private limited',
    'Institute for lean construction excellence',
    'Viceroy builders private limited',
    'FLYNT ELECTRIC PRIVATE LIMITED',
    'Indo african technoconstructions private limited',
    'Phoenix spaces private limited',
    'Khetan constructions private limited',
    'Smg estates private limited',
    'Spectrum buildtech limited',
    'Accent infrastructure private limited',
    'Anjali buildcon private limited',
    'Milestone buildcon private limited',
    'Jss properties private limited',
    'Shree vaastu buildwell private limited',
    'J. r. sood & co. private limited',
    'Nehru place hotels and real estates private limited',
    'Universal building products private limited',
    'CADENCE BUILDERS & CONSTRUCTIONS PRIVATE LIMITED',
    'Erasma builders & developers private limited',
    'Faye builders & constructions private limited',
    'Calista real estates private limited',
    'D e s i power (kosi) private limited',
    'Infraplan engineering services private limited',
    'Hassab realty private limited',
    'Rianne realities pvt ltd',
    'Shree naman housing private limited',
    'Loonkar developers private limited',
    'Smaran developers private limited',
    'Kvs realtech private limited',
    'Indicon constructions private limited',
    'G.v properties private limited',
    'Rijuta properties private limited',
    'Vdb property ventures private limited',
    'Zodiac developers private limited',
    'Varun developers private limited',
    'Mvl realty private limited',
    'Ratan j. batliboi - consultants private limited',
    'Citron infraprojects limited',
    'Viva ssakash developers private limited',
    'Acg real estate private limited',
    'Goyal complex pvt ltd',
    'Apple chemie india private limited',
    'Acme shelters pvt ltd',
    'Apnaghar realtors private limited',
    'Harsh unique row house developers private limited',
    'Homely complex private limited',
    'Vn realtors private limited',
    'Cirrus tech developers private limited',
    'Shree sai city promotors and developers private limited',
    'S m buildwell private limited',
    'Intellectual property protection organisation pvt ltd',
    'Grass field fire estate private limited',
    'Grass field fire land developers private limited',
    'Grass field fire propcon private limited',
    'Devna commercial complex private limited',
    'Siwal infracon private limited',
    'Om aastha construction private limited',
    'SRMPR CONSTRUCTION PRIVATE LIMITED',
    'Asv constructions private limited',
    'Ruby manoharan property developers private limited',
    'Ultra readymix concrete private limited',
    'Edifixio india private limited',
    'K.b.s. housing private limited',
    'CHAVALA VENTURES PRIVATE LIMITED',
    'Fairland projects private limited',
    'Sparrowhawk international channels india private limited',
    'Venture infrastructure limited',
    'Laxmi shops and warehouses limited',
    'Shriline properties private limited',
    'Vdb whitefield development private limited',
    'Deccan structures private limited',
    'Fortunegate mansions private limited',
    'Ansam india constructions and developers private limited',
    'Concrete erectors private limited',
    'Machhar industries limited',
    'Vista homes private limited',
    'Viva saphale realtors private limited',
    'Viva umroli land developers private limited',
    'Rohan rajdeep highways limited',
    'Best realinfra private limited',
    'Dsk southern projects private limited',
    'Sarvagya infrastructure private limited',
    'Winajes constructions india private limited',
    'Creative infocity limited',
    'Falshruti infrastructures private limited',
    'Faith ecospace private limited',
    'Shree swastik organisor private limited',
    'Jmj builders private limited',
    'Hombale constructions and estates private limited',
    'SATYAGIRI VENTURES PRIVATE LIMITED',
    'Viraj infrastructure limited',
    'Taurian infrastructure private limited',
    'Star superstructures private limited',
    'Fasqua investment private limited',
    'Asnani stock broker private limited',
    'Aishwarya and co. p ltd',
    'Anush commodities private limited',
    'Kagrana management consultancy private limited',
    'Arabesque investments pvt ltd',
    'Pn-nj industries private limited',
    'HIMALAYA TRADE & FINANCE PVT LTD',
    'Swift financial results ltd',
    'Calcutta fintrade pvt ltd',
    'Lotus capital financial services limited',
    'Ulike stock & securities pvt ltd',
    'Marco finance pvt.ltd.',
    'ALANKIT FOREX INDIA LIMITED',
    'Punam stock brokings private limited',
    'Indent investments private limited',
    'Rubicon securities private limited',
    'Headlines financial services private limited',
    'Gandhi securities and investment private limited',
    'Amrapali aadya trading and investment private limited',
    'Ravijyot finance and leasing private limited',
    'Mandava investments private limited',
    'SPARTAN BUSINESS SERVICES PRIVATE LIMITED',
    'Htc financial intermediary services private limited',
    'Shubhmangal portfolio private limited',
    'Thar share brokers private limited',
    'Satyam prima capital private limited',
    'Canpac trends private limited',
    'Akbar insurance agency services private limited',
    'Suyog insurance advisors private limited',
    'APOORVA MANPOWER SERVICES PRIVATE LIMITED',
    'Shanteri investment private limited',
    'SONEGA TRADES & INVESTMENTS PRIVATE LIMITED',
    'Sudha habitat private limited',
    'Nrk investments priavte limited',
    'Trinity consortium development private limited',
    'Earthspace realtors (india) private limited',
    'Aptcon developers private limited',
    'Reclamation properties (india) private limited',
    'G4 investments (india) private limited',
    'Medoc premises private limited',
    'Kishan lall & sons (udyog) pvt ltd',
    '29ESTATE SOLUTIONS PRIVATE LIMITED',
    'Organised investments ltd.',
    'Kamdhenu fincap limited',
    'Batlivala & karani securities india private limited',
    'Stargate india finance and investment management private limited',
    'Rikhav financial services private limited',
    'Verano builders & developers private limited',
    'Pragati infra solutions private limited',
    'Gaurisuta buildhome private limited',
    'Gaurisuta infrasolution private limited',
    'Pramaki finvest private limited',
    'Pinnacle superstructures private limited',
    'Ds realty and realtor private limited',
    'Tangier capital management private limited',
    'Venket lakshmi investments private limited',
    'Suvidha insurance broking private limited',
    'Argosy finvest private limited',
    'Dalal and broacha stock broking private limited',
    'Jamnadas virji shares and stock brokers private limited',
    'Omana estate private limited',
    'Talera enterprises private limited',
    'Girik wealth advisors private limited',
    'Adarsh wealth ventures limited',
    'Devakar investment and trading company pvt ltd',
    'Mahakali capital investments services private limited',
    'Khush securities private limited',
    'NEXNOS PHARMA PRIVATE LIMITED',
    'KIRPALANEY & ASSOCIATES (ENGINEERS) PRIVATE LIMITED',
    'Poojaa foundation private limited',
    'J s development sourcing advisors private limited',
    'Alf construction private limited',
    'Patiswara credit services private limited',
    'Propstation realty private limited',
    'Pulak properties ltd',
    'Akshat estates pvt ltd',
    'GPT HEALTHCARE LIMITED',
    'Hartal builders and developers private limited',
    'Whitefield estates private limited',
    'Sand properties private limited',
    'Greenfest infracon private limited',
    'Choice trading corporation private limited',
    'Great india estates private limited',
    'Symetric realties private limited',
    'Promag realtors and developers private limited',
    'Narmada estates pvt.ltd.',
    'Angamaly plantations and properties private limited',
    'Metro city properties pvt ltd',
    'Ambey niwas private limited',
    'Amit realtors private limited',
    'Shuko real estate private limited',
    'Muktha housing and estates private limited',
    'Centum properties private limited',
    'Provyoo india private limited',
    'Ajala properties private limited',
    'Prerona infrastructure private limited',
    'Shree shyamkamal estates pvt. ltd.',
    'Hestia realtors private limited',
    'Kesar procon street priave limited',
    'Arya buildwell private limited',
    'Victory infratech private limited',
    'Dra developers & projects private limited',
    'Sobha contracting private limited',
    'Leanpitch technologies private limited',
    'Prolore search marketing private limited',
    'Salar online wholesale private limited',
    'Tesscorn technologies private limited',
    'Sys.n consultants private limited',
    'Sharma strips private limited',
    'Ravi promoters private limited',
    'Concert care india private limited',
    'Religent global ventures private limited',
    'Algo chips private limited',
    'Efeco services private limited',
    'Nafex bureau private limited',
    'Ra creative insight consulting private limited',
    'NACSTERGEN AI PRIVATE LIMITED',
    'Talent bee consulting private limited',
    'Jbm builders private limited',
    'YEMOTA SYSTEMS & SOLUTIONS PRIVATE LIMITED',
    'Chinay logistics private limited',
    'Pride shipping agencies private limited',
    'Sambhav food processors private limited',
    'Va friendship solar park private limited',
    'Newage fire protection engineers private limited',
    'Trpl resources & consultancy services private limited',
    'Krish multitrade private limited',
    'Eternal hr services private limited',
    'Va infosolutions india private limited',
    'Eagle peak consultancy private limited',
    'Vasplanet services private limited',
    'Ikn chase check services private limited',
    'DOMINO',
    'S INDUSTRIES PRIVATE LIMITED',
    'ELOQUENT INFO SOLUTIONS PRIVATE LIMITED',
    'AN USEDLESS PAPER PRIVATE LIMITED',
    'ASIAPOWER HUMAN RESOURCES PRIVATE LIMITED',
    'SIFT CONSULTANCY PRIVATE LIMITED',
    'SLO TECHNOLOGIES PRIVATE LIMITED',
    'TABLE IMAGE SOLUTIONS PRIVATE LIMITED',
    'AERONUTRIX SPORTS PRODUCTS PRIVATE LIMITED',
    'ZENEX E-COMMERCE PRIVATE LIMITED',
    'SUNCITY MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'PERFECT COMPLIANCE PRIVATE LIMITED',
    'CERTIFIED PROFESSIONAL ADVISORY SERVICES PRIVATE LIMITED',
    'CLOTHING RENTAL (MUMBAI) PRIVATE LIMITED',
    'ALTERNATIVE BUSINESS INTELLIGENCE PRIVATE LIMITED',
    'EDUINGS DIGITAL SERVICES PRIVATE LIMITED (OPC)',
    'DLZ CONSULTANTS (INDIA) PRIVATE LIMITED',
    'AVAMEH CONSULTING PRIVATE LIMITED',
    'FITRR TECHNOLOGIES PRIVATE LIMITED',
    'INTELLEX ENGINEERS PRIVATE LIMITED',
    'FUTURE 7-INDIA CONVENIENCE LIMITED',
    'LITTLE ANGELS MEDICAL SERVICES PRIVATE LIMITED',
    'ABANS FINTRADE PRIVATE LIMITED',
    'GRAYLABS INDIA PRIVATE LIMITED',
    'VETRIVA ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'VINGYAN INNOVATIONS PRIVATE LIMITED',
    'CARTELLO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HAKAGO PRIVATE LIMITED',
    'BACKPACK INTERNATIONAL PRIVATE LIMITED',
    'DEENZ TECHNOLOGIES PRIVATE LIMITED',
    'SUJAL SYSTEMS PRIVATE LIMITED',
    'INTELLIGIBLE TECH SOLUTION PRIVATE LIMITED',
    'LITMUS WORLD MARKETING TECHNOLOGIES PRIVATE LIMITED',
    'WANBURY HEALTHCARE PRIVATE LIMITED',
    'WANBURY LIFESCIENCE PRIVATE LIMITED',
    'QUIDICH INNOVATION LABS PRIVATE LIMITED',
    'PLUS CAPITALVENTURES SERVICES PRIVATE LIMITED',
    'GOODEDGE ADVISORY PRIVATE LIMITED',
    'BELFRICS CRYPTEX PRIVATE LIMITED',
    'SCROLL REGIONAL CONTENT AND SOFTWARE DEVELOPMENT SERVICES PRIVATE LIMITED',
    'MEMESYS CULTURAL LAB PRIVATE LIMITED',
    'ELEMENT RETAIL PRIVATE LIMITED',
    'PAYSO FINTECH PRIVATE LIMITED',
    'ASTRA CYBERTECH PRIVATE LIMITED',
    'ASK CRE PRIVATE LIMITED',
    'WORLDEX COURIER AND CARGO PRIVATE LIMITED',
    'DEESHA POWER SOLUTIONS PRIVATE LIMITED',
    'ABANTE INTEGRATED MANAGEMENT SERVICES PRIVATE LIMITED',
    'MIGARAH AERO PRIVATE LIMITED (OPC)',
    'MOLECULE TECHNOLOGIES LIMITED',
    'STRIDE E-KART PRIVATE LIMITED',
    'FIVE RIVERS MANAGEMENT CONSULTING PRIVATE LIMITED',
    'FOUNTAINHEAD PROJECT MANAGEMENT PRIVATE LIMITED',
    'SAFE AND STRONG BUSINESS CONSULTANTS PRIVATE LIMITED',
    'VERYTAT TECHNOLOGIES & INFRASTRUCTURES PRIVATE LIMITED',
    'GREENTORUS ORGANICS PRIVATE LIMITED',
    'MORLAND MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'RAULT ENGINEERING PRIVATE LIMITED',
    'AKULA LOGISTICS PRIVATE LIMITED',
    'SHORTLIST PROFESSIONAL SERVICES PRIVATE LIMITED',
    'RASHPI CONSULTANTS PRIVATE LIMITED',
    'UNICOAL RESOURCES PRIVATE LIMITED',
    'DIRECTSHIP FULFILLMENT SERVICES PRIVATE LIMITED',
    'MUDS MANAGEMENT PRIVATE LIMITED',
    'METACOG PATENT RESEARCH SOLUTIONS PRIVATE LIMITED',
    'MVK MANAGEMENT CONSULTING PRIVATE LIMITED',
    'ORGANIC121 SCIENTIFIC PRIVATE LIMITED',
    'TECHNOCRACY CONSULTING PRIVATE LIMITED',
    'PRESENCE OF IT (INDIA) PRIVATE LIMITED',
    'HIREAJACKAL CONSULTING PRIVATE LIMITED',
    'WINEDGE CONSULTING PRIVATE LIMITED (OPC)',
    'ORECTIC CONSULTING PRIVATE LIMITED',
    'SKYLKA TECHNOLOGIES PRIVATE LIMITED',
    'DIGITAL 24 AV SOLUTIONS PRIVATE LIMITED',
    'SANDHYA PROTECTORS LIMITED',
    'AFICIONADO TECHNOLOGIES PRIVATE LIMITED',
    'THEORY Y TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'DATAMOUNT ANALYTICS PRIVATE LIMITED',
    'RENEPAY PRIVATE LIMITED',
    'TIP KNOWLEDGE SERVICES PRIVATE LIMITED',
    'ESTAFF CONNECT PRIVATE LIMITED',
    'RED MONKEY DESIGN GROUP PRIVATE LIMITED',
    'AIROFLY TRAVELS PRIVATE LIMITED',
    'DARSHIKA CONSULTANTS PRIVATE LIMITED',
    'ROOTS LOGISTICARE PRIVATE LIMITED',
    'MYONLINECA TECHNOLOGIES PRIVATE LIMITED',
    'VAULTBOARD CONSULTING PRIVATE LIMITED',
    'BOTTLE OPENERS DIGITAL SOLUTIONS PRIVATE LIMITED',
    'EXEMPLARY PEOPLE PRIVATE LIMITED',
    'SUG TECHNOLOGIES PRIVATE LIMITED',
    'SING ETECH STANDARDS PRIVATE LIMITED',
    'TEXILA EDUCARE HEALTHCARE AND TECHNOLOGY ENTERPRISES PRIVATE LIMITED',
    'INDIAN MANUFACTURING ACADEMY PRIVATE LIMITED',
    'WYNAUT WEBVENTURES PRIVATE LIMITED',
    'CARAT MANAGEMENT SERVICES PRIVATE LIMITED',
    'PERFECT SOCIAL PROJECTS CONSULTANCY PRIVATE LIMITED',
    'MUNSHIJEE MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'HEVINS ENGINEERING PRIVATE LIMITED',
    'SKB 360 GLOBAL PRIVATE LIMITED',
    'ASMECH ENGINEERING SERVICES PRIVATE LIMITED',
    'MUSADDILAL HOLDINGS PRIVATE LIMITED',
    'CUBIX WEBTECH SOLUTIONS PRIVATE LIMITED',
    'CONNECT TRADE INNOVATIONS PRIVATE LIMITED',
    'MACLOGY CONSULTING SERVICES PRIVATE LIMITED',
    'LIMITLESS SOLUTIONS PRIVATE LIMITED',
    'HEI DESIGN CENTER PRIVATE LIMITED',
    'DRIFTUP SOLUTIONS PRIVATE LIMITED',
    'JANMAT RESEARCH & SOLUTIONS PRIVATE LIMITED',
    'PROLOANS FINCORP PRIVATE LIMITED',
    'ANALYTIX BIZCARE SOLUTIONS PRIVATE LIMITED',
    'WENDT CORPORATE SERVICES PRIVATE LIMITED',
    'AMPHION ADVERTISING AND MARKETING PRIVATE LIMITED',
    'PIXELRUSH DIGITAL ADVERTISING PRIVATE LIMITED',
    'DOCABSTRACT TITLE SEARCH (INDIA) PRIVATE LIMITED',
    'KENAN MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'KWIK PRINTS PRIVATE LIMITED',
    'APEXTRIBES MARKETING PRIVATE LIMITED',
    'SHRI MAHALAKSHMI OVERSEAS BUSINESS CONSULTANTS PRIVATE LIMITED',
    'PALNAR CONSULTING SERVICES PRIVATE LIMITED',
    'FINCH MANAGEMENT CONSULTING PRIVATE LIMITED',
    'LET US THINK ADVERTISING PRIVATE LIMITED',
    'BINOMIAL LABS PRIVATE LIMITED',
    'BUILDING INFORMATION MODELING PLUS PLUS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'FUBURG INDUSTRIES INDIA PRIVATE LIMITED',
    'PEOPLE TECH ENTERPRISES PRIVATE LIMITED',
    'OMECO TECHNOLOGIES PRIVATE LIMITED',
    'KAVEESHA ENGINEERS INDIA PRIVATE LIMITED',
    'FRONTIZA SERVICES PRIVATE LIMITED',
    'SAARUS INNOVATIONS PRIVATE LIMITED',
    'WINIIN TAXSCOPE PRIVATE LIMITED',
    'SYMBIOSIS E-SERVE PRIVATE LIMITED',
    'S K PROLIFIC SOLUTIONS PRIVATE LIMITED',
    'SIGMAINC PROFESSIONAL SERVICES PRIVATE LIMITED',
    'TECKNOWLEDGE DEVELOPMENT PRIVATE LIMITED',
    'TALENT TAKEAWAYS INFOTECH PRIVATE LIMITED',
    'FINACT SOLUTIONS INDIA PRIVATE LIMITED',
    'BABY SAFETY PRIVATE LIMITED',
    'SANKHYA & SRINIDHI HOSPITALS PRIVATE LIMITED',
    'SILKPLANET ONLINE SERVICES PRIVATE LIMITED',
    'TRINA SOLAR (INDIA) PRIVATE LIMITED',
    'GMI RESEARCH PRIVATE LIMITED',
    'SMART HOME AUTOMATION INDIA PRIVATE LIMITED',
    'OYE VENTURES PRIVATE LIMITED',
    'BETTER BRANDS & PRACTICES INDIA COMMUNICATIONS PRIVATE LIMITED',
    'INFIGENT SOLUTION PRIVATE LIMITED',
    'MG AURAA CINEMAS PRIVATE LIMITED',
    'TOPNOTCH OVERSEAS EDUCATIONAL CONSULTANCY PRIVATE LIMITED',
    'SPHERETECH INTERNATIONAL ENGINEERING AND PROJECTS PRIVATE LIMITED',
    'IMPECCABLE INNOVATIONS PRIVATE LIMITED',
    'C.S HAWKLER LOGISTICS PRIVATE LIMITED',
    'GREATSHIP OILFIELD SERVICES LIMITED',
    'KJMC TRADING & AGENCY LIMITED',
    'PITTIE INFRA PRIVATE LIMITED',
    'FINGERTIPPLUS TECHNOLOGIES PRIVATE LIMITED',
    'UBIKWITES EXPORT MANAGEMENT PRIVATE LIMITED',
    'CONTINUUM MP WINDFARM DEVELOPMENT PRIVATE LIMITED',
    'PERKARAT PRIVATE LIMITED',
    'MAXENTRA CONSULTANTS PRIVATE LIMITED (OPC)',
    'BIN SARI SPECIALIZED TECHNOLOGIES CORROSION PROTECTION INDIA PRIVATE LIMITED',
    'PRAGATI AEROSOLS PRIVATE LIMITED',
    'BLUCREST CAPITAL ADVISORS PRIVATE LIMITED',
    'NUVOLAT INFOTECH INDIA PRIVATE LIMITED',
    'QGLOBAL MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'TEAMSMART BUSINESS SUPPORT SERVICES PRIVATE LIMITED',
    'LEGENDARY DISTRIBUTORS PRIVATE LIMITED',
    'BLOOMBLOOM DREAMBIZ PRIVATE LIMITED',
    'OMG DIGITAL INDIA PRIVATE LIMITED',
    'MADHUSHREE AGRO INDUSTRIES (INDIA) PRIVATE LIMITED',
    'BLIMPS INDIA AERIAL TECHNOLOGIES PRIVATE LIMITED',
    'SPORTZIFY INTERNET SOLUTIONS PRIVATE LIMITED',
    'LEARNKART TECHNOLOGY PRIVATE LIMITED',
    'BAJAJ SINDHUDURG RICE MILLS LIMITED',
    'EZLYPAY TECHNOLOGIES PRIVATE LIMITED',
    'SOHM ANALYTICAL SERVICES (I) PRIVATE LIMITED',
    'ORTUS AUTOMATION PRIVATE LIMITED',
    'VYOMAN INFRAPROJECTS PRIVATE LIMITED',
    'UPPER CRUST HOSPITALITY PRIVATE LIMITED',
    'IMT-THL INDIA PRIVATE LIMITED',
    'STRUGENCE ASSET RECONSTRUCTION PRIVATE LIMITED',
    'TICKLED MEDIA (INDIA) PRIVATE LIMITED',
    'MYNA MAHILA FOUNDATION',
    'LITTLE BAY SAILING & ROWING CLUB ACADEMY AND ASSOCIATION',
    'EINSTEIN PRODUCTIONS PRIVATE LIMITED',
    'DRILLPRO INTERNATIONAL PRIVATE LIMITED',
    'CELLORE CELLULAR INTERNATIONAL SERVICES PRIVATE LIMITED',
    'CANARA FACILITIES MANAGEMENT PRIVATE LIMITED',
    'FINARCADIA HOLDINGS PRIVATE LIMITED',
    'OCEAN DIAL ASSET MANAGEMENT INDIA PRIVATE LIMITED',
    'HITLAB ENTERTAINMENT PRIVATE LIMITED',
    'VENTAREX AUTOMATON PRIVATE LIMITED',
    'SURNADEV ELECTRICALS PRIVATE LIMITED',
    'SK EXPRESS SERVICES PRIVATE LIMITED',
    'SWAD AGRO COLD CHAIN PRIVATE LIMITED',
    'DUCHEM SPECIALITIES INDIA PRIVATE LIMITED',
    'VERSALLIES WELLNESS PRIVATE LIMITED',
    'SNP SHIP MANAGEMENT PRIVATE LIMITED',
    'VERSALLIES BIOSCIENCES PRIVATE LIMITED',
    'QUANTASTIC MARKETING PRIVATE LIMITED',
    'XTRA MEDIA VENTURES PRIVATE LIMITED',
    'MONEYMAP INVESTMENT ADVISORS PRIVATE LIMITED',
    'R.A.V FACILITY MANAGEMENT PRIVATE LIMITED',
    'PERFORMALUX PRIVATE LIMITED',
    'RIVAAJ RETAILS PRIVATE LIMITED',
    'INDAMER MJETS AIRPORT SERVICES PRIVATE LIMITED',
    'MEDIATORS TALENT SEARCH PRIVATE LIMITED',
    'DIOSNA PROCESS SOLUTIONS PRIVATE LIMITED',
    'DSV INFO SOLUTIONS PRIVATE LIMITED',
    'INTEX INTERNATIONAL TRADING & CLEARING PRIVATE LIMITED',
    'FM INDIA SUPPLY CHAIN PRIVATE LIMITED',
    'ELIXIR INTEGRATED BRANDCOMM PRIVATE LIMITED',
    'S V MAINTENANCE MANAGEMENT SERVICES PRIVATE LIMITED',
    'VIJAYA ELECTRONICS PRIVATE LIMITED',
    'CMC SKILLS PRIVATE LIMITED',
    'VERSATILE SHIPPING & LOGISTICS PRIVATE LIMITED',
    'HOME CRAFT ONLINE PRIVATE LIMITED',
    'MOTOMOJO TECHNOLOGIES PRIVATE LIMITED',
    'INTERIO SOURCE INDIA PRIVATE LIMITED',
    'EZEN AVIATION PRIVATE LIMITED',
    'DATABASE INTERACTIVE PRIVATE LIMITED',
    'DIRECT MEDIA & CABLE PRIVATE LIMITED',
    'BLACK WATER BIOTECH PRIVATE LIMITED',
    'RACENEXT INFORMATION SOLUTIONS PRIVATE LIMITED',
    'REDBRICK OFFICES LIMITED',
    'TINA MEDIA PRIVATE LIMITED',
    'NOIZE BRANDS AND LIFESTYLE PRIVATE LIMITED',
    'RAY SYNTEX PRIVATE LIMITED',
    'RAZIA (INDIA) CONSTRUCTION PRIVATE LIMITED',
    'IMMACULATE SERVICING INDIA PRIVATE LIMITED',
    'CLICKEXCEL.COM PRIVATE LIMITED',
    'PARTHIV WEALTH PRIVATE LIMITED',
    'PROTOPOROS STAFFING SERVICES PRIVATE LIMITED',
    'HANDTRIBE E-RETAIL PRIVATE LIMITED',
    'JUST ENGAGED WEDDINGS & EVENTS PRIVATE LIMITED',
    'TAXIDIO TRAVEL INDIA PRIVATE LIMITED',
    'CANVS CREATIVE SOLUTIONS PRIVATE LIMITED',
    'SUNSTREAM GREEN ENERGY PRIVATE LIMITED',
    'SUNSTREAM GREEN ENERGY ONE PRIVATE LIMITED',
    'DNR INDIA AUTOTECH PRIVATE LIMITED',
    'NITZZ GLOBAL IT SERVICES PRIVATE LIMITED',
    'CAMRY TOURS AND TRAVELS PRIVATE LIMITED',
    'KAD MODEL MANAGEMENT PRIVATE LIMITED',
    'LIGO INTERTRADE PRIVATE LIMITED',
    'UPPEAR TECHNOLOGIES PRIVATE LIMITED',
    'RISEFY OUTSOURCING SERVICES PRIVATE LIMITED',
    'EDEN HYDROPONIC GROWERS PRIVATE LIMITED',
    'BLACK LOTUS TRADEX PRIVATE LIMITED',
    'EXPERT SUPPORT SERVICES PRIVATE LIMITED',
    'TARA LIVELIHOOD ACADEMY PRIVATE LIMITED',
    'SHAURYAM SOLUTIONS PRIVATE LIMITED',
    'KICKSTART HUMAN CAPITAL SOLUTIONS PRIVATE LIMITED',
    'GUNG HO MARKETING VENTURES PRIVATE LIMITED',
    'GLOBAL HEALTH PATLIPUTRA PRIVATE LIMITED',
    'TECHMASTERS INFOMATRIX PRIVATE LIMITED',
    'NICOBAR DESIGN STUDIO PRIVATE LIMITED',
    'HEADON TECHNOLOGIES PRIVATE LIMITED',
    'AZURE INNOVATIONS PRIVATE LIMITED',
    'HEALTH ARX TECHNOLOGIES PRIVATE LIMITED',
    'WATTKRAFT INDUSTRIES PRIVATE LIMITED',
    'SURAJKIRAN RENEWABLE RESOURCES PRIVATE LIMITED',
    'CHILD LEARNING PRIVATE LIMITED',
    'A. N. EMEDINEXUS TECHNOLOGIES PRIVATE LIMITED',
    'INDRADHANUSH PRIVATE LIMITED',
    'ANGLEPAISA CONSULTANCY SERVICES PRIVATE LIMITED',
    'SMART CITY SERVICES PRIVATE LIMITED',
    'AKSHNA BUILDWELL PRIVATE LIMITED',
    'SPOTLAW APPS PRIVATE LIMITED',
    'NEW AGE PHYSIOTHERAPY CENTRE PRIVATE LIMITED',
    'FORESIGHT BIOTECH PRIVATE LIMITED',
    'ASPLOR RESEARCH PRIVATE LIMITED',
    'AAVRITII INTERCONNECT PRIVATE LIMITED',
    'ZOE CONCEPTS PRIVATE LIMITED',
    'PROJECTS INDIA MICE PRIVATE LIMITED',
    'SOCIALLENDING TECHNOLOGIES AND HOLDINGS PRIVATE LIMITED',
    'METROPOLITAN EDUCATION & TESTING SERVICES PRIVATE LIMITED',
    'TEXCHANGE E-BIZ PRIVATE LIMITED',
    'VEGANWAY LIFESTYLE INDIA PRIVATE LIMITED',
    'ADVENT PUBLIC-RELATIONS PRIVATE LIMITED',
    'PENCILLATI STUDIOS PRIVATE LIMITED',
    'ARGENTUM TECHNOLOGIES PRIVATE LIMITED',
    'SHIN-ETSU SILICONES INDIA PRIVATE LIMITED',
    'TOP STAR CORPORATE FACILITIES PRIVATE LIMITED',
    'ZAHRA OVERSEAS PRIVATE LIMITED',
    'GAME TIME SOFT SOLUTIONS PRIVATE LIMITED',
    'QUINTILLION BUSINESS MEDIA LIMITED',
    'PANAKEIA TECHNOLOGIES PRIVATE LIMITED',
    'DOUBLE EDGE CONSULTING PRIVATE LIMITED',
    'AVANTA BUSINESS CENTRE (NP) PRIVATE LIMITED',
    'SP SYNDICATE PRIVATE LIMITED',
    'KAVIYASRI FOUNDATION',
    'SUKAMAL FINSERVE PRIVATE LIMITED',
    'MYSTERY MONKS ENTERTAINMENT PRIVATE LIMITED',
    'SIX DEE NETAD SOLUTIONS PRIVATE LIMITED',
    'ASL PROTECTIVE INDIA PRIVATE LIMITED',
    'VINPRA ENGINEERING INDIA PRIVATE LIMITED',
    'TECH CONNECT SECURITY PRIVATE LIMITED',
    'TWA ONLINE SERVICES PRIVATE LIMITED',
    'BEYOND BORDERS LOGISTICS PRIVATE LIMITED',
    'AKOGNOS LIFE SCIENCES PRIVATE LIMITED',
    'OVERLOOK MEDIA PRIVATE LIMITED',
    'ACTRA CONSTRUCTION & INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'USEKIWI INFOLABS PRIVATE LIMITED',
    'AGORAA SMART SOLUTIONS PRIVATE LIMITED',
    'OREL SOUTH ASIA PRIVATE LIMITED',
    'V B TECHVENTURES PRIVATE LIMITED',
    'KEY CENTER FOR ADVANCED RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'INNOTARGET FASHALOT RETAIL PRIVATE LIMITED',
    'EDUSHILLA UNIVERSITY CONNECTION PRIVATE LIMITED',
    'GREEN WATTAGE PRIVATE LIMITED',
    'AFORESERVE LABS PRIVATE LIMITED',
    'DEVSHAKTI FREE ELECTRIC PRIVATE LIMITED',
    'DELFINITY LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'WHIZZRD TECHNOLOGIES PRIVATE LIMITED',
    'BOUGH CONSULTING (INDIA) PRIVATE LIMITED',
    'SERGE FERRARI INDIA PRIVATE LIMITED',
    'BLUETOWN (INDIA) PRIVATE LIMITED',
    'BOE INDIA PRIVATE LIMITED',
    'VIDYA QUALITY AND SAFETY SOLUTION EXPERTS PRIVATE LIMITED',
    'INDERJIT SINGH SODHI FOUNDATION',
    'AUD CENTRE FOR INCUBATION INNOVATION & ENTREPRENEURSHIP',
    'SCHOOL FOR SOCIAL ENTREPRENEURS INDIA',
    'ADVIT FOUNDATION',
    'VIR SOFTECH PRIVATE LIMITED',
    'INDIABULLS ALTERNATE INVESTMENTS LIMITED',
    'GREAT CHAMP TECHNOLOGY PRIVATE LIMITED',
    'ID EXPORTS PRIVATE LIMITED',
    'INVINCIBLE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'APROPOS BUSINESS SERVICES PRIVATE LIMITED',
    'OM GOM CONSULTANCY PRIVATE LIMITED',
    'MEDHEALIX HEALTH TECH PRIVATE LIMITED',
    'MUSICONCEPTS PRIVATE LIMITED',
    'ERR AND INTEGRATION PRIVATE LIMITED',
    'APEIROGON TECHNOLOGIES PRIVATE LIMITED',
    'COMSET TRADING PRIVATE LIMITED',
    'DATA ANTICS SYSTEMS PRIVATE LIMITED',
    'POISED INDIA ADVISORY PRIVATE LIMITED',
    'JAIEESPY TECHKART PRIVATE LIMITED',
    'CARTERPULL CONSULTING PRIVATE LIMITED',
    'EV MOTORS INDIA PRIVATE LIMITED',
    'J.S. SOLARTECH INDIA PRIVATE LIMITED',
    'FIELD TABS MARKETING SOLUTIONS PRIVATE LIMITED',
    'INNOVEOS E-COMMERCE PRIVATE LIMITED',
    'INVESTORS INDIA TECHNOLOGIES PRIVATE LIMITED',
    'INOX FMCG PRIVATE LIMITED',
    'COUNCIL FOR FOOTWEAR LEATHER AND ACCESSORIES',
    'ICE GATE EDUCATIONAL INSTITUTE PRIVATE LIMITED',
    'GRAPHIC ERA GLOBAL SCHOOL',
    'GSR UJWALA FOUNDATION',
    'V1 OVERSEAS CAREERS PRIVATE LIMITED',
    'ADIRAA CAREER SOLUTIONS PRIVATE LIMITED',
    'DEVELOPMENT MANAGEMENT FOUNDATION',
    'ATLANTIS ERUDITION & TRAVEL SERVICES PRIVATE LIMITED',
    'LANZEINTEGRA TECHNOLOGIES PRIVATE LIMITED',
    'GURUSTHANAM TECHNO SCHOOLS PRIVATE LIMITED',
    'SHIVALIK COMMUNICATIONS PRIVATE LIMITED',
    'INDIAN SCHOOL OF K -12 EDUCATION PRIVATE LIMITED',
    'VIDWATH EDUCATION FOUNDATION',
    'NEW EDGE OVERSEAS CONSULTANCY PRIVATE LIMITED',
    'ABSOLUTE HERBS EXPORTS PRIVATE LIMITED',
    'LEUSCH INDIA PRIVATE LIMITED',
    'ESS GLOBAL MIGRATION SERVICE PRIVATE LIMITED',
    'INCREDIBLE IDEAS PRIVATE LIMITED',
    'EPITOME CORPORATE SOLUTIONS PRIVATE LIMITED',
    'HVCS CORPORATE SOLUTIONS PRIVATE LIMITED',
    'SR KUBE GLOBAL INNOVATION AGENCY PRIVATE LIMITED',
    'ECONOMIZER SERVICES PRIVATE LIMITED',
    'CHANAKYA GLOBAL EDUCATION CENTRE PRIVATE LIMITED',
    'EXTRAMARKS EDUCATION INDIA PRIVATE LIMITED',
    'IMPERIAL INSTITUTE OF MANAGEMENT AND TECHNICAL COUNCIL',
    'SUFI SKILLS AND EDUCATION (OPC) PRIVATE LIMITED',
    'PAPERVC PRIVATE LIMITED',
    'ORANGE RAY HOLISTIC PRIVATE LIMITED',
    'VLURN EDUCATION PRIVATE LIMITED',
    'DATA PANACEA INDIA PRIVATE LIMITED',
    'R K SAFE FORWARDING PRIVATE LIMITED',
    'GLASS ACADEMY FOUNDATION',
    'GLOBAL REACH EDUCATION SERVICES PRIVATE LIMITED',
    'RABBIT TORTOISE IMMIGRATION SERVICES INDIA PRIVATE LIMITED',
    'KAUSHAL SHALA FOUNDATION',
    'STUDENT EDUCATION EMPOWERMENT AND DEVELOPMENT FOUNDATION',
    'SKILLS LAGOON TRAININGS PRIVATE LIMITED (OPC)',
    'FOSTER MINDS CONSULTING SERVICES PRIVATE LIMITED',
    'CAREER CLINIC PRIVATE LIMITED (OPC)',
    'IIT GANDHINAGAR INNOVATION AND ENTREPRENEURSHIP CENTER',
    'BLOSSOM DIGITAL MEDIA NETWORK PRIVATE LIMITED',
    'GREEN CIRCLE EDUVISION LIMITED',
    'CLASSES AT HOME.COM PRIVATE LIMITED',
    'INURTURE 360 CAREERS PRIVATE LIMITED',
    'AHAM LEARNING HUB PRIVATE LIMITED',
    'DIY EDUCATIONAL TECHNOLOGIES FOUNDATION',
    'TAYNA EVENTS PRIVATE LIMITED',
    'ANTOAN BIOTECH PRIVATE LIMITED',
    'MASTRO EDUTECH PRIVATE LIMITED',
    'STUDYBOARD EDUCATION PRIVATE LIMITED',
    'NEOTECH TECHNICAL & MEDICAL RESEARCH FOUNDATION',
    'RELIANCE CRUISE AND TERMINALS LIMITED',
    'ARAVALI EDUWORLD PRIVATE LIMITED',
    'ACCUSTER SKILLS PRIVATE LIMITED',
    'RIGHT GUIDE EDU - TECH (I) PRIVATE LIMITED',
    'MINDPRO ACADEMY PRIVATE LIMITED',
    'CAREER POINT INSTITUTE OF SKILL DEVELOPMENT PRIVATE LIMITED',
    'MOTION E-LEARNING SOLUTIONS PRIVATE LIMITED',
    'ISDC PROJECTS INDIA PRIVATE LIMITED',
    'LORATIS SETMYCAREER.NET PRIVATE LIMITED',
    'VAIBHAV EDUVENTURES PRIVATE LIMITED',
    'VIKALP INDIA PRIVATE LIMITED',
    'ONE PLACE COMMERCIALS PRIVATE LIMITED',
    'TRANSITECH PRIVATE LIMITED',
    'SHIYALI HR SERVICES PRIVATE LIMITED',
    'VITALIC HEALTH LIMITED',
    'BUSY BEES INDIA PRIVATE LIMITED',
    'FORTHWITH GLOBAL CONSULTING PRIVATE LIMITED',
    'QSOCS TECHNOLOGIES PRIVATE LIMITED',
    'PREPGOALS EDUCATIONAL SOLUTIONS PRIVATE LIMITED',
    'CENTRE FOR SCIENCE OF STUDENT LEARNING',
    'KKMS FOUNDATION',
    'INNOVATIVE MIDBRAIN OPTIMIZATION INSTITUTE PRIVATE LIMITED',
    'TRANSFORMING DREAMS INDIA PRIVATE LIMITED',
    'STUDYCOPTER LEARNING LABS PRIVATE LIMITED',
    'BODHI TREE KNOWLEDGE SERVICES PRIVATE LIMITED',
    'ADMISSION TRACKS PRIVATE LIMITED (OPC)',
    'METARION KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'BORN SMART E - LEARNING PRIVATE LIMITED',
    'SPOTMENTOR EDUCATION TECHNOLOGIES PRIVATE LIMITED',
    'INSPILEARN EDUCATION PRIVATE LIMITED',
    'THOMAS AND MUFASSIL ENTERPRISES PRIVATE LIMITED',
    'GCC LEARNING',
    'QLYTIX SOLUTIONS PRIVATE LIMITED',
    'DREAMBIG NETWORKS PRIVATE LIMITED',
    'SANCHHAYA EDUCATION PRIVATE LIMITED',
    'T-SERIES STAGEWORKS ACADEMY PRIVATE LIMITED',
    'SYM BLOSSOM ANIMATION PRIVATE LIMITED',
    '7 STAR SUPER SPECIALITY HOSPITAL PRIVATE LIMITED',
    'GALWAY FOUNDATION',
    'MORELIFE FOUNDATION',
    'SYNERGYBYTE INFOTAINMENT PRIVATE LIMITED',
    'SAHAYADRI LEARNING CENTRE PRIVATE LIMITED',
    'CYGNUS CORSANTS MLS HEALTHCARE PRIVATE LIMITED',
    'CYGNUS CORSANTS MEDICARE PRIVATE LIMITED',
    'ATEN STUDIES PRIVATE LIMITED',
    'ADU ACADEMY INDIA PRIVATE LIMITED',
    'ECDEMY LEARNING SOLUTIONS INDIA PRIVATE LIMITED',
    'DECLUTTER LEARNING PRIVATE LIMITED',
    'CONNECT AND HEAL PRIMARY CARE PRIVATE LIMITED',
    'EKAYANA LEARNERS HUDDLE PRIVATE LIMITED',
    'BIL- RYERSON TECHNOLOGY STARTUP INCUBATOR FOUNDATION',
    'METRO WORLD CHILD INDIA FOUNDATION',
    'TAJ EDUGLOBE LIMITED',
    'TEEVRA EDUTECH PRIVATE LIMITED',
    'INNOVATIVE COUNCIL OF INDIAN TOURISM',
    'EMINENT AUDIO VISUAL PRIVATE LIMITED',
    'SPANDREL INTERIORS INDIA PRIVATE LIMITED',
    'MEDNEO MEDICAL COMMUNICATIONS PRIVATE LIMITED',
    'REBEL TRIP SOLUTIONS PRIVATE LIMITED',
    'ANK AHA PRIVATE LIMITED',
    'THRIVESOFT TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'ETALON MULTITRADE PRIVATE LIMITED',
    'SVP TECHNO ENGINEERS PRIVATE LIMITED',
    'GREAT MARKET AGGREGATOR PRIVATE LIMITED',
    'NETWORK-IE INFOSYSTEMS PRIVATE LIMITED',
    'LEHBERRY TECHNOLOGIES PRIVATE LIMITED',
    'RELUIRE ENERGY PRIVATE LIMITED',
    'LOKTRA TECHNOLOGIES PRIVATE LIMITED',
    'LOKDHUN TELEMEDIA PRIVATE LIMITED',
    'ICASTX TECHNOLOGIES PRIVATE LIMITED',
    'MYRSA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ALLSAN SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'SANTINT INDIA TECHNOLOGY PRIVATE LIMITED',
    'AQUAFIL INDIA PRIVATE LIMITED',
    'COGNIZE INVENTIVES PRIVATE LIMITED',
    'DFD TECHNOLOGIES PRIVATE LIMITED',
    'DATIOT PRIVATE LIMITED',
    'KLAPS INTERACTIVE SOLUTIONS PRIVATE LIMITED',
    'APCO INNOVATIVE AUTO PRIVATE LIMITED',
    'KARBANIC MEADOWS (INDIA) PRIVATE LIMITED',
    'INTELECHS ENTERPRISE PRIVATE LIMITED',
    'SAP PARTS PRIVATE LIMITED',
    'ARWAL LANDSANSAR DEVELOPERS PRIVATE LIMITED (OPC)',
    'OPTIMA INFRAVENTURES PRIVATE LIMITED',
    'BHADORIA CONSULTANCY SERVICES PRIVATE LIMITED',
    'PARISODHANA TECHNOLOGIES PRIVATE LIMITED',
    'KEN CLOUD SYSTEMS PRIVATE LIMITED',
    'KSHITU CREATION PRIVATE LIMITED',
    'CONQUAS ENGINEERS (OPC) PRIVATE LIMITED',
    'EZYTEK CONSULTING PRIVATE LIMITED',
    'ASSORT STAFFING SERVICES PRIVATE LIMITED',
    'GROWINGTOTS EDUCATION PRIVATE LIMITED',
    'ONEMI TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'CITY PLUS ODISHA PRIVATE LIMITED',
    'DYNAX SOLUTIONS PRIVATE LIMITED',
    'T- GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'HYPER STEALTH TECHNOLOGIES PRIVATE LIMITED',
    'INDITECH ELECTROSYSTEMS PRIVATE LIMITED',
    'CONCENT TECHNOLOGY DISTRIBUTION PRIVATE LIMITED',
    'DNYANADA INSTITUTE OF FLOW PIPING TECHNOLOGY',
    'KNOREX INDIA PRIVATE LIMITED',
    'ACCORDION TECHNOLOGY PRIVATE LIMITED',
    'SHIN-ETSU CHEMICAL TYLOSE INDIA PRIVATE LIMITED',
    'YAMUNA LAND INFRA PRIVATE LIMITED',
    'DAIZ SOLAR PRIVATE LIMITED',
    'AIS HOLIDAYS PRIVATE LIMITED',
    'EVERGREEN RENEWABLES PRIVATE LIMITED',
    'UNIQ FACILITY SERVICES PRIVATE LIMITED',
    'SKILLEE TRAININGS PRIVATE LIMITED',
    'JHM RICE MILLS PRIVATE LIMITED',
    'ENVICON VIBROTECH PRIVATE LIMITED',
    'SINGHAL RICE & PULSES PRIVATE LIMITED',
    'IDEARX SERVICES PRIVATE LIMITED',
    'FERNLINK TECHNOLOGIES PRIVATE LIMITED',
    'VYAPINI TECH SERVICES PRIVATE LIMITED',
    'PYTEN LABS PRIVATE LIMITED',
    'MS MODULAR PRIVATE LIMITED',
    'VARNAV ACCOMMODATIONS PRIVATE LIMITED',
    'COHERE-MED SOLUTIONS PRIVATE LIMITED',
    'SUHIT PROPERTIES PRIVATE LIMITED',
    'VRAJVIHAR CONSOLIDATED TECHNOLOGIES PRIVATE LIMITED',
    'RESILIENCEWORKS CONSULTATION SERVICES PRIVATE LIMITED',
    'BHU ENTERTAINMENT PRIVATE LIMITED',
    'DIVINEX INFOMATICS PRIVATE LIMITED',
    'WGC ADVISORY SERVICES PRIVATE LIMITED',
    'DOCON TECHNOLOGIES PRIVATE LIMITED',
    'XCELLINS TECHNOLOGIES PRIVATE LIMITED',
    'MECH MARINE ENGINEERS PRIVATE LIMITED',
    'JAZAK DEVELOPERS PRIVATE LIMITED',
    'MEGACOSM COGNITIONS PRIVATE LIMITED',
    'EMERALD HAVEN LIFE SPACES (RADIAL ROAD) LIMITED',
    'TWINTECH ACADEMY BUSINESS MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'BRIDGEROCK IT SOLUTIONS PRIVATE LIMITED',
    'PAAJI N',
    'S HANDS HOSPITALITY PRIVATE LIMITED',
    'BISTRITA PROJECTS PRIVATE LIMITED',
    'BRIDGE SKILL DEVELOPMENT ACADEMY PRIVATELIMITED',
    'JALAN PENS PRIVATE LIMITED',
    'RSHOP & PSOFT ONLINE SERVICE PRIVATE LIMITED',
    'MY3 SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'STRUGENCE TRUSTEE PRIVATE LIMITED',
    'ACTIVBUZZ SOFTWARE PRIVATE LIMITED',
    'BACKLINC MEDIA PRIVATE LIMITED',
    'NEXTSTARTS UTILITIES PRIVATE LIMITED',
    'VISION RABBIT ADVISORY PRIVATE LIMITED',
    'WENOUR ENTERPRISES PRIVATE LIMITED',
    'INDIA SPORTS FLASHES PRIVATE LIMITED',
    'ISFT COLLEGE AND INSTITUTE PRIVATE LIMITED',
    'ADEDGE INDIA WATER TECHNOLOGIES PRIVATE LIMITED',
    'TRUEBODH TECHNOLOGIES PRIVATE LIMITED',
    'PLANETCAST BROADCASTING SERVICES LIMITED',
    'CONVEY TECH LABS INDIA PRIVATE LIMITED',
    'BLUE CHADDI STUDIOS PRIVATE LIMITED (OPC)',
    'EVENTUATE INNOVATIONS PRIVATE LIMITED',
    'INGEO CONTRACTOR PRIVATE LIMITED',
    'CCBA DESIGNS PRIVATE LIMITED',
    'XENONSTACK PRIVATE LIMITED',
    'OSTIUM MEDICOMM PRIVATE LIMITED',
    'SNOWLAN EPICURE PRIVATE LIMITED',
    'ORBIXON INFORMATICS PRIVATE LIMITED',
    'SOLVINTECH PRIVATE LIMITED',
    'EDZON TECH SERVICES PRIVATE LIMITED',
    'MATRIX FINANCERS LIMITED',
    'REMEDO WELLNESS PRIVATE LIMITED',
    'ADSKOM INDIA PRIVATE LIMITED',
    'GERMINATE AGRO MARKETING PRIVATE LIMITED',
    'MERISTEM RESEARCH AND CONSULTING PRIVATELIMITED',
    'RMSCLOUD SOFTWARE PRIVATE LIMITED',
    'SVASTANIBHANDA MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'TAC INFOSEC PRIVATE LIMITED',
    'PROBITY TECHNOLOGIES PRIVATE LIMITED',
    'AVME TECHNOLOGIES PRIVATE LIMITED',
    'DIGITALRIES PRIVATE LIMITED',
    'LEXGO ONLINE PRIVATE LIMITED',
    'UCONNECT PRIVATE LIMITED',
    'UNI-COM FINCORP PRIVATE LIMITED',
    'SECTOR 7 WORKSPACES PRIVATE LIMITED',
    'UTOPIA GREENTRANS PRIVATE LIMITED',
    'APPZ SOLUTIONS PRIVATE LIMITED',
    'WEBMAG (INDIA) PRIVATE LIMITED',
    'PROVIDENTIAL PLATFORMS PRIVATE LIMITED',
    'REVERSO HEALTHCARE PRIVATE LIMITED',
    'SKILLPLANET COMMUNITY PRIVATE LIMITED',
    'NIMIDA CAPITAL PRIVATE LIMITED',
    'AKULA CONSULTING INDIA PRIVATE LIMITED',
    'SIRI AB INDIA PRIVATE LIMITED',
    'LUMENORE SOLUTION (INDIA) PRIVATE LIMITED',
    'PEST SHIELDS INDIA PRIVATE LIMITED',
    'CHEMGENIX LABORATORIES PRIVATE LIMITED',
    'THINKXQ MARCOM PRIVATE LIMITED',
    'JAVIK VASUDHA PRIVATE LIMITED',
    'DE PRO SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'PRIDEROCK EDUCATION NETWORK PRIVATE LIMITED',
    'RPPELECTRICALS PRIVATE LIMITED',
    'MUKTHAA LIFESTYLE PRIVATE LIMITED',
    'SERENDIPITY ARTS PRIVATE LIMITED',
    'GRADITI SYSTEMS PRIVATE LIMITED',
    'SUNFLOW BATH PRIVATE LIMITED',
    'DAKSHINDIA DESTINATION MANAGEMENT PRIVATE LIMITED',
    'YOUNCHANG ENGINEERING INDIA PRIVATE LIMITED',
    'SHARK IDENTITY PRIVATE LIMITED',
    'INDIA UNIPER POWER SERVICES PRIVATE LIMITED',
    'NEW DELHI INCUBE & INNOVATE PRIVATE LIMITED',
    'ARG OUTLIER MEDIA PRIVATE LIMITED',
    'GOLDEN ERA AGRI SOLUTIONS PRIVATE LIMITED',
    'MAGNOLIAS DISTRIBUTION PRIVATE LIMITED',
    'AUDIENCETECH INDIA SOLUTIONS PRIVATE LIMITED',
    'CIRRUS LUXURY PRIVATE LIMITED',
    'OYYO TEXTILES PRIVATE LIMITED',
    'FUTUREWAGON PRIVATE LIMITED',
    'TVASTA MANUFACTURING SOLUTIONS PRIVATE LIMITED',
    'NEDFI VENTURE CAPITAL LIMITED',
    'NEXTBIO RESEARCH PRIVATE LIMITED',
    'BC PETRO ENERGY PRIVATE LIMITED',
    'ARNEJA INFOTECH PRIVATE LIMITED',
    'WALMOND CONSTRUCTIONS PRIVATE LIMITED',
    'SUASIVE CONSULTANTS PRIVATE LIMITED',
    'RATHINAM FINANCE LIMITED',
    'MYTRAH BHAGIRATHA POWER PRIVATE LIMITED',
    'MVI TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VARCHINNO TECHNOLOGIES PRIVATE LIMITED',
    'MAGNOLIAS RETAIL PRIVATE LIMITED',
    'GENASHI GEMS PRIVATE LIMITED',
    'UNITED PETROFER LIMITED',
    'SARG MEDIA HOLDING PRIVATE LIMITED',
    'AWESOME VENTURES PRIVATE LIMITED',
    'JUPEETER POLYFLEX PRIVATE LIMITED',
    'TRISHASHNA HOLDINGS & INVESTMENTS PRIVATE LIMITED',
    'APSALAR ANALYTICS PRIVATE LIMITED',
    'SCRUM TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'APPL MULTIPLE PRIVATE LIMITED',
    'ROMAAN VENTURES PRIVATE LIMITED',
    'ARTIFICIAL LEARNING SYSTEMS INDIA PRIVATE LIMITED',
    'STRUB TRADE PRIVATE LIMITED',
    'AXIOMMAX ONCOLOGY PRIVATE LIMITED',
    'P TRAVELOSURE PRIVATE LIMITED',
    'PIMOONY BROADBAND SERVICES PRIVATE LIMITED',
    'CORBETT INDUSTRIES (INDIA) PRIVATE LIMITED',
    'TECHKNOWSENSATIONS PRIVATE LIMITED',
    'DENTEDGE HEALTHCARE PRIVATE LIMITED',
    'MY GRAND WEDDING PRIVATE LIMITED',
    'VAIKUNDANATHA PERUMAL RENEWABLE ENERGY PRIVATE LIMITED',
    'VISHWAMBHAR ENTERPRISES PRIVATE LIMITED',
    'FREE THINKERS PRIVATE LIMITED',
    'REGEN BLADE MFG PRIVATE LIMITED',
    'TRUENORTH LABS PRIVATE LIMITED',
    'TEORAINN SOLAR PRIVATE LIMITED',
    'OPENCURVE DIGITAL MEDIA PRIVATE LIMITED',
    'RELIANCE FOUNDATION YOUTH SPORTS',
    'AMAP PRESS & TOOLS PRIVATE LIMITED',
    'KALIKAPUR NURSING HOME PRIVATE LIMITED',
    'THE NAZRBATTU PRODUCTIONS PRIVATE LIMITED',
    'GREEN WORLD PAINTS PRIVATE LIMITED',
    '100 MPH PRIVATE LIMITED',
    'BLUE DREAMZ BEVERAGES PRIVATE LIMITED',
    'MESON VALVES INDIA LIMITED',
    'KP CARS INTL PRIVATE LIMITED',
    'MATIAS FASHION AND LIFESTYLE PRIVATE LIMITED',
    'GREATER WARANGAL SMART CITY CORPORATION LIMITED',
    'MONTECARLO PROJECTS LIMITED',
    'KUMATHE RENEWABLE ENERGY PRIVATE LIMITED',
    'SHRESHTA REALTY ESTATE PRIVATE LIMITED',
    'DUBAF FOODS AND BEVERAGES PRIVATE LIMITED',
    'TEACHAKTIVE EDUCATION SOLUTIONS PRIVATE LIMITED',
    'SMAPSTERS OUTDOORS PRIVATE LIMITED',
    'ASCENTECH AERO LIFESTYLE PRIVATE LIMITED',
    'IRICH PRIVATE LIMITED',
    'KALA SWARAJ FOUNDATION.',
    'ATHARVA FREIGHT FORWARDERS PRIVATE LIMITED',
    'UNITED EKTA ENGINEERING PRIVATE LIMITED',
    'DAMJI HARI INFRA PRIVATE LIMITED',
    'GEOPURE AQUA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AHUJA GREEN TECHNOLOGIES PRIVATE LIMITED',
    'SKANDASHASU BUSINESS PROCESS SERVICES PRIVATE LIMITED',
    'EVENTSNOW PRIVATE LIMITED',
    'UTILITY PROJECTS AND SERVICES PRIVATE LIMITED',
    'TIGER FARMS AND ENTERPRISE PRIVATE LIMITED',
    'YOLO MEDIA PRIVATE LIMITED',
    'JBK CONTROLS INDIA PRIVATE LIMITED',
    'SPINEBIZ Services Private Limited',
    'GVR CONSULTING SERVICES PRIVATE LIMITED',
    'KIMS HOSPITAL ENTERPRISES PRIVATE LIMITED',
    'SHREE BALAJI COMMOTRADE PRIVATE LIMITED',
    'PRECISION GASIFICATION SERVICES PRIVATE LIMITED',
    'JITF URBAN WASTE MANAGEMENT (FEROZEPUR) LIMITED',
    'JITF URBAN WASTE MANAGEMENT (JALANDHAR) LIMITED',
    'SBP MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'TVARITA CONSULTING PRIVATE LIMITED',
    'INDIA TALKIES PRIVATE LIMITED',
    'AMBC TECHNOLOGIES PRIVATE LIMITED',
    'SPIRIT MEDIA PRIVATE LIMITED',
    'B P AGARWALLA & SONS LTD',
    'Teachforce Education & Training Private Limited',
    'VRUNDAVAN TECHNOLOGY AND MANAGEMENT PRIVATE LIMITED',
    'Extreme Projects Private Limited',
    'RANDSTAD INDIA Private Limited',
    'SHALOM INFOTECH PRIVATE LIMITED',
    'SUMUKHAA DEVELOPERS PRIVATE LIMITED',
    'MANITOU EQUIPMENT INDIA PRIVATE LIMITED',
    'NIWAS RESIDENTIAL & COMMERCIAL PROPERTIES PRIVATE LIMITED',
    'ERODE TEXTILE MALL Private Limited',
    'SHRINK PACKAGING SYSTEMS PRIVATE LIMITED',
    'MAHARANA INFRASTRUCTURE AND PROFESSIONAL SERVICES Limited',
    'GGV Managerial Services Private Limited',
    'NOIDA HEALTH CARE TRAINING AND PLACEMENTS PRIVATE LIMITED',
    'R.K.FLYWINGS PVT LTD',
    'INKNOWERSITY EDUCATION Private Limited',
    'MARUDHAR CULTIVATORS PRIVATE LIMITED',
    'RYBA KING AQUATECH SOLUTIONS PRIVATE LIMITED',
    'GENESIS MEDICAL SYSTEMS PRIVATE LIMITED',
    'MARUTI NANDAN HOUSING & LAND DEVELOPMENT PRIVATE LIMITED',
    'MARUTI NANDAN REALTEK PRIVATE LIMITED',
    'RAJDARBAR AYURVEDA PRIVATE LIMITED',
    'MARVEL VINYLS LIMITED.',
    'DR.SANGHVI',
    'S CONTROLS INDIA LIMITED',
    'EAGLE FORGINGS PRIVATE LIMITED',
    'RADNIK EXPORTS PRIVATE LIMITED',
    'RAGHAV HOME FASHIONS PRIVATE LIMITED',
    'PRIAPUS INFRASTRUCTURE LIMITED',
    'RAI BAHADUR NARAIN SINGH SUGAR MILLS LIMITED',
    'RAI PRINTOGRAPHICS PRIVATE LIMITED',
    'RAI SAHIB RAM CHARAN AND SONS PRIVATE LIMITED',
    'RAILTRANZ CONSULTANCY PRIVATE LIMITED',
    'MISTA DECOR PRIVATE LIMITED',
    'RAINBOW PRINTADS PRIVATE LIMITED',
    'Prima Infratech Private Limited',
    'DURATUF SAFETY GLASS PRIVATE LIMITED',
    'DURGA DAS PUBLICATIONS (INDIA) PRIVATE LIMITED',
    'RAJ KAMAL PRAKASHAN PVT LTD',
    'YOG MAYA CREATIONS PRIVATE LIMITED',
    'PRIMA REALTORS PRIVATE LIMITED',
    'Earth Environment Management Services Private Limited',
    'DURGA DAS PUBLICATIONS PRIVATE LIMITED',
    'DURGA DASS PRIVATE LIMITED',
    'PRIMCON MARKETING PRIVATE LIMITED',
    'OPEN SOLUTIONS SOFTWARE SERVICES PRIVATE LIMITED',
    'RADHA KRISHNA PRAKSHAN PRIVATE LIMITED',
    'RADHA RAJ INFRASTRUCTURE PRIVATE LIMITED',
    'VOLO HEALTH INSURANCE TPA PRIVATE LIMITED',
    'RADHIKA CONSTRUCTION COMPANY PRIVATE LIMITED',
    'EAST WEST RESCUE PRIVATE LTD.',
    'Radhika Heights Limited',
    'PROGRESSIVE COLONISER PRIVATE LIMITED',
    'EASY BILL Private Limited',
    'PROGRESSIVE FIBRE CONTAINERZ PRIVATE LIMITED',
    'RADHA KRISHAN AND SONS PRIVATE LIMITED',
    'EATINC FOOD & BEVERAGES PRIVATE LIMITED.',
    'EAST INDIA HOSPITALITY SERVICES PRIVATE LIMITED',
    'RADHAPHOOL FIN-INVESTMENTS PVT LTD',
    'RADIANT AIREXPRESS PRIVATE LIMITED',
    'ECOCAT (INDIA) PRIVATE LIMITED.',
    'Radiant e Quest Limited',
    'ECOS (INDIA) MOBILITY & HOSPITALITY PRIVATE LIMITED',
    'ECREATE EVENTS PRIVATE LIMITED',
    'ECOTECH HERBAL PRIVATE LIMITED',
    'Radicura Infra Limited',
    'RADIMAGE HEALTHCARE INDIA PRIVATE LIMITED',
    'EDEN RESIDENCY PRIVATE LIMITED',
    'Radio Design India Private Limited',
    'RAI AND SONS PVT LTD',
    'RAINBOW TRAVELS (INDIA) PVT LTD',
    'RAJ ESTATE AND PROPERTIES PRIVATE LIMITED',
    'EAGLE HOME ENTERTAINMENTS PRIVATE LIMITED',
    'Earth Gracia Buildcon Private Limited',
    'Earth Iconic Infrastructures Private Limited',
    'Educomp-Raffles Higher Education Limited.',
    'EARTH INFRASTRUCTURES LIMITED',
    'EARTHLINE APPARELS PRIVATE LIMITED',
    'PRIME INFRAHEIGHT PRIVATE LIMITED',
    'R.C COMPUSOFT PRIVATE LIMITED',
    'Echnologix Technical Services Private Limited',
    'E-homes Infrastructure Private Limited',
    'EKATRA HOSPITALITY VENTURES PRIVATE LIMITED',
    'METIS HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'EAST INDIA TECHNOLOGIES PRIVATE LIMITED.',
    'RAJAT DEVELOPERS PRIVATE LIMITED',
    '3 DIMENSIONAL INSURANCE BROKERS INDIA PRIVATE LIMITED',
    'GROW MONEY CAPITAL PRIVATE LIMITED',
    'RAJDHANI LEATHER PRIVATE LIMITED',
    'RAJDHANI MOTORS PVT LTD',
    'RAJESH BEARING PRIVATE LIMITED',
    'RAJGANGA AGRO PRODUCT PRIVATE LIMITED',
    'RAJGARH INDUSTRIES PRIVATE LIMITED',
    'RAJIV PLASTICS Private Limited',
    'RAKESH PAPERS PRIVATE LIMITED',
    'ECOWARE SOLUTIONS PRIVATE LIMITED',
    'Edesia Constructions Limited',
    'Edesia Developers Limited',
    'Edesia Infrastructure Limited',
    'Raj Chopra & Company Private Limited',
    'Robogenius Learning Solutions Limited',
    'GNex REALTECH PRIVATE LIMITED',
    'GREEN VALLY LAND AND DEVELOPMENT PRIVATE LIMITED',
    'GUARDIAN INTERNATIONAL PRIVATE LIMITED',
    'Gyans Maestros Private Limited',
    'H B P ESTATES PRIVATE LIMITED',
    'Agoda International India Private Limited',
    'MANAMI ENTERPRISES PRIVATE LIMITED',
    'GALWALIA ISPAT UDYOG Private Limited',
    'HAMZA TRADING AND INVESTMENTS PVT LTD',
    'HAP APPAREL PRIVATE LIMITED',
    'HAPA FASHIONS PRIVATE LIMITED',
    'BALAJI CONTRACTS & RESOURCES PRIVATE LIMITED',
    'GAMA BUSINESS TRAVEL (INDIA) PRIVATE LIMITED',
    'ALCON WIRELESS PRIVATE LIMITED',
    'GD OVERSEAS LIMITED',
    'HARE KRSNA PROJECTS PRIVATE LIMITED',
    'GD Securities Private Limited',
    'GEE SEE TOURS AND TRAVEL PRIVATE LIMITED',
    'GEM FINANCIERS AND DISTRIBUTORS PRIVATE LIMITED',
    'SHOGHI COMMUNICATIONS LIMITED',
    'GEMCO AUTOMOTIVE PRODUCTS PVT LTD',
    'GEMINI STEARATES PRIVATE LIMITED',
    'HYGEIA FRUIT AND VEGETABLE PROCESSORS PRIVATE LIMITED',
    'HIM TEKNOFORGE LIMITED',
    'GEMINI VINYLS PRIVATE LIMITED',
    'HASHBROWN SYSTEMS PRIVATE LIMITED',
    'HATHOR REALTORS PRIVATE LIMITED',
    'HAVELLS ELECTRONICS PVT LTD',
    'Haveus Aerotech India Private Limited',
    'GENERAL TRAVEL COMPANY PRIVATE LIMITED',
    'HAZRAT INAYAT KHAN FOUNDATION',
    'GENESIS CAPITAL ADVISORS PRIVATE LIMITED',
    'GENESIS PUBLISHING PRIVATE LTD',
    'GENIOUS PROMOTERS AND DEVELOPERS PRIVATE LIMITED',
    'GENUINE CREATIONS PRIVATE LIMITED',
    'GEO-TEC INTERNATIONAL PRIVATE LIMITED',
    'ART SPECIAL SITUATIONS FINANCE (INDIA) LIMITED',
    'GET GRUBS PRIVATE LIMITED',
    'GHAZIABAD WOOD SEASONING PRIVATE LIMITED',
    'HERMES BUILDERS AND DEVELOPERS LIMITED',
    'HERMES PROPERTIES LIMITED',
    'INCOTEC ENTERPRISES PRIVATE LIMITED',
    'HERO INSURANCE BROKING INDIA Private Limited',
    'HERO MANAGEMENT SERVICE Private Limited',
    'GCB OVERSEAS PRIVATE LIMITED',
    'HARI SHANKAR SINGHANIA HOLDINGS PRIVATE LIMITED',
    'HARISH CHANDRA INFRASTRUCTURE PVT. LTD',
    'HARIYALI FARMS PRIVATE LIMITED',
    'HEURISTICS INFORMATICS PRIVATE LIMITED',
    'HARJASE SUPPORT SERVICES LIMITED',
    'HH INTERIOR & AUTO COMPONENTS PRIVATE LIMITED',
    'Harmonic India Private Limited',
    'HI TOURS (INDIA) PRIVATE LIMITED',
    'HI TOURS CARS PRIVATE LIMITED',
    'HI TOURS PRIVATE LIMITED',
    'HARPREET INSURANCE AGENTS PRIVATE LIMITED',
    'HARRETON OVERSEAS PRIVATE LIMITED',
    'HARYANA JEWELLERS PRIVATE LIMITED',
    'HIGH STREET STORES PRIVATE LIMITED',
    'HARYANA WOOLLEN AND GENERAL MILLS PVT LTD',
    'JVT TRADING PRIVATE LIMITED',
    'HB SECURITIES LIMITED',
    'HBeonLabs Technologies Private limited',
    'H P AGRAWAL AND COMPANY PRIVATE LIMITED',
    'HALDI RAM PRODUCTS PRIVATE LIMITED',
    'HALDIRAM BHUJIA BHANDAR PRIVATE LIMITED',
    'HI-TECH AUDIO SYSTEMS PRIVATE LIMITED',
    'UNION FOODS PRIVATE LIMITED',
    'HONEYGOLD RETREATS PRIVATE LIMITED',
    'NEVITON SOFTECH PRIVATE LIMITED',
    'HESPERA REALTY PRIVATE LIMITED',
    'HESTIA HOSPITALITY PRIVATE LIMITED',
    'HOTEL HANS PRIVATE LIMITED',
    'HPL INDIA LIMITED',
    'HT Music and Entertainment Company Limited',
    'HUGHES AND HUGHES CHEM LIMITED',
    'HG ATOMS AND MOLECULES PRIVATE LIMITED',
    'Hi Tech Glazing Solutions Private Limited',
    'HICON ENGINEERING CO PRIVATE LTD',
    'HIDRIVE DEVELOPERS AND INDUSTRIES PRIVATE LIMITED',
    'HIGH BROW MARKETING SERVICES PRIVATE LIMITED',
    'I C B R BUILDERS PVT LTD',
    'Hilton Hotel Management Services Private Limited',
    'SCHIMMER INFRA PRIVATE LIMITED',
    'DION IMPEX PRIVATE LIMITED',
    'IDC TECHNOLOGIES SOLUTIONS INDIA PRIVATE LIMITED',
    'IDEAL IMPRESSIONS PRIVATE LIMITED',
    'UBN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HIMALAYA EXPORTS PVT LTD',
    'HCY INDUSTRIAL PARKS PRIVATE LIMITED',
    'HCY Warehousing Private Limited',
    'H-D Motor Company India Private Limited',
    'HECTOR REALCON PRIVATE LIMITED',
    'HERITAGE AVIATION PRIVATE LIMITED',
    'INDIA INTERNATIONAL HOUSE LIMITED',
    'INDIA LAND AND SPACE INFRASTRUCTURE PRIVATE LIMITED',
    'INDIA LAND AND SPACE LOGISTICS PRIVATE LIMITED',
    'INDIA LAND HOTELS MUMBAI Private LIMITED',
    'INDIA OUTSOURCING PARTNERS PRIVATE LIMITED',
    'HERO CORPORATE SERVICE Private Limited',
    'HIND ENTERPRISES PRIVATE LIMITED',
    'HEROLD INFRA PRIVATE LIMITED',
    'HESPERA LAND DEVELOPMENT PRIVATE LIMITED',
    'HORIZON INDUSTRIAL PRODUCTS PRIVATE LIMITED',
    'HUMMEL CONNECTOR SYSTEMS PRIVATE LIMITED',
    'Indiabulls Commercial Credit Limited',
    'INDIABULLS COMMERCIAL PROPERTIES LIMITED',
    'DHANI STOCKS LIMITED',
    'INDIABULLS CONSTRUCTIONS LIMITED',
    'INDIABULLS DISTRIBUTION SERVICES LIMITED',
    'LAAJ INTERNATIONAL PRIVATE LIMITED',
    'Latona Builders & Constructions Private Limited',
    'KRUGER CONSULTING PRIVATE LIMITED',
    'LAXMI AGRO INDUSTRIAL CONSULTANTS & EXPORTERS LIMITED',
    'LAKISHA REAL ESTATE LIMITED',
    'LAXMI REMOTE (INDIA) PRIVATE LIMITED',
    'LAXMIVILA INFRATECH PRIVATE LIMITED',
    'LB Circle India Private Limited',
    'LAN RAILTECH PRIVATE LIMITED',
    'LE PASSAGE TO INDIA TOURS AND TRAVELS PRIVATE LIMITED',
    'LEADER DOCUMENT PROCESSING PRIVATE LIMITED',
    'LEADING EDGE COMMUNICATION PRIVATE LIMITED',
    'LEADING EDGE INFRATECH PRIVATE LIMITED',
    'Lanaa Clothing (India) Private Limited',
    'KS ARCIS OUTSOURCING PRIVATE LIMITED',
    'KS MOBILES & MORE PRIVATE LIMITED',
    'KOSHINOVA ENGINEERING PRIVATE LIMITED',
    'LEARNING EDGE ACADEMY OF PROFESSIONALS PRIVATE LIMITED',
    'LEARNINGLINKS PUBLISHING HOUSE PRIVATE LIMITED',
    'LEEDS SPORTS PRIVATE LIMITED',
    'LEELA TRENDZ PRIVATE LIMITED',
    'KSHITIJ INDIA PRIVATE LIMITED',
    'LANDMARK REALTECH PRIVATE LIMITED',
    'LEGEND TRAVELS PRIVATE LIMITED',
    'LEGENDARY SWORDS PRIVATE LIMITED',
    'LEGION ENTERTAINMENT PRIVATE LIMITED',
    'LEGO India Private Limited',
    'LEISUREZONE CAFE PRIVATE LIMITED',
    'Lelogix Design Solutions Private Limited',
    'LANDSCAPE OUTSOURCE MARKETING PRIVATE LIMITED',
    'LANEXIS PRIVATE LIMITED',
    'LANGERS INTERNATIONAL PRIVATE LIMITED',
    'LANGHAM CAPITAL INDIA PRIVATE LIMITED',
    'LARK Sunam Hospitals Private Limited',
    'LENUS PROPERTIES LIMITED',
    'LASER CHITS PRIVATE LIMITED',
    'LEOS BUSINESSES PRIVATE LIMITED',
    'Leuze electronic Private Limited',
    'LEVANA IVF CENTER PRIVATE LIMITED',
    'EPSILON EMBEDDED COMPUTING PRIVATE LIMITED',
    'LASERVISION ESTATES PRIVATE LIMITED',
    'G C S COMPUTER TECHNOLOGY PRIVATE LIMITED',
    'LAVONE BUILDERS AND DEVELOPERS LIMITED',
    'LAXMI PUBLICATIONS PRIVATE LIMITED',
    'LCG INDUSTRIES PRIVATE LIMITED',
    'LANCERS CONSULTANTS PRIVATE LIMITED',
    'LGN Estates and Realtors Private Limited',
    'LHAWANG PILGRIMAGE PRIVATE LIMITED',
    'ANANDA HOUSE PRIVATE LIMITED',
    'LIBRA DIESEL ENGINEERS PRIVATE LIMITED',
    'LAND MARK DEALERS PRIVATE LIMITED TRS FROM CALCUTTA',
    'LANDBASE INFRATECH PRIVATE LIMITED',
    'LIFELONG INDIA Private Limited',
    'LIFELONG MEDITECH Private Limited',
    'LIFESTYLE HOSPITALITES PRIVATE LIMITED',
    'LIFESTYLE PROPBUILD PRIVATE LIMITED',
    'LANDBASE PROPERTIES PRIVATE LIMITED',
    'LANDMARK PROPERTY DEVELOPMENT COMPANY LIMITED',
    'Ligare Aviation Engineering Private Limited',
    'SPECTRUM ACADEMY PRIVATE LIMITED',
    'LIGHT MICROFINANCE PRIVATE LIMITED',
    'Light Speed Solutions Private Limited',
    'LILAC REAL ESTATES DEVELOPERS PRIVATE LIMITED',
    'Lilac Steel Private Limited',
    'LEMONMINT HOSPITALITY SERVICES PRIVATE LIMITED',
    'LEMONMINT TOURS PRIVATE LIMITED',
    'LinkedIn Technology Information Private Limited',
    'LENSER COMMUNICATIONS PRIVATE LIMITED',
    'LENUS CONSTRUCTIONS LIMITED',
    'LENUS INFRASTRUCTURE LIMITED',
    'COLORPLUS CARDS PRIVATE LIMITED',
    'LEVINA INVESTMENT AND MERCANTILE COMPANY',
    'LEX ORBIS CONSULTING PRIVATE LIMITED',
    'LEXNOVUM CONSULTAIRE PRIVATE LIMITED',
    'LEXPLOSION SOLUTIONS PRIVATE LIMITED',
    'LITE BITE FOODS PRIVATE LIMITED',
    'LITE BITE TRAVEL FOODS PRIVATE LIMITED',
    'LEADING LINE MERCHANT TRADERS PRIVATE LIMITED',
    'LEADING TRAVEL ASSOCIATES PRIVATE LIMITED',
    'LIC CARDS SERVICES LIMITED',
    'LIVE WIRE CUSTOMER MANAGEMENT SERVICES PRIVATE LIMITED',
    'LIVE WITH TRUE VALUE DEVELOPERS PRIVATE LIMITED',
    'LeapStart Trustee Company Private Limited',
    'Learn Academy Systems Private Limited',
    'ELECTRO RENT INDIA PRIVATE LIMITED',
    'LEGACY BUILDWELL PRIVATE LIMITED',
    'LEGEND STOCK BROKING COMPANY PRIVATE LIMITED',
    'Limitless Mobility Solutions Private Limited',
    'Linnet Constructions Limited',
    'Linnet Developers Limited',
    'LNG AGRICOM PRIVATE LIMITED',
    'LNM INDYA TEXTILES PRIVATE LIMITED',
    'Lodhi Property Company Limited',
    'LOFT FURNITURE DESIGN PRIVATE LIMITED',
    'LOGIC COMMERCIAL ENTERPRISES PRIVATE LIMITED',
    'LOGIC FRUIT TECHNOLOGIES PRIVATE LIMITED',
    'Linnet Infrastructure Limited',
    'Linnet Properties Limited',
    'LOGIX ESTATES PRIVATE LIMITED',
    'LOGIX FINANCE & INVESTMENT PVT.LTD.',
    'Logix Infra Developers Private Limited',
    'LOGIX INFRATECH PRIVATE LIMITED',
    'LOGIX REALTORS PRIVATE LIMITED',
    'LOHIA NETWORKS PRIVATE LIMITED',
    'KRISH AUTOMOTORS PRIVATE LIMITED',
    'Linnet Real Estate Limited',
    'WELFURN INTERIORS PRIVATE LIMITED',
    'JSH CONSULTANTS INDIA PRIVATE LIMITED',
    'DEVSONS ADVERTISING PRIVATE LIMITED',
    'E4TCOMM',
    'ROUTING SWITCHING TIGERS PRIVATE LIMITED',
    'IQRA QUALITY SERVICES PRIVATE LIMITED',
    'LIVEINNOVATIVE STAY SOLUTIONS PRIVATE LIMITED',
    'YAASHINI TOURS & TRAVELS PRIVATE LIMITED',
    'ELEGARE BEAUTY PRIVATE LIMITED',
    'SINEW SOFTWARE SYSTEMS PRIVATE LIMITED',
    'PHYPAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'KSTUDIO SOLUTIONS PRIVATE LIMITED',
    'SEEME NETWORK PRIVATE LIMITED',
    'PINSOFT TECHNOLOGIES PRIVATE LIMITED',
    'ACUITI LABS (INDIA) PRIVATE LIMITED',
    'GAUTAM POLYCHEM PRIVATE LIMITED',
    'XPECTRUM INFOMEDIA PRIVATE LIMITED',
    'INNOLLENCE CONSULTING PRIVATE LIMITED',
    'NEUTRON MEDICALS PRIVATE LIMITED',
    'TAMARA FARMS PRIVATE LIMITED',
    'SYNJERGO TECHNOLOGIES PRIVATE LIMITED',
    'MAXIM MARCOM SERVICES PRIVATE LIMITED',
    'DEVI CITY INDUSTRIAL PARK PRIVATE LIMITED',
    'EASYKRISHI PRIVATE LIMITED',
    'ASM ENGINEERING TECHNOLOGIES PRIVATE LIMITED',
    'STAIRWELL VENTURES PRIVATE LIMITED',
    'CANDIDAFFAIR STUDIO PRIVATE LIMITED',
    'ENSIGN INFOSYSTEMS PRIVATE LIMITED',
    'PANSOFT TECHNOLOGIES PRIVATE LIMITED',
    'CYNIX LABS PRIVATE LIMITED',
    'KOLLECTCARE PRIVATE LIMITED',
    'CLICHE WITHA TWIST PRIVATE LIMITED',
    'CHRYSALIS DIGITAL SOLUTIONS AND SERVICESPRIVATE LIMITED',
    'LIGHT AND YOU PRIVATE LIMITED',
    'GUJARAT EARTH MINERALS PRIVATE LIMITED',
    'PRIMODIA ENERGY SYSTEMS PRIVATE LIMITED',
    'MULTITEK CONTROLS PRIVATE LIMITED',
    'CLOUDTHING INDIA PRIVATE LIMITED',
    'SNA MILK AND MILK PRODUCTS PRIVATE LIMITED',
    'TIME CYBERMEDIA PRIVATE LIMITED',
    'LITECO TECNOLOGIES AND ENGINEERING PRIVATE LIMITED',
    '24 X 7 SECURITY ALLIANCE PRIVATE LIMITED',
    'A K JAIN SALES & MARKETING PRIVATE LIMITED',
    'PACELITE MULTI SOLUTIONS PRIVATE LIMITED',
    'ASSERTIVE EDUCON PRIVATE LIMITED',
    'DOCPRIME TECHNOLOGIES PRIVATE LIMITED',
    'SELECTNEXT DIGITAL MEDIA PRIVATE LIMITED',
    'GIRKUNJA CONSTRUCTION PRIVATE LIMITED',
    'RAJHANS MULTIPLEX PRIVATE LIMITED',
    'EXCOSA INDIA PRIVATE LIMITED',
    'GYNOFEM HEALTHCARE PRIVATE LIMITED',
    'VWANDER TRAVEL PRIVATE LIMITED',
    'SPARKCLEAN TECHNOLOGIES PRIVATE LIMITED',
    'PRIVI EXPORTS PRIVATE LIMITED',
    'DOMAUTICS PRIVATE LIMITED',
    'OPTIMINT SOLUTIONS PRIVATE LIMITED',
    'HEALTH ORBIT TRADING PRIVATE LIMITED',
    'INSTASOFT TECHNOLOGIES PRIVATE LIMITED',
    'ASPM CONSULTING (OPC) PRIVATE LIMITED',
    'PRANSFORM PRIVATE LIMITED',
    'SMARTVISION REALESTATE (INDIA) PRIVATE LIMITED',
    'PNC DESIGN AND DEVELOPMENT PRIVATE LIMITED',
    'LCE SKILLS TRAINING PRIVATE LIMITED',
    'AADI ENGINEERING PRIVATE LIMITED',
    'NEWMEK SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SIDDHANTH LEARNING SOLUTIONS PRIVATE LIMITED',
    'TECHMENT LABS PRIVATE LIMITED',
    'ADVINO HEALTHCARE PRIVATE LIMITED',
    'TAP SENSE TECHNOLOGIES PRIVATE LIMITED',
    'SURGERI TECHNOLOGIES PRIVATE LIMITED',
    'LULU AND SKY BRANDS PRIVATE LIMITED',
    'EXCELIUN SOLUTIONS PRIVATE LIMITED',
    'SILITECH SYSTEMS PRIVATE LIMITED',
    'SN SYSTEMS PRIVATE LIMITED',
    'KHUSHBOO ENGRAVURES PRIVATE LIMITED',
    'SCHNELL RESEARCH PARTNERS PRIVATE LIMITED',
    'RALVON INFRA PRIVATE LIMITED',
    'RAPIDO PAYMENTS PRIVATE LIMITED',
    'HOME4PET E-COMMERCE PRIVATE LIMITED',
    'SABIO COMMERCE PRIVATE LIMITED',
    'V6 INFRASTRUCTURES PRIVATE LIMITED',
    'CPC PRECICOMP PRIVATE LIMITED',
    'MY TRIP DZIRE INDIA PRIVATE LIMITED',
    'MOD-BIT SPACE FURNISHINGS PRIVATE LIMITED',
    'ICORETS PRIVATE LIMITED',
    'BLAZINGMINDS EDUSERV PRIVATE LIMITED',
    'AARFID INDIA PRIVATE LIMITED',
    'MTECH BUILDCON PRIVATE LIMITED',
    'XPRESS FREIGHT SOLUTIONS PRIVATE LIMITED',
    'ANIK MILK PRODUCTS PRIVATE LIMITED',
    'CONCIPIO POWER PRIVATE LIMITED',
    'PUNIRGAURAV DEVELOPERS PRIVATE LIMITED',
    'REWANTA FASHIONS PRIVATE LIMITED',
    'CODESABERS TECHNOLOGY (OPC) PRIVATE LIMITED',
    'STARLING EYE PRIVATE LIMITED',
    'ATHULYA MERCHANTS PRIVATE LIMITED',
    'CB SERVICES INDIA PRIVATE LIMITED',
    'APPSINVO PRIVATE LIMITED',
    'SERVICEMART TECHNOLOGIES PRIVATE LIMITED',
    'ARTVAULT TECHNOLOGIES PRIVATE LIMITED',
    'TEAFLECTIONS PRIVATE LIMITED',
    'NEENOPAL INTELLIGENT SOLUTIONS PRIVATE LIMITED',
    'FINZEN FINTECH PRIVATE LIMITED',
    'PRENU SERVICES PRIVATE LIMITED',
    'ORAH NUTRICHEM PRIVATE LIMITED',
    'SANNER OF INDIA PRIVATE LIMITED',
    'BDS MACHINES PRIVATE LIMITED',
    'VERSATILETECH VENTURES PRIVATE LIMITED',
    'PREDII INDIA PRIVATE LIMITED',
    'AKSHAT SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'TRADEVISER (OPC) PRIVATE LIMITED',
    'VOLYTY INDIA PRIVATE LIMITED',
    'JAYASREE REVA PHOENIX METROLOGY PRIVATE LIMITED',
    'EXHIBITS EXPO PRIVATE LIMITED',
    'MARVEL CORPORATE SERVICES PRIVATE LIMITED',
    'SOLARYTE INDIA PRIVATE LIMITED',
    'QWIKPIK TECHNOLOGY PRIVATE LIMITED',
    'ANMOL INFOMEDIA PRIVATE LIMITED',
    'GOLD LINE SOLUTION PRIVATE LIMITED',
    'BIGTRANS INDIA PRIVATE LIMITED',
    'WATERWAYS CERAMICA PRIVATE LIMITED',
    'JAYVEER DENIM PRIVATE LIMITED',
    'VELFOUR SERVICES PRIVATE LIMITED',
    'SOLARINERTIA POWER PRIVATE LIMITED',
    'BLUE JWEL PRIVATE LIMITED',
    'BIOTRAK RESEARCH AND DIAGNOSTICS CENTRE PRIVATE LIMITED',
    'FOXTECH MECH ENGINEERS PRIVATE LIMITED',
    'TRANSIN LOGISTICS PRIVATE LIMITED',
    'NSE ACADEMY LIMITED',
    'TRITON VENTURES PRIVATE LIMITED',
    'KALAKRUTII ASSOCIATES PRIVATE LIMITED',
    'OOF VENTURES PRIVATE LIMITED',
    'COREINTEGRA GLOBAL SERVICES PRIVATE LIMITED',
    'CM OVERSEAS ENTERPRISES PRIVATE LIMITED',
    'WELCOME ANDAMAN TRAVELS PRIVATE LIMITED',
    'INTERCAX TECHNOLOGIES PRIVATE LIMITED',
    'TROVA TECHNOLOGIES PRIVATE LIMITED',
    'SKREEM TECHNOLOGY PRIVATE LIMITED',
    'MYRIAD SOFTCORP PRIVATE LIMITED',
    'DREAMLAND CLUB AND RESORTS PRIVATE LIMITED',
    'OSSVISOR INDIA PRIVATE LIMITED',
    '3I MOLECULAR SOLUTIONS AND HEALTHCARE SERVICES PRIVATE LIMITED',
    'IGLOOIN SERVICES PRIVATE LIMITED',
    'SILVERPEAK PROJECTS PRIVATE LIMITED',
    'SRI VENKATESWARA ALTERNATIVE FUEL INDUSTRIES PRIVATE LIMITED',
    'DATASIGNS TECHNOLOGIES PRIVATE LIMITED',
    'APRUS BIO-MEDICAL INNOVATIONS PRIVATE LIMITED',
    'SHRACOM PRIVATE LIMITED',
    'N.K.PNEUMATICS PRIVATE LIMITED',
    'FUTURESOFT DIGITAL INDIA PRIVATE LIMITED',
    'NUTRACODE HOLDINGS PRIVATE LIMITED',
    'MAHAVATAR BABAJI ENTERTAINMENT PRIVATE LIMITED',
    'NOVASYS HEALTH SYSTEMS PRIVATE LIMITED',
    'OPENKNOTS PRIVATE LIMITED',
    'STAR COMNET PRIVATE LIMITED',
    'PLOWNS INDIA PRIVATE LIMITED',
    'AIPEX WORLDWIDE (OPC) PRIVATE LIMITED',
    'FTC TALENT MEDIA & ENTERTAINMENT PRIVATELIMITED',
    'A&B CONSULTANCY SOLUTIONS PRIVATE LIMITED',
    'ENROCO TECHNOLOGIES PRIVATE LIMITED',
    'GOLDENKEY INDIA PRIVATE LIMITED',
    'PI SQUARE INNOVATIONS PRIVATE LIMITED',
    'DRJ FILMS PRIVATE LIMITED',
    'B.P.A.I. FOODS PRIVATE LIMITED',
    'SATAV PATIL FOODS AND BEVERAGES PRIVATE LIMITED',
    'DALLACE INFRACON LIMITED',
    'D. N. DESIGNS PRIVATE LIMITED',
    'THE DALAL FAMILY CHARITABLE FOUNDATION',
    'BLUE CLOUD PEOPLE SOLUTIONS (OPC) PRIVATE LIMITED',
    'AKSARA AUTOS PRIVATE LIMITED',
    'EMSEVA PRIVATE LIMITED',
    'MAHAVEER MEDI-SALES PRIVATE LIMITED',
    'MUTHU PHARMA PRIVATE LIMITED',
    'JASMINE SOURCING PRIVATE LIMITED',
    'WORLDWIDE COLONISERS PRIVATE LIMITED',
    'RISE GALLAERY PRIVATE LIMITED',
    'YZ FITNESS & SPORTS ARENA PRIVATE LIMITED',
    'UPVERSE SOLUTIONS PRIVATE LIMITED',
    'ALCOVE BUSINESS ADVISORY PRIVATE LIMITED',
    'GANGBOARD TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'BREADDISTRICT FOODS PRIVATE LIMITED',
    'SKAAH SUPPLY CHAIN LOGISTICS PRIVATE LIMITED',
    'ARRA HOSPITALITY GROUP PRIVATE LIMITED',
    'OMEK ENTERPRISE PRIVATE LIMITED',
    'DRONA EXPORTS PRIVATE LIMITED',
    'THIRUNAVUKKARASU REBAR DETAILING (OPC) PRIVATE LIMITED',
    'AXION TECHNICAL SERVICES PRIVATE LIMITED',
    'JOHNKART ONLINE TRADE AND SERVICES PRIVATE LIMITED',
    'V&J FURNISHINGS PRIVATE LIMITED',
    'TECHNOREVO SOFTWARES PRIVATE LIMITED',
    'WEB BYTE TECHNOLOGIES PRIVATE LIMITED',
    'FAIRLEAD INSPECTION & TESTING PRIVATE LIMITED',
    'TWIG SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HANSEL SOFTWARE PRIVATE LIMITED',
    'IOTIUM SYSTEMS PRIVATE LIMITED',
    'JD SYSTEMS INDIA PRIVATE LIMITED',
    'DORSAL EXPOVENTURE PRIVATE LIMITED',
    'BRIGHT OMNIA TRADING PRIVATE LIMITED',
    'N2S TECHNOLOGIES PRIVATE LIMITED',
    'KINGAR SIGNS PRIVATE LIMITED',
    'CRON SYSTEMS PRIVATE LIMITED',
    'MICROSKIN SOLUTIONS INDIA PRIVATE LIMITED',
    'CREATION TECHNICS INDIA PRIVATE LIMITED',
    'GENLINK PHARMA SOLUTIONS PRIVATE LIMITED',
    'RIPPLEMART TECHNOLOGIES PRIVATE LIMITED',
    'ESAF SMALL FINANCE BANK LIMITED',
    'SAHYOG ADVISORY SERVICES PRIVATE LIMITED',
    'ORO CONSTRUCTIONS PRIVATE LIMITED',
    'VISIONSOFT ASPAC PRIVATE LIMITED',
    'CREDITSAFE TECHNOLOGY PRIVATE LIMITED',
    'HIND GRANITES PRIVATE LIMITED',
    'ICONIC DENIM PRIVATE LIMITED',
    'DR RAOS ENT SUPER SPECIALITY INTERNATIONAL HOSPITAL PRIVATE LIMITED',
    'TALWALKARS CLUB SYSTEMS PRIVATE LIMITED',
    'HP FOOD PRIVATE LIMITED',
    'PCPL COMMERCIAL PRIVATE LIMITED',
    'COMPTON DIGITAL INDIA INITIATIVE PRIVATE LIMITED',
    'AUSTERE ANALYTICS SOLUTIONS PRIVATE LIMITED',
    'FOUNDATION FOR SANDBOXSTARTUP INITIATIVES',
    'NR COMMERCE PRIVATE LIMITED',
    'AERIS COMMUNICATIONS INDIA PRIVATE LIMITED',
    'HCT AUTOLINE PRIVATE LIMITED',
    'PRANETOR SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'EMAYAM INDUSTRIES PRIVATE LIMITED',
    'DEVAKI HI-ENERGY BATTERIES PRIVATE LIMITED',
    'GROWTH STREET SOLAR PRIVATE LIMITED',
    'DECIZEN MINDS PRIVATE LIMITED',
    'NAVARATAN TECHNOLOGIES PRIVATE LIMITED',
    'NEXIBIT SOLUTIONS PRIVATE LIMITED',
    'NAVACHETANA EMPLOYEES WELFARE PRIVATE LIMITED',
    'SCOUTERS PRIVATE LIMITED',
    'PARITY CONSULTING AND TRAINING PRIVATE LIMITED',
    'LOTUS ASSET DEVELOPMENT AND MANAGEMENT INDIA PRIVATE LIMITED',
    'TELEGLOBAL COMMUNICATIONS PRIVATE LIMITED',
    'AAPAH INNOVATIONS PRIVATE LIMITED',
    'RAY MACH TECHNOLOGIES PRIVATE LIMITED',
    'JONIC SUN FINTECH SOLUTIONS PRIVATE LIMITED',
    'BRHATT RESTAURANT PRIVATE LIMITED',
    'AHAMMUNE BIOSCIENCES PRIVATE LIMITED',
    'KET INFOTECH PRIVATE LIMITED',
    'STELLA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'COCHIN SMART MISSION LIMITED',
    'YUG CARGO AND COURIER SERVICES PRIVATE LIMITED',
    'ZENITH BIRLA STEELS PRIVATE LIMITED',
    'DEERAJ TEA PRIVATE LIMITED',
    'ZED LIFESTYLE PRIVATE LIMITED',
    'AZURE POWER THIRTY SEVEN PRIVATE LIMITED',
    'ELEMENTAR INDIA PRIVATE LIMITED',
    'MARSTI MITHYA PRIVATE LIMITED',
    'MANUREVA DIGITAL SOLUTIONS INDIA PRIVATELIMITED',
    'SMHACK PRIVATE LIMITED',
    'SAYAJI HOUSEKEEPING SERVICES LIMITED',
    'INDUSTRYLANE SOLUTIONS PRIVATE LIMITED',
    'PRINCIPLE INDIA PRIVATE LIMITED',
    'SARONDA WORLD PRIVATE LIMITED',
    'VASTA BIO-INFORMATICS PRIVATE LIMITED',
    'RISINGJUPITER INDIA PRIVATE LIMITED',
    'ELEICS DESIGN PRIVATE LIMITED',
    'QUAGGA TECH PRIVATE LIMITED',
    'ANDHRA PRADESH MEDTECH ZONE LIMITED',
    'ESTONTEC (OPC) PRIVATE LIMITED',
    'QUAERO 3 (INDIA) PRIVATE LIMITED',
    'RIOT SOLUTIONS PRIVATE LIMITED',
    'LAKSHMI HOSPITALITY & FARMS PRIVATE LIMITED',
    'LIMRA TECHNOSYS PRIVATE LIMITED',
    'TECHAIM INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'EBENEZER SKILL DEVELOPMENT INDUSTRY (OPC) PRIVATE LIMITED',
    'DUCK LEARNING INDIA PRIVATE LIMITED',
    'ASCENTRIK RESEARCH PRIVATE LIMITED',
    'BIZCRAFT SOLUTIONS PRIVATE LIMITED',
    'COALSHASTRA PRIVATE LIMITED',
    'TRACKMYKID INDIA PRIVATE LIMITED',
    'GRAYLAB TECHNOLOGIES PRIVATE LIMITED',
    'BI MINING PRIVATE LIMITED',
    'DIPONED BIO PRIVATE LIMITED',
    'SVR AGROTECH PRIVATE LIMITED',
    'PEPCART LOGISTICS PRIVATE LIMITED',
    'LAND KART BUILDERS PRIVATE LIMITED',
    'SYNERGY CROPSCIENCE PRIVATE LIMITED',
    'VIBHIN ONLINE SERVICES PRIVATE LIMITED',
    'VALLARPADAM MOVERS PRIVATE LIMITED',
    'APPOINTY INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'QUMBA TRANSPORT TECHNOLOGY PRIVATE LIMITED',
    'BEE ONLINE COMMUNICATION PRIVATE LIMITED',
    'FUTURE PIPE INDUSTRIES SERVICES PRIVATE LIMITED',
    'ALEPA DAIRY FOODS PRIVATE LIMITED',
    'O&M ONE ADVISORY AND OPERATIONS PRIVATE LIMITED',
    'APOGEE INSURANCE MARKETING PRIVATE LIMITED',
    'WELCOME IT TECHNOLOGIES PRIVATE LIMITED',
    'PARIMITY SOLUTIONS & SERVICES PRIVATE LIMITED',
    'STREETBELL TECHNOLOGIES PRIVATE LIMITED',
    'KIN CHAIN (OPC) PRIVATE LIMITED',
    'LOTUS INTERMODAL LOGISTICS INDIA PRIVATELIMITED',
    'OPTIMIDEA NETWORK PRIVATE LIMITED',
    'FLOWMAX FILTRATION INDIA PRIVATE LIMITED',
    'V19 SOFTECH PRIVATE LIMITED',
    'PROSENSE SERVICES PRIVATE LIMITED',
    'MANOHAR SARDA FOODS PRIVATE LIMITED',
    'UNOCAREER SERVICES PRIVATE LIMITED',
    'YEPPLER INTERNET SOLUTIONS PRIVATE LIMITED',
    'MCTEC (INDIA) PRIVATE LIMITED',
    'APRIKOSE PHARMACEUTICALS PRIVATE LIMITED',
    'STRIVO PHARMA PRIVATE LIMITED',
    'SKAJEN VITRIFIED PRIVATE LIMITED',
    'REVATA ENGINEERING PRIVATE LIMITED',
    'UCH LOGISTICS (INDIA) PRIVATE LIMITED',
    'PROMISING PR NETWORKS (INDIA) PRIVATE LIMITED',
    'XPLORENA BUSINESS SOLUTIONS (OPC) PRIVATE LIMITED',
    'G&G INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'GNARUS SOLUTIONS PRIVATE LIMITED',
    'THARAWAT DEV INDIA PRIVATE LIMITED',
    'WEBCONTXT INDIA PRIVATE LIMITED',
    'SANKON TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VASCO HOSPITALITY PRIVATE LIMITED',
    'NETWORK OF INDIAN MICE AGENTS',
    'DHM PROJECTS PRIVATE LIMITED',
    'STEP TOMORROW SERVICES PRIVATE LIMITED',
    'BLE MEDIA SOLUTIONS PRIVATE LIMITED',
    'E-DINERO CONSULTANTS PRIVATE LIMITED',
    'TECHNOTRENDZ SOLUTIONS PRIVATE LIMITED',
    'AERODESIGN SOLUTIONS PRIVATE LIMITED',
    'HIPPOCAMPUS HEALTH CARE PRIVATE LIMITED',
    'DROVE SECURITY SOLUTION PRIVATE LIMITED',
    'A.T.E. CHANDRA FOUNDATION',
    'TECHNOCARE CITIZEN SERVICES COUNCIL',
    'MOTOCRUIZER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HOPFIRST INFOCOMM PRIVATE LIMITED',
    'DUGANTA OIL AND NATURAL GAS PRIVATE LIMITED',
    'CORECRED TECHNOLOGIES PRIVATE LIMITED',
    'LAKSHYALEADERS EDUCATION SOFTWARE PRIVATE LIMITED',
    'ADVIKS ENGLISH ACADEMY PRIVATE LIMITED (OPC)',
    'NOVAVENTE PRIVATE LIMITED',
    'SAUBHAGYATECH (OPC) PRIVATE LIMITED',
    'CRATIS MEDIA PRIVATE LIMITED',
    'SOCIAL WORTH TECHNOLOGIES PRIVATE LIMITED',
    'ISTTM INDIA PRIVATE LIMITED',
    'RXPONT INDIA PRIVATE LIMITED',
    'AMALTAAS CONCEPT (OPC) PRIVATE LIMITED',
    'THEORGANIC CARBON PRIVATE LIMITED',
    'SCENICBEAUTY HOMES PRIVATE LIMITED',
    'GREEN SUSTAINABLE ALLIANCE PRIVATE LIMITED',
    'GAMYAM TECHNOLOGIES PRIVATE LIMITED',
    'HARIDHAM CONSTRUCTION PRIVATE LIMITED',
    'GOWARDHAN KRUSHI AYURVED PRIVATE LIMITED',
    'AASAAN SERVICES SOLUTIONS PRIVATE LIMITED',
    'ECORECO ENVIRO EDUCATION PRIVATE LIMITED',
    'DIGIOTECH SOLUTIONS PRIVATE LIMITED',
    'VEATIVE LABS PRIVATE LIMITED',
    'KUBER ETHNIC STORY PRIVATE LIMITED',
    'GOLDEN GOOSE SPORTS PRIVATE LIMITED',
    'SHUBHKARMA UDYOG PRIVATE LIMITED',
    'HYDROGEN GENTECH PRIVATE LIMITED',
    'INSTADO TECH PRIVATE LIMITED',
    'EAZIPOINTS SYSTEMS PRIVATE LIMITED',
    'COUNSELKART EDUCATIONAL SERVICES PRIVATE LIMITED',
    'WISH KART MARKETING CONSULTANCY PRIVATE LIMITED',
    'TENCO FOODS PRIVATE LIMITED',
    'STANOFIC PRIVATE LIMITED',
    'BRANDSWIND PRIVATE LIMITED',
    'MURTI LOGISTICS PRIVATE LIMITED',
    'ANCHOR DESTINATIONS AND TRAVEL MANAGEMENT PRIVATE LIMITED',
    'RUBYKON MFG.CO. PRIVATE LIMITED',
    'AADYAH AEROSPACE PRIVATE LIMITED',
    'WESCALEIT INDIA PRIVATE LIMITED',
    'PMD INFRASTRUCTURE & DEVELOPMENT PRIVATELIMITED',
    'NECRON PHARMA SPECIALITY PRODUCTS PRIVATE LIMITED',
    'PRIMA TERRA INFOTECH PRIVATE LIMITED',
    'SGGR CONSULTING ENGINEERS PRIVATE LIMITED',
    'UNIFY BUILDING TECHNOLOGIES PRIVATE LIMITED',
    'NOVAMR ADS AND MEDIA PRIVATE LIMITED',
    'A G TRAINING AND INNOVATION CENTRE',
    'BIG EDGE SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'SNACKPACK PRIVATE LIMITED',
    'HELIX PRIVATE LIMITED',
    'DHANALAXMI TIMBERS PRIVATE LIMITED',
    'LETZ CONNECT TECHNOLOGIES PRIVATE LIMITED',
    'SG GLOBAL SUPPORT SERVICES INDIA PRIVATE LIMITED',
    'ROSEN INDIA PRIVATE LIMITED',
    'CHANDNI MACHINES LIMITED',
    'BVG-UKSAS EMS PRIVATE LIMITED',
    'FUNDTONIC SERVICE PRIVATE LIMITED',
    'NETBOX TECHNOLOGY PRIVATE LIMITED',
    'TRANSWORLD INTEGRATED LOGISTEK PRIVATE LIMITED',
    'KAARYA NEXT SOLUTIONS PRIVATE LIMITED',
    'MIRCHANDANIS CAREER PLACEMENTS INDIA PRIVATE LIMITED',
    'VIMAL NOURISHMENT TECHNOLOGIES PRIVATE LIMITED',
    'ROLANEXT CONSTRUCTION PRIVATE LIMITED',
    'ARIA INDIA CORPORATE SOLUTIONS PRIVATE LIMITED',
    'INACCES GEOTECHNICAL SOLUTIONS INDIA PRIVATE LIMITED',
    'GLOBAL ADJUSTMENTS FOUNDATION',
    'STARTUPSECTION ADVISORY PRIVATE LIMITED',
    'NEUBIZ (OPC) PRIVATE LIMITED',
    'XOBIN TECHNOLOGIES PRIVATE LIMITED',
    'DEIVEE FITNESS PRIVATE LIMITED',
    'BANSAL PATHWAYS HABIBGANJ PRIVATE LIMITED',
    'MAXLIFE HEALTH ENTERPRISES PRIVATE LIMITED',
    'PODDAR HOTELS PRIVATE LIMITED',
    'INGEM HOTELS AND RESTAURANTS PRIVATE LIMITED',
    'ADANI FINSERVE PRIVATE LIMITED',
    'BIO FACT RESEARCH PRIVATE LIMITED',
    'CHETNA NATURE FARMING PRODUCER COMPANY LIMITED',
    'ORABLUE CHEM PRIVATE LIMITED',
    'DEEVOIR RETAIL ANALYTICS PRIVATE LIMITED',
    'PAUL PENDERS BOTANICALS INDIA PRIVATE LIMITED',
    'BENTEX CONTROL & SWITCHGEAR (S) PRIVATE LIMITED',
    'UNIBA CLOTHING PRIVATE LIMITED',
    'AIRFI AVIATION SOLUTIONS PRIVATE LIMITED',
    'MARKETFRONT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MACDONALD HUMFREY (AUTOMATION) INDIA PRIVATE LIMITED',
    'LEMON FLIP SOLUTIONS PRIVATE LIMITED',
    'TYCHE CAST TECH PRIVATE LIMITED',
    'FRAMEWORKPE INVESTMENT DATA MANAGEMENT SERVICES PRIVATE LIMITED',
    'MARK9 CONSULTING PRIVATE LIMITED',
    'ULIS TECHNOLOGY PRIVATE LIMITED',
    'NUTSPACE EDTECH PRIVATE LIMITED',
    '2WTRADE INDIA PRIVATE LIMITED',
    'CIAGA PRIVATE LIMITED',
    'ATOMICLES TECHNOLOGIES PRIVATE LIMITED',
    'MEGHAJA PRIVATE LIMITED',
    'UTL LOGISTICS PRIVATE LIMITED',
    'UENGAGE SERVICES PRIVATE LIMITED',
    'TUNE-UP TRAININGS PRIVATE LIMITED',
    'ENCON SOLAR PRIVATE LIMITED',
    'DESIGN STORY STUDIO PRIVATE LIMITED',
    'SUNPOWER INDIA VENTURES PRIVATE LIMITED',
    'LUMIXTRA LIGHTING PRIVATE LIMITED',
    'SOUTHY HOSPITALITY AND SERVICES PRIVATE LIMITED',
    'ARMIN TRAVELS PRIVATE LIMITED',
    'SBW HOTEL UDYOG PRIVATE LIMITED',
    'JADOUN ROADLINES PRIVATE LIMITED',
    'RED MOTIVE REALTY SERVICES PRIVATE LIMITED',
    'WITTY ENTERPRISES PRIVATE LIMITED',
    'PROMOLTA IT SOLUTIONS PRIVATE LIMITED',
    'KAVASSU NUTRITION & ORGANIC DAIRY PRIVATE LIMITED',
    'CRUST N CRUMB FOOD SOLUTIONS PRIVATE LIMITED',
    'ARETE ELECTRO POWER PRIVATE LIMITED',
    'RS DRUG INDUSTRIES PRIVATE LIMITED',
    'BUXUS MEDIA PRIVATE LIMITED',
    'ATS EXOTIC HOMES PRIVATE LIMITED',
    'ATS GRAND REALTORS PRIVATE LIMITED',
    'WHOA MAMA STUDIOS PRIVATE LIMITED',
    'UNIVERSYS TECHNOLOGIES PRIVATE LIMITED',
    'WORLD WIDE CARRIERS PRIVATE LIMITED',
    'VSAAS INNOVATIONS PRIVATE LIMITED',
    'CBL DATA SCIENCE PRIVATE LIMITED',
    'CAMPUS PUPPY PRIVATE LIMITED',
    'OLEADS EDUCATION & TECHNOLOGY PRIVATE LIMITED',
    'TRAVIS ONLINE PRIVATE LIMITED',
    'CARRYGO LOGISTICS PRIVATE LIMITED',
    'FIESTRO HOLIDAYS PRIVATE LIMITED',
    'MAYURESH TRADE CENTRE UNITS PURCHASERS PRIVATE LIMITED',
    'AMIMA MINES AND MINERALS PRIVATE LIMITED',
    'PARADIP EAST QUAY COAL TERMINAL PRIVATE LIMITED',
    'UNITED CIIGMA HOSPITALS HEALTHCARE PRIVATE LIMITED',
    'VAMANA EXTRUSIONS PRIVATE LIMITED',
    'ATTRIBUTUM INSURTECH PRIVATE LIMITED',
    'EXTRA MILE LEARNING PRIVATE LIMITED',
    'AROVEDA LIFESTYLE PRIVATE LIMITED',
    'ALUMIL BUILDMATE PRIVATE LIMITED',
    'SHREE SAMARTH WIND PARK PRIVATE LIMITED',
    'AMBILY TECHNOLOGIES PRIVATE LIMITED',
    'RAPPIER SOLUTIONS INDIA PRIVATE LIMITED',
    'MOVEX INFRASTRUCTURE PRIVATE LIMITED',
    'EON REALITY INDIA PRIVATE LIMITED',
    'METWIZ MATERIALS PRIVATE LIMITED',
    'PROFUGO SOCIAL VENTURES PRIVATE LIMITED',
    'PUSH & PULL SERVICES PRIVATE LIMITED',
    'MUDAR INGREX LIMITED',
    'VISHVAKARMA CONSULTING SERVICES PRIVATE LIMITED',
    'EFORCE INFOSYSTEMS PRIVATE LIMITED',
    'CHOTTA HAAZRI FOODS PRIVATE LIMITED',
    'WONDER GLOBAL (INDIA) TECHNOLOGY CENTRE PRIVATE LIMITED',
    'DAVLEKHA PEREZ ADVISORY INDIA PRIVATE LIMITED',
    'RAISONI AGRO EXIM PRIVATE LIMITED',
    'C3SOLUTION BPO INDIA PRIVATE LIMITED',
    'METALKARMA CONSTRUCTION INDIA PRIVATE LIMITED',
    'AVIKIRAN SOLAR INDIA PRIVATE LIMITED',
    'SAM TAX ADVISORS PRIVATE LIMITED',
    'NGLC REALTECH PRIVATE LIMITED',
    'ACEROS OIL AND GAS EQUIPMENT PRIVATE LIMITED',
    'DANPEX SYSTEMS PRIVATE LIMITED',
    'UBER INDIA DEVELOPMENT PRIVATE LIMITED',
    'OTHERSIDE CONSULTING INDIA (OPC) PRIVATELIMITED',
    'VARNAM CRAFT COLLECTIVE PRIVATE LIMITED',
    'GLOINNT SOLUTIONS PRIVATE LIMITED',
    'CSD TECHNOLOGIES PRIVATE LIMITED',
    'ZARAH CONCEPT INDIA (OPC) PRIVATE LIMITED',
    'URBAN BEAT PROJECT (OPC) PRIVATE LIMITED',
    'SKYCLIFF IT PRIVATE LIMITED',
    '91SOCIAL SOFTWARE PRIVATE LIMITED',
    '10COSINE TECH SOLUTIONS PRIVATE LIMITED',
    'LAHANTI LASTMILE SERVICES PRIVATE LIMITED',
    'THERLI INFRA PRIVATE LIMITED',
    'NATALRY PRIVATE LIMITED',
    'PRRSAAR AGRO PRODUCTS PRIVATE LIMITED',
    'NEOLACTA LIFESCIENCES PRIVATE LIMITED',
    'MISSRE PHARMACEUTICAL PRIVATE LIMITED',
    'RAJJAN KHAN FRUITS PRIVATE LIMITED',
    'SPACK EXIM PRIVATE LIMITED',
    'QUATRIZ VENTURES PRIVATE LIMITED',
    'KASPLO INTERNET PRIVATE LIMITED',
    'TARTANS EXPORT PRIVATE LIMITED',
    'JAHASA TECHNOLOGIES PRIVATE LIMITED',
    'SEEKER HEIGHTS INDIA PRIVATE LIMITED',
    'UNOMER TECHNOLOGIES PRIVATE LIMITED',
    'SULOCHNA TOWERS PRIVATE LIMITED',
    'WERA FOOD TECHNOLOGY PRIVATE LIMITED',
    'ENSEMBLE PROJECTS PRIVATE LIMITED',
    'LOGICIAN MEDIASERVICES PRIVATE LIMITED',
    'OPTEL VISION INDIA PRIVATE LIMITED',
    'RDA LABS INDIA PRIVATE LIMITED',
    'MATERIALS MAINTENANCE MANAGEMENT SERVICES PRIVATE LIMITED',
    'FRICTIONFREE SOLUTIONS PRIVATE LIMITED',
    'CLEAN CARBON PRIVATE LIMITED',
    'SCUBA EVOLUTION INDIA PRIVATE LIMITED',
    'POEM EVANGELISTS OPC PRIVATE LIMITED',
    'REALTIME INFRATEL PRIVATE LIMITED',
    'JUPITER CONTROL SYSTEMS PRIVATE LIMITED',
    'WEBOFFICE INFOTECH INDIA PRIVATE LIMITED',
    'DELTABASE COMMUNICATIONS PRIVATE LIMITED',
    'IMATE SOLUTIONS SOFTWARE SERVICES PRIVATE LIMITED',
    'FLIGHTS MOJO BOOKINGS PRIVATE LIMITED',
    'AIRFIBER NETWORKS PRIVATE LIMITED',
    'AMPLIFI BUSINESS INCUBATION SERVICES PRIVATE LIMITED',
    'SWARAN FOUNDATION FOR EDUCATION',
    'BASAVASHAKTI MEGA FOOD PARK PRIVATE LIMITED',
    'INSTAONE SOFTWARE PRIVATE LIMITED',
    'CYPSELA SERVICES PRIVATE LIMITED',
    'MYSTERY INFOTECH PRIVATE LIMITED',
    'DARING GOURMET PRIVATE LIMITED',
    'KRP WATERTECH PRIVATE LIMITED',
    'TESSELLATE TECH VENTURES PRIVATE LIMITED',
    'BATOONI MOBILE ADVERTISING PRIVATE LIMITED',
    'CITYNEON CREATIONS INDIA PRIVATE LIMITED',
    'DSPZ AUTOMATION PRIVATE LIMITED',
    'ABJA GLOBAL HOSPITALITY INVESTMENTS PRIVATE LIMITED',
    'BASAVASHAKTI FRUITS PRIVATE LIMITED',
    'OFCA POWER TECHNOLOGY PRIVATE LIMITED',
    'PHIKANET BPO SERVICES PRIVATE LIMITED',
    'LAB WORLD PLUS HEALTH DIAGNOSTIC SERVICES PRIVATE LIMITED',
    'GURGAON-PALWAL TRANSMISSION LIMITED',
    'DATACAPTEN TECHNOLOGIES PRIVATE LIMITED',
    'AYESIGN DIGITAL PRIVATE LIMITED',
    'SAPANA MOTION PICTURES AND TELEFILMS PRIVATE LIMITED',
    'NETCOM LEARNING INDIA PRIVATE LIMITED',
    'SHASTICORP CONSULTANCY SERVICES PRIVATE LIMITED',
    'MILKLANE DAIRY SERVICES PRIVATE LIMITED',
    'TRUESERVE TECHNOLOGIES PRIVATE LIMITED',
    'GRISPO CLAMBI SHIPPING SERVICES PRIVATE LIMITED',
    'MIMO TECHNOLOGIES PRIVATE LIMITED',
    'UNOFIX TECHNOLOGIES PRIVATE LIMITED',
    'LIVHOUSING E-SERVICES PRIVATE LIMITED',
    'JUNGLE LORE STUDENT EXPEDITIONS PRIVATE LIMITED',
    'AGRIRAIN AGRO INDUSTRIES INDIA PRIVATE LIMITED',
    'NOVUS AUTOMATION PRIVATE LIMITED',
    'PACIRA HEALTHCARE PRIVATE LIMITED',
    'HOPE FOR KIDS & WELFARE FOUNDATION',
    'ENTREPRENEUR EDUCATIONAL SOCIAL WELFARE FOUNDATION',
    'BELGOTEX INDIA PRIVATE LIMITED',
    'ROSLEK INDIA PRIVATE LIMITED',
    'CAPTAIN TOURS & TRAVELS PRIVATE LIMITED',
    'AVALANCE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'DBL HASSAN PERIYAPATNA TOLLWAYS LIMITED',
    'MONTANE VENTURES PRIVATE LIMITED',
    'TRUISM INFRATECH PRIVATE LIMITED',
    'HOUSE OF LIONS PRIVATE LIMITED',
    'NEXT KNOCK CONSULTING SERVICES PRIVATE LIMITED',
    'NSV INDIA PRIVATE LIMITED',
    'IA WEALTH PRIVATE LIMITED',
    'FINIZIA CONSULTANCY PRIVATE LIMITED',
    'CENTER FOR SUSTAINABILITY POLICY AND TECHNOLOGY MANAGEMENT',
    'KRSV INNOVATIVE AUTO SOLUTIONS PRIVATE LIMITED',
    'GONG CHENG COMMUNICATIONS PRIVATE LIMITED',
    'MERAKI SPORT & ENTERTAINMENT PRIVATE LIMITED',
    'BANYAN TREE FINVEST PRIVATE LIMITED',
    'NIPPON SIGNAL INDIA PRIVATE LIMITED',
    'MOONSKY AVIATION SERVICES PRIVATE LIMITED',
    'FOETRON CONSULTANCY SERVICES PRIVATE LIMITED',
    'IPREDICTT DATA LABS PRIVATE LIMITED',
    'VINRAK TECHNOLOGIES PRIVATE LIMITED',
    'MARVEL SOLREN PRIVATE LIMITED',
    'DOVER PHARMACEUTICALS PRIVATE LIMITED',
    'JUNGOOS INFOTECH PRIVATE LIMITED',
    'MEDISERVE SOLUTIONS PRIVATE LIMITED',
    'JSM INFOTECH PRIVATE LIMITED',
    'GREENERGY SOLAR ENTERPRISE PRIVATE LIMITED',
    'SEVEN STAR DIGITAL NETWORKS PRIVATE LIMITED',
    'HEBBALE LABS PRIVATE LIMITED',
    'KNOWLEDGE MARINE & ENGINEERING WORKS LIMITED',
    'DEVSANKALP RETAIL PRIVATE LIMITED',
    'LITTLE PASSPORTS EDUTOURS PRIVATE LIMITED',
    'KMGD OVERSEAS PRIVATE LIMITED',
    'MANHATTAN TECH VENTURES PRIVATE LIMITED',
    'MEHTA AUTOMOTIVE PRIVATE LIMITED',
    'LAKHTARWALA JEWELLERS PRIVATE LIMITED',
    'MEDINEJ PHARMACEUTICAL PRIVATE LIMITED',
    'NARIKUDI FARMERS PRODUCER COMPANY LIMITED',
    'KARIYAPATTI FARMERS PRODUCER COMPANY LIMITED',
    'TIRUMALLA EDIBLE OILS REFINERY INDIA PRIVATE LIMITED',
    'UNITY CYLINDERS & EQUIPMENTS PRIVATE LIMITED',
    'LE SANTIAGO FARMS PRIVATE LIMITED',
    'LE SANTORINI FARMS PRIVATE LIMITED',
    'SAPURA ENGINEERING & CONSTRUCTION (INDIA) PRIVATE LIMITED',
    'LE WINDMILL FARMS PRIVATE LIMITED',
    'MUKTESHWAR KISAN PRODUCER COMPANY LIMITED',
    'SLB GOLD & JEWELLERY PRIVATE LIMITED',
    'PREMIER GRANITES LTD',
    'BHARNA FARMERS PRODUCER COMPANY LIMITED',
    'TALABIRA (ODISHA) MINING PRIVATE LIMITED',
    'EARTH SOIL MINE CHEM PRIVATE LIMITED',
    'KEYSTONE RESORTS PRIVATE LIMITED',
    'RNP OIL AND FOODS PRIVATE LIMITED',
    'RIYARCHITA AGRO FARMING PRIVATE LIMITED',
    'GLOBAL PETROLEUM PRIVATE LIMITED',
    'DRILL KING INDIA PRIVATE LIMITED',
    'VIRGINIA TECH INDIA RESEARCH & EDUCATION FORUM',
    'SIMAN STONES INTERNATIONAL PRIVATE LIMITED',
    'SUNRIGEL OIL SERVICES PRIVATE LIMITED',
    'GSPC ENERGY LIMITED',
    'BANYAN TREE FARMS PRIVATE LIMITED',
    'TRANQUINI INDIA PRIVATE LIMITED',
    'THAICRATE DELIVERY PRIVATE LIMITED',
    'SORICH ORGANICS PRIVATE LIMITED',
    'BAJAJ FOODS AND BEVERAGES INDIA PRIVATE LIMITED',
    'OILWELL TOOLS SERVICES & SUPPLIES PRIVATE LIMITED',
    'AVD AGRI FOOD INDUSTRIES PRIVATE LIMITED',
    'LIGHT BITE FOODS PRIVATE LIMITED',
    'LIFE SPAN PRIVATE LIMITED',
    'CHINA COAL NO.3 MINING (INDIA) PRIVATE LIMITED',
    'SMG MILK FOOD PRIVATE LIMITED',
    'SKY GATE HOSPITALITY PRIVATE LIMITED',
    'NESANS MINING AND AUTOMATION PRIVATE LIMITED',
    'TIWARTA COAL BENEFICIATION LIMITED',
    'ARSHIA FOODWORKS PRIVATE LIMITED',
    'MEAT AND SPICE PRIVATE LIMITED',
    'HILLS AGRIBUSINESS & DAIRY PRODUCTS PRIVATE LIMITED',
    'EUROSPAWN INDIA PRIVATE LIMITED',
    'SANWARIYA LCNG LIMITED',
    'NUMA BENGALURU INNOVATIONS PRIVATE LIMITED',
    'PROBUS TECHNOLOGIES PRIVATE LIMITED',
    'DISHA MINES AND MINERALS PRIVATE LIMITED (OPC)',
    'RAJBHARTI QUARTZITE INDUSTRIES PRIVATE LIMITED',
    'BRIGHTGEM MINING PRIVATE LIMITED',
    'D CORP AGRO FOODS PRIVATE LIMITED',
    'DELICIOSO GOURMET FOODS PRIVATE LIMITED',
    'BENGAL-IRC GRANITE MINERAL LIMITED',
    'BKG M SAND & AGGREGATES PRIVATE LIMITED',
    'FOOD SERVICE (INDIA) PRIVATE LIMITED',
    'DIMAN ADVISORS PRIVATE LIMITED',
    'KCD FOODIES (INDIA) PRIVATE LIMITED',
    'TAKE AGRO INDIA PRIVATE LIMITED',
    'UNISTONE FOODS PRIVATE LIMITED',
    'VIJAYA SPOORRTHI FOODS PRIVATE LIMITED',
    'HETERO WIND POWER (PENNAR) PRIVATE LIMITED',
    'ZAHARA FOOD PRODUCTS PRIVATE LIMITED',
    'SAS WEALTH PRIVATE LIMITED',
    'SWASTHUM WELLNESS PRIVATE LIMITED',
    'NATU',
    'S SERVICES PRIVATE LIMITED',
    'Icope technologies private limited',
    'Brahad elastomers private limited',
    'PROKENS OPESMETRICS PRIVATE LIMITED',
    'Qualitree solutions private limited',
    'Banyan tree advisors private limited',
    'Verifacts services private limited',
    'B2k services private limited',
    'Perry johnson certifications private limited',
    'Novergy energy solutions private limited',
    'R square consulting services private limited',
    'Sg iconsult management and outsourcing private limited',
    'Rho consulting private limited',
    'Aqua fire systems private limited',
    'Young presidents organization (mumbai chapter)',
    'E-hub corporate services private limited',
    'DELTTA GREENTECH WORLD BOMBAY ECOSYSTEMS PRIVATE LIMITED',
    'Applegreen financial services private limited',
    'PRIYARTH VENTURES PRIVATE LIMITED',
    'H horizon support and services private limited',
    'Mogra investment consultants private limited',
    'Sharp manpower consultancy private limited',
    'Sodexo svc india private limited',
    'Dar capital advisory private limited',
    'Synergy credit consultants private limited',
    'Vikrant advisory services private limited',
    'Svenska global management services private limited',
    'Bnb interior consultant private limited',
    'Knexir consultants private limited',
    'Pgfs management consultants private limited',
    'POUSSE MANAGEMENT SERVICES PRIVATE LIMITED',
    'Aquarius engineering consultancy private limited',
    'Arsh management consultants private limited',
    'Business gateways international ( india ) private limited',
    'Pithisaria consultancy services private limited',
    'Knowledge beans training management & consulting private limited',
    'Green world projects private limited',
    'Mdis india private limited',
    'High places international consulting private limited',
    'SREENIDHI VALUATION RESEARCH & ANALYTICS PRIVATE LIMITED',
    'AMARIS ACT CONSULTING PRIVATE LIMITED',
    'Khaitan consultants limited',
    'Ars management consultancy services private limited',
    'Enertech systems & solutions pvt ltd',
    'Smfc advisory services private limited',
    'Affinity global services private limited',
    'Karmyog management & services private limited',
    'Sukriti designs private limited',
    'Project management engineering services (india) private limited',
    'Flow technologies private limited',
    'Progress software development private limited',
    'A.n. prakash construction project management consultants private limited',
    'Nag interiors private limited',
    'Npr interiors private limited',
    'Corotech engineers private limited',
    'Dadbhawala engineers and consultants private limited',
    'Oronim technologies private limited',
    'Advance eco controls private limited',
    'Genesis inscapes private limited',
    'Kamco global private limited',
    'TATA KORF ENGINEERING SERVICES LTD',
    'Cfi technologies private limited',
    'Bhumitra energy auditing and consultancy private limited',
    'Harmilap media private limited',
    'Anil kumble sports promotion private limited',
    'Ngc network (india) private limited',
    'Blue sky brandcomm asia private limited',
    'Valuable advertising network private limited',
    'Walnut advertising india pvt.ltd.',
    'Nomadic communications private limited',
    'Adworld signages private limited',
    'Accurate ancillary products limited',
    'Indication instruments limited',
    'RUMMY CHHABRA INVESTMENTS PRIVATE LIMITED',
    'Sudhir automotive industries private limited',
    'Asiatic engineers private limited',
    'Jetsave india tours private limited',
    'KRSKA CAPITAL PRIVATE LIMITED',
    'Madhubani investments private limited',
    'Reliable mercantile private limited',
    'Alidia powertronics private limited',
    'Bhabani pigments private limited',
    'Systems india private limited',
    'Parag agro tech private limited',
    'Sri jayasakthi polymers private limited',
    'Cochin petromins pvt ltd',
    'Bridgestone india private limited',
    'Mandev tubes private limited',
    'Hallite sealing solutions india private limited',
    'PRIME PIPES & FITTINGS PRIVATE LIMITED',
    'TUBESONS SPECIMENCARE PRIVATE LIMITED',
    'Elegant superpolyplast private limited',
    'Fukoku india private limited',
    'Unipet industries private limited',
    'Smiley monroe rubber & allied products (india) private limited',
    'WOCO TECH POLYMERE KANDLA LIMITED',
    'Shail international private limited',
    'High tech reclaim private limited',
    'Veegrip belts private limited',
    'Daejung moparts private limited',
    'Consumers plastics private limited',
    'AADHUNIK INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED',
    'PURUSHOTHAM PLASTICS & TECHNOLOGIES PRIVATE LIMITED',
    'Finor piplaj chemicals limited',
    'Big box containers private limited',
    'Corrukraft packaging private limited',
    'K.p. packaging limited',
    'Saitech mouldings private limited',
    'Makwell plastisizers private limited',
    'Mechemco resins private limited',
    'Allen reinforced plastics pvt ltd',
    'Mainetti (india) private limited',
    'Purushotham moulds & plastics private limited',
    'Bhagwati plastoworks private limited',
    'Hamilton housewares private limited',
    'INDIAN OCEAN GARNET SANDS COMPANY PRIVATE LIMITED',
    'Eco-care building innovations private limited',
    'Seazone granito private limited',
    'Pagel concrete technologies private limited',
    'Kayoma cement private limited',
    'Seepex india private limited',
    'Al mufaddal impex private limited',
    'Panchratan steels private limited',
    'Ami tech (india) private limited',
    'Ishu super steel private limited',
    'Escort bearing (india) private limited',
    'Subham udyog private limited',
    'VAZRON INDUSTRIES PRIVATE LIMITED',
    'Asl enterprises limited',
    'Fortunecoat industries private limited',
    'Pami metals private limited',
    'Bhavya alloys private limited',
    'PIONEER WELD AND WEAVES PRIVATE LIMITED',
    'Ferrous forgings limited',
    'Mayank raw-mint private limited',
    'Uniglobal papers private limited',
    'Zion infraprojects private limited',
    'Iris foils private limited',
    'Shalimar gold exports private limited',
    'Mysolitaire jewels private limited',
    'Vnm jewel crafts limited',
    'Southern alloy foundries private limited',
    'BAY-FORGE Private Limited',
    'Akar alloys pvt ltd',
    'Bds projects india private limited',
    'Systherm engineering private limited',
    'Yamini automation private limited',
    'Perfect glaze (india) private limited',
    'Kartikeya industries private limited',
    'Jayam fab engineering private limited',
    'GALAXY HYDRAULICS PRIVATE LIMITED',
    'Matrix metal products private limited.',
    'Imperiall technoforge private limited',
    'Sai sanket enterprises private limited',
    'Domech fabricators private limited',
    'Forbes aquatech limited',
    'Snehal packaging private limited',
    'Advent water treatment private limited',
    'Malvern-aimil instruments private limited',
    'Balbir structure private limited',
    'Atharva foundries private limited',
    'Accurate steel forgings (india) limited',
    'Nayak engineering private limited',
    'Suryadipta projects private limited',
    'Hero products india private limited',
    'Vsl india private limited',
    'Nikhil equipments pvt ltd',
    'Sakhamuri infratech private limited',
    'Astrotech steels private limited',
    'Sf forgings private limited',
    'Wirecom (india) private limited',
    'Msbc secure (india) private limited',
    'Robo silicon private limited',
    'NEELAM APPLIANCES LIMITED',
    'R r kabel limited',
    'Total schweisstechnik private limited',
    'Hindusthan parsons ltd.',
    'Vikrant cranes india private limited',
    'Integrated induction power limited',
    'Autotronix engineering private limited',
    'Cabs india tours and travels private limited',
    'Amasco tours and travels private limited',
    'C world holidays india private limited',
    'Nomad travels private limited',
    'Mystic travels private limited',
    'Penta freight private limited',
    'Aurora travels tours private limited',
    'Prudential travels private limited',
    'HARVEY WORLD DESTINATIONS PRIVATE LIMITED',
    'Silver stone travels private limited',
    'Eastern risen expedition private limited',
    'Express student services private limited',
    'Forts and palaces tours limited',
    'Cholan tours private limited',
    'Target shipping private limited',
    'Safset forwarders private limited.',
    'Apm terminals india private limited',
    'SHM SHIPYARD PRIVATE LIMITED',
    'Embee road services private limited',
    'Liberty shipping agencies private limited',
    'Great circle shipping private limited',
    'Oscar freight private limited',
    'Godara roadways private limited',
    'Fidesta logistics private limited',
    'AIR GLOBE PRIVATE LIMITED',
    'Logistic integrators (i) private limited',
    'Mohit trans lifter private limited',
    'Pegasus forwarding services private limited',
    'W.w. shipping agencies private limited',
    'Shri krishna investments private limited',
    'Taurus aerospace systems private limited',
    'Mkf logistics private limited',
    'Stadia landmark project private limited',
    'Tamara consulting private limited',
    'Plan2execute india private limited',
    'Conquest integrated solutions (chennai) private limited',
    'Agada diagnostics private limited',
    'Arck consultants private limited',
    'RESPONCE HOSPITALITY SERVICES PRIVATE LIMITED',
    'Goldenlion consulting services private limited',
    'VT CAPITAL MARKET PRIVATE LIMITED',
    'Experifun educational solutions private limited',
    'Medizen education and communication private limited',
    'Escv consulting services private limited',
    'Madanco trexim private limited',
    'Venerate dealmark private limited',
    'Polisetty somasundaram tobacco products (india) private limited',
    'Great india business private limited',
    'A g security services private limited',
    'Appsolute media private limited',
    'Visionway ielts and immigration private limited',
    'Multidisciplinary consultancy services private limited',
    'Tirupati placement associates private limited',
    'Sona yukti private limited',
    'Right human skills and resources private limited',
    'Pushpak infra steel private limited',
    'Fusol advisory private limited',
    'Cognet hr solutions private limited',
    'Dafater consultants private limited',
    'Enmax engineering (india) private limited',
    'Air-o-matic systems (chennai) private limited',
    'ASTRO NUMBER SERVICES PRIVATE LIMITED',
    'Hanu reddy escrow specialist india private limited',
    'Sukhi orion security systems private limited',
    'A and g facades private limited',
    'Zealcity digital private limited',
    'United alliance healthcare private limited',
    'Ars electricals private limited',
    'Trajectories business solutions private limited',
    'Triple s electric powers private limited',
    'Srm infotainment media private limited',
    'Kisangates agro informatics private limited',
    'Sledgehammer oil tools private limited.',
    'Orayan logistics private limited',
    'Nanavati speciality chemicals private limited',
    'SRMPR AUTO MANUFACTURING PRIVATE LIMITED',
    'Justickets private limited',
    'Prompt integrated facility services private limited',
    'Hotline fashions (india) private limited',
    'Siddarth intercrafts private limited',
    'Avon gas engineers private limited',
    'Linkstrat business solutions private limited',
    'Rbk security and manpower services private limited',
    'ZAR IMPORTS & EXPORTS PRIVATE LIMITED',
    'Kenmore shoes private limited',
    'Paroma shoes private limited',
    'Venus footstep private limited',
    'Associate plywood industries private limited',
    'Jolly board limited',
    'Indo tossa private limited',
    'Cygnus apparel private limited',
    'Prajakt textiles private limited',
    'Garvit creation private limited',
    'Din fabtech pvt. ltd.',
    'Purnima apparels private limited',
    'Shivam fashion kraft private limited',
    'Pinnacle garments private limited',
    'Shibumi accessories pvt. ltd.',
    'Sanraj consultants private limited',
    'Rain tree design private limited',
    'Lakshya garments private limited',
    'Sri anjaneya cartons private limited',
    'Freelance products private limited',
    'Greencraft paper private limited',
    'Nitai clothings private limited',
    'Blue orchid educational aids private limited',
    'Atlanta forms private limited',
    'Globe pharma publications private limited',
    'JASMINE TOWELS PRIVATE LIMITED',
    'Bookbox india private limited',
    '21 fools design and entertainment private limited',
    'The indian and eastern engineer company private limited',
    'Worldwide media private limited',
    'India tv & film academy private limited',
    'Spica elastic private limited',
    'VIKRAM NUVOTECH INDIA PRIVATE LIMITED',
    'Agstya textiles private limited',
    'JAY TEXFAB PRIVATE LIMITED',
    'Ten plus ventures private limited',
    'Apt garments private limited',
    'Woodupu fashions private limited',
    'Varsana lumbers private limited',
    'Pushpraj printers private limited',
    'Heidelberg india private limited',
    'Salasar plywood private limited',
    'Kaluram laminates private limited',
    'Millenium papers private limited',
    'Sri venkatramana paper mills private limited',
    'Siddho mal paper conversion company private limited',
    'SHIVALI UDYOG (I) PRIVATE LIMITED',
    'Carbon edge industries limited',
    'Tikku eco paper products private limited',
    'Vrinda papers private limited',
    'Empee offset private limited',
    'Bhiwadi cylinders private limited',
    'Kanhan packagings private limited',
    'TROVABO HEALTHCARE PRIVATE LIMITED',
    'NESHIEL AGROCHEM PRIVATE LIMITED',
    'Aryavart chemicals private limited',
    'Kubo combustion efficiency chemicals private limited',
    'SHREE VARDHAMAN CHEMICALS PRIVATE LIMITED',
    'Sundex process engineers pvt ltd',
    'Regency dye chem pvt ltd',
    'Oscar chemicals private limited',
    'Sauman chemaux private limited',
    'Dai-ichi goseichemicals (india) ltd',
    'Sambhav interchem private limited',
    'Devcon chemicals private limited',
    'Chimera chemicals private limited',
    'MEGACHEM SPECIALTY CHEMICALS (I) PRIVATELIMITED',
    'Bic chemicals and packagings private limited',
    'Ramsons perfumes private limited',
    'HINDYS LAB PRIVATE LIMITED',
    'Umed healthcare private limited',
    'Reena organics private limited',
    'Tranvero chemicals private limited',
    'Duraent biologicals limited',
    'Venus essence private limited',
    'Soundboard media private limited',
    'Next sourcing services (india) private limited',
    'Bhavika apparels private limited',
    'Tantra designs private limited',
    'Radical media services private limited',
    'Subcontinental media group private limited',
    'Positive point graphic private limited',
    'ARYA HOSPITALITY & MANAGEMENT PRIVATE LIMITED',
    'Best packaging private limited',
    'Abhideep chemicals pvt ltd',
    'Kankai chemicals pvt ltd',
    'Tradewell international private limited',
    'Associate allied chemicals (india) private limited',
    'Vindhya organics private limited',
    'Srinidhi labs private limited',
    'Pim packaging private limited',
    'Rms media observer & management private limited',
    'PON PURE CHEMICAL INDIA PRIVATE LIMITED',
    'Indus chemie exports private limited',
    'JAY CHEMICAL INDUSTRIES PRIVATE LIMITED',
    'Ashoka distillers and chemicals pvt ltd',
    'RAMA ELECTRONIC MEDIA & COMMUNICATIONS LIMITED',
    'INSPIRED MUSIC PRIVATE LIMITED',
    'Agri tech research and exports private limited',
    'K. N. CHARI RUBBER & PLASTICS PRIVATE LIMITED',
    'Supreme gums private limited',
    'RAMAN & WEIL PRIVATE LIMITED',
    'Sita petrochem private limited',
    'ABJA POWER PRIVATE LIMITED',
    'Gspc (jpda) limited',
    'Rajtaru builders and investments private limited',
    'AGRWALAS DEVELOPMENTS AND CONSTRUCTIONS PVT LTD',
    'Samashti gas energy limited',
    'G.b.r. eco projects private limited',
    'Silvassa estates private limited',
    'Swan lake properties pvt ltd',
    'Tvh infrastructure chennai private limited',
    'Kimberly properties private limited',
    'V.g.n. pearl square properties private limited',
    'Akshya urja private limited',
    'Evian engineering private limited',
    'PASSAVANT ENERGY & ENVIRONMENT INDIA PRIVATE LIMITED',
    'Orbit residency private limited',
    'Jagannath property developers private limited',
    'Sm infrastructure private limited',
    'Acg pharmapack private limited',
    'Acecons mining and logistics private limited',
    'Jainam builders private limited',
    'Smc insurance brokers private limited',
    'S p singla constructions private limited',
    'Tarini infrastructure limited',
    'Pratham buildcon private limited',
    'Sphere properties private limited',
    'Skyrise home developers private limited',
    'Vriti constructions private limited',
    'Crazy properties private limited',
    'Ankur propmart private limited',
    'Hansmukhi projects private limited',
    'Navrang buildwell private limited',
    'AMISHI BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Dove infrastructure private limited',
    'Isabel builders & developers private limited',
    'Rochelle builders & constructions private limited',
    'Annabel builders & developers private limited',
    'DLF ASSETS LIMITED',
    'Nellis builders & developers private limited',
    'Bhamini real estate developers private limited',
    'Laraine builders & constructions private limited',
    'Dlf southern towns private limited',
    'Chevalier builders & constructions private limited',
    'Snigdha builders & constructions private limited',
    'Pravin organisers limited',
    'Prudent fintrade private limited',
    'H.a.constructions private limited',
    'Shree naman builders private limited',
    'Manomay estates private limited',
    'Divai civil constructions private limited',
    'G. r. infrastructure private limited',
    'Gupta promoters private limited',
    'Twenty first century colonisers private limited',
    'Astra landbase private limited.',
    'Amarprem estates private limited',
    'Ardent build-tech limited',
    'Levidia infra private limited',
    'B n civitech private limited',
    'Safe heights developers private limited',
    'Thakur and associates infrastructural development private limited',
    'AAADI BUILDCRAFT CONCEPT PRIVATE LIMITED',
    'S2 realty and developers private limited',
    'Avishkar infrastructure private limited',
    'Sireesh holdings private limited',
    'GUESTURE LIVING SOLUTIONS PRIVATE LIMITED',
    'Shanders realassets private limited',
    'S b estate private limited',
    'Ss infrastructure private limited',
    'Super city builders private limited',
    'Uday infrastructure international private limited',
    'Agl infrabuild private limited',
    'Sks landmarks private limited',
    'Cedar builders private limited',
    'Crux prestressing systems private limited',
    'Metropolitan infrahousing private limited',
    'Splendid aparna projects private limited',
    'Futura techpark private limited',
    'Sai construction pvt.. ltd',
    'Agarwal business centre properties private limited',
    'Vishnu projects and constructions private limited',
    'VASANTHA CONSTRUCTIONS PRIVATE LIMITED',
    'Dee-tech energy projects private limited',
    'Sukriti buildcon private limited',
    'Raj landmark private limited',
    'Olive builders and developers private limited',
    'Neo legno products private limited',
    'Sai baba infracon private limited',
    'Dolchand kallaji (india) private limited',
    'Tolani projects private limited',
    'Shiv shyam infocom private limited',
    'Marigold estates private limited',
    'Rocklines farms and resorts private limited',
    'Barton real estate investments private limited',
    'TIME & SPACE HOLDINGS PRIVATE LIMITED',
    'Dk solid waste management services private limited',
    'Pooja realties and properties (mumbai) private limited',
    'Ranjana construction private limited',
    'SHIVRIS RESOURCES PRIVATE LIMITED',
    'Saba housing private limited',
    'S.s.m infrastructure private limited',
    'Easwara realtor private limited',
    'Fortune butterfly city limited',
    'South coast infrastructure development company of andhra pradesh limited',
    'Prasad infracon (india) private limited',
    'Bougainvillea properties private limited',
    'Sri vishnu consol private limited',
    'Asomi finance private limited',
    'PADMAKSHI FINANCIAL SERVICES Private Limited',
    'Sri anurakhavi chit funds private limited',
    'Bitubab real estate private limited',
    'Passion stock broking private limited',
    'Jpa solutions private limited',
    'SHEKHAVATI INVESTMENTS AND TRADERS LTD.',
    'Ird mechanalysis limited',
    'Sanman packaging private limited',
    'Gestapo investments private limited',
    'Yalamanchili school of learning private limited',
    'Eperipherals trading limited',
    'NAVEEN REGO CAPITAL PRIVATE LIMITED',
    'Bluestock investments private limited',
    'Dhyan investments and trading company private limited',
    'RMS CREDIT PRIVATE LIMITED',
    'Noble holdings private limited',
    'Sadoday developes limited',
    'Rachit investments limited',
    'SHERRY SECURITIES PRIVATE LIMITED',
    'Roopkala holdings private limited',
    'Yash ventures private limited',
    'Dhanvridhi holdings private limited',
    'Shashank finvest pvt ltd',
    'Pankaj mangaldas securities private limited',
    'Farnworth investment advisors private limited',
    'Pioneer wealth management services limited',
    'Prime research and advisory limited',
    'International financial solutions private limited',
    'PUNE E - STOCK BROKING LIMITED',
    'Rbrk investments limited',
    'K g b securities and investments private limited',
    'Infonic india financial services private limited',
    'Arc holdings limited.',
    'Indak investcorp private limited',
    'Sfs global limited',
    'Rba finance private limited',
    'KARUNA MANAGEMENT SERVICES LIMITED',
    'COGENT FOODS PRIVATE LIMITED',
    'Triburg investments and engineers private limited',
    'STEPTRADE SHARE SERVICES PRIVATE LIMITED',
    'NL FOREX Private Limited',
    'ABCHLOR INVESTMENTS PRIVATE LIMITED',
    'Wealthkraft investment services private limited',
    'V2J CAPITAL FINANCIAL SERVICES PRIVATE LIMITED',
    'My capital solutions private limited',
    'SECMARK CONSULTANCY LIMITED',
    'Messiah investment pvt ltd',
    'SPEARHEAD WEALTH & RISK ADVISORY PRIVATE LIMITED',
    'Rajkamal estates and properties pvt ltd',
    'MEHTA GROWELL HOLDINGS PRIVATE LIMITED',
    'Gold seal holdings pvt ltd',
    'Vishwabharati holdings private limited',
    'Sukhramdas securities p ltd',
    'Wild flower farms and estates private limited',
    'Agmon projects private limited',
    'Embassy office parks management services private limited',
    'Dhanvridhi securities private limited',
    'Indo stosec private limited',
    'Dhangiri securities private limited',
    'Chic infotech private limited.',
    'Dhumketu finvest private limited',
    'Ravson investments private limited',
    'Santosh kumar kejriwal securities pvt. ltd.',
    'KRCHOKSEY SHARES AND SECURITIES PRIVATE LIMITED',
    'Bajoria investments pvt.ltd.',
    'Arunaya insurance brokers private limited',
    'Hastera credit pvt ltd',
    'Shelters financial advisors private limited',
    'Gravitas holdings private limited',
    'Vr wealth advisors private limited',
    'J m land promoters private limited',
    'Maprika properties private limited',
    'Caps gold private limited',
    'Vgn one holdings private limited',
    'Jaycon infrastructure limited',
    'Vandc vaults and finance limited',
    'A p m buildcon private limited',
    'R.g. buildwell engineers limited',
    'Hemadri real estate developers private limited',
    'Lan estates private limited',
    'Ramprastha estates private limited',
    'Bajoria fincon limited',
    'Devasthali constructions private limited',
    'METSSA TRADING PRIVATE LIMITED',
    'Telos risk management and insurance broking services private limited',
    'Gss procon private limited',
    'Supertech precast technologies private limited',
    'WASEEM REAL ESTATES & HOTELS PRIVATE LIMITED',
    'Acumen realtors and projects private limited',
    'Aloo investment company private limited',
    'Bombay education society',
    'Aries properties and finance private limited',
    'Carlton builders and engineers private limited',
    'Maheshwari estates private limited',
    'Shaileen construction pvt ltd',
    'FALCON REAL ESTATE PRIVATE LIMITED',
    'Prabhu pratistha flats private limited',
    'Baijnath maniram holding & finance co. private limited',
    'Sunshine realmart private limited',
    'Patan finance and investment co. limited',
    'Varsha holdings pvt. ltd.',
    'Navkar realventure private limited',
    'Gama investments private limited',
    'Emm cee properties private limited',
    'K k agarwal and associates private limited',
    'Shajiv trading company private limited',
    'Hyphen strategic design private limited',
    'Pioneer finest limited',
    'Surya boards limited',
    'Stanvac chemicals (india) limited',
    'Alankit imaginations limited',
    'P z estates pvt ltd',
    'Fashions flasher (india) private limited',
    'Icon controls private limited',
    'Parul handicrafts private limited',
    'Pallia credits private limited',
    'SHALKOOT MECHANIQUE PRIVATE LIMITED',
    'Bhilwara telenet services private limited',
    'Quickcalls private limited',
    'Smartalk private limited',
    'Shakuntalam portfolio private limited',
    'Control electric company private limited',
    'Asel aviation services and equipments private limited',
    'Neuron marketing private limited',
    'Nika engineers private limited',
    'KDP BUILDWELL PRIVATE LIMITED',
    'CMG WORLDWIDE PRIVATE LIMITED',
    'Unified credit solutions private limited',
    'Inventa cleantec private limited',
    'Bathline (india) private limited',
    'Sanchetna financial services private limited',
    'Ctc electricals private limited',
    'Hmc technologies limited',
    'Cl educate limited',
    'Home concepts private limited',
    'Aslv polymers private limited',
    'Dentsu webchutney private limited',
    'Vrishti impex private limited',
    'Vichara technology (india) private limited',
    'Argos consultants private limited',
    'Albireo telematics private limited',
    'Dreamzsop advertising private limited',
    'Prabhatam aviation private limited',
    'Vel engineering consultants private limited',
    'Cornerstone constructions limited',
    'Auro service consultants private limited',
    'KONECRANES AND DEMAG PRIVATE LIMITED',
    'Preciturn engineering private limited',
    'Srn engineers and associates private limited',
    'Phillips kiln services (india) private limited',
    'Symec engineers (india) pvt.ltd.',
    'Archtec systems (india) private limited',
    'India finance and construction company private limited',
    'Fluid hammer consultancy services private limited',
    'Ibis consulting private limited',
    'Matharoo architects private limited',
    'Aman spices pvt ltd',
    'Silverline graphics private limited',
    'Trend-set engineers private limited',
    'Polestar healthcare and realtech private limited',
    'Capro switchgear company private limited',
    'Ivory financiers private limited',
    'ORBIT TECHSOL INDIA PRIVATE LIMITED',
    'Sahar land and housing private limited',
    'Erik software private limited',
    'Lepide software private limited',
    'Cgn & associates india private limited',
    'KAMAINDIA PRIVATE LIMITED',
    'Viva total facility & management services private limited',
    'Revital business solutions private limited',
    'Craftsman solutions private limited',
    'Kaarak enterprise development services private limited',
    'Orsay international private limited',
    'Extensive brands private limited',
    'Pvrs infra mining private limited',
    'Big pie integrators private limited',
    'Rubal logistics private limited',
    'Peace angels foundation',
    'Aala technical services private limited',
    'Pmv management consulting private limited',
    'Jolene designs private limited',
    'Dataq research private limited',
    'Jump2tech e-solution private limited',
    'Vj verma jewellers private limited',
    'Silverstone technologies (india) private limited',
    'Rajath labour and management services private limited',
    'Enetspark infotech private limited',
    '4b serve private limited',
    'William grant and sons india private limited',
    'Archimedes engineers private limited',
    'Erpi services private limited',
    'Patel warehousing private limited',
    'Chandavarkar & thacker consultants private limited',
    'Narasapur producer transform private limited',
    'Tecnomic components private limited',
    'Tecnomic systems and networks private limited',
    'Walkwater talent advisors private limited',
    'Innovation glass (india) private limited',
    'Maxitech engineering private limited',
    'Frauscher sensor technology india private limited',
    'Kobo books india private limited',
    'UNIWEALTH INVESTMENT SERVICES PRIVATE LIMITED',
    'Wiwotech systems private limited',
    'Trisys it services private limited',
    'Rise finconnect private limited',
    'Eis techinfra solutions (india) private limited',
    'Raj gar-fab private limited',
    'Hue chem textiles private limited',
    'Multibiz (exim) private limited',
    'Sri lakshmi saraswathi spintex limited',
    'AGRICH CROP SCIENCE PRIVATE LIMITED',
    'JEYAVISHNU CLOTHING PRIVATE LIMITED',
    'Pradit fashions private limited',
    'Salasar carpets private limited',
    'Shree kanhaiyalal textiles private limited',
    'Shree sailone synthetics private limited',
    'Jasper textile processors private limited',
    'EPTA INDIA PRIVATE LIMITED',
    'Creative wear private limited',
    'Ryyty apparel resources (india) private limited',
    'Ramsons udhyog private limited',
    'Fusion textile india private limited',
    'Vaikunth properties private limited',
    'Satpuda textiles private limited',
    'Tapi fabrics private limited',
    'Dyandeep textiles private limited',
    'Shivapriya knitwear private limited',
    'Sanmaan exports private limited',
    'Kesharinandan knit fabrics private limited',
    'Akshara garments private limited',
    'Liberti world lingerie private limited',
    'Dhanu textiles private limited',
    'Spread home products private limited',
    'Varsace apparels private limited',
    'Mahacot textiles private limited',
    'Fabricraft impex private limited',
    'Crystal apparels pvt ltd',
    'Turning fashions pvt.ltd.',
    'K b dyeing mills private limited',
    'Neerus ensembles private limited',
    'LOUMIAN ENGINEERING PRIVATE LIMITED',
    'Ideal finishing agency private limited',
    'Kapurthala northern indian tanneries ltd',
    'Royal india texcel private limited',
    'Arthanari loom centre textile private limited',
    'Armstrong knitting mills private limited',
    'Texport syndicate (india) limited',
    'Creative texcare private limited',
    'Stecon polymers private limited',
    'Nivia synthetics pvt ltd',
    'A s nisar ahmed and company limited',
    'Nona technologies private limited',
    'Mufaddel timber and allied products private limited',
    'Aurica laminates limited',
    'Oswal wood private limited',
    'Vritti impex private limited',
    'Aurolam industries private limited',
    'Novell enterprise private limited',
    'Vyankatesh board mills private limited',
    'Sun fine papers private limited',
    'Gupta paper house private limited',
    'Amit packs private limited',
    'TOMOEGAWA AURA INDIA PRIVATE LIMITED',
    'Allure gift wraps private limited',
    'The mysore chip boards limited',
    'Nadia printing & packaging pvt.ltd.',
    'Komark labels india private limited',
    'R. s. print solutions private limited',
    'Supermak foils private limited',
    'Arjun pulp and paper (india) private limited',
    'Cardboard and packaging company (mysore) private limited',
    'Admiral marine services private limited',
    'Globopac india private limited',
    'Modi paper trace india private limited',
    'Priyesh labels private limited',
    'Chachar packaging private limited',
    'Vindhya fabricators private limited',
    'Bitstream mediaworks private limited',
    'Green pearl publications private limited',
    'Contemporary apparel and marketing enterprises private limited',
    'Divya apparels private limited',
    'K v s international private limited',
    'Guru sewak garments private limited',
    'Achievers garments private limited',
    'S.k.d. window fashions private limited',
    'BREAL ESTATE ONE PRIVATE LIMITED',
    'Isiss retail private limited',
    'Tantra garments private limited',
    'Tantra fashions private limited',
    'Vogue accessories private limited',
    'Shreysha textiles private limited',
    'Ayma creations private limited',
    'Pushp creations private limited',
    'Excel apparels exports private limited',
    'Sarju casualwear private limited',
    'Design deal fashions private limited',
    'Pallavaram tanners industrial effluent treatment company limited',
    'Mother impex chennai private limited',
    'RITEX LEATHERS PRIVATE LIMITED',
    'Indexport leather export private limited',
    'A.r.t. international private limited',
    'Florence shoe company private limited',
    'Viking leathers private limited',
    'Blaft publications private limited',
    'Himalaya books private limited',
    'News india publications private limited',
    'SPRINGER NATURE INDIA PRIVATE LIMITED',
    'Prabhat news papers pvt ltd',
    'ZM DIGICONNECT PRIVATE LIMITED',
    'Vedarth animation studio private limited',
    'Naptech packagings private limited',
    'NOVASYS GREENERGY PRIVATE LIMITED',
    'TAMIL NADU ELECTRICITY CONSUMERS',
    'S - CONNOISSEURS OF ART PRIVATE LIMITED',
    'K t exports (india) private limited',
    'Savlani trading and investment company private limited',
    'Ishar trading private limited',
    'Michailides ml oriental tobacco private limited',
    'Varsha sales private limited',
    'Spectators global private limited',
    'Jasol investment& trading co pvt ltd',
    'Intetrade (india) pvt ltd',
    'Prasidh Power Trading Private Limited',
    'Anuga exim services limited',
    'Shakun impex pvt ltd',
    'Jasmin export house private limited',
    'Badrinath trading p ltd',
    'Desai trade credits private limited',
    'Asialink agencies private limited',
    'R d ashar pvt ltd',
    'Address home retail private limited',
    'Neptune engineering private limited',
    'Weyenberg resources (india) private limited',
    'DREAMFOLKS SERVICES LIMITED',
    'Alpine of asia pacific india private limited',
    'JUST EQUIPMENTS PRIVATE LIMITED',
    'Xeno trade private limited',
    'Ratnapriya impex private limited',
    'Golden globex limited',
    'Gdn enterprises private limited',
    'Korloy india tooling private limited',
    'Ars foods ingredients private limited',
    'J. p. switchgear distributors private limited',
    'Forte impex private limited',
    'Abp commercial trade private limited',
    'Eevo corporate advisors private limited (opc)',
    'Vaishali agencies pvt ltd',
    'Raghuvir exim limited',
    'Meena agency ltd',
    'Naval overseas pvt ltd',
    'SALUINT INTERMEDIATES & CHEMICALS PRIVATE LIMITED',
    'Industrial motion india private limited',
    'Variety agents private limited',
    'S k s agencies limited',
    'Oarsman Credit Private Limited',
    'Swell exports private limited',
    'Agson global private limited',
    'Karle international private limited',
    'Vigven tech mark private limited',
    'Transview enterprise india private limited',
    'Natura biotechnol private limited',
    'Geofin comtrade limited',
    'Narang overseas private limited (trf.)',
    'Batot hydro power limited',
    'Barkat exports private limited',
    'Corporate-millennium hygiene solutions private limited',
    'Kalahasti developments and farming private limited',
    'Radius synergies private limited',
    'Boom buying private limited',
    'Trivium power engineers private limited',
    'Simple plant and process solutions private limited',
    'SPG GLOBAL COMMODITIES LIMITED',
    'Spc exports private limited',
    'Elbrina enterprises private limited',
    'CYRUS INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'Softbyte (india) private limited',
    'Manman manufacturing company private limited',
    'ARTOON SOLUTIONS PRIVATE LIMITED',
    'Ideas plus technology solutions private limited',
    'Dream procon private limited',
    'Formz projects private limited',
    'Koncept digital media private limited',
    'Vt netzwelt private limited',
    'Aexonic technologies private limited',
    'Rupa infotech and infrastructure private limited',
    'B.b.professi nals computers and electronics private limited',
    'Bastian solutions india private limited',
    'Galaxy knowledge management solutions private limited',
    'Placid technologies private limited',
    'Abiba systems private limited',
    'Kuliza technologies private limited',
    'Gnosys process consultancy private limited',
    'I-nable solutions private limited',
    'Riversilica technologies private limited',
    'Protonix (india) software private limited',
    'IND WHALES INNOVATIONS PRIVATE LIMITED',
    'Pravaa infosystems private limited',
    'Medal software technologies private limited',
    'Onya digital solutions private limited',
    'Pure online panel research services private limited',
    'SMART INFORCE COMPUTING (INDIA) PRIVATE LIMITED',
    'Inowits technologies private limited',
    '3S TECHNOLOGIES & AUTOMATION PRIVATE LIMITED',
    'Verity infotech private limited',
    'Tangence solutions (india) private limited',
    'Nuvodev technologies private limited',
    'Reflektion media software (india) private limited',
    'Yana enterprises private limited',
    'Pegarse technologies private limited',
    'Ponsai business consultant private limited',
    'Peol technologies private limited',
    'Vector hr consulting private limited',
    'Adman technologies pvt ltd',
    'Kran consulting private limited',
    'Tanshikii technologies private limited',
    'Ulccs it infrastructure private limited',
    'Bbn townships private limited',
    'Millennium real estate developers private limited',
    'Markuplab technologies private limited',
    'Tenderwoods solutions private limited',
    'Ten sol software private limited',
    'Nexgenix (india) private limited',
    'Pboplus consulting services private limited',
    'U s technosoft private limited',
    'Indigo systems and technology consulting (india) private limited',
    'Jindal technologies and management services private limited',
    'Genius corner educom private limited',
    'Production modeling india private limited',
    'Wish i.t. services private limited',
    'Wave infotech solutions india private limited',
    'Thinpc technology private limited',
    'Tanisi it services private limited',
    'RSTAR TECHNOLOGIES PRIVATE LIMITED',
    'Aats services private limited',
    'Klonsys techno services private limited',
    'Dream weavers infomatics private limited',
    'Ameba softwares private limited',
    'Insat lynx computers private limited',
    'Softenger (india) private limited',
    'Ergin imaging systems private limited',
    'Vista neotech private limited',
    'Athelp info solutions private limited',
    'Access technical solutions private limited',
    'Cursive technologies private limited',
    'EVERYTHING FINANCIAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Saiyash technologies private limited',
    'Algosys technologies private limited',
    'Sarvaha systems private limited',
    'Innovative systems pvt ltd',
    'Eworks technologies private limited',
    'VENIRE PRIVATE LIMITED',
    'Logiquebrain consultancy india private limited',
    'Soham software services private limited',
    'Focus softnet private limited',
    'Visapro services private limited',
    'Karthik solus limited',
    'Suryajyoti infotech limited',
    'Softquest technologies private limited',
    'Arkin software technologies private limited',
    'NORTHTEL PRIVATE LIMITED',
    'I.r. computer solutions private limited',
    'Psr soft labs private limited',
    'Iprocess business solutions private limited',
    'LOGINSOFT PRIVATE LIMITED',
    'Bit order technologies private limited',
    'S p a enterprise info services (india) private limited',
    'Bloomedha info solutions limited',
    'Corpone outsourcing private limited',
    'Santo systems private limited',
    'AVENSYS GLOBAL TECHNOLOGY PRIVATE LIMITED',
    'Atharvan business consulting private limited',
    'Aareeva esolutions private limited',
    'Sine info ventures private limited',
    'Arcelia it services private limited',
    'DESIGNTECH SYSTEMS PRIVATE LIMITED',
    'Bijib soft private limited',
    'Sutherland global services private limited',
    'Americorp capital private limited',
    'Redisolve software private limited',
    'Brand idea consultancy private limited',
    'Idea center for educational research',
    'Wellwisher academic institution private limited',
    'Exquisite services limited',
    'Rahi care mandi private limited',
    'Shinon collaborative consultancy private limited',
    'Futures group outreach',
    'Advantage nashik foundation',
    'Garbhasanskar antenatal services private limited',
    'Comsat tv7 health planet private limited',
    'Hi-tech systems & services ltd.',
    'Axiom gen nxt india private limited',
    'Healthadda retail private limited',
    'Abdos labtech private limited',
    'Esteem integrated logistics private limited',
    'Marconis institute private limited',
    'Birla edutech limited',
    'TAHERA & IDRIS FAROOQUI FOUNDATION',
    'Msp investment private limited',
    'Scorpion security limited',
    'Antya shala educational and social foundation',
    'Svkm foundation',
    'Pulsatom health care private limited',
    'Tuscan properties private limited',
    'Malnad hospital and institute of oncology private limited',
    'Skf par boiled driers private limited',
    'KIDS CLINIC INDIA LIMITED',
    'Agile testing alliance association',
    'Disha education',
    'Dake hospitals private limited',
    'Jehangir clinical developement centre private limited',
    'Kamineni fertility center private limited',
    'Asian institute of nephrology and urology private limited',
    'LIFELINE MULTI SPECIALITY HOSPITALS PRIVATE LIMITED',
    'Sutherland healthcare solutions private limited',
    'Apollo clinical excellence solutions limited',
    'Edulabs learning solutions private limited',
    'Micro solutions (india) pvt ltd',
    'Leaderz walk life skills education private limited',
    'Triumph through training private limited',
    'Iris health services limited',
    'YUVNAM PRIVATE LIMITED',
    'Ez healthline private limited',
    'Immucor india private limited',
    'Enhance aesthetic & cosmetic studio private limited',
    'Venire foundation',
    'Solace research private limited',
    'Alta laboratories limited',
    'Techtronics education (india) limited',
    'Australian indian rural development foundation',
    'Brilliant exams and scholastic tests private limited',
    'Sparc samudaya nirman sahayak',
    'Banyan universal academy',
    'Vxl india edu centre private limited',
    'L. P. SAVANI INSTITUTES PRIVATE LIMITED',
    'Sparsh diagnostica private limited',
    'SIXD ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'Professional fashion and management private limited',
    'Commtel foundation',
    'Sas production private limited',
    'Eduved learning solutions private limited',
    'Excel entertainment private limited',
    'Performance audio india private limited',
    'Ameya infotainment private limited',
    'Endemol india private limited',
    'VASIND FARM & DAIRY PRODUCTS PRIVATE LIMITED',
    'Fastway mahalakshmi cable network private limited',
    'Gee info media private limited',
    'Golcha cinetale pvt limited',
    'Pla entertainment private limited',
    'Gurgaon recreation park limited',
    'Salora audio video services private limited',
    'Zykonn medicare private limited',
    'Tulsea pictures private limited',
    'Adroa healthcare private limited',
    'Ashoka intercast foundry private limited',
    'Tuscan consultants and developers private limited',
    'S.s. edutainment private limited',
    'Prathamesh kala kendra',
    'Westfort hi tech hospital limited',
    'Value E-Healthcare Limited',
    'Savi vision private limited',
    'Indian hospitals corporation limited',
    'Skdj ganpati health care private limited',
    'North bengal oncology centre private limited',
    'Ohio cardiology associates india private limited',
    'Spark entertainments private limited',
    'Axon medical solutions private limited',
    'QUBE CINEMA TECHNOLOGIES PRIVATE LIMITED',
    'G n m nursing home private limited',
    'Bridge music private limited',
    'Anjuman-i-islam',
    'Prithvilok welfare association',
    'A.b.medical centres limited',
    'Leaf cleantech private limited',
    'Rai bahadur mathura dass education foundation',
    'AVANTARI TECHNOLOGIES PRIVATE LIMITED',
    'India home health care private limited',
    'G-eng advisory services private limited',
    'Apparel made-ups and home furnishing sector skill council',
    'India foundation for humanistic development',
    'Kshitij entertainment private limited',
    '007 universe resorts & spa private limited',
    'Business ethics foundation',
    'Topsource support services private limited',
    'WOLF MACHINE TOOLS LIMITED',
    'Bajrangbali rolling mills limited',
    'Shri hare-krishna sponge iron limited',
    'Neo metaliks limited',
    'Mal metalliks private limited',
    'Jal pravahika pvt ltd',
    'Siddhant ispat private limited',
    'Chamundi die cast private limited',
    'Weltek pumps pvt ltd',
    'Sai ram properties private limited',
    'Utsav industries pvt ltd',
    'Stone sapphire (india) private limited',
    'Wood grip induistries private limited',
    'Liluah ceramics pvt limited',
    'Pasa associates private limited',
    'Supriya buildcon private limited',
    'Shri kalyan buildmart private limited',
    'Axis royal real estate developers private limited',
    'Ramraj engineering private limited',
    'Akarsh property developments private limited',
    'Vismaya builders and developers private limited',
    'Kalpak superprojects private limited',
    'Waterman aquatic systems private limited',
    'Haryana power generation corporation ltd',
    'Srm infra projects private limited',
    'Mirage infra limited',
    'Ytc housing private limited',
    'N.s. readymix private limited',
    'Glaze builders private limited',
    'Bds homes private limited',
    'Kgk real estate private limited',
    'Moon buildestates private limited',
    'Red chilli developers private limited',
    'Pareek power private limited',
    'DUKES AND SHANTHA HOMES PRIVATE LIMITED',
    'Saanvi infrastructure private limited',
    'Goldenoak projects private limited',
    'Kanak buildhome private limited',
    'Kgk infrastructure and developers private limited',
    'Team building systems private limited',
    'TRIDENT RESIDENCY PRIVATE LIMITED',
    'Trident buildtech private limited',
    'Trident buildwell private limited',
    '3RD SPACE PRIVATE LIMITED',
    'Saanidhanam infrastructure development private limited',
    'KGK INFRASTRUCTURE (INDIA) PRIVATE LIMITED',
    'Namokar buildestate private limited',
    'Oasis irrigation equipment co ltd',
    'Alcoi india private limited',
    'Northern sky properties private limited',
    'Kalpak realty private limited',
    'Nice infracon private limited',
    'Exalter developers private limited',
    'Ratnali homes private limited',
    'Shri ambika power and sugar private limited',
    'Akarshak builders and developers private limited',
    'Samal builders private limited',
    'Daksha infrastructure private limited',
    'Prestar infrastructure projects limited',
    'Swarup enclave private limited',
    'Jaimata tower private limited',
    'Well homes projects private limited',
    'Mme infrastructure private limited',
    'Bhavesh buildcon private limited',
    'Aric infrabuild private limited',
    'Parth builtech private limited',
    'Gajgamini promoters private limited',
    'Sakthifinance commercial vehicle and infrastructure limited',
    'CELICA MOTORBIKES PRIVATE LIMITED',
    'Isum motors private limited',
    'Sarabhai m. chemicals limited',
    'Badhwar cars private limited',
    'Zulaikha motors private limited',
    'Utkal autobody private limited',
    'Shridhara infratech private limited',
    'Shrines projects private limited',
    'Walls & bridges (india) private limited',
    'Ranil infratech private limited',
    'Abra motors private limited',
    'Vibrant vehicles private limited',
    'Ranil projects private limited',
    'Rapid infrastructure private limited',
    'Lvr holding limited',
    'Maa tara buildtech private limited',
    'Aaa pee foundations private limited',
    'Assam jute park developers limited',
    'Pranic enterprises private limited',
    'Sureka international private limited',
    'Jagannath agri trading private limited',
    'Trinity golf india private limited',
    'Namokar enterpriss private limited',
    'Streamline developers private limited',
    'Sulabh developers private limited',
    'Sree rani sati infracon private limited',
    'Satts estates limited',
    'Hirawat electricals private limited',
    'Model vintrade private limited',
    'Basera niketan private limited',
    'Sunita finlease limited',
    'Cbb energy (india) private limited',
    'Chakiat agencies private limited',
    'REGAL AGRO FOODS PRIVATE LIMITED',
    'Vishnu colonizers private limited',
    'Citypulse maintenance services private limited',
    'Blue diamond buildcon private limited',
    'Krishna landcon private limited',
    'Naman sales private limited',
    'Girik housing projects private limited',
    'Eastern chamber of commerce',
    'SHREE SERVICES & TRADING CO LTD',
    'Murlidhar ratanlal exports ltd',
    'Bharat vanijya eastern pvt ltd',
    'Ard estates and projects private limited',
    'Wonderbuild infrastructure private limited',
    'Naresh kumar & company pvt ltd',
    'Starlink abasan private limited',
    'Shivdata properties private limited',
    'Maharashtra auto parts private limited',
    'Bamalwa diamonds ltd',
    'ASHOKA MANUFACTURING PRIVATE LIMITED',
    'Rasaraj supply pvt ltd',
    'Webnesters online solutions private limited',
    'Shri vitthal plastics private limited',
    'India parenting private limited',
    'Pranjal technologies private limited',
    'SCS TECH INDIA PRIVATE LIMITED',
    'WARNER ELECTRONICS INDIA PRIVATE LIMITED',
    'Hi tech hubs private limited',
    'De facto infotech private limited',
    'S c horizons consulting private limited',
    'Total i t solutions private limited',
    'Oztron eco energy private limited',
    'Advance software technologies private limited',
    'Orbit innovations private limited',
    'Gunank technologies private limited',
    'Celcius technologies private limited',
    'Marg infotech private limited',
    'Hybridtronics private limited',
    'Innefu labs private limited',
    'Responsible investment research association',
    'QUATTRO ENGINEERING INDIA PRIVATE LIMITED',
    'Edutech soft private limited',
    'Ids eservices limited',
    'Shiv shakti realtech private limited',
    'Dignitas digital private limited',
    'Havns corporate services private limited',
    'Showboat entertainment private limited',
    'Albatross projects private limited',
    '4FRONT ANALYTICS PRIVATE LIMITED',
    'Innovationm mobile and web technologies private limited',
    'Vishesh business systems private limited',
    'It dezignhub private limited',
    'Blastoff web solutions private limited',
    'Ezeiatech systems private limited',
    'Futuristic internet services private limited',
    'Net4u technology private limited',
    'Growmore advisors private limited',
    'Ascent human solutions pvt ltd',
    'Sg services pvt. ltd.',
    'Infomagine softwares private limited',
    'Rmax broadband private limited',
    'General services corporation private limited',
    'Vidhi services pvt ltd',
    'Jk plant bio sciences research limited',
    'Cozclub consulting private limited',
    'Crayons logistics solutions private limited',
    'Comma consulting private limted',
    'Bean consulting private limited',
    'Red kite consulting private limited',
    'Watchover management solutions private limited',
    'Sunil promoters pvt ltd',
    'AFRY INDIA PRIVATE LIMITED',
    'Rts rural technologies solutions private limited',
    'PROTON FACILITY SOLUTIONS PRIVATE LIMITED',
    'Adwitiya strategic solutions private limited',
    'Zenith financial consulting private limited',
    'Hermes global holdings private limited',
    'Asiapacific academy for aviation & hospitality private limited',
    'Ia property developers private limited',
    'Kkc estates pvt.ltd.',
    'Planet commercial private limited',
    'Viven advisory services private limited',
    'Easyshop marketing private limited',
    'A k productions private limited',
    'PROTOCOL INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED',
    'White water advisors private limited',
    'Pace connect private limited',
    'Ronlance consulting services private limited',
    'SALVEO INTERNATIONAL DEVELOPMENT INDIA PRIVATE LIMITED',
    'Strategic safe management private limited',
    'TCG CENTRES FOR RESEARCH AND EDUCATION IN SCIENCE AND TECHNOLOGY',
    'Sensenet technologies private limited',
    'Apr consultants private limited',
    'Apple finconsultants private limited',
    'ELYSIUM CAPITAL ADVISORY PRIVATE LIMITED',
    'P c management system private limited',
    'Yamai fashions private limited',
    '2coms consulting private limited',
    'Railcon technical consultancy services private limited',
    'Economy realtors advisory private limited',
    'Actuate management consultants private limited',
    'Gallop consultants private limited',
    'GENSOL ENGINEERING LIMITED',
    'Teracon construction (india) private limited.',
    'SAFE GLOBAL VENTURES PRIVATE LIMITED',
    'Sbd arkay engineers pvt ltd',
    'Amogh consultants private limited',
    'Amritkunj capital markets ltd',
    'Sri krishna viniyog pvt ltd',
    'MGM ENGINEERS & CONSULTANTS PRIVATE LIMITED',
    'Pora developers private limited',
    'Whirlworks aerial private limited',
    'CHHARIA IMPEX PRIVATE LIMITED',
    'Sampan media private limited',
    'Global fairs & media private limited',
    'New vision printing services private limited',
    'Rio management services private limited',
    'Root info solutions private limited',
    'Praman techno soft india private limited',
    'SIRIUS AUTOMATION SYSTEMS PRIVATE LIMITED',
    'Ann pharma and food solutions private limited',
    'Kanvic consulting private limited',
    'Bharat ram associates private limited',
    'Super tyres private limited',
    'Industrial foams private limited',
    'Medical engineers (india) ltd.',
    'Pride of india pvt ltd',
    'Economic gateway consultants private limited',
    'Mittal professional services private limited',
    'Saraf services private limited',
    'Environmental design solutions private limited',
    'Aura design and projects private limited',
    'India infrastructure publishing private limited',
    'Jus scriptum magnus private limited',
    'GUJARAT MITRA PRIVATE LIMITED',
    'Vj creations private limited',
    'Indian tanning industries private limited',
    'United india periodical pvt ltd',
    'SUZDAL RAIL PRIVATE LIMITED',
    'Colortone process private limited',
    'Spectrum images private limited',
    'H g graphics private limited',
    'Trinity snacks private limited',
    'Volga foods private limited',
    'New horizons manufacturing private limited',
    'SURDAS TRADING & MANUFACTURING CO LTD',
    'Alankar business corporation private limited',
    'Bombay footwear private limited',
    'Ahill apparel exports private limited',
    'Associated colours industries private limited',
    'Pratap pandit limited',
    'SIDDHARTH COLORCHEM Private Limited',
    'Swastik starchem private limited',
    'Merck specialities private limited',
    'Farm chem india private limited',
    'The andhra farm chemicals corporation limited',
    'PRING FASHIONS PRIVATE LIMITED',
    'RAJDHANI CRAFTS INTERNATIONAL PRIVATE LIMITED',
    'Ravina chemicals private limited',
    'Amogh chemicals private limited',
    'Apan carbon private limited',
    'K k polycolor asia limited',
    'Mieco boards private limited',
    'Halides chemicals private limited',
    'Classic furniture manufacturing company pvt ltd',
    'Kalpataru packaging products private limited',
    'Shyam tex chem private limited',
    'Supack industries private limited',
    'Gullybaba publishing house private limited',
    'Lion tapes private limited',
    'SANE VOICE VENTURES PRIVATE LIMITED',
    'Kolkata rising publications private limited',
    'Jm coating solutions private limited',
    'Rachna agrochem private limited',
    'Tropical agro system (india) private limited',
    'Advance shoes private limited',
    'Kalachuvadu publications private limited',
    'Ori plast ltd.',
    'Mahesh timber private limited',
    'Ruia chemicals pvt ltd',
    'Suman agrovet private limited',
    'Galpha laboratories limited.',
    'Concord biotech limited',
    'SPC LIFE SCIENCES LIMITED',
    'Karukrit advertising pvt ltd',
    'Ananda offset pvt ltd',
    'Litizen entertainment private limited',
    'MOSER BAER ELECTRONICS LIMITED',
    'Indermani coal benefication & energy private limited',
    'Desai chemical co pvt ltd',
    'North east hydrocarbon limited',
    'Lucky pharmaceuticals private limited',
    'Aims pharma private limited',
    'KWALITY PHARMACEUTICALS Limited',
    'Dhanlaxmi petroleum private limited',
    'Ambe dye-chem pvt ltd',
    'Shanpar industries private limited',
    'Zydus hospitals and healthcare research private limited',
    'Super ammonia pvt ltd',
    'Reo remedies private limited',
    'Laborate pharmaceuticals india ltd',
    'INTECH ORGANICS LIMITED',
    'Haffkine bio-pharmaceutical corporation limited',
    'Acro paints limited',
    'Genesis organics private limited',
    'ROY',
    'LA MODE GARMENTS PRIVATE LIMITED',
    'Alphatech distributors private limited',
    'Saanvi impex india private limited',
    'Arete trading private limited',
    'Best marketing company private limited',
    'ORCHIDS NETWORK & SYSTEMS INDIA PRIVATE LIMITED',
    'Aryan technologies and telecommunication private limited',
    'TARAHAAT INFORMATION AND MARKETING SERVICES Private Limited',
    'Network 4 barter private limited',
    'Impact public relations private limited',
    'TFK GLOBAL PRIVATE LIMITED',
    'Srg engineering private limited',
    'Biovitrum lifesciences private limited',
    'Onerx medicals private limited',
    'H k d diamond laboratories (canada) private limited',
    'Re jewels private limited',
    'K l export private limited',
    'Ganador international private limited',
    'KUNNEL SPD PRIVATE LIMITED',
    'Mpl agencies pvt ltd',
    'Osb overseas private limited',
    'Katbro corporation private limited',
    'Katyayani overseas private limited',
    'M.a. market services private limited',
    'Amtel communication private limited',
    'Bols kyndal india private limited',
    'Patodia syntex limited',
    'Regal shoes (inidia) private limited',
    'Times marketing private limited',
    'Krpc enterprises private limited',
    'Pkn trading private limited',
    'Safetech tradex private limited',
    'Perfetti van melle india private limited',
    'Mybaby retail india private limited',
    'C anand and associates (lighting) pvt ltd',
    'Nirved traders private limited',
    'Pacific-harish industries limited',
    'Sigmawamco mercantiles private limited',
    'Victorinox india private limited',
    'Toyop relief private limited',
    'NOUAM TECHPRENEURS PRIVATE LIMITED',
    'Bullworker private limited',
    'Thuse elektronics private limited',
    'Unisource sales private limited',
    'Dpi exports private limited',
    'Phobos trading private limited',
    'Dynamic computer marketing enterprises private limited',
    'Brilltech india exports private limited',
    'SLJ VISION PRIVATE LIMITED',
    'Triveni global private limited',
    'Monika exim international limited',
    'Kalpaka exim private limited',
    'Mackk networks private limited',
    'EFC LIMITED',
    'Pkm construction private limited',
    'Veasta technologies private limited',
    'Wonder point creative solutions private limited',
    'Renaissance technology private limited',
    'Quicksun technologies private limited',
    'Open destination infotech private limited',
    'Linkstar infosys private limited',
    'Acmefil engineering systems private limited',
    'Sarita infotech pvt ltd',
    'Shree krupa systems private limited',
    'Vital intelligence technology private limited',
    'Satrang technologies private limited',
    'Arora-group international private limited',
    'Paycraft solutions private limited',
    'Ilabs info technology center (gurgaon) private limited',
    'Saviance technologies private limited',
    'CIRCLE POINT VENTURES PRIVATE LIMITED',
    'Valliappa software technological park private limited',
    'Krishi irrigation private limited',
    'Surya software systems private limited',
    'Anisha infotech private limited',
    'Eduquity career technologies private limited',
    'COURSE5 INTELLIGENCE LIMITED',
    'Sobis software (india) private limited',
    'Witness systems software (india) private limited',
    'Eminentlabs software private limited',
    'Softway solutions private limited',
    'Briskon technologies private limited',
    'Servicemax technologies (india) private limited',
    'I- trust informatics private limited',
    'Lore software solutions private limited',
    'Dynafusion technologies private limited',
    'Vision el-tech and services private limited',
    'Headrun technologies private limited',
    'Gajatatre housing pvt. ltd.',
    'Ksj infrastructure private limited',
    'The great india car and coach rentals private limited',
    'Leasing iq (india) private limited',
    'Cray supercomputers (india) private limited',
    'Hitech comprint private limited',
    'Oliveboard comptech private limited',
    'FLYIN TRAVEL AND TOURISM PRIVATE LIMITED',
    'TRACXN TECHNOLOGIES LIMITED',
    'BETA CAE SYSTEMS INDIA PRIVATE LIMITED',
    'Calligo technologies private limited',
    'SOMAYAJI TECHSERV INDIA PRIVATE LIMITED',
    'S-h trafficdata solutions private limited',
    'Choice infoway private limited',
    'Pinnacle innovative technologies private limited',
    'Vtrio solutions private limited',
    'Madmart services private limited',
    'Novation technologies private limited',
    'Mod computers private limited',
    'Infotech financials private limited',
    'Startree apartments private limited',
    'Sharanam realinfra private limited',
    'Navyug infrarealty private limited',
    'Ugo technologies private limited',
    'Unigreens properties private limited',
    'Indosam infra private limited',
    'SYNTEL Private Limited',
    'Aver software technologies limited',
    'Mahesh software systems private limited',
    'GALLAGHER INSURANCE BROKERS PRIVATE LIMITED',
    'Pen india limited',
    'Skidata (india) private limited',
    'No frills deal realty services private limited',
    'Broadway infotech private limited',
    'BHAANE PRIVATE LIMITED',
    'Mushroom softech private limited',
    'Extrapolix technologies private limited',
    'Sairam softek private limited',
    'Ichigo technologies private limited',
    'Ennovations techserv private limited',
    'Cbase infotech (india) private limited',
    'D.b. informatics private limited',
    'Kh it solutions private limited',
    'INTELSOFT PRIVATE LIMITED,',
    'Imagene technologies private limited',
    'Softview technologies private limited',
    'Aretove technologies india private limited',
    'Smartdv technologies india private limited',
    'Tekdi technologies private limited',
    'Corona ventures solutions private limited',
    'Sempersol consultancy private limited',
    'Bodacious it hub private limited',
    'Innate info services private limited',
    'DIGITRAL PRIVATE LIMITED',
    'TYCHE INVESTMENTS PRIVATE LIMITED',
    'Perfect business technologies private limited',
    'Bob eprocure solutions private limited',
    'MFLIXWORLD TECHNOLOGIES PRIVATE LIMITED',
    'Scientia infocom india private limited',
    'Merquri work and play private limited',
    'Si3d systems private limited',
    'KOTHREPALLY DEVELOPERS PRIVATE LIMITED',
    'Laga systems private limited',
    'I-biz software private limited',
    'Calmove technologies private limited',
    'Ananth phoenix infrazone private limited',
    'Inteq bpo services private limited',
    'Val-met engineering private limited',
    'Scimergent analytics and education private limited',
    'Vie support language services private limited',
    'Athena infonomics india private limited',
    'Ashajyot mercantile private limited',
    'Aequitas debt solutions private limited',
    'Sentryforce securitas private limited',
    'Ideal techlabs private limited',
    'APPRENDER PRIVATE LIMITED',
    'India cements infrastructures limited',
    'Contentino entertainment private limited',
    'Anmol automobiles private limited',
    'Axiomrc recruitment consultants private limited',
    'Pasa resources private limited',
    'Hmshost services india private limited',
    'AVAILITY INDIA PRIVATE LIMITED',
    'MCA CONSULTING SERVICES PRIVATE LIMITED',
    'Carbon masters india private limited',
    'Tuscon technologies private limited',
    'J d jones and co (bombay) pvt ltd',
    'KONTI INFRAPOWER & MULTIVENTURES PRIVATELIMITED',
    'Bombay cotton and yarn company private limited',
    'Among beyond ventures private limited',
    'Glocal ventures private limited',
    'VYANA WEALTH MANAGEMENT PRIVATE LIMITED',
    'Evergreen separatech private limited',
    'Hospitality appliances private limited',
    'Bonai services private limited',
    'Smruta engineering industries private limited',
    'Pranay cones and tubes pvt.ltd.',
    'Reliable pest control p ltd',
    'MMP INTERNATIONAL PRIVATE LIMITED',
    'Business development bureau (india) private limited',
    'Onco life sciences private limited',
    'Kunal industries private limited',
    'Alf design consultants private limited',
    'Broadridge financial solutions (india) private limited',
    'Golden edutech private limited',
    'The tips global institute',
    'Kolt design services private limited',
    'Innovus eduservices private limited',
    'Cma mental arithmetic (india) private limited',
    'Jnd edu management services private limited',
    'Jnd edu-infra services private limited',
    'Anuttam academic institutions',
    'Kripa educational institutions private limited',
    'Dharthy marketing private limited',
    'Ksmd impex (india) private limited',
    'Radcliffe education (east) private limited',
    'Modi scientific management techniques private limited',
    'Oes consultants private limited',
    'Inko services private limited',
    'School of applied learning in testing private limited',
    'Aparajitha institutions',
    'Manchester international school',
    'Coimbatore innovation and business incubator',
    'Global education solutions india private limited',
    'Sarvam education infrastructure private limited',
    'Street infra private limited',
    'Ahaguru education technology private limited',
    'S m e-learning solutions private limited',
    'Deutsche schule chennai private limited',
    'Super speeds private limited',
    'Royal universys webnet private limited',
    'Radcliffe education private limited',
    'Ibrain thinking solutions private limited',
    'Launchpad learning labs and career private limited',
    'Metcoat tech solutions private limited',
    'Cibi anand impex private limited',
    'Cygnus journalism private limited',
    'Sm flow & controls private limited',
    'INDIGO CATERING & SERVICES PRIVATE LIMITED',
    'Rozgar vikas education private limited',
    'PEOPLE GOODNESS FORUM',
    'Tarini lifesciences limited',
    'Rashmi smart meters private limited',
    'Gurung & al security systems private limited',
    'Ela spa and healthcare private limited',
    'Desai hospitals private limited',
    'Multimode enterprises private limited',
    'Icad school of learning private limited',
    'Botanic healthcare private limited',
    'Vidya.com consultancy private limited',
    'Trio vidyakkendra private limited',
    'Sushruta medical aid and research hospital limited',
    'Baljees hotels and real estates private limited',
    'India satcom limited',
    'Purv knowledge solutions private limited',
    'Maple bear education private limited',
    'PARSHI TRAINING AND TECHNICAL SERVICES PRIVATE LIMITED',
    'Joyeria jewels india private limited',
    'Harsh futures commodities private limited',
    'KHURANAA HOSPITALITY PRIVATE LIMITED',
    'Shree amman pharma private limited',
    'Shyam agency private limited',
    'Xerxes traders pvt. ltd.',
    'Ankit impex india private limited',
    'Vastrakala exports private limited',
    'Kno-well ceramics private limited',
    'Bridge n bond marketing private limited',
    'Epic marketing company pvt ltd',
    'Ruby mercantile company pvt ltd',
    'Synthetic packers private limited',
    'Shyam ganga traders private limited',
    'Joyprit plastic dealers private limited',
    'SCORECHEM CHEMICALS PRIVATE LIMITED',
    'Hitech industrial suppliers india private limited',
    'Ncr vehicles private limited',
    'Malay exports private limited',
    'Wooma & company (forwarders) pvt. ltd.',
    'Caravel logistics private limited',
    'Southern shipping agencies p ltd',
    'Smart parking india private limited',
    'Green channel inter-port services private limited',
    'Anugraha logistics private limited',
    'Asmi express private limited',
    'Ardom holdings private limited',
    '365 build technologies india private limited',
    'Cabsat channels private limited',
    'Ergotor information technologies private limited',
    'Tekno tele infra services private limited',
    'Rkpl call centre private limited',
    'Eagle conferencing private limited',
    'Astonfield tower communication privatelimited',
    'I-win advisory services limited',
    'Analysys mason india private limited',
    'V s verma infranet private limited',
    'GTPL HATHWAY LIMITED',
    'Maheswari brothers holdings private limited',
    'Scorpio fiscal markets private limited',
    'My Branch Services Private Limited',
    'Shipa fabrics private limited',
    'ACKURETTA SYSTEMS PRIVATE LIMITED',
    'Pny sabha finance limited',
    'Ideal toll & infrastructure private limited',
    'AMERICAN EXPRESS SERVICES INDIA PRIVATE LIMITED',
    'SAINATH COMMERCIAL CREDIT PRIVATE LIMITED,',
    'Elixir financial services private limited',
    'Isc investment & finance private limited',
    'Ardelis financial services private limited',
    'PURAK INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'TIBIO INNOVATION SOLUTIONS PRIVATE LIMITED',
    'Prompt fincap private limited',
    'Ecofin services india private limited',
    'Mittal investment and agencies private limited',
    'Shree rasbihari trading and investments pvt ltd',
    'Shree kishorijee trading and investments pvt ltd',
    'SURELA INVESTMENT AND TRADING LIMITED',
    'Complan securities private limited',
    'Go go investment private limited',
    'Baiju trading and investments pvt ltd',
    'Island investments private limited',
    'Devyani finance and investment private limited',
    'Vridhi shares and securities private limited',
    'Alchemy equity research and securities private limited',
    'Bal krishna builder private limited',
    'Vaammpus ex-imports holdings private limited',
    'Value added corporate services private limited',
    'Amass chits private limited',
    'FE FUNDINFO (INDIA) PRIVATE LIMITED',
    'Provigil surveillance limited',
    'Vital natural resources private limited',
    'Gift collective investment management company limited',
    'Rolta resources private limited',
    'N & J FINSTOCKS PRIVATE LIMITED',
    'Jc biotech private limited',
    'GNSA INFOTECH PRIVATE LIMITED',
    'Hsm investments ltd',
    'ACCIL Corporation Private Limited',
    'Systematix assets management company private limited',
    'SV GLOBAL FINANCE PRIVATE LIMITED',
    'Sahshru finance pvt ltd',
    'Future first insurance broking private limited',
    'Unisafe insurance brokers private limited',
    'Span caplease private limited',
    'OSB STOCKBROKING PRIVATE LIMITED',
    'K b investments private limited',
    'Jaldhar investments and trading company private limited',
    'Pohoomals exports private limited',
    'Lucid productions private limited',
    'Nederman india private limited',
    'Meine kuche india private limited',
    'Corning finolex optical fibre private limited',
    'Payper bagging india private limited',
    'Ramsona industries private limited',
    'Nature connect india private limited',
    'Sathya innovative solutions (india) private limited',
    'Haritha laboratories private limited',
    'Artjini private limited',
    'Styrax instruments india private limited',
    'Excel cash management corporation private limited',
    'Innovative management solutions (india) private limited',
    'Rohm semiconductor india private limited',
    'Uni logistic agencies private limited',
    'Sigma media services private limited',
    'Pelican consolidates private limited',
    'VGN HOME BUILDING INDIA PRIVATE LIMITED',
    'Nexus innovative solutions private limited',
    'Aspen care private limited',
    'Thor power systems (india) private limited',
    'Aura biotechnologies private limited',
    'Dream warrior pictures private limited',
    'Tefmo software solutions private limited',
    'Magtech security systems private limited',
    'Darpan dealcom limited',
    'Shibani departmental stores private limited',
    'Ps ixora flat owners association',
    'Sai vardan services private limited',
    'Ruby management services private limited',
    'Talentahead india private limited',
    'Asiapower recruitment consultants limited',
    'Zircon international limited',
    'Topsline life response services private limited',
    'Globe security services private limited',
    'COLUMBIA MACHINE ENGINEERING (INDIA) PRIVATE LIMITED',
    'Jaimin packaging private limited',
    'Axis polyfilms private limited',
    'Vollert india private limited',
    'S g s india private limited',
    'Karan bottling company private limited',
    'Alphard maritime private limited',
    'Tisa tech secure private limited',
    'Licit local media private limited',
    'Horizon survey company india private limited',
    'PEEL-WORKS PRIVATE LIMITED',
    'APEX BUSINESS SERVICES PRIVATE LIMITED',
    'Purple tree business solutions private limited',
    'M&m outdoor (india) private limited',
    'Premier wire products limited',
    'Sabesan technical services private limited',
    'Marwadi commodity broker private limited',
    'National commodity clearing limited',
    'Om sai finmart private limited',
    'Idt design consultants private limited',
    'Malta creations private limited',
    'Erm placement services pvt ltd',
    'ULTRA WASH TEX PRIVATE LIMITED',
    'Maple esolutions limited',
    'Dhi-(india) water and environment private limited',
    'Isf commodities private limited',
    'Advanced engineering solutions private limited',
    'V civilnet india private limited',
    'Vertex advisory services private limited',
    'Emarketz india private limited',
    'General mobile technology india private limited',
    'Bookmyseats private limited',
    'GEODIS INDIA PRIVATE LIMITED',
    'Shearvan purchasing india private limited',
    'Dunnhumby consulting services india private limited',
    'TUSKERS SERVICES INDIA PRIVATE LIMITED',
    'Azim premji trustee company private limited',
    'Associated human resource service private limited',
    'Aquasphere greentech solutions private limited',
    'Ewie services india private limited',
    'Sai infraaequipments private limited',
    'Arizona printers and packers pvt ltd',
    'Four dimensions securities (india) limited',
    'Millennium pools pvt. ltd.',
    'Aurangabad forging private limited',
    'Global charts & navaids private limited',
    'Zeal consultants and trading private limited',
    'Electro plasma equipments p.ltd.',
    'Human factors international private limited',
    'Yogi display arts private limited',
    'ACUITE RATINGS & RESEARCH LIMITED',
    'Optimo finance private limited',
    'Joule tech industrial services private limited',
    'Green elephant india private limited',
    'Veritas global private limited',
    'Nextgen corporate innovations private limited',
    'Unipart services india private limited',
    'Quantum projectinfra private limited',
    'Money manthan advisors private limited',
    'STE MET (INDIA) PRIVATE LIMITED',
    'Shunipta plastocare private limited',
    'Sharp control equipments private limited',
    'Fifth generation technologies india private limited',
    'Toshiba software (india) private limited',
    'Rambus chip technologies (india) private limited',
    'Itlogix integrated systems private limited',
    'Microlink solutions private limited',
    'Planvisage software solutions private limited',
    'Cornet technology(india) private limited',
    'Eurotech genset private limited',
    'Reflexions (india) private limited',
    'TRIO ELEVATORS CO (INDIA) PRIVATE LIMITED',
    'NOBLE ELECTRADE PRIVATE LIMITED',
    'Yama technologies private limited',
    'Reliable lifts india private limited',
    'Lot mobiles private limited',
    'Sachin electricals private limited',
    'BHARAT RESINS Private Limited',
    'Awi services (india) private limited',
    'Ohm energy management sys private limited',
    'Modvak engineering india private limited',
    'Psp techno engineers private limited',
    'Systems elmech solutions private limited',
    'Orenda power solutions private limited',
    'Sunrise solar & agro (india) private limited',
    'AMEODEVICE INDIA PRIVATE LIMITED',
    'DAWNSUN KYOSEI ENGINEERING PRIVATE LIMITED',
    'Samsung india electronics private limited',
    'Minda nexgentech limited',
    'Jct automation private limited',
    'Yoctozant technologies india private limited',
    'Baxcell instrument valves and fittings private limited',
    'Moryaas digital private limited',
    'Athiappa electrical and electronics p. ltd',
    'FUJITEC EXPRESS LIMITED',
    'Just connect electricals private limited',
    'Mg electrica private limited',
    'PRESSPART ANDHERI INDIA PRIVATE LIMITED',
    'Nuteck power solutions private limited',
    'Kgp solar projects private limited',
    'Vee dee enterprises private limited',
    'Bth electrics (guj) private limited',
    'Technomech engineering private limited',
    'Cisco systems (india) private limited',
    'Juki india private limited',
    'Joivivre microelectronic private limited',
    'Megatron solutions private limited',
    'Cosmode consultants pvt. ltd.',
    'Deccan power products private limited',
    'Hensel electric india private limited',
    'ACCENT EQUITIES PRIVATE LIMITED',
    'Rubicon microelectronic design centre private limited',
    'Fytronics (india) private limited',
    'Abhyudaya microelectronic design centre private limited',
    'Smd electronics private limited',
    'Orbittal electromech engineering projects private limited',
    'Digital reach private limited',
    'NEW SPICE SALES AND SOLUTIONS LIMITED',
    'Unicom infotel private limited',
    'Spanco infotech private limited',
    'FUN FILMS & MUSIC ENTERTAINMENT PRIVATE LIMITED',
    'EMIL HEALTHCARE PRIVATE LIMITED',
    'Elcom international private limited',
    'Dermacare surgicals private limited',
    'Srinivasa medisales private limited',
    'A-CARE MEDISYSTEM PRIVATE LIMITED',
    'Mesco laboratories limited',
    'Newnik lifecare private limited',
    'Kobold instruments private limited',
    'Comfort insta-power limited',
    'Sharon controls india private limited',
    'Krishnaiah motors pvt ltd',
    'Renault nissan automotive india private limited',
    'SANSERA ENGINEERING LIMITED',
    'India yamaha motor private limited',
    'ASTE ENTERPRISES PRIVATE LIMITED',
    'Bemco india private limited',
    'Paradip multi cargo berth private limited',
    'Coastal shipping links (india) private limited',
    'Five stars shipping company private limited',
    'Trw automotive india private limited',
    'Auto tricks private limited',
    'Naresh engineers ltd',
    'Orient flights private limited',
    'Dimaz aviation private limited',
    'Xlerate driveline india limited',
    'Jamshedpur technocrats private limited',
    'Nexteer automotive india private limited',
    'Syndicate wiper systems private limited',
    'Yamato logistics india private limited',
    'Bay island yacht club private limited',
    'RAMBAL PRIVATE LIMITED',
    'Dania oro jewellery private limited',
    'Idyllic comfortek private limited',
    'Woodware furnitures private limited',
    'Cool diamonds jewellery private limited',
    'Jaya shanmuga projects private limited',
    'Mapco property developers private limited',
    'Scaffold properties private limited',
    'Tanwar estates private limited',
    'Benchmark properties managment private limited',
    'United lifespace private limited',
    'Gurukul builders private limited',
    'Tvish realty private limited',
    'Gatipriya properties private limited',
    'Jollymaker estates private limited',
    'Sakila estates limited',
    'Ras cities and townships private limited',
    'Maheswari townships private limited',
    'VINETON TECHNOLOGIES PRIVATE LIMITED',
    'Shivrathi developers private limited',
    'Shivrathi projects private limited',
    'Shivrathi builders private limited',
    'Experion developers private limited',
    'Experion hospitality (tamil nadu) private limited',
    'Babylon real estate developers private limited',
    'QUICKPAISA FINTECH PRIVATE LIMITED',
    'MIVAAN ENERGY PRIVATE LIMITED',
    'Bhairaav erectors limited',
    'Green earth estate management private limited',
    'Saarrthi landmarks india private limited',
    'Vanguard credit & holdings pvt. ltd.',
    'Goodearth infraprojects private limited',
    'Speedfast infrastructure private limited',
    'Aglow realtech private limited',
    'Ruhil buildtech private limited',
    'AAKASH PROJECTS & INFRASTRUCTURES PRIVATE LIMITED',
    'Ameya technopark developers private limited',
    'Krish real estate private limited',
    'Utl realtors private limited',
    'Stepon surface solutions private limited',
    'Simm samm airways private limited',
    'Riverbed technology india private limited',
    'Xcellhost cloud services private limited',
    'Jaydee electronics private limited',
    'Datacom products (india) private limited',
    'Master channel community network pvt ltd',
    'QUANT SYSTEMS INDIA PVT LTD',
    'EXTRANET SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Sajix software solutions private limited',
    'Eateam solutions private limited',
    'Qlurn it solutions private limited',
    'Comnet innovations private limited',
    'Afilias india private limited',
    'Synergy telematics private limited',
    'Esquvi technologies private limited',
    'Kinzo infosoft private limited',
    'Kinzo it solutions private limited',
    'Rr infomatics private limited',
    'Aster networks private limited',
    'Adiance technologies private limited',
    'Techno infonet gujarat private limited',
    'Maven infosoft private limited',
    'Gujarat synergy private limited',
    'GREENSTACK COMPUTING PRIVATE LIMITED',
    'Staah hotel software private limited',
    'Ekomate systems india private limited',
    'S.l.n technologies private limited',
    'Adarsh solutions private limited',
    'Televital india private limited',
    'INATECH INDIA PRIVATE LIMITED',
    'BLOOMONT SOLUTIONS PRIVATE LIMITED',
    'Lloyds offshore global services private limited',
    'Eterno infotech private limited',
    'Axheleon it services private limited',
    'DYNATRACE INDIA SOFTWARE OPERATIONS PRIVATE LIMITED',
    'Centurion software solutions private limited',
    'Honey bee it solutions private limited',
    'Hyderabad knowledge park private limited',
    'Align biz technologies private limited',
    'Procyon techsolutions private limited',
    'Binarys data source (india) private limited',
    'Mindcom consulting services private limited',
    'Viscad software private limited',
    'Integreatz erp india private limited',
    'Shovel technologies private limited',
    'Flipkart online services private limited',
    'Cr bi consulting india private limited',
    'Fugenx technologies private limited',
    'Jobraiser software private limited',
    'Sagacious infosystems private limited',
    'Online news media private limited',
    'Sphurana technologies private limited',
    'DEMANDNXT BUSINESS SERVICES PRIVATE LIMITED',
    'Right aligned solutions private limited',
    'Activesphere technologies private limited',
    'Sanctum networks private limited',
    'Gvw technologies private limited',
    'Xlsys technologies private limited',
    'Qliktech india private limited',
    'Codecraft technologies private limited',
    'HASHLOG SOLUTIONS PRIVATE LIMITED',
    'Solidrebar engineering services private limited',
    'Parasnath printers private limited',
    'Shree gajanan industries private limited',
    'Aakar innovations private limited',
    'Uge green engineering private limited',
    'Anjani defence systems private limited',
    'Security sector skill development council',
    'Pratham education foundation',
    'Efil educational services private limited',
    'Elements educare private limited',
    'Dhriti edu services private limited',
    'West coast marine sailing school private limited',
    'Knowledge business education private limited',
    'Azim premji foundation for development',
    'Stratadigm education and training private limited',
    'Progressive institutes private limited',
    'CIEL SKILLS AND CAREERS PRIVATE LIMITED',
    'Regent research writing private limited',
    'Strive india education foundation',
    'Unwind learning labs private limited',
    'Greycampus edutech private limited',
    'ICMAI MANAGEMENT ACCOUNTING RESEARCH FOUNDATION',
    'Gem learning services private limited',
    'Marwadi education management services private limited',
    'Marwadi education private limited',
    'Marwadi universal education private limited',
    'Oberon education and emigration consultants private limited',
    'Conde nast (india) private limited',
    'International professional financial careers academy private limited',
    'Consolidated education technologies (india) private limited',
    'Skyfi education labs private limited',
    'Simplilearn solutions private limited',
    'Trident timeshare private limited',
    'Inspire health private limited',
    'Aesthetics medispa private limited',
    'Artharaj eco foundation',
    'Raj charitable foundation',
    'Fusion health care private limited',
    'Pragati ayushman private limited',
    'Virinchi health care private limited',
    'NAYUV WELLNESS & HEALTH PRIVATE LIMITED',
    'Ezee nursing solution private limited',
    'Intervein laboratories private limited',
    'D r healthcare private limited',
    'Marwadi charitable foundation',
    'Asian med horizon private limited',
    'Links medi-tech private limited',
    'INSIGHT TECHNOLOGIES PRIVATE LIMITED ,',
    'Prragathi steel castings private limited',
    'Self growth nidhi limited',
    'International power corporation private limited',
    'Bluechip solutions pplus private limited.',
    'Sparrow technologies limited',
    'Multimedia studio limited',
    'Chemmanur metals and alloys private limited',
    'Thakral one solutions private limited',
    'Millennia realtors private limited',
    'Curo hospitals private limited',
    'Sreedhareeyam ayurvedic eye hospital and research centre private limited',
    'Aditya jyot eye hospital private limited',
    'Tata aig general insurance company limited',
    'Mamata institute of medical sciences',
    'Elixir hospital private limited',
    'Concept medicare (india) private limited',
    'Disha medical services private limited',
    'Vibrant motivation and development foundation',
    'VIRON WELLNESS PRIVATE LIMITED',
    'CELLBIOS HEALTHCARE & LIFESCIENCES PRIVATE LIMITED',
    'Voice foundation',
    'Firsthealth medical solutions private limited',
    'Nandan naturals private limited',
    'Tanna healthcare private limited',
    'Suzynova dental pvt ltd',
    'Grassroots india',
    'Twinkle enviro-tech private limited',
    'Amanora - esf institute for sustainability & management',
    'INDIAN SINGERS',
    'LEAF PRODUCTS PRIVATE LIMITED',
    'QMONIQS SOFTWARE PRIVATE LIMITED',
    'HEMANI CHEMICALS PRIVATE LIMITED',
    'DALHYD TECHNOLOGY PRIVATE LIMITED',
    'DOD PROJECT PRIVATE LIMITED',
    'APPECTUAL TECHNOLOGY AND SERVICES PRIVATE LIMITED',
    'VEIRA ELECTROTECH PRIVATE LIMITED',
    'CUREOUS LABS PRIVATE LIMITED',
    'LETIC VITRIFIED PRIVATE LIMITED',
    'ENNOBLE SOCIAL INNOVATION FOUNDATION',
    'SOLOSTONE TILES PRIVATE LIMITED',
    'ACC STEEL PRIVATE LIMITED',
    'EPROPELLED SYSTEMS PRIVATE LIMITED',
    'NINJACART PRIVATE LIMITED',
    'VERSATILE INDUSTRIES (I) PRIVATE LIMITED',
    'WPI INDIA DEVELOPMENT PRIVATE LIMITED',
    'ADANI SPORTSLINE PRIVATE LIMITED',
    'KAPP NILES INDIA TECHNOLOGIES PRIVATE LIMITED',
    'FIREBIRD ENTERPRENUERIAL VENTURES PRIVATE LIMITED',
    'ORION SUPPLY CHAIN PRIVATE LIMITED',
    'TRAVELSUKHA PRIVATE LIMITED',
    'OUTLEAP TECHNOLOGIES PRIVATE LIMITED',
    'RAJ RAJENDRA HOME APPLIANCES PRIVATE LIMITED',
    'CHIROPRACTIC ZHEALTHEHR INDIA PRIVATE LIMITED',
    'ELMACK ENGG SERVICES PRIVATE LIMITED',
    'SOCIABBLE INDIA PRIVATE LIMITED',
    'TURMERIC CAPITAL MUMBAI ADVISORY SERVICES PRIVATE LIMITED',
    'U-TURN LIFESTYLE PRIVATE LIMITED',
    'BGA ELECTRICAL & SERVICES PRIVATE LIMITED',
    'PRES OORJA PRIVATE LIMITED',
    'JUST ENERGY INDIA PRIVATE LIMITED',
    'CHARGEXO LITHIUM TECHNOLOGY PRIVATE LIMITED',
    'EXCELRINNOVATIVE EDUSPACE PRIVATE LIMITED',
    'AUDITECH INNOVATIONS PRIVATE LIMITED',
    'PIXELUS DIGITAL PRIVATE LIMITED',
    'IGM SURFACES PRIVATE LIMITED',
    'DR. EDWIN MEDILABS PRIVATE LIMITED',
    'RAYIOT SOLUTIONS PRIVATE LIMITED',
    'KVR AUTOMOTIVE PRIVATE LIMITED',
    'SOURCEIFY TRADING PRIVATE LIMITED',
    'FUTOPS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RICCO DELIZIO PRIVATE LIMITED',
    'ULTRAMARINE SPECIALTY CHEMICALS LIMITED',
    'SUPERIOR BIOFUELS PRIVATE LIMITED',
    'FAVORZ SERVICES INDIA PRIVATE LIMITED',
    'KOCHASOFT INDIA PRIVATE LIMITED',
    'VEECAP INFRA SERVICES (OPC) PRIVATE LIMITED',
    'ANVESHA TECH LAB PRIVATE LIMITED',
    'THREE THIRTY FIFTH INDUSTRIES PRIVATE LIMITED',
    'MLG POLYPLAST PRIVATE LIMITED',
    'FASHION WIZARD PRIVATE LIMITED',
    'PANCHSHIL TRADE AND TECHPARK PRIVATE LIMITED',
    'ZYF TEX PRIVATE LIMITED',
    'KILLIMANJARO COMMODITIES (INDIA) PRIVATELIMITED',
    'CETUSTECH SOLUTIONS PRIVATE LIMITED',
    'ETHIQS CAPITAL SERVICES PRIVATE LIMITED',
    'HERBAL RANCH PRIVATE LIMITED',
    'INSIGHT MODULARS PRIVATE LIMITED',
    'MAGNETECH ELEVATORS PRIVATE LIMITED',
    'AMIDE BY AD (OPC) PRIVATE LIMITED',
    'SEYAL TECHNOLOGIES PRIVATE LIMITED',
    'LOG ON LOGISTICS INDIA PRIVATE LIMITED',
    'FOHOWAY INDIA PRIVATE LIMITED',
    'SHREEJI PROCESS CONTROL PRIVATE LIMITED',
    'GOLDEN BAG TECHNOLOGY PRIVATE LIMITED',
    'TECHRYT CONSULTING PRIVATE LIMITED',
    'GOLDEN CHERI FOODS PRIVATE LIMITED',
    'DOTERRA INDIA PRIVATE LIMITED',
    'ADITYA PRECISION ENGINEERING PRIVATE LIMITED',
    'GERALD TECHNOLOGIES PRIVATE LIMITED',
    'IGNATIVELABS (OPC) PRIVATE LIMITED',
    'OJASTOAURA LIFE SCIENCE PRIVATE LIMITED',
    'AUGMENTO LABS PRIVATE LIMITED',
    'SGP HEALTHCARE PRIVATE LIMITED',
    'SPACE CLOUD INFOTECH (OPC) PRIVATE LIMITED',
    'COOPERWIND INDIA PRIVATE LIMITED',
    'CHRONOS IMAGING INDIA PRIVATE LIMITED',
    'QUICKOM INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'KSM SOFTECH PRIVATE LIMITED',
    'RADIANT SHADOWS HOSPITALITY PRIVATE LIMITED',
    'NUCREST PHARMA PRIVATE LIMITED',
    'KEMPA PROPERTIES PRIVATE LIMITED',
    'HEALTHY SAGA PRIVATE LIMITED',
    'TNV ESSENTIALS INDIA PRIVATE LIMITED',
    'FSN INTERNATIONAL PRIVATE LIMITED',
    'KGK JEWELLERY MANUFACTURING PRIVATE LIMITED',
    'SANDERSON SOLUTIONS INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'RELIANCE ANIMATION STUDIOS PRIVATE LIMITED',
    'COMFYCARE PRODUCTS PRIVATE LIMITED',
    'BAYESTREE INDIA PRIVATE LIMITED',
    'ABSOLUTE AROMAS INDIA PRIVATE LIMITED',
    'SNJ LIFECARE PRIVATE LIMITED',
    'QUAADBOTICS PRIVATE LIMITED',
    'EMKAY POLYMERS PRIVATE LIMITED',
    'ONETAXFILER SERVICES PRIVATE LIMITED',
    'RACING DAYS PRIVATE LIMITED',
    'TANJAMI OVERSEAS PRIVATE LIMITED',
    'TRIMTAB STAFFING SERVICES GLOBAL PRIVATELIMITED',
    'CAREER TAKE-OFF SKILLS GALAXY FOUNDATION',
    'VOYAGE OF WELLNESS PRIVATE LIMITED',
    'RENEW VYOMAN ENERGY PRIVATE LIMITED',
    'MEB PHARMA PRIVATE LIMITED',
    'SABAF INDIA PRIVATE LIMITED',
    'PLAEUP PRIVATE LIMITED',
    'BIRIYANI BOX INDIA PRIVATE LIMITED',
    'SOUR APPLE ASSET MANAGEMENT PRIVATE LIMITED',
    'AARANYA MACHINERY PRIVATE LIMITED',
    'VENTILAIR ENGINEERS PRIVATE LIMITED',
    'VSN SOLARONE INDIA PRIVATE LIMITED',
    'AYURMEGHA HEALTHCARE PRIVATE LIMITED',
    'SONA STAR INNOVATION PRIVATE LIMITED',
    'CLEANEDGE WATER INDIA PRIVATE LIMITED',
    'NEVAKAR INDIA PRIVATE LIMITED',
    'EPNOVATE TECHNOLOGY PRIVATE LIMITED',
    'GREENRAY GRANITO PRIVATE LIMITED',
    'WELLKIN INSTA SOLUTIONS PRIVATE LIMITED',
    'UTOPIAN TROOP FOUNDATION',
    'NOVEL HEALTHTECH SOLUTIONS PRIVATE LIMITED',
    'MODERN SAPPHIRE CONSTRUCTION PRIVATE LIMITED',
    'FAMA TECHNOLOGIES PRIVATE LIMITED',
    'CHAUDHARY VIRENDRA SINGH SAARTHI FOUNDATION',
    'VALSYS STEEL INDIA PRIVATE LIMITED',
    'SUSWANI JEWELLERS PRIVATE LIMITED',
    'REFRAHOLD INDUSTRIES PRIVATE LIMITED',
    'GETSERV TECHNOLOGIES PRIVATE LIMITED',
    'VEDAS TECHNOCRATS PRIVATE LIMITED',
    'KULSYS TECHNOLOGIES PRIVATE LIMITED',
    'TCT THE CONTENT TEAM PRIVATE LIMITED',
    'HAPPYCHASES MEDIA WORKS (OPC) PRIVATE LIMITED',
    'MACROS FASTENING SYSTEMS PRIVATE LIMITED',
    'BLUEEARTH HOSPITALITY PRIVATE LIMITED',
    'REDKENKO HEALTH TECH PRIVATE LIMITED',
    'BOTSON LABS PRIVATE LIMITED',
    'CVAP INTERNATIONAL PRIVATE LIMITED',
    'LI SOFTWARE PRIVATE LIMITED',
    'AISHWARYA OVERSEAS INDIA PRIVATE LIMITED',
    'SYSTEMATICWIRES PRIVATE LIMITED',
    'LIBERTY TECH IT SOLUTIONZ PRIVATE LIMITED',
    'KFIN SERVICES PRIVATE LIMITED',
    'CULTUREMONKEY PRIVATE LIMITED',
    'URBANKISAAN FARMS PRIVATE LIMITED',
    'ANHA CONCIERGE PRIVATE LIMITED',
    'DIGINEOUS TECHNOLOGIES PRIVATE LIMITED',
    'AMEO MEDIA PRIVATE LIMITED',
    'SEHGREE INDUSTRIES PRIVATE LIMITED',
    'AYAAN APPARELS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING TWELVE LIMITED',
    'LAND STRATZ PRIVATE LIMITED',
    'TECHNORAIL INNOVATIONS PRIVATE LIMITED',
    'BASEL DYNAMICS TECH SOLUTIONS PRIVATE LIMITED',
    'JSM FOREX PRIVATE LIMITED',
    'DELORA JONES COSMETICS (OPC) PRIVATE LIMITED',
    'EP VENTURES PRIVATE LIMITED',
    'CREDFINE DIGITAL INDIA PRIVATE LIMITED',
    'TIL SKABE (INDIA) PRIVATE LIMITED',
    'QA BANGALORE PRIVATE LIMITED',
    'GREEN CITY SOLAR INDIA PRIVATE LIMITED',
    'SAI INDENT SHIPPING AGENCY PRIVATE LIMITED',
    'NEXO GLOBAL BIOCIDE AND TECHNOLOGIES PRIVATE LIMITED',
    'CHETTIPPATTU FOODS PRIVATE LIMITED',
    'IKARIA WELLNESS PRIVATE LIMITED',
    'JICON TECHNOLOGIES PRIVATE LIMITED',
    'BAKELITE ENGINEERING PRIVATE LIMITED',
    'TRU DESIGNS PLANNERS PRIVATE LIMITED',
    'GEOLOGICAL INSTITUTE INDIA PRIVATE LIMITED',
    'VINTAGE WORLD HOLIDAYS PRIVATE LIMITED',
    'KLAR CARE SERVICES PRIVATE LIMITED',
    'PAFLOG SUPPLY CHAIN SERVICES PRIVATE LIMITED',
    'SAMENA INFRA SOLUTIONS PRIVATE LIMITED',
    'SWAROOP STEEL TUBE INDIA PRIVATE LIMITED',
    'ADANI HYBRID ENERGY JAISALMER FIVE LIMITED',
    'CREDENCE FAMILY OFFICE PRIVATE LIMITED',
    'YANNI GLOBAL (OPC) PRIVATE LIMITED',
    'SAPLING GLOBAL ASSURANCE PRIVATE LIMITED',
    'TOP CRANE SYSTEM PRIVATE LIMITED',
    'ST HANDICRAFTS PRIVATE LIMITED',
    'YCS TECHSOFT PRIVATE LIMITED',
    'HJORT KNUDSEN INDIA PRIVATE LIMITED',
    'ITBRIDGE CONSULTANTS PRIVATE LIMITED',
    'H&M SERVICES PRIVATE LIMITED',
    'RXOS HEALTHCARE PRIVATE LIMITED',
    'TWOWALLS DESIGN SERVICES PRIVATE LIMITED',
    'NJC LABS CONSULTING AND SERVICES PRIVATELIMITED',
    'LIBERTY STEEL SERVICES INDIA PRIVATE LIMITED',
    'REDWERT ENGINEERING LABS PRIVATE LIMITED',
    'SAGE ORGANICS PRIVATE LIMITED',
    'QUALIS APPARELS PRIVATE LIMITED',
    'DIGIMONEY FINANCE PRIVATE LIMITED',
    'MYMATSYA OIL PRIVATE LIMITED',
    'SAHRUDAYA HEALTH CARE (SRIKAKULAM) PRIVATE LIMITED',
    'MANTRA KINGDOM PRIVATE LIMITED',
    'MAD OVER KALAKARI PRIVATE LIMITED',
    'GLOSTER NUVO LIMITED',
    'OXALE INFOTECH PRIVATE LIMITED',
    'MIEUX TECHNOLOGIES PRIVATE LIMITED',
    'ONCOMINE INDIA PRIVATE LIMITED',
    'VAYUSUTA LOGISTIC PRIVATE LIMITED',
    'RKSK GARMENTS PRIVATE LIMITED',
    'SRII PRITHA PRIVATE LIMITED',
    'DR. MANN LIFESCIENCES PRIVATE LIMITED',
    'VIGNESH INTERNATIONAL INGENIEUR DIENSTLEISTUNG PRIVATE LIMITED',
    'SAMKHYA TECHNOLOGIES PRIVATE LIMITED',
    'GODI INDIA PRIVATE LIMITED',
    'CIBES LIFT INDIA PRIVATE LIMITED',
    'CREATION HOME DECOR AND FURNISHING PRIVATE LIMITED',
    'MARLENSOFT PRIVATE LIMITED',
    'GATS ENERGY PRIVATE LIMITED',
    'CARTIZON DIGITAL PRIVATE LIMITED',
    'FAPLA PRIVATE LIMITED',
    'MUFG GLOBAL SERVICE PRIVATE LIMITED',
    'NESTACK TECHNOLOGIES PRIVATE LIMITED',
    'MACHINTEL MEDIA PRIVATE LIMITED',
    'MANO AMICA CORPORATE PRIVATE LIMITED',
    'WOXWAX SOLUTIONS PRIVATE LIMITED',
    'CITRUS GLOBAL RESOURCES LIMITED',
    'BIG MINDZ BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KP WATER TREATMENT PRIVATE LIMITED',
    'NORTH LOOP PRIVATE LIMITED',
    'SORTING TAX ADVISORY SERVICES PRIVATE LIMITED',
    'SYNTAXIVE TECHNOLOGIES PRIVATE LIMITED',
    'INNOVATE TAX PRIVATE LIMITED',
    'ATUL GREENTECH PRIVATE LIMITED',
    'AAPOON DIGITAL PRIVATE LIMITED',
    'CARAFIT INDIA PRIVATE LIMITED',
    'TRUSTCHEM PIGMENTS PRIVATE LIMITED',
    'VITAEGISS WELLNESS PRIVATE LIMITED',
    'CAERUS GLOBAL INDUSTRIES PRIVATE LIMITED',
    'DAEWOOST INDIA PRIVATE LIMITED',
    'ATLANTA CROP PRIVATE LIMITED',
    'QUADROBAY TECHNOLOGIES PRIVATE LIMITED',
    'SIMPLE STEPS FITNESS PRIVATE LIMITED',
    'SECURE RPO PRIVATE LIMITED',
    'HUDDL CREATIVE PRIVATE LIMITED',
    'INNAVOTO INDIA PRIVATE LIMITED',
    'VIPUN COGNITIVE SOLUTIONS PRIVATE LIMITED',
    'ADANCO INDUSTRIES PRIVATE LIMITED',
    'DHOOT ELECTRICALS SYSTEMS PRIVATE LIMITED',
    'SMUK (OPC) PRIVATE LIMITED',
    'GROWTHLYTICS ENERGY CONSULTING (INDIA) PRIVATE LIMITED',
    'RPA INFOTECH INDIA PRIVATE LIMITED',
    'NEXTWHAT AUTOMATION INDIA PRIVATE LIMITED',
    'MORAE SERVICES INDIA PRIVATE LIMITED',
    'DEL SYSTEMS & CONTROLS PRIVATE LIMITED',
    'NARMADA GLOBAL WELLNESS PRIVATE LIMITED',
    'SUMEET URBAN SERVICES (CHENNAI) V PRIVATE LIMITED',
    'PRORICH AGRO PRIVATE LIMITED',
    'INNOVATIVE MARKETING MANAGEMENT PRIVATE LIMITED',
    'MELLIFLUOUS MOTION PICTURES PRIVATE LIMITED',
    'MDSI OVERSEAS PRIVATE LIMITED',
    'KRITRIMAMEDHA SOLUTIONS PRIVATE LIMITED',
    'PHOENIX SEZ DEVELOPERS PRIVATE LIMITED',
    'TECHMANTRA NOW INDIA PRIVATE LIMITED',
    'MGUDA TECHNOLOGIES PRIVATE LIMITED',
    'TARANJOT ENERGY SOLUTIONS PRIVATE LIMITED',
    'CLEARLAKE PRIVATE LIMITED',
    'IATOCS PRIVATE LIMITED',
    'ATROADS TECHNOLOGIES PRIVATE LIMITED',
    'PROSIFT ENTERPRISES PRIVATE LIMITED',
    'GREENPRO VENTURES PRIVATE LIMITED',
    'GSTACK TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'CANDELA ENERGY PRIVATE LIMITED',
    'BIPROZ SOLUTIONS PRIVATE LIMITED',
    'PRACHAY HOLDING PRIVATE LIMITED',
    'RUDRALCO EXTRUSION LIMITED',
    'SHUBHAM TESTING AND CALIBRATION SERVICES PRIVATE LIMITED',
    'CALIBRAINT TECHNOLOGIES PRIVATE LIMITED',
    'OXTRO EXPO MANAGEMENT PRIVATE LIMITED',
    'DIMIOUR INDIA PRIVATE LIMITED',
    'FROG SERVICES PRIVATE LIMITED',
    'WHITESPACE CONSULTANCY PRIVATE LIMITED',
    'PUNE GAS SYSTEMS PRIVATE LIMITED',
    'DWARIKA CAPITAL PRIVATE LIMITED',
    'BRYMAX GLOBAL PRIVATE LIMITED',
    'ONLIVE SERVER PRIVATE LIMITED',
    '7INK BREWS PRIVATE LIMITED',
    'ECLEC DEVELOPMENT ORIENTATION AND RESEARCH PRIVATE LIMITED',
    'INSTITUTE OF MANAGEMENT ACCOUNTANTS INDIA PRIVATE LIMITED',
    'SARASWATIDEVI RAMCHANDRA MITTAL FOUNDATION',
    'OCEANGROWTH INTERNET PRIVATE LIMITED',
    'IMBA GLOBAL EDUCATION PRIVATE LIMITED',
    'RIGHTDATA LABS PRIVATE LIMITED',
    'RADIANCE INTERNATIONAL PRIVATE LIMITED',
    'AUCTOMATE TECHNOLOGIES PRIVATE LIMITED',
    'FENSTER HOLZ INDUSTRIES PRIVATE LIMITED',
    'ANALYTICS INTELL PRIVATE LIMITED',
    'VIRAJRAMAGYA BIO CHEMICAL PRIVATE LIMITED',
    'ILIE DEVELOPERS PRIVATE LIMITED',
    'PUROBIEN NUTRITION PRIVATE LIMITED',
    'QUBIT AI TECHNOLOGIES PRIVATE LIMITED',
    'TECHZOBRIS PRIVATE LIMITED',
    'FORTUNA INDUSTRIES PRIVATE LIMITED',
    'WHITE-MAPPING GLOBAL PRIVATE LIMITED',
    'DATASCAPE REALTY PRIVATE LIMITED',
    'ZENVIRO SERVICES PRIVATE LIMITED',
    'NNF NIDHI LIMITED',
    'GANGA GLOBAL HOMES PRIVATE LIMITED',
    'LN LABORATORIES PRIVATE LIMITED',
    'INCOMMON WORKS PRIVATE LIMITED',
    'MALBI INTERNATIONAL PRIVATE LIMITED',
    'ZOOM TRAVELLING PRIVATE LIMITED',
    'CIRCUIT CARE INDIA PRIVATE LIMITED',
    'VEERA HEALTHCARE PRIVATE LIMITED',
    'SCANOTREK PRIVATE LIMITED',
    'BLUEBASIC AMA ENGINEERING PRIVATE LIMITED',
    'BIOPAPRO CUTLERIES PRIVATE LIMITED',
    'SMARTBEX TECHNOLOGIES PRIVATE LIMITED',
    'GLOBOFARM INTERNATIONAL PRIVATE LIMITED',
    'QUALITY EMPHASIS STEEL SOLUTIONS PRIVATELIMITED',
    'GIGGSO INDIA PRIVATE LIMITED',
    'ESP INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED',
    'SKILL IT UP INDIA PRIVATE LIMITED',
    'CONIFEROUS MULTITRADE PRIVATE LIMITED',
    'TREEQ POWER ELECTROMECHANICAL PRIVATE LIMITED',
    'SERI PRINTS PRIVATE LIMITED',
    'STUDIO ETHENO LIFESTYLE AND TECHNOLOGY PRIVATE LIMITED',
    'MEDON HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'ALEYO COMMUNICATIONS PRIVATE LIMITED',
    'SAI ISWARYA FOREX PRIVATE LIMITED',
    'COUNSELINDIA SERVICES PRIVATE LIMITED',
    'TWIM INDIA PRIVATE LIMITED',
    'PRKAY CONSTRUCTION PRIVATE LIMITED',
    'CUPERTINO LABORATORIES PRIVATE LIMITED',
    'ANEETA PACKAGING PRIVATE LIMITED',
    'CYGNET ACCOUNT AGGREGATION PRIVATE LIMITED',
    'MAC COMPOUNDS PRIVATE LIMITED',
    'CRAFTINK PRIVATE LIMITED',
    'EVEY TRANS (UJJ) PRIVATE LIMITED',
    'BBW GLOBAL TEK PRIVATE LIMITED',
    'SHREE VIJAY VALLABH CREATIONS PRIVATE LIMITED',
    'POLWELL REAL ESTATES PRIVATE LIMITED',
    'DEXNINJA PRIVATE LIMITED',
    'SUDLOWS INDIA PRIVATE LIMITED',
    'FLY JUPITER PRIVATE LIMITED',
    'AMICORN RETAIL PRIVATE LIMITED',
    'I-MEDITA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'JEWELEN PRIVATE LIMITED',
    'VARANK TECH PRIVATE LIMITED',
    'SUPERTYRE TEC PRIVATE LIMITED',
    'KRAAFTED LUXURY EVENTS AND EXPERIENCES PRIVATE LIMITED',
    'SHAKTIOLEVIN GRANULES PRIVATE LIMITED',
    'AYAVAZHI TECHNOLOGIES PRIVATE LIMITED',
    'SCILIFE PRIVATE LIMITED',
    'MIRZA INVESTMENT PRIVATE LIMITED',
    'HARVEST ABROAD STUDIES PRIVATE LIMITED',
    'FLIXBUS INDIA PRIVATE LIMITED',
    'LEAD FLAKE PRIVATE LIMITED',
    'STUPA SPORTS ANALYTICS PRIVATE LIMITED',
    'PINAAFAL PRIVATE LIMITED',
    'BASILMINTS OVERSEAS PRIVATE LIMITED',
    'SK BIOBIZ AGRO PRIVATE LIMITED',
    'SAHAJ ABHILASHA INDUSTRIES PRIVATE LIMITED',
    'INTELLIGENT AND DEVELOPED PRODUCTS PRIVATE LIMITED',
    'VINARCH BUSINESS CONSULTING PRIVATE LIMITED',
    'PAYNETWORK TECHNOLOGIES PRIVATE LIMITED',
    'THINKERPLACE PRIVATE LIMITED',
    'THINK SMART INVESTMENTS PRIVATE LIMITED',
    'ELECSOFT-SYSTEMS (OPC) PRIVATE LIMITED',
    'CITY FOOTBALL INDIA PRIVATE LIMITED',
    'TERRA PHARMA PRIVATE LIMITED',
    'AM ASSOCIATES INDIA PRIVATE LIMITED',
    'PAUL AUTOMOTIVE PRIVATE LIMITED',
    'IDEALPRIME VENTURES PRIVATE LIMITED',
    'LOUIS & CLOUDS INDIA PRIVATE LIMITED',
    'VIDEOMAX INTERNATIONAL PRIVATE LIMITED',
    'ELDER DRUGS & PHARMACEUTICAL PRIVATE LIMITED',
    'NOSEBERRY PRIVATE LIMITED',
    'SPOCTO SOLUTIONS PRIVATE LIMITED',
    'VISO ENGINEERING & CONSTRUCTIONS PRIVATELIMITED',
    'RB AERO DEVELOPMENT SERVICES INDIA PRIVATE LIMITED',
    'UMAEXPO PRIVATE LIMITED',
    'CLOUD SERVER PRIVATE LIMITED',
    'GATEB SERVICES PRIVATE LIMITED',
    'NORTHWEST TITLE PLANET PRIVATE LIMITED',
    'BALAJI ENZYME & CHEMICAL PRIVATE LIMITED',
    'SHEARES INDIA HEALTHCARE MANAGEMENT PRIVATE LIMITED',
    'PARINIDHI INFRASTRUCTURE PRIVATE LIMITED',
    'SOLAFT FILTRATION SOLUTIONS INDIA PRIVATE LIMITED',
    'TAXLEAD BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CHENNAI PRECISION PLUS INDIA PRIVATE LIMITED',
    'DINKUM DATA SOLUTIONS PRIVATE LIMITED',
    'ASCENT SIGMAX SPORTSMEDS PRIVATE LIMITED',
    'PERPIXL RENDERING TECHNOLOGIES PRIVATE LIMITED',
    'APG ENVIRONMENT HOMES PRIVATE LIMITED',
    'R.D. HOSIERY PRIVATE LIMITED',
    'SARVONNATI FARMER PRODUCER COMPANY LIMITED',
    'SUNTEK AXPRESS INDIA PRIVATE LIMITED',
    'APPAREL EVRYWEAR PRIVATE LIMITED',
    'TUF-M SOLUTIONS PRIVATE LIMITED',
    'CRYSTAL COLOURCHEM PRIVATE LIMITED',
    'MEDTHERAPY BIOTECHNOLOGY (INDIA) PRIVATELIMITED',
    'INANDK DESIGN PRIVATE LIMITED',
    'CYARA OPERATIONS INDIA PRIVATE LIMITED',
    'GREEN INFRA RENEWABLE PROJECTS LIMITED',
    'VIVERE IMAGING PRIVATE LIMITED',
    'LINGAASYS TECHNOLOGY PRIVATE LIMITED',
    'KOLLI HILLS HERBS AND SPICES PRIVATE LIMITED',
    'CODEWITS SOLUTIONS PRIVATE LIMITED',
    'PALANTUS INFRATECH PRIVATE LIMITED',
    'OC TECHNOLOGIES PRIVATE LIMITED',
    'AMPARO TECHNOLOGY PRIVATE LIMITED',
    'MEBOT (OPC) PRIVATE LIMITED',
    'ORDINAREE TRIBE PRIVATE LIMITED',
    'GENEFIT NUTRITION CLINIC PRIVATE LIMITED',
    'GENINS CLAIMS ADVISORY PRIVATE LIMITED',
    'INDUS NATURES HUB PRIVATE LIMITED',
    'GREENWIRE EARTHING SOLUTIONS PRIVATE LIMITED',
    'IPF CREDITEASE PRIVATE LIMITED',
    'WK-SYSTEMS INDIA PRIVATE LIMITED',
    'DHANVANYA NIDHI LIMITED',
    'BIOGENIX SYSTEMS PRIVATE LIMITED',
    'LORD INDUSTRIALS PRIVATE LIMITED',
    'MOLAB PRIVATE LIMITED',
    'MALHAR SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'AT THE WORLD E- EDUCATION & SCHOLARSHIP AWARDS (OPC) PRIVATE LIMITED',
    'PRIME GRAPHITE PRIVATE LIMITED',
    'CANDORE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'AMPRI HYDRAULICS & PNEUMATICS PRIVATE LIMITED',
    'PANASA TECHNOLOGY PRIVATE LIMITED',
    'PROACTIVE SHIP SUPPLY PRIVATE LIMITED',
    'RAKSH BIO SCIENCE PRIVATE LIMITED',
    'DKP POLYMERS PRIVATE LIMITED',
    'ADS AND FUNNEL PRIVATE LIMITED',
    'BKJ ENTERPRISES (OPC) PRIVATE LIMITED',
    'NADA SOUND AND VIBRATION TECHNOLOGY INDIA PRIVATE LIMITED',
    'PAGE-3 MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'NATCHARAM SOLUTIONS PRIVATE LIMITED',
    'REDFOX GLOBAL IT SERVICES PRIVATE LIMITED',
    'OPENWINGS WELLNESS PRIVATE LIMITED',
    'DATALLIGENCE-AI PRIVATE LIMITED',
    'FESTIVOGUE PRIVATE LIMITED',
    'PLURIMO PULTRUSION AND COMPOSITE PRIVATELIMITED',
    'VRATA TECH SOLUTIONS PRIVATE LIMITED',
    'SATHYA MOBILES INDIA PRIVATE LIMITED',
    'TRULY FRESH FOODS PRIVATE LIMITED',
    'ADZMEDIA MOBILE ADS PRIVATE LIMITED',
    'SINCERE ACADEMIC FOUNDATION',
    'REPLAST EPR PRIVATE LIMITED',
    'ACCORD GLOBAL ADR PRIVATE LIMITED',
    'VVLS ENTERPRISE PRIVATE LIMITED',
    'GREENKO KA01 IREP PRIVATE LIMITED',
    'KANKARIA PRECAST PRIVATE LIMITED',
    '23BMI LIFE SCIENCES PRIVATE LIMITED',
    'DAXARCH SOLUTIONS PRIVATE LIMITED',
    'TORQBOLT PRIVATE LIMITED',
    'ALPHA WINGS TECH SOLUTIONS PRIVATE LIMITED',
    'VIRTUA STUDIOS PRIVATE LIMITED',
    'INSTAMOBILIZE SERVICES PRIVATE LIMITED',
    'GOLDPLUS NIDHI LIMITED',
    'CLOUDY FOODCOURT PRIVATE LIMITED',
    'DOT & KEY WELLNESS PRIVATE LIMITED',
    'PROMPT INNOVATIONS PRIVATE LIMITED',
    'GIDC EPSEZ GANDHINAGAR ASSOCIATION',
    'ENJOY WISHLIST INDIA PRIVATE LIMITED',
    'RUMMYTIME TECHNOLOGIES PRIVATE LIMITED',
    'TUCANA PHARMA PRIVATE LIMITED',
    'PHOENIX STEEL MILL SERVICES (INDIA) PRIVATE LIMITED',
    'HAQQANI PRIVATE LIMITED',
    'FOODFOX TECHNOLOGIES PRIVATE LIMITED',
    'SUMMERSALT LIFESTYLE PRIVATE LIMITED',
    'ELECTA ENERGY PRIVATE LIMITED',
    'CARRIERA CONSULTING PRIVATE LIMITED',
    'SAGO INDUSTRIES PRIVATE LIMITED',
    'DB MANUFACTURERS AND PROCESSORS PRIVATE LIMITED',
    'SHRISTI YATAYAT TOURS AND TRAVELS PRIVATE LIMITED',
    'MANDI HOUSE PRIVATE LIMITED',
    'CHRIS AND HARRIS GLOBAL LIMITED',
    'STAFFCLOUD SERVICES PRIVATE LIMITED',
    'INNOVAC CERAMIC PRIVATE LIMITED',
    'SAMPLRR MARKETING PRIVATE LIMITED',
    'NOW.GG PUBLISHING PRIVATE LIMITED',
    'APPZOID TECHNOLOGIES PRIVATE LIMITED',
    'RIVERSYS TECHNOLOGIES PRIVATE LIMITED',
    'MATRI SEVA HEALTHCARE PRIVATE LIMITED',
    'DIAGNO CARE INDIA PRIVATE LIMITED',
    'ONEMEDIA NETWORK LIMITED',
    'RPC EXPORTS PRIVATE LIMITED',
    'PYZO SPORTSTECH PRIVATE LIMITED',
    'ISKA INFRAS PRIVATE LIMITED',
    'BENATTON PHARMACEUTICAL PRIVATE LIMITED',
    'FUTURZ TRAVELS AND LOGISTICS PRIVATE LIMITED',
    'MAKOWDA WORLDWIDE PRIVATE LIMITED',
    'TALENT SPIDER MANPOWER SOLUTIONS PRIVATELIMITED',
    'ULARI TECHNOLOGY PRIVATE LIMITED',
    'FREESTYLE SHIPPING PRIVATE LIMITED',
    'AIOI.SYSTEMS INDIA PRIVATE LIMITED',
    'JSRAM TECHNOLOGIES PRIVATE LIMITED',
    'ADS.RESONATE INDIA PRIVATE LIMITED',
    'UNIGLOW HEALTH CARE PRIVATE LIMITED',
    'MGI CAPITAL (INDIA) PRIVATE LIMITED',
    'FLY2LEARN PRIVATE LIMITED',
    'NAMASTE LOANS PRIVATE LIMITED',
    'CAFFEINE BAAR PRIVATE LIMITED',
    'VEERISE INFOMATIC PRIVATE LIMITED',
    'GANDHAVADI FINANCIAL SERVICES PRIVATE LIMITED',
    'EASTGATE EXPORT PRIVATE LIMITED',
    'JIVRAJ TEA INTERNATIONAL PRIVATE LIMITED',
    'FOXLINK INDIA ELECTRIC PRIVATE LIMITED',
    'PRIME PROGRESSION GLOBAL COMMERCE PRIVATE LIMITED',
    'OPEN WEAVER INDIA PRIVATE LIMITED',
    'RANKRAZE TECHNOLOGIES PRIVATE LIMITED',
    'MUZK SOLUTIONS PRIVATE LIMITED',
    'INTELLO TECH AMC PRIVATE LIMITED',
    'ABRECO FREIGHT PRIVATE LIMITED',
    'EPICTUS SOLUTIONS INDIA PRIVATE LIMITED',
    'ONLINE PSB ACCOUNT AGGREGATOR PRIVATE LIMITED',
    'INNAVX TECHNOLOGIES PRIVATE LIMITED',
    'ULTRA GAS & ENERGY LIMITED',
    'INTERNET KITCHENS (OPC) PRIVATE LIMITED',
    'AT QUEST SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'KIRA ESPORTS INDIA PRIVATE LIMITED',
    'RC ASSOCIATES PRIVATE LIMITED',
    'WORLD GOODS MARKET LIMITED',
    'ECO LIFE PROJECTS PRIVATE LIMITED',
    'ZHOU HUANG INDIA PRIVATE LIMITED',
    'PREVENTTA OPTIME PRIVATE LIMITED',
    'ARCKEN SOLUTIONS (OPC) PRIVATE LIMITED',
    'LUCKDEEP INDUSTRIES PRIVATE LIMITED',
    'SILECTRO ENTERPRISE PRIVATE LIMITED',
    'SHIVYAAN LEARNING SOLUTIONS PRIVATE LIMITED',
    'ACUTEN GLOBAL PRIVATE LIMITED',
    'DR SCALE HEALTHCARE AND MEDICAL DEVICES PRIVATE LIMITED',
    'INDOPLUS PRIVATE LIMITED',
    'PROWESSCA TECHNOLOGY SOLUTIONS (OPC) PRIVATE LIMITED',
    'MEDTRAIL LABS PRIVATE LIMITED',
    'CURASIGNA SYSTEMS PRIVATE LIMITED',
    'PLATFARM INDIA PRIVATE LIMITED',
    'BONG EATS PRIVATE LIMITED',
    'MEETAIDE TECHNOLOGIES PRIVATE LIMITED',
    'J.M.SMITH INTERNATIONAL INDIA PRIVATE LIMITED',
    'KENVERSE PRIVATE LIMITED',
    'ADITHYA SAFE DEPOSIT LOCKERS PRIVATE LIMITED',
    'BLUEKEI SOLUTIONS PRIVATE LIMITED',
    'AMPLIFY LIFE INDIA PRIVATE LIMITED',
    'SONY RESEARCH INDIA PRIVATE LIMITED',
    'TOPLINE INDUSTRIES PRIVATE LIMITED',
    'ARTHPROJECT RETAIL PRIVATE LIMITED',
    'UACI SEEDS & BIOTECH PRIVATE LIMITED',
    'DVMART ESHOP (OPC) PRIVATE LIMITED',
    'GHAZIABAD WATER SOLUTIONS PRIVATE LIMITED',
    'YELLOW BIRDS RETAIL PRIVATE LIMITED',
    'VIRTUAL CEO ADVISORY PRIVATE LIMITED',
    'KOBLERR ENTERPRISES PRIVATE LIMITED',
    'H.G. REWARI BYPASS PRIVATE LIMITED',
    'REGENT STANDARD PRIVATE LIMITED',
    'STUPIFY LABS PRIVATE LIMITED',
    'STONEHILL CESY FOUNDATION',
    'KAILANI FOODS PRIVATE LIMITED',
    'WINDIGO FOOD PROCESSING PRIVATE LIMITED',
    'MONETIZER ADVISORY PRIVATE LIMITED',
    'COROFY CREATIVES PRIVATE LIMITED',
    'DANTARE FOODS PRIVATE LIMITED',
    'ASHA SOHI MEMORIAL FOUNDATION',
    'WISHPOND INNOVATIONS PRIVATE LIMITED',
    'KONNEXIONS DIGITAL PRIVATE LIMITED',
    'NATURAL LIFESTYLE PRODUCTS PRIVATE LIMITED',
    'REDAPTIVE SERVICES PRIVATE LIMITED',
    'WK POWER PROJECTS INDIA PRIVATE LIMITED',
    'TURANTH SURAKSHA INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'DELHIVERY FREIGHT SERVICES PRIVATE LIMITED',
    'CLASSIC INDIA INFO SOLUTIONS PRIVATE LIMITED',
    'PRATYANCHA MANAGEMENT SERVICES PRIVATE LIMITED',
    'PACIDERMA PRIVATE LIMITED',
    'SO HUM BHARAT DIGITAL PAYMENTS PRIVATE LIMITED',
    'ORIGIN8 LAB PRIVATE LIMITED',
    'KONNEXIONS LEAGUE PRIVATE LIMITED',
    'VERT ECOSYSTEM TRADE PRIVATE LIMITED',
    'SGM ALLOYS PRIVATE LIMITED',
    'IDEAS2GOAL TECHNOLOGIES PRIVATE LIMITED',
    'JCM MASK FACTORY PRIVATE LIMITED',
    'KG GK JEWELLERS PRIVATE LIMITED',
    'SYNERGY POLYCHEM PRIVATE LIMITED',
    'ESYATECH SOLUTIONS PRIVATE LIMITED',
    'YFX STUDIOS PRIVATE LIMITED',
    'HEUBACH PIGMENTS PRIVATE LIMITED',
    'GKC ENGINEERING PRIVATE LIMITED',
    '1ITP LABS PRIVATE LIMITED',
    'AEGLE LEAF PRIVATE LIMITED',
    'ATG SOURCING INDIA PRIVATE LIMITED',
    'ASTHA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'INTIGNIS INDUSTRIES PRIVATE LIMITED',
    'IMBARKELY INDIA PRIVATE LIMITED',
    'VIVA-API LABS PRIVATE LIMITED',
    'VISOPR CONSULTANCY SERVICES PRIVATE LIMITED',
    'TETHYS TECHNOLOGIES PRIVATE LIMITED',
    'NELLAI RENEWABLES PRIVATE LIMITED',
    'ADOMOBI TECHNOLOGY PRIVATE LIMITED',
    'ECLAT HEALTH SOLUTIONS (INDIA) PRIVATE LIMITED',
    'AUTOMATED SOFTTECH TECHNOLOGY PRIVATE LIMITED',
    'CURATEQ BIOLOGICS PRIVATE LIMITED',
    'HELPEE HEALTH TECH PRIVATE LIMITED',
    'ABMIRO SOLUTIONS PRIVATE LIMITED',
    'PALMNOTE TECHNOLOGIES PRIVATE LIMITED',
    'ORIGINFERTILITY CLINIC AND RESEARCH CENTER PRIVATE LIMITED',
    'SUDEEP POLYMERS PRIVATE LIMITED',
    'CONSTOR SOLUTIONS PRIVATE LIMITED',
    'FLAVURO FOODS PRIVATE LIMITED',
    'HEALTHYKARTS PRIVATE LIMITED',
    'ECESIS ENGINEERING CONSULTANCY SERVICES PRIVATE LIMITED',
    'GOODCLAP INITIATIVES PRIVATE LIMITED',
    'VIJAI MARINE SERVICES PRIVATE LIMITED',
    'EMWA FOUNDATION',
    'VTEL TECHNOLOGIES LIMITED',
    'ASSOCIATED STAFFING PRIVATE LIMITED',
    'DELTA LIGHT INDIA PRIVATE LIMITED',
    'INCUBATE TECHNOLOGY LAB PRIVATE LIMITED',
    'ADVOTIS PHARMACEUTICAL PRIVATE LIMITED',
    'RISE 2 XL PRIVATE LIMITED',
    'GREENERGY BIO REFINERIES PRIVATE LIMITED',
    'KASHIANANDAMDHAM PRIVATE LIMITED',
    'MINTWORXS SOFTWARES PRIVATE LIMITED',
    'GOHYPE TECHNOLOGIES PRIVATE LIMITED',
    'GALVANO TECH SURFIN PRIVATE LIMITED',
    'DOITYOURSELF SCHOOLS PRIVATE LIMITED',
    'APPSVITAL TECHNOLOGIES PRIVATE LIMITED',
    'FRACTAL PICTURE PRIVATE LIMITED',
    'PICS JUMP ACADEMY PRIVATE LIMITED',
    'NAMLATECH INDIA PRIVATE LIMITED',
    'ECNA PRIVATE LIMITED',
    'STEAM FACTORY PROJECTS PRIVATE LIMITED',
    'ENTRANCE EXPORT PRIVATE LIMITED',
    'RARH AYURVEDA ARAGYA SETU FOUNDATION',
    'UNAPRIME INVESTMENT ADVISORS PRIVATE LIMITED',
    'FLYFIN SOFTWARE INDIA PRIVATE LIMITED',
    'T.G. PROPERTY SERVICES PRIVATE LIMITED',
    'S.R. DRUGS AND INTERMEDIATES (UNIT 2) PRIVATE LIMITED',
    'AUSPOONS INTERNATIONAL PRIVATE LIMITED',
    'AMP ENERGY MARKETS INDIA PRIVATE LIMITED',
    'VIYAL TECHNOLOGIES PRIVATE LIMITED',
    'E-ASHWA AUTOMOTIVE (COSTAL ANDHRA) PRIVATE LIMITED',
    'QURATIVITY MEDIA SOLUTIONS PRIVATE LIMITED',
    'DALOOPA PRIVATE LIMITED',
    'BOMA INFRASTRUCTURE PRIVATE LIMITED',
    'SHYFT INNOVATIONS INDIA PRIVATE LIMITED',
    'SEEMAX BIOTECH PRIVATE LIMITED',
    'MAXWELL AUTOMATIC DOORS INDIA PRIVATE LIMITED',
    'KOITECH PRIVATE LIMITED',
    'ZIMAAO PRIVATE LIMITED',
    'MIZUSHI INDIA PRIVATE LIMITED',
    'ACHIEVE INTELLIWORK SOLUTIONS PRIVATE LIMITED',
    'ALIVEON PRIVATE LIMITED',
    'NOUVIQUE FINECHEM PRIVATE LIMITED',
    'CAREOTECH SERVICES PRIVATE LIMITED',
    'SBA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'IKI CHIC PRIVATE LIMITED',
    'EMPYREANAIR SERVICES (OPC) PRIVATE LIMITED',
    'YE PRAYAS PRIVATE LIMITED',
    'SRAAT RETAIL SOLUTIONS PRIVATE LIMITED',
    'WIDE MOBILITY MECHATRONICS PRIVATE LIMITED',
    'NUBIBO TECHNOLOGIES PRIVATE LIMITED',
    'NAVA KISAN AGRI FARMS PRIVATE LIMITED',
    'STANDARD COLORS AND CHEMICALS INDIA PRIVATE LIMITED',
    'CHATURBOTS AI PRIVATE LIMITED',
    'TIITAN HOLDINGS INDIA PRIVATE LIMITED',
    'MAGENTA EV SOLUTIONS PRIVATE LIMITED',
    'EXTRATECH INDIA AUTOMATION PRIVATE LIMITED',
    'JOIN2 OUR FOUNDATION',
    'GADAG TRANSMISSION LIMITED',
    'BEYOND WATER TRADING PRIVATE LIMITED',
    'NEGUP SOLUTIONS (OPC) PRIVATE LIMITED',
    'KLUARC TECHNOLOGIES PRIVATE LIMITED',
    'RETTER TECHNOLOGY CONSULTING PRIVATE LIMITED',
    'EVOMATA INNOVATIONS (OPC) PRIVATE LIMITED',
    'SBNA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'AMPLIZ PRIVATE LIMITED',
    'POWERGRID BHADLA TRANSMISSION LIMITED',
    'SEA SQUARE PRIVATE LIMITED',
    'NEBULOUS TECHNOLOGIES PRIVATE LIMITED',
    'UNCAP RESEARCH LABS PRIVATE LIMITED',
    'SOZIALE SACK ADVERT PRIVATE LIMITED',
    'LETSGETTIN CORPORATE TRAININGS PRIVATE LIMITED',
    'YUKBA FASHIONS PRIVATE LIMITED',
    'ABMS MULTINATIONAL TRADING PRIVATE LIMITED',
    'HAPS INDUSTRIES PRIVATE LIMITED',
    'ZAZU WILDLIFE TECHNOLOGIES PRIVATE LIMITED',
    'HOMVERY PRIVATE LIMITED',
    'UPROW ERP PRIVATE LIMITED',
    'DIGIOSK INDIA PRIVATE LIMITED',
    'DEFINITICS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'KRAFTONOMICS RETAIL AND LOGISTICS PRIVATE LIMITED',
    'IHEAL HEALTHTECH PRIVATE LIMITED',
    'KALINTH ADVISORS PRIVATE LIMITED',
    'FINARB ANALYTICS CONSULTING (OPC) PRIVATE LIMITED',
    'LWT BUSINESS PRIVATE LIMITED',
    'VIA MAGNA PRIVATE LIMITED',
    'DOIFOO INTERNET PRIVATE LIMITED',
    'SVAYAM INFOWARE PRIVATE LIMITED',
    'STURDY PARKING SOLUTIONS (INDIA) PRIVATE LIMITED',
    'ZYMRAT ACTIVEWEAR PRIVATE LIMITED',
    'REVLITY VR TECHNOLOGIES PRIVATE LIMITED',
    'TRUSTSERVE CONSULTANCY SERVICES PRIVATE LIMITED',
    'SUMERTI INDUSTRIES PRIVATE LIMITED',
    'ZEN3 ITSOLUTIONS PRIVATE LIMITED',
    'CNF TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'KAMYA SHIPPING PRIVATE LIMITED',
    'JARLIE INDIA PRIVATE LIMITED',
    'VISHVAND ENTERPRISES PRIVATE LIMITED',
    'KEPL ENGINEERING PRIVATE LIMITED',
    'NEXTQORE PRIVATE LIMITED',
    'ZING7 IT SERVICES PRIVATE LIMITED',
    'PREXEL PRIVATE LIMITED',
    'SANELA TECHNOLOGIES PRIVATE LIMITED',
    'CUNOMIAL TECHNOLOGIES PRIVATE LIMITED',
    'MAHALAKSHMI ELECTRONICS PRIVATE LIMITED',
    'STRATOTEK CONSULTING PRIVATE LIMITED',
    'EPOS AUDIO INDIA PRIVATE LIMITED',
    'TECH START SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'LIMITLESS SECURITY & FACILITY MANAGEMENT PRIVATE LIMITED',
    'GLOBE 13 AGRO PRIVATE LIMITED',
    'KALLAL ECOMMERCE GLOBAL TRADE (OPC) PRIVATE LIMITED',
    'FIQ INNOVATIONS PRIVATE LIMITED',
    'TAXREPLY INDIA PRIVATE LIMITED',
    'IGEAR TECH PRIVATE LIMITED',
    'FUTURE ENCRYPT PRIVATE LIMITED',
    'GRIP INVEST TECHNOLOGIES PRIVATE LIMITED',
    'ESWIFT INTERNATIONAL ASSISTANCE PRIVATE LIMITED',
    'MITUL PROPERTIES PRIVATE LIMITED',
    '11X INFISOL PRIVATE LIMITED',
    'AIDIFY LEARNING AND MOBILITY PRIVATE LIMITED',
    'MARGIN SENTIMENT ADVISORYS PRIVATE LIMITED',
    'KVM HEALTH AND EDUCATION PRIVATE LIMITED',
    'TAPROOT FARMS PRIVATE LIMITED',
    'KALINGAINNOVATION FOUNDATION',
    'VVV INFOTECH PRIVATE LIMITED',
    'ADDWELLPROJECTS PRIVATE LIMITED',
    'ONLINKS WEB SERVICES PRIVATE LIMITED',
    'APOLLONIUS COMPUTATIONAL BUSINESS SOLUTIONS (OPC) PRIVATE LIMITED',
    'VIBRONICS LAB PRIVATE LIMITED',
    'PERODE GRANITES PRIVATE LIMITED',
    'SECUREVA COMFORT PLUS HEALTHCARE (OPC) PRIVATE LIMITED',
    'VEDANT SERVICES PRIVATE LIMITED',
    'BIOERRA AYURVEDA PRIVATE LIMITED',
    'MODE RETAILS SALES & MARKETING PRIVATE LIMITED',
    'LOGIT SOLUTIONS PRIVATE LIMITED',
    'DIGISPARSH PRIVATE LIMITED',
    'RLCLOGISTICS PRIVATE LIMITED',
    'ATK MOHUN BAGAN PRIVATE LIMITED',
    'HIREKUL RECRUITMENT PRIVATE LIMITED',
    'NEXINDIA INFO SYSTEMS PRIVATE LIMITED',
    'DIGIGRO TECHNOLOGIES PRIVATE LIMITED',
    'HAFLINGER TECHNOLOGIES PRIVATE LIMITED',
    'WEALTHSWAN CONSULTANTS PRIVATE LIMITED',
    'TPS CONSULTANCY FOUNDATION',
    'JANGRAS INTERNET AND DIGITAL FINANCIAL (PAYMENT) SERVICES PRIVATE LIMITED',
    'WMC TRADING PRIVATE LIMITED',
    'ALLYARD ONLINE PRIVATE LIMITED',
    'ARP TELESERVICES PRIVATE LIMITED',
    'GRUHA AUTOMATIONS PRIVATE LIMITED',
    'FOOD-TANTRAA PRIVATE LIMITED',
    'REALTYFIELD ADVISORS PRIVATE LIMITED',
    'WELL WELLNESS PRIVATE LIMITED',
    'PULSE INNOVATION PRIVATE LIMITED',
    'VINSAG PRIVATE LIMITED',
    'GHCL TEXTILES LIMITED',
    'SUHITA FOODS AND AGRO PRIVATE LIMITED',
    '4CURENCARE HEALTHCARE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED',
    'Reel Life Pictures Private Limited',
    'Sevenage Infotech Private Limited',
    'FINCASYS HERITAGE PRIVATE LIMITED',
    'AASHVI CREATIONS PRIVATE LIMITED',
    'GRAVITY GLOBAL HEALTHTECH PRIVATE LIMITED',
    'SEEDUP ADVISORS PRIVATE LIMITED',
    'BM ALPHA SOLUTIONS PRIVATE LIMITED',
    'JP AGRI GENETICS PRIVATE LIMITED',
    'Pamp Technologies (india) Private Limited',
    'NEXTBUILD TECHNOLOGIES PRIVATE LIMITED',
    'CYCLORAMA STUDIOS PRIVATE LIMITED',
    'KULOMB MOBILITY PRIVATE LIMITED',
    'Unitas Global India Private Limited',
    'Supply Wisdom Services India Private Limited',
    'Orange Waves Networks Private Limited',
    'JENECO FARMACIA PRIVATE LIMITED',
    'DOCX TECHNOLOGIES PRIVATE LIMITED',
    'JK SUGARS AND COMMODITIES PRIVATE LIMITED',
    'NEOHUB SPACES PRIVATE LIMITED',
    'KIKAI INDUSTRIES PRIVATE LIMITED',
    'TAPGENICS PRIVATE LIMITED',
    'MOBELCHEM SPECIALTY PRIVATE LIMITED',
    'Steribrooks Penems Private Limited',
    'Oely Products Private Limited',
    'MALAXMI POLYMERS PRIVATE LIMITED',
    'BRANDS SCALEUP PRIVATE LIMITED',
    'VOQZI MEDIA PRIVATE LIMITED',
    'SRI VENKATESWARI JEWELLERS PRIVATE LIMITED',
    'JINGLE ENTERTAINMENT PRIVATE LIMITED',
    'NEWZIE TN DAIRY PRODUCTS PRIVATE LIMITED',
    'VNUIT INDIA PRIVATE LIMITED',
    'WELLINGTON COLLEGE INTERNATIONAL INDIA PRIVATE LIMITED',
    'Uniquelife Consultants Private Limited',
    'Rishabh Apparel Exports Private Limited',
    'Desoft Technology Solutions Private Limited',
    'CONVERGE EDUTECH PRIVATE LIMITED',
    'Valamis India Private Limited',
    'No Nasties Private Limited',
    'Sdal Mart Private Limited',
    'SAFETYNET INNOVATIONS PRIVATE LIMITED',
    'PME LEISURE PRIVATE LIMITED',
    'AL SARNA RETAIL PRIVATE LIMITED',
    'VISHWAJAYA MARKETING AND RESEARCH SERVICES (OPC) PRIVATE LIMITED',
    'IVY MINDS LEARNING SOLUTIONS PRIVATE LIMITED',
    'Prof.samit Ray Edumission Private Limited',
    'Toplad Private Limited',
    'Educluster India Private Limited',
    'Iit Foundation For Accreditation And Assessment',
    'ADBHUT TRAVEL AND EVENT PRIVATE LIMITED',
    'GREVITYWINGSGREEN INDIA MARKETING PRIVATE LIMITED',
    'PINACA TECHNOLOGIES PRIVATE LIMITED',
    'IQZ DESIGNS PRIVATE LIMITED',
    'WOVENTEX HEALTHFAB PRIVATE LIMITED',
    'THASAAMAH TECHNOLOGY PRIVATE LIMITED',
    'SYSTEM PROTECTION TECHNOCORP PRIVATE LIMITED',
    'INTERWEAVE POLYTEX PRIVATE LIMITED',
    'BIGSTARBAAZAR RETAL MARKETING PRIVATE LIMITED',
    'Mysunar Jewels Private Limited',
    'Dhana Aviation Private Limited',
    'Atlas Steel Industries Private Limited',
    'OHM CLEAN TECH PRIVATE LIMITED',
    'CAPXIMIZE INDIA PRIVATE LIMITED',
    'ET CHOCOLATES (INDIA) PRIVATE LIMITED',
    'JN2 INFRAPROJECTS PRIVATE LIMITED',
    'GARUDA MOTION PICTURES PRIVATE LIMITED',
    'JAIHIND STEEL PRIVATE LIMITED',
    'BUTTERSCOTCHMANGO INDIA PRIVATE LIMITED',
    'TRIDEV WHEELERS PRIVATE LIMITED',
    'BEELINE CAPITAL ADVISORS PRIVATE LIMITED',
    'JUNIPER GREEN GEM PRIVATE LIMITED',
    'SPYWIRE INFOTECH PRIVATE LIMITED',
    'SHLOKIN DIGITAL MEDIA PRIVATE LIMITED',
    'RIVLET INTERNATIONAL PRIVATE LIMITED',
    'INTERNATIONAL DISPUTE RESOLUTION COUNCIL',
    'AERTHLY TECH PRIVATE LIMITED',
    'CEEYES MOBILITY SOLUTIONS PRIVATE LIMITED',
    'POLYSOL SPECIALTY CHEMICALS PRIVATE LIMITED',
    'ENSURE SECURE SERVICES PRIVATE LIMITED',
    'MESHUGA PRIVATE LIMITED',
    'BNP MANPOWER AND SECURITY SERVICES PRIVATE LIMITED',
    'AUDAZ VENTURES PRIVATE LIMITED',
    'SYNERGIST TECHNOLOGIES PRIVATE LIMITED',
    'PUDDYS TECHNOLOGIES PRIVATE LIMITED',
    'AJAL ASSOCIATES PRIVATE LIMITED',
    'PANCHAHARA (OPC) PRIVATE LIMITED',
    'ITSEC CONSULTANTS PRIVATE LIMITED',
    'RUSTAM AGRIFRESH INDUSTRIES PRIVATE LIMITED',
    'ANMOLPAHAL FOUNDATION',
    'VENTRIX TECHNOLOGIES PRIVATE LIMITED',
    'GEARTRON TECHNOLOGIES PRIVATE LIMITED',
    'KRI HOSPITALITY PRIVATE LIMITED',
    'BHATIA EMPLOYMENT PRIVATE LIMITED',
    'BEEP INNOVATIONS PRIVATE LIMITED',
    'PLM NORDIC TECH PRIVATE LIMITED',
    'EOB MANAGEMENT ADVISORS PRIVATE LIMITED',
    'AXELROD MARKETING AND ADVERTISING PRIVATE LIMITED',
    'MACELTRON MACHINES PRIVATE LIMITED',
    'PIONEER BREWERIES INDIA PRIVATE LIMITED',
    'BIPLOB WORLD PRIVATE LIMITED',
    'SHANTIONE FULFILLMENT CENTRE PRIVATE LIMITED',
    'BOL7 AGRO FOODS (OPC) PRIVATE LIMITED',
    'RAWLINE INDUSTRIES PRIVATE LIMITED',
    'WHITECREW INDUSTRIES PRIVATE LIMITED',
    'VED MAHAKAUSHAL PRODUCER COMPANY LIMITED',
    'VEON EVENTS PRIVATE LIMITED',
    'HUGGAIN ONLINE BUSINESS PRIVATE LIMITED',
    'ARTHAWIND SHARE PRIVATE LIMITED',
    'SUCCESSR HRTECH PRIVATE LIMITED',
    'CLIPTAX PRIVATE LIMITED',
    'TEESTRA LIFESTYLE PRIVATE LIMITED',
    'POPO VENTURES PRIVATE LIMITED',
    'RADIANTFIRST TREEBANC HINDUSTHAN NIDHI LIMITED',
    'KREDUE FINTECH PRIVATE LIMITED',
    'SRI MUKUND BAKERS & TRADERS PRIVATE LIMITED',
    'ENPASS TECHNOLOGIES PRIVATE LIMITED',
    'NEEDAMANGALAM NIDHI LIMITED',
    'CHANAN CONSUMER PRODUCTS PRIVATE LIMITED',
    'RENEW SOLAR VIDHI PRIVATE LIMITED',
    'SPG LOGISTIC PARK MEERUT PRIVATE LIMITED',
    'SIXTY STRIKES PRIVATE LIMITED',
    'HYPRSCI PRIVATE LIMITED',
    'OTIS TEXTILES PRIVATE LIMITED',
    'SILPEROX BIO CHEM PRIVATE LIMITED',
    'PUMINATI DIGITAL PRIVATE LIMITED',
    'KAYMAN AND CONTINENTAL NETWORKS PRIVATE LIMITED',
    'APPSBOAT TECHNOLOGIES PRIVATE LIMITED',
    'VAZIR IMMIGRATION SERVICES PRIVATE LIMITED',
    'RAS GLOBAL INDUSTRIES PRIVATE LIMITED',
    'XELWARE PRIVATE LIMITED',
    'NUBE PROFESSIONAL SERVICES (OPC) PRIVATELIMITED',
    'ESDEC INDIA SOLAR PRIVATE LIMITED',
    'MOBISAFAR TECHNOLOGIES PRIVATE LIMITED',
    'BEYOND THEORY LEARNING PRIVATE LIMITED',
    'DATACURATE TECHNOLOGIES PRIVATE LIMITED',
    'JS PRODUCTS INDIA PRIVATE LIMITED',
    'HIMTECH IT SERVICES PRIVATE LIMITED',
    'KUHMANCHEE MEDIALABS PRIVATE LIMITED',
    'CHEM STONE INDUSTRIES PRIVATE LIMITED',
    'I-EXAMINE MEDIA SOLUTIONS PRIVATE LIMITED',
    'BOOTSTART BIZ SOLUTIONS PRIVATE LIMITED',
    'RAYONNANT INDUSTRIES AND RENEWABLES PRIVATE LIMITED',
    'RRB PHARMACEUTICALS PRIVATE LIMITED',
    'IDEAYE MEDIA PRIVATE LIMITED',
    'SWADESHI VIKRETA FORUM',
    'BRANE ENTERPRISES PRIVATE LIMITED',
    'PARMARTECHNOLOGIES PRIVATE LIMITED',
    'ITECHGENIC GLOBAL PRIVATE LIMITED',
    'TRES INFOSOL PRIVATE LIMITED',
    'SJAIN TECHNOLOGIES PRIVATE LIMITED',
    'PRIDE PINNACLE PRODUCTS PRIVATE LIMITED',
    'JUSTISQUAD ASSOCIATION',
    'GETMYINDIA FOUNDATION',
    'BIKAL GOODS TRANSPORT PRIVATE LIMITED',
    'WINARB SOLUTIONS PRIVATE LIMITED',
    'TWIKA AURUS PRIVATE LIMITED',
    'COSMOS CAPITAL PRIVATE LIMITED',
    'RENEW SURYA PRATAP PRIVATE LIMITED',
    'VISUAL WIZARDS ACADEMY PRIVATE LIMITED',
    'HAPPY CONNECTS TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'PUSHPAKTECH PRIVATE LIMITED',
    'DELUXE ENTERTAINMENT DISTRIBUTION INDIA PRIVATE LIMITED',
    'AKHANDALAMANI ELECTRICALS AND CONSTRUCTION PRIVATE LIMITED',
    'ZOOTECK TECHNOLOGY PRIVATE LIMITED',
    'AWGMEN TECHNOLOGIES PRIVATE LIMITED',
    'EQUALGENIUS FOUNDATION',
    'DURU COMPLIANCE PRIVATE LIMITED',
    'QUADS FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'CREENSIGHT PRIVATE LIMITED',
    'ATELIER NEORAH PRIVATE LIMITED',
    'ASHRITHA NIDHI LIMITED',
    'HEXAGRAM FINTECH PRIVATE LIMITED',
    'LOHAA WORLD TRADE LINKS PRIVATE LIMITED',
    'VENTURESHARK INFRASTRUCTURE PRIVATE LIMITED',
    'ALILA HOME CARE PRODUCTS PRIVATE LIMITED',
    'FOCUZSOFT TECHNOLOGIES PRIVATE LIMITED',
    'SUNROOF POWER SOLUTION PRIVATE LIMITED',
    'HAI FOODIE ONLINE PRIVATE LIMITED',
    'HABIBPUR FARMER',
    'GREENS NUTRI AGRO COT PRIVATE LIMITED',
    'PINAAFAL FARMS PRIVATE LIMITED',
    'JDS MOTION TECHNOLOGY PRIVATE LIMITED',
    'AIOLOS CLOUD SOLUTIONS PRIVATE LIMITED',
    'CIVIL-TECH CONSULTANTS AND ENGINEERS PRIVATE LIMITED',
    'BLR ENTERPRISES PRIVATE LIMITED',
    'FAST TRADE TECHNOLOGIES PRIVATE LIMITED',
    'OPENNETS INDIA PRIVATE LIMITED',
    'BROKI SERVICES PRIVATE LIMITED',
    'MSMEDNA SOLUTIONS PRIVATE LIMITED',
    'ORG RESEARCH PRIVATE LIMITED',
    'ANJANIYA ENERGIES & FERTILIZERS PRIVATE LIMITED',
    'RTN PROPUSERS PRIVATE LIMITED',
    'IBUSINESSLABS PRIVATE LIMITED',
    'GSINFOTECHVIS PRIVATE LIMITED',
    'MFG OVERSEAS PRIVATE LIMITED',
    'AMER INTERNATIONAL TOURS AND TRAVELS PRIVATE LIMITED',
    'YOGIS WELLNESS INDIA PRIVATE LIMITED',
    'GARIB PATHSHALA WELFARE FOUNDATION',
    'G. K. ALLOYS PRIVATE LIMITED',
    'LEOZEN LIFE SCIENCES PRIVATE LIMITED',
    'SHRINIWAS SOLAR ENERGY PRIVATE LIMITED',
    'JINISHA SECURITIES PRIVATE LIMITED',
    'V3CUBE INNOVATIONS PRIVATE LIMITED',
    'HAWKISTUDIO PRIVATE LIMITED',
    'CPC PRECIPARTS PRIVATE LIMITED',
    'VIRTUAL GALAXY INSURANCE BROKERS PRIVATE LIMITED',
    'DATSOLUTIONS PRIVATE LIMITED',
    'ARJUN IMMIGRATION AND EDUCATION SERVICES PRIVATE LIMITED',
    'AYANTRAM PRIVATE LIMITED',
    'MYMYEYES TECHNOLOGIES PRIVATE LIMITED',
    'HALVAD RENEWABLES PRIVATE LIMITED',
    'VANTHALI RENEWABLES PRIVATE LIMITED',
    'ALAKNANDA TNR MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'SHOP LOCAL SOLUTIONS PRIVATE LIMITED',
    'ISC RENTALS PRIVATE LIMITED',
    'ANTHILL PROPERTIES PRIVATE LIMITED',
    'INDERJIT MARWAHA AUTOS PRIVATE LIMITED',
    'HUBTREE VENTURES PRIVATE LIMITED',
    'HVM NATURALS PRIVATE LIMITED',
    'CAMPTRA TECHNOLOGIES PRIVATE LIMITED',
    'VR DERMA PRIVATE LIMITED',
    'SLOW PRODUCTS PRIVATE LIMITED',
    'DIVINE FIRST MANAGEMENT PRIVATE LIMITED',
    'BILI CONSULTANCY PRIVATE LIMITED',
    'CONEX TERMINAL PRIVATE LIMITED',
    'EIRA NUTRIZEN PRIVATE LIMITED',
    'B. BAREFOOT ENTERPRISES PRIVATE LIMITED',
    'CRC HOMES PRIVATE LIMITED',
    'MEDEMY LIFE SCIENCES PRIVATE LIMITED',
    'SARVODYA LIFE SKILLS PRIVATE LIMITED',
    'EPITOMECLOUD TECHNOLOGY PRIVATE LIMITED',
    'NORMALYZ (OPC) PRIVATE LIMITED',
    'XENOTECH AI PRIVATE LIMITED',
    'MICRO-PRECISE HITECH PRIVATE LIMITED',
    'DAAKIA PRIVATE LIMITED',
    'NU-FLOW AUTOMATION (INDIA) PRIVATE LIMITED',
    'MSJ TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NARIDARPAN DIGITAL MEDIA PRIVATE LIMITED',
    'NARAYAN HOSPITAL SAGAR PRIVATE LIMITED',
    'IRIS WAVES PRIVATE LIMITED',
    'SECURE CARD SOLUTIONS INDIA PRIVATE LIMITED',
    'TOTUS CERAMICS INDIA PRIVATE LIMITED',
    'SUDHA INFRAELECTRICAL PRIVATE LIMITED',
    'TRAYIS TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'ACIC-VGU FOUNDATION',
    'IREU ENTERPRISES PRIVATE LIMITED',
    'AGRIBLE PROCESSORS PRIVATE LIMITED',
    'BRFL TEXTILES PRIVATE LIMITED',
    'JETSTREAK INDUSTRIES PRIVATE LIMITED',
    'KOODOO PRIVATE LIMITED',
    'SYM COMMERCIAL PRIVATE LIMITED',
    'ANNISHKA TRADE SOLUTIONS PRIVATE LIMITED',
    'BALAJI RAISING INDIA PRIVATE LIMITED',
    'INDUCTUS PROJECTS PRIVATE LIMITED',
    'OZA INDUSTRIES PRIVATE LIMITED',
    'ATX SYSTEMS PRIVATE LIMITED',
    'MONKLABS PRIVATE LIMITED',
    'GR ENA KIM EXPRESSWAY PRIVATE LIMITED',
    'EDSOLVE FOUNDATION',
    'KIRANGLOBAL SILICACHEM PRIVATE LIMITED',
    'SAPPER SOFTWARE PRIVATE LIMITED',
    'OBEN ELECTRIC VEHICLES PRIVATE LIMITED',
    'KREATIVETEC DIGITAL SOLUTIONS PRIVATE LIMITED',
    'ORIGAMI DRIPBAG PRIVATE LIMITED',
    'CHQBOOK INSURANCE BROKING PRIVATE LIMITED',
    'VCODE SOFTWARES PRIVATE LIMITED',
    'SENTIENT DEVELOPERS PRIVATE LIMITED',
    'EMPYREAN MOBILITAS PRIVATE LIMITED',
    'GLOBALFAIR TECHNOLOGIES PRIVATE LIMITED',
    'INEVITABLE MEDICARE PRIVATE LIMITED',
    'FINADOCTOR MICRO CARE FOUNDATION',
    'NATTER DIGITAL SOLUTIONS PRIVATE LIMITED',
    'ADVISORATE PRIVATE LIMITED',
    'KHWAHISHEIN FOUNDATION',
    'LAT GLOBAL PUBLISHERS PRIVATE LIMITED',
    'MALOLA DEVELOPMENTS PRIVATE LIMITED',
    'G-3 TECHNOLOGIES PRIVATE LIMITED',
    'EBOT AI IT SOLUTIONS PRIVATE LIMITED',
    'VINZ GLOBAL (INDIA) PRIVATE LIMITED',
    'KUMAR BIOSEEDS AND AGRO PRODUCTS PRIVATE LIMITED',
    'JAIPUR JEWELRY FEDERATION',
    'HIGHWAY DESTINATION LOGISTICS PRIVATE LIMITED',
    'CYBERSEC SERVICES ADVISOR PRIVATE LIMITED',
    'UNALOME FOUNDATION',
    'ATILUS PHARMA PRIVATE LIMITED',
    'QUADRICAP ADVISORS PRIVATE LIMITED',
    'XIALPHA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CHILLETA FOODS PRIVATE LIMITED',
    'TIRUPATI LIFESCIENCES PRIVATE LIMITED',
    'MEDAARA HEALTH CARE TECHNOLOGIES PRIVATE LIMITED',
    'IRINE',
    'AMAR EXPORTZ PRIVATE LIMITED',
    'Regaliaa buildtech & services private limited',
    'COVERIDE CREATIONS PRIVATE LIMITED',
    'Ingenero technologies (india) private limited',
    'Halcyon trading private limited',
    'Divya mercantile private limited',
    'Namdeo umaji agritech (india) private limited',
    'Seaking trading agency pvt ltd',
    'Reliance brands limited',
    'Gifting ideas private limited',
    'Phenomenex india private limited',
    'RESILIENT APPARELS PRIVATE LIMITED',
    'Poddar global (kolkata) private limited',
    'Giantlok india private limited',
    'Reckers mechatronics private limited',
    'Rdr impex private limited',
    'Sar marketing and sales private limited',
    'Cosmosgalaxy (india) private limited',
    'Scantech india measuring equipments private limited',
    'Rocca exim private limited',
    'Ambitious trading private limited',
    'KAUSHAL AGENCIES PVT LTD',
    'Arvind rub-web controls limited',
    'Vinod international limited',
    'Linen design company private limited',
    'Konica minolta business solutions india private limited',
    'Dust control and ventilation private limited',
    'MRKA TRADING INTERNATIONAL PRIVATE LIMITED',
    'S KNOWLEDGE SYSTEMS PRIVATE LIMITED',
    'Eventfaqs media private limited',
    'Vervali systems private limited',
    'SEMTECH ADVANCED SYSTEMS INDIA PRIVATE LIMITED',
    'Det labs private limited',
    'Light wave technologies private limited',
    'NEILSOFT PRIVATE LIMITED',
    'Ibn technologies limited',
    'Uptech systems private limited',
    'Isn global solutions private limited.',
    'Itcube solutions private limited',
    'Zs associates india private limited',
    'Reflexis systems india private limited',
    'Yoteam information technologies private limited',
    'Valley crest software private limited',
    'Seventh august it services private limited',
    'Novus nexus india private limited',
    'Probytes software private limited',
    '1218 india private limited',
    'Mphatek systems private limited',
    'Tag eleven softech private limited',
    'Xl softech systems private limited',
    'Softpath systems private limited',
    'Arabindo polymers private limited',
    'Eappsys info solutions india private limited',
    'New horizons cybersoft limited',
    'Wordstream technologies private limited',
    'Signtech india private limited',
    'Chemcleanzio india private limited',
    'FIRESKY CONSULTANTS INDIA PRIVATE LIMITED',
    'Sterling environmental solutions private limited',
    'A. g. professional systems private limited',
    'Ispita resorts private limited',
    'Varkey school infrastructure management services private limited',
    'Msa gujarat molecular imaging (india) private limited',
    'RSM Delivery Center (India) Private Limited',
    'Minesweeper media services private limited',
    'Basar enterprises private limited',
    'Zircon logistics private limited',
    'IndiaNivesh Investment Managers Private Limited',
    'Aero offshore private limited',
    'Mondo shipping logistic private limited',
    'Casappa hydraulics india private limited',
    'Inokule healthcare private limited',
    'Yash offshore private limited',
    'MECHATRON TECHGEAR PRIVATE LIMITED',
    'Herbapex botanicals private limited',
    'Blue ocean strategic advisors private limited',
    'Global express multilogistics private limited',
    'Bridging gaps marketing consultancy services private limited',
    'Shrikaam fincom consulting private limited',
    'Sophos bi corporate solutions private limited',
    'Atul engineering consultancy services private limited',
    'Herco transformers limited',
    'Sunrise skill development private limited',
    'Cafe creme (india) private limited',
    'Ssk fire safety solutions private limited',
    'Navigate consulting business solutions india private limited',
    'Orange machinetech private limited',
    'Mega process technology private limited',
    'Megacity flour mills private limited',
    'Arklogistics services private limited',
    'Sitaram spinners private limited',
    'Dakshah ebiz consulting private limited',
    'Value line homestyle private limited',
    'SUB-K IMPACT SOLUTIONS LIMITED',
    'Smile stonetech services india private limited',
    'Modern fresh foods india private limited',
    'Ramco private limited',
    'Psa sical terminals limited',
    'Beach minerals company private limited',
    'Airport global technical solutions private limited',
    'Mars capital private limited',
    'M p n corporate consultants private limited',
    'Daiichi systems private limited',
    'CHETTINAD PRODUCTS AND SERVICES PRIVATE LIMITED',
    'Micro code india private limited',
    'Dasava corporate services private limited',
    'Thulir learning solutions private limited',
    'Bristol industries private limited',
    'Vestox business solutions private limited',
    'Avis enertech private limited',
    'Kj com trade private limited',
    'Stone bench creations private limited',
    'Basell automation system private limited',
    'Illam hospitality services private limited',
    'Ecube interior solutions private limited',
    'Buka power plant consultants private limited',
    'Trimed solutions (india) private limited',
    'THINKTOWER INTECH PLATFORM PRIVATE LIMITED',
    'Swastik buyers pvt ltd',
    'Shriram electrocast private limited',
    'Snowmasters special effects india private limited',
    'Paradise infranirman consultants private limited',
    'Ilico services limited',
    'SECURE INFRATECH FINSERV AND SECURITIES LIMITED',
    'Satya subal himghar private limited',
    'Karnataka trustee company private limited',
    'Expert industrial security private limited',
    'Kika dye chem exports private limited',
    'Vg educational services private limited',
    'Kaizen institute (india) private limited',
    'Astron foundation',
    'Everonn school limited',
    'RHAPSODY EDUCATION PRIVATE LIMITED',
    'Strategum eduserve private limited',
    'Finitiatives learning india private limited',
    'Trivium education services private limited',
    'Vidyasagar learning private limited',
    'Yugnirman public school private limited',
    'Aadyant education private limited',
    'Iant educom private limited',
    'Edvista educational services private limited',
    'Rainbow preschool international limited',
    'Arrina education services private limited',
    'Social synergy foundation',
    'Amrit skills development private limited',
    'Everonn technical education india limited',
    'Bharadwaj institute private limited',
    'Gigglewhiz learning private limited',
    'Rockwell educational institutions private limited',
    'Brn marine education private limited',
    'Vedang innovative it transformation private limited',
    'Panoramic educare private limited',
    'Rkkr holdings private limited',
    'Emmess control private limited',
    'Suvarna alloys private limited',
    'Moon steels and general industries private limited',
    'Magotteaux industries private limited',
    'Rostfrei steels private limited',
    'Beko-kare enterprises private limited',
    'Bharat roll industry pvt ltd',
    'Bhansali international private limited',
    'Monel equipments private limited',
    'VALVAYA CAPITAL PRIVATE LIMITED',
    'Vimco tubes private limited',
    'RBR GOLD PRIVATE LIMITED',
    'Pytex jewellers private limited',
    'TAMBOLI FOUNDRY SUPPLY & SERVICES LIMITED',
    'Chola turbo machinery international private limited',
    'Weartech alloys private limited',
    'Meche pvt ltd',
    'Seete rings private limited',
    'Ravin energy solutions private limited',
    'Petromech engineers private limited',
    'Veera precicast private limited',
    'SALASAAR STEEL INDUSTRIES LIMITED',
    'Nsr steels private limited',
    'T g r engineering and automotives private limited',
    'Calcutta tube (india )private limited',
    'Nash industries (i) private limited',
    'Geo designs and research private limited',
    'Ashbee industries india private limited',
    'Bell fluid technics private limited',
    'Gagan packaging pvt ltd',
    'Kuloday packaging(india) pvt ltd',
    'Nikita containers private limited',
    'Aps global private limited',
    'Simal packaging private limited',
    'Classic products private limited',
    'Ratna home products private limited',
    'Bhansali engineering industries private limited',
    'Snehal ac and r engg private limited',
    'Green readymade steel products india private limited',
    'William king steel service centres private limited',
    'Solid structures private limited',
    'Shree die cast private limited',
    'Patodia forgings & gears limited',
    'Sachina engineering private limited',
    'ASTEC VALVES & FITTINGS PRIVATE LIMITED',
    'Modest and parsons international private limited',
    'Vitech fabricators private limited',
    'Porus equipments private limited',
    'Segal optiks private limited',
    'Uni profiles private limited',
    'Sunrise tools india private limited',
    'Buttwelded tools private limited',
    'Vijaya seamless containers private limited',
    'Silver containers private limited',
    'Steelfab engineering private limited',
    'Delta tmt bars private limited',
    'Herdsmann industries private limited',
    'Microvision enviro equipments private limited',
    'Waterman international technologies private limited',
    'Vec vacuum solutions private limited',
    'Ecoflex flooring private limited',
    'Ovivo india private limited',
    'Aristo preci-machines pvt ltd',
    'SIBAS ULTRASONICS PRIVATE LIMITED',
    'Milpan engineering private limited',
    'Ami foodservice equipment solutions private limited',
    'Raghav aerospace manufacturing technologies private limited',
    'Sealtite dichtungs private limited',
    'Grand prix motors private limited',
    'Almighty auto ancillary private limited',
    'Speciality sintered products private limited',
    'Duck woo autoind private limited',
    'Daejoo automotive india private limited',
    'Dong ah electric india private limited',
    'Samira marinas private limited',
    'Marcons ship management pvt ltd',
    'Meka shipyard private limited',
    'Huf india private limited',
    'Kar auto private limited',
    'ARCEDIOR INTERNATIONAL PRIVATE LIMITED',
    'Apana hardware suppliers private limited',
    'Intelerio furnishing private limited',
    'Bodhi brands private limited',
    'Anar coir private limited',
    'Space management systems india private limited',
    'Team one architects (india) private limited',
    'Oriel windows private limited',
    'Vighnahar packaging private limited',
    'Diam gems and stones private limited',
    'Bonitas jewels private limited',
    'Dinurje jewellery private limited (part ix)',
    'Dipti diamonds & jewellery private limited',
    'SAMBHAV GEMS LIMITED',
    'Kemika photo products private limited',
    'Virat farms private limited',
    'EXCO GRAPHIC INDIA PRIVATE LIMITED',
    'Asian global limited',
    'P.a.v. print pack pvt ltd',
    'Bharat embroidaries private limited',
    'Tulip farms private limited',
    'Gladdolia farms private limited',
    'Skl india private limited',
    'Rocky estates private limited',
    'Aov forex private limited',
    'Saarc builders private limited',
    'COOKFLIX PRIVATE LIMITED',
    'SOLIDON (INDIA) PRIVATE LIMITED',
    'Computer application and design services private limited',
    'Leading services private limited',
    'Cosmo india private limited',
    'Skup estates private limited',
    'Staple resourcing private limited',
    'Engineers mech india private limited',
    'Vedang multitech (india) private limited',
    'Balwani and associates private limited',
    'Paragon properties private limited',
    'Uma exim private limited',
    'Righill international limited',
    'Wiley india private limited.',
    'Iknoor technology private limited',
    'SIDHVANDAN FINANCE LIMITED',
    'Vision housing finance pvt ltd',
    'Securelynkx rfid network private limited',
    'INSTANTPAY INDIA LIMITED',
    'Inative telecommunications private limited',
    'A.g. shares and securities limited',
    'Swissfone india ventures private limited',
    'Next generation telecommunications india private limited',
    'Quick investment (india) ltd.',
    'Celtic investments private limited',
    'Ameya investments private limited',
    'Desons holdings and finance pvt ltd',
    'Deepak finance and investment private limited',
    'Truworth corporation private limited',
    'S v traders & investment pvt ltd',
    'Agrentoe investments pvt ltd',
    'Vibgyor printing and packaging pvt ltd',
    'Oberoi plaza pvt ltd',
    'Odyssey fiscal services pvt ltd',
    'Vastushilp investments private limited',
    'Cine cable private limited',
    'Amy agro private limited',
    'Imperial holding private limited',
    'Oberoi leasing and finance co pvt ltd',
    'DUGGAL GUPTA INSURANCE SURVEYORS AND LOSS ASSESSORS PRIVATE LIMITED',
    'Sanya holding private limited',
    'Magic info solutions private limited.',
    'Sunwood speakers pvt ltd',
    'Dakshya infra developers private limited',
    'Fairyland homes private limited',
    'Atlantic investment private limited',
    'Bombay plaza pvt ltd',
    'N s telecommunication private limited',
    'Vitasta estates private limited',
    'Trophy estates private limited',
    'Bucon projects india private limited',
    'Eurus internetworks private limited',
    'Anadi investments pvt ltd',
    'Right florist private limited',
    'LECCE INDIA LIGHTING PRIVATE LIMITED',
    'Bakshi properties private limited',
    'Seema securities private limited',
    'Money options services pvt ltd',
    'Vijay ganga properties pvt ltd.',
    'Emkay portfolio india private limited',
    'Alwarpet properties private limited',
    'Sairam infra projects private limited',
    'Nadia properties pvt ltd',
    'Sahajanpur developers pvt ltd',
    'RIAAN WELLNESS PRIVATE LIMITED',
    'Nikung properties pvt ltd',
    'Uttarayan housing private limited',
    'Nsg developers private limited',
    'Bengal srijan projects pvt ltd',
    'I finance company limited',
    'UPPER INDIA SMELTING & REFINERY WORKS PRIVATE LIMITED',
    'Trinetra buildcon private limited',
    'Santasha real estate private limited',
    'Novus realty private limited',
    'Harischandra estates pvt ltd',
    'Rachna estate private limited',
    'Hemang holdings private limited',
    'Vps share company private limited',
    'Blossom info solutions private limited.',
    'S p wahi properties private limited',
    'Blossom promoters private limited.',
    'Vachan realtors private limited.',
    'Samhi hotels (gurgaon) private limited',
    'MERAYA DISTILLERIES PRIVATE LIMITED',
    'Seven heaven buildmart private limited',
    'Queensgate holdings (india) private limited',
    'Virat greens private limited',
    'Kabra exports private limited',
    'Gee kay tradecom limited',
    'Dhiru financial and management private limited',
    'Dayanand munjal investments pvt ltd',
    'Park town planners private limited',
    'Munjal investments pvt ltd',
    'Sambhavana buildprop private limited',
    'Gloster real estates private limited',
    'Ganpati arcade private limited',
    'Suvridhi infracon private limited',
    'Bluemotion awas private limited',
    'Crest realcon private limited',
    'Aegis realtech private limited',
    'Aum construction management services private limited',
    'JASMINN ESTATE DEVELOPERS PRIVATE LIMITED',
    'Manjula projects private limited',
    'Nitkish properties private limited.',
    'Allworth nirman private limited',
    'Murlidhar housing projects private limited',
    'County projects private limited',
    'Innovest ventures private limited',
    'Eighth north ventures private limited',
    'Jeen realtech private limited',
    'Uddhav realtech private limited',
    'NEETLY INDIA PRIVATE LIMITED',
    'Prabha estates pvt ltd',
    'Sidh-vinayaka development private limited',
    'Khemka leasing private limited',
    'Bhasin credit aid limited.',
    'Arcbuild ventures private limited',
    'ROMCO ALUMINATES PRIVATE LIMITED',
    'Nina concrete systems private limited',
    'Kanahi buildcon private limited',
    'Sanya infra structure private limited',
    'Wishtree developers private limited',
    'Angels realtor private limited',
    'Guru nanak overseas co pvt ltd',
    'Noble institute for premier studies and technologies limited',
    'Biznetindia dot com private limited',
    'Lakshya digital private limited',
    'Netxylem info systems private limited',
    'Sova metals & power private limited',
    'Stss traders private limited',
    'Mentor appliances private limited',
    'Perfect (nasik) engineering services private limited',
    'The metal industries ltd',
    'Rekofa small tools pvt ltd',
    'Genesis packaging private limited',
    'Forbes marshall private limited',
    'Rapid punching solutions private limited',
    'MARWAR METALS PRIVATE LIMITED',
    'Aneer engineers private limited',
    'Fleet gaskets india pvt. ltd.',
    'Makson machinery private limited',
    'Memco engineering pvt ltd',
    'Hindustan steel supply company pvt.ltd.',
    'Energized lighting solutions private limited',
    'Rotomac electricals pvt ltd',
    'Rathi copper castings pvt. ltd.',
    'Web infocom services pvt ltd',
    'O e n india ltd',
    'Nucom infotech pvt ltd',
    'U.s. cables private limited',
    'Skan cables and wires private limited',
    'Om suites private limited',
    'Exotic lighting private limited',
    'Prashant electricals limited',
    'G k plastics pvt ltd',
    'Brar india private limited',
    'Pomera and co limited',
    'Punjab transformers and electronics limited',
    'Aone handicraft private limited',
    'Divine electrotech private limited',
    'Alliance components and devices private limited',
    'Mrj infratech private limited',
    'Rosy coils india private limited',
    'Prakant electronics private limited',
    'Vishwa micro processors pvt. ltd.',
    'Orsus (india) private limited',
    'Rabyte electronics private limited',
    'INTELLIEST TECHNOLOGY PRIVATE LIMITED',
    'Land n sky broadcast solutions private limited',
    'ESSITY OPERATIONS GOA LIMITED',
    'BS & B SAFETY SYSTEMS (INDIA) LIMITED',
    'Unissi (india) pvt. ltd.',
    'Healthcare associates private limited',
    'Evan automation private limited',
    'Vadamalai media private limited',
    'Hind elastomers private limited',
    'Stork auto engineering private limited.',
    'Orange cabs private limited',
    'Altius trucks sales & service private limited',
    'Himatsingka trade and agency ltd',
    'V r automobiles private limited',
    'Binwa automobiles & engineering private limited',
    'Burnet pharmaceuticals pvt ltd',
    'Accord distributors private limited',
    'Muller india private limited',
    'Manz india private limited',
    'Skh auto trims private limited',
    'Hanning motors india private limited',
    'Vinko auto industries limited',
    'Ravi auto ltd',
    'Siddharth organizers private limited',
    'Argentum electric vehicles private limited',
    'Elan auto india limited',
    'Compaq international private limited',
    'Pals plush india private limited',
    'Om royal jewels private limited',
    'Arihant manufacturing company pvt ltd',
    'Manvi gems and jewellery private limited',
    'Bharat hydro power corporation limited',
    'Kuber transmissions (india) private limited',
    'Sitac re private limited',
    'Genext green power solutions private limited',
    'Uttarakhand hydro power private limited',
    'Satyam (north east) thermal power limited',
    'Itn solar private limited',
    'VECTOR GREEN SURYA URJA PRIVATE LIMITED',
    'Asun solar power private limited',
    'Azure power ( punjab ) private limited',
    'Evergreen solar systems india private limited',
    'S b electrical projects india private limited',
    'Crystal wind energy private limited',
    'RENOWAB INFRATECH PRIVATE LIMITED',
    'Woodside developments private limited',
    'Excel infratech private limited',
    'Tara buildwell private limited',
    'Prithvee buildwell private limited',
    'Prithvee infratech private limited',
    'Prithvee realtech private limited',
    'Tr asset ventures private limited',
    'Samara infratech private limited',
    'Design worx infrastructure india private limited',
    'VASUDHA REALTECH PRIVATE LIMITED',
    'Hiconhera buildtech private limited',
    'Gayatri infrastructure limited',
    'Osia infrastructure limited',
    'SI HOSPITALITY PRIVATE LIMITED',
    'Pam rose housing and construction private limited',
    'Bharucha & motivala infrastructure private limited',
    'Fabtech infra private limited',
    'Star industrial development company pvt ltd',
    'K.g.b. realtors private limited',
    'Architects atelier pvt ltd',
    'S.M.S PROPERTIES PRIVATE LIMITED',
    'Atulya estate private limited',
    'Blue stone estate pvt. ltd.',
    'Shokeen realtors pvt. ltd.',
    'Dreamland estates private limited',
    'Ozar properties private limited',
    'Trehan infrastructure developers private limited',
    'Pegasus land and housing private limited',
    'Panel consultancy private limited',
    'Standard analytical laboratory n d private limited',
    'Spectro global lab private limited',
    'Sankhya consultants private limited',
    'Jsd search house private limited',
    'Impartial chits pvt. ltd.',
    'MGRATEWORLD CONSULTANTS PRIVATE LIMITED',
    'Suri enterprises private limited',
    'Oak apparels private limited',
    'DURHA PROJECTS INDIA PRIVATE LIMITED',
    'Grand slam overseas pvt ltd',
    'Yuna weddings private limited',
    'Karma fashions private limited',
    'Dassault aircraft services india private limited',
    'Ellbee associates pvt ltd',
    'Cauvery steels private ltd',
    'Bahubali dyes limited',
    'Kunal international limited',
    'Juneja marketing private limited',
    'Chanchal exim private limited',
    'Instyle promoters and builders private limited',
    'O n exim private limited',
    'Hanuman promoters and builders private limited',
    'Impreglam electronics limited',
    'INDO PACIFIC AVIATION PRIVATE LIMITED',
    'Macht technologies private limited',
    'Saroj sarees private limited',
    'WINDOW PASSIONS INDIA PRIVATE LIMITED',
    'Stork rubber products private limited',
    'Srmb dairy farmings private limited',
    'Texco tools private limited',
    'Softline business systemspvt ltd',
    'Rage leasing and construction private limited',
    'Phoenix publishing house private limited',
    'Saxsons biotech private limited',
    'Green fingers (india) private limited',
    'Samara india private limited',
    'Tml investments private limited',
    'Raghvender shanker finance and investment company private limited',
    'Pan business lists private limited',
    'Shakuntala polyfoam private limited',
    'Seaco merchandising private limited',
    'V.m. trading private limited',
    'Kshipra overseas private limited',
    'Taffles exports private limited',
    'B.e.c. conduits private limited',
    'Arlington impex private limited',
    'Screenage consultancy services private limited',
    'Rnv alloy steels private limited',
    'Aaren electra private limited',
    'Ashish emporium private limited',
    'Unique printpack private limited',
    'Dazzles exports private limited',
    'Airawat tours private limited',
    'Gaylord consultancy services private limited',
    'Raj decomats private limited',
    'Bothra finlease private limited',
    'Pacific garments private limited',
    'Financial arm india private limited',
    'Sanger finlease private limited',
    'Perma papers private limited',
    'Rawal acids private limited',
    'Ansun investments limited',
    'Ibe services private limited',
    'Brigantine estate private limited',
    'Advance public publication entertainment affairs relations private limited',
    'Anupriya marketing limited',
    'Kalapano promoters and finance private limited',
    'Medirad tech india limited',
    'Radhika textile mills private limited',
    'ADTEL SOFTWARE PRIVATE LIMITED',
    'Singhal finstock pvt ltd',
    'Tanya pharma private limited',
    'Fujitsu consulting india private limited',
    'Bses rajdhani power limited',
    'Indus environmental services private limited',
    'Easy photo voltech private limited',
    'Creons infrastructure private limited',
    'Valient infotech private limited',
    'Jaygee hospitality services private limited',
    'Dragonfly creations private limited',
    'Tcc paints private limited',
    'Jhankar consultants private limited',
    'Vkj projects private limited',
    'Careways tours and travels private limited',
    'SHEWNARAIAN MAGRAJ FINANCE & INVESTMENTSPRIVATE LIMITED',
    'GOOD LUCK FINANCIAL INCLUSION PRIVATE LIMITED',
    'Trisoft systems private limited',
    'Chase avian communications private limited',
    'An associates engineering private limited',
    'Gcs management solutions india private limited',
    'Three coins properties private limited',
    'WARPDRIVE TECHNOLOGIES PRIVATE LIMITED',
    'Eternal business solutions private limited',
    'Scent trans private limited',
    'MORISON SCV CONSULTING PRIVATE LIMITED',
    'Somany natureal stones india private limited',
    'Paragon apparel private limited',
    'Ava finance private limited',
    'Shahpuri communications private limited',
    'Silverglades holdings private limited',
    'Gautam sehgal & co. private limited',
    'Vertex industries private limited',
    'Raccord systems private limited',
    'System plantations & investments private limited',
    'Uniline electronics private limited',
    'Adrem india private limited',
    'Brand algorithms and solutions private limited',
    'Career reckoner private limited',
    'A.w. properties private limited',
    'Maharaja gourmet services private limited',
    'Viewmore commosales private limited',
    'Unisource exim private limited',
    'Harjivandas mohandas and company-india private limited',
    'MULTIWYN TILES PRIVATE LIMITED',
    'Skipper homes private limited',
    'B sec services limited',
    'Sarveshwari technologies limited',
    'Skcms claim insurance surveyors and loss assessors private limited',
    'Akshara vyapaar pvt ltd',
    'R. s. associates private limited',
    'Navakar trading company private limited',
    'Teikin automotive india private limited',
    'Jagannath sales pvt ltd',
    'Avion dealers private limited',
    'Anamika vincom private limited',
    'Gangotri suppliers private limited',
    'Hindustan portfolio private ltd',
    'THALES DIS CPL INDIA PRIVATE LIMITED',
    'LIXIL WINDOW SYSTEMS PRIVATE LIMITED',
    'Munjral brothers (distribution) private limited',
    'Flashway impex private limited',
    'Skynet mercantiles private limited',
    'Itg exim private limited',
    'Gulab merchandise private limited',
    'Trafigura india private limited',
    'Legend expoevents private limited',
    'Uttam commercial co ltd',
    'Ter commodities trading private limited',
    'Ylda india private limited',
    'Khazana stores private limited',
    'Escorts dealers development association limited',
    'Rajpur infratech private limited',
    'Red brick lane marketing solutions private limited',
    'KARAVALI ENTERPRISES PRIVATE LIMITED',
    'POOVAR AYURVEDA CENTRE AND HOSPITAL PRIVATE LIMITED',
    'Lulu enterprises india private limited',
    'Apurva vinimay private limited',
    'Sidhant enterprises pvt ltd',
    'S & m industrial valves limited',
    'Photo systems (india) private limited',
    'Sitac renewable energy private limited',
    'Arista realtors private limited',
    'Green cube mercantile consultants private limited',
    'Sudeep exim private limited',
    'Dazzle buildwell private limited',
    'Devindu buildcon private limited',
    'Ramjee global realtech private limited',
    'Ellora commotrade pvt. ltd.',
    'RALLI AGROTECH LIMITED',
    'Cubbon marketing pvt.ltd.',
    'Annant shree viniyog pvt. ltd.',
    'Advance mediplus private limited',
    'Vedika exim private limited',
    'Standard rehabilitators private limited',
    'Girijapati dealtrade private limited',
    'Alive merchants private limited',
    'Veer tie-up private limited',
    'Tanishka builders private limited.',
    'Happy brick building private limited',
    'Blooming commodities private limited',
    'Mani buildtech private limited',
    'Sun yug textile private limited',
    'Biorise (india) private limited',
    'B. p. agro foods private limited',
    'Kultali food marketing private limited',
    'Ashish barter private limited',
    'Advika dealers private limited',
    'Motijug agencies ltd',
    'Devghar barter private limited',
    'Global exports ltd',
    'R d mercantiles private limited',
    'Ss aamouage trading private limited',
    'Rajiv export industries pvt ltd',
    'Jamirah vyapar udyog ltd',
    'Shree raj international pvt. ltd.',
    'Linkwise dealtrade private limited',
    'Fort advisory services private limited',
    'Kr mercantiles pvt ltd',
    'Nci cable private limited',
    'Strong marketing private limited',
    'Amodar commodeal private limited',
    'Blockdeal agency private limited',
    'Jagmata sales private limited',
    'Newtech dealtrade private limited',
    'Swift wholwsellers private limited',
    'Sankatsathi distributors private limited',
    'Snowball dealers private limited',
    'Madhudhan barter private limited',
    'NAKSHI CREATIONS PRIVATE LIMITED',
    'Smart nutrition products private limited',
    'S s a t commodities private limited',
    'Oversure enterprises private limited',
    'Orikam healthcare india private limited',
    'Goodpoint dealers private limited',
    'Sankatharan marketing private limited',
    'Sakaar tradelinks private limited',
    'Vasundhara retailers (india) private limited',
    'Skipper textiles pvt ltd',
    'Chocolate retail private limited',
    'Landscape vinimay private limited',
    'Sathe and company private limited',
    'Madan traveller guest house private limited',
    'Tricolor hotels limited',
    'Bright hospitality private limited',
    'Baani hospitality services private limited',
    'Palm land hospitality private limited',
    'Iora hotels private limited',
    'Prinia hotels private limited',
    'Moonlight dealtrade private limited',
    'Zambala hotel & restaurants private limited',
    'Naora hospitality private limited',
    'Gemini dealtrade private limited',
    'TAXINDIAINTERNATIONAL.COM PRIVATE LIMITED (OPC)',
    'Greenstar landscape private limited',
    'SAMRIDH IMPACT SOLUTIONS PRIVATE LIMITED',
    'GINGLANI DISTILLERS PRIVATE LIMITED',
    'CSEP RESEARCH FOUNDATION',
    'Grow talent company limited',
    'Radical scientific equipments private limited',
    'K C ENGINEERS LIMITED',
    'Paperklips business solutions private limited',
    'Kims nagercoil institute of medical sciences private limited',
    'Minar hydrosystems private limited',
    'Toyota enterprise india private limited',
    'Akruti commotrade private limited',
    'Bhanu vinimay private limited',
    'Sree sumangala metals and industries private limited',
    'M sankar trading and consultancy private limited',
    'Murari barter private limited',
    'Dugar diamond trading private limited',
    'Decalogue communications private limited',
    'Chetan exim limited',
    'Parvati tie up private limited',
    'Jagkarta electricals private limited',
    'Goa state infrastructure development corporation limited',
    'JAJPUR CLUSTER DEVELOPMENT - NIMZ',
    'Protrack education private limited',
    'Raghuveer commotrade private limited',
    'Bhanu tradelink private limited',
    'Abbey west services private limited',
    'VISION ONE INFORMATION AND ADVISORY PRIVATE LIMITED',
    'Sarva educational institution private limited',
    'VASAL EDUCATIONAL GROUP PRIVATE LIMITED',
    'Hyderabad educational academy private limited',
    'Britti prosikshanprivate limited',
    'KULDHARA VENTURES PRIVATE LIMITED',
    'Vabri math private limited',
    'Adi finshiksha consultants private limited',
    'Teoler education services private limited',
    'Madhusala distilleries private limited',
    'South west construction private limited',
    'Koncept eduinfra tech services private limited',
    'Dna diagnostic centre private limited',
    'Navin hospitals private limited',
    'Ushanak sons pvt ltd',
    'Akna management solutions private limited',
    'New age rehabilitation centre private limited',
    'Tiger manpower resources private limited',
    'Primus health care private limited',
    'UGH VINTAGE HOSPITAL AND MEDICAL RESEARCH CENTRE PRIVATE LIMITED',
    'Yenepoya logistics private limited',
    'Kims kollam multi speciality hospital india private limited',
    'SPARSH OPTIMUM HEALTHCARE PRIVATE LIMITED',
    'Shanti memorial hospital private limited',
    'Amritsar scanomed pvt ltd',
    'Green park hospitality services private limited',
    'CUREWELL PACKAGING PRIVATE LIMITED',
    'SUDAMO IMPEX PRIVATE LIMITED',
    'Dispur ct and imaging centre private limited',
    'Solapur diagnostics private limited',
    'Sanya hospital and diagnostics private limited',
    'Dcdc health services private limited',
    'London house drycleaners india private limited',
    'KARUR TEXTILES DESIGN CENTRE PRIVATE LIMITED',
    'Vskb consultants private limited',
    'The associated chambers of commerce and industry of india',
    'Chhankata entertainment private limited',
    'NOWNOW DIGITAL INDIA PRIVATE LIMITED',
    'Srijan arts private limited',
    'Copal art private limited',
    'Parkash amusement private limited',
    'Red entertainment private limited',
    'Veritus media services private limited',
    'Delhi united sports private limited',
    'Dhillon brothers private limited',
    'Qutab entertainment private limited',
    'Kasper consulting private limited',
    'Mindmap advance research private limited',
    'Sphere equipments private limited',
    'Corporate transaction advisory private limited',
    'Dealsothon online private limited',
    'Authorsupfront publishing services private limited',
    'Radiance consultancy services private limited',
    'Famcom labs private limited',
    'Anant hydel project private limited',
    'Grassik consultants private limited.',
    'Aureus marketing services private limited.',
    'Nng import export private limited.',
    'Meesan logistics private limited',
    'Lunar enterprise private limited',
    'Nek consultants private limited',
    'Ecospace projects private limited',
    'Assam company india limited',
    'The waterbase limited',
    'Ncc blue water products ltd.',
    'NAYARA ENERGY LIMITED',
    'Aishani training and research private limited',
    'Soni rubber products ltd',
    'Kitply industries limited',
    'Hindusthan national glass & industries limited',
    'Yenepoya minerals and granites limited',
    'Jotindra steel and tubes limited',
    'MINSOL LIMITED',
    'India containers ltd',
    'Eimco elecon (india ) limited',
    'Intense technologies limited',
    'Emco limited',
    'Ifb industries ltd',
    'L m j services ltd',
    'AGI GREENPAC LIMITED',
    'Dalmia laminators ltd',
    'Dhp india limited',
    'Subhbijay distributor private limited',
    'Kishaloy agencies private limited',
    'Fivestar dealcom private limited',
    'Talland suppliers private limited',
    'Bhagyashri home appliances private limited',
    'Ranisatidadi distributors private limited',
    'Shyamal dealtrade private limited',
    'Bakys enterprises private limited',
    'Protogreen retail solutions private limited',
    'Presidency medical centre pvt ltd',
    'Safa gold alanallur private limited',
    'Hykart sales private limited',
    'Midas touch global private limited',
    'Thankys exports pvt ltd',
    'LULU INTERNATIONAL SHOPPING MALLS PRIVATE LIMITED',
    'Vision tradesolutions (india) private limited',
    'BHIM INDUSTRIES PRIVATE LIMITED',
    'Manish co pvt ltd',
    'Pakhi sales private limited',
    'Tanvi tradecom private limited',
    'Tanvi tie-up private limited',
    'Arjun dealers private limited',
    'Jagmata marcom private limited',
    'Suvridhi commotrade private limited',
    'Neelgagan dealers private limited',
    'SAXON PROPERTIES & INVESTMENTS PVT LTD',
    'Lighting industries pvt ltd',
    'Alkharsh international private limited',
    'Surabhi enterprises private limited',
    'Anamika agencies private limited',
    'Vinayak ancillaries tradex private limited',
    'Tutex trade & investments limited',
    'Dexune marketing private limited',
    'Chipmonks private limited',
    'Subhlakshmi commosales private limited',
    'Smart brands products private limited',
    'Slr retailers private limited',
    'D.pauls travel & tours limited',
    'INDO-BERG PRIVATE LIMITED',
    'Zeesora mercantile private limited',
    'Goodview trading private limited',
    'Swastika commosales private limited',
    'Musee musical private limited',
    'Coastline gourmet private limited',
    'Pinata services private limited',
    'Credxl ventures private limited',
    'Omaxe retail limited',
    'Zuma consumables private limited',
    'C l sharma resorts private limited',
    'Mga lifestyle private limited',
    'Peace channels dalhousie resorts private limited',
    'Welgrow hotels concepts private limited',
    'Integrated hotels private limited',
    'Sankatsathi commodities private limited',
    'Ammtys multicuisine private limited',
    'Mandovi hotels private limited',
    'De souza hotels private limited',
    'Satsanga retreat private limited',
    'Neelgagan suppliers private limited',
    'Mahamani commodeal private limited',
    'MOTHER',
    'S SPECIALITIES PRIVATE LIMITED',
    'Hella india lighting limited',
    'Sethia oils ltd',
    'Voith paper fabrics india limited',
    'Bhogali foods products private limited',
    'Shineroad foods (india) private limited',
    'TVS ORGANICS PRIVATE LIMITED',
    'Universal spices private limited',
    'Asian consulting engineers private limited',
    'Prime liquors and leasing private limited',
    'ETICO VENTURES PRIVATE LIMITED',
    'Mehar farms private limited',
    'Prabha farms pvt ltd',
    'Yuvak fine fab limited',
    'Jindal medicot limited',
    'Jindal specialty textiles limited',
    'Chiripal textile mills private limited',
    'Lochan agro pvt. ltd.',
    'Fortune mall private limited',
    'Pine drive resorts private limited',
    'Burman resorts private limited',
    'Saffron hospitality private limited',
    'Manikala vyapaar private limited',
    'Msm hospitality services private limited',
    'Laxmiwan shoppers private limited',
    'Madhurashi shoppers private limited',
    'Playwell impex private limited',
    'Heartlink medical solutions private limited',
    'Tapovan marketing private limited',
    'Massive restaurants private limited',
    'West park hotels & spa private limited',
    'Aditya trademart specialities private limited',
    'Mangalsudha dealers private limited',
    'Anu associates impex private limited',
    'Hari regency private limited',
    'BOBBA LOGISTICS PRIVATE LIMITED',
    'Parineetta resorts private limited',
    'Hotel gaudavan private limited',
    'Basant vihar hotels private limited',
    'Cmm logistics private limited',
    'Sjs gold private limited',
    'Francis alukkas live gold private limited',
    'Rutt deen pvt ltd',
    'Kaizen hotels & resorts limited',
    'Global hunt overseas private limited',
    'Queen dealers private limited',
    'Vogue crafts & designs private limited',
    'Auto wings sales services solapur pvt ltd',
    'Global infra and minerals private limited',
    'Ugo logistics private limited',
    'Sra hotel & resorts private limited',
    'Freightstar private limited',
    'Chandraprabhu hospitality private limited',
    'Viraj garments private limited',
    'Yashica shipping agencies private limited',
    'Sagar offshore shipping services private limited',
    'Air one aviation private limited',
    'Aircraft search & aviation professionals private limited',
    'Gsm tours & logistics (india) private limited',
    'TRAVSTARZ HOLIDAY & DESTINATIONS PRIVATE LIMITED',
    'Vandana air travels private limited',
    'Sanghi motors (bombay) private limited',
    'Fairdeal automobiles private limited',
    'Better power services private limited',
    'Shine express india private limited',
    'Shubham logistics private limited',
    'HIND ICE & COLD STORAGE PVT LTD',
    'Nbs exports pvt ltd',
    'M.b.apparels private limited',
    'Kandla warehouse and logistics private limited',
    'Syndicate freight private limited',
    'Ascension hotels private limited',
    'Beach heritage inn private limited',
    'Cannanore county club and resorts private limited',
    'Carewell movers private limited',
    'Bsc- c and c- kurali toll road limited.',
    'Prakriti inbound private limited',
    'ENVIRO GREEN RESOURCES PRIVATE LIMITED',
    'Tlc-travel and leisure consultants private limited',
    'Gati import export trading limited',
    'Kvm air cargo private limited',
    'Ij dream vacation private limited',
    'THRILLOPHILIA TRAVEL SOLUTIONS PRIVATE LIMITED',
    'Travel house pvt ltd',
    'Pax travels pvt.ltd.',
    'Radhika express private limited',
    'Seaport trans liner services pvt ltd',
    'Ipf logistics private limited',
    'Relayte world travel (india) private limited',
    'Will marine container service private limited',
    'Kutch carrier private limited',
    'Libra steamship care private limited',
    'Natchart private limited',
    'Bodhgaya guest house private limited',
    'Shree jee celebrations private limited',
    'Newport express services private limited',
    'Ocean & air speed private limited',
    'Vas logistics private limited',
    'B.s. freight channel private limited',
    'Jumbo courier company private limited',
    'Rajdhani air express private limited',
    'Asian fast food services private limited',
    'Boro boro respect hotels private limited',
    'Kondody hotels and resorts india private limited',
    'Keer hotels private limited',
    'Su-kam power systems limited',
    'Ramani hotels limited',
    'Channel five cable network private limited',
    'Nawa hotels and resorts private limited',
    'Ujjwal luxury hotels private limited',
    'Cc fine foods south india private limited',
    'Panam holidays and resorts private limited',
    'Katha tours and travels private limited',
    'Swift world limited',
    'Tourism india management enterprise private limited',
    'M.r. holiday mystique private limited',
    'Ambassador holidays india private limited',
    'On way transport india private limited',
    'Kasa capital & finance private limited',
    'Leela capital and finance limited',
    'J b savings and finance private limited',
    'Bihari hire purchase pvt ltd',
    'RAINTREE COMPUTING PRIVATE LIMITED',
    'South assam carriers pvt ltd',
    'Mex storage systems private limited',
    'Narayan power tech private limited',
    'Cani merchandizing pvt ltd',
    'Mnv traders private limited',
    'Standard & poors south asia services private limited',
    'Indian motor sports association',
    'Ess aar universal private limited',
    'Caliber human resources private limited',
    'Metaphor exports private limited',
    'Aec education private limited',
    'Uma medicare limited.',
    'Indus fatehgarhsahib hospital private limited',
    'Rdh engineers private limited',
    'DR. SHAJI',
    'S RUBBER & SYNTHETIC PVT. LTD.',
    'Prime green media private limited',
    'Micro management ltd',
    'Mallelil polymers private limited',
    'Nibber castings private limited',
    'Imi alloys private limited',
    'Sri jayalakshmi ferro alloys private limited',
    'K d cosultancy services pvt ltd',
    'Acg ajas components private limited',
    'Tal manufacturing solutions limited',
    'Manu enterprises limited',
    'A j drill tech engineering co. private limited',
    'Navneet stationers private limited',
    'Domnick hunter india private limited',
    'Commscope solutions (india) private limited',
    'Popular wheelers private limited',
    'S and a associates private limited',
    'White saffron grains private limited',
    'Kog-ktv food products (india) private limited',
    'Transcontinental healthcare private limited',
    'Jasud extrusions pvt ltd',
    'Sugnaneshwara hydel power private limited',
    'Gmr power corporation limited',
    'Jaintia hills power limited',
    'VTV INFRASTRUCTURE MANAGEMENT PRIVATE LIMITED',
    'Wellpoint systems private limited',
    'A.P.S. FOODS PRIVATE LIMITED',
    'Arcon (india) private limited',
    'Kalakriti overseas private limited',
    'VISMAY BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Inteq software private limited',
    'Harimarkatamarkata business private limited',
    'Safe touch marine private limited',
    'Axis risk consulting services private limited',
    'IDEAL CABLES LIMITED',
    'Vibodh developers private limited',
    'Dr. patel metropolis healthcare private limited',
    'Fountain entertainment private limited',
    'Knowin consultancy limited',
    'Utalika vintrade limited',
    'Synergy vintrade private limited',
    'Utsav suppliers private limited',
    'Shankar silk mills private limited',
    'Speed tex private limited',
    'Raj metropolis healthcare private limited',
    'Zentek export engineering private limited',
    'Nanda ispat pvt ltd',
    'Lakeview sales private limited',
    'GOLDUST CONSULTING SERVICES PRIVATE LIMITED',
    'Shyamsteel energy private limited',
    'Vkarma capital investment management company private limited.',
    'Hurtado home decor private limited',
    'Atlantic agencies private limited',
    'Nagra media private limited',
    'Avaneesh dealmark private limited',
    'Aryadeep tradelink private limited',
    'Wallace medinova private limited',
    'ANDORI COOLING INDIA PRIVATE LIMITED',
    'Speciality resorts private limited',
    'SOUTHERN ROADWAYS PRIVATE LIMITED',
    'JAYEM CAPOP TRACK PRIVATE LIMITED',
    'ESSEL FINANCE WEALTH ZONE PRIVATE LIMITED',
    'Aravali niwas private limited',
    'Nilima real estate developers private limited',
    'Success monks performance consulting private limited',
    'Sesame schoolhouse private limited',
    'Inde global advisory private limited',
    'Harita seating systems limited',
    'WELSPUN TRADEWEL LIMITED',
    'Vardhman industries limited',
    'Gateway distriparks ltd.',
    'Green acre agro services private limited',
    'Zen comtrade private limited',
    'Sri santhini exports private limited',
    'Bhagawati steels private limited',
    'Rajhans vegetable oil refinery private limited',
    'Ayusha dairy private limited',
    'Vestergaard asia private limited',
    'Rajpal cotton industries private limited',
    'Sasthi vyapaar private limited',
    'Hidimba trading private limited',
    'Creative stylo packs private limited',
    'Mrg publication private limited',
    'Reliance aromatics and petrochemicals limited',
    'Finekem laboratories private limited',
    'Vector bio sciences private limited',
    'Bovian health care private limited',
    'Professional games club private limited',
    'Gaurav chemicals (india) private limited',
    'RAYMOND CONSUMER CARE PRIVATE LIMITED',
    'SUDHAKAR POLYMERS Private Limited',
    'Gurushanti finance private limited',
    'Psr projects & constructions (india) private limited',
    'GOLDCREST SOLUTIONS PRIVATE LIMITED',
    'SEA-HAWK TRADING PRIVATE LIMITED',
    'Lavina contractors and developers private limited',
    'Akshnishit investment and trading private limited',
    'Ratnakar stock brokers private limited',
    'SOUND INVESTMENT COMPANY PRIVATE LIMITED',
    'Dvk investments private limited',
    'Universal infraworld private limited',
    'Carnival properties private limited',
    'Crg trading & finvest pvt ltd',
    'Ambattur developers private limited',
    'Paras trend height setters private limited',
    'Surabhi agencies pvt.ltd.',
    'Esplanade developers private limited',
    'Acropolis developers private limited',
    'Radhey buildcon private limited',
    'Fliessen real estates private limited',
    'Veear property developers (bombay) private limited',
    'Axis infoway (india) private limited',
    'Avin infotech private limited',
    'Principalsoft technologies private limited',
    'APPIRIO INDIA CLOUD SOLUTIONS PRIVATE LIMITED',
    'Emerald jewellery retail limited',
    'Arkinnet software private limited',
    'Onward eservices limited',
    'Firiri films private limited',
    'ADK PRINTKRAFT PRIVATE LIMITED',
    'Deepak agro solutions limited',
    'Madaus pharmaceuticals private limited',
    'Gsb refractories india private limited',
    'Jashvil engineering private limited',
    'Priority gold private limited',
    'Coroshield equipment private limited',
    'Skf technologies (india) private limited',
    'RADIANT CPC SOLUTIONS INDIA PRIVATE LIMITED',
    'Moscow region podar international private limited',
    'Rotamic hydraulics private limited',
    'Trilok ship breakers ltd',
    'Harsha engineers (india) private limited',
    'Geeken comfort solution limited',
    'Neptune electricals private limited',
    'Adani power maharashtra limited',
    'Mega airways limited',
    'Adani power rajasthan limited',
    'Brindaban agro industries private limited',
    'Bhilori agro pvt ltd',
    'Excelsior construction private limited',
    'Elogic design solution (india) private limited',
    'Vidur constructions private limited',
    'Aspen infrastructures limited',
    'Sensys buildcon private limited',
    'Govind properties pvt ltd',
    'Arcons realtors private limited',
    'Makaan.com private limited',
    'Edrea developers private limited',
    'Castor developers private limited',
    'Valmark projects (india) private limited',
    'Crest realtech private limited',
    'Agnes developers private limited',
    'Advance composites private limited',
    'P v s infotech private limited.',
    'Impartus innovations private limited',
    'Intel mobile communications india private limited',
    'One source technologies private limited',
    'Virtunex technologies private limited',
    'Automotive exchange private limited',
    'MINDA TELEMATICS AND ELECTRIC MOBILITY SOLUTIONS PRIVATE LIMITED',
    'Malladi industries private limited',
    'Regal rubber private limited',
    'Kothari prima private limited',
    'Stec stainless steel private limited',
    'Scope private limited',
    'MAGNA AUTOMOTIVE INDIA PRIVATE LIMITED',
    'SUNDRAM PRECISION COMPONENTS LIMITED',
    'Intelligent conveyors and stackers pvt ltd',
    'LEDOS LIGHTING PRIVATE LIMITED',
    'Tandem machines private limited',
    'Cmos instruments private limited',
    'Mega rubber products private limited',
    'Udupi power corporation limited',
    'Asco numatics (india) private limited',
    'Vadinar oil terminal limited',
    'Jewelmark india private limited',
    'Aakruti gems private limited',
    'Linc writing aids pvt ltd',
    'SREE VALMIKI EDUCATION MANAGEMENT PRIVATE LIMITED',
    'Villa capri estates pvt ltd',
    'Sambhav shelters private limited',
    'Srushti erectors & developers private limited',
    'Sulalit builders private limited',
    'Dipali organisor private limited',
    'Kaunteya builders private limited',
    'Gujarat home development corporation private limited',
    'Chowgule ports & infrastructure private limited',
    'Abhinay trading private limited',
    'Anant intercontinental private limited',
    'Natural resources consulting private limited.',
    'Realty consultants private limited',
    'Rewnee viniyog private limited',
    'Ernst & young merchant banking services private limited',
    'Parinati solutions private limited',
    'Star narrow fabrics india private limited',
    'Pricepoint concept consultancy private limited',
    'Kamdhenu infradevelopers limited',
    'Sri sharadamba properties limited',
    'Rkb marketing private limited',
    'A plus education solutions private limited',
    'JHS SVENDGAARD BRANDS LIMITED',
    'Sidhidatri tradevin private limited',
    'Tejaswini finvest private limited',
    'ONE SGG VENTURES PRIVATE LIMITED',
    'Kamdhenu nutrients private limited',
    'Lenox india private limited',
    'Apdl estates limited',
    'Valerian hospitality and hotels private limited',
    'Shama & shiva hotels private limited',
    'Shakti cargomovers private limited',
    'SUNCITY ALLOYS PRIVATE LIMITED',
    'International iron and alloys private limited',
    'Kroner investments limited',
    'Brevini india private limited',
    'Newelco india private limited',
    'Goldman sachs trustee company (india) private limited',
    'Shubhlaxmi casting private limited',
    'Hrishikesh investments private limited',
    'Atr india customer support private limited',
    'Goodwill comtrades private limited',
    'Yati developers private limited',
    'Infinity diamond harbour projects private limited',
    'Goa beach estate private limited',
    'KOTHARI PREMISES PRIVATE LIMITED',
    'Golden goose realtors limited',
    'Cds infra limited',
    'E-zest solutions limited',
    'Augustan textile colours private limited',
    'Divi mines & minerals private limited',
    'Asl prefab structures private limited',
    'Tt techno park management services india private limited',
    'Shiv shakti healthcare private limited',
    'Dynavista industries private limited',
    'Laguna clothing private limited',
    'Gokaldas intimatewear private limited',
    'Karur goldline exports private limited',
    'Vishwas footwear company limited',
    'RAKETM WIRELESS TECHNOLOGIES PRIVATE LIMITED',
    'Manne laboratories private limited',
    'Perlcon premix private limited',
    'Curatio health care (i) private limited',
    'Precision plastics (india) private limited',
    'WELLPET POLYMERS PRIVATE LIMITED (OPC)',
    'Yamuna cement and minerals private limited',
    'TUF INDIA LIMITED',
    'CERATIZIT India Round Tool Solutions Private Limited',
    'Utkal electricals pvt limited',
    'Kalinga fixtures private limited',
    'Vodafone india limited',
    'Sterlite power grid ventures limited',
    'Impact automotive solutions limited',
    'Continental sourcing private limited',
    'Red box rewards india private limited',
    'Emini hydro power private limited',
    'Caparo renewables limited',
    'MATRIX DEVELOPERS LIMITED',
    'Funcity estates private limited',
    'Futuristic call solutions private limited',
    'H g realtors private limited',
    'Paras retail private limited',
    'Al shifa scan centre private limited',
    'Bhumika business private limited',
    'Demach software india private limited',
    'S-cube futuretech private limited',
    'Jaiveek agro biotech private limited',
    'PATEL CONCRETE & QUARRIES PRIVATE LIMITED',
    'Piramal texturising pvt ltd',
    'Shiana impex private limited',
    'Dialforhealth india limited',
    'Sapa precision tubing pune private limited',
    'V s metacast private limited',
    'Texcel international private limited',
    'MINDA RINDER PRIVATE LIMITED',
    'Ensave devices private limited',
    'MOTION DYNAMIC PRIVATE LIMITED',
    'Kasco environmental systems private limited',
    'Jbm auto system private limited',
    'Green infra wind ventures limited',
    'Kiran energy solar power private limited',
    'Ankit dyes & intermediates private limited',
    'Utkal fans pvt ltd',
    'Delhi cleantech services private limited',
    'Maples imaging solution private limited',
    'Ramky reclamation and recycling limited',
    'Ikm commodities private limited',
    'Ramky e-waste management limited',
    'Ht learning centers limited',
    'Bhubaneswar industrial waste management (orissa) private limited',
    'Saloo investments and consultants limited',
    'Sunder biotech private limited',
    'John crane flexibox (india) private limited',
    'ADANI GAS HOLDINGS LIMITED',
    'Rain fruits and more private limited',
    'J m commodities limited',
    'Kesh ganga tex private limited',
    'Esjay plastomers private limited',
    'GUJARAT AGROCHEM PRIVATE LIMITED',
    'AMARJYOT CHEMICAL Limited',
    'Harvis pharm private limited',
    'Astral remedies private limited',
    'Tarapur vastra udyog private limited',
    'Manjunath tyresoles treads private limited',
    'Enembee engineers pvt. ltd.',
    'CHEMICORP SPECIALITIES INDIA PRIVATE LIMITED',
    'Hc hydraulic technologies private limited',
    'Razorinsights technology private limited',
    'Spoton software private limited',
    'Aquarius financial consultants private limited',
    'Skp e-solutions private limited',
    'Della design private limited',
    'Verizon india private limited',
    'Signature portfolio private limited',
    'Advene exim private limited',
    'Sunbury realities private limited',
    'Sunteck fashions & lifestyles private limited',
    'Nucleus it enabled services limited',
    'Fox star studios india private limited',
    'Tea time limited',
    'Orient international limited.',
    'Neptune exports limited',
    'TATA STEEL BSL LIMITED',
    'Goldking crop care private limited',
    'Crown chemicals pvt ltd',
    'Gland celsus bio cheicals private limited',
    'Ramdev chemical private limited',
    'Doc n cliq pharmaceutici private limited',
    'Medo specia pharma private limited',
    'Cornutum india private limited',
    'Zuari commodity trading limited',
    'MFS FORMWORK SYSTEMS PRIVATE LIMITED',
    'Adlec power private limited',
    'Elmatic technologies private limited',
    'Rupal textile private limited',
    'Magnum farms private limited',
    'Sahuwala high pressure cylinders private limited',
    'Lucrative fashions private limited',
    'Zivene design and development private limited',
    'EDIT DESIGNS PRIVATE LIMITED',
    'DEEJAY MINING & EXPORTS PRIVATE LIMITED',
    'Ven-tech private limited',
    'AVIOR CONTROL SYSTEMS PRIVATE LIMITED',
    'Spark autovision private limited',
    'OPTUMINSIGHT INDIA PRIVATE LIMITED',
    'Starlite printers private limited',
    'Delta power solutions india private limited',
    'Ina bearings india private limited',
    'Tcg jewelry private limited',
    'Reyami - millennium interiors private limited',
    'Sri power generation (india) private limited',
    'Tulip hospitals private limited',
    'Mileage real estates private limited',
    'Domeo properties private limite',
    'Viloma equity services private limited',
    'Pranavaditya spinning mills limited',
    'Monachem additives private limited',
    'Addpol chemspecialities private limited',
    'Mantri plast pvt. ltd.',
    'Tuscany ceramiche private limited',
    'Murugan fabs private limited',
    'Vegetal exim private limited',
    'Parmes diamonds exports private limited',
    'Piramal renewable energy private limited',
    'Vijaylaxmi developers private limited',
    'Prabhat homes private limited',
    'Sabar real estate private limited',
    'Hansazone private limited',
    'Concept commodities private limited',
    'Rotomac dealers pvt. ltd',
    'N v techno services private limited',
    'Shaktidham industries private limited',
    'Sheshadri textiles private limited',
    'Phoenix dealers private limited',
    'Odeon theatres and properties private limited',
    'Snehanjali solutions private limited',
    'Sunshine exports diamonds private limited',
    'Outshine villas private limited',
    'Passionate investment management private limited',
    'Sierra management services private limited',
    'Panasia infrastructure management services private limited',
    'Scale ventures private limited',
    'Unicel technologies private limited',
    'BE POSITIVE PRODUCTIONS PRIVATE LIMITED',
    'Purple diamond private limited',
    'Indigo diamond private limited',
    'LALCHAND PHULCHAND AND SONS ENTERPRISES PRIVATE LIMITED',
    'VISCOM MACHINE VISION (INDIA) PRIVATE LIMITED',
    'AIOPSGROUP COMMERCE INDIA PRIVATE LIMITED',
    'GUTURI MARKETING PRIVATE LIMITED',
    'CASASTYLE INDIA PRIVATE LIMITED',
    'FP INFINITY PRIVATE LIMITED',
    'DNTHIDE PRIVATE LIMITED',
    'SRI PARSHVA PHARMA DISTRIBUTORS PRIVATE LIMITED',
    'RIKHAB DAS JAIN FOUNDATION',
    'GILDED TECHNOLOGIES PRIVATE LIMITED',
    'VALIANT FINTECH PRIVATE LIMITED',
    'FP KRATOS PRIVATE LIMITED',
    'SUGEE.IO PRIVATE LIMITED',
    'EDMYST NEW HORIZONS PRIVATE LIMITED',
    'MINDFUL OFFICIAL SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'PROPIXEL TECHNOLOGIES PRIVATE LIMITED',
    'SOCIORAC ONLINE PRIVATE LIMITED',
    'GREEN INFRA SOLAR GENERATION LIMITED',
    'BHAKTI CARES FOUNDATION',
    'RARE & PURE SPECIALITIES PRIVATE LIMITED',
    'FUGENIX TECHNO LABS PRIVATE LIMITED',
    'HAIGREVE DIGITAL PRIVATE LIMITED',
    'KEFI HEALTHCARE PRIVATE LIMITED',
    'TESHA LIFESTYLE PRIVATE LIMITED',
    'HEARTLAND PHARMACY (OPC) PRIVATE LIMITED',
    'PALM TREE ENGINEERING PRODUCTS PRIVATE LIMITED',
    'A3 INDIA RETAILS PRIVATE LIMITED',
    'FINVERSE BUSINESS ADVISORS PRIVATE LIMITED',
    'STANTECH SOLUTIONS PRIVATE LIMITED',
    'AMICA PAYMENT SERVICES PRIVATE LIMITED',
    'ALKATEL COMMUNICATIONS PRIVATE LIMITED',
    'RETAINIQ INDIA PRIVATE LIMITED',
    'DIGITALI360 AD AGENCY PRIVATE LIMITED',
    'ITORIX SOFTWARE PRIVATE LIMITED',
    'MONEYMILE MARKETING SERVICE PRIVATE LIMITED',
    'PTERYGO ENTERPRISES PRIVATE LIMITED',
    '4E LEARNING SOLUTIONS PRIVATE LIMITED',
    'BARENTZ INDIA PRIVATE LIMITED',
    'DATAINTELO CONSULTING PRIVATE LIMITED',
    'IMMERIA BATH PRIVATE LIMITED',
    'ECLIPTON TECHNOLOGIES PRIVATE LIMITED',
    'MAHTARI LOVE FOUNDATION',
    'MOLITECH SOLUTIONS PRIVATE LIMITED',
    'PEIMAR INDIA PRIVATE LIMITED',
    'PREMIUM HOME DEVELOPERS PRIVATE LIMITED',
    'DOOBH PRIVATE LIMITED',
    'EQUILIB FOUNDATION',
    'RED PANDA LIFESTYLE PRIVATE LIMITED',
    'SADBHAV SUPPLY CHAIN PRIVATE LIMITED',
    'ARAMCO FOOD AND BEVERAGES PRIVATE LIMITED',
    'BXGC PRIVATE LIMITED',
    'CONTENTOCEAN INFOTECH PRIVATE LIMITED',
    'SECPOSTRONIX PRIVATE LIMITED',
    'GURUNATH CONSTRUCTIONS AND PROMOTERS PRIVATE LIMITED',
    'FUNDSMAP PRIVATE LIMITED',
    'KAB NIVAS PRIVATE LIMITED',
    'PREQIN INDIA PRIVATE LIMITED',
    'KAB NIKETAN PRIVATE LIMITED',
    'PRUDENCE EXIM PRIVATE LIMITED',
    'BOLIVE HEALTHCARE PRIVATE LIMITED',
    'HSPS SERVICES PRIVATE LIMITED',
    'GLAZEVIEW PRIVATE LIMITED',
    'DIVIT GLOBALL UDYOG PRIVATE LIMITED',
    'MODAIR EXPRESS PRIVATE LIMITED',
    'SIX BY SIX COMMUNICATIONS PRIVATE LIMITED',
    'PRR PROPERTIES PRIVATE LIMITED',
    'ADTECHX MEDIA PRIVATE LIMITED',
    'MILKY SECURITIES PRIVATE LIMITED',
    'PUNYAM ACADEMY PRIVATE LIMITED',
    'ZUMBOBUY TECH PRIVATE LIMITED',
    'WELVIZ BIOTECH PRIVATE LIMITED',
    'HIGHPEAK VENTURES PRIVATE LIMITED',
    'BP NIKETAN PRIVATE LIMITED',
    'SEKHAR FOUNDATION',
    '1EOR GLOBAL PRIVATE LIMITED',
    'PERKS INSTITUTE OF SECURITY AND FACILITYMANAGEMENT PRIVATE LIMITED',
    'STRIVEAPP TECHNOLOGIES PRIVATE LIMITED',
    'BRACHEIUM BRAND TECHNOLOGIES PRIVATE LIMITED',
    'AMPSZ ENTERPRISES PRIVATE LIMITED',
    'ANSKALON LIFESTYLE PRIVATE LIMITED',
    'SIGNUP ENTERPRISE PRIVATE LIMITED',
    'E-ASHWA AUTOMOTIVE (CHENNAI) PRIVATE LIMITED',
    'AUDIENCESTREET PRIVATE LIMITED',
    'ROSEPLEX PROJECTS PRIVATE LIMITED',
    'HUMANITYUPLIFTINGMANKIND FOUNDATION',
    'CLICKTECH RETAIL PRIVATE LIMITED',
    'PRESTIGE BETA PROJECTS PRIVATE LIMITED',
    'NIDUSOFT SOLUTIONS PRIVATE LIMITED',
    'CLEAN AF INDIA FOUNDATION',
    'SRPSC INDIA PRIVATE LIMITED',
    'WHIZLANCER INFOTECH PRIVATE LIMITED',
    'INNOWERX MANUFACTURING SERVICES PRIVATE LIMITED',
    'HEALTHY LIFE FARMS PRIVATE LIMITED',
    'ANGEL ONE LIMITED',
    'A. K. MEGA ELECTRONICS LIMITED',
    'ASTBERG VENTILATION PRIVATE LIMITED',
    'ML NIVAS PRIVATE LIMITED',
    'BRAR SPIRITUAL & CULTURE FOUNDATION',
    'RVB ENCLAVE PRIVATE LIMITED',
    'TRAQEZ PRIVATE LIMITED',
    'RARIKO TECHNOLOGIES PRIVATE LIMITED',
    'ORIM ADVISORS PRIVATE LIMITED',
    'BITCOT TECHNOLOGIES PRIVATE LIMITED',
    'ISANTE AGRI PRIVATE LIMITED',
    'ACHRAY SOLUTIONS PRIVATE LIMITED',
    'PATAAREE STUDIOS PRIVATE LIMITED',
    'ZEAL WAREHOUSING & TRANSPORTATION PRIVATE LIMITED',
    'BODHI NIRVAN PRIVATE LIMITED',
    'APS INSTALLATION SERVICES PRIVATE LIMITED',
    'NAVAMANI AGRO PRIVATE LIMITED',
    'SSA HUMAN CONSULTING PRIVATE LIMITED',
    'TEKHSOL IOT SOLUTIONS PRIVATE LIMITED',
    'DR AMEES LAB (OPC) PRIVATE LIMITED',
    'ENGIMA PREMISES PRIVATE LIMITED',
    'INCOBIST INDIA PRIVATE LIMITED',
    'RECCLOUD TECHNOLOGIES PRIVATE LIMITED',
    'TRIGYA INNOVATIONS INDIA PRIVATE LIMITED',
    'LORDS MARK INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'VILLATIC FOODS AND GOODS PRIVATE LIMITED',
    'SHANTI ARHAM FOUNDATION',
    'DRONYLABS (OPC) PRIVATE LIMITED',
    'CUREWORKS HEALTHCARE PRIVATE LIMITED',
    'DRIFTERRS SERVICES PRIVATE LIMITED',
    'INFINITE X CIRCULAR SYSTEMS PRIVATE LIMITED',
    'HCG DISTRIBUTION PRIVATE LIMITED',
    'ASHPRO LOGISTICS PRIVATE LIMITED',
    'FADE FOREX PRIVATE LIMITED',
    'ENDPOINT TECHNOLOGIES PRIVATE LIMITED',
    'GSG FITNESS PRIVATE LIMITED',
    'TRIOS COWORKING PRIVATE LIMITED',
    'BYLANE LOGISTIC PRIVATE LIMITED',
    'SERVICEAIDE SERVICE MANAGEMENT PRIVATE LIMITED',
    'MFRAME ONLINE SERVICES (OPC) PRIVATE LIMITED',
    'THETAWAVE SERVICES PRIVATE LIMITED',
    'ADOSTROPHE DIGITAL MARKETING PRIVATE LIMITED',
    'ASTRANOVA BIOTECH PRIVATE LIMITED',
    'DEMCO CONTAINER LINE PRIVATE LIMITED',
    'IMPETROSYS SOFTWARE SOLUTION PRIVATE LIMITED',
    'CARNIVAL CAPITAL HOLDING PRIVATE LIMITED',
    'AL SAMAYA INFOSYSTEM PRIVATE LIMITED',
    'BOOKINGJINI LABS PRIVATE LIMITED',
    'FA WEBTECH PRIVATE LIMITED',
    'UNISCIENT ENGINEERING PRIVATE LIMITED',
    'SKAPARE CORPORATE SOLUTIONS PRIVATE LIMITED',
    'CT INFOTECH INDIA PRIVATE LIMITED',
    'ACF TECHNOLOGY PRIVATE LIMITED',
    'FRIENDLOAN TECHNOLOGIES PRIVATE LIMITED',
    'RENESYS SOLAR PRIVATE LIMITED',
    'VILLI & PURI SCIENTIFICA PRIVATE LIMITED',
    'SHOOTUP TECHNOLOGIES PRIVATE LIMITED',
    'FFL CUISINES PRIVATE LIMITED',
    'ETHNOSERVE BESPOKE SERVICES PRIVATE LIMITED',
    'ELBOUND SYSTEMS PRIVATE LIMITED',
    'SPINTEC ENGINEERING PRIVATE LIMITED',
    'FINLITE FINANCE PRIVATE LIMITED',
    'INVESTADVISE GLOBAL BUSINESS PRIVATE LIMITED',
    'MARVELENS STUDIOS PRIVATE LIMITED',
    'TENET MEDCORP PRIVATE LIMITED',
    'GUNDA CORPORATION PRIVATE LIMITED',
    'INFO QUEST BACKGROUND CHECKS PRIVATE LIMITED',
    'COMPAGNO STRATEGIC SOLUTION PRIVATE LIMITED',
    'KYI SOFT SOLUTIONS PRIVATE LIMITED',
    'GOLDENFRAME TALKIES PRIVATE LIMITED',
    'VSL VENTURES PRIVATE LIMITED',
    'REAPIT INCORPORATIONS PRIVATE LIMITED',
    'BLUEZ ONLINE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'HEATWORKS PRIVATE LIMITED',
    'DIL SE YATRA PRIVATE LIMITED',
    'IHNC PRIVATE LIMITED',
    'SORTED STEEL PRIVATE LIMITED',
    'DOSCAM ELECTRIC & ENGINEERS PRIVATE LIMITED',
    'JOBTECH CONSULTANCY PRIVATE LIMITED',
    'LOGARHYTHM CONSULTANCY PRIVATE LIMITED',
    'ZYLA HEALTH PRIVATE LIMITED',
    'BINMILE TECHNOLOGIES PRIVATE LIMITED',
    'BETTERLIFE DIGITAL MEDIA PRIVATE LIMITED',
    'UBERGRAD INDIA PRIVATE LIMITED',
    'COMPLETECH PRIVATE LIMITED',
    'IMPULSIVE WEB PRIVATE LIMITED',
    'SHOUVIK LAHIRI BUSINESS INTERVENTIONS PRIVATE LIMITED',
    'JUSDA INDIA SUPPLY CHAIN MANAGEMENT PRIVATE LIMITED',
    'BAINBRIDGE NAVIGATION PRIVATE LIMITED',
    'PRABHUJI ETECH CREATIONS PRIVATE LIMITED',
    'SES CONSULTING ENGINEERS PRIVATE LIMITED',
    'OMI JOURNEY PRIVATE LIMITED',
    'ORLE TECHNOLOGY SERVICES PRIVATE LIMITED',
    'STAFFINGINE TECHNOLOGIES PRIVATE LIMITED',
    'SOLESTO ENERGY PRIVATE LIMITED',
    'ADMAX AGRO PRODUCTS PRIVATE LIMITED',
    'RELIANCE GAS LIFESTYLE INDIA PRIVATE LIMITED',
    'SPEEDIKA PRIVATE LIMITED',
    'POONA PNEUMATIC PRIVATE LIMITED',
    'BINSUFI GENERAL TRADING PRIVATE LIMITED',
    'UAA DIGITAL MEDIA PRIVATE LIMITED',
    'FASHKUUT PRIVATE LIMITED',
    'AARUSH (PHASE V) LOGISTICS PARK PRIVATE LIMITED',
    'MULTIPLEX GLOBAL RESOURCES (IFSC) PRIVATE LIMITED',
    'OCCIPITAL TECHNOLOGIES PRIVATE LIMITED',
    'GOOD LIFE CONSUMER PRIVATE LIMITED',
    'NUTEC-THERMO FURNACES AND EQUIPMENTS PRIVATE LIMITED',
    'AKSON OILTECH PRIVATE LIMITED',
    'PRINTECHS MARKING & CODING SOLUTIONS PRIVATE LIMITED',
    'HIGH ON MUSIC ENTERTAINMENT PRIVATE LIMITED',
    'RRRK ASSOCIATES PRIVATE LIMITED',
    'TRITON MARINE OILFIELD SERVICES PRIVATE LIMITED',
    'ADAMAS DIGITAL LEARNING SOLUTIONS PRIVATE LIMITED',
    'DASSAULT RELIANCE AEROSPACE LIMITED',
    'VINOX INDIA PRIVATE LIMITED',
    'HERMES ONLINE EDUCATION INDIA PRIVATE LIMITED',
    'HJ HOSPITALITY PRIVATE LIMITED',
    'MYCOIT TECHNOLOGIES PRIVATE LIMITED',
    'CLAIMCHASE SERVICES PRIVATE LIMITED',
    'YATNAM LAB LIMITED',
    'NABLING SERVICES PRIVATE LIMITED',
    'FOENERO MULTITRADE PRIVATE LIMITED',
    'SEABIRD MARINE SERVICES (GUJARAT) PRIVATE LIMITED',
    'KUSSARP SECURICORE PRIVATE LIMITED',
    'SHUANGMA MACHINERY (INDIA) PRIVATE LIMITED',
    'MY PLUSH TOY PRIVATE LIMITED',
    'JCR FASHION RETAIL PRIVATE LIMITED',
    'EPOCHAERO SPACE PRIVATE LIMITED',
    'OVERFLY SERVICES (OPC) PRIVATE LIMITED',
    'JED-I TECHNOLOGIES PRIVATE LIMITED',
    'PATCHUS COMMUNICATIONS PRIVATE LIMITED',
    'SBASIC APPLICATIONS PRIVATE LIMITED',
    'KAYIL SYSTEMS PRIVATE LIMITED',
    'NIRANTHARA INFRA PRIVATE LIMITED',
    'AARUSH (PHASE II) LOGISTICS PARK PRIVATELIMITED',
    'SUREHOMZ REALTY SERVICES PRIVATE LIMITED',
    'AARUSH (PHASE IV) LOGISTICS PARK PRIVATELIMITED',
    'XTERRA MINING SERVICES PRIVATE LIMITED',
    'AARZEAL TECHNOLOGIES PRIVATE LIMITED',
    'NSTORE TECHNOLOGIES PRIVATE LIMITED',
    'KUTUMBH CARE FOUNDATION',
    'BLUEBIRD LIGHTS PRIVATE LIMITED',
    'PILLOW MINT HOSPITALITY SERVICES PRIVATELIMITED',
    'SIRIADARSHA (MYSORE) CHITS PRIVATE LIMITED',
    'CRAIN INFOSCIENCE PRIVATE LIMITED',
    'SVM EVENT MANAGEMENT PRIVATE LIMITED',
    'LOGICANGLE PRIVATE LIMITED',
    'DUNAMIS INFRATECHNO SOLUTIONS PRIVATE LIMITED',
    'JNANA FOUNDATION',
    'HEAPTRONIX TECHNOLOGIES PRIVATE LIMITED',
    'PRAYOGA FILMS PRIVATE LIMITED',
    'JINDAL URBAN WASTE MANAGEMENT (JODHPUR) LIMITED',
    'PAS SOFTECH PRIVATE LIMITED',
    'OBMONDO INDIA PRIVATE LIMITED',
    'PROMOTECH FABRICATION MACHINES PRIVATE LIMITED',
    'MEGALO WORLDWIDE LOGISTICS PRIVATE LIMITED',
    'AIDT PHASE-1 PRIVATE LIMITED',
    'ECOWIN SYSTEMS AND SERVICES PRIVATE LIMITED',
    'SIMYOG TECHNOLOGY PRIVATE LIMITED',
    'COURSERA INDIA PRIVATE LIMITED',
    'SPOILT FOX CONSULTING PRIVATE LIMITED',
    'SSGC TAXPRO PRIVATE LIMITED',
    'RSM HOSPITALITY PRIVATE LIMITED',
    'DHFL INVESTMENTS LIMITED',
    'MACHEDA LOGISTICS INDIA PRIVATE LIMITED',
    'CONTEC CRITICAL SOLUTIONS PRIVATE LIMITED',
    'ANAPLAN INDIA PRIVATE LIMITED',
    'MILLENNIUM SEMICONDUCTORS PRIVATE LIMITED',
    'CUSTOM CONSTRUCTION PRIVATE LIMITED',
    'MANOR & MEWS PRIVATE LIMITED',
    'DEEPSEA BLUE GLOBAL LIMITED',
    'LUMAC INDUSTRIAL SERVICES PRIVATE LIMITED',
    'DALMIA CHINNAKOMERLA COTTON PRODUCER COMPANY LIMITED',
    'BRASSICAE TECHNOLOGIES PRIVATE LIMITED',
    'VENTXPERT CONVERTING SOLUTIONS INDIA PRIVATE LIMITED',
    'AROHAK TECHNOLOGIES PRIVATE LIMITED',
    'APPROCOOL AIRCON PRIVATE LIMITED',
    'BIM & GRAFX INTEGRATED STUDIO PRIVATE LIMITED',
    'AMITRICKS SOLUTION PRIVATE LIMITED',
    'CONTISHIP LOGISTICS PRIVATE LIMITED',
    'MAXHEAL REMEDIES PRIVATE LIMITED',
    'EYEDREAM CONSULTANT PRIVATE LIMITED',
    'CARGOES LOTUS GLOBAL EXPRESS PRIVATE LIMITED',
    'ATLANTEAN GLOBAL HOSPITALITY PRIVATE LIMITED',
    'TARUN JAIN FINE JEWELLERY PRIVATE LIMITED',
    'MANOMYA PRIVATE LIMITED',
    'BEGOL LOGISTICS PRIVATE LIMITED',
    'STEDRANT TECHNOCLINIC PRIVATE LIMITED',
    'ROMEE ENGITECH PRIVATE LIMITED',
    'PROVOCATRO APPARELS PRIVATE LIMITED',
    'SYNERGIE SOCIALWORKS PRIVATE LIMITED',
    'QUESTS CREATIVE PRIVATE LIMITED',
    'FRANKEL HEALTHCARE PRIVATE LIMITED',
    'UNIVERONA CONSULTANCY SERVICES PRIVATE LIMITED',
    'SHEPRENEUR SOLUTIONS PRIVATE LIMITED',
    'BSM BIG SOCIAL MEDIA PRIVATE LIMITED',
    'SIX SIGMA ELDERCARE PRIVATE LIMITED',
    'MYTRAH ADITYA ENERGY PRIVATE LIMITED',
    'ZENX CREATIVE MANAGEMENT SERVICES PRIVATE LIMITED',
    'BAY AREA ENGICON PRIVATE LIMITED',
    'REALPRO REALTY SOLUTIONS PRIVATE LIMITED',
    'SHARPTECH MEDIA PRIVATE LIMITED',
    'PYKIH DATA INTELLIGENCE PRIVATE LIMITED',
    'FORGEFRONT SECURITY PRIVATE LIMITED',
    'TRIANZ VENTURES PRIVATE LIMITED',
    'EDUSARC CONSULTANCY PRIVATE LIMITED',
    'DECCAN AIRSPORTS PRIVATE LIMITED',
    'MEISSA REALTY VENTURES PRIVATE LIMITED',
    'CDOCKET PRIVATE LIMITED',
    'WOVEN ZELTS PRIVATE LIMITED',
    'SOUTHMADE REALTY & RETAIL PRIVATE LIMITED',
    'MALWA SOLAR POWER GENERATION PRIVATE LIMITED',
    'NUCTECH INDIA PRIVATE LIMITED',
    'ECOTAB BUILDING COMMISSIONING CONSULTANTS PRIVATE LIMITED',
    'KEYED FOUNDATION',
    'FASHION GRANITE AND CERAMIC TILES PRIVATE LIMITED',
    'OSX TRADING PRIVATE LIMITED',
    'ARKON WEB SOLUTIONS PRIVATE LIMITED',
    'JMT DEVELOPERS PRIVATE LIMITED',
    'OPENSENSE LABS PRIVATE LIMITED',
    'ICTI TECHNOLOGIES PRIVATE LIMITED',
    'ARTHA LOGISTICS PRIVATE LIMITED',
    'CURITEX MEDICAL PRIVATE LIMITED',
    'SARVA VIDYALAYA INNOVATION FOUNDATION',
    'BUSINESS DYNAMIKS PRIVATE LIMITED',
    'NICEG PRIVATE LIMITED',
    'TECHNOGRAMS SOLUTIONS PRIVATE LIMITED',
    'KAISHIN METALEX STAINLESS STEEL PRIVATE LIMITED',
    'DURO TECHNICAL SYSTEMS PRIVATE LIMITED',
    'BET CONSULTANTS PRIVATE LIMITED',
    'GREENSTONE HEALTH PRIVATE LIMITED',
    'IMPLENIA SMART NETWORK SERVICES PRIVATE LIMITED',
    'TOSIL SYSTEMS PRIVATE LIMITED',
    'SAUMYA ARTS AND ENTERTAINMENT PRIVATE LIMITED',
    'ARDIDRA TECHNOLOGIES PRIVATE LIMITED',
    'LIVETRONICS PRIVATE LIMITED',
    'SAYA TECH LABS PRIVATE LIMITED',
    'TRIEKA INNOVATIONS PRIVATE LIMITED',
    'FRAKTAL TECHNOLOGIES PRIVATE LIMITED',
    'FYNAMICS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GREENARK ENLIVEN PRIVATE LIMITED',
    'LEGALIDEA CONSULTANCY PRIVATE LIMITED',
    'XIAOLIN ELECTRONIC PRIVATE LIMITED',
    'ZONTEK INTERNET OF THINGS SCINECE AND TECHNOLOGY INDIA PRIVATE LIMITED',
    'QUANTSIO INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'MANSOR PROPERTIES PRIVATE LIMITED',
    'ELIXA TECHNOLOGIES PRIVATE LIMITED',
    'VA CSC PRIVATE LIMITED',
    'ENVIROTECH RESEARCH PRIVATE LIMITED',
    'TEKNOFORMIKS INDIA PRIVATE LIMITED',
    'SOLARBIRD ENGINEERING PRIVATE LIMITED',
    'TECHNOCARE OVERSEAS INDIA PRIVATE LIMITED',
    'IFOS FLIGHT SERVICES PRIVATE LIMITED',
    'XTRACOVER TECHNOLOGIES PRIVATE LIMITED',
    'HOK BEAUTY PRIVATE LIMITED',
    'BREATHINGROOM SOLUTIONS PRIVATE LIMITED',
    'EDVIE DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'EHG 360 EXPORTS PRIVATE LIMITED',
    'DURO ENGINEERING MANAGEMENT PRIVATE LIMITED',
    'CHIDRUPI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'WOLLWOLL PHOTO FRAME DESIGN PRIVATE LIMITED',
    'RENIT TECHNOLOGIES PRIVATE LIMITED',
    'APEIRONT SOLUTIONS PRIVATE LIMITED',
    'SAMARTH SKILLS DEVELOPMENT PRIVATE LIMITED',
    'SHUMATI BUSINESS SERVICES PRIVATE LIMITED',
    'ECOREN AEGA WINDS PRIVATE LIMITED',
    'LUXLIGHTING TECHNOLOGY PRIVATE LIMITED',
    'FINDOC INVESTMART (IFSC) PRIVATE LIMITED',
    'M.A.G RENEWABLE ENERGY PRIVATE LIMITED',
    'SHRI ADINATH EEQUIPMENTS PRIVATE LIMITED',
    'CHINTA ENGICON PRIVATE LIMITED',
    'ASANAM HEALTH & WELLBEING (OPC) PRIVATE LIMITED',
    'WISFLUX PRIVATE LIMITED',
    'INDUSVIVA INTERNATIONAL PRIVATE LIMITED',
    'STANGROWTH CONSULTANT PRIVATE LIMITED',
    'FLOYDWIZ TECHNOLOGIES PRIVATE LIMITED',
    'IMPEX GLOBAL LOGISTICS PRIVATE LIMITED',
    'NINOS IT SOLUTION PRIVATE LIMITED',
    'TERGUS WORKS PRIVATE LIMITED',
    'DILIGENCE NETSOFT PRIVATE LIMITED',
    'DSPC ENGINEERING PRIVATE LIMITED',
    'HASOFFER TECHNOLOGIES PRIVATE LIMITED',
    'ALENA PUBLISHING PRIVATE LIMITED',
    'SHEETAL ECO HVAC ENGINEERING PRIVATE LIMITED',
    'VRUTI IMPEX PRIVATE LIMITED',
    'BE ONSITE SOLAR ENERGY PRIVATE LIMITED',
    'MYTHRI REALTORS AND DEVELOPERS PRIVATE LIMITED',
    'SICURO VENTURES PRIVATE LIMITED',
    'PRAVAG CONSULTING PRIVATE LIMITED',
    'DHARMA TRUSTEE PRIVATE LIMITED',
    'ENERCOMM SALES SERVICE PRIVATE LIMITED',
    'MAXURA PHARMACEUTICAL PRIVATE LIMITED',
    'APG DC INFRA PRIVATE LIMITED',
    'SEATAAL PROPERTIES PRIVATE LIMITED',
    'TUBEROSE REALTORS PRIVATE LIMITED',
    'SOVEREIGN REALTY PRIVATE LIMITED',
    'OYE FINTECH PRIVATE LIMITED',
    'VISIONARY FINANCEPEER PRIVATE LIMITED',
    'IMAGITECH INFRASTRUCTURE PRIVATE LIMITED',
    'UNIPICK FOODS PRIVATE LIMITED',
    'MERLIN TECH LABS PRIVATE LIMITED',
    'DEVOBAL TECHNOLOGIES PRIVATE LIMITED',
    'OUDH COCOGEM (INDIA) PRIVATE LIMITED',
    'KIARA LIFESPACES PRIVATE LIMITED',
    'S2V ADVERTISERS AND INFOTECH PRIVATE LIMITED',
    'DDRIVEN DATA SCIENCES & ANALYTICS PRIVATE LIMITED',
    'FUNDWAVE TECHNOLOGIES PRIVATE LIMITED',
    'VOITH DIGITAL SOLUTIONS INDIA PRIVATE LIMITED',
    'CONEFLOWER INFRATECH PRIVATE LIMITED',
    'TUBEROSE DEVELOPERS PRIVATE LIMITED',
    'DECISION SCIENCE RESEARCH LABS PRIVATE LIMITED',
    'PDGT FRAMEWORKS PRIVATE LIMITED',
    'VEDAYAJ INNOVATIONS (OPC) PRIVATE LIMITED',
    'UCARTZ ONLINE PRIVATE LIMITED',
    'MOUNT EDGE DIGITAL SERVICES PRIVATE LIMITED',
    'MOONSHINE TECHNOLOGY PRIVATE LIMITED',
    'HSO INDIA PRIVATE LIMITED',
    'BOPPO TECHNOLOGIES PRIVATE LIMITED',
    'APPGALLOP PRIVATE LIMITED',
    'BRIDGE IMPACT PRIVATE LIMITED',
    'MERUDAN IT CONSULTING PRIVATE LIMITED',
    'SHILPMIS TECHNOLOGIES PRIVATE LIMITED',
    'TRUSTIDEAS TECHNOLOGY PRIVATE LIMITED',
    'LOGIEAGLE PRIVATE LIMITED',
    'OBJECTCODES INFOTECH PRIVATE LIMITED',
    'SILICONVEINS PRIVATE LIMITED',
    'EMANAGE SOFTWARE PRIVATE LIMITED',
    'BYTERIDERZ INDIA PRIVATE LIMITED',
    'MOTONEURON LABS PRIVATE LIMITED',
    'ESON INFOTECH PRIVATE LIMITED',
    'IT PATH SOLUTIONS PRIVATE LIMITED',
    'VAMEDIA BOX PRIVATE LIMITED',
    'EQADA INFOTECH PRIVATE LIMITED',
    'SEAMLESS INFOTECH PRIVATE LIMITED',
    'THUMBMATIC SOLUTIONS PRIVATE LIMITED',
    'NETMAP TECHNOLOGY PRIVATE LIMITED',
    'BYTRIX NET PRIVATE LIMITED',
    'SR INTELLIGENT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DIGIVERV INDIA PRIVATE LIMITED',
    'OT PRIVACY SOFTWARE PRIVATE LIMITED',
    'TALASECURE PRIVATE LIMITED',
    'HIGH PEAK SOFTWARE PRIVATE LIMITED',
    'AKAMAI INDIA NETWORKS PRIVATE LIMITED',
    'KHYMAZE INDIA PRIVATE LIMITED',
    'ORIGAMICX DIGITAL MEDIA PRIVATE LIMITED',
    'RUBRIK INDIA PRIVATE LIMITED',
    'CNIOT SERVICES (OPC) PRIVATE LIMITED',
    '3S SENSORS & SYSTEMS TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'NOUVEAU LABS PRIVATE LIMITED',
    'APPINEZZ IN TECHNOLOGIES PRIVATE LIMITED',
    'ACRONOTICS PRIVATE LIMITED',
    'STOCKONE TECHNOLOGIES PRIVATE LIMITED',
    'ARISTOBRAT RETAIL PRIVATE LIMITED',
    'AFORECYBERSEC TECHNOLOGY PRIVATE LIMITED',
    'TRICENTIS INDIA PRIVATE LIMITED',
    'NIXTS SOLUTIONS (OPC) PRIVATE LIMITED',
    'VISPARA TECHNOSOFT PRIVATE LIMITED',
    'MICROTECH DIGISYSTEMS PRIVATE LIMITED',
    'MAPI TECHNOLOGY PRIVATE LIMITED',
    'LAVEERA TECHNOLOGIES PRIVATE LIMITED',
    'TIBIL DATA SOLUTIONS PRIVATE LIMITED',
    'ALGOBITZ PRIVATE LIMITED',
    'CODEPUREX TECHNOLOGIES PRIVATE LIMITED',
    'EXIMIOUS GLOBAL PRIVATE LIMITED',
    'QUEEN SMARTECH PRIVATE LIMITED',
    'FENOPIX TECHNOLOGIES PRIVATE LIMITED',
    'SIGHTSEER INNOVATIONS PRIVATE LIMITED',
    'SUREKHA TECHNOLOGIES PRIVATE LIMITED',
    'TRUCKNET DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'WIZMOBI TECHNOLOGIES PRIVATE LIMITED',
    'INTEGENSOFT PRIVATE LIMITED',
    'AAKARSHA TECHNOLOGIES PRIVATE LIMITED',
    'GULT DESIGN PRIVATE LIMITED',
    'PRAYAS FINANCIAL SERVICES PRIVATE LIMITED',
    'SENSEFORTH AI RESEARCH PRIVATE LIMITED',
    'LYEARN SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED',
    'AKI E-COMMERCE VENTURES PRIVATE LIMITED',
    'NETFAS TECHNOLOGIES PRIVATE LIMITED',
    'APPINFOINC TRAFFIC INDIA PRIVATE LIMITED',
    'VOICETREE COMMUNICATIONS PRIVATE LIMITED',
    'INNOVISTAN VENTURES PRIVATE LIMITED',
    'IBA INFOTECH PRIVATE LIMITED',
    'SVAPNASRSTI SOFTWARES PRIVATE LIMITED',
    'LEADSOC TECHNOLOGIES PRIVATE LIMITED',
    'STEERMINDS PRIVATE LIMITED',
    'REDBOT INNOVATIONS PRIVATE LIMITED',
    'SUBHANU RAPIDD INDOGLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'HYPERSIMPLIFY SOLUTIONS PRIVATE LIMITED',
    'UNTANGLED TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'PRESCRIBENEXT TECHNOLOGIES PRIVATE LIMITED',
    'ORO MEDIA LAB PRIVATE LIMITED',
    'KLONEC AUTOMATION SYSTEMS PRIVATE LIMITED',
    'ADESSO INDIA PRIVATE LIMITED',
    'ACCENT TECHNO SOLUTIONS PRIVATE LIMITED',
    'FLEXIBEES BUSINESS SERVICES PRIVATE LIMITED',
    'HNR RETAIL PRIVATE LIMITED',
    'HIRANYA TECHNOLOGIES PRIVATE LIMITED',
    'ASTAR ULTRA MODERN PACKING PRIVATE LIMITED',
    'NIKSUN ELECTRO-INFRA PRIVATE LIMITED',
    'SOHAM TALENTLINK PRIVATE LIMITED',
    'ICALLGENESIS PRIVATE LIMITED',
    'ACUWAY MOLDS( INDIA) PRIVATE LIMITED',
    'FARMTRAY GROCERY SUPPLIES PRIVATE LIMITED',
    'SIGMAINTL DIVERSIFIED INDIA PRIVATE LIMITED',
    'CONCEPO ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED',
    'NIRUHA SYSTEMS PRIVATE LIMITED',
    'SWIPE RECORD SYSTEM PRIVATE LIMITED',
    'MOBOSECURITAS SERVICES PRIVATE LIMITED',
    'UKAY ALLIED INNOVATORS PRIVATE LIMITED',
    'PAPERLESS POSTCARDS VENTURE PRIVATE LIMITED',
    'ODISHA RAIL INFRASTRUCTURE DEVELOPMENT LIMITED',
    'FASTWAY IPLS NETWORK PRIVATE LIMITED',
    'VIJ ALLURE PRIVATE LIMITED',
    'ARKCHEM SYSTEMS PRIVATE LIMITED',
    'SETH CYCLO POWER PRIVATE LIMITED',
    'OTT-JAKOB CLAMPING TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MANAN OILFIELD SERVICES PRIVATE LIMITED',
    'AUTOGEN INDIA PRIVATE LIMITED',
    'FLAGPOLE ENTERPRISES (OPC) PRIVATE LIMITED',
    'IBICON PRIVATE LIMITED',
    'NISSAR CONSULTANCY PRIVATE LIMITED',
    'JUST IN TIME ONLINE INDIA PRIVATE LIMITED',
    'DIGITAL GOLD INDIA PRIVATE LIMITED',
    'EPACIFIC SERVICES PRIVATE LIMITED',
    'PRANAV EYE CARE SYSTEMS (OPC) PRIVATE LIMITED',
    'SUKSHMATARANGA TECHNOLOGIES PRIVATE LIMITED',
    'EVAH DECOR PRIVATE LIMITED',
    'PRIME REBAR CONSULTING & ENGINEERING PRIVATE LIMITED',
    'OMKARMIC DIGITAL PRIVATE LIMITED',
    'MASSTRANS SOLUTIONS PRIVATE LIMITED',
    'HOBBY HUB LEARNING PRIVATE LIMITED',
    'JOYOM FENSTER TECH PRIVATE LIMITED',
    'VIBRANTMINDS TECHNOLOGIES PRIVATE LIMITED',
    'WISETHINGS SOLUTIONS PRIVATE LIMITED',
    'ALPHANITI FINTECH PRIVATE LIMITED',
    'ELEVATORCART PRIVATE LIMITED',
    'ENTEKA SYSTEMS PRIVATE LIMITED',
    'ACME PROCESS SYSTEMS PRIVATE LIMITED',
    'ENERSOURCE CONSULTING PRIVATE LIMITED',
    'SAI SEEYA COMPOSITE PRIVATE LIMITED',
    'FALCON SANDS PRIVATE LIMITED',
    'HORTICOLD REFRIGERATION AND ENGINEERING PRIVATE LIMITED',
    'RUH WEBSTORE PRIVATE LIMITED',
    'GRAPESEED CONSULTANTS PRIVATE LIMITED',
    'CAZAAYAN TECHNOLOGIES PRIVATE LIMITED',
    'PRUDOUR PRIVATE LIMITED',
    'SURESH PATNI FAMILY VENTURES PRIVATE LIMITED',
    'YESAB VENTURES PRIVATE LIMITED',
    'QUINTESSENTIAL INNOVATIONS PRIVATE LIMITED',
    'SS CRAFTEXPO PRIVATE LIMITED',
    'SURAJ LIFEDRUG SOLUTIONS INDIA PRIVATE LIMITED',
    'APPNETWISE PRIVATE LIMITED',
    'INMAR TECHNOLOGIES PRIVATE LIMITED',
    'BHEEM INFORMATICS PRIVATE LIMITED',
    'BOSON MOTORS PRIVATE LIMITED',
    'INDRASOL TECHNOLOGIES PRIVATE LIMITED',
    'INSPIRELABS SOLUTIONS PRIVATE LIMITED',
    'INDUS INTERNATIONAL SCHOOL PRIVATE LIMITED',
    'SERIND PHARMA PRIVATE LIMITED',
    'MVIYES PHARMA VENTURES PRIVATE LIMITED',
    'INTELI ADORNER INDIA PRIVATE LIMITED',
    'TKG HEALTHCARE PRIVATE LIMITED',
    'SYNVERGENT HEALTHCONNECT PRIVATE LIMITED',
    'ONSIGHT ANALYTICS SOLUTIONS INDIA PRIVATE LIMITED',
    'CEVA ESA BSC PRIVATE LIMITED',
    'INDIAN OCEAN XCHANGE INDIA PRIVATE LIMITED',
    'REDSERV BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KIRAYA CENTER IT SOLUTION PRIVATE LIMITED',
    'TERAINIUM PRIVATE LIMITED',
    'CENTAUR FSA PRIVATE LIMITED',
    'MAANYAM ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'VAYATRONICS PRIVATE LIMITED',
    'TALENT ZING PRIVATE LIMITED',
    'ECOPMIN TECHNOLOGIES PRIVATE LIMITED',
    'ERGOS LOGISTICS AND SHIPPING PRIVATE LIMITED',
    'DERIVATIVES CONNECT PRIVATE LIMITED',
    'YM GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'INDIGOLEARN EDU TECH PRIVATE LIMITED',
    'DESIGN EIGHT PRIVATE LIMITED',
    'ASPS RENEWABLES PRIVATE LIMITED',
    'KAPIL PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'MIOT MEDICAL SUPPLIES PRIVATE LIMITED',
    'CEO TSG IR AND LABOUR COMPLIANCE SERVICES PRIVATE LIMITED',
    'LIFTSTRADE PRIVATE LIMITED',
    'IPSS SKILL ACADEMY PRIVATE LIMITED',
    'COUCO FASHION HOUSE PRIVATE LIMITED',
    'VS TRUSTEE PRIVATE LIMITED',
    'MILESMATE AUTOTECH PRIVATE LIMITED',
    'BUILDERSMART BUILDING MATERIALS PRIVATE LIMITED',
    'SAMBAV EHR PRIVATE LIMITED',
    'EVVIN ONLINE PRIVATE LIMITED',
    'ASPIREAL TECHNOLOGIES PRIVATE LIMITED',
    'LEARNSHIP TECHNOLOGIES PRIVATE LIMITED',
    'HITEVISION TECH INDIA PRIVATE LIMITED',
    'DIGICOMPASS INFOMATICS INDIA LIMITED',
    'XXAM SPORTS TECHNOLOGIES PRIVATE LIMITED',
    'MIL POWER CONVERTER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ALPI-POLARIZ TECHSOL PRIVATE LIMITED',
    'SEMITECTS TECHNOLOGIES PRIVATE LIMITED',
    'WINUX COMMUNICATIONS PRIVATE LIMITED',
    'RDX DIGITAL PRIVATE LIMITED',
    'ORIZZONTE INTERIORS PRIVATE LIMITED',
    'ORO TECH SERVICES PRIVATE LIMITED',
    'YUSEONG ENTERPRISES PRIVATE LIMITED',
    'HISOA ELECTRONIC PRIVATE LIMITED',
    'LOKAHI SOFTWARE PRIVATE LIMITED',
    'HOOP CAR RENTALS PRIVATE LIMITED',
    'OTH ONLINE PRIVATE LIMITED',
    'BOON CASTLE MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'CBTW INDIA PRIVATE LIMITED',
    'CULMINANT EXECUTIVE SERVICES PRIVATE LIMITED',
    'FOCUSON INTERIOR DECORATORS PRIVATE LIMITED',
    'CESTA SHIPPING PRIVATE LIMITED',
    'PROCURRI INDIA PRIVATE LIMITED',
    'OCTAVE INFOTECH PRIVATE LIMITED',
    'ARYUPAY TECHNOLOGIES PRIVATE LIMITED',
    'VELTECH AUTO PART (INDIA) PRIVATE LIMITED',
    'HOLATELL TECH PRIVATE LIMITED',
    'SKAMBHA EQUINE ENTERPRISES PRIVATE LIMITED',
    'VITIS MANAGEMENT SERVICES INDIA PRIVATE LIMITED',
    'IMPACT DATA SERVICES PRIVATE LIMITED',
    'MAKXENIA ENGINEERING RESOURCE PRIVATE LIMITED',
    'HOWRAH COMPOSITE LIMITED',
    'FIT7 GLOBAL VENTURES PRIVATE LIMITED',
    'CSC WI-FI CHOUPAL SERVICES INDIA PRIVATELIMITED',
    'DINTELLECTS SOLUTIONS PRIVATE LIMITED',
    'MANIPAL INTELLIGENT TRANSPORT PRIVATE LIMITED',
    'HOGAR CONTROLS INDIA PRIVATE LIMITED',
    'WIMI INDUSTRIES PRIVATE LIMITED',
    'RURU INFRASTRUCTURE PRIVATE LIMITED',
    'AMBUJA NEOTIA INCUBATION PRIVATE LIMITED',
    'JARNAIRE AIRCON PRIVATE LIMITED',
    'MAPLE SECURITY SOLUTIONS PRIVATE LIMITED',
    'ATUSAM TECHNO PRIVATE LIMITED',
    'BYOND BRANDINN PRIVATE LIMITED',
    'AMZENEX HEALTHCARE PRIVATE LIMITED',
    'PROTUNE KSA CONSULTANTS PRIVATE LIMITED',
    '10XTD DIGITAL & DESIGN SOLUTIONS PRIVATELIMITED',
    'PRAVASHA PROJECTS PRIVATE LIMITED',
    'TRUAD COMMUNICATION PRIVATE LIMITED',
    'ACTSYS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'ANA IDENTITY SOLUTIONS PRIVATE LIMITED',
    'SHOFU DENTAL INDIA PRIVATE LIMITED',
    'EVOLVING EDUTAINMENT PRIVATE LIMITED',
    'ANUMULA PRIVATE LIMITED',
    'ORALFISH AD VENTURES PRIVATE LIMITED',
    'QBF MEDIA PRIVATE LIMITED',
    'RAJARAJESWARI MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'TOYOBO INDIA PRIVATE LIMITED',
    'STACKMINDZ TECHNOLOGY PRIVATE LIMITED',
    'BDO CONSULTING PRIVATE LIMITED',
    'AYUSHMAN COLD CHAIN & PRESERVATIONS PRIVATE LIMITED',
    'GP INNOVATIONS PRIVATE LIMITED',
    'SAGASIT ANALYTICS PRIVATE LIMITED',
    'SEENPICK RETAIL TECH PRIVATE LIMITED',
    'TALF SAUR URJA PRIVATE LIMITED',
    'GLOBAL DRIVE ROOTS PRIVATE LIMITED',
    'VISION ENVSYS PRIVATE LIMITED',
    'CUBBER TECHNOLOGIES PRIVATE LIMITED',
    'FAASHIONTREE PRIVATE LIMITED',
    'REALTA FACILITY MANAGEMENT PRIVATE LIMITED',
    'LA-DAIRYLICIOUS VENTURES PRIVATE LIMITED',
    'PAVITRA HARSH SNEH PRIVATE LIMITED',
    'SENSECARE HEALTH SOLUTIONS PRIVATE LIMITED',
    'TEKARCH TECHNOLOGY PRIVATE LIMITED',
    'ELEGANS BRANDING PRIVATE LIMITED',
    'SMARTBIKE MOBILITY PRIVATE LIMITED',
    'AUTHENTIC NETTING & SPIKES PRIVATE LIMITED',
    'SOHAMM DISTRICOM PRIVATE LIMITED',
    'MGR PICTURES PRIVATE LIMITED',
    'AIRFAST GLOBAL LOGISTICS PRIVATE LIMITED',
    'AKIS TECH SYSTEMS PRIVATE LIMITED',
    'DHANORI-ALANDI FOUNDATION',
    'APPIGIZER MEDIA PRIVATE LIMITED',
    'HINDUSTAN INFRALOG PRIVATE LIMITED',
    'ELAF CONSULTING PRIVATE LIMITED',
    'I-MAVEN AUTOMOTIVE PRIVATE LIMITED',
    'SUNNIVA CORPORATE ADVISORY PRIVATE LIMITED',
    'BLAHO PRIVATE LIMITED',
    'AMII YUGAL PRIVATE LIMITED',
    'BEYOND MEDIA LABS PRIVATE LIMITED',
    'DEE GEE VISUAL INDIA PRIVATE LIMITED',
    'GANGETICA RESIDENTS ASSOCIATION',
    'ENFROSUN SOLAR PRIVATE LIMITED',
    'SVIZZERA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'NLI PACKAGING MACHINES PRIVATE LIMITED',
    'BIT4ID INDIA PRIVATE LIMITED',
    'XEN TELEMATICS PRIVATE LIMITED',
    'ATIRATH GAMING TECHNOLOGY PRIVATE LIMITED',
    'BRIGHTCOM DIGITAL MEDIA PRIVATE LIMITED',
    'CRAVINGS KITCHEN PRIVATE LIMITED',
    'VAISHNAV INNOVATIONS PRIVATE LIMITED',
    'IBUS TECHNOLOGIES PRIVATE LIMITED',
    'SQUAD ENTERPRISES PRIVATE LIMITED',
    'CLOUDPHYSICIAN HEALTHCARE PRIVATE LIMITED',
    'CALLISTO LABORATORIES LIMITED',
    'AZA METAL INDUSTRIES PRIVATE LIMITED',
    'MKM CREATIONS PRIVATE LIMITED',
    'CBEESO FURNITURE PRIVATE LIMITED',
    'BIOMETRONIC MARKETING PRIVATE LIMITED',
    'VAPCOM TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'TPP TECHNO PLASTIC PRODUCTS INDIA PRIVATE LIMITED',
    'OSADHI SKIN PRODUCTS PRIVATE LIMITED',
    'UNO MINDA KATOLEC ELECTRONICS SERVICES PRIVATE LIMITED',
    'PERSTORP INDUSTRIES INDIA PRIVATE LIMITED',
    'ESWAR THERAPEUTICS PRIVATE LIMITED',
    'SIZZLE',
    'SQUIRE COMMUNICATIONS PRIVATE LIMITED',
    'Raj air express cargo private limited',
    'Bhavana teletech private limited',
    'Zen forex and management private limited',
    'MESKY ONLINE PRIVATE LIMITED',
    'ALTITUDE FINVEST LIMITED',
    'Sakthi financial services cochin p ltd',
    'Knowledge capital services private limited',
    'AYN LOGISTICS INFRA PRIVATE LIMITED',
    'SUSEE FINANCE AND LEASING PRIVATE LIMITED',
    'KREPL CHEMICAL DISTRIBUTORS LIMITED',
    'Abnay agency services private limited',
    'Marval caplease private limited',
    'MANSHARAM TRADING PRIVATE LIMITED',
    'Shantidoot financial services private limited',
    'Deepak batra financial services private limited',
    'F.a capital management private limited',
    'Metro investments private limited',
    'PODDAR REALTY INDIA PRIVATE LIMITED',
    'Anjaneya holdings private limited',
    'Everest kanto investment and finance private limited',
    'Navnitlal and company investment private limited',
    'Freight wings consultants private limited',
    'Pluto securities private limited',
    'Lasertron enterprise services private limited',
    'PROFITMART SECURITIES PRIVATE LIMITED',
    'Gna investment limited',
    'DVARA KSHETRIYA GRAMIN FINANCIAL SERVICES PRIVATE LIMITED',
    'Thamiraparani investments private limited',
    'Kapil chits (karnataka) private limited',
    'Manappuram chits (karnataka) private limited',
    'Ruchirag investment pvt ltd',
    'Ajk investments private limited',
    'Kay kay investments private limited',
    'Choice organics private limited',
    'Healthcursor it consulting private limited',
    'Lilac insights private limited',
    'Healthcare central foundation',
    'Denovo biolabs private limited',
    'PIXEL PATHLABS PRIVATE LIMITED',
    'Pathcare labs private limited',
    'Appleaday health solutions private limited',
    'K-link healthcare (india) private limited',
    'Govindasamy charitable foundation',
    'ARSHIYA FOUNDATION',
    'Shyam industries limited',
    'Bangalore custom house agents association limited',
    'Norka scms-institute of paramedical and development studies',
    'Third eye for good public governance',
    'ZOO DIGITAL INDIA PRIVATE LIMITED',
    'Fingerprint films private limited',
    'Samvaad video private limited',
    'INTERCUT ENTERTAINMENT PRIVATE LIMITED',
    'Rajnanda entertainment private limited',
    'BBC STUDIOS INDIA PRIVATE LIMITED',
    'Eyeqube studios private limited',
    'Excel radio frequency technologies private limited',
    'B s k network and entertinmentprivate limited',
    'Saraswathi media private limited',
    'Bjn entertainment private limited',
    'Red rooster life cycle (international) private limited',
    'INDURI FARM PRIVATE LIMITED',
    'Red rooster racing (international) private limited',
    'Emaar hills township private limited',
    'B & W SEPARATION INDIA PRIVATE LIMITED',
    'Knight riders sports private limited',
    'Luminosity pictures private limited',
    'Pioneer entertainment and media private limited',
    'Tradebulls commodities private limited',
    'Ahmedabad university support foundation',
    'PARIDYAM HEALTH CARE PRIVATE LIMITED',
    'Simulation product life cycle management private limited',
    'Sg aerospace (india) private limited',
    'Jm foundation for excellence in journalism',
    'Beyond verve entertainment private limited',
    'Devotional management services private limited',
    'The piramal art foundation',
    'Bindass party private limited',
    'Resurgence fincap advisors private limited',
    'Highend project consultants private limited',
    'Vasantha corpo relations private limited',
    'SPARK PWM PRIVATE LIMITED',
    'Netripples software limited',
    'Aptech limited',
    'Howard hotels limited',
    'Coromandel engineering company limited',
    'Goldcrest corporation limited',
    'Midvalley entertainment limited',
    'Picturehouse media limited',
    'Mukand limited',
    'Oriyara properties pvt. ltd.',
    'H & M HENNES & MAURITZ INDIA PRIVATE LIMITED',
    'Pinax paper mills private limited',
    'Sunwin technosolutions private limited',
    'S b energy projects private limited',
    'The concorde residential schools (bangalore) private limited',
    'Ecm logistics private limited',
    'ARISTO BIO-TECH AND LIFESCIENCE LIMITED',
    'SEACO PLANTATIONS PRIVATE LIMITED',
    'Mangrol floriculture private limited',
    'Kausalya agro farms and developers private limited',
    'Rajathi biotech private limited',
    'Pv sons corn milling company private limited',
    'Bharat waterfront private limited',
    'PANDIYAN PLANTATIONS PRIVATE LIMITED',
    'Cheerakuzhy rubber nursery and research centre private limited',
    'Mint agri research and development private limited',
    'V b farms private limited',
    'SHREERAMOM REAL ESTATE PRIVATE LIMITED',
    'Flowers valley floriculture private limited',
    'Topper agro private limited',
    'Sun blessed coffee private limited',
    'Indo ferro metal private limited',
    'Kanyakumari farms private limited',
    'Van-latta farms private limited',
    'Hi-tek breeders private limited',
    'R j breeders private limited',
    'Chintamani poultry farms private limited',
    'Shraddha poultry farms private limited',
    'Paayas milk producer company limited',
    'Bhaskar bio industries private limited',
    'Commando kennels and industrial security services private limited',
    'Bluemoon plantations and farms private limited',
    'Pnp agrotech private limited',
    'Mangalam krishi vanijya private limited',
    'Krithisha agro farms private limited',
    'Pandiyan sericultural farm private limited',
    'Superior buildestates private limited',
    'Westend agro products private limited',
    'Greenfield nursery and landscapes private limited',
    'Sky hemmay private limited',
    'Nutrahelix biotech private limited',
    'Driptech india private limited',
    'HMH DRILLING ENGINEERING SERVICES OF INDIA PRIVATE LIMITED',
    'A.d.j.agro exports private limited',
    'Preston india private limited',
    'Pyramid timber associates private limited',
    'Belgaum sands private limited',
    'Samco nutritions private limited',
    'Span healthcare private limited',
    'Altret bio-tech limited',
    'Sieco engineers private limited',
    'RSM AUTOKAST PRIVATE LIMITED',
    'Prom machining solutions india private limited',
    'G.plast private limited',
    'Press-comp international private limited',
    'Bloom electronics private limited',
    'K.l. energy and coal benefication private limited',
    'Patel furnace and forging private limited',
    'Sriba sea base private limited',
    'Lakshadweep development corporation limited',
    'Magnum sea foods limited',
    'Exodus marine company private limited',
    'Syndicate exports private limited',
    'MAMMEN MAPPILLAI AND INVESTMENTS LIMITED',
    'Expat leisure and resorts limited',
    'Acceleration 2005 private limited',
    'Lakshmi narasimha holdings (coimbatore) private limited',
    'A p cranes private limited',
    'Ssk electronicsandsystems private limited',
    'Sciana instruments private limited',
    'Ebm-papst india private limited',
    'Aurobindo biotech products private limited',
    'Birla electricals limited',
    'DEV INFORMATION TECHNOLOGY LIMITED',
    'Aic technik private limited',
    'Ace designers limited',
    'Wintech hydraulics private limited',
    'It chasesys india private limited',
    'Groovy communications india private limited',
    'Microage infoserve private limited',
    'Meridian infotech limited',
    'Benq india private limited',
    'Arena machineries limited',
    'N-tex machinery private limited',
    'Multilines mechatronics private limited',
    'EXCELLENCE BUSINESS MACHINES & PROJECTS PRIVATE LIMITED',
    'V j industries private limited',
    'Headworks india private limited',
    'Elegant microweb systems private limited',
    'TRANSIT ELECTRONICS LIMITED',
    'P s digital electronics pvt. ltd.',
    'Aidiall technologies private limited',
    'Samtek technologies private limited',
    'Kala genset private limited',
    'Siddhivinayak genset private limited',
    'Trucut precision tools private limited',
    'Mody pumps (india) private limited',
    'Issojet burner private limited',
    'Rotofilt engineers llimited',
    'Rmb power projects private limited',
    'Sk ultratech machines private limited',
    'Prado impex private limited',
    'E- agro care machineries and equipments private limited',
    'Internet customer contact (india) private limited.',
    'Vikshakthi pharma labs private limited',
    'Super kino equipments private limited',
    'Blumenbecker kat automation private limited',
    'Jainam cables (india) private limited',
    'South india wire products private limited',
    'Maniar electricals private limited',
    'Venus wire industries private limited.',
    'Balaji extrusions and cables private limited',
    'S.v.s refcomp private limited',
    'GEETANJALI WIRE PRODUCTS PVT LTD',
    'Nichicon electronics (india) private limited',
    'Almas lifts private limited',
    'Carclo technical plastics private limited',
    'Tkg industries private limited',
    'Rove electric private limited',
    'Archilum building solutions private limited',
    'KASA LIGHTS & ELECTRONICS PRIVATE LIMITED',
    'Reliance equipments private limited',
    'Watlow thermal solutions india private limited',
    'Edmi india private limited',
    'Myko electronics private limited',
    'Axis engineering india private limited',
    'Secutech automation (india) private limited',
    'Kyocera asia pacific india private limited',
    'Veyespe hitech innovations private limited',
    'Jap tricomp systems services private limited',
    'Vertex trading and services private limited',
    'Kramer electronics india private limited',
    'Indtech instruments private limited',
    'Spectrum automation and controls pvt ltd',
    'Aec electricals and networks private limited',
    'Innovative automation private limited',
    'Electro automation india private limited',
    'Rrl steels ltd',
    'Bharti telecom limited',
    'Avr electronics private limited',
    'Webrands. com limited',
    'Spicasoft infotech private limited',
    'Coral telecom limited',
    'Transpower india electronics private limited',
    'Uei electronics private limited',
    'Vee ess sales pvt ltd',
    'Vitage systems private limited',
    'Aim graphic machines private limited',
    'Control electronics ltd',
    'Megatherm electronics pvt ltd',
    'Systematix media private limited',
    'Sabero echostar (india) private limited',
    'Novire technologies private limited',
    'Toshcon cd automation ( india) private limited',
    'Solar technologies and services india private limited.',
    'Arihant power equipments private limited',
    'E-fab cables private limited',
    'Honeywell electrical devices and systems india limited',
    'Electrocon consumer electronics (india ) limited',
    'Dimensions infonet private limited',
    'Titanium coretech private limited',
    'Cutek circuits india private limited',
    'Tej lighting systems private limited',
    'Medical microtechnology limited',
    'Venus medsys private limited',
    'Hopeq general trading private limited',
    'Syntel international private limited',
    'Aidees electronics private limited',
    'GALAXY CONVEYORS PRIVATE LIMITED',
    'Ark electronic motion controls india private limited',
    'Ehh dee computers private limited',
    'Bhima and brother bullion private limited',
    'Mission commosales private limited',
    'Shelka marketing services private limited',
    'Traco international investment pvt ltd',
    'Vareli tecnac private limited',
    'Infrasoul techserve private limited',
    'KOLTE-PATIL PROPERTIES PRIVATE LIMITED',
    'Ritona vinimay pvt ltd',
    'Strip commodeal pvt ltd',
    'Shree mahalaxmi corporation private limited',
    'Guljag hotels pvt ltd',
    'Kent resorts private limited',
    'Baba hotels private limited',
    'Annectos rewards and retail private limited',
    'Ankit impex marketing services private limited',
    'Fairlie hotels & resorts private limited',
    'Platinum dealers private limited',
    'Fetise fashion private limited',
    'Goa coastal resorts and recreation private limited',
    'Riviera de goa resorts and hotels private limited',
    'Cambay sez hotels limited',
    'Goverdhan greens holidays private limited',
    'BHASKAR RETAIL SALES PRIVATE LIMITED',
    'Buddy star ventures private limited',
    'B v p k hotels private limited',
    'Tma hospitality services private limited',
    'Evoke resorts private limited',
    'Va foodcom private limited',
    'Living cocoon retail limited',
    'Aakarshan commosales private limited',
    'Sivalotous hotels private limited',
    'Electron online studio private limited',
    'REDBOYS SECURITY & PROTECTION PRIVATE LIMITED',
    'Ipp pumps (india) private limited',
    'Acron hotels private limited',
    'K5 restaurants & entertainment private limited',
    'Ka hospitality private limited',
    'Shivamrut resorts private limited',
    'Natraj hospitality services private limited',
    'Food ideas private limited',
    'Ajuba hotels & residency private limited',
    'SAY OVERSEAS PRIVATE LIMITED',
    'Benchmark holidays private limited',
    'Benashem tourisem private limited',
    'Karani hotels private limited',
    'Pink top hotels and motels development private limited',
    'Dangayach hotels private limited',
    'Superfine hotels private limited',
    'Heritage leisure private limited',
    'Nest hotels and resorts (kodaikanal) private limited',
    'Kunda herbals private limited',
    'Sonex fashions private limited',
    'Herman miller furniture (india) private limited',
    'Plaza hotels private limited',
    'Span hill resorts pvt ltd',
    'RIVER F&B PRIVATE LIMITED',
    'Jeeves consumer services private limited',
    'Koutilya super markets private limited',
    'Jobys online marketing and consultancy private limited',
    'Ice hospitality private limited',
    'Pilgrimage hotels private limited',
    'Springtime clubs and hosptality services private limited',
    'Purple prive resort private limited',
    'Fairmacs shipstores private limited',
    'Cmn distributors private limited',
    'East gulf trading private limited',
    'Ambrosia resorts private limited',
    'Traditional hotels private limited',
    'Ags logistics private limited',
    'Old world hospitality private limited',
    'Platinum world hospitality private limited',
    'Sanjvik terminals private limited',
    'Khanna fincap private limited',
    '1524 BESPOKE TRAVEL EXPERIENCES PRIVATE LIMITED',
    'Sonesta inns private limited',
    'Rebari logistics private limited',
    'Fairr technologies private limited',
    'Shikaku technology private limited',
    'Gour nitai fleet logistics private limited',
    'Cargo carriers india limited',
    'Reliance gas pipelines limited',
    'RHENUS CONTRACT LOGISTICS INDIA PRIVATE LIMITED',
    'POSEIDON LOGISTICS PRIVATE LIMITED',
    'Confidence shipping co private limited',
    'L&t sapura shipping private limited',
    'SHOWFREIGHT SHIPPING INDIA PRIVATE LIMITED',
    'Adani ennore container terminal private limited',
    'Atcl logistics (india) private limited',
    'Navkanj bulk ships private limited',
    'Multi star marine & shipping services private limited',
    'Ar airways private limited',
    'Premier airways limited',
    'Aerotech fms private limited',
    'Delhi trading commercial private limited',
    'NANDO',
    'S DECK PRIVATE LIMITED',
    'Arcland developers private limited',
    'Allena developers private limited',
    'Beltalk developers private limited',
    'Beauteous nirman private limited',
    'Ramaesis developers private limited',
    'Ayaan infra project private limited',
    'Ujala developers private limited',
    'Evernew infracon private limited',
    'Shuban real estate private limited',
    'Mohini niketan private limited',
    'Rjd promoters private limited',
    'Rjd developers private limited',
    'VR MALWA PRIVATE LIMITED',
    'Swift infracon private limited',
    'Paradise infraestate private limited',
    'Ge cee promotors private limited',
    'Krishan infratech private limited',
    'Inner urban infraestate private limited',
    'Canopus developers private limited',
    'The almighty buildtech private limited',
    'Sapient estates private limited',
    'Pkr infrastructure private limited',
    'Pivotal infrastructure private limited.',
    'Siripuram developers private limited',
    'Vajrasila infra private limited',
    'AMARPRAKASH LIFESPACES PRIVATE LIMITED',
    'Drishti land and estates private limited',
    'Narang realty private limited',
    'S.d. infrastracture & real estate private limited',
    'Witmer enterprises private limited',
    'Sp project and investments (india) private limited',
    'Jay vijay builders pvt.ltd.',
    'Himadri resorts private limited',
    'West bengal industrial land holdings private limited',
    'Collage design private limited',
    'Forward manufacturing company private limited',
    'Zentech offshore engineering private limited',
    'Pacific mining products private limited',
    'Linkers india logistics private limited',
    'Lakeland india private limited',
    'Spm techsolutions private limited',
    'Saraswati packaging industries private limited',
    'CALPRO SPECIALITIES PRIVATE LIMITED',
    'Beesdale communications private limited',
    'Ndlo secretarial services private limited',
    'C-quest capital green ventures private limited',
    'Moneywise media private limited',
    'Netplus broadband services private limited',
    'Apical academic infrastructure and communication private limited',
    'Surya adsystems pvt ltd',
    'Century advertising private limited',
    'Guruveda marketing private limited',
    'BHALLA CHEMICAL WORKS PRIVATE LIMITED',
    'Vandana construction company private limited',
    'CONNOISSEUR',
    'S ASSORTED COLD STORAGE LTD',
    'NAGVEER COLD STORAGE PRIVATE LIMITED',
    'Nezone warehousing private limited',
    'Vee vee bus services private limited',
    'Three i logistics india private limited',
    'Smart marine services private limited',
    'Carrypak services private limited',
    'Spring communications private limited',
    'Junotele solutions private limited',
    'Shree mallikarjun shipping private limited',
    'Formag india private limited',
    'Sunbeams travels (baroda) private limited',
    'Prarabdh communications pvt ltd',
    'E to e wireless & network solutions private limited',
    'Siticable broadband south limited',
    'Mycycle tours & travels private limited',
    'Skypass travel private limited',
    'TAMARIND GLOBAL SERVICES PRIVATE LIMITED',
    'GOOMO ORBIT CORPORATE & LEISURE TRAVELS (I) PRIVATE LIMITED',
    'Shoreline lifestyles private limited',
    'Tamilnadu power finance and infrastructure development corporation limited',
    'Sandhya holdings private limited',
    'ASHV FINANCE LIMITED',
    'Security investments limited',
    'Bay watch travels private limited',
    'TAANYA TOURS TRAVELS & FREIGHT FORWARDERS PRIVATE LIMITED',
    'Connect freight logistics private limited',
    'Bhoruka roadways india private limited',
    'SAH & SANGHI BRANDS PRIVATE LIMITED',
    'SHELLIMPEX PRIVATE LIMITED',
    'Compass telematics private limited',
    'PETERSON SERVICES INDIA PRIVATE LIMITED',
    'Tiger professional services private limited',
    'Wiseman finance pvt ltd',
    'Htc global financial services private limited',
    'Hck capital services private limited',
    'Brushapati investment and trading company private limited',
    'Rajiv ramanlal trading co. private limited',
    'Treetops capital services private limited',
    'Rr equity brokers private limited',
    'More-finanshare investments private limited',
    'Vkbs holdings india private limited',
    'Kanyakumari investment and finance pvt ltd',
    'Ankshree investments and trading company limited',
    'Brijvasan investment and trading company private limited',
    'Rajendra investment private limited',
    'Navkar investment private limited',
    'Ompareek investment company limited',
    'Kasyap finance private limited',
    'Mukesh babu securities ltd',
    'Shriyam broking intermediary limited',
    'Salisbury investments private limited',
    'Keygien global limited',
    'LPC SECURITIES Private Limited',
    'Goels financial services private limited',
    'Canara bank securities limited',
    'Carina finvest limited',
    'Deepa bagla financial consultants private limited',
    'Prabhudas lilladher financial services private limited',
    'Lanica financial services private limited',
    'M p vora shares and securities private limited',
    'Rajah investments private limited',
    'Saturn holdings and properties private limited',
    'Legris holding india private limited',
    'Ajmera associates limited',
    'NHC OVERSEAS PRIVATE LIMITED',
    'Kent investments private limited',
    'Incremental securities private limited',
    'NAINI CAPITAL LIMITED',
    'Metroplitan credit co pvt ltd',
    'Sanchi business & finance pvt ltd',
    'Princep trade and finance pvt ltd',
    'Samkit finance pvt. ltd.',
    'Peerless securities ltd',
    'Sachchiyay stock broking private limited',
    'ONICRA CREDIT INFORMATION COMPANY PRIVATE LIMITED',
    'MONEYPALM BROKERS PRIVATE LIMITED',
    'TOWER RESEARCH CAPITAL MARKETS INDIA PRIVATE LIMITED',
    'Iit investrust limited',
    'MSSA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'Pankaj shawls private limited',
    'Anugrah portfolio advisorpvt ltd',
    'Surendra fiscal services private limited',
    'Puneet advisory services private limited',
    'Epsilon capital management private limited',
    'Ahn consultants private limited',
    'Tp power holdings private limited',
    'Roshan foundations limited',
    'Shs financial services private limited',
    'PARVATHIPURAM NIDHI LIMITED',
    'Indiafilings private limited',
    'Batlivala & karani capital private limited',
    'Ved financial consultancy services p.ltd.',
    'Yash dream real estate limited',
    'Acme spaces private limited',
    'Aadinath promoters and developers private limited',
    'Shubhrashi kutir private limited',
    'Hca infrastructure private limited',
    'Pushpa properties pvt ltd',
    'Ishar estates and properties private limited',
    'Ajitesh estates private limited',
    'BLAK-N-WHYTE AGENCY PRIVATE LIMITED',
    'Truly creative developers private limited',
    'Kabra properties and securities private limited',
    'Darvesh bussa realtors private limited',
    'Pleasant builders private limited',
    'Gardenia properties private limited',
    'Brookefield constructions private limited',
    'White cliff realty private limited',
    'Yellow stone realty private limited',
    'Spire premises private limited',
    'Tamarind premises private limited',
    'Manisha elite realty private limited',
    'Shivjot developers and builders limited',
    'STAMLO INDUSTRIES LIMITED',
    'Bishal abasan india limited',
    'HACKBERRY RAYLAND ADVISORY PRIVATE LIMITED',
    'Avinash realtors private limited',
    'Mag realbuild private limited',
    'Kkg properties private limited',
    'Ssd realtors private limited',
    'Hika ventures private limited',
    'Vibhor home developers private limited',
    'Luar infratech private limited',
    'Matt projects private limited',
    'John estates private limited',
    'Prestige construction ventures private limited',
    'NEXUS SHANTINIKETAN RETAIL PRIVATE LIMITED',
    'Agasthya holdings private limited',
    'Places real estate solutions private limited',
    'Sajawat dwellers private limited',
    'Damini properties pvt.ltd.',
    'Urmila realtors private limited',
    'Mask properties management private limited',
    'Electra estates private limited',
    'Tatwa infrastructure private limited',
    'GREENFIELD MANOR PRIVATE LIMITED',
    'Dattatreya lifestyle private limited',
    'Man-mandir shelter private limited',
    'Customer lab solutions private limited',
    'Vav management services private limited',
    'Compucrafters india private limited',
    'B.m.corporate services private limited',
    'Chess management services private limited',
    'VALUEBRIGHT CONSULT SOLUTIONS PRIVATE LIMITED',
    'Gm corporate service private limited',
    'Webcon consulting (india) limited',
    'Future zone private limited',
    'B. CONSULTANCY & SOLUTIONS INDIA PRIVATE LIMITED',
    'Shyam technical services pvt ltd',
    'Jay shree it consultants limited',
    'Innova unified management services private limited',
    'Dalmia management private limited',
    'Amigos solutions private limited',
    'Anand environmental consultants private limited',
    'Gateway engineering & project management private limited',
    'Jayathe petrotech engineers and consultants private limited',
    'Essence engineering private limited',
    'Nn combined engineering agencies private limited',
    'Yaga technologies private limited',
    'I solutions tele network private limited',
    'I. m. engineering works private limited',
    'Biltech engineers private limited',
    'Spintex marketing consultancy private limited',
    'Transrail logistics limited',
    'Ans tempcontrol engineers private limited',
    'Shivam concrete technology and consultancy private limited',
    'San engineering and locomotive company limited.',
    'Cdm smith india private limited',
    'Sunlarge properties private limited',
    'Viridis architecture private limited',
    'Architectural lighting concepts private limited',
    'De 3.2 architects private limited',
    'Perfect engineering associates private limited',
    'RUBAMIN PRIVATE LIMITED',
    'Kind health and hygiene private limited',
    'YESHA TILES PRIVATE LIMITED',
    'Land mark tiles private limited',
    'Amalgamated synthetic moulders pvt ltd',
    'Yokostone continental limited',
    'Ivax properties private limited',
    'Situ plastic industries pvt ltd',
    'Intelligent infrastructure limited',
    'T t l minerals exports pvt ltd',
    'Metal corporation of india limited',
    'Detlon services private limited',
    'Pns metals limited',
    'Sanvijay rolling and engineering limited',
    'Kamdar distributors private limited',
    'TIJARIA VINYL PRIVATE LIMITED',
    'Meghdoot intertrade pvt ltd',
    'Bhartiya metacast private limited',
    'Ipi steel ltd',
    'Kanu brush care private limited.',
    'Thermotek composite industries private limited',
    'Awdhan trading co ltd.',
    'Sharp ferro alloys limited',
    'Win enterprises private limited',
    'K.p.n.auto wings private limited',
    'Coalman coal benefication (india) private limited',
    'Designed products limited',
    'Interkrafts autocity private limited',
    'PAL AUTOMOTIVES PRIVATE LIMITED',
    'Turtle automobiles private limited',
    'Kandla motors private limited',
    'Netambit infosource and e services private limited',
    'Track manufacturing co. private limited',
    'Howrah 2 wheelers private limited',
    'Guru nanak auto enterprises limited',
    'Harmony motors private limited',
    'Trishna skyscraper limited',
    'Srinivasa cars private limited',
    'Jagsak realtors private limited',
    'Weavernest construction private limited',
    'Aztech india private limited',
    'Veeteejay mobikes private limited',
    'Plantiss agrotech private limited',
    'Tradeswift commodities private limited',
    'Megaa moda private limited',
    'Incredible dealcom private limited',
    'Invention vincom private limited',
    'Keymer bagshawe marketing co pvt ltd',
    'Happy vyapaar pvt. ltd.',
    'Ajanta vyapaar pvt. ltd.',
    'Pampar ovenfresh foods private limited',
    'Soft touch commercial private limited',
    'Starlite commercial pvt ltd',
    'Kamal dealcom private limited',
    'Bakul agencies private limited',
    'Bakul commotrade private limited',
    'Bakul traders private limited',
    'Bhootra mercantiles private limited',
    'Irl insurance consultants private limited',
    'Satyavachana commotrade private limited',
    'MICROSYS INFOTECH AND TELECOM PRIVATE LIMITED',
    'SIDDHARTH ADVISORY SERVICES PRIVATE LIMITED',
    'Shogun vanijya private limited',
    'OM ARIHANT KRIPA COMMODITIES & MERCHANDISE PRIVATE LIMITED',
    'Federal - mogul ignition products india limited',
    'Lnb commercial private limited',
    'Manish vinyls private limited',
    'Grampus impex private limited',
    'Rajkaur overseas private limited',
    'TECHNOVILLE CONSULTANTS PRIVATE LIMITED',
    'Elegant dealers private limited',
    'S b p commercial pvt ltd',
    'Sherawali embroidery private limited',
    'Balgopal merchandise private limited.',
    'Japan steel works india private limited',
    'Matrix synergies private limited',
    'Two plus marketing private limited',
    'John distilleries private limited',
    'Shree shyamji tradeimpex private limited',
    'Ideal concepts private limited',
    'SHARIKA ENTERPRISES LIMITED',
    'Aricia india international private limited',
    'Jupiter international limited',
    'SUMAN PROPERTIES & TRADERS LTD',
    'Gangaur exports private limited',
    'Granville trading india private limited',
    'S g s silk mills private limited',
    'Times exim private limited',
    'Junach limited',
    'Bcpl railway infrastructure limited',
    'Punit marketing pvt ltd',
    'Sukhsagar vanijya private limited',
    'Sasana enterprises private limited',
    'Acoustic arts private limited',
    'Uttam (bharat) electricals pvt.ltd.',
    'Medionics india private limited',
    'Krypton biomedicals private limited',
    'Bienstar biogenics private limited',
    'New india biopharma private limited',
    'Shimmer land commercial private limited',
    'Thulasi pharmacies india private limited',
    'United laboratories india pvt ltd',
    'Meridian jewels private limited',
    'Rauli trees merchants private limited',
    'M.s.j. chemicals worldwide limited',
    'Worldwide urja limited',
    'Lehanaa enterprises private limited',
    'Shivani interior solutions private limited',
    'Snow flower sales private limited',
    'Vikrant techno steel private limited',
    'Hotel ans international limited',
    'Swastikarmaan steels private limited',
    'Ebaco india private limited',
    'Hysel india private limited',
    'Nova biological systems private limited',
    'Iprocess clinical marketing private limited',
    'Jagjan private limited',
    'Yamini barter private limited',
    'Acyutam etrade private limited',
    'Tulip vinimay private limited',
    'Mayank marketing private limited',
    'JIFFY TRAVELS PRIVATE LIMITED',
    'Primacy global enterprises private limited',
    'Raasaa retail private limited',
    'Gainridge investment advisory private limited',
    'G m c impex private limited',
    'Indo metalloys private limited',
    'MARUSHIKA TECHNOLOGY ADVISORS PRIVATE LIMITED',
    'Rakesh masala private limited',
    'O.s.automobiles private limited',
    'Apeejay eximp pvt ltd',
    'Shree kripa cloths private limited',
    'Harpinder real estates private limited',
    'Unitech realty ventures limited',
    'Jatinder pal builders private limited',
    'SPSEA HOSPITALITY PRIVATE LIMITED',
    'Angelica developers limited',
    'Palchin real estates private limited',
    'Empower builder private limited',
    'Mayflower developers private limited',
    'Glittery realty and construction private limited',
    'Flamboyant developers private limited',
    'Heart beat properties private limited',
    'Hbs arch studio private limited',
    'Sabarmati projects private limited',
    'Morpheus infrastructure private limited',
    'Godavari builtech private limited',
    'Landworks private limited',
    'Kewal properties and estates pvt.ltd.',
    'Pranava avenues private limited',
    'Adinath devcon private limited',
    'Balgopal realdev private limited',
    'Space olympia properties private limited',
    'Saipan infrastructure private limited',
    'EPIMONEY PRIVATE LIMITED',
    'Subha technical services private limited',
    'Sak industries private ltd',
    'Nature technologies private limited',
    'APEX SOLUTIONS LIMITED',
    'Bpa technologies private limited',
    'EMOTE INVESTMENTS PRIVATE LIMITED',
    'EMOTE HOLDINGS PRIVATE LIMITED',
    'EMOTE WEALTH PRIVATE LIMITED',
    'Cherub software private limited',
    'Pdssia it consultants private limited',
    'TECHNIP ENERGIES INDIA LIMITED',
    'Mahan computer services india limited',
    'Kartikey software private limited',
    'Tulleeho portals private limited',
    'Interra infotech india private limited',
    'IVISTEC PARTNERS INDIA PRIVATE LIMITED',
    'Abira nirman udyog limited',
    'Taab software solutions private limited',
    'Processworks information technology private limited',
    'Okaya infocom private limited',
    'Orion nsf technologies private limited',
    'Himalayan infra projects private limited',
    'Graype systems private limited',
    'Codera technologies private limited',
    'Pushpit properties private limited',
    'Swarnatura realty private limited',
    'Kct realcon private limited',
    'Nelson projects private limited',
    'Maxwell and stuart project management private limited',
    'Manak infratech private limited',
    'Duke shine promoters and developers private limited',
    'Zeus infratech india private limited',
    'V p exim infracon private limited',
    'Susthira enterprises private limited',
    'Sri veda vinayagar foundations private limited',
    'Red pepper properties private limited',
    'Jamuna sagar developers private limited',
    'Sugam promoters private limited',
    'Navam estates private limited',
    'Mediapro learning solutions private limited',
    'Zraddhaa information services private limited',
    'WSP CONSULTANTS INDIA Private Limited',
    'Ask e-square business solutions private limited',
    '22nd century software solutions (india) private limited',
    'Xpert technosoft solutions private limited',
    'Dynamic gold infra limited',
    'B d investment enterprises pvt ltd',
    'Enjay apartments pvt ltd',
    'Samir enterprises private limited',
    'Realtrack infotek private limited',
    'Stratogent technology services private limited',
    'Pana infotech private limited',
    'Qualsys technologies private limited',
    'Grassroots bpo private limited',
    'Credii technologies private limited',
    'Weown services private limited',
    'Comatec global private limited',
    'COOKPAD INDIA TECHNOLOGIES PRIVATE LIMITED',
    'Ar infomatrix private limited',
    'Ryzklytix consulting solutions private limited',
    'Paradigm it private limited',
    'Itsys solutions private limited',
    'Orbit coatings pvt ltd',
    'Tera informatics private limited',
    'Hinduja group limited',
    'One network (india) private limited',
    'REMIGES TECHNOLOGIES PRIVATE LIMITED',
    'SPRYLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'Manthantec consulting services pvt. ltd.',
    'CSM TECHNOLOGIES PRIVATE LIMITED',
    'Dimari it services india private limited',
    'Inflexi technologies private limited',
    'Mund consulting private limited',
    'Jst technologies private limited',
    'Vcare software solutions private limited',
    'Vtouch hitechnologies private limited',
    'Human network private limited',
    'Detecvision technologies private limited',
    'Merkur gaming india private limited',
    'Unicus infolabs private limited',
    'Rsi softech india private limited',
    'LENCIA CONSULTING PRIVATE LIMITED',
    'TELEMATICS WIRE PRIVATE LIMITED',
    'Azazo private limited',
    'Pernia qureshi consultancy private limited',
    'Royal fables private limited',
    'Barcos hospitality india private limited',
    'Wtvision solutions private limited',
    'Mangalam hospital pvt ltd',
    'S k facility management services private limited',
    'ESTHETICA SPA & SALON RESOURCES PRIVATE LIMITED',
    'N.a safecare hospitals private limited',
    'Dsk studios private limited',
    'Miraj entertainment limited',
    'Imagepro private limited',
    'Naba diganta water management limited',
    'Sudha money changers private limited',
    'Cottonconnect (south asia) private limited',
    'Skyline motors (india) private limited',
    'Dalimit associates private limited',
    'Franco indian research private limited',
    'Harris builders private limited',
    'Proedge technologies private limited',
    'Seven seas forgings private limited',
    'AMBER ENTERPRISES INDIA LIMITED',
    'Kalinga aluminium co pvt ltd',
    'Shyamnagar tin factory private limited',
    'Radar commercials private limited',
    'Chemmanur jewelleries (bangalore) limited',
    'Southco (india) private limited',
    'Vinar precision products private limited',
    'Dhanman precicast pvt ltd',
    'Leo ispat limited',
    'NEXO INDUSTRIES Private Limited',
    'K.k.metals private limited',
    'Accrete innovations private limited',
    'Belim steels private limited',
    'SHRI VAIBHAV METACAST PVT LTD',
    'Thermaline aluminium private limited',
    'Spm autocomp systems private limited',
    'INLAND INSULATIONS PRIVATE LIMITED',
    'FLOWMART (INDIA) PRIVATE LIMITED',
    'Swayambhu engineering private limited',
    'Arya prime enterprises private limited',
    'Dacc international private limited',
    'T. m. apparels private limited',
    'Kamal metals pvt ltd',
    'Aqua machineries private limited',
    'Innovative process equipments private limited',
    'National implement (india) private limited',
    'Fristam pumps (india) pvt ltd',
    'L s engineers private limited',
    'CEE DEE VACUUM EQUIPMENT PVT LTD',
    'Laxmi oil pumps and systems private limited',
    'Shavo norgren (india) private limited',
    'M F RINGS AND BEARING RACES PRIVATE LIMITED',
    'MASCOT CNC TOOLS & EQUIPMENTS PRIVATE LIMITED',
    'Gkn sinter metals private limited',
    'Yogiraj smelters private limited',
    'Bright foundries coimbatore private limited',
    'Himalayan components (india) private limited',
    'Autus advisors private limited',
    'Gravitie knowledge services private limited',
    'Sparkling hues gems private limited',
    'Sayani metals private limited',
    'White metals limited',
    'JYOTI SOLUTIONSWORKS PRIVATE LIMITED',
    'Ratusaria industries private limited',
    'PROTECH ENGINEERING INDUSTRIES PVT LTD',
    'Galore international projects private limited',
    'Welmade locking systems private limited',
    'Advanced crushing engineers private limited',
    'Shraddha rollers private limited',
    'Ohaus weighing india private limited',
    'CREESTAA ELEVATORS EQUIPMENT PRIVATE LIMITED',
    'Msk products private limited',
    'Sidharth turnkey projects private limited',
    'Electronica hitech machine tools private limited',
    'Agrosaw (india) private limited',
    'West bengal agro-industries corpn ltd',
    'Arc craft exports private limited',
    'Glen appliances private limited',
    'AMIGLOBAL ENTERPRISES PRIVATE LIMITED',
    'Rotmax engineering enterprises private limited',
    'Prima automotive private limited',
    'Vasutech automations private limited',
    'Griphold engineering private limited',
    'Chanderpur industries private limited',
    'Fischer connectors india private limited',
    'Ace flow control private limited',
    'Fagor automation india private limited',
    'Shailesh machine tools private limited',
    'Informatics (india) limited',
    'Sree venkateshwara valves & pumps private limited',
    'Svp mining technologies private limited',
    'Premier tech aqua systems india private limited',
    'Bull excavators india private limited',
    'Helix precision limited',
    'Shreeram metafusion engineers pvt ltd',
    'Murata machinery india private limited',
    'Creative manufacturing solutions (india) private limited',
    'Heattrans equipment private limited',
    'Tufit mechatronics private limited',
    'Pristine plants (india) private limited',
    'T & i engineers private limited',
    'Sarens heavy lift india private limited',
    'Nano cranes private limited',
    'Ritters automation private limited',
    'Navkar packaging pvt ltd',
    'Karl mayer india private limited',
    'INDIAN ION EXCHANGE & CHEMICALS LIMITED',
    'Dewpoint air and systems engineering pvt ltd',
    'Sarvodaya sucrotech limited',
    'Crane-bel international private limited',
    'Encon renewable private limited',
    'Bisu agritech private limited',
    'EUROTECK ENVIRONMENTAL PRIVATE LIMITED',
    'Kusters calico machinery private limited',
    'Mutha engineering private limited',
    'Gemata industry india private limited',
    'Yudo hot runner india private limited',
    'Jaipur mechanical works private limited',
    'Salgaocar heavy industries private limited',
    'THE WESMAN ENGINEERING COMPANY PRIVATE LIMITED',
    'Pelican rotoflex private limited',
    'Pica type systems private limited',
    'Kambert machinery company private limited',
    'AUTHENTIC INSTRUMENT INDUSTRIES LIMITED',
    'Imv india private limited',
    'Beandes appliances private limited',
    'Sriram eco-raksha computer services private limited',
    'Sks sales private limited',
    'LAVISH EXIM',
    'Ceiling impex private limited',
    'Shree panchganga agro impex private limited',
    'Good times enterprises private limited.',
    'Hello trade online private limited',
    'Ktm impex private limited',
    'UR SUGAR INDUSTRIES LIMITED',
    'Elation impex private limited',
    'Ngda services private limited',
    'Tekno derm mediequip private limited',
    'Williams-sonoma india private limited',
    'Amtrak info system private limited',
    'Machtools technoserve private limited',
    'Crown tradex private limited',
    'Livguard energy technologies private limited',
    'Jaina india private limited',
    'The marsden bakubhai and sons private limited',
    'Rais marketing private limited',
    'Kains ventures private limited',
    'India coffee and tea distributing company limited',
    'Jamnagar investment co pvt ltd',
    'TAO DESIGN STUDIO PRIVATE LIMITED',
    'Shrigopal rameshkumar sales private limited',
    'MP OFFSHORE PRIVATE LIMITED',
    'UV&W PRODUCTS PRIVATE LIMITED',
    'Brisco private limited',
    'Sunwave vinimay pvt ltd',
    'Abira commotrade limited',
    'Prakruti import export private limited',
    'MP AUTOMOTORS PRIVATE LIMITED',
    'Tenatra intertrade private limited',
    'Polyflor india private limited',
    'Purplebond fashion private limited',
    'Deepak international limited',
    'J. g. s enterprises private limited',
    'Senkush traders private limited',
    'Yash global limited',
    'Navigator sourcing services india private limited',
    'B.jain exports (i) private limited',
    'Iris vision private limited',
    'VALEO INDIA PRIVATE LIMITED',
    'Led linear india private limited',
    'Kanta sales private limited',
    'Noyyal communications private limited',
    'Kvr systems sales and services private limited',
    'Guiness commodities private limited',
    'Bhawani vyapaar pvt. ltd.',
    'RDG SYSTEMS & SOFTWARE PVT.LTD.',
    'Quency consultancy pvt ltd',
    'Chitragupta sales & services pvt ltd',
    'Icp (india) private limited',
    'Aditi commodities private limited',
    'Simpark infrastructure private limited',
    'RELYABLE FINANCE AND INVESTMENT SOLUTIONS PRIVATE LIMITED',
    'Pickup tradelink pvt ltd',
    'Foto best private limited',
    'Approch marketing private ltd',
    'Beau jhelum traders and developers private limited',
    'Poomkudy agencies private ltd',
    'Trium marketing and consultants private limited',
    'Elements homestead products private limited',
    'Sg chemicals and dyes trading limited',
    'Vee n dee impex private limited',
    'Kamal autocare private limited',
    'Lakeforest wines private limited',
    'Vaikunth dham exim private limited',
    'Chakradhari dealcom private limited',
    'Vignesh traders private limited',
    'Aaa mercantile private limited',
    'Simplex dealtrade private limited',
    'Vrs foods limited',
    'Aakarshan sales private limited',
    'Soga commodities private limited',
    'Torrent tradelinks private limited',
    'Everest creators private limited',
    'Genuine vintrade private limited',
    'Rosemount sales private limited',
    'Superlite commosales private limited',
    'S4 exports and imports private limited',
    'Anamika marketing pvt ltd',
    'Raghvendra vinimay private limited',
    'Vinayak commotrade private limited',
    'Novelty merchants private limited',
    'Ramdoot commerce private limited',
    'Chandrashekhar exports private limited',
    'Maniams marketing services private limited',
    'Greerex (india) pvt ltd',
    'Contemporary industries limited',
    'Kamaldhan sales private limited',
    'Flowtop dealers private limited',
    'Foremost commotrade private limited',
    'Lookline vanijya private limited',
    'Touchwin suppliers private limited',
    'Saj marketing pvt ltd',
    'Deepeejay textiles pvt ltd',
    'Jay commotrade private limited',
    'Deepsikha marketing pvt ltd',
    'Mawandia estates pvt ltd',
    'Envigo marketing private limited',
    'Federal-Mogul Powertrain Solutions India Private Limited',
    'Katna kantha trading private limited',
    'Jhalani ferro alloys private limited',
    'Quash products india private limited',
    'Arrow it private limited',
    'As information technology private limited',
    'Nigo technologies private limited',
    'Sarang services private limited',
    'Workxmate technologies private limited',
    'Evosys consultancy services private limited',
    'Sproutobjects technologies private limited',
    'Anu information technologies private limited',
    'G k v computers and solutions private limited',
    'Fornax systems private limited',
    'Kalpatharu software limited',
    'Mobax networks private limited',
    'Sakthi infogy solutions private limited',
    'Ideatec softwares india private limited',
    'Globrin (india) private limited',
    'Iness technology private limited',
    'Woods realtors limited',
    'Profoundis labs private limited',
    'ODISHA KNOWLEDGE CORPORATION LIMITED',
    'Elecom software private limited',
    'Web spiders private limited',
    'Abs infolink (india) private limited',
    'Softobiz technologies private limited',
    'People connect private limited',
    'S a e movers private limited',
    'Dimension advisory services private limited',
    'VOLTY IOT SOLUTIONS PRIVATE LIMITED',
    'Prateeti infotech private limited',
    'Techniecode software solutions private limited',
    'Universal cargo solutions private limited',
    'Varshyl technologies private limited',
    'Onsumaye web solutions private limited',
    'Hindsoft technology private limited',
    'Ilog solutions india private limited',
    'Shreepati computech private limited',
    'Rachana infotech private limited',
    'Encore corporate services private limited',
    'Sun software solutions private limited',
    'Prometheus technologies private limited',
    'Bolster solutions private limited',
    'Indian furniture products limited',
    'Avon solutions & logistics private limited',
    'Kavniya technology solutions private limited',
    'Hi - commands tech india limited',
    'Dart innovations and technologies private limited',
    'NED TECHNOLOGY PRIVATE LIMITED',
    'Orisenc technologies private limited',
    'Calibrage info systems private limited',
    'Gfa fashion apparels private limited',
    'BIZZ IMPACT INFOTEC PRIVATE LIMITED',
    'POWER TECHNOLOGY COMPUTERS PRIVATE LIMITED',
    'Rave maxpro it solutions limited',
    'Mobigraph solutions india private limited',
    'Fis global business solutions india private limited',
    'Servers india.net private limited',
    'Kamyab infotech private limited.',
    'Studiosoft solutions private limited',
    'Easy design solutions private limited',
    'Benma infosol private limited',
    'Cynosure technologies private limited',
    'Pure incense private limited',
    'Acrossdomain solutions private limited',
    'Drishti-soft solutions private limited',
    'Gypsum network private limited',
    'Rsg media systems private limited',
    'Automation network and services private limited',
    'P. g. infometic private limited',
    'Telecraft e-solutions private limited',
    'Thomson digital (india) limited',
    'Srk technology private limited',
    'Nysa communications private limited',
    'Evolution developers private limited',
    'GEO IT SKILLS PRIVATE LIMITED',
    'Pacific bpo private limited',
    'Yuvisha technologies private limited',
    'Webenture technologies private limited',
    'Magic host informatics private limited',
    'Invoxel technologies private limited',
    'Helm analytics private limited',
    'Shaant infosystems private limited',
    'Venkatesh technosoft solution private limited',
    'Ribbun software private limited',
    'Esgk it solutions private limited',
    'Scada tech solutions india private limited',
    'Embee software pvt ltd',
    'Sirion labs private limited',
    'Newgen digital solutions private limited',
    'Impec soft solutions private limited',
    'Milestone plm solutions private limited',
    'Thirty six labs private limited',
    'Skillteaser technologies private limited',
    'Anant infomedia private limited',
    'Searce cosourcing service private limited',
    'Icoderz solutions private limited',
    'Bosleo technology private limited',
    'Resilinc solutions private limited',
    'Tornado software private limited',
    'Socit technologies private limited',
    'AEREN KPO SERVICES PRIVATE LIMITED',
    'Moonshine eservices private limited',
    'Rydberg infratechnics private limited',
    'Black butterfly web designer private limited',
    'Prolim infosystems private limited',
    'Mct cards & technology private limited',
    'Imerit technology services private limited',
    'Nanochip solutions private limited',
    'Posibolt solutions private limited',
    'Medialogic solutions private limited',
    'Cricket association of india',
    'Beautiful bay entertainment private limited',
    'Internationalexpo federation chamber of commerce and industries',
    'SARRVAD SOLUTIONS PRIVATE LIMITED',
    'Yen expo private limited',
    'Unitech chandra foundation',
    'Bilasa medicals private limited',
    'Primecare medical services and multispeciality clinics (india) private limited',
    'Suryansh broadcasting private limited',
    'Jyoti awareness foundation',
    'Phaze experience design services private limited',
    'Piron india corp private limited',
    'Indsight growth partners advisors private limited',
    'Easy fix handy solutions india private limited',
    'Centre for fundraising solutions private limited',
    'Futureworks media limited',
    'Vatsal healthcare solutions private limited',
    'K venkataswamy and company private limited',
    'Ernakulam medical centre pvt ltd',
    'Azad body builders p ltd',
    'Touche golf club private limited',
    'Kraska zone training private limited',
    'My tech bay services private limited',
    'RMDC RESTAURANTS PRIVATE LIMITED',
    'Doctor on call private limited',
    'Bohra bros production private limited',
    'Slideways industries private limited',
    'Interactive television private limited',
    'International health care products limited',
    'Securico systems private limited',
    'Pacific rim alliance india private limited',
    'Fifth reich strategic solutions private limited',
    'Ack infrastructure service private limited',
    'Samaj electoraltrust association',
    'Sholay media and entertainment private limited',
    'Virtual studio private limited',
    'Finesse beauty salon private limited',
    'Netambit iservices limited..',
    'BHAGWATI RECYCLING PRIVATE LIMITED',
    'Sai mail solutions private limited',
    'Remedial resolution advisors private limited',
    'Scorpio television india pvt ltd',
    'Sam movies entertainment private limited',
    'Parshuram artefacts private limited',
    'Salt experiences and management private limited',
    'Famous studios limited',
    'Takshila seas and resorts private limited',
    'Q events private limited',
    'Balaji entertainment (gujarat) private limited',
    'Manikaran utility services company limited',
    'Chartwell estates private limited',
    'INOX INDIA LIMITED',
    'Navyug pharma- chem pvt. ltd.',
    'Ideal instutite pprivate limited',
    'Marathon garment manufacturing company private limited',
    'Dip naturals project consultancy private limited',
    'Motricity india private limited',
    'LADAM FLORA PRIVATE LIMITED',
    'Veritas properties private limited',
    'JAI SHIVSHAKTI HEALTH & EDUCATIONAL FOUNDATION',
    'Asra stampings pvt ltd',
    'Kohinoor broadcasting corporation limited',
    'Quadrant televentures limited',
    'THE RAVALGAON SUGAR FARM LIMITED',
    'Neelamalai agro industries limited',
    'Naga dhunseri group ltd.',
    'GOODRICKE GROUP LIMITED',
    'ORIENTAL RAIL INFRASTRUCTURE LIMITED',
    'Ingersoll-rand (india) limited',
    'Madhav marbles and granites limited',
    'Mint investments ltd',
    'Heritage foods limited',
    'Kanco tea & industries limited',
    'Dhunseri investments limited',
    'Gujarat raffia industries limited',
    'Shiva suitings ltd',
    'Bannari amman spinning mills limited',
    'Shree ganesh forgings limited',
    'R.k.wire products ltd',
    'Premco global limited',
    'Filaments india ltd.',
    'Thacker and company limited',
    'Veritas (india) limited',
    'Vybra automet ltd',
    'TUTICORIN ALKALI CHEMICALS AND FERTILIZERS LIMITED',
    'Syschem (india) limited',
    'STYRENIX PERFORMANCE MATERIALS LIMITED',
    'GARWARE TECHNICAL FIBRES LIMITED',
    'HLE GLASCOAT LIMITED',
    'Murudeshwar ceramics limited',
    'Kennametal india limited',
    'Vallabh steels limited',
    'Adityavani facility services private limited',
    'Prayama business solutions private limited',
    'Poojyaya security and man power services private limited',
    'Adio brand solutions private limited',
    'Skilytics india private limited',
    '45 degree private limited',
    'S. s realty myths private limited',
    'Tamilnadu chamber of commerce and industry',
    'Groom india salon & spa private limited',
    'Ashwath innovation private limited',
    'Weblight facility management private limited',
    'Al-bestower interiors private limited',
    'S s guards private limited',
    'Speedfam (india) private limited',
    'Quantum heat treaters india private limited',
    'Zebra innovations private limited',
    'Air control india private limited',
    'Agew steel manufacturers pvt ltd',
    'Mynores india pvt. ltd',
    'Unimech systems india private limited',
    'Ashley f and s engineering private limited',
    'Fleetguard filters private limited',
    'Filtrum fibretechnologies private limited',
    'Shakti pneumatic and industrial stores private limited',
    'HEICO DYNAMICS PRIVATE LIMITED',
    'Mittal precision steel tubes private limited',
    'Avenex technologies private limited',
    'Toshniwal sensors private limited',
    'Gks engineering private limited',
    'Vishal tools and forgings pvt ltd',
    'Bluemist industries private limited',
    'Flovel engineering private limited',
    'Gdbm (india) private limited',
    'Thermodyne technologies private limited',
    'Svendborg brakes (india) private limited',
    'Imr india private limited',
    'Wickman machine tools (india) private limited',
    'Jdt diamond tools private limited',
    'Carboloy precision tools india private limited',
    'Sinewave power technologies private limited',
    'Jsm oilfield services private limited',
    'Nagosasi components india private limited',
    'Craft tech cutting tools private limited',
    'Power mech industri private limited',
    'Sahayog enterprises private limited',
    'Kappa building machines private limited',
    'Mungi engineers (zahirabad) private limited',
    'Matsun casting private limited',
    'Lub solutions private limited',
    'Gedia india automotive components private limited',
    'Dabri ispat private limited',
    'Harbans lal prem kumar private limited',
    'Prayas engineering limited',
    'Deccan energy solutions private limited',
    'Brassomelt extrusions private limited',
    'Siderforgerossi india private limited',
    'Savera tubes private limited',
    'Watco india private limited',
    'Saacke machines & tools private limited',
    'Harman sales private limited',
    'Rotex controls private limited',
    'Measureall engineering company private limited',
    'Sudha ventilating systems private limited',
    'Wireform components (india) private limited',
    'Somero india private limited',
    'Whirler centrifugals private limited',
    'Magtorq engineering solutions private limited',
    'Gayson & co pvt ltd',
    'Wagatech private limited',
    'Sgj enterprises private limited',
    'Charit engineering private limited',
    'SI AIR SPRINGS PRIVATE LIMITED',
    'Creative enviro control private limited',
    'Gs engitech private limited',
    'Varsity instruments private limited',
    'Sixth sense robotics and automations private limited',
    'Kepro technologies private limited',
    'Kwality photonics pvt ltd',
    'Modern engineering services pvt ltd',
    'Filtrum tools and components private limited',
    'R.l. jain equipments private limited',
    'Lucky mycro fine appliances private limited',
    'Tomita india private limited',
    'Kamtron systems private limited',
    'Rechner infosystems private limited',
    'Unitherm private limited',
    'Pcl (india) private limited',
    'Sanmati buildcon private limited',
    'ASCENDANT STAR PRIVATE LIMITED',
    'Crystal electrodynamix private limited',
    'Elcare systems private limited',
    'Katara dental pvt ltd',
    'Konjal machines private limited',
    'Annanya interface and controls private limited',
    'Visakha wire ropes limited',
    'Heat and control (south asia) private limited',
    'Way machines india private limited',
    'Park construction pvt ltd',
    'Teknochem graphite equipments (india) private limited',
    'Aawadkrupa plastomech private limited',
    'Konar engineering services private limited',
    'Sanhua india private limited',
    'Seiko-maraica electrical manufacturing (india) private limited',
    'LEDVANCE PRIVATE LIMITED',
    'Shree sant kripa accessories private limited',
    'Kyosan india private limited',
    'B t water treatment private limited',
    'Hi tech electro repair private limited',
    'Aica engineering (india) private limited',
    'Regency semi-conductors private limited',
    'Proteck machinery private limited',
    'Delsys automation technologies private limited',
    'Shakuntalam electricals private limited',
    'Sharika lightec private limited',
    'Jagdish electronics (india) pvt ltd',
    'Philips india limited',
    'Permag products private limited',
    'Duke speciality consultants private limited',
    'Seimitsu patterns and dies private limited',
    'Chetas watertech ( india ) private limited',
    'Electrical products company (india) private limited',
    'GOLDEN VALLEY BANQUET & CATERERS PRIVATE LIMITED',
    'Hill top hospitality private limited',
    'Priyanka hospitality private limited',
    'Ishan banquet & caterers private limited',
    'Siyaram exports india private limited',
    'Ganga trademart private limited',
    'Welfia solutions private limited',
    'Annapakshi craft sources private limited',
    'Eternal hospitality private limited',
    'Windermere hotels private limited',
    'Hail finvest pvt. ltd.',
    'Snowblue business private limited',
    'Duet india hotels (pune) private limited',
    'Duet india hotels (hyderabad) private limited',
    'Duet india hotels (bangalore) private limited',
    'Duet jkm india hotels (indore) private limited',
    'Duet india hotels (chennai) private limited',
    'Duet india hotels (chennai omr) private limited',
    'Bestech hotels & resorts private limited',
    'Bestech hotels private limited',
    'Akash procon pvt ltd',
    'Ragas automation private limited',
    'Yolee hotels private limited',
    'VIVEK RETAIL (INDIA) PRIVATE LIMITED',
    'Angel imart private limited',
    'Palm lagoon backwater resorts private limited',
    'Hotel peringottukara palace private limited',
    'Eco hotels india private limited',
    'Tbz nirmal zaveri private limited',
    'Madeenastar trading company private limited',
    'Silchar enterprises private limited',
    'Sunlike suppliers private limited',
    'Eastwood dealers private limited',
    'Hillview commercial private limited',
    'Sri krishna bullion mart private limited',
    'Grand marian hotels private limited',
    'Shantsagar hotels pvt ltd',
    'Rashraj tradelink private limited',
    'Hira cement limited',
    'CARTRAIL TRADE HUB PRIVATE LIMITED',
    'Pritam hotels private limited',
    'Rsr inns private limited',
    'Secunderabad hotels private limited',
    'Dart distributors private limited',
    'Vistar green resorts private limited',
    'Kingswood hotels private limited',
    'Economy hotels india services private limited',
    'Sodder resorts private limited',
    'Duet india hotels (ahmedabad) private limited',
    'Duet india hotels (jaipur) private limited',
    'BUSY BITE FOODS AND SERVICES PRIVATE LIMITED',
    'Poppys hotel private limited',
    'NAVEEN HOTELS PRIVATE LIMITED',
    'STEELMAN TELECOM LIMITED',
    'Green emerald hotel and resort company limited',
    'Classical paradise hotels and resort limited',
    'Rudra resorts ncr private limited',
    'Nandi hospitality services private limited',
    'Hotel kanakeshwar private limited',
    'Eurochine culinary services private limited',
    'QASR HOTELS COCHIN PRIVATE LIMITED',
    'Host hotels private limited',
    '7 apple hotels private limited',
    'Pleasant hotels and resorts private limited',
    'Piva resorts private limited',
    'Black sheep hospitality private limited',
    'Breeze project india private limited',
    'Agarwal express relocation services private limited',
    'Lotus energy solutions private limited',
    'Sahara domestic & international packers & movers private limited',
    'A b t transports private limited',
    'Babina hospitalities private limited',
    'Skysea logistics (india) private limited',
    'Shrijee freight forwarders private limited',
    'Allegiance logistics private limited',
    'SARADA PALACE & RESORTS PRIVATE LIMITED',
    'Mount orchards pvt ltd',
    'Kasturi hotels pvt ltd',
    'Golden sparrow hospitality (india) private limited',
    'Hotel paras mahal private limited',
    'Sun on mount hotels private limited',
    'Assotech hotels private limited',
    'World park hotels (india) private limited',
    'Imperial shipping private limited',
    'GRAND INFRASTRUCTURE PRIVATE LIMITED',
    'Beverly hotels private limited',
    'Sreshta leisure private limited',
    'Vestin park hotels private limited',
    'Kalyan grand stay private limited',
    'Jiwan residency private limited',
    'Chestnut heights resorts private limited',
    'Osama tours and travels private limited',
    'Best india logisticss private limited',
    'Woodside hotels private limited',
    'Kochin myfair inns (india) private limited',
    'Star worldwide group private limited',
    'Kindplace hospitality private limited',
    'Venkatesh logistics private limited',
    'Calcutta rail track systems limited',
    'Prateek logistics india private limited',
    'KSA FINANCE PRIVATE LIMITED',
    'Sampark logistics private limited',
    'Safenfast carrier private limited',
    'The unified cloud private limited',
    'Pccure247 technologies private limited',
    'Hyperlink technology private limited',
    'Zsoft internet media private limited',
    'The web plant private limited',
    'Mpr ventures india private limited',
    'Gemini technical services limited',
    'SEENIT ONLINE PRIVATE LIMITED',
    'Thinksys software private limited',
    'Metropark datatech private limited',
    'Voxient solutions private limited',
    'Ses engineering private limited',
    'Allevents informations private limited',
    'Vconsyst software solutions private limited',
    'Global tech park private limited',
    'CORDIANT TRAVELTECH PRIVATE LIMITED',
    'Kelnet communication services private limited',
    'CODECLOUDS INFOTECH PRIVATE LIMITED',
    'Envyus media private limited',
    'NUPINION HEALTHCARE PRIVATE LIMITED',
    'Digilog automations private limited',
    'Brainwave (india) private limited',
    'Jerry varghese information technology private limited',
    'Cygnus technologies private limited',
    'Amoli infotech private limited',
    'Winjit technologies private limited',
    'Roundrobin tech services private limited',
    'Knowledge township limited',
    'Dgbm systems private limited',
    'SOLITAIRE INFOSYSTEMS PRIVATE LIMITED',
    'Nature9 consulting private limited',
    'Path infotech limited',
    'Sonal infosoft india private limited',
    'Fast link infotech private limited',
    'Solitaire infomedia private limited',
    'Satnam erp solutions private limited',
    'Sumona automation private limited',
    'Fingertips it solution private limited.',
    'Studio brahma private limited',
    'Wms software private limited',
    'STEP EDUCATION AND TRAINING SERVICES PRIVATE LIMITED',
    'Optimus information india private limited',
    'Kerberos system control private limited',
    'Cloudsteer technology private limited',
    'Obsitech solutions private limited',
    'In4solution private limited',
    'CRYSTAL DELTA SOLUTIONS PRIVATE LIMITED',
    'Enhanced messaging solutions private limited',
    'Jdb it care computers pvt ltd',
    'Computer point softnets esolutions private limited',
    'On semiconductor technology india private limited',
    'Grey b research private limited',
    'Seeds technical services private limited',
    'U.v. research private limited',
    'BTYCOON GLOBAL PRIVATE LIMITED',
    'Barwale foundation',
    'Genext genomics private limited',
    'Tynet technologies private limited',
    'Alletec retail solutions private limited',
    'Wog technologies private limited',
    'Star web maker services private limited',
    'Evolve consultants private limited',
    'Sanskar projects and housing limited',
    'Krishna breeders private limited',
    'Railtech infraventure private limited',
    'BREATHEEASY CONSULTANTS PRIVATE LIMITED',
    'Himadi solutions private limited',
    'Omjyoti apparels private limited',
    'Sky force security & alliance services private limited',
    'Rra corporate services private limited',
    'Nishith desai associate private limited',
    'Sonico technology and infrastructure private limited',
    'First engineering technologies private limited',
    'SHYAM SPECTRA IT SERVICES PRIVATE LIMITED',
    'Friends it services private limited',
    'Futureshift consulting private limited',
    'Silverline business pvt.ltd..',
    'Encircle exports india private limited',
    'Amiyon solutions private limited',
    'Absolutions media & technologies private limited',
    'S cube technology services private limited',
    'Tqm corpcare pvt ltd',
    'A m outsourcing services private limited',
    'Haier appliances (india) private limited',
    'Vat consultants private limited',
    'Crazyengineers technologies private limited',
    'SANTA FE ASSOCIATES INDIA PRIVATE LIMITED',
    'Inbase technologies private limited',
    'GOBELKI INDUSTRIES LIMITED',
    'YLP SOLUTIONS PRIVATE LIMITED',
    'Casagrand management services private limited',
    'Beacon analytics private limited',
    'Bodhitree technologies private limited',
    'Resergent infoteck private limited',
    'Accuster technologies private limited',
    'Umas enterprises private limited',
    'United consultancy services india private limited',
    'AQUARIUS HR CONSULTANTS PRIVATE LIMITED',
    'Atelier associates private limited',
    'Max interarch private limited',
    'Blue waters motion pictures private limited',
    'Vogue security solutions private limited',
    'Ramona consultants private limited',
    'Centtra solutions private limited',
    'Visage media services private limited',
    'I-care health & management services private limited',
    'Fabricare laundry private limited',
    'M m r property consultants private limited',
    'Indian safari lodges and camps private limited',
    'Geetanjali construction co pvt ltd',
    'Premier switchgears private limited',
    'Tai industries ltd',
    'Jayesh art jewellers (exports) private limited',
    'Edge securities private limited',
    'Top hydrofit private limited',
    'SWISS MILITARY CONSUMER GOODS LIMITED',
    'The supreme industries limited',
    'Asian star company limited',
    'Adventz securities enterprises limited',
    'Archies limited',
    'Ahluwalia contracts (india) limited',
    'ESPIRE HOSPITALITY LIMITED',
    'Marikar (motors) ltd',
    'Sidh enterprises ltd',
    'Inertia steel limited',
    'T. spiritual world limited',
    'Mahindra and mahindra financial services limited',
    'Lkp finance limited',
    'Bgil films & technologies limited',
    'Brijlaxmi leasing and finance limited',
    'PAVAPURI TRADING & INVESTMENT CO. LTD.',
    'Orson holdings co ltd',
    'Prime urban development india limited',
    'United interactive limited',
    'Meenakshi india limited',
    'Integra telecommunication and software limited',
    'Metal coatings (india) limited',
    'Oriental trimex limited',
    'Jbm auto limited',
    'Den networks limited',
    'Balkrishna industries limited',
    'Aurum infocomm limited',
    'Colorado - india construction private limited',
    'Sankalp realtors private limited',
    'MAHA MANAV MRITUNJAY INSTITUTE OF YOGA & ALTERNATIVE MEDICINE LIMITED',
    'Afflatus pharmaceuticals private limited',
    'Vika manufacturing company pvt. ltd.',
    'CMR GREEN TECHNOLOGIES LIMITED',
    'Sankalp infrastructure private limited',
    'Sanvim developers private limited',
    'G.telsoft solutions private limited',
    'Nath royal limited',
    'Kotak agri international private limited',
    'Sai sharan agriculture private limited',
    'Sutlej agro products limited',
    'Vijayakrishna spice farms private limited',
    'Lav-kush farming and development private limited',
    'Kanoi agro industries pvt ltd',
    'Lorven agriculture private limited',
    'Kedarnath cottons private limited',
    'Kalpaka rubber plantations pvt ltd',
    'Pokar agrotech private limited',
    'Cosmos green private limited',
    'Matru bhumi supply chain private limited',
    'Dr. bawasakar technology (agro) private limited',
    'Mother herbs private limited',
    'Colorcon asia private limited',
    'K p r agro farms private limited',
    'Manju vidhan agriculture pvt ltd',
    'Modinagar tea co pvt ltd',
    'Akshata cashew products limited',
    'Hosur coir foams private limited',
    'Shiva manju cashew private limited',
    'LIBERTY HOSPITALITY PRIVATE LIMITED',
    'Healthy raja farm to fork private limited',
    'Maruthi mooligai producer company limited',
    'Cap agro farms private limited',
    'Gardenia agro private limited',
    'Malayalam plantations limited',
    'Rhea realty private limited',
    'Foss india private limited',
    'Sainath agriculture private limited',
    'Bhumiputra agro private limited',
    'Shubh labh agriculture private limited',
    'Veritas agro ventures private limited',
    'SHASHWAT HOSPITALITY SERVICES PRIVATE LIMITED',
    'Krushi farming private limited',
    'Premier agro lite limited',
    'Bcm horticulture private limited',
    'Vinayaka vijay agriculture private limited',
    'Radhakant agro foods private limited',
    'Pck cotton private limited',
    'Mahad eco agrotech private limited',
    'Sawanthavadi rubber and plantation private limited',
    'Champion plastics india private limited',
    'Kari ganur iron and steel private limited',
    'SKM SIDDHA AND AYURVEDHA COMPANY (INDIA) PRIVATE LIMITED',
    'Acme tools private limited',
    'FROSTEES INDIA PRIVATE LIMITED',
    'Gks business associates private limited',
    'Mahtani chitosan private limited',
    'Indo thai foods private limited',
    'Trisha interior solutions private limited',
    'Ittina film city private limited',
    'Maharashtra state mining corporation limited',
    'Roy & co. udyog private limited',
    'Punj lloyd upstream limited',
    'GRE RENEW ENERTECH PRIVATE LIMITED',
    'Dynafluid valves and flow controls private limited',
    'Tiger surgical disposable private limited',
    'Oyster medisafe private limited',
    'Veeral controls private limited',
    'Rbs transformers and switchgears pvt ltd',
    'Meena circuits private limited',
    'Raviratna motors private limited',
    'Sheet shapers (india) private limited',
    'Eurofinance training private limited',
    'TVS AUTOMOBILE SOLUTIONS PRIVATE LIMITED',
    'Sehgal autoriders private limited',
    'Sonali castings (hyd) private limited',
    'Sugoi motors private limited',
    'Tork motors private limited',
    'Amit-raj wires private limited',
    'ELEKTROLITES (POWER) PRIVATE LIMITED',
    'Rama aircon engineers pvt ltd',
    'RAJASTHAN ELECHEM PRIVATE LIMITED',
    'Mangal electrical industries private limited',
    'Baid power services private limited',
    'Hunter electronics private limited',
    'Super seal flexible hose limited',
    'Emkay hgh auto private limited',
    'Uttaranchal appliances limited',
    'Pic view electronics pvt ltd',
    'Jagmohan automotives private limited',
    'Aisin automotive haryana private limited',
    'Anusaya auto press parts private limited',
    'Pentagaon gears private limited',
    'Filtrum autocomp private limited',
    'The hi-tech engineering systems private limited',
    'NAVGATHI MARINE DESIGN & CONSTRUCTIONS PRIVATE LIMITED',
    'Geepee shipping agencies private limited',
    'Rhythm creators private limited',
    'Hero electric devices private limited',
    'Priority power solutions private limited',
    'Responce renewable energy limited',
    'Globecast india private limited',
    'Bayland shipping agency private limited',
    'Aashirvad autotech (guj )private limited',
    'Knorr-bremse india private limited (tfr co from delhi to haryana)',
    'Stesalit limited',
    'SIMEC ENERGY INDIA PRIVATE LIMITED',
    'Filtration system solutions (india) private limited',
    'Vidyut transformers private limited',
    'Megaforge pvt ltd',
    'Sahil automobile private limited',
    'Caveo pinnacle india private limited',
    'KRISHNA PENSTONE AUTOMOTIVE PRIVATE LIMITED',
    'Donaldson india filter systems private limited',
    'Nahata comfort systems pvt ltd',
    'Indfarad technologies private limited',
    'Blooming furniture private limited',
    'F e industries private limited',
    'Aricent designs private limited',
    'Shrine empire gallery private limited',
    'Prakash wood palace private limited',
    'Akshay furnitures private limited',
    'DIAMOND AND GEM DEVELOPMENT CORPORATION LIMITED',
    'Phoenix udyog private limited',
    'Ramkrishna goldi private limited',
    'Action wood products private limited',
    'ROHITA & DEEPA DESIGNS PRIVATE LIMITED',
    'Freewill sports private limited',
    'Hi-line pens private limited',
    'Techno weigh systems private limited',
    'White mark limited',
    'Caterpillar signs private limited',
    'Seenu precision tooling systems private limited',
    'Mamta handicrafts private limited',
    'Nannooh brothers private limited',
    'B.g. distributors private limited',
    'Adgifts (india) pvt. ltd.',
    'BETTER PLANET DESIGNTECH PRIVATE LIMITED',
    'Pbk waste solutions private limited',
    'Gujarat energy transmission corporation limited',
    'Vemagiri power services limited',
    'Quarkcity energy private limited',
    'Manimahesh power private limited',
    'Arya energy limited',
    'Skoda power private limited',
    'Jakson power private limited',
    'Sagar power (dandela) limited',
    'Tt energy private limited',
    'GANESH LOCO COMPONENTS PRIVATE LIMITED',
    'Sigma auto craft private limited',
    'Precise cuts india private limited',
    'Auto solutions private limited',
    'V.b.kusumgar and company pvt ltd',
    'Bharat coach builders pvt ltd',
    'Sonil ventilfabrik private limited',
    'Sanmati engine parts exports private limited',
    'INLAKS SHIPPING COMPANY PRIVATE LIMITED',
    'Arya ship breaking co pvt ltd',
    'Hero eco med private limited',
    'Devine meditech private limited',
    'Simpex pharma private limited',
    'Shri kaustub shipping private limited',
    'SEABRIDGE STEVEDORES PRIVATE LIMITED',
    'Shantilal multiport infrastructure private limited',
    'AVON STEEL INDUSTRIES PRIVATE LIMITED',
    'Dyna automation private limited',
    'Censico international private limited',
    'Texool limited',
    'Smart hotels private limited',
    'Bell hotels pvt ltd',
    'Kapsons online private limited',
    'Sharktribe fashion (india) private limited',
    'Matrix distribution house private limited',
    'Raasleela hotels and resorts private limited',
    'HIKARI HOTELS PRIVATE LIMITED',
    'Gyan ganga limited',
    'Megacity services private limited',
    'Indotel hospitality service private limited',
    'Munnar ridgetree residences private limited',
    'Muchhala magic land private limited',
    'Jenukallu valley resort private limited',
    'Just holidays private limited.',
    'SIGNATURE SATTVA INFRATECH PRIVATE LIMITED',
    'Kass travels private limited',
    'Mercury realtors private limited',
    'Gayland hotels private limited',
    'Greenacre holdings ltd',
    'Shangri-la caterers & services private limited',
    'Baba resorts private limited',
    'Friendly adventure resorts and leisure hotels private limited',
    'KUKKEDWARA HOSPITALITY PRIVATE LIMITED',
    'HOTEL& ALLIED TRADES PRIVATE LIMITED',
    'Imperial motels private limited',
    'Jlpl resorts private limited',
    'Trishla hotels pvt ltd',
    'Mugele logistics (india) private limited',
    'Pleasure resorts private limited',
    'Saffron hotels private limited',
    'Q WEST INFRASTRUCTURE PRIVATE LIMITED',
    'Deligent road carriers limited',
    'Zad hotels private limited',
    'Menlo worldwide forwarding india private limited',
    'Ags fourwinds india private limited',
    'FALCON PAYTECH PRIVATE LIMITED',
    'Virgincar hotels private limited',
    'Somnath residency private limited',
    'Rajkamal holidays private limited',
    'Taj trade and transport company limited',
    'Sai surface transport private limited',
    'Oscar shipping agencies pvt ltd',
    'S r pusalkar and company private limited',
    'WIZ LOGTEC INDIA PRIVATE LIMITED',
    'TKW LUXURY TOURS PRIVATE LIMITED',
    'Volo shipping private limited',
    'Freight carriers private limited',
    'L&t aviation services private limited',
    'Club one airways private limited',
    'Josh helios services private limited',
    'Vision aviation private limited',
    'Koppal logistics private limited',
    'Ninex logistics private limited',
    'Dan hospitality india private limited',
    'Escapade resorts pvt ltd',
    'Poona hoteliers association',
    'Jorini hospitality private limited',
    'Ganesha hospitality services private limited',
    'Kalisma hospitality private limited',
    'Dbs corporate services private limited',
    'Topland pumps private limited',
    'Durga carriers private limited',
    'Super safe logistics (india) private limited',
    'Fast train logistics private limited',
    'HIMALAYA TRANSPORT SYNDICATE PRIVATE LIMITED',
    'KERALA RAPID TRANSIT CORPORATION LIMITED',
    'Rp cargo and logistics private limited',
    'Jindal packers and movers private limited',
    'Super eats private limited',
    'Srs cargo logistics (india) private limited',
    'Rehab lifting company pvt ltd',
    'Tristar logistics (india) private limited',
    'SHIVANGI MOTELS PRIVATE LIMITED',
    'R.r.n. hotels private limited',
    'Arunachalam hotels private limited',
    'Kesar road lines private limited',
    'Cold care services private limited',
    'ADANI KP AGRIWAREHOUSING PRIVATE LIMITED',
    'Amratlal ashok kumar cold storage and ice factory private limited',
    'Hnk travel solutions private limited',
    'Go explore private limited',
    'Kishore bagai transport pvt ltd',
    'Albatross logistics centre (india) private limited',
    'Silverlink travels private limited',
    'Rcpl logistics private limited',
    'Eprime travels.com private limited',
    'Shalimar holidays private limited',
    'Crm travel solutions private limited',
    'Consolidation cargo private limited',
    'Saras hotels private limited',
    'NCS HOTELS & RESORTS PRIVATE LIMITED',
    'Hansa vacations private limited',
    'Merinoair container lines private limited',
    'Best tourism deals (india) private limited',
    'Aadesh travels private limited',
    'Pelican travxpert private limited',
    'Anchor movers and forwarders private limited',
    'Skywaa travel management private limited',
    'Trusted freight forwarders private limited',
    'Club temmery private limited',
    'Transfare (india) private limited',
    'Abhinav transport (india) private limited',
    'Popular freight express private limited',
    'EBIX TOURS AND TRAVELS PRIVATE LIMITED',
    'COLUMBUS TRAVELS & SERVICES PRIVATE LIMITED',
    'Trade wings logistics (india) private limited',
    'Sardesai movers private limited',
    'Mb solution private limited',
    'Crony infotech private limited',
    'Lakshmi infosoul services private limited',
    'Accer technology services private limited',
    'Vaneera digi-sec labs private limited',
    'Squad systems private limited',
    'Cyber infotech private limited',
    'Cancyte technologies private limited',
    'C test medicals private limited',
    'Techno info software private limited',
    'Nms glosol communications private limited',
    'Itechline4u services & marketing solutions private limited',
    'Sandrock esecurities private limited',
    'Anb computer solutions private limited',
    'Edunext technologies private limited',
    'Ypsomed india private limited',
    'Shiv jyoti overseas india private limited',
    'Dayma infotech private limited',
    'Axle hosting private limited',
    'HHI AUTO COMPONENTS PRIVATE LIMITED',
    'Gama facility management private limited',
    'Psm consulting private limited',
    'AVNISH MERCHANDISE PRIVATE LIMITED',
    'Das corporate services private limited',
    'ARDEN ASIA PACIFIC SOFTWARE PRIVATE LIMITED',
    'INTELLOSOL SOFTWARES INDIA PRIVATE LIMITED',
    'CAMREL SMART SOLUTIONS PRIVATE LIMITED',
    'INFYSHINE TECHNOLOGIES PRIVATE LIMITED',
    'CHOCOLATE TECHNOLOGIES PRIVATE LIMITED',
    'GIANT TECH LABS PRIVATE LIMITED',
    'ACY ENTERTAINMENT PRIVATE LIMITED',
    'ROCKSOLID ENTERPRISES PRIVATE LIMITED',
    'INFOTACHUS IT SOLUTIONS PRIVATE LIMITED',
    'SRVS DIGITAL PRIVATE LIMITED',
    'C9 SOFTWARES AND SOLUTIONS PRIVATE LIMITED',
    'EPAPAYYA INDIA PRIVATE LIMITED',
    'DEWWARE IT SOLUTIONS PRIVATE LIMITED',
    'ABHIJITBANIK CREATIVESTUDIO PRIVATE LIMITED (OPC)',
    'SUMATO GLOBALTECH PRIVATE LIMITED',
    'YOUNG HATS PRIVATE LIMITED',
    'PROFICES TECHNOLOGIES PRIVATE LIMITED',
    'PALADIN COMPUTECH PRIVATE LIMITED',
    'ENERGIZER INFORMATION TECHNOLOGIES AND GLOBAL MARKETPLACES PRIVATE LIMITED',
    'AMELIA BUILDTECH PRIVATE LIMITED',
    'PRISTINE INFORMATION SERVICES PRIVATE LIMITED',
    'PROBISTICK TECHNOLOGIES PRIVATE LIMITED',
    'MUNIWAR TECHNOLOGIES PRIVATE LIMITED',
    'LEANAPPS SOFTWARE PRIVATE LIMITED',
    'ONTIME INFOTECH PRIVATE LIMITED',
    'CONVERGENCE INTERNATIONAL PRIVATE LIMITED',
    'TECH U GO PRIVATE LIMITED',
    'COMPUTENEXT INDIA PRIVATE LIMITED',
    'RK THINXMART SOLUTIONS PRIVATE LIMITED',
    'JANASPANDANA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ROADZEN TECHNOLOGIES PRIVATE LIMITED',
    'WIX COM INDIA PRIVATE LIMITED',
    'WDTS INDIA PRIVATE LIMITED',
    'RABHAV LIMITED',
    'OZYEN TECHNOLOGIES PRIVATE LIMITED',
    'PYLON TECHNAKRITI SOLUTIONS PRIVATE LIMITED',
    'GLOBAL SMART TECHNOLOGIES & SERVICES PRIVATE LIMITED',
    'SYSTEM TWO SOLUTIONS PRIVATE LIMITED',
    'RSDF INFOTECH SERVICES PRIVATE LIMITED',
    'MARA STUDIOS PRIVATE LIMITED',
    'JMS BUILDWELL PRIVATE LIMITED',
    'ENERGY BOTS PRIVATE LIMITED',
    'SQUASH APPS PRIVATE LIMITED',
    'INNDATA ANALYTICS PRIVATE LIMITED',
    'SYSARK DATASOL PRIVATE LIMITED',
    'DEVOIR SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'AMPLENVOY SOLUTIONS PRIVATE LIMITED',
    'TRULOGICS SOFTWARE AND WEB SOLUTIONS PRIVATE LIMITED',
    'NEOSME TECHNOLOGIES PRIVATE LIMITED',
    'VIEWSYNC DATA SERVICES PRIVATE LIMITED (OPC)',
    'CINCH DATA SOLUTIONS PRIVATE LIMITED',
    'KANMALAI TECHNOLOGIES PRIVATE LIMITED',
    'SIDDHARTH INFOSOFT (OPC) PRIVATE LIMITED',
    'CITY CONSOLE SYSTEM SOLUTION PRIVATE LIMITED',
    'COINSBURG VENTURES PRIVATE LIMITED',
    'ZAPTAS TECHNOLOGIES PRIVATE LIMITED',
    'OSLO SOLUTIONS INDIA PRIVATE LIMITED',
    'SUVERA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MYGURU ONLINE INDIA PRIVATE LIMITED',
    'LINCOLN TECH PRIVATE LIMITED',
    'KM MOBILE SOLUTIONS PRIVATE LIMITED',
    'IKIGAI BUSINESS CONSULTING PRIVATE LIMITED',
    'REDIPRO IT SOLUTIONS PRIVATE LIMITED',
    'TIRUPPUR BROADWAVE PRIVATE LIMITED',
    'AD-HASH TECHNOLABS PRIVATE LIMITED',
    'KATERRA TECHNOLOGIES PRIVATE LIMITED',
    'MANAGEMENT SERVICES AUTOMOTIVE (INDIA) PRIVATE LIMITED',
    'ADZORB DIGITAL PRIVATE LIMITED',
    'SPRUCE IT PRIVATE LIMITED',
    'ARI NETWORK SERVICES PRIVATE LIMITED',
    'IQUANTELA TECHNOLOGIES PRIVATE LIMITED',
    'CLOVE IT SOLUTIONS PRIVATE LIMITED',
    'WELKYN TECHNOLOGIES PRIVATE LIMITED',
    'SKEIN TECHNOLOGIES PRIVATE LIMITED',
    'OYC TECH INDIA PRIVATE LIMITED',
    'GREYRADIUS INFORMATICS PRIVATE LIMITED',
    'NXTSTACK TECHNOLOGIES PRIVATE LIMITED',
    'CLERP SOLUTIONS PRIVATE LIMITED',
    'SYBERNAUTICS SYSTEMS PRIVATE LIMITED',
    'BROCTAGON IT SOLUTIONS PRIVATE LIMITED',
    'FLAMANTETEK PRIVATE LIMITED',
    'MAXBYTE TECHNOLOGIES PRIVATE LIMITED',
    'BLOGMINT DIGITAL PRIVATE LIMITED',
    'NGFV INDIA PRIVATE LIMITED',
    'MANISHA SOFT SOLUTIONS PRIVATE LIMITED',
    'TECHNOSTRATS CONSULTING PRIVATE LIMITED',
    'SMARTWEB INTERNET SERVICES LIMITED',
    'HEPTAGON TECHNOLOGIES PRIVATE LIMITED',
    'HYPERTRACK TECHNOLOGIES PRIVATE LIMITED',
    'BLUME PLAST PRIVATE LIMITED',
    'AP TECHPINS PRIVATE LIMITED',
    'GLOCALVIEW INFOTECH PRIVATE LIMITED',
    'RIPPLE NETWORK PRIVATE LIMITED',
    'CREWLYTICS INFOTECH PRIVATE LIMITED',
    'NETFUSION SERVICES PRIVATE LIMITED',
    'EURACO TECHNOLOGIES PRIVATE LIMITED',
    'GIAAN CORPORATE SERVICES PRIVATE LIMITED',
    'THINKOLOGI PRIVATE LIMITED',
    'CAMNCLOUD TECHNOLOGIES PRIVATE LIMITED',
    'GOLDMINE IT SOLUTIONS PRIVATE LIMITED',
    'BUZYTECH IT SOLUTIONS PRIVATE LIMITED',
    'MYADVO TECHSERVE PRIVATE LIMITED',
    'SOUP2NUTZ SERVICES PRIVATE LIMITED',
    'FASTCHEK TECHNOLOGIES PRIVATE LIMITED',
    '1THING DESIGN & INNOVATION PRIVATE LIMITED',
    'KLEVERMIND INFOTECH PRIVATE LIMITED',
    'PROHORIZON DIGITECH PRIVATE LIMITED',
    'LIVE FOR LIVES INTERNET PRIVATE LIMITED',
    'IDEAKARD INDIA PRIVATE LIMITED',
    'NAVORI SOFTWARE PRIVATE LIMITED',
    'GM TECHNO SOLUTIONS PRIVATE LIMITED',
    'NIGHT FOLKS TECH PRIVATE LIMITED',
    'YOUNG IT MINDS PRIVATE LIMITED',
    'ROSHI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TAP&TICK SOLUTIONS PRIVATE LIMITED',
    'ALPHAMATE TECHNOLOGIES PRIVATE LIMITED',
    'RESONANT ELECTRONICS PRIVATE LIMITED',
    'IBERIUS TECHNOLOGIES PRIVATE LIMITED',
    'MISSISYSTEMS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WEMONDE PRIVATE LIMITED',
    'OMANGOM INFOSYSTEMS PRIVATE LIMITED',
    'O2O SOFTWARE SERVICES PRIVATE LIMITED',
    'LETREACH TECHNOLOGIES PRIVATE LIMITED',
    'AJEVA DIGITAL PRIVATE LIMITED',
    'ABSOLUTE GLOBAL WORK PRIVATE LIMITED',
    'PLANQUBE TECHNOLOGIES PRIVATE LIMITED',
    'PRODPEAK TECHNOLOGY PRIVATE LIMITED',
    'AMRITA INFOVISION PRIVATE LIMITED',
    'NABLASOL DIGITAL SERVICES PRIVATE LIMITED',
    'YUPPLE TECHNOLOGIES PRIVATE LIMITED',
    'GLOBAL IT MAGICIANS PRIVATE LIMITED',
    'ASUJA ESERV PRIVATE LIMITED',
    'COREIP TECHNOLOGY PRIVATE LIMITED',
    'SALEZSHARK SOFTWARE INDIA PRIVATE LIMITED',
    'EX SQUARED SOLUTIONS INDIA PRIVATE LIMITED',
    'ARDEM DATA SERVICES PRIVATE LIMITED',
    'ARCHER TECHNOLOGIES PRIVATE LIMITED',
    'ESSENCE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BSCUBES TECHNOLOGIES PRIVATE LIMITED',
    'ASSURESOFT TECHNOLOGIES PRIVATE LIMITED',
    'PRODIGY AUTOMOBILE TECHNOLOGIES PRIVATE LIMITED',
    'RWEBSYS TECHNOLOGIES PRIVATE LIMITED',
    'WITSYNC SOFT SOLUTIONS PRIVATE LIMITED',
    'ARIHANT PURECHEM PRIVATE LIMITED',
    'AADARSH EDUTAINMENT PRIVATE LIMITED',
    'JAGLAXMI PLASTPACK PRIVATE LIMITED',
    'PRADESH TODAY MEDIA PRIVATE LIMITED',
    'ConsultAdd Services Private Limited',
    'THE STAFFERS HR MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'VAARTHA NEWS NETWORK PRIVATE LIMITED',
    'DBL JAORA-SAILANA TOLLWAYS PRIVATE LIMITED',
    'SHREE B.S. COTTON PRIVATE LIMITED',
    'CELL REALCON CORPORATION LIMITED',
    'CINE SQUARE ENTERTAINMENT PRIVATE LIMITED',
    'GLASSHOUR MARKETING AND CONSULTANCY PRIVATE LIMITED',
    'Aplite InfoSolution Private Limited',
    'Sure International Private Limited',
    'ANAND PREMIUM CARS PRIVATE LIMITED',
    'Mittal Coin Private Limited',
    'AARNAV INFRA & TECHNOLOGY PRIVATE LIMITED',
    'Virtual Medico Technologies Private Limited',
    'Gajanand Dwellings Private Limited',
    'PARAM ERP SOLUTIONS INDIA PRIVATE LIMITED',
    'OXYZEN INFOLAB PRIVATE LIMITED',
    'Webygeeks Technologies Private Limited',
    'ACE DHWAJ ENGINEERING PRIVATE LIMITED',
    'Aagrium Farm Products Private Limited',
    'DS INVESTMENTS PRIVATE LIMITED',
    'SHREE ASHTAVINAYAK SERVICES PRIVATE LIMITED',
    'Sanit Hospitality Private Limited',
    'ALLAHABAD BYPASS PATHWAYS PRIVATE LIMITED',
    'NAINIL CONSTRUCTION PRIVATE LIMITED',
    'STAGEBUZZ EVENTS EXHIBITIONS & TV SETS PRIVATE LIMITED',
    'ADONAI TECHNOWARES PRIVATE LIMITED',
    'Outdoor Learning Resources Private Limited',
    'PALSUD MAHILA KISAN PRODUCER COMPANY LIMITED',
    'YOUNG INNOVATORS ONLINE SOLUTIONS PRIVATE LIMITED',
    'Etch Softwares Private Limited',
    'ACOEM ECOTECH INDUSTRIES PRIVATE LIMITED',
    'UPSILON PHARMACEUTICALS HEALTH CARE PRIVATE LIMITED',
    'EAST CARE HOSPITALITY AND RESORTS PRIVATE LIMITED',
    'Prestige Foundation',
    'SKGN INFRABUILD PRIVATE LIMITED',
    'MARVELLOUS OVERSEAS INDIA PRIVATE LIMITED',
    'KRISHNAKISHORE AGROTECH PRIVATE LIMITED',
    'SUMANTRA TECHSOFT PRIVATE LIMITED',
    'BADRI ECOFIBRES PRIVATE LIMITED',
    'PROBIZ MANAGEMENT SERVICES PRIVATE LIMITED',
    'PRIMO INFRASTRUCTURE PRIVATE LIMITED',
    'MMF INFOTECH TECHNOLOGIES PRIVATE LIMITED',
    'TRIVEDI LLC MARKETING PRIVATE LIMITED',
    'SMSGATEWAYHUB TECHNOLOGIES PRIVATE LIMITED',
    'OPTIMUS MANAGEMENT AND HUMAN RESOURCE CONSULTANCY PRIVATE LIMITED',
    'ALL INDIA INFORMATION TECHNOLOGY ASSOCIATION',
    'OSSWAL INFOSYSTEM PRIVATE LIMITED',
    'BAMAS RICE MILLS PRIVATE LIMITED',
    'Infxcel Education Services Private Limited',
    'Pepcus Software Services Private Limited',
    'DOLLEX AGROTECH LIMITED',
    'CONSTELL ASIA PRIVATE LIMITED',
    'Sohum Innovation Labs India Private Limited',
    'KAKAJI AUTO & AGRO PRIVATE LIMITED',
    'MARKETMAGNIFY INVESTMENT ADVISER AND RESEARCH PRIVATE LIMITED',
    'KALYAN STOCK HOLDINGS (INDORE) PRIVATE LIMITED',
    'SHRUTI SNACKS PRIVATE LIMITED',
    'NINJA INFO-SEC SERVICES PRIVATE LIMITED',
    'SEAC LOGISTICS INFRA PRIVATE LIMITED',
    'Eternal infrasolutions Private Limited',
    'SAMAY FINSERV PRIVATE LIMITED',
    'THE BASICS DIGITAL SOLUTIONS PRIVATE LIMITED',
    'DBL BETUL-SARNI TOLLWAYS LIMITED',
    'VIJAN HOTELS PRIVATE LIMITED',
    'CRUCIAL INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'I-Novate Infotech Private Limited',
    'ADELIKA RESEARCH AND AGRICULTURAL INSTITUTE',
    'FINE JOBS CONSULTANT PRIVATE LIMITED',
    'B.P. BANSAL AGRITECH PRIVATE LIMITED',
    'AFE EDUCATION PRIVATE LIMITED',
    'MASCOT LEARNING HUB PRIVATE LIMITED',
    'Kartikeya Realbuild Private Limited',
    'UP TO THE MARK ADVERTISING PRIVATE LIMITED',
    'DSE TECHNOLOGIES PRIVATE LIMITED',
    'RUPAM POLYMERS PRIVATE LIMITED',
    'SHV MULTITRADE PRIVATE LIMITED',
    'DBL BANKHLAFATA-DOGAWA TOLLWAYS PRIVATE LIMITED',
    'CONVERGENCE FUTURISTIC SOLUTION ENTERPRISE PRIVATE LIMITED',
    'ELTA Engineering Services Private Limited',
    'GBC MEGA MOTELS PRIVATE LIMITED',
    'PANASIA COMMODITY TRADING PRIVATE LIMITED',
    'SAVYUG FOODS PRIVATE LIMITED',
    'SHRI BALAJI TRADEMART(INDIA)PRIVATE LIMITED',
    'DAUTO ENGINEERING PRIVATE LIMITED',
    'AFFLUX IT SOLUTIONS PRIVATE LIMITED',
    'TARITAS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'FRONTIER TRUCKS PRIVATE LIMITED',
    'D CARNIVAL FOODS & BEVERAGES PRIVATE LIMITED',
    'ES Infraserve Private Limited',
    'KAMBY FOODS Private Limited',
    'SAFAL MANAGEMENT CONSULTANCY INDIA PRIVATE LIMITED',
    'Mahakali Nutri Foods Private Limited',
    'AROCHEM RATLAM PRIVATE LIMITED',
    'INNOVARE ACADEMIC SCIENCES PRIVATE LIMITED',
    'TRIREME LIFE SCIENCES PRIVATE LIMITED',
    'KAILASH DEVBUILD (INDIA) PRIVATE LIMITED',
    'Felix Properties Private Limited',
    'Newtechfusion Cybertech Private Limited',
    'ARYAVRAT TOLLWAYS PRIVATE LIMITED',
    'Blossom Freight Forwarding (India) Private Limited',
    'Sky Fly Logistics Private Limited',
    'NEWPORT INDIA PRIVATE LIMITED',
    'FORAY PHARMA DISTRIBUTORS PRIVATE LIMITED',
    'GABZ Multitrade Private Limited',
    'AutoCircus Retail Private Limited',
    'VENDIMAN PRIVATE LIMITED',
    'FUJI TECH PRODUCTS PRIVATE LIMITED',
    'M S SHIPPING AGENCIES PRIVATE LIMITED',
    'ROTHWELL FORMULATIONS PRIVATE LIMITED',
    'OPUS Innovation Private Limited',
    'KAZKAZI Food Concepts Private Limited',
    'MERITAS HOTELS PRIVATE LIMITED',
    'EXPLOSOFT TECH SOLUTIONS PRIVATE LIMITED',
    'Ahmedabad Logistics Park Private Limited',
    'Hoskote Logistics Park Private Limited',
    'Chakan Logistics Park Private Limited',
    'Samaira Hospitality Private Limited',
    'SUMUKH ENTERTAINMENT & HOSPITALITIES PRIVATE LIMITED',
    'Blueberry Hotels Private Limited',
    'A.S JUSTRIDE TOURS and TRAVELS PRIVATE LIMITED',
    'COZMO TRAVEL PRIVATE LIMITED',
    'SHREE BALAJI SHIPPING & PROJECTS PRIVATE LIMITED',
    'STARLINE HOSPITALITY PRIVATE LIMITED',
    'DR MOBILITY SOLUTIONS PRIVATE LIMITED',
    'UWS Integrated Logistics Private Limited',
    'F.M. TECHNOLOGIES PRIVATE LIMITED',
    'UNIWORLD EXPRESS PRIVATE LIMITED',
    'GML Teleservices Private Limited',
    'INDRIYA LIFESTYLE SERVICES PRIVATE LIMITED',
    'BOI MERCHANT BANKERS LIMITED',
    'ATLANTIS CAPITAL PRIVATE LIMITED',
    'CPPIB India Advisors Private Limited',
    'CREDENT ASSET MANAGEMENT SERVICES PRIVATE LIMITED',
    'KEEMAYA HOUSING FINANCE PRIVATE LIMITED',
    'ACE IMPRESSIONS ASSIGNMENTS AND ADVISORY PRIVATE LIMITED',
    'GROVALUE FINANCIAL SERVICES PRIVATE LIMITED',
    'CHARCOALEATS FOODTECH PRIVATE LIMITED',
    'Kangaroo Logistics Private Limited',
    'Infinity Cuisine Private Limited',
    'FINTREE FINANCE PRIVATE LIMITED',
    'EAT DRINK LOVE HOSPITALITY PRIVATE LIMITED',
    'KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD',
    'LAKSHMISHREE CAPITAL SERVICES PRIVATE LIMITED',
    'ADITYA BIRLA SUN LIFE PENSION MANAGEMENTLIMITED',
    'ADITYA BIRLA HEALTH INSURANCE CO. LIMITED',
    'Vodafone m-pesa Limited',
    'MAHIMTURA INVESTMENTS PVT LTD',
    'SAUMILYA SHAH TRADING COMPANY PRIVATE LIMITED',
    'NEMISH SHAH INVESTMENTS P LTD',
    'SONACHI HOTELS AND HOSPITALITY PRIVATE LIMITED',
    'CHOKSI TECHNOLOGIES PRIVATE LIMITED',
    'DIVYASHAKTI INNOVATIVE TRUSTEES PRIVATE LIMITED',
    'Encompass marketing and Technology Solutions Private Limited',
    'SAMYAG FOREX SERVICES PRIVATE LIMITED',
    'NS WEALTH SOLUTION PRIVATE LIMITED',
    'RUBIQUE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Vir Special Ship Private Limited',
    'BOXCOWORLD LOGISTICS INDIA PRIVATE LIMITED',
    'Financial Benchmarks India Private Limited',
    'Phillip Services India Private Limited',
    'WGC Management Services Private Limited',
    'FINSOL ADVISORS PRIVATE LIMITED',
    'VARSHNEY BUILDERS (BOMBAY) PRIVATE LIMITED',
    'FIDELITY DEVELOPERS PRIVATE LIMITED',
    'YELLOWCITY BUILDERS PRIVATE LIMITED',
    'NOVATION DEVELOPERS PRIVATE LIMITED',
    'BLUE BERRY PROPERTIES PRIVATE LIMITED',
    'Marengo Trading And Properties Private Limited',
    'SILVER VALUE HOMES PRIVATE LIMITED',
    'MODISPACES DEVELOPERS PRIVATE LIMITED',
    'TARAN PROJECTS PRIVATE LIMITED',
    'BELVA FARMS PRIVATE LIMITED',
    'FILIPPA FARMS PRIVATE LIMITED',
    'PACIFIC HABITATS INDIA PRIVATE LIMITED',
    'MAHANSARIA TYRES PRIVATE LIMITED',
    'AIKYA REALTY PRIVATE LIMITED',
    'EKTA DWELLINGS PRIVATE LIMITED',
    'SENORITA DEVELOPERS PRIVATE LIMITED',
    'ASHMORE ESTATE PRIVATE LIMITED',
    'CAMPBELL PROPERTIES & HOSPITALITY SERVICES LIMITED',
    'Sugee One Developers Private Limited',
    'Isprava Luxury Private Limited',
    'Credence Hometech Private Limited',
    'TRIBECA DWELLERS AND BUILDERS PRIVATE LIMITED',
    'Birla Infrastructure and Constructions Private Limited',
    'SAGAR PREMI BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'Birla Infrastructure and Developers Private Limited',
    'SIDKAN CONSULTANCY PRIVATE LIMITED',
    'SHAPOORJI PALLONJI DEFENCE AND MARINE ENGINEERING PRIVATE LIMITED',
    'Metropolitan Lifespace Real Estate Developers Private Limited',
    'MILEAGE LOGISTICS PRIVATE LIMITED',
    'GREAT DESIGN & DECORS PRIVATE LIMITED',
    'Haldia International Container Terminal Private Limited',
    'BBN SHIPMANAGEMENT PRIVATE LIMITED',
    'Laxmi Tripon India Private Limited',
    'TAS AVIATION PRIVATE LIMITED',
    'Acumen Technical Advisory Private Limited',
    'FENDER FORMULATIONS PRIVATE LIMITED',
    '3D FUTURE TECHNOLOGIES PRIVATE LIMITED',
    'CSE DEVELOPMENT (INDIA) PRIVATE LIMITED',
    'DELTAPHI TECH PRIVATE LIMITED',
    'NEELAMI AUCTIONEER PRIVATE LIMITED',
    'E-MERGE WORKSPACES & TECHNOLOGIES PRIVATE LIMITED',
    'HUNGUND ENTERTAINMENT & EVENTS PRIVATE LIMITED',
    'SUPERTECH PHARMA SOLUTIONS PRIVATE LIMITED',
    'Walkie Talkies Private Limited',
    'IMPACT ADS PRIVATE LIMITED',
    'INI Agri Private Limited',
    'Aryan Airport Services Private Limited',
    'Aditya Clean Power Ventures Private Limited',
    'KVM Technology Solutions Private Limited',
    'SYK STUDIO PRIVATE LIMITED',
    'PRECISE INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'Paper Design India Private Limited',
    'SNEHAN GLOBAL INDUSTRIES PRIVATE LIMITED',
    'VISCOMM 360 COMMUNICATIONS PRIVATE LIMITED',
    'WOOT FACTOR EVENTS PRIVATE LIMITED',
    'ARTHASHASTRA INVESTMENTS PRIVATE LIMITED',
    'ALT Culture Entertainment Private Limited',
    'GET SIMPL TECHNOLOGIES PRIVATE LIMITED',
    'FAIR DEAL FACILITIES MANAGEMENT PRIVATE LIMITED',
    'BRISK BRAINS PRIVATE LIMITED',
    'EVENT TRAVELER PRIVATE LIMITED',
    'MAPLE TREE BUSINESS CONSULTANTS PRIVATE LIMITED',
    'MandiBridge Retail Private Limited',
    'THE PEACE MISSION PRIVATE LIMITED',
    'Springbok Ventures Private Limited',
    'Scientifit Wellness Private Limited',
    'Labh Ventures India Private Limited',
    'Bhogilal Trusteeship Private Limited',
    'GO-EAST ADVISORS INDIA PRIVATE LIMITED',
    'Jobs for Youth Private Limited',
    'Forever Fresh Logistics Private Limited',
    'KATYAL MERCHANDISE PRIVATE LIMITED',
    'BHPC PERSONAL CARE PRIVATE LIMITED',
    'VERITAS INFRATECH PRIVATE LIMITED',
    'START & SCALE CONSULTING SERVICES PRIVATE LIMITED',
    'SUPACAT ENGINEERING SERVICES PRIVATE LIMITED',
    'SMARTERIORS INTERNATIONAL PRIVATE LIMITED',
    'INDIAN ARTISAN PRIVATE LIMITED',
    'ZEROZERO CREATIVE SOLUTIONS PRIVATE LIMITED',
    'Think Sustainable Lab Private Limited',
    'NEXUS AUDIENCE NETWORK PRIVATE LIMITED',
    'Infinitas Technology Solutions Private Limited',
    'Cirtru Classifieds Private Limited',
    'Dry Chill Industries India Private Limited',
    'Bombay High Brewing Private Limited',
    'RxHeal Commerce Private Limited',
    'ENNOVEX TECHNOLOGIES PRIVATE LIMITED',
    'HETA PERSONNEL SERVICES PRIVATE LIMITED',
    'HETA OUTSOURCE SERVICES PRIVATE LIMITED',
    'JSW Paradip Terminal Private Limited',
    'VTUFF GLAZE PRIVATE LIMITED',
    'MISTER HOMECARE SERVICES PRIVATE LIMITED',
    'ANM ISPAT PRIVATE LIMITED',
    'Gagandeep Consultancy Private Limited',
    'EZEE WHOLESALE PRIVATE LIMITED',
    'GrowTrust Ventures Consultancy Private Limited',
    'MUSAFIR CONFERENCE & SERVICES PRIVATE LIMITED',
    'TREYA WIRELESS PRIVATE LIMITED',
    'Eregon Impex Private Limited',
    'EQUENTIS WEALTH ADVISORY SERVICES LIMITED',
    'TCRC INSPECTIONS PRIVATE LIMITED',
    'TALE SPIN EDITORIAL SERVICES PRIVATE LIMITED',
    'XSTROPS CONSULTING PRIVATE LIMITED',
    'RARE EARTH ENVIRONMENT SOLUTIONS PRIVATE LIMITED',
    'Inspired Lifestyles Private Limited',
    'Vistaar Logistic Private Limited',
    'VISCOMM FILMS PRIVATE LIMITED',
    'REPLETE REAL ESTATE PRIVATE LIMITED',
    'APEX FOOD PRODUCTS PRIVATE LIMITED',
    'TECHNICUS PROJECTS INDIA PRIVATE LIMITED',
    'PYRAMIS CARGO MANAGEMENT PRIVATE LIMITED',
    'EDUISFUN TECHNOLOGIES PRIVATE LIMITED',
    'MUTTERFLY TECHNOLOGIES PRIVATE LIMITED',
    'BOMBAY METRICS SUPPLY CHAIN LIMITED',
    'VI-SON CONTROL CABLES PRIVATE LIMITED',
    'MEXCELLE TECHNOLOGIES PRIVATE LIMITED',
    'TRAVAIL TRAINING AND CONSULTANCY PRIVATE LIMITED',
    'Retrogeek Creative Private Limited',
    'TAMASHA WORLDWIDE ENTERTAINMENT PRIVATE LIMITED',
    'Fintech Blue Solutions Private Limited',
    'Korkom Manpower Solution and Consultancy Private Limited',
    'enParadigm Performance Solutions Private Limited',
    'JSW JATADHAR MARINE SERVICES PRIVATE LIMITED',
    'SABER TOOTH MEDIA PRIVATE LIMITED',
    'NUPINION LABS PRIVATE LIMITED',
    'PB LIFESTYLE FRANCHISES PRIVATE LIMITED',
    'RYGGRAD TRAINING & CONSULTING PRIVATE LIMITED',
    'SPECIFIC MECHATRONICS PRIVATE LIMITED',
    'NIVID INFORMATICS PRIVATE LIMITED',
    'GODSPEED GAMING SOLUTIONS PRIVATE LIMITED',
    'FLEXFLOW VALVES PRIVATE LIMITED',
    'EMPYRAL ELECTRICALS PRIVATE LIMITED',
    'UNIVERSAL WORLDWIDE PRIVATE LIMITED',
    'Pasistence Consultancy Services Private Limited',
    'MICRON AIR FILTERS AND EQUIPMENTS PRIVATE LIMITED',
    'Able Energy Solutions Private Limited',
    'SECURE- IT FACILITY MANAGEMENT PRIVATE LIMITED',
    'ROCHE INFORMATION SOLUTIONS INDIA PRIVATE LIMITED',
    'TouchCore Systems Private Limited',
    'SANGHVI HI-LIFT PRIVATE LIMITED',
    'RANKSKILLS KNOWLEDGE INTERNATIONAL PRIVATE LIMITED',
    'GEFCO India Private Limited',
    'HRS FLOW INDIA PRIVATE LIMITED',
    'Kjellberg Cutting and Welding India Private Limited',
    'Micro-Epsilon India Private Limited',
    'Advanced Digital Technology India Private Limited',
    'Right to Research Foundation',
    'RAAY Foundation',
    'AIR SOLUTION INDIA PRIVATE LIMITED (OPC)',
    'GEOMETRIX AUTOMATION AND ROBOTICS PRIVATE LIMITED',
    'AIWMI KNOWLEDGE MANAGEMENT PRIVATE LIMITED',
    'GAJALAKSHMI ASSOCIATES PRIVATE LIMITED',
    'Pulse Orbit Entertainment Private Limited',
    'ATMOS CARE PRIVATE LIMITED',
    'VIVACITY FOODS AND HOSPITALITY PRIVATE LIMITED',
    'SQR GLOBAL TRADING PRIVATE LIMITED',
    'MTMS ENGINEERS PRIVATE LIMITED',
    'IDEAS TO IMPACTS INNOVATIONS PRIVATE LIMITED',
    'HINDUSTAN COATINGS PRIVATE LIMITED',
    'TALENT PUNDITS HR SERVICES PRIVATE LIMITED',
    'A-Star Power Solutions Private Limited',
    'PETRA ELEVATORS PRIVATE LIMITED',
    'XOTIC GETWAYS PRIVATE LIMITED',
    'Devise Electronics Private Limited',
    'ETO MAGNETIC India Private Limited',
    'INVENTIVE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'Panatech Asia Engineering Private Limited',
    'EcoAd MARKETING AND PROMOTION PRIVATE LIMITED',
    'DELTA SARAS PIPING PRIVATE LIMITED',
    'SHAPE SPORTS AND FITNESS SOLUTIONS PRIVATE LIMITED',
    'AD FINCORP PRIVATE LIMITED',
    'SAILILA ADDLINK PRIVATE LIMITED',
    'Ideabrew Solutions Private Limited',
    'Enhancier Cx Solutions Private Limited',
    'UNICOV GLOBAL ENGINEERING PRIVATE LIMITED',
    'Pisum Food Services Private Limited',
    'SVI AND SSK CORPORATION PRIVATE LIMITED',
    'SAVI PRESSINGS PRIVATE LIMITED',
    'TRANS TECH HVAC PRIVATE LIMITED',
    'MULTICHOICE HEALTHCARE PRIVATE LIMITED',
    'SYNERGY NAVIS MARINE PRIVATE LIMITED',
    'IndianRootz Marketing Solutions Private Limited',
    'MAHA CLUSTERS COUNCIL',
    'Sanar Wellness Private Limited',
    'Excellential Consulting Services Private Limited',
    'KUUBER EVENTS PRIVATE LIMITED',
    'ACE REMEDIES PRIVATE LIMITED',
    'Truepay Payment services Private Limited',
    'VENTURIT CONSULTING SERVICES PRIVATE LIMITED',
    'SYNERGY INFRASYS MANAGEMENT PRIVATE LIMITED',
    'EAU SPARC ENERGIE PRIVATE LIMITED',
    'GLOBUS INTERNATIONAL COATERS PRIVATE LIMITED',
    'DM SWASTIK AUXILARIES AND CHEMICALS PRIVATE LIMITED',
    'SHREE JAY JAGDAMBA FLANGES PRIVATE LIMITED',
    'JAY JAGDAMBA FORGINGS PRIVATE LIMITED',
    'LALLEMAND INDIA PRIVATE LIMITED',
    'SCALE UP Private Limited',
    'R. R. INDUSTRIAL PACKAGING PRIVATE LIMITED',
    'KAT-i Infotech Private Limited',
    'Suvastu Bhoomi Vikasak Private Limited',
    'PET SETTERS INDIA PRIVATE LIMITED',
    'AMODA INFOTECH PRIVATE LIMITED',
    'DoYourCompliance Solutions Private Limited',
    'MAHARASHTRA EX-SERVICEMEN CORPORATION LIMITED',
    'SILVER JUBILEE EDUCATIONAL & SOCIAL FOUNDATION',
    'SAMVIT FOUNDATION',
    'INFINI INSTITUTE OF CONSTRUCTION PROJECTMANAGEMENT PRIVATE LIMITED',
    'PUG TECHNOLOGY FOUNDATION',
    'I-INFINITY TECHNOLOGIES PRIVATE LIMITED',
    'DIGICORE TECHNOLOGIES PRIVATE LIMITED',
    'RETRANZ INFOLABS PRIVATE LIMITED',
    'Ramkrishna IT Consulting Private Limited',
    'Transworld Educare Private Limited',
    'Sai Diligent Tutorials private limited',
    'SHB SOCIAL FOUNDATION',
    'VISION CONTAINER LINE PRIVATE LIMITED',
    'SRINIVASA INFRA BUILDCON INDIA PRIVATE LIMITED',
    'Transworld Healthcare Private Limited',
    'D & F SHINE SERVICES PRIVATE LIMITED',
    'LEAP & SCALE PRIVATE LIMITED',
    'SIEAT ENGINEERING PRIVATE LIMITED',
    'AUCTUS SONHIRA ENERGY VENTURES PRIVATE LIMITED',
    'HORIZON TECHNICAL SERVICES PRIVATE LIMITED',
    'EAGLE STAR VENTURES PRIVATE LIMITED',
    'Doorhan-In Private Limited',
    'PRACHIN LAND-INFRA PRIVATE LIMITED',
    'RR KALYANKAR CONSTRUCTIONS PRIVATE LIMITED',
    'PALAKKAD HEALTH CARE PRIVATE LIMITED',
    'RESOURCE REALTORS PRIVATE LIMITED',
    'EDUCAT WORLDWIDE EDUCATION CONSULTANTS PRIVATE LIMITED',
    'NEXUS BAG MANUFACTURING PRIVATE LIMITED',
    'Caremark Care Services Private Limited',
    'VISWASANTHI DEVELOPMENT FOUNDATION',
    'INDIAN PILGRIM REVIVAL FORUM',
    'ARIES VISMAYAS MAX ENTERTAINMENTS PRIVATE LIMITED',
    'ARTOCARPUS FOODS PRIVATE LIMITED',
    'TBH VENTURES PRIVATE LIMITED',
    'RainyBits Technology Private Limited',
    'Skyspace Logistics Private Limited',
    'ACCENTRIC INSTITUTE OF MANAGEMENT ACCOUNTING & TRAINING PRIVATE LIMITED',
    'JATAYUPARA TOURISM PRIVATE LIMITED',
    'BRODLYNK ENGINEERING PRIVATE LIMITED',
    'ROTERENDE PROPERTIES PRIVATE LIMITED',
    'KALYAN SILKS PROPERTIES PRIVATE LIMITED',
    'LIFE PLANNER STUDIES AND OPPORTUNITIES PRIVATE LIMITED',
    'ESATTO BRICKS AND METALS PRIVATE LIMITED',
    'KHIDMA TOURISM AND TRANSPORT PRIVATE LIMITED',
    'PIXELBIRD TECHNOLOGIES PRIVATE LIMITED',
    'ZAIMUS TECHNOLOGIES PRIVATE LIMITED',
    'Cloudspring Technologies Private Limited',
    'WebNamaste Consulting Private Limited',
    'LORIKEET CONSULTANCY AND TRAINING PRIVATE LIMITED',
    'POTHEN CARS PRIVATE LIMITED',
    'Abaan Impex Private Limited',
    'Starcare Hospital Kozhikode Private Limited',
    'MagGenome Technologies Private Limited',
    'INFIYO TECHNOLOGIES PRIVATE LIMITED',
    'CLASSICENDEAVOURS & ENGINEERS (INDIA) PRIVATE LIMITED',
    'Innovative Petrochemical Engineering Services Private Limited',
    'QUINOID BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Neoito Technologies Private Limited',
    'Refined IT solutions and Marketing Private Limited',
    'TRANSCAPE TECHNOLOGY PRIVATE LIMITED',
    'STRAVA TECHNOLOGIES PRIVATE LIMITED',
    'TWINSWAY TECHNOLOGIES PRIVATE LIMITED',
    'BEZOS TECHNOLOGIES PRIVATE LIMITED',
    'OREGON HEALTHCARE PRIVATE LIMITED',
    'SOLGEN ENERGY PRIVATE LIMITED',
    'THRISSUR INFRASTRUCTURE DEVELOPMENT SOLUTIONS PRIVATE LIMITED',
    'SAGARJITH BUILDERS PRIVATE LIMITED',
    'ALCAZAR INDIA DESIGNERS AND CONTRACTORS PRIVATE LIMITED',
    'BUILDIA BUILDING MATERIALS TRADING PRIVATE LIMITED',
    'TROODON IT SOLUTIONS PRIVATE LIMITED',
    'Trivandrum Engineering Science and Technology Research Park',
    'NATTIKA BEACH RESORTS PRIVATE LIMITED',
    'TREISTEL INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'TRINITY SKILLWORKS PRIVATE LIMITED',
    'MAXVALUE NIDHI LIMITED',
    'JMJ PLUS FINSERV PRIVATE LIMITED',
    'WAYCAFE PRODUCER COMPANY LIMITED',
    'VALUEMENTOR INFOSEC PRIVATE LIMITED',
    'ELECTREX (INDIA) LIMITED',
    'B S APPLIANCES LIMITED',
    'DAUTHYA TECHNOLOGIES PRIVATE LIMITED',
    'ZAMORINS SOLUTIONS PRIVATE LIMITED',
    'YUHIRO TECHNOLOGIES PRIVATE LIMITED',
    'JMJ CHARITABLE FOUNDATION',
    'NYLE INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED',
    'Fresh Harvest Private Limited',
    'NANO GENETICS PRIVATE LIMITED',
    'Yieldplus Crop Management Services Private Limited',
    'FRASCO Advanced Technology Private Limited',
    'HOTEL AMRITHA PRIVATE LIMITED',
    'SRIYA FARMS AND FEEDS PRIVATE LIMITED',
    'SAGARA HOLIDAYS AND RESORTS PRIVATE LIMITED',
    'ALINDAL TECHNOLOGIES LIMITED',
    'THAZHAYIL NIDHI LIMITED',
    'MULAMOOTTIL NIDHI LIMITED',
    'Caraway Development Centre (India) Private Limited',
    'JASSBYS FOODS PRIVATE LIMITED',
    'GREENHOOD FOOD & BEVERAGES PRIVATE LIMITED',
    'BonneTerre Foods Private Limited',
    'G.M. AGRO & BEVERAGES (INDIA) PRIVATE LIMITED',
    'HATTI FOOD AND BEVERAGES PRIVATE LIMITED',
    'Fresheteria Hospitality Private Limited',
    'DropKaffe Food and Beverages Private Limited',
    'BLUECAMEL INDIA FOODS PRIVATE LIMITED',
    'HARINI FOOD PRODUCTS PRIVATE LIMITED',
    'SENSAROM FOODS PRIVATE LIMITED',
    'DCUBE AI SYSTEMS AND SERVICES PRIVATE LIMITED',
    'ZeroPi Tech Solutions Private Limited',
    'THREE SEAS INFOLOGICS PRIVATE LIMITED',
    'VALORIZ DIGITAL PRIVATE LIMITED',
    'QWORKS TECHNOLOGIES PRIVATE LIMITED',
    'ETHAN CORPORATE SOLUTIONS PRIVATE LIMITED',
    'BLISS CHOCOLATES INDIA PRIVATE LIMITED',
    'Sakaem Pravasi Support Services Private Limited',
    'KAPUYT CLOTHING PRIVATE LIMITED',
    'CREATIVE MIND SPARK TRADING PRIVATE LIMITED',
    'GO GO CREATIONS PRIVATE LIMITED',
    'MAXPRO INTERNATIONAL SPINTEX PRIVATE LIMITED',
    'QUANTFARM (OPC) PRIVATE LIMITED',
    'Artesano Lifestyle Private Limited',
    'Brand Studio Lifestyle Private Limited',
    'MINDCARTER PSYCHOLOGICAL SERVICES PRIVATE LIMITED (OPC)',
    'EPICA STUDIO PRIVATE LIMITED',
    'H2O PET PACKAGING PRIVATE LIMITED',
    'Pluto Seven Business Solutions Private Limited',
    'LinkedDots Engineering Solutions Private Limited',
    'Adebeo Solutions Private Limited',
    'Microcommerce Business Innovations Private Limited',
    'MODEE SOFTWARE RESEARCH & DEVELOPMENT PRIVATE LIMITED',
    'Skills OutsourceThink Private Limited',
    'Neev Labs IT Solutions India Private Limited',
    'ULTIMATETEK SOLUTIONS PRIVATE LIMITED',
    'Astrome Technologies Private Limited',
    'INTELLIPREDIKT TECHNOLOGIES PRIVATE LIMITED',
    'E2 Software India Private Limited',
    'V6 appSys Infotech Private Limited',
    'Coviam Technology and Services Private Limited',
    'DELPHINIUM TECHNOLOGIES PRIVATE LIMITED',
    'VISHVEYA SYSTEMS PRIVATE LIMITED',
    'Procain Consulting & Services Private Limited',
    'PEARLARC SYSTEMS PRIVATE LIMITED',
    'Nuviso Networks Private Limited',
    'DataMi Mobile Solutions Private Limited',
    'TECIGNITE (INDIA) PRIVATE LIMITED',
    'Vyuti Systems Private Limited',
    'ZENSPRING TECHNOLOGIES PRIVATE LIMITED',
    'VEXATA DATA SYSTEMS INDIA PRIVATE LIMITED',
    'PHONOLOGY IT SOLUTIONS PRIVATE LIMITED',
    'BRAVVURA DIGITAL PRIVATE LIMITED',
    'NADOLI INFOTECH PRIVATE LIMITED',
    'Digimafia Media Private Limited',
    'Biram Technologies Private Limited',
    'PROQUO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VERA SECURITY INDIA PRIVATE LIMITED',
    'HP PPS India Operations Private Limited',
    'DataXu India Private Limited',
    'BRO4U ONLINE SERVICES PRIVATE LIMITED',
    'CubicLogics India Private Limited',
    'INBRIDGE SOLUTIONS PRIVATE LIMITED',
    'PLANET11 ECOMMERCE SOLUTIONS INDIA PRIVATE LIMITED',
    'Aplica Technologies (India) Private Limited',
    'CORE2DIGITAL INTERNET SOLUTIONS PRIVATE LIMITED',
    'Voxdoc BPO Private Limited',
    'ReachC Onmark Private Limited (OPC)',
    'ANVETSU TECHNOLOGIES PRIVATE LIMITED',
    'Pydan Consulting Private Limited',
    'TECHSYNTAX SOLUTIONS PRIVATE LIMITED',
    'IshaWare Technologies Private Limited',
    'NIYATA INFOTECH PRIVATE LIMITED',
    'GINIMINDS SOLUTIONS PRIVATE LIMITED',
    'Signiwis Technologies Private Limited',
    'Kapuchin Games Private Limited',
    'NEETI HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'TANGSYS TECHNOLOGIES PRIVATE LIMITED',
    'TON TECHNOLOGY SERVICES PRIVATE LIMITED',
    'NEAREX TECHNOLOGIES PRIVATE LIMITED',
    'TELCONET SOLUTIONS PRIVATE LIMITED',
    'BOTTLE LAB TECHNOLOGIES PRIVATE LIMITED',
    'PARIVARTH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Foundation for Neglected Disease Research',
    'Postdot Technologies Private Limited',
    'Carea Consulting Private Limited',
    'WickedRide Adventure Services Private Limited',
    'SALUSFIN INDIA SYSTEMS AND SERVICES PRIVATE LIMITED',
    'ITTRENDS TECHNOLOGIES PRIVATE LIMITED',
    'IVISTAZ ECOM SERVICES PRIVATE LIMITED',
    'UNIVISION TECHNOLOGY CONSULTING PRIVATE LIMITED',
    'CHRONOSPHERE TECHNOLOGIES PRIVATE LIMITED',
    'Aigua Sprinkler and Hydrant India Private Limited',
    'Kushal Info Services Private Limited',
    'ACE INDIA OFFICE SOLUTIONS PRIVATE LIMITED',
    'NET RIGHT TECHNOLOGIES PRIVATE LIMITED',
    'Sixth Element Furnishing Solutions Private Limited',
    'RightAvenue Infotech Private Limited',
    'Red Baton Creative Marketing Solutions Private Limited',
    'LegalXgen Software Solution Private Limited',
    'Roljobs Technology Services Private Limited',
    'KENTROPY TECHNOLOGIES PRIVATE LIMITED',
    'Oplus Mobitech India Private Limited',
    'SSG BUSINESS SERVICES PRIVATE LIMITED',
    'Techprise Solutions Private Limited',
    'BELL IT&SS PRIVATE LIMITED',
    'SIGNOVUS TECHNOLOGIES PRIVATE LIMITED',
    'EBITA Info Solutions Private Limited',
    'SoftNis IT Management Services Private Limited',
    'BizViz Technologies Private Limited',
    'BendFlex Research and Development Private Limited',
    'Sirma Business Consulting (India) Private Limited',
    'Lafiny Technologies Private Limited',
    'Weiwo Communication Private Limited',
    'Regus Eversun Business Centre Private Limited',
    'STEEL INSPECT QUALITY SERVICES INDIA PRIVATE LIMITED',
    'ELYCTIS INDIA PRIVATE LIMITED',
    'AFFINITY ANSWERS PRIVATE LIMITED',
    'GREAT WEST GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'CERIDIAN DAYFORCE INDIA PRIVATE LIMITED',
    'AB INBEV GCC SERVICES INDIA PRIVATE LIMITED',
    'E-LAND SYSTEMS INDIA PRIVATE LIMITED',
    'Deejay Agri Support Foundation',
    'WITMAKERS FOUNDATION',
    'The Yellow Door Enterprises Private Limited',
    'ASE India Private Limited',
    'Samhrutha habitat infrastructure private limited',
    'India builders corporation private limited',
    'Foresight projects private limited',
    'Champion land zone private limited',
    'Sonigra constructions pvt ltd',
    'Virneesh properties developers private limited',
    'Pride industrial park pvt ltd',
    'Konark advisers private limited',
    'Vijaya infra project private limited',
    'Gajra developers limited',
    'M A ARCHITECTS PRIVATE LIMITED',
    'Shreenath mega texprocess cluster private limited',
    'Ripple effect softech services private limited',
    'Tsysinfo technologies private limited',
    'Saas softpro leaders private limited',
    'Endeavour erp solutions india private limited',
    'Hoshin solutions private limited',
    'EUROMAX PERSONAL CARE PRIVATE LIMITED',
    'SUNRAY ENGINEERING & TECHNOLOGIES PRIVATE LIMITED',
    'Auxesis infotech private limited',
    'India apps private limited',
    'Intellect software solutions private limited',
    'KOSMIC INTERIOR PRIVATE LIMITED',
    'Engage medical india private limited',
    'Ensavior technologies private limited',
    'Crystal datasystems india private limited',
    'Starapps software private limited',
    'Kaira software private limited',
    'Narayankrupa tenstones private limited',
    'Ray infoweb private limited',
    'Peerbits solution private limited',
    'Soham erp solutions private limited',
    'Space-o digicom private limited',
    'Wifiray infratech private limited',
    'MSC SYSTEMS PRIVATE LIMITED',
    'Teradata india private limited',
    'Pc care247 solutions private limited',
    'GLORYBIRD INDIA PRIVATE LIMITED',
    'Antares systems limited',
    'GLOBOSPORT LICENSING AND MERCHANDISING PRIVATE LIMITED',
    'DATACON TECH PRIVATE LIMITED',
    'Mobi2fun mobile entertainment (bangalore) private limited',
    'GOAUDITS PRIVATE LIMITED',
    'I-exceed technology solutions private limited',
    'Emmatics technologies private limited',
    'Kiwi india private limited',
    'Inmobi technology services private limited',
    'Axtel communications private limited',
    'Accelerate technology ventures private limited',
    'Cosmitude softwares private limited',
    'Akrl consulting and it services private limited',
    'Brij systems limited',
    'Larvik engg consultants private limited',
    'Tekno point multimedia india private limited',
    'Integrated cadcam solutions private limited',
    'M j systems (india) private limited',
    'Innovative informatics private limited',
    'Netlynx technologies private limited',
    'Cnc e-solutions private limited',
    'Wiblaze india private limited',
    'Finacus solutions private limited',
    'Pc zones it services private limited',
    'Galaxy infosolutions private limited',
    'HATHWAY SAI STAR CABLE & DATACOM PRIVATE LIMITED',
    'Epps infotech private limited',
    'Infovie Software Solutions Private Limited',
    'Abas force (india) private limited',
    'Tru business solutions private limited',
    'Change networks private limited',
    'Nano net logic private limited',
    'Minsyst consulting private limited',
    'Hifi digi advertising private limited',
    'I s techspace services india private limited',
    'Patel brothers atm credit card processing services private limited',
    'Firmzen software private limited',
    'White leaf ites private limited',
    'Uni-com india private limited',
    'Schoolpad technologies private limited',
    'Nanostuffs technologies private limited',
    'Tejas it solutions private limited',
    'Splashgain technology solutions private limited',
    'Quadlogix technologies private limited',
    'Success alignment systems private limited',
    'Magneto it solutions private limited',
    'Omfys technologies (india) private limited',
    'Qhash technologies private limited',
    'Contracting plus solutions private limited',
    'Geostat informatics (india) private limited',
    'Sanchan info solutions private limited',
    'MOSCHIP INSTITUTE OF SILICON SYSTEMS PRIVATE LIMITED',
    'Honnex software solutions private limited',
    'Nichebit softech private limited',
    'CLOUD4C SERVICES PRIVATE LIMITED',
    'Corent technology private limited',
    'WEBSEC SOLUTIONS PRIVATE LIMITED',
    'Bloom technologies private limited',
    'Techslash solutions private limited',
    'Nagalakshmi tech solutions private limited',
    'Frontaddress technologies private limited',
    'Sunbright technologies private limited',
    'Aeon networks private limited',
    'Cd cloudenablers private limited',
    'Cresttek engineering solutions private limited',
    'Webtrendz technologies india private limited',
    'Prosim research and development private limited',
    'Eurofins analytical services india private limited',
    'Enaltec labs private limited',
    'J s b market research private limited',
    'Accon lifesciences private limited',
    'Shakambari aromatics private limited',
    'Sudish chemicals pvt ltd',
    'Dfw envirotech india private limited',
    'Supreme startech private limited',
    'Gerchem labs (india) pvt. ltd.',
    'Msn organics private limited',
    'United cryo gases private limited',
    'Varun organics private limited',
    'Adlers bio-energy limited',
    'Medicare environmental management private limited',
    'Goldfarms plant tech private limited',
    'Astra chemtech private limited',
    'Brenntag ingredients (india) private limited',
    'Krupa colours private limited',
    'Pladel multi trading private limited',
    'Exel-ammonia private limited',
    'Ind-ital chemicals limited',
    'Renders india private limited',
    'Watsol polymers pvt ltd',
    'Sikko products private limited',
    'CHEMBOND MATERIAL TECHNOLOGIES PRIVATE LIMITED',
    'Solufeed plant products and services private limited',
    'Cresta paints india private limited',
    'Nitin pumps private limited',
    'Sheenlac paints limited',
    'Clavita pharma private limited',
    'Swas healthcare private limited',
    'Pride lifescience private limited',
    'Santosh rubber machinery private limited',
    'Amol pharmaceuticals private limited',
    'Supriya bio-tech private limited',
    'Hp drug house private limited',
    'Sakshi chem sciences private limited',
    'Bayberry pharmaceuticals private limited',
    'Blesso herbal international private limited',
    'Mili healthcare private limited',
    'Missionpharma logistics (india) private limited',
    'Sangros drugchem private limited',
    'Dolpphin termite and pest control private limited',
    'ERIS LIFESCIENCES LIMITED',
    'Anthem bio pharma private limited',
    'Tridax laboratories limited',
    'Sri dhanada laboratories private limited',
    'ANDHRA MEDI PHARMA INDIA PRIVATE LIMITED',
    'Aculife healthcare private limited',
    'Jkp paints (india) private limited',
    'OMICRON DDS PROJECTS PRIVATE LIMITED',
    'Mylab lifesolutions private limited',
    'Amaze pharmaceuticals limited',
    'Fourth dimension india private limited',
    'Medicore laboratories private limited',
    'Micropure parenterals private limited',
    'Maithri laboratories private limited',
    'Msn laboratories private limited',
    'Msn pharmachem private limited',
    'Msn life sciences private limited',
    'Hygienic research institute (india) private limited',
    'Bhanu cosmetics packaging private limited',
    'Hygienic research institute private limited',
    'Boutique perfumery private limited',
    'Taoka chemical india private limited',
    'Easom chemiques private limited',
    'JKP TRADEIMPEX PRIVATE LIMITED',
    'Srigen lifesciences private limited',
    'K patel chemo-pharma private limited',
    'Bsa polycontainer private limited',
    'Shree gaurav polymers private limited',
    'Unique retreads pvt ltd',
    'S.v.rubber company private limited',
    'Brijdham polymers private limited',
    'Dynaflex private limited',
    'Associated luggage company private limited',
    'Joyful plastics private limited',
    'Mayur wovens private limited',
    'Arihant polyforms private limited',
    'Cambay technopack private limited',
    'Vaidyanath plast private limited',
    'A. j beltings private limited',
    'Radcom packaging private limited',
    'Palram india private limited',
    'Bhavi plast private limited',
    'Meccanotecnica india private limited',
    'Aar aar technoplast private limited',
    'Kelvin plastic pvt ltd',
    'Wellproof technologies private limited',
    'Dalal plastics private limited',
    'Asiatic composite limited',
    'Jaeger products private limited',
    'ZIRCAR REFRACTORIES LIMITED',
    'Accord ceramics private limited',
    'Acer granito private limited',
    'Artistique glass private limited',
    'Shriji sanitrade private limited',
    'Abin building products and solutions private limited',
    'Rheoplast technology private limited',
    'Sudarshan beopar co ltd',
    'PROSPER HOUSING FINANCE LIMITED',
    'Sdu investments private limited',
    'Sammohan holding and leasing p.ltd.',
    'Mag finserv company limited',
    'CENTENNIAL FINANCE PRIVATE LIMITED',
    'Kaypee exim private limited',
    'Aptus value housing finance india limited',
    'Aumo holdings private limited',
    'Upl investment private limited',
    'Silverleaf capital services private limited',
    'Chitra holdings pvt ltd',
    'Mukesh holdings private limited',
    'Prabhudas lilladher advisory services private limited',
    'Lalana leasing and finance pvt.ltd.',
    'Canara robeco asset management company limited',
    'Anetheol securities and commercials private limited',
    'Thl metals limited',
    'Hornic investment private limited',
    'Hathi finance private limited',
    'WELLWORTH FINANCIAL SERVICES PRIVATE LIMITED',
    'Carnival soft private limited',
    'E-city investments and holdings company private limited',
    'Sankhya financial services private limited',
    'Buoyant capital private limited',
    'Sultania trade private limited',
    'Sree visalam chit fund ltd',
    'Diamond boart international private limited',
    'Tamilnadu urban infrastructure trustee company limited',
    'Sumeru global holdings and services private limited',
    'Decent investment and finance private limited',
    'AMMAN MATCH PRIVATE LIMITED',
    'Sourabh gilts & securities limited',
    'Dps business associates private limited',
    'Macquarie finance (india) private limited',
    'METRO CITY CAPITAL SERVICES PRIVATE LIMITED',
    'Suprasesh general insurance services and brokers private limited',
    'Central registry of securitisation asset reconstruction and security interest of india',
    'Pinnacle analytical solutions india private limited',
    'Muthoot securities limited',
    'Polymath advisors private limited',
    'Dollaren capital private limited',
    'Cresa financial services private limited',
    'Uphar finvest limited',
    'Unique tradebiz private limited',
    'Geo portfolio services private limited',
    'Clubmillionaire financial services private limited',
    'Muthoot commodities limited',
    'Glomeral securities private limited',
    'Ram ratna research and holdings private limited',
    'SKMAL HOLDINGS PRIVATE LIMITED',
    'Infina finance private limited',
    'Ksa shares and securities private limited',
    'Sai supreme holding company private limited',
    'Systematix capital services private limited',
    'Lumiere insurance surveyors and loss assessors private limited',
    'Henry and farad private limited',
    'Gayatri financial services private limited',
    'EBIXCASH WORLD MONEY LIMITED',
    'Cosmos bon-voyage and forex private limited',
    'India capital advisors private limited',
    'Maharashtra energy generation limited',
    'Globalworth securities limited',
    'Vallum capital advisors private limited',
    'EQUINOMICS RESEARCH PRIVATE LIMITED',
    'Sarthak finserve advisory private limited',
    'Lorven insurance broking services private limited',
    'Queen building solutions private limited',
    'Gkr holdings private limited',
    'Blc infrastructures private limited',
    'Zara builders private limited',
    'Zenriba estates and investments pvt ltd.',
    'Modi builders pvt ltd',
    'Varshraj realtors private limited',
    'Karnaal builders & developers private limited',
    'Perfect realty private limited',
    'Credence property developers private limited',
    'Nidhaan Infracon Private Limited',
    'Rustomjee realty private limited',
    'Aura properties (india) private limited',
    'Cavalcade properties private limited',
    'Apple plaza private limited',
    'Xcellent realty private limited',
    'Blue crystal construction & developers private limited',
    'Ghanwat enterprises private limited',
    'Real estate mumbai private limited',
    'Goldmoon realcon private limited',
    'Candolim beach estates private limited',
    'Seetharam shetty brothers estates private limited',
    'DASSCON REALTY PRIVATE LIMITED',
    'Thomsun realtors private limited',
    'Relcon properties private limited',
    'Aconite properties pvt.ltd.',
    'Newfound properties and leasing private limited',
    'Hscm realtors private limited',
    'Rudraksha landscapes private limited',
    'Academy for creative teaching india private limited',
    'Ar trustee company private limited',
    'RANE',
    'ANALYTICAL LABORATORIES PRIVATE LIMITED',
    'Swayamsiddha mahila utkarsha foundation',
    'National institute for smart government',
    'Tatva global environment (deonar) limited',
    'Saint gobain india foundation',
    'E-city bioscope entertainment private limited',
    'Motion picture distributors association (india) private limited',
    'Khana khazana productions private limited',
    'Vinod chopra films private limited',
    'Highbrow production services private limited',
    'Red chillies entertainments private limited',
    'Angel media network private limited',
    'Jesus christ telecasting network private limited',
    'Makkal tholai thodarpu kuzhumam limited',
    'E-city digital cinemas bombay private limited',
    'Samira entertainment private limited',
    'Focus trade fairs private limited',
    'Aakriti av productions private limited',
    'Gamiana digital entertainment private limited',
    'R s entertainment private limited',
    'Rj fitness club private limited',
    'Sun city gymkhana private limited',
    'Gsown lifestyle centres private limited',
    'Medallin sports private limited',
    'TENT WORKS INTERACTIVE PRIVATE LIMITED',
    'Nirmal sports private limited',
    'Great hyderabad adventure club',
    'Cricket drome private limited',
    'Life strategies humancare private limited',
    'Showhouse event management private limited',
    'Pioneer logisys private limited',
    'Consegna services private limited',
    '247 facility services private limited',
    'Hr governance solutions (india) private limited',
    'Access ascent foundation',
    'Zoetis india limited',
    'Innovaid advisory services private limited',
    'Omidyar network india advisors private limited',
    'Sustainable technosolutions for environmental protection private limited',
    'ONELINE WELLNESS PRIVATE LIMITED',
    'Wns cares foundation',
    'Rightmatch hr services private limited',
    'Aryash advisory services private limited',
    'WORKOOPOLIS HRM PRIVATE LIMITED',
    'Starship maritime training institute',
    'Strategic mantra consulting private limited',
    'Equitas dhanyakosha india',
    'Consortium for technology research entrepreneurship and employment',
    'Rockwood lithium india private limited',
    'PROWORKS ENGINEERING AND TECHNICAL SERVICES PRIVATE LIMITED',
    'Weltweit certifications private limited',
    'ROYAL PRUDENCE PRIVATE LIMITED',
    'E3 zone edutrain private limited',
    'Tele access e-services private limited',
    'Five stars chartering private limited',
    'Minc billbox pvt ltd',
    'Sampan aviation services private limited',
    'Geomatt equipment rentals private limited',
    'Chaudhari lifestyle private limited',
    'Inetest technologies india private limited',
    'Spearhead insurance broking private limited',
    'Kaysan hr solutions private limited',
    'Waterman consulting engineers india private limited',
    'SVG FASHIONS PRIVATE LIMITED',
    'Agrawal riders private limited',
    'Numex engineers private limited',
    'Urmila and company limited',
    'Grand rail ventures india private limited',
    'Cheraman infrastructure private limited',
    'Universal hydro structures private limited',
    'GRUHLAXMI LIFE SPACE PRIVATE LIMITED',
    'Sri vamana realtor private limited',
    'Sridevi balaji infra developers private limited',
    'Tecton engineering & construction (india) private limited',
    'Lineage power private limited',
    'Hedge buildcon private limited',
    'National marine and infrastructure india private limited',
    'Kappa infra ventures private limited',
    'Suroj modular housing private limited',
    'Svkr infra india limited',
    'Kavuru infra projects private limited',
    'Super surfaces india private limited',
    'A.navinchandra infrarealty private limited',
    'Umang homes private limited',
    'SARE SHELTERS PROJECT PRIVATE LIMITED',
    'Abhash developers private limited',
    'Hlt residency private limited',
    'Lily realty private limited',
    'Shambhavi realty private limited',
    'Shashwati realty private limited',
    'Pashmina buildcon private limited',
    'Union real estate private limited',
    'Pushpak buildtech private limited',
    'Diwali land private limited',
    'Royalty infrastructure private limited',
    'JP INFRA HOMES PRIVATE LIMITED',
    'Gruhalaxmi skyscraper private limited',
    'Skylite infracon private limited',
    'PASHAMYLARAM STEEL PRODUCTS PRIVATE LIMITED',
    'Octagon assets private limited',
    'Profex engineering private limited',
    'Bteks infra private limited',
    'Sunbright infratech private limited',
    'Muskan highrise private limited',
    'Brown bricks realty private limited',
    'Shakambari infratech limited',
    'Super decorative stones private limited',
    'Direct cars private limited',
    'FORTPOINT PROPERTIES PRIVATE LIMITED',
    '99 BIKERS PRIVATE LIMITED',
    'STAR RICE LAND PRIVATE LIMITED',
    'Jayabheri automotives private limited',
    'Aastha automobiles private limited',
    'Infinity autolinks private limited',
    'Agwan motors private limited',
    'Aditya fuels limited',
    'Qi lifecare private limited cn',
    'Ana enterprises private limited',
    'Ana services (india) private limited',
    'Convatec india private limited',
    'Global viso trading private limited',
    'H&r india sales private limited',
    'Mohan enterprises (rajasthan) pvt ltd',
    'DEMETER CONSULTANCY PRIVATE LIMITED',
    'Mohamad idris bros private limited',
    'Zest auto private limited',
    'Yashvi distribution services private limited',
    'R k p trading company private limited',
    'ACALYPHA REALTY LIMITED',
    'Salasar derivatives private limited',
    'Shrem impex private limited',
    'Supra exim private limited',
    'Frontline commerce pvt ltd',
    'Apex dealcomm private limited',
    'Kurkenmutty estates private limited',
    'Square meal private limited',
    'Milliken chemical and textile (india) co. private limited',
    'Ensemble furniture solutions private limited',
    'Mobile2win india private limited',
    'Tradecom international private limited',
    'Yogi international private limited',
    'IRACIS PROCESS ENGINEERS PRIVATE LIMITED',
    'MORSEF MACHINES PRIVATE LIMITED',
    'Lavish health care private limited',
    'Sri rajendra scientific and surgicals private limited.',
    'Premiere ornaments private limited',
    'A.navinchandra steels private limited',
    'Starwood veneers pvt ltd',
    'Orange glaze ceramics private limited',
    'Urmit chemicals private limited',
    'Dalwin marine turbo engg private limited',
    'Core power systems limited',
    'Sonak surface technologies private limited',
    'Inscon medical solutions private limited',
    'Stellar peripherals private limited',
    'Dhruvi commercial private limited',
    'Visen marketing private limited',
    'Brown overseas private limited',
    'Durian industries limited',
    'Welknown exports pvt ltd',
    'Pnp industries private limited',
    'Bombay stationers private limited',
    'Jay bhagwati trading & agencies private limited',
    'United consultancy services private limited',
    'Pgs premiere conferencing private limited',
    'Longbow legal services private limited',
    'Mystical destinations private limited',
    'La-organiq foods private limited',
    'MENCEE PHARMA PRIVATE LIMITED',
    'Worksphere ventures (india) private limited',
    'Lucsam services private limited',
    'C & a logistics solutions (india) private limited',
    'Connect residuary private limited',
    'Cat-5 enterprises india private limited',
    'Htl aircon services private limited',
    'Auxin shipping private limited',
    'Consonni contract (india) private limited',
    'Jai ambe manufacturers limited',
    'Aimsite display private limited',
    'Brandzstorm india retail marketing private limited',
    'Trainingincorporate consultants private limited',
    'Epitome gifts private limited',
    'Genesis catering services private limited',
    'Adstream advertising services private limited',
    'Little door talents private limited',
    'Rossini india printing rollers private limited',
    'Iliftoff consultant technologies private limited',
    'Sidmax design products india private limited',
    'Shetty projects and services private limited',
    'Pioneer hr solutions private limited',
    'Carpe heat transfer private limited',
    'Microware cards solutions private limited',
    'Palo alto networks (india) private limited',
    'Foundation consulting solutions private limited',
    'Cargo movers and logistics private limited',
    'Virgo hydraulic private limited',
    'Dawn shipping private limited',
    'MEGANET TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SHREM AVIATION HUB PRIVATE LIMITED',
    '7p events and activations private limited',
    'Atlas capfin advisory & hospitality private limited',
    'Impetus placements private limited',
    'Chess global advisory services private limited',
    'Skm mercantile private limited',
    'Aciron consulting private limited',
    'Embassy express freight private limited',
    'Unicommerce esolutions private limited',
    'Projtech engineering private limited',
    'Klassic business advisory private limited',
    'Perception & quant research private limited',
    'T v rao learning sysytems private limited',
    'Suyog merchandise shipping private limited',
    'Universal hunt private limited',
    'Ballard projects private limited',
    'TRAVELCART HOSPITALITY PRIVATE LIMITED',
    'Talent anywhere services private limited',
    'Digi system gurgaon private limited',
    'Sanvi services private limited',
    'Chetan wood processing private limited',
    'Bti consultants (india) private limited',
    'SWISS RE GLOBAL BUSINESS SOLUTIONS INDIAPRIVATE LIMITED',
    'British orient infotel private limited',
    'Cavalierindia training and consulting private limited',
    'Kpi consulting services private limited',
    'Crown consultants private limited',
    'Aquachem enviro engineers private limited',
    'Faldrup finance private limited',
    'Fundtech india private limited',
    'Esp consultant india private limited',
    'Kanvas consultancy services private limited',
    'Hj support services private limited',
    'Geebee advisory services private limited',
    'NAFA GENERAL PARTNERS PRIVATE LIMITED',
    'Doka india private limited',
    'Eduwise consultancy private limited',
    'Revmax consultants private limited',
    'Imagination design and communications india private limited',
    'Epsilon design consultancy private limited',
    'Thost project management india private limited',
    'Sphinx adonis events private limited',
    'Savali management consultancy private limited',
    'Silver square corporation india private limited',
    'KARVY FORDE SEARCH PRIVATE LIMITED',
    'Sands utility services private limited',
    'YBR INDUSTRIES PRIVATE LIMITED',
    'Currie & Brown (Padgham) Private Limited',
    'Quadra projects private limited',
    'Active corporate services (india) private limited',
    'Hi-tech tea consultancy pvt ltd',
    'Sew energytech services private limited',
    'KATANAMECH SOLUTIONS PRIVATE LIMITED',
    'Increations designs and contracts private limited',
    'Hekur contractors private limited',
    'SPICA METFAB SOLUTIONS INDIA PRIVATE LIMITED',
    'Veltech masters engineering private limited',
    'SACHINGANDHI CONSULTANTS PRIVATE LIMITED',
    'Ovobel estates private limited',
    'Grey worldwide (india) private limited',
    'Multi tech associates private limited',
    'Mascot dynamics private limited',
    'Ashruly engineering private limited',
    'Safety projects private limited',
    'Silmax tools india private limited',
    'Rajass technologies private limited',
    'Waterman industries private limited',
    'Magtronic devices pvt ltd',
    'Envirox protection company private limited',
    'Mech world eco private limited',
    'Kota tapes (india) private limited',
    'Kuubera motion controls private limited',
    'Parallel track engineering company private limited',
    'Jupiter energy technologies private limited',
    'Aadhar equipments private limited',
    'Jet lifts private limited',
    'Navi infrastructure engineering private limited',
    'Gurukrupa laser tech private limited',
    'ABHIJEET RANEE POLYMERS PRIVATE LIMITED',
    'JTEKT BEARINGS INDIA PRIVATE LIMITED',
    'Sansree automation private limited',
    'Vollmer technologies india private limited',
    'Offshore marinetech private limited',
    'Nido machineries private limited',
    'Hammer knock pressotechnologies (india) private limited',
    'BROADSTREAM SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Samarth turnkey solutions private limited',
    'Elder equipments private limited',
    'SGB BRANDSAFWAY PRIVATE LIMITED',
    'Kubs safes and locks private limited',
    'Dyrocon airtech private limited',
    'Ashwath technologies private limited',
    'Vijayeswari ring travellers private limited',
    'Piotex textech private limited',
    'Vortex engineering private limited',
    'Uster technologies (india) private limited',
    'Haartz automotive india private limited',
    'Sri koteswara cam systems private limited',
    'Pharmalab india private limited.',
    'Biosystems diagnostics private limited',
    'Gvn material handling private limited',
    'Ga-mor machines tools private limited',
    'B mehta engineering co pvt ltd',
    'Rainbow mechanical engineering private limited',
    'OILFIELD SERVICES & SUPPLIES INDIA PRIVATE LIMITED',
    'MOTAN PRIVATE LIMITED',
    'Sri vivegha engineering private limited',
    'LIGHT DYNAMICS CYLINDERS INDIA PRIVATE LIMITED',
    'Kj energy products private limited',
    'Goodwill power generators private limited',
    'Bhatt magnetics pvt ltd',
    'Sunotronics india private limited',
    'Amc cookware (india) private limited',
    'Jet tec info-consumables (india) private limited',
    'Eaicom india private limited',
    'DIGITAL WAVES INTERNATIONAL PRIVATE LIMITED',
    'Venktron digital systems private limited',
    'Byte interface pvt ltd',
    'Quasar innovations private limited',
    'Leading network systems private limited',
    'Simha manufacturing company private limited',
    'Power net systems private limited',
    'Mbh power private limited',
    'Golden electronic controls (india) private limited',
    'Inelec engineers india private limited',
    'Walson woodburn wire die private limited',
    'Vora electric service private limited',
    'Electrofocus electricals private limited',
    'CAPCHEM ELECTRICALS LIMITED',
    'Shavison electronics private limited',
    'Square elevators private limited',
    'Hiver aircon private limited',
    'Relinquo automation private limited',
    'OHMIUM OPERATIONS PRIVATE LIMITED',
    'Global enersol technologies private limited',
    'Shirdi cables private limited',
    'Current electricals limited',
    'Vulcan electricals ltd.',
    'Obo bettermann india private limited',
    'Bt convergence technologies private limited',
    'Shecon technologies private limited',
    'Real switchgears & cables private limited',
    'C tech labs private limited',
    'Atrium infocomm private limited',
    'Control technoaids electronics india private limited',
    'Avvas infotech private limited',
    'Max Spare Limited',
    'Torvin technologies private limited',
    'Kohinoor televideo private limited',
    'Reep industries private limited',
    'Smsilicon india private limited',
    'Matrix meditec private limited',
    'Invent bio-med private limited',
    'Vijayalakshmi health & surgicals private limited',
    'S3V VASCULAR TECHNOLOGIES LIMITED',
    'Mediserve technologies private limited',
    'Medived innovations private limited',
    'Srks software solutions private limited',
    'Legato embedded systems private limited',
    'Cascademic solutions private limited',
    'Global gateway infratech private limited',
    'Streamvector technology private limited',
    'Zenicon infoway private limited',
    'TEAMLEASE HRTECH PRIVATE LIMITED',
    'Phases india technology solutions private limited',
    'Kefas softwares private limited',
    'Pace infotech (india) private limited',
    'Network security solutions (india) limited',
    'Secure matrix global private limited',
    'Syssoft infotech (india) private limited',
    'Xs cad india private limited',
    'Opportune technologies private limited',
    'Ilead technologies private limited',
    'Ots e- solutions private limited',
    'Holcim services (south asia) limited',
    'Greeksoft technologies private limited',
    'Sapphire erp systems private limited',
    'Alamiko solutions private limited',
    'Suvaance internet marketing services private limited',
    'Shiftu technology private limited',
    'PROCESSIA PLM PRIVATE LIMITED',
    'Magus infotech india private limited',
    'Varit information technology private limited',
    'HEXAGON MANUFACTURING INTELLIGENCE INDIA PRIVATE LIMITED',
    'Phadnis software limited',
    'Thinking hut it solutions private limited',
    'Bizgaine technologies private limited',
    'Subhash computers private limited',
    'Jade global software private limited',
    'Excel it services private limited',
    'Codaemon softwares private limited',
    'Aaa infocom private limited',
    'Signion systems pvt ltd.',
    'Logical solutions ltd',
    'Siritel systems private limited',
    'Measurement solutions private limited',
    'Esn technologies (india) private limited',
    'Kbts technologies private limited',
    'Ne technologies india private limited',
    'Catalytic software limited',
    'Hsbc electronic data processing india private limited',
    'Rad softech private limited',
    'PLANFUL SOFTWARE INDIA PRIVATE LIMITED',
    'I-vantage india private limited',
    'Centrix technologies private limited',
    'Xcelerate solutions private limited',
    'Mavensoft systems private limited',
    'Giftech software solutions private limited',
    'Digi tele networks private limited',
    'My-tec software private limited',
    'NAG TALENT VENTURES AND INFOTECH PRIVATE LIMITED',
    'Vectorform software private limited',
    'Renovau telecom private limited',
    'Knoahsoft technologies private limited',
    'Hornbill solutions private limited',
    'Pegasys information technologies private limited',
    'Srs business solutions india private limited',
    'Hyperfactory it services india private limited',
    'Xtramilesoft technologies private limited',
    'GBIT INDIA PRIVATE LIMITED',
    'Agiliance india private limited',
    'Vincent info solutions private limited',
    'Armo techsolutions private limited',
    'OLOFI PHARMA & HEALTHCARE PRIVATE LIMITED',
    'Tekyslab private limited',
    'Gramener it services private limited',
    'Mahtia business solutions private limited',
    'M&m infosoft( india) private limited',
    'Acharis it consultancy private limited',
    'Vedic mobitek private limited',
    'Rcart e commerce solutions private limited',
    'FIRSTFORCE TECHNOLOGIES PRIVATE LIMITED',
    'Risk edge solutions private limited',
    'Snippets it solutions private limited',
    'Ripples it solutions private limited',
    'Veeras infotek private limited',
    'SOBHA TAMBARAM DEVELOPERS LIMITED',
    'Winsar infosoft private limited',
    'Seventhsense technologies private limited',
    'Redblacktree technologies private limited',
    'Telic info services private limited',
    'Athenahealth technology private limited',
    'Dun & bradstreet technologies & data services private limited',
    'Klabs technology and solutions private limited',
    'MINDSPRINT DIGITAL (INDIA) PRIVATE LIMITED',
    'Tensor infotech private limited',
    'Exhilar innovative solutions private limited',
    'G-net solutions coimbatore private limited',
    'Its infosystems private limited',
    'Pivoting softwares private limited',
    'Concentrix technologies (india) private limited',
    'Get2galaxy technology solutions private limited',
    'Orionid software private limited',
    'La freightlift private limited',
    'Ashutosh container services private limited',
    'Diamond maritime agency private limited',
    'MANDAWEWALA ENTERPRISES LIMITED',
    'Maritime ventures private limited',
    'QUEST COWORKS PRIVATE LIMITED',
    'Heritage river journeys private limited',
    'Hanaro logistics private limited',
    'Baroda taxi cabs private limited',
    'Relocation international india private limited',
    'Viskan logistics services private limited',
    'Sss sai forwarders private limited.',
    'Sunmeet logistic private limited',
    'Schenker india private limited',
    'A. V. FREIGHT & LOGISTICS PRIVATE LIMITED',
    'Mass express cargo private limited',
    'Cochin quick transit service private limited',
    'Cargo systems (india) private limited',
    'R. k. carriers india private limited',
    'Adithya freight forwarders private limited',
    'Srivalli shipping & transport private limited',
    'Tnl logistics private limited',
    'V k cargo and freight forwarders private limited',
    'Blue bird cargo private limited',
    'Lom supply chain (india) private limited',
    'Future supply chain solutions limited',
    'Nakshtra logistics private limited',
    'Kmt shipping & logistics private limited',
    'Sas aviation private limited',
    'Yap hospitality private limited',
    'H & K SOLUTIONS PRIVATE LIMITED',
    'Leapon adventures private limited',
    'Good earth eco tourism private limited',
    'Converge travel abode india private limited',
    'Dasin citi tours and travels (india) private limited',
    'Elite wellness and tourism india private limited',
    'VISHNUMA GLOBAL SOLUTIONS PRIVATE LIMITED',
    'Nikhil logistics private limited',
    'Sahara rent-a-car private limited',
    'Sameera travels and tours private limited',
    'Iriss electronic travel distribution private limited',
    'Jalhansa tours & travels private limited',
    'Tripmac tourism private limited',
    'East wind holiday tours private limited',
    'Jaishree giriraj roadways private limited',
    'Machado and sons agents and stevedores private limited',
    'Westship logistics private limited',
    'D k clearing and shipping agency private limited',
    'Shivam clearing agency (mumbai) private limited',
    'Integrated shipping and forwarding private limited',
    'Freightcan logistics (india) private limited',
    'Sainath forwarders private limited',
    'Euro trans logistics private limited',
    'Ahura logistics private limited',
    'EXIM FREIGHT LINE PRIVATE LIMITED',
    'VRUDHI LIFESCIENCES PRIVATE LIMITED',
    'JET FREIGHT LOGISTICS LIMITED',
    'SAR LOGISTIX PRIVATE LIMITED',
    'Scm inventure private limited',
    'Comfort tours private limited',
    'Mywish tours and travels private limited',
    'S.g.logistics private limited',
    'Lom logistics (india) private limited',
    'Maverick telecommunication private limited',
    'Speed and safe courier services private limited',
    'Windchimes communications private limited',
    'Telstra telecommunications private limited',
    'Tekelec systems india private limited',
    'Infiniti research marketing solutions india private limited',
    'Airlink wireless private limited',
    'Mobile magic private limited',
    'Fibtel telecom solutions (india) private limited',
    'Westbury construction private limited',
    'Adel shipping holdings limited.',
    'Sree devi karumari finance private limited',
    'SHRACHI FISCAL SERVICES PRIVATE LIMITED',
    'Apposite trading private limited',
    'Sioux finance limited',
    'Malabar capital advisors private limited',
    'Raghunandan finance private limited',
    'NILGIRIS FRANCHISE LIMITED',
    'Gold star corporate solutions private limited',
    'Girnar residency private limited',
    'Tranzlease holdings (india) private limited',
    'MSK INVESTMENT SERVICES PRIVATE LIMITED',
    'Emerald fintrade private limited',
    'Sportive financial services private limited',
    'Triple ess infrastructure private limited',
    'Kaushal finlease company private limited',
    'Anchor apartments pvt ltd',
    'Greycells18 media limited',
    'MANAPPURAM HOME FINANCE LIMITED',
    'Icredizen financial technologies private limited',
    'Transpacific investments private limited',
    'Ideal insurance brokers private limited',
    'Graphic investments pvt ltd',
    'Hbi consultants private limited',
    'Sensoheat engineering equipments india private limited',
    'Wren & pecker private limited',
    'Aryan pumps & enviro solutions private limited',
    'Global nest consulting private limited',
    'Rudvin labs private limited',
    'Anahat organisation development consultancy private limited',
    'RADIANT CASH MANAGEMENT SERVICES LIMITED',
    'Nichias industrial products private limited',
    'SRI RAGHAVENDRA LOGISTICS PRIVATE LIMITED',
    'Emwhiz technologies private limited',
    'Lennox india technology centre private limited',
    'Kronos logistics india private limited',
    'Totoodo mobile communications service private limited',
    'Timeless ventures private limited',
    'Natural herbs and formulation private limited',
    'Skp commodities limited',
    'People combine infrastructures private limited',
    'SHETE',
    'S IMMIGRATION AND EDUCATIONAL CONSULTANTS PRIVATE LIMITED',
    'Empathy digital media private limited',
    'Vidyatree learning private limited',
    'Bigspring private limited',
    'TECHVENDORS INDIA PRIVATE LIMITED',
    'Information and communication technology academy of kerala',
    'Sunera learnware private limited',
    'Edugreen education & services private limited',
    'Mac h r management consultants private limited',
    'Blueridge educational institute',
    'People combine play school initiatives private limited',
    'Funky monkeys play centers private limited',
    'Karvat healthcare services private limited',
    'GENERAL DIAGNOSTICS INTERNATIONAL PRIVATE LIMITED',
    'Mdindia healthcare networx private limited',
    'Sare jahan se acha socio-eco-pol foundation private limited',
    'Mantissa infotech private limited',
    'Gujarat medical services corporation limited',
    'Namtech tai limited',
    'Syndicated research worldwide private limited',
    'Atrimed health care foundation',
    'Asiatic clinical research private limited',
    'Kindorama healthcare private limited',
    'Ravi nair hospitals private limited',
    'Amg healthcare destination private limited',
    'Incor hospitals vizag private limited',
    'Makhan singh hospital and enterprises pvt. ltd.',
    'Diagnostics therapeutic medical centre private limited',
    'Swasth india services private limited',
    'Uksas ambulance private limited',
    'SRIVEDA SATTVA PRIVATE LIMITED',
    'Broadvision services private limited',
    'Asit koticha foundation',
    'Brucke biocare private limited',
    'Small scale sustainable infrastructure development fund',
    'Designer and artist copyright limited',
    'Retailers association of india',
    'JUST-HUMBLE CHARITABLE FOUNDATION',
    'The film & television producers guild of india ltd.',
    'Triggerhappy entertainment private limited',
    'Manhattan communications (india) private limited',
    'SIDDHANT CINEVISION Private Limited',
    'Box office cinema india private limited',
    'Maask entertainment private limited',
    'Ramanora global private limited',
    'Subhash studios private limited',
    'Rama entertainment private limited',
    'Invictus t mediaworks private limited',
    'Showspace events private limited',
    'Friday filmworks private limited',
    'N.b.pawar hospitalities private limited',
    'ROYAL MULTISPORT PRIVATE LIMITED',
    'Blueridge golfclub private limited',
    'Ideal multiplex private limited',
    'Saark freight forwarders private limited',
    'Neesa security solutions private limited',
    'Cross cultural consulting services private limited',
    'Eddies hospitality private limited',
    'DGC ENGINEERING PRIVATE LIMITED',
    'Nis it solutions (nagpur) private limited',
    'Jagdeesh security and services private limited',
    'Nano serendipity consortium private limited',
    'IKP VENTURE ADVISORS PRIVATE LIMITED',
    'Robotix learning solutions private limited',
    'C360 design solutions private limited',
    'Medihealthcare private limited',
    'Mobilevectors private limited',
    'Trade facilities management (india) private limited',
    'Tim leisure services private limited',
    'Kshitiraj constructions private limited',
    'Queenstown constructions private limited',
    'Worksphere gold land limited',
    'Galore infratech private limited',
    'Mep una bus terminal private limited',
    'Fire brick constructions private limited',
    'Narmada bridge tollway limited',
    'Savitri buildinfra private limited',
    'Prive errectors private limited',
    'Dnyaneshwar infra private limited',
    'Hemay infrastructure private limited',
    'ITL SHIP MANAGEMENT PRIVATE LIMITED',
    'Goldchip infraventure private limited',
    'Olive infraresorts private limited',
    'DHAMRA INFRASTRUCTURE PRIVATE LIMITED',
    'Shivratna properties private limited',
    'Urmila infrastructures private limited',
    'Domesh builders private limited',
    'Urmila mansion private limited',
    'Tnr industries private limited',
    'Lanxin infratech private limited',
    'Western indian states motors ltd',
    'Susee autoplaza private limited',
    'Hitech car masters private limited',
    'Soni auto & allied industries limited',
    'Valliyara trading and services private limited',
    'S & s goods private limited',
    'SUSEE AUTOMOTIVE PRIVATE LIMITED',
    'Phoenix auto world private limited',
    'Renault nissan technology & business centre india private limited',
    'Drav multitrading private limited',
    'Komal amin exports private limited',
    'Villamode export (india) p ltd',
    'Shekhawati marketing private limited',
    'Proton consultancy services private limited',
    'Palak agency private limited',
    'Samurai commodity services private limited',
    'Vibhuti commodities private limited',
    'Fortune bell commodities pvt ltd',
    'View mercantile private limited',
    'Parshva diam private limited',
    'IGS RAILROADS PRIVATE LIMITED',
    'Dimension retail solutions private limited',
    'Raghav tradelink private limited',
    'Udanta exim private limited',
    'Rajrajeshwari multitrade private limited',
    'Ionization engineers private limited',
    'Tarang exports private limited',
    'SUKRAFT RECYCLING PRIVATE LIMITED',
    'Rektor mines and minerals limited',
    'Saberi merchants & traders private limited',
    'HAPPY E BUSINESS PRIVATE LIMITED',
    'Kasauti sales private limited',
    'Arrive business spaces private limited',
    'Netway home products (india) private limited',
    'Charming fashions private limited',
    'Amazing marketing & exim private limited',
    'Jaj creations impex private limited',
    'WORLDWIDE GREEN TRADING PRIVATE LIMITED',
    'Dialforhealth greencross limited',
    'Lumiere life sciences private limited',
    'Evershine pharmaceutical distributors private limited',
    'Sai biocare private limited',
    'Mangatrai pearls & jewellers private limited',
    'Eagle petroleum company limited',
    'Precious alloys private limited',
    'Infinium precious resources limited',
    'Aston steel private limited',
    'Abc imports and exports (india) private limited',
    'La cera mall private limited',
    'Belden india private limited',
    'STARKER AUTOMATION PRIVATE LIMITED',
    'Agrasen agro industries private limited',
    'Meta information systems private limited',
    'Iqlub online marketing private limited',
    'North american mercantile india private limited',
    'Laxsons automation private limited',
    'Pelf power electronics private limited',
    'Ramya impex private limited',
    'Action medical marketing private limited',
    'Lanxin engineering private limited',
    'Speciality value lighting & design private limited',
    'N.k.agencies private limited',
    'Anjani kumar company private limited',
    'Vikram tea processor private limited',
    'Aji commercial pvt ltd',
    'Flash trade finvest private limited',
    'Tranquil trading company limited',
    'Sr artefacts private limited',
    'Satra property developers private limited',
    'Kgr enterprises private limited',
    'Igawara india private limited',
    'ANUP INDUSTRIES PRIVATE LIMITED',
    'Solsons exports pvt ltd',
    'Wonderpack formers private limited',
    'Indian comtrade intermediaries pvt.ltd.',
    'Fonterra india private limited',
    'Dhanvantari botanicals private limited',
    'Sanjeevani health & life style private limited',
    'Via media health communications private limited',
    'Metieta advertising private limited',
    'Modemedia communications private limited',
    'Hta marketing services private limited',
    'Better communications private limited',
    'Cloud nine graphics private limited',
    'OAP MEDIATECH PRIVATE LIMITED',
    'Future media (india) limited',
    'R K SWAMY LIMITED',
    'Swan travels pvt ltd',
    'Skyline international services(pvt)ltd',
    'Mohan modes pvt ltd',
    'Independent investment company',
    'CRIMSON FINANCIAL SERVICES Private Limited',
    'Elegant realtors and exim private limited',
    'Suraj bhan synthetics private limited',
    'Sunstar properties and impex private limited',
    'Best deal housing and constructions private limited',
    'Ramprastha infrastructure private limited',
    'Prime comfort products private limited',
    'Cint security private limited',
    'Go try marketing private limited',
    'Anuraj overseas private limited',
    'Gtpl jay mataji network private limited',
    'Nsr international private limited',
    'Patracode services private limited',
    'Concom trading india private limited',
    'Smart enovations (india) private limited',
    'ASR INVESTCORP PRIVATE LIMITED',
    'Phantom ideas private limited',
    'Granite river labs technology private limited',
    'Altigreen propulsion labs private limited',
    'Unicap consulting private limited',
    'Integral business and investment solutions private limited',
    'Brainbridge employability enhancement school private limited',
    'Ncdex institute of commodity markets and research',
    'Growth capital trustee company private limited',
    'Chemtrade overseas private limited',
    'Par-pact environmental engineering private limited',
    'Pipavav technical services private limited',
    'Pioneer decopack private limited',
    'Dezan shira consultancy services private limited',
    'Translog express private limited',
    'Vetrie speciality engineering private limited',
    'Maximus mice and media solutions private limited',
    'Brandcanvas wall art private limited',
    'Nuovomondo chemicals private limited',
    'P16 INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'Sitel technologies private limited',
    'Capaleph trustee company india private limited',
    'CRICKET MILLIONAIRE PRIVATE LIMITED',
    'Vistoso furniture private limited',
    'Crp beaumont research (india) private limited',
    'Redberry equipment private limited',
    'Prospero finvest limited',
    'Green bricks infradevelopers private limited',
    'K. b. warehousing & logistics private limited',
    'Vertices consultants private limited',
    'Bachmann electronic industrial automation private limited',
    'Astute management solutions & services private limited',
    'Gk energy marketers private limited',
    'SEEBACH FILTER SOLUTIONS INDIA PRIVATE LIMITED',
    'STARTUPWALA TECHNOLOGIES PRIVATE LIMITED',
    'Neha elecon services private limited',
    'Plutus fund advisors private limited',
    'Saara polycoats private limited',
    'Unique hvac solutions private limited',
    'Shivratna media private limited',
    'Aishwarya mechfo (india) private limited',
    'S k a mansion private limited',
    'Medha traction equipment private limited',
    'Hansa vision india private limited',
    'Analyze biotech private limited',
    'Rka advisory services private limited',
    'Jaju chem drops private limited',
    'Shram resources private limited',
    'Naz maritime services private limited',
    'Reach process outsourcing private limited',
    'Tiwari security and detective agency private limited',
    'Adept force private limited',
    'Kspy pack private limited',
    'Rite ways enviro private limited',
    'Origin insurance brokers india private limited',
    'Ckb global logistics private limited',
    'HIND ELECTRONIKA INDIA PRIVATE LIMITED',
    'Maximum media private limited',
    'Thyssenkrupp india private limited',
    'Monnaie interior designers private limited',
    'Kokare clothing asia private limited',
    'Eight petals creative solution private limited',
    'When-it-strikes crisis management private limited',
    'Elitmus evaluation private limited',
    'Benir e-store solutions private limited',
    'NOVO STAR MANAGEMENT SYSTEMS SOLUTIONS INDIA PRIVATE LIMITED',
    'CALL FOR SAFETY & QUALITY SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SEQUEL PROMOTERS AND DEVELOPERS PRIVATE LIMITED',
    'Ncl homes limited',
    'Dr. bvs builders private limited',
    'Engineers estates madras private limited',
    'Popular foundations private limited',
    'S g promoters private limited',
    'Second vivekananda bridge tollway company private limited',
    'Sri meenakshmi metropolitan construction private limited',
    'Mana projects private limited',
    'Eranad properties private limited',
    'Eranad township complex private limited',
    'Vazhayoor properties private limited',
    'Easthill property developers private limited',
    'Kallai realtors private limited',
    'MANANCHIRA TOWNSHIP COMPLEX PRIVATE LIMITED',
    'Avas real estate pvt ltd',
    'Mirchandani infrastructure private limited',
    'GOSHAR DEVELOPERS PRIVATE LIMITED',
    'A B INFRABUILD LIMITED',
    'Dmia land (india) private limited',
    'Ranka griha nirman private limited',
    'Asian homes private limited',
    'Marvel infratech private limited',
    'Barasat-krishnagar expressways limited',
    'Rajauli-bakhtiyarpur expressways limited',
    'Cedres industries india private limited',
    'Marcomm designing and infrastructure private limited',
    'Unisquire builders and developers private limited',
    'Newtown dwellers private limited',
    'Amipro infra private limited',
    'Bes consultants private limited',
    'Abhikalp infrastructure private limited',
    'Eureka structures private limited',
    'SHUBHAM EPC PRIVATE LIMITED',
    'Shri vastunirmiti landmark private limited',
    'Hyderabad expressways limited',
    'Spectrum infraprojects india private limited',
    'Ranchi expressways limited',
    'Ascendo projects private limited',
    'Mpr projects private limited',
    'Viswakarma commerce centre private limited',
    'Bharat pre-stressed technologies private limited',
    'Idi infra private limited',
    'Highpowerv realtors & construction company private limited',
    'Adharshila buildcon private limited',
    'New horizons realbuild private limited',
    'Samsung c&t india private limited',
    'Vijayachandra building products private limited',
    'ASTERIX AADHARBHUT SANRACHNA LIMITED',
    'D E C ENGINEERING PRIVATE LIMITED',
    'Searock developers private limited',
    'Asian property developers private limited',
    'Alfa mana realtors parivate limited',
    'Conpro consultants private limited',
    'Auckland constructions private limited',
    'Rhett infraprojects private limited',
    'Adarsh industrial estate private limited',
    'Khemka global infrastructure private limited',
    'Gloob interior design private limited',
    'STERNA INDIA OIL & GAS PRIVATE LIMITED',
    'Alliance infraprojects private limited',
    'PRAMUKH & AAADI BUILDSCAPE PRIVATE LIMITED',
    'Covalent projects & engineering private limited',
    'I.s.p. infrastructures private limited',
    'LANDTECH AEPC PRIVATE LIMITED',
    'Urban tree infrastructures private limited',
    'Shivoham builders private limited',
    'Sai ram krishna cars private limited',
    'Evm passenger cars india private limited',
    'Suryabala trucks and tippers private limited',
    'Sree saradhambal automobiles erode private limited',
    'Apple auto private limited',
    'Secure mobile india private limited',
    'Param cars private limited',
    'Opulent auto care private limited',
    'RAJARSHI TRADERS PRIVATE LIMITED',
    'Udeshi international private limited',
    'Agrasen cars private limited',
    'Virgo motor agencies private limited',
    'Sonnet trade and investments private limited',
    'Prism enterprises private limited',
    'Khatu naresh agencies private limited',
    'ACCHAI FOODS PRIVATE LIMITED',
    'National spot exchange limited',
    'Kochhar impex private limited',
    'Groma global limited',
    'ESSENZAA NUTRITION PRIVATE LIMITED',
    'Bluescope av technologies private limited',
    'Giovenzana controls india private limited',
    'Arme impex private limited',
    'Mercer consulting (india) private limited',
    'MILTONROY INDIA PRIVATE LIMITED',
    'Specialise instruments marketing company private limited',
    'Kusters engineering india private limited',
    'Imperial tradex private limited',
    'Zinnia enterprises india private limited',
    'Kupps & sachs india private limited',
    'Parexel international clinical research private limited',
    'Sai heatreaters and non-destructive testing private limited',
    'Seven stars media private limited',
    'Purple events limited',
    'Linear communications private limited',
    'Oojam creative solutions private limited',
    'Situations advertising and marketing services pvt ltd',
    'Sig printpack private limited',
    'Gnosis services private limited',
    'Walkways advertising private limited',
    'Image brandnew india private limited',
    'Agrawal metal works private limited',
    'Jain hydraulics pvt ltd',
    'Eastman industries limited',
    'Garg ispat udyog limited',
    'Rmsi private limited',
    'Adidas technical services private limited',
    'Soni exim private limited',
    'Amway india enterprises private limited',
    'Pal inn private limited',
    'Vishesh holdings private limited',
    'PRIORITY IDC PRIVATE LIMITED',
    'Verve integrated marketing services private limited',
    'S r v logistics india private limited',
    'Delhi cargo service center private limited',
    'Rational international india private limited',
    'Orangetip design private limited',
    'Three wheels united india services private limited',
    'Vis networks private limited',
    'EXCELLENCE4U RESEARCH SERVICES PRIVATE LIMITED',
    'Zhi ernest solutions private limited',
    'Vision speciality coatings private limited',
    'Footieculture india private limited',
    'Synclovis systems private limited',
    'Vg m.i.c.e. management private limited',
    'RIDDH PROJECTS PRIVATE LIMITED',
    'T. s. lines (india) private limited',
    'VEEYEM INFRATECH (I) PRIVATE LIMITED',
    'Bjn banquets private limited',
    'Urban science applications private limited',
    'Avn solution providers private limited',
    'Vilco ingredients private limited',
    'Siddhant arts private limited',
    'EAGLE HOSPITALITY SERVICE PRIVATE LIMITED',
    'AL JABER HEAVY LIFT & TRANSPORT (INDIA) PRIVATE LIMITED',
    'Dolphin marine supply private limited',
    'Nexus petrochem private limited',
    'Ca media digital (india) private limited',
    'Pico services mumbai private limited',
    'Inline shipping agency private limited',
    'Linq digital marketing private limited',
    'FIDUS SPORTS MANAGEMENT PRIVATE LIMITED',
    'Prius logistics private limited',
    'PNGS GARGI FASHION JEWELLERY LIMITED',
    'Shamrock facility management services private limited',
    'NEXDIGM PRIVATE LIMITED',
    'ZOOMLION HEAVY INDUSTRY INDIA PRIVATE LIMITED',
    'Paramtech cad services private limited',
    'Maitrise language essentials private limited',
    'Value gain distributors private limited',
    'Beeserv consulting private limited',
    'FATEH HYDERABAD ASSOCIATED FOOTBALL CLUB PRIVATE LIMITED',
    'High edge real estate advisory private limited',
    'Karsha thoughts technologies private limited',
    'Highpowerv stanpro services (india) private limited',
    'INTEGRATED FOODS & CONSUMER PRODUCTS (INDIA) PRIVATE LIMITED',
    'Jai consultancy services private limited',
    'Andovar localization services private limited',
    'Ips vantage tech services private limited',
    'Jay durga industrial security private limited',
    'Lynx security and detective services private limited',
    'Jeet inspection services (india) private limited',
    'Harsha graphics private limited',
    'Navinya shipping services private limited',
    'V c shah patel services private limited',
    'Brandaid events (india) private limited',
    'Greenlight planet india private limited',
    'Milestone logistics private limited',
    'Venuta exim and logistics solutions private limited',
    'Essnd derma private limited',
    'PIT LANE RETAIL PRIVATE LIMITED',
    'Essnd life private limited',
    'Accord extruders private limited',
    'CEEYU CONSUMER PRIVATE LIMITED',
    'Green international project management private limited',
    'Thriven marketing india limited',
    'Promozone (india) private limited',
    'Shwetamber gem and jewellers private limited',
    'Drishtee rural apparel producer company limited',
    'Graceful media (india) private limited',
    'Dcp india private limited',
    'Stalwart leisure private limited',
    'Smas auto leasing india private limited',
    'Mansarovar cartons hut private limited',
    'Idam infrastructure advisory private limited',
    'Jnp builders private limited',
    'Sushobhit properties private limited',
    'Warasgaon infrastructure providers limited',
    'Keystone lifespaces private limited',
    'Qcd infra private limited',
    'Aril infrastructure private limited',
    'Intalia realty private limited',
    'SUSHEE INFRA & MINING Limited',
    'Sumadhura constructions private limited',
    'Progressive enclaves limited',
    'Sitrus projects private limited',
    'Faster infrastructure and engineering services private limited',
    'Vaibhu infra tech india private limited',
    'Akshayazen global infratech private limited',
    'Kodur developers private limited',
    'Milan vihar private limited',
    'Star city homes private limited',
    'Uttarak infradevelopers private limited',
    'Sulekh constructions private limited',
    'Talin infradevelopers private limited',
    'Vyan infraprojects private limited',
    'Pushpak habitat private limited',
    'Lahar infrastructure private limited',
    'Leelavati infrastructure private limited',
    'Sadhana villas private limited',
    'Green park projects private limited',
    'Vasupradha projects private limited',
    'Sabarmati land fostering private limited',
    'Udayan projects private limited',
    'Splendor landbase limited',
    'Friends infrastructure private limited',
    'Landcraft developers private limited',
    'Jaksons developers private limited',
    'Spectrum construction co private limited',
    'Himalaya darshan housing developement (gujarat) private limited',
    'Jayhind buildcon private limited',
    'Radha krishna realty private limited',
    'Yash procon private limited',
    'Shashvat infraventure private limited',
    'Srs real estate limited',
    'Premium commercial constructions private limited',
    'Kerala state construction corpn ltd',
    'Veegaland developers private limited',
    'Loya pre engineered buildings private limited',
    'Hrl township developers limited',
    'Hrl (thane) real estate limited',
    'Uditi premises private limited',
    'Urban kshetra infrastructure private limited',
    'FAIME MAKERS PRIVATE LIMITED',
    'Ryan ship management private limited',
    'Aakash global buildmate private limited',
    'G: corp developers private limited',
    'Steel real estates private limited',
    'Pearl buildestate developers private limited',
    'Seven ocean infratech private limited',
    'Ritu associates private limited',
    'Seamless properties private limited',
    'Navin housing and properties private limited',
    'Techno engineering construction (india)private limited',
    'Voora shreeram constructions private limited',
    'Top light homes private limited',
    'SAUNRACHANA STRUCON PRIVATE LIMITED',
    'Nexus infratech private limited',
    'Simran outsourcing services private limited',
    'CYBER PARK DEVELOPMENT & CONSTRUCTION PRIVATE LIMITED',
    'Western outdoor structures private limited',
    'G+H INSULATION INDIA PRIVATE LIMITED',
    'MILLENNIUM ENGINEERS AND CONTRACTORS PRIVATE LIMITED',
    'Eta properties and investments private limited',
    'GAANGEY MINERALS PRIVATE LIMITED',
    'GTV INFRASTRUCUTRES PRIVATE LIMITED',
    'Kcd & shree swami realcon infra private limited',
    'Premsai properties and infrastructure private limited',
    'Ten square estates private limited',
    'Black and veatch india private limited',
    'Svr ventures india private limited',
    'Trigya infradevelopers private limited',
    'Gitanjali habitat private limited',
    'SREE UGCL PROJECTS LIMITED',
    'SUSHEE ARUNACHAL HIGHWAYS LIMITED',
    'Greenrays enersol private limited',
    'Sai charan engineers private limited',
    'Vessella constructions private limited',
    'Varenya constructions limited',
    'Navaj constructions private limited',
    'NORTH FACTOR DESIGN STUDIO PRIVATE LIMITED',
    'Brook field projects private limited',
    'ESPAN INFRASTRUCTURE (I) LIMITED',
    'Haridwar estates private limited',
    'Jashraj realtors private limited',
    'Future city multiservices sez limited',
    'Hill city service apartments limited',
    'Vadhvan green port private limited',
    'Srp realtors private limited',
    'Indigo infracon private limited',
    'Ramp weblogic private limited',
    'The next milestone technologies private limited',
    'Xpointers consulting private limited',
    'Prorigo software private limited',
    'Unosys solutions private limited',
    'EBIX TECHNOLOGIES PRIVATE LIMITED',
    'Welkin it services private limited',
    'Iacg animations private limited',
    'Techstar software development (india) private limited',
    'Yttrium info technologies private limited',
    'Vengai software solutions private limited',
    'Solsemindia software private limited',
    'Rcv innovations private limited',
    'VIVOTEX INDIA PRIVATE LIMITED',
    'Kvik infotel private limited',
    'Experts communications private limited',
    'Adbox software private limited',
    'Integrated chennai business park (india) private limited',
    'Chronus software (india) private limited',
    'Trusted properties (kpo) private limited',
    'AAUM RESEARCH & ANALYTICS PRIVATE LIMITED',
    'Virudhunagar kamaraj memorial software private limited',
    'Chargebee technologies private limited',
    'Axlerate (india) private limited',
    'BALAJI SOLUTIONS LIMITED',
    'Disa technologies private limited',
    'Fugro survey (india) private limited',
    'Treelabs foundation',
    'Suraj claims bureau private limited',
    'Sundex biotech private limited',
    'Buyselltips financial research private limited',
    'Igenerix pharma private limited',
    'Expert legal assist private limited',
    'Ruralshores business services private limited',
    'Nextgen accounting services private limited',
    'Innovators consultants private limited',
    'Ixcfo services private limited',
    'India pulses and grains association',
    'Hill view parking services limited',
    'Studio next technology private limited',
    'Ascent advertising private limited',
    'Radcom trading india private limited',
    'Ecocentric management private limited',
    'LEGACY SHIP MANAGEMENT PRIVATE LIMITED',
    'Nextgen clearing private limited',
    'Uniship global solutions private limited',
    'Futuregenz hr solutions private limited',
    'Tejaswi services private limited',
    'End to end consulting services private limited',
    'Ziksana education (india) private limited',
    'Lehren networks private limited',
    'Sunset ashram entertainment private limited',
    'Aakash infra realities private limited',
    'Avezo advisors private limited',
    'India one brand services private limited',
    'Rosslare electronics india private limited',
    'Uni source media works private limited',
    'SQUARICLE INNOVATIONS PRIVATE LIMITED',
    'Bloom irrigation systems private ltd',
    'Rio tinto india private limited',
    'Amserve consultants limited',
    'Apco worldwide (india) private limited',
    'Sui generis consulting private limited',
    'Hyundai capital india private limited',
    'INI INFRASTRUCTURE & ENGINEERING PRIVATELIMITED',
    'Aviva equipments private limited',
    'Wealth management private limited',
    'J.s. negi consultants private limited',
    'Blackrock services india private limited',
    'Liftket india private limited',
    'Earthline services private limited',
    'Rm business enterprises private limited',
    'Rangreza Retail Services Private Limited',
    'FLOATER DRILLING PRIVATE LIMITED',
    'MATTEROFTECH SOLUTIONS PRIVATE LIMITED',
    'E BEE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'BOX VERSE SOLUTIONS PRIVATE LIMITED',
    'Computer Storage Services India Private limited',
    'BODMAS TECHNOLOGIES PRIVATE LIMITED',
    'Webfries IT Solutions Private Limited',
    'KAREXPERT TECHNOLOGIES PRIVATE LIMITED',
    'EAZYDINER PRIVATE LIMITED',
    'INFOSKY SOFTWARE MANAGEMENT PRIVATE LIMITED',
    'MARZ SYSTEMS (INDIA) PRIVATE LIMITED',
    'IBG RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'VDOIT TECHNOLOGIES LIMITED',
    'Zircot Technologies Private Limited',
    'PLABRO NETWORKS PRIVATE LIMITED',
    'Moshpit Technologies Private Limited',
    '80 dB Communications Private Limited',
    'EVATO TECHNOLOGY PRIVATE LIMITED',
    'GREEN PLANET HOSPITALITY PRIVATE LIMITED',
    'Evoxyz Technologies Private limited',
    'DigiSmart Digital Media Private Limited',
    'PROMMADA HINDUSTAN PRIVATE LIMITED',
    'CONVERSION BUG DIGITAL MARKETING PRIVATE LIMITED',
    'ETHICALHAT CYBER SECURITY PRIVATE LIMITED',
    'HAZE MEDIA IT PRIVATE LIMITED',
    'Turnpoint Technologies Private Limited',
    'L.S. Power Control Private Limited',
    'MAXBROS VENTURES INDIA LIMITED',
    'MAXBROS TELETRONICS PRIVATE LIMITED',
    'BULK MARINE INDIA PRIVATE LIMITED',
    'ROBUST RESULTS PRIVATE LIMITED',
    'DARYA SHIPMANAGEMENT PRIVATE LIMITED',
    'TRUX APP PRIVATE LIMITED',
    'TRAVEL IQ SERVICES PRIVATE LIMITED',
    'CRESCO FUTURES LIMITED',
    'Unnati Online Private Limited',
    'Quatrro Business Support Solutions Private Limited',
    'BYTENINJAS SERVICES PRIVATE LIMITED',
    'Way2Solution Facility Management Services Private limited',
    'SATVACART INNOVATIVE CONCEPTS PRIVATE LIMITED',
    'Whiz Kidz Media Private Limited',
    'Saffron Tiger Infravision Group Private Limited',
    'HSG PROPMART PRIVATE LIMITED',
    'ITX Services India Private Limited',
    'MIHAMA INDIA PRIVATE LIMITED',
    'PIONEER KNOWLEDGE FOUNDATION',
    'B & Q RELOCATION SERVICES PRIVATE LIMITED',
    'PAYOOM DIGITAL MEDIA PRIVATE LIMITED',
    'SOM PRO FACILITIES INDIA PRIVATE LIMITED',
    'BRILLIANT WELLNESS PRIVATE LIMITED',
    'GLADIATA PROJECTS PRIVATE LIMITED',
    'BIMLRAJ OUTSOURCING PRIVATE LIMITED',
    'PayGate India Private Limited',
    'NRM CORPORATE LEASING PRIVATE LIMITED',
    'Incredible Facade Developer Private Limited',
    'I & S BUILDTECH PRIVATE LIMITED',
    'KHOMES REALTOR PRIVATE LIMITED',
    'Hippo Innovations Private Limited',
    'ViralCraft Digital Media Private Limited',
    'KILPATRICK EXECUTIVE SEARCH INDIA PRIVATE LIMITED',
    'Three Ayee Consulting & Venture Management Private Limited',
    'DUBLI INDIA PRIVATE LIMITED',
    'AUSTRALIA INDIA INSTITUTE PRIVATE LIMITED',
    'Altitude Software Asia Pacific Private Limited',
    'BLINK COMMERCE PRIVATE LIMITED',
    'Airbnb Payments India Private Limited',
    'ROMANO ESTATE MANAGEMENT SERVICES LIMITED',
    'WISDOMHILL CAPITAL ADVISORS PRIVATE LIMITED',
    'BRONCOS SERVICES PRIVATE LIMITED',
    'GLOBE SECURITY SOLUTIONS PRIVATE LIMITED',
    'TRICULIN RETAIL PRIVATE LIMITED',
    'VRIDHI ENTERPRISES PRIVATE LIMITED',
    'KONTENT EDGE PRIVATE LIMITED',
    'SUPER INDIA (GLOBAL) LOGISTICS PRIVATE LIMITED',
    'NDM MARKETING PRIVATE LIMITED',
    'RADIANCE SPACE SOLUTIONS PRIVATE LIMITED',
    'La Mer Maritime Private Limited',
    'Fluidech IT Services Private Limited',
    'NEWAGE HONGFA LOGISTICS INDIA PRIVATE LIMITED',
    'CapBuild Clinical Skills Private Limited',
    'Datrux Systems Private Limited',
    'SHALIN INTERNATIONAL PRIVATE LIMITED',
    'A S R Business Advisors Private Limited',
    'Designbox Collective Private Limited',
    'LiveObjects Technologies Private Limited',
    'Chainway (India) Private Limited',
    '90MINUTES RETAIL PRIVATE LIMITED',
    'ADVANCE SECURITECH INDIA PRIVATE LIMITED',
    'TALETTUTAYI SOLAR PROJECTS ONE PRIVATE LIMITED',
    'PayGo Technologies Private Limited',
    'Xedign Design Private Limited',
    'CHISEL & ADZE CONSULTING PRIVATE LIMITED',
    'INDIFI TECHNOLOGIES PRIVATE LIMITED',
    'WINNTUS FORMWORK PRIVATE LIMITED',
    'Quick Digital Technologies Private Limited',
    'EUGENIX HAIR SCIENCES PRIVATE LIMITED',
    'INDIA BUILDINGSMART INTERNATIONAL PRIVATE LIMITED',
    'POLICYBAZAAR INSURANCE BROKERS PRIVATE LIMITED',
    'DIYA FACILITY SOLUTIONS AND WAREHOUSE MANAGEMENT PRIVATE LIMITED',
    'GRADUATE MANAGEMENT GLOBAL CONNECTION (INDIA) PRIVATE LIMITED',
    'PHONON COMMUNICATIONS PRIVATE LIMITED',
    'PATTERNS IT ENABLED SERVICES PRIVATE LIMITED',
    'ANED Technologies Private Limited',
    'TECHFORCE INFOTECH PRIVATE LIMITED',
    'INTRANSURE TECHNOLOGIES PRIVATE LIMITED',
    'EPSTOM SPEC CHEM PRIVATE LIMITED',
    'Mobiefit Technologies Private Limited',
    'APTASK INDIA PRIVATE LIMITED',
    'CORBION COMMUNICATION PRIVATE LIMITED',
    'MADHAV INFRACON (GHANSORE MANDLA CORRIDOR) PRIVATE LIMITED',
    'EXIMCAN ENTERPRISES PRIVATE LIMITED',
    'BORKAR SURAKSHA PACKAGING PRIVATE LIMITED',
    'NIHAR HOSPITALITY PRIVATE LIMITED',
    'VGG Trading Private Limited',
    'OLIVERS HOLIDAY HOMES PRIVATE LIMITED',
    'SWORD LEO SYSTEMS PRIVATE LIMITED',
    'Bharat Bhushan Finance & Commodity Brokers Limited.',
    'N D A SECURITIES LIMITED',
    'CSL FINANCE LIMITED',
    'INTEGRATED CAPITAL SERVICES LIMITED',
    'DCM SHRIRAM AQUA FOODS LIMITED',
    'TKS DEVELOPERS LIMITED',
    'Wesbok Lifestyle Private Limited',
    'DEXTER APPARELS PRIVATE LIMITED',
    'GROVERSONS INTERNATIONAL LIMITED',
    'Amphibian Tours Private Limited',
    'AMPHIBIOUS DESIGN (INDIA) PRIVATE LIMITED',
    'Handy Training Technologies Private Limited',
    'QUIZIGO TECHNOLOGIES PRIVATE LIMITED',
    'DHANUKA LABORATORIES LIMITED',
    'RAMAGUNDAM FERTILIZERS AND CHEMICALS LIMITED',
    'KADIMI ORGANICS LIMITED',
    'Digital Dwarves Private Limited',
    'BABRI POLYPET PRIVATE LIMITED',
    'Multi infratech Private Limited',
    'CLAAS Agricultural Machinery Private Limited',
    'Continental Defence Solutions Private Limited',
    'VINSAK INDIA PRIVATE LIMITED',
    'BRAMBILLA INDIA PRIVATE LIMITED',
    'R M Technocorp Private Limited',
    'CARRYAGE TECHNOLOGIES PRIVATE LIMITED',
    'SEYNSE TECHNOLOGIES PRIVATE LIMITED',
    'SUNIL EDUCATIONAL SERVICES INDIA PRIVATE LIMITED',
    'PARUL INNOVATION AND ENTREPRENEURSHIP RESEARCH CENTRE',
    'PROYURVEDA LIFESCIENCE PRIVATE LIMITED',
    'MAIHER SECURITY SERVICE INDIA PRIVATE LIMITED',
    'K10 ENTERTAINMENT PRIVATE LIMITED',
    'MALVICA ENGINEERING LIMITED',
    'KESHAV MANGLAM IMPEX PRIVATE LIMITED',
    'MODERN CABLES CONDUCTORS PVT LTD',
    'SAHYADRI CASHEWS PRIVATE LIMITED',
    'POWERGRID SOUTHERN INTERCONNECTOR TRANSMISSION SYSTEM LIMITED',
    'NER II TRANSMISSION LIMITED',
    'AVAADA CLEAN ENERGY PRIVATE LIMITED',
    'AVAADA NON-CONVENTIONAL ENERGY PRIVATE LIMITED',
    'AVAADA SUSTAINABLE ENERGY PRIVATE LIMITED',
    'ASSESS SEALNCARE PRIVATE LIMITED',
    'AUTO WHEELS PRIVATE LIMITED',
    'SIPAT TRANSMISSION LIMITED',
    'Raipur-Rajnandgaon-Warora Transmission Limited',
    'Odisha Generation Phase-II Transmission Limited',
    'Warora-Kurnool Transmission Limited',
    'Welspun Green Energy Private Limited',
    'Propel Power Systems Private Limited',
    'EMPERIUM REALTY PRIVATE LIMITED',
    'LINC INFRA ENGINEERING AND CONTRACTS PRIVATE LIMITED',
    '13THJUNE INFOTECH PRIVATE LIMITED',
    'SHR LIFESTYLES PRIVATE LIMITED',
    'ARM News Private Limited',
    'VIKRAMSHILA MEDIA VENTURES PRIVATE LIMITED',
    'Jhola Internet Private Limited',
    'Intaglio Press Private Limited',
    'JUGGERNAUT BOOKS PRIVATE LIMITED',
    'PREMIA COSMETICS PRIVATE LIMITED',
    'ENOVUS HEALTHCARE PRIVATE LIMITED',
    'ANANT DESIGN PRIVATE LIMITED',
    'INTEGRINA TECHNOLOGIES PRIVATE LIMITED',
    'Transforming Retail Private Limited',
    'STAR RFID AND SYSTEMS INDIA PRIVATE LIMITED',
    'LUMINUP ELECTRONICS LED INDIA PRIVATE LIMITED',
    'LEAF INNOVATION PRIVATE LIMITED',
    'Telecolor India Private Limited',
    'PRIMEONE INFRAPROJECTS PRIVATE LIMITED',
    'BAXY LIMITED',
    'Usha Breco Chamunda Devi Ropeway Private Limited',
    'Usha Breco Shimla Ropeway Private Limited',
    'JOURNEYS RESORTS PRIVATE LIMITED',
    'AVAADA SOLAR ENERGY PRIVATE LIMITED',
    'KNM TRANS & FORM PRIVATE LIMITED',
    'CAN ACTIN IMMIGRATION PRIVATE LIMITED',
    'SAFESEA STEAMSHIP PRIVATE LIMITED',
    'MEMORABLE INDIA JOURNEYS PRIVATE LIMITED',
    'INDOMATRIX LOGISTICS PRIVATE LIMITED',
    'Kalpadeep Holidays and Events Private Limited',
    'Chhattisgarh-WR Transmission Limited',
    'VICTOR HOSPITALS AND MEDICAL SERVICES (GOA) PRIVATE LIMITED',
    'Micro Units Development & Refinance Agency Limited',
    'IMAGINATIVE FINSERVICES PRIVATE LIMITED',
    'SARTHAK SEWA PRIVATE LIMITED',
    'JPL GLOBAL PRIVATE LIMITED',
    'SIMROSE RESORTS PRIVATE LIMITED',
    'MCCL BUILDPRO LIMITED',
    'MAGNUM PROMOTERS PRIVATE LIMITED',
    'TC NetLeap Private Limited',
    'JAAPYAROSE INDUSTRIES PRIVATE LIMITED',
    'GAME CHANGERS TEXFAB PRIVATE LIMITED',
    'PRADEEP POWER SOLUTION PRIVATE LIMITED',
    'EDV FASHION PRIVATE LIMITED',
    'DUNONU INDIA PRIVATE LIMITED',
    'FLY WITH US TOURS AND TRAVELS PRIVATE LIMITED',
    'STHI Holidays India Private Limited',
    'The Leaf Holidays Private Limited',
    'TDL Warehousing Parks Limited',
    'K SAHNI BROTHERS PRIVATE LIMITED',
    'AMAN TRAVELS DELHI PRIVATE LIMITED',
    'FIREFLIEZ TRAVELS AND EVENTS PRIVATE LIMITED',
    'DILWARA LEASING AND INVESTMENT LIMITED',
    'SPENG ENGINEERING PRIVATE LIMITED',
    'MTI MATERIALS PRIVATE LIMITED',
    'VNG AUTOMOTIVES PRIVATE LIMITED',
    'INFRASTRUCTURE PROJECTS AND ENGINEERS PRIVATE LIMITED',
    'ECLECTIC MARKETING INDIA PRIVATE LIMITED',
    'INDIKA AGRO PRODUCTS PRIVATE LIMITED',
    'KANTA CREDITS AND HOLDING PRIVATE LIMITED',
    'D.P. AUTO INDUSTRIES PRIVATE LIMITED',
    'PHAROS SOLUTIONS PRIVATE LIMITED',
    'EBULLIENT SECURITIES PRIVATE LIMITED',
    'MULTIVIEW NETWORK DISTRIBUTION PRIVATE LIMITED',
    'SINGHAL POLYTECH LIMITED',
    'ANKHUA EXPORTS PRIVATE LIMITED',
    'P.P. JEWELLERS PRIVATE LIMITED',
    'RANGOLI FURNISHINGS PRIVATE LIMITED',
    'MYLOANCARE VENTURES PRIVATE LIMITED',
    'AGGAM MONEYTECH PRIVATE LIMITED',
    'POWERFUL TECHNOLOGIES LIMITED',
    'LUMAX ELECTRONICS PRIVATE LIMITED',
    'K C M ROYALINFRA INDIA PRIVATE LIMITED',
    'Techximum Solutions Private Limited',
    'Mosix Tech Private Limited',
    'Argali Knowledge Services Private Limited',
    'VISION INTERIOR & CONSULTANT PRIVATE LIMITED',
    'FYD INTERIORS PRIVATE LIMITED',
    'INXUS EVENTS PRIVATE LIMITED',
    'IMPACT INVESTORS COUNCIL',
    'MAD MEN MARKETING OPC PRIVATE LIMITED',
    'BRAND ANALYSIS INDIA PRIVATE LIMITED',
    'OTHERLOGIC EXPERIENTIAL PRIVATE LIMITED',
    'SUPPLY CHAIN ANALYTICS AND TECHNOLOGIES PRIVATE LIMITED',
    'ALL IN ONE HOSPITALITY PRIVATE LIMITED',
    'ZOOPCONNECT PRIVATE LIMITED',
    'GO 2 MARKET INDIA PRIVATE LIMITED',
    'Compare Policy Insurance Web Aggregators Private Limited',
    'MARK MAKERS CONSULTANCY SERVICES PRIVATE LIMITED',
    'DFractals Advisory Services Private Limited',
    'OPULENCE FASHIONS & RETAIL PRIVATE LIMITED',
    'KHURANA RETAIL PRIVATE LIMITED',
    'PREMIER WEALTH FINMART PRIVATE LIMITED',
    'Compliance Engineering Private Limited',
    'ASSO CHEMICALS PRIVATE LIMITED',
    'JAI MATA DI AUTO INDUSTRIES PRIVATE LIMITED',
    'K A SANGHI ENTERPRISES PRIVATE LIMITED',
    'BANSAL WOOLLENS PRIVATE LIMITED',
    'SHIVAM WIRES PRIVATE LIMITED',
    'BDR PRODUCTS INDIA PRIVATE LIMITED',
    'E-QUIPO SOLUTIONS PRIVATE LIMITED',
    'KUMAR FOOD INDUSTRIES LIMITED',
    'SINDHU TRADE LINKS LIMITED',
    'UNO MINDA LIMITED',
    'B.D.CREDITS LIMITED',
    'RINISH OVERSEAS PRIVATE LIMITED',
    'Pious Farms Private Limited',
    'BTW Foods Private Limited',
    'Megma Woolen Private Limited',
    'SAMAST CLOTHING PRIVATE LIMITED',
    'NASCENT COMMUNICATION PRIVATE LIMITED',
    'MY TRAVELNET INDIA PRIVATE LIMITED',
    'AMBIENT INTELLECT INDIA PRIVATE LIMITED',
    'INFRRACO PROJECTS PRIVATE LIMITED',
    'ZEERION INDIA PRIVATE LIMITED',
    'CLAYMANGO DESIGNS PRIVATE LIMITED',
    'PRESANG CEMENTS PRIVATE LIMITED',
    'MPCL INDUSTRIES LIMITED',
    'GENIEDOC TECHNOLOGIES PRIVATE LIMITED',
    'MITRAS EDUCATION PRIVATE LIMITED',
    'iTeach Movement',
    'First Medical Diagnostics Private Limited',
    'V.G.S. HOLIDAYS PRIVATE LIMITED',
    'GE INDIA INDUSTRIAL PRIVATE LIMITED',
    'SHOW EFFECT WORLDWIDE PRIVATE LIMITED',
    'gCare Technologies Private Limited',
    'SVML PNEUMATIC PRIVATE LIMITED',
    'Digitech Secwatch Private Limited',
    'BRIGHT BEGININGS PRIVATE LIMITED',
    'IBOX STUDIOS PRIVATE LIMITED',
    'REDLINE HEALTH CARE PRIVATE LIMITED',
    'CAPITAL ELECTRICALS Private Limited',
    'V P JAIN CAPITAL PRIVATE LIMITED',
    'AMBAY MOTORS PRIVATE LIMITED',
    'Surge Advertising Private Limited',
    'Euphoria InfoVentures Private Limited',
    'SHRI PARAS CORP BUSINESS SOLUTIONS PRIVATE LIMITED',
    'UNISON ADVERTISING PRIVATE LIMITED',
    'BLING COUTURE PRIVATE LIMITED',
    'Rhinoceros Equipments Private Limited',
    'A2Z BUYING SERVICES PRIVATE LIMITED',
    'BREBEN CARGO PRIVATE LIMITED',
    'R2K RETAILZONE PRIVATE LIMITED',
    'SPICE HERBALS & AMENITIES PRIVATE LIMITED',
    'A M P IMPEX PRIVATE LIMITED',
    'OYSTER BATH CONCEPTS PRIVATE LIMITED',
    'FILM ELECTRONICS PRIVATE LIMITED',
    'C T A APPARELS PRIVATE LIMITED',
    'AKAY HYDRAULICS PRIVATE LIMITED',
    'SHISHODIA CONSTRUCTION COMPANY PRIVATE LIMITED',
    'SHIELDS INTERNATIONAL PRIVATE LIMITED',
    'LASH PRODUCTS PRIVATE LIMITED',
    'MITSU SECURITIES MANAGEMENT PRIVATE LIMITED',
    'GLORY EXPORT PRIVATE LIMITED',
    'MANBHARI LEASING AND FINANCE PRIVATE LIMITED',
    'GOOD HEALTH ACCESSORIES INDIA PRIVATE LIMITED',
    'INDICARE HEALTH SERVICES PRIVATE LIMITED',
    'DIGITRA SOLUTIONS PRIVATE LIMITED',
    'WMS ENTERTAINMENT PRIVATE LIMITED',
    'FLYBOY REALITY PRIVATE LIMITED',
    'Evernote Technologies India Private Limited',
    'Techshino Technology India Private Limited',
    'SOLARGISE FOUNDATION',
    'EBG Federation',
    'Viridian ESpark Venture Accelerator',
    'JCC CONSULTANTS INDIA (OPC) PRIVATE LIMITED',
    'TROILUS AND TRINITY PRIVATE LIMITED',
    'SURE CABS PRIVATE LIMITED',
    'UNIWORLD STUDIOS PRIVATE LIMITED',
    'CANGRAFT EQUIPMENT PRIVATE LIMITED',
    'BLUE & GREY SOLUTIONS PRIVATE LIMITED',
    'Sensorise Digital Services Private Limited',
    'SBGI INDIA PRIVATE LIMITED',
    'ALPHA DELTA COATINGS PRIVATE LIMITED',
    'CUT SHORT PUBLICITY PRIVATE LIMITED',
    'JB Trustee Private Limited',
    'Yellow Drive Technologies Private Limited',
    'PB Trustee Private Limited',
    'PJ Trustee Private Limited',
    'Violet Ivy Management Private Limited',
    'BrandConn Digital Private Limited',
    'Safeview Media Private Limited',
    'FAMEPOSTER CAREER SERVICES PRIVATE LIMITED',
    'Verifair Business Events Private Limited',
    'MASHEL ELECTRIC PRIVATE LIMITED',
    'LUBE EXPERT PRIVATE LIMITED',
    'SUDARSHAN FACILITIES PRIVATE LIMITED',
    'CURATE EXPERIENCES PRIVATE LIMITED',
    'NEW BEGINNERS SERVICES PRIVATE LIMITED',
    'Eschool Buddy Retail Private Limited',
    'GLOBAL WORLD OF MUSIC AND ARTS PRIVATE LIMITED',
    'ACI PROJECT INDIA PRIVATE LIMITED',
    'CLAAS INDIA Private LIMITED',
    'SEQUOIA INFRASTRUCTURE LIMITED',
    'MOTHERSON TECHNO TOOLS LIMITED',
    'XTREMS RETAILS PRIVATE LIMITED',
    'BLACK FOX FINANCIAL PRIVATE LIMITED',
    'RURAL SPARK ENERGY INDIA PRIVATE LIMITED',
    'JAVAS CONSULTANCY SERVICES PRIVATE LIMITED',
    'Common Ground Foundation',
    'GINGER SCIENCE PRIVATE LIMITED',
    'PUSHPA PACKWELL PRIVATE LIMITED',
    'FACIO COMMUNICATIONS PRIVATE LIMITED',
    'AVEENA MILK PRODUCTS PRIVATE LIMITED',
    'LAMBENT ENGINEERING PRIVATE LIMITED',
    'S3 ENERGY PRIVATE LIMITED',
    'Wellman Employment India Private Limited',
    'M&S TRAVERSE PRIVATE LIMITED',
    'DELTECH HEALTHCARE PRIVATE LIMITED',
    'SOLVENS CONSTRUCTION AND SERVICES PRIVATE LIMITED',
    'INQNEST MARKETING SOLUTIONS PRIVATE LIMITED',
    'ServerWorks IT Solutions OPC Private Limited',
    'STEVIE',
    'MEON TECHNOLOGIES PRIVATE LIMITED',
    'SMART SENTRY AI INDIA PRIVATE LIMITED',
    'VALUBIZ CONSULTANCY PRIVATE LIMITED',
    'ENTERPRISES AWARDS PRIVATE LIMITED',
    'SUSTAINABLE IMPACTS PRIVATE LIMITED',
    'AVWAL WAREHOUSING PRIVATE LIMITED',
    'SKILLRAZE CONSULTING & TECHNOLOGIES PRIVATE LIMITED',
    'STAR WIRE (INDIA) VIDYUT (SAWAI MADHOPUR) PRIVATE LIMITED',
    'SHIPWORKZ MARINE SOLUTIONS PRIVATE LIMITED',
    'MAGNEQ VENTURES PRIVATE LIMITED',
    'NAVIAS SHIP MANAGEMENT PRIVATE LIMITED',
    'JAIBALAJI HOMETEX PRIVATE LIMITED',
    'INVENTIVECAFE INDIA PRIVATE LIMITED',
    'STARCRET ENTERTAINMENT INDIA PRIVATE LIMITED',
    'KAMPRI LIFESCIENCE PRIVATE LIMITED',
    'NEXTERA PRODUCTION PRIVATE LIMITED',
    'IJYARAYS ENERGY PRIVATE LIMITED',
    'TRINFINITY BPO PRIVATE LIMITED',
    'REACHING AND ENABLING YOU PRIVATE LIMITED',
    'SAMIPYA WELFARE FOUNDATION',
    'EMAMBIT PRIVATE LIMITED',
    'BPM ENTERPRISES PRIVATE LIMITED',
    'KRISHI SQUARE PRIVATE LIMITED',
    'CHAHAK FARMS PRIVATE LIMITED',
    'JETTRADE AND LOGISTIC (I) PRIVATE LIMITED',
    'BRAINITCH ACADEMY PRIVATE LIMITED',
    'GREENGOURMET FOODS PRIVATE LIMITED',
    'EXIA TECHNOLOGY (OPC) PRIVATE LIMITED',
    'ESSAR MINERALS LIMITED',
    'PI BIOFERMA PRIVATE LIMITED',
    'PPF FARMERS PRODUCER COMPANY LIMITED',
    'EKANOMATIC V STUDIO (OPC) PRIVATE LIMITED',
    'RSD POLYACRYLATES PRIVATE LIMITED',
    'LTDEDITION SOURCING PRIVATE LIMITED',
    'EVOTE TECHNOLOGIES PRIVATE LIMITED',
    'EFINIT PRIVATE LIMITED',
    'ROAD LESS TRAVELLED PRIVATE LIMITED',
    'ZAVMA PRECISION ENGINEERING PRIVATE LIMITED',
    'UET EDU SOLUTIONS PRIVATE LIMITED',
    'ANVAY INFOTECH PRIVATE LIMITED',
    'SRBC SERVICES PRIVATE LIMITED',
    'STARLIGHT CAPITAL PRIVATE LIMITED',
    'PROPASSETS MANAGEMENT PRIVATE LIMITED',
    'QUINATE HOSPITALITY PRIVATE LIMITED',
    'HUMAN FORESTS PRIVATE LIMITED',
    'AYUSH CRICKET ACADEMY PRIVATE LIMITED',
    'FINLEG TAX SERVICES PRIVATE LIMITED',
    'CADAN RETAIL & FASHION LIFESTYLE PRIVATE LIMITED',
    'AVM SOLAR PRIVATE LIMITED',
    'KIGEN (INDIA) PRIVATE LIMITED',
    'VALLABH PACKWELL FOUNDATION',
    'JAGANNATH HALOGEN PRIVATE LIMITED',
    'KANVAS CONCEPTS PRIVATE LIMITED',
    'AVINASH INDUSTRIES PRIVATE LIMITED',
    'FGEE CART TRADELINKS PRIVATE LIMITED',
    'VIVIC ENERGY PRIVATE LIMITED',
    'EMBASSY PRISM VENTURES PRIVATE LIMITED',
    'KV ARMOTEC ENTERPRISES PRIVATE LIMITED',
    'CYBERDISTI PRIVATE LIMITED',
    'PAAL FOOD PRODUCTS PRIVATE LIMITED',
    'UNITEDRCM SERVICES PRIVATE LIMITED',
    'EVEREADY HOLDINGS PRIVATE LIMITED',
    'UNOSAFE ELEVATOR PRIVATE LIMITED',
    'COTLAND FASHION PRIVATE LIMITED',
    'TRADIGVIDYA EDUCATION PRIVATE LIMITED',
    'LEARNX EDUCATION AND TECHNOLOGY PRIVATE LIMITED',
    'AUTOMATON CYBER TECHS PRIVATE LIMITED',
    'PRAAN TECHNOLOGIES PRIVATE LIMITED',
    'NRG MINCHEM PRIVATE LIMITED',
    'MEDICA INSTITUTE PRIVATE LIMITED',
    'ETHER HOSPITALITY PRIVATE LIMITED',
    'YOUNG NETWORKS INDIA PRIVATE LIMITED',
    'PRAYAAN LEISURE HOTELS PRIVATE LIMITED',
    'WE FOUNDER CIRCLE PRIVATE LIMITED',
    'GOLDEN ADMISSIONS PRIVATE LIMITED',
    'TRADENODE INTERNATIONAL PRIVATE LIMITED',
    'UKI BHARAT ENGINEERIANS PRIVATE LIMITED',
    '2M RESEARCH PRIVATE LIMITED',
    'ASCENTLE INDIA PRIVATE LIMITED',
    'NAKKASH INDIA DESIGNS (OPC) PRIVATE LIMITED',
    'GENERATION360 MEDIA SOLUTIONS PRIVATE LIMITED',
    'ATTICA GOLD HOMES PRIVATE LIMITED',
    'NIVEUM PRIVATE LIMITED',
    'CXO360 ADVISORS PRIVATE LIMITED',
    'WORKMOB PRIVATE LIMITED',
    'ANIMAGTICS TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'GLOIND CONTRACT LOGISTICS PRIVATE LIMITED',
    'B AND N CREATIVE SOLAR PRIVATE LIMITED',
    'NORTHLINE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'WISEWALK CONSULTANTS PRIVATE LIMITED',
    'WHITE HILL MUSIC PRIVATE LIMITED',
    'INDO MONEY JEWELLERS & BULLION PRIVATE LIMITED',
    'GIGU INNOVATIONS PRIVATE LIMITED',
    'PINTU PRO (OPC) PRIVATE LIMITED',
    'NIMPAA TELECOMMUNICATIONS PRIVATE LIMITED',
    'HBMK RETAIL PRIVATE LIMITED',
    'REDBRICK AI PRIVATE LIMITED',
    'REFYNE TECH PRIVATE LIMITED',
    'HINTEK LABS PRIVATE LIMITED',
    'YARDS MASTER INFRATECH PRIVATE LIMITED',
    'CATALEYA APPARELS PRIVATE LIMITED',
    'KATIE AND NAVEL FOUNDATION',
    'KNAM FOODS PRIVATE LIMITED',
    'ADVON INDUSTRIES PRIVATE LIMITED',
    'REDDOT ONE INFRA PRIVATE LIMITED',
    'FULNESS BAZAAR PRIVATE LIMITED',
    'TEENGO TECHNOLOGY PRIVATE LIMITED',
    'STRAT SURE ASSOCIATES PRIVATE LIMITED',
    'MINDFUL SOULS PRIVATE LIMITED',
    'EDTUBE TECHNOLOGIES PRIVATE LIMITED',
    'ASSESSORS AND REGISTERED VALUERS FOUNDATION',
    'ATHENA BEHAVIORAL HEALTH SERVICES PRIVATE LIMITED',
    'STRATEGIC ALLIANCE (SBA) PRIVATE LIMITED',
    'RLC EXPLORATION SERVICES PRIVATE LIMITED',
    'REBRIGHT PARTNERS INDIA PRIVATE LIMITED',
    'ADANI TRANSMISSION STEP-ONE LIMITED',
    'COLEDRA SOLUTIONS PRIVATE LIMITED',
    'XL KPO SERVICES PRIVATE LIMITED',
    'AGZ TECHNOLOGIES PRIVATE LIMITED',
    'PETERSON TECHNOLOGY PARTNERS (INDIA) PRIVATE LIMITED',
    'ARS SOLUTIONS PRIVATE LIMITED',
    'ACCORD BRANDCOM PRIVATE LIMITED',
    'COORG CIT-TBI FOUNDATION',
    'RDOT VENTURES PRIVATE LIMITED',
    'MAHESHWARI GLOBAL ORGANISATION',
    'JUBLIANT HOSPITALITY SERVICES PRIVATE LIMITED',
    'DHAN VALLABH WELFARE FOUNDATION',
    'MADHUBAN MULTIMETALS PRIVATE LIMITED',
    'NEEKS & HANKS SOLUTIONS PRIVATE LIMITED',
    'JARDIN HOSPITALITY PRIVATE LIMITED',
    'RICHMAX GOLD AND JEWELLERY PRIVATE LIMITED',
    'MSP KNIT GARMENTS PRIVATE LIMITED',
    'SILIZIUM CIRCUITS PRIVATE LIMITED',
    'DARA FERTILIZERS AND CHEMICALS PRIVATE LIMITED',
    'FRESHROUTES FARM PRODUCE PRIVATE LIMITED',
    'BOTANIAM XTRACTX LIMITED',
    'VNG ENTERPRISES PRIVATE LIMITED',
    'FAN-TIME ICE CREAM (OPC) PRIVATE LIMITED',
    'DREAMSELLER FASHION PRIVATE LIMITED',
    'CINNAMON MEDIA AND ARTWORKS PRIVATE LIMITED',
    'RADHIKA REMEDIES PRIVATE LIMITED',
    'SOLLUX PHARMA PRIVATE LIMITED',
    'SCHNEEBERG INDIA PRIVATE LIMITED',
    'CAREWAVE TECHNOLOGIES PRIVATE LIMITED',
    'ADVANTEC WHEELS PRIVATE LIMITED',
    'MEDOPLUS SERVICES PRIVATE LIMITED',
    'BRILLARCO PRIVATE LIMITED',
    'ARTJUNOON CARNATION PRIVATE LIMITED',
    'Sur innovations private limited',
    'Cbalance solutions private limited',
    'Kanalysis consultant private limited',
    'Cube45 ecommerce services private limited',
    'Banjara sarhand foods private limited',
    'Nison consultants private limited',
    'C marc (india) pvt ltd',
    'Vcan technologies private limited',
    'Smr corporate service private limited',
    'Global environmental geotechnologies private limited',
    'Elsamex india private limited',
    'Cms support services private limited',
    'Surefin financial consultants private limited',
    'Maverick quality advisory services private limited',
    'Aif capital (india) private limited',
    'Purplerain technologies private limited',
    'TECH FIREFLY PRIVATE LIMITED',
    'VEDANT TECHSERVE PRIVATE LIMITED',
    'Apparent infotech private limited',
    'Mindpool consultants private limited',
    'Ng professionals private limited',
    'Mconverge services private limited',
    'KNS MONEY PRIVATE LIMITED',
    'Sbis consultants private limited',
    'Axis management services private limited',
    'Intellipro solutions private limited',
    'Alltechz solutions private limited',
    'Navabrind it solutions private limited',
    'Reliason technologies private limited',
    'Jurix corporate consultancy private limited',
    'Chaque jour hr services private limited',
    'Global pt provider private limited',
    'Orcus capital advisors private limited',
    'New age techsci research private limited',
    'Quality austria central asia private limited',
    'Breeze innovations private limited',
    'Ibrandox online private limited',
    'Net 4 communications ltd',
    'G.s.computel private limited',
    'Encoding enhancers private limited',
    'SPECTRUM TALENT MANAGEMENT LIMITED',
    'INVITRON ADVANCED ANALYTICS PRIVATE LIMITED',
    'PERSONOME MEDICINE PRIVATE LIMITED',
    'Sahaj inclusive opportunities (india) private limited',
    'Ofi (india) private limited',
    'R & N TECHAUTO INDUSTRIES PRIVATE LIMITED',
    'Tricore solutions private limited',
    'Punch solutions private limited',
    'Amida cleantech private limited',
    'Red consulting private limited',
    'Buddha properties private limited',
    'Prithvi consultants private limited',
    'Perfect connections limited',
    'Fund flow consultancy private limited',
    'Loyalty and gifting ideas private limited',
    'OMEN SOFTECH PRIVATE LIMITED',
    'Two55am studio private limited',
    'Specialized process innovation private limited',
    'Eirc consulting private limited',
    'Keva ayurveda health care private limited',
    'Timetronic management consultants private limited',
    'DELTAETA COST REDUCTION CONSULTANTS PRIVATE LIMITED',
    'Australian council for educational research (india)',
    'Leadpro consultancy private limited',
    'Foresight it solutions and consulting india private limited',
    'Bond consultants private limited',
    'Sanghavi bothra engineering company private limited',
    'Mosaic capital services private limited',
    'Mogae consultants private limited',
    'Geekay facility management private limited',
    'Suryashakti management services private limited',
    'Sydenham institute of management alumni association',
    'Dickenson investor relations events private limited',
    'Sanraj engineers private limited',
    'WUTOPIA SERVICES PRIVATE LIMITED',
    'C & C ALPHA GROUP INDIA PRIVATE LIMITED',
    'Avval business ideas private limited',
    'Gati intellect systems limited',
    'Vr1 corpcare private limited',
    'Forceone skill development private limited',
    'Vishal precision steel tubes and strips private limited',
    'Sagar polytubes private limited',
    'Ignite steel private limited',
    'Goel sponge private limited tfr. from kolkatta to delhi',
    'Electrosteel thermal coal limited',
    'Good fortune plantations private limited',
    'Shree gita cot-oils private limited',
    'Barwale seeds private limited',
    'Sunwell farms private limited',
    'Daftari agro private limited',
    'Mangla gupta plantations private limited',
    'Yadav foods limited.',
    'PANCHURA ESTATES PRIVATE LIMITED',
    'Atyam agro products private limited',
    'Red dragon plantations private limited',
    'Hillgreen plantations private limited',
    'Mittal agriculture private limited',
    'B c m agro private limited',
    'Sakata seed india private limited',
    'Grasslands agro private limited',
    'Goa agro tech private limited',
    'Musikvahana agro private limited',
    'Redemaco engineering private limited',
    'Mwh india private limited',
    'Ensemble infrastructure india limited',
    'Navalkar associates private limited',
    'Inventys research company private limited',
    'Firenix technologies private limited',
    'Geo appraisal private limited',
    'Sanidhya design consultancy private limited',
    'Thorn lighting india private limited',
    'Gsa plant engineering services private limited',
    'E&S TECHNOLOGIES INDIA PRIVATE LIMITED',
    'K. g. ventures private limited',
    'SATYAM MULTITRADE PRIVATE LIMITED',
    'Tuv sud south asia private limited',
    'Pnu engineering private limited',
    'Discovery communications india (pvt company with unlimited liability)',
    'Adzen creations private limited',
    'Pracharnama media private limited',
    'Metallicz media private limited',
    'Admiracle advertising private limited',
    'Manipal advertising services private limited',
    'I-o sign international private limited',
    'Spectrum corporate services limited',
    'B y padhye publicity pvt ltd',
    'Guju ads private limited',
    'Out-sel promotions india private limited',
    'Tristar communications private limited',
    'Orienta cine advertising private limited',
    'Mahanagar media network private limited',
    'Pdm media (india) private limited',
    'Drizzlin media india private limited',
    'V green media private limited',
    'Landmark 360 media private limited',
    'Ad service limited',
    'Releasemyad media private limited',
    'Bhaskar minerals pvt ltd',
    'Trading engineers (international) limited',
    'Rishi electronics limited',
    'UNICON TECHNOLOGY INTERNATIONAL PRIVATE LIMITED',
    'Ultra international limited',
    'La archplan pvt ltd',
    'SWELL AGRO TECH PRIVATE LIMITED',
    'Unicast private limited',
    'Bakshi international private limited',
    'Tehkhand associates pvt ltd',
    'Trikausch india private limited',
    'GOPAL VILLAS PRIVATE LIMITED',
    'Beegee electronics private limited',
    'U p farm products private limited',
    'SKYROCK CONSTRUCTIONS PRIVATE LIMITED',
    'Weldone construction co private ltd.',
    'Bhiwadi casting private ltd',
    'Top travel and tours private limited',
    'Slv security services private ltd',
    'Faridabad presswell private limited',
    'Deena paints (india) private limited',
    'Shanti steels private limited',
    'Esvee tube tech private ltd',
    'SAMPARK FIN SERVICES PRIVATE LIMITED',
    'Genesis trading private limited',
    'Samraj textiles private limited',
    'Perfect communications private limited',
    'V and s industries private limited',
    'Sitashri trading and finance private limited.',
    'N h phytonics private limited',
    'Diwan mundhra brothers private limited',
    'Computronics international limited',
    'ONICRA CREDIT RATING AGENCY OF INDIA PRIVATE LIMITED',
    'GALF PIPELINE TESTING & INSPECTION PRIVATE LIMITED',
    'Best mining solutions private limited',
    'Peridot energy services limited',
    'MANU TILING COMPANY PRIVATE LIMITED',
    'Radiant aggregates private limited',
    'Nagaur agrotech limited',
    'Shree kandla salt industries private limited',
    'Tulsi global logistics private limited',
    'Bedekar masalewale private limited',
    'R. k. delicacies private limited',
    'INDUR AVENUES PRIVATE LIMITED',
    'Lotte india corporation limited',
    'Pioneer nf forgings india private limited',
    'Oriental bakery private limited',
    'Brihan karan sugar syndicate private limited',
    'R. k. bakewell mars private limited',
    'Eagle peak garam chai private limited',
    'Careway agro procurement private limited',
    'Ican space developers private limited',
    'ASSAM EDIBLE OILS PRIVATE LIMITED',
    'KRISHNAMURARI BUILDTECH LIMITED',
    'Everytime foods industries private limited',
    'Pcs foods india private limited',
    'Alchemist tea estates private limited',
    'Tera panth foods limited',
    'Akshar rice & pulse mills private limited',
    'General mills india private limited',
    'Gemini distilleries private limited',
    'Vintage wines private limited',
    'Asansol bottling & packaging co private limited',
    'Anshi complex pvt ltd',
    'Premier starch products private limited',
    'Delta pure water india limited',
    'Nil dhara limited',
    'G.b.r. minerals private limited',
    'Jiwa mines and minerals limited',
    'V k lalco private limited',
    'B d textile mills private limited',
    'Riviera polymers private limited',
    'Rukmani fibres pvt ltd',
    'Shri nityanand cotspin limited',
    'Vishal space private limited',
    'Kj quarries private limited',
    'Mukesh fashions private limited',
    'Jairenga mills private limited',
    'S.s.d. spinning mills limited',
    'Gd foods & beverages private limited',
    'Sing venture foods private limited',
    'RAGA TEX INDIA PRIVATE LIMITED',
    'Abt foods limited',
    'Southern food products private limited',
    'Shree niwas exports private limited',
    'Jayalakshmi weaving mill (india) private limited',
    'Uphar silk mills pvt ltd',
    'Nalgonda realtors private limited',
    'BAGRRYS INDIA PRIVATE LIMITED',
    'Porus agro food products private limited',
    'Ikta aromatics limited',
    'Banga natural resource private limited',
    'Hermes distillery private limited',
    'Rakesh eatables and general products private limited',
    'Seethalakshmi hall flour mills private limited',
    'Khaitan apparel private limited',
    'Pebble exports private limited',
    'Khosla investment private limited',
    'Mohan breweries and distilleries limited',
    'Paras silk mills pvt ltd',
    'JATIA FAMILY HOTELS & RESORTS PRIVATE LIMITED',
    'Western breweries limited',
    'Country commodities private limited',
    'Tara agritech limited',
    'ELITE SPECIALITIES PRIVATE LIMITED',
    'Tarini agro foodprocess private limited',
    'Gajjan majra agro limited',
    'Walko food company private limited',
    'Theni guru krishna textile mills private limited',
    'Anitha texcot (india) private limited',
    'SAMANA GLOBAL BUSINESS SOLUTIONS LIMITED',
    'Krushna cotex private limited',
    'Fancy embrotex private limited',
    'Shivasakthi textile processing mills private limited',
    'Vera nets private limited',
    'Punjab information and communication technology corporation limited',
    'Aeroflon engineers private limited',
    'Dandy rolls india private limited',
    'Devendra kirti silk mills private limited',
    'Kalpana embroidery private limited',
    'Shyamsree food processing private limited',
    'Sneha knitting private limited',
    'Coralbells cotspin private limited',
    'Divine titanium private limited',
    'Dhruv cotex private limited',
    'Rajapalayam textile limited',
    'Elphinstone spinningg and weaving mills company limited',
    'B l garments private limited',
    'S.oliver fashion india private limited',
    'Jandk pulp and papers private limited',
    'Bhavin containers private limited',
    'Mitul enterprises private limited',
    'RISHAB WORLD PRIVATE LIMITED',
    'Microsynth fabrics (india) ltd',
    'Sri jaya jothi textile mills p ltd',
    'V.r.knitfab private limited',
    'Derby clothing private limited',
    'Sikkim engineering private limited',
    'Flamingo filters private limited',
    'Regalia chess creations private limited',
    'Sangkaj industries private limited',
    'Worldwide cricket company private limited',
    'Super-wave technology private limited',
    'Precious life medical technologies private limited',
    'Monash biomed private limited',
    'Mitra creative diamonds private limited',
    'A himanshu gems & jewellery private limited',
    'Zenith finesse (india) private limited',
    'Cosmos furniture private limited',
    'Tierra enviro limited',
    'Elg india private limited',
    'Epicure jewels private limited',
    'Spirare energy private limited',
    'Muktar power (india) private limited',
    'Amtech power limited',
    'ADANI TOTAL GAS LIMITED',
    'Madhav power private limited',
    'SRI RAMACHANDRA SPORTS SCIENCES PRIVATE LIMITED',
    'Acetech energy project india private limited',
    'Chintamani jewellers private limited',
    'Pelikan solitaires private limited',
    'Sri maruthi power-gen (india) private limited',
    'Srinivasa gayithri resource recovery limited',
    'Sadgurusaai energies private limited',
    'Mcleod hydro power ventures private limited',
    'Sai nivas power (i) project private limited',
    'Vestas wind technology india private limited',
    'R.k.m powergen private limited',
    'Hindustan thermalprojects limited',
    'Jaigad powertransco limited',
    'Trishakti power holdings private limited',
    'Cosmic power solutions limited',
    'G.m. energy services private limited',
    'Phasis green energy private limited',
    'TUTICORIN ELECTRICITY SUPPLY PRIVATE LIMITED',
    'Jsw energy (raigarh) limited',
    'Synthesis green ventures private limited',
    'Precision transmatic devices private limited',
    'Ksk energy resources private limited',
    'Upper bichom small hydro projects private limited',
    'GEM PLAZA PRIVATE LIMITED',
    'SARVATRA MARKETING PRIVATE LIMITED',
    'Pop store interiors private limited',
    'Hero solar energy private limited',
    'Clean solar power (chitradurga) private limited',
    'WAA SOLAR LIMITED',
    'Newton solar private limited',
    'Madhav solar (karnataka) private limited',
    'Windsource power and infrastructure private limited',
    'Ecosource power and infrastructure private limited',
    'Greenstar energy and agrofarms private limited',
    'Renewsource energy and agrofarms private limited',
    'Zoom automobile ancillaries private limited',
    'Greenfuel supplies private limited',
    'Octaga green power and sugar company limited',
    'Ksk wind energy tuticorin rajapudukudi private limited',
    'Garapati autoventures private limited',
    'PEAREY LALL & SONS (E.P.) Private Limited',
    'Augusta motors private limited.',
    'Akanksha automobiles (rudrapur) private limited',
    'Indus automobiles private limited',
    'Unitron energy systems private limited',
    'Ksk electricity financing india private limited',
    'Krishnaa energy private limited',
    'EKS FLEXOPRINT INDIA PRIVATE LIMITED',
    'Spi wind power private limited',
    'Clh gaseous fuel applications private limited',
    'Punjab biomass power limited',
    'KRIKLAS HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'Suryataap energies and infrastructure private limited',
    'Swift thermal power private limited',
    'Tp farms private limited',
    'Dazling infrapower private limited',
    'Hero wind energy private limited',
    'HERO FUTURE ENERGIES PRIVATE LIMITED',
    'Clean wind power (pratapgarh) private limited',
    'Clean wind power (anantapur) private limited',
    'Clean wind power (ratlam) private limited',
    'Clean wind power (satara) private limited',
    'Clean solar power (dhar) private limited',
    'Jsw energy (bengal) limited',
    'Master speciality gases private limited',
    'Punjab renewable energy systems private limited',
    'Gasifpower tech private limited',
    'Ksk mahanadi power company limited',
    'SAIB BRAKES PRIVATE LIMITED',
    'Jsg innotech private limited',
    'Miku automotive private limited',
    'Sij chains limited',
    'Agustawestland india private limited',
    'Ksk water infrastructures private limited',
    'EASE & COMFORT CHAIRS PRIVATE LIMITED',
    'Modutech building systems private limited',
    'Kpc projects limited',
    'Ultra fab india private limited',
    'Jpv ships india private limited',
    'Sunrise freight movers private limited',
    'Boby chemmanur airlines private limited',
    'Ace express logistics private limited',
    'YSG CABS AND LOGISTICS PRIVATE LIMITED',
    'Enthuse-answers travel & tours private limited',
    'United continents travel service private limited',
    'Holidayz mart private limited',
    'Indoxpress logistics solutions private limited',
    'MKC INDUSTRIES PRIVATE LIMITED',
    'Arrow global logistics private limited',
    'Yogayatan ports private limited',
    'TULI DAIRY PRIVATE LIMITED',
    'Venus cargo and logistics private limited',
    'CARGO PLACEMENT SOLUTIONS PRIVATE LIMITED',
    'CARGOSOL LOGISTICS LIMITED',
    'Trinity express cargo private limited',
    'Tulsiimpex forwarders private limited',
    'Transglobal inland container services private limited',
    'Skyport transport private limited',
    'C u inspections india private limited',
    'Dawn india forwarders private limited',
    'Sonata travels india private limited',
    'Rkg logistics private limited',
    'SYNERGY BAXI LOGISTICS PRIVATE LIMITED',
    'Tatkal cargo limited',
    'Abhiyan cargo private limited',
    'Jay container services co private limited',
    'Sohom shipping services private limited',
    'A.v.m. cargo private limited.',
    'Signal logistics private limited',
    'Neotrans logistics private limited',
    'Abhinav xpress cargo private limited',
    'Zed supplychain limited',
    'Garudadhri cold storage private limited',
    'Free trade warehousing private limited',
    'KANDLA FREE TRADE WAREHOUSING PRIVATE LIMITED',
    'Haldia free trade warehousing private limited',
    'Konkan storage systems (kochi) private limited',
    'Alandi warehousing pvt ltd',
    'Bharat travel point private limited',
    'Tarini logistics private limited',
    'B k logistics private limited',
    'Jre tank terminals private limited',
    'Budget logistics private limited',
    'Ameya logistics private limited',
    'PRIMA URBANSCAPES PRIVATE LIMITED',
    'Halidon marketing limited',
    'NAVAYUGA JAGANNATH PORT LIMITED',
    'MERCATOR OIL & GAS LIMITED',
    'Sharp travels india ltd',
    'Xebec india tours and exports private limited',
    'Trinity tours and travels private limited',
    'Combined logistics solutions private limited.',
    'Shanti adventure tours private limited',
    'Vintage rides private limited',
    'Zap booking private limited',
    'Namaste airport services private limited',
    'Sd logitrade india private limited',
    'Namaste air services private limited',
    'Rudra treks n expeditions private limited',
    'Regia travels private limited',
    'Jappe goa tourism services private limited',
    'Favourite tours and forex private limited',
    'Antrek tours and travels private limited',
    'Hajeej (india) hospitality private limited',
    'Allied cargo services (india) private limited',
    'Intersight holidays private limited',
    'Intersight hospitalities limited',
    'Monsoon whispers travel and tours private limited',
    'Jatayu sculpture and museum private limited',
    'EURASIA HOLIDAYS PRIVATE LIMITED',
    'Pyramid tours and allied services p ltd',
    'Mehta brothers freight forwarders p ltd',
    'Shree yash destinations private limited',
    'Etrust travel and placements private limited',
    'Grand skies travel private limited',
    'Grin travels private limited',
    'U & I HOLIDAYS PRIVATE LIMITED',
    'Musafir.com india private limited',
    'TRIO TRAVELS & HOLIDAYS PRIVATE LIMITED',
    'Sambhav trade tours private limited',
    'RAJASTHAN TOURS P LTD',
    'Ganesham tours and travels india private limited',
    'Tapukara logistics agent private limited',
    'PARIPOORNA TECHADEMY PRIVATE LIMITED',
    'Planet adventure private limited',
    'Dmc leisure private limited',
    'Travair connections limited',
    'ANKUR TOUR & TRAVELS PRIVATE LIMITED',
    'Rr shipping private limited',
    'Chetak sons private limited',
    'Kat logistics private limited',
    'MY INDO CHANNEL PRIVATE LIMITED',
    'Infrastructure logistics private limited',
    'Cabo da rama logistics private limited',
    'Adani logistics limited',
    'Aman logistics private limited',
    'Shree ashapura stevedores & cargo carriers private limited',
    'Kamal translifters private limited',
    'Cnc india tools and services private limited',
    'T p mathew and company pvt ltd',
    'Catabatic technology private limited',
    'Pushpak management services private limited',
    'BLUGATE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'Dkg labs private limited',
    'Rose garden housing developers private limited',
    'Aritha consulting services private limited',
    'Sunflower techno solutions private limited',
    'Shree satguru infocom private limited',
    'Methodist church in india trust association',
    'Truesign computers private limited',
    'Salasar ecommerce total solutions private limited',
    'Auroin (india) limited',
    'IRESEARCH SERVICES PRIVATE LIMITED',
    'Lexvalueadd consulting private limited',
    'IDEA',
    'S PLASTICS PRIVATE LIMITED',
    'Mangal engineering ltd',
    'Aic casting pvt. ltd.',
    'Sapphire builders pvt. ltd.',
    'Neha fiscal services private limited',
    'Rydon industries private limited',
    'Shree bankey bihari ispat private limited',
    'Chaudhry rolling mills private limited',
    'Aditi holdings private limited',
    'Poshs metal industries private limited',
    'Braco electricals (india) private limited',
    'Jindal aluminium limited.',
    'Mahat steels private limited',
    'YASH METALLICS PRIVATE LIMITED',
    'Accent steels india private limited',
    'NECO HEAVY ENGINEERING AND CASTINGS PRIVATE LIMITED',
    'DUNUNG METALLIC',
    'S MANAGMENT SERVICES PRIVATE LIMITED',
    'Purvag commodities & derivatives private limited',
    'Art n glass india private limited',
    'Vaidat legale services private limited',
    'Sra enterprises private limited',
    'Veer manpower services private limited',
    'Shri krishan manpower services private limited',
    'A2z filtration specialities private limited',
    'Nextera technologies private limited',
    'Forest fern hospitality private limited',
    'Shamia automobiles private limited',
    'Mns designs private limited',
    'CABOT SYSTEMS & AUTOMATION PRIVATE LIMITED',
    'Choir de law private limited.',
    'T merchandising services private limited',
    'Bsp diagnostic systems private limited',
    'Three six advertising & marketing private limited',
    'Studio 34 designart private limited',
    'Dehn india private limited',
    'Origo commodities india private limited',
    'HOTLINK SERVICES PRIVATE LIMITED',
    'Npr solutions private limited',
    'SAV LOGISTICS LIMITED',
    'Db sharper edge consulting private limited',
    'Ppg international private limited',
    'I.o.t websolutions private limited',
    'Fincredible financial consultancy private limited',
    'Kausalya trip india private limited',
    'Shopzyada retail private limited',
    'Ambe maa equity advisor private limited',
    'Aryan intercontinental private limited',
    'Tm systems private limited',
    'Patco liners pvt ltd',
    'Kayavlon impex private limited',
    'Dynamic results india private limited',
    'Arrowhead solutions private limited',
    'Zenica lifestyle private limited',
    'Abs prima private limited',
    'Alfa trading company private limited',
    'Carpediem management consulting private limited',
    'Codepips data solutions private limited',
    'Icmg consulting india private limited',
    'Artec advertising private limited',
    'Mangalam web media private limited',
    'Radiant international private limited',
    'Perma roof engineers and contractors private limited',
    'Kravis marine private limited',
    'Chempro inspections private limited',
    'YELLOW PAPER CONSULTING PRIVATE LIMITED',
    'Powair automation equipments private limited',
    'Packnowcrat (india) private limited',
    'Radheya machining limited',
    'Accely consulting india private limited',
    'Mecgale pneumatics private limited',
    'Kaizen global services (india) private limited',
    'Blow plast retail limited',
    'Minolli infrastructure products private limited',
    'IMAGINA SOURCING PRIVATE LIMITED',
    'Collective image productions private limited',
    'Sureflo techcon private limited',
    'Interhydraulik india private limited',
    'Pink pharmacy services private limited',
    'WODEHOUSE ENTERPRISES PRIVATE LIMITED',
    'Hn business consultants private limited',
    'Pearl overseas private limited',
    'Bold entertainment private limited',
    'Matrix hr development & training centre private limited',
    'Silver jubilee solutions private limited',
    'SCION FORGE PRIVATE LIMITED',
    'Suryavanshi industries limited',
    'Krishna weavers limited',
    'Surya ray elixirs private limited',
    'Art cafe private limited',
    'Manikya winbold systems private limited',
    'Niner enterprises private limited',
    'Kmr business services private limited',
    'Medallion hotels private limited',
    'V link systems private limited',
    'Specsmakers opticians private limited',
    'Mediinfotec private limited',
    'Shesri management consultants private limited',
    'Hosur hydraulics private limited',
    'Know n grow corporate services private limited',
    'Primeplan green energy private limited',
    'Radhamani india ltd',
    'Multimedia sales promotion private limited',
    'Exsem india krishi bikash limited',
    'Yashwi commodities pvt ltd',
    'ZEHNCORE CONSULTANCY SERVICES PRIVATE LIMITED',
    'Mehandi diamonds private limited',
    'B. m. advertising private limited',
    'S.d. real estate nirman private limited',
    'Gajrup vanijya private limited',
    'Arcreation design private limited',
    'NECO DEFENCE SYSTEMS PRIVATE LIMITED',
    'NAGARJUNA AGRICULTURAL RESEARCH AND DEVELOPMENT INSTITUTE PRIVATE LIMITED',
    'Banyan tree schools private limited',
    'Ignite career confidence private limited',
    'Gar education private limited',
    'Blossom management and law college private limited',
    'Hippocampus learning centres private limited',
    'Edskill vocational training private limited',
    'Virad viswakarma institute of training and research limited',
    'Vedanta academy',
    'XCHEM POLYMERS INDIA PRIVATE LIMITED',
    'MNR LABS PRIVATE LIMITED',
    'Keron lifesciences private limited',
    'SHIDIMO INTERAUX PVT LTD',
    'Madhu silica private limited',
    'Oriental hydraulics private limited',
    'Beva silicones private limited',
    'Excel orgo-chem pvt.ltd.',
    'MCPI PRIVATE LIMITED',
    'Silkflex trexim private limited',
    'Redflame explosives private limited',
    'Boom & bang explosives private limited',
    'Sua fireworks private limited',
    'Tyresoles (india) private limited',
    'Gold seal avon polymers private limited',
    'Innocool rubber private limited',
    'I r tubes pvt ltd',
    'Laxmi hydraulics pvt ltd',
    'Pune hydraulics systems private limited',
    'Decorpac india private limited',
    'The malanadu latex india pvt ltd',
    'Msl stratiforme-compreforme industries private limited',
    'Processo plast enterprise private limited',
    'Konvertor packaging solutions private limited',
    'Standard conduits private limited',
    'Sanplast private limited',
    'Venkatesh tech (india) private limited',
    'Atmaram maneklal industries limited',
    'Tanvika polymers private limited',
    'Vora packaging private limited',
    'Plasto eltronics private limited',
    'A k engineering industries (india) private limited',
    'Shefield technoplast private limited',
    'Wave polymer technology private limited',
    'Mukat tanks and vessels private limited',
    'Feryez polymer pvt ltd',
    'Tushank enterprises private limited',
    'Raja plastics private limited',
    'Engineered polymers (india) pvt ltd',
    'Ruparel plastics pvt ltd',
    'Nippon polymers pvt ltd',
    'Pradip polyfils private limited',
    'Paras agro plast pvt ltd',
    'Estara ventures private limited',
    'Ambernath plasto packaging pvt ltd',
    'Harmony plastics private limited',
    'Raha poly products limited',
    'Deshna profiles private limited',
    'Sri balaji assemblies & plastics private limited',
    'Mohan mutha polytech private limited',
    'VIGYAN TRAINING AND DEVELOPMENT SERVICESLIMITED',
    'Inex industries limited',
    'Tuffglaze india private limited',
    'JMT GLASS & AGRO PRIVATE LIMITED',
    'Modison contacts private limited',
    'Stone shippers (mumbai) private limited',
    'SELZA CERAMIC PRIVATE LIMITED',
    'Vison refractories pvt ltd',
    'Sapana ceramics private limited',
    'Akshay refractory monoliths private limited',
    'Icon granito private limited',
    'Donato vitrified private limited',
    'Sentosa granito private limited',
    'Kripton ceramic private limited',
    'TCL CERAMICS LIMITED',
    'Laxmi asbestos products limited',
    'RAJAPUSHPA INFRA PRIVATE LIMITED',
    'Hi-life machine tools ltd',
    'A b n enterprise pvt ltd',
    'Maanheruka cement limited',
    'Shri nath cements private limited',
    'Flycon concrete product private limited',
    'Grid floors private limited',
    'Vee kay prestressed private limited',
    'Shivratna asphamat pvt.ltd.',
    'Madurai arkay rock produce private limited',
    'VAF DEF-AERO SYSTEMS PRIVATE LIMITED',
    'Unique forge (gujarat) pvt ltd',
    'Diamond power transmission private limited',
    'Steeloy rolling mills private limited',
    'STEEL AND SCRAP PRIVATE LIMITED',
    'Daksh minerals and marine private limited',
    'Sanjay alloys pvt ltd.',
    'Gnd ispat private limited',
    'Puja ferro alloys private limited',
    'Alok alloys private limited',
    'Chrysalis finance limited',
    'Minera steel & power private limited',
    'Ultraseal (india) private limited',
    'Mahavir steel industries ltd',
    'Premier steel complex private limited',
    'S p s metal cast & alloys limited',
    'Pasupaty springs private limited',
    'Awk steelwares private limited',
    'Yamodima storage systems limited.',
    'PROTERIAL (INDIA) PRIVATE LIMITED',
    'Sitaram polyplast private limited',
    'Premium ferro alloys ltd',
    'Jayaswal neco steel and mining limited',
    'Bma steel private limited',
    'Maa durga enterprises limited',
    'Welding alloys (india) private limited',
    'PRAMADHA SERVICES LIMITED',
    'Migatronic india private limited',
    'Shree bvm metals private limited',
    'Bric properties india private limited',
    'Ambica infraspace private limited',
    'Hazel exports private limited',
    'Esteem realtors private limited',
    'Shree homes (india) private limited',
    'Saga realty & infrastructure private limited',
    'Acme realties private limited',
    'Oasis life spaces private limited',
    'Superb infraprojects private limited',
    'Ecostruk infra private limited',
    'Vipra infraprojects private limited',
    'HONCHO PROPERTIES PRIVATE LIMITED',
    'Sai welfare housing private limited',
    'Swastik homes nirman private limited',
    'APARNA PROMOTERS & DEVELOPERS PVT LTD',
    'Rapid promoters pvt. ltd.',
    'K.k. infratech private limited',
    'Aaryavart infrastructure private limited',
    'Himachal pradesh road and other infrastructure development corpn ltd',
    'Goenka properties private limited.',
    'Universal civil infracon private limited',
    'Garware infrastructure private limited',
    'Solitaire livetech private limited',
    'Isc it services private limited',
    'Integratecloud saas private limited',
    'Esquire infolab systems private limited',
    'Omni infoword private limited',
    'Direct tv private limited',
    'Sanmour pharma private limited',
    'Greentech environ management private limited',
    'Ecosan services foundation',
    'Felis creations private limited',
    'Blue drop films private limited',
    'India news broadcasting private limited',
    'NORTH-WEST NEWS PRIVATE LIMITED',
    'Indance performing arts private limited',
    'Goodeed charitable foundation',
    'Indian cable net company limited',
    'Eoc networks private limited',
    'Radio active music consultancy private limited',
    'Sundram fasteners employees welfare company private limited',
    'Entertainment City Limited',
    'Dr manibhai desai management training centre',
    'Lifespring hospitals private limited',
    'Worldwide ship management private limited',
    'Eastcoast watersports private limited',
    'Nirmal fitness private limited',
    'K.p.h. dream cricket private. limited.',
    'Esskay properties and investments private limited',
    'Lifeclinic health management systems india private limited',
    'M v hospital for diabetes private limited',
    'Subbalakshmi lakshmipathy foundation.',
    'Dr. suresh mediscan systems private limited',
    'Dns events private limited',
    'Purple mango creative solutions private limited',
    'Show business private limited',
    'Talera entertainment private limited',
    'Vissa televison network limited',
    'Eventxpress management services private limited',
    'SENTHIL GREEN POWER PRIVATE LIMITED',
    'Indo-british cultural exchange',
    'Amr advisors private limited',
    'Vana lifestyle private limited',
    'MANTRAM QUALITY ASSURANCE PRIVATE LIMITED',
    'Asap structured solutions private limited',
    'Elcina electronics manufacturing cluster private limited',
    'K.g. charities',
    'Zvky design studio private limited',
    'S E-VEHICLES PRIVATE LIMITED',
    'GREEN FARMEASY PRIVATE LIMITED',
    'NOA JEWELS PRIVATE LIMITED',
    'HELION TECHNOCRATS PRIVATE LIMITED',
    'MISHRA',
    'MORENOTES (OPC) PRIVATE LIMITED',
    'SHALBY HOSPITALS MUMBAI PRIVATE LIMITED',
    'VIQUEIRA STAVBA PRIVATE LIMITED',
    'CARENOW SOLUTIONS PRIVATE LIMITED',
    'ZOOPUP TECHNOLOGIES PRIVATE LIMITED',
    'LENSKART FOUNDATION',
    'VAIKARTANA CHARITABLE FOUNDATION',
    'DUNDIGAL WASTE 2 ENERGY PRIVATE LIMITED',
    'FILMYBOX ENTERTAINMENT PRIVATE LIMITED',
    'SG FIBERNET PRIVATE LIMITED',
    'EDGEFORCE SOLUTIONS PRIVATE LIMITED',
    'BURUGULA SOLAR PARK PRIVATE LIMITED',
    'HSB GLOBETRADE PRIVATE LIMITED',
    'MR SURYA SOCIAL FOUNDATION',
    'SURAKSHA RUBBER PRODUCTS PRIVATE LIMITED',
    'ARSHIA WAREHOUSING PRIVATE LIMITED',
    'YAVAR TECH WORKS PRIVATE LIMITED',
    'TREVISAN INDIA PRIVATE LIMITED',
    'NPCI BHARAT BILLPAY LIMITED',
    'UNIVISORY GLOBAL EDUCATION PRIVATE LIMITED',
    'RYTE DIGITAL MEDIA (OPC) PRIVATE LIMITED',
    'JXB SOFTWARE INDIA PRIVATE LIMITED',
    'MENCH ADS MEDIA PRIVATE LIMITED',
    'WEBSTEAM TECHNOLOGIES PRIVATE LIMITED',
    'STREET INDIA EXIM PRIVATE LIMITED',
    'LINK 2 LINK MARKETING PRIVATE LIMITED',
    'IDIGIZEN PRIVATE LIMITED',
    'GREENKO AP02 IREP PRIVATE LIMITED',
    'IRCON GURGAON REWARI HIGHWAY LIMITED',
    'TWO AM TECHNOLOGIES PRIVATE LIMITED',
    'TAKAYAMA GLOBAL SYNERGIES PRIVATE LIMITED',
    'SPARKHOST INDIA PRIVATE LIMITED',
    'NAGAR MEDIATECH PRIVATE LIMITED',
    'WONDERWORKS PRIVATE LIMITED',
    'RAGHAV PRODUCTIVITY SOLUTIONS PRIVATE LIMITED',
    'SSOSEC SYSTEMS INDIA PRIVATE LIMITED',
    'WEATHER FIGHTER PRIVATE LIMITED',
    'ICEGLOBAL ECOMMERCE TECHNOLOGY PRIVATE LIMITED',
    'CLUBMALL INTERNET PRIVATE LIMITED',
    'PAVILION TREE SOLUTIONS PRIVATE LIMITED',
    'MAHIJ NATURAL PRIVATE LIMITED',
    'FREEDOM FROM CANCER FOUNDATION',
    'DIVYADI RETAIL PRIVATE LIMITED',
    'DOLLARBIRD TECHNOLOGIES PRIVATE LIMITED',
    'PROPTECH CLEARDEALS PRIVATE LIMITED',
    'SHARIEF AUTOMOTIVE PRIVATE LIMITED',
    'ADORNPLUS PRIVATE LIMITED',
    'FEDERATION OF INDIAN FANTASY SPORTS',
    'CLOUDLAND INTERACTIVE PRIVATE LIMITED',
    'FM GLOBAL BRAND MANAGEMENT PRIVATE LIMITED',
    'MAYDIV IT SOLUTIONS PRIVATE LIMITED',
    'HUNTMATIC GLOBAL PRIVATE LIMITED',
    'THINK THOUGHT PRIVATE LIMITED',
    'EDHAYATI FOUNDATION',
    'FABEX ENGINEERING PRIVATE LIMITED',
    'RAMA TECHNOLOGIES PRIVATE LIMITED',
    'IBEGIN SOLUTIONS PRIVATE LIMITED',
    'AVT ACADEMY FOR PROFESSIONAL EDUCATION PRIVATE LIMITED',
    'VITALCORE TECHNOLOGIES PRIVATE LIMITED',
    'ELEGANT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INMITO HEALTHTECH PRIVATE LIMITED',
    'SYNERG TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'KPS MANUFACTURING PRIVATE LIMITED',
    'LAZARUS BUSINESS PARK PRIVATE LIMITED',
    'STEED AGRO INDIA PRIVATE LIMITED',
    'OPTAIOT PRIVATE LIMITED',
    'XELENCE PRODUCTS PRIVATE LIMITED',
    'DIGITAL NEST EDUCON PRIVATE LIMITED',
    'SHREE BRITE INORGANICS PRIVATE LIMITED',
    'GRANDIS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DPPC FOOD AND FLORA PRIVATE LIMITED',
    'KAILASHDEV MARITIME INTERNATIONAL PRIVATE LIMITED',
    'ZITRUS HEALTHCARE (OPC) PRIVATE LIMITED',
    'TICINO BUSINESS SYNERGIES PRIVATE LIMITED',
    'PROLANCE SERVICES PRIVATE LIMITED',
    'SAHIB FERTILIZERS PRIVATE LIMITED',
    'TP SOUTHERN ODISHA DISTRIBUTION LIMITED',
    'RESPONSIBLE LOGISTICS PRIVATE LIMITED',
    'GRECIAN PRIVATE LIMITED',
    'TRUKSHA FOODS PRIVATE LIMITED',
    'INCASAFIT PRIVATE LIMITED',
    'CLOUDVAULT PRIVATE LIMITED',
    'CUREBAY TECHNOLOGIES PRIVATE LIMITED',
    'GNANA SHAKTHI HEALTHCARE SERVICES PRIVATE LIMITED',
    'TRIZEN SECURITIES PRIVATE LIMITED',
    'IMMENSITAS PRIVATE LIMITED',
    'ASHOK CORE INVESTMENTS PRIVATE LIMITED',
    'VRIKSHAM GREEN TREASURE FOUNDATION',
    'TRUPTIK HOSTINGWEB TECHNOLOGIES PRIVATE LIMITED',
    'SFED INDIA PRIVATE LIMITED',
    'ELE MOBILITY SOLUTIONS PRIVATE LIMITED',
    'ICLOUDWA CONSULTANCY PRIVATE LIMITED',
    'KOHLI PRINTING AND CONVERTING MACHINES PRIVATE LIMITED',
    'ELEVATED PRINCIPLES INDIA PRIVATE LIMITED',
    'CROWDAPPS TECHNOLOGIES PRIVATE LIMITED',
    'MOBI-LIFT MHE INDIA PRIVATE LIMITED',
    'ECOGUARD FILTERS PRIVATE LIMITED',
    'INFONAUTICS TECHNOLOGY (OPC) PRIVATE LIMITED',
    'INFINITY DISTILLERY AND BREWERY LIMITED',
    'PRISTINE E TELESERVICES PRIVATE LIMITED',
    'DRISHTIKIDS PRIVATE LIMITED',
    'DELOUNIX DIGITAL SOLUTIONS PRIVATE LIMITED',
    'ATINDRIYA ENERGY INDIA PRIVATE LIMITED',
    'DOIONS PRIVATE LIMITED',
    'V R DELLA FILM FACTORY PRIVATE LIMITED',
    'ROBUST TECH INNOVATIONS PRIVATE LIMITED',
    'EFEVRESI TECH SOLUTIONS PRIVATE LIMITED',
    'ALLTIMATE LIFE SOCIAL NETWORK (OPC) PRIVATE LIMITED',
    'DAPOLI GRAMODAY FARMERS PRODUCER COMPANYLIMITED',
    'URBANEE INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'GANGATIKA TECHNOLOGIES PRIVATE LIMITED',
    'AHIYAS ENGINEERS PRIVATE LIMITED',
    'SWITCH MOBILITY AUTOMOTIVE LIMITED',
    'POLYMORPHIC SOFTWARE PRIVATE LIMITED',
    'SMART SCHOON PRIVATE LIMITED',
    'RSVF INDUSTRIES PRIVATE LIMITED',
    'DELIGHT INDUSTRIES PRIVATE LIMITED',
    'PRAGYANAM BRAHMA FOUNDATION',
    'CLEAN MAX KHANAK PRIVATE LIMITED',
    'CFAST LOGISTICS PRIVATE LIMITED',
    'SIXTH ELEMENT FINSERV PRIVATE LIMITED',
    'BLACKX TECHNOLOGY PRIVATE LIMITED',
    'EXANET SOLUTION PRIVATE LIMITED',
    'DANUBIA WOOD TRADING (INDIA) PRIVATE LIMITED',
    'FRISSKET FOODS PRIVATE LIMITED',
    'DHANYAKATAKA AGRITECH PRIVATE LIMITED',
    'MIDDLEWARE SYSTEMS TECHNOLOGIES PRIVATE LIMITED',
    'TRUSTECH CONSULTANTS PRIVATE LIMITED',
    'ALIF MEDICAL DEVICES PRIVATE LIMITED',
    'WAY2SEND PRIVATE LIMITED',
    'VEDSHIP INNOVATIONS PRIVATE LIMITED',
    'SERVEXPLUS INDIA PRIVATE LIMITED',
    'BUILDANYTHING TECHNOLOGIES PRIVATE LIMITED',
    'ADVENT SEISMIC SPV PRIVATE LIMITED',
    'AEGIS RENEWABLE TECH SOLUTIONS PRIVATE LIMITED',
    'INVOXIEA GLOBAL SERVICES PRIVATE LIMITED',
    'SARV BIO PHARMACEUTICAL RESEARCH PRIVATELIMITED',
    'TYKE TECHNOLOGIES PRIVATE LIMITED',
    'SHAUNAK HOLDING PRIVATE LIMITED',
    'S V OIL AND GAS INSPECTIONS PRIVATE LIMITED',
    'TILACE TECHNOLOGY PRIVATE LIMITED',
    'ZOFTHIRE PRIVATE LIMITED',
    'KHEMKA EVENTS PRIVATE LIMITED',
    'LEGAL BUDDY INDIA PRIVATE LIMITED',
    'KOLTE-PATIL SERVICES PRIVATE LIMITED',
    'TOSH BRANDING PRIVATE LIMITED',
    'DURGAPUR LOGISTICS PRIVATE LIMITED',
    'GYAN INFRATECH PRIVATE LIMITED',
    'FINFLOW TECH PRIVATE LIMITED',
    'DECCAN AGRO TRADE PRIVATE LIMITED',
    'ADVENTURER',
    'S AGRO EXIM PRIVATE LIMITED',
    'SHARPCOM MEDIA (OPC) PRIVATE LIMITED',
    'ITSACHECKMATE.COM SERVICES INDIA PRIVATELIMITED',
    'LET ME SELL PRIVATE LIMITED',
    'DICE FM INDIA PRIVATE LIMITED',
    'LOCALVOCAL OUTREACH PRIVATE LIMITED',
    'WINDOW MASTER INDIA PRIVATE LIMITED',
    'TECHSOWN PRIVATE LIMITED',
    'OZYCARE SOLUTIONS INDIA PRIVATE LIMITED',
    'DC INDUSTRIES PRIVATE LIMITED',
    'RECONS NATURECARE PRODUCTS PRIVATE LIMITED',
    'PARIHAR BNTSISSKARU VENTI PRIVATE LIMITED',
    'REGAL KITCHEN SPECIALITY FOODS PRIVATE LIMITED',
    'NEWBRAVE VENTURE PRIVATE LIMITED',
    'STATPRO FINTECH PRIVATE LIMITED',
    'SMT. SAVITRI MANOCHA FOUNDATION',
    'FABROMAX ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED',
    'INTERSHIFT RELOCATIONS PRIVATE LIMITED',
    'SOURCING AND MANUFACTURING EXPORTS PRIVATE LIMITED',
    'TRANSOURCE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'IRRIGATE POROUS PRIVATE LIMITED',
    'MEENAZO PRIVATE LIMITED',
    'LECOLOSSUS MEP EXPERTS PRIVATE LIMITED',
    'PROFECTUS LEARNING AND TALENT SOLUTIONS PRIVATE LIMITED',
    'ALGORITHMIC BIOLOGICS PRIVATE LIMITED',
    'SANDMARTIN BUILDWELL PRIVATE LIMITED',
    'HOLOSTIK PACKAGING PRIVATE LIMITED',
    'ELECTROMECH ENTERPRISES SOLUTIONS PRIVATE LIMITED',
    'SINGHI ENERGY SERVICES PRIVATE LIMITED',
    'GENTRADE MILLS PRIVATE LIMITED',
    'ZIPSTRIDE INDIA PRIVATE LIMITED',
    'STG WEALTH SERVE PRIVATE LIMITED',
    'CROSSLINK CHEM PRIVATE LIMITED',
    'TRINOVA TECHNOLOGIES PRIVATE LIMITED',
    'CUMIN CLUB FOODS PRIVATE LIMITED',
    'MICROKRED TECHNOLOGIES PRIVATE LIMITED',
    'GEORGE INSTITUTE SERVICES INDIA PRIVATE LIMITED',
    'IDFL INDIA PRIVATE LIMITED',
    'FABNINJAS PRIVATE LIMITED',
    'JUNGLE FOWL PRIVATE LIMITED',
    'AMAN E-WASTE RECYCLERS PRIVATE LIMITED',
    'DEJI INTERLINING PRIVATE LIMITED',
    'KG MOBILITY PRIVATE LIMITED',
    'AAVARTANAA INTEGRATED PRIVATE LIMITED',
    'LOGUS PROJECTS PRIVATE LIMITED',
    'ORTHO LIFE SYSTEMS PRIVATE LIMITED',
    'ANAM FINE CHEMICALS PRIVATE LIMITED',
    'AMPHICORE PRIVATE LIMITED',
    'SURANA REALTORS PRIVATE LIMITED',
    'KPCV STRATA YIELD OPPORTUNITY PRIVATE LIMITED',
    'VALLABH NARI NIKETAN ORGANISATION',
    'WEWASHLIFE PRIVATE LIMITED',
    'SMARTECH INNOVATIONS PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP THREE LIMITED',
    'TRDP AGRO SCIENCE PRIVATE LIMITED',
    'WAVIN INDIA PIPES AND FITTINGS MANUFACTURING PRIVATE LIMITED',
    'VIRGIN HILLS RENEWABLE POWER PRIVATE LIMITED',
    'OAKNST INFOTECH PRIVATE LIMITED',
    'MY MED PRIVATE LIMITED',
    'PROFITSQUARES PRIVATE LIMITED',
    'TRIGUN RETAIL PRIVATE LIMITED',
    'SWAPNANEER BUILDING PRIVATE LIMITED',
    'VIJAYALAXMI FUELS PRIVATE LIMITED',
    'PAWSIBILITIES PRIVATE LIMITED',
    'HEADWAY STRATA PRIVATE LIMITED',
    'TECHNOKRATEN ENGINEERING PRIVATE LIMITED',
    'OPSNETIC PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP TWO LIMITED',
    'SRBATTLEDORE ACADEMY (OPC) PRIVATE LIMITED',
    'MITTALGOLD TMT PRIVATE LIMITED',
    'ARRAYPOINTER PRIVATE LIMITED',
    'PURLO PRIVATE LIMITED',
    'VALOR MECH PRIVATE LIMITED',
    'PREETI CAPITALS PRIVATE LIMITED',
    'WORLDVIEW EDU ONLINE PRIVATE LIMITED',
    'BLUE DWARF TECHNOLOGIES PRIVATE LIMITED',
    'NEW VISION GLOBAL INDUSTRIES PRIVATE LIMITED',
    'COAZADPOWERON PRIVATE LIMITED',
    'ABI AND ABI ENTERTAINMENT PRIVATE LIMITED',
    'GRENZEBACH INDIA PRIVATE LIMITED',
    'KAI ANNASAHEB KAKADE FARMER PRODUCER COMPANY LIMITED',
    'EMERX SERVICES PRIVATE LIMITED',
    'FT FILMS TODAY ENTERTAINMENT AND EVENTS PRIVATE LIMITED',
    'FUTKAR EXPRESS PRIVATE LIMITED',
    'OBEROI INNOTECH PRIVATE LIMITED',
    'MAHARANA PRATAP SOCIAL WELFARE FOUNDATION',
    'THIRUMAL SUPORT SERVICE PRIVATE LIMITED',
    '121 CONNECTS PRIVATE LIMITED',
    'RAIFF BY ARODRAPE PRIVATE LIMITED',
    'DOT PROFESSIONALS PRIVATE LIMITED',
    'STOREBUZZ RETAIL INDIA PRIVATE LIMITED',
    'ENABL ENGINEERING PRIVATE LIMITED',
    'GOTHIC MEDIA CAPITAL PRIVATE LIMITED',
    'CLOOBEES INDIA PRIVATE LIMITED',
    'SHREE MODESHWARI LOGISTICS PRIVATE LIMITED',
    'PROPERTYGURU TECHNOLOGIES PRIVATE LIMITED',
    'SAINTS & MASTERS PRIVATE LIMITED',
    'KISANBUDDY AGRITECH PRIVATE LIMITED',
    'MIRANA INNOVATIONS PRIVATE LIMITED',
    'FIDELITY IMMIGRATION PRIVATE LIMITED',
    'GM NEXUS INDIA PRIVATE LIMITED',
    'YOUWEPLAY PRIVATE LIMITED',
    'MEGMENTO PHARMACEUTICALS PRIVATE LIMITED',
    'WEAVE COMMUNICATIONS INDIA PRIVATE LIMITED',
    'ACHERNAR BUILDERS PRIVATE LIMITED',
    'SYNERGUS TECHNOLOGY PRIVATE LIMITED',
    'TRAVERSING VISADONE CONSULTANCY PRIVATE LIMITED',
    'SS NINTENDO FEDERATION',
    'RATECART LOKALBUY PRIVATE LIMITED',
    'J A AMIN FOUNDATION',
    'HI-TECHORGANIC STORE PRIVATE LIMITED',
    'HAPPIEST HEALTH SYSTEMS PRIVATE LIMITED',
    'OKEANOS UTILITIES PRIVATE LIMITED',
    'AROH ( A RAY OF HOPE) FOUNDATION',
    'SMARTDATAFACTORY PRIVATE LIMITED',
    'SPRINT TECH SOLUTIONS LIMITED',
    'GULSHAN CARE FOUNDATION',
    'RENEW NOW SOLUTIONS INDIA PRIVATE LIMITED',
    'VROZART HEALTH PRIVATE LIMITED',
    'NATURAMIST IMPEX PRIVATE LIMITED',
    'GLOBALSYNC PRIVATE LIMITED',
    'LAKSHYA BRANDS PRIVATE LIMITED',
    'ARCTURUS INFRASTRUCTURE PRIVATE LIMITED',
    'VALCAN IT SOLUTIONS PRIVATE LIMITED',
    'EAGLEOS PRIVATE LIMITED',
    'V K R E A T E SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'WEDOHXM CONSULTING PRIVATE LIMITED',
    'MOTO BUSINESS SERVICE INDIA PRIVATE LIMITED',
    'INDOTHAI CALICUT PRIVATE LIMITED',
    'FARM FRESH COMMODITIES PRIVATE LIMITED',
    'PARI 7 TARET PRIVATE LIMITED',
    'HEY COACH (OPC) PRIVATE LIMITED',
    'WINNING GROWTH LIFE E-COM PRIVATE LIMITED',
    'MATHUR HEALTH CARE AND CONSULTANTS PRIVATE LIMITED',
    'S99 COMPUTERS PRIVATE LIMITED',
    'HEALTHSHINE INDIA PRIVATE LIMITED',
    'REALSIM MEDICAL HEALTHCARE PRIVATE LIMITED',
    'FRESH PERSPECTIVES PRIVATE LIMITED',
    'NIBLIC GREENS HOSPITALITY PRIVATE LIMITED',
    'LENSCORP AI PRIVATE LIMITED',
    'TRADEITION SMART SOLUTIONS PRIVATE LIMITED',
    'WELIVDIT PRIVATE LIMITED',
    'BOSSCODER SOFTWARE SERVICES PRIVATE LIMITED',
    'BLOOM VALUE INDIA PRIVATE LIMITED',
    'UPR TECH INDIA PRIVATE LIMITED',
    'POOJA PHOOLA INDUSTRIES PRIVATE LIMITED',
    'TAXI STAND TECHNOLOGIES PRIVATE LIMITED',
    'MERIDIAN BIOTECH INDIA PRIVATE LIMITED',
    'AUSTENITE TUBE INDUSTRIES PRIVATE LIMITED',
    'ORDERSTREAM PRIVATE LIMITED',
    'I.M.S MEDICAL SERVICES PRIVATE LIMITED',
    'CIPHERICS PRIVATE LIMITED',
    'MINDTWIG CONSULTING PRIVATE LIMITED',
    'NANMADHI BUILDTECH PRIVATE LIMITED',
    'SAMSARA SMARTWORLD PRIVATE LIMITED',
    'NEXTGEN GREENS PRIVATE LIMITED',
    'INFINITE ELEMENTS PRIVATE LIMITED',
    'THINKSTARTUP LEARNING PRIVATE LIMITED',
    'HIREUP INNOVATIONS & TECHNOLOGIES PRIVATE LIMITED',
    'DEVDEVA POLYMERS PRIVATE LIMITED',
    'ZETACMA PRIVATE LIMITED',
    'ADZENIA INDIA PRIVATE LIMITED',
    'NAVGRAHAA GEMS PRIVATE LIMITED',
    'ZECTOS SOFTWARE PRIVATE LIMITED',
    'STEELIFE STAINLESS PRIVATE LIMITED',
    'GOPIKESH (OPC) PRIVATE LIMITED',
    'ASTERIA BELMONT PRIVATE LIMITED',
    'RAINVI TECHNOLOGIES PRIVATE LIMITED',
    'ODY HOSPITALITY & EVENTS PRIVATE LIMITED',
    'CROSSBORDER LOGISTECH PRIVATE LIMITED',
    'SHRI BALAJI INFRAPORT PRIVATE LIMITED',
    'ORN TIRATH PRIVATE LIMITED',
    'PAYJOY INDIA FINANCE PRIVATE LIMITED',
    'GRTR HOLDINGS PRIVATE LIMITED',
    'PSY EQUITY PRIVATE LIMITED',
    'HELLA CHEMICAL MARKET PRIVATE LIMITED',
    'UPHEALTH MEDICAL SERVICES PRIVATE LIMITED',
    'FORSCHER EDUCATION PRIVATE LIMITED',
    'COITSER TECHNOLOGIES PRIVATE LIMITED',
    'SWEVEN DIGITAL PRIVATE LIMITED',
    'LACUNA DEVELOPERS AND BUILDERS (OPC) PRIVATE LIMITED',
    'PLAYFUL GAMES NETWORK TECHNOLOGY PRIVATELIMITED',
    'R AND M ELECTRICAL INDIA PRIVATE LIMITED',
    'TRIVIANZ TECHNOLOGIES PRIVATE LIMITED',
    'CADVARSITY ONLINE PRIVATE LIMITED',
    'CREATIVEBUZZ MEDIA PRIVATE LIMITED',
    'THEISM EVENTS INDIA PRIVATE LIMITED',
    '7-INDIA CONVENIENCE RETAIL LIMITED',
    'CONSTUM INDIA PRIVATE LIMITED',
    'INDUS POWER INDUSTRIES PRIVATE LIMITED',
    'LUV RANJAN FILMS PRIVATE LIMITED',
    'INDYHAAT INTERNET PRIVATE LIMITED',
    'SPEED DEEM PRIVATE LIMITED',
    'SUREENA CHOWDHRI RETAIL PRIVATE LIMITED',
    'OSTIN INDUSTRIES PRIVATE LIMITED',
    'HOLIDAY JALSAA PRIVATE LIMITED',
    'ADVENTURE OVERSEAS PRIVATE LIMITED',
    'INDORE INTERNATIONAL MEGA FURNITURE CLUSTER ASSOCIATION',
    'KT AUTOMATION PRIVATE LIMITED',
    'FITNESS SHIFT INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'BIG SUR PRIVATE LIMITED',
    'TAPAZ HYDERABAD INFO PARKS PRIVATE LIMITED',
    'XSOFTEX TECHNOLOGIES PRIVATE LIMITED',
    'ADINMI TECHNOLOGIES PRIVATE LIMITED',
    'KPC TECHNO VISION PRIVATE LIMITED',
    'HOVE LUBRICANTS INDIA PRIVATE LIMITED',
    'HASHTRUST TECHNOLOGIES PRIVATE LIMITED',
    'IVISHA TECHNOLOGIES PRIVATE LIMITED',
    'CHAPERON PROJECTS PRIVATE LIMITED',
    'IIMPACTRCM HEALTHCARE SUCCESS SOLUTIONS PRIVATE LIMITED',
    'INDIGENESIS MEDIA PRIVATE LIMITED',
    'SOLARK INFRASOLUTIONS PRIVATE LIMITED',
    'BIG VIKING GAMES PRIVATE LIMITED',
    'URBAN DRYFRUITS PRIVATE LIMITED',
    'QUALISGOODS TRADEX (OPC) PRIVATE LIMITED',
    'LOADRUNNR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ERAFAV RETAIL INDIA PRIVATE LIMITED',
    'JOINT ANALYTICAL SYSTEM (INDIA) PRIVATE LIMITED',
    'TAMUKU PRIVATE LIMITED',
    'MASALA RAM ORGANICS PRIVATE LIMITED',
    'ANAY AUTOPARTS RETAIL PRIVATE LIMITED',
    'NETTRICKS TECHNO PRIVATE LIMITED',
    'ACME GREENTECH FOODS PRIVATE LIMITED',
    'ASHANANDA INDUSTRIES (OPC) PRIVATE LIMITED',
    'REDCAP DIGITAL SOLUTIONS PRIVATE LIMITED',
    'TI ART PRIVATE LIMITED',
    'SVA VENTURES PRIVATE LIMITED',
    'KOLKATA WASTE MANAGEMENT PRIVATE LIMITED',
    'LYALLPUR UNIFORMS & BOOKS PRIVATE LIMITED',
    'FRESH AND FINE FOODS PRIVATE LIMITED',
    'TRANSLOGIC GLOBAL SOLUTIONS PRIVATE LIMITED',
    'KAY BEE RESEARCH AND INNOVATION CENTRE PRIVATE LIMITED',
    'MICROSHARE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TEJ RENT A CAR PRIVATE LIMITED',
    '7HILLSTS PRIVATE LIMITED',
    'CG INNOVATIONS PRIVATE LIMITED',
    'TECHGIST SYSTEMS (OPC) PRIVATE LIMITED',
    'AMADYLLO PRIVATE LIMITED',
    'ITVISION360 INDIA PRIVATE LIMITED',
    'ISTACK CONSULTING PRIVATE LIMITED',
    'NAVJEEVAN GODAN FOUNDATION',
    'HOTSTART ENERGY PRIVATE LIMITED',
    'OCEL COLORZ PRIVATE LIMITED',
    'SHIVANYA MONEY NIDHI LIMITED',
    'SKY OCEAN COMMUNICATIONS PRIVATE LIMITED',
    'MAGICIANS CODE PRIVATE LIMITED',
    'GANPAT UDYOG PRIVATE LIMITED',
    'AXIADO INDIA PRIVATE LIMITED',
    'MARSHAL SAFETY SERVICE PRIVATE LIMITED',
    'WWLP LOGISTICS PRIVATE LIMITED',
    'AMOUR INSTAEAZY INDIA PRIVATE LIMITED',
    'RISK SHIELD PRIVATE LIMITED',
    'PRANAMI AYURVEDA PRIVATE LIMITED',
    'CONTIGO BRANDING SOLUTIONS PRIVATE LIMITED',
    'ADONAI IMMIGRATION SERVICES (OPC) PRIVATE LIMITED',
    'INFICIAL INFOTECH PRIVATE LIMITED',
    'DEALMONETA PRIVATE LIMITED',
    'AIM GLOBAL TECHTOOLS PRIVATE LIMITED',
    'NANGALBIBRA-BONGAIGAON TRANSMISSION LIMITED',
    'PSEUDOCODE INFOTECH PRIVATE LIMITED',
    'MENTORED MINDS PRIVATE LIMITED',
    'TOUCHOUTS (OPC) PRIVATE LIMITED',
    'AV7 BRANDING PRIVATE LIMITED',
    'PBLS INDIA PRIVATE LIMITED',
    'GIGAMAC PRIVATE LIMITED',
    'ASHDAN REALTY PRIVATE LIMITED',
    '7THTECH FINESSE PRIVATE LIMITED',
    'QBIKO IT SOLUTIONS PRIVATE LIMITED',
    'KANVAS DIGI LABS PRIVATE LIMITED',
    'WIZZTIME SOFTWARE PRIVATE LIMITED',
    'UNIQUE HOSTING PRIVATE LIMITED',
    'VEHTEC SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HEXAMARVEL TECHNOLOGIES PRIVATE LIMITED',
    'WALKERSCOTT IT CONSULTING SERVICES INDIAPRIVATE LIMITED',
    'MLINOTS TECHNOLOGIES PRIVATE LIMITED',
    'INDEXING OPERATIONS PRIVATE LIMITED',
    'AGJ DATA INFOTECH RESEARCH PRIVATE LIMITED',
    'MYNVAX PRIVATE LIMITED',
    'ARING PRODEV PRIVATE LIMITED',
    'SANDS CENTRE FOR INNOVATION AND TESTING PRIVATE LIMITED',
    'VREON TECH INDIA PRIVATE LIMITED',
    'FUNDAMENT SERVICES PRIVATE LIMITED',
    'BUYONCLOUD SOFTWARE SERVICES PRIVATE LIMITED',
    'KODY TECHNOLAB LIMITED',
    'VIGNESWARA TECH SOLUTIONS (OPC) PRIVATE LIMITED',
    'KREMLIN TECH VENTURES PRIVATE LIMITED',
    'HANSAA DIGIVENTURES PRIVATE LIMITED',
    'WEBSLAW INDIA PRIVATE LIMITED',
    'ALENTRIS RESEARCH PRIVATE LIMITED',
    'NOBLESERVE SYSTEMS PRIVATE LIMITED',
    'ELPHILL TECHNOLOGY PRIVATE LIMITED',
    'INDSPACE HOSPITALITY PRIVATE LIMITED',
    'PAPPAYA TECHNOLOGIES PRIVATE LIMITED',
    'GOMAYA ORGANICS PRIVATE LIMITED',
    'DATACUE TECHNOLOGIES PRIVATE LIMITED',
    'VISISHT ARYAVARTA PRIVATE LIMITED',
    'AIRPORT ADVERTISING (AGARTALA) PRIVATE LIMITED',
    'APPYHUB TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'WARDROGUE INDIA PRIVATE LIMITED',
    'DIO DIGITAL IMPLANT INDIA PRIVATE LIMITED',
    'QUALITY HEALTHCARE ACCESS PRIVATE LIMITED',
    'SAMANVAYA SOCIAL VENTURES PRIVATE LIMITED',
    'EK ANEK SOCIAL IMPACT SOLUTIONS PRIVATE LIMITED',
    'ACHIEVA SCHOOL OF PROFESSIONAL STUDIES PRIVATE LIMITED',
    'VERACITY MEDIA PRIVATE LIMITED',
    'UJALA HEALTHCARE SERVICES LIMITED',
    'CINEMA CAFE (TAMIL) TELEVISION PRIVATE LIMITED',
    'MNR HEALTH CARE PRIVATE LIMITED',
    'MINHAJ INTERFAITH & WELFARE FOUNDATION',
    'KHELOMORE FOUNDATION',
    'PSYCHOSONIC RESEARCH LAB PRIVATE LIMITED',
    'GSEAMS PRIVATE LIMITED',
    'ALFA WORLD MOVIES PRIVATE LIMITED',
    'BALIN GYMS PRIVATE LIMITED',
    'GROVE END VENTURES PRIVATE LIMITED',
    'LM MANUFACTURING INDIA PRIVATE LIMITED',
    'MAVERICK LITERACY PRIVATE LIMITED',
    'COUNTER STROKES PRIVATE LIMITED',
    'INSPIRON PSYCHOLOGICAL WELL-BEING CENTREPRIVATE LIMITED',
    'ARRHAM INTELLIGENCE INSTITUTE PRIVATE LIMITED',
    'PSN SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'FIMO TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'MY BROTHER WELFARE FOUNDATION',
    'DIVINE HOLISTIC CENTER PRIVATE LIMITED',
    'LAUGHTERYOGA WORLDWIDE FOUNDATION',
    'SSM MULTISPECIALITY HOSPITAL PRIVATE LIMITED',
    'TIORDA ADVISORS PRIVATE LIMITED',
    'BHARTI RM TRUSTEES S1 PRIVATE LIMITED',
    'EDUSTER LEARNING SOLUTIONS PRIVATE LIMITED',
    'BHARTI SBM TRUSTEES S2 PRIVATE LIMITED',
    'BHARTI SBM TRUSTEES D1 PRIVATE LIMITED',
    'BHARTI RBM TRUSTEES II PRIVATE LIMITED',
    'SSC TRADECOM PRIVATE LIMITED',
    'BHARTI RM TRUSTEES II PRIVATE LIMITED',
    'BHARTI SBM TRUSTEES S1 PRIVATE LIMITED',
    'DOCTORVAHINI PRIVATE LIMITED',
    'CELARA DIAGNOSTICS PRIVATE LIMITED',
    'VOLTIMO BIZSOL PRIVATE LIMITED',
    'TMC INTELLECTUAL SERVICES PRIVATE LIMITED',
    'AMPERE AND THERE PRIVATE LIMITED',
    'VISHWAPRIYA NETWORKS PRIVATE LIMITED',
    'RADHESHYAM ENVIRO SERVICES PRIVATE LIMITED',
    'JAINAM JIVIKA FOUNDATION',
    'INSOLUTIONS BUSINESS ADVISORY PRIVATE LIMITED',
    'RAKSHA UNIVERSAL PRIVATE LIMITED',
    'JEETJATAN MATRIMONIAL SERVICES PRIVATE LIMITED',
    'DR.NAVAS-KMCT MEDICARE PRIVATE LIMITED',
    'KUBAULI AGRO PRIVATE LIMITED',
    'JAJMAU TANNERY EFFLUENT TREATMENT ASSOCIATION',
    'LECTRO E-MOBILITY PRIVATE LIMITED',
    'MUTHOOT PAPPACHAN CENTRE OF EXCELLENCE IN SPORTS',
    'CASTCODEDIGITAL BIOSCOPE PRIVATE LIMITED',
    'SARAL DIAGNOSTICS CLASSIC PRIVATE LIMITED',
    'JALADHARA HYDRO SOLUTIONS PRIVATE LIMITED',
    'PAMG HEALTHBUDDY SERVICES PRIVATE LIMITED',
    'AIC BANASTHALI VIDYAPITH FOUNDATION',
    'PITCHRIGHT VENTURES PRIVATE LIMITED',
    'REVON IT ONLINE SERVICES PRIVATE LIMITED',
    'ADVAITAM CONSULTANCY PRIVATE LIMITED',
    'CURTAINSPA SOLUTIONS PRIVATE LIMITED',
    'AMUA PRIVATE LIMITED',
    'ASKUS MEDICAL RESOURCES PRIVATE LIMITED',
    'ULTRA CINEMA & NUTECH LIMITED',
    'WHITE RIVER HEALTH AND EDUCATION PRIVATELIMITED',
    'ZOI HEALTH PRIVATE LIMITED',
    'HUMANS FIRST FOUNDATION',
    'TEAMNEST EMPLOYEE SERVICES PRIVATE LIMITED',
    'ACTON HEALTHCARE ENGINEERING INNOVATIONSPRIVATE LIMITED',
    'AMEEQUE DIGITALS PRIVATE LIMITED',
    'WATERFOREFRONT ENGINEERING INFRASTRUCTURE PRIVATE LIMITED',
    'M&H PROGRESSIVE SKILLS PRIVATE LIMITED',
    'SONOCO GRAPHICS INDIA PRIVATE LIMITED',
    'FERTKEL HEALTHCARE ENGINEERS PRIVATE LIMITED',
    'MIT CREATIVE SERVICES PRIVATE LIMITED',
    'TAKSHASHILA SKILLS PRIVATE LIMITED',
    'RAFT CONSULTING SERVICES PRIVATE LIMITED',
    'MENROL SERVICES PRIVATE LIMITED',
    'IDEAL EXOTICA FLAT OWNERS ASSOCIATION',
    'SEALINK ADVENTURES INDIA PRIVATE LIMITED',
    'ODITRONICS TECHNOLOGY PRIVATE LIMITED',
    'SABTECH ENGINEERING SERVICES PRIVATE LIMITED',
    'HIWARALE CONSULTANTS PRIVATE LIMITED',
    'TIMELESS TRIPS PRIVATE LIMITED',
    'TECHNOKRAFT RETAIL SOLUTIONS INDIA PRIVATE LIMITED',
    'SIMPLE & REAL ANALYTICS PRIVATE LIMITED',
    'NATURA GREENTECH PRIVATE LIMITED',
    'DIGITAL ENTREPRENEURSHIP AND COWORKING CENTER PRIVATE LIMITED',
    'PRIMUS SENIOR SERVICES PRIVATE LIMITED',
    'RESA HEALTHCARE PRIVATE LIMITED',
    'JW',
    'S TELECOM (OPC) PRIVATE LIMITED',
    'MYVACALA PRIVATE LIMITED',
    'SHRASTA DECOR PRIVATE LIMITED',
    'RELIABLE WASH LAUNDRY SERVICES PRIVATE LIMITED',
    'ISOTRACK INNOVATIVE INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED',
    'LAYOVER CAFE (INDIA) PRIVATE LIMITED',
    'MEFFIER GLOBALE EXPORTES PRIVATE LIMITED',
    'SRV IT HUB PRIVATE LIMITED',
    'BIZASIA CORPORATE ADVISORY SERVICES PRIVATE LIMITED',
    'SHKUBO CMO SERVICES PRIVATE LIMITED',
    'MARSPLAY INTERNET PRIVATE LIMITED',
    'RIXIT REALCON PRIVATE LIMITED',
    'THEVARA BUILDERS AND INFRA PRIVATE LIMITED',
    'KONNI BUILDING DEVELOPERS PRIVATE LIMITED',
    'MOHAR TECHNOLOGIES PRIVATE LIMITED',
    'DYNAMIC MERCANTILE PRIVATE LIMITED',
    'AEROSPACE QUALITY SUPPLIER PRIVATE LIMITED',
    'FOXIOM LEADS PRIVATE LIMITED',
    'LEELAWATI CONTRACTS PRIVATE LIMITED',
    'PORWAL JAIN FOUNDATION',
    'ADHARSTAMBH FOUNDATION',
    'CSE SOLAR PARKS SATNA PRIVATE LIMITED',
    'V-GUARD FOUNDATION',
    'MRKS INDUSTRIES PRIVATE LIMITED',
    'JPS LEGAL SOLUTIONS PRIVATE LIMITED',
    'DECK INFORMATION & TECHNOLOGY PRIVATE LIMITED',
    'DRYTEC INDUSTRIES PRIVATE LIMITED',
    'BILLIONBRICKS FOUNDATION',
    'BHEWARG FOUNDATION',
    'DFC SECURITY PRIVATE LIMITED',
    'VIDHEE FOOD AND BEVERAGES PRIVATE LIMITED',
    'NEXSEL TECH PRIVATE LIMITED',
    'TRANSMARINE CARGO SERVICES PRIVATE LIMITED',
    'GENCOM AUDIO VISUAL PRIVATE LIMITED',
    'POSIVIEW DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'THEKKEMALA INFRA DEVELOPERS PRIVATE LIMITED',
    'NEXTGEN NANO STONE TRADING PRIVATE LIMITED',
    'KEABIS TECH PRIVATE LIMITED',
    'MONARCH AUTOMOTIVE PRIVATE LIMITED',
    'ALFRED N. SCHINDLER FOUNDATION FOR CHILDREN',
    'WISE ADVISE PRIVATE LIMITED',
    'Canterburg tech-bpo (india) private limited',
    'Mvdco advisory services private limited',
    'Nomura financial advisory and securities (india) private limited',
    'Sprout growth advisors private limited',
    'GENERAL CARBON ADVISORY SERVICES PRIVATE LIMITED',
    'Turning point brand consulting private limited',
    'Petunia advisory private limited',
    'Architectural energy solutions private limited',
    'Benchmark management services (india) private limited',
    'LAKSHMI SHREE INVESTMENT AND SECURITIES LTD',
    'Joshi deodhar engineering company ltd',
    'Kings infra ventures limited',
    'Omnitex industries (india) limited',
    'INDARMA PRIME INDUSTRIES PRIVATE LIMITED',
    'Amines and plasticizers limited',
    'Tijaria polypipes limited',
    'Euro ceramics limited',
    'Farmax india limited',
    'Vhcl industries limited',
    'Iykot hitech toolroom limited',
    'Bgr energy systems limited',
    'Radhe developers (india) limited',
    'FLOMIC GLOBAL LOGISTICS LIMITED',
    'GALAXY CLOUD KITCHENS LIMITED',
    'Zircon traders limited',
    'Muller and phipps (india) limited',
    'GENERIC ENGINEERING CONSTRUCTION AND PROJECTS LIMITED',
    'Fcs software solutions limited',
    'Greaves cotton limited',
    'Fulford (india) limited',
    'Creative eye limited',
    'Aurionpro solutions limited',
    'T BHIMJYANI WAREHOUSING COLD CHAIN PRIVATE LIMITED',
    'Bharat foamcast private limited',
    'Ramesh exports private limited',
    'Aasthan dates limited',
    'Baheti agrocrafts private limited',
    'Dlg farms private limited',
    'Indus valley agro industry limited',
    'Goldstar agrinnova private limited',
    'Shri sai cottex private limited',
    'Green act farms & plantations private limited',
    'Parvin cotex private limited',
    'Earthen delight agro products private limited',
    'Vrijesh orchid private limited',
    'Pranar oils and chemicals india private limited',
    'Deffree engineering private limited',
    'Magal engineering co india private limited',
    'Sterling urban developments private limited',
    'NEW HORIZONS ASPHALT PRIVATE LIMITED',
    'Vidarbha mining private limited',
    'Ajax stonekraft private limited',
    'Star claytech private limited',
    'Aadhyashakti minings private limited',
    'Narayan global enertech private limited',
    'Srija mines & minerals private limited',
    'G k stones india private limited',
    'Snowman logistics limited',
    'Trinity pharmaceuticals & food private limited',
    'Tart patisserie private limited',
    'Upec (india) foods private limited',
    'NATURAL STORAGE SOLUTIONS PRIVATE LIMITED',
    'Sahlokc uniwaves private limited',
    'Pagariya food products private limited',
    'Puratos food ingredients india private limited',
    'Cakekraft india private limited',
    'Triguni food private limited',
    'Mylar sugars limited',
    'J j confectionery pvt ltd',
    'Bakeys foods private limited',
    'Engineered coated fabric private limited',
    'SRAVYA TEXTILES PRIVATE LIMITED',
    'Madura creation private limited',
    'Prospun textile india private limited',
    'Gabani industries limited',
    'Rameswar apex private limited',
    'Concord weaving preparatory pvt ltd',
    'Shree hari yarns private limited',
    'Swaas enterprises private limited',
    'S.a.n. garment manufacturing private limited.',
    'Shivam devansh fab private limited',
    'Cotton cottage india private limited',
    'Swe fashions private limited',
    'SHREE SIDDHIVINAYAK SPINNING & WEAVING MILLS PRIVATE LIMITED',
    'Devarshee geosynthetics and infrastructure private limited',
    'Strata geosystems (india) private limited',
    'Kibs hosiery mills private limited',
    'Podar apparels private limited',
    'Shree prakash impex private limited',
    'Dki apparel private limited',
    'Levi strauss (india) private limited',
    'Kurinji design private limited',
    'Reddy and pathare elastics pvt ltd',
    'Ambertex clothing private limited',
    'Noah fashions private limited',
    'Blue mercury apparels private limited',
    'Texon (india) private limited',
    'West india impex private limited',
    'ROOT',
    'S SHIPPING (JAMNAGAR) PRIVATE LIMITED',
    'TITAN ASIA PRIVATE LIMITED',
    'Alok transport private limited',
    'Ksk dibbin hydro power private limited',
    'Ksk upper subansiri hydro energy limited',
    'Boston infrastructure & development private limited',
    'Unique era promotors private limited',
    'Virender builders private limited',
    'Motiprabha infratech private limited',
    'Subhash infraengineers private limited',
    'Desi construction private limited',
    'Ksk wind energy halagali benchi private limited',
    'SUNBOURNE DEVELOPERS PRIVATE LIMITED',
    'ADANI ESTATE MANAGEMENT PRIVATE LIMITED',
    'Shayona infrastructure private limited',
    'CHIRIPAL INDUSTRIAL PARK PRIVATE LIMITED',
    'Prarthana infratech private limited',
    'Ksk wind energy tirupur elayamuthur private limited',
    'Suryajyothi energy private limited',
    'Rs windtech engineers private limited',
    'Krishi hydro power private limited',
    'Nurpur gases private limited',
    'Firoze estates private limited',
    'Vaikunth builders pvt ltd',
    'Goan real estate and construction private limited',
    'Hillside constructions company private limited',
    'GH2 SOLAR PRIVATE LIMITED',
    'Avya green technologies private limited',
    'Atithi builders and constructors private limited',
    'Sukumar housing and finance private limited',
    'Baswant builders and developers p.ltd.',
    'Cordcon builders private limited',
    'Geo profiles and engineering services p ltd',
    'LADAM HOMES PRIVATE LIMITED',
    'Kairavi agencies private limited',
    'Mumbai construction and developers private limited',
    'Detect electronics systems (india) private limited',
    'Midas energy systems private limited',
    'Ptl solar energy private limited',
    'Ksk wind energy nandgaon athni private limited',
    'D1 williamson magor bio fuel limited',
    'Vital developers private limited',
    'Neelkamal shantinagar properties private limited c/n',
    'Jsw infrastructure limited',
    'Kurnool vayu vidyut projects private limited',
    'Kameng dam hydro power limited',
    'Oasis procon private limited',
    'Neetnav real estate private limited',
    'Supertech construction company private limited',
    'Swaraj onkar struccon private limited',
    'VSB INFRACORP PRIVATE LIMITED',
    'Shiv siddhant realty private limited',
    'Hundred million constructions private limited',
    'Goodearth engineers and developers (india) private limited',
    'Kadavil builders and developers private limited',
    'Indo global infra projects private limited',
    'Metronic engineering private limited',
    'Sew lsy highways limited',
    'Atlantic shelters private limited',
    'Broadway shelters private limited',
    'Blue marine shelters private limited',
    'Curlews shelters private limited',
    'Dublin shelters private limited',
    'Halidon logistics limited',
    'Integrity sea trans private limited',
    'Sri vatsa hotels limited',
    'Santosh pre-cool and cold storage private limited',
    'Oneworld shipping services private limited',
    'Rayna group private limited',
    'Container freight station association of india (renewal old an 165281)',
    'Omci shipmanagement private limited',
    'Coastline maritime private limited',
    'Jsw shipyard private limited',
    'Gl shipping services india private limited',
    'Royal expeditions private limited',
    'Mystical journeys (india) private limited',
    'Inair holidays private limited',
    'Sprite tours and travels private limited',
    'Aanyang travels india private limited',
    'Orchid voyages private limited',
    'Travel agents association of india',
    'Make plans travel services private limited',
    'Akma tours & travels private limited',
    'Holly offshore logistics limited',
    'Prish tours private limited',
    'Wiyam logisitics private limited',
    'Agencia ultramarina private limited',
    'South western barges private limited',
    'Agrawal roadlines pvt ltd',
    'Ameya container freight station private limited',
    'Overseas maritime agencies private limited',
    'Kamal freight private limited',
    'I m s ship management private limited',
    'Freight wings private limited',
    'S n das freight forwarders private limited',
    'Concord maritime and logistics private limited',
    'Embassy transportation india private limited',
    'Yak shipping services private limited',
    'Rhenus logistics india private limited',
    'Thakkar shipping agency private limited',
    'Sai aerocean logistics private limited',
    'Modern frieght company pvt ltd',
    'Pinwheel travel & experience private limited',
    'Shubh maruti logistics private limited',
    'Skg tours private limited',
    'Salem tours and travels private limited',
    'Josco travel & tours private limited',
    'Transair international private limited',
    'Quick cargo services india private limited',
    'Mercury forwarders private limited',
    'GOK TECHNOLOGIES PRIVATE LIMITED',
    'Espee atlantic travels private limited',
    'Safers mobility private limited',
    'Barrabazar transport company private limited',
    'Srilas telecom private limited',
    'United infracore limited',
    'Rdbex courier & cargo private limited',
    'Airstate logistics and couriers private limited',
    'YOGAYOG TRANSPORT PRIVATE LIMITED',
    'LEMON ELECTRONICS LIMITED',
    'Metropolis logistics private limited',
    'Popkorn pr plus communication private limited',
    'CONNEQT BUSINESS SOLUTIONS LIMITED',
    'Softel telecom private limited',
    'Scube telecom private limited',
    'ACCUSPEED ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'Mars agency private limited',
    'Apna tele link private limited',
    'Fingertip technologies private limited',
    'Titiksha tele technocrats private limited',
    'Spacelink network private limited',
    'MOJO NETWORKS PRIVATE LIMITED',
    'Gtpl nagpur telelink private limited',
    'Gtpl spn digital network private limited',
    'Gtpl sharda cable network private limited',
    'Bombay barons private limited',
    'Esesvi telecom private limited',
    'Arpwood capital private limited',
    'Pug capital private limited',
    'Subhiksha investments madras private limited',
    'Pl capital markets private limited',
    'IIFL SAMASTA FINANCE LIMITED',
    'Ashok finance (karur) limited',
    'Leo knowledge management private limited',
    'VERSA TRADING PRIVATE LIMITED',
    'Mosolf india logistics private limited',
    'Prominent holidays private limited',
    'Oceancolor holidays private limited',
    'Basis -ml farm tours and ayurveda private limited',
    'Appu s travel and tourism private limited',
    'Xplor worldwide private limited',
    'SHREE SATI ONLINE PRIVATE LIMITED',
    'NILKAMAL INFRABUILD PRIVATE LIMITED',
    'Axis traveltech private limited',
    'Dadabhai travel & tours private limited',
    'K r gandhi logistics private limited',
    'Ifos aviation services private limited',
    'Vimal shipping agency private limited',
    'Ramzan karim shipping services pvt ltd',
    'BRIHANMUMBAI CUSTOM BROKERS ASSOCIATION',
    'D r d trucks (india) private limited',
    'X travels private limited',
    'Supreme star shipping company private limited',
    'TAYLOR LOGISTICS PRIVATE LIMITED',
    'O & H SHIPPING SERVICES (INDIA) PRIVATE LIMITED',
    'Barefoot airtours private limited',
    'Ben line agencies(india)private limited',
    'VARA INFROVATE PRIVATE LIMITED',
    'Vibrant cellnet private limited',
    'Nanoland limited',
    'Sacaya technologies private limited',
    'Fortuna softel private limited',
    'Rks infotech private limited',
    'Seabit infosolutions private limited',
    'Simos peripherals private limited',
    'Belcosys technologies private limited',
    'Isg compusolutions india private limited',
    'Amartech convergence india private limited',
    'Acme infocom private limited',
    'COPPICE BEVERAGES PRIVATE LIMITED',
    'Totale communicare private limited',
    'Comtech systems private limited',
    'Mano infosystems private limited',
    'Techahead software private limited',
    'Search value ites private limited',
    'Applied info services (india) private limited',
    'Kanakdrishti infotech private limited',
    'Enziq solutions private limited',
    'Avid technocrats private limited',
    'CREDO INFOTECH PRIVATE LIMITED',
    'Netking web services private limited',
    'Sky-e it solutions private limited',
    '4sight solutions private limited',
    'Software joint private limited',
    'Soteria command center private limited',
    'EPIRCO INFRATECH PRIVATE LIMITED',
    'Collaborate solutions private limited',
    'Barefoot resorts and leisure private limited',
    'Redsun communication private limited',
    'Das infomedia private limited',
    'Zibanka media services private limited',
    'Bitscape infotech private limited',
    'Excelacom technologies private limited',
    'Pioneer e solutions private limited',
    'Latticebridge infotech private limited',
    'Subrahmanyam ananthalakshmi info technology private limited',
    'Uxl information technologies private limited',
    'Kou-chan technologies private limited',
    'Rms technologies private limited',
    'Convergent wireless communications private limited',
    'INTERTRUSTVITEOS CORPORATE AND FUND SERVICES PRIVATE LIMITED',
    'Dreamart interactive private limited',
    'AVERIWARE SOLUTIONS PRIVATE LIMITED',
    'Datamatrix technologies private limited',
    'Eveltio education consulting private limited',
    'Bridgei2i analytics solutions private limited',
    'Centum consultancy services private limited',
    'Joglekar computer solution private limited',
    'Centurysoft private limited',
    'Amideep technologies private limited',
    'Solminds technologies private limited',
    'CHERRYTEC INTELISOLVE PRIVATE LIMITED',
    'Outsourcebiz india private limited',
    'Balin tech labs private limited',
    '4D INDIATEQ LIMITED',
    'Drive india enterprise solutions limited',
    'Star online technologies limited',
    'Gloabtel convergence limited',
    'Apind communications private limited',
    'Ksg automation private limited',
    'Softalk computers private limited.',
    'Tamanna business solutions private limited.',
    'Alpha plus technologies private limited',
    'Bahar infocons private limited',
    'Aggarwal computronix private limited',
    'Js technosoft private limited',
    'Accurate info soft private limited',
    'Tower research capital india private limited.',
    'Ats cadd core private limited',
    'Legacy global technologies private limited',
    'Digiapt software technologies private limited',
    'Spardhin solutions private limited',
    'Consultingnode infotech private limited',
    'Beehive digital concepts private limited',
    'Lsg software private limited',
    'D.h. reen pharmaceuticals private limited',
    'Time leverage instruments private limited',
    'Axiom tie-up private limited',
    'Benaka minerals trading private limited',
    'The excelsior mill supply company limited',
    'Nowrosjee wadia and sons limited',
    'W r talwalker brothers private limited',
    'JAYEM SECURITIES PRIVATE LIMITED',
    'UNITROL ENGINEERING PRIVATE LIMITED',
    'Venkatesh karriers limited',
    'Gulmohr trading company private limited',
    'Incab commodeal pvt. ltd.',
    'Swastik goods and suppliers pvt. ltd.',
    'Fairplan vincom pvt ltd',
    'Puriya industrial packaging limited',
    'Floriba estates pvt ltd',
    'Rajat apartments pvt. ltd.',
    'Park apartments pvt ltd',
    'Bimla properties pvt. ltd.',
    'Mukul housing pvt. ltd.',
    'Merlin homes pvt ltd',
    'Web design house private limited',
    'Fomra builders private limited',
    'Sahara india commercial estates private limited',
    'Bagban abasan private limited',
    'Biscon niketan private limited',
    'Anchor infrastructures private limited',
    'Anurag enclave pvt ltd',
    'Rainbow infrastructure pvt ltd',
    'Rahul residency private ltd',
    'Mataji developers private limited',
    'Cocoon residences private limited',
    'Brahmaputra industrial estate private limited',
    'Keshri nandan realties private limited',
    'Purshotam industries ltd',
    'Lords creative infrasolution private limited',
    'Holambi khurd buildestates private limited',
    'BRINDAVAN INFRABUILD PRIVATE LIMITED',
    'PASSERINE SPORTS PRIVATE LIMITED',
    'Surya realcon private limited',
    'Parjat developments private limited',
    'Westminster developments private limited',
    'Jagbir developments private limited',
    'Zarina developments private limited',
    'Khazina developments private limited',
    'Pathak developers private limited',
    'Neelgund developers and builders private limited',
    'Suvastu housing private limited',
    'Inkal ventures private limited',
    'Heet builders private limited',
    'Sharana development private limited',
    'Navi Mumbai SMART CITY Infrastructure Limited',
    'A.r.s. properties private limited',
    'Somerset estate private limited',
    'R.kothari eractor private limited',
    'Neelkanth india housing private limited',
    'Neelkanth property developers private limited',
    'Aliens developers private limited',
    'Suvarnabhoomi developers private limited',
    'Pearl beach realty private limited',
    'VGN PROJECTS ESTATES PRIVATE LIMITED',
    'Vgn estates private limited',
    'V.guruswamy naidu & co private limited',
    'Cnc realty private limited',
    'Sarvagya commerce india pvt ltd',
    'E f c logistics india private limited',
    'Supreme shrachi infrastructures private limited',
    'Sriram tokharam realtors private limited',
    'SREYASH BREWSKI LIMITED',
    'Mats infrastructure private limited',
    'Arjava projects private limited',
    'Embassy inn private limited',
    'Shyam sunder estates private limited',
    'Kwality developers p ltd',
    'Abn buildwell private limited',
    'Sarl nestbuild private limited',
    'GREENHAT CONSULTANTS PRIVATE LIMITED',
    'Abhinav building solutions private limited',
    'Sunland infratech private limited',
    'Holambi khurd promoters private limited',
    'Embassy construction pvt ltd',
    'Maybach developers private limited',
    'Prabhavathi builders and developers private limited',
    'H.r.c.ventures (bangalore) private limited',
    'Sitara developers private limited',
    'Viridian infra private limited',
    'Awas meadows coriander farms private limited',
    'Pluss realty and financial services private limited',
    'Genex infratech limited',
    'BRANDSON ENTERPRISES PRIVATE LIMITED',
    'Amarprakash reaalty solutions private limited',
    'Anuj properties pvt. ltd.',
    'Kalpataru properties pvt.ltd.',
    'Green park agri private limited',
    'Dadi infrastructure private limited.',
    'Sansar infrastructure private limited',
    'Lambodar niwas private limited',
    'Everstrong enclave private limited',
    'Edric builders private limited',
    'Rajashi developers private limited',
    'Helpful complex private limited',
    'Investors clinic property solutions private limited',
    'Holambi khurd realtors private limited',
    'WISHWELL FARMS PRIVATE LIMITED',
    'Samriddhi contech private limited',
    'GYMLINE PLUS PRIVATE LIMITED',
    'Starwood properties private limited',
    'Lj-victoria properties private limited',
    'Bee-line builders and developers private limited',
    'Sincere business services pvt ltd',
    'Ultex plasti-coats private limited',
    'Prudent real estate and properties pvt. ltd.',
    'Krishna laxmi developers private limited',
    'Amarprakash foundation private limited',
    'E RESIDENCES PRIVATE LIMITED',
    'Auro shikha vinimay pvt ltd',
    'Concord synthetics pvt ltd',
    'Automatic software private limited',
    'Maa retail private limited',
    'Parma clima technologies india private limited',
    'Global natural fibre forum',
    'Catalytic think tank forum',
    'Barspell technologies india private limited',
    'Sentient sensors private limited',
    'Inroads leadership development private limited',
    'Ignite education private limited',
    'Ankanji consultants private limited',
    'Isthaan financials private limited',
    'Naracamicie fashions india private limited',
    'Freya capital advisors private limited',
    'Vsm vibration tech private limited',
    'Vgn facility management services private limited',
    'Options media private limited',
    'Agrya consulting private limited',
    'Brand wave communications private limited',
    'Data proficient corporate and financial services private limited',
    'Miraj metals private limited',
    'Idataworks systems private limited',
    'Cogent hr services private limited',
    'SPHINX ADONIS EVENTS INTERNATIONAL PRIVATE LIMITED',
    'Keensecure technology private limited',
    'Voice training and research private limited',
    'Infinite displays india private limited',
    'KOKAL INTERIOR CONTRACTS PRIVATE LIMITED',
    'Suvarna electricals private limited',
    'Unique system skills (india) private limited',
    'ABILITY GAMES LIMITED',
    'Blueapple events private limited',
    'Ico inspection services india private limited',
    'Scarlet splendour designs private limited',
    'Qui vive consulting services private limited',
    'Dyulok technologies private limited',
    '50KVENTURES ADVISORS PRIVATE LIMITED',
    'Mecheri smart capital private limited',
    'Aargee staffing services private limited',
    'Rapid solutions (i) private limited',
    'Bcl secure premises private limited',
    'Chennaistar shipping private limited',
    'Hsrp solutions (punjab) private limited',
    'Kore security services private limited',
    'Guru info solutions private limited',
    'Prasad extreme digital cinema network private limited',
    'Crest commercial projects (india) private limited',
    'Rudrali jewels private limited',
    'Spads phototype setting industries private limited',
    'Superb my trip private limited',
    'Pratul enterprises private limited',
    'Wiz world commercial private limited',
    'KAK AUTOMOBILES & UTILITIES PRIVATE LIMITED',
    'Fragrance delivery technologies private limited',
    'Gammon seaport infrastructure limited',
    'Gammon renewable energy infrastructure projects limited',
    'Gammon road infrastructure limited',
    'Semantichr advisors & consultants private limited',
    'Autoji private limited',
    'Aura opto electronics india private limited',
    'Talento technical plant services private limited',
    'Asap fluids private limited',
    'Den premium multilink cable network private limited',
    'Chitoor infra company private limited',
    'Redefine realty consulting private limited',
    'Bwl blue whale logistics india private limited',
    'Symbio generrics india private limited',
    'Jco gas pipe limited',
    'Shankar ramchandra auctioners private limited',
    'Nz insurance brokers private limited',
    'Jpt share services private limited',
    'Ananya crafts and designs private limited',
    'Marketing solutions and services private limited',
    'ELEANOR CONGLOMERATE PRIVATE LIMITED',
    'Eduplex consultancy services private limited',
    'Mainstay development consultants private limited',
    'Interics interior management private limited',
    'Ansh commerce private limited',
    'ANIMAZIONE VISUAL STUDIO PRIVATE LIMITED',
    'Fortech enterprises private limited',
    'Shankar mercantile agency private limited',
    'Ravindra services private limited',
    'Seeq electronic systems private limited',
    'Essix biosciences limited',
    'Jigar commodities & derivatives private limited',
    'Siegwerk india private limited',
    'JSS MEDICAL RESEARCH ASIA PACIFIC PRIVATE LIMITED',
    'Axis hr consultancy private limited',
    'EZONE SECURITY SOLUTIONS (INDIA) PRIVATE LIMITED',
    'VEHANT TECHNOLOGIES PRIVATE LIMITED',
    'MILAGROW BUSINESS & KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'Strawberry fields televentures private limited',
    'Tak technologies private limited',
    'Sungel international private limited',
    'Skylark infoservices private limited',
    'Rr india private limited',
    'Amiga informatics private limited',
    'Firstouch solutions private limited',
    'Think safety private limited',
    'Sks technologies private limited',
    'Divine thermal wrap private limited',
    'Pgc hospitality services private limited',
    'Third eye security guarding private limited',
    'Trendz utensils private limited',
    'Swastik tungsten private limited',
    'ASHVITHA PHARMA PRIVATE LIMITED',
    'Naini papers limited',
    'Delvin formulations private limited',
    'Nova carbons india private limited',
    'Dolphin lifecare limited',
    'TECHNOVA VENTURES PRIVATE LIMITED',
    'Kantilal manilal and company private limited',
    'Tarun composites pvt ltd',
    'Geissel india private limited',
    'Salt lake shirts private limited',
    'B m g chemicals private limited',
    'Gears and pinions private limited',
    'Ratna agro chemicals pvt ltd',
    'Vins bioproducts limited',
    'Chargewave energykem private limited',
    'Sneha aqua private limited',
    'Sanvira industries limited',
    'Zenith die makers private limited',
    'Devdhar chemicals private limited',
    'ACID INDIA LIMITED',
    'Amtec health care private limited',
    'SHILPA CHEMSPEC INTERNATIONAL PRIVATE LIMITED',
    'Madhur manufacturing and exporters pvt.ltd.',
    'Isolloyd engineering technologies limited',
    'Adjavis venture limited',
    'KASYAP SWEETNERS PRIVATE LIMITED',
    'Caliron chemicals pvt ltd',
    'Geetanjali press private limited',
    'Vipul drugs private limited',
    'Umesh chemicals private limited',
    'Jain coke & power private limited',
    'Spectrum polymers pvt ltd',
    'AUTOTECH-SIRMAX INDIA PRIVATE LIMITED',
    'Andhra polymers pvt ltd',
    'Arcies laboratories limited',
    'Pharma base india private limited',
    'Exol corporation limited',
    'Gem pressure systems (india) private limited',
    'Century inks pvt ltd',
    'Unimed technologies limited.',
    'Fairdeal petrolium private limited',
    'Capital market publishers india private limited',
    'Golden sparrow publishing private limited',
    'Embassy printing inks private limited',
    'Gurukul publications private limited',
    'Nugenic pharma private limited',
    'KAUSTUBHA SCIENTIFIC RESEARCH LABORATORYPRIVATE LIMITED',
    'Prakash petrochemicals private limited',
    'Wild well control (india) private limited',
    'MEDIBIOS LABORATORIES LIMITED',
    'Amn life science private limited',
    'Cure medicines (india) private limited',
    'Enal drugs pvt ltd.',
    'Chemi therm plants and systems private limited',
    'Clan laboratories private limited',
    'PEGADO FIXING SOLUTIONS PRIVATE LIMITED',
    'Raajratna metal industries ltd',
    'Deedy chemicals pvt ltd',
    'Jagson colorchem limited',
    'Sienna formulations private limited',
    'Hindustan biosynth limited',
    'Bioreliance laboratories private limited',
    'Adam fabriwerk private limited',
    'AMRUT CREATIONS INDIA LIMITED',
    'Nipro tube glass private limited',
    'ADEEP LIFE SCIENCES PRIVATE LIMITED',
    'Burgeon pharmaceuticals private limited',
    'Scott-edil advance research laboratories & education limited',
    'Salve pharmaceuticals private limited',
    'Ciess texaux speciality chemicals private limited',
    'Chorus drugs private limited',
    'Marathawada realtors private limited',
    'VISHWA SAMUDRA HOLDINGS PRIVATE LIMITED',
    'Rohini oil field chemicals private limited',
    'Saimirra innopharm private limited',
    'Skabama chemico and commercial pvt ltd',
    'ELECTRONICA TUNGSTEN LIMITED',
    'S k poly formulations private limited',
    'Dynaciate process solutions private limited',
    'Vivo life sciences private limited',
    'KALPANA CHEMICALS Private Limited',
    'Adwit (india) private limited',
    'Innorex pharmaceuticals private limited',
    'CHORUS LABS LIMITED',
    'LARSON PHARMA Private Limited',
    'GOPAL PRINT & PROCESSORS PRIVATE LIMITED',
    'PIONEER INDUSTRIES PRIVATE LIMITED',
    'Marleshwar printing and packaging private limited',
    'Aero industries private limited',
    'THE SCIENTIFIC FERTILISER COMPANY PRIVATE LIMITED',
    'Usl chemicals private limited',
    'Aparna constructions and estates private limited',
    'Bhimad commercial company private limited',
    'PENTAGON RUBBER LIMITED',
    'Gpsar healthcare limited',
    'Pride drugs and pharma private limited',
    'Lathia industrial supplies co pvt ltd',
    'Seal jet (india) pvt ltd',
    'Kishor valves private limited',
    'Intrac tyres private limited',
    'Kanta flex (india) private limited',
    'Ujwal plastics industries private limited',
    'Plastrulon processors private limited',
    'Brindavan infrastructure company limited',
    'R.k.m. estates private limited',
    'Avijit estate & holdings limited',
    'Eigmef apparel park ltd',
    'Phani estates private limited',
    'IAV INFRASTRUCTURES PRIVATE LIMITED',
    'Kalpatharu enterprises private limited',
    'Bengal silver spring projects limited',
    'Gaea engineers and contractors private limited',
    'Abhay ispat infraprojects private limited',
    'CRESCENT EPC PROJECTS AND TECHNICAL SERVICES LIMITED',
    'TRINITECH INFRASTRUCTURE (INDIA) PRIVATE LIMITED',
    'Kcl constructions private limited',
    'M one infrastructure private limited',
    'Era residency private limited',
    'Goldcoin properties private limited',
    'VUB PROJECTS PRIVATE LIMITED',
    'Springfield projects private limited',
    'Palm heights private limited',
    'Aurum developers private limited',
    'K rachana properties private limited',
    'Shanivi construction private limited',
    'BHAGYANAGAR ENTERTAINMENT & INFRA DEVELOPMENT COMPANY PRIVATE LIMITED',
    'Hotcrete infrastructure private limited',
    'Shangrila infracon india private limited',
    'PAKRICORN TECHNO SOLUTIONS PRIVATE LIMITED',
    'Chettinad projects development private limited',
    'R s d estates private limited',
    'Uniexcel developers private limited',
    'Happy home infraprojects private limited',
    'Shri balaji infradevelopers private limited',
    'Cccl infrastructure limited',
    'Great saturn infrastructure pvt. ltd.',
    'UNNATI INDUSTRIAL PARK PRIVATE LIMITED',
    'Titanium buildwell private limited',
    'Electra heights private limited.',
    'Neris developers private limited',
    'Carnoustie leisure private limited',
    'Advermark wiresmith private limited',
    'Anushna estates private limited',
    'YOGYA INFRASTRUCTURES LIMITED',
    'Beverly hills realty private limited',
    'Aesthetic builders private limited',
    'Survir infrastructures private limited',
    'Brick by brick developers & promoters private limited',
    'Vvsv builders & promoters private limited',
    'Pareena builders & promoters private limited',
    'SIDDHYUG TEXTILES PRIVATE LIMITED',
    'Highway apartments private limited',
    'Akson projects and services private limited',
    'FORCON INFRA PRIVATE LIMITED',
    'Miracle properties private limited',
    'Suraj magic land private limited',
    'Shivdayal infrastructure private limited',
    'Jpv infraprojects (i) private limited',
    'Rohinton mehta infrastructures private limited',
    'PONDICHERRY -TINDIVANAM TOLLWAY PRIVATE LIMITED',
    'THUMMALACHETTY BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Gvk shivpuri dewas expressway private limited',
    'Acestar properties private limited',
    'Shri satguru buildcon private limited',
    'Happy infracon private limited',
    'Ramavtar properties private limited',
    'Elegant niketan private limited',
    'Neptune plaza maker private limited',
    'Synergy thrislington instacon private limited',
    'Basuki civil projects private limited',
    'Pranidhi constructions private limited',
    'Star cineplex private limited',
    'SRI RANGANATHA ENTERPRISES & THEATERS PRIVATE LIMITED',
    'Tallam shilpa private limited',
    'Knchan infrastructures limited',
    'Horizon shelters private limited',
    'Paradigm building solutions private limited',
    'Abad property management services private limited',
    'Drish shoes limited',
    'Mfar rmc private limited',
    'Escort projects private limited',
    'Projin project private limited',
    'Besto infrastructure bangalore private limited',
    'Woodstick developers private limited',
    'KOLIVE INDIA PRIVATE LIMITED',
    'Wood preservers private limited',
    'TRISKAIDEKA ADVISORS PRIVATE LIMITED',
    'Sharcon realty private limited',
    'Shivdayal buildcon private limited',
    'AEROLITE INDUSTRIES PRIVATE LIMITED',
    'Radhika somana interiors private limited',
    'Osnar paints and contracts private limited',
    'Noble consolidated glazings limited',
    'G.k. autovehicles private limited',
    'Ganesh autosolutions india private limited',
    'Asha automobiles private limited',
    'Bhagyanagar industrial park',
    'Green valley pride private limited',
    'En3 sustainability solutions private limited',
    'Primerose nirman private limited',
    'S m abasan private limited.',
    'Unix infrastructure limited',
    'Uranus auto seat trims private limited',
    'Nidhikamal automobiles private limited',
    'Rt villa private limited',
    'Carplanet enterprises private limited',
    'Parashar motors private limited',
    'Rohan autoriders private limited',
    'Spero power private limited',
    'Sanjivani purandar water foundation',
    'P.s.s. ventures private limited',
    'L & w construction private limited',
    'Platinum construction syndicate private limited',
    'Patliputra builders limited',
    'H.k. land developers private limited',
    'Raghuveer urban constructions company private limited',
    'Westcoast realtors and developers private limited',
    'Sabve rohini contractors private limited',
    'SAVANA INFRASTRUCTURE & PROPERTIES LIMITED',
    'Rng infrastructure private limited',
    'BLACK LOTUS ESTATES PRIVATE LIMITED',
    'Sainsons developers private limited',
    'Nimbus real estate solutions private limited',
    'T & t projects limited',
    'Stonearch properties private limited',
    'Chelsea apartments private limited',
    'Gtm builders and promoters private limited',
    'Mansarovar apartments private limited',
    'B m gupta estates private limited',
    'Ncc urban homes private limited',
    'Ampa housing development private limited',
    'Dakshin constructions private limited',
    'SEVENTH SENSE REALITY DEVELOPERS PRIVATE LIMITED',
    'Indiabulls land holdings limited',
    'New modern buildwell private limited',
    'Nezone estates pvt. ltd.',
    'Jaipur marbo tile private limited',
    'Duncans agro chemicals limited',
    'Vaikunth infrastructure private limited',
    'Neelkamal nirman co. private limited',
    'Seabird construction private limited',
    'Nivedita shivyatan construction private limited',
    'Saha infrastructures private limited',
    'Saha realty ventures private limited',
    'Maruthi power infra bangalore private limited',
    'Anand investments private limited',
    'Highrise properties private limited',
    'Raghav realtors private limited',
    'Sadhana developers and builders private limited',
    'Shreyas shelters private limited',
    'Snowflower properties private limited',
    'Raj rewal associates consultants pvt ltd',
    'Naivedya infrastructures private limited',
    'Akshay sthapatya private limited',
    'Dlf sbpl developers private limited',
    'Swanand consultants and engineers private limited',
    'Spandan enterprise pvt ltd',
    'Oceanmint developers private limited',
    'Karaikal port private limited',
    'Sri jagathswapna realtors private limited',
    'Shree gurukrupa land developers private limited',
    'Chanani capital city and towers pvt ltd',
    'SIMPLEX INFRA DEVELOPMENT Private Limited',
    'NEST WELL CONSTRUCTION PRIVATE LIMITED',
    'Dignity infrastructure private limited',
    'Atyam infrastructure private limited',
    'Hamara shelters private limited',
    'Swarna housing developers private limited',
    'Intent devcon private limited',
    'PBS INTERNATIONAL AGRO PRODUCTS PRIVATE LIMITED',
    'Vishwas asset holdings private limited',
    'Rajpurohit projects private limited',
    'Sommji kumar properties private limited',
    'Krish realtors private limited',
    'Chandra dwellings private limited',
    'Kanushree developers private limited',
    'Arihant kripa developers private limited',
    'Kadavanthara builders private limited',
    'Opera housing private limited',
    'Nicco jubilee park limited',
    'Durable realty (india ) private limited',
    'Varali constructions limited',
    'Sophia constructions limited',
    'Varali infrastructure limited',
    'Sentia infrastructure limited',
    'Patel knr infrastructures limited',
    'Arihant realty services private limited',
    'URBANYX INFRA PRIVATE LIMITED',
    'Ramprastha promoters and developers private limited',
    'SATLUJ BUILDERS & LAND DEVELOPERS PRIVATE LIMITED',
    'Indiaworld technologies private limited',
    'Bendek developers private limited',
    'Ild infrastructure private limited',
    'A.b. propmart private limited',
    'Serida properties limited',
    'Impact sare magnum townships private limited',
    'Magnet developers private limited',
    'Mohite builders pvt ltd',
    'Ponnas infrastructure private limited',
    'Hyland property developers private limited',
    'Rising projects india private limited',
    'Ashparry construction private limited',
    'TENON FACILITY MANAGEMENT INDIA PRIVATE LIMITED',
    'Adg online solutions private limited',
    'Manorath developers private limited',
    'Rbbr infrastructure private limited',
    'Hr realtors & developers private limited',
    'IBROX AVIATION AND TRADING PRIVATE LIMITED',
    'Samarjit realties & farms private limited.',
    'Ashjit realties private limited',
    'Bbm constructions pvt. ltd.',
    'ZEON LAND & ESTATE DEVELOPERS PRIVATE LIMITED',
    'NOUAM INFRA PRIVATE LIMITED',
    'Newbridge capital private limited',
    'Farida holdings private limited',
    'Matrix financial services ltd',
    'Sciera solutions private limited',
    'Tapp chennai holdings private limited',
    'Mohan mutha sons investments private limited',
    'Snt holdings private limited',
    'Vanshree holdings pvt ltd',
    'Rainbow investments limited',
    'Energetics investments q consultants p ltd',
    'Russell credit ltd',
    'Mks credit & finance pvt ltd',
    'Manoj fincom private limited',
    'Juniper investments limited',
    'Easy insurance agencies private limited',
    'Panorama mercantile private limited',
    'Jas par holdings private limited',
    'SUNMAN INVESTMENT ADVISORS PRIVATE LIMITED',
    'Innovative microfinance for poverty alleviation and community transformation',
    'Vadakkemuriyil finance company (india) limited',
    'Churiwala properties and investments pvt ltd',
    'Nariman finvest pvt. ltd.',
    'Sapphire insurance agencies limited',
    'NIRMAL BANG INSURANCE BROKING PRIVATE LIMITED',
    'Sugandha holdings private limited',
    'Shanti securities private limited',
    'Indian acrylics investments ltd',
    'South asian stocks limited',
    'Nupur finvest private limited',
    'HCL CAPITAL PRIVATE LIMITED',
    'Sahri-kahri investments private limited',
    'Smartest corporate services private limited',
    'Rallis commercial private limited',
    'Invest one india limited',
    'Vansh holdings private limited',
    'L m s foundries pvt ltd',
    'Tanna brokers private limited',
    'Shyam advisory limited',
    'Fida securities private limited',
    'Amit shares and finance private limited',
    'Devatha holdings private limited',
    'Bansal precision forge limited',
    'Sprism investment services private limited',
    'Octogen holdings private limited',
    'Affluenz financial services india private limited',
    'J m financial and investment consultancy services private limited',
    'INDIFI CAPITAL PRIVATE LIMITED',
    'Anugrah investments limited',
    'Amco holdings pvt ltd',
    'Potential holding pvt ltd',
    'Tiger travels and tours limited',
    'West end investment and finance consultancy pvt ltd',
    'Amisha vinyls private limited',
    'Insan investments and finance limited',
    'Helios pecuniary and investors private limited',
    'Hakumatrai investment and trading private limited',
    'Velji dosabhai investments pvt ltd',
    'RAITAN SERVICES PRIVATE LIMITED',
    'PODS FINSERV PRIVATE LIMITED',
    'Ratnakar securities private limited',
    'BLACKSOIL CAPITAL PRIVATE LIMITED',
    'Zip properties and investment private limited',
    'Sapphire securities private limited',
    'Nangalia stock broking private limited',
    'Brijmohan sagarmal capital services private limited',
    'Krisma investments private limited',
    'Indian clearing corporation limited',
    'Prachin investment private limited',
    'Bright securities private limited',
    'MENTOR HOME LOANS INDIA LIMITED',
    'Karvy investor services limited',
    'Jacinth finvest limited',
    'SUKHDEV CONSULTANCY LIMITED',
    'Naveen shares& securities pvt ltd',
    'Sheela timber industries limited',
    'Samudra securities limited',
    'Hail securities & investments pvt. ltd.',
    'Automatrix commodities pvt. ltd.',
    'Somani stock broking pvt.ltd.',
    'J v s securities pvt ltd',
    'Trusthouse securities private limited',
    'Japan power service private limited',
    'East india stock brokers private limited',
    'Globus capital markets private limited',
    'SHAKSHI CRESEC PRIVATE LIMITED',
    'Nishk credit services private limited',
    'Credent capital services private limited',
    'DOO INNOVATION PRIVATE LIMITED',
    'Jazaa financial advisory private limited',
    'One up capital private limited',
    'Gnv commodities private limited',
    'Borkar consultancy services private limited',
    'E d sassoon and company private limited',
    'Abhinandan financial and chemical pvt ltd',
    'Aristo fincap private limited',
    'Atlas exchange bureau private limited',
    'Crowe horwath consultants private limited',
    'Jagsons forex private limited',
    'Avista advisory associates private limited',
    'Whitecross (india) private limited',
    'Nucore capital management private limited',
    'Multi securities private limited',
    'GOCAPITAL FINANCE LIMITED',
    'Morgan solid waste company holdings limited',
    'Consortium capital private limited',
    'Jagdhatri investment advisory private limited',
    'Ksb tech private limited',
    'Pollution control consultants (india) private limited',
    'SMRITI FORGING & ENGINEERING CO PVT LTD',
    'Medmez services private limited',
    'India innovation incorporation private limited',
    'Spectro textile testing and calibration private limited',
    'Uni ads limited',
    'Tarun khiwal photography private limited',
    'Portrait advertising and marketing private limited',
    'G-tec e-media private limited',
    'Get n dial info service private limited',
    'Rapport outdoor advertising private limited',
    'HITENDRA CONSULTANCY (OPC) PRIVATE LIMITED',
    'Dynamation media pvt ltd',
    'Planet dezign india private limited',
    'Sutraa creations private limited',
    'Prachin advertising private limited',
    'Adelement media solutions private limited',
    'Hope advertising private limited',
    'ENKAY (INDIA) RUBBER COMPANY PRIVATE LIMITED',
    'Thermoplastic india private limited',
    'Rapid engineering co pvt ltd',
    'Shree shyam kamal industries private limited',
    'Karan raghav exports private limited',
    'Platinum creations private limited',
    'Creative travel private limited',
    'Jumbo international private limited',
    'Aerolux india private limited',
    'Sitac properties private limited',
    'Bentex palaces private limited',
    'Sharsh finance and investment company private limited',
    'Deep india enterprises private limited',
    'Sheel overseas limited',
    'Seeta foods private limited',
    'Rishabh holdings private limited',
    'Mectech process engineers private limited',
    'Integral engineering private ltd',
    'Chandhok textiles enterpsies private ltd.',
    'Pushkar electronic private ltd.',
    'Konark publishers private ltd',
    'Unison associates private ltd.',
    'Kayem food industries private limited',
    'Naya plastics private ltd.',
    'Veer construction technocrats private limited',
    'CARNATION ESTATES PRIVATE LIMITED',
    'Civtech consultants private limited',
    'Four c plus media tech private limited',
    'New way electronics private limited',
    'PRAKASH MACHINERIES PRIVATE LIMITED',
    'Ptc finanace private limited .',
    'Cabot electronics private limited',
    'Mark agro private limited',
    'Wanderlust travels private limited',
    'Vsk-kegfarms corporate holdings private limited',
    'County investments private limited',
    'Gurera industries limited',
    'Chitvan farms private limited',
    'Sangam farms private limited',
    'Savera farms private limited',
    'Essel marketing private limited',
    'Trans bharat aviation pvt ltd',
    'Uparjan trading private limited',
    'Khandelwal galva strips private limited',
    'MR JUNEJA IRON & STEEL PRIVATE LIMITED',
    'Echo erectors private ltd',
    'Theta investment private limited',
    'Flair builders private limited',
    'ONE MORE FOODS PRIVATE LIMITED',
    'Classic couriers private limited',
    'Shailja investments limited',
    'Mectech knitfabs private limited',
    'Savcon thermal engineers (india) private limited',
    'ANAND BHAWAN SAFETY VAULTS PRIVATE LIMITED',
    'KINGSPAN JINDAL PRIVATE LIMITED',
    'QUICK CLEAN HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'Shomit finance limited',
    'Bansal strips pvt ltd',
    'ANURAG DIGITAL PRIVATE LIMITED',
    'MARVEL TEA PRIVATE LIMITED',
    'Sytex scientific and hydraulics private limited',
    'P v cargo carriers private limited',
    'International tractors limited',
    'Delite kom limited',
    'SMC CORPORATION( INDIA) PRIVATE LIMITED',
    'Max faith engineers private limited',
    'Bajaj maschinen private limited',
    'Ramose infra private limited',
    'Integrated network systems private limited',
    'Ukg securities private limited',
    'Varuna finance private limited',
    'Red eagle shipping agencies private limited',
    'Vee vee properties private limited',
    'Plastometal engg.(i) private limited',
    'Spiral product design private limited',
    'Honeywell international (india) private limited',
    'Trigon synergies private limited',
    'WELLTIME TRADING AND SERVICES PRIVATE LIMITED',
    'RIDINGS CONSULTING ENGINEERS INDIA LIMITED',
    'K k capital services limited',
    'Joy d-zign engineers private limited',
    'Bnt media & entertainment limited',
    'G c n infotech private limited',
    'LECTRIX URBAN EMOBILITY PRIVATE LIMITED',
    'Apurva corporate advisors private limited',
    'ENEED INTEGRATED SERVICES PRIVATE LIMITED',
    'Sigma moulds and stampings private limited',
    'Cadence electrical engineers private limited',
    'Colorlines clothing india private limited',
    'MATOSHRI INFRA POWER AND TEXTILE INDUSTRIES PRIVATE LIMITED',
    'Atmaram maneklal (exports) pvt ltd',
    'Shree nandeshwar knit india private limited',
    'Shashank mercantile private limited',
    'Navketan pvt ltd',
    'Chandmani tea co ltd',
    'Caculo earthmovers private limited',
    'Indian clothing league private limited',
    'Dee are texfab private limited',
    'Kumar metal industries private limited',
    'Fantail textiles private limited',
    'Arakal textile trade private limited',
    'Jaipur integrated texcraft park private limited',
    'Jvs textile processors limited',
    'Berry tex private limited',
    'Shrirang and sons private limited',
    'Kavis fashions private limited',
    'Swastik coaters pvt ltd',
    'Chimanlal suresh kumar textiles private limited',
    'POKARNA MARKETING PRIVATE LIMITED',
    'APEX COCO AND SOLAR ENERGY LIMITED',
    'Shiv shakti handicrafts private limited',
    'Ram rajya clothing private limited',
    'Blisswood global impex private limited',
    'Singla apparels private limited',
    'Maryan apparel private limited',
    'Kashvi designs private limited',
    'Aaruthra apparels private limited',
    'Kanade granite pvt ltd',
    'Marutinandan tex-print private limited',
    'AANCHAL FABTEX INDIA PRIVATE LIMITED',
    'Frendi fashions private limited',
    'Colortex clothing private limited',
    'Best clothing company (india) private limited',
    'Somani creation private limited',
    'A. r. fibtex pvt.ltd.',
    'Sandlon technologies private limited',
    'Instyle exports pvt ltd',
    'Amaryllis clothing private limited',
    'Khloe retail private limited',
    'Caculo apparels private limited',
    'Disha designs private limited',
    'Krishma gloves private limited',
    'Spell fashions private limited',
    'Allied outfitters limited',
    'Eurolux fragrances private limited',
    'Cottstown textiles private limited',
    'Rajpurohit Technosolutions Private Limited',
    'VARDHMAN AIRPORT SOLUTIONS PRIVATE LIMITED',
    'Raichand brothers (india) private limited',
    'Ayman tanning company private limited',
    'Saraswati timber private limited',
    'Oscar medicare private limited',
    'A. p. leather co. private limited',
    'K h leather industries private limited',
    'Roselin leathers private limited',
    'Zahonero india private limited',
    'Kaas footwear industries private limited',
    'Pavers england limited',
    'Samrat laminates private limited',
    'Surya decolam private limited',
    'Kandla lumbers private limited',
    'Vidhata panels private limited',
    'JETLINE INDUSTRIES PRIVATE LIMITED',
    'Radhe sham ravi prakash timbers private limited',
    'SUDHIR PAPERS PRIVATE LIMITED',
    'ENVOPAP PRIVATE LIMITED',
    'Soni son packaging private limited',
    'Svam packaging private limited',
    'Vedant papercraft private limited',
    'Gurukrupa steel and rolling mills private limited',
    'Sankeshwar packaging pvt ltd',
    'Lvr industries private limited',
    'Sri ratna packaging private limited',
    'Resource papers private limited',
    'S.r. papers private limited',
    'God media private limited',
    'Rawat publication private limited',
    'GIFTOSIS ONLINE SERVICES PRIVATE LIMITED',
    'Apple publishing international private limited',
    'Iilm publishing private limited',
    'Dsij private limited',
    'B.a.g. convergence private limited',
    'Coffeeland news track private limited',
    'Prime mag subscription services private limited',
    'City guide yellow pages private limited.',
    'Kerala law journal pvt ltd',
    'Liquid publishing private limited',
    'Bulb media private limited',
    'WATERGATE PRODUCTION PRIVATE LIMITED',
    'Bw businessworld media private limited',
    'SHUBH SANCHAR (INDIA) PRIVATE LIMITED',
    'Blue fish designs private limited',
    'MADHUSHA LIFECARE PRIVATE LIMITED',
    'LAKESIDE HOTELS PRIVATE LIMITED',
    'Wordcraft publications private limited',
    'J k fine prints private limited',
    'Jujhar advertisers private limited',
    'Score media private limited',
    'Dwarikesh informatics limited',
    'Savi fashion apparels private limited',
    'Blupex vyapar pvt. ltd.',
    'A to z printers & publishers private limited',
    'Pagemakers offset press pvt ltd',
    'Security printing and minting corporation of india limited',
    'Defined values publishers private limited',
    'Green printing solution private limited',
    'Goa art printers private limited',
    'TURBO ENERGY Private Limited',
    'GROWELL SOLAR ENERGY PRIVATE LIMITED',
    'Sun alternate energy private limited',
    'Renew wind energy (shivpur) private limited',
    'Vayuputhra energy private limited',
    'Greenko solar energy private limited',
    'Greenko wind energies private limited',
    'Greenko energy ventures private limited',
    'Sandeep wind farms private limited',
    'Deekay wind farms india private limited',
    'Evermellow energy (india) private limited',
    'Wind world wind farms (tamilnadu) private limited',
    'Aditya solar energy private limited',
    'Athena emra power private limited',
    'Renew wind energy (karnataka) private limited',
    'Renew wind energy (devgarh) private limited',
    'Jaipur vidyut vitran nigam limited',
    'Greenko budhil hydro power private limited',
    'Duncan macneill power india limited',
    'GASTECH SOLUTIONS PRIVATE LIMITED',
    'Makharia industrial gases private limited',
    'Kasa power private limited',
    'Renew wind energy (rajasthan) private limited',
    'Renew wind energy (sipla) private limited',
    'Renew solar power private limited',
    'Renew wind energy (orissa) private limited',
    'Fourth prime solutions private limited',
    'Renew wind energy (ap 2) private limited',
    'RENEW GREEN ENERGY SOLUTIONS PRIVATE LIMITED',
    'Renew wind energy (karnataka 3) private limited',
    'Renew wind energy (rajasthan 3) private limited',
    'Renew wind energy (rajasthan one) private limited',
    'Renew wind energy (karnataka five) private limited',
    'TERRALIGHT SOLAR ENERGY PATLASI PRIVATE LIMITED',
    'MARELLI POWERTRAIN INDIA PRIVATE LIMITED',
    'Sravanthi renewable energy private limited',
    'TP WIND POWER LIMITED',
    'Dhananjay power india private limited',
    'Roha urja private limited',
    'Saipuram wind energies private limited',
    'Anantpura wind energies private limited',
    'SAVITRA AGRI INDUSTRIAL PARK PRIVATE LIMITED',
    'Natems renewable energy private limited',
    'Endotech solar private limited',
    'Ulaginoli energy solutions private limited',
    'Kent r o systems limited.',
    'SANJOO FILAMENTS PRIVATE LIMITED',
    'Shraddha utilities private limited',
    'Aquatechnics water treatment technologies private limited',
    'Stellar space private limited',
    'Puzzolana estates private limited',
    'Chaitanya infrastructures pvt ltd',
    'Celeb homes private limited',
    'Plus projects private limited',
    'Trr properties limited',
    'Ahuja and anand probuilt private limited',
    'PROTEXER PRIVATE LIMITED',
    'Khaneja properties private limited.',
    'Ahuja and anand constructs private limited',
    'Kangaroo buildcon private limited',
    'Sainsons builders private limited',
    'Exclusive infrastructure private limited',
    'Orbit buildtech private limited',
    'Gennext infratech private limited',
    'Qube corporation private limited',
    'Ramprastha urban development private limited',
    'Yash infrafarms and developers private limited',
    'Translite scaffolding limited',
    'Techno enviro services private limited',
    'G CORP DWELLINGS PRIVATE LIMITED',
    'Altius realcon development(india) private limited',
    'Steel-crete private limited',
    'United pestichem and nonionics private limited',
    'Aditya builders private limited',
    'Rajdeep construction private limited',
    'Bunts properties private limited',
    'Mamta capita land private limited',
    'Natasha constructions private limited',
    'Damji shamji realty private limited',
    'Ivan properties pvt ltd',
    'Sea mist properties pvt ltd',
    'Wonder estate developers pvt ltd',
    'Meridian construction private limited',
    'Meher foundations and civil engineers private limited',
    'Belladona builders and developers pvt ltd',
    'Nawany corp (i) limited',
    'Arth developers p ltd',
    'Genuine homemakers private limited',
    'Bp comtrade private limited',
    'Esteem constructions private limited',
    'Skidmore owings and merrill india private limited',
    'Vinamra properties private limited',
    'EKNATH CONTRACTS PRIVATE LIMITED',
    'Shivam realties (india) private limited',
    'Viva land developers private limited',
    'Viva infra projects private limited',
    'Almighty infrastructure private limited',
    'Shree ram cargo private limited',
    'Prime peoples cargo private limited',
    'LX PANTOS INDIA PRIVATE LIMITED',
    'Vishwahind logistics limited',
    'Spacedge express solutions private limited',
    'Castlerock cold storage private limited',
    'Patton warehousing private limited',
    'Vishwas warehousing and trading private limited',
    'Rajhans warehousing company private limited',
    'Absolute logistics private limited',
    'Marco shipping services pvt ltd',
    'Quick freight systems private limited',
    'Triumph marine services pvt.ltd.',
    'Subramany logistics private limited',
    'Ekido holiday tours private limited',
    'Innovative holiday solutions private limited',
    'Gappu mahendra travels private limited',
    'Sunshine india private limited',
    'Tsw travels private limited',
    'Trans indus (india) private limited',
    'Exotique expeditions private limited',
    'Mehar travels private limited',
    'Travel spirit international private limited',
    'Moon light hospitality private limited',
    'Aileron air private limited',
    'Sohagia tours and travels private limited',
    'Vassa travels & tours private limited',
    'Vivekananda travels private limited',
    'Gns leisure travels private limited',
    'Bucketlist travel company private limited',
    'Travelera private limited',
    'Jac air service pvt ltd',
    'Pama properties private limited',
    'Cassinath truckers private limited',
    'Vulcan shipping private limited',
    'Tipiship waterways private limited',
    'Sidmark sales enterprise private limited',
    'Sgk aviations private limited',
    'Avi air private limited',
    'Specialized destination services private limited',
    'Indian vanlines private limited',
    'All-ways logistics ( cha ) private limited',
    'Aos logistics private limited',
    'Tripsmart consultants private limited',
    'Eleness logistics services private limited',
    'Sanpra international warehouse and logistic private limited',
    'Omkar translogistics private limited',
    'Good track call taxi private limited',
    'Ntl call taxi private limited',
    'AH SYSTEMS PRIVATE LIMITED',
    'Tns express private limited',
    'Agl logistics private limited',
    'Abad transport private limited',
    'Cargo world logistics india private limited',
    'Seabon shipping private limited',
    'Trikom shipping private limited',
    'Resource shipping private limited',
    'Dweta travel house private limited',
    'Itl tours and travels private limited',
    'Club medisa tours private limited',
    'A l travel currency private limited',
    'Sawera travels private limited',
    'Tsc travel services private limited',
    'Girikand logistics private limited',
    'Jubilee travels and tours pvt ltd.',
    'Dot cabs (india) private limited',
    'Naer air travel services private limited',
    'Sea port services private limited',
    'Jalan translogistics (india) limited',
    'Mentor shipping services private limited',
    'Global business logistics solutions private limited',
    'Skyasia aviation private limited',
    'Wise voyage private limited',
    'Stolt Tank Containers Cleaning and Repair Kandla Private Limited',
    'NEPTUNE LOGITEK PRIVATE LIMITED',
    'Lokesh logistics private limited',
    'Noren logistics private limited',
    'Tulsi shipping private limited',
    'Shreenath roadways private limited',
    'Shri dhanya travels private limited',
    'Satyam clearing and forwarding agency private limited',
    'Globex premium holidays limited',
    'Ewns holidays private limited',
    'Oceanic clearing and shipping company private limited',
    'Pro kargo (india) private limited',
    'Dc software services private limited',
    'Ship india logistics private limited',
    'Jai mata di transport service private limited',
    'Globus logisys private limited',
    'Nalwa logistics private limited',
    'Rr investor securities trading private limited',
    'Savitri holding private limited',
    'Fahmi communication private limited',
    'Prefer logistics private limited',
    'P t express lines private limited',
    'Heuristic communication private limited',
    'Fastway aerospace private limited',
    'Fastway shine star network private limited',
    'Abijai teleservices private limited',
    'Fastway citizen cable network private limited',
    'Fastway space satellite private limited',
    'Fastway shree neelkanth network private limited',
    'Monga telecom private limited',
    'Grep-tech solutions private limited',
    'Oxygen communications private limited',
    'Ponmala multitrading private limited',
    'Domo gadgets private limited',
    'Arcon powertrans private limited',
    'Parshuram bhikaji logistics private limited',
    'Kops outsourcing solutions private limited',
    'Rightex consultancy pvt ltd',
    'Stellarix consultancy services private limited',
    'IPE GLOBAL Limited',
    'Good times marketing private limited',
    'Thakkar manpower services pvt ltd',
    'T group solutions pvt. ltd.',
    'Jnr management resources pvt limited',
    'V b advisors private limited',
    'Samadhan management services private limited',
    'Sgk international private limited',
    'Acro hr solutions (india) private limited',
    'S m professional services private limited',
    'Saba corporate services private limited',
    'Smp advisory services private limited',
    'Samit econext private limited',
    'Kasa consultancy services private limited',
    'A s a p business advisory private limited',
    'Pure conference solutions private limited',
    'DAA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Nimbus consulting private limited',
    'Laburnum capital advisors private limited',
    'Fortuna public relations private limited',
    'Aravali logistics solutions private limited',
    'Elion technologies and consulting private limited',
    'India serves private limited',
    'Redrock fund advisors private limited',
    'Guardian india solutions private limited',
    'OT ENGINEERING PRIVATE LIMITED',
    'Kwaliteit de servici private limited',
    'Ida wealth management private limited',
    'Abconindia consultants private limited',
    'Higher edge consulting private limited',
    'Carnival consultants private limited',
    'Kites event management private limited',
    'Legend strategies private limited',
    'Educate artsome private limited',
    'Accunite solutions private limited',
    'Casa2 stays private limited',
    'Aqra water solutions private limited',
    'Brandbizz consultancy private limited',
    'Rolga consultancy services private limited',
    'Drishti consulltants private limited',
    'Shwetajigen investments services private limited',
    'Bhadra services private limited',
    'Arya biznet consultants private limited',
    'MARIS INDIA BPM PRIVATE LIMITED',
    'Jotwire india private limited',
    'Presta services private limited',
    'INTEGRATED PROPERTY SOLUTIONS PRIVATE LIMITED',
    'KP AND MB CONSULTANTS PRIVATE LIMITED',
    'Trainedge consulting private limited',
    'Thomas assessments private limited',
    'Nike sourcing india private limited',
    'Datamen consultants pvt ltd',
    'Samstha services private limited',
    'Burton consultants private limited',
    'N2n ingredients private limited',
    'Katalyst business accelerator services foundation',
    'Makers development services private limited',
    'DKIC PRIVATE LIMITED',
    'Sipra services and investments pvt ltd',
    'Kunal consultancy private limited',
    'Anu financial consultants private limited',
    'R. d. shah stock brokers private limited',
    'Kirtane pandit consulting private limited',
    'Dexterous solutions limited',
    'AIBARA PROPERTIES PRIVATE LIMITED',
    'Warburg pincus india private limited',
    'Saatvik management services private limited',
    'Ratan real estates services private limited',
    'Lift & shift india private limited',
    'Nouvasys solutions private limited',
    'Tangent international consultancy private limited',
    'GROUPE MRP INDIA PRIVATE LIMITED',
    'Marshall integrated services private limited',
    'DIVERSIFIED ENERGY SOLUTIONS PRIVATE LIMITED',
    'SMARTMANTRA FINANCIAL SERVICES PRIVATE LIMITED',
    'Secure energy services limited',
    'SARSA INVESTMENTS SERVICES LIMITED',
    'Maharshi commerce limited',
    'Hyderabad precisions manufacturing co pvt ltd',
    'Bodhi organizational & people development consultants private limited',
    'Perfomax consulting private limited',
    'Eila consulting private limited',
    'Changlin construction machinery india private limited',
    'Conquest quality systems services private limited',
    'Sks enterprises private limited',
    'Maknan consultancy private limited',
    'Metro facility management private limited',
    'ENCLOSURE WORLD INDIA PRIVATE LIMITED',
    'Square feet interiors private limited',
    'Globlink projects private limited',
    'M. p. shah engineering private limited',
    'Jeno maran associates private limited',
    'Kelvin consultants private limited',
    'Systra mva consulting (india) private limited',
    'S d architectural & designs private limited',
    'Raj fabcon interiors private limited',
    'Speed engineering solutions private limited',
    'Vajra diamond mining private limited',
    'Pro tex security services private limited',
    'Sona vets pvt ltd',
    'Gopinath dairy products private limited',
    'Tyohar foods private limited',
    'Bbq foods india private limited',
    'Imperial farms and resorts private limited',
    'Nostimia foods private limited',
    'Meghraj food processing (india) private limited',
    'Heena agriculture private limited',
    'Whiz foods private limited',
    'Bakers confectioneries private limited',
    'Nexus frozen fruits containers and foods private limited',
    'Pubs and allied beverage systems limited',
    'Nagar farms private limited',
    'Kodandaram roller flour mills private limited',
    'Mahadeovadi private limited',
    'Extrusions real estate pvt ltd',
    'Nalhati food products private limited',
    'Breadworks gourmet foods private limited',
    'SPAC STARCH PRODUCTS (INDIA) PRIVATE LIMITED',
    'Pnr nanda krishna eco farms private limited',
    'Homeland foods private limited',
    'Indus coffee private limited',
    'ECENTRIC DIGITAL LIMITED',
    'Saishakti housing limited',
    'India cocoa private limited',
    'Suga coco products private limited',
    'K.s.research farms pvt. ltd',
    'Nedspice processing india private limited',
    'Arya hybrid seeds limited',
    'Skylark feeds private limited',
    'Sentini bottling private limited',
    'Hce foods & beverages private limited',
    'S V SPIRITS PRIVATE LIMITED',
    'ALLIED BLENDERS AND DISTILLERS LIMITED',
    'Cil commodities private limited',
    'Jupiter aqua lines limited',
    'Shalimar agro tech private limited',
    'Sundrop foods india private limited',
    'Mukkadan plantation p ltd',
    'Kunal calcium ltd',
    'AAKAAR MARBLE',
    'S CHOICE SPIRITS PRIVATE LIMITED',
    'Wibhav non-woven products pvt ltd',
    'Huetrap clothing private limited',
    'Cosmo textorium private limited',
    'Aayush texfab private limited',
    'P a s cotton mills private limited',
    'Heinrich cycling and sports wear private limited',
    'S p spinning mills private limited',
    'Swapnil fabrics private limited',
    'Rasayan lifestyles private limited',
    'Bharti exim private limited',
    'Aayushi embroidery private limited',
    'Aner textiles private limited',
    'Uptown galeria clothing private limited',
    'Purnima spinners private limited',
    'Vibhatex fashions private limited',
    'V g textiles private limited',
    'Vepar designs private limited',
    'URJA PRODUCTS PRIVATE LIMITED',
    'Ess gee trendz private limited',
    'Komansu electronics private limited',
    'NARAYAN INDUSTRIES GLOBAL LIMITED',
    'Data nova india pvt ltd',
    'Silicom electronics private limited',
    'Interface devices india private limited',
    'Photonic system private limited',
    'Pdac microsystems private limited',
    'Simco auto limited',
    'K V SPORTS & WELLNESS PRIVATE LIMITED',
    'Joyful wears private limited',
    'Varalakshmi automobiles private limited',
    'Alive automotives private limited',
    'BHARAT SERUMS AND VACCINES LIMITED',
    'Transasia instruments limited',
    'General meditech devices private limited',
    'Pura-sys pharma private limited',
    'Ophthalmic marketing and services private limited',
    'Ar anaesthetics private limited',
    'Forbo siegling movement systems india private limited',
    'Dezire jewels private limited',
    'Siddhant diamonds p ltd',
    'Rajan jewellery and diamonds india private limited',
    'Green future windows private limited',
    'Jin aagam lifestyle solutions private limited',
    'Sentini artile private limited',
    'Pro-tech sports and safety products private limited',
    'Innomac healthcare equipments private limited',
    'STIC PENS PRIVATE LIMITED',
    'AVIVA WRITING PRODUCTS PRIVATE LIMITED',
    'A & t stationers private limited',
    'Indian writing instruments p ltd',
    'Iwi stationery private limited',
    'Mohan impressions pvt ltd',
    'Ferolite jointings limited.',
    'SIVANTHI JOE POLYMERS PRIVATE LIMITED',
    'Micromax energy limited',
    'Greenvolution eco services private limited',
    'Seven greens solar systems private limited',
    'SND TRADING PRIVATE LIMITED',
    'Tuticorin power company private limited',
    'Today power private limited',
    'Gill acqua hydro power generation company private limited',
    'Sare facility (omr) services private limited',
    'RIDDHI TRADE SOLUTIONS PRIVATE LIMITED',
    'Greenko rego hydro projects private limited',
    'Greenbrilliance energy private limited',
    'Avatar solar private limited',
    'Ren solar energy solutions private limited',
    'Solarcare (india) private limited',
    'Hira energy limited',
    'Aright green power private limited',
    'Supreme infra power d & t private limited',
    'P. k. infra and power company private limited',
    'Photon solar power private limited',
    'Sujana power (india) limited',
    'Akshaya solar power (india) private limited',
    'Sunil hitech energy private limited',
    'Greenko energies private limited',
    'Ravikiran power projects private limited',
    'GREENKO HIM KAILASH HYDRO POWER PRIVATE LIMITED',
    'GREENKO AT HYDRO PRIVATE LIMITED',
    'Isa power private limited',
    'Aspiration energy private limited',
    'Radhapuram wintech private limited',
    'Green strategy services private limited',
    'Apas water solutions private limited',
    'Tsi yatra private limited',
    'Malik infrastructure (india) private limited',
    'Kumar technobuild private limited',
    'Hira buildcon prvate limited',
    'Aks infratech (india) private limited',
    'Pragati buildwell private limited',
    'West-coast wind energy private limited',
    'Oasis propmart private limited',
    'Anand rathi power projects private limited',
    'DHAATURUTTAMA POWER & ISPAT PRIVATE LIMITED',
    'Edcl - arunachal hydro project private limited',
    'SAULESE ENERGIJA PRIVATE LIMITED',
    'Upt spares & services private limited',
    'Mercury infradev private limited',
    'Dhanraj builders private limited',
    'Red litchee realties private limited',
    'Goyal avenue private limited',
    'Sre india realfin private limited',
    'K.r.c. infraprojects private limited',
    'Mnt infratech private limited',
    'Ranchi developers private limited',
    'VADRAJ ENERGY (GUJARAT) LIMITED',
    'Sls constructions private limited',
    'Laveena properties private limited',
    'INFINIUM COMMUNICATION PRIVATE LIMITED',
    'Heeru corrosion protection services india private limited',
    'Rudraksh laminates private limited',
    'Maharashtra state police housing and welfare corpn ltd',
    'Doshi dyeing and printing works private limited',
    'Murliwala infrastructure private limited',
    'Prudent constructions private limited',
    'PHOENIX INDUSTRIES LIMITED',
    'Kabra estate p ltd',
    'Kalpak holiday resorts private limited',
    'V.VANG SOLUTIONS PRIVATE LIMITED',
    'Rational buildcon private limited',
    'Panama builders and developers private limited',
    'Vista hospitality services private limited',
    'Mansarovar heritage inn private limited',
    'Sws hospitality private limited',
    'Vera restaurants private limited',
    'B. M. INFOTRADE PRIVATE LIMITED',
    'Chhotabhai retailing india private limited',
    'Tlc getaways private limited',
    'Royal caterers private limited',
    'AMRITARA HOSPITALITY PRIVATE LIMITED',
    'Hotel swosti pvt ltd',
    'EXCELLENCY RESORTS PRIVATE LIMITED',
    'Indian tankers private limited',
    'Sarthak logistics private limited',
    'Pink feather hotels private limited',
    'Vahan motors private limited',
    'Jayaraj trucks & buses private limited',
    'Ez worldwide express private limited',
    'Girikand travels private limited',
    'Colonial gourmet foods private limited',
    'Devesh roadlines private limited',
    'Vinayak products private limited',
    'Vasudev adigas fastfood private limited',
    'Krbr overseas private limited',
    'Enerflo project combines private limited',
    'Bramha leisures private limited',
    'Malkera hotels and resorts private limited',
    'Tulip hotels private limited',
    'BLISSFUL FARMS & RESORTS PRIVATE LIMITED',
    'Srm hotels private limited',
    'M s v hotels private limited',
    'SONOTEL HOTELS & RESORTS PRIVATE LIMITED',
    'Indoceanic shipping company limited',
    'Equip engineers (india) private limited',
    'Prime shipping services (india) private limited',
    'Chennai international terminals private limited',
    'Sanghavi logistics private limited',
    'Sivanthi joe logistics private limited',
    'CHARLIE',
    'COUNCIL',
    'Synergy techno solutions private limited',
    'CINEYUG MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'Rajshri entertainment private limited',
    'Eros international films private limited',
    'Vincere arts and media private limited',
    'Novex communications private limited',
    'Ashirwad telenetwork private limited',
    'Nandini industries india private limited',
    'Impulse events and trade fairs private limited',
    'Mgs club one private limited',
    'New wadala sports club private limited',
    'PRIMOR PRIVATE LIMITED',
    'Akanksha global logistics private limited',
    'Boco tax-iq.in advisory services private limited',
    'Tupelo life india private limited',
    'Gms global solutions private limited',
    'Paniit alumni reach for india foundation',
    'Right labour contractors private limited',
    'Lifecycle career avenues private limited',
    'COSMOS MAYA INDIA PRIVATE LIMITED',
    'Advanced hair studio private limited',
    'Blueprint events & exhibitions private limited',
    'Indel automotives private limited',
    'Learning curve edutech solutions private limited',
    'Ow sports management private limited',
    'Eregnow.com private limited',
    'Rihita cargo forwarders private limited',
    'Oman india joint investment fund-trustee company private limited',
    'Space vision digital network private limited',
    'B v c logistics private limited',
    'Grishma constructions & trading private limited',
    'HERMINIO INDIA PRIVATE LIMITED',
    'Avendus capital private limited',
    'Uday contractors private limited',
    'Basf india limited',
    'Essar shipping limited.',
    'Shreyas shipping and logistics limited',
    'Aegis logistics limited',
    'Shriram asset management company limited',
    'Tips industries limited',
    'Zealousweb technologies private limited',
    'Icalibre info consultant private limited',
    'Upadpro software & services private limited',
    'Xerox india limited',
    'Valtech india systems private limited',
    'Vsm software private limited',
    'Entersoft systems private limited',
    'Quicklogic software (india) private limited',
    '3head design studio private limited',
    'Qantom software private limited',
    'Graymatter software services private limited',
    'Ngx technologies private limited',
    '3d concept analysis and development (india) private limited',
    'Openstrides software and solutions private limited',
    'Athinio data systems private limited',
    'Edcite learning private limited',
    'Sun bio it solutions private limited',
    'Isleen solutions private limited',
    'Pluribus networks india private limited',
    'Techciti technologies private limited',
    'Enkindle technologies private limited',
    'BYTESQUEUE TECHNOLOGIES PRIVATE LIMITED',
    'Ayansh technosoft private limited',
    'Goavega software india private limited',
    'Dabas technologies india private limited',
    'DBRAINS INFO SYSTEMS & CONTROLS PRIVATE LIMITED',
    'Avf distributors (india) private limited',
    'Pronto solutions india private limited',
    'Zeus systems private limited',
    'Seclore technology private limited',
    'Empronc solutions private limited',
    'Webstream communications private limited',
    'Dreamsoft it solutions private limited',
    'Sequel outsourcing private limited',
    'TAURIAN MINERALS PROCESSING PRIVATE LIMITED',
    'Caresoft consultancy private limited',
    'Bit mapper integration technologies private limited',
    'Cybernet it private limited',
    'VPR MARKSOFT SOLUTIONS PRIVATE LIMITED',
    'Pioneer integrated networks solutions private limited',
    'Tcd technologies private limited',
    'Erp analysts (india) private limited',
    'SUJA ASSOCIATES PRIVATE LIMITED',
    'Metrics4 analytics private limited',
    'Zenmonics software private limited',
    'COZY INFOSYSTEMS PRIVATE LIMITED',
    'Passionworks software private limited',
    'IQUANTI (INDIA) PRIVATE LIMITED',
    'Bizacuity solutions private limited',
    'Verudix solutions private limited',
    'Sysnet global solutions india private limited',
    'Coalesce technologies private limited',
    'Shrim soft private limited',
    'Ayan tech solutions private limited',
    'Aasan software private limited',
    'Amulya infotech india private limited',
    'Intuition elearning private limited',
    'Rolling arrays consulting private limited',
    'Univabs solutions private limited',
    'Salvage infotech (india) private limited',
    'Megneil tech private limited',
    'Cablecast new media private limited',
    'Sankhya analytical research private limited',
    'Finoit technologies (i) private limited',
    'SAAVN MEDIA LIMITED',
    'Media.net software services (india) private limited',
    'Pos nirvana private limited',
    'Numerix financial software (india) private limited',
    'P4d systems india private limited',
    'Brainvire infotech private limited',
    'CLEVERTAP PRIVATE LIMITED',
    'Karvy technologies private limited',
    'Beyond mobile services private limited',
    'Buxton consulting (india) private limited',
    'Chekhra business solutions private limited',
    'Innoppl technologies private limited',
    'Sthavir solution private limited',
    'Best itechpro private limited',
    'Medha it systems private limited',
    'Sysarc infomatix private limited',
    'Care info solutions private limited',
    'Sathyadeep engineering company limited',
    'Earlysail software private limited',
    'Tirth agro technology private limited',
    'Geepage (india) infosystem private limited',
    'Zeus inc private limited',
    'Pacecom technologies private limited',
    'Verisign services india private limited',
    'Central data systems private limited',
    'Ubix systems marketing private limited',
    'CA (INDIA) TECHNOLOGIES PRIVATE LIMITED',
    'Jdianm lighting private limited',
    'Wabot com (india) private limited',
    'Growthwell consulting private limited',
    'Mehta commodities pvt ltd',
    'Road infrastructure development company of rajasthan limited',
    'Satcom infratech private limited',
    'Apna ghar infrastructures india private limited',
    'M. v. omni projects (india) limited',
    'Jeedimetla residential homes private limited',
    'Hpr infra projects private limited',
    'Vaishnovi versatile ventures private limited',
    'Arihant industrial corporation limited',
    'Rainbow habitat private limited',
    'Highrise housing projects private limited',
    'Fernas construction india private limited',
    'Vijaylaxmi infra projects private limited',
    'Puranik buildcon private limited',
    'Tej kiran housing private limited',
    'Fortune square realtors private limited',
    'Scenic infra-projects private limited',
    'Scenic constructions private limited',
    'Periwinkle land developers private limited',
    'Deserve spaces private limited',
    'Arham builders private limited',
    'Buildmat developers pvt ltd',
    'Smtc infraprojects private limited',
    'Shivalik i.b. cars private limited',
    'RAJARSHI MILES PRIVATE LIMITED',
    'Pride pd wheels private limited',
    'Kataria cars private limited',
    'Shabbir and brothers trading private limited',
    'Vasant overseas private limited',
    'Trinity heights exim private limited',
    'Masara impex private limited',
    'Seven business ventures india private limited',
    'Solsol india private limited',
    'J.a. united exports private limited',
    'Manash lifestyle private limited',
    'Systematix distributions services private limited',
    'P s worldwide private limited',
    'OLATECH SOLUTIONS LIMITED',
    'Astrum electronics india private limited',
    'Wahid exports private limited',
    'Sarkar industries private limited',
    'Arshiya northern ftwz limited',
    'Topahead distributions private limited',
    'Bharat international pet foods private limited',
    'Praxis suppliers pvt.ltd.',
    'ICEBERG TRADE & COMMERCE IMF PRIVATE LIMITED',
    'AGROCORP INDIA TRADE SERVICES PRIVATE LIMITED',
    'Sunlit enterprises pvt ltd',
    'Raani oils private limited',
    'Mack star marketing private limited',
    'Alliance biomedica private limited',
    'D. navinchandra exports private limited',
    'Kaarya ethnic clothing (india) private limited',
    'Suripi textiles private limited',
    'Metasha enterprises pvt ltd',
    'Delta aircon private limited',
    'Fluidline systems & controls private limited',
    'Euronet services india private limited',
    'Mil laboratories private limited',
    'Gras impex private limited',
    'SAINI MICROELECTRONICS PRIVATE LIMITED',
    'Kaushal continental (india) private limited',
    'Crystal millennium merchandise private limited',
    'YAMHA TRADINGCOMPANY PRIVATE LIMITED',
    'Magal machine tools and accessories private limited',
    'Kotkar energy dynamics p ltd',
    'Skyking mercantile company private limited',
    'N jewellery techniques private limited',
    'Valencia leasing and infotech private limited',
    'Hisaria impex private limited',
    'FIREBELLY PROPERTIES LIMITED',
    'Staras seating private limited',
    'Ala international (india) private limited',
    'Ipsel entertainment private limited',
    'AGT FOODS INDIA PRIVATE LIMITED',
    'Bonisons exports private limited',
    'Prism intertrade (india) private limited',
    'Ram charan company private limited',
    'Himgiri castings pvt ltd',
    'Cocetra trade link private limited',
    'INSPA INTERIOR & EXTERIOR PRODUCTS PRIVATE LIMITED',
    'Cloud ecommerce private limited',
    'Phoenix comtrade private limited',
    'Ex-buzz fire & security private limited',
    'I p b dealers private limited',
    'KTK INFOTRONICS PRIVATE LIMITED',
    'Aussin intensive care private limited',
    'Anantco enterprises private limited',
    'K.v.p.fabs private limited',
    'Ruc industrial solutions private limited',
    'SHINESHILPI JEWELLERS PRIVATE LIMITED',
    'Carat lane trading private limited',
    'Quiosco retail india private limited',
    'Fore strategic security private limited',
    'Ramatara resorts private limited',
    'Avia villas private limited',
    'Gc international private limited',
    'Topworth urja & metals limited',
    'Shree bhimeshwari ispat private limited',
    'POPURI INDUSTRIES LIMITED',
    'D bros jewels private limited',
    'Callista creations private limited',
    'Golconda corrosion control private limited',
    'GOODRICH GASKET PRIVATE LIMITED',
    'Achieve techno cast private limited',
    'Japan india iron private limited',
    'Manis foundries private limited',
    'Mhitraa engineering equipments private limited',
    'Pha india private limited',
    'Pattern packagings private limited',
    'Amit plastopack technologies private limited',
    'Syndicate machines private limited',
    'SUNGWOO HITECH INDIA PRIVATE LIMITED',
    'Javeri tubes private limited',
    'G m flowtech private limited',
    'S.v.a. rikkon lubes private limited',
    'Rig tech (india) private limited',
    'Viva composite panel private limited',
    'Ashtron machinery private limited',
    'Oil control valves india private limited',
    'Perfect instrumentation control (india) private limited',
    'Nord drivesystems private limited',
    'Enerzi microwave systems private limited',
    'Rice lake weighing systems india limited',
    'Apf water systems private limited',
    'Filtertechniks private limited',
    'Turbocare technoservices private limited',
    'Hitek ventilation systems private limited',
    'Svenska intelly serve private limited',
    'Srushti tubes private limited',
    'Speedcrafts infratech private limited',
    'Mhwirth india private limited',
    'Megabound (india) private limited',
    'Middleby india engineering private limited',
    'Middleby celfrost innovations private limited',
    'Adair dutt instruments pvt ltd',
    'Supercut saws private limited',
    'Vipras visiontech private limited',
    'Community pure water india private limited',
    'Thai summit autoparts india private limited',
    'Highly electrical appliances india private limited',
    'Caliper brakes private limited',
    'BIESSE INDIA PRIVATE LIMITED',
    'Klad on design private limited',
    'A.eberle systems private limited',
    'Banner engineering india private limited',
    'Intact appliances private limited',
    'Tara relays private limited',
    'Beegees computers private limited',
    'R.m. computers private limited',
    'Procon technologies private limited',
    'Seleicon hi-tec electronic systems private limited',
    'Voltamp controls (india) private limited',
    'Ike electric private limited',
    'Megawin switchgear private limited',
    'South precision instrument private limited',
    'Leading edge systems private limited',
    'Vishay transducers india private limited',
    'FOCUS LIGHTING AND FIXTURES LIMITED',
    'Advanced chromatography technologies private limited',
    'Innov lite (india) private limited',
    'Indektra power solutions private limited',
    'Relco insulators private limited',
    'Fagor control systems private limited.',
    'D.b. electricals private limited',
    'Empire photovoltaic systems private limited',
    'V-pack automations private limited',
    'Taram engineering private limited',
    'Heba fire fighting systems india private limited',
    'Valid Technologies India Private Limited',
    'Ace antenna india private limited',
    'Shaf broadcast private limited',
    'Pall india private limited',
    'Schiller healthcare india private limited',
    'Camlens tech private limited',
    'Sentier consulting and healthcare private limited',
    'Lifeon labs private limited',
    'Bonsai babycare private limited',
    'Wanbury pharma limited',
    'Seiko watch india private limited',
    'Equity motors (rajkot) private limited',
    'Umicore autocat india private limited',
    'M.g.brothers automotives private limited',
    'Abc infra equipment private limited',
    'Premier conveyors private limited',
    'Roshan motors (jaipur) private limited',
    'Yapp india automotive systems private limited',
    'Lizlyn ship management private limited',
    'MARINETRANS INDIA LIMITED',
    'Bremskerl friction materials india private limited',
    'Brandmark solutions private limited',
    'Tgk special steel private limited',
    'Porto novo maritime limited',
    'Performance analyst private limited',
    'Amon engineers private limited',
    'Jbs clothing company limited',
    'Tempus fugit private limited',
    'Sociomantic labs private limited',
    'Omci rig technical & support services private limited',
    'Hanwha international india private limited',
    '200 not out cinemas private limited',
    'Teknowsource management consultants private limited',
    'Metal box property private limited',
    'Trustwell management services private limited',
    'Clique conbuild private limited',
    'Eak automobiles private limited',
    'Deccan environmental consultants private limited',
    'Doodle designs private limited',
    'Prgx india private limited',
    'Akshay microprocessors private limited',
    'Guardian homes private limited',
    'BHARATHIRE.COM PRIVATE LIMITED',
    'Custodial services india private limited',
    'Book connect tech solutions private limited',
    'Plant engtech private limited',
    'Chennai sinostar private limited',
    'REHOBOTH ENGINEERING AND CONTRACTORS PRIVATE LIMITED',
    'Inode talent institute private limited',
    'Nexwave talent management solutions private limited',
    'Rus education india private limited',
    'ARIHANT INSTITUTE LIMITED',
    'C s kids learning private limited',
    'Nano scientific research centre private limited',
    'PURELEARN EDUINFRA HYDERABAD PRIVATE LIMITED',
    'Ceo skill foundations private limited',
    'Skill training assessment management partners limited',
    'Sg academic establishments private limited',
    'NIYA LOGISTICS & AVIATION SKILL DEVELOPMENT TECHNOLOGY PRIVATE LIMITED',
    'White board ventures private limited',
    'Hara fitness international private limited',
    'Apex kidney care private limited',
    'Heidenhain optics & electronics india private limited',
    'Lakshmi organised care & united services private limited',
    'Kaypee electronics and associates private limited',
    'Kanakia medical services private limited',
    'R&h spa services private limited',
    'Datri blood stem cell donors registry',
    'Apex wellness medipharma private limited',
    'Avancer labs private limited',
    'Dr.modi`s karjat health resort limited',
    'Open seva education & healthcare foundation',
    'Pepper wellness private limited',
    'Livlife hospitals private limited',
    'Small and medium scale emulsion manufacturers association',
    'Performers syndicate limited',
    'Carnival films entertainment private limited',
    'Infinit technovision private limited',
    'Eros animation private limited',
    'Hhm events private limited',
    'SRIKANTH PRODUCTIONS PRIVATE LIMITED',
    'Aircheck india private limited',
    'CHANDRAMOHAN FOUNDATION',
    'Rose valley films limited',
    'Tsa promotions and events private limited',
    'Yo sports management private limited',
    'Asmi entertainments private limited',
    'Pench tiger retreat private limited',
    'PINK FOODS HOSPITALITY PRIVATE LIMITED',
    'Thulashi park international private limited',
    'Dorman long technology india private limited',
    'A2z support services private limited',
    'Sgk advisory services private limited',
    'First credit ites private limited',
    'Orcapod consulting services private limited',
    'Divine hr solutions private limited',
    'Lnp management consultants private limited',
    'Northstar technical services private limited',
    'Positive biosciences limited',
    'Janhit electoral trust.',
    'Shivas hair designers private limited',
    'Mp ensystems advisory private limited',
    'I9 communications private limited',
    'Wmart online services private limited',
    'Tra research private limited',
    'Aspire management solutions private limited',
    'Tata housing development company limited',
    'Kamal distributors private limited',
    'Kamal medico private limited',
    'NEW HEAVEN CHEMICALS AND INDUSTRIES LIMITED',
    'Vadilal chemicals limited',
    'Mindteck (india) limited',
    'Opal luxury time products limited',
    'Le waterina resorts & hotels limited.',
    'Bhagyodaya infrastructure development limited',
    'Ncbrain (india) software private limited',
    'Verity information solutions private limited',
    'Veritra it solutions private limited',
    'Altitud digitals india private limited',
    'Alpha cloud labs private limited',
    'Adata technology (india) private limited',
    'IVY MOBILITY SOLUTIONS PRIVATE LIMITED',
    'HATRO TECHNOLOGY PRIVATE LIMITED',
    'Echelon bpo pvt. ltd.',
    'Zymr systems private limited',
    'Logicalbit technologies private limited',
    'Mitoken solutions private limited',
    'MOVATE TECHNOLOGIES PRIVATE LIMITED',
    'Karanji infotech private limited',
    'Simpluris technologies private limited',
    'Didactics software rede private limited',
    'Avaali solutions private limited',
    'Ans e.construct engineers and developers international private limited',
    'Bitsnpixs technologies private limited',
    'ISHANYA INNOVATIONS PRIVATE LIMITED',
    'Syntel services private limited',
    'Samay infosolutions private limited',
    'S n a infotech private limited',
    'One two three greetings (india) private limited',
    'Kush infosystems private limited',
    'Highness microelectronics private limited',
    'KARMASOFTRA TECHNOLOGIES PRIVATE LIMITED',
    'Callstreet solutions india private limited',
    'Respondez bpo private limited',
    'Trinus solutions private limited',
    'Sharptech creative services private limited',
    'Alibaba.com india e-commerce private limited',
    'Noveline technologies private limited',
    'BSE TECH INFRA SERVICES PRIVATE LIMITED',
    'PENINSULA DATA SERVICES PRIVATE LIMITED',
    'GLOBAL IT & METAL PARK INDIA PRIVATE LIMITED',
    'Misys trade & risk management india private limited',
    'Fervid technology solutions private limited',
    'SPARKLINE EINS AUTOMATION PRIVATE LIMITED',
    'OPALFORCE SOFTWARE INDIA LIMITED',
    'S A TECH SOFTWARE INDIA LIMITED',
    'Progment software technologies private limited',
    'Kaarya consulting services private limited',
    'F1circle designs private limited',
    'Icon infotech services private limited',
    'Wild creek web studio private limited',
    'Hibrise technologies private limited',
    'Crayon data (india) private limited',
    'Grass roots research & creation (india) private limited',
    'Bejo sheetal bio-science foundation',
    'Global research & management services private limited',
    '4u facility management private limited',
    'Fortune accounting services private limited',
    'Indevia accounting private limited',
    'Erudite management solutions private limited',
    'V2 LIFESTYLES PRIVATE LIMITED',
    'Maddock films private limited',
    'PROTEK LOGISTICS (INDIA) PRIVATE LIMITED',
    'Imicl dighi maritime limited',
    'H and h precision private limited',
    'Thakkars stardom events private limited',
    'Top entertainment private limited',
    'KLEANO FINHOUSE SERVICES PRIVATE LIMITED',
    'Total talent solution private limited',
    'Worldwide clinical trials india private limited',
    'Comscore technologies india private limited',
    'Swift india domestic services private limited',
    'Mission energy foundation',
    'Blossom publications india limited',
    'Rise india solutions private limited',
    'Nakoder films private limited',
    'Dive safe subsea private limited',
    'Paddle point bpo services private limited',
    'Kji resources india private limited',
    'Pure clean & clear solutions india private limited',
    'Idea hippo ventures private limited',
    'CREDWIRE SOLUTIONS PRIVATE LIMITED',
    'GRAND TOURIO HOLIDAY SOLUTIONS PRIVATE LIMITED',
    'GRAVITY HOSPITALITY AND SERVICES PRIVATE LIMITED',
    'Jewelrich e-commerce private limited',
    'DIGIEXPRESS LOGISTICS PRIVATE LIMITED',
    'NAVIG8 INDIA PRIVATE LIMITED',
    'MOVIE TIME CINEMAS PRIVATE LIMITED',
    'ATTUNE MATRIMONIAL SERVICES PRIVATE LIMITED',
    'IMPLANTIUM INDIA PRIVATE LIMITED',
    'DAKSH FOUNDATION',
    'NUDGE LIFESKILLS FOUNDATION',
    'PARIJAT HOLDINGS PRIVATE LIMITED',
    'DB MOTORS PRIVATE LIMITED',
    'JINGO HOLIDAYS PRIVATE LIMITED',
    'DEEP AUTO ELECTRICALS PRIVATE LIMITED',
    'DQAP SYSTEMS PRIVATE LIMITED',
    'MUNAFA ENTERPRISES PRIVATE LIMITED',
    'CHIROM HOTELS PRIVATE LIMITED',
    'TRUE GREEN TECHNOLOGIES PRIVATE LIMITED',
    'SURFBOATS SOLUTIONS PRIVATE LIMITED',
    'SO THAI SPA PRIVATE LIMITED',
    'MANGAL ANALYTICS AND RESEARCH CONSULTING PRIVATE LIMITED',
    'PRIDE RECREATION PRIVATE LIMITED',
    'QCND PRIVATE LIMITED',
    'VICINITO TECHNOLOGIES PRIVATE LIMITED',
    'OURSPACE SOLUTIONS PRIVATE LIMITED',
    'INAVIT DIGITAL PRIVATE LIMITED',
    'RU4S KPO SERVICES PRIVATE LIMITED',
    'GENAU SYSTEMS PRIVATE LIMITED',
    'SP BEVCODE CONSULTANCY SERVICES PRIVATE LIMITED',
    'WOW ECARTS PRIVATE LIMITED',
    'FLEXI RENTAL SOLUTIONS PRIVATE LIMITED',
    'FUJIE BUSSAN INDIA PRIVATE LIMITED',
    'GROUPENT HOLIDAY INDIA PRIVATE LIMITED',
    'TRY FASHION PRIVATE LIMITED',
    'P3 MULTISOLUTIONS IT SERVICES PRIVATE LIMITED',
    'V QUOTIENT CONSULTING SERVICES PRIVATE LIMITED',
    'TIFO LEARNING SOLUTIONS PRIVATE LIMITED',
    'CLEVERIX EDUCATION PRIVATE LIMITED',
    'ADLAND MEDIA SERVICES PRIVATE LIMITED',
    'LARSUN INVENTURE PRIVATE LIMITED',
    'BOLDEN VENTURES PRIVATE LIMITED',
    'BRAND 13 PROMOTIONS PRIVATE LIMITED',
    'EXTENT MARKETING AND TECHNOLOGIES PRIVATE LIMITED',
    'TECHNEXA TECHNOLOGIES PRIVATE LIMITED',
    'IGNITER VACATIONS INDIA PRIVATE LIMITED',
    'Green Future Private Limited',
    'REACH INDIA PRIVATE LIMITED',
    'Treasure Vase Ventures Private Limited',
    'READY SET TRIP PRIVATE LIMITED',
    'Ray Travels India Private Limited',
    'YES ADVISORS PRIVATE LIMITED',
    'Collaboration People Technologies Private Limited',
    'JMC OVERSEAS PRIVATE LIMITED',
    'POLYOLS TECHNOLOGIES PRIVATE LIMITED',
    'SUPRATEEK FINVEST CONSULTANCY PRIVATE LIMITED',
    'Udaan Technologies Private Limited',
    'EASY CONNECT TRAVEL PRIVATE LIMITED',
    'MERRIDIAN WORLDWIDE LOGISTICS PRIVATE LIMITED',
    'MOVEX LINES PRIVATE LIMITED',
    'MARS INTERNATIONAL HOLIDAYS PRIVATE LIMITED',
    'GO PLANET TOURS INDIA PRIVATE LIMITED',
    'FASTWAY PANIPAT DIGITAL NETWORK PRIVATE LIMITED',
    'FASTWAY SONIPAT DIGITAL NETWORK PRIVATE LIMITED',
    'Delve InfoTechnologies Private Limited',
    'NetTech Infovision Private Limited',
    'MACMAKERS IT SERVICES PRIVATE LIMITED',
    'AHM DIGITAL NETWORK PRIVATE LIMITED',
    'HB SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'DREAMBRICKS DEVELOPERS PRIVATE LIMITED',
    'Novuse Internet Private Limited',
    'CONNAIZEN SOFTWARE PRIVATE LIMITED',
    'SOULILUTION IT SERVICES PRIVATE LIMITED',
    'VIROOPA SOFTECH PRIVATE LIMITED',
    'SureTek Infosoft Private Limited',
    'LUMAX MANAGEMENT SERVICES PRIVATE LIMITED',
    'INSTAMOD AIR PIPE PRIVATE LIMITED',
    'ARGO TRADING INDIA PRIVATE LIMITED',
    'VIBGYOR BROADCASTING PRIVATE LIMITED',
    'EUSTAN VENTURES PRIVATE LIMITED',
    'EMERGE 360 EFFICIENCY PRIVATE LIMITED',
    'Rational Cargo Care Private Limited',
    'IAE GLOBAL INDIA PRIVATE LIMITED',
    'ONE 21 TECH ITES PRIVATE LIMITED',
    '7HORSE TECHNOLOGIES PRIVATE LIMITED',
    'SMALL WORLD DIGITAL SERVICES PRIVATE LIMITED',
    'THEOCTOPUS BUSINESS SERVICES PRIVATE LIMITED',
    'REAL TIME NETWORKS PRIVATE LIMITED',
    'S.G. INSTRUMENTS PRIVATE LIMITED',
    'SMS FILTRON PRIVATE LIMITED',
    'PLAST ALLOYS (INDIA) LIMITED',
    'SHRI BHOLANATH INDUSTRIES LIMITED',
    'FIRST SHARE CARE LIMITED',
    'POORVA TRADING PRIVATE LIMITED',
    'REAL GROWTH SECURITIES PRIVATE LIMITED',
    'RVL FINANCE & INVESTMENTS PRIVATE LIMITED',
    'NETEDGE COMPUTING SOLUTIONS PRIVATE LIMITED',
    'A.U.S. FINANCE & INVESTMENTS PRIVATE LIMITED',
    'I. P. PASRICHA & CO CONSULTANTS PRIVATE LIMITED',
    'JACK MORRIS MEDIA PRIVATE LIMITED',
    'PHOTON COMPUTERS INDIA PRIVATE LIMITED',
    'AMBITIOUS PENS PRIVATE LIMITED',
    'WYZAX LABORATORIES PRIVATE LIMITED',
    'BEACON NEON SIGNS PRIVATE LIMITED',
    'NEOLITE ZKW LIGHTINGS PRIVATE LIMITED',
    'CONTITECH INDIA PRIVATE LIMITED',
    'D K PRINTWORLD PRIVATE LIMITED',
    'Smartivity Labs Private Limited',
    'OFL CAPITAL CORPORATION LIMITED',
    'BHARAT PRODUCTS LIMITED',
    'RISPANA LEASING FINANCE AND INVESTMENTS PRIVATE LIMITED',
    'SANT HARI METPRINT IMPEX PRIVATE LIMITED',
    'BESTWAY TOURS AND SAFARIS PRIVATE LIMITED',
    'ZOLLERN INDIA PRIVATE LIMITED',
    'Bobieri Creazon Fashion Accessories Private Limited',
    'UNICORP HOLIDAYS & BUSINESS TRAVEL PRIVATE LIMITED',
    'SANSKRITI HEALTHCARE PRIVATE LIMITED',
    'GOLDEN WINGS INTERNATIONAL TRAVELS PRIVATE LIMITED',
    'W3VILLA TECHNOLOGIES PRIVATE LIMITED',
    'FASTWAY FATEHABAD DIGITAL NETWORK PRIVATE LIMITED',
    'STRUTALENT SOLUTIONS PRIVATE LIMITED',
    'KAIRA INTERNATIONAL CONCEPTS PRIVATE LIMITED',
    'H. L. SOMANY FOUNDATION',
    'MICKEY MAYO INTERNATIONAL PRIVATE LIMITED',
    'ADIEU HOLIDAYS PRIVATE LIMITED',
    'Turnaround Corporate Advisors Private Limited',
    'GTM TECH PRIVATE LIMITED',
    'PINAKA SECURITY & ALLIED SERVICES PRIVATE LIMITED',
    'Zymbia Interactive Technologies Private limited',
    'KNEX Systems Private Limited',
    'Talocity InstaSolutions Private Limited',
    'FRANKFINN AVIATION SERVICES PRIVATE LIMITED',
    'STEELBIRD HI-TECH INDIA LIMITED',
    'SHREE IT MANAGEMENT AND SERVICES OPC PRIVATE LIMITED',
    '3ST TECHNOLOGIES PRIVATE LIMITED',
    'Doschemen Pharmaceuticals Private Limited',
    'FASTWAY GANPATI DIGITAL NETWORK PRIVATE LIMITED',
    'XAMAX ERGONOMICS PRIVATE LIMITED',
    'Pinnacle Mobile Services Private Limited',
    'MEDIRENT SERVICES PRIVATE LIMITED',
    'BDP HOLDINGS PRIVATE LIMITED',
    'KASTURI MEGAVENTURES PRIVATE LIMITED',
    'PACKPRINT SOLUTIONS PRIVATE LIMITED',
    'BHAGAT HOSPITALITIES PRIVATE LIMITED',
    'Splash India Private Limited.',
    'FIBRO GRATS PRIVATE LIMITED',
    'SHIVANI TRUCKING PRIVATE LIMITED',
    'KALYAN INFRATECH PRIVATE LIMITED',
    'SHRIKAMAL INFRASTRUCTURES PRIVATE LIMITED',
    'PRISM HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'RAMA POWER AND STEEL PRIVATE LIMITED',
    'PROTEC AQUA SOLUTIONS PRIVATE LIMITED',
    'KSHIPRA RESTAURANTS PRIVATE LIMITED',
    'Trumen Technologies Private Limited',
    'INKJET SOLUTIONS PRIVATE LIMITED.',
    'SRJ HEALTH CARE PRIVATE LIMITED',
    'RAVE INFOSYS PRIVATE LIMITED',
    'HARMAN COTTEX & SEEDS PRIVATE LIMITED',
    'YASHAS INFRASTRUCTURES PRIVATE LIMITED',
    'HETAL CONSULTANTS PRIVATE LIMITED',
    'FLAIR IT SOLUTIONS PRIVATE LIMITED',
    'NIKHIL CAPITAL AND CURRENCY PRIVATE LIMITED',
    'ANAND TOWNSHIP (INDORE) PRIVATE LIMITED',
    'MY STORE PRIVATE LIMITED',
    'Virtual Voyage Educational Services Private Limited',
    'APOLLO RAJSHREE HOSPITALS PRIVATE LIMITED',
    'SANMAN EXHIBITORS PRIVATE LIMITED',
    'SARVESHWARI STONE PRODUCTS PRIVATE LIMITED',
    'VINAYAK AUTOLINK PRIVATE LIMITED',
    'DRAVYA FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'SEROSOFT SOLUTIONS PRIVATE LIMITED',
    'VYANKATESH METALS AND ALLOYS PRIVATE LIMITED',
    'RAMPION NIRMAN PRIVATE LIMITED',
    'ROCK ENGINES PRIVATE LIMITED',
    'Mittal Udyog Indore Private Limited',
    'JABALPUR GARMENT AND FASHION DESIGN CLUSTER ASSOCIATION',
    'KALYAN KETI TOLL PRIVATE LIMITED',
    'OM SOFTWARE INTERNET SOLUTIONS PRIVATE LIMITED',
    'KHANDWA BIO-TECH PRIVATE LIMITED',
    'HINDUSTAN MINES PRIVATE LIMITED',
    'SHREE RAM PRODUCTS PRIVATE LIMITED',
    'JAI BHAWANI TRADING COMPANY PRIVATE LIMITED',
    'KESHAV INDUSTRIES PRIVATE LIMITED',
    'MARUCOM TELEVENTURES PRIVATE LIMITED',
    'RAJASTHAN PROPERTY BROKERS PRIVATE LIMITED',
    'Techinfini Solutions Private Limited',
    'INSTA POWER CONTROL AND EQUIPMENTS PRIVATE LIMITED',
    'AADARSH PRIVATE LIMITED',
    'Pure Oils and Products Limited',
    'SANSAI PROPERTIES & HOTELS PRIVATE LIMITED',
    'INFOGRAVITY CONSULTANCY SERVICES PRIVATE LIMITED',
    'ACCRUAL DEVELOPERS PRIVATE LIMITED',
    'THE GREAT LOGISTIC & PARKING SERVICES LIMITED',
    'NAMTEL TECHNOLOGIES PRIVATE LIMITED',
    'CHARTERED BUS PRIVATE LIMITED',
    'KETI TOLL INFRASTRUCTURE PRIVATE LIMITED',
    'CARE AGRI INFRASTRUCTURES PRIVATE LIMITED',
    'PREMSHREE PRIME PROPERTIES PRIVATE LIMITED',
    'HFC MARKETING AND ADVISORY LIMITED',
    'FCC ENTERPRISES & INFRASTRUCTURE PRIVATE LIMITED',
    'ZENSOFT TECHNOLOGIES PRIVATE LIMITED',
    'ZEFE LABS (I) PRIVATE LIMITED',
    'Century 21 Malls Private Limited',
    'LADHA REAL ESTATE PRIVATE LIMITED',
    'XCESS INFOSTORE PRIVATE LIMITED',
    'HINDUSTAN INFRATECH PRIVATE LIMITED',
    'R.M. SALES & SERVICES PRIVATE LIMITED',
    'PEARL BIO-SCIENCE',
    'SIZZLING FOODS (INDIA) PRIVATE LIMITED',
    'BARDIA TECHNOLOGY SYSTEMS PRIVATE LIMITED',
    'SNS System Private Limited',
    'CHAMELIDEVI FLOUR MILLS PRIVATE LIMITED',
    'WISCON PHARMACEUTICALS PRIVATE LIMITED',
    'VCC INFRASTRUCTURE PRIVATE LIMITED',
    'VASTU RACHANA ARCHDESIGN PRIVATE LIMITED',
    'ECLAT INFOTECH PRIVATE LIMITED',
    'Sejal Unexo Private Limited',
    'TECHVALENS SOFTWARE SYSTEMS PRIVATE LIMITED',
    'SURENDRA COMPOSITES PRIVATE LIMITED',
    'MAX REALMART PRIVATE LIMITED',
    'CASYON MULTI ELECTRONICS PRIVATE LIMITED',
    'SIENA INFOTAINMENT PRIVATE LIMITED',
    'POWER INTELLECTUAL ENGINEERING AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'Synques Consultancy Private Limited',
    'RESOTECH CONSULTANCY SERVICES PRIVATE LIMITED',
    'PAGE 3 DIGITAL MEDIA AND COMMUNICATIONS PRIVATE LIMITED',
    'KRYFS FABRICATIONS PRIVATE LIMITED',
    'KABEER LOGISTICS AND PROMOTERS PRIVATE LIMITED',
    'DELIGHT LIFELIKE PRODUCTS PRIVATE LIMITED',
    'SELECTUS MANPOWER SOLUTIONS PRIVATE LIMITED',
    'SWARNA FERTILIZER AND CHEMICALS PRIVATE LIMITED',
    'WE WIN LIMITED',
    'ITECH SOFTWARE SOLUTION PRIVATE LIMITED',
    'CHAHAT PROPERTIES PRIVATE LIMITED',
    'BANSAL AGRIFOOD INDIA PRIVATE LIMITED',
    'T. R. PROPERTIES PRIVATE LIMITED',
    'Suryavanshi Infrastructure Private Limited',
    'YOGESH REALTY PRIVATE LIMITED',
    'NYATI HOLDINGS PRIVATE LIMITED',
    'LAXYO ENERGY LIMITED',
    'SOCIETY OF COMMUNITY HEALTH ORIENTED OPERATIONAL LINKS',
    'VINSUN INFRA ENGINEERING PRIVATE LIMITED',
    'YOGISOFT TECHNOLOGIES PRIVATE LIMITED',
    'MODERN HOME COMFORTS PVT LTD',
    'SATYA SAI HOSPITAL AND INSTITUTE OF MEDICAL SCIENCE PRIVATE LIMITED',
    'PSR TRADING AND INVESTMENT PRIVATE LIMITED',
    'SIGMA ORGANICS AND CHEMICALS PRIVATE LIMITED',
    'RSA BUILDERS AND CONTRACTORS PRIVATE LIMITED',
    'COLOURS-OF-FUN ART MATERIALS PRIVATE LIMITED',
    'EXCLUSIVE INSURANCE BROKING SERVICES LIMITED',
    'OAK FINALEASE LIMITED',
    'DIDYMOUS PRIVATE LIMITED',
    'SUROM CONSTRUCTION PRIVATE LIMITED',
    'SEION WATERTECH PRIVATE LIMITED',
    'SARVESHWARI MINERALS PRIVATE LIMITED',
    'MAATESHWARI ALUMINIUM PRIVATE LIMITED',
    'UNIQUE SAWS AND MACHINERY PRIVATE LIMITED',
    'AGARWAL DAL MILLS PRIVATE LIMITED',
    'RAHUL PRECISION WORKS PRIVATE LIMITED',
    'ENTER 10 TELEVISION PRIVATE LIMITED',
    'MANGAL KAMNA REAL ESTATE (INDIA) PRIVATE LIMITED',
    'VIJAY MARBLES PRIVATE LIMITED',
    'SYSTANGO TECHNOLOGIES LIMITED',
    'SUPREMO INDIA PRIVATE LIMITED',
    'RAASVIN RUBBERS PRIVATE LIMITED',
    'NEBULA ADVERTISING PRIVATE LIMITED',
    'NAGRANI INDUSTRIES PRIVATE LIMITED',
    'B.R. GOYAL CONSTRUCTIONS PRIVATE LIMITED',
    'M.P. SAINIK COAL MINING PRIVATE LIMITED',
    'SHRI SHRISTI CONSTRUCTION PRIVATE LIMITED',
    'FLASH HERBAL AGRO PRIVATE LIMITED',
    'KRITI NUTRIENTS LIMITED',
    'PRIMEONE WORK FORCE PRIVATE LIMITED',
    'NIKHIL COMMODITY AND DERIVATIVES PRIVATE LIMITED',
    'ASCO CAPITAL PRIVATE LIMITED',
    'NAMAH EDUCATIONAL INSTITUTE PRIVATE LIMITED',
    'SM MILKOSE LIMITED',
    'SWASTIKA SECURITIES LIMITED',
    'RM AUTOLINK PRIVATE LIMITED',
    'BIDASARIA EXPORTS PVT LTD',
    'A.K.J.SECURITIES LIMITED',
    'SONIC BIOCHEM EXTRACTIONS PRIVATE LIMITED',
    'MANSHA PROFESSIONAL SERVICES PRIVATE LIMITED',
    'SATGURU SCHOOL LIMITED',
    'SWASTIK COAL CORPORATION PRIVATE LIMITED',
    'BHANDARI CONTROL AND ELECTRICALS PVT LTD',
    'INDORE TOOLS PRIVATE LIMITED',
    'CAP AND SEAL (INDORE) PRIVATE LIMITED',
    'FLAME REAL ESTATE PVT LTD',
    'TATA PRECISION INDUSTRIES (INDIA) LIMITED',
    'INDORE CNC PRIVATE LIMITED',
    'ALTRUIST GLOBAL HOLDINGS PRIVATE LIMITED',
    'SURYA INFRAVENTURE PRIVATE LIMITED',
    'MASAND AGRO EQUIPMENTS PVT LTD',
    'SHIV OFFSET (INDIA) PRIVATE LIMITED',
    'MODERN TECHNO PROJECTS PRIVATE LIMITED',
    'D.V.S.INFORMATICS PVT LTD',
    'PLM BUILDERS AND DEVELOPERS Private Limited',
    'JUNEJA CRANE SERVICES PVT LTD',
    'SHINTON CHEMICALS PVT LTD',
    'M.B.FOODS PVT LTD',
    'SHAKTI PUMPS (INDIA) LIMITED',
    'RAJRATAN INVESTMENTS PRIVATE LIMITED',
    'INDO THAI SECURITIES LIMITED',
    'SHANKAR THREADS PRIVATE LIMITED',
    'Aakash Global Foods Private Limited',
    'ANUROOP ESTATE AND FINVEST PRIVATE LIMITED',
    'J.S. BASE COMPUTERS PRIVATE LIMITED',
    'GLOBAL MEGA VENTURES PRIVATE LIMITED',
    'STEEL AUTO CAST PRIVATE LIMITED',
    'SMRITI TELEVISION MEDIA AND FILMS PRIVATE LIMITED',
    'RADIUS ESTATE AND FINVEST PRIVATE LIMITED',
    'EXUVIT HEALTHCARE PRIVATE LIMITED',
    'CSI LOGISTICS PRIVATE LIMITED',
    'DEFRAIL COMPOSITES PRIVATE LIMITED',
    'CLEAR IMAGING MEDICAL SYSTEMS PRIVATE LIMITED',
    'MADHYA PRADESH POORV KSHETRA VIDYUT VITARAN COMPANY LIMITED',
    'MADHYA PRADESH PASCHIM KSHETRA VIDYUT VITARAN COMPANY LIMITED',
    'ABN EQUIPMENTS AND SYSTEMS PRIVATE LIMITED',
    'PSPL ADVERTISING PRIVATE LIMITED',
    'DIVYA INFRA DEVELOPERS PRIVATE LIMITED',
    'ARPIT CARRIERS PRIVATE LIMITED',
    'E.M.ELECTRO - MECHANICALS PRIVATE LIMITED',
    'OSMED FORMULATIONS PRIVATE LIMITED',
    'NEEL BLEACH PRIVATE LIMITED',
    'UNIVIVE HEALTHCARE PRIVATE LIMITED',
    'TARTE ENGINEERS PRIVATE LIMITED',
    'MAHAKALI FOODS PRIVATE LIMITED',
    'TWENTY FIRST CENTURY TECHNOPRODUCTS PVT LTD',
    'BHASIN PACKWELL PVT LTD',
    'NAIDUNIA INVESTMENTS PVT LTD',
    'DKJ CORPORATE AND FINANCE SERVICES PVT LTD',
    'KEHEMS TECHNOLOGIES PRIVATE LIMITED',
    'MALWA MEDINEED PRIVATE LIMITED',
    'GEI POWER LIMITED',
    'JAJOO SURGICALS PRIVATE LIMITED',
    'AGARWAL REAL CITY PRIVATE LIMITED',
    'ZUNCH WEB MARKETING SERVICES PRIVATE LIMITED',
    'ITSC TECHNOLOGIES PRIVATE LIMITED',
    'MANGIRISH TRADING AND INVESTMENT PRIVATE LIMITED',
    'STONE N STYLE PRIVATE LIMITED',
    'VINAYAK FINMAN PRIVATE LIMITED',
    'MADHYACHAL REAL ESTATE PRIVATE LIMITED',
    'SHUBHLAABH REALINVEST PRIVATE LIMITED',
    'EMPOWER INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'SUN ULTRA TECHNOLOGIES PRIVATE LIMITED',
    'MARCHING ANTS HOSPITALITY PRIVATE LIMITED',
    'Srijan Logistics India Private Limited',
    'CLUMPLING TECHNOLOGIES PRIVATE LIMITED',
    'CONTINENTAL HOLIDAY PRIVATE LIMITED',
    'MINERVA ONLINE EDUCATION PRIVATE LIMITED',
    'DEBBAS LIGHTING INDIA PRIVATE LIMITED',
    'Serigold 79 Technology Private Limited',
    'MUSTANGS E-SERVICES PRIVATE LIMITED',
    'TELEGENCE POWERCOMM PRIVATE LIMITED',
    'ASSIST CLICK PRIVATE LIMITED',
    'C P CAREERS PRIVATE LIMITED',
    'DBL MUNDI-SANAWAD TOLLWAYS PRIVATE LIMITED',
    'PATNA PETROCHEMICALS PRIVATE LIMITED',
    'DEACON INFRATEL PRIVATE LIMITED',
    'Sealink private limited',
    'SIRONA HYGIENE PRIVATE LIMITED',
    'INDIA INCOMING VACATIONS PRIVATE LIMITED',
    'INTRICATE RESEARCH PRIVATE LIMITED',
    'Credent Cold Chain Logistics Private Limited',
    'SHANNEN CONSULTANTS PRIVATE LIMITED',
    'Alpere Technologies Private Limited',
    'LIGHTENUP DISTRIBUTION AND RETAIL PRIVATE LIMITED',
    'AARK INVESTMENTS AND MANAGEMENT PRIVATE LIMITED',
    'Arystar Technology Private Limited',
    'TREEFROGS COMMUNICATION SERVICES PRIVATE LIMITED',
    'FAAD NETWORK PRIVATE LIMITED',
    'IRAYO TECHNOLOGIES PRIVATE LIMITED',
    'India Fertility Solutions Private Limited',
    'Ammaiya Services Private Limited',
    'VARUN PROCON PRIVATE LIMITED',
    'MALWA VEHICLES PVT LTD',
    'ANDRITZ HYDRO Private Limited',
    'EAGLE SEEDS AND BIOTECH LIMITED',
    'MUNDRA SOLAR LIMITED',
    'YELLOW 2 GEN ENERGY PRIVATE LIMITED',
    'TRADESMAN SERVICES (INDIA) PRIVATE LIMITED',
    'RKGA CONSULTANTS PRIVATE LIMITED',
    'AKPASH PHARMACEUTICALS PRIVATE LIMITED',
    'VELOCITY BRAND SERVER PRIVATE LIMITED',
    'INDOTECH INDUSTRIES (I) PRIVATE LIMITED',
    'ZoloStays Property Solutions Private Limited',
    'APP INTEGRATORS IT PRIVATE LIMITED',
    'Emagine International IT Private Limited',
    'JENNEX GRANITE INDUSTRIES PRIVATE LIMITED',
    'B C TECHNOMATION PRIVATE LIMITED',
    'SURANA ESTATE AND COMMODITY TRADING PRIVATE LIMITED',
    'TECHFORCE COMPOSITES PVT LTD',
    'KAILASH TRANSFORMERS PRIVATE LIMITED',
    'KUBER IMPEX LIMITED',
    'SUPRIM CEMENT PRIVATE LIMITED',
    'PUMIK ENGINEERING COMPONENTS PRIVATE LIMITED',
    'MANAS LABS PRIVATE LIMITED',
    'AOR LOGISTICS PRIVATE LIMITED',
    'BEMAC Research India Private Limited',
    'CROSSPOLE LOGISTICS PRIVATE LIMITED',
    'KUGD SERVICES PRIVATE LIMITED',
    'CIT INFRATEL PRIVATE LIMITED',
    'Seclude Hospitality Private Limited',
    'NARMADA TRAUMA CENTRE PRIVATE LIMITED',
    'NAMAN HANDICRAFTS PRIVATE LIMITED',
    'MOJOLAND INDIA LIMITED',
    'BOHEMIA BEER PRIVATE LIMITED',
    'IMPENDI ANALYTICS INDIA PRIVATE LIMITED',
    'SPN INFOSOL PRIVATE LIMITED',
    'LIVENUTRIFIT HEALTHTECH PRIVATE LIMITED',
    'ADS TRIANGLE PRIVATE LIMITED',
    'Growth Market Intelligence Private Limited',
    'HCL TRAINING & STAFFING SERVICES PRIVATE LIMITED',
    'KhauGaliDeals Private Limited',
    'Devil On Wheels (OPC) Private Limited',
    'NOR BLACK NOR WHITE PRIVATE LIMITED',
    'IMAGINNOVATIVE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'Complete HEOR Solutions India Private Limited',
    'SHUBHIKA TECHNOLOGIES PRIVATE LIMITED',
    'Energos Services India Private Limited',
    'UNISTAR SOFTECH PRIVATE LIMITED',
    'SolaOz Energy private Limited',
    'S&P ELECINFRA PRIVATE LIMITED',
    'ADAPIRT TECHNOLOGIES PRIVATE LIMITED',
    'EFFIVITY TECHNOLOGIES PRIVATE LIMITED',
    'SANDESH DIGITAL PRIVATE LIMITED',
    'UNIPRO TECHNOCRATS PRIVATE LIMITED',
    'NEOTIGHT ENGINEERING SERVICES PRIVATE LIMITED',
    'SHREE RAMKRISHNA KNOWLEDGE FOUNDATION',
    'MHS PORTFOLIO MANAGEMENT PRIVATE LIMITED',
    'CRESCENT DATA TECHNOLOGIES PRIVATE LIMITED',
    'VENUS POWER PROJECTS PRIVATE LIMITED',
    'WOTU TECHNOLOGIES PRIVATE LIMITED',
    'Vyshleski Technology Labs Private Limited',
    'GUIDING MEDIA PRIVATE LIMITED',
    'MOBILISE COMMUNICATIONS PRIVATE LIMITED',
    'JUPITOR TECHNOLOGY PRIVATE LIMITED',
    'EOMNICARE PRIVATE LIMITED',
    'VELOCE TECH INFORMATION PRIVATE LIMITED',
    'PRASHA CONSULTANCY SERVICES PRIVATE LIMITED',
    'Indus Intellirisk & Intellisense Services Private Limited',
    'J M Exports Private Limited',
    'Pluskart Healthcare Services Private Limited',
    'BROWN BIRD CONSULTING PRIVATE LIMITED',
    'SIYANA INFO SOLUTIONS PRIVATE LIMITED',
    'GRAPHX TECHSTUDIO PRIVATE LIMITED',
    'MONEYMINE PROFESSIONAL SERVICES PRIVATE LIMITED',
    'KAMUTHI RENEWABLE ENERGY LIMITED',
    'ONE DEVELOPERS PRIVATE LIMITED',
    'KYROS IT SERVICES PRIVATE LIMITED',
    'ORMEAL FOODS PRIVATE LIMITED',
    'INPLENION CONSULTING SERVICES PRIVATE LIMITED',
    'VIVARNA POWER PRIVATE LIMITED',
    'ALISHA PNEUMATICS INDIA PRIVATE LIMITED',
    'RSPL GLOBAL SERVICES PRIVATE LIMITED',
    'LORVEN EARTHLINKS PRIVATE LIMITED',
    'PHOENIX LOGISTICS INDIA PRIVATE LIMITED',
    'PRECEDE WORKFORCE SOLUTIONS INDIA PRIVATE LIMITED',
    'ASA DIAGNOSTICS PRIVATE LIMITED',
    'CAPEDGE ENERGY PRIVATE LIMITED',
    'CAPEDGE METALS & MINERALS PRIVATE LIMITED',
    'LITTLESHOWS MEDIA PRIVATE LIMITED',
    'K S WIND & RENEWABLES INDIA PRIVATE LIMITED',
    'THE CONCEPT HOUSE INDIA PRIVATE LIMITED',
    'Avancer Software Solutions Private Limited',
    'GORANTLA SYSTEMS INDIA PRIVATE LIMITED',
    'Nilah Energy Private Limited',
    'TRONX MOTORS PRIVATE LIMITED',
    'METAMORPHOSIS ENGINEERING AND SKILL DEVELOPMENT SERVICES (OPC) PRIVATE LIMITED',
    'APOLLO SHINE FOUNDATION',
    'MAAN TECH - INFRA PRIVATE LIMITED',
    'TSP Consultancy Services Private Limited',
    'Big Laundry Services Private Limited',
    'IHR OUTSOURCING AND SOLUTIONS PRIVATE LIMITED',
    'JOVI VENTURES PRIVATE LIMITED',
    'BMTG Advisors India Private Limited',
    'FINOCULUS SOFTWARE INDIA PRIVATE LIMITED',
    'DSK SCIENCE SOLUTIONS PRIVATE LIMITED (OPC)',
    'AIYER SHIPPING AGENCY PRIVATE LIMITED',
    'HW DESIGN LABS PRIVATE LIMITED',
    'NEROCA Football Club Private Limited',
    'Knoctowl Technologies Private Limited',
    'Nimesh Energy Solutions Private Limited',
    'DRON DEF INDUSTRIES PRIVATE LIMITED',
    'To Be Healthy Foods Private Limited',
    'TAS TEXTILES INDIA PRIVATE LIMITED',
    'Atman Creative and Knowledge Development Foundation',
    'NIF CASTING PRIVATE LIMITED',
    'FARM FETCH PRIVATE LIMITED',
    'GREENKO OMC RENEWABLE ENERGY PRIVATE LIMITED',
    'PRR CARGO EXPRESS PRIVATE LIMITED',
    'CEESARK TECHVENTURES INDIA PRIVATE LIMITED',
    'Wonder Projects Development Private Limited',
    'ERUDORE ADVISORS PRIVATE LIMITED',
    'YSA BIOTEC PRIVATE LIMITED',
    'MECKLAI DIGITAL PRIVATE LIMITED',
    'Glider Buildcon Realtors Private Limited',
    'KASPER INFRASTRUCTURE PRIVATE LIMITED',
    'MEDALL SCANS AND LABS RANCHI PRIVATE LIMITED',
    'SATTVIC ROASTED PRIVATE LIMITED',
    'UNITED ROCKSTONES PRIVATE LIMITED',
    'Physio Care Private Limited',
    'MASK INFRASTRUCTURE PRIVATE LIMITED',
    'ESCO SYSTEMS PRIVATE LIMITED',
    'Allwin CNC Machinery Private Limited',
    'CEM Brand Capita Private Limited',
    'Kiara Global Services Private Limited',
    'GODREJ FUND MANAGEMENT AND INVESTMENT ADVISERS PRIVATE LIMITED',
    'Keyplease Hospitality Services Private Limited',
    'AMAZE HEALTHCARE PRIVATE LIMITED',
    'Classic Legends Private Limited',
    'GEVASOL INDUSTRIES PRIVATE LIMITED',
    'KOHINOOR TYRES PRIVATE LIMITED',
    'Z3 GLOBAL CONSULTING PRIVATE LIMITED',
    'SUPER DIAMOND PROCESSORS PRIVATE LIMITED',
    'TECH OPPORTUNITY PRIVATE LIMITED',
    'RUNWAY LIFESTYLE EVENTS PRIVATE LIMITED',
    'VIPRE SG INDIA PRIVATE LIMITED',
    'WEST COAST TRUCKING PRIVATE LIMITED',
    'Raftaar Technologies Private Limited',
    'TRIDHAATU ABODES PRIVATE LIMITED',
    'RELIABLE GALAXY FACILITY SERVICES PRIVATE LIMITED',
    'Mahagram Payments Private Limited',
    'LLAMA LOGISOL PRIVATE LIMITED',
    'FEYNMAN INNOVATIONS PRIVATE LIMITED',
    'Nutrizo Wellness Private Limited',
    'O',
    'S INDIA PRIVATE LIMITED',
    'MCHK REAL ESTATE PRIVATE LIMITED',
    'MDN Fusion India Private Limited',
    'MAXONIC CONSULTING PRIVATE LIMITED',
    'MAXWELL INFOTECH LIMITED',
    'MEDHA IMPEX PRIVATE LIMITED',
    'MAXWELL TOWN PLANNERS INDIA PRIVATE LIMITED',
    'MEDICOTRANS PRIVATE LIMITED',
    'PYRAMID WINES PRIVATE LIMITED',
    'VORA KOTHARI PVT LTD',
    'STERLING AND WILSON Private Limited',
    'LIBERTY EXPORTS PRIVATE LIMITED',
    'SKYPACK TRAVELS PRIVATE LIMITED',
    'ALLANA COLD STORAGE Private Limited',
    'MediaTek India Technology Private Limited',
    'MEDICO ELECTRODES INTERNATIONAL LIMITED',
    'STATFIELD EQUIPMENTS PVT LTD',
    'MEDYSKY PRIVATE LIMITED',
    'MEENAKSHI POLYMERS PRIVATE LIMITED',
    'Meenakshy Agri & Eco Tourism Private Limited',
    'Meenakshy Cashew Private Limited',
    'KRAIBURG TPE PRIVATE LIMITED',
    'LOGIN BUSINESS SOLUTIONS PRIVATE LIMITED',
    'LOGIN WEB SERVICES PRIVATE LIMITED',
    'MATRI ESTATES PRIVATE LIMITED',
    'MAVERICK HOSPITALITY PRIVATE LIMITED',
    'MAVIKA ESTATE CREATORS PRIVATE LIMITED',
    'MBC BUSINESS CONSULTANTS AND TRADING PRIVATE LIMITED',
    'MBC GLOBAL ADVISORY SERVICES INDIA PRIVATE LIMITED',
    'MBD WORLDWIDE PRIVATE LIMITED',
    'MDS INFRAPROJECTS PRIVATE LIMITED',
    'Mechel Somani Carbon Private Limited',
    'Medhavi Professional Services Private Limited',
    'MEDI TREE INFRASTRUCTURE LIMITED',
    'MARUDHAR INVESTMENT PVT LTD',
    'MARUDHAR THEATER PRIVATE LIMITED',
    'GRAND FOUNDRY LIMITED',
    'TARIERO INDIA PRIVATE LIMITED',
    'SPACE AGE ENGINEERING AND CHEMCIAL PRIVATE LIMITED',
    'PANCHGANGA INFRA PRIVATE LIMITED',
    'MEDIUM PACKAGING PRIVATE LIMITED',
    'Sonmil Industries Private Limited',
    'MEERA AND COMPANY LIMITED',
    'MEERA RESCUE SERVICES PRIVATE LIMITED',
    'MEGA CABS LIMITED',
    'MEGA GRAIN TRADING COMPANY PRIVATE LIMITED',
    'MAYFLOWER MANAGEMENT SERVICES PRIVATE LIMITED',
    'MELANGE COUTURE PRIVATE LIMITED',
    'MELAR AGRO FOOD PRIVATE LIMITED',
    'MAYOUR SANITARY HOUSE PRIVATE LIMITED',
    'MAYUR REALTORS PRIVATE LIMITED',
    'MAYUR VISION PRIVATE LIMITED',
    'MAYURATH FILMS PRIVATE LIMITED',
    'MENTIS INFOCOM PRIVATE LIMITED',
    'MEGHNA AUTOWORKS PRIVATE LIMITED',
    'MERCANTILE CAPITALS AND FINANCIAL SERVICES PRIVATE LIMITED',
    'MIDAS GLOBAL MARITIME PRIVATE LIMITED',
    'MERIDIAN SOLUTIONS PRIVATE LIMITED',
    'MEGRIAR ASSOCIATES PRIVATE LIMITED',
    'METAL BOX INDIA LIMITED (WEST BENGAL TO DELHI)',
    'Metal One Corporation India Private Limited',
    'MEHINDER PROPERTIES PRIVATE LIMITED',
    'LOW & BONAR INDIA PRIVATE LIMITED',
    'MEHRAULI LAND AND PROPERTIES PRIVATE LIMITED',
    'METALORE OVERSEAS PRIVATE LIMITED',
    'METALSA INDIA PRIVATE LIMITED',
    'METALTECH DESIGN PRIVATE LIMITED.',
    'METIS MARKETING SERVICES PRIVATE LIMITED',
    'METLLOY OVERSEAS PRIVATE LIMITED',
    'LOTUS PRINTERS PRIVATE LIMITED',
    'METTEL ESTATES PRIVATE LIMITED',
    'METTLESOME SHIPPING & LOGISTIC SERVICES PRIVATE LIMITED',
    'SFC SOLUTIONS INDIA (SEALING) PRIVATE LIMITED',
    'M S P EXPORTS PRIVATE LIMITED',
    'M S P SPICES PRIVATE LIMITED',
    'MACS MAX PRIVATE LIMITED',
    'MALNAD BUILDERS PRIVATE LIMITED',
    'RITES SYSTEMS PRIVATE LIMITED',
    'MGF AUTO LOGISTICS PRIVATE LIMITED',
    'MGF AUTO VENTURES INDIA PRIVATE LIMITED',
    'MGF VEHICLE SALES PRIVATE LIMITED',
    'MI INDUSTRIES (INDIA) PRIVATE LIMITED',
    'MI MYSOLAR24 PRIVATE LIMITED',
    'ARGUS INVESTMENTS PRIVATE LIMITED',
    'NAVIN FRESH MUSHROOMS PRIVATE LIMITED',
    'MANDC EXPORT INDUSTRIES LIMITED',
    'MEK STRUCTURAL ENGINEERING PRIVATE LIMITED',
    'MICROSOFT CORPORATION (INDIA) PVT LTD',
    'MICROSOFT GLOBAL SERVICES CENTER (INDIA) PRIVATE LIMITED',
    'MICROSOFT INDIA (R&D) PRIVATE LIMITED',
    'MICROSOFT RESEARCH LAB INDIA PRIVATE LIMITED',
    'MEKANO ENGINEERING PRIVATE LIMITED',
    'ALL INDIA REPORTER ENGINEERING COMPANY PRIVATE LIMITED',
    'MEKASTER TOOLS LIMITED',
    'MANIPAL PRESS PRIVATE LIMITED',
    'Melimu Edutech Private Limited',
    'PARAMOUNT BLANKETS PRIVATE LIMITED',
    'ONWARD LOGISTICS LIMITED',
    'PACE EDUCATION AND FINANCIAL SERVICES PRIVATE LIMITED',
    'PACE INDUSTRIES PRIVATE LIMITED',
    'PADMAHASTA WAREHOUSING PRIVATE LIMITED',
    'A N J MARKETING PRIVATE LIMITED',
    'PAGE ADVERTISING AND COMMUNICATIONS PRIVATE LIMITED',
    'PAHARPUR INDUSTRIES LIMITED',
    'PARAS LABEL (INDIA) PRIVATE LIMITED',
    'PARAS MERCANTILE LIMITED',
    'NEHAL IMPORTS PVT LTD',
    'SHREE VENKATESH SHIPPING SERVICES PRIVATE LIMITED',
    'KARMIK DESIGNS PVT LTD',
    'SPEECH 2 TEXT MEDICAL SOLUTIONS (INDIA) PVT LTD',
    'SREE SUGAVANESHWARA KNITTING CO PRIVATE LIMITED',
    'Parijat Innovations Private Limited',
    'PARITOSH ESTATES PRIVATE LIMITED',
    'SREE VALLIAPPA INVESTMENTS PRIVATE LIMITED',
    'PARK INFRASTRUCTURE LIMITED',
    'PARK LAND CONSTRUCTION AND EQUIPMENTS LIMITED',
    'PARK MEDICLAIM INSURANCE TPA PRIVATE LIMITED',
    'PARK VIEW PROMOTERS PRIVATE LIMITED',
    'PANAMA POLY PRODUCTS PRIVATE LIMITED',
    'OYSTER MARKETING PRIVATE LIMITED',
    'PARMA AND PARMA (INDIA) PVT LIMITED',
    'PARMA ELECTRONICS PRIVATE LIMITED',
    'P C FINANCIAL SERVICES PRIVATE LIMITED',
    'PANCHAL MANUFACTURING CO PRIVATE LIMITED',
    'PANCHVATI PLANTATIONS PRIVATE LIMITED',
    'PARMESHWAR PROMOTERS PRIVATE LIMITED',
    'PANKAJ CONTINENTAL PRIVATE LIMITED',
    'PARTH POLYCRAFT PRIVATE LIMITED',
    'PASCO HOTELS PRIVATE LIMITED',
    'PASCO MOTELS PRIVATE LIMITED',
    'PANKAJ GLASS WORKS LIMITED',
    'PANTHER ESTATES PRIVATE LIMITED.',
    'Pasithea Infrastructure Limited',
    'PASONDA TEXTILE INDUSTRIES PVT LTD',
    'PARAMOUNT GLOBAL PRIVATE LIMITED',
    'Passi HealthCom Private Limited',
    'PASSION BUILDCON PRIVATE LIMITED',
    'PASSION SOFT SOLUTIONS PRIVATE LIMITED',
    'Passion Trail Limited',
    'Passionate Foods Private limited',
    'PARAMOUNT IMPEX PRIVATE LIMITED',
    'EUROTEX INDUSTRIES AND EXPORTS LIMITED',
    'PITTIE SOLAR PRIVATE LIMITED',
    'STARCOM INFORMATION TECHNOLOGY LIMITED',
    'PARAS EQUIPMENTS AND ENGINEERING PRIVATE LIMITED',
    'SMARTAI INDIA PRIVATE LIMITED',
    'PAUK HYDRO POWER PRIVATE LIMITED',
    'PAUL & COMPANY (INDIA) PRIVATE LIMITED',
    'PARDESH AGENCIES PRIVATE LIMITED',
    'PAUL SALES PRIVATE LIMITED',
    'KOREGAON CONSTRUCTIONS PVT LTD',
    'PARDESH EXPORTS PRIVATE LIMITED',
    'PARDUS CONSULTANTS PRIVATE LIMITED',
    'PARI MECHATRONICS PRIVATE LIMITED',
    'PARIVESH DEVELOPERS AND BUILDERS PRIVATE LIMITED',
    'PARKER CHEM PRIVATE LIMITED',
    'PAMSKI PROJECTS PRIVATE LIMITED',
    'Pay Mek Consultants Private Limited',
    'PARKLAND ESTATES PRIVATE LIMITED',
    'PAYAL PETROPACK PRIVATE LIMITED',
    'PAYAL POLYCOMPOUNDS PRIVATE LIMITED',
    'PAYARD INVESTMENTS PRIVATE LIMITED',
    'PANASIAN CONSTRUCTION COMPANY PRIVATE LIMITED',
    'PANASONIC CONSUMER INDIA PRIVATE LIMITED',
    'Parmida Properties Limited',
    'PC JEWELLER LIMITED',
    'PARRAGON PUBLISHING (INDIA) PRIVATE LIMITED',
    'PARSHWA ACCESSORIES PRIVATE LIMITED',
    'PCM Chemical India Private Limited',
    'PD COMPUTERS PRIVATE LIMITED',
    'PDS LIMITED',
    'PE Consulting Investintoindia Private Limited',
    'PASCO SOFTWARE I PARK PRIVATE LIMITED',
    'PEAK INFRATECH PRIVATE LIMITED',
    'PEAK PLASTONICS PRIVATE LIMITED',
    'PEAK SECURITIES PRIVATE LIMITED',
    'PASHUPATI IMPORTS PRIVATE LIMITED',
    'PEARL BEVERAGES LIMITED',
    'PEARL BOTTLING PRIVATE LIMITED',
    'PEARL BUILDCON AND RESORTS PRIVATE LIMITED',
    'PEARL DRINKS LIMITED',
    'PEARL GLOBAL SYNDICATE PRIVATE LIMITED',
    'PEARL INTERNATIONAL SERVICES PRIVATE LIMITED',
    'PASONDIA CABLES PRIVATE LIMITED',
    'PASUPATI OLEFIN LIMITED',
    'PEARLS INFRASTRUCTURE PROJECTS LIMITED',
    'PATEL FINLEASE (INDIA) PRIVATE LIMITED',
    'PATEL JIVA SALES PRIVATE LIMITED',
    'PATEL WOOD AGRO FORESTERY PRIVATE LIMITED',
    'PEL ASSET AND INFRASTRUCTURE LIMITED',
    'PELICAN CRAFTS PRIVATE LIMITED',
    'PATEL WOOD PRODUCTS LIMITED',
    'PENGUIN RESORTS PRIVATE LIMITED',
    'PENTA VILLE FARMS PRIVATE LIMITED',
    'PATHFINDER INFOSERVICES PRIVATE LIMITED',
    'PEOPLE RESEARCH ON INDIA',
    'ICICI Prudential Trust Limited',
    'Indiantryst Tours Private Limited',
    'INDIASIGN PRIVATE LIMITED',
    'INDICA OVERSEAS PRIVATE LIMITED',
    'IE AUTO INDUSTRIAL ENTERPRISE PRIVATE LIMITED',
    'UTKAL PIPELINE INFRASTRUCTURE LIMITED',
    'EATON POWER QUALITY PRIVATE LIMITED',
    'INDIGO DISTRIBUTORS PRIVATE LIMITED',
    'IKM HOLDINGS PRIVATE LIMITED',
    'IMPERATIV INTERNATIONAL HOTELS PRIVATE LIMITED',
    'IMR MEDIA PRIVATE LIMITED',
    'INDER LAL AND COMPANY PRIVATE LTD.',
    'H.T.S TOURS PRIVATE LIMITED',
    'HITECH PROPERTY DEVELOPERS PRIVATE LIMITED',
    'HOPE STAR PROPERTIES PRIVATE LIMITED',
    'HORIZON AEROSPACE (INDIA) PRIVATE LIMITED',
    'Indiabulls Collection Agency Limited',
    'Indiabulls Infrastructure Projects Limited',
    'INDIABULLS INSURANCE ADVISORS LIMITED',
    'INDIABULLS MULTIPLEX SERVICES LIMITED',
    'INDO RAMA RETAIL HOLDINGS PRIVATE LIMITED',
    'Terravision Radar Private Limited',
    'INDEV CONSULTANCY PRIVATE LIMITED',
    'India Steel Summit Private Limited',
    'INDIA STEM FOUNDATION',
    'INDIA TOURISM DEVELOPMENT CORPORATION LIMITED',
    'INDRAPRASTHA ENERGY & WASTE MANAGEMENT COMPANY LIMITED',
    'INDIA TRADE PROMOTION ORGANISATION',
    'INDIABULLS ASSET RECONSTRUCTION COMPANY LIMITED',
    'INDO AUSTRIAN BUSINESS FORUM',
    'NTP HEALTHCARE & MEDICAL SERVICES PRIVATE LIMITED',
    'INDO GERMAN INTERNATIONAL PRIVATE LIMITED',
    'INDUS INNOVATIVE MEDIA PRIVATE LIMITED',
    'INDO RUSSIAN INTERNATIONAL PRIVATE LIMITED',
    'INDOFIX INTERNATIONAL PRIVATE LIMITED',
    'INDIAN TECHNOMETAL COMPANY LIMITED',
    'INDUSTRIAL COLAB (INDIA) PRIVATE LIMITED',
    'INDIAN TECHNOMINERALS COMPANY LIMITED',
    'INDIAN ZARI EMPORIUM PRIVATE LIMITED',
    'INDIGO COLLECTIONS PRIVATE LIMITED',
    'INDIGRAM CONSULTING SERVICES PRIVATE LIMITED',
    'INFINITE SUM INDIA PRIVATE LIMITED',
    'INDIGRAM SOCIAL DEVELOPMENT PROJECTS PRIVATE LIMITED',
    'INFOGAIN INDIA PRIVATE LIMITED',
    'INFOLONA CONSUMER SOLUTIONS PRIVATE LIMITED',
    'INFOMAX MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED',
    'INDO - GERMAN BRAKES PRIVATE LIMITED',
    'INDO AEROSPACE SOLUTIONS PRIVATE LIMITED',
    'INDO ALUSYS INDUSTRIES LIMITED',
    'INDOIT REAL ESTATES LIMITED',
    'INDO-JAPAN TRADE CENTRE PRIVATE LIMITED',
    'INDO AMERICAN INNOVATIVE TECHNOLOGIES PRIVATE LIMITED',
    'Indo Apparels Private Limited',
    'INDO ARAB AIR SERVICES PRIVATE LIMITED',
    'KASH-PACKS PRIVATE LIMITED.',
    'INLAND DEVELOPERS PRIVATE LIMITED',
    'KUNAFA FOODS & BEVERAGES PRIVATE LIMITED',
    'INDUS B2C GLOBAL PRIVATE LIMITED',
    'INDUS GAS TRANSMISSION LIMITED',
    'INMACS MANAGEMENT SERVICES LIMITED',
    'INMACS MICROSYSTEMS PRIVATE LIMITED',
    'Life Circle Health Services Private Limited',
    'INDRAPRASTHA BUILD-CAP PVT. LTD.',
    'ADANI LOGISTICS SERVICES LIMITED',
    'Innovative Building Systems India Private Limited',
    'INNOVATIVE COMPUTECH PRIVATE LIMITED',
    'INNOVATIVE DRESSES PRIVATE LIMITED',
    'INNOVATIVE EDUCATION NETWORK PRIVATE LIMITED',
    'INDRASIL TECHNOLOGIES PRIVATE LIMITED',
    'INDU FARMS PRIVATE LIMITED',
    'Innovative Precast Private Limited',
    'INDUS action Initiatives',
    'INMACS LIMITED.',
    'INNODATA INDIA PRIVATE LIMITED',
    'INDUS PUNJAB FROZEN FOODS EXPORTS PRIVATE LIMITED',
    'INDUS REALCON PRIVATE LIMITED',
    'INDUS TEXTILE MILLS PRIVATE LIMITED',
    'INDUSTRIAL CONVEYORS PRIVATE LIMITED',
    'INDUSTRIAL DEVELOPMENT SERVICES PRIVATE LIMITED',
    'FORESIGHT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'LION SERVICES LIMITED.',
    'London Court of International Arbitration (India) Private Limited',
    'LITTLE SCHOLARZ PRIVATE LIMITED',
    'LIVANA BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'LIVE MEDIA AND PUBLISHERS PRIVATE LIMITED',
    'LOOKS SALON PRIVATE LIMITED',
    'LOOKS SCHOOL OF HAIR AND BEAUTY PRIVATE LIMITED',
    'LORD KRISHNA DWELLERS PRIVATE LIMITED',
    'LIFI PUBLICATIONS PRIVATE LIMITED',
    'LIFTECH INDIA PRIVATE LIMITED',
    'Lime Labs India Private Limited',
    'Lorena Infrastructure Limited',
    'Logix Buildcon Private Limited',
    'LOGIX BUILDERS & PROMOTERS PRIVATE LIMITED',
    'LORSHYA WIPETEK PRIVATE LIMITED',
    'FANUC INDIA PRIVATE LIMITED',
    'Lotus Nu-Tratech Private Limited',
    'LOTUS STATIONERS PRIVATE LIMITED',
    'LOTUS TECHNOSOFT PRIVATE LIMITED',
    'LOUIS DREYFUS COMPANY INDIA PRIVATE LIMITED',
    'LTC LOGISTICS PRIVATE LIMITED',
    'LTC Translinks Private Limited',
    'LUCCHINI (I) PRIVATE LIMITED',
    'FIRSTMERGE TECHNOLOGIES PRIVATE LIMITED',
    'GARTEX INSTA APPARELS PRIVATE LIMITED',
    'EXCELLENT PROPERTY DEVELOPERS PRIVATE LIMITED',
    'LONG VIEW DEVELOPERS PRIVATE LIMITED',
    'LUCINA LAND DEVELOPMENT LIMITED',
    'LUCINA PROPERTIES LIMITED',
    'LUCKNOW 9 CABLE NETWORK PRIVATE LIMITED',
    'LONGMAN SUNTECH ENERGY PRIVATE LIMITED',
    'DG BIM CONSULTING PRIVATE LIMITED',
    'LONGTEL TECHNOLOGY PRIVATE LIMITED',
    'LUNAR DEVELOPERS PRIVATE LIMITED',
    'LUSTRE FIN SECURITIES LIMITED',
    'Lutron GL Sales and Services Private Limited',
    'LUXOR PLASTCHEM PRIVATE LIMITED',
    'Lorena Builders Limited',
    'Lorena Constructions Limited',
    'STONEX GLOBAL PRIVATE LIMITED',
    'Lorena Developers Limited',
    'LORINA ADVISORY SERVICES PRIVATE LIMITED',
    'M .H. POLYMERS PRIVATE LIMITED',
    'LOTUS HERBALS Private Limited',
    'M D BUILDTECH PRIVATE LIMITED',
    'M D OVERSEAS PRIVATE LIMITED',
    'M D PUBLICATIONS PRIVATE LIMITED',
    'LUCERNE TRADING SERVICES PRIVATE LIMITED',
    'LUCINA BUILDERS AND DEVELOPERS LIMITED',
    'LUCINA BUILDWELL LIMITED',
    'LUCINA ESTATE LIMITED',
    'LUCKY TOWNSHIP DEVELOPERS LIMITED',
    'M H K EXPORTS PRIVATE LIMITED',
    'Lorena Real Estate Limited',
    'M K N COMMODITY BROKERS PRIVATE LIMITED',
    'MINDEX CAPITAL MARKET PRIVATE LIMITED',
    'M K R CONSTRUCTION PRIVATE LIMITED',
    'M K S TOWERS INTERNATIONAL PRIVATE LIMITED',
    'LION FACILITIES PRIVATE LIMITED',
    'LION INFRATECH PRIVATE LIMITED',
    'M M DOTCOM GRAPHICS PRIVATE LIMITED',
    'LUCKY STAR ESTATE(INDIA)PVT LTD',
    'LUCKY STRIKE FINANCIERS PRIVATE LTD.',
    'M R CHAINS PRIVATE LIMITED',
    'M R K OVERSEAS PRIVATE LIMITED',
    'LUZ LIGHT DESIGN STUDIO PRIVATE LIMITED',
    'LX MARKETING PRIVATE LIMITED',
    'Life Canvas Private Limited',
    'M D SECURITIES PRIVATE LIMITED',
    'M TWENTY FOUR SECURITY PRIVATE LIMITED',
    'M. H. SYNTHETICS PRIVATE LIMITED',
    'M.B. EDUCATIONAL CONCEPTS PRIVATE LIMITED',
    'M.B. FINMART PRIVATE LIMITED',
    'JAINCO TANKS PRIVATE LIMITED',
    'M.P. INDIA ENTERPRISES PRIVATE LIMITED',
    'M.P. MINING & ENERGY LIMITED',
    'M.S. EMBROIDERY PRIVATE LIMITED',
    'M2K ENTERTAINMENT PRIVATE LIMITED',
    'M G M INTERNATIONAL PVT LTD',
    'M. G. STEELS LIMITED',
    'M K TRADELINKS PRIVATE LIMITED',
    'MAA VAISHNO NET - TECH PRIVATE LIMITED',
    'Maan Aluminium Limited',
    'MAATRA ANCILLARIES PRIVATE LIMITED',
    'M J ENGINEERING WORKS PRIVATE LIMITED',
    'LIVIN PRODUCTS PRIVATE LIMITED',
    'LIVING MEDIA INDIA LIMITED',
    'M K TOWERS PRIVATE LIMITED',
    'M2K INFRASTRUCTURE PRIVATE LIMITED',
    'MACO PRIVATE LIMITED',
    'MA DESIGN INDIA PRIVATE LIMITED',
    'MAA SARDA RAIL NIRMAN PRIVATE LIMITED',
    'MACSTAR MACHINE TOOLS PRIVATE LIMITED',
    'MABON CONSTRUCTIONS LIMITED',
    'ANABHA VENTURES PRIVATE LIMITED',
    'GEM SUGARS LIMITED',
    'MABON INFRASTRUCTURE LIMITED',
    'M S BHALLA AND CO PVT LTD',
    'M S G PERSONNEL VISION PRIVATE LIMITED',
    'MACRO OUTSOURCING PRIVATE LIMITED',
    'MADHUSUDAN EXPOFAB PRIVATE LIMITED',
    'MAESTRO PROMOTERS PRIVATE LIMITED',
    'MAGIC SOFTWARE PRIVATE LIMITED',
    'MAGIC TOWN PLANNERS PRIVATE LIMITED',
    'Magicbricks Realty Services Limited',
    'STEDER SALES AND DISTRIBUTIONS PRIVATE LIMITED',
    'RURAL INTERACTIVE INFOTECH (OPC) PRIVATELIMITED',
    'DARWIN LABS PRIVATE LIMITED',
    'ALT TAB HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'HEADWAY BPO SOLUTIONS PRIVATE LIMITED',
    'DWARAKA SRINIVASA CONSTRUCTIONS PRIVATE LIMITED',
    'IMAGINEXT TECH SOLUTIONS PRIVATE LIMITED',
    'QPAVE SOLUTIONS PRIVATE LIMITED',
    'XOMIC INFOTECH PRIVATE LIMITED',
    'LUMIUM DESIGN ENGINEERING PRIVATE LIMITED',
    'FIX MY GADGETS TECHSERVICES PRIVATE LIMITED',
    'MINPUT ENERGY PRIVATE LIMITED',
    'ALLIANCEIT AND CSS PRIVATE LIMITED',
    'TANAY VIDHYUT (I) PRIVATE LIMITED',
    'CHEVISANCE SHIPPING PRIVATE LIMITED',
    'MOWZZ LEISURE AND LIFE STYLE CLUB PRIVATE LIMITED',
    'DECIBELPRO PRIVATE LIMITED',
    'KAR KONCEPT PRIVATE LIMITED',
    'WEALTHSPRING PRIVATE LIMITED',
    'SUPER BOXING PROMOTIONS PRIVATE LIMITED',
    'EASYZARIYA SERVICES (OPC) PRIVATE LIMITED',
    'EXCELTECH INDIA PRIVATE LIMITED',
    'OFFING GROUP PRIVATE LIMITED',
    'MAKESWORTH ACCOUNTANTS PRIVATE LIMITED',
    'TATTVAM INDUSTRIES PRIVATE LIMITED',
    'JAHAJEE PRIVATE LIMITED',
    'EDUAPPS SOFTWARE SERVICES PRIVATE LIMITED',
    'CLOUDQ PRIVATE LIMITED',
    'YOUNG INDIA INDUSTRY PRIVATE LIMITED',
    'SAMBRIDHHI MARKETING PRIVATE LIMITED',
    'FAST SUPPORT PRIVATE LIMITED',
    'ARK PROFESSIONAL SERVICES PRIVATE LIMITED',
    'MOOT DATA SOLUTIONS PRIVATE LIMITED',
    'CAPTIVATE SOFTECH PRIVATE LIMITED',
    'THINQLOUD SOLUTIONS PRIVATE LIMITED',
    'NEXTOGEN TECHNOLOGIES PRIVATE LIMITED',
    'SHULIN SOLAR POWER PRIVATE LIMITED',
    'HAPPYSHAPPY EVENT SERVICES PRIVATE LIMITED',
    'LEARNING CURVE LIFE SKILLS FOUNDATION',
    'DIGITAL BRANDSTER PRIVATE LIMITED',
    'ESSEL REALTY PRIVATE LIMITED',
    'VI FARM ORGANICS LIMITED',
    'SPC COMPOUNDING INDIA PRIVATE LIMITED',
    'ECO EMARKET PRIVATE LIMITED',
    'TECHPANACEA PRIVATE LIMITED',
    'BRITONNA HOTEL AND YACHT CLUB PRIVATE LIMITED',
    'CARVEANICHE TECHLABS PRIVATE LIMITED',
    'I DREAM EDUCATION PRIVATE LIMITED',
    'LOOKE DIGITAL PRIVATE LIMITED',
    'NINGYUAN MACHINE TOOL PRIVATE LIMITED',
    'ALTRA FITNESS & SPA (I) PRIVATE LIMITED',
    'DIGITAL TECHNOSYS PRIVATE LIMITED',
    'PRABHU LOGISTICS PRIVATE LIMITED',
    'SINGALILA TEA ESTATE PRIVATE LIMITED',
    'MINIMOLAR CLUB PRIVATE LIMITED',
    'ZEROWAV PRIVATE LIMITED',
    'YAKAY SOLUTIONS PRIVATE LIMITED',
    'AGILETECH INFO SOLUTIONS PRIVATE LIMITED',
    'STARTBIZ PRIVATE LIMITED',
    'SICAL BANGALORE LOGISTICS PARK LIMITED',
    'BIOGRAIN PROTINEX PRIVATE LIMITED',
    'MV CLOUDS PRIVATE LIMITED',
    'DESIGN VERTICALS CONSULTANTS PRIVATE LIMITED',
    'NS DREAMCON PRIVATE LIMITED',
    'CONNECT TRADECAP PRIVATE LIMITED',
    'PUMPCHARGE INTERNET PRIVATE LIMITED',
    'PAITHAN ECO FOODS PRIVATE LIMITED',
    'DREAM SPORTS FOUNDATION',
    'SANSI TOURISM PRIVATE LIMITED',
    'INSTAFUND INTERNET PRIVATE LIMITED',
    'PWG FITNESS PRIVATE LIMITED',
    'INFIUS INFRASTRUCTURE PRIVATE LIMITED',
    'SOLROOF RENEWABLE DWELLINGS PRIVATE LIMITED',
    'CLEAN ELECTRIC PRIVATE LIMITED',
    'INITNINE CONSULTANTS (OPC) PRIVATE LIMITED',
    'FUNDFINA TECHNOLOGIES PRIVATE LIMITED',
    'IMMWIT PRIVATE LIMITED',
    'BROOKEFIELD SANJEEVINI HEALTHCARE PRIVATE LIMITED',
    'DHAVALA MATERIAL JUNCTION PRIVATE LIMITED',
    'SAMAYAA HOTELS AND RESORTS PRIVATE LIMITED',
    'WELCH MATERIALS INDIA PRIVATE LIMITED',
    'BASECAMP STARTUPS PRIVATE LIMITED',
    'ACCORD IDEATION PRIVATE LIMITED',
    'SAMECART PRIVATE LIMITED',
    'ELECTROM COMMUNICATIONS PRIVATE LIMITED',
    'OSHYOM APP ADVISOR PRIVATE LIMITED',
    'BHANJA REAL ESTATE PRIVATE LIMITED',
    'MUMBAI FRESH PRIVATE LIMITED',
    'FISSION FEATURES PRIVATE LIMITED',
    'AGRONXT SERVICES PRIVATE LIMITED',
    'DESI FUSION INDIA PRIVATE LIMITED',
    'REDIVIVUS RECYCLERS PRIVATE LIMITED',
    'CALDIM ENGINEERING PRIVATE LIMITED',
    'SMART SKILL TECH PRIVATE LIMITED',
    'NOGUILT FITNESS AND NUTRITION INDIA PRIVATE LIMITED',
    'ERWIN INDIA PRIVATE LIMITED',
    'FUSIONSPAN INDIA PRIVATE LIMITED',
    'TOTAL MARKETING SUPPORT INDIA PRIVATE LIMITED',
    'BLUEBERRY VOYAGE PRIVATE LIMITED',
    'JAYDU INDIA PRIVATE LIMITED',
    'SEAVIE PRIVATE LIMITED',
    'MARJING COMMERCE PRIVATE LIMITED',
    'VENA ENERGY SOLAR HELIOS INDIA POWER RESOURCES PRIVATE LIMITED',
    'BUILDNEXT CONSTRUCTION SOLUTIONS PRIVATE LIMITED',
    'ONE CLICK INNOVATIONS PRIVATE LIMITED',
    'BIOMI LIFE SCIENCES PRIVATE LIMITED',
    'CXIO TECHNOLOGIES PRIVATE LIMITED',
    'SATRIX TECHNOLOGIES PRIVATE LIMITED',
    'EVOLUTION DIGITAL (INDIA) PRIVATE LIMITED',
    'CEFA-CILINAS BIOTICS PRIVATE LIMITED',
    'MGURU EDULABS PRIVATE LIMITED',
    'TRIVIA TRADING PRIVATE LIMITED',
    'KURODA ELECTRIC INDIA PRIVATE LIMITED',
    'CLOUDINNOV8 TECHNOLOGIES PRIVATE LIMITED',
    'LETSMOVE SERVICES PRIVATE LIMITED',
    'SOARES ENTERPRISES (INDIA) PRIVATE LIMITED',
    'YIRON TECHNOLOGIES PRIVATE LIMITED',
    'ONE 1 ONE STARTUP SOLUTIONS PRIVATE LIMITED',
    'UDAAN VISA FACILITATION PRIVATE LIMITED',
    'ENCHANTED PROPERTIES PRIVATE LIMITED',
    'GPA TEA ESTATE PRIVATE LIMITED',
    'FRESHLIGHT CONSTRUCTION PRIVATE LIMITED',
    'WAVETECH INFOCOM PRIVATE LIMITED',
    'BROKEN ARROW RETAILS PRIVATE LIMITED',
    'ONE RX INDIA PRIVATE LIMITED',
    'FUSION BUILDING MATERIALS PRIVATE LIMITED',
    'DBL MUNDARGI HARAPANAHALLI TOLLWAYS PRIVATE LIMITED',
    '7 WONDERS WORLD TRAVELS PRIVATE LIMITED',
    'NEOABEER TRAVEL & TOURISM PRIVATE LIMITED',
    'IRC SHIPPING LOGISTICS PRIVATE LIMITED',
    'GOLDEN PEACE HI TECH INFRA PRIVATE LIMITED',
    'PHYGITAL INSIGHTS PRIVATE LIMITED',
    'HIRACO STORAGE PRIVATE LIMITED',
    'STEV & JOLS PROJECT SOLUTIONS PRIVATE LIMITED',
    'CHORAL EVENT MANAGEMENT PRIVATE LIMITED',
    'YADKI INFOTECH PRIVATE LIMITED',
    'K-CIRCLE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'DELIUM TECHNOLOGIES PRIVATE LIMITED',
    'OMNIS HEALTHCARE SERVICES PRIVATE LIMITED',
    'KIDS WELLNESS SERVICES PRIVATE LIMITED',
    'RDL TECHNOLOGIES PRIVATE LIMITED',
    'NISHKA INFOTECH (OPC) PRIVATE LIMITED',
    'TIC INDIA PRIVATE LIMITED',
    'GUJARAT CREDO ALUMINA CHEMICALS LIMITED',
    'UNITEDREPUBLIC SERVICES PRIVATE LIMITED',
    'HAUSKHAAS FOODTECH PRIVATE LIMITED',
    'SMARTTRAK ENERGY PRIVATE LIMITED',
    'VIO CVTOAPPLY PRIVATE LIMITED',
    'KIDO ENTERPRISES PRIVATE LIMITED',
    'HOSPEKART ONLINE PRIVATE LIMITED',
    'CODEACHI TECHNOLOGIES PRIVATE LIMITED',
    'FLUIIDMASK STUDIOS PRIVATE LIMITED',
    'GATEWAYVR PRIVATE LIMITED',
    'NURTURING GREEN PLANTATION PRIVATE LIMITED',
    'SUNRISE MENTORS PRIVATE LIMITED',
    'TECHTHEOS INDIA PRIVATE LIMITED',
    'EYUVA INTERNET PRIVATE LIMITED',
    'NEWSTRIDES CONSULTING PRIVATE LIMITED',
    'MAYEKAR BROADBAND PRIVATE LIMITED',
    'AGRION OVERSEAS PRIVATE LIMITED',
    'INFINITYWORLD INFRATECH PRIVATE LIMITED',
    'GOLD24 JEWELLERY PRIVATE LIMITED',
    'Dsyn technologies private limited',
    'Nvr technologies private limited',
    'Talent access hr services private limited',
    'Pricol corporate services limited',
    'Hans d to r solutions private limited',
    'Global commodities trading limited',
    'Daniel vinimay private limited',
    'Svk exports private limited',
    'JAY LAXMI TRADELINKS PRIVATE LIMITED',
    'Centra sales private limited',
    'Alokananda agencies private limited.',
    'S j m international limited',
    'Latitudes tourism private limited',
    'Essar satvision limited',
    'Sat e-com limited',
    'Knox investments pvt ltd',
    'TC FOREX SERVICES LIMITED',
    'Gemini sunrise investment pvt ltd',
    'Rajendra finance private limited',
    'SUVARNA INVESTMENT & TRADING PRIVATE LIMITED',
    'Emerging india value advisors private limited',
    'Harshadray investment private limited',
    'UDBALA ENTERPRISES LIMITED',
    'Vivek financial commodity broking private limited',
    'Beach side properties private limited',
    'EDWELL INFRASTRUCTURE HAZIRA LIMITED',
    'Nccc realty private limited',
    'Bonus distributors private limited',
    'Pearl flats (india) limited',
    'Yapen developers private limited',
    'Poddar promoters pvt ltd.',
    'Shri chaturbhuj real estates private limited',
    'Enlai developers private limited',
    'Carney developers private limited',
    'Kirti realties and farms private limited',
    'City promoters & developers private limited',
    'Turquoise housing private limited',
    'Barry callebaut india private limited',
    'Stanes motor parts limited',
    'Hotel tunga international private limited',
    'Mambalam iyers food products private limited',
    'Subburaj spinning mills private limited',
    'Mjp media private limited',
    'Best agrochem private limited',
    'Swastik veneers private limited',
    'Usha concast private limited',
    'Pentair valves and controls india private limited',
    'Gayathri industrial products private limited',
    'Eat it private limited',
    'Xanadu biscuit pvt ltd',
    'Equine tech nutri care private limited',
    'Akshar accommodations private limited',
    'Param anand builders private limited',
    'Naman enterprises private limited',
    'Surya digisoft private limited',
    'Enzen technologies private limited',
    'Strumsoft india private limited',
    'Giri digital solutions private limited',
    'Securent india private limited',
    'Noah data private limited',
    'Emergic venture capital private limited',
    'ASSYST INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'Cwps lochbridge india private limited',
    'BSVLIFE PRIVATE LIMITED',
    'SUNDARAVEL MARKETING COMPANY PRIVATE LIMITED',
    'Mera money advisors private limited',
    'Northways constrain private limited',
    'Northways creations private limited',
    'Northways enterprises private limited',
    'Northways fabricators private limited',
    'KRCHOKSEY HOLDINGS PRIVATE LIMITED',
    'Westbury infrastructure private limited',
    'Shining marbles private limited',
    'Kalyani apparels private limited',
    'Narooma builders & developers private limited',
    'Lear builders & developers private limited',
    'Nudhar builders & developers private limited',
    'Ariadne builders & developers private limited',
    'Rachelle builders & constructions private limited',
    'Dlf residential builders limited',
    'Vijas infrastructures private limited',
    'Peeaar constructions pvt ltd',
    'Dlf gayatri home developers private limited',
    'Adeline builders & developers private limited',
    'Balint real estates private limited',
    'Elvira builders & constructions private limited',
    'Armand builders & constructions private limited',
    'Camden builders & developers private limited',
    'Vijaygi investments private limited',
    'Koon seng construction (india) private limited',
    'Neo lifespaces private limited',
    'Amazo arcade private limited',
    'Sgs management solutions private limited',
    'Rhea retail private limited',
    'Aviohelitronics knowledge research & analysis private limited',
    'Moss design private limited',
    'Segmenty automotive intelligence private limited',
    'Kalptaru insurance brokers limited',
    'Capitalvia global research limited',
    'Imaritime consultancy private limited',
    'Bestop consulting india private limited',
    'JLT ADVISORY SERVICES LIMITED',
    'SUPERVASI FOUNDATION',
    'VIMLABAI GARWARE RESEARCH INSTITUTE PRIVATE LIMITED',
    'Ibg welding research (india) private limited',
    'Total business solutions india private limited',
    'Futuredimensions consultants private limited',
    'FIRSTVIEW MEDIA VENTURES PRIVATE LIMITED',
    'Revive containers private limited',
    'Pinnacle insights private limited',
    'Eco emissions xchange private limited',
    'Kalozal consultants private limited',
    'Integrated retail management consulting pvt limited',
    'E e software technologies private limited',
    'RD PROJECT DEVELOPERS PRIVATE LIMITED',
    'Planet ganges consulting private limited',
    'Aim outsourcing consultants private limited',
    'Excellence edu solutions private limited',
    'Shri karni air couriers & cargo private limited',
    'Las designs private limited',
    'Sharp and score hr consulting private limited',
    'Blue nile solutions india private limited',
    'Muse consultants private limited',
    'Pious fashion private limited',
    'TECHWEN SYSTEMS PRIVATE LIMITED',
    'EZYTEK CLEAN PRIVATE LIMITED',
    'Gip india private limited',
    'Nishita consultancy services private limited',
    'Ambit capital private limited',
    'B vijaykumar technical services private limited',
    'Professional assessment and training systems private limited',
    'Raj mohindra consultants private limited',
    'Alphatech consultants private limited',
    'Food edge gourmet solutions private limited',
    'PADMAKSHI-MONDIAL ASSET SERVICES PRIVATE LIMITED',
    'VOXLAW TAX ASP PRIVATE LIMITED',
    'Sun enviro technologies private limited',
    'Cpg business synergies private limited',
    'Care facilities management services private limited',
    'AMBIT WEALTH PRIVATE LIMITED',
    'Taqwaa advisory and shariah investment solutions private limited',
    'Leogem consultants private limited',
    'Aon consulting private limited',
    'Canopus consultancy services private limited',
    'Sixdyne wealthserve private limited',
    'Addon resources private limited',
    'Celebutante talent management company private limited',
    'Ashish business solutions private limited',
    'Sterling relocation private limited',
    'Margdarshak consultants private limited',
    'Bhagwati human capital management private limited',
    'K s d financial consultancy private limited',
    'Chhapia financial management private limited',
    'Books ifinance consultancy private limited',
    'Amsc india private limited',
    'Edulever consulting company private limited',
    'Imentor development services private limited',
    'Sde engineers private limited',
    'Axiom management consultants p ltd',
    'Tracery financial consultancy p ltd',
    'Reach management consultants private limited',
    'Three d management services private limited',
    'Ss corporate management services private limited',
    'Pari washington company advisors private limited',
    'Akshaya business solutions private limited',
    'Mentor learning services private limited',
    'Integrass technical services private limited',
    'Ecologikol advisors india private limited',
    'Abs vipanan pvt. ltd.',
    'HMB PROPERTIES PRIVATE LIMITED',
    'On time professional services private limited',
    'On time management services private limited',
    'Omega capital consultants private limited',
    'Athena wealth advisors private limited',
    'Mewar polytex limited',
    'Hemadri cements ltd',
    'Nova roofings and pipes limited',
    'Hindalco industries limited',
    'Kridhan infra limited',
    'Surana industries limited',
    'Lgb forge limited',
    'Ip rings limited',
    'Voltas limited',
    'PRITHVI EXCHANGE (INDIA) LIMITED',
    'Cg vak software and exports limited',
    'Magna electro castings limited',
    'AMARA RAJA ENERGY & MOBILITY LIMITED',
    'Wpil limited',
    'Thanga mayil jewellery limited',
    'Ellora paper mills limited',
    'Purohit construction limited',
    'Telecanor global limited',
    'Saraf infraprojects limited',
    'Sarvamangal marcantile company limited',
    'CONSTRONICS INFRA LIMITED',
    'Magnum matrixs private limited',
    'Impeliment management solutions private limited',
    'Followon interactive media private limited',
    'R&R SALONS PRIVATE LIMITED',
    'Phoenix infoquest private limited',
    'Greshma commodities private limited',
    'City trade logistics private limited',
    'Kailas manasarovar foundation',
    'Vasai timber industries private limited',
    'Shreekripa automobiles private limited',
    'Finshore securities private limited',
    'Inaavi consultancy private limited',
    'Patcart packaging private limited',
    'Arcadia investments company limited',
    'Gold star construction co.pvt ltd',
    'Carat holdings and trading company private limited',
    'Steelsmith (india) private limited',
    'Golden medows properties private limited',
    'Bigshare services private limited',
    'Rashmi fabricators private limited',
    'Anannya estate and finance private limited',
    'Vruddhi confinvest india private limited',
    'Sunil agro foods limited',
    'JAYATMA INDUSTRIES LIMITED',
    'Julie (india) ltd',
    'Automotive axles limited',
    'Ces limited.',
    'Filtron engineers limited',
    'Muthoot finance limited',
    'Magnanimous trade & finance ltd',
    'Veer energy & infrastructure limited',
    'Polaris consulting & services limited',
    'SASTASUNDAR VENTURES LIMITED',
    'Jm financial limited',
    'Bindawala banijya ltd',
    'Sspdl limited',
    'Dynacons systems and solutions limited',
    'Danlaw technologies india limited',
    'WAAREE RENEWABLE TECHNOLOGIES LIMITED',
    'Zipper trading enterprises limited',
    'Tree house education & accessories limited',
    'Cerebra integrated technologies limited',
    'Axtel industries limited',
    'Crest ventures limited',
    'Huber india private limited',
    'Kanrad technologies india private limited',
    'CANDOR GURGAON ONE REALTY PROJECTS PRIVATE LIMITED',
    'Max pacific corporation limited',
    'Blue bird logistics private limited',
    'Stem multicom enterprises limited',
    'Poonam makar lifestyles private limited',
    'Quintessence extracts (india) private limited',
    'Biomass 2 biopower (qa) limited',
    'Manappuram agro farms limited',
    'Genetic seeds private limited',
    'Sanjeev agro-vet private limited',
    'Akhilesha agro farms private limited',
    'Harin bio-tech international private limited',
    'Malpani agro-tech limited',
    'Janus aviation private limited',
    'Ultimo stud farm private limited',
    'SONAR PAPER PRODUCTS PRIVATE LIMITED',
    'Secure organic private limited',
    'Asa agrotech private limited',
    'Hi-tech agrovision private limited',
    'Positron energy private limited',
    'Apoorva agrico private limited',
    'INDACOCO INDIA PRIVATE LIMITED',
    'Heritage bio-natural systems private limited',
    'Reward farming and livestock private limited',
    'Bengal brahmaputra conclave private limited',
    'Bengal brahmaputra buildcon private limited',
    'Bengal brahmaputra devcon private limited',
    'Van-ganga farms private limited',
    'Vishnupriya farms private limited',
    'Sonoco agro-enterprises private limited',
    'Derby plantations pvt ltd',
    'Karadi malai plantations private limited',
    'Nakoda agro commodities private limited',
    'Mikrosen control devices private limited',
    'Torque cables private limited',
    'Pelikan office automation private limited',
    'Dsk digital technologies private limited',
    'Jyothi dies and pressing private limited',
    'ROLLZ INDIA WASTE MANAGEMENT PRIVATE LIMITED',
    'Storewell storage solutions private limited',
    'Cognovit power solutions private limited',
    'Inductra magnetic components private limited',
    'Goel power controls private limited',
    'Jcb power products india private limited',
    'Nanocryst transcore private limited',
    'Cape electric private limited',
    'Jatson power private limited',
    'MADGETS INDIA PRIVATE LIMITED',
    'Electronic controls and discharge systems private limited',
    'Superpower generators private limited',
    'Kbm extrusions machines private limited',
    'Z f healthcare pvt. ltd.',
    'Mennekes electric india private limited',
    'Accurate material handlers private limited',
    'Therm transfer equipment private limited',
    'ENRX PRIVATE LIMITED',
    'Helical auto technology india private limited',
    'Sai supertek global private limited',
    'Hydroflex pipe private limited',
    'Jvs electronics private limited',
    'Gnostice information technologies private limited',
    'Micrologix embedded controls private limited',
    'Insystron electronics private limited',
    'Lsi components private limited',
    'NBBC ENGINEERING PRODUCTS & SERVICES PRIVATE LIMITED',
    'Ace coating india private limited',
    'Crescentius telesoft private limited',
    'Multi trade technologies private limited',
    'MANGALAM COMPUTECH LIMITED',
    'Radiall india private limited',
    'Eswari electricals private limited',
    'Killi electricals pvt ltd',
    'INTEL SOLUTIONS & SERVICES INDIA PRIVATE LIMITED',
    'Maruwa electronic (india) private limited',
    'Caliber interconnect solutions private limited',
    'Thermolab testing services private limited',
    'Aaron lights private limited',
    'G-next media private limited',
    'Ie power technologies private limited',
    'Pentagon el-mech solutions (south) private limited',
    'DCX SYSTEMS LIMITED',
    'Kvt electrodes private limited',
    'Svp composites private limited',
    'Elin appliances private limited',
    'Jaishree surgident india private limited',
    'Enterprise opthalmics private limited',
    'Meril life sciences india private limited',
    'Encon systems private limited',
    'Mutual inductors limited',
    'Steranco healthcare private limited',
    'Esbee dynamed private limited',
    'Immunoshop india private limited',
    'NOVACLOUD PRIVATE LIMITED',
    'Sheetal wireless technologies private limited',
    'Bokaria reinforcing company private limited',
    'Wisedv electronics india private limited',
    'Esteem power trax private limited',
    'Emergem medicare private limited',
    'Safetec healthcare & hygiene private limited',
    'Elico ltd',
    'Genetic instruments private limited',
    'Newtech instruments (india) private limited',
    'Parsvnath telecom private limited',
    'Binatone telecommunication private limited',
    'Sameer electro systems private limited',
    'Changepond engineering and logistics private limited',
    'DIOPTER EYECARE PRIVATE LIMITED',
    'Galaxy glass products private limited',
    'PRASAD CORPORATION Private Limited',
    'Gtpl narmada cyberzone private limited',
    'S c a heavy equipment private limited',
    'Benteler automotive india private limited',
    'Sri srinivasa trading company private limited',
    'Century autotech private limited',
    'Krah woory india private limited',
    'Bajaj motors limited',
    'Jcbl marrel tippers private limited',
    'A c & r appliances private limited',
    'Navitas gensets private limited',
    'Weiler international electronics private limited',
    'KLAUS MULTIPARKING SYSTEMS PVT LTD',
    'Voss exotech automotive private limited',
    'Aam india manufacturing corporation private limited',
    'Kusalava international limited',
    'Impression systems and engineers private limited',
    'Econzerv solutions private limited',
    'Bhalani biomedicals private limited',
    'Modsonic instruments manufacturing company private limited',
    'Sollatek electronics india ltd.',
    'RUCHI GAS AND INFRATECH PRIVATE LIMITED',
    'Uniserve telecom private limited',
    'Onmed india private limited',
    'Saife vetmed private limited',
    'Skyquest technology consulting private limited',
    'CG DEVELOPERS AJMER PRIVATE LIMITED',
    'Zinc hotels & resorts india private limited',
    'Zinc journey india private limited',
    'CG GROWTH PARTNERS PRIVATE LIMITED',
    'Nanosemi technology & systems private limited',
    'R k m exim private limited',
    'Sphinx arts & crafts private limited',
    'Aashka hospitality private limited',
    'Dev priya hotels private limited',
    'FOUR SEASONS RESIDENCY PRIVATE LIMITED',
    'Thousand island hotels and resorts private limited',
    'Le grande residency private limited',
    'Coronae hotels private limited',
    'Motels & infrastructure india private limited',
    'Guestline hospitality management and developement services limited',
    'Siddharta resorts & foods private limited',
    'Ken project india limited',
    'Somayaji hotels private limited',
    'Barbeque-nation hospitality limited',
    'Twenty four seven hospitality private limited',
    'Sunville hotels and resorts private limited',
    'Caravan realty private limited',
    'Suhan developers private limited',
    'Suhan builders & developers private limited',
    'Manan infrastructure & development private limited',
    'Sivatar ventures private limited',
    'Omkareshwar realties and services private limited',
    'Anmol and mane builder and developers private limited',
    'Ueg infrastructure private limited',
    'Revell realtors private limited',
    'Space konstryst private limited',
    'Ipl infra services private limited',
    'Abode infra projects india private limited',
    'Suchirindia infracon private limited',
    'Gjs infratech private limited',
    'Padgro consultants private limited',
    'Ph foundations private limited',
    'Mascot overseas private limited',
    'Kailashwati buildcon private limited',
    'Jupiter home makers india private limited',
    'Endemic buildcon india private limited',
    'Rajni developers private limited',
    'Faldu infrastructure private limited',
    'Shaarc projects limited',
    'Bangalore-goa estates private limited',
    'Spl properties private limited',
    'Spl realtors private limited',
    'Darshita homes private limited',
    'Creo concepts private limited',
    'Sattva homes private limited',
    'Quicon buildtech india private limited',
    'Korath gulf links builders private limited',
    'Vajra realtors private limited',
    'Ac city projects private limited',
    'Rainbow constructions & developers (india) private limited',
    'Mrugal properties limited',
    'Mlb advisory services limited',
    'Asmitabusiness services private limited',
    'Avias corporate services private limited',
    'Quantum trustee company private limited',
    'IITL MANAGEMENT AND CONSULTANCY PRIVATE LIMITED',
    'VAIBHAV EQUISEC PRIVATE LIMITED',
    'VALUE ETHICS PRIVATE LIMITED',
    'Prutech financial services private limited',
    'Levana financial services limited',
    'TORQUE INSURANCE BROKERS PRIVATE LIMITED',
    'ARMONIA LIFE SCIENCE PRIVATE LIMITED',
    'United risk insurance broking company private limited',
    'United risk management services private limited',
    'Siri haripuram properties private limited',
    'PRARAMBH PROJECTS PRIVATE LIMITED',
    'Maxconcorde infra private limited',
    'Prabhat sadan properties private limited',
    'Vibhakar estate finance and developments private limited',
    'Troika estates private limited',
    'Dimple realtors private limited',
    'Parulekars properties private limited',
    'G n m realtors private limited',
    'Kusum dhan properties private limited',
    'Shaan realtors private limited',
    'Sadguru infrastructure private limited',
    'PRINITE HOSPITALITY PRIVATE LIMITED',
    'Pinnacle real estate development private limited',
    'Csn estates private limited',
    'Vrs estates private limited',
    'Jay ambe infra projects private limited',
    'INDIA GREEN REALITY Limited',
    'Dharmanath infracon private limited',
    'MIT REALTORS PRIVATE LIMITED',
    'Embassy classic private limited',
    'Living design private limited',
    'Trishul buildtech & infrastructures private limited',
    'Smart village private limited',
    'K. a. malle pharmaceuticals limited',
    'Suvimal properties pvt ltd',
    'Bellor estates and hotel private limited',
    'Neelkanth rameshwar realtors private limited',
    'Silver infraprojects private limited',
    'G.v.p. realty private limited',
    'Galore developers private limited',
    'Pink colonizers private limited',
    'Medtech services pvt ltd',
    'Doshi housing private limited',
    'Saraf housing development private limited',
    'Kg foundations private limited',
    'Escapade real estate private limited',
    'Makhouse infratech private limited',
    'Vidhi housing pvt ltd',
    'Concord non woven industries private limited',
    'Green life construction private limited',
    'Viswakarma nirman private limited',
    'Nexgen colonisers private limited',
    'Ferrous luxury world private limited',
    'B. m. gupta promoters private limited',
    'Indigo infraprojects private limited',
    'Delhi golf link properties private limited',
    'RAJHANS INFRACON (INDIA) PRIVATE LIMITED',
    'M.m. housing private limited',
    'Firenze propertiesandinvestments private limited',
    'Preeti developers private limited',
    'Spl developers private limited',
    'Spl properties (bne) private limited',
    'Capital land assets india private limited',
    'Spl homes private limited',
    'Sattva housing private limited',
    'SATTVA REALTORS PRIVATE LIMITED',
    'Darshita realtors private limited',
    'INNOVATIVE REALEST PRIVATE LIMITED',
    'Pranjee properties private limited',
    'Amkay realestate private limited.',
    'VJTF INFRASCHOOL SERVICES (UDAIPUR) PRIVATE LIMITED',
    'Gupta realinfra ventures private limited',
    'Citybase properties private limited',
    'Jeenmata real estate advisors private limited',
    'Chartered realities private limited',
    'Benzy home makers private limited',
    'Spenta corporation private limited',
    'Nivirti real estate private limited',
    'Hhb real estate private limited',
    'Manikya homes private limited',
    'Oorjita builders and developers private limited',
    'Suchirindia homes private limited',
    'Suchirindia townships private limited',
    'Suchirindia properties private limited',
    'Suchirindia estates private limited',
    'Team s properties private limited',
    'Spero foundations private limited',
    'Grove omr properties private limited',
    'Rescuwear (india) pvt ltd',
    'K k properties pvt ltd',
    'Sparking star infradev private limited',
    'Nachiket developers private limited',
    'Ultrashine realestate private limited',
    'Impressive nirman private limited',
    'Quickgrow housing private limited',
    'Dasmesh warehousing private limited',
    'Srichakra transtech private limited',
    'Ambrosia designs private limited',
    'Youdian business solutions private limited',
    'Scor.in infomedia private limited',
    'Mahindra Susten Private Limited',
    'Xanberri naturals private limited',
    'Ray adcomm private limited',
    'Alfa kpo private limited',
    'Pilot technologies (india) limited.',
    'CHRISTIE',
    'Euclid solutions private limited',
    'Has lifestyle limited',
    'Liberation coaches private limited',
    'Arebee media & software private limited',
    'S f distributors private limited',
    'Guljag air products private limited',
    'Western industrial applications private limited',
    'Acetech technologies private limited',
    'Zephirum research private limited',
    'Xceed toolings private limited',
    'Lexicon lifesciences private limited',
    'Man united management consultants private limited',
    'M n g estates private limited',
    'Interart creators plumbing services private limited',
    'Transvision shipping private limited',
    'Rts realtime systems india private limited',
    'Brand scientific equipment private limited',
    'Lumicom visual solutions private limited',
    'Medicare remedies private limited',
    'Marketgate dimensions research india private limited',
    'Shelf drilling offshore services (india) private limited',
    'Simpal mobile payment and information services private limited',
    'ALPHA-PHARMA HEALTHCARE PRIVATE LIMITED',
    'Obey jobs private limited',
    'Pelagia marine services private limited',
    'White dwarf media private limited',
    'Zenith quality assessors private limited',
    'Mindspace esop consultants private limited',
    'Basil hr advisory private limited',
    'DESIGNERS ELEMENTS CONSTRUCTIONS PRIVATE LIMITED',
    'Environmental protection services company (hyderabad) private limited',
    'Shaasta investments & initiatives private limited',
    'Zetatek engineering systems private limited',
    'Totem International Private Limited',
    'Gade autonomous systems private limited',
    'CAREATOR TECHNOLOGIES PRIVATE LIMITED',
    'Jai associates private limited',
    'Victory traders private limited',
    'SUSEE VEHICLE DEALERS PRIVATE LIMITED',
    'AGROCHEM LABORATORIES PRIVATE LIMITED',
    'BRIVAS PRIVATE LIMITED',
    'ZUORA INDIA PRIVATE LIMITED',
    'Bluemoon fibre tech india private limited',
    'India property online private limited',
    'Imcola crane company private limited',
    'Cerebrus hr solutions private limited',
    'Prodcontrol (india) private limited',
    'Marutham bioages innovations private limited',
    'Ishan housing projects ltd',
    'Sas tele infrastructure private limited',
    'Shakers kitchen innovation private limited',
    'Kwality process equipments private limited',
    'Casmir india energy private limited',
    'ROLTA BI & BIG DATA ANALYTICS PRIVATE LIMITED',
    'Omkar supranational private limited',
    'Precitech heavy equipments private limited',
    'Marzer technologies private limited',
    'Core crushtech private limited',
    'BOLT HAMMERS PRIVATE LIMITED',
    'Ras pumps private limited',
    'Excel filtration private limited',
    'PALOD HIMSON MACHINES PRIVATE LIMITED',
    'Enpay transformer components india private limited',
    'Das instrumentation private limited',
    'Perfect plantex industries limited',
    'Electro mec machinery manufacturers private limited',
    'Enmas epc power projects limited',
    'Cirugia de lux (india) private limited',
    'Circuitects electronic solutions private limited',
    'Wika instruments india private limited',
    'Trans engineers india private limited',
    'Eternal engineering equipment private limited',
    'G3s components private limited',
    'HEF-DURFERRIT MECHANICAL ELEMENTS PRIVATE LIMITED',
    'Hess concrete machinery india private limited',
    'Deyan gas private limited',
    'INERGY INFRA PRIVATE LIMITED',
    'Arrow power renewable solutions (india) private limited',
    'PRECIA MOLEN INDIA Private Limited',
    'BIOMEDICON CARE PRIVATE LIMITED',
    'Avantika infosolutions private limited',
    'Nagarjuna oil corporation limited',
    'Sen automation company pvt ltd',
    'Image master printer ribbons private limited',
    'Jumbo systems and solutions private limited',
    'Metalsoft technologies private limited',
    'Ucal el-tech private limited',
    'Montan hydraulik (india) private limited',
    'Esteem e technologies (chennai) private limited',
    'Apex automation private limited',
    'Nest connectivity solutions private limited',
    'EVER ON POWER Limited',
    'A d associates electricals private limited',
    'Simective engineers private limited',
    'Protech controls pvt ltd',
    'Enertec controls limited',
    'Valley systems engineers private limited',
    'Rover systems private limited',
    'Dynamic motors (india) private limited',
    'Hydro prokav pumps india private limited',
    'Rcube electric private limited',
    'Novatek electroengineers private limited',
    'CRUST ',
    'CRUMB FOOD INNOVATIONS INDIA LIMITED',
    'Harness techniques (india) private limited',
    'Sun translink (india) private limited',
    'Hathway prime cable & datacom private limited',
    'COPRAL ENERGY PRIVATE LIMITED',
    'Kdu enterprises private limited',
    'Technodeal enerpower private limited',
    'Teknic engineering (i) private limited',
    'Spaceage concepts (india) limited',
    'R.b.associates private limited',
    'Alliant techsol private limited',
    'Schnell energy equipments private limited',
    'Acronov technologies private limited',
    'Teknic electric (i) private limited',
    'Avm electricals india private limited',
    'Champion agro limited',
    'Circuittech electricals india private limited',
    'Coral rewinding india private limited',
    'EPITOME COMPONENTS Private Limited',
    'Clancor technovates india private limited',
    'Alpine systems private limited',
    'BENSTAR POWER TECHNOLOGIES INDIA PRIVATELIMITED',
    'Windrolinx software solutions private limited',
    'Nissan electronics limited',
    'FOERSTER INSTRUMENTS INDIA PRIVATE LIMITED',
    'VIVAAN FLEXI PACK PRIVATE LIMITED',
    'Karadi tales company private limited',
    'Blue neem medical devices private limited',
    'Yogeshwar implants (india ) private limited',
    'D and u healthage private limited',
    'Western india electro medical systems private limited',
    'Q max test equipments private limited',
    'Neilmed devices private limited',
    'AUSA MEDICAL DEVICES PRIVATE LIMITED',
    'Ace scientific private limited',
    'Kunash instruments private limited',
    'Newtec pro manufacturing private limited',
    'Swistar india private limited',
    'M and m engineers (gujarat) private limited',
    'UT AUTOMOTIVE DESIGN',
    'S GRIEVANCE SERVICES PRIVATE LIMITED',
    'Onus consultants private limited',
    'Urban infrastructure venture capital limited',
    'Net profit consultancy private limited',
    'Primevision investment advisors private limited',
    'Jain investment advisors private limited',
    'Creditcheck partners private limited',
    'Dr m l dhawale memorial homeopathic institute',
    'Roche diagnostics india private limited',
    'NATURE',
    'Hyphen training & consulting private limited',
    'Selectigence hr solutions private limited',
    'Group role activity for mahila interdependent network development association',
    'Right management consultants private limited',
    'Spark automation solutions (i) private limited',
    'Constantia knowledge services private limited',
    'Bajarangbali textiles private limited',
    'Arihant wellness private limited',
    'ACTIVATE DIMENSION PRIVATE LIMITED',
    'White fin private limited',
    'Alive kraft private limited',
    'Fairlinks marriages private limited',
    'Spiritual products private limited',
    'Brushion global solution private limited',
    'Hallmark solitaire private limited',
    'S s springs private limited',
    'Pg glass private limited',
    'Avon lifestyle private limited',
    'SREE KRISHNA LABELS & SOLUTIONS PRIVATE LIMITED',
    'Honicel india private limited',
    'Universal transformers private limited',
    'Winshuttle software (india) private limited',
    'Luni power company pvt ltd',
    'Green elephant pune private limited',
    'Brahm energy private limited',
    'Matrix enclaves projects developments private limited',
    'Blyth wind park private limited',
    'NABINAGAR POWER GENERATING COMPANY LIMITED',
    'Greenesol power systems private limited',
    'Poly solar parks private limited',
    'Genesis energy solutions private limited',
    'Bhavnagar biomass power projects private limited',
    'Sakhigopal integrated power company limited',
    'Suzlon gujarat wind park limited',
    'Greenkonnect energy private limited',
    'Evergreen energy enterprises (india) private limited',
    'Mvk green power private limited',
    'Yashoda energy private limited',
    'Jed solar parks private limited',
    'Drashta power consultants pvt. ltd.',
    'Qre greenesol power transformer company private limited',
    'EMERSON MEASUREMENT SYSTEMS AND SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Adiraj energy private limited',
    'Aerotech energy private limited',
    'Green elephant daund private limited',
    'KENERGY WIND POWER AND INFRASTRUCTURE Limited',
    'AURO REALTY PRIVATE LIMITED',
    'Skil lohit power private limited',
    'Vatio energy india private limited',
    'V5 water solutions private limited',
    'Srinagar banihal expressway limited',
    'New india infra buildtech limited',
    'Splendid nirman private limited',
    'Oasis epc solutions limited',
    'Vivaan buildcon projects private limited',
    'Meem procon private limited',
    'Connect infrastructure & projects private limited',
    'Sdu projects private limited',
    'MMG DEVELOPERS PRIVATE LIMITED',
    'Bombay kunststoff pharma supplies pvt ltd',
    'B.p.gangar construction pvt ltd',
    'Formatic estate investment p ltd',
    'Veema property and land developers private limited',
    'Arch intersol private limited',
    'Maharashtra state road development corporation limited',
    'Lokhandwala kataria construction private limited',
    'Kashikar constructions private limited',
    'Vhcpl-adcc pinglai infrastructure private limited',
    'Samay realtors private limited',
    'Klassic construction (pune) private limited',
    'Magestic premises private limited',
    'Niwara realtors private limited',
    'Options infra project private limited',
    'Das sez marine private limited',
    'Nandi vardhan infrastructure limited',
    'JP INFRA REALTY PRIVATE LIMITED',
    'Sigor engineering private limited',
    'Deron properties private limited',
    'Soham land development private limited',
    'Thorve patil realtors private limited',
    'Lmc projects and realty private limited',
    'Apec infrastructure private limited',
    'Manthena estates private limited',
    'G a r hotels and estates private limited',
    'Tn (dk) expressways limited',
    'Srushti baths & interiors private limited',
    'Svr constructions private limited',
    'Alekhya design house private limited',
    'Swarnamukhi developers private limited',
    'Saaksha developers private limited',
    'Rama krishna buildwell private limited',
    'Agrasen estates pvt ltd',
    'Ferrous infrastructure private limited',
    'Sunshine infrawell private limited',
    'Shankaranand estate pvt ltd',
    'Purvi properties pvt ltd',
    'Devdiya reality private limited',
    'NIRWANA AGRO & LEISURES PRIVATE LIMITED',
    'Rmz construction (india) private limited',
    'Doxa infrastructure private limited',
    'Hi lite builders private limited',
    'VARDAAN PROJECTS PRIVATE LIMITED',
    'Sahayog microfinance limited',
    'Nagar-kopargaon infrastructure private limited',
    'Shivam developers private limited',
    'Vishal earthmovers india private limited',
    'Jal vayu prakash homes private limited',
    'Syns builders private limited',
    'Mohindra ajit builders and construction private limited',
    'Promarc software private limited',
    'Pdsys technologies private limited',
    'Invitra technologies private limited',
    'Excelict technology consulting private limited',
    'Omniscient software private limited',
    'Pioneer data sys (india) private limited',
    'Panhealth technologies private limited',
    'Pixel computer private limited',
    'KIAM INTL PRIVATE LIMITED',
    'Kool studios private limited',
    'Xerces blue software solutions private limited',
    'HITACHI VANTARA SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'Savitr software services private limited',
    'Suchan infotech limited',
    'S2tech.com india private limited',
    'Om systems and services private limited',
    'Wizcom technologies private limited',
    'Idesign datasolutions private limited',
    'Fortek software solutions private limited',
    'Zen quality assurance private limited',
    'Virtumobile technologies private limited',
    'Meta business solutions private limited',
    'Kalpavriksh software solutions private limited',
    'Acn infotech private limited',
    'Cvm solutions private limited',
    'Digital nirvana information systems (india) private limited',
    'Protocol india private limited',
    'Sumith electronics private limited',
    'I-bee software soulutions pvt ltd',
    'Prutech solutions india private limited',
    'Prana engineering solutions private limited',
    'Pegasystems worldwide india private limited',
    'Iclick data source india private limited',
    'COFORGE DPA PRIVATE LIMITED',
    'Rs geoinformatics solutions private limited',
    'Votigo software private limited',
    'TECHNOGEN INDIA PRIVATE LIMITED',
    'PURVANSH HOLDINGS PRIVATE LIMITED',
    'Mazik tech solutions private limited',
    'SCREATIVES SOFTWARE SERVICES PRIVATE LIMITED',
    'Soham online solutions private limited',
    'Msecure data labs private limited',
    'Quantum data engines india private limited',
    'Viweon technologies private limited',
    'HAWIS TECH SOLUTIONS PRIVATE LIMITED',
    'OREMUS TECHNOLOGIES PRIVATE LIMITED',
    'Hasya software private limited',
    'Sb technology services private limited',
    'Prosper techsoft private limited',
    'Design master global it solutions private limited',
    'Recache it services private limited',
    'Mclob consulting services private limited',
    'Criticalys info management private limited',
    'Srivis india private limited',
    'Allied infosoft private limited',
    'BOUNTEOUS DIGITAL PRIVATE LIMITED',
    'Tenth planet technologies private limited',
    'Trivent systems private limited',
    'Jeevan technologies india private limited',
    'DIGITAL.AI SOFTWARE INDIA PRIVATE LIMITED',
    'Mahima technology private limited',
    'SILEX TECHNOLOGY INDIA PRIVATE LIMITED',
    'Escrowtech india private limited',
    'WIPRO TECHNOLOGY PRODUCT SERVICES PRIVATE LIMITED',
    'Zunotech edusystems private limited',
    'INCHCAPE SHIPPING SERVICES SSC PRIVATE LIMITED',
    'Advans it services private limited',
    'Ephron systems private limited',
    'Geoedge technologies private limited',
    'Amphisoft technologies private limited',
    'Webwings global solutions private limited',
    'Max mobility private limited',
    'Edurobo private limited',
    'Aayam infotech private limited',
    'Vista it solutions private limited.',
    'Csos corporate solutions private limited',
    'Garg data services private limited',
    'Infotech explorer india private limited',
    'Glenbrook processing systems private limited',
    'J kumar software systems (india) private limited',
    'PHILIPS VITALHEALTH SOFTWARE INDIA PRIVATE LIMITED',
    'FORTREA SCIENTIFIC PRIVATE LIMITED',
    'Arshiya technologies (india) private limited',
    'Krypsis technologies private limited',
    'Siddhi technologies & services private limited',
    'Appsoft infosystem private limited',
    'INVIXUS TECHNOLOGY & CONSULTING PRIVATE LIMITED',
    'Mahika technology solutions private limited',
    'Octaware information technologies private limited',
    'Phyder mobile solutions private limited',
    'Addition it solutions private limited',
    'ORBIT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Edmatix information systems private limited',
    'Sab weblabs private limited',
    'Cadd centre training services private limited',
    'HOLISTIC INNOVATIONS LAB PRIVATE LIMITED',
    'Gf impex private limited',
    'Sunmax hatcheries private limited',
    'Optima poultry private limited',
    'Five c foods limited',
    'Puredrops plantations and farms private limited',
    'Green sky india agro private limited',
    'Kay bee agro farms private limited',
    'Lantern green fields private limited',
    'Tejasvi farms & properties private limited',
    'Reventa crop science private limited',
    'Tierra seed science private limited',
    'Acumen technologies private limited',
    'Mahalakshmi estates private limited',
    'Duinkop enterprises private limited',
    'Agile scaffolding private limited',
    'J k agro farms private limited',
    'Aoj media private limited',
    'Tyco fire and security india private limited tr frm mah',
    'Food connection private limited',
    'Zodiac hotels private limited',
    'Anriya project management services private limited',
    'G corp projects private limited',
    'Jr housing developers private limited',
    'JHAR MINERAL RESOURCES PRIVATE LIMITED',
    'Rohne coal company private limited',
    'Prithvi natural resources private limited',
    'Pan-asia petroleum private limited',
    'S s offshore private limited',
    'Global gases india private limited',
    'Macron energy private limited',
    'Sri kumaraswamy mineral exports private limited',
    'Maxwell mines private limited',
    'Astarc mining private limited',
    'Gagan minerals private limited',
    'Vivid realestate private limited',
    'Ramamaruthi minchem industries private limited',
    'Gaba diamond private limited',
    'Pablo foods private limited',
    'Fantasy fruits & nuts private limited',
    'Aryajan ventures private limited',
    'M k jokai agri plantations private limited',
    'Heavenly foods private limited',
    'Maasafi foods limited',
    'Garg foods private limited',
    'Sri salasar balaji agro tech private limited',
    'Surabhi milkfood and beverages limited',
    'Rameswar udyog private limited',
    'Sahib international private limited',
    'Pioneer torsteel mills private limited',
    'Pondicherry agro foods private limited',
    'Creative hortifarms private limited',
    'Maxvita foods (india) private limited',
    'SINHASAN ENGINEERING PRIVATE LIMITED',
    'Manasadevi bakers private limited',
    'Indo-muscat bakery private limited',
    'Sunniva foods private limited',
    'Kisan oleochem and derivatives private limited',
    'Anand bhog foods private limited',
    'Glowwide aqua india private limited',
    'Recco foods private limited',
    'Maiyas restaurants private limited',
    'Oakwood winery private limited',
    'Redwing wines private limited',
    'Rupani spinning mills private limited',
    'Origin marketing private limited',
    'Sweta synthetics private limited',
    'Shankar tex-fab (india) private limited',
    'BAJRANG PROCESSORS PRIVATE LIMITED',
    'Sertel electronics private limited',
    'Arumugam spinning mills private limited',
    'Karur cotton mills private limited',
    'Thanga bagyaa spinning mills private limited',
    'Vijay velavan spinning mills private limited',
    'K.a.s industries india private limited',
    'M.p.shan tex private limited',
    'Panna lal woollens pvt ltd',
    'Kalpit realty and services limited',
    'Navin syntex private limited',
    'Jai baba texturisers pvt ltd',
    'Dhariyal polymers pvt ltd',
    'Hmm polyfab private limited',
    'Amtech communications pvt ltd',
    'Count n denier syntex private limited',
    'Madhusudan filaments private limited',
    'Sumati spintex private limited',
    'Surabhi cotex private limited',
    'Msk creations private limited',
    'Asr fashions private limited',
    'Varaha texfab private limited',
    'Saubhagya cotex private limited',
    'Madhu mattor pvt ltd',
    'Priyadarshan knitwear private limited',
    'Laven fashions private limited',
    'PARK PRIVIERA HOSPITALITY PRIVATE LIMITED',
    'Kanchan cotex private limited',
    'Pramukh cotex private limited',
    'Arogya textiles private limited',
    'Ageti textiles private limited',
    'Power hindustan infrastructures private limited',
    'Kh foges india private limited',
    'Kcd heritage private limited',
    'Sri lakshmi constructions and exports private limited',
    'Bk conclave private limited',
    'Ads designs private limited',
    'Marina projects private limited',
    'Bhavsagar niwas private limited',
    'Sarvlok hirise private limited',
    'Linton towers private limited',
    'Motilal hirise private limited',
    'Oversure nirman private limited',
    'Panchwati infracon private limited',
    'Jota builders private limited',
    'Quality residency private limited',
    'Premkunj residency private limited',
    'Daava realcon private limited',
    'Lucky hirise private limited',
    'Linkview housing private limited',
    'Prayas residency private limited',
    'Linkplan properties private limited',
    'Amrit realcon private limited',
    'Winsher realtors private limited',
    'Snowberry buildtech private limited',
    'Seabird niwas private limited',
    'Likewise construction private limited',
    'Active designs private limited',
    'M-tech innovations limited',
    'Saphire motors private limited',
    'Aadit ehs solutions private limited',
    'Cauvery motors private limited',
    'Mango motors private limited',
    'Yamaha motor india sales private limited',
    'Shivalik i b autocars private limited',
    'Handlair engineers private limited',
    'Samshaleen exports private limited',
    'VISHAKHA ACCOUNTING SERVICES PRIVATE LIMITED',
    'TAURRUS CORPS PRIVATE LIMITED',
    'RICHEMONT INDIA PRIVATE LIMITED',
    'Tamarin clothing (india) private limited',
    'Saptashringi marketing private limited',
    'Chenab enterprise private limited',
    'Shoolin impex private limited',
    'Vedx international private limited',
    'Synergies development & sourcing private limited',
    'E and s asia general trading private limited',
    'Bp lubricants private limited',
    'Hi-speed machining india private limited',
    'Akashdeep sales private limited',
    'Benchmark agencies private limited',
    'Divya tradelink private limited',
    'Creative engineers and services private limited',
    'Sangli turmeric cluster private limited',
    'Mendiratta business solutions private limited',
    'PANGROW TECH PRIVATE LIMITED',
    'Saraca pipes and structurals pvt ltd',
    'Vanpic projects private limited',
    'Vanpic ports private limited',
    'Genex enterprises private limited',
    'Sundeep logistics private limited',
    'Unitol training solutions private limited',
    'Scarpe marketing private limited',
    'Penshell design private limited',
    'Confidance holding private limited',
    'M d m m consultants private limited',
    'Flow techniques private limited',
    'Kalsen management consultants private limited',
    'Laurel communication & security solutions private limited',
    'Tinysurprise online services private limited',
    'INFO-MES DIGITAL AUTOMATION PRIVATE LIMITED',
    'Dnson marine private limited',
    'V-shesh learning services private limited',
    'Santhalakshmi rsm engineering solutions private limited',
    'Tulika enterprises private limited',
    'Qualitas consilium private limited',
    'Integerated engineering solution private limited',
    'Jishnu exports private limited',
    'Cnds system solutions private limited',
    'The montana international pre school private limited',
    'Lotus centre for professional studies and research private limited',
    'Iyer educational institutions private limited',
    'Universal management forum',
    'Pathway academic resource private limited',
    'Ubique learning solutions private limited',
    'Inthink edutech private limited',
    'Setrac maritime training & welfare organisation',
    'Bonfire edu india private limited',
    'Els international education pathways private limited',
    'Lok bharti skilling solutions private limited',
    'Institute of insurance and risk management',
    'Infinity knowledge city projects private limited',
    'Muvva edukul india private limited',
    'Meritus smart learning solutions private limited',
    'Acharya education services private limited',
    'Edualliance educational consultants private limited',
    'O.m. books foundation',
    'HYTECH EDUCATION CONSULTANTS PRIVATE LIMITED',
    'EDUPROGRESS AND RESEARCH PRIVATE LIMITED',
    'Think & learn private limited',
    'Kalrashukla classes private limited',
    'Ideal classes (vasai) private limited',
    'Varsity education management private limited',
    'Centre for investment education and learning private limited',
    'Wellington institute of technology management and research private limited',
    'TEJAS EDUCONNECT PRIVATE LIMITED',
    'Chidkar learning solutions private limited',
    'Mattie herbal cures',
    'Ossum healthcare private limited',
    'Offshore health services india private limited',
    'Mumukshu healthcare private limited',
    'International institute of dental research private limited',
    'Yashwant diagnostic center private limited',
    'MEDPLUS HEALTH SERVICES LIMITED',
    'Sanghamitra hospitals private limited',
    'Dhanvantri healthcare private limited',
    'Southern cogen systems private limited',
    'Remfuel bioenergy private limited',
    'Usher eco power limited',
    'Marathon energy private limited',
    'Nextgen city utilities private limited',
    'Tato hydro power private limited',
    'BAYARDS ALUMINIUM CONSTRUCTIONS INDIA PRIVATE LIMITED',
    'Vasishta energy private limited',
    'Tcw wind power private limited',
    'Spark environmental technology limited',
    'RE SUSTAINABILITY HEALTHCARE SOLUTIONS LIMITED',
    'MAHAGENCO RENEWABLE ENERGY LIMITED',
    'Greenpower energy projects private limited',
    'Urja bio system private limited',
    'Mahabubnagar solar parks private limited',
    'Clarion wind farm private limited',
    'Gaia energy solutions private limited',
    'Solar semiconductor energy systems (india) private limited',
    'Wind world wind farms (junom) private limited',
    'Vin semiconductors private limited',
    'Kvm energy private limited',
    'Ramco windfarms limited',
    'Control plus oil and gas solutions private limited',
    'Feedback energy distribution company limited',
    'NEXRISE BUILD PRIVATE LIMITED',
    'WALWHAN URJA ANJAR LIMITED',
    'Rajalakshmi renewables private limited',
    'HEXA INDUSTRIES PRIVATE LIMITED',
    'Geberit plumbing technology india private limited',
    'Nexzone water management private limited',
    'Infratech constructions services (india) private limited',
    'Nettlinx realty private limited',
    'Cresent buildtech private limited',
    'TIPSONS TECHNOLOGIES PRIVATE LIMITED',
    'Harikrupa infracon private limited',
    'Synergy concepts private limited',
    'Shah build tech private limited',
    'Cliffvale projects private limited',
    'Kelly handerson pvt ltd',
    'K raheja developers pvt ltd',
    'Amu properties and finance private limited',
    'Juhu beach real estates private limited',
    'Koyna country cottages private limited',
    'Hari infrastructure private limited',
    'Ganesh malls private limited',
    'Ruchir developers private limited',
    'MARATHON PANVEL INFRASTRUCTURES PRIVATE LIMITED',
    'NAVI MUMBAI INTERNATIONAL AIRPORT PRIVATE LIMITED',
    'Sapphire space infracon private limited',
    'Marathon nexzone land private limited',
    'V-3 builders and construction private limited',
    'SANRAJ FAMILY VENTURES PRIVATE LIMITED',
    'Unique gruh nirman private limited',
    'Tara dwellings private limited',
    'Uttampushpa developers private limited',
    'Icl construction consulting private limited',
    'Modi housing private limited',
    'Nsl nagapatnam power and infratech limited',
    'Nsl sez (hyderabad) private limited',
    'Arena infrastructure private limited',
    'Ascendant estates private limited',
    'Archies projects pvt ltd',
    'Silverline proects private limited',
    'My home infrastructures private limited',
    'Dnc infrastructure private limited',
    'Gvr infra projects limited',
    'Kavin infrastructure services private limited',
    'Subhash place management private limited',
    'Madhyam housing solutions private limited',
    'Madhyam housing private limited',
    'Dev infratrade private limited',
    'Aventure infrastructure limited',
    'Aavkar infrastructure private limited',
    'Vasudhaiva procon private limited',
    'Uniproducts (india) limited',
    'Kashyap constructions private limited',
    'Saraswati infracon india limited',
    'Midmac infrastructure private limited',
    'Sanria homes private limited',
    'Gomteshwara developers private limited',
    'Elite properties management (p) ltd.',
    'Viva jangid developers private limited',
    'FOREFRONT PRIVATE LIMITED',
    'Charbhuja infrastructure private limited',
    'Sanskar land developers private limited',
    'Fabulous food park private limited',
    'Enterprising exporters private limited',
    'Newpath realty holdings private limited',
    'Gvr rmn hubli lakshmeshwar road project private limited',
    'Gvrmp belgaum khanapur tollway private limited',
    'Nithya associates private limited',
    'Tandem construction private limited',
    'Edifice erection private limited',
    'Artmatrix properties private limited',
    'Akshar buildtech private limited',
    'Solid solutions international private limited',
    'Iinterchange systems private limited',
    'Bay-pac systems private limited',
    'Rk tech (india) private limited',
    'Infratech infrastructure services private limited',
    'MAGICK WOODS EXPORTS PRIVATE LIMITED',
    'Tad consultancy private limited',
    'Nihon technology private limited',
    'Hoorecon it-sys private limited',
    'A produle systems private limited',
    'Kolkata knowledge city private limited',
    'Softech erp solutions private limited',
    'Abm techno-matrix private limited',
    'Vim soft private limited',
    'Syntax soft-tech (india) private limited',
    'Futuristic process solutions private limited',
    'Technomics it solutions private limited',
    'Infocyber india private limited',
    'My personal health record express (india) private limited',
    'Pacicon infopower private limited',
    'Electronic payment and services private limited',
    'Aditech ict private limited',
    'S5 agency world (india) private limited',
    'Maria infotech private limited',
    'Telekinetics network systems private limited',
    'Venmitra systems private limited',
    'Defencely cloud security private limited',
    'Ace workflows private limited',
    'Wadhawan techspaces private limited',
    'C-dot systems private limited',
    'Krcs technologies private limited',
    'Adqura it solutions private limited',
    'Systems technology group (india) private limited',
    'Yalamanchili products and solutions private limited',
    'Divihn soft systems private limited',
    'Beyontec 2nable solutions private limited',
    'Krypta records management private limited',
    'EBIXCASH GLOBAL SERVICES PRIVATE LIMITED',
    'Tabs communication solutions private limited',
    'Seaview support systems private limited',
    'American infoserv private limited',
    'Venkanna software services private limited',
    'Navrita software private limited',
    'Gigabyte technology (india) private limited',
    'Data semantics private limited',
    'Crystal process management private limited',
    'Shakti info consultancy private limited',
    'Infonative solutions private limited',
    'Surbhi india technology private limited',
    'Gvc systems private limited',
    'Bvc eservices private limited',
    'Luminis consulting services private limited',
    'Protecon btg private limited',
    'Lumium innovations private limited',
    'Mantis technologies private limited',
    'Imark info360 private limited',
    'Kostcare infotech private limited',
    'Jivinc technologies private limited',
    'Orange business services india solutions private limited',
    'Verismo networks private limited',
    'Sfj business solutions private limited',
    'Mediaforge business solutions private limited',
    'Ecrm india . com limited',
    'SHOPPERS',
    'S FARMA CASA PRIVATE LIMITED',
    'Incozen therapeutics private limited',
    'Bajaj cosmetics products private limited',
    'Precious products (india) private limited',
    'Zetts cosmetics private limited',
    'Hpcl biofuels limited',
    'Jogniya explosives private limited',
    'Ordain health care global private limited',
    'YELLOWCAP INFRA PRIVATE LIMITED',
    'Uttam technologies india private limited',
    'Helios lifestyle private limited',
    'SUPRIYATA PRIVATE LIMITED',
    'Tokai rubber auto-parts india private limited',
    'Bharat rubber works private limited',
    'U-tech rubber products private limited',
    'Aeroflex india private limited',
    'Kedarnath plastics private limited',
    'Precious plasto packing private limited',
    'Suyash relesomer private limited',
    'Nifco south india manufacturing private limited',
    'Malasiya plastics and engineering private limited',
    'SOUTHCITY MOTORS Private Limited',
    'Reinforced soil technologies private limited',
    'Vishakha poly pipes private limited',
    'Devashish polymers private limited',
    'Nexstar extrusions private limited',
    'Jyoti (india) metal industries private limited',
    'Magna cement mart private limited',
    'Robust ceratech private limited',
    'Dell ceramic private limited',
    'Endeka ceramics india private limited',
    'Pavit ceramics private limited',
    'Rauschert india private limited',
    'Setco chemicals (india) private limted',
    'Rajapushpa cements limited',
    'Bulland cements private limited',
    'Jca cement trading private limited',
    'Rajapushpa holdings limited',
    'KASHI WELFAB PRIVATE LIMITED',
    'Shree raj castech private limited',
    'Akai steels private limited',
    'Jenco galva private limited',
    'Shrem alloys private limited',
    'Industrial metallics (india) private limited',
    'Shelltec engg. ancilaries india private limited',
    'Gpt steel industries limited',
    'Hi-con techno cast private limited',
    'Sanfoods and cold storage private limited',
    'Bhuwalka pipes private limited',
    'Maa banbhori steel industry private limited',
    'Dhakad metals private limited',
    'Rhj industries private limited',
    'Three pl services private limited',
    'Lucky steel false ceiling systems private limited',
    'Nikoo precision cast private limited',
    'Motherson molds and diecasting limited',
    'Dynabrade india abrasive power tools private limied',
    'Mettube india private limited',
    'Indo seals private limited',
    'Arkara engineering private limited',
    'New-age precision cast private limited',
    'Crescent heavy fabrication industry private limited',
    'VIRAJ PROFILES PRIVATE LIMITED',
    'Shreya containers limited',
    'Hothur ispat private limited',
    'R k polymer industries private limited',
    'A a toolings private limited',
    'Ksk engineering company private limited',
    'LEGREIN EXPORTS PRIVATE LIMITED',
    'Hem-sil trading and manufacturing private limited',
    'U c rai holdings pvt ltd',
    'Kosha investments limited',
    'PE EN A MARKETING PRIVATE LIMITED',
    'GOPALKRISHNA PACKAGING SOLUTIONS PRIVATELIMITED',
    'Saarthi finvest and developers private limited',
    'Saroja bhagwandas investments private limited',
    'Instant holdings limited',
    'Principal holdings (india) private limited',
    'Shrem investments private limited',
    'Hope microcredit finance (india) private limited',
    'Brd chits limited',
    'Rohsun consultants private limited',
    'V. rama krishna sons private limited',
    'Harita srinivasan private limited',
    'Kgeyes investments private limited',
    'Systematix shares and stocks (india) limited',
    'Splendor finance limited',
    'UJJIVAN FINANCIAL SERVICES Limited',
    'Chandrapore estates private limited',
    'Phillip finance & investment services india private limited',
    'Metropolitan stock exchange of india limited',
    'Chamdol trading and investment services private limited',
    'Acepro advisors private limited',
    'Jhp finvest private limited',
    'Gayathri tax consultants private limited',
    'Unilight insurance brokers private limited',
    'Equus advisors and technology solutions private limited',
    'Jai mata di financial solutions private limited',
    'Phillip (india) private limited',
    'DEALMONEY DISTRIBUTION AND ADVISORY SERVICES PRIVATE LIMITED',
    'Neesa venture holdings limited',
    'ARTIFICE DISTRIBUTORS PRIVATE LIMITED',
    'Sivan securities private limited',
    'Vakrathunda holding private limited',
    'Zerodha commodities private limited',
    'Savasthi investments limited',
    'Kanchansobha finance private limited',
    'Ovation investment and trading p.ltd.',
    'Sarsan securities p ltd',
    'Crown sharebroker private limited',
    'Vbd capital advisors private limited',
    'FEDEX SECURITIES PRIVATE LIMITED',
    'VRISE SECURITIES PRIVATE LIMITED',
    'Divyajyoti holdings private limited',
    'Phillip commodities india private limited',
    'Robocom investment consultants private limited',
    'Aman share trading limited',
    'A-rank holdings private limited',
    'Blue dart finance & consultancy services ltd',
    'Raima equities private limited',
    'Synergy financials management (india) private limited',
    'Ablaze fincon limited.',
    'Dream forex private limited',
    'ETS SECURITIES PRIVATE LIMITED',
    'Vowel finance and leasing private limited',
    'True capital and finance private limited',
    'Karvy financial services limited',
    'Kroesus consulting private limited',
    'Regulus capital advisors private limited',
    'AEGIS WEALTH MANAGEMENT LIMITED',
    'Prudence finserv private limited',
    'Jayabheri properties private limited',
    'Securisk insurance brokers private limited',
    'Sandstone capital advisors private limited',
    'Vsan infrastructure private limited',
    'Capital commerce private limited (trf)',
    'Ecoreco ventures private limited',
    'Abha real estate private limited',
    'Myluck housing private limited',
    'Anekanta realtors private limited',
    'UNACORES SOLUTIONS PRIVATE LIMITED',
    'Terrapolis commercial private limited',
    'Ami infra projects private limited',
    'Vardaan developers india private limited',
    'Agc lands private limited',
    'Crossdomain solutions private limited',
    'Gowda corporate estates private limited',
    'Raintree realtors india private limited',
    'Virtus investments india private limited',
    'Vista properties pvt ltd',
    'Zahid properties private limited',
    'Inertia infotech private limited',
    'Sahana builders and developers private limited',
    'SWAPNALOK MEDIA & TECHNOLOGY PRIVATE LIMITED',
    'Kings field reality developers private limited',
    'Precision polyplast private limited',
    'Mantadhari tea estates private limited',
    'Bellmount enterprises private limited',
    'Titanium homes private limited',
    'Aright infra private limited',
    'Varambally properties private limited',
    'Kedia securities pvt ltd',
    'Deelen properties private limited',
    'Epsilon clinical research private limited',
    'Manipal hospitals (dwarka) private limited',
    'Bmh care hospital limited',
    'Producin private limited',
    'Yashodhara super-speciality hospital private limited',
    'Delonix healthcare private limited',
    'KAUVERY HOSPITAL MEDICAL SERVICES PRIVATE LIMITED',
    'Ads dental hospital & implant centre private limited',
    'Sushumna yoga private limited',
    'AMELIO EARLY EDUCATION PRIVATE LIMITED',
    'Synergizers sustainable foundation',
    'AFFORDABLE QUALITY HEALTH',
    'SWAZTHA WAY 2 HEALTH PRIVATE LIMITED',
    'Himshikha development project',
    'West bengal nepal chamber of commerce and industry',
    'Borg energy india private limited',
    'Time tech waste solutions private limited',
    'INDIAN RESINS MANUFACTURERS ASSOCIATION',
    'Deccan chamber of commerce industries & agriculture pune',
    'Ahmedabad association of builders and developers',
    'Filmkraft productions (india) private limited',
    'Loading pictures private limited',
    'Digiquest blueswan productions private limited',
    'Ayngaran international media private limited',
    'Jayabheri entertainments private limited',
    'White water mass media private limited',
    'Elixir logical thinkers movies private limited',
    'EOE INDIA SOLUTIONS PRIVATE LIMITED',
    'Mega reach novex communications private limited',
    'Indian rhythm and arts association',
    'CITY PULSE MULTIPLEX LIMITED',
    'Phillipcapital (india) private limited',
    'Qi(india)health care private limited',
    'Boost shoe company private limited',
    'Globetor gaming projects private limited',
    'Team sportzconsult private limited',
    'G5a foundation for contemporary culture',
    'Ecosteps laboratory private limited',
    'V care support services private limited',
    'John 3:16 mission foundation',
    'Four axes business solutions private limited',
    '3S HIVETECH PRIVATE LIMITED',
    'WIRECARD INDIA PRIVATE LIMITED',
    'Minimax ads private limited',
    'Art d space private limited',
    'Pritesh secura solution facility management and services india private limited',
    'Terramatic solutions private limited',
    'Loyalty marine services private limited',
    'Syncspace solutions private limited',
    'Twist studio entertainment private limited',
    'Swan suites & services private limited',
    'Fine three enterprises private limited',
    'Iglyte advertising and marketing services private limited',
    'Astro security services private limited',
    'Pioneer facilities private limited',
    'Youdoo healthcare management private limited',
    'Solarika india private limited',
    'Forum for the future india private limited',
    'Pink hash financial services private limited',
    'TELEMEDIA MANAGEMENT HOLDINGS PRIVATE LIMITED',
    'Vikran fashions private limited',
    'Sepc power private limited',
    'Signals and systems (india) private limited',
    'Ronuk industries private limited',
    'Hyd-air engineering pvt ltd',
    'Dhanvanthri engineers pvt ltd',
    'Rakim investments pvt ltd',
    'Logicon engineers private limited',
    'Mandeep investments pvt ltd',
    'Raj restaurant pvt.ltd.',
    'Symatic engineering private limited',
    'WALKE',
    'S CREATIVE AGENCY PRIVATE LIMITED',
    'Kaleidoscope marketing communications private limited',
    'Adcraft outdoor media private limited',
    'Eye ads private limited',
    'Take wing communication private limited',
    'Srichakra communications private limited',
    'Kusum granites private limited',
    'Best colour solutions india private limited',
    'Farouk sodagar darvesh & co. private limited',
    'Sudarshan extrusions private limited',
    'Bhoruka steel and services limited',
    'Dakshin foundry private limited',
    'Tex tech industries india private limited',
    'Flexible automation systems private limited',
    'Talema electronic india private limited',
    'S r v e industries limited',
    'Srivari infra structure private limited',
    'Forstar frozen foods private limited.',
    'Seven seas india private limited',
    'Neeli aqua private limited',
    'Bharat luxindo agrifeeds private limitedd',
    'Dhruva imaging private limited',
    'Mohan projects private limited',
    'Priority projects private limited',
    'Network homes private limited',
    'Star india awas private limited',
    'I-nurture education solutions private limited',
    'King coal and energy private limited',
    'Stutie mining (india) private limited',
    'Chhattisgarh natural resources private limited',
    'Ultra tech coal private limited',
    'Skn gas private limited',
    'Sparc oilfield services private limited',
    'Arcata petroleum private limited',
    'Ascent hydro projects limited',
    'United steels international private limited',
    'Vassantram metha and company private limited',
    'The andhra pradesh mineral devevelopment corporation limited',
    'Svg exports private limited',
    'Goodwin granites private limited',
    'Rajapuram rock products private limited',
    'Thulunadan granites private limited',
    'Sakthi aggregates products private limited',
    'Galala granites private limited',
    'Grandwin rock products private limited',
    'Sahara granites private limited',
    'Micro carbonates private limited',
    'Salasar inframines private limited',
    'Bhudhan mining private limited',
    'Rajas marble industries private limited',
    'Nawa salts private limited',
    'Tec datum infoservices private limited',
    'Archean salt holdings private limited',
    'Greenstone rock products private limited',
    'Lavagold rock private limited',
    'IQ INVESTIVENTURE LIMITED',
    'SARAS MINING & MINERALS PRIVATE LIMITED',
    'Min rocks international private limited',
    'Shanmugha granite industries private limited',
    'Capithan marine exports (india) private limited',
    'GIRNAR FOOD AND BEVERAGES PRIVATE LIMITED',
    'Goodlife industries limited',
    'Pasupala foods private limited',
    'Avyaktt oils private limited',
    'Simplot india foods private limited',
    'Kdelite foods limited',
    'Annapurna universal foods private limited',
    'Food barn (india) private limited',
    'Safa food products private limited',
    'Maa uttar bahini rice mill private limited',
    'G-one agro products limited',
    'Nesso green tea private limited',
    'Raj oil mills (mumbai) private limited',
    'MAHALAKSHMI OILS PVT. LTD.',
    'Nirvedh oil and agro products private limited',
    'R p k agrotech exports private limited',
    'Sovereign dairy industries limited',
    'Aria dairy farms private limited',
    'Dairy classic ice creams private limited',
    'Honeycomb retail (india) private limited',
    'Goverdhan milk private limited',
    'Storeex solutions private limited',
    'Tit bit foods (india) private limited',
    'Natures basket limited',
    'Sms international beverages private limited',
    'Shivaji roller flour mills private limited.',
    'Perfect poultry products private limited',
    'Utkal feeds private limited',
    'Natural frozen foods limited',
    'K-SURE AGROTECH PRIVATE LIMITED',
    'Nagrewal food products private limited',
    'Ifg innovative foods private limited',
    'R t agro private limited',
    'Global vetmed concepts india private limited',
    'Snj sugars and products limited',
    'Padmaadevi sugars limited',
    'MAAN RESTAURANT PRIVATE LIMITED',
    'Decadent foods private limited',
    'Herbs and spice catering private limited',
    'Food finders private limited',
    'The devicolam distilleries ltd',
    'Prag distillery private limited',
    'CAPRICORN BLENDERS PRIVATE LIMITED',
    'Ace beveragez private limited',
    'Punjabexpo breweries private limited',
    'Tern distilleries private limited',
    'Pure life office systems private limited',
    'Bacardi india private limited',
    'Rahamankhan tobacco enterprises private limited',
    'Lav-kush farms private limited',
    'Kailash rolfo india private limited',
    'Seagold shipping (india) private limited',
    'Wilhelmsen ship management (india) private limited',
    'Marine solutions distribution and services private limited',
    'ENHANSAFE INDIA PRIVATE LIMITED',
    'Avipro india private limited',
    'Windals precision private limited',
    'Super auto forge private limited',
    'Sagar ispat india private limited',
    'Nexus technocrafts automations & solutions private limited',
    'Greenleaf interiors private limited',
    'Traverse outdoor gear private limited',
    'Promp + tech pharma equipments (india) private limited',
    'SLEEP CRAFT RETAIL PRIVATE LIMITED',
    'ALONA KITCHENETTE & INTERIORS PRIVATE LIMITED',
    'Podo lite footcare private limited',
    'Romeo polymers private limited',
    'Manubhai zaveri ornaments private limited',
    'Delish gourmet private limited',
    'Revashankar gems limited',
    'Saiesha jewellery private limited',
    'Fine gems export pvt.ltd.',
    'Aryarth bullion private limited',
    'Akshaya jewellers private limited',
    'THIRD WAVE RUGGEDTECH PRIVATE LIMITED',
    'Harmony musical instruments (madras) private limited',
    'Koochie play systems private limited',
    'Hugo play private limited',
    'Advanced animal nutrition private limited',
    'Kangaro metaplast private limited',
    'SAROJ ROOFING PRIVATE LIMITED',
    'Rex instruments private limited',
    'SHOBHA ASARS PRIVATE LIMITED',
    'Comma retail support services private limited',
    'Anjaria enviro tech private limited',
    'Vinal tech private limited',
    'Krl recyclers limited',
    'Ecosanitaz green solutions private limited',
    'Verve cement additives private limited',
    'Gold star jewellery private limited',
    'Dharia switchgears and controls private limited',
    'En power solutions private limited',
    'Udangudi power corporation limited',
    'Bollywood tourism private limited',
    'Yugh impex india private limited',
    'Opus dei logistics (india) private limited',
    'Vodka amusement rides private limited',
    'Dsb consultancy private limited',
    'Ym tech consulting private limited',
    'UNISYNTH OVERSEAS LIMITED',
    'Krian media limited',
    'Arha consulting private limited',
    'Eduramp learning services private limited',
    'Piramal flight systems private limited',
    'Pharmintech turnkey solutions private limited',
    'PAYCRAFT URBAN SOLUTIONS PRIVATE LIMITED',
    'Green elephant engineering private limited',
    'Gurit (india) private limited',
    'Urban link consulting private limited',
    'Dataction analytics private limited',
    'Access global services india private limited',
    'Retail direct private limited',
    'Dhanvi processing and packaging private limited',
    'Rohini signs private limited',
    'Apex hr management solutions private limited',
    'Zumigo india private limited',
    'HUB RENEWABLE ENERGY PRIVATE LIMITED',
    'Flowian solutions private limited',
    'Siddharth eco-bags private limited',
    'Farida prime tannery private limited',
    'Continental conveyors private limited',
    'Jehangir lentin estates private limited',
    'Nissiwood veneers private limited',
    'Maple mouldings private limited',
    'Brothers wood trek india private limited',
    'Divine veneer and plywood pvt ltd',
    'Cauvery saw mills private limited',
    'MONARCH ERGO PRIVATE LIMITED',
    'D s doors (india) limited',
    'Khatema fibres limited',
    'Paper packaging private limited',
    'Fast packs pvt ltd',
    'Seshaasai business forms pvt ltd',
    'N desai papers pvt ltd',
    'Balaje corrugated cartons private limited',
    'K. b. tea product private limited',
    'Index packaging private limited',
    'Maxim label & packaging (india) private limited',
    'Gautam finepack private limited',
    'Kores (india) limited',
    'Headword publishing company private limited',
    'Yorke communications private limited',
    'Daijiworld publications private limited',
    'Maruti media advertising private limited',
    'Mark entertainment private limited',
    'Inspired prints private limited',
    'Nap-dot graphics systems pvt.ltd.',
    'Rashtra deepika news corporation private limited',
    'GOPSONS PAPERS PRIVATE LIMITED',
    'Suryajit publications private limited',
    'Nirupshah design studio private limited',
    'Higrid imaging solutions private limited',
    'Reality premedia services private limited',
    'Mohini prints (madras) private limited',
    'Bharat katha offset pvt ltd',
    'Vykat prints private limited',
    'SREE D',
    'S SILICON VALLEY (OPC) PRIVATE LIMITED',
    'SCIFORN SOLUTIONS PRIVATE LIMITED',
    'MONITA TECHNO FOOD (INDIA) PRIVATE LIMITED',
    'NEXPATH LABORATORIES PRIVATE LIMITED',
    'CYGNUM SQUARES CONSTRUCTION PRIVATE LIMITED',
    'EDU GLOBAL CAREERS PRIVATE LIMITED',
    'SPYBLOOD HEALTHCARE PRIVATE LIMITED',
    'RECY ENERGY PRIVATE LIMITED',
    'GULF SKIDS ENGINEERING SERVICES PRIVATE LIMITED',
    'AGRANI RURBAN DEVELOPMENT FOUNDATION',
    'MINGLE STUDIO PRIVATE LIMITED',
    'DIMENSIONS TO DESIGNE PRIVATE LIMITED',
    'BIOLUKE PHARMACEUTICALS PRIVATE LIMITED',
    'VISAXPRESS EDUCATION & MIGRATION CONSULTANTS PRIVATE LIMITED',
    'NATIONAL CENTRE FOR ADDITIVE MANUFACTURING FOUNDATION',
    'INCILO LOGISTICS PRIVATE LIMITED',
    'TAMIL NADU CENTRE OF EXCELLENCE FOR ADVANCED MANUFACTURING',
    'HINDUSTAN GAMING PRIVATE LIMITED',
    'VSMART AGROTECH PRIVATE LIMITED',
    'SHIRYAM TECHNOLOGIES PRIVATE LIMITED',
    'SEVENTH HORSE AGRI-TECH PRIVATE LIMITED',
    'LWM CELEBRATIONS PRIVATE LIMITED',
    'HOMEBOUND LIFESTYLES PRIVATE LIMITED',
    'CABAI TECHNOLOGIES PRIVATE LIMITED',
    'ADDRESS INDIA PRIVATE LIMITED',
    'HAATHI CONCRETE MIXTURES PRIVATE LIMITED',
    'AADHI GLASS PRIVATE LIMITED',
    'ZUS PAUL COFFEE PRIVATE LIMITED',
    'ADP ASCENT BEAUTY PRIVATE LIMITED',
    'ALPHA CARNIVORE PRIVATE LIMITED',
    'FP ALPHA PRIVATE LIMITED',
    'ML ENCLAVE PRIVATE LIMITED',
    'VIVA MOTORS COMMERCIAL PRIVATE LIMITED',
    'AISHWARYA AVANT BUILDERS PRIVATE LIMITED',
    'EARNVALUE MEDIA PRIVATE LIMITED',
    'TRUPARTS TECHNOLOGY PRIVATE LIMITED',
    'ARUSHI PANDIT FOUNDATION',
    'INFOLAB NETWORKS PRIVATE LIMITED',
    'SHAKTI EV MOBILITY PRIVATE LIMITED',
    'RENOWIN ECOMMERCE PRIVATE LIMITED',
    'REFEX AIRPORTS AND TRANSPORTATION PRIVATE LIMITED',
    'PANAAYA TECHNOLOGIES PRIVATE LIMITED',
    'KREATE TECHNOLOGIES PRIVATE LIMITED',
    'LIFTONICS MATERIAL HANDLING EQUIPMENT MANUFACTURERS PRIVATE LIMITED',
    'DIGIFFICIENT SOLUTIONS PRIVATE LIMITED',
    'HOABL LANDBUILD PRIVATE LIMITED',
    'BANDISH PRODUCTIONS PRIVATE LIMITED',
    'ELEON SKINCARE PRIVATE LIMITED',
    'TCL INTERMEDIATES PRIVATE LIMITED',
    'ORGRAMEEN BIOPRODUCTS PRIVATE LIMITED',
    'GORTONSHIRE ELITE SPORTS PRIVATE LIMITED',
    'SEEBURGER INDIA PRIVATE LIMITED',
    'SUPARNA DWELLINGS PRIVATE LIMITED',
    'IKZ TECHNOLOGY PRIVATE LIMITED',
    'JPIN IT SERVICES PRIVATE LIMITED',
    'ADVISORYNEST INDIA PRIVATE LIMITED',
    'BARASINGHA HOSPITALITY PRIVATE LIMITED',
    'PARIKRANTI FOUNDATION',
    'RITZ7 AUTOMATIONS PRIVATE LIMITED',
    'UNIYOU PRIVATE LIMITED',
    'TRAILER LOGISTICS INDIA PRIVATE LIMITED',
    'ARABELLA MODE INDIA PRIVATE LIMITED',
    'WONTR (OPC) PRIVATE LIMITED',
    'J&A REALTECH PRIVATE LIMITED',
    'GDN TRAVELS PRIVATE LIMITED',
    'SDAU RURAL BUSINESS INCUBATION CENTRE',
    'BLUEAPP SOFTWARE PRIVATE LIMITED',
    'DEEPRICH INTERNATIONAL PRIVATE LIMITED',
    'CISV INDIA PRIVATE LIMITED',
    'FAIMATECH ENGINEERS PRIVATE LIMITED',
    'RENEW VIDYUT TEJ PRIVATE LIMITED',
    'KAB MANSION PRIVATE LIMITED',
    'ADSIFY MARKETING PRIVATE LIMITED',
    'AKBARALI CONSTRUCTION PRIVATE LIMITED',
    'JOGMAYA ENTERTAINMENT PRIVATE LIMITED',
    'VAIYAM FOODS PRIVATE LIMITED',
    'VN SAMARTH CORPORATE SERVICES PRIVATE LIMITED',
    'LAB2LAND AGRITECH SOLUTIONS PRIVATE LIMITED',
    'PHA TEXTILES PRIVATE LIMITED',
    'DCODE INSIGHTS PRIVATE LIMITED',
    'KRIARJ BUSINESS CONSULTANTS (OPC) PRIVATE LIMITED',
    'I-BHASHA EDTECH PRIVATE LIMITED',
    'NICHEBY PRIVATE LIMITED',
    'SUPARNA REALTORS PRIVATE LIMITED',
    'KRISHIM TECH PRIVATE LIMITED',
    'NEXUS DAY SURGERY CENTERS PRIVATE LIMITED',
    'PRAYASH ANALYTICS PRIVATE LIMITED',
    'DUTTCO LIFESPACE PRIVATE LIMITED',
    'VASANTNAND FARMER PRODUCER COMPANY LIMITED',
    'SANNA CAPITAL PRIVATE LIMITED',
    'SPAWNSER PRIVATE LIMITED',
    'GAHLAWAT FARMER PRODUCER COMPANY LIMITED',
    'KINGVISH PRIVATE LIMITED',
    'GO DIGIT LIFE INSURANCE LIMITED',
    'ELECTROCEAN TECHNOLOGIES PRIVATE LIMITED',
    'STRIBON NEXTGEN PRIVATE LIMITED',
    'AVANTHIYA PHARMA PRIVATE LIMITED',
    'VOSTRO BANKING ADVISORS PRIVATE LIMITED',
    'CLIMAJO PRIVATE LIMITED',
    'AIRDATA TECHNOLOGIES PRIVATE LIMITED',
    'SAEYON CONSTRUCTION EQUIPMENT (OPC) PRIVATE LIMITED',
    'SAMCO CONSULTING ENGINEERS PRIVATE LIMITED',
    'UNOMINDA AUTO SYSTEMS PRIVATE LIMITED',
    'BENEFITSKLUB TECHNOLOGIES PRIVATE LIMITED',
    'NUUTJOB LIMITED',
    'UNOMINDA EV SYSTEMS PRIVATE LIMITED',
    'CHERRYAUTO PRIVATE LIMITED',
    'BP RESIDENCY PRIVATE LIMITED',
    'KLEREN CLOTHINGS PRIVATE LIMITED',
    'OWAR BILLPOINT SERVICES PRIVATE LIMITED',
    'TEKNORIX TECHNOLOGIES PRIVATE LIMITED',
    'CHEMICALS INDIA PRIVATE LIMITED',
    'LSA LIFE SCIENCE ACADEMY PRIVATE LIMITED',
    'BP ENCLAVE PRIVATE LIMITED',
    'MRD NIVAS PRIVATE LIMITED',
    'S2 DATA SYSTEMS PRIVATE LIMITED',
    'INDER WAREHOUSING INDIA PRIVATE LIMITED',
    'PAHAL DIGITAL INDIA PRIVATE LIMITED',
    'AHZ STUDY ABROAD PRIVATE LIMITED',
    'MAGNE MOTORSPORT PRIVATE LIMITED',
    'TRANSCOTECH PRIVATE LIMITED',
    'AI.XYZ SERVICES PRIVATE LIMITED',
    'WINICE FURNISHERS PRIVATE LIMITED',
    'TRANSGREEN AGRO AND LOGIX PRIVATE LIMITED',
    'BP NIVAS PRIVATE LIMITED',
    'KALINGA ALUMINA LIMITED',
    'ARCHE RESOURCES PRIVATE LIMITED',
    'FLORAWARE RETAIL PRIVATE LIMITED',
    '70MM DIGIVERSE PRIVATE LIMITED',
    'FIIANALYTICS TECHNOLOGIES PRIVATE LIMITED',
    'OJASAM CONSULTING & SERVICES PRIVATE LIMITED',
    'AGAINST ALL ODDS(AAO) BLOCKTECH PRIVATE LIMITED',
    'PAKMANN INNOVENTIONS PRIVATE LIMITED',
    'ELATED PHARMA INDIA PRIVATE LIMITED',
    'SGMG PRODUCTS OVERSEAS PRIVATE LIMITED',
    'PANELIQ TECHNOLOGIES PRIVATE LIMITED',
    'EDUKRAFTZ FURNITURE PRIVATE LIMITED',
    'TECHNOSMART AUTOMATION PRIVATE LIMITED',
    'SUNRAJ CORRUGATORSS PRIVATE LIMITED',
    'JUMPCLOUD INDIA PRIVATE LIMITED',
    'INNOVATIVE POLYCOATS PRIVATE LIMITED',
    'VNEXTGEN IT SOLUTIONS PRIVATE LIMITED',
    'TATA ASSET MANAGEMENT PRIVATE LIMITED',
    'PRIDECONTROLS & SYSTEMS PRIVATE LIMITED',
    'SNSGAP TRADING PRIVATE LIMITED',
    'EURO SAFETY NONWOVENS PRIVATE LIMITED',
    'DENIM VISTARA GLOBAL PRIVATE LIMITED',
    'GIGACURE HEALTHCARE ANALYTICS PRIVATE LIMITED',
    'ENCEPHALON HITECH PRIVATE LIMITED',
    'TRESOR HEALTHCARE PRIVATE LIMITED',
    'MGSP ENGINEERS PRIVATE LIMITED',
    'BADHO INDIA PRIVATE LIMITED',
    'ROECHLING INDUSTRIAL INDIA PRIVATE LIMITED',
    'FINO PAYMENTS BANK LIMITED',
    'ALIG CONVEYOR AUTOMATION PRIVATE LIMITED',
    'SUNSOIL PRIVATE LIMITED',
    'IPSONS PHARMA EQUIPMENTS PRIVATE LIMITED',
    'RENEW E-FUELS PRIVATE LIMITED',
    'INFINITE GROUP EDUCATION CONSULTANT PRIVATE LIMITED',
    'JAKSON GREEN PRIVATE LIMITED',
    'EQUIRUS FINANCE PRIVATE LIMITED',
    'AXIS PENSION FUND MANAGEMENT LIMITED',
    'IIFL OPEN FINTECH PRIVATE LIMITED',
    'NSL GREEN STEEL RECYCLING LIMITED',
    'SHILPA PHARMA LIFESCIENCES LIMITED',
    'NUTRIVENTIA LIMITED',
    'P.A.R.K. FELTS PRIVATE LIMITED',
    'LIVOSO TECHNOLOGIES PRIVATE LIMITED',
    'FILINGHOUR FINANCIAL SERVICES PRIVATE LIMITED',
    'CALIFONIX TECH AND MANUFACTURING PRIVATE LIMITED',
    'INVENTPHILE VENTURES PRIVATE LIMITED',
    'ICONIX LIFESTYLE INDIA PRIVATE LIMITED',
    'SBL KNOWLEDGE SERVICES PRIVATE LIMITED',
    'CONTAINER AND SHIPPING INSPECTION SERVICES PRIVATE LIMITED',
    'AMBITECH HEALTHCARE PRIVATE LIMITED',
    'AGP KARAIKAL LNG PRIVATE LIMITED',
    'ANA DATA CONSULTING PRIVATE LIMITED',
    'S K D C CONSULTANTS LIMITED',
    'FOUNDRY RESOURCE PLANNING AND CONSULTING PRIVATE LIMITED',
    'COFORGE SOLUTIONS PRIVATE LIMITED',
    'DREAM VALLEY GOLF AND RESORTS LIMITED',
    'JUNGBUSCH ALES INDIA PRIVATE LIMITED',
    'LE-STYLE ENTERPRISE PRIVATE LIMITED',
    'SS AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'AROMEE BRANDS PRIVATE LIMITED',
    'TPI GLOBAL SSC INDIA PRIVATE LIMITED',
    'STELLARO BRANDS PRIVATE LIMITED',
    'SAGE BUSINESS TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'CEIGALL INDIA LIMITED',
    'SULA VINEYARDS LIMITED',
    'VERB DANCE STUDIO PRIVATE LIMITED',
    'DTIG PRIVATE LIMITED',
    'KEERTANA FINSERV PRIVATE LIMITED',
    'INTERLINK ENGAGE PRIVATE LIMITED',
    'PACKFORA SOLUTIONS PRIVATE LIMITED',
    'OPSEC ONLINE INDIA PRIVATE LIMITED',
    'ANNAPURNA SWADISHT LIMITED',
    'SUKHVARSHA PROJECTS PRIVATE LIMITED',
    'CENTRE FOR TEACHER ACCREDITATION (CENTA) PRIVATE LIMITED',
    'ADM INVESTMENT MANAGER INDIA PRIVATE LIMITED',
    'LIVLONG PROTECTION & WELLNESS SOLUTIONS LIMITED',
    'CATERHERO TECHNOLOGIES PRIVATE LIMITED',
    'AVENUE SOUND PRIVATE LIMITED',
    'BLUE CROSS ENGINEERING PRIVATE LIMITED',
    'FABEN INDIA PRIVATE LIMITED',
    'VISHKO22 PRODUCTS & SERVICES PRIVATE LIMITED',
    'FLEET LABS TECHNOLOGIES PRIVATE LIMITED',
    'TATA CLASSEDGE LIMITED',
    'TADAS WIND ENERGY PRIVATE LIMITED',
    'GRASIM BUSINESS SERVICES PRIVATE LIMITED',
    'ADL COORDINATES PRIVATE LIMITED',
    'HELIUS TECHNO ENGINEERS PRIVATE LIMITED',
    'SAPIENT HEALTH & BEAUTY PRIVATE LIMITED',
    'Smaart fire protection private limited',
    'Rvt media private limited',
    'Tuticorin energy private limited',
    'Matrubhoomi developers private limited',
    'Gokani consultants private limited',
    'Premium build tech private limited',
    'V r avenues india private limited',
    'Taranjit textile and commercial private limited',
    'Life care medical systems enterprises private limited',
    'Villa trading company private limited',
    'Mempris overseas private limited',
    'Manipal hospitals (jaipur) private limited',
    'GAJJRAJ AGENCY PRIVATE LIMITED',
    'MONISHA SRI DURGA FARMS PVT LTD,',
    'Health & glow retailing private limited',
    'Avenue 2 revenue media private limited',
    'Axis private equity limited',
    'SHRADDHA LEGACY PROPERTIES PRIVATE LIMITED',
    'Ratnabali commodities private limited',
    'Danvar foods private limited',
    'NEEL PAPER LINKS PRIVATE LIMITED',
    'Aryan hi-rise private limited',
    'Gurcharan singh engineers private limited',
    'CREST GEARTECH PRIVATE LIMITED PVT LTD',
    'Cbl industries limited',
    'PRIORITY VENDOR TECHNOLOGIES PRIVATE LIMITED',
    'Moria tea estate limited',
    'Flury s swiss confectionery private limited',
    'Westernland dairy private limited',
    'M p tapes private limited',
    'Chicos fashions private limited',
    'BARRY O',
    'SAGE AND SAFFRON HOSPITALITY PRIVATE LIMITED',
    'SKYHIND TOURS AND TRAVELS PRIVATE LIMITED',
    'SVLN SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'STEPS & LADDERS EDUTECH PRIVATE LIMITED',
    'BAJAJ FINSERV MUTUAL FUND TRUSTEE LIMITED',
    'EONIAN FUEL PRIVATE LIMITED',
    'SOIL STRATA PRIVATE LIMITED',
    'FOCIS PHARMACEUTICAL PRIVATE LIMITED',
    'CARIBOU FARMS PRIVATE LIMITED',
    'VITAL WELLNESS LIMITED',
    'NYALA FARMS PRIVATE LIMITED',
    'SHUNYA FINTECH PRIVATE LIMITED',
    'WILDEBEEST FARMS PRIVATE LIMITED',
    'CHRONOMETRIK EXPORTS PRIVATE LIMITED',
    'GYM WISE INDIA PRIVATE LIMITED',
    'DIGITACTIX PRIVATE LIMITED',
    'R HOUSE REALTY PRIVATE LIMITED',
    'PROVEVO DESIGN PRIVATE LIMITED',
    'HELSINKY FOODS PRIVATE LIMITED',
    'LIVRO SHIPPING PRIVATE LIMITED',
    'BANDAR TREE PRIVATE LIMITED',
    'ALSORG FOUNDATION',
    'TRIDGE TRADE INDIA PRIVATE LIMITED',
    'HASHOPS AI LABS PRIVATE LIMITED',
    'KV MEDICREST LOGISTICS PRIVATE LIMITED',
    'TRAITSOFT PRIVATE LIMITED',
    'BIOMETRIC CARE SERVICES INDIA PRIVATE LIMITED',
    'SUTRAA TECHNOSOFT PRIVATE LIMITED',
    'RESU INFRACON PRIVATE LIMITED',
    'UMARGAM KRUSHI VIKAS WOMEN FARMER PRODUCER COMPANY LIMITED',
    'OJASVIT TECHNO PRIVATE LIMITED',
    'VALANTIC CONSULTING INDIA PRIVATE LIMITED',
    'PARTSEZI PRIVATE LIMITED',
    'URBAN MELANGE PRIVATE LIMITED',
    'RETHINK LABS PRIVATE LIMITED',
    'VC E-WASTE ENG PRIVATE LIMITED',
    'BLANK LABS PRIVATE LIMITED',
    'EASTERN INDIA TEA SPARES & ENGINEERING PRIVATE LIMITED',
    'TECHNODUXX PRIVATE LIMITED',
    'NITHRAAN ENERGY PRIVATE LIMITED',
    'ECLAIRER VENTURE PRIVATE LIMITED',
    'PERFECT POINT ADVISORS PRIVATE LIMITED',
    'SAMYA DEVELOPMENT RESOURCES PRIVATE LIMITED',
    'ACTIVE360 TECHNOLOGIES PRIVATE LIMITED',
    'ZENITHRAIL EDVARSITY PRIVATE LIMITED',
    'ITFOX LAB PRIVATE LIMITED',
    'APPASANI ESTATES PRIVATE LIMITED',
    'MERMEDS LIFESCIENCES PRIVATE LIMITED',
    'HARIT PRADESH MILK PRODUCER COMPANY LIMITED',
    'RUPRAJ DIGITAL SOLUTIONS PRIVATE LIMITED',
    'HILLTOP SEZ DEVELOPMENT INDIA PRIVATE LIMITED',
    'ULTRANUTRI INDIA PRIVATE LIMITED',
    'DIGIMARKET OPERATIONS PRIVATE LIMITED',
    'HARBOUR INN PRIVATE LIMITED',
    'ROSTRUM EDTECH PRIVATE LIMITED',
    'SKYZER INDIA (OPC) PRIVATE LIMITED',
    'OMNICS TECHNOLOGIES PRIVATE LIMITED',
    'NEBULINX PRIVATE LIMITED',
    'RAICHAND MANAGEMENT PRIVATE LIMITED',
    'TRUE SCALE ENGINEERING PRIVATE LIMITED',
    'EVOLVEX BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANTARYAMIN SOLUTIONS PRIVATE LIMITED',
    'MICRO ELEVATORS INDIA LIMITED',
    'RAICHAND TRADING PRIVATE LIMITED',
    'OPENFUSION INDIA PRIVATE LIMITED',
    'HIGHRICES TECHNOLOGIES PRIVATE LIMITED',
    'CLEARTRADE.AI PRIVATE LIMITED',
    'HYPER GROCERS PRIVATE LIMITED',
    'ARABIAN INDUSTRIES INDIA PRIVATE LIMITED',
    'HEAL.EXPERT PRIVATE LIMITED',
    'AMIPOLYMER CSR FOUNDATION',
    'PROPGENIES INFRA TECH PRIVATE LIMITED',
    'MOUNTAIN LIVING PRIVATE LIMITED',
    'CLEAN EMISSIONZ INDIA PRIVATE LIMITED',
    'NRG ORGANICS PRIVATE LIMITED',
    'EVREX TECH PRIVATE LIMITED',
    'CLOC ONLINE SERVICES PRIVATE LIMITED',
    'GRAMSANSAAR SERVICES PRIVATE LIMITED',
    'MAMLESHWAR GREEN FUEL PRIVATE LIMITED',
    'CARE4SIGN SAFETEC LIMITED',
    'VAPPAS CAPITAL AND MARKETING PRIVATE LIMITED',
    'CIRCULAR FASHION PRIVATE LIMITED',
    'SLAVIC PHARMA PRIVATE LIMITED',
    'EQSENSE TECHNOLOGIES PRIVATE LIMITED',
    'DESPERATELY CINEMA PRIVATE LIMITED',
    'AEROTEK NXTGEN PRIVATE LIMITED',
    'LEARNIQO EDUCATION SERVICES PRIVATE LIMITED',
    'MEHTA ALMS FOUNDATION',
    'FRESHFIN SOLUTIONS PRIVATE LIMITED',
    'GONET CABLES AND ELECTRICAL INDUSTRY PRIVATE LIMITED',
    'MEDML INDIA OPERATIONS PRIVATE LIMITED',
    'SPG FOOD PRODUCTS PRIVATE LIMITED',
    'SOON SAFE SOLUTIONS PRIVATE LIMITED',
    'TOPVEG SEEDS PRIVATE LIMITED',
    'DORINA PHARMACEUTICAL PRIVATE LIMITED',
    'BLUEWAY NUTRIENTS PRIVATE LIMITED',
    'MELANGENOW MARKETING SOLUTIONS PRIVATE LIMITED',
    'CASAGRAND ZINGO PRIVATE LIMITED',
    'KALPATARU HILLS RESIDENCY PRIVATE LIMITED',
    'OKAYA GLOBAL CHARGING SOLUTIONS PRIVATE LIMITED',
    'VOLOPAY INDIA PRIVATE LIMITED',
    'STORIES WITH US (OPC) PRIVATE LIMITED',
    'KUN PREMIUM CARS PRIVATE LIMITED',
    'PRACTICE MARKETING PRIVATE LIMITED',
    'TOGETHER INNOVATION LABS PRIVATE LIMITED',
    'COSPACE 360 PRIVATE LIMITED',
    'POLYCYCLING SOLUTIONS PRIVATE LIMITED',
    'FRANCINA & FRANCIS CONSULTING (OPC) PRIVATE LIMITED',
    'EPOORTI SERVICES PRIVATE LIMITED',
    'EQUIVALENT IO TECHNOLOGIES PRIVATE LIMITED',
    'SOEZY SOLUTIONS PRIVATE LIMITED',
    'HEALTHMOBIS INNOVATIONS PRIVATE LIMITED',
    'DREIWELT PRIVATE LIMITED',
    'SEIZE THE ADS PRIVATE LIMITED',
    'JEROBYTE SOFTWARES PRIVATE LIMITED',
    'KAMIRAJ ENTERPRISE PRIVATE LIMITED',
    'MERCHANT SHIP EQUIPMENT PRIVATE LIMITED',
    'EARTH & ORBIT FINTECH PRIVATE LIMITED',
    'ROGPAD TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'JUPITER ELECTRIC MOBILITY PRIVATE LIMITED',
    'NOURRITOURE FOODS PRIVATE LIMITED',
    'DYNOS EDUCATION INDIA PRIVATE LIMITED',
    'SEVENVISION TRADETECH PRIVATE LIMITED',
    'VISION FARBE PRIVATE LIMITED',
    'ANAM MEDICAL SOLUTIONS PRIVATE LIMITED',
    'MAA PATLA DURGAMAGA PRIVATE LIMITED',
    'FRITRIO SQUARE LOGISTICS PARKS PRIVATE LIMITED',
    'GENDER LAB FOUNDATION',
    'EL DOMO PRIVATE LIMITED',
    'RIGAURSWASTIK JEWELS PRIVATE LIMITED',
    'ATI ASI CONSTRUCTIONS PRIVATE LIMITED',
    'FLUX CONSULTING PRIVATE LIMITED',
    'KEYSKY REALTORS PRIVATE LIMITED',
    'ELE OOTA TECHNOLOGIES PRIVATE LIMITED',
    'ORANGEWOOD INNOVATIONS PRIVATE LIMITED',
    'ACCISMUS TECHNOLOGIES PRIVATE LIMITED',
    'INNOVATIVE FURNITEL PRIVATE LIMITED',
    'HIMALAYAN COLLEGE OF VOCATIONAL SERVICES PRIVATE LIMITED',
    'FUTURE FINISHERS PRIVATE LIMITED',
    'LEXICON ALUMNI OF BELIEVERS PRIVATE LIMITED',
    'NORTHERN STAR LOGISTICS PRIVATE LIMITED',
    'GLET CARAFE PRIVATE LIMITED',
    'JEEVANSANGI SERVICE PRIVATE LIMITED',
    'SERIEUX SOLUTIONS PRIVATE LIMITED',
    'CEG LAB PRIVATE LIMITED',
    'ALS MEDICARE PRIVATE LIMITED',
    'GV DISCOVERY CHEMISTRY PLATFORM PRIVATE LIMITED',
    'DABAD AUTOMOTIVE PRIVATE LIMITED',
    'SQUARE OWNERS WELFARE ASSOCIATION',
    'FANORY TECHNOLOGY PRIVATE LIMITED',
    'VEH RENEWABLES PRIVATE LIMITED',
    'VAAIPL PRIVATE LIMITED',
    'ORATECH INFO SOLUTIONS PRIVATE LIMITED',
    'DR SEVENSEAS CONSULTANCY PRIVATE LIMITED',
    'UNICARE LOGISTICS PRIVATE LIMITED',
    'AVVISO GLOBAL PRIVATE LIMITED',
    'JOL WORKS PRIVATE LIMITED',
    'KLUTHE INDIA PRIVATE LIMITED',
    'BADAMIKAR REALITIES PRIVATE LIMITED',
    'VIMAAN TECHNOLOGIES PRIVATE LIMITED',
    'VIDYA PLANET PRIVATE LIMITED',
    'ZEALIE INDIA PRIVATE LIMITED',
    'ALPHANETWORKS GLOBAL DELIVERY CENTRE PRIVATE LIMITED',
    'GAMMEL MONK PRIVATE LIMITED',
    'DIGITAL TRAFFIC PRIVATE LIMITED',
    'PRIMARY PLUS KLUG KINDERWELT PRIVATE LIMITED',
    'RLSS WB ASSOCIATION',
    'BIZPLUGINS INFOTECH PRIVATE LIMITED',
    'INDISMART LEARNING PRIVATE LIMITED',
    'REPLENISH ENERGY PRIVATE LIMITED',
    'M. G. BAKERS PRIVATE LIMITED',
    'IFUTURE GLOBISTIC AGRO & AQUA LIMITED',
    'SUNGRACE CHEMICALS PRIVATE LIMITED',
    'CHAITHANYA BILVA PRIVATE LIMITED',
    'SOUVENIER GIFTOS PRIVATE LIMITED',
    'JIVO MART PRIVATE LIMITED',
    'DPD TECHNOLOGIES PRIVATE LIMITED',
    'AAGAM FRP PRODUCTS PRIVATE LIMITED',
    'DIIVYAMTEJ BUILDCON PRIVATE LIMITED',
    'FARMCO INNOVATIONS PRIVATE LIMITED',
    'GROWWCAPITAL CONSULTANCY PRIVATE LIMITED',
    'LIVOG TECHNOLOGIES PRIVATE LIMITED',
    'INNTOVATING BUSINESS SOLUTION PRIVATE LIMITED',
    'ASHOK CRIME SPECTRUM RESEARCH FOUNDATION',
    'PRIMET RESOURCE PRIVATE LIMITED',
    'DEOLI KRISHI FED PRODUCER COMPANY LIMITED',
    'WUNDERBAKED TECHNOLOGIES PRIVATE LIMITED',
    'THE HOSTELLER HOSPITALITY PRIVATE LIMITED',
    'MITTAL 21 INDIA PRIVATE LIMITED',
    'GSHARP MEDIA PRIVATE LIMITED',
    'YODABOT TECH PRIVATE LIMITED',
    'KENTRIX SERVICES PRIVATE LIMITED',
    'WONCORE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'VELLEY SURAKSHIT (OPC) PRIVATE LIMITED',
    'SPITI INDIA PRIVATE LIMITED',
    'HASS DESIGNS PRIVATE LIMITED',
    'KUIPER LABS PRIVATE LIMITED',
    'JANANYA NIRMAN PRIVATE LIMITED',
    'SPLS INDUSTRIES PRIVATE LIMITED',
    'GLASSIO PRIVATE LIMITED',
    'DR MEENU',
    'SCORPIO VESSELS PRIVATE LIMITED',
    'Bay tankers private limited',
    'MCQUILLING INDIA PRIVATE LIMITED',
    'Frontline containers private limited',
    'Sahara international airport private limited',
    'Garuda jets private limited',
    'Deviate enterprises private limited',
    'Lf logistics (india) private limited',
    'KYAGAR RETAIL PRIVATE LIMITED',
    'Active india holidays private limited',
    'Heaven ahead voyage private limited',
    'Discover leisure tours and travels private limited',
    'Attar logistics private limited',
    'Xlo india limited',
    'Veritas logistics private limited',
    'CONNOISSEUR SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'Mayur c.contractor logistics private limited',
    'Bhagya logistics private limited',
    'Asl logistics private limited',
    'Wondrous world private limited',
    'R.k.container movers private limited',
    'Zebec marine services private limited',
    'Seaways shipping and logistics limited',
    'Shri panchami cargoes private limited',
    'Sai trance marine resources private limited',
    'SEALAND PROJECTS PRIVATE LIMITED',
    'Sentini softec private limited',
    'Fortune logistics india private limited',
    'Miv logistics private limited',
    'Express ocean terminal services private limited',
    'Pentagon freight services india private limited',
    'Meandering vacations private limited',
    'Mac-nels container lines private limited',
    'Iwa logistics private limited',
    'Associated trade logistics private limited',
    'Panko express india private limited',
    'Sbs transpole logistics private limited',
    'Say infra and storage private limited',
    'Hira warehousing and cold storage private limited',
    'Stellar marine food processor india private limited',
    'KBGB AGRITECH PRIVATE LIMITED',
    'Nanesh cold storage private limited',
    'Kintetsu world express (india) private limited',
    'Esprit container line private limited',
    'Emirates container line private limited',
    'UNIGO TRAVEL (INDIA) PRIVATE LIMITED',
    'Seamaster sea and air logistics private limited',
    'Namakkal logistics (india) private limited',
    'Shree ram shipping industries private limited',
    'M r shipping private limited',
    'KEWALSHANTI STOCK VISION PRIVATE LIMITED',
    'Marine space craft private limited',
    'India calling tours private limited',
    'Red apple car rentals private limited',
    'Air falak travels india private limited',
    'Planet earth destination management company private limited',
    'REDWINGS ENTERPRISES PRIVATE LIMITED',
    'Trinity air travel and tours kerala private limited',
    'Deva hospitality private limited',
    'Jatayupara adventure tourism private limited',
    'Birla viking travels limited',
    'Just online solutions private limited',
    'Yez studio branding solutions private limited',
    'Samarth compuexim house pvt ltd',
    'Startup equity partners private limited',
    'Infinity knowledge systems private limited',
    'Quest 2 travel.com india private limited',
    'Shakti computers private limited',
    'Lth online solutions private limited',
    'GLOBALCOM IDC LIMITED',
    'Unique compsol private limited',
    'Maxim peripherals private limited',
    'Hawk development management services private limited',
    'Rf arrays systems private limited',
    'Apollo business technologies private limited',
    'Netspider infotech india limited',
    'Location guru solutions private limited',
    'Polycom technology (r & d) center private limited',
    'WONESE INDIA PRIVATE LIMITED',
    'Technowin solutions private limited',
    'INNOHAVEN INDIA PRIVATE LIMITED',
    'GMMOS ENGINEERING (INDIA) PRIVATE LIMITED',
    'Tecsys solutions private limited',
    'Documagic solutions private limited',
    'Maple digital technology international private limited',
    'Imap systems private limited',
    'Shrim it services private limited',
    'Esds internet services private limited',
    'Nuleap technologies private limited',
    'Cygnet technologies private limited',
    'Techterrain consulting private limited',
    'Watchwitz technologies private limited',
    'Clogik solutions private limited',
    'A human info digital media private limited',
    'Splunk services india private limited',
    'Saibber tech private limited',
    'Neal analytics services private limited',
    'VIVAN BUSINESS CONSULTANTS PRIVATE LIMITED',
    'Ultimate information technology private limited',
    'Cross country infotech private limited',
    'Integration infotech india privat limited',
    'Product horizons technologies private limited',
    'ENX DIGITAL PRIVATE LIMITED',
    'Alvis technologies private limited',
    'Smartcloud infotech private limited',
    'Eeshana solutions private limited',
    'Alef mobitech solutions private limited',
    'SEMANTIC TECHNOLOGIES AND AGRITECH SERVICES PRIVATE LIMITED',
    'Jasapp techserv private limited',
    'Codes kube private limited',
    'Arrowebs solutions private limited',
    'Himansu it services private limited',
    'Rmn infotech private limited',
    'Car and half.com private limited',
    'Riktam technology consulting private limited',
    'Everguard life ventures private limited',
    'Outsourzing worldwide private limited',
    'Axis-v creatives private limited',
    'Yentrek india software private limited',
    'Rendersoft systems india private limited',
    'Innobridge consulting private limited',
    'Telliant systems india private limited',
    'Brio systems private limited',
    'It resonance private limited',
    'ZOHO TECHNOLOGIES PRIVATE LIMITED',
    'Jwala it solutions private limited',
    'Boston mediatech private limited',
    'Redevon it services private limited',
    'Welsoft technologies private limited',
    'Mrv infotech india private limited',
    'Commnet systems consultancy private limited',
    'Itransz esolution private limited',
    'Secureaccess infotech private limited',
    'Embdes technologies private limited',
    'Jkl technologies private limited',
    'Digital mind consultancy services private limited',
    'Valzen solutions private limited',
    'Bluemarble smartware private limited',
    'Xlicon business services private limited',
    'Locsea software development private limited',
    'Peninlog technologies private limited',
    'Deep identity india private limited',
    'Sea infonet private limited',
    'Pj research and consulting services private limited',
    'Dwf research private limited',
    'Indo canada plastic testing lab & institute private limited',
    'Nitin lifesciences limited',
    'Celogen lifescience & technologies private limited',
    'Carnegie endowment for international peace india',
    'Clevergene biocorp private limited',
    'Delta legal services private limited',
    'Euphoria fabrication private limited',
    'ELDECO HOMES PROJECTS LIMITED',
    'Cnc communications & network consulting india private limited',
    'Aica laminates india private limited',
    'Rn logistics and supply chain private limited',
    'Dynamic tax services private limited',
    'Optymyx techonline private limited',
    'Careerbuilder.com india private limited',
    'Gti investment advisory services private limited',
    'Ccs (india) private limited',
    'Sollatek india technologies private limited',
    'Compact systems private limited',
    'Indo-australian chamber of commerce',
    'Riyaz ice and cold storage private limited',
    'Waterfield properties private limited',
    'Prekshak investments and trading pvt ltd',
    'Pranir trustees pvt ltd',
    'Glamoor cosmetics pvt ltd',
    'Well dwell builders private limited',
    'Jairamdass khushiram impex pvt ltd',
    'Crescent organics private limited',
    'Mahak cosmetics and credit pvt ltd',
    'Precihole machine tools private limited',
    'Vir sponge and power limited',
    'Saswan minerals and chemicals pvt.ltd.',
    'Kotak securities limited',
    'Kalindi finstock private limited',
    'Abhay advertising private limited',
    'Sangameshwar coffee estates limited',
    'Prestige estates projects limited',
    'Asian hotels (east) limited',
    'K.c.p.sugar and industries corporation limited',
    'Salona cotspin limited',
    'Lambodhara textiles limited',
    'Maharaja shree umaid mills limited',
    'Indian terrain fashions limited',
    'Sudal industries limited',
    'DSJ KEEP LEARNING LIMITED',
    'DIVI',
    'S POULTRY TECHNOLOGY PRIVATE LIMITED',
    'Krognos integrated marketing services private limited',
    'Eldorado technologies limited',
    'Logics auto components india private limited',
    'R.j.s. engineers private limited',
    'Value added technologies private limited',
    'Ut bene pharma private limited',
    'Wavesight wireless solutions private limited',
    'Ikea services india private limited',
    'Brainlab india private limited',
    'Urban emissions private limited',
    'Pan ex logistics private limited',
    'Rohs certification private limited',
    'BRANE SMART ENERGY PRIVATE LIMITED',
    'Fidelity professional services private limited',
    'Exp experiential marketing private limited',
    'Lila digital and environmental solutions private limited',
    'Best koki automotive private limited',
    'Kangaroo cabs private limited',
    'Life industries india private limited',
    'Dhruva holidays private limited',
    'Cartus india private limited',
    'Dew drops hospitality private limited',
    'Trans quality system consultancy private limited',
    'Elematec trading india private limited',
    'Innovation alchemy consulting private limited',
    'Tecumen business solutions private limited',
    'Gnat technologies private limited',
    'Unimex formdrill india private limited',
    'Zela wellness private limited',
    'Trinergy technologies (india) private limited',
    'Forthpage consulting private limited',
    'Equator consultants private limited',
    'Prudent eco systems private limited',
    'Vasyas consultants private limited',
    'Thoughts academy private limited',
    'Inch by inch the body temple health care private limited',
    'Venti oelde india private limited',
    'International hallmark & assay private limited',
    'Bcs tech & supplies private limited',
    'Kiron fluid systems private limited',
    'Abg cement holdco private limited',
    'Italent india management consultants private limited',
    'Beackon logistics private limited',
    'Eastro control systems private limited',
    'Fourth quadrant business solutions private limited',
    'Karina tourism and adventures private limited',
    'Edge brand architects (india) private limited',
    'Paper boat web private limited',
    'Radium creation limited',
    'Intime services (mumbai) private limited',
    'Creative collaboration advisors private limited',
    'Action sports private limited',
    'Experience factory private limited',
    'Ssk retails private limited',
    'Fifth avenue sourcing private limited',
    'U.K.TEXTILES PRIVATE LIMITED',
    'Vinit gloves manufacturing private limited',
    'Design classics exports private limited',
    'Abhinav texfab private limited',
    'Krr spintex private limited',
    'Dholi integrated spinning park limited',
    'Reliable clothing private limited',
    'Neptune polymers pvt ltd',
    'Mei leathers private limited',
    'AAROKA FASHION PRIVATE LIMITED',
    'Millennium leather foils private limited',
    'Ucd model private limited',
    'K k s k tanning company private limited',
    'K k s k leathers private limited',
    'Conceria international private limited',
    'Srinala leathers india private limited',
    'Metropoli capinstock private limited',
    'Rajyashree power loom factory pvt ltd',
    'Garment technology expo private limited',
    'Pb india private limited',
    'Bajoria foods private limited',
    'Arunachal boards india private limited',
    'Kewalram textiles private limited',
    'Shree krishnanand textiles private limited.',
    'SARKAR PLYWOOD PVT LTD',
    'ASEAN PLYWOODS PRIVATE LIMITED',
    'Sandy acoustech private limited',
    'Meta arch private limited',
    'Nui pulp & paper industries private limited',
    'KANKESH EXIMS PRIVATE LIMITED',
    'Shivam spinfab limited',
    'Jolly spinning mills private limited',
    'Pammi agro private limited',
    'Amni cotton private limited',
    'J.d. apparels private limited',
    'Fine paper source private limited',
    'Asta files private limited',
    'Accent containers private limited',
    'Hi couture private limited',
    'Topman exports limited',
    'Kothari apparels private limited',
    'Glue brandworks private limited',
    'K k s k industries private limited',
    'Raswi industries private limited',
    'Milanart offset printers (india) private limited',
    'DESIGN 76 VENTURES PRIVATE LIMITED',
    'Metropolitan media company limited',
    'Sara books private limited',
    'KEYWORDS STUDIOS INDIA PRIVATE LIMITED',
    'An printing and engraving private limited',
    'Tag india private limited',
    'Walker footwear industries limited',
    'GRAND PAPER & BOARDS PRIVATE LIMITED',
    'Lepakshi integrated textile park private limited',
    'Bekaam printers private limited',
    'Walled city ad limited',
    'Fancy corporation limited',
    'Print superb printers private limited',
    'Prime global media private limited',
    'Laserlink (lcp) private limited',
    'Forest of chintz designs private limited',
    'Nandi printers private limited',
    'Value 360 communications private limited',
    'Idg media private limited',
    'RIYANASONS PACKAGING PRIVATE LIMITED',
    'Fourth signal (india) private limited',
    'Global attire private limited',
    'MAMOC WORLDWIDE PRIVATE LIMITED',
    'Infini designs private limited',
    'Hpcl-mittal energy limited',
    'Rajiv petrochemicals pvt ltd',
    'Ongc petro additions limited',
    'Sri tripura sundari cotton press company private limited',
    'RELIABLE SPACES PRIVATE LIMITED',
    'Pronix technologies private limited',
    'Appy apparels private limited',
    'Transasia sales private limited',
    'Powerspack industries private limited',
    'Dimac organics pvt ltd',
    'HINDPRAKASH INDUSTRIES LIMITED',
    'Amophil chemicals private limited',
    'Stabicoat nutrition and wellness private limited',
    'Spitfire hygiene products private limited',
    'Godavari cellulosics limited',
    'Guljag health care private limited',
    'Korde chemicals pvt ltd',
    'Jayantilal j gandhi chemicals private limited',
    'Chemphar organic (india) pvt ltd',
    'Gayatri paints private limited',
    'Haresh petrochem private limited',
    'MAHEK CARGO CARRIERS PRIVATE LIMITED',
    'Bharadwaj packaging private limited',
    'Spenta publishers private limited',
    'SHEESHO TECHNOLOGIES PRIVATE LIMITED',
    'Dainichi color india private limited',
    'Haware publications private limited',
    'SPENTA DIGITAL MEDIA PRIVATE LIMITED',
    'Shroff publishers and distributors private limited',
    'Ego wall decor private limited',
    'DBJ MERCANTILE PRIVATE LIMITED',
    'Good morning india media private limited',
    'RISHABH METALS & CHEMICALS PRIVATE LIMITED',
    'Finorga (india) pvt ltd',
    'Bhalotia auto products private limited',
    'Appy builders private limited',
    'Veena buildcon private limited',
    'Purnima colonisers private limited',
    'Pec projects and systems private limited',
    'Anushria infrastructure private limited',
    'Veekeshavam infrastructure private limited',
    'Mesco kalinga steel limited',
    'Maruti thermal power private limited',
    'Rajkot (gujarat) solar energy private limited',
    'GIRIGANGA INFRASOLUTIONS PRIVATE LIMITED',
    'Global heavy electricals limited',
    'Msk projects (i) private limited',
    'Akshat servcon private limited',
    'SOLAR ENERGY CORPORATION OF INDIA Limited',
    'Celtem infrastructure private limited',
    'Clean wind power (devgarh) private limited',
    'Amv infrastructure and properties private limited',
    'Ponneth builders private limited',
    'Ecolibrium energy private limited',
    'Constant developers private limited',
    'Heera life style private limited',
    'Fuma umbrella private limited',
    'Aquabrane water technologies private limited',
    'Ramasamy power gen private limited',
    'Rinkoo constructions private limited',
    'Mistry construction co pvt ltd',
    'Horizon promoters india limited',
    'Concert infotech private limited',
    'Galan real estates p.ltd.',
    'Urmi realtors private limited',
    'Jade contractors and builders private limited',
    'Indiaauction.com private limited',
    'Ravi nirman nigam limited',
    'Onshore construction company private limited',
    'N. a. estates private limited',
    'Vijaykamal properties private limited',
    'Krishna developers private limited',
    'Adarsh housing private limited',
    'Ruddhi buildcon private limited',
    'Starline developers private limited',
    'Citilights home makers private limited',
    'Alvi tech services pvt ltd',
    'Veritas industries private limited',
    'Nirmal infrastructure private limited',
    'Mm realty private limited',
    'Mig (bandra) realtors and builders private limited',
    'Acetech green energy systems private limited',
    'Lakshachandi housing and infrastrcuture private limited',
    'Modern hi-tech developers private limited',
    'Shree naman estate projects private limited',
    'EQUIRUS INSURANCE BROKING PRIVATE LIMITED',
    'Lakshachandi constructions private limited',
    'Narbheram power and steel private limited',
    'Hindustan electricpower limited',
    'Victor thermal power private limited',
    'Nvr wind private limited',
    'Nvr energy private limited',
    'Nvr vidyut private limited',
    'Enviropol engineers private limited',
    'Manjeera estates private limited',
    'NAC QUIPPO EQUIPMENT SERVICES LIMITED',
    'Eshq consultants private limited',
    'Aliens aerocity private limited',
    'Pollard water solutions private limited',
    'Kamp developers private limited',
    'Axon constructions private limited',
    'Arun excello urban infrastructure private limited',
    'Arun excello homes private limited',
    'Tirumala milk products private limited',
    'Keratech coconut oil manufacturing company private limited',
    'K.s. speciality fats private limited',
    'Punjab agri ventures limited',
    'SAKTHI MURUGAN ROLLER FLOUR MILLS PRIVATE LIMITED',
    'B d corporates private limited',
    'BBM DISTRIBUTION PRIVATE LIMITED',
    'Parle agro private limited',
    'Permedia foods private limited',
    'Ekea agro private limited',
    'Eggway international asia private limited',
    'Au bon pain cafe india limited',
    'Harnik general foods private limited',
    'Midas foods india private limited',
    'CHAME AGRO INDUSTRIES PRIVATE LIMITED',
    'Shree basaveshwar sugars limited',
    'K.p.r. sugar mill limited',
    'SHRI MODI LEVIGATED KAOLIN PRIVATE LIMITED',
    'Wrigley india private limited',
    'Cargill india private limited',
    'Viraatt victuals private limited',
    'TAPROBANE FOOD & BEVERAGE PRODUCTS PRIVATE LIMITED',
    'Shakshi mines and infrastructure private limited',
    'PREMIER',
    'S VPL TOURS AND TRAVELS PRIVATE LIMITED',
    'Vitesse travels private limited',
    'Munak financiers private limited',
    'Sagar deposits and advances limited',
    'Ad exim private limited',
    'Surya finvest private limited',
    'SHUBHAM HOUSING DEVELOPMENT FINANCE COMPANY LIMITED',
    'Shining star holdings private limited',
    'Kosani finance and investments private limited',
    'Udhayalakshmi properties limited',
    'Kaypee land and finance private limited',
    'Penguin securities pvt ltd',
    'Green park leafin private limited',
    'Shiny industrial finance private limited',
    'T.s. mahalingam financial services private limited',
    'Svasti microfinance private limited',
    'Mamta housing finance company private limited',
    'Superview Real Estates Private Limited',
    'Prem finance co pvt ltd',
    'Magus infra - tech private limited',
    'GRAMEEN CAPITAL INDIA Private Limited',
    'Ha capital avenues private limited',
    'Magus credit & capital private limited',
    'Seven seas holdings limited',
    'Indian securitisation foundation',
    'SETIA AUTO FINANCE PRIVATE LIMITED',
    'Mayank fincom limited',
    'Berar finance limited',
    'Poonawalla financials private limited',
    'BHARTIYA ADVISORY SERVICES PRIVATE LIMITED',
    'Anveshan textile limited',
    'Shailesh shah securities private limited',
    'Kiran investment co private limited',
    'Yamuna investments private limited',
    'Alert agencies and investments private limited',
    'Devashish investments private limited',
    'Laadki trading and investments limited',
    'Tivoli investment and trading company private limited',
    'Coastal investments and finance pvt ltd',
    'Balam investment co pvt ltd',
    'All state finance and leasing ltd',
    'Seawell holdings pvt ltd',
    'Kabra holdings and properties private limited',
    'Mkm share & stock brokers limited',
    'Sheena investments private limited',
    'Brady investments private limited',
    'KAP DESIGNS PRIVATE LIMITED',
    'Deo credit capital pvt ltd',
    'Rukh investments private limited',
    'Parachute investments private limited',
    'Merton finance and trading private limited',
    'Prajapati lawns premises private limited',
    'BLIDA AGRO PRIVATE LIMITED',
    'Diamond technology solutions private limited',
    'Biofin investments private limited',
    'Beneruz investment and consultants private limited',
    'Anurag investments private limited',
    'Telecom investments india private limited',
    'Hoist holdings private limited',
    'Vivekam financial services private limited',
    'Kencraft india pvt. ltd.',
    'Neptune corporate services private limited',
    'Per square feet real estate private limited',
    'Capital galleria maintenance services private limited',
    'Capital highstreet maintenance services private limited',
    'Carpediem advisors private limited',
    'Vigour mobile india private limited',
    'Bourton consulting (india) private limited',
    'Dns consulting private limited',
    'Durga facility management services private limited',
    'Cbs hi-tech ventures private limited',
    'Vibgyor power india private limited',
    'Sycamine consulting private limited',
    'Nissan business solutions private limited',
    'Cyrix healthcare private limited',
    'Sai maritime and management private limited',
    'Eskay management services pvt ltd',
    'Sarovar hotels private limited',
    'Eurofinance training and publishing private limited',
    'Excellent informatic private limited',
    'Harkan management consultancy services private limited',
    'IIGB ADVISORS PRIVATE LIMITED',
    'BAY CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED',
    'Sairam corporate advisors private limited',
    'Pcg-rkca management and financial services private limited',
    'TAXOPEDIA ADVISORY PRIVATE LIMITED',
    'Fuchsia consultants private limited',
    'Ams project consultants private limited',
    'Riskpro management consulting private limited',
    'Snda consultants private limited',
    'Ikeva venture and knowledge advisory services private limited',
    'Snaptics business solutions private limited',
    'Prosource consulting private limited',
    'Sloan management advisory services (india) private limited.',
    'Gkm payroll services private limited',
    'Vyapar suvidha pvt. ltd.',
    'Accord group (india) private limited',
    'Umc technologies private limited',
    'Atlas shipping services pvt ltd',
    'Osda security & detective associates private limited',
    'Pee dee advertising private limited',
    'D p ahuja & co. private limited',
    'Anthroplace consulting private limited',
    'Jrk financial services private limited',
    'Sunflower investment advisory private limited.',
    'B. jain consultants private limited',
    'Sarvatra integrated management service private limited',
    'Sensol technologies private limited',
    'Rahila designs private limited',
    'Target fashions limited',
    'P & r infraprojects limited',
    'TGPEL PRECISION ENGINEERING LIMITED',
    'Salgaocar engineers private limited',
    'Vinir engineering private limited',
    'Mantri homes private limited',
    'Jasmine enterprises private limited',
    'Gokulam engineers india private limited',
    'VINVISH ASSOCIATES PRIVATE LIMITED',
    'Indus projects limited',
    'Ecoaqua engineering systems private limited',
    'Trans tech projects private limited',
    'Vca projects and interiors private limited',
    'Madras marketing & engineering services private limited',
    'Restore machines india pvt ltd.',
    'Neyantran engineers private limited',
    'Ang ron geotech private limited',
    'Nissenken quality evaluation (india) private limited',
    'Creative channel advertising and marketing private limited',
    'Sunrise advertising private limited',
    'Advantedges digital private limited',
    'Adrenal advertising and promotions private limited',
    'Forest creative communications private limited',
    'Origin corporate services private limited',
    'Anupam advertising private limited',
    'Mechbrain india private limited',
    'Sears communication services private limited',
    'M f steels pvt. ltd',
    'Nutech photo lithographers private limited',
    'Evergreen estates and exhibitors private limited',
    'Bhayana builders private limited',
    'Dakshin kegg private limited',
    'Bentex builders pvt ltd',
    'Seth consultants private limited',
    'Goel overseas india private limited',
    'P s bedi and company private limited',
    'Shotam consultants private limited',
    'Rawalwasia castings private limited',
    'Anand medi caids private limited',
    'Ranika investments private limited',
    'Sugam precision private limited',
    'Sai computers limited',
    'Duaco equipments private limited',
    'Marsons industries private ltd',
    'Autodecor private limited',
    'Hybrid holdings pvt ltd',
    'Marwaha plastics private limited',
    'Bahl builders private limited',
    'BATRA BROTHERS PRIVATE LIMITED',
    'Dulari exports private limited',
    'Reliance synthetics private limited',
    'Malik chemi process private limited',
    'Aneka estates private limited',
    'J s furnishings private limited',
    'Wadcot private limited',
    'Sonika commerce private ltd.',
    'D d auto private limited',
    'Galaies electronics private limited',
    'Sri krishna sweets private limited',
    'J.d. food products private limited',
    'Sri mayur biscuit company pvt. ltd.',
    'ASHOK PATNI FAMILY VENTURES PRIVATE LIMITED',
    'Covisible solutions (india) private limited',
    'ARTHUR',
    'S FIRST INDIA PRIVATE LIMITED',
    'Doughmakers india private limited',
    'Shingote agro foods private limited',
    'Sanskriti tex fab private limited',
    'Liviya international private limited',
    'Sparsh fab textiles private limited',
    'Deeps texstyles private limited.',
    'Jatin cotton mills private limited',
    'Silver duck traders private limited',
    'Dxn marketing india private limited',
    'Cegaro industries private limited',
    'Kalchini enterprises ltd',
    'Anandtex india private limited',
    'Nagesh artsand crafts private limited',
    'Mansarover furnishings private limited',
    'Wooltop designs private limited',
    'Coco tufters private limited',
    'Raunak coirs limited',
    'Hailstone innovations private limited',
    'Shivoy farms private limited',
    'Devashi polytex private limited',
    'Integrated life fiscal services private limited',
    'Shivji valji tarpaulins private limited',
    'JET TECH SYSTEMS PRIVATE LIMITED',
    'Sbl silks private limited',
    'QUALITY LEISURES & LIFESTYLES PVT LTD',
    'S g a fashion private limited',
    'M m poonjiaji spices limited',
    'Disha tex fab private limited',
    'Padmavati synthetics private limited',
    'Dweta tex fab private limited',
    'Kruti fabrics private limited',
    'Meha tex private limited',
    'House of trims private limited',
    'Indigo multifab private limited',
    'Gold flake corporation limited',
    'Meha garments private limited',
    'Lisa apparels private limited',
    'Padmavati garments private limited',
    'Kaladarshan garment private limited',
    'Urja textiles private limited',
    'Crest textiles private limited',
    'RAHUL TEXTILE INDUSTRIES PRIVATE LIMITED',
    'Arce polymers private limited',
    'Pt communication systems private limited',
    'NIDHI DYEING AND PRINTING MILLS PVT LTD',
    'R n texofab private limited.',
    'Carona industries private limited',
    'GARMENT MANTRA LIFESTYLE LIMITED',
    'Kikani enterprises private limited',
    'Allied thread works private limited',
    'Kalyani innerwear private limited',
    'Yes oui care private limited',
    'Dharmaji textiles private limited',
    'Sanghmitra projects private limited',
    'A a infraproperties private limited',
    'Kaveri infra properties private limited',
    'Ljk construction india private limited',
    'Ekdev realty private limited',
    'Subhrashi developers private limited',
    'Jagbadan nirmaan private limited',
    'Roselife housing private limited',
    'Dhatri infrastructure private limited',
    'Parvati kunj residents association',
    'Parikarma realestate limited',
    'Lgcl properties private limited',
    'SHIVALIK MOTORS AND TRACTORS PRIVATE LIMITED',
    'Bbd industries private limited',
    'Eshta motors private limited',
    'Kvr automobiles private limited',
    'Rishabh fourwheels pvt ltd',
    'Sapna cars private limited',
    'Prem narain workshop pvt ltd',
    'AUTO AGRIC INDUSTRIES PRIVATE LIMITED',
    'Rishabh buildtech india private limited',
    'National projects construction corporation limited',
    'Lgcl infrastructures private limited',
    'NAIKNAVARE ASSOCIATES PROMOTERS & BUILDERS PRIVATE LIMITED',
    'Deccan homes private limited',
    'Vrishali realestate private limited',
    'Manali properties private limited',
    'Coastal infratech private limited',
    'City development (pune) private limited',
    'Teemage builders private limited',
    'CORAL INFRAGOLD PRIVATE LIMITED',
    'Bcre india private limited',
    'Aquarius buildwell private limited',
    'SIDDHIKA COATINGS LIMITED',
    'Grc projects private limited',
    'Rajlaxmi infratech private limited',
    'Cranberry estates private limited',
    'Giridhari homes private limited',
    'Surakshithh promoters private limited',
    'Kassons infratech private limited',
    'Kga constructions private limited',
    'Dfi architects private limited',
    'G.s. majestic developers private limited',
    'Asj holding private limited',
    'Auto hitech private limited',
    'Pal prateek motors private limited',
    'Poddar automobiles ltd',
    'Ashish wheels limited',
    'Mahakali motors private limited',
    'Visha automotive sales & services private limited',
    'K.u.n. motor company private limited',
    'Ncgb marine pvt.ltd.',
    'INTERNATIONAL MERITIME INSTITUTE PRIVATE LIMITED',
    'Sahni distributors private lmited',
    'Deedi automobiles pvt ltd',
    'RAJESH MOTORCARS PRIVATE LIMITED',
    'Hyoseong electric india private limited',
    'A b s wheels private limited',
    'Shahwar motives private limited',
    'Homco engineering works pvt ltd',
    'Aryan lubricants private limited',
    'Chandan trading company private limited',
    'Exmart international private limited',
    'Fides distribution private limited',
    'ACCELERATOR VENTURES PRIVATE LIMITED',
    'Rajasthan enterprises pvt ltd',
    'VAIGHAI ANIMAL NUTRITION LIMITED',
    'Vachi vincom private limited',
    'Vibhuti vincom private limited',
    'Violet dealcom private limited',
    'Shree arihant tradelinks india private limited',
    'RIEKE PACKAGING INDIA PRIVATE LIMITED',
    'Worlds window impex india private limited',
    'Tricut marketing private limited',
    'Sunvision exim private limited',
    'Simplast india private limited',
    'Alert impex private limited',
    'Texl moda italiana impex private limited',
    'Pearl vincom private limited',
    'Textile suppliers syndicate india pvt ltd',
    'Pittie indo textilia private limited',
    'Authorgen technologies private limited',
    'Ajmer automobiles private limited',
    'Plus marketers private limited',
    'S.l. oberoi motors private limited',
    'LIGHTHOUSE ASSOCIATES PRIVATE LIMITED',
    'MEHROTRA & CO PVT LTD',
    'Hemp trading co pvt ltd',
    'Prosperity importers & exporters pvt ltd',
    'Yash marketing and traders pvt. ltd.',
    'Greenchip trexim pvt ltd',
    'Ashicon housing pvt ltd',
    'Chakresh commercial pvt ltd',
    'Quinline dealcomm pvt ltd',
    'Lily dealcomm pvt ltd',
    'TARANG VINCOM PVT LTD',
    'Drutgati yatayat private limited',
    'Zimkele plantations pvt.ltd.',
    'Rosy sale promotion pvt.ltd.',
    'Triyog cosmetics pvt.ltd.',
    'Castrol trading pvt ltd',
    'Anklesh financial consultants pvt ltd',
    'Calvin marketing pvt ltd',
    'Gangavati trade pvt ltd',
    'Niraj dealer private limited',
    'Citystar housing & projects private limited',
    'Anmol vinimay private limited',
    'Elite dealers private limited',
    'Smart goods pvt ltd',
    'Kaveri vanijya pvt ltd',
    'Kasauti vyapaar pvt ltd',
    'Jaltarang vinimay pvt ltd',
    'Win infosoft india private limited',
    'Sukhmani solutions private limited',
    'Megapix promoters private limited',
    'Moonlink residency private limited',
    'Sgn properties private limited',
    'Gangotri premises private limited',
    'Uvaca digital systems private limited',
    'Ornate technoservices private limited',
    'Transline ifmi systems private limited',
    'Neelkamal infraproject private limited',
    'Brijlax realty private limited',
    'Dhanvijay builders private limited',
    'Dhanvijay infrastructure private limited',
    'Rahul realcon private limited',
    'Tangra enclave private limited',
    'Arrowspace towers private limited',
    'Tanushree properties pvt ltd',
    'Burlington technology private limited',
    'Al-anaam electronic components private limited',
    'Solution software (india) private limited',
    'Dimension websoft private limited',
    'Bankey bihari corporation limited',
    'Cyber art informations private limited',
    'Max healthcare institute limited',
    'Trace software pvt ltd',
    'M-tech systems pvt ltd',
    'Concept strategies private limited',
    'Global e- softsys private limited',
    'Itchamps software private limited',
    'Legends consulting private limited',
    'SMART KROW TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Beahead private limited',
    'Ironjaw studios private limited',
    'Innorium business solutions private limited',
    'Fortune infoserveindia private limited',
    'Dataaegis software private limited',
    'Sugoi labs private limited',
    'B-76 technologies private limited',
    'Silicon it solutions private limited',
    'Primemove technologies private limited',
    'Takira solutions private limited',
    'Eblizz technology solution private limited',
    'R m techno private limited',
    'Overdrive electronics private limited',
    'Rajadhani technologies private limited',
    'Junipers softwares private limited',
    'EAST END TECHNOLOGIES PRIVATE LIMITED',
    'Luminous infoways private limited',
    'Bee huss solutions private limited',
    'Banctec india private limited',
    'Best hawk infosystems private limited',
    'Winner technology services private limited',
    'Pragati infosoft private limited',
    'Metacube software private limited',
    'GLOBUS IMPEX SERVICES PRIVATE LIMITED',
    'Shine internet private limited',
    'Nescant info systems private limited',
    'Unigate systems private limited',
    'Servesilicon technologies private limited',
    'Contactis outsourcing private limited',
    'Queppelin technology solutions private limited',
    'Surmanja infotech private limited',
    'Innovative technosystems private limited',
    'Smr informatics private limited',
    'Engenia technologies private limited',
    'Twistfuture software private limited',
    'Truelancer internet private limited',
    'Webcon it solutions private limited',
    'Lead semantics private limited',
    'E pocket solutions private limited',
    'Rithisha information systems private limited',
    'Dep india private limited',
    'APN VENTURES AND CONSULTANCY PRIVATE LIMITED',
    'Aversan systems private limited',
    'Net magnus solutions (india) private limited',
    'Dextrasys technologies private limited',
    'Cloudinfra technologies private limited',
    'Kgm softwares private limited',
    'Asset infotech limited',
    'Leading edge technology & consultants pvt. ltd.',
    'Capital informatics private limited',
    'Net results limited',
    'Titagarh enterprises limited',
    'Tvh computers and consultants pvt ltd',
    'Fitser web services private limited',
    'Sofin technologies private limited',
    'Kejriwal dyeing and printing mills private limited',
    'DJ',
    'S REGISTER INDUSTRIAL SERVICES (INDIA) PRIVATE LIMITED',
    'Sahil freight express private limited',
    'Far shipping (india) private limited',
    'Subcont surveyors private limited',
    'Dolphin navigation private limited',
    'Surge marine services private limited',
    'Super quick freight cargo solutions private limited',
    'Chhatrala logistics private limited',
    'Velji global logistics private limited',
    'Ksm marine logistics private limited',
    'International cargo express private limited',
    'Shri balaji shipping solutions private limited',
    'Precious logistics private limited',
    'Valuetree india private limited',
    'T p logistics private limited',
    'Prakruti industries private limited',
    'RAS FREIGHT PRIVATE LIMITED (OPC)',
    'Shekar logistics private limited',
    'Blueocean container terminals (india) private limited',
    'GARUDA SPORTS VENTURE PRIVATE LIMITED',
    'Travix leisure and travel private limited',
    'L.v. tours & travels private limited',
    'Tj travel services private limited',
    'Paramount vacation planners private limited',
    'Aerowheels travels private limited',
    'ECSTATIC INDIA TOURS PRIVATE LIMITED',
    'FEAST INDIA TOURS PRIVATE LIMITED',
    'Travizia tours and travels private limited',
    'Ishana freight and logistics private limited',
    'Manaj infraconstruction limited',
    'Sheth infrastructure private limited',
    'Sankirt infracon private limited',
    'Haldankar infra solutions private limited',
    'Svarna infrastructure & builders private limited',
    'Blossom infraventures india private limited',
    'Mytrah engineering private limited',
    'Bindu urja infrastructure limited',
    'Soham property holdings ( one ) private limited',
    'Aaloka real estate private limited',
    'Soham developers and infrastructure private limited',
    'Ruparel homes (india) private limited',
    'Naomi constructions private limited',
    'Gauri interior private limited',
    'GOLD GREEN AVIATION SERVICES PRIVATE LIMITED',
    'Drrs developers and infra projects private limited',
    'Smd architectural designs private limited',
    'Mytrah engineering & infrastructure private limited',
    'Gees epc services private limited',
    'Ramrajya enclave private limited',
    'Lifestyle interiors private limited',
    'Monarch cars private limited',
    'Ecovinal international private limited',
    'Agafiya trading private limited',
    'CHETRA SEALS PRIVATE LIMITED',
    'Culti flora private limited',
    'Gs caltex india private limited',
    'Rain bird products and services private limited',
    'Rivolta mercantiles private limited',
    'Rajendra agri- trade private limited',
    'Sunanda agri- trade private limited',
    'Rohit agri-trade private limited',
    'Unicharm india private limited',
    'Health n age private limited',
    'Just lifestyle private limited.',
    'Isiworld steels pvt ltd',
    'Isimetals (india) pvt ltd',
    'Geetavin enterprises private limited',
    'Mastermind projects and associates private limited',
    'Stl impex (india) private limited',
    'Grewal exports private limited',
    'Saraswati exports private limited',
    'Concept commercial private limited',
    'Isicom traders pvt ltd',
    'Isisales (india) pvt ltd',
    'Isistar exports pvt ltd',
    'Firestone trading private limited',
    'Preci marking private limited',
    'Brand marketing (india) private limited',
    'Hoya medical india private limited',
    'Skaps industries india private limited',
    'Samantar sales and services private limited',
    'Gokulmani agricom limited',
    'Robertet flavours and fragrances india private limited',
    'Jai mata tradeplace private limited',
    'Starent networks india sales and services private limited',
    'Sarah exim private limited',
    'M.b. exports limited',
    'Rameshwar marketing private limited',
    'I.n.k. metatrade limited',
    'Efetch impex private limited',
    'Fairmacs departmental stores private limited',
    'Rajveer lifestyles private limited',
    'Goup multitrade private limited',
    'Metropolis health products retail private limited',
    'Mj distributors private limited',
    'PRIME FOCUS PRODUCTION SERVICES PRIVATE LIMITED',
    'Acme pc components private limited',
    'Reach logistics private limited',
    'SUNGOLD MEDIA AND ENTERTAINMENT LIMITED',
    'Telstar hospitality private limited',
    'Shubh arambh resorts private limited',
    'Dhangra hotels & beach resorts private limited',
    'Reach hotels private limited',
    'Neighbourhood hospitality private limited',
    'Fifah dining experiences private limited',
    'Shrutika roadlines private limited',
    'Aka supplychain solutions private limited',
    'A.s.cargo movers private limited',
    'A.s. carriers private limited',
    'Computer sciences corporation india private limited',
    'Starlight logistics private limited',
    'Ark global logistics private limited',
    'Mail exprres logistic private limited',
    'Shrinathji forwarders private limited',
    'Metro logistic private limited',
    'Maruti mumbai cargo private limited',
    'Cargo concepts (bombay) private limited',
    'Ocean care forwarders private limited',
    'Equator freight & logistics private limited',
    'A.s.global logistics & warehousing services private limited',
    'Punit reach logistics private limited',
    'Dhaval construction and developers private limited',
    'Dhaval housing private limited',
    'Pristine hospitalities private limited',
    'Shivalik ventures private limited',
    'Neptune realtors & developers private limited',
    'Anns realtors private limited',
    'Shiv sreyaa estates private limited',
    'Unico infraengineers private limited',
    'Technomaint contractors limited',
    'Kent industrial park private limited',
    'Kataria industrial park private limited',
    'Aone aniket infracon private limited',
    'Divis infratech india private limited',
    'Firsthouse budget homes private limited',
    'Jaagruthi power and infra private limited',
    'Shoaham land developers private limited',
    'Sankpal developers private limited',
    'Yoggav realty private limited',
    'Redan infrastructure private limited',
    'Bharathi infra india private limited',
    'Mbl projects limited',
    'Cvs infrastructure private limited',
    'BNP PARIBAR PRIVATE LIMITED',
    'RRHI PRIVATE LIMITED',
    'CAPACIT',
    'ZINE GARAGE PRIVATE LIMITED',
    'ADIRA TECH SERVICES PRIVATE LIMITED',
    'Valay solution private limited',
    'Tg equirus broking private limited',
    'Aavkar publications private limited',
    'Yashraj investments and leasing company private limited',
    'Anson fincorp private limited',
    'Venkatgiri lifcon private limited',
    'Alchemy housing finance private limited',
    'Quest investment advisors private limited',
    'Aamdani finvest private limited',
    'Intact insurance brokers private limited',
    'AGEAS FEDERAL LIFE INSURANCECOMPANY LIMITED',
    'Cyberplat india private limited',
    'MAHADHAN AGRITECH LIMITED',
    'Sri bheemeswara securities private limited',
    'Nj indiainvest private limited',
    'UNIDEL DESIGNS PRIVATE LIMITED',
    'Sanchit securities private limited',
    'M k infin private limited',
    'Dhanki securities private limited',
    'Supna holdings (india ) private limited',
    'Derivium tradition securities (india) private limited',
    'Stalwarts stock broking private limited',
    'Franklin templeton asset management (india) private limited',
    'MOTILAL OSWAL INVESTMENT ADVISORS LIMITED',
    'Cipher - plexus capital advisors private limited',
    'Karshni infrastructures private limited',
    'Galaxy real estate developers (guj) private limited',
    'Jesal park housing development private limited',
    'Apurva developers pvt ltd',
    'Revon properties private limited',
    'Romell real estate private limited',
    'Mast constructions private limited',
    'Rockdale realtors private limited',
    'Lov kush properties private limited',
    'Kalpana realty services private limited',
    'Madhani developers private limited',
    'Aerz infrastructure private limited',
    'Greenovation projects private limited',
    'Sriperumbudur ventures private limited',
    'Montana developers private limited',
    'Symmetree realty ventures private limited',
    'Megabuild tosha realtor private limited',
    'Rhodia developers private limited',
    'Tapus realties private limited',
    'Sport direct distribution private limited',
    'Knitted shirts private limited',
    'Sunmetro properties private limited',
    'AMBIENCE PROPERTIES PRIVATE LIMITED',
    'Dakshin shelters private limited',
    'Cyberabad city developers private limited',
    'Skyline ashapura infraprojects private limited',
    'KARSHNI BUSICON INDIA PRIVATE LIMITED',
    'Tishman speyer india private limited',
    'Energee realty ventures private limited',
    'Perigee realty ventures private limited',
    'Apogee realty ventures private limited',
    'Satyavacha real estates private limited',
    'Pridhvi edifices private limited',
    'Sigma byte computers private limited',
    'Siskom infotech private limited',
    'NETWEB TECHNOLOGIES INDIA LIMITED',
    'Ronit information systems private limited',
    'Accusol technologies private limited',
    'Kecious microtech private limited',
    'Bmv system integration private limited',
    'COMMSCOPE NETWORKS INDIA PRIVATE LIMITED',
    'Eka software solutions private limited',
    'L10n infopreneur private limited',
    'Crm infotek india private limited',
    'Knowledge adventure india private limited',
    'Flytomap technologies private limited',
    'Limberlink technologies private limited',
    'Merritt innovative solutions india private limited',
    'Shiksha infotech private limited',
    'Stixis technologies private limited',
    'Maven silicon softech private limited',
    'Vector e-commerce private limited',
    'Wego search technologies private limited',
    'Live inbox software technologies private limited',
    'AMAZON DIGITAL SERVICES PRIVATE LIMITED',
    'Asti infotech private limited',
    'VICTORIAS SECRET INDIA PRIVATE LIMITED',
    'Ynoox india private limited',
    'Bright minds solutions private limited',
    'EUCLID INFOTECH LIMITED',
    'PINSTORM TECHNOLOGIES LIMITED',
    'Qad india private limited',
    'Brainpower technologies private limited',
    'Transaction network services (india) private limited',
    'Indusion consultancy private limited',
    'Senseware infomedia private limited',
    'COVERSTACK TECHNOLOGIES PRIVATE LIMITED',
    'Loyal infoservices private limited',
    'Qaagility technologies private limited',
    'Bsmart private limited',
    'Triple point technology (india) private limited',
    'Infogrid pacific software private limited',
    'Invecta technologies private limited',
    'Prodigy systems and services private limited',
    'Sierra-cedar india private limited',
    'CONCENTRIX CATALYST TECHNOLOGIES PRIVATE LIMITED',
    'Karmanya software private limited',
    'Object technology solutions india private limited',
    'KLOUDGIN SAAS INDIA PRIVATE LIMITED',
    'Celigo india private limited',
    'Bluestone solutions private limited',
    'SAIS IT SERVICES INDIA PRIVATE LIMITED',
    'Esolve technologies private limited',
    'Openrice india private limited',
    'Platys solutions private limited',
    'Ascent web solutions private limited',
    'Optimizers human and info solutions private limited',
    'Precision it solutions private limited',
    'Mcafee software (india) private limited',
    'Cac india private limited',
    'Ums infotech private limited',
    'SOPRA BANKING SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'Propitia software solutions private limited',
    'Itlogic solutions private limited',
    'Kiwiqa services private limited',
    'Sufalam solutions private limited',
    'Aureate labs private limited',
    'Kaybee i t solutions private limited',
    'Hogo works solutions private limited',
    'Stanley engineered fastening india private limited',
    'Raah solutions private limited',
    'Ditto digital private limited',
    'Smart infocom private limited',
    'Softcon systems private limited',
    'Imagination technologies (india) private limited',
    'Maverick mobile solutions private limited',
    'Gamecloud technologies private limited',
    'Ethosh designs private limited',
    'Twenty twenty interior design software (india) private limited',
    'Verity knowledge solutions private limited',
    'Saksham innovations private limited',
    'Run service infocare private limited',
    'Quickplay media private limited',
    'Infineon technologies india private limited',
    'CURIA INDIA PRIVATE LIMITED',
    'Capital one services (india) private limited',
    'Toto india industries private limited',
    'Ultimate holidays private limited',
    'BPIN PRIVATE LIMITED',
    'Mun health product (india) private limited',
    'Minority branding solutions private limited',
    'Rank infratel private limited',
    'ENGIE AXIMA INDIA PRIVATE LIMITED',
    'Opj power solutions private limited',
    'Opj renewable energy private limited',
    'Imperus interior india private limited',
    'Nimbus automation solutions private limited',
    'Acumen tech-sol private limited',
    'Nasser overseas consultants private limited',
    'Versalis pacific (india) private limited',
    'Genmedic healthcare private limited',
    'Kaphs architectural and aviation products private limited',
    'Jade advisory services private limited',
    'OSB INDIA PRIVATE LIMITED',
    'Aspire recruitment solutions private limited',
    'Arya communications and electronics services private limited',
    'Mindcrest (india) private limited',
    'Metal communications private limited',
    'State street corporate services mumbai private limited',
    'Design 360 degrees solutions private limited',
    'JSS SOFTWARE & PARKS PRIVATE LIMITED',
    'Butterfly advisory services private limited',
    'Intelli search services private limited',
    'Three eg project management consultants private limited',
    'Unitech metalstamping technologies private limited',
    'Beroe consulting india private limited',
    'Privi biotechnologies private limited',
    'Visual citi signs & displays private limited',
    'A.g. india retail private limited',
    'Xentrix studios private limited',
    'Fintel solutions private limited',
    'Chowki services private limited',
    'Chapter five brand solutions private limited',
    'Filtrec bharat manufacturing private limited',
    'Continues intelligence lab private limited',
    'Genius attestation services and it solutions private limited',
    'Shetty infraservices private limited',
    'Potence controls private limited',
    'Zebra crossing paradigm private limited',
    'Raghnall insurance broking and risk management private limited',
    'Knerzon oil and gas technical services private limited',
    'CKP PRODUCTS LIMITED',
    'Enopeck seals industries private limited',
    'Concept electronic engineering solutions private limited',
    'Urvina india private limited',
    'Sam life sciences private limited',
    'Rook innovative solutions private limited',
    'Shubham pharmachem pvt ltd',
    'Threestar forwarders private limited',
    'Sinnar bidi udyog limited',
    'Pioneer embroideries limited',
    'HUHTAMAKI INDIA LIMITED',
    'IRONWOOD EDUCATION LIMITED',
    'Mother mira industries limited',
    'SARASWATI TECH ENGINEERING AND SERVICES PRIVATE LIMITED',
    'HAITECH AGRICULTURAL SOLUTIONS PRIVATE LIMITED',
    'Anokhi raj tea plantations private limited',
    'Arohana dairy private limited',
    'COMPANY3 METHOD INDIA PRIVATE LIMITED',
    'Kaolin techniques private limited',
    'Aviva marbles private limited',
    'Sfp foods private limited',
    'Meakin alco beverages limited',
    'Synthesis home textiles private limited',
    'Meera cotton and synthetic mills private limited',
    'Lanvin infrastructure private limited',
    'Prudvi infra & developers private limited',
    'SANGATH INFRATECH PRIVATE LIMITED',
    'Chokshi estate private limited',
    'Shree siddhi infrabuild private limited',
    'Conele infra private limited',
    'Bajaj shelters private limited',
    'Alchemist properties private limited',
    'SKM INFRASTRUCTURE (INDORE) PRIVATE LIMITED',
    'Tsi business parks (hyderabad) private limited',
    'Designer home steds private limited',
    'Ghanwat developers private limited',
    'Seeni naina holdings private limited',
    'Alamdar infrastructure private limited',
    'Navnit infra project private limited',
    'Arch infra projects nirman private limited',
    'Sensation infratech private limited',
    'Herieall constructions private limited',
    'Jet infraventure limited',
    'A.a. nayak constructions private limited',
    'Jess construction private limited',
    'Neish properties private limited',
    'Yuvaan infrastructure private limited',
    'Linkwell infrastructure private limited',
    'Vedaliya exports private limited',
    'Forever living imports (india) private limited',
    'Cascade star india private limited',
    'Steeltouch hardware private limited',
    'A.r.s.imports and exports private limited',
    'Orbit paper traders private limited',
    'Yaathum biotech private limited',
    'Mava technologies private limited',
    'WEDIGI GLOBAL CONSULTING PRIVATE LIMITED',
    'Gf global ventures private limited',
    'Flame facilities private limited',
    'Blume venture advisors private limited',
    'Orange decors private limited',
    'Bloom energy (india) private limited',
    'KGPCO INDIA PRIVATE LIMITED',
    'Bureau veritas industrial services (india) private limited',
    'DHRUV CONSULTANCY SERVICES LIMITED',
    'ZERO MASS PRIVATE LIMITED',
    'Regus mid-town business centre private limited',
    'Steel aiids enterprise private limited',
    'Arnav international private limited',
    'Filter specialists india private limited',
    'Diacron consultants india private limited',
    'Finlaw consultancy private limited',
    'Nikhil thampi label private limited',
    'Five network kailash broadband private limited',
    'Sol brand solutions private limited',
    'Parampara crafts exim private limited',
    'TRIPLE R INDIA PRIVATE LIMITED',
    'Infinity knowledge city private limited',
    'Asian american academic bridge private limited',
    'Rustomjee knowledge city private limited',
    'Infinity education infrastructure private limited',
    'Rustomjee academy for global careers private limited',
    'Learnex academy private limited',
    'Indian foundation for humanity',
    'Apcegen technologies private limited',
    'Gorgeous skin private limited',
    'KSAC HOSPITALS (I) PRIVATE LIMITED',
    'Ava entertainment private limited',
    'Rw media private limited',
    'Trilogy media private limited',
    'Entertainment world developers amritsar private limited',
    'SILLY MONKS ENTERTAINMENT LIMITED',
    'Super energizer fitness and entertainment private limited',
    'Diamond display solutions private limited',
    'Kreeda games india private limited',
    'Capital investment research services private limited',
    'Rst technologies private limited',
    'British business promotion association',
    'Tarang life care foundation',
    'Bajaj international realty private limited',
    'GAJRA PAI AND ZHU PRIVATE LIMITED',
    'Tulipe kitchen & decor private limited',
    'Follow your dreams foundation india',
    'Total sea-land logistics private limited',
    'Bright horizons child care services private limited',
    'Hapag-lloyd india private limited',
    'Indus bpo services private limited',
    'Chandigarh entertainment world private limited',
    'Mandke foundation',
    'Emmbi industries limited',
    'Onmobile global limited',
    'Nagalakshmi agro farms private limited',
    'Dekor exclusive granites private limited',
    'Marino food products private limited',
    'Ujjwal poly pack (india) private limited',
    'INDUS TREE CRAFTS LIMITED',
    'Shipping times (india) pvt ltd',
    'Exim multimedia (india) private limited',
    'Daicel chiral technologies (india) private limited',
    'Phoenix infocity private limited',
    'Bostik india private limited',
    'Rohini global marketing private limited',
    'VLINE PHARMACHEM PRIVATE LIMITED',
    'Kamsri printing and packaging private limited',
    'Suraj steelmet private limited',
    'Kems shakti precision castings private limited',
    'SREE IVY ROCKKS OVERSEAS PRIVATE LIMITED',
    'Dss transmission gears private limited',
    'Southern forklifters private limited',
    'Tcg real estate investment management co private limited',
    'Master heat treaters private limited',
    'Shakti-saifra precision tools (india) private limited',
    'Allied moulded enclosure products (india) private limited',
    'Shinwa (india) engineering & trading private limited',
    'TECH RIZES TRANSDOMAIN PRIVATE LIMITED',
    'Srm technologies private limited',
    'Jayashree electrodevices pvt ltd',
    'Jagath jothi solar energy private limited',
    'Synergy power controls private limited',
    'E to e interconnections private limited',
    'Alptech controls private limited',
    'Cae india private limited',
    'Electrostatic colour coatings private limited',
    'Cheloor golden real estate private limited',
    'Lam research (india) private limited',
    'Netscout systems software india private limited',
    'Deloitte special projects india private limited',
    'Fabastra impex private limited',
    'Aristos electronic manufacturing service private limited',
    'Consolidated speciality services private limited',
    'Classic labour advisory services private limited',
    'RAJURI STEELS & TMT BARS PRIVATE LIMITED',
    'Bombay tools private limited',
    'Rp telebuy skyshop private limited',
    'B.v.chinai and co. (india) private limited',
    'Bombay tools supplying agency private limited',
    'Firestorm electronics corporation private limited',
    'Dandvati investments & trading company private limited',
    'Cda technologies india private limited',
    'Analog devices india private limited',
    'Nilkamal limited',
    'Bluefish pharmaceuticals private limited',
    'Mahabharat motors manufacturing company private limited',
    'Kolkata west international city private limited',
    'Universal crescent port private limited',
    'Prashant pronoy projects private limited',
    'Infospace developers private limited',
    'Kwic facility management services private limited',
    'AQUITY SOLUTIONS INDIA PRIVATE LIMITED',
    'Kanika multiscope private limited',
    'Ihs global private limited',
    'CARDOST AUTOTECH PRIVATE LIMITED',
    'J.L. KNIT (INDIA) LIMITED',
    'ALLIED STRIPS LIMITED',
    'KAMAL BEARINGS PRIVATE LIMITED',
    'UNITHERM INDUCTOWELD (INDIA) PRIVATE LIMITED',
    'P.R. STAMPINGS PRIVATE LIMITED',
    'SUPREET CHEMICALS LIMITED',
    'V.S.Dempo Holdings Private Limited',
    'VEG AGRO INDIA LIMITED',
    'SMSG AUTOMART PRIVATE LIMITED',
    'WEBSTEP TECHNOLOGIES PRIVATE LIMITED',
    'MATHEUS IT SOLUTION OPC PRIVATE LIMITED',
    'Touchteck Facility Management Services Private Limited',
    'ROCKFIELD MINING AND MINERALS PRIVATE LIMITED',
    'BLACKROCK MINING AND MINERALS PRIVATE LIMITED',
    'HARDSTONE MINING AND MINERALS PRIVATE LIMITED',
    'ASINA TEA ESTATE PVT LTD',
    'CONNECTIONS HOTELS AND ALLIED SERVICES PRIVATE LIMITED',
    'VIVOUTLAW CONSULTANTS PRIVATE LIMITED',
    'DANKUNI JUICE PRIVATE LIMITED',
    'VIVID LAND & PROJECT LIMITED',
    'TEJA MARINE SERVICES PRIVATE LIMITED',
    'MACTOS SYSTEMS PRIVATE LIMITED',
    'Gamma Institute of Advanced Studies Private Limited',
    'ANISAT INFRASTRUCTURE PRIVATE LIMITED',
    'ROOT PROJECT ENGINEERING CONSULTANCY PRIVATE LIMITED',
    'USRA BARTER PRIVATE LIMITED',
    'EVERLASTING BARTER LIMITED',
    'DIVONIER TIE UP PRIVATE LIMITED',
    'BEATUS SOCIAL COMPLIANCE SERVICES LIMITED',
    'GAINWELL COMMOSALES PRIVATE LIMITED',
    'JAK MARITIME & LOGISTICS INDIA PRIVATE LIMITED',
    'REDE SCALABLE ENERGY MANAGEMENT PRIVATE LIMITED',
    'PCM POWER GENERATION PRIVATE LIMITED',
    'PCM DDM DEVELOPERS PRIVATE LIMITED',
    'EMPORIUM MARKETING PRIVATE LIMITED',
    'SHAKAMBARI REALTORS PRIVATE LIMITED',
    'ASPEE MERCANTILE AND TRADING CO LTD',
    'THE INDIAN STEEL & WIRE PRODUCTS LTD',
    'MAURIA UDYOG LTD',
    'NOKHA AGRO SERVICES PRIVATE LIMITED',
    'SHREE TEA (ASSAM) MANUFACTURING INDUSTRIES LIMITED',
    'DREAMVALLEY AGROTECH PRIVATE LIMITED',
    'FRESHLIGHT BIOTECH PRIVATE LIMITED',
    'ASIAN FISHMEAL & FEEDS PRIVATE LIMITED',
    'COASTAL FUEL PVT LTD',
    'ELITE METALIKS PRIVATE LIMITED',
    'NIVRITTI FOODS PRIVATE LIMITED',
    'ASIAN THAI FOODS ( U.P.) PRIVATE LIMITED',
    'WOW MOMO FOODS PRIVATE LIMITED',
    'KAY DAIRY FARMS PRIVATE LIMITED',
    'K C DATTA & SONS INDUSTRIES PRIVATE LIMITED',
    'GEETANJALI DESIGN PRIVATE LIMITED',
    'SHOMOTA WOMEN CARE PRIVATE LIMITED',
    'MANSAROVAR FABRICS PRIVATE LIMITED',
    'Koushal Charma Private Limited',
    'MERCURY EXPORTS & MANUFACTURING PRIVATE LIMITED',
    'SHARPMEDIA SOLUTIONS PRIVATE LIMITED',
    'Willpower Improvement Leaders Private limited',
    'JEETZ FILMWORKS PRIVATE LIMITED',
    'PATRALEKHA PRINT PRIVATE LIMITED',
    'HALDIA PETROCHEMICALS LIMITED',
    'SECURITY FITTINGS PRIVATE LIMITED',
    'PLUS POINT BUILDSWARE PRIVATE LIMITED',
    'RAMP ENTERPRISES PRIVATE LIMITED',
    'VINEET AUTOMOBILES PRIVATE LIMITED',
    'DEV MOTORS PRIVATE LIMITED',
    'PAVNA INDUSTRIES LIMITED',
    'Mascot Motors Private Limited',
    'STONEMEN CRAFTS INDIA PRIVATE LIMITED',
    'KODIA ESTATES PRIVATE LIMITED',
    'F S INFRATECH PRIVATE LIMITED',
    'KHAN & BROTHERS INFRATECH PRIVATE LIMITED',
    'SHIVA AUTO SALES PRIVATE LIMITED',
    'PAVNA AUTO ENGINEERING PRIVATE LIMITED',
    'AUTO MOVERS (INDIA) PRIVATE LIMITED',
    'DINESH CHAND FINANCE COMPANY PRIVATE LIMITED',
    'DARSHAN AMUSEMENTS PRIVATE LIMITED',
    'VAISHNO INFRACONSTRUCTIONS PRIVATE LIMITED',
    'CHOUDHARY INFRAENGINEERING PROJECTS PRIVATE LIMITED',
    'TERASOL TECHNOLOGIES PRIVATE LIMITED',
    'Technical Offerings and System Solutions Private Limited',
    'WABASTA INFOTECH PRIVATE LIMITED',
    'Pavna e-Systems & Electronics Private Limited',
    'MASCOT AUTOMOTIVE INDIA PRIVATE LIMITED',
    'RK AGROEXPORT PRIVATE LIMITED',
    'NS WEBSOLUTION PRIVATE LIMITED',
    'MASCOT SPEED INDIA PRIVATE LIMITED',
    'MAHSEER PRODUCT PRIVATE LIMITED',
    'MASCOT RETAIL PRIVATE LIMITED',
    'R. K. SWARN PRIVATE LIMITED',
    'SIA IMPEX PRIVATE LIMITED',
    'RASS PHARMA PRIVATE LIMITED',
    'HICKS HEALTH CARE PRIVATE LIMITED',
    'MR. BROWN BAKERY & FOOD PRODUCTS PRIVATE LIMITED',
    'PAVNA SPORTS VENTURE PRIVATE LIMITED',
    'SHREE BHAWANI PAPER MILLS LIMITED',
    'TRIVENI GLASS LIMITED',
    'KAROM CORPORATION PRIVATE LIMITED',
    'PURN-KUTI FORESTRY (INDIA) LIMITED',
    'CHAUDAHRANA STEELS PRIVATE LIMITED',
    'LAW PUBLISHERS (INDIA) PRIVATE LIMITED',
    'M V PLAST PRIVATE LIMITED',
    'A H WHEELER AND COMPANY PRIVATE LIMITED',
    'SHUCHITA PRAKASHAN PRIVATE LIMITED',
    'SRI DURGA PUSTAK BHANDAR PRIVATE LIMITED',
    'BHARAT PUMPS AND COMPRESSORS LIMITED',
    'VEEKAY CONNECTORS PRIVATE LIMITED',
    'CARACTERES TYPES PRIVATE LIMITED',
    'TEECEE GENERAL INDUSTRIES PRIVATE LIMITED',
    'UNIVERSAL TELELINKS PRIVATE LIMITED',
    'ALLAHABAD ENTERPRISES PRIVATE LIMITED',
    'KUMAR INDUSTRIES PRIVATE LIMITED',
    'TRANSCENDS ART & DESIGN CRAFTS PRIVATE LIMITED',
    'EXCELLENT APARTMENTS PRIVATE LIMITED',
    'NATRAJ COLONISERS PRIVATE LIMITED',
    'AVIRAL COLONIZERS PRIVATE LIMITED',
    'SPECTRUM INFRAESTATE PRIVATE LIMITED',
    'WELKIN INFRATECH LIMITED',
    'AGRAJ INFRASTRUCTURE PRIVATE LIMITED',
    'KANHA MOTORS PRIVATE LIMITED',
    'Puran Motors Private Limited',
    'COMMERCIAL AUTO SALES PRIVATE LIMITED',
    'SHUCHITA RETAIL PRIVATE LIMITED',
    'MAIS OVERSEAS PRIVATE LIMITED',
    'ELCHICO HOTELS AND RESTAURANTS PRIVATE LIMITED',
    'UR TRAVEL SHOP PRIVATE LIMITED',
    'ADI VOYAGES INDIA PRIVATE LIMITED',
    'QUANTISER TELECOM SERVICES PRIVATE LIMITED',
    'SANGAM INVESTMENTS LIMITED',
    'PRAYAG UDYOG PRIVATE LIMITED',
    'SBW UDYOG LIMITED',
    'LEBENSRAUM INFRA PRIVATE LIMITED',
    'EMAR HOUSING AND CONSTRUCTIONS LIMITED',
    'ADMIRE INFRAVENTURES PRIVATE LIMITED',
    'IMMENSE INFRABUILD PRIVATE LIMITED',
    'DKUMARS INFRAPROJECTS PRIVATE LIMITED',
    'ABHAY INFRAVENTURES PRIVATE LIMITED',
    'Sarthak Infraventures Private Limited',
    'EROL BUILDERS PRIVATE LIMITED',
    'Reecomps Teleservices Private Limited',
    'AD SOFTEX (INDIA) PRIVATE LIMITED',
    'IMMENSE COMMUNICATION PRIVATE LIMITED',
    'S R INFOTECH PRIVATE LIMITED',
    'DATA EXPERT TECHNICAL INSTITUTE PRIVATE LIMITED',
    'TEAMWORK INFO SOLUTIONS PRIVATE LIMITED',
    'MINDSTICK SOFTWARE PRIVATE LIMITED',
    'SHARDA INFOSOLUTIONS PRIVATE LIMITED',
    'SHUCHITA TECHNOLOGIES PRIVATE LIMITED',
    'IMPETUS TECHNOCARE PRIVATE LIMITED',
    'Studybay Technologies Private Limited',
    'SHRIMAYI TRADEMART SERVICES PRIVATE LIMITED',
    'ALLAHABAD INDUSTRIAL DEVELOPMENT CENTRE PRIVATE LIMITED',
    'Assure IP India Private Limited',
    'PRESIDENCY INTERNATIONAL HOTELS PRIVATE LIMITED',
    'SUVIDHA MOVERS PRIVATE LIMITED',
    'TRIVENI GLAZERS PRIVATE LIMITED',
    'Suryang Enterprises Private Limited',
    'QUBES DESIGN PRIVATE LIMITED',
    'ZENOM SOLAR POWER PRIVATE LIMITED',
    'KANHA AUTOMOTIVES PRIVATE LIMITED',
    'YASH GREEN LAND PRIVATE LIMITED',
    'Dnata International Private Limited',
    'ANGEL SEAIR CARGO PRIVATE LIMITED',
    'TRAVELOGY INDIA PRIVATE LIMITED',
    'PLAN JOURNEYS PRIVATE LIMITED',
    'Travel Beats Holidays Private Limited',
    'D L LOGISTICS PRIVATE LIMITED',
    'DEE CATALYST PRIVATE LIMITED',
    'AJ Journey Ease Private Limited',
    'ENGLOBE LOGISTICS PRIVATE LIMITED',
    'Dnata Marketing Services Private Limited',
    'AFFINITY TELECOM PRIVATE LIMITED',
    'MINAVO TELECOM NETWORKS PRIVATE LIMITED',
    'CELL COM TELEVENTURE PRIVATE LIMITED',
    'DECON TELECOM SOLUTIONS PRIVATE LIMITED',
    'TRIPLE PLAY TELECOMMUNICATION PRIVATE LIMITED',
    'LOGICALFLIP COMMUNICATIONS PRIVATE LIMITED',
    'STAY CONNECT CELLULAR SERVICES PRIVATE LIMITED',
    'INMATE TELECOMMUNICATIONS PRIVATE LIMITED',
    'HELMER TECHNOLOGIES PRIVATE LIMITED',
    'MSG ADVERT Private Limited',
    'ELITE (INDIA) PRIVATE LIMITED',
    'ASHLAR SECURITIES PRIVATE LIMITED',
    'CHHABILDAS INVESTMENT PRIVATE LIMITED',
    'PRANIL POLYMERS LIMITED',
    'MODINAGAR ROLLS Private Limited',
    'Gen Y Commodities Private Limited',
    'FINCLOVER WEALTH MANAGEMENT SERVICES PRIVATE LIMITED',
    'LEAF INVESTMENT PRIVATE LIMITED',
    'A K BAJAJ INVESTMENT PRIVATE LIMITED',
    'RAGHUKUL TRADING PRIVATE LIMITED',
    'GOLDRUSH CAPITAL SERVICES PRIVATE LIMITED',
    'SHARE INDIA SECURITIES LIMITED.',
    'ANG Capital Services Private Limited',
    'PARAS SHARE BROKERS PRIVATE LIMITED',
    'SHARE WISE EQUITY BROKERS PRIVATE LIMITED',
    'TRUSTLINE WEALTH MANAGEMENT PRIVATE LIMITED',
    'JINDAL PIPES FINANCE LIMITED',
    'KOR WEALTH ADVISORS PRIVATE LIMITED',
    'FISCO RATING AGENCY PRIVATE LIMITED',
    'RAJMAHAL HOUSING PRIVATE LIMITED',
    'U.R. Infratech Private Limited',
    'HOMES CONNECT CONSULTING PRIVATE LIMITED',
    'ASSOTECH CONSTRUCTION PRIVATE LIMITED',
    'INSPIRETECH REALTY PRIVATE LIMITED',
    'BULLMEN BUSINESS CENTER PRIVATE LIMITED',
    'ACE RESIDENCY PRIVATE LIMITED',
    'ACEAQUA BEVERAGES PRIVATE LIMITED',
    'WILLIAM AND LIBERTY PROPERTIES PRIVATE LIMITED',
    'FLORAVILLE MANAGEMENT SERVICES PRIVATE LIMITED',
    'KRIPALU INFRATECH & BUILDERS PRIVATE LIMITED',
    'SYNERGYONE REAL ESTATES PRIVATE LIMITED',
    'NAVJYOTI RESIDENCY PRIVATE LIMITED',
    'R N V Projects Private Limited',
    'VENETIAN INFRAPROJECT PRIVATE LIMITED',
    'ANDRI BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'AJAY REALCON INDIA PRIVATE LIMITED',
    'INNOVATIVE INFRAVENTURES PRIVATE LIMITED',
    'PRESIDENCY INFRAHEIGHTS PRIVATE LIMITED',
    'Home Consultant Private Limited',
    'NEST N BEST PRIVATE LIMITED',
    'Samana Engineering & Construction Private Limited',
    'TARKULI ENTERPRISES PRIVATE LIMITED',
    'ACE MEGA STRUCTURES PRIVATE LIMITED',
    'ACE INFRACITY DEVELOPERS PRIVATE LIMITED',
    'STAR LANDCRAFT PRIVATE LIMITED',
    'MENDING WALLS PROMOTERS AND DEVELOPERS PRIVATE LIMITED',
    'HSSS INVESTMENT HOLDING PRIVATE LIMITED',
    'HSBKB Property Trustee Co Private Limited',
    'SBSB Realty Trustee Co Private Limited',
    'SSBSB Realty Trustee Co Private Limited',
    'KBHB INVESTMENT HOLDING PRIVATE LIMITED',
    'SHS Realty Trustee Company Private Limited',
    'SBSSB Realty Trustee Co Private Limited',
    'SSBPB INVESTMENT HOLDING PRIVATE LIMITED',
    'CONSILIUM INFRA PRIVATE LIMITED',
    'BEN NAVIS INFRASTRUCTURE PRIVATE LIMITED',
    'LUXMI INFRA HOMES PRIVATE LIMITED',
    'KAPI REALATORS PRIVATE LIMITED',
    'Saurabh And Sayyad Property Options Private Limited',
    'ELEVEN CONSTRUCTION PRIVATE LIMITED',
    'T AND T INFRAZONE PRIVATE LIMITED',
    'OTS INFRASTRUCTURES PRIVATE LIMITED',
    'EAGLE LANDBUILDCON PRIVATE LIMITED',
    'PASSION INFRADEVELOPERS PRIVATE LIMITED',
    'ONSITE RENTALS SERVICES PRIVATE LIMITED',
    'SUNWAY INFRASTRUCTURE SERVICES LIMITED',
    'MARKEM - IMAJE INDIA PRIVATE LIMITED',
    'Masamb Electronics Systems Private Limited',
    'GENESIS FUTURISTIC TECHNOLOGIES LIMITED',
    'MNK CREATIVES PRIVATE LIMITED',
    'OUTWORKS SOLUTIONS PRIVATE LIMITED',
    'TELENITY SYSTEMS SOFTWARE INDIA PRIVATE LIMITED',
    'VELOCITY SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MASTECH DIGITAL PRIVATE LIMITED',
    'OMNIA EDUCATION PRIVATE LIMITED',
    'OJAS SOFTECH PRIVATE LIMITED.',
    'ACUTECH SOLUTIONS PRIVATE LIMITED',
    'SISOFT TECHNOLOGIES PRIVATE LIMITED',
    'WEBKUL SOFTWARE PRIVATE LIMITED',
    'SYNTHESIS SYSTEMS INDIA PRIVATE LIMITED',
    'BIT WEB TECHNOLOGIES PRIVATE LIMITED',
    'PROBABILITY GAMING PRIVATE LIMITED',
    'PROSPUS CONSULTING PRIVATE LIMITED',
    'STOCK OPTIONS XPRESS PRIVATE LIMITED',
    'A. R. POLYMERS PRIVATE LIMITED',
    'SHANTI SURGICALS PRIVATE LIMITED',
    'INTEGRATED DEFENCE PRODUCTS PRIVATE LIMITED',
    'UVIRAJ GLOBAL PRIVATE LIMITED',
    'UVIRAJ IMPEX PRIVATE LIMITED',
    'XPERT SAFETY SOLUTIONS PRIVATE LIMITED',
    'INDUSTRIAL YARNS & THREADS (INDIA) PRIVATE LIMITED',
    'MOTI SURGICAL UDYOG PRIVATE LIMITED',
    'AGMOTEX FABRICS Private Limited',
    'RAJ RAJESHWARI TECCHNO-FAB PRIVATE LIMITED',
    'CLASSIC APPARELS PRIVATE LIMITED',
    'SARAH GARMENTS PRIVATE LIMITED',
    'KARAN LETEX LIMITED',
    'SADAF ENTERPRISES PRIVATE LIMITED',
    'NAMO NAMAH EXIM PRIVATE LIMITED',
    'REGAL GARMENTS PRIVATE LIMITED',
    'CANARY APPARELS PRIVATE LIMITED',
    'ALLIED LEATHER FINISHERS PRIVATE LIMITED',
    'AFPL GLOBAL PRIVATE LIMITED',
    'PARASNATH TECHGARMENTS PRIVATE LIMITED',
    'RED GINGER SECURITIES INDIA PRIVATE LIMITED',
    'ARRAY FASHIONS PRIVATE LIMITED',
    'RISHI SAFETEX PRIVATE LIMITED',
    'JET KNIT INDCLUS PRIVATE LIMITED',
    'NOMADIC CASUALS PRIVATE LIMITED',
    'RUKSH GARMENTS PRIVATE LIMITED',
    'DEVASHISH IMPEX PRIVATE LIMITED',
    'JET KNITWEARS Limited',
    'RYDERS EQUESTRIAN PRODUCTS PRIVATE LIMITED',
    'RAHMAN INDUSTRIES LIMITED',
    'S.A. LEATHER SELLERS LIMITED',
    'Camio Exports Private Limited',
    'SHOEMAX ENGINEERING PRIVATE LIMITED',
    'GROWMORE INTERNATIONAL LIMITED',
    'IBRAHIM INTERNATIONAL PRIVATE LIMITED',
    'ZAIBUNCO INDUSTRIES PRIVATE LIMITED',
    'AMAR BROTHERS GLOBAL PRIVATE LIMITED',
    'H G E INTERNATIONAL PRIVATE LIMITED',
    'INDCOAT SOLES PRIVATE LIMITED',
    'MEGALEATHER CLUSTERDEVELOPMENT (U.P.) LIMITED',
    'TIRUBALA INTERNATIONAL PRIVATE LIMITED',
    'Y K INDUSTRIES PRIVATE LIMITED',
    'MODEL EXIMS (INDIA) PRIVATE LIMITED',
    'AMIN TANNERY LIMITED',
    'RUKSH FOOTWEAR PRIVATE LIMITED',
    'BHOLA FOOTWEAR EXPORT PRIVATE LIMITED',
    'A.T.O. EXIMS PRIVATE LIMITED',
    'SWADESHI FOOTCARE PRIVATE LIMITED',
    'LEAYAN GLOBAL PRIVATE LIMITED',
    'AALEE INDIA EXPORTS PRIVATE LIMITED',
    'PARVEZ SHOES PRIVATE LIMITED',
    'RUKSH LEATHER FINISHER PRIVATE LIMITED',
    'TREADSTONE INTERNATIONAL LIMITED',
    'TREADSTONE EQUESTRIAN PRIVATE LIMITED',
    'SIKANDAR AND COMPANY PRIVATE LIMITED',
    'HOMERA TANNING INDUSTRIES PRIVATE LIMITED',
    'JAMA CORPORATION PRIVATE LIMITED',
    'L R MOULDS PRIVATE LIMITED',
    'SHOEMAC LEATHER TECH ENGINEERS LIMITED',
    'RUPANI FOOTCARE PRIVATE LIMITED',
    'SEVEN SHOES PRIVATE LIMITED',
    'S.K.SHOES AND BOOTS PRIVATE LIMITED',
    'CRESCENT TANNERS PRIVATE LIMITED',
    'INDCOAT SHOE COMPONENTS LIMITED',
    'K G FOOTWEAR EXPORTS PRIVATE LIMITED',
    'M.K.J.COMPONENTS PRIVATE LIMITED',
    'CUSHY SHOES PRIVATE LIMITED',
    'CALICO SHOES PRIVATE LIMITED',
    'AHSAN LEATHERS PRIVATE LIMITED',
    'SUPER SHOES LIMITED',
    'SURI SHOES PRIVATE LIMITED',
    'AKI INDIA LIMITED',
    'VIKRON ENTERPRISES PRIVATE LIMITED',
    'NAAZ EXPORTS PRIVATE LIMITED',
    'KRISTOL EXIM PRIVATE LIMITED',
    'STAR INTERNATIONAL PRIVATE LIMITED',
    'TORPEDO SHOES PRIVATE LIMITED',
    'M K U LIMITED',
    'HABIB TANNERY PRIVATE LIMITED',
    'PROPENE PRODUCTS LIMITED',
    'KPL PACKAGING PRIVATE LIMITED.',
    'AMARITA PACKAGING PRIVATE LIMITED',
    'HARIOM INDUSTRIES LIMITED',
    'BEHARIJI PAPERS PRIVATE LIMITED',
    'V. K. PACKWELL PRIVATE LIMITED',
    'U P LAMINATORS PRIVATE LIMITED',
    'SWATANTRA ESTATES PRIVATE LIMITED',
    'AVCOM MEDIA PRIVATE LIMITED',
    'NAGARCHHAYA PUBLICATION PRIVATE LIMITED',
    'UNIVERSAL SUBCRIPTION AGENCY PRIVATE LIMITED',
    'SHRAY OFFSET PRIVATE LIMITED',
    'SOLAR PRESS PRIVATE LIMITED',
    'ANAND SAVTRI METAL PRINTERS PRIVATE LIMITED',
    'A.R PRINT PACK PRIVATE LIMITED',
    'NORTHERN ALKALIES PRIVATE LIMITED',
    'PARAS TRADEMART PRIVATE LIMITED',
    'ARAUL REFIRGERATION INDUSTRIES PRIVATE LIMITED',
    'JAI INNOVATIVE CHEMICAL INDUSTRIES PRIVATE LIMITED',
    'AUCHLITE CHEMICAL PRIVATE LIMITED',
    'NIKHIL TECHNO CHEM PRIVATE LIMITED',
    'SHELL ORGANICS PRIVATE LIMITED',
    'VIKRANT CHEMICO INDUSTRIES LIMITED',
    'MLA CHEMICALS PRIVATE LIMITED',
    'RUCHI ORGANICS LIMITED',
    'SRP ADHESIVES PRIVATE LIMITED',
    'LOHIA SALES AND SERVICES LIMITED',
    'SYNTANS AND COLLOIDS ORGANICS PRIVATE LIMITED',
    'ANOD PHARMA PRIVATE LIMITED',
    'KAMERO TECHNOSYS LIMITED',
    'A P CHEMICALS PRIVATE LIMITED',
    'MEDINI CITY HOMES SHAHJAHANPUR PRIVATE LIMITED',
    'MANI CITY HOMES MIRZAPUR PRIVATE LIMITED',
    'NIRAD CITY HOMES SITAPUR PRIVATE LIMITED',
    'YAMIR CITY HOMES RAEBAREILLY PRIVATE LIMITED',
    'MAHANT CITY HOMES MIRZAPUR PRIVATE LIMITED',
    'VIVASH CITY HOMES RAEBAREILLY PRIVATE LIMITED',
    'VIJVAL CITY HOMES RAEBAREILLY PRIVATE LIMITED',
    'OJAYIT CITY HOMES SITAPUR PRIVATE LIMITED',
    'ODITI CITY HOMES SITAPUR PRIVATE LIMITED',
    'YASHAS CITY HOMES RAEBAREILLY PRIVATE LIMITED',
    'MAHIKA CITY HOMES MIRZAPUR PRIVATE LIMITED',
    'VAYUN CITY HOMES RAEBAREILLY PRIVATE LIMITED',
    'SAS COLONISERS PRIVATE LIMITED',
    'ADIL CITY HOMES AGRA PRIVATE LIMITED',
    'AASHISH CITY HOMES AGRA PRIVATE LIMITED',
    'BARSAAT CITY HOMES RAMPUR PRIVATE LIMITED',
    'AMALENDU CITY HOMES BULANDSHAHAR PRIVATE LIMITED',
    'MARKLINES INDIA PRIVATE LIMITED',
    'CEKATAINERS PACK TEK INDIA LIMITED',
    'MIRAIST PRIVATE LIMITED',
    'MBATREK PRIVATE LIMITED',
    'FLIP ROBO TECHNOLOGIES PRIVATE LIMITED',
    'GLIESE SOLUTIONS PRIVATE LIMITED',
    'TALETTUTAYI SOLAR PROJECTS FOUR PRIVATE LIMITED',
    'LUGH EDUTECH PRIVATE LIMITED',
    'JOSHO LEARNING PRIVATE LIMITED',
    'MISSION IGNITE SERVICES PRIVATE LIMITED',
    'INTERNATIONAL CENTRE FOR ADVANCE STUDIES AND RESEARCH',
    'TEACHEDISON SOLUTIONS PRIVATE LIMITED',
    'PROLIFE MULTI SPECIALTY HOSPITALS PRIVATE LIMITED',
    'QUIZIZZ INDIA PRIVATE LIMITED',
    'TALKING YAK ENGLISH LEARNING PRIVATE LIMITED',
    'TRAINING-LADDER CONSULTANTS (OPC) PRIVATE LIMITED',
    'SOLOCUBES TECH PRIVATE LIMITED',
    'EXPAT EDUCATIONAL INSTITUTE',
    'MEDICIANS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'RAYONNANT NATURAL CARE EXCELLENCE PRIVATE LIMITED',
    'V AID HEALTH CARE SERVICES PRIVATE LIMITED',
    'ELEVATEX PERFORMANCE INSTITUTE PRIVATE LIMITED',
    'INSPIRIT SAFETY SOLUTIONS PRIVATE LIMITED',
    'IPA EDUCATION PRIVATE LIMITED',
    'KJF SHELTERS FOUNDATION',
    'KJF MANAVTA-NI-MAHEK FOUNDATION',
    'WATCH YOUR HEALTH.COM INDIA PRIVATE LIMITED',
    'DRSTORE HEALTHCARE SERVICES INDIA PRIVATE LIMITED',
    'CROWN VETERINARY SERVICES PRIVATE LIMITED',
    'PARKWAY HEALTHCARE INDIA PRIVATE LIMITED',
    'WELCOME CURE PRIVATE LIMITED',
    'DISTINCT HORIZON PRIVATE LIMITED',
    'LALJI SUPERSPECIALITY HOSPITAL & RESERCH CENTRE GORAKHPUR PRIVATE LIMITED',
    'SOOTHE HEALTHCARE PERSONAL CARE PRIVATE LIMITED',
    'MOONJUR HEALTHCARE PRIVATE LIMITED',
    'MEDIGENCE NETWORK PRIVATE LIMITED',
    'VIVOIZ HEALTHTECH PRIVATE LIMITED',
    'FAIRGAZE SKILLS PRIVATE LIMITED',
    'STERLING DENTAL TRAININGS PRIVATE LIMITED',
    'HEALTH & HAPPINESS PRIVATE LIMITED',
    'VISION DIGITAL INSURANCE TPA PRIVATE LIMITED',
    'STERLING DENTAL CENTRES PRIVATE LIMITED',
    'A B CHARITABLE FOUNDATION',
    'INDUCTOTHERM CSR FOUNDATION',
    'GETFAST PHARMACEUTICALS PRIVATE LIMITED',
    'LFS HEALTHCARE PRIVATE LIMITED',
    'VERITAAS HEALTH CARE PRIVATE LIMITED',
    'CITILAB HEALTHCARE (INDIA) PRIVATE LIMITED',
    'CORMED HEALTHCARE PRIVATE LIMITED',
    'TRINITY EYE CARE PRIVATE LIMITED',
    'AVITIS SUPER SPECIALTY HOSPITALS PRIVATELIMITED',
    'SANTAAN FERTILITY CENTER & RESEARCH INSTITUTE PRIVATE LIMITED',
    'KOSHAL MULTI-CARE HOSPITAL PRIVATE LIMITED',
    'SURYA MOTHER AND CHILD CARE JAIPUR PRIVATE LIMITED',
    'PRATHIMA CANCER HOSPITAL PRIVATE LIMITED',
    'RADVIN FOUNDATION',
    'RADHA SURROGACY MOTHER CARE PRIVATE LIMITED',
    'YOURDOST HEALTH SOLUTIONS PRIVATE LIMITED',
    'CHEMO INDIA FORMULATION PRIVATE LIMITED',
    'THUMBAY HOSPITAL INDIA PRIVATE LIMITED',
    'ACCUHEALTH SOLUTIONS PRIVATE LIMITED',
    'PLAN MY MEDICAL TRIP PRIVATE LIMITED',
    'BVR HEALTHCARE PRIVATE LIMITED',
    'IMPRES HEALTH PRIVATE LIMITED',
    'NETCORE SKILL DEVELOPMENT FOUNDATION',
    'DEEVOIR HEALTHCARE SERVICES PRIVATE LIMITED',
    'RESILIENCE HEALTH PRIVATE LIMITED',
    'OPTIMUS MEDICAL SERVICES PRIVATE LIMITED',
    'SOOTHIKA AYURVEDA MOTHER & BABY CARE PRIVATE LIMITED',
    'HARSH SOCIAL WELFARE FOUNDATION',
    'HUM ASPEN WELLNESS PRIVATE LIMITED',
    'OPUS RURAL FOUNDATION',
    'LANGHORNE PHYSICIANS PRIVATE LIMITED',
    'HAPPYDAYS COMMUNITIES PRIVATE LIMITED',
    'ARCHEESH HEALTH CARE PRIVATE LIMITED',
    'MAKE MY CLINIC INDIA PRIVATE LIMITED',
    'ASIA PACIFIC COMPUTER EDUCATION MANAGEMENT ASSOCIATION',
    'SPECIAL SMILES PRIVATE LIMITED',
    'INTERNATIONAL INSTITUTE OF CSR FOUNDATION',
    'ANUBHUTI WELFARE FOUNDATION',
    'MAHAGRAM FOUNDATION',
    'INDUMATI BABULAL AJMERA FOUNDATION',
    'BEHANDELN MEDCARE SOLUTIONS PRIVATE LIMITED',
    'VASMED HEALTH SCIENCES PRIVATE LIMITED',
    'HERBAL EXTRACTS MANUFACTURERS ASSOCIATION OF INDIA',
    'DOCTORSCABIN HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'EMPBINDI INTERNATIONAL ASSOCIATION',
    'TRAYARUNYA FOUNDATION',
    'AADVIKA ENGINEERS PRIVATE LIMITED',
    'INDO U K CLINICS PRIVATE LIMITED',
    'VA EXERGY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NCR INDICARE PRIVATE LIMITED',
    'THERANOSIS LIFE SCIENCES PRIVATE LIMITED',
    'SANO TECHNOLOGIES PRIVATE LIMITED',
    'ASVINS LIFETECHNOLOGIES PRIVATE LIMITED',
    'AMIT HEALTHCARE PRIVATE LIMITED',
    'YASHASWI PERSONNEL SERVICES PVT LTD',
    'JAYBHARATH ELECTORAL TRUST',
    'LUDHIANA OIL EXPELLER AND PARTS MANUFACTURERS ASSOCIATION',
    'KUREWAY LABS PRIVATE LIMITED',
    'ATHULYA KRISHI FOUNDATION',
    'WAJRA O',
    'S SCHOOL OF ANIMATION AND VISUAL WOUNDER PRIVATE LIMITED',
    'SPORTS ALLEY PRIVATE LIMITED',
    'RND TECH ENGINEERING PRIVATE LIMITED',
    'ZOPSOFT TECHNOLOGY PRIVATE LIMITED',
    'AZURE POWER THIRTY EIGHT PRIVATE LIMITED',
    'SHENANDOAH MEDICAL CONSULTANTS PRIVATE LIMITED',
    'RANZURE NETWORKS PRIVATE LIMITED',
    'BRICK FORCE CONSULTING SERVICES PRIVATE LIMITED',
    'CONCEPTHELIOS MARKETING PRIVATE LIMITED',
    'ADARA SKILLS PRIVATE LIMITED',
    'SKILLFIRST DIGITAL PRIVATE LIMITED',
    'DNG TECHNOLOGIES PRIVATE LIMITED',
    'SHREE RAJNARAYAN RAI FOUNDATION',
    'SAMARTH SECURITY & SURVEILLANCE INDIA PRIVATE LIMITED',
    'FASTCOLLAB SYSTEMS PRIVATE LIMITED',
    'OROANCE MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'IMPERME REALITIES PRIVATE LIMITED',
    'ASG ENERGY SOLUTIONS PRIVATE LIMITED',
    'FASTRACK WORLD WIDE PRIVATE LIMITED',
    'NEPTUNE SURFACE COATING (OPC) PRIVATE LIMITED',
    '7ARRAY SOLUTIONS PRIVATE LIMITED',
    'KALTHIA UNA HIGHWAY LIMITED',
    'DARUMA SERVICES PRIVATE LIMITED',
    'TECH-NET CYBER SOLUTIONS PRIVATE LIMITED',
    'AWEDIBLE ACOUSTICS PRIVATE LIMITED',
    'ENNSIGNN ADVISORY SERVICES PRIVATE LIMITED',
    'STERLING5 PRIVATE LIMITED',
    'NINEROOT TECHNOLOGIES PRIVATE LIMITED',
    'HIVELOOP TECHNOLOGY PRIVATE LIMITED',
    'AXIS TOURS AND TRAVELS PRIVATE LIMITED',
    'PLUSCORP CONSULTING PRIVATE LIMITED',
    'INTELLO LABS PRIVATE LIMITED',
    'GENEREX POWER SYSTEMS PRIVATE LIMITED',
    'ION WATER TREATMENT PRIVATE LIMITED',
    'TECHNITAB SOLUTIONS PRIVATE LIMITED',
    'ABRAPS INTRADECO SERVICES PRIVATE LIMITED',
    'INSANE MARKETERS PRIVATE LIMITED',
    'SKYSCRIPT TECHNOLOGIES PRIVATE LIMITED',
    'SAMRUDDHIGREEN INFRATECH PRIVATE LIMITED',
    'FARMS2FORK TECHNOLOGIES PRIVATE LIMITED',
    'OSBERT TECHNOLOGIES PRIVATE LIMITED',
    'APOLLO NUTRITIONS PRIVATE LIMITED',
    'NSSPL INDUSTRIES PRIVATE LIMITED',
    'INCLUSIVE E-MARKET SERVICES PRIVATE LIMITED',
    'ACHINTYA SOLAR POWER PRIVATE LIMITED',
    'SANVIKA PROJECTS PRIVATE LIMITED',
    'WADIA REALITY PRIVATE LIMITED',
    'ZRANGA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'OMKAAR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANJ HOSPITALITY PRIVATE LIMITED',
    'BDP ENERGY PRIVATE LIMITED',
    'JOLTME ELECTROVISION (INDIA) PRIVATE LIMITED',
    'SRISTI ORGANIC FOODS PRIVATE LIMITED',
    'GTEX FABRICS PRIVATE LIMITED',
    'RISER TECHUB PRIVATE LIMITED',
    'ALBATROSS SPORTS FOUNDATION',
    'PACIFIC CONSOLIDATED INDUSTRIES (PCI) GASES INDIA PRIVATE LIMITED',
    'JANANI FAMILY CARE PRIVATE LIMITED',
    'GENERAL KINEMATICS INDIA PRIVATE LIMITED',
    'BLACKBOARD EDUTECH INDIA PRIVATE LIMITED',
    'JOINTOLEAD SOLUTIONS PRIVATE LIMITED',
    'RECORN FOODS PRIVATE LIMITED',
    'SR GREEN ENERGY PRIVATE LIMITED',
    'EPSOFT SOLUTIONS PRIVATE LIMITED',
    'DTSCUBE KNOWLEDGE PRIVATE LIMITED',
    'RAJMUDRA PALLIA LOGISTICS PRIVATE LIMITED',
    'GO-LED TECH PRIVATE LIMITED',
    'LIL PROJECTS PRIVATE LIMITED',
    'NEEDLE INNOVISION PRIVATE LIMITED',
    'EVGRIEN SERVICES PRIVATE LIMITED',
    'JSY INFRA FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'EXCELENCIA TECHTEX PRIVATE LIMITED',
    'TRANQUILITY TOWERS PRIVATE LIMITED',
    'JOBVITE INDIA PRIVATE LIMITED',
    'GLOBAL EYE SECURITY SERVICES INDIA PRIVATE LIMITED',
    'MBP SOLAR PRIVATE LIMITED',
    'CONTENT RESPONDUS PRIVATE LIMITED',
    'GODS STEELCON PRIVATE LIMITED',
    'ARCHEDGEE PRIVATE LIMITED',
    'TERNION ENTERTAINMENT PRIVATE LIMITED',
    'MARUTI ROPES INDIA PRIVATE LIMITED',
    'COREVANCE SYSTEMS PRIVATE LIMITED',
    'SEAICE CLUB & RESORTS INDIA PRIVATE LIMITED',
    'UNIVERSALMIND TECHNOLOGIES PRIVATE LIMITED',
    'YNV TECHNOLOGIES PRIVATE LIMITED',
    'SOFEENE BRANDS AND MARKETING PRIVATE LIMITED',
    'RESERVE BANK INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'UJJIVAN SMALL FINANCE BANK LIMITED',
    'CUDDLE ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'PILETECH INFRA PRIVATE LIMITED',
    'SEALINK CLEARING FORWARDING PRIVATE LIMITED',
    'DILIGENTSQUAD TECHNOLOGIES PRIVATE LIMITED',
    'NAUTRICA EXPORTS PRIVATE LIMITED',
    'NISE LEISURE AND HOLIDAYS PRIVATE LIMITED',
    'TENSHI PHARMACEUTICALS PRIVATE LIMITED',
    'IRITTY SAND AND GRAVELS PRIVATE LIMITED',
    'POLICYMATTERS CONSULTING (OPC) PRIVATE LIMITED',
    'BIOPRIME AGRISOLUTIONS PRIVATE LIMITED',
    'HAYERS INFOTECH PRIVATE LIMITED',
    'NYASA RETAIL PRIVATE LIMITED',
    'FOUREN TECHNOLOGIES PRIVATE LIMITED',
    'TZI SOLUTIONS PRIVATE LIMITED',
    'PURO WELLNESS PRIVATE LIMITED',
    'SHARNAGAT PLAZA PRIVATE LIMITED',
    'BLUE INDIASUPPLY PRIVATE LIMITED',
    'CORPELSERVE INDIA PRIVATE LIMITED',
    'ALEXISS FACILITY SERVICES PRIVATE LIMITED',
    'SOLITAIRE FITNESS PRIVATE LIMITED',
    'WHITENIGHTS PRIVATE LIMITED',
    'ALWAHID HR CONSULTANCY PRIVATE LIMITED',
    'DCIPHER COMPUTING PRIVATE LIMITED',
    'KARVY RENEWABLE ENERGY PROJECTS LIMITED',
    'TEICON ENGINEERING INDIA PRIVATE LIMITED',
    'SERVIZZO PROJECTS PRIVATE LIMITED',
    'TEAMLEASE DIGITAL PRIVATE LIMITED',
    'APPICON IT PRIVATE LIMITED',
    'CAROMI PRINTS SOLUTIONS PRIVATE LIMITED',
    'SIMPLIFYLIVES (OPC) PRIVATE LIMITED',
    'DHAVALA INFRA-ENGINEERING PRIVATE LIMITED',
    'FRAMSIKT TECHNOLOGIES PRIVATE LIMITED',
    'ENVOCRYSTAL INDIA PRIVATE LIMITED',
    'AHAM KAUSHAL VIKAS PRIVATE LIMITED',
    'SKEIRON RENEWABLE ENERGY AMIDYALA PRIVATE LIMITED',
    'CLINCH REWARD SOLUTIONS PRIVATE LIMITED',
    'FINIMBLE SOLUTIONS PRIVATE LIMITED',
    'LEO GLOBAL LOGISTICS PRIVATE LIMITED',
    'RIVOTTA PRIVATE LIMITED',
    'NIRAMAYA EDUCATIONAL AND SOCIAL FOUNDATION',
    'COMFORT ELEVATORS PRIVATE LIMITED',
    'JACKFRUIT SOFTWARE LABS PRIVATE LIMITED',
    'SUCHNA MARINE SERVICES PRIVATE LIMITED',
    'DEEDEE LABS PRIVATE LIMITED',
    'AASUA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'GRANDE RETAILS PRIVATE LIMITED',
    'PARCELNOW WORLDWIDE PRIVATE LIMITED',
    'S2PAY SOFTWARE PRIVATE LIMITED',
    'VANSHIKA CHEMICALS PRIVATE LIMITED',
    'CORAL SERVICES PRIVATE LIMITED',
    'EXPERIENCES.DIGITAL PRIVATE LIMITED',
    'NEWAGE MEDIA & VENTURES PRIVATE LIMITED',
    'OYAA INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'GATS IMF LIMITED',
    'PARC ACCELERATOR PRIVATE LIMITED',
    'MEP SANJOSE MAHUVA KAGAVADAR ROAD PRIVATE LIMITED',
    'RALLY INFRA PRIVATE LIMITED',
    'AVRONIA INDIA PRIVATE LIMITED',
    'HERCULES TECHNOLOGIES PRIVATE LIMITED',
    'WELLBEAM INDIA PRIVATE LIMITED',
    'PLINTRON SERVICES PRIVATE LIMITED',
    'VALUE FOUNDERS PRIVATE LIMITED',
    'NODAL ENGINEERING PRIVATE LIMITED',
    'PR SARKAR CHARITABLE FOUNDATION',
    'ENGIKART LABS INDIA PRIVATE LIMITED',
    'GLOCAL HOSPITALITY PRIVATE LIMITED',
    'EXPRESOLV LIMITED',
    'ROCKDRILL INFRASTRUCTURE PRIVATE LIMITED',
    'ASHWATH INFRAPROJECTS PRIVATE LIMITED',
    'PUBANG ETRON ELECTRIC MOTOR PRIVATE LIMITED',
    'ICX4 SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'ENTERPRISE COMPUTING SOLUTIONS PRIVATE LIMITED',
    'VIOLIN TECHNOLOGIES PRIVATE LIMITED',
    'GAVI RANGA SOLARS PRIVATE LIMITED',
    'UNEECOPS WORKPLACE SOLUTIONS PRIVATE LIMITED',
    'GMA PINNACLE AUTOMOTIVES PRIVATE LIMITED',
    'RAINMAKER ONLINE TRAINING SOLUTIONS PRIVATE LIMITED',
    'STEMZ ONCOLOGY PRIVATE LIMITED',
    'MUKAND AUDYOGIK YANTRA PRIVATE LIMITED',
    'GURUPRASAD POWER CONTROLS PRIVATE LIMITED',
    'DRAMA SCHOOLS FOUNDATION MUMBAI',
    'CURLY BRACKETS SYSTEMS PRIVATE LIMITED',
    'TAG PIPE EQUIPMENT (INDIA) PRIVATE LIMITED',
    'SUNNYSIDE ESTATE PRIVATE LIMITED',
    'PELNEXT DEFENCE SYSTEMS PRIVATE LIMITED',
    'MAPAEX CONSUMER HEALTHCARE PRIVATE LIMITED',
    'EMOJIFI PRIVATE LIMITED',
    'ENINJA FULFILMENT SERVICE PRIVATE LIMITED',
    'SPICEJET MERCHANDISE PRIVATE LIMITED',
    'GREENER PRIVATE LIMITED',
    'GREENKO CHARANKA SOLAR ENERGY PRIVATE LIMITED',
    'SHARNAM TECHNO TECH INDIA PRIVATE LIMITED',
    'EUROVITA SYSTEMS PRIVATE LIMITED',
    'ANANDA HOMES PRIVATE LIMITED',
    'ZUCI SVEDNIKA PRIVATE LIMITED',
    'LARGE TO 5XL STORE PRIVATE LIMITED',
    'RAMAGYA EDUCATIONAL SERVICES PRIVATE LIMITED',
    'GEMROCK RESOURCES (INDIA) PRIVATE LIMITED',
    'ATA INFOTECH VENTURES PRIVATE LIMITED',
    'VOICETOUCH INFOTECH PRIVATE LIMITED',
    'AIDC PRODUCTS INDIA PRIVATE LIMITED',
    'TECHNOMARA WEB SOLUTIONS PRIVATE LIMITED',
    'LAZAVAB CONSTRUCTION AND DEVELOPERS AND GENERAL SUPPLIER PRIVATE LIMITED',
    'HALOPOLY INDUSTRIES PRIVATE LIMITED',
    'APRECOMM PRIVATE LIMITED',
    'URJAVAN KISAN PRODUCER COMPANY LIMITED',
    'CLOUDLENE TECHNOLOGIES PRIVATE LIMITED',
    'VEKO CARE PRIVATE LIMITED',
    'DEEP ONSHORE DRILLING SERVICES PRIVATE LIMITED',
    'JUSTFUN PRIVATE LIMITED',
    'TANTRAGYAN TECHNOLOGIES PRIVATE LIMITED',
    'DEMANDMATRIX PRIVATE LIMITED',
    'E-CARGOWARE SOFTWARE PRIVATE LIMITED',
    'COMFORT TECHNO SERVICES PRIVATE LIMITED',
    'LETCETRA AGRITECH PRIVATE LIMITED',
    'SYON SOFTTECH PRIVATE LIMITED',
    'GAADIN TECHNOLOGIES PRIVATE LIMITED',
    'KPC TRAVELS AND HOSPITALITY PRIVATE LIMITED',
    'FAST FITNESS PRIVATE LIMITED',
    'JM EDUCATION INITIATIVES PRIVATE LIMITED',
    'TASTE BUDDIES FOOD PRIVATE LIMITED',
    'SINETEC AUTOMATION PRIVATE LIMITED',
    'PT TRADE AND COMMERCE PRIVATE LIMITED',
    'EMEGATRON TECHNOLOGIES PRIVATE LIMITED',
    'SKILLSUPPLIES RETAIL PRIVATE LIMITED',
    'KARUR WIND ENERGY PRIVATE LIMITED',
    'SAMSUNG HOSPITALITY INDIA PRIVATE LIMITED',
    'SAHAWAS HOUSING FINANCE PRIVATE LIMITED',
    'NL TECHNOLOGIES PRIVATE LIMITED',
    'THINKANALYTICS DEVELOPMENT INDIA PRIVATELIMITED',
    'ADVANCED TECHNOLOGY MAINTENANCE SERVICESINDIA PRIVATE LIMITED',
    'FLASH SOLUTIONS PRIVATE LIMITED',
    'SHIN TECHNOLOGY PRIVATE LIMITED',
    'DATABACK MEDIA PRIVATE LIMITED',
    'CREWKARMA NETWORKS PRIVATE LIMITED',
    'PRICEWATERHOUSECOOPERS DIGITAL SERVICES PRIVATE LIMITED',
    'XEE-VITA HEALTHCARE PRIVATE LIMITED',
    'VIAK GROUP PRIVATE LIMITED',
    'VAARSE BEAUTY PRIVATE LIMITED',
    'FUELED TECHNOLOGIES PRIVATE LIMITED',
    'MARKONE TECHNOLOGIES PRIVATE LIMITED',
    'REVOL SOFTWARE PRIVATE LIMITED',
    'FINTELLIGENCE TECHNOLOGY PRIVATE LIMITED',
    'SOLGENIE TECHNOLOGIES PRIVATE LIMITED',
    'RAMS CREATIVE TECHNOLOGIES PRIVATE LIMITED',
    'CIDREC TECHNOLOGIES PRIVATE LIMITED',
    'ECREDIT INDIA PRIVATE LIMITED',
    'SPECIALIZED DESTINATION AND EVENT MANAGEMENT PRIVATE LIMITED',
    'MANNICK SHAH CORPORATE SOLUTION PRIVATE LIMITED',
    'CONTENT & EDITING SOLUTIONS PRIVATE LIMITED',
    'SMARTTRAK INFRA PRIVATE LIMITED',
    'TRAVELART MAESTROS PRIVATE LIMITED',
    'PEOPLESAFE EHS TECHNOLOGIES PRIVATE LIMITED',
    'PROVERBIUM APPSOLUTIONS PRIVATE LIMITED',
    'SWADESHI INDIA INFRA PRIVATE LIMITED',
    'TRENDER INNOVATIONS PRIVATE LIMITED',
    'MEP NAGPUR RING ROAD 1 PRIVATE LIMITED',
    'GLOBAL PROPERTIEZ AND BUSINESSES PRIVATELIMITED',
    'SOLUM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PIERIAN DIGITAL PRIVATE LIMITED',
    'DEZIRE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VANTA BIOSCIENCE LIMITED',
    'PLANET-P INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'TURTLE BOOKS PRIVATE LIMITED',
    'DNY REMEDIES INDIA PRIVATE LIMITED',
    'ARODO INDIA PRIVATE LIMITED',
    'AMNEY GENERATOR PRIVATE LIMITED',
    'BAYSIDE MEDIA PRIVATE LIMITED',
    'ABD VELOXE INDIA PRIVATE LIMITED',
    'SHIKHARAM MACHINING PRIVATE LIMITED',
    'MARCH WORK PRIVATE LIMITED',
    'GOALS101 DATA SOLUTIONS PRIVATE LIMITED',
    'RAPIDTEK CONTROLS PRIVATE LIMITED',
    'IDELIVER RETAIL SERVICES PRIVATE LIMITED',
    'KREATE KONNECT E- SOLUTIONS PRIVATE LIMITED',
    'TRANSFORMEDGE ENTERPRISE SERVICES PRIVATE LIMITED',
    'QTROVE SERVICES PRIVATE LIMITED',
    'ALCHEMY ROCK STONES PRIVATE LIMITED',
    'FORESEE INFRASTRUCTURE PRIVATE LIMITED',
    'VASHAN INFRATECH INDIA PRIVATE LIMITED',
    'LEARNING MATTERS PRIVATE LIMITED',
    'WIZTOWN PLANNERS PRIVATE LIMITED',
    'CANBASE PRIVATE LIMITED',
    'ISOWHIZ INDIA PRIVATE LIMITED',
    'VOIPZEN INDIA PRIVATE LIMITED',
    'NEXT CHAPTER TECHNOLOGY PRIVATE LIMITED',
    'GO4NET SOLUTIONS PRIVATE LIMITED',
    'ACHIRAL SYSTEMS PRIVATE LIMITED',
    'FOURSYS INFOTECH PRIVATE LIMITED',
    'UNHAD MEDIA (OPC) PRIVATE LIMITED',
    'SHRI RAM PETROCHEM PRIVATE LIMITED',
    'JINDAL ZEIN VENTURES PRIVATE LIMITED',
    'ANANDA FOODS LIMITED',
    'REAL RELIEF INDIA PRIVATE LIMITED',
    'VGAINT ENTERPRISES PRIVATE LIMITED',
    'STEEL ON CALL SERVICES (INDIA) PRIVATE LIMITED',
    'TRIOCULA TECHNOLOGIES PRIVATE LIMITED',
    'WISHOLIZE INDIA PRIVATE LIMITED',
    'NUMARGA SERVICES PRIVATE LIMITED',
    'PALAWAT INSIDE INDIA TRAVELS PRIVATE LIMITED',
    'ASIATISCH WORLDWIDE LOGISTICS PRIVATE LIMITED',
    'READYTOGO TRAVELS PRIVATE LIMITED',
    'ABHINAND VENTURES PRIVATE LIMITED',
    'SANDLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'CREATOORS TECH PRIVATE LIMITED',
    'SANCODE TECHNOLOGIES LIMITED',
    'ELPIS HYDRAULICS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'INVENTIVY TECHNOLOGIES PRIVATE LIMITED',
    'TALENCE SERVICES PRIVATE LIMITED',
    'MEDITUNE HEALTHCARE PRIVATE LIMITED',
    'NEWAMPS CONSULTING PRIVATE LIMITED',
    'SKALENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'YAGO TIMBER PRIVATE LIMITED',
    'GODREJ CATTLE GENETICS PRIVATE LIMITED',
    'DRINN VIRTUAL CLINIC PRIVATE LIMITED',
    'INDIWEB HOLDINGS PRIVATE LIMITED',
    'RANITAL ESTATES PRIVATE LIMITED',
    'VEELEAD SOLUTIONS PRIVATE LIMITED',
    'BAGAHOLICS PRIVATE LIMITED',
    'EAST ASIA EXIM PRIVATE LIMITED',
    'PSR IT SERVICES PRIVATE LIMITED',
    'EZIMAX TECHNOLOGIES PRIVATE LIMITED',
    'JG CORPNET (OPC) PRIVATE LIMITED',
    'HICKORY HOSPITALITY PRIVATE LIMITED',
    'SEA QUEEN HOTEL PRIVATE LIMITED',
    'TEJAYS INDUSTRIES PRIVATE LIMITED',
    'EVENTIDE MARKETING PRIVATE LIMITED',
    'VIJAYALAKSHMI ISPAT PRIVATE LIMITED',
    'RETYRSMART ADVISORY & SUPPORT SERVICES (INDIA) PRIVATE LIMITED',
    'PAWSITIVE PETS PRIVATE LIMITED',
    'GLOBAL MECHANICAL ENGINEERING INDIA PRIVATE LIMITED',
    'WIDECARE PRIVATE LIMITED',
    'INCREDIBLE VENTURES PRIVATE LIMITED',
    'JOAPA DIGITAL SECUTECH PRIVATE LIMITED',
    'PSCOPE TECHNOLOGIES PRIVATE LIMITED',
    'CURIOUS MEN FILMS PRIVATE LIMITED',
    'DATABAZAAR DIGITAL PRIVATE LIMITED',
    'ONEVOICE TRANSMEDIA PRIVATE LIMITED',
    'MINT TREE FOODS PRIVATE LIMITED',
    'COMMENCE MINT VENTURES PRIVATE LIMITED',
    'SNOWSTONE MICRONS PRIVATE LIMITED',
    'RWT INDIA PRIVATE LIMITED',
    'BHARAT FEEDER AND SHIPPING SERVICES PRIVATE LIMITED',
    'REDPRO FACILITIES PRIVATE LIMITED',
    'CB IOT TECHNOLOGIES PRIVATE LIMITED',
    'UB CORPORATE SERVICES PRIVATE LIMITED',
    'SKOLA TOYS PRIVATE LIMITED',
    'VISHESHAGYA SERVICES PRIVATE LIMITED',
    'ZENFOSYS IT SERVICES PRIVATE LIMITED',
    'SPECTRAL INSIGHTS PRIVATE LIMITED',
    'REMOTELAB TECHNOLOGIES INDIA PRIVATE LIMITED',
    'WEWORK INDIA MANAGEMENT PRIVATE LIMITED',
    'AZOVA RCM PRIVATE LIMITED',
    'VIZFEEL TECHNOLOGIES PRIVATE LIMITED',
    'RAJ AD ZONE PRIVATE LIMITED',
    'PRIME FOCUS ACADEMY OF MEDIA AND ENTERTAINMENT STUDIES PRIVATE LIMITED',
    'BASE52 ENTERTAINMENT PRIVATE LIMITED',
    'LANDSCAPE HOSPITALITY INDIA PRIVATE LIMITED',
    'TURTLE QUICK PRIVATE LIMITED',
    'TRANSLINER INDIA PRIVATE LIMITED',
    'SASWAD TOURS AND TRAVELS PRIVATE LIMITED',
    'NAIDU-BROS IMEX INDIA PRIVATE LIMITED',
    'GALLANT SPORTS & INFRA PRIVATE LIMITED',
    'LIKESTYLE INDIA PRIVATE LIMITED',
    'HIMACUS ENTERPRISES PRIVATE LIMITED',
    'LITTLE FOOD DAILY PRIVATE LIMITED',
    'RC COLOUR PRIVATE LIMITED',
    'GEORGE MAIJO AUTOMOBILES PRIVATE LIMITED',
    'DCONSUMERI MEDIATECH PRIVATE LIMITED',
    'SE7EN BRANDS ELECTRONICS PRIVATE LIMITED',
    'TEAMONK GLOBAL FOODS PRIVATE LIMITED',
    'FEG INDIA SOLUTIONS PRIVATE LIMITED',
    'SHAMBYS HOSPITALITY PRIVATE LIMITED',
    'PCM WORLDWIDE FLIGHTS PRIVATE LIMITED',
    'WHEELS SHIPPING INDIA PRIVATE LIMITED',
    'TRANSTRUCK TECHNOLOGIES PRIVATE LIMITED',
    'TOPSWA LOGISTICS PRIVATE LIMITED',
    'ADANI AGRI LOGISTICS (KATIHAR) LIMITED',
    'ADANI AGRI LOGISTICS (KOTKAPURA) LIMITED',
    'GROW INDIA RESIDENCY PRIVATE LIMITED',
    'ESS TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'KLOUD TECHNOLOGY CONSULTANTS PRIVATE LIMITED',
    'CERVELLO INDIA PRIVATE LIMITED',
    'NEEDA GREEN ENERGY PRIVATE LIMITED',
    'DAMOCON ADVISORS PRIVATE LIMITED',
    'DATAMANTRA INFOSOLUTIONS PRIVATE LIMITED',
    'ASQI INVESTMENT MANAGERS PRIVATE LIMITED',
    'RESEARCH INNOVATION INCUBATION DESIGN LABORATORY FOUNDATION',
    'FULCRUM LIFESTYLE PRIVATE LIMITED',
    'GUNINA PROCON PRIVATE LIMITED',
    'INTEGRATED ELDERCARE SOLUTIONS PRIVATE LIMITED',
    'IDATA MANAGEMENT & SOLUTIONS PRIVATE LIMITED',
    'AD TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'CURIS LIFESCIENCES PRIVATE LIMITED',
    'FOODLINK COOK HOUSE (INDIA) PRIVATE LIMITED',
    'LE GALA EVENTS PRIVATE LIMITED',
    'ELUCIDATA DATA CONSULTING PRIVATE LIMITED',
    'MSI INFOTECH PRIVATE LIMITED',
    'GJG INDIA PRIVATE LIMITED',
    'RADIANT LIFE CARE FOUNDATION',
    'FASTIDIOUS BUILDMART PRIVATE LIMITED',
    'SC JAIN & SONS PRIVATE LIMITED',
    'PUNE SMART CITY DEVELOPMENT CORPORATION LIMITED',
    'ANDAND BRAND PARTNERS PRIVATE LIMITED',
    'LA NOURRITURE INDIA SPECIALITIES LIMITED',
    'SAANGINI WOMENS SUPPORT ORGANISATION',
    'EXPRESSFEAST INDIA PRIVATE LIMITED',
    'STEEL FORTE EXIM PRIVATE LIMITED',
    'GUJARAT PETROCHEMICALS LIMITED',
    'ERGODE TRADING PRIVATE LIMITED',
    'AGZON AGRO PRIVATE LIMITED',
    'SPENCERS HOLDINGS PRIVATE LIMITED',
    'RAMA INFRATECH HOUSING PRIVATE LIMITED',
    'CRS CONSTRUCTION PRIVATE LIMITED',
    'ASYMPTOTE CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'HI-TECH METAL RECYCLING (INDIA) PRIVATE LIMITED',
    'RELIANCE E-GENERATION AND MANAGEMENT PRIVATE LIMITED',
    'EXPEDITORS TECHNOLOGIES PRIVATE LIMITED',
    'ALPHA LINEAR PRIVATE LIMITED',
    'STARK ENTERPRISES PRIVATE LIMITED',
    'AJVIK TECHNOLOGIES PRIVATE LIMITED',
    'SUPPORT FOR YOU INFO SOLUTIONS PRIVATE LIMITED',
    'SHERLOCKS HOSPITALITY PRIVATE LIMITED',
    'SOURCEGAIN CONSULTING PRIVATE LIMITED',
    'CER MICROGRIDS PRIVATE LIMITED',
    'ALL ABOUT EVE PRIVATE LIMITED',
    'MYSERVICEKART TECHNOLOGIES PRIVATE LIMITED',
    'SMAAX DIGITECH INDIA PRIVATE LIMITED',
    'BIZEE TECHNOLOGIES PRIVATE LIMITED',
    'E-EASY SOLUTIONS PRIVATE LIMITED',
    'DUNAMIS SPORTAINMENT PRIVATE LIMITED',
    'DREAMS EXPERIENTIAL MARKETING PRIVATE LIMITED',
    'METEROLOGY DATA PRIVATE LIMITED',
    'LAWFIN SERVICES PRIVATE LIMITED',
    'GLORING HOSPITALITIES PRIVATE LIMITED',
    'PRAASH BRANDS PRIVATE LIMITED',
    'STERLING DENTAL SERVICES PRIVATE LIMITED',
    'PARASOL TELECOM SOLUTION PRIVATE LIMITED',
    'ORGANIC KASHMIR PRIVATE LIMITED',
    'KODUMBURAR INDIA PRIVATE LIMITED',
    'FACTSERVICES PRIVATE LIMITED',
    'INFOBELL IT SOLUTIONS PRIVATE LIMITED',
    'IMMACULATE CREATIONS PRIVATE LIMITED',
    'STAINLAY INDIA IMPEX PRIVATE LIMITED',
    'EZ SHUTTLE PRIVATE LIMITED',
    'ALPHABET TECHSOLUTIONS (INDIA) PRIVATE LIMITED',
    'CER ENERGY SERVICES PRIVATE LIMITED',
    'VEROALFA PRECISION AND CHEMICALS INDIA PRIVATE LIMITED',
    'PATELHITECH ENGINEERING PRIVATE LIMITED',
    'CAMPARI INDIA PRIVATE LIMITED',
    'INTERSTAR WORLD PRIVATE LIMITED',
    'INNOVATION IMAGING TECHNOLOGIES PRIVATE LIMITED',
    'GNR SYSTEMS INDIA PRIVATE LIMITED',
    'RUDRA COTTEX PRIVATE LIMITED',
    'PAM ENERGY PRIVATE LIMITED',
    'VENA ENERGY INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'NISA RESOURCES GROWTH PRIVATE LIMITED',
    'AJ TECHNOVATIONS PRIVATE LIMITED',
    'LIVEME INDIA PRIVATE LIMITED',
    'ASAVARI DIE AND MOULDS PRIVATE LIMITED',
    'GSK SOLUTIONS INDIA PRIVATE LIMITED',
    'MAXIMA TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SPECIAL RECRUITMENT GROUPS PRIVATE LIMITED',
    'GLISSBIO PRIVATE LIMITED',
    'LASA SUPERGENERICS LIMITED',
    'GRENOVE SERVICES PRIVATE LIMITED',
    'BIENT TECHNOLOGIES PRIVATE LIMITED',
    'TAKVAVIYA TECHNOLOGIES PRIVATE LIMITED',
    'SHREE AAGARSEN ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'MYELIN INNOVATION PRIVATE LIMITED',
    'KNOWZIES TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'WONDER VALLEY RECREATIONS AND HOSPITALITY PRIVATE LIMITED',
    'FORMAT INDIA PRIVATE LIMITED',
    'CYBERSCRYPT INNOVATIONS PRIVATE LIMITED',
    'SMAPPTECH SYSTEMS PRIVATE LIMITED',
    'SQUAREINCH DIGITAL PRIVATE LIMITED',
    'ALGORYTHMIX TECH PRIVATE LIMITED',
    'UNIFIED IT SUPPORT PRIVATE LIMITED',
    'TRISTHA GLOBAL PRIVATE LIMITED',
    'HOST RUNWAY IT SOLUTIONS PRIVATE LIMITED',
    'LABRANZA INFOTECH PRIVATE LIMITED',
    'AON TEXTILES PRIVATE LIMITED',
    'SHRINE SOFTWARE SERVICES PRIVATE LIMITED',
    'BLISS WEB SOLUTION PRIVATE LIMITED',
    'SUBLIME WEBTECH PRIVATE LIMITED',
    'DELTACONS PROJECTS (INDIA) PRIVATE LIMITED',
    'PURPLY RETAIL INDIA PRIVATE LIMITED',
    'UBER INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'RIGHTFOCUS INVESTMENTS PRIVATE LIMITED',
    'WHEEL FLEXIBLE PACKAGING PRIVATE LIMITED',
    'PROPSQUAD PRIVATE LIMITED',
    'CONFIRMATION.COM INDIA PRIVATE LIMITED',
    'BIOTICS LAB LIFE SERVICES PRIVATE LIMITED',
    'MAHAKALI AUTOMOBILES PRIVATE LIMITED',
    'INDUS SOLUTION WIZARD PRIVATE LIMITED',
    'KRITIVITY WEB SOLUTIONS PRIVATE LIMITED',
    'SASL SHIPPING PRIVATE LIMITED',
    'SECURE SPACE PRIVATE LIMITED',
    'VLCC ONLINE SERVICES PRIVATE LIMITED',
    'VBR TECHNOLOGIES PRIVATE LIMITED',
    'SENSE CONNECT IT PRIVATE LIMITED',
    'AB MOBILE SOLUTIONS ALLIANCE INDIA PRIVATE LIMITED',
    'ANONDITA EXULTIA HEALTHCARE PRIVATE LIMITED',
    'ZOBNA ARTS PRIVATE LIMITED',
    'UNIVERSITY LIVING ACCOMMODATION PRIVATE LIMITED',
    'JAIMAA KELADEVI FRUITS PRIVATE LIMITED',
    'NESOI HOLDINGS PRIVATE LIMITED',
    'PEEPUL CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED',
    'SYNGIENCE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SMARTGEAR TECHNOLOGIES PRIVATE LIMITED',
    'COMPSEC PRIVATE LIMITED',
    'HEGDE HEALTHCARE PRIVATE LIMITED',
    'ADROIT INSPECTION SERVICES PRIVATE LIMITED',
    'COSBOTAC NATURALS PRIVATE LIMITED',
    'ZARKO GRANITO PRIVATE LIMITED',
    'SOLAR DEFENCE LIMITED',
    'CRK MEDICARE PRIVATE LIMITED',
    'ACUMEN SYNERGY PRIVATE LIMITED',
    'FOCAL S&B ENERGY INDIA PRIVATE LIMITED',
    'TUTICORIN LNG TERMINAL PRIVATE LIMITED',
    'VORACIOUS ENTERPRISES PRIVATE LIMITED',
    'MYD LABS PRIVATE LIMITED',
    'BLS E-SERVICES LIMITED',
    'POWER OF N TECHSTUDIO PRIVATE LIMITED',
    'EVOLENT HEALTH INTERNATIONAL PRIVATE LIMITED',
    'WASWANI NET SANCHAR TELECOM SERVICES PRIVATE LIMITED',
    'KAPL PROPERTY HOLDINGS PRIVATE LIMITED',
    'SF ENGINEERING PROJECTS & EQUIPMENTS PRIVATE LIMITED',
    'TELE SYSTEM COMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'CARE CARDS INDIA PRIVATE LIMITED',
    'SUN SIL POLYMERS PRIVATE LIMITED',
    'NAMDEV TEXTILE INDUSTRY PRIVATE LIMITED',
    'HI TECH ELECTRICALS INDIA PRIVATE LIMITED',
    'VSRL POWER PRIVATE LIMITED',
    'AXIS ENERGY LAND (FATEHGARH-III) PRIVATE LIMITED',
    'PROCAM FORMING PRIVATE LIMITED',
    'SMART LIVING HOME AUTOMATION PRIVATE LIMITED',
    'KAGAMI (INDIA) PRIVATE LIMITED',
    'VISIONNAIRE SOLUTIONS PRIVATE LIMITED',
    'AGAMI HOSPITALITY & SERVICES PRIVATE LIMITED',
    'V.M. INFRA SOLUTIONS PRIVATE LIMITED',
    'AGRARIAN DEVELOPMENT CONSULTANT PRIVATE LIMITED',
    'KALOLWALA & ASSOCIATES PRIVATE LIMITED',
    'E-STAR GLOBAL PRIVATE LIMITED',
    'CHECKERS INDIA TECHNOLOGY PRIVATE LIMITED',
    'AASTHA LADDERS PRIVATE LIMITED',
    'VANSH FURNISHINGS PRIVATE LIMITED',
    'TRANSWORLD INTERNATIONAL PACKAGING PRIVATE LIMITED',
    'PROWESS ENTERPRISE (INDIA) PRIVATE LIMITED',
    'DROPLET OFFSHORE SERVICES PRIVATE LIMITED',
    'ALAYA INTERNATIONAL PRIVATE LIMITED',
    'GLITTER TECHNOLOGY VENTURES PRIVATE LIMITED',
    'VISTARA INVESTMENT MANAGEMENT PRIVATE LIMITED',
    'ONLINE MEDI CONSULT PRIVATE LIMITED',
    'EVERSHINE BPO INDIA PRIVATE LIMITED',
    'TRAIN PLACE PRIVATE LIMITED',
    'OMSAI CABLE SYSTEMS INDIA PRIVATE LIMITED',
    'AIA CSR FOUNDATION',
    'TECHMANN INSTRUMENTS PRIVATE LIMITED',
    'GLOSSAREAD TECHNOLOGIES PRIVATE LIMITED',
    'HOME MANAGEMENT AND CARE GIVERS SECTOR SKILL COUNCIL',
    'CENTRUM HOUSING FINANCE LIMITED',
    'RICHVIK WEALTH PRIVATE LIMITED',
    'LULU INFRABUILD PRIVATE LIMITED',
    'PAPER LESS RACK DIGITAL SOLUTIONS PRIVATE LIMITED',
    'KUMPENNY SOLUTIONS OPC PRIVATE LIMITED',
    'HINDUSTAN AYURVED LIMITED',
    'JASSK INDUSTRIES PRIVATE LIMITED',
    'EUROPEAN FOODS INDIA PRIVATE LIMITED',
    'FUTURE INFONET PRIVATE LIMITED',
    'VYDIK SERVICES PRIVATE LIMITED',
    'V BRANDTECH CONSULTING SOLUTIONS PRIVATE LIMITED',
    'ARCHITECTED BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EINDHA GRANITE PRIVATE LIMITED',
    'TABSLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'JEWELCLICK ONLINE PRIVATE LIMITED',
    'TRIPIFY PRIVATE LIMITED',
    'BRUNEL LOGISTICS (SI) PRIVATE LIMITED',
    'OCEAN TRANSWORLD CLEARING PRIVATE LIMITED',
    'ARUNI NETWORK SOLUTIONS PRIVATE LIMITED',
    'ALPHASTREET INDIA PRIVATE LIMITED',
    'OREOPS FRAMEWORK PRIVATE LIMITED',
    'FRAME TECHNOLOGY MARKETING SERVICES PRIVATE LIMITED',
    'MRCUBE SOLUTIONS PRIVATE LIMITED',
    'SANAVISH TECHNOLOGIES PRIVATE LIMITED',
    'SRIJAN DIGITAL PLATFORMS PRIVATE LIMITED',
    'VENSITI SOLUTIONS PRIVATE LIMITED',
    'SAV (SURVEYORS & VALUERS) INDIA PRIVATE LIMITED',
    'WITZEAL TECHNOLOGIES PRIVATE LIMITED',
    'OZONE MOTORS PRIVATE LIMITED',
    'TVIS FASHIONS PRIVATE LIMITED',
    'UNIQUE ENVICARE PRIVATE LIMITED',
    'CHATTERBOX TECHNOLOGIES PRIVATE LIMITED',
    'NBS HEIGHTS PRIVATE LIMITED',
    'MOBILIZAR TECHNOLOGIES PRIVATE LIMITED',
    'DECINTELL TECH PRIVATE LIMITED',
    'POLO QUEEN PHARMA TRADE INDUSTRY LIMITED',
    'DAEMO ENGINEERING INDIA PRIVATE LIMITED',
    'FUTURA TECHDYNAMICS PRIVATE LIMITED',
    'ZUNO GENERAL INSURANCE LIMITED',
    'YOUNG FINANCIAL SERVICES INDIA PRIVATE LIMITED',
    'GROUND CRAFTS PRIVATE LIMITED',
    'REPLIGEN INDIA PRIVATE LIMITED',
    'ACCURATE POWER CONTROLS (INDIA) PRIVATE LIMITED',
    'MARS (INDIA) ANTENNAS & RF SYSTEMS PRIVATE LIMITED',
    'NADAGOUDA ENERGIES PRIVATE LIMITED',
    'POLO QUEEN SOLUTIONS LIMITED',
    'JOBSON SIGHT INTERNATIONAL PRIVATE LIMITED',
    'EASY QUENCH SERVICES PRIVATE LIMITED',
    'PLUS MAX INFRASTRUCTURE PRIVATE LIMITED',
    'THROUGHBIT TECHNOLOGIES PRIVATE LIMITED',
    'STS TECHNO INDIA PRIVATE LIMITED',
    'CH14 MEDIA FOUNDATION',
    'R&M MARINE ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'CONSTELLAR EXHIBITIONS INDIA PRIVATE LIMITED',
    'VIEVERA HOSPITALITY SERVICES PRIVATE LIMITED',
    'TSABA ENTERTAINMENT PRIVATE LIMITED',
    'BRAINROOTZ LABS PRIVATE LIMITED',
    'ABRIDGE MARKETING SOLUTIONS PRIVATE LIMITED',
    'OASIS ENGINEERING & ADVISORY SERVICES PRIVATE LIMITED',
    'OLENE LIFE SCIENCES PRIVATE LIMITED',
    'SOMANY EXCEL VITRIFIED PRIVATE LIMITED',
    'NEXLEAF ANALYTICS INDIA PRIVATE LIMITED',
    'ACEHACKER TECHNOLOGIES PRIVATE LIMITED',
    'INITIATEFIRST INFORMATION SERVICES PRIVATE LIMITED',
    'GHRIAN TECHNOLOGIES PRIVATE LIMITED',
    'SOFTILITY TECH PRIVATE LIMITED',
    'DIANTHA SYSTEMS PRIVATE LIMITED',
    'KLENTY INDIA PRIVATE LIMITED',
    'HAMSE EXOTIC BEVERAGES PRIVATE LIMITED',
    'CLOUD PLANET TECHNOLOGIES PRIVATE LIMITED',
    'FONE KART SERVICES AND SOLUTIONS PRIVATE LIMITED',
    'PREMIER AVIATION SERVICES PRIVATE LIMITED',
    'CLICKBLICK DIGITAL PRIVATE LIMITED',
    'OPAL BPM INDIA PRIVATE LIMITED',
    'CIRIGHT HARDWARE SYSTEMS PRIVATE LIMITED',
    'ESSBEE MILK PRODUCTS PRIVATE LIMITED',
    'SURABHI BEEJ PRODUCER COMPANY LIMITED',
    'ROTMAAX POWER PROJECTS CHENNAI PRIVATE LIMITED',
    'CNP SPORTS SERVICES PRIVATE LIMITED',
    'HARI PRIYA GLOBAL ENTERPRISES PRIVATE LIMITED',
    'MAHAVEERAM INFRASKY PRIVATE LIMITED',
    'XORAAPP SOLUTIONS AND CONSULTANCY PRIVATE LIMITED',
    'CSC-AG MERCHANTS PRIVATE LIMITED',
    'PROSCENIUM ELECTRONICS SYSTEM PRIVATE LIMITED',
    'CHIKBOOK RETAIL SOLUTIONS INDIA PRIVATE LIMITED',
    'A.H. DIGITAL MEDIA PRIVATE LIMITED',
    'JMC SHIP PRIVATE LIMITED',
    'TRIBAL MANTRA INDIA PRIVATE LIMITED',
    'FNH TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'HYPERNOVA INTERACTIVE TECHNOLOGY PRIVATE LIMITED',
    'APPROCKER TECHNOLOGIES PRIVATE LIMITED',
    '24X7 CURRENCY EXCHANGE PRIVATE LIMITED',
    'DEFSYS DEVELOPMENT INDIA PRIVATE LIMITED',
    'ELECTROFAB ENGINEERING SERVICES PRIVATE LIMITED',
    'QUALEMAGNI PRIVATE LIMITED',
    'DOSA INC FOODS PRIVATE LIMITED',
    'SHREE BALBIR FOOD PRODUCT PRIVATE LIMITED',
    'THE HEALTH CONNOISSEUR FOODS PRIVATE LIMITED',
    'MAKHANAWALA NATURAFOODS PRIVATE LIMITED',
    'SPRING BEE DAIRY PRODUCTS PRIVATE LIMITED',
    'SIROHI AGRO FOODS PRIVATE LIMITED',
    'TORNETO FOODS INTERNATIONAL PRIVATE LIMITED',
    'RSGL FOODS PRIVATE LIMITED',
    'BROWN HOUSE BAKING PRIVATE LIMITED',
    'MR. BROWN MARKETING PRIVATE LIMITED',
    'BLUE MOUNT DAIRY PRIVATE LIMITED',
    'SANTUSHTI SHAKES PRIVATE LIMITED',
    'BLAIR FOOD PRODUCTS PRIVATE LIMITED',
    'KRISHNA MILLING TECH PRIVATE LIMITED',
    'GLITZHILL VENTURES PRIVATE LIMITED',
    'PADDYMINE FOOD PRODUCTS PRIVATE LIMITED',
    'R N M CATERING PRIVATE LIMITED',
    'HASIRU FOODS PRIVATE LIMITED',
    'FIRMROOTS PRIVATE LIMITED',
    'SWASTHYA KRANTI NATURALS PRIVATE LIMITED',
    'AGRI LINK FOOD PROCESSING PRIVATE LIMITED',
    'KROVO FOOD & LOGISTICS PRIVATE LIMITED',
    'AA BIZCORP PRIVATE LIMITED',
    'ANNAM ORGANICS PRIVATE LIMITED',
    'NUTRIFRESH TASTY FOODS AND BEVERAGES PRIVATE LIMITED',
    'COCHIN BAKERY PRIVATE LIMITED',
    'AMNA FOOD INDUSTRIES PRIVATE LIMITED',
    'CHHAJED OVERSEAS PRIVATE LIMITED',
    'CAPITAL GASES PRIVATE LIMITED',
    'ELOHI FOODS PRIVATE LIMITED',
    'BRIJWHEEL AUTOMOBILES PRIVATE LIMITED',
    'BRS SOLVEX PRIVATE LIMITED',
    'QUARISMA BEVERAGES PRIVATE LIMITED',
    'SMILEY SALES & SERVICES PRIVATE LIMITED',
    'MONA BEVERAGES PRIVATE LIMITED',
    'GO POWER NUTRITION PRIVATE LIMITED',
    'KHANAL FOODS PRIVATE LIMITED',
    'MUDDY PUDDLE FOODS PRIVATE LIMITED',
    'FISHVISH FOODS PRIVATE LIMITED',
    'PRAKSONS EXTRACTS INDIA PRIVATE LIMITED',
    'SIMPLEMEAL FOODS PRIVATE LIMITED',
    'TEA POST PRIVATE LIMITED',
    'KAYLEE HERBAL POWDER PRIVATE LIMITED',
    'JAGDISH NAMKEENS PRIVATE LIMITED',
    'BREKKIE FOODS PRIVATE LIMITED',
    'ASQUARE FOOD & BEVERAGES PRIVATE LIMITED',
    'KAPRIKA CONFECTIONARY PRIVATE LIMITED',
    'NUTRIVOR FOODS PRIVATE LIMITED',
    'LIVEAT FOODS PRIVATE LIMITED',
    'EXPOVAN PRIVATE LIMITED',
    'ECOIND ORGANIC FOODS INDIA PRIVATE LIMITED',
    'TRK GLOBAL PRIVATE LIMITED',
    'P.R.S.K. ENTERPRISES PRIVATE LIMITED',
    'GREEN K FOODS PRIVATE LIMITED',
    'ALOKA BREWERIES PRIVATE LIMITED',
    'HOPE FOODS PRIVATE LIMITED',
    'FINE FLOW INDUSTRIES PRIVATE LIMITED',
    'VASUDHA AGRO FOOD PRODUCTS PRIVATE LIMITED',
    'AYUSH RICETECH PRIVATE LIMITED',
    'SRAVAN FOOD PARK PRIVATE LIMITED',
    'REVOLUTION CRAFTBREWS PRIVATE LIMITED',
    'GHOUSIA FOOD PRODUCTS PRIVATE LIMITED',
    'FASHION FOCUS HOSIERIES PRIVATE LIMITED',
    'AASTHRA SIZING PRIVATE LIMITED',
    'WONDERMONT INDUSTRIES PRIVATE LIMITED',
    'AACHARAN ENTERPRISES PRIVATE LIMITED',
    'COLORGLOW PROCESSING MILLS PRIVATE LIMITED',
    'SHIVA MILLS LIMITED',
    'KMS CONFECTIONERIES PRIVATE LIMITED',
    'HYGEIA WELLNESS PRIVATE LIMITED',
    'PITARADESIGN AND TEXTILES PRIVATE LIMITED',
    'BIKANER EXPRESS FOODS PRIVATE LIMITED',
    'SARI NUTRI HEALTH FOODS PRIVATE LIMITED',
    'MBS BEVERAGE PRIVATE LIMITED',
    'SWASTH AAHAR PRIVATE LIMITED',
    'SAMAARA SUPERMARKETS PRIVATE LIMITED',
    'AXEL & MARC FOOD PRIVATE LIMITED',
    'MAXROTTH GLOBAL FOODS PRIVATE LIMITED',
    'MAZDA PEST CONTROL PRIVATE LIMITED',
    'UNIFIED IMPORT PRIVATE LIMITED',
    'BEST COTTON MILLS PRIVATE LIMITED',
    'KAMAL COTSPIN UNIT II PRIVATE LIMITED',
    'MOHEY FASHIONS PRIVATE LIMITED',
    'WEST HILL COMMODITIES PRIVATE LIMITED',
    'LAN SPIN TEX PRIVATE LIMITED',
    'BLUE BOYD FASHIONS PRIVATE LIMITED',
    'TMM HI-TECH RESEARCH & DEVELOPMENT FOUNDATION',
    'WAKE CUP INDIA FOODS PRIVATE LIMITED',
    'IMPERO CONSUMER PRODUCTS PRIVATE LIMITED',
    'RAMKRISHNA COTSPIN PRIVATE LIMITED',
    'AMOUVE BEDDING PRIVATE LIMITED',
    'AGRAL POLYSACK PRIVATE LIMITED',
    'COSMO BOARDS PRIVATE LIMITED',
    'COLACO & VALERIE PRIVATE LIMITED',
    'SANGANER CLOTHING PRIVATE LIMITED',
    'KESULA TEXTILES PRIVATE LIMITED',
    'STUDIO BAGRU PRIVATE LIMITED',
    'SUPER SPINTEX PRIVATE LIMITED',
    'SHIVEN YARN PRIVATE LIMITED',
    'SUDEVI INDUSTRIES PRIVATE LIMITED',
    'DHANAI TEXTILES PRIVATE LIMITED',
    'AIRVEDA TECHNOLOGIES PRIVATE LIMITED',
    'COOLFREEZ SYSTEMS PRIVATE LIMITED',
    'SEG AUTOMOTIVE INDIA PRIVATE LIMITED',
    'LOTUS SURFACE TECHNOLOGIES PRIVATE LIMITED',
    'CONVEYOR SOLUTIONS INDIA PRIVATE LIMITED',
    'NILANG ASPHALT EQUIPMENTS PRIVATE LIMITED',
    'HORNEX SOLUTION PRIVATE LIMITED',
    'SETA ENGINEERS PRIVATE LIMITED',
    'JCAM SYSTEMS PRIVATE LIMITED',
    'LIGERO ELECTRONIC TECHNOLOGIES PRIVATE LIMITED',
    'BOSON INDUSTRIES PRIVATE LIMITED',
    'GSG CLEANTECH PRIVATE LIMITED',
    'KENDO SECURITY SYSTEMS PRIVATE LIMITED',
    'GYANAM ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'FRAUSCHER RAIL SIGNALLING SYSTEMS INDIA PRIVATE LIMITED',
    'STERADIAN SEMICONDUCTORS PRIVATE LIMITED',
    'NCLR BHARATH HI-TECCH INFRASTRUCTURE PRIVATE LIMITED',
    'PIONEER POWER SYSTEMS PRIVATE LIMITED',
    'RAYRHYTHMS INDUSTRIES PRIVATE LIMITED',
    'GLOBAL GREEN POWER RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED',
    'ULTRAMAG POWER TRANSFORMERS PRIVATE LIMITED',
    'AATITHYAA TECHNO INDIA PRIVATE LIMITED',
    'Pro India Save Energy Private Limited',
    'COMAC INDIA PRIVATE LIMITED',
    'KARUVI COOLING TOWERS PRIVATE LIMITED',
    'ERWON ENERGY PRIVATE LIMITED',
    'BLUEBIRD SOLAR PRIVATE LIMITED',
    'LIGHT INSIDE PRIVATE LIMITED',
    'DADHWAL SOLAR PRIVATE LIMITED',
    'VAREYN SOLAR PRIVATE LIMITED',
    'ENERGE INDIA PRIVATE LIMITED',
    'PERFECT ELECTRONICS AND CONNECTORS PRIVATE LIMITED',
    'DESH RAJ COOL CARE PRIVATE LIMITED',
    'REX PRICISION WORKS PRIVATE LIMITED',
    'ZESTORM ELECTRIC PRIVATE LIMITED',
    'DYNERE ENGINEERING PRIVATE LIMITED',
    'CARE ELECTRONICS PRIVATE LIMITED',
    'ROBOTINA INDIA PRIVATE LIMITED',
    'LEISTRITZ INDIA PRIVATE LIMITED',
    'NEXTT LEVEL BEAUTY PRIVATE LIMITED',
    'TECH SPHERE ENGINEERING PRIVATE LIMITED',
    'ACK SYSTEM INTEGRATOR PRIVATE LIMITED',
    'SUNSHINE POWERTRONICS PRIVATE LIMITED',
    'TIGER AUTOMATION PRIVATE LIMITED',
    'NEW NORTHEAST ELECTRIC INDIA PRIVATE LIMITED',
    'ELETTA INSTRUMENTATION INDIA PRIVATE LIMITED',
    'NEXBAND OPTIFIBRES PRIVATE LIMITED',
    'SAALFO TECH PRIVATE LIMITED',
    'MEAR SOLAR CRAFTS PRIVATE LIMITED',
    'SWAN BIOTEC PRIVATE LIMITED',
    'SREEM SERBA TURBINES PRIVATE LIMITED',
    'SEK ELECTRICALS PRIVATE LIMITED',
    'BEAVER TECHNOLOGIES PRIVATE LIMITED',
    'SAMAGRA ELECTRIC PRIVATE LIMITED',
    'ADEPTUS SERVO-MECHATRONICS PRIVATE LIMITED',
    'ZENETH KITCHEN EQUIPMENT PRIVATE LIMITED',
    'SAFE HALO PRODUCTS PRIVATE LIMITED',
    'BOCXOD LED LIGHTING PRIVATE LIMITED',
    'KERALA GRAMAJYOTHY LIGHTING PRIVATE LIMITED',
    'MAVERICK POWER TECHNOLOGIES PRIVATE LIMITED',
    'BAGLA ELECTRICALS AND ELECTRONICS PRIVATE LIMITED',
    'TARIL SWITCHGEAR PRIVATE LIMITED',
    'ANANT AIRCON PRIVATE LIMITED',
    'BLACK BOX GPS TECHNOLOGY OPC PRIVATE LIMITED',
    'RAJVITEX INDUSTRIES PRIVATE LIMITED',
    'A R ONLINE ELECTRICALS PRIVATE LIMITED',
    'PRESEVI INDUSTRIES PRIVATE LIMITED',
    'SAITRONIX ELECTRO DRIVES PRIVATE LIMITED',
    'SOLAIRE ELEKTRIK PRIVATE LIMITED',
    'RVM ELECTRICALS PRIVATE LIMITED',
    'MACRO AUTOMATION SOLUTIONS INDIA PRIVATE LIMITED',
    'SASI ENERGYCELL PRIVATE LIMITED',
    'LEDURE LIGHTINGS LIMITED',
    'SUNASH TECHNO SOLUTIONS PRIVATE LIMITED',
    'RENIT POWER PRIVATE LIMITED',
    'PRODNXT TECHNOLOGIES PRIVATE LIMITED',
    'EPOWER AUTOMATION & SOLUTIONS PRIVATE LIMITED',
    'DIXON TECHNOLOGIES (INDIA) LIMITED',
    'HALOMAX LIGHTING SOLUTIONS PRIVATE LIMITED',
    'CN ENGINEERS AND SYSTEMS PRIVATE LIMITED',
    'JYOTIPUNJ SOLAR AND ELECTRONICS PRIVATE LIMITED',
    'OSRAM LIGHTING PRIVATE LIMITED',
    'EWEL GROUP INDIA PRIVATE LIMITED',
    'PERFECT ID INDIA PRIVATE LIMITED',
    'KRISHIV VENTURES PRIVATE LIMITED',
    'PG INFOTEL PRIVATE LIMITED',
    'AGGRESSIVE DIGITAL SYSTEMS PRIVATE LIMITED',
    'ECE (INDIA) ENERGIES PRIVATE LIMITED',
    'PACIFIC CYBER TECHNOLOGY PRIVATE LIMITED',
    'FOXCONN HON HAI TECHNOLOGY INDIA MEGA DEVELOPMENT PRIVATE LIMITED',
    'SREE VENNELA CIRCUITS PRIVATE LIMITED',
    'QUIBIT TELECOM PRIVATE LIMITED',
    'FEED THE NEED SURFACTANTS PRIVATE LIMITED',
    'GAG INFORMATICS SYSTEMS PRIVATE LIMITED',
    'OPTIEMUS ELECTRONICS LIMITED',
    'METAL SAFETY ENGINEERING PRIVATE LIMITED',
    'PROFESSIONAL AUDIO VIDEO SOLUTIONS PRIVATE LIMITED',
    'HEALTHCUBED INDIA PRIVATE LIMITED',
    'M B LANDMARKS PRIVATE LIMITED',
    'ABNCO CONSTRUCTIONS PRIVATE LIMITED',
    'NAGNECHI CONSTRUCTION PRIVATE LIMITED',
    'SAVITRY ASSOCIATE PRIVATE LIMITED',
    'EMERGENT DREAMWORKS INFRA DEVELOPERS PRIVATE LIMITED',
    'O.C. INFRAVENTURES & CONSTRUCTION PRIVATE LIMITED',
    '3ATOWNSHIP CONSTRUCTION PRIVATE LIMITED',
    'VEEGI PROJECTSS PRIVATE LIMITED',
    'COURTYARD REALTY PRIVATE LIMITED',
    'SHUBHAM TECH ENTERPRISES PRIVATE LIMITED',
    'BLACKLEAD INFRATECH PRIVATE LIMITED',
    'VALENCIA AND MISHAL VENTURES PRIVATE LIMITED',
    'GEOPRENEUR INFRACORP LIMITED',
    'GKS VENTURES PRIVATE LIMITED',
    'ACADEMIA EDIFICIO PRIVATE LIMITED',
    'AVIGHNAA CONTRACTORS PRIVATE LIMITED',
    'GE1 EXPRESSWAY PRIVATE LIMITED',
    'ASTARC INFRA DEVELOPERS PRIVATE LIMITED',
    'NEIL INFRASTRUCTURE & CONSULTING ENGINEERS PRIVATE LIMITED',
    'ALLWORTH COMPLEX PRIVATE LIMITED',
    'S R PROBUILD PRIVATE LIMITED',
    'FOURFRONT INFRA PRIVATE LIMITED',
    'WHITE LOTUS BUILDCON PRIVATE LIMITED',
    'GRAHA GRAND PROPERTIES INDIA PRIVATE LIMITED',
    'S CUBE ENERGY AND INFRA PRIVATE LIMITED',
    'STRUCTURES AND DESIGNS PRIVATE LIMITED',
    'SIDDHARTHA INTERNATIONAL PROJECTS PRIVATE LIMITED',
    'FREEDOMPOINT EXPRESSWAY PRIVATE LIMITED',
    'GAIROLA DEVELOPERS PRIVATE LIMITED',
    'NIMBLE INFRA PRIVATE LIMITED',
    'SEVENTH SKY COMPLEX PRIVATE LIMITED',
    'BELLVIEW NIWAS PRIVATE LIMITED',
    'LIVEHIGH TOWERS PRIVATE LIMITED',
    'JAZZ REALTORS PRIVATE LIMITED',
    'CITY HEIGHTS BUILDERS INDIA PRIVATE LIMITED',
    'RNV VENTURES PRIVATE LIMITED',
    'SRISIRI INFRA PROJECTS PRIVATE LIMITED',
    'ABISKO PROJECTS PRIVATE LIMITED',
    'AR SQUARE DESIGN BUILD PRIVATE LIMITED',
    'RAI DEVELOPERS PRIVATE LIMITED',
    'SL AUTOMOBILES PRIVATE LIMITED',
    'AUTO VOGUE PRIVATE LIMITED',
    'BRAJBIHARI COMPLEX PRIVATE LIMITED',
    'BUFFLEHEAD TOWERS PRIVATE LIMITED',
    'SALMON RESIDENCY PRIVATE LIMITED',
    'MYTVS PARTS MART PRIVATE LIMITED',
    'CRYSTAL CARS PRIVATE LIMITED',
    'LIGHTCORAL COMPLEX PRIVATE LIMITED',
    'MIDWAY MOTORS PRIVATE LIMITED',
    'THISTLE COMPLEX PRIVATE LIMITED',
    'VIGHNRAJA COMPLEX PRIVATE LIMITED',
    'SWARNYUG HIRISE PRIVATE LIMITED',
    'FIREBRICK COMPLEX PRIVATE LIMITED',
    'DWARKAPATI RESIDENCY PRIVATE LIMITED',
    'MISTYROSE CONSTRUCTION PRIVATE LIMITED',
    'CLEMENTINE CONSTRUCTION PRIVATE LIMITED',
    'NETTLES DEVCON PRIVATE LIMITED',
    'NAVYBEANS CONCLAVE PRIVATE LIMITED',
    'NIGHTANGELS COMPLEX PRIVATE LIMITED',
    'AVOCADO CONSTRUCTION PRIVATE LIMITED',
    'ELDERBERRY CONSTRUCTION PRIVATE LIMITED',
    'BHUMI COMPLEX PRIVATE LIMITED',
    'BISQUE CONSTRUCTIONS PRIVATE LIMITED',
    'BURLYWOOD CONSTRUCTION PRIVATE LIMITED',
    'NECTARINE COMPLEX PRIVATE LIMITED',
    'ARYAN TECHNOCON PRIVATE LIMITED',
    'TIRATH CONSTRUCTIONS PRIVATE LIMITED',
    'JUBILANT MOTORWORKS (SOUTH) PRIVATE LIMITED',
    'MY CAR NEXA PRIVATE LIMITED',
    'JUBILANT SPORTS CARS PRIVATE LIMITED',
    'SASWAT RESIDENCY PRIVATE LIMITED',
    'VAISHNODEVI ADVISORY PRIVATE LIMITED',
    'AUTOPARTS HUB PRIVATE LIMITED',
    'VIP (MUMBAI) AUTOMOBILES PRIVATE LIMITED',
    'ICON CARS PRIVATE LIMITED',
    'PODDAR SOLUTIONS PRIVATE LIMITED',
    'AUTOMOBILITY SERVICES AND SOLUTIONS PRIVATE LIMITED',
    'KRISHIV AUTO AGENCIES PRIVATE LIMITED',
    'RATNAPPRABBHA MOTORS PRIVATE LIMITED',
    'SHREE HATKESHWARA MOTORS PRIVATE LIMITED',
    'JAI AND SONS PRIVATE LIMITED',
    'MANSUI TRADING PRIVATE LIMITED',
    'RATNAPPRABBHA CARS PRIVATE LIMITED',
    'DRIVEO TECHNOLOGIES PRIVATE LIMITED',
    'SHAKTI WHEELS INDIA PRIVATE LIMITED',
    'KAVISH AUTOMOBILES PRIVATE LIMITED',
    'DRS INFRA PRIVATE LIMITED',
    'ROYCE AUTO HUB PRIVATE LIMITED',
    'KRISHAA AUTO PRIVATE LIMITED',
    'UNIQUE AUTOMOBILES PRIVATE LIMITED',
    'SMART AUTO SYSTEMS PRIVATE LIMITED',
    'SPEED LINKS AUTOMOBILES PRIVATE LIMITED',
    'DEVANSHU AUTOMOBILES PRIVATE LIMITED',
    'TRUE & REAL VALUE AUTOMOBILE SERVICES PRIVATE LIMITED',
    'SHRIRAM WAGONS PRIVATE LIMITED',
    'LAISH MADISON MOTOR WERKS PRIVATE LIMITED',
    'ANNAMALAI MOTORS PRIVATE LIMITED',
    'FINIKS SHIPPING PRIVATE LIMITED',
    'BLUEJELLY CRUISES AND RESORTS PRIVATE LIMITED',
    'MANGALORE COAL TERMINAL PRIVATE LIMITED',
    'WEBPORT MEDIA PRIVATE LIMITED',
    'UNIVERSAL JET & SEA LOGISTICS PRIVATE LIMITED',
    'WISHFUL TRAVELS PRIVATE LIMITED',
    'PRISTINE HINDUSTAN INFRAPROJECTS PRIVATE LIMITED',
    'TARANA LOGISTICS PRIVATE LIMITED',
    'PAMUSA LOGISTICS SERVICES PRIVATE LIMITED',
    'PICK N GO TRAVELS PRIVATE LIMITED',
    'TRAVELIA HOLIDAYS PRIVATE LIMITED',
    'TALES FROM INDIA TOURS PRIVATE LIMITED',
    'ROADAIR GLOBAL FREIGHT MANAGEMENT PRIVATE LIMITED',
    'VIHAAN OVERSEAS PRIVATE LIMITED',
    'SUJATA CONTAINER MOVERS PRIVATE LIMITED',
    'AVO LOGISTICS AND INTERNATIONAL TRADING PRIVATE LIMITED',
    'CLASSIC EXPEDITIONS (INDIA) PRIVATE LIMITED',
    'ADD MORE TOURISM SOLUTIONS PRIVATE LIMITED',
    'EMPIRE TRANSPORT SERVICES LIMITED',
    'SACHIN INTERNATIONAL ONLINE TRAVELS PRIVATE LIMITED',
    'ARYA TRAVEL PLANNERS PRIVATE LIMITED',
    'SVS VISA SERVICES (INDIA) PRIVATE LIMITED',
    'VST MOBILITY SOLUTIONS PRIVATE LIMITED',
    'TRANSFRESH LOGISTICS PRIVATE LIMITED',
    'BEST IDEA PACKERS LIMITED',
    'FAREDEAL TRAVEL PRIVATE LIMITED',
    'ELLORA BOARDING PRIVATE LIMITED',
    'JAI KALKA MAA TOUR AND TRAVELS PRIVATE LIMITED',
    'INDO AFRICA GLOBAL LOGISTICS PRIVATE LIMITED',
    'JAHAZ INDIA PRIVATE LIMITED',
    'RISING SUN LOGISTICS PRIVATE LIMITED',
    'BEST FARES PRIVATE LIMITED',
    'QUICK ATTESTATION SERVICES OPC PRIVATE LIMITED',
    'LOCAL TRIP INTERACTIVE PRIVATE LIMITED',
    'FLY WITH US GLOBAL REPRESENTATION PRIVATE LIMITED',
    'AFG LOGISTICS PRIVATE LIMITED',
    'TQUE3 TRAVEL MANAGEMENT PRIVATE LIMITED',
    'METRIPPING TECHNOLOGIES PRIVATE LIMITED',
    'OMALAYA TRAVEL PRIVATE LIMITED',
    'BN BRIGHT IMMIGRATION CONSULTANCY SERVICES PRIVATE LIMITED',
    'INCREDIBLE DESTINATION TOURS PRIVATE LIMITED',
    'PACETRAVELS247 WORLDWIDE SERVICES PRIVATE LIMITED',
    'INKMAP TRAVELS AND TOURISM PRIVATE LIMITED',
    'ENJOYABLE HOLIDAYS AND TRAVELS PRIVATE LIMITED',
    'HYTTE MOBILITY AND HOSPITALITY PRIVATE LIMITED',
    'TRANSWORLD INTERNATIONAL RECORDS & DATA MANAGEMENT SERVICES PRIVATE LIMITED',
    'KARGOEX LOGISTICS PRIVATE LIMITED',
    'HONEYVIHAR LEISURE & TOURS PRIVATE LIMITED',
    'WAYLINK PITSTOP SOLUTIONS PRIVATE LIMITED',
    'HAPPYTRIPINDIA HOLIDAY VENTURES PRIVATE LIMITED',
    'TOSHALI TOURS PRIVATE LIMITED',
    'CLICK2SHIP LOGISTICS PRIVATE LIMITED',
    'ACCIVA TRAVELS PRIVATE LIMITED',
    'TRAVEL ADDICTS LEISURE AND ENTERTAINMENT PRIVATE LIMITED',
    'TVARA AUTOMOTIVE INNOVATIONS PRIVATE LIMITED',
    'TRANSEAZY LOGISTICS PRIVATE LIMITED',
    'BIZCURSION TRAVEL PRIVATE LIMITED',
    'ZINGARA SOLUTIONS PRIVATE LIMITED',
    'TOURMATRIX TRAVELS PRIVATE LIMITED',
    'ALL ABOUT HOLIDAYS PRIVATE LIMITED',
    'VARANASI INTERNATIONAL SHIPPING SERVICES PRIVATE LIMITED',
    'ABSOLUTE JOURNEY PRIVATE LIMITED',
    'WORLD VIEW SHIPPING & LOGISTICS PRIVATE LIMITED',
    'UNITED GLOBAL TRAVEL AND FOREX (INDIA) PRIVATE LIMITED',
    'LINKJET LOGISTICS PRIVATE LIMITED',
    'AMAZON GLOBAL TRAVELS PRIVATE LIMITED',
    'TRAVIATE ONLINE PRIVATE LIMITED',
    'INTERGLOBECONNECT HOSPITALITY AND SERVICES PRIVATE LIMITED',
    'WORLD WIDE ADVENTURES ASIA PRIVATE LIMITED',
    'TOURISM SIMPLE INDIA PRIVATE LIMITED',
    'MOTORIDERS BIKES AND CARS RENTALS PRIVATE LIMITED',
    'BORDERLESS TRAVEL SERVICES LIMITED',
    'JARDIN TRAVEL SOLUTIONS LIMITED',
    'A.T.C. MULTIMODAL TRANSPORT PRIVATE LIMITED',
    'PRINCIPALITY SHIP MANAGEMENT PRIVATE LIMITED',
    'EMIZA SUPPLY CHAIN SERVICES PRIVATE LIMITED',
    'UNICORN TOURISM & TOURS SERVICES PRIVATE LIMITED',
    'TED TRAVEL & EXPERIENCES PRIVATE LIMITED',
    'HOLIDAY DISCOVERERS PRIVATE LIMITED',
    'RDS EXPRESS & LOGISTICS INDIA PRIVATE LIMITED',
    'DREAMCASTER TOURS AND TRAVELS PRIVATE LIMITED',
    'PRATHAM SHIPPING & LOGISTICS PRIVATE LIMITED',
    'ANTILOG VACATIONS PRIVATE LIMITED',
    'TEJAL LOGISTICS PRIVATE LIMITED',
    'WEFAA GLOBAL LOGISTICS PRIVATE LIMITED',
    'LAVERA GLOBAL LOGISTICS PRIVATE LIMITED',
    'OPUS WORLDWIDE PRIVATE LIMITED',
    'BLUE WORLD SHIPPING AGENCIES PRIVATE LIMITED',
    'DADHICH LIFE SECURE AMBULANCE SERVICE PRIVATE LIMITED',
    'SUPER INDIA PARIVAHAN PRIVATE LIMITED',
    'SATGURU TRAVEL AND TOURISM PRIVATE LIMITED',
    'ESCAPAR HOLIDAYS PRIVATE LIMITED',
    'EASTERN MULTITRANS LOGISTICS PRIVATE LIMITED',
    'ESSENTIAL TOURS AND TRAVELS (INDIA) PRIVATE LIMITED',
    'DREAM DESTINATIONS PRIVATE LIMITED',
    'SUPERLORRY SERVICES PRIVATE LIMITED',
    'KARTHIK TRAVELS PRIVATE LIMITED',
    'JTT LOGISTICS PRIVATE LIMITED',
    'TRAVELRR PRIVATE LIMITED',
    'THREE R INFOCOM PRIVATE LIMITED',
    'GRIZZLY TECHNOLOGIES PRIVATE LIMITED',
    'OUTPLAY APPS PRIVATE LIMITED',
    'VGONEXT I-SOLUTIONS PRIVATE LIMITED',
    'SAADHAN IT SERVICES PRIVATE LIMITED',
    'IDS KISAN NETWORK PRIVATE LIMITED',
    'ONLINE VIDEO TOOLS PRIVATE LIMITED',
    'WEBUTERS TECHNOLOGIES PRIVATE LIMITED',
    'MOBI OCEAN TECHNOLOGIES PRIVATE LIMITED',
    'AUTOCITY INTERNATIONAL PRIVATE LIMITED',
    'SPHIRO TECHNOLOGIES PRIVATE LIMITED',
    'MARS INFOCARE SOLUTIONS PRIVATE LIMITED',
    'ACETRUM TECHNOLOGIES PRIVATE LIMITED',
    'DEFMACRO SOFTWARE PRIVATE LIMITED',
    'CLOUDVANDANA SOLUTIONS PRIVATE LIMITED',
    'BAI INFOSOLUTIONS PRIVATE LIMITED',
    'CASFER TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'CRECIO IT INTERACTIVE (OPC) PRIVATE LIMITED',
    'DZIGNE TECHNOSYS (INDIA) PRIVATE LIMITED',
    'INTELLIS ENGINEERING SERVICES PRIVATE LIMITED',
    'NUMADIC IOT PRIVATE LIMITED',
    'RYEL PROJECTS PRIVATE LIMITED',
    'DYNAMIC ELEMENTS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'BOGHANI INTERNET PRIVATE LIMITED',
    'COREFRAGMENT TECHNOLOGIES PRIVATE LIMITED',
    'CONVASYS TECHNOLOGIES PRIVATE LIMITED',
    'ECOMGROWTH WEB SOLUTION PRIVATE LIMITED',
    'ELEKORE SYSTEMS PRIVATE LIMITED',
    'SALIGRAM TECHNOLOGIES PRIVATE LIMITED',
    'SEARCHNATIVE INDIA PRIVATE LIMITED',
    'PIANA IT SOLUTIONS PRIVATE LIMITED',
    'STELLAR DIGITAL PRIVATE LIMITED',
    'ILOGIC INFOTECH PRIVATE LIMITED',
    'ENGRAVE TECHNOLOGIES PRIVATE LIMITED',
    'BLUE LEAF INTECH PRIVATE LIMITED',
    'WEBBYGENIUS INFOTECH PRIVATE LIMITED',
    'KRAZY MANTRA E-COMMERCE PRIVATE LIMITED',
    'TECHNOADVISER TECHNOLOGIES PRIVATE LIMITED',
    'DEV OPUS PRIVATE LIMITED',
    'CUBISYS TECH STUDIOS PRIVATE LIMITED',
    'ALETHE LABS INDIA PRIVATE LIMITED',
    'AKH TECH LOGISTICS PRIVATE LIMITED',
    'PIRO TECHNOLOGIES PRIVATE LIMITED',
    'SK TARANG INFORMATICS PRIVATE LIMITED',
    'KAFFEINE LABS PRIVATE LIMITED',
    'EM TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'COPPERROOTS TECHNOLOGIES PRIVATE LIMITED',
    'TECH WIZARD IT AND INFRA PRIVATE LIMITED',
    'UCREATE IT PRIVATE LIMITED',
    'OJASKAR SOLUTIONS INDIA PRIVATE LIMITED',
    'ZAMEEN BAZAAR PRIVATE LIMITED',
    'VIRTUSMINDS TECHNOLOGIES PRIVATE LIMITED',
    'WIDESTREAK TECH PRIVATE LIMITED',
    'PANWORLD DIGITAL PRIVATE LIMITED',
    'AMRITVANI TECHNOLOGIES PRIVATE LIMITED',
    'SEKHMET TECHNOLOGIES PRIVATE LIMITED',
    'PIVERSE INDIA PRIVATE LIMITED',
    'HUNGRYCHAIN TECHNOLOGIES PRIVATE LIMITED',
    'CODEMAX IT SOLUTIONS PRIVATE LIMITED',
    'ACUMONT SOLUTIONS PRIVATE LIMITED',
    'QTECH ANALYTICS PRIVATE LIMITED',
    'SECUREWORKS INDIA PRIVATE LIMITED',
    'SIMPLEWORKS SOLUTIONS PRIVATE LIMITED',
    'YANTRIKS INDIA PRIVATE LIMITED',
    'ARCCORE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'STRADUS INDIA SERVICES PRIVATE LIMITED',
    'TEKIZMA INDIA SOLUTIONS PRIVATE LIMITED',
    'SHOPMATIC SOLUTIONS PRIVATE LIMITED',
    'AVANSEUS TECHNOLOGIES PRIVATE LIMITED',
    'PERNIXDATA INDIA PRIVATE LIMITED',
    'KHARADI ANNEX CO-OPERATE DEVELOPMENT PRIVATE LIMITED',
    'NCRYPTED TECHNOLOGIES PRIVATE LIMITED',
    'IWANT TECHNOLOGIES PRIVATE LIMITED',
    'CAHOOT TECHNOLOGIES PRIVATE LIMITED',
    'ATI ACCURATE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'REBIRTH WEBONETIX PRIVATE LIMITED',
    'ORLOVI TECH SOLUTIONS PRIVATE LIMITED',
    'ORIGINAL DIMENSION PRIVATE LIMITED',
    'SATKAR FINTECH PRIVATE LIMITED',
    'INTELLUS SOFTWARE INDIA PRIVATE LIMITED',
    'GETIT COMMUNICATIONS PRIVATE LIMITED',
    'QUINTYPE TECHNOLOGIES INDIA LIMITED',
    'J. C. PENNEY SERVICES INDIA PRIVATE LIMITED',
    'FASTFILMZ MEDIA INDIA PRIVATE LIMITED',
    'APPSECCO CONSULTING PRIVATE LIMITED',
    'ZEOTAP INDIA PRIVATE LIMITED',
    'NETRADYNE TECHNOLOGY INDIA PRIVATE LIMITED',
    'MONTY TELECOM DEVELOPMENT PRIVATE LIMITED',
    'BABELSYS TECHNOLOGY INDIA PRIVATE LIMITED',
    'ALLYGROW ENGINEERING SERVICES PRIVATE LIMITED',
    'SYNCRON SOFTWARE INDIA PRIVATE LIMITED',
    'VSB TECHNOLOGIES PRIVATE LIMITED',
    'MORGENTEC CONSULTING PRIVATE LIMITED',
    'AFFLE X PRIVATE LIMITED',
    'SECURASHIELD INDIA PRIVATE LIMITED',
    'KNOWLEDGEOPS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SRIGGLE TECH PRIVATE LIMITED',
    'KRITSNAM TECHNOLOGIES PRIVATE LIMITED',
    'SAVVYCHIP TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'TRISPACE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'NUMBER THEORY SOFTWARE PRIVATE LIMITED',
    'MSGAI LABS PRIVATE LIMITED',
    'BENZARA E-COMMERCE INDIA PRIVATE LIMITED',
    'NP TECHNOLOGY LABS PRIVATE LIMITED',
    'BLISS CONNECT INDIA PRIVATE LIMITED',
    'KCS WEBTECH PRIVATE LIMITED',
    'AEOLOGIC TECHNOLOGIES PRIVATE LIMITED',
    'MAGNIFIER TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'VALLETTO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'YASEER INNOVATIVE SOFTWARE PRIVATE LIMITED',
    'G - MAX IT SERVICES PRIVATE LIMITED',
    'VIDWATH INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'SEAM TECHNOLOGY LAB PRIVATE LIMITED',
    'RELATEHOST SOLUTIONS PRIVATE LIMITED',
    'NORTHCORP SOFTWARE PRIVATE LIMITED',
    'MEDICOSA TECHNOLOGY PRIVATE LIMITED',
    'TOMINTO MARKETING PRIVATE LIMITED',
    'MOBIBERSERK TECHNOLOGIES PRIVATE LIMITED',
    'FUTURETECH INFOSOLUTIONS PRIVATE LIMITED',
    'HOUSTON SYSTEMS PRIVATE LIMITED',
    'EQUAL INFOTECH PRIVATE LIMITED',
    'E-LALA TECHNOLOGIES PRIVATE LIMITED',
    'PRODWARE SOLUTIONS PRIVATE LIMITED',
    'HEALTH DYNAMICS SOLUTION PRIVATE LIMITED',
    'OCTUNE MEDIA PRIVATE LIMITED',
    'ZIKHIN TECHNOLOGIES PRIVATE LIMITED',
    'COINTAB SOFTWARE PRIVATE LIMITED',
    'NEW EVOLVING STRATEGIC TECHNOLOGIES PRIVATE LIMITED',
    'SAHAS TECHNOLOGIES PRIVATE LIMITED',
    'MINIMALIST SOLUTIONS PRIVATE LIMITED',
    'YIN YANG SOLUTIONS PRIVATE LIMITED',
    'BRONTOO TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'MOBTRAY DIGITAL (INDIA) PRIVATE LIMITED',
    'MEDIRAYS INFOTECH PRIVATE LIMITED',
    'CARNOT TECHNOLOGIES PRIVATE LIMITED',
    'IOLITE SOFTWARES PRIVATE LIMITED',
    'INDIAN TEXT TO SPEECH PRIVATE LIMITED',
    'DOMAINZ GURU (INDIA) PRIVATE LIMITED',
    'MINDDEFFT TECHNOLOGIES PRIVATE LIMITED',
    'RITE KNOWLEDGE LABS (I) PRIVATE LIMITED',
    'RAPIDO QUICK SMS PRIVATE LIMITED',
    'KREASERV MEDIA PRIVATE LIMITED',
    'INSTINCT INNOVATIONS PRIVATE LIMITED',
    'TRIMURTI TECHSERV PRIVATE LIMITED',
    'BIZCRAFT SYSTECH PRIVATE LIMITED',
    'CODE POTATO SOFTWARE PRIVATE LIMITED',
    'INCEPTOR TECHNOLOGIES PRIVATE LIMITED',
    'INFOSEUM IT OPC PRIVATE LIMITED',
    'IPROSONIC SYSTEMS PRIVATE LIMITED',
    'TREPUP TECHNOLOGIES PRIVATE LIMITED',
    'KYTA PRODUCTIONS PRIVATE LIMITED',
    'NITROLABS TECHNOLOGY PRIVATE LIMITED',
    'XEEVA INDIA PRIVATE LIMITED',
    'MOBITO TECHNOLOGY PRIVATE LIMITED',
    'BHADANI TECHNOLOGIES PRIVATE LIMITED',
    'IMENSO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'QUBIT INFOTECH PRIVATE LIMITED',
    'DREAMZ VISION CREATIVE GEEKS PRIVATE LIMITED',
    'MAHINDRA TEQO PRIVATE LIMITED',
    'JRHS INFOTECH PRIVATE LIMITED',
    'INGENIUM TECHNOLOGIES PRIVATE LIMITED',
    'ACCEDIAN NETWORKS INDIA PRIVATE LIMITED',
    'WEBID SOLUTIONS INDIA PRIVATE LIMITED',
    'BIG DATA BUSINESS CENTER PRIVATE LIMITED',
    'NETPRET SOLUTIONS PRIVATE LIMITED',
    'GRAONE SOLUTIONS PRIVATE LIMITED',
    'ENVISIA TECHSOFT PRIVATE LIMITED',
    'KENNECT SOLUTIONS PRIVATE LIMITED',
    'ONEWORLD SOFTECH PRIVATE LIMITED',
    'WSLAB SERVICES PRIVATE LIMITED',
    'ADSMN INTERACTIVE PRIVATE LIMITED',
    'SWIFTSYS SERVICES (MUMBAI) PRIVATE LIMITED',
    'PLUS BUSINESS INFOTECH PRIVATE LIMITED',
    'INFRACLOUD TECHNOLOGIES PRIVATE LIMITED',
    'RAZORPAY SERVICES PRIVATE LIMITED',
    'PALASH HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'ZONOPACT INDIA PRIVATE LIMITED',
    'DBS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'SOL INFORMATICS PRIVATE LIMITED (OPC)',
    'QFIX INFOCOMM PRIVATE LIMITED',
    'WYNBI SOLUTIONS PRIVATE LIMITED',
    'PHARMACOPIA LABS PRIVATE LIMITED',
    'MELITE SOFT TECHNOLOGIES PRIVATE LIMITED',
    'SAMOLA SYSTEMS PRIVATE LIMITED',
    'GIBBR TECHNOLOGIES PRIVATE LIMITED',
    'ABP ENGITECH SOLUTIONS PRIVATE LIMITED',
    'PRIMENODE WEB SOLUTIONS PRIVATE LIMITED',
    'GYANMATRIX TECHNOLOGIES PRIVATE LIMITED',
    'WEALTH WALLET TECHNOLOGIES PRIVATE LIMITED',
    'SIMPLIFYTHIS TECHNOLOGIES PRIVATE LIMITED',
    'HORNBILL SOFTECH PRIVATE LIMITED',
    'HIGNOSIS IT SOLUTIONS PRIVATE LIMITED',
    'SWISS MOBI SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'SEEKCAREERZ.COM PRIVATE LIMITED',
    'DRONA LEARNING SOLUTIONS PRIVATE LIMITED',
    'CONVERSANT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'GMHK SYSTEMS PRIVATE LIMITED',
    'YASH INFRAESTATE INDIA PRIVATE LIMITED',
    'SRASTHI BUILD CON PRIVATE LIMITED',
    'B H I INFRASTRUCTURE PRIVATE LIMITED',
    'ALUCOP INDIA PRIVATE LIMITED',
    'MISHA LAND DEVELOPMENT PRIVATE LIMITED',
    'SUN NUTRAFOODS PRIVATE LIMITED',
    'ADAMANT INFRASTRUCTURES LIMITED',
    'PAX Edutainment Private Limited',
    'Focus Eye Technocraft Private Limited',
    'RALIN POLYMERS PRIVATE LIMITED',
    'MADHYA PRADESH JAL NIGAM MARYADIT',
    'VAKRATUND MULTIDEVELOPERS INDIA PRIVATE LIMITED',
    'PARAM FOOD INDUSTRIES PRIVATE LIMITED',
    'EPIC RESEARCH LIMITED',
    'SUKHDHAM HOTELS PRIVATE LIMITED',
    'S.G.S. MOTORS PRIVATE LIMITED',
    'BioUrja India Infra Private Limited',
    'CENTRE FOR INNOVATIONS AND DEVELOPMENT ASSISTANCE',
    'HAARISH EQUIPMENTS PRIVATE LIMITED',
    'VISION FORCE RESORTS PRIVATE LIMITED',
    'FINNOVA BUSINESS CONSULTANCY PRIVATE LIMITED',
    'UPPAL COMMERCIAL PRIVATE LIMITED',
    'AXMIYAN HR SOLUTIONS PRIVATE LIMITED',
    'JKAK CONSULTANTS PRIVATE LIMITED',
    'CRISPY CAREERS TRAINING AND CONSULTING SERVICES PRIVATE LIMITED',
    'Vista Websoft Private Limited',
    'Ocean Motors Private Limited',
    'JSM DEVCONS INDIA PRIVATE LIMITED',
    'Flexi Caps & Polymers Private Limited',
    'AT BIZ INFRA PRIVATE LIMITED',
    'Skye Earth Developers Private Limited',
    'Kalindi Infotech Private Limited',
    'BADRI VISHAL MEGA ESTATE WAREHOUSE PRIVATE LIMITED',
    'VISWAS LABOUR AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'CROSSROADS CLOTHING PRIVATE LIMITED',
    'IPT REAL ESTATES PRIVATE LIMITED',
    'KANHA TEA ESTATE PRIVATE LIMITED',
    'ARFA PINNACLE DEVCON PRIVATE LIMITED',
    'Vivan Real Estate Private Limited',
    'SAMYAK INFRA ESTATE PRIVATE LIMITED',
    'SIMPLEX METAL PROCESSORS (INDIA) PRIVATE LIMITED',
    'SHREE KESHAV DEVBUILD PRIVATE LIMITED',
    'SHREE KESHAV DEVCON PRIVATE LIMITED',
    'RAIM BUILDERS AND DEVELOPERS INDIA PRIVATE LIMITED',
    'R. SAI LOGISTICS INDIA PRIVATE LIMITED',
    'MULTIMODE LOGISTICS (INDIA) PRIVATE LIMITED',
    'COLORFUL TRAVEL PRICE PRIVATE LIMITED',
    'Campus Mall Private Limited',
    'SHIKHAR INFRASOLUTIONS (INDIA) PRIVATE LIMITED',
    'MADAN GOPAL BAHETI CHARITABLE FOUNDATION',
    'MINDBOWSER INFOSOLUTIONS PRIVATE LIMITED',
    'SHRI NEMI REALESTATE INDIA PRIVATE LIMITED',
    'SHREE GURUKRIPA PACKERS PRIVATE LIMITED',
    'PS PRECESSION CNC COMPONENTS PRIVATE LIMITED',
    'CARNIVAL FILMS PRIVATE LIMITED',
    'Iziss Technology Private Limited',
    'WorkMonk Solutions Private Limited',
    'IES CONSULTANCY SERVICES PRIVATE LIMITED',
    'ABHISHEK GANG CONSULTANCY SERVICES PRIVATE LIMITED',
    'AADI INFRACON (INDIA) PRIVATE LIMITED',
    'PASSION GREENS CONSULTANCY PRIVATE LIMITED',
    'Trees Retail Private Limited',
    'ADITYA TECHNOLOGY & CAREER DEVELOPEMENT PRIVATE LIMITED',
    'Niladri EXIM Private Limited',
    'U-TURN APPARELS PRIVATE LIMITED',
    'DECCAN TECHNOSECURITY & UTILITYSERVICES PRIVATE LIMITED',
    'Indo Thai Realties Limited',
    'JAI SHIV CEREALS TRADERS PRIVATE LIMITED',
    'TRIFID RESEARCH PRIVATE LIMITED',
    'DBL ASHOKNAGAR-VIDISHA TOLLWAYS PRIVATE LIMITED',
    'MANOMAY EATRIES PRIVATE LIMITED',
    'S.S. KITCHEN WARE PRIVATE LIMITED',
    'FREEZTECH LOGISTICS PRIVATE LIMITED',
    'ERIS ENERGY LIMITED',
    'PEST SOLUTIONS INDIA PRIVATE LIMITED',
    'THE GRAND LAAVANYA RESORT & HOTEL PRIVATE LIMITED',
    'RAJORIYA CONSTRUCTIONS PRIVATE LIMITED',
    'SHREE ATHARVA RESORT UJJAIN PRIVATE LIMITED',
    'THE CURRY HOUSE FOODS PRIVATE LIMITED',
    'TECH FORCE WAYAND PRIVATE LIMITED',
    'ARTHAV INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'Vibrant Pithampur Infra Developers Private Limited',
    'D CARNIVAL RECREATION PRIVATE LIMITED',
    'K.R.S. INFRA-ESTATE PROJECT DEVELOPER PRIVATE LIMITED',
    'Linkites Infotech Private Limited',
    'ABA DEVBUILD PRIVATE LIMITED',
    'Kaycee insurance corporate agency private limited',
    'Chaitanya infratech private limited',
    'G d sons credit & investment pvt ltd',
    'RIKALP CAPITAL PRIVATE LIMITED',
    'Ateeya estates private limited',
    'Glomed developers private limited',
    'RABI BINOD BUSINESS PRIVATE LIMITED',
    'Hn financial advisors private limited',
    'G. t. stock vision private limited',
    'Aim shares and securities private limited',
    'Labhesh finstock private limited',
    'Vikrant holdings and trading pvt ltd',
    'Leasecon investments pvt ltd',
    'Priya ranjan investment and trading co private ltd.',
    'Bagri udyog pvt ltd',
    'LUCKY MOTOR AND COMMERCIAL FINANCERS PRIVATE LIMITED',
    'Minnie pan india private limited',
    'Triveni polymers private limited',
    'Campari exports private limited',
    'Best barcode system private limited',
    'Pa med services private limited',
    'C. net communications (india) private limited',
    'Roots cooling systems private limited',
    'Usha exim private limited',
    'Kundan rice mills limited (part ix co.)',
    'Surabhi engineers limited',
    'Sm finlease limited',
    'Nikko auto limited',
    'Vinay foundary and engineering industries private limited',
    'Harmonic software patterns private limited',
    'Jay switches (india) private limited',
    'Jay k. frp pvt. ltd.',
    'Multi modes transport private limited',
    'Desien beiz technik private limited',
    'Sunil wire industries private limited',
    'Elron instrument company private limited',
    'Mantec health care services private ltd.',
    'H j engineers private ltd',
    'Vivsun exports private limited',
    'Pehachan advertising and marketing private ltd',
    'Benny impex private limited',
    'Gloxinia farms private limited',
    'Trinayana auto private limited',
    'EMERSE STUDIO PRIVATE LIMITED',
    'Travel oytser india private limited',
    'Bio instruments (india) private limited',
    'Vardan overseas private limited',
    'Ranee polymers private limited',
    'NITASH PROMOTERS PRIVATE LIMITED',
    'Mundhra agencies private limited',
    'Seascape technologies limited',
    'Jns instruments limited',
    'Master safety products private limited',
    'Mountain trail holidays private limited',
    'Shobha cards private limited',
    'Tushar leasing & investment private limited',
    'Sysware infotech pvt ltd',
    'Fincap portfolio limited',
    'Deepan exim and invest private limited',
    'Disco investments private limited',
    'Sachi enterprises private limited',
    'Dsp precision products private limited',
    'Hope consultants limited',
    'Unistyle impex private limited',
    'MODI-MUNDIPHARMA BEAUTY PRODUCTS PRIVATELIMITED',
    'S s a t consultants private limited',
    'Easa elevators private limited',
    'Tara lohia private limited',
    'Gopal teknocon private limited',
    'Pyro telecom engineering services private limited',
    'Bpo supply chain management private limited',
    'Smart patent outsourcing services private limited',
    'Search bureau consulting private limited',
    'Ethical medicare private limited',
    'Be engineering services india private limited',
    'Patina designs private limited',
    'Empi vittal centre innopolis private limited',
    'Sandmartin outsourcing private limited',
    'Bahri realty management services private limited',
    'V.k. mechanical services private limited',
    'Tavleen resorts and spa private limited',
    'Ideaworks design & strategy private limited',
    'Asia pacific communications associates private limited',
    'Prachi financial services private limited',
    'Cargocare freight and forwarding private limited',
    'Eventales designs private limited',
    'Karna paints pvt ltd',
    'Neel kamal enterprises private limited',
    'Total integrated design india private limited',
    'Bath plus (india) pvt. ltd.',
    'ANONDITA LATEX PRODUCTS (INDIA) PRIVATE LIMITED',
    'Pisces exim (india) private limited',
    'Rusha careers private limited',
    'Archi medes india consultants private limited',
    '21st century legend corporation private limited',
    'Gmr enterprises private limited',
    'GMR SEZ & PORT HOLDINGS LIMITED',
    'Boost automobiles india private limited',
    'Puneet india private limited',
    'Z PLUS SECURITY MANAGEMENT PRIVATE LIMITED',
    'Irudek tradecom private limited',
    'Avery dennison (india) private limited',
    'Utech india limited',
    'Gdr info-products limited',
    'Xponential data and business services private limited',
    'QINTENT INNOVATIONS PRIVATE LIMITED',
    'Sumpragatti enterprises private limited',
    'Wikasta business & technical solutions private limited',
    'Geneclick biotech private limited',
    'Saaraa medical solutions private limited',
    'New designer.web private limited',
    'Vidyatech solutions private limited',
    'Capri akvotech systems private limited',
    'M.n. technologies private limited',
    'Standard portfolios private limited',
    'Navigant technologies private limited',
    'Sarat book house private limited',
    'Unitech premises developers limited',
    'Nova bio fuels private limited',
    'S p wahi management and technology consultants private limited',
    'Quad global konnect private limited',
    'Sydler remedies private limited',
    'Bioxera pharma private limited',
    'Abhikhya trade private limited',
    'RANGOON CHEMICAL WORKS PVT LTD',
    'CHIRAG FOOTCARE PRIVATE LIMITED',
    'Mallcom safety private limited',
    'NEWZSTREET MEDIA PRIVATE LIMITED',
    'Lubrikote specialities private limited',
    'Bronkol pvt ltd',
    'Pharmamen enterprises private limited',
    'STESSO SHOPPERS PLAZA PRIVATE LIMITED',
    'Prakash lubriquipment pvt ltd',
    'Sarisons shoe tech private limited',
    'INDO GLOBAL PAPERS PRIVATE LIMITED',
    'VISTARR CONSUMER PRODUCTS PRIVATE LIMITED',
    'Martidale pharmaceuticals pvt ltd',
    'Medihauxe international private limited',
    'Premier carbonic pvt ltd',
    'Bathinda industrial gases pvt ltd',
    'MEHER BUSINESS VENTURES PRIVATE LIMITED',
    'DHANRAJ SUGARS PRIVATE LIMITED',
    'Adonis laboratories private limited',
    'Karnani pharmaceuticals pvt ltd',
    'Himanshu organics private limited',
    'ZODIAC BRAND SPACE PRIVATE LIMITED',
    'ASIATIC COLOUR-CHEM INDUSTRIES PRIVATE LIMITED',
    'Synergy aeromatics private limited',
    'Rudraksh detergent and chemicals private limited',
    'Dyechem international private limited',
    'V p soap pvt ltd',
    'Shree ujjawal agrichem private limited',
    'Permaseal auto products private limited',
    'Venlon metacoat private limited',
    'Savo polymers and petro products private limited',
    'Life essentials personal care private limited',
    'ROADCO (INDIA) LIMITED',
    'Chemtech intermediates private limited',
    'UNISAN FORMULATIONS PRIVATE LIMITED',
    'Anudeep enterprises private limited',
    'Nice chemicals pvt ltd',
    'Savi jana sea foods pvt ltd',
    'Bathwal plastics ltd',
    'Rachana polymers pvt ltd',
    'Infantry hotels private limited',
    'Lavanya paints pvt ltd',
    'Spectrum pharmaceuticals private limited',
    'Jaipur metacast private limited',
    'Amulya flexipipe private limited',
    'BHAIRAV EMBRO DESIGN PRIVATE LIMITED',
    'MORVEL LABORATORIES PRIVATE LIMITED',
    'VEESHNA POLYPACK PRIVATE LIMITED',
    'Varsa plastic industries private limited',
    'Satish injecto-plast private limited',
    'Auraa adhesive tapes private limited',
    'Siddharth chlorochem pvt ltd',
    'Chittor polyfab private limited',
    'VARDHMAN POLYMERS PVT. LTD',
    'Nupal remedies private limited',
    'Precision camshafts limited',
    'Shri mahavir foam private limited',
    'Aims retail services private limited',
    'Uttam foundries and ispat private limited',
    'Its tecnodue india private limited',
    'Gnrc plastics pvt ltd',
    'Ilpea paramount limited',
    'Modi-senator (india) private limited',
    'Umang polymers private limited',
    'Kanishka vinyl private limited',
    'Ruparel nets pvt ltd',
    'Shah paperplast industries limited',
    'Nediyara extrusions pvt.ltd.',
    'Space age chemplast pvt ltd',
    'Praxom arogyacare (ksg) private limited',
    'Hindustan pharmachem limited',
    'Luk plastcon limited',
    'Pramod fibre-plast private limited',
    'LINGARAJ PIPES PRIVATE LIMITED',
    'Mask polymers insulators private limited',
    'NOVA CHEMDRUGS PRIVATE LIMITED',
    'Wright care remedies private limited',
    'OPTISURGICARE (INDIA) PRIVATE LIMITED',
    'Chadha exports pvt ltd',
    'Shree balaji glass manufacturing pvt ltd',
    'Keshira jewels private limited',
    'Adarsh petrochem (india) private limited',
    'Pulver-ash projects ltd',
    'ARTISTAAN PRIVATE LIMITED',
    'Eastern carbon exim private limited',
    'Goenka ferro chem private limited',
    'G. tech splicing private limited',
    'Aswini homeo and ayurvedic products private limited',
    'SANGKAJ STEEL PRIVATE LIMITED',
    'Lucid laboratories private limited',
    'Trisen general industrial products and consultants pvt ltd',
    'Cosminova cosmetics private limited',
    'Sun pvt ltd',
    'Hll biotech limited',
    'Kathua steel works pvt ltd',
    'Shivalay ispat and power private limited',
    'CHEMFAB ALKALIS LIMITED',
    'Sileng manufacturing india private limited',
    'Divekar wallstabe & schneider precision seals private limited',
    'Prince t m t steels private limited',
    'Howrah ferrous ltd',
    'Sagar roofings private limited',
    'KISSUI METALIKS & STEELS PRIVATE LIMITED',
    'B.g. rubber products private limited',
    'Krm tyres private limited',
    'Milgerlan applicators private limited',
    'Hope enterprises private limited',
    'Jain jubilant cars private limited',
    'Tosy auto private limited',
    'Shakti infranirman private limited',
    'Reve infraprojects private limited',
    'Comfort vyapaar private limited',
    'Silverline advisory private limited',
    'Premchand jute & industries private limited',
    'Bwf tec india private limited',
    'Prominent vanijya pvt ltd',
    'Satnam commodities private limited',
    'Moz exports pvt ltd',
    'Fantasy trading company pvt ltd',
    'Sulabh tradelink private limited',
    'Nirmala distributors private limited',
    'Madhav trading corporation limited',
    'BUSILINK ASSOCIATES PRIVATE LIMITED',
    'WINDSOR DEALERS PRIVATE LIMITED',
    'Orchid vyapaar private limited',
    'Ie exim private limited',
    'Sarvodaya agencies private limited',
    'AMEY ESTATES PRIVATE LIMITED',
    'Popular vanijya private limited',
    'Raj salt pvt ltd',
    'Brotex vanijya private limited',
    'Combined tradecomm private limited',
    'Kimaan exports private limited',
    'Capricon agencies private limited',
    'SARTHAK METALS LIMITED',
    'Indmoda exports private limited',
    'Heirloom collections private limited',
    'Siddharth global private limited',
    'M. h. windows decor private limited',
    'Pawan communications private limited',
    'Win-medicare private limited',
    'Forza medi (india) private limited',
    'Dcs hair products (india) private limited',
    'Medtra life care private limited',
    'Khushi vanijya pvt ltd',
    'Mico trading private limited',
    'MIDKOT INVESTMENTS PRIVATE LIMITED',
    'Sea-invest india private limited',
    'Peekay agencies pvt ltd',
    'A v george and co private ltd',
    'Sri bhagavathy traders private limited',
    'Shrestha consultancy private limited',
    'Rekofa tooltech private limited',
    'Maa manasa distributors private limited',
    'Lime light tie up pvt ltd',
    'NEELKANTHAM SYSTEMS PRIVATE LIMITED',
    'Aventura components private limited',
    'Sahasra electronics private limited',
    'Bestsellers cochin pvt ltd',
    'Lovson exports limited.',
    'Omaxe global trading corporation private limited',
    'Brijwasi marketing pvt ltd',
    'Pm control systems (india) private limited',
    'Nishakar marketing pvt ltd',
    'Hindustan export and import corporation private limited',
    'Biddle sawyer limited',
    'Teksons private limited',
    'Silkasia exports private limited',
    'Manobal marketing private limited',
    'Mahasakti tieup private limited',
    'Swaraj bazaar private limited',
    'Mettler-toledo india private limited',
    'SHAN SHAI',
    'S IEGC PRIVATE LIMITED',
    'Elofic industries limited.',
    'GALAXY VOGUE PRIVATE LIMITED',
    'Poysha air products private limited',
    'Poysha leasing private limited',
    'Hubert ebner (india) private limited',
    'Walsons services private limited',
    'United concepts and solutions pvt ltd',
    'Toy zone impex private limited',
    'Leisure builders private limited',
    'M f electricals private limited',
    'Wazir estates private limited',
    'Moneyplus capital and finance private limited',
    'Starts india private limited',
    'Raghupati securities private limited',
    'JEEVIYA BEVERAGES PRIVATE LIMITED',
    'Avi capital services private limited',
    'Invisible kitchens private limited',
    'Jsb staffing solutions private limited',
    'OBERHAUSER SERVICES PRIVATE LIMITED',
    'Synventive molding solutions jbj private limited',
    'Time immigration consultants private limited',
    'Sangam refrigeration and air-conditioning services private limite',
    'Taurus communication & marketing network private limited',
    'ACE MATRIX SOLUTIONS PRIVATE LIMITED',
    'Kapur graphics private limited',
    'Salto dee fe consulting service private limited',
    'I s engineers contractors private limited',
    'India institute for critical action centre in movement',
    'Geno biosciences private limited',
    'Vale india private limited',
    'Sanskar business private limited',
    'Blue circle medi services private limited',
    'GREENDALE INDIA LIMITED',
    'Kush dealcomm private limited',
    'DIASPORE MERCANTILE PRIVATE LIMITED',
    'Necas automation private limited',
    'SANVIJAY INFRASTRUCTURES PRIVATE LIMITED',
    'Radium management services private limited',
    'Bee k bee prints private limited',
    'Darbari lal futuristic limited',
    'Advance coaching & exim private limited',
    'Wisetime learning private limited',
    'Aadra couture private limited',
    'Hairwits and skinwits india private limited',
    'ROSHLEEN INTERNATIONAL PRIVATE LIMITED',
    'Environmental protection service company (delhi) private limited',
    'Xplusplus outsourcing private limited',
    'Vee gee kaushiko engineering private limited',
    'Semco tech services private limited',
    'Sfi india private limited',
    'Pin media private limited',
    'SCORN MARKETING PRIVATE LIMITED',
    'Edaxis systems india private limited',
    'Vishwa internationals private limited',
    'Excelgens consulting services india private limited',
    'Cyan international (india)',
    'Atharv care india private limited',
    'Railway children india',
    'Kush vinimay private limited',
    'HIGH VISION SCHOOLS PRIVATE LIMITED',
    'Dr. gaba and associates medicare private limited',
    'Vardaan health care private limited',
    'Processor systems (india) private limited',
    'Health and hospitality limited',
    'Royal yoga meditation institute private limited',
    'Amiown schools private limited',
    'Salasar merchants private limited',
    'Amity education services private limited',
    'Amity education infrastructure private limited',
    'N. k. charitable',
    'Vidyalaxmi retails private limited',
    'Gopalpriya commercial private limited',
    'Icharaj retails private limited',
    'Windsor specialty resins private limited',
    'Mehar overseas private limited',
    'Dudeja interconnect system private limited',
    'Open futures & commodities private limited',
    'J N MUKHERJEE & CO PVT LTD',
    'Cmm arena retails private limited',
    'Tacent tradelinks (india) private limited',
    'Acme supplier private limited',
    'Juvalia sales private limited',
    'Rural broadband private limited',
    'Nittin creations (india) private limited',
    'P.c.chanda & co. private limited',
    'MANDAKINI TRAVEL AND TOURS PRIVATE LIMITED',
    'Aman resorts pvt ltd',
    'Swargam resorts private limited',
    'Planet resorts and developers private limited',
    'Disha hotels private limited',
    'VW CUISINES & CONCEPTS PRIVATE LIMITED',
    'PARAMOUNT CREATIVE VENTURES PRIVATE LIMITED',
    'Ha ha foodworks private limited',
    'Jc world hospitality private limited',
    'Greenview hotels private limited',
    'Orthodox commodities pvt ltd',
    'Sanwaria fashions marketing private limited',
    'Middleton hotels private limited',
    'Upline travels private limited',
    'Millennium commodities private limited',
    'LAKE PALACE TRADE AND TRAVELS PRIVATE LIMITED',
    'Daffodil trexim private limited',
    'Kamani agencies private limited',
    'Linkpoint retails private limited',
    'G.l. vanijya private limited',
    'Lake resorts pvt ltd',
    'International caterers private limited',
    'Aneja sweets and bakers private limited',
    'Apexone leisure & hospitality private limited',
    'Manraj motors private limited',
    'Transport wings (cal) pvt ltd',
    'Cyber green rent a car private limited',
    'Guru shipping and clearing private limited',
    'Tci-concor multimodal solutions private limited',
    'Gajraj carriers pvt ltd',
    'Kuehne + nagel private limited',
    'Aaram shop private limited',
    'Endorse marketing private limited',
    'Rush travel private limited',
    'Orange tours & trips private limited',
    'Avantage services private limited',
    'Sam logistic infrastructure private limited',
    'Airship cargo private limited',
    'Direct ocean shipping private limited',
    'Doyen barter private limited',
    'Country roads hospitality pvt ltd',
    'As instant reservation networks private limited',
    'CURITIBA NICKEL PRIVATE LIMITED',
    'Eos hospitality private limited',
    'A.d. hotels pvt ltd',
    'Twu travel with us private limited',
    'Periplus travel private limited',
    'Guha roy food joint & hotel private limited',
    'First & fast carriers private limited',
    'El-ar travels private limited',
    'SRIJAN BHUMI TOUR & TRAVELS PRIVATE LIMITED',
    'Times holidays private limited',
    'Swastiksubham international limited',
    'Arisu trading private limited',
    'Sensea marine pvt ltd',
    'Shivkhori transportation private limited',
    'Elxire data services private limited',
    'Seven seas couriers pvt ltd',
    'Thrs travel and hospitality representation services private limited',
    'Sajan telematics pvt ltd',
    'Digi cablecomm services private limited',
    'Bacfo & krauter holdings private limited',
    'Machino transport pvt ltd',
    'Indo journeys private limited',
    'Terra world travel (india) private limited',
    'Timblo agro development private limited',
    'Salgaocar leasing and credit company private limited',
    'White feather travels private limited',
    'Mountain club resorts (india) private limited',
    'Competent finman private limited',
    'Chopra audio visual private limited',
    'Eastern plaza ltd',
    'Jaishree credit pvt ltd',
    'Sigma consultants pvt ltd',
    'Traviate private limited',
    'Joshi travels private limited',
    'OLEV BEAUTY PRIVATE LIMITED',
    'K d joshi finance and investment pvt ltd',
    'Makarand holding pvt ltd',
    '5pl logistics private limited',
    'Ranbhumi securities private limited',
    'ALOKE TRADING & INVESTMENT PRIVATE LIMITED',
    'Reddy holdings private limited',
    'Linton securities private limited',
    'The calcutta stock exchange limited',
    'The oriental company limited',
    'Ajmera investments pvt ltd',
    'TORTRIX SALES PRIVATE LIMITED',
    'Zigma processing and manufacturing private limited',
    'T k international limited',
    'Ganapati properties private limited',
    'Abbott resorts private limited',
    'Mbd alchemie private limited',
    'FEISTY MARKETING PRIVATE LIMITED',
    'Evernew securities private limited',
    'MYOTIC TRADING PRIVATE LIMITED',
    'Vls capital limited',
    'Sarvodaya texstyle private limited',
    'Bhavsagar texfab private limited',
    'Vikas superfine garments private limited',
    'Concept clothing textiles private limited',
    'Arsha food supply private limited',
    'Bbm life styles private limited',
    'Petals embroidery private limited',
    'Rpv exports private limited',
    'Kapoor brothers roller flour mills pvt ltd',
    'Sachdeva and sons rice mills ltd',
    'Ritu beri couture private limited',
    'Ritu beri designs private limited',
    'Mrk shares and stocks private limited',
    'Viku impex private limited',
    'Amrit feeds ltd',
    'Mfp products private limited',
    'Big apple clothing private limited',
    'Texons exports and imports private limited',
    'Manan marbles private limited',
    'Rlt fashions private limited',
    'Sterling creations private limited',
    'RAINWAX POLYMER PRIVATE LIMITED',
    'Renaissance lifestyle private limited',
    'Omtara designs private limited',
    'Kothari knitting mills p ltd',
    'Rangaj th studio private limited',
    'Spinel exports private limited',
    'Discovery leathers private limited.',
    'B l international clothing private limited',
    'Akj industries private limited',
    'Zealheight ores private limited',
    'Arbor brewpub private limited',
    'Savorlife products private limited',
    'Bhooteswar food products private limited',
    'IRAJ FARMS PRIVATE LIMITED',
    'Jalandhar leather india pvt ltd',
    'Unistar footwears private limited',
    'Systech inductions private limited',
    'R s woods private limited',
    'Woodside fashions limited',
    'IRAJGAJANAN GREENS PRIVATE LIMITED',
    'Consortium mines & granites (chennai) private limited',
    'Om crusher india private limited',
    'Simbhaoli speciality sugars private limited',
    'Skcc paper & board pvt ltd',
    'Satkar duplex board mills pvt ltd',
    'Ashok sharma & associates pvt ltd',
    'Shree vallabh ginning and pressing private limited',
    'Tan prints (india) private limited',
    'Velsons printographic private limited',
    'Swastik print-tech private limited.',
    'Ohm products private limited',
    'Shivalik offset private limited',
    'Magnum exports pvt ltd',
    'Sarwati woolen mills pvt ltd',
    'Unique publishers (india) private limited',
    '9.9 GROUP PRIVATE LIMITED',
    'Kalpa char products private limited',
    'Astral steritech private limited',
    'Holytex carpets pvt.ltd.',
    'Venus texspin limited',
    'Auram impex private limited',
    'Kolhapur oxygen and acetylene private limited',
    'Applause syntex private limited',
    'Times collection private limited',
    'KRIBHCO FERTILIZERS LIMITED',
    'Arcl organics limited',
    'Brij footcare private limited',
    'Prem footwear private limited',
    'Desai beverages private limted',
    'U i beverages private limited',
    'NETWORTH PROJECTS PRIVATE LIMITED',
    'Todays diaries india private limited',
    'Grace paper crafts private limited',
    'Vapi organic chemicals private limited',
    'Makson pharmaceuticals (india) private limited',
    'Montage pharmaceuticals pvt ltd',
    'Capsulation and pharmaceuticals private ltd',
    'CENTRIENT PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'Indian medicines pharmaceutical corporation limited',
    'Daya agri products private limited',
    'Leben laboratories private limited',
    'Rathi enterprises private limited',
    'Kay pee dies india private limited',
    'MEGATIC INTERMEDIATES PRIVATE LIMITED',
    'ARJUNA NATURAL PRIVATE LIMITED',
    'USV Private Limited',
    'M.d. auto components private limited',
    'DUCOL ORGANICS AND COLOURS LIMITED',
    'Usv reliable homes private limited',
    'Herbotouch (india) private limited',
    'Naturence cosmetics private limited',
    'Mountain valley springs india private limited',
    'SHALIMAR CHEMICAL WORKS Private Limited',
    'Laxmi rubber products private limited',
    'Unipatch rubber ltd',
    'Maruti technofab industries private limited',
    'Bommidala filaments limited',
    'Visiontek consultancy services private limited',
    'Bec fertilizers limited',
    'PRINCESS PHARMA PRIVATE LIMITED',
    'JM INFRA & ENVIRO TECHNOLOGIES PRIVATE LIMITED',
    'Cactus profiles private limited',
    'ALPHA PLASTOMERS PRIVATE LIMITED',
    'Oswal plastics pvt ltd',
    'Rotomac insulation pvt ltd',
    'Rotomac speciality chemicals private limited',
    'Fiji fibrematics private limited',
    'Abbott pharma limited',
    'Henna industries pvt. ltd.',
    'B.ceramics private limited',
    'Shell sand pvt ltd',
    'Tech towers & developers private limited',
    'Rise realtech private limited',
    'Godbles nirman private limited',
    'Zulekha properties private limited',
    'Kargo equipments private limited',
    'Madhura kumar properities private limited',
    'Cogent it solutions private limited',
    'Critical i.t. solutions private limited',
    'Kadri developers private limited',
    'Tirupati real estates private limited',
    'Divas offshore software technologies private limited.',
    'Arihant info solutions private limited',
    'Bisecure networks private limited',
    'Kbg services private limited',
    'Consolidators information systems private limited',
    'B r informatics private limited',
    'Sharvani infosolutions private limited',
    'Mcwell softech private limited',
    'Cta softech private limited',
    'Sunlight software private limited',
    'TEDCO EDUCATION PRIVATE LIMITED',
    'Airwide solutions india private limited',
    'ELLENBARRIE TEA & INDUSTRIES PRIVATE LIMITED',
    'PATODI FASTENERS PRIVATE LIMITED',
    'Dh technology private limited',
    'Dassault systemes india private limited',
    'Brains media solutions private limited',
    'Rise infradevelopers private limited',
    'Bose estates private limited',
    'Petro it solutions private limited',
    'West range properties pvt ltd',
    'Raunak realtors private limited',
    'Eagle apartments pvt ltd',
    'Patton estates private limited',
    'Megha conclave private limited',
    'Outlay conclave private limited',
    'Bimla estates private limited',
    'Leonis developers private limited',
    'DOTSQUARES TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Blive web solutions private limited',
    'Habilesoft india private limited',
    'Sushanti avenues private limited',
    'Alco info tech private limited',
    'Technable solutions private limited',
    'Rebuscode information solutions private limited',
    'Aplomb technologies private limited',
    'Thinkedge technology private limited',
    'Icolab softwares private limited',
    'Open software technology (india) limited',
    'Fine pearls (india) private limited',
    'Apex vyapaar private limited',
    'Perfextion solutions private limited',
    'Taxmann technologies private limited',
    'Wfx technologies private limited',
    'Safepoint estates private limited',
    'Sarvlok nirman private limited',
    'Prakash retail private limited',
    'Mnp holdings private limited',
    'Binj technologies private limited',
    'Unicorn post media solutions private limited',
    'Viewcom technologies private limited',
    'Bhagwati developers pvt.ltd.',
    'Macario technologies private limited',
    'Interra systems (india) private limited',
    'Spaceage info solutions private limited',
    'Dvs solutions private limited',
    'Techmobia digital solutions private limited',
    'Primus software development india private limited',
    'KOCKPIT ANALYTICS PRIVATE LIMITED',
    'TIOL PRIVATE LIMITED',
    'Ps softech private limited.',
    'Indoswift consultancy services private limited',
    'RAMAGYA CONSUMER CARE PRIVATE LIMITED',
    'Parakums informace systems private limited',
    'Robinville intech private limited',
    'Exponential interactive india private limited',
    'Akasha wireless communications private limited',
    'Input zero technologies private limited',
    'Bitflipping technologies private limited',
    'Santasha technosoft private limited',
    'COPPER DIGITAL (INDIA) PRIVATE LIMITED',
    'Digisol network services private limited',
    'Prologic web solutions private limited',
    'Maxrad software india private limited',
    'FIREPACK STUDIO PRIVATE LIMITED',
    'Objectstream software private limited',
    'Rtf promoters and builders private limited',
    'Ebizneeds (india) business solutions private limited',
    'SIGMA INFOSOLUTIONS LIMITED',
    'Zenatix solutions private limited',
    'Aap infosystems private limited',
    'Avs webs private limited',
    'Transerve technologies private limited',
    'Borderlessmind technologies pvt.ltd',
    '360 analytics & advisory private limited',
    'Rsk realtors private limited',
    'Crosstab it consulting private limited',
    'OTR & INDUSTRIAL TYRE SERVICES INDIA PRIVATE LIMITED',
    'Jay polychem india limited',
    'Quantum hitech merchandising private limited',
    'Acquaint infotech private limited',
    'Tcs and associates private limited',
    'Symbiotic sciences private limited',
    'INFOLLION RESEARCH SERVICES LIMITED',
    'CHOWGULE CENTER FOR APPLIED AND PROFESSIONAL STUDIES',
    'Gujarat eco textile park limited',
    'ELLENBARRIE FOOD PRODUCTS & INDUSTRIES LTD.',
    'Mehta polypropylene indus pvt ltd',
    'PRIME GOLD INDIA LIMITED',
    'Nasik metaldust pvt ltd',
    'Nsi castings private limited',
    'Jindal prefab private limited',
    'Gangadhar alloy private limited',
    'Uppal ferro cast private limited',
    'Krishna al-cast private limited',
    'Asianol biotech private limited',
    'Ashoka multiyarn mills limited',
    'Noida plast private limited',
    'Symphony polymers private limited',
    'Osaka alloys and steels pvt ltd',
    'Adhunik corporation limited',
    'Multiwyn foams pvt ltd',
    'Indoswe extrusions limited',
    'Keramos tile and stone private limited',
    'Excel ceramic private limited',
    'Allied ceramics pvt ltd',
    'Jindal pe-x tubes private limited',
    'VISA NATURAL RESOURCES LIMITED',
    'Technocem systems india private limited',
    'Binay udyog pvt ltd',
    'New hindustan tubes private limited',
    'Bansal alumex private limited',
    'Kissan zinc india pvt ltd',
    'Indian gem & jewellery creation private limited',
    'Indian gem & jewellery imperial private limited',
    'Surana diamond jewellery private limited',
    'Showlite aluminium industries pvt ltd.',
    'Poonam roofing products private limited',
    'Sj global private limited',
    'Tirupati plast private limited',
    'Siddharth foundry private limited',
    'Super iron foundry pvt ltd',
    'Patton overseas limited',
    'Minmat ferro alloys pvt ltd',
    'Indo pumps private limited',
    'Pacwel plastics pvt ltd',
    'Slg jewellers private limited',
    'Aircare projects private limited',
    'Jacs metals pvt ltd',
    'Dyna-k auto parts private limited',
    'Lubex petrochem pvt ltd',
    'Nirmal wires pvt ltd',
    'Lm metalliks private limited',
    'Zero tolerances toolings private limited',
    'Jaynix engineering private limited',
    'Lila forgings pvt ltd',
    'Gnc forge pvt ltd',
    'Rathi electro copper pvt ltd',
    'Patton international ltd',
    'Pye tools private limited',
    'Inder industries pvt ltd',
    'Deeps tools private limited',
    'ASN MANUFACTURING AND SERVICES PRIVATE LIMITED',
    'PIGMENTS & CHROMATES (INDIA) PVT LTD',
    'Vasundhra ispat private limited',
    'Hsil associates limited',
    'Animesh ispat private limited',
    'Kamdhenu steels and alloys limited',
    'Galvano india private limited',
    'Busch vacuum india private limited',
    'Oriental compressor accessories pvt ltd',
    'Marathon electric motors (india) limited',
    'Kkk bearings pvt ltd',
    'Sood ispat and power private limited',
    'Ottoman tubes private limited',
    'Lg alloys private limited',
    'Bhawani dealmark private limited',
    'ORGANIC COOLING TECHNOLOGY PRIVATE LIMITED',
    'Oscar sealing systems pvt ltd',
    'Kosbros machine tools private limited',
    'N s mould makers private limited',
    'Fibretex india private limited',
    'Snow space furniture systems private limited',
    'Jbs steels private limited',
    'Dindigul engineering clusters private limited',
    'Niksan agrotech india private limited',
    'Iris india household solutions private limited',
    'Murthal fabrication private limited',
    'Paragon instrumentation engineers private limited',
    'Aar bee machineries pvt ltd',
    'RSD ASPHALTS PRIVATE LIMITED',
    'Authentix india private limited',
    'Triveni wire craft private limited',
    'Jag hardware private limited',
    'Rattan power presses private limited',
    'Harison pumps private limited',
    'Msf industries private limited',
    'Polywood india limited',
    'Eagle medical systems private limited',
    'Spintron india private limited',
    'Faridabad tools pvt ltd',
    'Brahmos aerospace thiruvananthapuram limited',
    'Vam group hi tech engineering pvt ltd',
    'Narpat steels pvt. ltd.',
    'Knm spares private limited',
    'Ufi filters india private limited.',
    'Epc (india) private limited',
    'Everbake systems private limited',
    'Durofit technologies private limited',
    'General imsubs private limited',
    'Varun viren valves private limited',
    'Koshala engineers and services private limited',
    'Buraj controls private limited',
    'Qualimark machines private limited',
    'Netcool and referigeration india private limited',
    'Amrit aircon system private limited',
    'Morgan signature towers private limited',
    'Dempo properties and investments private limited',
    'Narke electricals pvt ltd',
    'Neelgagan nirman private limited',
    'Mahamani plaza private limited',
    'Palanhare buildtech private limited',
    'Palanhare nirmaan private limited',
    'Palanhare buildwell private limited',
    'Palanhare infraestates private limited',
    'Palanhare tower private limited',
    'Palanhare apartment private limited',
    'Palanhare buildcon private limited',
    'Palanhare realtors private limited',
    'Open access technology india private limited',
    'Lamba software systems private limited',
    'Mindset seismic private limited',
    'De souza estate holdings private limited',
    'Vnv software private limited',
    'Winmethods technologies private limited',
    'Netware computers private limited',
    'Flexsin technologies private limited',
    'Mind shell infotech private limited',
    'Alpinesoft it solutions private limited',
    'Om information technologies private limited',
    'Bonanza infotech private limited',
    'Just apps private limited',
    'Thapson systems pvt ltd',
    'P cube mobility private limited',
    'Perleybrook labs private limited',
    'Kalinga software private limited',
    'Sentire exports private limited',
    'Aa walker developers private limited',
    'Sunrays infrastructure private limited',
    'S.e.a. realtors private limited',
    'Cladding projects private limited',
    'Gempulse infotech private limited',
    'Apex spatial tech solutions private limited',
    'Shree yash avenues private limited',
    'Batco integrated logistics private limited',
    'COMMRAX NETWORKS PRIVATE LIMITED',
    'Shakuntlam infotech private limited',
    'Crypton tech private limited',
    'Networks infotech private limited',
    'Munch ado india private limited',
    'Msewa software solution private limited',
    'Synergy electric private limited',
    'Novatree e-solutions private limited',
    'Msh business consulting private limited',
    'G.m.comptech network solutions private limited',
    'B.l.infosoft private limited',
    'Coframe software private limited',
    'Inative networks private limited',
    'INDIA DATSEC SOLUTIONS PRIVATE LIMITED',
    'Rv solutions private limited',
    'Aonesite solutions private limited',
    'E MEDITEK INSURANCE LIMITED',
    'Gem software solutions limited',
    'Soarlogic information technologies private limited',
    'Logic simplified private limited',
    'Nishan systems private limited',
    'E-biz infoservices private limited',
    'Isec services private limited',
    'Softcrylic mobile technologies private limited',
    'Edios software solutions private limited',
    'Oceans and palms resorts private limited',
    'Aks interactive solutions private limited',
    'Webtenet solutions private limited',
    'ACUITY KP SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Srr software private limited',
    'Sagar technocity private limited',
    'WORLDPAY INDIA PRIVATE LIMITED',
    'Harangad solutions private limited.',
    'Ap infoarts private limited',
    'FATEH RURAL PRIVATE LIMITED',
    'Mkt marketing technologies private limited',
    'D4n technologies private limited',
    'Quy technology private limited',
    'Revolution next technologies private limited',
    'Convalida technologies private limited',
    'Cloudspace private limited',
    'Netlings webworks private limited',
    'Bespoke digital media india private limited',
    'Thoughtpulp technologies private limited',
    'Andd techservices private limited',
    'Etoile info solutions private limited',
    'Allin info systems private limited',
    'SARVAP SOLUTIONS PRIVATE LIMITED',
    'Acme infovision systems private limited',
    'Awc software private limited',
    'Policyx.com insurance web aggregator private limited',
    'Protocol automation technologies private limited',
    'Ranosys technologies private limited',
    'Cloud7 technologies private limited',
    'Sid tech private limited',
    'Balaji websoft technology private limited',
    'Extensive host private limited',
    'Daily law times private limited',
    'Intecons software lab private limited',
    'Froiden technologies private limited',
    'Imatrix technologies private limited',
    'True power tech private limited',
    'Lensel web services private limited',
    'Gfk mode private limited',
    'Uday infotech private limited',
    'Hue service private limited',
    'Kreeti technologies private limited',
    'INDXX CAPITAL MANAGEMENT PRIVATE LIMITED',
    'Bureau of research on industry and economic fundamentals private limited',
    'Imperial online services private limited',
    'Sunlight information technology private limited',
    'Leader valves ltd',
    'Eastern pneumatics pvt ltd',
    'Intertech hydraulics private limited',
    'MRS BEARINGS PRIVATE LIMITED',
    'K f beltings pvt ltd',
    'Sagar heavy engineering pvt ltd',
    'Glanze engineering company pvt ltd',
    'Vafs (india) private limited',
    'Avi engineering pvt ltd',
    'Micro tools (india private limited',
    'Onkar dies private limited',
    'Darley engineers private limited',
    'Panesar agriculture works private limited',
    'R a machine tools private limited',
    'Kke wash systems private limited',
    'Venus india metals private limited',
    'Kalgidhar small tool private limited',
    'C.k. zipper private limited',
    'Ascent poly films pvt ltd',
    'Pune polymers p ltd',
    'Tough casting private limited',
    'Amcl machinery limited',
    'Ronald web offset private limited',
    'PREMIER CASTINGS PRIVATE LIMITED',
    'Idmc limited',
    'Arm welders private limited',
    'Indo ferro melt private limited',
    'ARBS POWER SOLUTIONS PRIVATE LIMITED',
    'Kedia industries ltd',
    'Elin electronics ltd.',
    'Sevana electrical appliances pvt ltd',
    'India forgings & engineering company pvt ltd',
    'Databyte equipment private limited',
    'Avk computer centre pvt ltd',
    'ARCVAC FORGE CAST Private Limited',
    'G k ispat private limited',
    'G d tools pvt ltd',
    'Shakambaree traders pvt ltd',
    'FILO DESIGN PRIVATE LIMITED',
    'Continental engineers and consultants limited',
    'Hy tuf steels pvt ltd',
    'Guru metachem private limited',
    'Star coolers and condensers private limited',
    'Associated toolings (india) pvt ltd',
    'Duraweld metsys private limited',
    'Somik enterprises private limited',
    'Super winding wires private limited',
    'Rigid conductors (raj.) private limited',
    'AAJCO ENERGY PRIVATE LIMITED',
    'Yuanda aluminium engineering (india) private limited',
    'Vishva electrotech limited',
    'Litech electrosystems private limited',
    'Recons power equipments private limited',
    'Mixavi equipments private limited',
    'Shan tablewares private limited',
    'TUSKER MATERIALS HANDLING PRIVATE LIMITED',
    'Ascent technologies private limited',
    'Nanocut engineers private limited',
    'Beta maschinenfabrik private limited',
    'Toshniwal sensing devices private limited',
    'S m creative electronics limited',
    'Ultra technologies private limited',
    'Impressia imaging pvt. ltd.',
    'Kdp micro point pvt. ltd.',
    'Daze digital private limited',
    'Plug energia private limited',
    'Benz india private limited',
    'Media focus advisory private limited',
    'Naina electronics pvt ltd',
    'Atria broadband services private limited',
    'Chandigarh music centre private limited',
    'Nishko instruments pvt ltd',
    'Freemans measures private limited',
    'Compax industrial systems pvt ltd',
    'Shiva niryat pvt. ltd.',
    'Central calcutta sales private limited',
    'Microtech autoparts private limited',
    'Jainendra automotive pvt. ltd.',
    'M.l.r.motors limited',
    'Advance engineers india private limited',
    'Alliance winding equipment india private limited',
    'Micro network (india) private limited',
    'Meko auto private limited',
    'Sterling automobiles private limited',
    'Napino auto and electronics limited',
    'Suhal projects ltd',
    'SU-ASHISH DIAM PRIVATE LIMITED',
    'Avon cycles ltd',
    'La sovereign bicycles private limited',
    'Pahwa estates and holdings private limited',
    'Elite plast autosystems private limited',
    'Sovik autos private limited',
    'Unitech (info) private limited',
    'SEN & PANDIT ELECTRONICS PVT LTD',
    'Contrive instrumentation private limited',
    'CLIMATECH AIRCON ENGINEERS PRIVATE LIMITED',
    'Panva engineering private limited',
    'Woodage interiors private limited',
    'Mirage toughened glasses private limited',
    'Krebs international limited',
    'Goyal sons jewels private limited',
    'Hazoorilal and sons jewellers private limited',
    'Muskaan safety solutions private limited',
    'Elymer international private limited',
    'Bhagwati filters private limited',
    'New-tech synergy systems private limited',
    'Oppalokka sports india private limited',
    'Ambassador stationery concepts private limited',
    'Rankers synergies private limited',
    'Kirloskar proprietary limited',
    'HARITA GREENTECH POWER LIMITED',
    'Comet energy solutions india private limited',
    'Incotech engineers pvt ltd',
    'DENSITY TRANSFORMERS PRIVATE LIMITED',
    'Texel india technology private limited',
    'Edge infoways private limited',
    'Dk software and technologies private limited',
    'Cynoteck technology solutions private limited',
    'Voz creativa private limited',
    'Perennation computer solutions global private limited',
    'Mark design solutions private limited',
    'Kay kay softech private limited',
    'Nagarro software private limited',
    'Cnc technologies international limited',
    'Sesame group india private limited',
    'Landmark infonet private limited',
    'TACTIVE SOFTWARE SYSTEMS PRIVATE LIMITED',
    'OCEAN EVOKE PRIVATE LIMITED',
    'Magnon interactive private limited',
    'Visvero solutions private limited',
    'Smartshore infoservices private limited',
    'Skilrock technologies private limited',
    'Tekege solutions private limited',
    'Orbit it services private limited',
    'Resseaux tech private limited',
    'Fastflow software private limited',
    'Pnr education private limited',
    'Indra technologies private limited',
    'S p solutions point private limited',
    'C r a technologies private limited',
    'Akd techsols private limited',
    'GETOUT SYSTEM PRIVATE LIMITED',
    'Simpli5d technologies private limited',
    'Addazz online services private limited',
    'DUCTUS TECHNOLOGIES PRIVATE LIMITED',
    'ATRIA CONVERGENCE TECHNOLOGIES LIMITED',
    'Vipshel infotech private limited',
    'ROCKMECH IT SOLUTIONS PRIVATE LIMITED',
    'Kke soteco private limited',
    'Royalways technologies privite limited',
    'Jindal info media private limited',
    'Anthem infotech private limited',
    'Bmp egroup solution private limited',
    'Authbridge data services private limited',
    'S v technology solutions private limited',
    'Stutzen corporates private limited',
    'Sagore.com e-services private limited',
    'Opaque solutions private limited',
    'BARSAATI MEDIA TECH PRIVATE LIMITED',
    'R l agro solutions private limited',
    'Q innovations private limited',
    'Eans business support private limited',
    'Gateway bpo private limited',
    'Astech systems private limited',
    'Tectura infotech private limited.',
    'PURPLE KPO SERVICES PRIVATE LIMITED',
    'Visan realty ventures private limited',
    'Streak infotech private limited',
    'Spirant communication private limited',
    'Intellect information technologies private limited',
    'CYBER MEDIA RESEARCH & SERVICES LIMITED',
    'CHANAKYA ASHOK ENTERPRISES PRIVATE LIMITED',
    'Kag investment and advisors private limited',
    'Asm research private limited',
    'Services (india) private limited',
    'Adrianse india private limited',
    'Gkc associates private limited',
    'Pelican associates private limited',
    'Craphts consultants (india) private limited',
    'Population health services (india)',
    'South delhi builders pvt ltd',
    'BEUMER INDIA PRIVATE LIMITED',
    'PLANSWELL PROFESSIONALS PRIVATE LIMITED',
    'Ratna software architects consultancy private limited',
    'Smart payment solutions private limited',
    'Ennexa technologies private limited',
    'Hannu internet corp. private limited',
    'Shinewell innovation softech private limited',
    'Ybrant people manpower & consulting private limited',
    'Cleantec infra private limited',
    'Blufox entertainment private limited',
    'Affinity planners private limited',
    'Woxa technologies private limited',
    'Hermes india infraconsult private limited',
    'Aadhev impex private limited',
    'Ang experts private limited',
    'Central linen park private limited',
    'Digitech systems & infocom private limited',
    'Taarak india private limited',
    'Essen solutions private limited',
    'CAPITAL TREE INFRATECH ADVISORS PRIVATE LIMITED',
    'M2 vending private limited',
    'Pragmatix research and advisory services private limited',
    'Sgf consultancy services private limited',
    'Gempulse infoedge private limited',
    'Rib consulting private limited',
    'Koovs marketing consulting private limited',
    'Seek research and consultations private limited',
    'Ingenious e-brain solutions private limited',
    'Aahana decor private limited',
    'A and m portfolio managers private limited',
    'Nest innovative solutions private limited',
    'Foots and yards real estate consultants private limited',
    'Hanumanta land promoters private limited',
    'LEGACY TELESALES PRIVATE LIMITED',
    'Tristar global infrastructure private limited.',
    'Walker consultants private limited',
    'Sunil nayyar consultants private limited',
    'Tejas detective agency private limited',
    'INSIGHT ALPHA RESEARCH & SOLUTIONS PRIVATE LIMITED',
    'Bequrious software private limited',
    'Software plus solutions private limited',
    'Camphor solutions private limited',
    'Oneworld resources private limited',
    'Bir engineering services private limited',
    'P.n. ghosh and associates private limited',
    'Pioneer fabcon private limited',
    'Varsha metal finishers private limited',
    'Bony rubber co private limited',
    'Avishkar industries private limited',
    'LAKSHMI LIFE SCIENCES PRIVATE LIMITED',
    'Machine tools india ltd',
    'Encon enterprises private limited',
    'Pressure and process boilers private limited',
    'ANNAMALLAI ENTERPRISE PRIVATE LIMITED',
    'Ravi seamless pipes india private limited',
    'Annapurna tube products private limited',
    'Weitex india private limited',
    'Arvind engineering works ltd',
    'Eastern engineering & technologies private limited',
    'Ptc engineering (india) private limited',
    'P p rolling mills mfging company private limited',
    'John energy limited',
    'Pioneer cranes & elevators private limited',
    'Psk mineral developement private limited',
    'La tech exports pvt ltd',
    'Sureprint technologies private limited',
    'Goenka electric motor vehicles private limited',
    'Lisega india private limited',
    'Dsk rushabh equipments private limited',
    'Aries india earthmovers private limited',
    'JBM EXHAUST SYSTEMS PRIVATE LIMITED',
    'Cenerg global tools private limited',
    'Span technologies private limited',
    'Bhagyashree engineering private limited',
    'Balaji aluminium extrusions private limited',
    'Mohanlal jewellers private limited',
    'Beda flow systems private limited',
    'Eepos fine rail systems india private limited',
    'Bf elbit advanced systems private limited',
    'Koshala udyog private limited',
    'Neera pumps & valves private limited',
    'O.k. enterprises private limited',
    'Gold range castings private limited',
    'Tuli international private limited',
    'Polo patine leisure private limited',
    'Poona couplings pvt ltd',
    'ALFA LAVAL INDIA PRIVATE LIMITED',
    'Jayshree pistons private limited',
    'Raj mechatronix private limited',
    'Poonawalla stud farm private limited',
    'Valiant-tms systems private limited',
    'Enco engineers combine (plant ii) private limited',
    'Ciciko office machines pvt ltd',
    'Kejriwal computers ltd.',
    'Ramtech software solutions private limited',
    'Syscomp impex pvt. ltd.',
    'Softweb technologies private limited',
    'Macro tech equipment private limited',
    'Austen hadfield manufacturing company private limited',
    'Sh haryana wires limited',
    'Bansal wire industries limited',
    'Spectra lead metals private limited',
    'Kundan metals private limited',
    'Nippon rika gr (india) private limited',
    'Raina agrico private limited',
    'Yashwant industrial works pvt ltd',
    'HINDUSTHAN TECHNOLOGIES PRIVATE LIMITED',
    'Compact lamps private limited',
    'Anchemco limited',
    'DAVID BROWN GEAR SYSTEMS INDIA PRIVATE LIMITED',
    'Niumec engineering private limited',
    'Rajyog engineering private limited',
    'Akashganga constructional machines private limited',
    'Kalyani strategic systems limited',
    'Siva equipment private limited',
    'Suncare pharmaceuticals private limited',
    'Hob nob electronics private limited',
    'JAINCO RUBBER INDUSTRIES PRIVATE LIMITED',
    'Cooper gaskets pvt ltd',
    'Grm met mash projects private limited',
    'Shailaum machine manufacturers private limited',
    'Voyager electronics india private limited',
    'Sumeru microwave communications private limited',
    'Goa resistors private limited',
    'Kushang technologies limited',
    'Nanakkripa electronics private limited',
    'Sna power engineering private limited',
    'Verifone india sales private limited',
    'Ostberg india private limited',
    'Hetronic systems india private limited',
    'Novus innovations private limited',
    'Positronics pvt ltd',
    'Alba urmet communication and security private limited',
    'A j m tools private limited',
    'Suncity sheets private limited',
    'Northern electrocom private limited',
    'Xenitis infotech (electronics) private limited',
    'Automotive manufacturers private limited',
    'Lawa fasteners private limited',
    'Thriam moulds and dies private limited',
    'Victora auto private limited',
    'Marshall auto industries limited',
    'Clearplus india private limited',
    'Jaycee autofab private limited',
    'ADMACH AUTO INDUSTRIES INDIA PRIVATE LIMITED',
    'P.r. components private limited',
    'Laxmi auto industries pvt ltd',
    'Thaparsons autos pvt ltd',
    'Emson gears limited',
    'Crown technologies private limited',
    'Securico electronics india limited',
    'Salgaocar marine private limited',
    'Three bees shipping private limited',
    'Orissa stevedores ltd',
    'Brand india real estate private limited',
    'Ten on ten habitat private limited',
    'Lord krishna realinfra private limited',
    'Uninav developers private limited',
    'Lake view properties pvt ltd',
    'Sgbc owners association pvt ltd',
    'Jams builders pvt ltd',
    'Evergreen developers pvt ltd',
    'P p promoters pvt ltd',
    'Model estates pvt ltd',
    'Amicus real estate pvt.ltd.',
    'Pritam niket pvt.ltd.',
    'Ujwala estates private limited',
    'Awesome promoters private limited',
    'Adishakti promoters private limited',
    'Udayan realty (india) limited',
    'Sonam complex private limited',
    'Malhotras trading co pvt ltd',
    'Himalay promoters pvt ltd',
    'Adinath investment and trading co ltd',
    'Lansdown properties ltd',
    'Samaira construction private limited',
    'Aabharan properties private limited',
    'Bhagirathi estates pvt ltd',
    'Ubber buildcon private limited',
    'Malbros international private limited',
    'ASKA REAL ESTATE PRIVATE LIMITED',
    'Vardhman buildcon private limited',
    'Sikka heights private limited',
    'Sikka homes private limited',
    'Sangla properties private limited',
    'Futurevision properties private limited',
    'Sikka infra planet private limited',
    'Nirvana infradevelopers private limited',
    'Ivalue advisors private limited',
    'Sikka infraheights private limited',
    'Sikka superb spaze private limited',
    'Jms buildtech private limited',
    'Kef company calicut property services private limited',
    'Tangible estates private limited',
    'Amber realty private limited',
    'Ashrita developers private limited',
    'Nirmala enclave private limited',
    'Niak turn-key project private limited',
    'I e s properties ltd',
    'Pragati properties pvt ltd',
    'Chandrima holdings pvt.ltd.',
    'Ganapati housing pvt ltd',
    'South calcutta diesels private limited',
    'Aakancha properties private limited',
    'Kumbagold holdings private limited',
    'Apsara housing private limited',
    'Tasu estate private limited',
    'Tribune commerce private limited',
    'Onkar bearing private limited',
    'Sa realcon private limited',
    'Msa infrastructure private limited',
    'Cygnus developers (india) private limited',
    'Starpoint properties private limited',
    'Abhilasha plaza private limited',
    'Funidea projects private limited',
    'Goodpoint estates private limited',
    'Esm maintenance and services private limited',
    'AMBIENCE CITY DEVELOPERS PRIVATE LIMITED',
    'J.s.b. buildwell private limited',
    'Green bay infrastructure private limited',
    'Trident infrahomes private limited',
    'Dadu developers pvt ltd',
    'Manobal construction private limited',
    'Sikka projects private limited',
    'Unnati nirman private limited',
    'SHEO FINANCE & AUTOMOBILES PVT LTD',
    'Nei properties ltd.',
    'Kamdhenu lefins pvt ltd',
    'Niladri holdings private limited',
    'Mangalam niket private limited',
    'Chopra nirman private limited',
    'Pearl carzonrent private limited',
    'Welspun global brands limited',
    'SAMRAJ POLYTEX LIMITED',
    'Iris computers limited',
    'Icreon communications private limited',
    'Trend consultants private limited',
    'Unify technologies private limited',
    'Cybest solutions private limited',
    'Infocom consultancy services private limited',
    'Leela software solutions private limited',
    'MYRRA FMCG INDIA PRIVATE LIMITED',
    'Setron india private limited',
    'Silicon micro systems (india) private limited',
    'Infozech software private limited',
    'Navisite india private limited',
    'Silvertone info systems private limited',
    'Rushi mandup specialities limited',
    'COMPREHENSIVE AIRCON SERVICES PRIVATE LIMITED',
    'T i infotech private limited',
    'Hisar infotech private limited',
    'Shiv shakti softech private limited',
    'Nistha infotech private limited',
    'Ariose software private limited.',
    'Nirman software private limited',
    'Arrive technologies private limited',
    'P s infoplanet private limited',
    'Jhilmil construction private limited',
    'Eskar properties private limited',
    'K v developers private limited',
    'Eco infra estate private limited',
    'Ayushmati constructions private limited',
    'Sanjukta properties private limited',
    'ILD HOUSING PROJECTS PRIVATE LIMITED',
    'V s townplanners private limited',
    'Ras software solutions private limited',
    'Nakoda cotton industries private limited',
    'Alliance embroidery private limited',
    'Progressive corrugated fiberboard private limited',
    'Gokalchand rattanchand woollen mills pvt ltd',
    'Vaibhav yarn mills private limited',
    'Chopco fashions private limited',
    'H.j.fashions private limited',
    'Shloka designs private limited',
    'TEN LETTER WORD ENTERPRISES PRIVATE LIMITED',
    'Vk global digital private limited',
    'Vallabh textiles company limited',
    'Castle apparels private limited',
    'SWARAJ SUITING LIMITED',
    'SRINIKETAN FASHIONS LIMITED',
    'Pot pourrie creations private limited',
    'Dotman press private limited',
    'Unicorn books private limited',
    'Samanvay advertising and communications private limited',
    'Sree mudranalaya technology pvt ltd',
    'Vk global publications private limited',
    'They india private limited',
    'Thomson press india ltd',
    'Moorthy offset printers private limited',
    'J THOMAS TRADING & INVESTMENTS PVT LTD',
    'Mtc publishing limited',
    'CG COAL AND POWER PRIVATE LIMITED',
    'Mujeeb sons exports private limited',
    'S-cci india private limited',
    'Dudheria tex tile pvt. ltd.',
    'Heritage mercantile pvt ltd',
    'Qs adhesives india private limited',
    'Sbm paints private limited',
    'J.G.CHEMICALS LIMITED',
    'Ace oilchem private limited',
    'Alsen industries private limited',
    'Yamuna lubricants private limited',
    'A i c chemicals private limited',
    'Isovolta (india) pvt ltd',
    'Hitech plastochem udyog private limited',
    'Bengal processing mills pvt ltd',
    'Solaris chemtech industries limited',
    'Deccan mechanical and chemical industries private limited',
    'Samruddhi industries limited',
    'Chemisol india pvt.ltd.',
    'Shakti distilleries private limited',
    'Timpack pvt ltd',
    'Anand epoxies ltd',
    'Kaushik orthopaedic private limited',
    'D k creations private limited',
    'Silverstar fashions private limited',
    'Kapsons apparels india private limited',
    'Universal medicap limited',
    'JFL LIFE SCIENCES LIMITED',
    'Arihantanam lifecare private limited',
    'Penam laboratories limited',
    'Future101 design private limited',
    'Paramount chemtech private limited',
    'Proton pharma private limited',
    'Saroj international leathers private limited',
    'Mayor overseas private limited',
    'Tirupati jars private limited',
    'Synbiotics limited',
    'B g p healthcare private limited',
    'PREMIER PLASMOTEC PRIVATE LIMITED',
    'Lorom india corporation private limited',
    'Lakhani belmaks ispat gadwal limited',
    'Shakun appliances private limited',
    'Beiersdorf (india) private limited',
    'Spell organics limited',
    'Protech bio systems private limited',
    'Popular biotech private limited',
    'GENO PHARMACEUTICALS Private Limited',
    'SECUNDERABAD PRINTED CARTONS LIMITED',
    'Mayur reeds and healds private limited',
    'Roli books private limited',
    'Jagjit publishing company private limited',
    'Khappa coal company private limited',
    'Bharati newspapers private limited',
    'Nirma chemical works private limited',
    'Radhey healthcare private limited',
    'Crc india manufacturing and distributors private limited',
    'Destiny hi-tech medicines private limited',
    'Saurashtra acetylene pvt ltd',
    'Assam surfactants private limited',
    'Greenland paper mills limited',
    'K t m l pack private limited',
    'Ultima hygiene products private limited',
    'National tyre and rubber co of india ltd',
    'Saltee infotex (india) private limited',
    'Velvin packaging private limited',
    'Ravlak technologies private limited',
    'Pragati offset private limited',
    'T k rubber industries pvt ltd',
    'Smj venture private limited',
    'Schoeller allibert time materials handling solutions limited',
    'Stereokem private limited',
    'Yamuna synthetics private limited',
    'Titanium mineral products limited',
    'DE SAGACIOUS ALLIANCES PRIVATE LIMITED',
    'Prime telerad providers private limited',
    'Rajdhani collections private limited',
    'N d biotech private limited',
    'Vishwambhar chemicals private limited',
    'Sigma container private limited',
    'Girnar extrusions pvt ltd',
    'Trillion plastics pvt ltd',
    'Saras plastics private ltd',
    'Gamma organics limited',
    'Nirma limited',
    'Simpolo vitrified private limited',
    'Delta buildwares private limited',
    'ADAPTIVE PRODUCTS AND SERVICES PRIVATE LIMITED',
    'J k technosoft limited',
    'Paras spices private limited',
    'Hathway channel 5 cable and datacom private limited',
    'Fly mobiles private limited',
    'Subir udyog ltd',
    'Faber capital private limited',
    'Rbl bank limited',
    'Seer buildwell private limited',
    'Evermore financial services private limited',
    'Green hawk solutions private limited',
    'Sd viewtrip holiday private limited',
    'Apshan logistics private limited',
    'Sea cargo logistics (india) private limited',
    'VIBRANT REALITY INFRA PRIVATE LIMITED',
    'Trenton investments company pvt ltd',
    'Mansukh financial private limited',
    'Evrro properties and finance pvt ltd',
    'Revro real estate and finance pvt ltd',
    'Attractive fin-lease private limited',
    'Mudita express cargo private limited',
    'Moongipa transport private limited',
    'Irc global limited',
    'Rameshwara estates pvt ltd',
    'J. thomas finance pvt. ltd.',
    'Vardhaman leasing and housing finance limited',
    'Jain vijay roadways pvt ltd',
    'Aura holdiings private limited',
    'Demuric holdings pvt ltd(tr co from maharashtra)',
    'Pallonji leasing pvt limited',
    'Ag venture capital private limited',
    'Treff travel team private limited',
    'Shivji taxcon chits private limited',
    'Manipal chit fund private limited',
    'Martin burn constructions limited',
    'Ifci venture capital funds limited',
    'Freedom air services private limited',
    'Universal weather and aviation india private limited',
    'Bajaj auto holdings limited',
    'Alpak investments pvt ltd',
    'KAANCHI JEWELS PRIVATE LIMITED',
    'SYNERGY SHAKTHI RENEWABLE ENERGY Private Limited',
    'Katha tours private limited',
    'Plan your trip (india) private limited',
    'Emmay logistics (india) private limited',
    'Exceptional escapes travel private limited',
    'Maan capital services private limited',
    'UNITED INVESTMENT & TRADING CO PVT LTD',
    'BHARAT ROADWAYS KTT LIMITED',
    'Subhankar investment consultants private limited',
    'Sona gold agrochem private limited',
    'Savitri projects and management consultants limited',
    'Yield securities and credits private limited',
    'Crest finvest private limited',
    'Shrinath tourism private limited',
    'Marck securities private limited',
    'Diva jyote portfolios private limited',
    'Tips & target portfolios private limited',
    'Bedrock venture management private limited',
    'PRICOL TRAVEL PRIVATE LIMITED',
    'Himalaya trans - logistics private limited',
    'Liquid paper finserve private limited',
    'Agrawal investment & capital services private limited',
    'Megafin investments pvt ltd',
    'Avadh credit and lease limited',
    'Bajoria viniyog pvt ltd',
    'J m d infin private limited',
    'Bajrang viniyog pvt ltd',
    'Winnage insurance brokers private limited',
    'BENGAL ISHA INFRASTRUCTURE PRIVATE LIMITED',
    'Shub labh projects pvt ltd',
    'Aska investments pvt ltd',
    'WEGROW FINANCIAL SERVICES PRIVATE LIMITED',
    'Franco-indian holdings private limited',
    'Asian capital market ltd.',
    'Cliff finvest private limited',
    'Stanfab engineering pvt ltd',
    'Rajmahal trade and investments private limited',
    'DIAMONDITE MARKETING PRIVATE LIMITED',
    'Polytronics holdings private limited',
    'Star car consultants private limited',
    '5paisa Capital Limited',
    'Cottage industries aid pvt ltd',
    'Eman holdings private limited',
    'Hudson insurance brokers private limited',
    'ROYAL SUNDARAM GENERAL INSURANCE CO. LIMITED',
    'Foresight capital trust private limited',
    'Vikas surya buildwell private limited',
    'Thirty six realtech private limited',
    'Kantawalla estate and developers private limited',
    'KDC NIRMAN LIMITED',
    'FORTUNA COPIA ESTATE PRIVATE LIMITED',
    'Unitech builders limited',
    'Regency land and lease holdings private limited',
    'Ferromar shipping private limited',
    'Sterling transship limited',
    'Olympus realtors private limited',
    'Ireo private limited',
    'Uv realtors private limited',
    'Somerville developers limited',
    'Sunstar buildwell private limited',
    'Solitaire projects private limited',
    'Vibhor vaibhav infrahome private limited',
    'LECTRIX EV PRIVATE LIMITED',
    'Zexus air services private limited',
    'SUNLIGHT INFRA ENERGY PRIVATE LIMITED',
    'Rbg financial services private limited',
    'Venture quotient advisors private limited',
    'D v real estate private limited',
    'Nilaya infra private limited',
    'H.d.seeds farm private limited',
    'LUXMI TEA CO Private Limited',
    'Nilgiri plantations ltd',
    'Festival traders ltd',
    'Biotech plantations private limited',
    'Lakhotia agro industries pvt ltd',
    'Urban hi-breed farm ltd',
    'Radikal agrotech private limited',
    'Noble agro biotech private limited',
    'Western india agriculture logistic warehousing private limited',
    'New agro developers private limited',
    'Ganesh laxmi rice mills private limited',
    'Vaishali agri ventures private limited',
    'Champion agro world private limited',
    'Efresh farmers development centre private limited',
    'Sima textile processing centre limited',
    'Kulwant timbers private limited',
    'Advent greens private limited',
    'Krishna decor pvt ltd',
    'Hanu kripa ispat private limited',
    'Ulka sea foods private limited',
    'H.j.s. commercial private limited',
    'HINDAGE OILFIELD SERVICES LIMITED',
    'Dolphin extrusions private limited',
    'Dolphin ore extraction private limited',
    'Ace minerals company private limited',
    'Bharat minex private limited',
    'Sesa resources limited',
    'Madhucon granites limited',
    'Jyoti minerals private limited',
    'Scantling granite limited',
    'Shivgyan mines and minerals private limited',
    'Goyal marbles private limited',
    'SRI SUBRAMANYA MINES & MINERALS LIMITED',
    'SRI SWAMINATHA MINES & MINERALS LIMITTED',
    'Shree ram krishna stonex private limited',
    'G.D.ASSOCIATES PRIVATE LIMITED',
    'R.s.triveni foods private limited',
    'Jrs india corporation private limited',
    'Makarwa foods private limited',
    'Snofield foods pvt ltd',
    'Poonam biscuits private limited',
    'Kyaboni lokenath rice mill private limited',
    'Hi-pro cereal foods private limited',
    'Himalayan feed manufacturing company pvt ltd',
    'I.g.international private limited',
    'Freaking amazing foods private limited',
    'Wave fresh private limited',
    'Kotghei winery private limited',
    'Elwin foods private limited',
    'H & k eatery products private limited',
    'Sunrise biscuit company private limited',
    'Jaipuria cosmetics private limited',
    'Trdp happy world private limited',
    'Holdwell distributors pvt.ltd.',
    'Himalaya wine company private limited',
    'Coastal breweries private limited',
    'RAMCHARAN FOOD INDUSTRIES PRIVATE LIMITED',
    'TROUBLESOME DUO KITCHENS PRIVATE LIMITED',
    'Apeksha gourmet jar private limited',
    'RAJESH MOTORS (CARS) PRIVATE LIMITED',
    'Himalayan spirits limited',
    'Globus spirits (jharkhand) limited',
    'Patel beverages private limited',
    'Asian tea company private limited',
    'India cigar company private limited',
    'Sadguru cotton private limited',
    'Arviva industries (india) limited',
    'Adarsh marmo granites private limited',
    'Asiatic construction co pvt ltd',
    'Prima products private limited',
    'Sulochana cotton spinning mills private limited',
    'Coimbatore polytex private limited',
    'Pgc industries private limited',
    'Shri siddhi vinayaga tex india private limited',
    'Mani spinning mills private limited',
    'Aarti steels limited',
    'Longowalia yarns limited',
    'GANGA ACROWOOLS LIMITED',
    'Sallo trading company private limited',
    'Vijay mining & infra corp private limited',
    'Bharat coking coal limited',
    'Lakshmi horticulture private limited',
    'Organization for skill and entrepreneurial development for agriculture and allied sectors',
    'Zeal organosys private limited',
    'Roopuday agrotec private limited',
    'GRASS FIELD FARMS AND RESORTS PRIVATE LIMITED',
    'Prabhat agrochem private limited',
    'Riddhi processors private limited',
    'Gogia capital services limited',
    'Pnr capital services limited',
    'V p printxperts private limited',
    'Forever new apparels private limited',
    'Shreeji polyfab private limited',
    'Rimagine dzyns private limited',
    'Sml labels (india) pvt. ltd.',
    'SUVIDHI TEXTILES Private Limited',
    'New hosiery impex pvt ltd',
    'TIRUPATI RUGS PRIVATE LIMITED',
    'Fab craft industries private limited',
    'Morgan ventures limited',
    'Sidral food pvt ltd',
    'ULTIMATE TOWNSHIP INDIA PRIVATE LIMITED',
    'GDR FLOUR AND FOOD PRODUCTS PRIVATE LIMITED',
    'Jalan brothers pvt ltd',
    'Rameswara syntex ltd',
    'Gouripur textiles private limited',
    'Pgi distributors private limited',
    'Opulent fabric mills private limited',
    'Wingsfield knitwear private limited',
    'Ibshar holdings exim private limited',
    'Indolot marketing private limited',
    'V p bedekar and sons private limited',
    'Yamuna binimoy private limited',
    'Yogamaya binimoy private limited',
    'Radikal international private limited',
    'Radikal impex private limited',
    'Victora trading international private limited',
    'Vinayak binimoy private limited',
    'Trishul binimoy private limited',
    'Cherry trexim private limited',
    'SHRUTI AGRICULTURE & HOLDINGS PVT LTD',
    'STORIES GLOBAL HOMES PRIVATE LIMITED',
    'Jet-tech private limited',
    'Sis tradelink private limited',
    'BPN EDUCATION INDIA PRIVATE LIMITED',
    'Isbe exim private limited',
    'Nobel exim (india) private limited',
    'S a logistics private limited',
    'Soccer international private limited',
    'Ananta ortho systems private limited',
    'Avi impex private limited',
    'Good deals marketing private limited',
    'Adarsh multiflex private limited',
    'Associated soap stone distributing company private limited',
    'Pcp international limited',
    'Magus marketing pvt ltd',
    'Shreya marketing pvt ltd',
    'Balaji impex pvt ltd',
    'WINSUM SERVICES PRIVATE LIMITED',
    'Rollatainers niryat pvt ltd',
    'Wens export private limited',
    'Netlink business systems private limited',
    'Reliance expovision private limited',
    'Tack innovation (india) private limited',
    'Chandra mukhi goods pvt.ltd.',
    'Supreme commercial pvt. ltd.',
    'Prajyoti impex private limited',
    'Siliguri marketing private limited',
    'Spear networks private limited',
    'Scoper commercials private limited',
    'Raksha pipes private limited',
    'Svs exim private limited',
    'G.s.c. enterprises private limited',
    'R.s.c. enterprises private limited',
    'Lily commodities private limited',
    'Vasa commercial private limited',
    'Swadeshi tie-up private limited.',
    'Prb enterprises private limited',
    'Curtainman online private limited',
    'Active goods private limited',
    'Goodluck sales private limited',
    'KAMAL MASA SURFACE COATING ACCESSORIES PRIVATE LIMITED',
    'Medow solutions private limited',
    'Achiever dealcom private limited',
    'RESILIENT PROPERTIES PRIVATE LIMITED',
    'San landmark private limited',
    'Sree sabari infrastructures and constructions india private limited',
    'Bagkiya constructions private limited',
    'Msk real estates private limited',
    'Rishabh probuild private limited',
    'Enerfra projects ( india ) private limited',
    'NEOSINMAR DEVELOPERS PRIVATE LIMITED',
    'Vishal construction company private limited',
    'Nagarwalla enginering company private limited',
    'Eversmile construction co pvt ltd',
    'Technozone environmental solutions private limited',
    'Saarthak hi-tech home developers private limited',
    'Grand entertainment and event private limited',
    'ADANI NOBLE PRIVATE LIMITED',
    'Wow infra private limited',
    'HOLOSTIK PRINTPACK PRIVATE LIMITED',
    'Dhanesh enterprise private limited',
    'I4 KNOWLEDGE PROCESSING PRIVATE LIMITED',
    'Sona creations private limited',
    'Crystal towers private limited',
    'Merino towers private limited',
    'Sjr prime corporation private limited',
    'Paradigm integrated facility services private limited',
    'TRU WINDCHIMES PRIVATE LIMITED',
    'Sjr prime spectrum private limited',
    'K.kumar raja projects private limited',
    'B r developers private limited.',
    'Windoors international limited',
    'Nirmal lifestyle properties private limited',
    'Rnp scaffolding & formwork private limited',
    'Mbk logistix private limited',
    'Chellaram shipping private limited',
    'Ronak container and cargo logistics private limited',
    'C n sanghavi and company (forwards) private limited',
    'Associated global logistics private limited',
    'Tradex logistics (india) private limited',
    'Intercont freight liners private limited',
    'Starship freight private limited',
    'Royal translines pvt.ltd',
    'Contico shipping agency private limited',
    'Nyk shipmanagement (india) private limited',
    'On the move logistics private limited',
    'New india transline private limited',
    'Shreepa logistics private limited',
    'VISHNUSURYA PROJECTS AND INFRA LIMITED',
    'A 2 z logistics india private limited',
    'Estrat logistics private limited',
    'Mer cargo logistics private limited',
    'Ntc shipping services private limited',
    'Ispeed freight (india) private limited',
    'Eastern clearing and forwarding agency private limited',
    'Manik logistics private limited',
    'Suraj logistix private limited',
    'Shyamsunder transport co. private limited',
    'Golcha investment private limited',
    'Triple play telecom private limited',
    'Arinc india private limited',
    'Rajcomm communication systems private limited',
    'Sky televentures services private limited',
    'Vakils feffer and simons private limited',
    'Millenium broadcast company private limited',
    'Kadevi electronic systems private limited',
    'Lead communications private limited',
    'Royal welding wires private limited',
    'Gtpl parshwa cable network private limited',
    'Gl networks and systems private limited',
    'Tantra infosolutions private limited',
    'Bydesign india private limited',
    'Anr electronozix private limited',
    'Divox communications private limited',
    'Ceequence technologies private limited',
    'A-one biz solutions private limited',
    'Aps telecom services private limited',
    'Kor telesolutions private limited',
    'Beep private limited',
    'Micronova teleinfra private limited',
    'Ipdna communications and services private limited',
    'Nangalia fiscal services private limited',
    'BOAL FINANCIAL PRIVATE LIMITED',
    'Gaurav sashank bangalore financial ventures private limited',
    'Lakshmiraman investment & finance limited',
    'NIKUNJ FINANCIAL SERVICES LIMITED',
    'Shri krishna share brokers private limited',
    'JAIKA FINANCE Private Limited',
    'Kanak realtors and finance private limited',
    'SHREYAS MORAKHIA AND FAMIILY ASSETS PRIVATE LIMITED',
    'Nav developers limited',
    'Krishna bhima samruddhi local area bank limited',
    'Zen capital private limited',
    'P.k.investment pvt ltd',
    'SHANTHI AGROFARMS GLOBAL SERVICES PRIVATE LIMITED',
    'Grihastha finance limited',
    'National trust housing finance limited',
    'B.r. housing finance pvt. ltd.',
    'Tanna agro impex private limited',
    'MAGNILLIANT CONSULTANCY SERVICES PRIVATELIMITED',
    'Regsus commodity trade services private limited',
    'BRIJDEV REALTIES PRIVATE LIMITED',
    'John deere financial india private limited',
    'Brijwasi finance private limited',
    'Rohini finsec private limited',
    'PERIQUE PROPERTIES PRIVATE LIMITED',
    'KURLA TRADING CO PRIVATE LIMITED',
    'M p sanghvi investmens pvt ltd',
    'Neelammegha investment and trading co pvt ltd',
    'SANJIV SARITA CONSULTING PRIVATE LIMITED',
    'Ruarco investments p ltd',
    'Rhoda textiles private limited',
    'Adamji investments pvt ltd',
    'Samarkand investments private limited',
    'Rapid holdings pvt ltd',
    'Shaun holdings private limited',
    'Claymore investment pvt ltd',
    'Zulekha trading and finance private limited',
    'QUEST FIN-CAP PRIVATE LIMITED',
    'Accredut finance and investments private limited',
    'RICHFIELD TEXTILES PRIVATE LIMITED',
    'Classic infin limited',
    'Rns investment private limited',
    'Quant capital finance and investments private limited',
    'Proficient equities private limited',
    'Angelus chits private limited',
    'Vipanchi chit fund limited',
    'Ramesh chit funds private limited',
    'D n c chits private limited',
    'Caspian impact investments private limited',
    'Mitsurishi finance and securities ltd',
    'Riser holding private limited',
    'Parkar holdings private limited',
    'Exasense holdings private limited',
    'Saj leasing and finance private limited',
    'Jsw investments private limited',
    'Nilyam holdings private limited',
    'Innoweb technologies private limited',
    'Martin burn information technology pvt ltd',
    'Echo business solutions private limited',
    'Metalogic consulting india private limited',
    'Mylan pharmaceuticals private limited',
    'Mhl healthcare limited',
    'Centurion indus technology and science research',
    'Arya market research private limited',
    'Quantum consumer solutions private limited',
    'Kantar market research services private limited',
    'Mrca financial services (india) private limited',
    'Perspective consultants private limited.',
    'Strategic analysis (india) private limited.',
    'Dqs certification india private limited',
    'Seaward packaging limited',
    'Sona construction technologies private limited',
    'Rane engineers & surveyors private limited',
    'Mine pro communications private limited',
    'Kartbin online services private limited',
    'Knowledgeworks consulting india private limited',
    'Naga engineering and inspection private limited',
    'Mysource innoventures private limited',
    'Webbing solutions private limited',
    'Sanata consultants private limited',
    'Insignia tourism marketing private limited',
    'Synergy relationship management services private limited',
    '2s consulting private limited',
    'ORIENTAL INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED',
    'Aqf advisors private limited',
    'Anand mehta & associates consultants private limited',
    'XCHANGE LEASING INDIA PRIVATE LIMITED',
    'Int advisory council private limited',
    'R n safety services private limited',
    'Adarsh advisory services private limited',
    'PIONEER ASSURANCE CONSULTANTS PRIVATE LIMITED',
    'Shandar interior pvt ltd',
    'Indian institute of electronic business management private limited',
    'Ved-zen consultants private limited',
    'Rcs advisors (india) private limited',
    'Synergy infra consultants private limited',
    'Entech consultancy bureau (madras) private limited',
    'Rsjk project consultancy private limited',
    'Sankhyaa learning private limited',
    'Protean staffing private limited',
    'Conserve consultants private limited',
    'Nestech consulting private limited',
    'H n mukherjee and associates pvt ltd',
    'MEGA SHARE & STOCK LTD',
    'Anumati consultancy & services pvt. ltd.',
    'Viratech infomedia private limited',
    'Bkr consultants private limited',
    'Conem management consultants pvt ltd',
    'S JAYKISHAN CONSULTING PRIVATE LIMITED',
    'Orchid technical consultancy private limited',
    'Vivan infratel solutions private limited',
    'M. mukerjee mgmt. consultants private limited',
    'Aaa supports private limited',
    'Turbotech precision engineering private limited',
    'AGRISOL IDUKKI PRIVATE LIMITED',
    'IAV ENGINEERING & CONSTRUCTION SERVICES LIMITED',
    'Jasamrit engineering private limited',
    'Flexocon engineers private limited',
    'Mactenn engineering (india) private limited',
    'Empire tubewells private limited',
    'Virtual engineering services private limited',
    'Axis interiors pvt ltd',
    'POWSOL ADVISOORS LIMITED',
    'Nova sancoale services private limited',
    'Miyamoto design and engineering consultants private limited',
    'Smlxl-architecture and urban design private limited',
    'Symmetrics development services private limited',
    'Itech protomation & controls private limited',
    'Prorich shade systems private limited',
    'Travancore builders private limited',
    'Newkem engineers pvt ltd',
    'Ocean diving centre limited',
    'Kanchan engineering private limited',
    'Gouri engineering private limited',
    'Suyash metal pressings pvt ltd',
    'Electronic and engineering company (india) private limited',
    'H.j.thakur architects private limited',
    'Triplan aqua systems (india) private limited',
    'Prosares solutions private limited',
    'Anuprita engineering consultants private limited',
    'O AND M SOLUTIONS PRIVATE LIMITED',
    'Hydrotech engineers and consultants private limited',
    'Vastech consultants private limited',
    'Sonata design systems private limited',
    'Oneirix engineering laboratories private limited',
    'Vastu consultants and developers private limited',
    'SEPPASOLUTIONS PRIVATE LIMITED',
    'Automation and control technology india private limited',
    'Prosdek engineering solutions private limited',
    'Fujita engineering india private limited',
    'M.n. dastur & company (p) ltd.',
    'SCENTIDO PRIVATE LIMITED',
    'Yantriq systems private limited',
    'John deere india private limited',
    'Gm technical services private limited',
    'Signet communications private limited',
    'Entasis india private limited',
    'Innocean worldwide communication private limited',
    'Tv9 media maharashtra private limited',
    'Eastcoast processing private limited',
    'EKBOTE',
    'TRAINING CONSULTING GRID PRIVATE LIMITED',
    'Launch it consulting india private limited',
    'DATA PATTERNS (INDIA) LIMITED',
    'Smartnet technology private limited',
    'BRIDGE GLOBAL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Iasys technology solutions private limited',
    'Maybole technologies private limited',
    'BARCLAYS GLOBAL SERVICE CENTRE PRIVATE LIMITED',
    'Etc management services india private limited',
    'Salzer technologies limited',
    'One point it consulting private limited',
    'Proceed technologies private limited',
    'Edgeverve systems limited',
    'SMARTBEAR SOFTWARE INDIA PRIVATE LIMITED',
    'Chakra network solutions private limited',
    'Infonet comm enterprises private limited',
    'IOTA SOFTWARE & SERVICES PRIVATE LIMITED',
    'Igration technology solutions private limited',
    'Kanaka consulting private limited',
    'Magicworks it solutions private limited',
    'Maestrotech systems private limited',
    'Mobiona software solutions private limited',
    'Diggity solutions private limited',
    'Ficus knowledge softcon services private limited',
    'Ican infosoft private limited',
    'Phoenixgen systems private limited',
    'Greentech knowledge solutions private limited',
    'Cis it solutions private limited',
    'Moonscape technologies private limited',
    'Sudan technoprudent private limited',
    'Voxomos systems private limited',
    'Triffort technologies private limited',
    'Eejak technologies private limited',
    'Sycamore software solutions private limited',
    'Activelement software private limited',
    'Abbey business services (india) private limited',
    'Outsourced consulting and solutions private limited',
    'Vcidex solutions private limited',
    'Diya systems (mangalore) private limited',
    'Microstop infotech private limited',
    'Seven people systems private limited',
    'Xerago customer value maximization private limited',
    'Apple g web technology private limited',
    'Infrascale india private limited',
    'Sakaye infotech private limited',
    'SEERS DESIGN PRIVATE LIMITED',
    'Integrhythm (india) private limited',
    'Hyper thread solutions private limited',
    'Analance solutions private limited',
    'Infosoft global private limited',
    'Special rescue training academy private limited',
    'Sarvaang utkarsh foundation',
    'SINDOORI MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'Exactech india private limited',
    'Medwonders health network private limited',
    'Vasantha subramanian hospitals india private limited',
    'Orane healthcare india private limited',
    'Quadra health technologies private limited',
    'Sukriti agro private limited',
    'Peanuts solar water heater private limited',
    'JEDIV CARGO MANAGEMENT PRIVATE LIMITED',
    'VH MEDCARE PRIVATE LIMITED',
    'Healthway hospitals private limited',
    'Logica infotech services private limited',
    'Gliese consulting private limited',
    'Spirit of math schools india private limited',
    'Grooming babies global private limited',
    'Teachaclass (tac) foundation.',
    'Ramakrishna hospitals private limited',
    'Nandhini builders private limited',
    'Design core (india) private limited',
    'A.j.hotels(india) private limited',
    'Jyothi gas private limited',
    'CHINMAYEE ESTATE DEVELOPERS & FINANCE PRIVATE LIMITED',
    'Dhanalakshmi property developers private limited',
    'Stellar management consultants private limited',
    'Belfast agency private limited',
    'FOUNDATION FOR REPRODUCTIVE HEALTH SERVICES INDIA',
    'Worksure medpharma consultancy india private limited',
    'Cetas healthcare private limited',
    'AZEFAST TECHNOLOGIES PRIVATE LIMITED',
    'Phaneesh hospitals private limited',
    'Thyrocare technologies limited',
    'Life care bio-medical private limited',
    'Reliance foundation',
    'Kalp cancer foundation',
    'Ponnani yoga and naturopathy health resort private limited',
    'My 30 minutes limited',
    'Sudar surgical private limited',
    'HEXEL REALTORS PRIVATE LIMITED',
    'Zen hygiene private limited',
    'Piramal udgam data management solutions',
    'Il&fs academy of applied development',
    'Health and hygiene waste management solutions private limited',
    'Mhealth ventures india private limited',
    'Sanity life-sciences private limited',
    'Neo west health private limited',
    'The british institute of engg technology (india) private limited',
    'D b mahajan education foundation',
    'Varuni healthcare private limited',
    'Career endeavour academy private limited',
    'Cats academy india private limited',
    'Udayan education private limited',
    'K.S.INSTRUMENTS PRIVATE LIMITED',
    'Evangelical trust association of south india.',
    'Hotel and restaurant association (western india)',
    'Sife india',
    'Eye tv network private limited',
    'Colourbars films private limited',
    'Hcv digital entertainment private limited',
    'Mad entertainment limited',
    'Venkateswara essencess and chemicals private limited',
    'Radhakrishna multi speciality hospital private limited',
    'Imetrix vision technology india private limited',
    'Anak exports private limited',
    'Yuva animation studios private limited',
    'Emi solutions private limited',
    'Introduction trade shows private limited',
    'Sahaya holistic integrative hospital private limited',
    'Encompass events pvt. ltd.',
    'Kannan advertising service private limited',
    'Al madeena institute of medical science private limited',
    'Sna ayurveda nursing home private limited',
    'Esaf health care services private limited',
    'Neo sports broadcast private limited',
    'Unventured expeditions private limited',
    'WINGMAN PICTURES PRIVATE LIMITED',
    'Ankita chugh weddings and events private limited',
    'Assam bengal navigation company private limited',
    'Kinder womens hospital and fertility centre private limited',
    'Samudra health care enterprises limited',
    'Archana hospitals private limited',
    'Ajara health care and research centre private limited',
    'Kitex herbals limited',
    'Bop consultants private limited',
    'Dkt healthcare india private limited',
    'Prime healthcasre products limited',
    'Matchbox films private limited',
    'Bergen engines india private limited',
    'Advanced neuro- science allies private limited',
    'Vadain sampark',
    'Biologic science instruments private limited',
    'Maya digital media private limited',
    'Third eye integrated services private limited',
    'Oceanus offshore services private limited',
    'Dr. agravat healthcare limited',
    'PCOC INFRA PRIVATE LIMITED',
    'I c b i (india) private limited',
    'Social seva initiatives private limited',
    'Cargo care international private limited',
    'Idealquality engineers (india) private limited',
    'Ap fin eng services (india) private limited',
    'Suryatej infratech private limited',
    'Swati airport support services private limited',
    'The eimco-k.c.p. limited',
    'Electro optics private limited',
    'Amar autotech private limited',
    'Sameer auto pvt ltd',
    'Sigma galvanizing pvt ltd',
    'Shivapriyadarshini castings private limited',
    'BALCKE-DUERR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Gamson india private limited',
    'Imco alloys private limited',
    'Jifcon tools pvt ltd',
    'Ges polymers private limited',
    'Lala pipes private limited',
    'Sri varahiamman steels private limited',
    'Shree krishna induction private limited',
    'Shree mahavir metalcraft private limited',
    'Peenya engineering company private limited',
    'Innovative technomics pvt ltd',
    'Natasha fin tubes private limited',
    'Anand engineering products private limited',
    'Vasthi engineers private limited',
    'Binjrajka steel tubes limited',
    'Re- bar couplers india (pvt) limited',
    'Sanghavi industries private limited',
    'Meghdoot refrigeration services private limited',
    'Dadawala ispat pvt ltd',
    'Precision metal products private limited',
    'Texas instruments (india) private limited',
    'Fore vision instruments (india) private limited',
    'Sigma punch forms private limited',
    'Raviraj hi-tech private limited',
    'Hydro pneumatic accessories (india) private limited',
    'Coronet engineers private limited',
    'Jay pumps private limited',
    'Dint-tech control private limited',
    'Polycraft puf machine private limited',
    'VENTIL FLOWSERVE PRIVATE LIMITED',
    'Vt vacuum technologies private limited',
    'Shreeji environmental engineering private limited',
    'Green pumps and equipments private limited',
    'H p valves & fittings india private limited',
    'Fluid pumps and equipment india private limited',
    'Sarathy geo-tech and engineering services private limited',
    'Scantech laser wave private limited',
    'Matcon engineers india private limited',
    'Shreepriya auto parts private limited',
    'Ih engineered elements private limited',
    'Esp engineered components private limited',
    'K.l.n.engineering products private limited',
    'Saw tech private limited',
    'Nandi tmt bars private limited',
    'Mobi cast private limited',
    'Aarav steel projects private limited',
    'Rajeshwari metallurgicals private limited',
    'R n r processor private limited',
    'Dhananjay industrial engineer private limited',
    'Advance technoforge private limited',
    'Mundeth fittings private limited',
    'SABEETHA ROOFING INDIA PRIVATE LIMITED',
    'TRI PATH PROPERTIES PRIVATE LIMITED',
    'SHIVKRUPA FABRICON LIMITED',
    'Rohit spring forms private limited',
    'Chemin springs india private limited',
    'Rainbow fabricators private limited',
    'Assomet industries pvt ltd',
    'Akvalo instruments private limited.',
    'SPAN FILTRATION SYSTEMS PRIVATE LIMITED',
    'C doctor india private limited',
    'Quality engineering(baroda)pvt ltd',
    'M bhogilal engineers pvt ltd',
    'Petrotec-retail petroleum equipment (india) pvt ltd',
    'J-pack engineers private limited',
    'Syringa engineers private limited',
    'Ureatac india private limited',
    'Snam abrasives private limited',
    'Auditra engineering company private limited',
    'Ugam beam science private limited',
    'Fujilloy india private limited',
    'Kolben hydraulics limited.',
    'Shreesamarth tech process engineering private limited',
    'S. d. material handlers private limited',
    'Powergate energy (mysore) private limited',
    'Cooper elevators india private limited',
    'Mega cranes (india) private limited',
    'Ultra airtech private limited',
    'Neo tech energy systems private limited',
    'Radiant hitech eng. private limited',
    'Filter machines private limited',
    'Turbokopar industries india private limited',
    'Deutsch india power connectors private limited',
    'Shakthi tech manufacturing india private limited',
    'Nisiki technologies private limited',
    'TAN SWA TECHNOLOGIES PRIVATE LIMITED',
    'Himenviro-fuji singapore elevators private limited',
    'Advanced systems sampling private limited',
    'Eco chimneys private limited',
    'Amron associates private limited',
    'Hi-tech elevators private limited',
    'Shakti equipments private limited',
    'United crane components private limited',
    'Omntec waaree atg pvt. ltd.',
    'Associated equipment rentals private limited',
    'Drishti marine solutions private limited',
    'Hercules agencies private limited',
    'Twice digitale private limited',
    'Ab presstech machineries private limited',
    'Electronic and engineering services private limited',
    'Rishraj trading and investments private limited',
    'Crg multitrade private limited',
    'Pec therm private limited',
    'Couple international private limited',
    'Indiska india export services private limited',
    'Bhagyalaxmi general trading private limited',
    'Vks texports private limited',
    'Lakris impex private limited.',
    'Ankur clearing agency private limited',
    'Primo commodities exim private limited',
    'Nathani international private limited',
    'Sterling exports pvt limited',
    'Ahmed b zakaria and sons private limited',
    'Chandragupta traders private limited',
    'Assam nezone network private limited',
    'Class one systems solutions & technology private limited',
    'Sew services private limited',
    'Prabhath i.t.solutions private limited',
    'Durga scientific private limited',
    'Oceancatch marketing private limited',
    'Shri siva marketing agencies private limited',
    'Blue bell drinks pvt. ltd.',
    'MOHSIN ENTERPRISES PRIVATE LIMITED',
    'Aswati foodkrafts private limited',
    'Quilon foods private limited',
    'Shivamy tradexim private limited',
    'Prabhu marketing services private limited',
    'PRAJESH REALTIES PRIVATE LIMITED',
    'Naath exim (india) private limited',
    'Millennium aero dynamics private limited',
    'Star galaxy trades private limited',
    'Bhishma realty limited',
    'Woodward impex private limited',
    'Lokumal kishinchand exports private limited',
    'Hamsafar vanijya pvt ltd',
    'Luv-kush traders pvt ltd',
    'Vikas overseas private limited',
    'MAXSTAR APPLIANCE LIMITED',
    'Shri balaji presses private limited',
    'Gandt total energy services private limited',
    'Progressive infotech private limited',
    'Honda trading corporation india private limited',
    'Mckay exim private limited',
    'Curzon trade private limited',
    'Snb overseas private limited',
    'AGWAY SALESMART MARKETING SOLUTIONS LIMITED',
    'Bijon trading pvt ltd',
    'K rise retails private limited',
    'Al-gyas exports private limited',
    'Papeyon exports private limited',
    'PLATINUM PAINTING ESSENTIALS & TRADING PRIVATE LIMITED',
    'M.r.a.enterprises private limited',
    'Emotoeast technology private limited',
    'Ldev ideas private limited',
    'Zing acnr private limited',
    'Reliable automotive private limited',
    'Enkie international private limited',
    'K h t agencies private limited',
    'Jagriti suppliers private limited',
    'Vaghasia limited',
    'Supermarket grocery supplies private limited',
    'Samay impex private limited',
    'Kalpataru aluminiums private limited',
    'Prabhanjan multitrade private limited',
    'Touchline trading private limited',
    'Aaron fine chemicals private limited',
    'Mangaldeep holding and trading private limited',
    'Motivi pharmaceuticals private limited',
    'R b masturalal and sons private limited',
    'Alphavector (india)private limited',
    'Mrsp consultants private limited',
    'Bigt exim international private limited',
    'Sanmur controls pvt ltd',
    'Noah exim and realtors limited',
    'Al fifa trading & marketing private limited',
    'Goel brothers and company private limited',
    'Basuki sales and services private limited',
    'Pranav consumer solutions private limited',
    'Modi private limited',
    'Neville wadia private limited',
    'Tribol lubricant private limited',
    'Artic international private limited',
    'Pudu lifestyle products private limited',
    'Mesdan india private limited',
    'Rajrishi exports ltd',
    'Ottimo international private limited',
    'Brightvision international private limited',
    'Impart services private limited',
    'Mindsprings (india) private limited',
    'Sound. com private limited.',
    'Zara security solutions private limited',
    'G.f. brothers exim private limited',
    'Tone dealings private limited',
    'Numinous impex india private limited',
    'Navyug enterprises pvt ltd',
    'Jai tulshi trexim private limited',
    'Sahastra sales private limited',
    'Suryajyoti vanijya and viniyog private limited',
    '3A TRADING AND LOGISTICS PRIVATE LIMITED',
    'Brahmi wright technologies private limited',
    'Intercad systems private limited',
    'Spigot software private limited',
    'Specadel technologies private limited',
    'Gm insights solutions private limited',
    'CAVALIER ANIMATION & TECH PRIVATE LIMITED',
    'NEXUS MYSORE RETAIL PRIVATE LIMITED',
    'Micrologic integrated systems private limited',
    'Sun plus software technologies private limited',
    'Deemtek systems india private limited',
    'Mfiflex technologies private limited',
    'Kirti integrated solutions india private limited',
    'Asarva chips & technologies private limited',
    'Ideacrest solutions private limited',
    'Exinent info solutions private limited',
    'Smartedge it services private limited',
    'Meenu developers private limited',
    'Itecsys technologies private limited',
    'Datamate info solutions private limited',
    'Vitalect technologies india private limited',
    'Sahi oretrans private limited',
    'Kp logistics private limited',
    'Nuwave esolutions private limited',
    'Solitaire powertech private limited',
    'Whitebox computer services private limited',
    'Vani rachana softwares private limited',
    'Hamt consultants private limited',
    'Process nine technologies private limited',
    'GTPL KAIZEN INFONET PRIVATE LIMITED',
    'JYT CAPITAL PRIVATE LIMITED',
    'QSOL SOFTWARES PRIVATE LIMITED',
    'DBL UCHERA - NAGOD TOLLWAYS LIMITED',
    'NOBILITY ENGINEERS & CONTRACTORS PRIVATE LIMITED',
    'RANA & JOSHI BUILDTECH PRIVATE LIMITED',
    'ENIZE INFOTECH PRIVATE LIMITED',
    'Viznar Technocrafts Private Limited',
    'Capstone business solutions private limited',
    'MACCUS MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'MORPHOGENE BIOTECH PRIVATE LIMITED',
    'SAGAR AUTOTECH (MYSORE) PRIVATE LIMITED',
    'WEBVILLEE TECHNOLOGY PRIVATE LIMITED',
    'ANAND CARS PRIVATE LIMITED',
    'DMC DIGITAL MARKETING & IT CONSULTANTS PRIVATE LIMITED',
    'STREAM TELEVENTURES PVT.LTD. (OPC)',
    'New Horizons Marketing Solutions Private Limited',
    'SRS Valutech Systems Private Limited',
    'BALENO INDIA TRAVELS PRIVATE LIMITED',
    'Verna Logistics Park Private Limited',
    'Wagholi Logistics Park Private Limited',
    'Tamilnadu Logistics Park Private Limited',
    'BHAVANA SEVENET LIMITED',
    'Oxfordshire Capital Private Limited',
    'GOODLUCK STAINLESS PRIVATE LIMITED',
    'YELLOW SAPPHIRE HOLDINGS PRIVATE LIMITED',
    'OMNI SECURITIES AND COMMERCIALS PRIVATE LIMITED',
    'COMPUTECH SHARECAP LIMITED',
    'Fortitude Securities Private Limited',
    'KENWORTH FINSERV PRIVATE LIMITED',
    'Hind Shipping Line Private Limited',
    'Shipeasy Logistics Private Limited',
    'SIMON BROTHERS P.LTD.',
    'JCS International Logistics Private Limited',
    'M PLUS PARKING SERVICES PRIVATE LIMITED',
    'RELIABLE CABS SERVICES PRIVATE LIMITED',
    'KRITDEEP PROPERTIES PRIVATE LIMITED',
    'My Cute Office Private Limited',
    'Falcom Realty Private Limited',
    'Podar Properties Private Limited',
    'Sheth Realtors and Holdings Private Limited',
    'Sheth Creators and Holdings Private Limited',
    'Platinum Infradevelopment Private limited',
    'YIELD VALUE STRUCTURES PRIVATE LIMITED',
    'STALLIONS PROPTECH SOLUTIONS PRIVATE LIMITED',
    'Red Poppy Premises Private Limited',
    'Tanzanite Properties Private Limited',
    'Godrej Home Developers Private Limited',
    'Godrej Hillside Properties Private Limited',
    'Valator Developers Private Limited',
    'GODREJ HOME CONSTRUCTIONS LIMITED',
    'TRANQUIL ESTATE PRIVATE LIMITED',
    'GCORP TOWNSHIP PRIVATE LIMITED',
    'Godrej Greenview Housing Private Limited',
    'Gamut Holdings Private Limited',
    'True House Property Developers Private Limited',
    'CALLALILY PREMISES & ADVISORY PRIVATE LIMITED',
    'SILVER CONSTRUCTION CORPORATION PRIVATE LIMITED',
    'AMORA REALTORS PRIVATE LIMITED',
    'TECHWIN REALTORS BUILDWELL PRIVATE LIMITED',
    'DEV INTERNATIONAL PROJECTS PRIVATE LIMITED',
    'DOIT SMART HOUSING (INDIA) PRIVATE LIMITED',
    'CALLIDORA FARMS PRIVATE LIMITED',
    'KEYBLOOM REALTY PRIVATE LIMITED',
    'ASHISH RENT-A-CAR PRIVATE LIMITED',
    'Quadridge Technologies Private Limited',
    'NETACCESS SOFTWARE PRIVATE LIMITED',
    'MANSCHAFT IT PRIVATE LIMITED',
    'DIPCO INFOTECH PRIVATE LIMITED',
    'INTERACTIV MOBILE TECHNOLOGIES PRIVATE LIMITED',
    'SHAWMAN SOFTWARE PRIVATE LIMITED',
    'WEB-STEPUP INDIA PRIVATE LIMITED',
    'STYLABS TECHNOLOGIES PRIVATE LIMITED',
    'Crelegant Web Technologies Private Limited',
    'Bazinga Softtech Private Limited',
    'NINETY NINE SOLUTIONS PRIVATE LIMITED',
    'CRESCENDO IT SOLUTIONS PRIVATE LIMITED',
    'GoQii Technologies Private Limited',
    'ONELEAP SOLUTIONS PRIVATE LIMITED',
    'Clarisity Solutions Private Limited',
    'Liberty Data Analytics Private Limited',
    'PRACMAN India Private Limited',
    'Poal Technologies Private Limited',
    'ALEOS SOLUTIONS & SERVICES PRIVATE LIMITED',
    'FlatPi Technologies Private Limited',
    'BRIBHOO SECURITIES PRIVATE LIMITED',
    'AARAV GLOBAL PRODUCTS AND SERVICES PRIVATE LIMITED',
    'Leucon Technology Private Limited',
    'AFFIX CENTER SOFTECH SERVICES PRIVATE LIMITED',
    'N-Gage Marketing India Private Limited',
    'INFINITE ANALYTICS INDIA PRIVATE LIMITED',
    'ITAM ADVISORY SERVICES PRIVATE LIMITED',
    'Softinator TechLabs Private Limited',
    'MOBILITEAM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Rekhaprocity Software Private Limited',
    'SOFTPILLAR TECHNOLOGIES PRIVATE LIMITED',
    'MAPPR TECHNOLOGIES SOLUTION PRIVATE LIMITED',
    'VIOLET INFOSYSTEMS PRIVATE LIMITED',
    'Gizbuzz services Private Limited',
    'Visible Alpha Solutions India Private Limited',
    'NESTINCUBATE TECHNOLOGIES PRIVATE LIMITED',
    'EVERESTEK TECHNOSOFT SOLUTIONS PRIVATE LIMITED',
    'TOGGLEHEAD DIGITAL PRIVATE LIMITED',
    'Sunrich Technologies Private Limited',
    'Healthcare Interactive India Private Limited',
    'GATES COMPUTING PRIVATE LIMITED',
    'APPMIX TECHNOLOGIES PRIVATE LIMITED',
    'ALBRECHT SOLUTIONS (INDIA) PRIVATE LIMITED',
    'VODAFONE IDEA TECHNOLOGY SOLUTIONS LIMITED',
    'PLAY TIME MEDIA (I) PRIVATE LIMITED',
    'IOTAP TECHNOLOGY & SOLUTIONS PRIVATE LIMITED',
    'CMS IT Services Private Limited',
    'NUTRICRAFT PRODUCTS PRIVATE LIMITED',
    'PEARL TALENT MANAGEMENT AGENCY PRIVATE LIMITED (OPC)',
    'WATERWAYS CONTAINER LINES PRIVATE LIMITED',
    'Activolt Tech Solutions Private Limited',
    'EXICON MEDIA SOLUTIONS PRIVATE LIMITED',
    'ValuEd Online Services Private Limited',
    'J.C. FLOWERS ASSET RECONSTRUCTION PRIVATE LIMITED',
    'Devidayal Solar Solutions Private Limited',
    'Bazaar247 Mcommerce Private Limited',
    'BREAKFREE CONSULTING (INDIA) PRIVATE LIMITED',
    'VENUS LEGAL SERVICES PRIVATE LIMITED',
    'TFG Real Estate Private Limited',
    'Jeena International Logistics Private Limited',
    'Siemens Healthcare Private Limited',
    'Unlax Consumer Solutions Private Limited',
    'WhiteBoard Idea Labs Private Limited',
    'REBELS BY DEFAULT ADVERTISING PRIVATE LIMITED',
    'STEP Estate Planning India Private Limited',
    'ECOSYS EFFICIENCIES PRIVATE LIMITED',
    'Amana Development Consulting Private Limited',
    'BFSI Career Certification and Training Private Limited',
    'AMERICAN INSTITUTE OF CHEMICAL ENGINEERSINDIA',
    'SoaringEagles Learning Private Limited',
    'MBA TEST PREP PRIVATE LIMITED',
    'INFOMATICA EDUTECH PRIVATE LIMITED',
    'PAREKH E-COM AND WAREHOUSING SERVICES PRIVATE LIMITED',
    'CALIBRANT CLASSES PRIVATE LIMITED',
    'LODHA FOUNDATION',
    'JEEVAN AADHAR TRANSFORMATIVE AFTERCARE SERVICES PRIVATE LIMITED',
    'BLUE AAASHA WELFARE FOUNDATION',
    'ANUSHKAA FOUNDATION FOR ELIMINATING CLUBFOOT',
    'INDIAN AIR HOSPITAL PRIVATE LIMITED',
    'CENTAUR LABORATORIES PRIVATE LIMITED',
    'Smokescreen Technologies Private Limited',
    'CONTINENTAL BELTING PRIVATE LIMITED',
    'SmartLite Technik Private Limited',
    'SKYHIGH INDUSTRIES PRIVATE LIMITED',
    'EQUINOX VIRTUAL PRIVATE LIMITED',
    'HOLLYWOOD ENTERTAINMENT PRIVATE LIMITED',
    'Discern Living Technology Solutions Private Limited',
    'GRAAND PRIX ENTERPRISES PRIVATE LIMITED',
    'Sciencebydesign Labsystems (India) Private Limited',
    'Avantee Mega Food Park Private Limited',
    'MAGNUM SPORTS PRIVATE LIMITED',
    'Zoetrope Entertainment Private Limited',
    'AARETE EVENTS & ENTERTAINMENT PRIVATE LIMITED',
    'SPORTS UNITED INDIA PRIVATE LIMITED',
    'SPK FILMS PRIVATE LIMITED',
    'GEH Consultancy Services Private Limited',
    'ANAYAN SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'SUNSHINE FOUNDATION',
    'TRANSTAR LOGISTICS PRIVATE LIMITED',
    'Positrus Healthcare India Private Limited',
    'HAMPI EXPRESSWAYS PRIVATE LIMITED',
    'Ronald McDonald House Charities Foundation India (RMHC India)',
    'RATNIDEVI MURLIDHAR BAWRI SOCIAL WELFARE FOUNDATION',
    'GW Clearing Private Limited',
    'NATHANI FOUNDATION',
    'Revolutionary Fitness Private Limited',
    'WYP Brand Solutions Private Limited',
    'DIGIMO INNOVATIONS PRIVATE LIMITED',
    'ANAGHA LOGISTICS PRIVATE LIMITED',
    'PLUS LAB SYNC PRIVATE LIMITED',
    'Three 13 Social Foundation',
    'Akshat Charitable Foundation',
    'Udaya Vistara Skills Solutions Private Limited',
    'STEELITE ENGINEERING LIMITED',
    'WOM Academy Private Limited',
    'Great Eastern CSR Foundation',
    'SHYAMKARNA ENTERPRISES PRIVATE LIMITED',
    'PARIKH METACAST PRIVATE LIMITED',
    'A-Grow Agricultures Private Limited',
    'HARDOLI FARMS PRIVATE LIMITED',
    'Jaicorp Welfare Foundation',
    'Aktis Foundation',
    'MEHTA & MEHTA TRAINING AND KNOWLEDGE FOUNDATION',
    'BDA HEALTH CARE PRIVATE LIMITED',
    'BELVEDERE PICTURES PRIVATE LIMITED',
    'MULTIFLEX MARINE PRIVATE LIMITED',
    'SP CRANES PRIVATE LIMITED',
    'Best Deal TV Private Limited',
    'FLASH ENTERTAINMENT PRIVATE LIMITED',
    'GULMOHAR DEVELOPERS AND CONSTRUCTION PRIVATE LIMITED',
    'Sway Dance Studio Private Limited',
    'SCRIPT STORIES MEDIA PRIVATE LIMITED',
    'THE FLOOR MANAGEMENT CO PRIVATE LIMITED',
    'NUTRISMO MEALS PRIVATE LIMITED',
    'C3 COMMUNITY DEVELOPMENT ASSOCIATION',
    'NEW ERAA B2B TRADING PRIVATE LIMITED',
    'DIGITAL LOGISTICS PRIVATE LIMITED',
    'MAHARASHTRA METRO RAIL CORPORATION LIMITED',
    'Spiral Content Solutions Private Limited',
    'BELLFRANC ALLIED SERVICES PRIVATE LIMITED',
    'INNOVARE RETAILS PRIVATE LIMITED',
    'GREENGOLD WINE PRIVATE LIMITED',
    'LINGAYATE LOGISTICS PRIVATE LIMITED',
    'CHINTAMANI MOTORS PRIVATE LIMITED',
    'SUN EXPRESS LOGISTICS (INDIA) PRIVATE LIMITED',
    'TECHLICIOUS DESIGN AND DEVELOPMENT PRIVATE LIMITED',
    'Neha Fleet Solutions Private Limited',
    'MAULI INFOTECH (OPC) PRIVATE LIMITED',
    'DTC TECHNOLOGIES PRIVATE LIMITED',
    'SketchX Engineering OPC Private Limited',
    'Handy Online Solutions Private Limited',
    'CORE OFFSHORE SERVICES PRIVATE LIMITED',
    'PBS GOURMET FOODS PRIVATE LIMITED',
    'OXSTREN WEARABLE TECHNOLOGIES PRIVATE LIMITED',
    'RJ AGRO INDIA FOODS PRIVATE LIMITED',
    'PERFECT SCOT SOLUTIONS PRIVATE LIMITED',
    'GOLDEN SPARROW MARINE SERVICES PRIVATE LIMITED',
    'PROFORCE PROFESSIONAL SERVICES PRIVATE LIMITED',
    'KWALITEX HEALTHCARE PRIVATE LIMITED',
    'ATREYA HEALTHCARE FOUNDATION',
    'IMPRESSIONS ENTERTAINMENTS AND EVENTS PRIVATE LIMITED',
    'RITE ZONE CHEMCON INDIA LIMITED',
    'APINTUS labs private limited',
    'GPAX PHARMACEUTICALS PRIVATE LIMITED',
    'EEMI ARLIN SILICONE HOSES PRIVATE LIMITED',
    'Thomas & Brian Mfg. Private Limited',
    'Gemini Energy Projects Private Limited',
    'T.K. ENGINEERS PRIVATE LIMITED',
    'Controls and Process Automation Solutions Private Limited',
    'KALYANI BHARAT FC PRIVATE LIMITED',
    'PROSERV TOOLS PRIVATE LIMITED',
    'PROSFORA TECHNOLOGIES PRIVATE LIMITED',
    'NBS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'MINUS CO2 ENERGY PRIVATE LIMITED',
    'THINKING HAT MANAGEMENT AND COMMUNICATIONS PRIVATE LIMITED',
    'DESIBOL INFOTECH SOLUTIONS PRIVATE LIMITED',
    'TRISNOTA TECHNICAL SERVICES PRIVATE LIMITED',
    'PRAYAS FRESH FRUITS PRODUCER COMPANY LIMITED',
    'VISUALAN TECHNOLOGIES PRIVATE LIMITED',
    'SOLTHERMAL PANELS PRIVATE LIMITED',
    'VANKON MODULAR PRIVATE LIMITED',
    'PLUGGUS TECHNOLOGIES PRIVATE LIMITED',
    'Arsan Medicare Private Limited',
    'IndiaCrete Ready Mix Private Limited',
    'SHREE SWAMI SAMARTH SOLAR PARK PRIVATE LIMITED',
    'ClearDrop Engineering Private limited',
    'Pentanen Engineering Private Limited',
    'MAHALAXMI (THANE) REALTORS PRIVATE LIMITED',
    'NM AUTOMOTIIVE PRIVATE LIMITED',
    'VEETRAG COMPUTERS PRIVATE LIMITED',
    'AXYVA ESOLUTION PRIVATE LIMITED',
    'ROYAL GREENHOUSE CONSTRUCTION INDIA PRIVATE LIMITED',
    'GREENERIES AGRO PRIVATE LIMITED',
    'TION ENTERPRISES PRIVATE LIMITED',
    'XTROVERT GLOBAL OPC PRIVATE LIMITED',
    'ANACARDO FOODS PRIVATE LIMITED',
    'AMRAVATI DYEING MILLS PRIVATE LIMITED',
    'COOL TECH HVAC SERVICES PRIVATE LIMITED',
    'Suditi Sports Apparel Limited',
    'DEEPSEA OFFSHORE ENTERPRISES PRIVATE LIMITED',
    'Suditi Design Studio Limited',
    'Blain India Private Limited',
    'VIJRAH EXIM PRIVATE LIMITED',
    'EIPII EXPORTS PRIVATE LIMITED',
    'RetZEN Retail Private Limited',
    'UMEUS UNITED PRIVATE LIMITED',
    'WALNUT HOSPITALITY PRIVATE LIMITED',
    'MICROPAN PHARMACEUTICALS PRIVATE LIMITED',
    'TOOVIA TECHNOLOGIES PRIVATE LIMITED',
    'Jaigarh Digni Rail Limited',
    'SOMA UNIVERSAL LOGISTICS PRIVATE LIMITED',
    'COMPARESHOW MEDIA (OPC) PRIVATE LIMITED',
    'PARLE LEEPACK MACHINERY PRIVATE LIMITED',
    'Vedant Clearing And Forwarding Private limited',
    'GOLDSTAR DRY OFFSET PRIVATE LIMITED',
    'HEXES INDIA PRIVATE LIMITED',
    'Tantrayut Telecommunications Private Limited',
    'CITYZONE INFONET PRIVATE LIMITED',
    'ICAN SOLUTIONS PRIVATE LIMITED',
    'DISCO SYSTEMS PRIVATE LIMITED',
    'INTECH FURNACES PRIVATE LIMITED',
    'SHREESAMARTH KRUPA BUILDCON PRIVATE LIMITED',
    'MCAP WEALTH PRIVATE LIMITED',
    'Fingro Finserv Private Limited',
    'Pecuniary Matters Management Private Limited',
    'PROFESSIONAL ENTREPRENEURS PRIVATE LIMITED',
    '3 DAK INFRA PRIVATE LIMITED',
    'Team Habitat Next Private Limited',
    'NIRMITI INFRAPROJECTS LIMITED',
    'SAMYAK REALCON PRIVATE LIMITED',
    'Q & M REALTY CONSTRUCTION WORKS PRIVATE LIMITED',
    'Home Builders & Infrastructures Private Limited',
    'STS AUTO BIKES PRIVATE LIMITED',
    'RELIANCE INFRA PROJECTS LIMITED',
    'GLOBALCOM REALTY LIMITED',
    'TRIXIE IMPEX PRIVATE LIMITED',
    'SmartWeb Marketing Private Limited',
    'MALSA MARKETING AND SERVICES PRIVATE LIMITED',
    'MOERHEIM ROSES AND TRADING INDIA PRIVATE LIMITED',
    'TS FASHIONS PRIVATE LIMITED',
    'Limitless Productions Private Limited',
    'TEXT MERCATO SOLUTIONS PRIVATE LIMITED',
    'GlamFlame Photography and Brand Communication Private Limited',
    'NAPANDA ESTATES PRIVATE LIMITED',
    'PSM AVIATION PRIVATE LIMITED',
    'Stratasys India Private Limited',
    'KROPEX CANDIDA PRINT PRIVATE LIMITED',
    'LEGUME AGRI INDIA PRIVATE LIMITED',
    'I & B SEEDS PRIVATE LIMITED',
    'MEDIA 360 DEGREE PRINTS PRIVATE LIMITED',
    'NIDHI PRINTERS PRIVATE LIMITED',
    'Quite Frankly Productions India Private Limited',
    'FUDE ECOFUEL PRIVATE LIMITED',
    'GENUINE FERT & PEST PRIVATE LIMITED',
    'ARCTURUS PHARMA PRIVATE LIMITED',
    'Denkanikottai Farms Private Limited',
    'AMODHINI ESTATES PRIVATE LIMITED',
    'TYKUN REALTORS PRIVATE LIMITED',
    'VPLUS PREMEDIA PRIVATE LIMITED',
    'PEEKON ADVISORS PRIVATE LIMITED',
    'SPROUTLIFE FOODS PRIVATE LIMITED',
    'SWAN NATURALS PRIVATE LIMITED',
    'PRIMO DRINKS PRIVATE LIMITED',
    'Hindsiam bevs Private Limited',
    'SYNPACK FLEXPACK PRIVATE LIMITED',
    'Hey Spoon Private Limited',
    'KARNATAKA VIJAYNAGAR STEEL LIMITED',
    'Alliage Metal Castings Private Limited',
    'SERENA NUTRITION PRIVATE LIMITED',
    'KINLONG HARDWARE (INDIA) PRIVATE LIMITED',
    'AMD Apparels Private Limited',
    'ZUMAN EXPORTS PRIVATE LIMITED',
    'ORALIAHDENTAL PRIVATE LIMITED',
    'ASTAL INTERBUILD PRIVATE LIMITED',
    'SULAX TECHNOLOGIES PRIVATE LIMITED',
    'Meusburger India Private Limited',
    'RUDHOLM & HAAK INDIA PRIVATE LIMITED',
    'SRB CUSTOM BUILT EQUIPMENTS PRIVATE LIMITED',
    'Noire Designs Private Limited',
    'TKL Knits (India) Private Limited',
    'RSA Turbotech Private Limited',
    'Zenith Aerospace Private Limited',
    'Burnet Rose Lingerie Private Limited',
    'Adwit Global Private Limited',
    'PrintQ Digital Imaging Private Limited (OPC)',
    'Founding Fuel Publishing Private Limited',
    'Kirloskar Toyota Textile Machinery Private Limited',
    'ZINCO ELECTRIC PRIVATE LIMITED',
    'Dustven Engineering Private Limited',
    'IMASIA CAD CAM SERVICES PRIVATE LIMITED',
    'RSJ MEGA HOTELS PRIVATE LIMITED',
    'MURUGAN OIL EXTRACTIONS PRIVATE LIMITED',
    'KIET Technologies Private Limited',
    'SMARTTRON AUTOMATIONS PRIVATE LIMITED',
    'TVJ MINERAL PROCESSING PROJECTS PRIVATE LIMITED',
    'CRAFTWELL MANUFACTURING PRIVATE LIMITED',
    'LEINTZ CONTROLS PRIVATE LIMITED',
    'SRASHTA SCIENTIFIC SYSTEMS PRIVATE LIMITED',
    'ProVaC Manufacturing Technologies Private Limited',
    'Nanoworkz Microwave Devices Private Limited',
    'Archon Aircomfort Solution Private Limited',
    'PRANAG DATA LINKS PRIVATE LIMITED',
    'TWENTY FIRST CENTURY OFFICES PRIVATE LIMITED',
    'GOOD WAY ORGANIC PRIVATE LIMITED',
    'VELANKANI TELECOM PRIVATE LIMITED',
    'VANORA ROBOTS PRIVATE LIMITED',
    'Narang Delicacies Private Limited (OPC)',
    'ORIG PHARMACEUTICALS PRIVATE LIMITED',
    'Reviva Pharmaceuticals India Private Limited',
    'VIJAYA EMTECH PRIVATE LIMITED',
    'APEX TEST TECHNOLOGIES PRIVATE LIMITED',
    'EDISONBRO SMART LABS PRIVATE LIMITED',
    'Certitude Technologies Private Limited',
    'Ambit Power Solutions Private Limited',
    'Overdrive Electric Private Limited',
    'Eco Pallet Private Limited',
    'Greenmine Industries Private Limited',
    'TRINTRON INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'FORENGE TECHNOLOGIES PRIVATE LIMITED',
    'BURLEY TEC PRIVATE LIMITED',
    'GLOBALFOUNDRIES Engineering Private Limited',
    'Huaptec Telecom India Private Limited',
    '4S TELECOM PRIVATE LIMITED',
    'VT VACUUM HEAT TREATERS PRIVATE LIMITED',
    'Biznustek Systems Private Limited',
    'SAM MACHINERY INDIA PRIVATE LIMITED',
    'LORMAN KITCHEN EQUIPMENTS PRIVATE LIMITED',
    'LAKSHMI VACUUM METALLURGICALS PRIVATE LIMITED',
    'HASMAG EQUIPMENTS PRIVATE LIMITED',
    'MATRIX VISION INDIA PRIVATE LIMITED',
    'LIFEZEN HEALTHCARE PRIVATE LIMITED',
    'EKSTEP FOUNDATION',
    'AmudIT Innovative Solutions Private Limited',
    'BAL RESEARCH FOUNDATION',
    'INFOPACE MANAGEMENT PRIVATE LIMITED',
    'Vyuha Advisors and Consultants Private Limited',
    'FOKKER ELMO SASMOS INTERCONNECTION SYSTEMS LIMITED',
    'Techno Brain Shared Services Private Limited',
    'iRAISE Management Consultants Private Limited',
    'SELLERX PRIVATE LIMITED',
    'KTEX NONWOVENS PRIVATE LIMITED',
    'STIMULATE DESIGNS PRIVATE LIMITED',
    'K2B SECURE SOLUTION PRIVATE LIMITED',
    'RADICAL TECHNO PRODUCTS PRIVATE LIMITED',
    'BOWLERS KART PRIVATE LIMITED',
    'MULGEO PRODUCT INDIA PRIVATE LIMITED',
    'SOLLUNA SURGICAL PRIVATE LIMITED',
    'BOTLAB DYNAMICS PRIVATE LIMITED',
    'JAGRIT KISAN PRODUCER COMPANY LIMITED',
    'NEXTECH SERVICES PRIVATE LIMITED',
    'BRANDIT COMMUNICATIONS PRIVATE LIMITED',
    'DIGITAL MINDS TECHNOLOGIES PRIVATE LIMITED',
    'OOSTROM CONSULTANTS PRIVATE LIMITED',
    'FIRMWAY SERVICES PRIVATE LIMITED',
    'DEYVOS LABS PRIVATE LIMITED',
    'VIVONO DESIGNS PRIVATE LIMITED',
    'JETHRO PROFESSIONALS PRIVATE LIMITED',
    'TECHNOFRA PRIVATE LIMITED',
    'SUMATINATH DETERGENTS PRIVATE LIMITED',
    'GNANI INNOVATIONS PRIVATE LIMITED',
    'SHR INFRASTRUCTURE PRIVATE LIMITED',
    'FOODLUXE PRIVATE LIMITED',
    'TRYGGO INDIA PRIVATE LIMITED',
    'KONTRESIND CONSULTING (OPC) PRIVATE LIMITED',
    'SEURO POLYMECH PRIVATE LIMITED',
    'INVEST KARNATAKA FORUM',
    'VANBROS HOME PRIVATE LIMITED',
    'AQSA AIR CONDITIONER',
    'S INHOUSE CARE PRIVATE LIMITED',
    'HOMEBELL SOFTWARE INDIA PRIVATE LIMITED',
    'INGENX TECHNOLOGY PRIVATE LIMITED',
    'PALACIAL REAL ESTATE PRIVATE LIMITED',
    'WEFAST INDIA PRIVATE LIMITED',
    'KENRISE MEDIA PRIVATE LIMITED',
    'JSN COMPUTE SYSTEMS INDIA PRIVATE LIMITED',
    'VALUEAPPZ SOLUTIONS PRIVATE LIMITED',
    'CARCREW TECHNOLOGY PRIVATE LIMITED',
    'MMT INFRASTRUCTURE PRIVATE LIMITED',
    'INAYA RENEWABLE ENERGIES PRIVATE LIMITED',
    'MICRO FOCUS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'WEALTH FIRST INVESTMENT ADVISERS PRIVATELIMITED',
    'UNOHQ TECHNOLOGIES PRIVATE LIMITED',
    'AADVENTURE INFOTECH PRIVATE LIMITED',
    'AQUARTIA PRIVATE LIMITED',
    'TWINCITY COMMUNICATION PRIVATE LIMITED',
    'FINDESK MARKET SERVICES PRIVATE LIMITED',
    'TETHYS NOVITATE PRIVATE LIMITED',
    'SAFETYFIRST SOLUTIONS PRIVATE LIMITED',
    'MACTRIGON DIGITAL PRIVATE LIMITED',
    'ETICO LIFESCIENCES PRIVATE LIMITED',
    'BTW BUILD INDIA FOUNDATION',
    'ARKA TECHKNOWLEDGES PRIVATE LIMITED',
    'BHUSHIT TEXTILES PRIVATE LIMITED',
    'ASCENT TECHMIND (I) PRIVATE LIMITED',
    'SOLOGENX PRIVATE LIMITED',
    'CHARUTA TEXTILES PRIVATE LIMITED',
    'IDLABELS AND SOLUTIONS PRIVATE LIMITED',
    'IMMENSO TECH PRIVATE LIMITED',
    'BSS MATERIEL LIMITED',
    'BLITS COURIERS AND XPRESS SERVICES PRIVATE LIMITED',
    'JAI BHAVANI FARMER PRODUCER COMPANY LIMITED',
    'RANGADHOL SOLAR POWER PRIVATE LIMITED',
    'PICTOR DIAGNOSTICS INDIA PRIVATE LIMITED',
    'IKITCHEN VENTURES PRIVATE LIMITED',
    'RICKUL INDIA PRIVATE LIMITED',
    'WEBMILEZ INFOTECH PRIVATE LIMITED',
    'ARITHMICA PRIVATE LIMITED',
    'ISHTI TEXTILES PRIVATE LIMITED',
    'INCOGNITO FORENSIC FOUNDATION',
    'RODEC HEALTHCARE PRIVATE LIMITED',
    'KALASH CROP SEEDS SCIENCES PRIVATE LIMITED',
    'ASTRANTIA TRADERS PRIVATE LIMITED',
    'GODESKLESS INDIA PRIVATE LIMITED',
    'VEZADO ECOM INDIA PRIVATE LIMITED',
    'HERD AGRICULTURE PRIVATE LIMITED',
    'ROSHNI HOMES PRIVATE LIMITED',
    'MOEL INFRASTRUCTURE PRIVATE LIMITED',
    'INSTACAR TECHNOLOGIES PRIVATE LIMITED',
    'NEDFI TRUSTEE LIMITED',
    'WORKLINE PRIVATE LIMITED',
    'AUSSIZZ INDIA PRIVATE LIMITED',
    'CRICKET TALKIES PRIVATE LIMITED',
    'DPJ BIDAR CHINCHOLI (ANNUITY) ROAD PROJECT PRIVATE LIMITED',
    'SHREY RAJ ELECTRO PRIVATE LIMITED',
    'ANALYTIX MANTRA PRIVATE LIMITED',
    'STUDENTING ERA PRIVATE LIMITED',
    'EMPAXIS DATA MANAGEMENT INDIA PRIVATE LIMITED',
    'JAIN LIFESCIENCES PRIVATE LIMITED',
    'ATRIA WIND POWER (CHITRADURGA) PRIVATE LIMITED',
    'TALENT4ASSURE ASSESSMENT SERVICES PRIVATE LIMITED',
    'CARENCURE PHARMA PRIVATE LIMITED',
    'PAYTM PAYMENTS BANK LIMITED',
    'ACME AFFORDABLE SHELTERS PRIVATE LIMITED',
    'TRUE FIT DEVELOPMENT INDIA PRIVATE LIMITED',
    'SERARO INFOTECH PRIVATE LIMITED',
    'RADHA',
    'HOSMAT HEALTHCARE PRIVATE LIMITED',
    'STT PAYTECHS PRIVATE LIMITED',
    'CP SPORTS VENTURES PRIVATE LIMITED',
    'SAVITA CHHAYA FOUNDATION',
    'WVP SERVICES PRIVATE LIMITED',
    'VFM HOLIDAYS AND TRAVEL PRIVATE LIMITED',
    'NSE IFSC LIMITED',
    'FITUCCI FIT-OUT INDIA PRIVATE LIMITED',
    'EDIGISERVE INDIA PRIVATE LIMITED',
    'WALNUT KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'MANSUKH IFSC BROKING PRIVATE LIMITED',
    'KWH TECH SERVICES PRIVATE LIMITED',
    'MAHAMAYA RENTALS PRIVATE LIMITED',
    'ZAD MARKETING INDIA PRIVATE LIMITED',
    'PROCEZZ KREDIT PRIVATE LIMITED',
    'SAVADIKA RETAIL PRIVATE LIMITED',
    'TRIOTA VENTURES PRIVATE LIMITED',
    'RF GENIE ENTERPRISES PRIVATE LIMITED',
    'MOBIPRO INNOVATION PRIVATE LIMITED',
    'CTOI MEDIA PRIVATE LIMITED',
    'ALMAWIZ TECHNOLOGIES PRIVATE LIMITED',
    'APEDGI TECHNOLOGIES PRIVATE LIMITED',
    'WINDSTREAM 5 BROADBAND SERVICES PRIVATE LIMITED',
    'PURSUIT INDIA SPORTS AND ENTERTAINMENT PRIVATE LIMITED',
    'TECHFRUITS SOLUTIONS PRIVATE LIMITED',
    'GLOBOTRANS PROLOGISTIX PRIVATE LIMITED',
    'SORIN GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'ACCEDO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GEM OVERSEAS SERVICES PRIVATE LIMITED',
    'FLORID PRINT & PACK PRIVATE LIMITED',
    'OPSAWAY IT SERVICES PRIVATE LIMITED',
    'SAI PRASAD INTERNET SERVICES PRIVATE LIMITED',
    'INSOLVENCY PROFESSIONAL AGENCY OF INSTITUTE OF COST ACCOUNTANTS OF INDIA',
    'AVACARE SHARED SERVICES (INDIA) PRIVATE LIMITED',
    'M.D.POMEGRANATE PLANTATION INDIA PRIVATELIMITED',
    'ULTIMATE GAMING TECHNOLOGIES PRIVATE LIMITED',
    'TOPSY TURVY RETAIL PRIVATE LIMITED',
    'NAMISH REALTORS & CONSTRUCTIONS PRIVATE LIMITED',
    'ENSIGN INSURANCE BROKERS PRIVATE LIMITED',
    'MAA KHAMBESWARI AGRO PRODUCER COMPANY LIMITED',
    'MEGHNATHI BROTHERS INDUSTRIES LIMITED',
    'ABHIYASH AGROTECH PRIVATE LIMITED',
    'GHANTASILA WOMEN AGRO PRODUCER COMPANY LIMITED',
    'SAI-JYOTI TILLAGE PRIVATE LIMITED',
    'N.R.C. AGROVET PRIVATE LIMITED',
    'SIRA TALUK FARMER PRODUCER COMPANY LIMITED',
    'CHIATAI INDIA PRIVATE LIMITED',
    'HALLIBURTON INDIA OPERATIONS PRIVATE LIMITED',
    'WAGHNADI FARMERS PRODUCER COMPANY LIMITED',
    'GLOMIN TRADING CORPORATION PRIVATE LIMITED',
    'ANN FMCG PRIVATE LIMITED',
    'COOLBERG BEVERAGES PRIVATE LIMITED',
    'MICROTECH SUPPORT 247 PRIVATE LIMITED',
    'RESEARCH INSTITUTE OF MATERIAL SCIENCES PRIVATE LIMITED',
    'SOUTHOPEN HOUSING PRIVATE LIMITED',
    'ACM NATURAL PRODUCTS PRIVATE LIMITED',
    'FORKFUSION HOSPITALITY PRIVATE LIMITED',
    'VYAGHRA HEALTH FOODS PRIVATE LIMITED',
    'BIDADA FOODS PRIVATE LIMITED',
    'FILLI CAFE INDIA PRIVATE LIMITED',
    'SALUTARIS FOOD TECHNOLOGIES PRIVATE LIMITED',
    'SIMPLYBUY SOLUTIONS PRIVATE LIMITED',
    'SWMKHWR VALLEY TEA PRODUCER COMPANY LIMITED',
    'SOLIS NATURALS PRIVATE LIMITED',
    'FRESHOKARTZ AGRI PRODUCTS PRIVATE LIMITED',
    'FIPOLA RETAIL (INDIA) PRIVATE LIMITED',
    'KANAK FOODS PRIVATE LIMITED',
    'SMACKOS FOOD PRODUCTS PRIVATE LIMITED',
    'ATHACHI FARMS & PLANTATION PRIVATE LIMITED',
    'BHUGARBHO GEO SCIENCES PRIVATE LIMITED',
    'CAPE TRADITIONS PRIVATE LIMITED',
    'PLANETARY FOODS PRIVATE LIMITED',
    'AKKSHA SYS (OPC) PRIVATE LIMITED',
    'NYS CUISINEART PRIVATE LIMITED',
    'NIRVAANIC LIFE FOODS PRIVATE LIMITED',
    'YJ CROP CARE PRIVATE LIMITED',
    'FUTURESION CONSUMER PRODUCTS PRIVATE LIMITED',
    'THOOTHUKUDI TRADITIONAL CROP PRODUCER COMPANY LIMITED',
    'ETEN CRAFT HOLDINGS PRIVATE LIMITED',
    'RSR HR SOLUTION PRIVATE LIMITED',
    'KGK COMPUTERS AND SERVICES PRIVATE LIMITED',
    'MORESLIDES.COM SERVICES PRIVATE LIMITED',
    'DEVINCO HPC PRIVATE LIMITED',
    'INFOMAGICA INITIATIVES PRIVATE LIMITED',
    'INNOVIEN CONSULTING PRIVATE LIMITED',
    'METARVRSE IMMERSIVE TECHNOLOGIES PRIVATELIMITED',
    'WIZZOI INFOTECH PRIVATE LIMITED',
    'GORGEOUSS ATARA PRIVATE LIMITED',
    'RTU ORGANIC PRIVATE LIMITED',
    'HERO CORPORATION PRIVATE LIMITED',
    'EDWISETECH PRIVATE LIMITED',
    'GAMA LUXUS HOTELS PRIVATE LIMITED',
    'ECONOLYTICS CONSULTANCY PRIVATE LIMITED',
    'DHAVALA WAREHOUSING PRIVATE LIMITED',
    'CHHATTISGARH RAILWAY CORPORATION LIMITED',
    'PANITEK POWER PRIVATE LIMITED',
    'ZJZ DESIGN STUDIO (OPC) PRIVATE LIMITED',
    'ARINSUN CLEAN ENERGY PRIVATE LIMITED',
    'SEEKHO INDIA PRIVATE LIMITED (OPC)',
    'DELICASY KITCHEN AND BAR PRIVATE LIMITED',
    'OFFICE STAG SOLUTIONS PRIVATE LIMITED',
    'SPRNG ENERGY PRIVATE LIMITED',
    'NLVD ASSURANCE (OPC) PRIVATE LIMITED',
    'AMUM INTERNATIONAL PRIVATE LIMITED',
    'IGI AVIATION SERVICES PRIVATE LIMITED',
    'MACAZO HOSPITALITY PRIVATE LIMITED',
    'I-SUCCEED VENTURES PRIVATE LIMITED',
    'ASIAN CHICKFISH PRIVATE LIMITED',
    'DENGI FINSERV PRIVATE LIMITED',
    'MEDGURU HEALTH CARE SERVICES PRIVATE LIMITED',
    'MODI MARCO ALDANY PRIVATE LIMITED',
    'CONNOISSEURS KLÃ–VER PRIVATE LIMITED',
    'SKATE GOOSE (OPC) PRIVATE LIMITED',
    'GRAND SUMMIT PRIVATE LIMITED',
    'SKANDA HEI HR INTERNATIONAL PRIVATE LIMITED',
    'CINT HEALTHCARE PRIVATE LIMITED',
    'MLP FACILITATORS PRIVATE LIMITED',
    'PENASCOP (INDIA) AGENCY PRIVATE LIMITED',
    'FLYING GEESE QUILTS PRIVATE LIMITED',
    'BLUEPROX INFOTECH PRIVATE LIMITED',
    'KARL BUCKS INVESTMENT PRIVATE LIMITED',
    'MILLION MINDS INFOTECH PRIVATE LIMITED',
    'SPRNG RENEWABLE ENERGY PRIVATE LIMITED',
    'ONDEM SERVICES PRIVATE LIMITED',
    'MCCO ADVISORY SERVICES PRIVATE LIMITED',
    'ASIAN SUPER STORES PRIVATE LIMITED',
    'POSTERITY ASSOCIATES PRIVATE LIMITED',
    'ADVENTURES SPORTS SYSTEMS AND TIMING PRIVATE LIMITED',
    'IVOOMI INNOVATION PRIVATE LIMITED',
    'E-CARGO LOGISTICS SERVICES PRIVATE LIMITED',
    'KHELO TECH AND STRATEGY PRIVATE LIMITED',
    'DISTINGUISHED CONSULTANCY SOLUTIONS PRIVATE LIMITED',
    'NOWWT SERVICES PRIVATE LIMITED',
    'HIGHER PITCH DIGITAL CONSULTING PRIVATE LIMITED',
    'ARVAND PETROLEUMS PRIVATE LIMITED',
    'SPRNG POWER PRIVATE LIMITED',
    'ARMOUR WEB SERVICES PRIVATE LIMITED',
    'SOLIDCREATE PRIVATE LIMITED',
    'QBG TRADING PRIVATE LIMITED',
    'PURNA EXPERTS (OPC) PRIVATE LIMITED',
    'ADANI CEMENTATION LIMITED',
    'ASCENDION ENGINEERING PRIVATE LIMITED',
    'RASCURE PHARMACEUTICALS PRIVATE LIMITED',
    'BIZLOAN PRIVATE LIMITED',
    'PERCH RESIDENCES PRIVATE LIMITED',
    'SPNN BUSINESS SERVICES PRIVATE LIMITED',
    'AUXIBLE INDIA PRIVATE LIMITED',
    'MACHER LABS PRIVATE LIMITED',
    'KASOVA VENTURES PRIVATE LIMITED',
    'FLEXIPLE TECH PRIVATE LIMITED',
    'LA VERNE INFOTECH PRIVATE LIMITED',
    'GLOBAUX IMPEX PRIVATE LIMITED',
    'GLOBALPLAY MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'CARE INTERNATIONAL MULTI SERVICES PRIVATE LIMITED',
    'EXCELENCIA PHARMACEUTICALS PRIVATE LIMITED',
    'ESG INTELLIGENCE PRIVATE LIMITED',
    'TARG.AI PRIVATE LIMITED',
    'NEWINC INTERNET SERVICES PRIVATE LIMITED',
    'PACYON VENTURES PRIVATE LIMITED',
    'TASHA GOLD PRIVATE LIMITED',
    'BUSINESS GIFTS PRIVATE LIMITED',
    'MNL GLUCK SERVICES PRIVATE LIMITED',
    'HUBGURU PRIVATE LIMITED',
    'POWERTECH INDUSTRIAL SERVICES PRIVATE LIMITED',
    'EBIZFILING INDIA PRIVATE LIMITED',
    'CAPITAWORLD GLOBAL PRIVATE LIMITED',
    'PINAK ADVISORY SERVICES PRIVATE LIMITED',
    'GOODWATTS WTE AHMEDABAD PRIVATE LIMITED',
    'ARTEM ENERGY FUTURE PRIVATE LIMITED',
    'SUZUYO INDIA PRIVATE LIMITED',
    'ALFANAR ENERGY PRIVATE LIMITED',
    'ADROIT FINANCIAL SERVICES (IFSC) PRIVATELIMITED',
    'EMENTALIST OUTSOURCING SERVICES PRIVATE LIMITED',
    'VIPULJYOTI INTERIOR SOLUTION PRIVATE LIMITED',
    'ADMEDIA DIGITAL LABS PRIVATE LIMITED',
    'REZNO LAMINATES INDIA PRIVATE LIMITED',
    'VIRAJ TECHNOLOGY INDIA LIMITED',
    'TRADEIMPEX POLYMERS (INDIA) PRIVATE LIMITED',
    'POWERGRID VARANASI TRANSMISSION SYSTEM LIMITED',
    'AZURE POWER FORTY THREE PRIVATE LIMITED',
    'KAVIR SOLAR PRIVATE LIMITED',
    'GOA-TAMNAR TRANSMISSION PROJECT LIMITED',
    'ABD DIAMONDS PRIVATE LIMITED',
    'WHITELOTUS SOLAR SINDH PRIVATE LIMITED',
    'NEOTERIC PRECITECH PRIVATE LIMITED',
    'ISLAND EAST WATCH & FASHIONS PRIVATE LIMITED',
    '4PEL SOLAR SUN FLAME PRIVATE LIMITED',
    'GOA NATURAL GAS PRIVATE LIMITED',
    'BETAM WIND ENERGY PRIVATE LIMITED',
    'LINCHPIN BIOSCIENCES PRIVATE LIMITED',
    'KAMDAR TIMES PRIVATE LIMITED',
    'TARALTEC SOLUTIONS PRIVATE LIMITED',
    'MKT INFRA DEVELOPMENT PRIVATE LIMITED',
    'ARIA AEROTECH PRIVATE LIMITED',
    'SATE-LITE TECHNOLOGIES PRIVATE LIMITED',
    'SUN PHARMACEUTICAL MEDICARE LIMITED',
    'AGIS INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'VJ JINDAL COCOA PRIVATE LIMITED',
    'MURATA BUSINESS ENGINEERING (INDIA) PRIVATE LIMITED',
    'VLI MINING EQUIPMENT (INDIA) PRIVATE LIMITED',
    'SOLEOS SOLAR ENERGY PRIVATE LIMITED',
    'EPI UPS (INDIA) PRIVATE LIMITED',
    'VPLAN4U INDIA PRIVATE LIMITED',
    'PANTHEON BUILDERS PRIVATE LIMITED',
    'MONDO BUILDERS PRIVATE LIMITED',
    'MICHVERG INFRATECH AND MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'CLOUD CASTLE PRIVATE LIMITED',
    'KRIPALU INDUSTRIES PRIVATE LIMITED',
    'A&U INFRA PARK PRIVATE LIMITED',
    'KAMALAM ESTATES PRIVATE LIMITED',
    'SANCHORE RENEWABLE PRIVATE LIMITED',
    'SCOSMOS GADGETS PRIVATE LIMITED',
    'VRC SILOS PRIVATE LIMITED',
    'AURINKO ENERGY PRIVATE LIMITED',
    'LUXRA SOLAR INDIA PRIVATE LIMITED',
    'UPEKSHA CONSTRUCTIONS PRIVATE LIMITED',
    'KOYIKKAL CONSTRUCTIONS PRIVATE LIMITED',
    'ULTRASCEND INFRATECH PRIVATE LIMITED',
    'GIR-TALALA LIFESTYLE RESORTS PRIVATE LIMITED',
    'STARTLING GMP CLEAN ROOM PRIVATE LIMITED',
    'KISHANGARH GULABPURA TOLLWAY LIMITED',
    'BALBHADRA CRUSHER PRIVATE LIMITED',
    'RAJANI ENGICON PRIVATE LIMITED',
    'SUMMIT TERRACRAFT PRIVATE LIMITED',
    'SPIRAL PROCON PRIVATE LIMITED',
    'ALMARK PHARMA PRIVATE LIMITED',
    'WALLNUT BUILDING SOLUTIONS INDIA PRIVATELIMITED',
    'IA STANDS PRIVATE LIMITED',
    'CP WHOLESALE INDIA PRIVATE LIMITED',
    'FERROSCO INDUSTRIES PRIVATE LIMITED',
    'R2 PRO PRIVATE LIMITED',
    '4PEL SOLAR DAYLIGHT ENERGY PRIVATE LIMITED',
    'FEM ELEMENTEN STUDIO PRIVATE LIMITED',
    'POWERGRID MITHILANCHAL TRANSMISSION LIMITED',
    'BIJAWAR-VIDARBHA TRANSMISSION LIMITED',
    'SUWASTHI INTENSE BEAUTY PRODUCTS PRIVATELIMITED',
    'SANIDHY DEVELOPERS AND COLONIZERS PRIVATE LIMITED',
    'AVDYNAMICS INDIA PRIVATE LIMITED',
    'DATLU PRIVATE LIMITED',
    'MTPL PROJECTS PRIVATE LIMITED',
    'SEA STONES ASSETS PRIVATE LIMITED',
    'BOLENG ENTERPRISE PRIVATE LIMITED',
    'ORANGE REALITIES PRIVATE LIMITED',
    'CLAY BUSINESS VENTURES PRIVATE LIMITED',
    'AMSA ELECTRONICS PRIVATE LIMITED',
    'AURUM AUTOMOBILES PRIVATE LIMITED',
    'RKH AUTOMOBILES PRIVATE LIMITED',
    'UNIFOUR COMERCIO PRIVATE LIMITED',
    'AMSM AUTOMART PRIVATE LIMITED',
    'TUSKER ENTERPRISES PRIVATE LIMITED',
    'VANSHITA LIFECARE PRIVATE LIMITED',
    'UBIQUITY FARE PRIVATE LIMITED',
    'INDOSURGICALS PRIVATE LIMITED',
    'DROMER TECHNOLOGIES PRIVATE LIMITED',
    'EFARM EXCHANGE PRIVATE LIMITED',
    'FNV RETAIL PRIVATE LIMITED',
    'NACHSTER ENTERPRISES PRIVATE LIMITED',
    'INFINIAN TECHNOLOGY PRIVATE LIMITED',
    'AEVAS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GRASSROOTS TEA CORPORATION PRIVATE LIMITED',
    'ROCKINGDEALS PRIVATE LIMITED',
    'PADMANIDHI PROPERTIES PRIVATE LIMITED',
    'AJISHT STRUCTURES PRIVATE LIMITED',
    'TIGER GLOBAL WORLD PRIVATE LIMITED',
    'TRUBEX SOLUTIONS PRIVATE LIMITED',
    'TAILHUB PRIVATE LIMITED',
    'AMOLAKCHAND ANKUR KOTHARI ENTERPRISES PRIVATE LIMITED',
    'SANTECH MACHINERY AND EQUIPMENT PRIVATE LIMITED',
    'YELLOW LOOP PRIVATE LIMITED',
    'SMRADDHI TRADERS PRIVATE LIMITED',
    'SOIGNER MEDICAMENT PRIVATE LIMITED',
    'LEGEND GOURMET PB PRIVATE LIMITED',
    'ALEX AND VERA HOSPITALITY SERVICES PRIVATE LIMITED',
    'RIVERFACE HOLIDAYS PRIVATE LIMITED',
    'AYUSH MART PRIVATE LIMITED',
    'HARESHA FOODS PRIVATE LIMITED',
    'INSU MOVE IN COMFORTS INDIA PRIVATE LIMITED',
    'AGILE FASHIONS INDIA PRIVATE LIMITED',
    'AUROMIR FOUNDATION FOR INTEGRAL LEARNING',
    'UNAKOTI SCIENTIFIC PRIVATE LIMITED',
    'NEUBERG DIAGNOSTICS PRIVATE LIMITED',
    'PROBYTO DATA SCIENCE AND CONSULTING PRIVATE LIMITED',
    'LEGOSINDIA LANGUAGE SERVICES PRIVATE LIMITED',
    'UNITED HUMAN RIGHTS FEDERATION',
    'NMAMI LIFE PRIVATE LIMITED',
    'PK HEALTHCARE PRIVATE LIMITED',
    'SABKA DEVELOPMENT ASSOCIATION',
    'SARATHI CSR FOUNDATION',
    'PEPFUELS TECHNOLOGIES PRIVATE LIMITED',
    'INFOTECHHUB PRIVATE LIMITED',
    'GREENERACE TECHNOLOGIES PRIVATE LIMITED',
    'SGMG MULTIMEDIA PRIVATE LIMITED',
    'RUGSOTIC PRIVATE LIMITED',
    'CENTIPLEX PRIVATE LIMITED',
    'ASQON ANALYTICS PRIVATE LIMITED',
    'CEMOSA INDIA PRIVATE LIMITED',
    'SURVAM PRIVATE LIMITED',
    'DEINDE CONSULTING PRIVATE LIMITED',
    'TRETANATURE AGRI PRODUCTS PRIVATE LIMITED',
    'WILDHAWK ADVENTURES PRIVATE LIMITED',
    'AVAHAN SPA PRIVATE LIMITED',
    'TURNITIN INDIA PRIVATE LIMITED',
    'AMARAVATI PEOPLE FOUNDATION',
    'VIKRAM SOLAR FOUNDATION',
    'FEDERATION OF NEW VENTURE',
    'DOWELL ELECTRICALS PRIVATE LIMITED',
    'ALL FIT CONSULTANCY PRIVATE LIMITED',
    'MERKANT INFRASTRUCTURE PRIVATE LIMITED',
    'MERIDEAN OVERSEAS EDUCATION CONSULTANTS PRIVATE LIMITED',
    'DIGILEARN PRIVATE LIMITED',
    'EDSPIROID SYSTEMS PRIVATE LIMITED',
    'LEADBURG KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'CONTREE FOUNDATION',
    'BRAINGROOM INDIA PRIVATE LIMITED',
    'IQUE FOUNDATION FOR YOUTH AWARENESS',
    'SOCORRO CARE PRIVATE LIMITED',
    'CONFEDERATION OF EASTERN CHAMBERS OF COMMERCE AND INDUSTRY',
    'COIMBATORE RIFLE CLUB',
    'DOT2GLOBE SOLUTIONS INDIA PRIVATE LIMITED',
    'JUMPBALL EDUVENTURES PRIVATE LIMITED',
    'OYEZ UNISERV PRIVATE LIMITED',
    'SOLVATIVE PRIVATE LIMITED',
    'DIALOGUES CAFE PRIVATE LIMITED',
    'SHERWOOD LONGSTAY PRIVATE LIMITED',
    'TEP ROOFTOP SOLAR INDIA PRIVATE LIMITED',
    'DIGICONNECTT TECHNOLOGYS PRIVATE LIMITED',
    'CALISTA FITNESS PRIVATE LIMITED',
    'INDIABULLS INFRA RESOURCES LIMITED',
    'ONEZEROEIGHT BRANDCOMM PRIVATE LIMITED',
    'AQUA CENTRIC PRIVATE LIMITED',
    'KALAM INNOVATION HUB PRIVATE LIMITED',
    'MAGICTYM DIGITAL (INDIA) PRIVATE LIMITED',
    'LQ GLOBAL SERVICES PRIVATE LIMITED',
    'ROMA INSTITUTE PRIVATE LIMITED',
    'RACKUP CAMBRIDGE EDUSOLUTIONS PRIVATE LIMITED',
    'CADD TALENTZ TRAINING SERVICES PRIVATE LIMITED',
    'PARSHI EMERGING TECHNOLOGIES PRIVATE LIMITED',
    'NCML BETTIAH PRIVATE LIMITED',
    'AVAADA RJJAMSAR PRIVATE LIMITED',
    'BLUE ROOSTER VENTURES PRIVATE LIMITED',
    'DIGIPLUSIT SOFTWARE PRIVATE LIMITED',
    'POISED MEDIA PRIVATE LIMITED',
    'LIQUI FORGE PRIVATE LIMITED',
    'STUDYSID EDUTECH SOLUTIONS PRIVATE LIMITED',
    'SALANCO (INDIA) PRIVATE LIMITED',
    'MVC INFOTECH PRIVATE LIMITED',
    'SANSKAAR SKILL DEVELOPMENT CORPORATION PRIVATE LIMITED',
    'AREA ONLINE SERVICES INDIA PRIVATE LIMITED',
    'GAMUT ANALYTICS PRIVATE LIMITED',
    'FORTE FURNITURE PRODUCTS INDIA PRIVATE LIMITED',
    'RENNOVATE HOME SOLUTIONS PRIVATE LIMITED',
    'MONOCAST STRUCTURAL DESIGNERS PRIVATE LIMITED',
    'PATHARITECH PRIVATE LIMITED',
    'ZAIRO INTERNATIONAL PRIVATE LIMITED',
    'BIRD ADVANCED DEFENCE SYSTEMS PRIVATE LIMITED',
    'GENETIC CALLNET CONSULTANCY PRIVATE LIMITED',
    'LATUR RENEWABLE PRIVATE LIMITED',
    'COFFEE-GO-ROUND ENTERTAINMENT PRIVATE LIMITED',
    'HORSE POWER SPORTS PRIVATE LIMITED',
    'CHIGRU INNOVATIONS (OPC) PRIVATE LIMITED',
    'ANUJ LALIT INFRATECH PRIVATE LIMITED',
    'BLUPIN TECHNOLOGIES PRIVATE LIMITED',
    'TATVI TECHNOLOGY LABS PRIVATE LIMITED',
    'SUGAR CRAFT PRIVATE LIMITED',
    'LERNIO EDUTECH PRIVATE LIMITED',
    'ENVIU FOUNDATION',
    'ATMA COMMUNICATIONS PRIVATE LIMITED',
    'CERKA SOLUTIONS PRIVATE LIMITED',
    'ITECH IT SOLUTIONS PRIVATE LIMITED',
    'XPERT PROPERTY MANAGEMENT SERVICES PRIVATE LIMITED',
    'HUNTOFFICES PRIVATE LIMITED',
    'AICE HEALTH CARE PRIVATE LIMITED',
    'WEPACT TECHNOLOGIES PRIVATE LIMITED',
    'LEOPIC CONSOLIDATOR INDIA PRIVATE LIMITED',
    'MELISTO PRIVATE LIMITED',
    'VANA FOUNDATION',
    'ITUS CAPITAL ADVISORS PRIVATE LIMITED',
    'BECQUER ENERGY INDIA SALES OFFICE PRIVATE LIMITED',
    'FRIMLINE PRIVATE LIMITED',
    'ALOPA INFOTECH PRIVATE LIMITED',
    'TAIKO PLASTIC TECHNOLOGIES PRIVATE LIMITED',
    'VIMERSIA MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'MICROFOSSIL INDIA (OPC) PRIVATE LIMITED',
    'ONESTOP BLOCKCHAIN & CLOUD SOLUTIONS PRIVATE LIMITED',
    'ITENSIA PRO PRIVATE LIMITED',
    'GADRE FOUNDATION',
    'SHREM ROADWAYS PRIVATE LIMITED',
    'YUTO PRINTING & PACKAGING (INDIA) PRIVATE LIMITED',
    'SAVITHA PATIL PHOTOGRAPHY AND FILMS PRIVATE LIMITED',
    'SYSTRONIKA TECHNOLOGIES PRIVATE LIMITED',
    'TOPRE INDIA PRIVATE LIMITED',
    'IOS SPORTS FOUNDATION',
    'VIJAYSHREE RRB PRIVATE LIMITED',
    'SECURING HUMAN FOUNDATION',
    'SPINTECH TUBES PRIVATE LIMITED',
    'FDN PROPERTIES PRIVATE LIMITED',
    'MOONWALKR SPORTING INNOVATIONS PRIVATE LIMITED',
    'BLACKLIGHT MOBILITY PRIVATE LIMITED',
    'BRAINBEAN TECHNOLABS PRIVATE LIMITED',
    'KAASMA PRIVATE LIMITED',
    'INGENUENT INSTITUTE PRIVATE LIMITED',
    'KGTS ENGINEERS INDIA PRIVATE LIMITED',
    'RAPIDO TRAVELS INDIA PRIVATE LIMITED',
    'SHAAN AGRO OILS & EXTRACTIONS PRIVATE LIMITED',
    'BEST GUARD SECURITY AND FACILITIES SERVICES PRIVATE LIMITED',
    'AGILE AIRPORT SERVICES PRIVATE LIMITED',
    'MITZVAH ENGG (INDIA) PRIVATE LIMITED',
    'INSTROL RENEWABLE ENERGY PRIVATE LIMITED',
    'SERVILE CONSULTING PRIVATE LIMITED',
    'VANITY VENTURES PRIVATE LIMITED',
    'JALAYAN IT SOLUTIONS PRIVATE LIMITED',
    'NASMYTH ASIA (IN) PRIVATE LIMITED',
    'SPIOT SYSTEMS PRIVATE LIMITED',
    'SAHYOG OZONE VENTURE PRIVATE LIMITED',
    'AVANEESH TECHNOSOFT PRIVATE LIMITED',
    'P&Y PROJECTS PRIVATE LIMITED',
    'INTRAKRAFT SOLUTIONS PRIVATE LIMITED',
    'OYDRO INDIA PRIVATE LIMITED',
    'SURYODAY ONE ENERGY PRIVATE LIMITED',
    'ZYUDLY LABS DATA SOLUTIONS PRIVATE LIMITED',
    'COGITECH SOLUTIONS PRIVATE LIMITED',
    'GDRIVE MOTORS PRIVATE LIMITED',
    'VEER SALONS PRIVATE LIMITED',
    'MYTRAH UJJVAL POWER PRIVATE LIMITED',
    'BISOU COSMETICS PRIVATE LIMITED',
    'ATULYA COMPOSITES PRIVATE LIMITED',
    'SHEKHAWATI SHIPPING & LOGISTICS PRIVATE LIMITED',
    'HATS-OFF DIGITAL PRIVATE LIMITED',
    'MOBILECODERZ TECHNOLOGIES PRIVATE LIMITED',
    'AMPSOLAR VENTURES PRIVATE LIMITED',
    'ATTROCK CONSULTANCY PRIVATE LIMITED',
    'TANISHHA GLOBAL STAR SOLUTIONS PRIVATE LIMITED',
    'WE CONNECT STUDENTS PRIVATE LIMITED',
    'FANATIQ HEALTHCARE PRIVATE LIMITED',
    'BIZ TRICK ADVISORS PRIVATE LIMITED',
    'AARUSH (PHASE III) LOGISTICS PARK PRIVATE LIMITED',
    'SADHANA ENVIRO ENGINEERING SERVICES PRIVATE LIMITED',
    'AKM AGRO PROCESSING PRIVATE LIMITED',
    'PRIMEDICAL SOLUTIONS (OPC) PRIVATE LIMITED',
    'SHREM AIRPORT HOTELS PRIVATE LIMITED',
    'ACCURATE BIOTECH SEED INDIA PRIVATE LIMITED',
    'SLMDS SKILL DEVELOPMENT PRIVATE LIMITED',
    'OSSIS INFOTECH PRIVATE LIMITED',
    'YOUAPPI INDIA PRIVATE LIMITED',
    'FUTUROTECH LIFESTYLE PRODUCTS PRIVATE LIMITED',
    'RANJAN GAMBHIR LEGACY PRIVATE LIMITED',
    'HYDMARK APPLICON PRIVATE LIMITED',
    'PRAVANJAN MOHANTY CONSTRUCTION PRIVATE LIMITED',
    'INSPIRAR MOBITECH PRIVATE LIMITED',
    'XPERTSOL SERVICES PRIVATE LIMITED',
    'SFV PROPERTIES PRIVATE LIMITED',
    'SESRITHA TECHNOLOGY INDIA PRIVATE LIMITED',
    'MIA&J FOOD STORE PRIVATE LIMITED',
    'HIPPIE DELUXE PRIVATE LIMITED',
    'REVIVE KNOWLEDGE PRIVATE LIMITED',
    'BRAINSTEM POWER CONVERSION PRIVATE LIMITED',
    'BONLI FARMER PRODUCER COMPANY LIMITED',
    'SUSTAINABLE EMPLOYERISM HR SOLUTIONS (OPC) PRIVATE LIMITED',
    'VANDEY CONSULTANCY SERVICES PRIVATE LIMITED',
    'FITNESS HOOK PRIVATE LIMITED',
    'SILGAN DISPENSING SYSTEMS INDIA PRIVATE LIMITED',
    'OOM DIGIWAY PRIVATE LIMITED',
    'AM PROTOTYPING LABS PRIVATE LIMITED',
    'ORIN TECHNOSYS PRIVATE LIMITED',
    'ACCSON BUILDERS PRIVATE LIMITED',
    'R. SAI TRANS LOGISTICS PRIVATE LIMITED',
    'JASRAJ SPACES PRIVATE LIMITED',
    'JYOTI INTERIORS PRIVATE LIMITED',
    'VAULTRA ENERGY SOLUTIONS PRIVATE LIMITED',
    'AMMAPETTAI KALANJIA JEEVIDAM PRODUCER COMPANY LIMITED',
    'ASSOCIATION FOR EQUITABLE EDUCATIONAL SPACES',
    'NATIVEMENTOR PRIVATE LIMITED',
    'OWNSTYLE AGRO PRIVATE LIMITED',
    'HAPPYEASYGO INDIA PRIVATE LIMITED',
    'REMINISCENCE PUBLICATION PRIVATE LIMITED',
    'STENJOY CLUB AND RESORTS PRIVATE LIMITED',
    'CRAMOISI ART PRIVATE LIMITED',
    'KRESTON RANGAMANI BUSINESS ADVISORS PRIVATE LIMITED',
    'SEABRIDGE MARINE AGENCIES PRIVATE LIMITED',
    'KALPANABEN PATANWALA REAL ESTATES (OPC) PRIVATE LIMITED',
    'ALITYART (OPC) PRIVATE LIMITED',
    'ZEROMED INTEGRATED PRINTING SOLUTIONS PRIVATE LIMITED',
    'BRAJVRINDA ORNAMENT PRIVATE LIMITED',
    'LDR CORPORATE SOLUTIONS PRIVATE LIMITED',
    'CONNECTED IO PRIVATE LIMITED',
    'EDIT 25 LIFESTYLE PRIVATE LIMITED',
    'ELEMENTS HR SERVICES PRIVATE LIMITED',
    'STONE CASTLE FIDUCIARY SERVICES PRIVATE LIMITED',
    'E-PROCUREMENT TECHNOLOGIES SEZ PRIVATE LIMITED',
    'CYGENICA PRIVATE LIMITED',
    'WAY DOT COM INDIA PRIVATE LIMITED',
    'VANIKA COMMERCIAL AND HOLDINGS PRIVATE LIMITED',
    'INNOVSOURCE FACILITIES PRIVATE LIMITED',
    '3KSL TRANSPORT PRIVATE LIMITED',
    'NISSAR OVERSEAS PRIVATE LIMITED',
    'ROAST AND FRY INDUSTRIES PRIVATE LIMITED',
    'SYNTHESIS SIMULATION TECHNOLOGIES PRIVATE LIMITED',
    'HYDROBACCUS INITIATIVE PRIVATE LIMITED',
    'AGROTECH RISK PRIVATE LIMITED',
    'LUNARJUNA DESIGNS PRIVATE LIMITED',
    'UNRAVEL DATA SYSTEMS PRIVATE LIMITED',
    'KITSUN APPLIANCES PRIVATE LIMITED',
    'SHRI AKSHAR AGRO-FOREST FARMS PRIVATE LIMITED',
    'KD CARE AGRO PRODUCER COMPANY LIMITED',
    'ADVANTAGE AGRI GAIN INTERNATIONAL PRIVATE LIMITED',
    'LEANCROP TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'PAIS BIOTECH INDIA PRIVATE LIMITED',
    'PREPEND TECHNOLOGIES PRIVATE LIMITED',
    'HALLPARTY PLATFORMS PRIVATE LIMITED',
    'CAMPERMYTRIP INDIA PRIVATE LIMITED',
    'RDA BULK PACKAGING INDIA PRIVATE LIMITED',
    'BANGASHREE FARMERS PRODUCER COMPANY LIMITED',
    'GULJAG SAYAKHA CHEMICALS PRIVATE LIMITED',
    'SHIKSHAN UNIFORMS PRIVATE LIMITED',
    'BISWAS & ROY DIGITAL PRIVATE LIMITED',
    'VISSION TECH INNOVATIONS PRIVATE LIMITED',
    'UMASHANKAR REALHOMES PRIVATE LIMITED',
    'BURLY SINKS PRIVATE LIMITED',
    'ONSHORE ENGINEERING AND PROJECTS PRIVATELIMITED',
    'WHATZNOT TECHNOLOGY (OPC) PRIVATE LIMITED',
    'BUYNBAND TECH PRIVATE LIMITED',
    'WW TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'KATCH EXPORTS PRIVATE LIMITED',
    'KARA AUTOCORP PRIVATE LIMITED',
    'ESSEM INDUSTRIES PRIVATE LIMITED',
    'PLANTREATS PRIVATE LIMITED',
    'AURUS PETROCHEM PRIVATE LIMITED',
    'DOVETAIL INVESTMENT MANAGEMENT INDIA (IFSC) PRIVATE LIMITED',
    'SPICE FLO EXPORTS PRIVATE LIMITED',
    'INTERNATIONAL KNOWLEDGE ACADEMY PRIVATE LIMITED',
    'POSITIVE VIBES CONSULTING PRIVATE LIMITED',
    'VEER VASU TEXTILES PRIVATE LIMITED',
    'CRAYOSA PRIVATE LIMITED',
    'SKYWINDS SOLUTIONS PRIVATE LIMITED',
    'ADORNESPACE INFRASTRUCTURE PRIVATE LIMITED',
    'SJ MAHARATH HOLDINGS PRIVATE LIMITED',
    'APPBUDDY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ICONIC CREATIONS PRIVATE LIMITED',
    'SAX AND ROY PRIVATE LIMITED',
    'MEHLA BROTHERS PRIVATE LIMITED',
    '9ENVOY TECHNOLOGIES PRIVATE LIMITED',
    'ARCMACH PRIVATE LIMITED',
    'SPBCG PRODUCTS AND SERVICES (OPC) PRIVATE LIMITED',
    'ERAM POWER ELECTRONICS PRIVATE LIMITED',
    'AARIER PHARMA PRIVATE LIMITED',
    'ECOMDUKES PRIVATE LIMITED',
    'QUEST SOCIAL MEDIA PRIVATE LIMITED',
    'BRIGHT DIGITAL GOLD PRIVATE LIMITED',
    'GOLDMAN SOFTECH PRIVATE LIMITED',
    'RIGHT EXPRESS PRIVATE LIMITED',
    'DEEP ALGORITHMS SOLUTIONS PRIVATE LIMITED',
    'NESTPACK PRIVATE LIMITED',
    'SPV QONTRAC INDIA PRIVATE LIMITED',
    'R-LIFE ENTERPRISE PRIVATE LIMITED',
    'GROWFLINT TECHNOLOGIES PRIVATE LIMITED',
    'ARTHA ELECTRONICS AND SOLUTIONS (OPC) PRIVATE LIMITED',
    'STACKPOS IT SOLUTIONS INDIA PRIVATE LIMITED',
    'ACE AVIATION PRIVATE LIMITED',
    'WORLDWIDE TRANSCRIPTS PRIVATE LIMITED',
    'SKVI GLOBAL ENTERPRISE PRIVATE LIMITED',
    'EXCEL R LOGISTICS PRIVATE LIMITED',
    'ROROSAUR FOODTECH PRIVATE LIMITED',
    'MAHARIT PROJECTS PRIVATE LIMITED',
    'INFOSEC NINJA PRIVATE LIMITED',
    'IWA INDIA FOUNDATION',
    'AARG INBUILDO PRIVATE LIMITED',
    'INNOVUS CONCEPT PRIVATE LIMITED',
    'AGRITECHIES INDIA PRIVATE LIMITED',
    'NOVEAU HOSPITALITY (PRIVATE) LIMITED',
    'ICAMP EDTECH FOUNDATION',
    'BIGBUCKTREE INDIA PRIVATE LIMITED',
    'ASCEND PERFORMANCE MATERIALS INDIA PRIVATE LIMITED',
    'HILABS INDIA PRIVATE LIMITED',
    'CONCENTRIC CONSULTING INDIA PRIVATE LIMITED',
    'FINASSIST CAPITAL ADVISORS PRIVATE LIMITED',
    'SCORPIO SEALINGS PRIVATE LIMITED',
    'RITANSHI STEEL PROCESSORS PRIVATE LIMITED',
    'AXIS GREEN MOBILITY PRIVATE LIMITED',
    '5GX GLOBAL FINTECH PRIVATE LIMITED',
    'TECHIES LOGISTICS INDIA PRIVATE LIMITED',
    'OPTX INDIA PRIVATE LIMITED',
    'WIKI NEXUS PRIVATE LIMITED',
    'TAGBAG CORNERSTONE PRIVATE LIMITED',
    'DYNA4CAST TECHNOLOGIES PRIVATE LIMITED',
    'ARTHAM MICRO CARE FOUNDATION',
    'C M HEALING HANDS MULTI SPECIALITY HOSPITAL PRIVATE LIMITED',
    'KIDS MAGIK STATIONERY PRIVATE LIMITED',
    'ROUTE IGNITE SOLUTIONS PRIVATE LIMITED',
    'ZOHO COMMUNICATIONS PRIVATE LIMITED',
    'ZHUZOOR INFRATECH PRIVATE LIMITED',
    'WORTEL INFRASTRUCTURE PRIVATE LIMITED',
    'ORCASIA (OPC) PRIVATE LIMITED',
    'MCURA MOBILE HEALTH PRIVATE LIMITED',
    'SEKURA ENERGY PRIVATE LIMITED',
    'KYRO-SAAS TECHNOLOGIES PRIVATE LIMITED',
    'TRUERA (INDIA) PRIVATE LIMITED',
    'PFEXIM POWER TECH SOLUTIONS PRIVATE LIMITED',
    'SET SPROUT CONSULTING (OPC) PRIVATE LIMITED',
    'NEXTNOWO PRIVATE LIMITED',
    'MYRIAD RESOURCES PRIVATE LIMITED',
    'COSMIC CRF LIMITED',
    'FINOFY TECHNOLOGIES PRIVATE LIMITED',
    'RADIANCE KA SUNRISE SIX PRIVATE LIMITED',
    'VISCON REALTY PRIVATE LIMITED',
    'S.M.U.L. FOODS PRIVATE LIMITED',
    'HEMABH TECHNOLOGY PRIVATE LIMITED',
    'BENVAR PRIVATE LIMITED',
    'LYRA BEAUTY PRIVATE LIMITED',
    'CREDMART SERVICES PRIVATE LIMITED',
    'ITBRAINS CONSULTANCY AND SERVICES PRIVATE LIMITED',
    'LOGICX MEDIA TECH PRIVATE LIMITED',
    'DRSIT MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'GREENSUTRA SUSTAINABLE SOLUTIONS PRIVATELIMITED',
    'POCKETBILL SOFTWARE LABS PRIVATE LIMITED',
    'ARAGEN FOUNDATION',
    'SUBHE ELEARNING PRIVATE LIMITED',
    'LOYALTY SOLUTIONS & RESEARCH PRIVATE LIMITED',
    'LIVE EASY SERVICES PRIVATE LIMITED',
    'COOPTIONS CORPORATION LIMITED',
    'METALLIC BRIDGE PRIVATE LIMITED',
    'CUTEEDGE HOME DECORS PRIVATE LIMITED',
    'SHAIKHTECH INDIA PRIVATE LIMITED',
    'BIOSTIGE HEALTHCARE PRIVATE LIMITED',
    'TECHNOKHETI VENTURES PRIVATE LIMITED',
    'RETROGEN PRIVATE LIMITED',
    'SMMAHAVEER TRADERS PRIVATE LIMITED',
    'GROUNDOPS PRIVATE LIMITED',
    'TS IMAGINE INDIA PRIVATE LIMITED',
    'RAMA KRISHNA MULTISERVICES PRIVATE LIMITED',
    'EPIC88 TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'CREATIVE GRAPHICS PREMEDIA PRIVATE LIMITED',
    'ANAY CHEM PRIVATE LIMITED',
    '360 FMS PRIVATE LIMITED',
    'AIFHA INFOTECH SOLUTIONS PRIVATE LIMITED',
    'KNOWLEDGECODE TECHNOLOGY PRIVATE LIMITED',
    'AKJ REAL TECH PRIVATE LIMITED',
    'DATABOT EDUCATION PRIVATE LIMITED',
    'SKILLR TALENT PRIVATE LIMITED',
    'URBANBY PRIVATE LIMITED',
    '7IMPACT CONNECTIONS PRIVATE LIMITED',
    'SPECIFIC TITLE PRIVATE LIMITED',
    'ARCNORD PRIVATE LIMITED',
    'E-ASHWA AUTOMOTIVE (BALAGHAT) PRIVATE LIMITED',
    'FPEL NANDGAON 2 PRIVATE LIMITED',
    'FLORET VACATION PRIVATE LIMITED',
    'ELATED BUTTERFLY PRIVATE LIMITED',
    'TATA PASSENGER ELECTRIC MOBILITY LIMITED',
    'MAKZ KPO PRIVATE LIMITED',
    'ARAHAN FOODS PRIVATE LIMITED',
    'SIMATEK PRIVATE LIMITED',
    'MADOVERBUILDING AI PRIVATE LIMITED',
    'SPACE A PRIVATE LIMITED',
    'GOKIWI TECH PRIVATE LIMITED',
    'STRINGEE INDIA PRIVATE LIMITED',
    'SMARTRUN TECHNOLOGIES PRIVATEÂ LIMITED',
    'TERRESTRIAL FOODSÂ LIMITED',
    'MAHINDRA ELECTRIC AUTOMOBILE LIMITED',
    'RUI STEEL INDIA PRIVATE LIMITED',
    'BEST AUTO PRIVATE LIMITED',
    'ROD RETAIL PRIVATE LIMITED',
    'WHEELSEYE TECHNOLOGY INDIA PRIVATE LIMITED',
    'WELSPUN-KAVERI INFRAPROJECTS JV PRIVATE LIMITED',
    'DBL CHANDIKHOLE BHADRAK HIGHWAYS LIMITED',
    'SANGHI JEWELLERS PRIVATE LIMITED',
    'EXOS IT MANAGEMENT PRIVATE LIMITED',
    'AIR INDIA EXPRESS LIMITED',
    'PIONEER POLYLEATHERS PRIVATE LIMITED',
    'CONTROL TECHNIQUES INDIA PRIVATE LIMITED',
    'HORIZON INDUSTRIAL PARKS PRIVATE LIMITED',
    'AJIT INDUSTRIES PRIVATE LIMITED',
    'ANALOG LEGALHUB TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GRANULDISK INDIA PRIVATE LIMITED',
    'BSR INFRATECH INDIA LIMITED',
    'NORMA DND PRODUCTS PRIVATE LIMITED',
    'ICE MT INDIA PRIVATE LIMITED',
    'META SOFT TECH SYSTEMS PRIVATE LIMITED',
    'TIETOEVRY CONNECT INDIA PRIVATE LIMITED',
    'PRICEWATERHOUSECOOPERS ACCELERATION CENTRE INDIA PRIVATE LIMITED',
    'TREMARK ACCOUNTING PRIVATE LIMITED',
    'ANJANEYA COLD STORAGE PRIVATE LIMITED',
    'TACO EV COMPONENT SOLUTIONS PRIVATE LIMITED',
    'TACO PUNCH POWERTRAIN PRIVATE LIMITED',
    'TECHKNOWGREEN SOLUTIONS LIMITED',
    'INAPAYMENTS SOFTWARE PRIVATE LIMITED',
    'VRIZE INDIA PRIVATE LIMITED',
    'SISCOL INFRA PRIVATE LIMITED',
    'JSW REALTY PRIVATE LIMITED',
    'FNP E RETAIL PRIVATE LIMITED',
    'TIETOEVRY FINTECH INDIA PRIVATE LIMITED',
    'COVERSELF BENEFITS INDIA PRIVATE LIMITED',
    'VDMS SOLUTIONS PRIVATE LIMITED',
    'ANGENE CHEMICAL PRIVATEÂ LIMITED',
    'CRYTONIX REMOTE TECH WORKS PRIVATE LIMITED',
    'INDONG TEA COMPANY LIMITED',
    'RIVU INFRASTRUCTURAL DEVELOPERS PRIVATE LIMITED',
    'AADVI TECH SOLUTIONS PRIVATE LIMITED',
    'HORNET DYNAMICS PRIVATE LIMITED',
    'JMJ FINTECH LIMITED',
    'GMP FORMULATIONS PRIVATEÂ LIMITED',
    'INTERVIEWBIT TECHNOLOGIES PRIVATE LIMITED',
    'AURUM ANALYTICA PRIVATE LIMITED',
    'INTELLIMATION.AI SOFTWARE PRIVATE LIMITED',
    'INDOSPIRIT PRIVATE LIMITED',
    'D b h international private limited',
    'Best seller united india private limited',
    'Image public relations private limited',
    'Star and sitara wellness limited',
    'L&t shipbuilding limited',
    'Imprimis life pr private limited',
    'Gateway east india private limited',
    'Future People Services Limited',
    'Rci container services private limited',
    'Streamline aqua private limited',
    'Worli realty private limited',
    'Kumar horticulture pvt ltd',
    'Sunrise dairy private limited',
    'Rose(india)polyweaves pvt ltd',
    'Maskara textiles pvt ltd',
    'KANAI SHIKHAR PRIVATE LIMITED',
    'Aras overseas private limited tfr. from maharashtra to delhi',
    'Empower oilfield solutions private limited',
    'Tams fine ceramics private limited',
    'Ceramic services limited',
    'Bencera resources private limited',
    'Bhaum realty private limited',
    'Mformation software technologies india private limited',
    'Abhiman technologies private limited',
    'Astute software private limited',
    'NYK LINE (INDIA) Private Limited',
    'Itinfo software (india) private limited',
    'WELSPUN IRON AND STEEL PRIVATE LIMITED',
    'Shaligram industries private limited',
    'Health connect compusoft private limited',
    'F r retail destination private limited',
    'Yeshas education academy private limited',
    'Safed tracom pvt ltd',
    'Vilsoft technologies limited',
    'Millennia infrastructure private limited',
    'Pennzoil quaker state india limited',
    'Vivira chemicals pvt ltd',
    'Gujarat steels private limited',
    'SVA TRADELINK PRIVATE LIMITED',
    'SIEMENS INDUSTRY SOFTWARE COMPUTATIONAL DYNAMICS INDIA PRIVATE LIMITED',
    'Mvk energy private limited',
    'Solutions 4 energy private limited',
    'Syniverse clearing house india private limited',
    'Netcracker technology india private limited',
    'Sodexo facilities management services india private limited',
    'Davis langdon kpk (india)private limited',
    'Meenakshi jewel palace private limited',
    'PWC STRATEGY& (INDIA) PRIVATE LIMITED',
    'PEOPLE COMBINE EDUCATIONAL INITIATIVES PRIVATE LIMITED',
    'Agra chetna projects private limited',
    'Kma infra private limited',
    'Fast track diagnostics asia private limited',
    'Sodexo technical services india private limited',
    'Perrigo laboratories india private limited',
    'Armstrong world industries (india) private limited',
    'Innovative micro systems private limited',
    'Inx music private limited',
    'Parexgroup construction products private limited',
    'Powerica sales and services private limited',
    'Ifmr holdings private limited',
    'Ambika sugar and agro industries private limited',
    'BANKIM CONSULTANCY PRIVATE LIMITED',
    'Shasun biotech limited',
    'Finetune building private limited',
    'Straft developments private limited',
    'Suvidhinath buildtech private limited',
    'Avenue realty private limited',
    'Omkar commodities limited',
    'Sarda equipments private limited',
    'ALSTOM RAIL TRANSPORTATION INDIA PRIVATE LIMITED',
    'Takecare logistics park (india) private limited',
    'Amber road software private limited',
    'Arm wealth management services private limited',
    'Motilal oswal securities limited',
    'Advanced synchro tech private limited',
    'Capital first securities limited',
    'SKYLER ENTERPRISES PRIVATE LIMITED',
    'Wellworth capital services private limited',
    'Ntrust infotech private limited',
    'Avenue minerals & energy private limited',
    'Nirman advisory private limited',
    'Sanchez capital services private limited',
    'LAXMI MART PRIVATE LIMITED',
    'JUBILANT CHEMSYS LIMITED',
    'PATEL HYDRO POWER PRIVATE LIMITED',
    'SANAT PRODUCTS LIMITED',
    'KDB SYSTEMS AND SERVICES PRIVATE LIMITED',
    'AMROON FOODS PRIVATE LIMITED',
    'V K BAJAJ INVESTMENT PRIVATE LIMITED',
    'AUTOCARE MART PRIVATE LIMITED',
    'MARTI INDIA PRIVATE LIMITED',
    'SANWARIYA GAS LIMITED',
    'CONAX ACCESS SYSTEMS PRIVATE LIMITED',
    'AJAY REALTECH (INDIA) PRIVATE LIMITED',
    'JUBILANT STOCK HOLDING PRIVATE LIMITED',
    'AMPERE SOFTWARE PRIVATE LIMITED',
    'SARB ADVISORS PRIVATE LIMITED',
    'ARHYAMA POWER PROJECTS PRIVATE LIMITED',
    'FORTUNA HOUSING AND PLANNERS PRIVATE LIMITED',
    'BANARAS BEAD BUSINESS PRIVATE LIMITED',
    'VIRTUSA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SUMMIT DISCLOSURE SOLUTIONS INDIA PRIVATE LIMITED',
    'whatnot retail private limited',
    'KAMAL WINERIES PRIVATE LIMITED',
    'TVS AUTO ASSIST (INDIA) LIMITED',
    'ALVIN MEDICARE PRIVATE LIMITED',
    'BHAVANS STARCO BUILDERS PRIVATE LIMITED',
    'AMARKANTAK FOODS PRIVATE LIMITED',
    'AUMA DRIVES INDIA PRIVATE LIMITED',
    'MALAPARAMBA COMMERCIAL COMPLEX PRIVATE LIMITED',
    'GENOA RICE MILLS PRIVATE LIMITED',
    'LEARNING SHADES PRIVATE LIMITED',
    'PRANAAM CONSULTANTS PRIVATE LIMITED',
    'VISION P LASIK EYE CENTRE PRIVATE LIMITED',
    'BIRBAL TRADING PRIVATE LIMITED',
    'ADITYA PRABHA IMPEX PRIVATE LIMITED',
    'TECHNO FINANCIAL CONSULTANTS PRIVATE LIMITED',
    'CATTLE REMEDIES INDIA LIMITED',
    'GTA DATA SERVICES (INDIA) PRIVATE LIMITED',
    'AJARA VENTURES LIMITED',
    'ALYX ENTERPRISES PRIVATE LIMITED',
    'DICK ENTERPRISES PRIVATE LIMITED',
    'ANPEE MERCHANTILE LIMITED',
    'Easylink Services Corporation India private Limited',
    'SOMA INVESTMENTS LTD',
    'BHILWARA HOLDINGS LTD',
    'LONGWAY BUSINESS SOLUTIONS Limited',
    'NEW DELHI INDUSTRIAL PROMOTORS AND INVESTORS LTD',
    'MEDIELECT ESTATES PRIVATE LIMITED',
    'PYRO NETWORKS PRIVATE LIMITED',
    'MELINEX INVESTMENT AND FINANCE PRIVATE LIMITED',
    'MGF AUTOMOTIVE SALES PRIVATE LIMITED',
    'MATIS FINANCIALS PRIVATE LIMITED',
    'PATIL REALTY PRIVATE LIMITED',
    'FOCUS FILMS PRIVATE LIMITED',
    'MGR HOLDINGS PRIVATE LIMITED',
    'OPUS ONE DESIGN PRIVATE LIMITED',
    'MINDA AUTOMOTIVE SOLUTIONS LIMITED',
    'MINDA SAI LIMITED',
    'Navigator Travel Services Private Limited',
    'WELLMAN HINDUSTAN Private Limited',
    'TEMPLE GARMENT MANUFACTURING COMPANY PRIVATE LIMITED',
    'MOHAN APARTMENTS PRIVATE LIMITED',
    'QVC Realty Co. Limited',
    'MUKUL AGENCIES PRIVATE LIMITED',
    'RLD ENTERPRISES PRIVATE LIMITED.',
    'EEE REALTY PRIVATE LIMITED',
    'EVELYN HERBALS PRIVATE LIMITED',
    'EVERSHINE GARMENTS PRIVATE LIMITED',
    'EMOTIONS INFRASTRUCTURE PRIVATE LIMITED',
    'ENOCH ENTERPRISES PRIVATE LIMITED',
    'Rudra Innovations & Creations Private Limited',
    'Rudra Real Estate (Gorakhpur) Private Limited',
    'FAIR AGRO EXPORTS Private Limited',
    'FIBCOM INDIA LIMITED',
    'Firefly e-Ventures Limited',
    'Elegance Solutions Private Limited',
    'Flipkart Digital Media Private Limited',
    'Florence Investech Limited',
    'Fabrizio Real Estates Private Limited',
    'FOUR WINDS PROJECTS PRIVATE LIMITED.',
    'DBH INVESTMENTS PRIVATE LIMITED',
    'CASE COMPONENTS LIMITED',
    'BHARAT STARCH PRODUCTS PRIVATE LIMITED',
    'KINAPSE INDIA SCIENTIFIC SERVICES PRIVATE LIMITED',
    'GANESH PROMOTERS PRIVATE LIMITED',
    'ROSEBAY POLYMERS PRIVATE LIMITED',
    'Estee Advisors Private Limited',
    'Religare Comtrade Limited',
    'Jindal Stainless (Hisar) Limited',
    'HANDS ON DASTKAR ARTISAN DEVELOPMENT PRIVATE LIMITED',
    'FOREVER MULTIMEDIA PRIVATE LIMITED',
    'CHEP MANUFACTURING AND EQUIPMENT PRIVATE LIMITED',
    'YOJNA INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'PIPL MANAGEMENT CONSULTANCY AND INVESTMENT PRIVATE LIMITED',
    'BOSTON SCIENTIFIC SERVICES PRIVATE LIMITED',
    'ANVI HOUSING PRIVATE LIMITED',
    'IECPE INDIA PRIVATE LIMITED',
    'A.G. PREMIUM STEERINGS AND MOULDINGS PRIVATE LIMITED',
    'JINGYI TRANS CLIMATE CONTROL SYSTEM (INDIA) PRIVATE LIMITED',
    'AACT ADVISORS PRIVATE LIMITED',
    'ADGYDE SOLUTIONS PRIVATE LIMITED',
    'SWEDA PROMOTIONS INDIA PRIVATE LIMITED',
    'SOLITAIRE METROPOLIS PRIVATE LIMITED',
    'METRO HOTELS & RESORTS PRIVATE LIMITED',
    'ANVI HOLDINGS PRIVATE LIMITED',
    'TECH MAHINDRA GROWTH FACTORIES LIMITED',
    'CELERITIFINTECH SERVICES INDIA PRIVATE LIMITED',
    'KOGENTIX TECHNOLOGIES PRIVATE LIMITED',
    'MASS IT CHANNEL PRIVATE LIMITED',
    'DONRIVER INDIA PRIVATE LIMITED',
    'QUADGEN WIRELESS ENGINEERING SERVICES PRIVATE LIMITED',
    'MSTAR SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'SAHITI REAL ESTATES INDIA PRIVATE LIMITED',
    'PAKSHIN ENTERPRISES PRIVATE LIMITED',
    'LUXURIA COMPLEX PRIVATE LIMITED',
    'SERENE ELITE SERVICES PRIVATE LIMITED',
    'SAHRUDAYA HEALTH CARE (KARIMNAGAR) PRIVATE LIMITED',
    'DLJM ADVISORS PRIVATE LIMITED',
    'EGAR DIGITAL PRIVATE LIMITED',
    'PATIENT FOCUS PRIVATE LIMITED',
    'EVRIKSH HEALTHCARE PRIVATE LIMITED',
    'H.M. INDUSTRIAL PRIVATE LIMITED',
    'EMBERIFY INNOVATIONS PRIVATE LIMITED',
    'SPICE IOT SOLUTIONS PRIVATE LIMITED',
    'ACQUISORY LAND HOLDINGS PRIVATE LIMITED',
    'EFFERCHEM PRIVATE LIMITED',
    'AVENTICS INDIA PRIVATE LIMITED',
    'IIFL WEALTH ALTIORE LIMITED',
    'RELIGARE BUSINESS SOLUTIONS LIMITED',
    'TOOTHBOX PRIVATE LIMITED',
    'TRPL ROADWAYS PRIVATE LIMITED',
    'LM MEDIA SERVICES PRIVATE LIMITED',
    'SKAP FORGING PRIVATE LIMITED',
    'RAJYASHREE ENTRADE LIMITED',
    'PERPLEX MERCANTILES LIMITED',
    'SNCL BUILDERS LIMITED',
    'MADEVSAG RETAIL PRIVATE LIMITED',
    'SWINKPAY TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'CURLEW SEAVIEW LIMITED',
    'DCL REAL ESTATES LIMITED',
    'COPOBO HIGHRISE LIMITED',
    'LINKTAG GLOBAL SERVICES PRIVATE LIMITED',
    'ANANTA GLOBAL HOSPITALITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'VODAFONE INDIA DIGITAL LIMITED',
    'RUHEL MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'FURSAN PROJECTS LIMITED',
    'LEMARK SOLUTIONS PRIVATE LIMITED',
    'CURLEW RIVERVIEW LIMITED',
    'CURLEW SUNSHINE LIMITED',
    'CURLEW HIGHRISE LIMITED',
    'FORTUITY INVESTMENTS PRIVATE LIMITED',
    'SAIKARAN BUILDTECH PRIVATE LIMITED',
    'KIAAN SPORTS & NUTRITION PRIVATE LIMITED',
    'RATHNA SPECIALITY TAPES PRIVATE LIMITED',
    'FUSION BEVERAGES PRIVATE LIMITED',
    'VEDANTA STAR LIMITED',
    'INFINITE FINTECH PRIVATE LIMITED',
    'FEEDERTECH SHIPPING INDIA PRIVATE LIMITED',
    'JUSTONTIME LOGISTICS INDIA PRIVATE LIMITED',
    'SLCPAS SOFTWARE PRIVATE LIMITED',
    'GENISYS PROPERTY BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'SAYAJI HOTELS MANAGEMENT LIMITED',
    'FINTECH GLOBAL CENTER PRIVATE LIMITED',
    'CONVERTCART PRIVATE LIMITED',
    'SNP MANAGEMENT ACCOUNTING PRIVATE LIMITED',
    'SOLITON INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'CAMPUS AI PRIVATE LIMITED',
    'CONSTAR PROPERTIES PRIVATE LIMITED',
    'DAXIT BUYING SERVICE PRIVATE LIMITED',
    'ADAYA ASSOCIATES PRIVATE LIMITED',
    'Jac ground handling & allied services private limited',
    'Wadhwa and associates realtors private limited',
    'FLAGSHIP INFRASTRUCTURE LIMITED',
    'Fagris medica private limieted',
    'Indo global township private limited',
    'Harkrish infrastructure private limited',
    'Nirvaana spaces private limited',
    'Justify tracom private limited',
    'Vanila tracom private limited',
    'Taneka exim private limited',
    'Glebe trading private limited',
    'Menus healthcare services private limited',
    'Veronica-inn hotel & resort private limited',
    'RAYANTRANS TRANSPORTS LOGISTICS PRIVATE LIMITED',
    'ADANI KRISHNAPATNAM CONTAINER TERMINAL PRIVATE LIMITED',
    'Muthoot precious metals limited',
    'Baltimore Trading Private Limited tfr. from m,umbai to delhi',
    'Kavita securities private limited tfr. from mumbai to delhi',
    'Jindal south west finance investments private limited',
    'Wachovia investments private limited tfr. from mumbai to delhi',
    'Prabhava agro-farms private limited',
    'Adani township & real estate company private limited',
    'Sanand properties private limited',
    'Kumar builders mumbai realty private limited',
    'Antara housing private limited',
    'Newscale software private limited',
    'MINTKART INDIA PRIVATE LIMITED',
    'Aadarshini construction private limited',
    'PROLIFE FINE AND SPECIALTY CHEMICALS PRIVATE LIMITED',
    'Shree nuj constructions private limited',
    'Pizzeria fast foods restaurants (madras) private limited',
    'Arshiya transport and handling limited',
    'Shriram chits (maharashtra) limited',
    'Amideep ventures private limited',
    'Ujjain future bazaar private limited',
    'Numerify software india private limited',
    'Cadenza solutions private limited',
    'Citadel homes private limited',
    'Ashoka infra projects private limited',
    'Rajarshi wheels private limited',
    'CLIX FINANCE INDIA PRIVATE LIMITED',
    'Naresh deep sea shipping and manning services private limited',
    'Sussegado bar & kitchen private limited',
    'Zenwat solutions private limited',
    'Senthil business associates private limited',
    'Nv developers private limited',
    'Qwikcilver solutions private limited',
    'OATH GLOBAL BRANDS (INDIA) PRIVATE LIMITED',
    'Metro woven sacks private limited',
    'Harlalka silk mills private limited',
    'Indra fabrics private limited',
    'AAHAAN COMMERCIALS PRIVATE LIMITED',
    'Pita shree garments private limited',
    'Mahindra integrated township limited',
    'Pangenomics international private limited',
    'Swanston multiplex cinemas private limited',
    'World of winning india private limited',
    'Kushal infrastructure private limited',
    'Precious trading and investments limited',
    'Redcentric solutions private limited',
    'Isagro (asia) agrochemicals private limited',
    'Haldyn polymers private limited',
    'Sun metallics & alloys private limited',
    'Sheth developers & realtors (india) limited',
    'House full international limited',
    'Forever living trading (india) private limited',
    'Hindustan cargo limited',
    'Everwin marine service private limited',
    'Deep jayant commercial company pvt ltd',
    'Genx entertainment limited',
    'Networth softtech limited',
    'Jaagruthi agro foods private limited',
    'Sunquest information systems (india) private limited',
    'Kkss builders private limited',
    'Dynamic assignments private limited',
    'R.s.j.k.international private limited',
    'Salooni estates private limited',
    'Lehman brothers advisers private limited',
    'Vasundara prosys private limited',
    'Kwench global technologies private limited',
    'The walt disney company (india) private limited',
    'Inizio enterprises private limited',
    'United home entertainment private limited',
    'Popuri plant-tech private limited',
    'Nethawk networks india private limited',
    'Jl power ventures private limited',
    'Enrich hair and skin care products private limited',
    'Rajdhani tours and travels private limited',
    'MONARCH NETWORTH COMTRADE LIMITED',
    'SAKALDHARA BUILDERS PRIVATE LIMITED',
    'Spice Labs Private Limited',
    'HSB Corporate Consultants Private Limited',
    'SSB Consultants & Management Services Private Limited',
    'OLYMPUS OVERSEAS LIMITED',
    'AARDE TECHNOSOFT PRIVATE LIMITED',
    'REAN CLOUD INDIA PRIVATE LIMITED',
    'Coralbay Enterprises Private Limited',
    'KMC Infratech Road Holdings Limited',
    'MILLENNION LOGISTICS PRIVATE LIMITED',
    'GIO Exim and Logistics Private Limited',
    'Rayce Electronic Intelligence India Private Limited',
    'SANCO TRANSPORT LIMITED',
    'KANDIAMMAN PROPERTIES AND HOLDINGS PRIVATE LIMITED',
    'PUSHYAMI BUILDERS PRIVATE LIMITED',
    'MAGHA BUILDERS PRIVATE LIMITED',
    'GSH TECHNICAL SERVICES PRIVATE LIMITED',
    'OSMNEZ TECHNOLOGIES PRIVATE LIMITED',
    'MADHU JAYANTI HOUSING PRIVATE LIMITED',
    'SOHA SYSTEMS INDIA PRIVATE LIMITED',
    'CYNOSURE INTERFACE SERVICES PRIVATE LIMITED',
    'RASA NETWORKS INDIA PRIVATE LIMITED',
    'FXLynx Solutions Private Limited',
    'Liv Artificial Intelligence Private Limited',
    'GLOW PRIME TECHNOLOGIES PRIVATE LIMITED',
    'Coeo Labs Private Limited',
    'RANGJEE POLYTEX PRIVATE LIMITED',
    'KABA SECURITY SYSTEMS PRIVATE LIMITED',
    'Planetray Infotech Private Limited',
    'RAM MURTI STEELS PRIVATE LIMITED',
    'NSGC ADVANCED MAGNETECH PRIVATE LIMITED',
    'LAVGAN DOCKYARD Private Limited',
    'MOCHIKO FOOTWEAR PRIVATE LIMITED',
    'ONS STEEL SOLUTIONS PRIVATE LIMITED',
    'MOHAIR INVESTMENT AND TRADINGCOMPANY PRIVATE LIMITED',
    'Ozone Metallics Private Limited',
    'NOIDA TOOL SOLUTIONS PRIVATE LIMITED',
    'NANDOS SERVICES INDIA PRIVATE LIMITED',
    'PAVITRA RESORTS PRIVATE LIMITED',
    'PERFECT COLONISERS PRIVATE LIMITED',
    'NAYEF ESTATES PRIVATE LIMITED',
    'NEHA CREDIT AND INVESTMENT PRIVATE LIMITED',
    'NELSON ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'NELSON PLANNING AND DESIGN PRIVATE LIMITED',
    'PINNACLE INFRACON Limited',
    'SPR DISTILLERIES PRIVATE LIMITED',
    'PHOENICIA SHIPPING COMPANY Private Limited',
    'APOLLO TRICOAT TUBES LIMITED',
    'OMEGA FUTURISTIC PRIVATE LIMITED',
    'OPAL POLYMERS PRIVATE LIMITED',
    'PFC CAPITAL ADVISORY SERVICES LIMITED',
    'PFC GREEN ENERGY LIMITED',
    'PLANTECH INFRASTRUCTURE AND SERVICES LIMITED',
    'Plantronics India Private Limited.',
    'Abjayoni Estates Developers Private Limited',
    'AccountAid Consulting Private Limited',
    'ACME CLEANTECH INFRAVENTURE LIMITED',
    'PPAP SECURITIES ADVISORS PRIVATE LIMITED',
    'PUSHPAK ENTERPRISES PRIVATE LIMITED',
    'FIRST STEP BUILDCON PRIVATE LIMITED',
    'DLF SOUTH POINT LIMITED',
    'GANESH CONTRACTORS AND COLONISERS PRIVATE LIMITED',
    'INDIA TODAY ONLINE PRIVATE LIMITED',
    'AADHAR DEALCOM PRIVATE LIMITED',
    'INDUNIA REALTECH LIMITED',
    'INFOGAIN INDIA BPO PRIVATE LIMITED',
    'INTERGLOBE LUXURY PRODUCTS PRIVATE LIMITED',
    'ISHITANEM COLLECTIONS PRIVATE LIMITED',
    'HIND POCKET BOOKS PVT LTD',
    'JAI COMMERCIAL COMPANY LIMITED',
    'JINDAL EXPORTS LIMITED',
    'JINDAL SURGICALS PVT LTD',
    'JOBCURRY SYSTEMS PRIVATE LIMITED',
    'JSW VALLABH TINPLATE PRIVATE LIMITED',
    'JTEKT SONA AUTOMOTIVE INDIA LIMITED',
    'JustChalo Technologies Private Limited',
    'JYOTI SOFTSULES PRIVATE LIMITED',
    'INTELLIGRAPE SOFTWARE PRIVATE LIMITED',
    'KAMAL VATIKA PRIVATE LIMITED',
    'INTRICATE INVESTMENT SERVICES PRIVATE LIMITED',
    'KLM FABRICS PRIVATE LIMITED',
    'MISTRAL INFOTECH PRIVATE LIMITED',
    'FLATLE TECH PRIVATE LIMITED',
    'BEACH SAND MINERAL INDUSTRIES PRIVATE LIMITED',
    'WOODSHOPPER ONLINE INDIA PRIVATE LIMITED',
    'PIPL BUSINESS ADVISORS AND INVESTMENT PRIVATE LIMITED',
    'FIELD GREEN SOLUTIONS PRIVATE LIMITED',
    'GLOBAL CONSULTANCY AND INVESTMENT PRIVATE LIMITED',
    'RADHIKA INFOSOFT SOLUTIONS PRIVATE LIMITED',
    'SAMSUNG SDS INDIA PRIVATE LIMITED',
    'WEBBYMONKS TECHNOLOGIES PRIVATE LIMITED',
    'KEISANKI TECHNOLOGIES PRIVATE LIMITED',
    'EXELRATE TECHNOLOGY INDIA PRIVATE LIMITED',
    'WAVELABS TECHNOLOGIES PRIVATE LIMITED',
    'SYNCORDIS SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'USE MY VOUCHER TECHNOLOGIES PRIVATE LIMITED',
    'LODHA CORPORATE TRUSTEESHIP PRIVATE LIMITED',
    'CAL MEDIA PRIVATE LIMITED',
    'OPG SURYA VIDYUT PRIVATE LIMITED',
    'SANGAM LIFESTYLE VENTURES LIMITED',
    'BLANKET REALTY INDIA PRIVATE LIMITED',
    'MACHANI RAMESH METAMORPHOSIS PRIVATE LIMITED',
    'ILLUMINEX LED INDIA PRIVATE LIMITED',
    'ENTOMO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MACHANI RAMESH HERITAGE PRIVATE LIMITED',
    'BKG M-SAND PRIVATE LIMITED',
    'CARPASTRETCH INDIA PRIVATE LIMITED',
    'WHITE UNICORN FINVEST PRIVATE LIMITED',
    'PEOPLE COMBINE SOLUTIONS PRIVATE LIMITED',
    'STONERAY TECHNOLOGIES PRIVATE LIMITED',
    'PICSTORIE TECHNOLOGIES PRIVATE LIMITED',
    'RXPE PROJECTS PRIVATE LIMITED',
    'AMBAVAT VENTURES PRIVATE LIMITED',
    'MATERIALS SCIENCE (INDIA) PRIVATE LIMITED',
    'TELESMART SCS LIMITED',
    'FRAKOIN TECHNOLOGIES PRIVATE LIMITED',
    'J. P. INFRA CONSTRUCTIONS PRIVATE LIMITED',
    'JCPL LIFE SCIENCE VENTURES AND HOLDINGS PRIVATE LIMITED',
    'PAEON WELLNESS AND NUTRITION LIMITED',
    'CENTREQ BUSINESS SERVICES PRIVATE LIMITED',
    'DBJ ADVISORY SERVICES PRIVATE LIMITED',
    'JSPL LIFE SCIENCE SERVICES AND HOLDINGS PRIVATE LIMITED',
    'CANADIAN SOLAR INDIA PRIVATE LIMITED',
    'JP INFRA BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'SNCL ENTERTAINMENT LIMITED',
    'SAWANSUKHA GLOBAL PRIVATE LIMITED',
    'PASSION PLAYERS PRIVATE LIMITED',
    'IUNITE TECHNOLOGIES PRIVATE LIMITED',
    'IMAGEGRAFIX SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TEJORA PRIVATE LIMITED',
    'ISPL ADVISORY LIMITED',
    'PALAVA DWELLERS PRIVATE LIMITED',
    'TROPICAL BOVINE GENETICS PRIVATE LIMITED',
    'SYNGIENCE BROADCAST AHMEDABAD LIMITED',
    'ANZA MEDICODE INDIA PRIVATE LIMITED',
    'LIFEFRESH TRADING PRIVATE LIMITED',
    'RCSRRA HR COMPLIANCES CONSULTANTS PRIVATE LIMITED',
    'MAHANSARIA INDUSTRIAL VENTURES PRIVATE LIMITED',
    'OCS TECHNICAL SOLUTIONS INDIA PRIVATE LIMITED',
    'SHIRE BIOTECH INDIA PRIVATE LIMITED',
    'ESILICON ASIC PRIVATE LIMITED',
    'TATANKA PROPERTIES PRIVATE LIMITED',
    'GD FINGROWTH PRIVATE LIMITED',
    'ROCKETO HOSPITALITY PRIVATE LIMITED',
    'BHARAT GAS RESOURCES LIMITED',
    'DANIEL REAL ESTATE PRIVATE LIMITED',
    'DISHMAN IT XELLENCE PRIVATE LIMITED',
    'WECKERLE INDIA PRIVATE LIMITED',
    'APISERO INDIA PRIVATE LIMITED',
    'MRG WORLD PRIVATE LIMITED',
    'CEAT SPECIALTY TYRES LIMITED',
    'L&T HOUSING FINANCE LIMITED',
    'BROOKLAND INFRACON PRIVATE LIMITED',
    'AMNEAL INJECTABLES PRIVATE LIMITED',
    'HARIKRISHNA INSTITUTE OF ONCOLOGY PRIVATE LIMITED',
    'CLAMANT TECH SERVICES PRIVATE LIMITED',
    'INNERFRAME SERVICES PRIVATE LIMITED',
    'PRIMEBUILD DEVELOPERS AND FARMS PRIVATE LIMITED',
    'AFFLUENCE FOOD PROCESSORS PRIVATE LIMITED',
    'FCSL ASSET MANAGEMENT PRIVATE LIMITED',
    'Rishikesh finlease and ivestmentss private limited tfr. from mumbai to delhi',
    'Kamshet investments private limited tfr. from mumbai to delhi',
    'Avishai lifesciences private limited',
    'Motilal oswal real estate investment advisors ii private limited',
    'Four seasons drycleaning company private limited',
    'Capital first limited',
    'Siamed healthcare private limited',
    'Danta enterprises private limited',
    'RIVIERA CARPETS PRIVATE LIMITED',
    'CITOC MOTION PICTURES PRIVATE LIMITED',
    'Kothari pipes and fittings private limited',
    'Anodin healthcare private limited',
    'Future hospitality management limited',
    'Neela telefilms private limited',
    'Jaidev alloys private limited',
    'Rajnigandha developers private limited',
    'Vr specialty chemicals (i) private limited',
    'Divyansh projects (india) private limited',
    'SBI BUSINESS PROCESS MANAGEMENT SERVICESPRIVATE LIMITED',
    'Venus robotics private limited',
    'Amicus insurance broking services private limited',
    'Sumit diagold private limited',
    'Vrusti real estate developers private limited',
    'R&h homes private limited',
    'OMKAR REALTORS ANDHERI PROJECT PRIVATE LIMITED',
    'Dynasty home makers pvt ltd',
    'Triveni mercantiles private limited',
    'Syniverse teledata systems private limited',
    'Cool logistics india private limited',
    'Thiagarajar leasing private limited',
    'Minar organics p ltd',
    'Indu pharma private limited',
    'PRIJA TRADING PRIVATE LIMITED',
    'M-trans india private limited',
    'Choice merchandise broking private limited',
    'Kraftex securities private limited',
    'FAIRWINDS CONSULTANTS PRIVATE LIMITED',
    'Austin global ventures private limited',
    'India infoline finance limited',
    'Jp corp developers (india) private limited',
    'Insp india software development private limited',
    'Kennis business solutions private limited',
    'Kennis consultancy private limited',
    'DENTSU INDIA PRIVATE LIMITED',
    'DENTSU IMPACT PRIVATE LIMITED',
    'Kyra corporate solutions private limited',
    'PF DIGITAL MEDIA SERVICES LIMITED',
    'Sathavahana ispat ltd.',
    'Embassy constructions and developments private limited',
    'Goverdhannath synthetics pvt ltd',
    'Silko multimedia private limited.',
    'Fordon advertising and marketing private limited.',
    'Panchshil overseas pvt.ltd.',
    'Skechers retail india private limited',
    'Ritemed pharma retail private limited',
    'Fidessa trading systems private limited',
    'AVEVA SOFTWARE PRIVATE LIMITED',
    'Shreemayy creation private limited',
    'Storyboard brandcom private limited',
    'Logmein (india) private limited',
    'Blueocean market intelligence services private limited',
    'Heavy metal and tubes limited',
    'Supernova systems private limited',
    'Runwal properties private limited',
    'Runwal builders private limited',
    'Runwal realty private limited',
    'Sublime infrastructure private limited',
    'Orange city infrastructure development private limited',
    'Aargus advisors private limited',
    'ORION PROPERTY MANAGEMENT SERVICES LIMITED',
    'Vanderlande industries software private limited',
    'Leiutis pharmaceuticals private limited',
    'Alternative investment market advisors private limited',
    'IIFL WEALTH ADVISORS (INDIA) LIMITED',
    'Texotech solutions private limited',
    'ANG COMMODITIES PRIVATE LIMITED',
    'NAUGAON ARTISANS HANDICRAFTS LIMITED',
    'DHRITIKA HOLDINGS LIMITED',
    'PRASHANT COMMERCIAL HOLDINGS LIMITED',
    'DEVANG POLYMERS PRIVATE LIMITED',
    'KTL INSURANCE CONSULTANTS PRIVATE LIMITED',
    'KANUPRIYA ENTERPRISES PRIVATE LIMITED',
    'LOHIA ENTERPRISES PRIVATE LIMITED',
    'SIDDHANT CAPFIN PRIVATE LIMITED',
    'MANVI REAL ESTATES PRIVATE LIMITED',
    'APS India Infradevelopers Private Limited',
    'JAYKAYCEM (CENTRAL) LIMITED',
    'HCG REGENCY ONCOLOGY HEALTHCARE PRIVATE LIMITED',
    'O. E. IMPEX PRIVATE LIMITED',
    'CAWNPORE HOUSING DEVELOPMENT PRIVATE LIMITED',
    'SHRI FOUNDRIES AND ENGG. WORKS PRIVATE LIMITED',
    'SWAN FABRICATORS PRIVATE LIMITED',
    'MEHROTRA AGENCIES PRIVATE LIMITED',
    'ANVI REAL ESTATES PRIVATE LIMITED',
    'SHERISHA SOLAR PRIVATE LIMITED',
    'SEVA ENTERPRISE LIMITED',
    'MAX VENTURES AND INDUSTRIES LIMITED',
    'Ungerer Flavours India Private Limited',
    'SCIFI Logistics Private Limited',
    'GAMAYA ENTERPRISES PRIVATE LIMITED',
    'LOUNGE FORTY SEVEN VENTURES PRIVATE LIMITED',
    'KaiDP PROJECT ADVISORS PRIVATE LIMITED',
    'WEP DIGITAL SERVICES LIMITED',
    'E Analytics Partners (India) Private Limited',
    'AVAL PROPERTIES PRIVATE LIMITED',
    'EARTH INFRAREALTORS PRIVATE LIMITED',
    'AAYUSH TOURS & TRAVELS PRIVATE LIMITED',
    'KAJARIA TILES PRIVATE LIMITED',
    'MEDLIFE INTERNATIONAL PRIVATE LIMITED',
    'PIONEER INFRAESTATES PRIVATE LIMITED',
    'KEHEMS ENGINEERING PVT LTD',
    'SATYAVATHI FLYCON BLOCKS PRIVATE LIMITED',
    'BORKHEDI-WARDNER PATHWAYS PRIVATE LIMITED',
    'PREMIER SECURITY PRINTERS LIMITED',
    'ABHEEK REAL ESTATE PRIVATE LIMITED',
    'PROMPT LEASEVEST PRIVATE LIMITED',
    'AGDP PROJECTS PRIVATE LIMITED',
    'R N GUPTA CONSTRUCTION EQUIPMENT PRIVATE LIMITED',
    'AAKASHGANGA REALTY PRIVATE LIMITED',
    'AARKAY KHANNA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'ALBASTA WHOLESALE SERVICES LIMITED',
    'ADROIT BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'RAPID DISTRIBUTION PRIVATE LIMITED',
    'RAPID ESTATES PRIVATE LIMITED',
    'PUNEET TRADING AND INVESTMENT COmpany private limited',
    'REC TRANSMISSION PROJECTS COMPANY LIMITED',
    'RADIO TODAY BROADCASTING LIMITED',
    'ANANT RAJ AGENCIES PRIVATE LIMITED',
    'RTW LOGISTICS PRIVATE LIMITED',
    'RHODIA SPECIALTY CHEMICALS INDIA PRIVATELIMITED',
    'RASIKLAL HEMANI AGENCIES PVT LTD',
    'Alcatel-Lucent India Limited',
    'Alfonso Builders & Developers Private limited',
    'ASPAM ELECTRONICS PRIVATE LIMITED',
    'ASPIRING MINDS ASSESSMENT PRIVATE LIMITED',
    'ATC CARRIERS PRIVATE LIMITED',
    'ATULYA TRADING PRIVATE LIMITED',
    'JETAGE INFRASTRUCTURE LIMITED',
    'Kambod Real Estates Private Limited',
    'KADIMI CONSTRUCTION PRIVATE LIMITED',
    'LAHAR ENTERPRISES PRIVATE LIMITED',
    'KADIMI SPECIAL STEELS PRIVATE LIMITED',
    'KUCHAMAN DEVELOPERS PRIVATE LIMITED',
    'KUKA ALLOYS PRIVATE LIMITED',
    'Laxmibanta Estates Developers Private Limited',
    'LOUIS DREYFUS COMPANY SERVICES INDIA PRIVATE LIMITED',
    'LUCINA INFRASTRUCTURE LIMITED',
    'KSHITIZ INFRATECH PRIVATE LIMITED',
    'LE LOGIX SOFTWARE PRIVATE LIMITED',
    'SOFTECH ECOWORLD PRIVATE LIMITED',
    'Lizebeth Builders & Developers Private Limited',
    'LOTUS AGROTECH AND MARKETING PRIVATE LIMITED',
    'KSJ POLYALLOYS PRIVATE LIMITED',
    'MAJHAULIA SUGAR INDUSTRIES PRIVATE LIMITED',
    'PEGASUS AGRO INDUSTRIES PRIVATE LIMITED',
    'GSPL ADVISORY SERVICES AND INVESTMENT PRIVATE LIMITED',
    'ATARW TECHNOLOGIES PRIVATE LIMITED',
    'HEM TEX GARMENTS PRIVATE LIMITED',
    'NATCHI APPAREL PRIVATE LIMITED',
    'RODAMINE APPAREL INDUSTRIES PRIVATE LIMITED',
    'URBANTEX COUTURE PRIVATE LIMITED',
    'MASTERMADE BIO COMBINES PRIVATE LIMITED',
    'RP PUBLISHING PRIVATE LIMITED',
    'ZEN POUCHES PRIVATE LIMITED',
    'SACHIN HEALTH CARE PRIVATE LIMITED',
    'NICHINO CHEMICAL INDIA PRIVATE LIMITED',
    'SANGEET INDIA NETWORK PRIVATE LIMITED',
    'REMEP ENTERPRISES PRIVATE LIMITED',
    'FOUR FEATHERS MANAGEMENT SOLUTIONS LIMITED',
    'SKYZ INTERNATIONAL TRADING PRIVATE LIMITED',
    'AUXINITE MARKETING LIMITED',
    'SAMRIDDHI SOLAR POWER PRIVATE LIMITED',
    'ACCORD TELENTSEARCH PRIVATE LIMITED',
    'HAVELLS GLOBAL LIMITED',
    'NOVARRIS FASHION TRADING PRIVATE LIMITED',
    'CHANDI MATA REALTORS PRIVATE LIMITED',
    'INSTACON ELECTRONICS PRIVATE LIMITED',
    'PAPERCHASE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'LEADERSHIP CENTRE PRIVATE LIMITED',
    'RIVIERA FLOORS PRIVATE LIMITED',
    'AAREEM BUSINESS PRIVATE LIMITED',
    'RELIGARE INSURANCE LIMITED',
    'VIANAAR RESIDENCY PRIVATE LIMITED',
    'CAI AUTOMOBILES PRIVATE LIMITED',
    'KOLD SEAL INDIA PRIVATE LIMITED',
    'ISOMETRIC CONSULTANCY SERVICES PRIVATE LIMITED',
    'WINDLASS DEVELOPERS PRIVATE LIMITED',
    'ASHIKA RISE REALTY PRIVATE LIMITED',
    'OSHO RESOURCES (INDIA) PRIVATE LIMITED',
    'SYMARRON TECHNOLOGIES PRIVATE LIMITED',
    'NILABHUJA PROPERTIES PRIVATE LIMITED',
    'TAMOPAHA BUILCON PRIVATE LIMITED',
    'BERGAMOT CONBUILD PRIVATE LIMITED',
    'SOFTVISION SOFTWARE PARADIGMS PRIVATE LIMITED',
    'BINARY NUMBERS ITZONE PRIVATE LIMITED',
    'LLOYD CONSUMER PRIVATE LIMITED',
    'BELGAUM SOLAR POWER PRIVATE LIMITED',
    'ISAAC ENTERPRISES PRIVATE LIMITED',
    'NEOCARDIO DIAGNOSTICS PRIVATE LIMITED',
    'TEEL TECHNOLOGIES PRIVATE LIMITED',
    'AIR WORKS LIVERY SERVICES PRIVATE LIMITED',
    'REX POLYEXTRUSION PRIVATE LIMITED',
    'GLOSSY DIAMONDS PRIVATE LIMITED',
    'B M K LABORATORIES PRIVATE LIMITED',
    'MAHAL PICTURES PRIVATE LIMITED',
    'CHETTINAD SECURITY SERVICES PRIVATE LIMITED',
    'ESSEL FINANCE CAPSTAR ADVISORY LIMITED',
    'PRA PHARMACEUTICAL INDIA PRIVATE LIMITED',
    'UNITED MULTICHEM PRIVATE LIMITED',
    'MANOHAR PACKAGINGS PRIVATE LIMITED',
    'RKHS FOOD AND ALLIED SERVICES PRIVATE LIMITED',
    'AAPEE SHIPBREAKERS PRIVATE LIMITED',
    'GUJARAT POLYBUTENES PRIVATE LIMITED',
    'BINANI METALS LTD',
    'SUJATA PROPERTIES PVT LTD',
    'DETECTOR SAFETY SYSTEMS PRIVATE LIMITED',
    'VIRGO DECORS PRIVATE LIMITED',
    'SHARMA INVESTMENTS LIMITED',
    'TOMAR INVESTMENTS LIMITED',
    'BRAINMIDAS PRIVATE LIMITED',
    'AKSHARA VINTRADE PRIVATE LIMITED',
    'LIBERTY COLD STORAGE PRIVATE LIMITED',
    'LHG METAL TWO PRIVATE LIMITED',
    'MICROTEK TANGENT POWER PRIVATE LIMITED',
    'MICROTEK UNIVERSAL POWER PRODUCTS PRIVATE LIMITED',
    'WORLD OF RIVER PRIVATE LIMITED',
    'MICROTEK BALAJI POWERTRONICS PRIVATE LIMITED',
    'House & life technology private limited',
    'Brics hydro power private limited',
    'TORRENT GAS MORADABAD LIMITED',
    'Arihant premises pvt ltd',
    'Lodha impression real estate private limited',
    'Adinath builders private limited',
    'Abhishaya infrastructure private limited',
    'Shree sainath enterprises construction and developers private limited',
    'Elysian project solutions private limited',
    'Satlon enterprise private limited',
    'India circus retail private limited',
    'Graviss fast foods private limited',
    'Bnp paribas trustee india private limited',
    'Kunvarji commodities brokers private limited',
    'Accion labs india private limited',
    'DR. BATRA',
    'S VETERINARY CARE PRIVATE LIMITED',
    'Cavium networks (india) private limited',
    'Trizetto india private limited',
    'Habitat venture constructions private limited',
    'Cognizant technology services private limited',
    'LODHA VENTURES HOLDINGS PRIVATE LIMITED',
    'Agrasen impex private limited',
    'Clinical care consultants private limited',
    'S FRANCHISE PRIVATE LIMITED',
    'C.s.k. builders limited',
    'Contextual advertising private limited',
    'Athanas enterprise private limited',
    'Gebi glass (india) private limited',
    'JOYOUS MARKETING & IMPEX PVT LTD',
    'DR. BATRAS',
    'S INSTITUTE OF COMPUTING AND INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'Enterprise system solutions private limited',
    'Oded transformational technologies private limited',
    'Kapsons infosoft private limited',
    'King realtors private limited',
    'Genius technologies private limited',
    'Bebo technologies private limited',
    'PROFESSIONAL SOFTEC PRIVATE LIMITED',
    'ALPIERS TECHNOLOGIES LIMITED',
    'Innovative logic lab private limited',
    'Sanskrit e solutions & services private limited',
    'Hexagon capability center india private limited',
    'Yogya systems private limited',
    'Oomsys technologies (india) private limited',
    'Zalaris hr services india private limited',
    'Interweb itech india private limited',
    'Caresoft global private limited',
    'Swiftant it solutions india private limited',
    'TECHINFINITI INFOSOLUTIONS PRIVATE LIMITED (OPC)',
    'Kuthari information technology private limited',
    'Data adavance systems pvt ltd',
    'Pagaria computers pvt ltd',
    'Information highway consultants private limited',
    'Tidalwave software private limited',
    'Secure bit technologies private limited',
    'Safe warehouse logistic solutions private limited',
    'Graphic era infotech private limited',
    'Sage technologies private limited',
    'Unitedlex bpo private limited',
    'S.a.s. infotech private limited',
    'Aarpee niket limited',
    'Ojesh apartments private limited',
    'Mahakali developers and resorts private limited',
    'Flamez mall (jallandhar) private limited',
    'Synapseindia outsourcing private limited',
    'Swarajya analytics private limited',
    'Mobiloitte technologies india private limited',
    'Axis computech and peripherals private limited',
    'World wide connections india private limited',
    'Jain millennium builders private limited',
    'Vmock india private limited',
    'Srijai infrastructure developers private limited',
    'Data management centre pvt ltd',
    'EMARGINS PRIVATE LIMITED',
    'Sword software n technologies private limited',
    'Micronet infocom & logistics private limited',
    'Fedobe solutions private limited',
    'Stone solar private limited',
    'Conferwiz infotech private limited',
    'B3 net technologies private limited',
    'XLATIKA TECHNOLOGIES PRIVATE LIMITED',
    'Intensiv-filter himenviro private limited',
    'Ifood web media technology private limited',
    'SSPS GLOBAL PRIVATE LIMITED',
    'Cns web technologies private limited',
    'New line infotech private limited',
    'Spatial geotech private limited',
    'Damyant software private limited',
    'SOURCEDESK GLOBAL PRIVATE LIMITED',
    'Ensine knowledge systems private limited',
    'Ascent e digit solutions private limited',
    'Interaction i t services private limited',
    'Inca infotech technologies private limited',
    'Rp network solutions private limited',
    'Iris infosoft private limited',
    'Conquest software private limited',
    'Zi systech private limited',
    'Zapbuild technologies private limited',
    'Virtuoso netsoft private limited',
    'Strategic infosoft private limited',
    'Technisys engineering private limited',
    'Mediarun digital private limited',
    'Ase data solutions private limited',
    'Actech information systems limited',
    'Sagittarius peripherals infotech comservices and e-media ltd.',
    'Cdg multimedia systems private limited',
    'Athenta technologies private limited',
    'Concepts ventures private limited',
    'V s network solutions private limited',
    'Relecotech software solutions private limited',
    'Mft info services private limited',
    'Optirus solutions private limited',
    'Wiptech peripherals private limited',
    'Ecaps computers india private limited',
    'Oyster soft india private limited',
    'Scientific animations and graphics private limited',
    'Alba softech private limited',
    'IQBRI VERTICALS PRIVATE LIMITED',
    'Technospecs technologies private limited',
    'SYRJ INVESTMENTS PRIVATE LIMITED',
    'Gadre infotech private limited',
    'Transgenez solutions private limited',
    'A3LOGICS (INDIA) PRIVATE LIMITED',
    'SRI SHANMUGHA MINES & MINERALS LIMITED',
    'Stonchek exim private limited',
    'Agarwal sarees private limited',
    'ZIGMA CORPORATION PRIVATE LIMITED',
    'Palki fashion private limited',
    'Nitya creation private limited',
    'Aastha niryat private limited',
    'Megha garexpo private limited',
    'Jrb fabrics private limited',
    'Gyan international private limited',
    'Karam apparels private limited',
    'Fancy fasteners private limited',
    'Rsm leather enterprises private limited',
    'Bengal juneja leather complex limited',
    'Trot private limited',
    'Active bags private limited',
    'Shee sen leather pvt ltd',
    'Unique international pvt ltd',
    'Das style private limited',
    'Canton leather collections private limited',
    'Varsha credit private limited',
    'Eternal marbles private limited',
    'Makul timber products private limited',
    'Narkatiaganj farms limited',
    'Travancore titanium products ltd',
    'Ratan wood private limited',
    'Orlando holdings limited',
    'H.k. paper industries pvt ltd',
    'Shri hari pipes private limited',
    'Sri vari papers private limited',
    'Commonwealth trust india ltd',
    'Kejriwal textiles ltd',
    'LAMI PLAST COMPANY PRIVATE LIMITED',
    'SUPREME POLYMERS PRIVATE LIMITED',
    'Andheri mona premises limited',
    'B b cereals private limited',
    'BURDA MEDIA INDIA PRIVATE LIMITED',
    'Pacific images private limited',
    'Nanda stationer pvt ltd',
    'Kanchenjunga publications private limited',
    'Incoda ventures private limited',
    'Patalganga minerals private limited',
    'Udaya fibers private limited',
    'S CHAND AND COMPANY LIMITED',
    'Enthuse answers communications private limited',
    'Serenity books india private limited',
    'Rdg impressions private limited',
    'Wedoria Technologies Private Limited',
    'Densons denim limited',
    'Global coton private limited',
    'Suryavansi creation private limited',
    'VISHWESH KNITTING AND DYEING MILLS PRIVATE LIMITED',
    'Kanchanjunga herbals pvt. ltd.',
    'Kolkata metro networks limited',
    'Sai service spares & accessories private limited',
    'Foundry chemical industries private limited',
    'Upkar merchantry private limited',
    'Double chem private limited',
    'Siroo fashions private limited',
    'S.v.p. chemicals private limited',
    'M pallonji and company private limited',
    'Three a chemie private limited',
    'Sameer chemcon engineers private limited',
    'Inceptra lifestyle private limited',
    'Bowreah cotton mills co ltd',
    'Primax commerce pvt ltd',
    'Indtech apparels pvt ltd',
    'PRAGNA PHARMA PRIVATE LIMITED',
    'Gharda chemicals limited',
    'Afco industrial and chemicals limited',
    'NOBLE GAS LIMITED',
    'Solaris industrial chemicals limited',
    'Nitrochem india private limited (transfer company)',
    'Lakhotia udyogs ltd.',
    'Rathi chempels pvt ltd',
    'Nicholson chemical private limited',
    'Super fine knitters limited',
    'K.m.d.apparels private limited',
    'UPANI INDIA PRIVATE LIMITED',
    'MOHAN ADVERTISERS PRIVATE LIMITED',
    'Saber packaging private limited',
    'Pamach engineers private limited',
    'Akona engineering private limited',
    'SHREE GANESH REMEDIES LIMITED',
    'Asd tobacco private limited',
    'Gujarat boron derivatives pvt ltd',
    'Colourtex industries private limited',
    'Centurion remedies private limited',
    'JMU STAINLESS ALLOYS PRIVATE LIMITED',
    'Kay emm biomedicals private limited',
    'ARBRO PHARMACEUTICALS Private Limited',
    'Hindo plast private limited',
    'Good image pvt.ltd.',
    'Shiva medichem exports private limited',
    'Tirupati medicare limited',
    'Le-mantus pharmaceuticals private limited',
    'Bliss ayurveda (india) private limited',
    'Art printing house private limited',
    '21CENT BUSINESS SERVICES PRIVATE LIMITED',
    'Kerala medical services corporation limited',
    'Sri balamurugan industries private limited',
    'Aushadhi wellness private limited',
    'Eli lilly and company (india ) private limited',
    'Kailash ayurveda private limited',
    'Ganpati aloe vera herbs private limited',
    'CLEARPACK AUTOMATION PRIVATE LIMITED',
    'Tristar pvt ltd',
    'Hasti petro chemical and shipping limited',
    'Indian additives limited',
    'Arunaya organics private limited',
    'Vadivarhe speciality chemicals limited',
    'Sanhit petrochemicals private limited',
    'Bmi oxides private limited',
    'Shivalik dealcom private limited',
    'Ritushree vanijya private limited',
    'Solty commercial private limited',
    'RPSG RESOURCES PRIVATE LIMITED',
    'Saatyak distribution private limited',
    'Rpm international private limited',
    'Rosemary tradecom private limited',
    'Olay marketing private limited',
    'Central national india pulp and paper private limited',
    'Zion infradevelopers private limited',
    'Fabricotel export and import private limited',
    'Spinn well pvt ltd',
    'Hitech dealers private limited',
    'Ma jeenmata sales private limited',
    'Linkplan tradelink private limited',
    'Elahi exim india private limited',
    'Trinity vincom private limited',
    'ADPL ESTATES PRIVATE LIMITED',
    'Monarch agency private limited',
    'Akshar exim company private limited',
    'Bluemoon dealtrade private limited',
    'Alankar sales limited',
    'Jaiwanti vanijya private limited',
    'High growth distributors private limited',
    'Gulshan vincom private limited',
    'Nihar tie-up pvt ltd',
    'Tib retail private limited',
    'Newstrokes online private limited',
    'Primerose tradecom private limited',
    'DUNAMIS TRADE & SERVICES PRIVATE LIMITED',
    'Inox merchants private limited',
    'Dhm trading private limited',
    'SHASWAT SALES & SERVICES PVT LTD',
    'Wide range merchants pvt ltd',
    'Gogad impex private limited',
    'Lakshmi tradesoft private limited',
    'H g commercial pvt ltd',
    'Cd exim private limited',
    'Shagun dealmark private limited',
    'KOTA ELECTRICITY DISTRIBUTION LIMITED',
    'BHARATPUR ELECTRICITY SERVICES LIMITED',
    'BIKANER ELECTRICITY SUPPLY LIMITED',
    'Snb impex private limited',
    'AMIN',
    'ROLLEX PRIVATE LIMITED',
    'SPDT ENTERPRISES PRIVATE LIMITED',
    'StewKen Traveltek India Private Limited',
    'T-HUB FOUNDATION',
    'SILICON WIRELESS SYSTEMS PRIVATE LIMITED',
    'CYBERIN SYSTEMS PRIVATE LIMITED',
    'PROGRC SOFTWARE AND SERVICES PRIVATE LIMITED',
    'SAVANTT INDO PROJECTS PRIVATE LIMITED',
    'SUNSHINE INDO PROJECTS PRIVATE LIMITED',
    'AKS Business Services Private Limited',
    'ENIST INSTRUMENTS AND SERVICES PRIVATE LIMITED',
    'GLOBUS MINDSPACE ENGINEERING PRIVATE LIMITED',
    'CHERISH HR SERVICES PRIVATE LIMITED',
    'DLabs Incubator Association',
    'TEEM-V MEDIE CARE PRIVATE LIMITED',
    'GANGA ENVIRO SYSTEMS PRIVATE LIMITED',
    'CENTRAL INDIA PACKAGING COMPANY PRIVATE LIMITED',
    'HI REACH BROADBAND PRIVATE LIMITED',
    'S M FEEDS & FARMS (INDIA) PRIVATE LIMITED',
    'TEJASRI GREEN ORGANIC FARMING PRIVATE LIMITED',
    'CP PRIMA AQUACULTURE (INDIA) PRIVATE LIMITED',
    'SHENG LONG BIO-TECH (INDIA) PRIVATE LIMITED',
    'Bradken India Private Limited',
    'ALLIANCE ANDHRA PRADESH BLACK GALAXY GRANITES PRIVATE LIMITED',
    'Indibest Aqua Feeds Private Limited',
    'PURE DAIRY SOLUTIONS PRIVATE LIMITED',
    'BLUEJAY NUTS PRIVATE LIMITED',
    'Provision Value Gard Private Limited',
    'PASSION POTATO PRIVATE LIMITED',
    'AMBIKA APPALAM COMPANY PRIVATE LIMITED',
    'TRANSEND ORGANICS PRIVATE LIMITED',
    'ROCKMOUNT ENTERPRISES PRIVATE LIMITED',
    'HUNGER ANSWERED FOOD CONCEPTS PRIVATE LIMITED',
    'Bean and Leaf Beverages Private Limited',
    'MOTREX AUTOMOTIVE INDIA PRIVATE LIMITED',
    'Phoenix Oil Engines India Private Limited',
    'RETCHAKAR CHEMICALS PRIVATE LIMITED',
    'SUNIX CHEM PRIVATE LIMITED',
    'HERBZ & HEALZ HEALTHCARE CENTRE PRIVATE LIMITED',
    'Faraway Tree Hospitality Private Limited',
    'Shoestring Hospitality Private Limited',
    'HANKOOK MATZIP PRIVATE LIMITED',
    'H & S Supply Chain Services Private Limited',
    'Patja Logistics Private Limited',
    'TRANSLINER MARITIME PRIVATE LIMITED',
    'GLOBELINK TRAVEL PRIVATE LIMITED',
    'YESGT TRAVELS (INDIA) PRIVATE LIMITED',
    'Store N Move Private Limited',
    'HOLZWERK INTERIOR PRIVATE LIMITED',
    'NAVITA ESTATES PRIVATE LIMITED',
    'ALMOND REALTORS PRIVATE LIMITED',
    'Muhavoor Real Estate Private Limited',
    'Jansen Infrastructure Private Limited',
    'DELTA RETAILSPACE INNOVATIONS PRIVATE LIMITED',
    'SIGNA TECH SERVICES PRIVATE LIMITED',
    'BYTES AND LOGIC SYSTEMS PRIVATE LIMITED',
    'SpringBok Technologies India Private Limited',
    'ONEG SOFTWARE SERVICE PRIVATE LIMITED',
    'Merfantz Technologies Private Limited',
    'FQUO SOLUTIONS PRIVATE LIMITED',
    'SYVASOFT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'JUSTINTEGRATE IT PRIVATE LIMITED',
    'MOBOLUTION INDIA PRIVATE LIMITED',
    'BTHINQ INFORMATION SYSTEMS PRIVATE LIMITED',
    'iSalCal Solutions Private Limited',
    'ZeetaMinds Technologies Private Limited',
    'Apptium Technologies India Private Limited',
    'DINMIND INFOTECH PRIVATE LIMITED (OPC)',
    'Kore Mechatronics Private Limited',
    'BLUESUN HITECH SOLUTIONS PRIVATE LIMITED',
    'PVS INDUSTRY IT SOLUTION & SERVICES INDIA PRIVATE LIMITED',
    'INSPREMAC ENGINEERS PRIVATE LIMITED',
    'PROTEL LABS PRIVATE LIMITED',
    'MEDLAR INFOTECH PRIVATE LIMITED',
    'Grisaille AdTech Solutions Private Limited',
    'MENTHEE TECHNOLOGIES PRIVATE LIMITED',
    'PING TECHNO SOLUTIONS PRIVATE LIMITED',
    'FORZIA TECH PRIVATE LIMITED',
    'MAGELLANIX TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'SYSU INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'FIIND DATA SCIENCES PRIVATE LIMITED',
    'SLASHSQUARE MEDIA PRIVATE LIMITED',
    'ADYOG SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'WISEN IT SOLUTIONS PRIVATE LIMITED',
    'Vyatta Technology Private Limited',
    'CRUNCHLEADS SOLUTIONS PRIVATE LIMITED',
    'EXCELFORTE SOFTWARE (INDIA) PRIVATE LIMITED',
    'MARVELTECH COE INDIA PRIVATE LIMITED',
    'ICT Software Solutions Private Limited',
    'ARCLIGHTS POWER SOLUTIONS PRIVATE LIMITED (OPC)',
    'ANAX INDUSTRIES PRIVATE LIMITED',
    'EVENTUS HOLDING PRIVATE LIMITED',
    'SP TECH ENGINEERING PRIVATE LIMITED',
    'DOXA BUSINESS CENTRE PRIVATE LIMITED',
    'Startup Xperts Business Consulting Private Limited',
    'Innovative Fluid Solutions Private Limited',
    'CRAFTNER SOLUTIONS PRIVATE LIMITED',
    'ATALON PRODUCT CENTER PRIVATE LIMITED',
    'INDUS WORLD ASSETS PRIVATE LIMITED',
    'ILV DISTRIPARK PRIVATE LIMITED',
    'BULLDYERS INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'MARUCHAN AJINOMOTO INDIA PRIVATE LIMITED',
    'BASIS EXPERT CONSULTING SERVICES PRIVATE LIMITED',
    'JOE DATA SERVICES PRIVATE LIMITED',
    'Dengensha India Private Limited',
    'LIGHTING PRODUCTS RESEARCH FOUNDATION',
    'LIGHTCOMP RESEARCH AND DEVELOPMENT LABORATORY',
    'FourKites India Private Limited',
    'Prateek Technosoft India Private Limited',
    'WINSOLS STUDIOS PRIVATE LIMITED',
    'TECHNOSPIRIT CONSULTANCY PRIVATE LIMITED',
    'EGYTIM ACADEMY PRIVATE LIMITED',
    'ALAGUCHAMI MANAGEMENT CONSULTING PRIVATE LIMITED',
    'KAFEE WORLD BEVERAGES PRIVATE LIMITED',
    'RISHABA INDUSTRIAL DESIGNS PRIVATE LIMITED',
    'TOUGH SCAFF PRIVATE LIMITED',
    'GREENOCARE ENGINEERING PRIVATE LIMITED',
    'Harvey Innovative Solutions Private Limited',
    'SHAKTI HOLIDAYS PRIVATE LIMITED',
    'PINAKIN BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DAVIDSUN NATURALS PRIVATE LIMITED',
    'NOVUS RENEWABLE ENERGY PRIVATE LIMITED',
    'SPIZEBOX SERVICES PRIVATE LIMITED',
    'VERIFITECH INDIA INFO PRIVATE LIMITED',
    'ASAHITEC STENCILS PRIVATE LIMITED',
    'TTS EDUCATION PRIVATE LIMITED (OPC)',
    'FUEL TAPS ENGINEERING PRIVATE LIMITED',
    'ESSAAR INSTRUMENTS PRIVATE LIMITED',
    'MADOS PIPING IMPEX PRIVATE LIMITED',
    'PM AGRO BIOTECH PRIVATE LIMITED',
    'TECSILA HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    '4D GLOBAL MEDICAL BILLING SERVICES PRIVATE LIMITED',
    'ARIHANT LUBS LIMITED',
    'FABI CORPORATION PRIVATE LIMITED',
    'CENTURY SNACKS & FOODS PRIVATE LIMITED',
    'JANSHAKTI BOOKS AND PUBLICATION PRIVATE LIMITED',
    'SURAJ BLOW PLAST PRIVATE LIMITED',
    'LUXMI DIES & MOULDS PRIVATE LIMITED',
    'Deogiri Electronics Cluster Private Limited',
    'SHENDRA COMMERCIAL COMPLEX PRIVATE LIMITED',
    'ENDRESS + HAUSER INFOSERVE (INDIA) PRIVATE LIMITED',
    'RYTNOW SYSTEMS PRIVATE LIMITED',
    'Seveillar Clinical Supplies Services Private Limited',
    'MEASUREWEL TECHNOVISION PRIVATE LIMITED',
    'REVIN FINSERV PRIVATE LIMITED',
    'MY ARKAY COMMUNICATION SOLUTION PRIVATE LIMITED',
    'OFFICEXLR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Handy Home Solutions Private Limited',
    'MODI INNOVATIONS PRIVATE LIMITED',
    'GROWTH CATALYSTS CONSULTING PRIVATE LIMITED (OPC)',
    'H5S ENGINEERS PRIVATE LIMITED',
    'THE CENTER FOR APPLIED RESEARCH AND PEOPLE ENGAGEMENT',
    'Tirumalla Oil Refinery Private Limited',
    'RESHCON HEALTHCARE PRIVATE LIMITED',
    'GEMCO KATI NATURAL RESOURCES PRIVATE LIMITED',
    'AZIRA MINING PRIVATE LIMITED',
    'GAJANAN INFRA ENGINEERING PRIVATE LIMITED',
    'PRINCETON TEXTILES PRIVATE LIMITED',
    'RIGHT STREET MARKETING PRIVATE LIMITED',
    'Fenixwork Solutions Private Limited',
    'Jain Farm Fresh Foods Limited',
    'SHREE SANT MUKTAI INDUSTRIES PRIVATE LIMITED',
    'SKYRAIL INFRASTRUCTURE PRIVATE LIMITED',
    'PUNNICA EXPORTS PRIVATE LIMITED',
    'Jain Processed Foods Trading and Investments Private Limited',
    'GANESH OXYGEN PRIVATE LIMITED',
    'BG FASTENING AND ENGINEERING INDUSTRIES PRIVATE LIMITED',
    'CHANGZHENG BMR REFRIGERATION TECHNOLOGY PRIVATE LIMITED',
    'BAGLA INDUSTRIES PRIVATE LIMITED',
    'ROOPAM INDUSTRIES PRIVATE LIMITED',
    'GURU GUNESH MUTHA HOSPITAL PRIVATE LIMITED',
    'SHREE GANESH BAKERY NANDANI PRIVATE LIMITED',
    'LAXMI DATTA MANDAP INDUSTRIES PRIVATE LIMITED',
    'DUDHANE PCA MOTORPARTS PRIVATE LIMITED',
    'MAKNET INDUSTRIES PRIVATE LIMITED',
    'NEW MELTING CENTRE PRIVATE LIMITED',
    'TATYASAHEB KORE WARANA INFRASTRUCTURE PRIVATE LIMITED',
    'PADMAPRIYA ENTERPRISES PRIVATE LIMITED',
    'Fathom Software Private Limited',
    'Maahiron Technologies Private Limited',
    'J.K. WEALTH PRIVATE LIMITED',
    'GREEN COTTAGE AND RESORTS LTD',
    'RAVECHI FLORITECH PRIVATE LIMITED',
    'Sanguine Novaseeds Private Limited',
    'NeoArc Exim Private Limited',
    'VENTTURA BIOCEUTICALS PRIVATE LIMITED',
    'ABans Agri Warehousing & Logistics Private Limited',
    'JAROLI AGRO PRIVATE LIMITED',
    'Spiel Corporate Private Limited (OPC)',
    'Krishi Care & Management Services Private Limited',
    'NEW VISTA HORTICULTURE PRIVATE LIMITED',
    'Bijam Organic and Natural Food Private limited',
    'Vicorus India Private Limited',
    'DIGIINTERFACE PRIVATE LIMITED',
    'KING PRAWNS LIMITED',
    'Omega Petroenergy Private Limited',
    'ARETE ALLIED SERVICES PRIVATE LIMITED',
    'SDC Mines Private Limited',
    'A1 WAFERS CO PRIVATE LIMITED',
    'SQUAREMEAL FOODS PRIVATE LIMITED',
    'Samaira AgriFoods Private Limited',
    'Adrenaline Foods Private Limited',
    'Cranberry Foods Private Limited',
    'Accuron Foods Private Limited',
    'Power Brands Enterprises India Private Limited',
    'Esprezzo Foods and Beverages Private Limited',
    'KAMANI FOODS PRIVATE LIMITED',
    'Spresso Pod Manufacturing Private Limited',
    'Samaira Foods and Beverages Private Limited',
    'AJMERA REALTECH PRIVATE LIMITED',
    'CULINARY CART PRIVATE LIMITED',
    'GOOD CO COFFEE PRIVATE LIMITED',
    'ALKA TISSU PVT LTD',
    'BATS APPARELS LIMITED',
    'ESSAR LIFESTYLE PRIVATE LIMITED',
    'ZEE TEXTILE MILLS PVT LTD',
    'BLA Textiles Private Limited',
    'Red Cherry Fashion & Accessories Private Limited',
    'AVP INDUSTRIES PRIVATE LIMITED',
    'HELLENIC INDIA GARMENT EXPORTS PRIVATE LIMITED',
    'BURHANPUR INTEGRATED TEXTILE PARK LIMITED',
    'NANDAN TERRY LIMITED',
    'Nikita Syntex Private Limited',
    'ASTRA INDUSTRIES AND TRADING PRIVATE LIMITED',
    'BOMBAY MILL STUDIO PRIVATE LIMITED',
    'BOTTOMLINE RETAIL PRIVATE LIMITED',
    'PREETIKAYA LIFESTYLE SOLUTIONS PRIVATE LIMITED',
    'KHYAATI LEATHER INNOVATIONS PRIVATE LIMITED',
    'Amazia Fashion Private Limited',
    'JAY KIRAN EXPORT PRIVATE LIMITED',
    'Khushi advertising ideas private limited',
    'Pragati publication private limited',
    'Neat graphics private limited',
    'Sahib graphics private limited',
    'Independant communications company private limited',
    'Miracle studios private limited',
    'Dev print & pack private limited',
    'Divya media publications private limited',
    'Pustaka digital media private limited',
    'MAHAJAN BOOK DEPOT PRIVATE LIMITED',
    'Shree printwell offset private limited',
    'Almats branding solutions private limited',
    'Indrayadav multiprinters private limited',
    'QUADRA PRESS INDIA LIMITED',
    'Innerworkings india private limited',
    'Live law media private limited',
    'Sonic octaves private limited',
    'Skylark (properties) pvt ltd',
    'EASTERN ELECTRODES & COKE PRIVATE LIMITED',
    'Gas point bottling private limited',
    'Hawaii industrial gases private limited',
    'Pole-star distribution private limited',
    'Yuvraj lube and petro chemical private limited',
    'Argo-hytos private limited',
    'Showa kako india private limited',
    'Alak healthcare private limited',
    'Bo-chem private limited',
    'KARANDIKARS ORGOCHEM PRIVATE LIMITED',
    'Dns fine chemicals and laboratories private limited',
    'Gattefosse india private limited',
    'Mp biomedicals india private limited',
    'Kolor bio - genetics private limited',
    'Subhra pharma priavate limited',
    'Karrm health management & chemicals private limited',
    'Spiro lifecare private limited',
    'Sheenlac noroo coatings india private limited',
    'Nandini chemicals limited',
    'Orion chem private limited',
    'GOOD RASAYAN PRIVATE LIMITED',
    'Sds labs private limited',
    'Ashish interchem private limited',
    'Ronson pigments private limited',
    'Medybiz pharma private limited',
    'Jaydev speciality chemicals private limited',
    'Peregrine phosphate private limited',
    'Leomine organics private limited',
    'Sulphur crop care private limited',
    'Colorobbia chemicals india private limited',
    'Polynate foams private limited',
    'Lazeem health care private limited',
    'Rainbow agrosciences private limited',
    'Coatings and coatings (india) private limited',
    'Victory dyes and paper private limited',
    'Nulith graphic private limited',
    'Zydus hospira oncology private limited',
    'Copernicium pharmaceuticals private limited',
    'BLUE CROSS LABORATORIES Private Limited',
    'J p n pharma private limited',
    'TEVA GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'Yeluri formulations private limited',
    'Gujarat chlor alkali industries limited',
    'Aurum agrochem private limited',
    'Gillden paints private limited',
    'Lundbeck india private limited',
    'Arch pharmalabs limited',
    'Medicure private limited',
    'ZYPHAR',
    'S ART SERVICES (INDIA) PRIVATE LIMITED',
    'Jsl marketing prvate limited',
    'Saltrock advisors private limited',
    'Pro grow financial consultancy private limited',
    'Real value consultants private limited',
    'A v immigration and careers consultancy private limited',
    'Tolburn management services private limited',
    'Rightways air logistics private limited',
    'Walter p moore engineering india private limited',
    'Proficient partners consultancy private limited',
    'GLOBAL INDIAN DIGITAL PRIVATE LIMITED',
    'Cpg infra limited',
    'Promont hillside private limited',
    'Kingdom realtors private limited',
    'Jaiswar realty private limited',
    'Smart value homes (peenya project) private limited',
    'Vedavid realtors private limited',
    'Swarit realty private limited',
    'S l hirers private limited',
    'RADIUS ESTATES AND DEVELOPERS PRIVATE LIMITED',
    'Sc infraventures private limited',
    'Aarini woodland private limited',
    'Ktech auto private limited',
    'KHYATI MOTORS PRIVATE LIMITED',
    'Lakka transglobal india private limited',
    'Lakshmi car zone private limited',
    'Acclaim motors private limited',
    'Dani commodities private limited',
    'Corporate india tradex private limited',
    'Jade consumer products india private limited',
    'Mars commerce company private limited',
    'Farlin commodities private limited',
    'Hycon sales private limited',
    'RACHIKA TRADING LIMITED',
    'Amrit dealcom private limited',
    'Jinay trading company pvt ltd',
    'Soothing trading company private limited',
    'Total retail solutions private limited',
    'Cygnet enterprise private limited',
    'Archi exim private limited',
    'Vision hvac private limited',
    'Krish tektronics private limited',
    'REGENESIS VENTURE PRIVATE LIMITED',
    'Gajodhar trading company private limited',
    'Rural fairprice wholesale limited',
    'Interocean fincap services private limited',
    'Shrachi virtuous retail projects private limited',
    'Mgi (india) consulting private limited',
    'Lab furniture systems (india) private limited',
    'MAHAMAYA LIFESCIENCES PRIVATE LIMITED',
    'AMKAY PRODUCTS LIMITED',
    'Kothari creations private limited',
    'D. p. diamonds private limited',
    'Waterworld ceramics private limited',
    'Polytech instruments private limited',
    'Champion trading and services private limited',
    'Cygnus sales & services private limited',
    'METEX RESOURCES PRIVATE LIMITED',
    'FIRE & SECURITY DISTRIBUTION PRIVATE LIMITED',
    'Cpg academic services limited',
    'Kgk diajewels private limited',
    'Merck Performance Materials Private Limited',
    'Trishul commercials private limited',
    'JAGAN EXPORTS & TRADING PRIVATE LIMITED',
    'Unitech trade services private limited',
    'Doors and doors system (india) private limited',
    'Ivan exports private limited',
    'A. K. CAPITAL FINANCE LIMITED',
    'Ceragon networks india private limited',
    'Pjs overseas limited',
    'Moi commodities india private limited',
    'Colourflex laminators limited',
    'Small mart private limited',
    'SAHYOG HOLDINGS PRIVATE LIMITED',
    'Advanced bionics india private limited',
    'National commodity and derivatives exchange limited',
    'Vibrant global trading private limited',
    'Norbar torque tools india private limited',
    'True navya india private limited',
    'Andreas stihl private limited',
    'Shuklaam exim limited',
    'Nizam coal private limited',
    'Tfb exim (india) private limited',
    'Oriens global marketing private limited',
    'Sarda magnetics private limited',
    'Jai maa durga tradex private limited',
    'Capture technologies private limited',
    'Rebutor electronics private limited',
    'Maple retail private limited',
    'Bvc ventures private limited',
    'Strasa multitrade private limited',
    'Business arts india private limited',
    'Hyson convenience stores private limited',
    'High scale trading private limited',
    'Manya distributors private limited',
    'Arron fresh private limited',
    'Nahshon consumer products private limited',
    'Rikevita (india) private limited',
    'B r m electrade private limited',
    'Magnam netlink private limited',
    'Aura merchandise private limited',
    'Assetlite equipment india private limited',
    'Peroni pumps india private limited',
    'Qarmatek services private limited',
    'SAISANJ PRIVATE LIMITED',
    'Mennen aviation & hospitality limited (c/n)',
    'SLN TERMINUS HOTELS & RESORTS PRIVATE LIMITED',
    'Ust global welfare foundation',
    'Mehta foundation',
    'Interact social development foundation',
    'K chittilappilly foundation',
    'UMMEED CHILD DEVELOPMENT CENTER',
    'KARDEX INDIA PRIVATE LIMITED',
    'Ved puran gyan',
    'Rose audio visuals private limited',
    'Corporate moviez india private limited',
    'Barco electronic systems private limited',
    'Accord public relations private limited',
    'MATRIX INDIA ENTERTAINMENT CONSULTANTS PRIVATE LIMITED',
    'Mapleton technologies private limited',
    'Madkini hydro power private limited',
    'Quantum journeys private limited',
    'Beyond boundaries entertainment private limited',
    'Unicorn event management & marketing private limited',
    'Corporate sports club private limited',
    'Adiva innovations private limited',
    'Lotus online lottery private limited',
    'COGENT PROFESSIONALS PRIVATE LIMITED',
    'Venturebean consulting private limited',
    'Innovative interactive infotainment private limited',
    'Lindinger inspection services private limited',
    'Gujarat e.o.u association',
    'Chattels property management private limited',
    'Rohnos pigments private limited',
    'Shop elect private limited',
    'Palitam advisory services and consulting private limited',
    'Vramath resorts and plantations private limited',
    'Culture machine media private limited',
    'Technology distribution association of india',
    'Falcon infrastructures limited',
    'Connectaero aviation services (india) private limited',
    'Mandala advisory india private limited',
    'AUTHOR CAFE PRIVATE LIMITED',
    'Jre private limited',
    'Shalaka electronics pvt.ltd.',
    'Sharepro computer services private limited',
    'Nirala securities and commercials private limited',
    'Ajanta aviations private limited',
    'Skyline capital private limited',
    'Asp ship management india private limited',
    'PRIVI SPECIALITY CHEMICALS LIMITED',
    'Mohit industries limited',
    'REVALYU RECYCLING (INDIA) LIMITED',
    'Repro india limited',
    'Astrazeneca pharma india limited',
    'Texel industries limited',
    'Gtl limited',
    'Killick nixon limited',
    'Hi-klass trading and investment limited',
    'Odyssey technologies limited',
    'FUTURE ENTERPRISES LIMITED',
    'Itd cementation india limited',
    'Panoramic universal limited',
    'FIRST FINTEC LIMITED',
    'CIRCUIT SYSTEMS (INDIA) PRIVATE LIMITED',
    'AVASARA FINANCE LIMITED',
    'Visagar financial services limited',
    'Caliber tech solutions private limited',
    'Daman ganga board mills private limited',
    'Sarala foods private limited',
    'Mantray greenpark private limited',
    'Grain impex private limited',
    'Navkisan bio plaantec limited',
    'Bishnoi agro india private limited',
    'Basbey greenview private limited',
    'Nusun genetic research limited',
    'Pratapnay greenfield private limited',
    'Sri pravan agro farms private limited',
    'APARAJITA FARMS & HERBS INDIA PRIVATE LIMITED',
    'Excellent dreamestate private limited',
    'Karnataka state beverages corporation limited',
    'Auto cnc machining limited',
    'Prathima aqua culture private limited',
    'Dutch plantin coir india private limited',
    'KANVA MART LIMITED',
    'Gasalbertaenergy private limited',
    'Saihyandri energy services private limited',
    'KRISS DRILLING PRIVATE LIMITED',
    'ARKA METALS TRADING PRIVATE LIMITED',
    'Mondiale de minerals private limited',
    'AEONX DIGITAL SOLUTIONS PRIVATE LIMITED',
    'Squarepeg distribution services private limited',
    'Cf foods private limited',
    'Go proinsta foods private limited',
    'Pioneer food & agro industries private limited',
    'Austin foods and beverages private limited',
    'Umbrella corporation private limited',
    'Shirdi sai nutraceuticals private limited',
    'Kanderi fruitpack private ltd',
    'Ftk foods private limited',
    'GSR APPTECH PRIVATE LIMITED',
    'Dk bakings private limited',
    'Prushti investments private limited',
    'Balussery benefit chit fund private limited',
    'Loyal credit & investments ltd',
    'Sabari properties private limited',
    'Nov trusteeship services private limited',
    'Gef advisors india private limited',
    'MONEYBOLISM FINANCIAL SERVICES PRIVATE LIMITED',
    'Chinta madhava capital ventures private limited',
    'Atluri holdings private limited',
    'Sun investments private limited tfrl. from mumbai to delhi',
    'RENUKA FINANCIAL SERVICES PRIVATE LIMITED',
    'Hexagon topvalue private limited',
    'Forum synergies (india) pe fund managers private limited',
    'Caleb securities private limited',
    'Aesthetics securities private limited',
    'Casper securities private limited',
    'Mehul finance and investments private limited',
    'Poddar amalgamated holdings private limited',
    'Killick impex limited',
    'Sweet industries india private limited',
    'Troika securities private limited',
    'Aquest auto private limited',
    'ANDAZ TEXTILES PRIVATE LIMITED',
    'Priceline securities and investments private limited',
    'Joindre commodities limited',
    'Navneetlal holdings (india ) private limited',
    'Lastaki management consultants private limited',
    'Gravity financial services pvt ltd',
    'Lpy consultants private limited',
    'Everstone capital advisors private limited',
    'DISTRESS ASSET SPECIALIST LIMITED',
    'AROBANAANNAI NIDHI LIMITED',
    'Cornelian realtors and developers private limited',
    'DIGI1 ELECTRONICS PRIVATE LIMITED',
    'Dipti realtors private limited',
    'M86 RESIDENCY PRIVATE LIMITED',
    'A us holidays realty private limited',
    'PRITHVI CHAVAN PRODUCTIONS PRIVATE LIMITED',
    'Ellora asian realty private limited',
    'Tarama appartment private limited',
    'Sumangal industries limited',
    'Grindlay properties private limited',
    'Aggarwal towers private limited',
    'International sos services (india) private limited',
    'Rohit tower building ltd',
    'Samskruti builders private limited',
    'Baba enterprises private limited',
    'Zzimlia propertiees private limited',
    'Anuba property developers private limited',
    'Well-groomed developers limited',
    'JAYDEN INTERNATIONAL TRADERS PRIVATE LIMITED',
    'Aaam properties private limited',
    'Kumar urban development private limited',
    'Bagadia properties private limited',
    'Mahaghar properties private limited',
    'Traders tower constructions and property developers private limited',
    'Ketki properties and estates pvt ltd',
    'Vikalp projects private limited',
    'Fortune enclave private limited',
    'Euston infrastructure private limited',
    'Indospace industrial parks private limited',
    'Indospace skcl industrial park oragadam private limited',
    'UNIQUE KEEMAYA INFRAHOMES PRIVATE LIMITED',
    'Chainani infra private limited',
    'Grishma realtors private limited',
    'Reliable tech park private limited',
    'Wayanad realty private limited',
    'Mandiri realty investment (india) private limited',
    'Majolica propcon private limited',
    'Cjr realty private limited',
    'Sankrish estates private limited',
    'Ice constructions private limited',
    'ASHDAN DEVELOPERS PRIVATE LIMITED',
    'Panindia properties private limited',
    'Primco real estates private limited',
    'KUMAR NOVEL HOUSING PRIVATE LIMITED',
    'LEGALA ESTATES PRIVATE LIMITED',
    'VISHWA SAMANYU PROJECTS PRIVATE LIMITED',
    'Nec real estate private limited',
    'Ispace living edge properties india private limited',
    'Sable property holdings private limited',
    'Everstrong developers private limited',
    'Suvijay enterprises private limited',
    'Wadhwa estates and developers (india) private limited',
    'Wadhwa construction & infrastructure private limited',
    'Kshitij property solutions private limited',
    'Keemaya habitators private limited',
    'Disha loharuka infratech private limited',
    'Shivmani properties private limited',
    'Everlink enclave private limited',
    'Hulbert conclave private limited',
    'Goodpoint promoters private limited',
    'Raghunath lessors and real estates private limited',
    'Raghuveer leasing and real estates private limited',
    'Destination industrial parks private limited',
    'Keemaya housing private limited',
    'Pune realty maintenance services private limited',
    'Nice herbal medicine private limited',
    'Virbac animal health india private limited',
    'Phoenix medicare private limited',
    'Carp fine chem private limited',
    'Nilisha Buildwell Private Limited',
    'Biozeal lifesciences private limited',
    'WYNCLARK PHARMACEUTICALS PRIVATE LIMITED',
    'Mapei construction products india private limited',
    'Jaydip agencies private limited',
    'Poly hose india (rubber) private limited',
    'Topaz plast india private limited',
    'Sapthagiri pipes private limited',
    'Merrictro products private limited',
    'New gujarat polyplast private limited',
    'Arvind anticor limited',
    'Enpro con enter prise limited',
    'Sukaso ceracolors private limited',
    'Eastern ceramics limited',
    'Umberto ceramics international private limited',
    'Sri lalita cement industries limited',
    'Indcon structurals private limited',
    'V.S.T.MOTORS PRIVATE LIMITED',
    'Ravi technoforge private limited',
    'Sumangal castings private limited',
    'Shree vaishnav industries private limited',
    'Fortune ispat private limited',
    'Sree adityageethika ferro alloys private limited',
    'Quartet industrial solutions private limited',
    'Sree jaya vilas malleable castings private limited',
    'MAASHEETLA VENTURES LIMITED',
    'Raja alloys and metals private limited',
    'Riddhim siddhim steel (india) private limited',
    'Maruthi aluminium private limited',
    'Matrix housewares private limited.',
    'Pickme e-solutions india private limited',
    'Stainox alloys private limited',
    'Surabhi iron and steel company private limited',
    'THRIAM LITES PRIVATE LIMITED',
    'Shellmech precision cast private limited',
    'V b steel private limited',
    'United roofing systems (south india) private limited',
    'AVMY HEALTH PRIVATE LIMITED',
    'Kgn metals private limited',
    'Genesis coatings private limited',
    'Shradha forge pvt ltd',
    'Vinfab engineers india private limited',
    'SIGNATUREGLOBAL SECURITIES PRIVATE LIMITED',
    'Godson bending systems private limited',
    'Fenix process technologies private limited',
    'Su-mech storage systems private limited',
    'V3 powerpetro engineering private limited',
    'Kaveen infra solutions private limited',
    'New kessler engineering pvt ltd',
    'Shree satyanarayan industrial suppliers private limited',
    'Hamtek infra projects india private limited',
    'RICO FLUIDTRONICS LIMITED',
    'Pooja precision screws private limited',
    'Mascot systems private limited',
    'Omicron machine tools private limited',
    'Sicor engineering india private limited',
    'Khedut agro equipment private limited',
    'Ritebanc agri tech solutions private limited',
    'Evolutis india private limited',
    'Dc auto enterprises private limited',
    'Vrs elevators private limited',
    'Bosch automotive electronics india private limited',
    'Hedisa india diamond tools private limited',
    'ALUTEC FACADES INDIA PRIVATE LIMITED',
    'Gevas elevator private limited',
    'Lift-well hydraulics private limited',
    'Anil air tech engineers pvt.ltd.',
    'Shrijee process engineering works limited',
    'Hail mary enterprises private limited',
    'IGL INDUSTRIES LIMITED',
    'Marque systems private limited',
    'Fima india private limited',
    'Fairdeal components limited',
    'INOVANCE TECHNOLOGY PRIVATE LIMITED',
    'Sanjivan industries private limited',
    'Arr engineering (india) private limited',
    'Kolben compressor spares (india ) private limited',
    'Amlf works private limited',
    'Redex india private limited',
    'Shaan lube equipment private limited',
    'Klima technologies private limited',
    'MODI SPECIAL PURPOSE MACHINES PRIVATE LIMITED',
    'SETCO SPINDLES INDIA PRIVATE LIMITED',
    'Delval flow controls private limited',
    'Glazepro sun energy private limited',
    'Ross thermal systems private limited',
    'Rinchhada heat-cool systems private limited',
    'Ace electromagnetics private limited',
    'Volpak systems private limited',
    'Iljin automotive private limited',
    'Gt mechatronics private limited',
    'Protocol one it labs private limited',
    'Joister infomedia private limited',
    'Atlas solutions and consulting private limited',
    'Aayu infosystems private limited',
    'S2s technologies private limited',
    'Sumanabh software private limited',
    'Samyak (india) private limited',
    'Thinkbridge software private limited',
    'Divate technology consulting private limited',
    'JUMIO INDIA PRIVATE LIMITED',
    'Raivens technologies private limited',
    'Eidiko systems integrators private limited',
    'Seaant web technologies private limited',
    'MMH GLOBAL (INDIA) PRIVATE LIMITED',
    'TUTIS INNOVATIVE E-SERVICES PRIVATE LIMITED',
    'Inser solutions private limited',
    'Tuli e services private limited',
    'Abs professional services (india) private limited',
    'Dalberg development advisors private limited',
    'Resilience design and research labs',
    'Netmagic solutions private limited',
    'Riviera retails private limited',
    'Raftaar logistics (i) private limited',
    'Al ghurair construction aluminium india private limited',
    'Swabhav venturelabs services private limited',
    'Ferring therapeutics private limited',
    'Digital payments processing limited',
    'Prathamam manpower services private limited',
    'Quotient communications private limited',
    'UDAYA VISTARA SOLUTIONS PRIVATE LIMITED',
    'Visa managed service (india) private limited',
    'Smmart entrepreneur transformation co private limited',
    'Sampoorna yoga shala private limited',
    'DATANG TECHNOLOGIES & ENGINEERING INDIA PRIVATE LIMITED',
    'OP&E MANAGEMENT LIMITED',
    'Bright offshore solutions india private limited',
    'MINI SIGNS & DISPLAYS PRIVATE LIMITED',
    'Gator systems private limited',
    'Kleentech network private limited',
    'Skyboard media private limited',
    'Origin hr private limited',
    'Chapter 24 consulting private limited',
    'Gs3 engineering solutions private limited',
    'Audax protective fabrics private limited',
    'Graphene media private limited',
    'LYK APP INDIA PRIVATE LIMITED',
    'Bossar packaging private limited',
    'Tmeic industrial systems india private limited',
    'Integriti ventures india private limited',
    'AAROGHYA DISTRIBUTION PRIVATE LIMITED',
    'S.kumars retailer services private limited',
    'Mediaguru consultants private limited',
    'MGS VENTUREZ PRIVATE LIMITED',
    'Logicpro consulting private limited',
    'SUPP NUTRITION PRIVATE LIMITED',
    'Bittrack consultants private limited',
    'Atelier dada private limited',
    'D.h.patel and associates private limited',
    'Vinamra consultancy private limited',
    'Avid information search and documents private limited',
    'IQVIA ANALYTICS SERVICES PRIVATE LIMITED',
    'Wizmatrix consulting private limited',
    'V h r solution private limited',
    'Ferring pharmaceuticals private limited',
    'SHREE TISAI SECURITIES PRIVATE LIMITED',
    'Dow jones consulting india private limited',
    'New berry advisors limited',
    'Transamerica direct marketing consultants private limited',
    'Aarpee consultancy services private limited',
    'I2 PRO SERVICES PRIVATE LIMITED',
    'Itus life services private limited',
    'Zodiac hr consultants india private limited',
    'IMPERATIVE BUSINESS VENTURES LIMITED',
    'SGK INDIA ENGINEERING PRIVATE LIMITED',
    'Limelite consultants private limited',
    'Cogent training research development consultants private limited',
    'Ition solutions limited',
    'Imam consultants private limited',
    'Godavari strategic advisory services private limited',
    'Synergy management advisors private limited',
    'Vargo petro-tech private limited',
    'Reach sewn technologies and consulting private limited',
    'Pheroze kudianavala consultants private limited',
    'Susagar engineering private limited',
    'Technohand services private limited',
    'Kalpaka designers & engineers (india) private limited',
    'Devi hi-tech engineers pvt. ltd.',
    'Fabritek engineers and consultants private limited',
    'Blue lotus communications private limited',
    'Atom creatives private limited',
    'Intinex (india) private limited',
    'NORTHERN INDIA ALCOHOL SALES PRIVATE LTD',
    'TRANS INDIA HOLIDAYS PRIVATE LIMITED',
    'Rna agencies private limited',
    'Kochhar travels private limited',
    'Sgs industrial controls and solutions private limited',
    'Xado india lubricants private limited',
    'Meghdooth motors private limited',
    'Growers agrireach private limited',
    'Inborn engineering solutions pvt ltd',
    'Winbros exim private limited',
    'Target sourcing services india private limited',
    'Dvksp impex private limited',
    'ADD-SHOP E-RETAIL LIMITED',
    'Balaji cellphone private limited',
    'Pema rules private limited',
    'Bestseller wholesale india private limited',
    'Truly pest solution private limited',
    'Capital foods private limited',
    'Luxury goods retail private limited',
    'Mapple stainless processing private limited',
    'LOGITECH ELECTRONICS (INDIA) PRIVATE LIMITED',
    'Healthilife exim (india) private limited',
    'Zytex international private limited zytex',
    'Samrat gems impex private limited',
    'Manoj ornaments private limited',
    'Fabula trading company private limited',
    'Skytech infinite platform private limited',
    'PAREKH INNOVATIVE LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'Parekh integrated services private limited',
    'Thukral trading private limited',
    'Tody brothers pvt ltd',
    'Sancare exports pvt ltd',
    'Multi-line business solutions private limited',
    'Delmar trading company private limited',
    'Ajaayu trading and consultancy private limited',
    'Vedant property private limited',
    'Winning moves toys & games private limited',
    'Ritebrand retail private limited',
    'JAI MAHAKALESHWAR EXPORTS PRIVATE LIMITED',
    'Techcomp biosafe lab india private limited',
    'Jeol india private limited',
    'Clarion india private limited',
    'Aluk building systems private limited',
    'Westernghats agro growers company limited',
    'Surge impex private limited',
    'West pioneer properties (india) private limited',
    'Marmik traders private limited',
    'J r chemtrade private limited',
    'Advika international private limited',
    'Ekta international private limited',
    'Shiva multitrade private limited',
    'Avico exim private limited',
    'Tekwin power systems india private limited',
    'FURNCOMS PRIVATE LIMITED',
    'Greenway tradecom limited',
    'Yashwi agencies private limited',
    'NAVOTECH AGENCIES PRIVATE LIMITED',
    'Novel instruments private limited',
    'Manshi edge tech private limited',
    'Spaces arena private limited',
    'Nayuta trading private limited',
    'GALAXY UNIVERSAL TRADES PRIVATE LIMITED',
    'Anand bazar private limited',
    'Saket market private limited',
    'Magppie international limited',
    'Strata retail and technology services private limited',
    'Jainuine lnsurance brokers private limited',
    'Veracity broking services private limited',
    'Ignite jewels private limited',
    'Srihitha shopping services private limited',
    'L i d jewellery (india) private limited',
    'India recypa private limited.',
    'Johnlee pharmaceuticals private limited',
    'Magppie retail limited',
    'Bet medical private limited',
    'SIMBA LOGISTICS PRIVATE LIMITED',
    'Relax hotel private limited',
    'Wonderland residency private limited',
    'Srs retreat services limited',
    'Zarina sultan hotels and resorts private limited',
    'Rayan holiday resorts private limited',
    'PNAIA TECHNOLOGIES PRIVATE LIMITED',
    'CHERUBIC INDIA SOURCING (OPC) PRIVATE LIMITED',
    'AFRO SEARCH INTERNATIONAL PRIVATE LIMITED',
    'SOCIOWASH MEDIA PRIVATE LIMITED',
    'MOKKOMOTTO (OPC) PRIVATE LIMITED',
    'MEDNOLOGIES PRIVATE LIMITED',
    'EUGIA STERILES PRIVATE LIMITED',
    'ACE SEZ DEVELOPERS PRIVATE LIMITED',
    'WHITE AND BLACK ENTERTAINMENT PRIVATE LIMITED',
    'REMASSIS SOLUTIONS PRIVATE LIMITED',
    'ENDURANCE EXPORTS PRIVATE LIMITED',
    'R R K COTTON',
    '84 SUPPORT FOUNDATION',
    'MONICA DIGITAL GRAPHIC PRIVATE LIMITED',
    'RADHIKA',
    'ESPRIT APPAREL PRIVATE LIMITED',
    'AGUA WOMEN',
    'S AND DAD',
    'S AGRITECH PRIVATE LIMITED',
    'FACTORNEST TECHNOLOGIES PRIVATE LIMITED',
    'ECOTACT INNOVATIONS PRIVATE LIMITED',
    'BIOEUR INDIA (OPC) PRIVATE LIMITED',
    'SPARCOLIFE DIGITAL HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'PRIMADONN CONSTRUCTION CHEMICALS PRIVATE LIMITED',
    'WEBIZY TECHSOL PRIVATE LIMITED',
    'TEA WHEELER PRIVATE LIMITED',
    'CRB INDUSTRY PRIVATE LIMITED',
    'VALOR PAYTECH INDIA PRIVATE LIMITED',
    'HRISHIKESH OVERSEAS & CONSULTANCY PRIVATE LIMITED',
    'POLYCON ACE HEALTHCARE PRIVATE LIMITED',
    'INTELLIMINT TECHNOLOGIES PRIVATE LIMITED',
    'AMALGAM MINES & MINERALS PRIVATE LIMITED',
    'IOCOD INFOTECH PRIVATE LIMITED',
    'CRISPRBITS PRIVATE LIMITED',
    'PRAHS BUSINESS HOUSE INDIA PRIVATE LIMITED',
    'MOVEWORKS PRIVATE LIMITED',
    'MEDIKIGAI INDIA PRIVATE LIMITED',
    'WHIZHACK TECHNOLOGIES PRIVATE LIMITED',
    'CG CARBON INDIA PRIVATE LIMITED',
    'AMV INDUSTRIES PRIVATE LIMITED',
    'BOLDBRAIN EDUCATION AND IMMIGRATION CONSULTANCY PRIVATE LIMITED',
    'UDBHAVA TECHNOLOGIES PRIVATE LIMITED',
    'SLASHRTC CLOUD PRIVATE LIMITED',
    'LAZYARTS INDIA PRIVATE LIMITED',
    'SUPERAPPLETS INDIA PRIVATE LIMITED',
    'SAFE AND STRONG IT SOLUTIONS PRIVATE LIMITED',
    'MYCLEAN SHINING INDIA FOUNDATION',
    'FINVERSE UPSKILLING PRIVATE LIMITED',
    'GHRELIN PHARMACEUTICALS PRIVATE LIMITED',
    'BRAD CONSULTING PRIVATE LIMITED',
    'SAI SUNNY ENTERPRISES PRIVATE LIMITED',
    'THIAGARAJAN AUTOMOBILES TRADING PRIVATE LIMITED',
    '7D METHOD PRIVATE LIMITED',
    'SATAMANA VENTURES PRIVATE LIMITED',
    'INTERGLOBE WONDER PRODUCTS PRIVATE LIMITED',
    'RECARE ENERGY PRIVATE LIMITED',
    'GOLDCOIN FLEXIPACK PRIVATE LIMITED',
    'ANANTU TECH SOLUTIONS PRIVATE LIMITED',
    'TRUE NORTH TECHNOLOGIES PRIVATE LIMITED',
    'VISUALAPP FOUNDRY PRIVATE LIMITED',
    'INFINITUDE LOGISTICS PRIVATE LIMITED',
    'RBP RENEWABLE (INDIA) PRIVATE LIMITED',
    'GROW SHINE INFRA PROJECTS PRIVATE LIMITED',
    'STEP2GEN TECHNOLOGIES PRIVATE LIMITED',
    'DRIP MUSIC PRIVATE LIMITED',
    'MASTER GROUP EMPIRE PRIVATE LIMITED',
    'IQZYME MEDTECH PRIVATE LIMITED',
    'EXOTIC PHONE ACCESSORIES AND REPAIR PRIVATE LIMITED',
    'SKYLINE INFRA CONSTRUCTION PRIVATE LIMITED',
    'ADLER WORKFORCE SOLUTIONS PRIVATE LIMITED',
    'IOS LOGIC PRIVATE LIMITED',
    'PROMPTSPACE SOCIAL VENTURES PRIVATE LIMITED',
    'DIGITALSCOUTS INDIA PRIVATE LIMITED',
    'JVRX ASSET MANAGEMENT PRIVATE LIMITED',
    'ALPHATECH DREDGE AND OFFSHORE SERVICES PRIVATE LIMITED',
    'EXPONENT ENERGY PRIVATE LIMITED',
    'AMRAAN EXPORTS PRIVATE LIMITED',
    'KNACK STUDIOS MEDIA PRIVATE LIMITED',
    'BCI PAYMENT INNOVATIONS LIMITED',
    'ALGOSENSE SYSTEMS PRIVATE LIMITED',
    'SKILLJAGINDIA PRIVATE LIMITED',
    'ACIC-MCATS FOUNDATION',
    'TATA BUSINESS HUB LIMITED',
    'MONASTIC HILL STUDIOS PRIVATE LIMITED',
    'SAFEDATA SOLUTIONS PRIVATE LIMITED',
    'DVL LOGISTICS PRIVATE LIMITED',
    'BMSINDIA MEDICAL RESOURCING PRIVATE LIMITED',
    'NATUREMAX FOODS PRIVATE LIMITED',
    'AIOSP - ASSOCIATION OF INDIAN OILFIELD SERVICE PROVIDERS',
    'FOTON PMI ELECTRO BUS INDIA PRIVATE LIMITED',
    'JSS AVIATION ENGINEERING AND MAINTENANCE PRIVATE LIMITED',
    'UNIQUECHARITABLE FOUNDATION',
    'BUDDHI FOODS PRIVATE LIMITED',
    'SURABHI POLYMERS PRIVATE LIMITED',
    'ATTICUS CAPITAL AND FINANCIAL SERVICES PRIVATE LIMITED',
    'SKOOTR FINSAVE PRIVATE LIMITED',
    'RIPIK TECHNOLOGY PRIVATE LIMITED',
    'PENTACAP ADVISORS PRIVATE LIMITED',
    'STEP UP ARCH PRIVATE LIMITED',
    'WISEHELIX SYSTEMS PRIVATE LIMITED',
    'WESTEND EDUCORP PRIVATE LIMITED',
    'BROWN BUNNY HEALTHTECH PRIVATE LIMITED',
    'OCGI FARMING PRIVATE LIMITED',
    'NORESTE TOUR INDIA PRIVATE LIMITED',
    'LEON STEELS PRIVATE LIMITED',
    'PRATRA TRAVEL TECHNOLOGIES PRIVATE LIMITED',
    'MBO PARTNERS INDIA PRIVATE LIMITED',
    'COMPLINOVA ASSOCIATES PRIVATE LIMITED',
    'MAXWELL BIOTECH PRIVATE LIMITED',
    'NAVCHIN MARINE DESIGN AND SHIPBUILDING PRIVATE LIMITED',
    'K AND D PROJECT TECHNOLOGIES LIMITED',
    'FIBS LOGISTICS INDIA PRIVATE LIMITED',
    'EA GIBSON SHIPBROKERS (INDIA) PRIVATE LIMITED',
    'SOUHARDYA SORBODA FOUNDATION',
    'PEAK INFINITY PRIVATE LIMITED',
    'POLYCARB ADVANCE SCIENCE PRIVATE LIMITED',
    'MANATEC E DRIVE PRIVATE LIMITED',
    'ASTERI TECHNOLOGY PRIVATE LIMITED',
    'TENANTCUBE TECHNOLOGIES PRIVATE LIMITED',
    'SIMONEFX REALITY LABS PRIVATE LIMITED',
    'KASHYP TECHNOENGICON INDIA PRIVATE LIMITED',
    'WINACLE CONSULTING PRIVATE LIMITED',
    'CLOUDFEATHER GAMES PRIVATE LIMITED',
    'XPLOREROOTS PRIVATE LIMITED',
    'EVERYWHERE AS A SERVICE PRIVATE LIMITED',
    'PRAMATI INDUSTRIES PRIVATE LIMITED',
    'BARK PARK SERVICES PRIVATE LIMITED',
    'KITCHEN HUBTECH OPERATIONS PRIVATE LIMITED',
    'CODEDCHALK EDU TECHNOLOGIES PRIVATE LIMITED',
    'VINAYAKAM FASHIONHUT INDIA PRIVATE LIMITED',
    'ECOBROWN PRODUCTS PRIVATE LIMITED',
    'A G MIND GAME PRIVATE LIMITED',
    'SANRON KLC BIOFUEL PRIVATE LIMITED',
    'RESMAN IMAGING PRIVATE LIMITED',
    'TRIELC ENGINEERS PRIVATE LIMITED',
    'VSTEELLANES ENGINEERING AND SERVICES PRIVATE LIMITED',
    'TINYBITT PRIVATE LIMITED',
    'ACHHA HE PRIVATE LIMITED',
    'MEDVOLT TECH PRIVATE LIMITED',
    'SMARTBIZZ CONSULTANCY AND SOLUTIONS PRIVATE LIMITED',
    'RENULYTICS PRIVATE LIMITED',
    'CONVERGENCE ENERGY SERVICES LIMITED',
    'NS TRANSPORT PRIVATE LIMITED',
    'HIFS HELP INDUSTRIAL FIRE SERVICES PRIVATE LIMITED',
    'FUTURE INDIA KITCHEN PRIVATE LIMITED',
    'BE1 GLOBAL TECH PRIVATE LIMITED',
    'LOANWISE FINANCIAL SERVICES PRIVATE LIMITED',
    'ACCURA INDIA PRIVATE LIMITED',
    'INTEGRATED SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'HOSKOTE WAREHOUSING PRIVATE LIMITED',
    'LAITH BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'ADVERTISE.NETWORK PRIVATE LIMITED',
    'VIKAS ECORAIN SOLUTION INDIA PRIVATE LIMITED',
    'STANVEE HOSPITALITY PRIVATE LIMITED',
    'EMERGE RENEWABLES PRIVATE LIMITED',
    'MG2NOTORIOUS PRIVATE LIMITED',
    'BONNEX GLOBAL LOGISTICS INDIA PRIVATE LIMITED',
    'TOOLS DIRECT TECHNOLOGIES PRIVATE LIMITED',
    'RUDRANSH MILLS PRIVATE LIMITED',
    'ELEMENT5 RACING (INDIA) PRIVATE LIMITED',
    'TURITO INDIA PRIVATE LIMITED',
    'IIEC PRIVATE LIMITED',
    'AMBROZE FOODS PRIVATE LIMITED',
    'ARELANG NATURALS PRIVATE LIMITED',
    'ANJANADRI MULTI SPECIALITY HOSPITAL PRIVATE LIMITED',
    'MEGA2MINI NETWORKS PRIVATE LIMITED',
    'TECHSHARP HYDRAULIC SOLUTIONS PRIVATE LIMITED',
    'NEHAN POLYPROPYELENE SOLUTIONS PRIVATE LIMITED',
    'AVINGENIOUS TECHNOLOGIES PRIVATE LIMITED',
    'STRATAMINE CONSULTING PRIVATE LIMITED',
    'IBL HEALTHCARE LIMITED',
    'SPACEFERRY LOGISTICS INDIA PRIVATE LIMITED',
    'MITOGENE TECHNOLOGIES PRIVATE LIMITED',
    'ATMASHRAY FOUNDATION',
    'CDD STRUCTURES PRIVATE LIMITED',
    'SKILLTREE FOUNDATION',
    'PSYNCOPATE TECHNOLOGIES PRIVATE LIMITED',
    'MODULAR MOBILE FACILITY PRIVATE LIMITED',
    'SPECSBHARAT OPTICALS PRIVATE LIMITED',
    'YG ESTATES PROPERTY MANAGEMENT PRIVATE LIMITED',
    'VW CONSULTING SERVICES PRIVATE LIMITED',
    'SMILY HOSPITALITY PRIVATE LIMITED',
    'KAYTWO CYBER SECURITY INDIA PRIVATE LIMITED',
    'NEXTGENINNOV8 SOCIAL FOUNDATION',
    'PRIZE HEALTH CARE FOUNDATION',
    'EMERALD SUSTAINABLE FOUNDATION',
    'V GUEST INN PRIVATE LIMITED',
    'PAGENTRA INFOSEC PRIVATE LIMITED',
    'INSA UNITED HEAVY INDUSTRIES PRIVATE LIMITED',
    'TRANSPEC LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'VIJAYANAND FOODS PRIVATE LIMITED',
    'HEPTACREST PRIVATE LIMITED',
    'SRI BALAHA CONSTRUCTION PRIVATE LIMITED',
    'NAMASCRAY EXPERIENCE PRIVATE LIMITED',
    'FETCH.IN PRIVATE LIMITED',
    'RAVI TELECOMMUNICATION PRIVATE LIMITED',
    'CONFIANCE BEVERAGES PRIVATE LIMITED',
    'NEOMAD JOURNEYS PRIVATE LIMITED',
    'ANUBAL AGRI FOODS PRIVATE LIMITED',
    'INDO WINGS PRIVATE LIMITED',
    'NEOVENTIVE TECH PRIVATE LIMITED',
    'KHAANA CHAHIYE FOUNDATION',
    'ZILLIORS TECHNOLOGY INDIA PRIVATE LIMITED',
    'SKYY RIDER ELECTRIC PRIVATE LIMITED',
    'SUPPORT REVOLUTION PRIVATE LIMITED',
    'SSS RISK MANAGEMENT AND INSURANCE BROKERS PRIVATE LIMITED',
    'REHLA - GARHWA HIGHWAYS PRIVATE LIMITED',
    'MOLDTEK POLYMER INDUSTRIES PRIVATE LIMITED',
    'EFFICACIOUS ADVISORS PRIVATE LIMITED',
    'MAHAJAN AWAS FOUNDATION',
    'TECHFER GLOBAL PRIVATE LIMITED',
    'AIRDOOT INDIA PRIVATE LIMITED',
    'VFUNDS PRIVATE LIMITED',
    'BEAUTYTALK ENTERPRISES PRIVATE LIMITED',
    'DEBTLIFE HOLDINGS PRIVATE LIMITED',
    'CROSSWORD AGROINDUSTRIES PRIVATE LIMITED',
    'INTECHNO PRODUCTS PRIVATE LIMITED',
    'TOP LIGHT FABRICS PRIVATE LIMITED',
    'CLOUDAGE GLOBAL SERVICES PRIVATE LIMITED',
    'LIFESPAN FOODS PRIVATE LIMITED',
    'SANKHYANA CONSULTANCY SERVICES PRIVATE LIMITED',
    'BEAKON CHANNELS PRIVATE LIMITED',
    'WEB WERKS INTERNET SERVICES PRIVATE LIMITED',
    'TCS CARBONS PRIVATE LIMITED',
    'WINFARM PRODUCER COMPANY LIMITED',
    'JAGANNATH INDUSTRIAL AND LOGISTICS PARKS PRIVATE LIMITED',
    'BREKLERS PRIVATE LIMITED',
    'VMN EXPORTS PRIVATE LIMITED',
    'SUDHAAMAYA MINES PRIVATE LIMITED',
    'ANAARAH IMPEX CONCIERGE PRIVATE LIMITED',
    'AUXO INDUSTRIES PRIVATE LIMITED',
    'LOGIQAI SOFTWARE INDIA PRIVATE LIMITED',
    'OXYFLOW CONTROLS PRIVATE LIMITED',
    'STEELERA STRUCTURES PRIVATE LIMITED',
    'ORBIT VICTORIA OWNERS ASSOCIATION',
    'EVERMETHOD TECHNOLOGY SERVICES PRIVATE LIMITED',
    'IPPOPAY TECHNOLOGIES PRIVATE LIMITED',
    'BUYFURNO PRIVATE LIMITED',
    'PHASE POWER AND AUTOMATION PRIVATE LIMITED',
    'MYVDYA EDUTECH PRIVATE LIMITED',
    'COMPOSITE STRAP INDIA PRIVATE LIMITED',
    'ARK GENE BUSINESS CONSULTING PRIVATE LIMITED',
    'DHARMAPAN PRIVATE LIMITED',
    'INTELLING IT SOLUTIONS PRIVATE LIMITED',
    'SMARTEXT AI LABS PRIVATE LIMITED',
    'IIT KHARAGPUR AI4ICPS I HUB FOUNDATION',
    'NN INVESTMENTS PRIVATE LIMITED',
    'AEXENT VENTURES PRIVATE LIMITED',
    'V.A.S. AUTOMOTIVE INDIA PRIVATE LIMITED',
    'AXIS ECORP HOLDINGS PRIVATE LIMITED',
    'SRI SHAAKHA GRANITES PRIVATE LIMITED',
    'APOYEN TECHNOLOGIES PRIVATE LIMITED',
    'OTIPY INTERNET PRIVATE LIMITED',
    'HYS INDUSTRIES PRIVATE LIMITED',
    'STDYGRP TECHNOLOGY PRIVATE LIMITED',
    'MEGAEXPRESS LOGISTICS PRIVATE LIMITED',
    'GKR CONSTRUCTIONS PRIVATE LIMITED',
    'DING INFINITY PRIVATE LIMITED',
    'SVANPRO IT TECHNOLOGIES PRIVATE LIMITED',
    'TAKEOFF FINTECH PRIVATE LIMITED',
    'MAARUTI CONCRETE FLOOR PRIVATE LIMITED',
    'ELECOREV RAMWAY INDIA PRIVATE LIMITED',
    'MULTIPLE COMPUTECH PRIVATE LIMITED',
    'ACBROTHERS EXPORTS PRIVATE LIMITED',
    'TECHPLAIN PRIVATE LIMITED',
    'SPICETECH SYSTEM PRIVATE LIMITED',
    'SPORTS GURU TECH INDIA PRIVATE LIMITED',
    'COLMAN AND KLEIN PRIVATE LIMITED',
    'SANCHI SOCIAL FOUNDATION',
    'CASTROCHEM PRIVATE LIMITED',
    'VEERSA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'JIO MEDIA LIMITED',
    'VAVOTECH SOFTWARES PRIVATE LIMITED',
    'INFRUIT TRAVELS PRIVATE LIMITED',
    'WIRE MONSTER PRIVATE LIMITED',
    'DR. SYAMA PRASAD MOOKERJEE INSTITUTE OF MEDICAL SCIENCES & RESEARCH FORUM',
    'WEBKALAKAAR SOFTWARE PRIVATE LIMITED',
    'MAGLARK SOFTWARE PRIVATE LIMITED',
    'ARLANXEO INDIA PRIVATE LIMITED',
    'PARAMSUKH BUILDERS PRIVATE LIMITED',
    'FINTRINSIC INDIA PRIVATE LIMITED',
    'APAARSEVA FOUNDATION',
    'TEXAS BREWERIES & BEVERAGES PRIVATE LIMITED',
    'BEST OVERSEAS EDUCATION PRIVATE LIMITED',
    'GRAVITY GLOBAL AGROTECH PRIVATE LIMITED',
    'SCEPTERTECH MEDIA PRIVATE LIMITED',
    'ARJAS MODERN STEEL PRIVATE LIMITED',
    'FINCENT SOFTWARE SERVICES PRIVATE LIMITED',
    'NUMERAH GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'KONNECT PATHLABS PRIVATE LIMITED',
    'VIZYON TECHNOLOGIES PRIVATE LIMITED',
    'SARATHY BIKES PRIVATE LIMITED',
    'SQUAREORBIT TECHNOLOGIES PRIVATE LIMITED',
    'MYMUSE INDIA PRIVATE LIMITED',
    'YOUHE LOGISTICS PRIVATE LIMITED',
    'MACROACTIVE FIT SCIENCE INDIA PRIVATE LIMITED',
    'K PATEL LIFESCIENCES PRIVATE LIMITED',
    'ASL NIRMAN PRIVATE LIMITED',
    'KRISH V GLOBAL ENTERPRISES PRIVATE LIMITED',
    'STERKEE TECHNOLOGIES PRIVATE LIMITED',
    'WOTLINE PRIVATE LIMITED',
    'K9 PETZERVICES PRIVATE LIMITED',
    'SMARTNRICH GLOBAL PRIVATE LIMITED',
    'UPMINT SOLUTIONS PRIVATE LIMITED',
    'CYBERPEACE COUNCIL',
    'STARLITE ELECTRODRIVES PRIVATE LIMITED',
    'GAYATRIDEVI FOODS AND BEVERAGES PRIVATE LIMITED',
    'ICON ELECTROMATIC PRIVATE LIMITED',
    'SAIGESECURE PRIVATE LIMITED',
    '4G5G CONSULTANTS PRIVATE LIMITED',
    'HILOTEX INTERNATIONAL PRIVATE LIMITED',
    'HAPPY ELEARNINGS TECH PRIVATE LIMITED',
    'CURLYDREAMS DIGITAL SERVICES (OPC) PRIVATE LIMITED',
    'SAKARASHOP ONLINE PRIVATE LIMITED',
    'APPSTARS APPLICATIONS PRIVATE LIMITED',
    'MYLINQ SOLUTIONS PRIVATE LIMITED',
    'LEAP AGRI LOGISTICS (BALURGHAT) PRIVATE LIMITED',
    'WINSOME HOSPITAL PRIVATE LIMITED',
    'CRESCENZA CONSULTING PRIVATE LIMITED',
    'SURAAVA HOLDINGS PRIVATE LIMITED',
    'HIPTAN SILICA CHEMS LIMITED',
    'FINEST STUDIO PRIVATE LIMITED',
    'BWO ASSOCIATION',
    'QUINARY CLINICAL RESEARCH PRIVATE LIMITED',
    'RULE OF THIRDS TECHNOLOGIES PRIVATE LIMITED',
    'WOCKHARDT REGENERATIVE PRIVATE LIMITED',
    'UPPER INDIA METATECH PRIVATE LIMITED',
    'DEESHA JYOT FOUNDATION',
    'ENTWURFEN SAFETY SOLUTIONS PRIVATE LIMITED',
    'ALPHACUBE TECHNOLOGIES PRIVATE LIMITED',
    'PRAYAGRAJ SWM PRIVATE LIMITED',
    'BRAB MEDIA PRIVATE LIMITED',
    'SHUNIYA VIGYAN PRIVATE LIMITED',
    'VELSTONE TRADING AND SERVICES PRIVATE LIMITED',
    'ZILLIOT TECHNOLOGIES PRIVATE LIMITED',
    '2A TRADING INDIA PRIVATE LIMITED',
    'UGA CABLE AND PIPE SEALING SYSTEMS INDIAPRIVATE LIMITED',
    'AQUILAPAY SOLUTIONS (OPC) PRIVATE LIMITED',
    'BRICKTECH INFRA SOLUTIONS PRIVATE LIMITED',
    'MICROGRID LABS INDIA PRIVATE LIMITED',
    'PINAKINNSOFT PRIVATE LIMITED',
    'TOTSOL AVIATION PRIVATE LIMITED',
    'DOUBT BUDDY EDUCATION TECHNOLOGY PRIVATELIMITED',
    'INFOITY TECHNOLOGIES PRIVATE LIMITED',
    'BUYERGAINS PRIVATE LIMITED',
    'APEKSHA LOGISTICS PRIVATE LIMITED',
    'SHIVAAN FOODS AND BEVERAGES PRIVATE LIMITED',
    'INPO VENTURES PRIVATE LIMITED',
    'WINEURAL TECHNOLOGIES PRIVATE LIMITED',
    'MERINO INFRA PROJECTS PRIVATE LIMITED',
    'ACCOUNTEGRITY CONSULTANTS PRIVATE LIMITED',
    'VIRESCENT RENEWABLE ENERGY PROJECT MANAGER PRIVATE LIMITED',
    'PHILOM TECH PRIVATE LIMITED',
    'EVA GROW MEDICAPS PRIVATE LIMITED',
    'ZAK VENTURE BIOGAS PRIVATE LIMITED',
    'WATER WALL PROJECTS PRIVATE LIMITED',
    'DARWIN PLATFORM BLISS LECLAT CONCIERGE SERVICE LIMITED',
    'JAMWAY LOGISTICS PRIVATE LIMITED',
    'GLOBEGEOMATICS PRIVATE LIMITED',
    'RUBA VENTURES PRIVATE LIMITED',
    'MAKKNOWLEDGE INDIA PRIVATE LIMITED',
    'INTRA LIFE PRIVATE LIMITED',
    'PLUTO SOLISTA BUSINESS PARKS PRIVATE LIMITED',
    'JAYAM IRRIGATION SYSTEMS PRIVATE LIMITED',
    'SKY DELIGHT DIGITAL PRIVATE LIMITED',
    'SQUADL TECHNOLOGIES PRIVATE LIMITED',
    'DINSHAWS SNACKS & FOODS PRIVATE LIMITED',
    'TECH ALMOND SOLUTIONS PRIVATE LIMITED',
    'RAAH INDUSTRIES PRIVATE LIMITED',
    'SALAGRAM METALICS PRIVATE LIMITED',
    'QMEASURE TECHNOLOGIES PRIVATE LIMITED',
    'DATA PHASE SYSTEMS PRIVATE LIMITED',
    'BREACHTAPE PRIVATE LIMITED',
    'MATEC ASIA FILTRATION SYSTEMS PRIVATE LIMITED',
    'FOUNDATION FOR STRUCTUREDLEARNING',
    'EASYBUSI CONSULTING PRIVATE LIMITED',
    'ARGONAUT TECHNOLOGIES PRIVATE LIMITED',
    'JDD SPARE AND STORE PRIVATE LIMITED',
    'Q3 VENI FINANCIAL INFORMATION PRIVATE LIMITED',
    'VIAARA FINTECH PRIVATE LIMITED',
    'NEXT TEXTILES PRIVATE LIMITED',
    'BRIDGE POLICY THINK TANK FOUNDATION',
    'MSRIT TECHNICAL RESEARCH AND INNOVATION COUNCIL',
    'P. SATYANARAYAN SONS PRIVATE LIMITED',
    'SARVODYA FOUNDATION FOR INCLUSION',
    'NEWDWORLD PRIVATE LIMITED',
    'G3-GAMING GEARS AND GADGETS PRIVATE LIMITED',
    'RISKBRICKS SOLUTIONS PRIVATE LIMITED',
    'ZOPPER INSURANCE BROKERS PRIVATE LIMITED',
    'INTELBRAIN PRIVATE LIMITED',
    'OM SRUSHTI FOUNDATIONS',
    'VASHUMATI KRUSHI UDYOG PRIVATE LIMITED',
    'REVANZA NUNGAMBAKKAM PRIVATE LIMITED',
    'BLACK COBRA LAM PRIVATE LIMITED',
    'NYC INDIA BUILDERR PRIVATE LIMITED',
    'HHM INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'SOTECH ENGINEERING PRIVATE LIMITED',
    'PRAMA INDIA PRIVATE LIMITED',
    'TINTESS PRIVATE LIMITED',
    'NIRMAN BHARATI HOLDINGS PRIVATE LIMITED',
    'INDIS HODU HOMES PRIVATE LIMITED',
    'FLEET XPRESS PRIVATE LIMITED',
    'MT K KAPITAL PRIVATE LIMITED',
    'SPARE8 PLATFORMS PRIVATE LIMITED',
    'Saams celebrations leisure (india) private limited',
    'Ksg international private limited',
    'Abc adcreation private limited',
    'Peerless commodities limited',
    'Nextel realty private limited',
    'BAZINGA HOME PRODUCTS PRIVATE LIMITED',
    'Navylloyed shipping private limited',
    'Agrinice global spares private limited',
    'Lotus diabetes private limited',
    'FRONTIZO BUSINESS SERVICES PRIVATE LIMITED',
    'STORYTAILORS CONTENT SOLUTIONS PRIVATE LIMITED',
    'Seh apparel (india) private limited',
    'Ubika research and analytics private limited',
    'Kash management services private limited',
    'Multiserv india private limited',
    'Vigil 24x7 guarding services private limited',
    'Gennxt engineers private limited',
    'Vikrant safeguard india private limited',
    'Verde exim private limited',
    'BEYONDYOURLENS CONSULTANTS PRIVATE LIMITED',
    'Zero-sum its solutions india private limited',
    'Stem electronics private limited',
    'Sekhri academy and immigration limited',
    'Borkar packaging private limited',
    'Ikia impex private limited',
    'Xal india private limited',
    'A n john ventures private limited',
    'Shreeji merchants private limited',
    'Idea chakki private limited',
    'BAJAJ PLAST PRIVATE LIMITED',
    'Sbm salt refinery private limited',
    'Your startup solutions (legal) private limited',
    'Vayugrid marketplace services private limited',
    'Scorg international consulting private limited',
    'Kurolikar automation research labs private limited',
    'Anil panganti impex private limited',
    'Dlf promenade limited',
    'M.b.signs and safety systems private limited',
    'I.m market innovative private limited',
    'Outreach advertising private limited',
    'N kumar insurance surveyors and loss assessors private limited',
    'SUN MEDITEK PRIVATE LIMITED',
    'Essjay enterprises private limited',
    'Kundan advisory services limited',
    'Unitech realty private limited',
    'Raj building products private limited',
    'S r lamifab private limited',
    'Geo ground engineering operations india private limited',
    'SHARP HEMP LIMITED',
    'Canara traders & printers private limited',
    'Ppg asian paints private limited',
    'Stratechem (india) private limited',
    'India ingredients private limited',
    'Reliable printers pvt ltd',
    'Goa paints and allied products private limited',
    'Swadesh colours private limited',
    'AMERICAN PRECOAT SPECIALITY PRIVATE LIMITED',
    'Unicure remedies private limited',
    'Emil pharmaceutical industries pvt ltd',
    'RV LIFESCIENCES LIMITED',
    'Insto cosmetics private limited',
    'NUREXA PHARMA PRIVATE LIMITED',
    'Vav life sciences private limited',
    'Raigad offset private limited',
    'OCTOPUS EDUFLEX PRIVATE LIMITED',
    'Superior spirits private limited',
    'Sriram chempro private limited',
    'Toyota chemical industries pvt ltd',
    'Blue diamond oil and petrochemicals limited',
    'JOSTICK POLYMERS PRIVATE LIMITED',
    'Hari udyog private limited',
    'MSN INTEMEDIATES PRIVATE LIMITED',
    'Woodrock healthcare private limited',
    'Bamni proteins limited',
    'King remedies private limited',
    'Micro resins private limited',
    'Merino pharmaceuticals industries private limited',
    'Vilman healthcare private limited',
    'Bonum medelae private limited',
    'Reynders label printing india private limited',
    'Smilax healthcare private limited',
    'Wizcure pharmaa private limited',
    'TIME CAP PHARMA LABS PRIVATE LIMITED',
    'NATURISE CONSUMER PRODUCTS PRIVATE LIMITED',
    'Ruchi medical private limited',
    'Fujifilm india private limited',
    'Printbindaas private limited',
    'Galaxy saws private limited',
    'Khatau makanji and company private limited',
    'CITIZEN MEDIA PRIVATE LIMITED',
    'GREENKO SOLAR POWER (DHARMAVARAM) LIMITED',
    'Bulli coke limited',
    'Enzo-chem laboratories private limited',
    'Ar-ex laboratories private limited',
    'Usan pharmaceuticals private limited',
    'Abryl formulations private limited',
    'ADRIAAN BIONICS PRIVATE LIMITED',
    'Bellapremier happy hygienecare private limited',
    'Speciality silica private limited',
    'Periar trading companmy private limited',
    'Nataraj oil mills private limited',
    'Mccoy soudal sealants adhesives & foams private limited',
    'Pioneer jellice india private limited',
    '3d industries private limited',
    'Unitech alice projects private limited',
    'Resins and allied chemical industries (bombay) private limited',
    'Shri samarth engineering private limited',
    'Amaze leder chemie private limited',
    'Bharat salt and chemical industries (mundra kutch) limited',
    'Picfare laboratories private limited',
    'SIMALIN CHEMICAL INDUSTRIES PRIVATE LIMITED',
    'Gujarat paraffins pvt ltd',
    'Vallabh pesticides limited',
    'INNOTEX (INDIA) PRIVATE LIMITED',
    'Arc retreading company private limited',
    'Tyresnmore online private limited',
    'GROUP MEERAN PRIVATE LIMITED',
    'FITWEL MOBILITY PRIVATE LIMITED',
    'RADIALS INTERNATIONAL MINING SERVICES PRIVATE LIMITED',
    'Hindustan tradetech private limited',
    'Anil thermoplastics private limited',
    'Shand pipe industry private limited',
    'Ocean healthcare private limited',
    'Nasreen chem private limited',
    'Kanak oxygen pvt ltd',
    'S j rubber industries limited',
    'SUDARSHAN ELASTOMER PRIVATE LIMITED',
    'Ashutosh financial services private limited',
    'ROOP RUBBER MILLS PRIVATE LIMITED',
    'Speedways rubber private limited',
    'Gayatree polymers pvt ltd',
    'Samarth foam private limited',
    'Ag poly packs private limted',
    'Viridis plastics private limited',
    'Ravi plast mold private limited',
    'Reliance formulation pvt ltd',
    'POLYSTYRENE PRODUCERS',
    'S RESEARCH AND PHARMACEUTICALS PRIVATE LIMITED',
    'MAYUR POLY FILMS PRIVATE LIMITED',
    'Polynova industries limited',
    'Wright care drugs private limited',
    'Baidyanath pharma private limited',
    'Drs education private limited',
    'Cfbt education resource management private limited',
    'Aero interiors private limited',
    'Creative virtual private limited',
    'Usha breco education infrastructure limited',
    'Kids campus education private limited',
    'Tenvic sports education private limited',
    'Institute of product leadership private limited',
    'Ecoedu consultants private limited',
    'MWT TECHNOLOGIES PRIVATE LIMITED',
    'Maurya education company private limited',
    'Ask edutrainers private limited',
    'ALCHEMIZE TECHNOLOGIES PRIVATE LIMITED',
    'Zodiac maritime agencies (india) private limited',
    'Kodaikanal international school',
    'Jagdamba service solutions private limited',
    'Royal treatment nail spa & salon private limited',
    'CHANNEL VAS SERVICES INDIA PRIVATE LIMITED',
    'Saint james human resource development services india private limited',
    'Mwt education consultancy private limited',
    'Get ahead education limited',
    'DRS INTERNATIONAL SCHOOL PRIVATE LIMITED',
    'Nms infrastructure private limited',
    'Smart brains academy private limited',
    'Absolute academy private limited',
    'Scholite india private limited',
    'Jetking smartrain academy private limited',
    'Indianoil - adani gas private limited',
    'Cf biomass private limited',
    'Dowac systems and projects india private limited',
    'OCTANE CONTROL & INSTRUMENTATION PRIVATE LIMITED',
    'Dlz power private limited',
    'PRAXIS HOME RETAIL LIMITED',
    'Helene power private limited',
    'Ursa solar projects private limited',
    'Shivalakha Solar Energy Private Limited',
    'Empereal energy & services private limited',
    'Novus energy solutions private limited',
    'Lanco rambara hydro power private limited',
    'Hyranks properties private limited',
    'Saurava towers private limited',
    'AVINASH TWIN CITY PRIVATE LIMITED',
    'Abir buildcon private limited',
    'Rgs buildcon (india) private limited',
    'Soho infrastructure private limited',
    'Kyocera document solutions india private limited',
    'Laxmi highcon private limited',
    'Laureate buildwell private limited',
    'Concept infracon private limited',
    'Khandelwal group private limited',
    'Reynold infra private limited',
    'Dharmadev infrastructure limited',
    'Meehit infra projects private limited',
    'Westbury holdings private limited',
    'Ashrith shelters private limited',
    'I builders and developers private limited',
    'Genesen labs limited',
    'Prerana builders pvt ltd',
    'Rebox estates and investments private limited',
    'Balkrishna developers private limited',
    'Raghukul properties and investments private limited',
    'Offshore infrastructures limited',
    'Hrishikesh developers private limited',
    'Cheerful properties private limited',
    'Oasis infrastructure private limited',
    'Sharan realtors private limited',
    'SUNDESHA ENTERPRISES PRIVATE LIMITED',
    'Taj housing architect limited',
    'BENEFICENT KNOWLEDGE PARKS AND PROPERTIES PRIVATE LIMITED',
    'Basar constructions private limited',
    'Ss307 realty private limited',
    'Amaanah properties india private limited',
    'Green woods constructions private limited',
    'Abhirup properties private limited',
    'LAUREN CONSTRUCTORS PRIVATE LIMITED',
    'Eiffel promoters private limited',
    'Eiffel homes private limited',
    'Eiffel lifespaces private limited',
    'J. d. promoters and builders private limited',
    'Marvel luxury realtors private limited',
    'Sai constro engineering private limited',
    'Coastal constructions india private limited',
    'Indus projects private limited',
    'B b r projects private limited',
    'Vishal shelters private limited',
    'HETERO INFRASTRUCTURE SEZ PRIVATE LIMITED',
    'Aditya construction company india private limited',
    'Aditya housing & infrastructure development corporation private limited',
    'Lanco hoskote highway limited',
    'Prajay land capital private limited',
    'AGRO INDUS CREDITS LIMITED',
    'Jmj nidhi limited',
    'Anchrom finance private limited',
    'Track express limited',
    'Kartikchandra finance bombay private limited',
    'Zya ventures limited',
    'MORGAN LEASING & FINANCE LIMITED',
    'VALUES ALTERNATIVE INVESTMENTS INTERNATIONAL PRIVATE LIMITED',
    'KANAKADURGA FINANCE LIMITED',
    'Steel city financial services private limited',
    'Infin solutions private limited',
    'Shasun leasing and finance pvt ltd',
    'Gar financial services private limited',
    'Hill view hire purchase private limited',
    'Jubilant properties private limited',
    'Target trades pvt. ltd.',
    'Perfect exports(india)pvt ltd',
    'Muthoot homefin (india) limited',
    'APPRECIATE FINCAAP PRIVATE LIMITED',
    'Dytel finance and investments private limited',
    'MSE FINTECH LIMITED',
    'Nissan renault financial services india private limited',
    'RATAN CORPORATION PRIVATE LIMITED',
    'CHINTAMANI COTTON TRADING PRIVATE LIMITED',
    'Ambo credit pvt ltd',
    'Jkb financial services limited.',
    'Privilege power and infrastructure private limited',
    'Msil investments private limited',
    'Roshnara investment and trading company private limited',
    'Shadhak investments and trading private limited',
    'Gainworthy investments private limited',
    'Vaijayanti investment and reality private limited',
    'Sanil sagar holdings private limited',
    'Vis-ram financial services private limited',
    'Acrastyle power (india) limited',
    'Indus city scapes constructions private limited',
    'Crn investments private limited',
    'Sidharth credit & investment (chennai) private limited',
    'Gentleman chit funds company india private limited',
    'Manappuram chits( india )limited',
    'Members chit private limited',
    'Laila finance limited',
    'G j holdings private limited',
    'Ananya finance for inclusive growth private limited',
    'Cincinnati investment and trading company private limited',
    'Iftex investments and properties pvt ltd',
    'THAZHAYIL FINANCE PRIVATE LIMITED',
    'Pearl oil private limited',
    'Man corp limited',
    'Samir investments pvt ltd',
    'NIRANJAN SANKAR ENTERPRISES PRIVATE LIMITED',
    'Dior2 investment private limited',
    'Msaps associates investments private limited',
    'Surae financial services private limited',
    'Bhandari equities private limited',
    'Frr forex private limited',
    'KUBIZ CAPITAL PRIVATE LIMITED',
    'Medico legal insurance consultants private limited',
    'TURTLEMINT INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'Pnb metlife india insurance company limited',
    'Lichfl financial services limited',
    'OCTOPODES CONSULTING PRIVATE LIMITED',
    'Omkara assets reconstruction private limited',
    'Eight capital advisory services private limited',
    'Eight finance private limited',
    'SUVRIDHI CAPITAL MARKETS Private Limited',
    'TRADEWELL FINVEST PRIVATE LIMITED',
    'GUARDWELL SECURITY SERVICES PVT LTD',
    'Zaveri enterprise private limited',
    'Kashmir finance private limited',
    'VIJAYENDRA BROTHERS AGENCY PRIVATE LIMITED',
    'Otn commodities private limited',
    'ANMOL SHARE BROKING PRIVATE LIMITED',
    'Amity securities private limited',
    'Tru trading and investments private limited',
    'Amalgamated business solutions limited',
    'Hiren holdings private limited',
    'Kalpitam investment & finance private limited',
    'Commissariat investments private limited',
    'Goldman sachs (india) finance private limited',
    'Prosperous global financial solutions private limited',
    'RAYS PRIME LOGISTICS PRIVATE LIMITED',
    'Ramraj securities private limited',
    'Fixed income money market and derivatives association of india',
    'Seed advisors private limited',
    'Kamla landmarc property leasing & finance private limited',
    'Arss holdings limited',
    'Jade commodities private limited',
    'Eastern theaters private limited',
    'Raghukul commodities india private limited',
    'Ksk trust private limited',
    'Barik tanners private limited',
    'Ishita advisory services private limited',
    'Aditya realtors ltd',
    'Aarya industrial products private limited',
    'Bawasons holdings private limited',
    'Vfc securities private limited',
    'Granada investments & finance private limited',
    'Nirwan monetary services private limited',
    'PAARYAL FINTECH SERVICES PRIVATE LIMITED',
    'GOLDMAN SACHS ASSET MANAGEMENT (INDIA) PRIVATE LIMITED',
    'Goldman sachs (india) capital markets private limited',
    'Sanjivani business consultants pvt ltd',
    'John mechel technologies private limited',
    'Quantum-link communications private limited',
    'Dfk consulting services (india) private limited',
    'Regal solutions private limited',
    'Yardi prabhu consultants & valuers private limited',
    'Advanced strategies private limited',
    'Century management and professional services private limited',
    'M&G GLOBAL SERVICES PRIVATE LIMITED',
    'Zebra management services private limited',
    'K and y consultants private limited',
    'Goldman sachs (india) securities private limited',
    'StockHolding Document Management Services Limited',
    'Vito india advisors private limited',
    'Quest (east india) advisor private limited',
    'Auctus advisors private limited',
    'Uts consulting services private limited',
    'Leo star impex private limited',
    'IFCONST PRIVATE LIMITED',
    'Genval consulting group private limited',
    'Clarity communications pvt ltd',
    'Organon management services private limited',
    'Subhashini signature services private limited',
    'Kp management & project consultants private limited',
    'Kozy kreative concepts private limited',
    'Asher consultants limited',
    'Iseo systems private limited',
    'Activepoint business consultants private limited',
    'Evergreen management services india private limited',
    'Avv power engineers private limited',
    'Virar merchandise pvt ltd',
    'La exactlly software private limited',
    'SM MUTUAL FUND DISTRIBUTORS PRIVATE LIMITED',
    'Delphi corporate solutions private limited',
    'Optomech engineers pvt ltd',
    'Kk nesar projects private limited',
    'Chourasia interiors private limited',
    'Archgroup international architects private limited',
    'Santura engineering private limited',
    'V2 film and design private limited',
    'MICROSOFT TELECOM (INDIA) PRIVATE LIMITED',
    'One convergence devices private limited',
    'Enmac systems private limited',
    'Tycon automation private limited',
    'Vil limited',
    'Aqua utility designs and management private limited',
    'Nebulous design workshop private limited',
    'Vachan electricals private limited',
    'General machinery and technical services limited',
    'UNIVERSAL MEP PROJECTS & ENGINEERING SERVICES LIMITED',
    'Intercon constructions (india) private limited',
    'Niteen parulekar architects private limited',
    'Kushal technical services private limited',
    'De dietrich process systems india private limited',
    'Indigo architects india private limited',
    'Telesis architects and designers private limited',
    'Vaulter engineering services private limited',
    'Meensham engineering private limited',
    'Hyquip technologies limited',
    'Autoform engineering india private limited',
    'Fichtner consulting engineers (india) private limited',
    'Seven seas engineering company private limited',
    'Manan solutions private limited',
    'VITRUVIA BRAND STUDIO PRIVATE LIMITED',
    'I.m.c.advertising private limited',
    'Mediamate advertising india private limited',
    'Nexus equity advertising pvt ltd',
    'Media star private limited',
    'Hibiscus communications private limited',
    'Bandwagon media private limited',
    'Acumen advertising private limited',
    'MANA ADVERTISING & ENTERTAINMENT LIMITED',
    'Adimage private limited',
    'Purnima advertising agency pvt ltd',
    'Bhagwati communication pvt ltd',
    'Raghav cold storage private limited',
    'Elmec tools and devices pvt ltd',
    'Sunlord apparels manufacturing company private limited',
    'Pragati impex india private limited',
    'Dr. ing. n.k. gupta technical consultants private limited',
    'Sanicon engineers private limited',
    'Gmgr bath fittings private limited',
    'World expenditions (india) private ltd',
    'Mehta print arts private limited',
    'M m eyetech private limited',
    'Casilica d- air private limited',
    'ZECO REALITY DEVELOPERS PRIVATE LIMITED',
    'Jet developers private limited',
    'Nuc soft limited',
    'Ssipl retail limited',
    'Smc capitals limited',
    'Sri krishna housing complex private limited',
    'Knowledge financial consultancy private limited',
    'Integrated overseas private limited',
    'Realgrowth overseas private limited',
    'Radhika lease fin private limited',
    'AKASA FINANCE LIMITED',
    'Singhal capital services limited.',
    'Zeco aircon limited',
    'Brindavan beverages private limited',
    'Weikfield foods private limited',
    'Coca cola india private limited',
    'Supreet business solutions private limited',
    'G m syntex private limited',
    'Shreya texfab private limited',
    'Wazir singh yarns private limited',
    'Peacock tanners private limited',
    'Citi threads (india) private limited',
    'Shaswat textiles private limited',
    'SEVATHAL VENTURES PRIVATE LIMITED',
    'Durairaj mills limited',
    'CHERAN SPINNER Private Limited',
    'Chenduran cotspin (india) private limited',
    'Elkaypee spinners private limited',
    'Leeds spinning mills private limited',
    'Sri saradhambika spintex private limited',
    'Poongodhai textiles private limited',
    'Milltex eco-fibres private limited',
    'Govardhan silk private limited',
    'SAGEAWAY INVEUM PRIVATE LIMITED',
    'Pan-age fashions private limited',
    'ZOOM FABRICS PRIVATE LIMITED',
    'Shanti niketan weave tech private limited',
    'Terranet (india) private limited',
    'Jamnagar woolen textile mills pvt ltd',
    'Saanwaria polyester private limited',
    'Dhanesh fabrics private limited',
    'Responsive sutip limited',
    'Tagon fabrics private limited',
    'AYAAN TRENDDZ PRIVATE LIMITED',
    'Black label fashions private limited',
    'GRG COTSPIN LIMITED',
    'Mix & match textiles private limited',
    'M. a. clothing company private limited',
    'T.c. terrytex limited',
    'Prag jyoti textile park private limited',
    'Avgol india private limited',
    'Aaa washers & dyers private limited',
    'Dg luxury lifestyle private limited',
    'Dreamland creations private limited',
    'Shilpa global pvt. ltd',
    'LEELAP CLOTHING PRIVATE LIMITED',
    'NAKSHATRA CREATIONS PRIVATE LIMITED',
    'Able boss brands retail private limited',
    'Tulip creations private limited',
    'Raunika fashions private limited',
    'Sona vana textiles private limited',
    'R.k. fabrics (india) private limited',
    'Hanesbrands apparel india private limited',
    'Fossil india private limited',
    'Rohini creations private limited',
    'B t mills private limited',
    'Response fabrics (india) private limited',
    'Jeeva accessories and apparels private limited',
    'Vesta apparels private limited',
    'Rama crafts private limited',
    'STORE SOFT SOLUTION PRIVATE LIMITED',
    'Anbu apparels india private limited',
    'Saratoga tex private limited',
    'M.s.r garments private limited',
    'Sreeja hosieries private limited',
    'Amba tex global private limited',
    'May apparels pvt. ltd.',
    'Dreamland cottons private limited',
    'Mangla apparels india private limited',
    'LILYMINT CLOTHING PRIVATE LIMITED',
    'Kushal uniform private limited',
    'Blessings clothing private limited',
    'Stanfab apparels private limited',
    'Nl clothing company private limited',
    'FEMIGO VENTURES PRIVATE LIMITED',
    'Kd industries private limited',
    'Pnr apparels private limited',
    'Jeaneration clothing private limited',
    'Kodai nuts private limited',
    'Mega win leather (india) private limited',
    'Sara suole private limited',
    'Nibras tannery private limited',
    'Gaitonde leathers and accessories private limited',
    'K h exports india private limited',
    'Baer shoes (india) private limited',
    'Davinci leather private limited',
    'Paragon footwears private limited',
    'Slipons india private limited',
    'Veekesy footcare (india) private limited',
    'KINGSWOOD INDUSTRIES PRIVATE LIMITED',
    'Sil boards (india) private limited',
    'Plamadera composite private limited',
    'Sri venkateshwara fibre udyog private limited',
    'Spectrum fibrecom private limited',
    'San wud shoppe private limited',
    'THAMARAPPALLY BROTHERS VENEERS AND PANELS PRIVATE LIMITED',
    'Yamir packaging private limited',
    'CPS CASH PROCESSING SOLUTIONS PRIVATE LIMITED',
    'Avdhoot redefine papers private limited',
    'Samkipack systems private limited',
    'Kagalwala packaging private limited',
    'Prag bosimi packaging private limited',
    'Star boxes india private limited',
    'Chetan papers private limited',
    'Raavi infracity private limited',
    'Gal developers and realtors private limited',
    'Synergyone iconcity private limited',
    'Bridgeview developers private limited',
    'Redwoods buildtech private limited',
    'Adishesh infraestates private limited',
    'Goldenpalm infracity private limited',
    'Lotus urban spaces private limited',
    'Zenith landmarks private limited',
    'Ganpati ingots private limited',
    'SRK INFRA PROJECTS PRIVATE LIMITED',
    'Bina puri infrastructure private limited',
    'Koncept nirmaan private limited',
    'Colonial constructions private limited',
    'Pbsamp projects private limited',
    'Galacon infrastructure and projects private limited',
    'Silpa infratech limited',
    'Drs infratech private limited',
    'Silpa mega projects private limited',
    'Phoenix spaces (guntur) private limited',
    'Ananya infra projects private limited',
    'JEEVAN PIVOTAL INFRA PROJECTS PRIVATE LIMITED',
    'Repute builders private limited',
    'S n damani infra private limited',
    'STEPSSTONE ENGINEERS & CONTRACTORS PRIVATE LIMITED',
    'Torrent properties private limited',
    'Mani ratnam flat owners association',
    'Elite projects private limited',
    'Fantasy buildwell private limited',
    'S e developers private limited',
    'Today hotels private limited',
    'NEXT GENERATION PROJECTS PRIVATE LIMITED',
    'Raheja builders private limited',
    'Rapid buildwell limited',
    'Om shivam buildtech private limited',
    'Unitech hi-tech developers limited',
    'Rising sun foods pvt ltd',
    'Aalok infrastructure private limited',
    'Ozone india limited',
    'Maxroth realty private limited',
    'Kiri infrastructure private limited',
    'Vista infracon private limited',
    'Pcl infracon private limited',
    'Millennium city multi ventures private limited',
    'Ashed properties and investments private limited',
    'Sri sivapriya shelters private limited',
    'Vascon construction private limited',
    'Pvk shelters (india) private limited',
    'Shrivision homes private limited',
    'Madhusiri geoinformatics & survey private limited',
    'Natasha homes private limited',
    'Malabar marina projects (india) private limited',
    'Malabar highview builders private limited',
    'Nasher properties private limited',
    'Kala darshan properties private limited',
    'Elan realtors india private limited',
    'Cello infrastructure limited',
    'DAVINIA INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED',
    'R. k. constro projects (south) private limited',
    'Sunshine realcon private limited',
    'Acn developers private limited',
    'Laxmi hericon private limited',
    'Gendi real estate private limited',
    'Lakecity infraprojects private limited',
    'Klm infraproject private limited',
    'Harmony avakash homes private limited',
    'Man & soil builders private limited',
    'Haaciendaa infotech & realtors private limited',
    'Chettinad realtors private limited',
    'Subasri realty private limited',
    'Real value infrastructure limited',
    'Great industrial constructions private limited',
    'Vetrivel housing promoter private limited',
    'Caparo india limited',
    'Othello projects private limited',
    'Shree yogeshwar infrastructure private limited',
    'Rooftech enterprises private limited',
    'Sepcon systems private limited',
    'Alpha holdings and infrastructures private limited',
    'Raja angsana construction private limited',
    'Raja symphonye housing private limited',
    'Metrik infraprojects private limited',
    'Fort-in infra developers private limited',
    'Astoria builders pvt ltd',
    'Sonbar developers and investments p ltd',
    'Forte aqsa developers private limited',
    'Ventures india corporation private limited',
    'SUNSET SPACES PRIVATE LIMITED',
    'VJTF INFRASCHOOL SERVICES (MUMBAI) PRIVATE LIMITED',
    'Panache developers private limited',
    'Eagle infra india limited',
    'Shiv-dhruv builders private limited',
    'Shivam earth movers pvt ltd',
    'Chougule hosmani developers private limited',
    'LOGLABS VENTURES PRIVATE LIMITED',
    'P j project engineers private limited',
    'Nhava sheva international container terminal private limited',
    'Dk infrastructure private limited',
    'Vindhyavasini megastructures limited',
    'Hk toll road private limited',
    'Aspher foods private limited',
    'FINCLUSION SOLUTIONS PRIVATE LIMITED',
    'Lichfl trustee company private limited',
    'Jaisingh finance private limited',
    'Capital mantra advisors private limited',
    'Wilgro financial services private limited',
    'ST.ALOYSIUS NIDHI LIMITED',
    'Xperitus insurance brokers private limited',
    'JIO INSURANCE BROKING LIMITED',
    'Faith financials private limited',
    'Okamura homes private limited',
    'Geoworks projects private limited',
    'Bakeri urban development private limited',
    'Ompee group private limited',
    'NEXUSMALLS WHITEFIELD PRIVATE LIMITED',
    'Autus developers private limited',
    'KATERRA INDIA PRIVATE LIMITED',
    'Sonnet builders and developers private limited',
    'Seaside properties pvt ltd',
    'Asuda properties pvt ltd',
    'Silvex developers private limited',
    'Disha land developers private limited',
    'Barmer real estate private limited',
    'Kireeta reality and finance private limited',
    'Beaming infradevelopers private limited',
    'Ivg infratech private limited',
    'Vruksha enterprises private limited',
    'Probro real estate ventures private limited',
    'Kushal infraproperty private limited',
    'Energetic construction private limited',
    'Attractive construction pvt ltd',
    'B g housing private limited',
    'Elegance malls limited',
    'Aravali realtors private limited',
    'Jumera promoters and developers private limited',
    'Elite realbuild private limited',
    'Hare krishna creative realty private limited',
    'Infinity industrial park private limited',
    'Silverline contractors private limited',
    'Ranch realtors private limited',
    'Reenaz properties private limited',
    'Shehab properties private limited',
    'Juhu real estate developers private limited',
    'Nilkamal builders private limited',
    'Arpanna developments private limited',
    'Basudeo builders private limited',
    'Mirah realtors private limited',
    'Jamnagar properties private limited',
    'Matheran realty pvt ltd',
    'Shubh landmark realty private limited',
    'The neo nest realty private limited',
    'WESTFIELD HYGIENE PRIVATE LIMITED',
    'Shringar properties private limited',
    'Green buildestate private limited',
    'Repute infotech & enterprises limited',
    'Kothari real estates private limited',
    'C j g holdings india private limited',
    'Giriraj estates pvt ltd',
    'Dalmia devcon private limited',
    'Ridhi sidhi niketan pvt ltd',
    'DALGREEN FOODS PRIVATE LIMITED',
    'FRESH AISLE RETAILS PRIVATE LIMITED',
    'Saswat developer private limited',
    'M.B.M.R REAL ESTATE PRIVATE LIMITED',
    'Nsp variegate rg road projects private limited',
    'Nsp variegate pp road projects private limited',
    'Infinium realty private limited',
    'Purvanchal projects private limited',
    'Ml buildtech private limited',
    'Nobal buildtech private limited',
    'Hsn realty services india private limited',
    'Prestige garden estates private limited',
    'Rare earth developers private limited',
    'Divyasree tarbus builders private limited',
    'Jaya shanmuga infra projects private limited',
    'Athamus venture management private limited',
    'Freenaz properties private limited',
    'Green leaf builders and developers (india) private limited',
    'Symbiosis properties and infrastructures india private limited',
    'Whitemount property developers private limited',
    'HAPPY AND RUBY BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'Deep mangal developers pvt ltd',
    'Aurosagar estates private limited',
    'Matrix land hub private limited',
    'Black forest realties private limited',
    'Dhanmata realty private limited',
    'Agrodhan developers private limited',
    'Aero developers private limited',
    'Aero realty private limited',
    'Brookfield townships private limited',
    'Fwpl properties private limited',
    'Best shelters private limited',
    'Ski properties private limited',
    'Sri krishna ventures private limited',
    'Ghr estates private limited',
    'Radison estates private limited',
    'HAMMER & MOLD INFRASTRUCTURE PRIVATE LIMITED',
    'Spaacio developers private limited',
    'INDIA LAND REALTY PRIVATE LIMITED',
    'Kasu assets development private limited',
    'Mountview realtech private limited',
    'Uppal projects private limited',
    'ARTERIORS BUILD INDIA PRIVATE LIMITED',
    'Maretek (india) private limited',
    'AWARD PACKAGING PRIVATE LIMITED',
    'Addon holdings private limited',
    'Framework consultants private limited',
    'Asset vantage systems private limited',
    'Avk automart private limited',
    'Matix services limited',
    'Mod age consultants & advisory services private limited',
    'Icmq certification india private limited',
    'Belleza enterprises private limited',
    'Sila solutions private limited',
    'S HOSPITAL LIMITED',
    'PACCS HEALTHCARE PRIVATE LIMITED',
    'Country vacations international limited',
    'Symchem research labs private limited',
    'Biognosys technologies (india) private limited',
    'Rohini holistic health centre private limited',
    'SARAVANA MULTI SPECIALITY HOSPITAL PRIVATE LIMITED',
    'Jansons mri diagnostic private limited',
    'S.g. meditech pvt.ltd.',
    'Doctorslab medical services private limited',
    'Biotavia labs private limited',
    'Geospatial delhi limited',
    'Shambhavi samarpan foundation',
    'Chembur golf welfare foundation',
    'Kalpataru life care private limited',
    'Radiological precision labs (india) private limited',
    'Wash for india foundation',
    'Justdispose recycling private limited',
    'Plastic bag manufacturers association of india',
    'Indo usa travel association',
    'Financial intermediaries association of india',
    'The printing materials and ink dealers association',
    'Gia india',
    'CULVER MAX ENTERTAINMENT PRIVATE LIMITED',
    'Ideas box entertainment limited',
    'A m pictures private limited',
    'Cindia theatres private limited',
    'Fastway combined cable network private limited',
    'Cinematica digitals private limited',
    'Ocean arts and mercantile private limited',
    'Jai hind entertainment private limited',
    'Prasad film laboratories pvt ltd',
    'Home theater store (india) private limited',
    'Indian independent filmmakers worldwide association',
    'Hathway mcn private limited',
    'South asia fm limited',
    'Popcorn entertainment private limited',
    'Epicenter entertainment private limited',
    'Heritage productions private limited',
    'Shreya broadcasting private limited',
    'APCOMART PRIVATE LIMITED',
    'Banyan tree events india private limited',
    'Cinimage studios private limited',
    'Pio printers private limited',
    'Lark leisure private limited',
    'Kalhaar blues and greens golf club private limited',
    'KIDS ARENA SPORTS & ACTIVITIES INDIA PRIVATE LIMITED',
    'Color sports india private limited',
    'Krishnamani holdings pvt. ltd.',
    'Swapna srushti international club private limited',
    'Swordfish events & entertainment private limited',
    'Chennai rhinos private limited',
    'Kulcha club restaurants private limited',
    'Twenty two alliance entertainers private limited',
    'Manomay motion pictures private limited',
    'Sss services private limited',
    'Westcomb commodity private limited',
    'MICRO INSTRUMENTS PRIVATE LIMITED',
    'Interroll india private limited',
    'Shri ks farmimplements private limited',
    'Rajasthan machinery mart pvt ltd',
    'Anoop forgings private limited',
    'Kishan autoparts private limited',
    'Inline control and equipment private limited',
    'Gauranga systems private limited',
    'Tanuj hydraulics private limited',
    'Harsha exito engineering private limited',
    'Aeolus aero tech private limited',
    'Saico cranes private limited',
    'Gemini valves and pumps private limited',
    'Deep earthmovers private limited',
    'Renovus vision automation private limited',
    'GAUTAM INFRASTRUCTURE & CONSTRUCTION EQUIPMENTS PRIVATE LIMITED',
    'Commercial infrastructure equipments private limited',
    'LEVIAT INDIA PRIVATE LIMITED',
    'Economode food equipment (india) private limited',
    'Vedula engineering private limited',
    'Shree resource acquisition and management private limited',
    'British tool house private limited',
    'Sujan precision components private limited',
    'UNI TRITECH PRIVATE LIMITED',
    'Acute instruments private limited',
    'Foreview engineering and technology private limited',
    'TOSHIO PRIVATE LIMITED',
    'E & s food technologies private limited',
    'Parvanda graphics private limited',
    'Carver technology & equipment private limited',
    'Valvinox s.r.l. india private limited',
    'Becquerel industries private limited',
    'Flextools precision engineering private limited',
    'Idc engineering india private limited',
    'Tecchno qualicon solutions private limited',
    'Shivani scientific industries pvt ltd',
    'Maxcess india automation private limited',
    'GREENPACK TECHNOLOGIES PRIVATE LIMITED',
    'Accura pharmaquip private limited',
    'Ricetec machinery private limited',
    'Nisan scientific process equipments pvt ltd',
    'Shashi charu hydraulics private limited',
    'Rapid pack engineering private limited',
    'Elina solutions private limited',
    'VITESCO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VALMET TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'Thiraviam engineering private limited',
    'W-lifestyle india private limited',
    'Toyota forms india private limited',
    'Curtiss wright surface technologies india private limited',
    'Tankaria industries private limited',
    'Shitaldhara engineering private limited',
    'Rossmann india galvano technology private limited',
    'Tvs global trade private limited',
    'Focaal automation private limited',
    'Living waterefine technologies private limited',
    'Inter roofs electronic systems private limited',
    'Proximon controls private limited',
    'Genesis infoserve private limited',
    'Maxima automation solutions private limited',
    'Qburst technologies private limited',
    'EVOLUTE FINTECH INNOVATIONS PRIVATE LIMITED',
    'Semyung india enterprises private limited',
    'Systems manufacturing private limited',
    'N.j.dataprint (bangalore)private limited',
    'Sienna ecad technologies private limited',
    'Inmac computers private limited',
    'Aarkay technoconsultants private limited',
    'Kores printer technology private limited.',
    'Htp global technologies private limited',
    'Pats computer technologies private limited',
    'SOLAR COMPACT PRIVATE LIMITED',
    'Sarjen systems private limited',
    'Leepra technologies private limited',
    'Avesta computers private limited',
    'Indorigin electric limited',
    'Rai industrial power private limited',
    'United electrotex private limited',
    'Star energy limited',
    'Line tek electronics (india) private limited',
    'Portescap india private limited',
    'Pioneer instruments private limited',
    'Sagar springs pvt ltd',
    'Komal leolite private limited',
    'Axis electrical components (india) private limited',
    'SOLIDUS HI-TECH PRODUCT PRIVATE LIMITED',
    'Ovi engineers private limited',
    'Energe electricals private limited',
    'Sneha insulation private limited',
    'Mohta electricals private limited',
    'Farcom cable systems private limited',
    'J.m. lube chemicals private limited',
    'Umang business ventures private limited',
    'Ferrari eastern fans india private limited',
    'COSMOS INDUSTRIAL SYSTEMS PRIVATE LIMITED',
    'Base terminal limited',
    'Royal power turnkey implements private limited',
    'Miele india private limited',
    'DALMIABIZ RETAIL PRIVATE LIMITED',
    'Vivo greentech solutions private limited',
    'Clues network private limited',
    'Fortune frontiers retail private limited',
    'Malabar equipments and general traders private limited',
    'TATTVIKA VENTURES PRIVATE LIMITED',
    'Dart global logistics private limited',
    'Indigo business services (india) private limited',
    'PEREIRA',
    'S FRESH FARMS PRIVATE LIMITED',
    'Ava metalics private limited',
    'Siriadhvaitha agri solutions private limited',
    'KUTE SONS DAIRYS LIMITED',
    'Pabanas agrotech private limited',
    'Indus coir private limited',
    'Megamart agro private limited',
    'Samarth plantations private limited',
    'Malnad organics private limited',
    'DOORS & MORE WOOD PRODUCTS LIMITED',
    'J r packages private limited',
    'Benchem(india)private limited',
    'Navaras food products pvt ltd',
    'Gujarat park hotels limited',
    'Dsf aquatech pvt ltd',
    'Nalapad pipes and machineries private limited',
    'Aec offshore trading private limited',
    'Bayer pharmaceuticals private limited',
    'Metro property management services (bangalore) private limited',
    'Mincore resources private limited',
    'CREDO ADVANCED CHEMICALS LIMITED',
    'Vsm projects private limited',
    'Eagle offshore company private limited',
    'MAN SS LIMITED',
    'Matix projects private limited',
    'Khandagiri resources private limited',
    'Richter-india private limited',
    'Oceanic sands private limited',
    'Gracious building services and materials private limited',
    'Kushalbagh marbles private limited',
    'Shiva shankar minerals private limited',
    'Nbr mines and minerals private limited',
    'Minepro minerals private limited',
    'Kanaak natural resources private limited',
    'MINERAL ENTERPRISES PRIVATE LIMITED',
    'Harold industries private limited',
    'Express bakers india private limited',
    'PURULIA & KHARAGPUR TRANSMISSION COMPANY LIMITED',
    'Pokaran solaire energy private limited',
    'Nsl wind power company (kayathar) private limited',
    'KANDANELLY INDUSTRIES PRIVATE LIMITED',
    'Green infra corporate solar limited',
    'Nrss xxix transmission limited',
    'Solairedirect energy india private limited',
    'Sunbrio energy private limited',
    'Nsl wind power company (chilarwadi) private limited',
    'Asian global infra private limited',
    'Green infra solar projects limited',
    'Leoes energy solutions private limited',
    'Saskang rong energy private limited',
    'Nagarjuna hydro energy private limited',
    'Paschim hydro energy private limited',
    'APT POWER ENGINEERING PRIVATE LIMITED',
    'Gayatri energy ventures private limited',
    'Bidar solar power private limited',
    'Nsl wind power company (sayamalai) private limited',
    'Shahuwadi wind energy private limited',
    'Jath wind energy private limited',
    'Sk renewables private limited',
    'Visalam energy private limited',
    'Sakthimurugan wind farms private limited',
    'VYOM SPACE EXPLORATION AND SERVICES PRIVATE LIMITED',
    'KYARIMAN TRANS SYSTEM PRIVATE LIMITED',
    'Radon energy limited',
    'Solarfield energy private limited',
    'Solarfield energy two private limited',
    'Kvk-eci hydro energy private limited',
    'Nsl wind power company (virli) private limited',
    'Aqua specialities private limited',
    'Water today private limited',
    'Welcome apartments private limited',
    'Emmanuel resorts private limited',
    'Sakku properties private limited',
    'Shyamlee infraventures private limited',
    'Bestcity developers (india) private limited',
    'Best realtech (india) private limited',
    'Vipul southern infracon limited.',
    'Apex residency private limited',
    'Ornate residency private limited',
    'Regalia properties private limited',
    'Zest towers private limited',
    'Tudor estates private limited',
    'Baroque developers private limited',
    'Verve homes private limited',
    'Vie properties private limited',
    'Epitome developers private limited',
    'Best realbuild (india) private limited',
    'Sucg infrastructure india private limited',
    'Apace homes private limited',
    'Neelkanth infrastructure limited',
    'Dss buildtech private limited',
    'Bradvip industrial marketings private limited',
    'S&g metal building solutions (india) private limited',
    'ESSPEE INFRASTRUCTURE & TELENETWORKING (INDIA) PRIVATE LIMITED',
    'Poothotta builders and properties private limited',
    'Natasha abode private limited',
    'Brahmamangalam builders and properties private limited',
    'Vaikom builders and properties private limited',
    'Osko builders india private limited',
    'Kite developers private limited',
    'Alufib interiors private limited',
    'Dadbhwala architicts engnieers and valuers private limited',
    'KCK DENTAL PRIVATE LIMITED',
    'Sunjay technologies private limited',
    'Beeline impex private limited',
    'Midas eastern machine tools private limited',
    'Stuvamac india private limited',
    'Fmax systems india private limited',
    'Samson agro tools private limited',
    'JP UDYOG PRIVATE LIMITED',
    'Dcs techno services private limited',
    'Aarson industries private limited',
    'Vishal technomation private limited',
    'Niehoff of india private limited',
    'MANOJKRISHNA ENGINEERING WORKS PRIVATE LIMITED',
    'Smart keytouch india private limited',
    'Lotus instruments solutions private limited',
    'Recon dies and tools pvt ltd',
    'ASKA EQUIPMENTS PRIVATE LIMITED (TRANSFERED FROM MAHARASHTRA)',
    'HAMON COOLING SYSTEMS PRIVATE LIMITED',
    'Smk turnkey solutions private limited',
    'Paras healds and reeds private limited',
    'Absorption aircon engineers private limited',
    'E2P MAGNUS GLOBAL TECH PRIVATE LIMITED',
    'Aquarius engineers private limited',
    'Krishna shyam earthmoovers private limited',
    'Chaitanya hi-tech engineering company private limited',
    'Apollo carmix equipments private limited',
    'LINCE SOFT SOLUTIONS PRIVATE LIMITED',
    'Laxmi en-fab private limited',
    'Caf india private limited',
    'SAVIR LOGISTICS PRIVATE LIMITED',
    'Frore reftek private limited',
    'Blue mount appliances private limited',
    'Jbm kanemitsu pulleys private limited',
    'Deepa solar systems private limited',
    'Rensar aviation n technologies private limited',
    'Spectrum controls private limited',
    'FORWARD ALLOYS & CASTINGS LIMITED',
    'Hexacarb engineers private limited',
    'Omt sliding bearings private limited',
    'Shin thermo epc private limited',
    'Macpro automation private limited',
    'Sushma industries private limited',
    'Digicon automation private limited',
    'Kaizeners techno private limited',
    'Mansha vacuum equipments private limited',
    'PANGLOBAL MACHINERIES PRIVATE LIMITED',
    'Tempo instruments private limited',
    'Centec rrr systems and sensors private limited',
    'Endo kogyo india private limited',
    'Pragati flowtech private limited',
    'White fire equipments private limited',
    'EDICON MINING EQUIPMENT PRIVATE LIMITED',
    'Pragyawan technologies private limited',
    'Hitech enviro engineers & consultants private limited',
    'Afeef aluminium technology private limited',
    'Snowbell machines private limited',
    'Therelek engineers private limited',
    'Makino india private limited',
    'Kewal engineering private limited',
    'Dr. fritsch machines and powders private limited',
    'Valco melton engineering india private limited',
    'Elementz engineers guild private limited',
    'Guardwel industries private limited',
    'Solpower india private limited',
    'Rucha engineers private limited',
    'Maps engineering contractors private limited',
    'Prashtech engineers private limited',
    'Indaai technologies private limited',
    'Ecosustain technologies private limited',
    'Allmoto technologies private limited',
    'Naik electro- man systems private limited',
    'Bls power solution limited',
    'Sirius engineering private limited',
    'Cfm schiller india engineering private limited',
    'Tlt engineering india pvt ltd',
    'Linkwell electronics private limited',
    'Swaminathan enterprises private limited',
    'Vcom technologies private limited',
    'Zuppa hospitality private limited',
    'More & kanade hotels & constructions private limited',
    'Rhizome hospitality solutions private limited',
    'Ideal hospitality private limited',
    'Rajpalace inn private limited',
    'Suncity suites private limited',
    'Vedang hotels private limited',
    'Shree udai regency private limited',
    'Id hotels private limited',
    'Nayagara hotels private limited',
    'Kgeyes hospitality private limited',
    'Hanu reddy hotels and resorts private limited',
    'Wak homes & fashions private limited',
    'KEMIN CBR PRIVATE LIMITED',
    'Traditions hospitality private limited',
    'Shipra hotels limited',
    'Kolaghat resort pvt ltd',
    'Sree sankara ayurvedic resorts private limited',
    'Malibu towne country club private limited',
    'Satvik kitchen art private limited',
    'Dosa express india private limited',
    'Tattva hospitality private limited',
    'Uptown restaurants private limited',
    'Icb hotels private limited',
    'Host inn private limited',
    'Allies logistics private limited',
    'Ksb train cargo carriers private limited',
    'Apogee logistics (india) private limited',
    'Associated container line private limited',
    'Dahnay logistics private limited',
    'VICTORE SHIPS PRIVATE LIMITED',
    'SANTOSH GILL EARTH MOVERS PRIVATE LIMITED',
    'Keolis hyderabad mass rapid transit system private limited',
    'Sea-sky marine private limited',
    'Park aeronautics private limited',
    'GATI EXPRESS & SUPPLY CHAIN PRIVATE LIMITED',
    'Raven logistics private limited',
    'Eco logistics solutions private limited',
    'Jtb india private limited',
    'Kesari vacations private limited',
    '2 x 2 logistics private limited',
    'Epic global services private limited',
    'S.s.cargo & logistics private limited',
    'Associated foreshore pipe lines private limited',
    'Aardour worldwide logistics private limited',
    'Unilog transporting company private limited',
    'Dolly freight consultants pvt ltd',
    'SHREEJI TRANSLOGISTICS LIMITED',
    'Ajay logistics private limited',
    'Wsa angel lines private limited',
    'Haldia coast cargo logistics private limited',
    'Cargo catalysts private limited',
    'Sovereign shipping private limited',
    'Trinity world holidays private limited',
    'Wings logistics private limited',
    'Seatech shipping & projects (i) private limited',
    'Afford air-express private limited',
    'Pn pacific network logistics private limited',
    'Airbiz offshore private limited',
    'Desire cargo india private limited',
    'ELMAC AGRO ',
    'PRIVATE LIMITED',
    'Seven square warehousing private limited',
    'Fast track logistics (india) private limited',
    'Sical sattva rail terminal private limited',
    'Starwoods shipping (india) private limited',
    'Kc maritime (india) limited',
    'Pegasus maritime (india) pvt ltd',
    'Marnavi shipping management private limited',
    'Max maritime private limited',
    'Results marine private limited',
    'Cochin international airport limited',
    'Travel cruise india private limited',
    'Divine voyages private limited',
    'NEUTRAL NVOCC PRIVATE LIMITED',
    'Ineedtrip travels private limited',
    'Flora holidays private limited',
    'Mountain movers trainers private limited',
    'Travelsky voyages private limited',
    'NIRVANA NOMADS PRIVATE LIMITED',
    'Beatrix vacations private limited',
    'Airsonic travels private limited',
    'Kesari tours private limited',
    'Trust holidays india private limited',
    'Lotus-aero enterprises private limited',
    'Iscra india tour operator private limited',
    'Tulip holidays private limited',
    'Shree translink (india) private limited',
    'Wave travels (india) private limited',
    'Serangoon air travel private limited',
    'Iq supply chain services opc private limited',
    'Flyway dubai tours private limited',
    'Adani agri logistics limited',
    'Paulabrao agencies pvt ltd',
    'Killick shipping services ltd',
    'Chakreshwari shipping agency private limited',
    'KAINAAZ ASSOCIATES CARGO MOVERS PRIVATE LIMITED',
    'Sagar shipping agencies (india) private limited',
    'Ausy technologies india private limited',
    'Callystro infotech private limited',
    'Noesys software private limited',
    'Antarjaal innovations private limited',
    'Yasco solutions private limited',
    'Cicadosoft technologies private limited',
    'Rural tecpark (india) private limited',
    'Emvigo technologies private limited',
    'Forecom infratech systems private limited',
    'Media house india private limited',
    'Mathenson records management private limited',
    'GRACEWORKS REALTY & LEISURE PRIVATE LIMITED',
    'S naidu online private limited',
    'Storm soft technologies private limited',
    'Knowledge architects web (india) private limited',
    'Technology horizons (india) private limited',
    'E-emphasys infotech private limited',
    'Centrafest technologies (mumbai) private limited',
    'Anmsoft technologies private limited',
    'ROUTE MOBILE LIMITED',
    'Novaserra technologies private limited',
    'Xl dynamics india private limited',
    'Oregono technologies private limited',
    'Indus cartel private limited',
    'Glocal infomart private limited',
    'WEIZMANN DIGITAL LIMITED',
    'Nis it solutions (india) private limited',
    'BRISK TECHNOVISION LIMITED',
    'Global one technologies private limited',
    'Sage software solutions private limited',
    'Smartlink broadband services private limited',
    'Street light software private limited',
    'Mediit health solutions (india) private limited',
    'THINGBITS ELECTRONICS PRIVATE LIMITED',
    'Jvx media services private limited',
    'Hercules infotech private limited',
    'Bizmaxim it solutions private limited',
    'OCCUPATIONAL THERAPY SUPPLIES PRIVATE LIMITED',
    'AR EMPORIUM PRIVATE LIMITED',
    'Spine software systems private limited',
    'Edreamz technologies private limited',
    'Kraftic mobile solutions private limited',
    'Joy web services private limited',
    'Metadesign software services private limited',
    'Nustech private limited',
    'Truelytics ecomm private limited',
    'Cludobits it solutions private limited',
    'Predusk technology private limited',
    'Techtuners software services private limited',
    'Etek it solutions private limited',
    'Zack it solutions private limited',
    'Krinfos web technologies private limited',
    'A3 it solutions private limited',
    'NEKTRIX SOFTWARE INDIA PRIVATE LIMITED',
    'Karvy insurance repository limited',
    'Symbiotic infotech private limited',
    'Blaze web services private limited',
    'Augurtron systems & solutions private limited',
    'Ticking minds technology solutions private limited',
    'Hubino technologies private limited',
    'Automated test system technologies private limited',
    'Digital chakra information technology private limited',
    'Equate systems india private limited',
    'Northern lights technology development (chennai) private limited',
    'Bridge technologies private limited',
    'Convergent technology solutions private limited',
    'Wonderwrks it services private limited',
    'Bikada forms pvt. ltd.',
    'SHANTA SYNERGIES INDIA PRIVATE LIMITED',
    'Digiqom solution pvt ltd',
    'Wildcard techno services private limited',
    'Acumen research & consulting private limited',
    'Bangalore biotech labs private limited',
    'Aryah software solutions private limited',
    'TURBOTECH INNOVATION PRIVATE LIMITED',
    'Amagi media labs private limited',
    'Clinprax research private limited',
    'BHAMI',
    'GIPRO SYSTEMS PRIVATE LIMITED',
    'Livserv technologies private limited',
    'Rajlaxmi pvt ltd',
    'National aromatics and petrochemicals corporation limited',
    'Goa minerals private limited',
    'Sharp foundry india limited',
    'Nilgiris chemical stoneware company private limited',
    'Micromatic manufacturing systems private limited',
    'Mittal minerals private limited',
    'Plant remedies private limited',
    'Gufic chem private limited',
    'S.B. GRANITES LIMITED',
    'PRICOL RETREATS LIMITED',
    'PPL ENTERPRISES PRIVATE LIMITED',
    'Ligna parquet industries private limited',
    'Jhilmil agriculture private limited',
    'Moonlight horticulture private limited',
    'Arrowline horticulture private limited',
    'Vibha blastings private limited',
    'Moonlight agriculture private limited',
    'Krishna stones private limited',
    'Gadadhara agro private limited',
    'Garib nawaz hotels private limited',
    'CHEMICAL AND MINERAL INDUSTRIES PVT LTD',
    'Saboo energy and power private limited',
    'Aathish minerals private limited',
    'Mersen india private limited',
    'Theobroma foods private limited',
    'N k agro exports (india) private limited',
    'VRB CONSUMER PRODUCTS PRIVATE LIMITED',
    'Viand agro foods private limited',
    'Inspired foods private limited',
    'Theobroma speciality foods private limited',
    'Taiyo feed mill private limited',
    'Laxmi natural products private limited',
    'Kash foods private limited',
    'Pagro frozen foods private limited',
    'Siva ram yarns private limited',
    'ECOGREEN CLEANTECH PRIVATE LIMITED',
    'Saurabh agrotech private limited',
    'K.l.f. nirmal industries private limited',
    'Kishanpura poultry farms private limited',
    'Anshul impex private limited',
    'GRAVISS HOTELS & RESORTS LIMITED',
    'Anjana milk products private limited',
    'Allflex india private limited',
    'Kutwal foods private limited',
    'Gavya Milk Specialities Private Limited',
    'Advance agrisearch limited',
    'TSUBAKI CONVEYOR SYSTEMS INDIA PRIVATE LIMITED',
    'DEMECH POWER & ENGINEERING SERVICES PRIVATE LIMITED',
    'Dotcad private limited',
    'Cosmos media products private limited',
    'Harjas logic systems private limited',
    'Green enerzon private limited',
    'Powerica limited',
    'Umw industries limited',
    'Gannon dunkerley holdings private limited',
    'Global sales private limited',
    'Physique india private limited',
    'Amphetronix offset interconnect solutions private limited',
    'Ray electric india private limited',
    'Vera troniks systems private limited',
    'Arun luminiares pvt ltd',
    'L. t. elevator private limited',
    'R. f. engineers private limited',
    'Solas fire safety equipment private limited',
    'Steel tech cort solution private limited',
    'Integrated geo instruments and services pvt ltd',
    'Efco maschinenbau india private limited',
    'Bee jai realty private limited',
    'SMITA CONDUCTORS Private Limited',
    'LIFESIGN HEALTHCARE PRIVATE LIMITED',
    'Bhotika trade and services private limited',
    'U k b electronics private limited',
    'L k electronics private limited',
    'S.a.p. automations (india) private limited',
    'Volks electronics private limited',
    'The motwane manufacturing company private limited',
    'Alice electronics pvt ltd',
    'VIBRANT ELECTRONICS Private Limited',
    'CRYOGENIC OGS PRIVATE LIMITED',
    'Mass-tech controls private limited',
    'Innovative secure technologies private limited',
    'Alpha imager private limited',
    'Creative web designers india private limited',
    'Aasha levin lighting systems private limited',
    'PALUCK TECHNOLOGIES LIMITED',
    'Asi test lab private limited',
    'Ador digatron private limited',
    'Elak pvt ltd',
    'Cardiolabs healthcare india private limited',
    'Accuray medical equipment (india) private limited',
    'Shanti enterprises electricals private limited',
    'Squarem systems private limited',
    'Eco-care instruments private limited',
    'Med-el india private limited',
    'Motiff laboratories private limited',
    'KPI HEALTHCARE INDIA PRIVATE LIMITED',
    'Meco instruments private limited',
    'Kulkarni instruments private limited',
    'Shivalik solid waste management limited',
    'Eclipse global private limited',
    'Laxmi electronics moulds and precision engineering private limited',
    'Mvl consulting private limited',
    'Nutel innovations private limited',
    'Megi control systems private limited',
    'Suchitra electronic components private limited',
    'MODI UDYOG PRIVATE LIMITED',
    'Sainik mining and allied services limited',
    'Mahindra stiller auto trucks ltd',
    'Anant resistors private limited',
    'Donglim precision (india) private limited',
    'Sst motor parts pvt. ltd.',
    'Advantek fuel systems private limited',
    'Vision autotech private limited',
    'Crm auto parts private limited',
    'SKH MARELLI EXHAUST SYSTEMS PRIVATE LIMITED',
    'Florida electrical industries limited',
    'Trisquare switchgears private limited',
    'Fairwell engineers private limited',
    'Accord automation private limited',
    'Shivanjali electricals pvt ltd',
    'Trinity auto components limited',
    'Shriniwas machine craft private limited',
    'Goldsun auto private limited',
    'Cepheid india private limited',
    'Bpl medical technologies private limited',
    'Mic instruments private limited',
    'Premier opticals pvt ltd',
    'Unique motors private limited',
    'KETAN MOTORS Private Limited',
    'SPUR TECHNOLOGIES PRIVATE LIMITED',
    'Imperial jin young industry private limited',
    'Pandit automobiles pvt. ltd.',
    'Lucas tvs limited',
    'Vivek automobiles ltd',
    'Gnb motors private limited',
    'Onkar motors ltd',
    'Tfr furniture & interiors private limited',
    'Anagha automobiles private limited',
    'BEEKAY AUTOCORP PRIVATE LIMITED',
    'Ab auto brakes private limited',
    'Devi electronics private limited',
    'Globatronix(bombay)pvt. ltd.',
    'Trafo power private limited',
    'Umc auto industries private limited',
    'Integrative solutions private limited',
    'Vijay litetronics components private limited',
    'Gic instruments private limited',
    'Param jewels private limited',
    'Bardiya trading company private limited',
    'Shrikant auto engineering private limited',
    'Pace diamonds private limited',
    'Nerine resort private limited',
    'Conamore resorts private limited',
    'Mhaske hotels pvt ltd',
    'Nyati hotels and resorts private limited',
    'Riverside resorts private limited',
    'Ceebros hotels private limited',
    'J.b.boda insurance surveyors & loss assessors private limited',
    'Premier global logistics limited',
    'Navigazione montanari ims ship management india private limited',
    'Cksr impex international private limited',
    'Sas realtors private limited',
    'Shiva systems & technologies private limited',
    'Shoolin shipping & logistics private limited',
    'Modern inns private limited',
    'Kolkata hotels private limited',
    'Afm logistics private limited',
    'Travonation holidays private limited',
    'All-trans shipping & logistic private limited',
    'Saudi tours private limited',
    'Natural hotels & resorts private limited',
    'Kai hospitality private limited',
    'Shiv vilas resorts private limited',
    'Lesage hotels and resorts private limited',
    'Overseas chinese cuisine (india) pvt ltd',
    'Aash logistics private limited',
    'Safe clearing and forwarding private limited',
    'T. k. centenary cargo services private limited',
    'Sr cargo india private limited',
    'Airsea forwarders india private limited',
    'OM SHREE LOGISTICS PRIVATE LIMITED',
    'Kir and caviar destinations private limited',
    'GEOFAST PRIVATE LIMITED',
    'Phoenix logistics private limited',
    'Sri datta logistics private limited',
    'Pl shipping & logistics limited',
    'Crossroad freight private limited',
    'Wandw cargo private limited',
    'Taurus shipping private limited',
    'Bernhard schulte shipmanagement (india) private limited',
    'Prime oceanic shipping private limited',
    'Shreejan cold storage private limited',
    'Garv logistics private limited',
    'Himalyaputra aviation limited',
    'N.k. logistics private limited',
    'South star shipping private limited',
    'Magadh travels and tours private limited',
    'Transasia travelnet private limited',
    'Prime air global limited',
    'Namaste tours pvt. ltd.',
    'Best carrying company private limited',
    'Piper india private limited',
    'Deepak goods transport private limited',
    'Supreme transport and traders limited',
    'Eagle cargo movers private limited',
    'Taurus freight forwarders private limited',
    'Roadstar express private limited',
    'Superspeed carriers private limited',
    'Bharat booking holidays india private limited',
    'Royal corptravel private limited',
    'Black rock logistics private limited',
    'Idms tours private limited',
    'Maa ambe logistics private limited',
    'LOGICENTRIX INDIA PRIVATE LIMITED',
    'Chalukya grace tours private limited',
    'Kerala tour mart india private limited',
    'RAMEE TOUR & HOLIDAYS PRIVATE LIMITED',
    'TROPICANA TOURISM PRIVATE LIMITED',
    'Aerosonic travel and cargo agency private limited.',
    'Eminence shipping agencies private limited',
    'Krownshipping cargo services private limited',
    'Mystique logistics private limited',
    'Sri shipping services private limited',
    'Liberty cold storage bombay private limited',
    'Green express logistics private limited',
    'India trip designers private limited',
    'Seatrans services private limited',
    'Balaji lines private limited',
    'Own logistics & services private limited',
    'VS & B DOMESTIC CONTAINER SOLUTIONS PRIVATE LIMITED',
    'Samwon exim and tours private limited',
    'Fsr travels private limited',
    'TIME & AGAIN EXCURSIONS PRIVATE LIMITED',
    'N t company clearing and forwarding private limited',
    'International visa services private limited',
    'Forefront logistics private limited',
    'S a r travel solution private limited',
    'Zahir adventure expedition private limited',
    'Apollo travel group private limited',
    'Ifly vacations private limited',
    'Hi walk travels private limited',
    'Anil mantra logistix private limited',
    'Valley fresh cold chain private limited',
    'Sunrich logistics private limited',
    'Mumbai aviation fuel farm facility private limited',
    'Meridian air travel private limited',
    'Aviation holidays private limited',
    'SPHERE TRAVELMEDIA & EXHIBITIONS PRIVATELIMITED',
    'STARLINE TRAVELS PRIVATE LIMITED',
    'Mithals international relocations private limited',
    'SPACE FREIGHT SOLUTIONS PRIVATE LIMITED',
    'Dart air services private limited',
    'TERRAH TECHNOLOGIES PRIVATE LIMITED',
    'Siti faction digital private limited',
    'Siti global private limited',
    'Economic logistic limited',
    'A.k.speak wireless private limited',
    'Snovaspace information systems private limited',
    'U software systems india private limited',
    'Exelan networking technologies private limited',
    'Varnik systems services private limited',
    'Senas net private limited',
    'Shlok information systems india private limited',
    'Nrs systems and technologies private limited',
    'Grape services private limited',
    'Rivian infotech private limited',
    'Pickle solutions private limited',
    'Binary infotech private limited',
    'Intex technologies (india) limited',
    'NSYNE SYSTEMS & SOLUTIONS INDIA PRIVATE LIMITED',
    'FREETIME HOSPITALITY INDIA PRIVATE LIMITED',
    'Ebms solutions private limited',
    'Sage infotech pvt. ltd.',
    'Clixxo broadband private limited',
    'Sapieo software india private limited',
    'Addval solutions private limited',
    'VSJ FINCAP PRIVATE LIMITED',
    'Gwyn engineering services private limited',
    'Krause biagosch india private limited',
    'Amtek it solutions private limited',
    'ESS TECHNOSYS PRIVATE LIMITED',
    'Netpeach technology services private limited',
    'Octathorpe web-consultants private limited',
    'Webileapps (india) private limited',
    'H c commercial ltd',
    'Espirit technoconsultants private limited',
    'Triveni communications private limited',
    'Experience infotech private limited',
    'Shakambaree technologies private limited',
    'Seventh apps private limited',
    'Somya translators private limited',
    'Ksp infotech private limited',
    'Axtrum solutions private limited',
    'Scube software square systems private limited',
    'Pal ittech private limited',
    'B4B TECHNOLOGIES PRIVATE LIMITED',
    'VSM ADVANCE AUTOMATION PRIVATE LIMITED',
    'Aptra technologies private limited',
    'Jouve india private limited',
    'Magic solutions private limited',
    'Creatiosoft solutions private limited',
    'Equal tech private limited',
    'Mobilepedia innovations private limited',
    'Phonon solutions private limited',
    'Luxos technologies private limited',
    'Royal info solutions private limited',
    'Arch network technologies (india) private limited',
    'Crab sheet solutions private limited',
    'Apricot infosoft private limited',
    'Remote infotech private limited',
    'Sahajanand technologies private limited',
    'Sriji computers private limited',
    'Pinnacle institute of digital technology private limited',
    'Ank technologies private limited',
    'Chargepoint technologies india private limited',
    'Modern streaming solutions private limited',
    'Bluerock eservices private limited',
    'Sagittarius eservices private limited',
    'Panacea infosec private limited',
    'Family buddy educare private limited',
    'Jetsynthesys private limited',
    'QUESS INTERNATIONAL SERVICES PRIVATE LIMITED',
    'Pavani engineers & projects private limited',
    'Xrg consulting private limited',
    'PANTNAGAR CETP PRIVATE LIMITED',
    'Data infocom limited',
    'Priya diagnostic and ultrasound centre private limited',
    'Kisan sanchar',
    'Providence buildtech private limited',
    'Increation media entertainments private limited',
    'Tiranga communications private limited',
    'Manthan movies private limited',
    'PUNE MULTIPLEX LIMITED',
    'Cabot sanmar limited',
    'Badotherm instruments holland private limited.',
    'Integrated workforce solutions private limited',
    'Sai shakti developers and builders private limited',
    'WIZELABS PRIVATE LIMITED',
    'Adobe events and promotions private limited',
    'Avs event solutions private limited',
    'Senfra limited',
    'Spa capital advisors limited',
    'Mapsofindia.com private limited',
    'Ramkumar morarka and sons private limited',
    'Baby corn events private limited',
    'SULZER PUMPS INDIA PRIVATE LIMITED',
    'Sevencolors motion picture private limited',
    'PHYSIQUE TRAINING EQUIPMENT PRIVATE LIMITED',
    'Anabond golf club private limited',
    'Smg sports management company private limited',
    'Smartube entertainment private limited',
    'Crosscraft private limited',
    'Deccan event management private limited',
    'Captain media private limited',
    'Apoorva properties and estates p.ltd.',
    'Transweigh (international) private limited',
    'Icc international agencies limited',
    'Full house entertainment private limited',
    'UPS EXPRESS PRIVATE LIMITED',
    'Omega techno solutions private limited',
    'Grace exhibitors and agencies pvt ltd',
    'Bhramma cine creations private limited',
    'Mycorporation consultants private limited',
    'Bateli tea co ltd',
    'United spirits limited',
    'Shreeji industries limited',
    'Gokul refoils and solvent limited',
    'BHANDARI HOSIERY EXPORTS LIMITED',
    'FAZE THREE AUTOFAB LIMITED',
    'THE RUBY MILLS LIMITED',
    'T t limited',
    'Nagreeka exports ltd.',
    'The sirpur paper mills ltd',
    'Gratex industries limited',
    'PCBL LIMITED',
    'VIDHI SPECIALTY FOOD INGREDIENTS LIMITED',
    'Oxides and specialities limited',
    'E.i.d parry (india) limited',
    'Kerala ayurveda limited',
    'Fdc limited',
    'Kilitch drugs (india) limited.',
    'Pearl polymers limited',
    'Captain polyplast limited',
    'Vishal malleables limited',
    'Facor alloys limited',
    'Hira ferro alloys limited',
    'SHRI BAJRANG ALLIANCE LIMITED',
    'Hindustan wires ltd',
    'Steelco gujarat limited',
    'Ess dee aluminium limited',
    'Premier ferro alloys & securities limited',
    'The tata power company limited',
    'Blue star limited',
    'Automotive stampings and assemblies limited',
    'Whirlpool of india limited',
    'Ss4 services private limited',
    'MAGNIT GLOBAL INDIA PRIVATE LIMITED',
    'Matrix rewards private limited',
    'CORPORATE TRUST CONSULTANTS PRIVATE LIMITED',
    'Amikrupa entertainment private limited',
    'Mont blanc properties private limited',
    'Sunil synthetics pvt ltd',
    'Siemens technology and services private limited',
    'Abad holdings private limited',
    'Catapharma (india) pvt ltd',
    'Golden swan leisure clubs private limited',
    'SUBA HOTELS PRIVATE LIMITED',
    'Asian institute of gastroenterology private limited',
    'Regent agro products ltd',
    'Paribartan electoral trust',
    'R-ADDA RESTAURANTS PRIVATE LIMITED',
    'R-vision india private limited',
    'Munters india humidity control private limited',
    'Media promotions private limited',
    'Delta paper mills ltd',
    'Punjab state grains procurement corporation limited',
    'Bhoir dredging co pvt ltd',
    'Prerna fine chem pvt ltd',
    'Vivil investments pvt. ltd.',
    'Shri gurudev en-trade ltd',
    'Lynx machinery and commercials limited',
    'Navcom industries limited',
    'Tvs electronics limited',
    'Mantech automation private limited',
    'Santec automation india private limited',
    'NEPTUNE AUTOMATIC PRIVATE LIMITED',
    'S b engineering pvt ltd',
    'Unique welding products pvt ltd',
    'Modern india steel rolling mills private limited',
    'Oay kay forgings private limited',
    'Advance mechtech private limited',
    'Marvelous vimercati foundry private limited',
    'Ram infrastructure limited',
    'Mr sheetfed india private limited',
    'New era conveyors private limited',
    'Cranoist material handling equipments private limited',
    'Deco equipments private limited',
    'Duro polyprene ltd',
    'Protos engineering company private limited',
    'Diamtools private limited',
    'TRUCUT TOOLS INDIA PRIVATE LIMITED',
    'Walia agni industries private limited',
    'Roots precision products private limited',
    'Connstrona facades private limited',
    'Matrix packaging private limited',
    'Ib turbo private limited',
    'Shree sk manufacturing private limited',
    'TVADARTHAM TECHNOLOGIES PRIVATE LIMITED',
    'Verga attachments private limited',
    'Minsun infraa prrojects private limited',
    'Micro-tech cnc pressings india private limited',
    'FABRTECH PRIVATE LIMITED',
    'Newage fire protection industries private limited',
    'Dalmec industrial manipulators india private limited',
    'Ansaldocaldaie - gb engineering private limited',
    'Sai arc india private limited',
    'Loha fab industries private limited',
    'Cosmos impex (india) pvt ltd',
    'Laxmi agroenergy private limited',
    'Imperial sewing machine private limited',
    'Parcon (india) pvt ltd',
    'Safe lifters private limited',
    'Electronfab engineering private limited',
    'Pyro electric and allied instruments pvt ltd',
    'Hylite electroplaters private limited',
    'TOSHNIWAL ENGINEERING & SYSTEMS PRIVATE LIMITED',
    'Indo toolings private limited',
    'Actionware india private limited',
    'Reliable agro enggservices pvt ltd',
    'R b forgings private limited',
    'CHEMTROLS INDUSTRIES PRIVATE LIMITED',
    'METALIKA PRODUCTS (INDIA) PRIVATE LIMITED',
    'Tru tek systems combine private limited',
    'Galiakotwala engineering company private limited',
    'Kirti pressings private limited',
    'Rohit press comp private limited',
    'Creative tools and components (india) private limited',
    'Doshi tubes private limited',
    'Mass fab(india) private limited',
    'Servocontrols and hydraulics (india) private limited',
    'Renown energy and equipment private limited',
    'KAREN',
    'S CONTROL SYSTEMS (INDIA ) PRIVATE LIMITED',
    'Navjeevan transmission private limited',
    'Xcel stiro private limited',
    'Prism instrumentation (india) private limited',
    'Finearc systems pvt ltd',
    'Pyro electric instruments goa private limited',
    'Sisco projects private limited',
    'Artee flow controls private limited',
    'Transmission corporation of andhra pradesh limited',
    'Advance india exim private limited',
    'Cache technologies private limited',
    'Ayoki cembol erectors private limited',
    'Pyramid - airtech private limited',
    'Swipfe engineering private limited',
    'County trade impex private limited',
    'Euro tops india private limited',
    'Durakart marketing private limited',
    'Xtech equipment private limited',
    'Sidhidata tradecomm limited',
    'Living up healthcare private limited',
    'Fancy multitrade private limited',
    'Nikhil vinimay private limited',
    'Venture electric machines private limited',
    'Pranit vinimay private limited',
    'Karan vinimay private limited',
    'Aaren vinimay private limited',
    'Khushboo tradecon private limited',
    'Aanya commotrade private limited',
    'Petunia dealtrade private limited',
    'Gadagraj vyapaar private limited',
    'Ornate tradelink private limited',
    'Harshit dealtrade private limited',
    'Cem instruments (india) private limited',
    'Triumph trading limited',
    'Office zone products private limited',
    'Tirupati retail (india) private limited',
    'Sultaniya sons tradelink private limited',
    'Indranuj dealer private limited',
    'Brilliant vintrade private limited',
    'Snowblue dealtrade private limited',
    'Christian louboutin india private limited',
    'Dermacy healthcare private limited',
    'Jalmurti vyapaar private limited',
    'Neptune dealcom private limited',
    'Tamohar vanijya private limited',
    'Sht building solutions private limited',
    'Reverie artwares private limited',
    'Navjyoti commodity management services limited',
    'Mahanidhi vyapaar private limited',
    'Savaliya agri commodity export private limited',
    'Rahmat trading company private limited',
    'Tapaswat commercial private limited',
    'Sai vardhan associates private limited',
    'Mansarovar tradecomm private limited',
    'T. g. interlinings private limited',
    'VIDABEST ENERGY PRIVATE LIMITED',
    'Warm lights private limited',
    'Niger technologies private limited',
    'Komal vintrade private limited',
    'Opus hotels & resorts private limited',
    'Daaj hotels and resorts private limited',
    'Teerathdeo dealer private limited',
    'Intercity agencies private limited',
    'The driftwood hotels private limited',
    'Sharda hotels and tours private limited',
    'Anmol spintex private limited',
    'Ds fire systems private limited',
    'Gurgaon bazaar private limited',
    'Mdc impex private limited',
    'Barque hotels private limited',
    'Jps consumer products private limited',
    'Mody pump sales and services private limited',
    'Sweetyet development distribution (india) private limited',
    'Metto super market private limited',
    'Brijbhumi merchants private limited',
    'Aaverina hospitality private limited',
    'Express hotels pvt ltd',
    'Sudama resorts private limited',
    'Brijbhumi tradevin private limited',
    'Ph4 food & beverages private limited',
    'K.p. automotives private limited',
    'Chandravesh dealcom private limited',
    'Radharani exports private limited',
    'Pgs inn private limited',
    'Girindra hospitality private limited',
    'Bidya 2nd sale private limited',
    'Pmc polymer marketing private limited',
    'Chesnut tradeworth private limited',
    'Pahilaj trading private limited',
    'Four seasons luxury resorts (india) private limited',
    'Ramee hotels private limited',
    'THRIVERA SERVICES PRIVATE LIMITED',
    'Dsa traders private limited',
    'Vimrith dealer private limited',
    'Agile hotels private limited',
    'Hotel kamal pvt ltd',
    'Golkonda resorts private limited',
    'Sssk business private limited',
    'Vaibhav properties private limited',
    'A p fine dining private limited',
    'Melange hospitality pvt ltd',
    'Consortium resorts and inns private limited',
    'CLOUDS INFRABUILD PRIVATE LIMITED',
    'Premier restaurants private limited',
    'Coastal resorts india ltd',
    'Kejriwal resorts private limited',
    'Regency holidayz private limited',
    'Escapade adventures and holidays private limited',
    'Tavisha hospitality private limited',
    'Nandhini hotels private limited',
    'G interstate trucking company private limited',
    'Travcom india private limited',
    'Rajpal cargo movers private limited',
    'Sudhir transports private limited',
    'PROENCA GRAND VACATION',
    'S MEDIA PRIVATE LIMITED',
    'Valuideas online private limited',
    'Shine web solutions private limited',
    'Triple play technologies private limited',
    'ESTILO ELECTRONICS AND SERVICES PRIVATE LIMITED',
    'Futuristic idc private limited',
    'Mpags e-systems & innovative solutions private limited',
    'Tech anugrah private limited',
    'Silicon infovision private limited',
    'Fore cad technologies private limited',
    'Vnurture healthcare software solutions private limited',
    'Egon software private limited',
    'Tech prastish software solutions private limited',
    'Nutsitlab private limited',
    'Xl lifestyle portals private limited',
    'Acknown technologies private limited',
    'Lunarmech technologies private limited',
    'Mantra tech ventures private limited',
    'APPCINO TECHNOLOGIES PRIVATE LIMITED',
    'Rsf technologies private limited',
    'Siddhi portfolio services p.ltd.',
    'Treeo resort p.ltd.',
    'Bowling and billiards association of india',
    'Ra pipes private limited',
    'Mukesh babu management consultants private limited',
    'Piper serica advisors private limited',
    'Jay bhavani metals private limited',
    'Indian public schools society',
    'Mangalam timber products ltd',
    'Pokarna limited',
    'Powersoft global solutions limited',
    'Hanuman agro industries limited.',
    'THE PHOENIX MILLS LIMITED',
    'THE RAMARAJU SURGICAL COTTON MILLS LIMITED',
    'Himatsingka seide limited.',
    'Gokak textiles limited',
    'Raymond limited',
    'Gtn industries limited',
    'GP PETROLEUMS LIMITED',
    'Themis medicare limited',
    'Deepak fertilisers and petrochemicals corporation ltd',
    'Hikal limited',
    'Torrent pharmaceuticals ltd',
    'Aksh optifibre limited',
    'Sahil tech (india) limited',
    'Vinayak polycon international limited',
    'Morganite crucible (india) limited',
    'Nilachal refractories limited',
    'SHREE SPONGE STEEL AND CASTING LIMITED',
    'Orissa sponge iron and steel limited',
    'Stelco strips ltd',
    'Anup malleables ltd',
    'Josts engineering comapny limited',
    'Kaira can company limited',
    'DUNCAN ENGINEERING LIMITED',
    'Ankur bio tech research private limited',
    'Bix insurance and financial technologies private limited',
    'Suyog telematics private limited',
    'ARMEX LOGISTICS PRIVATE LIMITED',
    'Designer audio india private limited',
    'ANGEE BRIDGING INDIA PRIVATE LIMITED',
    'EDUBYHEART INDIA PRIVATE LIMITED',
    'EDURUPT TECHNOLOGIES PRIVATE LIMITED',
    'TENITO PRIVATE LIMITED',
    'CAKEBEE DELI FRESH PRIVATE LIMITED',
    'INTERIORITY PRIVATE LIMITED',
    'NAMMA PANCHTATVA ECOXPERIENCE PRIVATE LIMITED',
    'ILOGIC STAFFING PRIVATE LIMITED',
    'APS PARADIGM PRIVATE LIMITED',
    'BASTIONSEVEN CONSULTING PRIVATE LIMITED',
    'FACTORDAILY MEDIA LAB FOUNDATION',
    'SAKHI SAPHALYA CRAFTS PRODUCER COMPANY LIMITED',
    'KUMA INFRA AND REALTY PRIVATE LIMITED',
    'SUNSACK GEOTEX PRIVATE LIMITED',
    'MAAULI PROPAC PRIVATE LIMITED',
    'TRUE NORTH CONSTRUCTIONS PRIVATE LIMITED',
    'TRINARY HEALTH PRIVATE LIMITED',
    'BREEZY CHEF PRIVATE LIMITED',
    'CMTI-CONSTRUCTION MANAGEMENT TRAINING INSTITUTE PRIVATE LIMITED',
    'SHIVOM FASHION TRENDS PRIVATE LIMITED',
    'RESET TECH GLOBAL PRIVATE LIMITED',
    'AVP CRAFTS PRIVATE LIMITED',
    'QUBIT FINTECH CONSULTANTS PRIVATE LIMITED',
    'GLOBAL POWER RESEARCH INSTITUTE PRIVATE LIMITED',
    'DRISHTI MULTITECH PRIVATE LIMITED',
    'ASHOK RENERGY PRIVATE LIMITED',
    'JURISEDGE ACADEMY PRIVATE LIMITED',
    'ELECTROHELPS NETWORKS PRIVATE LIMITED',
    'TRIUMPH AUTO CARS PRIVATE LIMITED',
    'HAZAR BAZAAR ORGANIZATION PRIVATE LIMITED',
    'INGENIA POLYMERS & CHEMICALS INDIA PRIVATE LIMITED',
    'AMP ENERGY DISTRIBUTED GENERATION ONE PRIVATE LIMITED',
    'BETTERBUKZ ACCOUNTING SERVICES PRIVATE LIMITED',
    'PROMEX BRANDS PRIVATE LIMITED',
    'INNOHUB INFRA DEVELOPMENT PRIVATE LIMITED',
    'HEALTHCAREDIALOG MEDIA PRIVATE LIMITED',
    'HILL RANCHES PRIVATE LIMITED',
    'GOODCRAVE PRIVATE LIMITED',
    'ANKURA CONSULTING INDIA PRIVATE LIMITED',
    'AALPS NUTRA TECH PRIVATE LIMITED',
    'AADISREE TRANSTECH PRIVATE LIMITED',
    'SRAS SHIPPING AND OFFSHORE PRIVATE LIMITED',
    'ORGANIC PERIYA PRIVATE LIMITED',
    'AUTOKOMPANY PREMIUM PRIVATE LIMITED',
    'TORRVIS PHARMACEUTICALS PRIVATE LIMITED',
    'SOILED ECOCULTURE PRIVATE LIMITED',
    'RAABTA JEWELS PRIVATE LIMITED',
    'TRAMP HOSPITALITY INDIA PRIVATE LIMITED',
    'PRABHA CORPORATE SERVICES PRIVATE LIMITED',
    'AJ PRIME PRIVATE LIMITED',
    'TIMECODE SOLUTIONS PRIVATE LIMITED',
    'REDLEAF SOFTS PRIVATE LIMITED',
    'SAMAVAMA INFRA AND REALTY PRIVATE LIMITED',
    'DEVIK LABS PRIVATE LIMITED',
    'STAAR SURGICAL INDIA PRIVATE LIMITED',
    'CONFIX INDIA PRIVATE LIMITED',
    'TRINETRA BEVERAGES PRIVATE LIMITED',
    'VSCART INDIA PRIVATE LIMITED',
    'ROYAL DURGA LOGISTICS PRIVATE LIMITED',
    'KREO CAPITAL ASSET PRIVATE LIMITED',
    'DANUB HOMES PRIVATE LIMITED',
    'DABROL KRISHNA DECORS PRIVATE LIMITED',
    'KIRSH GAMES PRIVATE LIMITED',
    'HARPAT HOLDINGS PRIVATE LIMITED',
    'ONESOLAR TECHNOLOGIES PRIVATE LIMITED',
    'FANWORLD PLATFORMS PRIVATE LIMITED',
    'ISENSE PR PRIVATE LIMITED',
    'MATA SITADEVI SHIPPING PRIVATE LIMITED',
    'LIFARS INDIA PRIVATE LIMITED',
    'VRIKSHA AGRO SCIENCES PRIVATE LIMITED',
    'VIVIDH FOOD STOCKIEST PRIVATE LIMITED',
    'QUANTAR ENGINEERING PRIVATE LIMITED',
    'ROYAL EXPERIENCE TOURS & TRAVELS (OPC) PRIVATE LIMITED',
    'BOOST ECOMMERCE PRIVATE LIMITED',
    'KARIOT SOLUTIONS PRIVATE LIMITED',
    'CAPTIV TECHNO SOLUTIONS PRIVATE LIMITED',
    'ARISCON ESTATES PRIVATE LIMITED',
    'IKONIC ENGINEERING AND DESIGN PRIVATE LIMITED',
    'GLEN PAPER PRODUCTS PRIVATE LIMITED',
    'JUNTO HOME PRODUCTS PRIVATE LIMITED',
    'AGARWAL HOLDINGS PRIVATE LIMITED',
    'TRISSENCE RETAIL PRIVATE LIMITED',
    'MULTIQOS TECHNOLOGIES PRIVATE LIMITED',
    'CLOUDCHAL PRIVATE LIMITED',
    'SHAKUNTA EDU COM PRIVATE LIMITED',
    'AARTI STEEL INTERNATIONAL LIMITED',
    'EVERSAFE POLYPRODUCTS PRIVATE LIMITED',
    'GLOBATECH ENTERPRISE PRIVATE LIMITED',
    'SUPER SOUL FOUNDATION',
    'TALL STAR PRIVATE LIMITED',
    'ORANGE KOI PRIVATE LIMITED',
    'TAKUMI INTERNATIONAL PRIVATE LIMITED',
    'DALGONA TECHNOLOGIES PRIVATE LIMITED',
    'HOM INDIA PRIVATE LIMITED',
    'BRIDGELABZ SOLUTIONS PRIVATE LIMITED',
    'ABIR SPACE PRIVATE LIMITED',
    'IDEEBS FASHION PRIVATE LIMITED',
    'PRATAP VOITURES PRIVATE LIMITED',
    'BONDBAZAAR SERVICES PRIVATE LIMITED',
    'SHIVSHRI GRAM UNNATI ARTHSAHAYATA NIDHI LIMITED',
    'VIROHAA INTERNET MEDIA (OPC) PRIVATE LIMITED',
    'HYE WOO PRINTING INDIA PRIVATE LIMITED',
    'SPEED TEAM INFRA PRIVATE LIMITED',
    'SUREGAS ENGINEERING PRIVATE LIMITED',
    'KURONGI AGRITECH PRIVATE LIMITED',
    'PROFESSIONAL CLOUD SAAS PRIVATE LIMITED',
    'DAUMESNIL SERVICES PRIVATE LIMITED',
    'FRESH JOY AGRO PRIVATE LIMITED',
    'CHIRAMEL ENTERPRISES PRIVATE LIMITED',
    'KOSHA FINE JEWELS PRIVATE LIMITED',
    'COMMUNICATION PLATFORM INDIA PRIVATE LIMITED',
    'STEPFLY INNOVATIONS PRIVATE LIMITED',
    'MAKSQ CONSULTING PRIVATE LIMITED',
    'VYAPAR SAATHI ADVISORS PRIVATE LIMITED',
    'VOYAGE INDIA PRIVATE LIMITED',
    'CACCORD INFORMATION PRIVATE LIMITED',
    'INTERMARINE SERVICES PRIVATE LIMITED',
    'LOOPERS MINI NIDHI LIMITED',
    'OAFF MUSIC PRIVATE LIMITED',
    'KARWAANLIFE (OPC) PRIVATE LIMITED',
    'ASYCHRON SOLUTIONS PRIVATE LIMITED',
    'GIBT INDIA PRIVATE LIMITED',
    'ASIMTE CONSULTANT INDIA PRIVATE LIMITED',
    'MNANS AGRO PRIVATE LIMITED',
    'LRCAMA INFRA PRIVATE LIMITED',
    'HNG RECRUITMENT AND STAFFING SERVICES PRIVATE LIMITED',
    'CLARIUM TECH PRIVATE LIMITED',
    'STUDIO DIGIARCH PRIVATE LIMITED',
    'DAYA EMERGENCY CARE CENTER PRIVATE LIMITED',
    'AKUMS HEALTHCARE LIMITED',
    'ARCH9 AGRI FIELDS PRIVATE LIMITED',
    'ARDESCO POWER PRIVATE LIMITED',
    'REDNEX PHARMACEUTICALS PRIVATE LIMITED',
    'BOXPORT PACKAGING SOLUTIONS PRIVATE LIMITED',
    'ABREL SPV 2 LIMITED',
    'NATURE CONSERVANCY INDIA SOLUTIONS PRIVATE LIMITED',
    'ARTIUM ACADEMY PRIVATE LIMITED',
    'HIGH FLYERS FITNESS PRIVATE LIMITED',
    'INCREDO TECHNOLOGIES PRIVATE LIMITED',
    '7G PLUS CARE PRIVATE LIMITED',
    'LAVITA PHARMA PRIVATE LIMITED',
    'CENTRAL TRANSMISSION UTILITY OF INDIA LIMITED',
    'VVVESTURES PRIVATE LIMITED',
    'UNEECHUB SERVICES PRIVATE LIMITED',
    'INFLUX ONE WORKFORCE (OPC) PRIVATE LIMITED',
    'RITZY ROUTE PRIVATE LIMITED',
    'FIBERSTORY INFRATECH PRIVATE LIMITED',
    'RENEW SUN SHAKTI PRIVATE LIMITED',
    'PACSEAL GASKETS INDIA PRIVATE LIMITED',
    'TFL FOODS PRIVATE LIMITED',
    'ELUCIDATE SOLUTIONS PRIVATE LIMITED',
    'BADU ROAD OWNERS ASSOCIATION',
    'KALYANI AURA WORKSPACE PRIVATE LIMITED',
    'ARNORIS CONTAINER LINES PRIVATE LIMITED',
    'VERTRICAL INDIA PRIVATE LIMITED',
    'BUZYG PRODUCTS AND SERVICES PRIVATE LIMITED',
    'KARTMAX TECHNOLOGIES PRIVATE LIMITED',
    'ATHARVA ELASTOMERS INDIA PRIVATE LIMITED',
    'IITI DRISHTI CPS FOUNDATION',
    'YOJANA ORGANICS PRIVATE LIMITED',
    'CUBYTS TECHNOLOGIES PRIVATE LIMITED',
    'RESONA GLOBAL FOODS PRIVATE LIMITED',
    'ENVIROTASK SERVICES PRIVATE LIMITED',
    'JBMI AGRI PRIVATE LIMITED',
    'MIDAS MOTORS PRIVATE LIMITED',
    'GINOX CONCEPTS PRIVATE LIMITED',
    'TRUCKGO LOGISTICS PRIVATE LIMITED',
    'TEACH GENZ PRIVATE LIMITED',
    'MICROHIND NETWORKS AND TECHNOLOGIES PRIVATE LIMITED',
    'TIEBUZZ SOLUTIONS PRIVATE LIMITED',
    'LUCKSHMI YARN IMPEX PRIVATE LIMITED',
    'RUDRAJEET SHIPPING SERVICES PRIVATE LIMITED',
    'LIONCREST ONLINE LEARNING PRIVATE LIMITED',
    'KPM INFOSYSTEM PRIVATE LIMITED',
    'SWELECT SUN ENERGY PRIVATE LIMITED',
    'MAVERICK LEARNING PRIVATE LIMITED',
    'GIGART SOLUTIONS PRIVATE LIMITED',
    'ECOSYNTECH PRIVATE LIMITED',
    'EXCURSY SOLUTIONS PRIVATE LIMITED',
    'TEZ DELIVERY PRIVATE LIMITED',
    'ORBIT ABHINASH OWNERS ASSOCIATION',
    'JOYYA GOODS PRIVATE LIMITED',
    'GROWINLIFE PRIVATE LIMITED',
    'NGOGURU PRIVATE LIMITED',
    'ZOOPPAY PRIVATE LIMITED',
    'PSI HEALTHCARE PRIVATE LIMITED',
    'DHROL BHADRA HIGHWAYS LIMITED',
    'SWAJYOT FOODS PRIVATE LIMITED',
    'REVX ENERGY PRIVATE LIMITED',
    'EMBEDDNA PRIVATE LIMITED',
    'ROAD CHARGING SOLUTION PRIVATE LIMITED',
    'IFAA Fitness Academy India Private Limited',
    'International Tax Research and Analysis Foundation',
    'Acceleron Labs Private Limited',
    'ULTRACASH TECHNOLOGIES PRIVATE LIMITED',
    'COCOCITI ONLINE SOLUTIONS PRIVATE LIMITED',
    'Aptusdatalabs Technologies Private Limited',
    'QuEST Global Engineering Services Private Limited',
    'Bagster Retail Private Limited',
    'BRAND BRAHMA MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'NUTGRAPH MEDIA PRIVATE LIMITED',
    'TIARE CONSILIUM PRIVATE LIMITED',
    'Catena Technologies Private Limited',
    'S CUBE ERGONOMICS PRIVATE LIMITED',
    'EcoTree Solutions Private Limited',
    'Soul Vision Creations Private Limited',
    'inStream adtech Private Limited',
    'TREDENCE ANALYTICS SOLUTIONS PRIVATE LIMITED',
    'idX (India) Display Private Limited',
    'VKARMA FOODS AND SUPPLEMENTS PRIVATE LIMITED',
    'Nuvoton Technology India Private Limited',
    'OutSmart Services Private Limited (OPC)',
    'Pro Waste Concepts Private Limited (OPC)',
    'Optiminds HR Services Private Limited (OPC)',
    'Techmantu Digital Private Limited (OPC)',
    'Artwist Academy Private Limited',
    'Learnyst Insight Private Limited',
    'JOULESTOWATTS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RJT ADVISORS PRIVATE LIMITED',
    'ACCGEM BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'Tech3in IT Solutions Private Limited',
    'Core Team Facility Management Private Limited',
    'ASTORMUELLER RETAIL PRIVATE LIMITED',
    'SILICON FACILITIES SERVICES PRIVATE LIMITED',
    'EMALLBUY RETAIL PRIVATE LIMITED',
    'SAADRUSO TECHNOLOGY VENTURES PRIVATE LIMITED',
    'Lithium Urban Technologies Private Limited',
    'IMMERSION ONLINE SERVICES PRIVATE LIMITED',
    'MONTBLEU TECHNOLOGIES PRIVATE LIMITED',
    'COMPANIESINN SOLUTIONS PRIVATE LIMITED',
    'SYNFINITY Management Consultants Private Limited',
    'SIGNOTECH SYSTEMS PRIVATE LIMITED',
    'ACCUNITY HR SERVICES PRIVATE LIMITED',
    'POZITIV ADVISORS PRIVATE LIMITED',
    'FRONTEDGE ACADEMY PRIVATE LIMITED',
    'KRIDHA BUSINESS SUPPORT SERVICES PRIVATE LIMITED',
    'STRATNEXT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'NHANCE DIGITAL BUILDTECH PRIVATE LIMITED',
    'FMXC Management Consulting Private Limited',
    'MAXIT MEDIA PRIVATE LIMITED',
    'Aquixin Services Private Limited',
    'BauenAd Interactive Private Limited',
    'CADOpt Technologies Private Limited',
    'Sencillatec Solutions Private Limited',
    'IBK ENGINEERS PRIVATE LIMITED',
    'Will Legal Services Private Limited',
    'WIDE HEART SOLUTIONS PRIVATE LIMITED',
    'BoxMantra Retail Services Private Limited',
    'PropertyAngel Management Private Limited',
    'JASSBYS PUBS PRIVATE LIMITED',
    'August Purple Services Private Limited',
    'PureSight Systems Private Limited',
    'DECOPAD INTERIORS PRIVATE LIMITED',
    'ININTRA ALLIANCES PRIVATE LIMITED',
    'ZDC MANAGEMENT PRIVATE LIMITED',
    'Agilis Interiorz Solutions Private Limited',
    'Novellus Consulting Private Limited',
    'Brainy Stars Education India Private Limited',
    'UTZ INDIA PRIVATE LIMITED',
    'ClickOnCare Retail Private Limited',
    'Atomtower Knowledge Solutions Private Limited',
    'SAMESKY CONFECTIONERIES INDIA PRIVATE LIMITED',
    'Brunex Pharmaceuticals Private Limited',
    'Sensonics Devices Private Limited',
    'NoBroker Technologies Solutions Private Limited',
    'AMPERSANDSQUARE TECH-SERVICES PRIVATE LIMITED',
    'QIN International Private Limited',
    'INTIMAR SERVICES PRIVATE LIMITED',
    '6CUBES CORPORATE TRAINING SOLUTIONS PRIVATE LIMITED',
    'Landmark Online India Private Limited',
    'HackerEarth Technologies Private Limited',
    'ENFORCE TECHNOLOGIES PRIVATE LIMITED',
    'ServiceMonk Technologies Private Limited',
    'Infraedge Management Services Private Limited',
    'BANGALORE MOUNTAINEERING CLUB PRIVATE LIMITED',
    'MUSION HOLOGRAMS PRIVATE LIMITED',
    'Cimplyfive Corporate Secretarial Services Private Limited',
    'Rich Bite Hospitality Private Limited',
    'FELIDAE INFOSEC PRIVATE LIMITED',
    'ISTA Wellness & Fitness OPC Private Limited',
    'Sancus Infrastructure Private Limited',
    'BuzzClan Info Services Private Limited',
    'TAJ RELOCATIONS PRIVATE LIMITED',
    'KIKO COSMETICS RETAIL PRIVATE LIMITED',
    'IdeasBridge Communications Private Limited',
    'SPEAKEASY COMMUNICATIONS PRIVATE LIMITED',
    'STRIDE ARC N DESIGN PRIVATE LIMITED',
    'BASIL TALENT PRIVATE LIMITED',
    'Lumileds India Private Limited',
    'DBL Kidskart Online Private Limited',
    'ELEVENTURE SYSTEMS & SERVICES PRIVATE LIMITED',
    'PACHIS FRAME PRODUCTION PRIVATE LIMITED',
    'CLEVERATTI SKILLS PRIVATE LIMITED',
    'EMRGTECH SOFTWARE SERVICES PRIVATE LIMITED',
    'SILVER LEAF SOLUTIONS PRIVATE LIMITED',
    'ONECOM SOFTWARE INDIA PRIVATE LIMITED',
    '7MINION TECHNOLOGY PRIVATE LIMITED',
    'WEB IQ TECHNOLOGIES PRIVATE LIMITED',
    'LFS HEALTH SERVICES PRIVATE LIMITED',
    'DATONG MECHANIC AND ELECTRIC PRIVATE LIMITED',
    'MADS Creations Private Limited',
    'ADZEN INTERIOR CREATIONS PRIVATE LIMITED',
    'HOSPITALITY CAD (OPC) PRIVATE LIMITED',
    'FASTWAY MANESAR DIGITAL VISION PRIVATE LIMITED',
    'NA Systems Private Limited',
    'LUXURY E-COMMERCE PRIVATE LIMITED',
    'WINDOWTECHS CREATIONS PRIVATE LIMITED',
    'One Eighty Aamoksh Technologies Private Limited',
    'CIK Telecom India Private Limited',
    'CIPHER MANAGED SECURITY SERVICES PRIVATELIMITED',
    'NETROMICS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'ZENTRUM LIFESTYLE SOLUTIONS & SERVICES PRIVATE LIMITED',
    'MOBILITI MANAGEMENT SERVICES PRIVATE LIMITED',
    'SUVRAT PURVEYORS INDIA PRIVATE LIMITED',
    'AXLOR IMPEX PRIVATE LIMITED',
    'NIPPO INDIA PRIVATE LIMITED',
    'INDUSTRIAL INFO RESEARCH INDIA PRIVATE LIMITED',
    'MOTOCARE INDIA PRIVATE LIMITED',
    'Serko India Private Limited',
    'ScribeAstore India Private Limited',
    'Crocus Brands Private Limited',
    'Startup Buddy Services Private Limited',
    'JOSH TALKS PRIVATE LIMITED',
    '5 LUBINA INFOTAINMENT PRIVATE LIMITED',
    '5ONE ANALYTICS PRIVATE LIMITED',
    'Biosite Research Private Limited',
    'Heads Global Private Limited',
    'JBS Security Resource Private Limited',
    'HATCH TACT INNOVATIONS PRIVATE LIMITED',
    'HEMERA RESOURCES PRIVATE LIMITED',
    'VIDHYA KNOWLEDGE FOUNDATION',
    'Tetrahedron Manufacturing Services Private Limited',
    'TRANSFORM FUTURE CONSULTING PRIVATE LIMITED',
    'TABONO SPORTS & ENTERTAINMENT OPC PRIVATE LIMITED',
    'PRO-ALIGN SECURITY INDIA PRIVATE LIMITED',
    'ICG MEDICAL INDIA PRIVATE LIMITED',
    'SENSO UNICO TECHNOLOGY PRIVATE LIMITED',
    'MOTIONWORKS ROBOTICS PRIVATE LIMITED',
    'TALETTUTAYI SOLAR PROJECTS PRIVATE LIMITED',
    'Green Wheels Fleet Management Private Limited',
    'VARNAM HEALTH CARE PRIVATE LIMITED',
    'EEE-TAXI MOBILITY SOLUTIONS PRIVATE LIMITED',
    'FULCRUM ALM SOLUTIONS PRIVATE LIMITED',
    'Diptab Ventures Private Limited',
    'E T S TOURIST PRIVATE LIMITED',
    'Encore Shipping India Private Limited',
    'SUPERSHINE KITCHEN SYSTEMS PRIVATE LIMITED',
    'NAVS Industries Private Limited',
    'FPI Events Private Limited',
    'TECHUM INTERNATIONAL PRIVATE LIMITED',
    'VAK LIGHTING INDIA PRIVATE LIMITED',
    'ALBATROSS FINISHING SCHOOL PRIVATE LIMITED',
    'VHarWah Learning Solutions OPC Private Limited',
    'GRAND FORMACION INDIA PRIVATE LIMITED',
    'VEGAZVA TECHNOLOGIES PRIVATE LIMITED',
    'NEP INDIA PRIVATE LIMITED',
    'Unnati Helpers Foundation',
    'VIVO HEALTH SERVICES PRIVATE LIMITED',
    'KAARA HOSPITALITY AND LEISURE PRIVATE LIMITED',
    'DREAMZ MYNEWCAR INDIA PRIVATE LIMITED',
    'NIRSAN CONNECT PRIVATE LIMITED',
    'Global Herbals India Private Limited',
    'TRIBES COMMUNICATION PRIVATE LIMITED',
    'iSENS Biosensors India Private Limited',
    'PRO CLAIM RISK & ALLIED SERVICES PRIVATE LIMITED',
    'Retreat Inn & Suites Private Limited',
    'NOVA GAMING VENTURES PRIVATE LIMITED',
    'TALETTUTAYI SOLAR PROJECTS TWO PRIVATE LIMITED',
    'Jindal United Steel Limited',
    'Eminent Auto Horizon Private Limited',
    'LEVEL A COMMODITY SERVICES PRIVATE LIMITED',
    'HEEHOON DESIGN GLOBAL PRIVATE LIMITED',
    'AESTHETIC AROMA Private Limited',
    'Akash Blowers Private Limited',
    'SKS NIRMAN VAANIJAY PRIVATE LIMITED',
    'Global Bottlers Private Limited',
    'MAHESH LUMBER PRIVATE LIMITED',
    'i2R Consulting Private Limited',
    'IBOSS REALTY SOLUTIONS PRIVATE LIMITED',
    'IPSAA FOUNDATION',
    'INSPUR TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Tiger India Private Limited',
    'WORLDWIDE VISION EDUCATION & IMMIGRATION CONSULTANTS PRIVATE LIMITED',
    'R.J. GREEN PRIVATE LIMITED',
    'GLOBAL AIRNET SERVICES PRIVATE LIMITED',
    'GOLDSTAR IMPEX PRIVATE LIMITED',
    'SRG TRADEX (INDIA) PRIVATE LIMITED',
    'PURPLE UNITED SALES PRIVATE LIMITED',
    'NILGIRI INFRAESTATE LIMITED',
    'PM-International India Private Limited',
    'GIFTS OVERSEAS PRIVATE LIMITED',
    'JMK HOLDINGS PRIVATE LIMITED',
    'ACTON REAL ESTATE INDIA PRIVATE LIMITED',
    'AMEREX PRIVATE LIMITED',
    'GROOM REAL ESTATE PRIVATE LIMITED',
    'OYO HOTELS AND HOMES PRIVATE LIMITED',
    'INDIAN INFOSEC CONSORTIUM',
    'CHROMEINFO TECHNOLOGIES PRIVATE LIMITED',
    'EATTREAT MEDIA PRIVATE LIMITED',
    'Sentieo India Private Limited',
    'CoinTribe Technologies Private Limited',
    'Wealth Taxi Technology Private Limited',
    'EMENOX RETAILS PRIVATE LIMITED',
    'K D R ENTERPRISES PRIVATE LIMITED',
    'Arbunize Digital Media Private Limited',
    'STEADCODE INDIA PRIVATE LIMITED',
    'GUEST HOUSER PRIVATE LIMITED',
    'SINDHUDURG RECREATION RESORTS PRIVATE LIMITED',
    'SINDHUDURG HOTEL INDUSTRY PRIVATE LIMITED',
    'OXLAND LOGISTICS PRIVATE LIMITED',
    'OMNISCIENT IT SOLUTIONS PRIVATE LIMITED',
    'FinFabric Software & Services Private Limited',
    'ONille Digital (OPC) Private Limited',
    'BrandMania Communications Private Limited',
    'PRAYAG TRAVEL SERVICES PRIVATE LIMITED',
    'Safety for Sure Taxi Private Limited',
    'SMARTECH ENERGY MANAGEMENT SERVICES PRIVATE LIMITED',
    'ALIPURDUAR TRANSMISSION LIMITED',
    'MAVI BUILDTECH PRIVATE LIMITED',
    'CK BIRLA HEALTHCARE PRIVATE LIMITED',
    'ANPLIFY SERVICES PRIVATE LIMITED',
    'Adroit Global Personnel Services Private Limited',
    'BURMAN HOSPITALITY PRIVATE LIMITED',
    'Taboola India Private Limited',
    'SUPERIOR STRUCTURES PRIVATE LIMITED',
    'DCM SHRIRAM CREDIT AND INVESTMENTS LIMITED',
    'PICKINGO LOGIXPRESS PRIVATE LIMITED',
    'SkyPower Solar Southeast Asia One Private Limited',
    'YCP SOLIDIANCE PRIVATE LIMITED',
    'KAWASAKI ROBOTICS INDIA PRIVATE LIMITED',
    'A. V. B. FINANCE Private LIMITED.',
    'HI-POINT INVESTMENT AND FINANCE PRIVATE LIMITED',
    'INDIGRAM LABS FOUNDATION',
    'VALUE PROLIFIC INVESTMENTS AND CONSULTING PRIVATE LIMITED',
    'JANPATH ESTATES PRIVATE LIMITED',
    'ADISHAKTI LOHA AND ISPAT LIMITED',
    'CHALLENGER GLOBAL MEDICITY PRIVATE LIMITED',
    'AWORKS DESIGN PRIVATE LIMITED',
    'RECRUIT WORLD PRIVATE LIMITED',
    'MSB DEVELOPERS PRIVATE LIMITED',
    'BHOLE BABA INFRASTRUCTURE PRIVATE LIMITED',
    'AMAR UJALA WEB SERVICES PRIVATE LIMITED',
    'TICK SOFTWARES LIMITED',
    'SkillGigs India Private Limited',
    'WHEELERS DETAILER PRIVATE LIMITED',
    'COMPLETE CIRCLE CAPITAL PRIVATE LIMITED',
    'LINK IN REPS PRIVATE LIMITED',
    'RS AUTOMATION SYSTEM PRIVATE LIMITED',
    'INMARSAT INDIA PRIVATE LIMITED',
    'BRM e-Commerce Retail Private Limited',
    'Clean India Ventures Private Limited',
    'PHIL TECHNOLOGIES PRIVATE LIMITED',
    'KROMOZONES SOFTWARE PRIVATE LIMITED',
    'BASHAR TECHNOLOGIES PRIVATE LIMITED',
    'EPM TECHNOLOGY SERVICES PRIVATE LIMITED.',
    'BEAU GLOBAL EXPORTS PRIVATE LIMITED',
    'INDIA INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'Innovari Technologies Private Limited',
    'SYNDACAST INDIA PRIVATE LIMITED',
    'PRIMAN INSTRUMENTS PRIVATE LIMITED',
    'UPPAL HOUSING Private Limited',
    'BONANZA PORTFOLIO LIMITED',
    'HANSUTTAM FINANCE LIMITED',
    'FIRST CIRCLE FINANCIAL SERVICES LIMITED',
    'LYCONET MARKETING INDIA PRIVATE LIMITED',
    'TAISYS INDIA PRIVATE LIMITED',
    'kaapi Solutions India opc Private limited',
    'R L HOSPITALITY SERVICES LIMITED',
    'DIAMOND PISTONS AND RINGS LIMITED',
    'CAPITAL ESTATE MANAGEMENT SERVICES PRIVATE LIMITED',
    'Commnest Technology OPC Private Limited',
    'EXPLORE TRAVELMILES PRIVATE LIMITED',
    'YUVAGRAM ADVISORS PRIVATE LIMITED',
    'BILLERUD INDIA PRIVATE LIMITED',
    'NimblePacc Packaging Private Limited',
    'ALL NEW KHABRI INDIA PRIVATE LIMITED',
    'MAITRI APPARELS PRIVATE LIMITED',
    'REPUTARE COMMUNICATION PRIVATE LIMITED',
    'PRAGMACS MANAGEMENT ADVISORY SERVICES PRIVATE LIMITED',
    'SNS E- BUSINESS SOLUTION PRIVATE LIMITED',
    'BRAVO CREDIT AND HOLDINGS PRIVATE LIMITED',
    'B M INTERNATIONAL PRIVATE LIMITED',
    'BULLET CARGO MOVERS PRIVATE LIMITED',
    'CRITICAL CARE UNIFIED PRIVATE LIMITED',
    'BPL MEDIA LIMITED',
    'CINELINKS SYSTEMS PRIVATE LIMITED',
    'CLASS SALES PRIVATE LIMITED',
    'Pathways Retail Private Limited',
    'SYSCOM CONSUMER PRODUCTS PRIVATE LIMITED',
    'GODOOZY ONLINE SERVICES PRIVATE LIMITED',
    'ESPOIR PLAST INDIA PRIVATE LIMITED',
    'ORTUS POLYMERS PRIVATE LIMITED',
    'A K COOL-X-PACKING PRIVATE LIMITED',
    'FREIGHT PLAN INDIA PRIVATE LIMITED',
    'METRO BRIGHT BAR (INDIA) PRIVATE LIMITED',
    'GHAZIABAD ALLOYS PRIVATE LIMITED',
    'Rellek Metal Service Centre Private Limited',
    'MINDA KOSEI ALUMINUM WHEEL PRIVATE LIMITED',
    'MINDA TG RUBBER PRIVATE LIMITED',
    'LORD KRISHNA FINANCIAL SERVICES LIMITED',
    'HOTWAVE ELECTRONICS PRIVATE LIMITED',
    'CALEX AUTO PRIVATE LIMITED',
    'Minda i Connect Private Limited',
    'Parador Developers (Amritsar) Private Limited',
    'Insta Con RealEstate Private Limited',
    'THUKRAL ELECTRIC BIKES PRIVATE LIMITED',
    'BRISTON TECHNOMACH PRIVATE LIMITED',
    'RAYAN AUTOMOTIVES PRIVATE LIMITED',
    'PRINT POLYMERS PRIVATE LIMITED',
    'COMPOSITE AQUA SYSTEM AND EQUIPMENTS PRIVATE LIMITED',
    'HISUN BUSINESS SOLUTIONS PRIVATE LIMITED',
    'NOVALAC INDUSTRIES PRIVATE LIMITED',
    'SHIVALIK IMPRESSIONS PRIVATE LIMITED',
    'Edupedia Publications Private Limited',
    'VEGATECH INFOSOLUTIONS PRIVATE LIMITED',
    'Wiwigo Technologies Private Limited',
    'Smartsource Global Technologies Private Limited',
    'Quantilus Systems Private Limited',
    'LUMENATIX SOUTH PRIVATE LIMITED',
    'NTC Golden Forwarders Private Limited',
    'LALAJI TRAVELS PRIVATE LIMITED',
    'DORADO LEARNING INDIA PRIVATE LIMITED',
    'CAKEKART TECHNOLOGY RETAIL SERVICES PRIVATE LIMITED',
    'JIT GLOBAL FREIGHT SOLUTIONS PRIVATE LIMITED',
    'THINK BIG SYSTEMS PRIVATE LIMITED',
    'Street Way Holidays Private Limited',
    'Siti Karnal Digital Media Network Private Limited',
    'SITI SAGAR DIGITAL CABLE NETWORK PRIVATELIMITED',
    'MYDEA VENTURES PRIVATE LIMITED',
    'GOLDLINE FINANCE PRIVATE LIMITED',
    'Supreme Housing Finance Limited',
    'CHAR CHINAR DESIGNER SHEETS PRIVATE LIMITED',
    'MAHALUXMI INFRAHOME PRIVATE LIMITED',
    'MUKMA REALTY PRIVATE LIMITED',
    'SSKS POWER PRIVATE LIMITED',
    'ALLURE INFRADEVELOPERS PRIVATE LIMITED',
    'OPSIS PROJECTS INDIA PRIVATE LIMITED',
    'AB MSAI RESEARCH LABS PRIVATE LIMITED',
    'VIDYAMANDIR GLOBAL INSTITUTE PRIVATE LIMITED',
    'LUCRIN INDIA PRIVATE LIMITED',
    'VINAYAK BUILDWELL PRIVATE LIMITED',
    'MORELIFE TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'zOrder Technologies Private Limited',
    'GARVIT DISTRIBUTORS PRIVATE LIMITED',
    'Mind ITSys Private Limited',
    'SHAKTI TIMES PRIVATE LIMITED',
    'KMC Electronics Private Limited',
    'OnionDev Technologies Private Limited',
    'Self Driven Softwares Limited',
    'YERHA ONLINE PRIVATE LIMITED',
    'COSMO RETAILSOLUTION PRIVATE LIMITED',
    'TechSaints International Private Limited',
    'VIDYA MANDIR CLASSES LIMITED',
    'SHAKTI BHOG FOODS LIMITED',
    'LITWEL INDIA LIMITED',
    'DARSHAN FOODS PRIVATE LIMITED.',
    'H B S SYSTEMS PRIVATE LIMITED',
    'BINDU FINANCE AND LEASING PRIVATE LIMITED',
    'AADYA GLOBAL HEALTHCARE PRIVATE LIMITED',
    'AAKRITI CONSULTANTS INDIA PRIVATE LIMITED',
    'ADINATH CONSTRUCTIONS PRIVATE LIMITED',
    'NAINTARA HOSPITALITY PRIVATE LIMITED',
    'NSN TRADING CO PRIVATE LIMITED',
    'JAYANT GRANITES PRIVATE LIMITED',
    'ARYAVART TRANSPORT COMPANY PRIVATE LIMITED',
    'Mobi NxtGen Solutions Private Limited',
    'zCore Technologies Private Limited',
    'PAPAYAMOBILE (INDIA) PRIVATE LIMITED',
    'BEEKASH PAYMENT SYSTEM PRIVATE LIMITED',
    'AIRMESH PRIVATE LIMITED',
    'PRACTICAL ACTION FOUNDATION',
    'INDOGULF CROPSCIENCES LIMITED',
    'VIDHU FINANCE AND LEASING LIMITED',
    'PRATYANCHA FINANCIAL SERVICES LIMITED',
    'ANDRU INDUSTRIES PRIVATE LIMITED',
    'MOMENTZ PRIVATE LIMITED',
    'FONDELCO METAL & ALLOYS PRIVATE LIMITED',
    'CLUB SOFITEL INN AND SUITES PRIVATE LIMITED',
    'MARC INDIA LIMITED',
    'AMSYS IT SERVICES PRIVATE LIMITED',
    'DUNEX LIFECARE PRIVATE LIMITED',
    'EPIXEL SOFTWARE PRIVATE LIMITED',
    'SAURJA SOLAR ENERGY PRIVATE LIMITED',
    'HAREON SOLAR INDIA PRIVATE LIMITED',
    'LOTUS VALLEY TECHNOLOGIES PRIVATE LIMITED',
    'AVENUE MONTAIGNE INDIA PRIVATE LIMITED',
    'HAREON DALMIA SOLAR PRIVATE LIMITED',
    'Rapidmile Business Solutions Private Limited',
    'GURU NETWORK PRIVATE LIMITED',
    'HYPERFLUX SOLUTIONS PRIVATE LIMITED',
    'DROOP ENTERPRISES PRIVATE LIMITED',
    'KY APPARELS PRIVATE LIMITED',
    'MOMENTUM INDIA PRIVATE LIMITED',
    'AMANDEEP JOHL GOLF ACADEMY PRIVATE LIMITED',
    'COLLECTIVE ART PRIVATE LIMITED',
    'Big Bad Wolf Entertainment Private Limited',
    'Purple Seas Sports and Technology Private Limited',
    'KONSULT APP PRIVATE LIMITED',
    'KAMLESH OVERSEAS PRIVATE LIMITED',
    'PJVS EDU VENTURES INDIA PRIVATE LIMITED',
    'RESPONSIBLE BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'HEADING WEDDING EVENTS PRIVATE LIMITED',
    'CITIZENS VENTURES FOR SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'DEZINEDISPLAY SOLUTIONS PRIVATE LIMITED',
    'Technicolour Dream Pants Private Limited',
    'Sixth Sense Enterprises OPC Private Limited',
    'SS Airlinkers OPC Private Limited',
    'Fitciti Technology Private Limited',
    'Morelle Management Private Limited',
    'PARAHOME CARE PRIVATE LIMITED',
    'CREDENT GLOBAL FINANCE LIMITED',
    'ALCHEMIST CAREER ENHANCEMENT PRIVATE LIMITED',
    'QVC FOODS PRIVATE LIMITED',
    'VARK SNACK FOOD PRIVATE LIMITED',
    'GRAFFITI NATURALS PRIVATE LIMITED',
    'MAKERS ASYLUM FOUNDATION',
    'Etrain Education Private Limited',
    'EBIX SMARTCLASS EDUCATIONAL SERVICES PRIVATE LIMITED',
    'KSP GLOBAL PRIVATE LIMITED',
    'BERSAVI INDIA PRIVATE LIMITED',
    'SANAV CREATIONS PRIVATE LIMITED',
    'EPIC BRANDS PRIVATE LIMITED',
    'AA BRANDS PRIVATE LIMITED',
    'GRAZIE ADVERTISING PRIVATE LIMITED',
    'ADVANCE BIOTECH SOLUTIONS INDIA PRIVATE LIMITED',
    'H&A PLAST (INDIA) PRIVATE LIMITED',
    'XPONENTS VENTURES PRIVATE LIMITED',
    'CHHABRA INFRADEVELOPERS INDIA PRIVATE LIMITED',
    'ESSAI SOLUTIONS PRIVATE LIMITED',
    'Fortis CSR Foundation',
    'RIOT LABZ PRIVATE LIMITED',
    'GLOBAL AIRFILTER INDIA PRIVATE LIMITED',
    'Gallant Social Development and Meditation Foundation',
    'G.T. MAGNETICS PRIVATE LIMITED',
    'TNST Component India Private Limited',
    'Smart Power for Rural Development India Foundation',
    'Lenswire Innovations Private Limited',
    'Center For Caregiver Training & Development',
    'PERNOD RICARD INDIA FOUNDATION',
    'PROSOURCE INDUSTRIES PRIVATE LIMITED',
    'ECOLOGIC POWER DEVELOPMENT PRIVATE LIMITED',
    'ReNew Wind Energy (MP Four) Private Limited',
    'ReNew Solar Energy (Telangana) Private Limited',
    'ALL INDIA MINORITIES COUNCIL',
    'KANAKBEN FOUNDATION',
    '3R MANAGEMENT LIMITED',
    'Playnlive Sports India Private Limited',
    'Its All About People Consulting OPC Private Limited',
    'AASHIRWAD PASHU AND PAKSHI SANSTHAN',
    'GLOBAL PRO SPORT DEVELOPMENT OPC PRIVATE LIMITED',
    'DE WELL AGENCIES INDIA PRIVATE LIMITED',
    'Sereno Facility Management Private Limited',
    'IMPETUS ENGINEERS PROJECTS PRIVATE LIMITED',
    'JINDAL INDIA RENEWABLE ENERGY LIMITED',
    'SKYLARK STRUCTURES AND ENGINEERING PRIVATE LIMITED',
    'RCM PREFABS PRIVATE LIMITED',
    'BRAND GALLERY PRIVATE LIMITED',
    'SKYTECH BUILDWELL PRIVATE LIMITED',
    'Albross India Private Limited',
    'APAC SPCLTY LABS PRIVATE LIMITED',
    'Haiyya Foundation',
    'FUTURE ZIPPERS PRIVATE LIMITED',
    'Gateway Sourcing Private Limited',
    'RDS PROJECT LIMITED',
    'GET STITCHED INDIA OPC PRIVATE LIMITED',
    'Arvana Sourcing and Services Private Limited',
    'ASCLEPIUS WELLNESS PRIVATE LIMITED',
    'RAHULGAMA EXPORTS (OPC) PRIVATE LIMITED',
    'S G INTERIORS PRIVATE LIMITED',
    'ReNew Wind Energy (AP Five) Private Limited',
    'ReNew Wind Energy (MP Three) Private Limited',
    'ReNew Wind Energy (Rajasthan Four) Private Limited',
    'PLAY HARD PRODUCTIONS OPC PRIVATE LIMITED',
    'DSM FRESH FOODS PRIVATE LIMITED',
    'K2 INFRAGEN LIMITED',
    'ReNew Clean Energy Private Limited',
    'ReNew Saur Urja Private Limited',
    'VOGUE TEXTILES LIMITED',
    'Synerzez Solutions Private Limited',
    'VOGUE CORPORATION LIMITED',
    'TMA EXIM PRIVATE LIMITED',
    'AADE TRANS LOGISTICS PRIVATE LIMITED',
    'OSMAK PROJECTS (INDIA) PRIVATE LIMITED',
    'TRIPMONEY FINTECH SOLUTIONS PRIVATE LIMITED',
    'WORLD ETCHING PREMIUM PRIVATE LIMITED',
    'DELHI PAPER PRODUCTS COMPANY PRIVATE LIMITED',
    'NextGen In-Vitro Diagnostics Private Limited',
    'OCEAN CONTAINER LINES PRIVATE LIMITED',
    'K.HARI TRADING PRIVATE LIMITED',
    'SAKAR XCLUSIVES (OPC) PRIVATE LIMITED',
    'CONSULT TECHNIQUES (INDIA) PRIVATE LIMITED',
    'Zufolo Designs Private Limited',
    'ARIES MEDTEK Private Limited',
    'HAIR MASTERS SALON PRIVATE LIMITED',
    'SOFT ARK RESOURCES PRIVATE LIMITED',
    'SourceLead Consultancy Private Limited',
    'VertexOne Process Solutions Private Limited',
    'DHAI STEP MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'BENISON CONSULTING PRIVATE LIMITED',
    'OSRA ENGINEERS PRIVATE LIMITED',
    'LUMAN INDIA PRIVATE LIMITED',
    'NA INVESTMENTS PRIVATE LIMITED',
    'New Age Consumer Services Private Limited',
    'MURTI SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'VERTICAL RECRUITERS PRIVATE LIMITED',
    'Countrywide Events Private Limited',
    'Team Invictus Services Private Limited',
    'VIRMANI BROTHERS PRIVATE LIMITED',
    'RALCO TYRES PRIVATE LIMITED',
    'ZEW TELECOM PRIVATE LIMITED',
    'MEC BEARINGS PRIVATE LIMITED',
    'OFL SECURITIES LIMITED',
    'SUNTRONICS ELECTRONICS INDIA LIMITED',
    'SNOWLION EXPEDITION PRIVATE LIMITED',
    'BALI HOMES PRIVATE LIMITED',
    'APOGEE INVESTMENTS PRIVATE LIMITED',
    'HERCULES HEALTHCARE PRODUCTS PRIVATE LIMITED',
    'XOOGLE GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'OZONE PHARMACEUTICALS LIMITED',
    'CRUSTACE SEAFOOD PRIVATE LIMITED',
    'Indent Online Supplies Private Limited',
    'STERLITE POWER TRANSMISSION LIMITED',
    'SILVASSA CRICKET LEAGUE',
    'NMDC STEEL LIMITED',
    'MUKUND COAL FIELDS PRIVATE LIMITED',
    'Together Global Ventures Limited',
    'ASHIAN E COMMERCE PRIVATE LIMITED',
    'IAN MARTIN CONSULTING PRIVATE LIMITED',
    'SPREADING HAPPINESS INDIYA FOUNDATION',
    'NAV LABELS PRIVATE LIMITED',
    'VINAYAK OUTSOURCING SERVICES PRIVATE LIMITED',
    'GREEN NETWORK TELECOM PRIVATE LIMITED',
    'RECTUSNET INFO SYSTEM PRIVATE LIMITED (OPC)',
    'DESIGN CONCEPT ENTERPRISES PRIVATE LIMITED',
    'FRONTIER PEST CONTROL LIMITED',
    'RSR RETAIL PRIVATE LIMITED',
    'Premium Plots Developers Private Limited',
    'EWALT TECHNOLOGIES PRIVATE LIMITED',
    'SIXWEBSOFT TECHNOLOGY PRIVATE LIMITED',
    'NRI CITY DEVELOPERS PRIVATE LIMITED',
    'LAMPADAIRE ENGINEERING & INFRASTRUCTURE PRIVATE LIMITED',
    'Govindam Infosoft Private Limited',
    'PML HOLIDAYS PRIVATE LIMITED',
    'EQUAL INDIA FOUNDATION',
    'FRANCO FOUNDATION',
    'UBBER BUILDTECH PRIVATE LIMITED',
    'Tech Connect Foundation',
    'Park Medicity (North) Private Limited',
    'UniEarth Earthing Solutions Private Limited',
    'GAUDIUM IVF AND WOMEN HEALTH PRIVATE LIMITED',
    'WEBOMAZE TECHNOLOGIES PRIVATE LIMITED',
    'Jacob & Smooth IT Management Services Private Limited',
    'CREW 4 EVENTS GLOBAL PRIVATE LIMITED',
    'GKC Consultants OPC Private Limited',
    'BP PUMPS PRIVATE LIMITED',
    'RWEALTH PRIVATE LIMITED',
    'Terma (India) Private Limited',
    'NECTAR INFOTEL SOLUTIONS PRIVATE LIMITED',
    'Raipur Cricket League',
    'TORAINSE LIFE CARE PRIVATE LIMITED',
    'Edurev Solutions Private Limited',
    'Benhadded Pharma Private Limited',
    'UFV INDIA GLOBAL EDUCATION',
    'NEXAMO TECHNOPLAST PRIVATE LIMITED',
    'RAJA SALH CINEMAS PVT LTD',
    'TITTAR LODGE PRODUCTIONS PRIVATE LIMITED',
    'BLOCKBUSTER MOVIESSS PRIVATE LIMITED',
    'Saatvik Green Energy Private Limited',
    'GLOBSOL INFRASTRUCTURE PRIVATE LIMITED',
    'A & T TRADERS PRIVATE LIMITED',
    'TECHGRACE SOLUTIONS PRIVATE LIMITED',
    'SHIVANI INFRATECH PRIVATE LIMITED',
    'SADASHIV CAPITAL SERVICES PRIVATE LIMITED',
    'DEKHO SEEKHO E-LEARNING SOLUTIONS PRIVATE LIMITED',
    'Skypike eSolutions Private Limited',
    'KANHAIYAGANJ JHULA CLUSTER PRIVATE LIMITED',
    'ENAVIYA FOOD & BEVERAGE PRIVATE LIMITED',
    'NY SOFTECH INDIA PRIVATE LIMITED',
    'AKAKTELECOM (OPC) PRIVATE LIMITED',
    'PASSARY MINERALS MADHYA PRIVATE LIMITED',
    'WOODKART HANDICRAFTS PRIVATE LIMITED',
    'CCM METAL TECH PRIVATE LIMITED',
    'SCIKNOW TECHNO SOLUTIONS LIMITED',
    'XORO GLOBAL PRIVATE LIMITED',
    'PGS ENERGY SERVICES PRIVATE LIMITED',
    'AEREN IP SERVICES PRIVATE LIMITED',
    'REDBRICK ASHRAY PRIVATE LIMITED',
    'COME AND GAIN FIRST STEP EDUCATION PRIVATE LIMITED',
    'Cintra Software Private Limited',
    'CREDENCE MEDICURE PRIVATE LIMITED',
    'Brickacres Intermediary Services Private Limited',
    'ARCADE INFOTECH PRIVATE LIMITED (OPC)',
    'ADWAIT BUSINESS CONSULTANCY DEVELOPMENT PRIVATE LIMITED',
    'MATRITAW BHAWANI SERVICES PRIVATE LIMITED',
    'CONSAGOUS TECHNOLOGIES PRIVATE LIMITED',
    'KRITI AUTO & ENGINEERING PLASTICS PRIVATE LIMITED',
    'ADVANZ 101 SYSTEMS PRIVATE LIMITED',
    'VEDAM DESIGN & TECHNICAL CONSULTANCY PRIVATE LIMITED',
    'E HEREX TECHNOLOGIES PRIVATE LIMITED',
    'BOMAR-INDOTECH PRIVATE LIMITED',
    'CRAFSOL TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'SAMPRATI PROPERTIES PRIVATE LIMITED',
    'RYDER TRANS INTERNATIONAL PRIVATE LIMITED',
    'AAKAR HOLDINGS PRIVATE LIMITED',
    'KODIXODEL PRIVATE LIMITED',
    'MAYVIL SERVICES PRIVATE LIMITED',
    'BHATIA OSL WASHERIES & MINERALS LIMITED',
    'AEC.COM PRIVATE LIMITED',
    'BRILLIANT FOUNDATION',
    'KETI BUILDCON PRIVATE LIMITED',
    'BHATIA SONS (INDIA) LIMITED',
    'Saksham Outreach Private Limited',
    'PLAY SCAPE SOLUTIONS PRIVATE LIMITED',
    'PG Tech Private Limited',
    'KALYAN MARBLE AND GRANITE LIMITED',
    'PRAGAT AKSHAY URJA LIMITED',
    'AQUARIUS PROMOTIONS PRIVATE LIMITED',
    'ACCRUAL REALITIES PRIVATE LIMITED',
    'Athena Abroad Consultants Private Limited',
    'SNAP COMPUTER SYSTEMS PRIVATE LIMITED',
    'SAISHAKTI REALTIES PRIVATE LIMITED',
    'INTERFACE TELE COMMUNICATION PRIVATE LIMITED',
    'DANOBAT-INDOTECH ( INDIA ) PRIVATE LIMITED',
    'VEDAANT (INDIA) EDUCATION PRIVATE LIMITED',
    'ACE ENGINEERINGS & CHEMICALS Private LIMITED',
    'APOORV ELECTRICALS (INDIA) PRIVATE LIMITED',
    't4 TEXULTANTS PRIVATE LIMITED',
    'KUSHWAH AND KUSHWAH PROJECT MANAGEMENT COSULTANTS PRIVATE LIMITED',
    'TIARA INFRASTRUCTURE PRIVATE LIMITED',
    'V GROUP CONSULTANCY SERVICES PRIVATE LIMITED',
    'ANK ENGINEERS PRIVATE LIMITED',
    'MP Online Limited',
    'SAHARA ROAD LINES PRIVATE LIMITED',
    'SCIENTE CONSULTING PRIVATE LIMITED',
    'SHREE TIRUPATI BALAJEE FIBC LIMITED',
    'VARDAAN BIOTECH LIMITED',
    'Samyak Finstock Private Limited',
    'TRENDS APPAREL PRIVATE LIMITED',
    'SAGAR SOLUTIONS PRIVATE LIMITED',
    'ARTH CITY PRIVATE LIMITED',
    'Kohli Sales and Services Private Limited',
    'SATISH SALUJA POWER SOLUTIONS PRIVATE LIMITED',
    'S.S. IMEX PRIVATE LIMITED',
    'KRASOMA BIOCHEM PRIVATE LIMITED',
    'JSC TECHNOCORP PRIVATE LIMITED',
    'PREM TEXTILES (INTERNATIONAL) Private LIMITED',
    'DILIP MASS COMMUNICATION PRIVATE LIMITED',
    'MA BHAGWATI POWER LIMITED',
    'MY FONE TELESERVICES PRIVATE LIMITED',
    'SUNDARAM PACKAGING INDIA PRIVATE LIMITED',
    'KRISHNA BELTS PRIVATE LIMITED',
    'INDO THAI WEALTH MANAGEMENT PRIVATE LIMITED',
    'AFFINE FORMULATIONS LIMITED',
    'ARISTO TOURS PRIVATE LIMITED',
    'CHESHTA INFO-TECH PRIVATE LIMITED',
    'NARAYANAN BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'NENOSYSTEMS CONSULTING SERVICES PRIVATE LIMITED',
    'SUPER FORMULATIONS PRIVATE LIMITED',
    'PEGASUS LOGISTICS PRIVATE LIMITED',
    'MADHYA PRADESH ROAD DEVELOPMENT CORPORATION LIMITED',
    'KHYATI FOODS PRIVATE LIMITED',
    'SAMHITA COMMUNITY DEVELOPMENT SERVICES',
    'Health Care Medical Devices Private Limited',
    'VIJAYSHRI STATIONERY PRODUCTS PRIVATE LIMITED',
    'SAHEB INFRASTRUCTURE PRIVATE LIMITED',
    'Adhunik Tradewell Private Limited',
    'ANAND JEWELS (INDORE) PRIVATE LIMITED',
    'NORTH RAJASTHAN HOLDINGS PRIVATE LIMITED',
    'VINDHYA ERECTORS PRIVATE LIMITED',
    'ABHIJAT INVESTMENT PRIVATE LIMITED',
    'VINAYAKA AUTOMOBILES(GWALIOR) PRIVATE LIMITED',
    'JETWAVE SOLUTIONS PRIVATE LIMITED',
    'Hindustan Engineering Private Limited',
    'Bhatia Coal Washeries Limited',
    'AQUA TERRA COKE & ENERGY LIMITED',
    'TRANSVICK INDUSTRIES PRIVATE LIMITED',
    'SAMYAK RESOURCES PRIVATE LIMITED',
    'PARAGON WATER TECHNOLOGIES PRIVATE LIMITED',
    'B K AGRAWAL WAREHOUSE AND INGREDIENTS PRIVATE LIMITED',
    'NICT TECHNOLOGIES PRIVATE LIMITED',
    'S D BANSAL IRON AND STEEL PRIVATE LIMITED',
    'S.S. NIRMAN PRIVATE LIMITED',
    'VIRTUAL INFRASTRUCTURE PRIVATE LIMITED',
    'BALAJIDHAM CONSTRUCTION PVT LTD',
    'SHIVAJI INFRASTRUCTURE SERVICES PRIVATE LIMITED',
    'INDO-EUROPEAN CHAMBER OF COMMERCE AND INDUSTRY',
    'GARLE IMPEX PRIVATE LIMITED',
    'SHOBHAN ENTERPRISES PRIVATE LIMITED',
    'INTELLICUS TECHNOLOGIES PRIVATE LIMITED',
    'DOUCEUR BIO-TECH PRIVATE LIMITED',
    'AMRIT PAPERS PRIVATE LIMITED',
    'ADITI ENTERPRISES PVT LTD',
    'EMLINK TECHNOLOGIES PRIVATE LIMITED',
    'SAGITTARIUS SECURITIES AND FINANCE LIMITED',
    'MB Power (Madhya Pradesh) Limited',
    'SR Cable TV Private Limited.',
    'SHIV SAI WAREHOUSING PRIVATE LIMITED',
    'PULSE DEVELOPMENT ASSOCIATION OF INDIA',
    'GROW SAFE CHEMICALS PRIVATE LIMITED',
    'Scorpio Informatics Private Limited',
    'COZY COMFORTS PRIVATE LIMITED',
    'APPALTO ELECTRONICS PRIVATE LIMITED',
    'MAVENMAGNET RESEARCH PRIVATE LIMITED',
    'DIGITEC ENGINEERS AND COMPUTECH PRIVATE LIMITED',
    'SAIKRUPA FINLEASE PRIVATE LIMITED',
    'ARPIT PLASTICS PRIVATE LIMITED',
    'VIPRO EXIM PRIVATE LIMITED',
    'RAGHUNANDAN INDUSTRIES PRIVATE LIMITED',
    'A JAETAL FOOD AND CHEMICALS LIMITED',
    'HORIZON PROJECTS (INDORE) PRIVATE LIMITED',
    'D.J.LABORATORIES PRIVATE LIMITED',
    'UJAAS ENERGY LIMITED',
    'SANIRA MARKETING PRIVATE LIMITED',
    'HARSHVARDHANS LABORATORIES PRIVATE LIMITED',
    'APPEX COTTON AGENCY (INDIA) PRIVATE LIMITED',
    'SINDH FOOTWEAR PRIVATE LIMITED',
    'SHREE PARAG EDIBLE OIL MILLS PRIVATE LIMITED',
    'PUNJAB RETAIL PRIVATE LIMITED',
    'JAI KISAN AGRI SOLUTION PRIVATE LIMITED',
    'SWADHYAYA PRINTERS PRIVATE LIMITED',
    'WESTERN REMEDIES PRIVATE LIMITED',
    'SANT RAVIDAS MADHYA PRADESH HASTASHILP EVAM HATHKARGHA VIKAS NIGAM LIMITED',
    'MALWA OXYGEN & INDUSTRIAL GASES PRIVATE LIMITED',
    'C-NET INFOTECH PRIVATE LIMITED',
    'SHIVANO ORGANICS Private Limited',
    'AGRO SOLVENT PRODUCTS PVT LTD',
    'KHAITAN CHEMICALS AND FERTILIZERS LIMITED',
    'RUPAK ENTERPRISES PRIVATE LIMITED',
    'SHREENATH TEXTILES PVT LTD',
    'PRESTIGE FABRICATORS PVT LTD',
    'RATNA BUILDERS PVT LTD',
    'T R KHANDELWAL ENTERPRISES PVT LTD',
    'UNIVERSAL MAGNOFLUX PVT LTD',
    'MITTAL COLD STORAGE PVT LTD',
    'MARBLECITY HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'VASUDHA SECURITY AND SERVICES PRIVATE LIMITED',
    'Flavorite Technologies Private Limited',
    'WWS SKYSHOP PRIVATE LIMITED',
    'ASIAN NATURAL RESOURCES (INDIA) LIMITED',
    'HOTMELT PACKAGING PRIVATE LIMITED',
    'SUN CYBER TECHNOLOGIES LIMITED',
    'CALTEC HOTELS & RESORTS PRIVATE LIMITED',
    'MADHYA PRADESH STATE ELECTRONICS DEVELOPMENT CORPORATION LTD',
    'RANEKA INDUSTRIES LIMITED',
    'RVS COLD STORAGE PRIVATE LIMITED',
    'VINDHYACHAL DISTILLERIES PRIVATE LIMITED',
    'BYTE PERIPHERAL SYSTEMS PRIVATE LIMITED',
    'CROWN HOTEL PVT.LTD.',
    'VISCUS INFOTECH LIMITED',
    'Panasia Herbal Private Limited',
    'STI INDIA LIMITED',
    'APOLLO CREATIONS PVT LTD',
    'PraGlo Enterprises Private Limited',
    'RAASHI AUTO CARE PRIVATE LIMITED',
    'AAR KAY AUTOMOTIVES PVT LTD',
    'MANTRI LEASING AND FINANCE PVT LTD',
    'A.I.AUTOMATION PRIVATE LIMITED',
    'Patamin Investments Private Limited',
    'SARVODAYA BUSINESS SOLUTIONS LIMITED',
    'MALWA WIRES PVT LTD',
    'KUBER LIGHTING PRIVATE LTD.',
    'SWADESH PRAKASHAN GWALIOR PVT LTD',
    'INVEN PHARMACEUTICALS PRIVATE LIMITED',
    'SWADESH PRINTERS GWALIOR PVT LTD',
    'BIDASARIA MILLS PRIVATE LIMITED',
    'SONIC ELECTROCHEM Private Limited',
    'AGRAWAL INDOTEX LIMITED',
    'AARTECH SOLONICS LIMITED',
    'WINTECH TAPARIA LIMITED',
    'GK CHEMICALS AND FERTILIZERS LIMITED',
    'TENCO SYSTEMS & SWITCH GEARS PVT LTD.,',
    'SIDHARTH DRILLERS PRIVATE LIMITED',
    'VISCUS OILS PRIVATE LIMITED',
    'OMEGA INDUSTRIES PVT LTD',
    'VINDHYA TELELINKS LIMITED',
    'SHREE CHLORATES PRIVATE LIMITED',
    'PTPL Tubing & Products Private Limited',
    'NASK CONSULTANTS PRIVATE LIMITED',
    'M.M. METALS PRIVATE LIMITED',
    'MAHLE Engine Components India Private Limited',
    'MEDICAPS LIMITED',
    'Q1 INFRATECH PRIVATE LIMITED',
    'SAPCON INSTRUMENTS PRIVATE LIMITED',
    'INSPROS ENGINEERS PVT LTD',
    'DEWAS SOYA LIMITED',
    'DEWAS HYDROQUIP PVT LTD',
    'Hemang Resources Limited',
    'OSWAL COMPUTERS & CONSULTANTS PVT LTD',
    'PANJON LIMITED',
    'T.K.ESTATES PVT LTD',
    'SEASON CHEMICALS PVT LTD',
    'KALYAN NAV NIRMAN LIMITED',
    'BUDHRATNA FILMS PRIVATE LIMITED',
    'CANARY FINVEST PVT LTD',
    'INDRA INDUSTRIES LIMITED',
    'JAKHETIA BUILDERS AND DEVELOPERS PVT LTD',
    'VRONE RETAIL PRIVATE LIMITED',
    'SIMRAN FARMS LIMITED',
    'UNNAYAN BHARAT FINANCE CORPORATION PRIVATE LIMITED',
    'GEI INDUSTRIAL SYSTEMS LIMITED',
    'META TUBEX PVT LTD',
    'SUKHCHAIN HIRE PURCHASE PRIVATE LIMITED',
    'COMMERCIAL SYN BAGS LIMITED',
    'SANCHI YANTRA UDYOG PVT LTD',
    'TURAKHIYA METALS PRIVATE LIMITED',
    'SATISFACTION PRODUCTS Private LIMITED',
    'PRIMO PICK N. PACK Private Limited',
    'AD- MANUM FINANCE LIMITED',
    'WAIDHAN ENGINEERING & INDUSTRIES PVT LTD',
    'KOHINOOR ELASTICS PVT LTD',
    'RAMNAD RENEWABLE ENERGY LIMITED',
    'TENDRIL CONCEPTS PRIVATE LIMITED',
    'Vuvuzela Retail Private Limited',
    'CredenceIS Computing Private Limited',
    'CEA Infotech Private Limited',
    'ADITI TECH CONSULTING PRIVATE LIMITED',
    'MACTION CONSULTING PRIVATE LIMITED',
    'KINGSMAN SOLUTION PRIVATE LIMITED',
    'FINWIZARD TECHNOLOGY PRIVATE LIMITED',
    'FIRST FUTURISTIC SHARED SERVICES PRIVATE LIMITED',
    'CARBON INITIATIVE FORUM',
    'IGNEEVA ADVANCED TECHNOLOGIES PRIVATE LIMITED',
    'FoodyBuddy Applications Private Limited',
    'TATVAM ANALYTICS PRIVATE LIMITED',
    'TECH-TAILOR SOLUTIONS PRIVATE LIMITED',
    'InstaKart Services Private Limited',
    'ECOEARTH ELECTRIC PRIVATE LIMITED',
    'OZIEL PHARMACEUTICALS PRIVATE LIMITED',
    'DIGITAL INTEGRATOR PRIVATE LIMITED',
    'CRISP INFOCARE PRIVATE LIMITED',
    'CAPRICORN IDENTITY SERVICES PRIVATE LIMITED',
    '3SINS TECHNOLOGIES PRIVATE LIMITED',
    'Shriya Industrial Consultants Private Limited',
    'BERRYKEM INDIA PRIVATE LIMITED',
    'Izwe Warehouse Management Solutions India Private Limited',
    'SANGOPAN TENDERCARE SERVICES PRIVATE LIMITED',
    'RISKALIBRATE CONSULTANCY PRIVATE LIMITED (OPC)',
    'ZINNOX BUSINESS AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'BrandAcc Services Private Limited',
    'INDELOX TECHNOLOGIES PRIVATE LIMITED',
    'DRAPER STARTUP HOUSE PRIVATE LIMITED',
    'Designjuice MarCom Private Limited',
    'Krayonik Digital Media Private Limited',
    'SEMINA AGRO PRIVATE LIMITED',
    'GaragePreneurs Internet Private Limited',
    'INFRASUPPORT PROJECTS PRIVATE LIMITED',
    'World Alumni Network Private Limited',
    'VITASTAA ONLINE SERVICES PRIVATE LIMITED',
    'Encore Heavy MAchinery Private Limited',
    'ChatPay Commerce Private Limited',
    'Lyrus Life Sciences Private Limited',
    'AKOSA VENTURES PRIVATE LIMITED',
    'KARUNANILAYA HOME NIVAS PRIVATE LIMITED',
    'MANRIT REALTY & INFRASTRUCTURE PRIVATE LIMITED',
    'Find Interactive Studios Private Limited',
    'ELITIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Amigobulls Fintech Services Private Limited',
    'Zenefits Technologies India Private Limited',
    'AKRITY COMPUTING PRIVATE LIMITED',
    'Neural Systems CoEdge Private Limited',
    'MONOLINE TECHNOLOGY AND SERVICES PRIVATE LIMITED',
    'AKRIVEIA TECHNOLOGIES PRIVATE LIMITED',
    'AppTad TECHNOLOGIES PRIVATE LIMITED',
    'INVENZO LABS INDIA PRIVATE LIMITED',
    'ALCORD INFO SOLUTIONS PRIVATE LIMITED',
    'ipassio E-learning Technologies Private Limited',
    'SinColas E-commerce Private Limited',
    'TERRA ROCK PRODUCTS PRIVATE LIMITED',
    'AEROTEK SIKA AVIOSYSTEMS PRIVATE LIMITED',
    'MAYON INFRA PROJECT PRIVATE LIMITED',
    'TEAM-TECH ENGINEERING PRIVATE LIMITED',
    'Evolution Culinary Private Limited',
    'ROCKETIUM.COM TECHNOLOGIES PRIVATE LIMITED',
    'Tembo Systems India Private Limited',
    'NASHTRONICS TRADING PRIVATE LIMITED',
    'FIRST FUTURISTIC INFRA PRIVATE LIMITED',
    'BIZMOBILE IT SOLUTIONS PRIVATE LIMITED',
    'WORLDWIDE AUTOMOTIVE WORKS PRIVATE LIMITED',
    'RUNSHENG TECHNOLOGIES PRIVATE LIMITED',
    'LorryZone Technologies Private Limited',
    'MORPHEDO TECHNOLOGIES PRIVATE LIMITED',
    'EMBASSY INTERIORS PRIVATE LIMITED',
    'MIEONE HOLDINGS PRIVATE LIMITED',
    'ADD-ELCINA ELECTRONICS PARK PRIVATE LIMITED',
    'Neva Power Private Limited',
    'WiMera Systems Private Limited',
    'Retigence Technologies Private Limited',
    'CEFEM-TECH CSE INDIA PRIVATE LIMITED',
    'ARIZEST PHARMA (INDIA) PRIVATE LIMITED',
    'ZAVASI TECHNOLOGIES PRIVATE LIMITED',
    'TURTLEDOVE DESIGN STUDIO PRIVATE LIMITED',
    'VIBGYOR MINERALS PRIVATE LIMITED',
    'Trutrade Foods Private Limited',
    'GROWTHBEATS TECHNOLOGIES PRIVATE LIMITED',
    'VOILA SCIENTIFIC NEEDS PRIVATE LIMITED',
    'KARSUNINDIA SOLUTIONS PRIVATE LIMITED',
    'InnovationBees Technologies Private Limited',
    'CIALFO SOLUTIONS PRIVATE LIMITED',
    'GLODESI TECHNOLOGIES PRIVATE LIMITED',
    'Tripeasel Technologies Private Limited',
    'Velankani Electronics Private Limited',
    'White Matter Advisory India Private Limited',
    'Thoughtscrest Software Private Limited (OPC)',
    'GyanLakshmi Innovations Private Limited (OPC)',
    'BLOOMBABY PRODUCTS PRIVATE LIMITED',
    'NORDEX INDIA PRIVATE LIMITED',
    'SAMYAMA JYOTHI SOLAR ENERGY PRIVATE LIMITED',
    'SPRNG TRANSFORM SUN ENERGY PRIVATE LIMITED',
    'ELEVATI INFOTECH PRIVATE LIMITED',
    'WEBTONIC TECHNOLOGIES PRIVATE LIMITED',
    'PERCH VALUQO PRIVATE LIMITED',
    'H. Craft Fine Jewellery Private Limited',
    'EDA AUSTRALASIA INDIA PRIVATE LIMITED',
    'TWIN STAR DISPLAY TECHNOLOGIES LIMITED',
    'MPTA Skill Training Foundation',
    'RVP AGRO FERT INDUSTRIES PRIVATE LIMITED',
    'Geecon Technology Private Limited',
    'BUZZ BAZZAR TRADING PRIVATE LIMITED',
    'ENRICH LAND VENTURES PRIVATE LIMITED',
    'Pranay Home Creators Private Limited',
    'VDS INFOTECH PRIVATE LIMITED',
    'Nimay Engineering Private Limited',
    'UTPL Corporate Trustees Private Limited',
    'K11 Education Private Limited',
    'Aurangabad Silk and Hamroo Cluster',
    'ASSOCIATED BEVERAGES PVT LTD',
    'DEVELOPMENT INVESTORS LTD',
    'NORTH EASTERN ELECTRIC POWER CORPN LTD',
    'KAY BEE BIO-ORGANICS PRIVATE LIMITED',
    'COLORTEK (MEGHALAYA) PRIVATE LIMITED',
    'Intellect Infotrade Private Limited',
    'B4U Media Ventures Private Limited',
    'VAAYU ENERGY LIMITED',
    'BRAHM INDIA PRIVATE LIMITED',
    'SONAPUR HERBAL CENTRE PRIVATE LIMITED',
    'ADHUNIK MEGHALAYA STEELS PRIVATE LIMITED',
    'J K AVTAR INDUSTRIES (I) LIMITED',
    'NORTH EAST POWERLINE EQUIPMENTS PRIVATE LIMITED',
    'RIBHOI ENGINEERING COMPANY PRIVATE LIMITED',
    'STAR CEMENT LIMITED',
    'ASPECT ENTERPRISES PRIVATE LIMITED',
    'UTKARSH TREXIM PRIVATE LIMITED',
    'HILLS CEMENT COMPANY LIMITED',
    'JAINTIA COKE PRIVATE LIMITED',
    'MEGHALAYA BITCHEM PRIVATE LIMITED',
    'Zupreme Nutrisciences Private Limited',
    'JUMPER AI PRIVATE LIMITED',
    'CBLPRO ESOLUTIONS PRIVATE LIMITED',
    'ASR TOOLINGS PRIVATE LIMITED',
    'BRANDSTROLLER ECOMMERCE PRIVATE LIMITED',
    'Teknos Coatings and Paints Private Limited',
    'H M HOLDINGS PRIVATE LIMITED',
    'STAR CEMENT MEGHALAYA LIMITED',
    'CHILLIBREEZE SOLUTIONS PRIVATE LIMITED',
    'MAXIM ESTATES INTERNATIONAL PRIVATE LIMITED',
    'NILANCHAAL CEMENT PRIVATE LIMITED',
    'UD MINING & NETWORK SERVICES PRIVATE LIMITED',
    'Kausthubha Minerals Private Limited',
    'MEGHABOND CEMENTS LIMITED',
    'COSMOS CEMENTS LIMITED',
    'SUTNGA MINES PRIVATE LIMITED',
    'CMJ BREWERIES PRIVATE LIMITED',
    'AURA HOTELS & RESORTS PRIVATE LIMITED',
    'Divyansh Powergen Private Limited',
    'DIVYANSH HOTEL AND RESORT PRIVATE LIMITED',
    'NORTH EASTERN INFORMATION TECHNOLOGY CONSULTANCY SERVICES PRIVATE LIMITED',
    'NITISHREE MEGHA MINES PRIVATE LIMITED',
    'MAXIM INFRASTRUCTURE AND REAL ESTATE PRIVATE LIMITED.',
    'GOLDSTONE CEMENTS LIMITED',
    'SOURCE DOT COM PRIVATE LIMTED',
    'AMRIT CEMENT LIMITED',
    'SHREYAS KULKARNI FLOURS PRIVATE LIMITED',
    'VENTO ENERGY INFRA PRIVATE LIMITED',
    'MATIC HIGHRISE PRIVATE LIMITED',
    'RYFLCT LABS PRIVATE LIMITED',
    'Cutting Chai Technologies Private Limited',
    'WORLDVIEW IMPACT (INDIA) PRIVATE LIMITED',
    'SHILLONG LAJONG FOOTBALL CLUB PRIVATE LIMITED',
    'JAI UMADUTT CEMENT LIMITED',
    'West Khashi Minerals & Mining Private Limited',
    'CG Cements Company Limited',
    'MEGHALAYA HEALTH CARE SERVICES LIMITED',
    'Ramgeet Exim Trading Private Limited',
    'MEGHALAYA MAHACOL MINERS PRIVATE LIMITED',
    'ADELIKA INFRASTRUCTURE & MINERALS PRIVATE LIMITED',
    'HOTEL POLO TOWERS PRIVATE LIMITED',
    'HILLS PUBLICATION PVT LTD',
    'Mount Mines and Minerals Private Limited',
    'Hillside Mines and Minerals Private Limited',
    'DIVYANSH CEMENT AND INFRASTRUCTURE PRIVATE LIMITED',
    'LUM MAWSHUN MINERALS PVT LTD',
    'NEZONE INDUSTRIES LIMITED',
    'LAFARGE UMIAM MINING PRIVATE LIMITED',
    'YORK PRINT PRIVATE LIMITED',
    'KAKARANIA INNOVATIVE SYSTEMS PRIVATE LIMITED',
    'NEZONE ALLOYS LIMITED',
    'HANNY FIBRE PRIVATE LIMITED',
    'MEGHALAYA POWER LIMITED',
    'SHILLONG TIMES PRIVATE LIMITED',
    'MEGHA TECHNICAL AND ENGINEERS PRIVATE LIMITED',
    'PURBANCHAL ALLOYS LIMITED',
    'MEGHALAYA CEMENTS LIMITED',
    'BYRNIHAT SPRINGS LIMITED',
    'NAGUR MINERALS PRIVATE LIMITED',
    'DRONAGIRI MINERALS PRIVATE LIMITED',
    'H.M. Pulp & Paper Private Limited',
    'MARBANIANG PROJECTS PRIVATE LIMITED',
    'Impulse Social Enterprises Private Limited',
    'TREASURY MINERALS PRIVATE LIMITED',
    'MELIORATE SOFTECH PRIVATE LIMITED',
    'MEMORY REPRO SYSTEMS PRIVATE LIMITED',
    'MEGATECH COMPONENTS PRIVATE LIMITED',
    'MILAP PRINTERS PRIVATE LIMITED',
    'Meggitt India Private Limited',
    'MEGH SECUR ITIES PRIVATE LIMITED',
    'MERU INFRASTRUCTURE PRIVATE LIMITED',
    'METALFAB INDUSTRIES PRIVATE LIMITED',
    'METALIFE GERMANY PRIVATE LIMITED',
    'METALITE ECO FUTURE LABS PRIVATE LIMITED',
    'MIND BIOMEDS PRIVATE LIMITED',
    'METROPOLE TEXTILE ENTERPRISES PVT LTD',
    'Minitube India Private Limited',
    'MINOCHA ENTERPRISES PRIVATE LIMITED',
    'M-FUTURE FURNISHING PRIVATE LIMITED',
    'MIRHA EXPORTS PRIVATE LIMITED',
    'MG AIRTECH PRIVATE LIMITED',
    'MG BURMANS CAPITAL ADVISORS PRIVATE LIMITED',
    'MITSUBISHI CORPORATION INDIA PRIVATE LIMITED',
    'Mitsubishi Electric India Private Limited',
    'MITTAL COMMUNICATIONS PRIVATE LIMITED',
    'MITTAL CONCEPTS PRIVATE LIMITED',
    'MG PROPERTIES PRIVATE LIMITED',
    'MGF AUTOMOBILES PRIVATE LIMITED',
    'MITTALS SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'MICE INDIA PRIVATE LIMITED',
    'MICRO POWER TECHNOLOGY PRIVATE LIMITED',
    'MICRO PRECISION PRODUCTS PVT LTD',
    'MK PROCESS TECHNOLOGIES PRIVATE LIMITED',
    'Microcomm India Limited',
    'LE SATTVA PRIVATE LIMITED',
    'MKS INFRATECH PRIVATE LIMITED',
    'UNIVERSAL PROJECTS BUILDCON PRIVATE LIMITED',
    'METABYTE INDIA PRIVATE LIMITED',
    'ALLANA EXPORTS Private Limited',
    'MIDAIR PROPERTIES PVT. LTD.',
    'ARIHANT ESTATES PRIVATE LIMITED',
    'DHOOT COMPACK Private Limited',
    'MKU HOLDINGS PRIVATE LIMITED',
    'MLJ INDUSTRIES LIMITED',
    'MIDAS PROPMART PRIVATE LIMITED',
    'MMC DIGI PRESS PRIVATE LIMITED',
    'MIDEA HOME APPLIANCES (INDIA) PRIVATE LIMITED',
    'MEMPHIS COMMERCE PRIVATE LIMITED',
    'MMTC LIMITED',
    'MN MOBICULES SYSTEMS PRIVATE LIMITED',
    'MNR PROJECTS PRIVATE LIMITED',
    'MENTORS EDUCATIONAL SERVICES PVT. LTD.',
    'MILKY WAY BUILDCON LIMITED',
    'MOCA Health Certifications India Private Limited',
    'MILLENNIUM HOMES PRIVATE LIMITED',
    'Millennium InfraDevelopers Limited',
    'MODERN NEST BUILT PRIVATE LIMITED',
    'MODERN RADIO HOUSE (INDIA) PRIVATE LIMITED',
    'MODEX COMMODITY TRADES PRIVATE LIMITED',
    'MODEX INTERNATIONAL SECURITIES LIMITED',
    'MODEX INVESTMENTS PRIVATE LIMITED',
    'Moen India Private Limited',
    'MOHAK CONSULTING SERVICES PRIVATE LIMITED',
    'MOHAK REAL ESTATE PRIVATE LIMITED',
    'MINDSTRINGS CONSULTING PRIVATE LIMITED',
    'MIRA EXIM LTD',
    'MIRUS SOLUTIONS PRIVATE LIMITED',
    'MISSION INFRADEVELOPERS PRIVATE LIMITED',
    'MITTAL MAX PACK PRIVATE LIMITED',
    'MOHTA CARBIDE AND CHEMICALS LIMITED',
    'MOMENTS REALTORS PRIVATE LIMITED',
    'MONAD SERVICES INDIA PRIVATE LIMITED',
    'MITUSHEE AUTO PRODUCTS PRIVATE LIMITED',
    'MONEYPALM WEALTH PRIVATE LIMITED',
    'MITUSHI ELECTRONIC COMPONENTS PRIVATE LIMITED.',
    'MONICA GROWTH FUND PRIVATE LIMITED',
    'SK SARTHI PRIVATE LIMITED',
    'MONSANTO MANUFACTURES PVT LTD',
    'CONCENTRIX SERVICES INDIA PRIVATE LIMITED',
    'Molex India Business Services Private Limited',
    'ALLANA INVESTMENTS AND TRADING COMPANY Private Limited',
    'MITUSHI FOOD PRIVATE LIMITED',
    'MKDSK FINANCIAL MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'MEGAMORPH MARKETING PRIVATE LIMITED',
    'MODISON CHEMTECH PRIVATE LIMITED',
    'RAGA LAND DEVELOPERS PRIVATE LIMITED',
    'MIL VEHICLES & TECHNOLOGIES PRIVATE LIMITED',
    'MILDA BUILDWELL PRIVATE LIMITED',
    'MILESTONE MULTIFAB PRIVATE LIMITED',
    'MOON MEDICAL EQUIPMENTS PRIVATE LIMITED',
    'MOONLIGHT BUILDMART PRIVATE LIMITED',
    'MILESTONE ESTATES PRIVATE LIMITED',
    'MODAGE PIPELINE DRILLERS PRIVATE LIMITED',
    'MODERN HERBALS PRIVATE LIMITED.',
    'MORE BITES N FOODS PRIVATE LIMITED',
    'MOHAN TREAD PRIVATE LIMITED',
    'MOHINDER PURI AND COMPANY PRIVATE LIMTED',
    'MOHINDRA UDYOG LIMITED',
    'MOHIT MINERALS LIMITED',
    'MOHIT PROPERTIES PRIVATE LIMITED',
    'MONARCH BUILDTECH LIMITED',
    'MONARCH GRAPHICS INDIA PRIVATE LIMITED',
    'MONICA AUTOMOBILES PRIVATE LIMITED',
    'IKON ENGINEERING AND ELECTRICALS COMPANY PRIVATE LIMITED',
    'MOXX INSURANCE PVT LTD',
    'mpurse services private limited',
    'VEBLR MEDIA SERVICES PRIVATE LIMITED',
    'MRA ASSOCIATES (INDIA) PRIVATE LIMITED',
    'MM FABTEX PRIVATE LIMITED',
    'ADV SPORTS PRIVATE LIMITED',
    'MOISSANITE DESIGNS PRIVATE LIMITED',
    'MMG GARMENTS PRIVATE LIMITED',
    'iUV Technologies Private Limited',
    'MOBINEERS INFO SYSTEMS PRIVATE LIMITED',
    'PCI PRECISION ENGINEERING LIMITED',
    'INTREPID TOURS INDIA PRIVATE LIMITED',
    'PEARL APARTMENTS LIMITED',
    'PEARL MINERAL PRIVATE LIMITED',
    'SWITCHING POWER CONVERSION PRIVATE LIMITED',
    'PEARL MINERAL RETAIL PRIVATE LIMITED',
    'TATA HITACHI CONSTRUCTION MACHINERY COMPANY Private Limited',
    'PEC LIMITED',
    'PEE CEE RAJ DEVELOPERS PRIVATE LIMITED',
    'PEE VEE SYNTHETICS PRIVATE LIMITED',
    'PENGUIN FARMS PRIVATE LIMITED',
    'PENTAGON ESTATES PRIVATE LIMITED',
    'PNJT REALTY PRIVATE LIMITED',
    'LAXMI BOARD AND PAPER MILLS Private Limited',
    'PAWA BROKERS PVT LTD',
    'KIRLOSKAR INTEGRATED TECHNOLOGIES Private Limited',
    'NATIONAL TRADERS LIMITED',
    'GARUDA CHIT AND TRADING CO PVT LTD',
    'PAWAN HANS LIMITED',
    'PAWITRA INTERNATIONAL PRIVATE LIMITED',
    'PERFECT OFFICE AIDS PRIVATE LIMITED',
    'PERFECT TRAVELS AND TOURS PRIVATE LIMITED',
    'PAYAL CABLES PRIVATE LIMITED',
    'PayPortal Services Private Limited',
    'PBG AUTO PRIVATE LIMITED',
    'PETRONET LNG LIMITED',
    'PBR IMPEX PRIVATE LIMITED',
    'PGM CONSTRUCTONS PRIVATE LIMITED',
    'PHAETON ENERGY PRIVATE LIMITED',
    'PERFECT CARGO MOVERS PRIVATE LIMITED',
    'PERFECT DIGITAL MEDIA RESOURCES PRIVATE LIMITED',
    'PERFECT GLOBAL PROFILES PRIVATE LIMITED',
    'PERFECT IMPACT DESIGNING AND PRINTING PRIVATE LIMITED',
    'TAMARA LEISURE EXPERIENCES PRIVATE LIMITED',
    'PHOENIX INTERNATIONAL FINANCE LIMITED',
    'PHOENIX INTERNATIONAL LIMITED',
    'TECHNOINFOWARE INDIA PRIVATE LIMITED',
    'PICL (INDIA) PRIVATE LIMITED',
    'TECNOTREE CONVERGENCE Private Limited',
    'TELOS INVESTMENTS & TECHNOLOGIES PRIVATE LIMITED',
    'TERRA INCOGNITUS SYSTEMS RESEARCH ALLIANCE PRIVATE LIMITED',
    'ALL INDIA ELECTRONICS ASSOCIATION',
    'MUBEA AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED',
    'PERDAMAN AGRO PRIVATE LIMITED',
    'Perdaman Media Entertainment Private Limited',
    'PERDAMAN PHARMACEUTICALS PRIVATE LIMITED',
    'PIONEER PROMOTERS PRIVATE LIMITED',
    'PERDAMAN RENEWABLE ENERGY PRIVATE LIMITED',
    'PEREGRINE INDIA ADVISORS PRIVATE LIMITED',
    'COMPATRARE SERVICES LIMITED',
    'PERFECT MALL MANAGEMENT PRIVATE LIMITED',
    'AARCON REALTECH PRIVATE LIMITED',
    'Pernod Ricard India Private Limited',
    'PERENIA CARBON INDIA PRIVATE LIMITED',
    'PERFACT IMPRESSION PRIVATE LIMITED',
    'PHARMEX DRUGS (I) PRIVATE LIMITED.',
    'PHE SEALING SOLUTIONS PRIVATE LIMITED',
    'OZ REALTY PRIVATE LIMITED',
    'PHOENIX AIR EXPRESS PRIVATE LIMITED.',
    'PHOENIX CEMENT LIMITED',
    'PLANET AGRO FARMS PRIVATE LIMITED',
    'Picanol India Private Limited',
    'PIK ENGINEERS PRIVATE LTD.',
    'PIK STORAGE SYSTEMS PRIVATE LTD.',
    'PIL PHARMACEUTICALS LIMITED',
    'PINAKI CONSULTING PRIVATE LIMITED',
    'PLASTIC TRADERS PRIVATE LIMITED',
    'PLASTICS MACHINERY MANUFACTURERS ASSOCIATION OF INDIA',
    'PLASTO INDIA PRIVATE LIMITED',
    'Platinum Circle Infrastructures Private Limited',
    'PINE EXPORTERS PRIVATE LIMITED',
    'PINEAPPLE ESTATES PPINEAPPLE ESTATES PRIVATE LIMITED',
    'PINNACLE FUTURES PRIVATE LIMITED.',
    'Pinnacle Metals Private Limited',
    'PIONEER SMT TECHNOLOGIES PRIVATE LIMITED',
    'PERTH VERIFICATION AND CREDIT MANAGMENT PRIVATE LIMITED',
    'MAXIMA DIGITAL PRIVATE LIMITED',
    'PETROWATCH INFORMATION (INDIA) PRIVATE LIMITED',
    'PLUTO ENTERPRISES PRIVATE LIMITED',
    'PLUTO TECHNOLOGIES PRIVATE LIMITED',
    'PM Powerpack Solutions Private Limited',
    'PMAC CONSULTING PRIVATE LIMITED',
    'PME INFRASTRUCTURE PRIVATE LIMITED',
    'PNB GILTS LIMITED',
    'PNB HOUSING FINANCE LIMITED',
    'PharmaSecure Product Authentication Services India Private Limited',
    'POENA POWER DEVELOPMENT LIMITED',
    'GALIAKOT CONTAINERS PRIVATE LIMITED',
    'NIRLEP APPLIANCES Private Limited',
    'PITCHI PRODUCTS PRIVATE LIMITED',
    'POLYPLAST PRIVATE LIMITED',
    'JRG AUTOMOTIVE (INDIA) PRIVATE LIMITED',
    'PIXXTRON EXIM PRIVATE LIMITED',
    'PORTRONICS DIGITAL PRIVATE LIMITED',
    'POSIST TECHNOLOGIES PRIVATE LIMITED',
    'POSITIV RADIO PRIVATE LIMITED',
    'PIYUSH IT SOLUTIONS PRIVATE LIMITED',
    'THEME D',
    'D C AGARWALA AND COMPANY PRIVATE LIMITED',
    'DALMIA CONTINENTAL PRIVATE LIMITED',
    'HEAVENLY FARMS PRIVATE LIMITED',
    'DALMIA RESORTS INTERNATIONAL BEACHES PRIVATE LIMITED',
    'DALMIA RESORTS INTERNATIONAL HILLS PRIVATE LIMITED',
    'HEMKUNT PROMOTERS PRIVATE LIMITED',
    'HEMMA HERBS PRIVATE LIMITED',
    'DALMIA RESORTS INTERNATIONAL PRIVATE LTD',
    'Dalmia Sugar Ventures Limited',
    'DAMODAR MENON INTERNATIONAL PRIVATE LTD',
    'HARYANA ISPAT PRIVATE LIMITED',
    'D S S HOTELS PRIVATE LIMITED',
    'HERITAGE RESORTS PRIVATE LIMITED',
    'HARYANA PIPES PRIVATE LIMITED',
    'HERO MINDMINE INSTITUTE Private Limited',
    'HESPER BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'D.J. Buildcon Private Limited',
    'D.J. Builders Private Limited',
    'D.J. EXPORTS PRIVATE LIMITED',
    'D.J.M. ESTATES PRIVATE LIMITED',
    'HILLGROW INFRACON PRIVATE LIMITED',
    'D.W. HABER INDIA PRIVATE LIMITED',
    'DAFODILS ELECTRICALS PRIVATE LIMITED',
    'HIM LOGISTICS PRIVATE LIMITED',
    'NIDARA CHILDREN PRIVATE LIMITED',
    'DAIHAN LABTECH INDIA PRIVATE LIMITED',
    'HIMALAYA COMMUNICATIONS PRIVATE LIMITED',
    'HIMALAYA CORPORATION LIMITED',
    'HIMALAYA ESTATE PRIVATE LIMITED',
    'DAILY MILAP PRIVATE LIMITED',
    'DAILY MILK FOODS (HAPUR) PRIVATE LIMITED',
    'HIMALAYAN PACKAGING INDUSTRIES PRIVATE LIMITED',
    'DAIWA KASEI INDIA PRIVATE LIMITED',
    'HELLO42 INDIA PRIVATE LIMITED',
    'HEMISPHERE PROPERTIES INDIA LIMITED',
    'HEO HYDRO POWER PRIVATE LIMITED',
    'HERAEUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HERITAGE COTTAGES PVT. LTD.',
    'HERITAGE FORTS & PALACES PRIVATE LIMITED',
    'HINDUSTAN SYRINGES AND MEDICAL DEVICES LIMITED',
    'HINDUSTAN TIN WORKS LIMITED',
    'HINDUSTHAN SPECIALITY CHEMICALS LIMITED',
    'HINDUSTHAN URBAN INFRASTRUCTURE LIMITED',
    'HERITAGE INFRA BUILT PRIVATE LIMITED',
    'HERMSLEY CAPITAL INVESTORS INDIA PRIVATE LIMITED',
    'HI TECH INSTITUTE OF ADVANCE TECHNOLOGIES PRIVATE LIMITED',
    'HIGH SPIRITS EXIM PRIVATE LIMITED',
    'HIGH TENSILE PRODUCTS PRIVATE LIMITED',
    'HITCO ELECTRICALS PRIVATE LIMITED',
    'ELITE ELECTRIKALS AND APPLIANCES PRIVATE LIMITED',
    'HIGHBEAM HOSPITALITY PRIVATE LIMITED',
    'Hillsborough Homes Private Limited',
    'DARBAR SPARES PRIVATE LIMITED',
    'CJ DARCL LOGISTICS LIMITED',
    'HILTON PLANTS AND INDUSTRIES LIMITED',
    'HIMAL SUPPLY (INDIA) PRIVATE LIMITED.',
    'HIMAL TRADE FACILITATORS PRIVATE LIMITED.',
    'HIMALAYAN ALES PRIVATE LIMITED',
    'QUARK AUTOMATION PRIVATE LIMITED',
    'INKSTUDIO INDIA PRIVATE LIMITED',
    'NIDRIVE PRIVATE LIMITED',
    'GUARDELL INDIA PRIVATE LIMITED',
    'FIVE39 MATRIMONIAL AND MATCHMAKING PRIVATE LIMITED',
    'RIPPLES OF HOPE FOUNDATION',
    'ZENOFARM EAST PRIVATE LIMITED',
    'FINLEIT FINANCIAL ADVISORS PRIVATE LIMITED',
    'REAL SME SOLUTIONS PRIVATE LIMITED',
    'VAXINO INTERNATIONAL PRIVATE LIMITED',
    'SOUTH 24 PARAGANAS (BISHNUPUR) SOCIAL INITIATIVES ASSOCIATION',
    'FEEDSCO INDIA PRIVATE LIMITED',
    'BAKER & DAVIS PRIVATE LIMITED',
    'AGATESNSTONES PRIVATE LIMITED',
    'HOMEDIGILAND SERVICES PRIVATE LIMITED',
    'BRIDGETHINGS IOT PRIVATE LIMITED',
    'MAVIS COMMUNICATION SERVICES PRIVATE LIMITED',
    'GODAVRI BASIN AGRICULTURE PRIVATE LIMITED',
    'BARBUS FIDUCIARY SERVICES PRIVATE LIMITED',
    'PIANO FORTE FIDUCIARY SERVICES PRIVATE LIMITED',
    'GMV YOGA PRIVATE LIMITED',
    'MERAKI SIGNATURE PRIVATE LIMITED',
    'NOVIGA AUTOMATION PRIVATE LIMITED',
    'KRAB INFOTECH PRIVATE LIMITED',
    'SURESERVE TECHSOFT PRIVATE LIMITED',
    'METALSTONE INTERNATIONAL PRIVATE LIMITED',
    'MINEROCK GLOBAL TRADING CORPORATION PRIVATE LIMITED',
    'ACHIM MINERALS CHEMICALS AND PETRO PRODUCTS PRIVATE LIMITED',
    'URSA MINOR CONSULTING PRIVATE LIMITED',
    'IEFP INDIA PRIVATE LIMITED',
    'VENKADAMBAL FARMS & PLANTATION PRIVATE LIMITED',
    'SWANITA INDUSTRIES PRIVATE LIMITED',
    'KUMBAKONAM KALANJIA JEEVIDAM PRODUCER COMPANY LIMITED',
    'ZAENA BIO PRIVATE LIMITED',
    'CLOUDATIX KOFFEE LAB PRIVATE LIMITED',
    'SIDS MARKETING PRIVATE LIMITED',
    'HEXAGON FOODS & BEVERAGES PRIVATE LIMITED',
    'FAIRVIEW FARMS PRIVATE LIMITED',
    'FRESKO FARMS PRIVATE LIMITED',
    'SITAMATA FARMERS PRODUCER COMPANY LIMITED',
    'PANCHA BHOOTANI AGRICULTURAL AND ALLIED SERVICES PRIVATE LIMITED',
    'TOIT BREWERIES PRIVATE LIMITED',
    'VALUE SEED PRIVATE LIMITED',
    'SSEV NATURO PRODUCTS PRIVATE LIMITED',
    'BHAGYADHARA AGROTECH PRIVATE LIMITED',
    'SOCIAL STORIES PRIVATE LIMITED',
    'NISHETTY PROJECTS PRIVATE LIMITED',
    'WINGED DAGGERS VENTURES PRIVATE LIMITED',
    'ZUKEWELL PRIVATE LIMITED',
    'AIRDATA NETWORK PRIVATE LIMITED',
    'ORBYSOL AGROS AND PROPERTIES PRIVATE LIMITED',
    'GREENWOOD ORCHARDS PRIVATE LIMITED',
    'S.K. MASALA AND FOODS LIMITED',
    'SPETTRO RESOURCES PRIVATE LIMITED',
    'WINGS AGRO PRIVATE LIMITED',
    'VIOLET HEALTH PRODUCTS INDIA PRIVATE LIMITED',
    'RANCORP FOODS SERVICES PRIVATE LIMITED',
    'PH4 CIDER WORKS PRIVATE LIMITED',
    'DELOSSIOO AGRO FOODS PRIVATE LIMITED',
    'ACHIM ASSOCIATES PRIVATE LIMITED',
    'SYMBIOSIS FEEDS INDIA PRIVATE LIMITED',
    'LALITHAA ORGANIC FOODS PRIVATE LIMITED',
    'NATUREBORNE BIO PRODUCTS PRIVATE LIMITED',
    'CIS FOODS AND HOSPITALITY PRIVATE LIMITED',
    'VEVUS LIPIDOS PRIVATE LIMITED',
    'SSG APPARELS PRIVATE LIMITED',
    'MORGAN BEVERAGES PRIVATE LIMITED',
    'SUPL VENTURES PRIVATE LIMITED',
    'JUNK-FREE LIFE PRIVATE LIMITED',
    'IYYA FOODS PRIVATE LIMITED',
    'BRIO BAKEHOUSE PRIVATE LIMITED',
    'KAMEDA LT FOODS (INDIA) PRIVATE LIMITED',
    'SHILPIRAJ CLOTHINGS PRIVATE LIMITED',
    'OXYM CRAFTS PRIVATE LIMITED',
    'BENOIT FASHION PRIVATE LIMITED',
    'INBA FISHERIES PRIVATE LIMITED',
    'COASTAL AQUA PRIVATE LIMITED',
    'GO4LIFE ORGANIC FOODS PRIVATE LIMITED',
    'DANGUS RM INDIA PRIVATE LIMITED',
    'GLAMFOLIO INDIA PRIVATE LIMITED',
    'ACC TRENDS PRIVATE LIMITED',
    'LYALLPUR SNACK FOODS LIMITED',
    'KOHLI LEATHER EXPORTS PRIVATE LIMITED',
    'SH LUGGAGE INDUSTRIES PRIVATE LIMITED',
    'SIVAKHARTHIKEYA FARMS PRIVATE LIMITED',
    'TRENSER TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'VENATRIX PRIVATE LIMITED',
    'TREJHARA SOLUTIONS LIMITED',
    'EMBTECH INNOVA PRIVATE LIMITED',
    'MAKONIS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'WINVERVE PRIVATE LIMITED',
    'GYRIT SOLUTIONS PRIVATE LIMITED',
    'REZLER SYSTEMS PRIVATE LIMITED',
    'BIMTECH DEVELOPERS PRIVATE LIMITED',
    'SECONCLOUD IT SERVICES PRIVATE LIMITED',
    'CLONET TECHNOLOGIES PRIVATE LIMITED',
    'DJ INTERACTIVE SOLUTIONS PRIVATE LIMITED',
    'ADROIT INTEGRATED SERVICES PRIVATE LIMITED',
    'EQUENTIA SCF TECHNOLOGIES PRIVATE LIMITED',
    'TECHNOSPROUT SYSTEMS PRIVATE LIMITED',
    'HATIO INNOVATIONS PRIVATE LIMITED',
    'MINDZAURUS TECHNOLOGIES PRIVATE LIMITED',
    'RETUNE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WORLDSHORE NETWORKS PRIVATE LIMITED',
    'DHISIGMA SYSTEMS PRIVATE LIMITED',
    'KEFI TECH SOLUTIONS PRIVATE LIMITED',
    'MASS DYNAMICS PRIVATE LIMITED',
    'DFM SOFTECH SOLUTIONS PRIVATE LIMITED',
    'CIPHERMATRIX INTERACTIVE PRIVATE LIMITED',
    'BIZPLX SOLUTIONS AND HOSPITALITY PRIVATELIMITED',
    'INTELLIGENT BUSINESS FORECASTING LABS PRIVATE LIMITED',
    'CITSA TECHNOLOGIES PRIVATE LIMITED',
    'HRUSTA TECHNOLOGIES PRIVATE LIMITED',
    'BILAGOS SOFTWARES PRIVATE LIMITED',
    'SURVEYSPARROW PRIVATE LIMITED',
    'INSTAWEB LABS PRIVATE LIMITED',
    'FIRSTNUCLEUS INTERNET TECHNOLOGIES PRIVATE LIMITED',
    'AAKASH INFOWAY PRIVATE LIMITED',
    'IYE-FI TECHNOCRATS PRIVATE LIMITED',
    'ANS IT INDIA PRIVATE LIMITED',
    'TWILIGHT IT SOLUTIONS PRIVATE LIMITED',
    'ATOS GLOBAL IT SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'XOVERTURE INDIA PRIVATE LIMITED',
    'SUREIFY LABS TECHNOLOGY PRIVATE LIMITED',
    'AYASTA TECHNOLOGIES PRIVATE LIMITED',
    'INTELLISENSE INNOVATIVE SYSTEMS PRIVATE LIMITED',
    'BETAMAGIC GLOBAL PRIVATE LIMITED',
    'VEEGAM SOFTWARE PRIVATE LIMITED',
    'SAYEFFECT TECH SOLUTIONS PRIVATE LIMITED',
    'NLOGIX IT SERVICES PRIVATE LIMITED',
    'VLSI SYSTEM DESIGN CORPORATION PRIVATE LIMITED',
    'ATOP DIGITAL TECHNOLOGY CONSULTING SERVICES PRIVATE LIMITED',
    'PINCER RESEARCH PRIVATE LIMITED',
    'NETAAR NETWORKS INDIA PRIVATE LIMITED',
    'EASYTECH INNOVATIONS PRIVATE LIMITED',
    'AIDIA TECHNOVATIONS PRIVATE LIMITED',
    'OXYNIA TECHNOLOGIES PRIVATE LIMITED',
    'ZOLUTE TECHNOLOGY AND CONSULTING PRIVATELIMITED',
    'TERSE SOFTWARE PRIVATE LIMITED',
    'ALACRITI APPLICATION SOLUTIONS PRIVATE LIMITED',
    '3S DATA MIGRATION SERVICES PRIVATE LIMITED',
    'UPTREND TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'SANYAM TECHNOLOGIES PRIVATE LIMITED',
    'AVEROFT PRIVATE LIMITED',
    'BHOJ TECH PRIVATE LIMITED',
    'TECHREFIC TECHNOLOGIES PRIVATE LIMITED',
    'BUG86 PRIVATE LIMITED (OPC)',
    'VIRALWIFI CONNECT PRIVATE LIMITED',
    'CINDREL SYSTEMS PRIVATE LIMITED',
    'SCANFLOW PRIVATE LIMITED',
    'IDEO MIND PRIVATE LIMITED',
    'YETNI FINTECH PRIVATE LIMITED',
    'IDEASAILOR TECHNOLOGIES PRIVATE LIMITED',
    'ALTROSYN TECHNOLOGIES PRIVATE LIMITED',
    'PROFORMIL INNOVATIONS PRIVATE LIMITED',
    'QVADY TECHNOLOGIES PRIVATE LIMITED',
    'RAYVOLUTION TECH PRIVATE LIMITED',
    'BLOOMSTACK TECHNOLOGIES PRIVATE LIMITED',
    'MECH CONTROL SYSTEMS PRIVATE LIMITED',
    'ARCANDFUSION E-TECHNOLOGIES PRIVATE LIMITED',
    'SMBDS INDIA PRIVATE LIMITED',
    'ITCONNECTUS TECH INDIA PRIVATE LIMITED',
    'SMAR TECHNOLOGIES PRIVATE LIMITED',
    'AINQA QDM PRIVATE LIMITED',
    'SOLUTIONCHAMPS TECHNOLOGIES PRIVATE LIMITED',
    'VANSHIKA ITLAM INDIA PRIVATE LIMITED',
    'HEAD HOPPERS STUDIOS PRIVATE LIMITED',
    'ASTU CONSULTANCY SERVICES PRIVATE LIMITED',
    'EPIC TECHNOLOGY RESEARCH PRIVATE LIMITED',
    'HEAD DIGITAL WORKS PRIVATE LIMITED',
    'ZETECHNO PRODUCTS AND SERVICES PRIVATE LIMITED',
    'BRACE INFOTECH PRIVATE LIMITED',
    'EKYUBE UTILITY CONSULTANTS PRIVATE LIMITED',
    'MOLVENO CONSULTING PRIVATE LIMITED',
    'WORKTABLE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SKYIN APPS PRIVATE LIMITED',
    'AGNA IT AND MEDIA PRIVATE LIMITED',
    'TATCODE SOFTWARE PRIVATE LIMITED',
    'WILCO SOURCE TECHNOLOGIES PRIVATE LIMITED',
    'HVAC INFORMATION DATA CAPTURE PRIVATE LIMITED',
    'GREYSCAPE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'DATALABS TECHNOLOGIES PRIVATE LIMITED',
    'SIFY DATA AND MANAGED SERVICES LIMITED',
    'IMPACTREE DATA TECHNOLOGIES PRIVATE LIMITED',
    'ENTO LABS INDIA PRIVATE LIMITED',
    'ASCENDENCY INTERLINKS PRIVATE LIMITED',
    'ENSEIGNER PRIVATE LIMITED',
    'ENMAS MINERALS PRIVATE LIMITED',
    'SAHASANKHA ADVISORY AND CONSULTING SERVICES PRIVATE LIMITED',
    'CHRISVIN GEOMET SERVICES PRIVATE LIMITED',
    'VITALCORE INDUSTRIALS PRIVATE LIMITED',
    'PEPGRA HEALTHCARE PRIVATE LIMITED',
    'INFINIAN SUCCESS LOGISTICS PRIVATE LIMITED',
    'AEDBM CONSULTANTS PRIVATE LIMITED',
    'KAYONE MANAGEMENT ADVISORY SERVICES PRIVATE LIMITED',
    'INNOVSPACE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PARADISE PEST CONTROL INDIA PRIVATE LIMITED',
    'ARCISHMAAN ELEMENTS PRIVATE LIMITED',
    'PRAVARTANA VENTURES PRIVATE LIMITED',
    'BRAINAK SYSTEM TECHNOLOGIES PRIVATE LIMITED',
    'SEDI BOTANICALS PRIVATE LIMITED',
    'R.BCC EXPORTERS PRIVATE LIMITED',
    'ANGAYEEAMMAL DEVARAJAN TEXTILE PRIVATE LIMITED',
    'CALYPSO FERTILIZERS PRIVATE LIMITED',
    'AMCORETEK INDIA PRIVATE LIMITED',
    'UNIOS INFRACON PRIVATE LIMITED',
    'TEK WIZARD ROBOTICS RESEARCH AND ENTREPRENEURSHIP INSTITUTE PRIVATE LIMITED',
    'LV TRUSTEE PRIVATE LIMITED',
    'S. VENU TRUSTEE PRIVATE LIMITED',
    'PRECULT ITES PRIVATE LIMITED',
    'GAP IT SERVICES INDIA PRIVATE LIMITED',
    'PKECM SERVICES PRIVATE LIMITED',
    'SUHANABEULAH FOUNDATION FOR ORPHAN CHILDREN AND OLD AGE PERSONS',
    'ETHIKA WORKLIFE SOLUTIONS PRIVATE LIMITED',
    'HYDERABAD PHARMA CITY LIMITED',
    'ARACIV TECHNOLOGIES PRIVATE LIMITED',
    'LH2 SOLUTIONS PRIVATE LIMITED',
    'BYTIZE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MINDSHARE LEARNING SOLUTIONS PRIVATE LIMITED',
    'KUBERAS INFOSYSTEMS PRIVATE LIMITED',
    'SMARTBAS BUILDING SOLUTIONS PRIVATE LIMITED',
    'LA OPULENCIA EVENTS PRIVATE LIMITED',
    'ADFARM PRIVATE LIMITED',
    'IBEA DESIGN STUDIO PRIVATE LIMITED',
    'CONSTEMS-AI SYSTEMS PRIVATE LIMITED',
    'IMPEXTECH LABS PRIVATE LIMITED',
    'RMVS INFOTECH PRIVATE LIMITED',
    'KNOWLEDGE PROCESSING CENTRE (INDIA) PRIVATE LIMITED',
    'HABU TECH INDIA PRIVATE LIMITED',
    'ELITE SCREENS AND ALLIED PRODUCTS PRIVATE LIMITED',
    'NEXTGEN TECHEDGE SOLUTIONS PRIVATE LIMITED',
    'POLICYWOW INSURANCE BROKING PRIVATE LIMITED',
    'ZACCO CYBER SECURITY PRIVATE LIMITED',
    'METTUR INSTRUMENT CONTROL SERVICES PRIVATE LIMITED',
    'AFFZIP MEDIA (OPC) PRIVATE LIMITED',
    'FAIR POWER AGE PRIVATE LIMITED',
    'TOPCUBIT IT SERVICES PRIVATE LIMITED',
    'SHRIJI ALCHEMICAL PRIVATE LIMITED',
    'EWAY ENGINEERING PRIVATE LIMITED',
    'COLLAR JOBSKART PRIVATE LIMITED',
    'MEDDIGI TECH PRIVATE LIMITED',
    'PHONOGRAPHIC DIGITAL LIMITED',
    'HASHTAG LABS PRIVATE LIMITED',
    'FELIZ MOMS PRIVATE LIMITED',
    'EXECUTIVE ZONE PRIVATE LIMITED',
    'BETSA GLOBAL TRADING PRIVATE LIMITED',
    'HR SYNERGY COMPLIANCE PRIVATE LIMITED',
    'R9 PRODUCTION WORKS PRIVATE LIMITED',
    'JSB GLOBALIS TRADELINK PRIVATE LIMITED',
    'MEDEWISE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'FAIR VILLAGE PRIVATE LIMITED',
    'GROVEUS INFORMATICS PRIVATE LIMITED',
    'KEHAN SOLARWORLD PRIVATE LIMITED',
    'SHREY COMMUNICATIONS PRIVATE LIMITED',
    'SHUDHTTAM NATURECURE AND RESORTS PRIVATELIMITED',
    'SLEEP MANAGEMENT PRIVATE LIMITED',
    'EKLINGA INDENTING AGENTS PRIVATE LIMITED',
    'ROY HATCHERIES PRIVATE LIMITED',
    'YUVAYANA TECH AND CRAFT PRIVATE LIMITED',
    'BANSHIDHAR SHEETGRAH PRIVATE LIMITED',
    'ADYA LETSDOTHIS PRIVATE LIMITED',
    'ECOPAYZ CONSULTANTS PRIVATE LIMITED',
    'ZANSHINSOFT PRIVATE LIMITED',
    'ISTITUTO MARANGONI MUMBAI TRAINING CENTRE PRIVATE LIMITED',
    'VERBOLABS LANGUAGES (OPC) PRIVATE LIMITED',
    'ADITYA RAJ SKILL DEVELOPMENT PRIVATE LIMITED (OPC)',
    'SAHNI SPORTS PRIVATE LIMITED',
    'MIRUS GLOBAL CONSULTANTS PRIVATE LIMITED',
    'VDK EDUVENTURES PRIVATE LIMITED',
    'VISWAGURU EDUCATION PRIVATE LIMITED',
    'STUDYIQ EDUCATION PRIVATE LIMITED',
    'UPWARDS AND EMERGING PRIVATE LIMITED',
    'WESTFIN CONSULTING PRIVATE LIMITED',
    'NIBSCORP PRIVATE LIMITED',
    'SARAOGI E-VENTURES PRIVATE LIMITED',
    'SUPERCHAMPZ SKILLS DEVELOPMENT PRIVATE LIMITED',
    'AVIXA INDIA PRIVATE LIMITED',
    'KHAN ACADEMY INDIA',
    'NAMCHI SMART CITY LIMITED',
    'AEROVITE AERO-DEFENCE PRIVATE LIMITED',
    'GOODVILLE TECHNOLOGIES PRIVATE LIMITED',
    'CULTURRO TECHNOLOGIES PRIVATE LIMITED',
    'HAZAMIN CONSULTANCY (OPC) PRIVATE LIMITED',
    'INVEZIA CONSULTANCY (OPC) PRIVATE LIMITED',
    'BESTINET (INDIA) PRIVATE LIMITED',
    'MOBILNXT INDIA PRIVATE LIMITED',
    'AVC INDUSTRIAL SALES PRIVATE LIMITED',
    'YNOS VENTURE ENGINE CC PRIVATE LIMITED',
    'WHITE OAK INVESTMENT MANAGEMENT PRIVATE LIMITED',
    'IOTECHWORLD AVIGATION PRIVATE LIMITED',
    'BYTAMORPH TECHNOLOGIES PRIVATE LIMITED',
    'MONTECINO INDUSTRIES PRIVATE LIMITED',
    '7PAVO ENTERTAINMENTS PRIVATE LIMITED',
    'AFRINEXT OVERSEAS PRIVATE LIMITED',
    'ZIXTI INNOVATIONS PRIVATE LIMITED',
    'TRIM HR CONSULTING PRIVATE LIMITED',
    'APPLUENT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'IMPLEXIANS ECO SOLUTIONS PRIVATE LIMITED',
    'JUNWEI ELECTRONIC PRIVATE LIMITED',
    'MOONA OVERSEAS JOB CONSULTANCY (OPC) PRIVATE LIMITED',
    'HAPPY GARDENERS PRIVATE LIMITED',
    'KODAMA NATURAL PRODUCTS PRIVATE LIMITED',
    'NGFMS INDIA PRIVATE LIMITED',
    'FLOWLABS SOFTWARE PRIVATE LIMITED',
    'COGNITIV ENTERPRISES PRIVATE LIMITED',
    'SPANMAX BUILDING SYSTEMS PRIVATE LIMITED',
    'GIST MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'ARBOR ORGANICS PRIVATE LIMITED',
    'LEXXO LAWTECH PRIVATE LIMITED',
    'SHANTI INN HOTEL & RESORTS PRIVATE LIMITED',
    'AARYAN CARRIERS AND MOVERS PRIVATE LIMITED',
    'CROWDWARE LABS PRIVATE LIMITED',
    'PRANATHARTHI VENTURES PRIVATE LIMITED',
    'SHRIGANESH ICE & SHEETGRAH PRIVATE LIMITED',
    'SAN ROLLING STOCK SERVICES LIMITED',
    'PURECHARGE SOLAR PRIVATE LIMITED',
    'AIR INDOOR ASSESSMENT PRIVATE LIMITED',
    'LASTMILE TRANSTECH PRIVATE LIMITED',
    'S2D PROCESS SOLUTIONS PRIVATE LIMITED',
    'CLOUDACCEL SOFT INDIA PRIVATE LIMITED',
    'GEMICORN TECHNOLOGIES PRIVATE LIMITED',
    'KAMATH AUTO RECYCLERS PRIVATE LIMITED',
    'EFFI FREI SOLUTIONS PRIVATE LIMITED',
    'CHANDRA EQUIPMENT INFRA SOLUTIONS PRIVATE LIMITED',
    'STARK NUTRITION PRIVATE LIMITED',
    'CRAFTERS RETAIL SOLUTIONS PRIVATE LIMITED',
    'NRISE TRADETECH MARKETING PRIVATE LIMITED',
    'A.S MOTIWALA FINE JEWELLERY PRIVATE LIMITED',
    'TGH LIFESTYLE SERVICES PRIVATE LIMITED',
    'QOGENT EQUIPMENT SERVICES PRIVATE LIMITED',
    'GOOD BUSINESS LAB FOUNDATION',
    'PROSPITIOUS CONSULTING SERVICES PRIVATE LIMITED',
    'KRISHA',
    'S GREEN HOMES PRIVATE LIMITED',
    'PUBERT INDIA PRIVATE LIMITED',
    'SIQS TIERRA PRIVATE LIMITED',
    'SCHUTZ INDIA PRIVATE LIMITED',
    'RODA NETWORKS PRIVATE LIMITED',
    'C. R. TECHNOFAB ENGINEERS PRIVATE LIMITED',
    'AGRISIA AGRO PRIVATE LIMITED',
    'MREX POLYMARKETING PRIVATE LIMITED',
    'VASCON VALUE HOMES PRIVATE LIMITED',
    'KLP TOWNSHIPS PRIVATE LIMITED',
    'BULKYBAY PRIVATE LIMITED',
    'NAWOCO PRIVATE LIMITED',
    'PEBBLE GARDEN DEVELOPERS PRIVATE LIMITED',
    'HIGH LANE CONSTRUCTIONS PRIVATE LIMITED',
    'MAGNAFITS INTERNATIONAL PRIVATE LIMITED',
    'NTS RETAILS PRIVATE LIMITED',
    'DIVED DEVELOPERS PRIVATE LIMITED',
    'DIVED LOGISTICS PRIVATE LIMITED',
    'DODDLE CAR SERVICE PRIVATE LIMITED',
    'KNS VINAYAK AUTO PRIVATE LIMITED',
    'SHIVANG MOTOTECH PRIVATE LIMITED',
    'ZORIN BIOCHEM PRIVATE LIMITED',
    'LIMELIGHT LAB GROWN DIAMONDS LIMITED',
    'HIMALAYANROI MARKETING SOLUTIONS PRIVATELIMITED',
    'CD ELECTRONIC JUNCTION PRIVATE LIMITED',
    'ELETE BIOTECH PRIVATE LIMITED',
    'VONIX TECHNOLOGIES PRIVATE LIMITED',
    'FATEHPURIA HYGIENE PRIVATE LIMITED',
    'CIS VEDA PRIVATE LIMITED',
    'CREANDO ASSOCIATES PRIVATE LIMITED',
    'INTICEDE HOLDINGS PRIVATE LIMITED',
    'INDOSPIRIT VAPING PRIVATE LIMITED',
    'SAUMESVAR INTERNATIONAL PRIVATE LIMITED',
    'E-KHANATE WORLDWIDE PRIVATE LIMITED',
    'INDUSROOF ECOMMERCE PRIVATE LIMITED',
    'GOCENTREPOINT FASHION PRIVATE LIMITED',
    'WALL JEWELS WALLPAPER WORLD PRIVATE LIMITED',
    'QUICK WALLS (OPC) PRIVATE LIMITED',
    'SAMMAAN HORECA (INDIA) PRIVATE LIMITED',
    'FORTIS ESCALATORS AND ELEVATORS PRIVATE LIMITED',
    'OFFIMART BUSINESS SERVICES PRIVATE LIMITED',
    'PHASE1 DESTINATIONS PRIVATE LIMITED',
    'DYNAMED HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'TRA LEISURE SERVICES PRIVATE LIMITED',
    'VEGAM.IO SOLUTIONS PRIVATE LIMITED',
    'AMIGO SAMPOORNA PANACEA PRIVATE LIMITED',
    'FROZEN STONE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HURUN REPORT PRIVATE LIMITED',
    'SEPTA MILLES PRIVATE LIMITED',
    'RIVERSTAGE PRIVATE LIMITED',
    'TMGP ENTERPRISES PRIVATE LIMITED',
    'AMBICRYSIS SOLUTIONS INDIA PRIVATE LIMITED',
    'MARLOWE MARKETING SERVICES INDIA PRIVATELIMITED',
    'AEROTECH INSPECTION & NDT (INDIA) PRIVATE LIMITED',
    'JOULON SERVICES INDIA PRIVATE LIMITED',
    'MINTZ GROUP INDIA PRIVATE LIMITED',
    'MUNZING MUMBAI PRIVATE LIMITED',
    'HOUSE OF MERAKI INDIA PRIVATE LIMITED',
    'INTRISKELION LABS PRIVATE LIMITED',
    'LIQUITICS SOLUTIONS PRIVATE LIMITED',
    'TENDER ROOTS ACADEMY OF PERFORMING ARTS',
    'KHADAYATA COMMUNITY BUSINESS FORUM',
    'SUN FIRE & SECURITY SYSTEMS PRIVATE LIMITED',
    'FIDEM GCOMM INFOTECH PRIVATE LIMITED',
    'SLEEPYHEAD HOME DECOR PRIVATE LIMITED',
    'AGUA TECHNIQUE PRIVATE LIMITED',
    'TRIOKA SOFTWARE PRIVATE LIMITED',
    'METACRUST PRIVATE LIMITED',
    'OPTIDESK SOLUTIONS PRIVATE LIMITED',
    'ORTHOSQUARE MULTISPECIALITY DENTAL CLINIC PRIVATE LIMITED',
    'STELLAR GROWTH ADVISORS PRIVATE LIMITED',
    'PRASHTEK EPARTS SOLUTIONS PRIVATE LIMITED',
    'UTPANNA DESIGNWORKS PRIVATE LIMITED',
    'ASHWIN BAVANI INITIATIVES PRIVATE LIMITED',
    'NETBEATS INFOWAY PRIVATE LIMITED',
    'RANK CLAIMS SEVA PRIVATE LIMITED',
    'TERRALENZE TECHNOLOGIES PRIVATE LIMITED',
    'GONDHALI INFRAPROJECTS PRIVATE LIMITED',
    'SINI MANGATT AESTHETICS PRIVATE LIMITED',
    'MOCLIENT SOLUTIONS PRIVATE LIMITED',
    'ETRANS GLOBAL PRIVATE LIMITED',
    'GOSFORTH DEVELOPERS PRIVATE LIMITED',
    'SANSCORP INDIA PRIVATE LIMITED',
    'GEMS WEALTH ADVISORY PRIVATE LIMITED',
    'ENWAL SECURE SOLUTIONS PRIVATE LIMITED',
    'KGA MANAGEMENT SERVICES PRIVATE LIMITED',
    'OMICSGEN LIFESCIENCES PRIVATE LIMITED',
    'ACUMEN EVENT MANAGEMENT PRIVATE LIMITED',
    'VIRUTHAKULANGARA FAMILY FOUNDATION',
    'WHITE UNICORN ENTREPRENEURSHIP DEVELOPMENT FOUNDATION',
    'CHOICE BPO SERVICES PRIVATE LIMITED',
    'AIOLOS SOLUTIONS PRIVATE LIMITED',
    'BOHRA BROS FILMS (OPC) PRIVATE LIMITED',
    'WAYFAR CONSULTING PRIVATE LIMITED',
    'PARAMVAH NETWORKS PRIVATE LIMITED',
    'BEST HOUSEKEEPING PRIVATE LIMITED',
    '5FINGER',
    'N SOIL FOUNDATION',
    'BRO MOBILE TRADING PRIVATE LIMITED',
    'REXLIDE PRIVATE LIMITED',
    'PDQ SOFTECH PRIVATE LIMITED',
    'DECCANSOLS SERVICES PRIVATE LIMITED',
    'DYOK SYSTEMS PRIVATE LIMITED',
    'NOETIC LABS PRIVATE LIMITED',
    'DILLY LEARNING PRIVATE LIMITED',
    'INDIPOLL COMINFRA PRIVATE LIMITED',
    'NESBA HEALTHCARE PRIVATE LIMITED',
    'SILARIS CLOTHING PRIVATE LIMITED',
    'COQUBE ANALYTICS AND SERVICES PRIVATE LIMITED',
    'CALYXPOD TALENT SOLUTIONS PRIVATE LIMITED',
    'KAPYNAG PHARMA PRIVATE LIMITED',
    'ADITYA BIOINNOVATION PRIVATE LIMITED',
    'KALINGA HR SOLUTION PRIVATE LIMITED',
    '39S EDUCATE EMPOWER ENLIGHTEN FOUNDATION',
    'COVA MEDICARE PRIVATE LIMITED',
    'SHANTISAGAR MARAINS PRIVATE LIMITED',
    'Rainbow holographix pvt ltd',
    'Back rx spine care private limited',
    'Srijan boarding houses private limited',
    'Sivasundar private limited',
    'Vizrt india private limited',
    'INTEGRAL ADVISORY SERVICES PRIVATE LIMITED',
    'Alphamatters advisors private limited',
    'G g associates private limited',
    'Nature wanderers private limited',
    'VINSPIRER SECURITY SOLUTION PRIVATE LIMITED',
    'Superlative consultancy private limited',
    'Effectual legal services private limited',
    'T & t consultants private limited',
    'Meltbook convergence private limited',
    'Indtech aviation training services private limited',
    'Vasavi foundation for empowerment',
    'Camas media private limited',
    'Kashyap tele-medicines limited',
    'Iti limited',
    'Bharat electronics limited',
    'Auro laboratories limited',
    'Premier limited',
    'Jullundur motor agency (delhi) ltd (trs. co.-delhi to harana)',
    'Nhpc limited',
    'SAMPANN UTPADAN INDIA LIMITED',
    'Linde india limited',
    'Kolte-patil developers limited',
    'D. d. ventures limited',
    'Golden bull research & growth limited',
    'Soni medicare limited',
    'AVRO COMMERCIAL CO PRIVATE LIMITED',
    'MODISON LIMITED',
    'Dish tv india limited',
    'M b commercial co ltd',
    'Sulabh impex limited',
    'Abhinandan exports limited',
    'Gujarat pipavav port limited',
    'Shipping corporation of india limited',
    'Beardsell limited',
    'Quick return investment company limited',
    'Stel holdings limited',
    'Mediaone global entertainment limited',
    'Cheviot co ltd',
    'Winmore leasing and holdings limited',
    'Kjmc corporate advisors (india) limited',
    'Badridas investment co ltd',
    'Shailja commercial trade frenzy limited',
    'Wep solutions limited',
    'Ajcon global services ltd',
    'EMKAY CONSULTANTS LTD',
    'Unnati mercantile limited',
    'Medicamen biotech limited',
    'MPS PHARMAA LIMITED',
    'Everest industries limited',
    'Ttk prestige limited',
    'Snl bearings limited',
    'Sarthak global limited',
    'Kjmc financial services limited',
    'KHANDELWAL BUSAR INDUSTRIES PRIVATE LIMITED',
    'ARGENTIUM INTERNATIONAL PRIVATE LIMITED',
    'Ing bpo services india private limited',
    'Ilhas infrastructure and realty private limited',
    'Orange sorting machines india private limited',
    'Chandan transport private limited',
    'Kpc holdings pvt ltd',
    'Star abasan private limited',
    'Transcendent condominiums private limited',
    'Tara workspaces private limited',
    'Precise estates private limited',
    'Sjs healthcare limited',
    'Astra buildwell private limited',
    'Agarwal motor finance private limited',
    'Kpc securities private limited',
    'Garg realtors private limited',
    'M a projects private limited',
    'Precious infrastructures private limited',
    'K b s infrastructure private limited',
    'Rashmi care infratech private limited',
    'Topview financial services private limited',
    'Caladium investments pvt ltd',
    'M.s. industrial products private limited',
    'Aakriti infrabuild private limited',
    'Viridian holdings private limited',
    'Velox infraprojects private limited',
    'Kumbh commercials pvt ltd',
    'Skylark housing development private limited',
    'Cross finance pvt ltd',
    'Gkcl stock broking private limited',
    'Rahul financial services pvt ltd',
    'Kamiko investment and trading pvt ltd',
    'GEON',
    'S VILLAS & PROPERTIES PRIVATE LIMITED',
    'GEMI',
    'S AUTOMOTIVES PVT LTD',
    'Rockmount infratech limited',
    'Hajira radiators private limited',
    'Haco machinery private limited',
    'Trafag controls india private limited',
    'Victora components private limited',
    'Infrastructure hydraulic supplies india private limited',
    'Flash viven machining technologies private limited',
    'Be india private limited',
    'Zeon belts private limited',
    'Kallows engineering india private limited',
    'MSL DRIVELINE SYSTEMS LIMITED',
    'Centroid consultants private limited',
    'Dsk infotech private limited',
    'Revos aqua systems private limited',
    'Insmart systems india private limited',
    'Tkva rubber machinery private limited',
    'Calorie hnt private limited',
    'Mansfield cables company limited',
    'Emco electro dyne private limited',
    'P.p. industries private limited',
    'Jems pumps and electricals private limited',
    'Bch electric limited',
    'Precise automation & control private limited',
    'Karaikal power company private limited',
    'Dee comtech systems private limited',
    'Suravi electricals private limited',
    'Envirex india private limited',
    'Sun filtration private limited',
    'Ideal textile machinery components pvt ltd',
    'K.boiler components pvt ltd',
    'Sun dweep engineers private limited',
    'BHARAT INSULATION COMPANY (INDIA) PRIVATE LIMITED',
    'ADINATH ELECTRICALS PRIVATE LIMITED',
    'Tushar engineering private limited',
    'Gurukrupa enginers private limited',
    'Himalaya stone crushers private limited',
    'Modern science apparatus private limited',
    'Yunca machinery manufacturing private limited',
    'Shree radhekrishna extrusions private limited',
    'Maschinen fabrik india pvt ltd',
    'Uniwrap systems private limited',
    'Spa treatments private limited',
    'Snowfall merchants private limited',
    'GRAVITY RAIL INFRA AND ADVISORY PRIVATE LIMITED',
    'Splendor commodities private limited',
    'VICTORIAFALLS INGREDIENTS PRIVATE LIMITED',
    'Ekato india private limited',
    'Theo solutions private limited',
    'Jagdamba commodities private limited',
    'Beharilal madanlal jaipuria limited',
    'D n ramesh merchandise private limited',
    'Shrimay enterprises private limited',
    'BVK MERCANTILE PRIVATE LIMITED',
    'Metro shopping arcade private limited',
    'Axle merchants private limited',
    'Success commosales private limited',
    'Quality dealcom private limited',
    'Quick commosales private limited',
    'Mayurpankh tradelink private limited',
    'Innovative commosales private limited',
    'Jalan exports private limited',
    'Prudent commodeal private limited',
    'Growth dealcom private limited',
    'Rajlaxmi vanijya private limited',
    'Styleshore emarketing private limited',
    'Tirupati tradecomm private limited',
    'Maa durga dealcom private limited',
    'Vidhata sales private limited.',
    'Mountview mercantile private limited',
    'Amj resources pvt ltd',
    'Gliding garments private limited',
    'PANDA RETAIL PRIVATE LIMITED',
    'Multicon exports private limited',
    'Aquasan technologies private limited',
    'Evernew commercial private limited',
    'Wellman trading private limited',
    'Hi-rise vintrade private limited',
    'Iconic suppliers private limited',
    'Spark trading private limited',
    'Precision biometric india private limited',
    'Apeejay oxford bookstores private limited',
    'Bhima boutique private limited',
    'Ck pearls & gems private limited',
    'Monitor tradecom private limited',
    'YUNNAI TRADING PRIVATE LIMITED',
    'Wondersoft barter private limited',
    'Strongwell marketing private limited',
    'Sitaramapada agencies private limited',
    'Wmw business private limited',
    'A b hotels limited',
    'Sens udyog private limited',
    'D d resorts pvt ltd',
    'Ranbanka jodha hotels private limited',
    'Elixir hospitality management limited',
    'Rockland hotels limited',
    'Overflow vanijya private limited',
    'Malsi hotels limited',
    'Fressia sales private limited',
    'Afamado retail private limited',
    'Utopian creations private limited',
    'Topwell marketing private limited',
    'Southern super market private limited',
    'Vana resorts & hotels private limited',
    'CLUB RESORTO HOSPITALITY LIMITED',
    'Great country holidays & resorts private limited',
    'Young hospitech private limited',
    'Hotel la paz gardens private limited',
    'Nexia impex private limited',
    'Greentower vinimay private limited',
    'Gujarat eco resorts and hotels private limited',
    'Beeaar hospitality services private limited',
    'TARANGAN HOLIDAYS PRIVATE LIMITED',
    'Silkina commodeal pvt.ltd.',
    'Ethos limited',
    'Sterling hoteliers and investments pvt ltd',
    'Devi resorts private limited',
    'HOSPEDIA MEDICARE PRIVATE LIMITED',
    'Hpc enterprises private limited',
    'Mewar hotel pvt ltd',
    'Kavset exports private limited',
    'Retail one india private limited',
    'Brajbhumi nirmaan private limited',
    'Gooddeal dealtrade private limited',
    'Gateway tradecomm private limited',
    'Silverlake suppliers private limited',
    'Joshi auto scans private limited',
    'U and i resorts private limited',
    'Munjoh resorts private limited',
    'Kidim india private limited',
    'Deluxe caterers private limited',
    'Rainbow beach holiday home pvt ltd',
    'Optus hotels private limited',
    'Solace hotels and hospitality services private limited',
    'Maheshwari foods and hospitality private limited',
    'Naturebloom hotel and resorts privat limited',
    'Re india hospitality private limited',
    'Wamika hospitality private limited',
    'Max ventures private limited',
    'Satguru tourist services private limited',
    'Rajneesh transport pvt ltd',
    'Sai service private limited',
    'Gokhale recreational resorts private limited',
    'Risan hospitalities private limited',
    'Ritz marketing solutions private limited',
    'Manitowoc india private limited',
    'Khaitan land limited',
    'Maple odc movers private limited',
    'Kelachandra logistics private limited',
    'Amrit transport company pvt ltd',
    'Arc parcel service private limited',
    'New kenilworth hotel (coimbatore) private limited',
    'Time tower estate management services private limited',
    'Krishna spacecon private limited',
    'WAE LIMITED',
    'Madhuri finserve private limited',
    'Neelkanth outsourcing services private limited',
    'Spire technologies and solutions private limited',
    'Sat microsystems private limited',
    'Configaware business consultancy private limited',
    'Woosun electrics (india) private limited',
    'Nixon biotech private limited',
    'Allegorical solutions private limited',
    'Excede web services private limited',
    'Isenses incorporation private limited',
    'Renaissance management consultants limited',
    'Solidus consult private limited',
    'Remote programmer private limited',
    'Quadro info technologies private limited',
    'Almighty techserv private limited.',
    'Sunray gram infratech private limited',
    'Reliant electronic design services private limited',
    'Opportunity international india private limited',
    'Sma management services private limited',
    'Agre strategies private limited',
    'M.m.muthiah research foundation',
    'Amoha education private limited',
    'The economy and policy research foundation',
    'Alacrity corporate solutions private limited',
    'Theysohn extrusionstechnik (india) private limited',
    'Okruti it consulting private limited',
    'Ecare softech private limited',
    'Fore consultants private limited',
    'Mb informatics private limited',
    'New prime digisoft private limited',
    'Obbserv online services private limited',
    'N a m s financial advisors private limited',
    'Cybrain software solutions private limited',
    'Panchavaktra logistics limited',
    'Indasia fund advisors private limited',
    'Antara senior living limited',
    'Radiation projects private limited',
    'Lombardi engineering india private limited',
    'Sourcehov india private limited',
    'Softlogic systems private limited',
    'Nutech eco-clean limited',
    'Dream soft4u private limited',
    'Veritaz trading & exim private limited',
    'Fruitful marketing private limited',
    'Wi not beverage solutions private limited',
    'Vendere sales services (india) private limited',
    'BRAITHROWE BUSINESS SERVICES PRIVATE LIMITED',
    'Sprouted consulting solutions private limited',
    'GIGLIGHT RESOURCES PRIVATE LIMITED',
    'Litejoy international private limited',
    'Bizancial consulting private limited',
    'JINDAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'Ski consultancy services limited',
    'Hindustan information technology private limited',
    'Bhakti management services private limited',
    'Asc technology solutions private limited',
    'Prudent management strategies private limited',
    'Srims estates private limited',
    'Flexiele consulting services private limited',
    'Ott logistics india private limited',
    'Tracers consulting private limited',
    'Adapt software india private limited',
    'Hbg knowledge services private limited',
    'Farm and garden technologies private limited',
    'Bluepi consulting private limited',
    'Adamas events private limited',
    'Maxsol financial consulting private limited',
    'CSMART LEGALSOFT PRIVATE LIMITED',
    'Nutrikraft india private limited',
    'Tapasya business solutions private limited',
    'Modlingua learning private limited',
    'Boston technologies private limited',
    'VAAR CORPORATE SOLUTIONS PRIVATE LIMITED',
    'Gna management services private limited.',
    'Vserve management private limited',
    'Topmost consultants private limited',
    'Net2source consulting limited',
    'Agarwal taxcon private limited',
    'Integrated casetech consultants private limited',
    'STRATEGISM INDIA PRIVATE LIMITED',
    'Hermes media private limited',
    'Life skills consultants private limited',
    'Uvva infotech private limited',
    'Avake security solutions private limited',
    'Mahima consultants pvt ltd',
    'Jkg services pvt. ltd.',
    'Tornado consultants ltd',
    'Bavishi consultants pvt ltd',
    'Careernet technologies private limited',
    'GURUKUL CONSULTANT PRIVATE LIMITED',
    'Fcom technology private limited',
    'Ekta commercial consultants private limited',
    'Bgr boilers private limited',
    'Nebb engineering india limited',
    'Z-tech engineering services private limited',
    'Rockmetal engineers private limited',
    'Bhadoria engineering services private limited',
    'Offshore engineering design and energy consultants private limited',
    'Hevea engineering works private limited',
    'Mott macdonald private limited',
    'Effipress engineering private limited',
    'Madhunil engineering services private limited',
    'Recon business advisory private limited',
    'Tirupathi balaji realtor private limited',
    'Vinay buildcon private limited',
    'B-one business house private limited',
    'Vadivu food oils private limited',
    'Purvanchal aromatics pvt ltd',
    'Sri divakara fisheries private limited',
    'Shriram coconut products limited',
    'Workplace solutions private limited',
    'G. s. tracon private limited',
    'Lingraj food products private limited',
    'Agrisun commodities private limited.',
    'Amrit supply company pvt ltd',
    'Ashian oils private limited',
    'New media broadcasting private limited',
    'DREAM FINCAP PRIVATE LIMITED',
    'Madgul minerals pvt ltd',
    'Shivam minerals and allied industries private limited',
    'Convenio foods international private limited',
    'Invogue garments india private limited',
    'Elite natural private limited',
    'Earth mineral resources private limited',
    'LAVIOSA INDIA PRIVATE LIMITED',
    'Avalor health care private limited',
    'Kap cones private limited',
    'Rozy food processing private limited',
    'Fruition natural extracts private limited',
    'Vinod kumar and brothers pvt ltd',
    'Charanjit foods and resorts private limited',
    'RAW PRESSERY PRIVATE LIMITED',
    'Bkg mining private limited',
    'LASER POWER & INFRA PRIVATE LIMITED',
    'Ambrozia delicacies private limited',
    'Sj protein solutions private limited',
    'Sona beverages private limited',
    'SHEEL OIL & FATS PRIVATE LIMITED',
    'IPL SUGARS AND BIOFUELS LIMITED',
    'Star synthetics pvt ltd',
    'Akshara spinning mills private limited',
    'Sahana clothing company private limited',
    'Hr polycoats private limited',
    'Echjay chem impex private limited',
    'Prime cottons private limited',
    'Jagdamba textiles private limited',
    'Paramount textile mills private limited',
    'Sree kaderi ambal mills private limited',
    'SRI SARAVANA MILLS PRIVATE LIMITED',
    'Coimbatore nonwovens private limited',
    'Amicus natural products private limited',
    'Suvidhi synthetics private limited',
    'Arun textiles private limited',
    'Shree kuber products private limited',
    'Peitho foods private limited',
    'Gopala fresh produce private limited',
    'Inder agro private limited',
    'Vsa foods & beverages private limited',
    'Sargodha oil mills private limited',
    'Aashwina construction private limited',
    'Sneha property dealers private limited',
    'Halcyon condominiums private limited',
    'Cornerstone shelters private limited',
    'Shriprop malls private limited',
    'Rojas engineers private limited',
    'Shriprop structures private limited',
    'Good earth eco developments private limited',
    'Dream flower housing projects private limited',
    'Psc properties private limited',
    'Hazira cryogenic engineering and construction management pvt ltd',
    'Vindeep developers private limited',
    'Smita infrastructure private limited',
    'SAFEGUARD BUILDERS PRIVATE LIMITED',
    'Ltbr developers private limited',
    'Transform projects private limited',
    'Substance infratel private limited',
    'Concorde buildcon private limited',
    'K.n. multiprojects and infrastructure private limited',
    'Regent township private limited',
    'Kankani developers private limited',
    'Neemrana estate private limited',
    'Gvpr engineers limited',
    'Pooshya exports private limited',
    'Shiva parvathi construction company private limited',
    'R r constructionsf and housing private limited',
    'Khivraj estates private limited',
    'Manikandan residencies development private limited',
    'Om shakthy fire realty private limited',
    'Srinivasan associates private limited',
    'Eldeco sidcul industrial park limited',
    'S.k.jain constuctions private limited',
    'Shri ashtapad properties private limited',
    'Cyberthink properties private limited',
    'Anamitra warehousing private limited',
    'Jmv land developers private limited',
    'Alacrity real estate private limited',
    'Sarth india limited',
    'Sarang fine homes private limited',
    'Spenta heights private limited',
    'Pinnacle piling (india) private limited',
    'Nirmal sahana builders private limited',
    'Dpj-dra tollways private limited',
    'Isha realtors private limited',
    'Egis road operation india private limited',
    'B p k infrastructures private limited',
    'Rida builders and promoters private limited',
    'Theme infraprojects private limited',
    'Warora-chandrapur-ballarpur tollroad limited',
    'Eisha structures limited',
    'Divine energy & infrastructure development private limited',
    'Bengal pragati infrastructure development limited',
    'Pragati social infrastructure & development limited',
    'Mahalaxmi tele infra private limited',
    'Green soul life spaces private limited',
    'Neelanchal con-tech private limited',
    'Psv projects private limited',
    'Anish scaffolding india private limited',
    'Creative power engineers private limited',
    'Anpad property ventures private limited',
    'Bhimaas engineering and projects private limited',
    'AKASH INFRA-PROJECTS LIMITED',
    'Inventure sejal realtors private limited',
    'FSD LIFESPACES PRIVATE LIMITED',
    'AQAAB GRIH NIRMAN PRIVATE LIMITED',
    'Cerebrum techstates private limited',
    'Shp properties private limited',
    'Sreepower infratech india private limited',
    'Alps prime spaces private limited',
    'Ramky multi product industrial park limited',
    'S&s green projects private limited',
    'Sehore kosmi tollways limited',
    'Ima projects private limited',
    'Add industrial park (tamil nadu) limited',
    'Dhobitalao buildings private limited',
    'Promag progressers facility services private limited',
    'Zuari infraworld india limited',
    'Mahindra world city (maharashtra) limited',
    'Raheja developers limited',
    'Jai bharat developers private limited',
    'NUMBER ONE ENTERPRISES PRIVATE LIMITED',
    'Him shikhar construction private limited',
    'Forest peace developers private limited',
    'One-o-one infraspace private limited',
    'A&t engineering private limited',
    'Inspire infraestates private limited',
    'Kashipur sitarganj highways private limited',
    'Salasar highways private limited',
    'Royaume estates private limited',
    'Klarissa property developers private limited',
    'Application nexus webservices private limited',
    'Tvc infra and realty limited',
    'Aktis engineering solutions private limited',
    'FOUNDEVER BUSINESS SERVICES OF INDIA PRIVATE LIMITED',
    'Manageserve technologies (india) private limited',
    'Kctronics innovative consultancy services private limited',
    'Jivox software india private limited',
    'ASTTECS COMMUNICATIONS PRIVATE LIMITED',
    'Wavemv solutions private limited',
    'ANAMITRA ESTATES AND DEVELOPERS PRIVATE LIMITED',
    'Xurmo technologies private limited',
    'Eka techserv private limited',
    'Ample softwares private limited',
    'Treble clef technology services private limited',
    'Longtail web services private limited',
    'Tarento technologies private limited',
    'Trivone digital services private limited',
    'Springpeople software private limited',
    'GOOGLE CONNECT SERVICES INDIA PRIVATE LIMITED',
    'Greyamp consulting services private limited',
    'Enfini technology solutions private limited',
    'Net cloud systems private limited',
    'Spider opsnet private limited',
    'Pixgrammer premedia private limited',
    'Q sufficit services (india) private limited',
    'Consultec esgisoft private limited',
    'Roomstonite ebookings private limited',
    'Think n solutions software private limited',
    'Webschedio india private limited',
    'Passportparking consulting private limited',
    'HIVETREE TECHNOLOGY PRIVATE LIMITED',
    'Nescode technologies private limited',
    'Kateel software private limited',
    'Coolminds technologies private limited',
    'VOLDUMAR PRIVATE LIMITED',
    'Ideonic systems private limited',
    'INTERNATIONAL BUSINESS SERVICES GROUP PRIVATE LIMITED',
    'Ontash india technologies private limited',
    'Activelobby information systems private limited',
    'Tetrixs technologies private limited',
    'Velvet bud technologies private limited',
    'Eben technologies private limited',
    'Spiralbean software solutions private limited',
    'Itrans learning solutions private limited',
    'Aptlogic enterprise solutions private limited',
    'Scenic technologies private limited',
    'Chintan systems private limited',
    'Advanced school of computer information india private limited',
    'Yogen babu securities private limited',
    'Labh software private limited',
    'Praxis interactive services private limited',
    'Softgainz technologies private limited',
    'Cgs infotech solutions private limited',
    'Live pages infotech private limited',
    'PHILLIPS MACHINE TOOLS INDIA PRIVATE LIMITED',
    'SUYOG COMPUTECH PRIVATE LIMITED',
    'Acceltree technologies private limited',
    'Infobridge solutions private limited',
    'Intellection software and technologies private limited',
    'Nitor infotech private limited',
    'CODITUDE PRIVATE LIMITED',
    'Nak software technologies private limited',
    'Bizlers technologies private limited',
    'SIERRA CONCEPTS E SOLUTIONS PRIVATE LIMITED',
    'Apitco limited',
    'S.v. electronics limited',
    'Infomerica (india) pvt ltd',
    'Techpoint solutions (india) private limited',
    'Ivrcl megamalls limited',
    'Smart information management systems (india) private limited',
    'Caliber technologies private limited',
    'Pentagram infotech private limited',
    'Alpha thought technologies private limited',
    'Techpeople solutions private limited',
    'Alacriti infosystems private limited',
    'J.v.s.infotech private limited',
    'Qvantel software solutions limited',
    'Ezen computer services private limited',
    'Infyz solutions private limited',
    'Revalsys technologies (india) private limited',
    'VIRTUOS DIGITAL LIMITED',
    'Solidcam software india private limited',
    'STOREWORKS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Foco it consulting services private limited',
    'NEVEXA DIGITAL PRIVATE LIMITED',
    'Valsatech software india private limited',
    'Sureminds solutions private limited',
    'Meticulous data works india private limited',
    'Marella softlabs private limited',
    'I28 technologies (india) private limited',
    'C&c technology private limited',
    'ULTRONIUM PRIVATE LIMITED',
    'Indchem software technologies limited',
    'Olympus premedia private limited',
    'Ec group datasoft private limited',
    'Itvillage.com private limited',
    'Raksha technologies private limited',
    'Netique infotech private limited',
    'Infokall enterprise solutions limited',
    'Kla-tencor software india private limited',
    'KERALA STATE WOMEN"S DEVELOPMENT CORPORATION LIMITED',
    'Chennai heritage',
    'New tirupur area development corporation limited',
    'Pankaj events & celebrations private limited',
    'Arun govil productions private limited',
    'Born free entertainment private limited',
    'Maiden drop entertainment & services private limited',
    'YASH RAJ FILMS PRIVATE LIMITED',
    'Film waves combine private limited',
    'Nylofilms private limited',
    'VRL MEDIA PRIVATE LIMITED',
    'Digital network associates private limited',
    'Conquest media house private limited',
    'Spectrum broadcast infrastructure services private limited',
    'Gobindas entertainment private limited',
    'Seven leisure private limited',
    'Itl holidays private limited',
    'Sherdan games park & holidays private limited',
    'Bharti telemedia limited',
    'Samwad media private limited',
    'Pacific India Event Managers Private Limited',
    'Second serve private limited',
    'Love music private limited',
    'Capitalworld media services private limited',
    'Motion philm cgi private limited',
    'Ef tourism and entertainment private limited',
    'Resonance india private limited',
    'Dar media private limited',
    'Transstadia boxing india private limited',
    'Automat turf management services private limited',
    'Virtual automation technologies private limited',
    'Global view consultant private limited',
    'Vimarsh development solutions private limited',
    'Sigma-hse (india) private limited',
    'Black belt commandos security systems private limited',
    'Sls transport training institute & consultancy private limited',
    'Duke india services private limited',
    'Daksha green enviro systems private limited',
    'Kia-training academy private limited',
    'Grameen pragati foundation',
    'Samira marketing advisory private limited',
    'Hvd distributors private limited',
    'Interface media & marketing private limited',
    'Spice pr advisors private limited',
    'Impelpro scm solutions private limited',
    'MYRAH SPA & PRODUCTS PRIVATE LIMITED',
    'Fast track corporate solutions private limited',
    'RHINEXA INDIA PRIVATE LIMITED',
    'Home fellas private limited',
    'Idhya eco living private limited',
    'Tbrc business research private limited',
    'Kgs charity foundation',
    'Siti maurya cable net private limited',
    'Vaibhav labour contractors private limited',
    'Intermodal logistics private limited',
    'HELP DESK CONSULTANTS PRIVATE LIMITED',
    'Systematica (india) consultants private limited',
    'AIDEMTEC SERVICES PRIVATE LIMITED',
    'Tivre business solutions private limited',
    'Stemade biotech private limited',
    'Glocal icd private limited',
    'Connect here 4 infoservices private limited',
    'Ashokasha exim pvt ltd.',
    'Yrf studios private limited',
    'Simtools private limited',
    'Aditya films private limited',
    'Patel polymers private limited',
    'Himalaya polyurethane private limited',
    'Shogun organics limited',
    'Servtech systems india private limited',
    'Vistara designs and investments private limited',
    'Fcg flameproof control gears private limited',
    'Twinkle chemi lab private limited',
    'Integrated automation systems (india) private limited',
    'A.t. trade overseas private limited',
    'Mech components private ltd',
    'Dhan shree impex pvt. ltd.',
    'Ati limited',
    'Aarvee denims and exports ltd',
    'Vasundhara rasayans limited',
    'Gayatri bioorganics limited',
    'Tanfac industries limited',
    'Colgate-palmolive (india) limited',
    'Tcp limited',
    'Ultramarine & pigments limited',
    'ZYDUS LIFESCIENCES LIMITED',
    'Square four projects india limited',
    'Heidelbergcement india limited.',
    'SHAH METACORP LIMITED',
    'Simplex castings limited',
    'Everest kanto cylinder limited',
    'PARLE INDUSTRIES LIMITED',
    'Usha martin education & solutions limited',
    'Gitanjali gems ltd',
    'Eldeco housing and industries limited',
    'Likhami consulting limited',
    'Golden crest education & services limited',
    'Ashirwad capital limited',
    'Bop information services private limited',
    'Technomart computech private limited',
    'Core value technologies private limited',
    'AIRLINQ SOFTWARE PRIVATE LIMITED',
    'Best institute of training & institutions private limited',
    'Laconic technology private limited',
    'Ditos technologies private limited',
    'Uc bar infotech private limited',
    'Sapphire infocom private limited',
    'Mediapro education technology private limited',
    'Contis technologies private limited',
    'Jvs technologies private limited',
    'Cross byrne design studios private limited',
    'Gurg software services private limited',
    'Volansys technologies private limited',
    'Nichetech computer solutions private limited',
    'Vinconnect technology services private limited',
    'Jyoti infosolution private limited',
    'HOMECARE SOFTWARE SOLUTIONS (HHAEXCHANGE) PRIVATE LIMITED',
    'Sanjeevani tech solutions private limited',
    'Seurata online private limited',
    'AKSA LEGACIES PRIVATE LIMITED',
    'Accord software and systems private limited',
    'Ids next business solutions private limited',
    'Qbar technologies private limited',
    'Orion infotech consultants private limited',
    'Quality software quality systems private limited',
    'Enstage software private limited',
    'Inquest technologies software private limited',
    'Prodat it solutions (india) private limited',
    'Ronanki infotech private limited',
    'MYSPACES INNOVATIONS PRIVATE LIMITED',
    'Emmes services private limited',
    'Nihon communication solutions private limited',
    'Soa it solutions private limited',
    'Vyoma technologies private limited',
    'D-ta vesaras solutions private limited',
    'Yulop websense solutions private limited',
    'Spectrus informatics private limited',
    'Qso technologies (india) private limited',
    'Kaseya software india private limited',
    'SYSTECH SERVICES PRIVATE LIMITED',
    'A.c.n. cable private limited',
    'Netsoft solutions india private limited',
    'Meltronics infotech private limited',
    'INFLOW TECHNOLOGIES PRIVATE LIMITED',
    'TELITICS TECHNOLOGIES PRIVATE LIMITED',
    'Meltwater software private limited',
    'A b logics private limited',
    'Embytes solutions private limited',
    'Kaynes embedded systems private limited',
    'Firstfocus bpo services (india) private limited',
    'Pronto software solutions private limited',
    'Deo - kin systems private limited',
    'Softcast technologies private limited',
    'Hygiea informatics private limited',
    'Hashedin technologies private limited',
    'Sohamsaa systems private limited',
    'Tejodaya systems private limited',
    'Geidea infotech private limited',
    'ET Marlabs Private Limited',
    'Accure private limited',
    'Avish websoft private limited',
    'Edunetwork private limited',
    'Consilient technologies private limited',
    'RABBIT ENTERPRISES PRIVATE LIMITED',
    'CARDINAL HEALTH INTERNATIONAL INDIA PRIVATE LIMITED',
    'Supernal technologies private limited',
    'Nineleaps technology solutions private limited',
    'Tonse technologies private limited',
    'Trrow network technologies india private limited',
    'Sipss global india private limited',
    'Channelmax it solutions private limited',
    'Yobitel communications private limited',
    'Curio tech private limited',
    'INDIAN INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT KERALA (SEC 25COMPANY)',
    'Worldviewer dot com india private limited',
    'Codea technologies private limited',
    'Maestria information systems private limited',
    'Ortus telecom solutions private limited',
    'Loloos technolab private limited',
    'Armtech solutions private limited',
    'Interaxis networks private limited',
    'Network redux india private limited',
    'Cognicor technologies private limited',
    'Eseller technologies private limited',
    'Indea design systems private limited',
    'Torero softwares limited',
    'Mainstream technologies (india) private limited',
    'Megahertz systems private limited',
    'Finawis technologies private limited',
    'Chamunda tech-net services private limited',
    'Know all edge networks private limited',
    'Klug Avalon Mechatronics Private Limited',
    'Computer technologies private limited',
    'Rajdeep info techno private limited',
    'Medsynaptic private limited',
    'ALYX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Gurujiworld technologies private limited',
    'FABRICLORE RETAIL PRIVATE LIMITED',
    'ANGLIAN INDUSTRIAL INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED',
    'Rasa business innovations private limited',
    '360 degree expeditions private limited',
    'White house promoters private limited',
    'Global bliss services private limited',
    'Vch corporation private limited',
    'Alcraft marine private limited',
    'C doctor and company private limited',
    'Shree gajanan warehouse private limited',
    'Kalyx warehousing private limited',
    'Irm enterprises private limited',
    'Artsana india private limited',
    'Pouring pounds india private limited',
    'Disruptive analytics private limited',
    'Garg leisure & hospitality private limited',
    'S h a enterprises private limited',
    'Enviro infrastructure company limited',
    'SHREE GOPINATHJI AUTOMOBILES PRIVATE LIMITED',
    'Surat realators private limited',
    'Ark infracon private limited',
    'Preserve tele india private limited',
    'Civic india housing & infrastructure private limited',
    'Asteria real estates private limited',
    'Fabcity properties private limited',
    'Gcorp buildwell private limited',
    'Abhcon builders and developers private limited',
    'Ainsworth realtors private limited',
    'VAAYU VISION PRIVATE LIMITED',
    'Elvid properties pvt ltd',
    'Prabhu prarthna apartments private limited',
    'Radhe shyam property constructions private limited',
    'Lalani estates and constructions private limited',
    'Lalani constructions private limited',
    'Viva highways limited',
    'Shreenathji developers private limited',
    'Harbinger developers private limited',
    'Moon stone developers private limited',
    'Gammon projects developers limited',
    'Nirmal lifestyle developers private limited',
    'Gmd business link private limited',
    'Sanjeev realty private limited',
    'NOW REALTY LANDMARKS PRIVATE LIMITED',
    'Nirvana multicon private limited',
    'Skp corp private limited',
    'Ysg estates private limited',
    'Sant lal build tech construction coprivate limited',
    'Breeze constructions private limited',
    'Vridhi properties private limited',
    'Sia properties private limited',
    'Sizzling heights developers private limited',
    'Proconnect supply chain solutions limited',
    'Polestar maritime limited',
    'Sea syst engineering (india ) private limited',
    'Seapol port private limited',
    'Erco travels private limited',
    'Heritage river cruises private limited',
    'KAMA HOSPITALITY SERVICES PRIVATE LIMITED',
    'Coverground travanues private limited',
    'Intraglobe supply chain private limited',
    'T R Finished Vehicles Logistics Solutions Limited',
    'Four waves travels private limited',
    'Akr express private limited',
    'Mobar india limited',
    'Skan marine services pvt ltd',
    'Pangea shipping agencies p ltd',
    'Marine project services limited',
    'Seaport shipping private limited',
    'Deluxe roadlines private limited',
    'JAYNEER INFRAPOWER & MULTIVENTURES PRIVATE LIMITED',
    'Sairaj financial services private limited',
    'Tuticorin coal terminal private limited',
    'Dakshin bharat gateway terminal private limited',
    'Navkar container line private limited',
    'Budget integrated logistics private limited',
    'Mint aviation private limited',
    'Travelsmantra holidays private limited',
    'Duurbeen bespoke private limited',
    'Kuruma travels private limited',
    'Macwin logistics private limited',
    'Unique logistic solutions (india) private limited',
    'Big navigators private limited',
    'Sherif global services private limited',
    'Valueplus logistics india private limited',
    'Big escapades private limited',
    'Parikh travels and tours private limited',
    'Sampuran yatra private limited',
    'Siesta hospitality services limited',
    'Frontier holidays private limited',
    'Jun farms private limited',
    'Kimatram and sons private limited',
    'MARROTT',
    'NUT OUTSOURCE PRIVATE LIMITED',
    'Goverdhan infotech consultants private limited',
    'Digital strides private limited',
    'Real craft tech private limited',
    'Ion eight technologies private limited',
    'Whale graphics (india) limited',
    'Advantage computers(india) private limited',
    'Supernet infocomm private limited',
    'Shriv commedia solutions private limited',
    'Om innovation call services private limited',
    'Opshub technologies private limited',
    'Radiant info solutions private limited',
    'Shrishti softech solutions private limited',
    'Eninov systems private limited',
    'Smyl info services private limited',
    'Edgeways technologies private limited',
    'Britlogic technologies private limited',
    'TALYBONT STREAMS PRIVATE LIMITED',
    'DEO BIZ & SERVICES PRIVATE LIMITED',
    'Playhouse motion pictures private limited',
    'Spags trusteeship private limited',
    'THIRUMUDIVAKKAM INDUSTRIAL ESTATE MANUFACTURERS',
    'S EDUCATION PRIVATE LIMITED',
    'American international academy india private limited',
    'LXL IDEAS PRIVATE LIMITED',
    'Binary systems private limited',
    'BOOKS COACHINGS PRIVATE LIMITED',
    'Hexalearn solutions private limited',
    'Bragnam learning private limited',
    'Aradhana skills private limited',
    'Tictactoe education private limited',
    'S VCARE HEALTH CLINIC PRIVATE LIMITED',
    'EAST WEST INTEGRATIVE RESEARCH INSTITUTEPRIVATE LIMITED',
    'Shri kumaran medical centre private limited',
    'INDEAYOGA SPIRITUAL PRIVATE LIMITED',
    'Minim charitable foundation',
    'Yagil pharma care private limited',
    'Apollo health resources limited.',
    'Spandan- a cardiac centre private limited',
    'Paradise welfare association',
    'Agarsen social welfare association',
    'Dhariwal and doshi industries private limited',
    'Serene charitable foundation',
    'Information technology service management forum',
    'Herd educational and medical research foundation',
    'Wipro travel services limited',
    'Uttarakhand purv sainik kalyan nigam limited',
    'Baijnath plastic product private limited',
    'Srs diecasting private limited',
    'Varron industriies private limited',
    'Ahluwalia erectors and fabricators private limited',
    'ALUMINIUM POWDER COMPANY LIMITED',
    'Sree alloys precision india private limited',
    'Bagaria aluminium alloys private limited.',
    'Aline design private limited',
    'Ketan plastics pvt ltd',
    'Bmi cables private limited',
    'Jain autocastings private limited',
    'RARE SS PROPERTIES INDIA PRIVATE LIMITED',
    'Krebs engineering private limited',
    'Sujata commodity and derivaties private limited',
    'A g industries pvt ltd',
    'Sadhana castings pvt ltd',
    'Gromore founders and forgers private limited',
    'Akshaj jewels private limited',
    'Technico metals private limited',
    'Technico steels & alloys private limited',
    'Ibex engineering private limited',
    'Azalea enterprises private limited',
    'Alchemy projects private limited',
    'Mittal precision hitech steels private limited',
    'Este auto castings private limited',
    'Indo shell cast private limited',
    'Venkateswara steels and springs (india) private limited',
    'Raja sponge iron and energgy private limited',
    'MULTI SERVE ROLLS PRIVATE LIMITED',
    'Lakshmi steel industries private limited',
    'Maxtech fastners private limited',
    'ELTEK MOTOR (INDIA) PRIVATE LIMITED',
    'Workspace metal solutions private limited',
    'More modular homes private limited',
    'Johnshah containers pvt ltd',
    'Oriental multimodal transport private limited',
    'Universal precision screws private limited',
    'Idl explosives limited',
    'Atur india private limited',
    'Baycity engineering pvt ltd',
    'HIGHGRADE CONSULTANTS AND ENGINEERING PRIVATE LIMITED',
    'R.v. steels private limited',
    'L.g.b. auto products private limited',
    'Nutech polymers private limited',
    'Parshwanath metal processors (india) pvt ltd',
    'Hira global alloys private limited',
    'Arrow alloys pvt ltd',
    'Bajrang steelmet trading private limited',
    'Prakalp private limited',
    'Nikoo forge pvt ltd',
    'Rawmin mining and industries private limited',
    'Nextgen enercon technologies private limited',
    'Advice builtcare private limited',
    'Ambaji cements private limited',
    'Steadyline trading private limited',
    'New metal refinery (india) private limited',
    'Ogun steels private limited',
    'Nevatia udyog ltd',
    'Shentracon steel private ltd',
    'Micro mesh (india) private limited',
    'Skil founders private limited',
    'Vci springs india private limited',
    'Amit iron private limited',
    'Steelfab structurals (india) private limited',
    'Sol jewellery private limited',
    'Mahendra tools and machines(india)private limited',
    'Caem india shelving private limited',
    'Associated aluminium products private limited',
    'The metal powder company limited',
    'U D CAPS LIMITED',
    'Anand engineers private limited',
    'Auto coats systems india pvt ltd',
    'Apollo heat exchangers private limited',
    'Lagan engineering company limited',
    'Netrack enclosures private limited',
    'Ensons gages and tools private limited',
    'Gajjar tools private limited',
    'Pilotsmith (india) private limited',
    'CONMAT OIL & GAS PRIVATE LIMITED',
    'Gnat foundry private limited',
    'Shiva drums private limited',
    'Chetna print-pack private limited',
    'Volmac castings private limited',
    'GODAWARI TECHFAB PRIVATE LIMITED',
    'Sea hydropower manufacturiing private limited',
    'Rajoo bausano extrusion private limited',
    'ESPM SENSE PRIVATE LIMITED',
    'Gayatri auto components private limited',
    'Flexican bellows and hoses private limited',
    'Axwel india private limited',
    'Narayan industries pvt ltd',
    'DELLNER HYDRATECH INDIA PRIVATE LIMITED',
    'Lehry instrumentation and valves private limited',
    'ADIGANGA PROPERTIES PRIVATE LIMITED',
    'Techtronics(india) limited',
    'Dy auto india private limited',
    'TIMKEN GGB TECHNOLOGY PRIVATE LIMITED',
    'MOL SHIPPING (INDIA) PRIVATE LIMITED',
    'Aerovent projects private limited',
    'CORON COOLING TOWERS PRIVATE LIMITED',
    'Cochin fire tech india private limited',
    'BEKO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Belting enterprises private limited',
    'Alexandra scale pvt ltd',
    'SUEZ INDIA PRIVATE LIMITED',
    'Absterge acme filters india private limited',
    'Aalekh vanijya private limited',
    'Abhiruchi dealers private limited',
    'Arham vinimay private limited',
    'Achivement vinimay private limited',
    'Abhinandan vincom private limited',
    'Ativir suppliers private limited',
    'Aegis vyapaar private limited',
    'Ambition goods private limited',
    'Batan traders pvt ltd',
    'Ease dealcom private limited',
    'Shri durga trade links private limited',
    'Prathmesh barter private limited',
    'Manipura commercial private limited',
    'Logwood vinimay private limited',
    'Reality merchants private limited',
    'Lexus tradelink private limited',
    'Bengal lloyd lines international private limited',
    'Sree lakshmi energy systems private limited',
    'Discovery distributors private limited',
    'Vvs marketing private limited',
    'Formative engineering private limited',
    'Bit tul private limited',
    'Joseph leslie dynamiks manufacturing private limited',
    'Abn motors private limited',
    'Silver arrow automobiles private limited',
    'August industries private limited',
    'Abhishek stock investments pvt.ltd.',
    'Arihant business pvt ltd.',
    'Acacia wine cellars private limited',
    'Amfora wine and foods pvt ltd',
    'Shri mahalaxmi autotech private limited',
    'Diamond autotech solution private limited',
    'Anand limited',
    'KHYATI INFRACON PRIVATE LIMITED',
    'Mangla brothers private limited',
    'Sudipta traders pvt ltd',
    'Snowtex tradelink pvt ltd',
    'Jatti motors private limited',
    'Startrack vinimay pvt ltd',
    'Netcom infotech private limited',
    'Banerjee exports private limited',
    'Xanti commercial private limited',
    'Atradex commodities private limited',
    'Bps international private limited',
    'Subala engineering private limited',
    'HIKA LCM TECHNOLOGIES PRIVATE LIMITED',
    'Janta snack foods private limited',
    'Mustafa marketing private limited',
    'Sr marine foods private limited',
    'Complete spice solutions india limited',
    'Arkaaye impex private limited',
    'Ashutosh trademart private limited',
    'Eramet india private limited',
    'Dnd exim private limited',
    'Gdr home fashions private limited',
    'SUMMIT MARITIME PRIVATE LIMITED',
    'Fig leaf marketing private limited',
    'Jayashree polymer exports private limited',
    'H r organo chem private limited',
    'Smr solutions private limited',
    'Dci india private limited',
    'Tunisu impex pvt ltd',
    'Ganga ram silk mills pvt ltd',
    'Lupine merchants private limited',
    'Northstar vinimay private limited',
    'Enclave tradecom private limited',
    'Federal agency private limited',
    'Lahar exports private limited',
    'Yukti medical innovations private limited',
    'CML BIOTECH LIMITED',
    'Themis distributors private limited',
    'Surat hira bourse',
    'Urjita electronics private limited',
    'NETMEDS HEALTHCARE LIMITED',
    'Kse electricals pvt.ltd.',
    'Laxmi dental laboratory private limited',
    'Sarda metals & alloys limited',
    'Maneswari trading company (a private company)',
    'Anika firetech private limited',
    'Gns telecom private limited',
    'Ozin cables & wires private limited',
    'Planet pure impex private limited',
    'Hank impex private limited',
    'Gopal traders private limited',
    'Mafatlal services limited',
    'Jubilee exports private limited',
    'Amman-try trading company private limited',
    'S.t.unicom private limited',
    'Emjay trading and investments private limited',
    'Girishad mercantile private limited',
    'Vsn commercials private limited',
    'Mohar export services pvt ltd',
    'Dalmia exim limited',
    'Dolphin offshore shipping limited',
    'Planet express private limited',
    'Jaipur gemstone exchange',
    'Elrose mercantile pvt ltd',
    'Adept artvertising solutions private limited',
    'Datapoint impex private limited',
    'Manshi electronics private limited',
    'Trium innovations private limited',
    'Gift links (india) private limited',
    'Saavy trade-invest private limited',
    'Gupta international industries limited',
    'Shah narotamdas harjivandas chemplast private limited',
    'R. CAMBRAY & CO PVT LTD',
    'Shah mobikes private limited',
    'Jive properties and trading company private limited',
    'Ballet properties and trading private limited',
    'Labharti realties private limited',
    'Dronagiri properties private limited',
    'Supermax conchem private limited',
    'Nirban infrastructure private limited',
    'Indelible realtors private limited',
    'Gemstone real estate private limited',
    'NEUMEC LANDMARK PRIVATE LIMITED',
    'Sanahind realty and infrastructure private limited',
    'Madhur enclave private limited',
    'Rituraj complex private limited',
    'Prachi housing private limited',
    'Purnima promoters private limited',
    'Lanson homes private limited',
    'Mytrah vayu (gujarat) private limited',
    'S r mechanicals private limited',
    'Alternate power solutions private limited',
    'Relyon solar private limited',
    'Arunodaya techsolar power projects private limited',
    'Athena infraprojects private limited',
    'Parot power private limited',
    'Cochin waste 2 energy private limited',
    'Awt energy private limited',
    'H2e power systems private limited',
    'Vayu urja bharat private limited',
    'Sanjay eco green power private limited',
    'CONSERVE ENERGY INTERNATIONAL PRIVATE LIMITED',
    'Deoghar mega power limited',
    'Abellon co-gen limited',
    'Asc power private limited',
    'Mangi winds private limited',
    'Bhrama winds private limited',
    'ECOREN GUSTY WIND PARKS PRIVATE LIMITED',
    'Aura winds private limited',
    'Jwalya winds private limited',
    'Cleantech ventures private limited',
    'Pearl generators private limited',
    'Oceanic enviro (india) private limited',
    'CN WATER SYSTEMS PRIVATE LIMITED',
    'Jalshree corporation private limited',
    'Teja chloro industries private limited',
    'Shilpi property developers (bombay) private limited',
    'Eskay infrastructure development private limited',
    'Bscpl aurang tollway limited',
    'Indo jatalia commodities limited',
    'B. m. gupta builders private limited',
    'KANUPRIYA CONSULTANTS PRIVATE LIMITED',
    'Imagination infratech private limited',
    'I carve projects private limited',
    'Dms projects private limited',
    'Brentford construction private limited',
    'Tvastar infratech private limited',
    'Synergy infraspace private limited',
    'MP INFRAPROJECTS PRIVATE LIMITED',
    'TECHNO AMI SOLUTIONS PRIVATE LIMITED',
    'Jains & alliance palms venture private limited',
    'Alliance budget housing india private limited',
    'Neelanchal regency park private limited',
    'Acecrete adhesions india private limited',
    'Cornerstone property developers private limited',
    'Partract estates and investments private limited',
    'Viram international private limited',
    'Safal developers pvt.ltd.',
    'Raja-nava developers pvt ltd',
    'Style evershine builders private limited',
    'Aastitva builders and developers private limited',
    'Aangan properties private limited',
    'Aryan toll road private limited',
    'Atr infrastructure private limited',
    'Raghvendra construction company private limited',
    'Arti properties private limited',
    'Sankalpan infrastructure private limited',
    'Orbus property private limited',
    'Fobos properties private limited',
    'M.V.R. INFRASTRUCTURE AND TOLLWAYS LIMITED',
    'Sn engineering services pvt. ltd.',
    'CFM ESTATES PRIVATE LIMITED',
    'Netex infrastructures limited',
    'Good earth eco ventures private limited',
    'Br property developers private limited',
    'Pms homlandz private limited',
    'Alliance beverly constructions private limited',
    'Alliance assets management services private limited',
    'Ds max realty private limited',
    'Paarel fine living private limited',
    'Parshwa developers private limited',
    'Concept reality and securities private limited',
    'SHAMJI OPTIMA PRIVATE LIMITED',
    'V real estate (india) private limited',
    'Beau properties private limited',
    'Mainstream lifespace developers private limited',
    'Shraddha viniyog private limited',
    'Patmos realty private limited',
    'Beyond squarefeet mall management private limited',
    'Hycr premises private limited',
    'OT PARK PRIVATE LIMITED',
    'Nv mumbai estate private limited',
    'Nv spaces & realty private limited',
    'Raffles square development private limited',
    'Lotus landmarks (india) private limited',
    'Vascon infrastructure limited',
    'Oxford golf & resorts private limited',
    'Vivan properties private limited',
    'Gold coast projects private limited',
    'Silver sand dwellings private limited',
    'Greenway infratech (india) private limited',
    'Suchir tathva infra projects private limited',
    'Purna reality private limited',
    'Alka properties private limited',
    'Admirable tower private limited',
    'Ozone infrastructure private limited.',
    'Express builders and promoters private limited',
    'Greenfield infraprojects private limited',
    'Dreamz infra india limited',
    'Capital cliff private limited',
    'Green constro infra private limited',
    'Virajit pvt ltd',
    'Bengal shrachi housing development limited',
    'Kbr minerals india private limited',
    'Bellona estate developers limited',
    'Vertex realty advisors private limited',
    'Sunteck realty holdings private limited',
    'Iref knowledge services private limited',
    'Dhariwal lifespaces private limited',
    'Green acre properties private limited',
    'ABS MARINE SERVICES LIMITED',
    'Stallion offshore logistics private limited',
    'Emsons realty private limited',
    'E 3 i erp solutions private limited',
    'Jagtap infotech private limited',
    'Shreyas integrated systems private limited',
    'Indus systems and services private limited',
    'Cdp (india) private limited',
    'Xplore systems private limited',
    'Ul engineering services and software private limited',
    'FLUENTGRID LIMITED',
    'Safaltek software private limited',
    'Afore technical services private limited',
    'Ekon solutions india private limited',
    'Isione printech solutions private limited',
    'Osi networks private limited',
    'Skyward techno solutions private limited',
    'JOSHI BIZTECH SOLUTIONS LIMITED',
    'INDRA TELELINKS PRIVATE LIMITED',
    'Amar technolabs private limited',
    'Innkey infosystems private limited',
    'Millennium silicon services (india) private limited',
    'Rhodium infotech private limited',
    'Cgi information systems and management consultants private limited',
    'Microhard services private limited',
    'Ssg software systems private limited',
    'Nichi-in software solutions private limited',
    'Aec promag consultancy private limited',
    'Sumeru software solutions private limited',
    'It2automate.com private limited',
    'Mindworks solutions private limited',
    'Wifi networks private limited',
    'Tli software private limited',
    'Fortune pai software private limited',
    'VIMEO TECHNOLOGIES PRIVATE LIMITED',
    'Ver se innovation private limited',
    'Sitec technologies private limited',
    'Test yantra software solutions (india) private limited',
    'Winco software solutions private limited',
    'Mymo wireless technology private limited',
    'Synopsis technologies india private limited',
    'Wiselead it solutions private limited',
    'Newfound info tech private limited',
    'Tams infotech private limited',
    'Conflux technologies private limited',
    'TOYOTA CONNECTED INDIA PRIVATE LIMITED',
    'Opteamix india business solutions private limited',
    'Inteamo innovations & software private limited',
    'Talentpace private limited',
    'Kvn promo digital communications private limited',
    'Nals outdoors india private limited',
    'V2 conglomerate limited',
    'FLIPKART HEALTH LIMITED',
    'Verma real estate private limited',
    'Mahindra defence systems limited',
    'Triumphant institute of management education private ltd.',
    'Bion creations private limited',
    'VIJYOTI MANAGEMENT & COMMUNICATIONS LEARNING INSTITUTE PRIVATE LIMITED',
    'Born to win learning services private limited',
    'Hello kids education india private limited',
    'Gokul kidz education private limited',
    'Ocean host management and education private limited',
    'ANUVAC CONFAB WORLDWIDE PRIVATE LIMITED',
    'Maverick edutech private limited',
    'Christel house india',
    'BHARTIYA ENTERPRISES PRIVATE LIMITED',
    'Aequs private limited',
    'Kara learning private limited',
    'Empowered skills private limited',
    'SRUSHTI ENGINEERING INNOVATIONS PRIVATE LIMITED',
    'Venkatachalapathy educational development association',
    'I.t. pathshala private limited',
    'Shrimati sulochana devi education foundation',
    'Cert team development (india) private limited',
    'Academy of engineering competence private limited',
    'NC MUSINGS PRIVATE LIMITED',
    'Goloka education private limited',
    'NEPTUNESHIP AGENCY PRIVATE LIMITED',
    'Prayas art foundation',
    'Moolchand group foundation',
    'CADABAM',
    'S MEDICARE LIMITED',
    'Artemis medicare services limited',
    'Ratnamani medi service private limited',
    'Bbr (india) private limited',
    'Sabre marketing services private limited',
    'Flowserve india controls private limited',
    'Vasudeva vilasam aryavaidyasala private limited',
    'Vaikom hospital and health care private limited',
    'Mani infotech private limited',
    'Virtus wellness private limited',
    'Good shepherd hospitals private limited',
    'Cethar healthcare services private limited',
    'Biotronik medical devices india private limited.',
    'Insta sculpt clinics private limited',
    'Pharmacare laboratories private limited',
    'Suchirindia foundation',
    'S SCIENCE PARK PRIVATE LIMITED',
    'Sports square private limited',
    'Hpa sports private limited',
    'Multiplex cinevision private limited',
    'Alliance broadcasting private limited',
    'A lotus film company private limited',
    'Sree shyam sayi corporation private limited',
    'Sita technocrate services private limited',
    'WATER MANAGEMENT AND PLUMBING SKILL COUNCIL',
    'OBSERVERDAWN MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'Naman integrated management services private limited',
    'Gyankul network private limited',
    'Kernel insights private limited',
    'Apriyant technologies private limited',
    'SPECTRUM PROGROW ADVISORS PRIVATE LIMITED',
    'ACCELERATED CLEANING SYSTEMS (INDIA) PRIVATE LIMITED',
    'Kromakay image salons private limited',
    'Aim illumination marvellous solutions private limited',
    'People 360 d consulting private limited',
    'Andrew wommack ministries india',
    'Integra recruiters private limited',
    'Hiraco renewable energy private limited',
    'Kotakurja private limited',
    'Shivam non conventional energy private limited',
    'Jalanidhi power project private limited',
    'Punjab hydro power private limited',
    'Auro mira energy and infrastructure india private limited',
    'Allison transmission india private limited',
    'Sri gomathi energy private limited',
    'Patel thermal energy private limited',
    'Greenergy wind corporation private limited',
    'Aravali power company private limited',
    'Vishwanath projects limited (part ix )',
    'Aheer energy private limited',
    'Intelizon energy private limited',
    'ECOREN CHINNAM WIND PARK PRIVATE LIMITED',
    'Greenera energy (india) private limited',
    'MSA BIO-ENERGY PRIVATE LIMITED',
    'Ind-barath power (konkan) limited',
    'Gurukripa windfarms developers private limited',
    'Jaishree windfarms developers private limited',
    'Krishna windfarms developers private limited',
    'Brightsolar renewable energy private limited',
    'Cleansolar renewable energy private limited',
    'Ss energy ventures private limited',
    'Ss wind energy private limited',
    'Rmd power infra private limited',
    'Sarayu wind power (tallimadugula) private limited',
    'Sarayu wind power (kondapuram) private limited',
    'Sri shirdi sai renewable energy private limited',
    'ECOREN ENERGY INDIA PRIVATE LIMITED',
    'Northstar solar power private limited',
    'IND-BARATH ENERGIES PRIVATE LIMITED',
    'Rdf power projects limited',
    'Suchand powergen private limited',
    'Dharmshala hydro power limited',
    'Samalpatti power company private limited',
    'Dayton thermosiphon private limited',
    'Spark conductors private limited',
    'United waters india private limited',
    'Rean watertech private limited',
    'Jayanti infrastructure private limited',
    'SIKKA PORTS & TERMINALS LIMITED',
    'Sri vani bhavani constructions private limited',
    'Universal engicon private limited',
    'Yashraj estates private limited',
    'Shaleen builders and developers private limited',
    'Chd retirement townships private limited',
    'Lohchab building company private limited',
    'Param estate private limited',
    'Laxmi infraspace private limited',
    'Apex tarmac private limited',
    'Bhumi procon private limited',
    'Jkm engineers private limited',
    'Mira mahal premises management private limited',
    'S & a builders and engineers private limited',
    'Bemisal premises private limited',
    'Sanghvi premises private limited',
    'Globus stores private limited',
    'Jangid estate private limited',
    'Vaithara builders and developers private limited',
    'Gl constructions private limited',
    'Mmk toll road private limited',
    'G and a developers private limited',
    'Rvs business architects india private limited',
    'Sanghvi habitats private limited',
    'Mhaiskar infrastructure private limited',
    'Ashapura habitats private limited',
    'Joy aman home creations private limited',
    'S.p.erectors and developers private limited',
    'MEXTECH REALTY PRIVATE LIMITED',
    'Kohinoor ctnl infrastructure company private limited',
    'Surana housing private limited',
    'Zone infracon private limited',
    'Rohan housing private limited',
    'Saishaa properties india private limited',
    'JAIPUR-MAHUA TOLLWAY LIMITED',
    'L v s infrastructure private limited',
    'Ramcons engineers & builders private limited',
    'R.G. HOUSING & INFRA PRIVATE LIMITED',
    'EDELWEISS RURAL & CORPORATE SERVICES LIMITED',
    'Mundeshwari multicon private limited',
    'Crown promotors private limited',
    'Sarvoch promotors private limited',
    'Sampark buildcon private limited',
    'Pivot buildcon private limited',
    'Shree mahesh realtors private limited',
    'Rps infrastructure ltd.',
    'Dnp constructions private limited',
    'Radheshyam travels private limited',
    'Sunny infrastructure private limited',
    'UNIQUE MERCANTILE INDIA LIMITED',
    'Raviraj infraproject private limited',
    'Himanshi property private limited',
    'Sarthav infrastructure pvt.ltd.',
    'Atmiya developers private limited',
    'Sonce technologies(india) private limited',
    'Net4site consulting india private limited',
    'Cito infotech private limited',
    'Green-estep technologies private limited',
    'Ndvor it solutions private limited',
    'Oakridge business solutions private limited',
    'Onebill software india private limited',
    'Andersard bpo india private limited',
    'Arista networks india private limited',
    '42gears mobility systems private limited',
    'Dbq technologies private limited',
    'Relevance lab private limited',
    'Truspeq consulting private limited',
    'Jbk infotech private limited',
    'Digital future of education private limited',
    'Gulbarga mega speed private limited',
    'CLOUDERA DATA PLATFORM INDIA PRIVATE LIMITED',
    'Tribune digital ventures software development center india private limited',
    'Smacera technologies consulting and services private limited',
    'Xyram software solutions private limited',
    'OAKNORTH (INDIA) PRIVATE LIMITED',
    'SPYKK MOBILE APP DEVELOPMENT LABS PRIVATE LIMITED',
    'LEEZA LIFESTYLE PRIVATE LIMITED',
    'ETERNITY FINESSE PRIVATE LIMITED',
    'YRITIS TECHNOLOGIES PRIVATE LIMITED',
    'BITOODLE ONLINE SERVICES PRIVATE LIMITED',
    'FUTUREGROW TAXCORP PRIVATE LIMITED',
    'KENOME TECHNOLOGIES PRIVATE LIMITED',
    'OCEAN NETWORK EXPRESS (INDIA) PRIVATE LIMITED',
    'SCNS PRIVATE LIMITED',
    'MINOSHIMA INDIA PRIVATE LIMITED',
    'BIZNOTION DIGITAL CONSULTING (OPC) PRIVATE LIMITED',
    'SERVOMAX LIMITED',
    'LEADTREE DIGITAL PRIVATE LIMITED',
    'QUICKSPACE INDUSTRIES PRIVATE LIMITED',
    'INTEGRUM LIFE SCIENCES PRIVATE LIMITED',
    'IMUONS WEB SOLUTIONS PRIVATE LIMITED',
    'SIDDH AYURVEDA PRIVATE LIMITED',
    'MEADPRO PRIVATE LIMITED',
    'GALACTIC SPORTS FEDERATION (INDIA)',
    'TRANSWIND TECHNOLOGIES PRIVATE LIMITED',
    'NOVAAONE CAPITAL PRIVATE LIMITED',
    'MANIKA VINAYAGAR HOTEL PRIVATE LIMITED',
    'AXIS WIND FARMS (MANIREVU) PRIVATE LIMITED',
    'GSQUARE INFRATECH PRIVATE LIMITED',
    'MIRAPRO INDIA PRIVATE LIMITED',
    'AAKALPA PACKAGING INDUSTRIES PRIVATE LIMITED',
    'MAGLOG LOGISTICS PRIVATE LIMITED',
    'DODWAL AND DODWAL TRADING PRIVATE LIMITED',
    'NEOPACK METALLIZING PRIVATE LIMITED',
    'AVAA POLYMERS INDIA PRIVATE LIMITED',
    'UPLGC TECHNOLOGIES PRIVATE LIMITED',
    'ENERGYMETEO CONTROL SOLUTION PRIVATE LIMITED',
    'IOO LABS PRIVATE LIMITED',
    'GREENIZON AGRITECH CONSULTANCY PRIVATE LIMITED',
    'ARYAGAMI CLOUD SERVICES PRIVATE LIMITED',
    'INTARGET MOBILITY SOLUTIONS PRIVATE LIMITED',
    'CYZERG INDIA PRIVATE LIMITED',
    'LIMOLINER INDIA PRIVATE LIMITED',
    'OSTRA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'EVOL TECHNOBITS DIGITAL PRIVATE LIMITED',
    'SUPRAES PRIVATE LIMITED',
    'AAROHIINFO FI MANAGEMENT LIMITED',
    'MANDEV SURGIPHARMA PRIVATE LIMITED',
    'LEAD GLOBAL PRIVATE LIMITED',
    'NATURE PLOTS PRIVATE LIMITED',
    'KAY IMAGERY AND TEXT EXPERT SERVICES PRIVATE LIMITED',
    'SINHA ROBOTICS PRIVATE LIMITED',
    'SPECTRAM TELECOM PRIVATE LIMITED',
    'MODERN ARCH INFRASTRUCTURE PRIVATE LIMITED',
    'LINKSIDES INFORMATIVE (OPC) PRIVATE LIMITED',
    'SIMPLISOL TECHNOLOGIES PRIVATE LIMITED',
    'PAYUMART ADVISORY PRIVATE LIMITED',
    'FRESHDATA WORKS PRIVATE LIMITED',
    'NUCLEON AI PRIVATE LIMITED',
    'SEMINAL TECHNOLOGY AND ENGINEERING PLASTICS PRIVATE LIMITED',
    'DEEPAK BUILDERS & ENGINEERS INDIA LIMITED',
    'GERMAN SPRINGS PRIVATE LIMITED',
    'VRIFS PRIVATE LIMITED',
    'KEEPER LANDWEY PRIVATE LIMITED',
    'CRYSTALCODE SYSTEMS PRIVATE LIMITED',
    'KRISHARJ OILFIELD SERVICES PRIVATE LIMITED',
    'ALOT PROCESS INSTRUMENTS PRIVATE LIMITED',
    'KAIRALI TELEVISION PRIVATE LIMITED',
    'FLYING HOMINGOS PRIVATE LIMITED',
    'JETSTREAM SOFTWARE INDIA PRIVATE LIMITED',
    'SNAPMINT CREDIT ADVISORY PRIVATE LIMITED',
    'SPORTZVILLAGE FOUNDATION',
    'FREQUENT RESEARCH FIELDWORK SOLUTIONS PRIVATE LIMITED',
    'YELLOW BOX WEB PRIVATE LIMITED',
    'TACENT INDUSTRIES PRIVATE LIMITED',
    'REGISTER FOR EXERCISE PROFESSIONALS INDIA FOUNDATION',
    'ZENOCH STRATEGIC WORKS PRIVATE LIMITED',
    'SCHRILL CONSULTING SERVICES INDIA PRIVATE LIMITED',
    'MRR SPECIAL PROJECTS AND DEVELOPMENT PRIVATE LIMITED',
    'BOLT ONE GLOBAL PRIVATE LIMITED',
    'AGSMARTIC TECHNOLOGIES PRIVATE LIMITED',
    'DELNIE PRIVATE LIMITED',
    'DHC BUILDWORKS (OPC) PRIVATE LIMITED',
    'MAGNA MENTORS PRIVATE LIMITED',
    'PROTRIBE SENIOR CARE SERVICES PRIVATE LIMITED',
    'CAMROLA QUARTZ LIMITED',
    'WINMAGIC TOYS PRIVATE LIMITED',
    'FACIPRO INFRA SERVICES PRIVATE LIMITED',
    'DIKSHAA DAIRY PRIVATE LIMITED',
    'UNIWEBAPPILY TECHNOLOGIES PRIVATE LIMITED',
    'ME CASA WALL TEXTURES PRIVATE LIMITED',
    'HEALPLUS LABS PRIVATE LIMITED',
    'DESTRA TECHNOLOGIES PRIVATE LIMITED',
    'KLEVEROWL SOLUTIONS PRIVATE LIMITED',
    'EURONET INFINITIUM SOLUTIONS PRIVATE LIMITED',
    'GREENEARTH NIDHI LIMITED',
    'VENKATESH MEDICO PRIVATE LIMITED',
    'SHREEPAD DEALERS PRIVATE LIMITED',
    'BARMECHA CONSTRUCTION PRIVATE LIMITED',
    'DUNFI ADVISORS PRIVATE LIMITED',
    'JELLYBOX DESIGN PRIVATE LIMITED',
    'MECCARNATE SOLUTIONS PRIVATE LIMITED',
    'BEDOUIN SYSTEMS PRIVATE LIMITED',
    'ZUYYU PRIVATE LIMITED',
    'WATSONITE SYSTEMS PRIVATE LIMITED',
    'CAPITALISTS ADVENTURE PRIVATE LIMITED',
    'GAATHA FILMS PRIVATE LIMITED',
    'CEROEN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'VIRTUAL METALSTREET PRIVATE LIMITED',
    'KJV FOURTH STONE PRIVATE LIMITED',
    'EKADRISHTA HOSPITALITY PRIVATE LIMITED',
    'PURIFO CHEMIE PRIVATE LIMITED',
    'TRIO EDUCATIONAL SERVICES PRIVATE LIMITED',
    'SAINO FIRST NETWORK PRIVATE LIMITED',
    'APASTRON TECHNOLOGIES PRIVATE LIMITED',
    'RUWABI FITNESS TECHNOLOGIES PRIVATE LIMITED',
    'ALAI TECHNOLOGY LABS INDIA PRIVATE LIMITED',
    'ACHALA AGRO CHEMICALS PRIVATE LIMITED',
    'RIVERSAND TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DEIN KLEIDER FASHION PRIVATE LIMITED',
    'AFOPOM FOUNDATION',
    'VALOR INNOVATIONS PRIVATE LIMITED',
    'UNBOX GADGETS PRIVATE LIMITED',
    'TRANSGLOBE POWERTECH PRIVATE LIMITED',
    'AANOOR EFILINGS PRIVATE LIMITED',
    'SCITUS PHARMA SERVICES PRIVATE LIMITED',
    'YDP GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'AEROMAXPENUKONDA COMPRESSORS PRIVATE LIMITED',
    'VAC IMPEX PRIVATE LIMITED',
    'BLUCYCLES PRIVATE LIMITED',
    'AKP HEALTHCARE PRIVATE LIMITED',
    'RITEMAN PROTECTION FORCE PRIVATE LIMITED',
    'CALICUT ATLANTIS HILLS PRIVATE LIMITED',
    'SIGNOWAVE SOLUTIONS PRIVATE LIMITED',
    'HCCR BUSINESS INTELLIGENCE CENTRE PRIVATE LIMITED',
    'ADITYANK SCIENTIFIC PRIVATE LIMITED',
    'LBD ROBOTICS PRIVATE LIMITED',
    'GSFTS PRIVATE LIMITED',
    'WHITBY WOOD PRITAMDASANI CONSULTING ENGINEERS PRIVATE LIMITED',
    'PURPLEARK LIFE PRIVATE LIMITED',
    'KRISH EVENTS PRIVATE LIMITED',
    'BLUECREST HR CONSULTING PRIVATE LIMITED',
    'LAS CARGO PRIVATE LIMITED',
    'LEOWAY INTERNATIONAL PRIVATE LIMITED',
    'MCOACH SKILLING SOLUTIONS PRIVATE LIMITED',
    'AEGEAN HEALTHCARE PRIVATE LIMITED',
    'AGROHAAT RETAIL PRIVATE LIMITED',
    'AVOCADO TREE DIGITAL PRIVATE LIMITED',
    'FIDESLOOP TECHNOLOGIES PRIVATE LIMITED',
    'TRANQUIL CELESTE CONSUMER TECHNOLOGY PRIVATE LIMITED',
    'VWYRE TECHNOLOGY LABS PRIVATE LIMITED',
    'AVIOR RESORTS AND CAMPS PRIVATE LIMITED',
    'ECO GREEN PRINTPACK PRIVATE LIMITED',
    'BAHUBALI CREATIVE DESIGN PRIVATE LIMITED',
    'MERHAKI FOODS AND NUTRITION PRIVATE LIMITED',
    'TESTLEAF SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PROMPTECH INSTRUMENTS PRIVATE LIMITED',
    'VIVANTA LOGISTICS PRIVATE LIMITED',
    'RIMEDO ADVISOR PRIVATE LIMITED',
    'ABIP ENGINEERS PRIVATE LIMITED',
    'SELMEC INFRA LIMITED',
    'CASTINGKALL MEDIA PRIVATE LIMITED',
    'VINISUN EDGE CREATIVE PRIVATE LIMITED',
    'HRIDAAN VENTURES PRIVATE LIMITED',
    'AORAKII ADVISORS PRIVATE LIMITED',
    'OSX SECURITY SOLUTIONS INDIA PRIVATE LIMITED',
    'GL FINSTOCK PRIVATE LIMITED',
    'REVITOS SPECIALITIES PRIVATE LIMITED',
    'SWAVELLE TRADING INDIA PRIVATE LIMITED',
    'NENS INTERNATIONAL TOURS PRIVATE LIMITED',
    'SOUTHBROS BALAS AUTHENTIC KITCHEN PRIVATE LIMITED',
    'SREEDHARAN BREWERY PRIVATE LIMITED',
    'DELIGHTJET PRIVATE LIMITED',
    'AP POWER INFRA TECH PRIVATE LIMITED',
    'ONDESK EXSERVE PRIVATE LIMITED',
    'CLIMP MEDIA PRIVATE LIMITED',
    'BRUHATI MACHINE TOOLS & AUTOMATION PRIVATE LIMITED',
    'RESILIENT FARMER PRIVATE LIMITED',
    'EPO FLOORING (OPC) PRIVATE LIMITED',
    'PAYATU SECURITY CONSULTING PRIVATE LIMITED',
    'WEBLANTERNS MARKETING PRIVATE LIMITED',
    'CHEMPHYTRONICS SYSTEMS PRIVATE LIMITED',
    'MANAM INFODATA PRIVATE LIMITED',
    'METATRON TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SVOD PROFESSIONAL (INDIA) PRIVATE LIMITED',
    'PRORITES EQUIPMENTS PRIVATE LIMITED',
    'G.I.M INFOTECH PRIVATE LIMITED',
    'SRI SAI RAMA FROZEN FOODS PRIVATE LIMITED',
    'PARTYCHEF HOSPITALITY PRIVATE LIMITED',
    'XTEND EQUIPMENTS PRIVATE LIMITED',
    'VIGYANPUN PRIVATE LIMITED',
    'INOUT CYBER INFOTECH PRIVATE LIMITED',
    'QUALE INFOTECH PRIVATE LIMITED',
    'JJ MAINTENANCE SERVICES PRIVATE LIMITED',
    'HASAN TANKERS PRIVATE LIMITED',
    'EPN WEB CONSULTANTS PRIVATE LIMITED',
    'BAGGCORP ENTERPRISES PRIVATE LIMITED',
    'PINATION CONSULTING PRIVATE LIMITED',
    'ELYTRA MEDIA SOLUTIONS PRIVATE LIMITED',
    'JAIN CRANE SERVICES PRIVATE LIMITED',
    'COLDSMITHS RETAIL SERVICES PRIVATE LIMITED',
    'G.C.T. TOURS & TRAVELS PRIVATE LIMITED',
    'GENOMIX AGRI GENETICS PRIVATE LIMITED',
    'CORPRAIZ SOLUTIONS PRIVATE LIMITED',
    'KAS CARS PRIVATE LIMITED',
    'KBK ONTECH PRIVATE LIMITED',
    'SAUCERY FOODS PRIVATE LIMITED',
    'SYNERGIES INNOVATION LABS PRIVATE LIMITED',
    'BRANDBOX LABS PRIVATE LIMITED',
    'ONKAR DIESEL WORKS (INDIA) PRIVATE LIMITED',
    'NEURONOIDS PRIVATE LIMITED',
    'ZONE PATH TECHNOLOGIES PRIVATE LIMITED',
    'SDR PACKAGING INNOVATIONS PRIVATE LIMITED',
    'TRICCI SUPPORT SERVICES PRIVATE LIMITED',
    'TAVAGA ADVISORY SERVICES PRIVATE LIMITED',
    'PERFIOS ACCOUNT AGGREGATION SERVICES PRIVATE LIMITED',
    'AVIKIRAN ENERGY INDIA PRIVATE LIMITED',
    'CONTINUUM POWER TRADING (TN) PRIVATE LIMITED',
    'SPIKER WINDOORS PRIVATE LIMITED',
    'WORLDUP TECHNOLOGIES PRIVATE LIMITED',
    'PAX INNOVATION ICT SERVICES PRIVATE LIMITED',
    'STERLITE GRID 12 LIMITED',
    'AGNUS LIGHTING SYSTEMS PRIVATE LIMITED',
    'LOURDS FORWARDING PRIVATE LIMITED',
    'FIELDNXT SERVICE SOLUTIONS PRIVATE LIMITED',
    'WAKOKLOL BUSINESS CONSULTING PRIVATE LIMITED',
    'REVOBLOX SYSTEMS PRIVATE LIMITED',
    'DHANICHOKHI REFRESHMENT HUB PRIVATE LIMITED',
    'HULA HOOP VFX PRIVATE LIMITED',
    'AFRICARE BUSINESS VENTURES (INDIA) PRIVATE LIMITED',
    'RN SURGEONS REVERIE PRIVATE LIMITED',
    'PSC INDUSTRIES PRIVATE LIMITED',
    'SECURE METERING & SERVICES (BHILWARA) PRIVATE LIMITED',
    'FAST TRACK ROADSIDE ASSISTANCE PRIVATE LIMITED',
    'NAVA RAIPUR ATAL NAGAR SMART CITY CORPORATION LIMITED',
    'ITEAM FOUNDATION',
    'GLITVAC FACILITY SERVICES PRIVATE LIMITED',
    'PATEL SETHIYAHOPU-CHOLOPURAM HIGHWAY PRIVATE LIMITED',
    'WECOOL IMPORTS AND TRADING PRIVATE LIMITED',
    'TT CADD & STRUCTURAL OUTSOURCING PRIVATELIMITED',
    'BONIFACE OFFSHORE ENERGY PRIVATE LIMITED',
    'SYNCRONY INFORMATION SYSTEMS AND CONSULTING SERVICES PRIVATE LIMITED',
    'ASTREA GREENTECH PRIVATE LIMITED',
    'ARISERS EXIM PRIVATE LIMITED',
    '8WORKSERA REMOTE WORK OPPORTUNITIES PRIVATE LIMITED',
    'SNACTEK FOOD MACHINES PRIVATE LIMITED',
    'KRISHNABHUMI HOLYDAYS PRIVATE LIMITED',
    'ELYSIAN INTELLIGENCE BUSINESS SOLUTION PRIVATE LIMITED',
    'KNOLL FARMS PRIVATE LIMITED',
    'VIJU SUPPLIER PRIVATE LIMITED',
    'KENIL MARKETING PRIVATE LIMITED',
    'LABBAIK UMRAHS INDIA PRIVATE LIMITED',
    'WIMATE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'KLOVERTECH MARKETING SOLUTIONS PRIVATE LIMITED',
    'NOVAL SUSTAINABILITY SOLUTIONS PRIVATE LIMITED',
    'IOTICS LAB PRIVATE LIMITED',
    'SVENLY JOBS CONSULTANT PRIVATE LIMITED',
    'SHALIMAR KNITFAB PRIVATE LIMITED',
    'ARTHLEX RESEARCH PRIVATE LIMITED',
    'NARBHERAM SOLAR TN PRIVATE LIMITED',
    'YASHODAM TECH VENTURES PRIVATE LIMITED',
    'BLOOMCAP EDU VENTURES PRIVATE LIMITED',
    'KAMADHENU CUTTING TOOLS PRIVATE LIMITED',
    'PATEL DARAH-JHALAWAR HIGHWAY PRIVATE LIMITED',
    'THREEWINKEL COMMUNICATIONS PRIVATE LIMITED',
    'MOHIB SHOE ENTERPRISES PRIVATE LIMITED',
    'CALCUTTA TRADE TEST & TRANING INSTITUTE PRIVATE LIMITED',
    'SIEGEN INFORMATICS PRIVATE LIMITED',
    'SIONIC ADVISORS INDIA PRIVATE LIMITED',
    'ADRS GLOBAL CARGO AND LOGISTICS PRIVATE LIMITED',
    'ARABIAN PIPELINE SUPPLY PRIVATE LIMITED',
    'ENTHUEVENTS HOLIDAY HUB PRIVATE LIMITED',
    'STELLENT CHEMICALS INDUSTRIES LIMITED',
    'AXEUM TECHNOLOGIES PRIVATE LIMITED',
    'HUMMERS LUBES & CHEMICALS INDIA PRIVATE LIMITED',
    'GAVI RANGANATHA SWAMY TRADING PRIVATE LIMITED',
    'BAARIZ TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ARTHAYAN ADVISORY SERVICES PRIVATE LIMITED',
    'JAMKHANDI RENEWABLE PRIVATE LIMITED',
    'P. N. GADGIL & SONS LIMITED',
    'RENKUBE PRIVATE LIMITED',
    'HEXAFORM TECHNOLOGIES PRIVATE LIMITED',
    'GIKS INDIA PRIVATE LIMITED',
    'LOKO LEISURE TRAVELS PRIVATE LIMITED',
    'TRICOG HEALTH INDIA PRIVATE LIMITED',
    'EVANGILE TECHNOLOGIES PRIVATE LIMITED',
    'CANDI SOLAR PRIVATE LIMITED',
    'AYURMEDLIFE HOSPITAL PRIVATE LIMITED',
    'BEANT ENTERPRISES PRIVATE LIMITED',
    'LOKACI PRIVATE LIMITED',
    'STARTOON LABS PRIVATE LIMITED',
    'ELSEIF TECHNOLOGIES PRIVATE LIMITED',
    'KRISU TECHKUL PRIVATE LIMITED',
    'WUHYUN TECH INDIA PRIVATE LIMITED',
    'MAGNEUM PRIVATE LIMITED',
    'MGR MEMORIAL HOUSE PRIVATE LIMITED',
    'GUJAR INDUSTRIES INDIA PRIVATE LIMITED',
    'NTTV BHARAT MEDIA PRIVATE LIMITED',
    'ASPECT GLOBAL VENTURES PRIVATE LIMITED',
    'EDUASTRAL COACHING PRIVATE LIMITED',
    'FRUGAL SCIENTIFIC PRIVATE LIMITED',
    'XCORDON FASHION SERVICES PRIVATE LIMITED',
    'EMMENESS ENTERPRISES PRIVATE LIMITED',
    'MOBISHAALA EDUTECH PRIVATE LIMITED',
    'INNOPROP SPACES PRIVATE LIMITED',
    'DLF PHASE - IV COMMERCIAL DEVELOPERS LIMITED',
    'DPAG PROJECTS PRIVATE LIMITED',
    'S INVESTORS SERVICE INDIA PRIVATE LIMITED',
    'Hungama gameshashtra private limited',
    'Antrans logistics india private limited',
    'Mbpy exim private limited',
    'Segoma imaging technologies (india) private limited',
    'Breitling india private limited',
    'Xion multiventures private limited',
    'Smb automation private limited',
    'Model n india software private limited',
    'Sensaas india solutions private limited',
    'Gigatude software solutions private limited',
    'Affosoft technologies india private limited',
    'Sollet soft solutions private limited',
    'Pinite info solutions private limited',
    'Zemoso technologies private limited',
    'Blue wave it solutions india private limited',
    'Appoids tech solutions private limited',
    'Devahuthi software solutions private limited',
    'NXT SERVE TECHNOLOGIES PRIVATE LIMITED',
    'Violet digicom private limited',
    'Ivtl infoview technologies private limited',
    'Ace software solutions private limited',
    'Balagan technologies private limited',
    'Gxp consultants private limited',
    'Dssi solutions (india) private limited',
    'Neeyamo enterprise solutions private limited',
    'Petronash engineering services private limited',
    'Multibasic technology services india private limited',
    'Mobiveil technologies india private limited',
    'Globees solutions india private limited',
    'Accumenta services private limited',
    'Databazaar india private limited',
    'Alqimi india private limited',
    'Orchid online research private limited',
    'Finezi technologies private limited',
    'Scarled computech private limited',
    'Soft systems consultancies private limited',
    'Darwin platform information technologies limited',
    'Omada software technologies private limited',
    'Quoinx technologies private limited',
    'Ida business solutions private limited',
    'Right side business solutions private limited',
    'Soctel software private limited',
    'Symbioun solutions private limited',
    'Dataweave software private limited',
    'Varcas interactive private limited',
    'Infomile solutions private limited',
    'Ani calls india private limited',
    'RYSUN LABS PRIVATE LIMITED',
    'Prv computer system (india) private limited',
    'Jamesblake it solutions private limited',
    'Wizard it solutions private limited',
    'Indicsoft technologies private limited',
    'Unmatched solutions private limited',
    'Bhaktee software private limited',
    'TIVO TECH PRIVATE LIMITED',
    'Sukhena technologies private limited',
    'Honeysys it services private limited',
    'Pictorial energy solutions private limited',
    'Schweickert india private limited',
    'Nidarsana communication solutions private limited',
    'Gebbs healthcare solutions private limited',
    'NTT GLOBAL NETWORKS PRIVATE LIMITED',
    'Simpro india technology private limited',
    'Bigv telecom private limited',
    'In-tap technologies private limited',
    'Novel innovative concepts interactive private limited',
    'MAVEN TELEMATICS SOLUTIONS PRIVATE LIMITED',
    'Eborn consulting private limited',
    'ANOMALOUS VENTURES ENTERTAINMENT PRIVATE LIMITED',
    'Pitasys softwares private limited',
    'Evive software analytics private limited',
    'Benchmark corporation private limited',
    'Mywebz devoloper private limited',
    'Mnm megartha software technologies private limited',
    'Ityx india private limited',
    'Satej infotech private limited',
    'Deify infocomm solutions private limited',
    'Centroid it systems india private limited',
    'QUALTON IT SERVICES PRIVATE LIMITED',
    'Florance energy solutions private limited',
    'Medontech private limited',
    'Erevmax technologies private limited',
    'BALAN BIOSCIENCES PRIVATE LIMITED',
    'Prajna bio sciences private limited',
    'Maxheal pharmaceuticals (india) limited',
    'Nova surface-care centre private limited',
    'YASHARTH PROPERTIES PRIVATE LIMITED',
    'FARMERIN TECHNIK INDIA PRIVATE LIMITED',
    'Sysfocon services private limited',
    'Green field resources private limited',
    'Edeline e-solutions company private limited',
    'MARGIN',
    'S STERLING ESTATES PRIVATE LIMITED',
    'Keystone enterprises private limited',
    'Smartech global solutions limited',
    'Shaf digital private limited',
    'Marc laboratories limited',
    'Green apples techsystems private limited',
    'Netfillip technologies private limited',
    'Monarch innovation private limited',
    'Unleaded software solutions private limited',
    'Societe generale global solution centre private limited',
    'Nice interactive solutions india private limited',
    'Continuserve softech india private limited',
    'Optebiz private limited',
    'Kiona software solution private limited',
    'Hyper drive information technologies private limited',
    'KONGSBERG DIGITAL SOFTWARE AND SERVICES PRIVATE LIMITED',
    'Ubq technologies private limited',
    'Netiapps software private limited',
    'Mobily infotech india private limited',
    'Veritech infosystems private limited',
    'Tyto software private limited',
    'Wm global technology services india private limited',
    'Gavika information technologies private limited',
    'Ambernet technologies india private limited',
    'Innoventes technologies india private limited',
    'Snapbizz cloudtech private limited',
    'Krythium solutions private limited',
    'Miraglo software technologies private limited',
    'Valueprocess technologies (india) private limited',
    'Synage software private limited',
    'Arbitron technology services india private limited',
    'Kaspersky lab india private limited',
    'Finesse information systems private limited',
    'Sydler technologies private limited',
    'Bmc software india private limited',
    'INDIO NETWORKS PRIVATE LIMITED',
    'NAPIER HEALTHCARE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Pass gerhard consulting alliance solutions centre private limited',
    'Evoke technologies private limited',
    'Iconcept software services private limited',
    'Next education india private limited',
    'Profitics soft tech (india) private limited',
    'Inforaise solutions private limited',
    'Uclid it services private limited',
    'Brn infotech private limited',
    'Meteorite informatics india private limited',
    'Teamf1 networks private limited',
    'NTT DATA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Gss healthcare it solutions private limited',
    'Wissen technology private limited',
    'Sreeven paytech private limited',
    'Emergys software private limited',
    'Gsr business services private limited',
    '4i apps solutions private limited',
    'Jeevan infotech india private limited',
    'Clematix software private limited',
    'Praxis softek solutions private limited',
    'Netwoven (india) private limited',
    'Aar technologies and software solution private limited',
    'REDKNEE INDIA OS PRIVATE LIMITED',
    'LOWE',
    'S HAIRXPRESO PRIVATE LIMITED',
    'Metmin resource consultants private limited',
    'SYNAMEDIA INDIA PRIVATE LIMITED',
    'Optima india packaging machines private limited',
    'Cleanergis biosciences private limited',
    'Schmetz india private limited',
    'BRUECKNER GROUP INDIA PRIVATE LIMITED',
    'Visakha container terminal private limited',
    'Royal bitumen private limited',
    'Voestalpine bohler welding india private limited',
    'Industrial energy limited',
    'Diabos private limited',
    'Karjat golf club private limited',
    'Wartex system private limited',
    'Megabuild manshila realty private limited',
    'Extron electronics private limited',
    'Durlabh technology solutions private limited',
    'RELIABULL FINANCIAL SERVICES PRIVATE LIMITED',
    'Avati consulting solutions private limited',
    'Taraba tech-solutions private limited',
    'Cocoon fashionwear private limited',
    'Aditya aarthik niyojan limited',
    'Omni rebar private limited',
    'S.v.tech engineering consultants private limited',
    'Invsearch solutions private limited',
    'Kenazglobal mercantile private limited',
    'Sindhu educational institutes private limited',
    'Funfirst global skillers private limited',
    'Grey sim limited',
    'Axl techno systems private limited',
    'Grey sim learnings foundation',
    'Opus education private limited',
    'Binaryedge education & research services private limited',
    'Tmi healthcare private limited',
    'Dia (india) private limited',
    'Centre for environment education and development private limited',
    'GLOBAL LONGLIFE HOSPITAL AND RESEARCH LIMITED',
    'Astellas pharma india private limited',
    'Pay asia management private limited',
    'Aiswarya hygiene services private limited',
    'All india footwear manufacturers and retailers association',
    'TRETIS ADVANCED COLLABORATIVE PRIVATE LIMITED',
    'Lekhya entertainment private limited',
    'Ambuja motion picture company limited',
    'Shobhna desai productions private limited',
    'Ambuja realty events management limited',
    'Le cordon bleu india private limited',
    'Saptarshi classes private limited',
    'Zen money private limited',
    'International inspection services private limited',
    'Webshar ( india ) private limited',
    'Flying dreams entertainment private limited',
    'Auroma accounting services private limited',
    'Bdr securities limited',
    'Mantra events and promotions private limited',
    'Subhadra metals private limited',
    'TERNARY RISK CONSULTANCY AND MANAGEMENT PRIVATE LIMITED',
    'Aditya Birla Fashion and Retail Limited',
    'YG CAPITAL LIMITED',
    'Coral hub limited',
    'BLACK BOX LIMITED',
    'Wanbury limited',
    'PODDAR HOUSING AND DEVELOPMENT LIMITED',
    'Motilal oswal financial services limited',
    'Vas infrastructure limited (cn)',
    'Balaji telefilms limited',
    'Elastrex polymers private limited',
    'Deccan agro farm privae limited',
    'Delta agrigenetics private limited',
    'Green vision life sciences private limited',
    'SHELAX INVESTMENT PRIVATE LIMITED',
    'Mittal agro retail private limited',
    'Blue ocean beverages private limited',
    'Bloomkraft silk limited',
    'Siera silk mills private limited',
    'Rataan fab tex private limited',
    'GABANI YARNTEX PRIVATE LIMITED',
    'Grv spintex private limited',
    'Shaurya clothing private limited',
    'Skl exports limited',
    'Supernova engineers limited',
    'Gelco electronics private limited',
    'Litura electrical technologies private limited',
    'Sapthagiri power technologies private limited',
    'S.m. environmental technologies private limited',
    'Witmans engineering private limited',
    'Spectrum techvision private limited',
    'Force - strain sensors private limited',
    'EURON TECHNOLOGIES PRIVATE LIMITED',
    'Akshay controls and systems private limited',
    'IC COMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'Indus technotronics private limited',
    'DISNEY ENTERTAINMENT (INDIA) PRIVATE LIMITED',
    'Gotiz healthcare limited',
    'SURGGINEX LIFESCIENCES PRIVATE LIMITED',
    'Process care systems (india) private limited',
    'Osworld scientific equipments private limited',
    'Universal axles private limited',
    'Bikeaffair cycling india private limited',
    'Meritor commercial vehicle systems india private limited',
    'Bhambhani shipping limited',
    'VGG INDIA PRIVATE LIMITED',
    'Capricorn components private limited',
    'Vi furnishings private limited',
    'Eskay cartons private limited',
    'Shreeji ornaments private limited',
    'Starlet jewels private limited',
    'Reynolds pens india private limited',
    'Metro gifts pvt ltd',
    'Dytech power solutions (india) private limited',
    'Aimco green energy limited',
    'Nandha energy limited',
    'Gotiz infratech limited',
    'Unique infraspace private limited',
    'Spatium ventures private limited',
    'K.raheja private limited',
    'Green cells infrastructures private limited',
    'JP INFRA SPACES PRIVATE LIMITED',
    'Dreams corporation private limited',
    'Baswant developers private limited',
    'Greatwall estates private limited',
    'Maheshwari mega ventures limited',
    'Epoch greenfields parks development limited',
    'YOGI AYURVEDIC PRODUCTS PRIVATE LIMITED',
    'Manor infraprojects limited',
    'Quick infrastructure and developers private limited',
    'Bhoomivijay properties private limited',
    'PRL Agastya Private Limited',
    'Mp space dynamics private limited',
    'Poddar infrastructure private limited',
    'Vora estate and properties private limited',
    'Basava constructions private limited',
    'S. n. plumbing private limited',
    'Iris infra services private limited',
    'Avadhut infracon pvt.ltd',
    'QUARRY CONSTRUCTION PRIVATE LIMITED',
    'Mmr engineers & contractors (india) private limited',
    'Enrico real estates private limited',
    'Aakav devcon private limited',
    'Anandmayee housing private limited',
    'Balkrishan infracon private limited',
    'Asha automine private limited',
    'Hmacs trading private limited',
    'Golden star exim private limited',
    'Reliance motor company private limited',
    'Matsya automobiles limited',
    'Vss sourcing (india) private limited',
    'Ispa exim private limited',
    'Vasishta pharmaceuticals private limited',
    'Yangon commercials private limited',
    'Sandeep organics private limited',
    'Synergy earth resources private limited',
    'Avestra chemical india private limited',
    'Ceramic tools private limited',
    'BLUE CARAT PRIVATE LIMITED',
    'Eltus commodities private limited',
    'Greenstar international private limited',
    'Sonashi electronic private limited',
    'Aegis organics private limited',
    'RV CURRENCY PRIVATE LIMITED',
    'Sayyomita distribution private limited',
    'Power gun systems private limited',
    'Trax tradecom private limited',
    'Aditya findings private limited',
    'Boon distribution private limited',
    'Pg hotels and resorts private limited',
    'Senora beach resorts private limited',
    'ARGON HOTELS PRIVATE LIMITED',
    'Deus fidius food & hospitality private limited',
    'Kosamattam ventures private limited',
    'Nivalink consultancy services private limited',
    'ITI CAPITAL LIMITED',
    'Sampoorna matchjobs.com private limited',
    'Tcg advisory services private limited',
    'Altitude investments private limited',
    'LEGASIS PRIVATE LIMITED',
    'Aavishkaar venture management services private limited',
    'Consci consultancy private limited',
    'Kaygen consulting private limited',
    'Bts strategy alignment and execution private limited',
    'Optimal corporate services private limited',
    'CENMARK AGRONOMICS PRIVATE LIMITED',
    'Glacier cooling solutions private limited',
    'Edag Production Solutions India Private Limited',
    'Food and biotech engineers (india)private limited.',
    'Skyway infraprojects private limited',
    'Dca architecture and design private limited',
    'EIGHTY TWO POINT FIVE COMMUNICATIONS PRIVATE LIMITED',
    'Diamond publicities private limited',
    'I-LOAN CREDIT PRIVATE LIMITED',
    'Ahmedabad bariatrics and cosmetics private limited',
    'Amaravathi pro-tech private limited',
    'Electrolinks technologies private limited',
    'Aditi staffing private limited',
    'Flow edge financial solutions private limited',
    'Global treatment services private limited',
    'Ritzee bags india private limited',
    'Aavishkaar venture trustees private limited',
    'Millward brown market research services india private limited',
    'Rur greenlife private limited',
    'ECONSHIP TECH PRIVATE LIMITED',
    'Ullattil hotels & spa private limited',
    'Auto sonics (india) private limited',
    'Shan ship management private limited',
    'D-vois n ssv broadband private limited',
    'Seaswan shipping services private limited',
    'Joker films private limited',
    'Salman khan ventures private limited',
    'P-cube enterprises private limited.',
    'Sears it & management services india private limited',
    'Axis paradigm spaces india private limited',
    'Gradmener technology private limited',
    'Accurate pathlab private limited',
    'UNIQUE INDUSTRIAL AUTOMATION PRIVATE LIMITED',
    'Dbc baid real estate and services private limited',
    'Harsco track machines and services private limited',
    'Nova human resources outsourcing private limited',
    'Kvr baseline resources private limited',
    'D n s holding private limited',
    'Clanergy media private limited',
    'Milestone brandcom private limited',
    'Calibre network solutions private limited',
    'Etcetra lifestyle limited',
    'Edag technologies india private limited',
    'Utrust consulting private limited',
    'Ocs group (india) private limited',
    'Shivani textiles limited',
    'Musashi india private limited',
    'Lakshmi facilities private limited',
    'Food pharma india private limited',
    'NIPPON LIFE INDIA AIF MANAGEMENT LIMITED',
    'International biotech park limited',
    'Metal tech pvt ltd',
    'Husqvarna (india) products private limited',
    'Findability sciences private limited',
    'DURLAX TOP SURFACE LIMITED',
    'Glass wall systems (india) private limited',
    'Achilles information (india) private limited',
    'KHAN & CO INFRA PROJECTS PRIVATE LIMITED',
    'Brainpower enterprise solutions private limited',
    'Klickbrick housing consultants private limited',
    'Compaxed management consulting private limited',
    'NY TRADECIRCLE PRIVATE LIMITED',
    'ADVENTUM OFFSHORE PRIVATE LIMITED',
    'Parmaarth international trading private limited',
    'Evie real estate private limited',
    'Agilis management consultants private limited',
    'Berkadia services india private limited',
    'J&F INDIA PRIVATE LIMITED',
    'Maritime associates india private limited',
    'Vikram engineers private limited',
    'Sun outsourcing solutions private limited',
    'Ruptech educational india',
    'Unique institute of higher learning private limited',
    'Echelon edusystems private limited',
    'Aavid consulting processes private limited',
    'Independent qualitative assessors gilde private limited',
    'Gmi creatives private limited',
    'Dream india education infrastructure solutions private limited',
    'Dream india solutions private limited',
    'Pelikan trading india private limited',
    'Parle elizabeth tools private limited',
    'Hephzi elevators private limited',
    'Hybrid systems limited',
    'Minnow trading company private limited',
    'Glorious overseas private limited',
    'Iss international limited',
    'Insignia enterprises private limited',
    'Top products india private limited',
    'Associated polytech industries private limited',
    'Hirann trading enterprises private limited',
    'Glade trading company private limited',
    'Gal international limited',
    'BRAND CONCEPTS LIMITED',
    'Bombay electrical projects and supplies (india) private limited',
    'Microtherm india private limited',
    'Abijah multitrade private limited',
    'Visage impex (india) private limited',
    'Harting (india) private limited',
    'Pushpak dealer private limited',
    'Dharmdeep commodities private limited',
    'Purandar exim private limited',
    'Kohinoor floors private limited',
    'Capital office suppliers private limited',
    'WONDERWORLD RESORTS PRIVATE LIMITED (U.T.COMPANY)',
    'Associated hotels private limited',
    'Sneha villas private limited',
    'Merit inns ltd',
    'Costa kitchen private limited',
    'Dighi oil storage private limited',
    'Terra vehicle logistics india private limited',
    'Saisiddhi clearing and forwarding private limited',
    'Bulk cargo logistics private limited',
    'Shreepati logistic india limited',
    'Rama vessel handlers private limited',
    'Total experienz tourism solutions (india) private limited',
    'Ofs cargo private limited',
    'Florence logistics private limited',
    'Shekhawat sales private limited',
    'Kottai garments private limited',
    'IKN EXPORTS PRIVATE LIMITED',
    'Jindal denim (india) private limited',
    'NR VENTURES PRIVATE LIMITED',
    'Krd exports private limited',
    'Clifton trends private limited',
    'Ags gem and jewellery park cochin private limited',
    'Feelwell garments & accessories private limited',
    'Centre of excellence in design limited',
    'K a s tanning company private limited',
    'Ana industrial safety private limited',
    'Footpro solutions private limited',
    'Affan shoes private limited',
    'S.r.shoes private limited',
    'Siddhi decor private limited',
    'VISHWAKARMA DESIGN STUDIO PRIVATE LIMITED',
    'Sangeeta traders chennai private limited',
    'Rich prints private limited',
    'Rising sun packaging india private limited',
    'SHREEAMBE IMPRINTS PRIVATE LIMITED',
    'MAYUKUMAR MANUFACTURERS PRIVATE LIMITED',
    'Ecoglobe packaging private limited',
    'Brijlaxmi paper products private limited',
    'H&v advanced materials (india) private limited',
    'Seven hills publications private limited',
    'Green apple design private limited',
    'Telemedia interactv india private limited',
    'Fugo creative private limited',
    'Feelgood creations private limited',
    'Openbooks trading private limited',
    'Sri krishna devaraya hatcheries pvt. ltd.',
    'Total foodservice equipment private limited',
    'Aero pack products private limited',
    'Aamoda publications private limited',
    'Telangana publications private limited',
    'Zeta films private limited',
    'TRISHA STUDIOS LIMITED',
    'Medianext infoprocessors private limited',
    'Avant garde omnimedia private limited',
    'Sohum autogas systems private limited',
    'Marcus oils & chemicals private limited',
    'Latex marketing private limited',
    'Jindal infrastructures private limited',
    'Bec industrial investment company private limited',
    'Manbhari biofuel private limited',
    'Happy chemicals private limited',
    'Witmans industries private limited',
    'Hri healthcare private limited',
    'Vantage specialty ingredients private limited',
    'TAGOOR LABORATORIES PRIVATE LIMITED',
    'Chalix microns india private limited',
    'ADROIT PHARMA RESEARCH PRIVATE LIMITED',
    'Bardoli acetylene private limited',
    'Westman chemicals private limited',
    'ELAN OVERSEAS EDUTECH PRIVATE LIMITED',
    'Indradhanush chemicals pvt ltd',
    'Indofil industries limited',
    'Photokina chemicals private limited',
    'Elegant chemical enterprises pvt ltd',
    'Vibha agro tech limited',
    'Spc biotech private limited',
    'Flexilis private limited',
    'Raico private limited',
    'Jostars orgotech private limited',
    'Suman udyog private limited',
    'Jupiter dyes private limited',
    'Madhu hydrocolloids private limited',
    'Cool aid private limited',
    'Efc infrastructures private limited',
    'Gsp crop science private limited',
    'GERMAN REMEDIES PHARMACEUTICALS PRIVATE LIMITED',
    'Natec medical private limited',
    'Vexxa lifesciences private limited',
    'Shankus acme pharma private limited',
    'ACCENT MICROCELL LIMITED',
    'Pvpharma healthcare private limited',
    'Lab systems and biotech (india) private limited',
    'Azatrius pharmaceuticals private limited',
    'Chempro pharma private limited',
    'Merix laboratories private limited',
    'Reckon pharmachem private limited',
    'Karnavati polyester private limited',
    'Jaywin remedies private limited',
    'Kentreck laboratories pvt ltd',
    'Remidex pharma private limited',
    'Arya vaidya nilayam limited',
    'Raichem medicare private limited',
    'Spiritus pharmaceuticals private limited',
    'Brahaspati merchandise private limited',
    'Technotrade impex india private limited',
    'Allure exports private limited',
    'Syncords (india) private limited',
    'Fairtech marketing services private limited',
    'Rajshila synthetics private limited',
    'R p m exim private limited',
    'Cavalier enterprises private limited',
    'Ashirvad impex private limited',
    'Goldmine commodities private limited',
    'AKAR CONFEX PRIVATE LIMITED',
    'SBS TRANSWORLD PRIVATE LIMITED',
    'Chukan butsu exim (india) private limited',
    'Orana india private limited',
    'Solid state systems private limited',
    'South india monument exports private limited',
    'BION ANALYTX PRIVATE LIMITED',
    'World mobile com private limited',
    'Hero mobile private limited',
    'Dexton seating systems and furniture (india) private limited',
    'Emsons exim private limited',
    'Organyze systems private limited',
    'Mount overseas private limited',
    'Uni-source trading private limited',
    'Ratug lube-oil private limited',
    'Taurus intelligent trading solutions private limited.',
    'Microware multimedia private limited',
    'Globe 200 sourcing private limited',
    'Godip organic chemicals private limited',
    'Proco international private limited',
    'Spears marketing limited',
    'FERTIS INDIA PRIVATE LIMITED',
    'Shlara automation private limited',
    'Sidhant vyapaar pvt ltd',
    'Alfa vinicom private limited',
    'Genesis trade-links private limited',
    'Vista distributors private limited',
    'GROWTHTREE VENTURES PRIVATE LIMITED',
    'Dev-yashu trading private limited',
    'Circular suppliers private limited',
    'New era software private limited',
    'Globizz translogistics private limited',
    'Nss trade (india) private limited',
    'Game shop retail private limited',
    'Valeo nutra private limited',
    'Asmi print & merchandise private limited',
    'Ajmer trading private limited',
    'Intouch consumer care solutions private limited',
    'Max hypermarket india private limited',
    'Volte retail private limited',
    'SDV PROJECTS SOLUTIONS PRIVATE LIMITED',
    'Zephyr retail private limited',
    'Resource world exim private limited',
    'Krs office & industrial automation private limited',
    'Hamsa life sciences private limited',
    'Hyderabad agencies pvt. ltd.',
    'Ocean blue boating andaman private limited',
    'Four seasons sales private limited',
    'Rinac india limited',
    'Invitty tradez private limited',
    'Sybilla marketing network private limited',
    'Kisaanonline agrivision (india) limited',
    'Brindavan print solutions private limited',
    'Linoui chocolates private limited',
    'Daksha trading company private limited',
    'NTEX TRANSPORTATION SERVICES PRIVATE LIMITED',
    'JAISURYAS RETAIL VENTURES LIMITED',
    'New priti itradeimex private limited',
    'Fame farmatech private limited',
    'Freightcan global logistics private limited',
    'MARS MEDICAL SYSTEMS & SERVICES PRIVATE LIMITED',
    'Om rocks export private limited',
    'JAMMU JEWEL HOTEL & RESTAURANT PRIVATE LIMITED.',
    'Citrus chambers mahabaleshwar private limited',
    'Discovery properties and hotels private limited',
    'Nature trails resorts private limited',
    'Bestech motels and resorts private limited',
    'Select equity advisory services private limited',
    'Experion hospitality private limited',
    'Experion hospitality (hyderabad) private limited',
    'Saga motels private limited',
    'Caddie hotels private limited',
    'Experion hospitality (maharashtra) private limited',
    'TAG VACATION INDIA LIMITED',
    'Tipping mr pink private limited',
    'Hotel sabar pvt ltd',
    'Kapani resorts private limited',
    'Duet india hotels private limited',
    'Gem international private limited',
    'Ibc hotels and resorts private limited',
    'Golden tree hotels private limited',
    'TICKMYTRIP SERVICES PRIVATE LIMITED',
    'XANDARI PEARL BEACH RESORTS PRIVATE LIMITED',
    'Air inn private limited',
    'Travel food services (duty free) private limited',
    'Travel retail services private limited',
    'Tastybudz speciality food services private limited',
    'Citrus resorts bengaluru private limited',
    'Diligent pmc private limited',
    'Peoplecare business solutions private limited',
    'Celsius 100 consulting private limited',
    'Vertex india venture advisory private limited',
    'Susutra consultants private limited',
    'Creintors teknosol private limited',
    'Global hinshitsu india private limited',
    'Moopens energy solutions private limited',
    'THENCE PRIVATE LIMITED',
    'Magna global hr services private limited',
    'Eureka outsourcing solutions private limited',
    'IQVIA CONSULTING AND INFORMATION SERVICES INDIA PRIVATE LIMITED',
    'Atherstone capital markets limited',
    'Advait techserve (india) pvt ltd',
    'Eggfirst advertising and design private limited',
    'Mehta & mehta legal and advisory services private limited',
    'Kaleidoscope properties management private limited',
    'Happy thinking people india private limited',
    'ROUTE LEDGER TECHNOLOGIES PRIVATE LIMITED',
    'IMPRINT LED DISPLAYS PRIVATE LIMITED',
    'Index advisory private limited',
    'SALSETTE DEVELOPERS PRIVATE LIMITED',
    'AUTUS WEALTH PRIVATE LIMITED',
    'ENTRATA INDIA PRIVATE LIMITED',
    'Ultimate mangement and financial services pvt ltd',
    'Aplav consultants private limited',
    'GEEKAY',
    'ART PRIVATE LIMITED',
    'NULTA HEALTHCARE PRIVATE LIMITED',
    'ECHOSENSE TECHNOLOGIES PRIVATE LIMITED',
    'SOLITAIRE PROPERTY MANAGEMENT PRIVATE LIMITED',
    'AMS-CHASYS AUTOMOTIVE INDIA PRIVATE LIMITED',
    'ELKART PRIVATE LIMITED',
    'MJ COMPOSITES INDIA PRIVATE LIMITED',
    'JAADUTECHNO DEALS PRIVATE LIMITED',
    'KENACTS SOFTWARE PRIVATE LIMITED',
    'POLY9 SOFTWARE SALES PRIVATE LIMITED',
    'ILOCUS CONSULTING PRIVATE LIMITED',
    'GENIE WEB APPLICATIONS PRIVATE LIMITED',
    'MG FUNDS PRIVATE LIMITED',
    'VITRUVIAN 3D SOLUTIONS PRIVATE LIMITED',
    'CASA GRANDE SMART VALUE HOMES PRIVATE LIMITED',
    'V-FIBERNET INDIA PRIVATE LIMITED',
    'ACA GLOBAL PRIVATE LIMITED',
    'EMEDIWORLD LIFESCIENCE PRIVATE LIMITED',
    'MEP SANJOSE NAGPUR RING ROAD 2 PRIVATE LIMITED',
    'SRI SAI RAM KISAN PRODUCER COMPANY LIMITED',
    'ADANI TOTAL PRIVATE LIMITED',
    'BGIC PRIVATE LIMITED',
    'SIRI MALLE INFRA DEVELOPERS PRIVATE LIMITED',
    'AZZURE MEDIA PRIVATE LIMITED',
    'SIMPLIFY3X SOFTWARE PRIVATE LIMITED',
    'NEMESIS GAMING PRIVATE LIMITED',
    'E-ASSURE SOLUTIONS INDIA PRIVATE LIMITED',
    'REELOVER MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'FOXSPREE PRIVATE LIMITED',
    'EMWILL INDUSTRIES PRIVATE LIMITED',
    'GOLDEN HOTELS & RESORTS PRIVATE LIMITED',
    'SWAN SOFTECH PRIVATE LIMITED',
    'STREAMLYN SEMISOFT PRIVATE LIMITED',
    'KODEGEAR TECHNOLOGIES PRIVATE LIMITED',
    'HEADSPIN TECHNOLOGIES PRIVATE LIMITED',
    'VV GLOBAL LOGISTICS PRIVATE LIMITED',
    'INCRETIVE PRIVATE LIMITED',
    'ANVATION LABS PRIVATE LIMITED',
    'VENA ENERGY KONKAN WIND POWER PRIVATE LIMITED',
    'GVN HOSPITAL PRIVATE LIMITED',
    'TMAXSOFT TECHNOLOGIES PRIVATE LIMITED',
    'BIGTHINX SOFTWARE PRIVATE LIMITED',
    'ROCKCHIP TECHNOLOGY PRIVATE LIMITED',
    'SUPER-TECH PLASTPACK PRIVATE LIMITED',
    'HYWEL READY MIX CONCRETE PRIVATE LIMITED',
    'BRANDCO SYSTEMS PRIVATE LIMITED',
    'BINARY COMMUNICATIONS PRIVATE LIMITED',
    'ASKANYTIME.IN INDIA PRIVATE LIMITED',
    'TRACELEADS B2B SERVICES PRIVATE LIMITED',
    'MAT JOURNALS PRIVATE LIMITED',
    'PROPUS ENTERPRISES PRIVATE LIMITED',
    'GN APP MARKETING INDIA PRIVATE LIMITED',
    'JOBBY INFINITY PRIVATE LIMITED',
    'VASUDHAA HOSPITALITY PRIVATE LIMITED',
    'MFMW HOME SOLUTIONS PRIVATE LIMITED',
    'IKLAST SYSTEMS PRIVATE LIMITED',
    'VROOM DRIVE INDIA PRIVATE LIMITED',
    'PRUDENCE MARINE SERVICES PRIVATE LIMITED',
    'HAPPY ROOTS FOODS & BEVERAGES INDIA PRIVATE LIMITED',
    'DJT FINANCIAL SERVICES PRIVATE LIMITED',
    'INTERA HEALTHCARE PRIVATE LIMITED',
    'OHEALER HEALTHCARE SERVICES PRIVATE LIMITED',
    'SHREE LAKSHMI CARS PRIVATE LIMITED',
    'AUTOBATICS PRIVATE LIMITED',
    'CRONIES PHARMA & BIO-SCIENCES PRIVATE LIMITED',
    'MOUVEMENT LOGISTICS PRIVATE LIMITED',
    'INFOICON SOFTWARE PRIVATE LIMITED',
    'KREATE EMPOWERMENT & WELFARE FOUNDATION',
    '2626 CREATIVE STUDIO PRIVATE LIMITED',
    'COLOSIEM HEALTHCARE PRIVATE LIMITED',
    'REISHA INDUSTRIAL AND ELECTRONIC ACCESSORIES PRIVATE LIMITED',
    'SELLRYT EBUSINESS PRIVATE LIMITED',
    'GRAIN TECHNIK PRIVATE LIMITED',
    'DATTAR SOLUTIONS PRIVATE LIMITED',
    'INNOVIMA TECHNOLOGIES PRIVATE LIMITED',
    'INNERWAVE ENDEAVORS PRIVATE LIMITED',
    'ZOMATO HYPERPURE PRIVATE LIMITED',
    'TELLURIS BIOTECH INDIA PRIVATE LIMITED',
    'WATERQUEST HYDRORESOURCES MANAGEMENT INDIA PRIVATE LIMITED',
    'KRAZY MANTRA HR SOLUTIONS PRIVATE LIMITED',
    'GENIX EDUCATION SOLUTIONS INDIA PRIVATE LIMITED',
    'WEB ERA TECHNOLOGY PRIVATE LIMITED',
    'INFINY WEBCOM PRIVATE LIMITED',
    'SIDCON INDIA PRIVATE LIMITED',
    'TWIST & IGNITE PRIVATE LIMITED',
    'LIVE DATA VISUALISATION PRIVATE LIMITED',
    'VISCADIA PRIVATE LIMITED',
    'ECOBIZ ENTERPRISES PRIVATE LIMITED',
    'XENIAL INDIA PRIVATE LIMITED',
    'SVL INDIA PRIVATE LIMITED',
    'CRKAY LOGICS PRIVATE LIMITED',
    'CHHABRIA REALTY PRIVATE LIMITED',
    'PAYTABS PAYMENT SOLUTIONS PRIVATE LIMITED',
    'ABSOLUTE REPORTS PRIVATE LIMITED',
    'INDIAN FOOTBALL COACHES ALLIANCE PRIVATELIMITED',
    'ARROBA COFFEE & BEVERAGES PRIVATE LIMITED',
    'HOLIDAYBOOKIE PRIVATE LIMITED',
    'FATSMEAGOL MEDIA PRIVATE LIMITED',
    'WHITE-BEAR REFRIGERATION INDIA PRIVATE LIMITED',
    'SHRIMARUTI PRECISION ENGINEERING PRIVATELIMITED',
    'XIN NETWORKS (INDIA) PRIVATE LIMITED',
    'HAMSA WELLNESS PRIVATE LIMITED',
    'ISHANVI INDUSTRIAL & LOGISTICS PARK PRIVATE LIMITED',
    'HEALTHONE NUTRITIONS PRIVATE LIMITED',
    'KAZON INDIA PRIVATE LIMITED',
    'AEROEDU MANAGEMENT PRIVATE LIMITED',
    'STARBIT OILFIELDS SERVICES INDIA LIMITED',
    'HASIRU DALA INNOVATIONS PRIVATE LIMITED',
    'ILARIZA BIONATURALS PRIVATE LIMITED',
    'CONVERGENCE ACCOUNTANCY PRIVATE LIMITED',
    'SHANADZZAR LOGISTICS (INDIA) PRIVATE LIMITED',
    'ARABICA HOLIDAYS INDIA PRIVATE LIMITED',
    'PAINTS AND COATINGS SKILL COUNCIL',
    'COOL FISH PRIVATE LIMITED',
    'SHREYASH RETAIL PRIVATE LIMITED',
    'PRARAJ ENTERPRISES PRIVATE LIMITED',
    'MYLINK SERVICES PRIVATE LIMITED',
    'BAT LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'TEKWIN TECHNOLOGIES PRIVATE LIMITED',
    'AUTOMATION OF THINGS PRIVATE LIMITED',
    'WATCHDOG TECHNOLOGIES PRIVATE LIMITED',
    'SHIVRAJ HEAVY ENGINEERING PRIVATE LIMITED',
    'HARWEST OVERSEAS PRIVATE LIMITED',
    'RVR DIGITAL NET PRIVATE LIMITED',
    'BLS E-SOLUTIONS PRIVATE LIMITED',
    'MADRAS INSTITUTE OF NEURO SCIENCES AND HOSPITALS PRIVATE LIMITED',
    'MUDSKIPPER FOUNDATION',
    'IONA ENTERTAINMENT PRIVATE LIMITED',
    'FARMERS FRESHZONE PRIVATE LIMITED',
    'DIFOT EXPRESS PRIVATE LIMITED',
    'STEPSTOGREEN ECOTEC (OPC) PRIVATE LIMITED',
    'SABRISCAN SOLUTIONS INDIA PRIVATE LIMITED',
    'VEDTEEK INFRASTRUCTURE PRIVATE LIMITED',
    'VUEL DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PROFITFUSION ADVISORY SERVICES (OPC) PRIVATE LIMITED',
    'DLJM SKILL DEVELOPMENT FOUNDATION',
    'LAUNDRETTES GROUP PRIVATE LIMITED',
    'COLLARFOLK PETSERVICES PRIVATE LIMITED',
    'D2R INFRA & BUILDING PROJECTS PRIVATE LIMITED',
    'ZLD TECHNOLOGIES PRIVATE LIMITED',
    'ADB ROOMS PRIVATE LIMITED',
    'ADHIRATH POWER AND HOLDINGS PRIVATE LIMITED',
    'PREMIER CONSULTANCY & INVESTIGATION PRIVATE LIMITED',
    'OGO TRIP PRIVATE LIMITED',
    'ENPROWESS TECHNOLOGIES PRIVATE LIMITED',
    'WOWRIOR INNOVATIONS PRIVATE LIMITED',
    'APIDEL TECHNOLOGIES PRIVATE LIMITED',
    'VAWSUM SCHOOLS PRIVATE LIMITED',
    'INDO-SWISS CENTRE OF EXCELLENCE',
    'V.I.I INSTITUTIE PRIVATE LIMITED',
    'ASHTAPATHY HEALTH CARE PRIVATE LIMITED',
    'RATTAN SPIRIT PRIVATE LIMITED',
    'ULTRA LNG HALDIA LIMITED',
    'SKY TRAVEL & TOURS BRANCH PRIVATE LIMITED',
    'SILERGY TECHNOLOGIES PRIVATE LIMITED',
    'MAIS TECHNOLOGIES PRIVATE LIMITED',
    'RANGPARV CRAFTS PRIVATE LIMITED',
    'ALICESOFT PRIVATE LIMITED',
    'LMD CONTROL AND AUTOMATION PRIVATE LIMITED',
    'MY BASKETZS PRIVATE LIMITED',
    'MANZA HOLIDAYS PRIVATE LIMITED',
    'KPB HOLDINGS LIMITED',
    'BRAHMA DESIGNS INDIA PRIVATE LIMITED',
    'SUROBHI ANALYTICAL CONSULTING (OPC) PRIVATE LIMITED',
    'CONRAD LIGHTING SOLUTIONS PRIVATE LIMITED',
    'PRINT ANTS ONLINE PRINTING SERVICES PRIVATE LIMITED',
    'SKAAS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'COMPANYJI.COM PRIVATE LIMITED',
    'ASCENTECH INFORMATION TECHNOLOGY PRIVATELIMITED',
    'DHRUV ENERGY PRIVATE LIMITED',
    'HANDC SERVICE PRIVATE LIMITED',
    'MIGHTY AUTO WHEELS PRIVATE LIMITED',
    'ESSENTIA FOOD INGREDIENTS AND SOLUTIONS PRIVATE LIMITED',
    'APTIVA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RIKI GLOBAL TRADING PRIVATE LIMITED',
    'IFACE PRIVATE LIMITED',
    'SANRAY LABORATORIES PRIVATE LIMITED',
    'THREE FINGERS ENTERTAINMENT LIMITED',
    'INSTASPACES REALTECH PRIVATE LIMITED',
    'ROYALERA HOMES PRIVATE LIMITED',
    'ENGINEERING COMMODITY & SERVICES (INDIA)PRIVATE LIMITED',
    'KANERA SALES PRIVATE LIMITED',
    'SATHGURU CATALYSER ADVISORS PRIVATE LIMITED',
    'CHM CLEAN ENERGY PRIVATE LIMITED',
    'GRANT INSTRUMENTS INDIA PRIVATE LIMITED',
    'LZINE TECHNOLOGIES PRIVATE LIMITED',
    'INTELYTICS SOLUTIONS PRIVATE LIMITED',
    'SOFTCORE SOLUTIONS PRIVATE LIMITED',
    'KAHA TECHNOLOGIES PRIVATE LIMITED',
    'LE PRECIS STUDIO PRIVATE LIMITED',
    'TM BLR SOLUTIONS PRIVATE LIMITED',
    'EPLAN SOFTWARE & SERVICES PRIVATE LIMITED',
    'VR GLOBAL CYBER TECHNOLOGIES PRIVATE LIMITED',
    'VACUBE IT SERVICES PRIVATE LIMITED',
    'COMPUTER SYSTEMS WEST PRIVATE LIMITED',
    'REPLETE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ENDOVIA FINANCIAL SERVICES PRIVATE LIMITED',
    'AIS TECHNOLABS PRIVATE LIMITED',
    'CONSILIUM AUTOMATION & FIRE PROTECTION PRIVATE LIMITED',
    'NEXTBILLION TECHNOLOGY PRIVATE LIMITED',
    'UDAY WELFARE FOUNDATION',
    'WEB APPLICATION LABS PRIVATE LIMITED',
    'FREE DOCTOR HELPLINE PRIVATE LIMITED',
    'CODEWORKS TECHNOLOGIES PRIVATE LIMITED',
    'BVM STRATEGIC SOLUTIONS PRIVATE LIMITED',
    'BLUBOXX COMMUNICATION PRIVATE LIMITED',
    'TECHPLAYR SERVICES PRIVATE LIMITED',
    'BLACK&GREEN MOBILE SOLUTIONS PRIVATE LIMITED',
    'FIRST RESPONDERS PRIVATE LIMITED',
    'CHANDIGARH MAHARASHTRA LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'YES LOGISTICS INDIA PRIVATE LIMITED',
    'ORIGINAL DENIM PRIVATE LIMITED',
    'DREAMZ NUTRITION & PHARMACEUTICALS PRIVATE LIMITED',
    'EVIRTUAL IT SERVICES PRIVATE LIMITED',
    'CLOUDPAY TECHNOLOGIES PRIVATE LIMITED',
    'NEWTEC HYDRAULICS PRIVATE LIMITED',
    'SEDNA LOGISTICS PRIVATE LIMITED',
    'CALLIDUS COMPLIANCE SOLUTIONS PRIVATE LIMITED',
    'PUNE BIENNALE FOUNDATION',
    'RADHASHOK PHARMACHEM PRIVATE LIMITED',
    'PATIL ELECTROMECH SOLAR ENERGIES PRIVATELIMITED',
    'CLIMA CONTROL REEFERS PRIVATE LIMITED',
    'SADBHAV HEALTH SERVICES PRIVATE LIMITED',
    '6S FOOTWEAR PRIVATE LIMITED',
    'MINDFUL COOK PRIVATE LIMITED',
    'XPERT GROUP PRIVATE LIMITED',
    'WHIZSTORM SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'REGAL ENGINEERS & CONTRACTORS PRIVATE LIMITED',
    'MAISHA INFOTECH PRIVATE LIMITED',
    'HUBX COMMERCIAL VENTURES PRIVATE LIMITED',
    'ZINGOOL UNIMEDIA LIMITED',
    'NODD VENTURES PRIVATE LIMITED',
    'S.B.V. EDUCATION & WELFARE FOUNDATION',
    'W3ERA WEB TECHNOLOGY PRIVATE LIMITED',
    'VSUN AUTOMOTIVE MARKETING PRIVATE LIMITED',
    'SAVIC TECHNOLOGIES PRIVATE LIMITED',
    'ISECURE POWER TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'ARYAUZORA VENTURES PRIVATE LIMITED',
    'INNOWIRELESS INDIA SERVICES PRIVATE LIMITED',
    'ANNOUNCECAST PRIVATE LIMITED',
    'TOJO VIKAS BIOTECH PRIVATE LIMITED',
    'NEXT LEAP ADVISORY AND SEARCH SERVICES PRIVATE LIMITED',
    'PHOOLTAS TECHNOLOGIES PRIVATE LIMITED',
    'AFS MAINTENANCE PRIVATE LIMITED',
    'PROUD NATURE BUILDTECH PRIVATE LIMITED',
    'CREATIVATORSS EVENT & PRODUCTION PRIVATE LIMITED',
    'AVISO INFOTECH PRIVATE LIMITED',
    'HOMEBRAIN IOT SERVICES PRIVATE LIMITED',
    'BAIDU INDIA INTERNET PRIVATE LIMITED',
    'COMPUCARE INDIA PRIVATE LIMITED',
    'CHATOUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BLUE PLATE HOSPITALITY AND SERVICES PRIVATE LIMITED',
    'TATVIC ANALYTICS PRIVATE LIMITED',
    'KRISHA DISTRIBUTION PRIVATE LIMITED',
    'ICONIQ SKILLS INDIA PRIVATE LIMITED',
    'WHITE LOTUS VENUS HOMES PRIVATE LIMITED',
    'VENTUREAST INVESTMENT ADVISORS PRIVATE LIMITED',
    'STEPCARE PRIVATE LIMITED',
    'SHUBHASHISH IT SERVICES LIMITED',
    'ARNA MEDISCIENCES PRIVATE LIMITED',
    'CHHAVI STAR ENTERPRISES PRIVATE LIMITED',
    'SUPOSHAA REALCON PRIVATE LIMITED',
    'ESCAN GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'AJITEK TECH SOLUTIONS PRIVATE LIMITED',
    'ANZEN TECHNOLOGIES PRIVATE LIMITED',
    'H2O CARE PRIVATE LIMITED',
    'BRANDS & FOLKS CONSULTING PRIVATE LIMITED',
    'NETARK TECHNOLOGIES INDIA PRIVATE LIMITED',
    'WASHINGGUNS TECHNOLOGIES PRIVATE LIMITED',
    'REVANTA MARKETING SERVICES PRIVATE LIMITED',
    'PROFFESIO ONLINE SERVICES PRIVATE LIMITED',
    'MIDGULF SERVICES INDIA PRIVATE LIMITED',
    'GUBBA AGRI COLD PRIVATE LIMITED',
    'EURO INFOTEK PRIVATE LIMITED',
    'ANGULAR MINDS PRIVATE LIMITED',
    'SIXPATH TECHNOLOGIES PRIVATE LIMITED',
    'QUINOVIC PHARMACEUTICALS PRIVATE LIMITED',
    'DIMENSION STEEL PRIVATE LIMITED',
    'FIREFITE EVEREST PRIVATE LIMITED',
    'OASIS CONNECTIVITY PRIVATE LIMITED',
    'NIRMAL BANG NIVESHALAYA PRIVATE LIMITED',
    'DHC GLOBAL CENTRE OF EXCELLENCE PRIVATE LIMITED',
    'MUTHOOT ROYALEX FOREX SERVICES PRIVATE LIMITED',
    'ENERGYGREEN TECHNOPOWER PRIVATE LIMITED',
    'BINDOOKHADAK SOLAR PROJECTS PRIVATE LIMITED',
    'ANKIREDDY FOUNDATION',
    'EKALAVYAS CONSULTANCY PRIVATE LIMITED',
    'RR BUILDCON PRIVATE LIMITED',
    'ARIN INFOTECH PRIVATE LIMITED',
    'MATRECOMM TECHNOLOGIES PRIVATE LIMITED',
    'DIVE SPORTSWEAR PRIVATE LIMITED',
    'S AND S DELIVERY SOLUTIONS PRIVATE LIMITED',
    'VOLTCON ENERGY INDIA PRIVATE LIMITED',
    'RELIANCE PROPERTY DEVELOPERS PRIVATE LIMITED',
    'WAREWE CONSULTANCY PRIVATE LIMITED',
    'MOBIKASA PRIVATE LIMITED',
    'TELE UNIV SOLUTIONS PRIVATE LIMITED',
    'MAX ESTATES LIMITED',
    'SOFTDEW TECH PRIVATE LIMITED',
    'APG PROPERTY SERVICES PRIVATE LIMITED',
    'ACCTRON SOLUTIONS & SERVICES PRIVATE LIMITED',
    'MAA SHEETLA DISTRIBUTORS PRIVATE LIMITED',
    'LETSTRAK TECH PRIVATE LIMITED',
    'DATARYNX PRIVATE LIMITED',
    'SURAT SMART CITY DEVELOPMENT LIMITED',
    'EKA HOSPITALITY PRIVATE LIMITED',
    'COGO FREIGHT PRIVATE LIMITED',
    'ACCURATE FINSERV PRIVATE LIMITED',
    'DAYAL VACATIONS INDIA PRIVATE LIMITED',
    'TICKETSNTRIPS TRAVEL PRIVATE LIMITED',
    'TIAA GLOBAL CAPABILITIES PRIVATE LIMITED',
    'KOLIKKO TECHNOLOGY INDIA PRIVATE LIMITED',
    'TRUE FACTOR APPLICATIONS AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GIMCO GLOBAL SERVICES PRIVATE LIMITED',
    'INDIAFARM FOODS PRIVATE LIMITED',
    'R AND G TEA PLANTATION PRIVATE LIMITED',
    'BRIAR TEA PRIVATE LIMITED',
    'AMRIT ECOTEX PRIVATE LIMITED',
    'TECHNICOAT INDIA PRIVATE LIMITED',
    'KINTECH GLOBAL SERVICES PRIVATE LIMITED',
    'NANJGEL SOLUTIONS PRIVATE LIMITED',
    'BMC SUPPORT AND ACCOUNTING SERVICES PRIVATE LIMITED',
    'KHALID EXCHANGE PRIVATE LIMITED',
    'ALCHEM LIFE PRIVATE LIMITED',
    'PHOTON PRODUCTIONS PRIVATE LIMITED',
    'EZEELY DISTRIBUTION NETWORKS PRIVATE LIMITED',
    'RAYEHANI MARKETING PRIVATE LIMITED',
    'STRATEGINK SOLUTIONS PRIVATE LIMITED',
    'TURBO FREIGHT PRIVATE LIMITED',
    'SUNCURE LIFESCIENCE PRIVATE LIMITED',
    'ANAMAYA (INDIA) PRIVATE LIMITED',
    'BIOMEDIC HEALTHCARE PRIVATE LIMITED',
    'IDECO ENGINEERING INDIA PRIVATE LIMITED',
    'IMPERIAL TECHSOL PRIVATE LIMITED',
    'WAKEFIT INNOVATIONS PRIVATE LIMITED',
    'RADISSON REALTY-INFRA PRIVATE LIMITED',
    'AMRIT VED PRIVATE LIMITED',
    'EDTECHREVIEW MEDIA PRIVATE LIMITED',
    'SD INFRA & MEP SERVICES PRIVATE LIMITED',
    'AB MOBILE SERVICES ALLIANCE INDIA PRIVATE LIMITED',
    'IHAUL LOGISTICS SOLUTION PRIVATE LIMITED',
    'TECSO ENERGY PRIVATE LIMITED',
    'DOGA INDIA PRIVATE LIMITED',
    'ARANYANI LIFESTYLES PRIVATE LIMITED',
    'CINETICO SERVICES PRIVATE LIMITED',
    'SIMPSOFT SOLUTIONS PRIVATE LIMITED',
    'JHM LOGISTICS PRIVATE LIMITED',
    'NECO DESERT TECH DEFENCE PRIVATE LIMITED',
    'DNA DHANRAJ TELECOM PRIVATE LIMITED',
    'VIZAG BROADBAND COMMUNICATIONS PRIVATE LIMITED',
    'CKERS FINANCE PRIVATE LIMITED',
    'LIMBER INFRASTRUCTURE SOLUTION PRIVATE LIMITED',
    'GOMO MARKETING SERVICES INDIA PRIVATE LIMITED',
    'BHARTI CONSULTANCY SERVICES PRIVATE LIMITED',
    'WINMAGIC INDIA PRIVATE LIMITED',
    'GALAXUX INDIA PRIVATE LIMITED',
    'GODAMWALE TRADING AND LOGISTICS PRIVATE LIMITED',
    'GITN SERVICES PRIVATE LIMITED',
    'RUSTICITY SOLUTIONS PRIVATE LIMITED',
    'BELLWETHER MANAGEMENT PRIVATE LIMITED',
    'IGC LIFESTYLE PRIVATE LIMITED',
    'VAMO SYSTEMS PRIVATE LIMITED',
    'SMARTIT FRAME SOFTWARE SERVICES PRIVATE LIMITED',
    'GIESECKE & DEVRIENT MS INDIA PRIVATE LIMITED',
    'MIST RAIN PLANTATIONS AND FARMS PRIVATE LIMITED',
    'ADRPLEXUS MEDICAL SERVICES PRIVATE LIMITED',
    'THIRUVALANGADU FARMERS PRODUCER COMPANY LIMITED',
    'SQA WORX SOLUTIONS PRIVATE LIMITED',
    'DIGIGARAGE TECHNOLOGIES PRIVATE LIMITED',
    'SD BARCODE SOLUTION PRIVATE LIMITED',
    'KRISTA SOFTWARE PRIVATE LIMITED',
    'SIMPLIFY GROWTH RESEARCH & CONSULTING PRIVATE LIMITED',
    'VED PRAKASH GUPTA FOUNDATION',
    'FAST TRACK FACILITIES PRIVATE LIMITED',
    'FANCYTAB LIFESTYLE PRIVATE LIMITED',
    'MEET & GREET GIFTS PRIVATE LIMITED',
    'JAT GLOBAL PRIVATE LIMITED',
    'AW HOSPITALITY PRIVATE LIMITED',
    'SAILOUT INTERNATIONAL PRIVATE LIMITED',
    'OBAMAA MCOMMERCE PRIVATE LIMITED',
    'TELLER COMM PRIVATE LIMITED',
    'EMIDIANCE PRIVATE LIMITED',
    'LUXEVEDA BRAND SERVICES PRIVATE LIMITED',
    'POSTERCHILD ADVERTISING PRIVATE LIMITED',
    'BYKEMANIA SOLUTIONS PRIVATE LIMITED',
    'SP PORT MAINTENANCE PRIVATE LIMITED',
    'ORIANA HOSPITAL PRIVATE LIMITED',
    'WELSPUN ENERGY THERMAL PRIVATE LIMITED',
    'AXON INTERCONTINENT PRIVATE LIMITED',
    'EASYEAT FOODS PRIVATE LIMITED',
    'LUXE PASSION PRIVATE LIMITED',
    'JFK TRANSPORTERS PRIVATE LIMITED',
    'POLO QUEEN CAPITAL LIMITED',
    'HONER DEVELOPERS PRIVATE LIMITED',
    'NA PROPERTIES PRIVATE LIMITED',
    'STAX LABS INC PRIVATE LIMITED',
    'VEDAHA TECHINFO PRIVATE LIMITED',
    'PREMIUM MEDICARE PRIVATE LIMITED',
    'FINNOVATION TECH SOLUTIONS PRIVATE LIMITED',
    'SUSTAINABILITY & GREENERGY CONSULTANTS (OPC) PRIVATE LIMITED',
    'PRAJASH PROJECTS & SERVICES PRIVATE LIMITED',
    'DEEVOIR SHARED SERVICES PRIVATE LIMITED',
    'KSM DIGITAL PRIVATE LIMITED',
    'SYNTAX TREE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'FREEG WIFI TECHNOLOGIES PRIVATE LIMITED',
    'YARAMAN COFFEE PRIVATE LIMITED',
    'CHENNAI PUBLISHING SERVICES PRIVATE LIMITED',
    'VNR BIOSCIENCES PRIVATE LIMITED',
    'BOLLYWOOD TIMES PRIVATE LIMITED',
    'RATNAAKAR INFRATECH PRIVATE LIMITED',
    'SILEAF TECHNOLOGIES PRIVATE LIMITED',
    'BANASHREE RENEWABLE ENERGY SYSTEM PRIVATE LIMITED',
    'CHIKKU ENERGY PRIVATE LIMITED',
    'AINS ICT SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SOPETEL TECHNOLOGIES PRIVATE LIMITED',
    'XEBRIUM SOFTWARE PRIVATE LIMITED',
    'SIVA SRI SOFT TECH SOLUTIONS PRIVATE LIMITED',
    'LIVE WEB EXPERTS PRIVATE LIMITED',
    'IT AMERICA INDIA PRIVATE LIMITED',
    'MECHMAK CNC (INDIA) PRIVATE LIMITED',
    'ECOWAVZ HEALTH PRIVATE LIMITED',
    'AERATE HEALTH CARE SOLUTIONS PRIVATE LIMITED',
    'KOREIOT SOLUTIONS PRIVATE LIMITED',
    'MEGLYN TECHNOLOGIES PRIVATE LIMITED',
    'PACIFIC SEA FREIGHT PRIVATE LIMITED',
    'VARUNA INTEGRATED SERVICES PRIVATE LIMITED',
    'TECHNICAD EDUTECH AND ENGINEERS PRIVATE LIMITED',
    'MODGEN SOLUTIONS PRIVATE LIMITED',
    'GRADOPEDIA EDUCATION PRIVATE LIMITED',
    'CASPIAN GLOBELINK PRIVATE LIMITED',
    'KANCHARLA CONSTRUCTIONS PRIVATE LIMITED',
    'ABC STEPS TECHNOLOGIES PRIVATE LIMITED',
    'AVC TECHNICAL SERVICES PRIVATE LIMITED',
    'UPSKILLIST INDIA PRIVATE LIMITED',
    'BLUETALON SOFTWARE INDIA PRIVATE LIMITED',
    'ASIANET DIGITAL NETWORK PRIVATE LIMITED',
    'AMLOH INDUSTRIES LIMITED',
    'BHARARI NATURAL AGRO PRIVATE LIMITED',
    'HARSIM AGRO TECH PRIVATE LIMITED',
    'L D SOLUTIONS PRIVATE LIMITED',
    'BRAINS PRIVATE LIMITED',
    'JAVA LOGISTICS PRIVATE LIMITED',
    'COCHIN TECH GENERATORS PRIVATE LIMITED',
    'RODEO RESORTS & HOTELS PRIVATE LIMITED',
    'PROFESSIONAL PROWORKERZ PRIVATE LIMITED',
    'LEAST COUNT TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'AASHNI ECOMMERCE PRIVATE LIMITED',
    'PAN HEALTHCARE PRIVATE LIMITED',
    'MANISHA ELECTRICALS AND ENGINEERS PRIVATE LIMITED',
    'WGBL INDIA PRIVATE LIMITED',
    'SOUTHERN GEO PROJECTS PRIVATE LIMITED',
    'WELSPUN FLOORING LIMITED',
    'CMK PROJECTS PRIVATE LIMITED',
    'EMERALD PERFORMANCE CHEMICAL PRIVATE LIMITED',
    'GLYCO CHEMBIOTECH PRIVATE LIMITED',
    'BARAKA TRAINING PRIVATE LIMITED',
    'FORSCHER TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'QUIX INTERNATIONAL PRIVATE LIMITED',
    'TOTO SHOPPE PRIVATE LIMITED',
    'ASTRON TOURS AND TRAVELS PRIVATE LIMITED',
    'PEERBITS CONSULTANCY SERVICES PRIVATE LIMITED',
    'MINUSBUGS PRIVATE LIMITED',
    'GURUVARAM NIDHI LIMITED',
    'EXTENSIVE ENTERPRISES PRIVATE LIMITED',
    'HIGH NOON CONSULTING PRIVATE LIMITED',
    'SRS LIVE TECHNOLOGIES PRIVATE LIMITED',
    'A B CYBER TECHNOLOGY PRIVATE LIMITED',
    'AKS LEATHER INDIA (OPC) PRIVATE LIMITED',
    'INDIANMAZE ADVISORY (OPC) PRIVATE LIMITED',
    'WATERWALA LABS PRIVATE LIMITED',
    'BLUE IVY VENTURES PRIVATE LIMITED',
    'FRUITIONPOINT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'OFFICEDECK TECHNOLOGIES PRIVATE LIMITED',
    'DREAMVISION DESIGN PRIVATE LIMITED',
    '3M3S TECH PRIVATE LIMITED',
    'BRIDGE INVESTOR RELATIONS PRIVATE LIMITED',
    'PROPBEST ADVISORY & SOLUTIONS PRIVATE LIMITED',
    'HARMONY LIFESCIENCE PRIVATE LIMITED',
    'IMEDRIX SYSTEMS PRIVATE LIMITED',
    'CLORIDA TECHNOLOGIES PRIVATE LIMITED',
    'CITY LINK PORTAL PRIVATE LIMITED',
    'VIRTUAL WORLD SPATIAL TECHNOLOGIES PRIVATE LIMITED',
    'POOJA TALWAR EDUCATION PRIVATE LIMITED',
    'JANITRI INNOVATIONS PRIVATE LIMITED',
    'SR MOVING TALKIES PRIVATE LIMITED',
    'ENGINEERED PRODUCTS AND CONTROLS (OPC) PRIVATE LIMITED',
    'WATERVISION SYSTEMS PRIVATE LIMITED',
    'CUENTAS CONSULTING PRIVATE LIMITED',
    'AMBIKA SPECIALTY INGREDIENTS PRIVATE LIMITED',
    'JIWA FOODS PRIVATE LIMITED',
    'PADECO INDIA PRIVATE LIMITED',
    'ACME LED INDIA PRIVATE LIMITED',
    'GYP ELITE INDIA PRIVATE LIMITED',
    'APPIUSS SOFTWARE (OPC) PRIVATE LIMITED',
    'PDR OUTSOURCE SOLUTIONS PRIVATE LIMITED',
    'ARKHA NON-CONVENTIONAL ENERGY PRIVATE LIMITED',
    'ADVANTUM HEALTH PRIVATE LIMITED',
    'VIKREED SOLUTIONS PRIVATE LIMITED',
    'DAVID ADAMSON INDIA PRIVATE LIMITED',
    'SAGACITO TECHNOLOGIES PRIVATE LIMITED',
    'ROBINVILLE ENVIRONMENT AND ROPEWAYS TECHNOLOGY PRIVATE LIMITED',
    'FLAT WORLD DESIGN & DEVELOPMENT PRIVATE LIMITED',
    'KEC SPUR INFRASTRUCTURE PRIVATE LIMITED',
    'CAROUSEL HOSPITALITY PRIVATE LIMITED',
    'SPIDERJUICE PRIVATE LIMITED',
    'AUTO INGRESS INDIA PRIVATE LIMITED',
    'SAMRUDDHI BUILDING SYSTEM PRIVATE LIMITED',
    'HONG GUANG DE TECHNOLOGY INDIA PRIVATE LIMITED',
    'DTR VMS INDIA PRIVATE LIMITED',
    'GTO PAY APPZ HR SOLUTIONS PRIVATE LIMITED',
    'FLAT WORLD HOME PRIVATE LIMITED',
    'XML (NEW DELHI) PRIVATE LIMITED',
    'MMA DESIGN PRIVATE LIMITED',
    'SHIROMANI SOFTTECH (OPC) PRIVATE LIMITED',
    'ONE TWO FLIP ENTERTAINMENT PRIVATE LIMITED',
    'TIME OF SPORTS SOLUTIONS PRIVATE LIMITED',
    'PEACOCKTAIL CREATIVE PRIVATE LIMITED',
    'WORKRINGS SERVICES PRIVATE LIMITED',
    'BNB TECHNOLOGIES PRIVATE LIMITED',
    'MOVESURE TECHNOLOGIES PRIVATE LIMITED',
    'COMFIA ECOM PRIVATE LIMITED',
    'ALPINE SPINWEAVE PRIVATE LIMITED',
    'BLUE KNOT APPARELS PRIVATE LIMITED',
    'FILOSHA FIBRES PRIVATE LIMITED',
    'VEERAM CLOTHING PRIVATE LIMITED',
    'AGROMETAL VENDIBLES PRIVATE LIMITED',
    'SUMMER RAIN EXPORTS PRIVATE LIMITED',
    'RAVI HOME FASHIONS PRIVATE LIMITED',
    'KUNAL CLOTHING PRIVATE LIMITED',
    'SRI SHYAM FASHION INDIA PRIVATE LIMITED',
    'SURKHAB EXPORTS PRIVATE LIMITED',
    'VISTA FURNISHING LIMITED',
    'BHAIRAV KNITTING PRIVATE LIMITED',
    'SUNRISE KNITTING MILLS PRIVATE LIMITED',
    'AGASTYA BUOYANT PRIVATE LIMITED',
    'LOOCUST INCORP APPAREL EXPORT PRIVATE LIMITED',
    'ASTRID FASHIONS PRIVATE LIMITED',
    'AIRWILL HOME COLLECTIONS PRIVATE LIMITED',
    'INDIANO TAILORED FABRIC PRIVATE LIMITED',
    'INDIA TERRY TOWELS PRIVATE LIMITED',
    'SHINE COT-SPIN PRIVATE LIMITED',
    'CTM DENIM PRIVATE LIMITED',
    'SUHASINI SPINNERS LIMITED........',
    'TEXGEEK FASHIONS PRIVATE LIMITED',
    'UNIQUE LABELS & RIBBONS PRIVATE LIMITED',
    'KABIR CLOTHINGS PRIVATE LIMITED',
    'KAAMDHENU YARN PRIVATE LIMITED',
    'FUSE LINE FABRICS PRIVATE LIMITED',
    'ABU SANDEEP FASHIONS PRIVATE LIMITED',
    'TYKIN RETAIL & TRADING PRIVATE LIMITED',
    'PATRORNA APPARELS PRIVATE LIMITED',
    'RELIANCE ABU SANDEEP PRIVATE LIMITED',
    'DEVI MAA SUNRAYS POWER PRIVATE LIMITED',
    'SIVANTA SPUNTEX PRIVATE LIMITED',
    'VASU LIFESTYLE PRIVATE LIMITED',
    'Varun Hospitality Management Private Limited',
    'UNTAG FASHIONS PRIVATE LIMITED',
    'TRENDYDICE APPARELS PRIVATE LIMITED',
    'ARBAB FASHIONS PRIVATE LIMITED',
    'AREK INDUSTRIES PRIVATE LIMITED',
    'SPUNWEB NONWOVEN PRIVATE LIMITED',
    'WILDLOTUS FASHIONS PRIVATE LIMITED',
    'KOLKOZY FASHION PRIVATE LIMITED',
    'TANDHAN COTTON MILLS PRIVATE LIMITED',
    'EXPOSE APPARELS PRIVATE LIMITED',
    'VEEKEM ENTERPRISES PRIVATE LIMITED',
    'MOARK LIFESTYLE PRIVATE LIMITED',
    'STARS DESIGN GROUP APPARELS PRIVATE LIMITED',
    'KAFA CLOTHING INDIA PRIVATE LIMITED',
    'KAY VENTURES PRIVATE LIMITED',
    'JK SOURCING PRIVATE LIMITED',
    'REVIVAL PROJECT CLOTHING PRIVATE LIMITED',
    'LOTUS ATTIRES (INDIA) PRIVATE LIMITED',
    'FAIR BROTHERS EXIM PRIVATE LIMITED',
    'PRANU LIFESTYLES PRIVATE LIMITED',
    'PURPLE STYLE LABS PRIVATE LIMITED',
    'LA RONDA CHOCODATES INDIA PRIVATE LIMITED',
    'TANJANA ENTERPRISES PRIVATE LIMITED',
    'CREASE AND CUFF CLOTHING PRIVATE LIMITED',
    'G D N EXPORT PRIVATE LIMITED',
    'FRONTIER PROTECTIVEWEAR PRIVATE LIMITED',
    'RICA COLLECTION PRIVATE LIMITED',
    'DUPATTA WORLD PRIVATE LIMITED',
    'VEENA WORLD FOREX PRIVATE LIMITED',
    'WAY 2 INTERNET PRIVATE LIMITED',
    'VENTURINI FOOTWEAR INDIA PRIVATE LIMITED',
    'UNITED CAPZ PRIVATE LIMITED',
    'ARTIS LEATHERS PRIVATE LIMITED',
    'EUROFARM ORGANICS PRIVATE LIMITED',
    'DMAX OVERSEAS PRIVATE LIMITED',
    'KUNSTFJORD TRADING PRIVATE LIMITED',
    'ICONIUM LEATHER WORKS PRIVATE LIMITED',
    'LIGHTHOUSE EDUPRO SERVICES PRIVATE LIMITED',
    'PILTOVER TECHNOLOGIES PRIVATE LIMITED',
    'CENTAURUS LIFESTYLE BRANDS PRIVATE LIMITED',
    'TAURIO FASHION PRIVATE LIMITED',
    'ENCRUSTD FASHION PRIVATE LIMITED',
    'ABRAR LEATHER EXPORTS PRIVATE LIMITED',
    'RISHI AND SOUJIT COUTURE PRIVATE LIMITED',
    'BOLTT SPORTS TECHNOLOGIES PRIVATE LIMITED',
    'COLOSSAL FOOTWEAR PRIVATE LIMITED',
    'LAVACA LEATHERZ PRIVATE LIMITED',
    'VIJU',
    'SMANE VENTURES PRIVATE LIMITED',
    'ZOLAAR TECH PRIVATE LIMITED',
    'MONO FOREX SWAP PRIVATE LIMITED',
    'SYSTROME TECHNOLOGIES PRIVATE LIMITED',
    'VAS SPECTROMETERS PRIVATE LIMITED',
    'ALIVEX ENGINEERING AND SUPPLIERS PRIVATELIMITED',
    'ORKEN INFOTECH (OPC) PRIVATE LIMITED',
    'IVIA BEAUTE PRIVATE LIMITED',
    'DIVYA VASTU PRIVATE LIMITED',
    'BIE TECHNOLOGIES PRIVATE LIMITED',
    'REFEX BEVERAGES PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TEN LIMITED',
    'ADANI SOLAR ENERGY AP ONE LIMITED',
    'TARC ESTATES PRIVATE LIMITED',
    'SG PREFAB & ENGINEERING PRIVATE LIMITED',
    'DRIFT ADVENTURES PRIVATE LIMITED',
    'KHOJ ALLOYS PRIVATE LIMITED',
    'BELA CASA LIGHTING PRIVATE LIMITED',
    'INDEMNITY INSURANCE SURVEYORS & LOSS ASSESSORS PRIVATE LIMITED',
    'NUCASH FINANCIAL SERVICES PRIVATE LIMITED',
    'YADAV LASER DIE PRIVATE LIMITED',
    'SPACETECH ORBITAL PRIVATE LIMITED',
    'GRAMYADARM VITARANA SOLUTIONS PRIVATE LIMITED',
    'MAHAMAYA RETREAT PRIVATE LIMITED',
    'YUTIKA CONSUMER PRIVATE LIMITED',
    'FASHION REVOLUTION FORUM',
    'VIPANIBIZ PRIVATE LIMITED',
    'MIHEE HERBALS PRIVATE LIMITED',
    'MAHENDRA TRANS LOGISTICS PRIVATE LIMITED',
    'INDSYSTEMS IT PRIVATE LIMITED',
    'BLUEGRASSROOTS TECH PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY NINE LIMITED',
    'ADANI RENEWABLE ENERGY ELEVEN LIMITED',
    'ADANI SOLAR ENERGY AP FOUR LIMITED',
    'MURARI AND MOKSHAGNA LOGISTICS PRIVATE LIMITED',
    'SAMOSA EXPRESS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWO LIMITED',
    'NITYANAND MOBILE FUEL PUMP PRIVATE LIMITED',
    'ETHUMBTECH PRIVATE LIMITED',
    'DECOROMIST HOUSING PRIVATE LIMITED',
    'BIZZTRICKS MANAGEMENT CONSULTING PRIVATELIMITED',
    'DEWANSAKYA FOUNDATION',
    'SENSONIC IN INDIA PRIVATE LIMITED',
    'EARLY STEPS ACADEMY PRIVATE LIMITED',
    'TAGG N PAY SOLUTIONS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY SIX LIMITED',
    'GKSHYAM FOODS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY EIGHT LIMITED',
    'FINDYOURFIT PRIVATE LIMITED',
    'WHIZKID LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'GOLDEN PODS PRIVATE LIMITED',
    'BILLINGEDGE RCM PRIVATE LIMITED',
    'SECURE DEBT RESOLUTIONS PRIVATE LIMITED',
    'NEEROZHUKKIL VAIDYASALA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY ONE LIMITED',
    'MINDADZ MEDIA PRIVATE LIMITED',
    'ECHO WEALTH PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY THREE LIMITED',
    'HAPPY CLIPS PRIVATE LIMITED',
    'SOFSTACK SOLUTION PRIVATE LIMITED',
    'BINASHREE MANUFACTURING PRIVATE LIMITED',
    'MADHURAM CONSULTANTS PRIVATE LIMITED',
    'WRKTOP TECHNOLOGIES PRIVATE LIMITED',
    'ARKASHREE TECHNOLOGY PRIVATE LIMITED',
    'SHEARFORCE INDIA PRIVATE LIMITED',
    'KAKKOII ENTERTAINMENT PRIVATE LIMITED',
    'WRAPOTEX INTERNATIONAL PRIVATE LIMITED',
    'CLOUD DESTINATIONS INFOTECH PRIVATE LIMITED',
    'NDSONS ENGINEERS PRIVATE LIMITED',
    'NEXZO INNOVATION PRIVATE LIMITED',
    'SUBCOM PROJECTS INDIA PRIVATE LIMITED',
    'TECHFIT TECHNOLOGIES PRIVATE LIMITED',
    'CREWTEC INFOSOL PRIVATE LIMITED',
    'EARTH ECO SOLUTIONS PRIVATE LIMITED',
    'SETCON PROJECTS PRIVATE LIMITED',
    'AUTOFARM AGRI INDIA PRIVATE LIMITED',
    'FRESHIVE FARMS (OPC) PRIVATE LIMITED',
    'ROYALEBLUE HOSPITALITIES (INDIA) PRIVATELIMITED',
    'GOALACTION PRIVATE LIMITED',
    'JEEVAN JYOT WELFARE FOUNDATION',
    'ADANI RENEWABLE ENERGY FOUR LIMITED',
    'AARIV PHARMACEUTICALS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY SEVEN LIMITED',
    'SAFAL ENTERPRISE PRIVATE LIMITED',
    'CLOTHLAB PRIVATE LIMITED',
    'TERCON PUMPS PRIVATE LIMITED',
    'ASNTAX PRIVATE LIMITED',
    'RAHEE NATURAL SEEDS PRIVATE LIMITED',
    'FIRST MEDIA NETWORK PRIVATE LIMITED',
    'YANTRAMAYA PROJECTS PRIVATE LIMITED',
    'EDUCATED UNEMPLOYED FOUNDATION',
    'UDDIPATH FOUNDATION',
    'SNEHA STAR H R SOLUTIONS PRIVATE LIMITED',
    'NEST ACADEMY OF SPORTS MANAGEMENT WELFARE FOUNDATION',
    'M2XCEL LEARNINGS PRIVATE LIMITED',
    'AVIRISE EXPRESS LOGISTICS PRIVATE LIMITED',
    'CHAOSNATIVE INDIA PRIVATE LIMITED',
    'LEARNOW-IDTCS PRIVATE LIMITED',
    'LOGIVIA LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'MADHAV MINERALS & CHEMICALS PRIVATE LIMITED',
    'YASRAH TRADING INTERNATIONAL PRIVATE LIMITED',
    'ENATOMS PRIVATE LIMITED',
    'HEALTHY HARVEST KRISHI PRODUCER COMPANY LIMITED',
    'RAGNOTECH SOLUTIONS PRIVATE LIMITED',
    'KRISHNA BALRAM EXPORTS PRIVATE LIMITED',
    'SPAZEONE SOLUTIONS PRIVATE LIMITED',
    'GSEC AIR SERVICES PRIVATE LIMITED',
    'PRISMFORCE PRIVATE LIMITED',
    'SKY STONE CRUSHER PRIVATE LIMITED',
    'YES ESTATE PRIVATE LIMITED',
    'MIRTH MEDIA PRIVATE LIMITED',
    'SPORTY FIT GEN PRIVATE LIMITED',
    'THINK INTERIO PRIVATE LIMITED',
    'MILLISYSTEMS PRIVIATE LIMITED',
    'NEST ACADEMY OF FASHION DESIGN AND INNOVATION WELFARE FOUNDATION',
    'AUTUS CYBER TECH PRIVATE LIMITED',
    'KDPL DIAGNOSTICS (LUDHIANA) PRIVATE LIMITED',
    'GREENZUP GROW PRIVATE LIMITED',
    'ANANTHSAI MINERALS PRIVATE LIMITED',
    'ADIE BROSWON SPIRITS PRIVATE LIMITED',
    'PERFECT2 VENTURA INDIA PRIVATE LIMITED',
    'GAP SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SULOJAY REALTY PRIVATE LIMITED',
    'HRSC STRATEGIES CONSULTING INDIA PRIVATELIMITED',
    'REVVI DIGITAL SOLUTIONS PRIVATE LIMITED',
    'NAAVALADI TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'JHNVI SOFT PRIVATE LIMITED',
    'IMPERIA CAPITAL ADVISORS PRIVATE LIMITED',
    'LAST MILE CHANNEL ENHANCEMENT PRIVATE LIMITED',
    'INSHARP PRIVATE LIMITED',
    'RIVAAN PLASTCHEM PRIVATE LIMITED',
    'AVAADA KNSOLAR PRIVATE LIMITED',
    'BRINDAWAN BAKERY PRIVATE LIMITED',
    'APP PAINT CHEMICALS PRIVATE LIMITED',
    'DEON TECHNOLOGY PRIVATE LIMITED',
    'SWASTHA BHARAT SAGAR PRIVATE LIMITED',
    'PRAKASH GREEN INDUSTRIES PRIVATE LIMITED',
    'UTTAM CLEAN ENERGY PRIVATE LIMITED',
    'HVAC EXPERT SOLUTIONS PRIVATE LIMITED',
    'CHANDAN ELECTROTECH PRIVATE LIMITED',
    'DREAMSEQUENCE PRIVATE LIMITED',
    'BADMINTONHUB INDIA PRIVATE LIMITED',
    'KALYAN AUTO ELECTRIC PRIVATE LIMITED',
    'VEDANG DISTRIBUTORS PRIVATE LIMITED',
    'CINEPANDA ENTERTAINMENTS PRIVATE LIMITED',
    'ADK BEVERAGES PRIVATE LIMITED',
    'PREMIUM LUXURY RESIDENCES PRIVATE LIMITED',
    'NANDINI SKIN CARE PRIVATE LIMITED',
    'ADDRESS MAKER RESIDENTIAL LAYOUT PRIVATELIMITED',
    'ADDRESS MAKER LIFE SPACES PRIVATE LIMITED',
    'DPHI TECH PRIVATE LIMITED',
    'BINCRAFT TECHNOLOGIES PRIVATE LIMITED',
    'CONCORD GLOBAL TECH SERVICES PRIVATE LIMITED',
    'NEXGENERA ENTERPRISES PRIVATE LIMITED',
    'CIPIO INDIA PRIVATE LIMITED',
    'SCRIPTBYTES TECHNOLOGY SERVICES PRIVATE LIMITED',
    'CODEART CONSULTING SERVICES PRIVATE LIMITED',
    'FIGITAL LIFESCIENCE PRIVATE LIMITED',
    'FORTUNE 7 FINTECH PRIVATE LIMITED',
    'DE',
    'S SPEECHGEARS PRIVATE LIMITED',
    'REACHLAW INDIA PRIVATE LIMITED',
    'UNI FINANCIAL SERVICES PRIVATE LIMITED',
    'MADEIN PRIVATE LIMITED',
    'POLICY ADDA INSURANCE BROKERS PRIVATE LIMITED',
    'UNISPACEGLOBAL INDIA PRIVATE LIMITED',
    'STEPCARE DIAGNOSTIC SERVICES PRIVATE LIMITED',
    'MPA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'NORTHPORT LOGISTICS PRIVATE LIMITED',
    'NEXTDOOR ORGANIC FOODS PRIVATE LIMITED',
    'ITHINK LOGISTIC QUICK SERVICES PRIVATE LIMITED',
    'SYGNIFIC IT SOLUTIONS PRIVATE LIMITED',
    'PV STEELS PRIVATE LIMITED',
    'HUBLOAD SLS SERVICES PRIVATE LIMITED',
    'IMPEZAR PRIVATE LIMITED',
    'JARVED WORLD PRIVATE LIMITED',
    'AGROWERS PRIVATE LIMITED',
    'BLACK INK BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'K. VIJAY ISPAT PRIVATE LIMITED',
    'RADIAN VENTURES (OPC) PRIVATE LIMITED',
    'LEUVEN CONSTRUCTION PRIVATE LIMITED',
    'MORARKA INVESTMENTS PRIVATE LIMITED',
    'NEWBORN LACTATION CLINIC PRIVATE LIMITED',
    'PACIFICCOAST PRECISTAT PRIVATE LIMITED',
    'VISUAL INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'ASM KNITWEARS PRIVATE LIMITED',
    'SOCIO INVENTIONS AND INNOVATIONS PRIVATELIMITED',
    'EASTNWEST IT SOLUTION PRIVATE LIMITED',
    'SINGHAL WELFARE FOUNDATION',
    'AMPYR RENEWABLE ENERGY RESOURCES ELEVEN PRIVATE LIMITED',
    'UPBOTT CONSULTING PRIVATE LIMITED',
    'MAHESHWARI COSMOPACK PRIVATE LIMITED',
    'SAANKETH SOUND ANALYTICS PRIVATE LIMITED',
    'ETHOSITY SOLUTIONS PRIVATE LIMITED',
    'HCP PROJECT MANAGEMENT PRIVATE LIMITED',
    'PROPELURS CONSULTING PRIVATE LIMITED',
    'RAKEFET INDIA PRIVATE LIMITED',
    'PROSAFETY ACADEMY PRIVATE LIMITED',
    'RMJ RETAILS PRIVATE LIMITED',
    'TEAMSTARBASE PRIVATE LIMITED',
    'GLOBALBEES BRANDS PRIVATE LIMITED',
    'ID4S PRIVATE LIMITED',
    'VALUECENT THE FOGG PRIVATE LIMITED',
    'SHINING FRAME FILMS PRIVATE LIMITED',
    'WEBPLAY ENTERTAINMENT (OPC) PRIVATE LIMITED',
    'HOME OF BUSINESS SOLUTIONS PRIVATE LIMITED',
    'LEARN BHARAT TECHNOLOGIES PRIVATE LIMITED',
    'GROUND HOLDING REALTORS PRIVATE LIMITED',
    'MONDEW AGRI SCIENCE PRIVATE LIMITED',
    'EVEDA HEALTHCARE PRIVATE LIMITED',
    'ANTON ORGANICS PRIVATE LIMITED',
    'JC INDIAN AIRLINE ACADEMY PRIVATE LIMITED',
    'HELLOSKILLS EDUCATION PRIVATE LIMITED',
    'USHA KIRAN REAL ESTATE PRIVATE LIMITED',
    'CYANEA TECHNOLOGIES PRIVATE LIMITED',
    'ICE BATTERY PRIVATE LIMITED',
    'TESORO BIOMOLD PRIVATE LIMITED',
    'PINCODE SHOPPING SOLUTIONS PRIVATE LIMITED',
    'FLUTRR DIGIMATE PRIVATE LIMITED',
    'OLAM INNOVATION CENTRE INDIA PRIVATE LIMITED',
    'MAGNIFY TECHNOLOGIES PRIVATE LIMITED',
    'SPECTALENT SERVICES PRIVATE LIMITED',
    'KAYEMM BUYERS MARKET PRIVATE LIMITED',
    'INSPIRED APES PRIVATE LIMITED',
    'OXERMED LABS PRIVATE LIMITED',
    'HOME KEY VENTURES PRIVATE LIMITED',
    'AR RECYCLERS PRIVATE LIMITED',
    'SILVER BLOOM HOSPITALITY PRIVATE LIMITED',
    'MARRORA FARMS PRIVATE LIMITED',
    'NIRVAY SOLUTIONS PRIVATE LIMITED',
    'RIZIN ADVISORY PRIVATE LIMITED',
    'P. DAS INFRASTRUCTURE PRIVATE LIMITED',
    'UNIVERSUS POLY & STEEL LIMITED',
    'FUTURE RENT A CAR PRIVATE LIMITED',
    'ONE CLICK VENTURES PRIVATE LIMITED',
    'AURAA BRAND CONSULTANTS PRIVATE LIMITED',
    'ROADGREEN INNOVATION INDIA PRIVATE LIMITED',
    'PISTARTECH PRIVATE LIMITED',
    'EASTBIM ENGINEERING PRIVATE LIMITED',
    'CLINICO PET SCAN PRIVATE LIMITED',
    'PAVO CREATIONS PRIVATE LIMITED',
    'MERIEU PRIVATE LIMITED',
    'VIDYUTH EV POWER PRIVATE LIMITED',
    'XENNEO TECH PRIVATE LIMITED',
    'YONGE GLOBAL (INDIA) PRIVATE LIMITED',
    'MOBELEC INNOVATIONS PRIVATE LIMITED',
    'SEROTONIN IMPEX PRIVATE LIMITED',
    'MGX. COM EXPRESS PRIVATE LIMITED',
    'AGRIPOWER FERTILISERS INDIA PRIVATE LIMITED',
    'AEROSPACE ASSET TRADING INDIA PRIVATE LIMITED',
    'INDIAN EXPLOSIVES PRIVATE LIMITED',
    'FREIGHTKARE MULTIMODAL LOGISTICS PRIVATELIMITED',
    'GALACTICHOMO PRIVATE LIMITED',
    'SPEQTRUM GREENGG PRIVATE LIMITED',
    'CRICUT TECHNOLOGIES PRIVATE LIMITED',
    'BATALA KRISHI PRODUCER COMPANY LIMITED',
    'HYPOWER MOBILITY PRIVATE LIMITED',
    'LEADEMBEDDED SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'URENU IMPEX PRIVATE LIMITED',
    'GUARENTED HOME SOLUTIONS PRIVATE LIMITED',
    'TEAM AIKAR GURU INDIA PRIVATE LIMITED',
    'SATHI FOUNDATION IIT KHARAGPUR',
    'FOXTALE CONSUMER PRIVATE LIMITED',
    'YOURS SKINCARE INDIA PRIVATE LIMITED',
    'FIVEBRO WATER SERVICES PRIVATE LIMITED',
    'ADVISORYOPEDIA SERVICES PRIVATE LIMITED',
    '1 BY 2 CORPORATES PRIVATE LIMITED',
    'DIVINE TECHNOMECH PRIVATE LIMITED',
    'DISRUPTWORKZ INFOLABS PRIVATE LIMITED',
    'MIRAI TECHNOLOGY PRIVATE LIMITED',
    'WEALTHAHOLIC FINMART PRIVATE LIMITED',
    'GAC GLOBAL IT SERVICES PRIVATE LIMITED',
    'MIDASTOUCH MARKET RESEARCH ANALYSTS PRIVATE LIMITED',
    'APPHIE TECHNOLOGIES PRIVATE LIMITED',
    'EQIXS FOUNDATION',
    'POWERDENTAL STUDIO PRIVATE LIMITED',
    'ANAMIR PRIVATE LIMITED',
    'MIVAAN BUILDCON PRIVATE LIMITED',
    'FICTIVEBOX MEDIA PRIVATE LIMITED',
    'MAJ ASSOCIATES PRIVATE LIMITED',
    'DPKA UNIVERSAL CONSUMER VENTURES PRIVATELIMITED',
    'SHREE SAI SERVICES PRIVATE LIMITED',
    'S.R. DRUGS AND INTERMEDIATES (UNIT 4) PRIVATE LIMITED',
    'GRANDA HOSPITALITY PRIVATE LIMITED',
    'UKEYO TECHNOLOGIES PRIVATE LIMITED',
    'INTERCONLINE SHIPPING SERVICES PRIVATE LIMITED',
    'CHATAUQUA MEDIA PRIVATE LIMITED',
    'CLUBALPHA TECHNOLOGIES PRIVATE LIMITED',
    'DEDIENNE AEROSPACE INDIA PRIVATE LIMITED',
    'LANKASRI INDIA PRIVATE LIMITED',
    'KASB AGRO SOLUTIONS PRIVATE LIMITED',
    'REALPHA TECHCORP PRIVATE LIMITED',
    'ONE OPEN STORE (OPC) PRIVATE LIMITED',
    'VENDING BROTHERS PRIVATE LIMITED',
    'ARCADIA ENGINEERING PRIVATE LIMITED',
    'FFT MEDIA (OPC) PRIVATE LIMITED',
    'AJEX & TURNER WIRE TECHNOLOGIES PRIVATE LIMITED',
    'TRACKRF SYSTEMS PRIVATE LIMITED',
    'X-ON ELECTRONICS PRIVATE LIMITED',
    'ORANGE RESEARCH LAB LIMITED',
    'STAR ELTECH MANUFACTURING INDIA PRIVATE LIMITED',
    'COLOR CLOUD HEALTHCARE INDIA PRIVATE LIMITED',
    'METALFIT INDIA PRIVATE LIMITED',
    'JAI SUSPENSION SYSTEMS PRIVATE LIMITED',
    'JUSTBEINGSCENTS (OPC) PRIVATE LIMITED',
    'QPI QUANTUM PROJECTS PRIVATE LIMITED',
    'RADIANCE KA SUNSHINE THREE PRIVATE LIMITED',
    'AXERON SMART SOLUTIONS PRIVATE LIMITED',
    'BEYUL PRIVATE LIMITED',
    'RENEW USHMA ENERGY PRIVATE LIMITED',
    'ELANTRON BIOTECH (OPC) PRIVATE LIMITED',
    'HYDRGNX PRIVATE LIMITED',
    'QUANTECO WORLD LIMITED',
    'RADIANCE KA SUNSHINE FIVE PRIVATE LIMITED',
    'AEVITAS SHIPPING & LOGISTICS PRIVATE LIMITED',
    'RAJARSHI INFRA PROJECTS PRIVATE LIMITED',
    'AEGLE MARMELOS HOLDINGS PRIVATE LIMITED',
    'DESIGN MAGNET PRIVATE LIMITED',
    'LIVIITNI SERVICES PRIVATE LIMITED',
    'YASHADA VIVANTA REALTY PRIVATE LIMITED',
    'DRAFTORA DESIGN AND ARCHITECTURAL SERVICES PRIVATE LIMITED',
    'MANSA MOTORS PRIVATE LIMITED',
    'RBST VENTURES PRIVATE LIMITED',
    'ECOSPHERE TRADE PRIVATE LIMITED',
    'DEALZO REALTY PRIVATE LIMITED',
    'GROUND HOLDING BUILDCON PRIVATE LIMITED',
    'CELONIS INDIA PRIVATE LIMITED',
    'ASL (AIR, SEA AND LAND) GLOBAL SUPPORT PRIVATE LIMITED',
    'INTELLISPEND TECHNOLOGY PRIVATE LIMITED',
    'CHANCHLANI IMPEX PRIVATE LIMITED',
    'ROYAL WORLD MULTITRADE PRIVATE LIMITED',
    'ALFA DIMITRIS GLOBAL RESOURCES PRIVATE LIMITED',
    'ONE POINT SHOP PRIVATE LIMITED',
    'Q SHOPPIE PRIVATE LIMITED',
    'RESAAS TECHNOLOGIES PRIVATE LIMITED',
    'DORATI NARENDAR INDIA EXPORTS PRIVATE LIMITED',
    'LP SINGH INDIA (OPC) PRIVATE LIMITED',
    'SHIPTURTLE APPS PRIVATE LIMITED',
    'IZONNET WEB SOLUTION PRIVATE LIMITED',
    'VEERYA SHIPPING & LOGISTICS PRIVATE LIMITED',
    'GUTURI LOGISTICS PRIVATE LIMITED',
    'ANDUIN INVESTMENT PRIVATE LIMITED',
    'ALICEBLUE INSURANCE BROKING PRIVATE LIMITED',
    'BILLBOX PUREWRIST TECH SOLUTIONS PRIVATELIMITED',
    'PENDULUM INVESTMENTS SERVICES PRIVATE LIMITED',
    'TEAMROLL GLOBAL SERVICES PRIVATE LIMITED',
    'PUNDE SOFTWARE (OPC) PRIVATE LIMITED',
    'CREDWIZARDDS SERVICESS (OPC) PRIVATE LIMITED',
    'LEVO.AI INDIA PRIVATE LIMITED',
    'SERVICENOW DATA SERVICES PRIVATE LIMITED',
    'EIGENLYTICS DATA SOLUTIONS PRIVATE LIMITED',
    'WORLDSKY NETWORK SOLUTIONS PRIVATE LIMITED',
    'VYBOG INDIA PRIVATE LIMITED',
    'CYBERSRC LABS PRIVATE LIMITED',
    'GOKLOUD SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'E2O AI TECHNOLOGIES PRIVATE LIMITED',
    'ONREMOTE TECHNOLOGIES PRIVATE LIMITED',
    'IPOWERFI TECHNOLOGIES PRIVATE LIMITED',
    'ASIA PARCEL SERVICE PRIVATE LIMITED',
    'TATSAVITUR HOLDINGS AND INVESTMENT PRIVATE LIMITED',
    'IWATERMARK WEALTH PRIVATE LIMITED',
    'TONIK FINANCIAL INDIA PRIVATE LIMITED',
    'ZYLU BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TANTRAMINDS SOLUTIONS PRIVATE LIMITED',
    'FUNDFLO TECHNOLOGIES PRIVATE LIMITED',
    'LEARNAIDE SERVICES PRIVATE LIMITED',
    'CERCA TECHNOLOGIES PRIVATE LIMITED',
    'CEREMORPHIC TECHNOLOGIES PRIVATE LIMITED',
    'INBISDESK INDIA PRIVATE LIMITED',
    'BUSINESSLIKE SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'COGNIX SOFTWARE SOLUTIONS (OPC) PRIVATE LIMITED',
    'URUZ TECHNOLOGIES PRIVATE LIMITED',
    'XFORM BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ODWEN TECHNOLOGIES PRIVATE LIMITED',
    'ENCYB SECURITY SERVICES PRIVATE LIMITED',
    'STITCH CONTROL PRIVATE LIMITED',
    'CINESTOX TECHNOLOGIES PRIVATE LIMITED',
    'YAKRIA PRIVATE LIMITED',
    'WISHBANC TECHNOLOGIES PRIVATE LIMITED',
    'VECTOR3 DIGITAL TECH PRIVATE LIMITED',
    'OZOS TECHNOLOGIES PRIVATE LIMITED',
    'GREYSCALEAI INDIA PRIVATE LIMITED',
    'BYTELEARN EDTECH PRIVATE LIMITED',
    'PRODEVAM INDIA PRIVATE LIMITED',
    'S2V AUTOMATION PRIVATE LIMITED',
    'THEKEDAR G INFRA PRIVATE LIMITED',
    'VALLYORIGINS INTERNATIONAL INDIA PRIVATELIMITED',
    'NAVYAAN CONSULTING (INDIA) PRIVATE LIMITED',
    'AUDLEY CONSULTANTS (OPC) PRIVATE LIMITED',
    'NETRIKA DFIR LAB PRIVATE LIMITED',
    'WHITE COAST CONSULTING PRIVATE LIMITED',
    'TECHNOGEN DIGITAL PRIVATE LIMITED',
    'CANUS TECH PRIVATE LIMITED',
    'KINGSLEY MAYBROOK PRIVATE LIMITED',
    'PAY PERFORM INDIA PRIVATE LIMITED',
    'CARIFER TECHNOLOGIES PRIVATE LIMITED',
    'MONTHLYBILLZ DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'AKHILA LABS PRIVATE LIMITED',
    'GAMECRIO STUDIOS PRIVATE LIMITED',
    'GETMEHIRE PRIVATE LIMITED',
    'SPELL INITIATIVES PRIVATE LIMITED',
    'CONTENT FOR GOOD PRIVATE LIMITED',
    'APEX SINTERED PRIVATE LIMITED',
    'VIDA HERMOSA PRIVATE LIMITED',
    'E-TRNL ENERGY PRIVATE LIMITED',
    'DHATRI NETWORKS PRIVATE LIMITED',
    'YA CAB SERVICES PRIVATE LIMITED',
    'BHAGIRATHI PLASTICS PRIVATE LIMITED',
    'ALL INDIA PANDEMIC NAVIGATOR FOUNDATION',
    'CCI SYSTEMS PRIVATE LIMITED',
    'BRICKKED CONTECH PRIVATE LIMITED',
    'STENCIL STUDIO PRIVATE LIMITED',
    'REACT LABS PRIVATE LIMITED',
    'LOGLIN STUDIOS PRIVATE LIMITED',
    'HABRIE EDTECH SOLUTIONS PRIVATE LIMITED',
    'STROM MOTORS (INDIA) PRIVATE LIMITED',
    'FIFTH RAY SYSTEM PRIVATE LIMITED',
    'FIRSTSENSE SAFETY PRIVATE LIMITED',
    'LIVING FORESTS INDIA PRIVATE LIMITED',
    'FPEL SOLVIN PRIVATE LIMITED',
    'DIGIFORTH SOLUTIONS PRIVATE LIMITED',
    'EN-VISION BIOMEDICAL WASTE TREATMENT (KALYAN) PRIVATE LIMITED',
    'HI-POINT WATER TECHNOLOGIES (I) PRIVATE LIMITED',
    'ANAYAA SOFTWARE PRIVATE LIMITED',
    'CLOUDSQUADS PRIVATE LIMITED',
    'CAMA ELECTRICALS PRIVATE LIMITED',
    'EMPORIO LIFESCIENCES PRIVATE LIMITED',
    'FARMERSHOP TECH INDIA PRIVATE LIMITED',
    'AURON WINGS PRIVATE LIMITED',
    'EAT NINO PRIVATE LIMITED',
    'SHRI SHRI NIRMAN PRIVATE LIMITED',
    'VISA HUT PRIVATE LIMITED',
    'SANVEG GREEN SOLUTIONS PRIVATE LIMITED',
    'AML MOTORS PRIVATE LIMITED',
    'RIDO SPORTS & POLYMERS PRIVATE LIMITED',
    'PRIHET PHARMACEUTICAL PRIVATE LIMITED',
    'SHRISURYAVANSHI NUTRACEUTICAL PRIVATE LIMITED',
    'VARMAN HEAVY EQUIPMENTS PRIVATE LIMITED',
    'TED APPS PRIVATE LIMITED',
    'TECHNOVAL INFORMATION SYSTEMS INDIA PRIVATE LIMITED',
    'AUDENTES LABS AND ANALYTICS PRIVATE LIMITED',
    'BKJ EXPORTS PRIVATE LIMITED',
    'CREDAVENUE SECURITIES PRIVATE LIMITED',
    'SPECTRAQUANT PRIVATE LIMITED',
    'AVAADA RJBIKANER PRIVATE LIMITED',
    'PARAVOX AUTOMOTIVE PRIVATE LIMITED',
    'KUTCH NEW ENERGY PROJECTS LIMITED',
    'EXPEED SOFTWARE PRIVATE LIMITED',
    'PANERIMO (OPC) PRIVATE LIMITED',
    'PROARCUS FACILITY MANAGEMENT INDIA PRIVATE LIMITED',
    'SYS INTELLO SERVICES PRIVATE LIMITED',
    'NEXT SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'HWY HAUL PRIVATE LIMITED',
    'AUTOMATIONLABORATORIES PRIVATE LIMITED',
    'OWM POLY YARN LIMITED',
    'RISHI FIBC PACKAGING PRIVATE LIMITED',
    'ONTHECLOUD NETWORKS PRIVATE LIMITED',
    'MUKUNDAN LIFESPACE PRIVATE LIMITED',
    'PRITHIVI GROW CARE PRIVATE LIMITED',
    'RAADHA RUKMANI STEELS PRIVATE LIMITED',
    'KAR NIPUNA FINTECH PRIVATE LIMITED',
    'DREAM ENVIRONMENT FOUNDATION',
    'XPERTZY PRIVATE LIMITED',
    'BIOKANTI INDIA PRIVATE LIMITED',
    'VIVEKANANDA SEVA SERVICES FOUNDATION',
    'THIRD EYE METALS PRIVATE LIMITED',
    'HEALTHY18 PRIVATE LIMITED',
    'VIKARSH EXCELLENT INDIA PRIVATE LIMITED',
    'GEM PHOENIX AUTO PRIVATE LIMITED',
    'ASENA SERVICES PRIVATE LIMITED',
    'AZISTA COMPOSITES PRIVATE LIMITED',
    'SEEK HAWK PRIVATE LIMITED',
    'HOICKO TECHNOLOGIES PRIVATE LIMITED',
    'INDUSOL TECHNOLOGIES PRIVATE LIMITED',
    'PEACHY TECHNOLOGIES PRIVATE LIMITED',
    'RAW TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SIDHYAN INTERNATIONAL PRIVATE LIMITED',
    'MICROLEVEL SOLUTION PRIVATE LIMITED',
    'MYRIAD APOTHECARY PRIVATE LIMITED',
    'TAXCLUE CONSULTECH PRIVATE LIMITED',
    'CHARTERED BABA EDUTECH (OPC) PRIVATE LIMITED',
    'DNS DRUGS & PHARMACEUTICALS PRIVATE LIMITED',
    'JK&JK HEALTHCARE PRIVATE LIMITED',
    'GIA LINE (OPC) PRIVATE LIMITED',
    'INNOVER DIGITAL PRIVATE LIMITED',
    'WANDERERBEING PRIVATE LIMITED',
    'VITHOBA MAULI AGRO PRODUCER COMPANY LIMITED',
    'RAJDHANI INTERSTATE TRANSPORT PRIVATE LIMITED',
    'KLAAR DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PLATEAUX VINTNERS PRIVATE LIMITED',
    'NILANJAY ORGANIC WORLD PRIVATE LIMITED',
    'BLIPPBUILDER INDIA PRIVATE LIMITED',
    'AYUSHAMANAYUSH FOUNDATION',
    'SAS ONE PRIVATE LIMITED',
    'PRORGANIQ HERBAL PRIVATE LIMITED',
    'BLUE RIDGE MARITIME AND ENERGY PRIVATE LIMITED',
    'SOURCE GOOD FOOD TECH PRIVATE LIMITED',
    'NJP GLOBAL SERVICES PRIVATE LIMITED',
    'UPMARKET FINTECH SOLUTIONS INDIA PRIVATELIMITED',
    'KLL HEALTHCARE PRIVATE LIMITED',
    'SAARTHI INTERNATIONAL PRIVATE LIMITED',
    'RAJASHREE INTERNATIONAL MANUFACTURING PRIVATE LIMITED',
    'GLUCIAN INDIA PRIVATE LIMITED',
    'ECLYTICS CONSULTING PRIVATE LIMITED',
    'TRENDSPACE IT PARK PRIVATE LIMITED',
    'NIKKU KIDS INTERACTIVE LEARNING GAMES PRIVATE LIMITED',
    'INDIA CUISINE AND FOOD PRODUCT PRIVATE LIMITED',
    'AVENIR MARITIME INDIA PRIVATE LIMITED',
    'ADVAY ORGANICS SOLUTIONS (OPC) PRIVATE LIMITED',
    'JH SCIAKY LIMITED',
    'DEVVARK INFOTECH PRIVATE LIMITED',
    'TRIDGE TALENTREPRENURSHIP SOFTWARE PRIVATE LIMITED',
    'KEEVS HEALTH INDIA PRIVATE LIMITED',
    'AVOLT MOBILITY SOLUTIONS PRIVATE LIMITED',
    'MEDPATH DIAGNOSTICS PRIVATE LIMITED',
    'INVESTOLOGIST FINANCIALS PRIVATE LIMITED',
    'ADDON INFOTECH SOLUTIONS PRIVATE LIMITED',
    'ANRISA ESTATES PRIVATE LIMITED',
    'CRAZE TECHNOLOGIES PRIVATE LIMITED',
    'LENCENS INCENSE PRIVATE LIMITED',
    'ASHA BLUE EYES FARMER PRODUCER COMPANY LIMITED',
    'VISION11 GAMING PRIVATE LIMITED',
    'HYPERAUTOMATION SOLUTIONS PRIVATE LIMITED',
    'PEACHPOTATO CONSULTING (OPC) PRIVATE LIMITED',
    'BELLATOR BEVERAGES PRIVATE LIMITED',
    'SBS GIGAFIBER PRIVATE LIMITED',
    'K.A. PETROCHEM PRIVATE LIMITED',
    'NUROPLUS HEALTHCARE PRIVATE LIMITED',
    'ZM CONSULTING (INDIA) PRIVATE LIMITED',
    'BOX AND BEYOND ENTERTAINMENT PRIVATE LIMITED',
    'SUPERCROSS INDIA PRIVATE LIMITED',
    '4A FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'L&T COMMUNITY WELFARE ASSOCIATION',
    'BYNRY SERVICES PRIVATE LIMITED',
    'THING SENSE SOLUTIONS PRIVATE LIMITED',
    'AMPLE CONSTRUCTION AND REAL ESTATES PRIVATE LIMITED',
    'GARUDA CHEMICALS INTERMEDIATES PRIVATE LIMITED',
    'LAXDIN METALLIC PRIVATE LIMITED',
    'IVANSYS TECHNOLOGIES PRIVATE LIMITED',
    'DATA NECTAR TECHNOSYS PRIVATE LIMITED',
    'SHRIMAT EXIM PRIVATE LIMITED',
    'VOLAR ALTA PRIVATE LIMITED',
    'STIMULI TECHNOLOGIES PRIVATE LIMITED',
    'HOMEKRAFT QUICK HOMES PRIVATE LIMITED',
    'BENNY',
    'S TARKASHI PRIVATE LIMITED',
    'ORIENT CRAFT FASHION INDUSTRIES LIMITED',
    'DENIMO DESIGN WASHING PRIVATE LIMITED',
    'ASEEMSHAKTI ENABLERS (OPC) PRIVATE LIMITED',
    'MANEK APPARELS PRIVATE LIMITED',
    'BETTER BOUTIQUES HYDERABAD PRIVATE LIMITED',
    'MERINOMERE VENTURES PRIVATE LIMITED',
    'MORAYA WOODPACK INDIA PRIVATE LIMITED',
    'SENTINI AGRIPRODUCTS PRIVATE LIMITED',
    'GRIHALAKSHMI FILMS PRIVATE LIMITED',
    'VIKRANT SPECIALITY SERVICES PRIVATE LIMITED',
    'DIGICOVER COMMUNICATIONS PRIVATE LIMITED',
    'DARPAN TIMES PRIVATE LIMITED',
    'PONTOS LABCARE PRIVATE LIMITED',
    'NOURYON CHEMICALS INDIA PRIVATE LIMITED',
    'VITARES LIFESCIENCES PRIVATE LIMITED',
    'SYNECTICS BIOSCIENCE PRIVATE LIMITED',
    'KRISHNA C-BOND PRIVATE LIMITED',
    'MOLIKULE TECHNOLOGIES PRIVATE LIMITED',
    'MANSAROVAR HOLISTIC PRIVATE LIMITED',
    'SIMARK CHEM (INDIA) PRIVATE LIMITED',
    'BIOROME MEDICARE PRIVATE LIMITED',
    'BYK INDIA PRIVATE LIMITED',
    'DHAVIT GLOBAL LIFE SCIENCES PRIVATE LIMITED',
    'LIFEGUARD PHARMA PRIVATE LIMITED',
    'VISCON RUBBER PRIVATE LIMITED',
    'FABRECA WINDOWS PRIVATE LIMITED',
    'RAMKRISHNA FOUNDRY PRIVATE LIMITED',
    'INOBLE MECHWAY PRIVATE LIMITED',
    'APEIRON STEEL BUILDINGS PRIVATE LIMITED',
    'GOPALAN TECH FABS INDIA PRIVATE LIMITED',
    'ALUTECH COOLING SYSTEM PRIVATE LIMITED',
    'KYOJIN ELECTRO PRIVATE LIMITED',
    'SMIDNYA TECHNOLOGIES PRIVATE LIMITED',
    'OJASVI MACHINES PRIVATE LIMITED',
    'EXIMP MEASUREMENT PRIVATE LIMITED',
    'RADIFORZ AUTOMATION PRIVATE LIMITED',
    'DGM AUTOMATION INDIA PRIVATE LIMITED',
    'SMURG PRESSES PRIVATE LIMITED',
    'EVOLIRA INITIATIVE PRIVATE LIMITED',
    'BALDWIN VISION SOLUTIONS PRIVATE LIMITED',
    'FEROMACH TECHNOLOGY PRIVATE LIMITED',
    'QODENEXT INDIA PRIVATE LIMITED',
    'ECOCLEAN MACHINES PRIVATE LIMITED',
    'JPK AUTOMATION PRIVATE LIMITED',
    'HIDROGLOBAL INDIA PRIVATE LIMITED',
    'DIVYANIA SERVICES INDIA PRIVATE LIMITED',
    'CRESCENT OPTO PRIVATE LIMITED',
    'ALCHEMIST E-VAAHAN PRIVATE LIMITED',
    'RESOLUX INDIA PRIVATE LIMITED',
    'SATSAN ENERGY SOLUTIONS PRIVATE LIMITED',
    'COMAP INDIA PRIVATE LIMITED',
    'INVERTED ENERGY PRIVATE LIMITED',
    'CHAMUNDA ELECTRO TECH PRIVATE LIMITED',
    'DAITAD FRANCHISEE PRIVATE LIMITED',
    'GADELA INDUSTRIAL AUTOMATION SOLUTION PRIVATE LIMITED',
    'ENVILON ELECTRO PRIVATE LIMITED',
    'LOHITHA POWER PRODUCTS PRIVATE LIMITED',
    'SNCAB INDUSTRIES PRIVATE LIMITED',
    'SDA CAD SERVICE (OPC) PRIVATE LIMITED',
    'CRESURGE MUSIC SOLUTIONS PRIVATE LIMITED',
    'ALAMBRE CABLES PRIVATE LIMITED',
    'ITOSS SOLUTIONS (I) PRIVATE LIMITED',
    'RCC NUTRA FILL PRIVATE LIMITED',
    'AMAZING MEDICAL DISPOSABLES PRIVATE LIMITED',
    'K.R.LYNCH HEALTHCARE PRIVATE LIMITED',
    'PROGENITURE LABORATORIES PRIVATE LIMITED',
    'PARAMTECH ELECTRIC MOTORS PRIVATE LIMITED',
    'VORC MOTORS PRIVATE LIMITED',
    'TEXMACO DEFENCE SYSTEMS PRIVATE LIMITED',
    'EV TECHO ELECTRA MOTORS PRIVATE LIMITED',
    'SONNAX TRANSMISSION INDIA PRIVATE LIMITED',
    'QOOGO MOTOR PRIVATE LIMITED',
    'DEREK HEALTHCARE PRIVATE LIMITED',
    'QUIQGENIE TECHNOLOGIES PRIVATE LIMITED',
    'RHYTHMFLOWS SOLUTIONS PRIVATE LIMITED',
    'NEBLIO TECHNOLOGIES PRIVATE LIMITED',
    'STORIES & IDEAS FOODS PRIVATE LIMITED',
    'IBLUE FMCG PRIVATE LIMITED',
    'ASIAN INDOOR CRICKET ASSOCIATION',
    'GRWM (OPC) PRIVATE LIMITED',
    'TOTAL MOVEMENTS PRIVATE LIMITED',
    'KING FREIGHT MARITIME PRIVATE LIMITED',
    'CERAMIC TECHNOKER PRIVATE LIMITED',
    'ZORDIAL TECHNOLOGIES PRIVATE LIMITED',
    'HSH CONSTRUCTION PRIVATE LIMITED',
    'OBBSERV RETAIL PRIVATE LIMITED',
    'SHAKAMBHARI SKILL SPORTS PRIVATE LIMITED',
    'ALCODES MOBILITY PRIVATE LIMITED',
    'AGMORA TECHNOLOGIES PRIVATE LIMITED',
    'TERRA SMART LIVEST PRIVATE LIMITED',
    'ROVERSIDE SOLUTIONS INDIA PRIVATE LIMITED',
    'IAM FINE FOUNDATION',
    'WARD AGRICULTURAL MACHINERY INDIA PRIVATE LIMITED',
    'JY CORPORATE ADVISORY SERVICES PRIVATE LIMITED',
    'SBP SHINESTAR PRIVATE LIMITED',
    'GEEK SPACE PRIVATE LIMITED',
    'PROSPECTA BUILDX INDIA PRIVATE LIMITED',
    'QUANTUMPOINT PRIVATE LIMITED',
    'PROCHE JOBS PRIVATE LIMITED',
    'MAARIF ACADEMY PRIVATE LIMITED',
    'KALP TURNKEY SERVICES PRIVATE LIMITED',
    'PAWAR LIFESTYLE BRANDS PRIVATE LIMITED',
    'TULJA UNIQUE TECHNOLOGIES PRIVATE LIMITED',
    'RENOIRCE TECHNOLOGIES PRIVATE LIMITED',
    'KAZOOM HOLDING PRIVATE LIMITED',
    'HPKA ENGINEERS PRIVATE LIMITED',
    'RE SUSTAINABILITY RELDAN REFINING PRIVATE LIMITED',
    'REDMOB MEDIA PRIVATE LIMITED',
    'PXP SERVICES PRIVATE LIMITED',
    'LONG COM INDIA PRIVATE LIMITED',
    'LEADER IT PRIVATE LIMITED',
    'EFSS SECURE PRIVATE LIMITED',
    'XYRIS LIFE SCIENCES PRIVATE LIMITED',
    'EXPANZSALL PRIVATE LIMITED',
    'PELOTON CONSULTING INDIA PRIVATE LIMITED',
    'ACHIEVE IMPOSSIBLE GREEN TECH AND TRAVEL(OPC) PRIVATE LIMITED',
    'RISETIME SEMICONDUCTOR (OPC) PRIVATE LIMITED',
    'GRANDBIZ HOLDINGS PRIVATE LIMITED',
    'ARYAVARTHA AQUA PRIVATE LIMITED',
    'WALL STREET ENGLISH INDIA PRIVATE LIMITED',
    'HEALIA DIAGNOSTICS PRIVATE LIMITED',
    'UPSPL INTEGRATED SERVICES PRIVATE LIMITED',
    'OTINGA TECHNOLOGY PRIVATE LIMITED',
    'PRIMAL ACADEMY FOR SPORTS SCIENCE PRIVATE LIMITED',
    'VENUESNVENDORS DIGITAL PRIVATE LIMITED',
    'RRIBADA MOVIE MASTERS PRIVATE LIMITED',
    'INFINITI RECRUITMENT PROCESS OUTSOURCINGPRIVATE LIMITED',
    'DQUBE GLOBAL SOFTWARE SERVICES PRIVATE LIMITED',
    'DR HERB HEALTH MARK PRIVATE LIMITED',
    'KSDA TECHNOLOGIES PRIVATE LIMITED',
    'QUDECS INDIA ENGINEERING SERVICE PRIVATELIMITED',
    'DBM VIRCON SERVICES (INDIA) PRIVATE LIMITED',
    'HUNTWIN DIMENSIONZ PRIVATE LIMITED',
    'RAINBIRD HEALTHCARE BUSINESS SERVICES PRIVATE LIMITED',
    'ZAK DECOR MART PRIVATE LIMITED',
    'AGCOM EXPORTS PRIVATE LIMITED',
    'DECAHEDRON PRIVATE LIMITED',
    'VINAYAKA FMCG PRIVATE LIMITED',
    'EHNOTE SOFTLABS PRIVATE LIMITED',
    'QUANTIFICARE HEALTH STATIONS PRIVATE LIMITED',
    'ANSIO MARKETPLACE PRIVATE LIMITED',
    'GSTDOST PRIVATE LIMITED',
    'MAINTAINAID ENGG SOLUTIONS PRIVATE LIMITED',
    'RIGHT MOVE SECURITY SERVICES PRIVATE LIMITED',
    'HARITHA AUTOMATION PRIVATE LIMITED',
    'KABIR EVENTS PRIVATE LIMITED',
    'GALLANT INFO SOLUTIONS PRIVATE LIMITED',
    'CALLESTO INTERNATIONAL PRIVATE LIMITED',
    'NOYER OVERSEAS (INDIA) PRIVATE LIMITED',
    'MAXIPLE SERVICES PRIVATE LIMITED',
    'KEEPCART RETAILS INDIA PRIVATE LIMITED',
    'VIJAY UDYOG KITCHEN EQUIPMENT PRIVATE LIMITED',
    'ROLLVEYOR FACTORY SYSTEM PRIVATE LIMITED',
    'TRABO SKILL DEVELOPMENT PRIVATE LIMITED',
    'HIPICS GLOBAL SYSTEMS PRIVATE LIMITED',
    'FTO SERVICES PRIVATE LIMITED',
    'PROPLANET POWER TECHNOLOGIES PRIVATE LIMITED',
    'ORANTHAI WORDS WORTH BOOK HOUSE AND STATIONERIES PRIVATE LIMITED',
    'ATCHAYAPATHRA FOODS PRIVATE LIMITED',
    'STANSON HOLDINGS PRIVATE LIMITED',
    'OPMIC INDIA ADVISORY PRIVATE LIMITED',
    'GYP CRAFT FRAMES PRIVATE LIMITED',
    'BIGPAGE E-COMMERCE PRIVATE LIMITED',
    'FLAVEL IMPEX PRIVATE LIMITED',
    'IENERGY DIGITAL PRIVATE LIMITED',
    'PARALLAX HOSTING PRIVATE LIMITED',
    'URBANE AEROSPACE PRIVATE LIMITED',
    'AST IMAGING PRIVATE LIMITED',
    'DUGROS INDIA TRADING HOUSE PRIVATE LIMITED',
    'PHN TECHNOLOGY PRIVATE LIMITED',
    'PEC ATTESTATION AND APOSTILLE SERVICES INDIA PRIVATE LIMITED',
    'GLAM ONLINE ENTERPRISES PRIVATE LIMITED',
    'SHAURYA TOTAL ELECTRICAL PRIVATE LIMITED',
    'BRAINFLOSS PRIVATE LIMITED',
    'NRV AUTOMOBEX INDIA PRIVATE LIMITED',
    'DAI LABS PRIVATE LIMITED',
    'FULCRO CONSULTING PRIVATE LIMITED',
    'BE TO BE INFOMEDIA PRIVATE LIMITED',
    'JANMAN MEDIA PUBLICATION PRIVATE LIMITED',
    'QUADRAPOD AGRO PRIVATE LIMITED',
    'GAU PETHI SAWDESHI UDYOG PRIVATE LIMITED',
    'DESENHAR ENGINEERING PRIVATE LIMITED',
    'KNIT GALLERY INDIA PRIVATE LIMITED',
    'MUSH TEXTILE PRIVATE LIMITED',
    'ARMORO PRODUCTS PRIVATE LIMITED',
    'HYOSUNG INDIA PRIVATE LIMITED',
    'SARAVANA WEAVES PRIVATE LIMITED',
    'ZINCS APPARELS PRIVATE LIMITED',
    'YELLOWSTONE EV POWER PRIVATE LIMITED',
    'ATIMODA PERFUMERY PRODUCTS PRIVATE LIMITED',
    'MAUSAR INNOVATIVE AGRO PRIVATE LIMITED',
    'LAJ-IDS EXPORTS PRIVATE LIMITED',
    'HEIMAT GLOBAL PRIVATE LIMITED',
    'MALIKAGUPTA LABEL INDIA PRIVATE LIMITED',
    'CHANG CHUN CHEMICAL INDIA PRIVATE LIMITED',
    'LABOCOSMETICA CHEMICALS PRIVATE LIMITED',
    'SPHINX MINING PRIVATE LIMITED',
    'INDO BEVS PRIVATE LIMITED',
    'SCHOELLER INDIA INDUSTRIES PRIVATE LIMITED',
    'PAMIDI RSB GLOVE INDUSTRIES PRIVATE LIMITED',
    'PROPEL FLEXIBLES PRIVATE LIMITED',
    'VINISUN PRINTECH INDIA PRIVATE LIMITED',
    'KAPPA COFFEE PRIVATE LIMITED',
    'MACHINO PLASTICS BECHARAJI LIMITED',
    'SREEPA FOOD PRODUCTS PRIVATE LIMITED',
    'AUTHENTIC GRAMIYA MASALA PRIVATE LIMITED',
    'TRUE INTEGRAL CONCRETE PRIVATE LIMITED',
    'VIVAN STEELS AND ALLOYS PRIVATE LIMITED',
    'DAVINCHY FOODS PRIVATE LIMITED',
    'RRP GLOBAL CHEMICALS PRIVATE LIMITED',
    'LAURA PHARMA PRIVATE LIMITED',
    '3K CONSTRUCTION CHEMICALS PRIVATE LIMITED',
    'KAYBEE METALLURGICAL PRIVATE LIMITED',
    'KLJ PARAFLEX INDIA LIMITED',
    'MECHNOX PRIVATE LIMITED',
    'INDOLACCA SHELLAC INDUSTRIES PRIVATE LIMITED',
    'OLCARE LABORATORIES PRIVATE LIMITED',
    'VOOT RESOURCES PRIVATE LIMITED',
    'GO4LIFE ORGANIC MILK PRIVATE LIMITED',
    'HYDRAULIC POWER SOLUTIONS PRIVATE LIMITED',
    'APM MOTORS INDIA PRIVATE LIMITED',
    'OMEGA SEIKI PRIVATE LIMITED',
    'INDOKOTE INDUSTRIES PRIVATE LIMITED',
    'GARUDAN UNMANNED SYSTEM PRIVATE LIMITED',
    'KYNTOX BIOTECH INDIA PRIVATE LIMITED',
    'NARMADA POLYMERS MANESAR LIMITED',
    'RADOPSYS PRIVATE LIMITED',
    'FRIGEL INTELLIGENT COOLING SYSTEMS INDIAPRIVATE LIMITED',
    'CONWEIGH INDUSTRIES PRIVATE LIMITED',
    'THALES RELIANCE DEFENCE SYSTEMS LIMITED',
    'ARM PIPING ZONE PRIVATE LIMITED',
    'GRADIANT INDIA PRIVATE LIMITED',
    'A2DS SCHUH FABRIK PRIVATE LIMITED',
    'EVIROCOR MACHINES INDIA PRIVATE LIMITED',
    'LUBCON LUBRICATION INDIA PRIVATE LIMITED',
    'LEONS INTEGRATIONS PRIVATE LIMITED',
    'GARUDA PUMPS PRIVATE LIMITED',
    'UPRATE AUTO COMPONENTS PRIVATE LIMITED',
    'RALLISON APPLIANCES PRIVATE LIMITED',
    'INDOLUS CONSPICUITIES PRIVATE LIMITED',
    'DOLPHIN PHARMATECH PRIVATE LIMITED',
    'VYANKATESH TUBE MILL PRIVATE LIMITED',
    'P. C. CHANDRA GOLD JEWELLERY ULTADANGA PRIVATE LIMITED',
    'PRITIKA ENGINEERING COMPONENTS LIMITED',
    'ACME ROLLTECH PRIVATE LIMITED',
    'ATTICA AUTOMATION INDIA PRIVATE LIMITED',
    'AGAS PARTS PRIVATE LIMITED',
    'A4 ADVANCE AUTOMATION PRIVATE LIMITED',
    'LINIMENT PHARMA PRIVATE LIMITED',
    'POWERFABRICA PRIVATE LIMITED',
    'SRIS SYNTHESIS PRIVATE LIMITED',
    'ARBITAL SOLUTIONS PRIVATE LIMITED',
    'GOODMEN INDUSTRIES PRIVATE LIMITED',
    'G.O. POLYMERS PRIVATE LIMITED',
    'CIKIT ELECTRICALS & TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ARORA FIREBRICKS PRIVATE LIMITED',
    'PRECITECH EQUIPMENTS INDIA PRIVATE LIMITED',
    'SARLAL ENGINEERING LIMITED',
    'CACOBEAN CHOCOLATE FACTORY PRIVATE LIMITED',
    'MAAKRUPA SCIENTIFIC INDUSTRIES PRIVATE LIMITED',
    'TOUTCHE ELECTRIC PRIVATE LIMITED',
    'HARVIL INDUSTRIES PRIVATE LIMITED',
    'SAGARASIA UNIVERSAL PRIVATE LIMITED',
    'AEROMOBIX SYSTEMS PRIVATE LIMITED',
    'SIFTER INTERNATIONAL PRIVATE LIMITED',
    'CHIRRA GLOBAL WEARS PRIVATE LIMITED',
    'NANOPASS INDIA PRIVATE LIMITED',
    'PANJI ENGINEERING PRIVATE LIMITED',
    'DRONE WORLD TECHNOLOGIES PRIVATE LIMITED',
    'BINDWEL TECHNOLOGIES PRIVATE LIMITED',
    'AOSNOWS PRIVATE LIMITED',
    'NEXILIS ELECTRONICS INDIA PRIVATE LIMITED',
    'SPECTRUMSTAB INDIA PRIVATE LIMITED',
    'AVANA SURGICAL SYSTEMS PRIVATE LIMITED',
    'TAYLOR GLASSWARE PRIVATE LIMITED',
    'SHRI JI ROBOTICS PRIVATE LIMITED',
    'PAYAL BOLT PRIVATE LIMITED',
    'MANGOEMOTION TECHNOLOGIES PRIVATE LIMITED',
    'AQ INDUCTIVE COMPONENTS INDIA PRIVATE LIMITED',
    'GRIFFYN ROBOTECH PRIVATE LIMITED',
    'AUTOLITE MOTORS INDIA LIMITED',
    'MITTALS GREEN ENERGY PRIVATE LIMITED',
    'ALPUR SOLAR PRIVATE LIMITED',
    'ACME CHITTORGARH SOLAR ENERGY PRIVATE LIMITED',
    'NANJ SOLAR PRIVATE LIMITED',
    'RENESYS TECHSOLUTIONS PRIVATE LIMITED',
    'KNR SRIRANGAM INFRA PRIVATE LIMITED',
    'TEJOBHI HEALTHCARE PRIVATE LIMITED',
    'APPRENTICE PROJECT FOUNDATION',
    'HARSH AND HARRI HEALTH CARE INDIA PRIVATE LIMITED',
    'REGENMED CARE PRIVATE LIMITED',
    'CONCINNITY AGRO2O PRIVATE LIMITED',
    'HOUSE OF LUSH PRIVATE LIMITED',
    'PMW PERFORMANCE SOLUTIONS PRIVATE LIMITED',
    'TRAVLIS LOGISTICS PRIVATE LIMITED',
    'VLJ REALTORS PRIVATE LIMITED',
    '2SYNC WEB SOLUTIONS PRIVATE LIMITED',
    'DEVAANYA SOLUTIONS PRIVATE LIMITED',
    'COLINA TECH SOLUTIONS PRIVATE LIMITED',
    'INTRINSYC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NEUN DESIGNS PRIVATE LIMITED',
    'LOHUM CLEANTECH PRIVATE LIMITED',
    'BLS KENDRAS PRIVATE LIMITED',
    'GEEKSKARMA (OPC) PRIVATE LIMITED',
    'MOHAR ORGANICS PRIVATE LIMITED',
    'SUMLUCK INTERNATIONAL SOLUTIONS PRIVATE LIMITED',
    'FALCA E-SOLUTIONS PRIVATE LIMITED',
    'SJP CHILLER SERVICES PRIVATE LIMITED',
    'GENEKA TECHNOLOGIES PRIVATE LIMITED',
    'ELLIOT FACILITY MANAGEMENT PRIVATE LIMITED',
    'TRIVO IT SOLUTIONS PRIVATE LIMITED',
    'DANTAYA ADVISORY SERVICES PRIVATE LIMITED',
    'KIDZBYTE MEDIATECH PRIVATE LIMITED',
    'RD PAYTECH PRIVATE LIMITED',
    'EXPEDITION JOURNEYS INDIA PRIVATE LIMITED',
    'KINGS CORNERSTONE INTERNATIONAL COLLEGE PRIVATE LIMITED',
    'LUMIYA IKON INTERNATIONAL PRIVATE LIMITED',
    'HYNGO INDIA PRIVATE LIMITED',
    'SAGEM CONSUMER PRODUCTS PRIVATE LIMITED',
    'GROBANANA PRIVATE LIMITED',
    'FRANCO INDIA AGRO TECH & SERVICES PRIVATE LIMITED',
    'MENDCURE LIFE SCIENCES PRIVATE LIMITED',
    'J.V.P MARINE PRODUCTS EXPORTS PRIVATE LIMITED',
    'TOPSTAR INFRA PROJECTS PRIVATE LIMITED',
    'ALMOND HOUSE PRIVATE LIMITED',
    'SERAPHEENA FOODS PRIVATE LIMITED',
    'JAYS AGRO AND MILKY PRODUCTS PRIVATE LIMITED',
    'WEBFOODS NETWORK PRIVATE LIMITED',
    'NATGROW FOODS PRIVATE LIMITED',
    'ASHOKA ENVIROTECH PRIVATE LIMITED',
    'AEROBLU FOOTWEAR PRIVATE LIMITED',
    'BELL MULTI KRAFT PRIVATE LIMITED',
    'VIOLIO HEALTHCARE LIMITED',
    '6S PHARMA SOLUTIONS PRIVATE LIMITED',
    'KUMI INDIA INDUSTRIES PRIVATE LIMITED',
    'SPIRO HOSES INDIA PRIVATE LIMITED',
    'HI-TEC METAL POWDERS PRIVATE LIMITED',
    'SSMG MARKINGS INDIA PRIVATE LIMITED',
    'KNH MECHTECH PRIVATE LIMITED',
    'TAKANG GLOBAL MACHINE TOOLS INDIA PRIVATE LIMITED',
    'ACCURINA TECHNOLOGIES PRIVATE LIMITED',
    'RAYLEIGH STRUTT CLEANTECH PRIVATE LIMITED',
    'BECQUEREL CURIE CLEANTECH PRIVATE LIMITED',
    'PREDICTIVE ENERGY INSTRUMENTS PRIVATE LIMITED',
    'BATCH 91 ENERGY VENTURES PRIVATE LIMITED',
    'AVAADA SUNBEAM ENERGY PRIVATE LIMITED',
    'HOLEN SOLAR PRIVATE LIMITED',
    'RECLAIR ENERGY PRIVATE LIMITED',
    'PARERIYA PROJECTS PRIVATE LIMITED',
    'NIHCHI CONSTRUCTIONS PRIVATE LIMITED',
    'RAJASEKHARA PROJECTS PRIVATE LIMITED',
    'NATURESCAPE INDIA RESORTS PRIVATE LIMITED',
    'ACQUAFRONT INFRASTRUCTURE PRIVATE LIMITED',
    'INDINFRAVIT PROJECT MANAGERS PRIVATE LIMITED',
    'AISAN SALES INDIA PRIVATE LIMITED',
    'NETSO MOTORS PRIVATE LIMITED',
    'SUWALKA MOTORS PRIVATE LIMITED',
    'STARKE INTERNATIONAL EXIM PRIVATE LIMITED',
    'ISYA AESTHETICS PRIVATE LIMITED',
    'SANTAMENTAL INTERACTIVE PRIVATE LIMITED',
    'HALPAWAT INDIA PRIVATE LIMITED',
    'SAUVAGYAM NIDHI LIMITED',
    'KAI RETAIL INDIA PRIVATE LIMITED',
    'DARTDESIGN AND FLEXSOL PRIVATE LIMITED',
    'SPINCER RESORTS INDIA PRIVATE LIMITED',
    'WINGS KITCHENS PRIVATE LIMITED',
    'FEBRUARY 30 HOSPITALITY PRIVATE LIMITED',
    'SMARTLINE LOGISTICS PRIVATE LIMITED',
    'GYONG XC INDIA PRIVATE LIMITED',
    'ALLCARGO LOGISTICS & INDUSTRIAL PARK PRIVATE LIMITED',
    'PUINTOLA TOLLWAY PRIVATE LIMITED',
    'JETMOBILITY PRIVATE LIMITED',
    'SIMPLY FLYSMART PRIVATE LIMITED',
    'GENEW INDIA TELECOM PRIVATE LIMITED',
    'EXURE TECHNOLOGIES PRIVATE LIMITED',
    'FUTUREWEALTH NIDHI LIMITED',
    'BASANTH CONTRACTS PRIVATE LIMITED',
    'RCCL EXPRESSWAY PRIVATE LIMITED',
    'NETRO TECHNOLOGIES PRIVATE LIMITED',
    'NOTIO TECHNOLOGY PRIVATE LIMITED',
    'PROTEKT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RICHERLINK TECHNOLOGY PRIVATE LIMITED',
    'ROCKWELL TECHNOLOGIES PRIVATE LIMITED',
    'AUGMENTED COGNIZANCE INNOVATION PRIVATE LIMITED',
    'WOODZON INTEGRATIVE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HUMANITAS GENERAL TRADING PRIVATE LIMITED',
    'SUMISHO AGRO INDIA PRIVATE LIMITED',
    'ESSAE GEARS AND TRANSMISSIONS PRIVATE LIMITED',
    'PARSHVI TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'SERAGA LIFESCIENCES PRIVATE LIMITED',
    'YR VENTURES PRIVATE LIMITED',
    'DAWN HR SOLUTIONS PRIVATE LIMITED',
    'AUUR LIFESCIENCE PRIVATE LIMITED',
    'VAANYA INDUSTRIES PRIVATE LIMITED',
    'AGRYUJ ITSERV PRIVATE LIMITED',
    'FACSTORY MEDIA PRIVATE LIMITED',
    'MWI MYWORLD INDIA PRIVATE LIMITED',
    'ANTONY PARAYIL FARMSTEAD PRIVATE LIMITED',
    'PVAI VALUATION PROFESSIONAL ORGANISATION',
    'HODOPHILE TRAVELS PRIVATE LIMITED',
    'MAGNOPIX SYSTEMS PRIVATE LIMITED',
    'TECHTRENO SOLUTIONS PRIVATE LIMITED',
    'MADOS INFRA PROJECTS PRIVATE LIMITED',
    'BRAINWICH LEARNING SOLUTIONS PRIVATE LIMITED',
    'STRAIGHTCURVE SOLUTIONS PRIVATE LIMITED',
    'GETSET CAMPING PRIVATE LIMITED',
    'GALAX ACCRUE TECH PRIVATE LIMITED',
    'B-INFORMATIVE IT SERVICES PRIVATE LIMITED',
    'NAIMATH EXPORTS AND IMPORTS PRIVATE LIMITED',
    'INNOCEPT EVENT STUDIO PRIVATE LIMITED',
    'KOACH AI TECHNOLOGIES PRIVATE LIMITED',
    'EDP MEDICAL EDUCATION PRIVATE LIMITED',
    'ADYEN INDIA TECHNOLOGY SERVICES PRIVATE LIMITED',
    'ATAMOS NANOTECH PRIVATE LIMITED',
    'PQSI DIGITAL PRIVATE LIMITED',
    'THYME INDIA PRIVATE LIMITED',
    'TACTOPUS LEARNING SOLUTIONS PRIVATE LIMITED',
    'NBASE2 SYSTEMS PRIVATE LIMITED',
    'SIANO LIFESTYLE SOLUTIONS PRIVATE LIMITED',
    'RIOD LOGIC PRIVATE LIMITED',
    'M2N FOOD TRAILS PRIVATE LIMITED',
    'BLOQUE LABS PRIVATE LIMITED',
    'GRANDI DATI TECHNOLOGIES PRIVATE LIMITED',
    'INVIOLABLE TECHNOLOGY PRIVATE LIMITED',
    'VIRTUOSO STAFFING SOLUTIONS PRIVATE LIMITED',
    'BIRLA I COLLEGE PRIVATE LIMITED',
    'INDIA INX GLOBAL ACCESS IFSC LIMITED',
    'AVAADA SUNCE ENERGY PRIVATE LIMITED',
    'GLOBAL HOSPITALITY BRANDS PRIVATE LIMITED',
    'MYJD PRIVATE LIMITED',
    'DOT2DOT INFOSOFT TECHNOLOGIES PRIVATE LIMITED',
    'BROWN-FORMAN INDIA PRIVATE LIMITED',
    'DQONTENTS (OPC) PRIVATE LIMITED',
    'TURFTOWN SPORTING PURSUITS PRIVATE LIMITED',
    'FYNAMICS TECHNO SOLUTIONS PRIVATE LIMITED',
    'MOVETIME TECHNOLOGIES PRIVATE LIMITED',
    'MATSO DEPOT PRIVATE LIMITED',
    'RAIMS INFOSEC PRIVATE LIMITED',
    'SPICAWORKS INDIA PRIVATE LIMITED',
    'RAAV TECHLABS PRIVATE LIMITED',
    'RESISTANT TECHNOLOGY PRIVATE LIMITED',
    'BULFRO MONITECH PRIVATE LIMITED',
    'RAPTECH PHARMA TECHNOLOGIES PRIVATE LIMITED',
    'PROTEAN EDU CONSULTANTS PRIVATE LIMITED',
    'UTIUM SYSTEMS PRIVATE LIMITED',
    'ARYAMAN TECHNOLOGIES PRIVATE LIMITED',
    'KOMODO INNOVATIONS PRIVATE LIMITED',
    'RRC AGRO INDUSTRIES PRIVATE LIMITED',
    'REGIRK SERVICES PRIVATE LIMITED',
    'BOTHANZI MEDICALS PRIVATE LIMITED',
    'CLARITY BEVERAGES PRIVATE LIMITED',
    'ACT.GLOBAL INDIA PRIVATE LIMITED',
    'MIGROS INDIA PRIVATE LIMITED',
    'EXPERT365 HYDROSYS PRIVATE LIMITED',
    'CALGENEX DESIGNS PRIVATE LIMITED',
    'POCHEMUCHKA KIDS PRIVATE LIMITED',
    'AMPLUS POWER SUPPLY PRIVATE LIMITED',
    'HH IRON AND STEEL PRIVATE LIMITED',
    'KUMORI TECHNOLOGIES SERVICES PRIVATE LIMITED',
    'ANTHILL CAMPS & RESORT PRIVATE LIMITED',
    'ASHOKA MALLASANDRA KARADI ROAD PRIVATE LIMITED',
    'REDSTACK TECHNOLOGIES PRIVATE LIMITED',
    'ISHOM RESIDENCY PRIVATE LIMITED',
    'DRAVIDAN AVIATION SERVICES PRIVATE LIMITED',
    'DOIT TALENT VENTURES (INDIA) PRIVATE LIMITED',
    'SMW IT SERVICE PRIVATE LIMITED',
    'VISHAL LIFE SCIENCES PRIVATE LIMITED',
    'KEMPSTON GLOBAL TRADE AND SERVICES PRIVATE LIMITED',
    'DEVANSH EDUCATION PRIVATE LIMITED',
    'ANOXIGATE TECHNOLOGIES PRIVATE LIMITED',
    'WS FINSERV PRIVATE LIMITED',
    'CONNECT THE RADIUS INDIA PRIVATE LIMITED',
    'DHA IT BULLS PRIVATE LIMITED',
    'ATWORKIN FITNESS PRIVATE LIMITED',
    'ADHANAM INFOTECH PRIVATE LIMITED',
    'ORTON CABLES PRIVATE LIMITED',
    'DBL NIDAGATTA MYSORE HIGHWAYS PRIVATE LIMITED',
    'SOJAS TECHNO-POWER PRIVATE LIMITED',
    'SULIS INOVATION PRIVATE LIMITED',
    'EVIDENCE ACTION INDIA FOUNDATION',
    'DOSHION POLY SCIENCE PRIVATE LIMITED',
    'BRANDEDUCER DIGITAL SOLUTIONS PRIVATE LIMITED',
    'VIMTRA VENTURES PRIVATE LIMITED',
    'INGENIOUS FACES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP EIGHT PRIVATE LIMITED',
    'VSIRAH PHARMACEUTICALS PRIVATE LIMITED',
    'ROUNDUP CAFE PRIVATE LIMITED',
    'DYSRE APPAREL PRIVATE LIMITED',
    'ALLSTAX TECHNOLOGIES PRIVATE LIMITED',
    'INNXT AVIATION PRIVATE LIMITED',
    'OLTEX TRADING PRIVATE LIMITED',
    'PRASHAKTI SERVICES PRIVATE LIMITED',
    'URS EQUIPMENT PRIVATE LIMITED',
    'AGRR FILAMENTS PRIVATE LIMITED',
    'SUKTRAN TECHNOLOGIES PRIVATE LIMITED',
    'DAHEGAONPHATA KARMAD HIGHWAYS PRIVATE LIMITED',
    'RIDHIMA VEDIC SOLUTIONS (OPC) PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY (MH) LIMITED',
    'NEWAY RENEWABLE ENERGY (BATHINDA) PRIVATE LIMITED',
    'BURNETT HOMEOPATHY PRIVATE LIMITED',
    'ELEANNT TECHNOLOGIES SERVICES PRIVATE LIMITED',
    'SMARTOUCH INFOTECH PRIVATE LIMITED',
    'INDAGO RESEARCH PRIVATE LIMITED',
    'FINWIZZ FINANCIAL SERVICES PRIVATE LIMITED',
    'ABHISHTI TEXTILE PRIVATE LIMITED',
    'REGENT METROPOLITAN SECURITIES PRIVATE LIMITED',
    'LITTELFUSE OPERATIONS INDIA PRIVATE LIMITED',
    'TBF ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'KRISHMOHAN TECH PRIVATE LIMITED',
    'NABVENTURES LIMITED',
    'PRINT PRIME INDIA PRIVATE LIMITED',
    'VIXSPACE INDIA PRIVATE LIMITED',
    'UXLI CONSULTING PRIVATE LIMITED',
    'IKOSHUR RECRUITMENT PRIVATE LIMITED',
    'FARFETCH INDIA PRIVATE LIMITED',
    'VARIABLE INDIA TRADERS PRIVATE LIMITED',
    'SAKSHAM UDYOG INDIA PRIVATE LIMITED',
    'SRI GOWMARIAMMAN FOOD PRIVATE LIMITED',
    'IOANYT INNOVATIONS PRIVATE LIMITED',
    'ARNAVTECH SOLAR PRIVATE LIMITED',
    'ORIX HOUSING FINANCE CORPORATION INDIA LIMITED',
    'INTELLECTFACES TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'EXA TELECOMMUNICATION PRIVATE LIMITED',
    'JALNA GHANSAWANGI HIGHWAYS PRIVATE LIMITED',
    'VMCJPR EDUCATIONAL SERVICES PRIVATE LIMITED',
    'SAMUDRA AUDITORS AND TRAINERS PRIVATE LIMITED',
    'SRAM & MRAM VENTURES PRIVATE LIMITED',
    'MAXIMIZER VENTURES PRIVATE LIMITED',
    'APTON PARTITIONING PRIVATE LIMITED',
    'TSR DARASHAW HR SERVICES PRIVATE LIMITED',
    'APPALANCHE TECHNOLOGIES PRIVATE LIMITED',
    'GEMMA MARKETING & COMMUNICATIONS PRIVATELIMITED',
    'NUVEM LABS PRIVATE LIMITED',
    'AURCHER PROJECTS PRIVATE LIMITED',
    'SYNTANK PRIVATE LIMITED',
    'SMARC SYSTEMS & AUTOMATION PRIVATE LIMITED',
    'BELLCHERRY VENTURES (OPC) PRIVATE LIMITED',
    'FUMIGRAIN PRIVATE LIMITED',
    'PROMOTEDGE GLOBAL SERVICES PRIVATE LIMITED',
    'SEVENRING INNOVATIONS PRIVATE LIMITED',
    'TIMESTAMP TECHNOLOGIES PRIVATE LIMITED',
    'RADEE HEALTH VENTURES PRIVATE LIMITED',
    'LIGER MOBILITY PRIVATE LIMITED',
    'NESCA TECH PRIVATE LIMITED',
    'BSAFAL INFRASPACE PRIVATE LIMITED',
    'ECO REVIVE INFRASTRUCTURE PRIVATE LIMITED',
    'EQMS INGENUITY PRIVATE LIMITED',
    'IAVA SERVICES PRIVATE LIMITED',
    'DAEJOO MATERIALS INDIA PRIVATE LIMITED',
    'METAWATERSURE TECHNOLOGIES PRIVATE LIMITED',
    'SCORELINE ENTERPRISES PRIVATE LIMITED',
    'RAVAGO MANUFACTURING INDIA PRIVATE LIMITED',
    'ARCTIC GATEWAY INDIA PRIVATE LIMITED',
    'MAISON ROUCADIL (OPC) PRIVATE LIMITED',
    'PAI FONDEKAR INVESTMENTS PRIVATE LIMITED',
    'KEY BUSINESS CONSULTANTS PRIVATE LIMITED',
    'SOLINO INTERNATIONAL PRIVATE LIMITED',
    'IVK HOSPITALITY PRIVATE LIMITED',
    'ALGAMBO INTERNET PRIVATE LIMITED',
    'VIJAYRAJA',
    'S GLOBAL HOPE FOUNDATION',
    'OAKUM DIGITAL STUDIO PRIVATE LIMITED',
    'CBR STEEL CAST AID LIMITED',
    'ESCALATES TECH INDIA PRIVATE LIMITED',
    'CROOKED TAIL PRIVATE LIMITED',
    'LMANDALA HPS PRIVATE LIMITED',
    'GKJ FAMILY ADVISORS PRIVATE LIMITED',
    'SINDPHAL POWER DEVELOPMENT PRIVATE LIMITED',
    'PHENOBOND INDIA PRIVATE LIMITED',
    'YERMALA POWER ENERGY PRIVATE LIMITED',
    'AAAS ENGINEERING AND TECHNOLOGY PRIVATE LIMITED',
    'MODERN CAPITAL FOOD PRIVATE LIMITED',
    'LIWO DESIGN AND BUILD PRIVATE LIMITED',
    'GREENYANA POWER PRIVATE LIMITED',
    'PAYKUN PAYMENT SOLUTIONS PRIVATE LIMITED',
    'ARIES SOLUTIONS PRIVATE LIMITED',
    'JK TOTALERG PRODUCTS PRIVATE LIMITED',
    'RESOLVEBAY SERVICES PRIVATE LIMITED',
    'MEDISIM VR PRIVATE LIMITED',
    'EARTH SAMVARTA FOUNDATION',
    'UNITE STACK LINES PRIVATE LIMITED',
    'SELLOGS METAMEDIARY SOLUTIONS PRIVATE LIMITED',
    'YANFENG SEATING (INDIA) PRIVATE LIMITED',
    'INDRA OKANE LIMITED',
    'MASSWAY INDIA TRADING PRIVATE LIMITED',
    'EXPLOROAR KIDS PRIVATE LIMITED',
    'ARIAKART VENTURES PRIVATE LIMITED',
    'SAINTLEY SONNE INDIA PRIVATE LIMITED',
    'GREENYANA SUNSTREAM PRIVATE LIMITED',
    'ESR INDUSTRIAL PARK REALTY PRIVATE LIMITED',
    'BSKZ PROJECTS PRIVATE LIMITED',
    'NEXTECH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EVENTIA EVENT DESIGNERS PRIVATE LIMITED',
    'EASTAWAY (INDIA) PRIVATE LIMITED',
    'VEW EXPRESS SERVICES PRIVATE LIMITED',
    'SSBA INSURANCE BROKER PRIVATE LIMITED',
    'ROZAD TECH (INDIA) PRIVATE LIMITED',
    'RIDINGSOLO HIKE & TREK PRIVATE LIMITED',
    'SATYA CONSTRUCTIONS PRIVATE LIMITED',
    'FIBZY INFRASOLUTIONS PRIVATE LIMITED',
    'CORLIENT TECH SOLUTIONS PRIVATE LIMITED',
    'SHARARAT VENTURES PRIVATE LIMITED',
    'SERIOUS FUN EVENTS PRIVATE LIMITED',
    'GIFTABLED INNOVENTURES PRIVATE LIMITED',
    'PARYAKSHAN LABORATORY PRIVATE LIMITED',
    'BIZM CONSULTING PRIVATE LIMITED',
    'RELIPROMPT ENTERPRISES LIMITED',
    'THATHWAA COMMUNICATIONS PRIVATE LIMITED',
    'VERNACT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DCS & STAFFING PRIVATE LIMITED',
    'ASSIE CAPITAL PRIVATE LIMITED',
    'SHRIPAD ECOSYS PRIVATE LIMITED',
    'LAKSHY INCLUSION SERVICES PRIVATE LIMITED',
    'MANPO CONSULTANTS PRIVATE LIMITED',
    'FINE QUALITY INDUSTRIES PRIVATE LIMITED',
    'CELLO INDUSTRIES PRIVATE LIMITED',
    'JEEBENZ MINING AND QUARRYING PRIVATE LIMITED',
    'MOOZE TECH PRIVATE LIMITED',
    'OP TECHNOLOGIES PRIVATE LIMITED',
    'ENTHUSIAST GLOBAL PRIVATE LIMITED',
    'SUHRULLEKHA FOODS PRIVATE LIMITED',
    'INFINITE SCALES INDIA PRIVATE LIMITED',
    'MOBIKWIK CREDIT PRIVATE LIMITED',
    'MECHWAN AUTOMATION PRIVATE LIMITED',
    'PERIGORD DATA SOLUTIONS INDIA PRIVATE LIMITED',
    'PDR HEALTHCARE PRIVATE LIMITED',
    'URJALAYA RENEWABLE PRIVATE LIMITED',
    'GILEAD HI-TECH (OPC) PRIVATE LIMITED',
    'ANUKRIYA FOUNDATION',
    'RESTOS ONLINE SERVICES PRIVATE LIMITED',
    'TILT BRAND SOLUTIONS PRIVATE LIMITED',
    'ERODE SMART CITY LIMITED',
    'EKA CORPORATE ADVISORS & SERVICES PRIVATE LIMITED',
    'PARK HOLIDAYS AND RESORTS PRIVATE LIMITED',
    'PRIST LEATHER PRIVATE LIMITED',
    'NEXTGEN RECRUITMENT VENTURES LIMITED',
    'LARTISAN BREADS PRIVATE LIMITED',
    'ISSGF INDIA PRIVATE LIMITED',
    'VIMOBIN LABS PRIVATE LIMITED',
    'KAMPURNI LANDSCAPING SOLUTIONS PRIVATE LIMITED',
    'SHORTHILLS TECH PRIVATE LIMITED',
    'STERLITE INNOVATIVE SOLUTIONS LIMITED',
    'VIVERVA TECHNOLOGY PRIVATE LIMITED',
    'ABHIVIDEO KATHA PRIVATE LIMITED',
    'SIPHON INFRA PRIVATE LIMITED',
    'CORUSCANT ONE IDEA NODAL PRIVATE LIMITED',
    'DRSC METALS PRIVATE LIMITED',
    'AWORKI FYD PRIVATE LIMITED',
    'ENNCON SYNERGIES (INDIA) PRIVATE LIMITED',
    'ALEAL SOFTWARE PRIVATE LIMITED',
    'SSUINNOVATION FOUNDATION',
    'MAALIGAI CONSTRUCTIONS PRIVATE LIMITED',
    'TECHNOCLARE INFOWAYS PRIVATE LIMITED',
    'SUSK LOGISTICS PRIVATE LIMITED',
    'ILOSUNG PRIVATE LIMITED',
    'INTELLIQUITY CONSULTING SERVICES PRIVATELIMITED',
    'JUNTRAN TECHNOLOGIES PRIVATE LIMITED',
    'RUDRANUSH FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'PRINTALYTIX PRIVATE LIMITED',
    'ASSAM BIO REFINERY PRIVATE LIMITED',
    'BHASKARAM IT SEVA PRIVATE LIMITED',
    'CLOUDNTEL TECH INNOVATION LAB PRIVATE LIMITED',
    'MASSIVE FARMS PRIVATE LIMITED',
    'PAIKAR REAL ESTATES PRIVATE LIMITED',
    'CREATIVEENCODE TECHNOLOGIES PRIVATE LIMITED',
    'SAMKAISER INFRATECH PRIVATE LIMITED',
    'GENERAL SOVEREIGN PRIVATE LIMITED',
    'LUCERNA EXPORTS PRIVATE LIMITED',
    'MODICUM TECHNOLOGIES PRIVATE LIMITED',
    'COMPENG COMPOSITE SOLUTIONS (OPC) PRIVATE LIMITED',
    'SPEAKABOOS EDUCATIONAL SERVICES PRIVATE LIMITED',
    'MATRUVATSALYA FOUNDATION',
    'H2O TECH LABS PRIVATE LIMITED',
    'CHARMEUSE TECHNOLOGIES PRIVATE LIMITED',
    'SEK TECHNOSOFT PRIVATE LIMITED',
    'NESTOTUS PRIVATE LIMITED',
    'ASTUTIC ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'WEBJI HOSTING PRIVATE LIMITED',
    'PRO TAEKWONDO LEAGUE PRIVATE LIMITED',
    'SARAF ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'SENATOR LOGISTICS INDIA PRIVATE LIMITED',
    'EUROTECNICHE INDIA PRIVATE LIMITED',
    'DAIKI AXIS INDIA PRIVATE LIMITED',
    'CHITRAKARS DIGITAL COMMUNICATIONS PRIVATE LIMITED',
    'BRIX ACADEMY INDIA PRIVATE LIMITED',
    'DEWSBERRY CAPITAL PRIVATE LIMITED',
    'MOLSYS PRIVATE LIMITED',
    'DEWCOMM COMMUNICATIONS ENTERPRISES PRIVATE LIMITED',
    'JNC TRANSLATION RESEARCH FOUNDATION',
    'OVBO INDIA PRIVATE LIMITED',
    'AV PRAKRITII INTERNATIONAL PRIVATE LIMITED',
    'MICOB PRIVATE LIMITED',
    'NGEI PRIVATE LIMITED',
    'SBTC INFRASOLUTIONS PRIVATE LIMITED',
    'LAVENTRIX SMARTCARE PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING NINETEEN PRIVATE LIMITED',
    'BACKWATER ANALYTICS PRIVATE LIMITED',
    'AICUMEN INNOVATIONS PRIVATE LIMITED',
    'INFOQUICK TECHNOLOGIES PRIVATE LIMITED',
    'HUGARRO GLOBAL HOLIDAYS PRIVATE LIMITED',
    'VAHATUKA PRIVATE LIMITED',
    'AARADHYADECOR PRIVATE LIMITED',
    'FPL VEHICLES PRIVATE LIMITED',
    'DEEPTEK MEDICAL IMAGING PRIVATE LIMITED',
    'SANDOR SPECIALITY DIAGNOSTICS PRIVATE LIMITED',
    'BHUPINE HEALTHCARE PRIVATE LIMITED',
    'RATRICO DEVELOPERS PRIVATE LIMITED',
    'LUMIVERSE SOLUTIONS PRIVATE LIMITED',
    'SCHEMATTER CAD AND PRINTING (OPC) PRIVATE LIMITED',
    'ANAY SALES PRIVATE LIMITED',
    'PREM WHEELS PRIVATE LIMITED',
    'BITOLA INDUSTRIES PRIVATE LIMITED',
    'APPIAN INFOTECH PRIVATE LIMITED',
    'SEAKNOTS IT SOLUTIONS PRIVATE LIMITED',
    'NIKET FARM PRIVATE LIMITED',
    'MUMBAI URJA MARG LIMITED',
    'NORDIC ACADEMY PRIVATE LIMITED',
    'FINDOC INFRABIZ PRIVATE LIMITED',
    'BACS ENERGY PRIVATE LIMITED',
    'LEENA AI INDIA PRIVATE LIMITED',
    'AIC-GLS FOUNDATION',
    'EMKAYGLOBAL FINANCIAL SERVICES IFSC PRIVATE LIMITED',
    'AMEYA CYBER RISK SOLUTIONS PRIVATE LIMITED',
    'KORE TRADECOM PRIVATE LIMITED',
    'SYSBITRON PRIVATE LIMITED',
    'RBOW WHOLESALERS AND DISTRIBUTORS (OPC) PRIVATE LIMITED',
    'PROMARC GROWTH SERVICES PRIVATE LIMITED',
    'ACCELUS ROBOTICS PRIVATE LIMITED',
    'NEXTRONICS PRIVATE LIMITED',
    'HAJEE AP BAVA INFRA PRIVATE LIMITED',
    'ZEN LIFESTYLE PRIVATE LIMITED',
    'KHULLAR APPARELS PRIVATE LIMITED',
    'VIGILANT SOLUTIONS INDIA PRIVATE LIMITED',
    'PROACTION FOUNDATION',
    'AWR LLOYD INDIA PRIVATE LIMITED',
    'THINKECO PRIVATE LIMITED',
    'ATTORT LEGAL CONSULTANCY PRIVATE LIMITED',
    'QLIXEL GLOBAL SOLUTIONS PRIVATE LIMITED',
    'AGHNE ELECTRIKAL VEHICLES INDIA PRIVATE LIMITED',
    'MBERG FOUNDATION',
    'VYASA YOGA TECHNOLOGIES PRIVATE LIMITED',
    'TRAIT IT PARK PRIVATE LIMITED',
    'MANNUR SQUARE LAND PRIVATE LIMITED',
    'ARETE MANUFACTURING SERVICES PRIVATE LIMITED',
    'ADOBESP GRID PRIVATE LIMITED',
    'JOVITHA COMMUNICATIONS PRIVATE LIMITED',
    'PRARAMBH RETAIL PRIVATE LIMITED',
    'BUNAVAT RETAIL PRIVATE LIMITED',
    'ROADWAY SOLUTIONS LONAVALA HIGHWAY PROJECT PRIVATE LIMITED',
    'SUPERLATIVE GAMING PRIVATE LIMITED',
    'ALANOL ADDITIVES PRIVATE LIMITED',
    'S.P.E.A.R. SECURITY SOLUTIONS PRIVATE LIMITED',
    'OPRL BIOSCIENCES PRIVATE LIMITED',
    'BOTMATIC SOLUTION PRIVATE LIMITED',
    'DONGA HWASUNG INDIA PRIVATE LIMITED',
    'NAMMA DOCTORVALLEY INDIA PRIVATE LIMITED',
    'AVINER NETWORK ENGINEERING PRIVATE LIMITED',
    'PALLAVI MEDICARE PRIVATE LIMITED',
    'UANDH PRIVATE LIMITED',
    'KNOWLEDGE EXCEL PRIVATE LIMITED',
    'APPL CENERGY SOLUTIONS PRIVATE LIMITED',
    'SYPNOSIS TELESOLUTIONS PRIVATE LIMITED',
    'AYANA ANANTHAPURAMU SOLAR PRIVATE LIMITED',
    'SADBHAV HYBRID ANNUITY PROJECTS LIMITED',
    'AGNOMICS ANALYTICS LAB PRIVATE LIMITED',
    'BIMAL WATER SOLUTIONS PRIVATE LIMITED',
    'STUDIO TIKTOK PRIVATE LIMITED',
    'GEOMETA PROJECTS PRIVATE LIMITED',
    'SRISHTINEER WOMEN ARTISANS EMPOWERMENT ASSOCIATION',
    'ARVO FOOD AND BEVERAGES PRIVATE LIMITED',
    'BUD AND BUDDIES EDUTECH PRIVATE LIMITED',
    'SWEE HONG INDIA PRIVATE LIMITED',
    'CARNATION INFOTECH PRIVATE LIMITED',
    'BRIGHTFOX EDUTECH LEARNING SOLUTIONS PRIVATE LIMITED',
    'BRIGHTEC WEB TECHNOLOGIES PRIVATE LIMITED',
    'MANSHUBH PROPERTIES PRIVATE LIMITED',
    'DWI INFOTECH PRIVATE LIMITED',
    'GBIO BT PRIVATE LIMITED (OPC)',
    'STARYA MOBILITY PRIVATE LIMITED',
    'SARASVATHI CORRUGATED (INDIA) PRIVATE LIMITED',
    'PANSOFIN PRIVATE LIMITED',
    'HABITOTAL ENGINEERING (OPC) PRIVATE LIMITED',
    'EVERY LIFE MATTERS FOUNDATION',
    'RISING FLAME FOUNDATION',
    'TRESFUTURE ENERGY PRIVATE LIMITED',
    'RADHA KRISHNA CALL TAXI PRIVATE LIMITED',
    'SAMATVA INDIA DESIGN & DEVELOPMENT PRIVATE LIMITED',
    'TRUCVR TECHNOLOGIES PRIVATE LIMITED',
    'TRONCART SOLUTIONS PRIVATE LIMITED',
    'ENERTECT VISION TECHNOLOGIES PRIVATE LIMITED',
    'CAIFU WEALTH CREATORS PRIVATE LIMITED',
    'ETENGY PRIVATE LIMITED',
    'SOLIDS AND MODELS ENGINEERING PRIVATE LIMITED',
    'FIDZEAL SOLUTIONS PRIVATE LIMITED',
    'AMWIN MACHINING PRIVATE LIMITED',
    'NEHRITZ SERBIZ PRIVATE LIMITED',
    'AWL EDIBLE OILS AND FOODS PRIVATE LIMITED',
    'DROOM TECH LOGISTIC PRIVATE LIMITED',
    'TUS NUA VENTURES PRIVATE LIMITED',
    'ACE URBAN HOUSING FINANCE PRIVATE LIMITED',
    'NIGHT GUARD FACILITY MANAGEMENT PRIVATE LIMITED',
    'IGENE MEDIA SOLUTION PRIVATE LIMITED',
    'VLSI EXPERT PRIVATE LIMITED',
    'NEEM TREE CONSULTANTS PRIVATE LIMITED',
    'SEAGEAR MARINE SUPPLIES PRIVATE LIMITED',
    'PINOCKS TECHNOLOGIES PRIVATE LIMITED',
    'CUEBIZ TECHNOLOGIES PRIVATE LIMITED',
    'NA SPORTZ DIGITAL SOLUTIONS PRIVATE LIMITED',
    'RINCON REALTY PRIVATE LIMITED',
    'SURYAINVICTUS APPLIED SOLUTIONS PRIVATE LIMITED',
    'SGL INDUSTRIES INDIA PRIVATE LIMITED',
    'PEBIBITS TECHNOLOGIES PRIVATE LIMITED',
    'RAKETECH PRIVATE LIMITED',
    'EDVEON TECHNOLOGIES PRIVATE LIMITED',
    'HOLD TECHNOLOGIES PRIVATE LIMITED',
    'MERALDA JEWELS PRIVATE LIMITED',
    'TEJIKA LABS PRIVATE LIMITED',
    'AQMEN MEDTECH PRIVATE LIMITED',
    'INFINIVO SYSTEMS PRIVATE LIMITED',
    'RNK WEB TECHNOLOGIES PRIVATE LIMITED',
    'ETHEREAL INGREDIENTS PRIVATE LIMITED',
    'IRHPL SERVICES PRIVATE LIMITED',
    'ORICAST INTERNATIONAL PRIVATE LIMITED',
    'YUVAN VENTURES PRIVATE LIMITED',
    'INDIC CENTER FOR PSYCHOLOGICAL WELLNESS & HOLISTIC HEALTH PRIVATE LIMITED',
    'VERTIVER PRIVATE LIMITED',
    'TESK VIKAS (INDIA) PRIVATE LIMITED',
    'AAMEEGO PLANNERS PRIVATE LIMITED',
    'KOSSA AUTO TEC PRIVATE LIMITED',
    'COMMON ROOM NON PROFIT FOUNDATION FOR NEW ENTREPRENEURS',
    'KINARA AI PRIVATE LIMITED',
    'LALLY MOTORS SERVICES PRIVATE LIMITED',
    'EVITALZ INFORMATION MANAGEMENT PRIVATE LIMITED',
    'EDF INDIA PRIVATE LIMITED',
    'NICOSA CONSULTING PRIVATE LIMITED',
    'HYPERREALITY TECHNOLOGIES PRIVATE LIMITED',
    'CUBEREUM TECHNOLOGIES PRIVATE LIMITED',
    'SMARTGAON MART PRIVATE LIMITED',
    'SRI BALAJI WORKSHOP PRIVATE LIMITED',
    'LEONSTRIDE TECHNOLOGIES PRIVATE LIMITED',
    'ANNUR SS AGRO FOODS PRIVATE LIMITED',
    'SOMRAS SOFTWARE PRIVATE LIMITED',
    'OMJAY EV LIMITED',
    'WEASEL LEGAL ADVISORS PRIVATE LIMITED',
    'AVANTTA INFRA PRIVATE LIMITED',
    'VRMX CONCRETE INDIA PRIVATE LIMITED',
    'GRANDBIZ IT SOLUTIONS PRIVATE LIMITED',
    'NANO DIGITAL MEDIA PRIVATE LIMITED',
    'CAYEKMLA SOFT TECH PRIVATE LIMITED',
    'TAKASHO GARDEN LIVING INDIA PRIVATE LIMITED',
    'UTTARAYAN FOUNDATION AND MUSEUM FOR ARTS',
    'CLEARSCORE TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'SYGNOSTIC TECHNOLOGIES PRIVATE LIMITED',
    'FLOATEX MARKETING SOLUTIONS PRIVATE LIMITED',
    'INFODOCT HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'SANDHAR WHETRON ELECTRONICS PRIVATE LIMITED',
    'MANKAME AUTOMOTIVE PRIVATE LIMITED',
    'ODEK APPCRAFT PRIVATE LIMITED',
    'DOMINO DATA LAB INDIA PRIVATE LIMITED',
    'THINCK HOLISTIC LIVING PRIVATE LIMITED',
    'REEVOLT HOUSE PRIVATE LIMITED',
    'ORIONSPICA IT SOLUTIONS PRIVATE LIMITED',
    'LAXTECH ELECTRONICS INDIA PRIVATE LIMITED',
    'SAVINAS EXPORT PRIVATE LIMITED',
    'CLARI SOFTWARE PRIVATE LIMITED',
    'WAASANG SOLAR PRIVATE LIMITED',
    'SHRUVMI DIGITECH PRIVATE LIMITED',
    'E2ES TECHNOLOGIES PRIVATE LIMITED',
    'ACUVEA ANALYTICS PRIVATE LIMITED',
    'ABSUMA LOGISTICS INDIA PRIVATE LIMITED',
    'KIYAAN LIFESTYLE SOLUTIONS (OPC) PRIVATELIMITED',
    'TATA UNISTORE LIMITED',
    'INTERNET INVESTMENT COMPANY PRIVATE LIMITED',
    'DELUXE LABORATORIES PRIVATE LIMITED',
    'HINTON INVESTMENTS AND FINANCE PRIVATE LIMITED',
    'HAVEMORE REALTY PRIVATE LIMITED',
    'DHATRI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MANSI SECURITIES AND COMMERCIALS PRIVATE LIMITED',
    'CEAL SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'SAMPATI PROPERTY DEVELOPERS PRIVATE LIMITED',
    'KALAVAKKAM PROPERTIES PRIVATE LIMITED',
    'CHETTINAD INFRASTRUCTURES & PROPERTY DEVELOPERS PRIVATE LIMITED',
    'CHETTINAD MINERALS AND LOGISTICS PRIVATE LIMITED',
    'CHETTINAD PROPERTIES PRIVATE LIMITED',
    'MADURANTHAGAM PROPERTIES PRIVATE LIMITED',
    'UTHIRAMERUR PROPERTIES PRIVATE LIMITED',
    'CHETTINAD PACKERS AND MOVERS PRIVATE LIMITED',
    'VINSONS AIR SERVICES PRIVATE LIMITED',
    'NEERVALUR PROPERTY DEVELOPERS PRIVATE LIMITED',
    'SHRUT SHAH TRADING COMPANY PRIVATE LIMITED',
    'GLOBE TROTTERS PRIVATE LIMITED',
    'YATRA TG STAYS PRIVATE LIMITED',
    'CIMWORKS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'OSM MARITIME SERVICES PRIVATE LIMITED',
    'SMG SECURITIES PRIVATE LIMITED',
    'MITTAL SECURITIES PRIVATE LIMITED',
    'MECKLAI FINANCIAL SERVICES PRIVATE LIMITED',
    'CIRCA SYSTEMS PRIVATE LIMITED',
    'R T W SOLUTIONS PRIVATE LIMITED',
    'APOLLO EXPORTS PRIVATE LIMITED',
    'MIHIKA FINANCIAL SERVICES PRIVATE LIMITED',
    'NIKKO PROPERTIES AND DEVELOPERS PRIVATE LIMITED',
    'DECOS SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'PRESCIENT TECHNOLOGIES PRIVATE LIMITED',
    'LANDMARK SHELTERS PRIVATE LIMITED',
    'SINDHUDURG PROJECTS PRIVATE LIMITED',
    'ANSYS SOFTWARE PRIVATE LIMITED',
    'CHALLENGER SYSTEMS (INDIA) PRIVATE LIMITED',
    'AFCO INFRACON PRIVATE LIMITED',
    'EPICENTER TECHNOLOGIES PRIVATE LIMITED',
    'SIMON DEVELOPERS AND INFRASTRUCTURE PRIVATE LIMITED',
    'NAVKANJ MINING RESOURCES LIMITED',
    'DA VINCI DESIGN SOLUTIONS PRIVATE LIMITED',
    'MAHENDRA REALTORS & INFRASTRUCTURE PRIVATE LIMITED',
    'ZOOMIN ONLINE (INDIA) PRIVATE LIMITED',
    'E4 SOFTWARE SERVICES PRIVATE LIMITED',
    'CITICORP SERVICES INDIA PRIVATE LIMITED',
    'ARCHWAY VENTURES (INTERNATIONAL) PRIVATE LIMITED',
    'HOSTIN SERVICES PRIVATE LIMITED',
    'EVOLVEWARE INFORMATION TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'SANDRIVER TECHNOLOGIES PRIVATE LIMITED',
    'ARAGON SERVICES PRIVATE LIMITED',
    'ULMA FORMWORK SYSTEMS INDIA PRIVATE LIMITED',
    'FOOTBALL SPORTS DEVELOPMENT LIMITED',
    'SYNGENTA SERVICES PRIVATE LIMITED',
    'EMERALD PROPERTY & POWER DEVELOPERS PRIVATE LIMITED',
    'KUNDAMPAKKAM PROPERTY DEVELOPERS PRIVATE LIMITED',
    'RENAISSANCE STRATEGIC CONSULTANTS PRIVATE LIMITED',
    'KODITHANDALAM PROPERTIES PRIVATE LIMITED',
    'KENT CARS PRIVATE LIMITED',
    'SAFAL SYSTEMS PRIVATE LIMITED',
    'HOUSE OF SANDY CONSULTANCY PRIVATE LIMITED',
    'SMS IT SOLUTIONS PRIVATE LIMITED',
    'INTEGRATED SOFTWARE AND SYSTEMS ENGINEERING PVT LTD',
    'MOTECH SOFTWARE PRIVATE LIMITED',
    'MARGARETA INFOTECH PRIVATE LIMITED',
    'DATAMATRIX INFOTECH PRIVATE LIMITED',
    'UPSURGE SOFTWARE PRIVATE LIMITED',
    'STARLITE ENTERPRISES PRIVATE LIMITED',
    'BRIJ BHOOMI EXPRESSWAY PRIVATE LIMITED',
    'TATA STARBUCKS PRIVATE LIMITED',
    'VAGAJ INVESTMENTS PRIVATE LIMITED',
    'CHING BEE INVESTMENTS PRIVATE LIMITED',
    'AND DATA INDIA PRIVATE LIMITED',
    'ANAND AUTOMOTIVE PRIVATE LIMITED',
    'BABA INFOTECH PRIVATE LIMITED',
    'RAINBOW INFOTECH (INDIA) PRIVATE LIMITED',
    'KLOUTIX SOLUTIONS PRIVATE LIMITED',
    'SARJU LASER MARKING PRIVATE LIMITED',
    'EASYRUPIYA WEB SERVICES PRIVATE LIMITED',
    'FOR-A INDIA PRIVATE LIMITED',
    'HERRMANN RESEARCH PRODUCTS & LABORATORIES PRIVATE LIMITED',
    'FLOWERY ADVISORS PRIVATE LIMITED',
    'BELLONA HOSPITALITY SERVICES LIMITED',
    'MAJESTIC MARKET RESEARCH SUPPORT SERVICES LIMITED',
    'NATASHA CONSULTANTS PRIVATE LIMITED.',
    'SAI PRASAN CONSULTANCY PRIVATE LIMITED',
    'CORPORATE MANAGEMENT COUNCIL OF INDIA PRIVATE LIMITED',
    'MARGOM CORPORATE ADVISORY SERVICES PRIVATE LIMITED',
    'LIFESTYLE SUPERMARKETS PRIVATE LIMITED',
    'SHOPRITE MARKETING PRIVATE LIMITED',
    'RITU',
    'S PEOPLE RESOURCES PRIVATE LIMITED',
    '7P BRAND BRAIN PRIVATE LIMITED',
    'INDRADHANUSH GAS GRID LIMITED',
    'NEOSALPHA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'UITP CONSULTANCY SERVICES PRIVATE LIMITED',
    'UNITRAX INFOVENTURES PRIVATE LIMITED',
    'APAARANIDHI ENTERTAINMENT PRIVATE LIMITED',
    'BACKWATER VENTURES PRIVATE LIMITED',
    'SWASTIK ANALYTICAL LABORATORY PRIVATE LIMITED',
    'ASHWINI SALUNKHE HAIR AND BEAUTY ACADEMY(OPC) PRIVATE LIMITED',
    'FINAPTECH FINANCIAL SERVICES PRIVATE LIMITED',
    'MECGRAPHIT SERVICES PRIVATE LIMITED',
    'SHIN TRADERS PRIVATE LIMITED',
    'SUKRUTI LOGISTICS PRIVATE LIMITED',
    'CRONOUS HEALTHCARE PRIVATE LIMITED',
    'XPRESSHOP HEALTHCARE PRIVATE LIMITED',
    'TESORO MULTI SERVICES PRIVATE LIMITED',
    'OBRA-C BADAUN TRANSMISSION LIMITED',
    'ENERGEIA MICROGRID PRIVATE LIMITED',
    'JASH STUDIO PRIVATE LIMITED',
    'NAVPATH KAUSHAL VIKAS FOUNDATION',
    'VINAYAK CONSTRUCTION EQUIPMENT PRIVATE LIMITED',
    'EDUATE PRIVATE LIMITED',
    'CONCLUSIVE SEMICONDUCTORS PRIVATE LIMITED',
    'SOCIUSIGB RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'DIGITAL DATARUN ANALYTICS & IT SOLUTIONSPRIVATE LIMITED',
    'BE SHARP CONSULTING PRIVATE LIMITED',
    'NEURICH NUTRIFOODS LIMITED',
    'KAL CARGO PRIVATE LIMITED',
    'PETLICIOUS SUPERFOODS INDIA PRIVATE LIMITED',
    'COLORSHINE INDIA PRIVATE LIMITED',
    'TAILCURRENT TECHNOLOGIES PRIVATE LIMITED',
    'PHILIMONT NUTRIFOODS LIMITED',
    'AGAASE LIFESTYLE PRIVATE LIMITED',
    'SKILLS2SHINE E-LEARNING PRIVATE LIMITED',
    'RIPPLESTREET INDIA PRIVATE LIMITED',
    'RS WALL INFRA PRIVATE LIMITED',
    'RAMTEJ FINVEST PRIVATE LIMITED',
    'WEALTHY MINDZ WORLDWIDE (OPC) PRIVATE LIMITED',
    'BHARAT GLOBAL LOGISTICS PRIVATE LIMITED',
    'RENTITY GLOBAL SERVICES PRIVATE LIMITED',
    'PI HEALTH SCIENCES LIMITED',
    'UNICA TOKEN PRIVATE LIMITED',
    'MONADIC (OPC) PRIVATE LIMITED',
    'SOLTOWN INFRA PRIVATE LIMITED',
    'BUSIFROG TECH PRIVATE LIMITED',
    'MAZARS TAX TECHNOLOGIES PRIVATE LIMITED',
    'KRVP REALTORS PRIVATE LIMITED',
    'SEG ENGINEERING SERVICES PRIVATE LIMITED',
    'MASTERPIECE INFOTECH PRIVATE LIMITED',
    'REGENXCEL PRIVATE LIMITED',
    'CLOUD GUARDIANS GLOBAL PRIVATE LIMITED',
    'STENTOR PHARMA PRIVATE LIMITED',
    'MITTAL BUILDERS (I) PRIVATE LIMITED',
    'DEFINIC TECH SOLUTIONS PRIVATE LIMITED',
    'JUSTICIA LAW PRIVATE LIMITED',
    'ENVIRTUS PRIVATE LIMITED',
    'WE2CODE TECHNOLOGY PRIVATE LIMITED',
    'BANKERSFEED PRIVATE LIMITED',
    'ECOSAVVY SOLUTIONS PRIVATE LIMITED',
    'DELLA LEADERS PRIVATE LIMITED',
    'HEEKENTERTAINMENT ADTECH PRIVATE LIMITED',
    'SUN SHINE FOOD PRODUCTS (I) PRIVATE LIMITED',
    'ELEGANT SURVEYORS PRIVATE LIMITED',
    'LINK POLYCHEM PRIVATE LIMITED',
    'IT FRUITECH PRIVATE LIMITED',
    'VISTA SPACES 3RD BLOCK PRIVATE LIMITED',
    'ROMANSON PRINTING & PUBLISHING HOUSE PRIVATE LIMITED',
    'TECH BIBER MACHINERY PRIVATE LIMITED',
    'FAIR COMPARISON INDIA PRIVATE LIMITED',
    'FIRSTDROP INNOVATIONS PRIVATE LIMITED',
    'GLOBALFAIR IMPEX INDIA PRIVATE LIMITED',
    'ORGANIX AGROVET PRIVATE LIMITED',
    'ZYLUX CORPORATIONS PRIVATE LIMITED',
    'RAZI SOLUTIONS PRIVATE LIMITED',
    'INDOWELL EQUIPMENT PRIVATE LIMITED',
    'NORDWAVE PRIVATE LIMITED',
    'COSMERIT INDIA PRIVATE LIMITED',
    'NOYYAL FARMS AND LAND PROMOTIONS PRIVATELIMITED',
    'STARSCAPES EXPERIENCES PRIVATE LIMITED',
    'MASEEHUM TASK MANAGER PRIVATE LIMITED',
    'DYNAMICS INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'SHY TIGER PRIVATE LIMITED',
    'SUJATA INTERIOR AND INFRA MARKETING PRIVATE LIMITED',
    'SATYAWAT POLYMERS PRIVATE LIMITED',
    'EAGLETRONICS AVIATION PRIVATE LIMITED',
    'UTTAR DILLI C&D WASTE RECYCLING PRIVATE LIMITED',
    'MAPWOOD.IN PRIVATE LIMITED',
    'XTRA CURRICULAM PRIVATE LIMITED',
    'CONFLUENT MEDICAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MEMERTISE MEDIA PRIVATE LIMITED',
    'DIVYALOK GENERAL HOSPITAL AND RESEARCH ENTRE PRIVATE LIMITED',
    'TEKNOBIT SYSTEMS PRIVATE LIMITED',
    'AVYUKTH SECURITIES PRIVATE LIMITED',
    'DEFINEQUITY INVESTMENT MANAGERS PRIVATE LIMITED',
    'GRATEFUL MINDS PRIVATE LIMITED',
    'TAAL MEDIA SOLUTIONS PRIVATE LIMITED',
    'KHATU SHYAM BABA SEVA FOUNDATION',
    'SATRIA TECHNOLOGIES PRIVATE LIMITED',
    'SKHOOLAR EDTECH SOLUTIONS PRIVATE LIMITED',
    'ACQUARA IT SOLUTION PRIVATE LIMITED',
    'EXPATS CHOICE PRIVATE LIMITED',
    'CREATIVE HUT EDUCATION PRIVATE LIMITED',
    'DIC TECHWARE PRIVATE LIMITED',
    'ASKK ESTATES PRIVATE LIMITED',
    'BOWERBIRD CONSTRUCTION AND ENGINEERING PRIVATE LIMITED',
    'HOA INVESTMENTS PRIVATE LIMITED',
    'INFLUENCIA (OPC) PRIVATE LIMITED',
    'VITRAG EDUCATION FOUNDATION',
    'AMEO INDIA LOGISTICS PRIVATE LIMITED',
    'RE-KAPDAA PRIVATE LIMITED',
    'ARPSTEEL BUILDING SOLUTIONS PRIVATE LIMITED',
    'DEEPALAYA CARE FOUNDATION',
    'DROOM DATA SCIENCE PRIVATE LIMITED',
    'SUNFT PRIVATE LIMITED',
    'WHITEFALLS ENTERPRISES PRIVATE LIMITED',
    'POINCARE TECHNOLOGIES PRIVATE LIMITED',
    'PRAVIN MILAPCHAND CONSTRUCTION PRIVATE LIMITED',
    'DRISHTIVISIONIT SOLUTIONS (OPC) PRIVATE LIMITED',
    'POLICY.ONLINE IT PRIVATE LIMITED',
    'PHIX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'FOODASSO INDIA PRIVATE LIMITED',
    'MEDISCRIBE.AI PRIVATE LIMITED',
    'SHEELA DANG MENTAL HEALTH CARE CENTER (OPC) PRIVATE LIMITED',
    'HALCYON AGRIMECH PRIVATE LIMITED',
    'RIO ELEVATOR PRIVATE LIMITED',
    'PROTECH TECHNICAL TERMINOLOGY PRIVATE LIMITED',
    'TECHILOGY SOLUTIONS PRIVATE LIMITED',
    'HYDROBENZ INDUSTRIES PRIVATE LIMITED',
    'DIGITAL ALIGN INDIA PRIVATE LIMITED',
    'ANIMAL INDUSTRY DATA INDIA PRIVATE LIMITED',
    'KAMI VISION INDIA PRIVATE LIMITED',
    'HMATRIX OPTICALS PRIVATE LIMITED',
    'EPOWERX EVOLVE PRIVATE LIMITED',
    'KARNEST TECHNOLOGY PRIVATE LIMITED',
    'OPENW3B FOUNDATION',
    'METAVERSE BLOCKCHAIN SOLUTIONS PRIVATE LIMITED',
    'GO360 CLOUD PRIVATE LIMITED',
    'ADSTORRO PRIVATE LIMITED',
    'KITBIT DIGITAL SOLUTIONS (OPC) PRIVATE LIMITED',
    'NEXFOLIO FINTECH SERVICES PRIVATE LIMITED',
    'TURBOTIC SERVICES PRIVATE LIMITED',
    'VRP GLOBAL PARTNERS PRIVATE LIMITED',
    'HABTOZ CONSULTANCY PRIVATE LIMITED',
    'OSTECH MACHINES PRIVATE LIMITED',
    'S.ARADHANA KNITTING MILLS PRIVATE LIMITED',
    'EKAGRA SOLUTIONS PRIVATE LIMITED',
    'SAPTRISHI URBAN SPACE PRIVATE LIMITED',
    'AKIRO PROTECH PRIVATE LIMITED',
    'SPORTSGATE PRIVATE LIMITED',
    'KAMAL WATCH ENTERPRISES PRIVATE LIMITED',
    'J AND M MAKERS PRIVATE LIMITED',
    'KAT COMPLIANCE KARMA PRIVATE LIMITED',
    'ORBITSHUB TECHNOLOGY PRIVATE LIMITED',
    'SPD CONCRETE PRIVATE LIMITED',
    'CARTASEC PRIVATE LIMITED',
    'ARAIYA WELLNESS PRIVATE LIMITED',
    'ONSCREENTECH SOLUTIONS PRIVATE LIMITED',
    'WELDART FABRICATION AND SERVICES INFRA PRIVATE LIMITED',
    'SAIDRASHTI INFRASTRUCTURE PRIVATE LIMITED',
    'HORECA MART PRIVATE LIMITED',
    'EDUCATIONZONE EXPERTS PRIVATE LIMITED',
    'ORGANIC KITCHEN GROCERY SUPPLIES PRIVATELIMITED',
    'EMARKIT TRADE TECH PRIVATE LIMITED',
    'KOITA VENTURES PRIVATE LIMITED',
    'MARKETPLACES TECH PRIVATE LIMITED',
    'HUGGUN MK APPARELS PRIVATE LIMITED',
    'MACH WORLDWIDE LOGISTICS INDIA PRIVATE LIMITED',
    'GLOBALWATER PAGE FOUNDATION',
    'TIRUPATI MATSUP LOGISTICS PRIVATE LIMITED',
    'HOBASA INDIA PRIVATE LIMITED',
    'QUBRIUX INDIA PRIVATE LIMITED',
    'VONAGE BUSINESS COMMUNICATIONS PRIVATE LIMITED',
    'C1 PRODUCTIONS PRIVATE LIMITED',
    'BILITI ELECTRIC INDIA PRIVATE LIMITED',
    'DIVYAPARIMAL FRAGRANCE PRIVATE LIMITED',
    'HGM TECHNOLOGIES PRIVATE LIMITED',
    'MATERRA INDIA PRIVATE LIMITED',
    'ONEZ TECHNOLOGIES PRIVATE LIMITED',
    'VALIDUS INDIA TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SOFT REFLEX INFORMATICS PRIVATE LIMITED',
    'KONCEPT DESIGN PROJECTS PRIVATE LIMITED',
    'NUCH SOFTWARE INDIA PRIVATE LIMITED',
    'MEDIJUNCTION SMART HEALTHCARE PRIVATE LIMITED',
    'SRPK INFRA PRIVATE LIMITED',
    'IJH ACADEMY PRIVATE LIMITED',
    'MEDIAGHAR DIGITAL PRIVATE LIMITED',
    'CALIDAD INNOVATIVE SERVICES PRIVATE LIMITED',
    'VOLTAJAR TECHNOLOGY PRIVATE LIMITED',
    'SUPER BEATS AND RECORDS PRIVATE LIMITED',
    'RENEW SANDUR GREEN ENERGY PRIVATE LIMITED',
    'DIGITAL HUBSPOT INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED',
    'MSS PROCESS CHEMICAL PRIVATE LIMITED',
    'GREENBEAM EARTH PRIVATE LIMITED',
    'SANEE INFRACON PRIVATE LIMITED',
    'SIEMOTECH MICRO FINANCE PRIVATE LIMITED',
    'HUNTCH TECHNOLOGIES PRIVATE LIMITED',
    'SANTASA WOMEN HEALTH PRIVATE LIMITED',
    'PROHPELTECH DIGITAL PRIVATE LIMITED',
    'MANO AIRCRAFT PRIVATE LIMITED',
    'SCHRODINGER INDIA PRIVATE LIMITED',
    'VMAO FARM PRIVATE LIMITED',
    'ASTOUNDED CONSTRUCTION PRIVATE LIMITED',
    'CONNECTING BRIDGES ENTERPRISES PRIVATE LIMITED',
    'NORMAN ENVIRO PROJECTS PRIVATE LIMITED',
    'Dera hydro power private limited',
    'S s hydro engineering private limited',
    'Suroj buildcon private limited',
    'Gurupriya housing private limited',
    'Vijayaram investments private limited',
    'Moksha projects private limited',
    'Bengal intelligent parks private limited',
    'Adamas builders private limited',
    'Legacy corporation private limited',
    'Rupsing realtors private limited',
    'IGI MANAGEMENT SERVICES PRIVATE LIMITED',
    'Hyundai motor india engineering private limited',
    'Ferromet marketing company private limited',
    'Tcg facilities management services private limited',
    'Tenstar clothing private limited',
    'Trisa exports private limited',
    'Icape india electronics private limited',
    'Formulated polymers limited',
    'Tamarind hotels private limited',
    'Breeze hotel limited',
    'Wular shipping services private limited',
    'Mann travel private limited',
    'Air yusho private limited',
    'Leo integrated technologies private limited',
    'Vayuputhra communications limited',
    'Skytel telecom private limited',
    'Spirent communications (india) private limited',
    'Bubna investment private limited',
    'Yashika investment services private limited',
    'Tcg urban infrastructure holdings private limited',
    'Rex venture private limited',
    'Artage securities pvt ltd',
    'Juggernaut homes pvt ltd',
    'Bip developers private limited',
    'Tcg binswanger projects private limited',
    'Earnest towers private limited',
    'Chennai luxury home developers private limited',
    'Quadrant four property developers private limited',
    'Kesar realty private limited',
    'Cindrella homes pvt ltd',
    '77 infosystems private limited',
    'ELEVEN EXPRESS PRIVATE LIMITED',
    'Posiflex technology (india) private limited',
    'Harman Connected Services Corporation India Private Limited',
    'Software ag bangalore technologies private limited',
    'Samsung r&d institute india - bangalore private limited',
    'Replicon software (india) private limited',
    'CITADEL INTELLIGENT SYSTEMS LIMITED',
    'Summit it solutions private limited',
    'TALENTQUEST SOLUTIONS PRIVATE LIMITED',
    'Logicshore it consulting private limited',
    'Tangoe india softek services private limited',
    'Mobile voice konnect private limited',
    'Blue camphor technologies private limited',
    'Quest global defence engineering services private limited',
    'Attivo network security india private limited',
    'Mitsogo technologies private limited',
    'Compserv consultants private limited',
    'SS&C FINTECH SERVICES INDIA PRIVATE LIMITED',
    'ORBCOMM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Kofax india private limited',
    'Sunsumi systems india private limited',
    'Sita corp (india) private limited',
    'Honey bee it services private limited.',
    'Vista applied business & informatics private limited',
    'Contenterra software private limited',
    'Retail it sols private limited',
    'Infoexcel consulting private limited',
    'Fibroin technologies private limited',
    'Techna infrastructure private limited',
    'Tcg chembiotek infrastructure private limited',
    'Logicmatter (india) private limited',
    'Cubus banking solutions india private limited',
    'Security weaver software private limited',
    'Rista mobility india private limited',
    'Sys build technologies private limited',
    'Th infocom private limited',
    'Adaq technologies private limited',
    'Landmark it solutions private limited',
    'Facebook india online services private limited',
    'NETT10 DIGITAL PRIVATE LIMITED',
    'Tcg livingspaces private limited',
    'Royal chemistry india private limited',
    'Gokul corporate services private limited',
    'JATIA CHEMICALS PRIVATE LIMITED',
    'S TECHNOLOGIES PRIVATE LIMITED',
    'Sai bhavani transformers private limited',
    'Ora cables private limited',
    'ANUP INSULATION PRIVATE LIMITED',
    'Cableman electric company private limited',
    'Ideal tridon clamp (mumbai) company private limited',
    'G m modular private limited',
    'Sri savitr solar private limited',
    'Hki solution india private limited',
    'Tofflon (india) private limited',
    'Hasco india private limited',
    'Digital circuits private limited',
    'Asus technology private limited',
    'Solus security systems private limited',
    'SPORTA TECHNOLOGIES PRIVATE LIMITED',
    'Pk online ventures private limited',
    'Aurofidel outsourcing limited',
    'Focalworks solutions private limited',
    'Trutech webs private limited',
    'Sciemetric technologies india private limited',
    'Talentrackr technologies private limited',
    'Brandpotion social media private limited',
    'Bizfac infotech (india) private limited',
    'Dgains soft solutions private limited',
    'Vizio consultancy software private limited',
    'Enabler business solutions private limited',
    'Gayatri comteklab private limited',
    'Applayer technologies private limited',
    'Hd printers india limited',
    'Shivrai technologies private limited',
    'Retailware softech private limited',
    'Ojas systems private limited',
    'Logic square private limited',
    'Webonise lab private limited',
    'Techno magic systems india private limited',
    'Abhiyanta india solutions private limited',
    'Sirvisetti global services private limited',
    'Mesmeric software solutions private limited',
    'Yana software private limited',
    'Myclassboard educational solutions private limited',
    'Sygnovate it solutions private limited',
    'Agama it biz solutions private limited',
    'Arsg solutions private limited',
    'Mayapuri graphic workstation private limited',
    'Claystone technologies private limtied',
    'Fss technologies private limited',
    'Ankeena networks private limited',
    'Servercraft internet services private limited',
    'TNQ TECHNOLOGIES PRIVATE LIMITED',
    'Mavens i softech solutions private limited',
    'Incandescent technologies private limited',
    'Mfore solutions india private limited',
    'Evanssion infotech private limited',
    'Thundertech consulting private limited',
    'Aes technologies (india) private limited',
    'Etrax mobility private limited',
    'Tatva global techno services private limited',
    'Enki life science limited',
    'ARIANAA CONSULTANTS PRIVATE LIMITED',
    'FIDELIS TECHNOLOGY SERVICES PRIVATE LIMITED',
    'Shubh upchar private limited',
    'Ken private limited',
    'Bollywood stock & media exchange private limited',
    'Talent on rent private limited',
    'Stepathlon lifestyle private limited',
    'Pandim consultancy and research services private limited',
    'Tripvillas india private limited',
    'Dot digital private limited',
    'Network solutions and consulting private limited',
    'Mukta v n films limited',
    'FIERA CAPITAL INVESTMENT ADVISORS INDIA PRIVATE LIMITED',
    'New growth comtrade private limited',
    'Propstack services private limited',
    'Securizen systems private limited',
    'Native films private limited',
    'Supra warehousing private limited',
    'People advertising private limited',
    'Change.org india private limited',
    'NEXDIGM CORPORATE SERVICES PRIVATE LIMITED',
    'Rimini street india operations private limited',
    'Quantium analytics private limited',
    'HSCC (INDIA) LIMITED',
    'Eldorado consultants private limited',
    'Orange antelopes private limited',
    'Sapientia corporate consultancy limited',
    'Focus corporate restructuring private limited',
    'Wealth first advisors private limited',
    'Wealth first commodities private limited',
    'Parikh dave consultancy private limited',
    'Skyline insurance surveyors and loss assessors private limited',
    'TRIMURTI LOGISOLUTIONS & RETAILS PRIVATE LIMITED',
    'Ruder finn pr (india) private limited',
    'Hr corp pro services india private limited',
    'Transferet relocation services (india) private limited',
    'Ants consulting & services private limited',
    'Nauhwar global corporate services india private limited',
    'Neogen management consultants private limited',
    'Fintell consultancies private limited',
    'R & h consulting and services private limited',
    'Credit suisse finance (india) private limited',
    'TEAMLEASE SERVICES LIMITED',
    'Mehta trend analysis consultancy private limited',
    'Proactive corporate services private limited',
    'NOVANET HOLDINGS PRIVATE LIMITED',
    'Sunrise jewelleries private limited',
    'Easy fit jewellery limited',
    'Kurukshetra diamonds private limited',
    'Rays gems private limited',
    'Rexpro enterprises private limited',
    'Glascon thermo process private limited',
    'Procoat specialities private limited',
    'Excel optics private limited',
    'Kingsun enviro private limited',
    'GOLDI SOLAR PRIVATE LIMITED',
    'RK WIND LIMITED',
    'Tianshun wind energy (india) private limited',
    'Valuable energy private limited',
    'Poorn electricity solutions private limited',
    'Konark renewable power private limited',
    'WALWHAN SOLAR BH LIMITED',
    'My own eco-energy private limited',
    'Banyan environmental innovations private limited',
    'SAMIRAN UDAIPUR WINDFARMS PRIVATE LIMITED',
    'Solar dynamics private limited',
    'Nsl wind power company (sreepalwan) private limited',
    'Bhubaneshwar power private limited',
    'Taqa neyveli power company private limited',
    'Welspun energy orissa private limited',
    'MIRZAPUR THERMAL ENERGY (UP) PRIVATE LIMITED',
    'WALWHAN SOLAR RJ LIMITED',
    'Firstchoice properties (india) private limited',
    'Jagat homes and resorts private limited',
    'Sine infra private limited',
    'Volute constructions ltd',
    'Rrahulraj realtor private limited',
    'Prominare builders and developers private limited',
    'Dev ashish developers private limited',
    'Keepsade properties private limited',
    'Topaim properties private limited',
    'Victory realty private limited',
    'Aatman innovations private limited',
    'Neelkanth kalindi realtors private limited',
    'Neelkanth soham developers private limited',
    'Nilayami realtors private limited',
    'Neelkanth devansh developers private limited',
    'Valuable infra-tech private limited',
    'Santo infra projects private limited',
    'Wankhede infratech india private limited',
    'Tis infrastructure services private limited',
    'Kul urban development bengaluru private limited',
    'S.v.e.c. constructions limited',
    'Janapriya engineers syndicate private limited',
    'Pochampad construction company private limited',
    'Vensam infrastructure (india) pvt ltd',
    'UJJWAL PUNE LIMITED',
    'Keller ground engineering india private limited',
    'Holystar infrastructure pvt. ltd.',
    'Hamara ghar constructions and developers private limited',
    'Meenal ceramics private limited',
    'Padm complex ltd',
    'West india hospitality limited',
    'NARAYAN REALTY Private Limited',
    'Gauri infracon private limited',
    'Pashmina infrastructure private limited',
    'Abcon concrete surgeons private limited',
    'Valuable infrastructure private limited',
    'Design network architects private limited',
    'Neelkanth sahyadri builders private limited',
    'WILLARD INDUSTRIES PRIVATE LIMITED',
    'Ravi priya estates private limited',
    'Harinarayanan structurals private limited',
    'Mettupakkam foundations private limited',
    'Serene senior living private limited',
    'Fire luxur developers private limited',
    'S & T GLOBALENGINEERING SERVICES PRIVATE LIMITED',
    'SPINUS TECHNOLOGIES PRIVATE LIMITED',
    'Club life realtors private limited',
    'Vadan interiors private limited',
    'Supreme suyog funicular ropeways private limited',
    'Sitara realities private limited',
    'Madhu infracon private limited',
    'Starwing build-con private limited',
    'Ramasethu infrastructure private limited',
    'Eta builders private limited',
    'Malegaon manmad kopargaon infrastructure and toll road private limited',
    'B r buildcare solutions private limited',
    'Pink city expressway private limited',
    'Kajima india private limited',
    'PRAJ ENGINEERING & INFRA LIMITED',
    'A TO Z COMMERCIAL TRADES PRIVATE LIMITED',
    'Diab core materials private limited',
    'Yash corp private limited',
    'Adani mundra sez infrastructure private limited',
    'Moradabad bareilly expressway limited',
    'V4u homes private limited',
    'Goswami infratech private limited',
    'Argent properties private limited',
    'Karrm real estate private limited',
    'Rsk tech systems private limited',
    'ZETRAN TECHNOLOGIES PRIVATE LIMITED',
    'Iba particle therapy india private limited',
    'SSS SOFT SOURCE AND PRINTING SOLUTIONS PRIVATE LIMITED',
    'Aniyanta consultants limited',
    'Richard design services india private limited',
    'Optimised engineering solutions private limited',
    'Sigma allied services private limited',
    'Qminds consulting global private limited',
    'Ambe consultancy services private limited',
    'Zen skillproc private limited',
    'AXYKNO CAPITAL SERVICES Private Limited',
    'Vst electronic security private limited',
    'Future automation private limited',
    'Guava creative solutions private limited',
    'Motion makers animation studio private limited',
    'Shagoon packaging pvt ltd',
    'Sun corrupack private limited',
    'Valuable edutainment private limited',
    'Omved lifestyle private limited',
    'India fleet car rental private limited',
    'FPS PRODUCTION PRIVATE LIMITED',
    'Titbit interactive systems private limited',
    'Techno maintenance services private limited',
    'I CAN FINANCIAL PRIVATE LIMITED',
    'ADAEQUARE TECHNOLOGIES PRIVATE LIMITED',
    'Melur meadows alternative lifestyle private limited',
    'Sheer media private limited',
    'Sky architectural solutions private limited',
    'SIGNATUREGLOBAL HOMES PRIVATE LIMITED',
    'Axis securities limited',
    'S&J ENTERPRISES PRIVATE LIMITED',
    'Classic modular decor systems private limited',
    'MANDAVA COLD STORAGE PRIVATE LIMITED',
    'Nortel networks (india) private limited',
    'Triple three india energy solutions private limited',
    'Ppc broadband india private limited',
    'Amici global solutions private limited',
    'Hpl communication limited',
    'Castor engineering private limited',
    'Varuni corporate services private limited',
    'Arm peb & prefab infrastructure india private limited',
    'Hind offshore private limited',
    'Multi media hrd pvt ltd',
    'Consumer links marketing private limited',
    'Avani shelters private limited',
    'Ashok shelters private limited',
    'Maharashtra rajya itar magas vargiya vitta ani vikas mahamandal limited',
    'Suyash outsourcing private limited',
    'Ace energy infrastructure private limited',
    'MO ALTERNATE INVESTMENT ADVISORS PRIVATE LIMITED',
    'Ibruk consulting private limited',
    'KOELNMESSE PRIVATE LIMITED',
    'Dhanasha engineers private limited',
    'Nylon ring traveller private limited',
    'Excellex technologies private limited',
    'Platinumone distribution services private limited',
    'INCREDIBLE TALENT EVENT EXHIBITION MANAGEMENT PRIVATE LIMITED',
    'Scrabble digital limited',
    'ACCERON INFOSOL PRIVATE LIMITED',
    'XPERT SCIENTIFIC PRIVATE LIMITED',
    '7 peace values private limited',
    'Dial health care india private limited',
    'Groupon technologies private limited',
    'Repro applied learning solutions limited',
    'Connect professional corporate advisory services private limited',
    'Bhoomi process management private limited',
    'New horizons ship management private limited',
    'Basil club brands private limited',
    'Microfilt filter media private limited',
    'Nutriva lifesciences private limited',
    'Visas of the world private limited',
    'Neon link innovations private limited',
    'Blue planet holidays private limited',
    'Diasys diagnostics india private limited',
    'Powersun india private limited',
    'AIRPIX GEOANALYTICS PRIVATE LIMITED',
    'ASDA MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'Ak consulting private limited',
    'Glam shack fashion house private limited',
    'Pb lifestyle entertainment private limited',
    'Soft healthcare private limited',
    'Nishikawa communications india private limited',
    'Praesagus real time production optimization private limited',
    'Doo creative india private limited',
    'S.s.industries india private limited',
    'Edvantage teacher development private limited',
    'Mass trade india consultants private limited',
    'Ideas to reach india private limited',
    'JM FRICTECH INDIA PVT LTD',
    'JINDAL STAINLESS HISAR LIMITED',
    'LAHMEYER INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'LOGWELL FORGE LIMITED',
    'Kuantum Papers Ltd',
    'KNR CONSTRUCTION LIMITED',
    'MACMET INDIA LTD.',
    'MA KS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'LEMON TREE LAND and DEVELOPERS PRIVATE LIMITED',
    'Kejriwal Bee Care India Pvt Ltd',
    'KYB COMMAT PVT LTD',
    'L AND T MHPS TURBINE GENERATORS PRIVATE LIMITED',
    'LAKSHMI LIFE SCIENCES LIMITED',
    'MAG FILTERS AND EQUIPMENTS PVT LTD',
    'LUCKY PHARMACEUTICALS PVT LTD',
    'LABORATE PHARMACEUTICALS INDIA LIMITED',
    'MAGMA HOUSING FINANCE LIMITED',
    'Link quest telecom limited',
    'MAGMA ITL FINANCE LIMITED',
    'LLOYDS LINE PIPES LIMITED',
    'LAKSHMI PRECISION TOOLS LIMITED',
    'LANCER FOOTWEAR INDIA PVT LTD',
    'KEVA FLAVOURS PVT LTD',
    'kf bioplants pvt ltd',
    'LALIT PIPES & PIPES LIMITED',
    'LUK INDIA PRIVATE LTD',
    'L & T PANIPAT ELEVATED CORRIDOR LIMITED',
    'KNORR BREMSE INDIA PRIVATE LIMITED',
    'LAKSHMI RING TRAVELLERS (COIMBATORE) LIMITED',
    'KROSS MANUFACTURERS (INDIA) PRIVATE LIMITED',
    'LANCO TANJORE POWER COMPANY LIMITED',
    'Kings safetywear (india) private limited',
    'M.SURESH JEWELLERY PRIVATE LIMITED',
    'KONKAN STORAGE SYSTEMS KOCHI PRIVATE LIMITED',
    'L and T SOUTH CITY PROJECTS LTD',
    'L&T KRISHNAGIRI WALAJAHPET TOLLWAY LIMITED',
    'L and T Sambalpur Rourkela Tollway Limited',
    'LINNHOFF INDIA PRIVATE LIMITED',
    'LUCID COLLOIDS LIMITDÃ‚Â Ã‚Â Ã‚Â Ã‚Â',
    'KAYNES TECHNOLOGY INDIA PVT LTD',
    'KLAUS MULTIPARKING SYSTEM PVT LTD',
    'Brightcom Group Ltd',
    'KINTECH SANTALPUR WINDPARK PRIVATE LIMITED',
    'LEAN AUTOMATION EQUIPMENTS PRIVATELIMITED',
    'KJS CEMENT LTD',
    'KONSTELEC ENGINEERS PRIVATE LIMITED',
    'KRYSTAL INTEGRATED SERVICES PRIVATE LIMITED',
    'KIM ENG SECURITIES INDIA PRIVATE LIMITED',
    'LOHIYA EDIBLE OILS PVT LTD',
    'LODHA DEVELOPERS PRIVATE LIMITED',
    'LCL LOGISTIX INDIA PRIVATE LIMITED',
    'M3M INDIA PVT LTD',
    'KERRY INDEV LOGISTICS PVT LTD',
    'KOLTE-PATIL I-VEN TOWNSHIPS (PUNE) LIMITED',
    'KEYSTONE REALTORS PRIVATE LIMITED',
    'KELLY SERVICES INDIA PRIVATE LTD',
    'KRISHI RASAYAN EXPORTS PVT LTD',
    'LAFARGE AGGREGATES & CONCRETE INDIA PRIVATE LIMITED',
    'KOENIG SOLUTIONS LIMITED',
    'LAMTUF PLASTICS LIMITED',
    'LODHA HEALTHY CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED',
    'KUNVARJI WAREHOUSING AND LOGISTICS PVT LTD',
    'KUSHAL TRADELINK LIMITED',
    'LAMA RICE PRIVATE LTD',
    'Lok Chemicals Pvt Ltd',
    'KOCH CHEMICAL TECHNOLOGY GROUP INDIA PRIVATE LIMITED',
    'M S KHURANA ENGINEERING LIMITED',
    'M K U PRIVATE LIMITED',
    'KKSPUN INDIA PRIVATE LIMITED',
    'LOOCUST INCORP APPAREL EXPORT PRIVATELIMITED',
    'Lenovo global technology india private limited',
    'KPIT ENGINEERING LIMITED',
    'LEAR ORAGADAM AUTOMOTIVE INDIA PRIVATE LIMITED',
    'LOKHANDWALA CONSTRUCTION INDUSTRIES PRIVATE LTD',
    'MADHAV ALLOYS PVT LTD',
    'MINDA FURUKAWA ELECTRIC PRIVATE LIMITED',
    'MAN DIESEL & TURBO INDIA PRIVATE LIMITED',
    'MANTRI PRIMUS LIFESPACES PRIVATE LIMITED',
    'MINDARIKA PRIVATE LIMITED',
    'MINDA EMER TECHNOLOGIES Limited',
    'MODELAMA EXPORTS LIMITED',
    'MODI MUNDIPHARMA PRIVATE LIMITED',
    'MERIDIAN MEDICAL RESEARCH AND HOSPITAL LTD',
    'MALAR PUBLICATIONS PVT LTD',
    'MAHINDRA BEBANCO DEVELOPERS LIMITED',
    'MARIKAR MOTORS LTD',
    'MATERIALS CHEMICALS AND PERFORMANCE INTERMEDIARIES PRIVATE LIMITED',
    'Minera steel and power pvt limited',
    'MAGNETI MARELLI POWERTRAIN INDIA PRIVATE LIMITED',
    'MOHAN MUTHA EXPORTS PVT LTD',
    'MEGHMANI INDUSTRIES LTD',
    'MEKINS INDUSTRIES LIMITED',
    'MITSUBA SICAL INDIA PRIVATE LIMITED',
    'MASU BRAKES PVT LTD',
    'MECON LTD',
    'MEDLEY Pharmaceuticals ltd',
    'MFX INFOTECH PVT LTD',
    'MAX PUBLICITY AND COMMUNICATION PRIVATE LIMITED',
    'MOMENTIVE PERFORMANCE MATERIALS INDIA P LTD',
    'MASHOBRA RESORT LTD',
    'MERCATOR LIMITED',
    'MCKINSEY KNOWLEDGE CENTRE INDIA PRIVATE LIMITED',
    'manipal global education services pvt ltd',
    'META ROLLS & COMMODITIES PRIVATE LIMITED C/N',
    'MANAKSIA COATED METALS AND INDUSTRIES LIMITED',
    'MERCURY TRAVELS LTD',
    'MEGHMANI FINECHEM LIMITED',
    'MAX INFRA (I) LIMITED',
    'MINDCHAMPION LEARNING SYSTEMS LIMITED',
    'MAHINDRA SHUBHLABH SERVICES LIMITED',
    'Matrix fine sciences private limited',
    'MANHATTAN ASSOCIATES (INDIA) DEVELOPMENT CENTRE PVT LTD ISC',
    'MAGNETI MARELLI INDIA PRIVATE LIMITED',
    'MAHLE HOLDING INDIA PRIVATE LIMITED',
    'MARUBENI ITOCHU STEEL INDIA PRIVATE LIMITED',
    'MERCURY MANUFACTURING COMPANY LIMITED',
    'MAHALAKSHMI INFRAPROJECTS LIMITED',
    'MAGNETI MARELLI MOTHERSON AUTO SYSTEM PVT LTD',
    'Mercator Info services India Pvt Ltd',
    'Mahindra Defence Naval Systems Pvt Ltd',
    'Mahindra sanyo special steel private limited',
    'MECHVAC INDIA LTD',
    'MODI CAR AGENCIES PVT LTD',
    'MICRO HOUSING FINANCE CORPORATION LIMITED',
    'MILLENNIUM ENGINEERS AND CONTRACTORS LIMITED',
    'MAHENDRA SPONGE AND POWER LTD.',
    'MOFLEX SUSPENSIONS PRIVATE.LIMITED',
    'MAHENDRA BROTHERS EXPORTS PVT LTD',
    'MAJOR BRANDS (INDIA) PRIVATE LIMITED',
    'MAN TRUCKS INDIA PRIVATE LIMITED',
    'METRO GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'MICRO FOCUS INDIA PRIVATE LIMITED',
    'Mmodal global services private limited',
    'MINDA INDUSTRIES LIMITED',
    'METSO INDIA PRIVATE LTD',
    'MANJUL PUBLISHING HOUSE PVT LTD',
    'MATRIMONY COM LIMITED',
    'MARVEL VINYLS LIMITED',
    'Mira Exim Limited',
    'MAHLE FILTER SYSTEMS (INDIA) Private Limited',
    'MALIK LIFESCIENCES PVT LTD',
    'MIDCO LIMITED',
    'MAJESCO LIMITED',
    'Neccon Power and Infra Ltd',
    'MYND SOLUTIONS PVT LTD',
    'mundial export import finame pvt limited',
    'OM METALS INFRAPROJECTS LIMITED',
    'NIKHIL ADHESIVES LTD',
    'NIS MANAGEMENT PVT LTD',
    'Neotia healthcare initiative limited',
    'NRB IBC BEARINGS PRIVATE LIMITED',
    'NGA HR INDIA PRIVATE LIMITED',
    'OLYMPIA TECH PARK CHENNAI PRIVATE LIMITED',
    'OKAYA POWER PRIVATE LTD',
    'NTL ELECTRONICS INDIA LIMITED',
    'NIPHA EXPORTS PVT LTD',
    'OAT and IIL INDIA LABORATORIES PRIVATE LIMITED',
    'NAMAKKAL TRANSPORT CARRIERS PRIVATE LIMITED',
    'NLMK INDIA SERVICE CENTER PRIVATE LTD',
    'MUMBAI NASIK EXPRESSWAY LIMITED',
    'NIDEC INDUSTRIAL AUTOMATION INDIA PVT LTD',
    'MSD PHARMACEUTICALS PVT LTD',
    'Mwv india paperboard packaging private limited',
    'OLIVE BAR AND KITCHEN PRIVATE LIMITED',
    'NET 9 ONLINE HATHWAY PRIVATE LIMITED',
    'NASDAQ CORPORATE SOLUTIONS INDIA PRIVATE LIMITED',
    'MYK SPINNING INDUSTRIES LIMITED',
    'NARNOLIA FINANCIAL ADVISORS LIMITED',
    'NGL FINE CHEM LIMITED',
    'Nilkamal bito storage systems private limited',
    'NCL WINTECH INDIA LIMITED',
    'NITIN FIRE PROTECTION INDUSTRIES LIMITED',
    'NAVKAR TERMINALS LIMITED',
    'Nash Industries I Pvt Ltd',
    'MPS TELECOM RETAIL PVT LTD',
    'Nedcommodities india private limited',
    'NARAYANA LEARNING PRIVATE LIMITED',
    'Mothersonsumi infotech and designs limited',
    'MOTOR WORLD PVT LTD',
    'NETPULSE COMMUNICATIONS INDIA PRIVATE LIMITED',
    'MY HOME CONSTRUCTIONS PVT LTD',
    'NXTGEN DATACENTER AND CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'NCL ALLTEK & SECCOLOR LIMITED',
    'OILFIELD SERVICES AND SUPPLIES INDIA PRIVATE LIMITED',
    'OLAM INFORMATION SERVICES PRIVATE LIMITED',
    'MUMBAI METRO ONE PRIVATE LIMITED',
    'Nandi Economic Corridor Enterprises Limited',
    'NaGASE india pvt limited',
    'NALCO WATER INDIA LIMITED',
    'NAVAYUGA DEVANAHALLI TOLLWAY PRIVATE LIMITED',
    'NAVAYUGA BENGALOORU TOLLWAY PRIVATE LTD',
    'MYSTIFLY CONSULTING INDIA PRIVATE LIMITED',
    'OMKAR REALTORS AND DEVELOPERS PRIVATE LIMITED',
    'NEOGEN CHEMICALS LTD',
    'NIELSEN INDIA PRIVATE LIMITED',
    'MYTRAH ENERGY (INDIA) LIMITED',
    'NTT DATA INFORMATION PROCESSING SERVICES PRIVATE LIMITED',
    'NTN BEARING INDIA PVT LTD',
    'MOTILAL OSWAL WEALTH MANAGEMENT LIMITED',
    'NETMAGIC IT SERVICES PRIVATE LIMITED',
    'NETMATRIX CROP CARE LIMITED',
    'NITIN CASTINGS PRIVATE LIMITED',
    'NIF PRIVATE LTD',
    'OBEETEE TEXTILES PRIVATE LIMITED',
    'NINA WATERPROOFING SYSTEMS PRIVATE LIMITED',
    'N RANGA RAO and SONS PRIVATE LTD',
    'NORTH EASTERN CARRYING CORPN.LTD.',
    'MUKESH INDUSTRIES LIMITED',
    'ORACLE OFSS BPO SERVICES LIMITED',
    'P C CHANDRA JEWELLERS PRIVATE LIMITED',
    'PEST CONTROL INDIA PRIVATE LIMITED',
    'Padmini vna mechatronics private limited',
    'P and C PROJECTS PRIVATE LIMITED',
    'PARMANAND AND SONS FOOD PRODUCTS PRIVATE LIMITED',
    'OREN HYDROCARBONS PRIVATE LIMITED',
    'ORIENT REFRACTORIES LIMITED',
    'PHILLIPS CARBON BLACK LTD',
    'ORBIT BEARINGS INDIA PRIVATE LIMITED',
    'PHOENIX CONVEYOR BELT INDIA (P) LTD.',
    'Patel Infrastructure pvt ltd',
    'POLYSIL IRRIGATION SYSTEMS PRIVATE LIMITED',
    'PHOENIX INDUSTRIES PRIVATE LIMITED',
    'ORIGIN ITFS PRIVATE LIMITED',
    'OXIGEN SERVICES INDIA PRIVATE LIMITED',
    'PASA RESOURCES PVT LTD',
    'PLENTEOUS PHARMACEUTICALS LTD',
    'PIONEER INDUSTRIES LTD',
    'PARAMOUNT PROPBUILD PVT LTD',
    'POSH CHEMICALS PRIVATE LIMITED',
    'PAUL RESORTS AND HOTELS PRIVATE LIMITED',
    'OWENS CORNING INDIA PRIVATE LIMITED',
    'POSCO ENGINEERING AND CONSTRUCTION INDIA PRIVATE LIMITED',
    'OVERSEAS INFRASTRUCTURE ALLIANCE INDIA PRIVATE LIMITED',
    'PETRONET MHB LTD',
    'PATEL REALTY (INDIA) LIMITED',
    'PL WORLDWAYS LIMITED',
    'PAYPAL INDIA PRIVATE LTD',
    'PARIN FURNITURE PRIVATE LIMITED',
    'PACE POWER SYSTEMS PRIVATE LIMITED',
    'PMJ GEMS AND JEWELLERS PVT LTD',
    'PATIL RAIL INFRASTRUCTURE PVT LTD',
    'PASHUPATI CAPITAL SERVICES PRIVATELIMITED',
    'PAWAR ELECTRO SYSTEMS PRIVATE LIMITED',
    'POSCO ELECTRICAL STEEL INDIA PRIVATE LIMITED',
    'PARTHENON INDIA PVT LTD',
    'OSHKOSH INDIA PRIVATE LIMITED',
    'PACIFICA INDIA PROJECTS PRIVATE LIMITED',
    'PEOPLE COMBINE BENGALURU KNOWLEDGE INSTITUTIONS PRIVATE LIMITED',
    'PEOPLE COMBINE EDUCATIONAL INITIATIVES LIMITED',
    'PHI SEEDS PRIVATE LIMITED',
    'Orion mall management company limited',
    'Polyhose india Private ltd',
    'PHOENIX LAMPS LIMITED',
    'POLICYBAZAAR INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'POSCO INDIA AHMEDABAD STEEL PROCESSING CENTER PRIVATE LIMITED',
    'PCL OIL AND SOLVENTS LIMITED',
    'ORANGE RENEWABLE POWER PRIVATE LIMITED',
    'PAHARPUR INDUSTRIES LTD',
    'PIONEER POLYLEATHERS LIMITED',
    'POSCO DAEWOO INDIA PRIVATE LIMITED',
    'PHILIPS HOME CARE SERVICES INDIA PRIVATELIMITED',
    'Oscar Investments Ltd',
    'PUDUMJEE INDUSTRIES LIMITED',
    'PUDUMJEE PULP AND PAPER MILLS LIMITED',
    'RASANDIK AUTO COMPONENTS PVT LTD',
    'R G SCIENTIFIC ENTERPRISES PRIVATE LIMITED',
    'RALSON INDIA LIMITED',
    'PVR BLUO ENTERTAINMENT LIMITED',
    'R R SEN AND BROS PRIVATE LIMITED',
    'PRIMACY INDUSTRIES LIMITED',
    'R S INFRAPROJECTS PVT LTD',
    'RAJESH MOTORS RAJASTHAN PRIVATE LIMITED',
    'RAJOO ENGINEERS LTD',
    'Pragati agri products pvt ltd',
    'RAKESH MASALA PVT LTD',
    'QUADRANT EPP SURLON INDIA LIMITED',
    'PREMIUM TRANSMISSION LIMITED',
    'RANDOM HOUSE PUBLISHERS INDIA PRIVATE LIMITED',
    'R S SOFTWARE INDIA LTD',
    'RANE MADRAS LIMITED',
    'PRIME KI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'RAJ WESTPOWER T LTD',
    'Rajaguru Spinning mills Pvt Ltd',
    'R R INNOVATIVE PRIVATE LIMITED',
    'PUSHPIT STEEL PRIVATE LIMITED',
    'PRINCE PIPES AND FITTINGS PRIVATE LIMITED',
    'R E ROGERS INDIA PRIVATE LIMITED',
    'RASI TEX INDIA PRIVATE LIMITED',
    'PRABHAT RESOURCES LIMITED',
    'PRECOT MERIDIAN LIMITED',
    'RAJESH CARGO MOVERS (INDIA) PRIVATELIMITED',
    'RAGHUKUL SHARES INDIA PRIVATE LIMITED',
    'RANE T4U PRIVATE LIMITED',
    'PRESTIGE GARDEN CONSTRUCTIONS PRIVATE LIMITED',
    'RAJAPALAYAM MILLS LTD',
    'RAIA JEWELS PRIVATE LIMITED',
    'RAMKY ENVIRO ENGINEERS LIMITED',
    'RAI SAHEB REKH CHAND MOHOTA SPG AND WVG MILLS LIMITED',
    'PRUDENT INSURANCE BROKERS PRIVATELIMITED',
    'R K SWAMY BBDO PRIVATE LIMITED',
    'PRABHAT TELECOMS INDIA LIMITED',
    'PRIME FOCUS TECHNOLOGIES PVT LTD',
    'PRECIPART INDIA PRIVATE LIMITED',
    'PURANIK BUILDERS PRIVATE LIMITED',
    'PRICEWATERHOUSECOOPERS SERVICE DELIVERY CENTER KOLKATA PRIVATE LIMITED',
    'QUEST GLOBAL ENGINEERING SERVICES P LTD',
    'PUNCH RATNA FASTENERS PVT LTD',
    'PREMIER POLYFILM LTD',
    'PRATAAP SNACKS PRIVATE LIMITED',
    'PRAKASH ASPHALTINGS AND TOLL HIGHWAYS(INDIA) LIMITED',
    'PRABHAT DAIRY LIMITED',
    'PRIMA TELECOM LIMITED',
    'progression infonet pvt ltd',
    'PSYCHOTROPICS INDIA LTD',
    'RAJ CHOPRA AND COMPANY PRIVATE LIMITED',
    'Presence OF IT India Pvt Ltd',
    'SAM INDIA BUILTWELL PVT LTD',
    'SANDEN VIKAS INDIA PRIVATE LIMITED',
    'SAMHI HOTELS PRIVATE LIMITED',
    'RAYS POWER INFRA PRIVATE LIMITED',
    'SALARPURIA PROPERTIES PVT LTD',
    'SANDARBH FOODS PVT LTD',
    'RUCHI MALLS PRIVATE LTD',
    'RELIGARE VENTURE CAPITAL LIMITED',
    'REFEX ENERGY LIMITED',
    'SAI FERTILIZERS AND PHOSPHATES PVT LTD',
    'RUBAMIN LIMITED',
    'SAARTHAK VANIJYA INDIA LIMITED',
    'Roop rubber mills limited',
    'RUBBERKING TYRES INDIA PRIVATE LIMITED',
    'RONUPLATE PRIVATE LIMITED',
    'RATNADEEP SUPER MARKET PRIVATE LIMITED',
    'RNS INFRASTRUCTURE LTD',
    'RUCHI HI RICH SEEDS PRIVATE LIMITED',
    'SANMAN TRADE IMPEX LTD',
    'RUCHI STRIPS AND ALLOYS LIMITED',
    'RKS MOTOR PVT LTD',
    'RAVINDRANATH GE MEDICAL ASSOCIATES PRIVATE LIMITED',
    'REVATHI EQUIPMENT LIMITED',
    'Renaissance jewellery limited',
    'REGUS BUSINESS CENTRE PUNE PRIVATE LIMITED',
    'REVIVE CONSTRUCTION COMPANY INDIA PRIVATE LIMITED',
    'S.j.s. enterprises private limited',
    'RISHABH INSTRUMENTS PVT LTD',
    'ROOTS INDUSTRIES INDIA LIMITED',
    'S P MANI AND MOHAN DAIRY INDIA PRIVATE LIMITED',
    'RITTAL INDIA PVT LTD',
    'RISHAB APPAREL PRIVATE LIMITED',
    'RISHABH METALS AND CHEMICALS PRIVATE LIMITED',
    'ROYAL TRANSLINES PVT LTD',
    'S V CREDITLINE PRIVATE LIMITED',
    'RELIANCE JIO DIGITAL SERVICES LIMITED',
    'rose engineered products india pvt ltd',
    'RUCHIRA PAPERS LTD',
    'S P APPARELS LIMITED',
    'SALESFORCE COM INDIA PVT LTD',
    'SAHYADRI HOSPITALS LIMITED',
    'RS BROTHERS RETAIL INDIA PRIVATE LIMITED',
    'RAVALI SPINNERS PVT LTD.,',
    'Rinder india private limited',
    'rga software systems pvt ltd',
    'RATNAMANI HEALTHCARE PRIVATE LIMITED',
    'Renfro india private limited',
    'SAMI LABS LIMITED',
    'ROLTA BI and BIG DATA ANALYTICS PRIVATE LIMITED',
    'SANSERA ENGINEERING PRIVATE LIMITED',
    'ROYALOAK STEELS PRIVATE LIMITED',
    'SAHAJANAND MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'RUSTOMJEE CONSTRUCTIONS PRIVATE LIMITED',
    'ROX TRADING AND SYSTEMS PRIVATE LIMITED',
    'SAMHI HOTELS AHMEDABAD PRIVATE LIMITED',
    'RELIABLE EXPORTS INDIA PRIVATE LIMITED',
    'RUSTAM FOODS PRIVATE LTD',
    'SANDS INFRABUILD PRIVATE LIMITED',
    'RISING STARS MOBILE INDIA PRIVATE LIMITED',
    'REED MANCH EXHIBITIONS PVT LTD',
    'SAKATA INX INDIA PRIVATE LIMITED',
    'RYKER BASE PRIVATE LIMITED',
    'RUBBERKING TYRE QUALITY PRODUCTS PRIVATELIMITED',
    'SAHELI EXPORTS PRIVATE LIMITED',
    'S C JOHNSON PRODUCTS PRIVATE LIMITED',
    'SHARMAN UDYOG PVT LTD',
    'SERCO INTEGRATED TRANSPORT PRIVATE LIMITED',
    'SCHOTT KAISHA PRIVATE LIMITED',
    'SIDDHI VINAYAK KNOTS AND PRINTS PRIVATE LIMITED',
    'SE FORGE LTD',
    'SEABRIDGE MARITIME AGENCIES PRIVATE LIMITED',
    'SEW EURODRIVE INDIA PRIVATE LIMITED',
    'sanyog enterprises pvt ltd',
    'SHATRANJ TRADING PVT LTD',
    'SHINGORA TEXTILES LIMITED',
    'SCJ PLASTICS LIMITED',
    'SAVEMAX WHOLESALE CLUB PRIVATE LIMITED',
    'SHUBHAM HOUSING DEVELOPMENT FINANCE COMPANY PRIVATE LIMITED',
    'SENTINI SANITARYWARES PRIVATE LIMITED',
    'Semillas Fito India Pvt Ltd',
    'SHREEJI PESTICIDES PVT LTD',
    'SHILLONG EXPRESSWAY PVT.LTD',
    'SATTVA ETECH INDIA PRIVATE LIMITED',
    'SERVICE MASTER CLEAN LIMITED',
    'SHAHLON SILK INDUSTRIES PRIVATE LIMITED',
    'SAURASHTRA ENVIRO PROJECTS PRIVATELIMITED',
    'SAS HOTELS and ENTERPRISES LIMITED',
    'shree malani foams pvt ltd',
    'SHIVASHAKTI BIO TECHNOLOGIES LIMITED',
    'SCHUTZ DISHMAN BIOTECH LIMITED',
    'SBS TRANSPOLE LOGISTICS PVT LTD',
    'SHRISTI HOUSING DEVELOPMENT LIMITED',
    'SATTVA HI TECH AND CONWARE PRIVATE LIMITED',
    'SHV LPG INDIA PRIVATE LIMITED',
    'SCA HYGIENE PRODUCTS INDIA PRIVATE LIMITED',
    'SHYAMARAJU AND COMPANY INDIA PVT LTD',
    'SE BLADES LIMITED',
    'SE Electricals limited',
    'SFP SONS INDIA PRIVATE LIMITED',
    'SGD PHARMA INDIA LIMITED',
    'SEA CONSORTIUM SHIPPING INDIA PRIVATE LIMITED',
    'SHRIRAM PROPERTIES PRIVATE LIMITED',
    'SEOYON E HWA AUTOMOTIVE INDIA PRIVATE LIMITED',
    'SARGAM INDIA ELECTRONICS PVT LTD',
    'SERVION T GLOBAL SOLUTIONS LIMITED',
    'SHRI GOVINDARAJA TEXTILES PRIVATE LIMITED',
    'SHUBHAM CIVIL PROJECTS PRIVATE LIMITED',
    'SHAKTHI KNITTING LIMITED',
    'SATEC ENVIR ENGINEERING INDIA PRIVATE LIMITED',
    'SCHNEIDER ELECTRIC SYSTEMS INDIA PVT LTD',
    'SHREE VAISHNAV INDUSTRIES PRIVATELIMITED',
    'SENSES PHARMACEUTICALS LIMITED',
    'SHILPI JEWELLERS PRIVATE LIMITED',
    'SHAKUN POLYMERS LIMITED',
    'SHREE PUSHKAR CHEMICAL FERTILIZER LTD',
    'SHREE R N METALS INDIA PRIVATE LIMITED',
    'SHANTHA BIOTECHNICS PRIVATE LIMITED',
    'SAPPHIRE FOODS INDIA PRIVATE LIMITED',
    'SCHWING STETTER INDIA PRIVATE LIMITED',
    'SHRI KAILASH LOGISTICS LIMITED',
    'Speedcrafts ltd',
    'Smc comtrade limited',
    'SONEAR INDUSTRIES LIMITED',
    'Stumpp Schuele and somappa Auto Suspension Systems Private Limited',
    'SPPL HOTELS PVT LTD',
    'STAR WIRE INDIA LIMITED',
    'SKH MAGNETI MARELLI EXHAUST SYSTEMS PVT LTD',
    'SULZER PUMPS INDIA LIMITED',
    'SOGEFI MNR ENGINE SYSTEMS INDIA PRIVATE LIMITED',
    'SRINIVASA HATCHERIES LIMITED',
    'srinivasa farms pvt ltd',
    'SONA FUJI KIKO AUTOMOTIVE LIMITED',
    'SREE JAYAJOTHI CEMENTS PVT LTD',
    'SUKHBIR AGRO ENERGY LIMITED',
    'SPENCER S RETAIL LIMITED',
    'SRL DIAGNOSTICS PRIVATE LIMITED',
    'SPICER INDIA PRIVATE LIMITED',
    'SNAM ALLOYS PVT LTD',
    'south west mining limited',
    'SIRCOLOR WOOD COATINGS PRIVATE LIMITED',
    'SOUTH CITY PROJECTS KOLKATA LTD',
    'SMRC AUTOMOTIVE PRODUCTS INDIA PRIVATE LIMITED',
    'SMS INTEGRATED FACILITY SERVICES PVT LTD',
    'Sterling & wilson energy systems private limited',
    'SONY PICTURES NETWORKS INDIA PVT LTD',
    'STERLING AND WILSON POWERGEN PRIVATE LIMITED',
    'SUASTH HEALTH CARE INDIA PRIVATE LIMITED',
    'SUAM OVERSEAS PVT LTD',
    'SUJAN COOPER STANDARD AVS PVT LTD',
    'SOUTH WEST PINNACLE EXPLORATION PRIVATE LIMITED',
    'STENCIL ENGINEERING PVT LTD',
    'STARWOOD HOTELS AND RESORTS INDIA PRIVATE LIMITED',
    'ST JUDE MEDICAL INDIA PRIVATE LIMITED',
    'SIGNALS AND SYSTEMS (INDIA) PRIVATELIMITED',
    'SOTC TRAVEL SERVICES PRIVATE LIMITED',
    'STRATEGIC OUTSOURCING SERVICES PRIVATE LIMITED',
    'SRS LIMITED',
    'SMALL BIZ EXPRESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SODEXO FOOD SOLUTIONS INDIA PRIVATE LIMITED',
    'SNC LAVALIN ENGINEERING INDIA PVT LTD',
    'Sqs india bfsi limited',
    'SMARTCHEM TECHNOLOGIES LIMITED',
    'SII INDIA IT & ENGINEERING SERVICES PVT LTD',
    'SPECTRUM POWER GENERATION LTD.',
    'Spice Mobility Limited',
    'SMC FOODS LTD',
    'SRL REACH LIMITED',
    'SONIC BIOCHEM EXTRACTIONS LIMITED',
    'simran farms ltd',
    'SNEHA FOODS AND FEEDS PRIVATE LIMITED',
    'SIEMENS WIND POWER PVT LTD',
    'SOLARA ACTIVE PHARMA SCIENCES LTD',
    'SIGMA CORPORATION INDIA LIMITED',
    'T R Sawhney Motors Private Limited',
    'Times jobs limited',
    'sunbeam real ventures pvt ltd',
    'SUNDARAM BNP PARIBAS FUND SERVICES LIMITED',
    'TCNS CLOTHING CO. LIMITED',
    'TAXMANN PUBLICATION PVT LTD',
    'TEX CORP LIMITED',
    'Super plastronics private limited',
    'SUPAMA FOREX PRIVATE LIMITED',
    'TENNECO AUTOMOTIVE INDIA PRIVATE LTD',
    'TECHNIP INDIA LIMITED',
    'SWISS GLASCOAT EQUIPMENTS LIMITED',
    'TECHFAB INDIA INDUSTRIES LIMITED',
    'TBZ NIRMAL ZAVERI P LTD',
    'THE KCP LIMITED',
    'SYLVAN PLYBOARD INDIA PRIVATE LIMITED',
    'TATA CERAMICS LIMITED',
    'Thirumeni finance pvt ltd',
    'Tarish Investment and trading company private Ltd',
    'SUTHERLAND HEALTHCARE SOLUTIONS PRIVATELIMITED',
    'SYNTHOKEM LABS PVT LTD',
    'SURANA CORPORATION LIMITED',
    'TERRATECH CHEMICALS INDIA PRIVATE LIMITED',
    'TATA INTERNET SERVICES LIMITED',
    'SURVIVAL TECHNOLOGIES PRIVATE LIMITED',
    'SWISS SINGAPORE INDIA PRIVATE LIMITED',
    'TIRUPATI INKS LIMITED.',
    'T AND T INFRA PVT LTD',
    'TATA AUTOCOMP GY BATTERIES PVT LTD',
    'sun polytex pvt ltd',
    'TDI INFRACORP INDIA LTD',
    'T C TERRYTEX LTD',
    'SUPRATECH MICROPATH LABORATORY AND RESEARCH INSTITUTE PRIVATE LIMITED',
    'SWARNA PRAGATI HOUSING MICROFINANCEPRIVATE LIMITED',
    'SWARAJ INDIA INDUSTRIES LIMITED',
    'systematic industries pvt ltd',
    'TECHNO PROCESS EQUIPMENTS INDIA PRIVATE LIMITED',
    'SUZLON ENERGY LTD',
    'TENOVA INDIA P LTD',
    'SYRMA TECHNOLOGY PRIVATE LIMITED',
    'SWETA ESTATES PVT LTD',
    'T AND T MOTORS PRIVATE LIMITED',
    'Supreme transport organisation private Ltd',
    'TATA AIG GENERAL INSURANCE COMPANYLIMITED',
    'SWISS PARENTERALS PRIVATE LIMITED',
    'TBEA ENERGY INDIA PRIVATE LIMITED',
    'SVG FASHIONS LIMITED',
    'THEJO ENGINEERING LTD',
    'TAMILNADU WASTE MANAGEMENT LIMITED',
    'SURAT TEXTILE MILLS LIMITED',
    'THALES INDIA PVT LTD',
    'THE CATHOLIC SYRIAN BANK LTD',
    'TATA INTERNATIONAL DLT PRIVATE LIMITED',
    'SYMANTEC SOFTWARE INDIA PRIVATE LIMITED',
    'TIRTH AGRO TECHNOLOGY PVT LTD',
    'SUNGWOO HITECH INDIA LIMITED',
    'SYNOPSYS INDIA PRIVATE LIMITED',
    'SYMANTEC SOFTWARE AND SERVICES INDIA PRIVATE LIMITED',
    'TCG FACILITIES MANAGEMENT SERVICES PVT LTD',
    'THREADS INDIA LTD',
    'Veeline media limited',
    'UTTAM SUGAR MILLS LTD',
    'Vibhor steel tubes private limited',
    'UPPAL-CHADHA HI-TECH DEVELOPERS PRIVATELIMITED',
    'TRIDENT LTD',
    'TVS INVESTMENTS LIMITED',
    'TRANSLINE TECHNOLOGIES PRIVATE LIMITED',
    'UNIVERSAL POWER SYSTEMS PRIVATE LIMITED',
    'VALUE EDGE RESEARCH SERVICES PVT LTD',
    'TITANIUM EQUIPMENT & ANODE MANUFACTURING COMPANY LIMITED',
    'TV TODAY NETWORK LIMITED',
    'VERTELLUS SPECIALTY MATERIALS (INDIA) PRIVATE LIMITED',
    'TITAN PAINTS AND CHEMICALS LIMITED',
    'VIHAAN NETWORKS LTD',
    'VALIANT GLASS WORKS PRIVATE LIMITED',
    'VIDEOCON D2H LIMITED',
    'Ups jetair express private limited',
    'V S T and SONS PRIVATE LIMITED',
    'Uniroyal Industries Ltd',
    'URJA PRODUCTS PVT LTD',
    'UNIVERSAL PRECISION SCREWS PRIVATELIMITED',
    'VIJAYA DIAGNOSTIC CENTRE PRIVATE LIMITED',
    'vikram solar pvt ltd',
    'UNI DESIGN JEWELLERY PRIVATE LIMITED',
    'UNIPLY INDUSTRIES LIMITED',
    'UST GLOBAL TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'TVS UPASANA LTD',
    'vestas wind technology india pvt ltd',
    'VASANT CHEMICALS PVT LTD',
    'Tuaman Engineering Ltd',
    'TOJO VIKAS INTERNATIONAL PVT LTD',
    'VELANKANI INFORMATION SYSTEMS LIMITED',
    'Vanita Agrochem India Pvt Ltd',
    'UTTAM GALVA METALLICS LIMITED',
    'VIJAY HOME APPLIANCES LIMITED',
    'VADINAR PORTS & TERMINALS LIMITED',
    'Vertex customer management india private limited',
    'UNILINE ENERGY SYSTEMS PVT LTD',
    'Vidal Health insurance tpa pvt ltd',
    'VEEKESY FOOTCARE INDIA PRIVATE LIMITED',
    'UNILEVER INDUSTRIES PRIVATE LTD',
    'UTKARSH INDIA LTD',
    'TVS INFRASTRUCTURE PRIVATE LIMITED',
    'UCAL FUEL SYSTEMS LIMITED',
    'TOTAL OIL INDIA PRIVATE LIMITED',
    'UM INDIA TWO WHEELERS PRIVATE LIMITED',
    'VERIZON COMMUNICATIONS INDIA PVT LTD',
    'VARRSANA ISPAT LTD',
    'U A E EXCHANGE AND FINANCIAL SERVICESLIMITED',
    'vashi electricals private limited',
    'TITAN LABORATORIES PVT LTD',
    'VEDANT FASHIONS PRIVATE LIMITED',
    'TURNER INTERNATIONAL INDIA PRIVATE LIMITED',
    'UNI-COM INDIA PVT LTD',
    'VEEDA CLINICAL RESEARCH PRIVATE LIMITED',
    'VERDANTIS TECHNOLOGIES PRIVATE LIMITED',
    'TML DRIVELINES LIMITED',
    'TRION PROPERITIES PRIVATE LIMITED',
    'VALEO INDIA PVT LTD',
    'TOMEN ELECTRONICS INDIA PRIVATE LIMITED',
    'UPDATER SERVICES PRIVATE LIMITED',
    'VARIAN MEDICAL SYSTEMS INTERNATIONAL INDIA PRIVATE LIMITED',
    'TRANSLINE AIR CARGO SERVICES PVT LTD',
    'VERIFICORP CREATIVE SERVICES INDIA PRIVATE LIMITED',
    'VEEKESY SANDALS INDIA PVT LTD',
    'UT WORLDWIDE (INDIA) PRIVATE LIMITED',
    'UTV SOFTWARE COMMUNICATIONS LIMITED',
    'TT NETWORK INTEGRATION INDIA PVT LTD',
    'VAMONA DEVELOPERS PVT LTD',
    'TWG WARRANTY SERVICES INDIA PRIVATE LIMITED',
    'TORAY KUSUMGAR ADVANCED TEXTILE PVT LTD',
    '4I ODC PRIVATE LIMITED',
    'A N E INDUSTRIES PRIVATE LIMITED',
    'VK ASSOCIATES PRIVATE LIMITED',
    'A T O I LTD',
    'Visu leasing and finance private limited',
    'WIN MEDICARE PRIVATE LIMITED',
    'XL LABORATORIES PVT LTD',
    'Yogya enterprises limited',
    'WILLIAMS SONOMA INDIA PRIVATE LIMITED',
    'A K SURYA POWER MAGIC PVT LTD',
    'ZONAC KNITTING MACHINES PVT',
    'Visage holdings and finance private limited',
    'WIPRO CONSUMER CARE LIMITED',
    'A RAYMOND FASTENERS INDIA PRIVATE LIMITED',
    'VNR SEEDS PVT LTD',
    'YAAGANTI SEEDS PRIVATE LIMITED',
    'Zaggle prepaid ocean services private limited',
    'Y TEC INDIA PRIVATE LIMITED',
    'VITEOS CAPITAL MARKET SERVICES LIMITED',
    '8K MILES SOFTWARE SERVICES LIMITED',
    'WAY2WEALTH REALTY ADVISORS PRIVATE LIMITED',
    'VIRGO VALVES & CONTROLS PRIVATE LIMITED',
    'VISHVARAJ INFRASTRUCTURE LTD',
    'ZEON LIFESCIENCES LTD',
    'VIRCHOW LABORATORES LIMITED',
    'VILLAGE FINANCIAL SERVICES PVT LTD',
    '20 CUBE LOGISTICS PVT LTD',
    'VILAS POLYMER LIMITED',
    'A R LIFE SCIENCES PRIVATE LIMITED',
    'YOJAKA INDIA PVT LTD',
    'YASHRAJ FILMS PRIVATE LIMITED',
    'ZYLOG PLASTALLOYS PRIVATE LIMITED',
    'WINRO COMMERCIAL INDIA LTD',
    'VIRIDENT SYSTEMS PRIVATE LIMITED',
    '3D TECHNOPACK LIMITED',
    'VIRAJ PROFILES LIMITED',
    'WELSPUN RENEWABLES ENERGY PRIVATE LIMITED',
    'A B INFRABUILD PRIVATE LIMITED',
    'WALL STREET FINANCE LIMITED',
    '3ACOMPOSITES INDIA PRIVATE LIMITED',
    'WADHWA RESIDENCY PRIVATE LIMITED',
    'WADHWA ESTATES AND DEVELOPERS INDIA PRIVATE LIMITED',
    'VISTAR METAL INDUSTRIES PRIVATE LIMITED',
    'WIPRO KAWASAKI PRECISION MACHINERY PVT LTD',
    '3G WIRELESS COMMUNICATIONS PRIVATE LIMITED',
    'VIWA DRYMIX PRIVATE LIMITED',
    'WTW Global Delivery and Solutions India Pvt Ltd',
    'A W Faber Castell India Private Limited',
    'webtech labels pvt ltd',
    'A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED',
    'YOKOGAWA IA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'XEROX BUSINESS SERVICES INDIA PRIVATE LIMITED',
    '21ST CENTURY HEALTH MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'VISHAL VIDEO AND APPLIANCES PRIVATE LIMITED',
    'ZOMATO INTERNET PRIVATE LIMITED',
    'WONDER GLOBAL INDIA TECHNOLOGY CENTRE PRIVATE LIMITED',
    'VODAFONE INDIA VENTURES LIMITED',
    'VINEY CORPORATION LIMITED',
    'WINDLASS ENGINEERS AND SERVICES PRIVATE LIMITED',
    'AADYA OVERSEAS LIMITED',
    'ACCEL TRANSMATIC LIMITED',
    'ACRES BUILDWELL PVT LTD',
    'A2G PLACEMENT PRIVATE LIMITED',
    'ACTION FOOTWEARS PVT LTD',
    'AASHKA SOFTWARE LIMITED',
    'ACRO TECHNOLOGIES INDIA PVT LTD',
    'Aarti writing products private limited',
    'ACE CREATIVE LEARNING PVT LTD',
    'ACCUSPEED ENGINEERING SERVICES INDIA LIMITED',
    'Accel frontline limited',
    'ACEBRIGHT (INDIA) PHARMA PRIVATE LIMITED',
    'ACELLERE SOFTWARE PRIVATE LIMITED',
    'ACN CABLE PRIVATE LIMITED',
    'ABEIMA INDIA PRIVATE LIMITED',
    'A.a.s. flight solutions private limited',
    'ABS AIRCON ENGINEERS PVT LTD',
    'ACCELERE DEVELOPMENT SOLUTIONS PRIVATE LIMITED',
    'AAA TECHNOLOGIES PRIVATE LIMITED',
    'ACCSOURCE KNOWLEDGE PROCESS OUTSOURCING PVT LTD',
    'ABSOLUTDATA RESEARCH and ANALYTICS SOLUTIONS PRIVATE LIMITED',
    'actis Technologies pvt limited',
    'AA - SERVE FOOD AND PHARMA PRIVATE LIMITED',
    'ABHILASHA TEX-CHEM LIMITED',
    'ACCOLITE SOFTWARE INDIA PRIVATE LIMITED',
    'AAMODA BROADCASTING COMPANY PVT LTD',
    'ABEC EXHIBITIONS AND CONFERENCES PVT LTD',
    'ABCO LEATHERS PRIVATE LIMITED',
    'ACCU FIX PRECISION TOOLS PRIVATE LIMITED',
    'ABSOTHERM FACILITY MANAGEMENT PRIVATE LIMITED',
    'ACCUDYNE INDUSTRIES INDIA PRIVATE LIMITED',
    'A.K. CAPITAL FINANCE PRIVATE LIMITED',
    'ABS PROFESSIONAL SERVICES INDIA PRIVATE LIMITED',
    'ABHIMAN TECHNOLOGIES PVT LTD',
    'AAKRITI INFO-MEDIA PRIVATE LIMITED',
    'ACER SOFTWARES PRIVATE LIMITED',
    'ACCEL INDIA MANAGEMENT COMPANY PRIVATE LIMITED',
    'ACESOCLOUD SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ABHRACLOUD SOFTWARES INDIA PRIVATE LIMITED',
    'ACCOLITE LABS INDIA PVT LTD',
    'A2Z GREEN WASTE MANAGEMENT LIMITED',
    'ACPL JEWELS PVT LTD',
    'ACTIA INDIA PRIVATE LIMITED',
    'AB INNOVATIVE SOFTWARE PRIVATE LIMITED',
    'ADHUNIK STEELS LIMITED',
    'AD SYNDICATE SERVICES PRIVATE LIMITED',
    'ADTEL SOFTEARE PRIVATE LIMITED',
    'ADMACH AUTO INDIA LIMITED',
    'AES LABORATONES PVT LTD',
    'ADVANT IT PARK PVT LTD',
    'ADVANCED MICRO DEVICES PVT LTD',
    'AF CONSULT INDIA PRIVATE LIMITED',
    'ADVANCED FLUORINE TECHNOLOGIES PRIVATE LIMITED',
    'AGILE BUSINESS INTELLIGENCE SERVICES PRIVATE LIMITED',
    'AHLUWALIA CONTRACTS INDIA LIMITED',
    'ADWAITH TEXTILES LIMITED',
    'AFTON CHEMICAL HYDERABAD PRIVATE LIMITED',
    'ADVANTAGE COMPUTERS INDIA PRIVATE LIMITED',
    'AEGAN BATTERIES LIMITED',
    'AD2C (INDIA) PRIVATE LIMITED',
    'Agarwal fasteners pvt ltd',
    'ADDII BIOTECH PVT LTD',
    'AEZ INFRATECH PRIVATE LIMITED',
    'ACUSIS SOFTWARE INDIA PRIVATE LIMITED',
    'ADANI DEVELOPERS PVT LTD',
    'ADHUNIK INFOTECH LIMITED',
    'AFFLE (INDIA) PRIVATE LIMITED',
    'ADO INDIA PVT LTD',
    'ADANI INFRA INDIA LIMITED',
    'Agile soft systems india private limited',
    'AGRAWAL CHANNEL MILLS PVT LTD',
    'ADM AGRO INDUSTRIES DHARWAD PVT LTD',
    'AEROTO BOLDROCCHI INDIA PRIVATE LIMITED',
    'AERENS GOLDSOUK INTERNATIONAL LIMITED',
    'ADITYA HOUSING AND INFRASTRUCTURE DEVELOPMENT CORPORATION PRIVATE LIMITED',
    'AHEADRACE SOFTWARWE DEVELOPMENT SERVICES PVT LTD',
    'ADROIT INFOTECH PRIVATE LIMITED',
    'ADVANCED BIO AGRO TECH LIMITED',
    'AFFORDABLE ROBOTIC and AUTOMATION PRIVATE LIMITED',
    'AGARWAL RUBBER LIMITED',
    'ADA CELLWORKS WIRELESS ENGINEERING PRIVATE LIMITED',
    'AETHERPAL (INDIA) PRIVATE LIMITED',
    'Actuant India Pvt ltd',
    'AHALIA MONEY EXCHANGE AND FINANCIAL SERVICES PRIVATE LIMITED',
    'ACUTA INFOTECH PRIVATE LIMITED',
    'AGC NETWORKS LIMITED',
    'AFPL GLOBAL PRIVATE LTD',
    'ADVAITAM TECH SOLUTIONS PRIVATE LIMITED',
    'AG FURNANCE IMPROVEMENTS PRIVATE LIMITED',
    'AGNITY INDIA TECHNOLOGIES PRIVATE LIMITED',
    'AGODA INTERNATIONAL INDIA PVT LTD',
    'ADWAYS INNOVATIONS INDIA PRIVATE LIMITED',
    'ADANI INFRASTRUCTURE MANAGEMENT SERVICES LIMITED',
    'AIMTRON ELECTRONICS PRIVATE LIMITED',
    'Alps Hospital Ltd',
    'ALPCORD NETWORK EVENTS AND CONFERNCES MANAGEMENT PRIVATE LIMITED',
    'AJANTA FOOTCARE INDIA PVT LTD',
    'ALLIED ELECTRONICS AND MAGNETICS LTD',
    'ALTEM ENERGY LIMITED',
    'ALPHAGAM COATING SOLUTIONS PVT LTD',
    'AIR INDIA CHARTERS LIMITED',
    'ALLERGAN HEALTHCARE INDIA PRIVATE LIMITED',
    'ALPHA CARBONLESS PAPER MANUFACTURING CO P LTD',
    'AIRASIA (INDIA) LIMITED',
    'ALANKIT LIFE CARE LIMITED',
    'ALPHA TOCOL ENGINEERING SERVICES PRIVATE LIMITED',
    'ALBA ASIA PVT LTD',
    'AKSHARA MOTORS PVT LTD',
    'AL- RKAYAN APPARELS AND EXPORTS PRIVATELIMITED',
    'ALTRUISTA HEALTH SERVICES PRIVATE LIMITED',
    'AKAR TOOLS LTD',
    'ALPHAVECTOR INDIA PRIVATE LIMITED',
    'ALUMILITE ARCHITECTURALS PVT LTD',
    'AIT RESOURCE INDIA PVT LTD',
    'ALTERA SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'AMAN ATLANTIC PRIVATE LIMITED',
    'AIMIA INDIA LOYALTY MANAGEMENT PRIVATE LIMITED',
    'ALLEGRO CAPITAL ADVISORS PRIVATE LIMITED',
    'AIWAY SOLUTIONS INDIA PRIVATE LIMITED',
    'AIRTEL M COMMERCE SERVICES LIMITED',
    'AMAN AVIATION AND AEROSPACE SOLUTION PRIVATE LIMITED',
    'ALPHA-PHARMA HEALTHCARE INDIA PRIVATE LIMITED',
    'ALLIED RESOURCE MANAGEMENT SERVICES INDIA PVT LTD',
    'AISIN NTTF PRIVATE LIMITED',
    'ALLEVARD IAI SUSPENSIONS PRIVATE LIMITED',
    'AJNARA REALTECH LTD',
    'Aksh medialab & software india private limited',
    'AKSHAY SOFTWARE TECHNOLOGIES LIMITED',
    'ALD DYNATECH FURNACES PRIVATE LIMITED',
    'AJNARA INFRASTRUCTURE PRIVATE LIMITED',
    'ALBANNA ENGINEERING (INDIA) PRIVATE LIMITED',
    'AIM FILTERTECH PRIVATE LIMITED',
    'Allstate solutions private limited',
    'AISIN AUTOMOTIVE KARNATAKA PVT LTD',
    'AIRWATCH TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ALVAREZ AND MARSAL INDIA PRIVATE LIMITED',
    'AKKEN TECHNOLOGIES PRIVATE LIMITED',
    'ALBANY MOLECULAR RESEARCH HYDERABAD RESEARCH CENTRE PRIVATE LIMITED',
    'ALLIED MOULDED ENCLOSURE PRODUCTS (INDIA) PRIVATEÃ‚Â LIMITED',
    'ALPHASERVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AIRBNB INDIA PVT LTD',
    'AKORN INDIA PVT LTD',
    'ALERE MEDICAL PRIVATE LIMITED',
    'ALLIANCE CAPITAL ASSET MANAGEMENT INDIA PRIVATE LIMITEDÃ‚Â',
    'AIG ANALYTICS & SERVICES PRIVATE LIMITED',
    'AMADA INDIA PRIVATE LIMITED',
    'ALINA HOSPITALITY PRIVATE LIMITED',
    'ALCHEMY TECHSOL INDIA PVT LTD',
    'ALAMELU CHARITABLE FOUNDATION',
    'ALLERGAN INDIA PRIVATE LIMITED',
    'AIR LIVERY INDIA PRIVATE LIMITED',
    'AMRICON AGROVET PRIVATE LIMITED',
    'AMBIENCE HOTELS & RESORTS PRIVATELIMITED',
    'ANAND ELECTRONICS & INDUSTRIES LIMITED',
    'ANNAPURNA ELECTRONICS AND SERVICES PRIVATE LTD',
    'Anandji haridas and company pvt ltd',
    'ANGEL COMMODITIES BROKING PVT LTD',
    'ANPI INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'ANPHAR ORGANICS PVT LTD',
    'ANDOR TECH INDIA PRIVATE LIMITED',
    'AMPLIFI COMMERCE SOLUTIONS PRIVATE LIMITED',
    'AMMAYAPPER TEXTILES PRIVATE LIMITED',
    'AMAZON PAY INDIA PVT LTD',
    'AMBIT HOLDINGS PRIVATE LIMITED',
    'ANTAL INFOTECH PVT LTD',
    'ANSAL CROWN INFRABUILD PVT LTD',
    'AMLF LOGISTICS PVT LTD',
    'AOSTA SOFTWARE TECHNOLOGIES INDIA LIMITED',
    'APCOTEX SOLUTIONS INDIA PRIVATE LIMITED',
    'AMPLIFON INDIA PRIVATE LIMITED',
    'ANALYTICA (INDIA) PRIVATE LIMITED',
    'ANNAKOOT PROPERTIES PVT LTD',
    'AMEC FOSTER WHEELER INDIA PRIVATE LIMITED',
    'AMERICAN EXPRESS SERVICES INDIA LIMITED',
    'ANITE TELECOMS INDIA PRIVATE LIMITED',
    'Amol Pharmaceuticals Pvt Ltd',
    'ANSEC HUMAN RESOURCE SERVICES PRIVATE LIMITED',
    'AMELIO CHILD CARE PRIVATE LIMITED',
    'AMMERAAL BELTECH (INDIA) PRIVATE LIMITED',
    'AMC COOKWARE INDIA PRIVATE LIMITED',
    'ANALYTIX BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'ANUBAVAM TECHNOLOGIES PVT LTD',
    'ANURAG ELECTRONICS GUJARAT PVT LTD',
    'AMSURE INSURANCE AGENCY LIMITED',
    'ANTENNA SOFTWARE INDIA PRIVATE LIMITED',
    'AMI INDIA LOGISTICS PRIVATE LIMITED',
    'APD EXPORTS PRIVATE LIMITED',
    'AMAZON WHOLESALE INDIA PRIVATE LIMITED',
    'Amneal Oncology Pvt Ltd',
    'AOL TECHNOLOGY INDIA PVT LTD',
    'AMD RESEARCH & DEVELOPMENT CENTER INDIA PRIVATE LIMITED',
    'AMERI CONSULTING SERVICE PRIVATE LIMITED',
    'ANCHOR ELECTRICALS PRIVATE LIMITED',
    'AOHUA MOBILE INDIA PRIVATE LIMITED',
    'ANU PRODUCTS LTD',
    'ANLON TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'APNA GHAR BUILDWELL PRIVATE LIMITED',
    'arm welders pvt ltd',
    'APOLLO AMRISH ONCOLOGY SERVICES PRIVATE LIMITED',
    'APOLLO COSMETIC SURGICAL CENTER PRIVATE LIMITED',
    'AR PRINTING AND PACKAGING (INDIA) PRIVATE LIMITED',
    'ARCELOR NEEL TAILORED BLANK PRIVATE LIMITED',
    'ARISE INDUSTRIES AND AGENCY PVT LTD',
    'ARISTO LABORATORIES PVT. LTD.',
    'ARKLITE SPECIALITY LAMPS LIMITED',
    'ARACKAL DIGITAL SOLUTIONS PRIVATELIMITED',
    'APOLLO FIEGE INTEGRATED LOGISTICS PRIVATE LIMITED',
    'APPLIED MICRO CIRCUITS INDIA PRIVATE LIMITED',
    'ARENE LIFE SCIENCES LIMITED',
    'APOLLO MICRO SYSTEMS PRIVATE LIMITED',
    'APPLIED THERMAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'APPLIED DEVELOPMENT SOFTWARE (INDIA) PRIVATE LIMITED',
    'APPSTER INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'APEX STRATEGIC CONSULTING PRIVATE LIMITED',
    'ARMSEL MHE PRIVATE LIMITED',
    'Aristo bio-tech and lifescience private limited',
    'APRICOT FOODS PVT LTD',
    'ARMACELL INDIA PRIVATE LTD',
    'ARDEE TECHNOLOGIES PRIVATE LIMITED',
    'Approcopp Engineering Pvt Ltd',
    'APL INDIA PVT LTD',
    'ARGOSY TRAVELS PVT LTD',
    'ARDOM TELECOM PRIVATE LIMITED',
    'ARONI COMMERCIALS LIMITED',
    'APLOPIO TECHNOLOGY PVT LTD',
    'APPLIFT INDIA TECHNOLOGIES PRIVATE LIMITED',
    'Apttus software private limited',
    'APURVA INDIA LIMITED',
    'AREVA RENEWABLE ENERGIES INDIA PRIVATE LIMITED',
    'APOLLO MUNICH HEALTH INSURANCE COMPANY LIMITED',
    'AQUANTIA SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'ARKEMA CHEMICALS INDIA PVT LTD',
    'AROMATAN COSMETICS PRIVATE LIMITED',
    'APSOLUT SOFTWARE INDIA PVT LTD',
    'APEX AUTO LIMITED',
    'AQUA DESIGNS INDIA PRIVATE LIMITED',
    'ARK CHEMICAL PVT LTD',
    'AQ MECHANICAL AND ELECTRICAL MANUFACTURING INDIA PVT LTD',
    'APPCITO NETWORKS PRIVATE LIMITED',
    'APIMA CONSULTING PRIVATE LIMITED',
    'ARKADE DEVELOPERS PVT LTD',
    'APTIFY SOFTWARE DEVELOPMENT SOLUTIONS (INDIA) PRIVATE LIMITED',
    'ARMSTRONG MACHINE BUILDERS PRIVATELIMITED',
    'AQUENT IMPEX INDIA PRIVATE LIMITED',
    'APTROID TECHNOLOGIES PRIVATE LIMITED',
    'ARCHETYPE ENGINEERING and INDUSTRY PRIVATE LIMITED',
    'APEX TUBES PVT .LTD',
    'ARORA AND ASSOCIATES REALTY LIMITED',
    'ARRIS INDIA PRIVATE LIMITED',
    'ARKAY ENERGY RAMESWARM LIMITED',
    'ARETEANS TECHNOLOGY SOLUTIONS PVT LTD',
    'APPVIEWX PRIVATE LIMITED',
    'AQUAMART FEEDS PRIVATE LIMITED',
    'ASPIRA PATHLAB and DIAGNOSTICS LIMITED',
    'ASSOTECH BEBL INFRASTRUCTURE PVT LTD',
    'ASIM NAVIGATION INDIA PVT LTD',
    'ARVIND INFRASTRUCTURE LIMITED',
    'ARYAN CLEAN COAL TECHNOLOGIES PRIVATE LIMITED.',
    'ASATSU-DK-FORTUNE COMMUNICATIONS PRIVATE LIMITED',
    'ATC TOWER COMPANY OF INDIA PRIVATE LIMITED',
    'ATC India Infrastructure Pvt Ltd',
    'ASH AND ALAIN INDIA PRIVATE LIMITED',
    'ASHIANA LANDCRAFT REALTY PVT LTD',
    'ASIT C MEHTA COMMODITY SERVICES LIMITED',
    'ASIAN TOWNSVILLE FARMS LIMITED',
    'ASIAN INSTITUTE OF NEPHROLOGY AND UROLOGY PRIVATEÃ‚Â LIMITED',
    'ASTRAL (INDIA) PRIVATE LIMITED',
    'ASHWANI CARS PVT LTD',
    'A-TEX (INDIA) PRIVATE LIMITED',
    'ASARVA CHIPS AND TECHNOLOGIES PVT LTD',
    'ASAP-Y SOURCING SOLUTIONS PRIVATE LIMITED',
    'ASIAN PEROXIDES LIMITED',
    'ASHLYN CHEMUNNOOR INSTRUMENTS PVT LTD',
    'ASCO NUMATICS INDIA PRIVATE LIMITED',
    'ARTIS MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'ARVIND INTERNET LIMITED',
    'ASHAPURA FORWARDERS PRIVATE LIMITED',
    'ASIAN STAR JEWELS PVT LTD',
    'ASIAN OILFIELD SERVICES LIMITED',
    'ARS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'ASIS LOGISTICS LIMITED',
    'ATHANI SUGARS LTD',
    'ASK FAMILY OFFICE AND INVESTMENT ADVISERS PRIVATE LIMITED',
    'ASPIRE LEARNING COMPANY PRIVATE LIMITED',
    'ASCENTIS INDIA CONSTRUCTION PRIVATE LIMITED',
    'Astron Paper and Board Mill Ltd',
    'ASM ASSEMBLY SYSTEMS INDIA PRIVATE LIMITED',
    'arunodaya print pack pvt ltd',
    'ASHTECH INFOTECH PRIVATE LIMITED',
    'ARROW ENTERPRISE COMPUTING SOLUTIONS INDIA PRIVATE LIMITED',
    'Asia Pacific Flight Training academy Ltd',
    'ASCENDAS SERVICES INDIA PRIVATE LIMITED',
    'ASHLEY MARKETELLIGENT PRIVATE LIMITED',
    'ASEEMA SOFTNET TECHNOLOGIES PVT LTD',
    'ASTARC MANAGEMENT SERVICES PRIVATE LIMITED',
    'ASPIRE HUMAN CAPITAL MANAGEMENT PRIVATE LIMITED',
    'ASHAPURA INTIMATES FASHION LIMITED',
    'ASAYA HOME STORE PRIVATE LIMITED',
    'ASHOKA FOAM MULTI PLAST LIMITED',
    'ARVOS ENERGY INDIA PRIVATE LIMITED',
    'ASHOK AND COMPANY PAN BAHAR LIMITED',
    'ARTH DESIGNBUILD INDIA PVT LTD',
    'ARVIND FASHION BRANDS LIMITED',
    'ASHKOM MEDIA INDIA PVT LTD',
    'ASIANET NEWS MEDIA AND ENTERTAINMENT PRIVATE LIMITED',
    'avon containners pvt ltd',
    'AURORA APPAREL PVT LTD',
    'AXIOM ESTATES ADVISORY SERVICES PRIVATE LIMITED',
    'AUSADH VYAPAAR PRIVATE LIMITED',
    'AVANTHA ERGO LIFE INSURANCE COMPANY LIMITED',
    'ATRA PHARMACEUTICALS LIMITED',
    'AUTOMATIC TRANSMISSION PARTS AND SERVICES PRIVATE LIMITED',
    'Avon Meters Pvt Ltd',
    'ATLANTIC SHIPPING PRIVATE LIMITED',
    'AVALON TECHNOLOGIES PRIVATE LIMITED',
    'ATLAS DYE-CHEM (INDIA) PRIVATE LIMITED',
    'AVIANS INNOVATIONS TECH PAT LTD',
    'AXIOM HR SERVICES PRIVATE LIMITED',
    'AVDEL INDIA PVT LTD',
    'BABEL MEDIA INDIA PRIVATE LIMITED',
    'ATLANTIC LUBRICANTS AND SPECIALITIES PRIVATE LIMITED',
    'AVON MONEY SOLUTION INDIA LIMITED',
    'AVX ELECTRONICS SENSING AND CONTROL INDIA PRIVATE LIMITED',
    'AUDITIME QUALITY MANAGEMENT PRIVATE LIMITED',
    'BABJI REALTORS PRIVATE LIMITED',
    'ATHER ENERGY PVT LTD',
    'AUTO HANGAR INDIA PRIVATE LIMITED',
    'ATOPTECH DESIGN AUTOMATION PRIVATE LIMITED',
    'AXIOM CONSULTING PRIVATE LIMITED',
    'BADVE CELLINO ENGINEERING PRIVATE LIMITED',
    'B N RATHI SECURITIES LIMITED',
    'AUDIENCE SCIENCE INDIA PRIVATE LIMITED',
    'AURUM SOFT SYSTEMS LIMITED',
    'AXN NETWORKS INDIA PRIVATE LIMITED',
    'AUGUSTA HITECH SOFT SOLUTIONS PRIVATELIMITED',
    'AVI WORLDWIDE PVT LTD',
    'AWP ASSISTANCE INDIA PRIVATE LIMITED',
    'ATOM TECHNOLOGIES LIMITED',
    'ATLAS HEALTHCARE SOFTWARE INDIA PRIVATE LIMITED',
    'B S E S INDIA PRIVATE LIMITED',
    'AUJAS NETWORKS PRIVATE LIMITED',
    'AXIOM HEALTHCARE IT CONSULTING PRIVATE LIMITED',
    'ATTRA INFOTECH PRIVATE LIMITED',
    'AUTOMOTIVE ROBOTICS ENGINEERING SERVICES ( INDIA ) PRIVATE LIMITED',
    'AUROCHEM LABORATORIES INDIA PRIVATE LIMITED',
    'ATMEL R & D INDIA PRIVATE LIMITED',
    'AUTOLINE INDUSTRIES LTD',
    'AVEDA RESORTS AND SPA PRIVATE LIMITED',
    'ATREYA SERVICES PRIVATE LIMITED',
    'AXIS WIND ENERGY LIMITED',
    'Avaali Solutions Pvt Ltd',
    'AVAAP IT SOLUTIONS PRIVATE LIMITED',
    'B V CHINAI AND CO INDIA PRIVATE LIMITED',
    'Backwater Technologies Pvt Ltd',
    'B A G FILMS AND MEDIA LIMITED',
    'B C POWER CONTROLS LIMITED',
    'AVANTHA BUSINESS SOLUTIONS LIMITED',
    'AUTO VOGUE PVT LTD',
    'ATOTECH DEVELOPMENT CENTER PRIVATELIMITED',
    'BELLADONA PLASTERS LIMITED',
    'BEUMER INDIA LIMITED',
    'BHARAT AUTOMOTIVE PRESSINGS INDIA PRIVATE LIMITED',
    'BEDMUTHA INDUSTRIES LTD',
    'BHADRA INTERNATIONAL INDIA PRIVATE LIMITED',
    'BELLSOFT INDIA SOLUTIONS PRIVATE LIMITED',
    'BHARAT INSULATION COMPANY (INDIA) LIMITED',
    'BHAIRAV EMBRO DESIGNS PRIVATE LIMITED',
    'BAUSCH AND LOMB INDIA PRIVATE LIMITED',
    'BENGAL PARK CHAMBERS HOUSING DEVELOPMENT LIMITED',
    'BB HOSPITALITY VENTURES PRIVATE LIMITED',
    'BGR MINING AND INFRA PRIVATE LIMITED',
    'BAJAJ RUBBER COMPANY PVT LTD',
    'BANGALORE DOR TECH PRIVATE LIMITED',
    'BEST SELLERS APPARELS PRIVATE LIMITED',
    'BELL FINVEST INDIA LTD',
    'BEKO COMPRESSED AIR TECHNOLOGIES PRIVATE LIMITED',
    'BAKER TILLY DHC PRIVATE LIMITED',
    'BAFNA LIFESTYLES REMEDIES LIMITED',
    'BBW BUSINESS SERVICES PRIVATE LIMITED',
    'BAWREE FASHIONS PRIVATE LIMITED',
    'BANGALORE ELEVATED TOLLWAY LTD',
    'BHAGAVATHI ANA LABS PRIVATE LIMITED',
    'BATLIBOI ENXCO PRIVATE LIMITED',
    'BELECTRIC PHOTOVOLTAIC INDIA PRIVATE LIMITED',
    'BELSTAR INVESTMENT AND FINANCE PRIVATE LIMITED',
    'BEYONDTECH IT CONSULTING PRIVATE LIMITED',
    'BELLS SOFTECH LIMITED',
    'BELIMO ACTUATORS (INDIA) PRIVATE LIMITED',
    'BENGAL TEA & FABRICS LTD',
    'BAGALKOT CEMENT AND INDUSTRIES LTD',
    'BHAGIRADHA CHEMICALS AND INDUSTRIES LIMITED',
    'BEBITZ FLANGES WORKS PRIVATE LIMITED',
    'Bafna Motors Mumbai Pvt Ltd',
    'BANCTEC TPS INDIA PRIVATE LIMITED',
    'BATEMAN ENGINEERING (INDIA) PRIVATE LIMITED',
    'BANGALORE PAINTS LIMITED',
    'Bagmane Developers Pvt Ltd',
    'BELONG TECHNOLOGIES INDIA PVT LTD',
    'BAGHMAR FINLEASE PRIVATE LIMITED',
    'BERGER NIPPON PAINT AUTOMOTIVE COATINGSPRIVATE LIMITED',
    'BAULI INDIA BAKES and SWEETS PRIVATE LIMITED',
    'BENEFITALIGN TECHNOLOGIES PRIVATELIMITED',
    'BASILIC FLY STUDIO PRIVATE LIMITED',
    'BAJAJ ECO - TEC PRODUCTS LIMITED',
    'BBM ENGINEERING SERVICES PRIVATE LIMITED',
    'BHARUCH ENVIRO INFRASTRUCTURE LIMITED',
    'BIOGENETIC DRUGS PVT LTD',
    'BJN PAINTS INDIA LIMITED',
    'BINARY FOUNTAIN SOLUTIONS INDIA PRIVATE LIMITED',
    'BIODIVERSITY CONSERVATION (INDIA) PRIVATE LIMITED',
    'BILLROTH HOSPITALS LIMITED',
    'BHARTIYA VEHICLE AND ENGINEERING CO.LTD.',
    'BHUVANA INFRA PROJECTS PRIVATE LIMITED',
    'BHAVYA CEMENTS LIMITED',
    'BIRNBAUM KHANDELWAL ADVISORY SERVICES PRIVATE LIMITED',
    'BLACK KNIGHT INDIA SOLUTIONS PRIVATE LIMITED',
    'BHIMA JEWELLERY AND DIAMONDS PRIVATE LIMITED',
    'BIRLA MANAGEMENT CENTRE SERVICES LIMITED',
    'BMM CEMENTS LIMITED',
    'BIO PETRO CLEAN INDIA PVT LTD',
    'BLUE MATRIX SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'BLUJAY SOLUTIONS INDIA PRIVATE LIMITED',
    'BHP BILLITON MARKETING SERVICES INDIA PRIVATE LIMITED',
    'BIOTAVIA PHARM LIMITED',
    'BLUE STAR INFOTECH LIMITED',
    'BHARTI REALTY LIMITED',
    'BIC CELLO INDIA PRIVATE LIMITED',
    'BIAS IT CONSULTING PRIVATE LIMITED',
    'BIO RAD LABORATORIES (INDIA) PRIVATE LIMITED',
    'BIAS INFOTECH PRIVATE LIMITED',
    'BLANKCHQ INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'BIOSYSTEMS DIAGNOSTICS PVT LTD',
    'BIG SAM SNACKS & FOODS PRIVATE LIMITED',
    'BIOBASE DATABASES INDIA PRIVATE LIMITED',
    'BMS INDUSTRIES LIMITED',
    'BNP PARIBAS ASSET MANAGEMENT INDIA PRIVATE LIMITED',
    'BHARTI AXA GENERAL INSURANCE COMPANY LIMITED',
    'BLOOM ENERGY INDIA PRIVATE LIMITED',
    'Bluestream professional services india private limited',
    'BLUEFISH PHARMACEUTICALS PVT LTD',
    'BIZVIZ TECHNOLOGIES PVT LTD',
    'BLIPPAR COM INDIA PRIVATE LIMITED',
    'BHATIA COKE & ENERGY LIMITED',
    'BIRD AUTOMOTIVE PRIVATE LIMITED',
    'BLINK CONSULTING PRIVATE LIMITED',
    'Bluering Realtech Private Limited',
    'Bhardwaj India Private Ltd',
    'Blueberry digital labs pvt ltd',
    'BOMBAY SELECTION PRIVATE LIMITED',
    'Calorx education and research foundation',
    'BURDA DRUCK INDIA PRIVATE LIMITED',
    'C S SOFT SOLUTIONS INDIA PVT LTD',
    'C and E LTD',
    'BRACECORP PUBLICATIONS PRIVATE LIMITED',
    'BON LON STEELS PRIVATE LIMITED',
    'Bombay wellprint inks pvt ltd',
    'BORAX MORARJI LIMITED',
    'C.e. info systems private limited',
    'BSM BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CALCOM CEMENT INDIA LIMITED',
    'BSL ENGINEERING SERVICES LIMITED',
    'busy infotech private limited',
    'BRANDZSTORM INDIA MARKETING PVT LTD',
    'BRUGG CABLES INDIA PRIVATE LIMITED',
    'BUSINESS JETS INDIA PRIVATE LIMITED',
    'BROADSOFT TECHNOLOGIES PRIVATE LIMITED',
    'C B M INDUSTRIE LIMITED',
    'BRAVURA SOLUTIONS INDIA PRIVATE LIMITED',
    'BTI PAYMENTS PRIVATE LIMITED',
    'C H ROBINSON WORLDWIDE FREIGHT INDIA PVT LTD',
    'BOI AXA INVESTMENT MANAGERS PRIVATE LIMITED',
    'BONFIGLIOLI RENEWABLE POWER CONVERSION INDIA PRIVATE LIMITED',
    'BOROSIL GLASS WORKS LIMITED',
    'Bombay hardware p ltd',
    'BRASS COPPER ALLOY INDIA LIMITED',
    'BRAND EYES DISTRIBUTORS PVT LTD',
    'BOSTONLOGIX INDIA PVT LTD',
    'CACHEMATRIX INTEGRATIONS PRIVATE LIMITED',
    'BUREAU VERITAS CERTIFICATION INDIA PRIVATE LIMITED',
    'BURKERT CONTROMATIC PRIVATE LIMITED',
    'BRISK INDIA PVT LTD',
    'BOOKER INDIA PRIVATE LIMITED',
    'BOHLER-UDDEHOLM INDIA LIMITED',
    'BRIDGESGI SOLUTIONS INDIA PRIVATE LIMITED',
    'BSN MEDICAL PRIVATE LIMITED',
    'C.H.ROBINSON INTERNATIONAL INDIA PVT LTD',
    'BSD STRUCTURAL ENGINEERING PRIVATE LIMITED',
    'BURGER KING INDIA PRIVATE LIMITED',
    'CALVIN KLEIN ARVIND FASHION PRIVATE LIMITED',
    'BRIDGESTONE INDIA AUTOMOTIVE PRODUCTS PRIVATE LIMITED',
    'BUZZCITY TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'BOSS PACKAGING SOLUTIONS PRIVATE LIMITED',
    'BUBBLE MOTION RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED',
    'BRAND CONCEPTS PRIVATE LIMITED',
    'CALYPSO TECHNOLOGY INDIA PRIVATE LIMITED',
    'BRINKS INDIA PRIVATE LIMITED',
    'BOT VFX INDIA PRIVATE LIMITED',
    'BUILDDIRECT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BONDADA ENGINEERING PRIVATE LIMITED',
    'BUSSAN AUTO FINANCE INDIA PRIVATE LIMITED',
    'C P ARORA ENGINEERS CONTRACTORS PRIVATELIMITED',
    'BUNGE INDIA TRADING PRIVATE LIMITED',
    'BULDANA URBAN BUSINESS SERVICES PRIVATE LIMITED',
    'CENTRODORSTROY (INDIA) PRIVATE LIMITED',
    'CG-PPI ADHESIVE PRODUCTS LIMITED',
    'CATALYST BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CARNATION AUTO INDIA PRIVATE LIMITED',
    'C-DOT ALCATEL-LUCENT RESEARCH CENTRE PRIVATE LIMITED',
    'CAPILLARY TECHNOLOGIES PRIVATE LIMITED',
    'CAMBIUM NETWORKS CONSULTING PRIVATE LIMITED',
    'casio india co private limited',
    'CARE IT SOLUTIONS PRIVATE LIMITED',
    'CATALYTIC MANAGEMENT ADVISERS PRIVATE LIMITED',
    'Casa decor private limited',
    'CANTABIL RETAIL INDIA LTD',
    'CAUVERY POWERGENERATION CHENNAI PRIVATE LIMITED',
    'Cedar Management Consulting Pvt Ltd',
    'CARGOSOL LOGISTICS PRIVATE LIMITED',
    'CERADECOR INDIA LIMITED',
    'CAPITAL SMALL FINANCE BANK LTD',
    'CELLO STATIONERY PRODUCTS PRIVATE LIMITED',
    'CFF FLUID CONTROL PRIVATE LIMITED',
    'CAMFIL AIR FILTRATION INDIA PRIVATE LIMITED',
    'CELEBRITY FASHIONS LTD',
    'canara lighting industries pvt ltd',
    'cavalier it solutions pvt ltd',
    'CEASEFIRE INDUSTRIES LIMITED',
    'CARRIER RACE TECHNOLOGIES PRIVATE LIMITED',
    'Camex ltd',
    'CELLIBER TECHNOLOGIES PVT LTD',
    'CERNER INDIA SALES PRIVATE LIMITED',
    'CARLSON HOSPITALITY MARKETING (INDIA) PRIVATE LIMITED',
    'CARLISLE TRADING & MANUFACTURING INDIA PRIVATE LIMITED',
    'CHAIN N CHAINS JEWELS LIMITED',
    'CAPILLARY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CARAT MEDIA SERVICES INDIA PRIVATE LIMITED',
    'CDM INDIA CORPORATE SERVICES PRIVATE LIMITED',
    'CANGO NETWORKS PRIVATE LIMITED',
    'CDP INDIA PRIVATE LIMITED',
    'CERIUM SYSTEMS PRIVATE LIMITED',
    'CATWALK WORLDWIDE PRIVATE LIMITED',
    'CB AND I INDIA PRIVATE LIMITED',
    'CHAINALYTICS SERVICES PRIVATE LIMITED',
    'CBC CORPORATION INDIA PVT LTD',
    'CAVOTEC ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'CATTLEYA TECHNOSYS PVT LTD',
    'CAPITA OFFSHORE SERVICES PRIVATE LIMITED',
    'CESARE BONETTI INDIA PRIVATE LIMITED',
    'CANTERBURG TECH BPO INDIA PRIVATE LIMITED',
    'CDK GLOBAL INDIA PRIVATE LIMITED',
    'CCT SOLUTIONS PRIVATE LIMITED',
    'CERMEX INDIA PRIVATE LIMITED',
    'CERNER HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'CGG SERVICES INDIA PVT LTD',
    'CARTINI INDIA LIMITED',
    'CASSIOPAE SOLUTIONS PRIVATE LIMITED',
    'CENTRE FOR DIGESTIVE AND KIDNEY DISEASES INDIA PRIVATE LIMITED',
    'CAPACITE STRUCTURES LIMITED',
    'CARE MANAGEMENT INTERNATIONAL PRIVATE LIMITED',
    'CAPSILON SOFTWARE PRIVATE LIMITED',
    'CFIRST BACKGROUND CHECKS INDIA PRIVATE LIMITED',
    'CAMPUS MANAGEMENT INTERNATIONAL PRIVATE LIMITED',
    'CAMBRIDGE UNIVERSITY PRESS INDIA PRIVATE LIMITED',
    'CARETEL INFOTECH LIMITED',
    'CARGO SOLAR POWER GUJARAT PRIVATE LIMITED',
    'CHOWGULE ABP COATINGS INDIA PRIVATE LIMITED',
    'CHINTELS INDIA LTD',
    'CHARMS INDIA PVT LTD',
    'CLEAR WATER LTD',
    'CHANDERPUR INDUSTRIE PVT LTD',
    'CHUGOKU PAINTS INDIA PRIVATE LIMITED',
    'CHOLAMANDALAM DISTRIBUTION SERVICES LIMITED',
    'CHROMEWELL ENGINEERING LIMITED',
    'CHANDRAUDAI AUTOMOBILES PRIVAT LIMITED',
    'CITRINE BUSINESS SOFTWARE SOLUTIONS PVT LTD',
    'CIR-Q-TECH TAKO TECHNOLOGIES PRIVATELIMITED',
    'CHAMUNDESWARI BUILD TECH PRIVATE LIMITED',
    'CLOUDCHERRY ANALYTICS PRIVATE LIMITED',
    'CHEMSPEC CHEMICAL PVT LTD.',
    'CIC VISION (INDIA) PRIVATE LIMITED',
    'CHERRYTEC INTELISOLVE LIMITED',
    'CLIFTON EXPORT PRIVATE LTD',
    'CLEANTECH TELE TOWER SERVICES PRIVATE LIMITED',
    'CHEMTECH ACIDS AND CHEMICALS PVT LTD',
    'CITYLIFE RETAIL PRIVATE LIMITED',
    'CLINICAL SOFTWARE PRIVATE LIMITED',
    'CHANDRA NET PRIVATE LIMITED',
    'CITIXSYS TECHNOLOGIES LIMITED',
    'CLOSURE SYSTEMS INTERNATIONAL I PRIVATE LIMITED',
    'CLOUPIA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CITIZEN INDUSTRIES LIMITED',
    'CHRIST NISHOTECH WATER SYSTEMS PRIVATE LIMITED',
    'CLSA TECHNOLOGY & SERVICES PRIVATE LIMITED',
    'CLINTEC (INDIA) INTERNATIONAL PRIVATE LIMITED',
    'CIANS ANALYTICS PVT LTD',
    'CLASSIC ENTERPRISES LIMITED (TRANSFER FROM W.B. TO RAJ.)',
    'CITRUS CHECK-INNS LIMITED',
    'CITRUS RETREATS (KERALA) PRIVATE LIMITED',
    'CITY PROPERTIES MAINTENANCE COMPANY BANGALORE LIMITED',
    'CITADEL RESEARCH AND SOLUTIONS PRIVATE LIMITED',
    'CHOWDARY SPINNERS LIMITED',
    'CHRONOS TECHNOLOGY PRIVATE LIMITED',
    'CHANDRA SHIP MANAGEMENT PRIVATE LIMITED',
    'CHEMSYNERGY INDIA PRIVATE LIMITED',
    'CHAMPION COMPUTERS PVT LIMITED',
    'CIRCUIT SYSTEMS (INDIA) LIMITED',
    'CLOTHING CULTURE LIMITED',
    'CJ FEED INDIA PRIVATE LIMITED',
    'CLIPPER FLEET MANAGEMENT INDIA PRIVATE LIMITED',
    'CHIPTEST ENGINEERING LIMITED',
    'CLIX FINANCE INDIA UNLIMITED',
    'CLASSIC RETAIL IMAGING SOLUTIONS PRIVATE LIMITED',
    'CLIQR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Choice Wealth Management Private Limited',
    'CHATTERJEE CLEANING ARTS SERVICES PRIVATE LIMITED',
    'CITRUS PROCESSING INDIA PRIVATE LIMITED',
    'CHENNAI CNC TOOL ROOM PRIVATE LIMITED',
    'CHUBB ALBA CONTROL SYSTEMS LIMITED.',
    'CLARKS FUTURE FOOTWEAR PRIVATE LIMITED',
    'CLOUD ONE ENTERPRISES PRIVATE LIMITED',
    'CLP POWER INDIA PRIVATE LIMITED',
    'COIT CONSULTING PRIVATE LIMITED',
    'COPPER MOBILE (INDIA) PRIVATE LIMITED',
    'CODENOMICON SOFTWARE INDIA PRIVATE LIMITED',
    'Connect India E Commerce Services Private Limited',
    'COMPUTER GENERATED SOLUTIONS INDIA PRIVATE LTD',
    'CORDIANT TECHNOLOGIES PRIVATE LIMITED',
    'CODECLOUDS IT SOLUTIONS PVT LTD',
    'COLLEGEDUNIA WEB PVT LTD',
    'compal electronics india pvt ltd',
    'CONCORDE DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'CONTINENTAL DRUG COMPANY PRIVATE LIMITED',
    'CONDECO SOFTWARE PRIVATE LIMITED',
    'COMPUTER INFOTECH INDIA PRIVATE LIMITED',
    'COMPASS LOGISTICS PRIVATE LIMITED',
    'COOLSOFT TECHNOLOGIES PRIVATE LIMITED',
    'CONCAST INDIA LIMITED',
    'CONCORD BLUE TECHNOLOGY PRIVATE LIMITED',
    'CM ENVIROSYSTEMS PVT LTD',
    'COMPASS GROUP (INDIA) SUPPORT SERVICES PRIVATE LIMITED',
    'COMPASS INDIA SUPPORT SERVICES PVT LTD',
    'CNETRIC ENTERPRISE SOLUTIONS PVT LTD',
    'CONFIDENT DENTAL EQUIPMENTS LIMITED',
    'CONCORDE CUPPA BEVERAGES PRIVATE LIMITED',
    'COMNET SOLUTIONS PRIVATE LIMITED',
    'CONVERGE BIOTECH PVT LTD',
    'COLOGICX SYSTEMS PRIVATE LIMITED',
    'COLLABNET SOFTWARE PRIVATE LIMITED',
    'CONSUS ITECHNOLOGIES PRIVATE LIMITED',
    'CMGRP INDIA PRIVATE LIMITED',
    'CLUMAX DIAGNOSTIC AND RESEARCH CENTRE PVT LTD',
    'CMI FPE LIMITED',
    'COKINETIC SYSTEMS INDIA PRIVATE LIMITED',
    'COCKRAM PROJECTS INDIA PVT LTD',
    'COLUMN SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'CONTINENTAL DATAGRAPHICS TECHNICAL SERVICES INDIA PRIVATE LIMITED',
    'CONSOLIDATED CYBERNETICS CO PRIVATE LIMITED',
    'COMPUCOM CSI SYSTEMS INDIA PRIVATE LIMITED',
    'CONGRUENT SOLUTIONS PVT LTD',
    'COMVERSE NETWORK SYSTEMS INDIA PRIVATE LIMITED',
    'CONTUS SUPPORT INTERACTIVE PRIVATE LIMITED',
    'COLLIERS INTERNATIONAL INDIA PROPERTY SERVICES PRIVATE LIMITED',
    'COOPER-STANDARD AUTOMOTIVE INDIA PRIVATE LIMITED',
    'CMA CGM LOGISTICS PARK DADRI PRIVATE LIMITED',
    'COBRA LEGAL SOLUTIONS PRIVATE LIMITED',
    'CONTINENTAL MILKOSE INDIA LTD',
    'COLLABERA SERVICES PRIVATE LIMITED',
    'CMS INFO SYSTEMS LTD',
    'COLOR PLUS FASHIONS LIMITED',
    'COMPUTER SCIENCES CORPORATION BUSINESS PROCESS SERVICES INDIA PRIVATE LIMITED',
    'CREMICA FOOD INDUSTRIES LTD',
    'COSMIC GLOBAL LIMITED',
    'Core Metal Krafts Limited',
    'CORE CHEMICALS MUMBAI PRIVATE LIMITED',
    'CREATIVE MANUFACTURING SOLUTIONS INDIA PRIVATE LIMITED',
    'COSMOS INFRA ENGINEERING (INDIA) LIMITED',
    'CPM INDIA SALES&MARKETING.PVTLTD',
    'Creative polypack ltd',
    'CURAM SOFTWARE INTERNATIONAL PRIVATE LIMITED',
    'CREATIVE PERIPHERALS AND DISTRIBUTION PRIVATE LIMITED',
    'CREDIT HIMATSINGKA PRIVATE LIMITED',
    'CSJ INFRASTRUCTURE PVT LTD',
    'COVENTRY COIL O MATIC HARYANA LTD',
    'CREATIVE STYLO PACKS PVT LTD',
    'CUSHMAN AND WAKEFIELD PROPERTY ADVISERS PRIVATE LIMITED',
    'CORNIER GENERATOR SALES AND SERVICES PRIVATE LIMITED',
    'CREST PROMOTERS PRIVATE LIMITED',
    'CROWLEYACCORD MARINE MANAGEMENT PRIVATE LIMITED',
    'CRESCENT INNOVATIVE PACKAGING PRIVATE LIMITED',
    'COSMO ELECTRO INDUSTRIES PRIVATE LIMITED',
    'Cosma international (india) private limited',
    'COSTRA ADVERTISING INDIA PRIVATE LIMITED',
    'CRAVE INFOTECH AND CONSULTANCY SERVICESPRIVATE LIMITED',
    'COSCO SHIPPING LINES INDIA PRIVATE LIMITED',
    'CORVETTE TECHNOLOGIES PRIVATE LIMITED',
    'CURTISS WRIGHT SURFACE TECHNOLOGIES INDIA PRIVATE',
    'COTELLIGENT INDIA PRIVATE LIMITED',
    'CRUST N CRUMB FOOD INGREDIENTS PRIVATELIMITED',
    'CSM SOFTWARE PRIVATE LIMITED',
    'CYGATE CLOUD SERVICES PRIVATE LIMITED',
    'CSI COMPUTECH INDIA PRIVATE LIMITED',
    'COUNTERCULTURE HOSPITALITY PRIVATE LIMITED',
    'CUREJOY HEALTH CARE INDIA PRIVATE LIMITED',
    'CRIYAGEN AGRI AND BIOTECH PVT LTD',
    'CYBERCOM DATAMATICS INFORMATION SOLUTIONS LIMITED',
    'CVC Network India Pvt Ltd',
    'CRYSTAL SOUND & MUSIC PRIVATE LIMITED',
    'CRANE PROCESS FLOW TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CSC E GOVERNANCE SERVICES INDIA LIMITED',
    'CYPRESS SEMICONDUCTOR TECHNOLOGY INDIA PRIVATE LIMITED',
    'CRYSTAL CERAMIC INDUSTRIES PRIVATE LIMITED',
    'CRAYON DATA INDIA PRIVATE LIMITED',
    'CORDYS SOFTWARE INDIA PRIVATE LIMITED',
    'CYIENT INSIGHTS PVT LTD',
    'COSOFT INDIA LIMITED',
    'CORRTECH INTERNATIONAL PRIVATE LIMITED',
    'CORIANT COMMUNICATION INDIA PRIVATE LIMITED',
    'CSR INDIA PRIVATE LIMITED',
    'CREAM EVENTS (INDIA) PRIVATE LIMITED',
    'COVANCE INDIA PHARMACEUTICAL SERVICES PRIVATE LIMITED',
    'CRESCENT LIFE SCIENCES PVT LTD',
    'CP MILK & FOOD PRODUCT PVT LTD',
    'CRENOVATIVE IDEAS PVT LTD',
    'CRAYONS.ADVERTISING PRIVATE LIMITED',
    'CYBIZ SUPERBRANDS PRIVATE LIMITED',
    'COUNTRY HOLIDAYS INN and SUITES PRIVATE LIMITED',
    'CYGILANT INDIA RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'CREDENCE RESOURCE MANAGEMENT PRIVATELIMITED',
    'DELL ORTO INDIA PRIVATE LIMITED',
    'D S WOODTECH LIMITED',
    'D D INTERNATIONAL PVT LTD',
    'DAVID BROWN GEAR SYSTEMS INDIA LIMITED',
    'DAMCO SOFT TECHNOLOGIES PRIVATE LIMITED',
    'DEAN INFOTECH PVT LTD',
    'DARRICK INSECTICIDES LTD',
    'DCM VIGILANCE & MAINTENANCE SERVICE OVT. LTD.',
    'DESAI FRUITS AND VEGETABLES PRIVATE LIMITED',
    'Delhivery Private Limited',
    'DAIICHI N HORIZON AUTOCOMP PRIVATE LIMITED',
    'DATA INFOSYS LIMITED',
    'DAY `N DAY SERVICES PRIVATE LIMITED',
    'DAVITA CARE (INDIA) PRIVATE LIMITED',
    'DECON INDIA PLASTICS PVT LTD',
    'DAVID BROWN DESIGN CENTRE PRIVATE LIMITED',
    'DDB MUDRA PVT LTD',
    'DELFINGEN INDIA PVT LTD',
    'DARVESH BUSSA REALTORS PVT LTD',
    'DECISIVEDGE TECHNOLOGY SERVICES INDIAPRIVATE LIMITED',
    'DAX NETWORKS LIMITED',
    'DATAMATICS SOFTWARE SERVICES LIMITED',
    'DERIV IT SOLUTIONS PRIVATE LIMITED',
    'D S DOORS INDIA LIMITED',
    'DELCAM SOFTWARE (INDIA) PRIVATE LIMITED',
    'DCNS INDIA PRIVATE LIMITED',
    'DAS OFFSHORE ENGINEERING PVT LTD',
    'DATATRACKS SERVICES LIMITED',
    'DESCON LIMITED',
    'DEL SEATEK INDIA PRIVATE LIMITED',
    'DANIEL MEASUREMENT SOLUTIONS PRIVATE LIMITED',
    'DANIELI INDIA LTD',
    'Dbxento systems private limited',
    'DENSO SUBROS THERMAL ENGINEERING CENTRE INDIA LIMITED',
    'DE LAGE LANDEN FINANCIAL SERVICES INDIA PRIVATE LIMITED',
    'Daiichi Kogyo India Pvt Ltd',
    'DAVIZTA (INDIA) PRIVATE LIMITED',
    'DAIWA PORTFOLIO ADVISORY INDIA PRIVATE LIMITED',
    'DATEX OHMEDA (INDIA) PRIVATE LIMITED',
    'DATATORRENT SOFTWARE INDIA PVT LTD',
    'DABEE TECHNOLOGY INDIA PRIVATE LIMITED',
    'DELUXE ENTERTAINMENT SERVICES INDIA PRIVATE LIMITED',
    'DAILY BREAD GOURMET FOODS (INDIA) PRIVATE LIMITED',
    'DAFFODIL SOFTWARE LIMITED',
    'DEFINITIVE SOURCING (INDIA) PRIVATE LIMITED',
    'DELHI STOCK EXCHANGE LIMITED',
    'daifuku india pvt ltd',
    'DENALI MANAGEMENT SERVICES PRIVATELIMITED',
    'DEEPERBLUE ASIA PACIFIC PVT LIMITED',
    'DEFENCE LAND SYSTEMS INDIA LIMITED',
    'DATAMATICS VISTA INFO SYSTEMS LIMITED',
    'DISHA HOTELS PVT LTD',
    'DIGITAL ONLINE SOLUTIONS PRIVATE LIMITED',
    'Digi drives pvt ltd',
    'DLF SOUTHERN HOMES PRIVATE LIMITED',
    'DEYS MEDICAL STORE (MANUFACTURING) LTD.',
    'DIVGI TORQTRANSFER SYSTEMS PRIVATE LIMITED',
    'DIMDIM SOFTWARE PRIVATE LIMITED',
    'DISHA FOODS PVT LTD',
    'dev it serv pvt ltd',
    'DIAMOND PRODUCTS LIMITED',
    'DLF EMPORIO RESTAURANTS LIMITED',
    'DIVYA NEXTGEN ENGICON PVT LTD',
    'DESIGNTECH SYSTEMS LIMITED',
    'DHANYA AGRO FARMS PRIVATE LIMITED',
    'DIANA RETAIL PRIVATE LIMITED',
    'DIL LIMITED',
    'DHARMESH JEWELLERS PVT LTD',
    'DIASORIN TRIVITRON HEALTHCARE PRIVATE LIMITED',
    'DIVYASHAKTI GRANITES LIMITED',
    'DIABU DIAMOND TOOLS (INDIA) PRIVATELIMITED',
    'DLF BRANDS LIMITED',
    'DISCOVERY COMMUNICATIONS INDIA PVT COMPANY WITH UNLIMITED LIABILITY',
    'DLB INFOTECH PRIVATE LIMITED',
    'DEV INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'DIVERSE BUSINESS HOLDINGS PRIVATE LIMITED',
    'DEVENDRA EXPORTS PRIVATE LIMITED',
    'DHFL Pramerica Asset Managers Private Limited',
    'DINDIGUL FARM PRODUCT PRIVATE LIMITED',
    'DIVYASREE INFRASTRUCTURE PROJECTS PVT LTD',
    'DIGITAL CHOCOLATE IT AND GAMING SOLUTIONS PRIVATE LIMITED',
    'DIMENSION DATA CLOUD SOLUTIONS INDIA PRIVATE LIMITED',
    'DIMERCO EXPRESS INDIA PRIVATE LIMITED',
    'DHANUSH INFOTECH PRIVATE LIMITED',
    'DISTANT FRONTIERS TOURS PRIVATE LIMITED',
    'DIGI M2M SOLUTIONS INDIA PRIVATE LIMITED',
    'DHR INTERNATIONAL INDIA PRIVATE LIMITED',
    'DIVA EXPORTS PVT LTD',
    'DHRUV CONSULTANCY SERVICES PRIVATE LIMITED',
    'Diptab Ventures Pvt Ltd',
    'DIGICALL TELESERVICES PRIVATE LIMITED',
    'DEUTEK CONTROLS INDIA LIMITED',
    'DIMENSION INDIA NETWORKS PRIVATE LIMITED.',
    'DIRECT INTERNET LIMITED',
    'DESMET BALLESTRA INDIA PRIVATE',
    'DLF POWER AND SERVICES LIMITED',
    'DESTIMONEY COMMODITIES PRIVATE LIMITED',
    'DIGIKORE STUDIOS PRIVATE LIMITED',
    'DONNA APPARELS PRIVATE LIMITED',
    'E SOLUTIONS IT SERVICES PRIVATE LIMITED',
    'DR.REDDYS HOLDINGS LIMITED',
    'DYNAMIC CABLES PRIVATE LIMITED',
    'DUGAL ASSOCIATES PRIVATE LIMITED',
    'DOUBLE SPRING MEDIA (INDIA) PRIVATE LIMITED',
    'DUNCANS TEA LIMITED',
    'DLIGHT ENERGY PRIVATE LIMITED',
    'DREAMFOLKS SERVICES PRIVATE LIMITED',
    'DR ENTERPRISE AUTOMOTIVE PRIVATE LIMITED',
    'DTDC SUPPLY CHAIN SOLUTIONS LIMITED',
    'DTDC E-COMMERCE LOGISTICS LIMITED',
    'E PACK POLYMERS PRIVATE LIMITED',
    'DOLI SYSTEMS PRIVATE LIMITED',
    'DRC SYSTEMS INDIA PRIVATE LIMITED',
    'DUTRON PLASTICS LIMITED',
    'DREAMAJAX TECHNOLOGIES PRIVATE LIMITED',
    'DR MOHANS DIABETES SPECIALITIES CENTRE PRIVATE LIMITED',
    'INTRICK CONSULTING PRIVATE LIMITED',
    'FETCHR INFO TECH PRIVATE LIMITED',
    'CONQUERORS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'CRATS INFOTECH (CHENNAI) PRIVATE LIMITED',
    'PSGG TECHNOLOGIES PRIVATE LIMITED',
    'RXADVANCE PBM INDIA PRIVATE LIMITED',
    'KWA ANALYTICS PRIVATE LIMITED',
    'INVOLVIO INDIA PRIVATE LIMITED',
    'EZ ENROUTE IT SOLUTIONS PRIVATE LIMITED',
    'ADD INNOVATIONS PRIVATE LIMITED',
    'NOIVO TECH PRIVATE LIMITED',
    'IMED IT SOLUTIONS INDIA PRIVATE LIMITED',
    'BUZZBOARD INDIA PRIVATE LIMITED',
    'NUCIS TECHNOLOGIES PRIVATE LIMITED',
    'CINTELL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'GROWTHWAVE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ALACER CONSULTING SERVICES PRIVATE LIMITED',
    'TECHNUMEN SYSTEMS PRIVATE LIMITED',
    'MYQSOFT INFOTECH PRIVATE LIMITED',
    'TESTORIGEN SOFTWARE TESTING SERVICES PRIVATE LIMITED',
    'SUBCODEVS IT CONSULTING AND SERVICES PRIVATE LIMITED',
    'AVETTI COMMERCE PRIVATE LIMITED',
    'THINKTREK WEBSOFT PRIVATE LIMITED',
    'VIBRANT LOGTALLY SOLUTIONS PRIVATE LIMITED',
    'SAPPHIRUS SYSTEMS PRIVATE LIMITED',
    'UPEN TECH SOLUTIONS PRIVATE LIMITED',
    'BROADCAST WEARABLES PRIVATE LIMITED',
    'SLN SOFTWARE CONSULTING PRIVATE LIMITED',
    'ECONTENTI INFOSOLINDIA PRIVATE LIMITED',
    'HIRE TAL CONSULTANCY PRIVATE LIMITED',
    'IGNIS IT SOLUTIONS PRIVATE LIMITED',
    'THE INDIAN ARBITRATION CENTRE',
    'EKDANT FARM DEVCON PRIVATE LIMITED',
    'Grep Ruby Webtech Private Limited',
    'Sarthak Pet Industries (India) Private Limited',
    'INFRASYS CONSULTING & ADVISORY PRIVATE LIMITED',
    'AANCHAL REALINFRA PRIVATE LIMITED',
    'AHEAD INDUSTRIES PRIVATE LIMITED',
    'SVAM CASTING PRIVATE LIMITED',
    'PARVATI SWEETNERS AND POWER LIMITED',
    'ALPINE RISK MITIGATION SERVICES PRIVATE LIMITED',
    'M-ADCALL DIGITAL MEDIA PRIVATE LIMITED',
    'SIDEFUSE WEB DEVELOPMENT PRIVATE LIMITED',
    'VARNITA TEXTILES PRIVATE LIMITED',
    'Epictenet Consultancy Private Limited',
    'SUKH SAGAR HOSPITALITY INDIA PRIVATE LIMITED',
    'M.V. Patel Lifestyle Private Limited',
    'Dabang Dunia Publications Private Limited',
    'DILIGENT PINKCITY CENTER PRIVATE LIMITED',
    'SAFETYPLUS PROTECTION PRIVATE LIMITED',
    'UPVC TECHNOCRATS PRIVATE LIMITED',
    'SHREENIDHI OILS & FOODS INGREDIENTS PRIVATE LIMITED',
    'DR. GOPALKRISHNA MEMORIAL DINDAYAL RESEARCH FOUNDATION',
    'CARMEL ORGANICS PRIVATE LIMITED',
    'Maikal Kanya International Private Limited',
    'SHRI RAM COMSOFT PRIVATE LIMITED',
    'JMD PRECISION EQUIPMENTS PRIVATE LIMITED',
    'P-TRADE FMCG PRIVATE LIMITED',
    'THE INDIAN ARBITRATION AND MEDIATION CENTRE PRIVATE LIMITED',
    'KHANDWA AGROH PATHWAYS PRIVATE LIMITED',
    'MHOW AGROH PATHWAYS PRIVATE LIMITED',
    'BELIEF BUILDCON PRIVATE LIMITED',
    'JAYSHRI GAYATRI FOOD PRODUCTS PRIVATE LIMITED',
    'PRISTINE ENVIRONMENTAL ASSOCIATES PRIVATE LIMITED',
    'POLYSHRI PRIVATE LIMITED',
    'PAVE ROOFING AND CONSTRUCTIONS PRIVATE LIMITED',
    'Devshreem Solutions Private Limited',
    'ROBOTRONIX ENGINEERING TECH PRIVATE LIMITED',
    'GOVIND FOODS INDIA PRIVATE LIMITED',
    'RACKBANK DATACENTERS PRIVATE LIMITED',
    'SAHYOGI INFRACARE PRIVATE LIMITED',
    'WITCOM INTREX PRIVATE LIMITED',
    'AAKRITI EDU CARE PRIVATE LIMITED',
    'CONCORDE RESERVES PRIVATE LIMITED',
    'CYLSYS SOFTWARE SOLUTION PRIVATE LIMITED',
    'GTA INFRACON LIMITED',
    'HIGH BROW MARKET RESEARCH INVESTMENT ADVISOR PRIVATE LIMITED',
    'Ishaan Solar Power Private Limited',
    'CARNIVAL MANAGEMENT SERVICES PRIVATE LIMITED',
    'ARIPRA INFOTECH PRIVATE LIMITED',
    'KD Packaging Private Limited',
    'PHYTO DRUGS PRIVATE LIMITED',
    'BANSAL PATHWAYS (DAMOH-KATNI) PRIVATE LIMITED',
    'BANSAL MINES AND MINERALS PRIVATE LIMITED',
    'IGNATIUZ SOFTWARE PRIVATE LIMITED',
    'ALGRO CONSULTANCY PRIVATE LIMITED',
    'GARNET MACHINES AND TOOLS INDIA PRIVATE LIMITED',
    'Halosis Consultants Private Limited',
    'VOCAL HEART INFOTECH PRIVATE LIMITED',
    'SAIFY HEALTHCARE AND MEDI-DEVICES (INDIA) PRIVATE LIMITED',
    'ZEHNTECH TECHNOLOGIES PRIVATE LIMITED',
    'GMV TERRAVENTURES PRIVATE LIMITED',
    'VALUABLE LIFESPACES PRIVATE LIMITED',
    'JAI SHREE MAHAKAAL INFOSOFT PRIVATE LIMITED',
    'OORJA TECHNICAL SERVICES PRIVATE LIMITED',
    'RYNA ENTERTAINMENT PRIVATE LIMITED',
    'UMBRA MINING PRIVATE LIMITED',
    'M. C. K. KUTTY ENGINEERS PRIVATE LIMITED',
    'DHULJI FINANCIAL SERVICES IMF PRIVATE LIMITED',
    'Weblength Infonet Private Limited',
    'BRINDLEYS ACCOUNTANCY SERVICES PRIVATE LIMITED',
    'Art Chef Creative Private Limited',
    'PIXELDO MEDIA PRIVATE LIMITED',
    'AMULETT EDUCATIONAL SERVICES PRIVATE LIMITED',
    'D K JAIN CORPORATE ADVISORS PRIVATE LIMITED',
    'MID-WAY INFRABUILD PRIVATE LIMITED',
    'FOURTY SEVEN BILLION INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'SHREE KESHAV INFRAESTATE PRIVATE LIMITED',
    'Aptech Agri Products Private Limited',
    'Indore Agritech Ventures (India) Private Limited',
    'Unnati Farms (India) Private Limited',
    'INDORE AGRITECH FIELDS PRIVATE LIMITED',
    'Indore Agritech Opportunities Private Limited',
    'Indore Agritech Vikas (India) Private Limited',
    'Money4drive Advertising Private Limited',
    'RAKUTEN SYMPHONY INDIA PRIVATE LIMITED',
    'SHREE SAI VEHICLES PRIVATE LIMITED',
    'ARROW BUILDTECH PRIVATE LIMITED',
    'HIMGIRI ENERGY VENTURES PRIVATE LIMITED',
    'AVP DIGITAL MEDIA PRIVATE LIMITED',
    'INNOWEAVE PACKAGING SOLUTIONS PRIVATE LIMITED',
    'EZEON TECHNOSOLUTIONS PRIVATE LIMITED',
    'P J REALTIES (INDORE) PRIVATE LIMITED',
    'BHADORA INDUSTRIES PRIVATE LIMITED',
    'EDUNIRVANA TRAINING SOLUTION PRIVATE LIMITED',
    'CITADEL REAL ESTATES PRIVATE LIMITED',
    'KHETAN RESORTS AND INFRATECH PRIVATE LIMITED',
    'mobiActivation Studios Private Limited',
    'PS COMPONENTS INDIA PRIVATE LIMITED',
    'UNICON METALS AND ALLOYS PRIVATE LIMITED',
    'NPA Infraestate Private Limited',
    'OPICLE TECHNOLOGIES PRIVATE LIMITED',
    'Lemion IT Solutions Private Limited',
    'IASSIST HEALTH PRIVATE LIMITED',
    'AGAMI TECH PRIVATE LIMITED',
    'MACKSOFY TECHNOLOGIES PRIVATE LIMITED',
    'Center of Ecommerce Excellence Private Limited',
    'DASSAULT SYSTEMES GLOBAL SERVICES PRIVATE LIMITED',
    'AsiaInfo Technologies (India) Private Limited',
    'Blackboard Information Technology India Private Limited',
    'Telr Payment Solutions India Private Limited',
    'DELTAKRAFT SOLUTIONS PRIVATE LIMITED',
    'ALPHA FIRST VENTURES PRIVATE LIMITED',
    'LearnQuest India Private Limited',
    'MERIDIAN IT (INDIA) PRIVATE LIMITED',
    'BYASA TECH SOLUTIONS PRIVATE LIMITED',
    'Instamojo Research and Development Private Limited',
    'KOBIAN ELECTRONICS INDIA PRIVATE LIMITED',
    'WEB WERKS INFRASTRUCTURE PRIVATE LIMITED',
    'PERFECT COPY SOLUTIONS PRIVATE LIMITED',
    'ZIP INFOSOLUTIONS PRIVATE LIMITED',
    'TRINITY DATA SYSTEMS PRIVATE LIMITED',
    'HIYA DIGITAL PRIVATE LIMITED',
    'ANTWORKS SOLUTIONS INDIA PRIVATE LIMITED',
    'Miscot Systems Private Limited',
    'PTOTEM TECHNOLOGIES PRIVATE LIMITED',
    'Orchid Software Services private limited',
    'GRITIK TECHNOLOGIES PRIVATE LIMITED',
    'KEERTI INSTITUTE INDIA PRIVATE LIMITED',
    'G-TEC JAIN KEERTI CAREER EDUCATION PRIVATE LIMITED',
    'ASCENT SmartWaves Private Limited',
    'ARWASYS TECHNOKRAFT PRIVATE LIMITED',
    'JET NETCOM BROADBAND PRIVATE LIMITED',
    'NeuOrb Consulting Private Limited',
    'ABH SOFTECH PRIVATE LIMITED',
    'ACQUIRED BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SMARTPADDLE TECHNOLOGY PRIVATE LIMITED',
    'CRAZE COMMERCE PRIVATE LIMITED',
    'CYLSYS WORLD WIDE PRIVATE LIMITED',
    'INNOVATIVE FOAM LIMITED',
    'BALT INDIA PRIVATE LIMITED',
    'XLPXL IT SOLUTIONS PRIVATE LIMITED',
    'CSGT Trading India Private Limited',
    'A10 Networks India Private Limited',
    'GexCon India Private Limited',
    'FirstView Consultants (India) Private Limited',
    'Intuitive Surgical India Private Limited',
    'Joinmay Electronic Private Limited',
    'THE SOUND BRAND CONSULTING AND STRATEGIC RESEARCH PRIVATE LIMITED',
    'Alma Medical Private Limited',
    'BELLISSIMO REAL ESTATE PRIVATE LIMITED',
    'New Democratic Electoral Trust',
    'Avenue E-Commerce Limited',
    'A. J. PARTS INDIA PRIVATE LIMITED',
    'Demetria Technology Private Limited',
    '22nd Avenue Talent Management Private Limited',
    'ENLINK MANAGED SERVICES PRIVATE LIMITED',
    'doLoop Technologies India Private Limited',
    'NexGear Technology Private Limited',
    'iGuru Ventures Private Limited',
    'CLOUDNANNY MANAGED SERVICES PRIVATE LIMITED',
    'Network24 Communications Private Limited',
    'LexiConn Content Services Private Limited',
    'iBinder Digital Private Limited',
    'FESTIVE PROPERTIES PRIVATE LIMITED',
    'AB COM PRIVATE LIMITED',
    'Skye Support sales and services Private Limited',
    'RN CHIDAKASHI TECHNOLOGIES PRIVATE LIMITED',
    'OORJAN CLEANTECH PRIVATE LIMITED',
    'A Little Big Entertainment Private Limited',
    'NINA PERCEPT PRIVATE LIMITED',
    'M-UJALA SOLARTECH PRIVATE LIMITED',
    'GRIDEDGE TECHNOLOGIES PRIVATE LIMITED',
    'Optiserv Solutions Private Limited',
    'Careeno International Private Limited',
    'TREDICI INTERIORS PRIVATE LIMITED',
    'IMPETUS',
    'S GOOD HEALTH ALWAYS CONSULTANCY PRIVATE LIMITED',
    'MONOFLOOR INDIA PRIVATE LIMITED',
    'Kenilworth India Consulting Private Limited',
    'Caitlyn India Private Limited',
    'Zuellig Pharma Specialty Solutions (India) Private Limited',
    'GRI-Alleset India Private Limited',
    'Zespri International (India) Private Limited',
    'S-Ancial Technologies Private Limited',
    'Rudraksh Research Foundation',
    'INNOVERTUS NUTRITION TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Academia Educare & Research Foundation',
    'WORLD TRADE CENTRE BHUBANESWAR (ODISHA) ASSOCIATION',
    'Interlink Banquets Private Limited',
    'INDUSTRIAL ASSET TRANSACTION SERVICES PRIVATE LIMITED',
    'DRINKASAUR SOFTWARE & LISTINGS PRIVATE LIMITED',
    'INCLUSIVE STUDENT PLACEMENT CONSULTANTS PRIVATE LIMITED',
    'GLOBAL INTELLIGENCE SOFTWARE LIMITED',
    'Wisedom Advertising private limited',
    'MAHARASHTRA TOURISM DEVELOPMENT CORPORATION LIMITED',
    'HI-FATIGUE SPRINGS PRIVATE LIMITED',
    'FOURESS INVESTMENTS PRIVATE LIMITED',
    'SIDDHI POLYCHEM PVT LTD',
    'GREEN OZONE MINERALS PRIVATE LIMITED',
    'METAL MINING INDUSTRIES (I) PRIVATE LIMITED',
    'Drishyam Films Private Limited',
    'KOTHARI FERRO GOLD INDUSTRIES PRIVATE LIMITED',
    'AEI EXPLOMOBILE PRIVATE LIMITED',
    'VERACITY GROUP (INDIA) PRIVATE LIMITED',
    'Konselect Educare Private Limited',
    'NAGPUR WASTE WATER MANAGEMENT PRIVATE LIMITED',
    'WAS-ANU COMSYS PRIVATE LIMITED',
    'GREENAIR INFRA TECH SOLUTIONS PRIVATE LIMITED',
    'CODEGREEN ENERGY PRIVATE LIMITED',
    'LOGISTICS CITY PRIVATE LIMITED',
    'UNIVICTOR HEALTHCARE PRIVATE LIMITED',
    'CLIMIC HEALTH PRIVATE LIMITED',
    'SUNBEAM DEVELOPERS AND CONSTRUCTIONS PRIVATE LIMITED',
    'NAGPUR VASTRAUDHYOG PRIVATE LIMITED',
    'Cineyug International Entertainment Private Limited',
    'Duskline Infrastructures Private Limited',
    'ErgoMe Healthtech Private Limited',
    'DRISHTI ENRICHMENT PRIVATE LIMITED',
    'SAVITRI DEVI FOUNDATION',
    'SMS Waste Management Private Limited',
    'ENVOCARE PEST CONTROL SERVICES PRIVATE LIMITED',
    'INTERNATIONAL MARITIME FEDERATION',
    'KSHMTA PROJECTS & CONTRACTING PRIVATE LIMITED',
    'SABA DEVELOPERS AND BUILDERS PRIVATE LIMITED',
    'ECSION RESEARCH LABS PRIVATE LIMITED',
    'RESISTOTECH INDIA PRIVATE LIMITED',
    'MobiCore Info Tech Softwares and Energy Private Limited',
    'AGILE CONNECTS PRIVATE LIMITED',
    'TECHNOBASE IT SOLUTIONS PRIVATE LIMITED',
    'ARAV SYSTEMS PRIVATE LIMITED',
    'UNIQUE-DK DEVELOPERS PRIVATE LIMITED',
    'CELLX SOLUTIONS PRIVATE LIMITED',
    'MARVEL TECHNOLOGIES PRIVATE LIMITED',
    'SG Studio 4 Technologies Private Limited',
    'CompanyHub IT Solutions private limited',
    'MasterSoft ERP Solutions Private Limited',
    'ORBITSYS CONSULTANCY PRIVATE LIMITED',
    'MERA FOOD CHOICE PRIVATE LIMITED',
    'PRIYA SALES PRIVATE LIMITED',
    'RANIUM SYSTEMS PRIVATE LIMITED',
    'PURPLE TUCHE BRAND SOLUTIONS PRIVATE LIMITED',
    'RMR ENVITECH PRIVATE LIMITED',
    'ALPHAVISION MULTIVENTURES (I) PRIVATE LIMITED',
    'R C PLASTO PACKAGING PRIVATE LIMITED',
    'dimension NXG private limited',
    'SONAI CATTLE FEED PRIVATE LIMITED',
    'AGRIYUG ENERGY (INDIA) PRIVATE LIMITED',
    'RUMITECH NUTRITION (INDIA) PRIVATE LIMITED',
    'Rajapur Agri Estates Private Limited',
    'WiseGuy Research Consultants Private Limited',
    '7 HORSE ENTERTAINMENT PRIVATE LIMITED',
    'RALIABILL IT SERVICES PRIVATE LIMITED',
    'DPJAIN (NAGDA-GOGAPUR) BOT ANNUITY PROJECT PRIVATE LIMITED',
    'Psquare Foods India Private Limited',
    'SUN DEVELOPERS AND CONSTRUCTION PRIVATE LIMITED',
    'CENTURION OVERSEAS PRIVATE LIMITED',
    'KK SERVICES PRIVATE LIMITED',
    'SUJAL PLAST PRIVATE LIMITED',
    'MILLSTONE SPECIALITY FOODS PRIVATE LIMITED',
    'STARTERMAN FOODS INDIA PRIVATE LIMITED',
    'PERITUS CONTROL EQUIPMENTS PRIVATE LIMITED',
    'REGENEL ELECTRIC SOLUTIONS PRIVATE LIMITED',
    'NSM TECHNOLOGIES PRIVATE LIMITED',
    'BROWN PAPER TECHNOLOGIES LIMITED',
    'Seaworthy Pack-tech Private Limited',
    'P P BAFNA VENTURES PRIVATE LIMITED',
    'PUDUMJEE PAPER PRODUCTS LIMITED',
    'Crew Automation & Electrical Private Limited',
    'HS3D VISUALIZATION PRIVATE LIMITED',
    'Mack Auraa Healthcare Private Limited',
    'Gaia Business Consultants Private Limited',
    'VISHWA SUPPLY PRIVATE LIMITED',
    'GeoSpatial Design Labs Private Limited',
    'INTELLECT DNYAN AND AADHAR FOUNDATION',
    'AMAGIC HOLOGRAPHICS INDIA PRIVATE LIMITED',
    'KOHINOOR ROPES PRIVATE LIMITED',
    'SOIL AGRO INDIA PRODUCER COMPANY LIMITED',
    'PRERNA BEVERAGES PRIVATE LIMITED',
    'AIMPEEM INDUSTRIES INDIA PRIVATE LIMITED',
    'SKM Food Private Limited',
    'UKAY LUGGAGE INDIA PRIVATE LIMITED',
    'NASHIK PACKAGING PRIVATE LIMITED',
    'GREEN PLANET FOODS PRIVATE LIMITED',
    'BODY BASICS RETAIL PRIVATE LIMITED',
    'Porite India Private Limited',
    'AYASTO STEELPAC PRIVATE LIMITED',
    'ROFU INDIA PRIVATE LIMITED',
    'KW POLYPACK INDIA PRIVATE LIMITED',
    'IBEX NEW CONCEPTS PRIVATE LIMITED',
    'Primus Media Private Limited',
    'SIMSOFT TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'MobiNext Technologies Private Limited',
    '9EDGE TECHNOLOGIES PRIVATE LIMITED',
    'CITIUS COMMUNICATIONS PRIVATE LIMITED',
    'Altius Digital Private Limited',
    'EWEBCORE TECHNOLOGIES PRIVATE LIMITED',
    'BROCADE MOBILITY PRIVATE LIMITED',
    'DOGFI.SH Mobile India Private Limited',
    'MASPOLI VENTURES PRIVATE LIMITED',
    'RAMMY TRADE SOLUTIONS PRIVATE LIMITED',
    'DRONA AVIATION PRIVATE LIMITED',
    'REALIX INDUSTRIES PRIVATE LIMITED',
    'ALFAAN EQUIPMENTS PRIVATE LIMITED',
    'RED CARPET TRAVEL SERVICES PRIVATE LIMITED',
    'TRAVELLITE TRAVEL SERVICES INDIA PRIVATE LIMITED',
    'SSV BROADBAND PRIVATE LIMITED',
    'Protect India Insurance Broking Services Private Limited',
    'FINO FINANCIAL SERVICES PRIVATE LIMITED',
    'Rosa Realty private Limited',
    'PEHAL INDIA PRIVATE LIMITED',
    'Consortexe Properties Private Limited',
    'SSV PROPERTIES PRIVATE LIMITED',
    'INTELIFOR TECHNOLOGIES PRIVATE LIMITED',
    'OPTICOM INFOWAY PRIVATE LIMITED',
    'Raavas Realtors Private Limited',
    'Sellergize Web Technology Services Private Limited',
    'Mousebyte Solutions Private Limited',
    'NEOTERIC GLOBE SERVICES PRIVATE LIMITED',
    'ADALBERT HEALTHCARE PRIVATE LIMITED',
    'TENDULKAR HOTELS PRIVATE LIMITED',
    'Yellow Sun Restaurants Private limited',
    'ICONIC TRANS AGRO PRIVATE LIMITED',
    'GAVAKSHA GLOBAL FREIGHT PRIVATE LIMITED',
    'SHARP MARKET RESEARCH PRIVATE LIMITED',
    'I2SL Emerging India Council',
    'MORNINGSTAR INVESTMENT ADVISER INDIA PRIVATE LIMITED',
    'ALIVIRA ANIMAL HEALTH LIMITED',
    'INDOTHERMO FURNACE & ENGINEERS PRIVATE LIMITED',
    'ERELEGO DIGI MEDIA PRIVATE LIMITED',
    'PUREPLAY SKIN SCIENCES (INDIA) PRIVATE LIMITED',
    'Core Laboratories India Private Limited',
    'Primetals Technologies India Private Limited',
    'Vednim Consulting Services OPC Private Limited',
    'KCC TECHNOLOGIES PRIVATE LIMITED',
    'SSK CITIZEN SERVICES PRIVATE LIMITED',
    'REDSOFT SOLUTIONS PRIVATE LIMITED',
    'KARRM CURRICULUM PRIVATE LIMITED',
    'SUIVANT SOFTWARE SERVICES PRIVATE LIMITED',
    'Cyquator Tech Private Limited',
    'TRUMPCAD TECHNOLOGIES PRIVATE LIMITED',
    'Ausland Ship Management Services Private Limited',
    'MESOTEK TECHNOLOGIES PRIVATE LIMITED',
    'KNOWLEDGE COMMUNITY COM (INDIA) PRIVATE LIMITED',
    'KARMA YOGA VEDANTA PRIVATE LIMITED',
    'Cubestack Solutions Private Limited',
    'PMI ENTERPRISES PRIVATE LIMITED',
    'VIVIFY SOLUTIONS PRIVATE LIMITED',
    'MindSpace Software Technologies Private Limited',
    'Seek2Share Technologies Private Limited',
    'SOFTMANAGE SOLUTION & SERVICES PRIVATE LIMITED',
    'CROWDFIRE INDIA PRIVATE LIMITED',
    'Capsag Consulting Services Private Limited',
    'INFOBRIDGE INFORMATION SERVICES PRIVATE LIMITED',
    'A2GS Marketing Solutions Private Limited',
    'G-ORDINATEUR PRIVATE LIMITED',
    'CHRONOS TECH SOLUTIONS PRIVATE LIMITED',
    'BUZIBEE TECHNOLOGIES PRIVATE LIMITED',
    'OAKTECH CONSULTANCY PRIVATE LIMITED',
    'PRANCONS INFRATECH PRIVATE LIMITED',
    'Bombay JCB Earthmovers Private Limited',
    'SPA TECHSOFT PRIVATE LIMITED',
    'NORTHWEST REVENUE CYCLE MANAGEMENT PRIVATE LIMITED',
    'NMBRLOGIC INTERNET PRIVATE LIMITED',
    '360Digital Hub Private Limited',
    'ZPMC Engineering (India) Private Limited',
    'DMW CORPORATION INDIA PRIVATE LIMITED',
    'BPM-DISCIPLINE CONSULTANCY PRIVATE LIMITED',
    'PANKYPUNNU E-COMMERCE PRIVATE LIMITED',
    'Encure Medical Private Limited',
    'Navi Mumbai Chamber of Business & Industries',
    'FRESH BOX MEDIA PRIVATE LIMITED',
    'ZEAL CO-TEAM PRIVATE LIMITED',
    'East West Energy Systems Private Limited',
    'Hyqee Ecommerce Private Limited',
    'ENF REAL ESTATE PRIVATE LIMITED',
    'ELITE OFFSHORE PRIVATE LIMITED',
    'MAARSHA INTERNATIONAL PRIVATE LIMITED',
    'UNITED FOUR FACILITY AND SECURITY SERVICES PRIVATE LIMITED',
    'Planet Business Support Services India Private Limited',
    'ENKAY MARCOMM PRIVATE LIMITED',
    'AV&T Solutions Private Limited',
    'Meena Resources Private Limited',
    'CAREER GUIDELINE SERVICES INDIA PRIVATE LIMITED',
    'CHEMICO HEALTH AND BEAUTY INDIA PRIVATE LIMITED',
    'NSD GLASS LIMITED',
    'Esente Healthcare Private Limited',
    'PADM LABORATORIES PRIVATE LIMITED',
    'Mectus Systems India Private Limited',
    'TRANSGEAR POWER SYSTEMS PRIVATE LIMITED',
    'RAYACME POWER INDIA PRIVATE LIMITED',
    'FRONTIER FURNITURE SYSTEMS PRIVATE LIMITED',
    'Genworks Health Private Limited',
    'Biocon Pharma Limited',
    'KONVERGE HEALTHCARE PRIVATE LIMITED',
    'SELMOUNT POWER SYSTEMS PRIVATE LIMITED',
    'QHL LIGHTING ELECTRONICS PRIVATE LIMITED',
    'Aspire Fire & Safety Private Limited',
    'PNS SYSTEMS PRIVATE LIMITED',
    'Trendstyle Furniture Private Limited',
    'AUGUST JEWELLERY PRIVATE LIMITED',
    'SPECTRUS SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'IIGP VALVE TECHNOLOGY PRIVATE LIMITED',
    'ANANDALAL ELECTRIC PRIVATE LIMITED',
    'TSR Recycling India Private Limited',
    'Prakruthi Recycling Private Limited',
    'Shudh-Labh Solutions Private Limited',
    'Veiva Scientific India Private Limited',
    'ATONARP MICRO-SYSTEMS INDIA PRIVATE LIMITED',
    'Leader Biomedical and Surgicals India Private Limited',
    'HAPPY RELIABLE SURGERIES PRIVATE LIMITED',
    'UNISUR LIFECARE PRIVATE LIMITED',
    'VENA ENERGY RODALBANDA PRIVATE LIMITED',
    'INTELLICAR TELEMATICS PRIVATE LIMITED',
    'Rohan Solar Power Private Limited',
    'VENA ENERGY SOLAR INDIA POWER RESOURCES PRIVATE LIMITED',
    'EcoSoch Solar Private Limited',
    'MVM SOLAR PRIVATE LIMITED',
    'NucleOSS Dental Implants Private Limited',
    'Hearfon Systems Private Limited',
    'ADILAB TECHNOLOGIES PRIVATE LIMITED',
    'Innov4Sight Health and Biomedical Systems Private Limited',
    'SRI VEERABHADRA VAHANA ENGINEERS PRIVATE LIMITED',
    'SAMASHTI Engineering Private Limited',
    'MEGHANA HOMES PRIVATE LIMITED',
    'Cigam Ventures Private Limited',
    'Beijing Shougang Engineering India Private Limited',
    'PREVALENCE GREEN SOLUTIONS PRIVATE LIMITED',
    'SIMPLE-TECH AEROSPACE PRIVATE LIMITED',
    'Aviotrix Aerospace Private Limited',
    'ABEsquare Furnish Private Limited',
    'INF Sales And Services Private Limited',
    'Beth Lifestyle Private Limited',
    'ELETTROMIL INDIA PRIVATE LIMITED',
    'RIZZIN TECHNOLOGY PRIVATE LIMITED (OPC)',
    'M.S.EARTH EVENTS (INDIA) PRIVATE LIMITED',
    'SUNLARGE FILAMENTS PRIVATE LIMITED',
    'CANADIAN SOLAR ENERGY PRIVATE LIMITED',
    'A PLUS FIXTURES INDIA PRIVATE LIMITED',
    'MILLENNIUM LIFE STYLE PRIVATE LIMITED',
    'MADHYARANGA ENERGY PRIVATE LIMITED (OPC)',
    'PRIME GASES PRIVATE LIMITED',
    'Devarahipparigi Wind Power Private Limited',
    'WINRAY LABS PRIVATE LIMITED',
    'VENA ENERGY GUDADUR PROJECT PRIVATE LIMITED',
    'Atria Wind Private Limited',
    'Mimesis Wind Energy Private Limited',
    'Drive Hydraulic Products Private Limited',
    'ES ENERGY PRIVATE LIMITED',
    'HV Ventures Projects Private Limited',
    'ROYAUME BUILDERS AND PROMOTERS PRIVATE LIMITED',
    'Vajram holdings private limited',
    'MERITNOVA INFRA SERVICES PRIVATE LIMITED',
    'Capricoast Home Solutions Private Limited',
    'SVAMITVA CONSTRUCTION PRIVATE LIMITED',
    'JENU IRUVE NIRMAAN PRIVATE LIMITED',
    'PROPERTY VAULT INDIA PRIVATE LIMITED',
    'THRIVE 360EAST DEVELOPERS PRIVATE LIMITED',
    'Prozest Realty Private Limited',
    'TRIDENT AUTO PRIVATE LIMITED',
    'STEVE MOTORS INDIA PRIVATE LIMITED',
    'Hoteon Trading Private Limited',
    'SHUBHAKARINI INFRA PRIVATE LIMITED',
    'BRANCO GYPSUM PRIVATE LIMITED',
    'ROTER LEHMANNPARTNER INDIA PRIVATE LIMITED',
    'KENTRON INFRA PRIVATE LIMITED',
    'SRI BAL FAB TECH PRIVATE LIMITED',
    'KELBUZZ Trading Private Limited',
    'SHIORA SOLUTIONS PRIVATE LIMITED',
    'Jivana Vitality India Private Limited',
    'NEOTEL COMMUNICATIONS PRIVATE LIMITED',
    'Euro Postech India Private Limited',
    'NinthMile Constructions Private Limited',
    'Tauheed Enterprises Private limited',
    'Metricbay Projects Private Limited',
    'UNICCA CONSTRUCTIONS & PROJECTS PRIVATE LIMITED',
    'EXCELL ENMARK PRIVATE LIMITED',
    'SUFFIX CREATIVE POOLS PRIVATE LIMITED',
    'APG COMMUNITY DEVELOPMENT PRIVATE LIMITED',
    'MD RETAIL INDIA PRIVATE LIMITED',
    'RIDA DEVELOPERS PRIVATE LIMITED',
    'Purpleyo Technologies Private Limited',
    'APVS Enterprises Private Limited',
    'STN Infra Private Limited',
    'OMERIN WIRES AND CABLES PRIVATE LIMITED',
    'NESARA GARDENS PRIVATE LIMITED',
    'GLENTEC HOLDINGS PRIVATE LIMITED',
    'VIVANT COATINGS INDIA PRIVATE LIMITED',
    'Fabulous Business Centre Private Limited',
    'MYNTRA JABONG INDIA PRIVATE LIMITED',
    'Spectacular Business Centre Private Limited',
    'NGI APEX IT INDIA PRIVATE LIMITED',
    'AlliedMetals (India) Private Limited',
    'ADORI LABS INDIA PRIVATE LIMITED',
    'Japanese Help Desk Services Private Limited',
    'ANTHOLOGY INTERNATIONAL PRIVATE LIMITED',
    'Gale Creative Agency Private Limited',
    'SBD INDIA PRIVATE LIMITED',
    'DRG Analytics & Insights Private Limited',
    'ExxonMobil Services & Technology Private Limited',
    'QUAVAC INDIA PRIVATE LIMITED',
    'WidasConcepts India Private Limited',
    'Smart Cities India Foundation',
    'EUROPEAN AMERICAN & ASIA FOREIGN CHAMBER OF COMMERCE AND INDUSTRY.',
    'CENTER FOR ASSISTED REPRODUCTION EMBRYOLOGY & ENDOSCOPY FERTILITY PRIVATELIMITED',
    'Gamatics India Private Limited',
    'Gladwin Analytics Private Limited (OPC)',
    'Pragyan Datalabs Private Limited (OPC)',
    'KOVAI MANAGEMENT SERVICES PRIVATE LIMITED (OPC)',
    'Abani Properties Private Limited',
    'Black and Yellow Mix Media Private Limited',
    'Saavarni Consulting Services Private Limited',
    'E AND M EXIM PRIVATE LIMITED',
    'DeliveryOntime Logistics Private Limited',
    'K & K Conveying Technology Private Limited',
    'KVP Business Solutions Private Limited',
    'Flipcarbon Integrated Solutions Private Limited',
    'CONCEPT FACILITIES MANAGEMENT (INDIA) PRIVATE LIMITED',
    'Myfi Communications Private Limited',
    'Lead Strategic Development Private Limited',
    'NetAnalytiks Technologies Private Limited',
    'tskamath Technologies private limited',
    'MJMARG CONSULTING PRIVATE LIMITED',
    'NABU MARKETING PRIVATE LIMITED',
    'Analyse Digital Business Solutions Private Limited',
    'K.S.POWER SOLUTIONS & SERVICES PRIVATE LIMITED',
    'NVT QUALITY BUILD SOLUTIONS PRIVATE LIMITED',
    'PURPLEHAT BRAND COMMUNICATIONS PRIVATE LIMITED',
    'TUSKER WORKSPACE PRIVATE LIMITED',
    'SKJ Sports Promotions Private Limited',
    'INSTACAL ENGINEERS PRIVATE LIMITED',
    'AIRA SERVICED APARTMENTS PRIVATE LIMITED',
    'Funfinity Learning Solutions Private Limited',
    'Transitions Optical Distribution Private Limited',
    'Prettl India Private Limited',
    'DOTMAPPERS IT PRIVATE LIMITED',
    'HIPSHIP ONLINE SERVICE PRIVATE LIMITED',
    'Saturam Technologies Private Limited',
    'ATOS IT SERVICES PRIVATE LIMITED',
    'BHARAT LIME ASSOCIATION',
    'SPOOK DIGITAL INDIA PRIVATE LIMITED',
    'TAGMA Centre of Excellence and Training',
    'LUSO IBERIA PERFUMES PRIVATE LIMITED (OPC)',
    'VCNR BUILDERS AND DEVELOPERS LIMITED',
    'ANKURAM SOCIAL VENTURES PRIVATE LIMITED',
    'Conceptual Life Consulting Private Limited',
    'BETTERPLACE SAFETY SOLUTIONS PRIVATE LIMITED',
    'SoStakes Services Private Limited',
    'FLOLEARNING SOLUTIONS PRIVATE LIMITED',
    'Truweight Wellness Private Limited',
    'MERITZEAL MARKETING SOLUTIONS PRIVATE LIMITED',
    'GEN FORCE AND ALLIED SERVICES PRIVATE LIMITED',
    'Cornerstone Property Management Private Limited',
    'Instavans Logistics Private Limited',
    'Lodestar Education Services Private Limited',
    'Prognosys Healthcare (India) Private Limited',
    'Andaz InfoTech Private Limited',
    'FAVANTE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'APPSOURCE SERVICES PRIVATE LIMITED',
    'INFOCOGNITIO SOLUTIONS PRIVATE LIMITED',
    'TVAKSA TECHNOLOGIES PRIVATE LIMITED',
    'River Business Solutions Private Limited',
    'Nuwill Research and Innovations Private Limited',
    'TRUSTED STAY PRIVATE LIMITED',
    'UNIHEIGHTS INTERIO PRIVATE LIMITED',
    'CAELEN CONSULTING PRIVATE LIMITED',
    'CBD WORKSPACES PRIVATE LIMITED',
    'DynCorp International Business Services Private Limited',
    'AVSS EFORRM (INDIA) PRIVATE LIMITED',
    'GLOBOCOM INFOTECH PRIVATE LIMITED',
    'QLIKEN TECHNOLOGIES PRIVATE LIMITED',
    'CapSource Talent Services Private Limited',
    'JobsForHer Restart Portal Private Limited',
    'AUM ZONE ONLINE SERVICES PRIVATE LIMITED',
    'Buyhatke Internet Private Limited',
    'GAPOON ONLINE CONSUMER SERVICES PRIVATE LIMITED',
    'Master Aapt Security and Facility Services Private Limited',
    'MVX Foods and Beverages Private Limited',
    'AAHANA DESIGNS AND INTERIORS PRIVATE LIMITED',
    'ELECTROLUX INDIA PRIVATE LIMITED',
    'ARCLAYS BUSINESS SOLUTIONS OPC PRIVATE LIMITED',
    'HOROMETRICAL DEVICES (INDIA) PRIVATE LIMITED',
    'ACMEMINDS PRIVATE LIMITED',
    'BUSINESS THRUST TECHSOFT PRIVATE LIMITED',
    'Transform HR Solutions OPC Private Limited',
    'RADHE RADHE CAPITAL MARKET PRIVATE LIMITED',
    'DS SOLUTIONS PRIVATE LIMITED',
    'ZVESTA ONLINE PRIVATE LIMITED',
    'TECHFEEL SAFETY TEXTILES PRIVATE LIMITED',
    'Cognitrex Consultants Private Limited',
    'DEVANKIT POWER SYSTEMS PRIVATE LIMITED',
    'BARAATI EVENT MANAGEMENT PRIVATE LIMITED',
    'Mediatel Communications International Private Limited',
    'TRIPLE LINK PRIVATE LIMITED',
    'DARONA PERFECT SALES SOLUTION PRIVATE LIMITED',
    'INDIA EVALUATION PRIVATE LIMITED',
    'Tycoon Computers Private Limited',
    'Healthlane Technologies Private Limited',
    'PLANET WIFI PRIVATE LIMITED',
    'ZIBAL TECHNOLOGIES PRIVATE LIMITED',
    'SightLife Advisory Private Limited',
    'Renovite Payment Solutions Private Limited',
    'SPAG DIGITAL PRIVATE LIMITED',
    'ARVIND BUILDWELL OPC PRIVATE LIMITED',
    'CICERONE TECHNOLOGIES PRIVATE LIMITED',
    'MILK INFOTECH PRIVATE LIMITED',
    'Jindal Coke Limited',
    'BLUESEAL AGRO PRIVATE LIMITED',
    'VASANT VEGGIE FARMER PRODUCER COMPANY LIMITED',
    'SHANTI SAGAR INTERNATIONAL DREDGING LIMITED',
    'GOTIZ RESOURCES LIMITED',
    'QUICKSTOP CAR CARE PRIVATE LIMITED',
    'DHAMRA LNG TERMINAL PRIVATE LIMITED',
    'Drilling Mentor Private Limited',
    'SALASAR INTERNET SERVICES PRIVATE LIMITED',
    'ARGENT LIGHTS PRIVATE LIMITED',
    'GURGAON CRICKET LEAGUE',
    'ABES HEALTH & NUTRITION (INDIA) PRIVATE LIMITED',
    'SCUBEN Ecommerce Private Limited',
    'VRINDA GLOBAL PRIVATE LIMITED',
    'Forensodigital Technologies Private Limited',
    'GREEN SKY CONSULTANTS PRIVATE LIMITED',
    'UNITECH GLASS TECH PRIVATE LIMITED',
    'NAVSHELL INTERNATIONAL PRIVATE LIMITED',
    'AGARWAL DENIM PRIVATE LIMITED',
    'SUDHA SANJEEV MEDICOS PRIVATE LIMITED',
    'RAJ MEGACON PRIVATE LIMITED',
    'BRD TEXTILES LIMITED',
    'URBAN FARMERS PRIVATE LIMITED',
    'ZAPBYTES TECHNOLOGIES PRIVATE LIMITED',
    'ISGEC SFW BOILERS PRIVATE LIMITED',
    'GLOPACT ENTERPRISES PRIVATE LIMITED',
    'CREDENCE CHEM PRIVATE LIMITED',
    'NEWEL LIFESCIENCES PRIVATE LIMITED',
    'Kiri Laboratories Private Limited',
    'JOYLAND MARKETING AND ENTERTAINMENT PRIVATE LIMITED',
    'BIOKINDLE LIFESCIENCES PRIVATE LIMITED',
    'RHYTEK ORGANICS PRIVATE LIMITED',
    'NS EVENT MANAGEMENT PRIVATE LIMITED',
    'TRA CHIT FUND CO PVT LTD',
    'TENAX GEOSYNTHETICS PRIVATE LIMITED',
    'TRIPEX OVERSEAS LIMITED',
    'GOODFARMS HAPPYCOWS PRIVATE LIMITED',
    'RUSHIKA FOOD PRODUCTS PRIVATE LIMITED',
    'DIVYA GLOBAL NUTS PRIVATE LIMITED',
    'DESAI INDUSTRIES PRIVATE LIMITED',
    'Maxxis Rubber India Private Limited',
    'Flourish FoodProducts Private Limited',
    'FUJI SILVERTECH CONCRETE PRIVATE LIMITED',
    'SHREE PORCELLANO PRIVATE LIMITED',
    'MOG TECHNOLOGIES PRIVATE LIMITED',
    'COPPER COMPONENTS AND ALLOYS LIMITED',
    'TORRENZA MOULD CRAFT PRIVATE LIMITED',
    'SANFO FOODS PRIVATE LIMITED',
    'MAA PANEL (INDIA) PRIVATE LIMITED',
    'GANDHINAGAR AUTOMOBILES PRIVATE LIMITED',
    'VENUS COMPRESSORS PRIVATE LIMITED',
    'EnSave Energy Private Limited',
    'BRINDA PHARMA TECHNOLOGIES PRIVATE LIMITED',
    'BABUL PRODUCTS PRIVATE LIMITED',
    'Efficore Energy Solutions Private Limited',
    'OASIS RENEWABLES AND WATER TREATMENT LIMITED',
    'CRUZE WATER TECH PRIVATE LIMITED',
    'LEXCRU WATER TECH PRIVATE LIMITED',
    'MECASTER FLOW SOLUTIONS PRIVATE LIMITED',
    'Rapid BevTech Private Limited',
    'JAYSHRI WEAVETECH PRIVATE LIMITED',
    'R.R.VIBRANT POLYMERS LIMITED',
    'SURYA PANEL PRIVATE LIMITED',
    'S KUMAR INDUSTRIES LIMITED',
    'TACON SECURITY SYSTEM PRIVATE LIMITED',
    'MELAMINE AND FIBRE BOARDS LIMITED',
    'KANKARIYA PETRO CHEMCICAL INDUSTRIES PRIVATE LIMITED',
    'Hema Remedies Private Limited',
    'DIVYAKSH ENGITECH PRIVATE LIMITED',
    'RESONANT PHARMACEUTICALS PRIVATE LIMITED',
    'ELEMENT SKY VILLAS PRIVATE LIMITED',
    'U R ENERGY (SOLAR) PRIVATE LIMITED',
    'ADANI GREEN ENERGY LIMITED',
    'SHARDA MA ENTERPRISES PRIVATE LIMITED',
    'SHUBH PRODUCTS PRIVATE LIMITED',
    'ABHILASH GROWTH FUND PRIVATE LIMITED',
    'BHAWANI IMPEX PVT. LTD.',
    'D V S INDUSTRIES PRIVATE LIMITED',
    'NAHAR GROWTH FUND PRIVATE LIMITED',
    'DigiNext Education Private Limited',
    'TRIEDGE SOLUTIONS PRIVATE LIMITED',
    'SAGA DEPARTMENT STORES PRIVATE LIMITED',
    'A. K. CAPITAL MARKETS LIMITED',
    'BHUSHAN ARORA PROPERTIES AND FINANCE PRIVATE LIMITED',
    'SUPANAVI TRADING PRIVATE LIMITED',
    'LALIT AIRWAYS PRIVATE LIMITED',
    'NUMBER-ONE CONSTRUCTIONS PRIVATE LIMITED',
    'FORTUNE TOURS AND EXPO PRIVATE LIMITED',
    'RAAJ KHOSLA AND CO PRIVATE LIMITED',
    'S D S TUBES PRIVATE LIMITED',
    'DHARAMSONS MARKETING PRIVATE LIMITED',
    'RUDRABHISHEK ENTERPRISES LIMITED',
    'AADHARSHILA TOWERS PRIVATE LIMITED',
    'BAJAJ JEWELS (INDIA) PRIVATE LIMITED',
    'VIR SINGH SANTOKH SINGH ANAND (FABRICATORS) PRIVATE LIMITED',
    'COMPUCOVER EAST PRIVATE LIMITED',
    'LEENA PROMOTERS AND DEVELOPERS PRIVATE LIMITED',
    'TRINETRA IMPEX PRIVATE LIMITED',
    'MINAR TRAVELS (INDIA) PVT LTD',
    'ARORA & ASSOCIATES INFRADEVELOPERS PRIVATE LIMITED',
    'ASHMIN CARGO SERVICES PRIVATE LIMITED',
    'MODEX CAPITAL MANAGEMENT PRIVATE LIMITED',
    'ELITE PROMOTORS PRIVATE LIMITED',
    'HPL ELECTRIC & POWER Limited',
    'TRIPLE KAY DISTRIBUTING CO PRIVATE LIMITED',
    'TRIDENT TECHNOLOGIES PRIVATE LIMITED',
    'NAV RACHNA NIRMAN UDYOG PRIVATE LIMITED',
    'CHAMAN LAL ENTERPRISES PRIVATE LIMITED',
    'AVTAR AGENCIES PRIVATE LIMITED',
    'O J FINANCIAL SERVICES LIMITED',
    'A T M ESTATES PRIVATE LIMITED',
    'KENT CABLES PRIVATE LIMITED',
    'PIYUSH ELECTRONICS AND ELECTRICALS PRIVATE LIMITED',
    'GREATHEALTH TREXIM PRIVATE LIMITED',
    'SUPREME SECURITIES LIMITED',
    'BRETTON WOODS FINLEASE LIMITED',
    'COMPUTECH PUBLICATIONS LIMITED',
    'S.P. SECURITIES LIMITED',
    'COSMO ENTERPRISES PRIVATE LIMITED',
    'GOVERDHAN VERMA PUNJAB JEWELLERS PRIVATE LIMITED',
    'GREAT AID EXPORT PRIVATE LIMITED',
    'KAVITA LABELS (INDIA) PRIVATE LIMITED',
    'RAI PREXIM (INDIA) PRIVATE LIMITED',
    'PARKASH AMUSEMENT RIDES & INFRASTRUCTURE PRIVATE LIMITED',
    'EMTEX MARKETING PRIVATE LIMITED',
    'TCAP INVESTMENTS PRIVATE LIMITED',
    'REAL STAR BUILDERS AND EXPORTERS PRIVATE LIMITED',
    'P.K. ADVERTISING SERVICES PRIVATE LIMITED',
    'AUTOMATIC FINANCIAL SERVICES PRIVATE LIMITED',
    'LEXSPHERE PRIVATE LIMITED.',
    'DISHAYEN TRAVELS PRIVATE LIMITED',
    'Malik Fabrics Private Limited',
    'AGR STEEL STRIPS PRIVATE LIMITED',
    'AMBA HOLDINGS ADVISORY PRIVATE LIMITED',
    'Global Blue Private Limited',
    'APEX TUBES PVT LTD',
    'SkyPower Solar India Private Limited',
    'RJ TAPHOUSE PRIVATE LIMITED',
    'MOBILE COMMUNICATIONS INDIA PRIVATE LIMITED',
    'DEWAN TRAVELS PRIVATE LIMITED',
    'TECHNICO STRIPS AND TUBES PRIVATE LIMITED.',
    'DHANJAL H.M.AUTO INDIA PRIVATE LIMITED',
    'SkyPower Southeast Solar India Private Limited',
    'Indiattitude Marketing Private Limited',
    'OSPIN TRADERS PRIVATE LIMITED',
    'BRAKEWEL AUTOMOTIVE COMPONENTS INDIA PRIVATE LIMITED',
    'NAV BHARAT PROMOTERS AND DEVELOPERS PRIVATE LIMITED',
    'SVAVLAMBI APPARELS LIMITED',
    'JDM OVERSEAS PRIVATE LIMITED',
    'MICHAEL ARAM EXPORTS PRIVATE LIMITED',
    'EUDAEMON CLOTHING PRIVATE LIMITED',
    'SELECTIVE EDUTECH CONSULTANTS PRIVATE LIMITED',
    'MAHAJAN INTERNATIONAL PRIVATE LIMITED',
    'Arico Foods Private Limited',
    'PARVERIAH APPARELS PRIVATE LIMITED',
    'OPENDOORS FINTECH PRIVATE LIMITED',
    'CREDITAS SOLUTIONS PRIVATE LIMITED',
    'Awfis Space Solutions Private Limited',
    'Buzzword Global Recruitment Services Private Limited',
    'Petra Asset and Facility Management Private Limited',
    'TEER ADVISORY SERVICES PRIVATE LIMITED',
    'ARVY SMARTCOM SYSTEMS PRIVATE LIMITED',
    'Foundation for Institutional Reform and Education',
    'G M MAINTENANCE TECHNOLOGY PRIVATE LIMITED',
    'RESERVATION DATA MAINTENANCE (INDIA) PRIVATE LIMITED',
    'N.Y. LEASING PRIVATE LIMITED',
    'NAVEEN TOURS PRIVATE LIMITED',
    'BARON ENTERPRISES PRIVATE LIMITED',
    'SHRIRAM VERITECH SOLUTIONS PRIVATE LIMITED',
    'INDIAN HOLIDAY PRIVATE LIMITED',
    'Glow Homes Technologies Private Limited',
    'Best Designs and Plans Private Limited',
    'ELIX FRESHENERS INDIA PRIVATE LIMITED',
    'SWAKRIT DESIGN PRIVATE LIMITED',
    'Stellar Dynamics Private Limited',
    'URBN India Sourcing & Design Solutions Private Limited',
    'ListenUp India Hearing Solutions Private Limited',
    'ZIPPY TAX SOLUTIONS PRIVATE LIMITED',
    'EWORLD BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ABSOLEM TECHNOLOGIES PRIVATE LIMITED',
    'SLP Engineering (India) Private Limited',
    'EAU BATHING SOLUTIONS PRIVATE LIMITED',
    'ADLENT CONSULTING PRIVATE LIMITED',
    'ZOLL Medical India Private Limited',
    'SPID INFO MEDIA PRIVATE LIMITED',
    'ADOMANTRA DIGITAL INDIA PRIVATE LIMITED',
    'INDO ASIA PRIVATE LIMITED',
    'GROWFAST SECURITIES AND CREDIT PRIVATE LIMITED',
    'UMANG LEASING AND CREDIT COMPANY LIMITED',
    'AdPushup Software India Private Limited',
    'POLAR ELECTRONICS PRIVATE LIMITED',
    'BIRDSVIEW INVESTMENT & CONSULTANT PRIVATE LIMITED',
    'BENE RESORTS PRIVATE LIMITED',
    'NEELGIRI MACHINERY PRIVATE LIMITED',
    'NEERAJ HOSIERY INDIA PRIVATE LIMITED',
    'SEVENHILL CONSULTING & INVESTIGATIONS PRIVATE LIMITED',
    'Team Worxs Techin Private Limited',
    'D V K JEWELLERS PRIVATE LIMITED',
    'A S COMPUTECH SERVICES PRIVATE LIMITED',
    'AMEVA FOUNDATION',
    'REMEDIES PHARMACEUTICALS INDIA PRIVATE LIMITED.',
    'AARSH RESOLUTION PROFESSIONALS PRIVATE LIMITED',
    'TARUNA AUTO PRIVATE LIMITED',
    'RCI SKILLS AND SOCIAL DEVELOPMENT PRIVATE LIMITED',
    'UNEXO LABORATORIES PRIVATE LIMITED',
    'SOCIAL JUSTICE FOUNDATION',
    'AHMEDABAD NETWORK SYSTEMS PRIVATE LIMITED',
    'DILLI CRICKET LEAGUE',
    'Ogrelogic Business Services OPC Private Limited',
    'PREMIER POLYFILM LIMITED',
    'Apex Buildsys Limited',
    'DCM FINANCIAL SERVICES LIMITED',
    'COFORGE LIMITED',
    'MIDEAST INTEGRATED STEELS LIMITED',
    'KEI INDUSTRIES LIMITED',
    'Globus Spirits Limited',
    'MULTITEX FILTERS Private LIMITED',
    'MITCO WELD PRODUCTS PRIVATE LIMITED',
    'GUMMI METALL TECHNIK (INDIA) PRIVATE LIMITED',
    'ROOPSI STONES PRIVATE LIMITED',
    'MOHAN BHAI MINERALS PRIVATE LIMITED',
    'SWYN HERDS PRIVATE LIMITED',
    'Vahdam Teas Private Limited',
    'FROST FALCON BREWERIES LIMITED',
    'SERVICES PRODUCER COMPANY LIMITED',
    'GRENOVA LABS INDIA PRIVATE LIMITED',
    'DHAKSHHIN AGROPOLIS LIMITED',
    'SHAADI BAARATI DELIGATES PRIVATE LIMITED',
    'KATIHAR KISAN KRASHI PRODUCER COMPANY LIMITED',
    'KOSI AUTOMOBILES PRIVATE LIMITED',
    'GURU KABEER DEVELOPMENT FOUNDATION',
    'SGC IT SOLUTIONS PRIVATE LIMITED',
    'HOSTAXIS NETWORK PRIVATE LIMITED',
    'RONGJENG TECHNOLOGIES PRIVATE LIMITED',
    'INFOCARE (I) ENTERTAINMENT PRIVATE LIMITED',
    'KAMAKHYA MOTOTEC PRIVATE LIMITED',
    'SCONE CERAMICS PRIVATE LIMITED',
    'Lepakshi energy (india) Private Limited',
    'RONGSHENG MOBILE INDIA PRIVATE LIMITED',
    'Clomozone Technology India Private Limited',
    'Softwide Techno Solutions Private Limited',
    'CLAIRVOYANCE RESEARCH PRIVATE LIMITED',
    'Plasma biotech Private Limited',
    'EMPOWERED.NET SERVICES PRIVATE LIMITED',
    'TVSR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HYMASATYA ENGINEERING PROJECTS PRIVATE LIMITED',
    'ANDHRA BUFFALO CORPORATION PRIVATE LIMITED',
    'ROYALMINDZ ESTATES PRIVATE LIMITED',
    'KONASEMA PROPERTIES PRIVATE LIMITED',
    'Swift Analytic Solutions Private Limited',
    'KIMS HOSPITALS PRIVATE LIMITED',
    'Daily Food Products Private Limited',
    'TOBACCO BYE PRODUCTS PVT LTD',
    'FORTUNA ENGI TECH AND STRUCTURALS (INDIA) PRIVATE LIMITED',
    'EPIQSYSTEMS INDIA PRIVATE LIMITED',
    'VASUDHA SAMPADA PRIVATE LIMITED',
    'RHINO MK SECURITY SERVCES PRIVATE LIMITED',
    'BHABANI PACKAGING SOLUTIONS PRIVATE LIMITED',
    'OLATUS SYSTEMS PRIVATE LIMITED',
    'ICLEAN HOLLOW METAL SYSTEMS PRIVATE LIMITED',
    'ONE TOUCH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ADESAN INTER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ONLINEPLUS DOTCOM PRIVATE LIMITED',
    'SUNDARAM MAHADEO AUTOWORLD PRIVATE LIMITED',
    'ITANAGAR CRICKET LEAGUE',
    'GREENKO ENERGY PROJECTS PRIVATE LIMITED',
    'ACEHIBC PRIVATE LIMITED',
    'Greenko Solar Projects Private Limited',
    'FRESH CART AGRO PRIVATE LIMITED',
    'SRI RAMANUJA AVENUES PRIVATE LIMITED',
    'Emprada Mines and Minerals Private Limited',
    'SUNLOK VENTURES PRIVATE LIMITED',
    'CORPORATE PROCESSOR PRIVATE LIMITED',
    'VINTRADE PRIVATE LIMITED',
    'GSMT REAL ESTATE DEVELOPERS PRIVATE LIMITED',
    'NAVIN INFRASOLUTIONS PRIVATE LIMITED',
    'GPT PROJECT MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'OMEGA COLONIZERS PRIVATE LIMITED',
    'R R DEAL INFRACON PRIVATE LIMITED',
    'RAJHANS FERTILIZERS LIMITED',
    'Sumit Medical Devices Private Limited',
    'ANAND REAL ESTATE (INDORE) PRIVATE LIMITED',
    'R. K. RESIN PLAST PRIVATE LIMITED',
    'HITECH WEAR PRIVATE LIMITED',
    'JICS Holdings Private Limited',
    'Nirvana Securities Private Limited',
    'NIRVANA OVERSEAS PRIVATE LIMITED',
    'DIVINE TOUCH REALESTATES PRIVATE LIMITED',
    'SAICHHAYA AUTOLINK PRIVATE LIMITED',
    'YASH CONSULTING PRIVATE LIMITED',
    'SANJAY TRADELINKS PRIVATE LIMITED',
    'MARINA INFRATECH PRIVATE LIMITED',
    'JAI BADRIVISHAL EXIM PRIVATE LIMITED',
    'ANVESHAN INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'LIFE CARE LOGISTIC PRIVATE LIMITED',
    'JAORA - NAYAGAON TOLL ROAD COMPANY PRIVATE LIMITED',
    'TECH SHOT PRIVATE LIMITED',
    'Jawsons Enterprises Private Limited',
    'Nalanda Infrastructure Private Limited',
    'SANYA STEEL FABRICATORS PRIVATE LIMITED',
    'PRATAPGARH LEASING AND FINANCE PVT LTD',
    'SAROJ TAPARIA CONSTRUCTION & HOUSING PRIVATE LIMITED',
    'PRAGYA ENGINEERING PRIVATE LIMITED',
    'JHANJHARI SONS LEASING AND INVESTMENT PVT LTD',
    'SIGNIFICANT ELECTRONICS AND COMPUTER TECHNOLOGY PVT LTD',
    'ANANT FORMULATIONS PRIVATE LIMITED',
    'GOLD FILAMENTS PRIVATE LIMITED',
    'MALWA HOSPITALITY PRIVATE LIMITED',
    'Newput Infotech Private Limited',
    'H.G. MERCANTILE PRIVATE LIMITED',
    'K. S. CITY PRIVATE LIMITED',
    'FAIRY LAND RESORTS PRIVATE LIMITED',
    'V SERV ENTERPRISES PRIVATE LIMITED',
    'PEGASUS INLAND CONTAINER DEPOT PRIVATE LIMITED',
    'PRAFUL LOGISTICS PRIVATE LIMITED',
    'INFOGRAVITY SOLUTIONS PRIVATE LIMITED',
    'MAHAN COAL LIMITED',
    'AISECT LIMITED',
    'JOBSGURU CONSULTANT PRIVATE LIMITED',
    'AXLE ENGINEERING PRIVATE LIMITED',
    'MATRIMONIAL PUNDIT PRIVATE LIMITED',
    'BABYLON INFRASTRUCTURE PRIVATE LIMITED',
    'OMATEK LABORATORIES PRIVATE LIMITED',
    'SYNTHETIC MOLECULES PRIVATE LIMITED',
    'Padam Buildmart Private Limited',
    'Akashdeep Finbuild Private Limited',
    'P2G SOLUTIONS PRIVATE LIMITED',
    'LAXMI ENGINEERING INDUSTRIES (BHOPAL) PRIVATE LIMITED',
    'Computronics Systems (India) Private Limited',
    'SARTHAK INNOVATIONS PRIVATE LIMITED',
    'RIA HOTELS PRIVATE LIMITED',
    'BMW PHARMACO INDIA PRIVATE LIMITED',
    'UMANG ENGINEERING PRIVATE LIMITED',
    'BRILLIANT SARE REALITY PRIVATE LIMITED',
    'UBITECH SOLUTIONS PRIVATE LIMITED',
    'DREAMWORLD DIGITAL SHOPING PRIVATE LIMITED',
    'HATHWAY DIGITAL LIMITED',
    'SHANTI INTERACTIVES PVT LTD',
    'M.P. Power Management Company Limited',
    'SHRI MATESHWARI REAL ESTATE AND DEVELOPERS PRIVATE LIMITED',
    'MALWA AGRO FOODS PRIVATE LIMITED',
    'SHANTI LOGISTICS PRIVATE LIMITED',
    'WELWET REAL ESTATE PRIVATE LIMITED',
    'RMONEY WEALTH ADVISORS PRIVATE LIMITED',
    'VECTUS INDUSTRIES LIMITED',
    'Orange Infrabuild Private Limited',
    'PUKHRAJ TELECOM PRIVATE LIMITED',
    'GK XIANGHE ELECTRICALS PRIVATE LIMITED',
    'AFFORD MOTORS INDIA PRIVATE LIMITED',
    'LASER CUT (I) TECHNOLOGY PRIVATE LIMITED',
    'APEX POOLS PRIVATE LIMITED',
    'KRISHIDHAN VEGETABLE SEEDS INDIA PRIVATE LIMITED',
    'KRISHIDHAN RESEARCH FOUNDATION PRIVATE LIMITED',
    'Vishal Realmart Private Limited',
    'IPER BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KHANNA PROPERTIES & INFRASTRUCTURES PRIVATE LIMITED',
    'KAILTECH TEST AND RESEARCH CENTRE PRIVATE LIMITED',
    'D B POWER LIMITED',
    'Gulmohar Fil-Tech Private Limited',
    'NICHE QUALITY SOLUTIONS PRIVATE LIMITED',
    'FILTREX ACCESSORIES PRIVATE LIMITED',
    'GEETANJALI BUILDCON PRIVATE LIMITED',
    'Mooncity Constructions Private Limited',
    'SHAIL TRADEXIMP PRIVATE LIMITED',
    'MADHYA PRADESH JAYPEE MINERALS LIMITED',
    'FRESH -O- VEG PRIVATE LIMITED',
    'DEVIKULAM DEVELOPERS (INDIA) PRIVATE LIMITED',
    'AARNEEL TECHNOCRAFTS PRIVATE LIMITED',
    'Techchilly Consultants Private Limited',
    'REAL FOOD AGENCY PRIVATE LIMITED',
    'STEEL INNOVATIONS PRIVATE LIMITED',
    'INDORE LASIK LASER CENTRE PRIVATE LIMITED',
    'MEXEL TECHNOLOGIES PRIVATE LIMITED',
    'FARMAKAL HEALTH CARE PRIVATE LIMITED',
    'P. K. MUSICBIZPRO PRIVATE LIMITED',
    'NEER TRADELINKS PRIVATE LIMITED',
    'CHAMELI ENTERPRISES PRIVATE LIMITED',
    'SURFACE PREPARATION SOLUTIONS & TECHNOLOGIES PRIVATE LIMITED',
    'OASIS DISTILLERIES LIMITED',
    'HINDUSTAN EQUIPMENTS PRIVATE LIMITED',
    'UNIDRUG INNOVATIVE PHARMA TECHNOLOGIES LIMITED',
    'GANGOTRI POLYMERS PRIVATE LIMITED',
    'SHIVA DRILLERS (INDIA) PVT LTD',
    'HOTLINE GLASS LIMITED',
    'ASHOKA POLYPLAST PRIVATE LIMITED',
    'DEVICA',
    'S BEAUTY TREASURES PRIVATE LIMITED',
    'HEALTHIFYME WELLNESS PRIVATE LIMITED',
    'GROWTHENABLER INDIA PRIVATE LIMITED',
    'CM Santusht Soul Spaces Private Limited',
    'MAJOR FOOTWEARS PRIVATE LIMITED',
    'PRANAV PACKWELL PRIVATE LIMITED',
    'AMG MARKETING AND FINANCIAL SERVICES PRIVATE LIMITED',
    'AAVEG TECHNOLOGY PRIVATE LIMITED',
    'MAGICLANE APP SERVICES PRIVATE LIMITED',
    'ARIHANT FUTURES AND COMMODITIES LIMITED',
    'BISP INFONET PRIVATE LIMITED',
    'Viera Agrofarms India Private Limited',
    'MadGenius Productions Private Limited',
    'CurlyArrows Education Private Limited',
    'INFLAKES CONSULTING & IT SOLUTIONS PRIVATE LIMITED',
    'BENELLIN RESEARCH LABS PRIVATE LIMITED',
    'KEMICS SOLUTIONS PRIVATE LIMITED',
    'ENVARA BUILDERS PRIVATE LIMITED',
    'GAIA SMART CITIES SOLUTIONS PRIVATE LIMITED',
    'Hexagon Events Private Limited',
    'THRISSUR REPRO HEALTH CARE PRIVATE LIMITED',
    'AIRRCHIP COMMUNICATIONS PRIVATE LIMITED',
    'Karza Technologies Private Limited',
    'SRICHAITANYA STUDENTS FACILITY MANAGEMENT PRIVATE LIMITED',
    'PRIMUS KNS LIFESTYLE PRIVATE LIMITED',
    'KAVworks Technologies Private Limited',
    'Service Lee Technologies Private Limited',
    'North Eastern Travel Trails Private Limited',
    'ASSETZ VALUE HOMES NORTH PRIVATE LIMITED',
    'MSM PROCESS SOLUTIONS PRIVATE LIMITED',
    'RESVERA WINES LIMITED',
    'ASM Alliance Management Services (India) Private Limited',
    'HANSEN SYSTEMS PRIVATE LIMITED',
    'Pharmameditech Scientific Equipment Private Limited',
    'Sarayu Branding & Printing Private Limited',
    'TUBACEX SERVICE SOLUTIONS INDIA PRIVATE LIMITED',
    'SUDARSHAN COMPONENTS PRIVATE LIMITED',
    'ENGINEERED FOOD CONCEPTS PRIVATE LIMITED',
    'Advaya Charitable Foundation',
    'SSARA RETAIL PRIVATE LIMITED',
    'Clobdata Techno Solutions Private Limited',
    'QOS Technology Private Limited',
    'INKERS TECHNOLOGY PRIVATE LIMITED',
    'Wurth Information Technology India Private Limited',
    'Sourashakthi Energy Private Limited',
    'Homigo Realty Private Limited',
    'UTILIPLUS Solutions Private Limited',
    'Intelleza Technologies Private Limited',
    'Authentic Medical Systems Private Limited',
    'S K HIGH WHEELS PRIVATE LIMITED',
    'Sapsbuy ECommerce Private Limited',
    'MOUTHWATERING HOSPITALITY PRIVATE LIMITED',
    'ADVANTAGE 3PL EXPRESS PRIVATE LIMITED',
    'FLIPKART ADVANZ PRIVATE LIMITED',
    'Vijay Khetan Ventures Private Limited',
    'MLJ India Private Limited',
    'POLOFOODS QSR PRIVATE LIMITED',
    'POLTERGEIST CAPITAL ADVISORY PRIVATE LIMITED',
    'JAINTIA STAFFING SERVICES PRIVATE LIMITED',
    'MEGHA PIPES & INDUSTRIES PRIVATE LIMITED',
    'S S NETCOM PRIVATE LIMITED',
    'DYNA ROOF PRIVATE LIMITED',
    'Sankirna Product And Solutions Private Limited',
    'e-Stone Information Technology Private Limited',
    'BURGUNDY HOTELS PRIVATE LIMITED',
    'ARIVAR RETAIL PRIVATE LIMITED',
    'EJOHRI JEWEL HUB PRIVATE LIMITED',
    'Oriano Clean Energy Private Limited',
    'Smart Monitoring & Surveillance Private Limited',
    'ANOVA DIAGNOSTICS PRIVATE LIMITED',
    'SHAPOORJI PALLONJI AND COMPANY Private Limited',
    'H. M. POWER & ENERGY PRIVATE LIMITED',
    'EVEREST ADVERTISING PRIVATE LIMITED',
    'Mondelez India Foods Private Limited',
    'PRITHVI MINING & STEEL PRIVATE LIMITED',
    'ORIENTAL RUBBER INDUSTRIES Private Limited',
    'N.E. EXPLORATION & MINING COMPANY PRIVATE LIMITED',
    'S H KELKAR AND COMPANY Limited',
    'MADHU SNAP FASTENERS MFG.COMPANY Public Limited',
    'ADITYA MINING & STEEL PRIVATE LIMITED',
    'H.M.Ferro Alloys Private Limited',
    'PURPLE ARCHITECTURE PRIVATE LIMITED',
    'MADHYAM AGRIVET INDUSTRIES LIMITED',
    'UTKARSA TECHNICAL SERVICES PRIVATE LIMITED',
    'SOBHAGIA SALES PRIVATE LIMITED',
    'VIBRACOUSTIC INDIA PRIVATE LIMITED',
    'NE TECHNO PRIVATE LIMITED',
    'AURITAS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Monte Carlo Fashions Limited',
    'ACCOLADE INDIA PVT LTD',
    'SQRO TECHNOLOGIES PRIVATE LIMITED',
    'ORANGE O TEC PRIVATE LIMITED',
    'Takahata Precision India Private Limited',
    'EFFICIENT HOTELS INDIA PRIVATE LIMITED',
    'A N BUSINESS TRADING PRIVATE LIMITED',
    'BEEKAY NIRYAT LIMITED',
    'GROVER CARBONIC PRIVATE LIMITED',
    'ITALIEN JEWELLERY MANUFACTURING COMPANY LIMITED',
    'SHALIMAR SUITINGS PVT LTD',
    'ABHI COKE PRIVATE LIMITED',
    'SURBHI CITIMART PRIVATE LIMITED',
    'PURBANCHAL MINES & MINERALS LIMITED',
    'STAR TECHNICAL SERVICES PRIVATE LIMITED',
    'BAJAJ CONSUMER CARE LIMITED',
    'U D COIR PRODUCTS PRIVATE LIMITED',
    'U D COKE PRIVATE LIMITED',
    'J.U.D. CEMENTS LTD',
    'DWARKADAS AND COMPANY PRIVATE LIMITED',
    'EAST WEST HOLDINGS LIMITED',
    'Genus Paper & Boards Limited',
    'DECCAN CHRONICLE HOLDINGS LIMITED',
    'PREMIER EXPLOSIVES LIMITED',
    'COROMANDEL INTERNATIONAL LIMITED',
    'LION PENCILS LIMITED',
    'RASOI LTD',
    'JOHNSON & JOHNSON PRIVATE LIMITED',
    'BOMBAY WIRE ROPES LIMITED',
    'SAMKRG PISTONS AND RINGS LIMITED',
    'SAARLOHA ADVANCED MATERIALS PRIVATE LIMITED',
    'TENTIWALA METAL PRODUCTS LIMITED',
    'INTERNATIONAL COMBUSTION (INDIA) LTD',
    'JYOTHI INFRAVENTURES LIMITED',
    'SPML INDIA LIMITED',
    'BM Munjal Energies Private Limited',
    'WOLTERS KLUWER (INDIA) PRIVATE LIMITED',
    'VISAKA INDUSTRIES LTD.',
    'DUNWELL ENTERPRISES PRIVATE LIMITED',
    'JINDAL POLY INVESTMENT AND FINANCE COMPANY LIMITED',
    'BAKEBEST FOODS Private Limited',
    'TARANAGAR INVESTMENT COMPANY LTD',
    'PREMIER CHENNAI PROPERTIES LIMITED',
    'TRANSPORT CORPORATION OF INDIA LIMITED',
    'COSYN LIMITED',
    'MARWADI CHANDARANA INTERMEDIARIES BROKERS PRIVATE LIMITED',
    'HERMIT LABS PRIVATE LIMITED',
    'CASACOPENHAGEN BRANDS PRIVATE LIMITED',
    'TECHTRIZ INDIA PRIVATE LIMITED',
    'DEMANDTRON PRIVATE LIMITED',
    'JHAJJAR WAREHOUSING PRIVATE LIMITED',
    'AVITUS ELECTRICALS & INSTRUMENTATION PRIVATE LIMITED',
    'RATHNA FOREX PRIVATE LIMITED',
    'SATIN FINSERV LIMITED',
    'SUPERGARD STEELS PRIVATE LIMITED',
    'KALEIDO CHEMIE PRIVATE LIMITED',
    'STONCETHERMAL PRIVATE LIMITED',
    'THICK SHAKE FOODS PRIVATE LIMITED',
    'NETZARY INFODYNAMICS PRIVATE LIMITED',
    'SAFFRON NETWORKS PRIVATE LIMITED',
    'KIOT INNOVATIONS PRIVATE LIMITED',
    'SRI VARSA AUTO AGENCIES PRIVATE LIMITED',
    'REINIGER SYSTEMS PRIVATE LIMITED',
    'PENSIEVE HEALTH PRIVATE LIMITED',
    'ROCKART PRIVATE LIMITED',
    'PLAYMANTIS STUDIO PRIVATE LIMITED',
    'VALEUR ENGINEERS PRIVATE LIMITED',
    'KHAMBHAT ENVIRON CARE ASSOCIATION',
    'SALOHA TECH SOLUTIONS PRIVATE LIMITED',
    'JAVI FORWARD ENTERPRISES PRIVATE LIMITED',
    'GV GLOBAL ELEVATORS INDIA PRIVATE LIMITED',
    'SHARE INDIA INSURANCE BROKERS PRIVATE LIMITED',
    'BANZAI NANO SOLUTIONS PRIVATE LIMITED',
    'QUANTECH CAPITAL INVESTMENT ADVISORS PRIVATE LIMITED',
    'SIMPLE LOGIC TECHNOLOGIES PRIVATE LIMITED',
    'FILL SKILL FOUNDATION',
    'BVM PROPERTY LEASING PRIVATE LIMITED',
    'ONCEHUB TECHNOLOGIES PRIVATE LIMITED',
    'JANJUNE REVENUE TECH PRIVATE LIMITED',
    'BERBRICK HEALTHCARE PRIVATE LIMITED',
    'KGA INTERNATIONAL TRADES PRIVATE LIMITED',
    'SPECKYFOX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SHWAY ENTERTAINMENT PRIVATE LIMITED',
    'SAYAR BUILDCON PRIVATE LIMITED',
    'ROSHAN SPACE DIGITAL PRIVATE LIMITED',
    'MOHANAMMA TECHNOLOGY PRIVATE LIMITED',
    'SUPERHUMAN VENTURES PRIVATE LIMITED',
    'VUEARK TECHNOLOGY SERVICES PRIVATE LIMITED',
    'INFIT WELLNESS PRIVATE LIMITED',
    'SERTURNER LABS PRIVATE LIMITED',
    'NATIONAL CENTRE FOR FINANCIAL EDUCATION',
    'SEQUOIA HEALTHCARE PRIVATE LIMITED',
    'MAHIRA LUXURY HOUSING PRIVATE LIMITED',
    'CDCA SUPPORT SERVICES PRIVATE LIMITED',
    'PRAGATI UNIVERSAL PRIVATE LIMITED',
    'MAXLIT PROPERTIES LIMITED',
    'GEDCOL SAIL POWER CORPORATION LIMITED',
    'ITISH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PERITOS SOLUTIONS & CONSULTING PRIVATE LIMITED',
    'LNSAK SYSTEM INDIA (OPC) PRIVATE LIMITED',
    'SJA LOGISOL INDIA PRIVATE LIMITED',
    'WILDLENSE ECO FOUNDATION',
    'SMARTKIDZ EDUCARE GLOBAL PRIVATE LIMITED',
    'TRARITI SARVABHAUMA TRADING PRIVATE LIMITED',
    'ANJ WEBTECH PRIVATE LIMITED',
    'SONOSCAPE MEDICAL INDIA PRIVATE LIMITED',
    'ISA TOURISM PRIVATE LIMITED',
    'ROSEATE HOSPITALITY PRIVATE LIMITED',
    'NATURISTIC FARM EXPORTS PRIVATE LIMITED',
    'VEDASHREE LABS PRIVATE LIMITED',
    'INNOGENIO SOLUTIONS PRIVATE LIMITED',
    'RECEPTIO SYSTEMS PRIVATE LIMITED',
    'SADUN OVERSEAS PRIVATE LIMITED',
    'WOLFTECHNICA SOFTWARE SERVICES PRIVATE LIMITED',
    'ARTIVINE PRIVATE LIMITED',
    'SEHAR INDUSTRIES RETAIL PRIVATE LIMITED',
    'CAYMUS TECHNOLOGY VENTURES PRIVATE LIMITED',
    'WIOO PIKINGS PRIVATE LIMITED',
    'RYDBERG ENGINEERING PRIVATE LIMITED',
    'EMIT GROUP INDIA PRIVATE LIMITED',
    'SWAR YANTRA TECHNOLOGIES PRIVATE LIMITED',
    'UNISIGHTS RESEARCH AND ANALYTICS PRIVATELIMITED',
    'PTI ENGINEERING TECHNOLOGIES PRIVATE LIMITED',
    'BIOPUGMARK TECHNOLOGY PRIVATE LIMITED',
    'QUANRO SOLUTIONS PRIVATE LIMITED',
    'HYPERSTATE TECHNOLOGIES PRIVATE LIMITED',
    'ROCHELLES TECHNOMATICS INDIA PRIVATE LIMITED',
    'ALICON INFOMATICS PRIVATE LIMITED',
    'QUODROID SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'IMPERIAL ASSESSMENT SERVICES PRIVATE LIMITED',
    'KRYSCH PROPERTIES PRIVATE LIMITED',
    'A2DYA MILK AND ORGANIC PRODUCTS PRIVATE LIMITED',
    'MESTASTOP SOLUTIONS PRIVATE LIMITED',
    'FLEXZO HR SERVICES PRIVATE LIMITED',
    'LEGOR LOGISTICS PRIVATE LIMITED',
    'TAKING OFF TO THE FUTURE PRIVATE LIMITED',
    'STROLLOUT SERVICES INDIA PRIVATE LIMITED',
    'EZOLLUTION SERVICES PRIVATE LIMITED',
    'UNIC INFOSYSTEMS PRIVATE LIMITED',
    'VALENCY LAB EQUIPMENTS PRIVATE LIMITED',
    'NETRA ACCELERATOR FOUNDATION',
    'HKL SPORTS FOUNDATION',
    'TEXTURE TOUCH INSTA PRIVATE LIMITED',
    'CRESCENT VALVES INTERNATIONAL PRIVATE LIMITED',
    'TECHNOMAX ENTERPRISES ENERGY SOLUTIONS PRIVATE LIMITED',
    'SABSTONE SOFTWARE PRIVATE LIMITED',
    'PANYUN OLOAN FINTECH PRIVATE LIMITED',
    'ISP GLOBAL CONSULTING PRIVATE LIMITED',
    'MIWAY TEACHING AIDS PRIVATE LIMITED',
    'HSD TECH SOLUTIONS PRIVATE LIMITED',
    'CHRYSALISGOLD TECHNOLOGIES PRIVATE LIMITED',
    'REVA ASPIRING YOUTH FOUNDATION',
    'SUNGLOW MARINE SERVICES PRIVATE LIMITED',
    'MYRA VEDA ORGANICS PRIVATE LIMITED',
    'NISTANTU AUTOMATION PRIVATE LIMITED',
    'SARVESH SOLITAIRE OVERSEAS PRIVATE LIMITED',
    'VMS OFFSHORE SERVICES PRIVATE LIMITED',
    'BAROM LOGISTICS PRIVATE LIMITED',
    'MAA ENT KOLKATA PRIVATE LIMITED',
    'JMK FREIGHT SOLUTIONS PRIVATE LIMITED',
    'DUTTCON FINANCIAL SERVICES PRIVATE LIMITED',
    'HC TRADING (INDIA) PRIVATE LIMITED',
    'ASHA FIRE SERVICE (OPC) PRIVATE LIMITED',
    'BAJO FOODS PRIVATE LIMITED',
    'ENVIROFINA ENERGY INDIA PRIVATE LIMITED',
    'DJG IMPEX PRIVATE LIMITED',
    'BLACKWATERTECH EAST PRIVATE LIMITED',
    'CHARGEFIND TECHNOLOGIES PRIVATE LIMITED',
    'BFGI ENGINEERING SERVICES PRIVATE LIMITED',
    'BRIGHTSTAR FINCAP PRIVATE LIMITED',
    'APOLLO MEDICALS PRIVATE LIMITED',
    'LYRE PHARMA PRIVATE LIMITED',
    'AUTOMATON CLOUD CONSULTING PRIVATE LIMITED',
    'MANGALNATH MULTIPLE NIDHI LIMITED',
    'MEEDARSH SOLUTIONS PRIVATE LIMITED',
    'CLEAN SOLAR POWER (KADAPA ) PRIVATE LIMITED',
    'ADONAIORI CREATIONS PRIVATE LIMITED',
    'MAKEYOUBIG MEDIA PRIVATE LIMITED',
    'ASTRONOMICAL LOGISTICS PARK PRIVATE LIMITED',
    'GGAITH SERVICES (OPC) PRIVATE LIMITED',
    'BJ AIMS GAMING PRIVATE LIMITED',
    'AIC-SMU TECHNOLOGY BUSINESS INCUBATION FOUNDATION',
    'PEDASYS LEARNING TECHNOLOGY INDIA PRIVATE LIMITED',
    'FSAIA INTERNATIONAL PRIVATE LIMITED',
    'B. B. COACHTECH INDIA PRIVATE LIMITED',
    'EVEY TRANS PRIVATE LIMITED',
    'BIOSPICE INDIA ENTERPRISES PRIVATE LIMITED',
    'FRESCURA INDIA PRIVATE LIMITED',
    'NASLAX GEOSERVICES PRIVATE LIMITED',
    'TEMICO INDIA PRIVATE LIMITED',
    'FUTURALIS TECHNOLOGIES PRIVATE LIMITED',
    'OMINON TECHNOLOGIES PRIVATE LIMITED',
    'BIYOLA INDUSTRIES PRIVATE LIMITED',
    'MOYEKH RETAIL SOLUTIONS PRIVATE LIMITED',
    'KKSV BUSINESS SERVICES PRIVATE LIMITED',
    'STICKBOX EVENTS PRIVATE LIMITED',
    'TECHNOLIFT EQUIPMENTS PRIVATE LIMITED',
    'GIRISHA LIFESCIENCES PRIVATE LIMITED',
    'VEGETARIAN DIARIES PRIVATE LIMITED',
    'GREAT TIGER LODGE PRIVATE LIMITED',
    'UAV SYSTEMS PRIVATE LIMITED',
    'CREATING ADVANCED FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'PUSHPAM BRAND SOLUTIONS PRIVATE LIMITED',
    'PILECUBES INDIA PRIVATE LIMITED',
    'APARAA DIGITAL PRIVATE LIMITED',
    'ALLEGIANCE LOYALTY SERVICES PRIVATE LIMITED',
    'HAMELIN FASHION AND RETAIL (OPC) PRIVATELIMITED',
    'DIAL1S E COMMERCE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WESTSHORE CUISINES PRIVATE LIMITED',
    'VAIVU RESOURCEQ SERVICES PRIVATE LIMITED',
    'TASKBENCH PRIVATE LIMITED',
    'VAISHNO DARPAN PAPERS PRIVATE LIMITED',
    'EDUBABBLE LEARNING PRIVATE LIMITED',
    'BESTSELLER VENTURES PRIVATE LIMITED',
    'COMPEX ADVISORS PRIVATE LIMITED',
    'ALTERNATIVE FARMTECH PRIVATE LIMITED',
    'JAYSOL SERVICES PRIVATE LIMITED',
    'VIDCOM BUSINESS SOLUTION PRIVATE LIMITED',
    'ANESTHESIA DYNAMICS INDIA PRIVATE LIMITED',
    'HAPICAL TRAVELS INDIA LIMITED',
    'UNAM VITAM CONSULTING AND VENTURES PRIVATE LIMITED',
    'ZIGRAM DATA TECHNOLOGIES PRIVATE LIMITED',
    'JCB INDUSTRIES PRIVATE LIMITED',
    'MCQDB PRIVATE LIMITED',
    'YJS MICRO ELECTRONICS PRIVATE LIMITED',
    'PUNNI AGRO PRIVATE LIMITED',
    'IMMERSE HOSPITALITY PRIVATE LIMITED',
    'INKHIGH TALENT AND ARTS PRIVATE LIMITED',
    'QYOU MEDIA INDIA PRIVATE LIMITED',
    'CLICK WEDDING VENTURES PRIVATE LIMITED',
    'TADANO CRANES INDIA PRIVATE LIMITED',
    'SOLSTEN DATA CONSULTING PRIVATE LIMITED',
    'NARENKUMAR JEWELLERS PRIVATE LIMITED',
    'GOLDEN RATIO MOTION PICTURES PRIVATE LIMITED',
    'INNOSHYNE PRIVATE LIMITED',
    'AMV PHARMACHEM PRIVATE LIMITED',
    'IRASUS TECHNOLOGIES PRIVATE LIMITED',
    'ELECTROMEC TRANSFORMER (INDIA) PRIVATE LIMITED',
    'KARALIKA INFRATECH PRIVATE LIMITED',
    'CHI SPORTS PRIVATE LIMITED',
    'BOOKNPLAY PRIVATE LIMITED',
    'SAMVARDHANA MOTHERSON GLOBAL CARRIERS LIMITED',
    'SSPT LOGISTICS PRIVATE LIMITED',
    'NITYDEV WOOD WORKS PRIVATE LIMITED',
    'BLUEMONK VENTURES PRIVATE LIMITED',
    'MISHKON RESEARCH LABS LIMITED',
    'MCTA MARKETING COURSES TRAINING ACADEMY PRIVATE LIMITED',
    'THOUGHTWARE TRAINING PRIVATE LIMITED',
    'HERJAVEC GROUP INDIA PRIVATE LIMITED',
    'SWASH PAPERTECH PRIVATE LIMITED',
    'RELINE UV ASEAN PRIVATE LIMITED',
    'INERRANT ROBOTOMATION PRIVATE LIMITED',
    'MANGOES INDUSTRIES PRIVATE LIMITED',
    'WHEALTHYFY HEALTHTECH PRIVATE LIMITED',
    'GREENDELIGHT INNOVATIONS PRIVATE LIMITED',
    'PSTS SHIPPING SERVICES PRIVATE LIMITED',
    'UMEANDUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HIMFLAX INFORMATION TECHNOLOGIES PRIVATELIMITED',
    'COGNITIVEBOTICS TECHNOLOGIES PRIVATE LIMITED',
    'SURAKSHA SEWA SAMARPAN FOUNDATION',
    'VB AIRSUSPENSION INDIA PRIVATE LIMITED',
    'BEHTAR ZINDAGI PRIVATE LIMITED',
    'NEZONE TUBES (TN) LIMITED',
    'CAMBEDU TRAINING SERVICES PRIVATE LIMITED',
    'ANVITA AUTO TECH WORKS PRIVATE LIMITED',
    'GRAY MATTER TECHNICAL SOLUTIONS INDIA PRIVATE LIMITED',
    'KAJ FINE JEWELLERY PRIVATE LIMITED',
    'ESSPROUT TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'VISVAJA DOORS INDIA PRIVATE LIMITED',
    'AARTI GREEN TECH LIMITED',
    'TASAL SOLUTIONS PRIVATE LIMITED',
    'JAYASAKTHI ROOFING PRIVATE LIMITED',
    'ATULSIA MEGASTORES PRIVATE LIMITED',
    'ARA CARRIER PRIVATE LIMITED',
    'TILTED CUP SOLUTIONS PRIVATE LIMITED',
    'MITCON ADVISORY SERVICES PRIVATE LIMITED',
    'PHOENIX BUSINESS INITIATIVES PRIVATE LIMITED',
    'PHPL SOLUTIONS PRIVATE LIMITED',
    'ASHIAAN SOLAR PRIVATE LIMITED',
    'PRAKRUTEES COSMOCEUTICALS PRIVATE LIMITED',
    'ZAPKEY TECHNOLOGIES PRIVATE LIMITED',
    'CDNA TECHNOLOGIES PRIVATE LIMITED',
    'BRIGHTCOVE INDIA PRIVATE LIMITED',
    'PAREBA LOGISTICS PRIVATE LIMITED',
    'MERAPOS PRIVATE LIMITED',
    'GEX SEARCH PRIVATE LIMITED',
    'M14 INTELLIGENCE RESEARCH PRIVATE LIMITED',
    'JSW ONE PLATFORMS LIMITED',
    'ALIBAUG SOLID WASTE MANAGEMENT ASSOCIATION',
    'TRUTRIBE VENTURES PRIVATE LIMITED',
    'RENASCENT POWER VENTURES PRIVATE LIMITED',
    'POWER MECH SSA STRUCTURES PRIVATE LIMITED',
    'AMPSOLAR EVOLUTION PRIVATE LIMITED',
    'NEOTREND EV SYSTEMS PRIVATE LIMITED',
    'SRISANG INFRA & SERVICES PRIVATE LIMITED',
    'BOMBAY BADMINTON PRIVATE LIMITED',
    'KIRANA KING RETAIL NETWORK PRIVATE LIMITED',
    'AURIOLUS FINVEST PRIVATE LIMITED',
    'DEGWEKAR INDUSTRIES PRIVATE LIMITED',
    'BLUTEN MARKETING PRIVATE LIMITED',
    'DIGIFY SOFTWARE PRIVATE LIMITED',
    'HAVENLEY FREEHOLDS PRIVATE LIMITED',
    'MOTOROYALE INDIA PRIVATE LIMITED',
    'REFINY INDUSTRIES PRIVATE LIMITED',
    'PWG HYDRAULICS INDIA PRIVATE LIMITED',
    'BETAUNIX ENGINEERIAN PRIVATE LIMITED',
    'IMPACT SEHKAR PRIVATE LIMITED',
    'ICON GLOBAL VENTURE PRIVATE LIMITED',
    'INDINVOICE TECH SOLUTIONS PRIVATE LIMITED',
    'PRANAY HOSPITALITY PRIVATE LIMITED',
    'CURVEITRIGHT PRIVATE LIMITED',
    'LABRAT STUDIO PRIVATE LIMITED',
    'SHREENATH VEHICLES PRIVATE LIMITED',
    'VAAKULAB TECHNOLOGIES PRIVATE LIMITED',
    'KUN CAR ENTERPRISES PRIVATE LIMITED',
    'AEROACE GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TRAVCLAN TRADE SERVICES PRIVATE LIMITED',
    'LONGEO LOGISTICS PRIVATE LIMITED',
    'NEW AGE HEALTHTECH PRIVATE LIMITED',
    'N4D- NUTRITION FOR DEVELOPMENT FOUNDATION',
    'NEETABLE TECHNOLOGIES PRIVATE LIMITED',
    'MUQADDAR KA SIKANDAR PRIVATE LIMITED',
    'DOGEMO DIGI INDIA PRIVATE LIMITED',
    'B.D. INNO VENTURES PRIVATE LIMITED',
    'FONTERRA FUTURE DAIRY PRIVATE LIMITED',
    'MISTRY ADVANCED NUTRITION CENTRE PRIVATELIMITED',
    'JAINGIRI FOUNDATION FOR EDUCATION AND CHILD WELFARE',
    'SILKY MAHAJAN HEALTH & FITNESS PRIVATE LIMITED',
    'XTO10X TECHNOLOGIES PRIVATE LIMITED',
    'ENVIRO HEIGHTS PRIVATE LIMITED',
    'AMSS TRAVEL STREET PRIVATE LIMITED',
    'PLENTOS VENTURES PRIVATE LIMITED',
    'IYER',
    'S PHARMACEUTICAL PRIVATE LIMITED',
    'DEEPA ERECTORS PRIVATE LIMITED',
    'GRANDEH DISHED ENDS PRIVATE LIMITED',
    'BIGCHEESE SOLUTIONS PRIVATE LIMITED',
    'CUBE HIGHWAYS PROJECT MANAGEMENT PRIVATELIMITED',
    'DIVA CLASSIC JEWELS AND GEMS PRIVATE LIMITED',
    'TAXKEY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KUTCH WINDFARM DEVELOPMENT PRIVATE LIMITED',
    'JPFL FILMS PRIVATE LIMITED',
    'APOLLO HIGH STREET CONDOMINIUMS PRIVATE LIMITED',
    'RBD HOLDINGS PRIVATE LIMITED',
    '3CLICKSMASTER PRIVATE LIMITED',
    'COMMON MAN WORKS PRIVATE LIMITED',
    'OLCEE INTERNATIONAL PRIVATE LIMITED',
    'DTDS SMART-CORE PRIVATE LIMITED',
    'KBR MANUFACTURING PRIVATE LIMITED',
    'NOUMENA DYNAMICS PRIVATE LIMITED',
    'KRIVANJA TECHNOLOGIES PRIVATE LIMITED',
    'EIJ CONSULTING PRIVATE LIMITED',
    'COMMUNITY AUTOPART PRIVATE LIMITED',
    'PRAKASH AUTOSALES PRIVATE LIMITED',
    'TRAVGRUB PRIVATE LIMITED',
    'SEKHRI IMMIGRATION (OPC) PRIVATE LIMITED',
    'FRIENDS DIGITAL 24 PRIVATE LIMITED',
    'GROVE SYSTEMS PRIVATE LIMITED',
    'VISION BOX INDIA PRIVATE LIMITED',
    'TECHNOPOP SOLUTIONS PRIVATE LIMITED',
    'ENSURE OVERSEAS VENTURES PRIVATE LIMITED',
    'SMC FRUITS AND VEGETABLES LIMITED',
    'XTRM INDIA PRIVATE LIMITED',
    'BLU-SMART MOBILITY PRIVATE LIMITED',
    'DUZONE ADHESIVES INDIA PRIVATE LIMITED',
    'HIGH DIGITAL INDIA PRIVATE LIMITED',
    'KAGAZEE (OPC) PRIVATE LIMITED',
    'SUPER-CHAIN INTERNATIONAL LOGISTICS INDIA PRIVATE LIMITED',
    'MANAS NETWORKS PRIVATE LIMITED',
    'ITANIMO TECHNOLOGY PRIVATE LIMITED',
    'LLS LOGISTICS PRIVATE LIMITED',
    'CAMIOS HOSPITALITY PRIVATE LIMITED',
    'PROX LOGISTICS PRIVATE LIMITED',
    'BHAGWATI BUSINESS MERCHANT LIMITED',
    'SETCONNECT E-COMMERCE & MULTISERVICES PRIVATE LIMITED',
    'S&F BLUE INDIA CONSULTANCY PRIVATE LIMITED',
    'SHREE DADU DAYAL AUTOMOBILES PRIVATE LIMITED',
    'WILH LOESCH PROJECT SERVICES PRIVATE LIMITED',
    'ACCELDATA TECHNOLOGY PRIVATE LIMITED',
    'WWSO ENTERPRISES LIMITED',
    'GV IMMIGRATION AND VISA (SERVICES) PRIVATE LIMITED',
    'STAR TREE-ANIMAL WELFARE ASSOCIATION',
    'PLM PUZZLES (OPC) PRIVATE LIMITED',
    'ARRIXON TECHNOLOGIES PRIVATE LIMITED',
    'ZAHA F&B DISTRIBUTORS PRIVATE LIMITED',
    'ZIG SCIENCES INDIA PRIVATE LIMITED',
    'MFHILLS BUSINESS SERVICES PRIVATE LIMITED',
    'HIDAKA PRECISION TOOLS INDIA PRIVATE LIMITED',
    'MERAKI SHIPPING INDIA PRIVATE LIMITED',
    'ZINGLA SHOPPING PRIVATE LIMITED',
    'PENR ASSOCIATES PRIVATE LIMITED',
    'RUDAM WUJI INTERNATIONAL PRIVATE LIMITED',
    'COGNIGIX DIGITAL LEARNING PRIVATE LIMITED',
    'REMAXX REALBUILD PRIVATE LIMITED',
    'ANANTA TOURISM PRIVATE LIMITED',
    'SNIVONI INSTITUTE OF GLOBAL STUDIES PRIVATE LIMITED',
    'ARSHIYA NORTHERN PROJECTS PRIVATE LIMITED',
    'ANTRAX LABS PRIVATE LIMITED',
    'UNIDENT DENMED PRIVATE LIMITED',
    'ZURO NETWORK PRIVATE LIMITED',
    'LUXURIO ASSETS PRIVATE LIMITED',
    'CROWN INSPECTION AND ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'LEATHERLUXURY MARKETING PRIVATE LIMITED',
    'PINGALA AI PRIVATE LIMITED',
    'WHITE HILL AGRO PRODUCTS PRIVATE LIMITED',
    'EROUTE TECHNOLOGIES PRIVATE LIMITED',
    'GUNDEV PROCESS CONSULTING PRIVATE LIMITED',
    'SOFTVAN LABS PRIVATE LIMITED',
    'ARSLAN SRS INDIA PRIVATE LIMITED',
    'ONE87 GLOBAL TRADEPEX PRIVATE LIMITED',
    'HIGHWAY AMENITIES DEVELOPERS PRIVATE LIMITED',
    'TAKNEK AUTOMATION SYSTEM PRIVATE LIMITED',
    'ARVI NAVIGATION PRIVATE LIMITED',
    'THELAGAADI PRIVATE LIMITED',
    'DRILL',
    'MATIC PETRO PRIVATE LIMITED',
    'INTER WORLD EDU JUNCTION PRIVATE LIMITED',
    'EXOTERAS PRIVATE LIMITED',
    'BUGENDAITECH PRIVATE LIMITED',
    'CSS INDIA CENTER PRIVATE LIMITED',
    'GOLDEN CASTLE DEVELOPERS PRIVATE LIMITED',
    'SANYAM IMPEX PRIVATE LIMITED',
    'GLOBALTAGS INDIA PRIVATE LIMITED',
    'SELECTIAL INDIA PRIVATE LIMITED',
    'HYDROFLUX ENGINEERING PRIVATE LIMITED',
    'ANGEL AUTO AGENCY PRIVATE LIMITED',
    'CITYFARMERS INDIA PRIVATE LIMITED',
    'VISHWAST FOODS AND FRAGRANCE PRIVATE LIMITED',
    'PERFECT BALANCE ACCOUNTING PRIVATE LIMITED',
    'LUBOCHEM SPECIALITY PRIVATE LIMITED',
    'JAY MELDI TOURS & TRAVELS PRIVATE LIMITED',
    'SHRADHASAI LIFESCIENCES PRIVATE LIMITED',
    'URANUS SOFTECH PARK PRIVATE LIMITED',
    'DITRINITY TECHNOLOGIES PRIVATE LIMITED',
    'HRB RESIDENCES PRIVATE LIMITED',
    'VERANDA RACE LEARNING SOLUTIONS PRIVATE LIMITED',
    'LLAMAS TRAVEL INTERNATIONAL PRIVATE LIMITED',
    'LIFESCIENCEZ ORDINAL RESEARCH & DEVELOPMENT PRIVATE LIMITED',
    'REVDATUM PRIVATE LIMITED',
    'WOY CONSULTING PRIVATE LIMITED',
    'DIALPAD SERVICES PRIVATE LIMITED',
    'MG CARS PRIVATE LIMITED',
    'DASSCODE ANALYTICS PRIVATE LIMITED',
    'SAMVITH NEUROPSYCHIATRIC CENTER PRIVATE LIMITED',
    'FINTAGS TECHNOLOGIES PRIVATE LIMITED',
    'AJIRA AI SOFTWARE INDIA PRIVATE LIMITED',
    'ADITYA BIRLA CAPITAL LIMITED',
    'AAB INDUSTRIAL LOGISTICS AND WAREHOUSINGPRIVATE LIMITED',
    'MOUNTAINIA DEVELOPERS AND HOSPITALITY PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING SIXTEEN LIMITED',
    'PAYASIA BPO PAYROLL INDIA PRIVATE LIMITED',
    'PRIDEWAY HR SERVICES PRIVATE LIMITED',
    'ITERENT TECHNOLOGY AND CONSULTATION PRIVATE LIMITED',
    'BRIGHTEX SYNERGIZER INDIA PRIVATE LIMITED',
    'MUDPIE EDUCATION PRIVATE LIMITED',
    'EUROFINS ADVINUS AGROSCIENCES SERVICES INDIA PRIVATE LIMITED',
    'LIVEALTLIFE HEALTH PRIVATE LIMITED',
    'UTKARSH CLASSES & EDUTECH PRIVATE LIMITED',
    'PRD SOFTWARE AND TECHNOLOGIES PRIVATE LIMITED',
    'TEKSTREET VENTURES PRIVATE LIMITED',
    'ALCHEMY ADVERTISING PRIVATE LIMITED',
    'CAMBAY CONSULTING INDIA PRIVATE LIMITED',
    'BEIERSDORF INDIA SERVICE PRIVATE LIMITED',
    'TRACKLINK LOGISTICS (INDIA) PRIVATE LIMITED',
    'WACHSTUM LASERS AND FAB PRIVATE LIMITED',
    'SARAL SANJIVANI PRIVATE LIMITED',
    'ACCUTEC STORAGE SOLUTIONS PRIVATE LIMITED',
    'BENEFITHUB INDIA PRIVATE LIMITED',
    'NEXTECH INDUSTRIES PRIVATE LIMITED',
    'RCINDO FINTECH PRIVATE LIMITED',
    'KANPUR RIVER MANAGEMENT PRIVATE LIMITED',
    'SPURQLABS TECHNOLOGIES PRIVATE LIMITED',
    'ECLATON ELECTRICALS PRIVATE LIMITED',
    'JAIPRAKASH POWER VENTURES LIMITED',
    'TS BRASS AND BRONZE WORKS PRIVATE LIMITED',
    'FOURVOLT SOLAR PRIVATE LIMITED',
    'GREENLINKS ECOSCAPE PRIVATE LIMITED',
    'ARISTI CYBERTECH PRIVATE LIMITED',
    'HOR KIDDAAN FOODS PRIVATE LIMITED',
    'WOKE F&B PRIVATE LIMITED',
    'CG FOUNDATION',
    'ANKNAN ONLINE TRADING PRIVATE LIMITED',
    'SCHILLINGS ENGINEERING INDIA PRIVATE LIMITED',
    'APCOS NATURALS PRIVATE LIMITED',
    'TRIDAC SOLUTION PRIVATE LIMITED',
    'NEWSWAN TECHNOLOGIES LIMITED',
    'SRI SWASI INFRAZ PRIVATE LIMITED',
    'AVIKIRAN VAYU INDIA PRIVATE LIMITED',
    '3CDN WORKPLACE TECH PRIVATE LIMITED',
    'NISABA EDUCATION TECHNOLOGIES PRIVATE LIMITED',
    'FBO FITTINGS AND SYSTEMS INDIA PRIVATE LIMITED',
    'INTSET BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CURLINK TECHNOSOLUTIONS (OPC) PRIVATE LIMITED',
    'CONSCIOUS EDGE TECH CONSULTING PRIVATE LIMITED',
    'KAYZ LETTINGS AND MANAGEMENT (OPC) PRIVATE LIMITED',
    'MAHINDRA TOP GREENHOUSES PRIVATE LIMITED',
    'PERFORMANCE DATA (INDIA) PRIVATE LIMITED',
    'PROFESSOR BABA',
    'S NEST (OPC) PRIVATE LIMITED',
    'DAA CONSULTING PRIVATE LIMITED',
    'YUBANTEC INDIA PRIVATE LIMITED',
    'ARWA FABRICS PRIVATE LIMITED',
    'DATAFLAKES INNOVATIONS PRIVATE LIMITED',
    'COINEDGE INTERNATIONAL PRIVATE LIMITED',
    'NAMMA HOMEOPATHY PRIVATE LIMITED',
    'MAVERICK DYNAMICS PRIVATE LIMITED',
    'IMPERIUM PROJECTS PRIVATE LIMITED',
    'ALLTEMP SUSTAINABLE REFRIGERANTS INDIA PRIVATE LIMITED',
    'NR GREENWOOD HOTELS AND RESORTS PRIVATE LIMITED',
    'NIPHA RAIL & ENGINEERS PRIVATE LIMITED',
    'RANGETECH SOLUTIONS PRIVATE LIMITED',
    'CREBRI TECHNOLOGIES PRIVATE LIMITED',
    'KOTECHA STEEL FORGE AND CAST INDUSTRIES PRIVATE LIMITED',
    'FLAME SOLREN PRIVATE LIMITED',
    '72 DPI SKILLZ PRIVATE LIMITED',
    'ENKASH NEW WAVES PRIVATE LIMITED',
    'NEXTGEN UNICORN PRIVATE LIMITED',
    'TIGMEN ENGINEERING PRIVATE LIMITED',
    'SARVODAYA MINES AND MINERALS PRIVATE LIMITED',
    'AVA CONDIMENTS PRIVATE LIMITED',
    'HM FLOW CONTROLS PRIVATE LIMITED',
    'THOUGHTDATA SOFTWARE INDIA PRIVATE LIMITED',
    'MARYMATHA INFRASTRUCTURE PRIVATE LIMITED',
    'EVERYWARE TECHNOLOGIES PRIVATE LIMITED',
    'MAITREYA LIFESCIENCE PRIVATE LIMITED',
    'NEWCS INTERNATIONAL PRIVATE LIMITED',
    'OILPOWER HYDRAULICS PRIVATE LIMITED',
    'BLACK GOLD INTERNATIONAL PRIVATE LIMITED',
    'ARCV HOLDINGS PRIVATE LIMITED',
    'NIRAL NETWORKS PRIVATE LIMITED',
    'BENLYCOS PRIVATE LIMITED',
    'PRATAP CARS PRIVATE LIMITED',
    'ECOBIO CONSULTING PRIVATE LIMITED',
    'CRS IMPEX PRIVATE LIMITED',
    'GUDSHO DIGITAL PRIVATE LIMITED',
    'PAAS RESEARCH PRIVATE LIMITED',
    'FORTUNIZE INDIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'PIXADOO VISUALS MUMBAI PRIVATE LIMITED',
    'ASPECTO TECHNOLOGIES PRIVATE LIMITED',
    'WHT NXT TRADE FAIR SOLUTIONS PRIVATE LIMITED',
    'EUROLANDCOM INDIA PRIVATE LIMITED',
    'ZOTALABS PRIVATE LIMITED',
    'SAAMKASH FOODS PRIVATE LIMITED',
    'TOKYO FOUNDRY INDIA PRIVATE LIMITED',
    'SYNTEGON TECHNOLOGY INDIA PRIVATE LIMITED',
    'ARTISAN STREAMS PRIVATE LIMITED',
    'RISHABH ENTERPRISES HVAC&R PRIVATE LIMITED',
    'CRONUS STEEL DETAILING PRIVATE LIMITED',
    'ANATA TECH PRIVATE LIMITED',
    'AMPITY INFOTECH PRIVATE LIMITED',
    'NAVBIZ TRADING PRIVATE LIMITED',
    'ECO MEDIVENT EQUIPMENTS PRIVATE LIMITED',
    'UMBRELLA KIDS PRIVATE LIMITED',
    'REVOPT GLOBAL PRIVATE LIMITED',
    'ARTEE SHADES PRIVATE LIMITED',
    'SDB STEEL AND PIPE PRIVATE LIMITED',
    'INSTALANE INTERNET PRIVATE LIMITED',
    'UNICHRONE PRIVATE LIMITED',
    'INTEGRER SOLUTIONS PRIVATE LIMITED',
    'EZML TECHNOLOGIES PRIVATE LIMITED',
    'LAWGICAL INDIA BUSINESS DEVELOPERS PRIVATE LIMITED',
    'RUDDER LABS INDIA PRIVATE LIMITED',
    'PEBBLEJAR LABS (OPC) PRIVATE LIMITED',
    'OPTIMIZING RESOURCES PRIVATE LIMITED',
    'SRBIT TECHNOLOGIES PRIVATE LIMITED',
    'A',
    'S VALLEY PRIVATE LIMITED',
    'OPENVITAE TECHNOLOGIES PRIVATE LIMITED',
    'DOLTON ELECTROMECH PRIVATE LIMITED',
    'MERRAKISH ENTERPRISES PRIVATE LIMITED',
    'GEYZET TECH INDUSTRIES PRIVATE LIMITED',
    'NAVZOO CARE PRIVATE LIMITED',
    'PALMBEACH ENGINEERING PRIVATE LIMITED',
    'MRINANK HYCHEM PRIVATE LIMITED',
    'EARTHAGE PRIVATE LIMITED',
    'INSIGHT INTERNATIONAL STUDY ABROAD PRIVATE LIMITED',
    'SHARDA NARAYAN PHARMACY PRIVATE LIMITED',
    'E-ASHWA AUTOMOTIVE (KOLKATA) PRIVATE LIMITED',
    'GRC GREEN ERP INDIA PRIVATE LIMITED',
    'INDO PAPER CRAFT PRIVATE LIMITED',
    'TEQBETA TECHNOLOGIES PRIVATE LIMITED',
    'LOGOI CONSULTANCY (OPC) PRIVATE LIMITED',
    'TAILWIND ENTERTAINMENT PRIVATE LIMITED',
    'LOHA NANDED WARANGA HIGHWAYS PRIVATE LIMITED',
    'PWR NUKLEUS TECHNOLOGIES PRIVATE LIMITED',
    'MEEPLE TECHNOLOGIES PRIVATE LIMITED',
    'ALABS AI PRIVATE LIMITED',
    'NEUROTECHNOLOGY LAB INDIA PRIVATE LIMITED',
    'RYAN CONSULTANTS PRIVATE LIMITED',
    'RAY CARE PRIVATE LIMITED',
    'FAIRHUNT MANPOWER SOLUTIONS PRIVATE LIMITED',
    'PASSING MILES FOUNDATION',
    'K2 CLOUD PRIVATE LIMITED',
    'OFFTO TRAVELLERS PRIVATE LIMITED',
    'FYIKIGAI TECHNOLOGIES PRIVATE LIMITED',
    'ASPIRE BIO PHARMA INDIA PRIVATE LIMITED',
    'AIRDATA INTERNET SERVICES PRIVATE LIMITED',
    'BECQ ENERGY PRIVATE LIMITED',
    'BKS METALICS PRIVATE LIMITED',
    'CYBERFENDER INFOTECH PRIVATE LIMITED',
    'GLEE TECHNOLOGIES PRIVATE LIMITED',
    'OYNX HOME DEVELOPERS PRIVATE LIMITED',
    'HOME DESTINATIONS REALTY PRIVATE LIMITED',
    'FRENVI PRIVATE LIMITED',
    'NAION PRIVATE LIMITED',
    'BRIJSHYAM INFRATECH PRIVATE LIMITED',
    'WEAR HUB PRIVATE LIMITED',
    'GLOBEPOINT MULTIMODAL LOGISTICS PRIVATE LIMITED',
    'SHERVAN ELECTRONICS & CABLES PRIVATE LIMITED',
    'MAXBIEN PHARMA PRIVATE LIMITED',
    'HUMM INFO CARE PRIVATE LIMITED',
    'KALTENPRO INDIA PRIVATE LIMITED',
    'TAX COLLARS PRIVATE LIMITED',
    'FREEBIRDS EXPERIENCES PRIVATE LIMITED',
    'KORREX SEALING SOLUTIONS PRIVATE LIMITED',
    'SRIPRAKASH BRANDLINE PRIVATE LIMITED',
    'SAGA RESEARCH LABORATORIES PRIVATE LIMITED',
    'SPIDER FASHIONS PRIVATE LIMITED',
    'RAJHANS EXPO PRIVATE LIMITED',
    'WHUSO ECOMMERCE SOLUTIONS PRIVATE LIMITED',
    'HORIZON HEALTH CRAFT INDIA PRIVATE LIMITED',
    'ATTICA GOLD BRANDS PRIVATE LIMITED',
    'SOUTH INDIAN PUBLICISTS PRIVATE LIMITED',
    'MYGINIE GIFTS PRIVATE LIMITED',
    'RIGHTWAY INTEGRATED SERVICES (OPC) PRIVATE LIMITED',
    'HONASCO PLASTIC TECH PRIVATE LIMITED',
    'KOGNIC LOOM (OPC) PRIVATE LIMITED',
    'EASEMYTRADE PRIVATE LIMITED',
    'KASH-V CHAMBER OF COMMERCE AND INDUSTRY',
    'AAR KAY METALLOYS INDIA PRIVATE LIMITED',
    'GEETHALAYA APPARELS PRIVATE LIMITED',
    'NEOFYSIS BIOTECH PRIVATE LIMITED',
    'SUPERQ TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ABHIYAAN WEALTH PRIVATE LIMITED',
    'MOBISATURN TECHNOLOGIES PRIVATE LIMITED',
    'TRD INFRA PRIVATE LIMITED',
    'RIMUSH INNOVATIONS PRIVATE LIMITED',
    'GREAT BIZ SOLUTIONS PRIVATE LIMITED',
    'INFINITY ELEVATORS PRIVATE LIMITED',
    '4BASECARE ONCO SOLUTIONS PRIVATE LIMITED',
    'ARNO EXIM (INDIA) PRIVATE LIMITED',
    'CANDI SOLAR IN 1 PRIVATE LIMITED',
    'AMP ENERGY GREEN FOURTEEN PRIVATE LIMITED',
    'MISTY VISUALS PRIVATE LIMITED',
    'VANVID CHEMICALS PRIVATE LIMITED',
    'CARBON NEUTRAL PRIVATE LIMITED',
    'JSW RENEWABLE ENERGY (DOLVI) LIMITED',
    'TABLESPACE CONSTRUCTIONS PRIVATE LIMITED',
    'PERK PAYMENT SOLUTION PRIVATE LIMITED',
    'HASTAGIRI SAREE PRIVATE LIMITED',
    'RANG REALTY PRIVATE LIMITED',
    'GREENBIRD ADVISORS PRIVATE LIMITED',
    'MUDITA STRAT-AEGIS CONSULTANTS PRIVATE LIMITED',
    'DREEFAL PRIVATE LIMITED',
    'GEOTECH INDUSTRIES PRIVATE LIMITED',
    'ZIYANA SOFTWARE PRIVATE LIMITED',
    'UNIFIED INTELLIGENCE PRIVATE LIMITED',
    'EXOME INNOVATION PRIVATE LIMITED',
    'LEAPSURGE BUSINESS INNOVATIONS PRIVATE LIMITED',
    'LUMEXA LIFE STYLE (OPC) PRIVATE LIMITED',
    'SRI KRISHNA GARDENERS AND BLOOM PRIVATE LIMITED',
    'JASH ENERGY PRIVATE LIMITED',
    'BLUMEN CAREER CONSULTANCY PRIVATE LIMITED',
    'MONET HEALTHCARE PRIVATE LIMITED',
    'NIFOUR AUTOMATION TECHNOLOGIES PRIVATE LIMITED',
    'COCOCART VENTURES PRIVATE LIMITED',
    'VISHANAND MOTORS INDIA PRIVATE LIMITED',
    'PAPERED SOLUTIONS PRIVATE LIMITED',
    'CHLOROPY TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'THIRD I INFORMATION SECURITY PRIVATE LIMITED',
    'MULTIPL FINTECH SOLUTIONS PRIVATE LIMITED',
    'TEKOVA FOODS PRIVATE LIMITED',
    'STRATSUTRA CONSULTING PRIVATE LIMITED',
    'HOWNOW TECHNOLOGIES PRIVATE LIMITED',
    'DIAFORAISON SERVICES PRIVATE LIMITED',
    'COFOUNDERS PLANET PRIVATE LIMITED',
    'SHAH ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'CONNECTED TECH LABS INDIA PRIVATE LIMITED',
    'SUPRAJAYLA INVESTMENT PRIVATE LIMITED',
    'NISARGA FRESH PROCESSING PRIVATE LIMITED',
    'ELEMENTAL GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SAI SIDHI SWAGAT HEALTH SERVICES PRIVATE LIMITED',
    'FOXSHELTER PRIVATE LIMITED',
    'HEBBEY BEVERAGES PRIVATE LIMITED',
    'YOUR BUZZING KITCHEN PRIVATE LIMITED',
    'E-CONNECT WORLD WEB PRIVATE LIMITED',
    'WORKHUB PRIVATE LIMITED',
    'NESTGURU REALTORS PRIVATE LIMITED',
    'AMBIPALM HEALTH PRIVATE LIMITED',
    'TCHYON INNOVATIVE LABS PRIVATE LIMITED',
    'ALBERT DE MONTAUBERT INDIA PRIVATE LIMITED',
    'SHRIYAYAI COACHING AND CONSULTING SERVICES PRIVATE LIMITED',
    'HAZLAAN INTERNATIONAL PRIVATE LIMITED',
    'TEKCLOVER PRIVATE LIMITED',
    'MINAYA MARKETING & COMMUNICATIONS PRIVATE LIMITED',
    'CONTEXTCO PRIVATE LIMITED',
    'ANUGA ESTATE AND HOSPITALITY PRIVATE LIMITED',
    'NATURMED SCIENTIFIC PRIVATE LIMITED',
    'DEZINEBOX SPACELAB PRIVATE LIMITED',
    'MAHADHATUH PRECIOUS METALS PRIVATE LIMITED',
    'PRASHWAS TECHNOLOGY PRIVATE LIMITED',
    'DEVATITHI TOURISM & HOSPITALITY PRIVATE LIMITED',
    'MEENA INTERNATIONAL PRIVATE LIMITED',
    'CEVIANIT PRIVATE LIMITED',
    'ALIBI GLOBAL PRIVATE LIMITED',
    'INFONAUTIX SOLUTIONS PRIVATE LIMITED',
    'CYBERKEY CONSULTING PRIVATE LIMITED',
    'NISHI INFRA AND TRADING PRIVATE LIMITED',
    'PICHOLA PRIVATE LIMITED',
    'JAJA TRENDS PRIVATE LIMITED',
    'OREX OPUS LOGISTICS PARK PRIVATE LIMITED',
    'CODIGNUS TECHNOLOGIES PRIVATE LIMITED',
    'SOUTH VILLAGE INDIA PRIVATE LIMITED',
    'OSENCE IT SOLUTIONS PRIVATE LIMITED',
    'WHEELS PLAY PRIVATE LIMITED',
    'KRISHNAWANTI RAMPRAKASH NAGPAL CHARITABLE FOUNDATION',
    'MIROR THERAPEUTICS PRIVATE LIMITED',
    'AFRINDIA CONNEXIONS PRIVATE LIMITED',
    'WECODE BYTE INDIA PRIVATE LIMITED',
    'ADCOMP PROCESSING TECHNOLOGY PRIVATE LIMITED',
    'JS BOISSON INDIA PRIVATE LIMITED',
    'FUTURE PLUS CORPORATE SERVICE PRIVATE LIMITED',
    'NOVAMED MEDICAL SYSTEMS PRIVATE LIMITED',
    'EARTHLINK TECHNOLOGIES PRIVATE LIMITED',
    'PLUMBTECH INDIA PRIVATE LIMITED',
    'WEBNOTICS PRIVATE LIMITED',
    'ADYANT WELLNESS MEDICARE SERVICES PRIVATE LIMITED',
    'PRANVAYU SEVA PRIVATE LIMITED',
    'TEAMASIA TECHNICAL TEXTILE PRIVATE LIMITED',
    'CONVERSATIONS ENTERPRISE PRIVATE LIMITED',
    'EARTH MORE PRIVATE LIMITED',
    'BANIL CASTING PRIVATE LIMITED',
    'ANIKUL PERSONAL CARE PRIVATE LIMITED',
    'MAX CARE SOLUTIONS PRIVATE LIMITED',
    'GSL LOGISTICS INDIA PRIVATE LIMITED',
    'TERN-EX PRIVATE LIMITED',
    'ARTHAA AYUBEAT PRIVATE LIMITED',
    'SKANCORP GAS TECHNOLOGIES PRIVATE LIMITED',
    '46 XX VENTURES PRIVATE LIMITED',
    'LOYALTY BONUS.COM PRIVATE LIMITED',
    'KEDRA STYLES PRIVATE LIMITED',
    'INJECTOPLAST PRIVATE LIMITED',
    'EXTREME ENERGY SOLUTIONS INDIA PRIVATE LIMITED',
    'ZOFTEC VERAS INDIA PRIVATE LIMITED',
    'FAODAIL STORES PRIVATE LIMITED',
    'DNS E-COMMERCE PRIVATE LIMITED',
    'JAIVIK KISAN ORGANIC FARMER PRODUCER COMPANY LIMITED',
    'MAPLE DRUG SUBSTANCES AND PRODUCTS PRIVATE LIMITED',
    'LOGARITHM HR CONSULTING SERVICES PRIVATE LIMITED',
    'ALWAYSBLUE LABS PRIVATE LIMITED',
    'NPLAY INFOTAINMENT PRIVATE LIMITED',
    'COTTON INSIDE PRIVATE LIMITED',
    'VYB LIFESTYLE PRIVATE LIMITED',
    'MINERALX FLOWTECH PRIVATE LIMITED',
    'FINCAPITA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'INVESTARC FINTECH SOLUTIONS PRIVATE LIMITED',
    'SUDEEP NUTRITION PRIVATE LIMITED',
    'COMMUTATUS PRIVATE LIMITED',
    'PRODIGAL WEB SOLUTION PRIVATE LIMITED',
    'GUIDE2SOLUTIONS EDUCOUNSELLING PRIVATE LIMITED',
    'MACHANI ROBOTICS PRIVATE LIMITED',
    'KREATIVE CORNER CONSULTANT PRIVATE LIMITED',
    'AKADIALOG PRIVATE LIMITED',
    'CENTRE FOR ENTERTAINMENT AND SPORT RESOLUTION',
    'EYEDYASINFO TECH SOLUTIONS PRIVATE LIMITED',
    'SHOPLETZY PRIVATE LIMITED',
    'E3 FURNITURE PRIVATE LIMITED',
    'WROCUS TECHNOLOGIES PRIVATE LIMITED',
    'KEPLERWORX PRIVATE LIMITED',
    'HEFO ORGANO VALLEY PRIVATE LIMITED',
    'QUALITY SURGICAL PRIVATE LIMITED',
    'AARA HEALTH PRIVATE LIMITED',
    'PMSS JAYALAKSHMI (OPC) PRIVATE LIMITED',
    'ZSM ESERVICES PRIVATE LIMITED',
    'CHROMATIC VENTURES PRIVATE LIMITED',
    'TRADECORP ROVENSA INDIA PRIVATE LIMITED',
    'SARADHI PROJECTS PRIVATE LIMITED',
    'DOTPEN EDUCARE PRIVATE LIMITED',
    'BMS BALAJI REALESTATE PRIVATE LIMITED',
    'SAGAA PAYSECURE PRIVATE LIMITED',
    'JD ENERBIZ PRIVATE LIMITED',
    'RICHSPX ENERGY PRIVATE LIMITED',
    'HINDUJA RENEWABLES TWO PRIVATE LIMITED',
    'CLASSIC TREES PRIVATE LIMITED',
    'SHB HERBALS PRIVATE LIMITED',
    'KUBER INVESTMENT ADVISORS & MANAGERS PRIVATE LIMITED',
    'ASMANAGEMENT OPERATION INDIA PRIVATE LIMITED',
    'ROBLOX INDIA SERVICES PRIVATE LIMITED',
    'VMARSH HEALTHCARE PRIVATE LIMITED',
    'MARKARIAN INTERNATIONAL PRIVATE LIMITED',
    'TROOPF MANAGEMENT SERVICES PRIVATE LIMITED',
    'METROFARMS AGROTECH PRIVATE LIMITED',
    'SB CHEM TEXT PRIVATE LIMITED',
    'VB ENVIRON INDIA PRIVATE LIMITED',
    'V-WILL ENGINEERING PRIVATE LIMITED',
    'SRINIBAS PRADHAN CONSTRUCTIONS PRIVATE LIMITED',
    'AARTI WELFARE FOUNDATION',
    'FRAMEBYFRAME PICTURES PRIVATE LIMITED',
    'RSK MEDIA TECHNOLOGIES PRIVATE LIMITED',
    'AMRUTAM DESIGNS PRIVATE LIMITED',
    'TRILLIONBITS INDIA PRIVATE LIMITED',
    'WISHGAMES11 PRIVATE LIMITED',
    'VAZIRANI REALTY PRIVATE LIMITED',
    'RISING SUN ENERGY ENTERPRISES PRIVATE LIMITED',
    'MOVERY PRIVATE LIMITED',
    'VEGAN BAAZAAR PRIVATE LIMITED',
    'DIVINE LOTUS AGROCART PRIVATE LIMITED',
    'JAP ENGINEERING PRIVATE LIMITED',
    'AGRO ENERGY ECO EFFICIENT PRIVATE LIMITED',
    'DSV CHARITABLE FOUNDATION',
    'GIRIJA MARINE SERVICES PRIVATE LIMITED',
    'MEDIANV DIGITAL MARKETING PRIVATE LIMITED',
    'PAWANSSIDDHI SUPPLIER PRIVATE LIMITED',
    'TECHNOED MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'KOKONUT INFO TECH PRIVATE LIMITED',
    'SUPREME FOUNDATION',
    'PARIJAT ACADEMY',
    'S MAC HOTELS PRIVATE LIMITED',
    'Gets holidays private limited',
    'Manoribel hotel and farming company private limited',
    'Menlyn transport private limited',
    'Marathon logistics private limited',
    'Kvr warehousing & logistics (india) private limited',
    'Nandson logistics limited',
    'QLIFE LOGISTICS AND FREIGHT PRIVATE LIMITED',
    'Shri manjunatha shipping private limited',
    'Dive andaman (india) private limited',
    'Sea trading services and ship management private limited',
    'Freight-ex logistics private limited',
    'Bombardier aerospace india private limited',
    'Hind port & handling services private limited',
    'Nasport handling india private limited',
    'Optitrans solutions private limited',
    'Modera freight services private limited',
    'Lee shipping services private limited',
    'SWIFT CARGO PRIVATE LIMITED',
    'Chandra cfs and terminal operators private limited',
    'Loksons private limited',
    'Garrisons logistics private limited',
    'Armec cooling system limited',
    'Fatton logistics private limited',
    'Dragon king container handling services limited',
    'Shree sati international private limited',
    'Destinations gateway private limited',
    'Marlin travels private limited',
    'Rana travels pvt ltd',
    'Seagate logistics transportation private limited',
    'All track logistic private limited',
    'REGENCY RENT-A-CAB PRIVATE LIMITED',
    'Escape2explore adventures private limited',
    'Best shipping and logistics private limited',
    'Cwt india private limited',
    'Nnr global logistics india private limited',
    'Rishabh integrated logistics private limited',
    'Sevenseas global express logistics private limited',
    'Menzies aviation (india) private limited',
    'NEW DHOLERA SHIPPING & TRADING CO LIMITED',
    'Arihant shipping private limited',
    'Southstar shipping (india) private limited',
    'Kay-pee services private limited',
    'Millennium freight forwarders private limited',
    'Keel logistics private limited',
    'Reva logistics private limited',
    'Emirates logistics india private limited',
    'Trish travels private limited',
    'Impress logistics (india) private limited',
    'FORTUNA FUNDCAP PRIVATE LIMITED',
    'Trans air express private limited',
    'MAMOTEK SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Isquare mobility private limited',
    'A-KAL TELEVERSE PRIVATE LIMITED',
    'Ms mobile technologies private limited',
    'Jas telecom private limited',
    'Vibrant global capital limited.',
    'Nas leasing india private limited',
    'L&T FINANCE LIMITED',
    'Sensex financial services private limited',
    'Kala darshan finance private limited',
    'Luxora infrastructure private limited',
    'Mac financial and management consultants private limited',
    'Nova tradex private limited',
    'Chokhani financial and investment consultancy service pvt ltd',
    'Inventure finance private limited',
    'Interlink management services (india) private limited',
    'Pammvi constructions limited',
    'Rakshit investments pvt ltd',
    'Kothari jewels private limited',
    'Vyoma investment & finance company private limited',
    'Superfund financial india private limited',
    'G.s.v. securities private limited',
    'Vramath financial services private limited',
    'Cherukuri benefit fund limited',
    'Sweetco confectionery private limited',
    'Konark natural foods private limited',
    'Eatman foods india private limited',
    'Little italy express foods private limited',
    'New tex-fab private limited',
    'Durafab silk industries pvt ltd',
    'Jayalakshmi textiles private limited',
    'Binary apparel tecknics india private limited',
    'HOUSE OF ANITA DONGRE PRIVATE LIMITED',
    'Bhavtej syntex private limited',
    'YASHOBHAV ENTERPRISES PRIVATE LIMITED',
    'Digital engineering projects private limited',
    'SOUL CLOTHING PRIVATE LIMITED',
    'Marudhar clothing private limited',
    'FEATHERFEEL NONWOVEN PRIVATE LIMITED',
    'Asm industries (india) private limited',
    'SAHAJ SOLAR LIMITED',
    'Indus intex private limited',
    'CLOTHING CULTURE PRIVATE LIMITED',
    'Bombay rayon holdings limited',
    'SAGAR GREEN FIELDS PRIVATE LIMITED',
    'Sri vishnu shankar mills limited',
    'Suvida designs private limited',
    'Styletribe fashion apparel private limited',
    'Project garments pvt ltd',
    'Miracle clothing private limited',
    'Mmv fashions private limited',
    'Clothes rack private limited',
    'Kanva fashions limited',
    'Renram fashions india private limited',
    'Sehej saraa fashion private limited',
    'Escalations travel ware india private limited',
    'Nathan manufacturers and traders private limited',
    'Maruti decor projects private limited',
    'Dev khush veneers private limited',
    'Angel exim private limited',
    'Param packaging private limited',
    'EVERGREEN BOARDLAM PRIVATE LIMITED',
    'Shree swami packaging private limited',
    'Elegant hygiene private limited',
    'Scholastic india private limited',
    'Ramya reprographic private limited',
    'Suvarna karnataka broadcasting limited',
    'Akme cards private limited',
    'Pentagram films private limited',
    'Repro enterprises private limited',
    'Repro innovative digiprint limited',
    'Sheen animation studio private limited',
    'PLAY MEDIA SPORTS AND ENTERTAINMENT PRIVATE LIMITED',
    'REPRO BOOKS LIMITED',
    'Marex media private limited',
    'Brand connect communications (india) private limited',
    'Music network india private limited',
    'NAVAYUGA ENGINEERS PROJECTS PRIVATE LIMITED',
    'Meet petro products private limited',
    'Rsl bioscience private limited',
    'Choksey chemicals private limited',
    'Gomati chemicals private limited',
    'CORIANDER SPECIALITIES PRIVATE LIMITED',
    'Toffen pharmaceuticals private limited',
    'Vasu organics private limited',
    'Snap natural and alginate products private limited',
    'Premium serums and vaccines private limited',
    'Aaranya biosciences private limited',
    'Heena marketing limited',
    'Initia pharmachem private limited',
    'Eastern chemicals (mumbai) private limited',
    'Technomax enterprises (india) private limited',
    'Arjun chemicals private limited',
    'Biocrop private limited',
    'Padma pharmaceuticals private limited',
    'Modi paint private limited',
    'Ibioanalysis private limited',
    'Immense healthcare private limited',
    'Leonis pharmaceuticals private limited',
    'Vital lifesciences private limited',
    'Harika drugs private limited',
    'India vitamins private limited',
    'Renocare pharmaceuticals private limited',
    'Riconpharma india private limited',
    'Raks pharma private limited',
    'Jasper brands private limited',
    'Gayatri herbals private limited',
    'Star orechem international private limited',
    'Geneombio technologies private limited',
    'Spectrum ingredients private limited',
    'KIRTI HEALTHCARE PRIVATE LIMITED',
    'Kaytross healthcare limited',
    'Teckwin sign solutions private limited',
    'Auxilia technologies private limited',
    'Gem corpochem private limited',
    'Atc tires private limited',
    'L&L PRODUCTS INDIA PRIVATE LIMITED',
    'Sanghvi poly products private limited',
    'Kmb extrusion private limited',
    'Lakshmi balaji realty private limited',
    'Metrology infosystems (india) private limited',
    'VENSAI TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Ayatas software solutions (india) private limited',
    'Toshiba india private limited',
    'Promptec solutions private limited',
    'Nst private limited',
    'Intuz solutions private limited',
    'Innodel technologies private limited.',
    'Idream technosoft private limited',
    'Axxonet solutions india private limited',
    'VINYAS INNOVATIVE TECHNOLOGIES LIMITED',
    'Fidelity business services india private limited',
    'Raise solutions private limited',
    'Lenvica computer solutions private limited',
    'Agni information systems private limited',
    'Secpod technologies private limited',
    'Pyrumas software (bangalore) private limited',
    'Semaconnect systems india private limited',
    'Ciberspring technologies (india) private limited',
    'Incadea india private limited',
    '3m digital networks private limited',
    'Engrav systems private limited',
    'Drn definite solutions private limited',
    'Vzure software network solutions private limited',
    'Zweezle media private limited',
    'NEEM INFO SOLUTIONS PRIVATE LIMITED',
    'PLANNET TECHNEST SOUTH INDIA PRIVATE LIMITED',
    'SHEEJA',
    'S HOSPITALITY PRIVATE LIMITED',
    'Vegas hospitality private limited',
    'Mad orders private limited',
    'Casamia hospitality and realty private limited',
    'Golden hills resort private limited',
    'Ivr pudl resorts & clubs private limited',
    'Oh so stoned ice creams private limited',
    'Nc chandra builder limited',
    'Rose valley hotels and entertainments limited',
    'Chrome hotels and resorts limited',
    'Sunflower inn limited',
    'Zen restaurants private limited',
    'SAANVEE STAR HOSPITALITY PRIVATE LIMITED',
    'Kanakia hotels & resorts private limited',
    'Jsm restaurants india private limited',
    'Aff logistics private limited',
    'ONS EXPRESS & LOGISTICS ( INDIA ) PRIVATE LIMITED',
    'Vijay parivahan private limited',
    'Cannon shipping company limited',
    'U - sea logistics services (india) private limited',
    'Selandia ship management (india) private limited',
    'Corporate wings and aviation technology priavate limited',
    'Chariot world tours limited',
    'Nikhil clearing & forwarding private limited',
    'Dnyaneshwar shipping services private limited',
    '24 x 7 travel solutions private limited',
    'Business transport resources india private limited',
    'Gujarat integrated maritime complex private limited',
    'Trio shipping services private limited',
    'DHANLAXMI CROP SCIENCE LIMITED',
    'Armatix (india)private limited',
    'Origin formulations private limited',
    'ARINNA LIFESCIENCES Limited',
    'Succor health care private limited',
    'Mehta api private limited',
    'Bristol-myers squibb india private limited',
    'Quad lifesciences private limited',
    'Neuheit pharma technologies private limited',
    'Cephas medical private limited',
    'SQUARE ENTERPRISES PRIVATE LIMITED',
    'Fluence pharma private limited',
    'Chromaflo technologies india private limited',
    'Amar life science private limited',
    'Astra-idl limited',
    'AKRON FORMULATIONS INDIA PRIVATE LIMITED',
    'Rampex labs private limited',
    'INNOVA CAPTAB LIMITED',
    'APEX MATCH CONSORTIUM (INDIA) PRIVATE LIMITED',
    'Tulsi cloth processors private limited',
    'Toyota boshoku automotive india private limited',
    'Lion rubber industries private limited',
    'Jagruti resins private limited',
    'Tokai imperial rubber india private limited',
    'Kaveri polymers pvt ltd',
    'Idol plasto private limited',
    'Organic industries private limited',
    'Annapurna pet private limited',
    'Primex plastics private limited',
    'Hangers plus (india) private limited',
    'Renolit india private limited',
    'Prince Corp Private Limited',
    'Aquafit piping systems (i) private limited',
    'Organic plastics private limited',
    'Funskool(india) ltd.',
    'CRYSTAL CERAMIC INDUSTRIES LIMITED',
    'Texturing technology private limited',
    'Inesh accerro limited',
    'Seven star steels limited',
    'Rhodium ferro alloys private limited',
    'Bilva technologies private limited',
    'Sriven life science private limited',
    'Jouel sculpt private limited',
    'Dia vente jewellery pvt. ltd.',
    'Kme india private limited',
    'Guardian castings private limited',
    'Progas systems private limited',
    'Wieland metals india private limited',
    'Varmora plastech private limited',
    'Texwell engineers private limited',
    'Miteck systems private limited',
    'STRUCTECH CONSULTING ENGINEERS INDIA PRIVATE LIMITED',
    'Devshree saving and investment company private limited',
    'Durabuild technologies private limited',
    'Bhukhanvala industries private limited',
    'Ddm engineering private limited',
    'Naargo industries private limited',
    'Hoist craft systems private limited',
    'Karnataka tufftriding and engineering works private limited',
    'Geonair aircondition and refrigeration manufacturers private limited',
    'Nicotra india private limited',
    'R and s engineering india pvt ltd',
    'Shubham equipments private limited',
    'EXELON PROJECTS PRIVATE LIMITED',
    'Infotech hal limited',
    'Miraj rotor blade technology private limited',
    'JEC BIOGAS TECHNOLOGY PRIVATE LIMITED',
    'Starrag india private limited',
    'Raptech engineering private limited',
    'Ikaros kinetic solar private limited',
    'Mirage steels private limited',
    'Major science instruments private limited',
    'Bbm heavy machinery private limited',
    'Jobby industrial services private limited',
    'Rotometrics india private limited',
    'Fibox india private limited',
    'Yash textile machines private limited',
    'Fab-tech works & constructions private limited',
    'Mansons international private limited',
    'Sparta oil tools private limited',
    'Cereibro trade service private limited',
    'Yes vcs india private limited',
    'Hilti manufacturing india private limited',
    'N and s proserv private limited',
    'GODSKITCHEN HOSPITALITY PRIVATE LIMITED',
    'Infinova (india) private limited',
    'Signature kitchens (india) private limited',
    'Star whites laundry equipements and services private limited',
    'Hi scan private limited',
    'Netweb software private limited',
    'Chs computers private limited',
    'Genilok computer solutions private limited',
    'Akhil systems private limited',
    'Wellness bpo private limited',
    'Prakruthik enterprises private limited',
    'BRIDGEMONTE ADVISORS PRIVATE LIMITED',
    'Maven professional services private limited',
    'Ecap consultants private limited',
    'WHITE THOUGHTS AND BRANDING PRIVATE LIMITED',
    'Mcs communications private limited',
    'Johnson electric private limited',
    'Intex solutions private limited',
    'Tesla controls (india) private limited',
    'Einstro technical services private limited',
    'SUN CONCLAVE PRIVATE LIMITED',
    'Vinilok solutions private limited',
    'Sara logistics services private limited',
    'Daystar it academy private limited',
    'FAZLANI ENTERPRISES PRIVATE LIMITED',
    'GOVERDHAN VENTURES PRIVATE LIMITED',
    'Phalashruti shikshan mandal private limited',
    'Sri gayatri educational services private limited',
    'Vishwanethra health services private limited',
    'Mpc healthcare services private limited',
    'Rosheel health care private limited',
    'Dots lifescience private limited',
    'Health & wellness aadhar private limited',
    'Synopsys (india) private limited',
    'Austin medical solutions private limited',
    'Ankur healthcare private limited',
    'Assured best care hospital private limited',
    'India electronics & semiconductor association',
    'Iosis spa and wellness private limited',
    'Atria hospitals and research centre private limited',
    'Panacea healing private limited',
    'Vasudha waste treatment private limited',
    'Maratha entrepreneurs association',
    'CARD MANUFACTURERS',
    's Adventures Private Limited',
    'JESONS IMPLEX PVT LTD',
    'JETWAYS TRAVELS PRIVATE LIMITED',
    'JAGRATAN FINVEST PRIVATE LIMITED',
    'JAI AMRIT EXPORTS PRIVATE LIMITED',
    'JAIR NETWORK & SERVICES PRIVATE LIMITED',
    'JAIVEER FINCON PRIVATE LIMITED',
    'INNOVATIVE LEADERSHIP FORUM',
    'PINNACLE CAPITAL SOLUTIONS PRIVATE LIMITED',
    'JH SOFTWARE PRIVATE LIMITED.',
    'JHABUA POWER INVESTMENTS LIMITED',
    'JHUM MARKETING PRIVATE LIMITED',
    'JINDAL CAPITAL LIMITED',
    'JINDAL COSMETICS PRIVATE LIMITED',
    'JAM VISION TECH PRIVATE LIMITED',
    'JAMSHEDPUR MINERAL WOOL MANOFACTURING COMPANY PRIVATE LIMITED',
    'JINDAL EXPORTS AND IMPORTS PRIVATE LIMITED.',
    'Jindal Fittings Limited',
    'Jindal General Services Private Limited',
    'Jindal Hydro Power Limited',
    'JINDAL INTELLICOM LIMITED',
    'JINDAL LEASEFIN LIMITED',
    'JINDAL MEDICAL AND SCIENTIFIC INSTRUMENTS COMPANY PRIVATE LIMITED',
    'JINDAL STAINLESS CONSULTANCY SERVICES PRIVATE LIMITED',
    'JINDAL POWER DISTRIBUTION LIMITED',
    'JINDAL POWER TRANSMISSION LIMITED',
    'JINDAL SYSTEMS PRIVATE LIMITED',
    'Jindal Techserv Private Limited',
    'JANESHWAR DASS AND SONS PRIVATE LIMITED',
    'JASMINE CONSULTING ASSIGNMENTS PRIVATE LIMITED',
    'ACCENTURE OPERATIONS SERVICES PRIVATE LIMITED',
    'SUTLEJ MOTORS Private Limited',
    'JIVA DESIGNS PVT. LTD.',
    'JIVAA RETAILS INDIA PRIVATE LIMITED',
    'JIWAN BOOKS INTERNATIONAL PVT LTD',
    'JIWAN PUBLISHING HOUSE PRIVATE LTD',
    'JK CATERERS PRIVATE LIMITED',
    'JKT&I EMPLOYEES WELFARE ASSOCIATION LIMITED',
    'RAM BHAJ AND SONS PRIVATE LIMITED',
    'JMD Abode and Banquets Private Limited',
    'JAY TECH PRINTING SYSTEMS PRIVATE LIMITED',
    'JAYANT ESTATE PRIVATE LIMITED',
    'JMF PERFORMANCE MATERIALS PRIVATE LIMITED',
    'JNG CONSTRUCTION PRIVATE LTD.',
    'JNJA INVESTMENTS PRIVATE LIMITED',
    'JODAS EXPOIM PRIVATE LIMITED',
    'JAYANTI COMMUNICATIONS PRIVATE LIMITED',
    'PERSONIV CONTACT CENTERS INDIA PRIVATE LIMITED',
    'K.N.K. ASSOCIATES PRIVATE LIMITED',
    'MANHATTAN INDUSTRIAL PROMOTERS PRIVATE LIMITED',
    'XELLENT TRIPS PRIVATE LIMITED',
    'MARCK DERIVATIVES PRIVATE LIMITED',
    'MARCK FINCON PRIVATE LIMITED',
    'MARG ERP LIMITED',
    'Mariabella Builders & Developers Private Limited',
    'MARIANA CONSTRUCTIONS LIMITED',
    'MARIANA INFRASTRUCTURE LIMITED',
    'MANOR HOTELS PRIVATE LIMITED',
    'MANSAAROVER IRRIGATIONS PRIVATE LIMITED',
    'MANSAROVAR BUILDERS PVT LTD',
    'KALS INFORMATION SYSTEMS PRIVATE LIMITED',
    'MANISH POLYCOATS PRIVATE LIMITED',
    'MANISHI TOWERS PRIVATE LIMITED',
    'MANJOLA INFRASTRUCTURE LIMITED',
    'MANLIFT INDIA PRIVATE LIMITED',
    'MARKUS INFRASTRUCTURE PRIVATE LIMITED',
    'MARMO HOME PRIVATE LIMITED',
    'MANOHAR LAL GUPTA PROJECTS PRIVATE LIMITED',
    'LMC ENTERPRISES PRIVATE LIMITED',
    'LMC MOTOR COMPANY PRIVATE LIMITED',
    'ROCKET ENGINEERING CORPORATION PRIVATE LIMITED',
    'SUBRAINS SOLUTIONS PRIVATE LIMITED',
    'INGRAIN SYSTEMS PRIVATE LIMITED',
    'OVRVIEW TECHNOLOGIES PRIVATE LIMITED',
    'MIISKY TECHNOVATION PRIVATE LIMITED',
    'MARIANA REAL ESTATE LIMITED',
    'MANU CREDIT INDIA LIMITED',
    'MAPLE PRESS PRIVATE LIMITED',
    'MARC PAPERS PRIVATE LIMITED',
    'ROOTER SPORTS TECHNOLOGIES PRIVATE LIMITED',
    'INTEGRATOR SERVICES INDIA PRIVATE LIMITED',
    'MARIANA PROPERTIES LIMITED',
    'MakeSense Technologies Limited',
    'LLOYD INSULATIONS (INDIA) LIMITED',
    'LM ENERGY AND SOFTWARE PRIVATE LIMITED',
    'LE MEILLEUR INFRASTRUCTURES AND DEVELOPERS PRIVATE LIMITED',
    'KUTUMBA EDUCATION AND KNOWLEDGE FOUNDATION',
    'LMC AUTOMOTIVE COMPANY PRIVATE LIMITED',
    'YAZAKI INDIA Private Limited',
    'KOGLAND COMMERCE PRIVATE LIMITED',
    'KENBAR AUTO PRIVATE LIMITED',
    'TECHNOSKULLS INNOVATION CENTER (INDIA) PRIVATE LIMITED',
    'VARSITO SOLUTIONS PRIVATE LIMITED',
    'BALWAN AGRO INDUSTRIES PRIVATE LIMITED',
    'KIDS DENTAL CARE PRIVATE LIMITED',
    'FOUNDATION FOR TECHNOLOGY AND BUSINESS INCUBATION',
    'TUNKERS AUTOMATION INDIA PRIVATE LIMITED',
    'SAYARMAL STEELS PRIVATE LIMITED',
    'DENTAL MAMMOTH INDIA PRIVATE LIMITED',
    'EVENT GRAPHIA PRIVATE LIMITED',
    'MIRSAAB ESTATES PRIVATE LIMITED',
    'SAWA ADVISORY SERVICES PRIVATE LIMITED',
    'MARIM INDUSTRIES LIMITED',
    'TRILLTALE TECHNOLOGIES PRIVATE LIMITED',
    'CLUSTERBEAN TECHNOLOGIES PRIVATE LIMITED',
    'MARION BIOTECH PRIVATE LIMITED',
    'SNAPTECH DIGITAL SOLUTIONS PRIVATE LIMITED',
    'IIT ROPAR-TECHNOLOGY BUSINESS INCUBATOR FOUNDATION',
    'CAREODRIVE FINANCIALS PRIVATE LIMITED',
    'MARIUS RISK MANAGEMENT PRIVATE LIMITED',
    'MARKENRICH CONSULTING PRIVATE LIMITED',
    'MARKETELS HOSPITALITY PRIVATE LIMITED',
    'AL-FATHIMA GENERAL TRADING PRIVATE LIMITED',
    'MarketGoal Digital Solutions Private Limited',
    'ALTF SPACES PRIVATE LIMITED',
    'MANDALA CONSTRUCTIONS PRIVATE LIMITED',
    'RIPLEY OFFSHORE PRIVATE LIMITED',
    'A3 CONSULTING PRIVATE LIMITED',
    'GANESHA COMMOSALES PRIVATE LIMITED',
    'TEEJ EXPORTS PRIVATE LIMITED',
    'MANDEEP INFOSOLUTIONS PRIVATE LIMITED',
    'MARS Car Care Services Private Limited',
    'KRACKERZ 360 DEGREE SOLUTIONS PRIVATE LIMITED',
    'MANDV MARKET DEVELOPMENT SERVICES PRIVATE LIMITED.',
    'BIOCONCEPT BIOLOGICALS PRIVATE LIMITED',
    'ACCRUVAL TECHNOLOGIES PRIVATE LIMITED',
    'ARCTIC IMPEX PRIVATE LIMITED',
    'ZIA HOLIDAYS AND RESORTS PRIVATE LIMITED',
    'MANIDHARI IMPEX PRIVATE LIMITED',
    'POSSIBL MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED',
    'THEFINANCIALMALL PRIVATE LIMITED',
    'VIHAAN AUTO VENTURES PRIVATE LIMITED',
    'DALMIA POLYPRO INDUSTRIES Private Limited',
    'AJ HOUSEKEEPING AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'PRIYAM IT SERVICES PRIVATE LIMITED',
    'AADROIT INDULGENCE PRIVATE LIMITED',
    'PROTOCOL LEADS INFOTECH PRIVATE LIMITED',
    'NEPSIZ TECHNOLOGIES PRIVATE LIMITED',
    'SDMA PROJECTS PRIVATE LIMITED',
    'TRIWAY CHENNAI CONTAINER FREIGHT STATIONPRIVATE LIMITED',
    'ISKPRO PRIVATE LIMITED',
    'SANJAY GHODAWAT FOUNDATION',
    'TECSHAK INDIA PRIVATE LIMITED',
    'PUMP HOUSE PRIVATE LIMITED',
    'UTTEZ DIGITAL INDIA PRIVATE LIMITED',
    'GMR INFRA SERVICES PRIVATE LIMITED',
    'MAPSURF TRAVELS PRIVATE LIMITED',
    'KARTIKEYA ENERTECH PRIVATE LIMITED',
    'AUTHENTIC JOURNEYS INDIA AND BEYOND PRIVATE LIMITED',
    'GREYSTONE ENERGY SYSTEMS PRIVATE LIMITED',
    'ESKAPS LOGISTICS & SHIPPING PRIVATE LIMITED',
    'KAAY LABS PRIVATE LIMITED',
    'SUVARNABHOOMI INFRA DEVELOPERS PRIVATE LIMITED',
    'ARPITA TRAVELS (OPC) PRIVATE LIMITED',
    'TOOLMECH PRIVATE LIMITED',
    'GOQWERTY COMMUNICATIONS PRIVATE LIMITED',
    'RAMPURA ORGANICS INDIA PRIVATE LIMITED',
    'ZACKE AGGREGATION PRIVATE LIMITED',
    'MICRO HEALTH LABORATORIES PRIVATE LIMITED',
    'RAGTAGGER LIFESTYLE PRIVATE LIMITED',
    'TECNESIUM COMPUTER SYSTEMS PRIVATE LIMITED',
    'BEARD DESIGN STUDIO PRIVATE LIMITED',
    'HL WORLDWIDE LOGISTICS PRIVATE LIMITED',
    'BANSAL IMPORTER PRIVATE LIMITED',
    'GETACALL INDIA (OPC) PRIVATE LIMITED',
    'KT TELEMATIC SOLUTIONS PRIVATE LIMITED',
    'ADVAITA ORGANICS PRIVATE LIMITED',
    'REDDWOOD RETAIL PRIVATE LIMITED',
    'SHANTI HEALTH SERVICES PRIVATE LIMITED',
    'NETCOMINFRA PRIVATE LIMITED',
    'TECHMIND AUTOMATION PRIVATE LIMITED',
    'C&G AGROVENTURES PRIVATE LIMITED',
    'JAVVYZ MEDIA PRIVATE LIMITED',
    'ACCELIGIZE BUSINESS SERVICES PRIVATE LIMITED',
    'STARTUP NUKAD INDIA FOUNDATION',
    'CHITYALA MANDALA FARMERS PRODUCER COMPANY LIMITED',
    'SWARUP & SAROJ SOLUTIONS PRIVATE LIMITED',
    'OMNIBRX BIOTECHNOLOGIES PRIVATE LIMITED',
    'SKYCORE TECHNOLOGIES PRIVATE LIMITED',
    'GESAR DISPLAYS PRIVATE LIMITED',
    'AAC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RADHAPURAM TRADITIONAL CROP PRODUCER COMPANY LIMITED',
    'MYTRAH AKSHAYA ENERGY PRIVATE LIMITED',
    'DEMYTO AUTOTECH SOLUTIONS PRIVATE LIMITED',
    'BEST FOOT FORWARD PRIVATE LIMITED',
    'REPLIKA PACKAGING PRIVATE LIMITED',
    'STAAR FIT PRIVATE LIMITED',
    'NCUBE LOGISTICS SOLUTION INDIA PRIVATE LIMITED',
    'TOCODE TECHNOLOGIES PRIVATE LIMITED',
    'SCIENTIA INNOVATION PRIVATE LIMITED',
    'SHUBHLAXMI DIAMOND PRIVATE LIMITED',
    'CUBE CONCRETE SOLUTIONS PRIVATE LIMITED',
    'DIGIUNIVERSE INDIA PRIVATE LIMITED',
    'HAPPYMILES TRAVEL INDIA PRIVATE LIMITED',
    'NIRVANA RECYCLING PRIVATE LIMITED',
    'HANSEN CUSTOMER SUPPORT INDIA PRIVATE LIMITED',
    'SUNREN POWER PRIVATE LIMITED',
    'ASHIMARA HOUSING PRIVATE LIMITED',
    'BANAYANTREE SERVICES LIMITED',
    'SANOZEN PHARMA PRIVATE LIMITED',
    'SUNERGY AGRO PRIVATE LIMITED',
    'KOGNITIV INDIA PRIVATE LIMITED',
    'RIVER APARTMENT OWNERS ASSOCIATION',
    'NUTECHANALYTICAL TECHNOLOGIES PRIVATE LIMITED',
    'DEFILOGIC ISOL (OPC) PRIVATE LIMITED',
    'RVK CHEMICALS PRIVATE LIMITED',
    'YFIN ADVISOR PRIVATE LIMITED',
    'BARMER POWER TRANSMISSION SERVICE LIMITED',
    'EWRI RECYCLERS (INDIA) PRIVATE LIMITED',
    'SPAN HEALTHCARE CONSULTING PRIVATE LIMITED',
    'INTRALAIT ENGINEERING TECHNOLOGIES PRIVATE LIMITED',
    'NEXTECHNO GEN PRIVATE LIMITED',
    'YZ SONS PRIVATE LIMITED',
    'VARTIS ENGINEERING PRIVATE LIMITED',
    'NORTH SOUTH MARITIME (INDIA) PRIVATE LIMITED',
    'TRANSWORLD INTERNATIONAL REALTY SERVICESPRIVATE LIMITED',
    'BABAJI SHIVRAM 4PL SOLUTIONS PRIVATE LIMITED',
    'CALMKEY HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'FABULYST PRIVATE LIMITED',
    'O2U2 SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'DREAMWEAVER INVESTMENT AND BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PRO NUTRI INDIA PRIVATE LIMITED',
    'IVIECAP SERVICES PRIVATE LIMITED',
    'IQ SPORTS MANAGEMENT PRIVATE LIMITED',
    'NIDHI MARQUE ONE MOTORS PRIVATE LIMITED',
    'SUMILAX SMT TECHNOLOGIES PRIVATE LIMITED',
    'ARC CONSULTING (I) PRIVATE LIMITED',
    'CONLOGISTICS ASIA PRIVATE LIMITED',
    'HERITAGE LIFESPACE PRIVATE LIMITED',
    'MELA ARTISANS (INDIA) PRIVATE LIMITED',
    'ART WEALTH MANAGEMENT (INDIA) PRIVATE LIMITED',
    'AWLIV LIVING SOLUTIONS PRIVATE LIMITED',
    'GATISTAVAM SOFTECH PRIVATE LIMITED',
    'CONTRACTORBHAI PRIVATE LIMITED',
    'ALEXIS PHARMACY PRIVATE LIMITED',
    'PILLER GLOBAL (INDIA) PRIVATE LIMITED',
    'WHIZ BROKERS BAZAAR PRIVATE LIMITED',
    'EVERGREENFASTENERS (INDIA) PRIVATE LIMITED',
    'BEEBOM MEDIA PRIVATE LIMITED',
    'NRSP FOUNDATION',
    'LIQVID ENGLISH EDGE PRIVATE LIMITED',
    'NEORAJKOT FOUNDATION',
    'MARSS TRADERS INDIA PRIVATE LIMITED',
    'GASSOL SOLUTIONS PRIVATE LIMITED',
    'AMOS INTERNATIONAL PRIVATE LIMITED',
    'WIKREATE WORLDWIDE PRIVATE LIMITED',
    'INNOVOSOFT TECHNOLOGIES PRIVATE LIMITED',
    'RHENO ECOSYSTEMS PRIVATE LIMITED',
    'NINAAD WELLBEING FOUNDATION',
    'KAYA BLENDERS AND DISTILLERS LIMITED',
    'COMZOOMER TECHNOLOGIES PRIVATE LIMITED',
    'GNG ACCOUNTANCY SERVICES PRIVATE LIMITED',
    'VANAVIL SYSTEMS INDIA PRIVATE LIMITED',
    'INSUIDE TECHNOLOGIES PRIVATE LIMITED',
    'GENTECH PROPERTIES PRIVATE LIMITED',
    'INSPIRION DIGITAL SOLUTIONS PRIVATE LIMITED',
    'RAISONI VENTURES PRIVATE LIMITED',
    'LUTSEL TECHNOLOGIES PRIVATE LIMITED',
    'SPAR SOLUTIONS INDIA PRIVATE LIMITED',
    'AUDENTIUS INFRA INDIA PRIVATE LIMITED',
    'OMNITRIX BUSINESS SERVICES PRIVATE LIMITED',
    'RISE ELEVEN READYMIX PRIVATE LIMITED',
    'ROOMSNOW ESOLUTIONS PRIVATE LIMITED',
    'OUTCOME SERVICES PRIVATE LIMITED',
    'BLS IT SERVICES PRIVATE LIMITED',
    'UNIFIED GLOBALTECH (I) PRIVATE LIMITED',
    'SURYAHABITECH PRIVATE LIMITED',
    'CLEAN WIND POWER(PIPLODA) PRIVATE LIMITED',
    'PSI ENERGY PRIVATE LIMITED',
    'FESTUS PROPERTIES PRIVATE LIMITED',
    'RAM ESUPER STORE PRIVATE LIMITED',
    'BOOK AS ONE PRIVATE LIMITED',
    'CLOUDIUM SOFTWARE PRIVATE LIMITED',
    'DOCTORTALK TECHNOLOGIES PRIVATE LIMITED',
    'AADHAR INDIA AGRI PRODUCER COMPANY LIMITED',
    'GLOBESHINE BUILDERS PRIVATE LIMITED',
    'GREENFIELD TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'JDS FLEETS UTILITIES INDIA LIMITED',
    'ETERNITY AUTOMOBILES PRIVATE LIMITED',
    'EXALTER RESORTS & SPA PRIVATE LIMITED',
    'VOODOO TRAVEL PRIVATE LIMITED',
    'COOPER LYBRANTH SERVICES LIMITED',
    'NORDEN COMMUNICATION PRIVATE LIMITED',
    'ENFROSUN POWER PRIVATE LIMITED',
    'BUNNYBERRY INNOVATIONS INDIA PRIVATE LIMITED',
    'EXTRUDE HONE INDIA PRIVATE LIMITED',
    'ART CORPORATE FINANCE (INDIA) PRIVATE LIMITED',
    'RISING FINANCIALS LIMITED',
    'FRUTZ MEDIA COM PRIVATE LIMITED',
    'KONSULTERA SOLUTIONS PRIVATE LIMITED',
    'EKOMKAR PICTURES PRIVATE LIMITED',
    'HASHTAG LOYALTY PRIVATE LIMITED',
    'PS ARCADIA OWNERS',
    'S DANCE STUDIO PRIVATE LIMITED',
    'GROWTH HACK SOLUTIONS PRIVATE LIMITED',
    'ZAADOO SERVICES PRIVATE LIMITED',
    'SKETCHEA IT CONSULTANTS PRIVATE LIMITED',
    'RTBRICK INDIA PRIVATE LIMITED',
    'DIGIFISH DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SWAN CREW PRIVATE LIMITED',
    'VISMAYA SOCIAL INNOVATIONS PRIVATE LIMITED',
    'HOLISTIQUE BEAUTY PRODUCTS PRIVATE LIMITED',
    'PICKIT GOURMET PRIVATE LIMITED',
    'BAGAHA KISAN UTPADAK PRODUCER COMPANY LIMITED',
    'VEZBYNATURE PRODUCTS PRIVATE LIMITED',
    'DHOLI SPINTEX PRIVATE LIMITED',
    'ARTISANAL HOSPITALITY PRIVATE LIMITED',
    'VARUN GAS LOGISTICS PRIVATE LIMITED',
    'TRIPSHELF TECHNOLOGIES PRIVATE LIMITED',
    'CAPSTOCKS HOLIDAYS AND RESORTS PRIVATE LIMITED',
    'SOLUTION OBJECTS SOFTWARE PRIVATE LIMITED',
    'ZAPPA JOBS & SOLUTIONS PRIVATE LIMITED',
    'LOKAA ENTERTAINMENT PRIVATE LIMITED',
    'ZORBA RENAISSANCE PRIVATE LIMITED',
    'PENDELN TECHNOLOGIES PRIVATE LIMITED',
    'SUCCESS HR PRIVATE LIMITED',
    'CAREERMAN STARTUP SERVICES PRIVATE LIMITED',
    'TALGO INDIA PRIVATE LIMITED',
    'QUADRANGLE ENGINEERING PRIVATE LIMITED',
    'RPLANX TECHNOLOGY PRIVATE LIMITED',
    'E-TECH FACILITY MANAGEMENT SERVICES (OPC) PRIVATE LIMITED',
    'TECHNOTUDE AUTOMATION PRIVATE LIMITED',
    'NEXGEN BPS PRIVATE LIMITED',
    'DABSTER CONSULTING PRIVATE LIMITED',
    'GREAT CLUB & RESORTS PRIVATE LIMITED',
    'KAUTILYA WAREHOUSING PRIVATE LIMITED',
    'DSR HEALTHCARE PRIVATE LIMITED',
    'KGA HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'MAQTRO ASSET INFINITY PRIVATE LIMITED',
    'AMYRA FOODS PRIVATE LIMITED',
    'HIRE-IT TECHNOLOGIES PRIVATE LIMITED',
    'VOYAGE GLOBAL JOURNEYS PRIVATE LIMITED',
    'PYC LOGISTICS PRIVATE LIMITED',
    'FALCONBRICK TECHNOLOGIES PRIVATE LIMITED',
    'ARLANT ATOM DATA LABS PRIVATE LIMITED',
    'CHOOSEBERRY TRADING PRIVATE LIMITED',
    'KAUVERY HEALTH ENTERPRISES PRIVATE LIMITED',
    'GFM RETAIL PRIVATE LIMITED',
    'GARUDA AEROSPACE PRIVATE LIMITED',
    'ESPLANADE WINE STORES PRIVATE LIMITED',
    'ACME VOYAGES PRIVATE LIMITED',
    'NSCKR EXPORTS PRIVATE LIMITED',
    'THE-CONNECTIONS ITES BUSINESS SERVICES PRIVATE LIMITED',
    'GSA SERVICES (OPC) PRIVATE LIMITED',
    'VOILA RESORTS & HOTELS PRIVATE LIMITED',
    'ALPINGO TRADING PRIVATE LIMITED',
    'SAK ENGINEERING CONSULTANCY INDIA PRIVATE LIMITED',
    'JINAY PHARMACEUTICALS PRIVATE LIMITED',
    'ASHOKA BAGEWADI SAUNDATTI ROAD LIMITED',
    'RAISE6 PRIVATE LIMITED',
    'APOLLO CVHF LIMITED',
    'ONE ESTORE PRIVATE LIMITED',
    'TEKTONIK BIZCORP PRIVATE LIMITED',
    'MIND FITNESS & SPORTS ARENA PRIVATE LIMITED',
    'ASHOKA HUNGUND TALIKOT ROAD LIMITED',
    'SUBHASH INFRA PROJECTS PRIVATE LIMITED',
    'KRM EYE INSTITUTE PRIVATE LIMITED',
    'PETROKENS ENGINEERING AND SERVICES PRIVATE LIMITED',
    'GLOBAL INVEST SERVICES PRIVATE LIMITED',
    'MILESTONE PRAKRITI PRIVATE LIMITED',
    'RXHEAL RETAIL PRIVATE LIMITED',
    'IDEAL CABLE TRANSMISSION PRIVATE LIMITED',
    'MMS HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'BIZSOL REALITY CLARITY CONSULTANCY PRIVATE LIMITED',
    'AMBROSIAL TECHOFFERINGS PRIVATE LIMITED',
    'KIMS SWASTHA PRIVATE LIMITED',
    'ESWARI AGRO INDUSTRIES PRIVATE LIMITED',
    'PRIMEPOINT INFRA PRIVATE LIMITED',
    'MICRO PRECISION CALIBRATION (INDIA) PRIVATE LIMITED',
    'ARRAY IMPEX PRIVATE LIMITED',
    'MEDBAZAR LIFECARE PRIVATE LIMITED',
    'METSTAR INDUSTRIES PRIVATE LIMITED',
    'BRICKS ESTATE PRIVATE LIMITED',
    'UPBEATIDEAS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TARUN KIRAN BHOOMI PRIVATE LIMITED',
    'SILICON BUILDCON PRIVATE LIMITED',
    'ANEKA INFOTECH PRIVATE LIMITED',
    'ONEWHISTLE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANGWAL DIGITAL MEDIA PRIVATE LIMITED',
    'TECHYOGI IT SOLUTIONS PRIVATE LIMITED',
    'SEQATO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MEDIFRIEND HEALTHSYS PRIVATE LIMITED',
    'GROSBEAK TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'OUST LABS INDIA PRIVATE LIMITED',
    'RAKUPA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CREST TEST SYSTEMS PRIVATE LIMITED',
    'BLEETECH INNOVATIONS PRIVATE LIMITED',
    'MAKDEAL EXIM PRIVATE LIMITED',
    'ADYANT ADVISORY SERVICES PRIVATE LIMITED',
    'ARCOS SKILL MANAGEMENT SERVICES PRIVATE LIMITED',
    'VISAGE LINES PERSONAL CARE PRIVATE LIMITED',
    'RELIABLE FIRST ADCON PRIVATE LIMITED',
    'GREEN BUSINESS CERTIFICATION INSTITUTE PRIVATE LIMITED',
    'BIGWAY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MOBILE STREAMS INDIA PRIVATE LIMITED',
    'QUATRIZ CONSULTING INDIA PRIVATE LIMITED',
    'LEGAL ENTITY IDENTIFIER INDIA LIMITED',
    'IMAGINATIVE IDENTITY CREATORS PRIVATE LIMITED',
    'SANCTOR DIGITAL PRIVATE LIMITED (OPC)',
    'CLEAN MASTER MANAGEMENT SERVICES PRIVATE LIMITED',
    'BLUMA APPLIANCES INDIA PRIVATE LIMITED',
    'STATSINK CONSULTANCY PRIVATE LIMITED',
    'EIGHTYONE HINJEWADI DEVELOPERS PRIVATE LIMITED',
    'PATRON FACILITY MANAGEMENT PRIVATE LIMITED',
    'AQUADRY EXCIPIENTS PRIVATE LIMITED',
    'EASETHIS ONLINE SERVICES PRIVATE LIMITED',
    'PARADISO SOFTWARE PRIVATE LIMITED',
    'LUXOX FURNITURE PRIVATE LIMITED',
    'TRIWAVE INFRACON PRIVATE LIMITED',
    'VENA ENERGY VINDHYA WIND POWER PRIVATE LIMITED',
    'EUROMAC MACHINES PRIVATE LIMITED',
    'ALGOTECH INDIA PRIVATE LIMITED',
    'VENA ENERGY SHIVALIK WIND POWER PRIVATE LIMITED',
    'GREENERGY YADGIR WIND ENTERPRISES PRIVATE LIMITED',
    'LANDMARK LIFESTYLE CARS PRIVATE LIMITED',
    'NAVAJNA TECHNOLOGIES PRIVATE LIMITED',
    'ABISHAR TECHNOLOGIES PRIVATE LIMITED',
    'ZIPPY CARE PRIVATE LIMITED',
    'V-MART BOOKS & STATIONERIES PRIVATE LIMITED',
    'VENA ENERGY GODAVARI WIND POWER PRIVATE LIMITED',
    'VENA ENERGY NILGIRI WIND POWER PRIVATE LIMITED',
    'CINIVU MEDIA PRIVATE LIMITED',
    'FOODPROS HOSPITALITY PRIVATE LIMITED',
    'ECONOMY UNIT INDIA PRIVATE LIMITED',
    'VENA ENERGY SOLAR RAVI INDIA POWER RESOURCES PRIVATE LIMITED',
    'SHRAWAN HIRISE PRIVATE LIMITED',
    'GLOBAL VALUE IT ADVISORY SERVICES PRIVATE LIMITED',
    'VERNAL TEXTILES PRIVATE LIMITED',
    'ADARE FOOD INGREDIENTS PRIVATE LIMITED',
    'KMK INDUSTRIES PRIVATE LIMITED',
    'ECOCOSMO GPS PRIVATE LIMITED',
    'GREEN CANTEEN PRIVATE LIMITED',
    'MAXIS SOFTWARE PRIVATE LIMITED',
    'LETSENDORSE DEVELOPMENT PRIVATE LIMITED',
    'PETROGRATE METAL PRODUCTS PRIVATE LIMITED',
    'DIVIDER PARTITION SYSTEM PRIVATE LIMITED',
    'ICIT EDUCATION PRIVATE LIMITED',
    'STAR WHEELS LOGISTICS & SERVICES PRIVATE LIMITED',
    'SPREAD DESIGN AND INNOVATION PRIVATE LIMITED',
    'FIRECON SPRINKLERS AND CONTROL SYSTEMS PRIVATE LIMITED',
    'FLYHIGH COMPLEX PRIVATE LIMITED',
    'AUTNHIVE PRIVATE LIMITED',
    'ROOTLY PLANT DECOR PRIVATE LIMITED',
    'ASTRO DEVAM PRIVATE LIMITED',
    'FARMFIELDS PRIVATE LIMITED',
    'PRERNA PROTECTIVE FORCE (OPC) PRIVATE LIMITED',
    'VASUPUJYA TRADELINK PRIVATE LIMITED',
    'ALAN ANNAI NIDHI LIMITED',
    'SHAHAJI AGRICULTURE AND FARMING PRIVATE LIMITED',
    'ONLY RETAIL PRIVATE LIMITED',
    'THEIA JEWELLERY PRIVATE LIMITED',
    'RAMMISS MARKETINGS PRIVATE LIMITED',
    'SCM XPRESS PRIVATE LIMITED',
    'JEEVANDHARA MICRO FINANCE FOUNDATION',
    'KP ENTERTAINMENT AND EVENTS PRIVATE LIMITED',
    'APM MEDICAL BILLERS PRIVATE LIMITED',
    'ADINATH IRRIGATION SYSTEMS PRIVATE LIMITED',
    'GEVIN SOFTVARE SOLUTIONS PRIVATE LIMITED(OPC)',
    'LAMILO TECHNOLOGIES PRIVATE LIMITED',
    'INSOLATION ENERGY LIMITED',
    'PATRATU VIDYUT UTPADAN NIGAM LIMITED',
    'MY WHEELS PRIVATE LIMITED',
    'SUPA FLEX PRIVATE LIMITED',
    'NOVAI TEK INDIA PRIVATE LIMITED',
    'FORETELICS TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'SCLEROID TECHNOLOGIES PRIVATE LIMITED (OPC)',
    'DIGICERT SECURITY INDIA PRIVATE LIMITED',
    'SPV LABORATORIES PRIVATE LIMITED',
    'PRIME LIVING PROJECTS PRIVATE LIMITED',
    'TRILLION LINES OF CODE & CONSULTING PRIVATE LIMITED',
    'THREADS LABS PRIVATE LIMITED',
    'SURAKSHA ASSET RECONSTRUCTION LIMITED',
    'ADVANTECH CONTROL SYSTEMS PRIVATE LIMITED',
    'EMBALL ISO INDIA PACKAGING PRIVATE LIMITED',
    'TSE BUSINESS CONSULTING PRIVATE LIMITED',
    'SANGUINE NEW MEDIA AND ADVISORY PRIVATE LIMITED',
    'CHAMP SPORTS PRIVATE LIMITED',
    'STEMZ HEALTHCARE PRIVATE LIMITED',
    'SUNSHAKTI RENEWABLE RESOURCES PRIVATE LIMITED',
    'VAASUDEVAAM POWER PLANTS AND CONSTRUCTION PRIVATE LIMITED',
    'DALVI CULINARY INDUSTRIES PRIVATE LIMITED',
    'SAALIM EXPORTS PRIVATE LIMITED',
    'MAXLIT LED SOLUTIONS PRIVATE LIMITED',
    'SREE JANANIDHI CHIT FUNDS PRIVATE LIMITED',
    'VEEGLOW ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'MRD BUSINESS MANAGEMENT PRIVATE LIMITED',
    'AFFERENT WEARABLE TECH PRIVATE LIMITED',
    'VIANET MEDIA PRIVATE LIMITED',
    'GEMS INTELLIGENCE UNIT PRIVATE LIMITED',
    'RAYDON PHARMACEUTICALS PRIVATE LIMITED',
    'FLOWSAVE ENGINEERING PRIVATE LIMITED (OPC)',
    'AUTOABODE CONSUMER ELECTRONICS PRIVATE LIMITED',
    'ZENRAX HEALTHCARE INDIA PRIVATE LIMITED',
    'ALBERO KITCHENS PRIVATE LIMITED',
    'SATYENDRA COMMODITIES PRIVATE LIMITED',
    'MOBITRASH RECYCLE VENTURES PRIVATE LIMITED',
    'DONE STRATEGIC CONSULTING PRIVATE LIMITED',
    'OBAN FASHIONS PRIVATE LIMITED',
    'MOBIZDOM TECHNOLOGY INDIA PRIVATE LIMITED',
    'HOLY WATER PUBLICATION PRIVATE LIMITED',
    'STUDIO PANIC DESIGN PRIVATE LIMITED',
    'CCC BESPOKE PRIVATE LIMITED',
    'CALLIDUS SHOEMAKERS PRIVATE LIMITED',
    'LEGGE FOOTWEAR PRIVATE LIMITED',
    'AJANTA RUBBER (INDIA) PVT. LTD.',
    'PARFOUR GOLF PRIVATE LIMITED',
    'EUPHORIC ENTERTAINMENT PRIVATE LIMITED',
    'MOJOPANDA EXIM PRIVATE LIMITED',
    'PANACHE FURNITURE AND INTERIORS PRIVATE LIMITED',
    'ARECA LIVINGS PRIVATE LIMITED',
    'UTKAL SPECIALITY INDUSTRIES INDIA PRIVATE LIMITED',
    '3SV PACKERS PRIVATE LIMITED',
    'BALARAM PAPERS PRIVATE LIMITED',
    'VIDHISHA PAPER MILLS LIMITED',
    'ANSATRACK PRIVATE LIMITED',
    'RAINBOW MERCANTILE PVT. LTD.',
    'MANU-MITA MEDIA PUBLISHERS PRIVATE LIMITED',
    'CEEFI ENTERPRISES PRIVATE LIMITED',
    'PRAKASH CONTENT PRIVATE LIMITED',
    'PRATHEM BAZAR PRIVATE LIMITED',
    'WHITE FORK MEDIA PRIVATE LIMITED',
    'MOR MUSIC PRIVATE LIMITED',
    'PALI MEDIA PRIVATE LIMITED',
    'VBL DESIGNS PRIVATE LIMITED',
    'VOGANOW FASHIONS PRIVATE LIMITED',
    'ZAZ AND ZAZ PRIVATE LIMITED',
    'KITEX INFANTSWEAR LIMITED',
    'HYDERABAD SECURITY OFFSET PRINTERS Private Limited',
    'FEMININ MARKETING PRIVATE LIMITED',
    'DYNASTY PLASTICS PVT LIMITED',
    'DR. AGARWALS EYE HOSPITAL LIMITED',
    'DYMES PHARMACHEM LIMITED',
    'DODSAL ENGINEERING AND CONSTRUCTION (INDIA) PRIVATE LIMITED',
    'DREAM TRADING PRIVATE LIMITED',
    'DR FRESH SEZ PHASE I PRIVATE LIMITED',
    'DON CONSTRUCTION CHEMICALS INDIA LIMITED',
    'DR WAMSER PLUS BATRA INDIA PRIVATE LIMITED',
    'DMX TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'E. c. software india private limited',
    'E INFOCHIPS LIMITED',
    'E CON PACKAGING PRIVATE LIMITED',
    'DUN & BRADSTREET TECHNOLOGIES & DATA SERVICES PVT LTD',
    'DUCON TECHNOLOGIES I PVT LTD',
    'E FLEET SYSTEMS PRIVATE LIMITED',
    'E EMPHASYS SOLUTIONS PRIVATE LIMITED',
    'DR BATRAS POSITIVE HEALTH CLINIC PRIVATE LIMITED',
    'DR. BATRAS B PERFECT PRIVATE LIMITED',
    'DM EYE CARE (DELHI) PRIVATE LIMITED',
    'DOMINION DIAMOND (INDIA) PRIVATE LIMITED',
    'DYNAMIC ORBITS ADVISORY PRIVATE LIMITED',
    'DURGA BEARINGS (MUMBAI) PRIVATE LIMITED',
    'DOTCOM SERVICES INDIA PRIVATE LIMITED',
    'DNV GL BUSINESS ASSURANCE INDIA PRIVATE LIMITED',
    'DURLAX ARCHTECH PRIVATE LIMITED',
    'DUFF and PHELPS INDIA PRIVATE LIMITED',
    'DST WORLDWIDE SERVICES INDIA PRIVATE LIMITED',
    'DYNAMIC CLOTHING PRIVATE LIMITED',
    'DROPKAFFE FOOD AND BEVERAGES PVT LTD',
    'DORSET KABA SECURITY SYSTEMS PRIVATE LIMITED',
    'DR ROSHAN LAL AGGARWAL AND SONS PRIVATE LIMITED',
    'DVIVERT SOLUTIONS PRIVATE LIMITED',
    'ELITE WEALTH ADVISORS LIMITED',
    'ECOAXIS SYSTEMS PRIVATE LIMITED',
    'ELECTRA EVENTS AND EXHIBITIONS INDIA PRIVATE LIMITED',
    'EATON FLUID POWER LIMITED',
    'EDGETECH AIR SYSTEM PVT.LTD.',
    'EFS Facilities Services India Pvt Ltd',
    'ELECTROSTEEL STEELS LIMITED',
    'ECOMAISTER BEADS INDIA PVT LTD',
    'ECL ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'EASTMAN INTERNATIONAL LIMITED',
    'EBREEZ SOFTWARE PRIVATE LIMITED',
    'EASTMAN LOGISTICS AND INFRASTRUCTURE PRIVATE LIMITED',
    'EASY TRIP PLANNERS PRIVATE LIMITED',
    'EISNERAMPER INDIA CONSULTANTS PVT LTD',
    'ELEGANT DYEING AND PROCESSING LIMITED',
    'ECOM GILL COFFEE TRADING PRIVATE LIMITED',
    'EBIX SOFTWARE INDIA PRIVATE LIMITED',
    'ELITE FOOD SPECIALITIES PRIVATE LIMITED',
    'EAP INFRASTRUCTURES PRIVATE LIMITED',
    'EFFWA INFRA AND RESEARCH PVT LTD',
    'ECO CARE BUILDING PRODUCTS PRIVATE LIMITED',
    'EICHER GOODEARTH PRIVATE LIMITED',
    'EAST INDIA COMPANY (TRADING) PRIVATE LIMITED',
    'ELBIT MEDICAL DIAGNOSTICS LIMITED',
    'EDUCATIONAL INITIATIVES PVT LTD',
    'Ei labs india private limited',
    'EDUNETWORK PVT LTD',
    'E2E INFOWARE PRIVATE LIMITED',
    'ECU INTERNATIONAL ASIA PRIVATE LIMITED',
    'Edelweiss broking limited',
    'E-DYNAMIC SOFTECH SOLUTIONS PRIVATE LIMITED',
    'EDEL LAND LIMITED',
    'ECOM EXPRESS PRIVATE LIMITED',
    'EDELWEISS METALS LIMITED',
    'EDELWEISS COMTRADE LIMITED',
    'E-GITS INDIA PRIVATE LIMITED',
    'EHRLICH LABORATORY PRIVATE LIMITED',
    'EFFECTS TECH SLT PVT LTD',
    'Electronics for imaging india private limited',
    'EASUN PRODUCTS OF INDIA PRIVATE LIMITED',
    'EISENMANN SURFACE FINISHING SYSTEMS INDIA PRIVATE LIMITED',
    'ELECTRONIC ARTS GAMES INDIA PRIVATE LIMITED',
    'ELECTRO OPTIC (ASIA) PRIVATE LIMITED',
    'EASTERN BOOK COMPANY PVT LTD',
    'Elanco India Pvt Ltd',
    'EAZYDINER PVT LTD',
    'EION TELECOM PRIVATE LIMITED',
    'ECOCAT INDIA P LTD',
    'EA LABS INDIA PVT LTD',
    'ELIPTICO IT SOLUTIONS PRIVATE LIMITED',
    'Educesta Global Services Private limited',
    'EAST INDIA PETROLEUM PVT LTD',
    'EQUUS ADVERTISING COMPANY LTD',
    'ENCODEX TELESYSTEMS (INDIA) PRIVATE LIMITED',
    'ENTIGENCE SOLUTIONS INDIA PRIVATE LIMITED',
    'ENDRESS HAUSER FLOWTEC INDIA PRIVATE LIMITED',
    'EPIANCE SOFTWARE PVT LTD',
    'EMAMI INFRASTRUCTURE LTD',
    'EON INFOTECH LIMITED',
    'ELRINGKLINGER AUTOMOTIVE COMPONENTS (INDIA) PRIVAT',
    'ENSURITY TECHNOLOGIES PVT LTD',
    'EMMBROS AUTOMOTIVES PVT LTD',
    'ENERGO PRODUCTS LIMITED',
    'EMPIRE TUBEWELLS PVT LTD',
    'EMIGRA IMMIGRATION SERVICES (INDIA) PRIVATE LIMITED',
    'ESDS SOFTWARE SOLUTION PRIVATE LIMITED',
    'EQUINOX EPC ENGINEERING (INDIA) LIMITED',
    'EMTELLE INDIA LIMITED',
    'ENSURE SUPPORT SERVICES (INDIA) LIMITED',
    'ENTREMONDE POLYCOATERS LTD',
    'ESCO COUPLINGS AND TRANSMISSIONS PRIVATE LIMITED',
    'EMRALD RESILIENT TYRE MANUFACTURERS PRIVATE LIMITED',
    'ESK INDIA COMMERCE AND TRADE PRIVATE LIMITED',
    'Embassy Projects Private Limited',
    'ENTERCOMS SOLUTIONS PRIVATE LIMITED',
    'ENTRACK OVERSEAS PRIVATE LIMITED',
    'ESN FINANCE AND CAPITAL SERVICES LTD',
    'ESCRIBE OUTSOURCING SERVICES PRIVATE LIMITED',
    'ENLIGHTIKS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EMANTRAS INTERACTIVE TECHNOLOGIES PRIVATE LIMITED',
    'ESMART CONSULTING CHENNAI PRIVATE LIMITED',
    'ENFINITY SOLAR SOLUTIONS PRIVATE LIMITED',
    'ELOKA ENTERPRISES PRIVATE LIMITED',
    'ENHANCE PROTEINS LIMITED',
    'EPPENDORF INDIA LIMITED',
    'ERNST AND YOUNG SERVICES PRIVATE LIMITED',
    'ENVIRONNEMENT SA INDIA PRIVATE LIMITED',
    'ESAF RETAIL PRIVATE LIMITED',
    'ENAM ASSET MANAGEMENT COMPANY PRIVATE LMITED',
    'ENIGMA SOLUTIONS PRIVATE LIMITED',
    'ENCORE THEME TECHNOLOGIES PVT LTDÃ‚Â',
    'ENVENTURE TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'ENDEAVOUR INSTRUMENT PRIVATE LIMITED (ENDEAVOUR FIN )',
    'ENDO LIGHTING ACCESSORIES INDIA PVT LTD',
    'EMERIO TECHNOLOGIES PRIVATE LIMITED',
    'EOC TAILOR MADE POLYMERS INDIA PVT LTD',
    'EPAM SYSTEMS INDIA PVT LTD',
    'EOLANE ELECTRONICS BANGALORE PRIVATE LIMITED',
    'EM 2 INFOTECH (INDIA) PRIVATE LIMITED',
    'ENTERPRISE SIGNAL INDIA PRIVATE LIMITED',
    'ENOX HARDWARE INDIA PVT LTD',
    'ENRICH HAIR AND SKIN SOLUTIONS PRIVATELIMITED',
    'ESCALON BUSINESS SERVICES PVT LTD',
    'EMAAR MGF LAND LIMITED',
    'ERA BUILDSYS LIMITED',
    'ESCORTS SECURITIES LIMITED',
    'ENTERO HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'ESPIRE INFRASTRUCTURE CORPORATION LIMITED',
    'ESSAR POWER HAZIRA LIMITED',
    'EXMAN SECURITY SERVICES PRIVATE LIMITED',
    'EXCEL BOOKS PRIVATE LIMITED',
    'ESSAR BULK TERMINAL LIMITED',
    'EVALUESERVE SEZ GURGAON PRIVATE LIMITED',
    'EUROTEK ENVIRONMENTAL PVT LTD',
    'ESSAR INFORMATION TECHNOLOGY LIMITED',
    'EURASIAN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ESSAR ENERGY SERVICES LIMITED',
    'EXOTECH ZANINI INDUSTRIES PRIVATE LIMITED',
    'EXCELLENCE OUTSOURCING PRIVATE LIMITED',
    'ESSAE TERAOKA PRIVATE LIMITED',
    'ETAG SOFTWARE SOLUTIONS PVT LTD',
    'EVEREST HOLOVISIONS LTD',
    'ESPROS TECHNOLOGY CONSULTANTS PRIVATE LIMITED',
    'ETC Management Services India Pvt Ltd',
    'EVERGENT TECHNOLOGIES (INDIA) LIMITED',
    'EXPRESS PUBLICATIONS (MADURAI) LIMITED',
    'ESTERLINE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'EXEL FINISHING PRIVATE LIMITED',
    'Excellence infocom private limited',
    'ESSEM SRINISONS SYSTEMS PRIVATE LIMITED',
    'ESRI INDIA TECHNOLOGIES LIMITED',
    'ETCO DENIM PRIVATE LIMITED',
    'EXCEL LASER TECHNOLOGY PRIVATE LIMITED',
    'EUROFLEX TRANSMISSIONS INDIA PRIVATE LIMITED',
    'ESSEL MARKETING & PROMOTIONS PRIVATE LIMITED',
    'ESSEL VISION PRODUCTIONS LIMITED',
    'ESQUIRE SYSTEMS PRIVATE LIMITED',
    'EVOLUTE SYSTEMS PRIVATE LIMITED',
    'Ever Electronics Pvt Ltd',
    'EXCEL FILTRATION PVT LTD',
    'EURO VISTAA INDIA LIMITED',
    'EXPERION TECHNOLOGIES (INDIA) PRIVATELIMITED',
    'EXPEDIENT HEALTHCARE MARKETING PRIVATE LMITED',
    'EUROSCHOOL INTERNATIONAL PRIVATE LIMITED',
    'EVERSHINE BUILDERS PVT. LTD',
    'EXFO ELECTRO OPTICAL ENGINEERING INDIA PRIVATE LIMITED',
    'ETISALAT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ESPAN INFRASTRUCTURE LIMITED',
    'EVOLVING SYSTEMS NETWORK INDIA PVT LTD',
    'ETA-MELCO ENGINEERING COMPANY PRIVATE LIMITED',
    'ETOUCH SYSTEMS (INDIA) PRIVATE LIMITED',
    'EXPERT WEB WORX PRIVATE LIMITED',
    'EXIMIUS DESIGN INDIA PRIVATE LIMITED',
    'EUCLID INFOTECH PRIVATE LIMITED',
    'EUROFINS ADVINUS LIMITED',
    'ETALIN HYDRO ELECTRIC POWER COMPANY LTD',
    'ETO MAGNETIC INDIA PVT LTD',
    'EUROFINS CLINICAL GENETICS INDIA PVT LTD',
    'EURO PANEL PRODUCTS PRIVATE LIMITED',
    'FLOWSERVE SANMAR LIMITED',
    'FLEXLINK SYSTEMS INDIA PRIVATE LIMITED',
    'Fastbooking India Pvt Ltd',
    'FEDERAL MOGUL POWERTRAIN SOLUTIONS INDIA PRIVATE LIMITED',
    'FIVES COMBUSTION SYSTEMS PVT LTD',
    'FALCON BUSINESS RESOURCES PVT LTD',
    'FIBRO INDIA PRECISION PRODUCTS PRIVATE LTD',
    'EZETAP MOBILE SOLUTIONS PVT LTD',
    'FASTRONIC TELESERVICES PRIVATE LIMITED',
    'Fernandez hospital private limited',
    'EZEEGO ONE TRAVEL TOURS LIMITED',
    'FEATHERLITE OFFICE SYSTEMS PVT LTD',
    'FLICKER PROJECTS PRIVATE LIMITED',
    'FABER SINDOORI MANAGEMENT SERVICES PRIVATE LIMITED',
    'FENWAL INDIA PRIVATE LIMITED',
    'FAITH AUTOMATION SYSTEMS AND TOOLING PRIVATE LIMITED',
    'FOODLINK RESTAURANTS INDIA PRIVATE LIMITED',
    'FAIRWOOD INFRA AND SERVICES PRIVATE LIMITED',
    'FIRST TIME US PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'FLEMING INDIA MANAGEMENT SERVICES PRIVATE LIMITED',
    'FAVORITE RESTAURANTS PRIVATE LIMITED',
    'EXUSIA INDIA PVT LTD',
    'FIDEL SOFTECH PRIVATE LIMITED',
    'FIRST RAIN SOFTWARE CENTRE PRIVATE LIMITED',
    'FARIDA PRIME TANNERY PVT LTD',
    'FOCAL IMAGE INDIA PRIVATE LIMITED',
    'FOCUS 4D CAREER EDUCATION PRIVATE LIMITED',
    'FISHER AND PAYKEL HEALTHCARE INDIA PRIVATE LIMITED',
    'FAZE-THREE LTD',
    'EYE Q VISION PRIVATE LIMITED',
    'FEDERAL MOGUL ANAND BEARINGS INDIA LTD',
    'FIDELIO INDIA PRIVATE LIMITED',
    'FLOWCRETE INDIA PRIVATE LIMITED',
    'FINASTRA SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'FEDBY INFORMATION SERVICES PRIVATE LIMITED',
    'FAES PACKAGING SOLUTIONS PRIVATE LIMITED',
    'FIREEYE CYBERSECURITY PRIVATE LIMITED',
    'FIRST ADVANTAGE GLOBAL OPERATING CENTER PVT LTD',
    'FIDELIS CORPORATE SOLUTIONS PRIVATE LIMITED',
    'FAIRMACS SHIPPING AND TRANSPORT SERVICES PRIVATE LIMITED',
    'FLAKTWOODS ACS (INDIA) PRIVATE LIMITED',
    'FOCUS LIGHTING AND FIXTURES PRIVATE LIMITED',
    'FELGUERA GRUAS INDIA PVT LTD',
    'FAASOS FOOD SERVICES PRIVATE LIMITED',
    'FINANCIAL OBJECTS SOFTWARE (INDIA) PRIVATE LIMITED',
    'F SECURE PRIVATE LIMITED',
    'Federal Mogul Anand Sealings India Ltd',
    'EXXONMOBIL SERVICES AND TECHNOLOGY PRIVATE LIMITED',
    'FIRST BLUE HOME FINANCE LIMITED',
    'FMS FR MEYERS SOHN INDIA PRIVATE LIMITED',
    'FLAIR WRITING INDUSTRIES PRIVATE LIMITED',
    'FACILE INFO-SERV (OPC) PRIVATE LIMITED',
    'G G VALVES PRIVATE LIMITED',
    'G and B FASHIONS PRIVATE LIMITED',
    'FRONTIER RAAS PRIVATE LTD',
    'FUNBARS HOSPITALITY PRIVATE LIMITED',
    'FRANCO LEOME SHOES PRIVATE LIMITED',
    'futures first info services pvt lrd',
    'FREYR SOFTWARE SERVICES PRIVATE LTD',
    'G.K. CARS PRIVATE LIMITED',
    'FOURTH DIMENSION SOLUTIONS LIMITED',
    'FRIENDS AUTO INDIA LTD',
    'FULLERTON SECURITIES & WEALTH ADVISORS LIMITED',
    'GAC LOGISTICS PVT LTD',
    'FRAMEWORK SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'FOTON MOTORS MANUFACTURING INDIA PVT LTD',
    'FRONTALRAIN TECHNOLOGIES PRIVATE LIMITED',
    'FORE SUPPORT SERVICES INDIA PRIVATE LIMITED',
    'GALA PRECISION ENGINEERING PRIVATE LIMITED',
    'FRONTLINE CAPITAL SERVICES LIMITED',
    'FORTPOINT AUTOMOTIVE MUMBAI PRIVATELIMITED',
    'FORUM PROJECTS PVT LTD',
    'FRISCHMANN PRABHU (INDIA) PRIVATE LIMITED',
    'G R ENGINEERING PRIVATE LIMITED',
    'GALLIUM INDUSTRIES LIMITED',
    'G4S SECURE SOLUTIONS INDIA PRIVATE LIMITED',
    'FRP SERVICES AND CO INDIA PVT LTD',
    'GALAX E SOLUTIONS INDIA PRIVATE LIMITED',
    'GAC SHIPPING INDIA PVT LTD',
    'FORTUNE INFRA DEVELOPERS PVT LTD',
    'Fork Media PVT LTD',
    'GALLAGHER OPERATIONS SUPPORT SERVICES PRIVATE LIMITED',
    'FOURESS ENGINEERING(INDIA)LIMITED',
    'Fsn e-commerce ventures private limited',
    'fresh and honest cafe limited',
    'FUNDTECH INDIA PVT LTD',
    'GAEKWAR SERVICES LTD',
    'FUTURE CARE FACILITY SERVICES PRIVATE LIMITED',
    'G CORP DEVELOPERS P LTD',
    'G PLUS H LIZ INDIA PRIVATE LIMITED',
    'GALAXY ENTERTAINMENT CORPORATION LIMITED',
    'GALA PRECISION TECHNOLOGY PRIVATE LIMITED',
    'FREEDOM OPTHALMIC PRIVATE LIMITED',
    'GAINSPAN SYSTEMS INDIA PRIVATE LIMITED',
    'FULCRUM FUND SERVICES (INDIA) PRIVATE LIMITED',
    'FOUNDING YEARS LEARNING SOLUTIONSPRIVATE LIMITED',
    'FORMICA LAMINATES INDIA PRIVATE LIMITED',
    'FUTURE MARKET INSIGHTS GLOBAL AND CONSULTING PRIVATE LIMITED',
    'FRANCIS WACZIARS AGENCIES PVT LTD',
    'FRIENDSHIPTIME COM PRIVATE LIMITED',
    'FRAME TECHNOLOGY MARKETING SERVICESPRIVATE LIMITED',
    'FUTURE STYLE LAB LIMITED',
    'G MOBILE DEVICES PRIVATE LIMITED',
    'FOUNDATION BRAKE MANUFACTURING PRIVATE LIMITED',
    'FUTURE FINANCIAL SERVICESS PRIVATE LIMITED',
    'GENERAL DYNAMICS SATCOM TECHNOLOGIES ASIA PRIVATE LIMITED',
    'GAURSONS INDIA LIMITED',
    'GIVO RETAIL PRIVATE LIMITED',
    'GEMPULSE INFOTECH PVT.LTD',
    'GANGA ACROWOOLS LTD',
    'GATI INFRASTRUCTURE PRIVATE LIMITED',
    'GKB HI TECH LENSES PRIVATE LIMITED',
    'GITA POWER & INFRASTRUCTURE PRIVATELIMITED',
    'GENESIS IT INNOVATIONS LIMITED',
    'GATI KAUSAR INDIA LIMITED',
    'GITS FOOD PRODUCTS PVT LTD.',
    'GENERAL MOTORS INDIA PVT LTD',
    'GARLOCK INDIA PRIVATE LIMITED',
    'GINZA INDUSTRIES LTD',
    'GEOSMART ENGINEERING PRIVATE LIMITED',
    'GDA TECHNOLOGIES LIMITED',
    'GEA PHARMA SYSTEMS (INDIA) PRIVATE LIMITED',
    'GIRNAR NEWTEL SOLUTIONS PVT LTD',
    'GANDHINAGAR HOTELS LIMITED',
    'GEMALTO DIGITAL SECURITY PRIVATE LIMITED',
    'GE DRILLING ENGINEERING SERVICES OF INDIA PRIVATE LIMITED',
    'GHAFARI PUROHIT ARCHITECTS AND ENGINEERS PVT LTD',
    'GEM BATTERIES PRIVATE LIMITED',
    'GETRAG TRANSMISSIONS INDIA PRIVATE LIMITED',
    'GENZEON TECHNOLOGY SOLUTIONS PVT LTD',
    'GL and V india Private Ltd',
    'GE INTELLIGENT PLATFORMS PRIVATE LIMITED',
    'GEODATA INDIA PRIVATE LIMITED',
    'GARDEN CITY FASHIONS PVT LTD',
    'GCE INDIA PVT LTD',
    'GEMINI DYEING AND PRINTING MILLS LIMITED',
    'GEEKOM LOGISTECH PRIVATE LIMITED',
    'GEA REFRIGERATION INDIA PRIVATE LIMITED',
    'GCP APPLIED TECHNOLOGIES INDIA PRIVATELIMITED',
    'GALORE NETWORKS PVT LTD',
    'GDF Suez Energy India Pvt Ltd',
    'Gleeds Hooloomann Consulting India Pvt Ltd',
    'GEECO ENERCON PVT LIMITED',
    'GEEP INDUSTRIES INDIA PRIVATE LIMITED',
    'GARRAD HASSAN INDIA PRIVATE LIMITED',
    'GARTNER INDIA RESEARCH ADVISORY SERVICES PRIVATE LIMITED',
    'GHIYA EXTRUSIONS PRIVATE LIMITED',
    'GANTEC PUBLISHING SOLUTIONS PRIVATE LIMITED',
    'GLITTERBUG TECHNOLOGIES PRIVATE LIMITED',
    'GI INFOTECH LIMITED',
    'GE GODAVARI ENGINEERING LIMITED',
    'GG CABLES AND WIRES INDIA PRIVATE LIMITED',
    'GFI INFORMATIQUE INDIA PRIVATE LIMITED',
    'GENWORKS HEALTH PVT LTD',
    'GEM PAINTS PRIVATE LIMITED',
    'GIESECKE AND DEVRIENT MS INDIA PRIVATE LIMITED',
    'GE DIESEL LOCOMOTIVE PRIVATE LIMITED',
    'GB FOODS INDIA TRADING PRIVATE LIMITED',
    'GDC DIMENSION DATA PRIVATE LIMITED',
    'Goldencross pharma private limited',
    'GOENKA ELECTRIC MOTOR VEHICLES PVT LTD',
    'global wool alliance pvt ltd',
    'GLOBAL FAIRS MEDIA PRIVATE LIMITED',
    'GOBIND SUGAR MILLS LIMITED',
    'Golden mandhir retail private limited',
    'GMR CORPORATE AFFAIRS PRIVATE LIMITED',
    'GMR CORPORATE CENTER LIMITED',
    'GOLDFINGER TRAVELS PRIVATE LIMITED',
    'GOLDSEAL SAARGUMMI INDIA PRIVATE LIMITED',
    'GOLDEN STAR FACILITIES AND SERVICES PRIVATE LIMITED',
    'Gokak Textiles Ltd',
    'GOODWILL ENGINEERING SERVICES PRIVATE LIMITED',
    'GMR KRISHNAGIRI SEZ LIMITED',
    'GMR ENERGY TRADING LTD',
    'GLOBAL HEAT TRANSFER DESIGNTECH PRIVATE LIMITED',
    'GODAVARI POLYMERS PVT.LTD.',
    'GLOBALLOGIC TECHNOLOGIES LIMITED',
    'GLORY GLOBAL SOLUTIONS (SOUTH ASIA) PVT LTD',
    'GOLDMINE ADVERTISING LIMITED',
    'GLOBE TEXTILES INDIA LIMITED',
    'Globalmantra innovations Pvt Ltd',
    'GODAVARI DRUGS LTD',
    'Godawari Energy LTD',
    'GOOMO ORBIT CORPORATE and Leisure Travels I Private Limited',
    'GOLDEN GATE PROPERTIES LTD',
    'GRAF DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'GOLDSTONE INFRATECH LTD.',
    'GOWORK SOLUTIONS LIMITED',
    'GOOD HEALTH TPA SERVICES LIMITED',
    'GNB TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'GOPSONS PAPERS LIMITED',
    'GLOBAL GALLARIE MOTORS PRIVATE LIMITED',
    'GOLDFINCH RESORTS PVT LTD',
    'GLOBALLOGIC INDIA LIMITED',
    'GR GREEN LIFE ENERGY PRIVATE LIMITED',
    'gmr aviation private ltd',
    'GMR HIGHWAYS LTD',
    'GLOBARENA TECHNOLOGIES PRIVATE LIMITED',
    'GP Global Energy Private Limited',
    'Global International Imex Pvt Ltd',
    'GOPAL KRISHNA PAPERS PVT LTD',
    'GLOMANTRA ESERVICES PRIVATE LIMITED',
    'GLOBAL INFORMATION SERVICES PRIVATE LIMITED',
    'GLOBAL GALLARIE AGENCIES PRIVATE LIMITED',
    'GOENKA MOTORS PVT LTD',
    'GRADE RESULTS TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'GRAB A GRUB SERVICES PVT LTD',
    'GLOBETOUCH TECHNOLOGIES PRIVATE LIMITED',
    'GLOBE CAPACITORS LTD',
    'GLOBE COMMODITIES LIMITED',
    'GOPALJEE DAIRY FOODS PRIVATE LIMITED',
    'GULSHAN HOMES AND INFRASTRUCTURE PVT LTD',
    'GUPTA METAL SHEETS LIMITED',
    'HACO MACHINERY PVT LTD',
    'Gupta Builders and Promoters pvt ltd',
    'GS ENGINEERING AND CONSTRUCTION DELHI PVT LTD',
    'GROUP10 TECHNOLOGIES PVT LTD',
    'GREEN PEARL ENGINEERING CONSTRUCTIONCORPORATION LIMITED',
    'Gwynniebee india private limited',
    'GRAND PRIX ENGINEERING PVT LTD',
    'GUJARAT POLY AVX ELECTRONICS LTD.',
    'GROWING STARS INFOTECH PVT LTD',
    'GRSC INFOTECH PRIVATE LIMITED C/N',
    'GROZ BECKERT CARDING INDIA PRIVATE LIMITED',
    'GREENKO RAYALA WIND POWER PVT LTD',
    'GVK EMERGENCY MANAGEMENT & RESEARCH INSTITUTE',
    'HABASIT IAKOKA PRIVATE LIMITED',
    'H and R BLOCK INDIA PRIVATE LIMITED',
    'GVK EMRI (UP)',
    'GREAT LAKES E LEARNING SERVICES PRIVATE LIMITED',
    'Grovalue Commodity pvt ltd',
    'GURUKULONLINE LEARNING SOLUTIONS PRIVATE LIMITED',
    'GX GLASS SALES SERVICES LIMITED',
    'GURIT INDIA PRIVATE LIMITED',
    'GUJARAT NIPPON INTERNATIONAL PRIVATELIMITED',
    'gujarat enviro protection and infrastructure limited',
    'GTC OILFIELD SERVICES PRIVATE LIMITED',
    'GTPL V and S CABLE PRIVATE LIMITED',
    'GREY ORANGE INDIA PVT LTD',
    'GURU & RAM ADVISORS AND CONSULTANTS PRIVATE LIMITED',
    'GROOVE SOFTWARE PVT LTD',
    'GREENSCAPE ECO MANAGEMENT PVT LTD',
    'H NYALCHAND REALTY PRIVATE LIMITED',
    'GRAPHISADS PVT LTD',
    'GS ENGINEERING AND CONSTRUCTION MUMBAI PRIVATE LIMITED',
    'GROBEST FEEDS CORPORATION INDIA PRIVATE LIMITED',
    'GRAINGER INDIA PRIVATE LIMITED.',
    'H K JEWELS PRIVATE LIMITED',
    'GREEN POINT TECHNOLOGY SERVICES (INDIA) LIMITED',
    'H.V.EQUIPMENTS PRIVATE LIMITED',
    'H L AGRO PRODUCTS PVT LTD',
    'H and S SUPPLY CHAIN SERVICES PRIVATE LIMITED',
    'GROFERS INDIA PVT LTD',
    'GRJ DISTRIBUTORS AND DEVELOPERS PVT LTD',
    'H M B S Textiles Pvt Ltd',
    'GREENSTAR RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED',
    'GRAND 7 ENTERTAINMENT PRIVATE LIMITED',
    'GROUPON SHARED SERVICES PVT LTD',
    'HAVELI RESTAURANT AND RESORTS LTD',
    'HGI INDUSTRIES LTD',
    'HINDUSTAN MINERAL PRODUCTS COMPANY LIMITED',
    'HI-TECH INVESTMENT CASTINGS LIMITED',
    'HEAT AND CONTROL SOUTH ASIA PRIVATE LIMITED',
    'HARITASA CHECKMATE ELECTRONICS PRIVATE LIMITED',
    'HITACHI AUTOMOTIVE SYSTEMS PUNE INDIA PRIVATE LIMITED',
    'HITACHI HIGH-TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HCIL COMTEL LIMITED',
    'HARIDWAR INFRASTRUCTURE LIMITED',
    'HITKARI MULTI-FILTERS LIMITED',
    'HANGAR 17 INFORMATION AND COMMUNICATION TECHNOLOGIES PRIVATE LIMITED',
    'HIMADRI FOODS LIMITED',
    'HAIKO LOGISTIC INDIA PRIVATE LIMITED',
    'HEXAGON-MIDCO INDIA PRIVATE LIMITED',
    'HIRSCHVOGEL COMPONENTS INDIA PVT LTD',
    'HINDUSTAN EPC COMPANY LIMITED',
    'Healthvista india private limited',
    'HARITA TECHSERV LIMITED',
    'HASKONINGDHV INDIA PVT LTD',
    'HITEX HEALTHCARE PVT LTD',
    'HI POINT SERVICES INDIA PRIVATE LIMITED',
    'HIPOWER SUPPORT CENTRE PRIVATE LIMITED',
    'HI BUILD COATINGS PRIVATE LIMITED',
    'HI TECH AIR POWER PRIVATE LIMITED',
    'HINDUSTAN EPC CO PRIVATE LIMITED',
    'HBO PLUS EMTB ARCHITECTS AND INTERIORS PRIVATE LIMITED',
    'HIMALYA INTERNATIONAL LIMITED',
    'HH PRINT MANAGEMENT INDIA PRIVATE LIMITED',
    'HALFEN MOMENT INDIA PVT LTD',
    'HDFC DEVELOPERS LIMITED',
    'HINES INDIA REAL ESTATES PRIVATE LIMITED',
    'HEALTHSUITE SOFTWARE PRIVATE LIMITED',
    'HEMPEL PAINTS INDIA PRIVATE LIMITED',
    'HARSHA ABAKUS SOLAR PRIVATE LIMITED',
    'HITECH PRINT SYSTEMS LIMITED',
    'HI CON TECHNO CAST PRIVATE LIMITED',
    'HIND FILTERS LIMITED',
    'HARSHA AUTOMOBILES PRIVATE LIMITED',
    'HANARO LOGISTICS PVT LTD',
    'HCC REAL ESTATE LIMITED',
    'HARRYS INDIA PRIVATE LIMITED',
    'HAGER ELECTRO PVT LTD',
    'HARLAND CLARKE HOLDING SOFTWARE INDIA PRIVATE LIMITED',
    'Haldia International Container Terminal Pvt Ltd',
    'Hashworks IT Services Pvt Ltd',
    'HIPPO INNOVATIONS PVT LTD',
    'HAICHENG VIVO MOBILE INDIA PRIVATE LIMITED',
    'HINDUSTHAN VIDYUT PRODUCTS LIMITED',
    'HANSOL CNP INDIA PRIVATE LIMITED',
    'IBI CONSULTANCY INDIA PRIVATE LIMITED',
    'Hotel leelaventure limited',
    'HOEC BARDAHL INDIA LIMITED',
    'HOME CABLE NETWORK PRIVATE LIMITED',
    'HOWE ENGINEERING PROJECTS INDIA PRIVATE LIMITED',
    'IAI JOINFLEX INDIA PRIVATE LIMITED',
    'HYOSEONG ELECTRIC INDIA PVT LTD',
    'Hotel sukhamay pvt ltd',
    'IAL INDIA LIMITED',
    'IDENTITY WELLNESS CENTRE PRIVATE LIMITED',
    'HUGHES COMMUNICATIONS INDIA LIMITED',
    'HUGHES NETWORK SYSTEMS INDIA LIMITED',
    'Hyundai Steel Pipe india pvt ltd',
    'ICD SECURITY SOLUTIONS (INDIA) PRIVATE LIMITED',
    'HYDERABAD CASTINGS LTD',
    'IAPMO PLUMBING CODES AND STANDARDS INDIA PRIVATE LIMITED',
    'HOME STORES INDIA PRIVATE LIMITED',
    'HY-TECH ENGINEERS PRIVATE LIMITED',
    'ideas2it technology services pvt ltd',
    'IAV INDIA PRIVATE LIMITED',
    'ICF CONSULTING INDIA PVT LTD',
    'I VISTA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'HYDE ENGINEERING AND CONSULTING INDIA PRIVATE LIMITED',
    'HOME INTERIOR DESIGNS E COMMERCE PRIVATE LIMITED',
    'I A P COMPANY PRIVATE LIMITED',
    'HOLZOO ONLINE NETWORKS PRIVATE LIMITED',
    'HYUNDAI AUTOEVER INDIA PVT LTD',
    'I DESIGN ENGINEERING SOLUTIONS LIMITED',
    'HUSKY INJECTION MOLDING SYSTEMS PRIVATE LIMITED',
    'HYKON INDIA PRIVATE LIMITED',
    'HTC GLOBAL SERVICES INDIA PRIVATE LIMITED',
    'IDFC BHARAT LIMITED',
    'id fresh food india private limited',
    'HYSTER YALE LIFT TRUCKS INDIA PRIVATE LIMITED',
    'HYDERABAD MENZIES AIR CARGO PRIVATE LIMITED',
    'ICWAI MANAGEMENT ACCOUNTING RESEARCH FOUNDATION',
    'IDFC SECURITIES LIMITED',
    'I SOFT R&D PRIVATE LIMITED',
    'HOLCIM (INDIA) PRIVATE LIMITED',
    'HOLCIM SERVICES SOUTH ASIA LIMITED',
    'IBIZ CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'HOLMARC OPTO-MECHATRONICS PRIVATE LIMITED',
    'HPCL SHAPOORJI ENERGY PRIVATE LIMITED',
    'I PROCESS SERVICES INDIA PRIVATE LIMITED',
    'I I INSPECTION AND EXPORT PRIVATE LIMITED',
    'I ADMIN OUTSOURCING PRIVATE LIMITED',
    'HSBC INVESTDIRECT (INDIA) LIMITED',
    'ICREA INFOTECH PRIVATE LIMITED',
    'IDEACTS INNOVATIONS PRIVATE LIMITED',
    'HYUNDAI ELECTRONICS INDIA LIMITED',
    'HYUNDAI MERCHANT MARINE INDIA PRIVATE LIMITED',
    'HUSQVARNA INDIA PRODUCTS PRIVATE LIMITED',
    'HOCHTIEF (INDIA) PRIVATE LIMITED',
    'I AND B SEEDS PRIVATE LIMITED',
    'HOLKOI TECHNOLOGIES PVT LTD',
    'HYOSUNG T AND D INDIA PRIVATE LIMITED',
    'HYUNDAI LOGISTICS INDIA PRIVATE LIMITED',
    'INDIA INFOLINE COMMODITIES LIMITED',
    'IFGL EXPORTS LIMITED',
    'ihhr hospitality pvt ltd',
    'INDIAN EXPRESS COMMERCIAL VENTURES & PROJECTS LIMITED',
    'IMEDGLOBAL SOLUTIONS INDIA PRIVATE LIMITED',
    'ILC IRON AND STEEL PVT LTD',
    'IFFCO-TOKIO GENERAL INSURANCE COMPANYLIMITED',
    'IMAGES RETAIL INTELLIGENCE SERVICES PRIVATE LIMITED',
    'IMAGES CONSUMER MEDIA PRIVATE LIMITED',
    'INDFRAG LIMITED',
    'IMF FOUNDRY EQUIPMENT INDIA PRIVATE LIMITED',
    'INDIA BOOK DISTRIBUTORS BOMBAY LIMITED',
    'INDIAN IRON AND METALS PRIVATE LIMITED',
    'INDIAN SOCIETY OF AGRIBUSINESS PROFESSIONALS',
    'INDIAN AGRIBUSINESS SYSTEMS PRIVATE LIMITED',
    'IHORSE TECH PVT LTD',
    'IGNIFY SOFTWARE PRIVATE LIMITED',
    'Indiana Gratings Pvt Ltd',
    'IMG RELIANCE LIMITED',
    'ILANTUS TECHNOLOGIES PRIVATE LIMITED',
    'IMPELSYS INDIA PRIVATE LIMITED',
    'IHG IT SERVICES(INDIA) PRIVATE LIMITED',
    'INDIAN NUTRITION PVT LTD',
    'IKAB SECURITIES AND INVESTMENT LIMITED',
    'INDICOR STEEL PRIVATE LIMITED',
    'INDIAN DRAPE PVT LTD',
    'IKANOS COMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'INBISCO INDIA PRIVATE LIMITED',
    'INDEL MONEY PRIVATE LIMITED',
    'I-EXCEED TECHNOLOGY SOLUTIONS PRIVATELIMITED',
    'IIFL ASSET MANAGEMENT LIMITED',
    'INDAUX INDIA PVT LTD',
    'IJM STEEL PRODUCTS PRIVATE LIMITED',
    'ims health india private limited',
    'IJM LINGAMANENI TOWNSHIP PRIVATE LIMITED',
    'Incadea India Pvt Ltd',
    'IMS HEALTH ANALYTICS SERVICES PVT LTD',
    'IMA PG INDIA PRIVATE LIMITED',
    'INDEX MONEY LIMITED',
    'IL& FS TOWNSHIP & URBAN ASSETS LIMITED',
    'IIC SERVICES (INDIA) PRIVATE LIMITED',
    'IGNITEE DIGITAL SERVICES PVT LTD',
    'IMPACT FOUNDATION INDIA',
    'INDIAN VEHICLE CARRIERS PRIVATE LTD',
    'IDT SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'INDIA RATINGS AND RESEARCH PVT LTD',
    'INDEGENE PRIVATE LTD',
    'INDIA INFOLINE INSURANCE SERVICES LIMITED',
    'IGEFI SOFTWARE INDIA PRIVATE LIMITED',
    'INDIAGAMES LIMITED',
    'INARCO PVT LTD',
    'IFS SOLUTIONS INDIA PRIVATE LIMITED',
    'IGO SOLUTIONS PVT LTD',
    'IDX INDIA DISPLAY PVT LTD',
    'IMPETUS INFOTECH (INDIA) PRIVATE LIMITED',
    'IMEDX INFORMATION SERVICES P LTD',
    'IGNITEWORLD PRIVATE LIMITED',
    'INDIABULLS INFRASTRUCTURE PRIVATE LIMITED',
    'INDIABULLS POWER SERVICES LIMITED',
    'INDIABULLS COMMODITIES LIMITED',
    'INDO PACIFIC AVIATION LIMITED',
    'INDUSTRIAL INFO RESOURCES INDIA PRIVATE LIMITED',
    'INFREIGHT LOGISTICS SOLUTIONS LTD.',
    'innova rubbers pvt ltd',
    'INDUCTION EQUIPMENTS INDIA PVT LTD',
    'INDITRADE DERIVATIVES AND COMMODITIES LIMITED',
    'INDORAMA INDUSTRIES LIMITED',
    'INGERSOLL RAND INTERNATIONAL INDIA PRIVATE LIMITED',
    'INDIHIRE HR CONSULTANTS PRIVATE LIMITED',
    'INNOVEST ADVISORY SERVICES PRIVATE LIMITED',
    'INDIGO PAINTS PRIVATE LIMITED',
    'INLAND FACILITIES MANAGEMENT PRIVATE LIMITED',
    'INFOFACE SOLUTIONS PRIVATE LIMITED',
    'INDO INDUSTRIES LIMITED',
    'INFORCE COMPUTING INDIA PRIVATE LIMITED',
    'INDIGO SYSTEMS AND TECHNOLOGY CONSULTING INDIA PRIVATE LIMITED',
    'INDRALOK TECHNOLOGY PRIVATE LIMITED',
    'INFOR (BANGALORE) PRIVATE LIMITED',
    'INDUS FERRO TECH LIMITED',
    'INFOMAP BPO SERVICES (INDIA) PRIVATE LIMITED',
    'Innovative logistics service private limited',
    'indraprastha shelters pvt ltd',
    'INMAGE SYSTEMS PRIVATE LIMITED',
    'INNOVES ANIMAL HEALTH PRIVATE LIMITED',
    'INP COMPUTER TECHNOLOGY PRIVATE LIMITED',
    'INNOVATIVE TYRES TUBES LIMITED',
    'INDIUM SOFTWARE (INDIA) LIMITED',
    'INFOVISION SOLUTIONS INDIA PRIVATE LIMITED',
    'INDOSUEZ W I CARR SECURITIES (INDIA) PRIVATE LIMITED',
    'INDYCA SOLUTIONS (INDIA) PRIVATE LIMITED',
    'INLAND INFRASTRUCTURE DEVELOPERS PVT LTD',
    'INORBIT MALLS INDIA PRIVATE LIMITED',
    'INDUS TREE PRODUCER TRANSFORM PRIVATE LIMITED',
    'INDUS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'INEIGHT INDIA PRIVATE LIMITED',
    'INOX WIND INFRASTRUCTURE SERVICES LIMITED',
    'INFRAHEDGE SERVICES (INDIA) PRIVATE LIMITED',
    'INFOSTEP INDIA PRIVATE LIMITED',
    'Indsur gears limited',
    'INFASTECH FASTENING TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INOVA AUTOMATION PRIVATE LIMITED',
    'ING INVESTMENT MANAGEMENT (INDIA) PRIVATE LIMITED',
    'INOGIC TECH INDIA PRIVATE LIMITED',
    'INNOVATIA INDIA IT AND KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'INGA CAPITAL PRIVATE LIMITED',
    'INNOVITI PAYMENT SOLUTIONS PRIVATE LIMITED',
    'INNOVIONS CONSULTING PRIVATE LIMITED',
    'INNOMINDS SOFTWARE SEZ INDIA PRIVATELIMITED',
    'INFLUX INTEGRATED SOLUTIONS PRIVATELIMITED',
    'INNOPPL IT SERVICES PVT LTD',
    'INDO JAPAN AIR SERVICES PVT LTD',
    'INDUS EXIMTECH PRIVATE LIMITED',
    'INDUSTRIAL FILTERS AND FABRICS PRIVATE LIMITED',
    'INFOGAIN INDIA PVT LTD',
    'INNOVATIVE B2B LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'INNROAD SOFTWARE DEVELOPMENT SERVICES PVT LTD',
    'INOX FMCG LIMITED',
    'INGERSOLL - RAND CLIMATE SOLUTIONS PRIVATE LIMITED',
    'IPSA BUSINESS INDIA PRIVATE LIMITED',
    'INTERNATIONAL LAND DEVELOPERS PRIVATE LIMITED',
    'INTERSPACE SOLUTIONS PRIVATE LIMITED',
    'Ishwar Singh and Associates Construction Pvt Ltd',
    'IPPRO SERVICES (INDIA) PRIVATE LIMITED',
    'INSCOL ACADEMY LIMITED',
    'Iron Systems India Pvt Ltd',
    'INTECH INFRASTRUCTURE PRIVATE LIMITED',
    'ION EXCHANGE WATERLEAU LIMITED',
    'ISB SHIP CONSULTANTS INDIA PRIVATE LIMITED',
    'IPROF LEARNING SOLUTIONS INDIA PRIVATE LIMITED',
    'IOT DESIGN & ENGINEERING LIMITED',
    'INTEGRATED BRAND.COMM. PRIVATE LIMITED',
    'ISHAAN CLUBS and HOSPITALITY PRIVATE LIMITED',
    'ISSL SETTLEMENT and TRANSACTION SERVICES LIMITED',
    'IQR CONSULTING PRIVATE LIMITED',
    'ISANGO INDIA PRIVATE LIMITED',
    'INTEQ IT SERVICES INDIA PRIVATE LIMITED',
    'ISIGHT RISK MANAGEMENT PRIVATE LIMITED',
    'ISPACE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'IRIS KPO RESOURCING INDIA PRIVATE LIMITED',
    'INTERNATIONAL GEMMOLOGICAL INSTITUTE INDIA PRIVATE LIMITED',
    'IQUEST ENTERPRISES LIMITED',
    'ITAPP SOFTWARE PRIVATE LIMITED',
    'INTEGRATED EQUIPMENT INDIA PRIVATE LTD',
    'INVENTECH INFO SOLUTIONS PVT LTD',
    'INVENTURUS KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'ITECS COMMUNICATIONS PRIVATE LIMITED',
    'INTELENET BUSINESS SERVICES LIMITED',
    'INSTA HEALTH SOLUTIONS PRIVATE LIMITED',
    'INTELLINET SYSTEMS PVT LTD',
    'ITCONS E SOLUTIONS PRIVATE LIMITED',
    'INTERLINK PETROLEUM LIMITED',
    'ISH TRAVEL & TOURS PRIVATE LIMITED',
    'INTEGREON MANAGED SOLUTIONS INDIA PRIVATE LIMITED',
    'ISOFT HEALTH MANAGEMENT (INDIA) PRIVATE LIMITED',
    'ISOFT HEALTH SERVICES (INDIA) PRIVATE LIMITED',
    'IP PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'INTELLECTYX DATA SCIENCE INDIA PVT LTD',
    'INTEGREON (INDIA) PRIVATE LIMITED',
    'ITECH IT PROJECTS (INDIA) PVT LTD',
    'ISE SECURITIES & SERVICES LIMITED',
    'INTEGRATED REGISTRY SERVICES LIMITED',
    'ITCOT CONSULTANCY AND SERVICES LIMITED',
    'INTERTECH MEDIA SOFTWARE PRIVATE LIMITED',
    'IRINJALAKUDA CREDITS & LEASING COMPANY LIMITED',
    'INTELLIGENT ENERGY INDIA PRIVATE LIMITED',
    'INVESTIS CORPORATE COMMUNICATIONS PRIVATE LIMITED',
    'INTERNATIONAL CONVEYORS LTD.',
    'ISILICA NETWORKS INDIA PRIVATE LIMITED',
    'INVOLUTE TECHNOLOGIES PRIVATE LIMITED',
    'ITELLIGENCE INDIA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'INTELIMENT SOFTWARE TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'ITALIAN DESIGN BAGAGE PRIVATE LIMITED',
    'INVESCO (HYDERABAD) PRIVATE LIMITED',
    'intex care private limited',
    'INTEGRATED DATA BASES INDIA LIMITED',
    'IPENGINE MANAGEMENT INDIA PRIVATE LIMITED',
    'ISA ADVANCE INSTRUMENTS INDIA PRIVATE LIMITED',
    'INVICON DEVELOPERS PRIVATE LIMITED',
    'IT AMERICA INDIA PVT LTD',
    'ISUZU LNX LOGISTICS INDIA PRIVATE LIMITED',
    'IRM ENERGY PRIVATE LIMITED',
    'INTEGRATED PROPERTY & POWER DEVELOPERS PRIVATE LIMITED',
    'INTERNATIONAL SPECIALTY PRODUCTS INDIA PRIVATE LIMITED',
    'ISS CATERING SERVICES (SOUTH) PRIVATE LIMITED',
    'JAYSYNTH DYESTUFF INDIA LIMITED',
    'J J IMPEX (DELHI) PRIVATE LIMITED',
    'javi home private ltd',
    'JAMS TECHNOLOGIES PRIVATE LIMITED',
    'jetair tours pvt ltd',
    'J.C. BROTHERS RETAIL PRIVATE LIMITED',
    'JBS ENTERPRISES PVT LTD',
    'JAGUAR-MAX SECURITY SOLUTIONS PRIVATE LIMITED',
    'IWL INDIA LIMITED',
    'JANANI TOURS & RESORTS PVT LTD',
    'JAIVEL ADVANCE TECHNOLOGIES PRIVATE LIMITED',
    'J K Sons Engineers Private Limited',
    'J. M. HUBER INDIA PRIVATE LIMITED',
    'JARIWALA SALES PRIVATE LIMITED',
    'JAYEM AUTOMOTIVES PRIVATE LTD',
    'ITFLUX TECHNOLOGIES PRIVATE LIMITED',
    'ITP PUBLISHING INDIA PRIVATE LIMITED',
    'ITIVITI INDIA PRIVATE LIMITED',
    'J. B. SYNTEX PRIVATE LIMITED',
    'ITEMA WEAVING INDIA PVT LTD',
    'JAINAM PHARMA INDIA PRIVATE LIMITED',
    'JAISURYAS RETAIL VENTURES PRIVATE LIMITED',
    'J R Laddha Financial services Pvt ltd',
    'JARDEN CONSUMER SOLUTIONS OF INDIA PRIVATE LIMITED',
    'J P POLYMERS PVT LTD',
    'JET TEC INFO CONSUMABLES INDIA PVT LTD',
    'JACOB BALLAS CAPITAL INDIA PRIVATE LIMITED',
    'ITZ CASH CARD LIMITED',
    'JAYESH ELECTRICALS LIMITED',
    'IXIA TECHNOLOGIES PVT LTD',
    'ITTI PVT LTD',
    'IVY MOBILITY SOLUTIONS LIMITED',
    'JAKHARIA FABRIC PRIVATE LIMITED',
    'J RAY MCDERMOTT ENGINEERING SERVICES PRIVATE LIMITED',
    'JANYA IT TECHNOLOGIES PRIVATE LIMITED',
    'JAGADAMBA AUTO COMPONENTS LIMITED',
    'IVY BPO Services Private Limited',
    'JAI PHARMA LIMITED',
    'IUP JINDAL METALS & ALLOYS LIMITED',
    'J.K. RISK MANAGERS & INSURANCE BROKERS LIMITED',
    'JAY BEE LAMINATIONS PVT LTD',
    'JAYCEE STEELS PVT LTD',
    'JAITRA SOFTWARE SOLUTIONS PRIVATELIMITED',
    'Jindal steel and power limited',
    'KAEFER PRIVATE LIMITED',
    'JM ENVIRO TECHNOLOGIES PRIVATE LIMITED',
    'JMA RANE MARKETING LIMITED',
    'JIWANRAM SHEODUTTRAI INDUSTRIES PRIVATE LIMITED',
    'K FLEX INDIA PRIVATE LIMITED',
    'KAFILA FORGE LIMITED',
    'K U N MOTOR COMPANY PRIVATE LIMITED',
    'KALASH SEEDS PVT LTD',
    'KABU PROJECTS PVT LTD',
    'Jyoti toolings & press components private limited',
    'JM MHATRE INFRA PRIVATE LIMITED',
    'JLT INDEPENDENT INSURANCE BROKERS PRIVATE LIMITED',
    'KAICO DEER ABRASIVE PRIVATE LIMITED',
    'KALISMA STEEL PRIVATE LIMITED',
    'K V AROCHEM PRIVATE LIMITED',
    'JINIGRAM CONSULTING SERVICES PRIVATE LIMITED',
    'JHAVERI FLEXO INDIA LIMITED',
    'JKT CONSULTING LIMITED',
    'K2 CRANES AND COMPONENTS PRIVATE LIMITED',
    'JINDAL REALTY PRIVATE LIMITED',
    'K R CHOKSEY INVESTMENT MANAGERS PRIVATE LIMITED',
    'k i international ltd',
    'JUNIPER HOTELS PRIVATE LIMITED',
    'JSS MEDICAL RESEARCH INDIA PRIVATE LIMITED',
    'JSG INNOTECH PVT LTD',
    'kabeer infotech systems india pvt ltd',
    'KALANIKETHAN FASHIONS PRIVATE LIMITED',
    'JOY GLOBAL (INDIA) LIMITED',
    'KAILASH VAHAN UDYOG LTD',
    'KAKINADA MARINE AND OFFSHORE COMPLEX LIMITED',
    'JYOTI PORTFOLIO PRIVATE LIMITED',
    'JOCATA FINANCIAL ADVISORY and TECHNOLOGY SERVICES PRIVATE LIMITED',
    'K P BUILDCON PRIVATE LIMITED',
    'JISNU COMMUNICATIONS LIMITED',
    'KADEVI INDUSTRIES LIMITED',
    'Jkm ferrotech limited',
    'JOYALUKKAS INDIA PRIVATE LIMITED',
    'K World Estates Pvt Ltd',
    'K RAHEJA CORPORATE SERVICES PRIVATE LIMITED',
    'JULIET APPEREL LTD',
    'JUMIO INDIA PVT LTD',
    'KAI MANUFACTURING INDIA PVT LTD',
    'JWT MINDSET ADVERTISING PRIVATE LIMITED',
    'jsw structural metal decking ltd',
    'K STEAMSHIP AGENCIES PRIVATE LIMITED',
    'JULY SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED',
    'KALITATE POWER TRANSMISSIONS PRIVATE LIMITED',
    'JUBILANT OIL & GAS PRIVATE LIMITED',
    'JUSTRELIEF WELLNESS PVT LTD',
    'Recommended By RIC N10854',
    'JUBILANT MOTORWORKS SOUTH PRIVATE LIMITED',
    'KAY INTERNATIONAL LTD',
    'KESELEC LIGHTING PRIVATE LIMITED',
    'KBB NUTS PVT LTD',
    'KHM DRIVE SYSTEMS PRIVATE LIMITED',
    'KALYANI TECHNOLOGIES LIMITED',
    'KARAM CHAND THAPAR BROS COAL SALES LTD',
    'KANHAI FOODS PVT LTD',
    'KESTE SOFTWARE PRIVATE LIMITED',
    'KAVERI GAS POWER LIMITED',
    'Kerneos india aluminate technologies private limited',
    'KESAR ENTERPRISES LIMITED Ã‚Â Ã‚Â Ã‚Â Ã‚Â Ã‚Â Ã‚Â Ã‚Â',
    'KAPSTON FACILITIES MANAGEMENT PRIVATE LIMITED',
    'KARNAVATI ENGINEERING LTD',
    'KALYANI THERMAL PROCESSING PRIVATE LIMITED',
    'KARNAVATI DISTRIBUTORS LIMITED',
    'KGS SOURCING INDIA PRIVATE LIMITED',
    'KEYNOTE COMMODITIES LIMITED',
    'KAPICO MOTORS INDIA PRIVATE LIMITED',
    'KANHATECH SOLUTIONS LIMITED',
    'KARNATAKA ROADLINES PVT LTD',
    'Kef infrastructure india private limited',
    'KALPATARU PROPERTIES THANE PRIVATE LIMITED',
    'KEMSYS TECHNOLOGIES PRIVATE LIMITED',
    'KELVIN COLD CHAIN LOGISTICS PRIVATE LIMITED',
    'KHANGLOBAL ENGINEERING CONSULTANTS P LTD',
    'KARNATAKA HYBRID MICRO DEVICES LIMITED',
    'KIERAYA FURNISHING SOLUTIONS PRIVATE LIMITED',
    'KEYSIGHT TECHNOLOGIES INTERNATIONAL INDIA PVT LTD',
    'KEPPEL OFFSHORE & MARINE ENGINEERING SERVICES MUMBAI PRIVATE LIMITED',
    'KIDER INDIA PRIVATE LIMITED',
    'KEIHIN INDIA MANUFACTURING PRIVATE LIMITED',
    'KAMLA LANDMARC MOTORS PRIVATE LIMITED',
    'KAZMUNAI INDIA PVT LTD',
    'KENSIUM LEGAL SERVICES PRIVATE LIMITED',
    'KERRY LOGISTICS INDIA PRIVATE LIMITED',
    'KDR SERVICES PRIVATE LIMITED',
    'KARNATAKA NUTRACEUTICALS LT',
    'KARMA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'KGK ENTICE INDIA PRIVATE LIMITED',
    'KASAI INDIA CHENNAI PRIVATE LIMITED',
    'KCP ENGINEERS PRIVATE LIMITED',
    'KALS INFORMATION SYSTEMS LIMITED',
    'KASTECH SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'KIRLOSKAR SYSTECH LIMITED',
    'KIMPLAS PIPING SYSTEMS LIMITED',
    'KOSMODERMA CLINICS AND SPAS PRIVATE LIMITED',
    'KSM HOUSING PRIVATE LIMITED',
    'KULKARNI POWER TOOLS LTD',
    'KSM NIRMAN PRIVATE LIMITED',
    'KRIPYA ENGINEERING PRIVATE LIMITED',
    'KILOL FABRICS PRIVATE LIMITED',
    'KRISHNAGIRI THOPUR TOLL ROAD LIMITED',
    'KRISHNA ISHIZAKI AUTO LIMITED',
    'KOOL EX COLD CHAIN LIMITED',
    'KOBELCO CRANES INDIA PRIVATE LIMITED',
    'KONVERTOR PACKAGING SOLUTIONS PVT LTD',
    'KINGFA SCIENCE AND TECHNOLOGY INDIA LIMITED',
    'KOTAK GLOBAL LOGISTICS LIMITED',
    'KRUPA CHATONS MFG. CO. PVT. LTD.',
    'KISAN RATILAL CHOKSEY SHARES AND SECURITIES PRIVATE LIMITED',
    'KRYSTAL STEEL MANUFACTURING PRIVATE LIMITED',
    'KISCO TRADING INDIA PVT LTD',
    'Kohinoor speciality foods india private limited',
    'KUBER TEXLEN PRIVATE LIMITED',
    'KTF FASHION PVT LTD',
    'KLOUDQ TECHNOLOGIES LIMITED',
    'KITPAY PRIVATE LTD',
    'KODIAK NETWORKS INDIA PVT LTD',
    'KLRF LIMITED',
    'Knowledge Lens Pvt Ltd',
    'KRUGER M AND E INDUSTRIES (INDIA) PRIVATE LIMITED',
    'KINEDEX HEALTHCARE PRIVATE LIMITED',
    'KIRAN VYAPAR LTD',
    'KOSAN CRISPLANT INDIA PRIVATE LIMITED',
    'Kohler Power India Pvt Ltd',
    'KRISHNA TRANSNATIONAL MARBLES PVT LTD',
    'KIRUSA SOFTWARE PRIVATE LIMITED',
    'KRIS AUTOMATED PACKAGING SYSTEMS PRIVATE LIMITED',
    'Krishna allied industries private limited',
    'KMG INFOTECH LIMITED',
    'KOYO BEARINGS INDIA PRIVATE LIMITED',
    'KPISOFT TECHNOLOGIES PRIVATE LIMITED',
    'KOTHARI DIAMOND INDUSTRIES PVT LTD',
    'KKR CAPITAL MARKETS INDIA PRIVATE LIMITED',
    'KNOAH SOLUTIONS PRIVATE LIMITED',
    'KISHCO LIMITED',
    'KIRPEKAR ENGINEERINGS PVT LTD',
    'KINGSTON PROPERTY SERVICES PRIVATE LIMITED',
    'KRONES INDIA PRIVATE LIMITEDI',
    'KK MILK FRESH INDIA LIMITED',
    'KORBA WEST POWER COMPANY LIMITED',
    'KOYO ELECTRONICS INDIA PRIVATE LIMITED',
    'KISAN RURAL FINANCE LIMITED',
    'KIRTI DEVELOPERS AND CONSTRUCTIONS LIMITED',
    'LAWRENCE AND MAYO INDIA PRIVATE LIMITED',
    'L&T CUTTING TOOLS LIMITED',
    'L and t chiyoda limited',
    'L AND L CONSULTANCY SERVICES PRIVATE LIMITED',
    'LATERAL MGT. SERVICES LIMITED',
    'LAMONS GASKET AND BOLT INDIA PRIVATE LIMITED',
    'LASER POWER AND INFRA PRIVATE LIMITED',
    'LE FABCO PVT LTD',
    'L&T ACCESS DISTRIBUTION SERVICES LIMITED',
    'KUMAR WEARS PRIVATE LIMITED',
    'LEANSOFT SOLUTIONS PRIVATE LIMITED',
    'L&T KOBELCO MACHINERY PRIVATE LIMITED',
    'LAMBDA EASTERN TELECOMMUNICATION LIMITED.',
    'L&T INVESTMENT MANAGEMENT LIMITED',
    'KV FIRE CHEMICALS INDIA PVT LTD',
    'Kuloday Plastomers Pvt Ltd',
    'LA ARCHPLAN PRIVATE LIMITED',
    'L&T HALOL - SHAMLAJI TOLLWAY LIMITED',
    'L&T AHMEDABAD - MALIYA TOLLWAY LIMITED',
    'L&t capital markets limited',
    'KURTOSYS SYSTEMS INDIA PVT LTD',
    'LBF TRAVEL INDIA PRIVATE LIMITED',
    'Laxmi india finleasecap private limited',
    'LEATHER WORLD INDIA LIMITED',
    'LANCO HYDRO POWER LIMITED',
    'LANDMARK BLITZ PRIVATE LIMITED',
    'LAMAR NATURAL PRODUCT PRIVATE LIMITED',
    'LANGOOR DIGITAL PRIVATE LIMITED',
    'L4 SUPPORT SERVICES PRIVATE LIMITED',
    'LA MCLEAN INDIA PRIVATE LIMITED',
    'LA-GAJJAR MACHINERIS PRIVATE LIMITED',
    'Kyocera ctc precision tools private limited',
    'KYYBA ENGINEERING PRIVATE LIMITED',
    'LEARNING INFORMATION SYSTEMS (INDIA) PRIVATE LIMITED',
    'LATERAL PRAXIS (INDIA) PRIVATE LIMITED',
    'L AND T THALES TECHNOLOGY SERVICES PRIVATE LIMITED',
    'KUSTERS ENGINEERING INDIA PRIVATELIMITED',
    'KYOKUTO TRADING (INDIA) PRIVATE LIMITED',
    'LANDMARK CARS PRIVATE LIMITED',
    'KURIOS THELES BUSINESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'LATENT VIEW ANALYTICS PRIVATE LIMITED',
    'Lantech pharmaceuticals limited',
    'LAN MARK SHOPS INDIA PRIVATE LIMITED',
    'LAQSHYA MEDIA PRIVATE LIMITED',
    'L FAST BRANDS PRIVATE LIMITED',
    'LCG INDUSTRIES LIMITED',
    'Le Ecosystem Technology India Pvt Ltd',
    'LONELY PLANET INDIA PRIVATE LIMITED',
    'LUXFER UTTAM INDIA PRIVATE LIMITED',
    'LINDSAY INTERNATIONAL PVT.LTD.',
    'LULU INTERNATIONAL SHOPPING MALL PRIVATE LIMITED',
    'LOTUS TEXPARK LIMITED',
    'LEGRIS INDIA PRIVATE LIMITED',
    'LUXMI TEA CO LTD',
    'LENSKART SOLUTIONS PVT LTD',
    'LION HOLDINGS PRIVATE LIMITED',
    'LECTRIX MOTORS PRIVATE LIMITED',
    'LMS INDIA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'M + r logistics (india) private limited',
    'LUKUP MEDIA PRIVATE LIMITED',
    'LINCOLN HELIOS (INDIA) LIMITED',
    'LYCA TELECOM PRIVATE LIMITED',
    'LUXRA ENTERPRISES PVT LTD',
    'LGC PROMOCHEM INDIA PRIVATE LIMITED',
    'LINA MEDICAL INDIA PRIVATE LIMITED',
    'lok priya buildwell private limited',
    'LG HAUSYS INDIA PRIVATE LIMITED',
    'LION MANPOWER SOLUTIONS PRIVATE LIMITED',
    'LILAC FACILITY MANAGEMENT PRIVATE LIMITED',
    'LINKEDTEAMS INDIA SOFTWARE PRIVATE LIMITED',
    'LUMERIS INDIA PRIVATE LIMITED',
    'LOTUS ROOFINGS PRIVATE LIMITED',
    'LODHA ESTATE P LTD',
    'LIVESTREAM TECHNOLOGIES PRIVATE LIMITED',
    'LOGISTIC INTEGRATORS i PRIVATE LIMITED',
    'LISTER TECHNOLOGIES PRIVATE LIMITED',
    'LIVEWEL AVIATION SERVICES PRIVATE LIMITED',
    'LM WIND POWER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'LEX NIMBLE SOLUTIONS PRIVATE LIMITED',
    'LINERS INDIA LIMITED',
    'Leewayhertz technologies Pvt Ltd',
    'LIVIA POLYMER BOTTLES PRIVATE LIMITED',
    'LLM APPLIANCES LIMITED',
    'LOTUS SHOPPING CENTRES PVT LTD',
    'LIZER CYLINDERS LIMITED',
    'LIQUENT SOFTWARE INDIA PRIVATE LIMITED',
    'LODHA FINSERV PVT LTD',
    'LESLIE E.ROBERTSON ASSOCIATES CONSULTING ENGINEERS (INDIA) PRIVATE LIMITED',
    'LUMINESCENT SOFTWARE PRIVATE LIMITED',
    'LOTUS SURGICALS PRIVATE LIMITED',
    'LOVEPAC CONVERTING PRIVATE LIMITED',
    'LOTUS LABS PVT LTD',
    'LOWES SERVICES INDIA PRIVATE LIMITED',
    'Liveon Healthcare Pvt Ltd',
    'LEONI CABLE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'LOTUS POND HOTEL PRIVATE LIMITED',
    'LORDS FREIGHT INDIA PRIVATE LIMITED',
    'LEGASIS SERVICES PRIVATE LIMITED',
    'LML LIMITED',
    'LUX FLAVOURS PRIVATE LIMITED',
    'LITTLE INTERNET PVT LTD',
    'LYONESS INDIA PRIVATE LIMITED',
    'LUMAX MANAGEMENT SERVICES PRIVATELIMITED',
    'LITHIUM TECHNOLOGIES INDIA R AND D PRIVATE LIMITED',
    'MA KNOWLEDGE SERVICES RESEARCH (INDIA) PRIVATE LIMITED',
    'M V SHOE CARE PRIVATE LIMITED',
    'MAGICTEL SOLUTIONS PVT LTD',
    'MAGNITUDE SOFTWARE INDIA PRIVATE LIMITED',
    'Mailam india limited',
    'M j logistic services limited',
    'M F RINGS AND BEARINGS RACES LIMITED',
    'MACHANI INFRA DEVELOPMENT CORPORATION PVT LTD',
    'MAHINDRA CONSULTING ENGINEERS LIMITED',
    'MADHU JAYANTI INTERNATIONAL LTD',
    'MAGNUM FORGE AND MACHINE WORKS PVT LTD',
    'M and M MACHINE CRAFT PVT LTD',
    'MAGNETI MARELLI SKH EXHAUST SYSTEMS PRIVATE LIMITED',
    'MADHAVI REAL ESTATES PRIVATE LIMITED',
    'MALANKARA PLANTATIONS LIMITED',
    'MACRO COMMERCE PRIVATE LIMITED',
    'MAGICON IMPEX PVT LTD',
    'MAGPET POLYMERS PVT LTD',
    'MAGNETI MARELLI TALBROS CHASSIS SYSTEMS PRIVATE LIMITED',
    'MAHINDRA SURYAPRAKASH PRIVATE LIMITED',
    'MAILHEM IKOS ENVIRONMENT PRIVATE LIMITED',
    'MACHINO AUTO COMP TOOLING PRIVATE LIMITED',
    'MAKSAT CORAL PRIVATE LIMITED',
    'MALCOLM PIRNIE CONSULTING ENGINEERS INDIA PRIVATE LIMITED',
    'M P ENGINEERING CONSTRUCTIONS INDIA PRIVATE LIMITED',
    'MAC CHEM PRODUCTS INDIA PRIVATE LIMITED',
    'MAHINDRA NAMASTE PRIVATE LIMITED',
    'MANAPPURAM CONSTRUCTION AND PROPERTIES LIMITED',
    'MAKAAN COM PRIVATE LIMITED',
    'MACH 7 TECHNOLOGIES PRIVATE LIMITED',
    'MAHARASHTRA SAFE CHEMISTS AND DISTRIBUTORS ALLIANCE LIMITED',
    'MALABAR JEWELS FORT PRIVATE LIMITED',
    'M G AUTOMOTIVES PRIVATE LIMITED',
    'MAHAPHANT FIBRE CEMENT SOUTH ASIA PRIVATE LIMITED',
    'MAGOD LASER MACHINING PVT LTD',
    'MAGIKMINDS SOFTWARE SERVICES PRIVATE LIMITED',
    'MAGUS CUSTOMER DIALOG PRIVATE LIMITED',
    'M TECH INFORMATICS LIMITED',
    'MAIA INTELLIGENCE PRIVATE LIMITED',
    'MAGNA RICO POWERTRAIN PRIVATE LIMITED',
    'MACK TELECOM SERVICES PRIVATE LIMITED',
    'MAIDEN MARKETING INDIA PVT LTD',
    'M SQUARE AUTOMOBILE PRIVATE LIMITED',
    'MAN TURBOMACHINERY INDIA PRIVATE LIMITED',
    'MAGNA POWERTRAIN BANGALORE PRIVATE LIMITED',
    'M G R AUTOMOBILES PRIVATE LIMITED',
    'MAN TUBINOX LIMITED',
    'M D OVERSEAS LIMITED',
    'MAMSYS CONSULTANCY SERVICES PVT LTD',
    'MACARONI MEDIA WORKS PRIVATE LIMITED',
    'MACMILLAN PUBLISHERS INDIA PRIVATE LIMITED',
    'MARSHALL MACHINES PRIVATE LIMITED',
    'MANGAL TEXTILE MILLS INDIA PRIVATE LIMITED',
    'MCNALLY SAYAJI ENGINEERING LIMITED',
    'MCGRAW HILL EDUCATION INDIA PRIVATE LIMITED',
    'MAXICARE OVERSEAS ASSOCIATES PRIVATE LIMITED',
    'MANIPAL ENERGY AND INFRATECH LIMITED',
    'MARUTI INSURANCE BROKING PRIVATE LIMITED',
    'MANTRI DEVELOPERS PVT LTD',
    'MAPSKO BUILDERS PVT LTD',
    'MASS TECH CONTROLS PRIVATE LIMITED',
    'MATRIX CELLULAR INTERNATIONAL SERVICES LIMITED',
    'Manjilas Food Tech Pvt Ltd',
    'MARK ACOUSTIC ENCLOSURE PRIVATE LIMITED',
    'MC CRAFTSMAN MACHINERY PRIVATE LIMITED',
    'MARINE ELECTRICALS INDIA PRIVATE LIMITED',
    'MARDA ESTATES PVT LTD',
    'Master components private limited',
    'MBNA INDIAN SERVICES PRIVATE LIMITED',
    'MAURYA TV PRIVATE LIMITED',
    'Marble Centre International Pvt Ltd',
    'MAX SPECIALITY PRODUCTS LIMITED',
    'MANROLAND INDIA PRIVATE LIMITED',
    'MASONITE DOORS PRIVATE LIMITED',
    'MARKOLINE INFRA PRIVATE LIMITED',
    'MASTER STAFFING SOLUTIONS PVT LTD',
    'Manipal Integrated services pvt ltd',
    'MAYUR INDUSTRIES LIMITED',
    'MBLAZON SOLUTIONS PRIVATE LIMITED',
    'MARUBENI INDIA PVT LTD',
    'MARKOLINES TRAFFIC CONTROLS PRIVATE LIMITED',
    'MAST INDIA TRADING SERVICES PRIVATE LIMITED',
    'MAX SPECIALITY FILMS LIMITED',
    'MANDO SOFTTECH INDIA PRIVATE LIMITED',
    'MATRIX INDIA ENTERTAINMENT CONSULTANS PRIVATE LIMITED',
    'MAXPOSURE MEDIA GROUP INDIA PRIVATE LIMITED',
    'MARINETRANS INDIA PRIVATE LIMITED',
    'MAST GLOBAL BUSINESS SERVICES INDIA PVT LTD',
    'MBE COAL and MINERAL TECHNOLOGY INDIA PRIVATE LIMITED',
    'MANTRA SOFTECH INDIA PRIVATE LIMITED',
    'MARLABS SOFTWARE PRIVATE LIMITED',
    'MARINO FOOD PRODUCTS PVT LIMITED',
    'MCAFEE INDIA SALES PRIVATE LIMITED',
    'MARYA FROZEN AGRO FOODS PRIVATE LIMITED',
    'MANGALI PETROCHEM LIMITED',
    'MARA SOCIAL MEDIA INDIA PVT LTD',
    'MANTRAM TECHNOFAB PVT LTD',
    'MAWANA FOOD PVT LTD',
    'MCCANN ERICKSON INDIA PRIVATE LIMITED',
    'MCDONALDS INDIA PRIVATE LIMITED',
    'MARS ENTERPRISES AND HOSPITALITY PRIVATE LIMITED',
    'MATRIKON INDUSTRIAL SOLUTIONS INDIA PRIVATE LIMITED',
    'MAYA ENTERTAINMENT LIMITED',
    'MANIKA MOULDS PRIVATE LIMITED',
    'MERIDIAN MOBILE PRIVATE LIMITED',
    'MERCURY CAR RENTALS PRIVATE LIMITED',
    'MENSK MANAGEMENT SERVICES LIMITED',
    'MCPL PRIVATE LIMITED',
    'MEDITAB SPECIALITIES PRIVATE LIMITED',
    'MEHTA TUBES LTD',
    'MICRO CARE COMPUTERS PVT LTD',
    'METRO HOLDINGS AND SECURITIES PRIVATE LIMITED',
    'MGRM NET LIMITED',
    'MEGASOFT SOLUTIONS INDIA PVT LTD',
    'Mewar Hi Tech Engineering Limited',
    'MEDIA IQ DIGITAL INDIA PRIVATE LIMITED',
    'MEDICARE T P A SERVICES I PRIVATE LIMITED',
    'MDBOSS (INDIA) PRIVATE LIMITED',
    'MEHER ADVANCED MATERIALS PVT LTD',
    'MEDIA NETWORK & DISTRIBUTION (INDIA) LIMITED',
    'MEDIMANAGE INSURANCE BROKING PRIVATE LIMITED',
    'MFAR HOTELS AND RESORTS PRIVATE LIMITED',
    'MECORDS INDIA LIMITED',
    'MEDIBIOS LABORATORIES PRIVATE LIMITED',
    'MICHELL BEARINGS (INDIA) PRIVATE LIMITED',
    'MEDGENOME LABS PRIVATE LIMITED',
    'MGRM MEDICARE LIMITED',
    'MERCURIO PALLIA LOGISTICS PRIVATE LIMITED',
    'MENTOR GRAPHICS INDIA PRIVATE LIMITED',
    'MENTORWARE INDIA PRIVATE LIMITED',
    'MEDIA SYSTEMS INDIA SOFT SOLUTIONS PRIVATE LIMITED',
    'MERIDIAN CHEM BOND PRIVATE LIMITED',
    'MERGERMARKET INDIA PRIVATE LIMITED',
    'M-HANCE INDIA PRIVATE LIMITED',
    'MEDIA 360 DEGREE SERVICES INDIA PRIVATE LIMITED',
    'MEDDIFF TECHNOLOGIES PRIVATE LIMITED',
    'MEDPLUS HEALTH SERVICES PRIVATE LIMITED',
    'Chevrox Constructions Pvt Ltd',
    'MCTC EXIM PRIVATE LIMITED',
    'MEDICINES COMPANY (INDIA) PRIVATE LIMITED',
    'MICRO FOCUS SOFTWARE INDIA PVT LTD',
    'MEDTEK.NET (INDIA) PRIVATE LIMITED',
    'MEIKO LOGISTICS INDIA PRIVATE LIMITED',
    'meiji india pvt limited',
    'MEAD JOHNSON NUTRITION INDIA PRIVATE LIMITED',
    'MERU MOBILITY TECH PRIVATE LIMITED',
    'Metmox software solutions india private limited',
    'MEDI ASSIST HEALTHCARE SERVICES PRIVATE LIMITED',
    'MEDIA WORLD VENTURES LIMITED',
    'MERA TRANSPORT EXCHANGE PVT LTD',
    'MERIDIAN APPARELS PRIVATE LIMITED',
    'MEGA CABS PRIVATE LIMITED',
    'METALSA INDIA PVT LTD',
    'MGF AUTOMOBILES LIMITED',
    'MOLSON COORS INDIA PVT LTD',
    'MINDA SILCA ENGINEERING PRIVATE LTD',
    'MORPHOGENESIS ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'MILK FOOD LTD',
    'MOBIQUEST MOBILE TECHNOLOGIES PVT LTD',
    'MINDA KYORAKU LIMITED',
    'MONNET DANIELS COAL WASHERIES LIMITED',
    'MONARCH SELF ADHESIVE TAPES AND FOAMS INDIA PRIVATE LIMITED',
    'MODERN THREADS(INDIA) LTD',
    'MIMOZA ENTERPRISES FINANCE PRIVATE LIMITED',
    'MODI MUNDIPHARMA BEAUTY PRODUCTS PRIVATE LIMITED',
    'MICROMATIC GRINDING TECHNOLOGIES LIMITED',
    'MIRRA AND MIRRA INDUSTRIES PRIVATE LIMITED',
    'MITSUBISHI HEAVY INDUSTRIES VST DIESEL ENGINES PRIVATE LTD',
    'micro polypet private ltd',
    'Mobicip Technologies Pvt Ltd',
    'MOBILE IRON INDIA SOFTWARE PRIVATE LIMITED',
    'MINDPOOL TECHNOLOGIES PRIVATE LIMITED',
    'Movers International Private Limited',
    'MONNET INDUSTRIES LIMITED',
    'MIDMARK INDIA PRIVATE LIMITED',
    'Millennium aero dynamics pvt ltd',
    'MOLSON COORS COBRA INDIA PRIVATE LIMITED',
    'MODY PUMPS INDIA PVT LTD',
    'MINDA NABTESCO AUTOMOTIVE PVT LTD',
    'MIQ LOGISTICS INDIA PRIVATE LTD',
    'MIRAMED AJUBA SOLUTIONS PRIVATE LIMITED',
    'MOLD-MASTERS TECHNOLOGIES PRIVATE LIMITED',
    'MOTELS AND INFRASTRUCTURE INDIA PVT LTD',
    'MOODYS SHARED SERVICES INDIA PVT LTD',
    'MOUCHEL ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'MICRO INSTRUMENTS LIMITED',
    'MICRON PRECION SCREWS LTD',
    'MINERAL ENTERPRISES LIMITED',
    'MOTION DYNAMICS PRIVATE LIMITED',
    'mitsuboshi belting india pvt ltd',
    'MITSUBISHI HITACHI POWER SYSTEMS INDIA PRIVATE LIMITED',
    'MINVESTA INFOTECH LTD',
    'MOTHERSON AIR TRAVEL AGENCIES LTD.',
    'Moschip semiconductor technology limited',
    'MOMOE TECHNOLOGIES PRIVATE LIMITED',
    'MIL INDIA LIMITED',
    'MORARJEE GOCULDAS SPG. & WVG. PRIVATE LIMITED',
    'MOTILAL OSWAL CAPITAL MARKETS PRIVATE LIMITED',
    'MOTILAL OSWAL INSURANCE BROKERS PRIVATE LIMITED',
    'MOSHES FINE FOODS PRIVATE LIMITED',
    'MILLENNIUM TECHNOSOFT LIMITED',
    'MODISPACES REAL ESTATE PRIVATE LIMITED',
    'MOVING KITCHEN PRIVATE LIMITED',
    'MMS MARITIME INDIA PRIVATE LIMITED',
    'MOTOR SALES LIMITED',
    'MIND MATRIX IT SERVICES PRIVATE LIMITED',
    'MSP STEEL AND POWER LIMITED',
    'MVS ENGINEERING LIMITED',
    'NATIONAL INDUSTRIAL CORPN LIMITEID',
    'NAGARRO SOFTWARE PVT LTD',
    'NANOCARE HEALTH SERVICES PVT LTD',
    'NARASUS SAARATHY ENTERPRISES PRIVATE LIMITED',
    'NARAINGARH SUGAR MILLS LTD.',
    'NABARD FINANCIAL SERVICES LIMITED',
    'MUKAND INDUSTRIES PVT LTD',
    'MSX INTERNATIONAL INDIA PRIVATE LIMITED',
    'MY CHOICE SAREES PRIVATE LIMITED',
    'MUTHOOT SYSTEMS AND TECHNOLOGIES PRIVATE LIMITED',
    'MSC TECHNOLOGY INDIA PRIVATE LIMITED',
    'MPSEZ UTILITIES PRIVATE LIMITED',
    'MSWIPE TECHNOLOGIES PVT LTD',
    'NABLER WEB SOLUTIONS PRIVATE LIMITED',
    'NATIONAL POLYPLAST INDIA LIMITED',
    'mscripts Systems India Private Limited',
    'NATIONAL COLLATERAL MANAGEMENT SERVICES LIMITED',
    'Muraai Information Technologies Pvt Ltd',
    'N D R INFRASTRUCTURE PRIVATE LIMITED',
    'MULTITECH AUTO PVT LTD',
    'MULTI- ACT EQUITY RESEARCH SERVICES PRIVATE LIMITED',
    'MXC SOLUTIONS INDIA PRIVATE LIMITED',
    'MUTHOOT AUTOMOTIVE INDIA PVT LTD',
    'NACHI MOTHERSON PRECISION PRIVATE LIMITED',
    'NACHI MOTHERSON TOOL TECHNOLOGY LIMITED',
    'NASCENT INFO TECHNOLOGIES PRIVATELIMITED',
    'MURUGAPPA ORGANO WATER SOLUTIONS PRIVATE LIMITED',
    'MYK SCHOMBURG INDIA PRIVATE LIMITED',
    'MUTHOOT SECURITIES LTD',
    'MSC SOFTWARE CORPORATION INDIA PRIVATE LIMITED',
    'MW HIGH TECH PROJECTS INDIA PRIVATE LIMITED',
    'NANO THERAPEUTICS PVT LTD',
    'NABHIRAJA SOFTWARE DESIGN PRIVATE LIMITED',
    'NAPIER HEALTHCARE SOLUTIONS (INDIA) LIMITED',
    'NARAYANA PEARLS INDIA PRIVATE LIMITED',
    'NATCO ORGANICS LIMITED',
    'NAGRAVISION INDIA PVT LTD',
    'NANDAN TERRY PRIVATE LIMITED',
    'NATIT SOLVED PRIVATE LIMITED',
    'NEXGEN INFRACON PVT LTD',
    'NETWORKPLAY MEDIA PRIVATE LIMITED',
    'NEUMAN AND ESSER ENGINEERING (INDIA) PRIAVTE LIMITED',
    'NEYDAL SOFTWARE PRIVATE LIMITED',
    'NETAMBIT INSURANCE BROKING INDIA LIMITED',
    'NAZARA TECHNOLOGIES PRIVATE LIMITED',
    'NEW AGE SOFTWARE AND SOLUTIONS INDIA PRIVATE LIMITED',
    'NDTV ETHNIC RETAIL LIMITED',
    'NEXT SOURCING SERVICES INDIA PRIVATE LIMITED',
    'NAVRAS TRAVELS PRIVATE LIMITED',
    'NEO MILK PRODUCTS PRIVATE LIMITED',
    'Nevitech Data Solutions Pvt Ltd',
    'NAVA BHARAT ENERGY INDIA LIMITED,',
    'NEST HOTELS AND RESORTS KODAIKANAL PRIVATE LIMITED',
    'NEXT DOOR LEARNING SOLUTIONS PVT LTD',
    'NEXT POLYMERS LIMITED',
    'NET PROACTIVE SERVICES PRIVATE LIMITED',
    'NEILSOFT LIMITED',
    'NAVIGANT BPM INDIA PRIVATE LIMITED',
    'NEC INDIA PRIVATE LIMITED',
    'NEONATAL CARE AND RESEARCH INSTITUTE PRIVATE LIMITED',
    'NICKUNJ EDM WIRES and CONSUMABLES PRIVATE LIMITED',
    'NICHI IN SOFTWARE SOLUTIONS PVT LTD',
    'NEWAVE ENERGY INDIA PRIVATE LIMITED',
    'NEELAM APPLIANCES PRIVATE LIMITED',
    'NDO INDIA PRIVATE LIMITED',
    'NECTAR LABORATORIES LTD',
    'NETWORK INTELLIGENCE (INDIA ) PRIVATE LIMITED',
    'NEOTISS LIMITED',
    'NETELIXIR EMARKETING SOLUTIONS PRIVATE LIMITED',
    'NAVA BARATH FERTILIZERS LTD',
    'NGK SPARK PLUGS (INDIA) PRIVATE LIMITED',
    'NAUVATA ENGINEERING PRIVATE LIMITED',
    'Nephrocare Health Services Pvt Ltd',
    'NEUVERA WELLNESS VENTURES PVT LTD',
    'NIDEC-SHIMPO INDIA MANUFACTURING PRIVATE LIMITED',
    'NEUROFOCUS SYSTEMS & SERVICES PRIVATE LIMITED',
    'NAVIONICS TECHNOLOGIES PRIVATE LIMITED',
    'NESTLE SKIN HEALTH INDIA PRIVATE LIMITED',
    'NEW VISION SOFTCOM AND CONSULTANCY PRIVATE LIMITED',
    'NBCL MARKETING PRIVATE LIMITED',
    'NEC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'nitson and amitsu private limited',
    'NUCON PNEUMATICS PVT LTD',
    'northern sky properties pvt ltd',
    'Nu sri shyam pharmaceuticals private limited',
    'NORTH INDIA TECHNICAL CONSULTANCY ORGANISATION LIMITED',
    'NSHM UDAAN SKILLS PRIVATE LIMITED',
    'NOVOPAN INDUSTRIES LIMITED',
    'OAB STUDIOS SOFTWARE PVT LTD',
    'NTT COMMUNICATIONS INDIA PRIVATE LIMITED',
    'NOVELVOX SOFTWARE INDIA PVT LTD',
    'NIRANTA SOLUTIONS AND SERVICES PVT LTD',
    'NISSIN ABC LOGISTICS PVT LTD',
    'Nitesh residency hotels pvt ltd',
    'NIRMAN ESTATE DEVELOPERS PRIVATE LIMITED',
    'NITESH ESTATES LIMITED',
    'NUNHEMS VEGETABLE SEEDS PVT LTD',
    'NYK SHIPMANAGEMENT INDIA PRIVATE LIMITED',
    'NITESH HOUSING DEVELOPERS PRIVATE LIMITED',
    'NURTURE SOFTWARE SOLUTIONS PVT LTD',
    'NOVATECH ENGINEERING PRIVATE LIMITED',
    'NOVEL SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'NOVA TECHSET PRIVATE LIMITED',
    'NNE Limited',
    'NMTRONICS (INDIA) PVT LTD',
    'Nucleus satellite communications (madras) private limited',
    'NIIT INSTITUTE OF PROCESS EXCELLENCE LIMITED',
    'NIIT SMARTSERVE LIMITED',
    'NIST INSTITUTE PRIVATE LIMITED',
    'NIPPON STEEL and SUMIKIN PIPE INDIA PRIVATE LIMITED',
    'NU WAY HEATRANSFER PRIVATE LIMITED',
    'NXP SEMICONDUCTORS INDIA PRIVATE LIMITED',
    'NITESH PUNE MALL PRIVATE LIMITED',
    'Oa networks india private limited',
    'NOVELL INDIA PVT LTD',
    'NOVAMARK SPECIALITIES PRIVATE LIMITED',
    'NORTHERN LIGHTS TECHNOLOGY DEVELOPMENT CHENNAI PRIVATE LIMITED',
    'NURAY CHEMICALS PVT LTD',
    'NOVUS GREEN ENERGY SYSTEMS PRIVATE LIMITED',
    'NThrive Global Solutions Pvt Ltd',
    'NIPPON STEEL AND SUMIKIN MATERIALS INDIA PRIVATE LIMITED',
    'NUANCE GROUP FASHION AND LUXURY DUTY FREE PVTLTD',
    'NISSIN BRAKE INDIA PRIVATE LIMITED.',
    'NIPUR CHEMICALS LIMITED',
    'NUANCE TRANSCRIPTION SERVICES INDIA PRIVATE LIMITED',
    'NOVA AGRITECH PRIVATE LIMITED',
    'NUEVORA ANALYTICS TECHNOLOGIES PRIVATE LIMITED',
    'NITTSU LOGISTICS (INDIA) PRIVATE LIMITED',
    'NORTHALLEY INDIA PVT LTD',
    'NOVATECH PROJECTS I PRIVATE LIMITED',
    'NJINSURANCE BROKERS PRIVATE LIMITED',
    'NTT DATA FA INSURANCE SYSTEMS INDIA PRIVATE LIMITED',
    'NUWILL RESEARCH AND INNOVATIONS PRIVATELIMITED',
    'NINE DOT NINE INTERACTIVE PRIVATE LIMITED',
    'NIRULAS CORNER HOUSE PRIVATE LIMITED',
    'nirvaan design private limited',
    'O C TANNER INDIA PRIVATE LIMITED',
    'North East Small Finance Bank Ltd',
    'NYK AUTO LOGISTICS (INDIA) PRIVATE LIMITED',
    'OMSONS MARKETTING PVT. LTD',
    'ORANGE CABS PVT LTD',
    'OIL STATES INDUSTRIES INDIA PRIVATE LIMITED',
    'OERLIKON LEYBOLD VACUUM INDIA PRIVATE LIMITED',
    'ORANGE BUSINESS SERVICES INDIA NETWORK PVT LTD',
    'OMP INDIA PVT LTD',
    'ONE SOURCE MARKETING SOLUTION PRIVATE LIMITED',
    'OKS-SPAN TECH PRIVATE LIMITED',
    'OPTIMUM INFOSYSTEMS PRIVATE LIMITED',
    'ORANE INTERNATIONAL PVT LTD',
    'OLYMPIA ELECTRONICS PRIVATE LIMITED',
    'OERLIKON FRICTION SYSTEMS (INDIA) LIMITED',
    'ONICRA CREDIT INFORMATION COMPANY LIMITED',
    'OPT IT Technologies India Pvt Ltd',
    'ONICRA CREDIT RATING AGENCY OF INDIA LIMITED',
    'ONUS ENTERPRISE PRIVATE LIMITED',
    'OCEAN INTERIORS LIMITED',
    'OPALINE HOTELS PRIVATE LIMITED',
    'ONEASSIST CONSUMER SOLUTIONS PRIVATELIMITED',
    'OPTRA TECHNOLOGIES PRIVATE LIMITED',
    'OMNESYS TECHNOLOGIES PRIVATE LIMITED',
    'OILCO SERVICES (INDIA) LIMITED',
    'OMG NETWORK INDIA PRIVATE LIMITED',
    'OBSIDIAN SOFTWARE PRIVATE LIMITED',
    'OPTICAL FUSION SOFTWARE SERVICES (INDIA) PRIVATE LIMITED',
    'OPEN TEXT TECHNOLOGIES INDIA PRIVATELIMITED',
    'OPAL ASIA (INDIA) PRIVATE LIMITED',
    'OIL FIELD WAREHOUSE & SERVICES LIMITED',
    'OOCL LOGISTICS INDIA PRIVATE LIMITED',
    'Oravel stays private limited',
    'OJALA (INDIA) ENGINEERING PRIVATE LIMITED',
    'ONECERT ASIA AGRI CERTIFICATION PRIVATE LIMITED',
    'ODYSSEY LOGISTICS PVT LTD',
    'ocean science and surveying pvt ltd',
    'OPTIMUS COMMODITY FUTURES PRIVATE LIMITED',
    'OPALFORCE SOFTWARE INDIA PRIVATE LIMITED',
    'OAKNET HEALTHCARE PRIVATE LIMITED',
    'OLIVE CAFES SOUTH PRIVATE LIMITED',
    'onco life cancer center pvt ltd',
    'OJAS INNOVATIVE TECHNOLOGIES PVT LTD',
    'OLIVE TEX SILK MILLS PVT LTD',
    'OCTANE MOBILE PRIVATE LIMITED',
    'OMAPAL TECHNOLOGIES PRIVATE LIMITED',
    'OPPO MOBILE M AND C PRIVATE LIMITED',
    'OPPO MOBILES ( RAJASTHAN) PRIVATE LIMITED',
    'OBJECTFRONTIER INDIA PRIVATE LIMITED',
    'OZONE URBANA INFRA DEVELOPERS PVT LTD',
    'PARAGON IRRIGATION LIMITED',
    'P M Relocations Pvt Ltd',
    'OSL HEALTHCARE PRIVATE LIMITED',
    'PARAMHANS WIRES PVT LTD',
    'PARAG PARIKH FINANCIAL ADVISORY SERVICES PRIVATE LIMITED',
    'PALFINGER CRANES INDIA PRIVATE LIMITED',
    'ORIENTAL VENEER PRODUCTS LIMITED',
    'P dass forging pvt ltd',
    'ORCHESTRATEHR SOLUTIONS PRIVATE LIMITED',
    'ORIENT FASHION EXPORTS INDIA PRIVATE LIMITED',
    'PAARTH INFRABUILD PVT LTD',
    'OTC EXCHANGE OF INDIA',
    'PARIPOORNA SOFTWARE SOLUTION SERVICE PRIVATE LIMITED',
    'OWENS CORNING INDUSTRIES INDIA PRIVATE LIMITED',
    'PARAS PVC PIPES AND FITTINGS PRIVATE LIMITED',
    'ORBIT NET SOLUTIONS PRIVATE LIMITED',
    'P & A INFOTECH PRIVATE LIMITED',
    'ORIND SPECIAL REFRACTORIES PRIVATELIMITED',
    'PAKONA ENGINEERS INDIA PVT LTD',
    'Pacer Automation Pvt Ltd',
    'PANIPAT JALANDHAR NH 1 TOLLWAY PRIVATE LIMITED',
    'OSPYN TECHNOLOGIES PRIVATE LIMITED',
    'PA CONSULTING SERVICES INDIA PVT LTD',
    'PACIFICA HOTELS (BANGLORE PROJECT) PRIVATE LIMITED',
    'OXIRICH CONSTRUCTION PVT LTD',
    'PAREXEL INTERNATIONAL INDIA PRIVATE LIMITED',
    'ORIENT TECHNOLOGIES PRIVATE LIMITED',
    'ORCC SOLUTIONS PRIVATE LIMITED',
    'OXFORD SHELTERS PVT LTD.',
    'ORIENTAL NICCO PROJECTS PRIVATE LIMITED',
    'ORIENTAL METALS INDIA PVT LTD',
    'Pace wisdom Solutions Pvt Ltd',
    'P M ELECTRO AUTO PVT LTD',
    'P K HOSPITALITY SERVICES PRIVATE LIMITED',
    'PACK PRINT INDUSTRIES INDIA PRIVATE LIMITED',
    'PARENTECH HEALTHCARE LIMITED',
    'OTS E SOLUTIONS PRIVATE LIMITED',
    'OWS FREIGHT SYSTEMS PRIVATE LIMITED',
    'OUTDOOR ADVERTISING PROFESSIONALS (INDIA) PRIVATE LIMITED',
    'OVERTURE NETWORKS INDIA PRIVATE LIMITED',
    'PANORAMIC HOLIDAYS LIMITED',
    'PACKSYS GLOBAL (INDIA) PRIVATE LIMITED',
    'ORBCOMM TECHNOLOGIES INDIA PVT LTD',
    'OTHAIN SOFTWARE SERVICES INDIA PRIVATELIMITED',
    'OVERNITE EXPRESS LIMITED',
    'PARAMOUNT IMPEX PVT LTD',
    'PANSE AUTOCOMPS PRIVATE LIMITED',
    'PEE AAR EXIM PRIVATE LIMITED',
    'PG ELECTROPLAST LTD',
    'PENVER PRODUCTS PRIVATE LIMITED',
    'PELICAN PRODUCTS AND SERVICES INDIA PRIVATE LIMITED',
    'PEERLESS FUNDS MANAGEMENT CO LIMITED',
    'PHEDRA PROJECTS PVT. LTD',
    'Pharm Olam International India Private Limited',
    'PENTAIR TECHNICAL PRODUCTS INDIA PRIVATE LIMITED',
    'PEERLESS FINANCIAL PRODUCTS DISTRIBUTION LTD',
    'PERKINELMER HEALTH SCIENCES PRIVATE LIMITED',
    'Pdrv enterprises private limited',
    'PATNI HEALTHCARE LIMITED',
    'PHOCOS INDIA SOLAR PVT LTD',
    'PATIL CONSTRUCTION & INFRASTRUCTURE LIMITED',
    'peoplestrong hr services pvt ltd',
    'PERK.COM SOFTWARE PRIVATE LIMITED',
    'PEOPLE EQUITY HR CONSULTING PRIVATE LIMITED',
    'PENTEK PEN AND STATIONERY PRIVATE LIMITED',
    'PELF FINSTOCK LIMITED',
    'PEPPERL AND FUCHS INDIA PRIVATE LIMITED',
    'PERIDIAN INDIA PRIVATE LIMITED',
    'PERFORM MEDIA INDIA PRIVATE LIMITED',
    'PEARL INSULATIONS PRIVATE LIMITED',
    'PENGALA LEARNING PRIVATE LIMITED',
    'PENTAIR THERMAL MANAGEMENT INDIA PRIVATE LIMITED',
    'PHI EDUCATION SOLUTIONS PVT LIMITED',
    'PERRY JOHNSON OUTSOURCING PRIVATE LIMITED',
    'PE ARISTI PROJECTS AND ENGINEERING PRIVATE LIMITED',
    'PHILS HEAVY ENGINEERING PVT LTD',
    'PENTAGON EL MECH SOLUTIONS PRIVATE LIMITED',
    'pelorus technologies pvt ltd',
    'PERKINELMER (INDIA) PRIVATE LIMITED',
    'PENTAUR TECHNOLOGY PRIVATE LIMITED',
    'PERQ ADVERTISING PVT LTD',
    'PERFECT RELATIONS PVT LTD',
    'PARKSONS CARTAMUNDI PVT LTD',
    'PERMA SHIPPING LINE INDIA PRIVATE LIMITED.',
    'PERVACIO INDIA PRIVATE LIMITED',
    'PETROFAC INFORMATION SERVICES PRIVATE LIMITED',
    'PERFECTVIPS TECHNO SOLUTIONS PRIVATE LIMITED',
    'PERSISTENCE MARKET RESEARCH PRIVATELIMITED',
    'PAYFRONT TECHNOLOGIES INDIA PVT LTD',
    'PARKASH AMUSEMENT RIDES AND FUN WORLD PRIVATE LIMITED',
    'PARKER-MARKWEL INDUSTRIES PRIVATE LIMITED',
    'PDS MULTINATIONAL FASHIONS LIMITED',
    'PEARL INTERNATIONAL TOURS AND TRAVELS LTD.',
    'Plaza wires private limited',
    'POLYPLASTICS INDUSTRIES (INDIA) PRIVATE LIMITED',
    'PLUSS ADVANCED TECHNOLOGIES PRIVATE LIMITED',
    'PIONEER FIL MED PRIVATE LIMITED',
    'POSITIVE EDGE SOLUTIONS PRIVATE LIMITED',
    'M2MIT DIGITAL PRIVATE LIMITED',
    'GAMERSROOF TECHNOLOGIES PRIVATE LIMITED',
    'INFIWARE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MLS INSPECTION PRIVATE LIMITED',
    'FINBASE CONSULTANTS PRIVATE LIMITED',
    'SOLUTIONEC PRIVATE LIMITED',
    'SHIVANIKA FOODS PRIVATE LIMITED',
    'ENHAZ BEVERAGES PRIVATE LIMITED',
    'ASMITA PATEL GLOBAL SCHOOL OF TRADING PRIVATE LIMITED',
    'EPIC YARNS PRIVATE LIMITED',
    'CALLISTO SOLAR POWER PRIVATE LIMITED',
    'APPRECIATE PLATFORM PRIVATE LIMITED',
    'CERATHERM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BELLARY INFRASTRUCTURE PRIVATE LIMITED',
    'RIVAARA IMMUNE PRIVATE LIMITED',
    'PRUDENCE PRIORITY PRIVATE LIMITED',
    'CABEATS TECH PRIVATE LIMITED',
    'CONCORD ONE TECHNOLOGIES PRIVATE LIMITED',
    'COMM100 PRIVATE LIMITED',
    'AFZET TECHNOLOGY PRIVATE LIMITED',
    'MICHEZO SPORTS INFRASTRUCTURE PRIVATE LIMITED',
    'PAGO ANALYTICS INDIA PRIVATE LIMITED',
    'INNO VALLEY WORKS PRIVATE LIMITED',
    'MULTIFIT EXERCISE SCIENCE ACADEMY PRIVATE LIMITED',
    'YARA INTERNATIONAL PRIVATE LIMITED',
    'GENRUI BIOTECH INDIA PRIVATE LIMITED',
    'BLUBELL SYSTECH PRIVATE LIMITED',
    'CREEKINN HOLIDAYS WORLD PRIVATE LIMITED',
    'STCH INTEGRATED MARKETING SOLUTION PRIVATE LIMITED',
    'ERIDANUS SOLAR POWER PRIVATE LIMITED',
    'CLAP CURATORS PRIVATE LIMITED',
    'TANGIBLE ASSIST INDIA PRIVATE LIMITED',
    'IOCS PRIVATE LIMITED',
    'XTEN-AV INDIA PRIVATE LIMITED',
    'TALENTFORE SOLUTIONS PRIVATE LIMITED',
    'MILLOWSATYA SERVICES PRIVATE LIMITED',
    'CBL EXPORTS PRIVATE LIMITED',
    'COSMA CUTTING SOLUTIONS PRIVATE LIMITED',
    'SUNRAY PRODUCTS PRIVATE LIMITED',
    'GREATVISTAS INTERNET TECHNOLOGY PRIVATE LIMITED',
    'MTCH INDIA SERVICES PRIVATE LIMITED',
    'GIGFORCE PRIVATE LIMITED',
    'FINDEM TECHNOLOGIES PRIVATE LIMITED',
    'ANKURA TIRUPATHI HOSPITALS PRIVATE LIMITED',
    'SLASH21 SPORTS MANAGEMENT PRIVATE LIMITED',
    'CONVISION PRIVATE LIMITED',
    'GETHER EVENT TECH PRIVATE LIMITED',
    'JUSTPAANI TECH SOLUTIONS PRIVATE LIMITED',
    'GEEKYANTS ACADEMY PRIVATE LIMITED',
    'SIVALEEN FOUNDATION FOR DEVELOPED INDIA',
    'EVOLUTEIQ SOLUTIONS PRIVATE LIMITED',
    'CYBERSHIELD COMMUNITY PRIVATE LIMITED',
    'PMPS GLOBAL ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'INSONTIS TECHNOLOGIES PRIVATE LIMITED',
    'PSL RETAIL PRIVATE LIMITED',
    'SAARA MEDIATECH PRIVATE LIMITED',
    'FANTAIL TECHNOLOGIES PRIVATE LIMITED',
    'DBLUE TECHNOLOGIES PRIVATE LIMITED',
    'SALESCOM SERVICES PRIVATE LIMITED',
    'YOBOSHU PRIVATE LIMITED',
    'STUDIOLITE APPLICATIONS PRIVATE LIMITED',
    'EUROFINE INTERNATIONAL INDIA PRIVATE LIMITED',
    'MEGA SOURCE TECHNOLOGY INDIA PRIVATE LIMITED',
    'ALC SKICORP THERMOADHESIVES PRIVATE LIMITED',
    'VRL STEEL PRIVATE LIMITED',
    'KOTHARI ALLUMINIO PRIVATE LIMITED',
    'APUTURE INDIA PRIVATE LIMITED',
    'GARUDAASTRA AEROINVENTIVE SOLUTIONS PRIVATE LIMITED',
    'TAUGA PRIVATE LIMITED',
    'QUBIX MEDICARE PRIVATE LIMITED',
    'PLUANG TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SKB INFOCOM PRIVATE LIMITED',
    'BRIGHT DRIVE HCS PRIVATE LIMITED',
    'DGRAPH LABS INDIA PRIVATE LIMITED',
    'VISYSTA NETWORKS PRIVATE LIMITED',
    'TENZAI SYSTEMS PRIVATE LIMITED',
    'CREDITGO TECHNOLOGY PRIVATE LIMITED',
    'INTELLITIDE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CLOUDSCOUTS TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'TELESTREAM INDIA PRIVATE LIMITED',
    'NUVIASEMI INDIA PRIVATE LIMITED',
    'HAIN CELESTIAL INDIA PRIVATE LIMITED',
    'BRHASPATIM SOLUTIONS INDIA PRIVATE LIMITED',
    'NOVEMBER FIRST INDIA SERVICE CENTRE PRIVATE LIMITED',
    'EPITOME SUSTAINABLE ENERGY PRIVATE LIMITED',
    'NEXT PAGE IT SOLUTIONS PRIVATE LIMITED',
    'PERFORM DIGITAL PRIVATE LIMITED',
    'NUVENTIONS INDIA PRIVATE LIMITED',
    'ILP 3 INDIA 17 PRIVATE LIMITED',
    'GLOENTECH PRIVATE LIMITED',
    'GRUPPENT ENGINEERING & CONSTRUCTION PRIVATE LIMITED',
    'VSAN DEVELOPERS PRIVATE LIMITED',
    'TEAMWORK ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'ILP 3 INDIA 16 PRIVATE LIMITED',
    'ILP 3 INDIA 18 PRIVATE LIMITED',
    'WOOTZ METAL SOLUTIONS INDIA PRIVATE LIMITED',
    'XPER SOFTWARES PRIVATE LIMITED',
    'DVSUM INDIA PRIVATE LIMITED',
    'KUNDAN REFINERY PRIVATE LIMITED',
    'FRANKLY RETAIL PRIVATE LIMITED',
    'GOCON LOGISTICS PRIVATE LIMITED',
    'HARBOUR NETWORK TECHNOLOGY PRIVATE LIMITED',
    'INFOZIANT IT SOLUTIONS PRIVATE LIMITED',
    'VISHESH ANALYTICS PRIVATE LIMITED',
    'TECHMATIC SYSTEMS INDIA PRIVATE LIMITED',
    'AERONUVO TECH SOLUTIONS PRIVATE LIMITED',
    'HUPP TECHNOLOGIES PRIVATE LIMITED',
    'MDTLABS PBC INDIA PRIVATE LIMITED',
    'REACHMUCHHIGHER ACADEMICS FOUNDATION',
    'ADANI HYBRID ENERGY JAISALMER ONE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR TWO LIMITED',
    'DP CHOCOLATES PRIVATE LIMITED',
    'AXXELENT PHARMA SCIENCE PRIVATE LIMITED',
    'PIDILITE LITOKOL PRIVATE LIMITED',
    'ENRICH ENCAP PRIVATE LIMITED',
    'VIDHICON INDUSTRIES PRIVATE LIMITED',
    'SHAURYA ISPAT UDYOG PRIVATE LIMITED',
    'TOTALTOOLS METAL PRIVATE LIMITED',
    'VKBS ENGINEERING PRIVATE LIMITED',
    'CORPUP SPACES PRIVATE LIMITED',
    'AUTO MOTIVE POWER MOBILITY PRIVATE LIMITED',
    'DURACELL INDIA OPERATIONS PRIVATE LIMITED',
    'RATLAM ABHUSHAN PRIVATE LIMITED',
    'DBOX RECORD MANAGEMENT PRIVATE LIMITED',
    'DFL TECHNOLOGIES PRIVATE LIMITED',
    'DATAFOUNDRY ARNAVA PRIVATE LIMITED',
    'KCHN MANAGEMENT SERVICES PRIVATE LIMITED',
    'ISRINGHAUSEN ENGINEERING PRIVATE LIMITED',
    'UVR NATURAL FOODS PRIVATE LIMITED',
    'S AGRI TECH PRIVATE LIMITED',
    'SNEHADAAN FOUNDATION',
    'VAKRATUND BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'AMP ENERGY GREEN FIVE PRIVATE LIMITED',
    'CLYDE INDUSTRIES INDIA PRIVATE LIMITED',
    'LAKSHMI FARMACHEM PRIVATE LIMITED',
    'BHAIYA INFRA PRIVATE LIMITED',
    'EXCELLENCIA INFRA PRIVATE LIMITED',
    'ANAND MOTOREN PRIVATE LIMITED',
    'WITNIP TECHNOLOGIES PRIVATE LIMITED',
    'TKG INFRASTRUCTURES PRIVATE LIMITED',
    'EITRI STUDIO PRIVATE LIMITED',
    'SINGH WHEELS INDIA PRIVATE LIMITED',
    'EFF N BEE MARKETING PRIVATE LIMITED',
    'ALTENER SOLUTIONS (OPC) PRIVATE LIMITED',
    'DANAIRE HVAC PRIVATE LIMITED',
    'TRANSFORM SCITECH PRIVATE LIMITED',
    'AJE NICEDELHI PRIVATE LIMITED',
    'METRO HI-TECH STEEL PRIVATE LIMITED',
    'THRIVENI SAINIK PBNW PRIVATE LIMITED',
    'ETECHIND PRIVATE LIMITED',
    'YL DESIGN PRIVATE LIMITED',
    'MATRIX FUSIONTECH PRIVATE LIMITED',
    'CREDENCE TUBES PRIVATE LIMITED',
    'REMOTE FINANCE TEAM PRIVATE LIMITED',
    'JOBSLOTS CONSULTING INDIA PRIVATE LIMITED',
    'SUSTAINABLE ADVANCED PLASTIC PRIVATE LIMITED',
    'PRO MIDAS PRIVATE LIMITED',
    'RV EXPORTS PRIVATE LIMITED',
    'AARREE DEVELOPERS PRIVATE LIMITED',
    'FLOSOL ENGINEERING PRIVATE LIMITED',
    'MATDUN LABS INDIA PRIVATE LIMITED',
    'ZILLIOBIT DIGITAL PRIVATE LIMITED',
    'SIRIUS STAR ENTERPRISE TECHNOLOGIES PRIVATE LIMITED',
    'AMP ENERGY GREEN THREE PRIVATE LIMITED',
    'BDA INDUSTRIAL RESOURCES PRIVATE LIMITED',
    'SUNNOVATIVE SOLAR ENERGY SOLUTION PRIVATE LIMITED',
    'ADANI SOLAR ENERGY BARMER ONE PRIVATE LIMITED',
    'HOME FARMING SOLUTIONS PRIVATE LIMITED',
    'VKARE INFORMATICS PRIVATE LIMITED',
    'VOLTY CONNECTORS & CABLES PRIVATE LIMITED',
    'PEOPLE FIN CONSULTING PRIVATE LIMITED',
    'AVERTA STRATEGY PRIVATE LIMITED',
    'ANAHEIM PROPERTIES PRIVATE LIMITED',
    'JLN ENGINEERING SERVICES PRIVATE LIMITED',
    'VISDUM TECH PRIVATE LIMITED',
    'IRONY BUSINESS SERVICES PRIVATE LIMITED',
    'VICTORA AUTOMOTIVE PRIVATE LIMITED',
    'ODMS PRIVATE LIMITED',
    'VTRO MOTORS PRIVATE LIMITED',
    'PROMAINTAIN SERVICES PRIVATE LIMITED',
    'MERAKI IDEALABS PRIVATE LIMITED',
    'BOOK MY LEARN PRIVATE LIMITED',
    'TARAMSYS PRIVATE LIMITED',
    'ABBAKKA ENGINEERING PRIVATE LIMITED',
    'GETL SOCIAL FOUNDATION',
    'BHUVANAM ESTATE PRIVATE LIMITED',
    'PROCESS COMBUSTION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'XELIUM RETAIL PRIVATE LIMITED',
    'PALLAVI SHIVA SOFTWARE SOLUTIONS PRIVATELIMITED',
    'KASTURI ENTERPRISE AND SERVICES PRIVATE LIMITED',
    'VSC FEDERATION FOR EMPLOYEES EMPOWERMENTLAWS',
    'FRETRON PRIVATE LIMITED',
    'KAVANAL ENTERPRISES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JODHPUR SIX PRIVATE LIMITED',
    'INFORIZON CORPORATE SERVICES PRIVATE LIMITED',
    'LEGAL O2 PRIVATE LIMITED',
    'HEWPACK INDIA PRIVATE LIMITED',
    'SLRI SOLUTIONS PRIVATE LIMITED',
    'SUNGWOO HITECH AP PRIVATE LIMITED',
    'IITD-AIA FOUNDATION FOR SMART MANUFACTURING',
    'SHRED CREATIVE LAB PRIVATE LIMITED',
    'WALLET INSURANCE BROKING PRIVATE LIMITED',
    'WONDER HOME FINANCE LIMITED',
    'FLOOD CONTROL INTERNATIONAL (INDIA) PRIVATE LIMITED',
    'AMARAVATI MEDICARE PRIVATE LIMITED',
    'VINSPIRE TRAINING & CONSULTANCY SERVICESPRIVATE LIMITED',
    'JHAKAAS RETAIL PRIVATE LIMITED',
    'FINEOS INDIA PRIVATE LIMITED',
    'SUNBULLS FUTURE ENERGIES PRIVATE LIMITED',
    'JAI AMMUNITION LIMITED',
    'VERDUROUS ENERGY INDIA PRIVATE LIMITED',
    'AISHANI TEXTILES PRIVATE LIMITED',
    'TPPL MP JOINT VENTURE PRIVATE LIMITED',
    'BLUECOLLAR DISTRIBUTORS AND WHOLESALERS PRIVATE LIMITED',
    'PAPTRONICS PRIVATE LIMITED',
    'VEAMA MEDICARE INDIA PRIVATE LIMITED',
    'ANIKET AMENITIES PRIVATE LIMITED',
    'DOMAIN 6 GTSC PRIVATE LIMITED',
    'REVERE INFO APP PRIVATE LIMITED',
    'AURUM WORKFORCE SOLUTIONS PRIVATE LIMITED',
    'SELENITE HOUSING PRIVATE LIMITED',
    'CSD STUDIOS PRIVATE LIMITED',
    'DCS INTERNET SERVICES PRIVATE LIMITED',
    'GIRIDHARI CONSTRUCTIONS PRIVATE LIMITED',
    'FUTURELIGHT TECHNOLOGIES PRIVATE LIMITED',
    'ZYPE DIGITAL PRIVATE LIMITED',
    'DWRESEARCH & COMMUNICATION PRIVATE LIMITED',
    'NAVINA HOTEL PRIVATE LIMITED',
    'AAVAS FINSERV LIMITED',
    'FUTSTART EXPERIENCE PRIVATE LIMITED',
    'PLANETARY ACCOUNTING & MARKETING PRIVATELIMITED',
    'STANRA TECH SOLUTIONS PRIVATE LIMITED',
    'SL VEGGIES INDIA PRIVATE LIMITED',
    'AOM ADVERTISING PRIVATE LIMITED',
    'MINDSOFT INNOVATIONS PRIVATE LIMITED',
    'SAHOO WEBSOLUTIONS PRIVATE LIMITED',
    'ASHWA INTERNET SERVICES PRIVATE LIMITED',
    'INNOSTACK HEXA SOLUTIONS PRIVATE LIMITED',
    'VANMARK FOOD EQUIPMENT (INDIA) PRIVATE LIMITED',
    'SIMS INSTITUTES FOR MEDICAL SCIENCE PRIVATE LIMITED',
    'IBAAD LINES PRIVATE LIMITED',
    'PEPE JEANS INNERFASHION PRIVATE LIMITED',
    'KONZEPTS DATA INNOVATION LABS PRIVATE LIMITED',
    'AMBASSADOR CONSULTING SERVICES PRIVATE LIMITED',
    'WESFA RESOURCE PRIVATE LIMITED',
    'SANWARIA AUTOMOBILE PRIVATE LIMITED',
    'INI INTERNATIONAL TRADING PRIVATE LIMITED',
    'ENERCON WINDENERGY PRIVATE LIMITED',
    'HARDIP DEVELOPERS PRIVATE LIMITED',
    'POWERED FNB PRIVATE LIMITED',
    'BANZAI SOLUTIONS PRIVATE LIMITED',
    'PYX TECH PRIVATE LIMITED',
    'VERVAIN MANAGEMENT PRIVATE LIMITED',
    'JODHPUR PRESIDENCY CLUB PRIVATE LIMITED',
    'KLIENTO TECHNOLOGIES PRIVATE LIMITED',
    'NUPA TECHNOLOGIES PRIVATE LIMITED',
    'TERRATECH INFRA INDIA PRIVATE LIMITED',
    'AIC-PINNACLE ENTREPRENEURSHIP FORUM',
    'BRISC BUSINESS VENTURES PRIVATE LIMITED',
    'S. J. BANQUET PRIVATE LIMITED',
    'ONIRO DIGITAL PRIVATE LIMITED',
    'LOGICSKILLS FOUNDATION',
    'LATENT HEAT2COMFORT TECHNOLOGIES PRIVATELIMITED',
    'CRAYONS HOSPITAL PRIVATE LIMITED',
    'TIVA LIFE PRODUCTS PRIVATE LIMITED',
    'SAGOUS SOFTWARE AND SERVICES PRIVATE LIMITED',
    'AJABA AEROBOTICS PRIVATE LIMITED',
    'TRESTLE LABS PRIVATE LIMITED',
    'ALCHEMIE COMMERCE PRIVATE LIMITED',
    'MERAKI HEALTHCARE PRIVATE LIMITED',
    'SBTSMS PRIVATE LIMITED',
    'EMERGANCE EXIM INDIA PRIVATE LIMITED',
    'WIZARDO EXHIBITION AND INTERIOR DESIGN PRIVATE LIMITED',
    'PTP LOGISTICS PRIVATE LIMITED',
    'ASNM CARE PRIVATE LIMITED',
    'BVG ELECTRONICS (INDIA) PRIVATE LIMITED',
    'KSS SUBSEA INDIA PRIVATE LIMITED',
    'BURGEON INDUSTRIES PRIVATE LIMITED',
    'CRAFFI THEKARIGAR PRIVATE LIMITED',
    'LINDER STRAPPING INDIA PRIVATE LIMITED',
    'MORE ORGO PRIVATE LIMITED',
    'AGRI GATE PRIVATE LIMITED',
    'DONUM INFRALAND PRIVATE LIMITED',
    'CALCRAFT CONSTRUCTIONS PRIVATE LIMITED',
    'GREENVENT ACOUSTIC PRIVATE LIMITED',
    'ARYAN WOOD PRODUCTS PRIVATE LIMITED',
    'AVAADA CLEAN SUSTAINABLE ENERGY PRIVATE LIMITED',
    'CROZIL LIFE SCIENCES (OPC) PRIVATE LIMITED',
    'EXPONUS VISA & PASSPORT SERVICES PRIVATELIMITED',
    'JHTC HYDROTECH PRIVATE LIMITED',
    'AARJAY WEBS & MEDIA CONSULTANCY (OPC) PRIVATE LIMITED',
    'INTERCRAFTS FRAGRANCE PRIVATE LIMITED',
    'SIRA SEEDS PRIVATE LIMITED',
    'SKYLLER CARGO LOGISTICS INDIA PRIVATE LIMITED',
    'PROVEST CHITS PRIVATE LIMITED',
    'SINDHUJA MICROCREDIT PRIVATE LIMITED',
    'HHN SERVICES PRIVATE LIMITED',
    'SLYDEX IMPEX (INDIA) PRIVATE LIMITED',
    'HIARYA AUTOMATION PRIVATE LIMITED',
    'WASTE TO ART PRIVATE LIMITED',
    'BOUDHIK VENTURES PRIVATE LIMITED',
    'EMBEDDED DIGITAL SOLUTION INDIA PRIVATE LIMITED',
    'PUREGLAM SKIN CARE PRIVATE LIMITED',
    'NEUROMORPHIC MACHINES PRIVATE LIMITED',
    'HUNDEKAR ADVISORY SERVICES (OPC) PRIVATELIMITED',
    'SALVATION MEDIA LIMITED',
    'BELLSPIRE VIRTUAL ART PRIVATE LIMITED',
    'FIDENSGEN BUSINESS SOLUTIONS PRIVATE LIMITED',
    'YG RESEARCH INDIA PRIVATE LIMITED',
    'AARANA LED LIGHTS PRIVATE LIMITED',
    'ALSISAR IMPACT PRIVATE LIMITED',
    'DOBBY AUTOMATIONS PRIVATE LIMITED',
    'SPERO PROPERTIES AND SERVICES PRIVATE LIMITED',
    'NIPA PANI PRIVATE LIMITED',
    'AETAS VENTURES PRIVATE LIMITED',
    'SPACE EDUCOM AND VISA SERVICES PRIVATE LIMITED',
    'VCORP TECHNOLOGIES PRIVATE LIMITED',
    'RUMAH DESIGN PRIVATE LIMITED',
    'MAFWIL DIGITAL SERVICES PRIVATE LIMITED',
    'DIJIFFY SOLUTIONS PRIVATE LIMITED',
    'MXSII TECH PRIVATE LIMITED',
    'SUCCESS FORMULA 1 CONSULTING PRIVATE LIMITED',
    'ADIYOGI EXPLORE WATERSPORTS PRIVATE LIMITED',
    'YUJ SPIRITUAL FOUNDATION',
    'ALLSAFE TECHNOLOGIES PRIVATE LIMITED',
    'MOTOHOM PRIVATE LIMITED',
    'CTOB SOLUTIONS PRIVATE LIMITED',
    'VIOLET AURA PRIVATE LIMITED',
    'GROWBOOST TECHNO PRIVATE LIMITED',
    'PGF TECHSPACE PRIVATE LIMITED',
    'GRITSTONE ENGIKOMP PRIVATE LIMITED',
    'BOGANVILLA FURNISHING PRIVATE LIMITED',
    'VSV RENEWABLES PRIVATE LIMITED',
    'VICINITY BUILDCON PRIVATE LIMITED',
    'DREAMS BIKES & MACHINES PRIVATE LIMITED',
    'VITTIS WELLNESS INDIA LIMITED',
    'KSU AVIATION PRIVATE LIMITED',
    'KIAAYO ENTERPRISES PRIVATE LIMITED',
    'BAGHIRATHI SUSTAINABILITY INDIA PRIVATE LIMITED',
    'PERMAN AUTO CONCEPTS PRIVATE LIMITED',
    'ZE3 RENEWABLE ENERGY PRIVATE LIMITED',
    'PML REALTORS PRIVATE LIMITED',
    'NAVKUL BUILDCON PRIVATE LIMITED',
    'ZINFOG CODELABS PRIVATE LIMITED',
    'NESL E-INFRASTRUCTURE LIMITED',
    'VIRTU INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'BLOCKSTEIN PRIVATE LIMITED',
    'HEYMOJO AI LABS PRIVATE LIMITED',
    'KONFINITY INFOTECH PRIVATE LIMITED',
    'WHITEPHLOX CARE PRIVATE LIMITED',
    'CODIUM TECHLABS PRIVATE LIMITED',
    'RMADE TECHNOLOGIES PRIVATE LIMITED',
    'SAINALYTICS CLINICAL RESEARCH SOLUTIONS PRIVATE LIMITED',
    'KHAPSIKANA SOLAR PRIVATE LIMITED',
    'QUALITY HYGIENE SOLUTIONS PRIVATE LIMITED',
    'FIBRSOL GLOBAL NETWORK LIMITED',
    'SWIFT LUBRICANTS PRIVATE LIMITED',
    'FRANTEL BIZ SERVICES PRIVATE LIMITED',
    'GIFKARO PLATFORM PRIVATE LIMITED',
    'VIRMATI TECHNOLOGIES LIMITED',
    'AVISH TRENDS PRIVATE LIMITED',
    'NTK INDIA HYDRAULIC COMPONENTS PRIVATE LIMITED',
    'SUGAVYA DAIRY FARMS PRIVATE LIMITED',
    'ABHISHTA SOLAR PRIVATE LIMITED',
    'GREENPANEL INDUSTRIES LIMITED',
    'IH&MS INFRA INDIA PRIVATE LIMITED',
    'JAQK HOLIDAYS PRIVATE LIMITED',
    'BIP INDIA INFRA PROJECTS MANAGEMENT SERVICES PRIVATE LIMITED',
    'CMES POWER 2 PRIVATE LIMITED',
    'CANOPUS DATA INSIGHTS PRIVATE LIMITED',
    'SPIDERNINE TECHNOLOGIES LIMITED',
    'EXCEAM INDIA BRANCH PRIVATE LIMITED',
    'TDL REAL ESTATE HOLDINGS LIMITED',
    'KNY HOTELS SERVICES PRIVATE LIMITED',
    'DVARA SOLUTIONS PRIVATE LIMITED',
    'GSE SUPPORT INDIA PRIVATE LIMITED',
    'MIRAJ MIRACLE PRIVATE LIMITED',
    'SWF SUNSTAR INDIA PRIVATE LIMITED',
    'LIL-BRAHMAS CREATIVE EDUCATIONS PRIVATE LIMITED',
    'GHATFRESH PRIVATE LIMITED',
    'LEHUI FINNAH INDIA ENGINEERING & EQUIPMENT PRIVATE LIMITED',
    'KUNDANA TECHNO TEX PRIVATE LIMITED',
    'VERIZON PHARMACEUTICAL PRIVATE LIMITED',
    'RASSS TECH FARMS PRIVATE LIMITED',
    'DECAL TECH PRIVATE LIMITED',
    'MAGWEN VALVES PRIVATE LIMITED',
    'ECHOMAX MINERALS PRIVATE LIMITED',
    'PROSPITIOUS TECHNOLOGIES PRIVATE LIMITED',
    'COGNATE GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'BUFFRR FILM PRODUCTIONS PRIVATE LIMITED',
    'JKM VENTURES PRIVATE LIMITED',
    'ORLANDO VALVES AND COMPONENTS PRIVATE LIMITED',
    'EAP ELECTRO ALLIED PRODUCTS PRIVATE LIMITED',
    'ARROW TOOLS PRIVATE LIMITED',
    'INCREDIBLE JOBS PRIVATE LIMITED',
    'FOUR EF RENEWABLES PRIVATE LIMITED',
    'CAMION AUTOMOBILES PRIVATE LIMITED',
    'CRYOCOOL TECHNOLOGIES PRIVATE LIMITED',
    'ELSE ELEMENTS (OPC) PRIVATE LIMITED',
    'NAMMA INTERIORS PRIVATE LIMITED',
    'COTSWOLD SEA PRIVATE LIMITED',
    'WESOURCE FURNITURE & INTERIOR PRODUCTS PRIVATE LIMITED',
    'ANIRUTHK INFRASTRUCTURE PRIVATE LIMITED',
    'FORMOED WIDE SPAN STRUCTURE PRIVATE LIMITED',
    'OMSTER STORAGE PRIVATE LIMITED',
    'WIZARD TUBE & ENGINEERED COMPONENTS PRIVATE LIMITED',
    'SOFAAB DESIGNS AND FURNISHING PRIVATE LIMITED',
    'EVERGREEN MAHUVA WINDFARMS PRIVATE LIMITED',
    'KALLAPALLI WIND DEVELOPMENT LIMITED',
    'WIND WORLD (PUDUKKOTTAI) LIMITED',
    'TEMPEST WIND ENERGY PRIVATE LIMITED',
    'VUELTA WIND ENERGY PRIVATE LIMITED',
    'PAJAPATTI RENEW ENERGY LIMITED',
    'MAVADI RENEWABLE POWER LIMITED',
    'WIND WORLD (TIRUCHIRAPALLI) LIMITED',
    'VSV SOLAR PRIVATE LIMITED',
    'PALLADUM POWER DEVELOPMENT LIMITED',
    'NAGARPATTINAM WIND DEVELOPMENT LIMITED',
    'SUN SOL INFINITY PRIVATE LIMITED',
    'MYTRAH VAYU (BRAHMANI) PRIVATE LIMITED',
    'HELIOUS SPECIALTY GASES PRIVATE LIMITED',
    'FLURRY WIND ENERGY PRIVATE LIMITED',
    'MBS WIND ENERGY PRIVATE LIMITED',
    'SPRNG SOLAR PLUS PRIVATE LIMITED',
    'ARCIS CLEAN ENERGY PRIVATE LIMITED',
    'ALIENTO WIND ENERGY PRIVATE LIMITED',
    'FLUTTER WIND ENERGY PRIVATE LIMITED',
    'TIRUNELVELI RENEW POWER LIMITED',
    'VIRUDHANAGAR POWER ENERGY LIMITED',
    'SUBHRAHPURAM ENERGY LIMITED',
    'SUNIBOAT TECHNOLOGIES PRIVATE LIMITED',
    'MYTRAH VAYU (BRAHMAPUTRA) PRIVATE LIMITED',
    'ALUNGAL DEVELOPERS PRIVATE LIMITED',
    'NIPUN MASONRY WORKS PRIVATE LIMITED',
    'ALUNGAL PROJECTS PRIVATE LIMITED',
    'THANE CREEK BRIDGE INFRASTRUCTURE LIMITED',
    'KRISHNACORP LIMITED',
    'SADBHAV JODHPUR RING ROAD PRIVATE LIMITED',
    'GRUHAM DEVELOPERS PRIVATE LIMITED',
    'MANDARMANI CONSTRUCTIONS PRIVATE LIMITED',
    'APG ABODE HOMES PRIVATE LIMITED',
    'BEARER BUILDERS INDIA PRIVATE LIMITED',
    'ALUNGAL PROPERTIES PRIVATE LIMITED',
    'PALLANTIUM INFRA TECH PRIVATE LIMITED',
    'DE REALTY AND ENGINEERING PRIVATE LIMITED',
    'ADIKYA INFRASTRUCTURES PRIVATE LIMITED',
    'ANTALYA FRAMEWORK PRIVATE LIMITED',
    'RAYA INFRA BUILDCON PRIVATE LIMITED',
    'HORMIGON ENGINEERING AND INFRA PRIVATE LIMITED',
    'LUXEBUILT HOMES PRIVATE LIMITED',
    'RAQ INFRA PRIVATE LIMITED',
    'TELSA CONSTRUCTION (OPC) PRIVATE LIMITED',
    'REPA INDUSTRIES PRIVATE LIMITED',
    'SUPREME INFRACON INDUSTRIES PRIVATE LIMITED',
    'PIRAISIA HOMES (OPC) PRIVATE LIMITED',
    'BUDHWAMAHADEV HYTECH PRIVATE LIMITED',
    'SARK INFRA ESTATES PRIVATE LIMITED',
    'DHANDU INFRASTRUCTURE PRIVATE LIMITED',
    'PRSSB INFRABUILD PRIVATE LIMITED',
    'ATOM CRAFTS PRIVATE LIMITED',
    'HYNDAVA PROJECTS PRIVATE LIMITED',
    'MISHRIF TRADING PRIVATE LIMITED',
    'DMR MOTORS PRIVATE LIMITED',
    'PAX POS SOLUTIONS INDIA PRIVATE LIMITED',
    'SHREEJAY ATTIRE PRIVATE LIMITED',
    'GOABAY TRADING PRIVATE LIMITED',
    'GREENPILL INFRA PROJECT PRIVATE LIMITED',
    'GLYRA HEALTHCARE PRIVATE LIMITED',
    'INFINION BIOPHARMA LIMITED',
    'PORTLINE TRADE PRIVATE LIMITED',
    'DEEKSHA ANALYTICAL PRIVATE LIMITED',
    'FNBNEEDS FOODS PRIVATE LIMITED',
    'KK ALLIANCE INDIA PRIVATE LIMITED',
    'KUBERIAN INDIA PRIVATE LIMITED',
    'HILUXE GIFTS PRIVATE LIMITED',
    'AGNA ORG AGROVILLA (INDIA) PRIVATE LIMITED',
    'HORTIFRUT IG BERRIES PRIVATE LIMITED',
    'HIGHLAND HEALTH SOLUTIONS PRIVATE LIMITED',
    'WAHLEN TECH PRIVATE LIMITED',
    'RANJITH ANISH AGASTYA MALLIKA (RAAM) PRODUCTS PRIVATE LIMITED',
    'AELAN MOBILES PRIVATE LIMITED',
    'KNIPEX TOOLS INDIA PRIVATE LIMITED',
    'NEVAAN PROGRESSIVE PRIVATE LIMITED',
    'POMIGA EXIM PRIVATE LIMITED',
    'JVA INDUSTRIES PRIVATE LIMITED',
    'VITROKITS PRIVATE LIMITED',
    'MIJIE TECHNOLOGY ELECTRONICS PRIVATE LIMITED',
    'VAULTX INTERNATIONAL (OPC) PRIVATE LIMITED',
    'POPSKOPE INTERNATIONAL PRIVATE LIMITED',
    'AADYA GARMENTS PRIVATE LIMITED',
    'WOOMAYA ONLINE SHOPPING PRIVATE LIMITED',
    'ARYA GROCERY AND DAILY NEEDS SERVICES (OPC) PRIVATE LIMITED',
    'UNIVIN CONSUMER PRODUCTS PRIVATE LIMITED',
    'OMKAR FIREWISE PRIVATE LIMITED',
    'SRI ARSHIT SOLUTIONS PRIVATE LIMITED',
    'CERASUS HANDICRAFTS PRIVATE LIMITED',
    'ALENTO HOTEL PRIVATE LIMITED',
    'ASHDAN HOTEL MANAGEMENT PRIVATE LIMITED',
    'NOMA HOTELS PRIVATE LIMITED',
    'STAR INN SUITES AND RETREAT LIMITED',
    'UNILINK EDUCATION PRIVATE LIMITED',
    'VIVTRA CONSULTING SERVICES PRIVATE LIMITED',
    'IGNIFY TELECOM SERVICES & ENGINEERING PRIVATE LIMITED',
    'BEEKAY SUPPLYCHAIN SOLUTIONS PRIVATE LIMITED',
    'DISCNDRUM PRIVATE LIMITED',
    'SVOD GURU (INDIA) PRIVATE LIMITED',
    'A&H HOSPITALITY PRIVATE LIMITED',
    'CIJ TECHNOLOGIES PRIVATE LIMITED',
    'V-CUBE INDIA PRIVATE LIMITED',
    'KHERDA RENAISSANCE FOUNDATION',
    'SAANWARIYA ELECTRICALS PRIVATE LIMITED',
    'ALICE MANAGEMENT EDUCATION PRIVATE LIMITED',
    'TEKSAIN SERVICES PRIVATE LIMITED',
    'ESTAR DE MODA LIFESTYLE (OPC) PRIVATE LIMITED',
    'TATA STEEL BUSINESS DELIVERY CENTRE LIMITED',
    'MAHTO FRUITS PRIVATE LIMITED',
    'EXELIENT DIGILEARN PRIVATE LIMITED',
    'SHARAD-SUMAN FOUNDATION',
    'NIMBU MIRCHI NIMBU AD FLICKS PRIVATE LIMITED',
    'HARIMITTI AGRO PRIVATE LIMITED',
    'TRANZSILICA SYSTEMS PRIVATE LIMITED',
    'DIUS BRAND HOLDINGS PRIVATE LIMITED',
    'SPECTACULAR BUSINESS TRANSFORMATION PRIVATE LIMITED OPC',
    'EDAPPADI TALUK DYEING & BLEACHING CLUSTER',
    'SIDDHIKA CAREER PRIVATE LIMITED',
    'EASE VENTURE PRIVATE LIMITED',
    'SAI CAD EDIFICATION PRIVATE LIMITED',
    'MODO EDULABS PRIVATE LIMITED',
    'RHOCENT CONSULTING PRIVATE LIMITED',
    'S.R.OPEN LIBRARY PROJECT FOUNDATION',
    'SHANKET LEARNING SOLUTIONS PRIVATE LIMITED',
    'GOODMORE MARKETING PRIVATE LIMITED',
    'ARRIVER CLASSES PRIVATE LIMITED',
    'WHOLENESS INFIRMARY PRIVATE LIMITED',
    'STARCARE HOSPITAL KANNUR PRIVATE LIMITED',
    'SPEEDOTRACK GPS (OPC) PRIVATE LIMITED',
    'MIRAE ASSET FOUNDATION',
    'PROVIDENCE SHIP MANAGEMENT (INDIA) PRIVATE LIMITED',
    'FRILL ASSETS INDIA PRIVATE LIMITED',
    'AJS HOSPITAL PRIVATE LIMITED',
    'TORSO FITNESS INDIA PRIVATE LIMITED',
    'RANGSONS HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'SOCIAL CAPITALISM FOUNDATION',
    'SAYOMA EDUCATIONAL AND WELFARE FOUNDATION',
    'INNOVATIVE ONCOLOGY NETWORK PRIVATE LIMITED',
    'ELEVATE GLOBAL TRAINING SOLUTIONS (OPC) PRIVATE LIMITED',
    'KPS ENVIRO TECH PRIVATE LIMITED',
    'OBG OUTSOURCING PRIVATE LIMITED',
    'APOOVAS ADVISEMENT SERVICES PRIVATE LIMITED',
    'HRD IMMIGRATION VISA AND TRAVEL PRIVATE LIMITED',
    'TALENTEL PLATFORMS PRIVATE LIMITED',
    'ALPS LOGISTICS INDIA PRIVATE LIMITED',
    'ASSYST INTERNATIONAL PRIVATE LIMITED',
    'PROTECTRON ELECTROMECH PRIVATE LIMITED',
    'IGUS (INDIA) PRIVATE LIMITED',
    'SHANKARANARAYANA CONSTRUCTIONS PRIVATE LIMITED',
    'EAST INDIA PETROLEUM PRIVATE LIMITED',
    'ESAB INDIA LIMITED',
    'ASPIRE SYSTEMS (INDIA) PRIVATE LIMITED',
    'APACHE FOOTWEAR INDIA PVT LTD',
    'SAME DEUTZ-FAHR INDIA PRIVATE LIMITED',
    'DEVI SEA FOODS LIMITED',
    'HERBALIFE INTERNATIONAL INDIA PRIVATE LIMITED',
    'AVANTI FEEDS LIMITED',
    'FEROKE BOARDS LIMITED',
    'MALIK LIFESCIENCES PRIVATE LIMITED',
    'PANTAO HUMAN SERVICES PRIVATE LIMITED',
    'SIGNITIVE TECHNOLOGIES PRIVATE LIMITED',
    'REGENCY EXPORTS PRIVATE LIMITED',
    'R.R. SPORTS WEAR PRIVATE LIMITED',
    'JBF INDUSTRIES LIMITED',
    'EXECUTRIX ADVISORSHIP PRIVATE LIMITED',
    'YANSHVAR EMONISIS CONSULTATORY PRIVATE LIMITED',
    'BSH CONSULTANCY PRIVATE LIMITED',
    'GANYT ECOMMERCE SOLUTIONS PRIVATE LIMITED',
    'STRACON OUTSOURCING SERVICES PRIVATE LIMITED',
    'QUTONE FOUNDATION',
    'R. K. GLOBAL HEALTHWINGS PRIVATE LIMITED',
    'KANARI NUTRITION PRIVATE LIMITED',
    'SUNDAY RETAIL PRIVATE LIMITED',
    'I-SHARE FOUNDATION',
    'DOCTOR SRAMS MEDICAL CODING AND BILLING ACADEMY (OPC) PRIVATE LIMITED',
    'SEQMED LIFESCIENCES PRIVATE LIMITED',
    'AYAM STUDIOS PRIVATE LIMITED',
    'AAVAS CONSULTANTS (OPC) PRIVATE LIMITED',
    'SPIKY EDUCOM PRIVATE LIMITED',
    'UNIVERSAL FLEXIBLES PRIVATE LIMITED',
    'GOVE FINANCE LIMITED',
    'FOCUS COMPUTERS PRIVATE LIMITED',
    'FALCON AGENCIES PRIVATE LIMITED',
    'SRI VISHNU GRANITES PRIVATE LIMITED',
    'NADIADWALA GRANDSON FOUNDATION',
    'MOBIKODE SOFTWARE PRIVATE LIMITED',
    'VIVEK PRIVATE LIMITED',
    'VKHVAC SYSTEMS SERVICES PRIVATE LIMITED',
    'VIVID OPEN ACCESS PRIVATE LIMITED',
    'VIJNATA PRIVATE LIMITED',
    'VENTANA STUDIOS PRIVATE LIMITED',
    'VARAVASTRA INDIA PRIVATE LIMITED',
    'TOSALL INDIA PRIVATE LIMITED',
    'DAAEMI FILMS PRIVATE LIMITED',
    'CYGILANT (INDIA) RESEARCH AND DEVELOPMENT PRIVATE LIMITED',
    'HSENID MOBILE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'AVAADA CLEAN PROJECT PRIVATE LIMITED',
    'ACME HUKKERI SOLAR ENERGY PRIVATE LIMITED',
    'SAMRITHI WHEELS PRIVATE LIMITED',
    'E-ASHWA AUTOMOTIVE PRIVATE LIMITED',
    'GRG SMART VEHICLE PRIVATE LIMITED',
    'NAPINO CONTINENTAL VEHICLE ELECTRONICS PRIVATE LIMITED',
    'SATVA COATINGS PRIVATE LIMITED',
    'MAHAJANCONVEYOR PRIVATE LIMITED',
    'IZRA SOLAR ENERGY PRIVATE LIMITED',
    'ZORYA SOLAR ENERGY PRIVATE LIMITED',
    'NOKOR BHOOMI PRIVATE LIMITED',
    'RENEW TRANSMISSION VENTURES PRIVATE LIMITED',
    'YALA SOLAR PRIVATE LIMITED',
    'EKIALDE SUN ENERGY PRIVATE LIMITED',
    'ACME GULEDAGUDDA SOLAR ENERGY PRIVATE LIMITED',
    'ACME SANDUR SOLAR ENERGY PRIVATE LIMITED',
    'GREA ROOF INDUSTRIES PRIVATE LIMITED',
    'RELIANCE VELOCITY LIMITED',
    'PHOENIX TECH SPACE INDIA PRIVATE LIMITED',
    'SHRITIRUMALA INFRACON DEVELOPERS PRIVATELIMITED',
    'TENORIS INDIA PRIVATE LIMITED',
    'TECHNO TOYS PRIVATE LIMITED',
    'OUTMATCH PRIVATE LIMITED',
    'SILVERCORD HOME FURNISHING PRIVATE LIMITED',
    'ARIST SATKARA PRIVATE LIMITED',
    'TWM MALLET PRIVATE LIMITED',
    'ABERDARE TECHNOLOGIES PRIVATE LIMITED',
    '23 AND HALF DEGREE FURNITURE & INTERIOR PRODUCTS PRIVATE LIMITED',
    'VATAN HOUSING PRIVATE LIMITED',
    'STONESTEEL PREFAB INFRA PRIVATE LIMITED',
    'ADYAH SOLAR ENERGY PRIVATE LIMITED',
    'SINGAIAVS PRIVATE LIMITED',
    'PHOENIX FINANCIAL DISTRICT PRIVATE LIMITED',
    'INCOR PATANCHERU HEIGHTS PRIVATE LIMITED',
    'PHOENIX SOFT SPACE INDIA PRIVATE LIMITED',
    'PHOENIX INFOBUILD INDIA PRIVATE LIMITED',
    'MARINESCAPE INDIA PRIVATE LIMITED',
    'VIVASVAT SOLAR ENERGY PRIVATE LIMITED',
    'ABHA SUNLIGHT PRIVATE LIMITED',
    'ACME KUDLIGI SOLAR ENERGY PRIVATE LIMITED',
    'ACME KITTUR SOLAR ENERGY PRIVATE LIMITED',
    'ACME SIDLAGHATTA SOLAR ENERGY PRIVATE LIMITED',
    'CANDES ENERGY SOLUTIONS PRIVATE LIMITED',
    'KNOWLEDGE SQUARE PARKS & INCUBATORS PRIVATE LIMITED',
    'KR MOTORS KOLHAPUR PRIVATE LIMITED',
    'TVS MOBILITY PRIVATE LIMITED',
    'GROUND ECA3G PRIVATE LIMITED',
    'AKHILAGYA SOLAR ENERGY PRIVATE LIMITED',
    'NIRJARA SOLAR ENERGY & POWER PRIVATE LIMITED',
    'TECHNOSPHERE ENGINEERING PRIVATE LIMITED',
    'TENSAI INFRA POWER PRIVATE LIMITED',
    'CCFG INDIA PRIVATE LIMITED',
    'NCP COMMERCIALS PRIVATE LIMITED',
    'KAMLAPUNJ PROPERTIES AND HOSPITALITY PRIVATE LIMITED',
    'TRINEVA INFRA PROJECTS PRIVATE LIMITED',
    'SPMLIL-AMRUTHA CONSTRUCTIONS PRIVATE LIMITED',
    'VENGURLEKARS SHREESAI BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'SUVIDHA LIFESPACES ASSOCIATES PRIVATE LIMITED',
    'ESR RANJANGAON R1 LOGISTICS AND INDUSTRIAL PARK PRIVATE LIMITED',
    'CHANDIL TRANSMISSION LIMITED',
    'NOKOR SOLAR ENERGY PRIVATE LIMITED',
    'APICON REAL INFRA PRIVATE LIMITED',
    'EVTEQ MOBILITY PRIVATE LIMITED',
    'QUICKSYS SOLUTIONS (OPC) PRIVATE LIMITED',
    'SRIANGALI GENERAL TRADING PRIVATE LIMITED',
    'RAMYSHAA COMMERCIAL PRIVATE LIMITED',
    'INFINITY MEDICARE PRIVATE LIMITED',
    'HEALY WORLD TRADING INDIA PRIVATE LIMITED',
    'SRI RAJRAJESHWARI INFRAPROJECTS PRIVATE LIMITED',
    'GOEL GANGA INFRATECH SOLUTIONS PRIVATE LIMITED',
    'KRISHNAPATNAM CONSTRUCTIONS PRIVATE LIMITED',
    'TRUPT FOOD PARK PRIVATE LIMITED',
    'SAROVAR MECH INDIA PRIVATE LIMITED',
    'DR. GOKANO PHARMA (OPC) PRIVATE LIMITED',
    'WINYSTRA PHARMACEUTICALS PRIVATE LIMITED',
    'KONTERA VENTURES PRIVATE LIMITED',
    'TRINITAS ENTERPRISES PRIVATE LIMITED',
    'KEELSTAR TRADING PRIVATE LIMITED',
    'ANSA RESOURCES PRIVATE LIMITED',
    'SHANTIMADHU CONFECTIONERY PRIVATE LIMITED',
    'VIVEK STEELS SKYLINE PRIVATE LIMITED',
    'ANGELROSE TRADING PRIVATE LIMITED',
    'AZURE SPARKLER PRIVATE LIMITED',
    'WHITE HORSE MARCOM SELECTIONS PRIVATE LIMITED',
    'EMBRIX TRADE SERVICE PRIVATE LIMITED',
    'NUPLANET VENTURES INDIA PRIVATE LIMITED',
    'KG ENTERPRISE PRIVATE LIMITED',
    'AIM GLOBAL FLEXTECH PRIVATE LIMITED',
    'LEOBIZ GLOBAL NETWORK PRIVATE LIMITED',
    'CARICIA FASHIONS PRIVATE LIMITED',
    'VIJAYAN OVERSEAS PRIVATE LIMITED',
    'CAPE HERBS PRIVATE LIMITED',
    'CARROTY WEAVING EQUIPMENT PRIVATE LIMITED',
    'TMC PLYWOOD PRIVATE LIMITED',
    'MEMA LIFESTYLE AND FASHION PRIVATE LIMITED',
    'OHNICIO PRIVATE LIMITED',
    'BROVEINS MARKETING INDIA PRIVATE LIMITED',
    'FLP TRADING PRIVATE LIMITED',
    'ATMOS TRADING INDIA PRIVATE LIMITED',
    'PERFECT SALES ELECTRONICS PRIVATE LIMITED',
    'SHIVGANGA ASSOCIATES PRIVATE LIMITED',
    'LAKASHIKA COUTURE PRIVATE LIMITED',
    'CLICK HOTELS PRIVATE LIMITED',
    'LAKESIDE SOFTWARE INDIA PRIVATE LIMITED',
    'VISUAL LABS IT SERVICES PRIVATE LIMITED',
    'ELITSER INFOTECH PRIVATE LIMITED',
    'VESUVIUS TECHNOLOGY PRIVATE LIMITED',
    'DEVIC EARTH PRIVATE LIMITED',
    'PUSHPPRIYA FOUNDATION',
    'NARAYANI HOLIDAYS AND CONFERENCES PRIVATE LIMITED',
    'NRAM REGENT PRIVATE LIMITED',
    'WORKCRUITERS PRIVATE LIMITED',
    'IMPOF IT SOLUTIONS PRIVATE LIMITED',
    'ZEEDUP TECHNOLOGIES & SERVICES (OPC) PRIVATE LIMITED',
    'GARVAR ROADLINES PRIVATE LIMITED',
    'HANUMANT KRIPA EASY FINANCE PRIVATE LIMITED',
    'EARNJOY TECHNOLOGY PRIVATE LIMITED',
    'AN3O TECHNOLOGIES PRIVATE LIMITED',
    'NAVITAS SERVICES PRIVATE LIMITED',
    'PHARMSIGHT RESEARCH & ANALYTICS PRIVATE LIMITED',
    'DATAPEACE AI TECHNOLOGIES PRIVATE LIMITED',
    'STAG MARINE MANAGEMENT PRIVATE LIMITED',
    'VRAJBHOOMI CHARITABLE FOUNDATION',
    'BEA GLOBETROTTER PRIVATE LIMITED',
    'MCS RESOURCES PRIVATE LIMITED',
    'SAVIYNT INDIA PRIVATE LIMITED',
    'RESILIENT INNOVATIONS PRIVATE LIMITED',
    'AVRT TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AS COOLING TECHNOLOGIES INDIA PRIVATE LIMITED',
    'OFG MANUFACTURING BUSINESSES PRIVATE LIMITED',
    'SWASTIK ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED',
    'VIDUR HUMAN CARE PRIVATE LIMITED',
    'STELLARSP PRIVATE LIMITED',
    'ALTERNATE ANGLE CONSULTANTS PRIVATE LIMITED',
    'CONATUS FINSERVE PRIVATE LIMITED',
    'SALONAH PROPERTIES PRIVATE LIMITED',
    'ZEBIBYTE SYSTEMS PRIVATE LIMITED',
    'KSHMAA TECHNOLOGIES PRIVATE LIMITED',
    'RYNAN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ENTIRE IT DESIGN PRIVATE LIMITED',
    'JETBRAIN ROBOTICS PRIVATE LIMITED',
    'SRYK ENTERPRISES PRIVATE LIMITED',
    'ARCHWAY TECHNICAL SERVICES (OPC) PRIVATELIMITED',
    'GESTALTI PEBO BUSINESS SOLUTIONS PRIVATELIMITED',
    'BHAWAN INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'FEDO HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'QUADRIC INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'JADEPURPLE INVESTRIGHT PRIVATE LIMITED',
    'CAPAZ STAFFING SERVICES PRIVATE LIMITED',
    'TRIANGULAR INFOSOLUTIONS PRIVATE LIMITED',
    'ELPRONET INNOVATIONS PRIVATE LIMITED',
    'IDLD LEARNING & DEVELOPMENT (INDIA) PRIVATE LIMITED',
    'BROOKPROP MANAGEMENT SERVICES PRIVATE LIMITED',
    'VEGITH GLOBAL SERVICES PRIVATE LIMITED',
    'ULAVI TECHNOLOGIES PRIVATE LIMITED',
    'BIZBOX PUBLISHING PRIVATE LIMITED',
    'NITPR MARKETING SOLUTIONS PRIVATE LIMITED',
    'PRIMESONS TECHTRADE PRIVATE LIMITED',
    'MAIMOON INTERNATIONAL TOOLS PRIVATE LIMITED',
    'AJWA NATURE SAFARI PARK PRIVATE LIMITED',
    'BIOQUICK TECHNOLOGIES PRIVATE LIMITED',
    'VIVAAN FARMICULTURE PRIVATE LIMITED',
    'TALISMAN HR SOLUTIONS PRIVATE LIMITED',
    'SHAYONAM BUSINESS SERVICES PRIVATE LIMITED',
    'PIXELTECH SECURITY PRIVATE LIMITED',
    'COMPETITIVE COMMUNICATION SERVICES PRIVATE LIMITED',
    'KONKAN SINDHU SUSTAINABLE ENERGY DEVELOPERS LIMITED',
    'BITWARE TECHNOLOGIES PRIVATE LIMITED',
    'BFMS FACILITY MANAGEMENT PRIVATE LIMITED',
    'LIONTREK ENTERTAINMENT INDIA PRIVATE LIMITED',
    'SAM SPORTS NUTRITION AND WELLNESS PRIVATE LIMITED',
    'ANURAG BEVERAGES PRIVATE LIMITED',
    'HOLTEK SEMICONDUCTOR (INDIA) PRIVATE LIMITED',
    'JSM ADVISERS PRIVATE LIMITED',
    'HABITUS HR SOLUTIONS PRIVATE LIMITED',
    'ASPIRE DIAGNOLINE PRIVATE LIMITED',
    'ZABARA LIFE RESOURCES PRIVATE LIMITED',
    'SAZU MEDIA PRIVATE LIMITED',
    'CAPSOL ENERGY PRIVATE LIMITED',
    'VENSAI IMPEX PRIVATE LIMITED',
    'PLENIER CONSULTING PRIVATE LIMITED',
    'ESTAGROW SOLUTIONS PRIVATE LIMITED',
    'E-XING PRECISION DESIGN PRIVATE LIMITED',
    'EMER HEALTH CARE PRIVATE LIMITED',
    'KUTE SONS INDUSTRIES PRIVATE LIMITED',
    'WISSDA CONSULTING PRIVATE LIMITED',
    'SALTORO BUSINESS SPACES PRIVATE LIMITED',
    'ALOK EXPORTS PRIVATE LIMITED',
    'SUNRICH SHIPPING PRIVATE LIMITED',
    'MERTEX INDIA PRIVATE LIMITED',
    'BISIFUSION PRIVATE LIMITED',
    'SHREEKAMNA CORPORATE SERVICES PRIVATE LIMITED',
    'EWD PLUS PRIVATE LIMITED',
    'PRVN HOSPITALS PRIVATE LIMITED',
    'ESCO UNITED SOLUTIONS PRIVATE LIMITED',
    'ACCESS2JUSTICE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED',
    'MYSALARYDOST FINTECH PRIVATE LIMITED',
    'COLTIVARE TECH SERVICES PRIVATE LIMITED',
    'INTERACTIVE HR SPOT PRIVATE LIMITED',
    'MPCON LIMITED',
    'SHARDA CROPCHEM LIMITED',
    'TIGER LOGISTICS (INDIA) LIMITED',
    'IDEEO TECH SOLUTIONS PRIVATE LIMITED',
    'WWL TRANSPORT SOLUTIONS INDIA PRIVATE LIMITED',
    'LUBLUB INDIA PRIVATE LIMITED',
    'THINK ERA IBIRDS PRIVATE LIMITED',
    'YDI SOLUTIONS PRIVATE LIMITED',
    'WAHED INVEST PRIVATE LIMITED',
    'WOOJU ENVIORNMENT & MAINTENANCE PRIVATE LIMITED',
    'SOCNET TECHNOLOGIES PRIVATE LIMITED',
    'UCORE CONNECTRONICS PRIVATE LIMITED',
    'ADPOOL SERVICES PRIVATE LIMITED',
    'LRDMC TRAVEL INDIA PRIVATE LIMITED',
    'CYBUSAIR SERVICES PRIVATE LIMITED',
    'TEYEES ADVISORY SERVICES PRIVATE LIMITED',
    'ESH TECHNOLOGY PRIVATE LIMITED',
    'ASHOKA KARADI BANWARA ROAD PRIVATE LIMITED',
    'UNNATTI TRACOM PRIVATE LIMITED',
    'SANTOSH STAINLESS INDIA PRIVATE LIMITED',
    'PROCESSSMAART PRIVATE LIMITED',
    'KGBIND MANUFACTURING AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'ALPHAINVENTA PRIVATE LIMITED',
    'GURGAON SOHNA HIGHWAY PRIVATE LIMITED',
    'CONTINENT HENGJU PRIVATE LIMITED',
    'REDBAY TECHNOLOGIES PRIVATE LIMITED',
    'HQ ENGINEERING PRIVATE LIMITED',
    'FASHCODE RETAIL PRIVATE LIMITED',
    'TAGMATIC TECHSOLUTIONS PRIVATE LIMITED',
    'TRID TECHNO CRAFT PRIVATE LIMITED',
    'LOTPICK CONSULTING SERVICES PRIVATE LIMITED',
    'EASY DNA INDIA PRIVATE LIMITED',
    'BVSLN SYSTEM SERVICES PRIVATE LIMITED',
    'ADHARSHILA NIDHI LIMITED',
    'SUNDER BUILDWELL PRIVATE LIMITED',
    'AKSHAYAGUNA HERBALS PRIVATE LIMITED',
    'MYNAH INFRASTRUCTURE PRIVATE LIMITED',
    'NERDWALLET INDIA PRIVATE LIMITED',
    'PAULSHANTANU ENGINEERING PRIVATE LIMITED',
    'PRO Q.C. INTERNATIONAL PRIVATE LIMITED',
    'AANVITHA FOUNDATION',
    'UCON STRUCTURAL SYSTEMS PRIVATE LIMITED',
    'RUDRARAJ STEELS PRIVATE LIMITED',
    '1T9 TECHNOLOGY PRIVATE LIMITED',
    'SIXPOINT SOCIAL CLUB PRIVATE LIMITED',
    'GARFA ESTATES ASSOCIATION',
    'GARAMORE TOLLWAY PRIVATE LIMITED',
    'MUNISUVRAT SOLAR PRIVATE LIMITED',
    'KARVRISH RESOURCES PRIVATE LIMITED',
    'INSTRUTEL SYSTEMS PRIVATE LIMITED',
    'VERDICAL SOLUTIONS INDIA PRIVATE LIMITED',
    'GMR TENAGA OPERATIONS AND MAINTENANCE PRIVATE LIMITED',
    'SECURIGHT TECHNOLOGIES PRIVATE LIMITED',
    'COMPTECH INFORMATIC PRIVATE LIMITED',
    'SAISRUSHTI (DEVANAHALLI-BEERASANDRA) PROJECTS PRIVATE LIMITED',
    'BEEZ INNOVATION LABS PRIVATE LIMITED',
    '24ONLINE INFO TECHNOLOGIES PRIVATE LIMITED',
    'SAISRUSHTI (KENGERI) PROJECTS PRIVATE LIMITED',
    'ARUDHRAHA INFRASTRUCTURES PRIVATE LIMITED',
    'ROHAN RAJDEEP ALAPPUZHA PROJECTS LIMITED',
    'HUAKE ENGINEERING INDIA PRIVATE LIMITED',
    'LAND TRADES BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'PYC INDIA CONSULTING PRIVATE LIMITED',
    'TOUCHALIFE FOUNDATION INDIA',
    'CROWNWELL INFRA PRIVATE LIMITED',
    'DATAMATICS ROBOTICS SOFTWARE LIMITED',
    'EAR TO THE WILD FOUNDATION',
    'JUNAKART TEXTILE PRIVATE LIMITED',
    'JAL TRANS LOGISTICS PRIVATE LIMITED',
    'RAJDHANI AIR SERVICES PRIVATE LIMITED',
    'ECHLON CORPORATION PRIVATE LIMITED',
    'BIGSPRING SERVICES PRIVATE LIMITED',
    'TABLERO23 ADVISORY PRIVATE LIMITED',
    'ICONKRISHI INSTITUTE OF MEDICAL SCIENCESPRIVATE LIMITED',
    'SAUMIT INTERGLOBE PRIVATE LIMITED',
    'SQWEEKS TECHNOLOGIES PRIVATE LIMITED',
    'VIRTUAL PHYSICIAN SCRIBES INDIA PRIVATE LIMITED',
    'LEO',
    'AQUILA INVESTMENTS COMPANY PRIVATE LIMITED',
    'Rasona investments pvt ltd',
    'STANDARD CHARTERED CAPITAL LIMITED',
    'Axis asset management company limited',
    'Muthoot risk insurance and broking services private limited',
    'Axis mutual fund trustee limited',
    'BHARTI MANAGEMENT SERVICES LIMITED',
    'Fiduciary euromax global markets limited',
    'Vega jeweldiam private limited',
    'Sharekhan commodities private limited',
    'Lehman brothers capital private limited',
    'Fiduciary euromax capital markets private limited',
    'Neptune developers & constructions private limited',
    'Newedge broker india private limited',
    'Decuple finsec private limited',
    'DVARA RESEARCH FOUNDATION',
    'Bookaprop estates private limited',
    'City centre mall nashik private limited',
    'Alkor technologies limited',
    'Pioneer realty limited',
    'Doric real estate limited',
    'Neptune developers limited',
    'Temple rose real estate private limited',
    'Shami realty private limited',
    'T3 urban developers limited',
    'Sheth creators and constructors private limited',
    'Track prolet private limited',
    'Cache properties private limited',
    'Blooming skies real estate private limited',
    'Ekantika hospitality private limited',
    'Team industrial consultancy services private limited',
    'WIKI KIDS PRIVATE LIMITED',
    'Agt india private limited',
    'Synoverge technologies private limited',
    'Apigee technologies (india) private limited',
    'KANAI TECHNOLOGY PARKS PRIVATE LIMITED',
    'YOKOGAWA TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'TOYOTA TSUSHO SYSTEMS INDIA PRIVATE LIMITED',
    'Ibt media private limited',
    'Mindstretch learning lab private limited',
    'Iron mountain services private limited',
    'Micronova helios networking solutions private limited',
    'SPRINKLR INDIA PRIVATE LIMITED',
    '66DEGREES INTERNATIONAL PRIVATE LIMITED',
    'Trafigura global services private limited',
    'Vrsoft system and solutions private limited',
    'Paradigm geophysical (india) private limited',
    'Spectrum techno-consultants private limited',
    'Fingertips software systems private limited',
    'Mahasystems private limited',
    'Addnode india private limited',
    'COMMUNITY BRANDS SOFTWARE DEVELOPMENT SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Redbytes software private limited',
    'GIRNAR SOFTWARE (SEZ) PRIVATE LIMITED',
    'Synergy computer solutions international limited',
    'SUTISOFT PRIVATE LIMITED',
    'Sindhu and sanjeev software solutions private limited',
    'Cmyk health boutique private limited',
    'Karnataka automats private limited',
    'Suyosha healthcare private limited',
    'MADHAV HEALTH CARE & REALTY PRIVATE LIMITED',
    'Uplift india association',
    'Scan grafiks (madras) private limited',
    'Children s future india private limited',
    'Digilife media private limited',
    'Coastal amusement and realty private limited',
    'Pickle media private limited',
    'Faith services private limited',
    'Locnapps media private limited',
    'Kriatec services private limited',
    'Res an eve private limited',
    'K line ship management (india) private limited',
    'Jaguar communication consultancy services private limited',
    'Perfect enroller india private limited',
    'Integrated environmental solutions india private limited',
    'Brand david communications private limited',
    'Desmi equipments private limited',
    'Graphiti multimedia private limited',
    'ADITYA BIRLA SUN LIFE INSURANCE COMPANY LIMITED',
    'Citigroup global markets india private limited',
    'Spice island apparels limited',
    'Baid global ventures limited',
    'Packtech industries limited',
    'Mphasis limited',
    'Continental controls limited',
    'Oberoi realty limited',
    'JULIEN AGRO INFRATECH LIMITED',
    'Arfin india limited',
    'Gtl infrastructure ltd',
    'MINOSHA INDIA LIMITED',
    'Runwal farms private limited',
    'Invitro international private limited',
    'Summerhouse eco-ventures private limited',
    'Ranco realty private limited',
    'Sri sai nath agri industries private limited',
    'Shree sai urja limited',
    'SHELL ENERGY MARKETING AND TRADING INDIAPRIVATE LIMITED',
    'Gokul minex private limited',
    'Sky enterprise private limited',
    'RAJARAM COM-TRADE SERVICES PRIVATE LIMITED',
    'RRUCHI FOOD PLAZA PRIVATE LIMITED',
    'Vrd export house private limited',
    'Garden court distilleries private limited',
    'International tobacco company limited',
    'Dhruva woollen mills private limited',
    'Sheetal drape (india) private limited',
    'Umayal spinners private limited',
    'Daughters interiors private limited',
    'Retro clothing private limited',
    'Ramsons veit private limited',
    'Fargrow fashions private limited',
    'Wood house ltd',
    'Formica laminates (india) private limited',
    'Nsd printpack private limited',
    'Infinity industries private limited',
    'Chary publications private limited',
    'Dike business services limited',
    'AVAADA VENTURES PRIVATE LIMITED',
    'Big offset private limited',
    'Ariane orgachem private limited',
    'Bestsource nutrition private limited',
    'H j arochem private limited',
    'Deltaspharrma private limited',
    'Harlequin paints private limited',
    'Milton lifecare private limited',
    'Marigold pharmaceuticals private limited',
    'GSK PHARMA INDIA PRIVATE LIMITED',
    'VALAGRO BIOSCIENCES PRIVATE LIMITED',
    'Consolidated remedies private limited',
    'Eye kare kilitch limited',
    'Tembo exim private limited',
    'Optibelt power transmission india private limited',
    'Yahska polymers private limited',
    'Yes imported solutions private limited',
    'Magic glass private limited',
    'NI-CHROME ALLOY CASTINGS PRIVATE LIMITED',
    'Refractory shapes private limited',
    'B d impex private limited',
    'Maxroof corporation private limited',
    'Dolphin die cast private limited',
    'Somani products private limited',
    'Imperial glazing private limited',
    'N dot dorwin facade solutions private limited',
    'P s p laser tech private limited',
    'Kailash roofing solutions private limited',
    'Siddhivinayak laser fabrication private limited',
    'Signellent technologies india private limited',
    'International training and development private limited',
    'I and a international private limited',
    'Cno it services (india) private limited',
    'Innominds software private limited',
    'Davek technologies private limited',
    'Sis software (india) private limited',
    'Erpdirect solutions (india) private limited',
    'Kstrata it solutions private limited',
    'Righteous technologies private limited',
    'Jarvis business solutions private limited',
    'Ibot control systems india private limited',
    'RXR SOLUTIONS PRIVATE LIMITED',
    'NORTONLIFELOCK SOFTWARE AND SERVICES INDIA PRIVATE LIMITED',
    'Trifecta technologies of india private limited',
    'Deserve tech private limited',
    'Interactive intelligence india private limited',
    'Htp cyberline solutions private limited',
    'Aim infocom services private limited',
    'Innolever solutions private limited',
    'Webtree designs private limited',
    'S s data code india private limited',
    'Sumisha exim private limited',
    'Solutions outsourcing private limited',
    'Agile labs private limited',
    'Textron india private limited',
    'Utthunga technologies private limited',
    'TIETO INDIA PRIVATE LIMITED',
    'Eukleia technologies private limited',
    'Designs simulation engineering solutions private limited',
    'Nigus systems private limited',
    'Web werks india private limited',
    'UNIVERSAL TRUSTEESHIP SERVICES LIMITED',
    'Efkon india private limited',
    'Big-i tuna communications private limited',
    'Sal business solutions private limited',
    'Agile financial technologies private limited',
    'Inventec systems private limited',
    'Railsys engineers private limited',
    'Socioffice software private limited',
    'Intellvisions solutions private limited',
    'AIROX TECHNOLOGIES LIMITED',
    'Preeminent technology(india) private limited',
    'Paragon dynamics info systems private limited',
    'Navajyoti consultancy private limited',
    'Laxmichand chheda consultancy private limited',
    'Arham industries limited',
    'P16 SPORTS MEDIA AND ENTERTAINMENTS PRIVATE LIMITED',
    'Asahi kasei india private limited',
    'Adn fire safety private limited',
    'Ibc (india) consultancy & marketing services private limited',
    'Katmandu apparel private limited',
    'Blastclean systems private limited',
    'Freight commerce solutions private limited',
    'Doble engineering private limited',
    'Cellcare pathology lab private limited',
    'Ansr source india private limited',
    'Colliers international (india) property services private limited',
    'Tetra tech es india private limited',
    'Carlyle india advisors private limited',
    'Wellesley partners consulting (india) private limited',
    'P16 RETAIL STORES PRIVATE LIMITED',
    'Infosun technologies private limited',
    'SCHENCK PROCESS SOLUTIONS INDIA PRIVATE LIMITED',
    'Bureau veritas (india) private limited',
    'CONCEPT CONSILIO INDIA PRIVATE LIMITED',
    'Sarin technologies india private limited',
    'Highlight films private limited',
    'Pioneer elastic (india) private limited',
    'Chl building design services private limited',
    'Pronk multiservice india private limited',
    'Red shore international private limited',
    'Unique waves consultancy services private limited',
    'Msc international import export private limited',
    'NJD CAPITAL PRIVATE LIMITED',
    'German laundry private limited',
    'MAHAPATRA BUSINESS SOLUTION PRIVATE LIMITED',
    'Global accounting solutions private limited',
    'REVERE COMMUNICATIONS PRIVATE LIMITED',
    'Click retail private limited',
    'Xpan solutions private limited',
    'Blueprint communication and space solutions private limited',
    'Vigprona business india private limited',
    'BOMBAY INTEGRATED SECURITY (INDIA) LIMITED',
    'Atlas converting equipment (india) private limited',
    'Pritbor technology & consulting private limited',
    'Universal neo-tech private limited',
    'QUEEN',
    'KOMMUNITEE LIVING SPACES PRIVATE LIMITED',
    'LITTLE TIGERS FOOD & FUTURE PRIVATE LIMITED',
    'GRAMON TRADING AND MARKETING PRIVATE LIMITED',
    'VIDHYAAN LEARNING SERVICES PRIVATE LIMITED',
    'PALMOTOR WAYS PRIVATE LIMITED',
    'VALLABH STEEL NORTH PRIVATE LIMITED',
    'VAMSTAR INDIA PRIVATE LIMITED',
    'C1C READYMIX INDIA PRIVATE LIMITED',
    'ESCONDER INDIA PRIVATE LIMITED',
    'CAD VENTURES PRIVATE LIMITED',
    'GROW SWADESH PRIVATE LIMITED',
    'GREENORBIT SOFTWARE PRIVATE LIMITED',
    'YEXT INDIA PRIVATE LIMITED',
    'REBELLION COSMETICS PRIVATE LIMITED',
    'PAYGOAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANALYTIQ DYNAMICS PRIVATE LIMITED',
    'ANANT PROJECTS INDIA PRIVATE LIMITED',
    'SMARTGENIEE MINIATURE FMS PRIVATE LIMITED',
    'TEST TRIBE PRIVATE LIMITED',
    'SEACONVOY SYSTEMS ENGINEERING PRIVATE LIMITED',
    'DSB HOSPITALITY PRIVATE LIMITED',
    'BURROUGHS WELCOME PHARMACIA PRIVATE LIMITED',
    'TRUE VALUE SOLAR ENERGY PRIVATE LIMITED',
    'ATUL KRISHAN BANSAL FOUNDATION',
    'ASINDIA INNOVATIONS PRIVATE LIMITED',
    'DIAGON VANGUARD DIAGNOSTICS INDIA PRIVATE LIMITED',
    'GLOBETEK INDIA PRIVATE LIMITED',
    'ATULYIT FLAVOCHEM PRIVATE LIMITED',
    'SIGNSUTRA INTERNATIONAL PRIVATE LIMITED',
    'BARBOURNE TRADING PRIVATE LIMITED',
    'ZENSTACK PRIVATE LIMITED',
    'SRISHTI QUALITY FOODS INDIA PRIVATE LIMITED',
    'KAADS KEEDS KAADS CONSTRUCTION ALLIED SERVICES PRIVATE LIMITED',
    'BANGARAM INTERNATIONAL BEACH RESORTS PRIVATE LIMITED',
    'ARIGHT PLANTS AND ENERGY PRIVATE LIMITED',
    'PRIME PROGRESSION PACKAGING PRIVATE LIMITED',
    'JAYADI SPACES PRIVATE LIMITED',
    'CHANGEJAR TECHNOLOGIES PRIVATE LIMITED',
    'DROOMPLANET PRIVATE LIMITED',
    'STRUCTITECT BUILDCON PRIVATE LIMITED',
    'MIZZEN DIGITAL PRIVATE LIMITED',
    'SHAJAY MARKETING PRIVATE LIMITED',
    'MKRS RETAIL PRIVATE LIMITED',
    'AEGIS GREEN ENERGY PRIVATE LIMITED',
    'AAYOGG CONSULTING PRIVATE LIMITED',
    'MZM ANALYTICS PRIVATE LIMITED',
    'ZENZULA GLOBAL PRIVATE LIMITED',
    'KRYFTON CONSULTING PRIVATE LIMITED',
    'MANAAR LABS PRIVATE LIMITED',
    'R V ESTATE CONSULTANTS PRIVATE LIMITED',
    'SPIRE TRADE AND E COMMERCE PRIVATE LIMITED',
    'ANBOTO SOLAR PRIVATE LIMITED',
    'SUNEDISON MANUFACTURING PRIVATE LIMITED',
    'MARK SOLAR PRIVATE LIMITED',
    'SAKSHAMTA FOUNDATION',
    'DREAM HOUSE TECHNOLOGIES PRIVATE LIMITED',
    'AUXAIR TECHNOLOGIES PRIVATE LIMITED',
    'MARUDHARA FOODS PRIVATE LIMITED',
    'GROWW CREDITSERV TECHNOLOGY PRIVATE LIMITED',
    'BEWELL DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'PRACHURYA ENTERPRISES PRIVATE LIMITED',
    'JAYADI TECHMAC PRIVATE LIMITED',
    'BHOJPUR MAHADEV HIGHWAYS PRIVATE LIMITED',
    'GVTECH PROCESS AUTOMATION PRIVATE LIMITED',
    'JOEGREEN INDIA PRIVATE LIMITED',
    'NICOMAC TAIKISHA CLEAN ROOMS PRIVATE LIMITED',
    'SWAADHI INDIA EDTECH PRIVATE LIMITED',
    'AHOPE SOLUTIONS PRIVATE LIMITED',
    'PARAM INVESTOPEDIA PRIVATE LIMITED',
    'IDPTS RESEARCH WINGS PRIVATE LIMITED',
    'E BUG INDIA PRIVATE LIMITED',
    'SVL ASSOCIATES PRIVATE LIMITED',
    '3HATZ INDIA PRIVATE LIMITED',
    'ILOVESAREES PRIVATE LIMITED',
    'LOANINGHUB (INDIA) PRIVATE LIMITED',
    'REETIHOUSE ATTIRES (OPC) PRIVATE LIMITED',
    'GATIK OTTO INDIA PRIVATE LIMITED',
    'GOOFYBAG ONLINE PRIVATE LIMITED',
    'EUREKA SUSTAINABILITY INTERNATIONAL PRIVATE LIMITED',
    'EEE3LIFE MARKETING PRIVATE LIMITED',
    'SIGNATUREIT SOFTWARE DESIGNERS PRIVATE LIMITED',
    'CHARIOT AGRO LIMITED',
    'VAYU PRODUCTS PRIVATE LIMITED',
    'FOOD HUB SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'DATABONKER TECHNOLOGIES PRIVATE LIMITED',
    'CENTREAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'MOTION DIME PRIVATE LIMITED',
    'PAPERSPACE INDIA PRIVATE LIMITED',
    'YUSHI SHIPPING PRIVATE LIMITED',
    'NUVVEN INDIA PRIVATE LIMITED',
    'FORCE-OF LIFE PRIVATE LIMITED',
    'FINWELL TECHNOLOGIES PRIVATE LIMITED',
    'MEGALARK EXPORTS PRIVATE LIMITED',
    'VALVES & ALLIED INDUSTRIES ASSOCIATION',
    'KAVALRY TECHNOLOGIES PRIVATE LIMITED',
    'SONOFLUX MUSIC & LEARNING PRIVATE LIMITED',
    'REDALLIANZ TECHNOLOGIES PRIVATE LIMITED',
    'TRAVEVO GLOBAL PRIVATE LIMITED',
    'BMTC INDIA SEMICONDUCTOR PRIVATE LIMITED',
    'DATAXS TECHNOLOGIES PRIVATE LIMITED',
    'MILLENIUM SHIPPING & LOGISTICS PRIVATE LIMITED',
    'HARDCASTLE AGROTECH SOLUTIONS PRIVATE LIMITED',
    'SJAAR AGRO EXPORTS PRIVATE LIMITED',
    'FAWN DOG TECH PRIVATE LIMITED',
    'ADWARN TECHNOLOGIES PRIVATE LIMITED',
    'ALDAR CONSTRUCTIONS PRIVATE LIMITED',
    'TSF MEDIA PRIVATE LIMITED',
    'VENUS INCUBATION SERVICES PRIVATE LIMITED',
    'ALUTECH GREEN PRIVATE LIMITED',
    'J V FLEXI TAPES PRIVATE LIMITED',
    'DATA LEAP TECH PRIVATE LIMITED',
    'RADIUM DESIGNS PRIVATE LIMITED',
    'LEATHER JOURNAL WHOLESALER PRIVATE LIMITED',
    'FLEXA INDIA PRIVATE LIMITED',
    'BOSSDOM PRIVATE LIMITED',
    'YOU AND ME HOTELS PRIVATE LIMITED',
    'GOOD WISH REALTORS PRIVATE LIMITED',
    'SEA SHELTER CARRIERS PRIVATE LIMITED',
    'EUCLIDXR IMMERSIVE PRIVATE LIMITED',
    'NEXUS NETWORKS (BLR) PRIVATE LIMITED',
    'CHIRAG CONCRETE MACHINE PRIVATE LIMITED',
    'KODIMUND PRIVATE LIMITED',
    'FRESH SURVEY PRIVATE LIMITED',
    'ADVAINT TECHNOLOGIES PRIVATE LIMITED',
    'TARTANHQ SOLUTIONS PRIVATE LIMITED',
    'TECHOBUILD PRIVATE LIMITED',
    'RRAJ BIOPLAST PRIVATE LIMITED',
    'AGOX CERA PRIVATE LIMITED',
    'C2D COME2DIGITAL PRIVATE LIMITED',
    'PERZEUS BIOSCIENCES PRIVATE LIMITED',
    'APS TECHNICAL SOLUTIONS PRIVATE LIMITED',
    'DELTACITY DIGITAL PRIVATE LIMITED',
    'DELUXE FACILITY MANAGEMENT PRIVATE LIMITED',
    'SANVIRA BIOSCIENCES PRIVATE LIMITED',
    'GOOD WISH BUILDWELL PRIVATE LIMITED',
    'AVION PAPER TRADELINK PRIVATE LIMITED',
    'PROFUGO REAL TOXIN FREE FARM PRODUCTS AND PRODUCER COMPANY LIMITED',
    'INGENUITY BIOSCIENCES PRIVATE LIMITED',
    'AECONS INFOTECH PRIVATE LIMITED',
    'TERRENE LOGISOLUTIONS PRIVATE LIMITED',
    'JINDAL POLYBUTTONS PRIVATE LIMITED',
    'DHANI HEALTHCARE LIMITED',
    'BRESMED HEALTH SOLUTIONS INDIA PRIVATE LIMITED',
    'UNITED CORPORATE ACCOUNTING AND TAXATIONSERVICES PRIVATE LIMITED',
    'UNIVESTO CAPITAL PRIVATE LIMITED',
    'GPOHEALTH INDIA PRIVATE LIMITED',
    'VEOLIA CARBON CLEAN INDIA PRIVATE LIMITED',
    'GROWKOSH SERVICES PRIVATE LIMITED',
    'GREEN BROTHERS INTERNATIONAL PRIVATE LIMITED',
    'EURJA ENERGY GENERATION PRIVATE LIMITED',
    'ROHIL FABRICS PRIVATE LIMITED',
    'REMBAL DISTRIBUTION AND LOGISTICS PRIVATE LIMITED',
    'CREDITCIRCLE SERVICES PRIVATE LIMITED',
    'ERRIKOS CONSULTING SERVICES PRIVATE LIMITED',
    'BANDURA TECH PRIVATE LIMITED',
    'NEXARIX TECHSOLUTIONS PRIVATE LIMITED',
    'TEE TEE WOOD TECH INDIA PRIVATE LIMITED',
    'A3T TECHNOLOGIES PRIVATE LIMITED',
    'MIKRO GRAFEIO SERVICES PRIVATE LIMITED',
    'INDAFIT TECH PRIVATE LIMITED',
    'OATS MANAGEMENT CONSULTANCY PRIVATE LIMITED',
    'FUTURE VARSITY EDUCARE FOUNDATION',
    'ACE RENEWTECH ENGINEERING PRIVATE LIMITED',
    'SUJAL TECH SOLUTIONS (OPC) PRIVATE LIMITED',
    'AFFINITY MERCHANTS PRIVATE LIMITED',
    'DELTACADD SOLUTIONS PRIVATE LIMITED',
    'WAMA TECHNOLOGY PRIVATE LIMITED',
    'INNODELVE IT SOLUTIONS PRIVATE LIMITED',
    'TUTECK TECHNOLOGIES PRIVATE LIMITED',
    'FLY AIR WINGS PRIVATE LIMITED',
    'K D LABS LIMITED',
    'CTS OM (INDIA) PRIVATE LIMITED',
    'SILK N FAB PRIVATE LIMITED',
    'UNITY RENT-A-CAR PRIVATE LIMITED',
    'AHEERA INDIA PRIVATE LIMITED',
    'RIOGEN HEALTHCARE PRIVATE LIMITED',
    'MGM RESORTS PRIVATE LIMITED',
    'VEDANGA HOLDINGS PRIVATE LIMITED',
    'TOMORROW CAPITAL HOLDINGS PRIVATE LIMITED',
    'ALPHAPINE & AROMATICS PRIVATE LIMITED',
    'AERIAL HOSPITALITY PRIVATE LIMITED',
    'AVIHOST PRIVATE LIMITED',
    'NEUM AUTOMOTIVE INDUSTRIES PRIVATE LIMITED',
    'BRAND BOX GLOBAL PRIVATE LIMITED',
    'REDCENTRIC SUPPORT SERVICES PRIVATE LIMITED',
    'AROMA ALYSSUM CHEMICALS PRIVATE LIMITED',
    'CROWNTECH SURFACE FINISHINGS PRIVATE LIMITED',
    'JIAMAA PROJECTS PRIVATE LIMITED',
    'SUPERGA BEAUTY INDIA PRIVATE LIMITED',
    'ANANT RAJ CLOUD PRIVATE LIMITED',
    'ARVEE SPECIALITY CHEMICALS PRIVATE LIMITED',
    'AVISA FOODS AND FUELS PRIVATE LIMITED',
    'PANEL VIEWPOINT PRIVATE LIMITED',
    'V&V HARDWARES PRIVATE LIMITED',
    'NEST ACADEMY OF MODELLING AND GROOMING EDUCATION FOUNDATION',
    'NAVIGMATE PRIVATE LIMITED',
    'LIGHT TREE TECHNOLOGY INDIA PRIVATE LIMITED',
    'GREEN AGES FOOD PRIVATE LIMITED',
    'RISING SUN ENERGY 3 PRIVATE LIMITED',
    'SOLE-MONO-POLE PRIVATE LIMITED',
    'MINERVA VERITAS DATA CENTRE PRIVATE LIMITED',
    'STAFFURS SOLUTIONS PRIVATE LIMITED',
    'TIBREWALA ELECTRICALS PRIVATE LIMITED',
    'DESIGNALYTICA PRIVATE LIMITED',
    'DIGITAL COLONY PRIVATE LIMITED',
    'KRIDAY IMPEX (OPC) PRIVATE LIMITED',
    'LEXITIVA LEGAL SERVICES PRIVATE LIMITED',
    'UNIDO ED PRIVATE LIMITED',
    'LOVEINSTORE TECHNOLOGIES PRIVATE LIMITED',
    'TRADE UNLISTED PRIVATE LIMITED',
    'ABHIAKSH INDIA PRIVATE LIMITED',
    'REDSEAL LABS INDIA PRIVATE LIMITED',
    'PURELEARN EXCELLENCE PRIVATE LIMITED',
    'OAKWOOD AGRI-TECH PRIVATE LIMITED',
    'LNL HEALTH FOODS PRIVATE LIMITED',
    'VEDARI CAPS PRIVATE LIMITED',
    'SKYHUB PARTITIONS PRIVATE LIMITED',
    'SHOORA DESIGNS LIMITED',
    'EMOOKS INDIA PRIVATE LIMITED',
    'IMGSY PRIVATE LIMITED',
    'EVENTECH TECHNOLOGIES PRIVATE LIMITED',
    'VAISHNO DEVI INDUSTRIES PRIVATE LIMITED',
    'BISHOPS SCIENTIFIC PRIVATE LIMITED',
    'TAVASTECH PRIVATE LIMITED',
    'POWER ZENIX PRIVATE LIMITED',
    'DECEMBER RETAIL PRIVATE LIMITED',
    'UNITED KINGSDELL INTERNATIONAL PRIVATE LIMITED',
    'ZEYA SAVING NIDHI LIMITED',
    'ASPIRON TECHNOLOGIES PRIVATE LIMITED',
    'DEFINE TECHNO SOLUTIONS PRIVATE LIMITED',
    'KORESARA MANUFACTURING, TESTING AND AUTOMATION PRIVATE LIMITED',
    'OCTASERV TECHNOLOGIES PRIVATE LIMITED',
    'AWESOMONIC CELEBRINO PRIVATE LIMITED',
    'KAUMUDI VIRTUAL MEDIA PRIVATE LIMITED',
    'FISHLAH PRIVATE LIMITED',
    'MULTITAPERS PRIVATE LIMITED',
    'ACUTE ENDEAVORS PRIVATE LIMITED',
    'ISHTAR GATE INTERNATIONAL PRIVATE LIMITED',
    'FNF GLOBAL BUSINESS PRIVATE LIMITED',
    'BSE ADMINISTRATION & SUPERVISION LIMITED',
    'AROGYAM NAIVEDYAM AND NATURAL FOOD PRODUCTS PRIVATE LIMITED',
    'PSL SYSTEMS PRIVATE LIMITED',
    'SAMEO DISTRIBUTION (INDIA) PRIVATE LIMITED',
    'ALORINE (OPC) PRIVATE LIMITED',
    'VIDYA EDTECH PRIVATE LIMITED',
    'ENERGY SWIPE TECHNOLOGIES PRIVATE LIMITED',
    'HINGE ROOMS PRIVATE LIMITED',
    'PAWCARE PRIVATE LIMITED',
    'ANJANI SPINTEX PRIVATE LIMITED',
    'BOPILTECH SERVICES AND SOLUTIONS PRIVATELIMITED',
    'RARE & BASICS INDIA PRIVATE LIMITED',
    'FOURESS ENGINEERING INFRASTRUCTURE PRIVATE LIMITED',
    'UJAAL APPAREL AND ACCESSORIES PRIVATE LIMITED',
    'CORPSERV PRIVATE LIMITED',
    'NAMO NATURAL RESOURCES PRIVATE LIMITED',
    'DOCTOR PROTECT SERVICES PRIVATE LIMITED',
    'AASHI TRANSGLOBAL PRIVATE LIMITED',
    'AGENTA SKILLING SERVICES INDIA PRIVATE LIMITED',
    'SLOW SOLUTIONS PRIVATE LIMITED',
    'OAK WIZ MONEY PRIVATE LIMITED',
    'PLAN CARE FOUNDATION',
    'SAKSHAM SAHAYATA FOUNDATION',
    'AMARNATH MANUFACTURER PRIVATE LIMITED',
    'GOOD LITTLE ROBOTS PRIVATE LIMITED',
    'RABEEH HEALTH & EDUCATION FOUNDATION',
    'ENFES NATURALS PRIVATE LIMITED',
    'LLFX TECHNOLOGIES PRIVATE LIMITED',
    'LOKALIFY PRIVATE LIMITED',
    'BEE HIMALAYANS PRODUCT PRIVATE LIMITED',
    'STARS OF PANTNAGAR PRIVATE LIMITED',
    'SJP COMMUNICATIONS PRIVATE LIMITED',
    'OHM GLOBAL MOBILITY PRIVATE LIMITED',
    'HYPER VALVES PRIVATE LIMITED',
    'SG CHAKOR CONSTRUCTION PRIVATE LIMITED',
    'APOLLO VTS INDIA PRIVATE LIMITED',
    'INNOVATE B2B PRIVATE LIMITED',
    'LEPORP AUTOMOTIVE EMBEDDED SOLUTIONS PRIVATE LIMITED',
    'MIND AND BRAIN INSTITUTE PRIVATE LIMITED',
    'TEA TRAIL PROPERTIES PRIVATE LIMITED',
    'CITY PHARMA DISTRIBUTORS PRIVATE LIMITED',
    'ONE MIND MUSIC PRIVATE LIMITED',
    'PLANTONORGANIC EXPERIENCE CENTRE PRIVATELIMITED',
    'INDI FARMERS SUSTAINABLE VENTURES PRIVATE LIMITED',
    'VYAPAR GURU INFOTECH PRIVATE LIMITED',
    'ATELIER GAMES PRIVATE LIMITED',
    'INFRAMENTUM ASSETS PRIVATE LIMITED',
    'HUDSON FOODS PRIVATE LIMITED',
    'ASHMITA HOLIDAYS PRIVATE LIMITED',
    'COLLABERA TALENT SOLUTIONS PRIVATE LIMITED',
    'NIKHIL BHARAT COUNCIL FOR MASSIVE OPEN ONLINE COURSE',
    'AEVITAS IT PRIVATE LIMITED',
    'VYOMAN ORGANIK PRIVATE LIMITED',
    'ADAMAS TECH CONSULTING PRIVATE LIMITED',
    'CLOUDBUILDERS TECHNOLOGIES PRIVATE LIMITED',
    'FUTURE MAKEUP (INDIA) PRIVATE LIMITED',
    'BITBOTS TECHNOLOGIES PRIVATE LIMITED',
    'NIT RAIPUR FOUNDATION FOR INNOVATION ANDENTREPRENEURSHIP',
    'SHASHWAT FURNISHING SOLUTIONS LIMITED',
    'AMANTRAN TELEVISION MEDIA PRIVATE LIMITED',
    'BRIGHTSUN WELFARE FOUNDATION',
    'ENTERMINDS (OPC) PRIVATE LIMITED',
    'NNP BUILDCON PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP FIVE LIMITED',
    'VIJAYSINH DUBBAL FARM PRODUCER COMPANY LIMITED',
    'MAHAAN FOUNDATION',
    'SOURCE CODE CONTROL INDIA PRIVATE LIMITED',
    'MIKHAIL ENTERPRISE PRIVATE LIMITED',
    'SHAREPOINTEMPOWER PRIVATE LIMITED',
    'PRIVATEDEAL INDIA PRIVATE LIMITED',
    'HIRINGMASTER SOLUTIONS PRIVATE LIMITED',
    'SV GRAFIX PRIVATE LIMITED',
    'SIGARAM SECURITIES PRIVATE LIMITED',
    'ALTX CONVERGENCE PRIVATE LIMITED',
    'CONSCIOUS BREATHING PRIVATE LIMITED',
    'HI LOCUM PRIVATE LIMITED',
    'JAYANTARA DEVELOPMENT FOUNDATION',
    'METALOPLAST TECHNOLOGIES PRIVATE LIMITED',
    'ENTO PROTEINS PRIVATE LIMITED',
    'CUBEDATA INDIA PRIVATE LIMITED',
    'VIKAS BENLING PRIVATE LIMITED',
    'FRIQS AUTOMATION PRIVATE LIMITED',
    'BETANXT INDIA PRIVATE LIMITED',
    'EMPNEO INFORMATION AND COMMUNICATION TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'MYTODAY TECHNOLOGY PRIVATE LIMITED',
    'DEFIGO SOLUTIONS 4U PRIVATE LIMITED',
    'HIRETEK SERVICES PRIVATE LIMITED',
    'AQUS VENTURES PRIVATE LIMITED',
    'TYB10X INNOVATIONS (OPC) PRIVATE LIMITED',
    'RASAYAN MARKETING PRIVATE LIMITED',
    'STOCK TEACHERS INSTITUTE PRIVATE LIMITED',
    'GUILD OF INDIAN FOOD PROFESSIONALS AND SECTOR SKILL COUNCIL',
    'WISE SNDTWU INCUBATION CENTRE',
    'MANAHCARE SERVICES PRIVATE LIMITED',
    'KDPL DIAGNOSTICS (JALANDHAR) PRIVATE LIMITED',
    'FINSPERITY LIMITED',
    'UNIFIED FARMERS PRODUCER COMPANY LIMITED',
    'MILANO21 FOODS PRIVATE LIMITED',
    'ELVITA FOODS PRIVATE LIMITED',
    'AQJ APPARELS PRIVATE LIMITED',
    'ORIENT ECOMEV LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'TANISI CLOTHING PRIVATE LIMITED',
    'LCS LOGISTICS AND SERVICES PRIVATE LIMITED',
    'SHA CORPS PRIVATE LIMITED',
    'DABORD INFRA PRIVATE LIMITED',
    'GC NAKSUM PRIVATE LIMITED',
    'INDIVILLE MERCHANDIZE PRIVATE LIMITED',
    'STRASTA PRIVATE LIMITED',
    'EARTHLIFE ESSENTIALS PRIVATE LIMITED',
    'RIBBONATE TECHNOLOGIES PRIVATE LIMITED',
    'DRIVETRAIN AI TECHNOLOGIES PRIVATE LIMITED',
    'AVYAY SOLUTIONS INDIA PRIVATE LIMITED',
    'ISHAN BIO FILMS PRIVATE LIMITED',
    'UNICEM CEMENT PRIVATE LIMITED',
    'ALCONE TEX ENGINEERING PRIVATE LIMITED',
    'V-EFFICHARGE POWER-SYSTEMS PRIVATE LIMITED',
    'TEGO LEGAL TECHNOLOGIES PRIVATE LIMITED',
    'LEARNASYOUGO PRIVATE LIMITED',
    'APRICITAS ENGINEERING PRIVATE LIMITED',
    'ZQUARKS (OPC) PRIVATE LIMITED',
    'JODHANI ECO-LUTION PRIVATE LIMITED',
    'ULTRARATE SALES AND SERVICES PRIVATE LIMITED',
    'SKYLARK BUILDSPACE PRIVATE LIMITED',
    'KHUSHAL SOOD TRUSTEESHIP SERVICES PRIVATE LIMITED',
    'UJJWAL AUTOHUB PRIVATE LIMITED',
    'MALUR BANGARPET HIGHWAYS LIMITED',
    'MOTION PLUS AUTOMATION PRIVATE LIMITED',
    'VALVE ZONE & CONTROLS PRIVATE LIMITED',
    'VILLAGE FOOD COURTS PRIVATE LIMITED',
    'ANEX EXPRESS CARGO PRIVATE LIMITED',
    'SIGNIFTY VENTURES PRIVATE LIMITED',
    'SECURRA HEALTHCARE PRIVATE LIMITED',
    'ZENTAN CONSULTANCY PRIVATE LIMITED',
    'HOOTE GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'PRECOGNITAS HEALTH PRIVATE LIMITED',
    'RSK TECHNOSERV PRIVATE LIMITED',
    'PIXELDUST TECHNOLOGIES PRIVATE LIMITED',
    'QUALITY IT SOLUTIONS PRIVATE LIMITED',
    'VROZART DIGITAL PRIVATE LIMITED',
    'SUBHIKSHA WELLNESS SERVICES PRIVATE LIMITED',
    'PRAKRITISIDDHI TECHNOLOGIES PRIVATE LIMITED',
    'ICHHAWAR KRISHI PRODUCER COMPANY LIMITED',
    'CLOUDFORTI PRIVATE LIMITED',
    'SYSTEM CARES IT SOLUTIONS PRIVATE LIMITED',
    'UDYAMI MART ECOM PRIVATE LIMITED',
    'KIWI CONTENT PRIVATE LIMITED',
    'DEBARUP INDUSTRIES PRIVATE LIMITED',
    'OPTIFLUX TECH INNOVATIONS PRIVATE LIMITED',
    'FARMSTUM INDIA PRIVATE LIMITED',
    'SHOW N SHINE PRIVATE LIMITED',
    'MINHAPHARMA PRIVATE LIMITED',
    'BHANDARY SCHOOL BOOK PRIVATE LIMITED',
    'SRPACK PRINT PRIVATE LIMITED',
    'URBAN CASH & CARRY PRIVATE LIMITED',
    'JST CONSULTANCY SERVICES PRIVATE LIMITED',
    'TEXRENA PRIVATE LIMITED',
    'CONCRETE WORKS CONSTRUCTION CHEMICALS PRIVATE LIMITED',
    'BETELGEUSE REAL ESTATE PRIVATE LIMITED',
    'BENTOCOACH GLOBAL CONSULTANTS PRIVATE LIMITED',
    'COACH ME IN PRIVATE LIMITED',
    'PH91 PRIVATE LIMITED',
    'CODING ACADEMY (OPC) PRIVATE LIMITED',
    'SAVE (SOCIAL ACTIVITIES FOR VULNERABLE ENVIRONMENT) FOUNDATION',
    'LOCATION ONE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'WOODS HARDWARES AND FITTINGS PRIVATE LIMITED',
    'HIGHSTAGE INDIA PRIVATE LIMITED',
    'AGRICONNECT SOLUTIONS PRIVATE LIMITED',
    'SHETHJI AGRI COMMODITY PRIVATE LIMITED',
    'REDBRIDGE ENTERPRISES PRIVATE LIMITED',
    'SEVEN ISLANDS TRADING PRIVATE LIMITED',
    'ELON PRECISION ENGINEERING PRIVATE LIMITED',
    'IMEC DZIGN ENTERPRISE PRIVATE LIMITED',
    'UNDER PAR SPORTS TECHNOLOGIES PRIVATE LIMITED',
    'PEZOSYS INDIA PRIVATE LIMITED',
    'INNOVINC ASPIRE FOODSTUFF PRIVATE LIMITED',
    'DEKI ENERGY PRIVATE LIMITED',
    'STEPFORADDER SYSTEMS PRIVATE LIMITED',
    'LULULEMON INDIA (SERVICES) PRIVATE LIMITED',
    'BANGALORE MALUR HIGHWAYS LIMITED',
    'SIA ELITE BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'GULFTIC TESTING AND INSPECTION SERVICES PRIVATE LIMITED',
    'XLNT BUSINESS SERVICES PRIVATE LIMITED',
    'COINBASE INDIA SERVICES PRIVATE LIMITED',
    'ECOMOUNT BUILDERS AND DEVELOPERS PRIVATELIMITED',
    'HENHOT E-FOOD PRIVATE LIMITED',
    'NOVEL TRANSLOGISTICS PRIVATE LIMITED',
    'JHARCAN VENTURES PRIVATE LIMITED',
    'MBG CARD INDIA PRIVATE LIMITED',
    'PROVIDH TECHNOLOGIES PRIVATE LIMITED',
    'INDIAN SERVERS PRIVATE LIMITED',
    'VANES ENGINEERING INDIA PRIVATE LIMITED',
    'CONNECTEK CONSULT-IT PRIVATE LIMITED',
    'TECHCEDENCE INFOSYSTEMS PRIVATE LIMITED',
    'ULTRAFLY SOLUTIONS PRIVATE LIMITED',
    'DEZERV INVESTMENTS PRIVATE LIMITED',
    'PBBRULEE (OPC) PRIVATE LIMITED',
    'THIRDERA INDIA PRIVATE LIMITED',
    'PADMANAVA STUDIO PRIVATE LIMITED',
    'BIO-OXY PHARMA PRIVATE LIMITED',
    'PRIVI FINE SCIENCES PRIVATE LIMITED',
    'MOOPLE INDIA PRIVATE LIMITED',
    '315 WORK AVENUE PUNE SPACES PRIVATE LIMITED',
    '2EXCEL APP-TECH PRIVATE LIMITED',
    'AAZOL VENTURES (MUMBAI) PRIVATE LIMITED',
    'LOUDCURTAINS PRIVATE LIMITED',
    'OBEROITEL IVR PRIVATE LIMITED',
    'PLANT TALENT INDIA PRIVATE LIMITED',
    'NOSTAGA TECHNOLOGIES PRIVATE LIMITED',
    'MYFINVEST FINANCIAL ADVISORS PRIVATE LIMITED',
    'REDE FIN CAPITAL ADVISORY PRIVATE LIMITED',
    'ABUSHA ESTATES PRIVATE LIMITED',
    'DUBEY FOUNDATION',
    'MORII SOFTWARES (OPC) PRIVATE LIMITED',
    'HYPERTECHPRENEURS PRIVATE LIMITED',
    'AHAVA SERVICES PRIVATE LIMITED',
    'MEDICOSTORES.COM PRIVATE LIMITED',
    'VERACITY WELLNESS PRIVATE LIMITED',
    'BEEING EVENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'BIDWINGS INDIA PRIVATE LIMITED',
    'CROSSTOWER INDIA TRADING PRIVATE LIMITED',
    'ANSH GLOBAL TECHNOLOGIES SOLUTION PRIVATE LIMITED',
    'SWAYAM ANALYTICS PRIVATE LIMITED',
    'HARIOM IMPORT AND EXPORT CONSULTANCY PRIVATE LIMITED',
    'GRO DIGITAL PLATFORMS LIMITED',
    'MAHALAKSHMI BIOTECHNOLOGIES PRIVATE LIMITED',
    'GARDA TECH PRIVATE LIMITED',
    'MYLOGIC BUSINESS MANAGEMENT SCHOOL PRIVATE LIMITED',
    'CAREONE HOSPITAL AND RESEARCH CENTRE PRIVATE LIMITED',
    'SHIVANSH HR SERVICES PRIVATE LIMITED',
    'HAWAK PRIME SECURITY FORCE PRIVATE LIMITED',
    'REVOLUT PAYMENTS INDIA PRIVATE LIMITED',
    'ALUFIT INTERNATIONAL PRIVATE LIMITED',
    'JOURNYZ FROM ZINDA TECH PRIVATE LIMITED',
    'VASTUCHEM PRIVATE LIMITED',
    'WOLTER REALTY SERVICES PRIVATE LIMITED',
    'KNITT TECHNOLOGIES PRIVATE LIMITED',
    'SUMA SURFACES PRIVATE LIMITED',
    'BETTER CALL SAUL PRIVATE LIMITED',
    'MBKH SOLUTIONS PRIVATE LIMITED',
    'XOMOY INNOVATIVES PRIVATE LIMITED',
    'VIRTUALPIXELS MULTISERVICES PRIVATE LIMITED',
    'HEAVENLY VACATIONS PRIVATE LIMITED',
    'TEXTAXUS ACCOUNTANCY INDIA PRIVATE LIMITED',
    'U S OIL & GAS DISTRIBUTION PRIVATE LIMITED',
    'REVANZA GLOBAL VENTURES PRIVATE LIMITED',
    'YUVRAJ TECHPRINTS PRIVATE LIMITED',
    'AURIK GREEN SOLUTIONS PRIVATE LIMITED',
    'BMBANC INTERNATIONAL PRIVATE LIMITED',
    'DUDIGITAL BD PRIVATE LIMITED',
    'BESURE BUDDY PRIVATE LIMITED',
    'MCCOY ANIMATION PRIVATE LIMITED',
    'TRAVEO HOLIDAYS PRIVATE LIMITED',
    'RIGVED BUSINESS SOLUTIONS (OPC) PRIVATE LIMITED',
    'FINANIA CONSULTANCY PRIVATE LIMITED',
    'NETBRAIN TECHNOLOGIES PRIVATE LIMITED',
    'ZIBATECH WELLNESS PRIVATE LIMITED',
    'CASAGRAND FRESH PRIVATE LIMITED',
    'JYOTI TRANS CARGO PRIVATE LIMITED',
    'AV7 THE PRODUCT SERVIICES PRIVATE LIMITED',
    'VANITA WIRES PRIVATE LIMITED',
    'PRASHANTI INFRASTRUCTURE & CONSTRUCTION PRIVATE LIMITED',
    'APPTIVITY PRIVATE LIMITED',
    'SPECIALIST CYBER AND SECURITY SOLUTIONS PRIVATE LIMITED',
    'AL 50 ACTION LAB 2050 FOUNDATION',
    'KISHTWAR TRANSMISSION LIMITED',
    'MAATROM HR SOLUTION PRIVATE LIMITED',
    'CORNEIGHT PARKS PRIVATE LIMITED',
    'KRUTAK RESEARCH ANALYTICS PRIVATE LIMITED',
    'RIMJHIM STAINLESS ALLOYS PRIVATE LIMITED',
    'OZIN SKILL TECH PRIVATE LIMITED',
    'DRAUP BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RENTEQUIP GLOBAL PRIVATE LIMITED',
    'NEXTNEEDS MULTI SOLUTIONS PRIVATE LIMITED',
    'OCTOPUS LEGACY PRIVATE LIMITED',
    'TAXCREW ADVISORS (OPC) PRIVATE LIMITED',
    'S.P PRINTECH SOLUTIONS PRIVATE LIMITED',
    'DISCIDIUM SOLUTIONS (OPC) PRIVATE LIMITED',
    'NYAYA MITRA LIMITED',
    'RGJ CULTURAL AND CAREER DEVELOPMENT FOUNDATION',
    'YODISO INDIA PRIVATE LIMITED',
    'ISIKALI CONSULTANCY PRIVATE LIMITED',
    'SEPIO SOLUTIONS PRIVATE LIMITED',
    'BRAND MARKETING WORKS PRIVATE LIMITED',
    'SOFTTECH CARE FOUNDATION',
    'WISA INDIA PRIVATE LIMITED',
    'LEEN INNOVATIONS PRIVATE LIMITED',
    'A5G NETWORKS PRIVATE LIMITED',
    'CARBONEXT INDIA PRIVATE LIMITED',
    'SAPA LEARNING PRIVATE LIMITED',
    'BRSB SECURITIES PRIVATE LIMITED',
    'NAYA SAVERA SOCIAL FOUNDATION',
    'ECO LIFE INFRASTRUCTURE LIMITED',
    'DRIVEROAD SOLUTIONS PRIVATE LIMITED',
    'HARIKRUSHNA MACHINES PRIVATE LIMITED',
    'AUGMENT SIMULATION INDIA PRIVATE LIMITED',
    'HEALTHCARE CAPITAL PRIVATE LIMITED',
    'AISHWARYAM FACILITY SERVICES MANAGEMENT PRIVATE LIMITED',
    'INSYDWORKS TECHNOLOGIES PRIVATE LIMITED',
    'IIMBG INCUBATION CENTRE TO SUPPORT INNOVATION RESEARCH AND ENTREPRENEURSHIP',
    'SAHNI THREADS PRIVATE LIMITED',
    'TEKCORP PARADIGMS PRIVATE LIMITED',
    'NOVANATIVE INDIA PRIVATE LIMITED',
    'ADHVESH WEAVING PRIVATE LIMITED',
    'UNIKARMIC FOUNDATION',
    'GUEST BLOGGING TECHNOLOGY PRIVATE LIMITED',
    'DHRUVBOSE FOUNDATION',
    'AWESM BUSINESS CONSULTING PRIVATE LIMITED',
    'IVOK PLUITECH PRIVATE LIMITED',
    'ADWIZE CONSULTANCY PRIVATE LIMITED',
    'IWM CYBER SEC PRIVATE LIMITED',
    'TSC AUTO ID TECHNOLOGY INDIA PRIVATE LIMITED',
    'RIYAARTH FOOD TECH PRIVATE LIMITED',
    'REVSTRAT STRATEGY CONSULTING (OPC) PRIVATE LIMITED',
    'DAA TECHNOLOGIES PRIVATE LIMITED',
    'PROWEBHILL PRIVATE LIMITED',
    'SHIVSHAKTI AAROGYA FOUNDATION',
    'ATHAVANMATICHI PRIVATE LIMITED',
    'IGNITE DISCOVERY LABS PRIVATE LIMITED',
    'VIKRAYA TECHNOLOGIES PRIVATE LIMITED',
    'GLITZ VENTURES (OPC) PRIVATE LIMITED',
    'TECHLEAGUE ITSOL PRIVATE LIMITED',
    'N.C. JOHN GARMENTS PRIVATE LIMITED',
    'S FOOTWEAR WORLD PRIVATE LIMITED',
    'VIRI SOLUTIONS (OPC) PRIVATE LIMITED',
    'SMARTWASH SOLUTIONS PRIVATE LIMITED',
    'HEXOM INFOTECH PRIVATE LIMITED',
    'USABILITYEVOLUTION PRIVATE LIMITED',
    'TECHPAY SOLUTIONS PRIVATE LIMITED',
    'BHAMBARI PRINTERS PRIVATE LIMITED',
    'SRADDHA SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'CLOUD HATCH PRIVATE LIMITED',
    'TFCC INTERNATIONAL PRIVATE LIMITED',
    'R N PEB STRUCTURES PRIVATE LIMITED',
    'DARIYA LOGISTICS PRIVATE LIMITED',
    'QUALFIS GLOBAL PRIVATE LIMITED',
    'MATH MAP LEARNING (OPC) PRIVATE LIMITED',
    'APPTIVTECH SOLUTIONS PRIVATE LIMITED',
    'Q3G INDIA PRIVATE LIMITED',
    'DAT-A-CCURATE CONSULTING PRIVATE LIMITED',
    'JADE GLOBAL FOUNDATION',
    'ANTON ACADEMY PRIVATE LIMITED',
    'OML TOOLS & TECHNOLOGIES PRIVATE LIMITED',
    'VAKILGIRI FOUNDATION',
    'INDO GSP CHEMICALS PRIVATE LIMITED',
    'MAHALAXMI FOOD AND SPICES PRIVATE LIMITED',
    'CUREBRIDGE HEALTHCARE PRIVATE LIMITED',
    'SPORTSLG INDIA PRIVATE LIMITED',
    'BLUE MOUNTAIN PHARMACEUTICAL INDUSTRIES PRIVATE LIMITED',
    'MINUTUS COMPUTING PRIVATE LIMITED',
    'VATSON AUTOMATION PRIVATE LIMITED',
    'ALAMO REALTY INDIA PRIVATE LIMITED',
    'MRAWBITS COMPUTING (OPC) PRIVATE LIMITED',
    'PINKLOTUS HEALTH CARE PRIVATE LIMITED',
    'ADDON AFFILIATE SERVICES (OPC) PRIVATE LIMITED',
    'ELCOMPUTE TECHNOLOGIES PRIVATE LIMITED',
    'CLUTCH HEALTH PRIVATE LIMITED',
    'FIXLING SELLER SERVICES PRIVATE LIMITED',
    'VEE EDGE TECHNOLOGY PRIVATE LIMITED',
    'SILENTSTORE PRIVATE LIMITED',
    'IGREEN SHIPPING & LOGISTICS PRIVATE LIMITED',
    'SARVAJNA EDUTECH PRIVATE LIMITED',
    'DESERT STORM TECHNOLOGIES PRIVATE LIMITED',
    'BAY LEAF DIGITAL SERVICES PRIVATE LIMITED',
    'ODETTE E - RETAIL PRIVATE LIMITED',
    'CHUNGJEONG TECHNOLOGY PRIVATE LIMITED',
    'ZINAVO PRIVATE LIMITED',
    'STERILESOFT PRIVATE LIMITED',
    'ILAAMA FOODS PRIVATE LIMITED',
    'SMARTGIG TECHNOLOGIES PRIVATE LIMITED',
    'NUMBERSTACK CONSULTING PRIVATE LIMITED',
    'HYPERCAP PRIVATE LIMITED',
    'ESTATE HUNTERS INDIA PRIVATE LIMITED',
    'KREATELIST INFOTECH PRIVATE LIMITED',
    'RAJDANGA CHAMBERS OWNERS ASSOCIATION',
    'ORKS MARKETING PRIVATE LIMITED',
    'RVS VENTURES PRIVATE LIMITED',
    'SKETCH REALTY PRIVATE LIMITED',
    'SEERAJ FREIGHT PRIVATE LIMITED',
    'BREAK-THE-BARRIER FOUNDATION',
    'KMVPL KHAMMAM-DEVARAPALLE HIGHWAY PRIVATE LIMITED',
    'TANN TRIM PRIVATE LIMITED',
    'SAFRI SOLUTIONS PRIVATE LIMITED',
    'ARO TRANS PROJECT PRIVATE LIMITED',
    'TAURU LOGISTICS & WAREHOUSING PARK PRIVATE LIMITED',
    'ACCRUV PRIVATE LIMITED',
    'X3I SOLUTIONS PRIVATE LIMITED',
    'SCANORAD TELERADIOLOGY SERVICES (OPC) PRIVATE LIMITED',
    'ZRIYA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'DSJ TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'CUBIX NETWORKS PRIVATE LIMITED',
    'NEXT VENTURES INDIA PRIVATE LIMITED',
    'ORB GOLDEN DESIGNS PRIVATE LIMITED',
    'OPTIQUALL IT SOLUTIONS PRIVATE LIMITED',
    'TRISTEEL CONSULTING AND ENGINEERING PRIVATE LIMITED',
    'HOONAR TEKWURKS PRIVATE LIMITED',
    'KATOMARAN TECHNOLOGIES PRIVATE LIMITED',
    'WIZY SAAS PRIVATE LIMITED',
    'UNICUS JOBS (OPC) PRIVATE LIMITED',
    'IGNIS CAPITAL ADVISORS LIMITED',
    'AQUASTAR CONSULTING & ENGINEERING (INDIA) PRIVATE LIMITED',
    'UBUNTU IDEAS PRIVATE LIMITED',
    'SAFEXPAY TECHNOLOGIES PRIVATE LIMITED',
    'VED EDUSOL PRIVATE LIMITED',
    'FLAIR PLANET INDIA PRIVATE LIMITED',
    'LOGICALDNA TECHNO SYSTEMS PRIVATE LIMITED',
    'LANDMARKZ EPC PRIVATE LIMITED',
    'ZEALOPACE DESIGNS PRIVATE LIMITED',
    'DATAMOTIVE TECHNOLOGIES PRIVATE LIMITED',
    'MINONIM LIFESCIENCES PRIVATE LIMITED',
    'DIVINE FIRE SOLUTIONS PRIVATE LIMITED',
    'CREDILENT CERTIFICATIONS PRIVATE LIMITED',
    'AUNIK TRADING PRIVATE LIMITED',
    'WISH SOLUTIONS INDIA PRIVATE LIMITED',
    'MIXCART SHOPPING PRIVATE LIMITED',
    'LEGACY DIGITRONICS PRIVATE LIMITED',
    'NEOMEN DESIGNERS (OPC) PRIVATE LIMITED',
    'ESCAPE THE ORDINARY PRIVATE LIMITED',
    'EBIZ VERTICALS PRIVATE LIMITED',
    'EM3 FARM RESIDUE MANAGEMENT PRIVATE LIMITED',
    'COGDESIGN PRIVATE LIMITED',
    'GROUP POWER CONSULTING ENGINEERS PRIVATELIMITED',
    'EDUFIR PRIVATE LIMITED',
    'ARKIHIVE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PFS MANAGEMENT SERVICES INDIA PRIVATE LIMITED',
    'WELLWORKS TECHNOLOGIES PRIVATE LIMITED',
    'CLINIMD PRIVATE LIMITED',
    'TGHCO HEALTH SUPPORT SERVICES PRIVATE LIMITED',
    'SIB OPERATIONS AND SERVICES LIMITED',
    'FODXPERT ALLY PRIVATE LIMITED',
    'INSTABILL TECHNOLOGIES PRIVATE LIMITED',
    'RONAM TECHNOLOGIES PRIVATE LIMITED',
    'COVIANGELS FOUNDATION',
    'GRAVITAF PRIVATE LIMITED',
    'WOFT BUSINESS SERVICES PRIVATE LIMITED',
    'ALT-KUZNETS SUSTAINABILITY ADVISORS (OPC) PRIVATE LIMITED',
    'ECLAT PEOPLE ELEMENT PRIVATE LIMITED',
    'TRADEFORT INTERNATIONAL PRIVATE LIMITED',
    'SUPERQUEST SKILLEDSEARCHERS HR INDIA PRIVATE LIMITED',
    'GUNI INNOVATION FOUNDATION',
    'EDUCATION UNIPLUS DEVELOPMENT FOUNDATION',
    'ASPIRING EXCELLENCE PRIVATE LIMITED',
    'TAPAS EDUCATION PRIVATE LIMITED',
    'LITTLE RABBITS PRIVATE LIMITED',
    'TORUS PRIMERO EDUTECH PRIVATE LIMITED',
    'OPPORTUNITY CIRCLE FOUNDATION',
    'ACUVER FOUNDATION',
    '3I LIFE CARE SOLUTIONS PRIVATE LIMITED',
    'HELPZINDAGI FOUNDATION',
    'HELIUM MARINE SERVICES PRIVATE LIMITED',
    'TRINITY MANPOWER CONSULTING PRIVATE LIMITED',
    'INTERN THEORY CAREER SOLUTIONS PRIVATE LIMITED',
    'SHOUTLO DIGITAL PRIVATE LIMITED',
    'MAHA BHURI ADVISORY SERVICES PRIVATE LIMITED',
    'JUSTFLIK PRIVATE LIMITED',
    'EGNOSI INDIA PRIVATE LIMITED',
    'PRAYGA INDIA PRIVATE LIMITED',
    'GLRK HEALTHCARE FOUNDATION',
    'NEELAM GARG FOUNDATION',
    'AVIVA SPORTS FOUNDATION',
    'REDHELP FOUNDATION',
    'PINK DOOR FOUNDATION',
    'TLG TECHFIT PRIVATE LIMITED',
    'RED MAPLE PRODUCTIONS PRIVATE LIMITED',
    'BIZZY BABY MEDIA & ENTERTAINMENT PRIVATELIMITED',
    'YANTRAAPICTURES PRIVATE LIMITED',
    'RATLE HYDROELECTRIC POWER CORPORATION LIMITED',
    'PYRAMID SYSTECH CONSULTING PRIVATE LIMITED',
    'CHIKUPIKU FOUNDATION',
    'ONETRACKER TECHNOLOGIES PRIVATE LIMITED',
    'CELSIOR TECHNOLOGIES PRIVATE LIMITED',
    'EASYDEPLOY TECHNOLOGIES PRIVATE LIMITED',
    'EARTH PAWS PRIVATE LIMITED',
    'SHRIMATI SHANTABEN HARIBHAI GAJERA FOUNDATION',
    'AGX COLLABORATORY FORUM',
    'SAAHAS MEDICAL AND EDUCATIONAL FOUNDATION',
    'VISRAYA FOUNDATION',
    'MIEUX DISPLAY PRIVATE LIMITED',
    'HELIX MONEY PRIVATE LIMITED',
    'GREEN SHOOT ACADEMY PRIVATE LIMITED',
    'STARKENN TECHNOLOGIES PRIVATE LIMITED',
    'PURECRAFT BEVERAGES PRIVATE LIMITED',
    'SARGUN ENGINEERING PRIVATE LIMITED',
    'CHIRIPAL NOVA INDUSTRIES PRIVATE LIMITED',
    'ZENQUIP INDIA PRIVATE LIMITED',
    'DBCHEFS SOLUTIONS PRIVATE LIMITED',
    'CHECK AN INVOICE AUTOMATION PRIVATE LIMITED',
    'FTPL INDIA PRIVATE LIMITED',
    'KAYZAN AIRCON SOLUTIONS PRIVATE LIMITED',
    'KYYBA FILMS INDIA PRIVATE LIMITED',
    'INDCOAT OUTSOLES PRIVATE LIMITED',
    'AARNEE INTERNATIONAL PRIVATE LIMITED',
    'HEARTVALE HEALTHCARE SERVICES PRIVATE LIMITED',
    'KAPSN CONTAINER LINE PRIVATE LIMITED',
    'ARKIT INDUSTRIES INDIA PRIVATE LIMITED',
    'GRATUS CLUB PRIVATE LIMITED',
    'RESILLION INDIA PRIVATE LIMITED',
    'FUTUREHAT INNOVATIONS PRIVATE LIMITED',
    'TECHNICAL MAGE PRIVATE LIMITED',
    'TENSOR TOUR INDIA PRIVATE LIMITED',
    'INVOYZ FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'STEM WORKS CREATIVE PRODUCTS PRIVATE LIMITED',
    'QATAYWORLD PRIVATE LIMITED',
    'MOORE PIPE INDIA PRIVATE LIMITED',
    'DYNAMICS SPECTRUM PRIVATE LIMITED',
    'SUUMAYA FOUNDATION',
    'SECURITYHOUSE INDIA PRIVATE LIMITED',
    'ACCEND PHARMA PRIVATE LIMITED',
    'FIFTHFARM PRIVATE LIMITED',
    'BLUE METEOR PRIVATE LIMITED',
    'GROWTHSTATION CONSULTING SERVICES PRIVATE LIMITED',
    'RIASH TECH PRIVATE LIMITED',
    'SATISCOMM (INDIA) PRIVATE LIMITED',
    'SURGEUP TECHNOLOGIES PRIVATE LIMITED',
    'APOLLONGER DIGITAL SERVICES PRIVATE LIMITED',
    'INSIGHTAV CAD SERVICES (OPC) PRIVATE LIMITED',
    'OYELA TECHNOLOGIES PRIVATE LIMITED',
    'DEUDOOR TECH PRIVATE LIMITED',
    'WWOH INNOVATIONS PRIVATE LIMITED',
    'DKE PARTS PRIVATE LIMITED',
    'UFFIZIO TECHNOLOGIES PRIVATE LIMITED',
    'BYTESTRONE INDIA PRIVATE LIMITED',
    'KEYBRIDGE EDUCATION FOUNDATION',
    'GLYCO IT SERVICES (OPC) PRIVATE LIMITED',
    'NAVANC DATA SCIENCES PRIVATE LIMITED',
    'OM ARHAM ONLINE PRIVATE LIMITED',
    'AXIAMATIC TECHNOLOGIES PRIVATE LIMITED',
    'SCIENTIAL PHARMACEUTICALS PRIVATE LIMITED',
    'SARVADHI SOLUTIONS PRIVATE LIMITED',
    'ONECORE ENTERPRISES PRIVATE LIMITED',
    'WEBSTACK LABS PRIVATE LIMITED',
    'FINHERENT ASSETS PRIVATE LIMITED',
    'POOLE & PARTNERS PRIVATE LIMITED',
    'WHITESTONE VALUERS AND CONSULTANTS PRIVATE LIMITED',
    'BIGGPOCKET FINTECH PRIVATE LIMITED',
    'SAVE EAT FOODS PRIVATE LIMITED',
    'DAMOS INVESTMENT AND DEVELOPMENT PRIVATELIMITED',
    'ANAPTYSS INDIA PRIVATE LIMITED',
    'VISIONTEK NATURA PRIVATE LIMITED',
    'GOAT AI PRIVATE LIMITED',
    'AHLADA CLEAN ROOM TECH PRIVATE LIMITED',
    'BHVK AGROTECH PRIVATE LIMITED',
    'CARXCASH SERVICES PRIVATE LIMITED',
    'SAGAR LIFE CARE (INDIA) PRIVATE LIMITED',
    'SPAYCI AI LABS PRIVATE LIMITED',
    'TIMELESS BUSINESS PARK PRIVATE LIMITED',
    'SUVI TRADING PRIVATE LIMITED',
    'MISSION DEV INDIA PRIVATE LIMITED',
    'KANDOI HARIBHAI DAMODAR MITHAIWALA PRIVATE LIMITED',
    'ANOTHER FOODS PRIVATE LIMITED',
    'PAVANPUTRA POLYFAB INDIA PRIVATE LIMITED',
    'BUILDMUDRA FOUNDATION',
    'DATAVERSE SOLUTIONS PRIVATE LIMITED',
    'SAFALYA TECHNOLOGIES PRIVATE LIMITED',
    'KMSG TECHNOLOGIES PRIVATE LIMITED',
    'PRISHA TREKKING AND TRAVEL CAFE PRIVATE LIMITED',
    'SHW TECHNOLOGIES PRIVATE LIMITED',
    'NEW EDTECH SKILLS PRIVATE LIMITED',
    'SYBARISIP PRIVATE LIMITED',
    '40BEARS TECHCORP PRIVATE LIMITED',
    'ANANT RAJ DIGITAL PRIVATE LIMITED',
    'ELYSIUM CALIPARK FOUNDATION',
    'PRUTHVI BEVERAGES PRIVATE LIMITED',
    'SECUREICHI LABS PRIVATE LIMITED',
    'WHITE NEST PRIVATE LIMITED',
    'PITTIE ANTARIKSH REALTY PRIVATE LIMITED',
    'INCNBIZ EXPRESS PRIVATE LIMITED',
    'WATTAMWAR HEALTH CARE PRIVATE LIMITED',
    'FORMURA MOBILIA PRIVATE LIMITED',
    'ADVANTAGE CLUB TECHNOLOGIES PRIVATE LIMITED',
    'SRBH AGROTECH PRIVATE LIMITED',
    'DHANUKA CHEMICALS PRIVATE LIMITED',
    'HRDC PRIVATE LIMITED',
    'HAND CYBERNETICS PRIVATE LIMITED',
    'AVAADA SUNSHINE ENERGY PRIVATE LIMITED',
    'PRYM SHARED SERVICES INDIA PRIVATE LIMITED',
    'RADIANCE TN SOLAR PARK PRIVATE LIMITED',
    'ACQUAINTALL TECH PRIVATE LIMITED',
    'AVAADA TNGREEN PRIVATE LIMITED',
    'PROFESSIONAL MITRA PRIVATE LIMITED',
    'ZLIDEL SOLUTIONS (OPC) PRIVATE LIMITED',
    'I-SPARC TECHNOLOGIES PRIVATE LIMITED',
    'MEDIQUITY TECHNOLOGIES PRIVATE LIMITED',
    'ADIKAVI TEXTILES PRIVATE LIMITED',
    'BALVEERAM INDIA PRIVATE LIMITED',
    'NADELLA INFRA PRIVATE LIMITED',
    'PROWEALTH ENTERPRISES PRIVATE LIMITED',
    'BORED ROOM IDEAS PRIVATE LIMITED',
    'KHUB TECHNOLOGIES PRIVATE LIMITED',
    'BEEYIELD VENTURES PRIVATE LIMITED',
    'LANDOMEGA REALTY VENTURES PRIVATE LIMITED',
    'TEQ GREEN POWER XI PRIVATE LIMITED',
    'UBIQCOM INDIA PRIVATE LIMITED',
    'AGRIMENU FARMING TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'DILIP KUMAR BORAH FOUNDATION',
    'BEATOVEN PRIVATE LIMITED',
    'AZISTA AGRO FOODS PRIVATE LIMITED',
    'SOURCE FOR FUTURE VENTURES PRIVATE LIMITED',
    'SOHAM FREIGHT SERVICE PRIVATE LIMITED',
    'CARBON LIGHT PRIVATE LIMITED',
    'HOUSE CONCERT ENTERTAINMENT PRIVATE LIMITED',
    'STEADFAST IT CONSULTING PRIVATE LIMITED',
    'BLACKBUG LANDS PRIVATE LIMITED',
    'WHITE LEARN PRIVATE LIMITED',
    'SOFTSCALE SOLUTIONS PRIVATE LIMITED',
    'EVIFY LOGITECH PRIVATE LIMITED',
    'ARTIZE DIE MAKERS PRIVATE LIMITED',
    'AMIMA PROJECTS PRIVATE LIMITED',
    'EVEGAH MOBILITY PRIVATE LIMITED',
    'MOTORHUNK PRIVATE LIMITED',
    'DSCRIPTNEST TECHNOLOGIES PRIVATE LIMITED',
    'SYMCON INDUSTRIES PRIVATE LIMITED',
    'PRAHAN SOFT PRIVATE LIMITED',
    'CIRCULLENCE SOLUTIONS PRIVATE LIMITED',
    'SECURELY MANAGED INDIA PRIVATE LIMITED',
    'PRACSAL PRIVATE LIMITED',
    'SONU FLEXI PACK PRIVATE LIMITED',
    'JIRAAF PLATFORM PRIVATE LIMITED',
    'TOPHAT INFOTECH PRIVATE LIMITED',
    'SORTHIRE SOLUTIONS PRIVATE LIMITED',
    'WRUSHI MEDIHALL 24 PRIVATE LIMITED',
    '5T FOUNDATION',
    'BHIWANDI PROJECTS PRIVATE LIMITED',
    'ENVIRO AWARE PRIVATE LIMITED',
    'MELIUS INTEGRATED (OPC) PRIVATE LIMITED',
    'AI GROWTH INVESTMENT ADVISORS PRIVATE LIMITED',
    'NITESH ENTERPRISES PRIVATE LIMITED',
    'ELEGANT EARTH CONSTRUCTIONS PRIVATE LIMITED',
    'SPOLA TECHNOLOGIES PRIVATE LIMITED',
    'LEDGER LABS PRIVATE LIMITED',
    'CAPWISE FINANCIAL PRODUCTS DISTRIBUTION PRIVATE LIMITED',
    'DAY2DAY TAX INDIA PRIVATE LIMITED',
    'MARAUDER',
    'S ATTIC LITERARY SERVICES AND PUBLISHING PRIVATE LIMITED',
    'QQUENCH MEDIA PRIVATE LIMITED',
    'FEELGOOD PRODUCTION PRIVATE LIMITED (OPC)',
    'CODE MANTRA ENTERPRISES PRIVATE LIMITED',
    'FILMLION MEDIA PRIVATE LIMITED',
    'GLOBAL JOURNALS PRIVATE LIMITED',
    'SCIENTIFIC OPEN ACCESS JOURNALS PRIVATE LIMITED',
    'MARINASHION FOODS PRIVATE LIMITED',
    'DEVANSH DISTRIBUTIONS PRIVATE LIMITED',
    'MAREX CREATIVES PRIVATE LIMITED',
    'DEVSIDDH PUBLICATION PRIVATE LIMITED',
    'DIGITAL ARTS TECHNOLOGIES PRIVATE LIMITED',
    'INDMARK PAPERFORM PRIVATE LIMITED',
    'SREE GOKULAM TES AND CORC PUBLISHING PRIVATE LIMITED',
    'OPTIMAL SQUARE MEDIA PRIVATE LIMITED',
    'OOD MEDIA PRIVATE LIMITED',
    'NAMOKAR TIMES PRIVATE LIMITED',
    'COROMANDEL PRINTERS PRIVATE LIMITED',
    'KAVI PUVI VIAMEDIA PRIVATE LIMITED',
    'SRAG PRIVATE LIMITED',
    'IFFCO-MC CROP SCIENCE PRIVATE LIMITED',
    'VESTAL LIFESCIENCES PRIVATE LIMITED',
    'INSTANT RELIEF PHARMA PRIVATE LIMITED',
    'ZIPBOOKS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DIGIMARK ONLINE SERVICES PRIVATE LIMITED',
    'ARAMUC WORLDWIDE PRIVATE LIMITED',
    'S AND V STUDIO PRIVATE LIMITED',
    'COACT IMPRINTS PRIVATE LIMITED',
    'PIXEL PLUS MEDIA PRIVATE LIMITED',
    'JAMKAIN MEDIA VENTURES PRIVATE LIMITED',
    'BRILLARE SCIENCE PRIVATE LIMITED',
    'OMLOTUS YOGA GOODS& SERVICES (INDIA) PRIVATE LIMITED',
    'ECOTRAIL PERSONAL CARE PRIVATE LIMITED',
    'GACL-NALCO ALKALIES & CHEMICALS PRIVATE LIMITED',
    'ALMA LIFE SCIENCE PRIVATE LIMITED',
    'FASTO ADHESIVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ASSURE SURGILAB PRIVATE LIMITED',
    'BROADCOUSTIC MEDIA SOLUTIONS PRIVATE LIMITED',
    'EDUPULSE MEDIA PRIVATE LIMITED',
    'METAL FLOW LUBRICANTS & SOLUTIONS PRIVATE LIMITED',
    'NAYATI MEDICAL PRIVATE LIMITED',
    'DOVOY CHEMICALS INDIA PRIVATE LIMITED',
    'BONAYU LIFESCIENCES PRIVATE LIMITED',
    'CIPLA HEALTH LIMITED',
    'ACS ALTERNATIVE FUELS PRIVATE LIMITED',
    'SANTIAGO LIFE SCIENCES PRIVATE LIMITED',
    'CYSTRON PHARMA PRIVATE LIMITED',
    'INNER BEING WELLNESS PRIVATE LIMITED',
    'NICHINO INDIA PRIVATE LIMITED',
    'RENOVATE BIOLOGICALS PRIVATE LIMITED',
    'VAMSI PHARMA PRIVATE LIMITED',
    'BHARDWAJ INDIA PRIVATE LIMITED',
    'ANNORA PHARMA PRIVATE LIMITED',
    'SEUTIC LABS PRIVATE LIMITED',
    'AARKA MEDICARE PRIVATE LIMITED',
    'ORYGAMUS LABORATORIES PRIVATE LIMITED',
    'VEDIC AYUR WELLNESS INDIA PRIVATE LIMITED',
    'MEDRIX SOLUTIONS PRIVATE LIMITED',
    'AP NANOCATALYZERS INDIA PRIVATE LIMITED',
    'JBLD INTERNATIONAL PRIVATE LIMITED',
    'MALLET CHEMICALS PRIVATE LIMITED',
    'TRANS INDIA CERAMICS PRIVATE LIMITED',
    'THYLAKOID BIOTECH PRIVATE LIMITED',
    'EUGEN PRINTING & PACKAGING PRIVATE LIMITED',
    'MART INFO MEDIA PRIVATE LIMITED',
    'FESO SOCIAL MEDIA PRIVATE LIMITED',
    'ACCURATE ADS INDIA PRIVATE LIMITED',
    'SILGO RETAIL LIMITED',
    'KHUSHSAM JEWELLERS PRIVATE LIMITED',
    'PIYUSHI PRIME IMPEX PRIVATE LIMITED',
    'B&B GROWING INDUSTRIES PRIVATE LIMITED',
    '9DESIGN CRAFTS PRIVATE LIMITED',
    'VP AERO SOLUTIONS PRIVATE LIMITED',
    'GLITZ AND GLAM EXPO PRIVATE LIMITED',
    'INVENTIVE DOORS AND DECORS PRIVATE LIMITED',
    'SHREE RAM WOODEN INDUSTRIES PRIVATE LIMITED',
    'MEDIC SCIENCE LIFE CARE PRIVATE LIMITED',
    'MEDISTICS GLOBAL PRIVATE LIMITED',
    'RIGHT CHOICE AVIATION PRIVATE LIMITED',
    'GD BIKES PRIVATE LIMITED',
    'WABTEC TEXMACO RAIL PRIVATE LIMITED',
    'MABON TECHNOLOGIES PRIVATE LIMITED',
    'LANCETTE PLASTO PRIVATE LIMITED',
    'NECTAR PHYTOCHEMS PRIVATE LIMITED',
    'AVIRO WRITING INSTRUMENTS PRIVATE LIMITED',
    'BIHARILAL GREENWOOD PRIVATE LIMITED',
    'VRB ENTERPRISES PRIVATE LIMITED',
    'WESCO WOOD PRIVATE LIMITED',
    'IED GREENPOWER INDIA PRIVATE LIMITED',
    'LF RETAIL PRIVATE LIMITED',
    'SPECIALITY INTERIORS PRIVATE LIMITED',
    'RND Herbals Private Limited',
    'ARYAMOND LUXURY PRODUCTS PRIVATE LIMITED',
    'SOLIFLEX PACKAGING PRIVATE LIMITED',
    'IMAGEM JEWELLERS PRIVATE LIMITED',
    'TRISONS ARTS PRIVATE LIMITED',
    'TBA JEWELS PRIVATE LIMITED',
    'MARANGONI SOUTH ASIA PRIVATE LIMITED',
    'SOCIAL ORGANICS PRIVATE LIMITED',
    'NATURE PURE WELLNESS PRIVATE LIMITED',
    'BAJAJ WINDOWS PRIVATE LIMITED',
    'DR MANUFACTURING PRIVATE LIMITED',
    'UNITY FLEXI PACK GLOBAL PRIVATE LIMITED',
    'TAKSHVI GLOBAL BAG PRIVATE LIMITED',
    'HERAMBA RENEWABLES LIMITED',
    'ADANI POWER (JHARKHAND) LIMITED',
    'KROME DISPENSE PRIVATE LIMITED',
    'JAGWARE SANITARY INDUSTRIES PRIVATE LIMITED',
    'PERFECT MARMO GRANI IMPEX PRIVATE LIMITED',
    'SAGAR DIAMONDS LIMITED',
    'SISHU INTERNATIONAL PRIVATE LIMITED',
    'WINSOL ENGINEERS PRIVATE LIMITED',
    'PRIME RENEWABLES PRIVATE LIMITED',
    'CYBER ENERGY (OPC) PRIVATE LIMITED',
    'BAREWETHER ENTERPRISE PRIVATE LIMITED',
    'SPS COATINGS PRIVATE LIMITED',
    'MYTRAH AADHYA POWER PRIVATE LIMITED',
    'LIGHTRAY ENERGY PRIVATE LIMITED',
    'Hurricane Windfarms Private Limited',
    'PERENNIAL ELECTRICITY LIMITED',
    'ECOREN ONE WIND ENERGY PRIVATE LIMITED',
    'DOT PROPACK INDUSTRIES PRIVATE LIMITED',
    'CSE SANITARY TECHNOLOGY INDIA PRIVATE LIMITED',
    'HEYARU ENGINEERING PRIVATE LIMITED',
    'YORA ENTERPRISES PRIVATE LIMITED',
    'BLUE ANT DESIGNS PRIVATE LIMITED',
    'HETERO MED SOLUTIONS LIMITED',
    'HAMPI ENERGY LIMITED',
    'RAYDEON ENERGY PRIVATE LIMITED',
    'AADHAV ENERGY TECH PRIVATE LIMITED',
    'NIRJARA RENEWABLE PRIVATE LIMITED',
    'S.G. VAYU EQUIPMENTS PRIVATE LIMITED',
    'AASHMAN ENERGY PRIVATE LIMITED',
    'SHREYAS RENEWABLE ENERGY PRIVATE LIMITED',
    'SPK POWER INFRA PRIVATE LIMITED',
    'SONIC THERMAL Private Limited',
    'MARUDHAR STONES ITALIA PRIVATE LIMITED',
    'TRUSTED AEROSPACE ENGINEERING Private Limited',
    'PONDICHERRY SOLID WASTE MANAGEMENT COMPANY PRIVATE LIMITED',
    'SUKAVALA RENEWABLE ENERGY PRIVATE LIMITED',
    'AMRELI RENEWABLE ENERGY PRIVATE LIMITED',
    'RATABHE RENEWABLE ENERGY PRIVATE LIMITED',
    'PIPARTODA RENEWABLE ENERGY PRIVATE LIMITED',
    'AYUSHI PRIME ENTERPRISES PRIVATE LIMITED',
    'TIDY CASA PRIVATE LIMITED',
    'XL INTERNATIONAL Private Limited',
    'MARATHWADA ENVIRONMENTAL CARE CLUSTER',
    'IRM ENERGY LIMITED',
    'ZUKA POWER PRIVATE LIMITED',
    'FABA ECO FORCE ENERGY SOLUTIONS PRIVATE LIMITED',
    'EMBASSY-ENERGY PRIVATE LIMITED',
    'FAYA RENEWABLES AND POWER PROJECTS PRIVATE LIMITED',
    'MSGP ENERGY PRIVATE LIMITED',
    'ADANI TRANSMISSION BIKANER SIKAR PRIVATELIMITED',
    'KOHIMA-MARIANI TRANSMISSION LIMITED',
    'ATHENA HISAR SOLAR POWER PRIVATE LIMITED',
    'REWA ULTRA MEGA SOLAR LIMITED',
    'HARTEK SOLAR PRIVATE LIMITED',
    'ELGEN (INDIA) Private Limited',
    'RAJASTHAN URJA VIKAS AND IT SERVICES LIMITED',
    'ARKAY ENERGY (RAMESWARM) PRIVATE LIMITED',
    'OSTRO MAHAWIND POWER PRIVATE LIMITED',
    'SANWARIYA GAS (TWO) LIMITED',
    'AGRAWAL SOLAR POWER (UP) PRIVATE LIMITED',
    'YS ECOFIBRE PRIVATE LIMITED',
    'TIMARPUR-OKHLA WASTE MANAGEMENT COMPANY LIMITED',
    'REBARTECH SOLUTIONS PRIVATE LIMITED',
    'MET ASIA PRIVATE LIMITED',
    'HOFFMANN QUALITY TOOLS INDIA PRIVATE LIMITED',
    'CLENSTA INTERNATIONAL PRIVATE LIMITED',
    'PEPPERTRAIL TRADING PRIVATE LIMITED',
    'NEW SANROS AYURVEDIC PRIVATE LIMITED',
    'MEDOMED LIFE SCIENCE PRIVATE LIMITED',
    'MEDICANA PRIVATE LIMITED',
    'HAIR FROM INDIA PRIVATE LIMITED',
    'REDMOND HOME APPLIANCE TRADING PRIVATE LIMITED',
    'BUSINESS THRUST CONSULTANCY PRIVATE LIMITED',
    'DECOR REMEDY PRIVATE LIMITED',
    'APCO INFRATECH Private Limited',
    'BYTONNE ENTERPRISE PRIVATE LIMITED',
    'HOLLAND & SHERRY INDIA PRIVATE LIMITED',
    'BOANG TECHNOLOGY PRIVATE LIMITED',
    'DAXER TRADING PRIVATE LIMITED',
    'DUMETALS RECYCLING AND ALLOYS PRIVATE LIMITED',
    'SSURA SPIRITS PRIVATE LIMITED',
    'APPL CORP PRIVATE LIMITED',
    'ATLANTIS FORMULATIONS PRIVATE LIMITED',
    'KAIRVAM ELECTRONICS INDIA PRIVATE LIMITED',
    'BANKE BIHARI ELECTRONICS PRIVATE LIMITED',
    'L.I.I. TRADE PARK PRIVATE LIMITED',
    'ATNT LABORATORIES INDIA PRIVATE LIMITED',
    'EMINENCE ELECTROAPPLIANCES PRIVATE LIMITED',
    'SWIFTCOM CONVERGENCE DEVICES PRIVATE LIMITED',
    'CRYSTAL CHRONICLE PRIVATE LIMITED',
    'INLEAD ELECTRONICS PRIVATE LIMITED',
    'BVM OVERSEAS LIMITED',
    'MAXIMUS INTERNATIONAL LIMITED',
    'NOLTA KOTTARAM INDIA PRIVATE LIMITED',
    'TG CORP INDIA PRIVATE LIMITED',
    'KOMALAY INVESTRADE PRIVATE LIMITED',
    'SHIVAJIT SUCCESS PRIVATE LIMITED',
    'STUDIO19 OFFICES PRIVATE LIMITED',
    'FIRDAUS TEXTILES PRIVATE LIMITED',
    'GULF AGRO IMPEX PRIVATE LIMITED',
    'RAWLLEY HEALTHCARE PRIVATE LIMITED',
    'TECHCHEM SOLUTIONS PRIVATE LIMITED',
    'SAM EQUIPMENT & TRADERS PRIVATE LIMITED',
    'SEASONS CREATION PRIVATE LIMITED',
    'EBUTOR DISTRIBUTION PRIVATE LIMITED',
    'EMPHORIA ENTERPRISES PRIVATE LIMITED (OPC)',
    'KOYASON BUILDING MATERIALS PRIVATE LIMITED',
    'HERMOSO CERAMICS PRIVATE LIMITED',
    'VISHWAM POLYMERS PRIVATE LIMITED',
    'SOLAR PULSE ENERGY PRIVATE LIMITED',
    'EMINENT PIPE & PROFILES PRIVATE LIMITED',
    'MAXTREME PHARMA LIMITED',
    'FORETELL AUTOMOBILES PRIVATE LIMITED',
    'PRESCAPP WELLNESS PRIVATE LIMITED',
    'OSSWELL INDIA PRIVATE LIMITED',
    'APC POLYMERS PRIVATE LIMITED',
    'QUALICO BAZAAR PRIVATE LIMITED',
    'PEMAX EXPORTS PRIVATE LIMITED',
    'V3 KATHAN INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'VERSATILE IMPEX PRIVATE LIMITED',
    'ALLESTRO AERO SOLUTIONS PRIVATE LIMITED',
    'IMPULSE ENGINEERING EXPORTS PRIVATE LIMITED',
    'SCHATZ PHARMACEAUTICALS PRIVATE LIMITED',
    'GEOFFERY PHARMACEUTICALS PRIVATE LIMITED',
    'ALHAQUE MACHINES PRIVATE LIMITED',
    'AAYURITZ PHYTONUTRIENTS PRIVATE LIMITED',
    'SELLERSHELPLINE ONLINE SALES AND SERVICES PRIVATE LIMITED',
    'HANDS ON TRADES PRIVATE LIMITED',
    'CANDY DEZINE OPC PRIVATE LIMITED',
    'AUM CLEEN PRODUCTS PRIVATE LIMITED',
    'INTECH FIRE& SECURITY PRIVATE LIMITED',
    'SMART FUEL PRIVATE LIMITED',
    'WISHUP TECHNOLOGY PRIVATE LIMITED',
    'AASTHA HOME DESIGN IMPEX PRIVATE LIMITED',
    'PREM AGRI RESOURCES PRIVATE LIMITED',
    'ZAPP PRECISION METALS (INDIA) PRIVATE LIMITED',
    'ABMR TRADEX PRIVATE LIMITED',
    'HELIOS NETWORK PRIVATE LIMITED',
    'LTI VENTILATOREN (INDIA) PRIVATE LIMITED',
    'KAVYA TRADE OVERSEAS INDIA PRIVATE LIMITED',
    'E MACHINES TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BLOSSOM FLAVORS & FRAGRANCES PRIVATE LIMITED',
    'STG SENSOR INDIA PRIVATE LIMITED',
    'DRAGONFLY IMPEX PRIVATE LIMITED',
    'NAVEEN ENGINEERING AND SPECIALITY COATING PRIVATE LIMITED',
    'GRANDIOSE IMPORTS AND EXPORTS PRIVATE LIMITED',
    'HONEY DRUGS AND PHARMACEUTICALS PRIVATE LIMITED',
    'MAXIMA ACCORD TRADING PRIVATE LIMITED',
    'TRIUMPH GLOBAL INDIA PRIVATE LIMITED',
    'GHORECHA EXIM PRIVATE LIMITED',
    'ITALCO CERAMICA PRIVATE LIMITED',
    'TARANGINI HOME CARE PRIVATE LIMITED',
    'APPL INTERNATIONAL PRIVATE LIMITED',
    'MAPMED IMAGING INDIA PRIVATE LIMITED',
    'EEAC AUTOMATION PRIVATE LIMITED',
    'ENERGIA APPLIANCES PRIVATE LIMITED',
    'BEAUKEV PHARMA INTERNATIONAL PRIVATE LIMITED',
    'ZASHED FASHIONTECH PRIVATE LIMITED',
    'MPCG MOBILE PRIVATE LIMITED',
    'PACE E-COMMERCE VENTURES LIMITED',
    'FRESH WATER MEDICAL PRIVATE LIMITED',
    'LIFELONG ONLINE RETAIL PRIVATE LIMITED',
    'SAIITEMS INNOVATIVES PRIVATE LIMITED',
    'OLYMPIADOS HOLDING PRIVATE LIMITED',
    'ZILLION INTERNATIONAL PRIVATE LIMITED',
    'SREE GOKULAM CREDIT AND INVESTMENT PRIVATE LIMITED',
    'ANVAYA FIN SERVICES PRIVATE LIMITED',
    'WEDIB EXPRESS LIMITED',
    'TATA PLAY BROADBAND PRIVATE LIMITED',
    'HANSA HOLDINGS PRIVATE LIMITED',
    'O3 FINANCE PRIVATE LIMITED',
    'APRAJITA MICROFINANCE ASSOCIATION',
    'FACTS ONLINE PRIVATE LIMITED',
    'SHARE INDIA CAPITAL SERVICES PRIVATE LIMITED',
    'ESSEL ADVISORS LIMITED',
    'WEST END HOUSING FINANCE LIMITED',
    'WIZBYTE NETWORKS PRIVATE LIMITED',
    'INDOSTAR HOME FINANCE PRIVATE LIMITED',
    'JAY NOVATECH PRIVATE LIMITED',
    'NEDUMPARAMBIL KURIES PRIVATE LIMITED',
    'TEP INDIA PRIVATE LIMITED',
    'NEDUMPARAMBIL NIDHI LIMITED',
    'MONEXO FINTECH PRIVATE LIMITED',
    'TIJORI CAPITAL PRIVATE LIMITED',
    'UNIVERSAL FINGROWTH PRIVATE LIMITED',
    'FINOVA CAPITAL PRIVATE LIMITED',
    'CSL APOLLO ARC PRIVATE LIMITED',
    'LOGISYS ADVISORS PRIVATE LIMITED',
    'WEALTHTIGER INVESTMENT ADVISORS PRIVATE LIMITED',
    'TOUCHSTONE FINCAP LIMITED',
    'K-SECURE RISK MANAGEMENT & INSURANCE BROKING PRIVATE LIMITED',
    'PUREASSURE INSURANCE BROKERS PRIVATE LIMITED',
    'KREDIT INDIA ASSURANCE PRIVATE LIMITED',
    'KREDIT INDIA FINANCE & TECHNOLOGY PRIVATE LIMITED',
    'CENTRUM INSURANCE BROKERS LIMITED',
    'RFL INSURANCE BROKING PRIVATE LIMITED',
    'JAJODIA EQUITY ADVISORS SERVICES LIMITED',
    'DELHI GREEN ESTATE PRIVATE LIMITED',
    'PEACE WORTH INSURANCE BROKERS PRIVATE LIMITED',
    'TRUE FUNDS & INSURANCE MARKETING PRIVATE LIMITED',
    'BOBY CHEMMANUR NIDHI LIMITED',
    'AMRITHAM RADHAKRISHNA NIDHI LIMITED',
    'INNITI ALLIANCE PRIVATE LIMITED',
    'KAIYPETI CHITS PRIVATE LIMITED',
    'AVIOM INDIA HOUSING FINANCE PRIVATE LIMITED',
    'CHANDARANA SECURITIES PRIVATE LIMITED',
    'SILVERSTONE CONSULTANCY SERVICES PRIVATELIMITED',
    'SSD FINMAN CONSULTANCY PRIVATE LIMITED',
    'ITRANSFORM SHARE AND STOCK CONSULTANTS PRIVATE LIMITED',
    'SMARTCOIN FINANCIALS PRIVATE LIMITED',
    'DEV VARDAAN MICRO FINANCE',
    'ABLE SECURITIES INDIA PRIVATE LIMITED',
    'JANADHAN EQUITIES PRIVATE LIMITED',
    'ROYAL ARAVALI NIDHI INDIA LIMITED',
    'RASRUNI CAPITAL PRIVATE LIMITED',
    'MALIK MICROFINANCE FOUNDATION',
    'BOOTH FINTECH PRIVATE LIMITED',
    'KUBER KANAK MICROFINANCE ASSOCIATION',
    'FRANK MERCHANT BANKERS LIMITED',
    'RAAS INVESTMENTS (INDIA) PRIVATE LIMITED',
    'GSC INVESTORS ADVISORS PRIVATE LIMITED',
    'MAGNA WEALTH ADVISORS PRIVATE LIMITED',
    'ART FINTECH (INDIA) PRIVATE LIMITED',
    'MSF INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    'ART MONETARY INVESTMENTS (INDIA) PRIVATELIMITED',
    'ART P2P SERVICES (INDIA) PRIVATE LIMITED',
    'CDPQ INDIA PRIVATE LIMITED',
    'JAGTARNI ENTERPRISES LIMITED',
    'MONEYGOALS SOLUTIONS LIMITED',
    'INCREMINT CONSULTING PRIVATE LIMITED',
    'TEAM MONEY SERVICES PRIVATE LIMITED',
    'MADHURI ADVISORY AND ASSETS PRIVATE LIMITED',
    'EQX ANALYTICS PRIVATE LIMITED',
    'AKARA CAPITAL ADVISORS PRIVATE LIMITED',
    'MH MORTGAGE SERVICES PRIVATE LIMITED',
    'FINNOVENTURES FINANCIALSERVICES PRIVATE LIMITED',
    'KAPIL CHITS (TELANGANA) PRIVATE LIMITED',
    'SDR CHIT PRIVATE LIMITED',
    'TRAXON INVESTMENTS PRIVATE LIMITED',
    'CENTURY INSURANCE BROKERS PRIVATE LIMITED',
    'TMW FINTECH PRIVATE LIMITED',
    'SPARROW CAPITAL ADVISORS PRIVATE LIMITED',
    'AVENDUS CAPITAL ALTERNATE STRATEGIES PRIVATE LIMITED',
    'UNIVERSAL CURRENCY EXCHANGE (I) PRIVATE LIMITED',
    'MAURYAN CAPITAL MANAGEMENT PRIVATE LIMITED',
    'RECEIVABLES EXCHANGE OF INDIA LIMITED',
    'BRIJCAP INVESTMENT PRIVATE LIMITED',
    'MAURYAN TRUSTEESHIP PRIVATE LIMITED',
    'INDIA RESURGENCE ARC PRIVATE LIMITED',
    'NEPTUNE WEALTH PRIVATE LIMITED',
    'GRAPP TRADE & SERVICES PRIVATE LIMITED',
    'SWAN INVESTMENTORS PRIVATE LIMITED',
    'ESPRESSO FINANCIAL SERVICES PRIVATE LIMITED',
    'SLA FINSERV PRIVATE LIMITED',
    'SRI SATYA SAI & SRI SAI CHITS PRIVATE LIMITED',
    'TRADEWELL CAPFIN PRIVATE LIMITED',
    'MIRA INDIA MANAGEMENT SERVICES PRIVATE LIMITED',
    'BUILDSOIL MANAGEMENT PRIVATE LIMITED',
    'ART DISTRIBUTION (I) PRIVATE LIMITED',
    'PAAVANA INSURANCE BROKERS PRIVATE LIMITED',
    'BRIXTON INSURANCE BROKER PRIVATE LIMITED',
    'CLOCK TOWER OPERATION & MAINTENANCE SERVICES PRIVATE LIMITED',
    'SKYLET INFRA PRIVATE LIMITED',
    'JASAL TECHNOLOGIES PRIVATE LIMITED',
    'IRIZ ID TECHNOLOGIES PRIVATE LIMITED',
    'YOOBIKWITI TECHNOLOGIES PRIVATE LIMITED',
    'ACRETIX SOFTWARE PRIVATE LIMITED',
    'DELIVERAIN TECHNOLOGIES PRIVATE LIMITED',
    'SANCHA IT SOLUTIONS PRIVATE LIMITED',
    'GSTUDIO TECHNOLOGIES PRIVATE LIMITED',
    'WINGS2I SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'CREATIVELOGIC NETWORKING PRIVATE LIMITED',
    'FINNIRV SOLUTIONS PRIVATE LIMITED',
    'VRAIO SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BAYESIAN TECHNOLOGIES PRIVATE LIMITED',
    'TRESILIENT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DATASISAR INFOSOLUTIONS PRIVATE LIMITED',
    'SPECBEE CONSULTING SERVICES PRIVATE LIMITED',
    'SAW IT SERVICES PRIVATE LIMITED',
    'PLANKTON SOLUTIONS PRIVATE LIMITED',
    'JUMBOTAIL TECHNOLOGIES PRIVATE LIMITED',
    'L & Q TECHNOLOGIES PRIVATE LIMITED',
    'JOYLON MEDIA & TECHNOLOGY PRIVATE LIMITED',
    'SUNWIZTECH SYSTEMS PRIVATE LIMITED',
    'RADIIUSCARD SOLUTIONS PRIVATE LIMITED',
    'CODEMARK TECHNOLOGIES PRIVATE LIMITED',
    'HURREH TECHNOLOGIES PRIVATE LIMITED',
    'LAGOORI INNOVATION LABS PRIVATE LIMITED',
    'ALLGOVISION TECHNOLOGIES PRIVATE LIMITED',
    'CATALYSTOR SKILL NETWORK PRIVATE LIMITED',
    'EMBEDSENSE SOLUTIONS PRIVATE LIMITED',
    'BLUE SANTOS TECHNOLOGIES PRIVATE LIMITED',
    'MASTERS TECHNOLOGY BUSINEZ PRIVATE LIMITED',
    'PURPLEPATCH SOFTWARE PRIVATE LIMITED',
    'RAONEBYTES TECHNOLOGIES PRIVATE LIMITED',
    'QREAM SOLUTIONS PRIVATE LIMITED',
    'MEDKUMO SOFTWARE INDIA PRIVATE LIMITED',
    'XELPMOC DESIGN AND TECH LIMITED',
    'ASPION TECHNOLOGIES PRIVATE LIMITED',
    'EXPANDYS CONSULTING PRIVATE LIMITED',
    'BLUEBASIL MEDTECH PRIVATE LIMITED',
    'ALPHABETA INNOVATIONS PRIVATE LIMITED',
    'SNAPTRUDE TECHNOLOGIES PRIVATE LIMITED',
    'SANTA CIRCLE TECHNOLOGIES PRIVATE LIMITED',
    'KEYQUEST TECHNOLOGIES PRIVATE LIMITED',
    'OPEN APPLIANCES PRIVATE LIMITED',
    'HACHIKO TECHNOLOGIES PRIVATE LIMITED',
    'ACALVIO TECHNOLOGIES PRIVATE LIMITED',
    'PHIO TECHNOLOGIES PRIVATE LIMITED',
    'STELLARSLOG TECHNOVATION PRIVATE LIMITED',
    'EASYOPS TECHNOLOGIES PRIVATE LIMITED',
    'FRINGE TECHLABS PRIVATE LIMITED',
    'S WORLD OF HOLIDAYS PRIVATE LIMITED',
    'REAL TECHNOLOGY SYSTEMS PRIVATE LIMITED',
    'VASP ENGINEERS PRIVATE LIMITED',
    'LIONIA LED INDIA PRIVATE LIMITED',
    'VISTAR LOGITEK PRIVATE LIMITED',
    'ATLANTIS LIGHTING PRIVATE LIMITED',
    'INNOVATIVE EMM CARE PRIVATE LIMITED',
    'BVG Energy Efficiency Private Limited',
    'TM Automotive Seating Systems Private Limited',
    'WINDROSE CAPITAL PRIVATE LIMITED',
    'SHIVNERI MUTUAL BENEFIT NIDHI LIMITED',
    'Eximius Investments Private Limited',
    'CURRAE CAPITAL FINANCE PRIVATE LIMITED',
    'WELTWEIT INDUSTRIES LIMITED',
    'SEQUEL CORPORATE SERVICES PRIVATE LIMITED',
    'BITS AND BYTE IT CONSULTING PRIVATE LIMITED',
    '10x Smart Technologies Private Limited',
    'PERFECT MULTIVENTURE SOLUTION (INDIA) PRIVATE LIMITED',
    'Global Pallets Services India Private Limited',
    'Legalbabu Corporate Services Private Limited',
    'INEX ITES Research Private Limited',
    'NHK TECHNOLOGIES PRIVATE LIMITED',
    'FACADE ONE INTERNATIONAL PRIVATE LIMITED',
    'RAJEDIA PUMPS & SEALS PRIVATE LIMITED',
    'LUXQUISITE FASHIONS PRIVATE LIMITED',
    'A5E Consulting Private Limited',
    'WholesomeBasket Marketing Private Limited',
    'BLUEWAVES DISTRIBUTORS PRIVATE LIMITED',
    'PACIFIC CUSTOMS BROKER SERVICES PRIVATE LIMITED',
    'BROADPLACE ADVERTISING INDIA PRIVATE LIMITED',
    'Atzos Ventures Private Limited',
    'THANE MOTORS PRIVATE LIMITED',
    'CIRCULAR ANGLE PRIVATE LIMITED',
    'VIBGYOR DIGITAL PRIVATE LIMITED',
    'WINSPIRATION ENERGY & ENGINEERING PRIVATE LIMITED',
    'DEWAN STAFF FINDERS PRIVATE LIMITED',
    'JAYDEN SHIPPING & LOGISTICS PRIVATE LIMITED',
    'NAOS Skin Care India Private Limited',
    'Food Ingredients Manufacturers & Suppliers of India Association',
    'HUBMATRIX TECHNOLOGIES PRIVATE LIMITED',
    'WIND AND WAVES SHIPPING PRIVATE LIMITED',
    'Gurutvaa Systems Private Limited',
    'FILTRACON TECHNOLOGY PRIVATE LIMITED',
    'Bloom Advisors Private Limited',
    'v VAISHALI CONSULTANT PRIVATE LIMITED',
    'ANGEL FACADE ENGINEERS PRIVATE LIMITED',
    'DIGITAL CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'Ushva Clean Technology Private Limited',
    'IREWARDS SOLUTIONS PRIVATE LIMITED',
    'DeVagabond Outdoor Private Limited',
    'CHAMADIA BROTHERS PROPERTIES PRIVATE LIMITED',
    'Final Deal Consultants Private Limited',
    'CERES HOTELS PRIVATE LIMITED',
    'YASHUSS UNLIMITED BUSINESS SOLUTIONS PRIVATE LIMITED',
    'COMMANDO NETWORKS PRIVATE LIMITED',
    'Acuatron Hydraulics Private Limited',
    'ARCHEL LIGHTING PRIVATE LIMITED',
    'Brio Climator Private Limited',
    'GLOBAL FACILITIES PRIVATE LIMITED',
    'ProActive Crewing and Offshore Services Private Limited',
    'Leadge Business Services Private Limited',
    'Hadwise Technologies Private Limited',
    'PREMOID GLOBAL CAPITAL ADVISORS PRIVATE LIMITED',
    'KARRM TRADING PRIVATE LIMITED',
    'Technoquest Consulting Private Limited',
    'ICHI VENTURES PRIVATE LIMITED',
    'Motvic Engineering Global Private Limited',
    'Remitware Payments Private Limited',
    'Grifols India Healthcare Private Limited',
    'DESIGN 24X7 INDIA PRIVATE LIMITED',
    'VERSALLIES VENTURES PRIVATE LIMITED',
    'INDIAN INSTITUTE OF KNOWLEDGE AND DEVELOPMENT PRIVATE LIMITED',
    'BIOALTUS LABORATORIES PRIVATE LIMITED',
    'APOLLO FIRE PROTECTION SYSTEMS PRIVATE LIMITED',
    'United Freight Management Private Limited',
    'Dreams ARTbank Private Limited',
    'RETECK ENVIROTECH PRIVATE LIMITED',
    'SLAVS AGROTECH PRIVATE LIMITED',
    'FISAGE SOLUTIONS PRIVATE LIMITED',
    'JME SERVICES INDIA PRIVATE LIMITED',
    'K-FX Services Private Limited',
    'MAGNUM MANAGEMENT AND SERVICES PRIVATE LIMITED',
    'VIRAT AMBE SPORTS CLUB PRIVATE LIMITED',
    'NMR LOGISTICS PRIVATE LIMITED',
    'Flemingo Corporate Services Private Limited',
    'INTERNATIONAL AIR SHIPPERS ASSOCIATION',
    'KITCHEN KRAFT ENTERPRISES PRIVATE LIMITED',
    'APLUS VISION OPC PRIVATE LIMITED',
    'EDUTIMES CONSULTANCY PRIVATE LIMITED',
    'I CAN EVENTS PRIVATE LIMITED',
    'PAPRIKA IDEA LABS PRIVATE LIMITED',
    'GURAV MARINE SERVICES PRIVATE LIMITED',
    'PD Square Design Studio Private Limited',
    'EXHIBITIONS & TRADE SERVICES INDIA PRIVATE LIMITED',
    'JDC GLOBAL LOGISTICS PRIVATE LIMITED',
    'KONFER NETPRESENCE PRIVATE LIMITED',
    'JYOTIRAJ INFOSYSTEM PRIVATE LIMITED',
    'Hollywood Amusement Parks Private Limited',
    'FUSION PRACTICES TECHNOLOGIES PRIVATE LIMITED',
    'YOGAKSHEMA CONSULTANCY SERVICES PRIVATE LIMITED',
    'SNOW-EX LOGISTICS PRIVATE LIMITED',
    'INTELLIGENT CONSULTING ENGINEERS AND BUILDERS PRIVATE LIMITED',
    'TEKSUS GEOMATICS PRIVATE LIMITED',
    'F5 TECHNO SOLUTIONS PRIVATE LIMITED',
    'UKA Consulting & Engineers Private Limited',
    'MUMBAI MESS SERVICES PRIVATE LIMITED',
    'Jetway Broadband India Private Limited',
    'GOAPPTIV PRIVATE LIMITED',
    'KRUSHI VALLABH INDUSTRIES PRIVATE LIMITED',
    'WorldHaus Construction Private Limited',
    'EkaVidha Corporate Services Private Limited',
    'Ledonix Technologies Private Limited',
    'Tenacity Clothing and Services Private Limited',
    'Nostalgic Foods Retail Private Limited',
    'Estratys Retail Private Limited',
    'ZSP DESIGN STUDIO PRIVATE LIMITED',
    'Assetz Industrial Parks Private Limited',
    'Infrasquare Realty Private Limited',
    'Healux International Private Limited',
    'OUI FOOD & HOSPITALITY PRIVATE LIMITED',
    'ANCHOR POINT HOSPITALITY PRIVATE LIMITED',
    'KPN Hospitality Private Limited',
    'FREIGHTCO 3PL PRIVATE LIMITED',
    'INTELLO TRADING PRIVATE LIMITED',
    'Kinematic Foodtech Private Limited',
    'Bartersphere Trading Private Limited',
    'MUSTEK AUTOMATION PRIVATE LIMITED',
    'VISTAP DESIGN CONCEPTS PRIVATE LIMITED',
    'WHITE PROJECTS PRIVATE LIMITED',
    'Yelahanka - AP border Tollways Private Limited',
    'ASSETZ PREMIUM HOMES PRIVATE LIMITED',
    'Home Trail Logistics Private Limited',
    'BULLET TRANS SOLUTIONS PRIVATE LIMITED',
    'RoyalBison AutoRentals India Private Limited',
    'Firefly Logistics Private Limited',
    'Navigana Technologies Private Limited',
    'AVIVA SMART SOLUTIONS PRIVATE LIMITED',
    'DGTG Marketing & Retail private limited',
    'GRESSCO CERAMIC TECHNOLOGY PRIVATE LIMITED',
    'ASSETZ PREMIUM HOLDINGS PRIVATE LIMITED',
    'RIDA ESTATES PRIVATE LIMITED',
    'XIAOMI COMMUNICATIONS AND LOGISTICS INDIA PRIVATE LIMITED',
    'Intello Transpo Private Limited',
    'AVIATORS AIR RESCUE PRIVATE LIMITED',
    'AIRLIFT TRANS OCEANIC PRIVATE LIMITED',
    'AVIKAM LOGISTICS PRIVATE LIMITED',
    'ROYAUME DEVELOPERS PRIVATE LIMITED',
    'Zinka Logistics Solutions Private Limited',
    'E-FRT AEROCEAN LOGISTICS PRIVATE LIMITED',
    'ALPHA CABS PRIVATE LIMITED',
    'Teem TravelWorld Private Limited',
    'Mera Transport Exchange Private Limited',
    'TAXSHE SERVICES PRIVATE LIMITED',
    'MPLIFIRE ONLINE SALES AND SERVICES PRIVATE LIMITED',
    'Dtree India Trading Private Limited',
    'DYNATRACK TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Loyal Hospitality Private Limited',
    'Bean Berry Resorts Private Limited',
    'HIGH SKY HOSPITALITY SERVICES PRIVATE LIMITED',
    'Adisseo Animal Nutrition Private Limited',
    'ZOYASHI RETAIL PRIVATE LIMITED',
    'KADAMBAAS HOSPITALITY PRIVATE LIMITED',
    'Shippr Technologies PRIVATE LIMITED',
    'Honeycomb Telnet Private Limited',
    'VOLVO FINANCIAL SERVICES (INDIA) PRIVATELIMITED',
    'ACP Investment Advisory Private Limited',
    'UTTHEJANA TRADING AND SERVICES PRIVATE LIMITED',
    'NIVARA HOME FINANCE LIMITED',
    'INFINITI CHIT FUNDS PRIVATE LIMITED',
    'Anemones Hospitality and Hotels Private Limited',
    'Jana Capital Limited',
    'MC CATERERS PRIVATE LIMITED',
    'COMMUNITY INDIA HOSPITALITY & RESORTS PRIVATE LIMITED',
    'Residencia Property Management Private Limited',
    'SAAHIB KITCHENS INDIA PRIVATE LIMITED',
    'T A JETS PRIVATE LIMITED',
    'ZIP CAB SERVICE PRIVATE LIMITED',
    'NAVRATNA SOLUTIONS PRIVATE LIMITED',
    'CBCB REALTY PRIVATE LIMITED',
    'GSN FREIGHT FORWARDING INDIA PRIVATE LIMITED',
    'DUIS MATERIAL HANDLING PRIVATE LIMITED',
    'Zenith Dwellings Private Limited',
    'TWP Retail Private Limited',
    'Polyphase Engineering Private Limited',
    'Aquaswim Impex Private Limited',
    'HEYWORLD HOLIDAY PRIVATE LIMITED',
    'GOLDEN BELL TRAVEL SOLUTIONS PRIVATE LIMITED',
    'PAXANIMI SERVICES PRIVATE LIMITED',
    'RideAlly Travels Private Limited',
    'PRIMECORP REALTY PRIVATE LIMITED',
    'Byond eTravel & Entertainment Private Limited',
    'SUNDAY TRAVELS PRIVATE LIMITED',
    'VRISHA INFRASTRUCTURE PRIVATE LIMITED',
    'PROP SHIKAAR CONSULTANTS PRIVATE LIMITED',
    'Assetz Communities Development Private Limited',
    'Luxquisite Parkland Private Limited',
    'eGATE TRAVEL SOLUTIONS PRIVATE LIMITED',
    'SHRIPROP AEROSPACE PRIVATE LIMITED',
    'Shriprop Living Space Private Limited',
    'SAMAY SHELTERS PRIVATE LIMITED',
    'Full Basket Property Services Private Limited',
    'SLPKG ESTATE HOLDINGS PRIVATE LIMITED',
    'Oaktree Properties Private Limited',
    'FORTIUS CONSTRUCTIONS PRIVATE LIMITED',
    'Value Home Properties Private Limited',
    'triune Travels and Money Changers India Private Limited',
    'KUMAR AND KUMAR INVESTMENTS PRIVATE LIMITED',
    'INTELEXEL BMS PRIVATE LIMITED',
    'WEDMANTRA DIGITAL PRIVATE LIMITED',
    'AXIOM COMPLIANCE PRIVATE LIMITED',
    'BUDLI INTERNET PRIVATE LIMITED',
    'XIPHIAS IMMIGRATION PRIVATE LIMITED',
    'NORTE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Accoguru Services Private Limited',
    'OVI HOSTING PRIVATE LIMITED',
    'VIKARA SERVICES PRIVATE LIMITED',
    'HULA INFOTAINMENT STUDIOS PRIVATE LIMITED',
    'HiLITE TURNKEY INTERIORS PRIVATE LIMITED',
    'KeyResource Manpower Consultancy Private Limited',
    'Nebula3D Services Private Limited',
    'ZenMeter Solutions Private Limited',
    'SUCCEED TECHNOLOGIES PRIVATE LIMITED',
    'Citizengage Solutions Private Limited',
    'ASMINOS GLOBAL PRIVATE LIMITED',
    'GCN BROADBAND PRIVATE LIMITED',
    'ICYCLE SOLUTIONS PRIVATE LIMITED',
    'SUCCINNOVA TECHNOLOGIES PRIVATE LIMITED',
    'INVESTOCK BROKERS PRIVATE LIMITED',
    'Laughter Yoga International Private Limited',
    'SHREEM DATATECH SOLUTIONS PRIVATE LIMITED',
    'TRANWAY TECHNOLOGIES LIMITED',
    'WHITETABLE TECHNOLOGIES PRIVATE LIMITED',
    'SMAK CONCEPTS PRIVATE LIMITED',
    'RAKEMP MECHTRONICS PRIVATE LIMITED',
    'SWAN BUSINESS ASSOCIATES INDIA PRIVATE LIMITED',
    'TOTUS FACILITY SERVICES PRIVATE LIMITED',
    'BIND BIND E-COMMERCE PRIVATE LIMITED',
    'Comezzo Marketing Technology Private Limited',
    'Brave New World Communications Private Limited',
    'Recstech technology private limited',
    'Timespan Management Private Limited',
    'NOBILIS NRI TAXATION ADVISORY PRIVATE LIMITED',
    'Carthero technologies Private Limited',
    'RUPTUB SOLUTIONS PRIVATE LIMITED',
    'DELIGHTFUL GOURMET PRIVATE LIMITED',
    'Blore Productions Private Limited',
    'Baa Parametric Private Limited',
    'ESTHENOS TECHNOLOGIES PRIVATE LIMITED',
    'AMRITAYA LOGISTIICS PRIVATE LIMITED',
    'VELANKANI CLOUD SOLUTIONS PRIVATE LIMITED',
    'Liquid Works Media Private Limited',
    'PARTS2BUILD TECHNOLOGIES PRIVATE LIMITED',
    'AMIRA LIFESTYLE PRIVATE LIMITED',
    'Qwikinnovate Services Private Limited',
    'SPLENDENTE RETAILS PRIVATE LIMITED',
    'SCIS Interiors Services Private Limited',
    'WOC SOLUTIONS PRIVATE LIMITED',
    'MINIONS VENTURES PRIVATE LIMITED',
    'EMBAUCHE INFOTECH SOLUTIONS PRIVATE LIMITED',
    'POBALCO FIRE & SAFETY SOLUTIONS PRIVATE LIMITED',
    'Callidus Social Enterprises Private Limited',
    'SREE NARAYANA FACILITIES PRIVATE LIMITED',
    'ADCANOPUS DIGITAL MEDIA PRIVATE LIMITED',
    'Strongfield Technologies India Private Limited',
    'AEROSPACE AND AVIATION SECTOR SKILL COUNCIL',
    'WILOOP NETWORKS PRIVATE LIMITED',
    'INDOOR BIOTECHNOLOGIES INDIA PRIVATE LIMITED',
    'INNER VOICE CONSULTANCY PRIVATE LIMITED',
    'RankSurge Learning Private Limited',
    'TAOM LEARNING PRIVATE LIMITED',
    'Learnito Education Private Limited',
    'VIDEOGYAN STUDIOS PRIVATE LIMITED',
    'ToonMedia Consulting Private Limited',
    'WARD FOUR CONSULTING PRIVATE LIMITED',
    'ATHEOS EDUCATIONAL INITIATIVES PRIVATE LIMITED',
    'QUADRA POINT BRAND SERVICES PRIVATE LIMITED',
    'EZEESMART EDUCATION PRIVATE LIMITED',
    'ABEL Training Private Limited',
    'DOTS LEARNING ACADEMY PRIVATE LIMITED',
    'EF Site Technologies Private Limited',
    'GREEN WORLD ESG CONSULTANTS FOUNDATION',
    'One Health Solutions Private Limited',
    'RX HOSPITALS PRIVATE LIMITED',
    'KNOWURTURE HEALTH SOLUTIONS INDIA PRIVATE LIMITED',
    'iMICRON WEB SERVICES PRIVATE LIMITED',
    'Loginomic Tech Solutions Private Limited',
    'GetLook Technology Private Limited',
    'SAICOOPER HR EXTENSION PRIVATE LIMITED',
    'SPECTRUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Everwell Health Solutions Private Limited',
    'KHATAU ENGINEERING SERVICES PRIVATE LIMITED',
    'UNITED PLANNTATIONN LIMITED',
    'PlaySolar Systems Private Limited',
    'Narayana Vaishno Devi Specialty Hospitals Private Limited',
    'ALPHACENTRIC HEALTHCARE PRIVATE LIMITED',
    'Neuroglia Health Private Limited',
    'INDIAN FOUNDATION FOR SAFE BLOOD',
    'OPENTURF TECHNOLOGIES PRIVATE LIMITED',
    'CineBee Reviews Private Limited',
    'MEDICAID ETHOS PRIVATE LIMITED',
    'Greyfalcon Healthcare Private Limited',
    'RESTORE PHYSIO PRIVATE LIMITED',
    'CRYSTAL EYE SECURE SOLUTIONS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING TWO LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING THREE LIMITED',
    'ADANI GREEN ENERGY (TAMILNADU) LIMITED',
    'ADANI WIND ENERGY KUTCHH ONE LIMITED',
    'ZEMIRA RENEWABLE ENERGY LIMITED',
    'FIRST LIGHT ASSET MANAGEMENT PRIVATE LIMITED',
    'SAMSARA LAND & INFRAVENTURES PRIVATE LIMITED',
    'V.L.INFRAPROJECTS LIMITED',
    'INDOCHIN DEVELOPMENT PRIVATE LIMITED',
    'DHARMAJ CROP GUARD LIMITED',
    'AUMENTO POLYMER TEKNIKS PRIVATE LIMITED',
    'KHAJIT CHEM PRIVATE LIMITED',
    'FOREVER LIFESCIENCE PRIVATE LIMITED',
    'SINGALA PROPERTY DEALER PRIVATE LIMITED',
    'AMANTA MARKETING PRIVATE LIMITED',
    'GREEN CLEAN FAB PRIVATE LIMITED',
    'TORQUE COMMERCIAL VEHICLES PRIVATE LIMITED',
    'PURE CARS PRIVATE LIMITED',
    'MINRAK WORLDWIDE PRIVATE LIMITED',
    'VISHAKHA MOULDINGS PRIVATE LIMITED',
    'PRIOR EXIM PRIVATE LIMITED',
    'AZEEN EXIM PRIVATE LIMITED',
    'VEE RUBBER INDIA PRIVATE LIMITED',
    'KONSYL PHARMACEUTICALS PRIVATE LIMITED',
    'SPM MULTIPACK PRIVATE LIMITED',
    'NIRAJ POLYMERS PRIVATE LIMITED',
    'HRPL RESTAURANTS PRIVATE LIMITED',
    'HARSHVIJAY EXIM OPC PRIVATE LIMITED',
    'HBM GARMENTS PRIVATE LIMITED',
    'OSCAR VALVES PRIVATE LIMITED',
    'ALOMA ENTERPRISE PRIVATE LIMITED',
    'ARVIND BEAUTY BRANDS RETAIL LIMITED',
    'INDEQUIP ENGINEERING LIMITED',
    'SHREE VISHWAKARMA ALU PROJECTS PRIVATE LIMITED',
    'STEEFO ENGINEERING PRIVATE LIMITED',
    'NUTRAWORLD LIFECARE PRIVATE LIMITED',
    'JN INFRATECH PRIVATE LIMITED',
    'ACE MICA PRIVATE LIMITED',
    'YANTRA WORLD SIGHTSEEING PRIVATE LIMITED',
    'TRIP CENTER WORLDWIDE PRIVATE LIMITED',
    'SURYAKAMAL INFRA PRIVATE LIMITED',
    'AMANTA HOSPITALS PRIVATE LIMITED',
    'COREL PHARMA CHEM PRIVATE LIMITED',
    'G M BIOCHEM PRIVATE LIMITED',
    'DHRU VEHICLES PRIVATE LIMITED',
    'VIBRANT INSURANCE BROKING PRIVATE LIMITED',
    'KARNAVATI INSURANCE BROKERS PRIVATE LIMITED',
    'Tashi Pharma Private Limited',
    'EMPEZAR INTERNATIONAL PRIVATE LIMITED',
    'SAMSARA BUILDTECH PRIVATE LIMITED',
    'JRM EXPORT PRIVATE LIMITED',
    'CHARTERED NEM PRIVATE LIMITED',
    'ERONKAN TECHNOLOGIES PRIVATE LIMITED',
    'AHMEDABAD INFORMATICS SYSTEMS PRIVATE LIMITED',
    'HSB INFOTECH PRIVATE LIMITED',
    'SSB DIGITAL PRIVATE LIMITED',
    'RHV ENTERPRISE PRIVATE LIMITED',
    'ALBATROSS PROJECTS RF TECHNOLOGY INDIA PRIVATE LIMITED',
    'BHARATJI DESIGNER JEWELLERY PRIVATE LIMITED',
    'MIRANA FOODS PRIVATE LIMITED',
    'ART CLUB PRIVATE LIMITED',
    'Dwaravati Creation and Consultancy Private Limited',
    'GainBuzz Media Private Limited',
    'TARGETED BITS MARKETING PRIVATE LIMITED',
    'BOTREE TECHNOLOGIES PRIVATE LIMITED',
    'ECLEVA PRIVATE LIMITED',
    'ACQUATIC CONTAINER LINES PRIVATE LIMITED',
    'ZEN AVIATION PRIVATE LIMITED',
    'MYLASTMINUTETRIP PRIVATE LIMITED',
    'CROSS COUNTRY CONTRACTORS PRIVATE LIMITED',
    'EVERCREST PROJECTS PRIVATE LIMITED',
    'SATYAM DEVELOPERS (GUJARAT) PRIVATE LIMITED',
    'BAKERI PROJECTS PRIVATE LIMITED',
    'GRD SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'SIYASIZA LOGISTICS PRIVATE LIMITED',
    'APEX AUTOLINKS PRIVATE LIMITED',
    'REAL VASTU HOMES PRIVATE LIMITED',
    'GORAJ INFRASTRUCTURE PRIVATE LIMITED',
    'AMG BUSINESS SOLUTIONS PRIVATE LIMITED',
    'POLSTA MOBILE TECH PRIVATE LIMITED',
    'MAJESCO SOFTWARE AND SOLUTIONS INDIA PRIVATE LIMITED',
    'Indimedi Solutions Private Limited',
    'VNC TECHNOLOGIES PRIVATE LIMITED',
    'RAIDLAYER WEBHOST PRIVATE LIMITED',
    'PIXLOGIX INFOTECH PRIVATE LIMITED',
    'UPLERS SOLUTIONS PRIVATE LIMITED',
    'FLEXIWARE SOLUTIONS PRIVATE LIMITED',
    'LIVEKEEPING TECHNOLOGIES PRIVATE LIMITED',
    'EQUBE INFOTECH PRIVATE LIMITED',
    'CIRIGHT SOFTWARE SYSTEMS PRIVATE LIMITED',
    'Thinkbiz Technology Private Limited',
    'DYRECT DIGITAL PRIVATE LIMITED',
    'KRIOS PRODUCTS PRIVATE LIMITED',
    'GADHIYA TRAVELHUB PRIVATE LIMITED',
    'AEVUM INFOSOFT PRIVATE LIMITED',
    'VASUDHAIVA KUTUMBAKAM GROUP PRIVATE LIMITED',
    'DHOLAKIA FOUNDATION',
    'COMMUNITY BUSINESS (INDIA) PRIVATE LIMITED',
    'J L.GROWTH FUND LIMITED',
    'UNMUTE MANAGEMENT PRIVATE LIMITED',
    'TIMWE INDIA PRIVATE LIMITED',
    'Boeing India Defense Private Limited',
    'TAWI INDUSTRIES PRIVATE LIMITED',
    'AVM PRINT PACK PRIVATE LIMITED.',
    'JAIN LABELS PRIVATE LIMITED',
    'PROFESSIONAL DATA SYSTEM PRIVATE LIMITED',
    'K CHEMSYSTEMS PRIVATE LTD',
    'MAHAVEERA CARRIERS PRIVATE LIMITED',
    'KALPANA MARKETING PRIVATE LIMITED',
    'HARMEET ESTATE AND LEASING PRIVATE LIMITED',
    'Acuity Infotech Private Limited',
    'FIND TECHNOLOGY PRIVATE LIMITED',
    'SUNRISE SPORTS (INDIA) PRIVATE LIMITED',
    'CLEAN REALTY PRIVATE LIMITED',
    'ASHISHWANGH MARITIME PRIVATE LIMITED',
    'TAFCON PROJECTS (INDIA) PRIVATE LIMITED',
    'RADIANCE DATA ANALYTICS PRIVATE LIMITED',
    'D SIGNATURE LIVE PRIVATE LIMITED',
    'BRD RETAIL DISTRIBUTIONS PRIVATE LIMITED',
    'SELECTIVE GLOBAL SEARCH PRIVATE LIMITED',
    'NIDHI AUTOTECH PRIVATE LIMITED',
    'EESHAAN AUTOMATION PRIVATE LIMITED',
    'MADHU MUSKAN DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PARKASH GARMENTS PRIVATE LIMITED',
    'VISTONY INDIA PRIVATE LIMITED',
    'Tree India E-Commerce Private Limited',
    'GALAXY POLYPACK PRIVATE LIMITED',
    'STG Lifecare Limited',
    'B.A.G. FILMS AND MEDIA LIMITED',
    'Creative Atoms Events & Services Private Limited',
    'EVOLVE VAPORS (INDIA) PRIVATE LIMITED',
    'KARVY DIGIKONNECT LIMITED',
    'SATYA COMMUNITY CARE FOUNDATION',
    'SOCIAL RESPONSIBILITY COUNCIL',
    'LE WEBEXY PRIVATE LIMITED',
    'BLISSWOOD GREEN INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED',
    'Easy Care Integrated Solutions India Private Limited',
    'TRESOR SALON PRIVATE LIMITED',
    'Vanguard Kemagro Private Limited',
    'SABIC INDIA PRIVATE LIMITED',
    'NECTAR ENTERPRISES PVT. LTD..',
    'LCRK AUTO ENGINEERS PRIVATE LIMITED',
    'RVA CONCRETE PRIVATE LIMITED',
    'STERLING EXPRESS PRIVATE LIMITED',
    'KOSHY CONSULTANTS PRIVATE LIMITED',
    'OURINITIATIVE MEDIA PRIVATE LIMITED',
    'DKD IKJOT UNITED PRIVATE LIMITED',
    'TECHSEARCH INDIA PRIVATE LIMITED',
    'MTE India Private Limited',
    'NTF Holdings Private Limited',
    'GALORE SALES & SERVICES INDIA PRIVATE LIMITED',
    'JAIRAJ STEEL ROLLING MILLS PRIVATE LIMITED',
    'BGM TELECOMMUNICATIONS PRIVATE LIMITED',
    'ACE INTEGRATED EDUCATION Private Limited',
    'SAVITA PLASTICS PRIVATE LIMITED',
    'DYNASTY HOUSING AND LAND DEVELOPMENT PRIVATE LIMITED',
    'BALAR MARKETING PVT LTD',
    'BSA CITI COURIERS PRIVATE LIMITED',
    'ADVIKA ENERGIES PRIVATE LIMITED',
    'SAB SONS CREDIT PRIVATE LIMITED',
    'OSCAR GLOBAL LIMITED.',
    'SINGLAS RETAIL PRIVATE LIMITED',
    'KERSEYMERE INDIA PRIVATE LIMITED',
    'AMAATRA HOUSECON PRIVATE LIMITED',
    'ALL IN MERCHANDISE PRIVATE LIMITED',
    'Poise Realtech Private Limited',
    'TOTAL QUALITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'DAMONT DEVELOPERS PRIVATE LIMITED',
    'New Spirit Apparels Private Limited',
    'FARCON LEATHER EXPORTS PRIVATE LIMITED',
    'FAST TRACK FURNITURE & INTERIORS (INDIA) PRIVATE LIMITED',
    'POWER AND ENERGY CONSULTANTS INDIA PRIVATE LIMITED',
    'AERONEA BIO CHEM PRIVATE LIMITED',
    'LINEN CRAFT PRIVATE LIMITED',
    'INVENTION FINE CHEMICALS PRIVATE LIMITED',
    'SAANS HEALTHCARE LIMITED',
    'AS RFID SOLUTIONS PRIVATE LIMITED',
    'VIVIDH METALTECH PRIVATE LIMITED',
    'HOLLTECK INDIA GUIDES PRIVATE LIMITED',
    'GRID ARCHITECTURE INTERIORS PRIVATE LIMITED',
    'ELLBEE AGRICULTURE PRIVATE LIMITED',
    'RAJVARDHAN ESTATES PRIVATE LIMITED',
    'KALLANI AUTOCAST PRIVATE LIMITED',
    'VICTORIA E VEHICLES PRIVATE LIMITED',
    'OSLO KITCHENS PRIVATE LIMITED',
    'SolarArise India Projects Private Limited',
    'PILO SHUDH PANI SEVA FOUNDATION',
    'DAMONT PROMOTERS PRIVATE LIMITED',
    'NEWTECH HOMES PRIVATE LIMITED',
    'ATCON INDIA LIMITED',
    'K.M. LINES PRIVATE LIMITED',
    'AMAATRA BUILDWELL PRIVATE LIMITED',
    'DEARCH ENGINEERS PRIVATE LIMITED',
    'VISTAR AUTOMOTIVES PRIVATE LIMITED',
    'OLIVE SPORTS PRIVATE LIMITED',
    'QUICK FIN SOLUTIONS PRIVATE LIMITED',
    'WINTAGE GARMENTS PRIVATE LIMITED',
    'AGNI PROTECTION PRIVATE LIMITED',
    'MOGU ENGINEERS PRIVATE LIMITED',
    'Stellar Renewables Private Limited',
    'AR Grandeye India Private Limited',
    'Reliable Automation Private Limited',
    'KARAM HOLDING PRIVATE LIMITED',
    'MULTIMATIC INDIA PRIVATE LIMITED',
    'ASPEN PUMPS INDIA PRIVATE LIMITED',
    'TECH FOG PRIVATE LIMITED',
    'SPHERE REFRIGERATION SYSTEMS PRIVATE LIMITED',
    '5B SOLAR POWER PRIVATE LIMITED',
    'DAY NIGHT FURNITURE AND PROJECTS PRIVATE LIMITED',
    'Sixinch India Private Limited',
    'RMAG ENGINEERING PRIVATE LIMITED',
    'AZURE POWER JUPITER PRIVATE LIMITED',
    'OSTRO MADHYA WIND PRIVATE LIMITED',
    'OSTRO RANN WIND PRIVATE LIMITED',
    'VECTOR GREEN SUNSHINE PRIVATE LIMITED',
    'Azure Power Makemake Private Limited',
    'AZURE POWER VENUS PRIVATE LIMITED',
    'CONTINENTAL ACCESSORIES PRIVATE LIMITED',
    'ISK BIOSCIENCES INDIA PRIVATE LIMITED',
    'GASCO CYLINDERS PRIVATE LIMITED',
    'KAPTEL OVERSEAS PRIVATE LIMITED',
    'NECTAR BIOPHARMA PRIVATE LIMITED',
    'KHK PHARMACEUTICALS PRIVATE LIMITED',
    'GLOBAL MOTION SOLUTIONS PRIVATE LIMITED',
    'AZURE POWER EARTH PRIVATE LIMITED',
    'AZURE POWER PLUTO PRIVATE LIMITED',
    'OSTRO URJA WIND PRIVATE LIMITED',
    'OSTRO ANANTAPUR PRIVATE LIMITED',
    'Solar Sky Power Private Limited',
    'AZURE POWER SATURN PRIVATE LIMITED',
    'OSTRO ANDHRA WIND PRIVATE LIMITED',
    'OSTRO RAJ WIND PRIVATE LIMITED',
    'OSTRO DHAR WIND PRIVATE LIMITED',
    'OSTRO BHESADA WIND PRIVATE LIMITED',
    'OM ELECTRO EQUIPMENTS PRIVATE LIMITED',
    'Canare Electric India Private Limited',
    'BLOSSOM KOCHHAR BEAUTY PRODUCTS PRIVATE LIMITED',
    'OOM SUPER MART PRIVATE LIMITED',
    'WELLELL INDIA PRIVATE LIMITED',
    'HAKEEM BAQAI',
    'POSITIVE HEALTH CLINIC PRIVATE LIMITED',
    'Vishat diagnostic private limited',
    'Beyond boundaries health care private limited',
    'Tcg software private limited',
    'Green circle consultants india private limited',
    'Harshit herbal private limited',
    'Devangi welfare foundation',
    'Rgb medivision private limited',
    'Excellence leap foundation',
    'Ankura medical & research centre private limited',
    'Unipath specialty laboratory limited',
    'Irinjalakuda scans and research centre private limited',
    'MEDI ASSIST INSURANCE TPA PRIVATE LIMITED',
    'Regenix super speciality laboratories private limited',
    'Coimbatore integrated waste management company private limited',
    'Powertech pollution controls private limited',
    'Indian center for corporate social responsibility',
    'Natvar parikh industries private limited',
    'Tamilnadu trade promotion organisation',
    'Green lantern productions private limited',
    'Oscar media private limited',
    'TIME CINEMAS AND ENTERTAINMENT PRIVATE LIMITED',
    'Art and artistes (india) private limited',
    'Prime market reach private limited',
    'Cvr idream media private limited',
    'First rain exhibits (india) private limited',
    'Mustard communications private limited',
    'Mindsweep ideas private limited',
    'BOI MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'Gagan narang sports promotion foundation',
    'Mokshana spaces private limited',
    'Core fitness private limited',
    'Lekha productions private limited',
    'Stellar insurance management services private limited',
    'Csr india corporate social services private limited',
    'Chefs united foods private limited',
    'Meena add charity initiative foundation',
    'HUBTOWN VIVA MAINTENANCE PRIVATE LIMITED',
    'Brix media private limited',
    'Blue online communications private limited',
    'Think creative adsolutions private limited',
    'Krg strategy consultants private limited',
    'Abhivridhi insurance brokers private limited',
    'Sampada entrepreneurship and livelihoods foundation',
    'Reverb event management private limited',
    'Rise india skills solutions private limited',
    'ROOTS HAIR & BEAUTY PRIVATE LIMITED',
    'Mark salon & spa private limited',
    'HATS ON ADVERTISING PRIVATE LIMITED',
    'Evergreen ecotech private limited',
    'Berylitics talent management services private limited',
    'Ncdex e markets limited',
    'ABL ENERGY AND MARINE CONSULTANTS INDIA PRIVATE LIMITED',
    'GALLANT SAFETY AND SECURITY PRIVATE LIMITED',
    'SHARRP CONSUMER WELLBEING SOLUTIONS PRIVATE LIMITED',
    'Wealth4u accounting solutions private limited',
    'Wealth4u labour law solutions private limited',
    'Wealth4u capital market solutions private limited',
    'Chem-trend chemicals company private limited',
    'Azelis (india) private limited',
    'S.kumars tyre manufacturing company limited',
    'Diageo india private limited',
    'Woodstock broking private limited',
    'Lakhotia polyesters (india) limited',
    'Pradip overseas limited',
    'Tainwala chemicals and plastics (india) ltd',
    'EMINENCE FINMART SERVICES PRIVATE LIMITED',
    'Kommineni insurance brokers private limited',
    'Aasmaa securities private limited',
    'Shastha management & financial consultants private limited',
    'CCLYTICX SERVICES PRIVATE LIMITED',
    'Ruby forex private limited',
    'Golden life-management private limited',
    'Rock castle property private limited',
    'Jivdani properties private limited',
    'Cosma realtors private limited',
    'Rossland constructions private limited',
    'Ernakulam realtors private limited',
    'S s r wealth solutions private limited',
    'Milind developers private limited',
    'Vgs realty construction private limited',
    'Snv holdings private limited',
    'Balaji constructions (bangalore) private limited',
    'A. m. developers (india) private limited',
    'Crimson property private limited',
    'Haldhar developers private limited',
    'Velocity realtors private limited',
    'Task realtors private limited',
    'Omkar realtors private limited',
    'Je bee properties private limited',
    'Sai laxmi properties private limited',
    'Nirmal realtors private limited',
    'Sai swaroop land & developers private limited',
    'Prakruti nirman development private limited',
    'Right choice housing private limited',
    'Lambodara properties & realtors private limited',
    'Shuban land & developers private limited',
    'Propmax developers and holders private limited',
    'Harshini estates private limited',
    'Trident properties private limited',
    'Mayura krishna infrastructure private limited',
    'Meticulous realtors private limited',
    'Goldshield real estate private limited',
    'Malavika holdings private limited',
    'New ram ratan apartments private limited',
    'Nirmal lifestyle luxor private limited',
    'Gajanana land & developers private limited',
    'Pp niketan private limited',
    'Blue line properties private limited',
    'Linkwise niketan private limited',
    'Agc realty private limited',
    'Om jagdish realtors private limited',
    'Anatomy realtors private limited',
    'Ipsel ventures and realty private limited',
    'Nirmal housing private limited',
    'Ketul realtors private limited',
    'Kalpit realtors private limited',
    'Tereli estates private limited',
    'Krypton datamatics ltd',
    'Datasoft comnet private limited',
    'Schemax expert techno crafts private limited',
    'Adobe systems india private limited',
    'Render 5 technologies private limited',
    'Angstle technologies private limited',
    'Priya softweb solutions private limited',
    'Ascendum solutions india private limited',
    'True vision technologies private limited',
    'Shoelace technologies private limited',
    'Infostretch corporation (india) private limited',
    'Itti private limited',
    'Synopsys (india) eda software private limited',
    'Vcreate logic private limited',
    'Info connect web technologies india private limited',
    'Lantiq communications india private limited',
    'Prime assetsource private limited',
    'Simply grameen business solutions private limited',
    'Avekshaa technologies private limited',
    'Corecad technologies private limited',
    'Cgtech india software solutions private limited',
    'Ipsoft global services private limited',
    'Codemancers technologies private limited',
    'Rackspace india private limited',
    'Bsol systems private limited',
    'Imtac india private limited',
    'Hiode technologies private limited',
    'Netsoft systems & networks (i) private limited',
    'Compitoplus services and consultancy private limited',
    'E-clone technologies private limited',
    'Infoblox technical support and software development private limited',
    'Prominent solutions private limited',
    'Altius customer services private limited',
    'Nityo infotech services private limited',
    'Moksha digital software private limited',
    'Digital dreams consulting private limited',
    'Swicons consultancy services private limited',
    'Diabeto medtech india private limited',
    'FIS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Engineering design software and services private limited',
    'E - ql business solutions private limited',
    'Intellovate technologies private limited',
    'Mediaware infotech private limited',
    'SOFTTECH ENGINEERS LIMITED',
    'Galaxy stamping private limited',
    'EMIT ENGINEERING & CONSTRUCTION PRIVATE LIMITED',
    'Keetronics (india) private limited',
    'ELINWG INDIA PRIVATE LIMITED',
    'Arvi systems & controls private limited',
    'Aegis automation india private limited',
    'Prismatic engineering private limited',
    'Accolade electronics private limited',
    'Magnacon electricals india ltd',
    'MARCO CABLES & CONDUCTORS LIMITED',
    'Sharp batteries and allied industries limited',
    'Meem transformer private limited',
    'Bharathi info & power systems private limited',
    'Maflow india private limited',
    'Pranita electricals private limited',
    'Everest cables & connectors private limited',
    'Warden security systems private limited',
    'Tecknotrove systems (india ) private limited',
    'Hager electro private limited',
    'Autotechnix control systems private limited',
    'Cirkit electro-components private limited',
    'Space age associates power-infra private limited',
    'Beam on service technology india private limited',
    'Somnet dynagraphics pvt ltd',
    'Hita technology private limited',
    'AVACEND SOLUTIONS PRIVATE LIMITED',
    'Ace mechatronix india private limited',
    'Esaad telecom private limited',
    'Mentel telecom private limited',
    'Uranus medical devices limited',
    'Vishal surgitech private limited',
    'Swiss engineering private limited',
    'Aluputer technology ( india ) private limited',
    'Agnus holdings private limited',
    'Zodiac mediquip limited',
    'Control scientific works private limited',
    'QMAX TEST TECHNOLOGIES PRIVATE LIMITED',
    'Prakaash eyewear private limited',
    'Slaney healthcare private limited',
    'Jayashree encoders private limited',
    'FREEDOM OPHTHALMIC PRIVATE LIMITED',
    'Lenvitz medical solutions private limited',
    'Hino motors sales india private limited',
    'Rico jinfei wheels limited',
    'Aisin automotive karnataka private limited',
    'PETE',
    'CURVE DEVELOPMENT SERVICES PRIVATE LIMITED',
    'Promark techsolutions private limited',
    'Yaelstar diamonds private limited',
    'DEREWALA JEWELLERY MANUFACTURING COMPANY Private Limited',
    'Geberit india manufacturing private limited',
    'L b publishers and distributors (calcutta) private limited',
    'Green and good products private limited',
    'HI-GREEN CARBON LIMITED',
    'Wind world wind farms (gujarat) private limited',
    'Wind world wind farms (maharashtra) private limited',
    'Wind world wind farms (rajasthan) private limited',
    'Wind world wind farms (up) private limited',
    'WIND WORLD HINDUSTAN INFRASTRUCTURE PRIVATE LIMITED',
    'Wind world (india) power development private limited',
    'AXIS ENERGY STORAGE SYSTEMS PRIVATE LIMITED',
    'INNOVANEER REALTORS PRIVATE LIMITED',
    'Wind world wind farms (m p) private limited',
    'Harekrishna energy private limited',
    'Deserve energy limited',
    'Ushdev mg windfarms private limited',
    'Four seasons energy ventures private limited',
    'Renewable energy corporation (india) private limited',
    'Wind world wind farms (india) limited',
    'Wind world wind farms (hindustan) private limited',
    'Suyog urja private limited',
    'AXIS RENEWABLE PROJECTS PRIVATE LIMITED',
    'ABC RE PARK (AP-05) PRIVATE LIMITED',
    'Riverside renewable power private limited',
    'Suncore power projects private limited',
    'Srk energy private limited',
    'Photonics watertech private limited',
    'DEWAS WATERPROJECTS WORKS PRIVATE LIMITED',
    'Gen-x nirman private limited',
    'Stylus infrastructure private limited',
    'Rise india financial services private limited',
    'El enterprises (india) private limited',
    'STRONG POINT CONSULTING PRIVATE LIMITED',
    'Secure source technologies private limited',
    'Unique labels private limited',
    'Sai arts private limited',
    'Siddhivinayak bizsol private limited',
    'Rsi retail solutions india private limited',
    'Go daddy india domains and hosting services private limited',
    'Universal domains and hosting services india private limited',
    'Skilltrain training & consultancy india private limited',
    'Lardner north & company private limited',
    'PURTI FLOWERS OWNERS',
    'S AND MATERIAL HANDLERS LTD',
    'Korn /ferry international private limited',
    'Big tree entertainment private limited',
    'Global proserv limited',
    'R s diamonds private limited',
    'Future capital investment private limited',
    'Zydus wellness limited',
    'Thanjavur spinning mill limited',
    'Suven life sciences limited',
    'Krypton industries ltd',
    'Rathi steel and power limited',
    'HITECH CORPORATION LIMITED',
    'KUSHAL LIMITED',
    'UGRO CAPITAL LIMITED',
    'Essar ports limited',
    'Cinerad communications ltd',
    'Newtech filter india private limited',
    'NATUREX INDIA PRIVATE LIMITED',
    'Vasana agrex and herbs private limited',
    'Go green projects private limited',
    'Somabhai tea processors private limited',
    'Sattva agro expo private limited',
    'C r narayana rao(consultants) private limited',
    'Drip india irrigation private limited',
    'Sattva industries private limited',
    'Eliga it programming private limited',
    'Yk software solutions private limited',
    'Filesie systems (india) private limited',
    'KAMESHWARI SOFTECH PRIVATE LIMITED',
    'Anjusoft (india) private limited',
    'Carboncubes technology (india) private limited',
    'Yakshna technologies india private limited',
    'Conquer info tech india private limited',
    'Tcg informatics private limited',
    'Jade eservices private limited',
    'Prolim solutions india private limited',
    'Best computer solutions private limited',
    'Big blue road (india) private limited',
    'Techved consulting india private limited',
    'Bsmart tech private limited',
    'Jariwala robotics private limited',
    'Montran corporation (india) private limited',
    'Icewarp technologies private limited',
    'Blackapple software solutions private limited',
    'Cohnreznick professional services private limited',
    'Systech hardware & networking academy private limited',
    'Mispl systems private limited',
    'Stackup technology solutions private limited',
    'Novus infosoft private limited',
    'Skyram technologies private limited',
    'Havas worldwide digital matrix private limited',
    'MAARUSA TECHNOLOGIES PRIVATE LIMITED',
    'Neptune financial software private limited',
    'Mottled technologies private limited',
    'Blom it services private limited',
    'Shorelynx software services private limited',
    'Wayinfotech software private limited',
    'Ishan netcom private limited',
    'True value it applitech private limited',
    'Educomp learning private limited',
    'Target corporation india private limited',
    'Secureyes techno services private limited',
    'Icrederity info services private limited',
    'ODIGMA CONSULTANCY SOLUTIONS LIMITED',
    'Digit88 technologies private limited',
    'E-square embedded solutions private limited',
    'ILLUMINE KNOWLEDGE RESOURCES PRIVATE LIMITED',
    'Noon consultancy (india) private limited',
    'In-net india private limited',
    'REFINITIV GLOBAL PRIVATE LIMITED',
    'Wanbury infotech private limited',
    'Pace setters buisiness solutions private limited',
    'BIOSPEC PRIVATE LIMITED',
    'Magnet telelinks private limited',
    'Nmrm infotech private limited',
    'Empays technologies private limited',
    'Obox solutions private limited',
    'PARALIFT EQUIPMENTS PRIVATE LIMITED',
    'Cellbeans healthcare informatics private limited',
    'Tansar solutions private limited',
    'ASSETSENSE TECHNOLOGIES PRIVATE LIMITED',
    'Spinsci technologies private limited',
    'Valuepitch etechnologies private limited',
    'Semantic shepherds integrated systems private limited',
    'Sss placement consultants private limited',
    'GLENCORE INFORMATION SERVICES PRIVATE LIMITED',
    'Valuelinked software solutions india private limited',
    'Revmakx technologies private limited',
    'Aorborc technologies private limited',
    'All india technologies limited',
    'Sdro innovative solutions private limited',
    'Lotus labs private limited',
    'Defsys solutions private limited',
    'C mahendra capital limited',
    'Kishens accounting solutions private limited',
    'URBANIA FOODS PRIVATE LIMITED',
    'Vastukala consultants (i) private limited',
    'BEW ENGINEERING LIMITED',
    'Ignitee digital services private limited',
    'Krvf outsourcing solutions private limited',
    'Strasa business private limited',
    'Swaratnika digital sound private limited',
    'Priedemann india private limited',
    'Kish corporate services india private limited',
    'Maritime online services private limited',
    'Phantom films productions private limited',
    'Staark accessories private limited',
    'Cmyk events private limited',
    'Krishi direct trade private limited',
    'Deloitte financial advisory services india private limited',
    'Pure talent services private limited',
    'INNOVACCER ANALYTICS PRIVATE LIMITED',
    'S & s water and power projects private limited',
    'Shree rang consultancy services private limited',
    'Textile sourcing and services private limited',
    'Promax management consultants private limited',
    'Vpd consultants pvt ltd',
    'PROFRITE CONSULTANTS PRIVATE LIMITED (OPC)',
    'SAU FINANCIAL SERVICES PRIVATE LIMITED',
    'Global airport and ground services private limited',
    'Seashell logistics private limited',
    'Aumkar supply chain solutions private limited',
    'Sme logistics private limited',
    'Stellar marine paints limited',
    'Supreme ground support aviation equipments private limited',
    'Rose valley airlines limited',
    'EBIX TRAVELS PRIVATE LIMITED',
    'LAVENDER INNOVATIONS PRIVATE LIMITED',
    'Gs holidays private limited',
    'Spiceland holidays and entertainments private limited',
    'Tour de world private limited',
    'Tapashvi sea and airfreight private limited',
    'Jtb jupiter express services private limited',
    'Vishal shipping agencies private limited',
    'Rhombus shipping and forwarders private limited',
    'Dimensions logistics services private limited',
    'Where to go tourism & hospitality private limited',
    'Johnasia shipping (i) private limited',
    'Holidaysmith private limited',
    'Valuelink logistics solutions private limited',
    'Khwahish technologies private limited',
    'Infinite linked solutions private limited',
    'Shopping zone india tv private limited',
    'Silver valley communications limited',
    'Signet digital private limited',
    'Hsbc agency (india) private limited',
    'AEROSPACE MANUFACTURING HOLDINGS PRIVATE LIMITED',
    'Ranganatham finance private limited',
    'Western union payment services (india) private limited',
    'AAACORP EXIM INDIA PRIVATE LIMITED',
    'Teamspace financial services private limited',
    'ORANGE CITY HOUSING FINANCE PRIVATE LIMITED',
    'India factoring and finance solutions private limited',
    'FORTUNE MANAGEMENT ADVISORS LIMITED',
    'Excalibur assets and capital management private limited',
    'Chokhani real estates and investments private limited',
    'Kanakia finance and investments private limited',
    'San-ram capital private limited',
    'INVESCO TRUSTEE PRIVATE LIMITED',
    'M r j chits private limited',
    'Shanti forex private limited',
    'Bharti axa life insurance company limited',
    'EQUITY HARVEST FINANCIAL PRODUCTS DISTRIBUTORS PRIVATE LIMITED',
    'Bee kay aar investments private limited',
    'Stci primary dealer limited',
    'Veracity financial services private limited',
    'ACHYUT HEALTHCARE LIMITED',
    'Parul-nisha trading private limited',
    'Trust capital services (india) private limited',
    'Dime securities and investments private limited',
    'Goldmine financial services private limited',
    'Synchro investments private limited',
    'BHARTI LIFE VENTURES PRIVATE LIMITED',
    'Trust financial consultancy services private limited',
    'One capitall limited',
    'Standard fiscal markets private limited',
    'Aquarius investment advisors (india) private limited',
    'Wealth junction consultants private limited',
    'Gurjar gems private limited',
    'INVESCO ASSET MANAGEMENT (INDIA) PRIVATELIMITED',
    'HDFC CREDILA FINANCIAL SERVICES LIMITED',
    'Parakkott investments india private limited',
    'Bhrugav debt collection solutions private limited',
    'Blessy forex private limited',
    'Munich re india services private limited',
    'Zodiac buildwell private limited',
    'Hls constructions private limited',
    'Sobha assets private limited',
    'Sobha highrise ventures private limited',
    'Educe infrastructure projects private limited',
    'Bounteous builders and developers private limited',
    'Speciality estates private limited',
    'Questa properties private limited',
    'Haben developers private limited',
    'Nepolyan real estates private limited',
    'Supreme real estate developers private limited',
    'Nagpal estates private limited',
    'Kalinga technologies private limited',
    'M.g.brothers real estates private limited',
    'BLUE BULL FILMS PRIVATE LIMITED',
    'Waterline shelters private limited',
    'Tejaswari properties private limited',
    'Clique developments limited',
    'R&h property developers private limited',
    'Niyati real estate developers private limited',
    'Abc realty private limited',
    'Siddhivinayak earthmovers and infrastructure private limited',
    'Perfect realbuild private limited',
    'Samarpeet properties private limited',
    'R & h real estate and land developers private limited',
    'Badra realties private limited',
    'Techpoint office automation (india) private limited',
    'Sanmina-sci india private limited',
    'Sarang hi - tech infrastructures private limited',
    'Rosa power supply company limited',
    'Transpares limited',
    'Vighneshwar airconditioning private limited',
    'Eibenstock positron elektrowerk private limited',
    'Acenotech batteries private limited',
    'Rajesh power services private limited',
    'Avana electrosystems private limited',
    'Wenglor sensoric india private limited',
    'Accurate helical springs private limited',
    'Scame india private limited',
    'TRANSERECT TESTING & COMMISSIONING ENGINEERS PRIVATE LIMITED',
    'Sunrise instruments private limited',
    'India renewables limited',
    'Urjas airtec private limited',
    'Reco safety and automation private limited',
    'Tvm signalling and transportation systems private limited',
    'Power square india private limited',
    'Quadrant measurements private limited',
    'Sriven batteries private limited',
    'Sohm hi-tech systems (i) private limited',
    'Aq mechanical & electrical manufacturing india private limited',
    'Sanmina-sci technology india private limited',
    'Rmc electronics private limited',
    'Omgvh electronics private limited',
    'Raison technologies india private limited',
    'Super mount pack private limited',
    'Satcom elektronics pvt.ltd.',
    'Mach mind technologies private limited',
    'TOYOTA TSUSHO NEXTY ELECTRONICS INDIA PRIVATE LIMITED',
    'Bharat records international private limited',
    'ADMIRE MEDIA PRIVATE LIMITED',
    'Sysmex india private limited',
    'Sunchirin autoparts india private limited',
    'SIMPSON SPENCE YOUNG INDIA PRIVATE LIMITED',
    'Oceanica yachts private limited',
    'VV KAY MARINE PRIVATE LIMITED',
    'Rapaport india private limited',
    'G. r. pens private limited',
    'Emaar diamonds private limited',
    'Mohit diamonds private limited',
    'Techseal engineering (india) private limited',
    'Chris adams parfums private limited',
    'Sabre helmets private limited',
    'Arjav diamonds (india) private limited',
    'Clay club innovations private limited',
    'Elife power systems private limited',
    'Tyresoles retreading (gujarat) private limited',
    'Greenko hatkoti energy private limited',
    'MILANO HOMES PRIVATE LIMITED',
    'Panama wind energy godawari private limited',
    'ETESIAN URJA LIMITED',
    'Kumaradhara power private limited',
    'Vainavi energy ventures private limited',
    'Fugen energy private limited',
    'Opera energy private limited',
    'Patiala bio power company limited',
    'Vijay green synergies private limited',
    'Sipla wind energy limited',
    'Rohtas bio energy limited',
    'Lalpur wind energy private limited',
    'Enclaves infrastructure (mysore) private limited',
    'Atul raj builders pvt ltd',
    'Space age developers private limited',
    'Priyanka communications india private limited',
    'Domach technologies (india) private limited',
    'Man projects limited',
    'Kamptee infrastructures private limited',
    'Cargo hub infrastructure private limited',
    'Indore treasure island private limited',
    'Royal fantasy constructions private limited',
    'Avd infra india private limited',
    'Saisamruddhi builders and contractors private limited',
    'Sar infracon',
    'PSP PROJECTS Limited',
    'Miracle infrastructure private limited',
    'Parvati pranam infra private limited',
    'Parvati organizers private limited',
    'Frptech (india) private limited',
    'Bhumi corporation private limited',
    'Varija constructions private limited',
    'Eon kharadi infrastructure private limited',
    'Bandra realty private limited',
    'Nakshatra buildcon private limited',
    'Sanskar buildtech private limited',
    'Joyross technical services private limited',
    'Purple constrution private limited',
    'Basix realtors private limited',
    'Darwin platform refineries limited',
    'Fike india private limited',
    'Allied offshore services pvt ltd',
    'Upkar mining private limited',
    'Adarsh india mining private limited',
    'V.g. quenim mining private limited.',
    'Vault fine spirits private limited',
    'DARWIN PLATFORM DISTILLERIES AND BREWERIES LIMITED',
    'SALT RANGE FOODS PRIVATE LIMITED',
    'GROBEST FEEDS CORPORATION (INDIA) Private Limited',
    'Anglo indian flower breeders private limited',
    'Manko natural flavours and extracts private limited',
    'Shanti foodchem private limited',
    'Vasa wellness private limited',
    'TATA CONSUMER SOULFULL PRIVATE LIMITED',
    'Good juicery private limited',
    'Golden spirits private limited',
    'Golden spirits (goa) private limited',
    'Midas golden distilleries private limited',
    'PIONEER FOODS PRIVATE LIMITED',
    'Shree gini texturising private limited',
    'Korindo plywood private limited',
    'Sarita silk mills private limited',
    'Uniloyal expotex limited',
    'Siddhi vinayak silk mills private limited',
    'Siddhi vinayak polyfab private limited',
    'Rajgopal fabs private limited',
    'Indian technical textile association',
    'Shree rayon private limited',
    'TARAPUR FABRICS PRIVATE LIMITED',
    'Virgo clothing culture private limited',
    'AKSHAR SPINTEX LIMITED',
    'Mpk enterprises private limited',
    'BRANDIX INTIMATE INDIA PRIVATE LIMITED',
    'Diesel fashion india reliance private limited',
    'My textiles private limited',
    'M-square clothing (india) private limited',
    'Tiny girl clothing company private limited',
    'S&S GARMENT ACCESSORIES INDIA PRIVATE LIMITED',
    'PIOUS INFOTECH PRIVATE LIMITED',
    'POOJA CASTINGS PVT LTD',
    'PORTECK INDIA INFOSERVICES PRIVATE LIMITED',
    'POPPYS KNITWEARS PRIVATE LIMITED',
    'POWERBAND INDUSTRIES PRIVATE LIMITED',
    'POLYMATECH ELECTRONICS PRIVATE LIMITED.',
    'PPL ENTERPRISES LIMITED',
    'PL ENGINEERING LTD',
    'PLANTECH CONSULTNATS PRIVATE LIMITED',
    'PRABAS VCARE HEALTH CLINIC PRIVATE LIMITED',
    'POSCO POGGENAMP ELECTRICAL STEEL PRIVATE LIMITED',
    'POWERTOOLS MARKETING LIMITED',
    'POLUS SOFTWARE PRIVATE LIMITED',
    'POSITIVE METERING PUMPS INDIA PRIVATE LIMITED',
    'PITNEY BOWES SOFTWARE INDIA PRIVATE LIMITED',
    'PIL INDIA PRIVATE LIMITED',
    'Power research and developement consultants private limited',
    'PINPOINT (INDIA) PRIVATE LIMITED',
    'PRADEEP DEVIAH AND ASSOCIATES PRIVATE LIMITED',
    'POWER GEARS LIMITED',
    'PINNACLE BIOMED PVT LTD',
    'PMC PROJECTS INDIA PRIVATE LIMITED',
    'PIONEERING VENTURES INDIA DEVELOPMENT SERVICES PRIVATE LIMITED',
    'PL DISTRIBUTION COMPANY PRIVATE LIMITED',
    'PP MERCHANDISING SERVICES PRIVATELIMITED',
    'PIL INDUSTRIES LIMITED',
    'PINNACLE ENGINES INDIA PRIVATE LIMITED',
    'POLY PLAST CHEMI-PLANTS(INDIA) PRIVATELIMITED',
    'Plivo Communications pvt ltd',
    'PLASTIC PIGMENT PVT LTD',
    'PLADA INFOTECH SERVICES PRIVATE LIMITED',
    'POSITIVE BIOSCIENCE LTD',
    'PLURALSOFT LIMITED',
    'POLE TO WIN INDIA PRIVATE LIMITED',
    'POWERED EPC SERVICES LTD',
    'portware india pvt ltd',
    'PINK LEMONADE COMMUNICATIONS PRIVATE LTD',
    'PRABH DAYAL OM PARKASH INFRASTRUCTURE PRIVATE LIMITED.',
    'PRAGATI PAPER INDUSTRIES LIMITED',
    'PIVOTROOTS DIGITAL PRIVATE LIMITED',
    'PIRAMAL HOUSING FINANCE PRIVATE LIMITED',
    'Preet machines limited',
    'PRICOL TRAVEL LIMITED',
    'PRAYAG POLYMERS PVT LTD',
    'PRODUCTION AIDS AND CONSULTANTS PRIVATE LIMITED',
    'PRAN BEVERAGES INDIA PRIVATE LIMITED',
    'PRESTIGE HOLIDAY RESORTS PRIVATE LIMITED',
    'PRITHVI FERRO ALLOYS PRIVATE LIMITED',
    'PRG INTERNATIONA ELECTRICALS PVT LTD',
    'PRESCIENT COLOR LIMITED',
    'PRINCE FOUNDATIONS LTD',
    'Precision Infomatic Madras Pvt Ltd',
    'PREMIUM RETAIL PVT LTD',
    'PRAYAS MANAGEMENT SERVICES PRIVATE LIMITED',
    'PREMIER BARS PRIVATE LIMITED',
    'PRICOL PUNE LIMITED',
    'PRISTINE LOGISTICS & INFRAPROJECTSPRIVATE LIMITED',
    'PREM HENNA MARKETING PVT LTD',
    'PRESTIGE MANGALORE RETAIL VENTURES PRIVATE LIMITED',
    'PRECISION AUTOMATION AND ROBOTICS INDIA LIMITED',
    'PRIME3SG IT SOLUTIONS PRIVATE LIMITED',
    'precise seamless apparels pvt ltd',
    'PRAMATI TECHNOLOGIES PVT LTD',
    'PRITHVI SOFTECH LIMITED',
    'PRI - MEDIA SERVICES PRIVATE LIMITED',
    'PREMIUM POLYALLOYS PVT LTD',
    'PRECA SOLUTIONS INDIA PVT LTD',
    'PROBENCHMARK OUTSOURCING SOLUTIONS (INDIA) PRIVATE LIMITED',
    'PRISM NEW MEDIA SOLUTIONS PRIVATE LIMITED',
    'PRISTINE ORGANICS PVT LTD',
    'PRESTIGE AMUSEMENTS PRIVATE LIMITED',
    'PREMIER SOLAR SYSTEMS PRIVATE LIMITED',
    'PRIME WOVENS LIMITED',
    'PRINTPACK PACKAGING SUPPLIES (INDIA) PRIVATE LIMITED',
    'PRESHA SOFTWARE PRIVATE LIMITED',
    'PRECISE CHEMIPHARMA PVT LTD',
    'PRAMUKH COTEX PVT LTD',
    'PRECISION SEALS MANUFACTURING LIMITED',
    'PRASHANT WEST POINT MACHINERY PRIVATELIMITED',
    'PREVENTINE LIFE CARE PRIVATE LIMITED',
    'PRIME PROGRESSION ICOM(INDIA) PRIVATE LIMITED',
    'PRINCIPAL ASSET MANAGEMENT PRIVATE LIMITED',
    'PRINCIPAL RETIREMENT ADVISORS PRIVATE LIMITED',
    'PROCESSMAP INFOTECH PRIVATE LIMITED',
    'PRESSMACH ENGINEERS PRIVATE LIMITED',
    'PRO ALIGN SECURITY INDIA PVT LTD',
    'PREM TEXTILES (INTERNATIONAL) PRIVATELIMITED',
    'PRIMERA MEDICAL TECHNOLOGIES PVT LTD',
    'PRIME HITECH INFRASTRUCTURE LIMITED',
    'PRIME MEIDEN LIMITED',
    'PRIMENET GLOBAL LIMITED',
    'PROBUS INSURANCE BROKER LIMITED',
    'QL2 SOFTWARE INDIA PRIVATE LIMITED',
    'PROPTIGER REALTY PRIVATE LIMITED',
    'Prosafe International Pvt Ltd',
    'QUANTA POWER SOLUTIONS INDIA PRIVATE LIMITED',
    'PVR PICTURES LIMITED',
    'QRG CENTRAL HOSPITAL and RESEARCH CENTRE LIMITED',
    'PROWARENESS SOFTWARE SERVICES PRIVATE LIMITED',
    'PROSENSE TECHNOLOGY PRIVATE LIMITED',
    'PUMA INDIA RETAIL PRIVATE LIMITED',
    'PTC SOFTWARE INDIA PVT LTD',
    'PROSTAR MICRONOVA POWER SYSTEMS PRIVATE LIMITED',
    'PURVAG COMMODITIES AND DERIVATIVES PRIVATE LIMITED',
    'PROFORM INTERIORS PVT LTD',
    'QA INFOTECH PRIVATE LIMITED',
    'proficient equities pvt ltd',
    'QUAKER CHEMICAL INDIA PVT LTD',
    'PROZONE INTU PROPERTIES LIMITED',
    'QUADRA SYSTEMS NET INDIA PRIVATE LIMITED',
    'PTRAANS LOGISTICS (INDIA) PRIVATE LIMITED',
    'PROPYL PACKAGING LIMITED',
    'PUSHKAR INSULATION AND PACKAGING PVT LTD',
    'PULSE SECURE TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'PROVENANCE LAND PVT LTD',
    'PYROTECH ELECTRONICS PVT LTD',
    'PYREON SOFTWARE CONSULTANTS PRIVATE LIMITED',
    'PURE GOLD JEWELLERS AND DIAMONDS (INDIA) PRIVATE LIMITED',
    'PROMETRIC TESTING PRIVATE LIMITED TFR FROM DELHI TO HARYANA',
    'QUADWAVE CONSULTING PVT LTD',
    'PROSEED INDIA LIMITED',
    'PROSPERITA HOTEL VENTURES LIMITED',
    'PROTEUS TECHNOLOGIES pvt ltd',
    'PRORETENTION TECHNOLOGIES PRIVATE LIMITED',
    'PRTM MANAGEMENT CONSULTANTS (INDIA) PRIVATE LIMITED',
    'Quantel Electronics India Private Limited',
    'PROMOZONE INDIA PRIVATE LIMITED',
    'QMAX TEST TECNOLOGIES PRIVATE LIMITED',
    'QUADRANT SOFTWARE SYSTEMS INDIA PRIVATE LIMITED',
    'PROFESSIONAL ACCESS SOFTWARE DEVELOPMENT PVT LTD',
    'PYRO BKP TELECOM CONSULTANTS PRIVATE LIMITED',
    'QUAL MOBILE SOLUTIONS PRIVATE LIMITED',
    'Prokarma softech private limited',
    'QUADRATIC INSIGHTS PVT LTD',
    'PYOGINAM APPAREL PRIVATE LIMITED',
    'QIAGEN INDIA PVT LTD',
    'QTEL COMTECH LIMITED',
    'QUATTRO ENGINEERING INDIA LIMITED',
    'radco marketing private ltd',
    'RABO EQUITY ADVISORS PRIVATE LIMITED',
    'R R LEATHER PRODUCTS PRIVATE LIMITED',
    'RAJURI STEELS PRIVATE LIMITED',
    'RAMAN AND WEIL PRIVATE LIMITED',
    'QUIPPO VALUERS AND AUCTIONEERS PRIVATE LIMITED',
    'R N LABORATORIES PRIVATE LIMITED',
    'QUIKR REALTY LIMITED',
    'RACOLD THERMO LIMITED',
    'RAMAKRISHNA HOUSING PVT LTD',
    'RAMAKRISHNA HOSPITAL PVT LTD',
    'RAKSHIT PHARMACEUTICALS LTD',
    'RAMANA SAFETY AND SYSTEMS INDIA PRIVATE LIMITED',
    'R CONSULTANTS PRIVATE LIMITED',
    'R2 INTERNATIONAL CONSULTING (INDIA) PRIVATE LIMITED',
    'R2K SOFTWARE INDIA PRIVATE LIMITED',
    'RAJARAM BANDEKAR SIRIGAO MINES PRIVATE LIMITED',
    'RAJHANS INFRACON INDIA PRIVATE LIMITED',
    'QUANTUMID TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RAINBOW CHILDRENS MEDICARE PRIVATE LIMITED',
    'RADIANT INFO SYSTEMS LIMITED',
    'RAKINDO DEVELOPERS PRIVATE LIMITED',
    'R & B INFRA PROJECT PRIVATE LIMITED',
    'RADIUS INFRATEL PRIVATE LIMITED',
    'RADIUS OUTSOURCING (INDIA) PRIVATE LIMITED',
    'RADIUS BILLING AND SUPPORT SERVICES (INDIA) PRIVATE LIMITED',
    'RAJARSHI CARS PRIVATE LIMITED',
    'R J RISHIKARAN PROJECTS PRIVATE LIMITED',
    'RADHA SMELTERS LIMITED',
    'RAJSHREE POLYPACK PRIVATE LIMITED',
    'Quicklogic software india pvt ltd',
    'RADHA REGENT HOTELS PVT LTD',
    'R P METAL SECTIONS PRIVATE LIMITED',
    'QUIKAST TECHNOLOGIES PRIVATE LIMITED',
    'RAHEJA HOSPITALITY PRIVATE LIMITED',
    'RADISYS INDIA PRIVATE LIMITED',
    'R SAI LOGISTICS INDIA PRIVATE LIMITE',
    'QUINTILLION MEDIA PRIVATE LIMITED',
    'QUIPPO TELECOM INFRASTRUCTURE PRIVATE LIMITED',
    'R And B Denims Limited',
    'REGENCY CREATIONS LIMITED',
    'ravi iron limited',
    'RANEE POLYMERS PVT LTD',
    'Relevant E Solutions Pvt Ltd',
    'RAYS POWER EXPERTS PVT LTD',
    'REAL GROWTH INFRA PRIVATE LIMITED',
    'RAVALGAON SUGAR FARM LIMITED',
    'Ranchor electronics private limited',
    'RAVENMAC PHARMACEUTICALS PVT LTD',
    'REED SI EXHIBITIONS PRIVATE LIMITED',
    'RAMKY PHARMA CITY (INDIA) LIMITED',
    'RDS INFOTECH PRIVATE LIMITED',
    'RAVASCO TRANSMISSION AND PACKING PRIVATE LIMITED',
    'RAPTIM RESEARCH LIMITED',
    'RASHI RESOURCES PRIVATE LIMITED',
    'RAUT ENGINEERING PVT LTD',
    'RBZ JEWELLERS PRIVATE LIMITED',
    'RASA MARKETING PRIVATE LIMITED',
    'RELIANCE CEMENT COMPANY PRIVATE LIMITED',
    'RBOOMERANG RETAIL COMMERCE TECHNOLOGIES INDIA PVT LTD',
    'RBS GLOBAL TRADE SERVICE CENTRE PRIVATE LIMITED',
    'RELIANCE CLOTHING INDIA PRIVATE LIMITED',
    'Rave technologies (india) private limited',
    'REAL VIDEO IMPACT PRIVATE LIMITED',
    'RAMBUS CHIP TECHNOLOGIES INDIA PRIVATE LIMITED',
    'RAMBAL LIMITED',
    'RATNARUP PROJECTS PRIVATE LIMITED',
    'RAMKY ENERGY AND ENVIRONMENT LIMITED',
    'REEBOK INDIA COMPANY',
    'Red chillies entertainments pvt ltd',
    'RBS EQUITIES INDIA LIMITED',
    'RBS FINANCIAL SERVICES (INDIA) PRIVATE LIMITED',
    'RCI CASH MANAGEMENT SERVICES PRIVATE LIMITED',
    'REALTY AUTOMATION AND SECURITY SYSTEMS PRIVATE LIMITED',
    'RAVSOFT SOLUTIONS INDIA PRIVATE LIMITED',
    'REGENERSIS INDIA PVT LTD',
    'REGENCY HOSPITAL LTD',
    'REHLAT ONLINE SERVICES PVT LTD',
    'RECONNECT ENERGY SOLUTIONS PRIVATE LIMITED',
    'RECKITT BENCKISER SCHOLL INDIA PRIVATE LIMITED',
    'RAMBOLL ENGINEERING CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'RATEGAIN TRAVEL TECHNOLOGIES PRIVATE LIMITED',
    'RCI Industries and technologies limited',
    'RATTANINDIA SOLAR 2 PRIVATE LIMITED',
    'RCM MEDIGAIN INDIA PRIVATE LIMITED',
    'ROHANNA AGRI LIMITED.',
    'RITIKA PRIVATE LIMITED',
    'ROI Mantra Pvt Ltd',
    'REVE SYSTEMS INDIA PVT LTD',
    'ROKI MINDA CO. PRIVATE LIMITED',
    'ROBUST HOTELS PRIVATE LIMITED',
    'RELIGARE SUPPORT SERVICES LIMITED',
    'RELIGARE HEALTH INSURANCE COMPANY LIMITED',
    'RELIGARE WEALTH MANAGEMENT LIMITED',
    'ROCKLAND HOSPITALS LIMITED',
    'RITE INFOTECH PRIVATE LIMITED',
    'RMS CREDIT SOLUTIONS PRIVATE LIMITED',
    'ROECHLING ENGINEERING PLASTICS (INDIA) PRIVATE LIMITED',
    'RJ FEEDS LIMITED',
    'rex industries india pvt ltd',
    'RELIANCE JIO MESSAGING SERVICES PRIVATE LIMITED',
    'REVERIE LANGUAGE TECHNOLOGIES PVT LTD',
    'RENUKA PLASTI CRAFTS PRIVATE LIMITED',
    'RESILIENT SOFTECH PRIVATE LIMITED',
    'RHINE ENGINEERING PRIVATE LIMITED',
    'RJ BIO-TECH LIMITED',
    'RELIANCE SUPPLY SOLUTIONS PRIVATE LIMITED',
    'RELIANCE TRENDS LIMITED',
    'RELIANCE RETAIL INSURANCE BROKING LIMITED',
    'RITWIK SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'RISKRAFT CONSULTING LIMITED',
    'RMD FOODS and BEVERAGES PRIVATE LIMITED',
    'Riverbed Technology India Pvt Ltd',
    'RELIANCE MONEY EXPRESS LIMITED',
    'RELIANCE INFOSTREAMS PRIVATE LIMITED',
    'RICH OFFSET INDIA PRIVATE LIMITED',
    'RHODIA POLYMERS & SPECIALTIES INDIA PRIVATE LIMITED',
    'ROFIN BAASEL LASER INDIA PRIVATE LIMITED',
    'ROCKETALK INDIA PRIVATE LIMITED',
    'RIO TINTO EXPLORATION INDIA PRIVATE LIMITED',
    'RHINO SERVICES PRIVATE LIMTIED',
    'RESOURCES GLOBAL PROFESSIONALS INDIA PRIVATE LIMITED',
    'REVTECH SOLUTIONS INDIA PRIVATE LIMITED',
    'RESFEBER LABS PRIVATE LIMITED',
    'RICHCORE LIFESCIENCES PRIVATE LIMITED',
    'RESOLVE SALVAGE and FIRE INDIA PRIVATE LIMITED',
    'REWISE ANALYTICS AND TECHNOLOGIES PRIVATE LIMITED',
    'resource pro operational solutions pvt ltd',
    'Renovite payment solutions pvt ltd',
    'RHODIA SPECIALTY CHEMICALS INDIA LIMITED',
    'RENOVISION AUTOMOTION SERVICES PRIVATE LIMITED',
    'ROHTO PHARMA INDIA PRIVATE LIMITED',
    'Relifin Technologies India Pvt Ltd',
    'REVOKARMAHUB SOFTWARE AND SERVICES PRIVATE LIMITED',
    'RELIANCE HEALTH INSURANCE LTD',
    'ROLEX HOSIERY PVT LTD',
    'S B RESHELLERS PRIVATE LIMITED',
    'S B SYSCON PRIVATE LIMITED',
    'ROYAL GOAN BEACH RESORTS PRIVATE LIMITED',
    'ROYAL LACES LIMITED',
    'ROXUL ROCKWOOL INSULATION INDIA PRIVATE LIMITED',
    'S D ENGINEERSTECH PVT LTD',
    'ROSENBERGER ELECTRONIC COMPANY (INDIA) PRIVATE LIMITED',
    'S A M APPARELS Private limited',
    'ROOTS COOLING SYSTEMS PVT LTD',
    'ROYAL DISTILLERY PRIVATE LIMITED',
    'SABOO COATINGS PRIVATE LIMITED',
    'SAASFORCE CONSULTING PVT LTD',
    'SAASFOCUS CONSULTING PRIVATE LIMITED',
    'RUCHI ACRONI INDUSTRIES LIMITED',
    'RUBY MILLS LIMITED',
    'RSB INFRASTRUCTURE LIMITED.',
    'S. E. POWER LIMITED',
    'ROSY BLUE TRADESERVE PRIVATE LIMITED',
    'RUDRA REAL ESTATE LIMITED',
    'SABMILLER BREWERIES PRIVATE LIMITED',
    'S A PHARMACHEM PRIVATE LIMITED',
    'ROLEX RINGS PRIVATE LIMITED',
    'SABOORI COLLEZIONE INTERNATIONAL (P) LTD',
    'S K WHEELS PRIVATE LIMITED',
    'S P SOFTWARE TECHNOLOGIES INDIA PRIVATELIMITED',
    'RUDIMENT EDUCATIONAL SERVICES PRIVATE LIMITED',
    'RT PACKAGING LIMITED',
    'S R CORPORATE SERVICES PRIVATE LIMITED',
    'S B PACKAGINGS LIMITED',
    'RYTHMOS INDIA PVT LTD',
    'ruchi restaurants pvt ltd',
    'SABIC RESEARCH AND TECHNOLOGY PRIVATE LIMITED',
    'S J LOGISTICS INDIA PRIVATE LIMITED',
    'ROYAL STAR JEWELLERY PRIVATE LIMITED',
    'RUTTONSHA INTERNATIONAL RECTIFIER LIMITED',
    'ROSTI TECHNICAL PLASTICS (INDIA) PRIVATE LIMITED',
    'ROLLS-ROYCE MARINE INDIA PRIVATE LIMITED',
    'RUNWAL HOMES PRIVATE LIMITED',
    'RUBICON RED SOFTWARE INDIA PRIVATE LIMITED',
    'ROTHSCHILD (INDIA) PRIVATE LIMITED',
    'RUSADA INDIA PRIVATE LIMITED',
    'SAAHAJ MILK PRODUCER COMPANY LTD',
    'ROMSONS SCIENTIFIC AND SURGICAL INDUSTRIES PRIVATE LIMITED',
    'RUPTUB SOLUTIONS PRIVATE LTD',
    'ROYALGOLF LINK CITY PROJECTS PRIVATELIMITED',
    'RUCHI INFOTECH LIMITED',
    'ROLLS ROYCE INDIA PRIVATE LIMITED',
    'S M SUGAR PRIVATE LIMITED',
    'SAGE METALS LIMITED',
    'SAKET CITY HOSPITALS PRIVATE LIMITED',
    'SAFENET INFOTECH PRIVATE LIMITED',
    'SAFE and SECURE LOGISTIC PVT LTD',
    'SANGHVI FORGING AND ENGINEERING LIMITED',
    'SANGKAJ STEEL LIMITED',
    'SAGA AUTOMOTIVE (INDIA) PRIVATE LIMITED',
    'SANGKAJ ENGINEERING PVT LTD',
    'SAKSHI EDUCATION CONSULTING AND TRAINING PRIVATE LIMITED',
    'SANFIELD INDIA LIMITED',
    'SAMSHI PIPE INDUSTRIES LIMITED',
    'SAGITEC SOLUTION PVT LIMITED',
    'SAMRUDDHI REALTY LIMITED',
    'SANGHVI ORGANICS PVT. LTD.',
    'SAGAR HEALTH CARE AND DIAGNOSTIC SERVICES PRIVATE LIMITED',
    'SAI LILAGAR POWER LIMITED',
    'SAMASTA MICROFINANCE LTD',
    'SAINT GOBAIN SEKURIT INDIA LIMITED',
    'Salmon Commerce Pvt Ltd',
    'SALTMARCH MEDIA INDIA PRIVATE LIMITED',
    'Sai regency power corporation private limited',
    'SANKALP & KPIT SEMICONDUCTOR PRIVATE LIMITED',
    'SANKARA NETHRALAYA PRIVATE LIMITED',
    'SAKAR POULTRY PVT LTD',
    'SAIF ADVISORS PRIVATE LIMITED',
    'SAI SHANKAR MANAGEMENT SERVICES PRIVATE LIMITED',
    'SAMUNDRA INSTITUTE OF MARITIME STUDIES',
    'SAKURA AUTOPARTS INDIA PVT LTD',
    'sai point automobiles pvt ltd',
    'SAISANJ RETAIL PRIVATE LIMITED',
    'SACHI INFOTECH PRIVATE LIMITED',
    'SAMRAT GEMS IMPEX PVT LTD',
    'SAI SOFTEK SERVICES PRIVATE LIMITED',
    'SANMINA SCI TECHNOLOGY INDIA PRIVATE LIMITED',
    'SAKRI IT SOLUTIONS PRIVATE LIMITED',
    'SANCTUM WEALTH MANAGEMENT PRIVATE LIMITED',
    'SAINT GOBAIN RESEARCH INDIA PRIVATE LIMITED',
    'SAHIBJI TRAVELS and TOURS PRIVATE LIMITED',
    'SALINI INDIA PRIVATE LIMITED',
    'SAM GAS PROJECTS PVT LTD',
    'Sarda plywood industries ltd',
    'SAVOURITES HOSPITALITY PVT LTD',
    'SAYA HOMES PRIVATE LIMITED',
    'SEASONS TEXTILES LTD',
    'SAVERA PRESS COMPS PVT LTD',
    'Saya buildcon consortium private limited',
    'SASKEN NETWORK ENGINEERING LIMITED',
    'SCHNEIDER PROTOTYPING INDIA PRIVATELIMITED',
    'SAVERA DIGITAL INDIA PVT LTD',
    'SCARECROW COMMUNICATIONS LIMITED',
    'SCRIPLOGIX ANALYTICS PVT LTD',
    'SEGMENTAL CONSULTING AND INFRASTRUCTURE ADVISORY PRIVATE LIMITED',
    'SD LOGITRADE INDIA P LTD',
    'SATURN SYSTEMWARES PRIVATE LIMITED',
    'SEAMLESS EDUCATION ACADEMY PRIVATE LIMITED',
    'SASHAKTA TECHNOLOGIES PRIVATE LIMITED',
    'SATYAM CINEPLEXES LIMITED',
    'SCHUNK METAL AND CARBON (INDIA) PRIVATE LIMITED',
    'SDS RAMCIDES CROPSCIENCE PRIVATE LIMITED',
    'SAPL INDUSTRIES PVT LTD',
    'SARLA PERFORMANCE FIBERS LTD',
    'SD FINE CHEM LIMITED',
    'SEKTRA MARKETING SERVICES PRIVATELIMITED',
    'SEEC TECHNOLOGIES ASIA PRIVATE LIMITED',
    'searchlight health pvt ltd',
    'SCSOFT TECHNOLOGIES PRIVATE LIMITED',
    'SAPA EXTRUSION INDIA PRIVATE LIMITED',
    'SEA TRADE SHIPPING INDIA PRIVATE LIMITED',
    'SARASWAT INFOTECH LIMITED',
    'SAXON SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'SECURE 24 IT SERVICES PRIVATE LIMITED',
    'SBI FUNDS MANAGEMENT PRIVATE LIMITED',
    'SCANDIC FOOD INDIA PRIVATE LIMITED',
    'SCHOOL GURU EDUSERVE PRIVATE LIMITED',
    'SATMED CLAIM SERVICES PRIVATE LIMITED',
    'SEEDS INTIMATE APPAREL INDIA PVT LTD',
    'SECURIFI EMBEDDED SYSTEMS INDIA PRIVATE LIMITED',
    'SEAARLAND MANAGEMENT SERVICES (INDIA) PRIVATE LIMITED',
    'SEARS IT &MANAGEMENT SERVICES INDIA PVT LTD',
    'SASMOS HET TECHNOLOGIES LTD',
    'SDB SELECT SERVICES PRIVATE LIMITED',
    'SAVVYMOB TRAVEL SOLUTIONS PVT LTD',
    'SHIV NARESH SPORTS PVT LTD',
    'SHERVANI HOSPITALITIES LIMITED',
    'SHIVA DISTILLERIES LIMITED',
    'SHINRAI AUTO SERVICES LTD',
    'Shiva Cement Limited',
    'SEOYON E-HWA AUTOMOTIVE CHENNAI PRIVATE LIMITED',
    'SHARMAN WOOLLEN MILLS LIMITED',
    'SHIV SAMARTH MOTORS (INDIA) PRIVATE LIMITED',
    'SHIVAM SYNCOTEX PVT LTD',
    'SHIGA ENERGY PVT LTD',
    'SHIVAM HI TECH STEELS PRIVATE LIMITED',
    'SERDIA PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'SEMAC CONSULTANTS PVT LTD',
    'SHIRDI INDUSTRIES LIMITED',
    'SERVICE CARE PRIVATE LIMITED',
    'SHEOREY DIGITAL SYSTEMS LIMITED',
    'SELLIGENCE TECHNOLOGIES SERVICES PRIVATE LIMITED',
    'SHENG LI TELECOM INDIA PRIVATE LIMITED',
    'SERENDIPITY INFOLABS PRIVATE LIMITED',
    'SHINRAI INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'SHIROKI TECHNICO INDIA PVT. LTD.',
    'SEROLE INFO TECHNOLOGIES INDIA PVT LTD',
    'SHALIMAR HATCHERIES LIMITED',
    'SHIRT COMPANY (INDIA) PRIVATE LIMITED',
    'SHANGHVI AND ASSOCIATES CONSULTANTS PRIVATE LIMITED',
    'SGP Software Solutions Pvt Ltd',
    'SHIFT INDIA PRIVATE LIMITED',
    'SGS MEDTRANS SOLUTIONS PRIVATE LIMITED',
    'SERGI TRANSFORMER EXPLOSION PREVENTION TEHCNOLOGIES PRIVATE LIMITED',
    'SENES CONSULTANTS INDIA PRIVATE LIMITED',
    'SHAH INFRA TOWERS PVT LTD',
    'SEPTODONT HEALTHCARE INDIA PRIVATELIMITED',
    'SHARP FACILITY MANAGEMENT PRIVATE LIMITED',
    'SGB SCAFFOLDING AND INDUSTRIAL SERVICES PRIVATE LIMITED',
    'SGL CARBON INDIA PRIVATE LIMITED',
    'SHEEL DIAMOND EXPORTS LIMITED',
    'SHETH DEVELOPERS AND REALTORS INDIA LIMITED',
    'SERIAL INNOVATIONS INDIA PRIVATE LIMITED',
    'SHIAMAK DAVAR INTERNATIONAL (INDIA)PRIVATE LIMITED',
    'SEQUOIA CAPITAL INDIA ADVISORS PRIVATE LIMITED',
    'SHARMA ORTHOPEDIC INDIA PRIVATE LIMITED',
    'SENSE DIGITAL MEDIA PVT LTD',
    'SHAW ACADEMY EDUCATION PRIVATE LIMITED',
    'SHIVALIK DISTRIBUTION PVT LTD',
    'Shivalik Communications Pvt Ltd',
    'SHARP BUSINESS SYSTEMS INDIA PRIVATE LIMITED',
    'SIDDHARTH GREASE AND LUBES PRIVATE LIMITED',
    'SHOWA INDIA PRIVATE LIMITED',
    'SHRENIK INDUSTRIES PRIVATE LIMITED',
    'SHREE PUJA OVERSEAS PRIVATE LIMITED',
    'SIEMENS POSTAL PARCEL & AIRPORT LOGISTICS PRIVATE LIMITED',
    'SIDDHI PORTFOLIO SERVICES P LTD',
    'SHOE CLUB INDIA PRIVATE LIMITED',
    'SICGILSOL INDIA PRIVATE LIMITED',
    'SIE BRAINS TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SILICON LABORATORIES SEMICONDUCTORS INDIA PRIVATE LIMITED',
    'SILICOMP INDIA PRIVATE LIMITED',
    'SHRIRAM AXIALL PRIVATE LIMITED',
    'SIGACHI INDUSTRIES PRIVATE LIMITED',
    'SHREEGEN PHARMA LTD',
    'SHRAMIK POWER JOB PRIVATE LIMITED',
    'SIGMA FITNESS PRIVATE LIMITED',
    'Signatureglobal (india) private limited',
    'Shubhram Hospital Solutions Pvt Ltd',
    'SHRINIVAS ELECTRICALS GTD PRIVATE LIMITED',
    'SHRIRAM EPC LIMITED',
    'SHORETEL COMMUNICATIONS PRIVATE LIMITED',
    'SIGNET CHEMICAL CORPORATION PRIVATE LIMITED',
    'SHIVAS FARMA CASA PRIVATE LIMITED',
    'SIDEL INDIA PVT LTD',
    'shree balaji alumnicast private ltd',
    'SHREE BALAJI ETHNICITY RETAIL LIMITED',
    'SIERRA CEDAR INDIA PRIVATE LIMITED',
    'SIGMAAVIT TECHNOLOGY SOLUTIONS PVT LTD',
    'SIGMA MICROSYSTEMS PRIVATE LIMITED',
    'SIGMA OSS SYSTEMS INDIA PRIVATE LIMITED',
    'SKYPACK INDIA PVT LTD',
    'SMILE MULTIMEDIA PRIVATE LIMITED',
    'SITEC LABS PRIVATE LIMITED',
    'SKUMAR AND COMPANY (TRADES) PRIVATE LIMITED',
    'SMITHS DETECTION VEECON SYSTEMS PRIVATE LIMITED',
    'SINWOO PACK INDIA PVT LTD',
    'SNEHA KINETIC POWER PROJECTS PRIVATELIMITED',
    'SIMPLION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SKM SIDDHA AND AYURVEDHA COMPANY INDIA PVT LTD',
    'SIMOLA VITRIFIED PVT LTD',
    'SKANRAY TECHNOLOGIES PRIVATE LIMITED',
    'SISL INFOTECH PVT. LTD',
    'SIMRAN INTERNATIONAL EXPORT INDIA PRIVATE LIMITED',
    'SINGER INDIA LTD',
    'SITAPURAM POWER LTD',
    'SISTEMA SHYAM TELESERVICES LIMITED',
    'SIS PROSEGUR HOLDINGS PVT LTD',
    'SKYLARK INFRA ENGINEERING PVT LTD',
    'SINMADO ENGINEERING (INDIA) PRIVATE LIMITED',
    'SMS IRON TECHNOLOGY PRIVATE LIMITED',
    'SK RESTAURANT PVT LTD',
    'SMARTESTING SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SLING MEDIA PRIVATE LIMITED',
    'SIPERA SYSTEMS PRIVATE LIMITED',
    'SLK GLOBAL SOLUTIONS PVT LTD',
    'SMART SUPPLY CHAIN MANAGEMENT SOFTWARE PRIVATE LIMITED',
    'Sk systems private limited',
    'SIMPA ENERGY INDIA PRIVATE LIMITED',
    'SKANEM INTERLABELS INDUSTRIES PRIVATE LIMITED',
    'SKYLARK WAREHOUSING SOLUTIONS PVT LTD',
    'SINTEX BAPL LIMITED',
    'SINTERCOM INDIA PRIVATE LIMITED',
    'SNAPDEAL PRIVATE LIMITED',
    'SINGHAL POWER PRESSES PVT LTD',
    'SNAP ON TOOLS PRIVATE LIMITED',
    'SMITH AND NEPHEW HEALTHCARE PRIVATE LIMITED',
    'Skylark realtors private limited',
    'Smarttrak Solar Systems Pvt Ltd',
    'SILICUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SKAVA SYSTEMS PRIVATE LIMITED',
    'SMARTEK CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'SMR HR TECHNOLOGIES PRIVATE LIMITED',
    'SMMILKOSE LIMITED',
    'skn haryana city gas distribution pvt ltd',
    'SNIPP INTERACTIVE INDIA PRIVATE LIMITED',
    'SQUARE ROOT HOSPITALITIES PRIVATE LIMITED',
    'SOMA TEXTILES AND INDUSTRIES LTD',
    'SOMANY FOAM LIMITED',
    'SPACE MATRIX DESIGN CONSULTANTS PVT LTD',
    'SPJ CARGO PVT LTD',
    'Sona Gold Agrochem Pvt Ltd',
    'SPACE CIRCLE CLUBS AND RESORTS PRIVATE LIMITED',
    'SOMA TECH PRIVATE LIMITED',
    'SREE SAKTHI PAPER MILLS LIMITED',
    'SOLAR ENERGIETECHNIK LIMITED',
    'SPX FLOW TECHNOLOGY INDIA PVT LTD',
    'SOLITAIRE INFOSYS PRIVATE LIMITED',
    'SPRINGWELL MATTRESSES PVT LTD',
    'SODECIA INDIA PVT LIMITED',
    'SPECTRO ANALYTICAL LABS LIMITED',
    'SOLAS FIRE SAFETY EQUIPMENT PVT LTD',
    'SPRINT CARS PVT LTD',
    'soiltech india pvt ltd',
    'SPIRAX SARCO INDIA PRIVATE LIMITED',
    'SPECTRUM AUXI CHEM PRIVATE LIMITED',
    'SOCOMEC INNOVATIVE POWER SOLUTIONSPRIVATE LIMITED',
    'SPE FILMS INDIA PRIVATE LIMITED',
    'SPS INTERMODAL SERVICES INDIA PRIVATE LIMITED',
    'SPRINGER (INDIA) PRIVATE LIMITED',
    'SPECTRUM BUSINESS SOLUTIONS LTD',
    'SONGWON SPECIALTY CHEMICALS-INDIA PVT LTD',
    'SPENCERS TRAVEL SERVICES LIMITED',
    'SPECTRUM ETHERS LTD',
    'SPRINT EXPORTS PVT LTD',
    'SOLIX SOFTECH PVT LTD',
    'SPRING INFRADEV LIMITED',
    'SPC INTERNATIONAL INDIA PVT LTD',
    'SOMANDA VINEYARDS and RESORTS PRIVATE LIMITED',
    'SPIDERLOGIC INDIA PRIVATE LIMITED',
    'SPECIALITY SINTERED PRODUCTS PRIVATELIMITED',
    'SOFTINWAY TURBOMACHINERY SOLUTIONS PRIVATE LIMITED',
    'SPEAR LOGISTICS PRIVATE LIMITED',
    'SOLTEX PETROPRODUCTS LTD',
    'SOLVE IT SOLUTIONS PRIVATE LIMITED',
    'SOLUTIONS INTEGRATED MARKETING SERVICES PRIVATE LIMITED',
    'SOFTTECH ENGINEERS PRIVATE LIMITED',
    'SQUID DESIGN SYSTEMS PRIVATE LIMITED',
    'SONACHI INDUSTRIES LIMITED',
    'SONUS NETWORKS INDIA PRIVATE LIMITED',
    'SOFTINN SOFTWARE SERVICES PRIVATE LIMITED',
    'SONY PICTURES NETWORKS DISTRIBUTION INDIA PRIVATE LIMITED',
    'Solcen Technologies Pvt LTD',
    'SOHM ANALYTICAL SERVICES I PVT LTD',
    'SPACE HUB SMART LIVINGS PRIVATE LIMITED',
    'SPECTRAL SERVICES CONSULTANTS PRIVATE LIMITED',
    'Stanford Laboratories Pvt Ltd',
    'STEWART & MACKERTICH WEALTH MANAGEMENT LIMITED',
    'SRMB SRIJAN LIMITED',
    'STADMED PRIVATE LIMITED',
    'STI SANOH INDIA PRIVATE LIMITED',
    'STAR ENGINEERS INDIA PRIVATE LIMITED',
    'STANDARD CHARTERED FINANCE LIMITED',
    'SRICITY PROJECTS PRIVATE LIMITED',
    'Sterling graphics pvt ltd',
    'STI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SRM HOTELS PVT LIMITED',
    'SS UTENSILS MANUFACTURING COMPANY PRIVATE LIMITED',
    'STERLING META PLAST INDIA PRIVATE LIMITED',
    'STANLEY BLACK AND DECKER INDIA PRIVATE LIMITED',
    'STATCON POWER CONTROLS LIMITED',
    'STAFFORD CONTROLS LIMITED',
    'STATOMAT SPECIAL MACHINES INDIA PRIVATE LIMITED',
    'SRI JAYAJOTHI & COMPANY LIMITED',
    'STAR PAPER MILLS LTD',
    'STANLEY RETAIL LTD',
    'STEMKOR INTERNATIONAL PRIVATE LIMITED',
    'STERLING AND WILSON CO GEN SOLUTIONS PRIVATE LIMITED',
    'STANDARD OILS GREASES PRIVATE LIMITED',
    'STEELFAB ENGINEERING PVT LTD',
    'STALLION SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'STARWOOD CONTRACTS PVT LTD',
    'STAR DEN MEDIA SERVICES PRIVATE LIMITED',
    'STAR HEALTH AND ALLIED INSURANCE COMPANY LTD',
    'STALWART SECURITY SERVICES INDIA LIMITED',
    'SRS GLOBAL SECURITIES LIMITED',
    'SRS FINANCE LIMITED',
    'STEINER INDIA LTD',
    'STAMPEDE CLOUD SERVICES PRIVATE LIMITED',
    'SRICO POWERTECH PVT. LTD',
    'STELIS BIOPHARMA PRIVATE LIMITED',
    'STERIS INDIA PVT LTD',
    'STARAGRI FINANCE LIMITED',
    'STANLEY ENGINEERED FASTENING INDIAPRIVATE LIMITED',
    'SUNRISE ESUPPORT PRIVATE LIMITED',
    'studio u plus a advisory pvt ltd',
    'SUNVISORS INDIA PVT LTD',
    'SUGAL & DAMANI UTILITY SERVICES PRIVATE LIMITED',
    'stonex india pvt ltd',
    'SukhSagar Complexes Pvt ltd',
    'SUPPORTMART TECHNICAL SERVICES PRIVATE LIMITED',
    'STRANGE EXPORTS PVT LTD',
    'SUMITRON EXPORTS PVT LTD',
    'SUNGRO SEEDS PRIVATE LTD',
    'SUDHAKARAN NAIR & COMPANY PRIVATE LIMITED',
    'STRATCAP WEALTH MANAGEMENT PRIVATE LIMITED',
    'SUPREME AUTO DEALERS PVT LTD',
    'SUDIVA SPINNERS PVT LTD',
    'SUPER MARKETING SERVICES PVT LTD',
    'STYRAX COMMODITIES LIMITED (EDELWEISS)',
    'STYX BACK OFFICE SERVICES PRIVATE LIMITED',
    'SUMEET FACILITIES PRIVATE LIMITED',
    'SUPPORT.COM INDIA PVT LTD',
    'SUMATI LEGAL SERVICES PVT LTD',
    'SUPERIOR TALENT INDIA PRIVATE LIMITED',
    'SUPERIOR SHARED SERVICES INDIA PRIVATELIMITED',
    'SUBHAM PLANNERS LIMITED',
    'STRUENGINEERS INDIA PRIVATE LIMITED',
    'STRING INFORMATION SERVICES PRIVATE LIMITED',
    'STOLL INDIA PRIVATE LIMITED',
    'SUDERSHAN BIOTECH PRIVATE LIMITED',
    'SUMITOMO CHEMICAL INDIA PRIVATE LIMITED',
    'SUMITOMO (S.H.I.) CONSTRUCTION MACHINERY INDIA PRIVATE LIMITED',
    'SUGAM VANIJYA HOLDINGS PRIVATE LIMITED',
    'suminter india organics pvt ltd',
    'SUICH INDUSTRIES PRIVATE LIMITED',
    'SUN-ARES INDIA REAL ESTATE PRIVATE LIMITED',
    'STUDY OVERSEAS GLOBAL PRIVATE LIMITED',
    'SULA VINEYARDS PRIVATE LIMITED',
    'SUPER SEALS (INDIA) LIMITED',
    'Stove kraft private limited',
    'SULZER CHEMTECH TOWER FIELD SERVICES (INDIA) PRIVATE LIMITED',
    'Sukritha Buildmann Pvt Ltd',
    'Supreme Nutri Grain Pvt Ltd',
    'SUNSHIELD CHEMICALS LTD',
    'SUKSH TECHNOLOGY PRIVATE LIMITED',
    'STYROLUTION INDIA PRIVATE LIMITED',
    'SUMIT WOODS PRIVATE LIMITED',
    'SUMAN ELECTRIC UDYOGS P LTD',
    'SUNGARD AVAILABILITY SERVICES INDIA PRIVATE LIMITED',
    'SUMI CYCLO DRIVE INDIA PRIVATE LIMITED',
    'SUPER INDIA GLOBAL LOGISTICS PRIVATE LIMITED',
    'STUDYMODE TECHNOLOGIES PRIVATE LIMITED',
    'SUBLIME FOODS PRIVATE LIMITED',
    'SUEZ WATER TECHNOLOGIES AND SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SYNDICATE INNOVATIONS INTERNATIONALLIMITED',
    'Suvidha Stores Pvt Ltd',
    'SUVIDHA ENGINEERS INDIA PRIVATE LIMITED',
    'SYSTECH FRANCHISE CONSULTANTS PRIVATE LIMITED',
    'SURYA CONS PVT LTD',
    'SYNERZIP SOFTECH INDIA PRIVATE LIMITED',
    'SYSNET GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'SYNERGY CARGO MANAGEMENT INDIA PRIVATE LIMITED',
    'systemair india pvt ltd',
    'SYSTRA MVA CONSULTING INDIA PRIVATE LIMITED',
    'SVAM PACKAGING INDUSTRIES PRIVATE LIMITED',
    'SYNONN LIFESCIENCES LIMITED',
    'SURI ENGINEERS PVT LTD',
    'SWISS LAMPS PRIVATE LIMITED',
    'SURGICON HEALTHCARE PRIVATE LIMITED',
    'SYNERGIA CONSULTANTS PRIVATE LIMITED',
    'SURYA CHILDRENS MEDICARE PVT LTD',
    'SYSTECH SERVICES LIMITED',
    'T & M SERVICES CONSULTING PRIVATELIMITED',
    'SWAFE BUSINESS PROCESS MANAGEMENT PRIVATE LIMITED',
    'SYKES BUSINESS SERVICES OF INDIA PRIVATE LIMITED',
    'SVC VENTURES PRIVATE LIMITED',
    'SWASTIK INFRA LOGIC INDIA PRIVATE LIMITED',
    'SURETEX PROPHYLACTICS (INDIA) LIMITED',
    'SUYASH IMPEX PRIVATE LIMITED',
    'SYENA INFOSOFT PVT LTD',
    'SYKES ENTERPRISES (INDIA) PRIVATE LIMITED',
    'SYMBIOSIS NETWORK PRIVATE LIMITED',
    'SURANJAN HOLDING AND ESTATE DEVELOPERS PRIVATE LIMITED',
    'Swiss Re Global Business Solutions india Private limited',
    'SV ALUEXT PROFILE PVT LTD',
    'SYNNOVA GEARS AND TRANSMISSIONS PRIVATE LIMITED',
    'SWADHAAR FINSERVE PRIVATE LIMITED',
    'SYNCHRONICA MOBILE GATEWAY PRIVATE LIMITED',
    'SWIFT FREIGHT (INDIA) PRIVATE LIMITED',
    'SYNOPHIC SYSTEMS PRIVATE LIMITED',
    'SWADHAAR INFORMATION AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'SYNOPSYS INDIA EDA SOFTWARE PVT LTD',
    'SUVIJAY BUILDCON PUNE PRIVATE LIMITED',
    'SURI SHOES PVT LTD',
    'SVP INDUSTRIES LTD',
    'SYNFINITY MANAGEMENT CONSULTANTS PVT LTD',
    'SVP MANAGEMENT & TECHNICAL SERVICES PRIVATE LIMITED',
    'SYNCRON SERVICES INDIA PRIVATE LIMITED',
    'SYNCORDIS SOFTWARE SERVICES INDIA PVT LTD',
    'SWESIGMA IT CONSULTING INDIA PRIVATE LIMITED',
    'SYNOVATE INDIA PRIVATE LIMITED',
    'SWASTIK ROADLINES PRIVATE LIMITED',
    'TCS AND ASSOCIATES PVT LTD',
    'TEK TRAVELS PRIVATE LIMITED',
    'TC VISA SERVICES INDIA LIMITED',
    'Teamwork education foundation',
    'TEKNOS INDIA AND CO. PRIVATE LIMITED',
    'TAEWOONG LOGISTICS PRIVATE LIMITED',
    'TAS-AGT SYSTEMS LIMITED',
    'TECTYL OIL AND CHEMICALS INDIAPRIVATE LIMITED',
    'TATA ASSET MANAGEMENT LIMITED',
    'TANAKA AUTO PARTS INDIA PRIVATE LIMITED',
    'TANGERINE DIGITAL ENTERTAINMENT PRIVATE LIMITED',
    'TECHCIL TECHNOLOGY PRIVATE LIMITED',
    'TECHERGO SOLUTIONS LIMITED',
    'TAVANT TECHNOLOGIES INDIA PVT LTD',
    'TASA FOODS PVT LTD',
    'TAFFLES TRADING SERVICES PVT LTD',
    'TENTY MARKETING CO PRIVATE LIMITED',
    'TANDBERG TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'TANLA CORPORATION PRIVATE LIMITED',
    'TAKASAGO INTERNATIONAL INDIA PVT LTD',
    'TAIYO LUCID PRIVATE LIMITED',
    'TAKATA INDIA PRIVATE LIMITED',
    'TANLA SOLUTIONS LIMITED',
    'TECHNICOLOR CONNECTED HOME INDIA PRIVATE LIMITED',
    'TELENOR INDIA COMMUNICATIONS PRIVATE LIMITED',
    'TENPATH SOLUTIONS PRIVATE LIMITED',
    'TEAM HR SERVICES LIMITED',
    'TECHKNIT IT ENABLED SERVICES PRIVATE LIMITED',
    'TECH AUTO PVT LTD',
    'TEKNOMICS SYSTEMS PRIVATE LIMITED',
    'TECHATLANTIS LABS INDIA PRIVATE LIMITED',
    'TENSILICA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TECHJINI SOLUTIONS PRIVATE LIMITED',
    'TARGET TRAINING SERVICES PRIVATE LIMITED',
    'TAGROS CHEMICALS',
    'T S Lines India Private Limited',
    'TEK COMPONENTS PVT LTD',
    'TELERADIOLOGY SOLUTIONS PRIVATE LIMITED',
    'TARASPAN SOLUTIONS PRIVATE LIMITED',
    'TATA HAL TECHNOLOGIES LIMITED',
    'Talena Software Pvt Ltd',
    'TEJAS CONSTRUCTIONS and INFRASTRUCTURE PRIVATE LIMITED',
    'TAINWALA CHEMICALS AND PLASTICS INDIA LTD',
    'TAG OFFSHORE LIMITED',
    'TEBODIN INDIA PVT LTD',
    'TAVISCA SOLUTIONS PRIVATE LIMITED',
    'TECHILA SOLUTIONS PRIVATE LIMITED',
    'TBEA INDIA TRANSFORMER PRIVATE LIMITED',
    'TECHNIP GLOBAL BUSINESS SERVICES PVT LTD',
    'TATA SKY BROADBAND PRIVATE LIMITED',
    'TATA BOEING AEROSPACE LTD',
    'TASTETARIA PRIVATE LIMITED',
    'TECHNIP E&C INDIA LIMITED',
    'MONTGOMERY TECHNOLOGIES PRIVATE LIMITED',
    'ALUBO NETZWERKS PRIVATE LIMITED',
    'BUILDMYINFRA PRIVATE LIMITED',
    'LEONIS AUSTIN TOWN DEVELOPERS PRIVATE LIMITED',
    'HYREFOX CONSULTANTS PRIVATE LIMITED',
    'UTKARSH TRANSPORT PRIVATE LIMITED',
    'ZYSOL INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'UPFIELD SERVICES PRIVATE LIMITED',
    'UNIFII-NOW TECHNOLOGY CONSULTING PRIVATELIMITED',
    'ENFUSION SOFTECH INDIA PRIVATE LIMITED',
    'PERIVAN INDIA PRIVATE LIMITED',
    'RAMPRASTHA CITY DEVELOPERS PRIVATE LIMITED',
    'PIXELMIND IT SOLUTIONS PRIVATE LIMITED',
    'GILL DEVELOPERS AND PROMOTORS PRIVATE LIMITED',
    'EQUIRUS WEALTH PRIVATE LIMITED',
    'LA VILLA CANDOLIM PRIVATE LIMITED',
    'ACTIVELOC GLOBALIZATION SERVICES PRIVATELIMITED',
    'BLOOM WAREHOUSING AND DEVICES PRIVATE LIMITED',
    'CIAC GLOBAL FOUNDATION',
    'PUFFERFISH HOSPITALITY PRIVATE LIMITED',
    'CASCHAIN PRIVATE LIMITED',
    'ALERT PAY SOLUTIONS PRIVATE LIMITED',
    'SIMMERING FOODS & RESTAURANTS PRIVATE LIMITED',
    'LEONIS VIJAYANAGAR DEVELOPERS PRIVATE LIMITED',
    'WHITEHATS CYBERTECH PRIVATE LIMITED',
    'ALWADOOD FURNISHING PRIVATE LIMITED',
    'ENTUITE TECHNOLOGIES PRIVATE LIMITED',
    'BLT BRILLIANT LIFTS & ESCALATORS PRIVATELIMITED',
    'EVCO ELECTRIC COMMERCIAL VEHICLES PRIVATE LIMITED',
    'EDGEFINITY PRIVATE LIMITED',
    'SURVAM CORPORATE SERVICES PRIVATE LIMITED',
    'WORLD WED WAREHOUSE PRIVATE LIMITED',
    'PROCHAIN CONSULTING PRIVATE LIMITED',
    'ENHANCE TECH LABS PRIVATE LIMITED',
    'ATHOS ENGINEERING INDIA PRIVATE LIMITED',
    'LEONIS HSR DEVELOPERS PRIVATE LIMITED',
    'AYUSMAT NATUROPATHY AND YOGA HOSPITAL PRIVATE LIMITED',
    'KAI OS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'ENGX ELECTRICALS PRIVATE LIMITED',
    'HEALING PHARMA INDIA PRIVATE LIMITED',
    'MADHAV FARMTECH CORPORATION PRIVATE LIMITED',
    'Condor Footwear Limited',
    'AICPE EDUCATIONAL SERVICES PRIVATE LIMITED',
    'PLANTIX AGRITECH INDIA PRIVATE LIMITED',
    'TEMPUS FRUITS PROCESSING PRIVATE LIMITED',
    'YASASHWI INTERNATIONAL PRIVATE LIMITED',
    'RASAYANA FINE CHEMICALS PRIVATE LIMITED',
    'GREENJOULES PRIVATE LIMITED',
    'ECOFINE COLOURCHEM PRIVATE LIMITED',
    'OVION MOBITECH PRIVATE LIMITED',
    'EXPOFAB LINEN PRIVATE LIMITED',
    'PAVERS AND BLOCKS MANUFACTURERS ASSOCIATION',
    'SGOLECHA PRIVATE LIMITED',
    'BURDWAN POULTRY AND FEEDS PRIVATE LIMITED',
    'PVM MED TRANS SERVICES PRIVATE LIMITED',
    'HELIOCENTRIX TECHNOLOGY PRIVATE LIMITED',
    'SHIVALI FASHION PRIVATE LIMITED',
    'AVAADA GREEN KNPROJECT PRIVATE LIMITED',
    'RABBITFOOTS DIGITAL CONSULTING PRIVATE LIMITED',
    'SUBSCRIPTION ONLINE SERVICES PRIVATE LIMITED',
    'SANTIYA OVERSEAS PRIVATE LIMITED',
    'GNZ CARCARE PRIVATE LIMITED',
    'HUAREN LINEN INDIA PRIVATE LIMITED',
    'CONCEPTUAL MANAGEMENT HOLDINGS PRIVATE LIMITED',
    'LENS ACADEMY PRIVATE LIMITED',
    'SPECTRA COMPUNET PRIVATE LIMITED',
    'GR SANGLI SOLAPUR HIGHWAY PRIVATE LIMITED',
    'ITA CONNECTION PRIVATE LIMITED',
    'LATERITE RESEARCH PRIVATE LIMITED',
    'BCFOODS (INDIA) SEASONINGS AND INGREDIENTS PRIVATE LIMITED',
    'WHITE LOTUS AGRICULTURE PRIVATE LIMITED',
    'ZEMEX PETROCHEMICALS PRIVATE LIMITED',
    'ABZ CONSULTANTS PRIVATE LIMITED',
    'VISHWAKARMA MARINE PRIVATE LIMITED',
    'FORTIGO TRANSPORT AGENCY PRIVATE LIMITED',
    'OPTIMAL CAREER AND STAFFING PRIVATE LIMITED',
    'WAYOL WELLNESS PRIVATE LIMITED',
    'QUALITY KIDNEY CARE PRIVATE LIMITED',
    'SHARADA TECHNO SPECIALTIES PRIVATE LIMITED',
    'YOUR TRAVEL BOOKING PRIVATE LIMITED',
    'NIDLOK STYLE AND SOIREE PRIVATE LIMITED',
    'ARBS EV SOLUTIONS PRIVATE LIMITED',
    'JGC CATALYSTS AND CHEMICALS INDIA PRIVATE LIMITED',
    'MATTER FILES PRIVATE LIMITED',
    'NECTAR TOWN FOUNDATION',
    'SLEEK AVIATION PRIVATE LIMITED',
    'SKYCOMM INTERNET SERVICES PRIVATE LIMITED',
    'WRIGHT TECH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CORTRACK SOLUTIONS PRIVATE LIMITED',
    'OZZY INFONET INDIA PRIVATE LIMITED',
    'OTELTECH PRIVATE LIMITED',
    'ROYALE HAPPYBEAN PRIVATE LIMITED',
    'MAA SAA CARE PRIVATE LIMITED',
    'PARITY TRUSTONE SOLUTIONS PRIVATE LIMITED',
    'BIZWY INFORMATION MANAGEMENT INDIA PRIVATE LIMITED',
    'ROUTECORP INDIA PRIVATE LIMITED',
    'JUSTIFIED ADVERTISING SOFTWARE SERVICES INDIA DIGITAL PRIVATE LIMITED',
    'SUHORA TECHNOLOGIES PRIVATE LIMITED',
    'SITARA SOLAR ENERGY PRIVATE LIMITED',
    'SHAPERS TALENT HIRE SERVICES PRIVATE LIMITED',
    'PINESPHERE SOLUTIONS PRIVATE LIMITED',
    'COMSAFE FOOTWEAR INDUSTRIES PRIVATE LIMITED',
    'SHOBI SOLUTIONS PRIVATE LIMITED',
    'INTERNO DOORS INDIA PRIVATE LIMITED',
    'FINLEAD INNOVATIONS PRIVATE LIMITED',
    'DICE TOY LABS PRIVATE LIMITED',
    'XXL STUDIOWORKS PRIVATE LIMITED',
    'GEOMETRICS AIRFIELDS PRIVATE LIMITED',
    'SIGAKA TECH SOLUTIONS PRIVATE LIMITED',
    'ISHTAR MUSIC PRIVATE LIMITED',
    'PANOPTIC ANALYTICS PRIVATE LIMITED',
    'MIGHTYWARNER INFOSERVE (OPC) PRIVATE LIMITED',
    'FOCUZAR SOLUTIONS PRIVATE LIMITED',
    'RKVITY CLASSES (OPC) PRIVATE LIMITED',
    'JOYAMAZE INDIA PRIVATE LIMITED',
    'ILINK FINANCIAL & MANAGEMENT SERVICES PRIVATE LIMITED',
    'GRAMINI SOLUTIONS PRIVATE LIMITED',
    'AMARAVATHI AERO SPORTS PRIVATE LIMITED',
    'OPIANT TECHNOLOGIES PRIVATE LIMITED',
    'MOI CONSULTANCY PRIVATE LIMITED',
    'SIDDHI WASTETOGREEN LIMITED',
    'BUXKART SECURITIES INDIA PRIVATE LIMITED',
    'MOWONN ECART PRIVATE LIMITED',
    'CONSULTGREEN ENTERPRISES PRIVATE LIMITED',
    'PERSQUARE ENGINEERS INDIA PRIVATE LIMITED',
    'ARKNODEIO SOFTWARE SERVICES PRIVATE LIMITED',
    'RUFINA HOTELS PRIVATE LIMITED',
    'OPTAAMAZE SECURITY GUARDING & TRAINING PRIVATE LIMITED',
    'BERRYDALE FOODS PRIVATE LIMITED',
    'RUKMANI SIKANDER ANAND FILMS PRIVATE LIMITED',
    'REIDIUS ENGITECH PRIVATE LIMITED',
    'HYBER PLASTIC AND RUBBER PRODUCTS (INDIA) PRIVATE LIMITED',
    'SENSORTEC INNOVATION INDIA PRIVATE LIMITED',
    'CHEFLING SOFTWARE PRIVATE LIMITED',
    'QDM SERVICES PRIVATE LIMITED',
    'SATYAKAMGLOBAL INDIA PRIVATE LIMITED',
    'OVERBRIDGE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TOSHNIWAL ELECTRIC WORKS PRIVATE LIMITED',
    'ESEM STABLES PRIVATE LIMITED',
    'THINK FRESH AGRO FARMS PRIVATE LIMITED',
    'MARKANDA REAL ESTATE PRIVATE LIMITED',
    'KOOLKANYA PRIVATE LIMITED',
    'MISK APPARELS PRIVATE LIMITED',
    'BLOOMINGORCHIDS PRIVATE LIMITED',
    'SUMUKH PAPER AND PAPERBOARDS PRIVATE LIMITED (OPC)',
    'SPECTRAA FACILITY SOLUTIONS PRIVATE LIMITED',
    'BELAARU (OPC) PRIVATE LIMITED',
    'ACCI GLOBAL LOGISTICS PRIVATE LIMITED',
    'WEEPROTECT GOODS PRIVATE LIMITED',
    'ZALE TRADING PRIVATE LIMITED',
    'INFUNEX HEALTHCARE PRIVATE LIMITED',
    'VRM STRUCTURES INDIA PRIVATE LIMITED',
    'UNDOKAI SOLUTIONS PRIVATE LIMITED',
    'MAHHAGURU NAVGRAH PRIVATE LIMITED',
    'ATRIA POWER HOLDINGS PRIVATE LIMITED',
    'KABEER SERVKRAFT PRIVATE LIMITED',
    'SPACEPLEXX BIZ. SERVICES PRIVATE LIMITED',
    'TIL ADVISORS PRIVATE LIMITED',
    'ARCOS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'KALTHIA ASHTI PACHOD PRIVATE LIMITED',
    'CORAL LOGISTICS ASSETS (INDIA) PRIVATE LIMITED',
    'NTF NEW WORLD WIND INDIA PRIVATE LIMITED',
    'SYENA KITCHENCONCEPTZ MANUFACTURING PRIVATE LIMITED',
    'TESTINGXPERTS PRIVATE LIMITED',
    'Q1 TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MAVEL TECHNOLOGIES PRIVATE LIMITED',
    'HEALTHWAYS MILK & FOOD PRODUCTS PRIVATE LIMITED',
    'BAJAJ HEALTHCARE SOCIAL FOUNDATION',
    'MOKSA FOUNDATION AND CHARITABLE ASSOCIATION',
    'MEENAMBAKKAM REALTY PRIVATE LIMITED',
    'WADHWANI INSTITUTE FOR ARTIFICIAL INTELLIGENCE FOUNDATION',
    'LEOTECHSA ROBOTICS PRIVATE LIMITED',
    'MABAS MARINE PRIVATE LIMITED',
    'PRO INDIA RECYCLING PRIVATE LIMITED',
    'PIXDYNAMICS PRIVATE LIMITED',
    'KEP TECHNOLOGIES PRIVATE LIMITED',
    'HUIZHONG AUTOMOBILE COMPONENTS INDIA PRIVATE LIMITED',
    'TOPMIND COMMUNICATION PRIVATE LIMITED',
    'AAVANA LABS PRIVATE LIMITED',
    'RSDR BUILDERS PRIVATE LIMITED',
    'VCPM REALTORS PRIVATE LIMITED',
    'VIMSEC TECHNOLOGIES PRIVATE LIMITED',
    'VISIOAPPS TECHNOLOGY PRIVATE LIMITED',
    'MFX INTERACTIVE PRIVATE LIMITED',
    'TENNY JOSE FOODS PRIVATE LIMITED',
    'RMZ ESTATES PRIVATE LIMITED',
    'CONSTROMALL GOODS PRIVATE LIMITED',
    'DEPOTO ECOMMERCE (OPC) PRIVATE LIMITED',
    'STONEBRICKS PROPERTY DEVELOPMENT PRIVATELIMITED',
    'ALTMETA KNOWLEDGE SERVICES PRIVATE LIMITED',
    'FINTRAC GLOBAL SERVICES PRIVATE LIMITED',
    'TEQNOLO SOFTWARE CONSULTANCY SERVICES PRIVATE LIMITED',
    'ASTERPLUS INDIA MERCHANDISERS PRIVATE LIMITED',
    'PREFERRED CONSUMER PRODUCTS PRIVATE LIMITED',
    'BROWN WALL FOODS PRIVATE LIMITED',
    'AIEDA TECHNOLOGIES PRIVATE LIMITED',
    'GALOREKART MARKETPLACE PRIVATE LIMITED',
    'VISHVESHWARA PRODUCTIONS PRIVATE LIMITED',
    'SHEMAROO ENTERTAINMENT LIMITED',
    'UMAIYAL ENTERPRISES SERVICES PRIVATE LIMITED',
    'STILEDIVITA INDIA PRIVATE LIMITED',
    'AGVEDA NUTRI PRODUCTS PRIVATE LIMITED',
    'KHIVESARA ENTERPRISES PRIVATE LIMITED',
    'DYNATRACK HEAVY EQUIPMENT & SPARE PARTS PRIVATE LIMITED',
    'ISHWA HOLIDAYS PRIVATE LIMITED',
    'BENEFITONE ENGAGEMENT TECHNOLOGIES PRIVATE LIMITED',
    'JKACH ENTERPRISES PRIVATE LIMITED',
    'JBM OGIHARA DIE TECH PRIVATE LIMITED',
    'ZEEBER SUPPLYCHAIN PRIVATE LIMITED',
    'ACME RAISAR SOLAR ENERGY PRIVATE LIMITED',
    'MARTLENZ RESEARCH PRIVATE LIMITED',
    'ATZ MEDAPPZ PRIVATE LIMITED',
    'OWLSFIELD MANAGEMENT PRIVATE LIMITED',
    'THEVAR AND MHETRE CONSTRUCTIONS PRIVATE LIMITED',
    'SOWISE TECHNOLOGIES PRIVATE LIMITED',
    'BAJAJ RENEWABLE ENERGY PRIVATE LIMITED',
    'RMZ HI-TECH COMMERCIAL PARKS PRIVATE LIMITED',
    'IBAHANA BEAUTY & WELLNESS PRIVATE LIMITED',
    'TEPSOL RESCO FOUR PRIVATE LIMITED',
    'SARVSAHARA EDUCATION FOUNDATION',
    'CLOUDTHAT SEZ PRIVATE LIMITED',
    'JEEV LIFESTYLES PRIVATE LIMITED',
    'ARS INFRASTRUCTURE PROJECT PRIVATE LIMITED',
    'SYSASTRAL SOFTECH PRIVATE LIMITED',
    'GENQUBE TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'CISMAC AUTOMATION PRIVATE LIMITED',
    'RAVIN MARINE PRIVATE LIMITED',
    'KENNEDYS KOGNITIVE COMPUTING PRIVATE LIMITED',
    'AMOS L&C INSURANCE BROKERS PRIVATE LIMITED',
    'SQAD GEAR PRIVATE LIMITED',
    'VANTEGIC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'AEROTRANS GLOBAL FORWARDING INDIA PRIVATE LIMITED',
    'FIRST WINGS MEDICHECK AND RESEARCH PRIVATE LIMITED',
    'ZESSO VENTURES PRIVATE LIMITED',
    'PAKSHIMITRA POULTRY TECHNOLOGIES PRIVATELIMITED',
    'PHAEDRUS INDIA EXPEDITIONS PRIVATE LIMITED',
    'MYCAP ADVISOR INDIA PRIVATE LIMITED',
    'ASQ INTERNATIONAL FOOD AND BEVERAGE SERVICES PRIVATE LIMITED',
    'SYNERGI CLEAN AIR INDIA PRIVATE LIMITED',
    'PETROCON ENGG. & INSPECTION PRIVATE LIMITED',
    'SUDH INFOSYSTEMS PRIVATE LIMITED',
    'PRICOL GOURMET PRIVATE LIMITED',
    'INTELLIGENT INDUSTRIAL PROJECTS PRIVATE LIMITED',
    'BENETTON ARTIFICIAL INTELLIGENCE PRIVATELIMITED',
    'TREE OF KNOWLEDGE DIGITAL PRIVATE LIMITED',
    'WIVITAN SOLUTIONS INDIA PRIVATE LIMITED',
    'NUMASCALE INDIA PRIVATE LIMITED',
    'EXPERIMENTAL RESTAURANTS PRIVATE LIMITED',
    'HARNESSIO R&D LABS INDIA PRIVATE LIMITED',
    'AURAGLASS PRIVATE LIMITED',
    'SNAPZO TECHNOLOGIES PRIVATE LIMITED',
    'AECO TECHNOSTRUCT PRIVATE LIMITED',
    'KALPITA TECHNOLOGIES PRIVATE LIMITED',
    'IDEANT MOBILITY AND TESTING CERTIFICATION PRIVATE LIMITED',
    'QBN ENTERPRISES (OPC) PRIVATE LIMITED',
    'ADAMSON INTERNET PRIVATE LIMITED',
    'BINTIX WASTE RESEARCH PRIVATE LIMITED',
    'MANUSAMARTH ENGINEERING INDIA PRIVATE LIMITED',
    'WUERT EXPORTS PRIVATE LIMITED',
    'JEVALI RENEWABLE ENERGY PRIVATE LIMITED',
    'TENGRAM TECHNOLOGIES PRIVATE LIMITED',
    'TRAAVISTA HOTELS AND RESORTS PRIVATE LIMITED',
    'DIVINE TECHNOVATIONS PRIVATE LIMITED',
    'QUADRANT RESEARCH AND SERVICES PRIVATE LIMITED',
    'MALVERNER CREATIVE PRIVATE LIMITED',
    'HAPPYMATE FOODS LIMITED',
    'DCS GENETICS PRIVATE LIMITED',
    'ASPL PROCON PRIVATE LIMITED',
    'LIMINAL TECH PRIVATE LIMITED',
    'RIZIENT TECHNOLOGIES PRIVATE LIMITED',
    'ITW MEDIAWORX PRIVATE LIMITED',
    'RESICAP INDIA PRIVATE LIMITED',
    'SUNGSHIN CONSTRUCTION INDIA PRIVATE LIMITED',
    'APPENTUS TECHNOLOGIES PRIVATE LIMITED',
    'RUSSELL TOBIN ASSOCIATES STAFFING SOLUTIONS INDIA PRIVATE LIMITED',
    'AGRIVOLUTION FOUNDATION',
    'RESILIENT CONNECT SOLUTIONS PRIVATE LIMITED',
    'CLARION INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'AMPLUS GREEN ONE POWER PRIVATE LIMITED',
    'AITRON ICT VENTURES PRIVATE LIMITED',
    'MUTHU SOFT LABS PRIVATE LIMITED',
    'KENZO NUTRICO PRIVATE LIMITED',
    'GOODLUCK SYSTEMS PRIVATE LIMITED',
    'FINWISELY FINTECH SERVICES PRIVATE LIMITED',
    'SKYNIK FREIGHT INDIA PRIVATE LIMITED',
    'QUALIMOUNT ENGINEERING PRIVATE LIMITED',
    'FFEUROX PRIVATE LIMITED',
    'EXXENCE INDIA MANAGEMENT PRIVATE LIMITED',
    'DINDORI ORGANIC KRISHAK PRODUCER COMPANYLIMITED',
    'FINESS DESIGN TRADING AND MANUFACTURING (OPC) PRIVATE LIMITED',
    'SVC CARGO PRIVATE LIMITED',
    'GORBANDH HOTEL PRIVATE LIMITED',
    'MAKE YOUR DESTINATIONS PRIVATE LIMITED',
    'SHIBLI CONTINENTAL PRIVATE LIMITED',
    'AMREST ELECTRICALS LIMITED',
    'NUVRI INDIA PRIVATE LIMITED',
    'TGF GLASS AND ALUMINIUM (I) PRIVATE LIMITED',
    'EBSC TECHNOLOGIES PRIVATE LIMITED',
    'MATTOX HEALTHCARE PRIVATE LIMITED',
    'SOFTICES CONSULTANCY PRIVATE LIMITED',
    'BIRLON RING TRAVELLER PRIVATE LIMITED',
    'CONSAM TELECOM PRIVATE LIMITED',
    'DHARMADEV BUILDCON PRIVATE LIMITED',
    'PIE NETWORK PRIVATE LIMITED',
    'ROADWAY SOLUTION HINJAWADI HIGHWAY PROJECT PRIVATE LIMITED',
    'APPOIDS TRAVEL TECH MEDIA PRIVATE LIMITED',
    'SPRINTIT EXPERTS PRIVATE LIMITED',
    'ST JOHNS HEALTH INNOVATION FOUNDATION',
    'BAY AREA ADVANCED ANALYTICS INDIA PRIVATE LIMITED',
    'SMOTEC AUTOMATION PRIVATE LIMITED',
    'MELODIUM MARITIME PRIVATE LIMITED',
    'MASS STUDIOS PRIVATE LIMITED',
    'ADEEP MY IT SOLUTION PRIVATE LIMITED',
    'SENSILA VOYAGES PRIVATE LIMITED',
    'SBR FOODS PRIVATE LIMITED',
    'FAIRSPACE MEDIA SERVICES PRIVATE LIMITED',
    'ALMAN INTERACTIVE PRIVATE LIMITED',
    '10 MILLION STORIES ENTERTAINMENT PRIVATELIMITED',
    'SARCLAD INDIA PRIVATE LIMITED',
    'OSCEOLA STAFFING PRIVATE LIMITED',
    'RELENZIA PHARMA PRIVATE LIMITED',
    'MARI KRIPA FURNITURE PRIVATE LIMITED',
    'GOODLUCK FACILITIES PRIVATE LIMITED',
    'KALT FACTORY PRIVATE LIMITED',
    'ODIN ADVISORY (OPC) PRIVATE LIMITED',
    'MAGHAJZ ENTERTAINMENT PRIVATE LIMITED',
    'TRUGLINT DETAILING PRIVATE LIMITED',
    'PRESSLOGIC ADVERTISERS INDIA PRIVATE LIMITED',
    'ABB GLOBAL BUSINESS SERVICES AND CONTRACTING INDIA PRIVATE LIMITED',
    'VICHAAR NIRMAAN FOUNDATION',
    'DHAAKSHA EVENTS AND PROMOTIONS PRIVATE LIMITED',
    'CHARGED CYCLES PRIVATE LIMITED',
    'EMUNSHI BUSINESS ADVISORS PRIVATE LIMITED',
    'MACE MACRO INDIA (FM SOLUTIONS) PRIVATE LIMITED',
    'PDV TECHNOCRATS PRIVATE LIMITED',
    'SPITFIRE VENTURES (OPC) PRIVATE LIMITED',
    'WOOTZ STRUCTURES PRIVATE LIMITED',
    'QUARK MEDIA TECH PRIVATE LIMITED',
    'HAASTIKA HANDICRAFTS PRIVATE LIMITED',
    'MIRABLE HEALTH SERVICES PRIVATE LIMITED',
    'NORD CARTE PRIVATE LIMITED',
    'ODN DIGITAL SERVICES PRIVATE LIMITED',
    'FAIROLL CONSULTANCY PRIVATE LIMITED',
    'HASHAI LABS PRIVATE LIMITED',
    'BANSAL STEEL MANUFACTURING PRIVATE LIMITED',
    'KY2SC CHANNELS PRIVATE LIMITED',
    'MATRAA CONSULTANTS PRIVATE LIMITED',
    'DENIAR PRODUCTINO PRIVATE LIMITED',
    'SANJYOT CORPORATE SERVICES PRIVATE LIMITED',
    'AMSTAG TECH PRIVATE LIMITED',
    'AHLL DIAGNOSTICS LIMITED',
    'UPTYCS INDIA PRIVATE LIMITED',
    'SKOTECH IT HUB PRIVATE LIMITED',
    'GUNDLAPALLY KRIDA FOUNDATION',
    'ANAXCLOUD PRIVATE LIMITED',
    'ADANI BRAHMA BELVEDERE PRIVATE LIMITED',
    'GREWSYS TECHNOLOGIES PRIVATE LIMITED',
    'BAKER TILLY JFC INFO TECH PRIVATE LIMITED',
    'PROBOTIQ SOLUTIONS PRIVATE LIMITED',
    'SHADOW FOLK FACILITY MANAGERS PRIVATE LIMITED',
    'RENEWATE INFRASTRUCTURE TECHNOLOGIES PRIVATE LIMITED',
    'NEURONE EDEN PRIVATE LIMITED',
    'AAY SOLAR SHEKHPURA PRIVATE LIMITED',
    'PUJA SERVICES INDIA PRIVATE LIMITED',
    'BFA INDIA PRIVATE LIMITED',
    'TEFY PRIVATE LIMITED',
    'SACE EDUCO PRIVATE LIMITED',
    'ABJ EDUVENTURES PRIVATE LIMITED',
    'AAA SHENYANG CONTAINER SEAL PRIVATE LIMITED',
    'ITI ALTERNATE FUNDS MANAGEMENT LIMITED',
    'JKGOLD CHEMICALS PRIVATE LIMITED',
    'EVERLEDGER SYSTEMS PRIVATE LIMITED',
    'TECNONAUTS TECHNOLOGY SERVICES PRIVATE LIMITED',
    'KNIGHTHOOD PRODUCTS & SERVICES PRIVATE LIMITED',
    'HADOOPT TECHNOLOGIES PRIVATE LIMITED',
    'SUVAM FABTEX PRIVATE LIMITED',
    'TYA LIFE PRIVATE LIMITED',
    'LIMPIAR TECHNO ENGINEERS (INDIA) PRIVATELIMITED',
    'NEW LITE SHIPPING PRIVATE LIMITED',
    'HIZEN INTELLIGENCE SYSTEMS PRIVATE LIMITED',
    'SIDDHRUP ACCOUNTAX PRIVATE LIMITED',
    'WIND CHISEL PRIVATE LIMITED',
    'NEWPIOUS SYNERGIES PRIVATE LIMITED',
    'REDDY AUTOMOTIVE PRIVATE LIMITED',
    'AYANA KADAPA RENEWABLE POWER PRIVATE LIMITED',
    'SCHMELZER AGRO INDIA PRIVATE LIMITED',
    'VIBRANCE PROCON PRIVATE LIMITED',
    'IO FACTORY PRIVATE LIMITED',
    'BIOSOL RESEARCH AND INNOVATIONS PRIVATE LIMITED',
    'SAIPANKH TRADEX PRIVATE LIMITED',
    'ABREEZE FOODS PRIVATE LIMITED',
    'NAVEEN ROADWAYS PRIVATE LIMITED',
    'HARIKRIT FILMS PRIVATE LIMITED',
    'INVENTIVE KEY PRIVATE LIMITED',
    'THINKALT STRATEGIES PRIVATE LIMITED',
    'SARVAN GLOBAL SHIPPING PRIVATE LIMITED',
    'ANEKAR INFRA PROJECTS PRIVATE LIMITED',
    'ALSACE LORRAINE INDIA PRIVATE LIMITED',
    'NORDIC KOLEKTIVE PRIVATE LIMITED',
    'TAALIN MACHINERY & ROBOTICS PRIVATE LIMITED',
    'ALKESH INFRATECH PRIVATE LIMITED',
    'ORDNC 2023 000001 U93090PN2018NPL195112 PRIVATE LIMITED',
    'BREWAEGLE BREWING PRIVATE LIMITED',
    'G5K PETRO PRODUCTS PRIVATE LIMITED',
    'MJIC CONSULTANCY PRIVATE LIMITED',
    'INDIC DIGITAL EXPERIENCES LIMITED',
    'INCN CONSTRUCTION DEVELOPMENT PRIVATE LIMITED',
    'CRAFTTANK PRIVATE LIMITED',
    'SHOESTRING COMMUNICATIONS PRIVATE LIMITED',
    'VLSIUVM TECHNOLOGIES (OPC) PRIVATE LIMITED',
    '3I HUMAN CAPITAL SOLUTIONS PRIVATE LIMITED',
    'SAAVIO FOODS PRIVATE LIMITED',
    'LISCO SYSTEMS PRIVATE LIMITED',
    'STHAPANAA SOLUTIONS PRIVATE LIMITED',
    'AEQUS FORCE CONSUMER PRODUCTS PRIVATE LIMITED',
    'KINEER SERVICES PRIVATE LIMITED',
    'ILLUMNUS EDUCATION TECHNOLOGIES PRIVATE LIMITED',
    'NATKAS SOLUTIONS PRIVATE LIMITED',
    'SNAPPLE TECHSERV PRIVATE LIMITED',
    'AA ELECTRO MAGNETIC TEST LABORATORY PRIVATE LIMITED',
    'FOLKSWIRE PRIVATE LIMITED',
    'AGK PROFESSIONAL SERVICES PRIVATE LIMITED',
    'INSTAHOT FOODS PRIVATE LIMITED',
    'SNIBE DIAGNOSTIC (INDIA) PRIVATE LIMITED',
    'MONEED TRADING PRIVATE LIMITED',
    'SACRA SYSTEMS PRIVATE LIMITED',
    'DREAMAKING FOUNDATION',
    'KULAY HOUSING PROJECTS PRIVATE LIMITED',
    'TECH ANCUBATE PRIVATE LIMITED',
    'HPV ELEVATE HVAC ENGINEERS PRIVATE LIMITED',
    'IDENTIC DENTAL LABORATORY PRIVATE LIMITED',
    'UNOTEN EVENTII TECH PRIVATE LIMITED',
    'SIGNITEQ SERVICES PRIVATE LIMITED',
    'ENTPERMASYS GLOBAL CONSULTING AND ADVISORY SERVICES PRIVATE LIMITED',
    'TRIARUP FOUNDATION',
    'PARTHA FENESTRATION INDIA PRIVATE LIMITED',
    'EMINENCE QUALIFICATION CHECK PRIVATE LIMITED',
    'EMPROS VENTURES PRIVATE LIMITED',
    'SALONI HERBAL PRIVATE LIMITED',
    'BOOKMYSHOW LIVE PRIVATE LIMITED',
    'MANVILLE VENTURES PRIVATE LIMITED',
    'PROTEUS ENERGY PRIVATE LIMITED',
    'NAMASTASYE SERVICES PRIVATE LIMITED',
    'DUSK PROPERTIES PRIVATE LIMITED',
    'NEITHAL SOLUTIONS PRIVATE LIMITED',
    'COURSECHAMPS INTERNET VENTURES (OPC) PRIVATE LIMITED',
    'GLASIAL INDIA PRIVATE LIMITED',
    'GUYS SHACK FOODS PRIVATE LIMITED',
    'MARVEL RECRUITMENT & TRAINING SOLUTIONS PRIVATE LIMITED',
    'EGAN SOLAR POWER PRIVATE LIMITED',
    'DIGITALSOFT INNOVATION LAB PRIVATE LIMITED',
    'SHADVIKA FINANCIAL SERVICES PRIVATE LIMITED',
    'MAHESAN CHIT FUND PRIVATE LIMITED',
    'RAYON INK TECHNOLOGIES PRIVATE LIMITED',
    'BANANA INNOLUTIONS PRIVATE LIMITED',
    'SATYARAM SHANTI HOSPITALITY PRIVATE LIMITED',
    'SPAXE HOSPITALITY & WELLNESS PRIVATE LIMITED',
    'TECSO CHARGE ZONE LIMITED',
    'SKYLOTECH INDIA PRIVATE LIMITED',
    'DOOR STEP SCHOOL FOUNDATION',
    'CURADIGM DATALYTICS PRIVATE LIMITED',
    'PIPELINE MANAGEMENT SERVICES PRIVATE LIMITED',
    'TEPSOL SUN ENERGY PRIVATE LIMITED',
    'ETUDIT PRIVATE LIMITED',
    'TACOMA PHARMASOLUTIONS PRIVATE LIMITED',
    'VICTRIX PRODUCTS PRIVATE LIMITED',
    'STREETWALL ADS PRIVATE LIMITED',
    'EDER LABS PRIVATE LIMITED',
    'DOONEXPRESS SUITES PRIVATE LIMITED',
    'INSIGHTUS TECHNOLOGIES PRIVATE LIMITED',
    'CROONIX INTERNATIONAL PRIVATE LIMITED',
    'DOPPELT11 COMMUNICATIONS PRIVATE LIMITED',
    'CIGMA MEDICAL CODING PRIVATE LIMITED',
    'VNC DIGITAL SERVICES PRIVATE LIMITED',
    'EROM WELLCARE PRIVATE LIMITED',
    'IZIA BRANDING PRIVATE LIMITED',
    'TEKSTAR DISTRIBUTION PRIVATE LIMITED',
    'LIKE TREE LIMITED',
    'SHS PROJECTS INDIA PRIVATE LIMITED',
    'FOMALHAUT INFRASTRUCTURE PROJECTS PRIVATE LIMITED',
    'COLLABACE INNOVATIVE LABS PRIVATE LIMITED',
    'JAM INFOSYSTEMS PRIVATE LIMITED',
    'DIGIQAL SOLUTION SERVICES PRIVATE LIMITED',
    'DAYWORTH RETAIL SOLUTIONS INDIA PRIVATE LIMITED',
    'MAXINT SOFTWARE INDIA PRIVATE LIMITED',
    'I.M.S.I STAFFING PRIVATE LIMITED',
    'AISEON HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'AETRAM TRADE MERCHANTS PRIVATE LIMITED',
    'RRD SHELTERS PRIVATE LIMITED',
    'GYANKRITI EDUCATION FOUNDATION',
    'KARE VOYAGE PRIVATE LIMITED',
    'KOTHUR LOGISTICS PARK PRIVATE LIMITED',
    'MADHUCHITT HI-TECH SERVICES PRIVATE LIMITED',
    'WAYBEYOND MEDIA PRIVATE LIMITED',
    'LIRA- LOGISTIC INDEMNITY RISK ASIA PRIVATE LIMITED',
    'VARDAAN RESOURCES PRIVATE LIMITED',
    'EXCEL TELESONIC INDIA PRIVATE LIMITED',
    'CHETTINAD MICRO BUSINESS PRIVATE LIMITED',
    'VAPCON AIR SYSTEMS PRIVATE LIMITED',
    'INDIAN HORIZON MARKETING SERVICES LIMITED',
    'U DIGITAL CONTENT PRIVATE LIMITED',
    'ABRITA SOLUTIONS PRIVATE LIMITED',
    'CONSUMMATE MATERIALS TESTING AND ENGINEERING PRIVATE LIMITED',
    'GREYHOUND ENTERPRISES PRIVATE LIMITED',
    'TRIGYN TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'STANDARD CHARTERED (INDIA) MODELING AND ANALYTICS CENTRE PRIVATE LIMITED',
    'PALANTIR CONSULTING PRIVATE LIMITED',
    'MADURA SOUTH INDIA CORPORATION PRIVATE LIMITED',
    'SHOPRITE MALL PRIVATE LIMITED',
    'UPGRAD EDUCATION PRIVATE LIMITED',
    'BHURUKA GASES INVESTMENTS INDIA PRIVATE LIMITED',
    'MICRON INDUSTRIES PRIVATE LIMITED',
    'ASSOCIATED CEMENT HOLDINGS PRIVATE LIMITED',
    'C S FOUNDATION',
    'BARBER MARINE RESEARCH AND DEVELOPMENT FOUNDATION',
    'GREENTEK SYSTEMS (INDIA) PRIVATE LIMITED',
    'KUNDALINI HOLISTIC HEALING PRIVATE LIMITED',
    'LAHARI PRODUCTIONS PRIVATE LIMITED',
    'M POWER STAFFING SERVICES PRIVATE LIMITED',
    'MAG HARD INSULATIONS AND ENGINEERS PRIVATE LIMITED',
    'WADHAWAN FOOTBALL PRIVATE LIMITED',
    'WADHAWAN SPORTS HOLDINGS PRIVATE LIMITED',
    'AMRUT BAUGH RESORTS PRIVATE LIMITED',
    'D.S.G. SHIP SERVICES PRIVATE LIMITED',
    'IMPERIAL BUILDREAL PRIVATE LIMITED',
    'UNIMONI ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'ACYUTA SERVICES PRIVATE LIMITED',
    'MSA PROBE CONSULTING PRIVATE LIMITED',
    'PERKS LINKS AND SERVICES PRIVATE LIMITED',
    'ETHOS PORT PRIVATE LIMITED',
    'CLOVER ESTATES PRIVATE LIMITED',
    'BRICK EAGLE PROJECTS PRIVATE LIMITED',
    'AVIRAL TEXTILE PRINTERS PRIVATE LIMITED',
    'S CUBE TRANS CONTINENTAL FORWARDING INDIA PRIVATE LIMITED',
    'REACH AJCON TECHNOLOGIES PRIVATE LIMITED',
    'DINDAYAL BIYANI EQUITIES PRIVATE LIMITED',
    'MYWEB MARKETING AND SERVICES PRIVATE LIMITED',
    'MEL TRAINING & ASSESSMENTS LIMITED',
    'SUNPRA ESTATES PRIVATE LIMITED',
    'FERRO ALLOYS CORPORATION LIMITED',
    'WHITE SOLUTIONS PRIVATE LIMITED',
    'SUN ARK SERVICES PRIVATE LIMITED',
    'GREAT SATURN DREDGING PRIVATE LIMITED',
    'PLACEMENT PUNDITS AND RECRUITMENT SERVICES PRIVATE LIMITED',
    'NAHAR INDUSTRIAL ENTERPRISES LIMITED',
    'INDIGRID 1 LIMITED',
    'FORTUNE METALS LIMITED',
    '10 CFO SERVICES (INDIA) PRIVATE LIMITED',
    'SUNDIAL CREATIVE MEDIA PRIVATE LIMITED',
    'CROUCHING TIGER MOTION PICTURES PRIVATE LIMITED',
    'GREEN MARBLE HOUSE PRIVATE LIMITED',
    'GLAZE ENTERPRISES PRIVATE LIMITED',
    'VISHAL EXIM PRIVATE LIMITED',
    'GOLD STAR GEMS PRIVATE LIMITED',
    'BANSAL BUILDCON PRIVATE LIMITED',
    'IK ADVISORY SERVICES PRIVATE LIMITED',
    'ADITYA BIRLA CAPITAL TECHNOLOGY SERVICES LIMITED',
    'EASTMAN EXPORTS PRIVATE LIMITED',
    'SURYA GARMENTS PRIVATE LIMITED',
    'CELIA LEATHER PRIVATE LIMITED',
    'CREDENCE RESOURCE MANAGEMENT PRIVATE LIMITED',
    'PLATINUM PLASTIC AND INDUSTRIES PRIVATE LIMITED',
    'VENUS CHARITABLE FOUNDATION',
    'BRADFORD INDIA FILMS ALLIANCE PRIVATE LIMITED',
    'PLATINUM HOLDINGS PRIVATE LIMITED',
    'SCHWING STETTER (INDIA) PRIVATE LIMITED',
    'MAYA MOVIES PRIVATE LIMITED',
    'ANIMA CREATIVE MANAGEMENT PRIVATE LIMITED',
    'INTERNATIONAL SPECIALTY PRODUCTS (INDIA) PRIVATE LIMITED',
    'AIRLIFT CONTAINER LINES PRIVATE LIMITED',
    'EXPRESS NETWORK PRIVATE LIMITED',
    'AKSHAY MERCANTILE PRIVATE LIMITED',
    'WARTSILA INDIA PRIVATE LIMITED',
    'HI-PURITY CHEMICALS PRIVATE LIMITED',
    'K.C. RICE MILLS PRIVATE LIMITED',
    'PRINZ TRANSFORMERS AND ELECTRIC COMPANY PRIVATE LIMITED',
    'CAPRICORN SYSTEMS GLOBAL SOLUTIONS LIMITED',
    'R.K.INTERIORS PRIVATE LIMITED',
    'FORTUNE CONSTRUCTIONS PRIVATE LIMITED',
    'FRANKE FABER INDIA PRIVATE LIMITED',
    'AMBIKA OVERSEAS PVT LTD',
    'ARUNA PUMPS PRIVATE LIMITED',
    'EOPL VENTURES PRIVATE LIMITED',
    'JUBILANT BIOSYS LIMITED',
    'M.G.CONSTRUCTIONS PRIVATE LIMITED',
    'RAJDARBAR SPACES PRIVATE LIMITED',
    'BHARAT MOTORS LIMITED',
    'BHARAT UDYOG PRIVATE LIMITED',
    'BINANI INDUSTRIES LIMITED',
    'BRANDBOFFO DIGITAL SOLUTIONS (OPC) PRIVATE LIMITED',
    'APLENTY RENEWABLE ENERGY PRIVATE LIMITED',
    'OPTIMISTIC CONCEPTS ENTERTAINMENT PRIVATE LIMITED',
    'AYN INFRASTRUCTURE PRIVATE LIMITED',
    'TORR TRANSFORMATIVE TECHNOLOGIES PRIVATELIMITED',
    'AUTRANS INDIA PRIVATE LIMITED',
    'MANTLE SOLUTIONS PRIVATE LIMITED',
    'NEWGENFAB CLOTHING GARMENTS TRADING PRIVATE LIMITED',
    'RADDREAM PRIVATE LIMITED',
    'CHITRIKA ARTISANS PRODUCER COMPANY LIMITED',
    'RAMCONS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'EUPOREA TECHNOLOGIES PRIVATE LIMITED',
    'LEVVAN ENGINEERING & AUTOMATION PRIVATE LIMITED',
    'UNCO FABS HOSIERY PRIVATE LIMITED',
    'YINLUN ADM INDIA PRIVATE LIMITED',
    'PRANYAS DEVELOPMENT FOUNDATION',
    'SANJAY MANE AVIATION ACADEMY PRIVATE LIMITED',
    'CHIMARA STERIKART SOLUTIONS PRIVATE LIMITED',
    'SPECTRAMATIC SOLUTIONS PRIVATE LIMITED',
    'RB HYGIENE HOME INDIA PRIVATE LIMITED',
    'GRANDBIZ GARMENTS PRIVATE LIMITED',
    'REFLEXALLEN INDIA TUBING PRIVATE LIMITED',
    'BYTEFORCE PRIVATE LIMITED',
    'JASMINE SOLAR POWER PRIVATE LIMITED',
    'COGNIAL ARTIFICIAL INTELLIGENCE SOLUTIONS PRIVATE LIMITED',
    'AMUN RENEWABLES PRIVATE LIMITED',
    'LAN PROPERTY DEVELOPERS PRIVATE LIMITED',
    'PARDOS LUCKNOW DEVELOPERS PRIVATE LIMITED',
    'ARAS ASA REALITY DEVELOPERS PRIVATE LIMITED',
    'ERPL INDUSTRIAL AND LOGISTICS PARK PRIVATE LIMITED',
    'PRATHIMA PHARMACEUTICALS PRIVATE LIMITED',
    'NEWAY SHIPPING PRIVATE LIMITED',
    'SPOTCHECK HEALTH AND WELLNESS SERVICES PRIVATE LIMITED',
    'CKOLON IT CONSULTING PRIVATE LIMITED',
    'IRIDESCENT SKINCARE PRIVATE LIMITED',
    'HCS MEDICALS PRIVATE LIMITED',
    'DEUEX SOLUTIONS PRIVATE LIMITED',
    'SEDAXIS ADVANCED MATERIALS PRIVATE LIMITED',
    'HRNESS DIGITAL AND CONSULTING SOLUTIONS PRIVATE LIMITED (OPC)',
    'SOLARUN SUNATH SERVICES PRIVATE LIMITED',
    'SUMPTUOUS BUSINESS CENTRE PRIVATE LIMITED',
    'LALANI INNOVATIONS PRIVATE LIMITED',
    'LIMONICS DISTRIBUTION PRIVATE LIMITED',
    'GADNACO INDUSTRIES LIMITED',
    'MIOTICS PRIVATE LIMITED',
    'PRODSMITHS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ADANI SOLAR ENERGY JAISALMER TWO PRIVATE LIMITED',
    'SOL COMMUNICATION STRATEGIES PRIVATE LIMITED',
    'AWINR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FLUSSO SOLUTIONS PRIVATE LIMITED',
    'BRHMAGUPTA INTERNATIONAL PRIVATE LIMITED',
    'ADANI WIND ENERGY MP ONE PRIVATE LIMITED',
    'ZIGGLE TECH PRIVATE LIMITED',
    'GPSYPRO TECHNOLOGIES PRIVATE LIMITED',
    'CLIMOTION INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING EIGHTEEN LIMITED',
    'AMPLUS SUNLIGHT PRIVATE LIMITED',
    'GMI IMPLANTOLOGY INDIA PRIVATE LIMITED',
    'MIYY 1MEDKEY ID PRIVATE LIMITED',
    'OCUVENT MEDICAL DEVICES PRIVATE LIMITED',
    'VELOCITAS HEALTH SOLUTIONS PRIVATE LIMITED',
    'CHIKKIBOO TOURS PRIVATE LIMITED',
    'AIC-CVRAMAN COLLEGE OF ENGINEERING FOUNDATION',
    'UNRAVEL SOFTECH PRIVATE LIMITED',
    'BRAHMARI POWERTECH PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWELVE PRIVATE LIMITED',
    'NEBBIA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DUENDE EDUCATION (OPC) PRIVATE LIMITED',
    'NUOZEN TELECOM PRIVATE LIMITED',
    'ARCHPLUS SALES PRIVATE LIMITED',
    'DIOSIV FOODS PRIVATE LIMITED',
    'CLIMINGTON TECHNOLOGY PRIVATE LIMITED',
    'MODERNMONK HEALTHCARE PRIVATE LIMITED',
    'VYOMEEN MEDIA PRIVATE LIMITED',
    'TACTUS ELECTRONICS PRIVATE LIMITED',
    'BEAT BUCK IT MUSIC PRIVATE LIMITED',
    'AFFILOGUE PRIVATE LIMITED',
    'SHANTI SATYAPRAKASH VIKAL SEVA FOUNDATION',
    'ASTRIKOS CONSULTING PRIVATE LIMITED',
    'PIXEMO STUDIOS INDIA PRIVATE LIMITED',
    'MEDRIGS HEALTHCARE DEVICES PRIVATE LIMITED',
    'LAUSDEO TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'LIGIA AVE MARIA SERVICES (OPC) PRIVATE LIMITED',
    'AMPLUS SUNSHINE PRIVATE LIMITED',
    'URVYAM ENGINES PRIVATE LIMITED',
    'MEBIGO LABS PRIVATE LIMITED',
    'ALLAYSECURE SOLUTIONS PRIVATE LIMITED',
    'KMT VOYAGES PRIVATE LIMITED',
    'AROOVIAN AARAA INFRA PRIVATE LIMITED',
    'OMINAYA TECHNOLOGIES PRIVATE LIMITED',
    '3TANDAI INDIA PRIVATE LIMITED',
    'PRITA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'EDUNATION SERVICES PRIVATE LIMITED',
    'OVERDRESSED PRIVATE LIMITED',
    'BHRAMANN EDUCATIONAL SERVICES PRIVATE LIMITED',
    'KORAPALA PRIVATE LIMITED',
    'MEDIAKIND INDIA PRIVATE LIMITED',
    'INCANUS TECHNOLOGIES PRIVATE LIMITED',
    'MEERAKHOR NIMBLE INSTITUTE PRIVATE LIMITED',
    'VAIDIK TECHSAFE SOLUTIONS PRIVATE LIMITED',
    'SACHEM SPECIALTY AND FINE CHEMICALS INDIA PRIVATE LIMITED',
    'NLB TECHNOLOGY SERVICES PRIVATE LIMITED',
    'BLOCKGEMINI INFOTECH PRIVATE LIMITED',
    'RS MARKET ACCELERATORS PRIVATE LIMITED',
    'VEEDOTEN DIGITAL PRIVATE LIMITED',
    'ANGADI WORLD TECHNOLOGIES PRIVATE LIMITED',
    'VERIFAVIA IHM TECHNICAL SERVICES PRIVATELIMITED',
    'DEVDARSHAN HOLIDAYS INDIA PRIVATE LIMITED',
    'ACHARIYA HOPE INDIA MOVEMENT FOR SKILL ACTUALIZATION PRIVATE LIMITED',
    'SPARK FINE ADVISORS PRIVATE LIMITED',
    'SWADHARA TECHNOLOGIES PRIVATE LIMITED',
    'OUSTFIRE SAFETY ENGINEERS PRIVATE LIMITED',
    'STARFAB ENGINEERING SERVICES PRIVATE LIMITED',
    'SPARKREX TECHNOLOGIES PRIVATE LIMITED',
    'FRONTIERNEXT SOLUTIONS PRIVATE LIMITED',
    'SEANEB TECHNOLOGIES PRIVATE LIMITED',
    'KEATERRA CHEMICALS PRIVATE LIMITED',
    'IIDE EDUCATION PRIVATE LIMITED',
    'WATTZ SUSTAINABLE ENERGY SOLUTIONS PRIVATE LIMITED',
    'KLEARNOW INDIA PRIVATE LIMITED',
    'JENBACHER DISTRIBUTED POWER INDIA PRIVATE LIMITED',
    'TECHDOGS MARKETING PRIVATE LIMITED',
    'SHRI TECHTEX PRIVATE LIMITED',
    'AIC - MAHAMANA FOUNDATION FOR INNOVATIONAND ENTREPRENEURSHIP - IM-BHU',
    'TRUEGUARD REALCON PRIVATE LIMITED',
    'WOW HEALTH BOUTIQUE PRIVATE LIMITED',
    'NYBO DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'CLICKEDGE SOLUTIONS PRIVATE LIMITED',
    'REPOSE AGROTECH PRIVATE LIMITED',
    'TARA AUTOHUB PRIVATE LIMITED',
    'CHAQUE JOUR VENTURES PRIVATE LIMITED',
    'SHANE FORENSICTECH PRIVATE LIMITED',
    'GEBURT PLAST PRIVATE LIMITED',
    'TRIDIAGONAL SOFTWARE PRIVATE LIMITED',
    'DANVAN FARMING TECHNOLOGY PRIVATE LIMITED',
    'SATT SRINIWAS FOOD CRAFTS PRIVATE LIMITED',
    'EDONATE ADVISORY PRIVATE LIMITED',
    'FAB PICK SPORTS PRIVATE LIMITED',
    'PAVO & TUSKER INNOVATIONS PRIVATE LIMITED',
    'B&N LOGISTICS PRIVATE LIMITED',
    'SABA CARBONS & CHEMICALS PRIVATE LIMITED',
    '8-M BUSINESS HUB PRIVATE LIMITED',
    'COHERENT ADVISORS PRIVATE LIMITED',
    'CUPER CABLE PRIVATE LIMITED',
    'SAIRAMA REALITIES PRIVATE LIMITED',
    'WINDLASS ENGINEERS & SERVICES PRIVATE LIMITED',
    'TII INDIA PRIVATE LIMITED',
    'BASTAR RAILWAY PRIVATE LIMITED',
    'BEST AGROLIFE LIMITED',
    'DENSO INDIA PRIVATE LIMITED',
    'KANKER ROADWAYS PRIVATE LIMITED',
    'RAINYDAY CYBER SOLUTIONS PRIVATE LIMITED',
    'SPA CAPITAL SERVICES LIMITED',
    'LICHTBLICK HEALTH SOLUTIONS PRIVATE LIMITED',
    'CODALYZE TECHNOLOGIES PRIVATE LIMITED',
    'WELD EXCEL INDIA LIMITED',
    'AARINI AGRO PRIVATE LIMITED',
    'RAMA UDYOG PRIVATE LIMITED',
    'DHAVALA AGRISCIENCE CONSULTANTS PRIVATE LIMITED',
    'SANTOSH RUNGTA GROUP ALUMNI FOUNDATION',
    'GST FINBIZ CONSULTANTS PRIVATE LIMITED',
    'HEALENCE MIND SOLUTIONS (OPC) PRIVATE LIMITED',
    'CAPTAIN PIPES LIMITED',
    'BAN FOOD & HYGIENE PRIVATE LIMITED',
    'MAHAMAYA KISAN PRODUCER COMPANY LIMITED',
    'AQUASPADE PRIVATE LIMITED',
    'PVLBASE SPORTS PRIVATE LIMITED',
    'MGN AGRO PROPERTIES PRIVATE LIMITED',
    'ECS BIZTECH LIMITED',
    'GUJARAT ORGANICS PRIVATE LIMITED',
    'SINTEX PLASTICS TECHNOLOGY LIMITED',
    'IDP EDUCATION EXAM SERVICES PRIVATE LIMITED',
    'TALBROS INTERNATIONAL PRIVATE LIMITED',
    'PURNAMIDAM SERVICES PRIVATE LIMITED',
    'SAAS STAFFING SOLUTIONS PRIVATE LIMITED',
    'SWISS GARNIER HOSPITALS AND ENTERPRISES PRIVATE LIMITED',
    'RAYONIER ENGINEERING SOLUTIONS (OPC) PRIVATE LIMITED',
    'LYTUS BROADBAND PRIVATE LIMITED',
    'SEARCH VEGETABLE PROCESSING (SARAIYAHAT) PRODUCER COMPANY LIMITED',
    'SANTIEB',
    'S ANALYTICS (INDIA) PRIVATE LIMITED',
    'IMMUNOADOPTIVE CELL THERAPY PRIVATE LIMITED',
    'IVORA VENTURES PRIVATE LIMITED',
    'OOTB INNOVATIONS PRIVATE LIMITED',
    'SRILARA LABS PRIVATE LIMITED',
    'MAARZ MECHATRONICS PRIVATE LIMITED',
    'JEWEL LIFESCIENCES PRIVATE LIMITED',
    'LOYASH TRADING AND SERVICES PRIVATE LIMITED',
    'DIGITIAN CONSULTING SERVICES PRIVATE LIMITED',
    'INTENTWISE SERVICES INDIA PRIVATE LIMITED',
    'CATERPILLAR FINANCIAL SERVICES INDIA PRIVATE LIMITED',
    'AFZALPUR KALANJIAM JEEVIDHAM PRODUCER COMPANY LIMITED',
    'NUTRASTARCH FOODS AND AGRO PRIVATE LIMITED',
    'SECUNEUS TECHNOLOGIES PRIVATE LIMITED',
    'TTE ELECTRONICS INDIA PRIVATE LIMITED',
    'UNITIZED ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'JADHAO AUTOMATION & ROBOTICS PRIVATE LIMITED',
    'QUADRANT LIFESCIENCES PRIVATE LIMITED',
    'TMN PARKS PRIVATE LIMITED',
    'DERREN HEALTHCARE PRIVATE LIMITED',
    'CHISELLED INTERIOR WORKS PRIVATE LIMITED',
    'ELECTROMECH INFRASTRUCTURE EQUIPMENT PRIVATE LIMITED',
    'GSV OPHTHALMICS PRIVATE LIMITED',
    'RHOMES PRIVATE LIMITED',
    'VISHWANATH ENERGY PRIVATE LIMITED',
    'SYMBA RENEWABLES PRIVATE LIMITED',
    'MAACRICH FOODS PRIVATE LIMITED',
    'INVESTCORP INDIA ASSET MANAGERS PRIVATE LIMITED',
    'CLOUDELEMENTS TECHNOLOGIES INDIA PRIVATELIMITED',
    'THERAHURI URBAN MULTIPURPOSE NIDHI LIMITED',
    'HILTON HOTELS MANAGEMENT INDIA PRIVATE LIMITED',
    'SANKALP RESTRUCTURING PRIVATE LIMITED',
    'RHI MAGNESITA INDIA REFRACTORIES LIMITED',
    'CLOUDBLOCKS AUTOMATION PRIVATE LIMITED',
    'ACUVON CONSULTING PRIVATE LIMITED',
    'CLAIRVOYANT BIZ CONSULTANCY AND SOLUTIONS PRIVATE LIMITED',
    'ADROITEC RESEARCH & MANUFACTURING LAB PRIVATE LIMITED',
    'ESUNSCOPE SOLAR PRIVATE LIMITED',
    'D9 WELLNESS PRIVATE LIMITED',
    'ETA AEROSPACE PRIVATE LIMITED',
    'YE OCEAN GLOBAL SERVICE PRIVATE LIMITED',
    'LOLO AND BEBO PRIVATE LIMITED',
    'JUNEBERRY HUB PRIVATE LIMITED',
    'ALANKAR CABLES AND CONSULTING ENGINEERS PRIVATE LIMITED',
    'AARNACON SERVICES PRIVATE LIMITED',
    'MAGAN NIDHI LIMITED',
    'EUROAQUA PLUMTEK PRIVATE LIMITED',
    'KUNDKUND FASHION PRIVATE LIMITED',
    'BAEKAN PRODUCTION HOUSE PRIVATE LIMITED',
    'SCINNTC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'SMJ ELECTRICAL PRIVATE LIMITED',
    'TMGI SPORTS PRIVATE LIMITED',
    'MAU ORGANIC EXPORTS PRIVATE LIMITED',
    'RJ PRECISIONS PRIVATE LIMITED',
    'KARBON ENTERPRISES PRIVATE LIMITED',
    'CORPORATE PROFESSIONALS VALUATION SERVICES PRIVATE LIMITED',
    'ACCUMEDIA IT PRIVATE LIMITED',
    'KERING EYEWEAR INDIA PRIVATE LIMITED',
    'INDUSTRUCT CONSTRUCTIONS PRIVATE LIMITED',
    'WELBOW METALS INDIA PRIVATE LIMITED',
    'ROQUE MOTORS PRIVATE LIMITED',
    'PROSPACE INDUSTRIAL PARKS PRIVATE LIMITED',
    'SAI KARISHMA TRAVELS & FOREX PRIVATE LIMITED',
    'MATROP TECHNOLOGY PRIVATE LIMITED',
    'QUORA FOREX PRIVATE LIMITED',
    'VENTUREZILLA PRIVATE LIMITED',
    'UPJ INFOTECH PRIVATE LIMITED',
    'CHASEN (INDIA) HI-TECH LOGISTICS SERVICES PRIVATE LIMITED',
    'VISUBH VENTURES PRIVATE LIMITED',
    'DANEV PESTAID PRIVATE LIMITED',
    'GOSEVIT SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'THINKVIRTUAL ASSISTANCE SERVICES PRIVATELIMITED',
    'BAOBAB OFFICE SPACES PRIVATE LIMITED',
    'BLAZAR CRAFTS (OPC) PRIVATE LIMITED',
    'JVSA EDUCATION AND LEARNING INITIATIVES PRIVATE LIMITED',
    'TUNTURU ENGINEERING AID (OPC) PRIVATE LIMITED',
    'KAARVAN SERVICES PRIVATE LIMITED',
    'AIC-KRIFY FOUNDATION',
    'INTRICATE BUILDING SERVICES DESIGN PRIVATE LIMITED',
    'INTERROPAC PRIVATE LIMITED',
    'MESSAGEBIRD INDIA PRIVATE LIMITED',
    'MONARK EPC INDIA PRIVATE LIMITED',
    'ACCELERATORS WORK OFFICE SOLUTIONS PRIVATE LIMITED',
    'MAHESHSUCHIT IMMIGRATION PRIVATE LIMITED',
    'JYOTIKAR PRECAST PRIVATE LIMITED',
    'ENVIRANT DEVELOPERS PRIVATE LIMITED',
    'CHARTERED HELP PRIVATE LIMITED',
    'SNDT AUTOMATION PRIVATE LIMITED',
    'PACTORA INDIA PRIVATE LIMITED',
    'MYLOD MARKETING AND CONSULTING PRIVATE LIMITED',
    'RADOPT TECHNOLOGIES PRIVATE LIMITED',
    'CLEVERMESH INDUSTRIES PRIVATE LIMITED',
    'NILAM NETHRAM DESIGNERS PRIVATE LIMITED',
    'GRANTHA CONSTRUCTION PRIVATE LIMITED',
    'IJR CONSULTING PRIVATE LIMITED',
    'CYNOSURE BIOTECH PRIVATE LIMITED',
    'LEOPARD LOGISTICS INDIA PRIVATE LIMITED',
    'CARRIL SOLUTIONS PRIVATE LIMITED',
    'ILV LOGISTICS PARKS PRIVATE LIMITED',
    'ADDVALS ADVISORY SERVICES PRIVATE LIMITED',
    'WICKEDEYE ENTERTAINMENT PRIVATE LIMITED',
    'TRIFOLD PRIVATE LIMITED',
    'OMEGA CENTURY INSTITUTE OF ONCOLOGY PRIVATE LIMITED',
    'DEVVRAT YOGA (OPC) PRIVATE LIMITED',
    'MACI RESEARCH PRIVATE LIMITED',
    'AVANTA AGASTYA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CMYOURK COMMUNICATIONS PRIVATE LIMITED',
    'EKANEK NETWORKS PRIVATE LIMITED',
    'GLOWBURST TRAVEL PRIVATE LIMITED',
    'NUCON AMETRA ELECTRONICS SYSTEMS PRIVATELIMITED',
    'ADYOB TECHNOLOGIES PRIVATE LIMITED',
    'INCUVATIONS FOUNDATION',
    'STRINGCELL MFG. PRIVATE LIMITED',
    'XCHANGETECHS INDIA PRIVATE LIMITED',
    'EXATHOUGHT TECHNOLOGY CONSULTING PRIVATELIMITED',
    'GOBBET TECHNOLOGIES PRIVATE LIMITED',
    'RAYMOND CONSUMER CARE LIMITED',
    'PASSENGER DRONE RESEARCH PRIVATE LIMITED',
    'CULTINO AGROTECH PRIVATE LIMITED',
    'NEPLAR COREI PRIVATE LIMITED',
    'BLABBER MEDIA HOUSE PRIVATE LIMITED',
    'WIDESKY E-RETAILS PRIVATE LIMITED',
    'STARMOON CONSULTING SERVICES PRIVATE LIMITED',
    'PRASANNAKSHI HEALTH CARE PRIVATE LIMITED',
    'PREMIERE GETAWAY PRIVATE LIMITED',
    'SKYSCREEN INTERNATIONAL PRIVATE LIMITED',
    'XOVIAN AEROSPACE PRIVATE LIMITED',
    'SAR EDUCATION FOUNDATION',
    'BENCHMATCH TECHNOLOGIES PRIVATE LIMITED',
    'RANKGURU TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'DATANIMBUS TECHNOLOGIES PRIVATE LIMITED',
    'SANTASA FERTILITY PRIVATE LIMITED',
    'ABHAKSHI ENTERPRISES PRIVATE LIMITED',
    'BATON-UBIXI SYSTEMS INDIA PRIVATE LIMITED',
    'FLYBLADE (INDIA) PRIVATE LIMITED',
    'JAKS SRICHAND FOUNDATION',
    'NTM DIGITAL SOLUTION PRIVATE LIMITED',
    'BLISSWATER INDUSTRIES PRIVATE LIMITED',
    'PURENCE INTERNATIONAL PRIVATE LIMITED',
    'MAREN SOLUTIONS PRIVATE LIMITED',
    'FRESCO NZ (INDIA) PRIVATE LIMITED',
    'ARYAAMONEY PRIVATE LIMITED',
    'THETA ENERLYTICS PRIVATE LIMITED',
    'ENDURING HANDCRAFTS PRIVATE LIMITED',
    'PHOMETO PRIVATE LIMITED',
    'NINIS AND NANAS BABYCREATIONS PRIVATE LIMITED',
    'AVI TECHNOFIT PRIVATE LIMITED',
    'TAILWIND FINANCIAL SERVICES PRIVATE LIMITED',
    'DYNAMIZE LEARNING PRIVATE LIMITED',
    'DRYCOTEC GLOBAL PRIVATE LIMITED',
    'ASAHIDENSO MULTILINK PRIVATE LIMITED',
    'IBG ECHITS INDIA PRIVATE LIMITED',
    'FLASHBACK SOUVENIR PRIVATE LIMITED',
    'STALWART LEARNING PRIVATE LIMITED',
    'SKYBERTECH IT INNOVATIONS PRIVATE LIMITED',
    'HEC HOSPITALITY PRIVATE LIMITED',
    'WEDNESDAY SOLAR PRIVATE LIMITED',
    'JRR SAFELOGIC TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'GINGERBREAD TECHNOLOGIES PRIVATE LIMITED',
    'KAI FINCAP LIMITED',
    'NUMERO ICHI PROFESSIONALS PRIVATE LIMITED',
    'GROWSHINE VENTURES PRIVATE LIMITED',
    'STRAVISO INDIA PRIVATE LIMITED',
    'INNOMECH AEROSPACE TOOLINGS PRIVATE LIMITED',
    'SHAGUN CARES INDIA PRIVATE LIMITED',
    'HERITAGE HEALTHCARE PRIVATE LIMITED',
    'PAPPU MARINE PRIVATE LIMITED',
    'DERIVE SYSTEMS PRIVATE LIMITED',
    'CAPPELLA SPORTS PRIVATE LIMITED',
    'PHOENIX TECHNOBUILD PRIVATE LIMITED',
    'FABTECH TECHNOLOGIES PRIVATE LIMITED',
    'METALLOPLAST PRIVATE LIMITED',
    'MOTIONTRONIX SYSTEMS PRIVATE LIMITED',
    'ETAASH TALENT SOLUTIONS PRIVATE LIMITED',
    'CROSSMILES TRAVEL PRIVATE LIMITED',
    'YADNYA ACADEMY PRIVATE LIMITED',
    'AURIRA SOFTWARE LAB PRIVATE LIMITED',
    'JOSKAN INDIA PRIVATE LIMITED',
    'DXFACTOR SOLUTIONS PRIVATE LIMITED',
    'CSE SOLAR SUNPARK MAHARASHTRA PRIVATE LIMITED',
    'INKEL INFRASTRUCTURE DEVELOPMENT PROJECTS LIMITED',
    'FRONTIER AUTOMOTIVES PRIVATE LIMITED',
    'SKYBUFFER SOLUTIONS PRIVATE LIMITED',
    'KICREATION PRIVATE LIMITED',
    'FURCHLES INDIA PRIVATE LIMITED',
    'AMDDAS FOODS PRIVATE LIMITED',
    'YANTRA TECH INNOVATION LAB PRIVATE LIMITED',
    'SKIN SCIENCE LABORATORY PRIVATE LIMITED',
    'NAPCLOUD INDIA PRIVATE LIMITED',
    'EMBASSY INDUSTRIAL PARK HOSUR PRIVATE LIMITED',
    'A1 BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'TETRUSCORP SOLUTIONS INDIA PRIVATE LIMITED',
    'LUTZ BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'MEDICLOCK LIFESCIENCE PRIVATE LIMITED',
    'FUTURESAFE TECHNOLOGIES PRIVATE LIMITED',
    'GEETGANGA PROPERTIES PRIVATE LIMITED',
    'MEHULION TECHNOLOGIES PRIVATE LIMITED',
    'INGENIOUS SAGGI SOLUTIONS PRIVATE LIMITED',
    'CREATIONIST TECHNOVATIONS PRIVATE LIMITED',
    'CREDSQUARE TECHNOLOGIES PRIVATE LIMITED',
    'TALENSETU SKILL TRAINING FOUNDATION',
    'ANKNAN INFOTECH PRIVATE LIMITED',
    'TEALWALLS TECHNOLOGIES PRIVATE LIMITED',
    'IYEMET EVENT PRIVATE LIMITED',
    'BROFIND INDIA TECHNOLOGY ENVIRONMENTAL PRIVATE LIMITED',
    'ACCURA CONCEPTS PRIVATE LIMITED',
    'WARETECH INDIA SOLUTION PRIVATE LIMITED',
    'FEGIO SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'SRI SARVADA NUTRIENTS PRIVATE LIMITED',
    'SEGMENT IT LABS PRIVATE LIMITED',
    'FULCRUM DIGITAL PRIVATE LIMITED',
    'A&N SEARCH EDUCATION PRIVATE LIMITED',
    'VERTICO BPO PRIVATE LIMITED',
    'ANKNAN EXPORT PRIVATE LIMITED',
    'ALMEHTAB POLYMERS PRIVATE LIMITED',
    'THREAD COUNT DESIGNS PRIVATE LIMITED',
    'HANGTE EQUIPMENT MANUFACTURE INDIA PRIVATE LIMITED',
    'UPSKILLIT TRAINING SOLUTIONS PRIVATE LIMITED',
    'SHINSUNG C&T INDIA PRIVATE LIMITED',
    'MILLENNIUM MEDISOLUTIONS PRIVATE LIMITED',
    'APEXEN FOUNDATION OF MEDICAL SCIENCES',
    'SAATHIVA ENTERPRISE PRIVATE LIMITED',
    'NGM TECHNOLOGIES PRIVATE LIMITED',
    '4PEL RELIABLE POWER SERVICES PRIVATE LIMITED',
    'LURNWELL TECHNOLOGIES PRIVATE LIMITED',
    'AUZONE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MILL GEARS PRIVATE LIMITED',
    'PITAD & MALOT GLOBAL EXPANSION PRIVATE LIMITED',
    'TELIKOS SPHERICAL PRIVATE LIMITED',
    'HCI RESIDENTIAL CARE AND WELLNESS CENTRE(INDIA) PRIVATE LIMITED',
    'PROJECT42 LABS PRIVATE LIMITED',
    'NIJIKO SOLUTIONS PRIVATE LIMITED',
    'HINJEWADI BUSINESS PARK PRIVATE LIMITED',
    'EESONA ELIXIRTRIPS INDIA PRIVATE LIMITED',
    'VECTOR FINANCE PRIVATE LIMITED',
    'KEYWEST REALTY PRIVATE LIMITED',
    'HUNYHUNY OVERSEAS PRIVATE LIMITED',
    'AJNA INNOVATIONS PRIVATE LIMITED',
    'INDIECRAFT IMPEX INDIA PRIVATE LIMITED',
    'KWALITY MACHINES & NATURAL GAS EQUIPMENTPRIVATE LIMITED',
    'SOLSTICE HOSPITALITY PRIVATE LIMITED',
    'CBT GLOBAL ROUTES PRIVATE LIMITED',
    'KWENCHRS BEVERAGE PRIVATE LIMITED',
    'ROBRO SYSTEMS PRIVATE LIMITED',
    'SHININGSTAR RESTAURANTS PRIVATE LIMITED',
    'NORM SOFTWARE PRIVATE LIMITED',
    'BEAMINGSTAR RESTAURANTS PRIVATE LIMITED',
    'ACHIEVERS AND LEADERS FORUM',
    'MOVERS INTERNATIONAL FAIRS AND EVENTS PRIVATE LIMITED',
    'KAYNES INTERNATIONAL DESIGN & MANUFACTURING PRIVATE LIMITED',
    'QIKBERRY TECHNOLOGIES PRIVATE LIMITED',
    'TECHFORMATO ENGINEERING PRIVATE LIMITED',
    'ASCOM CALCIUM INDIA PRIVATE LIMITED',
    'SOMAYAJI THOUGHTWORKS BHARAT PRIVATE LIMITED',
    'TRUE NORTH MARINE INDIA PRIVATE LIMITED',
    'PRIORITYAUTO LINCS PRIVATE LIMITED',
    'PARTHA AGRITRADE PRIVATE LIMITED',
    'APHERIO TECH PRIVATE LIMITED',
    'SHAALE PRIVATE LIMITED',
    'CTX IOT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ISRSD INNOVATIONS PRIVATE LIMITED',
    'CHANGFANG SEMICONDUCTOR PRIVATE LIMITED',
    'WEST STAR RETAIL AND TRADING PRIVATE LIMITED',
    'TOSSHEAD EVENTS INDIA PRIVATE LIMITED',
    'THOU GLOBAL MERCANTILE SERVICES PRIVATE LIMITED',
    'FAMULUS ENTERTAINMENT AND MEDIA PRIVATE LIMITED',
    'AVALIYA GLOBAL SERVICES PRIVATE LIMITED',
    'DROWCART TRADE AND INDUSTRIES PRIVATE LIMITED',
    'DANEV HEALTHCARE PRIVATE LIMITED',
    'LAVENDEL CONSULTING PRIVATE LIMITED',
    'TACHION PROMPT TECHNOLOGIES PRIVATE LIMITED',
    'DHRISTI KIRAN BUILDERS AND DEVELOPERS (OPC) PRIVATE LIMITED',
    'EB5 SOLICIS ADVISORY PRIVATE LIMITED',
    'LNNKIN ONLINE PRIVATE LIMITED',
    'ACEPLORER TOURS AND TRAVELS PRIVATE LIMITED',
    'CAPFRONT TECHNOLOGIES PRIVATE LIMITED',
    'DIGITELESCOPE PRIVATE LIMITED',
    'BIRLA TYRES LIMITED',
    'G-RANK DIGITAL SERVICES PRIVATE LIMITED',
    'BONNE BRIQUE INFRAPROJECTS PRIVATE LIMITED',
    'RATNAAFIN CAPITAL PRIVATE LIMITED',
    'DEFIANCE TECHNOLOGIES PRIVATE LIMITED',
    'SHIAAN OLFA PRIVATE LIMITED',
    'PREETHI WIND FARM PRIVATE LIMITED',
    'ATTON TECHNOLOGIES PRIVATE LIMITED',
    'PATAAK IT PRIVATE LIMITED',
    'BRIDGING ISLANDS INFRA PRIVATE LIMITED',
    'OCTANEUP TRANSFORMATION PRIVATE LIMITED',
    'INFINITE FOOD AND BEVERAGES PRIVATE LIMITED',
    'PUSHTIK LOGISTEK PRIVATE LIMITED',
    'AABHA AND DHWANI CREATIVE STUDIOS PRIVATE LIMITED',
    'LOSUNG SOLUTIONS PRIVATE LIMITED',
    'EAST COAST ALUMINIUM LIMITED',
    'GV MANTRA TECHNOLOGIES PRIVATE LIMITED',
    'QOS ENERGY INDIA PRIVATE LIMITED',
    'VAYUCOOLER IMPEX INDIA PRIVATE LIMITED',
    'SIDDHTECH HEALTHCARE SERVICES PRIVATE LIMITED',
    'CHIKOFF MEDIA PRIVATE LIMITED',
    'GENYMED THERAPEUTICS PRIVATE LIMITED',
    'GOKUL POLY VALVES PRIVATE LIMITED',
    'BLV INFINITY PROJECT SOLUTIONS PRIVATE LIMITED',
    'CODE SHASTRA PRIVATE LIMITED',
    'GLOBAL YOUNG ACTION NETWORK FOUNDATION',
    'CAPRICORN ART WORKS PRIVATE LIMITED',
    'DATHA HERBAL MEDICAL CARE PRIVATE LIMITED',
    'CZAR CERAMIC PRIVATE LIMITED',
    'EFFICIENT ENERTECH PRIVATE LIMITED',
    'CIKETI SOLUTIONS PRIVATE LIMITED',
    'COGNITO BREYN PRIVATE LIMITED',
    'DMDS SOLUTIONS PRIVATE LIMITED',
    'SPORTSCOM INDUSTRY CONFEDERATION',
    'SLNKO ENERGY PRIVATE LIMITED',
    'TRANSITRA PROJECTS PRIVATE LIMITED',
    'VENDSY INDIA PRIVATE LIMITED',
    'RIZEE LOGISTICS (OPC) PRIVATE LIMITED',
    'QUANHUA EXIM TRADING PRIVATE LIMITED',
    'GEOJIT TECHLOAN PRIVATE LIMITED',
    'GESPORTS PRIVATE LIMITED',
    'MEGASOURCE SERVICES PRIVATE LIMITED',
    'BLACKVELVET HOSPITALITY PRIVATE LIMITED',
    'PROTECONS SOLUTIONS PRIVATE LIMITED',
    'FOUNDACRES DEVELOPERS PRIVATE LIMITED',
    'AYGATE PROPERTIES PRIVATE LIMITED',
    'TILTLABS CONSULTANCY SERVICES PRIVATE LIMITED',
    'IWIN BORN TO WIN ENTERPRISES PRIVATE LIMITED',
    'OM FORGE AUTO INDUSTRIES PRIVATE LIMITED',
    'SAFDEL SOLUTIONS PRIVATE LIMITED',
    'SAR SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'WASAN E-MOBILITY PRIVATE LIMITED',
    'NAYAN INDIA SCIENCE AND TECHNOLOGIES PRIVATE LIMITED',
    'AAROGITA HEALTH & WELLNESS PRIVATE LIMITED',
    'EVODIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'GYRATORY MANPOWER SERVICES PRIVATE LIMITED',
    'ARUM HOTELS PRIVATE LIMITED',
    'ARYAKI LABS PRIVATE LIMITED',
    'AMSELTRACK TECHNOLOGIES PRIVATE LIMITED',
    'ODBORNE LEARNING (INDIA) PRIVATE LIMITED',
    'ADZIS SOFTWARE PRIVATE LIMITED',
    'NUTRANOVEL ADDITIVES PRIVATE LIMITED',
    'CONCRIA FLOOR SOLUTIONS PRIVATE LIMITED',
    'TWO DOWN BREWING PRIVATE LIMITED',
    'H-TOWN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'HHT PHARMA PRIVATE LIMITED',
    'BESET DISTRIBUTION SERVICES PRIVATE LIMITED',
    'RAYSEARCH INDIA PRIVATE LIMITED',
    'VARSUN AEROSPACE TECHNOLOGIES PRIVATE LIMITED',
    'EASAT RADAR SYSTEMS INDIA PRIVATE LIMITED',
    'HKSK INFRA DEVELOPERS PRIVATE LIMITED',
    'JUEGAS ENTERPRISES PRIVATE LIMITED',
    'HKSK LAND HOLDING PRIVATE LIMITED',
    'MEGMEET ELECTRICAL INDIA PRIVATE LIMITED',
    'JUGAL JAGDISH PROPERTIES PRIVATE LIMITED',
    'MAGSOL TECHNOLOGIES PRIVATE LIMITED',
    'FLIXIR SOLUTIONS PRIVATE LIMITED',
    'CLONE TAX CONSULTING PRIVATE LIMITED',
    'UIS GLOBAL PRIVATE LIMITED',
    'MADDER STAYS PRIVATE LIMITED',
    'VULCAN ADVANCE INTELLIGENCE COMPUTING PRIVATE LIMITED',
    'SEGOO INFRA PRIVATE LIMITED',
    'METLIN PROJECTS PRIVATE LIMITED',
    'SIGMAT CONSULTANCY PRIVATE LIMITED',
    'PAWFECT PET FOODS PRIVATE LIMITED',
    'EDIFICIO INFRASTRUCTURES PRIVATE LIMITED',
    'YUNICA RETAIL PRIVATE LIMITED',
    'DYUTHI AUTOMOBILES PRIVATE LIMITED',
    'KFL & ZAKKANZ ONLINE VENTURES PRIVATE LIMITED',
    'I. & I. FINTECH SOLUTIONS PRIVATE LIMITED',
    'ACN INDUSTRIES PRIVATE LIMITED',
    'UNIQUEFORCE TECHNOLOGY SOLUTIONS PRIVATELIMITED',
    'SDT ULTRASOUND SOLUTIONS INDIA PRIVATE LIMITED',
    'PAHALDESIGN EDUCATION PRIVATE LIMITED',
    'GEOLYTICS IT SERVICES PRIVATE LIMITED',
    'GIRLCODE HUMANITARIAN FOUNDATION',
    'WIZNET INDIA PRIVATE LIMITED',
    'ALONEHANDS PRIVATE LIMITED',
    'AFTERBRICKS CONSULTING PRIVATE LIMITED',
    'TUYDIS TECHNOLOGIES PRIVATE LIMITED',
    'AARGEE PIPELINE SERVICES PRIVATE LIMITED',
    'NIRATHISAYAM INDIA PRIVATE LIMITED',
    'TVASTA ANALYTIX PRIVATE LIMITED',
    'APOSTLESWAY TECHNOLOGIES PRIVATE LIMITED',
    'BERMAD INDIA PRIVATE LIMITED',
    'CUBATIC REALITIES PRIVATE LIMITED',
    'DIGITHOUGHT TECHNOLOGIES PRIVATE LIMITED',
    'AUSTARUNION INDIA PROCESS SYSTEMS PRIVATE LIMITED',
    'SYGMIA SOFTWARE PRIVATE LIMITED',
    'PROACT HEALTHCARE PRIVATE LIMITED',
    'ANAV ADVISORY SERVICES PRIVATE LIMITED',
    'AREION FINCAP PRIVATE LIMITED',
    'DIGITECTURA TECHNOLOGIES PRIVATE LIMITED',
    'DSMATICS TECHNOLOGIES PRIVATE LIMITED',
    'CONECHI CONE EXPERT PRIVATE LIMITED',
    'MK SUCCESS WORLD MARKETING AND RETAILS PRIVATE LIMITED',
    'INDIAQO PROPERTIES PRIVATE LIMITED',
    'ZIYYARA EDUTECH PRIVATE LIMITED',
    'IAST SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ARTIS SHIPPING INDIA PRIVATE LIMITED',
    'TOOR MOTORS LIMITED',
    'VARADHA LEADERSHIP SOLUTIONS PRIVATE LIMITED',
    'MPLRV INFRASTRUCTURE PRIVATE LIMITED',
    'DIGITION LABS PRIVATE LIMITED',
    'ROMACO INDIA PRIVATE LIMITED',
    'SKYSENSE TECH PRIVATE LIMITED',
    'TYZONIC INDIA PRIVATE LIMITED',
    'REGNUM WEALTH PRIVATE LIMITED',
    'ZERO 21 RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED',
    'AIC-GREAT LAKES BALACHANDRAN FOUNDATION',
    'PRAGNABIZTEK PRIVATE LIMITED',
    'WEALTH WORDS TECHNOLOGY INDIA PRIVATE LIMITED',
    'PRIME FUNDS MANAGEMENT LIMITED',
    'BENISON BUILDERS AND CONSTRUCTIONS PRIVATE LIMITED',
    'AIC-IIITH FOUNDATION',
    'JAIIHO LABS PRIVATE LIMITED',
    'ALEKAS SOLUTIONS PRIVATE LIMITED',
    'VISHWA SAMUDRA COASTAL LINES PRIVATE LIMITED',
    'PURPLEWAVE INDIA PRIVATE LIMITED',
    'DEICHMANN INTERNATIONAL BUSINESS SERVICEINDIA PRIVATE LIMITED',
    'DIWO (INDIA) PRIVATE LIMITED',
    'JITAMITRA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MDG INFORMATION SERVICES PRIVATE LIMITED',
    'IGM ENGINEERS AND CONTRACTORS PRIVATE LIMITED',
    'BADRI COTSYN PRIVATE LIMITED',
    'JAGDISH SAOJI PRIVATE LIMITED',
    'DAYLAND AGRI AND FARMING PRIVATE LIMITED',
    'ORIGINAL CHECK SOLUTIONS PRIVATE LIMITED',
    'RAZK INDUSTRIAL AUTOMATION PRIVATE LIMITED',
    'ARRAIGN TECHNOLOGIES PRIVATE LIMITED',
    'RAMPS CONFAB PRIVATE LIMITED',
    'EXPERIA HOMES PRIVATE LIMITED',
    'MCDS GOLBAL SOLUTIONS (I) PRIVATE LIMITED',
    'NEXT57 COWORKING PRIVATE LIMITED',
    'JFDMIL TECHNOLOGIES PRIVATE LIMITED',
    'ARISHNA DIGITAL COMMUNICATION PRIVATE LIMITED',
    'TRAUMKREDIT MARKETING SERVICES INDIA PRIVATE LIMITED',
    'KARL MAYER TEXTILE MACHINERY INDIA PRIVATE LIMITED',
    'ZUDDY HEALTHTECH PRIVATE LIMITED',
    'IMPACTFUL OVERSEAS DREAMS PRIVATE LIMITED',
    'HANSUNG DEVELOPMENT INDIA PRIVATE LIMITED',
    'MOC CANCER CARE FOUNDATION',
    'FLYING DUCHESS INFOTECH PRIVATE LIMITED',
    'UVENTRA SERVICES PRIVATE LIMITED',
    'SYSROOT SOLUTION PRIVATE LIMITED',
    'EASYTYPINGJOBS4U (OPC) PRIVATE LIMITED',
    'FLORAWARE INDIA PRIVATE LIMITED',
    'RABBIT COURIER PRIVATE LIMITED',
    'REKHAS UDYOG PRIVATE LIMITED',
    'BRUDER PLASTECH PRIVATE LIMITED',
    'RAVAGO HOLDING INDIA PRIVATE LIMITED',
    'CHANDRAKANT MANGAL VENTURES PRIVATE LIMITED',
    'R. S. LOGISTICS & WAREHOUSE SERVICES PRIVATE LIMITED',
    'IRAITECH INNOVATIONS & TECHNOLOGIES PRIVATE LIMITED',
    'CUSTO-SHASTRA SERVICES PRIVATE LIMITED',
    'AIMS2HEALTH PRIVATE LIMITED',
    'SYNTEL INDUSTRIES PRIVATE LIMITED',
    'HOME SECURE PESTOBIRD SERVICES PRIVATE LIMITED',
    'PESTRO MANAGEMENT PRIVATE LIMITED',
    'VIZZBEE ROBOTIC SOLUTIONS PRIVATE LIMITED',
    'GOLDSTEINROTH PRIVATE LIMITED',
    'ABL LEARNING SOLUTIONS PRIVATE LIMITED',
    'INDESO RETAIL PRIVATE LIMITED',
    'JANAKIBHARATH SOFTWARE SOLUTIONS PRIVATELIMITED',
    'EQUANIMOUS DESIGNS PRIVATE LIMITED',
    'WARIVO MOTOR INDIA PRIVATE LIMITED',
    'SANNIDHI LASER SOLUTIONS PRIVATE LIMITED',
    'PARAM ENVIROTECH PRIVATE LIMITED',
    'KEFFSOFT SERVICES PRIVATE LIMITED',
    'DIGIMAGNET COMMUNICATION PRIVATE LIMITED',
    'FIBRONA FIBERS PRIVATE LIMITED',
    'MADMAZE STUDIOS PRIVATE LIMITED',
    'INVEX HEALTH PRIVATE LIMITED',
    'MPL GALVA TUBES PRIVATE LIMITED',
    'GOVARDHAN LEARNING CLOUD PRIVATE LIMITED',
    'GREATCOMET PRIVATE LIMITED',
    'AXFONE INDIA PRIVATE LIMITED',
    'CHANAN FABRICATIONS PRIVATE LIMITED',
    'S.M. PHARMACEUTICALS PRIVATE LIMITED',
    'WOO ADVENTURES & EXPEDITIONS PRIVATE LIMITED',
    'SPPPH SOLAR INDIA PROJECTS PRIVATE LIMITED',
    'SSKCON INFRATEL PRIVATE LIMITED',
    'SUN DATA PROCESSING PRIVATE LIMITED',
    'CLEVERTECH PACKAGING AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'CONVENIENT RETAIL PRIVATE LIMITED',
    'CALIPERPSYCHOMETRICS & ANALYTICS INDIA PRIVATE LIMITED',
    'METRY INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'VORRAND CENTAURI CONSULTING PRIVATE LIMITED',
    'MAXPOL PRIVATE LIMITED',
    'RISHABH CARS INDIA PRIVATE LIMITED',
    'PARABOLIC LEADS PRIVATE LIMITED',
    'VR AUTOWORLD PRIVATE LIMITED',
    'ELAAF TECHNOLOGIES PRIVATE LIMITED',
    'PASSIEMECH INDUSTRIES PRIVATE LIMITED',
    'IKJOT ENERGY INTERNATIONAL PRIVATE LIMITED',
    'INTERNATIONAL REAL ESTATE PARTNERS (INDIA) PRIVATE LIMITED',
    'NATUREWINGS HOLIDAYS LIMITED',
    'FINCHARTS INSURANCE CORPORATE AGENCY PRIVATE LIMITED',
    'PROPTECH ADVISORS PRIVATE LIMITED',
    'ECCO SHOES INDIA PRIVATE LIMITED',
    'PRIMEDSERV TECH PRIVATE LIMITED',
    'APEXSEMICONDUCTOR INDIA PRIVATE LIMITED',
    'SAADAA SUSTAINABLE DESIGNS AND TECHNOLOGIES PRIVATE LIMITED',
    'EXODIA PROFESSIONALS PRIVATE LIMITED',
    'YACHE SERVICES PRIVATE LIMITED',
    'DARAZ FACILITY MANAGEMENT PRIVATE LIMITED',
    'SHRIVATSA UDYOG PRIVATE LIMITED',
    'NEETEX KNITTING NEEDLE INDIA PRIVATE LIMITED',
    'POCT SCIENCE HOUSE PRIVATE LIMITED',
    'KUNSHAN Q TECH MICROELECTRONICS (INDIA) PRIVATE LIMITED',
    'TODINI METALS AND CHEMICALS INDIA PRIVATE LIMITED',
    'SILICON ROAD FOUNDATION',
    'FIFTH DHAM PILGRIM FOUNDATION',
    'ATLANTIC CARE CHEMICALS PRIVATE LIMITED',
    'DEFINETEC INDIA PRIVATE LIMITED',
    'UNIPHARMA PRODUCTS PRIVATE LIMITED',
    'SUKSESS CHEMICALS PRIVATE LIMITED',
    'VARROC DELL',
    'S EMINENCE HEALTHCARE & EDUCATION PRIVATE LIMITED',
    'ONEAL MULTITRADE PRIVATE LIMITED',
    'PROVIDENTIA INFO TECH PRIVATE LIMITED',
    'CLICKMART PRIVATE LIMITED',
    'PHARMA MARTS PRIVATE LIMITED',
    'FIL OIL & GAS PRIVATE LIMITED',
    'RWC EVERYDAY PEOPLE SEARCH PRIVATE LIMITED',
    'WATERKART E-COMMERCE PRIVATE LIMITED',
    'COGNATIV INDIA PRIVATE LIMITED',
    'HILLS & WILLS REAL ESTATE PRIVATE LIMITED',
    'INTELLIGIZE IT SOLUTIONS (OPC) PRIVATE LIMITED',
    'RN FAUCETS PRIVATE LIMITED',
    'ASPRCM SOLUTIONS PRIVATE LIMITED',
    'COGNITIVE BIOTECH AND FOOD RESEARCH PRIVATE LIMITED',
    'BAKELITE SYNTHETICS INDIA PRIVATE LIMITED',
    'AUTOFOLK PRIVATE LIMITED',
    'SPACE TECTONIC PRIVATE LIMITED',
    'HASTAG SYSTEMS PRIVATE LIMITED',
    'TLT WRITING SERVICES PRIVATE LIMITED',
    'ARGT SOLUTIONS PRIVATE LIMITED',
    'RODOVIA INDIA PRIVATE LIMITED',
    'SHREE RAM BHAKT HANUMAN JI FOUNDATION',
    'LUMICAT CHEMS PRIVATE LIMITED',
    'ARCELORMITTAL NEEL TT PRIVATE LIMITED',
    'GLOBAL TRIBES TECHNOLAB PRIVATE LIMITED',
    'PROPELET SERVICES PRIVATE LIMITED',
    'SYM HOSPITALITY PRIVATE LIMITED',
    'HIND MERCHANDISE (OPC) PRIVATE LIMITED',
    'SANTRASH PRIVATE LIMITED',
    'MASANI A2 MILK AND MANURE PRIVATE LIMITED',
    'PBO HEALTHCARE PRIVATE LIMITED',
    'SECRET 7 STUDIOS PRIVATE LIMITED',
    'ICONIQ SPIRITS INDIA PRIVATE LIMITED',
    'SAFE TRAVEL TECHNOLOGIES PRIVATE LIMITED',
    'CABIN4J DIGITAL SERVICES (OPC) PRIVATE LIMITED',
    '010 CYBER FORENSICS PRIVATE LIMITED',
    'SABBATECH SOLUTIONS PRIVATE LIMITED',
    'PIXELMATE EXHIBITION ORGANIZING (OPC) PRIVATE LIMITED',
    'SAMARTH MANAGEMENT PRIVATE LIMITED',
    'KRISHAN LAL ENGINEERS & CONTRACTORS PRIVATE LIMITED',
    'C2C ENGINEERING PRIVATE LIMITED',
    'ATCULTS PRIVATE LIMITED',
    'HYENA INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'ABBIE IT MART ADVERTISING PRIVATE LIMITED',
    'XCELSIOR BIZTEK PRIVATE LIMITED',
    'URBAN FOODMART INDIA PRIVATE LIMITED',
    'AXLE LOGISTICS PRIVATE LIMITED',
    'DNYANTANTRA SHIKSHAN PRASARAK MANDAL PRIVATE LIMITED',
    'APS LAW PRIVATE LIMITED',
    'SHREE DHYAN INSURANCE BROKERS PRIVATE LIMITED',
    'SVAM CONCEPTS PRIVATE LIMITED',
    'OLYMPICODE GLOBAL HACKATHON PRIVATE LIMITED',
    'RB COLLECTION CENTRE PRIVATE LIMITED',
    'ACV AGRO FARMS PRIVATE LIMITED',
    'INSTRUCKO INDIA PRIVATE LIMITED',
    'SOURCERIGHT TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'BLACK FLASH SOLUTIONS PRIVATE LIMITED',
    'EMATRIX INFOTECH PRIVATE LIMITED',
    'ZUKLA EXIM CONSULTING PRIVATE LIMITED',
    'XAXS CORPS PRIVATE LIMITED',
    'INFINITIQ TECHNOLOGIES PRIVATE LIMITED',
    'REACH52 PRIVATE LIMITED',
    'PREZENT CONSULTING PRIVATE LIMITED',
    'TALENT TRIBE INFRA PRIVATE LIMITED',
    'WOW INFOBIZ PRIVATE LIMITED',
    'ZOOBIZ INDIA PRIVATE LIMITED',
    'KULDEEP STRUCTURAL CONCEPT DEVELOPERS PRIVATE LIMITED',
    'MAELWINE PHARMACEUTICALS PRIVATE LIMITED',
    'LIBERUM CHEMICALS PRIVATE LIMITED',
    'HOUSE OF BEING TECHNOLOGY PRIVATE LIMITED',
    'AVIOTEK BUSINESS SOLUTIONS PRIVATE LIMITED',
    'INOVA CARE INDIA PRIVATE LIMITED',
    'AFRIYANA INDIA PRIVATE LIMITED',
    'AVISO FUTURE TECH PRIVATE LIMITED',
    'NCOMPASS TECHSTUDIO PRIVATE LIMITED',
    'NR VIGYANBHARAT PRIVATE LIMITED',
    'KALPANA ACADEMY FOR EDUCATION AND SKILLS DEVELOPMENT PRIVATE LIMITED',
    'IBC PLATFORM PRIVATE LIMITED',
    'NAISHA EXPORTS PRIVATE LIMITED',
    'CINCH ENTERPRISES PRIVATE LIMITED',
    'VITYL INDUSTRIES PRIVATE LIMITED',
    'NHASSURANCE HEALTHCARE SERVICES PRIVATE LIMITED',
    'TAURUSOPEDIA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VERSATILE ENGISAFE PRIVATE LIMITED',
    'THEISM INFRATECH PRIVATE LIMITED',
    'PAESAGGIO CONSULTING SERVICES PRIVATE LIMITED',
    'ER - MECCANICA VENETA PRIVATE LIMITED',
    'INPAC TRAVELS (INDIA) PRIVATE LIMITED',
    'ORIENTAL INTERNATIONAL COMPANY PRIVATE LIMITED',
    'AMAN HOSPITALITY PRIVATE LIMITED',
    'STRATFORD TRADE SALES PRIVATE LIMITED',
    'ALLIED FINCAP SERVICES PRIVATE LIMITED',
    'RAJSHEELA HOUSING PRIVATE LIMITED',
    'AITHENT TECHNOLOGIES PRIVATE LIMITED',
    'GRANADA SERVICES PRIVATE LIMITED',
    'BRAHMAPUTRA ENTERPRISES PRIVATE LIMITED',
    'GENESIS OVERSEAS PRIVATE LIMITED',
    'MARKET MOVERS EXPORTS INDIA PRIVATE LIMITED',
    'PIGEON FARMS PRIVATE LIMITED',
    'SENATOR DEVELOPERS PRIVATE LIMITED',
    'GREENLINE DEVELOPERS PRIVATE LIMITED',
    'PULP STRATEGY TECHNOLOGIES PRIVATE LIMITED',
    'BIG BALLS AND STIFF SHAFTS GOLF CLUB PRIVATE LIMITED',
    'AKA CONSTRUCTION PRIVATE LIMITED',
    'STELLAR GASTRONOM PRIVATE LIMITED',
    'SWARSUDHA CASSETTES INDUSTRIES PRIVATE LIMITED',
    'PETROMAN MARKETING DELHI PRIVATE LIMITED',
    'ULTRAFRESH MODULAR SOLUTIONS LIMITED',
    'VISIONAIRE GLOBAL ENGINEERING PRIVATE LIMITED',
    'Three Levers Advisors Private Limited',
    'PropBirbal Realcom Private Limited',
    'GHAZIABAD PRINTING AND PACKING INDUSTRIES PRIVATE LIMITED',
    'SERVETEL COMMUNICATIONS PRIVATE LIMITED',
    'BRIGHT NUTRICARE PRIVATE LIMITED',
    'CIDEAS INVESTMENTS (INDIA) PRIVATE LIMITED',
    'M R GUPTA AND COMPANY PRIVATE LIMITED',
    'PINNACLE REWARDS & RECOGNITION PRIVATE LIMITED',
    'NEWGEN COMPUTERS TECHNOLOGIES LIMITED',
    'MEMBRANE TYRES PRIVATE LIMITED',
    'AVISHKAR TOURS PRIVATE LIMITED',
    'M L INFOMAP PRIVATE LIMITED',
    'STARGATE EXPERIENCES PRIVATE LIMITED',
    'ORANGE CORPORATE SERVICES PRIVATE LIMITED',
    'FFEVER CONSULTING PRIVATE LIMITED',
    'Fermentras India Private Limited',
    'CHRONICLE PUBLICATIONS PRIVATE LIMITED',
    'HONTRU WOMENES WELLNESS PRIVATE LIMITED',
    'INVENTIZ ENTERPRISES PRIVATE LIMITED',
    'KARTHIK INFORMATICS PRIVATE LIMITED',
    'TEXAS REVIEW INDIA PRIVATE LIMITED',
    'KANAXIS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'GUNTUR INSTITUTE OF ONCOLOGY PRIVATE LIMITED',
    'HARAGOVIND ENTERPRISES PRIVATE LIMITED',
    'E-Prospects Media India Private Limited',
    'V-Dream Technology & Communication Private Limited',
    'SATRA AGRI TECH PRIVATE LIMITED',
    'Greenway Bio Products Private Limited',
    'BATHINI GREENLANDS & INFRA PROJECTS PRIVATE LIMITED',
    'ZEBI DATA INDIA PRIVATE LIMITED',
    'ACCURACY INFO LABS PRIVATE LIMITED',
    'Zinovate Technologies Private Limited',
    'Brango Foods India Private Limited',
    'ANURADHA CHEMICALS PRIVATE LIMITED',
    'iVIS INTERNATIONAL PRIVATE LIMITED',
    'BETH WIND PARKS PRIVATE LIMITED',
    'MORI WIND PARKS PRIVATE LIMITED',
    'BORA WIND PARKS PRIVATE LIMITED',
    'BREEZE WIND PARKS PRIVATE LIMITED',
    'INFER RADIOLOGICAL AND IMAGING SERVICES PRIVATE LIMITED',
    'ANDHRA PRADESH STATE SKILL DEVELOPMENT CORPORATION',
    'Amaravati Hospitals and Healthcare Private Limited',
    'SRI KAUSTUBHA COMMERCIALS PRIVATE LIMITED',
    'HERTZ WIND PARKS PRIVATE LIMITED',
    'Nprodax Technologies Private Limited',
    'SEASHELL INDUSTRIES PRIVATE LIMITED',
    'Sphota Business Solutions Private Limited',
    'GREENKO ENERGY MANAGMENT SERVICES PRIVATE LIMITED',
    'SRI MURARI REFRACTORIES PRIVATE LIMITED',
    'HMR LOGISTICS PRIVATE LIMITED',
    'NAGABOT SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'PI DATA CENTERS PRIVATE LIMITED',
    'BitApps (India) Private Limited',
    'HSK IT SOLUTIONS INDIA PRIVATE LIMITED',
    'R.R.TECHPATH INDIA PRIVATE LIMITED',
    'AVANTI FROZEN FOODS PRIVATE LIMITED',
    'COMPUTEK IT SOLUTIONS (INDIA) PRIVATE LIMITED',
    'AIZANT PHARMACEUTICALS PRIVATE LIMITED',
    'SRISAICHANDANA API PRIVATE LIMITED',
    'KEKULE PHARMACEUTICALS (A.P) LIMITED',
    'TYSIM PETROCHEMS PRIVATE LIMITED',
    'KURRAL MINES MINERALS AND RESOURCES PRIVATE LIMITED',
    'AURORA E-LABS PRIVATE LIMITED',
    'JI TECHNOVATION PRIVATE LIMITED',
    'GANCO ENERGY (INDIA) PRIVATE LIMITED',
    'AADHYA ANALYTICS AND INFO LOGICS PRIVATE LIMITED',
    'CENTOTECH SERVICES PRIVATE LIMITED',
    'DISRUPTIVE SOFTWARE PRIVATE LIMITED',
    'AVEROSOFT PRIVATE LIMITED',
    'RIVER BAY AGRO PRIVATE LIMITED',
    'POWERSQUARE INFRA PROJECTS AND CONSULTANTS PRIVATE LIMITED',
    'POWERSQUARE ENTERPRISE SOLUTIONS AND STRATEGIES PRIVATE LIMITED',
    'POWERSQUARE INTEGRATIONS AND CONTROLS PRIVATE LIMITED',
    'SRI KAUSTUBHA HOLDINGS PRIVATE LIMITED',
    'MI2 SOFT PRIVATE LIMITED',
    'SRI KAUSTUBHA HEALTHCARE PRIVATE LIMITED',
    'MAXIMUS ARC LIMITED',
    'KURNOOL INSTITUTE OF ONCOLOGY PRIVATE LIMITED',
    'ACE URBAN DEVELOPERS PRIVATE LIMITED',
    'Lemon Sales & Distribution Private Limited',
    'BABA AEROSPACE AND TECHNOLOGIES PRIVATE LIMITED',
    'SRESHTA ENVIROTECH PRIVATE LIMITED',
    'Jobance Careers Private Limited',
    'GAYATHRI AQUA SEA FOOD EXPORTS PRIVATE LIMITED',
    'CAMPHOR SHOES (INDIA) PRIVATE LIMITED',
    'KENISYS SOFTWARE PRIVATE LIMITED',
    'FUSION SOLAR TECHNOLOGIES PRIVATE LIMITED',
    'GCON GREEN FIELDS PRIVATE LIMITED',
    'Apxor Technology Solutions Private Limited',
    'SPICE ESTATES PRIVATE LIMITED',
    'Team work Glass solutions Private Limited',
    'SREE SAI RATNAKAMALAMBIKA DEVELOPERS PRIVATE LIMITED',
    'C AND N INFRATECH INDIA PRIVATE LIMITED',
    'Kothavalsa Infraventures Private Limited',
    'GIBOR INFRASTRUCTURES PRIVATE LIMITED',
    'MYLAS INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'AIKALPA PRIVATE LIMITED',
    'BEYNON PHARMA PRIVATE LIMITED',
    'Fulcrum Global Technologies Private Limited',
    'NUEVE IT SOLUTIONS PRIVATE LIMITED',
    'EPACE TECHNOLOGIES PRIVATE LIMITED',
    'TVR PROJECTS PRIVATE LIMITED',
    'BULKHOUSE TRADING INDIA PRIVATE LIMITED',
    'GCON RISE (INDIA) PRIVATE LIMITED',
    'VANDANA MALL AND SCREENS PRIVATE LIMITED',
    'BLUE AVIS AVIATION (INDIA) PRIVATE LIMITED',
    'ALACRITY RECRUITMENT SERVICES PRIVATE LIMITED',
    'COLABS PHARMA PRIVATE LIMITED',
    'KAKINADA CONTAINER TERMINAL PRIVATE LIMITED',
    'SHIRDI SAI SHIPPING PRIVATE LIMITED',
    'EMARAA SOLUTIONS PRIVATE LIMITED',
    'ANJANI TILES LIMITED',
    'FOCUSSIGN SOLUTIONS PRIVATE LIMITED',
    'THIRDEYE SECURITY SERVICES PVT.LTD.',
    'B. BONCHEE OVERSEAS PRIVATE LIMITED',
    'CFACT Consulting Services Private Limited',
    'SUKH SAGAR MOTORS PRIVATE LIMITED',
    'RED WOOD PACKAGING PRIVATE LIMITED',
    'DRISHYAM REALTY PRIVATE LIMITED',
    'GMI CITY PRIVATE LIMITED',
    'GMI REAL ESTATE PRIVATE LIMITED',
    'METALICA FURNITURE PRIVATE LIMITED',
    'SAFESPACE LOGISTIC PRIVATE LIMITED',
    'FTI FOOD TECH PRIVATE LIMITED',
    'Bhavya Infra & Systems Private Limited',
    'RAGHUNANDAN CAPITAL PRIVATE LIMITED',
    'AVTEC LIMITED',
    'JAIN TRANSMISSION (I) PRIVATE LIMITED',
    'BARWAHA INFRASTRUCTURE PRIVATE LIMITED',
    'M.P.ENTERTAINMENT AND DEVELOPERS PRIVATE LIMITED',
    'SUYOG TRAINING INSTITUTE PRIVATE LIMITED',
    'MECHMEN CONSTRUCTIVE SOLUTIONS PRIVATE LIMITED',
    'CDN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'B.K. AGRAWAL MERCHANTS PRIVATE LIMITED',
    'KANIKA DIGITAL PRINTS PRIVATE LIMITED',
    'GEET DWELLERS PRIVATE LIMITED',
    'AGECO INDIA PRIVATE LIMITED',
    'MADHYA PRADESH POWER TRANSMISSION COMPANY LIMITED',
    'MADHYA PRADESH POWER GENERATING COMPANY LIMITED',
    'SYSTEMS LIFECYCLE PRIVATE LIMITED',
    'SYNERGY WEB-TECH PRIVATE LIMITED',
    'GURJAR CHEMICALS PRIVATE LIMITED',
    'Kanahaiyalal Buildcon Private Limited',
    'U.V. RESINS PRIVATE LIMITED',
    'GORAJ AUTO MATION PRIVATE LIMITED',
    'INDORE REAL ESTATE DEVELOPERRS PRIVATE LIMITED',
    'SHIVA INFRA-TECH PRIVATE LIMITED',
    'SANSKAR HOSPITAL AND RESEARCH CENTRE PVT.LTD.',
    'MEDPAK INDIA LIMITED',
    'SCF SERVICES Private Limited',
    'SMART CONTROLS INDIA LIMITED',
    'SOFMEN TECHNOLOGIES PRIVATE LIMITED',
    'V.M.G. REAL ESTATE PRIVATE LIMITED',
    'BHAGAWATI DEVELOPMENT SERVICES PRIVATE LIMITED',
    'RPJ MINERALS PRIVATE LIMITED',
    'COMPUTER GALLERY PRIVATE LIMITED',
    'SWAPNIL CONSTRUCTIONS PRIVATE LIMITED',
    'FEEL-INDIA TOURS AND TRAVELS PRIVATE LIMITED',
    'S.M.GARAGES PRIVATE LIMITED',
    'ARIHANT DETERGENTS PRIVATE LIMITED',
    'SCIENTECH TECHNOLOGIES PRIVATE LIMITED',
    'SAGAR CEMENTS (M) PRIVATE LIMITED',
    'VELTRONICS INDIA PRIVATE LIMITED',
    'ELBIZ SYSTEMS PRIVATE LIMITED',
    'R.F.NETWORK PRIVATE LIMITED',
    'FSC ENGINEERS PRIVATE LIMITED',
    'MID-INDIA INFRASTRUCTURE PRIVATE LIMITED',
    'INDIRA ASSETS AND REALTY PRIVATE LIMITED',
    'MIDEX GLOBAL PRIVATE LIMITED',
    'KAVITA REALITIES PRIVATE LIMITED',
    'DCNPL PRIVATE LIMITED',
    'Gamut Electronics Private Limited',
    'AIS DISTRIBUTION SERVICES LIMITED',
    'JAINAM ALTERNATE ENERGY PRIVATE LIMITED',
    'NEW VISION SOFTCOM AND CONSULTANCY PRIVATE LIMITED',
    'S FOOD CRAFTS PRIVATE LIMITED',
    'ANISA CARPETS LIMITED',
    'LAMBODAR COMMODITIES PVT. LTD.',
    'HERITAGE DEALERS PVT LTD',
    'ROXY SUPPLIERS PVT LTD',
    'XL FASHIONS Private Limited',
    'DATT MEDIPRODUCTS Private Limited',
    'WACOM INDIA PRIVATE LIMITED',
    'P.J. RESINS AND PLASTICIZERS PRIVATE LIMITED',
    'NARULA TRAVEL & TOURS PRIVATE LIMITED',
    'SACHIN WIRES LTD',
    'NAHARGARH HAVELIS & RESORTS PRIVATE LIMITED',
    'NBCC (INDIA) LIMITED',
    'NATIONAL CREDIT GUARANTEE TRUSTEE COMPANY LIMITED',
    'National Highways & Infrastructure Development Corporation Limited',
    'NAHID FINLEASE PRIVATE LIMITED',
    'N K OVERSEAS TRADERS PRIVATE LIMITED',
    'NATRAJ PRODUCTS PRIVATE LIMITED',
    'NATURAL AROMATICS PRIVATE LIMITED',
    'DEVA SINGH SHAM SINGH EXPORTS PRIVATE LIMITED',
    'N K RETAILS PRIVATE LIMITED',
    'N. N. INTRATRADE SERVICES PRIVATE LIMITED',
    'N.E.C.C. FINANCIAL SERVICES PRIVATE LIMITED',
    'NAV JEEWAN PHARMACY PRIVATE LIMITED',
    'N.R. FURNISHINGS PRIVATE LIMITED',
    'N.S EXPORTS PRIVATE LIMITED',
    'NAGDEVI TRADING AND INVESTMENT COMPANY LIMITED',
    'NAROSA BOOK DISTRIBUTORS PRIVATE LTD',
    'MANOHAR DYEING AND PRINTING WORKS PVT LTD',
    'PEGASOS SOFTWARE CONSULTANTS PRIVATE LIMITED',
    'PRABHU STRUCTURES PRIVATE LIMITED',
    'GRAN CRU CLUB PRIVATE LIMITED',
    'NAVIGATORS VISA GLOBAL LOGISTICS LIMITED',
    'NAVODYA EXIM PRIVATE LIMITED',
    'NAMO REALTECH PRIVATE LIMITED',
    'NANDA DEVI BUILDERS PRIVATE LIMITED',
    'NAYA BAZAAR NOVELTIES PRIVATE LIMITED',
    'NANDA INDUSTRIAL CONSULTANTS PRIVATE LIMITED',
    'NAP TECHNOLOGIES PRIVATE LIMITED',
    'NARAYAN CAPITAL SERVICES PRIVATE LIMITED',
    'NARAYAN COMMODITY BROKERS PRIVATE LIMITED',
    'NBTC MERCANTILE PRIVATE LIMITED',
    'NCUBE PLANNING AND DESIGN PRIVATE LIMITED',
    'ND CALLUS INFO SERVICES PRIVATE LIMITED',
    'NARAYAN SECURITIES LIMITED',
    'NARENDRA PRESS-TECH PRIVATE LIMITED',
    'NARMADA CAPITAL SERVICES PRIVATE LIMITED',
    'NARMADA WIND ENERGY PRIVATE LIMITED',
    'NE TELEVISION NETWORK PRIVATE LIMITED',
    'NAVENDU INVESTMENT COMPANY PRIVATE LIMITED',
    'NARSINGH DASS AND COMPANY PRIVATE LIMITED',
    'NARULA CORPORATE RELOCATION SERVICES PRIVATE LIMITED',
    '3DINNOVATIONS PRIVATE LIMITED',
    'NEELGAGAN REALCON PRIVATE LIMITED',
    'NATH EXPORT PROCESSING LIMITED',
    'NEEMRANA DEVELOPERS PRIVATE LIMITED.',
    'NEEMRANA ENTERTAINMENT PRIVATE LIMITED',
    'NEEMRANA HOTELS PRIVATE LIMITED',
    'NEEV EDUCATION PRIVATE LIMITED',
    'NEHA FINLEASE LIMITED',
    'NENU HOLDINGS LIMITED',
    'NATIONWIDE PROMOTERS PRIVATE LIMITED',
    'NEO HOLIDAYS PRIVATE LIMITED',
    'NATRAJ HOME FURNISHINGS PRIVATE LIMITED',
    'NATURE LIGHT SOLAR POWER PRIVATE LIMITED',
    'NEPTUNE TRAVCO PRIVATE LIMITED',
    'NATURE PURE BIO PRODUCTS PRIVATE LIMITED',
    'NAV BHARAT VANIJYA LIMITED',
    'NAV RECORDS PRIVATE LIMITED',
    'NAVAERA SOFTWARE SERVICES PRIVATE LIMITED',
    'NAVAIR NORSK EXPORTS PRIVATE LIMITED',
    'Nestle R&D Centre India Private Limited',
    'PANDE DESIGNS PVT LTD',
    'NEEL IMPEX LIMITED',
    'Net-Asia Technologies Private Limited',
    'NETCARROTS COM PRIVATE LIMITED',
    'NETCORP DIGITAL MEDIA PRIVATE LIMITED',
    'Neeleshwar Mines & Minerals (India) Private Limited',
    'NEELGAGAN BUILDCON PRIVATE LIMITED',
    'NEELKANTH ALLOYS PRIVATE LIMITED',
    'NEO DEVELOPERS PRIVATE LIMITED',
    'NEPHRINE RENAL CARE PRIVATE LIMITED',
    'NEPTUNE PROMOTERS PRIVATE LIMITED',
    'NETEDGE TECHNOLOGY PRIVATE LIMITED',
    'NetGains India Internet Private Limited',
    'NAVRANG EXIM LIMITED',
    'NETRIKA CONSULTING INDIA PRIVATE LIMITED',
    'NETWORK AIRLINE SERVICES PRIVATE LIMITED',
    'NAVRO EXPORTS PRIVATE LIMITED',
    'NETWORK REALTY PRIVATE LIMITED',
    'NETWORKXS DOT COM PRIVATE LIMITED',
    'NB TECHNOLOGIES PRIVATE LIMITED',
    'NBG PRINTO GRAOHIC PRIVATE LIMITED',
    'NBG PRINTO GRAPHIC MACHINERY COMPANY PVT LTD',
    'NBM MEDIA PRIVATE LIMITED',
    'ND HEROES FOOTBALL PRIVATE LIMITED',
    'NDA COMMODITY BROKERS PRIVATE LIMITED',
    'NDA RESEARCH AND TECHNOLOGIES PRIVATE LIMITED',
    'Nerissa Constructions Limited',
    'NDEH EXPORT HOUSE PRIVATE LIMITED',
    'NEW GENERATION NETWORKS LIMITED',
    'NEW INDIA COLOUR COMPANY LIMITED',
    'NEW INDIA DETERGENTS PRIVATE LIMITED',
    'NEW INDIA MOTORS NEW DELHI PRIVATE LIMITED',
    'NEEDLE EYE PLASTIC INDUSTRIES PRIVATE LTD.',
    'KAPLIN PLASTICS PVT LTD',
    'NEW LOOK ESTATES PRIVATE LIMITED',
    'NEW TRACK DRESSES PRIVATE LIMITED.',
    'NEW UNITED WORKSHOP PRIVATE LIMITED',
    'NEW VARIETY DECORATORS PRIVATE LIMITED',
    'NEWAGE CAPITAL SERVICES PRIVATE LIMITED',
    'NEWAGE ENTERPRISES PRIVATE LIMITED',
    'SANGLI TRADERS ASSOCIATION LIMITED',
    'NEWBY INDIA PRIVATE LIMITED',
    'PRADOT INFO SOLUTIONS PRIVATE LIMITED',
    'NEWLY WEDS FOODS INDIA PRIVATE LIMITED',
    'NEWMAN INDIA PRIVATE LIMITED',
    'NEWQUEST INSURANCE BROKING SERVICES LIMITED',
    'PISTA EXHIBITIONS PRIVATE LIMITED',
    'AAR-CHEM-TECH (INDIA) PRIVATE LIMITED',
    'AASTHA EXPORTS PRIVATE LIMITED',
    'AAV MINERAL AND CHEMICALS INDUSTRIES PRIVATE LIMITED',
    'AAY AAR CONSULTANCY SERVICES PRIVATE LIMITED',
    'PREMIA VILLAS PRIVATE LIMITED',
    'PREMIA WATERS PRIVATE LIMITED',
    'Vinci Energies India Private Limited',
    'PREMIER ROCK PRODUCTS PRIVATE LIMITED',
    'PREM NATH ANAND BUILD CON PRIVATE LIMITED',
    'PREM POWER CONSTRUCTION PRIVATE LIMITED',
    'PREMIA BUILDERS PRIVATE LIMITED',
    'PREMIA DEVELOPERS PRIVATE LIMITED',
    'PRESTIGE REAL ESTATE BUILDERS PRIVATE LIMITED',
    'PRESTIGE SAI HOUSING PRIVATE LIMITED',
    'PRESTIGE WINES & SPIRITS PRIVATE LIMITED',
    'PREXMA CONSULTING PRIVATE LIMITED',
    'PRIDE TOWEL MANUFACTURERS PRIVATE LIMITED',
    'PREMIA DISTILLERIES PRIVATE LIMITED',
    'PREMIA ENERGY PRIVATE LIMITED',
    'PREMIA ENTER-TAINMENT PRIVATE LIMITED',
    'SUNSTAR CUSTOMER CONNECT LIMITED',
    'PREMIA FACILITY MANAGEMENT PRIVATE LIMITED',
    'PREMIA FARM HOUSES PRIVATE LIMITED',
    'KEESARI INDUSTRIE LIMITED',
    'PRIME GOLD INTERNATIONAL LIMITED',
    'PRIME HARNESS SYSTEMS PRIVATE LIMITED',
    'PRIME RIGS LIMITED',
    'PRIME INFRA-BUILD PRIVATE LIMITED',
    'PRIME INFRATECH PRIVATE LIMITED',
    'PRIME INTERGLOBE PRIVATE LIMITED',
    'PREMIA FASHION WEEK PRIVATE LIMITED',
    'PREMIA HEALTH PRIVATE LIMITED',
    'PREMIA HILL VIEW PRIVATE LIMITED',
    'PREMIA LIFESTYLE PRIVATE LIMITED',
    'PREMIA PROJECTS AND DEVELOPERS PRIVATE LIMITED',
    'PREMIA QUALITY FOODS PRIVATE LIMITED',
    'PREMIA RESIDENCE DE ARISTOCRAT PRIVATE LIMITED',
    'PREMIUM ESTATES PRIVATE LIMITED',
    'PRESCIS CONSULTING PRIVATE LIMITED',
    'PRESTIGE HITECH CITY PRIVATE LIMITED',
    'PRESTIGE HI-TECH DEVELOPERS PRIVATE LIMITED',
    'PRIMA HOSPITALITY PRIVATE LIMITED',
    'PRIYA STYLES PRIVATE LIMITED',
    'PRIYADARSHANY AGRI FARMS PRIVATE LIMITED',
    'PRJ FAMILY MANAGEMENT COMPANY PRIVATE LIMITED',
    'PRIMA TECHNOLOGIES PRIVATE LIMITED',
    'PRIMATEL FIBCOM LIMITED',
    'PCL HOTELS LIMITED',
    'PROBUS INSURANCE BROKER PRIVATE LIMITED',
    'PROCON INDIA PRIVATE LIMITED',
    'DIVYAMRITVA HERBAL ORGANICS PRIVATE LIMITED',
    'PROFESSIONAL FACILITY AND PROTECTION PRIVATE LIMITED',
    'PROGRESSION INFONET PRIVATE LIMITED',
    'PROGRESSIVE BUILDWELL PRIVATE LIMITED',
    'PREMIA RESORTS PRIVATE LIMITED',
    'PROLIFIC PAPERS PRIVATE LIMITED',
    'Prologix Private Limited',
    'ABC MERCHANDISING PRIVATE LIMITED',
    'PREMIA RETAIL PRIVATE LIMITED',
    'PREMIA HOSPITALITY PRIVATE LIMITED',
    'PREMIA HOSPITALS PRIVATE LIMITED',
    'ABHAAS CONSTRUCTION PRIVATE LIMITED',
    'PREMIA STRUCTURES LIMITED',
    'PREMIA INFOMEDIA PRIVATE LIMITED',
    'PREMIA LAKE CITY PRIVATE LIMITED',
    'PREMIER INFORMATION TECHNOLOGY PARKS PVT LTD',
    'PRIMETIME ENTERTAINMENT & MEDIA PRIVATE LIMITED',
    'PRINGLE HOMEWARE PRIVATE LIMITED',
    'Prints Publications Private Limited',
    'PRISTINE INFRACON PRIVATE LIMITED',
    'PRITHU NEXGEN PRIVATE LIMITED',
    'PRITIKA AUTO PRODUCTS PRIVATE LIMITED',
    'Prive Luxury Limited',
    'ABL Softmines Technologies Private Limited',
    'ABLOOM ESTATES PRIVATE LIMITED',
    'ABM INTERNATIONAL LIMITED',
    'Privue Builders Private Limited',
    'PRO PLUS MANAGEMENT SERVICES PRIVATE LIMITED',
    'ABS QUALITY EVALUATIONS PRIVATE LIMITED.',
    'MBC LEGAL ADVISORS PRIVATE LIMITED',
    'ABU SECURITIES PRIVATE LIMITED',
    'PROBE CONSULTANTS PRIVATE LTD',
    'PRIME AVIATION SERVICES PRIVATE LIMITED',
    'PROGRESSIVE RECREATION PRIVATE LIMITED',
    'MEIDEN T&D (INDIA) LIMITED',
    'ABC SYSTEMS PRIVATE LIMITED',
    'ABD PROPERTIES PRIVATE LIMITED',
    'R1 RCM INDIA PRIVATE LIMITED',
    'R1 RCM GLOBAL PRIVATE LIMITED',
    'PRIMENET GLOBAL PRIVATE LIMITED',
    'PRIMERA INFRA GREENS LIMITED',
    'ABD REAL ESTATE PRIVATE LIMITED',
    'ABHISHEK FINANCE COMPANY LIMITED',
    'ABHISHEK SECURITIES PRIVATE LIMITED',
    'ABHIYAN INTERNATIONAL PRIVATE LIMITED',
    'ABK CONSULTANTS PRIVATE LIMITED',
    'ABK SOFTWARE SERVICES PRIVATE LIMITED',
    'ABL CAPITAL PRIVATE LIMITED',
    'ABMB REAL ESTATES PRIVATE LIMITED',
    'ABS LOGISTICS PRIVATE LIMITED',
    'VIRYA ESTATE MANAGEMENT PRIVATE LIMITED',
    'ABSOLUTE PROJECTS (INDIA) LIMITED',
    'ABV INFRASTRUCTURE PRIVATE LIMITED',
    'ACME GLOBAL BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Sunworld Innovations Private Limited',
    'ACME ORGANICS PRIVATE LIMITED',
    'ACME TOURS AND TRAVELS PRIVATE LIMITED',
    'Acaasa Real Estate Private Limited',
    'ACACIA FURNISHERS PRIVATE LIMITED',
    'Accedian Technologies Private Limited',
    'ASF BUILDCON PRIVATE LIMITED',
    'POPULAR MEGA MOTORS (INDIA) Private Limited',
    'ASHA TOWERS PRIVATE LIMITED.',
    'ASHA TRAEXIM PRIVATE LIMITED',
    'SAHNI SILK MILLS private limited',
    'SAHNI SONS PRIVATE LIMITED',
    'SAI CHHAYA DEVELOPERS PRIVATE LIMITED',
    'SAI FOODHOUSE PRIVATE LIMITED',
    'ASHARFI DEVI KITCHENWARE PRIVATE LIMITED',
    'SAI KRIPA ESTATE PRIVATE LIMITED',
    'ASHI FACADE PRIVATE LIMITED',
    'ARSENIC CLEANING AND SANITIZATION INDIA PRIVATE LIMITED',
    'ONE QUBE REALTORS PRIVATE LIMITED',
    'ASN SERVICES PRIVATE LIMITED',
    'ASP BUILTECH PRIVATE LIMITED',
    'ASHOK BROTHERS IMPEX PVT LTD',
    'ASHOK MANUFACTURING COMPANY PRIVATE LIMITED',
    'ASHOKA MUDHOL NIPANI ROADS LIMITED',
    'ASHTAVINAAYAK JEWELLER PRIVATE LIMITED',
    'SACH TRAVEL CONSULTANTS PRIVATE LIMITED',
    'Asian Automobile India Private Limited',
    'ASIAN FILMS TV Private LIMITED',
    'Asian Infracon Private Limited',
    'SAGAR MAL SHIMBHOONATH FINANCE AND INVESTMENT COMPANY PRIVATE LIMITED',
    'ASPEE LOGMAN PRIVATE LIMITED',
    'ASPEE PRECISION COMPONENTS PRIVATE LIMITED',
    'ASPEE SPRINGS LIMITED.',
    'ASPEN CASINGS PRIVATE LIMITED',
    'Aspen Communications Private Limited tfr. from chandigarh to delhi',
    'ASSOCIATION OF ACCOUNTING TECHNICIANS',
    'ASSOTECH REALTY PRIVATE LIMITED',
    'ASSURE STRATEGIC VENTURES PRIVATE LIMITED',
    'SAGU DREAM LAND PRIVATE LIMITED',
    'SAHIBJI TRAVELS & TOURS PRIVATE LIMITED',
    'ATIYA HEALTHCARE PRIVATE LIMITED',
    'SAHIT POLYCHEM PRIVATE LIMITED',
    'SAHKAR BUILDERS PRIVATE LIMITED',
    'SAI GRAPHICS (INDIA) PVT LTD',
    'SACHDEVA ROAD LINES PRIVATE LIMITED',
    'SACHKHAND APARTMENTS PRIVATE LIMITED',
    'ASTRO INSURANCE BROKERS LIMITED',
    'SACHKHAND BUILDERS PVT LTD',
    'AT & T COMMUNICATION SERVICES INDIA PRIVATE LIMITED',
    'AT AND T ENGINEERS PRIVATE LIMITED',
    'ASE CARGO PRIVATE LIMITED',
    'SAFDARJANG MOTORS PRIVATE LIMITED',
    'SAFE CAPITAL SERVICES Private Limited',
    'SAFFRON INFRADEVELOPERS PRIVATE LIMITED',
    'ASTABERRY BIOSCIENCES (INDIA) PRIVATE LIMITED',
    'ASTAM HEALTHCARE PRIVATE LIMITED',
    'ASTAR METALS PRIVATE LIMITED',
    'ASTECH MARKETING PRIVATE LIMITED',
    'ATLANTA TRAVELS PRIVATE LIMITED',
    'ASTHA STUDIOS PRIVATE LIMITED',
    'ASTIR PROPERTIES PRIVATE LIMITED',
    'ASTRAL INTERNATIONAL PRIVATE LIMITED',
    'ATULYA TECHPLAST PRIVATE LIMITED',
    'SAI KRIPA PROJECTS PRIVATE LIMITED',
    'KIRIYANTHAN FARMS AND RESORTS PRIVATE LIMITED',
    'ASKIITIANS WEB PRIVATE LIMITED',
    'SGA AGRO FOODS PRIVATE LIMITED',
    'ASP Global Corporation Private Limited',
    'AUTOMETERS LTD',
    'AUTOVIKAS SALES AND SERVICE PRIVATE LIMITED',
    'AV SCIENCE AND MARKETING PRIVATE LIMITED',
    'ASP PETROCHEMICALS PRIVATE LIMITED',
    'AVANTA OFFICES PRIVATE LIMITED',
    'SULOCHANA THAPAR FOUNDATION',
    'AVANTHA HOLDINGS LIMITED',
    'AVANTHA REALTY LIMITED',
    'AVANTHA TECHNOLOGIES LIMITED',
    'AVANTIKA INFRASTRUCTURE PVT. LTD.',
    'ASP KAUFIL INDIA PRIVATE LIMITED',
    'ASP NANOCEPTS TECHNOLOGIES PRIVATE LIMITED',
    'ASP OVERSEAS PRIVATE LIMITED',
    'ASTRAL OVERSEAS PRIVATE LIMITED',
    'Astrum Management Advisory Private Limited',
    'ASP RUBBER PRIVATE LIMITED',
    'SAIGURU BUILDMART PRIVATE LIMITED',
    'SAIL-KOBE Iron India Private Limited',
    'ENERDYNE TECHNOLOGIES PRIVATE LIMITED',
    'ASP SEALING PRODUCTS LIMITED',
    'ASP THERMOPLASTIC EXTRUSION PRIVATE LIMITED',
    'ATHENA LAND DEVELOPMENT LIMITED',
    'SAKKARWAL TRAVELS PRIVATE LIMITED',
    'Ati sunder Estates Developers Private limited',
    'ATLANTA GLOBAL ADVISORS PRIVATE LIMITED',
    'ATMA RAM KISHAN CHAND INSULATIONS PRIVATE LIMITED',
    'SALIENT FINANCIAL SOLUTIONS LIMITED',
    'ATREYA INTERNATIONAL PRIVATE LIMITED',
    'SALONI MOTELS & HOTELS LIMITED',
    'ATRIUM CORPORATE SOLUTIONS PRIVATE LIMITED',
    'AUM SHRI HOTELS & RESORTS PRIVATE LIMITED',
    'SALVIA TECHNOLOGIES PRIVATE LIMITED',
    'SALVIA TRAVELS PRIVATE LIMITED',
    'SALVOS ADVERTISING AND MARKETING PRIVATE LIMITED',
    'SAM GAS PROJECTS PRIVATE LIMITED',
    'SAM VISION TECH PRIVATE LIMITED',
    'AUREOLE ATELIER PRIVATE LIMITED',
    'ALL INDIA BROADCAST MANUFACTURERS & DISTRIBUTORS ASSOCIATION',
    'ALL INDIA GLASS MFRS',
    'S FARMTECH PRIVATE LIMITED',
    'AZUL SYSTEMS (INDIA) PRIVATE LIMITED',
    'CARSIL AUTO PRODUCTS PVT LTD',
    'JOIN PACK MACHINES PRIVATE LIMITED',
    'KALATMAK FASHIONS PRIVATE LIMITED',
    'KALCO Alu Systems Private Limited',
    'KALCO HOLDINGS PRIVATE LIMITED',
    'KALEIDOSCOPE (INDIA) PRIVATE LIMITED',
    'KALEIDOSCOPE APPAREL PRIVATE LIMITED',
    'JOLLY AUTO INDUSTRIES PRIVATE LIMITED',
    'JOLLY FARM FRESH PRIVATE LIMITED',
    'JONES AND BARTLETT INDIA PRIVATE LIMITED',
    'KALINJAR TECHNOLOGIES PRIVATE LIMITED',
    'K. House Restaurants Private Limited',
    'K. K. INFRACON PRIVATE LIMITED',
    'KKSPUN INDIA LIMITED',
    'K.S. COMMODITIES PRIVATE LIMITED',
    'Kalra Hospital SRCNC Private Limited',
    'KALYANI KALA MANDIR FOR PROLIFERATION OF ARTS AND CULTURAL SCIENCES',
    'KALYANI MANUFACTURING AND LEASING LIMITED',
    'KAMAL BUILDTECH PRIVATE LIMITED',
    'KAMAL DEVELOPERS PRIVATE LIMITED',
    'K.S.C.ENGINEERS PRIVATE LIMITED',
    'KAMDHENU GLOBAL LIMITED',
    'K.V. MULTI HEALTHPLEX PRIVATE LIMITED',
    'KAMYA INFRASTRUCTURES PRIVATE LIMITED',
    'KAILASH DWELLERS PRIVATE LIMITED',
    'KANGAROO GOLF EQUIPMENTS MFG CO INDIA PRIVATE LIMITED',
    'ARYAN AUTOAGENCIES PRIVATE LIMITED',
    'ABI-HEALTH TECHNOLOGIES PRIVATE LIMITED',
    'KANIKA AUDIO VISUALS PRIVATE LIMITED',
    'KANIKARAN CONSULTING PRIVATE LIMITED',
    'KANTA CHEMICALS PRIVATE LIMITED',
    'KANTA FINANCE PVT LTD',
    'KANTAS TRACK-PACK INDIA LIMITED',
    'INTELLECT LIFE STYLE PRIVATE LIMITED',
    'KAPILA COLOURS PRIVATE LIMITED',
    'KAPKOL EXPORTS PRIVATE LIMITED',
    'KAPOOR -E-ILLUMINATIONS PRIVATE LIMITED',
    'ASIA HEALTHCARE DEVELOPMENT LIMITED',
    'BODEX SYSTEMS PRIVATE LIMITED',
    'IFOCAL SOLUTIONS PRIVATE LIMITED',
    'LIVING VENTURES PRIVATE LIMITED',
    'TECAFINE POLYMER PRIVATE LIMITED',
    'MONKEY SLAP ENTERTAINMENT PRIVATE LIMITED',
    'BHARATHI GEO TECH PRIVATE LIMITED',
    'SMARTO SYSTEMS PRIVATE LIMITED',
    'TRIOMINDS MEDIA PRIVATE LIMITED',
    'SAFECON LIFESCIENCES PRIVATE LIMITED',
    'LASERSEC TECHNOLOGIES PRIVATE LIMITED',
    'QUARTER PIE INTERACTIVE PRIVATE LIMITED',
    'IV PROCESSING PRIVATE LIMITED',
    'PRATHAMESHWARA RETAIL PRIVATE LIMITED',
    'JUVENCA ONLINE PRIVATE LIMITED',
    'SHORAPUR SOLAR POWER LIMITED',
    'MG EDUCATIONAL ACADEMY',
    'WWS INDIA PRIVATE LIMITED',
    'ENTREPRENEURS ORGANISATION (NEW DELHI)',
    'IRC CUISINE PRIVATE LIMITED',
    'BAAZ SAFETY SOLUTIONS PRIVATE LIMITED',
    'ATRIA SOLAR POWER (CHAPIRI) PRIVATE LIMITED',
    'ATRIA WIND POWER (CHITRADURGA 2) PRIVATE LIMITED',
    'KEENEXPERT SOLUTION PRIVATE LIMITED',
    'GOLFING GREENS PRIVATE LIMITED',
    'CR CLOUD ACCOUNTING SERVICES PRIVATE LIMITED',
    'AVNIDE SPORTS PRIVATE LIMITED',
    'OMR PRIYA DIAGNOSTIC CENTRE PRIVATE LIMITED',
    'CONVELINE SYSTEMS PRIVATE LIMITED',
    'PIKQUICK SERVICES PRIVATE LIMITED',
    'IVAN INFOTECH PRIVATE LIMITED',
    'DIGITAL JEEVI SOLUTIONS PRIVATE LIMITED',
    'APG HABITAT PRIVATE LIMITED',
    'APG SKYWARDS PRIVATE LIMITED',
    'AANJANEYA AERODYNAMICS PRIVATE LIMITED',
    'ACCUISITE TECHNOLOGIES PRIVATE LIMITED',
    'INCDIA INDIA PRIVATE LIMITED',
    'TERASOFT TECHNOLOGIES PRIVATE LIMITED',
    'HEV FOODS PRIVATE LIMITED',
    'EDPULSE EDUCATION TECHNOLOGY PRIVATE LIMITED',
    'SITARAM NIWAS PRIVATE LIMITED',
    'FINSOL TECHNOLOGIES PRIVATE LIMITED',
    'WALKING TREE VENTURES PRIVATE LIMITED',
    'PURE WATER ENTERPRISES PRIVATE LIMITED',
    'IROCHEM PHARMACEUTICALS PRIVATE LIMITED',
    'VSRL INFOTECH PRIVATE LIMITED',
    'GBC INDIA EXPOSITIONS PRIVATE LIMITED',
    'LULU INDIA SHOPPING MALL PRIVATE LIMITED',
    'EAISHMAN PHARMA PRIVATE LIMITED',
    'TRRINGO.COM LIMITED',
    'BNPR-B REALTIES PRIVATE LIMITED',
    'DELMON SOLUTIONS PRIVATE LIMITED',
    'STICKHOUSE PRIVATE LIMITED',
    'A.TREDS LIMITED',
    'AGSTACK TECHNOLOGIES PRIVATE LIMITED',
    'DEVENTURE HOSPITALITY PRIVATE LIMITED',
    'SAMANK APPARELS PRIVATE LIMITED',
    'RA BACK OFFICE SERVICES (INDIA) PRIVATE LIMITED',
    'MOJRO TECHNOLOGIES PRIVATE LIMITED',
    'HOTKHANA.COM MEDIA SERVICES PRIVATE LIMITED',
    'RIRITANA HOSPITALITY PRIVATE LIMITED',
    'ZAMIN ENGINEERING INDIA PRIVATE LIMITED',
    'DECCAN STELLANT FOOD SERVICES PRIVATE LIMITED',
    'HERO HOMES FINANCE PRIVATE LIMITED',
    'ANCOMM TECHNOLOGIES PRIVATE LIMITED',
    'AUDITICS PRIVATE LIMITED',
    'SYNMAC CONSULTANTS PRIVATE LIMITED',
    'FILMBOARD MOVIES PRIVATE LIMITED',
    'ZAPPER HOSPITALITY SERVICES PRIVATE LIMITED',
    'TINY ROUTE SOFTWARE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'VERITO TECHNOLOGIES PRIVATE LIMITED',
    'COGNITIO INNOVO PRIVATE LIMITED',
    'SOFTLETS PRIVATE LIMITED',
    'TARGETONE INNOVATIONS PRIVATE LIMITED',
    'GREENDUNIA AGRICULTURAL MARKETING PRIVATE LIMITED',
    'T-INFRA ASIA PRIVATE LIMITED',
    'DVC PROCESS TECH (INDIA) LIMITED',
    'ATOM ALLOYS INDIA PRIVATE LIMITED',
    'EARLY FOODS PRIVATE LIMITED',
    'SCIENCE FOR LIFE FOUNDATION',
    'TREZOR ELEVATORS PRIVATE LIMITED',
    'ALIEN HOLIDAYS & HOSPITALITY SERVICES PRIVATE LIMITED',
    'SPECIALIST ENGINEERING SERVICES PRIVATE LIMITED',
    'ECONSULTANTZ SOLUTIONS PRIVATE LIMITED',
    'HENWA SOLUTIONS PRIVATE LIMITED',
    'SHOPPINGKART24 ONLINE SERVICES PRIVATE LIMITED',
    'SPECTRA ENVIROTECH PRIVATE LIMITED',
    'SRI CHIMA CARS PRIVATE LIMITED',
    'TMOK PRIVATE LIMITED',
    'HUMANIX LIFESCIENCES PRIVATE LIMITED',
    'SOCIALPULSAR DIGITAL MARKETING PRIVATE LIMITED',
    'SUNPOWER INDIA VENTURES JHARKHAND PRIVATE LIMITED',
    'BMF ENGINEERING SERVICES PRIVATE LIMITED',
    'VISHWAKARMA SOLAR LIGHT PRIVATE LIMITED',
    'YANTRA COMMERCE INDIA PRIVATE LIMITED',
    'APG INDUSTRIAL VENTURE PRIVATE LIMITED',
    'TALOD FOOD PRODUCTS PRIVATE LIMITED',
    'SYNERGIST SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'FUSOLVE TECHNOLOGIES PRIVATE LIMITED',
    'SHIRPUR AQUA PRIVATE LIMITED',
    'NEMCARE HOSPITAL TEZPUR PRIVATE LIMITED',
    'MEDATA SOFTECH PRIVATE LIMITED',
    'SOL KAR INFRASTRUCTURE PRIVATE LIMITED',
    'CLEAN WATER GENERATOR PRIVATE LIMITED',
    'BIOCON BIOLOGICS LIMITED',
    'ADZHUBMEDIA PRIVATE LIMITED',
    'MBS FACILITIES PRIVATE LIMITED',
    'POPEES BABY CARE PRODUCTS PRIVATE LIMITED',
    'INDSHINE ENERGY PRIVATE LIMITED',
    'MACARONI MEDIA WORKS AND LANGUAGE PRIVATE LIMITED',
    'ATYOURDOORSTEPDOTIN PRIVATE LIMITED',
    'SANDHYA INDUSTRIAL CHEMICAL EXPORT PRIVATE LIMITED',
    'FIDUS PROFESSIONALS PRIVATE LIMITED',
    'AMPIN ENERGY TRANSITION PRIVATE LIMITED',
    'BIGSTREAM TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SANDHYA DYES & CHEMICAL PRIVATE LIMITED',
    'GENIUS LEARNING LABS PRIVATE LIMITED',
    'A. K. BUSINESS SOLUTIONS PRIVATE LIMITED',
    'UTTARAYAN DIAGNOSTIC SERVICES PRIVATE LIMITED',
    'FLYTTA INNOVATIONS PRIVATE LIMITED',
    'ENVIRONOMICS PRIVATE LIMITED',
    '3V TRADING (INDIA) PRIVATE LIMITED',
    'ACCELARATA ONLINE SOLUTIONS PRIVATE LIMITED',
    'NETIZENS INFOTECH PRIVATE LIMITED',
    'GLORIA ALLUMINIUM INDIA PRIVATE LIMITED',
    'ILOGIC NETWORK SOLUTION PRIVATE LIMITED',
    'WEDENGAGE SOLUTIONS PRIVATE LIMITED',
    'CEIPAL SOLUTIONS PRIVATE LIMITED',
    'GREENTIN SOLUTIONS PRIVATE LIMITED',
    'DENALI MANAGEMENT SERVICES PRIVATE LIMITED',
    'ZENHILL PRIVATE LIMITED',
    'CAPRON VITRIFIED PRIVATE LIMITED',
    'TECHMERGE SOLUTIONS PRIVATE LIMITED',
    'BIMAL INFRA CONSTRUCTIONS PRIVATE LIMITED',
    'SAMAK AQUACULTURE PRIVATE LIMITED',
    'JS FUSION INDUSTRIES PRIVATE LIMITED',
    'THOTH INFRASTRUCTURE PRIVATE LIMITED',
    'LEO CERAMIC PRIVATE LIMITED',
    'BADVE ENTREPRENEURSHIP AND SKILL TRAINING FOUNDATION',
    'INTSCALE VENTURES PRIVATE LIMITED',
    'AZURE POWER FORTY ONE PRIVATE LIMITED',
    'JHAISHNA TECHNOLOGIES PRIVATE LIMITED',
    'AZURE POWER THIRTY NINE PRIVATE LIMITED',
    'DCC INFOTECH PRIVATE LIMITED',
    'HIGHLINE INDIA NIDHI LIMITED',
    'VCC INDUSTRIES PRIVATE LIMITED',
    'SARANYU SOLAR ENERGY PRIVATE LIMITED',
    'DIGIPRO DIGITAL PRIVATE LIMITED',
    'SUNDARAM TRANSTECH SOLUTIONS PRIVATE LIMITED',
    'INDIGRID TECHNOLOGY PRIVATE LIMITED',
    'RKR AGRO FOODS PRIVATE LIMITED',
    'MAYARA TSI PRIVATE LIMITED',
    'METICULOUS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ASSET BULLS INDIA PRIVATE LIMITED',
    'VIRAL PROJECTS PRIVATE LIMITED',
    'WANFUDA INSTRUMENTS INDIA PRIVATE LIMITED',
    'KAUSHALAM FOUNDATION',
    'EQUAIN ESTATES PRIVATE LIMITED',
    'WHITESPACE TECHNOLOGIES PRIVATE LIMITED',
    'JANSUTRA TECHNOLOGIES PRIVATE LIMITED',
    'FEYNMAN TECHNOLOGY PRIVATE LIMITED',
    'ZULU TECHNOLOGIES PRIVATE LIMITED',
    'BEHIND-THE-SCENES PRIVATE LIMITED',
    'ALCHEMY STONES MATRIX PRIVATE LIMITED',
    'GOLDEN CHARIOT ORGANICS PHARMA (INDIA) PRIVATE LIMITED',
    'TUI INDIA PRIVATE LIMITED',
    'RX3 CLOTHING PRIVATE LIMITED',
    'EONWEBS PRIVATE LIMITED',
    'TOPTIME CONSUMER PRIVATE LIMITED',
    'LAKSHDEEP GLOBAL PRIVATE LIMITED',
    'PRAKREETEE SOLAR ENERGY GODAWARI PRIVATE LIMITED',
    'TEACHSMART GLOBAL LEARNING SOLUTIONS PRIVATE LIMITED',
    'SMAAASH VILLAGE PRIVATE LIMITED',
    'ZESTY NATURALS PRIVATE LIMITED',
    'PURPLEPINK FILMS & MEDIA PRIVATE LIMITED',
    'KETROX LIMITED',
    'TRISIM TECHNOLOGIES PRIVATE LIMITED',
    'WINGLOBE HEALTHCARE PRIVATE LIMITED',
    'AUTOMATIA MACHINES PRIVATE LIMITED',
    'VNB PROJECTS PRIVATE LIMITED',
    'PRARTI WASHING MACHINES PRIVATE LIMITED',
    'SKH Y-TEC INDIA PRIVATE LIMITED',
    'KALASA EVENTORS PRIVATE LIMITED',
    'NEOCORE TECHNOLOGIES PRIVATE LIMITED',
    'CHAPTER 30 CREATIVES PRIVATE LIMITED',
    'IBM GLOBAL FINANCING INDIA PRIVATE LIMITED',
    'GRG ACCESSORIES LIMITED',
    'GOVIND ENTERTAINMENT CLUB PRIVATE LIMITED',
    'CLUEMANTRA EXIM PRIVATE LIMITED',
    'KRISHBHAVARA TECH AND TRADE LIMITED',
    'ABHAR TECHNOLOGIES PRIVATE LIMITED',
    'ABHAR TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'UNITED IT SERVICES PRIVATE LIMITED',
    'NATECO IT SOLUTIONS PRIVATE LIMITED',
    'SICAP INDIA PRIVATE LIMITED',
    'ALTAVISION DIGITAL SYSTEMS PRIVATE LIMITED',
    'ADON INTERACTIVE MEDIA PRIVATE LIMITED',
    'GLOBALHONEYBEE PRIVATE LIMITED',
    'CAPER INFRA PRIVATE LIMITED',
    'BAFNA SOLAR AND INFRA PRIVATE LIMITED',
    'BLUE OCEAN IMC PRIVATE LIMITED',
    'MCHAMP ENTERTAINMENT PRIVATE LIMITED',
    'TECHNOGEN IT SERVICES INDIA PRIVATE LIMITED',
    'SK INFRA ESTATES AND LAND DEVELOPERS PRIVATE LIMITED',
    'PRAXKO CAPITAL PRIVATE LIMITED',
    'FRAGMA DATA SYSTEMS PRIVATE LIMITED',
    'JHUNJHUNWALA HOMES PRIVATE LIMITED',
    'ARTIFEX TECHSYS PRIVATE LIMITED',
    'BRANDSTORY SOLUTIONS PRIVATE LIMITED',
    'TELECMI TECHNOLOGIES PRIVATE LIMITED',
    'ANDUM TECHNOLOGIES PRIVATE LIMITED',
    'AGGRANDIZE VENTURE PRIVATE LIMITED',
    'NOOBLE INFO PRIVATE LIMITED',
    'INTACT PACKAGING PRIVATE LIMITED',
    'GREEN FREEDOM PRIVATE LIMITED',
    'PG ADVISORY SERVICES PRIVATE LIMITED',
    'INDIUS MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'CENDYN INDIA PRIVATE LIMITED',
    'ORIGO FINANCE PRIVATE LIMITED',
    'TEAMSTREAMZ INDIA PRIVATE LIMITED',
    'ZENDESK TECHNOLOGIES PRIVATE LIMITED',
    'RCI DIGITAL SOLUTIONS PRIVATE LIMITED',
    'CONTINUA KIDS PRIVATE LIMITED',
    'ASCENDER INDIA PRIVATE LIMITED',
    'ACMATIC IT SOLUTIONS PRIVATE LIMITED',
    'Saks fashion private limited',
    'Heather cosmetics tex limited',
    'Britannia labels india private limited',
    'Maple accessories private limited',
    'Agarwalla teak international private limited',
    'Mahati packwell private limited',
    'Rdg productions private limited',
    'Titanium merchant private limited',
    'Hi-tech e-terminal services private limited',
    'People design and communications (india) private limited',
    'SABGROUP CONTENT NETWORK PRIVATE LIMITED',
    'Darwin platform1 news limited',
    'Espee lifesciences private limited',
    'Dom pharma private limited',
    'Behram chemicals pvt ltd',
    'Hwatsi chemical private limited',
    'Vichare inks & allied industries private limited',
    'Speed international (india) priavte limited',
    'Indinex private limited',
    'Texsol chemisol private limited',
    'ACRYNOVA INDUSTRIES PRIVATE LIMITED',
    'Famous minerals and chemicals private limited',
    'Molecraft life sciences private limited',
    'Waterfront fertilizer & chemicals private limited',
    'Atharva polymers private limited',
    'Sri gopal krishna labs private limited',
    'ABPC FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Gmm coatings private limited',
    'Anupam colours private limited',
    'BILANCIA CONSULTING PRIVATE LIMITED',
    'Tristar remedies private limited',
    'Abhilasha pharma private limited',
    'Syner medico private limited',
    'Maxheal laboratories private limited',
    'Scion chem private limited',
    'Labela regsources private limited',
    'Sh pharmaceuticals limited',
    'Amneal oncology private limited',
    'Exela pharm sci private limited',
    'Bymaa laboratories private limited',
    'Biogen idec biotech india private limited',
    'Dales remedies pvt.ltd.',
    'Jaron cosmetique private limited',
    'Condot systems private limited.',
    'Zdravi duvera india limited',
    'Anar rubtech private limited',
    'Shehjar industries private limited',
    'Raipur polymers private limited',
    'Aarogyam packaging solutions private limited',
    'SCHOLLE IPN INDIA PACKAGING PRIVATE LIMITED',
    'Glow plast machines private limited',
    'Neutral glass and alled industries pvt.ltd.',
    'DRYCHEM INDIA PRIVATE LIMITED',
    'Dust blowers facility management services private limited',
    'Svea modular concepts private limited',
    'Pro body balance private limited',
    'E-ally commodities (india) private limited',
    'Artizen interiors private limited',
    'Sd fashions private limited',
    'Crew petro private limited',
    'Miyako management services private limited',
    'Sabia bulk material analyser private limited',
    'Emsys electronics private limited',
    'Saksham training and facility management private limited',
    'Brothers outsourcing solutions private limited',
    'Arthtech consultants private limited',
    'Tutis biometrics private limited',
    'Graand prix elevators india private limited',
    'Tomasetto achille india private limited',
    'Orion express container lines private limited',
    'Brand harvest consultancy private limited',
    'L.h.s.enterprises private limited',
    'Vibrer technology private limited',
    'Darwin platform holdings limited',
    'Uphaar cards private limited',
    'Vignesh overseas (c & f) private limited',
    'Care shipping private limited',
    'Rath infotech and web solutions private limited',
    'Accurate restructure and management systems private limited',
    'Dualends technologies and trading private limited',
    'Arthtech knowledge technomanagement private limited',
    'Anewa engineering private limited',
    'Global cold storage private limited',
    'Waves enviro tech private limited',
    'Magic square entertainment private limited',
    'Neeyamo staffing services private limited',
    'Janville learning systems private limited',
    'Tfl continuous learning private limited',
    'Snapwiz edutec (india) private limited',
    'Apt academic solutions private limited',
    'Center for study of science technology and policy',
    'Mac maritime training and research institute',
    'Culture station knowledge foundation',
    'INSPIRUSEDUMENTORS PRIVATE LIMITED',
    'Confiable healthcare private limited',
    'Savitri harinath singh foundation',
    'Tran-scell biologics private limited',
    'Yashad hospital pvt ltd',
    'N m healthcare private limited',
    'Medcis pathlabs india private limited',
    'RETAILERS ASSOCIATION',
    'NEIL INDIA PRIVATE LIMITED',
    'Shree guruji parivar private limited',
    'NIELSENIQ (INDIA) PRIVATE LIMITED',
    'Enjay marketing services pvt ltd',
    'Aneja assurance private limited',
    'Springboard ventures private limited',
    'Fareast offshore heavy engineering private limited',
    'Cetco lining technologies india private limited',
    '21cc recruitment and training private limited',
    'Baz fintax consultancy india private limited',
    'HIRJI LOGIPACK PRIVATE LIMITED',
    'Thom india private limited',
    'Institutional shareholder services india private limited',
    'Team hr gsa private limited',
    'Brains at work private limited',
    'Ffreedom intermediary infrastructure private limited',
    'Tashipta events & entertainment private limited',
    'Dreamspace interiors private limited',
    'Vedic ritual services and handicrafts private limited',
    'Medline industries india private limited',
    'Redi india quality services private limited',
    'GGPL VENTURES PRIVATE LIMITED',
    'Sentinel engineering services private limited',
    'KISAAN INFOTECH LIMITED',
    'Nch india private limited',
    'Kalaimakal systems private limited',
    'Make in india advisory services private limited',
    'Harvard business school publishing india private limited',
    'Biocon academy',
    'Devraj consultancy limited',
    'Lighthouse advisors (india) private limited',
    'Hycinth advisors private limited',
    'ALVAREZ & MARSAL INDIA PRIVATE LIMITED',
    'Sm aker management services private limited',
    'Evolve accounting systems private limited',
    'Asa bhanu technical services limited',
    'Optimizer it consulting private limited',
    'Tes-amm (india) private limited',
    'EAGLELINE TECHNOLOGIES PRIVATE LIMITED',
    'Tetra tech india limited',
    'Ipwt engineering private limited',
    'Elsec engineering systems private limited',
    'Maersk training india private limited',
    'Shiseido india private limited',
    'Thite valuers and engineers private limited',
    'Kids media india private limited',
    'North star advertising pvt. ltd',
    'Kanchanjunga power company private limited',
    'Snow leopard adventures private limited',
    'K s infosystems private limited',
    'Ciena communications india private limited',
    'Solutions mantra service private limited',
    'Pristine education private limited',
    'Goodwill outsource private limited',
    'Ignites human capital services private limited',
    'Ocs designs private limited',
    'Harbinger business solutions (india) private limited',
    'Resonate systems private limited',
    'A.r.a. dairy farm private limited',
    'Transeasy relocations (india) private limited',
    'Branding2win internet marketing private limited',
    'Changeetal india private limited',
    'Mark and orion ventures private limited',
    'Ahalia exchange and travels private limited',
    'Gate gourmet india private limited',
    'Masala king exports trading private limited',
    'Unify facility management private limited',
    'Ishan technical plant services private limited',
    'C m advisory services private limited',
    'MICROSCAN ORANGE BROADBAND PRIVATE LIMITED',
    'Microscan entertainment private limited',
    'Royal electrical contractor private limited',
    'Whitewater corporate advisory private limited',
    'Travelworld holidays private limited',
    'Rrefcast private limited',
    'KINESSO INDIA PRIVATE LIMITED',
    'Bharat patel patents private limited',
    'Samena india advisors private limited',
    'Burnbill b2b solutions private limited',
    'Conscap consultants private limited',
    'Agri tourism development company private limited',
    'Zigor india private limited',
    'Perennial equipments private limited',
    'Ipercept consulting private limited',
    'Global autocon systems private limited',
    'SYNAPTICS INDIA PRIVATE LIMITED',
    'Cetus corporation private limited',
    'Croissance clinical research private limited',
    'Gencor pacific organics india private limited',
    'Quadrate multilingual consultant private limited',
    'Global united shipping india private limited',
    'Aspen alankar world limited',
    'Amico consultants private limited',
    'Praendex management resources private limited',
    'Hn recruit(india) private limited',
    'Skybird security private limited',
    'Indumati h.r. facilities private limited',
    'Shreerangam packaging private limited',
    'Interactive avenues private limited',
    'Reachlocal services private limited',
    'Bay express private limited',
    'Capa aeropark (india) private limited',
    'Peak pacific knowledge private limited',
    'Aqua engineers and consultants india private limited',
    'Vincular testing labs india private limited',
    'Zoom entertainment network limited',
    'Preeti shipping and logistics private limited',
    'Craft int-decor private limited',
    'Xannex enterprises india private limited',
    'Santa fe india private limited',
    'Careerhone corporate services private limited',
    'Creation softech technologies private limited',
    'Iqpc india private limited',
    'Onus payment systems india private limited',
    'ERIS OAKNET HEALTHCARE PRIVATE LIMITED',
    'Enginium designs private limited',
    'Star certification international private limited',
    'Smartowner services india private limited',
    'The indo-italian chamber of commerce and industry',
    'International transmission limited',
    'CREATIVELAND PUBLISHING PRIVATE LIMITED',
    'Kargwal products private limited',
    'Myles informatics private limited',
    'Onsglobal solutions private limited',
    'Cupertino software private limited',
    'Fecund software services private limited',
    'Hugh solutions private limited',
    'Aceline tech solutions private limited',
    'ANAGHA SOFTECH PRIVATE LIMITED',
    'Brainvalley software private limited',
    'Comorin technologies india private limited',
    'E-edit infotech private limited',
    'Vsix analytical labs private limited',
    'Saarum innovations private limited',
    'Vision market research consultant private limited',
    'Adwiti technocrats private limited',
    'Origin beanstalk creative consultants private limited',
    'Interpay solutions india private limited',
    'RAMMIT CORPORATE SOLUTIONS PRIVATE LIMITED',
    'MG HR CONSULTING PRIVATE LIMITED',
    'A k shipping private limited',
    'Coreit services private limited',
    'Velaajobs placements private limited',
    'Click digital studios india private limited',
    'Delta intlcommex private limited',
    'Iconnect data collection private limited',
    'Shezar edubox private limited',
    'SVA TURNKEY PROJECTS PRIVATE LIMITED',
    'Visionit peripherals private limited',
    'Innov8 infinite technology private limited',
    'Mensa consulting services (i) private limited',
    'Magnate maritime private limited',
    'Linen art private limited',
    'Steer advisory services private limited',
    'Paundra enterprises private limited',
    'Wasan finishing school private limited',
    'Offshore accounting and taxation services private limited',
    'MANGALAMPALLI SOFTWARE SOLUTIONS PRIVATELIMITED',
    'Samsika marketing consultants private limited',
    'Nandika consultancy services private limited',
    'Satyakiran engineers private limited',
    'Saivion outsourcing services private limited',
    'Megha futures private limited',
    'Meshayu consultants private limited',
    'Rupshee communication private limited',
    'Aagam corporate and financial consultant private limited',
    'Evoke hr solutions private limited',
    'Peopleplus professional services private limited',
    'TONBO IMAGING INDIA PRIVATE LIMITED',
    'Schnabel dc consultants india private limited',
    'Madaksira vineyards private limited',
    'PineBridge India Private Limited',
    'Keyjob consultant private limited',
    'Regus centre midtown (hyderabad) private limited',
    'CHOICE PORTFOLIO MANAGEMENT SERVICES PRIVATE LIMITED',
    'Auriga corporate advisors private limited',
    'Dhairya management services private limited',
    'Bluehat consultants private limited',
    'Sitra infotech private limited',
    'Kadwell consultants and services private limited',
    'Tao consulting systems private limited',
    'Rebaca technologies private limited',
    'Resurgent india ltd',
    'Stanford operations & maintenance private limited',
    'VALMET TECHNOLOGIES PRIVATE LIMITED',
    'Segula technologies india private limited',
    'Dhargalkar technoesis (india) private limited',
    'Edifice consultants private limited',
    'Fairwinds asset managers limited',
    'Plant engineering and geomatic services private limited',
    'Svenska infra services private limited',
    'Uniquify india design services private limited',
    'Vasco environmental india private limited',
    'Automotive design and engineering solutions private limited',
    'Ketads advertisement private limited',
    'Support direct (india) private limited',
    'DENTSU ONE PRIVATE LIMITED',
    'IVC LOGISTICS LIMITED',
    'Maytas metro limited',
    'Paymax consulting private limited',
    'M v agro renewable energy private limited',
    'Regus south mumbai business centre private limited',
    'REGUS MANAGED CLIENT INDIA 01 PRIVATE LIMITED',
    'BLACK HAWK LIFESTYLE PRIVATE LIMITED',
    'Belle lampara retail private limited',
    'FRACTAL ESTATES PRIVATE LIMITED',
    'Sibamar marine logistics private limited',
    'IMPERATIVE INDIA PRIVATE LIMITED',
    'Uplink media-tech pri vate limited',
    'Ketto online ventures private limited',
    'Aichelin unitherm heat treatment systems india private limited',
    'Oats corporate consultants private limited',
    'Signature interiors private limited',
    'Ramiro corporation private limited',
    'Eemausam weather risk management services private limited',
    'Global gold foundation private limited',
    'Cibo hospitality management private limited',
    'Happy fashion and accessories private limited',
    'GILEAD SCIENCES INDIA PRIVATE LIMITED',
    'Ispace hr services private limited',
    'VERACITY POWERTRONICS PRIVATE LIMITED',
    'Scicom contact centre services private limited',
    'Peridot solutions private limited',
    'Evident techno solutions private limited',
    'Venturecorp consultans pvt ltd',
    'Purvaj advisors private limited.',
    'Regus business centre (delhi) private limited',
    'Mastermind strategic solutions private limited',
    'Aakarsh consultancy enterprises limited',
    'Platinum project consulting private limited',
    'Binsa consultancy services private limited',
    'CHENNAI ORIGIN HEALTH SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'Ginni systems limited',
    'PRECISION BHOOMI SURVEY PRIVATE LIMITED',
    'Taru leading edge private limited',
    'AVANTE FACADE CONSULTING PRIVATE LIMITED',
    'Zamil steel buildings india private limited',
    'Ember technologies private limited',
    'Nk instruments private limited',
    'American quality assessors (india) private limited',
    'Usonix inspection solutions private limited',
    'Contract advertising (india) private limited',
    'Tech shastra (india) private limited',
    'Optimystix entertainment india private limited',
    'Ubiquitous signs private limited',
    'Mirriad advertising private limited',
    'Elite cable network private limited',
    'TARU DEVELOPMENT INITIATIVES FOUNDATION',
    'Maithon power limited',
    'Moet hennessy india private limited',
    'NEARBUY INDIA PRIVATE LIMITED',
    'Security products private limited',
    '22 feet tribal worldwide private limited',
    'Live more services private limited',
    'Aco technology centre private limited',
    'Powered epc services limited',
    'Bridge india foundation',
    'Origin d-fab private limited',
    'Tori tech resource private limited',
    'Apya capital services private limited',
    'Sumerra services india private limited',
    'Regus business centre plaza private limited',
    'Regus citygold business centre private limited',
    'VIIKING HEMP PRIVATE LIMITED',
    'Regus business centre (mumbai) private limited',
    'Regus solitaire business centre private limited',
    'Neptune entertainment private limited',
    'Agv systems private limited',
    'Techint india private limited',
    'STEAMLINE TECHNOCRATES PRIVATE LIMITED',
    'GRACE TURNKEY PROJECTS PRIVATE LIMITED',
    'Vision vidyut engineers private limited',
    'MUSCAT ENGINEERING CONSULTANCY PRIVATE LIMITED',
    'Regus business centre management private limited',
    'Regus ruby business centre private limited',
    'Regus gem business centre private limited',
    'OPTIMYSTIX FILMS PRIVATE LIMITED',
    'Regus elite commercial services private limited',
    'NM REALTY HOME PRIVATE LIMITED',
    'Techniplex ii complex management private limited',
    'Kmtc (india) private limited',
    'Kanha bangles private limited',
    'Omkar bird proofing (india) private limited',
    'The brand brewery private limited',
    'Rotobotix engineering private limited',
    'SATEJ BUSINESS SERVICES PRIVATE LIMITED',
    'Universal calibration services private limited',
    'Paveway automation private limited',
    'XPANSION DIGITAL WORKS PRIVATE LIMITED',
    'Gram shree development services private limited',
    'Jaagruthi logistics private limited',
    'PIONEER INTERIOR PROJECTS PRIVATE LIMITED',
    'Strike-it-rite management consultants private limited',
    'Optima response management private limited',
    'Fircosoft india private limited',
    'BASILICA REALCON PRIVATE LIMITED',
    'MOL MARITIME (INDIA) PRIVATE LIMITED',
    'Conscript hr advisors private limited',
    'Futurz staffing solutions private limited',
    'Adwiz marketing private limited',
    'Matunga safe deposit vaults private limited',
    'On target maintenance private limited',
    'Malak glazing systems private limited',
    'Beach comber tours and travel (india) private limited',
    'Fluidlogic systems pvt ltd',
    'Dispoline india private limited',
    'Anthem india infopoint private limited',
    'KENT ENGINEERING INDIA PRIVATE LIMITED',
    'Ventura commodities limited',
    'Logic nests private limited',
    'POSIVIEW NEXGEN PRIVATE LIMITED',
    'CACS TAX AND LEGAL SOLUTIONS PRIVATE LIMITED (OPC)',
    'Bit electrics private limited',
    'METRO GLOBAL SOLUTION CENTER PRIVATE LIMITED',
    'Sbr supply chain services private limited',
    'Conquest integrated solutions (pune) private limited',
    'Knowledge matrix (india) private limited',
    'TANGENT TECH SERVE PRIVATE LIMITED',
    'H. r. practice private limited',
    'Futurz human resources solutions private limited',
    'S.w.a.t. security solutions limited',
    'Sparkle services private limited',
    'Noble denton india private limited',
    'Pv signs private limited',
    'CHATTERJEE CLEANING ARTS SERVICES LIMITED',
    'Rishik commodeal private limited',
    'Bsbs knowledge ventures private limited',
    'Bodhih training solutions private limited',
    'Poshe solutions private limited',
    'Aromathai spa (india) private limited',
    'Sahrudaya health care private limited',
    'Trimm exports private limited',
    'G.d.techcentre private limited',
    'Care hygiene private limited',
    'Vortex medsolutions private limited',
    'Fine & fit gymnasium private limited',
    'Sushruta vishranthi dhama limited',
    'INDIAN DREDGER OWNERS',
    'S HEALTH & FITNESS LOUNGE PRIVATE LIMITED',
    'Z-bac adventure institute private limited',
    'Bhansali nippon a&l private limited',
    'AUTOCAL LIFE SCIENCE PRIVATE LIMITED',
    'EM & EM PERSONAL CARE PRIVATE LIMITED',
    'CRAFTIZEN FOUNDATION',
    'Hvl pest services private limited',
    'Strontium management services private limited',
    'Milestone strategy consultants private limited',
    'Wts energy india private limited',
    'Mangospring technology services private limited',
    'Jayapura welfare foundation',
    'Precihole engineering private limited',
    'IIFL SECURITIES LIMITED',
    'Page industries limited',
    'Terraform realstate limited',
    'Terraform magnum limited',
    'Brigade enterprises limited',
    'San techno mentors private limited',
    'Bellofram instruments (india) private limited',
    'Turck india automation private limited',
    'BOMBAY DEALS PRIVATE LIMITED',
    'Pennar agro products private limited',
    'Penneru harticulture cultivation private limited',
    'Anantha horticulture private limited',
    'Influx agrotech private limited',
    'Ethames advertising private limited',
    'Suryans farming private limited',
    'Costrategix technologies private limited',
    'VIMRAJ ENTERPRISES PRIVATE LIMITED',
    'UNISION STONE CRUSHERS PRIVATE LIMITED',
    'Igopl offshore private limited',
    'Morwell pharmacia private limited',
    'Verve beauty & fitness private limited',
    'Mind heal homeopathy private limited',
    'Sindhu cargo services private limited',
    'Milenium technologies (india) private limited',
    'Gxp pharmaceuticals private limited',
    'Finish services management company private limited',
    'Ikapital media services chennai private limited',
    'Luxury lanes private limited',
    'SANKALPAM FOUNDATION',
    'Wellness associates fitness solutions & management private limited',
    'South united fc1 private limited',
    'Worldwide events private limited',
    'Playon sporting ventures private limited',
    'SIGMAAVIT TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Clanergy studios private limited',
    'MEDIC CREATIONS PRIVATE LIMITED',
    'Insearch management private limited',
    'Bhn consulting (india) private limited',
    'Mountview advisory services private limited',
    'Pankaj management services private limited',
    'Contromet consultancy services private limited',
    'Rs hr team solutions private limited',
    'E m services (india) private limited',
    'Rashi shipping services private limited',
    'Swastik apartments private limited',
    'EWPL HOLDINGS PRIVATE LIMITED',
    'The professional couriers private limited',
    'Net recruitment services private limited',
    'Gini silk mills limited',
    'Tokyo plast international ltd',
    'Abb india limited',
    'Va tech wabag limited',
    'Gujarat narmada flyash company limited',
    'Veerhealth care limited',
    'Monarch Networth Capital Limited',
    'Ladderup finance limited',
    'Trilogic digital media limited',
    'Shriniwas power & infrastructure limited',
    'BIODEAL PHARMACEUTICALS LIMITED',
    'Airways courier (india) private limited',
    'Mipro bio-green private limited',
    'Raj agro products pvt. ltd.',
    'Kshetra agritech private limited',
    'Novary poultry private limited',
    'Sridevi agro farms private limited',
    'Developmental & eco-friendly enterprises',
    'LOHAGIRI INDUSTRIALS PRIVATE LIMITED',
    'Cadabams tristar care private limited.',
    'Melic biology private limited',
    'Varuna offshore drilling services private limited',
    'Drillpro (india) private limited',
    'Baker hughes oilfield services india private limited',
    'HAZEMAG ALLMINERAL INDIA PRIVATE LIMITED',
    'Gimpex-Imerys India Private Limited',
    'Utkarsh sfatik limited',
    'Oriental yeast india private limited',
    'Ajinomoto india private limited',
    'Balaji breweries private limited',
    'Muniraj synthetics (india) private limited',
    'Boon industries private limited',
    'Zenith koplavitch exports limited',
    'Vinayak clothings private limited',
    'SHREE R.N. METALS (INDIA) PRIVATE LIMITED',
    'GALTA INTERNATIONAL PRIVATE LIMITED',
    'SWARAJ SYNTEX PRIVATE LIMITED',
    'Texport international private limited',
    'DICITEX FURNISHINGS PRIVATE LIMITED',
    'Aari zardozi private limited',
    'PZ CONSTRUCTION AND TRADING MANAGEMENT PRIVATE LIMITED',
    'Vaishali sarees emporium private limited',
    'Quality knit wears private limited',
    'Aadinath garments private limited',
    'Elan contemporary clothing private limited',
    'Panggo exports limited',
    'Pinnium brands private limited',
    'Composite boards private limited',
    'Jagdamba cartons private limited',
    'F a s t solutions (india) private limited',
    'Origin media solutions private limited',
    'Rybcal india private limited',
    'Concept research media tech & info solution private limited',
    'Sankalp lubricants private limited',
    'Lubrita india private limited',
    'Amistad pharmachem private limited',
    'Solex chemicals private limited',
    'Unilab chemicals and pharmaceuticals private limited',
    'Aum farben-chem (india) private limited',
    'EUROFINS PEENYA RESOURCES PRIVATE LIMITED',
    'Firmenich aromatics production (india) private limited',
    'Viraj inks and chemicals private limited',
    'Enem nostrum remedies private limited',
    'Ultimate lifestylezz private limited',
    'Weidmuller electronics india private limited',
    'Oneness controlpanels private limited',
    'Bhavyam engineering technologies private limited',
    'Pcb power (india) limited',
    'Swan solutions and services private limited',
    'Genius filters and systems private limited',
    'Sharma surgitech private limited',
    'Novo dental products private limited',
    'Novodent equipments and materials private limited',
    'Vtitan corporation private limited',
    'Biolase india private limited',
    'Maimoon fashion accessories private limited',
    'Marian ship management and consultancy service private limited',
    'Shree sagar stevedores private limited',
    'Isuzu motors india private limited',
    'REX RAILING PRIVATE LIMITED',
    'Dream seats private limited',
    'JASANI INDIA PRIVATE LIMITED',
    'Apollo gold manjeri private limited',
    'Prisha gems private limited',
    'Proleds technologies private limited',
    'Empire motors private limited',
    'Rsm gayatri finance & securities advisory private limited',
    'Polo gifts creations private limited',
    '4r recycling private limited',
    'KAMLAM ORGANIC AGRO-SPICES PRIVATE LIMITED',
    'Garuda vaayu shakthi limited',
    'Purple products private limited',
    'Eroei power solutions private limited',
    'Microsun solar tech private limited',
    'Bindu jal urja private limited',
    'Gdk turbo care private limited',
    'Aqasion watertech private limited',
    'Zen turnkey solutions private limited',
    'ARKADE DEVELOPERS LTD',
    'Rohan estates private limited',
    'High-parra construction private limited',
    'Raheja life styles private limited',
    'Easy home solutions private limited',
    'Bitcon india infrastructure developers private limited',
    'Krishna constro-projects private limited',
    'Viitor infrastructures private limited',
    'Happy home real estate private limited',
    'Happy home corporation private limited',
    'Build wallinfra india private limited',
    'Yuga homes limited',
    'Neptune enclave private limited',
    'Neptune housing and realty private limited',
    'Neptune homes private limited',
    'Allied maharashtra developers private limited',
    'Neptune ventures and developers private limited.',
    'Nicon infra and construction private limited',
    'Progetto india projects private limited',
    'Abohar power generation private limited',
    'Manav promoters private limited',
    'SUVIJAY BUILDCON PRIVATE LIMITED',
    'Ashok design build private limited',
    'BUILDMIGHTY TECHNO PRIVATE LIMITED',
    'Gokul emerald condominium private limited',
    'Sheth creators and promoters private limited',
    'Cygnus property private limited',
    'Reatox rmc developers private limited',
    'Allied indapur developers private limited',
    'Sdr infrastructure private limited',
    'Yale power private limited',
    'SAFEGUARD REALTY PRIVATE LIMITED',
    'Navkar estate & homes private limited',
    'Sheth buildwell private limited',
    'Stanchion designs private limited',
    'Sheth creators and realtors private limited',
    'Swaroop infraelect privare limited',
    'Shree ratnakar infradevelop (india) private limited',
    'Mounthill properties private limited',
    'Amazing residency private limited',
    'Bemishal promoters private limited',
    'Dhanghar tradelinks private limited',
    'India aluminium & glazing private limited',
    'Advanced computers and mobiles india private limited',
    'Lab and life instruments private limited',
    'Tecsec technologies private limited',
    'Polar instruments (india) private limited',
    'Abrowaman healthcare private limited',
    'Adonis agency private limited',
    'Hayagreevas fabrics private limited',
    'Nobel biocare india private limited',
    'Micro jewels and diamonds private limited',
    'ARCELORMITTAL PROJECTS INDIA PRIVATE LIMITED',
    'Amberin trades private limited',
    'Kony india private limited',
    'Axiom it solutions private limited',
    'Deltaclass technology solutions private limited',
    'Altocare life sciences private limited',
    'Ojas innovative technologies private limited',
    'Globalpoint info solutions private limited',
    'Capacious it services private limited',
    'Vishist business solutions private limited',
    'Argha technology services india private limited',
    'Skilin learning technologies private limited',
    'Edven soft solutions india private limited',
    'Netcon technologies india private limited',
    'Esolz technologies private limited',
    'Abzooba india infotech private limited',
    'Pricewaterhousecoopers service delivery center (kolkata) private limited',
    'Blue copper technologies private limited',
    'Rajlaxmi solutions private limited',
    'Vega project (india) private limited',
    'Dotphi infosolutions private limited',
    'Mobcast innovations private limited',
    'Sweet couch technology private limited',
    'We-do-it (india) private limited',
    'Sella synergy india private limited',
    'Idisha info labs private limited',
    'Ascendum kps private limited',
    'Samyak info solutions private limited',
    'Sisa information security private limited',
    '1to1 help.net private limited',
    'Meridium services and labs private limited',
    'Formcept technologies & solutions private limited',
    'Phonologies (india) private limited',
    'NTT GLOBAL DATA CENTERS & CLOUD INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'Gts e-services private limited',
    'Africa view private limited',
    'Cornerstone ondemand services india private limited',
    'Crispy games private limited',
    'Beehive software services private limited',
    'Jhs business solution private limited',
    'S cube trans continental solutions private limited',
    'Clearpoint learning systems (india) private limited',
    'Enterprisedb software india private limited',
    'Periwinkle technologies private limited',
    'Nichebees technosolutions private limited',
    'Pershing india operational services private limited',
    'Invitrogen bioservices india private limited',
    'ARKGEN ENTERPRISES PRIVATE LIMITED',
    'Amba shipping & logistics private limited',
    'Achem technology (india) private limited',
    'Green aims infotech private limited',
    'Adnest creative communication private limited',
    'BEST BUY SOFTWARE & SOLUTIONS PRIVATE LIMITED',
    'Jedi dia. (india) private limited',
    'Vijay auto works private limited',
    'Quadratic insights private limited',
    'Anantaa wealthitect private limited',
    'Lex et corporate advisory private limited',
    'Laqshya airport media private limited',
    'Rayyan consulting private limited',
    'ARNITA CONSULTANTS PRIVATE LIMITED',
    'Vinayak marketing consultant private limited',
    'Euler hermes services india private limited',
    'Icici merchant services private limited',
    'Balaji-ratna multiservices private limited',
    'Moolani management consultants private limited',
    'Pelmar sudrishti engineering india private limited',
    'INFINITE E-LEARNING SOLUTIONS PRIVATE LIMITED',
    'Ingenious process solutions private limited',
    'Bhoomi property consultants private limited',
    'Vhs mechatronics services p ltd',
    'Building research and management services private limited.',
    'SURAT RESORTS PRIVATE LIMITED',
    'Laqshya digital media private limited',
    'Anand components private limited',
    'Kunamneni technologies private limited',
    'Prescience calibration private limited',
    'In-depth people products private limited',
    'B+M SURFACE SYSTEMS INDIA PRIVATE LIMITED',
    'Kleansite hospitality services private limited',
    'D j appliances private limited',
    'CLAYTON CONSULTING PRIVATE LIMITED',
    'Parika exports private limited',
    'Ecom support private limited',
    'Fouraar enterprises private limited',
    'ASSA ABLOY OPENING SOLUTIONS INDIA PRIVATE LIMITED',
    'Intec heating solutions (india) private limited',
    'Birdvision consulting private limited',
    'Koacts hr services private limited',
    'Techmation india equipment private limited',
    'Paythrough softwares and solutions private limited',
    'Srtc tech solutions private limited',
    'Ssu business solutions private limited',
    'Mirarbindo engineering private limited',
    'Sawant pumps private limited',
    'Boge compressors (india) private limited',
    'CORRTECH INTERNATIONAL LIMITED',
    'Emerson process management (india) private limited',
    'Abc compressors india private limited',
    'Rapsri engineering industries limited',
    'Klingelnberg india private limited',
    'Fine equipments (india) private limited',
    'Fyn technologies private limited',
    'Usae equipment private limited',
    'Movomech sunnex india private limited',
    'Sarjan watertech india private limited',
    'Dyna force hydraulics private limited',
    'Sanmit card clothing india private limited',
    'Gamzen infrastructure private limited',
    'Baumer india private limited',
    'Zen exim private limited',
    'Cybermotion technologies private limited',
    'Emag india private limited',
    'LSML PRIVATE LIMITED',
    'Total power conditioners private limited',
    'Sakar electricals & electronics private limited',
    '3a innovative technologies private limited',
    'Ecolux india private limited',
    'Data care systems private limited',
    'Savinirs electronics private limited',
    'Elsol energy private limited',
    'Coolpad communications private limited',
    'Kasai india (chennai) private limited',
    'Bluue mango seatings private limited',
    'Vm modular solutions private limited',
    'Blue star diamonds private limited',
    'Shachihata (india) private limited',
    'Satyug gold private limited',
    'Kriscon services private limited',
    'Enrich energy private limited',
    'SPECTRUM POWER GENERATION LIMITED',
    'ULTRA LNG DIGHI LIMITED',
    'Nuevo renewable power private limited',
    'Indu ionpure (india) private limited',
    'GRREENPRO WATERRMINE & SYSTEMS PRIVATE LIMITED',
    'R s estate developers private limited',
    'Nsd realtors private limited',
    'ZEE DEVELOPERS PRIVATE LIMITED',
    'Sight realty private limited',
    'Aquila realty private limited',
    'Sj contracts private limited',
    'Gmt buildcon private limited',
    'Veronica constructions pvt ltd',
    'Bcv developers private limited',
    'Swojas construction and packaging pvt ltd',
    'Runwal heights private limited',
    'Affluent estates private limited',
    'R mall developers private limited',
    'Traansglobe infrastructure limited',
    'Nivara infraabuild india private limited',
    'Arihant shelters (india) limited',
    'Oberoi constructions limited',
    'Oberoi estates private limited',
    'Beachwood properties private limited',
    'Oberoi mall limited',
    'Siddhivinayak realties private limited',
    'Corporate shelters private limited',
    'Neo realty private limited',
    'Excel briquettes private limited',
    'Gables promoters private limited',
    'Hajee a.p.bava & company constructions private limited',
    'Integrus realty private limited',
    'Shraddha townships private limited',
    'URBAN DESK PRIVATE LIMITED',
    'Stonecraft developers private limited',
    'Tamil nadu road development company limited',
    'Dwarakamai housing projects private limited',
    'AURUM REALESTATE DEVELOPERS LIMITED',
    'Expressions realty private limited',
    'QUARRY LUXURY STONES PRIVATE LIMITED',
    'Evenstar realty private limited',
    'Incline realty private limited',
    'Griha infrastructure private limited',
    'Royal infraconstru limited',
    'Mounthill estates private limited',
    'Windals auto private limited',
    'Landmark cars (east) private limited',
    'BITC LOAN SERVICES PRIVATE LIMITED',
    'Egberts india private limited',
    'Ria international india private limited',
    'Usg traders private limited',
    'Akulpita trading private limited',
    'Adishriya tradserv private limited',
    'Bombay film enterprises private limited',
    'Sunanda capital services limited',
    'Fairplay properties private limited',
    'Accord watertech & infrastructure private limited',
    'Building environment (india) private limited',
    'Growthally advisors private limited',
    'Viking life-saving equipment mumbai private limited',
    'NJD LACTEUS AND HORTUS LIMITED',
    'Chemionix e-solutions private limited',
    'Taproot dentsu india communication private limited',
    'Creative finserve private limited',
    'Khadija ship management private limited',
    'Saavee aerosystems private limited',
    'Bishop rock consulting private limited',
    'Grandmaster innovations private limited',
    'V 5 infotech private limited',
    'Qualixa turnkey projects private limited',
    'Osp labs private limited',
    'Pdg software india private limited',
    'Masala king supermarkets trading private limited',
    '101 digital services india private limited',
    'Samskriti business solutions private limited',
    'Arobaini networks private limited',
    'Educational catalysts india private limited',
    'TOPPR TECHNOLOGIES PRIVATE LIMITED',
    'Poddar shikshan sanstha',
    'Hoe wellness private limited',
    'Parekhs hospital private limited',
    'Glaze dental depo private limited',
    'Beyond smiles dentalcare private limited',
    'PARAMOUNT HEALTH SERVICES & INSURANCE TPA PRIVATE LIMITED',
    'COLUMBIA PACIFIC COMMUNITIES PRIVATE LIMITED',
    'Aepl-gwm private limited',
    'Momentum solutions private limited',
    'Movielabs films private limited',
    'Centaur digital private limited',
    'Highlight pictures (india) private limited',
    'Sync sound private limited',
    'Arka media works private limited',
    'Prana studios private limited',
    'Flipside gaming private limited',
    'SEQURE INDIA PEST CONTROL PRIVATE LIMITED',
    'Appletree nutraceuticals private limited',
    'Parallel hr solutions private limited',
    'Rathi filters & industries private limited',
    'Panchshil hotels private limited',
    'Gopinath engineering co pvt ltd',
    'Organic coatings limited',
    'Luharuka Media & Infra Limited',
    'Aastha broad casting network limited',
    'Compuage infocom limited',
    'Ranco energy and projects private limited',
    'P s r granites private limited',
    'Blue bird foods (india) pvt ltd',
    'Ace seafood bazaar private limited',
    'BYWELL CONFECTIONERS PRIVATE LIMITED',
    'Chheda specialities foods private limited',
    'Manna foods private limited',
    'PRATAP EXCELLENCY FOOD & BEVERAGES PRIVATE LIMITED',
    'Krystal gourmet private limited',
    'Sunbeam machines india private limited',
    'Signature international foods india private limited',
    'Quik beverages and foods private limited',
    'HITKARI HITECH PRIVATE LIMITED',
    'Vrijesh natural fibre & fabrics (india) private limited',
    'Quantum clothing india private limited',
    'Vijay synthetic prints private limited',
    'Navnitlal private limited',
    'A & L APPARELS PRIVATE LIMITED',
    'TEEJAY INDIA PRIVATE LIMITED',
    'L k industries private limited',
    'Jbc garments private limited',
    'Diyan fashions private limited',
    'Delta shoes private limited',
    'J & j leather enterprises limited',
    'Harissons bags private limited',
    'A v fabrifuse private limited',
    'MADRAS CHIPBOARD LIMITED',
    'Indian flexible packaging and folding carton manufacturers association',
    'R a kraft paper private limited',
    'HAL LEONARD FURTADOS (INDIA) PRIVATE LIMITED',
    'Phalanx labs private limited',
    'Jindo chemical solutions private limited',
    'Riko chemicals pvt ltd',
    'Vinergy international private limited',
    'Chemtreat india limited',
    'SHIVANI AMPOULES & VIALS PRIVATE LIMITED',
    'Alg chemicals private limited',
    'STRADEGI SOLUTIONS INDIA PRIVATE LIMITED',
    'Vidur logistics private limited',
    'Vmobile it (india) private limited',
    'Gd research center private limited',
    'Ramadevi software private limited',
    'Jm frictech india private limited',
    'Aqua cool co private limited',
    'Lks india private limited',
    'Smart planner private limited',
    'Pyramid Sports Private Limited',
    'Efficienergi consulting private limited',
    'Purform mannequins private limited',
    'Sarvejana healthcare private limited',
    'Kemin industries south asia private limited',
    'Sneha farms private limited',
    'Sri adhikari brothers television network limited',
    'J r j sea foods india private limited',
    'Valli agri industries private limited',
    'Graf laboratories pvt ltd',
    'Jaysons machinery and equipments pvt ltd',
    'VISHAL STRUCTURALS PRIVATE LIMITED',
    'Angel pumps private limited',
    'Hyundai motor india limited',
    'Omniscient electronics private limited',
    'Nagal comtech private limited',
    'Negm infrastructure development private limited',
    'RKEC PROJECTS LIMITED',
    'Pioneer foundation engineers private limited',
    'Sampurn agri ventures private limited',
    'Panchshil realty and developers private limited',
    'Escort developers private limited',
    'Professional commodity services private limited',
    'Starboard hotels private limited',
    'Rajkrishna insurance broker private limited',
    'Hdfc securities limited',
    'CLASSIC MALL DEVELOPMENT COMPANY LIMITED',
    'Mars creators and realtors private limited',
    'Renuka business holding and development private limited',
    'ACCUREX SOLUTIONS PRIVATE LIMITED,',
    'Rayrox embedded technologies india pvt ltd',
    'K-source business solutions private limited',
    'Esa software and automation india private limited',
    'Maxlinear technologies private limited',
    'Gislen software private limited',
    'LAUREN ENGINEERS & CONSTRUCTORS PRIVATE LIMITED',
    'Veracitiz solutions private limited',
    'Aar entertainment enterprises private limited',
    'Urmin ip assets private limited',
    'Bvm outsourcing services private limited',
    'Choose portal private limited',
    'Wpp marketing communications india private limited',
    'Heron health private limited',
    'FIEM APPLIED TECHNOLOGIES PRIVATE LIMITED',
    'INFINIMINDS PRIVATE LIMITED',
    'Sri durga spinners (india) private limited',
    'Heromount footwear india private limited',
    'Setu advertising private limited',
    'Gowra petrochem private limited',
    'Meiosis chemicals private limited',
    'Aguerri industries private limited',
    'Pushpak products india private limited',
    'Iruna indian brakes private limited',
    'Fcmd india gears & castings private limited',
    '3m electro and communication india private limited',
    'Givi misure private limited',
    'Highamp products private limited',
    'Deccan auto limited',
    'Foresight shelters private limited',
    'Ekdant constructions and developers private limited',
    'Meva formwork systems private limited',
    'Vinhar chemicals private limited',
    'Stepan (india) private limited',
    'Stci finance limited',
    'Fortinet technologies india private limited',
    'Krishna cloth traders private limited',
    'Suryaprakash hotels private limited',
    'WOORIJIP HOTEL PRIVATE LIMITED',
    'K.b.s.manian & bros private limited',
    'Ashok travels private limited',
    'Artemis translog private limited',
    'Ultimate marine private limited',
    'Professional international couriers private limited',
    'Cholamandalam securities limited',
    'Sbi general insurance company limited',
    'TOUCHSTONE CAPITAL LIMITED',
    'Patwardhan consultants private limited',
    'Vigiboss it solutions private limited',
    'ZIGNUTS TECHNOLAB PRIVATE LIMITED',
    'BANDHAN BANK LIMITED',
    'SATAYWAN ENCLAVE PRIVATE LIMITED',
    'AXOZE INFRATECH LIMITED',
    'BuildXperia Projects private limited',
    'CLARUS TELECOM INDIA PRIVATE LIMITED',
    'BRAINSPARK TECHNOLOGIES PRIVATE LIMITED',
    'Prevail Consulting Private Limited',
    'TWISPRO TECHNOLOGIES PRIVATE LIMITED',
    'CloudKaptan Consultancy Services Private Limited',
    'CliniOps Techsoft Private Limited',
    'StepToStrategy Software Consulting Private Limited',
    'Eppix eSolution (India) Private Limited',
    'JUMBODIUM TECH PRIVATE LIMITED (OPC)',
    'RANKTECH SOLUTIONS PRIVATE LIMITED',
    'UNITERRENE WEBSOFT PRIVATE LIMITED',
    'Leego Solutions Private Limited',
    'CLEONIX TECHNOLOGIES PRIVATE LIMITED',
    'NrXen It Technologies Private Limited',
    'FAMOCOM TECHNOLOGY SYSTEMS PRIVATE LIMITED',
    'YINGJIA COMMUNICATION PRIVATE LIMITED',
    'Aerotech Eng. Works Private Limited',
    'JETTRANS LOGISTICS PRIVATE LIMITED',
    'EPITECH INFOSYSTEMS PRIVATE LIMITED',
    'LINCOLN EDUCATION PRIVATE LIMITED',
    'SKYLIGHT HOLIDAYS PRIVATE LIMITED',
    'ONCE UPON A TIME FILM PRODUCTIONS PRIVATE LIMITED',
    'CRESCO RESEARCH SOLUTIONS PRIVATE LIMITED',
    'PUERARIA AYURVEDA PRIVATE LIMITED',
    'NRGtech Services Private Limited',
    'Wonderwall Education Private Limited',
    'VARATOYA WATER SOLUTIONS PRIVATE LIMITED',
    'AKASH FEEDS & CHICKS PRIVATE LIMITED',
    'Innovation Garage Ventures Private Limited',
    'ETERNAL SUNSHINE PRODUCTIONS PRIVATE LIMITED',
    'WEBEL ELECTRONICS MANUFACTURING CLUSTERS LIMITED',
    'WEBEL ELECTRONICS INFRASTRUCTURE DEVELOPMENT LIMITED',
    'Prasida Ayurveda Clinics Private Limited',
    'EXCELLENTIAM HOSPITALITY AND HEALTHCARE PRIVATE LIMITED',
    'SIX SEASONS CONCRETEX PRIVATE LIMITED',
    'SREE MA TRADING PRIVATE LIMITED',
    'Array Innovative Services Private Limited',
    'Topglobe Technologies Private Limited',
    'QUADRANT INFORMATICS PRIVATE LIMITED',
    'STRAIGHTLINE SOLUTIONS PRIVATE LIMITED',
    'DRPM INDUS CON-CARE PRIVATE LIMITED',
    'GN Infotech Private Limited',
    'AVORU HEALTH & RESEARCH PRIVATE LIMITED',
    'AMRICH MARKETING INDIA PRIVATE LIMITED',
    'PURPULIGO TECHNOLOGIES PRIVATE LIMITED',
    'ADITYA BROADBAND SERVICES PRIVATE LIMITED',
    'SARB HERB HEALTHCARE PRIVATE LIMITED',
    'MONARCH CYLINDER LINERS PRIVATE LIMITED',
    'APS ElectraPower Private Limited',
    'Dehradun Darshani Enterprises Private Limited',
    'VIVIDWAYS VENDITARE INDIA PRIVATE LIMITED',
    'AVEN FOODS PRIVATE LIMITED',
    'MEGAHERTZ INTERNET NETWORK PRIVATE LIMITED',
    'WEBWIDE VISION INFOTECH PRIVATE LIMITED',
    'DREAMZCRAFT INFOMATICS PRIVATE LIMITED',
    'ANIPR TECHNOLOGY SERVICES PRIVATE LIMITED',
    'ECONOMICAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'MGM Sales Private Limited',
    'AIDLINE HEALTHCARE PRIVATE LIMITED',
    'DAB HAND SOLUTIONS PRIVATE LIMITED',
    'VKC FOUNDATION',
    'BULL',
    'S MARKET INNOVATORS PRIVATE LIMITED',
    'SMC Real Estate Advisors Private Limited',
    'STUDY VAULT EDUCATION PRIVATE LIMITED',
    'GREENARROWS SAFETY MANAGEMENT PRIVATE LIMITED',
    '4PEL ENERGY SERVICES PRIVATE LIMITED',
    'JYOTIKIRAN ENERGY PRIVATE LIMITED',
    'SKV ENERGY SERVICES PRIVATE LIMITED',
    'GERMAN CERT PRIVATE LIMITED',
    'SIDJOBS CONSULTANCY PRIVATE LIMITED',
    'VYBEX CONSULTING PRIVATE LIMITED',
    'SWIFTLINE INFRA AND LOGISTICS PRIVATE LIMITED',
    'GSCC AUDITS & CERTIFICATIONS PRIVATE LIMITED',
    'REGALIEN BUSINESS SERVICES PRIVATE LIMITED',
    'TRINITY MOBILE APP LAB PRIVATE LIMITED',
    'Vishtech Engineering Corporation Private Limited',
    'INTRAC SYSTEMS PRIVATE LIMITED',
    'CADPRO Consultants Private Limited',
    'KOR ENERGY (INDIA) PRIVATE LIMITED',
    '3D FIRE & SAFETY PRIVATE LIMITED',
    'AANAXAGORASR SOFTWARE PRIVATE LIMITED',
    'QILO COMMUNICATIONS PRIVATE LIMITED',
    'REKNOWN MANAGEMENT SERVICES PRIVATE LIMITED',
    'TRIUNE HUMANE FOUNDATION',
    'GAUGE SQUAD (OPC) PRIVATE LIMITED',
    'SOFTWARE MATHEMATICS PRIVATE LIMITED (OPC)',
    'Ally-eXecutive Human Resource Consulting Partner OPC Private Limited',
    'Katalyze Finesse OPC Private Limited',
    'TRANSPARENT OVERSEAS LIMITED',
    'INFRALOG EVENTS PRIVATE LIMITED',
    'WYWID ZONE PRIVATE LIMITED',
    'KYI TECHNOSOLUTIONS PRIVATE LIMITED',
    'Renascent Infotech Private Limited',
    'BIZBROLLY SOLUTIONS PRIVATE LIMITED',
    'PRIMA FELICITAS PRIVATE LIMITED',
    'Vision Techzone Private Limited',
    'KRAMER RESEARCH AND DEVELOPMENT INDIA PRIVATE LIMITED',
    'ECOMART EXPORTS PRIVATE LIMITED',
    'VIRAJ CNG SERVICES PRIVATE LIMITED',
    'GARG CONSULTANCY & COMPLIANCE SERVICES PRIVATE LIMITED',
    'SEAMTEK INTERNATIONAL PRIVATE LIMITED',
    'INFINEON ENERGY CONSULTING PRIVATE LIMITED',
    'MARKET MONKEY SOLUTIONS PRIVATE LIMITED',
    'BHADRAKALI SECURITY & DETECTIVES INDIA PRIVATE LIMITED',
    'GENUS HEALTHCARE SOLUTION AND IT CONSULTING PRIVATE LIMITED',
    'XENIUS ENERGY SOLUTIONS PRIVATE LIMITED',
    'SKILLS AND YOU CONSULTANTS PRIVATE LIMITED',
    'HELVETICA ADVERTISING PRIVATE LIMITED',
    'AKGEC SKILLS FOUNDATION',
    'ULTERIOR VISION PRODUCTION PRIVATE LIMITED (OPC)',
    'SAGOON INDIA PRIVATE LIMITED',
    'GVV PACKAGING PRODUCTS PRIVATE LIMITED',
    'HALLWAZE CONNECTION INDIA PRIVATE LIMITED',
    'Diligent Spy Agency Services Private Limited',
    'TELISPIRE CALL TECH PRIVATE LIMITED',
    'KPMC Consultancy Private Limited',
    'Adroit Synergies Private Limited',
    'CREATIVESQUAD INTERNET SERVICES PRIVATE LIMITED',
    'ADZ2LEAD MEDIA PRIVATE LIMITED',
    'SAATHI CARE & NURSING PRIVATE LIMITED',
    'DD CORP PRIVATE LIMITED',
    'CLEAN & SECURE MANAGEMENT CONSULTANCY SERVICES PRIVATE LIMITED',
    'JYOTIKIRAN BIJEYPUR ENERGY PRIVATE LIMITED',
    'JYOTIKIRAN CHANDELI ENERGY PRIVATE LIMITED',
    'JYOTIKIRAN MAIDAWALI ENERGY PRIVATE LIMITED',
    'SEVEN BUCKS IRRIGATION DESIGN SERVICES PRIVATE LIMITED',
    'VIPRA BUSINESS CONSULTING SERVICES PRIVATE LIMITED',
    'C-EXMART TECHNOLOGY PRIVATE LIMITED',
    'PROTO DEVELOPMENT SERVICES PRIVATE LIMITED',
    'LIVE GREEN ECO WORKS PRIVATE LIMITED',
    'AON ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'VIKALP SOLUTIONS PRIVATE LIMITED',
    'HSCPL VENTURES PRIVATE LIMITED',
    'INDIA DOCUMENT SOLUTIONS PRIVATE LIMITED',
    'VISION INDIA SERVICES PRIVATE LIMITED',
    'REVA HR CONSULTANCY PRIVATE LIMITED',
    'Compendious Consulting Private Limited',
    'VS KERAMIC INFRASTRUCTURE PRIVATE LIMITED',
    'ASSOMACH SALES PRIVATE LIMITED',
    'SHARE INDIA COMMODITY BROKERS PRIVATE LIMITED',
    'BRILLTECH ENGINEERS PRIVATE LIMITED',
    'MODUS ADVERTISING WORKS PRIVATE LIMITED',
    'TELSPIEL COMMUNICATIONS PRIVATE LIMITED',
    'T. C. HEALTH CARE PRIVATE LIMITED',
    'JUBILANT SECURITIES PRIVATE LIMITED',
    'INDIAN COUNTRY HOMES PRIVATE LIMITED',
    'JUBILANT CAPITAL PRIVATE LIMITED',
    'VARANIUM CAPITAL ADVISORS PRIVATE LIMITED',
    'ENPRO EXPORTS PRIVATE LIMITED',
    'ENVECON GLOBAL SOLUTIONS PRIVATE LIMITED',
    'TOWER PROMOTERS PRIVATE LIMITED',
    'INFRASTRUCTURE INDUSTRY AND LOGISTICS FEDERATION OF INDIA.',
    'NetProphets Technologies Private Limited',
    'DURGA FARM DEVELOPERS PRIVATE LIMITED',
    'CREATIVE AGRI LAND DEVELOPERS PRIVATE LIMITED',
    'Jubilant DraxImage Limited',
    'XED MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'PASSION COMMODITIES PRIVATE LIMITED',
    'AL YUSUF FOOD PRODUCTS PRIVATE LIMITED',
    'Aristocrat Technologies India Private Limited',
    'SPHINX DESIGN AND ENGINEERING SERVICES PRIVATE LIMITED',
    'API TECHNICAL SERVICES (INDIA) PRIVATE LIMITED',
    'ADVANCED BUSINESS INTELLIGENCE AND ANALYTICS PRIVATE LIMITED',
    'CARGOTECH LOGISTICS PRIVATE LIMITED',
    'ALL WORLD MOVERS LOGISTICS PRIVATE LIMITED',
    'ARGUS FREIGHT MANAGEMENT PRIVATE LIMITED',
    'SAIASTHA EXIM CARGO PRIVATE LIMITED',
    'SWAMY LOGISTICS PRIVATE LIMITED',
    'EBIX CABS PRIVATE LIMITED',
    'VIJAY INFOSYS PRIVATE LIMITED',
    'ANIL AGGARWAL FINSTOCK COMPANY PRIVATE LIMITED',
    'LORETO TRADING AND FINANCE COMPANY Private Limited',
    'INVEST INDIA ECONOMIC FOUNDATION PRIVATE LIMITED',
    'YUG INTERNATIONAL PRIVATE LIMITED',
    'SRGP CORPORATION LIMITED',
    'HARI KRISHAN PROPERTIES LIMITED',
    'HEXCEL INVESTMENT SERVICES PRIVATE LIMITED',
    'MACRO LEASING AND FINANCE PRIVATE LIMITED',
    'KGS FINANCE AND LEASING PRIVATE LIMITED',
    'MSA INVESTMENT AND TRADING COMPANY PRIVATE LIMITED',
    'TRENDZ MERCANTILES PRIVATE LIMITED',
    'ARREMM HOLDINGS PRIVATE LIMITED',
    'SAMVEDI FINVEST LEASE PRIVATE LIMITED',
    'Namaste India Microfinance Private Limited',
    'MSF INVESTMENTS PRIVATE LIMITED',
    'ANSHITA HOLDINGS PRIVATE LIMITED',
    'AKC FINSERV PRIVATE LIMITED',
    'KESHAV FINCON LIMITED',
    'VICHITRA HOLDINGS PRIVATE LIMITED',
    'SOBHAN HOLDINGS PRIVATE LIMITED',
    'CANDC STOCK BROCKERS PRIVATE LIMITED',
    'MILKYWAY MERCANTILES PRIVATE LIMITED',
    'ALOK LEASINGS PRIVATE LIMITED',
    'UDBHAV FINANCE AND INVESTMENT COMPANY PRIVATE LIMITED',
    'MULTI STOCK BROKING PRIVATE LIMITED',
    'HINDUSTAN INSURANCE BROKERS LIMITED',
    'JAGRAN MEDIA NETWORK INVESTMENT PRIVATE LIMITED',
    'SAUMYA REAL ESTATES PRIVATE LIMITED',
    'V.K. SINGHANIA AND COMPANY PRIVATE LIMITED',
    'CORPORATE CONSULTANTS PRIVATE LIMITED',
    'TREADSTONE INDIA PRIVATE LIMITED',
    'EATO FISH PRIVATE LIMITED',
    'SRI GIRDHAR INVESTMENTS AND SHARES PRIVATE LIMITED',
    'VNS FINANCE AND CAPITAL SERVICES LIMITED',
    'MAHAVIR SPINFAB PRIVATE LIMITED',
    'RADIUM FINANCIAL SERVICES PRIVATE LIMITED',
    'CHUKNOO SECURITIES LIMITED',
    'BANSAL SHAREVEST SERVICES LIMITED',
    'JV STOCK BROKING PRIVATE LIMITED',
    'C R KOTHARI AND SONS SHARES AND STOCK BROKERS PRIVATE LIMITED',
    'SIDDHI SHARES PRIVATE LIMITED',
    'C.R. KOTHARI AND SONS STOCK BROKING PRIVATE LIMITED',
    'DMK HOLDINGS PRIVATE LIMITED',
    'S.J. TRADING COMPANY PRIVATE LIMITED',
    'SKUNG TRADELINK LIMITED',
    'SKUNG COMMXPERTS LIMITED',
    'ACHINTYA COMMODITIES PRIVATE LIMITED',
    'M.G. INFRAESTATES PRIVATE LIMITED',
    'SHERU BUILDER PRIVATE LIMITED',
    'ANANDESHWARKRIPA INFRAPROJECTS PRIVATE LIMITED',
    'MIDLAND INFRABUILD ZONE PRIVATE LIMITED',
    'VPI INFRA PRIVATE LIMITED',
    'DEEP REAL ESTATES PRIVATE LIMITED',
    'S V MEGA LIMITED',
    'SPFL REAL ESTATE PRIVATE LIMITED',
    'DPK ESTATES LIMITED',
    'KUNDAN CASTINGS PRIVATE LIMITED',
    'I. G. ESTATES PRIVATE LIMITED',
    'KLPR-B REALTIES PRIVATE LIMITED',
    'RAVE REAL ESTATE PRIVATE LIMITED',
    'ARPITA INFRA ESTATES PRIVATE LIMITED',
    'GDS INFRASTRUCTURES PRIVATE LIMITED',
    'ALGORITHM AVENUE PRIVATE LIMITED',
    'MCGILL FOODS PRIVATE LIMITED',
    'CLOUDWAPP TECHNOLOGIES PRIVATE LIMITED',
    'VALUEMAP TECHNOLOGIES PRIVATE LIMITED',
    'DEV CYBERNETIC PRIVATE LIMITED',
    'MERAKI ATTIRES PRIVATE LIMITED',
    'LIKPIN HOLDING INDIA PRIVATE LIMITED',
    'SUPG SOFTWARE PRIVATE LIMITED',
    'ANISHA POWER PROJECTS PRIVATE LIMITED',
    'FC SOFTWARE PRIVATE LIMITED',
    'ATIVA REAL ESTATE DEVELOPERS PRIVATE LIMITED',
    'VEDICOLOGY VENTURES PRIVATE LIMITED',
    'ARTERRA GLOBAL ENTERPRISE (OPC) PRIVATE LIMITED',
    'DLITHE CONSULTANCY SERVICES PRIVATE LIMITED',
    'PERINTO CREATIONS PRIVATE LIMITED',
    'REVOH INNOVATIONS PRIVATE LIMITED',
    'SPACELABS INTERIOR PRIVATE LIMITED',
    'LUMINARY LIFESTYLE PRIVATE LIMITED',
    'MMS SHIP MANAGEMENT (INDIA ) PRIVATE LIMITED',
    'SH SANA ENTERPRISES PRIVATE LIMITED',
    'TKPO SERVICES PRIVATE LIMITED',
    'NAVITASYS INDIA PRIVATE LIMITED',
    'INNAUMATION MEDICAL DEVICES PRIVATE LIMITED',
    'ALPHAWARE ADVISORY SERVICES PRIVATE LIMITED',
    'AYANA RENEWABLE POWER ONE PRIVATE LIMITED',
    'QUAMPETENCE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SGGG INDIA PRIVATE LIMITED',
    'PROREMAX IT SOFTWARE SERVICES (OPC) PRIVATE LIMITED',
    'CENTRIK SPORTIAZ FOUNDATION',
    'ARRZION DATA SYSTEMS PRIVATE LIMITED',
    'YONGNAM ENGINEERING INDIA PRIVATE LIMITED',
    'MATTSENKUMAR CYBER SERVICES PRIVATE LIMITED',
    'SUCCESS FINSERVE PRIVATE LIMITED',
    'ARMSPRIME MEDIA PRIVATE LIMITED',
    'DARKHORSE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AGILESKILL TALENT DEVELOPMENT AND EMPOWERMENT FOUNDATION',
    'R2MI RETAIL PRIVATE LIMITED',
    'AVR OIL AND GAS PRIVATE LIMITED',
    'HOTCLOUD EVENTVIBES PRIVATE LIMITED',
    'YESMARK PROJECTS PRIVATE LIMITED',
    'MADPACKERS HOSTELS PRIVATE LIMITED',
    'SWEEBON INDIA PRIVATE LIMITED',
    'BUSY LION PRIVATE LIMITED',
    'XPARTS LASER SOLUTIONS PRIVATE LIMITED',
    'MAXLITE AAC BLOCKS (INDIA) PRIVATE LIMITED',
    'MAIDEK MATERIAL TECH PRIVATE LIMITED',
    'CHITTAPUR KALANJIAM JEEVIDHAM PRODUCER COMPANY LIMITED',
    'SPECMED LIFE SCIENCES PRIVATE LIMITED',
    'APIGATE INDIA SERVICES PRIVATE LIMITED',
    'MEDLINE HEALTHCARE INDUSTRIES PRIVATE LIMITED',
    'URPAN IT PRIVATE LIMITED',
    'RAISUNSOFT SOLUTIONS PRIVATE LIMITED',
    'XYLOPIA LABS PRIVATE LIMITED',
    'JASCAPE CONSULTANTS (OPC) PRIVATE LIMITED',
    '718 VERSAILLES DESIGN STUDIO PRIVATE LIMITED',
    'ROHAN RESIDENCY PRIVATE LIMITED',
    'RADIXLINK INDIA PRIVATE LIMITED',
    'ALLCARGO TERMINALS LIMITED',
    'PARLE FREUND MACHINERY PRIVATE LIMITED',
    'GANGOTRI FRAGRANCES PRIVATE LIMITED',
    'CREDRIGHT FINANCE PRIVATE LIMITED',
    'GUTURI PACKING PRIVATE LIMITED',
    'SIL SAFEWAY INDIA LOGISTICS PRIVATE LIMITED',
    'BDCINFO PRIVATE LIMITED',
    'KSRA HEALTHCARE PRIVATE LIMITED',
    'QATAR AVIATION SERVICES INDIA PRIVATE LIMITED',
    'WESDIAN INDUSTRIES PRIVATE LIMITED',
    'QUAKE SAFE TECHNOLOGIES PRIVATE LIMITED',
    'ONTAMO ENTERTAINMENT PRIVATE LIMITED',
    'LIQUID PAYMENTS (INDIA) PRIVATE LIMITED',
    'DRAVIDIAN INFOTECH (OPC) PRIVATE LIMITED',
    'VIJAYA FASHIONS PRIVATE LIMITED',
    'THINK BIG SOLUTIONS TEAM INDIA PRIVATE LIMITED',
    'METROID ENGINEERS PRIVATE LIMITED',
    'PETRICHOR LEISURE AND RECREATION PRIVATELIMITED',
    'NELLSYS TECHNOLOGIES PRIVATE LIMITED',
    'KWANGSUNG SANDHAR TECHNOLOGIES PRIVATE LIMITED',
    'MIND SPIRIT DESIGNS & WORKS PRIVATE LIMITED',
    'V3 PLASTOTECH PRIVATE LIMITED',
    'ROHAN WAREHOUSING PRIVATE LIMITED',
    'CDW INDIA IT SOLUTIONS PRIVATE LIMITED',
    'CAPSOL SUNRAY PRIVATE LIMITED',
    'CLOUDMYNDS TECHNOLOGY PRIVATE LIMITED',
    'MYYOGATEACHER INDIA PRIVATE LIMITED',
    'OUTSCAL TECHNOLOGIES PRIVATE LIMITED',
    'MEDILIGHT EDUCATION PRIVATE LIMITED',
    'SSG AUTOMOTIVE COMPONENTS PRIVATE LIMITED',
    'WURFEL LIVING PRIVATE LIMITED',
    'LOOP AGTECH PRIVATE LIMITED',
    'FAIR STUDY AND SETTLE ABROAD SERVICES PRIVATE LIMITED',
    'HYTECH ACR PRIVATE LIMITED',
    'TRUE BASE PRIVATE LIMITED',
    'SOPA COGNITIVE ANALYTICS PRIVATE LIMITED',
    'STRATITUDE MANAGEMENT CONSULTING PRIVATELIMITED',
    'FRISCHEMIE SPECIALITY PERFORMANCE MATERIALS PRIVATE LIMITED',
    'MASS ENGITECH TRADING INDIA PRIVATE LIMITED',
    'FOUR KEYS CREATIVE DEVELOPMENT PRIVATE LIMITED',
    'IYGREE CONSULTING SERVICES PRIVATE LIMITED',
    'DIVVIT AND DEVAJ PRIVATE LIMITED',
    'ARSHIYA DATA CENTRE PRIVATE LIMITED',
    'ERNIESYS TECHNOLOGIES PRIVATE LIMITED',
    'INFLEXION INFOTECH PRIVATE LIMITED',
    'ESRI R&D CENTER INDIA PRIVATE LIMITED',
    'UBIFLY TECHNOLOGIES PRIVATE LIMITED',
    'SUREAMPLE EDUTECH PRIVATE LIMITED',
    'ATV TALKVION PRIVATE LIMITED',
    'QUIDEL DIAGNOSTICS INDIA PRIVATE LIMITED',
    'COSMOFEED TECHNOLOGIES PRIVATE LIMITED',
    'SALESKEN TECHNOLOGIES PRIVATE LIMITED',
    'QUATRO YASHIMA PRIVATE LIMITED',
    'FRUGALIS BIOPRODUCTS PRIVATE LIMITED',
    'TBKK HELP FOUNDATION',
    'KAJMAHAL INFOSERV PRIVATE LIMITED',
    'MIKU POLYMERS & PLASTICS LIMITED',
    'GSP EDUCATION SERVICES PRIVATE LIMITED',
    'SEYON LOGISTICS PRIVATE LIMITED',
    'SUGARH REALTORS PRIVATE LIMITED',
    'ALE DENT PRIVATE LIMITED',
    'QUESTEL IP SERVICES INDIA PRIVATE LIMITED',
    'SOLARSTREAM RENEWABLE SERVICES PRIVATE LIMITED',
    'CBSCRIBES BRANDING SERVICES PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING FOUR LIMITED',
    'PEARL PRECISION PRODUCTS PRIVATE LIMITED',
    'UNIGATE FORWARDING INDIA PRIVATE LIMITED',
    'TRIPLE LINE SHIPPING PRIVATE LIMITED',
    'TORUS ORO PORTFOLIO MANAGEMENT PRIVATE LIMITED',
    'FIBRANIUM PRODUCTS PRIVATE LIMITED',
    'LOHIA AEROSPACE SYSTEMS PRIVATE LIMITED',
    'TRAVOCATIONS AND MICE SOLUTIONS PRIVATE LIMITED',
    'SANDVIK MINING AND ROCK TECHNOLOGY INDIAPRIVATE LIMITED',
    'BIOCONNEXUS INDIA PRIVATE LIMITED',
    'NXTBILLION COMMERCE PRIVATE LIMITED',
    'ADVANCED TRENDS INDIA PRIVATE LIMITED',
    'OCEANUS TRANSPORTS PRIVATE LIMITED',
    'NEITHER PUBLICATIONS PRIVATE LIMITED',
    'NOBLEMEDS AND SURGICALS PRIVATE LIMITED',
    'CARDBYTE AI PRIVATE LIMITED',
    'VISIONFORCE PRIVATE LIMITED',
    'SCALETEAM TECHNOLOGIES PRIVATE LIMITED',
    'GENUINE ENVICARE PRIVATE LIMITED',
    'INCRED ASSET MANAGEMENT PRIVATE LIMITED',
    'IRIS IMPULSE INDIA PRIVATE LIMITED',
    'EKENNIS SOFTWARE SERVICE LIMITED',
    'TIRUPATI SPRINKLERS PRIVATE LIMITED',
    'MOVIAM TECHNOLOGIES PRIVATE LIMITED',
    'RETAILINSIGHTS NEWGEN CONSULTANCY SERVICES PRIVATE LIMITED',
    'NOVAMODULE INDIA PRIVATE LIMITED',
    'ROLTAMAX ENGINERING PRIVATE LIMITED',
    'QS CONSULTANTS AND ENGINEERS INDIA PRIVATE LIMITED',
    'BUBBLEFINE POLYPACK PRIVATE LIMITED',
    'ATTAPETTA GLOBAL PRIVATE LIMITED',
    'CFORCAT LEARNING PRIVATE LIMITED',
    'MANVI-ABM ELEVATORS PRIVATE LIMITED',
    'SPACEKAWA EXPLORATIONS PRIVATE LIMITED',
    'JUNIPER GREEN SIGMA PRIVATE LIMITED',
    'MOWO SOCIAL INITIATIVES FOUNDATION',
    'KARNATAKA BRAHMIN DEVELOPMENT BOARD',
    'APPLIED SYNERGY TECHNOLOGIES PRIVATE LIMITED',
    'TUOLUMNE TECHNOLOGY PRIVATE LIMITED',
    'ARTIGENZE SOLUTIONS PRIVATE LIMITED',
    'CHALAGARA MEDIA & SMAYA ENTERTAINMENT PRIVATE LIMITED',
    'SHERATOVE NIRMAN PRIVATE LIMITED',
    'INJALA PRIVATE LIMITED',
    'OTOPARK TECHNOLOGICAL SERVICES PRIVATE LIMITED',
    'LEGACY WAREHOUSE AND LOGISTICS PRIVATE LIMITED',
    'CYCLITICS DIGITAL PRIVATE LIMITED',
    'EFAN GOLD PRIVATE LIMITED',
    'E2G ENGINEERING SERVICES PRIVATE LIMITED',
    'LETSTECH SOFTWARES PRIVATE LIMITED',
    'NAYAR HARVEST VENTURE FIELDS PRIVATE LIMITED',
    'CONVENE INDIA PRIVATE LIMITED',
    'FILITE CONNECTRONICS PRIVATE LIMITED',
    'HELIX SENSE TECHNOLOGIES PRIVATE LIMITED',
    'HFIL TECHNOLOGIES PRIVATE LIMITED',
    'INFINITE BLUE INDIA PRIVATE LIMITED',
    'PEMAC PROJECTS PRIVATE LIMITED',
    'MYA SOLAR SYSTEMS PRIVATE LIMITED',
    'IPACCT SUPPORT PRIVATE LIMITED',
    'AYLA NETWORKS (INDIA) PRIVATE LIMITED',
    'INDMAN MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'DOCUBAY MEDIA PRIVATE LIMITED',
    'UA AGRO SOLUTIONS PRIVATE LIMITED',
    'AMCKO TECHPRO PRIVATE LIMITED',
    'HUDSON RPO (INDIA) PRIVATE LIMITED',
    'MANVIK FOODS PRIVATE LIMITED',
    'ENERCARE SOLUTIONS PRIVATE LIMITED',
    'HEALTHY BARN PRIVATE LIMITED',
    'INGEX FOODS PRIVATE LIMITED',
    'LAKLAR BROTHERSS INDIA PRIVATE LIMITED',
    'SACANB OFFSHORE PRIVATE LIMITED',
    'SHIVALI BOUTIQUE PRIVATE LIMITED',
    'WHEEL A TRADERS INDIA PRIVATE LIMITED',
    'MO DESIGNS PRIVATE LIMITED',
    'HRK MEDIA PRIVATE LIMITED',
    'SANTEIN ENGINEERING & EQUIPMENT PRIVATE LIMITED',
    'SAYNIT BUSINESS SERVICES PRIVATE LIMITED',
    'FAMPAY SOLUTIONS PRIVATE LIMITED',
    'INNCIRCLES TECHNOLOGIES PRIVATE LIMITED',
    'AMOOGHA ANIMATIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'INFINITEE INDIA NATURALS AND SYNTHETICS PRIVATE LIMITED',
    'RKSB INFRA FACILITIES PRIVATE LIMITED',
    'LUSTER SPECIALITY PAPERS PRIVATE LIMITED',
    'JASPAL INTERNATIONAL FASHIONS PRIVATE LIMITED',
    'SUNBRIGHT SOLAR POWER TECH PRIVATE LIMITED',
    'APPV SOFTWARE INDIA PRIVATE LIMITED',
    'VANDESATPURA INFOSYSTEMS (OPC) PRIVATE LIMITED',
    'POTUS INDIA PRIVATE LIMITED',
    'HEALTHEDGE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'COFFEE DAY ECON PRIVATE LIMITED',
    'DHAKSHA UNMANNED SYSTEMS PRIVATE LIMITED',
    'ARGITECH ENGINEERING PRIVATE LIMITED',
    'ADZ VALUE SERVICE PRIVATE LIMITED',
    'YESVENTIVE IT LABS PRIVATE LIMITED',
    'COFFEE DAY CONSULTANCY SERVICES PRIVATE LIMITED',
    'BALAJI GYPSUM PRIVATE LIMITED',
    'SHWETPUSHP BUSINESS SERVICES PRIVATE LIMITED',
    'GIRNAR FINSERV PRIVATE LIMITED',
    'JORBISH PRIVATE LIMITED',
    'INDIAN INSTITUTE OF SKILL DEVELOPMENT FOUNDATION',
    'ODIN SYSTEM PRIVATE LIMITED',
    'JANIKIN ROOKE CONTRACTS PRIVATE LIMITED',
    'NOVORISE FINTECH INDIA PRIVATE LIMITED',
    'AVALANCE TECHNOLOGY PRIVATE LIMITED',
    'AAPAI TECHNOLOGIES LIMITED',
    'SPARKMAGIC EXPERIENCES PRIVATE LIMITED',
    'TRAINERSEDGE CONSULTANTS PRIVATE LIMITED',
    'VIEWSMART APP MASTERY PRIVATE LIMITED',
    'TOURISOFT INDIA PRIVATE LIMITED',
    'DOUBLE8 EVENT AND ADVERTISING PRIVATE LIMITED',
    'MONTECARLO SINNAR SHIRDI HIGHWAY PRIVATELIMITED',
    'PQE INDIA PRIVATE LIMITED',
    'COGNEXT ANALYTICS PRIVATE LIMITED',
    'DATASEERS TECHNOLOGIES PRIVATE LIMITED',
    'CHITKI RETAILS PRIVATE LIMITED',
    'SHARMA PEB STEEL STRUCTURES PRIVATE LIMITED',
    'ALTR (INDIA) PRIVATE LIMITED',
    'INTELLISCEND NDDR PRIVATE LIMITED',
    'JAI AMBE TRANSMOVERS PRIVATE LIMITED',
    'TECHTEAM AI SOLUTIONS PRIVATE LIMITED',
    'GRAVTON MOTORS PRIVATE LIMITED',
    'SUNSHINE POWER SOLUTION PRIVATE LIMITED',
    'ANZEN MOTOR CAR INDIA PRIVATE LIMITED',
    'POLYRAM PLASTICS INDIA PRIVATE LIMITED',
    'DIGINNOVATORS SOLUTIONS PRIVATE LIMITED',
    'TROONDX TECHNOLOGIES PRIVATE LIMITED',
    'MABELS CLINIC PRIVATE LIMITED',
    'GIGBIG SOLUTIONS PRIVATE LIMITED',
    'FEEDBACK ADVISORY SERVICES PRIVATE LIMITED',
    'MIRACLEHEALTH SYSTEMS PRIVATE LIMITED',
    'SIRENA LABS PRIVATE LIMITED',
    'ENMAZ EDUCATION SERVICES PRIVATE LIMITED',
    'NEWTOMECH INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'INDOSWORLD EXIM INDIA PRIVATE LIMITED',
    'MAHINDRA FINANCE CSR FOUNDATION',
    'SPACEDRAFT INDIA PRIVATE LIMITED',
    'NOVELWORX DIGITAL SOLUTIONS PRIVATE LIMITED',
    'AV ADVANCED VISION SYSTEMS PRIVATE LIMITED',
    'ROCCITI ENGINEERING SERVICES PRIVATE LIMITED',
    'GOODFARMS PANCHGAVYA PRIVATE LIMITED',
    'FRUITBAE FOOD PRODUCTS PRIVATE LIMITED',
    'QAPITALARK DEVELOPERS PRIVATE LIMITED',
    'BHATIA SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'UVO LOGIC PRIVATE LIMITED',
    'SAVITRU VENTURES PRIVATE LIMITED',
    'DIGI TRAVEL SOLUTIONS PRIVATE LIMITED',
    'FITSPORT NUTRITION FOODS PRIVATE LIMITED',
    'TRANSDRIVE SOLUTIONS PRIVATE LIMITED',
    'CAPITALAND HOPE FOUNDATION (INDIA)',
    'CYPERUS BIOGENICS PRIVATE LIMITED',
    'BANWET INDUSTRIES PRIVATE LIMITED',
    'ZENSCALE TECHNOLOGIES PRIVATE LIMITED',
    'TRANSPOST TECHNOLOGIES PRIVATE LIMITED',
    'CELLESTIAL E-MOBILITY PRIVATE LIMITED',
    'NILE GLOBAL INDIA PRIVATE LIMITED',
    'SHAYZER INTERNATIONAL PRIVATE LIMITED',
    'RLDH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'KRISHIACHARYA TECHNOLOGIES PRIVATE LIMITED',
    'LASIN PLASTICS AND METALS INDIA PRIVATE LIMITED',
    'ZENLIKE YOGA FARMS PRIVATE LIMITED',
    'GENPRODIGY TALENT CONSULTANCY PRIVATE LIMITED',
    'BRIKMART INDIA PRIVATE LIMITED',
    'SJJS PROJECTS PRIVATE LIMITED',
    'MERON SCIENTIFIC PRIVATE LIMITED',
    'INNOVATION & SOLUTIONS LAB INDIA PRIVATELIMITED',
    'SAFEPAAS PRODUCT LABS INDIA PRIVATE LIMITED',
    'NIDHISHA TECHNOLOGIES PRIVATE LIMITED',
    'TAGWRIGHT TECHNOLOGIES PRIVATE LIMITED',
    'ASSUREKIT TECHNOLOGY AND SERVICES PRIVATE LIMITED',
    'SEMON ENGG INDUSTRIES PRIVATE LIMITED',
    'NEWBREED SOLUTIONS PRIVATE LIMITED',
    'ONEMAGNIFY INDIA PRIVATE LIMITED',
    'GCIL ENTERPRISES PRIVATE LIMITED',
    'NOVUS WORKRITES PRIVATE LIMITED',
    'CHETHANA PHARMA PRIVATE LIMITED',
    'KGI REALTY PRIVATE LIMITED',
    'MANCHERIAL REPALLEWADA ROAD PRIVATE LIMITED',
    'NORTHERN SOLVENTS PRIVATE LIMITED',
    'FOKAL ANALYTICS PRIVATE LIMITED',
    'TRANO VENTURE PRIVATE LIMITED',
    'ADDING SMILES PRIVATE LIMITED',
    'IZA MEDI TECHNOLOGIES PRIVATE LIMITED',
    'STACKTRAIL CASH AND CARRY PRIVATE LIMITED',
    'REDIUS INFOSECURITY PRIVATE LIMITED',
    'KBSS ENTERPRISES PRIVATE LIMITED',
    'CIBELES PHARMACEUTICALS PRIVATE LIMITED',
    'CLANBRIDGE LIVING PRIVATE LIMITED',
    'CROWDPOUCH MARKETING SERVICES PRIVATE LIMITED',
    '7CLICK BPO PRIVATE LIMITED',
    'VIKRAMADITYA RENEWABLE ENERGY PRIVATE LIMITED',
    'GAMMEL MUNK PRIVATE LIMITED',
    'RRJAIN CONSULTANTS PRIVATE LIMITED',
    'VINSUM AXPRESS INDIA PRIVATE LIMITED',
    'SREENIJA TECHNOLOGY AND SERVICES PRIVATELIMITED',
    'ARISTOLITE DESIGNS PRIVATE LIMITED',
    'AAROHAN BRANDS & MERCHANDISING SOLUTIONSPRIVATE LIMITED',
    'TJ DHARAM GLOBAL FOODS PRIVATE LIMITED',
    'DIGITOS TECHNOLOGIES PRIVATE LIMITED',
    'SWAN SEDA GLOBAL PRIVATE LIMITED',
    'TEAM ONE ARTEQ PRIVATE LIMITED',
    'IMAGINEST TECHNOLOGIES PRIVATE LIMITED',
    'CEYMOX TECHNOLOGIES PRIVATE LIMITED',
    'TRADEBRISK EXPORT VENTURE PRIVATE LIMITED',
    'THOUGHTWIN IT SOLUTIONS PRIVATE LIMITED',
    'UMAKO PACKAGING PRIVATE LIMITED',
    'EKHOJ ENTERPRISES PRIVATE LIMITED',
    'WHARF STREET STRATEGIES PRIVATE LIMITED',
    'F4K ANALYTICS AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GYPA MEDIA PRIVATE LIMITED',
    'GAYATHRI VEDIC SERVICES PRIVATE LIMITED',
    'ADDRESS MAKER PROPERTY DEVELOPERS PRIVATE LIMITED',
    'DESIGNA INDIA PRIVATE LIMITED',
    'PRETEC UNDERGROUND PRIVATE LIMITED',
    'SYNERGY ALLOYS AND WEAR SOLUTIONS PRIVATE LIMITED',
    'HIFIMAN ELECTRONICS INDIA PRIVATE LIMITED',
    'HITACHI AUTOMATION INDIA PRIVATE LIMITED',
    'ELICO MECHOPTRONIX PRIVATE LIMITED',
    'DRJ RECORDS INDUSTRIES PRIVATE LIMITED',
    'DIOS CASA FLOORING PRIVATE LIMITED',
    'APNATIME TECH PRIVATE LIMITED',
    'AASTARURMIKA HEALTH SYSTEMS',
    'ROWWET MOBILITY PRIVATE LIMITED',
    'AHN HOTEL AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'JACKINTHEBOX TOYS PRIVATE LIMITED',
    'IN-COUNTRY LOGISTICS PRIVATE LIMITED',
    'MAXVOLT ENERGY INDUSTRIES PRIVATE LIMITED',
    'DHALITE MANAGEMENT SERVICES PRIVATE LIMITED',
    'HITACHI ENERGY TECHNOLOGY SERVICES PRIVATE LIMITED',
    'OC SPECIALITIES CHEMICALS PRIVATE LIMITED',
    'JOBBOX TECHNOLOGIES PRIVATE LIMITED',
    'UNIFIED FORMWORK SYSTEMS PRIVATE LIMITED',
    'PACKAPEER ACADEMY PRIVATE LIMITED',
    'SANMARG ENGINEERING VALIDATION AND ASSESSMENT PRIVATE LIMITED',
    'NYMBLEUP SOLUTIONS PRIVATE LIMITED',
    'SAPTHASATHI CONSULTATION PRIVATE LIMITED',
    'PREBO AUTOMOTIVE PRIVATE LIMITED',
    'AIRBASE LABS INDIA PRIVATE LIMITED',
    'ASHOK DIAMJEWEL PRIVATE LIMITED',
    'ZERONSEC INDIA PRIVATE LIMITED',
    'ORCHER TECH PRIVATE LIMITED',
    'AZULE SOFTWARE PRIVATE LIMITED',
    'MURF SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MATTANIA INFRATECH PRIVATE LIMITED',
    'FLINEX INDIA TECHNOLOGIES PRIVATE LIMITED',
    'SCDE SOLUTIONS PRIVATE LIMITED',
    'ADVANCE INTELLIGENCE TECHNOLOGY INDIA PRIVATE LIMITED',
    'BAYSHORE INTELLIGENCE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SAMVIN GLOBAL CONSULTANCY PRIVATE LIMITED',
    'SZIIAH TECHNOLOGY PRIVATE LIMITED',
    'ONNSA RESEARCH INNOVATIONS PRIVATE LIMITED',
    'BINDEX STATIONERY PRIVATE LIMITED',
    'VERGE MOTORS PRIVATE LIMITED',
    'LR ENERGY PRIVATE LIMITED',
    'ABANI DIGITAL PRIVATE LIMITED',
    'ECHELLE CONSTRUCTIONS PRIVATE LIMITED',
    'YELLOWPEDAL TECHNOLOGIES PRIVATE LIMITED',
    'FASTFORWARD MOBILITY TECH PRIVATE LIMITED',
    'ENTITLED SOLUTIONS PRIVATE LIMITED',
    'CHEMOLEO INDUSTRIES PRIVATE LIMITED',
    'APEKS SOLTEK PRIVATE LIMITED',
    'RIELTA SECURITY INTERNATIONAL PRIVATE LIMITED',
    'LEATHER CEATRA (OPC) PRIVATE LIMITED',
    'SBIZZL TECHNOLOGIES PRIVATE LIMITED',
    'EO CHAPTER 180 FOUNDATION',
    'DIMERSE CREATIVE SOLUTIONS PRIVATE LIMITED',
    'HINIROG HEALTHTECH PRIVATE LIMITED',
    'WHIZZ HR PRIVATE LIMITED',
    'NIYOPAY CREDIT PRIVATE LIMITED',
    'STFT FINANCE PRIVATE LIMITED',
    'KANCHEM PHARMACEUTICALS PRIVATE LIMITED',
    'BERACAH INFOSOLUTIONS PRIVATE LIMITED',
    'ETEX HEALTHCARE PRIVATE LIMITED',
    'HUEZONE SOLUTIONS PRIVATE LIMITED',
    'GRO HEAT EXCHANGERS PRIVATE LIMITED',
    'RAAJ WOODTEK PRIVATE LIMITED',
    'KHARGHAR VIKHROLI TRANSMISSION LIMITED',
    'TECHNOVA RECYCLING INDIA PRIVATE LIMITED',
    'LEGHORNGROUP PRIVATE LIMITED',
    'AGTECHPRO PRIVATE LIMITED',
    'PAHRULI TOURS AND TRAVELS PRIVATE LIMITED',
    'HANSPARK INDUSTRIES PRIVATE LIMITED',
    'PT MECHATRONICS PRIVATE LIMITED',
    'DRONE DESTINATION LIMITED',
    'CHAMPSEARCH PRIVATE LIMITED',
    'SUSTAIN PLUS ENERGY FOUNDATION',
    'AFFNET MARKETING MEDIA PRIVATE LIMITED',
    'HOSA SOLUTIONS PRIVATE LIMITED',
    'FITFARMS FOOD TECH PRIVATE LIMITED',
    'MMF HOSPITALS ASSOCIATION',
    'SPACEGRAPH TECHNOLOGIES PRIVATE LIMITED',
    'TWIMBIT RESEARCH INDIA PRIVATE LIMITED',
    'TAG ASSESSORS GUILD PRIVATE LIMITED',
    'SEMITEC ELECTRONICS INDIA PRIVATE LIMITED',
    'VARA SOLUTION SUPPORT PRIVATE LIMITED',
    'INCLUSIVE NEWS INDIA PRIVATE LIMITED',
    'MANA PHARMA PRIVATE LIMITED',
    'PRO FUTURO CONSULTING INDIA PRIVATE LIMITED',
    '1NETWORK WEBSERVE PRIVATE LIMITED',
    'BIOSOFT HEALTH TECH PRIVATE LIMITED',
    'VANQUEST PHARMA PRIVATE LIMITED',
    'BBE SOLUTIONS INDIA PRIVATE LIMITED',
    'TECHCLOUD DEVELOPMENT SOLUTIONS PRIVATE LIMITED',
    'TORTEK INDIA PRIVATE LIMITED',
    'SWISS NEWATER INDIA PRIVATE LIMITED',
    'SENTENTIA EDUCATIONAL SOLUTION PRIVATE LIMITED',
    'AERO DIGITAL WORLD PRIVATE LIMITED',
    'INTERMAX SERVICES PRIVATE LIMITED',
    'ANTUNES NADI MANUFACTURING INDIA PRIVATELIMITED',
    'AITHER TECHNOLOGY INDIA PRIVATE LIMITED',
    'TRESPECT INDIA PRIVATE LIMITED',
    'APPLE INFOWAY PRIVATE LIMITED',
    'VINAYAK ETAIL SOLUTIONS PRIVATE LIMITED',
    'BLR LOUNGE SERVICES PRIVATE LIMITED',
    'RANEXT TECHNOLOGIES PRIVATE LIMITED',
    'NEXBA HEALTHCARE MARKETING & SERVICES PRIVATE LIMITED',
    'TRIBEVIBE ENTERTAINMENT PRIVATE LIMITED',
    'COMPANIESHOUSE INDIA PRIVATE LIMITED',
    'ROYAL DREAM TO FLY PRIVATE LIMITED',
    'INTERLINK INSURANCE AND REINSURANCE BROKING PRIVATE LIMITED',
    'AWISHION ELECTROMOB SOLUTIONS PRIVATE LIMITED',
    'STUCARE TECHNOLOGIES PRIVATE LIMITED',
    'ILEAD TAX & BUSINESS SERVICES PRIVATE LIMITED',
    'DRAVSTREAM TECHNOLOGIES PRIVATE LIMITED',
    'PIONERO ENVIRO TECTONICS PRIVATE LIMITED',
    'PEARL PORTLINE PRIVATE LIMITED',
    '3R RESEARCH AND TECHNOLOGY PUBLISHING PRIVATE LIMITED',
    'GRAVITTUS BUILDCON PRIVATE LIMITED',
    'SMMUD TECHNOLOGIES PRIVATE LIMITED',
    'KARNATAKA ARYA VYSYA COMMUNITY DEVELOPMENT CORPORATION LIMITED',
    'TRICEPT LIFE SCIENCES PRIVATE LIMITED',
    'DRIVE HOME PRIVATE LIMITED',
    'GRANDIOSE AUTOMATION SOLUTIONS PRIVATE LIMITED',
    'DECIPAY SERVICES PRIVATE LIMITED',
    'ZIIKI MEDIA PRIVATE LIMITED',
    'BAUER ENGINEERING INDIA PRIVATE LIMITED',
    'TANSAN INFRASTRUCTURE PRIVATE LIMITED',
    'JA SOLUTIONS INDIA PRIVATE LIMITED',
    'COMPUTE EDGE WIRELESS INDIA PRIVATE LIMITED',
    'RIDEKEEP AUTO PRIVATE LIMITED',
    'WILMAR SUGAR INDIA PRIVATE LIMITED',
    'MECHCREATIO INDUSTRIAL SOLUTIONS PRIVATELIMITED',
    'INMUTATIO CONSULERE PRIVATE LIMITED',
    'FCR BUSINESS PROCESS MANAGEMENT SERVICESPRIVATE LIMITED',
    'JUST CLICK KARO SERVICES PRIVATE LIMITED',
    'PACIFIC DIGITAL PRIVATE LIMITED',
    'SUNON ELECTRONICS INDIA PRIVATE LIMITED',
    'BHSSYEN SYSTEM PRIVATE LIMITED',
    'CENTRICO-INDIA PRIVATE LIMITED',
    'CLASSMETHOD INDIA PRIVATE LIMITED',
    'APSON MOTOR (INDIA) PRIVATE LIMITED',
    'GREENIP AGRO PRIVATE LIMITED',
    'PRAVAIG DYNAMICS PRIVATE LIMITED',
    'CHAKRAVDHAN TECHNOLOGIES PRIVATE LIMITED',
    'CHEMCONN SOURCING PRIVATE LIMITED',
    'IREU TECH EDUCATION PRIVATE LIMITED',
    'AEGIS RESOLUTION SERVICES PRIVATE LIMITED',
    'ODT INDIA CENTER OF EXCELLENCE PRIVATE LIMITED',
    'PEPAA PRODUCTS PRIVATE LIMITED',
    'TRUSTNRIDE VEHICLES PRIVATE LIMITED',
    'LINDNER INDIA CONSTRUCTION PRIVATE LIMITED',
    'LYKIQ LABS PRIVATE LIMITED',
    'AIDEAS ENGINEERING PRIVATE LIMITED',
    'AVVAD TECHNOLOGIES PRIVATE LIMITED',
    'DIGITAL BLINC TECHNOLOGIES PRIVATE LIMITED',
    'NRTS INSTRUMENT AND ENGINEERING PRIVATE LIMITED',
    'PARAGON TESTING ENTERPRISES INDIA PRIVATE LIMITED',
    'INTEGRE SOLUTIONS PRIVATE LIMITED',
    'BODY CHI ME INDIA PRIVATE LIMITED',
    'IEM HEALTH SCIENCES PRIVATE LIMITED',
    'BLJ INTERNATIONAL SERVICES PRIVATE LIMITED',
    'HAJ TRAVEL AGENTS FEDERATION OF INDIA',
    'EPPINGER TECHNOLOGY ASIA PRIVATE LIMITED',
    'EPIC.ONE LOYALTY SCIENCES PRIVATE LIMITED',
    'RIVOT MOTORS INDIA PRIVATE LIMITED',
    'KNOWLEDGE BRIDGE PRIVATE LIMITED',
    'OAN INDUSTRIES PRIVATE LIMITED',
    'GIGI BENEFITS INDIA PRIVATE LIMITED',
    'SLI SERVICES PRIVATE LIMITED',
    'HOME PLUS FINANCE PRIVATE LIMITED',
    'KOMPASS ACADEMY PRIVATE LIMITED',
    'ACIC ADVISORY PRIVATE LIMITED',
    'MOONLINE EXPRESS CARGO PRIVATE LIMITED',
    'TEDORA TECHNOLOGIES PRIVATE LIMITED',
    'AIRTLS STUDIO PRIVATE LIMITED',
    'MEGOAI SOLUTIONS PRIVATE LIMITED',
    'UNITED FOODLINKS PRIVATE LIMITED',
    'FABDIZ INTERIORS PRIVATE LIMITED',
    'INTOZI TECH PRIVATE LIMITED',
    'THYSSENKRUPP MATERIALS IT SERVICES INDIAPRIVATE LIMITED',
    '6M AVDS SOLUTIONS PRIVATE LIMITED',
    'VSS GLOBAL SUPPORT PRIVATE LIMITED',
    'RNSE-TRONICS PRIVATE LIMITED',
    'OPSLYFT TECHNOLOGIES PRIVATE LIMITED',
    'INTELLEWINGS PRIVATE LIMITED',
    'INVIZ AI SOLUTIONS PRIVATE LIMITED',
    'TILAK TRADERS AND EXPORTERS PRIVATE LIMITED',
    'MULTI-LIVING TECHNOLOGIES PRIVATE LIMITED',
    'GREY JACK EYEWEAR PRIVATE LIMITED',
    'MOMENTA RESOURCING INDIA PRIVATE LIMITED',
    'INFRO TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'ZAPAK GAMES PRIVATE LIMITED',
    'SMITHS INTERCONNECT INDIA PRIVATE LIMITED',
    'PROSOT INDIA PRIVATE LIMITED',
    'SQUENDO INDIA PRIVATE LIMITED',
    'DIGIELEVATE PRIVATE LIMITED',
    'AUDITORIA.AI SOFTWARE PRIVATE LIMITED',
    'C2FO INDIA TECHNOLOGIES PRIVATE LIMITED',
    'EIGHTFOLD AI INDIA PRIVATE LIMITED',
    'REVO VENTURES PRIVATE LIMITED',
    'SIWI EMBEDDED SOLUTIONS PRIVATE LIMITED',
    'MULTIPLEX DRONE PRIVATE LIMITED',
    'TELTURE SOLUTIONS PRIVATE LIMITED',
    'COSMICA TELEMATICS PRIVATE LIMITED',
    'SRA INFORMATION TECHNOLOGY CONSULTANTS PRIVATE LIMITED',
    'JUKSHIO TECHNOLOGY INNOVATION PRIVATE LIMITED',
    'WISH AFFAIR PRIVATE LIMITED',
    'SOLIQUE ADVISORY AND SUPPORT SERVICES PRIVATE LIMITED',
    'PRUFENS ADVISORY PRIVATE LIMITED',
    'MACTROL-REFU PRIVATE LIMITED',
    'MINDSARRAY NETWORK PRIVATE LIMITED',
    'LEG GODT INDIA PRIVATE LIMITED',
    'MAAHI SHAMBHALA HOSPITALITY PRIVATE LIMITED',
    'TABLETS MEDOPHARM PRIVATE LIMITED',
    'CLOUDQ IT SERVICES PRIVATE LIMITED',
    'PROPHANDY TECHNOLOGIES PRIVATE LIMITED',
    'SHREE VIGNESH CONSTRUCTION NETWORKING PRIVATE LIMITED',
    'BLACKSTONE COE INDIA PRIVATE LIMITED',
    'MOOOFARM PRIVATE LIMITED',
    'VLSIMONKS DESIGN PRIVATE LIMITED',
    'SEVEN GEOMAX CONSULTING PRIVATE LIMITED',
    'PRACTICESUITE INDIA PRIVATE LIMITED',
    'CHARVIK CORPORATE SERVICES PRIVATE LIMITED',
    'AYIKA INNOVATIE PRIVATE LIMITED',
    'WELLMOVE ELECTRONIC PRIVATE LIMITED',
    'CITYMAX CROSSELL PRIVATE LIMITED',
    'DMODOT RETAIL PRIVATE LIMITED',
    'WEFREIGHT INDIA PRIVATE LIMITED',
    'AGP CITY GAS PRIVATE LIMITED',
    'ZYPMEDIA INDIA PRIVATE LIMITED',
    'ABACOS HEALTH PRIVATE LIMITED',
    'RATHNA EXPORTS AND IMPORTS PRIVATE LIMITED',
    'BIZCON FINTECH LABS PRIVATE LIMITED',
    'MAVERICK TURF TECHNOLOGIES PRIVATE LIMITED',
    'TENSAI TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ALIZ INFOTECH PRIVATE LIMITED',
    'QUICK HITS SOLUTIONS PRIVATE LIMITED',
    'MEDEEZE HEALTHCARE PRIVATE LIMITED',
    'RCRISP SOLUTIONS INDIA PRIVATE LIMITED',
    'PICKRIGHT TECHNOLOGIES PRIVATE LIMITED',
    'KAPHEXIS VENTURES PRIVATE LIMITED',
    'METROPOLIS MEDIA PRIVATE LIMITED',
    'NEAR BAKE SERVICES PRIVATE LIMITED',
    'FIVE WATERS PROMOTIONS PRIVATE LIMITED',
    'OPPORTUNITY LABS INDIA PRIVATE LIMITED',
    'SOCIAL SCRIPT TECHNOLOGIES PRIVATE LIMITED',
    'TRANSCODEX TECHNOLOGIES PRIVATE LIMITED',
    'NARITH BUSINESS SERVICES PRIVATE LIMITED',
    'JIECANG PRIVATE LIMITED',
    'SGM INDIA PRIVATE LIMITED',
    'ALTATECNOLOGIA SOLUTIONS PRIVATE LIMITED',
    'M-KASH INDIA FINANCIAL SOLUTIONS PRIVATELIMITED',
    'CARNEGIE WORLDWIDE SERVICES PRIVATE LIMITED',
    'RT TRICONE FACILITIES MANAGEMENT (OPC) PRIVATE LIMITED',
    'APPALOOSA FOODS PRIVATE LIMITED',
    'CFO BRIDGE SERVICES PRIVATE LIMITED',
    'DIGIFIX INFO TECH PRIVATE LIMITED',
    'RADON INDIA PRIVATE LIMITED',
    'EWAANTECH TECHNOLOGIES PRIVATE LIMITED',
    'VALSTACK INFO PRIVATE LIMITED (OPC)',
    'SRIZON SOLUTIONS PRIVATE LIMITED',
    'CCS SUPPORT INDIA PRIVATE LIMITED',
    'RAASOFT INFOTECH PRIVATE LIMITED',
    'HYPERMINE TECHNOLOGIES PRIVATE LIMITED',
    'MEISTERVERSE PRIVATE LIMITED',
    'HAVISOLUTIONS PRIVATE LIMITED',
    'GOUKIYO EXPERIENCES PRIVATE LIMITED',
    'EVYAPAR SELLERHELP PRIVATE LIMITED',
    'CONSULTVA (OPC) PRIVATE LIMITED',
    'LAVISH MANPOWER SERVICES PRIVATE LIMITED',
    'CAPSULE8 INDIA PRIVATE LIMITED',
    'ODIGOS CUSTOMER SERVICES PRIVATE LIMITED',
    'VERASMART HEALTH CARE PRIVATE LIMITED',
    'JDOT EXPERIENCE PRIVATE LIMITED',
    'MSER VENTURES PRIVATE LIMITED',
    'MANNAG SERVICES PRIVATE LIMITED',
    'FASTINFO LEGAL SERVICES PRIVATE LIMITED',
    'LKB SOLUTIONS PRIVATE LIMITED',
    'ARYABHATA CIRCUITS AND RESEARCH LABS PRIVATE LIMITED',
    'SHREE BALAJI PERFORMANCE CHEMICALS PRIVATE LIMITED',
    'TANAKA AI INDIA PRIVATE LIMITED',
    'AUDIUS INDIA PRIVATE LIMITED',
    'DOWC TECHNOLOGIES PRIVATE LIMITED',
    'CENTRAPATH LABS PRIVATE LIMITED',
    'MOL NIPPON INDIA SHIP MANAGEMENT PRIVATE LIMITED',
    'GOLINTU SERVICES PRIVATE LIMITED',
    'IDEAL E-CASH SOLUTIONS PRIVATE LIMITED',
    'JIELA NETWORK TECHNOLOGY INDIA PRIVATE LIMITED',
    'WAY 2 WEBSOFT TECHNOLOGIES PRIVATE LIMITED',
    'ILP 3 INDIA 2 PRIVATE LIMITED',
    'VP CIVIL TECHNOLOGIES PRIVATE LIMITED',
    'ISMITA LOGISTICS PARK PRIVATE LIMITED',
    'EIDE BAILLY SHARED SERVICES PRIVATE LIMITED',
    'STERLING TECHNICAL SERVICES INDIA PRIVATE LIMITED',
    'CLOOBOT TECHLABS PRIVATE LIMITED',
    'TRIGON INFORMATICS PRIVATE LIMITED',
    'IAIR TECHNOLOGIES PRIVATE LIMITED',
    'ALLOCEAN EDIBLES PRIVATE LIMITED',
    'AZAFRAN VENTURES PRIVATE LIMITED',
    'RHNV INFRA PRIVATE LIMITED',
    'LOG10 EXPRESS LOGISTICS PRIVATE LIMITED',
    'ANURADHA IRON AND STEEL PRIVATE LIMITED',
    'KAMGAR SAFETY INDIA PRIVATE LIMITED',
    'ZILINGO INDIA FINANCIAL SERVICES PRIVATELIMITED',
    'ECOTRIPO TRAVEL PRIVATE LIMITED',
    'PRISM MOBILITY PRIVATE LIMITED',
    'XINDUS TECHNOLOGIES PRIVATE LIMITED',
    'ALLGEN TRADING INTERNATIONAL (OPC) PRIVATE LIMITED',
    'ALC SKICORP PRIVATE LIMITED',
    'GOCHAI BEVERAGES PRIVATE LIMITED',
    'BIGPITCHER GURUGRAM PRIVATE LIMITED',
    'AUCTOR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VIVAJIVA PRIVATE LIMITED',
    'BIGFATPHOENIX INTERACTIVE PRIVATE LIMITED',
    'AMPPULSE ELECTRICALS INDIA PRIVATE LIMITED',
    'AIVA GREEN ENERGY PRIVATE LIMITED',
    'KE ENGINEERS PRIVATE LIMITED',
    'L.b. associates private limited',
    'HUNGER CHOICE LIMITED',
    'PENTA GLOBAL ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED',
    'MADHUVAN ENTERPRISES PRIVATE LIMITED',
    'OMPRIME TECHNOLOGY PRIVATE LIMITED',
    'ATOMEIGHT SYSTEMS PRIVATE LIMITED',
    'YES SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'ARISHNA DATA COMMUNICATION PRIVATE LIMITED',
    'SOFTDOC MANAGEMENT PRIVATE LIMITED',
    'FLIPR INNOVATION LABS PRIVATE LIMITED',
    'DPE TECHNOLOGIES PRIVATE LIMITED',
    'IWG SUPPORT SERVICES PRIVATE LIMITED',
    'KB EXPRESS PRIVATE LIMITED',
    'NRS INTERNATIONAL PRIVATE LIMITED',
    'MARLECHA INDUSTRIES PRIVATE LIMITED',
    'STYMER TECHNOLOGIES PRIVATE LIMITED',
    'ON. DESIGN PRIVATE LIMITED',
    'LUCRO PLASTECYCLE PRIVATE LIMITED',
    'AQUILA SOLAR POWER PRIVATE LIMITED',
    'BRIGHTNIGHT INDIA PRIVATE LIMITED',
    'MATU INTERNATIONAL PRIVATE LIMITED',
    'IGNITIUM SERVICES PRIVATE LIMITED',
    'FINAGG TECHNOLOGIES PRIVATE LIMITED',
    'EARTHY HUES TOURS PRIVATE LIMITED',
    'DA SUSTAINABLE AND SMART ECOSYSTEM PRIVATE LIMITED',
    'PIGEON EDUCATION TECHNOLOGY INDIA PRIVATE LIMITED',
    'A2V INSURANCE BROKERS PRIVATE LIMITED',
    'AMAN CHUGH VENTURES PRIVATE LIMITED',
    'NUDJUR LABS PRIVATE LIMITED',
    'ZELUS NETWORK PRIVATE LIMITED',
    'BT TECHLABS INSURANCE BROKERS PRIVATE LIMITED',
    'TEKSOURCE SYSTEMS INDIA PRIVATE LIMITED',
    'KRYPTON FASHIONS PRIVATE LIMITED',
    'FUTURE FRAMEZ MEDIA PRIVATE LIMITED',
    'BLINK HEALTH INDIA PRIVATE LIMITED',
    'INFLUX BIG DATA SOLUTIONS PRIVATE LIMITED',
    'CTSNET INDIA PRIVATE LIMITED',
    'AOPLUS SOLUTIONS PRIVATE LIMITED',
    'ILP 3 INDIA 4 PRIVATE LIMITED',
    'PRACTUS BUSINESS TRANSFORMATION PRIVATE LIMITED',
    'AUTOTECH MIRAI DESIGN PRIVATE LIMITED',
    'BHH ORENDA PRIVATE LIMITED',
    'U2USYSTEMS(INDIA) PRIVATE LIMITED',
    'SHIFTLEAN TECHNOLOGIES PRIVATE LIMITED',
    'NTS AUTOMATION LABS PRIVATE LIMITED',
    'DEEPSOURCE PRIVATE LIMITED',
    'SNAP2INSIGHT INDIA PRIVATE LIMITED',
    'MMETHODS SOFTWARE INDIA PRIVATE LIMITED',
    'APPSMITH SOFTWARE PRIVATE LIMITED',
    'UNITED INFONET PRIVATE LIMITED',
    'OGI INTERNATIONAL PRIVATE LIMITED',
    'GREMOT MOBILITY PRIVATE LIMITED',
    'ZVC INDIA PRIVATE LIMITED',
    'MICOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'JWL KOVIS (INDIA) PRIVATE LIMITED',
    'ILP 3 INDIA 3 PRIVATE LIMITED',
    'VIKAS SCAFFOLDING PRIVATE LIMITED',
    'DOLLS EXPORTS PRIVATE LIMITED',
    'VOYOBEE PRIVATE LIMITED',
    'ATOMUS INDUSTRIES PRIVATE LIMITED',
    '3GEN DATA SYSTEMS PRIVATE LIMITED',
    'CELLDE INNOVATION LABS PRIVATE LIMITED',
    'REAPOLIS CONSTRUCTIONS PRIVATE LIMITED',
    'DIGITALCROWD INDIA PRIVATE LIMITED',
    'SAMAVRITTI INNOVATIONS PRIVATE LIMITED',
    'RDGDK ENGINEERING PRIVATE LIMITED',
    'TZ RAILINGS PRIVATE LIMITED',
    'HAPPY MOMO PRIVATE LIMITED',
    'PADDINGTON RESORTS PRIVATE LIMITED',
    'RPC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SUNNYSIDE VENTURES PRIVATE LIMITED',
    'ILP 3 INDIA 7 PRIVATE LIMITED',
    'AGROSOLUTIONS PROINDIA PRIVATE LIMITED',
    'FHHL PRIVATE LIMITED',
    'ANANTJEET SNACK N FOOD PRIVATE LIMITED',
    'IDRIVE INFORMATION SERVICES PRIVATE LIMITED',
    'CAREERSPROO SERVICES PRIVATE LIMITED',
    'TEAK IP SERVICES PRIVATE LIMITED',
    'SUKUPEDIA BUSINESS SERVICES PRIVATE LIMITED',
    'SARA INNOVATIONS (OPC) PRIVATE LIMITED',
    'SAYATVA INDUSTRIAL PRIVATE LIMITED',
    'TERMINATOR PEST INDIA PRIVATE LIMITED',
    'SPSBIO-CHEM PRIVATE LIMITED',
    'CANARA HEALTH FOODS PRIVATE LIMITED',
    'DHAARNI TEXTILES PRIVATE LIMITED',
    'RATNAAFIN INSURANCE BROKING PRIVATE LIMITED',
    'AGRENYA PRODUCTS PRIVATE LIMITED',
    'NOBEL ASSETS MANAGEMENT PRIVATE LIMITED',
    'KANAKIA FUTURE REALTY PRIVATE LIMITED',
    'QMETRY INDIA PRIVATE LIMITED',
    'DATA SCIENCE WIZARDS PRIVATE LIMITED',
    'MUMMADE SERVICES PRIVATE LIMITED',
    'TIKI TAR AND SHELL INDIA PRIVATE LIMITED',
    'MAPAEX HEALTH AND PERSONALCARE PRIVATE LIMITED',
    'SPINNMAX TYRES PRIVATE LIMITED',
    'ACCELIRATE SOFTECH PRIVATE LIMITED',
    'ARIVIYA TECHNOLOGIES PRIVATE LIMITED',
    'SAMARO GLOBAL INDUSTRIES PRIVATE LIMITED',
    'INTERNATIONAL GEM JEWELLERY ILLUSTRATION(OPC) PRIVATE LIMITED',
    'ICT GROUP INDIA PRIVATE LIMITED',
    'SHINEBAY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TELEHEALTH FOR YOU PRIVATE LIMITED',
    'DREAM 2 SEAM TECHNOLOGIES PRIVATE LIMITED',
    'SEFIER CONSULTING PRIVATE LIMITED',
    'ISKRAEMECO INDIA PRIVATE LIMITED',
    'HERE INDIA PRIVATE LIMITED',
    'PIXEL TOWEL PRIVATE LIMITED',
    'NY2 GLOBAL BUSINESS PRIVATE LIMITED',
    'KJKSAA & ASSOCIATES CONSULTANCY PRIVATE LIMITED',
    'CYBERTRACS TECHNOLOGIES & RESEARCH PRIVATE LIMITED',
    'ITELTRONICS PRIVATE LIMITED',
    'GIZBO PRIVATE LIMITED',
    'TURNINGS CONSULTANCY SERVICES PRIVATE LIMITED',
    'YAPAN BIO PRIVATE LIMITED',
    'COSMENTUM ADVISORY SERVICES PRIVATE LIMITED',
    'DAIOEX TECHNOLOGY PRIVATE LIMITED',
    'KATAMARAN INDUSTRIES PRIVATE LIMITED',
    'NECTAR EMERGING TECHNOLOGIES PRIVATE LIMITED',
    'FULLSPECTRUM SOLUTIONS PRIVATE LIMITED',
    'SCOTNIX TECHNOLOGY (OPC) PRIVATE LIMITED',
    'GOFLYSMART HOLIDAYS PRIVATE LIMITED',
    'THINGS ALIVE SOLUTIONS PRIVATE LIMITED',
    'MOLDSINDIA TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'DREAM MAKERS BRAND PRIVATE LIMITED',
    'TBHR TECH SOLUTIONS PRIVATE LIMITED',
    'COGNITECH ENGINEERINGS PRIVATE LIMITED',
    'VONKEN BRANDTECH PRIVATE LIMITED',
    'GREENLAM SOUTH LIMITED',
    'CIMS HEALTHCARE PRIVATE LIMITED',
    'SHRI RISHABH INDIA PRIVATE LIMITED',
    'TNE AAC PRIVATE LIMITED',
    'NEOLYNC SOLUTIONS PRIVATE LIMITED',
    'MACOBS TECHNOLOGIES LIMITED',
    'ELECTRAA FAB PRIVATE LIMITED',
    'ABABIL MEDICAL DEVICES PRIVATE LIMITED',
    'SYNTHECIS PHARMACEUTICALS PRIVATE LIMITED',
    'MEGHMANI ORGANICS LIMITED',
    'BELMAKS MOTORS PRIVATE LIMITED',
    'VISALAM ENERGY SOLUTIONS PRIVATE LIMITED',
    'GREENVIRO GLOBAL PRIVATE LIMITED',
    'AYANA RENEWABLE POWER THREE PRIVATE LIMITED',
    'PHONICS DIGITAL PRIVATE LIMITED',
    'HASTI COMPUTERS PRIVATE LIMITED',
    'EASYPASS LOGISTICS PRIVATE LIMITED',
    'ATUL ADANI FINANCIAL SERVICES PRIVATE LIMITED',
    'BRONKHORST INSTRUMENTATION INDIA PRIVATELIMITED',
    'FLYWAY HOLIDAYS INN & SUITES PRIVATE LIMITED',
    'SKYTOWN PROPERTIES PRIVATE LIMITED',
    'HABITAT TOWNSHIP PRIVATE LIMITED',
    'BIG BIKING COMMUNE PRIVATE LIMITED',
    'KUMAR AGRO REFINERY PRIVATE LIMITED',
    'BADRI INDUSTRIES PRIVATE LIMITED',
    'KIPA APPARELS PRIVATE LIMITED',
    'KEN GLOBAL DESIGNS PRIVATE LIMITED',
    'BITSILICA PRIVATE LIMITED',
    'SURANI PLY INDUSTRIES PRIVATE LIMITED',
    'AMRIT INFORMATION TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'INFINECS SYSTEMS PRIVATE LIMITED',
    'NIYUTA FOOD INDUSTRIES PRIVATE LIMITED',
    'UPPM KRAFT PAPERS PRIVATE LIMITED',
    'CAROLINA OUTSOURCING PRIVATE LIMITED',
    'ISTEM PRIVATE LIMITED',
    'VRIJESH VESTIO PRIVATE LIMITED',
    'OMNIGROWTH MEDI SERVICES PRIVATE LIMITED',
    'ACCURATE SAVAN DEFENCE PRIVATE LIMITED',
    'ARC ELECTRICALS PRIVATE LIMITED',
    'ADITYA BIRLA POWER COMPOSITES LIMITED',
    'SIGNALTRON SYSTEMS PRIVATE LIMITED',
    'AADYA INDUSTRIAL EQUIPMENT PRIVATE LIMITED',
    'AYANA RENEWABLE POWER FOUR PRIVATE LIMITED',
    'DOPPLER ELECTRONICS PRIVATE LIMITED',
    'YASH ENVIRO TECH INDIA PRIVATE LIMITED',
    '3I-ANALTIX PRIVATE LIMITED',
    'GOLDEN STAR TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'DEXTARA DIGITAL PRIVATE LIMITED',
    'EORIGAMI SOFTWARE PRIVATE LIMITED',
    'ZUARI FARMHUB LIMITED',
    'GRID EDGEWRKS PRIVATE LIMITED',
    'YESTEACHER PRIVATE LIMITED',
    'KLOKTER LIFE SCIENCES PRIVATE LIMITED',
    'OSO MULTISOLUTIONS PRIVATE LIMITED',
    'BITSTRING IT SERVICES PRIVATE LIMITED',
    'SANKASH VENTURES PRIVATE LIMITED',
    'SARANSH VENTURES PRIVATE LIMITED',
    'HOUSEJOY TECHNOLOGIES PRIVATE LIMITED',
    'YUKTHI MANUFACTURING INDIA PRIVATE LIMITED',
    'AX2 TECHNOLOGIES PRIVATE LIMITED',
    'SUPER SIX SPORTS GAMING PRIVATE LIMITED',
    'LAMBDATEST INDIA PRIVATE LIMITED',
    'SHIPMED TECHNOLOGIES PRIVATE LIMITED',
    'MICROMEDIACLOUD TECHNOLOGIES PRIVATE LIMITED',
    'JIO PLATFORMS LIMITED',
    'SHIVANG FURNACES AND OVENS INDUSTRIES PRIVATE LIMITED',
    'KARMASTHAL HEALTHTECH PRIVATE LIMITED',
    'MAPAEX TRADELINK PRIVATE LIMITED',
    'IG RETAIL INDIA PRIVATE LIMITED',
    'BADA BUSINESS TRAININGS PRIVATE LIMITED',
    'CLOUDASCEND INDIA PRIVATE LIMITED',
    'SLINEP CONSULTING PRIVATE LIMITED',
    'EMAZEL TECH PRIVATE LIMITED',
    'SPIKE EVTEK PRIVATE LIMITED',
    'TECHRIZE INFOTECH PRIVATE LIMITED',
    'SARAVANA STORES ELITE PRIVATE LIMITED',
    'USBROADCAST INDIA PRIVATE LIMITED',
    'SELECTED RETAIL PRIVATE LIMITED',
    'INDO PAXYS PRIVATE LIMITED',
    'SEEDS FINCAP PRIVATE LIMITED',
    'GLOBAL MUSIC JUNCTION PRIVATE LIMITED',
    'Y J INDUSTRIES PRIVATE LIMITED',
    'HINTASTICA PRIVATE LIMITED',
    'SUPERSMART SECURITY FORCE PRIVATE LIMITED',
    'FIRST MAIN CONSULTANTS PRIVATE LIMITED',
    'AMIGO INDIA PRIVATE LIMITED',
    'AKT MONEY LIMITED',
    'ADITYA FLEXIPACK PRIVATE LIMITED',
    'WURKNET PRIVATE LIMITED',
    'SINARMAS PULP AND PAPER PRIVATE LIMITED',
    'ALLIANZ BULK CARRIERS MANAGEMENT SERVICES PRIVATE LIMITED',
    'MSCORPRES AUTOMATION PRIVATE LIMITED',
    'JAY ORGANICS PRIVATE LIMITED',
    'AURUS LEARNING PRIVATE LIMITED',
    'CIRCLEAPP ONLINE SERVICES PRIVATE LIMITED',
    'TECHNODREAMS ADVANCED SYSTEMS PRIVATE LIMITED',
    'SHAPEMAN TECHNOLOGIES PRIVATE LIMITED',
    'STACKPRO TECHNOLOGIES PRIVATE LIMITED',
    'PRARUH PRIVATE LIMITED',
    'BILLU PERSONAL CARE PRIVATE LIMITED',
    'NELAMANGALA FRESH FARMS PRIVATE LIMITED',
    'CRL INTERIOR AND FIT OUT PRIVATE LIMITED',
    'MOHAM RE-INSURANCE PRIVATE LIMITED',
    'ALCYONE TECHNOLOGIES PRIVATE LIMITED',
    'STAR PIPE FOUNDRY (INDIA) PRIVATE LIMITED',
    'DESKFACTORS TECHNOLOGIES PRIVATE LIMITED',
    'LOOPS HOSPITALITY & FACILITY MANAGEMENT PRIVATE LIMITED',
    'VRTTA GOU BHOOMI PRIVATE LIMITED',
    'ACCOVET LIMITED',
    'MTL SOLUTIONS PRIVATE LIMITED',
    'MANYATA BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'SERPLEX TRADING PRIVATE LIMITED',
    'FINMEN ADVISORS AND CONSULTANTS PRIVATE LIMITED',
    'SMT CARDIOVASCULAR PRIVATE LIMITED',
    'MAHODAR BEVERAGES PRIVATE LIMITED',
    'REVELATIONCARE PRIVATE LIMITED',
    'ALOWEDA WELLNESS PRODUCTS PRIVATE LIMITED',
    'DAYAL AQUA SCIENCES PRIVATE LIMITED',
    'CAPSAVVY CONSULTANTS PRIVATE LIMITED',
    'SOSUDA TECH PRIVATE LIMITED',
    'TEXOL ENERGY PRIVATE LIMITED',
    'MONOPHARMA PRIVATE LIMITED',
    'SUMADHURA COHOMES PRIVATE LIMITED',
    'HYE WOO INDIA PRIVATE LIMITED',
    'FNA EQUIPMENTS PRIVATE LIMITED',
    'SKYI FKUR BIOPOLYMERS PRIVATE LIMITED',
    'MANYATA COMMERCIAL DEVELOPERS PRIVATE LIMITED',
    'HEYMETA I-TECH PRIVATE LIMITED',
    'HUNTKEY INDIA PRIVATE LIMITED',
    'SAPTATI BUILD ESTATE PRIVATE LIMITED',
    'MANYATA KNOWLEDGE INFRASTRUCTURE PROJECTS PRIVATE LIMITED',
    'KLOUDI VIRTUAL ASSISTANT PRIVATE LIMITED',
    'SENSIGHT LABS PRIVATE LIMITED',
    'VENTURA TRADING PRIVATE LIMITED',
    'TRIQUETRA HEALTHCARE AND TECHNOLOGY PRIVATE LIMITED',
    'SOHAM ROCKSTAR ENTERTAINMENT PRIVATE LIMITED',
    'KAMDHENU COLOUR AND COATINGS LIMITED',
    'STATICREFRESH PRIVATE LIMITED',
    'MARIOTTE HYDRAULICS PRIVATE LIMITED',
    'JOIN COMMERCE PRIVATE LIMITED',
    'ENERGIZENT POWER PRIVATE LIMITED',
    'EXCELINK CAREER SOLUTIONS PRIVATE LIMITED',
    'ALTRA XERGI POWER PRIVATE LIMITED',
    'GOLDEN KEY BUILDCON PRIVATE LIMITED',
    'FEATHERSTONE DESIGNS PRIVATE LIMITED',
    'FUTURISTICHR SOLUTIONS PRIVATE LIMITED',
    'ZORG INDUSTRIES INDIA PRIVATE LIMITED',
    'MANYATA OFFICE PARK DEVELOPERS PRIVATE LIMITED',
    'SEABROOK TECHNOLOGY INDIA PRIVATE LIMITED',
    'STACI SOLUTIONS PRIVATE LIMITED',
    'AMBIANZ INDIA PRIVATE LIMITED',
    'ARCHETYPE SOLUTIONS SOFTWARE PRIVATE LIMITED',
    'THINKCIRCUIT RAILTECH PRIVATE LIMITED',
    'INDEX BAGS PRIVATE LIMITED',
    'ADSCLOUD AND IT PRIVATE LIMITED',
    'EWORKPLACE APPS INDIA PRIVATE LIMITED',
    'EEKAI INNOVATIONS PRIVATE LIMITED',
    'LIMITLESS SYNERGY PRIVATE LIMITED',
    'JEEV TEXTILES LIMITED',
    'SIMPLE LEARNING PRIVATE LIMITED',
    'SCION AGRICOS PRIVATE LIMITED',
    'GUNESH TECHNOVISION PRIVATE LIMITED',
    'NORTCELE SYSTEMS PRIVATE LIMITED',
    'KANYAKUMARI-ETTURAVATTAM TOLLWAY LIMITED',
    'WORLD CHEM INDUSTRIES PRIVATE LIMITED',
    'BOILERNOVA HM INDIA PRIVATE LIMITED',
    'GENERAL ENERGY MAINTENANCE SYSTEMS PRIVATE LIMITED',
    'HUMANTRA HR SOLUTIONS PRIVATE LIMITED',
    'ADAPT FINTECH ADVISORS PRIVATE LIMITED',
    'BELLA PACIFIC PAPER PRIVATE LIMITED',
    'KAPCON RMC PRIVATE LIMITED',
    'GHA GLOBAL HEALTHCARE ACADEMY PRIVATE LIMITED',
    'KLOUDPORTAL TECHNOLOGY SOLUTIONS PRIVATELIMITED',
    'IRIDA INTERACTIVE PRIVATE LIMITED',
    'PRO PHYSIO HEALTHCARE PRIVATE LIMITED',
    'HAZARIBAGH TOLLWAY LIMITED',
    'DTECH PRODUCTS PRIVATE LIMITED',
    'KAGAZKAAR RETAIL PACKAGING PRIVATE LIMITED',
    'ITCAN TECHNOLOGIES PRIVATE LIMITED',
    'SENTIENT LABS PRIVATE LIMITED',
    'DAKSHAYANI HEALTHCARE SERVICES PRIVATE LIMITED',
    'KUNAL AUTOTECH PRIVATE LIMITED',
    'AJAYRAJAN GLOBAL PRIVATE LIMITED',
    'GRTSA TECHNOLOGIES PRIVATE LIMITED',
    'HELIOSBRIDGE TECHNOLOGY PRIVATE LIMITED',
    'ANIMALL TECHNOLOGIES PRIVATE LIMITED',
    'KALKINE CONSULTANCY INDIA PRIVATE LIMITED',
    'WAHE INTERNATIONAL PRIVATE LIMITED',
    'IBCC INDUSTRIES (INDIA) PRIVATE LIMITED',
    'AIDDITION TECHNOLOGIES PRIVATE LIMITED',
    'CAPGRID SOLUTIONS PRIVATE LIMITED',
    'LINKS FIELD NETWORKS (INDIA) PRIVATE LIMITED',
    'CELIUM DEVICES PRIVATE LIMITED',
    'ROOP AUTO FORGE PRIVATE LIMITED',
    'HH BACK OFFICE SERVICES PRIVATE LIMITED',
    'LAPLIFE ELECTRONICS PRIVATE LIMITED',
    'FLIQA REALITY PRIVATE LIMITED',
    'FLATMATCH TECHNOLOGIES PRIVATE LIMITED',
    'MVIKAS TECHNOLOGIES PRIVATE LIMITED',
    'SANMAY DECOR PRIVATE LIMITED',
    'MYTHRI INFRASTRUCTURE AND MINING INDIA PRIVATE LIMITED',
    'CENTURY SHELTORS DEVELOPERS PRIVATE LIMITED',
    'VARITAS MANPOWER SOLUTION PRIVATE LIMITED',
    'SHANKAR TECHX PRIVATE LIMITED',
    'MEKERAN ENERGY & INFRA PRIVATE LIMITED',
    'SHELTERTECH INDIA PRIVATE LIMITED',
    'INCEPTION R&D OPERATIONS PRIVATE LIMITED',
    'MEELANEB CONSULTING SERVICES PRIVATE LIMITED',
    'AANSWR FASHION PRIVATE LIMITED',
    'KOTWA-MUZAFFARPUR TOLLWAY LIMITED',
    'MYSORE TAXIWALA CAR RENTALS PRIVATE LIMITED',
    'HICKEY INDIA PRIVATE LIMITED',
    'SADC DIECASTING INDIA PRIVATE LIMITED',
    'WEYBURN HEAVY INDUSTRIES PRIVATE LIMITED',
    'MEAN WELL INDIA ELECTRONICS PRIVATE LIMITED',
    'KAL ENERGY INDIA PRIVATE LIMITED',
    'LINEAR WEB DEVELOPMENT PRIVATE LIMITED',
    'ARIHANT INTELLIGENCE PRIVATE LIMITED',
    'POSH PUPPY TECHNOLOGIES PRIVATE LIMITED',
    'MEERASOFT TECHNOLOGY & SOLUTIONS PRIVATELIMITED',
    'NAVSHALI INNOVATIONS PRIVATE LIMITED',
    'AEROGEN MEDICAL DEVICES INDIA PRIVATE LIMITED',
    'TREECO EXIM PRIVATE LIMITED',
    'AT INFO SOLUTIONS PRIVATE LIMITED',
    'WONDER WALLCARE PRIVATE LIMITED',
    'FIMER INDIA PRIVATE LIMITED',
    'SOUTH INDIAN FRESH FOODS PRIVATE LIMITED',
    'FASTBUCKS SERVICES PRIVATE LIMITED',
    'ZB DENTAL INDIA PRIVATE LIMITED',
    'INTELLISOURCE TECHNOLOGIES PRIVATE LIMITED',
    'QUISITIVE TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'YAHA WATER SYSTEMS PRIVATE LIMITED',
    'JHANSI-LALITPUR TOLLWAY LIMITED',
    'LANYA CHEM INDUSTRIES PRIVATE LIMITED',
    'SUSHENAH SKIN AND HEALTH CARE PRIVATE LIMITED',
    'INTERFUSE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SOFY TECHNOLOGIES PRIVATE LIMITED',
    'GIENANTH INDIA PRIVATE LIMITED',
    'CRRC INDIA PRIVATE LIMITED',
    'STEP ADVISORY PRIVATE LIMITED',
    'RULMECA INDIA PRIVATE LIMITED',
    'S-LINK TECHNOLOGY PRIVATE LIMITED',
    'MARWAH SPORTS PRIVATE LIMITED',
    'KAMDHENU METALLIC INDUSTRIES LIMITED',
    'IRIN PAPERS PRIVATE LIMITED',
    'GLOBAL LAB MATERIAL TESTING PRIVATE LIMITED',
    'JABIL INDIA MANUFACTURING PRIVATE LIMITED',
    'FUJI INDIA CORPORATION PRIVATE LIMITED',
    'CELKART STORE PRIVATE LIMITED',
    'SALCOMP TECHNOLOGIES INDIA PRIVATE LIMITED',
    'GRAINDESK COMMODITIES INDIA PRIVATE LIMITED',
    'CAKER STREET PRIVATE LIMITED',
    'DIGIVRIDDHI TECHNOLOGIES PRIVATE LIMITED',
    'SATYA AUTO PRIVATE LIMITED',
    'CWD MANUFACTURING PRIVATE LIMITED',
    'ONOMA KAIKETSU PRIVATE LIMITED',
    'PROXANT INFOTECH PRIVATE LIMITED',
    'ANAIKAR SHOE FACTORY PRIVATE LIMITED',
    'NICELY LIFE FOUNDATION',
    'UTSAV AUTOMOBILES PRIVATE LIMITED',
    'AIVOKS TECHNOLOGIES PRIVATE LIMITED',
    'AVIRIDH ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'SANJIVANI METAL TRADING PRIVATE LIMITED',
    'GENCREST PRIVATE LIMITED',
    'NLMK INDIA COATING PRIVATE LIMITED',
    'INVEST19 TECHNOLOGIES PRIVATE LIMITED',
    'RAMKRISHNA DIAMOND PRIVATE LIMITED',
    'MULTIWAYS LOGISTICS PRIVATE LIMITED',
    'KRISANDY PRIVATE LIMITED',
    'PIDILITE GRUPO PUMA MANUFACTURING LIMITED',
    'STRONG BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PURPLE BRIDGE INNOVATIONS PRIVATE LIMITED',
    'SOFTSPIN TECHNOLOGIES PRIVATE LIMITED',
    'FLIVIN COTTAGE PRIVATE LIMITED',
    'VERTIVER SUSTAINABILITY FOUNDATION',
    'COAPPS DEVELOPMENT SOLUTIONS PRIVATE LIMITED',
    'FUTURISTIC EDU INITIATIVES PRIVATE LIMITED',
    'FACTORIE INTELLIGENT OPERATIONS PRIVATE LIMITED',
    '3TOP AVIATION SERVICES PRIVATE LIMITED',
    'KISANMEET INDIA PRIVATE LIMITED',
    'AM LIGHTING PRIVATE LIMITED',
    'BAGLA TECVISION PRIVATE LIMITED',
    'RKD FURNISHINGS PRIVATE LIMITED',
    'ASSETGRO FINTECH PRIVATE LIMITED',
    'VM HEAVY MACHINERY PRIVATE LIMITED',
    'JAY MAHARAJ EDU FOCUS PRIVATE LIMITED',
    'FLEET HAWKS PRIVATE LIMITED',
    'FRAMEUP INFRACON PRIVATE LIMITED',
    'LAYER2 APAC PRIVATE LIMITED',
    'CLEARPIER PRIVATE LIMITED',
    'DISPATCHTRACK INDIA PRIVATE LIMITED',
    'AVIGNAAB INDIA PRIVATE LIMITED',
    'IXP LIFESCIENCES PRIVATE LIMITED',
    'AMITOJE INDIA PRIVATE LIMITED',
    'NEODOVE TECHNOLOGIES PRIVATE LIMITED',
    'FARMIOC TECHNOLOGIES PRIVATE LIMITED',
    'TDCX DIGILAB INDIA PRIVATE LIMITED',
    'TRUDO INDIA PRIVATE LIMITED',
    'NEXT INFORMATION SYSTEMS PRIVATE LIMITED',
    'ADRIDGE MEDIA PRIVATE LIMITED',
    'INDOFLUXLITE PRIVATE LIMITED',
    'MANGOHOMZ TECHNOLOGIES PRIVATE LIMITED',
    'WORKRE WORKSPACES PRIVATE LIMITED',
    'STEFEN ELECTRIC PRIVATE LIMITED',
    '5ELEMENT HOMES PRIVATE LIMITED',
    'PERANTI GREEN INFRA PRIVATE LIMITED',
    'SOURAYAN TECHNOLOGIES PRIVATE LIMITED',
    'SUNTEC DIGITAL SOLUTIONS PRIVATE LIMITED',
    'JSW RENEWABLE ENERGY (VIJAYANAGAR) LIMITED',
    'BEYOND SMART CITIES PRIVATE LIMITED',
    'EVERNEST GAINS PROPERTIES PRIVATE LIMITED',
    'MERRAKY ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'AUROGREEN HEALTH PRIVATE LIMITED',
    'AFFY NON-WOVEN PRIVATE LIMITED',
    'ANIHEAL CLINICAL CENTRES PRIVATE LIMITED',
    'CANARES AUTOMATION PRIVATE LIMITED',
    'GIGSTA TECHNOLOGIES PRIVATE LIMITED',
    'NXIT SERVICES PRIVATE LIMITED',
    'JIAGUAN TECHNOLOGY PRIVATE LIMITED',
    'MOHAN PACKERS AND MOVERS PRIVATE LIMITED',
    'WELLNESS LIFESTYLE PRIVATE LIMITED',
    'FONZEL OFFICE SOLUTIONS PRIVATE LIMITED',
    'CLEPIOS HEALTH INDIA PRIVATE LIMITED',
    'FIN AWARE PRIVATE LIMITED',
    'BIG MATRIX PRIVATE LIMITED',
    'HEHONG PAPER INDIA TECHNOLOGY PRIVATE LIMITED',
    'CRKMINES & CONSTRUCTION PRIVATE LIMITED',
    'IMFAST FINFOTECH PRIVATE LIMITED',
    'EASTERN GREENWICH ENTERTAINMENT PRIVATE LIMITED',
    'HEALTHCARE TRIANGLE PRIVATE LIMITED',
    'VALLAM (PHASE IV) LOGISTICS PARK PRIVATELIMITED',
    'TECHORBIT SOLUTIONS PRIVATE LIMITED',
    'BITS AND BYTE COMMUNICATIONS PRIVATE LIMITED',
    'REVERSIDE GLOBAL SERVICES PRIVATE LIMITED',
    'TULUA FOODS PRIVATE LIMITED',
    'GREENIKK SUSTAINABLE VENTURES PRIVATE LIMITED',
    'VALLAM (PHASE III) LOGISTICS PARK PRIVATE LIMITED',
    'SHAKTI HOSPITALITY PRIVATE LIMITED',
    'ORAI ROBOTICS PRIVATE LIMITED',
    'JFOREST INDIA PRIVATE LIMITED',
    'RATEMYSTAY PRIVATE LIMITED',
    'DNY SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'AARUSH MANUFACTURING SOLUTIONS PRIVATE LIMITED',
    'ALTBAZAR INDIA PRIVATE LIMITED',
    'TRELINDIA PRIVATE LIMITED',
    'KRP GEOTECH PRIVATE LIMITED',
    'PURNATVAM LEARNING SOLUTIONS PRIVATE LIMITED',
    'DEVPRO FOOD INDIA PRIVATE LIMITED',
    'LEARNING FORWARD INDIA FOUNDATION',
    'SUNRISE CREATIVE FASHION PRIVATE LIMITED',
    'YOUGOTAGIFT PRIVATE LIMITED',
    'DREAMPLUG AA TECH SOLUTIONS PRIVATE LIMITED',
    'ABDA AVIATION INDIA PRIVATE LIMITED',
    'LALANTOP IT SOLUTIONS PRIVATE LIMITED',
    'GANGA DHAM TOWERS PRIVATE LIMITED',
    'XTREME COOLERS PRIVATE LIMITED',
    'PARYAAVARNEER ENGINEERS & CONSULTANTS PRIVATE LIMITED',
    'DRU GOLD PRIVATE LIMITED',
    'ALTURAS HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'KC OVERSEAS PRIVATE LIMITED',
    'SHREE BALAJI HOSIERY MILLS PRIVATE LIMITED',
    'COSMIC SAFETY PRIVATE LIMITED',
    'AIPALETTE INDIA PRIVATE LIMITED',
    'CREMON COSMETICS PRIVATE LIMITED',
    'TPI COMPOSITES INDIA PRIVATE LIMITED',
    'WELMONT EDUVENTURES PRIVATE LIMITED',
    'TRICE SYSTEMS PRIVATE LIMITED',
    'HANBI E&C INDIA PRIVATE LIMITED',
    'YMX INDIA SERVICES PRIVATE LIMITED',
    'GUBBI CIVIL ENGINEERS LIMITED',
    'KAUVERY HOSPITALS (BENGALURU) PRIVATE LIMITED',
    'TFAM INSURANCE SURVEYOR AND LOSS ASSESSORS PRIVATE LIMITED',
    'RAPLAP PRIVATE LIMITED',
    'GREENGLOBE AUTOTECH PRIVATE LIMITED',
    'SPANESI INDIA PRIVATE LIMITED',
    'SREELAKSHMI STOCKISTS AND APPLIANCES PRIVATE LIMITED',
    'TREZEO KITCHENS PRIVATE LIMITED',
    'KNOWN2ME TECHNOLOGIES PRIVATE LIMITED',
    'KUNDAN HYDRO (GANGTOK) PRIVATE LIMITED',
    'VIBRANTVIVA ALLIANCE LIMITED',
    'AGASTHYA EDTECH PRIVATE LIMITED',
    'TELE CUBES MOBILE SERVICES PRIVATE LIMITED',
    'HOMEBOTS AUTOMATION PRIVATE LIMITED',
    'DARIYA SHIPPING AGENCIES PRIVATE LIMITED',
    'PIXELPOLY DIGITAL PRIVATE LIMITED',
    'HOMECOURT INDIA PRIVATE LIMITED',
    'VENGOV INDIA PRIVATE LIMITED',
    'KLIMAS INDIA PRIVATE LIMITED',
    'KONATHAN INDIA PRIVATE LIMITED',
    'RANKXCEL EDUCATION PRIVATE LIMITED',
    'PHA APPAREL PRIVATE LIMITED',
    'AVAK HOSPITALITY PRIVATE LIMITED',
    'KRISHI JAGRAN PRIVATE LIMITED',
    'AVANS DIAGNOSTICS PRIVATE LIMITED',
    'UNIWINDOWS PRIVATE LIMITED',
    'ACCS LOGISTICS PRIVATE LIMITED',
    'JK ASSOCIATES PRIVATE LIMITED',
    'INNOVATIVE ENGINEERS INDIA PRIVATE LIMITED',
    'ZINO ELECTRONICS (OPC) PRIVATE LIMITED',
    'RAZRLAB TECH PRIVATE LIMITED',
    'ZELP TECHNOLOGIES PRIVATE LIMITED',
    'PARADIGM ELECTRIC PRIVATE LIMITED',
    'AATCTW INDIA PRIVATE LIMITED',
    'CLINPRO RESEARCH PRIVATE LIMITED',
    'HYLUB FORMULATIONS PRIVATE LIMITED',
    'INTERONE TECHNOLOGIES PRIVATE LIMITED',
    'NH9CORP PRIVATE LIMITED',
    'FLAT WHITE CAPITAL PRIVATE LIMITED',
    'WESTERNHILLS FARMER PRODUCER COMPANY LIMITED',
    'EKTASEVA SOCIAL FOUNDATION',
    'AZTEC ELEMENTS INDIA PRIVATE LIMITED',
    'RANGEEN KHIDKI FOUNDATION',
    'TFI CONNECT PRIVATE LIMITED',
    'SAKINI ENTERPRISES PRIVATE LIMITED',
    'PILLARPLUS PRIVATE LIMITED',
    'ONEWEB INDIA COMMUNICATIONS PRIVATE LIMITED',
    'GABRIEL-BROS INDIA PRIVATE LIMITED',
    'LOKSEVA MICRO BENEFIT FOUNDATION',
    'ZOOMTIME IT SOLUTIONS PRIVATE LIMITED',
    'JAK CLINICS PRIVATE LIMITED',
    'TXCER PRIVATE LIMITED',
    'INSURYZE INNOVATION LABS PRIVATE LIMITED',
    'PROFILICS SYSTEMS PRIVATE LIMITED',
    'GURUZZI WELLNESS PRIVATE LIMITED',
    'PRAY AUTO PRIVATE LIMITED',
    'TRAYAMBAKAM ADVISORS PRIVATE LIMITED',
    'INNOVANA INFRASTRUCTURE LIMITED',
    'SUNSOLE RENEWABLES PRIVATE LIMITED',
    'LUXSH SOLUTIONS PRIVATE LIMITED',
    'CGSGREEN SUSTAINERGY PRIVATE LIMITED',
    'NEW PERIPHERALS TECHNOLOGY PRIVATE LIMITED',
    'AGNIHOTRI INFRACARE PRIVATE LIMITED',
    'AUTOMATE TECHNOLOGIES PRIVATE LIMITED',
    'SCHOOL TECH SOLUTION PRIVATE LIMITED',
    'TECNOCAP ORIENTAL PRIVATE LIMITED',
    'SUNSTRENGTH RENEWABLES PRIVATE LIMITED',
    'PROJNEXT SOLUTIONS PRIVATE LIMITED',
    'PRIMUS SENIOR LIFESTYLE MANAGEMENT PRIVATE LIMITED',
    'SOFTEASY NETWORKING SOLUTIONS PRIVATE LIMITED',
    'SOUTHERN INDIA STEELCAST PRIVATE LIMITED',
    'SURAKSHITAM SAFE KEEPERS (OPC) PRIVATE LIMITED',
    'MAXMAX LEGAL & CORPORATE SERVICES PRIVATE LIMITED',
    'RENEW VYAN SHAKTI PRIVATE LIMITED',
    'BAKARMAX PRIVATE LIMITED',
    'DIVIT SOFTLABS PRIVATE LIMITED',
    'PRO SCAN TELERADIOLOGY HUB PRIVATE LIMITED',
    'UJOY TECHNOLOGY PRIVATE LIMITED',
    'CHURROLTO FOODS PRIVATE LIMITED',
    'NIHIRA CONSUMMATE ENGINEERS PRIVATE LIMITED',
    'JRA ALIBAG ROAD PROJECT PRIVATE LIMITED',
    'ARYANSHI ONLINE E RETAIL PRIVATE LIMITED',
    'CRIOT INNOVATIONS PRIVATE LIMITED',
    'SI2 TECHNOLOGIES PRIVATE LIMITED',
    'BANG BANG MEDIACORP PRIVATE LIMITED',
    'AL AZAN FOUNDATION',
    'ALPHANEON FUTURE PRIVATE LIMITED',
    'RMV FOOD AND SERVICES PRIVATE LIMITED',
    'KRISHNA CORPINDIA PRIVATE LIMITED',
    'ZEPPIN DELIGHT PRIVATE LIMITED',
    'SREE SRINIVASA REFCON PRIVATE LIMITED',
    'BAY CIDER PRIVATE LIMITED',
    'HARAXY TECHNOLOGIES PRIVATE LIMITED',
    'ASTALYNX GLOBAL SOLUTIONS PRIVATE LIMITED',
    'ANCIT CONSULTING PRIVATE LIMITED',
    'TEMICO MOTOR INDIA PRIVATE LIMITED',
    'QRIUM (OPC) PRIVATE LIMITED',
    'EM CONSTRUCTOR PRIVATE LIMITED',
    'DATA FOR DECISIONS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'EXIKON TECHNOLOGY PRIVATE LIMITED',
    'TECHZEP MEDIA SOLUTIONS PRIVATE LIMITED',
    'ADISVAN INVESTMENTS PRIVATE LIMITED',
    'HULIKKAL AGRI & DAIRY PRIVATE LIMITED',
    'TALENTPULL AND INFRASTRUCTURE PRIVATE LIMITED',
    'SHARANAM CHEMICALS (OPC) PRIVATE LIMITED',
    'PURVOTTAR GRAMYA PRABHA PGP PRIVATE LIMITED',
    'IMS WORKFORCE SOLUTIONS PRIVATE LIMITED',
    'POLICY FOURPOINTO ADVISORY SERVICES PRIVATE LIMITED',
    'USETHEGEEKS INDIA PRIVATE LIMITED',
    'KWALITY TRADERS TEA LEAF PRIVATE LIMITED',
    'STECS CONSULTING PRIVATE LIMITED',
    'AUSTRALIAN BLACK SATIVA INDIA PRIVATE LIMITED',
    'HELLO SPACE TECHNOLOGIES PRIVATE LIMITED',
    'YARNCOMS OVERSEAS PRIVATE LIMITED',
    'JSPANTHER (OPC) PRIVATE LIMITED',
    'MAHAPHANT INDIA PRIVATE LIMITED',
    'PERITI INDUSTRIES PRIVATE LIMITED',
    'MARK MAKER ENGINEERING PRIVATE LIMITED',
    'JEEBLY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'R-TECH PRECISION PRIVATE LIMITED',
    'S.D. SAMATA SAMANTHA REALTY PRIVATE LIMITED',
    'INSTITUTION OF BAUXITE, ALUMINA AND ALUMINIUM STUDIES PRIVATE LIMITED',
    'PEEPAL TREE VENTURES PRIVATE LIMITED',
    'MARA ROBOTECH SOLUTIONS PRIVATE LIMITED',
    'SHREE CHARBHUJA AGRO INDUSTRIES PRIVATE LIMITED',
    'PRAVAHA IOT TECHNOLOGIES PRIVATE LIMITED',
    'KNEST VERTICALS PRIVATE LIMITED',
    'AIRTIFICIAL IR INDIA PRIVATE LIMITED',
    'LEXCELON CORPORATE ADVISORS PRIVATE LIMITED',
    'SHRI SUSWANI IMPORT & EXPORT PRIVATE LIMITED',
    'MCGBS PRIVATE LIMITED',
    'HAMDAN TECHNOLOGY SOLUTIONS (OPC) PRIVATE LIMITED',
    'INNOVATE LIFESCIENCES PRIVATE LIMITED',
    'LIA GEORSON PRIVATE LIMITED',
    'VERB STORIES PRIVATE LIMITED',
    'ERAS TEACHERS PRIVATE LIMITED',
    'ODIWARE TECHNOLOGIES PRIVATE LIMITED',
    'AADHYA TECHNO SOLUTIONS PRIVATE LIMITED',
    'ZYSK TECHNOLOGIES PRIVATE LIMITED',
    'SASTAVA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'AERANTA AVIONICS PRIVATE LIMITED',
    'FLEETONCLICK INDIA PRIVATE LIMITED',
    'E-UMANG CONSULTANCY PRIVATE LIMITED',
    'SONATA SOFTWARE SOLUTIONS LIMITED',
    'KAIYAAN LIGHTING SOLUTIONS PRIVATE LIMITED',
    'LOMADS TECHNOLOGIES PRIVATE LIMITED',
    'CAM ENERGY AND POWER PRIVATE LIMITED',
    'KAPIL GROUP MARKETING SERVICES PRIVATE LIMITED',
    'HELP TO SUPPORT FOUNDATION',
    'MORPHEES O2O SOLUTIONS PRIVATE LIMITED',
    'PUSHPAKRITI SROT FOUNDATION',
    'NIBBANA TEA PRIVATE LIMITED',
    'ACETAMIDE PRIVATE LIMITED',
    'AURA RESOURCES PRIVATE LIMITED',
    'A2Z TEAMACH PRIVATE LIMITED',
    'PCK AGRI VENTURES PRIVATE LIMITED',
    'D2SOL INDIA PRIVATE LIMITED',
    'QBROOT FINANCIAL SOLUTIONS INDIA PRIVATELIMITED',
    'SILABS INDIA PRIVATE LIMITED',
    'SAFE ENTERPRISES RETAIL TECHNOLOGIES PRIVATE LIMITED',
    'LEFTBIN LABS PRIVATE LIMITED',
    'SAVIOUR PRINTSOL PRIVATE LIMITED',
    'PINGBOT TECHNOLOGIES PIVATE LIMITED',
    'TIMESCARE ADVISORY SERVICES PRIVATE LIMITED',
    'ALFA PARF INDIA PRIVATE LIMITED',
    'MYPORT SERVICES INDIA PRIVATE LIMITED',
    'CORDELIA CONTAINER SHIPPING LINE PRIVATELIMITED',
    'CODENT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BRIANK SOFTECH PRIVATE LIMITED',
    'WISETECH GLOBAL (INDIA) PRIVATE LIMITED',
    'AKPAX SERVICES INDIA PRIVATE LIMITED',
    'ITECHNORIX SOLUTIONS PRIVATE LIMITED',
    'BELITO CREATION INDIA PRIVATE LIMITED',
    'LINDE SOUTH ASIA SERVICES PRIVATE LIMITED',
    'AEKKAM ACADEMY PRIVATE LIMITED',
    'GLOWPINK PRIVATE LIMITED',
    'IT MONKS SOLUTIONS PRIVATE LIMITED',
    'THOMAS WORDSWORTH HR SYSTEMS PRIVATE LIMITED',
    'ALL TIME TALES STUDIO PRIVATE LIMITED',
    'GETCELEB PRIVATE LIMITED',
    'TRUE WALLET PRIVATE LIMITED',
    'JAI SAI COAL TRADERS PRIVATE LIMITED',
    'INFINITY MEASUREMENT SOLUTIONS PRIVATE LIMITED',
    'TRUE STAR HOMES PRIVATE LIMITED',
    'HSA VENTURES PRIVATE LIMITED',
    'NAVACHAAR CHARITABLE FOUNDATION',
    'QURO LABS PRIVATE LIMITED',
    'STAR STEEL PROJECTS PRIVATE LIMITED',
    'MCLABS PRIVATE LIMITED',
    'FARAD INDIA PRIVATE LIMITED',
    'CERTIFIED INSANE CONSULTING AND ANALYTICS PRIVATE LIMITED',
    'AZONIX TECH PRIVATE LIMITED',
    'PLAN1 HEALTH INDIA PRIVATE LIMITED',
    'BLUME GLOBAL INDIA PRIVATE LIMITED',
    'BINYTREE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'FLY HUB TRAVEL PRIVATE LIMITED',
    'AVIANCE LOGISTICS PRIVATE LIMITED',
    'AMP ENERGY GREEN SEVEN PRIVATE LIMITED',
    'NBA HOLIDAYS PRIVATE LIMITED',
    'PUKKATTUPADY HOTELS AND RESORTS PRIVATE LIMITED',
    'HASH RATE COMMUNICATIONS PRIVATE LIMITED',
    'JHEEL SUSTAINABLE SOLUTIONS PRIVATE LIMITED',
    'PREMVATI AGRI PROCESSING PRIVATE LIMITED',
    'SPECIALISED HOME CONCEPTS PRIVATE LIMITED',
    'SENSES AKUSTIK PRIVATE LIMITED',
    'PRAGATI HANDICRAFTS PRIVATE LIMITED',
    'ZEECO BRAND EXPERIENCES PRIVATE LIMITED',
    'NEXTA EXECUTIVE SEARCH INDIA PRIVATE LIMITED',
    'DANDERA TECHNOLOGIES PRIVATE LIMITED',
    'WLPMS MUMBAI PRIVATE LIMITED',
    'WHITE PLUS INNOVATIONS (I) PRIVATE LIMITED',
    'WHITEATOM PRIVATE LIMITED',
    'GREENKO MH01 IREP PRIVATE LIMITED',
    'QUROMED LIFESCIENCES PRIVATE LIMITED',
    'ARADHYAA INFRA & HOLDINGS PRIVATE LIMITED',
    'BERKMAN FORWARDING INDIA PRIVATE LIMITED',
    'INTEGRATION DEVELOPER NETWORK PRIVATE LIMITED',
    'BANETIYA ENTERPRISES PRIVATE LIMITED',
    'KSRS EXPORTS PRIVATE LIMITED',
    'CLOUDEQ SOFTWARE INDIA PRIVATE LIMITED',
    'SHURUART FOUNDATION',
    'COANTUMLEAP DIGITAL (INDIA) PRIVATE LIMITED',
    'NEWRTA SOLUTIONS PRIVATE LIMITED',
    'WHITE BIRD AGRO PRIVATE LIMITED',
    'TECSO SOLAR ENERGY PRIVATE LIMITED',
    'EARNEST TACTICAL SOLUTIONS PRIVATE LIMITED',
    'ENTROPIA ENERGY PRIVATE LIMITED',
    'ELON CONSULTING SERVICE (OPC) PRIVATE LIMITED',
    'MAHASHAKTHI ELECTRONICS (OPC) PRIVATE LIMITED',
    'BILLIONS BEVERAGES PRIVATE LIMITED',
    'IDSCOPE SOLUTIONS PRIVATE LIMITED',
    'MSB CORPORATION PRIVATE LIMITED',
    'BALAJI PINEWOOD PRODUCTS PRIVATE LIMITED',
    'GARWARE FULFLEX INDIA PRIVATE LIMITED',
    'ROOMPE PRIVATE LIMITED',
    'KALSON JEWELLERS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY FIVE PRIVATE LIMITED',
    'ARIRO PRIVATE LIMITED',
    'TATA AUTOCOMP GOTION GREEN ENERGY SOLUTIONS PRIVATE LIMITED',
    'SMARTSOL ELECTRIC PRIVATE LIMITED',
    'SYNES CHEMSYS PRIVATE LIMITED',
    'IIPA CONSULTING PRIVATE LIMITED',
    'RIVIERA INFRAPROJECTS PRIVATE LIMITED',
    'KIDEX VENTURE PRIVATE LIMITED',
    'BSAFAL STURCO TRADING PRIVATE LIMITED',
    'TARAMIS LABS PRIVATE LIMITED',
    'NEURALSCHEMA INFOTECH PRIVATE LIMITED',
    'STIRLING EDUCATION INDIA PRIVATE LIMITED',
    'DATAGENIUS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PROWESS ENGINEERING FAB PRIVATE LIMITED',
    'INDO MONEY RETAILS INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY NINE PRIVATE LIMITED',
    'SKILLSCONSORTIUM PRIVATE LIMITED',
    'TUSCAN KABINI HOSPITALITY SERVICES PRIVATE LIMITED',
    'VEADVISORY AND CONSULTANTS PRIVATE LIMITED',
    'CARDPAY TECHNOLOGIES PRIVATE LIMITED',
    'TERVIVA INDIA PRIVATE LIMITED',
    'COMPLEASE SOLUTIONS PRIVATE LIMITED',
    'ADLERENSERV PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY TWENTY SEVEN PRIVATE LIMITED',
    'PACIFIC FIRE CONTROLS PRIVATE LIMITED',
    'SREE VENKATESHWARA MEDISOLUTIONS PRIVATELIMITED',
    'VASCORP INDIA PRIVATE LIMITED',
    'SAHIB PESTICIDES PRIVATE LIMITED',
    'BHR FASHIONS PRIVATE LIMITED',
    'GUGUSYS SMART SOLUTIONS PRIVATE LIMITED',
    'CFNC INDIA PRIVATE LIMITED',
    'TRES MANOS INDIA PRIVATE LIMITED',
    'MERCEL HOSPITALITY AND CATERING SERVICESPRIVATE LIMITED',
    'VIRDHI TECH LAB PRIVATE LIMITED',
    'PSH AIR PRIVATE LIMITED',
    'TAJUDDIN MARYAM LOGISTICS PRIVATE LIMITED',
    'MANUMAC ENGINEERING PRIVATE LIMITED',
    'VIXPLOR ANALYTICS PRIVATE LIMITED',
    'THERAPIVA PRIVATE LIMITED',
    'NETPICO LABS PRIVATE LIMITED',
    'SUNRISE SEAFOODS INDIA PRIVATE LIMITED',
    'TECHVARIABLE PRIVATE LIMITED',
    'RONIN SYNTHETICS PRIVATE LIMITED',
    'MICROCRISTAL TECHNOLOGIES PRIVATE LIMITED',
    'AUCTUSESG INSIGHTS FORUM',
    'SRS-TECH EXPERTS PRIVATE LIMITED',
    'NEOCHLORUS SOLAR SOLUTIONS PRIVATE LIMITED',
    'ASIAVILLE INTERACTIVE PRIVATE LIMITED',
    'L2H POWER SYSTEM PRIVATE LIMITED',
    'MAXOUT TV PRIVATE LIMITED',
    'SPD INDIA HEALTHCARE PRIVATE LIMITED',
    'ENSTRUCTURA CONSULTANTS PRIVATE LIMITED',
    'OCELLUS CONSULTING PRIVATE LIMITED',
    'AUTOSCIENT PRODUCTS AND SERVICES PRIVATELIMITED',
    'BLUECHINK TECHNOLOGIES PRIVATE LIMITED',
    'CABAIN RETAIL PRIVATE LIMITED',
    'FORERUN MOBILE STORE PRIVATE LIMITED',
    'MOVEMENTOR DESTINATIONS PRIVATE LIMITED',
    'ASSOCIATION FOR DEVELOPMENT OF LUGGAGE AND ACCESSORIES',
    'ASSOCIATION FOR DEVELOPMENT OF HANDBAGS AND SMALL BAGS INDUSTRY',
    'A3US SAFETY PRIVATE LIMITED',
    'APRAMSHRI AUTOMATIONS PRIVATE LIMITED',
    'F5 NETWORKS INNOVATION PRIVATE LIMITED',
    'ABJAYON CONSULTANCY PRIVATE LIMITED',
    'MANETTE WORLDWIDE PRIVATE LIMITED',
    'ACEPRO FINANCE PRIVATE LIMITED',
    'LOGISTICSA TECHNOLOGIES PRIVATE LIMITED',
    'ADDTITANS DIGITAL PRIVATE LIMITED',
    'TATWEER TECHNOLOGIES PRIVATE LIMITED',
    'SNAK INDIA CONSULTANCY SERVICES PRIVATE LIMITED',
    'FRESHKO INDIA PRIVATE LIMITED',
    'DHFL CHANGING LIVES FOUNDATION',
    'TANGIO BRAND SOLUTIONS PRIVATE LIMITED',
    'ZINGNZEST PRIVATE LIMITED',
    'APPSERVE APPLIANCE PRIVATE LIMITED',
    'SUNBEAM LIGHTWEIGHTING SOLUTIONS PRIVATELIMITED',
    'DAECHANG SEAT AUTOMOTIVE PRIVATE LIMITED',
    'FERNWEH GLOBETROT TECHNOLOGIES PRIVATE LIMITED',
    'WINSSION ALLIANCES PRIVATE LIMITED',
    'SINEW NUTRITION PRIVATE LIMITED',
    'ALACRITY DISTRIBUTION PRIVATE LIMITED',
    'SUVARNA DURGA HOSPITALITIES PRIVATE LIMITED',
    'HOOGHLY OIL AND GAS TERMINAL PRIVATE LIMITED',
    'POLICY PARIVAAR INSURANCE BROKERS PRIVATE LIMITED',
    'CAPATUS INVESTMENTS PRIVATE LIMITED',
    'TCR RESORTS AND REAL ESTATES PRIVATE LIMITED',
    'RSKS BUILDCON PRIVATE LIMITED',
    'APPODEEPO TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'CHARMANDER TECHNOLOGIES PRIVATE LIMITED',
    'ROSE QUALITY SOLUTIONS PRIVATE LIMITED',
    'ODYSSEUS SOLUTIONS PRIVATE LIMITED',
    'ASAA EXCELLENCE PRIVATE LIMITED',
    'SGS OVERSEAS PRIVATE LIMITED',
    'RUTIKA LIFESCIENCE PRIVATE LIMITED',
    'VISHWATECH SOLUTIONS PRIVATE LIMITED',
    'NB HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'FACTANA COMPUTING PRIVATE LIMITED',
    'AILOITTE TECHNOLOGIES PRIVATE LIMITED',
    'EVANTAGE SOFTECH INDIA PRIVATE LIMITED',
    'SYSGEN AI PRIVATE LIMITED',
    'MUNI ELECTROMECH DEVICES PRIVATE LIMITED',
    'GALAXY ELITE SERVICES INDIA PRIVATE LIMITED',
    'GEMMAX WIRETECH PRIVATE LIMITED',
    'AEPROCUREX SOURCING PRIVATE LIMITED',
    'CASLEY INDIA PRIVATE LIMITED',
    'MOCKUP TIMES PRIVATE LIMITED',
    'BELLISSIMO VENTURES PRIVATE LIMITED',
    'NIHON ACCESS INDIA PRIVATE LIMITED',
    'YUNIMAGE SERVICES PRIVATE LIMITED',
    'JCFLASH TECHNOLOGIES PRIVATE LIMITED',
    'VISHVEK CONSULTING PRIVATE LIMITED',
    'PRESCORP SOLUTIONS PRIVATE LIMITED',
    'CONSNORTH DEVELOPERS PRIVATE LIMITED',
    'ADRIATIC BUSINESS VENTURE PRIVATE LIMITED',
    'HYPERPORT LOGISTICS SOLUTION PRIVATE LIMITED',
    'AGILEINTEL RESEARCH PRIVATE LIMITED',
    'RALSONICS RESEARCH PRIVATE LIMITED',
    'JAISWAL HOLIDAYS INDIA PRIVATE LIMITED',
    'SULOCHANA MARCOM PRIVATE LIMITED',
    'LYTICA LABS PRIVATE LIMITED',
    'GLIC TECH PRIVATE LIMITED',
    'AGNIKUL COSMOS PRIVATE LIMITED',
    'VEBOTICS SQUARE SERVICES PRIVATE LIMITED',
    'INTELLOGRIT PRIVATE LIMITED',
    'GREEN FOSTER MINERALS PRIVATE LIMITED',
    'KONNECT INFOLINE PRIVATE LIMITED',
    'SN GLOVUS LEATHER PRIVATE LIMITED',
    'WILLOW FOUNDATION',
    'GRAAND PRIX HOME ELEVATORS INDIA PRIVATELIMITED',
    'OXIMUS ORGANIC INDIA PRIVATE LIMITED',
    'SAKARIYA PETRODYNE PRIVATE LIMITED',
    'RBK FARMER PRODUCER COMPANY LIMITED',
    'MEENACHIL BUILDERS AND DEVELOPERS PRIVATE LIMITED',
    'ATCRAFT INNOVATIONS PRIVATE LIMITED',
    'NEXTENG ENVIRO PRIVATE LIMITED',
    'CHILLMAX TECHNOLOGIES PRIVATE LIMITED',
    'BRUSHLESS MOTORS INDIA PRIVATE LIMITED',
    'SEIKODENKI INDIA PRIVATE LIMITED',
    'PRAVIK STUDIOS PRIVATE LIMITED',
    'RIGHT SOURCING SOLUTIONS INDIA PRIVATE LIMITED',
    'IMUZE MUSIC MANAGEMENT PRIVATE LIMITED',
    'GOYAM DIGITAL PRODUCTS PRIVATE LIMITED',
    'GAUSIN INTERNATIONAL ENGINEERS PRIVATE LIMITED',
    'MANEVA CONSULTING PRIVATE LIMITED',
    'GO GAGA MATCHMAKING PRIVATE LIMITED',
    'ABMM MAHESHWARI RELIEF FOUNDATION',
    'SBV NIDHI LIMITED',
    'ASSIGNIA INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'ASCENDERS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'At capital advisory india private limited',
    'ASPECT CONTACT CANTRE SOFTWARE INDIA PVT LTD',
    'AS VISAS AND PERMITS COM PRIVATE LIMITED',
    'ASCENSO ENVIRO PVT LTD',
    'ASSURED ADVERTISING and MEDIA PRIVATE LIMITED',
    'ASYMMETRIQUE COMMUNICATION PVT LTD',
    'ASM INDUSTRIES INDIA PVT LTD',
    'ASP CREW MANAGEMENT INDIA PRIVATE LIMITED',
    'AT AND F INDIA FABRICATION PRIVATE LIMITED',
    'ARZOO COM INDIA PRIVATE LIMITED',
    'ASSOCIATED HOSPITALITY AND DEVELOPERSPRIVATE LIMITED PARTIX',
    'ASKLOGGISTICS SERVICES (INDIA) PRIVATE LIMITED',
    'ASMEETA INFRATECH LTD',
    'ATB CARGO PRIVATE LIMITED',
    'ASCENTECH AERO PRIVATE LIMITED',
    'AUTHBRIDGE RESEARCH SERVICES PVT LTD',
    'AUTONIC ENERGY SYSTEMS PVT LTD',
    'AVAAMO TECHNOLOGIES PVT LTD',
    'ATS INFOTECH PVT LTD',
    'AURA CLOTHING PRIVATE LIMITED',
    'AUNDE INDIA LIMITED',
    'AXIOM GEN NXT INDIA PVT LTD',
    'AVIJIT ESTATE and HOLDINGS LIMITED',
    'AUROIN INDIA LTD',
    'AVN AROGYA HEALTH CARE LIMITED',
    'AUTOPRESS INDIA PVT LTD',
    'AUXILINK PROJECTS & MACHINERY PRIVATELIMITED',
    'AVIAN MEDIA PVT LTD',
    'ATUL HOUSING AND CONSTRUCTIONS PRIVATE LIMITED',
    'AVS CARGO MANAGEMENT SERVICES PVT LTD',
    'AUTOSTRIPING INDIA PRIVATE LIMITED',
    'Axis Integrated Systems Ltd',
    'AVINASH CARGO PVT LTD',
    'AURA INTEGRATED SOLUTIONS PRIVATELIMITED',
    'AXA ASSISTANCE INDIA PRIVATE LIMITED',
    'AURANGABAD JALNA TOLL WAY LTD',
    'AUTUS WEALTH MANAGEMENT PRIVATE LIMITED',
    'AVGRAPHIC DESIGNERS PRIVATE LIMITED',
    'AVENUES INDIA PRIVATE LIMITED',
    'AVRORA INDIA MARINE SYSTEMS PRIVATE LIMITED',
    'AU INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'Automotive Components Technology India Pvt Ltd',
    'awanti poly moulds pvt ltd',
    'AVENUE HOTELS AND RESORTS PVT LTD',
    'AXIS CROP SCIENCE PVT LTD',
    'AVL INDIA SOFTWARES PVT LTD',
    'Autoneum nittoku sound proof products india pvt ltd',
    'ATUM IT SERVICES INDIA PRIVATE LIMITED',
    'AUTOMOTIVE DESIGN & ENGINEERING SOLUTIONS PRIVATE LTD',
    'AXIS FACADE CONSULTING PRIVATE LIMITED',
    'AVIK PHARMACEUTICALS LIMITED',
    'AUDIENCE COMMUNICATIONS SYSTEMS INDIA PVT LTD',
    'AVULZECONSULTING PRIVATE LIMITED',
    'ATONARP MICRO SYSTEMS INDIA PVT LTD',
    'ATS DREAMZONE PRIVATE LTD',
    'B EARTH AND SPIRE INDIA PRIVATE LIMITED',
    'BANSAL CLASSES PVT LTD',
    'BC WEB WISE PVT LTD',
    'B JAIN PHARMACEUTICALS PRIVATE LIMITED',
    'BASANT WIRE INDUSTRIES PVT LTD',
    'BALANI INFOTECH PVT LTD',
    'BATHLA ALUMINIUM PVT LTD',
    'BAYATREE INFOCOMM.PVT.LTD',
    'AZAZO PVT LTD',
    'barnet india pvt ltd',
    'BASECAMP INDIA PRIVATE LIMITED',
    'B L LIFESCIENCES PVT LTD',
    'BANSAL CEMENT PVT LTD',
    'BD SHAH SECURITIES LTD',
    'BADOTHERM INSTRUMENTS HOLLAND PVT LTD',
    'AYOKI CEMBOL ERECTORS PVT LTD',
    'BARQUE HOTELS PVT LT D',
    'B Shah Impex Private limited',
    'B AND B DEVELOPERS AND BUILDERS PRIVATE LIMITED',
    'B L R KNITS PRIVATE LIMITED',
    'B9 BEVERAGES PRIVATE LIMITED',
    'BALPRADA HOTELS AND HOSPITALITY PRIVATE LIMITED',
    'BCL SECURE PREMIES PVT LTD',
    'BAGRRYS INDIA LIMITED',
    'BALAJI INTEGRATED SHIPPING INDIA PVT LTD',
    'BALTIC TESTING INDIA PVT LTD',
    'BD AND P HOTELS INDIA PRIVATE LIMITED',
    'AZIMUTH SOFTWARE INDIA PRIVATE LIMITED',
    'BBM ACOUSTIC INDIA PVT LTD',
    'BANYAN TOURS AND TRAVELS PVT LTD',
    'BASIX SUB-K ITRANSACTIONS LIMITED',
    'B A FABRICATORS and ENGINEERS pvt LTD',
    'BD AGRICULTURE INDIA PVT LTD',
    'BARPHANI CARD COMMERCE PVT LTD',
    'BANYAN TREE ADVISORS PVT LTD',
    'B M M ISPAT LIMITED',
    'AYATI LABS PRIVATE LIMITED',
    'BAFNA HEALTH CARE PRIVATE LIMITED',
    'BARRY WEHMILLER INTERNATIONAL PRIVATE LIMITED',
    'B3INFOTECH PRIVATE LIMITED',
    'B I R SOLUTIONS INDIA PRIVATE LIMITED',
    'BASKET OPTION PRIVATE LIMITED',
    'BANAI AUTO WORKS PRIVATE LIMITED',
    'B D INDUSTRIES PUNE PRIVATE LIMITED',
    'BAMBOO ROSE INDIA PRIVATE LIMITED',
    'BASIX HOME FURNITURE PVT LTD',
    'BC EXAMINATIONS AND ENGLISH SERVICES INDIA PVT LTD',
    'BEE K BEE PRINTS PVT LTD',
    'Better Power Services Pvt Ltd',
    'BHATTAD FACILITIES MANAGEMENT PVT LTD',
    'BESURE HEALTH CARE PVT LTD',
    'BERKELEY RETAILS LIMITED',
    'BHG ASSOCIATES PRIVATE LIMITED',
    'bhartiya global marketing ltd',
    'BHUNIT ENGINEERING CO PRIVATE LIMITED',
    'bharat road network ltd',
    'BHEJO ECOMMERCE PRIVATE LTD',
    'BHARAT PRAKASHAN DELHI LTD',
    'Beid healthcare private limited',
    'Bewell Labs Pvt Ltd',
    'BHARGAVAS MUSIK PRIVATE LIMITED',
    'BENCHMAARKER HR SOLUTIONS PRIVATE LIMITED',
    'BHARAVI LABORATORIES (P) LTD',
    'BHARATI DEFENCE AND INFRASTRUCTURE LIMITED',
    'BHARAT RE INSURANCE BROKERS PRIVATE LIMITED',
    'BECK & POLLITZER INDIA PVT LTD',
    'BHURJI ELECTRONICS PVT LTD',
    'BDS PROJECTS INDIA PVT LTD',
    'BENCHMARK COMPUTER SOLUTIONS PVT LTD',
    'BEYOND BORDERS LEARNING PROGRAMS INDIA PRIVATE LIMITED',
    'BHAFRA SPIRITS PRIVATE LIMITED',
    'BEHR PROCESS PAINTS INDIA PRIVATE LIMITED',
    'BETTER WORLD TECHNOLOGY PVT LTD',
    'Benison Technologies Pvt Ltd',
    'Becto Flex Containment System Pvt Ltd',
    'BEST BUY SOFTWARE AND SOLUTIONS PRIVATE LIMITED',
    'BEYOND KEY SYSTEMS PVT LTD',
    'BDS SERVICES PVT LTD',
    'BELWO SERVICES INDIA PRIVATE LIMITED',
    'BELOORBAYIR BIOTECH LTD',
    'BENCHMARK SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'BLUE WHALE ADVISORY SERVICES PVT LTD',
    'BLUE DREAMZ ADVERTISING PVT LTD',
    'BOHRA CARS PVT. LTD.',
    'BLACK OLIVE VENTURES PVT LTD',
    'BLOOM INFRASTRUCTURE AND LOGISTICS INDIA PVT LTD',
    'BOMBAY GAS CO LTD',
    'Bombay Swadeshi Stores Ltd',
    'BLUECHIP ONLINE SHARES INDIA PRIVATE LIMITED',
    'BLUEMOON LOGESTICS PVT LTD',
    'BLISS REFRIGERATION PVT LTD',
    'BLISSWOOD GLOBAL IMPEX PVT LTD',
    'BLUESTAR AIR TRAVEL SERVICES I PVT LTD',
    'BOMBAY OXYGEN CORPORATION LIMITED',
    'BIZINNOVATIV SOFTWARE PRIVATE LIMITED',
    'BLUE HARP TECHNOLOGIES PVT LTD',
    'BIGTECH SOFTWARE PRIVATE LIMITED',
    'BLISSTERING SOLUTIONS PRIVATE LIMITED',
    'bikham information technology pvt ltd',
    'BLACKMELON ADVANCE TECHNOLOGY COMPANYPRIVATE LIMITED',
    'BMD MACHINERY INDIA PRIVATE LIMITED',
    'BLUEJAY ENTERPRISES PVT LTD',
    'biking food products pvt ltd',
    'BNB SECURITY AND AUTOMATION SOLUTIONS PVT LTD',
    'BIZDOM LEARNING TECHNOLOGIES PRIVATE LIMITED',
    'BIZDATA TECHNOLOGIES PRIVATE LIMITEDÃ‚Â',
    'BONA SERA HOTELS LTD',
    'BLUE NEEM MEDICAL DEVICES PVT LTD',
    'BOLAS INTELLI SOLUTIONS PVT LTD',
    'Biogentek bg (india) private limited',
    'BLINK DIGITAL INDIA PRIVATE LIMITED',
    'BINARY WEB SOLUTIONS INDIA PRIVATE LIMITED',
    'BLUESHIFT INFORMATION SYSTEMS PRIVATE LIMITED',
    'BIOZED ENGINEERING PVT LTD',
    'BIMARIAN INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'BLACK BEAN DIGITAL MARKETING PVT LTD',
    'BLAZE CLOTHING INDIA PRIVATE LIMITED',
    'BOI MEDIA &ENTERTAINMENT PRIVATE LTD',
    'BOMBAY TECHNO-PLAST PRIVATE LIMITED',
    'BLACK HAWK SECURITY SYSTEM PRIVATE LIMITED',
    'BIGDEAL PROPERTIES INDIA PRIVATE LIMITED',
    'BILLIONAPPS TECHNOLOGIES PRIVATE LIMITED',
    'BIODEAL PHARMACEUTICALS PVT LTD',
    'BLUEFLOCK TECHNOLOGIES PVT LTD',
    'BIG WONG HOSPITALITY PVT LTD',
    'BIRD RETAIL PVT LTD',
    'BLISS INNS PVT LTD',
    'BONANZA HUMAN RESOURCE PVT LTD',
    'BIRLA HEALTHCARE AYURVEDA PVT LTD',
    'BISCO BIO SCIENCES PRIVATE LIMITED',
    'BROOKFIELD MULTIPLEX (INDIA) PRIVATE LIMITED',
    'BTC TOURS AND TRAVELS PVT LTD',
    'BRUCKE PHARMA PVT LTD',
    'Box Investment Advisors Private Limited',
    'C AND C HOTELSVENTURE PRIVATE LIMITED',
    'BUNTS HOTELS PVT LTD',
    'BURN GYM AND SPA PVT LTD',
    'BWF TEC INDIA PVT LTD',
    'BRAND BEE MANAGEMENT PVT LTD',
    'BOSE SOFTWARE PVT LTD',
    'BOYSEN INDIA LIMITED',
    'BREEZ BUILDERS AND DEVELOPERS PVT LTD',
    'BRIC DESIGNS PVT LTD',
    'C2 WORKSHOP PRIVATE LIMITED',
    'BRADY SERVICES PVT LTD',
    'BYSTRONIC LASER INDIA PVT LTD',
    'C SQUARE INFO SOLUTIONS PVT LTD',
    'BUSISOFT INFOTECH (INDIA) PRIVATELIMITED',
    'BOPARAIS MARTIAL SECURITY PRIVATE LIMITED',
    'BRIGHT LIFECARE PVT LTD',
    'BVM STORAGE SOLUTION PVT LTD',
    'BRICK AND BYTE INNOVATIVE PRODUCTSPRIVATE LIMITED',
    'BORING BRANDS PRIVATE LTD',
    'BRAND REALTY SERVICES LIMITED',
    'C TEL INFOSYSTEMS PVT LTD',
    'BPO CONNECT(INDIA) PRIVATE LIMITED',
    'BPI INDIA PRIVATE LIMITED',
    'BRISLOY TOOLS INDIA PVT LTD',
    'BRAHM ARPAN ORGANIC PVT LTD',
    'BRICSA CONSULTING PVT LTD',
    'Brisk technovision private limited',
    'c v karia clearing and forwarding pvt ltd',
    'BRANNIGAN RELOCATION PVT LTD',
    'BOWMAN and ARCHER PHARMA MACHINES INDIA PRIVATE LIMITED',
    'BRESCON CONSULTANTS PRIVATE LIMITED',
    'BRINDAVAN PRINT SOLUTIONS PRIVATELIMITED',
    'BUHARIWALA CORPORATION PVT LTD',
    'BOOKER SATNAM WHOLESALE PRIVATE LIMITED',
    'BREAD AND SPREAD HOTELS PRIVATE LIMITED',
    'BOP REALTY PVT LTD',
    'BROADWAYS CHEMTECH PRIVATE LIMITED',
    'BRAEMAR TECHNICAL SERVICES (OFFSHORE) INDIA PRIVATE LIMITED',
    'BRAINER TRADE AND FIN-TECH PRIVATE LIMITED',
    'BRAND INSIGHT INTERGRATED MAC PVT LTD',
    'BOROUGE INDIA PRIVATE LIMITED',
    'BRANDSCAPES CONSULTANCY PVT LTD',
    'C B ONLINE PRIVATE LIMITED',
    'C J ONLINE PVT LTD',
    'BUSINESS CO ORDINATION HOUSE PRIVATE LIMITED',
    'BRITA India Water Solutions PVT LTD',
    'CARMA INTERNATIONAL INDIA PVT LTD',
    'CASTMASTER MOBITEC INDIA PRIVATE LIMITED',
    'CANTATA TECHNOLOGIES SERVICES PRIVATELIMITED',
    'CAS WEIGHING INDIA PVT LTD',
    'CELCIUS TECHNOLGIES PVT. LTD.',
    'CELESTIAL INDUSTRIES PVT LTD',
    'CAPLET INDIA PRIVATE LTD',
    'CARRIER WHEELS PVT LTD',
    'CANNON HYGIENE (INDIA) PRIVATE LIMITED',
    'Ceiling Impex Pvt Ltd',
    'CACHEBOX INDIA PRIVATE LIMITED',
    'CARGO NAVIGATION SERVICES PRIVATE LTD',
    'CADD CENTRE INDIA PRIVATE LTD',
    'cadence electrical engineers pvt ltd',
    'CAPITAL APPARELS TECHNOLOGY PVT LTD',
    'CBF COMPONENTS PVT. LTD.',
    'CAMP SMA PRIVATE LIMITED',
    'CELLO HOUSEHOLD APPLIANCE PVT LTD',
    'CANARYS AUTOMATIONS PVT LTD',
    'CAPITAL CONTROLS INDIA PRIVATE LIMITED',
    'CANADA PURE FILLERS PRIVATE LIMITED',
    'CD EQUIFINANCE PVT LTD',
    'CELEBRATIONS EVENTS PVT LTD',
    'CAPRICON REALTY LIMITED',
    'CARGO INSPECTORS & SUPERINTENDENCECOMPANY PVT.LTD.',
    'CAREWELL TRAVELS and TOUR PRIVATE LIMITED',
    'CALLIDUSCLOUD INDIA PRIVATE LIMITED',
    'CARVER TECHNOLOGY AND EQUIPMENT PRIVATE LIMITED',
    'CBS INTERNATIONAL PROJECTS PVT LTD',
    'CAMELOT ENTERPRISES PRIVATE LIMITED',
    'CELLBIOS HEALTHCARE AND LIFESCIENCES PRIVATE LIMITED',
    'CEDAR INDIA CONSULTING PRIVATE LIMITED',
    'CATALYST MANAGEMENT SERVICES PVT LTD',
    'CARPE HEAT TRANSFER PVT LTD',
    'CADFEM ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'CAMPUS GROUP EDUCATION INDIA PVT LTD',
    'CAPER COURIER P LTD',
    'CARE RISK SOLUTIONS PRIVATE LIMITED',
    'C2C ORGANIZATIONAL DEVELOPMENT PVT LTD',
    'CARGO GEAR SERVICES INDIA PRIVATE LIMITED',
    'CATEX OVERSEAS IMPORT EXPORT PVT LTD',
    'CELIGO INDIA PVT LTD',
    'CAASP LABS PVT LTD',
    'CARNIVAL FILMS PVT LTD',
    'CARNIVAL ENTERTAINMENT and MEDIA PRIVATE LIMITED',
    'CARDINAL HEALTH MEDICAL PRODUCTS INDIA PRIVATE LIMITED',
    'CATERPILLAR CARGO SOLUTIONS INDIAPRIVATE LIMITED',
    'CGMP PHARMA N PLANS PRIVATE LIMITED',
    'CHATHA FOODS PRIVATE LIMITED',
    'CHADHA SALES PVT LTD',
    'Chime Tours Pvt Ltd',
    'CHIRAG ICE FACTORY PVT LTD',
    'CENTURION LABORATORIES PVT LTD',
    'CHEGG INDIA PVT LT',
    'CHETANA FINANCIAL SERVICES LIMITED',
    'CHEMMANUR GOLD PALACE INTERNATIONAL LTD',
    'CHAME AGRO INDUSTRIES PVT LTD',
    'Chelsea West Architects Pvt Ltd',
    'CEREDOX TECHNOLOGIES PRIVATE LIMITED',
    'CELLO TIPS AND PENS PRIVATE LIMITED',
    'CHHEDA ELECTRICAL & ELECTRONIC PVT LTD',
    'CELLO WRITING INSTRUMENTS AND CONTAINERS PRIVATE LIMITED',
    'CIESS TEXAUX SPECIALITY CHEMICALSPRIVATE LIMITED',
    'CHALMERS ENGINEERING (INDIA) PRIVATE LIMITED',
    'CHAITRA HOSPITALITY AND DEVELOPMENT SERVICES PRIVATE LIMITED',
    'CFC LOGISTICS PRIVATE LTD',
    'CELLO WRITING AIDS PVT LTD',
    'CENZA TECHNOLOGIES P LTD',
    'CENTRE FOR MONITORING INDIAN ECONOMY PVT LTD',
    'CENTURY AUTO ENGINEERING (PVT) LTD',
    'CHRISTIAN DIOR TRADING INDIA PVT LTD',
    'CEPTES SOFTWARE PVT LTD',
    'CHAMUNDA HEALTH CARE PVT LTD',
    'CHRISTOPHER CHARLES BENNINGER ARCHITECTS PRIVATE LIMITED',
    'CHEMIE ALLIANCE INDIA PRIVATE LIMITED',
    'CHEERFUL COMMERCIAL PVT LTD',
    'CENVEO PUBLISHER SERVICES INDIA LIMITED',
    'CHANGO YANGTHANG HYDRO POWER LTD',
    'CHEMTURA CHEMICALS INDIA PRIVATE LIMITED',
    'CIBERSPRING TECHNOLOGIES INDIA PVT LTD',
    'CEO INFOTECH PRIVATE LIMITED',
    'CIGNEX DATAMATICS TECHNOLOGIES LIMITED',
    'Choice Merchandise Broking Pvt ltd',
    'Choice Capital Advisors Private ltd',
    'Chandni overseas private limited',
    'CIAN HEALTHCARE PRIVATE LIMITED',
    'CI L TEXTILES PRIVATE LIMITED',
    'CHARU APPEAREL MANUFACTURING CO PRIVATE LIMITED',
    'CHEMLINKER TRADEX PVT LTD',
    'CHETTINAD SECURITY SERVICES PRIVATELIMITED',
    'CENTREM DIGITAL PRIVATE LIMITED',
    'CICC AUTOMATION TECHNOLOGIES PVT LT',
    'CHIRON INSTRUMENTS INDIA P LTD',
    'Civitech Developers Pvt Ltd',
    'COGENT IT SOLUTIONS PVT LTD',
    'CIPLA BIOTECH PVT LTD',
    'CLEARPACK AUTOMATION PVT LTD',
    'CLEAN ENERGY SYSTEMS INDIA PVT LTD',
    'Committed worldwide express private limited',
    'COMMITTED CARGO CARE PRIVATE LIMITED.',
    'COLSTON BATH & SPA PVT LTD',
    'Classic Synergy India Pvt Ltd',
    'Cml biotech private limited',
    'CLIFFORD FACILITY SERVICES PRIVATE LIMITED',
    'COHN & WOLFE SIX DEGREES PR CONSULTANTSPRIVATE LIMITED',
    'Cochin mini muthoottu nidhi limited',
    'COMFIT and VALVES PRIVATE LIMITED',
    'COGNITIVECLOUDS SOFTWARE PVT LTD',
    'CIRRIUS TECHNOLOGIES PVT LTD',
    'CLIMAVENETA CLIMATE TECHNOLOGIES PVT LTD',
    'CLOUDSPACE TECHNOLOGIES PRIVATE LIMITED',
    'CLASSIC BOTTLE CAPS PRIVATE LIMITED',
    'COGNISCIENT BUSINESS SOLUTIONS PVT LTD',
    'Ck Airtech India pvt ltd',
    'CITY LIFESPACES PVT LTD',
    'CLIENT NETWORK SERVICES INDIA PRIVATE LIMITED',
    'CLASSIC PRODUCTS PVT LTD',
    'COGNAM TECHNOLOGIES PVT LTD',
    'COALITION DEVELOPMENT SYSTEMS (INDIA) PRIVATE LIMITED',
    'CODE RED FILMS PVT LTD',
    'COLLATERAL MEDICAL PVT LTD',
    'CIRCUITECTS ELECTRONIC SOLUTIONS PVT LTD',
    'COCHIN HALLMARK CO PRIVATE LIMITED',
    'COLUMBIA MACHINE ENGINEERING INDIA PVT LTD',
    'COACTION COM PRIVATE LIMITED',
    'CLINSEARCH HEALTHCARE SOLUTIONS PVT LTD',
    'CIMPRESS TECHNOLOGIES PRIVATE LIMITED',
    'COMGUARD INFOSOL PRIVATE LIMITED',
    'CILICANT CHEM PRIVATE LIMITED',
    'CINEOM BROADCAST INDIA PRIVATE LIMITED',
    'CODE RAFT SOLUTIONS PRIVATE LIMITED',
    'COCO CARBONS INDIA PVT LTD',
    'COGITATE TECHNOLOGY SOLUTIONS INDIA PRIVATE LIMITED',
    'CLASSIC MALL DEVELOPMENT COMPANY PRIVATE LIMITED',
    'CINEMACRAFT INDIA PVT LTD',
    'CIVIL-AID TECHNOCLINIC PRIVATE LIMITED',
    'CMN Distributors Pvt Ltd',
    'CNRG ENERGY INDIA PRIVATE LIMITED',
    'CLG Retail Pvt Ltd',
    'COMECER MEDICAL SYSTEM PRIVATE LIMITED',
    'CORAZA TECHNOLOGIES PRIVATE LIMITED',
    'CORNELL OVERSEAS PVT LTD',
    'CORPORATE PROFESSIONALS SECRETARIAL SERVICES PRIVATE LIMITED',
    'CORPORATE PROFESSIONAL INDIA PVT LTD',
    'COSMO SOLUTIONS PVT LTD',
    'COMNET PUBLISHERS PVT LTD',
    'CONSISTENT INFOSYSTEMS PVT LTD',
    'COMMUNICATIONS TEST DESIGN INDIA PRIVATE LIMITED',
    'COSMOS IMPEX INDIA PVT LTD',
    'COMPUTERS NETWORK AND TELECOM INDIA PRIVATE LIMITED',
    'COSMIC STRANDS EPUBLISHING PVT LTD',
    'COVIDIEN HEALTHCARE INDIA PRIVATE LIMITED',
    'CORPORATE CATALYST INDIA PRIVATE LIMITED',
    'CORE COMPETENCY MARINE SERVICES PRIVATE LIMITED',
    'Consindia pvt ltd',
    'CONNECTPRO MANAGEMENT CONSULTANT PVT. LTD.',
    'CONCEPTS AND SOLUTIONS EVENT SERVICES PRIVATE LIMITED',
    'CORONET ENGINEERS PVT LTD',
    'Cooper Elevators India Pvt Ltd',
    'COMMUNICATION MEDIA PRODUCTS INDIA PRIVATE LIMITED',
    'CONTROLCASE INTERNATIONAL PVT LTD',
    'COMMUNE PROPERTIES INDIA PVT LTD',
    'COMPUTER FACTORY INDIA PVT LTD',
    'COUNTRY DEVELOPMENT & MANAGEMENT SERVICES LTD',
    'CONCEPT INTERNATIONAL BUSINESS CONSULTING PRIVATE LIMITED',
    'CONCORDE AIR LOGISTICS LTD',
    'COPYRIGHT INTEGRITY ADVISORY INDIA PVT LTD',
    'COPART INDIA PVT LIMITED',
    'CONVERGYS STREAM PRIVATE LIMITED',
    'CONCEPT INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CONVENTIONS AND FAIRS INDIA PRIVATE LIMITED',
    'COSMOS BON VOYAGE AND FOREX PVT LTD',
    'ContentSphere Technologies India Private Limited',
    'CONVERGYS INFOWAVZ PRIVATE LIMITED',
    'conventus technologies pvt ltd',
    'COWTOWN LAND DEVELOPMENT PVT LTD',
    'CONNECTAERO AVIATION SERVICES INDIA PRIVATE LIMITED',
    'CONTRACT RESOURCES PETROCHEM SERVICES (INDIA) PRIVATE LIMITED',
    'COOL STOP INDIA PVT LTD',
    'CORE ENERGY SYSTEMS PRIVATE LIMITED',
    'COREN TECHNO MECH PRIVATE LIMITED',
    'CONDOR AIR SERVICES PVT LTD',
    'CONSTRUCTION SPECIALTIES INTERNATIONAL INDIA PVT LTD',
    'CORPORATE INFOTECH PRIVATE LIMITED',
    'CONGRUENT IT SERVICES PRIVATE LIMITED',
    'CORPORATE LANDLORD INDIA PRIVATE LIMITED',
    'Cryoviva Biotech Pvt Ltd',
    'CTSOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CRAFTS PALACE HOTELS INDIA PRIVATE LIMITED',
    'CREATIVE SHADOWS PROMOTION PVT LTD',
    'CREATIVE GLOBAL SERVICES PVT LTD',
    'CUSTOMER CENTRIA DIGITAL SOLUTIONS PRIVATE LIMITED',
    'CYRUS RECLAIMER AND ENGINEERING SERVICES PVT LTD',
    'CRAY SUPERCOMPUTERS (INDIA) PRIVATELIMITED',
    'CREATIVE VALUERS & ENGINEERS PRIVATE LIMITED',
    'CQENT CONSULTING AND TECHNOLOGY PRIVATE LIMITED',
    'CRYSTAL ENVIRONMENT TECHNOLOGIES PVT LTD',
    'CUTTING EDGE SOFTWARE PVT LTD',
    'CRESTRON ELECTRONICS INDIA PRIVATE LIMITED',
    'D.K. HOSPITALITY PVT LTD',
    'CRYSTAL GRANITE & MARBLE PVT LTD',
    'CSDC INDIA PVT LTD.',
    'CREST WEALTH MANAGEMENT PRIVATE LIMITED',
    'CRALE FOODLINK PRIVATE LIMITED',
    'CREO LIFTSTYLES PVT LTD',
    'CUMBALLA HILL LIFE SCIENCES PRIVATE LIMITED',
    'CRIF HIGH MARK CREDIT INFORMATION SERVICES PVT LTD',
    'Cse panels private limited',
    'CYGNUS E SOLUTIONS PRIVATE LIMITED',
    'CYBERACE INFOVISION PVT LTD',
    'CRYSTAL HR AND SECURITY SOLUTIONS PVT LTD',
    'CYBERSWIFT INFOTECH PVT. LTD.',
    'CUREWORTH DRUGS AND INTERMEDIATES PRIVATE LIMITED',
    'Craftway engineers limited',
    'CRYSTAL BI TECHNOLOGIES PRIVATE LIMITED',
    'CREATIVE POLYFILMS LIMITED',
    'D K CLEARING And SHIPPING AGENCY PVT LTD',
    'CUBATIC SHIMUL VENTURES PRIVATE LIMITED',
    'CRIMSON COMMODITY LIMITED',
    'CROPNOSYS INDIA PVT LTD',
    'CREATIVE TOURS AND TRAVEL (INDIA) PRIVATE LIMITED',
    'CYBER POWER SYSTEMS INDIA PRIVATE LIMITED',
    'CUBIC COMPUTING PRIVATE LIMITED',
    'CRESCENT PAYMENTS PRIVATE LIMITED',
    'CRISS FINANCIAL HOLDINGS LIMITED',
    'CSAV GROUP AGENCIES INDIA LIMITED',
    'D VOIS N SSV BROADBAND PRIVATE LIMITED',
    'CSR TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'CYBERNETYX TECHNIK PVT LTD',
    'CROSS LINK SHIPPING PRIVATE LIMITED',
    'CRESCORE WEALTH MANAGEMENT SERVICES PVT LTD',
    'culture holidays india pvt ltd',
    'CYBIZ BRIGHTSTAR RESTAURANTS PRIVATE LIMITED',
    'D J BUILDERS PRIVATE LIMITED',
    'CURO HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'cranes software international ltd',
    'DELTA MAGNETS LIMITED',
    'DATA-CORE (INDIA) PRIVATE LIMITED',
    'DC WEB SERVICES PVT LTD',
    'DELHI ART GALLERY PRIVATE LIMITED',
    'DARS INFOTECH PRIVATE LIMITED',
    'DECCAN ENTERPRISES LIMITED',
    'DELSYS AUTOMATION TECHNOLOGIES PRIVATELIMITED',
    'DBAUX TECHNOLOGIES PVT LTD',
    'DAVIS SOFTWARE SOLUTIONS PVT LTD',
    'Deccan 360 airsea logistics private limited',
    'DAIKAFFIL CHEMICALS INDIA LTD',
    'DEBONO FLEXCOM INDIA LIMITED',
    'DELPHI RESEARCH SERVICES PVT LTD',
    'Decorhome (india) private limited',
    'DBCOM SYSTEM SOFTWARE INDIA P LTD',
    'DAJIKAKA GADGIL DEVELOPERS PRIVATE LIMITED',
    'dasmesh airconditioning engineers pvt ltd',
    'DELLA TECNICA OFFICE SYSTEM PVT LTD',
    'DECCAN RESORTS MAHAD PVT LTD',
    'datanet india pvt ltd',
    'DATAFLOAT TECHNOLOGIES INDIA PVT LTD',
    'Deepak chemtex private limited',
    'DARSHAN SOFTECH PVT LTD',
    'DELTA ELECTRO MECHANICAL PVT LTD',
    'DACCESS SECURITY SYSTEMS PVT LTD',
    'DATAGENIC INDIA PRIVATE LIMITED',
    'Damodartech international private limited',
    'DARE FASHION PVT LTD',
    'DELF CONSULTING ENGINEERS INDIA PRIVATE LIMITED',
    'DDS TPM FLAVOURS PRIVATE LIMITED',
    'DADAJEE DHACKJEE INFOTECH PVT LTD',
    'D-cube analytics private limited',
    'DATA TEMPLATE INFOTECH PVT LTD',
    'DATACARD INDIA PRIVATE LIMITED',
    'DAICEL CHIRAL TECHNOLOGIES (INDIA)PRIVATE LIMITED',
    'DABANG DUNIA PUBLICATIONS',
    'DAKSHIN DILLI SWACHH INITIATIVES LIMITED',
    'DELUXE LABORATORIES PVT LTD',
    'Delta Agrigenetics Pvt Ltd',
    'DELTA MECHCONS INDIA LIMITED',
    'DATAPAGE DIGITAL SERVICES PVT LTD',
    'DELIGHT LOGISTICS PVT LTD',
    'DELIVER PLUS LOGISTICS INDIA PVT LTD',
    'DATAFORMATICS CONSULTANCY PVT LTD',
    'DECAGON TELECOM PRIVATE LIMITED',
    'DELTA HEART CENTRE PRIVATE LIMITED',
    'Devicebook online services private limited',
    'DHANALAKSHMI SRINIVASAN CHIT FUNDSPRIVATE LIMITED',
    'DEWARS GARAGE LIMITED',
    'DIGIVAASI INTERACTIVE SERVICES PVT LTD',
    'DEYS MEDICAL STORES PVT LTD',
    'DINSHAWS DAIRY FOODS (CG) PRIVATE LIMITED',
    'DIVEKAR WALLSTABE AND SCHNEIDER PRECISION SEALS PRIVATE LIMITED',
    'DIMENSION ADVISORY SERVICES PVT LTD',
    'DGIPRO SYSTEMS PRIVATE LIMITED',
    'DGM INDIA INTERNET MARKETING PRIVATE LIMITED',
    'DIGITAL F5 MARKETING SERVICES PVT LTD',
    'DIVENSI SOLUTIONS PVT LTD',
    'DIGIPRO SYSTEMS PVT LTD',
    'Dhawala online solutions private limited',
    'DIGHI PORT LTD',
    'DHAMMANAGI DEVELOPERS PRIVATE LIMITED',
    'DIMO CASTINGS PRIVATE LIMITED',
    'DEV MANTRA FINANCIAL SERVICES PRIVATE LIMITED',
    'DIGICOM SYSTEMS BANGALORE PRIVATE LIMITED',
    'DIGI TRANS PVT LTD',
    'DEVDEEP PLYLAM GUJ PRIVATE LIMITED',
    'DHRUVA INFOTECH PRIVATE LIMITED',
    'DIANA WORD TRAVEL PVT LTD',
    'DINESH ENGINEERS PVT LTD',
    'DIE PLAST PRIVATE LIMITED',
    'DHANESH WEAVING PVT LTD',
    'DIGITAL TANTRA MEDIA SOLUTIONS PRIVATE LIMITED',
    'DESIGN OPTIMIZATION TECHNOLOGY PRIVATE LIMITED',
    'DHANVARSHA FINVEST LIMITED',
    'DISHA RETAIL FIXTURES PVT LTD',
    'DESIMD HEALTHCARE PRIVATE LIMITED',
    'DESIGN EXCELLENCE INDIA PVT LTD',
    'DESSERT MARINE SERVICES I PRIVATE LIMITED',
    'DISNEY ENTERTAINMENT INDIA LIMITED',
    'DHOTE OFFSET TECHNOKRAFTS PVT LTD',
    'DIGITAL INTEGRATED TECHNOLOGIES PVT LTD',
    'DIVINITI HOMES PVT LTD',
    'DIGINEXT EDUCATION PVT LTD',
    'DEVARYAA HOSPITALITIES PVT LTD',
    'DIALOGIC NETWORKS (INDIA) PRIVATELIMITED',
    'DISHA INTERIORS PRIVATE LIMITED',
    'DR SHAJIS MRI AND MEDICAL RESEARCH CENTRE PRIVATE LIMITED',
    'DR PAUL S MULTISPECIALITY CLINIC PRIVATE LIMITED',
    'DONGFANG ELECTRIC (INDIA) PRIVATELIMITED',
    'DR. B. LAL CLINICAL LABORATORY PRIVATELIMITED',
    'DOSHI ACCOUNTANTS S PRIVATE LIMITED',
    'DRISHTI SOFT SOLUTIONS PVT LTD',
    'DUET INDIA HOTELS AHMEDABAD PRIVATE LIMITED',
    'DUET INDIA HOTELS HYDERABAD PRIVATE LIMITED',
    'DR PADMAJA FERTILITY CENTRES PRIVATE LIMITED',
    'DOZCO INDIA PVT LTD',
    'DRK INTERNATIONAL FREIGHT FORWARDERSPRIVATE LIMITED',
    'Divya portfolio private limited',
    'DSQ ARCHITECTS PRIVATE LIMITED',
    'driftwood holidays pvt ltd',
    'DOLPHIN INKS PRIVATE LIMITED',
    'DQS CERTIFICATIONS INDIA PRIVATE LIMITED',
    'DMG INDIA PRIVATE LIMITED',
    'DOLAR SYSTEMS ANDSERVICES PRIVATE LIMITED',
    'DOLAT INVESTMENTS LIMITED',
    'DP WORLD PRIVATE LIMITED',
    'DORSCH CONSULT INDIA PVT LTD',
    'DR MARWAHS SKIN and LASER CENTRE PRIVATE LIMITED',
    'DUAL MANUFACTURING TECHNOLOGIES PRIVATELIMITED',
    'Dumadu Games Private Limited',
    'DOLAR ENGG INDUSTRIES PVT LTD',
    'DRD SOFTWARE AND SYSTEMS INDIA PRIVATE LIMITED',
    'DR.MEHTAS HOSPITALS PRIVATE LIMITED',
    'DREAMS CONSTRUCTION PVT LTD',
    'DOLLONS FOOD PRODUCTS PRIVATE LIMITED',
    'DJ LOGISTIC SOLUTIONS PRIVATE LIMITED',
    'DOCTORS ANALYTICAL LABORATORIES PRIVATE LIMITED',
    'DRAGON TECHNOLOGY DISTRIBUTION PRIVATE LIMITED',
    'DOORS AND DOORS SYSTEM INDIA PRIVATE LIMITED',
    'DK BAKINGS PVT LTD.',
    'DREAM THEATRE PVT LTD',
    'dr batras franchise pvt ltd',
    'DOCKENDALE SHIP MANAGEMENT INDIA PVT LTD',
    'DJO GLOBAL INDIA HEALTHCARE PVT LTD',
    'DOMACH TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DJ APPLIANCES PVT LTD',
    'DRG ANALYTICS AND INSIGHTS PRIVATE LIMITED',
    'DMI HOUSING FINANCE PVT LTD',
    'DRSCHUMACHER INDIA PVT LTD',
    'DIVYA ELECTRICAL TRANSFORMERS AND SERVICES PVT LTD',
    'DORMER TOOLS INDIA PVT LTD',
    'DP WOODTECH PRIVATE LIMITED',
    'E Travelvalue india private limited',
    'EARTHWISE HOSPITALITY AND ENTERTAINMENT HOLDINGS PVT LTD',
    'EBUSINESSWARE (INDIA) PRIVATE LIMITED',
    'EAST INDIA BEARING CO. PRIVATE LIMITED',
    'E-DURABLES ELECTRONICS PRIVATE LIMITED',
    'DVOIS SSV BROADBAND PRIVATE LIMITED',
    'DURLABH COMPUTERS PRIVATE LIMITED',
    'EARNEST SHIPPING & SHIP BUILDERS LTD Ã‚Â Ã‚Â Ã‚Â Ã‚Â',
    'EDELWEISS CUSTODIAL SERVICES LIMITED',
    'EDELWEISS INSURANCE BROKERS PVT LTD',
    'DUNNHUMBY IT SERVICES INDIA PVT LTD',
    'E I Design Private Limited',
    'EDGE BRAND ARCHITECTS INDIA PRIVATE LIMITED',
    'EB SOFTWARE INDIA PRIVATE LIMITED',
    'EagleSpeed International Logistics Pvt Ltd',
    'EABYAS INFO SOLUTIONS PRIVATE LIMITED',
    'EBENEZER TECHNOLOGIES PVT LTD',
    'ECLAT HEALTH SOLUTIONS PRIVATE LIMITED',
    'EAPPSYS INFO SOLUTIONS INDIA PRIVATELIMITED',
    'DYNAMIC STAFFING SERVICES PRIVATELIMITED',
    'E PLUS TECHNOLOGIES INDIA PVT TD',
    'EDAN MEDICAL INDIA PVT LTD',
    'ECUBE SALES SOLUTIONS PRIVATE LIMITED',
    'DYNE INFOTECH PVT LTD',
    'E CITY PROJECTS CONSTRUCTION PRIVATE LIMITED',
    'DURONTO TECHNOLOGIES PVT LTD',
    'EAND M CONSULTANTS PVT LTD Ã‚Â Ã‚Â Ã‚Â',
    'E BIZ SOLUTION PRIVATE LIMITED',
    'ECONIFY INFOTECH PRIVATE LIMITED',
    'EAC EURO ASIA CONSULTING PRIVATE LIMITED',
    'Edara Simple Media Solutions Pvt Ltd',
    'DURATEX SILK MILLS LIMITED',
    'E Land Fashion India Pvt Ltd',
    'ECONSHIP MARINE PRIVATE LIMITED',
    'E COM STREET INFOSERVICES INDIA PRIVATE LIMITED',
    'E SOFT TECHNOLOGIES LIMITED',
    'E LAND SYSTEMS INDIA PRIVATE LIMITED',
    'ECOTECH INDUSTRIES PVT LTD',
    'Dynamic IT Solution Pvt Ltd',
    'EAST WEST ASSIST TPA PRIVATE LIMITED',
    'E HOMES INFRASTRUCTVRE PVT LTD',
    'EDENRED INDIA PRIVATE LIMITED',
    'DYNARX TECHNOLOGY INDIA LIMITED',
    'ELCON SYSTEMS PRIVATE LIMITED',
    'ELICO HEALTHCARE SERVICES PRIVATE LIMITED',
    'ELECTRA ACCUMULATORS PRIVATE LIMITED',
    'EMINENCE TOWNSHIPS INDIA PRIVATE LIMITED',
    'ELECTRO FORCE INDIA PRIVATE LIMITED',
    'ELMEX ELECTIC PVT LTD',
    'ELECTROLEAD (PUNE) PVT.LTD',
    'ENCORE IT SERVICES SOLUTIONS PVT LTD',
    'EKAA FURNITURE PVT LTD',
    'ENERGY PLUS POWER SERVICES PRIVATELIMITED',
    'EMERALD TESTINGS (INDIA) PRIVATE LIMITED',
    'EMBASSY INDUSTRIAL PARKS PVT LTD',
    'EKAMTEC SYSTEMS LIMITED',
    'Embassy vtv infrastructure management private limited',
    'ENERGO CONSTRUCTION LIMITED',
    'EMUGE FRANKEN INDIA PRIVATE LIMITED',
    'EMITTANCE PRIVATE LIMITED',
    'ELECTRONIC AND ENGINEERING COMPANY INDIA PRIVATE LIMITED',
    'EKBOTE S LOGS AND LUMBERS PRIVATE LIMITED',
    'EGSTON ELECTRONICS INDIA PRIVATE LIMITED',
    'ELITE ITSERVICES INDIA PRIVATE LIMITED',
    'ELIND INDUCTION FURNACES P LTD',
    'ELEX INDIA PRIVATE LIMITED',
    'ELF SHIPPING INDIA PVT LTD',
    'ENCORP POWERTRANS PVT LTD',
    'EMART SOLUTIONS INDIA PRIVATE LIMITED',
    'EINS INSTITUTE OF MANAGEMENT TECHNOLOGY AND RESEARCH PRIVATE LIMITED',
    'ELPEE MANAGED PRINT SOLUTIONS PRIVATELIMITED',
    'EMERGENT MEDI TECH INDIA PRIVATE LIMITED',
    'ELECTRICA ENGINEERS INDIA PRIVATE LIMITED',
    'ELISIR LIFESTYLE PVT LTD',
    'EMARKETZ INDIA PVT LTD',
    'ENDEKA CERAMICS INDIA PVT LTD',
    'ELECTRO CARE INDIA PRIVATE LIMITED',
    'ENARKA INDIA PRIVATE LTD',
    'EMPEE EQUIPMENTS PRIVATE LIMITED',
    'EMANATION ADVISORS PRIVATE LIMITED',
    'ENDURA SOFT SOLUTION PRIVATE LIMITED',
    'EMERSOL ENGINEERING PRIVATE LIMITED',
    'ENABILON LEARNING PARIVATE LTD',
    'EIGHT CAPITAL ADVISORY SERVICES PRIVATELIMITED',
    'EGS INFO TECH PRIVATE LIMITED',
    'EMPEREAL KGDS RENEWABLE ENERGY PRIVATE LIMITED',
    'EMDEE FORWARDERS AND IMPEX PRIVATE LTD',
    'EISEN PHARMACEUTICAL COMPANY PRIVATE LIMITED',
    'EMAILMONKS TECHNOLOGIES PRIVATE LIMITED',
    'Eglo India Production Pvt Ltd',
    'ELESA AND GANTER INDIA PVT LTD',
    'ENTECH SIGNS AND DISPLAYS INDIA PVT LTD',
    'ESSAR STEEL INDIA LIMITED',
    'ENSURE INNOVATIONS PVT LTD',
    'ENFIELD APPARELS LIMITED',
    'ERD INFOTECH PVT LTD',
    'ESCONET TECHNOLOGIES PRIVATE LIMITED',
    'EPRIME TRAVELS COM PRIVATE LIMITED',
    'ENQOS SOFTWARE TECHNOLOGIES PRIVATELIMITED',
    'ENHANCE AESTHETIC AND COSMETIC STUDIO PRIVATE LIMITED',
    'ETA ENGINEERING PVT LTD',
    'ENTAB INFOTECH PVT LTD',
    'Enginemates Heat Transfer Private Limited',
    'ETERNUS SOLUTIONS PRIVATE LIMITED',
    'ENTERPRISE SOCIAL MEDIA PRIVATE LIMITED',
    'ENTRUST FAMILY OFFICE WEALTH SERVICES PRIVATE LIMITED',
    'EROS GRAND RESORTS AND HOTELS PVT LTD',
    'enovate biolife pvt ltd',
    'ESTIRE RESEARCH & ANALYTICS PRIVATELIMITED',
    'EPIC TELEVISION NETWORKS PRIVATE LIMITED',
    'ESCRIBE ACCOUNTING SERVICES PRIVATE LIMITED',
    'Escee infrastructure private limited',
    'ENMAS O & M SERVICES PRIVATE LIMITED',
    'ESKO GRAPHICS INDIA PVT LTD',
    'ENRICH IT SERVICES PRIVATE LIMITED',
    'ENGAGE4MORE INDIA PRIVATE LIMITED',
    'ESSEN VISION SOFTWARE PRIVATE LIMITED',
    'ENGLISH HELPER EDUCATION TECHNOLOGIES PVT LTD',
    'Enser communications private limited',
    'ER AUTO COMPONENTS PRIVATE LIMITED.',
    'ENFLUENCE IT SERVICES PVT LTD',
    'ESSENTIAL ENERGY INDIA PRIVATE LIMITED',
    'Essjay copier pvt ltd',
    'ENJAY I T SOLUTIONS LIMITED',
    'Eptisa India Private ltd',
    'ERESOURCE INFOTECH PVT LTD',
    'ENVOY MORTGAGE INDIA PVT LTD',
    'EQUATOR FREIGHT and LOGISTICS PRIVATE LIMITED',
    'ENTRUST SOFTWARE AND SERVICES PRIVATE LIMITED',
    'Equifax Software System Pvt Ltd',
    'ESKAY HOSPITALITY SERVICES INDIA PRIVATE LIMITED',
    'ENGINEERBABU IT SERVICES PRIVATE LIMITED',
    'EPIC RESEARCH PRIVATE LIMITED',
    'ENGINEF INDIA TECHNOLOGIES PRIVATE LIMITED',
    'EURUS INTERNETWORKS PVT LTD',
    'EXTREME BROADBAND SERVICES PRIVATE LIMITED',
    'eTrans Solutions Pvt Ltd',
    'FACTORIAL SOLUTIONS PVT LTD',
    'EXA THERMOMETRICS INDIA PVT LTD',
    'FAIRDEAL STUDIOS PVT LTD',
    'FAIRDEAL MULTIMEDIA PVT. LTD.',
    'EXTENSIBLE IT SOLUTIONS PVT LTD',
    'EZ XBRL SOLUTIONS PRIVATE LIMITED',
    'EVOLUTE SOLUTIONS PRIVATE LIMITED',
    'F6 Finserve Pvt Ltd',
    'EXASENSE LABS LIMITED',
    'EXCELSIOR SOFTWARE PRIVATE LIMITED',
    'EXHIBIT TECHNOLOGIES PVT LTD',
    'EUROSTAR ENGINEERING PVT LTD',
    'eventfaqs media pvt ltd',
    'EXCELIZE ARCHITECTURAL SERVICES PRIVATE LIMITED',
    'EUKILD BRAND SOLUTION PVT LIMITED',
    'EVM AUTOMOTIVE INDIA PVT LTD',
    'EXPRESS KARGO FORWARDERS PRIVATE LIMITED',
    'exhicon events media solutions pvt ltd',
    'ETHNOTECH ACADEMIC SOLUTIONS PRIVATELIMITED',
    'EURO AMERICAN PLASTIC PRODUCTS PRIVATE LIMITED',
    'EXON SOLUTIONS PVT LTD',
    'EXULT INFOSOLUTIONS PVT LTD A',
    'Express Shares And Capital Pvt Ltd',
    'Express lifts limited',
    'EUREKA D SOFT PRIVATE LIMITED',
    'euro india cylinders ltd',
    'ETHOS HR MANAGEMENT & PROJECTS PRIVATE LTD',
    'expicient software pvt ltd',
    'FA CAPITAL MANAGEMENT PVT LTD',
    'EXCELLENCE4U RESEARCH SERVICES PVT LTD',
    'EXCELSIA SHIPPING INDIA PRIVATE LIMITED',
    'FAIR CONSULTING INDIA PVT LTD',
    'Evolve Accounting Systems Pvt Ltd',
    'EUROP ASSISTANCE INDIA PVT LTD',
    'ETOOS EDUCATION PVT LTD',
    'Evolution Digital India Pvt Ltd',
    'FAB TECH WORKS AND CONSTRUCTIONS PRIVATE LIMITED',
    'FAIRMONT CONSTRUCTIONS PRIVATE LIMITED',
    'F & F ENTERPRISES PVT LTD',
    'EXCEL NET SOLUTIONS PVT LTD',
    'FICUS MERCANTILE LTD',
    'FITWEL GASKET COMPANY INDIA PRIVATE LIMITED',
    'FIRE ARCOR INFRASTRUCTURE PRIVATELIMITED',
    'FARM AND GARDEN TECHNOLOGIES PVT LTD',
    'FINOLEX J-POWER SYSTEMS PRIVATE LIMITED',
    'FINSALL NETWORK PRIVATE LIMITED',
    'FINE FINISH ORGANICS PVT LTD',
    'FITECH EQUIPMENTS (I) PVT. LTD',
    'FIBERWEB INDIA LTD',
    'FINESSE FASHIONS PVT.LTD',
    'fleurdelis technologies pvt ltd',
    'FIFTH AVENUE SOURCING PVT LTD',
    'FDSBG ENGINEERING SERVICES PRIVATELIMITED',
    'FAMY ENERGY PRIVATE LIMITED',
    'fly by wire international private limited',
    'FASTTRACK HOUSING FINANCE PRIVATE LIMITED',
    'FANS ASIA PVT LTD',
    'FIRSTVIEW CONFERENCES PRIVATE LIMITED',
    'FLAME PROOF EQUIPMENTS PVT LTD',
    'FICHTNER CONSULTING ENGINEERS INDIA PRIVATE LTD',
    'FINTELLIX SOLUTIONS PVT LTD',
    'FNS INTERNATIONAL PVT LTD',
    'Fastech telecommunication (india) private limited',
    'FARM2PLATE DAIRY PRODUCE PRIVATE LIMITED',
    'FEDERAL SYNERGIES INDIA PRIVATE LIMITED',
    'FIDELIS MANAGEMENT CONSULTANT PRIVATE LIMITED',
    'FIRST PASS SEMICONDUCTORS PVT LTD',
    'FINCO TRADERS INDIA PVT LTD',
    'FLOATING WALLS PVT LTD',
    'FEELWELL GARMENTS AND ACCESSORIES PVT LTD',
    'FLORAM SHOES INDIA PRIVATE LIMITED',
    'FEIN POWER TOOLS INDIA PVT LTD',
    'FIZZY FOODLABS PRIVATE LIMITED',
    'FHD CONSULTANTS PRIVATE LIMITED',
    'FLORA LEATHER FASHIONS PRIVATE LIMITED',
    'FKL INDIA PVT LTD',
    'FIRST INSIGHT SOFTWARE SOLUTIONS INDIAPRIVATE LIMITED',
    'FIRST LEGION CONSULTING PRIVATE LIMITED',
    'FAZLANI ACADEMY OF BUSINESS SCIENCES PVT LTD',
    'FINPOWER AIRCON SYSTEMS PVT LTD',
    'FIRST CALL ADVISORY INDIA PRIVATE LIMITED',
    'FIRST MEDICAL SERVICES PRIVATE LIMITED',
    'FLAWLESS ENGINEERING SOLUTIONS PVT LTD',
    'FIBER PLUS INDUSTIES LTD.',
    'FIRST DATA DEVELOPMENT PVT LTD',
    'FIFTH GEAR VENTURE LIMITED',
    'FEDEX SECURITIES LIMITED',
    'FLUIDLINE VALVES INTERNATIONAL PRIVATE LIMITED',
    'FinBiz Crossborder Consulting Pvt Ltd',
    'FCSONDHI AND CO. INDIA PVT LTD',
    'FANM PROPERTY SERVICES PRIVATE LIMITED',
    'foundation futuristic technologies Private limited',
    'FRISTAM PUMPS INDIA PVT LTD',
    'G CUBE WEBWIDE SOFTWARE PRIVATE LIMITED',
    'FORTUNE PARK HOUSING PROJECTS PRIVATELIMITED',
    'frr shares and securities ltd',
    'fratelli wines pvt ltd',
    'FULCRUM BIOMETRICS INDIA PVT LTD',
    'G ENG ADVISORY SERVICES PRIVATE LIMITED',
    'FRANK EDUCATIONAL AIDS PVT LTD',
    'FORETEK MARKETING PVT LTD',
    'FOERSTER BHUPATHI CONSULTING PVT LTD',
    'FOCUS MACHINES INDIA PRIVATE LIMITED',
    'FORTIS HEALTH MANAGMENT LIMITED',
    'FOODLINK BANQUETS AND CATERING INDIA PRIVATE LIMITED',
    'FUTURISK INSURANCE BROKING CO PRIVATE LIMITED',
    'FRAMES PROCESS and ENERGY SYSTEMS INDIA PRIVATE LIMITED',
    'G G ORGANICS PVT LTD',
    'FRR FOREX PVT LTD',
    'FUGRO GEOTECH INDIA PRIVATE LIMITED',
    'FOCAL AUDIO SYSTEMS P LTD',
    'FREIGHT CONNECTION SOUTH INDIA PRIVATE LIMITED',
    'FREIGHT LINES INDIA PVT LTD',
    'FTD AUTOMATION PVT LTD',
    'FOXFIRE TECHNOLOGIES (INDIA) LIMITED',
    'FOUR DIMENSIONS RETAIL DESIGN INDIA PRIVATE LIMITED',
    'FORTRESS FINANCIAL SERVICES LIMITED',
    'FX MART PRIVATE LIMITED',
    'FOUNTIL LIFE SCIENCES PRIVATE LIMITED',
    'FRAMES PRODUCTION COMPANY PVT LTD',
    'FOREFRONT PROPERTY DEVELOPERS PRIVATE LIMITED',
    'FORAYS SERVICES AND CONSTRUCTIONS PRIVATE LIMITED',
    'FORTIUS FACILITIES PRIVATE LIMITED',
    'FORMERTRON ENGINEERING(INDIA) PRIVATELIMITED',
    'FREIGHT CONNECTION INDIA PVT LTD',
    'FORADIAN TECHNOLOGIES PVT LTD',
    'FREIGHTCAN LOGISTICS INDIA PVT LTD',
    'FORBES FACILITY SERVICES PRIVATE LIMITED',
    'FRONTAVENUE INFOSOLUTIONS PVT LTD',
    'FORTE RESEARCH SYSTEMS INDIA PRIVATE LIMITED',
    'Four lions films private limited',
    'FUSION INDUS TECSON PVT LTD',
    'FUJIKURA AUTOMOTIVE INDIA PRIVATE LIMITED',
    'FUTURE SHARP SKILLS LIMITED',
    'FORTUNE FIVE INSURANCE AND FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'FORDHAM CONSULTANCY PVT LTD',
    'FOCUS TRANS TECH SHIPPING PRIVATE LIMITED',
    'FTS BUILDTECH PRIVATE LIMITED',
    'FORTUNE INTEGRATED ASSETS FINANCE LIMITED',
    'FORTUNE CREDIT CAPITAL LIMITED',
    'FUSCHIA CAREERS PVT LTD',
    'FOS DESIGNS AND SERVICES PRIVATE LIMITED',
    'FRICTION METAL FIBRES INDIA PRIVATE LTD',
    'FUTURESOFT SOLUTION PVT LTD',
    'FORESIGHT SOFTWARE SOLUTIONS PRIVATELIMITED',
    'FOURSPOTS INTERACTIVE SOLUTIONS PRIVATELIMITED',
    'FONTANA FASTENERS INDIA PVT LTD',
    'FORTUNA PUBLIC RELATINS PVT LTD',
    'FUERST DAY LAWSON (INDIA) PRIVATE LIMITED',
    'GD LAB SOLUTIONS PRIVATE LIMITED',
    'GAMUT TECHNOLOGIES PVT LTD',
    'GENAU EXTRUSIONS LIMITED',
    'GEMINI EQUIPMENT AND RENTALS PVT LTD',
    'G m ENGINEERING PVT LTD',
    'GEECEE INVESTMENTS LIMITED',
    'GELNOVA LABORATORIES INDIA PVT LTD',
    'GALAXY RISK INSURANCE BROKERS PRIVATE LIMITED',
    'G S T Corporation Ltd',
    'GARUDA THERMAL POWER PRIVATE LIMITED',
    'GANDHAR SHIPPING & LOGISTIC PVT LTD',
    'G4S FACILITY SERVICES(INDIA) PVT LTD',
    'GAERISH LOGITICS PRIVATE LIMITED',
    'G NEXT MEDIA PRIVATE LIMITED',
    'GEFRAN INDIA PVT LTD',
    'G L COMMUNICATIONS INDIA PRIVATE LIMITED',
    'GAUSSIAN NETWORKS PVT LTD',
    'G&g infratech private limited',
    'GDX FACILITY & MANAGEMENT SERVICES PVT LTD',
    'GARUDAH IT SERVICES PRIVATE LIMITED',
    'GAYATRI INFOTECH PVT LTD',
    'GAVESHANA GEOSCIENCES PRIVATE LIMITED',
    'GEMINI ENGI FAB LIMITED',
    'GEECEE LOGISTICS AND DISTRIBUTIONS PRIVATE LIMITED',
    'G R C INFRA PRIVATE LIMITED',
    'GBT COMPOSITES TECNOLOGY LTD',
    'GEECY VINCOTTE INDIA PRIVATE LIMITED',
    'GALACTIC ELECTRIC PVT LTD',
    'GAURANGA SOFT TECH PRIVATE LIMITED',
    'GAFFNEY KROESE SUPPLY INDIA PRIVATE LIMITED',
    'GANGAVARAM PORT SERVICES (INDIA) PRIVATE LIMITED',
    'GENCOR PACIFIC ORGANICS INDIA PVT LTD',
    'GATESIX TECHNOLOGIES INDIA PVT. LTD.',
    'GE RENEWABLE R and D INDIA PRIVATE LIMITED',
    'GARG SONS INDIA PVT LTD',
    'GALILEO SHIP MANAGEMENT AND TRAVELS PRIVATE LIMITED',
    'GENNEX LABORATORIES LTD',
    'GIBraltar Airsprings Pvt Ltd',
    'GHIBELLINES SECURITY SOLUTIONS LTD',
    'Gensol engineering private limited',
    'GLOBAL E SOFTSYS PRIVATE LIMITED',
    'GIRNAR AYURVEDIC PHARMACY PVT LTD',
    'GMAX AUTO LIMITED',
    'GERAD FINANCIAL SERVICES PRIVATE LIMITED',
    'GLOBAL STONES PRIVATE LIMITED',
    'GLOBAL CONSUMER PRODUCTS PRIVATE LIMITTED',
    'Geoconcept india private limited',
    'GIFT LINKS INDIA PVT LIMITED',
    'GJEWELCRAFT LIMITED',
    'GIRIRAJ CIVILDEVELOPERS PRIVATE LIMITED',
    'GO FASHION (INDIA) PRIVATE LIMITED',
    'GLOCHEM INDUSTRIES LIMITED',
    'GOADS INDIA PRIVATE LIMITED',
    'GLOBAL JEWELLERY PVT LTD',
    'GLASS POLISH INDIA LTD',
    'GEOSTAR SURVEYS INDIA PVT LTD',
    'GENOME VALLEY TECH PARKS AND INCUBATORS PRIVATE LIMITED',
    'GEOSANSAR ADVISORS PRIVATE LIMITED',
    'GIRNAR FOOD AND BE ERAGES PRIVATE LIMITED',
    'GHAZIABAD ALIGARH EXPRESSWAY PVT LTD',
    'GLOBAL SHIPPING AGENCIES INDIA PRIVATE LIMITED',
    'GLOBAL EASYWATER PRODUCTS PRIVATE LIMITED',
    'GOAN HOTELS AND REALTY PRIVATE LIMITED',
    'GLOBALENGLISH INDIA PRIVATE LIMITED',
    'Gkkworks consultants private limited',
    'GLOBSYN INNOVENTURES PRIVATE LIMITED',
    'gkw limited',
    'GLOBALITE INDUSTRIES PRIVATE LIMITED',
    'GNSA INFOTECH LIMITED',
    'GLORY SHIPMANAGEMENT PVT LTD',
    'German Magnetic Water Solutions Pvt Ltd',
    'GERMAN CENTRE FOR INDUSTRY AND TRADE DELHI PRIVATE LIMITED.',
    'GENRX PHARMACEUTICALS PVT LTD',
    'GODAVARI PIPES PVT LTD.',
    'GMR HOTELS AND RESORTS LIMITED',
    'GI TECH GAMING CO INDIA PRIVATE LIMITED',
    'GENERIC ENGINEERING AND CONSTRUCTION PRIVATE LIMITED',
    'GLOBAL PHARMATECH PRIVATE LIMITED',
    'Global longlife hospital and research private limited',
    'GIRNAR SOFTWARE (SEZ)PVT LTD',
    'Gigamon solutions india pvt ltd',
    'Geoconsult India Pvt Ltd',
    'GIFFORD INDIA PRIVATE LIMITED',
    'GLOBAL ASSETS LEASING AND FINANCE PRIVATE LIMITED',
    'GOA MEDICOS PVT LTD',
    'GENESIS BURSON -MARSTELLER PUBLIC RELATIONS PRIVATE LIMITED',
    'GLOBAL AUDIO TEXT SOLUTION PVT LTD',
    'Global Canesugar Services Pvt Ltd',
    'GENSIG SOFTWARE SERVICES INDIA PRIVATELIMITED',
    'GENNEXT INSURANCE BROKERS PVT LTD,',
    'GESTAMP PUNE AUTOMOTIVE PVT LTD',
    'GOYAL FASHIONS PVT LTD',
    'GREENVISION TECHNOLOGIES PVT LTD',
    'GRASSROOTS BPO PVT LTD',
    'GRAM POWER (INDIA) PRIVATE LIMITED',
    'GOPI DEHYDRATES PVT LTD',
    'GREEN VALLEYS SHELTERS PRIVATE LIMITED',
    'GRANGE MANAGEMENT SERVICES PRIVATE LIMITED',
    'Gram Tarang Employability Training Services Pvt Ltd',
    'GOURI ENGINEERING PVT LTD',
    'GOOD DROP WINE CELLARS PVT LTD',
    'GOZOOP RED INTERNET SERVICES PVT LTD',
    'GRID DESIGN SOLUTIONS PRIVATE LIMITED',
    'GRESHMA FINVEST PVT LTD',
    'Green Enabled IT Solutions Pvt Ltd',
    'GRANADA INVESTMENTS AND FINANCE PRIVATE LIMITED',
    'GREEN ARK ENERSOL PRIVATE LIMITED',
    'GREYSELL MARKETING PROMOTIONS PVT LTD',
    'GOOD RELATIONS INDIA PVT LTD',
    'GRIDLOGICS TECHNOLOGIES PRIVATE LIMITED',
    'GRACEWORKS REALTY LEISURE PRIVATE LIMITED',
    'GRAPHTONE INDIA PVT LTD',
    'GRAVITY CAST PVT LTD',
    'GREENKO WIND PROJECTS PRIVATE LTD',
    'GREENS POWER EQUIPMENT INDIA PVT LTD',
    'GREEN FIELD CONTROL SYSYTEM (I) PRIVATE LIMITED',
    'Greatvalue Projects India Ltd',
    'GOLDER ASSOCIATES CONSULTING INDIA PRIVATE LIMITED',
    'GOODWILL CONTAINER SERVICES PRIVATE LIMITED',
    'GREENBACK FINANCIAL AND FX SERVICES PRIVATE LIMITED',
    'GOODRICH NUTRISTERS PVT LTD',
    'Greenvalley marketing private limited',
    'GREAT SPORTS INFRA PRIVATE LIMITED',
    'GREY WORLDWIDE INDIA PVT LTD',
    'GRAY MATTERS INDIA PVT LTDÃ‚Â Ã‚Â',
    'GOODRICH GASKETS PRIVATE LIMITED',
    'GREENTECH INDUSTRIES',
    'GOLDSQUARE SALES INDIA PVT LTD',
    'GOVIK ELECTRICALS PRIVATE LIMITED',
    'GREYCELLS EDUCATION LIMITED',
    'GREATWELD ENGINEERING PRIVATE LIMITED',
    'GRADMENER TECHNOLOGY PVT LTD',
    'Graphiti Multimedia Pvt Ltd',
    'GRAND PROSPECT INTERNATIONAL COMMUNICATION PVT LTD',
    'GOPALJEE AGRO PRODUCTS PVT LTD',
    'GRACE TRAVELS (INDIA) PRIVATE LTD',
    'GREY HEAD MEDIA PVT LTD',
    'grow financial services consultancy pvt ltd',
    'GUARANTORS INFRASTRUCTURE PVT LTD',
    'HARI OM CONCAST AND STEELS PRIVATE LIMITED',
    'H P SINGH AGENCIES PVT LTD',
    'hacxad infotech pvt ltd',
    'HANCO PROPERTY DEVELOPERS PRIVATELIMITED',
    'HAMSTECH INDIA PRIVATE LIMITED',
    'Groom india salon and spa private limited',
    'GRIND MASTER MACHINE PVT LTD',
    'H and V Projects Private limited',
    'H FILLUNGER AND COMPANY PRIVATE LIMITED',
    'GROUP 7 GUARDS INDIA PRIVATE LIMITED',
    'HARDESH ORES PVT LTD',
    'HALAL CERTIFICATION SERVICES INDIA PVT LTD',
    'HARBINGER INTERACTIVE LEARNING PVT LTD',
    'Gulbarga Power Pvt Ltd',
    'H.M. TUBES AND CONTAINERS PVT. LTD',
    'H H M OUTSOURCING SOLUTIONS INDIA PRIVATE LIMITED',
    'H & M Hennes & Mauritz India Pvt Ltd',
    'HANS MARITIME SERVICES PRIVATE LIMITED',
    'GUBBI PAVERS & TILES(INDIA) PVT. LTD.',
    'GRV KREATIONS PVT LTD',
    'GYAANTECH SOFTWARE SOLUTIONS PVT LTD',
    'HANAPROTECH MOULDING AND TOOLS PRIVATE LIMITED',
    'GWS ENGINEERS AND FABRICATORS PVT LTD',
    'H DAYA ENTERPRISES PRIVATE LIMITED',
    'GUHRING INDIA PVT LTD',
    'GURUDEV PLASTICS PVT LTD',
    'HALISCAPE BUSINESS SOLUTIONS PVT LTD',
    'GRINTEX INDIA LIMITED',
    'GSP LABELS PRIVATE LIMITED',
    'GVP FORWARDER PVT LTD',
    'Gstaad Hotels Pvt Ltd',
    'GRIT INNOVATION SOFTWARE PRIVATE LIMITED',
    'HAPPY FINISH INDIA PRIVATE LIMITED',
    'HANNOVER MILANO FAIRS INDIA PVT LTD',
    'HALCYON SOFT SOLUTIONS PVT LTD',
    'GTS E SREVICES PRIVATE LIMITED',
    'GTFC LIMITED',
    'GULF AUTOMATION TECHNOLOGIES PVT LTD',
    'HANSA RESEARCH GROUP PVT LTD',
    'HARDWARE CONCEPTS INDIA PVT LTD',
    'H Q LAMPS MANUFACTURING CO PRIVATE LIMITED',
    'HAMON RESEARCH COTTRELL INDIA PVT LTD',
    'HAMMER COMMUNICATIONS PVT LTD',
    'HAITECH MEDICAL SOLUTIONS PVT LTD',
    'HARYANA COATING PVT LTD',
    'HCRI TECHNOLOGIES OF INDIA PRIVATE LIMITED',
    'HILIFE TOURS AND TRAVEL PRIVATE LIMITED',
    'HINDUSTAN EXPORT & IMPORT CORPORATION PVT LTD',
    'HARITA-NTI LIMITED',
    'HARYANA LEATHER CHEMICALS LTD',
    'HELICORD TRANSMISSIONS PRIVATE LIMITED',
    'HBN NETWORK PVT LTD',
    'HI LITE CONSTRUCTIONS PVT LTD',
    'HARMONY LIFESTYLE STRUCTURES PVT LTD',
    'HEM CORPORATION PRIVATE LIMITED (PART - IX)',
    'HEADSNMINDS CONSULTANTS PVT LTD',
    'HEXAGON NUTRITION PRIVATE LIMITED',
    'HI TECH METROLOGY PRIVATE LIMITED',
    'HIGHPOINTS TECHNOLOGIES INDIA PVT LTD',
    'HITECH INSURANCE BROKING SERVICES LTD',
    'HIMALAYA HEAVY LIFTERS I PRIVATE LIMITED',
    'HIKE LIMITED',
    'HEERAKERALA DEVELOPERS PRIVATE LIMITED',
    'HERMES SHIP MANAGEMENT PVT LTD',
    'Herald Logic Pvt Ltd',
    'HEADHUNTERS HR PVT LTD',
    'HEDGE SQUARE CONSULTANCY SERVICES PRIVATE LIMITED',
    'HELLO HEALTH SERVICES PRIVATE LIMITED',
    'HEALTH CARE PROCESS SOLUTIONS INDIA PVT LTD',
    'HITECH BIO SCIENCES INDIA LIMITED',
    'HIGHER TECHNOLOGY TRADING SYSTEMS PRIVATE LIMITED',
    'HEXION CHEMICALS INDIA PRIVATE LIMITED',
    'HINDUSTAN INSURANCE BROKERS LTD',
    'HIMALAYAN PACKAGING INDUSTRIES PRIVATELIMITED',
    'HIMILE MOLDS INDIA PRIVATE LIMITED',
    'HEURISTIX DIGITAL TECHNOLOGIES PVT LTD',
    'HCT SUN INDIA PRIVATE LIMITED',
    'HHV SOLAR TECHNOLOGIES LTD',
    'HEALTHCAREERS INSTITUTE PRIVATE LIMITED',
    'HIND AIR SERVICES PRIVATE LIMITED',
    'HICOM INFORMATION SERVICES PRIVATE LIMITED',
    'HIPSONIC TECHNOLOGIES PRIVATE LIMITED',
    'HRH NEXT SERVICES PRIVATE LIMITED',
    'I & B AUTOMATION & CONTROLS PRIVATELIMITED',
    'I G INTERNATIONAL PRIVATE LIMITED',
    'HOLISOL LOGISTICS PVT LTD',
    'I TEK LOGICS PRIVATE LIMITED',
    'HOSLEY INDIA PVT LTD',
    'HUMANA PEOPLE TO PEOPLE INDIA U S 25 CO',
    'HOMELAND BUILDWELL PVT LTD',
    'HOLLY HOCK RESORTS AND HOSPITALITY SERVICES PRIVATE LIMITED Ã‚Â Ã‚Â Ã‚Â',
    'HYDRODYNE INDIA PRIVATE LIMITED',
    'Hornbill information technologies private limited',
    'HOTSTUFF EVENTS and REPRO PVT LTD',
    'HYQUIP SYSTEMS LTD',
    'HMICRO (INDIA) PRIVATE LIMITED',
    'HOTEL MAYFAIR PRIVATE LIMITED',
    'HYDROCARBON SOLUTIONS INDIA PVT LTD',
    'I2E CONSULTING PVT LTD',
    'Howe Robinson shipping india private limited',
    'I PERITUS SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'HOWDEN THOMASSEN COMPRESSORS INDIA PVT LTD',
    'HOST INTERNATIONAL PVT LTD',
    'HYDROCHEM ENGINEERS BOMBAY PVT LTD',
    'I B H BOOKS AND MAGAZINES DISTRIBUTORS LIMITED',
    'HYDRIL PRESSURE CONTROL PRIVATE LIMITED',
    'IAL LOGISTICS INDIA LIMITED',
    'HOPEWELL TABLEWARE LIMITED',
    'HYBRID CYBER SOLUTIONS PVT LTD',
    'Horigine Consulting Pvt Ltd',
    'I MARINE INFRATECH INDIA PRIVATE LIMITED',
    'HOST ANALYTICS SOFTWARE PRIVATE LIMITED',
    'hypro engineers pvt ltd',
    'IBAHN INDIA PRIVATE LIMITED',
    'Hr integrated media private limited',
    'HUVEPHARMA SEA PUNE PRIVATE LIMITED',
    'HYGIENIC AIR SYSTEMS PVT LTD',
    'HOLISTIC HR AND SECURITY PRIVATE LIMITED',
    'I K MARINE AGENCIES PVT LTD',
    'HUBER SUHNER ELECTRONICS PVT LTD',
    'HySoC Technologies Pvt Ltd',
    'HOWDEN SOLYVENT (INDIA) PRIVATE LIMITED',
    'HORTONWORKS DATA PLATFORM INDIA PRIVATELIMITED',
    'I4 INFOTECH PRIVATE LIMITED',
    'HORIZON DATA SYSTEMS PRIVATE LIMITED',
    'HOTEL SUBA STAR PRIVATE LIMITED',
    'I TECH MEDIA PRIVATE LIMITED',
    'HOWE (INDIA) PRIVATE LIMITED',
    'HUMINT FINANCIAL & IT SOLUTIONS PRIVATELIMITED',
    'IFINTALENT GLOBAL PRIVATE LIMITED',
    'IMPERIA HEALTH PRIVATE LIMITED',
    'ILOG SOLUTIONS INDIA PVT LTD',
    'IFB SHIPPING INDIA PVT LTD',
    'ICETRAIL LOGISTICS PVT LTD',
    'IDHAYAM - G FINANCE AND INVESTMENTSERVICES LIMITED',
    'IN TIME GARMENTS PVT LTD',
    'ICHIBAN CROP SCIENCE LTD',
    'INAIR HOLIDAYS PVT LTD',
    'ICONIC SOFTECH SOLUTIONS PVT LTD',
    'IFOCUS SYSTEC INDIA PRIVATE LIMITED',
    'IMERYS MINERALS INDIA PRIVATE LIMITED',
    'IMPERIAL Ã‚Â FOOD BIZ PVT. LTD',
    'IMA INDUSTRIES INDIA PRIVATE LIMITED',
    'IDS SOFTWARE SOLUTIONS INDIA PRIVATE LIMITED',
    'IDA TRADING FOUNDATION PVT LTD',
    'IMERYS NEWQUEST INDIA PRIVATE LIMITED',
    'ICRA ONLINE LIMITED',
    'IMSI INDIA PRIVATE LIMITED',
    'IMMPLY INDIA TECHNOLOGY PVT LTD',
    'IDEAFORGE TECHNOLOGY PRIVATE LIMITED',
    'INCI CONSTRUCTION AND INTERIORS PRIVATE LIMITED',
    'ICWARES SYSTEMS AND SOFTWARES INDIA PRIVATE LIMITED',
    'IMAGINARIUM INDIA PRIVATE LIMITED',
    'IDAC SOLUTIONS PRIVATE LIMITED',
    'IIT-IANS PACE EDUCATION PRIVATE LIMITED',
    'ILLUSION DENTAL LABORATORY PRIVATE LIMITED',
    'IMPRESA HOSPITALITY MANAGEMENT PRIVATE LIMITED',
    'IMAGINATION TECHNOLOGIES HYDERABAD PVT LTD',
    'Imperative business ventures private limited',
    'IBUILD INNOVATIONS INDIA LIMITED',
    'IN NET INDIA PRIVATE LIMITED',
    'IKE ELECTRIC PVT LTD',
    'IMAGINE TECHNOLOGY AND SERVICES PRIVATE LIMITED',
    'IN TAP TECHNOLOGIES PVT LTD',
    'IFMR MEZZANINE FINANCE PRIVATE LIMITED',
    'Iifl investment adviser and trustee services limited',
    'ibs infoweb pvt ltd',
    'IGUS INDIA PRIVATE LTD',
    'IMPERIAL SERVICED OFFICES and PROPERTY MANAGEMENT PRIVATE LIMITED',
    'Increv india solutions private limited',
    'IMEX SHIPPING & LOGISTICS (INDIA)PRIVATE LIMITED',
    'ICONIX PROJECTS PRIVATE LTD',
    'ICNET SOFTWARE SOLUTIONS PVT LTD',
    'iboss tech solutions pvt ltd',
    'In Art Constructions Pvt Ltd',
    'ICS SYSTEM PVT LTD',
    'INDE hospitality Pvt Ltd',
    'INDOTECH TUBEWELLS PRIVATE LIMITED',
    'INFINITY ASSURANCE SOLUTIONS PVT LTD',
    'INDOSWIFT CONSULTANCY SERVICES PVT LTD',
    'INDO DAN LAMPSHADES PRIVATE LIMITED',
    'INDUS MOBILE DISTRIBUTION PRIVATE LIMITED',
    'INDIA PARENTING PVT LTD',
    'INDULGENCE RESTAURANTS PRIVATE LIMITED',
    'Infiniti Connect India Pvt Ltd',
    'Indiana International Corporation Flooring Pvt Ltd',
    'INDIAN ANGEL NETWORK SERVICES PRIVATELIMITED',
    'INDE PAY NETWORKS PRIVATE LIMITED',
    'Indicus netlabs pvt Ltd',
    'INDIAN RESOURCES INFORMATION AND MANAGEMENT TECHNOLOGIES LIMITED',
    'INDICUS ANALYTICS PRIVATE LIMITED',
    'INDIA INSURE RISK MANAGEMENT & INSURANCE BROKING SERVICES PVT LTD',
    'INFICARE SOFTWARE TECHNOLOGIES PVT LTD',
    'INDIA FASHIONS LTD',
    'INDTECH INSTRUMENTS PVT LTD',
    'INFINITY AUTOMATION SYSTEMS PVT LTD',
    'INDPRO ELECTRONIC SYSTEMS INDIA PRIVATE LIMITED',
    'INDIGO IMPEX PRIVATE LIMITED',
    'INFOLOGITECH INDIA PRIVATE LIMITED',
    'INDIGO INFORMATION SYSTEMS PVT LTD',
    'INFIN SOFTWARE TECHNOLOGIES PVT LTD',
    'Infinity HVAC Spares and Tools Private Limited',
    'INDO JAPAN POLYMERS PRIVATE LIMITED',
    'INDIAN PLUMBING SKILLS COUNCIL',
    'INDUS BIOTECH PRIVATE LIMITED',
    'INDUS NET TECHNOLOGIES PRIVATE LIMITED',
    'INDIANA CONVEYORS PVT LTD',
    'INDIGO JEWELLERY PRIVATE LIMITED',
    'INFONATIVE SOLUTIONS PVT LTD',
    'INDRA VISA FIDUCIARY SERVICES PVT LTD',
    'INFOLINK HEALTH SERVICES PRIVATE LIMITED',
    'INEXT LOGISTICS and SUPPLY CHAIN PRIVATE LIMITED',
    'INFOCUBE SOLUTION PRIVATE LIMITED',
    'INDUS INTEX PVT LTD',
    'INDOSPACE ROHAN INDUSTRIAL PARK KHED PRIVATE LIMITED',
    'INFOSTRETCH CORPORATION INDIA PRIVATE LIMITED',
    'INFOBAHN TECHNICAL SOLUTIONS (I) PVT LTD',
    'INDIA INFOLINE INSURANCE BROKERS LIMITED',
    'INDU IONPURE INDIA PRIVATE LIMITED',
    'INDIANIVESH INSURANCE BROKERS PRIVATE LIMITED',
    'INDIA INTERNATIONAL HOUSE LTD',
    'indian optics pvt ltd',
    'INDIASSETZ INFRA SERVICES PRIVATELIMITED',
    'INFODREAMZ TECHNOLOGIES NAGPUR PRIVATE LIMITED',
    'INFOCOST SOLUTION PRIVATE LIMITED',
    'INDIA ROADSIDE ASSISTANCE PRIVATE LIMITED',
    'INDIA CAPITAL RESEARCH AND ADVISORSPRIVATE LIMITED',
    'INDUSTRIAL TECHNO MAN POWER SUPPLY & SERVICES PVT LTD',
    'INDIA SKILLS PVT LTD',
    'INFOSEARCH BPO SERVICES PVT LTD',
    'INDO ASIA HOTELS PVT LTD',
    'INDTEX SOLUTIONS PVT LTD',
    'INFRA MOVES PRIVATE LIMITED',
    'intech pharma private limited',
    'INTEGRAL COMPUTER LIMITED',
    'INSTANT GLOBAL MONEY TRANSFER PRIVATE LIMITED',
    'INTELLECASH MICROFINANCE NETWORK COMPANY PRIVATE LIMITED',
    'INTEGRAL PR SERVICES PRIVATE LIMITED',
    'INSPIRATION CONSTRUCTION PVT LTD',
    'INTEGRATED AUDIO VISUAL (INDIA) PRIVATE LIMITED',
    'INMARK RETAIL PRIVATE LIMITED',
    'intellicomm Solutions and Enterprises Pvt Ltd',
    'INFRAPLAN ENGINEERING SERVICES PRIVATE LTD',
    'INNOREX PHARMACEUTICALS PVT LTD',
    'INNOVATION ALCHEMY CONSULTING PVT LTD',
    'INTERCONTINENTAL POLYMER PVT LTD.',
    'Innova Telecom pvt ltd',
    'INTEGRHYTHM INDIA PRIVATE LIMITED',
    'INNOVATION COMMUNICATIONS SYSTEMS LIMITED',
    'IN-STORE CONSULTING SERVICES PRIVATE LIMITED',
    'INSCRIBE GRAPHICS PRIVATE LIMITED',
    'INTERGLOBE TECHNOLOGIES PRIVATE LIMITED',
    'INNOVATIVE FINANCIAL ADVISORS PRIVATE LIMITED',
    'INSTRUMENTS RESEARCH ASSOCIATES PRIVATE LIMITED',
    'INNOVATORS FACADE SYSTEMS PRIVATE LIMITED',
    'INTEGRATED DECISIONS AND SYSTEMS INDIA PVT LTD',
    'INTERACTIVE FINANCIAL and TRADING SERVICES PRIVATE LIMITED',
    'INTEGRATED PAYMENT SOLUTIONS INDIA PRIVATE LIMITED',
    'INTERGRAPHIC SALES AND SERVICES PRIVATELIMITED',
    'INTELLICOMPUTE TECHNOLOGIES PVT LTD',
    'INTELLIGENCENODE CONSULTING PVT LTD',
    'INTELLIKA TECHNOLOGIES PRIVATE LIMITED',
    'INFOVITY INDIA PVT LTD',
    'INTEGRITY LOGISTIC SOLUTION INDIA PRIVATE LIMITED',
    'InfraEn India Pvt Ltd',
    'INTEGRATED PERSONNEL SERVICES PRIVATE LIMITED',
    'INTER FOTO INDIA PVT LTD',
    'inovar floors india pvt ltd',
    'INTECH DESIGNS INDIA PRIVATE LIMITED',
    'INSEMI TECHNOLOGY SERVICES PVT LTD',
    'INSIDEVIEW TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'intellecap advisory services pvt ltd',
    'INGSOPHY CONSULTANTS PRIVATE LIMITED',
    'INNOEYE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'INFOTRONICS COMMUNICATION PRIVATE LIMITED',
    'INSHORTS MEDIALABS PRIVATE LIMITED',
    'INNOVSOURCE SECURITY PRIVATE LIMITED',
    'INTERICS DESIGNS PVT LTD',
    'INTERACTCRM SOLUTIONS PRIVATE LIMITED',
    'INGENIOUS E BRAIN SOLUTIONS PVT LTD',
    'INTER FREIGHT FORWARDERS PRIVATE LIMITED',
    'INSTANTLY RESEARCH (INDA) PVT. LTD.',
    'INTENSIVE FISCAL SERVICES PRIVATELIMITED',
    'IQOR GLOBAL SERVICES INDIA PVT LTD',
    'IRIS GLOBAL SERVICES PVT LTD',
    'IR APPAREL & ACCESSORIES PRIVATE LIMITED',
    'ISHA NATURAL BEAUTY PRODUCTS & WELLNESS PRIVATE LIMITED',
    'ION EXCHANGE INDIA LTD',
    'INTERNATIONAL ELECTRONICS AND COMMUNICATION SYSTEMS PRIVATE LIMITED',
    'J L MORISON INDIA LTD',
    'ISON BPO INDIA PRIVATE LIMITED',
    'INTONE NETWORKS INDIA PRIVATE LIMITED',
    'J K INVESTO TRADE INDIA LTD',
    'J b boda reinsurance brokers private limited',
    'ISOLVE SERVICES INDIA PRIVATE LIMITED',
    'Intex Infraprojects Pvt Ltd',
    'ISHVERLAL MADANLAL AND COMPANY PRIVATELIMITED',
    'J K LEISURES PRIVATE LIMITED',
    'INTRIGO SYSTEMS INDIA PVT LTD',
    'ITM EDUTECH INDIA LTD',
    'ITALENT APPICATIONS PVT LTD',
    'ITS TECHNOLOGY SOLUTIONS PVT LTD',
    'INVENDIS TECHNOLOGIES INDIA PVT LTD',
    'IVOICE NETWORKS PVT LTD',
    'INVENIOLIFE TECHNOLOGY PVT LTD',
    'IWAVE SYSTEMS TECHNOLOGIES PVT LTD',
    'INTERNET MEDIA AND EVENTS PRIVATE LIMITED',
    'J J FABTEX PRIVATE LIMITED',
    'IONIDEA INTERACTIVE PVT LTD',
    'INTERNATIONAL CUSTOMER LOYALTY PROGRAMMES PRIVATE LIMITED',
    'INTUIT INDIA SOFTWARE SOLUTIONS PRIVATE',
    'J L SHAH SECURITIES PVT LTD',
    'INTERTECH TECHNOLOGIES PVT LTD',
    'ITAL PLASTIC COMPOUNDS PVT LTD',
    'IRIS REPS INDIA PVT LTD',
    'IPS E SERVICES PVT LTD',
    'ITV COMPUTERS PRIVATE LIMITED',
    'IOSIS SPA AND WELLNESS PVT LTD',
    'ITG TELEMATICS PVT LTD',
    'ITSHASTRA INDIA PRIVATE LIMITED',
    'ITOP SOLUTIONS PRIVATE LIMITED',
    'INTERNATIONAL INSPECTION SERVICESPRIVATE LIMITED',
    'IRI MARITIME AND CORPORATE SERVICES PRIVATE LIMITE',
    'IRON MOUNTAIN INDIA PVT LTD',
    'J D AUTO ELECTRICALS PRIVATE LIMITED',
    'IRC AGROCHEMICALS PRIVATE LIMITED',
    'ISF MARITIME SERVICES PVT LTD',
    'INTERTOUCH QUADRIGA INDIA PRIVATE LIMITED',
    'IRM INSURANCE BROKERS PVT LTD',
    'IQR ANALYTICS PRIVATE LTD',
    'IP CORE SOLUTIONS INDIA PVT LTD',
    'INVICTA DESIGN TECHNOLOGIES PVT LTD',
    'INTERNATIONAL HALLMARK & ASSAY PRIVATELIMITED',
    'IRRH SPECIALTY CHEMICALS INDIA LTD',
    'ISHAN INTERNATIONAL PRIVATE LIMITED',
    'IRIS HIGHTECH PRIVATE LIMITED',
    'JATO GARMENTS PVT LTD',
    'JDM SCIENTIFIC RESEARCH ORGANISATIONPRIVATE LIMITED',
    'JAYANITA EXPORTS PRIVATE LTD',
    'JALDOOT MATERIALS HANDLING PVT LTD',
    'JABSONS COTTON SEED INDUSTRIES PVT LTD',
    'j n robotic automation pvt ltd',
    'JINDAL CONSULTANCY SERVICES LIMITED',
    'JIANGYIN UNI POL VACUUM CASTING INDIA PRIVATE LIMITED',
    'JAYA HIND SCIAKY LTD',
    'JAYATMA INFORMATICS PRIVATE LIMITED',
    'JAYCEE ADS PRIVATE LIMITED',
    'JAINAM FAB PVT LTD',
    'JCVALVULAS INDIA PRIVATE LIMITED',
    'JENDAMARK TECHCELLENCY AUTOMATION INDIA PRIVATE LIMITED',
    'JAXTR TECHNOLOGY PRIVATE LIMITED',
    'JAGDISH TECHNOCAST PVT LTD',
    'JCKRC SPA DESTINATION PRIVATE LIMITED',
    'JANPATH RESTAURANTS PRIVATE LIMITED',
    'JAWED HABIB HAIR AND BEUTY STUDIO PVT LTD',
    'JBCN EDUCATION PVT LTD',
    'Jay jalaram technologies private limited',
    'JASANI JEWELLERY PRIVATE LIMITED',
    'JAYEM WAREHOUSING PRIVATE LIMITED',
    'jaarvis accelerator pvt ltd',
    'JINDAL MEDICAL AND SCIENTIFIC INSTRUMENTS COMPANY PVT LTD',
    'JIVA DESIGNS PRIVATE LIMITED',
    'JANA MED TECH PVT LTD',
    'JADE PAYMENT SOLUTIONS PVT LTD',
    'J S F HOLDINGS PRIVATE LIMITED',
    'JAINEX IMPORTS AND EXPORTS PVT LTD',
    'JASUBHAI BUSINESS SERVICES PVT. LTD',
    'jai raj print pack pvt ltd',
    'JACOBS INFRASTRUCTURE PRIVATE LIMITED',
    'jahanvi apparels india pvt ltd',
    'JAINCO RUBBER INDUSTRIES LIMITED',
    'JJ CONSULTANTS PVT LTD',
    'JR FURNISHING PRIVATE LIMITED',
    'KADAM MARKETING LTD',
    'JONAS WOODHEAD and SONS INDIA LIMITED',
    'K and J PROJECTS PRIVATE LIMITED',
    'JOUVE INDIA PVT LTD',
    'K L ENVITECH PVT LTD',
    'JST IT AND S PRIVATE LIMITED',
    'JULIET INDUSTRIES LIMITED',
    'JUNEJA PROJECT SERVICES PVT LTD',
    'JMD MAINTENANCE SERVICES PVT LTD',
    'K L N ENGINEERING PRODUCTS PRIVATE LIMITED',
    'JPM EXPORTS PVT LTD',
    'KADAKIA PLASTICS AND CHEMICALS PRIVATE LIMITED',
    'KAIROS TECHNOLOGIES(P) LTD',
    'JKT LEARNING SOLUTIONS PRIVATE LIMITED',
    'K T C INDIA PVT LTD',
    'K and M GARMENGUARDINI INDIA PVT LTD',
    'JKP MICROMINERALS INDIA PVT LTD',
    'JOYAM ENGINEERS AND CONSULTANTS PRIVATE LIMITED',
    'JK FILES (INDIA) LIMITED',
    'JNK INDIA PRIVATE LIMITED',
    'KAAMA IMPEX PRIVATE LIMITED',
    'JK Securities private limited',
    'JP FIRE SERVICES PVT LTD',
    'JVCKENWOOD MARKETING INDIA PRIVATELIMITED',
    'JUMBO SYSTEMS & SOLUTIONS PVT LTD',
    'KAARYA FACILITIES AND SERVICES PRIVATE LIMITED',
    'JOBTECH HOSPITALITY AND MANAGEMENT SERVICES PRIVATE LIMITED',
    'KAIREE SYSTEM PVT LTD',
    'JURISCAPE LEGAL RESEARCH PRIVATE LIMITED',
    'JTB TRAVELS PRIVATE LIMITED',
    'JUST LIFESTYLE PRIVATE LIMITED',
    'K LINE MARITIME ACADEMY INDIA',
    'K RAHEJA PRIVATE LIMITED',
    'KAIYUAN WELDING AND CUTTING AUTOMATION INDIA PRIVATE LIMITED',
    'JTL MANAGEMENT & HR SERVICES PRIVATELIMITED',
    'KAANE PACKAGING PRIVATE LIMITED',
    'KABBAGE INDIA PRIVATE LIMITED',
    'Kansal hosiery exports limited',
    'KAPPA INTERNET SERVICES PVT LTD',
    'KANEGRADE FLAVOURS AND INGREDIENTS PRIVATE LIMITED',
    'KALAMKRIYA LIMITED',
    'KANTA ENTERPRISES PVT LTD',
    'KASHYAP MOTORS INDIA PVT LTD',
    'KAM AVIDA ENVIRO ENGINEERS PRIVATE LTD',
    'KARUTURI FOODS PRIVATE LIMITED',
    'KARLE INTERNATIONALPVT LTD',
    'KAPO RETAIL PRIVATE LIMITED',
    'KANCHAN METALS PRIVATE LIMITED',
    'KALYX INDIA HEALTH CARE PRIVATE LIMITED',
    'KB POLYCHEM INDIA PRIVATE LIMITED',
    'KAMRON LABORATORIES',
    'KARTHIK ENTERPRISES PRIVATE LIMITED',
    'KANADIA FYR FYTER PRIVATE LIMITED',
    'KARADI PATH EDUCATION COMPANY PVT LTD',
    'KALE S GOODS CARRIERS PRIVATE LIMITED',
    'KAIZEN INSTITUTE (INDIA )PVT LTD',
    'KAMAL HEALTHCARE PRODUCTS PVT LTD',
    'KALPAVRUKSH SYSTEMS LTD',
    'KARGO LEAGUE LOGISTICS PRIVATE LTD',
    'KAYOMA TRADING PRIVATE LIMITED',
    'KARS FOODS INDIA PVT LTD',
    'KARYA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'KAPIL PROPERTY MANAGEMENT PRIVATELIMITED',
    'KANTHS IMMIGRATION AND EDUCATIONAL CONSULTANTS PRIVATE LIMITED',
    'KAY PEE SERVICES PRIVATE LIMITED',
    'Kardex india storage solutions pvt ltd',
    'KANAKIA HOTELS AND RESORTS PRIVATE LIMITED',
    'KAPILS SALON INDIA PVT LTD',
    'Kapil avenues and consultants private limited',
    'KBS CERTIFICATION SERVICES PRIVATE LIMITED',
    'KASS TRAVELS PVT LTD',
    'KNOWCROSS SOLUTIONS PVT LTD',
    'KHATTAR HOTELS AND RESORTS LIMITED',
    'KOHINOOR seed fields india pvt ltd',
    'Kirti solar limited',
    'KOCHAR INFOTECH PRIVATE LIMITED',
    'KOJAK KNITS PVT LTD',
    'KHATOR FIBRE AND FABRICS LIMITED',
    'KNACKFORGE SOFT SOLUTIONS PRIVATELIMITED',
    'KIWI ENTERPRISES PVT LTD',
    'KEYA FOODS INTERNATIONAL PVT LTD',
    'KONZERT TOOLINGS PRIVATE LIMITED',
    'KETUN ENERGY PRIVATE LIMITED',
    'KH LEATHER INDUSTRIES PRIVATE LIMITED',
    'KINECO KAMAN COMPOSITES INDIA PRIVATE LIMITED',
    'KN M MANAGEMENT ADVISORY SERVIES PVT LTD',
    'Kellton Securities pvt Ltd',
    'KENT INTELLIGENT TRANSPORTATION SYSTEMS INDIA PRIVATE LIMITED',
    'KIM FUTURE VISION SERVICES LTD',
    'KKASTURI MEDICARE PVT LTD',
    'KOBELCO PLATE PROCESSING INDIA PVT LTD',
    'KNEXIR CONSULTANTS PVT LTD',
    'KMS HEALTH CENTER PVT LTD',
    'KEYSTONE LOGIC SOLUTIONS PRIVATE LIMITED',
    'KOMTECH PLASTIC TECHNOLOGIES INDIA PVT LTD',
    'KEERTI KNOWLEDGE AND SKILLS LIMITED',
    'knowledge centre for success educate pvt ltd',
    'Kejriwal sangam thermopack private limited',
    'Kodak Alaris India Pvt Ltd',
    'KEMEFS SPECIALITIES PRIVATE LIMITED.',
    'KOELNMESSE YA TRADEFAIR PRIVATE LIMITED',
    'KEEC I PRIVATE LIMITED',
    'KONGSBERG DIGITAL SOFTWARE AND SERVICESPRIVATE LIMITED',
    'kmtc india pvt ltd',
    'KLARKE FACILITY MANAGEMENT PRIVATE LIMITED',
    'KENMORE VIKAS INDIA private limited',
    'KK WIND SOLUTIONS INDIA PVT LTD',
    'KHFM HOSPITALITY AND FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'KENDRION PUNE PRIVATE LIMITED',
    'KCLINK TECHNOLOGIES PVT LTD',
    'KHATI DESIGN PVT LTD',
    'KRISHI RASAYAN PRIVATE LIMITED',
    'KRISHNA QUINETTE SEATS PRIVATE LIMITED',
    'KRISHNA AUTOMOBILES PRIVATE LTD',
    'KUN CAPITAL MOTORS PVT LTD',
    'kunsons metals ltd',
    'Kristal Spirits India Pvt Ltd',
    'Datavision software solutions private limited',
    'Dhingra graphics and packaging private limited',
    'Asence pharma private limited',
    'Shah electric motors pvt ltd',
    'Creative transformers private limited',
    'Sintex industries limited',
    'Jsl industries limited',
    'THE DELHI SAFE DEPOSIT COMPANY LIMITED',
    'Avinash builders pvt ltd',
    'Roopam property private limited',
    'MALSISARIA VENTURES PRIVATE LIMITED',
    'Golden textiles private limited',
    'Breach candy hospital trust',
    'D c w limited',
    'Misrilall jain private limited',
    'Assam timber products private limited',
    'Alwar organics private limited',
    'Goa antibiotics and pharmaceuticals limited',
    'Intracin pharmaceuticals private limited',
    'Devendra enterprises pvt ltd',
    'PATIL ARC INDUSTRIES PRIVATE LIMITED',
    'Kamet plastics private limited',
    'Echha impex private limited',
    'Kalinga aquatic ltd',
    'Bmt chrome alloys private limited',
    'Khabros steel (india) limited',
    'Minister rainwear private limited',
    'JAIPUR PRINTERS PRIVATE LIMITED',
    'Styric chem private limited',
    'Ginni vitreous private limited',
    'Lords wear private limited',
    'Valani ltd',
    'Mb wheelers ltd',
    'R s consumables pvt ltd',
    'Dahej harbour and infrastructure limited',
    'Aashna realestate pvt ltd',
    'Kmi estates private limited',
    'Stretch bands (gujarat) private limited',
    'Penosh transport pvt ltd',
    'Sapphire sales and services private limited',
    'Ceraflux india private limited',
    'Maa kali exports pvt ltd',
    'PUNAM GEM & JEWELLERY PVT LTD',
    'Shanbhag hoteliers pvt ltd',
    'Costa river transport private limited',
    'Goa shipyard limited',
    'TEERTH GEOGREEN PRIVATE LIMITED',
    'Choice colonizers private limited',
    'Discover india tours private limited',
    'Belz instruments private limited',
    'Mangla hoists private limited',
    'Milano knits private limited',
    'STERIMED SURGICALS (INDIA) PRIVATE LIMITED',
    'Kad realcon private limited',
    'Paramount farms international private limited',
    'Greenwood villas private limited',
    'B kseth textile mills pvt ltd',
    'Mount fuji promoters private limited',
    'Shobha hotel private limited',
    'River view developers private limited',
    '"THE GORAYA REGISTERED FACTORY OWNERS',
    'S AUDIO VISUAL CENTRE PRIVATE LIMITED',
    'Gren technology & services private limited',
    'VONAMOR MEDIA PRIVATE LIMITED',
    'Balacomm media private limited',
    'Saxena m.k. & associates private limited',
    'Aqua terra logistics private limited',
    'Cubeworks design build private limited',
    'Exit germany (india) private limited',
    'EXCIS COMPLIANCE INDIA PRIVATE LIMITED',
    'Ziel koppelen technologies private limited',
    'Justoutdoor digital advertising private limited',
    'Nsrk consultancy services private limited',
    'Edu asia services private limited',
    'Nova capital advisors private limited',
    'Rhino fireworks private limited',
    'Toja tyre and treads pvt ltd',
    'T m t industrial complex private limited',
    'Trident rubber private limited',
    'Rubber park india private limited',
    'Primus gloves private limited',
    'Gates unitta india company private limited',
    'CONTINENTAL SURFACE SOLUTIONS INDIA PRIVATE LIMITED',
    'Rubber-o-dynat india pvt ltd',
    'Quality mix india pvt ltd',
    'Shrinath flexipack private limited',
    'TALON TACK PRIVATE LIMITED',
    'Virgo polymers private limited',
    'FITESA PUNE PRIVATE LIMITED',
    'Apex tent india private limited',
    'Poddar academic institutions private limited',
    'Psyco remedies limited',
    'Balaji multiflex private limited',
    'Eesha packaging private limited',
    'Premium aqua services private limited',
    'Nirmal images private limited',
    'Veeplast houseware private limited',
    'Narendra flexipack company private limited',
    'Spanker international private limited',
    'Tibriwal plastics pvt ltd',
    'Creative propack limited',
    'VARROC POLYMERS LIMITED',
    'Nylacast polymers private limited',
    'Altius sports & leisure private limited',
    'Asl plastic private limited',
    'Western rubber works pvt ltd',
    'Nexgen fluoropolymers private limited',
    'Theram polymer private limited',
    'Sil mirror private limited',
    'Mirka india private limited',
    'Fevicol company limited',
    'Associated rubber chemicals kochi private limited',
    'Bombay perfumery products pvt ltd',
    'AEROCOAST LOGISTICS PRIVATE LIMITED',
    'Vivacious pharmatex private limited',
    'Generex pharmassist private limited',
    'Annie chemie private limited',
    'Arteco coolants india private limited',
    'Sunworld vitrified private limited',
    'Albus healthcare private limited',
    'KALBURGI CEMENT PRIVATE LIMITED',
    'Broadway realtors private limited',
    'SUNLARGE CONSULTANTS AND PROPERTIES PRIVATE LIMITED',
    'Vikas housing private limited.',
    'Hilton estates private limited',
    'Ajay kumar ghanshyamdas properties developers private limited',
    'Avs infrahomes private limited',
    'Shelter realty private limited',
    'ARAV CONTRACTS LIMITED',
    'Ahinsa buildtech private limited',
    'Delux constructions private limited',
    'Bhayana builders hindustan infrastructure jv private limited',
    'S PARADISE PRODUCER COMPANY LIMITED',
    'LIGHTBEAM SOFTWARE PRIVATE LIMITED',
    'TECH BETTER SERVICES PRIVATE LIMITED',
    'DIGIPUB NEWS INDIA FOUNDATION',
    'VEEGLOW INDUSTRIES PRIVATE LIMITED',
    'THINKRISK DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'COSQ NETWORK PRIVATE LIMITED',
    'NEOPRAXIS INNOVATIONS PRIVATE LIMITED',
    'ECO-EMBRACE DESIGNER CLOTHING PRIVATE LIMITED',
    'CASSIUS CLAY PRIVATE LIMITED',
    'LIVIO BUILDING SYSTEMS PRIVATE LIMITED',
    'ARCH PROJECT SOLUTIONS PRIVATE LIMITED',
    'CAREMEDICO HEALTHTECH PRIVATE LIMITED',
    'PARIVAARA PRIVATE LIMITED',
    'INSPERON BUSINESS SERVICES PRIVATE LIMITED',
    'HARE RAMA HARE KRISHNA (CHARITABLE) FOUNDATION',
    'STONE HOUSE PRIVATE LIMITED',
    'AL-RIZQ INDIA PRIVATE LIMITED',
    'MEDIEASY HEALTHCARE SERVICES PRIVATE LIMITED',
    'BHASKARFIRE ENGINEERING PRIVATE LIMITED',
    'HUGOBYTE AI LABS PRIVATE LIMITED',
    'SENSATION SPAR SKYSCRAPERS PRIVATE LIMITED',
    'SIGNUM ELECTRO PRIVATE LIMITED',
    'CLAZY SMARTINCO SERVICES LIMITED',
    'PEE KAY STRUCTURAL EQUIPMENTS PRIVATE LIMITED',
    'ESTACHA PROPERTY DEVELOPMENTS PRIVATE LIMITED',
    'SSS EVENTS & ENTERTAINMENT PRIVATE LIMITED',
    'PLUTO BUSINESS PARKS PRIVATE LIMITED',
    'RITESERVE TECHNOLOGIES PRIVATE LIMITED',
    'SHRIPATI MANUFACTORY PRIVATE LIMITED',
    'SWIFT MOVE LOGISTICS PRIVATE LIMITED',
    'CREMBERIE FOODS PRIVATE LIMITED',
    'AWINMO INDIA MARKETING PRIVATE LIMITED',
    'STAKQUE DIGITAL PRIVATE LIMITED',
    'FIONAA GOLD PRIVATE LIMITED',
    'CONFEDERATION OF KOLKATA REALTORS',
    'EASEMYCARE HEALTH SERVICES PRIVATE LIMITED',
    'PRAJOT INFRASTRUCTURE PRIVATE LIMITED',
    'NGA PLASTIC TECHNOLOGY PRIVATE LIMITED',
    'VELFINTECH SOLUTIONS PRIVATE LIMITED',
    'LACHMANDAS PROPERTIES PRIVATE LIMITED',
    'COACH CHAKRA LEARNING SOLUTIONS PRIVATE LIMITED',
    'RKIT TECHNOLOGIES PRIVATE LIMITED',
    'DH HEALTHCARE SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'EXXOPTIMUS PARTNERS PRIVATE LIMITED',
    'UNITED TEX CHEM SOLUTIONS PRIVATE LIMITED',
    'TURBOCHARGE STARTUP PRIVATE LIMITED',
    'NETWORK ERA PRIVATE LIMITED',
    'MEIL NEELESHWARAM ROADWAYS PRIVATE LIMITED',
    'PCC APOSTILLE AND ATTESTATION SERVICES INDIA PRIVATE LIMITED',
    'STARLASTING EXIM PRIVATE LIMITED',
    'POLYCON SPECIALITY CONTAINERS PRIVATE LIMITED',
    'KWALICHEM PRIVATE LIMITED',
    'ASSYSTEM ENGINEERING SERVICES INDIA PRIVATE LIMITED',
    'MOLECULAR CONNECTIONS ANALYTICS PRIVATE LIMITED',
    'RAIDEN VENTURES FRANCHISE (RVF) BUSINESS LIMITED',
    'VINTA LABS PRIVATE LIMITED',
    'DEKCO IMAGE MANAGEMENT SYSTEMS PRIVATE LIMITED',
    'HYBRIDHIVE TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SUKHADA FOUNDATION',
    'MY INFOURLINE SERVICES PRIVATE LIMITED',
    'UNILEARN EDUTECH PRIVATE LIMITED',
    'PRESERVE WATER PRIVATE LIMITED',
    'NASSCRIPT SOFTWARE INNOVATIONS PRIVATE LIMITED',
    'MYSTUDIA PRIVATE LIMITED',
    'STANDUS (OPC) PRIVATE LIMITED',
    'WIM PLAST MOULDING PRIVATE LIMITED',
    'TOTAL CONFRA SOLUTIONS PRIVATE LIMITED',
    'PRITT RENEWABLES PRIVATE LIMITED',
    'V.K. AGRICULTURE EQUIPMENTS PRIVATE LIMITED',
    'SPV SYNERGY PRIVATE LIMITED',
    'EASITEQ ENGINEERING SERVICES PRIVATE LIMITED',
    'RIVERBANQ MUTUAL BENEFIT NIDHI LIMITED',
    'ENABLECAP PRIVATE LIMITED',
    'THEORYDESK PRIVATE LIMITED',
    'DENTGANGA PRIVATE LIMITED',
    'ACME COATTECH PRIVATE LIMITED',
    'MUNARA AGRO TECHNOLOGIES PRIVATE LIMITED',
    'DHANABHADRAM NIDHI LIMITED',
    'T-SHAW RESOURCES PRIVATE LIMITED',
    'DROPADI ESTATES PRIVATE LIMITED',
    'SERVERMOJO TECHNOLOGIES (OPC) PRIVATE LIMITED',
    '4 BHAI FITNESS PRIVATE LIMITED',
    'MOLECULAR CONNECTIONS RESEARCH PRIVATE LIMITED',
    'CAPITALFUSION INDIA PRIVATE LIMITED',
    'SOIL N SAGE NATURELLE (OPC) PRIVATE LIMITED',
    'AMBEGO VENTURES PRIVATE LIMITED',
    'ANAY AGRI PRODUCER COMPANY LIMITED',
    'BRAND KALAKAR PRIVATE LIMITED',
    'ARCHANA',
    'S FORMULATIONS LIMITED',
    'DYNAMIND SOLUTIONS PRIVATE LIMITED',
    'VEDSONS DESIGN STUDIO PRIVATE LIMITED',
    'IFB REFRIGERATION LIMITED',
    'BB COMMUNICATION HUMAN RESOURCES AND DEVELOPMENT PRIVATE LIMITED',
    'R. B. SAFE SECURITY SYSTEMS PRIVATE LIMITED',
    'JRG LAMINATES PRIVATE LIMITED',
    'FILZR MART PRIVATE LIMITED',
    'AVIT PRO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DR. RAO',
    '.CURIE',
    'S ICE CREAM & INDUSTRIES PRIVATE LIMITED',
    'PIPAL E-COMMERCE PRIVATE LIMITED',
    'DIGICART RETAILS PRIVATE LIMITED',
    'EXOWEAVES RETAIL PRIVATE LIMITED',
    'BODY CUPID PRIVATE LIMITED',
    'ROTHE PACKTECH PRIVATE LIMITED',
    'N V JOSEPH EXPORTS PRIVATE LIMITED',
    'COMPLICHECK SYSTEMS PRIVATE LIMITED',
    'CORNER STORE TECHNOLOGIES PRIVATE LIMITED',
    'NAILA EXIM PRIVATE LIMITED',
    'ACHARIYA MEGA MART PRIVATE LIMITED',
    'OMMTAYAL FARMS PRIVATE LIMITED',
    'ROYAL TOUCH INTERIORS PRIVATE LIMITED',
    'A4 PHARMA PRIVATE LIMITED',
    'FOODCOGNICS INDIA PRIVATE LIMITED',
    'BEONIA E-COMMERCE PRIVATE LIMITED',
    'BELSI RETAIL PRIVATE LIMITED',
    'OCI LIFESTYLES PRIVATE LIMITED',
    'INSANELY GREAT RETAILS PRIVATE LIMITED',
    'I TORQ (INDIA) PRIVATE LIMITED',
    'ESMARIO MARINE PRIVATE LIMITED',
    'SANABEL RETAIL PRIVATE LIMITED',
    'SPLEN MICA PRIVATE LIMITED',
    'Shri ram plastofab private limited',
    'Konkan polymers and additives private limited',
    'Platinum polymers private limited',
    'Avigiri urethane & rubber industries private limited',
    'Ea packaging india private limited',
    'Kothari agritech private limited',
    'MALAIKA APPLIANCES Limited',
    'Gujarat polyplast private limited',
    'CHEMCO PACKAGING INDUSTRIES PRIVATE LIMITED',
    'Kinugawa rubber india private limited',
    'Saroj buildcon private limited',
    'Surat glass india limited',
    'Vardhaman remedies private limited',
    'Luma optics private limited',
    'Clayris ceramics private limited',
    'Cepro building systems private limited',
    'Lumen ceramic private limited',
    'Orb ceramic private limited',
    'Hollis vitrified private limited',
    'Kmg ceramics india private limited',
    'Marujyu technology india private limited',
    'Enseft bitumenous products private limited',
    'Victoria utility services private limited',
    'Kalina engineering private limited',
    'JAY JAGDAMBA LIMITED',
    'Kalapurna steel and engg. private limited',
    'Avg wire screens private limited',
    'Sai forge private limited',
    'Madras electro castings limited',
    'HYUNDAI STEEL INDIA PRIVATE LIMITED',
    'Toyota tsusho india private limited',
    'Jyoti bright steel private limited',
    'Logos engineering private limited',
    'Asansol steel castings pvt ltd',
    'Thakkarsons roll forming private limited',
    'RAJASTHAN TRANSMAT PRIVATE LIMITED',
    'V s l steels limited',
    'Kesar aluminium india private limited',
    'Sri shiridi sai enterprises private limited',
    'OHT FASTCOMP PRIVATE LIMITED',
    'Shree himachal metals private limited',
    'Aar dee extrusions (india ) private limited',
    'Deccan exploration services private limited',
    'Indian commodity exchange limited',
    'ROONGTA RISING WEALTH MANAGEMENT PRIVATELIMITED',
    'Moneymontra finman services private limited',
    'Garg securities private limited',
    'Hasham investment and trading co pvt ltd',
    'Champions holdings private limited',
    'Champion superior capital solutions private limited',
    'Sonal investments private limited',
    'Castle investment and industries private limited',
    'Crescent holdings and enterprises private limited',
    'Mukesh investments pvt ltd',
    'XRBIA FINANCIAL SERVICES PRIVATE LIMITED',
    'Dharamshi securities private limited',
    'Insurance brokers association of india',
    'Accent chits private limited',
    'Kankeshwari finance private limited',
    'Miker financial consultants private limited',
    'Abcin services private limited',
    'Ifast financial india private limited',
    'Cowry capital private limited',
    'NCML FINANCE PRIVATE LIMITED',
    'R v capital services private limited',
    'Redbrick capital advisors private limited',
    'Brain ex wealth management services private limited',
    'Varanium advisory private limited',
    'Tamilnadu urban infrastructure financial services limited',
    'Sga business services pvt ltd',
    'Jumpstart insurance consultants private limited',
    'Anmol legal services private limited',
    'Pc technowledge centre private limited',
    'Good faith insurance broker private limited (cn)',
    'Almora townships private limited',
    'Hedge properties private limited',
    'Multi act realty enterprises pvt ltd',
    'Bhaveshwar real estate developers private limited',
    'Virman real estate private limited',
    'Denis leasing and infotech private limited',
    'VITALIZE GALAXY PRIVATE LIMITED',
    'Blue throat infrastructure private limited',
    'Rajat infraventures private limited',
    'Rishabh buildcon private limited',
    'Goldenarc projects private limited',
    'Rashmi construction private limited',
    'Inmedica health private limited',
    'Golden touch welfare foundation',
    'G2 healthcare private limited',
    'Vrundavan shalby hospitals limited',
    'SWISS PARENTERALS LIMITED',
    'Shalby limited',
    'SETCO AUTO SYSTEMS PRIVATE LIMITED',
    'Jasky exports private limited',
    'Remco granite limited',
    'Rasa sri developers private limited',
    'Polyflex technologies private limited',
    'Emids technologies private limited',
    'Cherish medical centre private limited',
    'Yashomati hospitals private limited',
    'Modern family doctor private limited',
    'Encore healthcare private limited',
    'Unicity health private limited',
    'Macare dental care private limited',
    'Integrated endodontics private limited',
    'Alliance dental care limited',
    'ARMAX HEALTH PRIVATE LIMITED',
    'Samhita institute of mental health and neurosciences private limited',
    'GAR PROPERTY DEVELOPMENT SERVICES PRIVATE LIMITED',
    'Am thyrovision laboratories private limited',
    'Eurofins genomics india private limited',
    'Mmsh clinical research private limited',
    'Prevest denpro limited',
    'Thakurs artistic yoga private limited',
    'Tech mahindra foundation',
    'Stanworth management private limited',
    'Cotton association of india',
    'Cognizant foundation',
    'F. k. films private limited',
    'Wi-chitra works private limited',
    'Dibakar banerjee productions private limited',
    'Celebzone media private limited',
    'Catalyst management services private limited',
    'Jarus technologies (india) private limited',
    'Big daddy productions private limited',
    'Shree ashtavinayak light cameraaction limited',
    'Mahesh bhupathi tennis academies private limited',
    'Word telecasting company limited',
    'Madhyam entertainment private limited',
    'Planet buzz (i) private limited',
    'Abhishek investments pvt ltd',
    'Gvr ajmer nagaur tollway private limited',
    'G-corp infracon private limited',
    'Atlanta global real estate (india) private limited',
    'Millennia developers private limited',
    'Floatels engineering private limited',
    'Samira constructions (india) limited',
    'Oxalis properties private limited',
    'Veritas design and planning india private limited',
    'Pier 4 infra solutions private limited',
    'Landlord properties private limited',
    'K d aher building systems private limited',
    'Matrix enport holdings private limited',
    'Csk infracon india private limited',
    'BAHUVIDA LIMITED',
    'WALAYAR VADAKKENCHERRY EXPRESSWAYS PRIVATE LIMITED',
    'R v avenues private limited',
    'Shri sevalal construction private limited',
    'Metroline (shivpuri) realcon private limited',
    'Metroline (shivpuri) developers private limited',
    'Metroline (shivpuri) builders private limited',
    'Shree ganesh buildtech construction private limited',
    'Vss buildcon private limited',
    'K s infratel solutions private limited',
    'Supreme panvel indapur tollways private limited',
    'Peepaltree developers private limited',
    'Harihar infrastructure development corporation limited',
    'Nouveau developers private limited',
    'ULLTRA LIFESPACE PRIVATE LIMITED',
    'Content properties private limited',
    'Manprit real estate private limited',
    'Serenity developers private limited',
    'Jogihalli infrastructure company private limited',
    'Maitry infra realtors private limited',
    'Id india private limited',
    'Boss properties private limited',
    'R v residence private limited',
    'Snowwhite infrastructure private limited',
    'Pragati realcon private limited',
    'Earthwork nirman private limited',
    'Princely infrastructure private limited',
    'Uday autolink private limited',
    'Sarthi wheels (india) private limited',
    'Neesa vacation club private limited',
    'Balvas hospitalities private limited',
    'Viral hospitality private limited',
    'Blue horizon hotels private limited',
    'Vivavivid resorts private limited',
    'Klassic recreation and resorts private limited',
    'Berggruen hotels private limited',
    'First residences private limited',
    'LANDMARK LEISURES & HOTELS PRIVATE LIMITED',
    'Phadnis resorts and spa india limited',
    'Adhik resort india private limited',
    'Phadnis hotels limited',
    'Sahil hospitality limited',
    'Prg hospitality services private limited',
    'Nortels service apartments private limited',
    'A s e hotels private limited',
    'Sanmati infradevelopers private limited',
    'Mirah food solutions private limited',
    'Vayudoot road carriers private limited',
    'Commercial carriers limited',
    'Hall mark cargo private limited',
    'Aarya trans solutions private limited',
    'Kenshine shipping private limited',
    'Ocean blue marinas and boat haven private limited',
    'Ryder shipping lines private limited',
    'Quest cargo private limited',
    'ABB SHIP MANAGEMENT PRIVATE LIMITED',
    'Sky one airways private limited',
    'Royalmarine logistics private limited',
    'Wah holidays private limited',
    'Bridgegap travels private limited',
    'Sky planners private limited',
    'Ayushi air travels private limited',
    'Satguru roadways private limited',
    'Seven star forwarding and logistics private limited',
    'Aadee logitrans private limited',
    'Oceanbrave shipping private limited',
    'Arnav logistics park private limited',
    '3h trawell private limited',
    'Travel deals 24x7 private limited',
    'GDCM LOGISTICS SERVICES PRIVATE LIMITED',
    'Southernsky air services private limited',
    'Unitac logistics private limited',
    'Budget cargo india private limited',
    'Rudram logistics services private limited',
    'SWIFT SHIPPING PRIVATE LIMITED',
    'Jetway forwarders private limited',
    'Seamax shipping india private limited',
    'NORTH SEA SHIPPING& LOGISTICS PRIVATE LIMITED',
    'ACCUTIME MOVERS & PACKERS PRIVATE LIMITED',
    'El shaddai freight express private limited',
    'Space hunters india private limited',
    'Srajan infrastructure developers and builders private limited',
    'Sadguru land and developers private limited',
    'Micro crystal housing private limited.',
    'Stuti realty private limited',
    'Kshitiraj realty private limited',
    'Sinhraj builders and developers private limited',
    'India land infrastructure development private limited',
    'Panchshil infrastructure holdings private limited',
    'Matoshree sahil infrastructure private limited',
    'Abhikalp infrastructure india private limited',
    'Infinity edifice private limited',
    'Mayamatha construction private limited',
    'Shanta sriram constructions private limited',
    'KAKINADA SEZ LIMITED',
    'Keystone infra private limited',
    'Venus infrastructure and developers private limited',
    'Kalawati organisers private limited',
    'Dhwani infrastructure private limited',
    'Ganesh infraprojects private limited',
    'Asawara earthtech private limited',
    'NUENERGI & INFRA EPC LIMITED',
    'Ashrita construction private limited',
    'H v infrabuild private limited',
    'Pcs integrated services private limited',
    'Sharief infrastructure private limited',
    'Earthlinks infra private limited',
    'Cicon structurals private limited',
    'RGM INVESTMENTS & PROPERTIES PVT LTD',
    'Siddhdarsh developers private limited',
    'Indiana build infrastructure private limited',
    'Convex properties private limited',
    'Distinctive realty private limited',
    'Mumbai metro one private limited.',
    'ASTEROPE PROPERTIES PRIVATE LIMITED',
    'Sustain properties private limited',
    'Triumfo technogroup private limited',
    'Hazel erectors private limited',
    'Micro ankur housing private limited.',
    'Shree ahuja properties and realtors private limited',
    'Pashmina builders & developers private limited',
    'Pashmina developers private limited',
    'Pramaan properties private limited',
    'KHAN & CO. INTERIORS PRIVATE LIMITED',
    'Glomore constructions private limited',
    'Maitri homes private limited',
    'Aadhya buildcon private limited',
    'BLUEKEY REALTY PRIVATE LIMITED',
    'Bg infrashelters private limited',
    'Triveni lifestyle private limited',
    'Suchi builders and developers private limited',
    'FREE A BILLION PRIVATE LIMITED',
    'Dess technologies private limited',
    'Buzzmeter.digital engagineers private limited',
    'Netobyte india private limited',
    'NOVENTIQ SERVICES INDIA PRIVATE LIMITED',
    'Data soft tech private limited',
    'Emc software and services india private limited',
    'Panchshil corporate park private limited',
    'Netwin infosolutions private limited',
    'P-one infrastructure private limited',
    'GLOBANT INDIA PRIVATE LIMITED',
    'Finite 4 engineering consultancy services private limited',
    'G2C ONLINE SERVICES LIMITED',
    'Empower it systems private limited',
    'DIGITAL CONVERGENCE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Ellicium solutions private limited',
    'Reach factory digital media private limited',
    'Ropalsoft technologies private limited',
    'Bics infotech private limited',
    'Page solutions private limited',
    'Adroit neo tech solutions private limited',
    'Tech vedika software private limited',
    'Matchfinder online services private limited',
    'Coromandel infotech india limited',
    'Introlligent solutions private limited',
    'Zirlen technologies private limited',
    'Aparajayah technologies private limited',
    'Gabriels technology solutions india private limited',
    'Usp studios private limited',
    'AZURE JEWELLERY MANUFACTURING PRIVATE LIMITED',
    'Access suites private limited',
    'MADOVERFISH INDIA PRIVATE LIMITED',
    'Fiora hypermarket limited',
    'Techniques infosoft solutions (india) private limited',
    'Frames movies private limited',
    'Earth garden private limited',
    'Amel services and consultancy private limited',
    'Gis infocom private limited',
    'AINILAM ROBOTICS PRIVATE LIMITED',
    'European business and technology centre',
    'Fsi emp india private limited',
    'Winoa abrasives india private limited',
    'Spine advisory private limited',
    'Biosafe lab india private limited',
    'Medavin healthtech private limited',
    '3d blueprint (india) private limited',
    'M&co. advisors and consultants private limited',
    'MILESTONE FINANCIAL DISTRIBUTION PRIVATE LIMITED',
    'Sur advisory services private limited',
    'Shayona management services private limited',
    'Graduate management admission council (india) private limited',
    'Texamine private limited',
    'CREATIVE INTEGRATED SERVICES PRIVATE LIMITED',
    'SHRI BALAJI VALVE COMPONENTS LIMITED',
    'Carbide cutting tools private limited',
    'JOHN COCKERILL GLOBAL BUSINESS SERVICES PRIVATE LIMITED',
    'T d williamson india private limited',
    'Jsg steel fabricators private limited',
    'Vibecube engineering private limited',
    'Waaree energies limited',
    'Lucent bio-medical private limited',
    'Lubeman engineers private limited',
    'High vacuum technologies and products private limited',
    'Hypratek fluid power private limited',
    'Flutech engineering private limited',
    'Teejet technologies (india) private limited',
    'Clean tech synergy private limited',
    'M-EXTEND INDIA PRIVATE LIMITED',
    'Creative dies & moulds private limited',
    'MK TRON AUTOPARTS PRIVATE LIMITED',
    'Sigma forging & forming private limited',
    'Malvika electronics private limited',
    'Alpha electric and engineering (india ) private limited',
    'Powercon projects and associates limited',
    'Memory electronics private limited',
    'Thakor electronics limited',
    'Media electronics limited',
    'Vedacom (india) pvt ltd',
    'Tancom electronics private limited',
    'United telelinks(bangalore)limited',
    'Zaran trading agencies private limited',
    'WAAREE INFRASTRUCTURE & AGRITECH PRIVATE LIMITED',
    'Tandon magnetics (india) private limited',
    'Cengres tiles limited',
    'Jet granito private limited',
    'Drsti precast private limited',
    'AVASK STEELS LIMITED',
    'Atul technocast private limited',
    'Triveni infrasteel limited',
    'DHANYA TMT PRIVATE LIMITED',
    'Sks ispat and power limited',
    'Echelon metals private limited',
    'Stel-tec private limited',
    'Polmor steel private limited',
    'Arrow cables limited',
    'Koushic pressure vessels private limited',
    'Eastman cast and forge ltd',
    'International tubes india private limited',
    'Metal india products private limited',
    'Utech engineering works (india) pvt ltd',
    'Sai cylinders private limited',
    'Mother india forming private limited',
    '3a composites india private limited',
    'Intricast private limited',
    'Mahabir extrusions private limited',
    'Panchalloy steel & forging private limited',
    'S m structural steel private limited',
    'Src casting private limited',
    'RMC SWITCHGEARS LIMITED',
    'Unique shell mould india private limited',
    'DAN INFRAPROJECTS PRIVATE LIMITED',
    'Avis metal industries limited',
    'UNM LIFESPACES PRIVATE LIMITED',
    'Tirupur container terminals private limited',
    'Congas food service equipments pvt ltd',
    'Neelkamal homes private limited',
    'Tirupati nirman private limited',
    'Complete infrastructure private limited',
    'A & p buildinfra private limited',
    'Prrsaar properties private limited',
    'Rapid real estate private limited',
    'Panchtatva infrabuild private limited',
    'Lanco kanpur highways limited',
    'M far constructions private limited',
    'Quatrus infrastructure private limited',
    'Near view reality private limited',
    'Remus habitat private limited',
    'Narayana infra projects india limited',
    'Amrutha mansions private limited',
    'Vrinda infradevelopers (india) private limited',
    'Spine properties private limited',
    'Broad field developers private limited',
    'Hariraj homes private limited',
    'Adept engineering solutions private limited',
    'Doon infradeveloper private limited',
    'San-tosh infrastructure pvt. ltd.',
    'Plk properties private limited',
    'Dimension realtors private limited',
    'Dimension nirman private limited',
    'SPURT HIGHRISE PRIVATE LIMITED',
    'Rajdoot enclave private limited',
    'Satyam enclave private limited',
    'Dipika realtech private limited',
    'Siddha hospitality private limited',
    'Vishwam infra developers private limited',
    'Excelline developers private limited',
    'Conscious developers private limited',
    'Shri murdeshwar tiles private limited',
    'Arc trends door solutions private limited',
    'Swiftrans international private limited',
    'Bhavna auto pureinfra private limited',
    'Balaji auto enterprises (mysore) private limited',
    'FABLE ADVISORY SERVICES LIMITED',
    'Podar eduspace private limited',
    'Edelweiss trusteeship company limited',
    'Nkd consultants private limited',
    'Gulab fin invest private limited',
    'Richa finance and investment private limited (trf)',
    'Sevelac investments private limited.',
    'MSE FINANCIAL SERVICES LIMITED',
    'Stan professionals private limited',
    'SAAN POPULAR FINANCE PRIVATE LIMITED',
    'Puja Trades & Investments Private Limited',
    'Veer capital management private limited',
    'Avista corporate finance advisory private limited',
    'Banyantree finance private limited',
    'Sri anoor property holdings private limited',
    'Ifin credit limited',
    'TRIMURTI AGEPRO PRIVATE LIMITED',
    'SHREE INSURANCE BROKERS PRIVATE LIMITED',
    'Sarsa insurance brokers private limited',
    'Peirce leslie insurance surveyors and loss assessors limited',
    'Alegion insurance broking private limited',
    'G.r. realcon private limited',
    'Bahadurgarh townships private limited',
    'Marvel realtech private limited',
    'Dinbandhu enterprises private limited',
    'Karmark estates private limited',
    'Saiba hotels and properties private limited',
    'Patel energy limited',
    'Shree prithvi estates (india) private limited',
    'Namrata developers private limited',
    'Island properties private limited',
    'Viraj properties private limited',
    'Riya shriya properties private limited',
    'Palss properties private limited',
    'Intel land developers private limited',
    'G g land and leasing private limited',
    'Blue rose properties private limited',
    'Techno realtors private limited',
    'Mohak mercantile private limited',
    'Ecostruk homes private limited',
    'Amrita estates private limited',
    'Fateh buildcon private limited',
    'Online real estate private limited',
    'Target real property (india) private limited',
    'Jagadamba shelter private limited',
    'Pawan putra devcon private limited',
    'AYUTHAYA PROPERTIES & REAL ESTATE DEVELOPMENT PRIVATE LIMITED',
    'Technocraft construction private limited',
    'Shri jee housing (pvt) ltd',
    'Horizon building solution private limited',
    'Ramgarh infrastructure private limited',
    'Parivesh construction private limited',
    'Nav grih developers private limited',
    'Frugal labs tech solutions private limited',
    'Saahas waste management private limited',
    'I-link research solutions india private limited',
    'Parkingrhino online services private limited',
    'Cec exhibitions private limited',
    'Genesis motors private limited',
    'CRAVIN VENTURES PRIVATE LIMITED',
    'Anlage infotech (india) private limited',
    'SECURISE TECHNOLOGIES PRIVATE LIMITED',
    'Enso holdings & finance private limited',
    'Indelible holdings private limited',
    'GOPESH',
    'S HEALTHCARE PRODUCTS PRIVATE LIMITED',
    'Grabmore internet private limited',
    'Open minds services private limited',
    'Mouse back solutions private limited',
    'Total plant engineering and design private limited',
    'MAX HAIR CLINIC PRIVATE LIMITED',
    'Digital film restore private limited',
    'Radient vincom private limited',
    'Mahestala agro foods private limited',
    'Protel chemicals private limited',
    'Nirmaya laboratories private limited',
    'Bhagwati organics private limited',
    'VALENTINE INDIA PRIVATE LIMITED',
    'Universal fine chemicals private limited',
    'Oswal dyechem private limited',
    'B.l. organics private limited',
    'Siddhartha fertichem private limited',
    'Krishana phoschem limited',
    'MV MOBILITY LIMITED',
    'Mandhana polymers private limited',
    'Hartex tubes private limited',
    'Perkybean polymers private limited',
    'Resico (india) private limited',
    'Nishigandha polymers private limited',
    'Cad paper machine pvt ltd',
    'TARAKAMI UNIVERSAL PRIVATE LIMITED',
    'Tejas organics pvt ltd',
    'Mehk chemicals pvt ltd',
    'Wanksons chemicals industries private limited',
    'Goodearth agrochem private limited',
    'Hyderabad ammonia and chemicals pvt ltd',
    'Notion press media private limited',
    'Global printing and packaging company private limited',
    'Prits leather exports private limited',
    'Manipal technologies limited',
    'Simran international export (india) private limited',
    'Esbeco india hides and skins private limited',
    'Mapunity information services private limited',
    'Technocrat printers private limited',
    'S s fuels private limited',
    'Indo swiss chemicals limited',
    'Varmora forge private limited',
    'Star fluoropolymers shoppe private limited',
    'Natural incense company private limited',
    'Disha chemicals india private limited',
    'Caraco pharmaceuticals private limited',
    'Papertex speciality chemicals private limited',
    'Coventya india private limited',
    'Zucchini india chemicals private limited',
    'Cropcare biotech private limited',
    'Prem barium industries private limited',
    'Newkem insulations manufacturers pvt ltd',
    'Aimco ecoscience limited',
    'JOYMAX COLONIZERS AND DEVELOPERS PRIVATE LIMITED',
    'CREST CONSTRUCTIONS PRIVATE LIMITED',
    'Abz skyline properties private limited',
    'P and k plinth private limited',
    'Preet builders pvt ltd',
    'True value homes (india) private limited',
    'Mss constructions private limited',
    'Triumph realtors india private limited',
    'P g c promoters (india) private limited',
    'R k city developers private limited',
    'A v bhat and sons developers private limited',
    'Aarushi agencies private limited',
    'Shree shyam leela constructions private limited',
    'JAJOO EXIM PRIVATE LIMITED',
    'Nainital buildcon private limited',
    'Kullu buildcon private limited.',
    'LIPSITA PROJECTS & SERVICES PRIVATE LIMITED',
    'Shyam kripa buildwell private limited',
    'Acme complex private limited',
    'Premium homeware private limited',
    'Sangmeshwar realtors private limited',
    'Kedareshwar properties private limited',
    'Marleshwar properties private limited',
    'Madhvi properties private limited',
    'Someswar realtors private limited',
    'Ceg technoconsult private limited',
    'Arvind buildhome private limited',
    'Manglam build-developers limited',
    'Incredible infratech limited',
    'Kasturi housing and constructions private limited',
    'Rohan and rajdeep infrastructure private limited',
    'RVR DIGITAL INFRASTRUCTURES LIMITED',
    'Ambattur realty private limited',
    'Innovative contracts private limited',
    'Adel landmarks limited',
    'Magna infrastructure private limited',
    'Akshar land developers private limited',
    'Track estates private limited',
    'Matoshree infrastructure private limited',
    'Sahyog contractors private limited',
    'Marshal microware infrastructure development company private limited',
    'Kanuha infra engineers private limited',
    'Virtuous infra limited',
    'Jamshedpur property developers pvt ltd',
    'Radheykrishna technobuild private limited',
    'Nirmanvridhi constructions private limited',
    'Maverick innovations private limited',
    'Jupiter infrastructure (india) private limited',
    'Sunworld infrastructure private limited',
    'Bkc estates private limited',
    'Eco envisage private limited',
    'Kamineni health care private limited',
    'Trisha infracon projects private limited',
    'Camron constructions private limited',
    'Uncut sewage solutions private limited',
    'Kartik finance and investments private limited',
    'Berkeley finance limited',
    'Contypark finance corporation limited.',
    'Apna insurance broking consultants india private limited',
    'M b boda insurance brokers private limited',
    'Prudence capital and money markets private limited',
    'Growing opportunity finance (india) private limited',
    'Sneh investments pvt ltd',
    'Unilight reinsurance brokers private limited',
    'Shriram general insurance company limited',
    'Tata capital financial services limited',
    'PRACHETAS ADVISORY SERVICES PRIVATE LIMITED',
    'Rapid creleasing private limited',
    'Sidhu investments private limited',
    'Nirdhan development & microfinance',
    'Akash finsec private limited',
    'Silverlink securities private limited',
    'Amrut dredging and shipping limited',
    'Mutha gold finance private limited',
    'P d p steels ltd',
    'Ishita holdings pvt. ltd',
    'Nsd syndicate india private limited',
    'Disari india micro finance development institution',
    'Kasturi metal composite private limited',
    'Anusuya blenders private limited',
    'Snk investments private limited',
    'S t holdings private limited',
    'Matushree investment pvt limited',
    'Singla fin leas private limited',
    'Dilip holdings private limited',
    'Minesh capital and holdings private limited',
    'Tower capital and securities private limited',
    'Zodiacal investments private limited',
    'Ankur infotech pvt ltd',
    'Shankar securities private limited',
    'JUPITER INFRATRADE PRIVATE LIMITED',
    'K jayantilal securities private limited',
    'Muthoot insurance brokers private limited',
    'Hira infra-tek limited',
    'Shyam realcon private limited',
    'R r nabar and company share brokers private limited',
    'R natvarlal parekh securities private limited',
    'R h securitites private limited',
    'Skg securities pvt ltd',
    'Yg realtech private limited',
    'Nagesh real estate private limited',
    'Hardwin buildcon private limited',
    'Samsar holdings private limited',
    'Ashith n kampani securities private limited',
    'Godavari biorefineries limited',
    'Avec realty private limited',
    'SREEGA ENTERPRISES PRIVATE LIMITED',
    'Regalpalms infrastructure private limited',
    'Rampant builders (india) private limited',
    'Gilt investment private limited',
    'Accord estates pvt ltd',
    'Kylesal holidays private limited',
    'Piya investments private limited',
    'Shripal trading private limited',
    'ALANKIT INSURANCE TPA LIMITED',
    'Fair deal insurance brokers private limited',
    'Ion exchange financial products private limited',
    'COFFEE DAY TRADING LIMITED',
    'Sympro consulting private limited',
    'JBS ENTERPRISES LIMITED',
    'Ksa architects and planners private limited',
    'BHATAWADEKAR HOLDINGS PRIVATE LIMITED',
    'Workspace design studio private limited',
    'Manipal ace event management company private limited',
    'Vantedge professional services private limited',
    'Sattva oil and gas engineering consultants private limited',
    'Labour laws and personnel services private limited',
    'K g n infrastructures private limited',
    'Sahyog design way private limited',
    'Insight brandcom private limited',
    'Design definition advertising private limited',
    'Red baron integrated services private limited',
    'Msb e-trade securities limited',
    'Global solar energy (india) limited',
    'Nrg consultants private limited',
    'S.c.j. sales private limited',
    'Sarvottam fabtex private limited',
    'Creative overseas private limited',
    'Akhil ribbons private limited',
    'MAURER-SANFIELD INDIA LIMITED',
    'Consolidated carpet industries limited',
    'Madhya bharat power corporation limited',
    'Vls securities limited',
    'R l walecha and associates private limited',
    'MOTIF ELECTRIC LIMITED',
    'Akn management consutlants private limited',
    'Wheels forwarders private limited',
    'Super creative graphic services private limited',
    'Vivek financial focus limited',
    'RATNALAYA NIWAS LIMITED',
    'Driplex water engineering private limited',
    'GARMENTS EXPORTERS AND MANUFACTURERS ASSOCIATION',
    'Narang scientific works private limited',
    'Pamposh constructions (india) private limited',
    'Sagu flexo packagings private limited',
    'Emperor investmens pvt ltd',
    'S and a motors private limited',
    'Akar impex private ltd',
    'Aditya ecological projects private ltd',
    'Elcon components private ltd',
    'Tacker technologies private limited',
    'Deep emotions publishing private limited',
    'Bhartiya global marketing limited',
    'Ananya fincap limited',
    'Mono plastic industries private ltd',
    'Alpasso industries private limited',
    'C2p engineering solutions private limited',
    'Lamech engineers private limited',
    'Ritco leasing and finance pvt ltd',
    'Jmd limited',
    'Perfect commercial private limited',
    'Jamvant estates private limited',
    'Cmg biotech private limited',
    'Superlative infrastructure private limited',
    'Savitri electronics private limited',
    'Venture media private limited',
    'Geomysore services india pvt ltd',
    'Design mechanics india private limited',
    'HITKARI MULTI-FILTERS PRIVATE LIMITED',
    'Alankamony nets private limited',
    'C m smith and sons limited',
    'Ginza industries ltd.',
    'Shrikrishnajee health foods private limited',
    'General mills food products india private limited',
    'Kretek cigarettes distributors private limited',
    'VIKRAM SOLAR LIMITED',
    'Sports and leisure apparel limited',
    'Grand labels private limited',
    'Nu-pon industries pvt ltd',
    'Vikas texfab private limited',
    'Ethenic attire india privat limited',
    'Zedex clothing private limited',
    'Vignesh apparels private limited',
    'Scotts wears private limited',
    'Premier fine linens private limited',
    'Major apparels private limited',
    'Permeshwar creations private limited',
    'Duke fashions (india) limited',
    'Kapoor cotsyn pvt.ltd.',
    'Sakthi ganesh textiles private limited',
    'V s p industries private limited',
    'Twistex india ltd',
    'Cacobean chocolatier private limited.',
    'Aurea biolabs private limited',
    'Sri jaganatha textiles limited',
    'Vishnuraam textiles limited',
    'Himatsingka wovens private limited',
    'Guru fashions pvt. ltd.',
    'IWL INDIA PRIVATE LIMITED',
    'Bindal silk mills private limited',
    'Am texturisers private limited',
    'Asiam studio private limited',
    'WHITE LOTUS POLYTEX PRIVATE LIMITED',
    'Ankur fiber private limited',
    'Deccan fabrics private limited',
    'Kansons textile private limited',
    'TAYAN CREATIONS PRIVATE LIMITED',
    'Krisven international private limited',
    'Creative dresses private limited',
    'Shahlon textile park private limited',
    'Avon cottex private limited',
    'S 2 resources private limited',
    'Conifer industries private limited',
    'Jasdan conbuild private limited',
    'Abundancia eco friendly resorts private limited',
    'Achievers real estate private limited.',
    'Abacus infocon private limited',
    'Meridian edutech solutions private limited',
    'Phoenix infrastructure private limited',
    'Natlass asia construction private limited',
    'Gopal infrastructure private limited',
    'Red projects private limited',
    'AVANCE-ATLAS INFRATECH PRIVATE LIMITED',
    'Lorel buildtech private ltd',
    'Tab realty & housing private limited',
    'Redpro constructions private limited',
    'Redpro developers private limited',
    'Shrachi burdwan developers private limited',
    'Trendy realtors private limited',
    'Ganesh realty and mall development private limited',
    'Diamond niwas private limited',
    'Uttranchal buildwell private limited',
    'Multivision constructions private limited',
    'MANOJ CONSTRUCTIONS PRIVATE LIMITED',
    'A n c l & co (india) private limited',
    'Dinesh buildcon private limited',
    'S t constructions private limited',
    'Shree radhey realtors private limited',
    'Ecodel construction limited',
    'Prabhatam buildtech limited',
    'Silver stone developers private limited',
    'JINDAL REALTY LIMITED',
    'RAJDARBAR BUILDCON PRIVATE LIMITED',
    'Today hotels (new delhi) private limited',
    'Tanishq buildcon private limited',
    'Vef housing developers private limited',
    'Acro tech infrastructure private limited',
    'Tactic engineering india private limited',
    'Tcst building solutions india private limited',
    'Vaikunth realty private limited',
    'Specular buildmart private limited',
    'Vision buildtech private limited',
    'Myriad infrastructure private limited',
    'Shail developers limited',
    'Patron builders pvt ltd',
    'Kaveri construction pvt ltd',
    'Rutu developers pvt ltd',
    'Gaba projects private limited',
    'Connections sales and services private limited',
    'ISON TECHNOLOGIES PRIVATE LIMITED',
    'Mini muthoottu nidhi kerala limited',
    'Intradechem services',
    'Ambadi enterprises limited',
    'CHOLA INSURANCE DISTRIBUTION SERVICES PRIVATE LIMITED',
    'Aircom infratel and forex private limited',
    'BABUKHAN PROPERTIES PRIVATE LIMITED',
    'D n v chits private limited',
    'Superior investment (india) limited',
    'Garden investment limited',
    'Investeurs consulting private limited',
    'Ezetap mobile solutions private limited',
    'AMRIT FINANCIAL SERVICES PVT LTD,',
    'Fairmoves financial services private limited',
    'Prithviraj infrastructure private limited',
    'Tamilnadu industrial development corporation limited',
    'Shriram credit company limited',
    'Jhaver investments private limited',
    'Chameli investments private limited',
    'Devatha finances private limited',
    'Navraj finance private limited',
    'Nirmal bang financial services private limited',
    'Albeli leasing and finance private limited',
    'Shresth cotton pvt ltd',
    'Shiv niket investment pvt ltd',
    'MALHOTRA DIGITAL SERVICES PRIVATE LIMITED',
    'Sayuj financial advisors private limited',
    'Sree guru finses private limited',
    'Njr finance pvt ltd',
    'S LEISURE PRIVATE LIMITED',
    'Pai vista hotels private limited',
    'Woodgrove resorts private limited',
    'Hardcastle restaurants private limited',
    'Jumboking foods private limited',
    'Shrikanchan hotels and resorts private limited',
    'Ganga hotels limited',
    'Hymavathi hospitalities private limited',
    'A.v.r.n.hotels private limited',
    'R.r hospitality private limited',
    'Albuquerque hotels private limited',
    'Gowani hotel private limited',
    'Charishma hotels private limited',
    'Jaysons transways private limited',
    'Gurukrupa frozen goods carrier private limited',
    'Prasanna transport network private limited',
    'Aditya roadlines private limited',
    'Navio shipping private limited',
    'Triton multimodal (india) private limited',
    'Sun flexitanks private limited',
    'AEROTECH AVIATION SERVICES PRIVATE LIMITED',
    'Gujarat state aviation infrastructure company limited',
    'Business aircraft international private limited',
    'Metco enterprises private limited',
    'Zim world freight private limited',
    'ARSHIYA LOGISTICS SERVICES LIMITED',
    'Gayatri roadlines private limited',
    'Ambitrans logistics private limited',
    'Spark global (scs) services private limited',
    'Teejay network logistics private limited',
    'Wols logistics private limited',
    'Rupal rice mill private limited',
    'CHETNA ORGANIC AGRICULTURE PRODUCER COMPANY LIMITED',
    'Mcn infrastructure private limited',
    'S FINE FOODS PRIVATE LIMITED',
    'Orgo foods private limited',
    'Fresh makers food & beverages private limited',
    'Spr wineries private limited',
    'Denzong breweries private limited',
    'Shroff textiles limited',
    'Anant yarn processing pvt ltd',
    'Vicky fashion limited',
    'Sant textile mills pvt ltd',
    'Acme cotsyn private limited',
    'AZEEN AGRO PRIVATE LIMITED',
    'Ragavendra spinners limited',
    'Arcelor chemicals private limited',
    'Varsha organics private limited',
    'Fruxinfo private limited',
    'Turnkey solutions private limited',
    'Capricot technologies private limited',
    'Plakon consulting private limited',
    'Sm netserv technologies private limited',
    'Exultsoft technologies private limited',
    'Cicada computer private limited',
    'Mcube investments software private limited',
    'M n world enterprise private limited',
    'Cast software india private limited',
    'Nopo nanotechnologies india private limited',
    'Resemble systems india private limited',
    'Stellium consulting india private limited',
    'Moonlander e-commerce private limited',
    'Girmiti software private limited',
    'Datagres it solutions private limited',
    'Abyeti technologies private limited',
    'Prazas learning india private limited',
    'Infortecor solutions private limited',
    'Biz message solutions india private limited',
    'ADVA IT SOLUTIONS PRIVATE LIMITED',
    'Eywa media innovations private limited',
    'Creed technologies private limited',
    'Case consult india pvt ltd',
    'Microsign technologies private limited',
    'Aufait technologies private limited',
    'Ejyothi services private limited',
    'Kings infomatica solutions private limited',
    'Sweans technologies private limited',
    'Sree cadd solutions private limited',
    'E-forum systems private limited',
    'Pan gulf technologies private limited',
    'Ve- comm software private limited',
    'Anamec instruments private limited',
    'Iijt education private limited',
    'Board software (india) private limited',
    'Hot dot technologies private limited',
    'Sphere info solutions private limited',
    'Rajguru solutions private limited',
    'Consulo technologies private limited',
    'Crg solutions private limited',
    'Netcraft technologies private limited',
    'VERO INDIA SOFTWARE PRIVATE LIMITED',
    'WCS INDIA PRIVATE LIMITED',
    'Pas solutions private limited',
    'Maps global research & development private limited',
    'Viscap consultancy services private limited',
    'Datavail infotech private limited',
    'Ditech process solutions private limited',
    'SCOUT INNOVATIONS PRIVATE LIMITED',
    'Savit interactive services private limited',
    'BETTER WORLD TECHNOLOGY PRIVATE LIMITED',
    'Spectron infotech private limited',
    'Clean energy development corporation private limited',
    'Shashwat electricals private limited',
    'Shimera project lighting private limited',
    'VIGHNAHARTA TECHNOLOGIES PRIVATE LIMITED',
    'Secutech systems private limited',
    'Dieq tooling and components private limited',
    'Ameya fluid control systems private limited',
    'Zumbach electronic india private limited',
    'HYTECH MACHINE TOOL & AUTOMATION (INDIA) PRIVATE LIMITED',
    'Futuretech instruments private limited',
    'Systronics india ltd',
    'Fasten cables and accessories private limited',
    'Ipg photonics (india) private limited',
    'KAPS MEDINEEDS PRIVATE LIMITED',
    'Ives healthcare private limited',
    'Orbusneich medical (india) private limited',
    'Sankara software services private limited',
    'Shaili endoscopy private limited',
    'ASTRA BIOSCIENCE Limited',
    'REGENIX BIOSCIENCES LIMITED',
    'Cinerama private limited',
    'Leader autogas (india) private limited',
    'Transport solutions india private limited',
    'SILICON CARS PRIVATE LIMITED',
    'Maxeff engineering p ltd',
    'Osa shipping private limited',
    'Medha ganser fuel systems private limited',
    'Monsoon studio private limited',
    'Asun lighting india private limited',
    'Vitra india private limited',
    'Tanvirkumar diamonds limited',
    'A plus industries private limited',
    'Satyam gifts private limited',
    'Star metal refinery private limited',
    'Regency nirman limited',
    'COURTYARD REAL ESTATE PRIVATE LIMITED',
    'INDOSPACE PARK CHAKAN 1D PRIVATE LIMITED',
    'INDOSPACE PARK CHAKAN 1C PRIVATE LIMITED',
    'INDOSPACE PARK CHAKAN 1B PRIVATE LIMITED',
    'Keemaya developers private limited',
    'Kul urban development private limited',
    'NAHAR EXCALIBUR PROJECT PRIVATE LIMITED',
    'Vrundavan vastu private limited',
    'Vasishta constructions private limited',
    'NAVAYUGA MACHILIPATNAM PORT LIMITED',
    'CVR LIFE SCIENCES PRIVATE LIMITED',
    'Pagadala constructions private limited',
    'Olympia merlin developers private limited',
    'Four corner properties private limited',
    'Aggarwal plaza private limited',
    'North delhi projects private limited',
    'Dhaman khol engineering & construction company private limited',
    'Foster certifications private limited',
    'Omega compliance india private limited',
    'Eptisa india private limited',
    'Leader prospects india private limited',
    'Haskell communications private limited',
    'Job world india private limited',
    'I-admin outsourcing private limited',
    'INDIABULLS RURAL FINANCE PRIVATE LIMITED',
    'Satguru infocorp services private limited',
    'PERTINENT CONSULTANTS PRIVATE LIMITED',
    'Eac - euro asia consulting private limited',
    'NIRVADHYA CAPITAL INDIA PRIVATE LIMITED',
    'Experian services india (private limited)',
    'Finman advisory services private limited',
    'Infovision hr consulting services private limited',
    'KSS E-COMMERCE TECHNOLOGIES PRIVATE LIMITED',
    'REP CONTENT SERVICES PRIVATE LIMITED',
    'Csl surveyors private limited',
    'Kirin advisors private limited',
    'Deloitte tax services india private limited',
    'Kep engineering services private limited',
    'Aakanksha management consultancy & holdings private limited',
    'Datapage (india) private limited',
    'Planarch team architects private limited.',
    'Timing technologies india private limited',
    'Niyamak consultancy private limited',
    'Land-marine equipment services private limited',
    'Business masters private limited',
    'Talwar solutions private limited',
    'Tsp access rental private limited',
    'Bajaao music private limited',
    'DOVE SOFT LIMITED',
    'DICE ACCELERATION AND EDUTECH SERVICES (INDIA) PRIVATE LIMITED',
    'Samper engineering private limited',
    'Infinity freight services private limited',
    'Square mango innovations private limited',
    'Asmacs skill development limited',
    'Trinity techno graphics private limited',
    'Green building technologies private limited',
    'GTT COMMUNICATIONS INDIA PRIVATE LIMITED',
    'Elysium international private limited',
    'Entrepreneur facilitation center and development',
    'Kayser automotive systems india private limited',
    'Kuamin business solutions private limited',
    'Zen elevators private limited',
    'Gateway media private limited',
    'Krishna dredging company private limited',
    'United peb solutions private limited',
    'Innovative photonics india private limited',
    'Iimcalcutta innovation park',
    'Soch development support private limited',
    'FRESHTOHOME FOODS PRIVATE LIMITED',
    'Nissan trading india private limited',
    'Golden falcon impex private limited',
    'Shivang trading company (india) private limited',
    'Alliance super fine industries limited',
    'Horizon tech b2b solutions private limited',
    'Optilink networks private limited',
    'CLARIANT INDIA LIMITED',
    'Heart & arrow diamond private limited',
    'T.v.i. marketing solutions private limited',
    'Blue mount exports pvt ltd.',
    'Devkripa vanijaya pvt ltd',
    'Brilliant tieup private limited',
    'Manorath distributors private limited',
    'Abans finance private limited',
    'NAVARATAN PROPERTY HOLDINGS PRIVATE LIMITED',
    'Rajasthan distilleries private limited',
    'SHREE VENKATESH INTERNATIONAL LIMITED',
    'Blossom grocery & foods india private limited',
    'Asia-perfect multilink private limited.',
    'FAB-5 MERCHANDISE COMPANY PRIVATE LIMITED',
    'White rose trading private limited',
    'Sachar gaming private limited',
    'Nete retail private limited',
    'KYRA PHOTON TECH PRIVATE LIMITED',
    'Caven life sciences private limited',
    'Dr batra s positive health products limited',
    'Klick impex private limited',
    'Centronic components india private limited',
    'Acme mep services (i) private limited',
    'Iycon (india) private limited',
    'VS OMNITRADE INDIA PRIVATE LIMITED',
    'Kriti tools private limited',
    'Sage hotels private limited',
    'Travel club holidays private limited',
    'Vinayagar hotels and resorts private limited',
    'Mgm hospitality india private limited',
    'Parry leisure villas private limited',
    'Shivhira hotels & hospitality private limited',
    'Piyush palace private limited',
    'SUVIDHI CORPORATION LIMITED',
    'Black rain hospitality private limited',
    'Torry harris restaurants private limited',
    'XANDARI RESORTS PRIVATE LIMITED',
    'M-star hotels palakkad private limited',
    'M-star hotels koduvayur private limited',
    'STUDIO BENTEL PRIVATE LIMITED',
    'Kgn hotels and resorts private limited',
    'Ramsukh resorts private limited',
    'Electro hotels private limited',
    'Natvar parikh hotels and resorts private limited',
    'Intrasoft technologies limited',
    'Nile limited',
    'Sejal glass limited',
    'D & h india limited',
    'Silveroak commercials limited',
    'Orbit exports ltd',
    'Future market networks limited',
    'COUNTRY CONDO',
    'S SHARED SERVICES INDIA PRIVATE LIMITED',
    'Invzon consultancy services private limited',
    'KAS DIRECT SOURCING PRIVATE LIMITED',
    'Sharat industries limited',
    'Hindustan unilever limited',
    'Mahaan foods limited',
    'The andhra sugars limited',
    'The grob tea co ltd',
    'PRECOT LIMITED',
    'Rajasthan petro synthetics ltd',
    'The rameshwara jute mills ltd',
    'Hytone texstyles limited',
    'SVP GLOBAL TEXTILES LIMITED',
    'Pact industries limited',
    'Sundaram multi pap limited',
    'India glycols limited',
    'Ganesh benzoplast limited',
    'Rubfila international ltd',
    'Mold-tek technologies limited',
    'Crimson metal engineering company limited',
    'Bhagyanagar india limited',
    'Jocil limited',
    'International diamond services limited',
    'Mobile telecommunications limited',
    'DYNAVISION LIMITED',
    'Gemini communication limited',
    'Iec fabchem limited',
    'Rico auto industries limited',
    'S.b and t international limited',
    'WHITE ORGANIC AGRO LIMITED',
    'Adani power limited',
    'Parsvnath developers limited',
    'B c c fuba india limited',
    'Shoppers stop limited',
    'V.r.woodart limited',
    'Suncity cinemas private limited',
    'Christine valmy institute private limited',
    'Quantum phinance consulting private limited',
    'TASMAI FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Victor tango entertainment private limited',
    'DLL TALWALKARS CLUB PRIVATE LIMITED',
    'AB WINES PRIVATE LIMITED',
    'Saket bio-cultures private limited',
    'Uday tungabhadra agriculture producer company limited',
    'Amar equipments private limited',
    'AUTO MECH (INDIA) PVT. LTD',
    'Gefran india private limited',
    'PETROMECH PIPE FITTINGS AND VALVES PRIVATE LIMITED',
    'VISHAL BEARINGS LIMITED',
    'Finair airconditioning private limited',
    'Swati fire protection private limited',
    'Filman filtrations private limited',
    'Ra medics specialty products private limited',
    'SHAKTIMAN EQUIPMENTS PRIVATE LIMITED',
    'Hindustan dealers limited',
    'KASERA HEAT EXCHANGER PRIVATE LIMITED',
    'Natura ecoenergy private limited',
    'Decimal systems private limited',
    'Aishwarya consolidates private limited',
    'Fire safety devices private limited',
    'Fine automation robotics india private limited',
    'Sk cutting tools solution private limited',
    'Esmech equipment private limited',
    'Jidoka engineers (india) private limited',
    'Aalidhra textool engineers private limited',
    'DOLAR ACADEMY FOR SKILL AND ENTREPRENEURSHIP PRIVATE LIMITED',
    'Bharat beams private limited',
    'EXCELSIOR SOFTWARES PRIVATE LIMITED',
    'Digicom systems (bangalore) private limited',
    'Binary spectrum softech private limited',
    'Thies textile machines india private limited',
    'Ashirvad pharma industries private limited',
    'NILESH TECHNO PLAST (INDIA) PRIVATE LIMITED',
    'Vitaran electronics private limited',
    'White house business solutions private limited',
    'Mukesh infoserve private limited',
    'Kuruvithadam agencies pvt ltd',
    'Shrey infotech private limited',
    'Ayyappa cnc private limited',
    'Fracktal works private limited',
    'Vardhman textile components limited',
    'AUTOMOTIVE END SOLUTION PRIVATE LIMITED',
    'Jacobi machinery private limited',
    'Swelect green energy solutions private limited',
    'TSI POWER PRIVATE LIMITED',
    'Susruta instruments private limited',
    'Cfr electronics kings private limited',
    'Aircon elevators private limited',
    'Power en quest services private limited',
    'Amphenol omniconnect india private limited',
    'Agri power and engineering solutions private limited',
    'SMB SYSTEMS PRIVATE LIMITED',
    'Meridian compu services pvt ltd',
    'Avon maintanence services private limited',
    'Deev gen set private limited',
    'Southern power equipment company private limited',
    'Kamath transformers private limited',
    'Interpump hydraulics india private limited',
    'MICROPACK Private Limited',
    'Ambience lifestyle limited',
    'Roj leather exports private limited',
    'Trans health care india private limited',
    'Power drives enterprises (india) private limited',
    'Chennai auto agency private limited',
    'Khwaja exports pvt ltd',
    'Saibaba apparel exports private limited',
    'Phoneshop technologies (india) private limited',
    'Ecoled illuminations private limited',
    'Maple leaf resorts and hotels private limited',
    'Golden hospitality services private limited',
    'Radha rajalakshmi hotels private limited',
    'Rhw management schools limited',
    'Vatika hotels private limited',
    'Mahima hospitality private limited',
    'Eros grand resorts and hotels private limited',
    'DEVENTURE HOTELS PRIVATE LIMITED',
    'Umak hospitality private limited',
    'CHAITRA HOSPITALITY & DEVELOPMENT SERVICES PRIVATE LIMITED',
    'Krrish shalimar projects private limited',
    'Leading lifestyle solutions private limited',
    'Eben telecom private limited',
    'Pazhoor ideal systems private limited',
    'Hermes india retail and distributors private limited',
    'Maisha hospitality private limited',
    'Glendale holiday homes private limited',
    'Dunes electronics private limited',
    'Ceeyes software technologies private limited',
    'Square dots india private limited',
    'BANSAL MULTIFLEX LIMITED',
    'Manilal patel clearing forwarding (bangalore) private limited',
    'Giraffe foodlinks private limited',
    'Prime goan resorts private limited',
    'Sankamthai hotels private limited',
    'Ivory beach resorts private limited',
    'Shared services international india private limited',
    'Paul resorts & hotels private limited',
    'Rotary hill view resorts private limited',
    'Maestro hotels and resorts private limited',
    'Onora hospitality private limited',
    'Krishna theeram ayur holy beach resorts private limited',
    'Annanthampy hotels and resorts private limited',
    'Skyocean shipping private limited',
    'Transocean shipping ventures private limited',
    'KYAN RESORTS & CLUBS PRIVATE LIMITED',
    'GOLDEN ANCHOR PRIVATE LIMITED',
    'Go airways private limited',
    'Total aviation services private limited',
    'Gateways for india airports private limited',
    'Hm aviation private limited',
    'Heligo charters private limited',
    'Proctor aviation private limited',
    'Sharavan aero technologies private limited',
    'Get together tours private limited',
    'Argus logistics private limited',
    'Brijda roadlines private limited',
    'Medi drips carriers pvt ltd',
    'Ad north east air cargo private limited',
    'Cml express private limited',
    'Silver communication private limited',
    'Kamakshi telecom private limited',
    'Reflex communications private limited',
    'Irdeto technology india private limited',
    'Strapp business solutions private limited',
    'Jalan infosystem private limited',
    'Link well telesystems pvt ltd',
    'Hayat communications private limited',
    'EXTRANET SUPPORTS PRIVATE LIMITED',
    'FIBERSTORY COMMUNICATIONS PRIVATE LIMITED',
    'Ram digi medias private limited',
    'Angel broadcasting network private limited',
    'Millenium mumbai broadcast private limited',
    'Shaha finlease private limited',
    'Dalmia cement (bharat) limited',
    'Andrade holdings private limited',
    'Credit browse (india) private limited',
    'Bse investments limited',
    'Sethi forex private limited',
    'FIVE-STAR BUSINESS FINANCE LIMITED',
    'Nithyakalyani investments private limited',
    'Rado investments private limited',
    'Yogakshemam loans limited',
    'Rich harvest holdings private limited',
    'Sara fund trustee company private limited',
    'Indiaemerging capital private limited',
    'SYNERGY VARIETIES PRIVATE LIMITED',
    'Kats holdings private limited',
    'Indage investments private limited',
    'Midway holdings private limited',
    'Ramchandra rathi finance private limited',
    'Yokoha investment pvt ltd',
    'Rosario investment pvt ltd',
    'Peach blossom investment pvt ltd',
    'Hibiscus investment and finance pvt ltd',
    'Marwari investments pvt ltd',
    'Mittalbhai investment pvt. ltd',
    'Angirasa holding & business syndicate private limited',
    'Anush shares and securities private limited',
    'Long short investments p ltd',
    'A p credit pvt ltd',
    'Agra portfolio private limited',
    'Vijaylaxmi fincap private limited',
    'Mascon financial services private limited',
    'MANIPAL IT SERVICES PRIVATE LIMITED',
    'Eaton capital advisors private limited',
    'Millepede india foundation',
    'Padmakshi capital private limited',
    'ZAGGLE PREPAID OCEAN SERVICES LIMITED',
    'Kripa securities private limited',
    'Bhagwati trading co ltd',
    'PRABHAS AUTOMOTIVE PRIVATE LIMITED',
    'DAFFODIL ENGRAVERS(INDIA) PRIVATE LIMITED',
    'Supertech holdings private limited',
    'Bsbk investments pvt ltd',
    'Supersound electronics india private limited',
    'Bml investments private limited',
    'NDW BAY REALTY PRIVATE LIMITED',
    'Palak logistics private limited',
    'Bullion refiners association',
    'Aura finsolutions private limited',
    'Heads up consulting private limited',
    'Votive management services private limited',
    'Continental immigration consultancy services private limited',
    'Indus best mega food park private limited',
    'Grasshoppers india private limited',
    'Indus franchise & showrooms consultants private limited',
    'Bt data and surveying services india private limited',
    'Ayra management consulting private limited',
    'AUMYAA ADVISORY SERVICES PRIVATE LIMITED',
    'Rudra experiences private limited',
    'Tierra azul sourcing and consulting private limited',
    'APOLLO PRO X LIMITED',
    'VCHOOSE INFOTECH PRIVATE LIMITED',
    'Pioneer infomedia private limited',
    'Globus management services private limited',
    'Prishma consultants pvt ltd',
    'ATIGO ELECTRONICS INDIA PRIVATE LIMITED',
    'Fta hsrp solutions private limited',
    'Ashita business solutions private limited',
    'Eider financial services limited',
    'Ayesa india private limited',
    'Prizmatics analytics private limited',
    'Potential project managers private limited',
    'Delphi research services private limited',
    'Jcss consulting private limited',
    'S.e.e. consulting private limited',
    'Forem consultants private limited',
    'Ascent consulting services private limited',
    'Leisure and lifestyle information services private limited',
    'Infomap consultants private limited',
    'Candor management services private limited',
    'Sea funds management india private limited',
    'Legalforce rapc private limited',
    'Walden india advisors private limited',
    'Groupower engineering private limited',
    'Trident staff solutions private limited',
    'J and s consultancy services private limited',
    'Abutstone project solutions private limited',
    'Scarborough immigration services private limited',
    'Atul desai consultants private limited',
    'UTOMI SYNERGY PRIVATE LIMITED',
    'QUIKR REALTY PRIVATE LIMITED',
    'Gem edible oils private limited',
    'K k s k hides private limited',
    'Sunshine agrovet private limited',
    'Agmatel india private limited',
    'Global calcium private limited',
    'Auto shell perfect moulder limited',
    'Knitvel needles private limited',
    'Sridhar biotech private limited',
    'Geetha kannan spices private limited',
    'JAYANTIKA INVESTMENT & FINANCE LIMITED',
    'Emerald jewel industry india limited',
    'Kalyani hatcheries private limited',
    'K p acqua products private limited',
    'Sonitpur agro industries pvt ltd',
    'M. s. farms private limited',
    'Lngse exports private limited',
    'S and t welcare equipments private limited',
    'Kikani exports private limited',
    'Manav tea company private limited',
    'Gra india private limited',
    'SHRIKANT AGROTECH INDUSTRIES LIMITED',
    'Jagadale agro farm private limited',
    'Sound of music (india) private limited',
    'BINDAL ENERGY PRIVATE LIMITED',
    'Springway mining private limited',
    'Peridot power ventures limited',
    'Jsw natural resources bengal limited',
    'Swaymbhu natural resources private limited',
    'NEWS SOURCE MEDIA PRIVATE LIMITED',
    'Ecostar energy and agrofarms private limited',
    'Goa state horticultural corporation limited',
    'Greenport corporation private limited',
    'ODISSI EXPORTS PRIVATE LIMITED',
    'Hitech computer and systems private limited',
    'Mir estates private limited',
    'NANDI SEEDS PRIVATE LIMITED',
    'Poabs enterprises private limited',
    'Ashapura international limited',
    'Navayuga minerals limited',
    'Balrampur agro industries private limited',
    'Jsw natural resources india limited',
    'FLASH RESOURCES PRIVATE LIMITED',
    'Flower valley agro-tech private limited',
    'Kmv agrolands private limited',
    'Neptune fairdeal products private limited',
    'Sangshri electricalss private limited',
    'Hazloc equipments private limited',
    'Accuramech industrial engineering private limited',
    'Penny wise films private limited',
    'Servo polytech coimbatore private limited',
    'Tridev auto parts private limited',
    'Interplex electronics india private limited',
    'Murata electronics (india) private limited',
    'Phi audiocom systems private limited',
    'Preventive care technologies private limited',
    'Dai manufacturing private limited',
    'Future prime energy private limited',
    'Telelec heating equipment private limited.',
    'Raymazda medical systems private limited',
    'Lucere lighting solution private limited',
    'Advent electric technologies private limited',
    'Ndt technologies private limited',
    'ADVANCED & BEST ELECTRICALS & ENGINEERS PRIVATE LIMITED',
    'Pentas engineering projects private limited',
    'SATHYA SOLUTIONS PRIVATE LIMITED',
    'Suntera energy services (india) private limited',
    'Vth source components private limited',
    'Espee dynamed equipments private limited',
    'Toshbro controls private limited',
    'Span biotronics private limited',
    'Accurate engineering company private limited',
    'Versatile equipments pvt ltd',
    'Hydroline products private limited',
    'Precimeasure controls private limited',
    'CAPCO WATER SOLUTIONS PRIVATE LIMITED',
    'ALAINA HEALTHCARE PRIVATE LIMITED',
    'Yelantra power solutions private limited',
    'Kepo itp electronics private limited',
    'Power onicks limited',
    'Shogini technoarts pvt ltd',
    'Sangeet audio india private limited',
    'Saral communications private limited',
    'Kktc autotech (india) limited',
    'Ostern pvt ltd',
    'Skyway motors private limited',
    'Wooshin safety systems india private limited',
    'Venkatesh agencies private limited',
    'ALLIED NIPPON PRIVATE LIMITED',
    'Rockman auto private limited',
    'Skylark fiscal services pvt ltd',
    'Ayesha sanitary private limited',
    'Amv inns private limited',
    'Kshetra green beach resorts and hotels private limited',
    'Vihar resorts and hotels (india) pvt ltd',
    'White water park india private limited',
    'Sumit resorts and farms private limited',
    'RAMEE HOTEL MANAGEMENT SERVICES PRIVATE LIMITED',
    'Muthoot agri development and hospitalities private limited',
    'LSL HOLDINGS PRIVATE LIMITED',
    'UNIVERSAL HOTELS & RESORTS PRIVATE LIMITED',
    'Ishaan clubs & hotels private limited',
    'Tacos restaurants private limited',
    'Humble hospitality private limited',
    'Humble hospitality (delhi) private limited',
    'Humble hospitality (punjab) private limited',
    'Humble hospitality (jalandhar) private limited',
    'Sentosa resorts private limited',
    'Simrut foods & hospitality private limited',
    'Momentum hotels private limited',
    'Maya lakecity resorts private limited',
    'Indian traditional hotels private limited',
    'Shine star hospitality private limited',
    'Mdk hotel enterprises pvt ltd',
    'Bhagyanagar hotels pvt ltd',
    'Annapoorna residency private limited',
    'Skyla hospitality private limited',
    'Butta convention services private limited',
    'Gem holiday resorts limited.',
    'Vgp golden resorts international limited',
    'Bay resorts limited',
    'Royal park hotels (india) private limited',
    'Royal valley hotel private limited',
    'M three budget hotels private limited',
    'Subhmangal tracom private limited',
    'Sai chakra hotels private limited',
    'Green nature trail resorts private limited',
    'LYX HOSPITALITY PRIVATE LIMITED',
    'Great indian craftsman hospitality private limited',
    'Dennisink villas private limited',
    'Goandream hospitality private limited',
    'Mashobra resort limited',
    'Jeco vyapaar private limited',
    'Libra highways private limited',
    'Shree mahavir secure logistics private limited',
    'Hidalgo logistics private limited',
    'Shree sai transport (sst india) private limited',
    'Sr logistics india private limited',
    'Abt industries limited',
    'Raigarh champa rail infrastructure private limited',
    'ASM SHIPPING PRIVATE LIMITED',
    'Curamus shipping p ltd',
    'NAVCHART SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'Lobaan softwares private limited',
    'ICHRCLOUD MEDICAL PRIVATE LIMITED',
    'EUV BUSINESS SERVICES PRIVATE LIMITED',
    'Terminus circuits private limited',
    'Cymetrix software private limited',
    'Saggraha management services private limited',
    'X-biz techventures private limited',
    'Data ratings intelligence private limited',
    'Sivani pumps and systems private limited',
    'Viratech software solution private limited',
    'Developtech it solution private limited',
    'Nicom international private limited',
    'Panalink infotech limited',
    'Cpa global support services india private limited',
    'Hanu software solutions (india) private limited',
    'Studio netsouls private limited',
    'Transtek infoways private limited',
    'Rishi technovision private limited',
    'Dynavision digitech private limited',
    'Saviour infosystem private limited',
    'KNOWALL SERVICES PRIVATE LIMITED',
    'Actian technology private limited',
    'Vivan chanakya pro soft solutions private limited',
    'Aagam digisys private limited',
    'Hope technologies private limited',
    'Balaji softwares solutions private limited',
    'GO APPYCODES SOLUTIONS PRIVATE LIMITED',
    'Sparktech systems private limited',
    'FARENEXUS SOLUTIONS PRIVATE LIMITED',
    'Turningpoint software solutions private limited',
    'ALGONOMY SOFTWARE PRIVATE LIMITED',
    'Infovision edutainment private limited',
    'Aeren it solutions private limited',
    'Sedin technologies private limited',
    'Optessa solutions private limited',
    'Volotek softwares private limited',
    'Findstone internet private limited.',
    'Gis app consultancy services private limited',
    'Five splash infotech private limited',
    'Flipper code private limited',
    'Datacomp web technologies (india) private limited',
    'Dbcommit technologies private limited',
    'Mascot see (india) private limited',
    'PREMIUM CUSTOMER IT SERVICES LIMITED',
    'Atechnocrat web solutions private limited',
    'Intellicube market research solutions private limited',
    'Vconnect cloud services private limited',
    'Cd byte info private limited',
    'Arithma technologies india private limited',
    'Move offshore call centre private limited',
    'Kcube consultancy services private limited',
    'Cj tech private limited',
    'Verito services private limited',
    '4s technologies private limited',
    'Idoc infosolutions private limited',
    'Guindy engineering solutions india private limited',
    'Wayzon infotech private limited',
    'Malachite business support services private limited',
    'Jcss crestlaw private limited',
    'PRIMAT INFRAPOWER & MULTIVENTURES PRIVATE LIMITED',
    'GULBRANDSEN CATALYSTS PRIVATE LIMITED',
    'GALAXY SQUARE PRIVATE LIMITED',
    'Shakti insulated wires private limited',
    'Poona young cricketers gymkhana & sports foundation',
    'Wellnest india projects private limited',
    'Drum events (india) private limited',
    'HERTZ CHEMICALS Private Limited',
    'U s recreations private limited',
    'Itpa commercial information services private limited',
    'VGP UNIVERSAL BROADCAST PRIVATE LIMITED',
    'Winchell freight forwarders private limited',
    'Indian boilers manufacturers association.',
    'Tetra engineers private limited',
    'Micro housing finance limited',
    'Mrr charities',
    'SAROJ AD CREATORS PRIVATE LIMITED',
    'M.k. exim (india) limited',
    'Adani ports and special economic zone limited',
    'Arihant finance (india) limited',
    'Mansi finance (chennai) limited',
    'Kovalam investment and trading company limited',
    'Bhagyashree leasing and finance limited',
    'Industrial and prudential investment company limited',
    'Ludlow jute & specialities limited',
    'Cil securities limited',
    'Mapro industries limited',
    'D b realty limited',
    'Eclerx services limited',
    'Mindvision capital limited',
    'Frontline securities limited',
    'Mohindra fasteners limited',
    'Shilpa medicare limited',
    'Sunil industries limited',
    'Punch ratna steels private limited',
    'Step manpower private limited',
    'Gujarat minorities finance and development corporation limited',
    'Dexler foundation',
    'Manoharlal santram transport private limited.',
    'Excel hr facilitations and services private limited',
    'Wings corporate services private limited.',
    'Conwood agencies private limited',
    'Wake up confectioners pvt ltd',
    'Bimexma technologies (india) private limited',
    'Impulse advertising pvt ltd',
    'Sankat mochan exports private limited',
    'Gulmohar resorts private limited',
    'FINETECH FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Maplle infraprojects limited',
    'Polyplex corporation limited',
    'The ramco cements limited',
    'Rain industries limited',
    'Nebco textile industries private limited',
    'We engineers structural consultants private limited',
    'SARITA FORGINGS LIMITED',
    'MIL STEEL AND POWER PRIVATE LIMITED',
    'Sahyog engineering private limited',
    'Gajra differential gears limited',
    'Belcon engineers private limited',
    'Swastid engineering private limited',
    'Focus robotomation private limited',
    'Mashiba elevators india private limited',
    'Vulcan cold form private limited',
    'Conpen engineering india private limited',
    'A.s. controls private limited',
    'Teknirvana tradelink private limited',
    'Sankei pragati india private limited',
    'Aeon ecotech private limited',
    'Lycos technologies private limited',
    'Salvagnini machinery india private limited',
    'VIHANTA SMART POWER TECHNOLOGIES PRIVATE LIMITED',
    'Global graphics machineries private limited',
    'Venus precision engineering (india) private limited',
    'Valiant automations private limited',
    'Tr formac fastenings private limited',
    'Perfect weighing system private limited',
    'Enercon asia pacific systems private limited',
    'Lvh construction solutions private limited',
    'Sri bhavana fabtech private limited',
    'Almac laser private limited',
    'Sea horse technical services international private limited',
    'Lloyds engineering corporation private limited',
    'Wilworth techsol private limited',
    'Swastid auto products private limited',
    'Seftech india private limited',
    'Woodstock laminates limited',
    'Kishore vadilal pvt ltd',
    'Fitch metals engineering india private limited',
    'GEE PEE AEROSPACE AND DEFENCE PRIVATE LIMITED',
    'Super engineers (india) private limited',
    'Smart-n-green control technologies private limited',
    'Sanko shoji india private limited',
    'FESTO INDIA PRIVATE LIMITED',
    'Tsujikawa india private limited',
    'Amigo dispensing solutions private limited',
    'Filtration technik india private limited',
    'TN INDIA PRIVATE LIMITED',
    'Spectrum weighpack private limited',
    'Rama spares manufacturing pvt ltd',
    'PLUS ORTHOPAEDICS INDIA PRIVATE LIMITED',
    'Perfect chloro systems private limited',
    'K.r. lynch surgical and medical private limited',
    'Jumps auto industries limited',
    'Gamani engineering private limited',
    'KARANJ ENVIROCARE PRIVATE LIMITED',
    'Nirmal multitrade private limited',
    'R B B R EXPORTS PRIVATE LIMITED',
    'SOFTDEAL PHARMACEUTICAL PRIVATE LIMITED',
    'Faststone mercantile company private limited',
    'Faiz exports private limited',
    'Western arya trading india private limited',
    'Artorius trading private limited',
    'Tbk tile home private limited',
    'Appan dukan marketing and services private limited',
    'Frc composites india ltd',
    'Simco materials international private limited',
    'Trigon marketing private limited',
    'Vertigo impex private limited',
    'Netcom impo expo private limited',
    'Total home solutions private limited',
    'NOMISTAR RESOURCES PRIVATE LIMITED',
    'Zap exports private limited',
    'Zion distrubution private limited',
    'Alva brothers entertainment private limited',
    'Viga trade solutions private limited',
    'Intec export (india) private limited',
    'Nestlinks impex private limited',
    'CURIZA LIFESCIENCES PRIVATE LIMITED',
    'Aldabra india private limited',
    'Ougi trading private limited',
    'SAARBULK FOODS PRIVATE LIMITED',
    'Quantrix solutions private limited',
    'Opple lighting india private limited',
    'Ind natural hair private limited',
    'Purni ad infrastructure private limited',
    'Kevin process technologies private limited',
    'Corona trading and exports private limited',
    'Khimji ramdas india private limited',
    'Affil green overseas private limited',
    'Tamron india private limited',
    'Techno tronics private limited',
    'Kaycee rubbers private limited',
    'Abe value point systems private limited',
    'Excelpoint systems (india) private limited',
    'SUTRAH BUILDWARE PRIVATE LIMITED',
    'Sangeetha mobiles private limited',
    'YNDE TEX PRIVATE LIMITED',
    'Cochin exports p ltd',
    'Sunu trading india private limited',
    'Daulatabad fort trading company limited',
    'Shri hith raghav enterprises private limited',
    'Jaipur earth developers private limited',
    'Anandam real estate private limited',
    'Sharvani buildcon private limited',
    'Infinity infrabuild limited',
    'Ariisto housing development private limited',
    'Ariisto housing infrastructure private limited',
    'Worthwhile properties private limited',
    'Logical properties private limited',
    'GODREJ PROJECTS DEVELOPMENT LIMITED',
    'CESTRUM INVESTMENT BROKER PRIVATE LIMITED',
    'Infinity realbuild private limited',
    'Absolute realty and financial services private limited',
    'Dhairya homes private limited',
    'Jadi real estates private limited',
    'Gunjan developers private limited',
    'Achalare realtors private limited',
    'Good life builders and developers private limited',
    'Ambica chennakesava projects limited',
    'Dyuti infrastructure private limited',
    'Unique pioneer homes private limited',
    'Mcn real estate private limited',
    'Avani premises private limited',
    'Arkay enclave pvt ltd',
    'Bina tube private limited',
    'Shailesh enclave private limited',
    'Jkc estates & investments(uf) private limited',
    'Triple a developers private limited',
    'Kadambagiri estates pvt ltd',
    'Investa venture private limited',
    'Roxx developers private limited',
    'Sanjog infracon private limited',
    'Apoorva towers private limited',
    'Bolgati enterprises private limited',
    'ALL TIMES BUILDERS & IMPEX PRIVATE LIMITED',
    'Calicut apollo builders private limited',
    'Sunway realtech private limited',
    'Atria mall management limited',
    'First class infrabuild private limited',
    'H.v. builders private limited',
    'A2B FOOTBALL PRIVATE LIMITED',
    'PUROHIT LUXURY HOMES PRIVATE LIMITED',
    'Rajkaran real estate private limited',
    'REGNANT MALL AND OFFICES PRIVATE LIMITED',
    'SKS ASSET RECONSTRUCTION PRIVATE LIMITED',
    'Eduplex solutions private limited',
    'Manpowergroup services india private limited',
    'Aov securities and management services private limited',
    'Ascent staffing solutions private limited',
    'Peopleedge business solutions private limited',
    'Innovision integrated solutions private limited',
    'Um ventures private limited',
    'Extint glasstech private limited',
    'Populus management services private limited',
    'Hunt jobs private limited',
    'Overflow vinimay private limited',
    'Startree traders private limited',
    'Sparx innovative marketing private limited',
    'Shanker agencies private limited',
    'Sanpellegrino cosmetics private limited',
    'Ronin exports private limited',
    'Frontier raas exports private limited',
    'Intreden exim private limited',
    'APARNA AGENCY Private Limited',
    'Avtar distributors private limited',
    'Synergy industrial services pvt ltd',
    'Pana-arc international private limited',
    'TANVI VENTURES INDIA PRIVATE LIMITED',
    'Ganeshaya vyapaar private limited',
    'IFGL REFRACTORIES LIMITED',
    'Dream barter private limited',
    'Marina barter private limited',
    'Ktr couplings (india) private limited',
    'R D HUNDIA TILES PRIVATE LIMITED',
    'Simfra frozen foods private limited',
    'Mayur sales private limited',
    'Godavari commodities ltd',
    'Stuti tie-up pvt ltd',
    'CREATIVE TRADE & EXPORT PVT LTD',
    'Madhulika dealcomm pvt. ltd.',
    'Faizal traders private limited',
    'Sunshine vinimay private limited',
    'Suraj vinimoy private limited',
    'Susheel jewellery mart private limited',
    'Masa traders private limited',
    'G & B FOOT CORP PRIVATE LIMITED',
    'Shree sanyogita sales pvt ltd',
    'Seasons international private limited',
    'NINETY ONE DEGREE LIFESTYLE AND INTERIORS PRIVATE LIMITED',
    'THE DOABA INDUSTRIAL & TRADING COMPANY PRIVATE LIMITED',
    'Prisource global private limited',
    'Od communications private limited',
    'MLB MEDICARE PRIVATE LIMITED',
    'Futuresoft (india) private limited',
    'Arken solutions private limited',
    'Florals touche (india) private limited',
    'Max life insurance company limited',
    'Suri profiles private limited',
    'Malani overseas private limited',
    'Nine software solutions private limited',
    'Sgi studio galli ingegneria india private limited',
    'NEBO BUSINESS SOLUTIONS & CONSULTANTS INDIA PRIVATE LIMITED',
    'Daford acoustics private limited',
    'Abm infocom private limited',
    'Vr servicon engineers private limited',
    'Smart data processing services pvt. ltd.',
    'Innotek industries private limited',
    'P s composites private limited',
    'Asg trading private limited',
    'AYB SERVICES PRIVATE LIMITED',
    'Aramuc scientific communication private limited',
    'Ritvik fincon private limited',
    'Utkal coal limited',
    'Avon containners private limited',
    'Smpp private limited',
    'VYOM PRODUCTIONS INDIA PRIVATE LIMITED',
    'Wesderby india private limited',
    'Jai santosh plywood and veneer co limited',
    'Aubergine holdings private limited',
    'Hari & sridhar jewellers private limited',
    'Hari darshan sevashram private limited',
    'Mobility solutions limited',
    'Securitrans india private limited',
    'Neptune ducati energy control private limited.',
    'Klim art private limited',
    'Avn realtors private limited',
    'Brigade tracom and exim private limited',
    'Unique aviation services private limited',
    'Centurion power cables private limited',
    'Sangat money-exchange private limited',
    'S s r impex private limited',
    'Metro buildcon private limited',
    'Dew solutions private limited',
    'J s b cargo movers private limited',
    'Marwar trucking private limited',
    'Porosil insulations private limited',
    'Raaj autotech private limited',
    'Autosmart agencies private limited',
    'Millennium plaza limited',
    'Dprj auto services private limited',
    'PADMINI VNA MECHATRONICS LIMITED',
    'Race automotive private limited',
    'VICTORA INDUSTRIES PRIVATE LIMITED',
    'MINDA VAST ACCESS SYSTEMS PRIVATE LIMITED',
    'Indo autotech ltd.',
    'HITACHI ASTEMO HARYANA PRIVATE LIMITED',
    'Trikaya autotech private limited',
    'Bharat automotive pressings (india) private limited',
    'Moonlight auto private limited',
    'Anv industries limited',
    'Bombay bonded stores suppliers association',
    'UNO MINDA KYORAKU LIMITED',
    'Mangal powertech private limited',
    'Qrg enterprises limited.',
    'Megha electronics private limited',
    'Get minerals and coal private limited',
    'Allwyn bikes private limited',
    'Appu exim private limited',
    'Citizen auto components private limited',
    'Jcbl infra equipments private limited',
    'Sanden vikas precision parts private limited',
    'Imperial silicon private limited',
    'Engser ltd.',
    'Sukumal power technology private limited',
    'KANTVA SHEETAL MODULAIRE PRIVATE LIMITED',
    'Grace retail private limited',
    'Medilink enterprises private limited',
    'Em-sos medical private limited',
    'Lalithaa jewellery mart private limited',
    'PRINCE GOLD AND DIAMONDS INDIA PRIVATE LIMITED',
    'M.p. jewellers & co.(1945) private limited',
    'Urban living furniture private limited',
    'Sevoke motors private limited',
    'Techno electromech private limited',
    'Static control systems pvt ltd',
    'Bla etech private limited',
    'Heating elements private limited',
    'Payal electronics pvt ltd',
    'Laxmi jewellery export private limited',
    'Medha energy private limited',
    'V.v. renewable energy private limited',
    'Toucan real estates private limited',
    'Akarsha prime project private limited',
    'Creo developers private limited',
    'Dealwel estates pvt ltd',
    'Rich realtors private limited',
    'Vihaan agriestates private limited',
    'Satya townships private limited',
    'Kumarapalayam tollways limited',
    'Ajm infratech private limited',
    'Sdl townships private limited',
    'Bhopal sanchi highways private limited',
    'Santati agriestates private limited',
    'P s sristi private limited',
    'Godrej holdings private limited',
    'Dhaliwal cold storage private limited',
    'O.s.leasing ltd',
    'Wagar royal business private limited',
    'Wellworth project developers pvt ltd',
    'Ish buildcon private limited.',
    'GOLDMINE DEVELOPERS LIMITED',
    'Gajraj buildwell private limited',
    'Essen finance and investments limited',
    'Exotica housing and projects private limited',
    'Ats nirman private limited',
    'Forest buildcon private limited',
    'Marvellous realhomes private limited',
    'Optimum realtech private limited',
    'Pentagon premises private limited',
    'Binni realtors private limited',
    'Shiva estates pvt. ltd.',
    'Golden home developers pvt ltd.',
    'Salarpuria developers pvt. ltd.',
    'P s facilities maintanance private limited',
    'Etree project consultants private limited',
    'Realgold properties pvt ltd',
    'Angels housing complex pvt ltd',
    'Pioneer land & building developers pvt ltd',
    'Diamond city south residents association',
    'Durga realcon private limited',
    'Decorative conclave private limited',
    'Neel kamal art effects private limited',
    'Blue orchid mansion private limited',
    'Bhagwati awas private limited',
    'Everstrong properties private limited',
    'Jil information technology limited',
    'INDIA HOLIDAY MALL.COM PRIVATE LIMITED',
    'Hema connoisseur collections private limited',
    'CT SOFTWARE SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Ml outsourcing services private limited',
    'Woodside infotech private limited',
    'Advant i.t.park private limited',
    'RONRD INFOCOM LIMITED',
    'Janhavi information technology private limited',
    'Maxonic india private limited',
    'Preet networks private limited',
    'Integral fusion e-services private limited',
    'Tango software solutions private limited',
    'Four squares foundation private limited',
    'Baid land investment pvt ltd.',
    'Lsa software private limited',
    'Incaendo technologies private limited',
    'Credwyn holdings (india)pvt ltd',
    'Nis hardware private limited',
    'Skyscraper space private limited',
    'Tax tech india private limited',
    'Serco india private limited',
    'Skyscraper griha niwas private limited',
    'Skyscraper manor private limited',
    'Feathertouch solutions private limited',
    'Ars traffic and transport technology (india) private limited',
    'Zafin software centre of excellence private limited',
    'Olivo software company private limited',
    'Maaks penta business solutions private limited',
    'Apex innovations private limited',
    'Kp corporate solutions limited',
    'Skyscraper enclave private limited',
    'Mj grain products private limited',
    'MOREISH FOODS LIMITED',
    'Modakpriya food private limited',
    'Globeground india private limited',
    'Tamilnadu sugar corporation limited',
    'PARRY SUGARS REFINERY INDIA PRIVATE LIMITED',
    'Ultimate industries limited',
    'Rudra manufacturing private limited',
    'Tarun realtors private limited',
    'Gpsk commodities private limited',
    'Peak chemical industries ltd',
    'Suklai tea company private limited',
    'GRANDELVE MINES & MINERALS PRIVATE LIMITED',
    'Mn impex private limited',
    'Zea maize private limited',
    'Panna agro pvt ltd',
    'Laxmi syntex private limited',
    'Vishwakarma shilp karyalay private limited',
    'Sumit su apparel private limited.',
    'No exit clothing private limited',
    'Janak sons knitwear private limited',
    'Atul global private limited',
    'Volcano marbles and minerals private limited',
    'Wonder marmostones private limited',
    'Wonder minerals private limited',
    'Best apparels private limited',
    'Gawri suitings limited',
    'MARINE NAVAIDS AND SOLAR AUTO PRIVATE LIMITED',
    'Passion nine fabs private limited',
    'Danfield bobbin limited',
    'Nrr tradecom private limited',
    'Natraj craftex priate limited',
    'Ishita knitfab private limited',
    'Ytc fabrics private limited',
    'Seven colours exim private limited',
    'Pvr lace trading private limited',
    'Drish leathers pvt ltd',
    'Mapletree leather goods private limited',
    'Sho bags india private limited',
    'Tecnova global consulting limited.',
    'Veekesy footgear private limited',
    'ERBIR VENTURES PRIVATE LIMITED',
    'Pride fabrics private limited',
    'Kudu knit process private limited',
    'Lawreshwar footcare private limited',
    'Island wood works private limited',
    'A.s. wood impex private limited',
    'Natural wood and veneers pvt ltd',
    'Bison india limited',
    'Rama panels private limited',
    'Maheshwari datamatics pvt ltd.',
    'D d chopra & co pvt ltd',
    'VIJAY ANAND SPECIALITY PAPERS PRIVATE LIMITED',
    'Carlton coats private limited',
    'M c bothra & company pvt ltd',
    'Super packaging ltd',
    'MANIPAL EFFICIENT MANAGEMENT SERVICES PRIVATE LIMITED',
    'Namo packaging solutions private limited',
    'Delux industries private limited',
    'Rajgarhia paper mills pvt ltd',
    'Zenith energy services private limited',
    'Sri vijayadurga security services private limited',
    'Quality network private limited',
    'Pvti carbon black private limited',
    'Exoellers management services private limited',
    'Seoil chemical india private limited',
    'Pranera services and solutions private limited',
    'Threedots consultancy private limited',
    'Fidus achates engineering private limited',
    'Process system engineers (india) private limited',
    'Peripheral engineers private limited',
    'Parsons brinckerhoff india private limited',
    'Egis india consulting engineers private limited',
    'S d interiors private limited',
    'Ceiltec projects private limited',
    'Kaushal interiors private limited',
    'Shubham architects private limited',
    'J h patel power project private limited',
    'Caden surveys private limited',
    'Margi industrial services pvt ltd',
    'Raut uni-tech private limited',
    'Fivebros forgings private limited',
    'Fab-india technologies private limited',
    'Cannon design international private limited',
    'Industrial product services private limited',
    'GROMA INFRASTRUCTURE LIMITED',
    'PL WORLDWAYS PRIVATE LIMITED',
    'Euro architectural concepts private limited',
    'I r technology services private limited',
    'Advent productions private limited',
    'Silent valley promotions private limited',
    'Cactus creatives private limited',
    'Dr amin controllers & surveyors private limited',
    'Ventures advertising private limited',
    'HAVAS LIFE SORENTO PRIVATE LIMITED',
    'Havas media india private limited',
    'Marching ants advertising private limited',
    'Cartesian consulting private limited',
    'Adview communications private limited',
    'Aura integrated solutions private limited',
    'Bantam enterprises private limited',
    'Mohan exports (india) private limited',
    'Motherson auto limited',
    'RIGHT HUMAN NUTRITION PRIVATE LIMITED',
    'BECK AND KOLL LABORATORIES PRIVATE LIMITED',
    'Concept laboratories pvt ltd',
    'Kremoint pharma private limited',
    'SAPAT GLOBAL HEALTH PRIVATE LIMITED',
    'MEDICHECK INFO PRIVATE LIMITED',
    'Zuvius lifesciences private limited',
    'Panchamved pharma lab private limited',
    'Brussels laboratories pvt ltd',
    'COMED BIO-TECH PRIVATE LIMITED',
    'Sang-froid chemical private limited',
    'Zoetic healthcare private limited',
    'Softech pharma private limited',
    'Prakruti medicines private limited',
    'Civentichem (india) private limited',
    'CONNEX PHARMA PRIVATE LIMITED',
    'Blue phosphate limited',
    'PAR ACTIVE TECHNOLOGIES PRIVATE LIMITED',
    'GARUDA MINERALIA PRIVATE LIMITED',
    'Coris chemicals and pharmaceuticals private limited',
    'Vishal print trader private limited',
    'Trigon antioxidants private limited',
    'Gland pharma ltd',
    'Lividus pharmaceuticals private limited',
    'Zenith chemical works private limited',
    'Concept pharmaceuticals limited',
    'Satwik drugs limited',
    'Clestra life sciences private limited',
    'Pharmaveda (india) private limited',
    'Melody healthcare private limited',
    'Plasma labs private limited',
    'Lissome cosmetics private limited',
    'Insignia cosmetics private limited',
    'Caress beauty care products private limited',
    'Medico media communications private limited',
    'Modern matches private limited',
    'Pavlo fire engineers pvt ltd',
    'Ranemarg flavours & fragrances private limited',
    'Pioneer asia industries private limited',
    'Jc lifecare private limited',
    'Biorow life sciences limited',
    'Fertinova india private limited',
    'NIVAARA CHEMICALS PRIVATE LIMITED',
    'UNIGEN LIFE SCIENCES PRIVATE LIMITED',
    'Chemsynth laboratories private limited',
    'HW HEARING SOLUTIONS PRIVATE LIMITED',
    'BNRG EDIBLE AGRO PRODUCTS PRIVATE LIMITED',
    'ACTOVIS STARTEL VISION PRIVATE LIMITED',
    'TRENDEST TEXKEYS PRIVATE LIMITED',
    'UNIVFOS UPSKILL INDIA PRIVATE LIMITED',
    'NIMANA FASHIONS PRIVATE LIMITED',
    'ALL INDIA WALL PAPER COVERINGS ASSOCIATION',
    'SNEIJDER CONNECT PRIVATE LIMITED',
    'ALLECRA HEALTHCARE PRIVATE LIMITED',
    'CONCLAVE EXHIBITIONS AND TRADE FAIRS PRIVATE LIMITED',
    'SREEMEDHAS SOFTWARE TECHNOLOGIES PRIVATELIMITED',
    'QUARUS SOLTECH PRIVATE LIMITED',
    'NUKKAD SHOPS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'IOV REGISTERED VALUERS FOUNDATION',
    'APITORIA PHARMA PRIVATE LIMITED',
    'KSH AUTOMOTIVE PRIVATE LIMITED',
    'VEDPRO TECHNOSYS PRIVATE LIMITED',
    'AFRIEL MONITORING SYSTEM INDIA PRIVATE LIMITED',
    'ATREYI FINANCIAL SERVICES PRIVATE LIMITED',
    'CELLCURE MEDICARE PRIVATE LIMITED',
    'VOLTERRA INDIA PRIVATE LIMITED',
    'OCTILLION POWER SYSTEMS INDIA PRIVATE LIMITED',
    'ISHRIKA ENERGY PRIVATE LIMITED',
    'HARRIER SECURITY SERVICES PRIVATE LIMITED',
    'TOOT MNE TECH PRIVATE LIMITED',
    'BENMORE DATA SERVICES PRIVATE LIMITED',
    'STERLITE INTERLINKS LIMITED',
    'CLERK COMMUNICATIONS PRIVATE LIMITED',
    'KNOSTIC TECHNOLOGIES PRIVATE LIMITED',
    'BLUEESTONE WEALTH MATTERS PRIVATE LIMITED',
    'NODAL (INDIA) CONSTRUCTIONS PRIVATE LIMITED',
    'AZENT OVERSEAS EDUCATION PRIVATE LIMITED',
    'APG LIFESTYLE HOMES PRIVATE LIMITED',
    'SHEJAWADKAR HOUSING AND INFRA PRIVATE LIMITED',
    'SAYNE TEXTILE PARK PRIVATE LIMITED',
    'SCHNEIDER ELECTRIC SOLAR INDIA PRIVATE LIMITED',
    'THIQA ENGINEERING AND CONSULTANCY PRIVATE LIMITED',
    'KARO SRISEVA TRADE PRIVATE LIMITED',
    'VIVAVED PRIVATE LIMITED',
    'WINDROSE TOURS (OPC) PRIVATE LIMITED',
    'VTHINK GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'MEMITECH WASTE MANAGEMENT PRIVATE LIMITED',
    'NEXT CLOUDWAVE SOLUTIONS PRIVATE LIMITED',
    'TWELFTH TIER PROPERTY LIMITED',
    'MP HOLIDAYS PRIVATE LIMITED',
    'EMBASSY REALTY VENTURES PRIVATE LIMITED',
    'ESP PORT SOLUTIONS PRIVATE LIMITED',
    'AMARDEEP SHIPPING PRIVATE LIMITED',
    'VRAJMANGAL LIQUID MOVERS AND TRADERS PRIVATE LIMITED',
    'SRI SAPTHAGIRI SRINIVASA HOSPITALITY PRIVATE LIMITED',
    'ZUIVER BUILDCON PRIVATE LIMITED',
    'ASSOCIATION OF HANDICRAFTS ENTREPRENEURSARTISANS AND DEALERS',
    'TIFORP INTERNATIONAL TRAVEL AND TOURS PRIVATE LIMITED',
    'A.S DRIVEZY RENTALS PRIVATE LIMITED',
    'ENVIROSPACE REALTY PRIVATE LIMITED',
    'UTX TRAVELS PRIVATE LIMITED',
    'ALTAMOUNT ESTATES PRIVATE LIMITED',
    'ACHOLE DEVELOPERS PRIVATE LIMITED',
    'GAMS FREEWHEELS PRIVATE LIMITED',
    'REDWOOD RENTAL PRIVATE LIMITED',
    'AGC SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'KOVIKA CHIT FUND PRIVATE LIMITED',
    'MONEYBOXX CAPITAL PRIVATE LIMITED',
    'INSTAPRIDE FINANCE PRIVATE LIMITED',
    'DIVERGENT RESEARCH AND CONSULTING PRIVATE LIMITED',
    '1STROKE FINANCIAL SERVICES PRIVATE LIMITED',
    'ORANGE FINCAP PRIVATE LIMITED',
    'JODGE INFRA (INDIA) PRIVATE LIMITED',
    'ASG BUILDTECH PRIVATE LIMITED',
    'REALMARK DEVELOPERS PRIVATE LIMITED',
    'ASTEN MATHER DEVELOPERS PRIVATE LIMITED',
    'DOIT REAL ASSETS (INDIA) PRIVATE LIMITED',
    'ARITRAA REAL ESTATE DEVELOPMENT AND MANAGEMENT PRIVATE LIMITED',
    'KONTOR SPACE LIMITED',
    'PANGLOBE SHIPPING SERVICES PRIVATE LIMITED',
    'SURASUNDARI CONSULTING PRIVATE LIMITED',
    'BLUPLANET TOURS & EVENTS PRIVATE LIMITED',
    'AROCELL TELECOMMUNICATIONS PRIVATE LIMITED',
    'HIGHQ (INDIA) PRIVATE LIMITED',
    'FALABELLA CORPORATE SERVICES INDIA PRIVATE LIMITED',
    'LQT COMMUNICATIONS PRIVATE LIMITED',
    'DONKER TECHNOLOGIES PRIVATE LIMITED',
    'COVOTO GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'IRIS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'SHIGAN FINANCIAL SERVICES PRIVATE LIMITED',
    'KARYAM FINANCIAL SERVICES PRIVATE LIMITED',
    'INTERACTIVETOUCHH TECHNOLOGY PRIVATE LIMITED',
    'GIRIJADEVI GIRISHBABU COLD STORAGE PRIVATE LIMITED',
    'FINTOUCH CONSULTANCY SERVICES PRIVATE LIMITED',
    'MAGNUS CADEAUX INDIA PRIVATE LIMITED',
    'ELIAS AUTO INDIA PRIVATE LIMITED',
    'DYMENSIONS COMPUTER TECHNOLOGY SOLUTIONSPRIVATE LIMITED',
    'CTACT PRIVATE LIMITED',
    'ARBROWN INDIA TRADING PRIVATE LIMITED',
    'THEMIS NUTRITIONALS PRIVATE LIMITED',
    'SWAADAM FOOD AND HOSPITALITY PRIVATE LIMITED',
    'VM WORKS PRIVATE LIMITED',
    'UNIWORLD VISION PRIVATE LIMITED',
    'SIMPLIWOW SERVICES PRIVATE LIMITED',
    'FENSSOL PRIVATE LIMITED',
    'RAVISHANKER PATEL CHARITABLE FOUNDATION',
    'GOOCAMPUS EDU SOLUTIONS PRIVATE LIMITED',
    'PN ENGAGE PRIVATE LIMITED',
    'LETSVENTURE TECHNOLOGIES PRIVATE LIMITED',
    'AASALABS TECHNOLOGIES PRIVATE LIMITED',
    'RASHIVAISHNAV EXPORTS PRIVATE LIMITED',
    'EMINENT CARS PRIVATE LIMITED',
    'AV INFO MEDIA PRIVATE LIMITED',
    'ECHT TRADE PRIVATE LIMITED',
    'LA GAMIN SERVICES PRIVATE LIMITED',
    'ABRAR VENTURES PRIVATE LIMITED',
    'KOTTAKKAL HYPER MARKET PRIVATE LIMITED',
    'MICRO MOBILITY INDIA PRIVATE LIMITED',
    'DESIGNDOTS IO (OPC) PRIVATE LIMITED',
    'NIPURNA IT SOLUTIONS PRIVATE LIMITED',
    'URBAN CLIFF PROJECTS PRIVATE LIMITED',
    'CENTRE SOURCE CONSULTANCY SERVICES PRIVATE LIMITED',
    'UWIC BUILDING MATERIALS PRIVATE LIMITED',
    'GREENCITY FOODS PRIVATE LIMITED',
    'QUICKSERVER LAB (OPC) PRIVATE LIMITED',
    'LEADING ORBIT PRIVATE LIMITED',
    'VRAJBHOOMI VIDHYA ASHRAM FOUNDATION',
    'ANTEAL TECHNOLOGIES PRIVATE LIMITED',
    'EASY OUTDESK PRIVATE LIMITED',
    'CODERPLEX FOUNDATION',
    'VK SOFTWARE TECHNOLOGY PARK PRIVATE LIMITED',
    'SOUTH ASIA CANCER CARE FOUNDATION',
    'VIBLAC PHARMA PRIVATE LIMITED',
    'TECHSTEEDS GLOBAL SERVICES PRIVATE LIMITED',
    'BRAINPAN DIGITAL PRIVATE LIMITED',
    'PRIMIS BPO PRIVATE LIMITED',
    'CHAKARDHAR TRANSPORT INDIA PRIVATE LIMITED',
    'ROUTIER OPERATIONS CONSULTING PRIVATE LIMITED',
    'RADIANT 3PL SOLUTIONS INDIA PRIVATE LIMITED',
    'DATAR TRAILER SERVICES PRIVATE LIMITED',
    'ZIPPY RETAIL TRADING PRIVATE LIMITED',
    'KABA EXPRESS PRIVATE LIMITED',
    'DARYAGANJ HOSPITALITY PRIVATE LIMITED',
    'MUVI CONCEPT RESTAURANTS PRIVATE LIMITED',
    'ABR ROADLINES PRIVATE LIMITED',
    'GHAYTH HOLIDAYS PRIVATE LIMITED',
    'ALEF AVIATION PRIVATE LIMITED',
    'DUNCKANS LOGISTICS PRIVATE LIMITED',
    'SAMA TRAVEL PRIVATE LIMITED',
    'VISTAJET INDIA PRIVATE LIMITED',
    'ATLASKONNECT TRAVELS VENTURE PRIVATE LIMITED',
    'JASSBYS DAKSHIN HOTELS PRIVATE LIMITED',
    'WHATTAY VENTURE PRIVATE LIMITED',
    'IBKP OPEN KITCHEN PRIVATE LIMITED',
    'YAGNA AGRO INDUSTRIES PRIVATE LIMITED',
    'KRISHKO LOGISTICS INDIA PRIVATE LIMITED',
    'SSVS TRANSLOGITECH INDIA PRIVATE LIMITED',
    'JM NEST PRIVATE LIMITED',
    'LA D',
    'MASTRU PRIVATE LIMITED',
    'VALLABH WELFARE FOUNDATION',
    'ISEQUALTO LEARNING SYSTEMS PRIVATE LIMITED',
    'CAVEO INFOSYSTEMS INDIA PRIVATE LIMITED',
    'PGS PARTNER INDIA PRIVATE LIMITED',
    'EDUBURG INDIA PRIVATE LIMITED',
    'PROZURA CONSTRUCTION CHEMICALS PRIVATE LIMITED',
    'VENYA TRAVELTECH INDIA PRIVATE LIMITED',
    'UX DISPLAY PRIVATE LIMITED',
    'AMEST ENGINEERING TECHNOLOGIES PRIVATE LIMITED',
    'MALIKS INDIAN HYPNOSIS ACADEMY PRIVATE LIMITED',
    'GR AKKALKOT SOLAPUR HIGHWAY PRIVATE LIMITED',
    'SAID TECHNOLOGIES PRIVATE LIMITED',
    'KRIDHAN PROJECTS PRIVATE LIMITED',
    'ZOLANCER TECHNOLOGIES PRIVATE LIMITED',
    'HEGENLIFE REMEDIES PRIVATE LIMITED',
    'PLUS MEDIA E-COMMERCE PRIVATE LIMITED',
    'TARUNIMAN FOUNDATION',
    'ANANT NAAD FOUNDATION',
    'AXARO ESTATES PRIVATE LIMITED',
    'REDRING CHEMICALS PRIVATE LIMITED',
    'VRX SPORTS PRIVATE LIMITED',
    'YELLOWROCK SERVICES PRIVATE LIMITED',
    'TRUECONNECT STRATEGIC SERVICES PRIVATE LIMITED',
    'VITTOHAM COMMERCIAL PRIVATE LIMITED',
    'COLEVIT TECHNOLOGIES PRIVATE LIMITED',
    'INQUEST ADVISORIES PRIVATE LIMITED',
    'DOYEN HOTELS PRIVATE LIMITED',
    'LITTLEROCK EDUCATION AND ENGINEERING SERVICES PRIVATE LIMITED',
    'LEHER.AI PRIVATE LIMITED',
    'MOD SPACE HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'OTIC-PARTICION INDIA PRIVATE LIMITED',
    'DUNGJI GUESTHOUSE PRIVATE LIMITED',
    'MEP LONGJIAN ACR PRIVATE LIMITED',
    'JMDES PRIVATE LIMITED',
    'SPEEDWAYS EV GLOBAL PRIVATE LIMITED',
    'NAVIKA INDIA NIDHI LIMITED',
    'SVS SOURCINGS PRIVATE LIMITED',
    'MOBIVANTAGE TECHNOLOGIES PRIVATE LIMITED',
    'SURREAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'XACTEQ INNOVATION LABS PRIVATE LIMITED',
    'GRAPHSQUARE DIGITAL DESIGNS PRIVATE LIMITED',
    'HRIDHAN CHEM PRIVATE LIMITED',
    'INFOEAZE DIGITAL SERVICES PRIVATE LIMITED',
    'LOCALHI TOURS & TRAVELS PRIVATE LIMITED',
    'LL INFOSYSTEMS PRIVATE LIMITED',
    'POMPETRAVAINI CORE INDIA PRIVATE LIMITED',
    'CHATEAU VERT PRIVATE LIMITED',
    'POSEIDON FOODS PRIVATE LIMITED',
    'SOMYRA WELFARE FOUNDATION',
    'RIKUN MANUFACTURING PRIVATE LIMITED',
    'SYMBSELECT FARMS PRIVATE LIMITED',
    'KSKS ACCOUNTING SERVICES PRIVATE LIMITED',
    'PREVALENT AI INDIA PRIVATE LIMITED',
    'ADITYAVANI GENUINE JOBS PRIVATE LIMITED',
    'ODISCIENCE RESOURCES PRIVATE LIMITED',
    'SGMM MITHAS PRIVATE LIMITED',
    'DEE GEE RESOURCESS PRIVATE LIMITED',
    'ROHIT BAL PRIVATE LIMITED',
    'BDG ECO PRODUCTS PRIVATE LIMITED',
    'LOGIREG TECHNOLOGIES PRIVATE LIMITED',
    'SEAREX MARINE INDIA PRIVATE LIMITED',
    'BSQUARE INSTRUMENTS PRIVATE LIMITED',
    'CONFECT GLOBAL SERVICES PRIVATE LIMITED',
    'OPSIO PRIVATE LIMITED',
    'ANJITECH CONSULTANCY SERVICES PRIVATE LIMITED',
    'Q2PAY TECHNOLOGIES PRIVATE LIMITED',
    'CLIMATE AIRCOOL PRIVATE LIMITED',
    'VALUE SQUARE ADVISORS PRIVATE LIMITED',
    'ADDICTION IMPEX PRIVATE LIMITED',
    'MY PROPERTY BOUTIQUE PRIVATE LIMITED',
    'ASPINO HR SERVICES PRIVATE LIMITED',
    'SMARTCLOUD INFOFUSION PRIVATE LIMITED',
    'LHC SHARED SERVICES PRIVATE LIMITED',
    'PRANAYA AGRO PRIVATE LIMITED',
    'MOODAGENT INDIA PRIVATE LIMITED',
    'COGNITIVE ATOM PRIVATE LIMITED',
    'ALN BILLING PRIVATE LIMITED',
    'AQUATIC PIPES AND TUBES PRIVATE LIMITED',
    'BESINS HEALTHCARE SERVICES INDIA PRIVATELIMITED',
    'ESPI HOMESTEAD PRIVATE LIMITED',
    'AELIUSPARALLEL HOLDINGS PRIVATE LIMITED',
    'ERIGO ENERGY SOLUTIONS PRIVATE LIMITED',
    'RRK A2Z SERVICES PRIVATE LIMITED',
    'PALRED RETAIL PRIVATE LIMITED',
    'DIGITOPPER SOLUTIONS PRIVATE LIMITED',
    'KAIVAS IT SOLUTIONS PRIVATE LIMITED',
    'BLAZEKILL TECHNOLOGIES PRIVATE LIMITED',
    'SHUNONG CHEMICAL PRIVATE LIMITED',
    'ISB INFRASTRUCTURE PRIVATE LIMITED',
    'QUALITEK LABS LIMITED',
    'TWIZZEY ONLINE SERVICES PRIVATE LIMITED',
    'PRATIAN LEARNING AND CONSULTING PRIVATE LIMITED',
    'ARUNDAYA MEDICARE PRIVATE LIMITED',
    'APHELIA INNOVATIONS PRIVATE LIMITED',
    'INTERCONTINENTAL WELLNESS & EXIMS PRIVATE LIMITED',
    'VRPM INVESTMENTS PRIVATE LIMITED',
    'COUNTRY EVENTS AND EXHIBITIONS PRIVATE LIMITED',
    'ASIFASOHIL INTERNATIONAL (OPC) PRIVATE LIMITED',
    'DE FANCIABLE JEWELLERS AND GARMENTS PRIVATE LIMITED',
    'SEASEC PRIVATE LIMITED',
    'PROMPT MACHINE TOOLS INDIA PRIVATE LIMITED',
    'BETTERSERV VENTURES PRIVATE LIMITED',
    'KLOG SOLUTIONS PRIVATE LIMITED',
    'ZOOMABROAD EDUCATION CONSULTANTS PRIVATELIMITED',
    'NEBULA HEALTHCARE LIMITED',
    'GUARDIAN HOLDINGS PRIVATE LIMITED',
    'FLYMATE PRIVATE LIMITED',
    'GLOBALXPERTS TECHNOLOGY PRIVATE LIMITED',
    'VECREAR TECHNOLOGIES PRIVATE LIMITED',
    'IC BRIDGEWAY WELFARE FEDERATION',
    'KNOWLEDGEUREKA PRIVATE LIMITED',
    'VIWINCO SOLUTIONS PRIVATE LIMITED',
    'PSYKIX SEABREACHER PRIVATE LIMITED',
    'MAXSHINE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'YUBY CONSUMER PRODUCTS PRIVATE LIMITED',
    'ITS OUR STUDIO PRIVATE LIMITED',
    'ROUND POTATO ENTERPRISE PRIVATE LIMITED',
    'DAKSHTELECO INDIA SERVICES PRIVATE LIMITED',
    'ADVATIX APAC LOGISTICS PRIVATE LIMITED',
    'ATLANTAS TECHNICAL SERVICES INDIA PRIVATE LIMITED',
    'PESSPECTRA PRIVATE LIMITED',
    'BEYOND OUTSOURCING PRIVATE LIMITED',
    'OSMO HOLIDAYS (OPC) PRIVATE LIMITED',
    'AKRIVEIA LABORATORIES PRIVATE LIMITED',
    'EKRATTNA FURNITURES PRIVATE LIMITED',
    'CASTSTUDIO DESIGNS PRIVATE LIMITED',
    'ADVANCED HAIR AND SKIN LABS PRIVATE LIMITED',
    'SRI KUPPANNA OIL MILLS PRIVATE LIMITED',
    'BRAINFUEL SOLUTIONS PRIVATE LIMITED',
    'CYBEREXCELLENCE ACADEMY PRIVATE LIMITED',
    'DOTBALL INTERACTIVE PRIVATE LIMITED',
    'ARMSTRONG LABS PRIVATE LIMITED',
    'FUTUREEYE INFOTECH PRIVATE LIMITED',
    'SCALABL STARTUP ADVISORS PRIVATE LIMITED',
    'SIMANTA INSPECTION SYSTEMS PRIVATE LIMITED',
    'INDIA PARYAVARAN SAHAYAK FOUNDATION',
    'SALK INDUSTRIES PRIVATE LIMITED',
    'MESBOR PRIVATE LIMITED',
    'KYTERO IMMIGRATION PRIVATE LIMITED',
    'BULI CHEMICALS INDIA PRIVATE LIMITED',
    'ALLSOFT CONSULTING PRIVATE LIMITED',
    'REMARKABLE PRODUCTIONS PRIVATE LIMITED',
    'MUNDRA CRUDE OIL TERMINAL PRIVATE LIMITED',
    'RONMON CREATIVE (OPC) PRIVATE LIMITED',
    'LIKESBY VENTURES PRIVATE LIMITED',
    'RESGENESIS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GNSQ GLOBAL SERVICE DELIVERY (OPC) PRIVATE LIMITED',
    'OHA TAXCON PRIVATE LIMITED',
    'NGEN RESEARCH PRIVATE LIMITED',
    'KIMIKA GMPSOL PRIVATE LIMITED',
    'BERT ENERGY INDIA PRIVATE LIMITED',
    'ISIT OFFICE SPACE SOLUTION PRIVATE LIMITED',
    'BRAMHANSH TECHNOLOGIES PRIVATE LIMITED',
    'CLEAN LIQUID LOGISTICS SERVICES PRIVATE LIMITED',
    'HOMEDROID TECHNOLOGIES PRIVATE LIMITED',
    'DRASS SOTTOMARINE PRIVATE LIMITED',
    'REDD EXPERIENCE DESIGN PRIVATE LIMITED',
    'VYOMAN AVIATION PRIVATE LIMITED',
    'ESPI STABLES AND FARMS PRIVATE LIMITED',
    'COREN INDUSTRIAL SERVICES PRIVATE LIMITED',
    'WEGARNER SOLUTIONS PRIVATE LIMITED',
    'GOYAL FINE JEWELS PRIVATE LIMITED',
    'CHHATTISGARH COPPER LIMITED',
    'NAM HO WORLD MARKETING PRIVATE LIMITED',
    'UNIFURN FURNITURE PRIVATE LIMITED',
    'ISCHOLAR KNOWLEDGE SERVICES PRIVATE LIMITED',
    'ASSETMAX INTERIORS PRIVATE LIMITED',
    'TKD ATHLETICS FOUNDATION',
    'AVAADA FOUNDATION',
    'MANNUR LAND DEVELOPERS PRIVATE LIMITED',
    'SARMEYAH SOLUTIONS PRIVATE LIMITED',
    'RENPROTECH SOLUTIONS PRIVATE LIMITED',
    'RIPPLE PURPLE PRIVATE LIMITED',
    'TOPVIEW BRAND INDIA PRIVATE LIMITED',
    'ACYCLIC TECHNOLOGIES PRIVATE LIMITED',
    'ROJANA FASHIONS (OPC) PRIVATE LIMITED',
    'KRANTI COMMUNITY FOUNDATION',
    'KISETSU SAISON FINANCE (INDIA) PRIVATE LIMITED',
    'REOTECH PROCESS EQUIPMENT PRIVATE LIMITED',
    'ENTELLUS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ADOCATES PRIVATE LIMITED',
    'SABAR FLEX INDIA LIMITED',
    'NENS FOREX SERVICES PRIVATE LIMITED',
    'BHADANE WAREHOUSE DEVELOPMENT PRIVATE LIMITED',
    'TRAVELTIME CITY BUS SERVICES (GURUGRAM) PRIVATE LIMITED',
    'ARTFILLS PRIVATE LIMITED',
    'DEXHIGH SERVICES PRIVATE LIMITED',
    'LIGANIS MARITIME SERVICES PRIVATE LIMITED',
    'MAITHRI NIRAMAYA PRIVATE LIMITED',
    'LYDNOW EDUTECH PRIVATE LIMITED',
    'TULJAPUR POWER DEVELOPMENT PRIVATE LIMITED',
    'SOMNATH PRODUCTS PRIVATE LIMITED',
    'Maieco organic private limited',
    'BALAJI SPECIALITY CHEMICALS LIMITED',
    'H.e.f.india private limited',
    'Phenix harness private limited',
    'Excella life sciences private limited',
    'Sss plastics private limited',
    'UTILIZEAI RESEARCH PRIVATE LIMITED',
    'ARVIND SMART TEXTILES LIMITED',
    'SGR MOULDS INDIA PRIVATE LIMITED',
    'INNOVIR BIOSCIENCES PRIVATE LIMITED',
    'TEMFLO PROJECTS PRIVATE LIMITED',
    'QIBLA UMRAH INDIA PRIVATE LIMITED',
    'PACKBAG HOSPITALITY PRIVATE LIMITED',
    'UNTITLED HOTELS & RESORTS PRIVATE LIMITED',
    'MOUNTAIN MANAGERS PRIVATE LIMITED',
    'TRIOEDGE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ZELLIS HR INDIA PRIVATE LIMITED',
    'TRANSCEDENCE AUTOMATION PRIVATE LIMITED',
    'SADEPACH LABS PRIVATE LIMITED',
    'SARADA HUMAN RESOURCES PRIVATE LIMITED',
    'VAULT AGRITECH PRIVATE LIMITED',
    'WISELEAP BUSINESS SERVICES HOLDING PRIVATE LIMITED',
    'GIMME FOODS PRIVATE LIMITED',
    'TASHA & GIRL PRIVATE LIMITED',
    'PRASATHAM PRODUCTS PRIVATE LIMITED',
    'VAM ONE INNOVATIONS PRIVATE LIMITED',
    'ARMSUN INDUSTRIES (OPC) PRIVATE LIMITED',
    'BELONGCARE MEDITECH PRIVATE LIMITED',
    'SCOOT TECH PRIVATE LIMITED',
    'BHORUKA SUPPLY CHAIN SOLUTIONS HOLDINGS LIMITED',
    'AUTOMOTIVE ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'KEN',
    'S CLOUD SERVICES PRIVATE LIMITED',
    'BUGSMASH TECHNOLOGIES PRIVATE LIMITED',
    'REXA PRIME SOLUTIONS PRIVATE LIMITED',
    'UNIO IOT PRIVATE LIMITED',
    'TSH OPERATION AND MAINTENANCE SERVICES PRIVATE LIMITED',
    'SDK LOGISTICS PRIVATE LIMITED',
    'DRSS FREIGHT FORWARDING PRIVATE LIMITED',
    'ENEOS MATERIALS INDIA PRIVATE LIMITED',
    'KAHHAK INDUSTRIES PRIVATE LIMITED',
    'REWARD HOTELS PRIVATE LIMITED',
    'CHEFERD FOODS PRIVATE LIMITED',
    'ASHCON LOGISTICS INDIA PRIVATE LIMITED',
    'ORGANISED TRANS SOLUTIONS PRIVATE LIMITED',
    'DINESH LOGISTICS PRIVATE LIMITED',
    'VIDARBHA CARGO PRIVATE LIMITED',
    'DOLPHUZ INSTRUMENTS PRIVATE LIMITED',
    'BROTHERS VENTURE PRIVATE LIMITED',
    'IKIT APPLIANCES PRIVATE LIMITED',
    'QUALCOSA INTERNATIONAL PRIVATE LIMITED',
    'TITANIUM FREIGHT AND LOGISTICS PRIVATE LIMITED',
    'CYCLONE GLOBAL LOGISTICS PRIVATE LIMITED',
    'VENNAR DIGITAL FARM PRIVATE LIMITED',
    'AJSG MOTORS PRIVATE LIMITED',
    'CLEANSECAR WASHING AND REPAIR SERVICES PRIVATE LIMITED',
    'FICODE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DIUS PROJECTS PRIVATE LIMITED',
    'SIMPLIFIED GLOBAL ACCOMODATION (OPC) PRIVATE LIMITED',
    'IWARE SUPPLYCHAIN SERVICES PRIVATE LIMITED',
    'LULU HOLIDAYS PRIVATE LIMITED',
    'RAFTAAR OFFSHORE PRIVATE LIMITED',
    'MERCATOR OCEANTRANSPORT LIMITED',
    'TINTECH ONLINE PRIVATE LIMITED',
    'INCOR SIRUSERI PROPERTIES PRIVATE LIMITED',
    'MSM EDIFICIO PRIVATE LIMITED',
    'SPS INFRA ENGINEERING PRIVATE LIMITED',
    'M.T.TOURS PRIVATE LIMITED',
    'MINTIFI FINSERVE PRIVATE LIMITED',
    'MICROSEC WEALTH MANAGEMENT LIMITED',
    'KOPURAM CHITS PRIVATE LIMITED',
    'OUTDOOR LEARNING TRIPSCHOOL PRIVATE LIMITED',
    'A.R.S. TERMINALS (INDIA) PRIVATE LIMITED',
    'KRESHA STEEL PRIVATE LIMITED',
    'ABOVO TRAVEL PRIVATE LIMITED',
    'JAYHAWKER INSURANCE MARKETING PRIVATE LIMITED',
    'SH FUND MANAGEMENT PRIVATE LIMITED',
    'LULU FINANCIAL SERVICES (INDIA) PRIVATE LIMITED',
    'SV SOFT SOLUTIONS PRIVATE LIMITED',
    'INCUPRO TECH VENTURE PRIVATE LIMITED',
    'VASPIRE TECHNOLOGIES SERVICES PRIVATE LIMITED',
    'DEXBYTES INFOTECH PRIVATE LIMITED',
    'NCOGNITIX LOGIC PRIVATE LIMITED',
    'INNOPIX IT SOLUTIONS (OPC) PRIVATE LIMITED',
    'COMSENSE TECHNOLOGIES PRIVATE LIMITED',
    'TRIUMPH IMAGING & VISUALIZATION INDIA PRIVATE LIMITED',
    'SIERRA WEB SOLUTIONS PRIVATE LIMITED',
    'LAKSHAN TECHNOLOGIES PRIVATE LIMITED',
    'TEGO DATA SOLUTIONS PRIVATE LIMITED',
    'KIOTEK DIGI NETWORKS PRIVATE LIMITED',
    'GANPATI EXCELLENT INFRASTRUCTURE PRIVATELIMITED',
    'GOWRA PALLADIUM PRIVATE LIMITED',
    'PIVOTCHAIN SOLUTION TECHNOLOGIES PRIVATE LIMITED',
    'RSC SOFTWARE LABS PRIVATE LIMITED',
    'NIVESHAN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ROADEXPRESS TECHNOLOGY PRIVATE LIMITED',
    'ZOCKETHUB PRIVATE LIMITED',
    'QUINE ZONE PRIVATE LIMITED',
    'AALBATROSS ENVIRONMENTAL SERVICES PRIVATE LIMITED',
    'CCB ULTRAHARD ABRASIVES PRIVATE LIMITED',
    'CASTLECRAFT ECOMMERCE PRIVATE LIMITED',
    'BIORADIUS THERAPEUTIC RESEARCH PRIVATE LIMITED',
    'DUCIS MANAGEMENT CONSULTING PRIVATE LIMITED',
    'SNEH EXPLOTECH PRIVATE LIMITED',
    'PARINATA MUSIC SERVICES PRIVATE LIMITED',
    'BIGO SERVICE INDIA PRIVATE LIMITED',
    'INROLE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'LAZLO SOFTWARE SOLUTION PRIVATE LIMITED',
    'BHAIRAVI RESELLER & SERVICES PRIVATE LIMITED',
    'BESPOKE PACKAGING INDIA PRIVATE LIMITED',
    'AVETEA EXOTICS PRIVATE LIMITED',
    'FXVISUALS SOLUTIONS PRIVATE LIMITED',
    'LANDMARK AUTOMOBILES LIMITED',
    'QMICS SOLUTIONS PRIVATE LIMITED',
    'SUNDARAM INDUSTRIES PRIVATE LIMITED',
    'PRASOFT IT SERVICES PRIVATE LIMITED',
    'ORTEL BROADBAND LIMITED',
    'OFFCAMPUSTEST TECHNOLOGIES PRIVATE LIMITED',
    'NEURALNET DATA SCIENCE PRIVATE LIMITED',
    'LOGYCODE TECH SOLUTIONS PRIVATE LIMITED',
    'LI DIGITAL PAYMENTS PRIVATE LIMITED',
    'DIGION SOLUTIONS PRIVATE LIMITED',
    'BITHOPS TECHNOLOGIES PRIVATE LIMITED',
    'INTECROWD INDIA PRIVATE LIMITED',
    'DISRUPTIVE ADVANTAGE INDIA PRIVATE LIMITED',
    'MALBORK TECHNOLOGIES PRIVATE LIMITED',
    'PARULSOFT INFO INDIA ADBS PRIVATE LIMITED',
    'GAMMA CAE TECHNOLOGIES PRIVATE LIMITED',
    'DGSERV TECH PRIVATE LIMITED',
    'CRG SOFTWARE INDIA PRIVATE LIMITED',
    'VTHRIVE SOLUTIONS PRIVATE LIMITED',
    'NEWWAY YTT (OPC) PRIVATE LIMITED',
    'TRAFIKSOL ITS TECHNOLOGIES PRIVATE LIMITED',
    'MAHAT RESEARCH AND ADVISORY PRIVATE LIMITED',
    'STMICROELECTRONICS FOUNDATION INDIA',
    'CMORA CARGOTECH PRIVATE LIMITED',
    'BRIGHTCROP AGRO PRODUCTS PRIVATE LIMITED',
    'EUN SUNG ENTERPRISES PRIVATE LIMITED',
    'BIM INTEGRATED SERVICES PRIVATE LIMITED',
    'PAS ADVERTISING ADBUILDS PRIVATE LIMITED',
    'CORPUSVISION TECHNOLOGIES PRIVATE LIMITED',
    'SOURCECODE LABS PRIVATE LIMITED',
    'STARK ELECTROTECH SERVICES PRIVATE LIMITED',
    'SOLUCIO INFRA SOLUTIONS PRIVATE LIMITED',
    'RINOKYA CONSULTANTS PRIVATE LIMITED',
    'SOLAXOCON SERVICES PRIVATE LIMITED',
    'MANDAKINI HOLIDAYS PRIVATE LIMITED',
    'TASHOKU COATING WORLD PRIVATE LIMITED',
    'ONFYNOPTIS SOLUTIONS PRIVATE LIMITED',
    'IC INDIA CASTING PRIVATE LIMITED',
    'MALABAR INTERNATIONAL PORT & SEZ LIMITED',
    'PI GLOBAL INDIA PRIVATE LIMITED',
    'INNOLUX OPTOELECTRONICS INDIA PRIVATE LIMITED',
    'NSE FOUNDATION',
    'BESTOWING LIFE FOUNDATION',
    'LEGEND SPORTS PROMOTION AND DEVELOPMENT FOUNDATION',
    'PIOTR AND ASH INTERNATIONAL PRIVATE LIMITED',
    'GENE FOOD WORKS PRIVATE LIMITED',
    'C.R.HOSPITALITY PRIVATE LIMITED',
    'MAA KATYAYANI TRANSPORT PRIVATE LIMITED',
    'TECHNOGREEN AIRCONDITIONING PRIVATE LIMITED',
    'ADMI PROMOTIONS PRIVATE LIMITED',
    'TAPSOM PROJECTS PRIVATE LIMITED',
    'ABHAY HOSPITALITY SERVICES PRIVATE LIMITED',
    'MAKESHIFT HOTELS PRIVATE LIMITED',
    'Parmaz estates private limited',
    'Krishna land realty private limited',
    'Vajra land infrastructure private limited',
    'Jalaram land infrastructure private limited',
    'Conwood realty private limited.',
    'Shree gannayak projects private limited',
    'Fortune developers & resoures pvt.ltd.',
    'Indraprasth integrated development land futuristic private limited',
    'Artek impex private limited',
    'Sumit infratech private limited',
    'Arham escon private limited',
    'One world property developers private limited',
    'Talisa infrastructure private limited',
    'Dhammanagi developerss private limited',
    'Sreekrit real estates private limited',
    'Prominent realtech private limited',
    'Ameya commercial projects private limited',
    'Supertech township project limited',
    'KAIZEN RESTAURANTS PRIVATE LIMITED',
    'Supertech realtors private limited',
    'Bhawani infracon private limited',
    'Oneway buildtech private limited',
    'H.m. apartments private limited',
    'Eminent buildcon private limited',
    'Usha breco education infrastructure one private limited',
    'Chocolate properties private limited',
    'Wealth amplifier infratech private limited',
    'Sitesandservices private limited',
    'Landbase realty private limited',
    'Luxor estates & holdings private limited',
    'Karni estates india private limited',
    'Ecosphere realty developments private limited',
    'Pelican realty projects private limited',
    'Dreamacres realty private limited',
    'Medroit management avenues private limited',
    'Shasan engineering private limited',
    'Freightco india limited',
    'Professional skill training & consultancy private limited',
    'Enerji systems private limited',
    'Vs ecommerce ventures private limited',
    'Brightspark energy private limited',
    'Mobimp services private limited',
    'Teshi fittings private limited',
    'Green lantern engineering private limited',
    'PSF MANAGEMENT SERVICES PRIVATE LIMITED',
    'CREDIT WISE CAPITAL PRIVATE LIMITED',
    'EXEENS CAPITAL ADVISORS PRIVATE LIMITED',
    'BALESTIER VENTURES PRIVATE LIMITED',
    'BITRA TRAILS PRIVATE LIMITED',
    'ALTCARGO OIL & GAS PRIVATE LIMITED',
    'YBM PARCEL SERVICE PRIVATE LIMITED',
    'PRICOL LOGISTICS PRIVATE LIMITED',
    'TAI JETS PRIVATE LIMITED',
    'MH HOSPITALITY PRIVATE LIMITED',
    'LEXOGO TOURS AND TRAVELS PRIVATE LIMITED',
    'NDX P2P PRIVATE LIMITED',
    'LACHHMIDHAR KANSHIRAM FINSERV PRIVATE LIMITED',
    'HYBRID FLEET MANAGEMENT PRIVATE LIMITED',
    'FINQUEST ARC PRIVATE LIMITED',
    'AUTUS SECURITIES INVESTMENT ADVISERS PRIVATE LIMITED',
    'GUERRILLA VENTURES PRIVATE LIMITED',
    'NOVOFIN CREDIT PRIVATE LIMITED',
    'VISAT REALTY PRIVATE LIMITED',
    'OXILON PRIVATE LIMITED',
    'ASDER AUTOMATION PRIVATE LIMITED',
    'GURBAX HOLDINGS PRIVATE LIMITED',
    'NISUS FINCORP PRIVATE LIMITED',
    'INMACS FINANCE PRIVATE LIMITED',
    'PANAESHA CAPITAL PRIVATE LIMITED',
    'KANIKA BUILDWELL PRIVATE LIMITED',
    'ZALTA PACKAGING PRIVATE LIMITED',
    'SAISRUSHTI (KAGGADASAPURA) PROJECTS PRIVATE LIMITED',
    'SAISRUSHTI (GUNJUR) PROJECTS PRIVATE LIMITED',
    'VNP REALTORS PRIVATE LIMITED',
    'DMT TRAVELS PRIVATE LIMITED',
    'COLT EQUIPMENTS PRIVATE LIMITED',
    'KRCPL PRIVATE LIMITED',
    'AUGOS BROADBAND PRIVATE LIMITED',
    'FUTURE EXPRESS PRIVATE LIMITED',
    'RANK REAL ESTATE AND INFRA DEVELOPERS PRIVATE LIMITED',
    'SUVA INFRASTRUCTURE PRIVATE LIMITED',
    'SPRK MED PRIVATE LIMITED',
    'VALUE AND KNOWLEDGE NETWORK PRIVATE LIMITED',
    'NECTARBITS PRIVATE LIMITED',
    'DOTSPAZIO INFINITO PRIVATE LIMITED',
    'AMARAVATI DEVELOPMENT PARTNERS PRIVATE LIMITED',
    'OBOR SPACE PRIVATE LIMITED',
    'NUTNBOLT INFRA PRIVATE LIMITED',
    'SPADE PROJECTS PRIVATE LIMITED',
    'Vikas lifestyle retail private limited',
    'CLEMONTE INFRA PRIVATE LIMITED',
    'Manisha impex private limited',
    'Pinokio Entertainment Private Limited',
    'Lemon tree hotel company private limited.',
    'Shreeramji commerce private limited',
    'Kritya commercial private limited',
    'UD SOLUTION PRIVATE LIMITED',
    'Naj india private limited',
    'LIGHT AXXIS PRIVATE LIMITED',
    'CUIRASS DOORS PRIVATE LIMITED',
    'Nath brothers exim international limited',
    'Cocomar resorts private limited',
    'Nexusneo agro-foods exports private limited',
    'Exmark distributors private limited',
    'United sons private limited',
    'R. d. rubber & tyres private limited',
    'Hotel babylon international private limited',
    'Mayfair restaurants private limited',
    'Ramgarh heritage private limited',
    'Ajc petrochem private limited',
    'Vidhu capital services private limited',
    'BANSAL CORPORATION PRIVATE LIMITED',
    'R a b marketing private limited',
    'Ajitnath builders private limited',
    'Allport international private limited',
    'Adaya builders private limited',
    'Bigg investments and finance private limited',
    'Autoneum india private limited',
    'Padmawati leasing and credits private limited',
    'Super screws private limited',
    'Anand reddiplex limited',
    'Mod holdings private limited',
    'Sansun estates private limited',
    'Incite digital private limited',
    'Noida infoservices private limited',
    'Divyam exim private limited',
    'Patgenix consultants private limited',
    'Winsome communications private limited',
    'Enfocus india private limited',
    'Biotech india limited',
    'Emg showmakerz private limited',
    'Aravli synthetics private limited',
    'Ssg investments private limited',
    'Maxim labelling (delhi) private limited',
    'ELEVATE ADVANCE SOLUTIONS PRIVATE LIMITED',
    'TRANSHUB INDIA PRIVATE LIMITED',
    'PROFERSN SERVICES PRIVATE LIMITED',
    'AAMRO DAIRIES PRIVATE LIMITED',
    'FARMX TRADING PRIVATE LIMITED',
    'PITAARA TALKIES PRIVATE LIMITED',
    'NUKEBOX STUDIOS PRIVATE LIMITED',
    'BDB SPORTS FOUNDATION',
    'AGILITY INDIA PRIVATE LIMITED',
    'MEHRA LIFE SCIENCES PRIVATE LIMITED',
    'EUROPA D TOURS PRIVATE LIMITED',
    'GLOBYLOG SOLUTIONS PRIVATE LIMITED',
    'AUTADE SUGARS PRIVATE LIMITED',
    'BSP FREEDO PRIVATE LIMITED',
    'WOCKHARDT LIMITED',
    'LRK LOGISTIC PRIVATE LIMITED',
    'LANDESA CONSULTING PRIVATE LIMITED',
    'BALIN WORLD PRIVATE LIMITED',
    'ALGOM CODES SERVICES PRIVATE LIMITED',
    'BALCKE DUERR ENGINEERING PRIVATE LIMITED',
    'MISMILE INTERNATIONAL PRIVATE LIMITED',
    'TARASREE TECHNOCAST PRIVATE LIMITED',
    'AUQUALL BPO SERVICES PRIVATE LIMITED',
    'WINNER AUTO COMPONENTS INDIA PRIVATE LIMITED',
    'DEEP COGNITION INDIA PRIVATE LIMITED',
    'AMAATRA HEALTH PRIVATE LIMITED',
    'VBXSOFT WEB AND INNOVATIONS PRIVATE LIMITED',
    'GLOBALYDK ELECTRIC PRIVATE LIMITED',
    'LENIENT CLOUD PRIVATE LIMITED',
    'AVIGNA PRIVATE LIMITED',
    'AUSDIA SOFTWARE INDIA PRIVATE LIMITED',
    'QUADRANT RESOURCES PRIVATE LIMITED',
    'WIZHCOMM CONSULTANTS AND TECHNOLOGIES PRIVATE LIMITED',
    'PIRAMAL SECURITIES LIMITED',
    'SYNTRINO PRIVATE LIMITED',
    'VEDAPURI LOTUS PROPERTIES PRIVATE LIMITED',
    'XOTIC CUSTOM WORKS INDIA PRIVATE LIMITED',
    'HELLO CABLES & SWITCHGEARS PRIVATE LIMITED',
    'AISAN INDUSTRY INDIA PRIVATE LIMITED',
    'IDEMPOTENT BPO PRIVATE LIMITED',
    'NNDC INDIA FOUNDATION',
    'SSA ELITE ENERGY ALLIANCE PRIVATE LIMITED',
    'ONE UP BRANDS PRIVATE LIMITED',
    'KRISORIGINALS PRIVATE LIMITED',
    'ZOIE AGRO PRIVATE LIMITED',
    'KEDAR CEREALS PRIVATE LIMITED',
    'Fargo telecom technologies private limited',
    'M.N. SPORTS PRIVATE LIMITED',
    'Ecowise trading private limited',
    'Accent megasales private limited',
    'Ras overseas private limited',
    'Aerial telecom solutions private limited',
    'LINKAPPAREL EXPORTS PRIVATE LIMITED',
    'Esperto payroll solutions private limited',
    'Virtunet systems private limited',
    'Codomain consultants private limited',
    'Mattsenkumar services private limited',
    'Balajee exchem private limited',
    'Coronation worth india private limited',
    'Chempolis india private limited',
    'Khyati nilum associates private ltd.',
    'REKHA CONTINENTAL LIMITED',
    'THE PUNJAB BUSINESS & SUPPLY COMPANY PRIVATE LIMITED',
    'Krishna labels pvt ltd',
    'Combine infra services private limited',
    'Mahavir port and terminal private limited',
    'Medical educational trust association surat of seventh-day adventist',
    'Scitech laboratories pvt ltd',
    'Monk engineers private limited',
    'Strategic vintrade private limited',
    'Theism ceemec private limited',
    'Peninsula management services private limited',
    'North land agri solutions private limited',
    'Val products india private company',
    'SEHMI RESORTS PRIVATE LIMITED',
    'Axience consulting private limited',
    'COACHING FOUNDATION INDIA PRIVATE LIMITED',
    'Harvest securities private limited',
    'Yellow submarine film private limited',
    'Benfoco overseas private limited',
    'ADBSAFEGATE INDIA PRIVATE LIMITED',
    'Wordplex media private limited',
    'Archen design private limited',
    'Reconnoiter technologies & research private limited',
    'Corporate warranties (india) pvt ltd',
    'Newton equipments p ltd',
    'Samruddha sugar engineers private limited',
    'Laser automation private limited',
    'Ducati india private limited',
    'Basudeb auto limited',
    'MEDIPURE LIFE SCIENCES INDIA PRIVATE LIMITED',
    'REMCO AGRITECH PRIVATE LIMITED',
    'CITADEL MAINTENANCE SERVICES PRIVATE LIMITED',
    'LIFEQUBES SHELTERS PRIVATE LIMITED',
    'LANDSKY ALLIED INDUSTRIES PRIVATE LIMITED',
    'MAITRAYANA CHARITY FOUNDATION',
    'SOUMATIC SOLUTIONS INDIA PRIVATE LIMITED',
    'KCM SUPPLY CHAIN SOLUTION PRIVATE LIMITED',
    'ROYAL CROP SCIENCE INDIA LIMITED',
    'KRIDHAN INFRATECH PRIVATE LIMITED',
    'INVTECH SOLAR PROJECTS PRIVATE LIMITED',
    'EPRC PANELS PRIVATE LIMITED',
    'AKRUX BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HUA YAO MOULDS PRIVATE LIMITED',
    'NOVOFIN CREDIT TECHNOLOGIES PRIVATE LIMITED',
    'MAGNUS DESIGNERS AND CONSULTANTS PRIVATELIMITED',
    'VISTA SPACES SUN (LALBAGH) PRIVATE LIMITED',
    'PALLAKKI NDT EXCELLENCE CENTER PRIVATE LIMITED',
    'NISAGRA RENEWABLE ENERGY PRIVATE LIMITED',
    'LEVERAGE IT PRIVATE LIMITED',
    'GREENKO SHIMOGA SOLAR PRIVATE LIMITED',
    'CHEMITECH ACEWORKS PRIVATE LIMITED',
    'ABACUS OVERSEAS STUDY PRIVATE LIMITED',
    'NORTHSTAR BEV PRIVATE LIMITED',
    'MERCURY CAPITAL ADVISORS INDIA PRIVATE LIMITED',
    'JODHPUR TIRE LIMITED',
    'NORTH EAST GALVA PRIVATE LIMITED',
    'LUCKNOW GOLF VIEW PRIVATE LIMITED',
    'SURNOI TECHNOLOGY PRIVATE LIMITED',
    'SESAT SOLUTIONS PRIVATE LIMITED',
    'SESEN REALTY PRIVATE LIMITED',
    'DBL BANGALORE NIDAGATTA HIGHWAYS PRIVATELIMITED',
    'INFOHOUSE REAL ESTATE PRIVATE LIMITED',
    'FEEDBACK BUSINESS INSIGHTS PRIVATE LIMITED',
    'QVC REALTY DEVELOPERS PRIVATE LIMITED',
    'INFIDIGIT CONSULTANTS PRIVATE LIMITED',
    'ZMOTION AUTONOMOUS SYSTEMS PRIVATE LIMITED',
    'KEEROS FOODS PRIVATE LIMITED',
    'TVS INVESTMENT AND CONSULTANCY SERVICES PRIVATE LIMITED',
    'CONSULDESK SOLUTIONS PRIVATE LIMITED',
    'GREENKO BAGALKOT SOLAR PRIVATE LIMITED',
    'NGENUE INDIA PRIVATE LIMITED',
    'DUMKA TRANSMISSION LIMITED',
    'KEF LIVING INDIA PRIVATE LIMITED',
    'Eulex india private limited',
    'SATYACORP ENTERPRISES PRIVATE LIMITED',
    'Pilani properties ltd',
    'L&t power development limited',
    'Neepaz power limited',
    'Adhunik power & natural resources limited',
    'Puri captive energy private limited',
    'Orchid infrastructure developers private limited',
    'L&t himachal hydropower limited',
    'Spml energy limited',
    'Yenepoya energy private limited',
    'Imminent solar private limited',
    'Clean filter industries pvt. ltd.',
    'MINDA STORAGE BATTERIES PRIVATE LIMITED',
    'Samraat umbrella co private limited',
    'Accra pac (india) private limited',
    'Xds security protekt india private limited',
    'Kumar auto parts pvt ltd',
    'Mk lide autoclutch industries private limited',
    'Shringaar medley private limited',
    'Manik chand and sons (jewellers) private limited',
    'Enteron waste management services private limited',
    'Mahendra power private limited',
    'Sitaram energy and logistics limited.',
    'Innowatts energy private limited',
    'Blue chip energy solutions private limited',
    'Seli hydro electric power company limited',
    'BIONICS CONSORTIUM PRIVATE LIMITED',
    'Khazana jewellery private limited',
    'Aquadyne appliances private limited',
    'Zima builders & developers private limited',
    'Madhav mukund developers private limited',
    'Adinath properties private limited',
    'Ats development private limited',
    'Dynamic colonizers private limited',
    'Saubhagya infratech private limited',
    'Avima exports pvt ltd',
    'AXIOM CONTROLS PRIVATE LIMITED',
    'INDIA CIRCUITS PRIVATE LIMITED',
    'Akg developers private limited',
    'Inderjeet bros projects private limited',
    'Kgap developers private limited',
    'Ats infratech private limited',
    'Ats hills infradevelopers private limited',
    'Jayati infrastructure limited',
    'MIKAEL GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SOCIALLY INDIA INCLUDED FOUNDATION',
    'CREVAC TECH PRIVATE LIMITED',
    'BLOKLEEN SOLAR PRIVATE LIMITED',
    'DUCOM AEROSPACE TECHNOLOGIES PRIVATE LIMITED',
    'OVION HOMECARE PRIVATE LIMITED',
    'APPTURE TECHNOLOGY PRIVATE LIMITED',
    'GAUECOGRAM AGROVIKAS PRODUCER COMPANY LIMITED',
    'AUXO SOLAR ENERGY PRIVATE LIMITED',
    'GIDEONS DIGITAL AGENCY PRIVATE LIMITED',
    'ROOT MULTITUDE (OPC) PRIVATE LIMITED',
    'FDC WEB TECHNOLOGIES PRIVATE LIMITED',
    'GTS FACILITY MANAGEMENT SERVICES PRIVATELIMITED',
    'CODEVALUE TECHNOLOGIES PRIVATE LIMITED',
    'BRND STUDIO PRIVATE LIMITED',
    'VYUHGENICS INDIA PRIVATE LIMITED',
    'DDRIVE STUDIO INDIA (OPC) PRIVATE LIMITED',
    'FOURBYFOUR EXPERIENCES PRIVATE LIMITED',
    'SWABHUVE TRADING AND SERVICES PRIVATE LIMITED',
    'SREEDHAREEYAM FARMS AND FOODS VENTURES PRIVATE LIMITED',
    'CEYONE MARKETING PRIVATE LIMITED',
    'SWEDINDUS SOLUTIONS AB INDIA PRIVATE LIMITED',
    'SUTANTU SERVICES PRIVATE LIMITED',
    'UTIVAC HEALTHCARE PRIVATE LIMITED',
    'EXOHEALTH ENTERPRISES PRIVATE LIMITED',
    'PANJATAN PAAK 5 MEDIA SOLUTIONS PRIVATE LIMITED',
    'INVENTURE DEVELOPERS PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY FIFTEEN PRIVATE LIMITED',
    'BRAVERY INFOTECH PRIVATE LIMITED',
    'ASTRAGEN EDUTAINMENT PRIVATE LIMITED',
    'PHTHALO PIGMENTS PRIVATE LIMITED',
    'VOGABE ADVISORS PRIVATE LIMITED',
    'RELEVANT INSPEC PRIVATE LIMITED',
    'SPACEPIXXEL TECHNOLOGIES PRIVATE LIMITED',
    '5PAN UNIVERSAL PRIVATE LIMITED',
    'DROPLEDGE PRIVATE LIMITED',
    'STALWART FACILITIES PRIVATE LIMITED',
    'SPG CHEM CARE PRIVATE LIMITED',
    'RHONIUM METALS AND MARKETING PRIVATE LIMITED',
    'CREATIVEMENTORS PRIVATE LIMITED',
    'MULURA LOGISTICS PRIVATE LIMITED',
    'INGENE FITNESS PRIVATE LIMITED',
    'MOBOCOR TRADING PRIVATE LIMITED',
    'HVA CHEMICAL SOLUTION PRIVATE LIMITED',
    'Olivia green projects and developments private limited',
    'Lotey enterprises private limited',
    'Rudranil agriculture private limited',
    'Arsta eco private limited',
    'Aksharaa agro private limited',
    'MCCORMICK FOODS INDIA PRIVATE LIMITED',
    'Tvarur oils & fats private limited',
    'Shreyas papers private limited',
    'Crossfields water purifiers private limited',
    'Summit nutraceuticals private limited',
    'North east nutrients private limited',
    'West india continental oils & fats private limited',
    'Lokesh electricals private limited',
    'Diamant triumph metallplastic private limited',
    'Awn agro private limited',
    'Life line feeds (india) private limited',
    'Kothari milkplan technologies private limited',
    'Samudra biopharma private limited',
    'Anandum dairy & foods private limited',
    'Annajal farms private limited',
    'Anjella tex private limited',
    'REVINTO LIFE SCIENCE PRIVATE LIMITED',
    'E-parisaraa private limited',
    'Mystical biotech private limited',
    'Deval energy resources private limited',
    'Uni klinger limited',
    'NITIRAJ ENGINEERS Limited',
    'Vijigeeshu quality management services private limited',
    'Softech controls private limited',
    'Alfa vertical transport private limited',
    'Positronic interconnects private limited',
    'Fischer measurement technologies (india) private limited',
    'Nihaar equipment private limited',
    'Nepani components and systems private limited',
    'Lourenco marine private limited',
    'Orix hi fidelity private limited',
    'Mindstec distribution private limited',
    'Calyx info private limited',
    'Virat electronics limited',
    'Adda electronics private limited',
    'Nextgen cnc hytek private limited',
    'Tamil nadu alakaline batteries limited',
    'RAKON INDIA PRIVATE LIMITED',
    'Brisk electronics private limited',
    'Atmospheric projects private limited',
    'Srijan infrarealty private limited',
    'Srijan enclave private limited',
    'Shagun skyscraper private limited',
    'Premium mansions private limited',
    'Skyscraper real estate private limited',
    'Floor infrastructure private limited',
    'Skyscraper vanijya private limited',
    'Devansh township private limited',
    'HILARIOUS REALTORS PRIVATE LIMITED',
    'Surya vaibhav developers private limited',
    'Flare estate private limited',
    'Lebnitze real estates private limited',
    'Gold projects developers private limited',
    'Exotica realtech private limited',
    'Amritlaxmi developers private limited',
    'A2z contractors private limited',
    'Regent infratech private limited',
    'Presido land developers private limited',
    'Marshall corporation ltd.',
    'Chintapurni estates private limited',
    'Ganpati appartments pvt ltd',
    'Super complex pvt ltd',
    'Ambamata estate and investment private limited',
    'Suvidha promoters pvt ltd',
    'Rajsonu farms and resorts private limited',
    'Vas infracon private limited',
    'Bmr properties private limited',
    'Ats realty private limited',
    'Four squares venture private limited',
    'Dhan daulat holding ltd',
    'Alipore towers pvt. ltd.',
    'Godavari properties pvt.ltd.',
    'Sai plazza private limited',
    'Venkateshwara realtors pvt ltd',
    'Sinhal infrastructure private limited',
    'Sitala infradev private limited',
    'Montreux properties private limited',
    'Central bombay cable network limited',
    'Unnatish agrodevelopers private limited',
    'Mgm minerals limited',
    'Bundl technologies private limited',
    'LEPTON SOFTWARE EXPORT & RESEARCH PRIVATE LIMITED',
    'Maxim mechatronics limited',
    'Marvellous farmhomes private limited',
    'Four squares landmarks private limited',
    'GOODKARMA HOSPITALITY PRIVATE LIMITED',
    'A b tools private limited',
    'Fusion industries limited',
    'Sun autoventure private limited',
    'LEGGETT & PLATT AUTOMOTIVE INDIA PRIVATELIMITED',
    'Maso automotives pvt ltd',
    'Dhariya infrastructure development private limited',
    'Shalin electromech private limited',
    'Cir-q-tech tako technologies private limited',
    'Roots auto products private limited',
    'Tanna cranktech private limited',
    'Dighi port limited',
    'E.C. BOSE & CO (PARADIP) PVT. LTD.',
    'M c c shipping and supply services private limited',
    'Epsom shipping india private limited',
    'Jungheinrich lift truck india private limited',
    'Apex transworld computers private limited',
    'Everest road equipments private limited',
    'Y-tec india private limited',
    'Spectrum antenna and avionics systems private limited',
    'Zebro officemate private limited',
    'TRU-SPRAG FREEWHEELS PRIVATE LIMITED',
    'Fortuna impex pvt ltd',
    'Ripal engitech private limited',
    'Vision art solutions private limited',
    'Labline equipments private limited',
    'JURONG ENGINEERING (INDIA) PRIVATE LIMITED',
    'Blue steel engineers private limited',
    'Anita medical systems pvt ltd',
    'Starfire gems private limited',
    'BB BREWMASTER VENTURES PRIVATE LIMITED',
    'Sunrise gems and jewels pvt. ltd.',
    'Iworx systems india private limited',
    'DEV',
    'S (INDIA) LIMITED',
    'Foster plus p india private limited',
    'Standard information services private limited',
    'BLUE JET HEALTHCARE LIMITED',
    'Yashdhir hotels limited',
    'Guru holding pvt ltd',
    'Som holdings and trading co pvt ltd',
    'Kamat hotels (india) ltd',
    'HFCL LIMITED',
    'BRIGHTCOM GROUP LIMITED',
    'Idfc limited',
    'Satin creditcare network limited',
    'Ashika credit capital limited',
    'Innoventive venture limited',
    'Housing development and infrastructure limited',
    'Market creators ltd',
    'Surya india limited',
    'A2z infra engineering limited',
    'Walchandnagar industries limited',
    'Ceeta industries limited',
    'Eih associated hotels limited',
    'Hester biosciences limited',
    'THAKKERS GROUP LIMITED',
    'Modi landscape private limited',
    'Global transmission private limited',
    'Prospecta nutri india private limited',
    'RAMAKRISHNA COMPONENTS MANUFACTURING PRIVATE LIMITED',
    'Sharda diesels private limited',
    'Ishan engineers & architects pvt ltd',
    'Grover zampa vineyards limited',
    'Vishavamurty farms private limited',
    'Neesa agritech and foods limited',
    'Mrigasira agros private limited',
    'Purna organics private limited',
    'Rythu mitra retail private limited',
    'Green coast nurseries india private limited',
    'Kala biotech private limited',
    'Modtec industries india private limited',
    'Balaji heavy lifters private limited',
    'Intech auto-stores and conveyors private limited',
    'Vijay fire vehicles and pumps limited',
    'Millennium technotools private limited',
    'Teksons cooling systems private limited',
    'Perfect infraengineers limited',
    'Aaryan engineering private limited',
    'Spig cooling towers india private limited',
    'Gpt vibration technology private limited',
    'Amex alloys private limited',
    'Kusum steels ltd',
    'Ranchi castings private limited',
    'Bansal ispat tubes private limited',
    'Bhagwati spares manufacturing pvt ltd',
    'Khs machinery private limited',
    'Zenith power projects private limited',
    'Areco consulting and engineering (india) private limited',
    'Sagittarius metals private limited',
    'Tejas automake private limited',
    'Nov india private limited',
    'PACIFIC MECHATRONICS PRIVATE LIMITED',
    'Saranya electronics private limited',
    'Elestar crane systems private limited',
    'Gmt engineers private limited',
    'Perfect generator technologies private limited',
    'N k multi-tech filters private limited',
    'Tracktech international private limited',
    'Swajit thermotreat private limited',
    'Suresales automation private limited',
    'Jayvik machineries pvt ltd',
    'Vac-u-max asia private limited',
    'Tam module hydraulic private limited',
    'Microtech boilers private limited',
    'Landsky engineers private limited',
    'Perfovision hydraulics private limited',
    'Meditech technologies india private limited',
    'Featherlite office systems private limited',
    'RELIANCE INSTRUMENTATION PRIVATE LIMITED',
    'Auna tools private limited',
    'Indlab equipments private limited',
    'E star engineers private limited',
    'ABS SYSTEMS & SERVICES PRIVATE LIMITED',
    'Humboldt wedag india private limited',
    'Aerostructures manufacturing india private limited',
    'Aerostructures assemblies india private limited',
    'Cemach machineries limited',
    'SRIYANTRA ENGINEERS PRIVATE LIMITED',
    'Imperial pharmachines private limited',
    'Electromech infraprojects private limited',
    'Nucleonix systems pvt.ltd.',
    'Hurco india private limited',
    'Smitvin engineers private limited',
    'Bapat controls and equipment private limited',
    'Cpl switches private limited',
    'Sumiran automations private limited',
    'Resolute resource solutions private limited',
    'Applied digital micro systems pvt ltd',
    'S.a. automation private limited',
    'Multiplex systems private limited',
    'S g suntronics power private limited',
    'Indo automotive batteries private limited',
    'ALWAR LAMPS PRIVATE LIMITED',
    'Arraystorm lighting private limited',
    'E-cosmos (india) private limited',
    'Sogo synergy private limited',
    'Icam technologies private limited',
    'Sga infraproject private limited',
    'Capture network systems private limited',
    'Intech energy systems private limited',
    'Tangent electronics private limited',
    'Lift link technologies private limited',
    'Penguin engineers & infratech private limited',
    'Metsar technologies private limited',
    'Q-SHIELD DIESEL & GAS TECHNOLOGIES PRIVATE LIMITED',
    'Hanaprotech moulding & tools private limited',
    'Trinity energy systems private limited',
    'Multitrack engineering private limited',
    'A.p.r electronics private limited',
    'Ge be private limited',
    'Tessolve semiconductor manufacturing industries private limited',
    'Kare peripherals private limited',
    'NIKKISO COSMODYNE INDIA PRIVATE LIMITED',
    'Kripa electronics ( india ) private limited',
    'Resitech electricals pvt ltd',
    'U and c batteries private limited',
    'Rig technologies private limited',
    'GETINCITY IT SERVICES PRIVATE LIMITED',
    'SONASOFT AI INDIA PRIVATE LIMITED',
    'CMAXINSIGHT MARKET INTELLIGENCE PRIVATE LIMITED',
    'SPYNET INFOCOM PRIVATE LIMITED',
    'MEP LONGJIAN CLR PRIVATE LIMITED',
    'MEP LONGJIAN LOHA WARANGA ROAD PRIVATE LIMITED',
    'SMERA RATINGS PRIVATE LIMITED',
    'NEXTGEN BRAND SPACEZ PRIVATE LIMITED',
    'BUFO INNOVATIONS PRIVATE LIMITED',
    'NUCON ALKAN AEROSPACE PRIVATE LIMITED',
    'LUCSAM ENTERPRISES PRIVATE LIMITED',
    'HICRETE TECH PRIVATE LIMITED',
    'PRAGMALYTICS TECHNOLOGIES PRIVATE LIMITED',
    'GEOSKETCH TECHNOLOGIES PRIVATE LIMITED',
    'SYMPHONI HR PRIVATE LIMITED',
    'ALPHAGEO OFFSHORE SERVICES PRIVATE LIMITED',
    'RIDGECRAFT HOMES PRIVATE LIMITED',
    'MUMBAI PUNE EXPRESSWAY LIMITED',
    'CANCCLEAR INDIA PRIVATE LIMITED',
    'BREATHLESS FILMS PRIVATE LIMITED',
    'SOFTZEMINI INFOSOLUTIONS PRIVATE LIMITED',
    'VAIJAPUR PACHOD TOLLWAYS PRIVATE LIMITED',
    'MAZIQ FARM TECHNOLOGIES PRIVATE LIMITED',
    'GRYFFINDOR ADVISORY SERVICES PRIVATE LIMITED',
    'GREENYANA SOLAR PRIVATE LIMITED',
    'MAARK PREMIUM AGRO PRODUCTS PRIVATE LIMITED',
    'UBC CARGO WORLD INDIA PRIVATE LIMITED',
    'INSIDEROOT HEALTH AND WELLNESS VENTURES PRIVATE LIMITED',
    'NOUAM TRUSS LIMITED',
    'SPARKLE TWO MALL DEVELOPERS PRIVATE LIMITED',
    'REALWEAR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ZITTERBOX SOLUTIONS PRIVATE LIMITED',
    'INTASYS CROPSCIENCE PRIVATE LIMITED',
    'RL LOGISTICS AND WAREHOUSING PRIVATE LIMITED',
    'EPOCH SPORTS AND GAMING (OPC) PRIVATE LIMITED',
    'WEAVER REAL ESTATE DEVELOPERS PRIVATE LIMITED',
    'HANA MEDICAL INDIA PRIVATE LIMITED',
    'INFOKRAFTS DATA CONSULTANCY SERVICES PRIVATE LIMITED',
    'POLL CAFE ANALYTICS PRIVATE LIMITED',
    'BMECIMAGING PRIVATE LIMITED',
    'YANJAN NEW MATERIAL INDIA PRIVATE LIMITED',
    'SMITH TUBES PRIVATE LIMITED',
    'ALPHA INFRA MANAGEMENT SERVICES PRIVATE LIMITED',
    'ESS JAY PEGASUS SPORTS FOUNDATION',
    'Home grown farm and nursery private limited',
    'Sree vindhya nurseries private limited',
    'Boganville farms private limited',
    'Vasudha farms private limited',
    'IRM INFRAPROJECTS PRIVATE LIMITED',
    'Pathrakali agro farm private limited',
    'Ess dee clean coal technologies private limited',
    'Pl agro technologies limited',
    'Agave agro (india) private limited',
    'Babu jai jessie farms private limited',
    'Xexus aqua cultures private limited',
    'Mm metal matriex private limited',
    'Ht foods private limited',
    'Aakash automobiles private limited',
    'M k c agro fresh limited',
    'Eco tech castings india private limited',
    'Patanwala dairy foods india private limited',
    'Naik oceanic exports private limited',
    'Recon oil industries private limited',
    'SAMYOG FOODS PRIVATE LIMITED',
    'Composite commodity futures private limited',
    'Pai international electronics limited',
    'Shakthi developers private limited',
    'RENAISSANCE DATACENTER PRIVATE LIMITED',
    'Krishna agrotech ltd.',
    'Snazy health products pvt ltd',
    'Majestic farm house limited',
    'Ruv2 enterprises private limited',
    'S.p.mani and mohan dairy (india) private limited',
    'Venco research and breeding farm private limited',
    'Normandy investments private limited',
    'New rok mines private limited',
    'Kalyana puri flour mills private limited',
    'Rajmahal coal mining limited',
    'Bharat stars services private limited',
    'Rajasthan hybrids private limited',
    'Leeviss enterprises private limited',
    'Bhr diagnostics private limited',
    'Racek industries private limited',
    'Hhv pumps private limited',
    'Condor power products private limited',
    'Lotemp systems private limited',
    'Protex engineering private limited',
    'Smec electronics (india) pvt ltd',
    'Maa kuthari projects private limited',
    'DOIT INNOVATIVE ATTRACTIONS (INDIA) PRIVATE LIMITED',
    'Akhuratha lifestyle services private limited',
    'Cascade exports private limited',
    'Coral shelters and holidays private limited',
    'Lulu international convention center private limited',
    'Vivaan fashions private limited',
    'Fuji royal hotels private limited',
    'Alhind holidays private limited',
    'Getner hotels pvt ltd',
    'Rtc hotels private limited',
    'Bhupati agencies private limited',
    'Homeconnect retail private limited',
    'Abil hospitality private limited',
    'Aarti medicals private limited',
    'Hotel vaigai private limited',
    'Sas hotels & enterprises limited',
    'Gunsam foods private limited',
    'Hammock leisure holidays private limited',
    'CYGNETT HOTELS & RESORTS PRIVATE LIMITED',
    'Backpackers hospitality private limited',
    'Umak resorts private limited.',
    'Hamara hotels private limited',
    'P.k delicacies private limited',
    'Parsvnath hotels limited',
    'Nishu institutional catering services private limited',
    'Brassica hospitality services private limited',
    'Stainless trading (india) limited',
    'Rajshi constructions private limited',
    'Magnolia fnb private limited',
    'Movenpick hotels and resorts management (india) private limited',
    'Pench hotel private limited',
    'Wizertech retail private limited',
    'Cubs country private limited',
    'Nita tradelinks private limited',
    'Apoorva appliances india private limited',
    'R s v industries private limited',
    'Monark dealcom private limited',
    'Marina natural resorts private limited',
    'Nature resorts and spa india private limited',
    'Vrl logistics limited',
    'Aida foods private limited',
    'SNOWFLAKE HOSPITALITY PRIVATE LIMITED',
    'Cfc logistics private limited',
    'Trv freight solutions private limited',
    'Sugam elevators private limited',
    'Shree vidyut limited',
    'Ambient solar private limited',
    'Sign technic industries private limited',
    'Mactrol automation solutions private limited',
    'Topsun energy limited',
    'Rexit technologies private limited',
    'Schematic aircon & automation private limited',
    'Westcott electricals private limited',
    'Aultra lighting systems private limited',
    'Ascon automation systems private limited',
    'ALPHA-ELSEC DEFENCE & AEROSPACE SYSTEMS PRIVATE LIMITED',
    'SWISS ELMECH PRIVATE LIMITED',
    'Y p technologies private limited',
    'VICTORA LIFTS PRIVATE LIMITED',
    'BIOMATIQUES IDENTIFICATION SOLUTIONS PRIVATE LIMITED',
    'INGETEAM INDIA PRIVATE LIMITED',
    'Sahara india electricals limited',
    'Meera agencies private limited',
    'Sharun wires private limited',
    'Tallyinfo engineering private limited',
    'Socomec ups private limited',
    'Grams electrical private limited',
    'Xprt engineered packaging solutions private limited.',
    'Rajamane and hegde services private limited',
    'Neel poweret private limited',
    'Indesys equipments private limited',
    'Bajaj power equipments private limited',
    'Infocom (india) private limited',
    'INDO POWERSYS PRIVATE LIMITED',
    'Tibrewala electromech pvt ltd',
    'Laasma power private limited',
    'Beacon industrial electronics private limited',
    'Apsom technologies (india) private limited',
    'Mindsarray technologies private limited',
    'Smarterhi communications private limited',
    'Rosmerta engineering private limited',
    'Elektromag devices private limited',
    'Visual technologies india private limited',
    'Star link communication private limited',
    'Delcom telesystems private limited',
    'Humax electronics india private limited',
    'Propack electronics private limited',
    'Relisys technologies private limited',
    'Sienna systems resources private limited',
    'Ekk eagle products india private limited',
    'G and s hi-tech engineering private limited',
    'S p i equipments india private limited',
    'Roffe impex international p ltd',
    'Veega holding and trading company limited',
    'Hamsons trading enterprises pvt ltd',
    'Twenty20 commodities private limited',
    'Dotmark vinimay private limited',
    'Acumen commodities (india) limited',
    'Mansingka industries limited',
    'MEGHRAJ IMPEX PRIVATE LIMITED',
    'A M MARKETING Private Limited',
    'Pacific security solutions private limited',
    'B.A.B. AGENCIES PRIVATE LIMITED',
    'Goodworth investments pvt ltd',
    'Pratichi vinimoy pvt ltd',
    'Worldclass gourmetfoods private limited',
    'Riteroute distribution private limited',
    'S.h.r trading private limited',
    'Interwear exports (india) private limited',
    'Chimanlal fein paper private limited',
    'Ranjana newsprint imports private limited',
    'Cns realtors private limited',
    'Yashomati comotrade private limited',
    'Somani plylam private limited',
    'Rahee viniyog limited',
    'Debdaru vinimay private limited',
    'Impexor global private limited',
    'Ampi agencies private limited',
    'Goldman commodity private limited',
    'Burzin and leons agenturen private limited',
    'Steamline industries limited',
    'Singhal commodities private limited',
    'Tracon export services private limited',
    'Bhavya impex private limited',
    'Heer pharma private limited',
    'Suprabharath exports p ltd',
    'Gulson impex private limited',
    'Drizzle trading and investments private limited',
    'Growell resources and management private limited',
    'Amon-ra impex private limited',
    'Retort exports private limited',
    'Realworth mercantile private limited',
    'Standardcon private limited',
    'Blueberry vincom private limited',
    'Mangalshiv overseas private limited',
    'Vanshika enterprises private limited',
    'Krishna kumar singh jewels private limited',
    'Ultravoilet print machinery private limited',
    'Ascon sales and services private limited',
    'Woodstock helicopters private limited',
    'First seo scrapers private limited',
    'Buddy (t-3 delhi) retail private limited',
    'Kishankanhaiya vanijya private limited',
    'Purba tea exports private limited',
    'Sunima trading private limited',
    'Subramany and co exports private limited',
    'Indus instruments impex private limited',
    'Kingstone suppliers private limited',
    'Mangalvani exports private limited',
    'Vertico fashions private limited',
    'Comfort hospitality private limited',
    'Chuo senko advertising india private limited',
    'Novitas india private limited',
    'Shree vinayak hotels private limited',
    'Savannah lifestyle private limited',
    'TBK KADAKIA',
    'S DELICIOUS PRIVATE LIMITED',
    'Kyungjoo hotel private limited',
    'Tatva hospitality private limited',
    'M far beach resorts private limited',
    'Riverdale hospitality private limited',
    'Shri s.s.hotel (india ) private limited',
    'GOAN HOTELS & REALTY PRIVATE LIMITED',
    'Rubberwala hospitality private limited',
    'Aashish hospitalities private limited',
    'WELLKEPT FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Gaurav holiday resort private limited',
    'Kohinoor elite hotels private limited',
    'Burgundy hospitality private limited',
    'Travel food services kolkata private limited',
    'Travel food services chennai private limited',
    'Shalaka foundation',
    'Lifetime learning solutions private limited',
    'World schools private limited',
    'Bml educorp services',
    'Unified learning private limited',
    'Imperial eduvision private limited',
    'Genesis learning initiatives private limited',
    'Learn guru private limited',
    'Tirumala educare private limited',
    'Islamic studies research academy pvt. ltd.',
    'Firebricks and potteries private limited',
    'Bhuruka gases limited',
    'Unique wires private limited',
    'Alpha indecors private limited',
    'Summit information technologies private limited',
    'Kalvi institute private limited',
    'D s infotech private limited',
    'Nettur technical training foundation',
    'I t contractors private limited',
    'MANIPAL HOSPITALS PRIVATE LIMITED',
    'SSSN PROJECTS PRIVATE LIMITED',
    'Sanskaar learners private limited',
    'Beyond basics learning private limited',
    'DILETTO TRAINING INSTITUTE PRIVATE LIMITED',
    'Blossom multispeciality hospitals and daycare centre private limited',
    'Reelabs private limited',
    'Begnot charity',
    'Saksham diagnostic private limited',
    'Anandi purandar medical & educational foundation',
    'GVK EMERGENCY MANAGEMENT AND RESEARCH INSTITUTE HYDERABAD',
    'Sovex health products private limited',
    'Meil foundation',
    'Western up tollway limited',
    'SMC INTEGRATED FACILITY MANAGEMENT SOLUTIONS LIMITED',
    'Smaat india private limited',
    'Amazon envirotech private limited',
    'Croplife india',
    'Safety first association of india ltd',
    'Indo-french chamber of commerce and industry.',
    'Northstar charitable foundation',
    'International copper association india',
    'Leela bharat foundation',
    'Yak management and marine education centre',
    'Biotabs lifesciences private limited',
    'Anamika healthcare private limited',
    'Imperial freight forwarders pvt ltd',
    'Titan sea and air services private limited',
    'Anubhav kargo private limited',
    'Immply india technology private limited',
    'Comptel solutions private limited',
    'Mediacom communications private limited',
    'Dbs mintek private limited',
    'Brightboxx animation and education private limited',
    'Heben chartered resources private limited',
    'Cubictree technology solutions private limited',
    'Data vectors private limited',
    'Addikiin technology private limited',
    'Bizlabs information solutions private limited',
    'Long range systems india private limited',
    'Valud softwares private limited',
    'Panini systems private limited',
    'JE SUIS WEB SOLUTIONS PRIVATE LIMITED',
    'Algo engines private limited',
    'Wwt india private limited',
    'Gbps networks private limited',
    'Heera software private limited',
    'Rotary international infotech private limited',
    'Techtrix solutions private limited',
    'Unik it private limited',
    'Velocita brand consultants private limited',
    'ANANTARA DRONE SERVICES PRIVATE LIMITED',
    'Uniken india private limited',
    'Qed42 engineering private limited',
    'Syntego global it systems private limited',
    'Sinaz techsol private limited',
    'Only b2b ites private limited',
    'Pearl technosolutions private limited',
    'Thinksmart tech india private limited',
    'Mindspeed technologies india private limited',
    'R.p.web apps private limited',
    'Euclid innovations private limited',
    'Greenbyte technologies private limited',
    'Dsquare tech labs (hyd) private limited',
    'Ibhar technologies private limited',
    'Conferencecall services india private limited',
    'FUTUREFIRST SYSTEM PRIVATE LIMITED',
    'Evince technologies private limited',
    'Skilworth technologies private limited',
    'Sensiple technologies india private limited',
    'Aroxo software private limited',
    'Suraksha polytechnic private limited',
    'Idonneous marketing services private limited',
    'Vipl infrastructure private limited',
    'Extraxa pharma private limited',
    'Prime1 events and entertainment private limited',
    'Hinditron corporate systems private limited',
    'Jhabarmal laddooram tex-fab private limited',
    'Eccentric engine private limited',
    'Dar film ventures i private limited',
    'ROYAL TRIO',
    'COUNCIL OF INDIA',
    'Yizumi precision machinery (india) technical center private limited',
    'Zocdoc online health management india private limited',
    'PENNWALT AGRITECH LIMITED',
    'Kpg steels private limited',
    'ENVALIOR INDIA PRIVATE LIMITED',
    'Fildan accessories (india) private limited',
    'V.k.a. polymers private limited',
    'Honour engineering private limited',
    'Goodluck ispat and alloys private limited',
    'Saket steels limited',
    'Doortech engineering private limited',
    'Jk fitwell private limited',
    'Utsah engineering private limited',
    'CMD PRECISION PRODUCTS PRIVATE LIMITED',
    'Prima gear cutting tools private limited',
    'Synergy polymers (india) private limited',
    'Hi-fab engineers pvt ltd',
    'Pace equipment private limited',
    'Silver techno-mech private limited',
    'Alice biotech private limited',
    'Muktai moulders private limited',
    'Locksmiths industries private limited',
    'R r luminaires private limited',
    'Kaizen composites private limited',
    'Lodhas aluminium sheet private limited',
    'Kristeel shinwa industries limited',
    'Pyramid precision engineering (india) private limited',
    'Sandhar tooling private limited',
    'KNAUF INDIA PRIVATE LIMITED',
    'Precious mineral processing systems private limited',
    'Oil tools international services private limited',
    'Fastenex private limited',
    'Metalworth industries limited',
    'Raga protek private limited',
    'Avdel (india) private limited',
    'Jai bhavani mata engitech private limited',
    'Ultra precision tools and vessels private limited',
    'Delfingen india private limited',
    'Bina merchants company private limited',
    'Tufflex hose (india) private limited',
    'Sakazaki engraving india private limited',
    'SHYAM STEEL MANUFACTURING LIMITED',
    'Amsons steels private limited',
    'R-pac (india) private limited',
    'Bhatia brothers engineering company private limited',
    'Rashmi strips private limited',
    'Samrat ispat products private limited',
    'Mc clelland engineers pvt ltd',
    'Vaaman engineers (india) limited',
    'Pan tech polycoats private limited',
    'Indaid components private limited',
    'GRANTOOLS PRIVATE LIMITED',
    'Gratefix fastening solutions private limited',
    'Aakash press parts private limited',
    'Its tooling private limited',
    'Cms manufacturing private limited',
    'TAKRAF INDIA PRIVATE LIMITED',
    'Weiss technik india private limited',
    'Right tight fastners private limited',
    'Mtc trans movers private limited',
    'Metallizers and corrosion controllers private limited',
    'Nikshepa machining technologies private limited',
    'Mahadev profiles private limited',
    'Gabbar industries private limited',
    'Cnz bearings private limited',
    'Jc valvulas india private limited',
    'Excel hydro pneumatics pvt ltd',
    'Draeger safety india private limited',
    'Sunbeam generators private limited',
    'Core hydraulics private limited',
    'Perrin valves private limited',
    'Flovel valves private limited',
    'Isotex corporation private limited',
    'Charnock equipments private limited',
    'Burckhardt compression (india) private limited',
    'Barani hydraulics india private limited',
    'Petro valves private limited',
    'Isotex projects private limited',
    'Tespa india private limited',
    'CY MYUTEC ANAND PRIVATE LIMITED',
    'Dyna drill equipment private limited',
    'Purshotam profiles private limited',
    'Clartech engineers private limited',
    'Acr instruments and valves private limited',
    'Vertex air technologies private limited',
    'Pocl enterprises limited',
    'Diligent trading co. private limited',
    'Iftex oil and chemicals limited',
    'Rapid credits and mercantiles private limited',
    'Ackruti safeguard systems private limited',
    'Chikmaglur energy projects limited',
    'Polco creations private limited',
    'Gmv agencies private limited',
    'Diamondtouch trading company private limited',
    'Dahivel energy projects private limited',
    'REFORM FIN TRADE PRIVATE LIMITED',
    'Arko enterprises private limited',
    'Reliance commercial dealers limited',
    'Sunshine tradelinks private limited',
    'Sun wave commercials private limited',
    'Ujagar trading private limited',
    'Lombard traders private limited',
    'Twison diam private limited',
    'Onfield marketing solutions private limited',
    'Strapex enterprises private limited',
    'Maruti rich ventures private limited',
    'Vincom realty india private limited',
    'Seastar shelters private limited',
    'Dove shelters private limited',
    'SMRK INVESTMENT & FINANCE PRIVATE LIMITED',
    'Hydrochem products (india) pvt ltd',
    'Si property (kerala) private limited',
    'Srilanand mansions private limited',
    'KOTA AGRI MARKET PRIVATE LIMITED',
    'P. E. ANALYTICS LIMITED',
    'UTTAM REAL ESTATES COMPANY',
    'Shri parasnath realtors private limited',
    'Hiracon properties private limited',
    'H.h.apartments holdings limited',
    'Model city creators private limited',
    'Park view residential private limited',
    'Bearys holdings private limited',
    'BEARYS GLOBAL INFOTECH PRIVATE LIMITED',
    'Dezira projects and realtors private limited',
    'SAVERA AGROTECH PRIVATE LIMITED',
    'Cosmo landbase private limited',
    'Royal propmart private limited',
    'Jbj land promoters private limited',
    'Nirmit estate pvt ltd',
    'Shugun realtors ltd',
    'ROYAL BUILDSQUARE PRIVATE LIMITED',
    'Vmsalgaocar realty private limited',
    'Chanakya software services private limited',
    'Sapeksh technologies private limited',
    'Milletech datasoft systems private limited',
    'NEWROCKET INDIA PRIVATE LIMITED',
    'Zestorm technologies private limited',
    'Core quality it management consultancy private limited',
    'ZDSB SUPPORT PRIVATE LIMITED',
    'Crimson consulting and technologies private limited',
    'Pingtel network solutions private limited',
    'NORDIC SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'R a s infotech limited',
    'Quad one technologies private limited',
    'Pllc software solutions private limited',
    'Techno endeavours private limited',
    'Travash software solutions private limited',
    'Sonar shelters limited',
    'Next sphere technologies (india) private limited',
    'Ecatalyst softech solutions private limited',
    'Eps designs india private limited',
    'Denuo source india private limited',
    'Sahaj hanalytics private limited',
    'G p it solutions private limited',
    'Omkarti software technologies private limited',
    'Adept chip services private limited',
    'VLAKSHYA SOFTSAT SOLUTIONS PRIVATE LIMITED',
    'Visionwings software private limited',
    'Vivaan technologies private limited',
    'Mainstay tech solutions private limited',
    'Data erpsystems india private limited',
    'Ishtah software solutions india private limited',
    'Everest consulting group india private limited',
    'Chennai gemini soft consultants private limited',
    'Assure eservices private limited',
    'EXCLUSIVE NETWORKS SALES INDIA PRIVATE LIMITED',
    'Logic information systems (india) private limited',
    'RAVEN360 INDIA PRIVATE LIMITED',
    'Inoryasoft private limited',
    'Gboxz technologies private limited',
    'MBF DIGITAL PRODUCTION SERVICES PRIVATE LIMITED',
    'Systech infovations private limited',
    'Speedstep software solutions (india) private limited',
    'Rmm technologies private limited',
    'Exterro r&d private limited',
    'Blue ray aviation private limited',
    'Kli freight solutions private limited',
    'Prudential cargo services private limited',
    'Joel of pearl travels private limited',
    'ECOM EXPRESS LIMITED',
    'New horizons logiware private limited',
    'Radiant x-ways logistic private limited',
    'Leeway logistics limited',
    'Nittsu shoji india private limited',
    'Mysha india services private limited',
    'Transorion logistics services private limited',
    'Spectrum supplychain solutions private limited',
    'Clarion logistics india private limited',
    'Keshavlal kalyanji & co. private limited',
    'Lirin logistics private limited',
    'Cargomen logistics (india) private limited - (part-ix)',
    'Oecl shipping and logistics private limited',
    'Savair energy limited',
    'Deepak transport agency limited',
    'Saabari logistics private limited',
    'Sonu cargo movers (india) private limited',
    'Air cargo trader private limited',
    'UNISTONE PANELS PRIVATE LIMITED',
    'Avyakth cold storages private limited',
    'Travelmanager holidays india private limited',
    'Konkan storage systems (karwar) private limited',
    'Apoorva logistics private limited',
    'Swift road link private limited',
    'Care my trip.com hospitality private limited',
    'Oasis voyages private limited',
    'Raftaar terminals private limited',
    'Glocal logistics private limited',
    'C. v. karia clearing & forwarding private limited',
    'COLDMAN LOGISTICS PRIVATE LIMITED',
    'Travel troops global private limited',
    'Eleanor shipping private limited',
    'Fonsys services private limited',
    'Portman india private limited',
    'Indo-american tourism limited',
    'PETTITT',
    'S HOTEL PRIVATE LIMITED',
    'Sr palm treat inn private limited',
    'The right ambient resorts pvt ltd',
    'Fishermans grove resorts private limited',
    'Neesa leisure limited',
    'Apex restaurants private limited',
    'Auro southland food services private limited',
    'Kuber healthfood and allied services private limited',
    'Infotainment tourz private limited',
    'WELLESLEY INFRASTRUCTURE PRIVATE LIMITED',
    'S2 royale retreat private limited',
    'Earth ocean logistics private limited',
    'Sky intex private limited',
    'Gold feather logistics private limited',
    'Trotter bees travel and living private limited',
    'IRISE INDIA PRIVATE LIMITED',
    'Manav greys exim pvt ltd',
    'Agd biomedicals private limited',
    'Parazelsus india private limited',
    'Threyes srinisons harness private limited',
    'Shell lifesciences private limited',
    'Farmachem life private limited',
    'Virtual vision private limited',
    'Meech shavotech private limited',
    'Russell finex sieves and filters private limited',
    'Bhagwati tools private limited',
    'Allies fire systems private limited',
    'Smart i electronics systems private limited',
    'Kedia texfab and industries private limited',
    'Sonal plasrub industries private limited',
    'Team interventure exports (india) private limited',
    'Pammvi aviation private limited',
    'Whirlwind marketing and exports pvt ltd',
    'Paptex trading private limited',
    'DYLAN TRADERS PRIVATE LIMITED',
    'Shavo technologies private limited',
    'Foram trading and investment private limited',
    'Heralds trading private limited',
    'GCX INDIA SERVICES LIMITED',
    'Engineers marketing company private limited',
    'M k b sales and marketing private limited',
    'Suman exports pvt ltd',
    'Forlink ventures private limited',
    'TRIDENT LIFELINE LIMITED',
    'Consumax life empowering private limited',
    'Herbolab india private limited',
    'Highseas vyapaar private limited',
    'Kraftex trading private limited',
    'Devin exim private limited',
    'Tungaloy india private limited',
    'Global international imex private limited',
    'Mukund impex and projects private limited',
    'Dmg corporation private limited',
    'Kabsons exports pvt ltd',
    'Way2 digital private limited',
    'Murlidhar trading private limited',
    'Basukinath vinimay private limited',
    'Paropkar commercial private limited',
    'Ganesh dealmark private limited',
    'Kalashsidhi vanijya private limited',
    'Jagatdhan vincom private limited',
    'Mnk consultants private limited',
    'Focus point consulting private limited',
    'TRANSCEND CAPITAL (INDIA) PRIVATE LIMITED',
    'Ascent supply chain consultants private limited',
    'Pradeep singhi financial advisors private limited',
    'Chitale advisory services private limited',
    'Liontree hr consultants private limited',
    'Niyamak advisor private limited',
    'Neuf management consultants private limited',
    'Kartavya consultants private limited',
    'Gayatri investment consultants private limited',
    'GERA REAL ESTATE PRIVATE LIMITED',
    'Ace kpo private limited',
    'Alcade engineers private limited',
    'Hb estate developers limited',
    'Satguru agro industries limited',
    'Interface auto private limited',
    'Ang india limited',
    'Classic welding products private limited',
    'Mastermind advisors private limited',
    'Arishina life sciences private limited',
    'Zipper india private limited',
    'Bhadar farms private limited',
    'Pravardhan seeds private limited',
    'Sri sai agri-bio labs private limited',
    'Skanda horticulture private limited',
    'Yashprabha agro private limited',
    'Dbm agro estates private limited',
    'Dusad agrofood private limited',
    'Thanga mayil agro private limited',
    'SUGUNA FOODS Private Limited',
    'Kallur geo-green farms private limited',
    'Geo farms private limited',
    'Mayos go green private limited',
    'Mk biofa technologies private limited',
    'Ganga poly product private limited',
    'RIDHI SIDHI ENGINEERING PRIVATE LIMITED',
    'Sajeev agri private limited',
    'Benchmarx logistic solutions private limited',
    'Silk route wines private limited',
    'Patodia farms private limited',
    'Agsri agricultural services private limited',
    'Emerging farm equipments (india) private limited',
    'Ralph agro rasayan private limited',
    'SKYLARK PROTEINS PRIVATE LIMITED',
    'RAAM AUTOBAHN INDIA PRIVATE LIMITED',
    'KGN MOBILE PRIVATE LIMITED',
    'ARYA SMART CITY PRIVATE LIMITED',
    'AWON SEMICONDUCTORS PRIVATE LIMITED',
    'PARDUS IMPEX PRIVATE LIMITED',
    'AKSHAYA SILVER MALL INDIA PRIVATE LIMITED',
    'Telangana State Civil Supplies Corporation Limited',
    'SYIFAR STEEL INDIA PRIVATE LIMITED',
    'OCTUNE PHARMA SOLUTIONS PRIVATE LIMITED',
    'Sunrita Enterprises Private Limited',
    'VRK RETAIL INDIA PRIVATE LIMITED',
    'SPOYL TECH SOLUTIONS PRIVATE LIMITED',
    'MSRM INTERNATIONAL TRADING PRIVATE LIMITED',
    'MEASURE INDIA CORPORATION PRIVATE LIMITED',
    'IKON TECH. PRIVATE LIMITED',
    'VALTECHNIK INDIA PRIVATE LIMITED',
    'BR RETAIL INDIA PRIVATE LIMITED',
    'SECUNDERABAD GOLF AND LEISURE RESORTS PRIVATE LIMITED',
    'MIRCHI HOSPITALITY PRIVATE LIMITED',
    'Trance International Hotels And Resorts Private Limited',
    'MIRCHI WILD WINGS PRIVATE LIMITED',
    'MIRCHI RESTAURANTS PRIVATE LIMITED',
    'COYATRI.COM INDIA PRIVATE LIMITED',
    'REHLAT ONLINE SERVICES PRIVATE LIMITED',
    'SMART TRAVEL SOLUTIONS PRIVATE LIMITED',
    'GVTECHNO LOGISTIC PRIVATE LIMITED',
    'NexGen Logistics Private Limited',
    'TRIPTYME TRAVELS PRIVATE LIMITED',
    'CHARITH ENTERPRISES PRIVATE LIMITED',
    'SHIPRA EQUITIES PRIVATE LIMITED',
    'SHIELD INSURANCE BROKING SOLUTIONS PRIVATE LIMITED',
    'KURAKULA',
    'S FINSOL PRIVATE LIMITED',
    'S EARTH EDUCATION SERVICES PRIVATE LIMITED',
    'PEARL POLYTUFF PRIVATE LIMITED',
    'RESOURCE SOLUTIONS INDIA PRIVATE LIMITED',
    'LIG GLOBAL FOUNDATION',
    'ALL INDIA BICYCLING FEDERATION',
    'UNICORPUS HEALTH FOUNDATION',
    'PLAYIZZON TECHNOLOGIES PRIVATE LIMITED',
    'ETEVA CONSULTING PRIVATE LIMITED',
    'PAYXFER TECHNOLOGIES PRIVATE LIMITED',
    'SCHOOL OF INSPIRATIONAL LEADERSHIP PRIVATE LIMITED',
    'H K PARAKH WELFARE FOUNDATION',
    'Enviro safety private limited',
    'Pratap research solutions private limited',
    'Lci engineering india private limited',
    'Federal shipping and logistics private limited',
    'Digital art india private limited',
    'Knr agrotech and beverages private limited',
    'Karecard solutions private limited',
    'Gramener technology solutions private limited',
    'Unique tfm services private limited',
    'Fairmacs shipping & transport services private limited',
    'Golden eagle communications limited',
    'Skylink multi media private limited',
    'Npns enterprise private limited',
    'Nippon paint (india) private limited',
    'Simar ventures private limited',
    'Optimum herbal extracts private limited',
    'Swach environment private limited',
    'Adret shipping & logistics private limited',
    'Canadian international school private limited',
    'Euroschool foundation',
    'Delhi international schools private limited',
    'Sanjay saraf educational institute private limited',
    'Premier educational establishments private limited',
    'Fortius institute of training private limited',
    'Tripada educational services private limited',
    'I s b m excellenz education private limited',
    'Gems education india private limited',
    'Jito administrative training foundation',
    'Indian school of integrated learning private limited',
    'MALKANI FAMILY FOUNDATION',
    'Posco-india steel distribution center private limited',
    'Satya fabricators pvt. ltd.',
    'EDITIN TECHNOLOGIES PRIVATE LIMITED',
    'Culcreuch exports private limited',
    'Ergomaxx (india) private limited',
    'Buhari trade international private limited',
    'Skosh commerical (india) private limited',
    'Accumax enterprises private limited',
    'Csp retail design concepts private limited',
    'Total gift solutions private limited',
    'White cube retails private limited',
    'Shree lalita safety and rescue products private limited',
    'Cell industries limited',
    'EFRESH HEALTHY FOOD HAPPY LIFE PRIVATE LIMITED',
    'PINVEST CONSULTING PRIVATE LIMITED',
    'M KITCHENS PRIVATE LIMITED',
    'ALLCLOUD ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'COLD CARE LOGISTICS PRIVATE LIMITED',
    'SPACION BUSINESS CENTRE PRIVATE LIMITED',
    'SHARP CLEANTECH INFRA PRIVATE LIMITED',
    'RURAL INSTITUTE FOR SKILL EMPOWERMENT PRIVATE LIMITED',
    'DEALON INDIA PRIVATE LIMITED',
    'ASD EDUCATION PRIVATE LIMITED',
    'PIXONIC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SUMATHI CROP SCIENCE PRIVATE LIMITED',
    'AEXPRESS MARKETING SERVICES INDIA PRIVATE LIMITED',
    'TEAMPLAY MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'RESTO MART INDIA PRIVATE LIMITED',
    'MEDECUBE HEALTHCARE INDIA PRIVATE LIMITED',
    'OCT8 BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CAVALIER LOGISTICS PRIVATE LIMITED',
    'INVEXGO SOLUTIONS PRIVATE LIMITED',
    'LOHAGARH FARMS PRIVATE LIMITED',
    'PANIIT ALUMNI REACH FOR JHARKHAND FOUNDATION',
    'LES TRANSFORMATIONS LEARNING PRIVATE LIMITED',
    'LETERS YOUTH EMPOWERMENT FOUNDATION',
    'GREEN CORPS FACILITY MANAGEMENT SERVICES PRIVATE LIMITED (OPC)',
    'FRIENDLY HOSPITALITY SOLUTIONS PRIVATE LIMITED',
    'FORESTVEDA PRODUCTS PRIVATE LIMITED',
    'ACESO PHARMA PRIVATE LIMITED',
    'MEANINGFUL DESIGN LABS PRIVATE LIMITED',
    'ACCTANK BUSINESS SERVICES PRIVATE LIMITED',
    'ALL ABOUT OUTDOOR PRIVATE LIMITED',
    'V3M TECHNOLOGIES PRIVATE LIMITED',
    'RART TECHNO VENTURE PRIVATE LIMITED',
    'TENACIOUS HR SOLUTIONS PRIVATE LIMITED',
    'APPWEBSTUDIOS TECHNOLOGIES PRIVATE LIMITED',
    'FOX DIGIT CONSULTANTS PRIVATE LIMITED',
    'DC TELEMATICS PRIVATE LIMITED',
    'TIRUPATI WORK SPACE SOLUTIONS PRIVATE LIMITED',
    'COMPANY360 PRIVATE LIMITED',
    'AVANT GARDE EDUFINTECH PRIVATE LIMITED',
    'BELA FASONADO PRIVATE LIMITED',
    'COLORCUBES DESIGNS PRIVATE LIMITED',
    'REBCO TECHNOLOGIES PRIVATE LIMITED',
    'HITECH ULTRAVIOLET PRIVATE LIMITED',
    'Magnificent infotech private limited',
    'Girija consultancy services private limited',
    'Gamooz interactive solutions private limited',
    'Safetech technologies private limited',
    'Radicle advisors private limited',
    'Sfi storefit projects private limited',
    '3e advisors private limited',
    'Ascentaz consulting private limited',
    'World one consulting private limited',
    'Amrac advisors private limited',
    'Mak v engineers private limited',
    'Encore asset reconstruction company private limited',
    'Amazin automation solutions india private limited',
    'CN IMMIGRATION SERVICES PRIVATE LIMITED',
    'INNOBINS TECHNOLOGY PRIVATE LIMITED',
    'Ventrans logistics private limited',
    'Ama services private limited',
    'Seven rays advisors private limited',
    'TQV PRIVATE LIMITED',
    'Jaysmit consultancy private limited',
    'Frontier technologies private limited',
    'A2z infraservices limited',
    'Unjha formulations limited',
    'Seya industries limited',
    'Indo amines limited',
    'DIVYASHAKTI LIMITED',
    'Tech mech international private limited',
    'Life green systems limited',
    'Sibi exports india private limited',
    'Jupiter software & systems private limited',
    'J.B.R.TECHNOLOGIES LIMITED',
    'Platinum heritage homes private limited',
    'Satkar logistics private limited',
    'Poomkudy estates and projects private limited',
    'MAHARASHTRA HYBRID SEEDS COMPANY Private Limited',
    'J k international private limited',
    'Purbanchal lumbers private limited',
    'COUNTO EQUIPMENTS AND TRADING PRIVATE LIMITED',
    'Jaipur scientific agriculture solutions private limited',
    'Mulpuri agrotech private limited',
    'Anantha seeds private limited',
    'Southern tree farms limited',
    'Restore tea (nilgiris) private limited',
    'M k tea pvt ltd',
    'Edward food research & analysis centre limited',
    'Dilsebol customized apparel private limited',
    'Bellad engineers private limited',
    'Sampark couriers private limited',
    'Integrated enterprise solutions private limited',
    'Shri r c utilities private limited',
    'Excell media private limited',
    'PLINTRON MOBILITY SOLUTIONS PRIVATE LIMITED',
    'Easwari media private limited',
    'Hipath netcom services private limited',
    'Altura financial services limited',
    'Upex express india private limited',
    'T. R. JAIN & JAIN INVESTMENTS & TRADES PVT LTD',
    'Kandhari travels private limited',
    'Unitel finance and investments private limited',
    'Datta digamber tours and travels private limited',
    'Cosmic travels & placements private limited',
    'Vardhman finstock private limited',
    'Abnl investment limited',
    'Kemfin services private limited',
    'Gold coin farmsandhousing developers limited',
    'Aswati holdingsandproperties private limited',
    'Muthoottu mini financiers limited',
    'Ocs software and engineering solutions private limited',
    'Wavenomics consultants private limited',
    'Brand navigators consulting private limited',
    'Abide consultancy services private limited',
    'Dsa electro controls private limited',
    'Prrsaar consultancy services private limited',
    'Eli knowledge services (india) private limited',
    'WARDHA MEGA FOOD PARK PRIVATE LIMITED',
    'Abir trademart private limited',
    'Innoexcel technologies private limited',
    'Softech infosol private limited',
    'R house furnishing solutions private limited',
    'India inns and motels private limited',
    'Adroitest panacea private limited',
    'Trinity outsourcing private limited',
    'LSI ENGINEERING & CONSULTANTS LIMITED',
    'Kaizen field & research services private limited',
    'Skh metals limited',
    'Crosspollen marketing services limited',
    'Infobahn international private limited',
    'Settlers engineers pvt ltd',
    'OLIVE DEVELOPMENT FOUNDATION',
    'ORDEFENCE SYSTEMS LIMITED',
    'MINDGO TECH PRIVATE LIMITED',
    'FLIPSPACES TECHNOLOGY LABS PRIVATE LIMITED',
    'QUANTIUM EXPRESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'VIRTUAL BIZ PRIVATE LIMITED (OPC)',
    'CONCRES SOLUTIONS PRIVATE LIMITED (OPC)',
    'SESHAT TECHNOLOGIES PRIVATE LIMITED',
    'ORO RETAIL PRIVATE LIMITED',
    'WPP INDIA CORPORATE SOCIAL RESPONSIBILITY FOUNDATION',
    'ALT DIGITAL MEDIA ENTERTAINMENT LIMITED',
    'TECHDEXT ENGINEERING PRIVATE LIMITED',
    'EASTREEL FILMS PRODUCTION PRIVATE LIMITED',
    'FAIR VINIMAY SERVICES PRIVATE LIMITED',
    'CONNIVIA ACCOUNTING SOLUTIONS PRIVATE LIMITED',
    'BIZARRO PROJECTS PRIVATE LIMITED',
    'COVER STORY CLOTHING LIMITED',
    'U & I VACATIONS PRIVATE LIMITED',
    'SAFFRON EARTH PRIVATE LIMITED',
    'RADIANCE SOLAR PRIVATE LIMITED',
    'PAREKH GADGETS PRIVATE LIMITED',
    'BLUEFLAME INDUSTRIES PRIVATE LIMITED',
    'PAYSENSE SERVICES INDIA PRIVATE LIMITED',
    'CURIOSITY GYM PRIVATE LIMITED',
    'RAJVI EXPORTS PRIVATE LIMITED',
    'ARVIND FOUNDATION',
    'QUINNOX SOCIAL WELFARE FOUNDATION',
    'GOLDSTAB SOCIAL WELFARE FOUNDATION',
    'SURYA IVF CLINIC PRIVATE LIMITED',
    'MINDCRESCENT WELLNESS VENTURES PRIVATE LIMITED',
    'OPTIVA THERAPEUTICS PRIVATE LIMITED',
    'SRI SAI TELECASTING PRIVATE LIMITED',
    'MARATHWADA PHARMA CLUSTER',
    'MERLIN ENTERTAINMENTS INDIA PRIVATE LIMITED',
    'SPORTYTRIP EXPERIENCES PRIVATE LIMITED',
    'STEEL USERS FEDERATION OF INDIA',
    'KJF VYWASAY SHRUJAN FOUNDATION',
    'RENES SPORTS MANAGEMENT PRIVATE LIMITED',
    'HERMES SPORTS ACADEMY INDIA PRIVATE LIMITED',
    'MOKSHA MARGHAM BROADCASTING PRIVATE LIMITED',
    'ATECSOFT TECHNOLOGIES PRIVATE LIMITED',
    'CST TRAINING AND DEVELOPMENT PRIVATE LIMITED',
    'SOOTHE HEALTHCARE DIAGNOSTICS PRIVATE LIMITED',
    'NEW FARIDABAD INDUSTRIAL AREA ASSOCIATION',
    'Akisons corporate solutions private limited',
    'Gemini professional services private limited',
    'Santech cybernetics private limited',
    'Xylem resource management private limited',
    'Mitraz financial services private limited',
    'Harbans lal consultants private limited',
    'Multi decor india private limited',
    'Magnusinnovative technical services private limited',
    'Euro-arch systems and solutions private limited',
    'Kd&p content & consultancy private limited',
    'Axis consultants (india) private limited',
    'Mechatronics control equipments india private limited',
    'Aka logistics private limited',
    'Jakson engineers limited',
    'Alankit assignments limited',
    'Design system (india) private limited',
    'Idi designs private limited',
    'Prakruti projects private limited',
    'Padaria consultants private limited',
    'Aminbhavi and hegde consulting engineers private limited',
    'Indian scientific innovation company limited.',
    'Education design architects india private limited',
    'B r herman and mohatta (varunee) private limited',
    'Nautilus maritime company private limited',
    'DENTSU ADVERTISING AND MEDIA SERVICES INDIA PRIVATE LIMITED',
    'M d graphics private limited',
    'Concept makerz events private limited',
    'Business studio private limited',
    'Enspar energy solutions private limited',
    'S subrahmanyan construction company private limited',
    'U-TECH CONSULTANTS & ENGINEERS PRIVATE LIMITED',
    'Aqua omega services private limited',
    'Amptronics techno private limited',
    'Icon medical systems private limited',
    'Global tenders services private limited',
    'Om netstore private limited',
    'Zentora overseas careers private limited',
    'Calantha retail private limited',
    'Sam consultancy services private limited',
    'Pricewaterhousecoopers private limited',
    'Eco valley farms and foods limited',
    'Parvati industries private limited',
    'Sima marine india private limited',
    'Bnx shipping private limited',
    'Tristar multimodel logistics private limited.',
    'Ych logistics (india) private limited',
    '68m hospitality services private limited',
    'Angre port private limited',
    'Travel club (india) private limited',
    'Hungry bags private limited',
    'BEX TRAVEL INDIA PRIVATE LIMITED',
    'Puneet agency private limited',
    'Linfox logistics (india) private limited',
    'E-fleet systems private limited',
    'Shree shipping logistics and clearing services private limited',
    'Metaminds travel and tours private limited',
    'Carona selvin travels private limited',
    'Ota falloons forwarders private limited',
    'Theme logistics and management private limited',
    'Anand freight overseas pvt ltd',
    'Star freight private limited',
    'Alpha cargo express private limited',
    'Tribune impex private limited',
    'C.h. robinson international (india) private limited',
    'Micropark logistics private limited',
    'Index logistics private limited',
    'Kanse enterprises private limited',
    'Sahakar logistics private limited',
    'NATIONWIDE SHIPPING SERVICES LIMITED',
    'R.g.shipping and logistics private limited',
    'Wagon rent a cab (india) private limited',
    'Manilal patel clearing forwarding (madras) private limited',
    'Worldgate express lines international private limited',
    'Leisure cargo india private limited',
    'Elite shipping agencies india private limited',
    'VICHARE EXPRESS & LOGISTICS PRIVATE LIMITED',
    'Discus it private limited',
    'Scarlet wireless india private limited',
    'Figrovin communication services private limited',
    'Cable solutions private limited',
    'Tirupati balaji estates private limited',
    'Maahi milk producer company limited',
    'Asia seed india private limited',
    'Asia farm-n-agro private limited',
    'Parvin cotgin private limited',
    'Foodquest private limited',
    'Mark international foods stuff private limited',
    'Taj agro commodities private limited',
    'Amul industries private limited',
    'Samigo mineral private limited',
    'M h foods private limited',
    'Aseptic fruit products india private limited',
    'K1 BEVERAGES PRIVATE LIMITED',
    'Salampuria agrotech private limited',
    'Emperor foodex limited',
    'Virginia mining resources private limited',
    'Hyderabad lithotriplsy centre private limited',
    'OOOH FACTORY PRIVATE LIMITED',
    'NATURES ORGANIC PRODUCTS (SARISKA) PRIVATE LIMITED',
    'Snow white dairy products limited',
    'Krayons entertainment private limited',
    'Goa orchids private limited',
    'Natco aqua limited',
    'SUNAHRI MULTI GRAIN PRIVATE LIMITED',
    'Agarmet international pvt ltd',
    'Mono orion foods india private limited',
    'Terai foods private limited',
    'BAMBINO PASTA FOOD INDUSTRIES PRIVATE LIMITED',
    'Compassionate choices private limited',
    'Vishal natural food products india private limited',
    'Food and joy limited',
    'Kannikattu food products industries private limited',
    'K k s k greenfields private limited',
    'Zam zam fisheries private limited',
    'Pride machine tools private limited',
    'Janta wafers private limited',
    'SASTASUNDAR HEALTHBUDDY LIMITED',
    'L r foods private limited',
    'Induss farm house products pvt.ltd.',
    'Vindhya basini enterprises private limited',
    'Shreevastava industries private limited',
    'Mukteshwar sugar mills limited',
    'TROPFRUIT PRODUCTS PRIVATE LIMITED',
    'Rupasi bangla agro industries private limited',
    'Unimass agrotech india limited',
    'True agri products private limited',
    'Green valley agro plantations private limited',
    'Aura software private limited',
    'Yours food private limited',
    'S V WINES PRIVATE LIMITED',
    'NPU REALESTATE PRIVATE LIMITED',
    'TANUSHRI BUILDCON PRIVATE LIMITED',
    'DEVESH REAL ESTATES PRIVATE LIMITED',
    'NUPUR REAL ESTATES PRIVATE LIMITED',
    'Kumbhi Infraheights Private Limited',
    'Kutra Infraheights Private Limited',
    'Nigohi Infraheights Private Limited',
    'Keshi Infraheight Private Limited',
    'Baijnath Ramnath Infra Private Limited',
    'OMANSH BUILDTECH PRIVATE LIMITED',
    'KSM EXPORTS LIMITED',
    'MATHURA PRASAD MUNNA LAL PRIVATE LIMITED',
    'B.N.A. COMPUTER STATIONERY PRIVATE LIMITED',
    'DYNACON SYSTEMS LIMITED',
    'INFO CARE DIGITAL SYSTEM PRIVATE LIMITED',
    'KMP TECHNOLOGIES PRIVATE LIMITED',
    'TIMES IT PROJECTS LIMITED',
    'ABHINAV CALL CENTRE PRIVATE LIMITED',
    'MITTAL INFOSYSTEMS PRIVATE LIMITED',
    'Adroit Infosystems Private Limited',
    'DATAMAN COMPUTER SYSTEMS PRIVATE LIMITED',
    'LOGICNEXT SOFTWARES & SERVICES PRIVATE LIMITED',
    'TOTAL INFOWAVE SOLUTIONS PRIVATE LIMITED',
    'CWS TECHNOLOGY PRIVATE LIMITED',
    'ORANE INFOSYSTEMS PRIVATE LIMITED',
    'CALORIS PLANITIA TECHNOLOGIES PRIVATE LIMITED',
    'SAGRY HEALTH CARE PRIVATE LIMITED',
    'ABHISHT BUILDCON PRIVATE LIMITED',
    'PAS INFRADEVELOPERS PRIVATE LIMITED',
    'SURAJ INFRAVENTURES PRIVATE LIMITED',
    'LPM CONSTRUCTIONS PRIVATE LIMITED',
    'ANEE SHRI SAI INFRA PRIVATE LIMITED',
    'KAUSTUBH INFRAPROJECTS PRIVATE LIMITED',
    'UrbanDoor Infratech Private Limited',
    'MACVISION INFRASTRUCTURE AND DEVELOPERS PRIVATE LIMITED',
    'SHIELDFIRST INFRASTRUCTURE AND SERVICES PRIVATE LIMITED',
    'DEOBAND HIGHWAYS PRIVATE LIMITED',
    'BNRL NEXTGEN AUTO PRIVATE LIMITED',
    'MG AUTOSALES PRIVATE LIMITED',
    'BEEKAY PARTS BAZAAR PRIVATE LIMITED',
    'MG CHARIOTS PRIVATE LIMITED',
    'MOPED HOUSE PRIVATE LIMITED',
    'VISHAL CARS PRIVATE LIMITED',
    'SAIBABA CAR SALES PRIVATE LIMITED',
    'RAMOM MOTION AUTOCORP PRIVATE LIMITED',
    'Anubhav autos private ltd.',
    'Sunshine kitchens private limited',
    'Nlmk india service center private limited',
    'Pearlite liners private limited',
    'Inteva products india automotive private limited',
    'Marvel technology & tools private limited',
    'MITSUBA INDIA PRIVATE LIMITED',
    'Hiacme automations india private limited',
    'M. p. enterprises & associates limited',
    'Oceanic shipyard limited',
    'Eastnet logistics and trading private limited',
    'Samudra shipyard private limited',
    'Riviera securities and finance limited',
    'Deccan coach builders private limited',
    'JAYANT INFRATECH LIMITED',
    'Daisy motors private limited',
    'L g electronics india private limited',
    'Sriram universal private limited',
    'Mitras bikes private limited',
    'Triumph auto private limited',
    'Fincantieri india private limited',
    'Jayessar equipment private limited',
    'Nacson electronics private limited',
    'Dencap electronics private limited',
    'Accutech business systems private limited',
    'Fiberhome india private limited',
    'Phoenix malvestio healthcare products private limited',
    'Nipro india corporation private limited',
    'Advanced sys-tek private limited',
    'Kalabhai dental private limited',
    'Ruby hall clinic services private limited',
    'GOLD PALACE PROPERTIES PRIVATE LIMITED',
    'Core jewellery private limited',
    'Shah time and jewels private limited',
    'Vision medicaid equipments private limited',
    'Air liquide medical systems private limited',
    'Jobelle home & hospitality private limited',
    'Novo modular furniture india private limited',
    'South india watch industries private limited',
    'Fortpoint automotive (cars) private limited (cn)',
    'Lally motors india private limited',
    'Nextmotive motors private limited',
    'Sonatapes private limited',
    'Zetek castings private limited',
    'R b agarwalla & company private limited',
    'NALCO METAL PRODUCTS LTD',
    'Durall building systems private limited',
    'Toyoda gosei minda india private limited',
    'Acero nutech structurals private limited',
    'ELLIOT PROJECTS PRIVATE LIMITED',
    'Ayoki fabtech private limited',
    'STEELLIFE KITCHENS & RAILS PRIVATE LIMITED',
    'Hosemasters industrial connectors private limited',
    'Addlife coating systems private limited',
    'STRUTSOL ENERGY PRIVATE LIMITED',
    'Pinnacle industrial controls private limited',
    'Chennai container terminal private limited',
    'Omni industrial packaging private limited',
    'Meena jewellers extension private limited',
    'Tpc engineering & projects private limited',
    'Theertha industries private limited',
    'Ams engineering industries india private limited',
    'Trinity engineers private limited',
    'Vew engineering projects private limited',
    'Hamex engineering private limited',
    'Simran technocrats (india) private limited',
    'Sundaram dynacast private limited',
    'Tristar forge and allied industries private limited',
    'Tmx precision tooling (india) private limited',
    'D.m. metalloys private limited',
    'Mercury precision products private limited',
    'Tri-wall pak private limited',
    'Aswad engineering private limited',
    'Harsha engineering (bangalore) private limited',
    'Asaco private limited',
    'Mahadev building systems private limited',
    'Prakash engitech private limited',
    'Apollo screens private limited',
    'Shree harikrishna hardware private limited',
    'Enviro control systems private limited',
    'Saptha innovations private limited',
    'M. g. automotives private limited',
    'Titan crushing machinery private limited',
    'Sidhansh electronics private limited',
    'Iry engineering private limited',
    'Accrue conveyor products private limited',
    'Sidhartha tools private limited',
    'R c fabrics private limited',
    'Security shoppe (india) private limited',
    'Nfc leasing and finance co private limited',
    'Karn securities private limited',
    'Star exim private limited',
    'Callida electricals private limited',
    'Hari consolidated private limited',
    'Esteem consultants private limited',
    'Vls asset management limited',
    'Jbm international limited',
    'Puri oil mills limited.',
    'De bono flexcom india limited',
    'Tps infrastructure limited',
    'Dirco polymers private limited',
    'Ercom engineers private limited',
    'Trinidhi finance private limited',
    'Dantal engineering private limited',
    'Brm industries private limited',
    'Hardicon limited',
    'Continental polymers private limited',
    'Batra worldwide private ltd',
    'Mirdula detergents private limited',
    'Kohli builders and developers private ltd',
    'Vlcc health care limited',
    'RAJDARBAR SECURITIES PRIVATE LIMITED',
    'Modern indexpo limited',
    'Lynx enterprises private limited',
    'Paper creations india private limited',
    'Axis designers private limited',
    'Shotam instruments pvt l td',
    'MATRIX NET ON LINE PRIVATE LIMITED',
    'Digital dispatch (india) private limited',
    'Sa research services private limited',
    'Prageu events & marketing services private limited',
    'Sarda international limited tfr. from kolkata to delhi',
    'Skyline cargo agents private limited',
    'Yorco sales private limited',
    'Kunj electronics and electricals pvt ltd',
    'Prodigy communications and marketing private limited',
    'United finsec private limited',
    'Cwick cargo carriers private limited',
    'Kusuma foundation',
    'Jindal home decor private limited',
    'NAWAZINDA TOTAL TECHNOLOGIES LIMITED',
    'Fariyas hotels private limited',
    'L c systems private limited',
    'Gurmon hotels private limited',
    'Swastik welcare & entertainment private limited',
    'Savshanti hotels pvt ltd',
    'Silver leaf hotels private limited',
    'Monarch plaza comforts private limited',
    'SUNRISE AGRO SEEDS PRIVATE LIMITED',
    'WELBILT FOODSERVICE INDIA PRIVATE LIMITED',
    'JOHREI BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VMAK RESEARCH AND SERVICES PRIVATE LIMITED',
    'SHANONS MARKETING SOLUTIONS PRIVATE LIMITED',
    'MACRAAN TELECOM SERVICES PRIVATE LIMITED',
    'SUBHENDU FASHIONVIBES OPC PRIVATE LIMITED',
    'PEARLS ONLINE COMMERCE PRIVATE LIMITED',
    'VECTOR RETAIL PRIVATE LIMITED',
    'GPA RETAIL PRIVATE LIMITED',
    'SWAPNICA EXIM TRADING SOLUTIONS PRIVATE LIMITED',
    'SERO IMPEX PRIVATE LIMITED',
    'IN HOUZ RETAIL PRIVATE LIMITED',
    'DRUGG MEDICAL STORES PRIVATE LIMITED',
    'HERBSPRO INDIA PRIVATE LIMITED',
    'CLOUDFOREST E-COMMERCE PRIVATE LIMITED',
    'ARGHYAM RETAIL SERVICES PRIVATE LIMITED',
    'EDIFY INSURANCE BROKERS PRIVATE LIMITED',
    'ARKA INSURANCE BROKING PRIVATE LIMITED',
    'KINGSMAN PROPERTIES PRIVATE LIMITED',
    'RED TREE ESTATES PRIVATE LIMITED',
    'EXD FIVE RINGS PRIVATE LIMITED',
    'RUPEEK FINTECH PRIVATE LIMITED',
    'WW FINANCIAL DISTRIBUTION PRIVATE LIMITED',
    'DHFL ADVISORY & INVESTMENTS PRIVATE LIMITED',
    'MOBIKWIK INVESTMENT ADVISER PRIVATE LIMITED',
    'REDDY URBAN INFRA PRIVATE LIMITED',
    'KAIROS CAPITAL PRIVATE LIMITED',
    'ACTIVEDATA PRIVATE LIMITED',
    'VIVAAN PROPERTIES INDIA PRIVATE LIMITED',
    'INNOVAGE INVESTMENT ADVISERS PRIVATE LIMITED',
    'ONLINE FOREXPORT BUSINESS PRIVATE LIMITED',
    'ORBITOL INVESTMENTS PRIVATE LIMITED',
    'REGNUM CAPITAL ADVISORS PRIVATE LIMITED',
    'RAMKRISHNA FINLEASE PRIVATE LIMITED',
    'DP TRADE KING PRIVATE LIMITED',
    'REDDY HABITAT PRIVATE LIMITED',
    'Paramount apparels private limited',
    'JULIET INDUSTRIES PRIVATE LIMITED',
    'SANDS SYNERGY PRIVATE LIMITED',
    'Istaa fashions private limited',
    'Hasbro clothing private limited',
    'Unitex international private limited',
    'Trigger apparels limited',
    'Manimalar fabrics india private limited',
    'Phenomena overseas private limited',
    'Earthbags export private limited',
    'Click clothing company private limited',
    'Sma fashions private limited',
    'Vogue nero global private limited',
    'Ahuja clothiers private limited',
    'F-STUDIO FASHION PRIVATE LIMITED',
    'Turquoise & gold apparels private limited',
    'Id overseas private limited',
    'Mandhana-wd limited',
    'Burnt umber fashion private limited',
    'Vishal tanneries private limited',
    'Jafra insoles india private limited',
    'Amity leather international private limited',
    'Jsd accessories private limited',
    'Hi-life marktech private limited',
    'K m a finished leathers private limited',
    'Action udhyog private limited',
    'Canvas shoe co (goa) private limited',
    'DEEP LEATHER (INDIA) PRIVATE LIMITED',
    'Shyama jewels private limited',
    'Sunshine plywood private limited',
    'Mayur ply industries private limited',
    'Himachal plywoods private limited',
    'Satyam vincom private limited',
    'Shivmanngal industries private limited',
    'Mangal papers private limited',
    'GRAMOX PAPER AND BOARDS PRIVATE LIMITED',
    'Smm paper marketing private limited',
    'Vidarbha stores packaging company private limited',
    'Milano papers private limited',
    'Devi paper tubes private limited',
    'Bajaj carbon limited',
    'Super cones india private limited',
    'Peninsula publications and studio private limited',
    'Sonnenblume ventures private limited',
    'Professional publications private limited',
    'Baya Global Product Trader Private Limited',
    'NILAY CITY HOMES SITAPUR PRIVATE LIMITED',
    'AVANCAR TRADE ADVISORS PRIVATE LIMITED',
    'BEEAAR AUTOWHEELS INDIA PRIVATE LIMITED',
    'ANK HOTELS PRIVATE LIMITED',
    'ARIF INDUSTRIES Private Limited',
    'ARIF COMFORTS PRIVATE LIMITED',
    'GREAT VALUE HOTELS Private LIMITED.',
    'MERA MANN HOTELS PRIVATE LIMITED',
    'HOMELIKE MOTELS AND RESORTS PRIVATE LIMITED',
    'FORTUNA MOTELS AND HOLIDAY HOMES PRIVATE LIMITED',
    'UPAL HOTELS PRIVATE LIMITED',
    'Hotel Harshikhar Private Limited',
    'ImperialHeritage Hotels Private Limited',
    'LUXUS HOSPITALITY PRIVATE LIMITED',
    'PRASAD HERITAGE PROJECTS PRIVATE LIMITED',
    'TANU SHREE HOTELS PRIVATE LIMITED',
    'Sunshine Teahouse Private Limited',
    'CHEF CUISINE RESTAURANTS PRIVATE LIMITED',
    'ADDISON INDUSTRIES PRIVATE LIMITED',
    'MEHRAB LOGISTICS AND AVIATION LIMITED',
    'UTTAR PRADESH METRO RAIL CORPORATION LIMITED',
    'BAYHAAR SHIPPING PRIVATE LIMITED',
    'ERA SHIPPING PRIVATE LIMITED',
    'LUCKNOW KANPUR GOODS CARRIERS PRIVATE LIMITED',
    'VERTEX SHIPS PRIVATE LIMITED',
    'LAXMI FOODS AND STORAGES PRIVATE LIMITED',
    'SARASWATI TRAVELS PRIVATE LIMITED',
    'MAYFAIR AIRTRAVEL SERVICES PRIVATE LIMITED',
    'VITAL INDIA SUPPLY CHAIN PRIVATE LIMITED',
    'SARVESHSACHAN TOURS & TRAVELS PRIVATE LIMITED',
    'SIMPLY INDIA HOLIDAYS PRIVATE LIMITED',
    'SIMPLYYATRA TOUR TRAVELS PRIVATE LIMITED',
    'A & A PACKERS PRIVATE LIMITED',
    'RELIABLE TRIP PRIVATE LIMITED',
    'Muzztech Wireless Private Limited',
    'SIKKA INTERNET PRIVATE LIMITED',
    'MALIKA INFOCOMM PRIVATE LIMITED',
    'THE PRADESHIYA INDUSTRIAL AND INVESTMENT CORPORATION OF UTTAR PRADESH LIMITED',
    'BARSANA MOTOR FINANCE PRIVATE LIMITED',
    'LAKSHAYA HOSTEL PRIVATE LIMITED',
    'SHREE BALAJI AROMATICS PRIVATE LIMITED',
    'CHADHA RUBBER PRIVATE LIMITED',
    'RAM GANGA CEMENT PRIVATE LIMITED',
    'Vikram housing pvt ltd',
    'Kwality constructions pvt ltd',
    'Bawa developers private limited',
    'Palmspring estates private limited',
    'Powai vihar developers private limited',
    'Sharanam hotels and resorts private limited',
    'Subhash buildcon private limited',
    'Citylights developers private limited',
    'Campmasters infrastructure services private limited',
    'Blue stone properties private limited',
    'Psj infrastructures private limited',
    'Kalindi developers private limited',
    'Dighi project development company ltd',
    'Lokhandwala infrastructure pvt ltd',
    'Vardhman home developers private limited',
    'Vardhman growmore developers private limited',
    'Essvee urban development private limited',
    'Phoenix structural and engineering private limited',
    'Atal buildwell private limited',
    'Kamalnath universal private limited',
    'Fieldstone construction private limited',
    'Bhandari buildcon private limited',
    'Rohan rajdeep rajasthan infra projects limited',
    'Majestique landmarks private limited',
    'Phoenix ventures private limited',
    'Gh reddy and associates (construction) private limited',
    'Facet construction engineering private limited',
    'PRABHATAM INTERNET LIMITED',
    'Parbati koldam transmission company limited',
    'Lachung hydro power private limited',
    'Vinirrmaa energy generation private limited',
    'Viaton energy private limited',
    'Sumathi infratech private limited',
    'Jsc ec ues private limited',
    'Scj developers private limited',
    'Montealto indure energy private limited',
    'Eden infracon private limited',
    'Eden infrabuild private limited',
    'Omegga power industry private limited',
    'Today homes and infrastructure private limited',
    'Vishnu realtors pvt ltd',
    'Satish buildwell private limited',
    'Pawanputra estates private limited',
    'Utopia energy private limited',
    'ROYCE DEVELOPERS PRIVATE LIMITED',
    'ANTRIKSH LIFESPACES PRIVATE LIMITED',
    'SKYLIGHT ADVISORS PRIVATE LIMITED (OPC)',
    'ESSEL HOUSING AND INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED',
    'HOUSEWISE SERVICES PRIVATE LIMITED',
    'SAMRIDDHIREAL MART PRIVATE LIMITED',
    'VINAYAKA SHOPPING COMPLEX PRIVATE LIMITED',
    'GREAT SANDS PROPERTIES PRIVATE LIMITED',
    'GN REALTECH PRIVATE LIMITED',
    'BRVS BUILDTECH PRIVATE LIMITED',
    'KRAM INFRACON PRIVATE LIMITED',
    'GREEN GROVE PROMOTERS PRIVATE LIMITED',
    'SANVIKA ESTATES PRIVATE LIMITED',
    'ORIGINAL INFRAVENTURES PRIVATE LIMITED',
    'HAPPYHOMESS CONSULTANCY PRIVATE LIMITED',
    'VALION E ASSETS PRIVATE LIMITED',
    'TRUSTMORE TECHNOLOGIES PRIVATE LIMITED',
    'FUNDZPARK FINTECH PRIVATE LIMITED',
    'NP RESIDENCIES PRIVATE LIMITED',
    'NP LIVING PRIVATE LIMITED',
    'IBMS SOLUTIONS PRIVATE LIMITED',
    'OM MINERALS & REALTORS PRIVATE LIMITED',
    'HSA FINANCE NIDHI LIMITED',
    'VTP VENTURES PRIVATE LIMITED',
    'CAPITAL RENTXZ LIVING SOLUTION PRIVATE LIMITED',
    'PROVIDENCE HOLDINGS PRIVATE LIMITED',
    'INDITRADE MICROFINANCE LIMITED',
    'DARSHITA BUILD-CON PRIVATE LIMITED',
    'SAVILLS PROPERTY SERVICES (INDIA) PRIVATE LIMITED',
    'PROPERTYSHARE ONLINE PLATFORM PRIVATE LIMITED',
    'LINKING SPACES TECHNOLOGIES PRIVATE LIMITED',
    'STERLING URBAN VENTURES PRIVATE LIMITED',
    'PUTHIYAVEETIL PROPERTIES PRIVATE LIMITED',
    'HUMAN MICRO SYSTEMS PRIVATE LIMITED',
    'IBJA KNOWLEDGE PARK LIMITED',
    'RUPA RENAISSANCE LIMITED',
    'SURFERS PROPERTIES PRIVATE LIMITED',
    'DEVAPPSYS IT SOLUTIONS PRIVATE LIMITED',
    'KRISH SOFTWARE SERVICES (INDIA) PRIVATE LIMITED',
    'NAVAN LABS INDIA PRIVATE LIMITED',
    'SUMERU ENTERPRISE TIGER BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RPNC SYSTEMS PRIVATE LIMITED',
    'CJP TECHNOLOGIES PRIVATE LIMITED',
    'BLAS-CONNECT IT SERVICES PRIVATE LIMITED',
    'Nkp infrastructure private limited',
    'Swastik homebuild private limited',
    'Haven foundations private limited',
    'Amalgam investments private limited',
    'Mitul-sanjay holding private limited',
    'Khaire kenjale investments pvt ltd',
    'Belindia finance and investments private limited',
    'Mahindra holdings limited',
    'Indus investments private limited',
    'Shanu pai panandiker trading and investment company private limited',
    'Nad investments private limited',
    'Chandramauli investments private limited',
    'Friends mercantile private limited',
    'Vesna investment and trading company private limited',
    'Shri hari textiles private limited',
    'Ansu securities private limited',
    'Pmc securities private limited',
    'Edelgive foundation',
    'Utopia ventures private limited',
    'Dante investments private limited',
    'R.v.mercantile private limited',
    'Chartered finance & leasing ltd.',
    'Hansom finance and trading private limited',
    'Akshata fintrade private limited',
    'Varun automobiles private limited',
    'Zoom insurance brokers private limited',
    'CASTELLAR INFRA PROJECTS PRIVATE LIMITED',
    'Edelweiss tokio life insurance company limited',
    'Jakkur technoparks private limited',
    'Cholamandalam ms general insurance company limited',
    'Edelweiss asset reconstruction company limited',
    'Edelweiss global wealth management limited',
    'Geo metal resources private limited',
    'Larc commercials private limited',
    'Libra motor finance private limited',
    'Ficc capital private limited',
    'Luhariwala finance and investment private ltd',
    'Shell share brokers private limited.',
    'Shyamal fin-vest (india) limited',
    'A b resorts and restaurants private limited',
    'ASIALINK ADVISORS INDIA PRIVATE LIMITED',
    'CGS-CIMB SECURITIES (INDIA) PRIVATE LIMITED',
    'Pandu finance and investments private limited',
    'Pugalia wollen mills private limited',
    'Cosmos twisters private limited',
    'Jiwrajka synthetics private limited',
    'Adiba fashions private limited',
    'MAHALAXMI SPINNING & WEAVING MILLS PRIVATE LIMITED',
    'Balaji attire private limited',
    'Pahari mata fashions private limited',
    'Deccan designs (india) private limited',
    'Blaze clothing (india) private limited',
    'R k garments private limited',
    'Garment valley (india) private limited',
    'Kgk creations processing private limited',
    'Shringar creations private limited',
    'S k m fabrics (amana) limited',
    'APPAREL GROUP INDIA PRIVATE LIMITED',
    'Mascot fashions private limited',
    'Sree iswarya textiles private limited',
    'Salasar denims private limited',
    'Don and julio worldwide apparels (india) private limited',
    'Rajguru creations private limited',
    'Tata international gst autoleather limited',
    'Zermatt shoes private limited',
    'Bainite machines private limited',
    'Eco wooden homes constructions private limited',
    'EAST INDIA FURNITURE PRIVATE LIMITED',
    'BOLLANT INDUSTRIES PRIVATE LIMITED',
    'Grolier international private limited',
    'Dm paper products india private limited',
    'Makwuds india private limited',
    'Mayura packaging private limited',
    'HUHTAMAKI FOODSERVICE PACKAGING INDIA PRIVATE LIMITED',
    'NEXT GEN PUBLISHING Private Limited',
    'Win creatives india private limited',
    'Vyapari mitra publications private limited',
    'Csi publications',
    'Bloomsbury publishing india private limited',
    'K sera sera box office private limited',
    'Soundroom lifestyle technologies private limited',
    'DITECH PUBLISHING SERVICES PRIVATE LIMITED',
    'AADHAN MEDIA PRIVATE LIMITED',
    'Regencyy coal & energy private limited',
    'Axens india private limited',
    'PEHAL PHARMA AND CHEMICALS INDIA LIMITED',
    'Alfa chemo plast private limited',
    'Maruti koatsu cylinders limited',
    'Corey organics private limited',
    'Anju phytochemicals private limited',
    'Podar textiles (daman) private limited',
    'Glide chem private limited',
    'Earnest john drugs and chemicals private limited',
    'Leslie agrochem private limited',
    'Nisha colour chem private limited',
    'Hi- tech inks private limited',
    'Srishti packaging private limited',
    'Vigneswara paints private limited',
    'Neptune chempastel private limited',
    'Sugen life sciences private limited',
    'Systole remedies private limited',
    'SAMRISA INFOTECH PRIVATE LIMITED',
    'Lavender pharmaceuticals private limited',
    'Satyajit chemicals private limited',
    'Hitech laboratories private limited',
    'Jubailo chem private limited',
    'Kopran research laboratories limited',
    'Aksitech life sciences private limited',
    'Deep finechem private limited',
    'Novopharm life sciences private limited',
    'Intas pharmaceuticals limited',
    'Ayulabs private limited',
    'Meck pharmachem limited',
    'Maxo (india) pharmachem pvt ltd',
    'Aishani builders private limited',
    'Zota health care limited',
    'Sangrose laboratories private limited',
    'Magbro health care private limited',
    'Felix pharmaceuticals private limited',
    'East coast organics private limited',
    'Sisco medicals device private limited',
    'Vanan pharma private limited',
    'Suncare formulations private limited',
    'Aestus pharmaceuticals india limited',
    'Nicholas healthcare limited',
    'Synmedic laboratories private limited',
    'Lenimen biotech private limited',
    'Deccan nutraceuticals private limited',
    'Rawal promoters and developers private limited',
    'Sandwoods infratech projects private limited',
    'Chandralekha infrastructure private limited',
    'Gkb buildestates private limited',
    'Insync tech - fin solutions limited',
    'Rkdk corporation limited',
    'Mohta holdings pvt ltd',
    'Vestin forex private limited',
    'Kaveri hire purchase and deposits private limited',
    'Suraksha insurance brokers private limited',
    'Blue crest insurance broking pvt. ltd.',
    'Metlife services east private limited',
    'MY COVER RISK INSURANCE BROKERS PRIVATE LIMITED',
    'Kapilesh stock holding pvt ltd',
    'Mohta securities pvt ltd',
    'Shree shyam devcon private limited',
    'Mecpro infratech private limited',
    'Lingaraj portfolios private limited',
    'Maak holdings private limited',
    'A2z infraheights private limited',
    'Light infrastructure private limited',
    'Twenty first realtors private limited',
    'Regal dwellings private limited',
    'Windy investments private limited',
    'L and s design concepts private limited',
    'Poluchem consultancy services private limited',
    'Pavan structurals pvt ltd',
    'R shroff consultants private limited',
    'Eskayem consultants pvt ltd',
    'Arc-cgl consultants private limited',
    'M b malewar designs private limited',
    'Trimatrix techno economic services private limited',
    'Ashapura consultancy services private limited',
    'Nb educational private limited',
    'Great search staffing and management systems private limited',
    'Ssco consultants private limited',
    'Swarnakshara educational consultancy (india) private limited',
    'Stone media advisory services private limited',
    'Paradigm ventures private limited',
    'Ss building services consultants private limited',
    'Last minute media private limited',
    'Kubos consultancy services private limited',
    'RADIANT ADVERTISING & MARKETING (I) PVT. LTD.',
    'Har parshad and company private limited',
    'GUR DAS KAPUR & SONS PRIVATE LIMITED',
    'Challa technical services private limited',
    'Belliss international limited',
    'Bajaj marketing company private limited',
    'Evergreen realsquare private limited',
    'Airwil jkm infrastructures private limited',
    'Jhajjar kt transco private limited',
    'Sanjay buildsquare private limited',
    'Kufri buildcon private limited',
    'Krish homes private limited',
    'Carnation developers private limited',
    'Sankheshwar properties private limited',
    'Akshaya3 infrapromoters india private limited',
    'Goldsouk infrastructure private limited',
    'Meghana townships private limited',
    'Marg industrial clusters limited',
    'Shivalik erection private limited',
    'Manipal industries limited',
    'Blue valley developers private limited',
    'Aruna promoters private limited',
    'Milgerlan engineering & construction private limited',
    'NATHAN',
    'S EN VOGUE (FURNITURE) PRIVATE LIMITED',
    'Appsbee technology private limited',
    'Insurekot sports private limited',
    'SHRM EAST PRIVATE LIMITED',
    'Lets talk institute private limited',
    'Mind farmers private limited',
    'Eage edusolutions private limited',
    'Iprimed education solutions private limited',
    'Learnhive education private limited',
    'Logic business studies private limited',
    'Uni ark study abroad private limited',
    'Roots education private limited',
    'Hl7 healthcare standard institute',
    'Kingster education private limited',
    'Maharashtra knowledge corporation limited',
    'M. a. d. recreations hyderabad private limited',
    'E-infochips institute of training research and academics',
    'Star edureliance private limited',
    'Macfast centre for industrial interface private limited',
    'Manjoorans education academy private limited',
    'American academy of financial management india private limited',
    'Podar education systems private limited',
    'JETKING TECHNOLOGIES PRIVATE LIMITED',
    'Edu solutions consultancy private limited',
    'Student and beyond online services private limited',
    'MUST & MORE HEALTH CARE PRIVATE LIMITED',
    'Magnum life sciences private limited',
    'GXPRESS SOLUTIONS (INDIA) PRIVATE LIMITED',
    'VIAJEROS MUNDO HOSPITALITY PRIVATE LIMITED',
    'PROGBUY MEDIA PRIVATE LIMITED',
    'RESOLUTE MEDICAL MANAGEMENT PRIVATE LIMITED',
    'JUSTRIDE LEASING PRIVATE LIMITED',
    'PAISHING PACKAGING VENTURES PRIVATE LIMITED',
    'JV FOODWORKS PRIVATE LIMITED',
    'PROLIFE ENTERTAINMENT AND PRODUCTION PRIVATE LIMITED',
    'MEHAR SOLAR TECHNOLOGY PRIVATE LIMITED',
    'GLUAL HYDRAULICS INDIA PRIVATE LIMITED',
    'ATHARVASHREE INFRAVENTURES PRIVATE LIMITED',
    'PHARMA SPRAY SOLUTIONS PRIVATE LIMITED',
    'VACATION N HOLIDAY PRIVATE LIMITED',
    'IMPEX EXPRESS LOGISTICS PRIVATE LIMITED',
    'SIDDHANT FREIGHT FORWARDERS PRIVATE LIMITED',
    'XENOPS TECHNOLOGIES PRIVATE LIMITED',
    'TECHNO-VIJAY ENGINEERING PRIVATE LIMITED',
    'LOANTAP FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'PROPURBAN ADVISORY SERVICES PRIVATE LIMITED',
    'PL GLOBAL FORWARDERS PRIVATE LIMITED',
    'HOMECHAMPZ TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'FLOCK SOFTWARE PRIVATE LIMITED',
    'MUB IT SERVICES PRIVATE LIMITED',
    'ARROW ADVERTISING INDIA PRIVATE LIMITED',
    'TUNING TALENTS PRIVATE LIMITED',
    'ALTEN GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'ESSAR OIL AND GAS EXPLORATION AND PRODUCTION LIMITED',
    'CORNERSTONE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'SCOUT INFRASTRUCTURE PRIVATE LIMITED',
    'WHIZNEXT TECHNOLOGIES PRIVATE LIMITED',
    'MINDBOARD INDIA PRODUCT FACTORY PRIVATE LIMITED',
    'APPDIRECT INDIA PRIVATE LIMITED',
    'IFINCHE MEDIA PRIVATE LIMITED',
    'FAGLIG SERVICES PRIVATE LIMITED',
    'AAHIDA',
    'ZINE RDM ENERGY PRIVATE LIMITED',
    'YOSKA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'THERAPIE CLINIC INDIA PRIVATE LIMITED',
    'NAYA LIVING PRIVATE LIMITED',
    'KAAMA BREWERIES PRIVATE LIMITED',
    'JSR INDIA PRIVATE LIMITED',
    'ROOTEFY INTERNATIONAL PRIVATE LIMITED',
    'LIBERTY LUXURIES PRIVATE LIMITED',
    'SADBHAV NAINITAL HIGHWAY LIMITED',
    'ADVANCED BUILDING SYSTEMS PRIVATE LIMITED',
    'FIRST LADY HOUSING PRIVATE LIMITED',
    'STILT SYSTEMS PRIVATE LIMITED',
    'OPTECH CONSULTING SERVICES PRIVATE LIMITED',
    'VIVIFY PUBLISHERS AND BROADCASTING PRIVATE LIMITED',
    'UNIFOUND BUSINESS SOLUTIONS (OPC) PRIVATE LIMITED',
    'AXTRICS SOLUTIONS PRIVATE LIMITED',
    'WYN VENTURES PRIVATE LIMITED',
    'TEQFOCUS SOLUTIONS PRIVATE LIMITED',
    'AECIO IT SOLUTIONS INDIA PRIVATE LIMITED',
    'TOSAF INDIA ADDITIVES SOLUTIONS PRIVATE LIMITED',
    'S. M. CHEMICAL VAPI PRIVATE LIMITED',
    'JVS FLOW CONTROL PRIVATE LIMITED',
    'SCHEDIO TECH PRIVATE LIMITED',
    'LA SUPER RETAIL PRIVATE LIMITED',
    'LMCS MARITIME PRIVATE LIMITED',
    'LOGISTICSNOW PRIVATE LIMITED',
    'BILLEASY E SOLUTIONS PRIVATE LIMITED',
    'FIRST QUADRANT EDUVENTURES PRIVATE LIMITED',
    'PRIMECRAFT GAMES PRIVATE LIMITED',
    'KORE1 MANPOWER SOLUTION PRIVATE LIMITED',
    'VELOTIO TECHNOLOGIES PRIVATE LIMITED',
    'NEED EQUITY FOR EQUITY FOUNDATION',
    'BLUE ELEPHANT TOURS OPC PRIVATE LIMITED',
    'SURYA DATA SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'VERMEER EQUIPMENT INDIA PRIVATE LIMITED',
    'DIVYANSHI GARMENTS PRIVATE LIMITED',
    'BRENEX REAL ESTATE SERVICES PRIVATE LIMITED',
    'Signature builders private limited',
    'N.d.infrastructure india private limited',
    'The bombay jewellers estate private limited',
    'Sweety estate private limited',
    'Mahaavaaja reality and development private limited',
    'RAMBHIA PROPERTIES PRIVATE LIMITED',
    'Zoom real estates private limited',
    'Nirmal lifestyle (kalyan) private limited',
    'Avs lifestyles private limited',
    'Quadron business park private limited',
    'One earth infrastructure private limited',
    'Aryan nagpal properties private limited',
    'Starview realty private limited',
    'Green realhome developers private limited',
    'Nav srajan projects private limited',
    'Sirisampada farm lands private limited',
    'FIRM FOUNDATIONS & HOUSING PRIVATE LIMITED',
    'V.g.n.enterprises private limited',
    'Venue promoters private limited',
    'U m investment pvt ltd',
    'Orchid properties pvt ltd',
    'Cd nirman private limited',
    'Arjundas estates private limited',
    'Bengal regent infrastructure ltd',
    'Baywatch real estates private limited',
    'Apex avenues india private limited',
    'Hg infrabuild private limited',
    'PILOT PIPELINES PRIVATE LIMITED',
    'Kan real estate development company private limited',
    'Rishabhdev infratech private limited',
    'DLF LANDS INDIA PRIVATE LIMITED',
    'United megaa builders private limited',
    'Intersil (india) pvt limited',
    'B chaudhury print & art services pvt ltd',
    'Plasser (india) private limited',
    'Brindavan enterprises private limited',
    'Unimotive auto parts private ltd',
    'National research development corporation',
    'DSV COLOAD & CLEARANCE PRIVATE LIMITED',
    'Bell office software and supplies private limited',
    'Aten capital private limited',
    'Itron india private limited',
    'Green leaves management private limited',
    'Akrl katherine cruises private limited',
    'Akrl resorts private limited',
    'Futurex trade fair and events private limited',
    'Play sports surfaces & recreational solutions private limited',
    'Transstadia playsport private limited',
    'Primetime integrated media private limited',
    'SALSETTE FILMS PRIVATE LIMITED',
    'Imperial sports education private limited',
    'Tanaria stars private limited',
    'Bhupathi tennis academy private limited',
    'Globosport india private limited',
    'Fervent communication private limited',
    'Greenscape eco management private limited',
    'Expert global corporate advisors private limited',
    'Cheyyur infra limited',
    'C s electrical advisors private limited',
    'Cemex management private limited',
    'Usdc projects india private limited',
    'Iksula services private limited',
    'Sigue support services private limited',
    'Vayaloor developers private limited',
    'Lochan infracon private limited',
    'Rajgreen infrastructure private limited',
    'Century building industries private limited',
    'Aequs sez private limited',
    'Malabar towers private limited',
    'Charisma developers private limited',
    'Reliable infrastructure private limited',
    'Turnkey bildcon (india) private limited',
    'Mitcon infraproject private limited',
    'V r housing ventures private limited',
    'Fastech constructions private limited',
    'Arunapanchami estates private limited',
    'Atlanta infra assets limited',
    'Dynasty infrabuilders private limited',
    'Kingmaker developers private limited',
    'Shiva structural engineers private limited',
    'Transcon life spaces private limited',
    'INTERISE INVESTMENT MANAGERS LIMITED',
    'Annalakshmi land developers private limited',
    'Saroj builds and properties private limited',
    'INTERNATIONAL SEAPORT DREDGING Private Limited',
    'HASHICORP (INDIA) PRIVATE LIMITED',
    'SYNERGY GLOBAL BUNKERING PRIVATE LIMITED',
    'NATURE ZONE FARMS PRODUCER COMPANY LIMITED',
    'QUOWORKS TECHNOLOGIES PRIVATE LIMITED',
    'AKOUNTO SERVICES PRIVATE LIMITED',
    'VIRUKSHAM TECHNOLOGIES PRIVATE LIMITED',
    'SOT-SCIENCE OF TALENT ACQUISITION CONSULTING SERVICES (OPC) PRIVATE LIMITED',
    'WORKFORCE LIMITED',
    'MACAVV MEDIA PRIVATE LIMITED',
    'FIDELIX INFOSOLUTIONS PRIVATE LIMITED',
    'U-SOLAR ENERGY SERVICES PRIVATE LIMITED',
    'AIDHI.TECH SOFTWARE SERVICES PRIVATE LIMITED',
    'FEKER TECHNOLOGIES PRIVATE LIMITED',
    'PAJASA AGRONICS PRIVATE LIMITED',
    'DESIZNO SOLUTIONS PRIVATE LIMITED',
    'GHANTEWALA FOODS PRIVATE LIMITED',
    'TECHNOCULTURE RESEARCH PRIVATE LIMITED',
    'BIORANGE BIOLOGICALS PRIVATE LIMITED',
    'VAIBHAV VISTAR LIMITED',
    'VEEDUCARE PRIVATE LIMITED',
    'SCILORE CONSULTING PRIVATE LIMITED',
    'BIIGGBANG AMUSEMENT PRIVATE LIMITED',
    'GOLDKEY FINVEST PRIVATE LIMITED',
    'ACCUBITS INVENT PRIVATE LIMITED',
    'MEHI INDUSTRIES PRIVATE LIMITED',
    'UTOPIAN HAZE PRIVATE LIMITED',
    'XBALL INDIA PRIVATE LIMITED',
    'VEVELON PETROCHEM PRIVATE LIMITED',
    'DIGINEO TECHNOLOGY PRIVATE LIMITED',
    'BSE E-AGRICULTURAL MARKETS LIMITED',
    'BUYERASSIST.IO INDIA PRIVATE LIMITED',
    'BINDAL STAINLESS PRIVATE LIMITED',
    'G6 INDUSTRIES PRIVATE LIMITED',
    'ACME PRINT O PAC PRIVATE LIMITED',
    'UNILYNK VERITONE PRIVATE LIMITED',
    'FLOKX IT SERVICES AND TRADING PRIVATE LIMITED',
    'GEMSOFT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GREEN PROTEIN FOUNDATION',
    'HIFI TRAVEL PRIVATE LIMITED',
    'DAXFO TECHNOLOGY PRIVATE LIMITED',
    'KMP FREIGHT PRIVATE LIMITED',
    'NADA DAIRY FARMS PRIVATE LIMITED',
    'ALLARCH HEALTHCARE TECHNOLOGIES PRIVATE LIMITED',
    'NEXTDOORHUB INTERNATIONAL PRIVATE LIMITED',
    'RAGANA PHARMA SOLUTIONS PRIVATE LIMITED',
    'MARKETS ON CLOUD PRIVATE LIMITED',
    'DIGITANGLE CONSULTING PRIVATE LIMITED',
    'OMBIR CREATION PRIVATE LIMITED',
    'UNOBRANDS INDIA PRIVATE LIMITED',
    'VIMAAN AIRLINES PRIVATE LIMITED',
    'IKIO LIGHTING LIMITED',
    'LEVEL - NXT TECH PRIVATE LIMITED',
    'CONQUEST LIFESTYLE PRIVATE LIMITED',
    'SESA FOODS PRIVATE LIMITED',
    'NUFAB TECHNICAL TEXTILES PRIVATE LIMITED',
    'BRICK WAY INFRASTRUCTURE PRIVATE LIMITED',
    'TELAIR NETWORK PRIVATE LIMITED',
    'SAHAJ BHARTIYA SAHYOG NIDHI LIMITED',
    'CODE2NODE PRIVATE LIMITED',
    'MAX ENGINEERING & MARKETING PRIVATE LIMITED',
    'AMSTOR IT SERVICES PRIVATE LIMITED',
    'SOS INFOTECH AND TELECOM PRIVATE LIMITED',
    'PENBOUND PARTNERS PRIVATE LIMITED',
    'RESGENESIS FREELANCE PRIVATE LIMITED',
    'YELLOWBOX INFOSERVE PRIVATE LIMITED',
    '3RD I CONSULTING AND CREATIONS PRIVATE LIMITED',
    'SHIVPRASAD LOGISTICS PRIVATE LIMITED',
    'RAPPIO ADVERTISING PRIVATE LIMITED',
    'CRO SPLENDID LAB PRIVATE LIMITED',
    'NIPMAN STEERING SYSTEMS PRIVATE LIMITED',
    'COMDE-DERENDA INDIA PRIVATE LIMITED',
    'SOVPLYM INDIA PRIVATE LIMITED',
    'SIMLIFE ELECTRIC PRIVATE LIMITED',
    'ZICON INFRA PRIVATE LIMITED',
    '24 MEDIA FILMS PRIVATE LIMITED',
    'D-DANCE FACTORY PRIVATE LIMITED (OPC)',
    'ADANI TRANSMISSION (RAJASTHAN) LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING ONE LIMITED',
    'ADANI SOLAR ENERGY KUTCHH TWO PRIVATE LIMITED',
    'SHAKUMBHARI SOLAR POWER PROJECTS PRIVATE LIMITED',
    'CHUDIALA SOLAR POWER PROJECTS PRIVATE LIMITED',
    'CEREBRUM BUSINESS PARK PRIVATE LIMITED',
    'BALLUPUR SOLAR POWER PROJECTS PRIVATE LIMITED',
    'CHANEL INDIA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'TAPRINT TECHNOLOGIES PRIVATE LIMITED',
    'TECHNOCRAFT ENGINEERING SERVICES PRIVATE LIMITED',
    'SELZER INNOVEX PRIVATE LIMITED',
    'NEW ERA FORWARDER PRIVATE LIMITED',
    'NEXTBRAIN TECHNOLOGIES PRIVATE LIMITED',
    'ONPAGEONE DIGITAL AGENCY PRIVATE LIMITED',
    '4A COMPOSITES PRIVATE LIMITED',
    'EVERSUPPORT OUTSOURCING PRIVATE LIMITED',
    'AIRYAMAN HOLISTIC PRIVATE LIMITED',
    'OBIC SOLUTIONS PRIVATE LIMITED',
    'SHIVANTA JD TALC INDIA PRIVATE LIMITED',
    'HAVENZLAND FOOD IMPEX PRIVATE LIMITED',
    'CARROTHR INDIA PRIVATE LIMITED',
    'KERN.ADLER SOFTWARE PRIVATE LIMITED',
    'PAVE VALUE TECHNOLOGIES PRIVATE LIMITED',
    'MUMBAI NEST REAL ESTATE ADVISORY PRIVATE LIMITED',
    'ACV TECHNOCRATS INDIA PRIVATE LIMITED',
    'GARSONS AGPO PRIVATE LIMITED',
    'GANGAMAI KALYAN ACR PRIVATE LIMITED',
    'AYMERIC TECH SOLUTIONS PRIVATE LIMITED',
    'LEGALIGHT EDUCATION PRIVATE LIMITED',
    'SVT ADVISORS PRIVATE LIMITED',
    'RASMI INFRA SPACE PRIVATE LIMITED',
    'JSR TAX SOLVERS AND CONSULTANTS PRIVATE LIMITED',
    'WEALTHHIVE VENTURES PRIVATE LIMITED',
    'BLUEINFINITY INNOVATION LABS PRIVATE LIMITED',
    'RUDRA CONSULTANCY PRIVATE LIMITED',
    'VOLNEX PRIVATE LIMITED',
    'KNU PHARMA ENGINEERS AND CONSULTANT PRIVATE LIMITED',
    'ESSJAY REALITY PRIVATE LIMITED',
    'A N D CLAYWOODWORX PRIVATE LIMITED',
    'TECKNO INGENIOUS SOLUTIONS PRIVATE LIMITED',
    'IROOT TECHNOLOGIES PRIVATE LIMITED',
    'ZWARE SOFT PRIVATE LIMITED',
    'VASTUSHILPKALA PRIVATE LIMITED',
    'TRIPPER OVERSEAS PRIVATE LIMITED',
    'GALORE SYSTEMS PRIVATE LIMITED',
    'MYNESTONLINE PRIVATE LIMITED',
    '777 MEDIA FOREST PRIVATE LIMITED',
    'EARNPAL FINANCE PRIVATE LIMITED',
    'PROMOBI PROPERTIES PRIVATE LIMITED',
    'KYNAK RENDEZVOUS PRIVATE LIMITED',
    'INTERNATIONAL TURNKEY SYSTEMS INDIA PRIVATE LIMITED',
    'QNQ DESIGN AND DEVELOPMENT PRIVATE LIMITED',
    'AIREX TECHNOLOGIES PRIVATE LIMITED',
    'STAFFINGZILLA MANPOWERHUNTERS PRIVATE LIMITED',
    'VISTANOVA SOLUTIONS PRIVATE LIMITED',
    'FLUKY CONSULTING PRIVATE LIMITED',
    'QUEENSLAND ACADEMY OF NURSING FOUNDATION',
    'RASPL INDUSTRIES PRIVATE LIMITED',
    'Akashganga barter private limited',
    'Bhanu tie up private limited',
    'Asthvinayak healthcare limited',
    'Western herbicides private limited',
    'Globegeosolutions technologies private limited',
    'Nomisma mobile solutions private limited',
    'My job point private limited',
    'Pasona India Private Limited',
    'V19 TECHNOLOGIES PRIVATE LIMITED',
    'Istar skill development private limited',
    'S v air links private limited',
    'Sovika aviation services private limited',
    'Searchlight hr services private limited',
    'Golden opportunities private limited',
    'Pro-interactive services (india) private limited.',
    'ABSOLUTE SECURITY AND ALLIED SERVICES PRIVATE LIMITED',
    'Interactive entertainment private limited',
    'E-quality productions private limited',
    'Aurora packers private limited',
    'Cream packs pvt ltd',
    'Miltech industries private limited',
    'GRIPWELL MULTI TECH PRIVATE LIMITED',
    'Altius india construction chemicals company private limited',
    'En route media private limited',
    'Karnataka news publications private limited',
    'Aqua systems pvt ltd',
    'Delight chemicals pvt ltd',
    'Syn - finechem laboratories private limited',
    'SUDESH CHEMICALS PVT LTD',
    'Aryan cinevisions private limited',
    'Swash nonionics pvt ltd',
    'Moraya global limited',
    'S.a.pharmachem private limited',
    'VINMAR BUSINESS SERVICES PRIVATE LIMITED',
    'IE BUSINESS PUBLICATIONS PRIVATE LIMITED',
    'Kl resources pvt ltd',
    'KABSONS GAS EQUIPMENT PRIVATE LIMITED',
    'Industrial chemicals and monomers limited',
    'Airgases projects private limited',
    'Super polychem private limited',
    'Uma flakes private limited',
    'Tirupati industrial chemicals private limited',
    'Dhingra organic chemicals private limited',
    'Dureco exports private limited',
    'PRAGYA PRECISION EQUIPMENT PRIVATE LIMITED',
    'DATATRENDS ANALYTICS PRIVATE LIMITED',
    'ARGENOBEL NANOSCIENCE PRIVATE LIMITED',
    'REGENCO INNOVATION PRIVATE LIMITED',
    'RIVERSDALE INFRAPROJECTS PRIVATE LIMITED',
    'MATSAPP INDIA PRIVATE LIMITED',
    'SOLAR AVIONICS LIMITED',
    'PARUL EDUCATION FOUNDATION',
    'ICEA SEO INDIA PRIVATE LIMITED',
    'ROVY SOLUTIONS PRIVATE LIMITED',
    'INDOLEADS TECHNOLOGIES PRIVATE LIMITED',
    'VIRINCHI CAPITAL PRIVATE LIMITED',
    'NELLAKI TRAILS AND TECHNOLOGIES PRIVATE LIMITED',
    'NASREEN OIL INDIA PRIVATE LIMITED',
    'ZEBAQ PRIVATE LIMITED',
    'GAAYASRUTHI MUSIC INNOVATIONS (OPC) PRIVATE LIMITED',
    'SILSTA WOOD PLAST PRIVATE LIMITED',
    'SAFEWAY WHOLESALE PRIVATE LIMITED',
    'PERSONAL ENTERPRISES PRIVATE LIMITED',
    'KONYM HOME CARE PRODUCTS PRIVATE LIMITED',
    'FITGO EQUIPMENT PRIVATE LIMITED',
    'SGPHARMA GLOBAL PRIVATE LIMITED',
    'DHREYANSH CHEMICALS PRIVATE LIMITED',
    'ASANSOL MEDIA HOUSE PRIVATE LIMITED',
    'EDUFOREX INDIA PRIVATE LIMITED',
    'METRICBEES PRIVATE LIMITED',
    'FOXELPIE INDIA PRIVATE LIMITED',
    'ARROWSCOPE MARKETING STUDIO PRIVATE LIMITED',
    'HARE KRISHNA STEEL AND ROLLING PRIVATE LIMITED',
    'CHILLSOFT PRIVATE LIMITED',
    'OCHER TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'QULE PHARMA PRIVATE LIMITED',
    'LIGHTNINGLOGISTICS PRIVATE LIMITED',
    'MICRO PRINT & PACK PRIVATE LIMITED',
    'STITCHDEAL (OPC) PRIVATE LIMITED',
    'GLACIUS CULINARY PRIVATE LIMITED',
    'GH ENERGY PRIVATE LIMITED',
    'SHRI KARNI PACKERS AND MOVERS PRIVATE LIMITED',
    'THINKBIT CONSULTING PRIVATE LIMITED',
    'WEBNORIA E-COMMERCE PRIVATE LIMITED',
    'A2Z ASSURANCE PRIVATE LIMITED',
    'BIVES FOUNDATION',
    'ADZGURU MEDIA & TECHNOLOGY PRIVATE LIMITED',
    'BLOOM & HARVEST PRIVATE LIMITED',
    'KLASLEAD PRODUCTIONS PRIVATE LIMITED',
    'G6EV PRIVATE LIMITED',
    '7ORSES BUSINESS SERVICES PRIVATE LIMITED',
    'HERBAXT FORMULATIONS PRIVATE LIMITED',
    'FPP PRIVATE LIMITED',
    'KAPIL RESORTS PRIVATE LIMITED',
    'WEBSHARK WEB SERVICES PRIVATE LIMITED',
    'INNOVINC REELS INDIA PRIVATE LIMITED',
    'GRAPDES PARTNERS PRIVATE LIMITED',
    'GI AGRO TECHNOLOGIES PRIVATE LIMITED',
    'GWELD PRIVATE LIMITED',
    'OLA ELECTRIC TECHNOLOGIES PRIVATE LIMITED',
    'SERVICE PRINCIPLES PRIVATE LIMITED',
    'DYN3D TECHNOLOGIES PRIVATE LIMITED',
    'NORTHPOINT CARS PRIVATE LIMITED',
    'ADBEATS MEDIA PRIVATE LIMITED',
    'YUM INDIA TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MILKIN EDIT FURNITURE PRIVATE LIMITED',
    'SOCIAL THEORY MARKETING PRIVATE LIMITED',
    'TPIL MARKETING PRIVATE LIMITED',
    'ALLY AND NAWAB INTERNATIONAL PRIVATE LIMITED',
    'ALTIR INDIA PRIVATE LIMITED',
    'ALFAONE RETAIL PHARMACIES PRIVATE LIMITED',
    'BEANLY BEVERAGES PRIVATE LIMITED',
    'LOGICAL FARMER PRIVATE LIMITED',
    'SLEDDING TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'BRIGHT CHOICE VENTURES PRIVATE LIMITED',
    'SHIPBOB INDIA PRIVATE LIMITED',
    'AKIN CONTINGENCY SOLUTION PRIVATE LIMITED',
    'P2A AGROTECH (OPC) PRIVATE LIMITED',
    'GGWP INDIA PRIVATE LIMITED',
    'SERVICEMELA ONLINE PRIVATE LIMITED',
    'CITIBUS PRIVATE LIMITED',
    'SOVEREIGN PUMPING SOLUTIONS PRIVATE LIMITED',
    'ENACT PROJECTS PRIVATE LIMITED',
    'RAJ RATAN LEONET PRIVATE LIMITED',
    'PAVAG INTERNATIONAL PRIVATE LIMITED',
    'MIREEN INDUSTRIES PRIVATE LIMITED',
    'DIUTINUS VENTURES PRIVATE LIMITED',
    'VIABLE THOUGHTS PRIVATE LIMITED',
    'WEB OMEGA (OPC) PRIVATE LIMITED',
    'H&T SPECIAL STRIPS PRIVATE LIMITED',
    'AVMY COATED PRODUCTS PRIVATE LIMITED',
    'SAMZHE INTERNATIONAL PRIVATE LIMITED',
    'SABINS EDUCATION (OPC) PRIVATE LIMITED',
    'WWTOURS INDIA PRIVATE LIMITED',
    'SUBHANU TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED',
    'SAI GLOBE INTERNATIONAL PRIVATE LIMITED',
    'GREEN DRIVE AUTO SERVICES PRIVATE LIMITED',
    'HALCYON BUILDTECH PRIVATE LIMITED',
    'THUMB360 DIGITAL AND CONSULTING SERVICESPRIVATE LIMITED',
    'JANMAT MARATHI INFOTAINMENT PRIVATE LIMITED',
    'ZEECO STEEL INDUSTRIES PRIVATE LIMITED',
    'BABUSONA BRANDS PRIVATE LIMITED',
    'METAMOULD PRIVATE LIMITED',
    'VII TECHNOLOGIES ENTERPRISES PRIVATE LIMITED',
    'ASHWA INDIA NIDHI LIMITED',
    'HOMESLICE FOODS PRIVATE LIMITED',
    'BREWED GAMES PRIVATE LIMITED',
    'WINPRO ECOMM WAREHOUSING PRIVATE LIMITED',
    'GAYATHRI SUPERMARTS PRIVATE LIMITED',
    'CLIFFORD ENGINEERING PRIVATE LIMITED',
    'SAMOR REALITY LIMITED',
    'ENERJAA INFRA PRIVATE LIMITED',
    'PORTONOVO SOLUTIONS (OPC) PRIVATE LIMITED',
    'SHRI SOLAR & AUTOMATION SOLUTION PRIVATELIMITED',
    'KUKKUR INDIA PRIVATE LIMITED',
    'MIMASOFT TECHNOLOGIES PRIVATE LIMITED',
    'UNRAVEL TECHNOLOGIES PRIVATE LIMITED',
    'RISTAL INDUSTRIES PRIVATE LIMITED',
    'RIVERBANQ DIGITAL PRIVATE LIMITED',
    'SHRINE ENERGY PRIVATE LIMITED',
    'BLUME SENIOR LIVING PRIVATE LIMITED',
    'ROLLNUMBER TECHNOLOGIES PRIVATE LIMITED',
    'FOUR ACES AGRO PRODUCTS PRIVATE LIMITED',
    'BRIN TECH PRIVATE LIMITED',
    'RAISE ALLIANCE INDIA PRIVATE LIMITED',
    'HAND FOR HANDMADE FOUNDATION',
    'ALOKIK METALS PRIVATE LIMITED',
    'PAULDEA IOT SOLUTIONS PRIVATE LIMITED',
    'APPAREL HIVE PRIVATE LIMITED',
    'BLUMENOTICS PROJECTS PRIVATE LIMITED',
    'MANOJ RAJPUT BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'ESSJAY AXIOM PRIVATE LIMITED',
    'Medclin research private limited',
    'Bengal solar systems private limited',
    'United translogix private limited',
    'Jkg celex techno services private limited',
    'Kolkata realty advisors private limited',
    'Southern pacific energy private limited',
    'GET ENERGIETECHNIK INDIA PRIVATE LIMITED',
    'BLUE TANGERINE INDIA PRIVATE LIMITED',
    'ESPERTO DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SV.CO DIGITAL PLATFORM PRIVATE LIMITED',
    'ADP PRIVATE LIMITED',
    'OCTAL COMPLEX PRIVATE LIMITED',
    'HARRODS CORLEONE TOURS PRIVATE LIMITED',
    'SUDAMA COMPLEX PRIVATE LIMITED',
    'TECHTANT ENGINEERING PRIVATE LIMITED',
    'KNAB FINANCE ADVISORS PRIVATE LIMITED',
    '3S INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED',
    'MEGAMIC ELECTRONICS PRIVATE LIMITED',
    'OORJA FINANCE ADVISORS SERVICES INDIA PRIVATE LIMITED',
    'KALYANKARI NIWAS PRIVATE LIMITED',
    'AIRBUZZ PRIVATE LIMITED',
    'SMD INTECH PRIVATE LIMITED',
    'FINAL CALL PRODUCTIONS PRIVATE LIMITED',
    'ELECTRO SOLAIRE PRIVATE LIMITED',
    'PKS BUILDMART PRIVATE LIMITED',
    'MORGAN ARC PRIVATE LIMITED',
    'TECHUVA SOLUTIONS PRIVATE LIMITED',
    'DARSHITA PROJECTS PRIVATE LIMITED',
    'BHOPAL SMART CITY DEVELOPMENT CORPORATION LIMITED',
    'NORTHERN INDIA BRICKS & HOMES PRIVATE LIMITED',
    'BLOGILICIOUS PRIVATE LIMITED',
    'SWIRLAIR EQUIPMENTS PRIVATE LIMITED',
    'AUMJI EXIM PRIVATE LIMITED',
    'ASTRA RAFAEL COMSYS PRIVATE LIMITED',
    'BRAND ECOMMERCE PRIVATE LIMITED',
    'KAPE ECOMMERCE PRIVATE LIMITED',
    'VETRA FURNITURE PRIVATE LIMITED',
    'SURYAM INTERNATIONAL PRIVATE LIMITED',
    'LAZERJET COMPLEX PRIVATE LIMITED',
    'KVA MANAGEMENT CONSULTING PRIVATE LIMITED',
    'ART BUSINESS & CONSUMER FINANCE (INDIA) PRIVATE LIMITED',
    'VILL GLOBAL PROJECTS PRIVATE LIMITED',
    'NA HOMES PRIVATE LIMITED',
    'MULTIFLATS REALTY SERVICES PRIVATE LIMITED',
    'SATTRIA SYSTEMS INDIA PRIVATE LIMITED',
    'LIRIK INFOTECH PRIVATE LIMITED',
    'ZOMINT ECOM PRIVATE LIMITED',
    'KAPIL CONSULTANCY RECRUITMENT SERVICES PRIVATE LIMITED',
    'SATORI HEALTH PRIVATE LIMITED',
    'TERAPACT TECHNOLOGY PRIVATE LIMITED',
    'TOSS TRUCKING PRIVATE LIMITED',
    'Peso medicare private limited',
    'Dilipkumar healthcare private limited',
    'Hiranandani healthcare private limited',
    'Phaex polymers private limited',
    'Mewsic india foundation',
    'Konkan medical services private limited',
    'Impel ventures limited',
    'Dhriti foundation',
    'Gentech healthcare private limited',
    'Resmed india private limited',
    'Integris health private limited',
    'Park medi world private limited',
    'GRAMEEN FOUNDATION FOR SOCIAL IMPACT',
    'Private eye private limited',
    'Mercuri goldmann (india) private limited',
    'Ub infrastructure projects limited',
    'ZEUS BIOTECH PRIVATE LIMITED',
    'Prime labels private limited',
    'Dynasty holdings private limited',
    'Vbl innovations private limited',
    'Unnathi projects limited',
    'Prestige fashions private limited',
    'Chaya health care private limited',
    'Uber diagnostics private limited',
    'Maharaja medical centre pvt ltd',
    'Kims health care management limited',
    'Mother care & health centre private limited',
    'Khubchandani hospitals private limited',
    'Reliance coal resources private limited',
    'Sankhya hospitals prvate limited',
    'Amri hospitals limited',
    'Zoya health care private limited',
    'ACMESUJAN PHARMACHEM PRIVATE LIMITED',
    'Aster precitubes private limited',
    'Vedika metals private limited',
    'Gargs engineers limited',
    'Hindalco-almex aerospace limited',
    'Bhastrik mechanical labs private limited',
    'Manesar steel processing (india) private limited',
    'Gokul ferrocast private limited',
    'Ramakrishna impex private limited',
    'Unity forge private limited',
    'Leak-proof cast (india) private limited',
    'Galvano structures india pvt ltd',
    'Vishesh tools private limited',
    'MSP LAB INSTRUMENTS PRIVATE LIMITED',
    'MTI INDUSTRIES PRIVATE LIMITED',
    '7E',
    'N DESIGN PRIVATE LIMITED',
    'Vector projects (india) private limited',
    'Aura print solutions private limited',
    'Pg stationery private limited',
    'Ashmita papers private limited',
    'Bagpet paper private limited',
    'Cabot india limited',
    'Khana khazana publications private limited',
    'Khanvel resort private limited',
    'Golden dwellings private limited',
    'Shah buildcon private limited',
    'Dangayach propmart and resorts private limited',
    'G. N. BUILDEV PRIVATE LIMITED',
    'Incredible real estate private limited',
    'Corniche realty private limited',
    'Gammon retail infrastructure private limited',
    'Dynamic township private limited',
    'Dynamic shelters private limited',
    'JUMPCHARGE ACCESSORIES PRIVATE LIMITED',
    'Rmx rubber private limited',
    'Nova developers private limited',
    'Nexus shelter private limited',
    'Magnet shelter private limited',
    'Lavim developers private limited',
    'Bhoomi development private limited',
    'Riverview city constructions limited',
    'Jaipur dream realtors private limited',
    'Pravesh constructions pvt ltd',
    'Shri gargi buildcon private limited',
    'Naturalcrete infrastructure india private limited',
    'Projin infrastructure private limited',
    'S p landmarks private limited',
    'Shivdayal realty private limited',
    'P v line private limited',
    'Mega hydel gen private limited',
    'Usaka hydro powers private limited',
    'POWERGRID HIMACHAL TRANSMISSION LIMITED',
    'Ranital hydro ventures private limited',
    'Sobra hydro energies private limited',
    'Sravanthi energy private limited',
    'Roton power projects private limited',
    'JAYASWAL NECO URJA PRIVATE LIMITED',
    'Friends bulk handlers limited',
    'DELTA ELECTRONICS INDIA PRIVATE LIMITED',
    'Dynamic electronics private limited',
    'Maxerience electrosystems private limited',
    'Sona power private limited',
    'Eco power private limited',
    'Elan greentech energies limited',
    'Annant enersol private limited',
    'Amtex energy private limited',
    'Peenya industrial gases private limited',
    'Sealwel corporation private limited',
    'Sona green power private limited',
    'Sun bio-fuels private limited',
    'Made by survivors jewels private limited',
    'Tat tvam asi eco lodges & farm private limited',
    'Intermed healthcare private limited',
    'Camex wellness limited',
    'Astral tradelink private limited',
    'Massimo dutti india private limited',
    'Donear retail private limited',
    'RISE WORLDWIDE LIMITED',
    'Abs media services private limited',
    'SHRIVALLABH PITTIE ENTERPRISES PRIVATE LIMITED',
    'Tcp homes & decor private limited',
    'Ith engineering (india) private limited',
    'Kshitiz impex private limited',
    'Cleantech rubbers private limited',
    'Central trade agency private limited',
    'Leak proof enterprise (i) private limited',
    'Coream medical private limited',
    'Handloom heritage limited',
    'Qdseatoman designs private limited',
    'SUDARSHAN ADDPACK PRIVATE LIMITED',
    'Finex kitchen private limited',
    'Brand marc appliances private limited',
    'Tricom impress private limited',
    'ALLURE RETAIL PRIVATE LIMITED',
    'Vl access india private limited',
    'Bling element private limited',
    'Malabar gold private limited',
    'Malabar international gold designs private limited',
    'Malabar retna mahal private limited',
    'Travancore gold india private limited',
    'Active photo services private limited',
    'Chandrakiran trading private limited',
    'Fonez 4 u private limited',
    'Kamya hastakala arts & crafts private limited',
    'Masalabox food network private limited',
    'Hetero healthcare limited',
    'Buddy travel retail private limited',
    'Shrishrijee import and export private limited',
    'Chogori india retail limited',
    'Buddy mantra retail private limited',
    'Malhar agency and trading private limited',
    'Mico plast industries private limited',
    'Osten enzyme india private limited',
    'Sripad pacific steels india private limited',
    'Lakshya techsolutions limited',
    'ZAPSCALE PRIVATE LIMITED',
    'CAPITAL SETU PRIVATE LIMITED',
    'ERAN INDIA MANUFACTURING PRIVATE LIMITED',
    'GNAKS LABS PRIVATE LIMITED',
    'SIMPLIFIED MARKETING PRIVATE LIMITED',
    'TRYCON CROP SCIENCE PRIVATE LIMITED',
    'RIVERA FOREXCHANGE PRIVATE LIMITED',
    'INNOTEC CLEAN PRIVATE LIMITED',
    'VOODOO SHOWOFF PRIVATE LIMITED',
    'AB CHLORIDE INDIA PRIVATE LIMITED',
    'SHOP GO LOCAL PRIVATE LIMITED',
    'PC SHOP INDIA PRIVATE LIMITED',
    'HANDSCART PRIVATE LIMITED',
    'NUBIOGENX PRIVATE LIMITED',
    'BROOKS STERISCIENCE LIMITED',
    'ANCIENT HERBAL REMEDIES PRIVATE LIMITED',
    'TRINETRA AERO-MARINE TECHNOLOGIES PRIVATE LIMITED',
    'GEETA PRECISION COMPONENTS (I) PRIVATE LIMITED',
    'KEE SAFETY SYSTEMS AND SERVICES INDIA PRIVATE LIMITED',
    'RISHIKA INDUSTRIES LIMITED',
    'HEARTECH DYNAMICS PRIVATE LIMITED',
    'PARASSIO CLOTHINGS PRIVATE LIMITED',
    'VIPSALESSQUAD (OPC) PRIVATE LIMITED',
    'HERMIT FOX PRIVATE LIMITED',
    'STAR WIRE (INDIA) VIDYUT (DR) PRIVATE LIMITED',
    'NESSBOT PRIVATE LIMITED',
    'AICUSS LABS PRIVATE LIMITED',
    'SIMUBLADE TECHNOLOGY PRIVATE LIMITED',
    'GANESH INFOTECH SOLUTIONS PRIVATE LIMITED',
    'BK SOFTWARE SERVICES INDIA PRIVATE LIMITED',
    'DRUYU TECHNOLOGIES PRIVATE LIMITED',
    'WISECOR MANAGEMENT SERVICES PRIVATE LIMITED',
    'NEW MEDIA SRIJAN SANSAR GLOBAL FOUNDATION',
    'DPDRAJ FOODS AND SPICES INDIA PRIVATE LIMITED',
    'SARCOLINE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'DHAN HIND UTILITY PRIVATE LIMITED',
    'ROYAL GABAT LIFESCIENCE PRIVATE LIMITED',
    'KAVIDHARA HANDLOOMS AND HANDICRAFTS PRODUCER COMPANY LIMITED',
    'ROSEUS PRIVATE LIMITED',
    'MAXSOINDIA INDUSTRIAL SOLUTION PRIVATE LIMITED',
    'HI YATRI INDIA PRIVATE LIMITED',
    'BIG VALUE TRAVELS PRIVATE LIMITED',
    'LIBERAL TV PRIVATE LIMITED',
    'S9 FINTECH PRIVATE LIMITED',
    'PRONOMZ HOLDINGS PRIVATE LIMITED',
    'CLTECH SOLUTIONS PRIVATE LIMITED',
    'I DOT TEC INFRASTRUCTURES PRIVATE LIMITED',
    'JSA POLYMERS PRIVATE LIMITED',
    'FARM SHIKSHA PRIVATE LIMITED',
    'BAGHBAN GREENINFRA PRIVATE LIMITED',
    'NIYA GLOBAL PRIVATE LIMITED',
    'TUVIS TECHNOLOGIES AND INNOVATIONS PRIVATE LIMITED',
    'CATERPILLAR INDIA ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'B2BRAIN TECHNOLOGIES PRIVATE LIMITED',
    'GETYOUR BRAVEMINDS PRIVATE LIMITED',
    'PROCURE PLUS PRIVATE LIMITED',
    'HADES IMPEX PRIVATE LIMITED',
    'PLAN MY ROOMS PRIVATE LIMITED',
    'TORFAC INDIA PRIVATE LIMITED',
    'HARE KRISHNA SPACES PRIVATE LIMITED',
    'GGMD PRIVATE LIMITED',
    'AP SPICA INTERNATIONAL PRIVATE LIMITED (OPC)',
    'WIBYNG TECHNOLOGIES PRIVATE LIMITED',
    'SATENANDI INFRA PRIVATE LIMITED',
    'OZONE TRADELINK PRIVATE LIMITED',
    'SAMAN SOLAR PRIVATE LIMITED',
    'ASSOCIATION OF CERTIFIED LIFE PLANNERS',
    '4MINDS SOLUTIONS PRIVATE LIMITED',
    'FLOW ART PRIVATE LIMITED',
    'AYRA ED TECH PRIVATE LIMITED',
    'TGLOBAL ACADEMY PRIVATE LIMITED',
    'FYNDNA TECHCORP PRIVATE LIMITED',
    'FROSTEC INDIA PRIVATE LIMITED',
    'SPIRE BUILDCON PRIVATE LIMITED',
    'BISJHINTUS PRIVATE LIMITED',
    'KHANDA PAVERS & BRICKS PRIVATE LIMITED',
    'TECHINNOVATOR SOLUTIONS PRIVATE LIMITED',
    'NORGAM MEDICAMENTS PRIVATE LIMITED',
    'BCAP ADVISORS INDIA PRIVATE LIMITED',
    'WOODBURN OWNERS ASSOCIATION',
    'TORRENT SAURYA URJA 3 PRIVATE LIMITED',
    'KIRI RENEWABLE ENERGY PRIVATE LIMITED',
    'MAVERICK PLASTICS PRIVATE LIMITED',
    '3AM HOSPITALITY SERVICES PRIVATE LIMITED',
    'CEIPAL SOFTWARE PRIVATE LIMITED',
    'LIFENESS SCIENCE INSTITUTE EDUCATION ANDWELFARE FOUNDATION',
    'GLOBAL FLIGHT HANDLING SERVICES (PUNE) PRIVATE LIMITED',
    'INFINITE DIGITAL DIMENSIONAL ANALYTICS PRIVATE LIMITED',
    'RIBBON SERVICES PRIVATE LIMITED',
    'RECRUITARK SOLUTIONS PRIVATE LIMITED',
    'TLM WIRING SYSTEMS PRIVATE LIMITED',
    'UJAAS FOODS PRIVATE LIMITED',
    'ON STAGE TALENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'ELEVER INVESTMENT ADVISER PRIVATE LIMITED',
    'CREATIONS WOODKRAFT PRIVATE LIMITED',
    'VERTUS LIFE SCIENCES PRIVATE LIMITED',
    'EMBASSY ORANGE DEVELOPERS PRIVATE LIMITED',
    'OPT-CYBER SECURITY SOLUTIONS PRIVATE LIMITED',
    'ENVISION BUSINESS SOLUTION PRIVATE LIMITED',
    'AFFINIVI PRIVATE LIMITED',
    'FYGY HEALTH PRIVATE LIMITED',
    'ADHERELIVE PRIVATE LIMITED',
    'FOODZY NUTRIFOODS INDIA PRIVATE LIMITED',
    'PAYMENT NETWORK.COM PRIVATE LIMITED',
    'R RETAILS AND EATERY PRIVATE LIMITED',
    'TRUSTSWAP WEB SERVICES PRIVATE LIMITED',
    'HARBANS INSTITUTE PRIVATE LIMITED',
    'BUDDIES',
    'S IOE SOLUTIONS PRIVATE LIMITED',
    'EATIGO INDIA PRIVATE LIMITED',
    'NRV DESIGNX PRIVATE LIMITED',
    'CELL PLANET PRIVATE LIMITED',
    'VAMA ART & CRAFT PRIVATE LIMITED',
    'IMPERIAL INDIA FASHION PRIVATE LIMITED',
    'EAST COAST LOGIPARK PRIVATE LIMITED',
    'PSR CONSULTANCY SERVICES PRIVATE LIMITED',
    'NUCLEUS AUDIO VISUAL PRIVATE LIMITED',
    'SI CREVA CAPITAL SERVICES PRIVATE LIMITED',
    'TAKSYKRAFT MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'PRIMACY INFOTECH PRIVATE LIMITED',
    'KETTLEDRUM EVENTS PRIVATE LIMITED',
    'ECS VTS SYSTEMS PRIVATE LIMITED',
    'NAVKEM HEALTHCARE LIMITED',
    'PROLIFE HAIR AND HEALTH CARE PRIVATE LIMITED',
    'VELOX REMEDIES PRIVATE LIMITED',
    'ARJIT JEWELS PRIVATE LIMITED',
    'ACTIVE14 LABS PRIVATE LIMITED',
    'AVLOG INFOTECH PRIVATE LIMITED',
    'MAVERIX PLATFORMS PRIVATE LIMITED',
    'GEEKRUIT CONSULTANCY PRIVATE LIMITED',
    'VISHWA LEARNING SOLUTIONS PRIVATE LIMITED',
    'CARE N GROW TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'CITY EXPLORERS PRIVATE LIMITED',
    'KRIYA TRAVEL LOGISTICS PRIVATE LIMITED',
    'COSI GAMES PRIVATE LIMITED',
    'SUKINO HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'UHLMANN INDIA PRIVATE LIMITED',
    'BRIJBHUSHAN INFOSOLUTIONS PRIVATE LIMITED',
    'PEPDECK TECHNOLOGIES PRIVATE LIMITED',
    'DELLNER POLYMER SOLUTIONS INDIA PRIVATE LIMITED',
    'MICROTECH CNC MACHINE TOOLS PRIVATE LIMITED',
    'SAUVEUR DRUGS & RESEARCH PRIVATE LIMITED',
    'TRUSTIN TAPE PRIVATE LIMITED',
    'ETIOS TECHNOLOGIES PRIVATE LIMITED',
    'SEARCH ONLINE COMMUNICATIONS OPC PRIVATE LIMITED',
    'AVIAN INFRASTRUCTURE AND ENERGY PRIVATE LIMITED',
    'DEEP LEARN LABS PRIVATE LIMITED',
    'DOBIG DATA SOLUTIONS PRIVATE LIMITED',
    'ELECTRA ADVERTISING PRIVATE LIMITED',
    'ANVIT CONCEPTS PRIVATE LIMITED',
    'ELYZIUM SECURITECH PRIVATE LIMITED',
    'SAKSHATH TECHNOLOGIES PRIVATE LIMITED',
    'OYEPAISA CONSULTING PRIVATE LIMITED',
    'Logical steps interactive solutions private limited',
    'Elysium infoservices private limited',
    'Webteck consulting private limited',
    'Bq technologies private limited',
    'Quizent technologies private limited',
    'Attinad software private limited',
    'BAKER HUGHES OILFIELD DIGITAL SOLUTIONS INDIA PRIVATE LIMITED',
    'Neologix software solutions india private limited',
    'Ra integrated communication private limited',
    'Ashoca wellness private limited',
    'Gujarat color laboratories pvt ltd',
    'Sgs kraft management private limited',
    'Proton biochem private limited',
    'Chirag pack (india) private limited',
    'Adsmith private limited',
    'Studio k-7 designs private limted',
    'Dsk holdings private limited',
    'International hospital limited',
    'MAGIC GENIE SERVICES LIMITED',
    'Thea kitchen private limited',
    'Pune e commodities broking private limited',
    'Vajra certified diamonds private limited',
    'Chumbak design private limited',
    'Arscent health services private limited',
    'Proficio business solutions private limited',
    'A v george and co india pvt ltd',
    'Earthlink infrastructure projects private limited',
    'Rishon communication technologies private limited',
    'Cinnamon holdings private limited',
    'Unicorn facility support services private limited',
    'Shresid interiors private limited',
    'Yogesh suraksha design studio private limited',
    'VERTIV ENERGY PRIVATE LIMITED',
    'Alpha pneumatics private limited',
    'Jp autogas india private limited',
    'Chemac equipments private limited',
    'Thermosonics private limited',
    'Elite conferences private limited',
    'Sicom arc limited',
    'Ashtech (india) private limited',
    'G d pest control private limited',
    'Flemingo duty free shop mumbai private limited',
    'Gumpro drilling fluids private limited',
    'Shreeji kosh services private limited',
    'YUTIKA WELFARE FOUNDATION',
    'TECHNO JACKS INTERNATIONAL PRIVATE LIMITED',
    'RZPX PRIVATE LIMITED',
    'AVAADA MHSOLAR PRIVATE LIMITED',
    'CROSSOVER TECHNOLOGY PRIVATE LIMITED',
    'GRANT THORNTON DIGITAL PRIVATE LIMITED',
    'MITCON IMPACT ASSET MANAGEMENT PRIVATE LIMITED',
    'GARGI CREATIONS PRIVATE LIMITED',
    'ADVIKTHA HEALTHCARE PRIVATE LIMITED',
    'MINI I LEAF PRIVATE LIMITED',
    'BEST VALUE ORGANICS PRIVATE LIMITED',
    'AMEERA MACHINES LIMITED',
    'CALTON ENERGY PRIVATE LIMITED',
    'ISMOSYS INDIA PRIVATE LIMITED',
    'CXSAAS TECHNOLOGIES PRIVATE LIMITED',
    'ABHINANDAN JAINS PROJECTS PRIVATE LIMITED',
    'SUUMAYA PROTECTIVE TEXCORP LIMITED',
    'TRANSCONTINENTAL CELEBRATION WORLD PRIVATE LIMITED',
    'PERENNIAL TURBO TECHNOLOGIES PRIVATE LIMITED',
    'STAYHOMESTAYS PRIVATE LIMITED',
    'AAMRK SOFTWARE PRIVATE LIMITED',
    'EIE COMPLETE SOLUTIONS PRIVATE LIMITED',
    'KARANKAL RETAIL PRIVATE LIMITED',
    'RICHLINE FOOD PRIVATE LIMITED',
    'DISOBEDIENCE (OPC) PRIVATE LIMITED',
    'ICG-IISU ALUMNAE ASSOCIATION-BANDHAN',
    'GEMINI INTEGRATED FACILITY MANAGEMENT PRIVATE LIMITED',
    'MICROBZTECH LABS PRIVATE LIMITED',
    'CONTRACT SQUARE PRIVATE LIMITED',
    'FUTURESTACK PRODUCT AND IT SERVICES PRIVATE LIMITED',
    'MYWEALTHGROWTH FINTECH PRIVATE LIMITED',
    'VITHALRAJ FOUNDATION',
    'AADYA REAL VENTURES PRIVATE LIMITED',
    'CGIL RETAIL TRADING PRIVATE LIMITED',
    'EKSLATE LEARNING PRIVATE LIMITED',
    'GSC BUILDING SOLUTIONS PRIVATE LIMITED',
    'BOTMAN NETWORKS PRIVATE LIMITED',
    'EPITUM MOBILITY SOLUTIONS PRIVATE LIMITED',
    'OLIZAM RETAIL PRIVATE LIMITED',
    'WORK CUBICLE PRIVATE LIMITED',
    'WIDUENTZ PRIVATE LIMITED',
    'HONGDA HIBOO TOOLS INDIA PRIVATE LIMITED',
    'BNW AUCTIONEERS PRIVATE LIMITED',
    'MINDFUL FASHION PRIVATE LIMITED',
    'PAYTM PAYMENTS SERVICES LIMITED',
    'Sahaj info media private limited',
    'Swarnarekha fitting private limited',
    'Mather academic services',
    'Universal welfare & education foundation',
    'Creative dreams e-learning (india) private limited',
    'Rotopacs polymers india private limited',
    'Prism corporation private limited',
    'Innergise learning private limited',
    'Sri venketeshwara infotech private limited',
    'Gh industries private limited',
    'BLUDENZ INDUSTRIES PRIVATE LIMITED',
    'Stonehill education foundation',
    'Learning catalyst private limited',
    'Gemini education services private limited',
    'Tablytics market research private limited',
    'Sayahna open access publishing',
    'Dreamz school private limited',
    'Chettinad educational institutions',
    'Universal education foundation',
    'Navjot educational and training private limited',
    'Padmaja engineering services private limited',
    'Elbex couriers private limited',
    'Haryana knowledge corporation limited',
    'Ozone experiential learning technologies private limited',
    'Terma medicare india private limited',
    'Chemveda life sciences india private limited',
    'PULSE NUTRI SCIENCE PRIVATE LIMITED',
    'Forel labs private limited',
    'Sekisui chemical india private limited',
    'Ceutica and chemie healthcare private limited',
    'Unimed biosystems private limited',
    'Honour lab limited',
    'Authentic ayurveda private limited',
    'Goldwin medicare limited',
    'Cygnus laboratories limited',
    'Sunlarge health centre private limited',
    'Ucb india private limited',
    'Universal medicare private limited',
    'Mazda international private limited',
    'Louis pharmaceuticals private limited',
    'Baccarose cosmetics private limited',
    'Tun wa poly films private limited',
    'Gujarat parawaxes pvt ltd',
    'Hi-shine inks private limited',
    'Brahans polymers private limited',
    'QUANTYS CLINICAL PRIVATE LIMITED',
    'Gasvigil technologies private limited',
    'Splash solution private limited',
    'Indraprastha gas limited',
    'ORTIN LABORATORIES LIMITED',
    'Kamar chemical & industries limited',
    'Camex limited',
    'Procter & gamble hygiene and health care limited',
    'Bhansali engg polymers ltd',
    'HIMADRI SPECIALITY CHEMICAL LIMITED',
    'MBL INFRASTRUCTURE LIMITED',
    'C p e c limited',
    'Indo-tech transformers limited',
    'Suprajit engineering limited',
    'Kanchi karpooram limited',
    'Neogem india limited',
    'Sunraj diamond exports limited',
    'Springform technology limited',
    'Arihant superstructures limited',
    'Oasis securities limited',
    'STARLOG ENTERPRISES LIMITED',
    'Hathway bhawani cabletel and datacom limited',
    'Dugar housing developments limited',
    'HCKK VENTURES LIMITED',
    'Libord finance limited',
    'Suvidha infraestate corporation limited',
    'Unipro technologies limited',
    'International steel industries limited',
    'Pvp ventures limited',
    'Acropetal technologies limited',
    'Insta finance limited',
    'Fusion fittings (i) limited',
    'National general industries limited',
    'Omaxe limited',
    'Supreme infrastructure india limited',
    'Indianivesh limited',
    'Mann resorts private limited',
    'Manjeet cotton private limited',
    'Express confectioners private limited',
    'Auto profiles limited',
    'Vatan desire infotech private limited',
    'P.e. systems private limited',
    'Narbheram motors private limited',
    'Pes hydro power private limited',
    'Wind world wind farms (nettur) private limited',
    'Sudha technical consultants private limited',
    'Trikaya agriculture private limited',
    'Shantivan farms private limited',
    'Kamal cement udyog pvt ltd',
    'A.c.baxi and company private limited',
    'Doshi tiles private limited',
    'Veekas pipes pvt ltd',
    'Kaveri spun pipe private limited',
    'Sudisa foundry private limited',
    'Citizen metals private limited',
    'Sri visaka precision products private limited',
    'A AND M JUMBO BAGS LIMITED',
    'Unity forgings private limited',
    'Crown metals private limited',
    'Leder chem private limited',
    'A to z alloys private limited',
    'Avon steel industries & profiles private limited',
    'Deccan industrial explosives private limited',
    'Kabra steels limited',
    'OM STEEL TUBES LTD',
    'PASHUPATI ISPAT PVT.LTD.',
    'Emul tek private limited',
    'Abhay ispat (india) private limited',
    'Balfa steelco private limited',
    'PREMIER BARS LIMITED',
    'Chhattisgarh iron and steel works private limited',
    'Electrospark enclosures private limited',
    'Solopioneer match private limited',
    'MAGNUS PLYWOOD PRIVATE LIMITED',
    'Anmol steel processors private limited',
    'Saishiv boards and tops private limited',
    'ARJAS STEEL PRIVATE LIMITED',
    'Shiv shakti tubes and industries limited',
    'Hari steels and general industries ltd',
    'Marfatia agency private limited',
    'SRCM SOLUTIONS PRIVATE LIMITED',
    'Lister moessner india private limited',
    'Labh flexipack private limited',
    'Navgrah fastners private limited',
    'Maruti inox (india) private limited',
    'Aysha foundation private limited',
    'Deepmala infrastructure private limited',
    'Shipco infrastructure private limited',
    'Spectrum promoters pvt ltd',
    'S v plaza pvt ltd',
    'Arista developers private limited',
    'Gvk deoli kota expressway private limited',
    'Alien land private limited',
    'Nandan developers pvt ltd',
    'TECHLUSSO SYSTEMS PRIVATE LIMITED',
    'BCM FOUNDATION',
    'BRONTO TECH INTEGRA PRIVATE LIMITED',
    'PLANTS GENIC PRIVATE LIMITED',
    'IDHAYAM-G JAGATH NIDHI LIMITED',
    'VASHI INFOTECH PRIVATE LIMITED',
    'STANVALVES AND CONTROLS PRIVATE LIMITED',
    'ARAJ LET',
    'LORE PRIVATE LIMITED',
    'R s marketing and logistics private limited',
    'Skan sales & services private limited',
    'Involute automation private limited',
    'Vision india tourism private limited',
    'Regal supplier private limited',
    'Sava international private limited',
    'HARMONISED TECHNOLOGIES PRIVATE LIMITED',
    'Eros life space developers private limited',
    'Larkins developers private limited',
    'Haaas corporation private limited',
    'Valuecent realty private limited',
    'Govind kripa infratech private limited',
    'Honour infra estates limited',
    'Phoenix infra zone private limited',
    'Pheromone chemicals private limited',
    'Ahresty india private limited',
    'Gimi india private limited',
    'Specialized mobility operations and innovation private limited',
    'W R T SALES AND SERVICES PRIVATE LIMITED',
    'S.s. digitech impex private limited',
    'Bloom dealtrade private limited',
    'AADVAIT FILMS PRIVATE LIMITED',
    'Winall dealtrade private limited',
    'V p udyog ltd',
    'Agrani international pvt ltd',
    'K t properties finance pvt ltd',
    'Suryavanshi commotrade pvt ltd',
    'South india corpn private limited',
    'Saipratap tracon pvt ltd',
    'Wilson and company limited',
    'GBL PLASTIC (OPC) PRIVATE LIMITED',
    'QNA MEDIA PRIVATE LIMITED',
    'HOMFORTABLE PRIVATE LIMITED',
    'O8 BLUE SKY LOGISTICS PRIVATE LIMITED',
    'INDANI AGRO (INDIA) PRIVATE LIMITED',
    'AMBAST RECRUITMENT INTERNATIONAL PRIVATELIMITED',
    'ITECHNOTREE PRIVATE LIMITED',
    'ANTTERS JOBS PRIVATE LIMITED',
    'COOLHAX LABS PRIVATE LIMITED',
    'EWS SOFTWARE PRIVATE LIMITED',
    'GREEN SWM INFRA PRIVATE LIMITED',
    'RAJSWAROOP FOUNDATION',
    'PRITHVI GLOBAL FX PRIVATE LIMITED',
    'NANHISIAASHA- A CHILD WELFARE FOUNDATION',
    'SENECA INVESTMENTS PRIVATE LIMITED',
    'TALENTS RESOURCES MANAGEMENT PRIVATE LIMITED',
    'DAYLIGHT INNOVATION PRIVATE LIMITED',
    'TIRUPATI STONEX PRIVATE LIMITED',
    'BARBREW BEVERAGES PRIVATE LIMITED',
    'DESI ELIXIR PRIVATE LIMITED',
    'OCGI AGRO PROCESSING PRIVATE LIMITED',
    'ANUPRERNA ARTISAN ALLIANCE PRIVATE LIMITED',
    'OCTAVE RETAIL PRIVATE LIMITED',
    'WHITEFOX TEXTILE CARE PRIVATE LIMITED',
    'RATHI GDR BROTHERS PRIVATE LIMITED',
    'FABIO NETWORKS PRIVATE LIMITED',
    'VIRIDIS INFRASTRUCTURE INVESTMENT MANAGERS PRIVATE LIMITED',
    'TEEM APPLIANCES PRIVATE LIMITED',
    'MUD AND BUSHES RESORTS PRIVATE LIMITED',
    'SSEV INFRA PRIVATE LIMITED',
    'REVANZA MELROSAPURAM PRIVATE LIMITED',
    '19THCROSS MEDIA & TECHNOLOGIES PRIVATE LIMITED',
    'GARUDA RG CONSULTANTS PRIVATE LIMITED',
    'FLEX MORE SERVICES PRIVATE LIMITED',
    'AMATEUR FOOTBALL ASSOCIATION',
    'ADVISE ALLY CONSULTING PRIVATE LIMITED',
    'CREDAERO PRIVATE LIMITED',
    'BVM GRACE FOUNDATION',
    'CLOUD WELLNESS PRIVATE LIMITED',
    'ZOTIKOSS HEALTHCARE PRIVATE LIMITED',
    'CODER VALLEY SOLUTION PRIVATE LIMITED',
    'EXOTIC MILE PRIVATE LIMITED',
    'HELLA EMOBIONICS PRIVATE LIMITED',
    'ENDESIGN PROJECTS INDIA PRIVATE LIMITED',
    'MORNINGCARS TECH PRIVATE LIMITED',
    'Greenwave products private limited',
    'Crete colors (gujarat) private limited',
    'Saizar enterprise private limited',
    'Anand utilities private limited',
    'Akhil india private limited',
    'Deesan exports private limited',
    'Manju enterprises private limited',
    'V.h. fashions private limited',
    'Trivenikalyan trading pvt ltd',
    'Yellow saphire syntex private limited',
    'EXCELLENT POLYVINYL PRIVATE LIMITED',
    'Bedekar marketing company private limited',
    'Bhimrajka impex limited',
    'Splendour exports private limited',
    'Rohit impex private limited',
    'Indaccess marketing private limited',
    'Arambha exim private limited',
    'Jaywanti traders private limited',
    'Manisha international private limited',
    'Murari alloys & finance pvt ltd',
    'Haas impex private limited',
    'R natvarlal parekh trading and finance limited',
    'S.t. cottex exports private limited',
    'Medicraft life science limited',
    'Jaika automobiles private limited',
    'Playhome edutainment private limited',
    'Pam net work limited',
    'Tech clean india private limited',
    'Dockside properties private limited',
    'Excel callnet private limited',
    'Ideasurge solutions private limited',
    'Laya and tia infotechnologies private limited',
    'Nch technosoft private limited',
    'Vr e-biz solutions private limited',
    'REVOLTUTION LABS PRIVATE LIMITED',
    'Paytrium solutions india private limited',
    'Jamocha tech private limited',
    'Utile software solutions private limited',
    'Cyber metric services (india) private limited',
    'Shoonye technology solutions private limited',
    'Rnf technologies private limited',
    'Day and night e-solutions private limited',
    'Belgravia enterprises private limited',
    'Flamenco tech (india) private limited',
    'Kolahai infotech private limited',
    'Ameyasoft technologies private limited',
    'Magnum mi steel private limited',
    'Ic technologies private limited',
    'Trusound private limited',
    'Sain processing and weaving mills private limited',
    'TINY BOX PRIVATE LIMITED',
    'Time express international private limited',
    'Asian estates private limited',
    'MASU BRAKE PADS PRIVATE LIMITED',
    'Rancan impex private limited',
    'Sharanam enterprises opc private limited',
    'Aran projects private limited',
    'HILAND GLOBAL ENGINEERING PRIVATE LIMITED',
    'Tsw capital services private limited',
    'Sarco aircon private limited',
    'K s enterprises private limited',
    'Madhu buildtech private limited',
    'Sharma industries private limited',
    'Gls logistics private limited',
    'Alankit associates private limited',
    'Tarini wilderness innovations private limited',
    'V3 business ventures private limited',
    'Yamuna warehousing company private limited',
    'ROOP LEASING & FINANCE PRIVATE LIMITED',
    'MAHESHWARI GEOPONICS PRIVATE LIMITED',
    'Parswa systems pvt. ltd.',
    'Riddhi techauto industries private limited',
    'Think n 3d studio private limited',
    'Grenoble electronics private limited',
    'Sandhar infosystems limited.',
    'Saab shoe factory private limited',
    'Psnr e-services private limited',
    'Hjs emissiontechnology india private limited',
    'Valuecent consultancy private limited',
    'PNGCORP ENTERPRISES PRIVATE LIMITED',
    'Avtech associates services private limited',
    'Linkers buying service private limited',
    'Zp india advisory private limited',
    'Sunlarge industries private limited',
    'Matts corner india private limited',
    'Kopal media private limited',
    'Madrat games private limited',
    'S s textile media private limited',
    'L k kathare corporate services private limited',
    'Aircon air-spares and services private limited',
    'Agarwal con-homes private limited',
    'Coriolis technologies private limited',
    'Pixel softek private limited',
    'Intelligent development and programming private limited',
    'Aisle network private limited',
    'Rivet systems private limited',
    'Tvasan technologies private limited',
    'MAMSYS TECHNOLOGIES PRIVATE LIMITED',
    'PALPX TECHNOLOGIES PRIVATE LIMITED',
    'Tathva technologies private limited',
    'Viswarethna technology solutions private limited',
    'ANANTH TECHNOLOGIES PRIVATE LIMITED',
    'Genweb technologies private limited',
    'MTAR TECHNOLOGIES LIMITED',
    'Ipertex technologies limited',
    'Magnetic infotech private limited',
    'Jiva internet solutions private limited',
    'Amskape information systems private limited',
    'Klystron technologies private limited',
    'Naga info solutions private limited',
    'La net team software solutions pvt.ltd.',
    'Ananosoft technologies private limited',
    'Ruhlamat automation technologies (india) private limited',
    'Splendornet technologies private limited',
    'Innovative business mind technologies private limited',
    'Zinemind technologies private limited',
    'Beehyv software solutions private limited',
    'Desidea software technologies private limited',
    'Tvarana software solutions private limited',
    'Bluesilica technologies private limited',
    'Eiwave digitech (india) private limited',
    'Cufa india private limited',
    'RIGHTWORKZ TECHNOLOGY CONSULTING PRIVATELIMITED',
    'Indwa technologies private limited',
    'Skoft technologies private limited',
    'Qfund technologies private limited',
    'Ka va it solutions private limited',
    'Vitara information technologies private limited',
    'Relationsatwork india advisory private limited',
    'SRS FORMULATIONS PRIVATE LIMITED',
    'Egiant agroconnect private limited',
    'BOTECO RESTAURANTS PRIVATE LIMITED',
    'KRIFOUR INDUSTRIES PRIVATE LIMITED',
    'Sunrise fire private limited',
    'Labotek plastics auxiliaries india private limited',
    'OAK & YOKE FOOD INDUSTRIES PRIVATE LIMITED',
    'Trison farms and constructions private limited',
    'Cortec corrosion solutions india private limited',
    'Embitee iron and steel private limited',
    'Hybrid ebi hatcheries private limited',
    'Rafiq naik exports private limited',
    'Nexus feeds limited',
    'Shalimar hatcheries limited.',
    'Linus agroventures private limited',
    'Bgr aquaatech india limited',
    'Pelicans automotive & promotional products private limited',
    'H. d. trailers private limited',
    'BELMAKS AUTOMOTIVES PRIVATE LIMITED',
    'Emmbros autocomp limited',
    'Pritika industries limited',
    'Seagull lines (india) private limited',
    'Global tvs bus body builders limited',
    'Gatrad aviation technologies private limited',
    'Dual manufacturing technologies private limited',
    'Sriram rmc private limited',
    'Fuego furniture private limited',
    'Som autotech private limited',
    'Ambica furniture private limited',
    'Carpenters classic (impex) private limited',
    'Phychem technologies private limited',
    'Terram geosynthetics private limited.',
    'Sundaram jewels private limited',
    'PENTAPHOS INDUSTRIES PRIVATE LIMITED',
    'Inter-jewels chemm private limited',
    'Supergems jewellery manufacturing private limited',
    'Diagold creation private limited',
    'Dinesh minerals private limited',
    'Murliwala furniture mall private limited',
    'Aashay industries private limited',
    'Gia india laboratory private limited',
    'Ryc furniture manufacturing private limited',
    'Mespack india private limited',
    'Vardhaman i.q. toys private limited',
    'Flair pens limited',
    'AERO FIBRE PRIVATE LIMITED',
    'Forever interiors private limited',
    'Shri krishna ads private limited',
    'BOROSIL TECHNOLOGIES LIMITED',
    'Tristha creations private limited',
    'Matrix comsec private limited',
    'Supreme solutions private limited',
    'Swbi design informatics private limited',
    'Suvi software private limited',
    'Moksha holdings pvt.ltd.',
    'Bits and bytes integrators private limited',
    'Drewry maritime services private limited',
    'Variante bpo solutions private limited',
    'Kartika infosolutions private limited',
    'Trident softech private limited',
    'B l infotech private limited',
    'Sai chempartners india private limited',
    'Singh bajaj auto ptrivate limited',
    'Adesh softech private limited',
    'Palm estates and developers private limited',
    'Suri systems (india) private limited',
    'Ardhas technology india private limited',
    'Pci software pvt. ltd.',
    'Dulichand motors pvt. ltd.',
    'Xenitis technolab private limited',
    'Baani infocom private limited',
    'Sachdeva colleges limited',
    'Ba call centre india private limited',
    'Butiva technology private limited',
    'Orbitsys technologies private limited',
    'Axind software private limited',
    'Nutech information systems private limited',
    'Sawariya consumer care private limited',
    'Invansys technologies private limited',
    'Valley telegence private limited',
    'Kapila information technology private limited',
    'Xanta tech private limited',
    'Bm home furnishing exports private limited',
    'Technocuz software solutions private limited',
    'Shree jagannath techno-solutions private limited',
    'KALINGA DEVELOPMENT CONSULTING & TECHNOLOGIES PRIVATE LIMITED',
    'Global road tech limited',
    'Geo media private limited',
    'Cyberspace networking systems private limited',
    'Lustre softech private limited.',
    'Quantum netwerkz private limited',
    'Libsys technologies private limited',
    'Ring india infotech private limited',
    'Focus infosoft private limited',
    'Algort technologies private limited',
    'Alpha star trading private limited.',
    'Prathap foundation for education and training (sec 25 company)',
    'POSSIBILITY EDUTECH PRIVATE LIMITED',
    'Nettigritty private limited',
    'Mittal strips limited',
    'ESSAE -TERAOKA Private Limited',
    'Aeon telectronics private limited',
    'At & s india private limited',
    'Microland limited',
    'Canbank factors limited',
    'Stellence pharmscience private limited',
    'New india electricals limited',
    'Asipac projects private limited',
    'Coffeelab limited',
    'Embassy property developments private limited',
    'Kapil health club private limited',
    'Handloom export promotion council',
    'Devi hospital private limited',
    'UNITRANS SHIPPING & TRADING PRIVATE LIMITED',
    'Sba infratech services private limited',
    'Vishva institute of urology and kidney centre private limited',
    'Halal certification services (india) private limited',
    'HUMBOLDT INSTITUTE FOR EDUCATIONAL RESEARCH PRIVATE LIMITED',
    'Dn leather solutions private limited',
    'Srm institute for training and skill development private limited',
    'Vista imaging & medical centre private limited',
    'ZOI HOSPITALS PRIVATE LIMITED',
    'Padmini hospital enterprise private limited',
    'Phoenix medical systems private limited',
    'Rajan eye care hospital private limited',
    'Arul mission hospital private limited',
    'Rhea healthcare private limited',
    'Radcliffe education (north) private limited',
    'Radcliffe education (south) private limited',
    'EDUSOFT HEALTHCARE PRIVATE LIMITED',
    'Array consulting private limited',
    'Tathagat tutorials private limited',
    'Auctus labs private limited',
    'Rigid health care private limited',
    'Mewar hospital private limited',
    'M.v. diabetes care private limited',
    'Indian home & personal care industry association',
    'The cotton textiles export promotion council',
    'Sanshadow consultants private limited',
    'Rensol technologies private limited',
    'Lecan solutions private limited',
    'Yahvi systems private limited',
    'True north ar india private limited',
    'NVM CAPITAL PRIVATE LIMITED',
    'Xegent consultants private limited',
    'Personne advisors private limited',
    'Coral bay advisors private limited',
    'QUANTSEDGE ADVISORY SERVICES PRIVATE LIMITED',
    'Virtusoft syscol private limited',
    'Arushi electronics private limited',
    'Supreme hi-fidelity private limited',
    'Z plus surveillance security private limited',
    'Sercon electro systems private limited',
    'Rectifier house (india) private limited',
    'Alfred herbert limited',
    'Relax technologies private limited.',
    'Samax telecom private limited',
    'Indchem communications limited',
    'Eastern cd mfg co pvt ltd',
    'Hospital infra solutions private limited',
    'Curadev pharma private limited',
    'Firefly firepumps private limited',
    'RASANDIK ELECTRIC VEHICLES PRIVATE LIMITED',
    'Azael manufacturing private limited',
    'Sas actuators limited',
    'Golden motors private limited',
    'OTTOMAN FOODS LIMITED',
    'Advantech india pvt ltd',
    'KAYGEE ENGINEERING PRIVATE LIMITED',
    'Multiwyn motors private limited',
    'ALTRA INDUSTRIAL MOTION INDIA PRIVATE LIMITED',
    'Karnal motors private limited',
    'Satya gears private limited',
    'Sond gears pvt ltd',
    'Elixir motors private limited',
    'Galaxy marilines private limited',
    'Spl shipping private limited',
    'PROGRESS RAIL INNOVATIONS PRIVATE LIMITED',
    'Eastern airways ltd',
    'Hero cycles limited',
    'J p cycles pvt ltd',
    'SHRIRAM FOUNDRY Private Limited',
    'Sumitra woodcraft private limited',
    'Tarun vadehra interiors private limited',
    'HNI OFFICE INDIA LIMITED',
    'Shade fashions private limited',
    'Anju synthetics private limited',
    'Kaveri texfab private limited',
    'Kan textiles private limited',
    'Genex polyfab limited',
    'Mccoy clothing private limited',
    'NOVOAVENTURAS PRIVATE LIMITED',
    'SPINEMAT INDUSTRIES PRIVATE LIMITED',
    'Panzara textiles private limites',
    'VISCOTEX ENERGY PRIVATE LIMITED',
    'Yolo designs private limited',
    'Nupur carpets private limited',
    'SRI LAKSHMI SRINIVASA JUTE MILLS PRIVATELIMITED',
    'ALKARA WATER SOLUTIONS PRIVATE LIMITED',
    'First garment manufacturing company (india) private limited',
    'PEACOCK APPARELS PRIVATE LIMITED',
    'Mahtani clothing company private limited',
    'Shaila traexim private limited',
    'Swati exim private limited',
    'Arunawati textiles private limited',
    'Pushpak hosieries (exports) private limited',
    'Offbeat apparels india private limited',
    'Ashish bags and fashions private limited',
    'Diksha garments private limited',
    'Tejoo fashions private limited.',
    'BREAKBOUNCE INDIA PRIVATE LIMITED',
    'Leather hunte private limited',
    'Prl products (india) private limited',
    'SHIVI ENTERPRISES PRIVATE LIMITED',
    'Camp crafts private limited',
    'Century apparels private limited',
    'Arihant retail private limited',
    'Jolly panel limited',
    'A-1 boards india private limited',
    'Oswin wood panels private limited',
    'Avi fabrics private limited',
    'Sankalp textiles private limited',
    'Samriddhi textiles private limited',
    'Kushal textiles private limited',
    'Daman ganga pulp and papers pvt ltd (tr co from maharashtra)',
    'SRI VYUHALAKSHMI PAPERS PRIVATE LIMITED',
    'Think pattern private limited',
    'Aaditya textiles private limited',
    'SIDDHESHWARI PAPER UDYOG Private Limited',
    'Rd brown box packaging private limited',
    'Sumridhi recycling private limited',
    'Anand buildprop pvt. ltd.',
    'Hindustan ecosoftt private limited',
    'Samridhi infra developers private limited',
    'Santur construction and finance private limited',
    'Tulip housing private limited',
    'Whitegold constructions private limited',
    'Kaveri builtech private limited',
    'Rakshvir apartments private limited',
    'Samman construction and finance private limited',
    'Tarouni construction and finance private limited',
    'Rdb two thousand plus ltd',
    'Ashlar education consultants private limited',
    'Centre for excellence in insurance studies',
    'Quadramedical research & foundation private limited',
    'Focus durobuild private limited',
    'Manushree apparels private limited',
    'Brijwasi estate private limited',
    'Justbuild infratech private limited',
    'Surakshit towers private limited',
    'Swarn real estates private limited',
    'Sea rock builders private ltd',
    'Luxor cyber city private limited',
    'Real tech constructions private limited',
    'Inner city projects private limited',
    'Mcwell developers pvt ltd',
    'Shiva parvathi developments private limited',
    'SCL Property Holdings Limited',
    'Pine hill infrastructure development pvt ltd',
    'Ecophalt infratech india private limited',
    'Microchip infotech systems private limited',
    'Manohar filaments pvt.ltd.',
    'Dantal hydraulics private limited',
    'Forpro consultants private limited',
    'Malik imprints private ltd.',
    'Cinemedia private limited',
    'Scientific security management services private limited',
    'Alps international pvt ltd',
    'Nandan electronics private limited',
    'Sitac private limited',
    'Natraj stationery products private limited',
    'Tedco investment and financial services private limited',
    'Madhu chawla design trend private limited',
    'S c j plastics export private limited',
    'Zenara pharma private limited',
    'Adena cosmetics private limited',
    'Bitchem asphalt technologies limited',
    'Maharashtra steels investment private limited',
    'GOYAL ISPAT PRIVATE LIMITED',
    'Silcon steels private limited',
    'AAMOR INOX LIMITED',
    'Himachal wire industries pvt ltd',
    'Xindia steels limited',
    'Retchakar tannins private limited',
    'PIYANSHU LOGISTICS PRIVATE LIMITED',
    'AALISHAN FIBRES PVT. LTD',
    'Hutchinson industrial rubber products private limited',
    'Mallelil industries private limited',
    'P.a.bricks pvt ltd',
    'Orbit equipments private limited',
    'SALASAR WEATHER SERVICES PRIVATE LIMITED',
    'ALPHARUB CRUMB RUBBER PRIVATE LIMITED',
    'VELTECH FORGING PRIVATE LIMITED',
    'Lechtech materials private limited',
    'Kantipudi steels private limited',
    'Suraj enterprise private limited',
    'EIGHTY-FOUR INVESTMENTS PRIVATE LIMITED',
    'Ajit india (gujarat) pvt ltd',
    'Athena india hitech components private limited',
    'Trident tubes limited',
    'C lal alloys pvt ltd',
    'Amravati infrastructure developers limited',
    'Alstrut india private limited',
    'Manak waste management private limited',
    'Shashvat jewels private limited',
    'Indaid engineers private limited',
    'Dinesh ispat private limited',
    'KNOHOW VENTURES PRIVATE LIMITED',
    'Nsi metals private limited',
    'PRECISION AUTOCASTINGS PRIVATE LIMITED',
    'Shalimar alloys private limited',
    'Right castings (india) private limited',
    'Ambaraams castings private limited',
    'Corros metals private limited',
    'Indo-MIM Private Limited',
    'Kohinoor ferro metalics private limited',
    'CHHAJER TECHFAB PRIVATE LIMITED',
    'Bajrang castings private limited',
    'R.b.g. minerals industries limited',
    'Janaki ram steel and power private limited',
    'Ap comtel private limited',
    'Green goose design private limited',
    'Periscope communications private limited',
    'Avia xpert private limited',
    'Broadwings logistics private limited',
    'S.a.b enterprises private limited',
    'Skipper travels international private limited',
    'Tedco exports private ltd',
    'Ikan consultants private limited',
    'Ncm india limited.',
    'Macro graphics private limited',
    'Multiprod (india) private limited',
    'Ecologic technologies limited',
    'Ambassador developers private limited',
    'Golden international private limited',
    'FAR PAVILION RESORT AND HOTELS PRIVATE LIMITED',
    'Pinnacle agencies private limited',
    'Dominant investments private limited',
    'Su-beeta wires private limited',
    'Aar ess exim private limited',
    'Moonview steel private limited',
    'Lutfi optronics private limited',
    'Sukhari consultants private limited',
    'THALES DIS TECHNOLOGY INDIA PRIVATE LIMITED',
    'Shalimar overseas private limited',
    'Sunsafe aluminium private limited',
    'Agraj marketing private limited',
    'R.e.d. corporate training private limited',
    'N k trading and consultancy private limited',
    'REPPLEN PROJECTS PRIVATE LIMITED',
    'Adele shipping services private limited',
    'Tino engineering private limited',
    'Fourwood securities private limited',
    'Miglanis and associates private limited',
    'Glen eagles golf club private limited',
    'Venus marketing combine private limited',
    'The indo-canadian business chamber',
    'Rkg international private limited',
    'Sbj centre of excellence private limited',
    'Exponet associates private limited',
    'Wincom trading (india) private limited',
    'Apicom india private limited',
    'Bonanza assurance advisors private limited',
    'Melange design private limited',
    'Magnum aviation private limited',
    'Shimuk enterprises private limited',
    'Mewtech solutions private limited',
    'Ahuja furnishers private limited',
    'Bry- air (asia) private limited',
    'Prerona media pvt ltd',
    'Prabhat signs private limited',
    'Aditya elastobond pvt ltd',
    'Chambal fertilisers and chemicals limited',
    'V.k. marmostones private limited',
    'Awanti granites private limited',
    'Shiv edibles limited',
    'A s smokefree electronic cigarette private limited',
    'S power private limited',
    'B s n joshi and sons limited',
    'Oripol industries limited',
    'Rajoo cotex limited',
    'Sri vikranth horticulture private limited',
    'GAUR RADHA GIRIDHARI PRIVATE LIMITED',
    'Natraj machinery pvt ltd',
    'Coastal gujarat power genco private limited',
    'Examo estate management private limited',
    'VAASV GHAR PRIVATE LIMITED',
    'Anjita enterprises private limited',
    'Ashiana apparels private limited',
    'Yima appliances and electronics private limited',
    'Satyam krishna infraproject private limited',
    'Sukrohi international limited',
    'Ishwar farmline equipments private limited',
    'Shamsons polymers private limited',
    'Sangbi construction and developers private limited',
    'Aurochem land developers private limited',
    'Bhansali udyog private limited.',
    'CLAUDE BRAND RETAIL SOLUTION PRIVATE LIMITED',
    'Om diesels private limited',
    'Assotech sports company private limited',
    'R s surgicals private limited',
    'Qed kares packers private limited',
    'Ugar theatre private limited',
    'Azad surdeep construction private limited',
    'K.s.n. buildwell private limited',
    'Mitashi trading private limited',
    'Katyaayani sales & services private limited',
    'Paramount automotives private limited',
    'Rng associates private limited',
    'K.s.n. developers private limited',
    'MYATHENA PROLEARN PRIVATE LIMITED',
    'VANESHA AYUTECH PRIVATE LIMITED',
    'IMIMOBILE CLOUD COMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'SHORESIDE PRIVATE LIMITED',
    'SHREE RAPID TECHNOLOGIES PRIVATE LIMITED',
    'MOBILE DEFENDERS PRIVATE LIMITED',
    'RISING AHEAD PRIVATE LIMITED',
    'MEITHEE TECH PRIVATE LIMITED',
    'RUSTIC EARTH PRIVATE LIMITED',
    'AVINASH UDYOG PRIVATE LIMITED',
    'BEATLE INFRACON PRIVATE LIMITED',
    'ATHGARH AMBICA AGRO PRIVATE LIMITED',
    'VERSA CONTROLS MEASUREMENT TECHNOLOGIES PRIVATE LIMITED',
    'BENURADHA CHARITABLE FOUNDATION',
    'JR GLOBAL CONSULTANCY SERVICES PRIVATE LIMITED',
    'CIBOLOGY PRIVATE LIMITED',
    'AKOVA FINTECH SOLUTIONS PRIVATE LIMITED',
    'NAVASRI TAX CONSULTANTS PRIVATE LIMITED',
    'VIZOLT TECH SOLUTIONS PRIVATE LIMITED',
    'AGGNE GLOBAL IT SERVICES PRIVATE LIMITED',
    'NAVITA CONSOL SERVICES PRIVATE LIMITED',
    'TFM SERVICES PRIVATE LIMITED',
    'THINKWELL EDUCATION PRIVATE LIMITED',
    'IMC INDIA SECURITIES PRIVATE LIMITED',
    'SHARVAGYAA FINANCE SERVICES PRIVATE LIMITED',
    'HELIOS EARLY LEARNING SOLUTIONS PRIVATE LIMITED',
    'INGEX BOTANICALS PRIVATE LIMITED',
    'FILO EDTECH PRIVATE LIMITED',
    'CHICKEN WILD WINGS PRIVATE LIMITED',
    'MANNA WELFARE FOUNDATION',
    'YAREE LOGERS PRIVATE LIMITED',
    'HARJAASE FOOD PRODUCTS PRIVATE LIMITED',
    'NILKANTH CROP SCIENCE PRIVATE LIMITED',
    'STEDEE CREATIONS PRIVATE LIMITED',
    'END2END URJA SOLUTIONS PRIVATE LIMITED',
    'TRACETEXT TECHNOLOGY PRIVATE LIMITED',
    'NIKANK INNOVATIONS PRIVATE LIMITED',
    'INDGLOBE POWER BOOSTER PRIVATE LIMITED',
    'CLOUD 9 TRAVELS PRIVATE LIMITED',
    'SHAILZA TECHNOLOGY PRIVATE LIMITED',
    'ACCADIO INTERNATIONAL EDUCATION PRIVATE LIMITED',
    'RELIABLE PAINTS PRIVATE LIMITED',
    'SNACKSTIME PRIVATE LIMITED',
    'CONNX COMMUNICATIONS PRIVATE LIMITED',
    'May-queen properties pvt. ltd.',
    'Mbm construction and realtors private limited',
    'Brahmaputra realtors private limited',
    'Jlpl infrastructures private limited',
    'Lucky builders private limited',
    'Swapnlok apartments private limited',
    'Booster promoters private limited',
    'Arrow infracon private limited',
    'Skh builders private limited',
    'Polywood green building systems private limited',
    'S k dutt construction pvt ltd',
    'Siri ram syal and sons (engineers) private limited',
    'H & h promoters private limited',
    'Bcc engineers private limited',
    'Wellside properties private limited',
    'U t agency pvt. ltd.',
    'Atoz infracon private limited',
    'Subhlaxmi enclave private limited',
    'Kolkata abasan private limited',
    'Achiever infraprojects private limited',
    'Aashirwad infraproject private limited',
    'Indralok complex private limited',
    'Winsome plaza private limited',
    'Ekdant projects private limited',
    'Intercity projects private limited',
    'Utility complex private limited',
    'Wellbuild enclave private limited',
    'Elect construction private limited',
    'Intent builders private limited',
    'Woodland procon private limited',
    'Elect realestate private limited',
    'Elite devcon private limited',
    'Wakeful construction private limited',
    'Isolate realestate private limited',
    'Index developers private limited',
    'Eligible procon private limited',
    'Ideal conclave private limited',
    'Weighty developers private limited',
    'Vakratunda nirman private limited',
    'Teghoria construction private limited',
    'Interface enclave private limited',
    'Overflow properties private limited',
    'A n instrumentation projects private limited',
    'Akriti infra assets private limited',
    'Winter promoters private limited',
    'Info-x software technology private limited',
    'Ace microelectronics pvt. ltd.',
    'BEAMINGSTAR HOSPITALITY & RETAIL SERVICES PRIVATE LIMITED',
    'TEJASGREEN AUTOMOTIVE PRIVATE LIMITED',
    'Digamber softech private limited',
    'Almamate info tech private limited.',
    'Duncan technology private limited',
    'Arya rkr india private limited',
    'Brijwasi resorts private limited',
    'Diamond valley technologies private limited',
    'Hanvit exim & hospitality private limited',
    'SETUKRIT PROPERTIES LIMITED',
    'K.s.n. builders private limited',
    'Kalki buildwell private limited',
    'Humcha padmavati leisure resorts private limited',
    'Sis soft consulting private limited',
    'Dolphin logic systems private limited',
    'Kal ayurveda research & education foundation',
    'Vidhya management services private limited',
    'Sardeva management consultants private limited',
    'Pahwa (holdings) private limited',
    'Silverado estates private limited',
    'Igsa solutions private limited',
    'Zorba entertainment private limited',
    'Siti krishna digital media private limited',
    'Isc services private limited',
    'Kommlabs dezign private limited',
    'Impact integrated infosystems private limited',
    'Cybersoft and softwares solutions private limited',
    'Eon networks private limited',
    'Sbg designs private limited',
    'Tirath ram ahuja private limited',
    'Core outsourcing services private limited',
    'Himraj buildcon private limited',
    'Gomantak estates and projects private limited',
    'Mangesh estates and projects private limited',
    'Shivani fabricators and engineers pvt ltd',
    'EAST AFRICAN INDIA OVERSEAS PRIVATE LIMITED',
    'Perfect springs private limited',
    'Sitco agencies private limited',
    'Divy power private limited',
    'Alpine impex private ltd',
    'Siddhi nirman private limited',
    'Bhakarh properties private limited',
    'Advance infracon private limited',
    'Goodliving infrastructure private limited',
    'Hsa engineers & contractors private limited',
    'Daisy projects private limited',
    'Tekriwal motors private limited',
    'Mns developers private limited',
    'L t space solutions private limited',
    'ECOM AGRO INDIA PRIVATE LIMITED',
    'Marshalls enterprise india private limited',
    'Lift life pharmaceuticals private limited',
    'Parakh international limited',
    'Recovery dealers private limited',
    'Satwik vintrade private limited',
    'PATHMAKER SHIPPING PRIVATE LIMITED',
    'Sherif travel and cargo service private limited',
    'Tara cotton traders private limited',
    'Tyre protector (india) private limited',
    'Zodiac business pvt ltd',
    'VRF MARKETING PRIVATE LIMITED',
    'TATTVA VALUERS PRIVATE LIMITED',
    'Indoplast products india private limited',
    'Mast innovative products private limited',
    'Knr instrumentation private limited',
    'Stroke equipments (india) private limited',
    'Meru automobiles private limited',
    'Jaikrishnaa autosales private limited',
    'Ansh vyapaar private limited',
    'Safal food products private limited',
    'Aadit auto company private limited',
    'LS AUTOMOTIVE INDIA PRIVATE LIMITED',
    'DR AXION INDIA PRIVATE LIMITED',
    'Shiv shakti wahan private limited',
    'Concept motorparts private limited',
    'SINHA AUTO SALES & SERVICES PRIVATE LIMITED',
    'Adilaid foods & feeds private limited',
    'Silver motors private limited',
    'Decon india plastics private limited',
    'A.j.m.india private limited',
    'Shree autorestorers (india) private limited',
    'Resina developers private limited',
    'Shivphal constructions private limited',
    'Shree motors agencies private limited',
    'Asr certification services private limited',
    'Molecular quest healthcare private limited',
    'Aos products private limited',
    'Shreya design studio private limited',
    'City x-ray and scan clinic private limited',
    'Vgs imaging and diagnostics private limited',
    'Mentors lifesciences (india) private limited',
    'Sreechand speciality hospitals private limited',
    'Mind plus healthcare private limited',
    'Compro technologies private limited',
    'Morpheus prodevelopers private limited',
    'Dempo sports club private limited',
    'Gaursons infratech private limited',
    'Tiara hr plus management services private limited',
    'Skylark esolutions private limited',
    'Uk interia private limited',
    'Madras cricket club',
    'Armech engineers private limited',
    'Sheela constructions limited',
    'Garg data information private limited',
    'Cellulose pulp industries private limited',
    'Hindustan foods limited',
    'B a & brothers (eastern) ltd',
    'Goa carbon limited',
    'Sun pharmaceutical industries limited',
    'Pgam analytics private limited',
    'Fidele consulting india private limited',
    'TRUECONF INDIA PRIVATE LIMITED',
    'Edukriti learning solutions private limited',
    'WEBCONTENTOR INDIA PRIVATE LIMITED',
    'M-i enterprises (india) private limited',
    'Ansh agrovet private limited',
    'Rubymerry enterprises private limited',
    'Senti developers pvt ltd',
    'RICHIUM INDIA PRIVATE LIMITED',
    'Bhulanbararee coal co ltd',
    'Wissen automation india private limited',
    'Times digital limited',
    'Smart safex services private limited',
    'Ferozepur foods pvt ltd',
    'S r deka and co pvt ltd',
    'Haryana bread products private limited',
    'Absas solutions private limited',
    'Proofex packagings private limited',
    'Forum sales private limited',
    'V n estates private limited',
    'Vrinda finlease limited',
    'Praja mechanicals private limited',
    'Shubham overseas private limited',
    'Finex securities india private limited',
    'Auric styles private limited',
    'Onkar investments pvt ltd',
    'TULSA ADVISORY PRIVATE LIMITED',
    'Exquisite enterprises private limited',
    'Razzmatazz films private limited',
    'Integrated resorts private limited',
    'Panchanan international private limited',
    'Replika press private limited',
    'American orient capital partners india private limited',
    'Trumen stationery manufacturing company pvt. ltd.',
    'B natha singh karam singh private limited',
    'Indutch ventures services private limited',
    'Grd finlease private limited',
    'J and k cargo movers private limited',
    'Titan estates private limited',
    'Sanwalee cold storage and food industries private limited',
    'Bartholomew enterprises private limited',
    'DIMENSIONS CORPORATE FINANCE SERVICES PRIVATE LIMITED',
    'Manu estates private limited',
    'Cme communications private limited',
    'Metro plantations private limited',
    'Gates india private limited',
    'Anu garments private limited',
    'Fifth dimension consultants private limited',
    'Life positive private limited',
    'Paliwal fibres private limited',
    'Aanchal computers limited',
    'Three s. instruments private limited',
    'N s p associates (india) private limited',
    'Ferrum extreme engineering private limited',
    'Haryana neel udyog private limited',
    'Anubha enterprises private limited',
    'Icps engineering private limited',
    'Krisons technosoft limited',
    'Spade financial services limited',
    'PVR INOX PICTURES LIMITED',
    'Winning thumb marketing private limited',
    'Salwan polyesters private limited',
    'Shakumbhari expo-impo limited',
    'Almal & sons pvt ltd',
    'Af lifestyle international private limited',
    'Transpower technologies private limited',
    'Heptavision automation india private limited',
    'Chemosar chemical private limited',
    'Nandgopal impex private limited',
    'Aries export private limited',
    'Indiamco exports pvt ltd',
    'Vidarbha tradelinks private limited',
    'Vanali constructions private limited',
    'Bhoopali constructions private limited',
    'Multi overseas india pvt ltd',
    'Juili constructions private limited',
    'Vortex impex private limited',
    'Pret india private limited',
    'R d s impex and sales promotion private limited',
    'Bholebaba vinimay (p) ltd',
    'Saga merchandising company private limited',
    'Parnali constructions private limited',
    'Sankul properties private limited',
    'Sumali homes private limited',
    'INDO BEVTRADE PRIVATE LIMITED',
    'Gmaxe developers private limited',
    'M s dhody and company private limited',
    'SUPERHITS DIGITAL TECHNOLOGIES LIMITED',
    'Skyline buildtech private limited',
    'Vsg builders private limited',
    'Sahib constructions private limited tfr. from mumbai to delhi',
    'Swarali constructions private limited',
    'Fides sales private limited',
    'Epc contracts (india) private limited',
    'SGI WATER INDIA PRIVATE LIMITED',
    'Zanobi builders & constructions private limited',
    'Classic commodities private limited',
    'Vvn trading private limited',
    'Andees impex private limited',
    'Likeme barter pvt.ltd.',
    'VALUTEC ENTERPRISES PRIVATE LIMITED',
    'Bactro trades pvt.ltd.',
    'Jaslav exports private limited',
    'Smartbridge trading solutions private limited',
    'Bbw distributors private limited',
    'Kansukh trading private limited',
    'Gmc beverages private limited',
    'Shantai exim limited',
    'V.s.n. enterprises private limited',
    'ULTRA WELLNESS PRIVATE LIMITED',
    'Suntool india private limited',
    'Shivom international private limited',
    'Jbl saks private limited',
    'Mitul papers private limited',
    'Chemofine dyes & chemicals private limited',
    'FIA DEVELOPERS PRIVATE LIMITED',
    'Mass power controls chennai private limited',
    'Jain energy (madhya pradesh) private limited',
    'Shyamsteel power private limited',
    'Java realties private limited',
    'MARKOLINES TECHNOLOGIES PRIVATE LIMITED',
    'Superior infrastructure private limited',
    'Soubhagya constructions pvt. ltd.',
    'Totem infrastructure limited',
    'Swarnamukhi homes private limited',
    'O b infrastructure limited',
    'Aparna infrahousing private limited (part ix )',
    'Parshva nirman private limited',
    'Hbs projects private limited',
    'V3 ventures private limited',
    'Matrix foundations private limited',
    'Paharpur-pragnya tech park private limited',
    'TATA STEEL UTILITIES AND INFRASTRUCTURE SERVICES LIMITED',
    'Hi lite constructions private limited',
    'Vasundhra homes private limited',
    'Construction consortium (india) private limited',
    'Carewell pipes private limited',
    'Geetu engineering and constructions private limited',
    'Al ashwaq sivadam builders private limited',
    'Paramount propbuild private limited',
    'Mascot buildcon private limited',
    'CONCRETE CONSTRUCTION& ENGINEERING COMPANY PRIVATE LIMITED',
    'Multivision infrastructure private limited',
    'Sansha builders and developers private limited',
    'Srp builders limited',
    'PURE HOME & LIVING PRIVATE LIMITED',
    'Cian retail private limited',
    'Goyal builders private limited',
    'Udhav holdings private limited',
    'Contemporary properties private limited',
    'Pinky properties private limited',
    'Lajwanti consultants and builders private limited',
    'Mont blanc enterprises private limited',
    'PURBASHA LEFIN & RESOURCES PRIVATE LIMITED',
    'Muthoot m george chits india limited',
    'Mateshwari gems and investment ltd',
    'Baguio investments private limited',
    'S.m.investments pvt ltd',
    'AVANTI HR SERVICES PRIVATE LIMITED',
    'J.j. resort private limited',
    'Creative cable network private limited',
    'Bhawani finvest private limited',
    'Jak shares private limited',
    'Kazuki munjal automotive components private limited',
    'Rainbow holdings private limited',
    'Bramco india private limited',
    'Dariapur aquatic private limited',
    'Vishwas commodities private limited',
    'Tanvi dealers private limited',
    'Tanvi agencies private limited',
    'Tanvi dealmark private limited',
    'Tanvi dealcom private limited',
    'Panchkoti stockist private limited',
    'Ganadhip dealtrade private limited',
    'Gnrc medishop private limited',
    'Menezes remedies limited',
    'Khivraj motors private limited',
    'Comscraft technology pvt ltd',
    'Starwise vyapaar private limited',
    'Shubharambh trading pvt ltd',
    'SPLENDIFEROUS EXIM PRIVATE LIMITED',
    'Asahi alpha limited',
    'Pristine global private limited',
    'DHOOT RESORTS AND SPA PRIVATE LIMITED',
    'Colonia santa maria hotels private limited',
    'INVERSION ADVISORY SERVICES PRIVATE LIMITED',
    'Ldpl hotels & developers private limited',
    'Orchard hospitality private limited',
    'Diamond exports private limited',
    'Ambiance india private limited',
    'Sterling ion (india) limited',
    'Edata ventures private limited',
    'Aadharsila impex private limited',
    'Sreenidhi towers private limited',
    'Mcc marketing private limited',
    'Prompt enterprises private limited',
    'Wink exim private limited',
    'Fujikura kasei coating india private limited',
    'B & h sourcing india private limited',
    'Realtel network services private limited',
    'Star investcon private limited',
    'Skinrock natural stones india private limited',
    'Tradepoint india private limited',
    'Siam services india private limited',
    'Punjab water resources management & development corporation limited',
    'Rsl distilleries private limited',
    'OWNERSHIP OFFICES & FLATS LTD',
    'Shree pawandoot projects pvt ltd',
    'Silverline realtors services pvt ltd',
    'Unicorn abasan private limited',
    'Builcon human habitation consultants pvt.ltd.',
    'Jayshree foundations pvt.ltd.',
    'Incredible builders private limited',
    'R t infratech private limited',
    'Onkar plaza private limited',
    'Landscape properties private limited',
    'Jay kay properties private limited',
    'Ace cars and bikes exchange private limited',
    'Sonata auto trade private limited',
    'Sterling mobikes private limited',
    'Jaeco motors private limited',
    'AARPEE TRADING & HOLDING PVT. LTD.',
    'Vedant equip sales and services private limited',
    'Aarpee housing development pvt ltd',
    'Rajcon engineers private limited',
    'Bhuj developers private limited',
    'Ceragem india private limited',
    'Silver sports india private limited',
    'Sudarshan buildcon private limited',
    'C & C TOLLS LIMITED',
    'Alliance dealcomm private limited',
    'C & C WESTERN UP EXPRESSWAY LIMITED',
    'Tribhovandas bhimji zaveri (tbz) pvt. ltd',
    'Infinity manufacturing company private limited',
    'Subham realcon private limited',
    'Ashirbad house keeping services private limited',
    'Lavita exports private limited',
    'Kaizen retail and distribution services private limited',
    'Intellect nirman private limited',
    'Stark infraprojects private limited',
    'Mody auto (india) private limited',
    'Binod auto private limited',
    'Om metals auto private limited',
    'Oberoi hotels pvt.ltd.',
    'Titagarh capital management services private limited',
    'S.mehta financial services private limited',
    'Kdb investments pvt ltd',
    'Fairlawn hotel pvt ltd',
    'MONEY2ME FINANCE PRIVATE LIMITED',
    'Synodic carnival commercial private limited',
    'Par properties and investment services pvt. ltd.',
    'Udman enterprises private limited',
    'Sharnarthi finance limited',
    'A k stock broking services pvt ltd',
    'Link logistics management private limited',
    'Wonder finvest private limited',
    'Jindal capfin private limited',
    'Brain ex research and advisory private limited',
    'Anan properties and finance company private limited',
    'Ajay finetech developers private limited',
    'SREEMA INSURANCE CONSULTANCY PRIVATE LIMITED',
    'V p cold storage and farms private limited',
    'PURISONS AGROTECH & FOODS PRIVATE LIMITED',
    'Garuda housing & land development private limited',
    'Hitashi housing & land development private limited',
    'Namashivaya infrastructure and land developers private limited',
    'Bhima infrastructure and properties private limited',
    'Viewmore real estate private limited',
    'Native tree developers private limited',
    'Le tours to india private limited',
    'Aura travel mart private limited',
    'Velocity tours & travel private limited',
    'East view developers private limited',
    'Kitti investment private limited',
    'Indobrij finance limited',
    'SRIKRISNA ESTATES AND CONSTRUCTIONS PRIVATE LIMITED',
    'Taneja projects private limited',
    'Ecs engineering private limited',
    'Earthlinks realty private limited',
    'Best location properties private limited',
    'DAIVYA AAHAR PRIVATE LIMITED',
    'Dreambuild developers private limited',
    'Khushman projects and infrastructure private limited',
    'Rsp infrastructures private limited',
    'Bharat fabtex and corporate park private limited',
    'Uretek india private limited',
    'Pardhanani international properties private limited',
    'Venture projects bangalore private limited',
    'Dinbandhu estates private limited',
    'Shakti link property consultant private limited',
    'Devraj properties private limited',
    'Trukons housing private limited',
    'Vriddhi infratech india private limited',
    'Diagraph impex private limited',
    'Swabhumi projects private limited',
    'Kripa kunj private limited',
    'PURV LOGISTICS PRIVATE LIMITED',
    'Shradha infra realty private limited',
    'Royal gen com services pvt ltd',
    'GREEN H2 NETWORK INDIA PRIVATE LIMITED',
    'Par integreted systems private limited',
    'COVALIENCE INDIA PRIVATE LIMITED',
    'Linktree technologies private limited',
    'Alpine infosoft private limited',
    'Ige info systems private limited',
    'Pi international global solutions private limited',
    'Inkling technologies private limited',
    'Bohniman systems private limited',
    'Carefusion development private limited',
    'Opera software india private limited',
    'Arion innovative technologies india private limited',
    'Busy infotech pvt ltd',
    'INTELLIOZ SOLUTIONS INDIA PRIVATE LIMITED',
    'Ariba india private limited',
    'Entab infotech private limited',
    'Softcruise technologies private limited',
    'I-enable exim services private limited',
    'Sar edutech limited',
    'Phistream consulting private limited',
    'Rcs global limited',
    'Monark software private limited',
    'Pranav mediatech solutions (india) private limited',
    'Infinite infoworld limited',
    'Falcon technologies private limited',
    'Maxim softech private limited',
    'Infinite techworld limited',
    'Infinite techhub limited',
    'Awapal solutions private limited',
    'Green gate infotech private limited',
    'Dishaa pro training private limited',
    'Complete software solutions private limited',
    'A j enterprises pvt ltd',
    'Jalan commercial pvt ltd',
    'Modulex modular buildings private limited',
    'Brijbhumi vanijya private limited',
    'Niketan merchants private limited',
    'Manjula enclaves private limited',
    'Golden art exports private limited',
    'Kapil impex private limited',
    'Disha enclave private limited',
    'Divine solutions private limited',
    'Godavari tradecom private limited',
    'Akshara commodeal private limited',
    'QUARK SOLAR PRIVATE LIMITED',
    'Kathana jewels private limited',
    'MDI UNITED PRIVATE LIMITED',
    'HAWK CYCLES PRIVATE LIMITED',
    'West range agencies pvt. ltd.',
    'FLIGHT SIMULATION SOLUTIONS PRIVATE LIMITED',
    'Devkripa tradelink private limited',
    'Arohi vanijya private limited',
    'Bfl exports ltd',
    'Brindavan tradecom private limited',
    'Sadana warehousing and agencies pvt ltd',
    'Nanak singh sujan singh sadana and sons pvt ltd',
    'Trident axles pvt.ltd.',
    'Topshop india private limited',
    'Autoweb india private limited',
    'PRANAY CARE PRIVATE LIMITED',
    'Mkl exports private limited',
    'Mkd exports private limited',
    'Dkm exports private limited',
    'Hardik impex private limited',
    'N p exim private limited',
    'Sadana agencies private limited',
    'Welcome enterprises private limited',
    'Yarico agencies private limited',
    'Onassis exports private limited',
    'Sanya trading private limited',
    'Vee gee industrial enterprises private limited',
    'APEX METAGRO PRIVATE LIMITED',
    'Atp thermtech private limited',
    'Enzyme overseas private limited',
    'Devisons infiniti housewares private limited',
    'Nangalwala auto manufacturing private limited',
    'GOYAL AGENCIES Private Limited',
    'Cambridge commodites pvt. ltd.',
    'Daga shipping agents pvt ltd',
    'Bhagat marketing ltd',
    'Embro arts pvt ltd',
    'Avlon overseas private limited',
    'Daniel suppliers pvt.ltd.',
    'Globotex private limited',
    'Ivangel sales & services private limited',
    'R m b exports private limited',
    'R.s. aggarwal enterprises private limited',
    'Aspire vision private limited',
    'Asi services private limited',
    'Hastings agencies private limited',
    'Shashanka commodities private limited',
    'Rocket vanijya private limited',
    'Blaise merchants private limited',
    'Hemangi vyapar pvt.ltd.',
    'Eastern tea brokers pvt ltd',
    'Elrich international private limited',
    'Barua and company private limited',
    'SUBHAM DIGITAL SERVICES PRIVATE LIMITED',
    'United exim private limited',
    'Mayur industrials marketing private limited',
    'Citic trading company private limited',
    'Kalyan silks trichur private limited',
    'Prime pulses limited',
    'Archer electronics private limited',
    'Powai labs technology private limited',
    'Deccan sales corporation limited',
    'Arya trading and services pvt ltd',
    'Janet exports (india) private limited',
    'J b scan private limited',
    'Mns credit management group private limited',
    'Devoted investment private limited',
    'AS HOSPITALITY PRIVATE LIMITED',
    'Kirit films pvt ltd',
    'Sterling technologies private limited',
    'Magnon solutions private limited',
    'Akila trading private limited',
    'Quality conscious contractors private limited',
    'F & S HOTELS PRIVATE LIMITED',
    'Kohinoor duron paints private limited',
    'Legend creations private limited',
    'Superior impex private limited',
    'Kamlavallabh developers private limited',
    'Pure services private limited',
    'Mega infotech private limited',
    'L k agro private limited',
    'Valiant communications limited',
    'Moil limited',
    'Ganpati creations private limited',
    'Yamuna industries ltd',
    'Crown foods private limited',
    'Karna apparels private limited',
    'Sns creations private limited',
    'V e impex private limited',
    'KAZO FASHION Private Limited',
    'Cremeux bakeries private limited',
    'Nezone biscuits pvt ltd',
    'K m k foods private limited',
    'Bhikharam chandmal bhujiawala pvt. ltd',
    'Creasion products private limited',
    'Puja dyeing works pvt ltd',
    'Centex woollen mills pvt ltd',
    'Rachna art prints private limited',
    'Gloster specialities limited',
    'Perfect fashions private limited',
    'Yamuna international private limited',
    'FLOWSERVE SANMAR PRIVATE LIMITED',
    'Virat ecobags private limited',
    'Alam tannery pvt ltd',
    'Da milano leathers private limited.',
    'Sb leather experts private limited',
    'Edcons exports pvt ltd',
    'Andre garcia marketing company private limited',
    'Touristor shoes pvt ltd',
    'Ranjit tannery pvt ltd',
    'Pee gee synthetics pvt ltd',
    'ECO WOOD PRIVATE LIMITED',
    'Innovestment impex private limited',
    'Hotlight woodcrafts private limited',
    'Aparajita wooden trexim private limited',
    'TECH-CONNECT RETAIL PRIVATE LIMITED',
    'Pee gee fabrics private limited',
    'Modi schiffli embroidery mills private limited',
    'Bharat agency wedding cards private limited',
    'Insulink packaging solutions private limited',
    'Emaho creation private limited',
    'Nipshell builders private limited',
    'SHREE SATI TEXPRINTS PRIVATE LIMITED',
    'Bahri agro & farms private limited',
    'Shine amusement private limited',
    'S-com infovision international limited',
    'GXI NETWORKS PRIVATE LIMITED',
    'SPIK SANDS IMPEX PRIVATE LIMITED',
    'MANTRA SKY CASTLE PRIVATE LIMITED',
    'TREPHY TECHNOLOGIES PRIVATE LIMITED',
    'YVAORION SOLUTIONS PRIVATE LIMITED',
    'ACQUATECNO INDIA PRIVATE LIMITED',
    'TAKE2ELECTRONICS INDIA PRIVATE LIMITED',
    'BURROWS EXPERIENCE PRIVATE LIMITED',
    'LAMBENT DEVELOPERS PRIVATE LIMITED',
    'BESIMPLE CLOTHING PRIVATE LIMITED',
    'KAIRALI MININGS PRIVATE LIMITED',
    'CREATARA MOBILITY PRIVATE LIMITED',
    'LETW BUSINESS SOLUTION PRIVATE LIMITED',
    'RK VOYAGERS INDIA PRIVATE LIMITED',
    'GSDP TECHNOLOGIES PRIVATE LIMITED',
    'TELL TODAY INTERGLOBE NETWORK PRIVATE LIMITED',
    'GMN HEALTHCARE PRIVATE LIMITED',
    'HIGHLIFE HOTELS PRIVATE LIMITED',
    'YOGICSECRET HEALTHCARE PRIVATE LIMITED',
    'BELLSPIRE SOLUTIONS PRIVATE LIMITED',
    'SHAKUNT HEALTH CARE PRIVATE LIMITED',
    'MODESTACK TECHNOLOGIES PRIVATE LIMITED',
    'TEPSOL ENERGY VENTURES PRIVATE LIMITED',
    'SPEAKIN COMMUNICATIONS PRIVATE LIMITED',
    'PGOC PRIVATE LIMITED',
    'BEDESCHI INDIA PRIVATE LIMITED',
    'OPTIMUM HR, LABOUR LAW COMPLIANCES AND PLACEMENT SERVICES PRIVATE LIMITED',
    'ANA CONSORTIUM PRIVATE LIMITED',
    'VARADA INNOVATIONS PRIVATE LIMITED',
    'KADAPALA AGROTECH PRIVATE LIMITED',
    'ASB AUTOMOBILES PRIVATE LIMITED',
    'AAMATE MULTI BIZ PRIVATE LIMITED',
    'PRICYFY WEB TECHNOLOGY (OPC) PRIVATE LIMITED',
    'ETHAN ENERGY INDIA PRIVATE LIMITED',
    'OPUS INSPECTION INDIA PRIVATE LIMITED',
    'INKOPIOUS PRIVATE LIMITED',
    'GREEN WORMS WASTE MANAGEMENT PRIVATE LIMITED',
    'PWSIM ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'AMBIW WEB PRIVATE LIMITED',
    'ATRIA WIND POWER (K1)PRIVATE LIMITED',
    'ABHASTRA TECHNOLOGY PRIVATE LIMITED',
    'RAMGARH RESORT & POLO COMPLEX PRIVATE LIMITED',
    'ORION HOMES PRIVATE LIMITED',
    'MAKERUPT MANUFACTURING TECHNOLOGIES PRIVATE LIMITED',
    'LAASSYA SUSTAINABLE SOLUTIONS (OPC) PRIVATE LIMITED',
    'CRYONIC ARTS PRIVATE LIMITED',
    'CALAVO TECHNOLOGIES PRIVATE LIMITED',
    'ECOSTREAM INFOTECH PRIVATE LIMITED',
    'KNR SOMWARPET INFRAPROJECT PRIVATE LIMITED',
    'SINUOS BRASS INTERNATIONAL PRIVATE LIMITED',
    'BONZER STAFFING SOLUTIONS PRIVATE LIMITED',
    'AGVI INDIA PRIVATE LIMITED',
    'TACTERIAL CONSULTING PRIVATE LIMITED',
    'SAMYUKTHA HEALTHCARE & DIAGNOSTICS PRIVATE LIMITED',
    'REALTYDADDY INDIA PRIVATE LIMITED',
    'CELLO WORLD LIMITED',
    'DHRITI ENGITECH PRIVATE LIMITED',
    'JYOTI METALLICS INDIA PRIVATE LIMITED',
    'GRAFT3D HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'KEDGE INFRA SOLUTIONS PRIVATE LIMITED',
    'NAKSHATRAMALI TRAVELS PRIVATE LIMITED',
    'ASSISTART ADVERTISING PRIVATE LIMITED',
    'GYAN AYURVEDA PRIVATE LIMITED',
    'EXPRESS PARCELMEN LOGISTICS PRIVATE LIMITED',
    'PRIVAFY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'OMNICOMM ECLINICAL SOLUTIONS PRIVATE LIMITED',
    'AVAADA INFRA PRIVATE LIMITED',
    'GKAP VENTURES PRIVATE LIMITED',
    'GLADMINDS SOLUTIONS PRIVATE LIMITED',
    'SPSG TOPHIRE PRIVATE LIMITED',
    'CAIMAN SOLUTIONS PRIVATE LIMITED',
    'LEXGENIX INTERNET PRIVATE LIMITED',
    'ALLIE OUTSOURCING SOLUTIONS PRIVATE LIMITED',
    'JUSFOCUS TECHNOLOGIES PRIVATE LIMITED',
    'ANTONY LARA RENEWABLE ENERGY PRIVATE LIMITED',
    'DECCANLOGIC PRIVATE LIMITED',
    'MEZZANINE INFRATECH PRIVATE LIMITED',
    'SEANEXT MARINE SOLUTIONS PRIVATE LIMITED',
    'BETMOUNT TECHNOLOGIES PRIVATE LIMITED',
    'BECRUX TOWNSHIP PRIVATE LIMITED',
    'NOVO INSURANCE BROKING SERVICES PRIVATE LIMITED',
    'ENTEONS PRIVATE LIMITED',
    'KAMILIA PALACE PRIVATE LIMITED',
    'SAMPTEL ENERGY PRIVATE LIMITED',
    'YDRA EVENTS PRIVATE LIMITED',
    'GLASTAL ENGINEERS PRIVATE LIMITED',
    'BVG SPACETHETICS PRIVATE LIMITED',
    'AKACHI MANAGEMENT PRIVATE LIMITED',
    'MVCS HOSPITALITY PRIVATE LIMITED',
    'INDGENE BIOLOGICS INDIA PRIVATE LIMITED',
    'FARMMONK INNOVATIONS PRIVATE LIMITED',
    'AVANZADA PRINTED TECHNOLOGY PRIVATE LIMITED',
    'TOOLSLICK TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'BIGHUB SOLUTIONS PRIVATE LIMITED',
    'HAYGOT SERVICES PRIVATE LIMITED',
    'ADANI SOLAR ENERGY KA NINE PRIVATE LIMITED',
    'NOMUS COMM-SYSTEMS PRIVATE LIMITED',
    'ALPHAPAX ENTERPRISES PRIVATE LIMITED',
    'FAIR FUTURE OVERSEAS EDUCATIONAL CONSULTANCY PRIVATE LIMITED',
    'PAGERO E-BUSINESS NETWORK PRIVATE LIMITED',
    'HAGNOSOFT TECHNOLOGIES PRIVATE LIMITED',
    'PMR MUD RIGGERS INDIA PRIVATE LIMITED',
    'SHASTA CORPORATE ADVISORS PRIVATE LIMITED',
    'TVS SUNDRAM FASTENERS PRIVATE LIMITED',
    'SIDAN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'ABP EXPORT PRIVATE LIMITED',
    'MAGNIMOUS INFO TECH PRIVATE LIMITED',
    'SANGHAR FRESH PRODUCE PRIVATE LIMITED',
    'INFOXERON TECHNOLOGIES PRIVATE LIMITED',
    'LIXR SOLUTIONS PRIVATE LIMITED',
    'WITZIG ADVISORY SERVICES PRIVATE LIMITED',
    'TIRUPALU ELECTRICAL PRIVATE LIMITED',
    'SEDA ENGINEERING PRIVATE LIMITED',
    'VALENTA GLOBAL PROJECTS PRIVATE LIMITED',
    'AMAHOP TECHNOLOGIES PRIVATE LIMITED',
    'ZIPZAP LOGISTICS PRIVATE LIMITED',
    'CAERUS EXPORTS PRIVATE LIMITED',
    'RDB REAL ESTATE CONSTRUCTIONS LIMITED',
    'VOYE.IN TRAVEL AUTOMATIONS INDIA PRIVATELIMITED',
    'MARKWIN VENTURES PRIVATE LIMITED',
    'CUBEBIO AI PRIVATE LIMITED',
    'APC IMPORTS PRIVATE LIMITED',
    'ARGIA DESTINATIONS PRIVATE LIMITED',
    'RAJLAXMI HYDRAULICS & ENGINEERING PRIVATE LIMITED',
    'KDI POWER PRIVATE LIMITED',
    'RBT TYROTUBE PRIVATE LIMITED',
    'LEVEL7 TURNKEY (OPC) PRIVATE LIMITED',
    'ANYCAST TECHNOLOGY PRIVATE LIMITED',
    'MASTER ASHIRWAD LOGISTICS PRIVATE LIMITED',
    'JANSA SOLAR SOLUTIONS PRIVATE LIMITED',
    'EUNOIA FINANCIAL SERVICES PRIVATE LIMITED',
    'NAVSARI PROFILES PRIVATE LIMITED',
    'VEDANSHEE SAFETY AND SIGN PRIVATE LIMITED',
    'ENVERTIZ CONSULTANCY PRIVATE LIMITED',
    'FLETCHER HEALTHCARE PRIVATE LIMITED',
    'AIRZIA HOLIDAYS PRIVATE LIMITED',
    'HARISH VENTURES PRIVATE LIMITED',
    'IMPERO IT SERVICES PRIVATE LIMITED',
    'GROWME ENVIOUS DIGITAL SOLUTIONS PRIVATELIMITED',
    'COGILYS FINCORP PRIVATE LIMITED',
    'OD BUSINESS SOLUTIONS PRIVATE LIMITED',
    'EMSAR ENGICON INDIA PRIVATE LIMITED',
    'MEROPE REAL ESTATE PRIVATE LIMITED',
    'HEADLONG NEWSROOM POST INDIA PRIVATE LIMITED',
    'AIRCONNECT INFOSYSTEMS PRIVATE LIMITED',
    'DEORAHI AYURVEDIC INDIA PRIVATE LIMITED',
    'SILOX INDIA PRIVATE LIMITED',
    'SPIRITEDBRIO ANIMATION PRIVATE LIMITED',
    'TNM GENIE PRIVATE LIMITED',
    'ASCENTIOS ADVISORS PRIVATE LIMITED',
    'FUELIFE EXPLORERS PRIVATE LIMITED',
    'GRAHIK LEARNING PRIVATE LIMITED',
    'STAYALT BRANDS PRIVATE LIMITED',
    'M CLOUD AIRCON PRIVATE LIMITED',
    'ONNTRA INDIA PRIVATE LIMITED',
    'VERISCRIPT PRIVATE LIMITED',
    'LENTRA AI PRIVATE LIMITED',
    'INDIA POWER CORPORATION LIMITED',
    'MANAVTA HOLDINGS LIMITED',
    'MANBHAWANI INVESTMENT LIMITED',
    'AMAR INVESTMENTS LTD',
    'PRESSMAN ADVERTISING LIMITED',
    'SAMTA PLASTICS PVT LTD',
    'VARDHMAN ACRYLICS LIMITED',
    'SAFFRON ENTERPRISES PRIVATE LIMITED',
    'PERFECT VALVES PRIVATE LIMITED',
    'CROSSLAND SERVICES PRIVATE LIMITED',
    'SHELTER DEVELOPERS PVT LTD',
    'NIHARIKA CONSTRUCTIONS PVT LTD',
    'MANJUSHREE PROPERTIES PVT LTD',
    'PROTECT VINIMAY PRIVATE LIMITED',
    'MODERN GEARS PRIVATE LIMITED',
    'GILARD ELECTRONICS PRIVATE LIMITED',
    'MADHAV KRG LIMITED',
    'BURO ENGINEERS (INDIA) PRIVATE LIMITED',
    'PRANAMI TRADING PRIVATE LIMITED',
    'DARSHAN DISTRIBUTORS PRIVATE LIMITED',
    'ROYAL GRANITES PRIVATE LIMITED',
    'GANGOTRI MERCANTILE PRIVATE LIMITED',
    'FRACHT FORWARDING AND TRAVELS PRIVATE LIMITED',
    'SILVERSON DEALERS PRIVATE LIMITED',
    'I POWER SOLUTIONS INDIA LIMITED',
    'UMAYAMBIKAI FINANCIAL SERVICES PRIVATE LIMITED',
    'PARIKH INN PRIVATE LIMITED',
    'DEDICO TRANSPORT PRIVATE LIMITED',
    'ROSE MEDICARE PRIVATE LIMITED',
    'WAVEBAND TECHNOLOGIES PRIVATE LIMITED',
    'ROMIT LEASING AND FINANCE PRIVATE LIMITED',
    'HINDUSTAN FUSAL PRIVATE LIMITED',
    'AASHNA INVESTMENTS PRIVATE LIMITED',
    'MODEL DEVELOPERS PVT LTD',
    'INNOGROW TECHNOLOGIES LIMITED',
    'GLOBSYN TECHNOLOGIES LIMITED',
    'JAYAMARUTHI SOFTWARE SYSTEMS PRIVATE LIMITED',
    'VIS INDUSTRIES PRIVATE LIMITED',
    'TDK INDIA PRIVATE LIMITED',
    'JAMES WARREN TEA LIMITED',
    'SURYAVANSHI FINANCE AND INVESTMENTS PRIVATE LIMITED',
    'RISHIKESH KRR POWER PRIVATE LIMITED',
    'S S SERVICES PVT LTD',
    'SKB AGENCIES PVT LTD',
    'BHRIGUS SOFTWARE (INDIA) PRIVATE LIMITED',
    'VAM HOLDINGS LIMITED',
    'SAHARA RAYS PRIVATE LIMITED',
    'GEMINI COSMETICS PRIVATE LIMITED',
    'R MCDILL & CO PVT LTD',
    'ALPHA PURE PACK PRIVATE LIMITED',
    'KOHINOOR STEEL PRIVATE LIMITED',
    'PUNJAB AGRO FOODGRAINS CORPORATION LIMITED',
    'VORTEX ELECTRONICS PRIVATE LIMITED',
    'MOBIHIVE TECHNOLOGIES PRIVATE LIMITED',
    'PAPUSHA GASES PVT LTD',
    'ORBIT HOMES PRIVATE LIMITED',
    'BRILLIANT COMMERCIAL PVT LTD',
    'LUNAR CONSULTANTS PVT LTD',
    'AGNIKAL VYAPAAR PVT LTD',
    'MANIKA PLASTECH PRIVATE LIMITED',
    'SHIVAMSHREE BUSINESSES LIMITED',
    'TRADEBULLS SECURITIES PRIVATE LIMITED',
    'INDIA ADVANTAGE SECURITIES PRIVATE LIMITED',
    'INDOSOLAR LIMITED',
    'KARISHMA ENTERPRISES PRIVATE LIMITED',
    'BRAHMAPUTRA INFRASTRUCTURE LIMITED',
    'SUBROS LIMITED',
    'SANCO INDUSTRIES LIMITED',
    'SPL INDUSTRIES LIMITED',
    'TARINI INTERNATIONAL LIMITED',
    'J. K. PROTOMAX PRIVATE LIMITED',
    'PRAGYA MERCANTILE PRIVATE LIMITED',
    'BODHI ART LIMITED',
    'ZENITH DEVELOPERS PRIVATE LIMITED',
    'JHUNJHUNWALA CONSULTANTS PVT LTD',
    'ISPAT DAMODAR PRIVATE LIMITED',
    'BOOK MY ACCOUNTANT SERVICES PRIVATE LIMITED',
    'BHASANK FOODS PRIVATE LIMITED',
    'JCB CONSTRUCTIONS PVT LTD',
    'UNISOL INDIA PRIVATE LIMITED',
    'QUALITY PHARMA PRODUCTS PRIVATE LIMITED',
    'PAYAL POLYPLAST PRIVATE LIMITED',
    'INFOVALLEY EDUCATIONAL AND RESEARCH PRIVATE LIMITED',
    'SWARN BIOTECH PRIVATE LIMITED',
    'AXA PARENTERALS LIMITED',
    'SAKSHI ENTERPRISES PRIVATE LIMITED',
    'GREEN BIOPLAST PRIVATE LIMITED',
    'VACLINE TECHNOLOGIES PRIVATE LIMITED',
    'HRIDESH DEVELOPERS PRIVATE LIMITED',
    'WINTAGE ENGINEERS & CONSULTANTS PRIVATE LIMITED',
    'DURGA DEVELOPERS PRIVATE LIMITED',
    'YUVRAJ ENTERPRISES PRIVATE LIMITED',
    'RAHI CARE PRIVATE LIMITED',
    'RECORDERS & MEDICARE SYSTEMS PRIVATE LIMITED',
    'MAISONETTE INFRA ESTATES PRIVATE LIMITED',
    'SATYA TRUCKING PRIVATE LIMITED',
    'SJAIN VENTURES LIMITED',
    'SUNFLAG FILAMENTS LIMITED',
    'OSCAR INVESTMENTS LIMITED',
    'VRP TELEMATICS PRIVATE LIMITED',
    'CRYSTAL PROPERTIES PVT LTD',
    'SONEPAT (INDIA) PRIVATE LIMITED',
    'ARYAN ENERGY PRIVATE LIMITED',
    'BETRUST INDUSTRIES PRIVATE LIMITED',
    'VRITUOUS SOLUTION PRIVATE LIMITED',
    'MCCMAHADEO CONSTRUCTIONS PRIVATE LIMITED',
    'FLAVIEN TECHNOLOGIES PRIVATE LIMITED',
    'WORKDAY INDIA PRIVATE LIMITED',
    'ARUNIL VENTURES PRIVATE LIMITED',
    'KAWAII CONSULTING SERVICES PRIVATE LIMITED',
    'VINADA LEATHER PRIVATE LIMITED',
    'VASHISHTHA EMBROIDERIES PRIVATE LIMITED',
    'REALBIO ADVANCED SYSTEMS PRIVATE LIMITED',
    'XPEDIENT DIGITAL PRIVATE LIMITED',
    'RASAYANA HOSPITALITY PRIVATE LIMITED',
    'GOSHAWK INFOTECH PRIVATE LIMITED',
    'INTEGRACE PRIVATE LIMITED',
    'BIGFISH BRAND ACTIVATIONS PRIVATE LIMITED',
    'SORA SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'UVA WEALTH PRIVATE LIMITED',
    'KKSY GLOBAL MARKETING PRIVATE LIMITED',
    'MICROTEK FACILITY MANAGEMENT PRIVATE LIMITED',
    'ASPEN HABITAT PRIVATE LIMITED',
    'OXWELL INNOVATIONS PRIVATE LIMITED',
    'SMOTO AUTOMOTIVE PRIVATE LIMITED',
    'MEGH COMPUTING PRIVATE LIMITED',
    'SAVEERA INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED',
    'KOSTA MARINA AND CLUB PRIVATE LIMITED',
    'KAUZWAY ENTERPRISE PRIVATE LIMITED',
    'JATF MINORITY EDUCATION FOUNDATION',
    'POWERGRID JAWAHARPUR FIROZABAD TRANSMISSION LIMITED',
    'CLEAN SOLAR POWER (JODHPUR) PRIVATE LIMITED',
    'PLAYWRITE FOUNDATION',
    'TRIQUARK INTERNET PRIVATE LIMITED',
    'DATASHRUBS SOLUTIONS PRIVATE LIMITED',
    'MILLENNIUS TECHNOLOGIES PRIVATE LIMITED',
    'CHILLYDIGITAL SOLUTIONS PRIVATE LIMITED',
    'VIGAMEQ CONSULTANCY SERVICES PRIVATE LIMITED',
    'ADVANCED TRADE INTEGRATIONS & SOLUTIONS PRIVATE LIMITED',
    'ITAL SOLUTIONS PRIVATE LIMITED',
    'SKYMOND TRAVEL AND HOLIDAYS PRIVATE LIMITED',
    'DUBAM PRIVATE LIMITED',
    'NANI CASHEW PROCESSING PRIVATE LIMITED',
    'ARCS SOLUTIONS PRIVATE LIMITED',
    'IBX BUSINESS SOLUTIONS PRIVATE LIMITED',
    '4THVENTURE IOTSPACE PRIVATE LIMITED',
    'ROBOXEL INNOVATIONS PRIVATE LIMITED',
    'OPES HEALTH CARE PRIVATE LIMITED',
    'ALMISBAH CAR RENTAL AND AGRO-SUPPORT EQUIPMENTS PRIVATE LIMITED',
    'NAVITAS LED LIGHTING PRIVATE LIMITED',
    'VIABLE VACATIONS PRIVATE LIMITED',
    'BRAIN DRAIN CONSULTANTS PRIVATE LIMITED',
    'EBCOS INDIA SERVICES PRIVATE LIMITED',
    'FERNS NURSERY PRIVATE LIMITED',
    'KALLUVILA AGRO PRODUCTS PRIVATE LIMITED',
    'LAWRBIT LEXTECH INDIA PRIVATE LIMITED',
    'OMSONS GLASSWARE PRIVATE LIMITED',
    'SHANNA RESTAURANTS PRIVATE LIMITED',
    'JMDTS RETAIL PRIVATE LIMITED',
    'ABHYANK ACADEMY PRIVATE LIMITED',
    'PWR247 4U TECHSOL PRIVATE LIMITED',
    'EXCENTIA HOTELS AND BANQUETS PRIVATE LIMITED',
    'BUZZINCONTENT PUBLICATIONS PRIVATE LIMITED',
    'MATH MATICS FINSERV PRIVATE LIMITED',
    'TENSORBREW PRIVATE LIMITED',
    'ARCO LAB PRIVATE LIMITED',
    'JMDTS INNOVATIONS PRIVATE LIMITED',
    'ADANI WIND ENERGY KUTCHH FOUR LIMITED',
    'TEKS TECH SUSTAINABILITY SERVICES PRIVATE LIMITED',
    'ERIDIUM DIGITAL PRIVATE LIMITED',
    'SULIT MEDIA PRIVATE LIMITED',
    'GREENHUES ENVIROTECH PRIVATE LIMITED',
    'CAREFIT JADEX PRIVATE LIMITED',
    'SESA CARE PRIVATE LIMITED',
    'SHAPE FUSION (OPC) PRIVATE LIMITED',
    'CLEAN SOLAR POWER (KONCH) PRIVATE LIMITED',
    'INBOX TECHNOLOGIES PRIVATE LIMITED',
    'DOR EDUCATION FOUNDATION',
    'PLUMTREE DIGITAL MEDIA PRIVATE LIMITED',
    'PLUGO INDIA PRIVATE LIMITED',
    'OKTOSERV BUSINESS SERVICES PRIVATE LIMITED',
    'GLOBIZON OVERSEAS ADVISORS PRIVATE LIMITED',
    'PONDERNEW IDEAS PRIVATE LIMITED',
    'KANDLA SAGARMALA TRANSHIP PRIVATE LIMITED',
    'TECH3COMMERCE INNOVATION LAB PRIVATE LIMITED',
    'CLAIM GENIUS INDIA PRIVATE LIMITED',
    'VERIMPLOYEE PRIVATE LIMITED',
    'SIERENTZ GLOBAL MERCHANTS INDIA PRIVATE LIMITED',
    'JHAIHO PRIVATE LIMITED',
    'TREFT SYSTEMS INDIA PRIVATE LIMITED',
    'MADINA BROTHERS PRIVATE LIMITED',
    'SRIM ALLOY PRIVATE LIMITED',
    'BEQ IMAGING SOLUTIONS INDIA PRIVATE LIMITED',
    'ECGIT PRIVATE LIMITED',
    'BRANDSHOW CONSULTANCY SERVICES PRIVATE LIMITED',
    'DOUGLAX INDUSTRIES INDIA PRIVATE LIMITED',
    'PRACH RETAIL ECOMMERCE PRIVATE LIMITED',
    'WALLENTINO SURFACE ART PRIVATE LIMITED',
    'ELEM BUSINESS INDIA PRIVATE LIMITED',
    'PRITA DESIGNS PRIVATE LIMITED',
    'AL-SAMA PERSONNEL SOLUTIONS PRIVATE LIMITED',
    'RADIANT IMMIGRATION SERVICES PRIVATE LIMITED',
    'FINETONE ACOUSTIC PRIVATE LIMITED',
    'FLIMSY LIFESTYLE PRIVATE LIMITED',
    'STARDMC HOLIDAYS PRIVATE LIMITED',
    'ISKILLIZA SOLUTIONS PRIVATE LIMITED',
    'VONUX SOLUTIONS PRIVATE LIMITED',
    'NIMESA TECHNOLOGY PRIVATE LIMITED',
    'SONAGIR TEXTILES PRIVATE LIMITED',
    'MANGOTAXI SERVICES PRIVATE LIMITED',
    'INTELLIVATE TECHNOLOGIES PRIVATE LIMITED',
    'RURAL INNOVATION LABS PRIVATE LIMITED',
    'A2N TECHNOLOGIES PRIVATE LIMITED',
    'MISTAY HOSPITALITY PRIVATE LIMITED',
    'DIAMONDSTELLER TRADING PRIVATE LIMITED',
    'ANURAG PROSEHAT HEALTH INDUSTRIES PRIVATE LIMITED',
    'SAARTHEE TECHNOLOGY PRIVATE LIMITED',
    'COUVEUSE MINE & MINERALS PRIVATE LIMITED',
    'HINDON MERCANTILE LIMITED',
    'SER INDUSTRIES LIMITED',
    'MAHESHWAR MANAGEMENT AND ENTERPRISE LIMITED',
    'OM OPTEL INDUSTRIES PRIVATE LIMITED',
    'AISAR DEVELOPMENT PRIVATE LIMITED',
    'VEDANT VEDIKA AUTOMOBILES PRIVATE LIMITED',
    'GULF OIL LUBRICANTS INDIA LIMITED',
    'KARIT INFRATECH PRIVATE LIMITED',
    'VIMIX SOLUTIONS PRIVATE LIMITED',
    'ABHINAV CAPITAL SERVICES LIMITED',
    'MEP INFRASTRUCTURE DEVELOPERS LIMITED',
    'ROYAL CUSHION VINYL PRODUCTS LIMITED',
    'CYPRESS TRADESERVE PRIVATE LIMITED',
    'HIGH GROUND ENTERPRISE LIMITED',
    'APPLIST TECHNOLOGY PRIVATE LIMITED',
    'LIVEGAGE TECHNOLOGY SERVICES PRIVATE LIMITED',
    'DIGIBEE TECHNOLOGY PRIVATE LIMITED',
    'KASHEDI PARSHURAM HIGHWAYS PRIVATE LIMITED',
    'M.B. AGRIBIZ PRIVATE LIMITED',
    'ONPRICE INFOTECH PRIVATE LIMITED',
    'GUL CIVIL CONSTRUCTION PRIVATE LIMITED',
    'CAPRI GLOBAL HOUSING FINANCE LIMITED',
    'MILCHEN FOODS PRIVATE LIMITED',
    'AMATE PRODUCTS PRIVATE LIMITED',
    'ATRIA WIND POWER (BASAVANA BAGEWADI) PRIVATE LIMITED',
    'TECHNICOLOR INDIA PRIVATE LIMITED',
    'PYRAMID CORPORATE SERVICES PRIVATE LIMITED',
    'DIGIKORE STUDIOS LIMITED',
    'ELECTRONICA PLASTIC MACHINES LIMITED',
    'DEVTECH M2M LIMITED',
    'CLASSIC CITI PRIVATE LIMITED',
    'JCK INFRA PROJECTS LIMITED',
    'GENNEXT INDIA PRIVATE LIMITED',
    'SHYAM CENTURY FERROUS LIMITED',
    'ROHAN ENTERPRISES AND MAINTENANCE SERVICES PRIVATE LIMITED',
    'INTERNATIONAL COMMERCE LIMITED',
    'ABC INDIA LIMITED',
    'EVERGREEN TEXTILES LIMITED',
    'AURUM PROPTECH LIMITED',
    'AJANTA COMMERCE LTD',
    'ANGLO INDIA JUTE & TEXTILE INDUSTRIES PRIVATE LIMITED',
    'POLIGOF - MICRO HYGIENE (INDIA) PRIVATE LIMITED',
    'ENPEE HEALTHCARE LIMITED',
    'GAJANAN ORES PRIVATE LIMITED',
    'FICUS CONSULTING INDIA PRIVATE LIMITED',
    'SHIVASAKTHI TEXTILE INDUSTRIES PRIVATE LIMITED',
    'GAJANAN MINCHEM PRIVATE LIMITED',
    'GANGES LINES (INDIA) PRIVATE LIMITED',
    'ARI CONSOLIDATED INVESTMENTS PRIVATE LIMITED',
    'USIS TECHNOLOGIES PRIVATE LIMITED',
    'CYGNO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PKP WIND POWER PRIVATE LIMITED',
    'TNR CORPORATE SOLUTION PRIVATE LIMITED',
    'MLL EXPRESS SERVICES PRIVATE LIMITED',
    'VIVAAN SOLAR RAIL ROOFTOP PROJECT PRIVATE LIMITED',
    'SHJ INTERNATIONAL TECHNOLOGIES PRIVATE LIMITED',
    'CUBEDOTS PRIVATE LIMITED',
    'ANNOVA SOLUTIONS PRIVATE LIMITED',
    'QUALIPACK PACKAGINGS PRIVATE LIMITED',
    'ELMEF TESTING & CALIBRATION LABORATORIESPRIVATE LIMITED',
    'PUSHPA CINE EXHIBITORS PRIVATE LIMITED',
    'EVM AUTOKRAFT INDIA PRIVATE LIMITED',
    'NEWWAVES BIO FUELS INDIA PRIVATE LIMITED',
    'WELDING ALLOYS SOUTH ASIA PRIVATE LIMITED',
    'VIANA INDUSTRIES PRIVATE LIMITED',
    'STARCARE TECHNOLOGIES PRIVATE LIMITED',
    'GLOBE(INDIA) LTD.',
    'ELITE LEASINGS LIMITED',
    'SAGAR BUSINESS PRIVATE LIMITED',
    'SHREE MAHAVEER MINERALS PRIVATE LIMITED',
    'RRD TEX PRIVATE LIMITED',
    'TRELLIS HORTICULTURE INTERNATIONAL PRIVATE LIMITED',
    'BOGAR BIO BEE STORES PRIVATE LIMITED',
    'BLUE SKIPPER PRIVATE LIMITED',
    'AEROSPACE ENGINEERS PRIVATE LIMITED',
    'SM CAR PRIVATE LIMITED',
    'INTELLI AI TRILLION TECHNOLOGIES PRIVATELIMITED',
    'KANNAPPAN SAAI RECYCLERS PRIVATE LIMITED',
    'FRESHBOX WEB SERVICES PRIVATE LIMITED',
    'REVITSONE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'GETMYVISA TRAVEL SERVICES PRIVATE LIMITED',
    'ELECTRONICS MART INDIA LIMITED',
    'UNIFUDS INDIA PRIVATE LIMITED',
    'PGUT VISAFRONT IMMIGRATION PRIVATE LIMITED',
    'BIRLA JEWELS LIMITED',
    'ORRIL ENERGY SERVICES PRIVATE LIMITED',
    'GACL FINANCE PRIVATE LIMITED',
    'PLUS MAX DUTY FREE (PUNE) PRIVATE LIMITED',
    'RMB AIR CONDITION SYSTEM (INDIA) PRIVATELIMITED',
    'TCTS PRIVATE LIMITED',
    'MODI VITTLES PRIVATE LIMITED',
    'VIVAAN OPERATIONS PRIVATE LIMITED',
    'RKG RETAIL VENTURES PRIVATE LIMITED',
    'AGRANAM BUSINESS ADVISORY AND SOLUTIONS PRIVATE LIMITED',
    'STEPBUCK TECHNOLOGIES PRIVATE LIMITED',
    'AKSSAI PROJEXEL PRIVATE LIMITED',
    'PLABS VENTURES PRIVATE LIMITED',
    'TJC INDIA PRIVATE LIMITED',
    'HAAS MINERALS PRIVATE LIMITED',
    'VISWAJIT BUILDER PRIVATE LIMITED',
    'RUPAL LEISURE PRIVATE LIMITED',
    'DE-BRIGHT GUIDANCE SERVICES PRIVATE LIMITED',
    'SPICERETREAT HOSPITALITY SERVICES PRIVATE LIMITED',
    'ITROIX TECHNOLOGIES PRIVATE LIMITED',
    'ACHARAJ FOODS AND BEVERAGES PRIVATE LIMITED',
    'HIGHMILER TYRES PRIVATE LIMITED',
    'CREATIVE INDIA PRIVATE LIMITED',
    'INGUZ TOURS & EVENTS SERVICES PRIVATE LIMITED',
    'HANNU KNITTERS PRIVATE LIMITED',
    'ELYSIAN DIGITAL SERVICES PRIVATE LIMITED',
    'CATES DESIGN INTERNATIONAL PRIVATE LIMITED',
    'SABRAS ENTERPRISE PRIVATE LIMITED',
    'HAAK EXIM PRIVATE LIMITED',
    'SHOPPEBOARD SOURCING SOLUTIONS PRIVATE LIMITED',
    'NABSTER POWER PRIVATE LIMITED',
    'PLANSINFO TECHNOLOGIES PRIVATE LIMITED',
    'GADDIWALE INFOTECH PRIVATE LIMITED',
    'QA TESTING LABORATORIES PRIVATE LIMITED',
    'AMPSOLAR URJA PRIVATE LIMITED',
    'EMPREO WHEELS PRIVATE LIMITED',
    'BAGUR LOGISTICS PARK PRIVATE LIMITED',
    'GREENMASTER WELLNESS PRIVATE LIMITED',
    'PIOMBINO STEEL LIMITED',
    'EAVETOP SOFTTECH PRIVATE LIMITED',
    'PROOFWORD DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'WHIRLDATA LABS PRIVATE LIMITED',
    'PETREGAZ KRISHNAPATNAM PRIVATE LIMITED',
    'SKYLARK SMARTMETERS PRIVATE LIMITED',
    'VAU TECHNOVATIONS LIMITED',
    'GM ELEKTRA PRIVATE LIMITED',
    'ELECTROSOLVE INDIA PRIVATE LIMITED',
    'HRTI PRIVATE LIMITED',
    'OLYMPEO RIVERSIDE PHASE I FLAT OWNERS ASSOCIATION',
    'SET INDIA BUSINESS PRIVATE LIMITED',
    'GIPASS ENGINEERING SERVICES PRIVATE LIMITED',
    'OUTRIS IMAGING PRIVATE LIMITED',
    'TSOLITSS INDIA PRIVATE LIMITED',
    'SYNAPSE COMMUNICATION DESIGN PRIVATE LIMITED',
    'MM SYSTEMS AND EQUIPMENTS PRIVATE LIMITED',
    'WINTRO VENTURES PRIVATE LIMITED',
    'ZIFFYHOMES INDIA PRIVATE LIMITED',
    'DELHI WASTE MANAGEMENT NAJAFGARH PRIVATELIMITED',
    'LUXIFER BEAUTY NUTRITION PRIVATE LIMITED',
    'GEARSTACK TECH STUDIO (OPC) PRIVATE LIMITED',
    'PRECODE TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'DERMACEUTICS INDIA PRIVATE LIMITED',
    'ENDRESS + HAUSER & CHAVARE ENGINEERING (JV) PRIVATE LIMITED',
    'ASIATEK SPACE DEVELOPERS PRIVATE LIMITED',
    'SOMYA CARS PRIVATE LIMITED',
    'SSSH EQUIPMENTS PRIVATE LIMITED',
    'CISWW ENGINEERING INDIA PRIVATE LIMITED',
    'MYLES AUTOMOTIVE TECHNOLOGIES PRIVATE LIMITED',
    'SIGMASOFT INFOTECH PRIVATE LIMITED',
    'FINPAL BOOKKEEPING PRIVATE LIMITED',
    'SUNVIRON PRIVATE LIMITED',
    'MONT VERT BUILDERS PRIVATE LIMITED',
    'TREXEDIA TRAVEL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SAFESTART INDIA PRIVATE LIMITED',
    'SBSOL DIGITAL PRIVATE LIMITED',
    'TRADECON RESOURCES PRIVATE LIMITED',
    'ITSALOGY CONSULTANCY SERVICES PRIVATE LIMITED',
    'ATNU SOLAR PRIVATE LIMITED',
    'SMOLLAN INDIA CSR FOUNDATION',
    'RAMKI TECHNOLOGIES PRIVATE LIMITED',
    'CKL SONS INVESTMENT PRIVATE LIMITED',
    'RESEARCH INNOVATION AND SCIENTIFIC ENTREPRENEURSHIP FOUNDATION IISER',
    'SHAILAJA INDUSTRIAL SUPPLIERS PRIVATE LIMITED',
    'AERPACE COMMUNICATIONS PRIVATE LIMITED',
    'WARUKSHA LABORATORIES PRIVATE LIMITED',
    'GIGMO SOLUTIONS PRIVATE LIMITED',
    'OPEN DHI PRIVATE LIMITED',
    'EPI-USE INDIA PRIVATE LIMITED',
    'VOSAIO TRAVEL INDIA PRIVATE LIMITED',
    'DYWIDAG SYSTEMS INTERNATIONAL INDIA PRIVATE LIMITED',
    'MINTO SOFTECH PRIVATE LIMITED',
    'ROYAL MEADOWS YACHTING INDIA PRIVATE LIMITED',
    'EIFLE CONSULTING SERVICES (OPC) PRIVATE LIMITED',
    'TENACITICS INDIA PRIVATE LIMITED',
    'Make positive software solutions private limited',
    'MANTENA MODULARS PRIVATE LIMITED',
    'G.l. communications (india) private limited',
    'Zeomega infotech private limited',
    'Ntc softech india private limited',
    '24/7 networks private limited',
    'Jba infotech private limited',
    'Velankani software private limited',
    'Opengear networks private limited',
    'I- mobile network engineering private limited',
    'Beqisoft technologies private limited',
    'Criticaltouch infotech services private limited',
    'Threeaxis engineering services private limited',
    'Amplebit energy solutions private limited',
    'Careercubicle technologies private limited',
    'Phoenix infomatrix private limited',
    'Vermis technology labs private limited',
    'Datafloat technologies india private limited',
    'Trinetz technology services private limited',
    'Lastra niraj private limited',
    'Everest information & technologies private limited',
    'Saffron media private limited',
    'Madhavi desai consulting private limited',
    'Mindset Securities Private Limited',
    'Itisl technologies private limited',
    'Rushabh marketing solutions private limited',
    'Biztact solutions private limited',
    'R d g micro electronics private limited',
    'Adventity global services private limited',
    'Mindcraft software private limited',
    'Suraj informatics private limited',
    'Printo document services private limited',
    'Infosols econsultants india private limited',
    'Rajtaru infotech entertainment limited',
    'Crave infotech and consultancy services private limited',
    'Cybersites india technologies private limited',
    'Infowan technologies private limited',
    'Twilight entertainment private limited',
    'BIOENABLE TECH SERVICES PRIVATE LIMITED',
    'Whiz software solutions private limited',
    'Axat technologies private limited',
    'Socheers infotech private limited',
    'Arigel software private limited',
    'Singh semiconductors & systems private limited',
    'Websource technologies limited',
    'Teamnet solutions private limited',
    'Innovapoint infotech private limited',
    'Pinnac technologies private limited',
    'Carpro systems india private limited',
    'Gocloudz technologies private limited',
    'Indu solutions private limited',
    'Adi strategies india private limited',
    'Kalp technologies private limited',
    'Maximojo software private limited',
    'Rapidera technologies private limited',
    'APPLICATION SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'Satori business services private limited',
    'Exusia india private limited',
    'Altius data solutions private limited',
    'Intellinet datasys private limited',
    'Stezier technology consulting private limited',
    'Eninisa technologies private limited',
    'Edvantech solutions private limited',
    'I horse technologies private limited',
    'Acentria technologies private limited',
    'Optus infotech private limited',
    'Eclat informatix india private limited',
    'Navas audio visual private limited',
    'Sri amogha educational services private limited',
    'BNY MELLON TECHNOLOGY PRIVATE LIMITED',
    'Niyati technologies private limited',
    'Cloudsdirect web solutions private limited',
    'Cogzidel technologies private limited',
    'Shreyas tech solutions private limited',
    'Ardhika software technologies private limited',
    'Pantheon india private limited',
    'Focuzcloud technology private limited',
    'Cordiant learn foundation',
    'Origin techserve private limited',
    'Delta itech solutions private limited',
    'Ashvich infotek private limited',
    'Bisquared consulting private limited',
    'Juara it solutions private limited',
    'Coip solutions private limited',
    'Innofied solution private limited',
    'Dipti consultancy private limited',
    'Access mobile (india) private limited',
    'Key network private limited',
    'Gajjar technologies private limited',
    'Bioorganics and applied materials private limited',
    'Polyclone bio services private limited',
    'ECRON ACUNOVA LIMITED',
    'Powersem semiconductors private limited',
    'Ushmaa technologies pvt ltd',
    'Owens-corning (india) private limited',
    'Synthesis equity research foundation private limited',
    'Athreya enterprises private limited',
    'Dharmapuri papers mills private limited',
    'Dinman polypacks private limited',
    'Taj mahal designer hotels private limited',
    'Rajspin officers welfare foundation private limited.',
    'Adventures (india) private limited',
    'PURESAIENS INDIA PRIVATE LIMITED',
    'Tyabji holding and investing company private limited',
    'Oto motive products (india) private limited',
    'Accent controls private limited',
    'SUPREME ENGINEERING LIMITED',
    'Bright star investments private limited',
    'Sunita commercials p ltd',
    'Chevy trading pvt ltd',
    'Sanyog chemicals private limited',
    'Rupa organics private limited',
    'Legend housing private limited',
    'Nirmal bang securities private limited',
    'Laukik paper industries private limited',
    'Sam industries limited',
    'Orient beverages ltd',
    'Indo cotspin limited',
    'Indus fila limited',
    'Ventura textiles limited',
    'Castrol india limited',
    'Lime chemicals limited',
    'Kokuyo camlin limited',
    'Sandu pharmaceuticals limited',
    'Fervent synergies limited',
    'National plastic technologies limited',
    'Facor steels limited',
    'Elango industries limited',
    'Steel strips wheels ltd',
    'R.s.infra-transmission limited',
    'Baroda extrusion limited',
    'Alkali metals ltd.',
    'India radiators limited',
    'REVENT PRECISION ENGINEERING LIMITED',
    'Elgi equipments limited',
    'Gujarat craft industries limited',
    'PITTI ENGINEERING LIMITED',
    'Cable corporation of india limited',
    'Precision wires india limited',
    'Mangalya soft-tech limited',
    'Mirc electronics limited',
    'ZF COMMERCIAL VEHICLE CONTROL SYSTEMS INDIA LIMITED',
    'United breweries limited',
    'PROZONE REALTY LIMITED',
    'Duke offshore ltd',
    'Mcleod russel india limited',
    'Swasti vinayaka art and heritage corporation limited',
    'Indianivesh capitals limited',
    'BCPL INTERNATIONAL LIMITED',
    'OLECTRA GREENTECH LIMITED',
    'City union bank limited',
    'Indbank merchant banking services limited',
    'Asit c mehta financial services limited',
    'Dolphin investment limited',
    'Thakral services (india) limted',
    'Quest softech (india) limited',
    'Hov services limited',
    'Vms industries limited',
    'Rolta india limited',
    'Transgene biotek limited.',
    'Entertainment network (india) limited',
    'Cravatex limited',
    'Reliance infrastructure limited',
    'Astec lifesciences limited',
    'Micromax informatics limited',
    'Pethe textiles private limited',
    'Toppers tutorial private limited',
    'Ahilandeeswari farms private limited',
    'Choleeswara farms private limited',
    'Saroj plantations private limited',
    'FAMYSHINE PRIVATE LIMITED',
    'Avani agricultural farms private limited',
    'DILASA AGRO PROCESSORS PRIVATE LIMITED',
    'Redcup foods private limited',
    'Alchemy processors private limited',
    'Basar foods private limited',
    'VARUN JALAN ADVISORS PRIVATE LIMITED',
    'Reliance ambit trade private limited',
    'Reliance prolific commercial private limited',
    'Creative agrotech private limited',
    'Gargi bio tek private limited',
    'Vighnaharta agri-horti producer company limited',
    'Hariyali biofarms private limited',
    'INDIA AGROVISION IMPLEMENTS PRIVATE LIMITED',
    'Mandarin jojoba farms private limited',
    'Mandarin jojoba private limited',
    'SURESAA TEA LIMITED',
    'Pandalur plantations private limited',
    'Fine tea plantation resort private limited',
    'Karadi caves plantation resort private limited',
    'Elysian plantation resort private limited',
    'Bloom plantation and resort private limited',
    'Flourish plantation resort private limited',
    'Oland plantation resort private limited',
    'Bear falls plantation resort private limited',
    'Bansidhar badridass modi pvt ltd',
    'Gujarat tea processors and packers limited',
    'Sankar tea co pvt ltd',
    'Spectro-flux engineering technologies private limited',
    'DIGITRON ELECTRONICS PVT LTD',
    'Unitread engineering pvt ltd',
    'TOP LASER TECHNOLOGY PRIVATE LIMITED',
    'Sunex tube tools private limited',
    'Gravotech engineering private limited',
    'Accrete engineering private limited',
    'Marks pryor marking technology private limited',
    'Aura laserfab private limited',
    'Conductix-wampfler india private limited',
    'Ia flow elements private limited',
    'S&s power switchgear equipment limited',
    'Sabar engineering private limited',
    'Technocraft tabla formwork systems private limited',
    'Emkay appliances private limited',
    'Raajratna electrodes private limited',
    'Ponnmoney marketing private limited',
    'Shilpa international (impex) pvt. ltd.',
    'Bio-therapeutic computers private limited',
    'Aptmicro solutions limited',
    'Modtech automation private limited',
    'Axitech nanosystems private limited',
    'Moze tech solutions private limited',
    'Multi infomedia private limited',
    'Reliance wimax limited',
    'Leviathan systems private limited',
    'Answer computer (india) private limited',
    'Abirami electronics private limited',
    'Concord united products private limited',
    'Lym technologies private limited',
    'Kalyx infotech private limited',
    'Excel eltech (india) private limited',
    'Neurotronix systems india private limited',
    'Hyson systems limited',
    'Nav bharat clearing agents private limited',
    'M.s.sorters private limited',
    'Sun energy systems india private limited',
    'Cantech engineers private limited',
    'PROPEL INDENERGY SOLUTIONS PRIVATE LIMITED',
    'Hi-tech forgings (bangalore) private limited',
    'Es electronics (india) private limited',
    'Intelux electronics private limited',
    'Goa-plast private limited',
    'Toyama controls and systems private limited',
    'Vedanth power equipments private limited',
    'Prabhat powertech private limited',
    'Datsons electronics pvt ltd',
    'Svpc automotive private limited',
    'Dyna spede integrated systems private limited',
    'Ultracab (india) limited',
    'Atlas cables and accessories private limited',
    'Ganpati wire ropes private limited',
    'Cosphi electric india private limited',
    'Adroit power systems india private limited',
    'BHAVIK AND NIRAJ ENERGY PRIVATE LIMITED',
    'Phos technologies private limited',
    'Vertex power solutions private limited',
    'Twin city fan india private limited',
    'Safe infratech private limited',
    'Kandolite lamps private limited',
    'Leolite lighting and electronic private limited',
    'Bhavana lighting private limited',
    'Asian tube lights(india) private limited',
    'Jomson controls & automation private limited',
    'Srico marketing private limited',
    'Light and magic automation private limited',
    'Dhruva automation and controls private limited',
    'Coupler enterprises private limited',
    'Coral coil india private limited',
    'Trinergy suvire private limited',
    'Omr bagla automotive systems india limited',
    'NIDEC MOBILITY INDIA PRIVATE LIMITED',
    'Chaitra associates power electronics private limited',
    'DELTAPRO TECHNOLOGIES PRIVATE LIMITED',
    'Hical nse electronics private limited',
    'Bliss electricals private limited',
    'Omega resistors private limited',
    'Rongxin power electronic india private limited',
    'Hical Infra Private Limited',
    'Abletech electro engineers private limited',
    'Wevin private limited',
    'Nikitech electric private limited',
    'Psk engineering private limited',
    'Eka engineering technics private limited',
    'Jove electronics private limited',
    'Host exports (india ) private limited',
    'Precious electro chem india private limited',
    'American tec electronic india private limited',
    'Rei electronics private limited',
    'Energywin technologies private limited',
    'Nandratan foundry and engineering works pvt ltd',
    'Elcom electronics pvt ltd',
    'Dhiren electronics pvt ltd',
    'Vinayak transmission products private limited',
    'Ngs solutions com private limited',
    'Aidin technologies private limited',
    'Bharti maxtel private limited',
    'Thomson video networks india private limited',
    'Euroflex transmissions (india) private limited',
    'Finecons private limited',
    'Poly pipes india private limited',
    'Big berry retail private limited',
    'Cnergy orthocare private limited',
    'J thomas and company auctioneers tamil nadu private limited',
    'Axiom international projects ltd',
    'Wellman mercantiles pvt ltd',
    'Samtel vinimay pvt ltd',
    'Pandora barter pvt.ltd.',
    'Bright impex pvt ltd',
    'Moneywise financial services private limited',
    'Kaushal vin-com private limited',
    'Tailorbird vincom private limited',
    'Greenfield vintrade private limited',
    'Suruchi sales private limited',
    'Lookline vinimay private limited',
    'Everlight international private limited',
    'Brijkishor trading private limited',
    'Lal mahal retail limited',
    'Infinity duty free services private limited',
    'Ansuya impex private limited',
    'Streamline refrigeration private limited',
    'Akshath trading company private limited',
    'Regency retail private limited',
    'Weilingdon retail private limited',
    'SAI RETAIL INDIA LIMITED',
    'Sanatan mercantile private limited',
    'Coimbatore tyres and treads private limited',
    'Skylark warehousing solutions private limited',
    'Mimas trading private limited',
    'Jenner air conditioning international private limited',
    'Rebecca suppliers private limited',
    'Color palette private limited',
    'Danube buildmart private limited',
    'Creatribes media private limited',
    'Sacheti sons trading private limited',
    'Antariksh realtors private limited',
    'Mars fragrance private limited',
    'Trident retail ventures private limited',
    'ROYALS INTERNATIONAL TRADE AND ALLIED PRODUCTS PRIVATE LIMITED',
    'North field impex private limited',
    'G s exports private limited',
    'POWERH2O WATER TECHNOLOGIES PRIVATE LIMITED',
    'Accutech network systems private limited',
    'Nova weatherworks acr (india) private limited',
    'Sri veena telesystems private limited',
    'Kohli export packaging india private limited',
    'Globizz synergy private limited',
    'Rania trading private limited',
    'Home interior designs e-commerce private limited',
    'Maalgaadi design store private limited',
    'Rhydo technologies private limited',
    'Rudrani impex private limited',
    'Leon tools private limited',
    'AMANS ATLANTIC LIMITED',
    'Above solutions india private limited',
    'I-dreams trade & events private limited',
    'Reliance comtrade private limited',
    'Charon trading private limited',
    'Satco traders (india) private limited',
    'FIRST INTERNET TELEVISION PRIVATE LIMITED',
    'Adam associates utility engineers private limited',
    'Swarnamayee marketing private limited',
    'SHRIVALLABH PITTIE TEXTILES JHALAWAR PRIVATE LIMITED',
    'Induco export import private limited',
    'ARUNAI POWER INFRA PRIVATE LIMITED',
    'India steel international private limited',
    'Chouki dhani motels (gujarat) private limited',
    'SHELTREX KARJAT PRIVATE LIMITED',
    'Shantinirmal resorts private limited',
    'Samovasarna resorts private limited',
    'Polmon vesnfer private limited',
    'Varun hospitality and allied services private limited',
    'Coastel sun view hotels private limited',
    'Seawaves hospitality private limited',
    'Aikido lifestyle private limited',
    'Hotel rock private limited',
    'Rising hotel ltd.',
    'Ahura restaurants private limited',
    'Vaama resorts and recreation private limited',
    'Dharamshala health resorts limited',
    'Dlf aspinwal hotels private limited',
    'Ict international cargo transport india private limited',
    'Supreme trans logistics private limited',
    'Shree shubham logistics limited',
    'KINGS METAL MART PRIVATE LIMITED',
    'Mc logistics india private limited',
    'Leaseplan fleet management india private limited',
    'Excel marine services pvt ltd',
    'Mitsutor shipping agency pvt.ltd.',
    'Pfs shipping (inda) limited',
    'Daiichi chuo shipping (india) private limited',
    'Mahalaxmi shipping private limited',
    'VIZAG PROFILES LOGISTICS PRIVATE LIMITED',
    'Shanghai shipping private limited',
    'Varun maritime limited',
    'BLUE MOON TECH SOLUTIONS PRIVATE LIMITED',
    'Trailblazer vacations private limited',
    'APML PRIVATE LIMITED',
    'One world travel solutions limited',
    'Skylink airline ticket centre private limited',
    'Fourforces travels private limited',
    'Pax freight express private limited',
    'Milap logistics private limited',
    'Colorful knowledge trip private limited',
    'Logilink india private limited',
    'Amlf logistics private limited',
    'UPSILON TECH PRIVATE LIMITED',
    'Ambica logistics private limited',
    'Plenus global logistics solutions private limited',
    'Sarveshwar logistics services private limited',
    'VENUS EXPRESS CARGO & LOGISTICS PRIVATE LIMITED',
    'Traveltime cars india private limited',
    'Cargo carters & logistics private limited',
    'Zeus air services private limited',
    'Sgl container line private limited',
    'K.n. logistics private limited',
    'R.c. freight forwarders private limited',
    'Express carriers limited',
    'Worldwide logistics (india) private limited',
    'Sun maritime private limited',
    'Berggruen logistics (india) private limited',
    'Ennore cargo container terminal private limited',
    'Gubba cold storage private limited',
    'Gubba green cold private limited',
    'Mohini infra private limited',
    'Sea alliance logistic and supply services private limited',
    'Ap logistics n agencies private limited',
    'N. g. logistics solutions private limited',
    'Shree rajlaxmi logistics (calcutta) private limited',
    'LOHANA',
    'S EXIM PRIVATE LIMITED',
    'Thermoline marketing private liimited',
    'Touchstone teleservices private limited',
    'Ssg stelco private limited',
    'Moirae generics private limited',
    'Harsha technologies private limited',
    'Spectra punj lloyd limited',
    'Solmaarc marketing agencies private limited',
    'Vijaylakshmi associates private limited',
    'Norfiox vincom pvt ltd',
    'Just overseas pvt. ltd.',
    'Numantec enterprises private limited',
    'Lasany impex private limited',
    'Komax automation india private limited',
    'Clyp engines private limited',
    'Tata services limited',
    'Barooahs and associates pvt ltd',
    'Fortuna merchants pvt ltd',
    'Archivista engineering services private limited',
    'Temcam engineering pvt. ltd.',
    'Chatterjee management services pvt ltd',
    'Inspection syndicate of india private limited',
    'Lifeline systems pvt ltd',
    'Amritson towers (india) pvt ltd',
    'High rise enterprises private limited',
    'Sachee fragrances and chemicals limited',
    'Western (india) sales pvt ltd',
    'Nicolian securitiesw and finance pvt ltd',
    'Kei metals pvt ltd',
    'Just kirat private limited',
    'SHINRYO SUVIDHA ENGINEERS INDIA PRIVATE LIMITED',
    'Kancord wires private limited',
    'Woodman industries private limited',
    'Radico khaitan finance limited',
    'I-helix speciality products india private limited',
    'Pine tree venture capitalists private limited',
    'United decoratives pvt ltd',
    'Bon bon leather wear private limited',
    'Raj rexine private ltd',
    'Kanshi steel works private ltd',
    'Shakuntalam properties private ltd',
    'Superb advertisers private limited',
    'Beach international pvt ltd',
    'Megastock investment services private limited',
    'Gkc management services private limited',
    'Fridace engineers private ltd',
    'Trak consolidated consultants private limited',
    'A p securitas private limited',
    'Satya holding private ltd',
    'Wings pharmaceuticals pvt ltd',
    'Sushant properties and developers pvt ltd',
    'Anshana forests private limited',
    'Surjit plantations private ltd.',
    'Amrit plantations private limited',
    'ROSMERTA AUTOTECH LIMITED',
    'Prem softech private. ltd.',
    'Bco consulting private limited',
    'Ginni india pvt ltd',
    'Ccl usha martin stressing systems limited',
    'Acme medical services private limited',
    'Pole-ads advertising private limited',
    'Positive advertising private limited',
    'Technopak advisors private limited',
    'Cwick (import consolidations) private ltd',
    'Creative mileage solutions private limited',
    'India infomedia private limited',
    'Aarham engineers private limited',
    'V d r leasing and credit company private limited',
    'Prayag polymers private limited',
    'Saraswati food products private limited',
    'In shoe tecnik private limited',
    'Trip travels private limited',
    'ACEMONEY INTERMEDIARIES PRIVATE LIMITED',
    'CARE AUTO SOLUTIONS PRIVATE LIMITED',
    'Jadie consultants private limited',
    'Careerist management consultants private limited',
    'Paper machineries delhi pvt ltd',
    'Land mark tours and travels pvt.ltd.',
    'Mohan clothing company private limited',
    'Varco-sara (india) private limited',
    'Transel impex private limited',
    'Vijay appliances and associates private limited',
    'Afimac associates private ltd',
    'Vikram agro private limited',
    'Competent fabricators private limited',
    'Shebang private limited',
    'LONGTAIL CAPITAL LIMITED',
    'Nirmal promoters private limited',
    'Express roadways private limited',
    'Tulika appliances private limited',
    'Involute engineering private limited',
    'Vaneet textile private limited',
    'Bee gee tee enterprises private limited',
    'Gypsum structural india private limited',
    'Cache digitech private limited',
    'Credible management and consultants private limited',
    'Suryodaya plantations private limited',
    'Multiplex capital limited',
    'Stitchwell qualitex private limited',
    'Jenny polywood industries limited tfr. from a.p. to delhi',
    'Lastango fashions pvt ltd',
    'PREM N KAPUR ASSOCIATES PRIVATE LIMITED',
    'Blm securities private limited',
    'Kochhar industries private limited',
    'Htpl logistics private limited',
    'Inimeg consultants private limited',
    'Indian micro electronics private limited',
    'Suburban finance and investments private limited',
    'DEZIRE PACKAGINGS PRIVATE LIMITED',
    'Orient portfolio private limited',
    'Amici securities limited',
    'Spfl securities limited',
    'Smc share brokers limited',
    'Chinar farms private limited',
    'Welcome destinations private limited',
    'V.v.t. communications private limited',
    'Eco holidays private limited',
    'Eltee printmaster private limited',
    'Stone craft (india) private limited',
    'Erm india private limited',
    'Prime point klinik private limited',
    'Mag filters and equipments private limited',
    'Empire services private limited',
    'S c cottage craft emporium private limited',
    'UNO MINDARIKA PRIVATE LIMITED',
    'Solvay specialities india private limited',
    'GAJJUMAL FATEHCHAND AND SONS PRIVATE LIMITED',
    'Services international limited',
    'Dkb optical international private limited',
    'CHERESO LIFE SCIENCES PRIVATE LIMITED',
    'Purnasons pvt ltd',
    'Sai fertilizers private limited',
    'Mls healthcare private limited',
    'Speedways tyre limited',
    'Caprilon polymers pvt ltd',
    'PROFOUND CEMENT WORKS LIMITED',
    'Allied cement co pvt ltd',
    'Gold plast international private limited',
    'Pittie polymers private limited',
    'Indian phosphate limited',
    'Northland rubber private limited',
    'Bright indotech private limited',
    'Max indo private limited',
    'Rubber general industries india private limited',
    'Swetal ispat limited',
    'Jagannath extrusion india limited',
    'Progressive metals private limited',
    'Goyal steels private limited',
    'Sumetco alloys private limited',
    'Apex alloy steel private limited',
    'Swastika castal ltd',
    'Cataliq laboratories private limited',
    'Shri karvir nivasini mahalaxmi ispat private limited',
    'Sarabhai Chemicals (India) Private Limited',
    'Mayur and devang industries limited',
    'RAVI STEEL AND RENEWABLES PRIVATE LIMITED',
    'MARUTHI PLASTICS & PACKAGING (CHENNAI) PRIVATE LIMITED',
    'Prime drugs pvt ltd',
    'Daniel ceramics private limited',
    'Sinbro commercial pvt. ltd.',
    'Multifilms plastics private limited',
    'GRAFITE CERAMICS PRIVATE LIMITED',
    'D m p projects pvt ltd',
    'Coral gold tiles private limited',
    'Ceramtec india innovative ceramic engineering private limited',
    'Patel brass works private limited',
    'Gradient wire products private limited',
    'Anu extrusions private limited',
    'Bajaj precision forgings pvt ltd',
    'Chakradhar chemicals private limited',
    'BIKANER CERAMICS PRIVATE LIMITED',
    'Rudra jewells private limited',
    'Deepsone non-ferrous rolling mills private limited',
    'Durga jewellers & gems private limited',
    'Ceramic tableware private limited',
    'Swastik grindwell private limited',
    'Castal extrusion pvt ltd',
    'Swastika steel & allied products private limited',
    'Manju concrete fabricators and developers private limited',
    'Brahmaputra concrete private limited',
    'Roxul-rockwool insulation india private limited',
    'Avana ecobuilt materials private limited',
    'Seisin refractories private limited',
    'Kds jewellers private limited',
    'Enam castings private limited',
    'Nicks auto industries private limited',
    'S p agarwala and company pvt ltd',
    'Vaid enterprises (india) private limited',
    'Anand carbo private limited',
    'Bajaj industries pvt ltd',
    'B p steel industries private limited',
    'Kaff appliances (india) private limited',
    'ISCAR INDIA PRIVATE LIMITED',
    'Fertiplant engineering company private limited',
    'Sandeep metalcraft private limited',
    'L&T ENERGY HYDROCARBON ENGINEERING LIMITED',
    'Versatile alucast private limited',
    'Gwalior webbing co. pvt. ltd.',
    'Parikh metaliks private limited',
    'Sathyam fasteners private limited',
    'Koyas fasteners private limited',
    'V b overseas private limited',
    'R s cookware private limited',
    'Delhi brass and metal works private limited',
    'Imt cables private limited',
    'Kisaan techno forge private limited',
    'Udyogi moulders private limited',
    'ERIGO ENTERPRISES PRIVATE LIMITED',
    'PROBAT INDIA PRIVATE LIMITED',
    'Shankar moulding limited',
    'Chamunda pharma machinery private limited',
    'L&T REALTY DEVELOPERS LIMITED',
    'Raigarh plastics private limited',
    'Varmora ceramics private limited',
    'Calcutta ferrous ltd',
    'Brasstech engineering private limited',
    'Cpl jewellers private limited',
    'Aric engineers private limited',
    'Galvi engineering private limited',
    'Raunaq engineering private limited',
    'Chilton refrigeration pvt ltd',
    'Emmessar technologies limited',
    'First technologies (india) private limited',
    'High-pack packaging machines private limited',
    'Topcon sokkia india private limited',
    'Uv graphic technologies private limited',
    'Robot components private limited',
    'Ontario electromechanica private limited',
    'Kawa press systems private limited',
    'Navjivan packaging machinery private limited',
    'See linkages private limited',
    'Agh altech private limited',
    'Sukam jewellers private limited',
    'PASL PRIVATE LIMITED',
    'Fiza developers and inter-trade private limited',
    'Give vinduet windows and doors private limited',
    'S s p private limited',
    'Kaapi machines (india) private limited',
    'Holisol logistics private limited',
    'Patton logistics services private limited',
    'Daudayal hotels pvt ltd',
    'Modern gem and designer private limited',
    'Snowland holidays private limited',
    'Quick aviation services private limited',
    'Jet concepts private limited',
    'Abm automation private limited',
    'ALTX ADVISORS INDIA PRIVATE LIMITED',
    'Vendmart retail private limited',
    'Westside hotel services private limited',
    'Sidcul concor infra company limited',
    'The harness transport and shipping private limited',
    'Kollam royal park hotel and resorts private limited',
    'Olivia hospitalities private limited',
    'Fast track logistics private limited',
    'East bound tours and travels private limited',
    'Jas culinary specialities private limited',
    'RAJASTHAN FORT AND PALACE PRIVATE LIMITED',
    'Kalpa taru heritage hotels private limited',
    'P.d.shah & sons cold storage private limited',
    'New kenilworth hotel private limited',
    'R & R RESORTS PVT LTD',
    'B MAZUMDER SAMAJPATI & SONS HOTELS PVT LTD',
    'Roland hotels private limited',
    'Tai projects private limited',
    'Carnation retreat pvt ltd',
    'Kay bouvet engineering ltd',
    'Shree kamakhya roadlines private limited',
    'Humming wheels private limited',
    'Abad motels and resorts private limited',
    'DGS TRANSLOGISTICS INDIA PRIVATE LIMITED',
    'Immanuel aviation and cargo services private limited',
    'Taj air limited',
    'Sai containers private limited',
    'Atg holidays private limited',
    'JSR REALBUILD PRIVATE LIMITED',
    'Trans orient holidays private limited',
    'Cagliostro tourism private limited',
    'Bhandari warehousing and logistics private limited',
    'Seaymer marine solutions private limited',
    'Travel designer india private limited',
    'Shreeji gala travel consultant private limited',
    'Raveendra hospitality private limited',
    'Sahaj bharti travels private limited',
    'SABSAN TRAVEL & TOURS PRIVATE LIMITED',
    'Great indian outdoors private limited',
    'Ganpati marine enterprises private limited',
    'Patiala cargo roadlines limited',
    'Flying green carriers private limited',
    'Ahl holidays private limited',
    'Matrix freight systems private limited',
    'Sash aps integrated logistics private limited',
    'B m roadlines private limited',
    'Transline logistics private limited',
    'Genius world hospitality private limited',
    '4 u travel services private limited',
    'Smile tours and travels private limited',
    'New delhi aviations private limited',
    'Worldwide tour services private limited',
    'WORK BETTER TRAINING PRIVATE LIMITED',
    'Tarang broadcasting company limited',
    'Golden star telecommunications private limited',
    'Best marine private limited',
    'VOVISTO PRIVATE LIMITED',
    'Eastern trucking co private limited',
    'Mj telecommunication services private limited',
    'FORTUNA SKILL MANAGEMENT PRIVATE LIMITED',
    'Mahindra first choice wheels limited',
    'AAKARSH AIR & SEA FREIGHT FORWARDERS PRIVATE LIMITED',
    'Zest aviation private limited',
    'Paul excursions private limited',
    'Vaibhav mobile teleshoppe private limited',
    '4a commodity broking limited',
    'Tfs investments private limited',
    'Total financial services ltd.',
    'Eureka portfolio management services private limited',
    'Nidhi auto private limited',
    'Anush finlease and construction private limited',
    'Rsl dyecot private limited',
    'Intersil investments private limited',
    'HEM FINLEASE PVT LTD',
    'THREE-M MANAGEMENT & FISCAL SERVICES PVT. LTD.',
    'INDICA TRAVELS AND TOURS PRIVATE LIMITED',
    'Janair travels private limited',
    'Wig air freight private limited',
    'PAUL MERCHANTS FINANCE PRIVATE LIMITED',
    'R g logistics private limited',
    'VYAPARA VIJAYAM HIRE PURCHASE PRIVATE LIMITED',
    'DEEDI FINANCIAL SERVICES PRIVATE LIMITED',
    'Punjab kashmir finance limited',
    'Dpgc finance limited',
    'Kartar deposits and advances pvt ltd',
    'AGILE FINSERV PRIVATE LIMITED',
    'Libra auto and general finance limited',
    'Libra automobiles limited',
    'Decimus financial limited',
    'Guanine real estates private limited',
    'TATTVA FINCORP LIMITED',
    'Dhanvarsha motor finance private limited',
    'POONAWALLA HOUSING FINANCE LIMITED',
    'Indus discoveries private limited',
    'TRAVEL ',
    'EASE PRIVATE LIMITED',
    'Udayant malhoutra and company private limited',
    'Pearl exotic journeys private limited',
    'Nedlloyd logistics india private limited',
    'SIKKAS KWICK HANDLING SERVICE PRIVATE LIMITED',
    'COMMITTED CARGO CARE LIMITED',
    'Cosmo maritime private limited',
    'Gauriputra investments and trading company private limited',
    'Apjr traders and commission agents private limited',
    'Csl securities private limited',
    'Veracious magnates infotech private limited',
    'OVINGTON ASSET MANAGEMENT PRIVATE LIMITED',
    'E c packtech machines private limited',
    'Positive design ventures private limited',
    'SAMTECH WATER ENGINEERS PRIVATE LIMITED',
    'Ss elegance logistics private limited',
    'Mahamaya ispat udyog private limited',
    'Samik solutions private limited',
    'Ramprastha ispat udyog private limited',
    'Privat hospitals dr sachdev private ltd.',
    'Vandana securities private limited',
    'PAISABAZAAR MARKETING AND CONSULTING PRIVATE LIMITED',
    'Thirteen cine vision private limited',
    'Saveer biotech limited',
    'International green scapes limited',
    'Unilec engineers limited',
    'Mecamidi hpp india private limited',
    'Vacations pro international private limited',
    'Universal training solutions private limited',
    'Saka engineering systems private limited',
    'Newpoint legal services private limited',
    'Classic gypsum industries private limited',
    'Gamma tech (india) private limited',
    'Tprg fragrances private limited',
    'Firstcall automation private limited',
    'Mann tours india private limited',
    'Haecom telesys private limited',
    'United fabricators and technical services private limited',
    'Jip jain industrial products private limited',
    'Propello innovations private limited',
    'Kap enterprises private limited',
    'Hill queen investment pvt ltd',
    'Spectrum petromac private limited',
    'Iv creation private limited',
    'D k ispat and timber limited',
    'Trafalgar consulting international company private limited',
    'Blue force security services private limited',
    'Usha buildtech private limited',
    'Prashant mehta foundation',
    'Comp-mart india private limited',
    'Techcurl media solutions private limited',
    'Uic services private limited',
    'Competent solar energy private limited',
    'Value solar energy private limited',
    'Prevision world (india) private limited',
    'UNIVERSAL CARTONS SOLUTIONS PRIVATE LIMITED',
    'West bengal awadhoot agro private limited',
    'Silicon safepack private limited',
    'Beeta conveyors private limited',
    'Kapur chand pvt ltd',
    'V conserve energy solutions india private limited',
    'Jk skins & shoes solutions private limited',
    'PERFORMANCE INDUSTRIES PRIVATE LIMITED',
    'Competent synergies private limited',
    'Embee arc (india) limited',
    'MDCWL LIMITED',
    'Delhi chamber of commerce',
    'Agra leather board pvt ltd',
    'USHAMIL ASSOCIATES PRIVATE LIMITED',
    'Sky forge private limited',
    'F s graphics private limited',
    'Sercon india private limited',
    'Rausheena india private limited',
    'Machado warehouse company private limited',
    'Larks learning private limited',
    'Harasfera design private limited',
    'Nextgen printers private limited',
    'Jay durga multitech private limited',
    'Innova techno products private limited',
    'A s fasteners private limited',
    'Final cut studios private limited',
    'Modern cyber zone private limited',
    'Kolkata games and sports private limited',
    'Indo global security services private limited',
    'LIVINDIA INFRA PRIVATE LIMITED',
    'Sasia security - risks.com private limited',
    'Ilo consulting services private limited',
    'Greenways retails private limited',
    'Dandini securities private limited',
    'Srkn advisory services private limited',
    'Vip elite entrepreneurs private limited',
    'Olive marketing solutions private limited',
    'Supervision secure services private limited',
    'Global upside india private limited',
    'Vidwan marketing private limited',
    'JOHNSON SCREENS ( INDIA ) PRIVATE LIMITED',
    'Bharat tyres (gujarat) private limited',
    'Indian borax ltd',
    'ANTILA WELLNESS PRIVATE LIMITED',
    'Carrier airconditioning & refrigeration limited',
    'Adit infratel private limited',
    'Promax legal solution private limited',
    'Cosmos manpower private limited',
    'Manford management and consultancy services private limited',
    'Nagreeka fabric private limited',
    'Gima manufacturing private limited',
    'Ran chemicals private limited',
    'Vicco products bombay pvt ltd',
    'L&t employees welfare foundation private limited',
    'Grindwell pulverizers private limited',
    'Secureshield security services private limited',
    'Banu systems private limited',
    'Paulsons beauty and fashion private limited',
    'Skipper technologies india private limited',
    'Jagprem consultants private limited',
    'Essee networks private limited',
    'M.p. birla group services private limited',
    'Rrd decors private limited',
    'Itkts interactive technologies private limited',
    'Laxmi udyog oil field equipments private limited',
    'Preet tractors private limited',
    'SPIRAL EHL ENGINEERING PRIVATE LIMITED',
    'Chaitanya steelshape private limited',
    'Aptus software labs private limited',
    'Khemka spline gauges private limited',
    'Amrit duraparts private limited',
    'Matcon aerospace private limited',
    'Maruti hydraulics private limited',
    'Dicksons engineering company private limited',
    'LEYBOLD INDIA PRIVATE LIMITED',
    'Premier spares private limited',
    'JADHAO GEARS LIMITED',
    'KANSARA ENGINEERS PRIVATE LIMITED',
    'Design and automation engineers (bombay) private limited',
    'Dhumal metals private limited',
    'Spanner elevator company private limited',
    'Uniom manufacturing & trading company pvt ltd',
    'Deltapure technologies (india) private limited',
    'Jm tools & prints private limited',
    'Dhall enterprises and engineers pvt ltd',
    'Nova bulk handlers private limited',
    'EASTERN SWITCHGEAR & ELECTRICAL COMPANY (ORISSA) PVT.LTD.',
    'Smc conveying systems private limited',
    'Rotta print india private limited',
    'R t c engineering works pvt ltd',
    'Rishi graphics pvt ltd',
    'Weldcon india private limited',
    'Topspares private limited',
    'Uniphos envirotronic private limited',
    'Mitutoyo south asia private limited',
    'Sukeshan equipments pvt ltd',
    'SUTTATTI ENTERPRISES Private Limited',
    'Rcg instruments (india) private limited',
    'Star engineers (india) private limited',
    'Datsons engineering works private limited',
    'Tractel tirfor india pvt ltd',
    'Monarch self adhesive tapes and foams (india) private limited',
    'Starflex gaskets private limited',
    'R a electronics private limited',
    'Synchronics electronics private limited',
    'Sarb presses private limited',
    'Shah electronics and home appliances private limited',
    'Automac (madras) private limited',
    'Unitek power solutions india limited',
    'Rungta infotech systems private limited',
    'Corporate trading (india) private limited',
    'Samitech electronics private limited',
    'Datacom computer services private limited',
    'Bristlecone india limited',
    'Fujisan technologies limited',
    'Promethean spenta technologies private limited',
    'E ENGINEERING PRIVATE LIMITED',
    'Excellent conclave private limited',
    'Welcome towers private limited',
    'Imperial plaza private limited',
    'Evergrow developers private limited',
    'Imperial reasidency private limited',
    'Welcome complex private limited',
    'Aakansha nirman private limited',
    'Littlestar estates private limited',
    'Avm estates private limited',
    'Welsome conclave private limited',
    'Lord highrise private limited',
    'Lord empire builder private limited',
    'Anand apartment maintenance private limited',
    'Entry india projects private limited',
    'Dayasindhu enclave private limited',
    'Saharsh commodeal private limited',
    'Rash builders india private limited',
    'Radha kishan buildwell private limited',
    'Bdi infrastructure private limited',
    'Felicity projects private limited',
    'In-art constructions private limited',
    'Eminence studio private limited',
    'Kritaka enclave private limited',
    'Nortex property private limited',
    'Nortex complex private limited',
    'Nortex builders private limited',
    'Pankaj international private limited',
    'Kanaiya exports private limited',
    'Basukinath niketan private limited',
    'Gandharaj niketan private limited',
    'Gemini nirman private limited',
    'Chandrima properties private limited',
    'Sonai food marketing private limited',
    'Himgiri developers private limited',
    'Sidhartha marketing pvt ltd',
    'Potential exports private limited',
    'Lee designs private limited',
    'Ishman creations private limited',
    'Seven point motors private limited',
    'Naturence research labs private limited',
    'Frangipani hospitality private limited',
    'Spearhead adventure services private limited',
    'JUPITER ADMINISTRATIVE AND SECURITY SERVICES PRIVATE LIMITED',
    'Innovative manpower solutions private limited',
    'Ulai enterprises pvt ltd',
    'Deepeka marketing private limited',
    'Skh management services limited',
    'Spectrum seating systems services private limited',
    'PREMIER VIGILANCE & SECURITY PVT LTD',
    'Garstin caretaker private limited',
    'VIRTUALTEAM CORPSERVE PRIVATE LIMITED',
    'MANIPAL BREWING AND HOSPITALITY PRIVATE LIMITED',
    'Riskpro india ventures private limited',
    'Jetserve india private limited',
    'Quasar enviro solutions private limited',
    'Pro-fact solution private limited',
    'Latiyal handicrafts private limited',
    'CHEKOPLAST (INDIA) Private Limited',
    'Tuareg properties and securities services limited',
    'Fair design india private limited',
    'Sona bath care private limited',
    'Zitron india pvt ltd',
    'Continental suraksha insurance broking services private limited',
    'Desnet engineers private limited',
    'Tact india private limited',
    'KRAUTER HEALTHCARE LIMITED',
    'KQ SEATS PRIVATE LIMITED',
    'Hi-sun forex and allied services private limited',
    'Et envirotech overseas private limited',
    'C l gupta exports limited',
    'Saburi ayur solutions private limited',
    'Dhirsons jewellers private limited',
    'Salwan media private limited',
    'Wegmans business park private limited',
    'Los angeles food processing limited',
    'Cross section media private limited',
    'Kapgrow corporate advisory services private limited',
    'Ksp sound design solutions private limited',
    'Rds blackwater securitas private limited',
    'Mynd integrated solutions private limited',
    'Sopedu security private limited',
    'Bmi publications private limited',
    'Wednesday brand solutions private limited',
    'Gluminent graphics private limited',
    'Sai corp creations private limited',
    'Ultimate telecom enng. solution pvt ltd.',
    'Bces admissions abroad private limited',
    'Transorg solutions & services private limited',
    'Apc engineers & consultants private limited',
    'Third eye surveillance & security systems private limited',
    'Kalabhai karson private limited',
    'Alexandre quality management india private limited',
    'V s trading and consultancy private limited',
    'C sankar trading and consultancy private limited',
    'Pope professional acoustics limited',
    'Apeejay holdings private limited',
    'Laxy trading pvt. ltd.',
    'Senstar international limited',
    'Apeejay surrendra management services private limited',
    'Techno services engineering systems private limited',
    'Blackberry ventures private limited',
    'Orkids education systems private limited',
    'K s knowledge solutions private limited',
    'Suncity handicrafts private limited',
    'Springs home decor private limited',
    'Sam designs private limited',
    'Krishan kanhaiya creation marketing private limited',
    'Aggarwal agencies private limited',
    'Shivanghi sales private limited',
    'WESTERN PEST SOLUTIONS PRIVATE LIMITED',
    'J b s global marketing private limited',
    'A.m. industry india private limited',
    'Busch shared services india private limited',
    'NEWPOINT CARDS & PRINTERS PRIVATE LIMITED',
    'Pk financial consulting private limited',
    'India unites foundation',
    'Vaidya ayurvedguru private limited',
    'Umala healthcare private limited',
    'Complete health n fitness private limited',
    'Sam security and manpower services private limited',
    'Swift security services pvt. ltd.',
    'Bharat fritz werner limited',
    'Manipal overseas trading company limited',
    'Eternal heart care centre and research institute private limited',
    'Radianz health care & research private limited',
    'Jbj technologies limited',
    'Sachan security and detectives private limited',
    'Care medical solution private limited',
    'AQURA ENVIRO PROJECTS PRIVATE LIMITED',
    'Sarvhitkari finlease and invest limited',
    'Young presidents organisation (chennai chapter)',
    'Cine prime entertainment private limited',
    'SILIGURI PARKS & RESORTS PRIVATE LIMITED',
    'K--net private limited',
    'Compass multiplier project private limited',
    'HAMMURABI & SOLOMON EDUCATIONAL ACADEMY PRIVATE LIMITED',
    'On events & promotions private limited',
    'Equi media private limited',
    'Manasvi gurukul educational academy private limited',
    'ADG EDUCATION',
    'Ibooks college private limited',
    'Kapsa wellness private limited',
    'The poona club limited',
    'Touchbeam enlightenment systems private limited',
    'M.l.singhi and associates private limited',
    'Sequoia fitness and sports technology private limited',
    'Karuna care foundation',
    'Om shree star management consultancy private limited',
    'HI-NO-DE FOUNDATION',
    'Brand nutrient marketing services private limited',
    'Everlink commodeal private limited',
    'Lifelong niketan private limited',
    'Outlay overseas private limited',
    'Dyp hospitality private limited',
    'Rupis resorts india private limited',
    'Ashish gambhir hotels private limited (part ix)',
    'Lahari holiday homes limited',
    'Manoharamma hotel investments private limited',
    'ANYTHING SKOOL LIMITED',
    'Sunlight dealtrade private limited',
    'Sea-hawk(india) pvt ltd',
    'Kanodia hotels international pvt ltd',
    'Gayatri vintrade private limited',
    'Concept barter private limited',
    'Ghosh brothers hospitality private limited',
    'Alamode hotels private limited',
    'Orbit leisure & lounge private limited',
    'Yashasvi trade centrik private limited',
    'Tarang engineering private limited',
    'White mushrooms holidays private limited',
    'Shree rathnam restaurants private limited',
    'Cozy tours pvt ltd',
    'Nirmalkunj tradelinks private limited',
    'Vera resources private limited',
    'Ashoka moving experts private limited',
    'Oscar shipping and logistics private limited',
    'Kanak agri-tech private limited',
    'Aokivectra hospitality private limited',
    'Western star line private limited',
    'Marcons maritime pvt ltd',
    'Atlantic aviation private limited',
    'Gomissing expeditions private limited',
    'Whitegate hotel and resort (india) private limited',
    'Fr8 integrated logistics private limited',
    'Seasky shipping line (west) private limited',
    'Lotus wellness and eco-resorts private limited',
    'KANOTA RESORTS PRIVATE LIMITED',
    'Hotel library club private limited',
    'Jalan inter continental hotels private limited',
    'P s hospitalities pvt ltd',
    'Hotel shevaroys private limited',
    'Rishi raj realtors private limited',
    'Sand storm buildtech private limited',
    'Ancient india travels private limited',
    'Venues and vacations private limited',
    'Swadeshi journeys private limited',
    'Sino luxury travels private limited',
    'Key shipping private limited',
    'Pranshu residency private limited',
    'Lytton hotel pvt ltd',
    'Standard-wellworth trucking & logistics private limited',
    'Aa globe services private limited',
    'PREFERRED TOURS & TRAVELS PRIVATE LIMITED',
    'Eternity travel and tour private limited',
    'Clement orient pvt ltd',
    'Titanic ocean services private limited',
    'Asia shipping international transport private limited',
    'Travels & rentals private limited',
    'Bhavsagar logistics private limited',
    'Bounce communication & design private limited',
    'Roam1 telecom limited',
    'Jet express (cargo courier) private limited',
    'Fimo india manufacturing private limited',
    'Akasha data communications private limited',
    'Happy cellular services private limited',
    'Vas mobitech private limited',
    'Speedair webtech private limited',
    'Experts doctors shield consultants limited',
    'BLUE JAY FINLEASE PRIVATE LIMITED',
    'DPGC LOGISTICS PRIVATE LIMITED',
    'Omshri cargo carriers private limited',
    'B.g.m tour & travel private limited',
    'Pangea trading company private limited',
    'Chittosho finances private limited',
    'PNC TECHLINE PRIVATE LIMITED',
    'Avs finlease limited',
    'Orbit projects pvt ltd',
    'Kmg macro investments private limited',
    'Track three leasing pvt ltd',
    'Twenty first century finance ltd',
    'Drl impex limited',
    'Sahana investments solutions private limited',
    'Greatbrothers chit fund private limited',
    'Bindal logistics private limited',
    'International ventures and travel india private limited',
    'Mojj finvest (india) pvt ltd.',
    'Sanmar engineering services limited',
    'G. k. investments ltd',
    'Murari investment & trading co ltd',
    'KANAK LAND DEVELOLMENT CREDIT & CO PVT LTD',
    'Escal finance services ltd',
    'Ultra trades & holdings company pvt ltd',
    'Uttam finalease pvt ltd',
    'Accord capital markets private limited',
    'Abhijeet logistics private limited',
    'Sampark global logistics private limited',
    'Adiona travels private limited',
    'Happy insurance tpa services private limited',
    'Multimoney forex limited',
    'P s shares private limited',
    'Gng stock holdings private limited',
    'SAKSHAM WEALTH PRIVATE LIMITED',
    'Nariman point realty services private limited',
    'Manekchand panachand trading investment co pvt ltd',
    'Nand kishore investments private limited',
    'Victor marinas and leisure services (goa) private limited',
    'Mm cargo gear and marine services private limited',
    'Baisiwala holdings private limited',
    'DSTC STEELS PRIVATE LIMITED',
    'Aditya birla money limited',
    'Carbac holdings ltd',
    'PANORAMA STUDIOS INTERNATIONAL LIMITED',
    'Khatau makanji spinning and weaving company limited',
    'Assambrook limited',
    'Knr constructions limited',
    'Krisons electronics systems limited',
    'Minda corporation limited',
    'Calcom vision limited',
    'Hardcastle and waud manufacturing company limited',
    'Irus software applications private limited',
    'Askara warehousing & services private limited',
    'Indiacan education private limited',
    'Comet logistics private limited',
    'Abhinaash food grain private limited',
    'Veda search and consulting private limited',
    'Sunsea agro and life sciences (india) limited',
    'Unison bio-tech industries private limited',
    'Gunjan agro and investment private limited',
    'K r horticulture private limited',
    'Conan agro marine private limited',
    'Esspal agro private limited',
    'Sharda devi agrochem private limited',
    'Iraj agriculture private limited',
    'Irajgajanan agriventure private limited',
    'Shree bal constructions private limited',
    'Summit engineers and consultants private limited',
    'Hindustan corporation (hyderabad) pvt ltd',
    'Sri ganapathy mills company limited',
    'Frontier biscuit factory private limited',
    'Smartschool education private limited',
    'Nuxalbari tea company private limited',
    'Smile train india',
    'Visionindia research foundation',
    'Able healthcare systems private limited',
    'Luthra hospitals private limited',
    'Peerless hospitex hospital and research center ltd.',
    'Ganpati medical institute',
    'Aarvees hospitality private limited',
    'Shree geeta sarees private limited',
    'Satyam (north east) energy limited',
    'Calcutta motor sports club ltd',
    'Vidarbha waste management private limited',
    'EP&M INDIA PRIVATE LIMITED',
    'VESTA ELDER CARE PRIVATE LIMITED',
    'Tactonomics private limited',
    'Unique marmochem private limited',
    'Stone age bundi private limited',
    'Darvell (india) pvt ltd',
    'Innocent organics private limited',
    'Danisco (india) private limited',
    'Iraj floriculture private limited',
    'Northshore foods private limited',
    'Kanegrade flavours & ingredients private limited',
    'Parisons agrotech private limited',
    'Koyenco solvent extractors pvt ltd',
    'Rio agriculture private limited',
    'CHATHA FOODS LIMITED',
    'SAY DATA ELECTRONICS PRIVATE LIMITED',
    'Supreme wafers private limited',
    'Saraju flour mills pvt ltd',
    'Rio agriventure private limited',
    'Money resources private limited',
    'E.b.i. foods private limited',
    'Tastebuds gourmet foods private limited',
    'Innocent green gardens private limited',
    'Miki maize milling private limited',
    'Pkm finefoodsandspices private limited',
    'Tea packs speciality ltd',
    'Khanna farms private limited',
    'Golden tulip farms private limited',
    'NATIONAL INDUSTRIAL CORPORATION PRIVATE LIMITED',
    'CARAPUR PROPERTIES PRIVATE LIMITED',
    'Kanchan commercial co pvt ltd',
    'Vel natural extracts private limited',
    'Indian organic farmers producer company limited (under part ixa)',
    'Atul bio space limited',
    'Rossell biotech limited',
    'Jai laxmi spinning mills limited',
    'Uv greens concepts private limited',
    'The world biotech private limited',
    'Mangal farming and agro industries private limited',
    'Zt travel services private limited',
    'South india linen manufacturers private limited',
    'K k p hi tech weaving india private limited',
    'Kalamkari designs private limited',
    'Shaka garments pvt ltd',
    'Kothari hosiery factory pvt ltd',
    'Chinar syntex limited',
    'Bhutada weaving mills private limited',
    'Sunitta textile mills pvt ltd',
    'Golden terry towel private limited',
    'Blossom fabrics limited',
    'Woolen processor private limited',
    'S. nanda industries private limited',
    'Nalwaya mineral industries private limited',
    'Godriwala plastics private limited',
    'R. i. cotton private limited',
    'SOUTH WEST FINTRADE UDYOG LIMITED',
    'Angel fabrics private limited',
    'Basundhara fuels private limited',
    'Bunga express shipping agency private limited',
    'East coast bauxite mining company private limited',
    'Bhagwati lime stone private limited',
    'Saffron naturele products private limited',
    'Coco-latex exports private limited',
    'Nextgen textile park private limited',
    'True living hometex private limited',
    'Anant spinners private limited',
    'Libra carpets p. ltd.',
    'Coastal aquabase pvt.ltd.',
    'Revolution clothings private limited',
    'Sun village resorts private limited',
    'Teaxpress private limited',
    'De souza leisures private limited',
    'Malwan hospitality private limited',
    'Lions hotels and resorts.(india) private limited',
    'Vaishree boutique hotels private limited',
    'Seven souls hospitality private limited',
    'Ultra cargo india private limited',
    'Entire logistics private limited',
    'Secure logistics solutions private limited',
    'Angel hospitality private limited',
    'Onkar vintrade private limited',
    'EVERGREEN EXPO CLEARING & FORWARDING PVT. LTD',
    'Sea meridian shipping agency pvt ltd',
    'Badrinath hotels private limited',
    'Tpb hospitality private limited',
    'Transrapid logistics private limited',
    'Shaildhar telecom services private limited',
    'Cantel communications india private limited',
    'Cyberspace communications private limited',
    'Tower vision india private limited',
    'Aqt network private limited',
    'Simpson & general finance company limited',
    'K v r holdings private limited',
    'Alcera ceramics private limited',
    'Desire realtors private limited',
    'Rose valley towers private limited',
    'Fedbank financial services limited',
    'J.K. JAJODIA & SONS PVT. LTD.',
    'Bele view towers private limited',
    'Nsi logistics private limited',
    'Diamond clearing & forwarding private limited',
    'Hvrv (india) pvt ltd',
    'Orbit towers pvt ltd',
    'Easy trip today travel marketing and representations private limited',
    'Rishishwar logistics private limited',
    'D & O VENTURES PRIVATE LIMITED',
    'SUNDARAM HOME FINANCE LIMITED',
    'VENTURE GUARDIAN PRIVATE LIMITED',
    'Suvidha infracon private limited',
    'Kirtilal trading company private limited',
    'Simpson and company limited',
    'GREENVALLEY INVESTMENTS (ALPHA) LIMITED',
    'XAVIER NIDHI LIMITED',
    'Real burgeon money chit fund private limited',
    'Mediterranean hospitality holidays private limited',
    'Celestial finhold private limited',
    'S R HOLDINGS PRIVATE LIMITED',
    'MULTILATERAL FINANCE & INVESTMENTS PRIVATE LTD',
    'Purnasons holding pvt ltd',
    'Btc tours and travels private limited',
    'Equi tours private limited',
    'Corporate voyagers private limited',
    'Yuva trip private limited',
    'Optima insurance brokers private limited',
    'Aditya birla money insurance advisory services limited',
    'FUZZ HOSPITALITY PRIVATE LIMITED',
    'BRIGHT VIEW INFRASTRUCTURE PRIVATE LIMITED',
    'Laxminarayan vyapaar private limited',
    'Herschel travels private limited',
    'CANDLE HOUSE TOURS & RESORTS PRIVATE LIMITED',
    'Frontier business systems private limited',
    'O3 securities private limited',
    'Ashoka industries limited',
    'Big digs resorts limited',
    'Impact hotels and resorts private limited',
    'Kanishka hotels pvt ltd',
    'Tirupati logistics private limited',
    'Dhamija finance and leasing limited',
    'Trans pacific finance private limited',
    'Moneyplus financial services private limited',
    'Hm-siwa financial services private limited',
    'Gemini arts private limited',
    'Innovative leasing & finance pvt ltd',
    'Emco enterprises & investments pvt. ltd.',
    'Worthy financial services ltd',
    'S.l.p.chits private limited',
    'Sundaram trustee company limited',
    'Three s infrastructure pvt ltd',
    'RSDR REALTY PRIVATE LIMITED',
    'Pan asia developers private limited',
    'Avighna infravision private limited',
    'Blue infrastructure private limited',
    'Jagjyoti investment pvt. ltd.',
    'Nutan finvest pvt ltd',
    'Tarjani insurance broking private limited',
    'Manya skyscraper private limited',
    'Kamakhya promoters private limited',
    'Sukhija real estates pvt ltd',
    'Spr estates and builders private limited',
    'ART FINANCIAL SERVICES (INDIA) PRIVATE LIMITED',
    'Mandakinee build and investment private limited',
    'Emu properties and securities private limited',
    'Velocity infrastructure private limited',
    'Win realtors private limited',
    'U.v.m.shipping services pvt.ltd.',
    'Matrix debt recovery services private limited',
    'Trueseed investment consultants private limited',
    'Bharatseth & sons holdings private limited',
    'Bellwether wealth advisory private limited',
    'Grg estates private limited',
    'Aura realtech private limited',
    'Three kay builders private limited',
    'Avighna infrastructure private limited',
    'Robotex real estates private limited',
    'Victory projects private limited',
    'Shri mahalakshmi estate development private limited',
    'Supergrowth developers private limited',
    'Surkshit investments private limited',
    'B N BISWAS & CO PVT LTD',
    'Apparel exim private limited',
    'Youngman woollen mills private limited',
    'Times furnishing pvt ltd',
    'Raj tex-o-twist pvt ltd',
    'Mangal textile mills (india) private limited',
    'Shikha dyeing and bleaching mills pvt ltd',
    'Drapes global (india) limited',
    'Coochbehar industries (india) private limited',
    'Mahip agro developers private limited',
    'Shine india agro industries limited',
    'Sashanka agro tech private limited',
    'SHRI SANKHESHWAR TEXTILE PRIVATE LIMITED',
    'Php glass & poly fabrics private limited',
    'Tphk syntex private limited',
    'Pcm agro products private limited',
    'Bikaner agrofood industries private limited',
    'Indepesca overseas private limited',
    'K A I INTERNATIONAL PRIVATE LIMITED',
    'Hometex designs (india) private limited',
    'Aneesh fashion bazar pvt ltd',
    'Rajyog minerals private limited',
    'Saboo minerals private limited',
    'WHITE ',
    'WHITE MINERALS PRIVATE LIMITED',
    'Eco-source exim private limited',
    'Digi bling private limited',
    'Index knit and weave private limited',
    'B p industrial corpn. pvt ltd',
    'Sma nutrition india private limited',
    'Golden vats private limited',
    'Indomonex private limited',
    'Onward knitwear solutions private limited',
    'Vidhi apparels private limited',
    'Bhoomika garments private limited',
    'Lp garments private limited',
    'Mtr textiles and apparel international private limited',
    'Saket fabs private limited',
    'Chandigarh beverages pvt ltd',
    'Nutan tobacco private limited',
    'Shree ganesh projects pvt.ltd.',
    'Howrah stores limited',
    'REENAM FABRICS PVT LTD',
    'Reve creations private limited',
    'Flint exports private limited',
    'Rishabh garments private limited',
    'Swadeshi granite india private limited',
    'Shobha designs private limited',
    'Ambey fabtex private limited',
    'Leather export house india private limited',
    'Enhance lifestyle private limited',
    'Amazon leathers private limited',
    'Lakhani. armaan. shoes. private. limited.',
    'B.b. hide leathers company private limited',
    'Shilpa overseas pvt ltd',
    'Harsha leather goods private limited',
    'Vacouro leather (india) pvt ltd',
    'KOBLERR FOOT WEAR & ACCESSORIES PRIVATE LIMITED',
    'Lakhani shoes and apparels private limited',
    'Lakhani reasearch and development centre private limited',
    'Tirupati balaji granites private limited',
    'East india plywood co ltd',
    'Decor plylam private limited',
    'New era agro board ltd.',
    'Astik (india) private limited',
    'The jain china clay mines pvt ltd.',
    'Bonai industrial co ltd',
    'Misrilall dharamchand pvt ltd',
    'Fresh food concepts private limited',
    'Kamala board box pvt ltd',
    'Govardhan shelters private limited',
    'Govardhan holdings private limited.',
    'Min-wool insulation limited',
    'V-access (india) private limited',
    'Sandeep weavers private limited',
    'Modern fibo-tex india ltd',
    'M. k. fabtex private limited',
    'Multiwyn lifestyle private limited',
    'Oster knit pvt limited',
    'Sharp enterprises private limited',
    'Edulight publications private limited',
    'Oriental mart private limited',
    'Oswal grandeur limited',
    'Rima beach world private limited',
    'Loka lifestyle private limited',
    'Magraj kantilal fab private limited',
    'Godavari pulp and paper mills private limited',
    'VARSHA DYEING AND PRINTING MILLS PRIVATE LIMITED',
    'Vulcanising fibre board private limited',
    'APEX ASIA PACIFIC PRIVATE LIMITED',
    'Vtc printrade private limited',
    'Nikunj creation private limited',
    'Oxbridge international private limited',
    'Health is wealth media private limited',
    'Mrh digital systems private limited',
    'Osd coke private limited',
    'Deep coal private limited',
    'Amalgamated fuels ltd',
    'Agarwal paper mills private limited',
    'Kriton weld equipments private limited',
    'Cyber media services limited',
    'Ananda vikatan productions private limited',
    'Xi tech solutions private limited',
    'Alkaloids pvt ltd.',
    'Upper india inorganic industries limited',
    'DELPHI-TVS TECHNOLOGIES LIMITED',
    'RAMNAD CHEMICAL WORKS PRIVATE LIMITED',
    'Rajda industries & exports private limited',
    'CREATIVE SQUARE APPARELS INDIA PRIVATE LIMITED',
    'Vitrag chemicals private limited',
    'Marvel global limited',
    'Indiana acids and chemicals private limited',
    'CLARION ORGANICS LIMITED',
    'Devostik adhesives private limited',
    'Preet agro industries private limited',
    'Asha nath (warehousing) private limited',
    'Aditya birla finance limited',
    'Fastner securities private limited',
    'Sound investment and leasing private limited',
    'Jet-aiu skyline transport private limited',
    'Palitana sugar mills pvt ltd',
    'Bini commercial enterprises private limited',
    'PAROSHA CHEMICALS PRIVATE LIMITED',
    'Sadafuli finvest pvt ltd(tr co from maharashtra)',
    'Annapurna commercial co ltd',
    'Deekay properties pvt ltd',
    'Micro vehicles private limited (c/n)',
    'Dawn financial services limited',
    'Oracle finvest and consultants pvt ltd',
    'Bentex fin pvt ltd',
    'Kanav finvest pvt ltd',
    'Gayaprasad hiralal ltd',
    'Ideal financing corporation limited',
    'Shellz overseas private limited',
    'Pratham courier and express services private limited',
    'Surbhi satcom private limited',
    'Pi communications private limited',
    'Rangoli portfolio private limited',
    'Gtn enterprises limited',
    'JAIPUR FINANCE AND DIARY PRODUCTS PVT LTD',
    'Surjya kumar banik capital private limited',
    'Eskar stock holdings private limited',
    'Ricky credit company pvt. ltd.',
    'Lodha capital markets ltd',
    'Plc securities ltd',
    'Gulisthan commerce pvt.ltd.',
    'Kiswok industries private limited',
    'Intellect securities private limited',
    'Morgan finvest private limited.',
    'Priyam commercial enterprises private limited',
    'Brahmaputra holdings private limited',
    'O3 capital global advisory private limited',
    'Wealth managers united (india) private limited',
    'Sushil finance consultants ltd',
    'A.j. consultants private ltd',
    'Nebula infomatique private limited',
    'Lakecity web private limited',
    'ZUARI SUGAR & POWER LIMITED',
    'Raa finlease limited',
    'YUWASH LAUNDRETTES PRIVATE LIMITED',
    'Abba realtors & builders company private limited',
    'Capricorn residency private limited',
    'Classic electrodes (india) limited',
    'Srinidhi finance private limited',
    'Logwell financial consultants private limited',
    'Industrial promotion and investment corporation of odisha limited',
    'Silver jubilee investments private limited',
    'Shantakumar investment company private limited',
    'Saket multi services private limited',
    'Redefining hospitality private limited',
    'V c space solutions private limited',
    'Santosh buildcon india private limited',
    'Gsb holdings & commercial private limited',
    'Samaresh investments limited',
    'Aims sanya developers private limited',
    'Sagar forex limited',
    'Rani sati marketing company private limited',
    'The oriental insurance company limited',
    'A p s investments pvt ltd',
    'Ambalika cements private limited',
    'Rishikesh real estates private limited',
    'Fifteen-a- holdings private limited',
    'Enoch intermediaries private limited',
    'Mathews brothers finance and investment private limited',
    'Manvi holdings private limited',
    'Vision estates private limited',
    'Chase realty private limited',
    'Tvs housing limited',
    'B-earth and spire (india) private limited',
    'Bata properties ltd',
    'Prakash builders pvt ltd',
    'RBS CONTRACTS PRIVATE LIMITED',
    'Karb estate private limited',
    'Ars real estates private limited',
    'Avichal buildcon private limited',
    'Sanya developers private limited',
    'Mahagun housing & construction private limited',
    'K. l. dhall projects private limited',
    'Shivalik urban landscapes private limited',
    'Aryam developers private limited',
    'Spj builders & brokers private limited',
    'G.k.b builders & promoters private limited',
    'Panama holding private limited',
    'Gautam nirman pvt ltd',
    'Gomateshwara properties pvt ltd',
    'Gunnidhi properties pvt ltd',
    'Lakeview builders private limited',
    'Satkar properties private limited',
    'Solitaire capital advisors private limited',
    'Survam investments private limited',
    'Gd finvest private limited',
    'Kingcup construction private limited',
    'Mmg financial consultants private limited',
    'Raghvi realtys private limited',
    'PROEM ARMOR CORROSION PRIVATE LIMITED',
    'Gritty realty private limited',
    'Highrank complex private limited',
    'Consolidated insurance surveyors & loss assessors private limited',
    'Sukhmani productions private limited',
    'Pnr realtors private limited',
    'Pret study by janak fashions private limited',
    'Vandom properties private limited',
    'Harikunj niwash pvt.ltd.',
    'Vasudha promoters private limited',
    'Somnath enclave private limited',
    'Matara panagarh developers private limited',
    'APEX FROZEN FOODS LIMITED',
    'Muhavra enterprises private limited',
    'Universal drinks private limited',
    'Shree matri mata fibres private limited',
    'Atc limited',
    'The invex private limited',
    'Start up farms india private limited',
    'Esspal international private limited',
    'Nextgen comm technologies private limited',
    'Natural texcollections private limited',
    'Earthcon housing (india) private limited',
    'East india cigar company private limited',
    'Mapel leaf exports pvt ltd',
    'Deen bandhu oil mills pvt.ltd.',
    'Vindhya carpets ltd',
    'Indian jute mills association',
    'Padmasagar jute private limited',
    'Kamakshi jute industries limited',
    'GOWTHAMI SPINTEX (INDIA) PRIVATE LIMITED',
    'Vishwas foods private limited',
    'Anubhav apparels private limited',
    'Top exim private limited',
    'Sahil knitwear private limited',
    'K.t.c. foods private limited',
    'Ginmesh clothing company private limited',
    'Hitech fashion wear private limited',
    'Jain agro food products private limited',
    'Raja fat and feeds pvt ltd',
    'Nutrich foods private limited',
    'MRS. BECTOR',
    'S BAY SERVICES PRIVATE LIMITED',
    'LIVENUTRIFIT WELLNESS PRIVATE LIMITED',
    'BROAD AIR CONDITIONING INDIA PRIVATE LIMITED',
    'MECHE INDUSTRIAL ORGANISATION PRIVATE LIMITED',
    'EGME INFOTECH PRIVATE LIMITED',
    'VERMAN MANUFACTURING & INTEGRATION PRIVATE LIMITED',
    'BONUSHUB DIGITAL SOLUTIONS PRIVATE LIMITED',
    'HANGOVER TRAILS PRIVATE LIMITED',
    'GREENMASTER LANDSCAPES PRIVATE LIMITED',
    'INDECAMPUS STUDENT ACCOMMODATIONS PRIVATE LIMITED',
    'SOLUTIO GLOBAL CONSULTING PRIVATE LIMITED',
    'USANA RENEWABLES (OPC) PRIVATE LIMITED',
    'TMOTIONS GLOBAL PRIVATE LIMITED',
    'XCEEDANCE CONSULTING INDIA PRIVATE LIMITED',
    'QUALIFICATIONS AND ASSESSMENTS INDIA PRIVATE LIMITED',
    'RENESOLA MEDITECH PRIVATE LIMITED',
    'GENERATION INDIA FOUNDATION',
    'JAI PARWATI SUKSHAM FOUNDATION',
    'L&L SECURITY SERVICES PRIVATE LIMITED',
    'PREMJI KANJI MASANI PRIVATE LIMITED',
    'MECPOWER SOLUTIONS LIMITED',
    'AITRO PRIVATE LIMITED',
    'EIG SECURITY PRIVATE LIMITED',
    'LEARNIPHI TECHNOLOGY PRIVATE LIMITED',
    'HEXIGON PRIVATE LIMITED',
    'ANAHAT TECHNOLOGIES PRIVATE LIMITED',
    'JETBRO PRIVATE LIMITED',
    'DIVANTAGE ECOM PRIVATE LIMITED',
    'COMAEA CONSULTING PRIVATE LIMITED',
    'YELLOW TROPUS PRIVATE LIMITED',
    'ANISWAR PRIVATE LIMITED',
    'INDECAMPUS STUDENT ACCOMMODATIONS (DD2) PRIVATE LIMITED',
    'CARVALHO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'L.A.N.H SOURCING PRIVATE LIMITED',
    'HASTIN BUILDTECH (OPC) PRIVATE LIMITED',
    'TAKSHASHILA HOME PRIVATE LIMITED (OPC)',
    'MAYANAGRI WORLD ONE PRIVATE LIMITED',
    'DAZZLE INNOVATION PRIVATE LIMITED',
    'ELEMENT6 RESEARCH AND LEARNING SOLUTIONSPRIVATE LIMITED',
    'CANOPUS INDIA PRIVATE LIMITED',
    'QCAD ENGINEERING SERVICES PRIVATE LIMITED',
    'ATL INDIA SOLUTIONS PRIVATE LIMITED',
    'TRIMARK PHARMACEUTICALS PRIVATE LIMITED',
    'CHATHRI PRIVATE LIMITED',
    'ROBUST ELECTRIC VEHICLES PRIVATE LIMITED',
    'TECHNOLOGICS GLOBAL PRIVATE LIMITED',
    'BBRS WAREHOUSING AND CONSULTANTS PRIVATELIMITED',
    'BILLENNIUM INDIA PRIVATE LIMITED',
    'SKYBRIDGE IT CONSULTING PRIVATE LIMITED',
    'JYOTI SOLAR SOLUTIONS PRIVATE LIMITED',
    'YUMMIQO F&B PRIVATE LIMITED',
    'BURR PILGER MAYER INDIA PRIVATE LIMITED',
    'WKA TECHNOLOGIES PRIVATE LIMITED',
    'ZHUDAO INFOTECH PRIVATE LIMITED',
    'TENDANCE FOUNDATION',
    'COVALUE TECHNOLOGIES PRIVATE LIMITED',
    'PRIMEVAL RENEWABLE PROJECTS PRIVATE LIMITED',
    'SPURS AND THREADS SOLUTIONS PRIVATE LIMITED',
    'PRESTIGE MULUND REALTY PRIVATE LIMITED',
    'R-TECH NETWORK & SECURITY SOLUTIONS PRIVATE LIMITED',
    'UDYOGII SOLUTIONS PRIVATE LIMITED',
    'NISQUARE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'SHINING ABODE PRIVATE LIMITED',
    'BITCRUST HR SERVICES PRIVATE LIMITED',
    'SYNERGYLABS TECHNOLOGY PRIVATE LIMITED',
    'HASH MEDIA PRIVATE LIMITED',
    'WITTY PROJECTS PRIVATE LIMITED',
    'BYTAMORPH SOLUTIONS PRIVATE LIMITED',
    'WITTY EDUPROJECTS PRIVATE LIMITED',
    'REAL ESTATE KINGS ASSOCIATION',
    'IDEASUNBOUND INNOVATIONS PRIVATE LIMITED',
    'APP WORLD SOLUTIONS PRIVATE LIMITED',
    'TILTLABS (OPC) PRIVATE LIMITED',
    'KRISHTEL INTERNET SERVICES PRIVATE LIMITED',
    'SARVASWA VENTURES (OPC) PRIVATE LIMITED',
    'ITECH SERIES PRIVATE LIMITED',
    'BILLIONLOANS FINANCIAL SERVICES PRIVATE LIMITED',
    'XJS ELECTRONICS PRIVATE LIMITED',
    'NOWIGENCE INDIA PRIVATE LIMITED',
    'TECHNOMECH FERROUS PRIVATE LIMITED',
    'HAPPIEST CURATORS PRIVATE LIMITED',
    'FLUPER LIMITED',
    'K&DS ELECTRONIC LIMITED',
    'EQUAL GROWTH FOUNDATION',
    'MYCITY1 INFO PRIVATE LIMITED',
    'ALTEK CHEMICALS PRIVATE LIMITED',
    'ARTHAAY FOUNDATION',
    'NAVKAR COMPUSOFT PRIVATE LIMITED',
    'RATTLEHEAD ENTERPRISES PRIVATE LIMITED',
    'PANIOR PARE PRODUCER COMPANY LIMITED',
    'BAG MAVERICK PRIVATE LIMITED',
    'VORTILLA TECHNOLOGIES PRIVATE LIMITED',
    'PRACHIT TECHNOLOGY SERVICES PRIVATE LIMITED',
    'MEDICAD HEALTHCARE PRIVATE LIMITED',
    'TOWNBUS INDIA PRIVATE LIMITED',
    'TARGETBAY ECOMMERCE SOLUTIONS PRIVATE LIMITED',
    'PREDSYS TECHNOLOGY PRIVATE LIMITED',
    'VICARA CONSULTING PRIVATE LIMITED',
    'OLYMP TARGET ART PRIVATE LIMITED',
    'SPINDLE INNOVATION LABS PRIVATE LIMITED',
    'AAAVIVA WHIZ GLOBAL PRIVATE LIMITED',
    'HERMES VOYAGES PRIVATE LIMITED',
    'WISSEN IT SERVICES PRIVATE LIMITED',
    'BOXOP SOLUTIONS INDIA PRIVATE LIMITED',
    'ZIONDB SERVICES PRIVATE LIMITED',
    'DAKRA INTERIORS PRIVATE LIMITED',
    'INDE EN VOGUE SOURCING PRIVATE LIMITED',
    'SHAPERZ GREENINDIA PRIVATE LIMITED',
    'PMC YM-PHARMA PRIVATE LIMITED',
    'ATHULYA ASSISTED LIVING PRIVATE LIMITED',
    'SWANKEDGE LIFESTYLE PRIVATE LIMITED',
    'AVGI SOLUTIONS PRIVATE LIMITED',
    'DOLPHIN GRANITES PRIVATE LIMITED',
    'DERMOT INFRACON PRIVATE LIMITED',
    'SULOCHANA PEDESTAL PRIVATE LIMITED',
    'COTOCUS PRIVATE LIMITED',
    'KP INFRA POWER PRIVATE LIMITED',
    'EARTH BLOCKS INDIA PRIVATE LIMITED',
    'KATYAYANI TELECOM SERVICES PRIVATE LIMITED',
    'DURVAH IT CONSULTING PRIVATE LIMITED',
    'MOONLIFE CARE PHARMACEUTICALS PRIVATE LIMITED',
    'BRAINSALT EDUCATION PRIVATE LIMITED',
    'S. AND T. MACHINE TOOLS PRIVATE LIMITED',
    'BENZSMARK FACILITY SERVICES INDIA PRIVATE LIMITED',
    'AFFINITY OUTSOURCING LIMITED',
    'BINARYSPHERE ONLINE SERVICES PRIVATE LIMITED',
    'QUICKSCRUM PRIVATE LIMITED',
    'MILLI GOLD INDIA PRIVATE LIMITED',
    'CYBERLET TECHNOLOGIES PRIVATE LIMITED',
    'WORLDSTAR SHIPPING SERVICES INDIA PRIVATE LIMITED',
    'BODHIFAB PRIVATE LIMITED',
    'MOVAI TECHNOLOGIES PRIVATE LIMITED',
    'GOEL GANGA INDIA PRIVATE LIMITED',
    'INAURATE PEREGRINE ROUTES PRIVATE LIMITED',
    'MAHALAXMI ASSET FINANCE PRIVATE LIMITED',
    'ORGANO FRESH SOLUTIONS PRIVATE LIMITED',
    'SVR AGRITECH INDIA PRIVATE LIMITED',
    'MEETA AGRICORN PRIVATE LIMITED',
    'RUSTOM HOSPITALITY PRIVATE LIMITED',
    'JUICIFIX PRIVATE LIMITED',
    'SABIRY AGROFRUITS PRIVATE LIMITED',
    'GENERAL DENIM PRIVATE LIMITED',
    'AASVAS NIDHI LIMITED',
    'COMPLINITY TECHNOLOGIES PRIVATE LIMITED',
    'BRIGHT HEALTHCARE & WELLNESS PRIVATE LIMITED',
    'PINPOINT DECOR PRIVATE LIMITED',
    'MPF CLOTHING COLLECTIONS PRIVATE LIMITED',
    'HAPPY JARS PRIVATE LIMITED',
    'SUNEXL ENTERPRISES PRIVATE LIMITED',
    'VANMED PHARMACEUTICALS PRIVATE LIMITED',
    'GROLMAN INDIA CHEMICAL PRIVATE LIMITED',
    'LAGOM LABS PRIVATE LIMITED',
    'SUSTAINABLE SPICES INITIATIVE - INDIA',
    'EXCEL BROKING (IFSC) PRIVATE LIMITED',
    'PRAGMATIC FOODTECH PRIVATE LIMITED',
    'PRADA RETAIL FIT-OUT PRIVATE LIMITED',
    'S.N.Q.S. INTERNATIONALS PRIVATE LIMITED',
    'NUTRIZO ADVANCIS HEALTHCARE PRIVATE LIMITED',
    'SOLIDUS LIFESCIENCES PRIVATE LIMITED',
    'SAJAA CHEMICALS PRIVATE LIMITED',
    'ARRUTH TECHNICAL PERFORMANCE WEAR PRIVATE LIMITED',
    'AMIDAS CLOTHING PRIVATE LIMITED',
    'AOUROLIN LAB AND INNOVATION PRIVATE LIMITED',
    'EMUST ENTERPRISES PRIVATE LIMITED',
    'ADJUIND PRIVATE LIMITED',
    'CHANNEL BIOSCIENCES PRIVATE LIMITED',
    '7 CON PIPES PRIVATE LIMITED',
    'PT MATERIALS TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'KISAAN PARIVAR LIMITED',
    'PAFFY INDUSTRIES PRIVATE LIMITED',
    'COMMIT PAPER PRODUCTS PRIVATE LIMITED',
    'WORD BITE TECHNOLOGY PRIVATE LIMITED',
    'ALSTHOM INDUSTRIES LIMITED',
    'METROD METALS PRIVATE LIMITED',
    'ALFERON MANAGEMENT PRIVATE LIMITED',
    'PRIORITY PROFILES PRIVATE LIMITED',
    'KOLMEKS INDIA PRIVATE LIMITED',
    'SHIVAHARDWELL INDUSTRIES (INDIA) PRIVATELIMITED',
    'SPYKE TECHNOLOGIES PRIVATE LIMITED',
    'ODEON CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED',
    'JINDAL TECHNOTEX LIMITED',
    'DENIMHUB LIFESTYLE PRIVATE LIMITED',
    'FERVID SMART SOLUTIONS PRIVATE LIMITED',
    'FOSSBYTES MEDIA PRIVATE LIMITED',
    'JRD DENIMS LIMITED',
    'ORNET PHARMACEUTICALS PRIVATE LIMITED',
    'BUENO SALUD CARE (INDIA) PRIVATE LIMITED',
    'TRITEC SPECIALITIES PRIVATE LIMITED',
    'ANGLOSWIFT DRUGS INDIA PRIVATE LIMITED',
    'EEPOS INDIA PRIVATE LIMITED',
    'WEISS AUTOMATION SOLUTIONS INDIA PRIVATELIMITED',
    'SUJANAND ENGINEERS & CONTRACTORS PRIVATELIMITED',
    'MATEX LASERS & AUTOMATION PRIVATE LIMITED',
    'SSF TUBO LINEA PRIVATE LIMITED',
    'G3 RO PURIFIERS PRIVATE LIMITED',
    'ZONTA BAUER PRIVATE LIMITED',
    'EPREDIA INDIA PRIVATE LIMITED',
    'CASTLE SMART AND ADVANCED TECHNOLOGIES PRIVATE LIMITED',
    'AJU TECH PRIVATE LIMITED',
    'MAG UNICORP PRIVATE LIMITED',
    'AGRICONIC MACHINERIES PRIVATE LIMITED',
    'RADIAL SOLAR SYSTEMS PRIVATE LIMITED',
    'QTPI PRIVATE LIMITED',
    'OPENWATER.IN PRIVATE LIMITED',
    'DETECTRONIC INDIA PRIVATE LIMITED',
    'BOYSEN EXHAUST SYSTEMS PUNE PRIVATE LIMITED',
    'MECHCON INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'SUNIT CONCRANES PRIVATE LIMITED',
    'BIJAPURE EQUIPMENTS PRIVATE LIMITED',
    'CORA WINDOW SYSTEMS PRIVATE LIMITED',
    'MAPS GRANITO PRIVATE LIMITED',
    'ARION TECH SOL PRIVATE LIMITED',
    'CYPET TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TUPIK PRIVATE LIMITED',
    'ONCOSIMIS BIOTECH PRIVATE LIMITED',
    'AVEW INDIA ELECTRONICS PRIVATE LIMITED',
    'AUTOBITS LABS PRIVATE LIMITED',
    'ATISHAY INDENTURE PRIVATE LIMITED',
    'SEION ELECTRICALS PRIVATE LIMITED',
    'DK SOLAR PROJECTS & VENTURES PRIVATE LIMITED',
    'BOVID ELECTRONICS AND COMMUNICATIONS PRIVATE LIMITED',
    'MST MANUFACTURING TECHNOLOGIES PRIVATE LIMITED',
    'MEDIWAYS TECHNOLOGIES PRIVATE LIMITED',
    'AV EDIBLE INGREDIENTS PRIVATE LIMITED',
    'ZEE LIFE SCIENCE PRIVATE LIMITED',
    'ANLON LIFESCIENCE PRIVATE LIMITED',
    'KANVID PHARMACEUTICALS PRIVATE LIMITED',
    'LUSH MOTORS PRIVATE LIMITED',
    'SUN MOBILITY PRIVATE LIMITED',
    'ROSEFINCH PHARMACEUTIQUE PRIVATE LIMITED',
    'GREENTEK NORTHERN INDIA PRIVATE LIMITED',
    'AIPC INDUSTRIES PRIVATE LIMITED',
    'INNOVENTINDIA ENGINEERS PRIVATE LIMITED',
    'RETROTECH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RMPS FACILITY MANAGEMENT PRIVATE LIMITED',
    'CLOUDBURST MEDIAWORKS PRIVATE LIMITED',
    'GPL TECHNICAL SOLUTIONS PRIVATE LIMITED',
    'KANCO MARINE SERVICES PRIVATE LIMITED',
    'ATOZLEARN EDUTECH PRIVATE LIMITED',
    'MIDSON CHITS PRIVATE LIMITED',
    'VAR FINCARE AND TAX CONSULTANTS PRIVATE LIMITED',
    'TQH CONSULTING PRIVATE LIMITED',
    'TRACK INVESTIGATION SERVICES PRIVATE LIMITED',
    'HYSOON TIMEWATCH INFOCOM PRIVATE LIMITED',
    'SATYAM HOLIDAYS PRIVATE LIMITED',
    'PRODYOGIC TECHNOLOGIES PRIVATE LIMITED',
    'RAGHUNANDAN CAPITAL (IFSC) PRIVATE LIMITED',
    'ARSH HR SERVICES PRIVATE LIMITED',
    'DEEVAN EXPEDITING PRIVATE LIMITED',
    'SAPTA CHAKRA PRIVATE LIMITED',
    'NESH INFO TECH PRIVATE LIMITED',
    'PANIPAT PLASTIC PARK HARYANA LIMITED',
    'TRIKUTAHILLS CONCRETE PRODUCTS PRIVATE LIMITED',
    'ALTHERA LABORATORIES INDIA PRIVATE LIMITED',
    'HIROSE ELECTRIC INDIA PRIVATE LIMITED',
    'GUJARAT ISP SERVICES LIMITED',
    'DPA INSTITUTE OF TOURISM AND HOSPITALITYEDUCATION',
    'CEFC PRATHAM FOUNDATION',
    'GESSMANN CONTROLLERS INDIA PRIVATE LIMITED',
    'PHDATA SOLUTIONS PRIVATE LIMITED',
    'SRI VARDHAMAN STHANAKVASI JAIN SANGH ULSOOR',
    'ATTRI BHOWMIK CLOTHING (OPC) PRIVATE LIMITED',
    'MOURYA CONCEPTS (OPC) PRIVATE LIMITED',
    'HYDRA ACTIVE PHARMA SCIENCES PRIVATE LIMITED',
    'ESSEN SHIMMER MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'ALTIS INTEGRATED SOLUTIONS (OPC) PRIVATELIMITED',
    'STUDY2WIN PRIVATE LIMITED',
    'TALENT ZONE PRIVATE LIMITED',
    'SYSTATIC CONSULTING SERVICES PRIVATE LIMITED',
    'BRAINIERS CONSULTANCY SERVICES PRIVATE LIMITED',
    'SAHAMANTHRAN PRIVATE LIMITED',
    'ADWOOSH MARKETING PRIVATE LIMITED',
    'MAX SUN SOLAR POWER PROJECTS PRIVATE LIMITED',
    'XPHENO PRIVATE LIMITED',
    'SURMOUNTISUCCESS GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SENTIENZ SOLUTIONS PRIVATE LIMITED',
    'MAHI VISA SERVICES PRIVATE LIMITED',
    'VASOYA INDUSTRIES PRIVATE LIMITED',
    'INTELLIWORKZ BUSINESS SOLUTIONS PRIVATE LIMITED',
    'AITMC VENTURES LIMITED',
    'PROLEAD NEOVENTURES PRIVATE LIMITED',
    'SNI LEGAL TECHNOLOGIES PRIVATE LIMITED',
    'AGSATECH INFO SERVICES PRIVATE LIMITED',
    'PEPPERL & FUCHS FACTORY AUTOMATION PRIVATE LIMITED',
    'DHARMA LIFE SCIENCES PRIVATE LIMITED',
    'IGE+XAO INDIA PRIVATE LIMITED',
    'SAGESTREET ADVISORY PRIVATE LIMITED',
    'BIZBUZZZ ECOMMERCE AND ADVERTISING PRIVATE LIMITED',
    'SURABHINATURALS PRIVATE LIMITED',
    'GODDARD TECHNICAL SOLUTIONS PRIVATE LIMITED',
    'VALUE ENABLERS (OPC) PRIVATE LIMITED',
    'NEOSPEAR SOFTWARE AND DEFENCE SERVICES PRIVATE LIMITED',
    'PROLEAD PROCESS OUTSOURCING AND COMPLIANCE SERVICES PRIVATE LIMITED',
    'BLOCK STOCK & BARRELS PRIVATE LIMITED',
    'CHARGE DOCK PRIVATE LIMITED',
    'TRENDESIGN INTERIOR SOLUTIONS PRIVATE LIMITED',
    'APPNINGS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'TRIAH LABS PRIVATE LIMITED',
    'RENTON NEED SERVICES PRIVATE LIMITED',
    'COMBAT LEAGUE PRIVATE LIMITED',
    'COUNTRY HOLIDAYS INN & SUITES PRIVATE LIMITED',
    'IOSYNTH LABS PRIVATE LIMITED',
    'FINZIP PRIVATE LIMITED',
    'PEBBLEWOOD INTERIORS PRIVATE LIMITED',
    'JDM AUTO COMPONENTS PRIVATE LIMITED',
    'AMARA HOTELS & RESORTS PRIVATE LIMITED',
    'BESTMATE INVESTMENT SERVICES PRIVATE LIMITED',
    'EXPAT IMMIGRATION SERVICES PRIVATE LIMITED',
    'OBCON SOLUTIONS PRIVATE LIMITED',
    'AREAHOP LABS PRIVATE LIMITED',
    'AUDICOR CARDIOMETRICS PRIVATE LIMITED',
    'KARO SAMBHAV PRIVATE LIMITED',
    'TRANSVERSAL TECH PRIVATE LIMITED',
    'SWISH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SURROUND NETWORKS PRIVATE LIMITED',
    'CURADEN INDIA PRIVATE LIMITED',
    'GROWTHLEAP CONSULTING SERVICES PRIVATE LIMITED',
    'PRAJAPATI PROJECTS AND VENTURES PRIVATE LIMITED',
    'P&T ACCOUNTANT',
    'S BHAU INSTITUTE OF INNOVATION ENTREPRENEURSHIP AND LEADERSHIP',
    'NOVOCURA TECH HEALTH SERVICES PRIVATE LIMITED',
    'ADILAXMI E-COMMERCE PRIVATE LIMITED',
    'INNOCRAFT ENGIMECH PRIVATE LIMITED',
    'INGENIOCRATS PRIVATE LIMITED',
    'KENDA EAGLE FOUNDATION',
    'VIGYAN MEDIA & TECHNOLOGIES PRIVATE LIMITED',
    'STRATA MULTIVENTURES PRIVATE LIMITED',
    'SMAK INNOMINDS PRIVATE LIMITED',
    'GUIDEWAYCOVERS PRIVATE LIMITED',
    'LAXMI INFOBAHN AQUADUCT PRIVATE LIMITED',
    'LAXMI INFOBAHN ONE PRIVATE LIMITED',
    'PURELEARN EDUSERVE AP PRIVATE LIMITED',
    'ARKIS LIGHTINGS PRIVATE LIMITED',
    'HUMBLEBRAG ADVERTISING PRIVATE LIMITED',
    'ENVIRO CREATORS FOUNDATION',
    'SCANFII SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'VALLEYWORKS TECH VENTURES PRIVATE LIMITED',
    'SYMBIOUN GLOBAL PRIVATE LIMITED',
    'SAVALI MOTORS PRIVATE LIMITED',
    'KNS PROPERTIES PRIVATE LIMITED',
    'RUN ADAM SPORTS PRIVATE LIMITED',
    'VICTOR RAIL SYSTEMS PRIVATE LIMITED',
    'NIKOM COPPER AND CONDUCTORS PRIVATE LIMITED',
    'WEEBO WAVES PRIVATE LIMITED',
    'KUSHWAHA',
    'S BEVERAGES PRIVATE LIMITED',
    'KONCEPT INFRATECH PRIVATE LIMITED',
    'OOMERO TECHNOLOGY PRIVATE LIMITED',
    'ACU 1ST CHOICE INSURANCE BROKERS PRIVATELIMITED',
    'SKIG PRIVATE LIMITED',
    'NUCLEAR MEDSYSTEMS INDIA PRIVATE LIMITED',
    'THINK ON PRIVATE LIMITED',
    'ORTECH TEXTILES PRIVATE LIMITED',
    'LEAGILE SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'KISRA DIGITAL MARKETING PRIVATE LIMITED',
    'JKG INVESTMENTS PRIVATE LIMITED',
    'SEPAM SOLUTIONS INDIA PRIVATE LIMITED',
    'RETOLD STORIES PRIVATE LIMITED',
    'BMARK LOGISTICS INDIA PRIVATE LIMITED',
    'ASTRO INVESTMENT & SECURITIES PRIVATE LIMITED',
    'FINX INVESTMENTS CONSULTANCY PRIVATE LIMITED',
    'CARTRADE FOUNDATION',
    'PURATECH CONSULTANCY SOLUTIONS PRIVATE LIMITED',
    'SWAYER INDUSTRIES PRIVATE LIMITED',
    'VIERA SEAMLESS PRIVATE LIMITED',
    'PANDROL RAHEE PRECISION INDUSTRIES PRIVATE LIMITED',
    'WINDFLUX TECHNOLOGIES PRIVATE LIMITED',
    'CODENGINE TECHNOLOGIES PRIVATE LIMITED',
    'CUDDALORE AGRO AND AQUA WORLD FARMER PRODUCER COMPANY LIMITED',
    'OLVY TECHNOLOGIES PRIVATE LIMITED',
    'BAMMCO PRIVATE LIMITED',
    'POPSPACE TECHNOLOGIES PRIVATE LIMITED',
    'TIREX TRANSMISSION PRIVATE LIMITED',
    'HEIRLOOM BAY PRIVATE LIMITED',
    'INFRAMANTRA INDIA PRIVATE LIMITED',
    'DAY FRESH RETAIL PRIVATE LIMITED',
    'CAPITARESOURCES PRIVATE LIMITED',
    'KINSEY KIIDS PRIVATE LIMITED',
    'SANMAN CITY PRIVATE LIMITED',
    'MAPND TRADING PRIVATE LIMITED',
    'TKV ENTERPRISES PRIVATE LIMITED',
    'Corus realtech private limited',
    'Dalhar developers private limited',
    'Oorjita projects private limited',
    'Global habitat private limited',
    'Good earth india infra private limited',
    'Fanibhushan build tech private limited',
    'Ashray neev private limited',
    'Salcon infrastructure private limited',
    'Konnark residency (i) private limited',
    'Golden age infrastructure private limited',
    'Golden age sweet home private limited',
    'Deserve houscorp private limited',
    'Sri tanesha infra private limited',
    'Infrastructure development corporation (karnataka) limited',
    'Srishaila constructions private limited',
    'Chayadeep properties private limited',
    'Il&fs airports limited',
    'Jan de nul dredging india private limited',
    'Amr malind infra private limited',
    'Rsg projects private limited',
    'Golden age structure private limited',
    'Buddies constructions private limited',
    'Yojna consultants private limited',
    'Sensation infracon private limited',
    'Sreereddy properties private limited',
    'Ivr prime developers (araku) private limited',
    'Deserve city private limited',
    'S h mangalam realty private limited',
    'Winsway realtors private limited',
    'GOLDEN AGE DWELLERS & LIVING PRIVATE LIMITED',
    'Golden age build cons private limited',
    'Brizo reality company private limited',
    'Redbrick private limited',
    'R.k. facade private limited',
    'Friscon infrastructures private limited',
    'P. bhushan residency private limited',
    'D p homes infraprojects private limited',
    'R r life space private limited',
    'Marwin infratech private limited',
    'Cornerview constructions & developers private limited',
    'Deserve arcade private limited',
    'Tci infrastructure limited',
    'D g infrastructure private limited',
    'RAJARSHI BIKES PRIVATE LIMITED',
    'Calamity car parlor private limited',
    'Omkar vehicles private limited',
    'Apco motolink private limited',
    'Rach exports private limited',
    'Saurastra interior private limited',
    'Kwickadd technologies private limited',
    'Vandana global limited',
    'Pharmacrest company private limited',
    'Manali e-business private limited',
    'Varakas global trade private limited',
    'Pure dead sea cosmetics private limited',
    'Nambiar trading private limited',
    'Roots global private limited',
    'Fortune tracom private limited',
    'Shri ram spices private limited',
    'Banthia unitrade private limited',
    'Subodhchandra jewellers private limited',
    'Sethwala farms and foods private limited',
    'S.h.a.m.k. mercantile private limited',
    'Esco biotech private limited',
    'Standard ganpati merchandise private limited',
    'Bharaj machineries private limited',
    'Cromwell industrial supplies private limited',
    'Cosmos business machines private limited',
    'Wuerth industrial services india private limited',
    'ZWICKROELL PRIVATE LIMITED',
    'Subham floriculture pvt ltd',
    'Divinitee genesis apparel private limited',
    'Total prototyping private limited',
    'Bmr marine products private limited',
    'Hn indigos private limited',
    '3d product development private limited',
    'NMC TOOLS PRIVATE LIMITED',
    'Unique services minmetals private limited',
    'A&m resources private limited',
    'Imerys ceramics (india) private limited',
    'Paramyug mines & minerals private limited',
    'Valentine foods private limited',
    'Aarkay food products ltd',
    'Dmul-asia overseas private limited',
    'K c dairy products private limited',
    'SHIKHAR URBAN AND RURAL ENTERPRISES PRIVATE LIMITED',
    'Shruti park pvt ltd',
    'ROQUETTE INDIA PRIVATE LIMITED',
    'INDIANFOODS INNOVATIONS PRIVATE LIMITED',
    'Ab mauri india private limited',
    'International bakery products limited',
    'Snacko bisc private limited',
    'Hydrolina biotech private limited',
    'Mangal masala private limited',
    'Dolphin foods india limited',
    'Atop food products private limited',
    'J.p. distilleries private limited',
    'Crown beers india private limited',
    'Sri lakshmi narasimha distilleries private limited',
    'Spaaqua products india private limited',
    'ALOK KNIT EXPORTS LIMITED',
    'Srijayavilas subbaraj spinning mills private limited',
    'Nisra tex exports private limited',
    'Gajanan textiles private limited',
    'Divya texturising private limited',
    'Raheja texfab private limited',
    'B-ARIN FABRICS PRIVATE LIMITED',
    'Mahan synthetic textiles private limited',
    'Sunrise colours limited',
    'Euro fashion inners international private limited',
    'Aaditya shoprite private limited',
    'Gilwood fashions private limited',
    'Bhairav creations private limited',
    'Edge apparels private limited',
    'Ganapati fishing line private limited',
    'Naredi texfab private limited',
    'Rupasi vanijaya private limited',
    'The suminter organic and fair trade cotton ginning mill private limited',
    'J.k. fabrics bangalore private limited',
    'Gini & jony limited',
    'Roop designs private limited',
    'Da lady apparels private limited',
    'Waterfront linen care private limited',
    'Sakshi leather exports private limited',
    'Calceus fashion private limited',
    'Plymex timber pvt ltd',
    'Vilsons particle board industries limited',
    'Sonal paper agencies private limited',
    'Gopal krishna papers private limited',
    'Gayatrishakti paper & boards limited',
    'Prakash corrugated pune private limited',
    'Bank note paper mill india private limited',
    'Shruti print solution private limited',
    'Rose valley patrika ltd',
    'Clood on musica private limited',
    'Midday infomedia limited',
    'Tarun printing works private limited',
    'Paperwall media & publishing private limited',
    'Declaration media private limited',
    'Napol entertainment private limited',
    'Lucent cleanenergy private limited',
    'Tribo lubes private limited',
    'Sundaram alloys limited',
    'Krunal industries private limited',
    'Irb ahmedabad vadodara super express tollway private limited',
    'Docklands infrastructure private limited',
    'Nide builders private limited',
    'Dhanya realty private limited',
    'VAG BUILDTECH LIMITED',
    'Kites infrabuild private limited',
    'Deco tech projects (india) private limited',
    'Fareast engineering and construction company private limited',
    'LEARNSURE AI PRIVATE LIMITED',
    'Mahidhara projects private limited',
    'Sai maatarini tollways limited',
    'Open spaces avenues india private limited',
    'Jak construction company private limited',
    'Green towers private limited',
    'FLEXCOM INDUSTRIES PRIVATE LIMITED',
    'Castle shelter private limited',
    'Micra heights private limited',
    'Granrock tiles private limited',
    'Superstone koats private limited',
    'Yantra aluminium window systems private limited',
    'Willwin india private limited',
    'Anas motors private limited',
    'Adimere solutions private limited',
    'Aariya cars private limited',
    'Wifin technologies india private limited',
    'Kg technology solutions private limited',
    'Spark mahalearning private limited',
    'Dhvani research and development solutions private limited',
    'Felix infotech private limited',
    'Invoscape technologies private limited',
    'O3m directional marketing private limited',
    'Fore brain technologies private limited',
    'CDW TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Bosco soft technologies private limited',
    'Dcis dot com solutions india private limited',
    'Maze net solution private limited',
    'Calysto software private limited',
    'FL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Cloud assert technologies india private limited',
    'Octagon enterprises private limited',
    'Force ten technologies private limited',
    'Sandcube technologies private limited',
    'Magicnines infotech private limited',
    'Mecwise software solutions private limited',
    'SHRESTHA SOFTWARE & SERVICES PRIVATE LIMITED',
    'Marksman technologies private limited',
    'King digital private limited',
    'Codenxt web technologies private limited',
    'Star india private limited',
    'The information company private limited',
    'Kalpataru computer services private limited',
    'Financial technologies communications limited',
    'Atidan technologies private limited',
    'Biztran solutions private limited',
    'Arohi software solutions private limited',
    'Web concepts 4u.com private limited',
    'Ecgplus technologies private limited',
    'Willswell technologies private limited',
    'Solverra technologies private limited',
    'Creapptive solutions private limited',
    'Brihaspathi technologies private limited',
    'Caprus it private limited',
    'Atn global networks private limited',
    'Resourcepoint technology solutions private limited',
    'Next wave multimedia private limited',
    'Medxpert solutions india private limited',
    'Canwin technologies private limited',
    'SNIPER SYSTEMS & SOLUTIONS PRIVATE LIMITED',
    'Coppercone software india private limited',
    'Namlabs technologies private limited',
    'Millennium dealcom private limited',
    'Netroute solutions private limited',
    'Slipstream it solutions private limited',
    'DEMANDSHORE SOLUTIONS PRIVATE LIMITED',
    'Mindmap it solution private limited',
    'Mana hc info private limited',
    'Connect compusys private limited',
    'Softeon india private limited',
    'Wpg c&c computers and peripheral (india) private limited',
    'Skiva technologies india private limited',
    'Dataperts technologies private limited',
    'Lintel technologies private limited',
    'TAC GLOBAL TECHNOLOGY PRIVATE LIMITED',
    'Proscizen research services private limited',
    'Custom apps and solutions private limited',
    'Rays techserv private limited',
    'Intech creative services private limited',
    'Edmca (india) private limited',
    'Iappsecure solutions private limited',
    'Port23 software solutions private limited',
    'Arvaan techno-lab private limited',
    'Vivacious web solutions private limited',
    'Greycell software private limited',
    'Comline corporate solutions private limited',
    'Softakin it solution private limited',
    'Prompt solutions private limited',
    'Google india private limited',
    'Colossal software technologies private limited',
    'DIGIT7 INDIA PRIVATE LIMITED',
    'Bolas intelli solutions private limited',
    'Digiwave networks private limited',
    'Commlabs technology centre private limited',
    'Tonbo imaging private limited',
    'REGALTUSK PRIVATE LIMITED',
    'Jamee networks private limited',
    'Albestraws software solutions private limited',
    'Arkieva supply chain technologies private limited',
    'Byzan systems pvt.ltd.',
    'Dyne infotech private limited',
    'Netmonastery network security private limited',
    'Knowledge oak company (india) private limited',
    'Gravitas brands india private limited',
    'Testex ndt india private limited',
    'Marathe infotech private limited',
    'Sansui shipping software private limited',
    'Abel software and consultants private limited',
    'Spine technologies (india) private limited',
    'Clear info-analytics private limited',
    'TICKER LIMITED',
    'ALBA INDUSTRIES LIMITED',
    'Antique minerals private limited',
    'Kns stonetech private limited',
    'Robo quarries private limited',
    'Ashwmegh industries private limited',
    'Lord govardhan beverages private limited',
    'Namosri ventures private limited',
    'Shree nagai devi sugar private limited',
    'Tummyfull foodventure private limited',
    'RMD FOODS & BEVERAGES PRIVATE LIMITED',
    'Vayhan instant foods private limited',
    'Phillips foods india private limited',
    'Prova flavours (india) private limited',
    'Rahil dairy industries private limited',
    'Banpal oilchem private limited',
    'Milk mantra dairy private limited',
    'Eastern red ruby food private limited',
    'DOLLON',
    'S RETAIL INDIA PRIVATE LIMITED',
    'European flavours and fragrances private limited',
    'Ftd infocom private limited',
    'BLOOMING BUD',
    'Mannk foods (india) private limited',
    'Nimbus beverages private limited',
    'Glanbia india private limited',
    'Madam agro-food industries private limited',
    'SOMA VINE VILLAGE PRIVATE LIMITED',
    'Laplant beverages private limited',
    'YOGURTBAY FOODS & BEVERAGES PRIVATE LIMITED',
    'Continental tobacco limited',
    'Arabian nights private limited',
    'Harsharatna industries private limited',
    'Kelvin silk mills private limited',
    'Prime tradecom private limited',
    'Silk india international limited',
    'AKLAVYA INDUSTRIES PRIVATE LIMITED',
    'Deepkala silk heritage private limited',
    'SILKY IMAGES FASHIONS PRIVATE LIMITED',
    'Khetani textile industries private limited',
    'Accusynth speciality chemicals private limited',
    'Vinaylene textile industriees pvt ltd',
    'Makhanlal rajkumar cotton limited',
    'Srestha arts and commodities private limited',
    'BHUMI TEX INDUSTRIES PRIVATE LIMITED',
    'M.m.naina exports private limited',
    'Sri ramalinga textiles p ltd',
    'Shree m.t.k.textiles private limited',
    'ASHOK TEXTILE MILLS PRIVATE LIMITED',
    'Peps industries private limited',
    'Natural fibre products consortium private limited',
    'Augustan coimbatore knitting co private limited',
    'KIRAN DESIGNERS PRIVATE LIMITED',
    'Santogen silk mills limited',
    'Konark infratech private limited',
    'Sunita developers private limited',
    'Silk india realty private limited',
    'Conoor builders private limited',
    'ANAY AGRI ESTATES PRIVATE LIMITED',
    'Kmc constructions limited',
    'QUBE 6 BUILDING SYSTEMS PRIVATE LIMITED',
    'Guruvayoor infrastructure private limited',
    'Metropolitan ventures india limited',
    'Krishnaiah dreamlands private limited',
    'ECOFACE INDIA PRIVATE LIMITED',
    'Prajay urban private limited',
    'Mjr infra private limited',
    'KIRBY BUILDING SYSTEMS & STRUCTURES INDIA PRIVATE LIMITED',
    'Om krishna buildcon private limited',
    'A b excavators and earthmovers private limited',
    'ADROID PRECISION PLASTICS PRIVATE LIMITED',
    'Cordial infrastructure private limited',
    'Kay kay royal apartments private limited',
    'Versatile buildtech private limited',
    'Dignity buildcon private limited',
    'River palace properties limited',
    'Growth field pvt ltd',
    'Pragati buildcon pvt ltd',
    'Ashman estate private limited',
    'G h vijapura infrastructure private limited',
    'Eternia complex private limited',
    'Divyajivan infrastructure private limited',
    'Shree matangi buildcon private limited',
    'Ranka developers private limited',
    'Sankalp hospitality private limited',
    'Skanda buildtech private limited',
    'Sowparnika projects and infrastructure private limited',
    'Prajwal promoters private limited',
    'Mgm - pooja buildtech private limited',
    'Nikunjam constructions private limited',
    'LOGTECH BUSINESS PRIVATE LIMITED',
    'Vkl builders india private limited',
    'Apollo green village private limited',
    'Bharath hi-tecch builders private limited',
    'Shamik enterprises private limited',
    'Saicharan properties limited',
    'Neeladri enterprises private limited',
    'Shiva land infrastructure private limited',
    'Kamla shanti landmarc property private limited',
    'ALDER RESIDENCY PRIVATE LIMITED',
    'Dhariya construction private limited',
    'Suncity buildhome private limited',
    'Ansal jkd pearl developers private limited',
    'Krishnam infrabuilders private limited',
    'HARSH MACRO DEVELOPERS PRIVATE LIMITED',
    'Gkb builders & developers private limited',
    'Pvp corporate parks private limited',
    'V.g.n.homes private limited',
    'Civi chem & applications private limited',
    'Vijaydeepa constructions private limited',
    'Shaligram buildcon private limited',
    'Db shapriya construction limited',
    'Vakil housing development corporation private limited',
    'Kalyani techpark private limited',
    'Teekays prime properties india limited',
    'Sri ventures land developers india limited',
    'Tangent construction (india) private limited',
    'Claysys infrastructure private limited',
    'Alfa erectors private limited',
    'Mindset estates private limited',
    'Sun-blend realtors private limited',
    'Lavitra properties private limited',
    'Supreme manor wada bhiwandi infrastructure private limited',
    'Colours real-estate properties private limited',
    'Agility infrastructure private limited',
    'Varz buildon private limited',
    'Nahar industrial infrastructure corporation limited',
    'Kranti developers private limited',
    'Oxford shelters private limited',
    'Sri krishna shapir construction private limited',
    'Bhugan infracon private limited',
    'Neo housing and infrastructure development limited',
    'Shashi structural engineers private limited',
    'Air city infrastructures private limited',
    'Megatown infradevelopers private limited',
    'North malabar expressway limited',
    'South malabar expressway private limited',
    'Simhapuri expressway limited',
    'L&L CONSTRUCTIONS PRIVATE LIMITED',
    'Shrocons infrastructures private limited',
    'International seaports (haldia) private limited',
    'Savla real estate private limited',
    'Exol infrastructure india limited',
    'Rsr infra works (india) private limited',
    'Sri saideva infra projects private limited',
    'Sai snigtha infrastructure private limited',
    'SOUTH CITY PROMOTERS & DEVELOPERS PRIVATE LIMITED',
    'Ameyas buildcons private limited',
    'ESTRELLA ENTERPRISES PRIVATE LIMITED',
    'Hi-vision infratech and developer (india) private limited',
    'Ab expressway limited',
    'Bricmor infra projects private limited',
    'Nirmal homes private limited',
    'Hdil infra projects private limited',
    'Greatdeal developers private limited',
    'Rajeshwar land developers private limited',
    'Mane developers private limited',
    'Wellknown housing development private limited',
    'Dream town properties private limited',
    'Navinmail realty private limited',
    'Wellknown infratech private limited',
    'Wellknown properties private limited',
    'Greater heights engg. solutions private limited',
    'Gd housing private limited',
    'Elargir solutions private limited',
    'Unicca realtech private limited',
    'Victor homes private limited',
    'Anitha housing private limited',
    'Sujatha homes private limited',
    'Aishu avenues private limited',
    'Krishnaiah home fields private limited',
    'BOLLINENI FARM SERVICES PRIVATE LIMITED',
    'Beekay dreamlands private limited',
    'Deeyes home fields private limited',
    'Sujatha arcades private limited',
    'SUPRA EARTH PRIVATE LIMITED',
    'Barath building construction (india) private limited',
    'Tejas foundation private limited',
    'Mahalaxmi buildwell enterprises private limited',
    'Golden life realcon india limited',
    'Silicon infratech private limited',
    'Flexible technology solutions india private limited',
    'Peninsula electronics manufacturing services private limited',
    'Optym india private limited',
    'Invaria tech india private limited',
    'Chipsapp technologies private limited',
    'Swizcom technologies india private limited',
    'Yuktix technologies private limited',
    'Confictura solution technologies private limited',
    'S2s softsys private limited',
    'Emplay analytics private limited',
    'Pi axis technologies private limited (opc)',
    'Einfolge technologies private limited',
    'Gsoft services private limited',
    'STM DOCUMENT ENGINEERING PRIVATE LIMITED',
    'Kameda infologics private limited',
    'Compu systems india private limited',
    'Ahalia information and management system private limited',
    'DIMENSION FINANCIAL SOFTWARE CONSULTANCYSERVICES PRIVATE LIMITED',
    'Data devices private limited',
    'Aride ocean infoway private limited',
    'Vordale software and consulting private limited',
    'Firstpos retail softsolutions india private limited',
    'Netcrew technologies private limited',
    'Worldemart private limited',
    'Richken media private limited',
    'Rawdata technologies private limited',
    'Perfomatix solutions private limited',
    'Dema tech solutions private limited',
    'Ileaf solutions private limited',
    'Sound trade and infotech private limited',
    'Seshaasai e-forms private limited',
    'Silverlink technologies private limited',
    'Lean six software private limited',
    'Cbt infotech private limited',
    'Commit technologies private limited',
    'Bhagyashree infotech private limited',
    'S2 institute of information technology management private limited',
    'Synergics solutions private limited',
    'Cubix micro systems india private limited',
    'Clarion technologies private limited',
    'Webtech developers private limited',
    'Vertex infoservices private limited',
    'Bitcode technologies private limited',
    'Kale logistics solutions private limited',
    'Interactive visual solutions private limited',
    'Codezeven software private limited',
    'Profecia links consulting private limited',
    'Transflower learning private limited',
    'Leadenrich solutions private limited',
    'Professional tech solutions private limited',
    'Innothoughts systems private limited',
    'Inuxu digital media technologies private limited',
    'Chanakya softech private limited',
    'GIRNAR SOFTWARE PRIVATE LIMITED',
    'Skyshade technologies private limited',
    'S. s. g. solutions private limited',
    'Teleparadigm networks limited',
    'HIENRA TECHNOLOGIES PRIVATE LIMITED',
    'Packetware (india) private limited',
    'Cendura software private limited',
    'Kasura technologies private limited',
    'Istorage india private limited',
    'Proclass technologies private limited',
    'Azri technologies (india) private limited',
    'Prathima infopark private limited',
    'Ces information technologies private limited',
    'Winfocus solutions private limited',
    'Worldtech software solutions private limited',
    'Wichorus design and development private limited',
    'Externetworks (india) private limited',
    'Honeypot it consulting private limited',
    'Need soft technologies private limited',
    'Bee innovations india private limited',
    'Creativexperts consulting private limited',
    'RYTHMOS INDIA PRIVATE LIMITED',
    'It grids (india) private limited',
    'Tech dimensions solutions private limited',
    'Ensoft professionals private limited',
    'Yq soft labs private limited',
    'Green work integrated technologies private limited',
    'Grid logic software private limited',
    'Cupertino techvox software private limited',
    'Amigo optima software solutions private limited',
    'Pyramid it solutions private limited',
    'Infologitech systems private limited',
    'Nexii it labs private limited',
    'Gagri global it services private limited',
    'COGNITIVZEN TECHNOLOGIES PRIVATE LIMITED',
    'Stratosphere it services private limited',
    'Vrtex solutions private limited',
    'Winvinaya infosystems india private limited',
    'Ism software private limited',
    'Sify technologies limited',
    'Zeus hygia life sciences private limited',
    'Surtech survey consultants india private limited',
    'Pixel boy media publicities private limited',
    'Iwa environment solutions private limited',
    'Layers-7 seguro consultoria private limited',
    'Kaizen ship management india private limited',
    'Imperial cements private limited',
    'Equus ict services india private limited',
    'Ma facility management and services private limited',
    'ARZ FOOD VENTURES PRIVATE LIMITED',
    '2cqr automation private limited',
    'Focus 4-d career education private limited',
    'Itemax engineering services private limited',
    'Sanghi investment advisors private limited',
    'Jhawar impact ventures private limited',
    'Sasmal infrastructure private limited',
    'Rangan technologies india private limited',
    'Karnataka asset management company private limited',
    'K V K RAJU INTERNATIONAL LEADERSHIP LIMITED',
    'Eduworld bangalore educational services private limited',
    'Shail foundation',
    'Hopes and dreamz learning private limited',
    'Ethnus consultancy services private limited',
    'Best first step education private limited',
    'R k educational institute',
    'ANWESHA FOUNDATION',
    'Iht network limited',
    'Brahmananda educational services private limited',
    'TALLY EDUCATION AND DISTRIBUTION SERVICES PRIVATE LIMITED',
    'Rochester wadhawan foundation for learning',
    'Smart start educations private limited',
    'Indrajal edutech private limited',
    'MILE MANAGEMENT INSTITUTE FOR LEADERSHIP & EXCELLENCE (INDIA) PRIVATE LIMITED',
    'Raghava puspha gayathri devi educational institution private limited',
    'Aim education pvt ltd',
    'Learnmile solutions private limited',
    'Musicuniv india private limited',
    'Arun muchhala education & research centre',
    'Dalmia biz education private limited',
    '360 world educator private limited',
    'Tapa international education network private limited',
    'Composite education solutions private limited',
    'Sneh academic services private limited',
    'Laetus education private limited',
    'Edulearning services private limited',
    'Eduvantage learning solutions private limited',
    'Piramal foundation for education leadership',
    'Medvarsity online limited',
    'Rl institute of aeronautical and engineering technology private limited',
    'Garnet education private limited',
    'IFMA INDIA COMPANY',
    'Chippersage education private limited',
    'Silverline edu services private limited',
    'Piramal higher education private limited',
    'Elins switch boards private limited',
    'Air borne logistics private limited',
    'Visakha plastic surgery services private limited',
    'DALMIA BIZ BULK PRIVATE LIMITED',
    'Genlabs healthcare private limited',
    'Royal dental clinics private limited',
    'SOHUM WELLNESS LIMITED',
    'Shonaalii sabherwal healthier lfestyle options private limited',
    'Greenchemistree foundation',
    'Bhaskar charitable institute',
    'Lorea healthcare private limited',
    'Ocean lifecare private limited',
    'Express clinics private limited',
    'SUASTH HEALTH CARE FOUNDATION',
    'Pinnacle hospitals india private limited',
    'Denave india private limited',
    'RADISSON HOSPITALITY MARKETING (INDIA) PRIVATE LIMITED',
    'N.M.PROPERTIES & CONSULTING PRIVATE LIMITED',
    'Rishi poly mach private limited',
    'Rifco safari enclave developers private limited',
    'Binco constructions private limited',
    'Southern lubrication private limited',
    'Shivangini properties private limited',
    'Karnataka hybrid micro devices limited.',
    'Mikrotek machines limited',
    'Maharashtra apex asset management company limited',
    'Infotech global (india) limited',
    'VISTRA CORPORATE SERVICES (INDIA) PRIVATE LIMITED',
    'Cessna garden developers private limited',
    'SAFT INDIA PRIVATE LIMITED',
    'BRAMHALL DEVELOPERS PRIVATE LIMITED',
    'Kamaz motors limited',
    'Lg soft india private limited',
    'Lifesupporters medical academy private limited',
    'Prama research lab private limited',
    'Asha kiran hospitals private limited',
    'Apollo bangalore cradle limited',
    'Apollo sugar clinics limited',
    'Sirona dental systems private limited',
    'Apeejay stya education foundation',
    'Ddk ayurheritage health centre private limited',
    'Eqms india private limited',
    'R and a foods private limited',
    'Expatiate communications india private limited',
    'Eximious ventures private limited',
    'K.l. scientech platers private limited',
    'Senthil navigations private limited',
    'Pentagon forge & machine limited',
    'Nu-way heatransfer private limited',
    'Svs hydraulics private limited',
    'PRIME TOOLS & EQUIPMENTS PRIVATE LIMITED',
    'Ogura clutch india private limited',
    'Triumph mechanics private limited',
    'Sunita die parts pvt ltd',
    'SUNITA TOOLS LIMITED',
    'IMAGINON ECOMM PRIVATE LIMITED',
    'Abhijeet techno-plast (india) private limited',
    'Jcr drillsol private limited',
    'Hyderabad metallurgical services pvt ltd',
    'Super technical (india) private limited',
    'Mainland heavy parts private limited',
    'Enrika trades and services private limited',
    'Nes engineers india private limited',
    'Shreefal engineering private limited',
    'HCJ TRADECOM PRIVATE LIMITED',
    'Sas industrial solutions private limited',
    'Rana machines india private limited',
    'Imosys engineering company private limited',
    'Manav manufacturing solutions private limited',
    'Aquarex purisys private limited',
    'LOTUS BOILERS & PRESSURE VESSELS PRIVATE LIMITED',
    'Bwe energy india private limited',
    'C&B ECOGEN PRIVATE LIMITED',
    'Oerlikon textile india private limited',
    'Reshmi industries (india) private limited',
    'Singhal power presses private limited',
    'Enprou technologies india private limited',
    'Care well fabrications private limited',
    'SANCTUS GLOBAL FORMULATIONS LIMITED',
    'Shree biocare solutions private limited',
    'Supra hi tech electro equipments pvt ltd',
    'Sahya valley technologies private limited',
    'Malabar extrusion equipments and spares private limited',
    'Prabhat elastomers pvt ltd',
    'Ike power engineering private limited',
    'Seven star electrodes private limited',
    'Nectar projects private limited',
    'Tii techno testing instruments private limited',
    'Sankalp engineering & services private limited',
    'Dezitech engineering private limited',
    'Tweezerman india private limited',
    'Nova gas techniques private limited',
    'Kasyap industries private limited',
    'AERIES TECHNOLOGY PRODUCTS AND STRATEGIES PRIVATE LIMITED',
    'Excel heaters private limited',
    'ANDHRA ELECTRONICS LIMITED',
    'Globe components private limited',
    'Bonfiglioli transmissions private limited',
    'Airco-fin tubes india private limited',
    'I-design engineering solutions limited',
    'Best it world (india) private limited',
    'HYPERCEPT VENTURES (INDIA) PRIVATE LIMITED',
    'Pratik technologies private limited',
    'Infonet asia private limited',
    'Supreme computers india private limited',
    'AMER-SIL KETEX PRIVATE LIMITED',
    'Edgar interactive private limited',
    'Rhea knowledge technologies private limited',
    'Prime abgb private limited',
    'J.p.electronic devices (india ) private limited',
    'Yercaud electronics private limited',
    'Galaxy controls private limited',
    'TVS SENSING SOLUTIONS PRIVATE LIMITED',
    'Icon design automation private limited',
    'Vyshali energy private limited',
    'Retesh appliances pvt ltd',
    'Royalarc electrodes limited',
    'Jts power private limited',
    'Escon gensets private limited.',
    'Six sigma technology private limited',
    'Precialp precision india private limited',
    'Crystal cooling towers private limited',
    'Sun electro devices private limited',
    'Densol engineering private limited',
    'Ultravolt instruments private limited',
    '21st century equipments private limited',
    'Thermo engineers private limitd',
    'SERVOTECH POWER SYSTEMS LIMITED',
    'Modutec ready panels private limited',
    'Stelmec limited',
    'Paramount mechanics private limited',
    'GARUDA FINSEC ADVISORY PRIVATE LIMITED',
    'Insta control private limited',
    'Office 2000 solutions private limited',
    'Briggs & stratton india private limited',
    'Leron chem private limited',
    'Winding wires manufacturers association of india',
    'Kaydour cables india private limited',
    'Ravi electricals private limited',
    'Jastech systems private limited',
    'Daramic battery separator india private limited',
    'Indo saudi services (cargo) private limited',
    'Sanall shipping private limited',
    'Rajkamal transport pvt ltd',
    'Sunrise logistics private limited',
    'Sriragav cargo private limited',
    'R n cabs private limited',
    'Skynautics services private limited',
    'DIVERSEY INDIA HYGIENE PRIVATE LIMITED',
    'Allcargo logistics park private limited',
    'Freight lines (india) pvt ltd',
    'Yourway transport biopharma services private limited',
    'Sancoline india private limited',
    'AYEN FREIGHT FORWARDERS PRIVATE LIMITED',
    'STC TRANSPORTS PRIVATE LIMITED',
    'Vayudoot holidays private limited',
    'Premium port lounge management company private limited',
    'Holiday mela travels private limited',
    'Universal journeys india private limited',
    'Naswiz holidays private limited',
    'Athena cars & tours private limited',
    'Innoventure holidays private limited',
    'Kings travelworld (india) private limited',
    'Sundersons logistics private limited',
    'Asiad holidays private limited',
    'STANDARD TRANSPORT PVT LTD.',
    'Adarsh rent-a-car private limited',
    'Mutual travels ( india) private limited',
    'H & t tours & travels private limited',
    'Tki tours (india) private limited',
    'RAINBOW TRADE FAIR TOURS PRIVATE LIMITED',
    'JENIKA GLOBAL TRADES PRIVATE LIMITED',
    'I-WAYS EXIM CONSULTING PRIVATE LIMITED',
    'Varun travels pvt ltd',
    'Suraj forwarders private limited',
    'Mak fumigants (india) private limited',
    'Kaia tourism private limited',
    'Lavi carz private limited',
    'Console shipping services india private limited',
    'IAL LOGISTICS INDIA PRIVATE LIMITED',
    'Sanghavi freight forwarders pvt ltd',
    'Thiru freight services private limited',
    'Degisa ocean air service private limited',
    'Khyber transport private limited',
    'Goodrich maritime private limited',
    'Total logistics (india) private limited',
    'Logistics services (india) private limited',
    'Fagioli india private limited',
    'Sharaf shipping agency (india) private limited',
    'Green dart logistics private limited',
    'Care clearing and forwarding private limited',
    'E travel online private limited',
    'Clair voyance speditors private limited',
    'Joshi transit solutions private limited',
    'Renaissance logi-spaces private limited',
    'Magus travel solutions private limited',
    'Associated cargo movers and packers private limited',
    'Ash logistics and traders private limited',
    'SKY ',
    'SEA CARGO PRIVATE LIMITED',
    'Jeevan shipping and logistics private limited',
    'Unique freight lines private limited',
    'SHAAN',
    'S KITCHEN PRIVATE LIMITED',
    'Mukunda foods private limited',
    'Saravana hospitality private limited',
    'Moonlink dealtrade private limited',
    'Jupiter solar power limited',
    'Gattani resorts private limited',
    'Girishkumar chhaganlal jewellers private limited',
    'Itspossible marketing limited',
    'APPARIO RETAIL PRIVATE LIMITED',
    'Beryl aqua private limited',
    'Max aerotron private limited',
    'Aralias duty free services private limited',
    'Baypark hotel & resorts private limited',
    'Brisk hotels private limited',
    'P.k.p. hotels private limited',
    'Gangaheritage resorts private limited',
    'Wheel india scm solutions private limited',
    'Bee cee logistic private limited',
    'Nkr logistics private limited',
    'Fairmount hotels private limited',
    'Saradhi lines pvt ltd',
    'Libra bus service pvt ltd',
    'Penosh travels and logistics private limited',
    'Irc logistics limited',
    'Champions club private limited',
    'Forvol international services limited',
    'S e h hotels and resorts private limited',
    'NORTHEAST TRAVELS & TRANSPORT LIMITED',
    'Aryaglobal private limited',
    'Freight bazaar india private limited',
    'Commander sanitaryware marketing private limited',
    'RASHLEELA ENTERPRISES PRIVATE LIMITED',
    'Thriveni earthmovers private limited',
    'Shri ram finance corporation private limited',
    'Asp transport private limited',
    'Tolani shipping company limited',
    'Ardee seaoil private limited',
    'Emem shipping agencies (india) private limited',
    'Gita energy generation private limited',
    'SAKTHI SHIPPING LOGISTICS PRIVATE LIMITED',
    'Krishnaraj shipping company limited',
    'Bulls eye logistics private limited',
    'METRO SEA & AIR CARGO PRIVATE LIMITED',
    'Airking charters private limited',
    'Unique logistics international (india) private limited',
    'Prp buildmart traders private limited',
    'Dbs logistics private limited',
    'Flyworld tours solutions private limited',
    'Ns tours & travels private limited',
    'Stic youth travels private limited',
    'Global traveltech private limited',
    'Reetu roadlines private limited',
    'Aashirvadh global logistics private limited',
    'Gateway freight system private limited',
    'Seabird marine services private limited',
    'Bmk hospitality services private limited',
    'Sreekrishna sheets and pipes private limited',
    'Kidology kids world private limited',
    'Abirami trading company private limited',
    'Urbanedge hotels and holdings private limited',
    'RATHNA RESORTS PRIVATE LIMITED',
    'Hotel k. p. park inn private limited',
    'World trade logistics private limited',
    'Pm cold storage private limited',
    'T t aviation handling services private limited',
    'Aa bee forex private limited.',
    'Hind air star private limited',
    'Arm tours pvt ltd',
    'Shalimar hotel private limited',
    'Honza rent a car private limited',
    'Ghai hotels and investments company private limited',
    'E-square leisure private limited',
    'Magadh foods private limited',
    'Dr. anbu paul hotels private limited',
    'Cuisineart food and beverage limited',
    'Morpheus hospitality private limited',
    'Goodwill transport private limited',
    'Noble logistics private limited',
    'A. s. l. travels private limited',
    'Leisureflies travels private limited',
    'Raj parivahan pvt ltd',
    'ACARE LOGISTICS SOLUTION PRIVATE LIMITED',
    'Real experience tours private limited',
    'Rajasthans invitation travels private limited',
    'Daksh tours private limited',
    'Southern trails (india) private limited',
    'New premier airlink private limited',
    'DRIVADO TRANSFERS PRIVATE LIMITED',
    'SEABIRD LOGISOLUTIONS LIMITED',
    'Teckwah logistics (india) private limited',
    'United technologies corporation india private limited',
    'Sampark india logistics private limited',
    'Bright shiptrans private limited',
    'Seabird distriparks (chennai) private limited',
    'Alluring india destination private limited',
    'NEST ',
    'Sarvo farm foods private limited',
    'S.l.n. coffee private limited',
    'Tatar foods pvt ltd',
    'Dhanvi foods private limited',
    'Eton clothing company private limited',
    'Naughty ninos private limited',
    'Mahavir corporation private limited',
    'Dwij yarns private limited',
    'Navnitlal and company (exports) pvt ltd',
    'Vitamins direct services private limited',
    'Kaizen infotech solutions private limited',
    'Murano veneers private limited',
    'Desai pharma distributors private limited',
    'Eastern agencies healthcare private limited',
    'Saisanket automation private limited',
    'Khadamat integrated solutions private limited',
    'Prince resources private limited',
    'Goalseek solutions private limited',
    'Techbean systems private limited',
    'Pkb india private limited',
    'Creative turnkey projects private limited',
    'PEOPLELINK UNIFIED COMMUNICATIONS PRIVATE LIMITED',
    'A.v.thomas exports limmitted.',
    'Fiveknot shipping agencies private limited',
    'Toppersedge.com india private limited',
    'Confluence educational services private limited',
    'Founding years learning solutions private limited',
    'Psrcube educational services private limited',
    'THINKCELL LEARNING SOLUTIONS PRIVATE LIMITED',
    'K2b learning private limited',
    'Brightstar learning india private limited',
    'Unsw global india private limited',
    'Knowledge enhance private limited',
    'Genie consultants private limited',
    'Flywings aviation training academy private limited',
    'HOMEVILLA YOGA PRIVATE LIMITED',
    'Vitalis healthcare private limited',
    'Bija health care private limited',
    'Skincurate research private limited',
    'Polytec packins india private limited',
    'Suburban diagnostics (india) private limited',
    'Renishaw metrology systems limited',
    'Diagnosearch life sciences private limited.',
    'Organisation of pharmaceutical producers of india',
    'T2 technology consulting private limited',
    'Pentagon events & activations private limited',
    'Garuda television private limited',
    'Citymax hospitality (india) private limited',
    'Lemon yellow sun films private limited',
    'Mercy corps india',
    'Vivaconnect private limited',
    'Unify search solutions private limited',
    'Dean sharpe design private limited',
    'Ghv hospitality (india) private limited',
    'DENEB AIR GASES PRIVATE LIMITED',
    'Sacom mediaworks private limited',
    'Cutawayy films private limited',
    'Entropy innovations private limited',
    'Urban management consulting private limited',
    'ULTRA RICH WEDDINGS LIMITED',
    'Fountainhead leisures private limited',
    'Smmart training & consultancy services private limited',
    'LCATTERTON MUMBAI ADVISORY SERVICES PRIVATE LIMITED',
    'Cae flight training (india) private limited',
    'PEDDER',
    'S BODY IMAGE PRIVATE LIMITED',
    'Pixeltek gaming solutions private limited',
    'Wealth doctor investment advisors private limited',
    'Extreme benefits private limited',
    'Endosys healthcare india private limited',
    'Darveshi engineering projects private limited',
    'Iddeo engineering private limited',
    'The key consumer diagnostics private limited',
    'Solutions consultancy services private limited',
    'Ion electricals private limited',
    'Sharekhan limited',
    'Lotus chocolate company ltd.',
    'Godfrey phillips india limited',
    'Supreme petrochem limited',
    'Amal limited',
    'Tirupati foam ltd',
    'Raj packaging industries limited',
    'Imp powers limited',
    'Kelvin fincap limited',
    'Asian hotels (west) limited',
    'THE INVESTMENT TRUST OF INDIA LIMITED',
    'B2b software technologies limited',
    'ZIFF DAVIS PERFORMANCE MARKETING PRIVATE LIMITED',
    'Daizy agrotech pvt ltd',
    'Bagmane pharmaceuticals private limited',
    'Lakshmi acqua culture pvt.ltd.',
    'Spring leaf retail private limited',
    'Bagmane constructions private limited',
    'BLACKGOLD AGRO PRODUCTS PRIVATELIMITED',
    'Fragrant kitchen private limited',
    'Jyoti international foods private limited',
    'Dicitex lifestyle private limited',
    'Valli jersy fabrics private limited',
    'Dr aykan textiles private limited',
    'Suvino exports private limited',
    'S MARKETING AND SERVICES PRIVATE LIMITED',
    'Delwis healthcare private limited',
    'Saam textiles private limited',
    'Ultimate furniture private limited',
    'Global (ind) hospitalilty services private limited',
    'Brigade hospitality services limited',
    'Kingston hospitality and developers private limited',
    'Whitesoul enterprises private limited',
    'Accord multispeciality clinics and medi-infra private limited',
    'Chartered hampi hotels private limited',
    'Arrow flight services private limited',
    'Able aviation (india) private limited',
    'Ailsinghani transport private limited',
    'TRICON GLOBAL SERVICES PRIVATE LIMITED',
    'Blg parekh logistics private limited',
    'Dhan logistics private limited',
    'Mitsui o s k lines (india) private limited',
    'Deugro projects (india) private limited',
    'Maestro logistics private limited',
    'Punjab terminals private limited',
    'Lavinstar logistics private limited',
    'Metalogix transport private limited',
    'Nordic logistics private limited',
    'AM GLOBALHUB PRIVATE LIMITED',
    'YATRA ONLINE LIMITED',
    'Scs logistics private limited',
    'Udl logistics private limited',
    'Mundra marine services private limited',
    'WMG WEALTH PRIVATE LIMITED',
    'ASAMI FARMER FINANCE PRIVATE LIMITED',
    'Artis financial expertise private limited',
    'Gujarat state financial services ltd',
    'Swojas leasing and finance pvt ltd',
    'Citicorp finance (india) limited',
    'Rohesh investments pvt ltd',
    'Ceebros investments private limited',
    'HEAVY METAL AND TUBES (INDIA) PRIVATE LIMITED',
    'BIS AGRO FARMS PRIVATE LIMITED',
    'Inventure insurance broking private limited',
    'Limitless insurance broking services private limited',
    'Sumangal shares & securities private limited',
    'Lightbox india advisors private limited',
    'Aquanomics systems limited',
    'Well-do holdings and exports private limited',
    'Kalinga advisory services private limited',
    'Quest portfolio services private limited',
    'SPL PALMS DEVELOPERS PRIVATE LIMITED',
    'Runwal developers private limited',
    'I-ven realty limited',
    'Sadguru builders private limited',
    'Jab estate private limited',
    'Shreekeerti properties private limited',
    'Bangalore regency developers private limited',
    'Kingston property services limited',
    'High pointe real estate private limited',
    'Dharti realty private limited',
    'Universal realtors private limited',
    'LYRA PROPERTIES PRIVATE LIMITED',
    'Brigade infrastructure and power private limited',
    'Shasta projects and estates private limited',
    'Panoramic beach properties private limited',
    'Brigade properties private limited',
    'Perspective realty private limited',
    'Newry properties private limited',
    'Newry property holdings private limited',
    'TENERITY INDIA PRIVATE LIMITED',
    'Pie software private limited',
    'Online print and pack private limited',
    'Lodestone software services private limited',
    'Autonomy software asia private limited',
    'RADISYS INDIA LIMITED',
    'Synergy images private limited',
    'SAMARTH LIFE SCIENCES PRIVATE LIMITED',
    'Supermix construction chemical (india) private limited',
    'EMNAR PHARMA PRIVATE LIMITED',
    'Sny autotech private limited',
    'Namco industries private limited',
    'Ess flexi tubes private limited',
    'Perma-pipe india private limited',
    'Bhalaria metal craft private limited',
    'Mahaa industries private limited',
    'Extinct fire engineers private limited',
    'Aastha tech products private limited',
    'SIEMENS ENERGY INDUSTRIAL TURBOMACHINERY INDIA PRIVATE LIMITED',
    'Levigo engineering india private limited',
    'Saurer textile solutions private limited',
    'Haulotte india private limited',
    'Tsugami precision engineering india private limited',
    'Gilbarco veeder root india private limited',
    'JSK MARKETING LIMITED',
    'Maxim india integrated circuit design private limited',
    'Shree samarth switchgear & transmission private limited',
    'GEBA CABLES AND WIRES INDIA PRIVATE LIMITED',
    'Sleek international private limited',
    'Maxim integrated products india sales private limited',
    'Cos phi power solutions private limited',
    'Nirvana lighting private limited',
    'Til investments pvt. ltd.',
    'India medtronic private limited',
    'Konica minolta healthcare india private limited',
    'Neo alliance healthcare technologies private limited',
    'Bavina cars (india) limited',
    'Hyundai wia india private limited',
    'Astramar shipping and trading services private limited',
    'Hari smriti properties private limited',
    'C mahendra international ltd',
    'MICROFIBER TELECOMMUNICATIONS PRIVATE LIMITED',
    'ABI-SHOWATECH (INDIA) PRIVATE LIMITED',
    'Ranco infraprojects private limited',
    'Blue energy private limited',
    'Stride energy resources private limited',
    'Yantra green power private limited',
    'Bpl power projects (ap) private limited',
    'Vivid power resources private limited',
    'Aries power systems (india) private limited',
    'Neepa real estates private limited',
    'Aruns housing remedies limited',
    'Art exim private limited',
    'Ambrosia properties private limited',
    'Alexandria properties private limited',
    'Babylon properties private limited',
    'Florentine properties private limited',
    'Imperial realty private limited',
    'Jodhpur entertainment world developers private limited',
    'Ventures real infra private limited',
    'Infra del projects private limited',
    'Pushpam project private limited',
    'NEO STRUCTO CONSTRUCTION PRIVATE LIMITED',
    'NEM (INDIA) DEVELOPMENT & CONSTRUCTION PRIVATE LIMITED',
    'Vamona developers private limited',
    'Rahejapolis developers private limited',
    'VYAPTI VANDEMATARAM (I) INFRABUILD PRIVATE LIMITED',
    'Chennai green woods private limited',
    'ENNARVEEKAY VENTURES PRIVATE LIMITED',
    'BLISS ADDRESS PRIVATE LIMITED',
    'Escube aircon private limited',
    'KEYME PROPERTIES PRIVATE LIMITED',
    'Grandeur infratech private limited',
    'RAHEJA PROPERTY DEVELOPERS PRIVATE LIMITED',
    'Raheja universal lifescapes private limited',
    'Shivramkrishna properties private limited',
    'Portofino properties private limited',
    'Raheja international corporate city private limited',
    'RAHEJA DISTRICT II PRIVATE LIMITED',
    'RAHEJA DISTRICT I PRIVATE LIMITED',
    'Diyug construction private limited',
    'Asvasidh novateur developers private limited',
    'Palladium constructions private limited',
    'Dreamscapes properties private limited',
    'ROPTOOLS MECHATRONICS PRIVATE LIMITED',
    'TALENTONLEASE PRIVATE LIMITED',
    'AERAMIC WELFARE FOUNDATION',
    'TRIDOMAINIC DESIGN AND MANUFACTURING SOLUTIONS PRIVATE LIMITED',
    'IOTSWARM PRIVATE LIMITED',
    'RAPHAEL SEQUEIRA FOUNDATION',
    'SHRI HARI FABRICATION PRIVATE LIMITED',
    'HASH INFLUENCER PRIVATE LIMITED',
    'LOUDER VENTURES PRIVATE LIMITED',
    'INSPIRERACE DIGITAL MEDIA PRIVATE LIMITED',
    'SNK INFRABUILDERS PRIVATE LIMITED',
    'ENKAANG ESSENTIALS TECHNOLOGIES PRIVATE LIMITED',
    'DEALSDON PRIVATE LIMITED',
    'CRAVE SPOT HOSPITALITY PRIVATE LIMITED',
    'AMIKEVA PRIVATE LIMITED',
    'WISEPL PRIVATE LIMITED',
    'J.ANUBHAV SARITA PRIVATE LIMITED',
    'NEXUS AUTOMATIONS PRIVATE LIMITED',
    'VTIMES PRIVATE LIMITED',
    'MAGTEQ BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ONELY TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'FINMET INDIA PRIVATE LIMITED',
    'ETHIC GREEN TECH PRIVATE LIMITED',
    '9PLATFORMS TECHNOLOGY PRIVATE LIMITED',
    'SUNSHINE SYNDICATE PRIVATE LIMITED',
    'AGROBUYS FARMER PRODUCER COMPANY LIMITED',
    'SHARDA WELFARE FOUNDATION',
    'SECURADO TECH PRIVATE LIMITED',
    'TECHNOFOODIES PRIVATE LIMITED',
    'AVIGNA VIJAYA PRIVATE LIMITED',
    'PROTECH E-WASTE PRIVATE LIMITED',
    'WORLD FUTURETECH ALLIANCE FOUNDATION',
    'ADANI GANGAVARAM PORT LIMITED',
    'FINETIC DIGITAL INTERACTIVE PRIVATE LIMITED',
    'TEAMSCART SOLUTIONS PRIVATE LIMITED',
    'ARRIVAL INDIA PRIVATE LIMITED',
    'SWAMI MEDISOLUTIONS PRIVATE LIMITED',
    'KOCHI WATER METRO LIMITED',
    'BASE PHARMACY (INDIA) PRIVATE LIMITED',
    'MULTIPE SERVICES PRIVATE LIMITED',
    'GOYAL DISTILLERY PRIVATE LIMITED',
    'SHEEVA CONNECTED INDIA PRIVATE LIMITED',
    'VIVNAR PRIVATE LIMITED',
    'GOVINDA TRANSPORT PRIVATE LIMITED',
    'UNIQUE STAR MARITIME PRIVATE LIMITED',
    'DIGIMAZE MARKETING PRIVATE LIMITED',
    'GRAD COMMERCE AI SERVICES PRIVATE LIMITED',
    'EUROINDUSTRIEL INTERNATIONAL PRIVATE LIMITED',
    'TRUE VECTOR BROKING PRIVATE LIMITED',
    'SOIE FASHION PRIVATE LIMITED',
    'MARSHALL LUBETECH PRIVATE LIMITED',
    'FOODTECHBIZ (OPC) PRIVATE LIMITED',
    'HIFARM TRADING (OPC) PRIVATE LIMITED',
    'INTEGRITYGEEKS TECH (OPC) PRIVATE LIMITED',
    'NAVNIRMAAN INDUSTRIES PRIVATE LIMITED',
    'SWIFTPACE SOLUTIONS PRIVATE LIMITED',
    'PONNAD FARMER PRODUCER COMPANY LIMITED',
    'ZEO FIN TECHNOLOGY PRIVATE LIMITED',
    'SUJATA SHIPPING & LOGISTICS PRIVATE LIMITED',
    'METZUYAN TECHNOLOGIES PRIVATE LIMITED',
    'MS IT PARK PRIVATE LIMITED',
    'ART SENSE INTERIORS PRIVATE LIMITED',
    'CROWIQ PRIVATE LIMITED',
    'VERVON TECHNOLOGIES PRIVATE LIMITED',
    'SCALE LUXURA INDIA PRIVATE LIMITED',
    'CRYPTIFIED SOLUTIONS (OPC) PRIVATE LIMITED',
    'GUDUVANCHERY MEDIC CENTRE PRIVATE LIMITED',
    'ALMACH LABS PRIVATE LIMITED',
    'INSIGHTLY ANALYTICS PRIVATE LIMITED',
    'PIERRE PETER FASHION PRIVATE LIMITED',
    'CHRONICLEHQ PRIVATE LIMITED',
    'TMS NATURAL EXTRACTS PRIVATE LIMITED',
    'RMX METALS PRIVATE LIMITED',
    'CITREA GROWTH PARTNERS PRIVATE LIMITED',
    'SIHOT INDIA PRIVATE LIMITED',
    'FINEXKART BUSINESS SOLUTIONS PRIVATE LIMITED',
    'DURGASTUTI GLOBAL SERVICES PRIVATE LIMITED',
    'EXPARAVENTURES INDIA PRIVATE LIMITED',
    'APRA INNOVATIVE PRIVATE LIMITED',
    'TEASEL REALTY PRIVATE LIMITED',
    'KERLTECH PRIVATE LIMITED',
    'SCLERALABS PRIVATE LIMITED',
    'SAYAN UTILITY & COMMON INFRASTRUCTURE PRIVATE LIMITED',
    'BIZNOW BUSINESS HUB PRIVATE LIMITED',
    'DIGITALNG PRIVATE LIMITED',
    'WER NETWORK CARE PRIVATE LIMITED',
    'PRATIMA NIRMAN PRIVATE LIMITED',
    'OCTAS INDIA PRIVATE LIMITED',
    'THINGMZING LABS PRIVATE LIMITED',
    'TAXL TECH PRIVATE LIMITED',
    'IMPAQT ROBOTICS PRIVATE LIMITED',
    'FIRSTNEST CONSTRUCTIONS PRIVATE LIMITED',
    'VENNER ENTERPRISES PRIVATE LIMITED',
    'FUNDLE TECH VENTURES PRIVATE LIMITED',
    'SHAIRITI NEW PRIVATE LIMITED',
    'KALICHEM PRIVATE LIMITED',
    'HAWKING DEFENCE SERVICES PRIVATE LIMITED',
    'VINAYAK COKEZONE PRIVATE LIMITED',
    'AREETE AI AND ROBOTICS (OPC) PRIVATE LIMITED',
    'EXPATRIA RELOCATION SERVICES PRIVATE LIMITED',
    'ORTEM PLAZZA PRIVATE LIMITED',
    'PARANJAY ESTATES PRIVATE LIMITED',
    'VTRANSFORM DIGITAL PRIVATE LIMITED',
    'HINDUSTAN BIOPOLYMERS PRIVATE LIMITED',
    'CHINCH INDIA PRIVATE LIMITED',
    'RUKMINI RAMKRISHNA INDUSTRIES PRIVATE LIMITED',
    'XQUANTUM (OPC) PRIVATE LIMITED',
    'NAIRIT HIGHRISE PRIVATE LIMITED',
    'JOBMINAR CONSULTANTS PRIVATE LIMITED',
    'MYCRUIT RESOURCES PRIVATE LIMITED',
    'LOGI-FY INFOTECH PRIVATE LIMITED',
    'A.T.K.S. ENTERPRISES PRIVATE LIMITED',
    'GLOBENEX STUDY ABROAD PRIVATE LIMITED',
    'PROF JIM (INDIA) PRIVATE LIMITED',
    'KAAPA WHITE PRIVATE LIMITED',
    'PODAR EDUSPACE TECH PRIVATE LIMITED',
    'CODEMASTR APPS PRIVATE LIMITED',
    'UAVGARAGE PRIVATE LIMITED',
    'EUROFINS BIOPHARMA PRODUCT TESTING INDIAPRIVATE LIMITED',
    'SUPERLIFE PRODUCTS PRIVATE LIMITED',
    'ACCURATE ENGITECH PRIVATE LIMITED',
    'CHAKRARATH VYAPAR PRIVATE LIMITED',
    'INCIPERE TECHNOLOGY PRIVATE LIMITED',
    'SOLUSS MEDITECH PRIVATE LIMITED',
    'AWISKAR TECHNOLOGY PRIVATE LIMITED',
    'SCHOLARSDIRECT EDUCATION CONSULTANCY PRIVATE LIMITED',
    'NANDSHRI DEVELOPERS PRIVATE LIMITED',
    'POOLR TECHNOLOGIES PRIVATE LIMITED',
    'NORCHEM INDIA PRIVATE LIMITED',
    'ELHAA TECHNOLOGIES PRIVATE LIMITED',
    'AMHAY SOLUTIONS (OPC) PRIVATE LIMITED',
    'VK INNOVATIONS PRIVATE LIMITED',
    'LGT WEALTH INDIA PRIVATE LIMITED',
    'ENGAZE DIGITAL MARKETING PRIVATE LIMITED',
    'WORDSWORTH TECHNOLOGIES PRIVATE LIMITED',
    'NEXTBLOCK TECHNOLOGIES PRIVATE LIMITED',
    'PRATOSH HOMES PRIVATE LIMITED',
    'WEEKEND LAUNCHPAD (OPC) PRIVATE LIMITED',
    'TROOPER IGA SOLUTIONS (OPC) PRIVATE LIMITED',
    'ZOTORK PRIVATE LIMITED',
    'KEVA VENTURES PRIVATE LIMITED',
    'TML FINTECH PRIVATE LIMITED',
    'ANONDITA HEALTHCARE AND RUBBER PRODUCTS INDIA PRIVATE LIMITED',
    'NORTH STAR ELECTRICALS PRIVATE LIMITED',
    'RELIANCE CARBON FIBRE CYLINDER LIMITED',
    'ROLLCE VENTURES PRIVATE LIMITED',
    'CORROTEK RUBBER PRODUCTS PRIVATE LIMITED',
    'PERMACULTURE WAYS REGENERATIVE SYSTEMS (OPC) PRIVATE LIMITED',
    'ACME GENERICS PRIVATE LIMITED',
    'PIXELPERINCHES TECHNOLOGIES PRIVATE LIMITED',
    'CELTSOFT (OPC) PRIVATE LIMITED',
    'VVS BAKERS PARADISE PRIVATE LIMITED',
    'SHAHBAZKERS DIAGNOSTIC CENTRE PRIVATE LIMITED',
    'THULAM FOODS PRIVATE LIMITED',
    'TIME4SERVERS TECHNOLOGIES PRIVATE LIMITED',
    'IVSERV TECHNOLOGIES PRIVATE LIMITED',
    'PENFORD INDUSTRIES PRIVATE LIMITED',
    'CHATIYA TECHNOLOGY PRIVATE LIMITED',
    'FPEL MEGA SOLAR PRIVATE LIMITED',
    'GOTI EXPORTS PRIVATE LIMITED',
    'AJITNATH ASSOCIATES PRIVATE LIMITED',
    'WAYSUP INDIA PRIVATE LIMITED',
    'THUNGA UDYOG PRIVATE LIMITED',
    'KAUSHAL RANJEET PRIVATE LIMITED',
    'ANILA RATTAN LEARNING PRIVATE LIMITED',
    'GROWMEORGANIC (OPC) PRIVATE LIMITED',
    'RAJATARANGINI INDIA (MEDIA) PRIVATE LIMITED',
    'NEONBYTE PRIVATE LIMITED',
    'REDBIRD INDUSTRIES PRIVATE LIMITED',
    'SETARA NETWORKS INDIA PRIVATE LIMITED',
    'GETMYEATS INDIA PRIVATE LIMITED',
    'OXALIS HEALTHCARE PRIVATE LIMITED',
    'JOBCENTO PRIVATE LIMITED',
    'MEVEERA (OPC) PRIVATE LIMITED',
    'WORKNOTION TECH PRIVATE LIMITED',
    'A&W ENGINEERING WORKS (INDIA) PRIVATE LIMITED',
    'RAINCODE LABS INDIA PRIVATE LIMITED',
    'SUNIL ENGINEERING SERVICES PRIVATE LIMITED',
    'PITCRAFT PRIVATE LIMITED',
    'MILKAR CHALO KISAN PRODUCER COMPANY LIMITED',
    'GAME INFINITY STUDIO PRIVATE LIMITED',
    'CUR8 VENTURES PRIVATE LIMITED',
    'GENISIS CREATIVE LEARNING PRIVATE LIMITED',
    'SWARPAN PROJECTS PRIVATE LIMITED',
    'P10S PRIVATE LIMITED',
    'INSOURCEDEV PRIVATE LIMITED',
    'EZEEGRO VENTURES PRIVATE LIMITED',
    'MAMTA ENTERPRISES (OPC) PRIVATE LIMITED',
    'SKYPARK MAINTENANCE ASSOCIATION',
    'DIGITAL LAND PRIVATE LIMITED',
    'IPEC TBI FOUNDATION',
    'VVCNET SERVICES PRIVATE LIMITED',
    'RE-COVER INDIA HEALTHCARE FOUNDATION',
    'VENGURLEKARS SHREESAI PROPERTIES PRIVATE LIMITED',
    'ROUNDGLASS IMPACT PRIVATE LIMITED',
    'BOT MERCANTILE PRIVATE LIMITED',
    'ADSNSTUFF PRIVATE LIMITED',
    'ADITI ESSENTIALS PRIVATE LIMITED',
    'NATURE TO SKIN CARE PRIVATE LIMITED',
    'SCHOLLS WELLNESS PRIVATE LIMITED',
    'METALLICZ EVENTS PRIVATE LIMITED',
    'TIL REALTY PRIVATE LIMITED',
    'BLUECRAFT AVIATION PRIVATE LIMITED',
    'ROUND THE COCKTAILS PRIVATE LIMITED',
    'AMEYA FOODS VENTURES PRIVATE LIMITED',
    'GPI ENGINEERING INDIA PRIVATE LIMITED',
    'PSCHOOL EDUTECH PRIVATE LIMITED',
    'CONNECT TO INDIA PRIVATE LIMITED',
    'FPEL POWER PRIVATE LIMITED',
    'COINFINITIVE CLOUD PRIVATE LIMITED',
    'SUBIKHSHAM WEALTH & HOLDINGS PRIVATE LIMITED',
    'ON PURPOSE CONSULTING PRIVATE LIMITED',
    'LONGBOW FOOD & BEVERAGES PRIVATE LIMITED',
    'SERVICE EASY TECHNOLOGY PRIVATE LIMITED',
    'SURYA SURGICAL INDUSTRIES INDIA PRIVATE LIMITED',
    'JOENJACK TOUCH PRIVATE LIMITED',
    'PANDHARKARS INFOTECH PRIVATE LIMITED',
    'HINDUSTAN DYNASTY PRIVATE LIMITED',
    'DIGINOTCH MEDIA PRIVATE LIMITED',
    'KRISH BAKERS & CONFECTIONERS PRIVATE LIMITED',
    'INT HOTELS PRIVATE LIMITED',
    'SALASAR AUTOHAUS INDIA PRIVATE LIMITED',
    'RAVI RAJ FOUNDATION',
    'SURREY IMMIGRATION CONSULTANCY SERVICES PRIVATE LIMITED',
    'INTERASLABS PRIVATE LIMITED',
    'BIOCLEANER INDIA PRIVATE LIMITED',
    'AVENIRTEK DIGITAL PRIVATE LIMITED',
    'R APPROACH MANAGEMENT CONSULTANTS INDIA PRIVATE LIMITED',
    'AM2PM QUALITY CARE (INDIA) PRIVATE LIMITED',
    'REV BOX TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INDOGOLECHA MARKETING (OPC) PRIVATE LIMITED',
    'DODO SKILLS INDIA PRIVATE LIMITED',
    'STREAM ENGINEERS INDIA PRIVATE LIMITED',
    'RELITICK INDUSTRIES PRIVATE LIMITED',
    'CONSTELLA INTELLIGENCE PRIVATE LIMITED',
    'RESIDENT BOOST TECHNOLOGIES PRIVATE LIMITED',
    'STARCLOUD SOLUTIONS PRIVATE LIMITED',
    'UNWIRED CONNECT PRIVATE LIMITED',
    'ASSURED DATA TECHNOLOGIES PRIVATE LIMITED',
    'WYDEN EDUCATION & TECHNOLOGY PRIVATE LIMITED',
    'ECOLIFE INDRAPRASTHA MOBILITY PRIVATE LIMITED',
    'MACAIN ENERGY SERVICES INDIA PRIVATE LIMITED',
    'DRAWLINES CONSULT PRIVATE LIMITED',
    'UNICUS TECHNOLOGIES PRIVATE LIMITED',
    'SOLARXL GAMMA ENERGY PRIVATE LIMITED',
    'CAELUM ARPIT BRAND TECHNOLOGIES PRIVATE LIMITED',
    'ZOIOS PRIVATE LIMITED',
    'RISING SUN ENERGY 2 PRIVATE LIMITED',
    'STUDIOAXIS CTAJ DESIGN INDIA PRIVATE LIMITED',
    'SAMBHAVNATH TRENDZ PRIVATE LIMITED',
    'ECONNECT PUJARI PRIVATE LIMITED',
    'HIGH HILLS HOSPITALITY PRIVATE LIMITED',
    'JBN WAREHOUSE PRIVATE LIMITED',
    'KIARO CLOTHING PRIVATE LIMITED',
    'AMERALD UNIVERSAL PRIVATE LIMITED',
    'GROWTHX EDUCATION LABS PRIVATE LIMITED',
    'VAUX SOURCE PRIVATE LIMITED',
    'KIESNA INDUSTRIES PRIVATE LIMITED',
    'BIZINSO PRIVATE LIMITED',
    'APPSYNTHESYS PRIVATE LIMITED',
    'SAHYOG INFRAHEIGHTS PRIVATE LIMITED',
    'TRANS MASTER PRIVATE LIMITED',
    'MILLION REJOICE NEW CREST NIDHI LIMITED',
    'RODEKA SPIRITS PRIVATE LIMITED',
    'DHAAKSH ORIGIN PRIVATE LIMITED',
    'PYXIS BRAND TECHNOLOGIES PRIVATE LIMITED',
    'BLUEDICE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ANSAR CASA DECOR (OPC) PRIVATE LIMITED',
    'LIGHTUP MARKETING PRIVATE LIMITED',
    'SOLARXL ALPHA ENERGY PRIVATE LIMITED',
    'INDEL TRUSTEESHIP PRIVATE LIMITED',
    'KOIND LOGISTICS PRIVATE LIMITED',
    'ELEVATE HOMES PRIVATE LIMITED',
    'I. DUDHWALA REALTY & INFRA PRIVATE LIMITED',
    'DR. RAMALINGA REDDY MAXIVISION EYE HOSPITALS PRIVATE LIMITED',
    'AAMDHANE PRIVATE LIMITED',
    'WADI AL KHAIR FOOD PRIVATE LIMITED',
    'KAMEX IT SOLUTIONS (OPC) PRIVATE LIMITED',
    'SUMERU HUMAN ASSET MANAGEMENT SERVICES PRIVATE LIMITED',
    'RISEANDGROWS CONSTRUCTIONS PRIVATE LIMITED',
    'CHARGEMATE PRIVATE LIMITED',
    'PRATHMIK SAHAAYATHA FOUNDATION',
    'PODDAR WELFARE FOUNDATION',
    'KLOUD KOMPUTING SOFTWARE SYSTEMS PRIVATELIMITED',
    'RUBYX PROJECTS PRIVATE LIMITED',
    'RIGHT OF CENTRE PRIVATE LIMITED',
    'CX100 SOLUTIONS PRIVATE LIMITED',
    'SYNERGIZE OFFSHORE AND MARINE CONSTRUCTION LIMITED',
    'NICO FLEX PRIVATE LIMITED',
    'RMG FINTECH PRIVATE LIMITED',
    'SNARF FOOD TECH PRIVATE LIMITED',
    'GIFTEN SOLUTIONS PRIVATE LIMITED',
    'ADVANCE AGILITY PRIVATE LIMITED',
    'AUTOSCALER SOFTWARE INDIA PRIVATE LIMITED',
    'FIRSTCODE REALITY PRIVATE LIMITED',
    'LABOR SOLUTIONS GLOBAL INDIA PRIVATE LIMITED',
    'EAGLE HAWK LOGISTICS PRIVATE LIMITED',
    'SRI THATWA PRIVATE LIMITED',
    'AEC BIM SOLUTIONS PRIVATE LIMITED',
    'RUBE INFO PARKS PRIVATE LIMITED',
    'DI FINSERVE PRIVATE LIMITED',
    'CAPRISKA KNITWEAR PRIVATE LIMITED',
    'DENIVA FASHION PRIVATE LIMITED',
    'TOP ROCK INTERIORS PRIVATE LIMITED',
    'RAJARSHI CREATIONS (OPC) PRIVATE LIMITED',
    'FNO TECH PRIVATE LIMITED',
    'AUMNIC SEMICONDUCTOR PRIVATE LIMITED',
    'WHMCS SMARTERS PRIVATE LIMITED',
    'OCEANSTORM VFX INDIA PRIVATE LIMITED',
    'AIITECH IT EDUCATION PRIVATE LIMITED',
    'CALIPERS CONSULTING PRIVATE LIMITED',
    'SUNSERG TECHNOLOGIES PRIVATE LIMITED',
    'OPTIMIN SYSTEMS PRIVATE LIMITED',
    'UNIENFIN FINANCIAL SERVICES PRIVATE LIMITED',
    'CEF JAMMU BIO FUEL PRIVATE LIMITED',
    'BS FINTECH PRIVATE LIMITED',
    'IRI TECHNOLOGIES PRIVATE LIMITED',
    'NEO INVESTMENT VALUE ADVISORS PRIVATE LIMITED',
    'RUDRA INFRACON PRIVATE LIMITED',
    'AXOM FILMCITY PRIVATE LIMITED',
    'ACIANA HEALTH TECHNOLOGIES INDIA PRIVATELIMITED',
    'DREAMLAND PUBLICATIONS PRIVATE LIMITED',
    'ELECTRICBUYMEP PRIVATE LIMITED',
    'PROJECTION SYSTEMS PRIVATE LIMITED',
    'SCION PARTNERS PRIVATE LIMITED',
    'YOURGROWTH WEALTH PRIVATE LIMITED',
    'SHIVI CHEMICAL TECHNOLOGIES PRIVATE LIMITED',
    'DIGITRIX EDUTECH PRIVATE LIMITED',
    'K G SETH SALVAGE PRIVATE LIMITED',
    'SOLIS PHARMACEUTICAL INDUSTRIES PRIVATE LIMITED',
    'SOUPHERB NUTRITION PRIVATE LIMITED',
    'DECISION CONSULTANT SOLUTIONS PRIVATE LIMITED',
    'ONE HRMUSTER PRIVATE LIMITED',
    'INDOPORT LOGISTICS PRIVATE LIMITED',
    'PLAYWISE ESPORTS PRIVATE LIMITED',
    'MINTINGM TECHNOLOGIES PRIVATE LIMITED',
    'TALENTFLEET SOLUTIONS PRIVATE LIMITED',
    'RING THE BELL TECHNOLOGIES PRIVATE LIMITED',
    'S LINK TRAVEL SOLUTION PRIVATE LIMITED',
    'HELVETICA BRANDS PRIVATE LIMITED',
    'SURYAURJA TWO PRIVATE LIMITED',
    'CDI SOLUTIONS IT PRIVATE LIMITED',
    'PG EQUIPMENTS INDIA PRIVATE LIMITED',
    'SURYAUDAY INSURANCE BROKERS PRIVATE LIMITED',
    'MY WATCH MERCHANT PRIVATE LIMITED',
    'PLANT A FKN TREE FOUNDATION',
    'ELECTROBOTIC MANUFACTURING PRIVATE LIMITED',
    'FUTURE LOG TECHNOLOGY PRIVATE LIMITED',
    'LET TO LIVING PRIVATE LIMITED',
    'HUMAN CAREERS TRAINING SERVICES AND PLACEMENT PRIVATE LIMITED',
    'VFLOWTECH INDIA PRIVATE LIMITED',
    'AGASTHYA FARMER PRODUCER COMPANY LIMITED',
    'SUPREME LOGISTICS PARK PRIVATE LIMITED',
    'UNIFY DOTS PRIVATE LIMITED',
    'AVINASH COFLEET PRIVATE LIMITED',
    'LOCATION BNK (INDIA) PRIVATE LIMITED',
    'MENTOR FOUNDATION',
    'QUALITYPICK RETAIL (OPC) PRIVATE LIMITED',
    'FPEL SURYA PRIVATE LIMITED',
    'RADHEGOVIND MANAGEMENT PRIVATE LIMITED',
    'Q-LAB INTERNATIONAL PRIVATE LIMITED',
    'ASKJUNO PRIVATE LIMITED',
    'NEELKUND INDUSTRIES PRIVATE LIMITED',
    'DRYCHEM KHOPOLI PRIVATE LIMITED',
    'ARTEON FASHION PRIVATE LIMITED',
    'RBP TRADING PRIVATE LIMITED',
    'FUTURE OFFICERS ACADEMY PRIVATE LIMITED',
    'VBB BROADCASTING PRIVATE LIMITED',
    'SECAID CONSULTANCY PRIVATE LIMITED',
    'USR PUBLISHING HOME PRIVATE LIMITED',
    'INNVENDT INSIGHTS PRIVATE LIMITED',
    'LEARNING COTTAGE PRIVATE LIMITED',
    'INSCITE FINTECH SOLUTIONS PRIVATE LIMITED',
    'ASCRIBER TECHNOLOGIES PRIVATE LIMITED',
    'KAANSH ENTERPRISES (OPC) PRIVATE LIMITED',
    'SURYAURJA FOUR PRIVATE LIMITED',
    'MARUDHAM VIVASAYA PANNAI PRIVATE LIMITED',
    'JAVELIN GLOBAL COMMODITIES TRADING INDIAPRIVATE LIMITED',
    'VERSATALIA LABS PRIVATE LIMITED',
    'XTREME MARKETER PRIVATE LIMITED',
    'LISTED DOTFANS PRIVATE LIMITED',
    'GURUKRIPA MICRO SERVICES FOUNDATION',
    'JODHPUR WASTE WATER RECYCLING PRIVATE LIMITED',
    'STEAM-A PRIVATE LIMITED',
    'ECC TECHNOLOGIES PRIVATE LIMITED',
    'AVIGHNA DIGINVEST PRIVATE LIMITED',
    'GHAR ANGAN INTERIORS CONTRACTOR PRIVATE LIMITED',
    'SUCCESS BOOSTER PRIVATE LIMITED',
    'TEAM INTEX PRIVATE LIMITED',
    'SOFTSHORE VISION PRIVATE LIMITED',
    'BIRAAT FOOD PRODUCT PRIVATE LIMITED',
    'SWADESHI APPS PRIVATE LIMITED',
    'BEHIND EARTH PRIVATE LIMITED',
    'BHADIYA NAMKEEN PRIVATE LIMITED',
    'AKG HI-TECH PRIVATE LIMITED',
    'RESPONSIBLE INFLUENCE PRIVATE LIMITED',
    'CURELINK PRIVATE LIMITED',
    'ARTISAN BAZAAR FOUNDATION',
    'ONE TECH CADRE PRIVATE LIMITED',
    'FP SONNEN PRIVATE LIMITED',
    'SATYAVARTA CONSULTANTS PRIVATE LIMITED',
    'OPEN4CARE LABORATORIES PRIVATE LIMITED',
    'ELP SOLAR TWO PRIVATE LIMITED',
    'ECOMEN ENVIRONMENTAL RESEARCH PRIVATE LIMITED',
    'MINETECK TECHNICAL SERVICES PRIVATE LIMITED',
    'VIGOCARE PRIVATE LIMITED',
    'UNILINK MARKETING PRIVATE LIMITED',
    'AIKHYA INFRA DEVELOPERS PRIVATE LIMITED',
    'PENTAGON SECURE SOLUTIONS PRIVATE LIMITED',
    'ARIES REFINERY PRIVATE LIMITED',
    'MARK FINZZER PRIVATE LIMITED',
    'REASON ANALYTICS SOFTECH PRIVATE LIMITED',
    'ENERGIX TECH SOLUTIONS PRIVATE LIMITED',
    'SWARN RUBBER MANUFACTURING INDIA PRIVATELIMITED',
    'VIZOROZ TECHNOLOGIES PRIVATE LIMITED',
    'KEEN ABOUT FUTURE FOUNDATION',
    'GIZABO SOLUTIONS PRIVATE LIMITED',
    'IINAS DESIGN PRIVATE LIMITED',
    'SK BLR KNITS & APPAREL PRIVATE LIMITED',
    'GRABEXPERIENCE PRIVATE LIMITED',
    'WELL-DEMAND MARKETING PRIVATE LIMITED',
    'ORIGON ASSOCIATES PRIVATE LIMITED',
    'SUPERCLUSTER PI PRIVATE LIMITED',
    'CAPHELP PARTNERS PRIVATE LIMITED',
    'SURGE LION MEDIA PRIVATE LIMITED',
    'CORPORATE MATH BUSINESS SERVICES PRIVATELIMITED',
    'WAPPOTIX PRIVATE LIMITED',
    'NEAR INTELLIGENCE PRIVATE LIMITED',
    'PEAK BCS VENTURES INDIA PRIVATE LIMITED',
    'DIGIIND HEALTHCARE PRIVATE LIMITED',
    'GARUDA HR & RECRUITMENT SERVICES (OPC) PRIVATE LIMITED',
    'EARTHHEAL INFRA PROJECTS PRIVATE LIMITED',
    'SHRI HARI 9 UNIVERSAL SOLUTIONS PRIVATE LIMITED',
    'KRISHGEN LABS PRIVATE LIMITED',
    'SOLUTION FOR SURE PRIVATE LIMITED',
    'DREAM REFLECTION MEDIA PRIVATE LIMITED',
    'PELORUS FORENSIC SERVICES PRIVATE LIMITED',
    'DIGIMALL4U RETAIL PRIVATE LIMITED',
    'PALANSOFT PRIVATE LIMITED',
    'FAIRMART (INDIA) PRIVATE LIMITED',
    'KRYOSS SOFTECH PRIVATE LIMITED',
    'LAWAY AUTOMOTIVES PRIVATE LIMITED',
    'APHRODITE CONSUMER INDIA PRIVATE LIMITED',
    'WOOSHELF PRIVATE LIMITED',
    'SITEPAY TECHNOLOGIES PRIVATE LIMITED',
    'FIDELITY EXPRESS INDIA PRIVATE LIMITED',
    'MICECAFE MERCHANDISE PRIVATE LIMITED',
    'GEO-TECHNICAL ENTERPRISES PRIVATE LIMITED',
    'FINSU ADVISORS PRIVATE LIMITED',
    'ONEDPO PRIVATE LIMITED',
    'SAITECK ERP SOLUTIONS PRIVATE LIMITED',
    'GLOBIZ VENTURES PRIVATE LIMITED',
    'ASGS LOGISTICS PRIVATE LIMITED',
    'FOUNDATION FOR INCLUSIVE TECHNOLOGIES',
    'RAINFOREST ALLIANCE INDIA FOUNDATION',
    'GOLDE PUNE AUTOMOTIVE INDIA PRIVATE LIMITED',
    'K S K BIO ENERGY PRIVATE LIMITED',
    'HACKERHIVE TECHNOLOGIES PRIVATE LIMITED',
    'SPACELEASE PRIVATE LIMITED',
    'RELIANCE HYDROGEN FUEL CELL LIMITED',
    'REALTIMEUPDATES PRIVATE LIMITED',
    'KISHEN SREEHARI (OPC) PRIVATE LIMITED',
    'MEHAR AUTO TECH PRIVATE LIMITED',
    'MIRANDOLA DESIGNS INDIA PRIVATE LIMITED',
    'KNN888 AUTOMOTIVE PRIVATE LIMITED',
    'KAY BEE LIFE SCIENCES PRIVATE LIMITED',
    'RITZY CIRCLE PRIVATE LIMITED',
    'FUTURE EV PRIVATE LIMITED',
    'PRIMA INTEGRATED INFRACORP PRIVATE LIMITED',
    'SUGARVISION TECHNOLOGY PRIVATE LIMITED',
    'Y FIBRE PRIVATE LIMITED',
    'TIRUPATI TIMBER INDUSTRIES PRIVATE LIMITED',
    'VEERABHA ESTATES & HOLDINGS PRIVATE LIMITED',
    'SOORYA APEX HEALTH CARE PRIVATE LIMITED',
    'SKABIZ MARKETING SERVICES & SOLUTIONS PRIVATE LIMITED',
    'RENEW GREEN (TNJ TWO) PRIVATE LIMITED',
    'SERVFIRST INFOTECH PRIVATE LIMITED',
    'HAZEL GREEN PRIVATE LIMITED',
    'WHALE POD TECHNOLOGIES PRIVATE LIMITED',
    'CARNEXT AUTO PRIVATE LIMITED',
    'TIN TAN PRODUCTIONS PRIVATE LIMITED',
    'GYANPRAKASH FOUNDATION',
    'SPARKMAGIC TECHNOLOGIES PRIVATE LIMITED',
    'CREATOMY BUILD PRIVATE LIMITED',
    'IIHMR FOUNDATION',
    'KALPACONS SERVICES PRIVATE LIMITED',
    'TUNIWASH INDIA PRIVATE LIMITED',
    'SHUBHUJA COMMERCIAL PRIVATE LIMITED',
    'UMAZEO SOLUTIONS & SERVICES (OPC) PRIVATE LIMITED',
    'KALGROUP PRIVATE LIMITED',
    'TRUYOGA WELLNESS PRIVATE LIMITED',
    'CLOUDNINE CONSULTING (OPC) PRIVATE LIMITED',
    'CHOIRA MUSICTECH PRIVATE LIMITED',
    'LADDO GOPAL JI REALESTATE DEVELOPERS (OPC) PRIVATE LIMITED',
    'INFINITYTANK PRIVATE LIMITED',
    'DEEPEX MANAGEMENT SERVICES PRIVATE LIMITED',
    'AARON FINANCIAL ADVISORY INDIA PRIVATE LIMITED',
    'NUTRATION MARCON PRIVATE LIMITED',
    'KMZ SERVICES PRIVATE LIMITED',
    'TECH JAPAN LAB PRIVATE LIMITED',
    'BUSINESSAWARE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'DIGITALXP PRIVATE LIMITED',
    'DEEPLITE FOODS INDIA PRIVATE LIMITED',
    '2 AND HALF FACTORIAL PRIVATE LIMITED',
    'AMRUTLAL & SONS PRIVATE LIMITED',
    'AGRIM HOUSING FINANCE PRIVATE LIMITED',
    'AITEK PVK IT SERVICES PRIVATE LIMITED',
    'BHAJWAL FED VEGETABLE PRODUCER COMPANY LIMITED',
    'KSOUND GLOBAL (OPC) PRIVATE LIMITED',
    'SOFTDECK TECHNOLOGIES PRIVATE LIMITED',
    'JUST BLACK F AND B PRIVATE LIMITED',
    'CHEMBRICH TECHNOLOGY PRIVATE LIMITED',
    'EDENZA CLUB AND RESORTS PRIVATE LIMITED',
    'EVA ART STUDIO PRIVATE LIMITED',
    'PEOPLETREE EDUTECH PRIVATE LIMITED',
    'CHATTYBAO TECHNOLOGIES PRIVATE LIMITED',
    'MAPAEX REALITY PRIVATE LIMITED',
    'ENTERPRISE OIL & GAS INDIA PRIVATE LIMITED',
    'ARISE INTEGRATED PLATFORMS INDIA PRIVATELIMITED',
    'NEWTRACE PRIVATE LIMITED',
    'SUV AKHAND JYOTI FOUNDATION',
    'SHANMUKH BUSINESS VENTURES PRIVATE LIMITED',
    'DEVATRI WELLNESS PRIVATE LIMITED',
    'NATURENLY SOLUTIONS PRIVATE LIMITED',
    'INDICBAZAAR PRIVATE LIMITED',
    'KARNAL CREAMARY PRIVATE LIMITED',
    'SEVAU VENTURES PRIVATE LIMITED',
    'HAMSA BIOPHARMA INDIA PRIVATE LIMITED',
    'INVESTOSPEED PRIVATE LIMITED',
    'GULLAK TECHNOLOGIES PRIVATE LIMITED',
    'HINDON ACCOUNT AGGREGATION SERVICES PRIVATE LIMITED',
    'TANTRANZM TECHNOLOGIES PRIVATE LIMITED',
    'PRANAV MINERALS AND CHEMICALS PRIVATE LIMITED',
    'EVERYDAYSURE INDIA PRIVATE LIMITED',
    'SRCS AND SONS PRIVATE LIMITED',
    'PLM ECOSYSTEMS (OPC) PRIVATE LIMITED',
    'PSTS INFO COM PRIVATE LIMITED',
    'MYMOBILE CLUB PRIVATE LIMITED',
    'FLATOES PRIVATE LIMITED',
    'ASTRANTIA REAL ESTATE PRIVATE LIMITED',
    'JUBATU TECHNOLOGIES PRIVATE LIMITED',
    'ERANKI LABS PRIVATE LIMITED',
    'UNIBCOMP NETWORKS PRIVATE LIMITED',
    'GAYO FITNESS ACADEMY AND RESEARCH CENTERPRIVATE LIMITED',
    'LEMOIZY TRADING PRIVATE LIMITED',
    'SILVERIO DEVELOPERS PRIVATE LIMITED',
    'QUARKS INFRA PROMOTERS & CONTRACTORS PRIVATE LIMITED',
    'ENBRAUN TECHNOLOGIES PRIVATE LIMITED',
    'V&W BIOTECH PRIVATE LIMITED',
    'APPZOTECH ENTERPRISES PRIVATE LIMITED',
    'AMAZIN FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'TECH-UNITY PACKAGING SOLUTIONS PRIVATE LIMITED',
    'ITP ENERGY SYSTEMS PRIVATE LIMITED',
    'SKP CLEANTECH PRIVATE LIMITED',
    'SAELOO CONSULTING PRIVATE LIMITED',
    'ANANTA SHAKTI ECO SOLUTIONS PRIVATE LIMITED',
    'NESHO FOUNDATION',
    'SRMPR HOSPITALITY PRIVATE LIMITED',
    'ARAPL RAAS PRIVATE LIMITED',
    'EVERBLOOM RETAIL PRIVATE LIMITED',
    'OPTIMUM ASSAY AND HALLMARKING PRIVATE LIMITED',
    'MWORLDWIDE LOGISTICS PRIVATE LIMITED',
    '2 DOTT LIFECARE PRIVATE LIMITED',
    'SATGURU IMF PRIVATE LIMITED',
    'FACCTUM IT SOLUTIONS INDIA PRIVATE LIMITED',
    'TDFS3 DIGITALFIFTH PRIVATE LIMITED',
    'DHANRASHI FINTECH PRIVATE LIMITED',
    'MASTRO STEELS PRIVATE LIMITED',
    'SRMPR GLOBAL RAISINGS AND HOLDINGS PRIVATE LIMITED',
    'CARLELO PRIVATE LIMITED',
    'MAVI AUTOMOTIVE INDIA PRIVATE LIMITED',
    'OHM DOVETAIL GLOBAL SERVICES (IFSC) PRIVATE LIMITED',
    'BSTL OFFSHORE CONSULTANTS PRIVATE LIMITED',
    'EXCELYA INDIA PRIVATE LIMITED',
    'URBANRISE CLASSIC HOMES PRIVATE LIMITED',
    'BUILD BOOSTER INDIA PRIVATE LIMITED',
    'INNOVATIVE CHEMEX PRIVATE LIMITED',
    'NPK BIONTOLOGY PRIVATE LIMITED',
    'MITSU FOUNDATION',
    'APRO ONLINE SOLUTIONS PRIVATE LIMITED',
    'BRANDINGTOWN PRIVATE LIMITED',
    'BUMIPUTRA RESORTS PRIVATE LIMITED',
    'MENTORS FOR KIDS FOUNDATION',
    'ESPEN CLEAN ENERGY PRIVATE LIMITED',
    'HITI FOUNDATION',
    'KRYSTAL CORNER PRIVATE LIMITED',
    'INTERNATIONAL TRADE ADVISORY SERVICES PRIVATE LIMITED',
    'FICTIV TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'WHIZZMARK BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HARIVARSHINI REAL ESTATES PRIVATE LIMITED',
    'INTHA TRADING PRIVATE LIMITED',
    'RAJAMAHENDRAVARAM GREENFIELD HIGHWAY PRIVATE LIMITED',
    'TSI COLLECTIVE FOUNDATION',
    'QUANTUM AEGIS PRIVATE LIMITED',
    'INTRAHOP SYSTECH PRIVATE LIMITED',
    'MOONAIR HOME APPLIANCES PRIVATE LIMITED',
    'APEX CREATIVE FACADE PRIVATE LIMITED',
    'AIMLEAP PRIVATE LIMITED',
    'SMART LIVING AND SPACE PRIVATE LIMITED',
    'SIGIL AND RITUAL (OPC) PRIVATE LIMITED',
    'PLAN B ADVERTISING PRIVATE LIMITED',
    'DIVYA DENTAL TRADE PRIVATE LIMITED',
    '21 BY 90 TECHNOLOGIES PRIVATE LIMITED',
    'ADI VEDA REGIMEN PRIVATE LIMITED',
    'INTERVEIN RESEARCH LABS PRIVATE LIMITED',
    'VENUS STAR CLOTHING PRIVATE LIMITED',
    'VICKY PROPERTY PROCUREMENT SERVICES PRIVATE LIMITED',
    'RAMANENI SWAGRUHA PRIVATE LIMITED',
    'MENDING MASTERS SERVICES PRIVATE LIMITED',
    'AARREE REALTORS PRIVATE LIMITED',
    'MVR HEALTH CARE FOUNDATION',
    'ELECTROV8 PRIVATE LIMITED',
    'TPS TECHNOLOGIES LIMITED',
    'ERGO HOLIDAYS PRIVATE LIMITED',
    'SHREE ENGINEERS AND CONSTRUCTIONS PRIVATE LIMITED',
    'NUVAME PRIVATE LIMITED',
    'TECQNIO GLOBAL SYSTEMS PRIVATE LIMITED',
    'SILVERCHROME INDUSTRIES PRIVATE LIMITED',
    'BRAHMAGNI (OPC) PRIVATE LIMITED',
    'ARCAB INDIA PRIVATE LIMITED',
    'MYFIRSTCHOICE TRADERS AND SHOPPERS PRIVATE LIMITED',
    'NARKE GREEN FOUNDATION',
    'UDVAIT PRIVATE LIMITED',
    'CUDDLES FOR CUBS PRIVATE LIMITED',
    'IPASS SOLUTIONS PRIVATE LIMITED',
    'GLOBETECH INFOSYSTEMS PRIVATE LIMITED',
    'VICKY EDUCATIONAL SERVICES PRIVATE LIMITED',
    'ROSENBERGER INTERCONNECT INDIA PRIVATE LIMITED',
    'CASAGRAND VIVACITY PRIVATE LIMITED',
    'BONATRA HEALTHCARE PRIVATE LIMITED',
    'ARKIMY TECHNOLOGIES PRIVATE LIMITED',
    'PRINSEPS RESEARCH PRIVATE LIMITED',
    'SEIS MENTES GAMERS PRIVATE LIMITED',
    'GCF FOODS PRIVATE LIMITED',
    'BIOBAZAAR HEALTHTECH PRIVATE LIMITED',
    'BLISSFUL YOU ORGANICA PRIVATE LIMITED',
    'TRICHY THURAIYUR BRICK PRIVATE LIMITED',
    'KALYANI ISPAT LIMITED',
    'BLACKROCK WASTE PROCESSING PRIVATE LIMITED',
    'COMMTECH CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'SISAMC SPV1PRIVATE LIMITED',
    'HITECH STEEL INDIA PRIVATE LIMITED',
    'ACIRA STUDIOS PRIVATE LIMITED',
    'SWAT SHADOW INVESTMENTS PRIVATE LIMITED',
    'LIFECREATORS DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'MEDSEED CHEMIST PRIVATE LIMITED',
    'ALTIS AGRO PRODUCTS PRIVATE LIMITED',
    'UI CONSULTANCY PRIVATE LIMITED',
    'WIZZY SOFTECH PRIVATE LIMITED',
    'MAVIM INDIA PRIVATE LIMITED',
    'NOUFAL CAPITAL ADVISORS (OPC) PRIVATE LIMITED',
    'KASLIWAL CAPITAL MANAGEMENT PRIVATE LIMITED',
    'JM COLLECTION PRIVATE LIMITED',
    'MAJESTYNODES (OPC) PRIVATE LIMITED',
    'EMBECTA INDIA PRIVATE LIMITED',
    'ROSTRUM REALTY PRIVATE LIMITED',
    'AVANT INFRA OSHIWARA PRIVATE LIMITED',
    'NORTH POLE EDUTECH PRIVATE LIMITED',
    'APPLIED BIOPLASTICS INDIA PRIVATE LIMITED',
    'SDS EXPRESS INDIA PRIVATE LIMITED',
    'CONEXXIA IT SERVICES INDIA PRIVATE LIMITED',
    'JAYADI CONSULT PRIVATE LIMITED',
    'ANGAD GLOBAL INTELLECTUAL PROPERTY RIGHT(OPC) PRIVATE LIMITED',
    'DUMPA CONSULTING PRIVATE LIMITED',
    'RUKON RAIL SOLUTIONS PRIVATE LIMITED',
    'ABHAY BOILERS & PROJECTS PRIVATE LIMITED',
    'HUOBAN ENERGY 2 PRIVATE LIMITED',
    'TECHXODUS TRADING PRIVATE LIMITED',
    'CREST INSURANCE BROKERS PRIVATE LIMITED',
    'ALL INDIA COUNCIL FOR PROFESSIONAL EXCELLENCE',
    'JEEVANADHATA FARMERS PRODUCER COMPANY LIMITED',
    'M G AGRO PROCESSING PRIVATE LIMITED',
    'SUPRADEEP HOMES PRIVATE LIMITED',
    'DBS LIFESTYLE INDIA PRIVATE LIMITED',
    'TRIDENT DECOR LIMITED',
    'MAKINGLIFE UDYOG PRIVATE LIMITED',
    'GLUMES IT SOLUTIONS PRIVATE LIMITED',
    'DAIRYORGANIK MISSION PRIVATE LIMITED',
    'UTILIZECORE INDIA PRIVATE LIMITED',
    'NAVYAANSH PARIVARTAN FOUNDATION',
    'DOORSTEP24 DIRECTORY (OPC) PRIVATE LIMITED',
    'MAA JHADESWARI FARMERS PRODUCER COMPANY LIMITED',
    'VISION LANGUAGE EXPERTS PRIVATE LIMITED',
    'CONGRUENCE HOLDINGS PRIVATE LIMITED',
    'NELLY SOFTWARE SERVICES PRIVATE LIMITED',
    'SVAPRAKRITI PRIVATE LIMITED',
    'IPROFIT PRIVATE LIMITED',
    'ARTEX LOGISTICS PRIVATE LIMITED',
    'HEALTH PRECISION PRIVATE LIMITED',
    'MAHARANI GOLD PARK PRIVATE LIMITED',
    'RASAL EXPORTS PRIVATE LIMITED',
    'NATIVE WOMEN FOOD PRODUCTS FOUNDATION',
    'ABSOLUTE NATURAL PRODUCTS PRIVATE LIMITED',
    'CLARIFIER FOOD & BEVERAGES PRIVATE LIMITED',
    'AMP ENERGY C&I ONE PRIVATE LIMITED',
    'IG FRESH PRODUCE PRIVATE LIMITED',
    'UPAJFARM TECHNOLOGY SERVICES PRIVATE LIMITED',
    'HUOBAN ENERGY 6 PRIVATE LIMITED',
    'C R INDUSTRIES PRIVATE LIMITED',
    'HI A MMT PRIVATE LIMITED',
    'KETHANA LIFESTYLE PRIVATE LIMITED',
    'NIRVAAH FOUNDATION',
    'CUSTODIANSHIP ADVISORY SERVICES PRIVATE LIMITED',
    'ALIARO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'FINTELICA PRIVATE LIMITED',
    'KVAV MICRO SERVICES ASSOCIATION',
    'SRI AAKASH EXPORT AND IMPORT PRIVATE LIMITED',
    'HELISAV (INDIA) PRIVATE LIMITED',
    'HANKOOK SERVICE CENTER PRIVATE LIMITED',
    'FOCUS WASTE MANAGEMENT PRIVATE LIMITED',
    'HASTRAA TESTECH INDIA PRIVATE LIMITED',
    'TUTORAC INDIA PRIVATE LIMITED',
    'PAVA MICRO SERVICES FOUNDATION',
    'JW BUILDMART PRIVATE LIMITED',
    'TRIOPHASE GLOBAL SERVICES PRIVATE LIMITED',
    'LOTUS WATER FOOD TESTING AND RESEARCH LABORATORY PRIVATE LIMITED',
    'ESTABLISHED DIGITAL PUBLISHING PRIVATE LIMITED',
    'DA GAME CHANGERS PRIVATE LIMITED',
    'APNEMY TECHNOLOGIES PRIVATE LIMITED',
    'SAMBANDH INFRASTRUCTURE AND DEVELOPMENT PRIVATE LIMITED',
    'ABZILON INDIA PRIVATE LIMITED',
    'STERIMED KOCHI PRIVATE LIMITED',
    'NUTRIGAMY FOODS PRIVATE LIMITED',
    'TRANSARROW INDIA PRIVATE LIMITED',
    'JAMBUGHODA KRUSHI VIKAS FARMER PRODUCER COMPANY LIMITED',
    'LICIT LEARNING PRIVATE LIMITED',
    'NUTSHELL LEARNING SERVICES (OPC) PRIVATELIMITED',
    'XENTEGRA PRIVATE LIMITED',
    'RIYA CHEMY PRIVATE LIMITED',
    'RENAISSANCE TECHPLATFORM PRIVATE LIMITED',
    'LLABDHI AND BOTHRA FOUNDATION',
    'YOUTH COVE FOUNDATION',
    'SURYAWANSHI ART TATTOO SUPPLY PRIVATE LIMITED',
    'RAJA RANI TRANSPORT PRIVATE LIMITED',
    'NEW RELIC ONE INDIA PRIVATE LIMITED',
    'PISTTA BAKER',
    'AON FOUNDATION',
    'RECAP SOLAR INDIA PRIVATE LIMITED',
    'KAVEER CONSULTING SERVICES (OPC) PRIVATELIMITED',
    'AARKAY VENTURES PRIVATE LIMITED',
    'MEDICROCKET HEALTHCARE PRIVATE LIMITED',
    'TIPS IMMIGRATION AND CONSULTANCY SERVICES PRIVATE LIMITED',
    'SPERSH POLYMERS PRIVATE LIMITED',
    'NEVIS PROPERTIES PRIVATE LIMITED',
    'TRUBOARD SERVICING PRIVATE LIMITED',
    'ATC MOULD INDIA PRIVATE LIMITED',
    'OCEAN LINER AGENCY SERVICES PRIVATE LIMITED',
    'Vipul lavanya developers limited',
    'Dsj infra projects private limited',
    'Avalon city infrastructures private limited',
    'Avalon buildcon private limited',
    'Valecha reality limited',
    'Growmore space solutions private limited',
    'Shree ramanjaneya developers private limited',
    'Naveen holdings pvt ltd',
    'Kanika infra promoters private limited',
    'Gnex housing private limited',
    'Hulk and hercules limited',
    'Bk structural contracts private limited',
    'Young ace global private limited',
    'PRACHIN INFRASTRUCTURE HOLDINGS PRIVATE LIMITED',
    'Alja properties private limited',
    'Carambola developers private limited',
    'Clavillia promoters private limited',
    'Trisquare properties private limited',
    'TACHU CONCEPT HOMES AND INTERIORS PRIVATE LIMITED',
    'Redsand holdings private limited',
    'Shilpa properties pvt ltd',
    'Excel international private limited',
    'Mascom electronics private limited',
    'Net vigil software private limited',
    'Prime com solutions private limited',
    'Itmantra techintellect private limited',
    'BIO ENTITIES PRIVATE LIMITED',
    'THRINAINA INFORMATICS PRIVATE LIMITED',
    'Imokshum technology private limited',
    'Greenchain software solutions private limited',
    'Transmedia technologies (a.p.) private ltd',
    'Tulasi technosoft private limited',
    'Frux software solutions private limited',
    'Nixsol india private limited',
    'Dharani info technologies private limited',
    'Rowan software technologies private limited',
    'Pronix it solutions private limited',
    '1bn software & it solutions private limited',
    'GEEKYANTS INDIA PRIVATE LIMITED',
    'Solution infotech (india) private limited',
    'Mipl solutions private limited',
    'Axelerant technologies private limited',
    'Infoicon technologies private limited',
    'Perpetuiti technologies private limited',
    'Bapna tech private limited',
    'Tecnoglare infotech private limited',
    'Junglee games india private limited',
    'Eminenture private limited',
    'Novelroots internet private limited',
    'Z n softech private limited',
    'Grapes digital private limited',
    'Sourcepro infotech private limited',
    'I-link infosoft (gujarat) private limited',
    'Alpha automation private limited',
    'Infosense private limited',
    'CREST INFOSYSTEMS PRIVATE LIMITED',
    'Allot technologies private limited',
    'Bharti soft tech private limited',
    'Infinity transoft solution private limited',
    'Prakash web tech private limited',
    'Pctechsquad technologies private limited',
    'J.j.electrovision private limited',
    'Ranal software technologies private limited',
    'Triveni hi-tech private limited',
    'Ibm india private limited',
    'KONRAD TECHNOLOGIES INDIA PRIVATE LIMITED',
    '10kinfo data solutions private limited',
    'Intersoftkk (india) private limited',
    'Softbee consultancy services private limited',
    'Vaptus consultancy services private limited',
    'Bhima soft private limited',
    'Software ag (india) private limited',
    'Maharashtra masala udyog sanghatana',
    'Mind sparks education association',
    'Suprasanna solaire energy private limited',
    'Emsafe fire safety solutions private limited',
    'Saleszip marketing private limited',
    'Meena jewellers private limited ( part ix )',
    'Thrissur expressway limited',
    'Rayalseema expressway private limited',
    'TRISENTIA INFOTECH PRIVATE LIMITED',
    'SPARKMAN INFRA ADVISORS (INDIA) PRIVATE LIMITED',
    'Euklid brand solutions private limited',
    'Transbit technologies software private limited',
    'Achantas enterprises private limited',
    'A.s. shipping agencies private limited',
    'Froq far east brand services private limited',
    'Venba tech private limited',
    'Strong force pt systems india private limited',
    'Winteg consultancy services private limited',
    'IYS SKILLS TECH PRIVATE LIMITED',
    'Enterkey solutions private limited',
    'Reefer care services private limited',
    'Imi vengineering private limited',
    'Perfect intercontinental (india) private limited',
    'Avant-garde fintech private limited',
    'Abraaz malaspina soles private limited',
    'Adcorre medias private limited',
    'Tdp textiles (india) private limited',
    'Mercure health care services private limited',
    'BWI PROJECT INDIA PRIVATE LIMITED',
    'Banyan hydraulics & projects private limited',
    'Ramesh centering works private limited',
    'Gypcore india private limited',
    'Kanishk ventures private limited.',
    'Ds overseas traders private limited',
    'WURKR PRIVATE LIMITED',
    'Retail interface private limited',
    'Quadmo solutions private limited',
    'Ulises consultancy services private limited',
    'Ladder consultancy services private limited',
    'Kamms management consultants private limited',
    'Checkmate industrial guards private limited',
    'Pioneer security solutions private limited',
    'Occulus consulting private limited',
    'Demax security management services private limited',
    'Epic sustainability services private limited',
    'KHFM HOSPITALITY AND FACILITY MANAGEMENTSERVICES LIMITED',
    'Hotel commerce private limited',
    'SIJCON DESIGN AND ENG PRIVATE LIMITED',
    'Photoquip (india) ltd',
    'Tips films limited',
    'Ever clear films private limited',
    'ONE TO ZERO DIGITAL PRIVATE LIMITED',
    'Taxaveen packaging pvt ltd',
    'Vimalachal print and pack pvt ltd',
    'Pushkar insulation and packaging private limited',
    'Shwet (india) exports private limited',
    'E m pax technology private limited',
    'Sapwood ventures private limited',
    'Ace genuine spares private limited',
    'Pinakin commercials private limited',
    'Aqumena marketing services private limited',
    'Clivet airconditioning systems private limited',
    'YITRO GLOBAL PRIVATE LIMITED',
    'Kalatmak spatial systems private limited',
    'Retro handicrafts private limited',
    'Willy kids education management private limited',
    'Sandy bay seafoods ( india) private limited',
    'Eco rrb infra private limited',
    'Murlidhar textile park private limited',
    'Optiontown software private limited',
    'Sunborne energy services india private limited',
    'Progrowth consulting private limited',
    'Fair value information technology services private limited',
    'Electronic freight data interchange private limited',
    'Thakur equipment india private limited',
    'Surya coats private limited',
    'Western india sea brines pvt ltd',
    'Leixir resources private limited',
    'Msr chemicals and frtilizers private limited',
    'Dusters total solutions services private limited',
    'Captain public retail networks private limited',
    'VGA RIGHT SQUARE FOOT PRIVATE LIMITED',
    'Macula healthcare private limited',
    'Touch hygiene services private limited',
    'Sarthi services private limited',
    'Enable excellence private limited',
    'Realgard power systems private limited',
    'Cochin business training services private limited',
    'Aries technical sales and service pvt ltd',
    'Heather impex private limited',
    'Firestorm finance & investments private limited',
    'GOLDCREST GLOBAL TRADING PRIVATE LIMITED',
    'Radiant organics private limited',
    'Flash graphics private limited',
    'Praxis corporate services private limited',
    'Pra real estate ventures private limited',
    'J.k.gems & jewellery private limited',
    'Colourtech coating (india) private limited',
    'Nirmal lifestyle malls private limited',
    'Nirmal lifestyle (indore) private limited',
    'BLOOMIN',
    'POCKET BOOKS PRIVATE LIMITED',
    'Ambi knowledge resources private limited',
    'Suvarna kala private limited',
    'Le griffe offset private limited',
    'Print access private limited',
    'Replica xerography private limited',
    'Triune print solutions private limited',
    'Aakruthi media & communications (india) private limited',
    'MILES EDUCATION PRIVATE LIMITED',
    'Mehra computer systems limited',
    'Repromen offset printers madras private limited',
    'GREAT DIVINE PULP AND PAPER (INDIA) PRIVATE LIMITED',
    'Green infra wind energy limited',
    'Tarapur grease industries private limited',
    'HUMAN ROBOTICS PRIVATE LIMITED',
    'PROSEAL INSULATION AND TRADING PRIVATE LIMITED',
    'R.l.fine chem private limited',
    'Medorganics india private limited',
    'AHEPRA HEALTHCARE PRIVATE LIMITED',
    'Stan plaza limited',
    'Soham organics private limited',
    'Pinnacle biomed private limited',
    'Oc specialities private limited',
    'Topaz textile auxilliaries private limited',
    'Guljag jaipur gases private limited',
    'Vapco engineers private limited',
    'Mebrom india private limited',
    'Gujarat dyestuff industries pvt ltd',
    'Shreenathji rasayan pvt.ltd.',
    'Harman finochem limited',
    'High-rise chemical industries private limited',
    'Glade organics private limited',
    'Embassy silicones india private limited',
    'Datta hydro-chem private limited',
    'Endress + hauser (india) private limited',
    'Fire power fuel savers private limited',
    'Denisco chemicals private limited',
    'Virupaksha organics limited',
    'Arkema peroxides india private limited',
    'Micro bax (india) limited',
    'Amines biotech private limited',
    'Ojas dycehem (india) private limited',
    'Siddhi ceracolours private limited',
    'Thermochem processes private limited',
    'Venkateshwara fibre glass (chennai) private limited',
    'Kamal healthcare products private limited',
    'Teja cement limited',
    'Suvidha city private limited',
    'Jsb homemakers private limited',
    'Ghv (india) private limited',
    'Nirmal nccc construction private limited',
    'Bebanco infrastructure limited',
    'CHAO-VEERA FINVEST PRIVATE LIMITED',
    'Pune infocity infrastructure private limited',
    'Dugar properties private limited',
    'Sri krishnaiah property developers private limited',
    'Bose building materials & prefab houses private limited',
    'International infratech private limited',
    'Green infra corporate wind limited',
    'Green infra wind farms limited',
    'Aatash dredging and consructions private limited',
    'Dhruv procon private limited',
    'Shanti-laxmi contractors private limited',
    'Strabag india private limited',
    'Astrix properties private limited',
    'MODERN TOLLROADS PRIVATE LIMITED',
    'Sheela infrastructures private limited',
    'Mep infrastructure private limited',
    'Rajlaxmi buildtech private limited',
    'Lokmangal infrastructure private limited',
    'Ramky elsamex hyderabad ring road limited',
    'Hospet chitradurga tollways limited',
    'Jupiter gran stones private limited',
    'Hallmark infrastructure private limited',
    'Alliance orchid tech park private limited',
    'Alliance orchid mall private limited',
    'Falit land developers private limited',
    'K.P.A. ENGINEERING PRIVATE LIMITED',
    'Carnoustie properties private limited',
    'Nanded city development and construction company limited',
    'Agarwal landmarks pvt. ltd',
    'Ramky towers limited',
    'V m n r constructions private limited',
    'Sri bdl properties private limited',
    'KARTYA CONSTRUCTIONS PRIVATE LIMITED',
    'Eirich india private limited',
    'Blue cross marketing private limited',
    'PROPERTY JUNCTION REALTY SOLUTIONS PRIVATE LIMITED',
    'EWAYCORP TECHNOLOGIES PRIVATE LIMITED',
    'Atshi buildtech private limited',
    'Atn infratech private limited',
    'Seh infrastructure private limited',
    'Agilent steel private limited',
    'VIRAL BUILDCON PRIVATE LIMITED',
    'WESTCOARSE CHEMICALS PRIVATE LIMITED',
    'Jvls constructions private limited',
    'Jvls builders private limited',
    'Balaji greenfield techno ventures private limited',
    'Cbs international projects private limited',
    'WITTY CONSTRUCTIONS PRIVATE LIMITED',
    'Darwin platform infrastructure limited',
    'Supreme kopargaon ahmednagar tollways private limited',
    'PURANDAR CONSTRUCTION PRIVATE LIMITED',
    'Jolly realty private limited',
    'Danco enterprises india private limited',
    'Vj projects private limited',
    'Renaissance indus infra private limited',
    'Talish infra projects private limited',
    'Dhruvin realtors private limited',
    'Jsb dream homes private limited',
    'Sd intrabuild private limited',
    'Madni dream builders private limited',
    'Dhansmruti buildcon private limited',
    'Tellapur technocity private limited',
    'Salasar balaji estates(india) private limited',
    'AAKRITI CONSTRUCTIONS AND DEVELOPERS PRIVATE LIMITED',
    'Lekcon infrastructure private limited',
    'Gamya infrastructure services private limited',
    'SCALE DESIGN COLLABORATIVE PRIVATE LIMITED',
    'Mukta heights private limited',
    'Sri bk and bs realtors private limited',
    'Marg sri krishnadevaraya airport private limited',
    'Sree balaji logicons private limited',
    'Highpowerv housing private limited',
    'Federal synergies (india) private limited',
    'Richa infraprojects private limited',
    'Swiss merchandise infrastructure limited',
    'Royalvision projects private limited',
    'Shriprop builders private limited',
    'Ganganagar automobiles private limited',
    'Apco autosales private limited',
    'ST. ANTONY',
    'S BIWHEELERS PRIVATE LIMITED',
    'Pure petrochem india private limited',
    'Mk commodity brokers limited',
    'Svs commodity brokers private limited',
    'Food creations private limited',
    'Zen marketing & media private limited',
    'HOME ZONE METALS PRIVATE LIMITED',
    'ATS HEIGHTS PRIVATE LIMITED',
    'Four nine infra private limited',
    'Citycon buildwel private limited',
    'Kartik infratown private limited',
    'GTV SEZ PHASE I PRIVATE LIMITED',
    'Rv homemakers private limited',
    'Techno lifestyle development private limited',
    'Amaaya properties private limited',
    'Cartoleria retailing private limited',
    'Hs fitness private limited',
    'E-plus technologies (india) private limited',
    'AABSYS INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'Zeetaa business solutions private limited',
    'PROLIFICS CORPORATION PRIVATE LIMITED',
    'Malvi software solutions private limited',
    'Amazant technosoft india private limited',
    'QARC DIGITAL PRIVATE LIMITED',
    'Global alliance private limited',
    'Seh software private limited',
    'Anushria infotech private limited',
    'Gazelle information technologies private limited',
    '4th dimension digital studio private limited',
    'Vocus communications private limited',
    'Acmedox technologies private limited',
    'B g web solutions private limited',
    'Bigdream infoservices private limited',
    'IRIS SPECTRA PRIVATE LIMITED',
    'Cybersurf (india) private limited',
    'Easy transcription and software private limited',
    'Aatash computer and communications private limited',
    'Elitech systems private limited',
    'Khodiyar cad center (india) private limited',
    'Its data-solutions private limited',
    'SIGMA SOLVE LIMITED',
    'Awaaz de infosystems private limited',
    'Brevity software solutions private limited',
    'Buildmet technologies private limited',
    'SOLIZE INDIA TECHNOLOGIES PRIVATE LIMITED',
    'Lampo computers private limited',
    'Embedded systems solutions private limited',
    'CONVERGENCE INFOTECH PRIVATE LIMITED',
    'Reli-e-marg software consultants private limited',
    'Shri sr software solutions private limited',
    'IMPELSYS PRIVATE LIMITED',
    'Crimsonlogic india private limited',
    'Koteshwar software and technology consultants private limited',
    'Theorem (india) private limited',
    'Erp outsourcing private limited',
    'NTT CLOUD INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'Suncorp information technologies private limited',
    'Microgenesis techsoft private limited',
    'Teja soft innovations private limited',
    'Thematics infotech private limited',
    'Trek technology (india) private limited',
    'Sam infoways india private limited',
    'Logesys solutions india private limited',
    'Twenty two by 7 solutions private limited',
    'Augen technologies software solutions private limited',
    'Effone technologies private limited',
    'Eflair management systems private limited',
    'Nbiton solutions private limited',
    'PRAVATI DHARA PRIVATE LIMITED',
    'TRIPLET ENGINEERING AND CONSULTANCY SERVICES PRIVATE LIMITED',
    'DEVIKA FABRICS PRIVATE LIMITED',
    'WESN INDIATECH (OPC) PRIVATE LIMITED',
    'RTG INDUSTRIES PRIVATE LIMITED',
    'S DEVELOPMENT SOCIETY OF INDIA',
    'Biogenesis healthcare private limited',
    'Ceevees imaging and healthcare research private limited',
    'Dr singh city hospital and medical research centre private limited',
    'Light flow media arts private limited',
    'Future east film private limited',
    'Tarashakti overseas private limited',
    'Lifespring healthplus india private limited',
    'Geo-chem laboratories (rajkot) pvt ltd',
    'Parthys reverse informatics analytic solutions private limited',
    'Sampurna training and entrepreneurship programme',
    'Creation art productions private limited',
    'Silania kreations private limited',
    'Eod amusement private limited',
    'Besure healthcare private limited',
    'Jbm motors limited',
    'Jbm ogihara automotive india limited',
    'Kalzip india private limited',
    'Ruby engineering company private limited',
    'Shiva techniques surfaces private limited',
    'Manu international pvt ltd',
    'Preci fab engineers private limited',
    'Gmi zarhak moulders private limited',
    'Fibertech composite private limited',
    'Shantilal doshi private limited',
    'Podar investments private limited',
    'Bharat forgings pvt ltd',
    'Rajhans industries pvt ltd',
    'Nagreeka indcon products private limited',
    'Newtech systems pvt ltd',
    'Armtex rubber private limited',
    'Integral alpha private limited',
    'Armylon metaliks private limited',
    'Senthil steel company private limited',
    'Amba foundaries private limited',
    'Pvs protections private limited',
    'Luthra precision instruments private limited',
    'Hi-mak private limited',
    'G. r. metaliks and industries private limited',
    'ITP EXTERNALS INDIA PRIVATE LIMITED',
    'Gee ess alloys india private limited',
    'Shah machines private limited',
    'Naveen bharath equipments private limited',
    'Oscar equipments pvt ltd',
    'Duggal motors private limited',
    'Itt corporation india private limited',
    'Xylem water solutions india private limited',
    'Tb hydro flovel valves private limited',
    'Intervalve Poonawalla Limited',
    'SM EXHAUST TECHNOLOGY PRIVATE LIMITED',
    'Weber hydraulic india private limited',
    'FLUID CHECK VALVES PRIVATE LIMITED',
    'Sunmax boiler engineers private limited',
    'Gajra gears private limited',
    'Nu-teck couplings private limited',
    'PEE TEE TURNERS LIMITED',
    'Dozco (india) pvt ltd',
    'P c s l merchandise pvt ltd',
    'East and west clothing private limited',
    'Nlg genset private limited',
    'Hrd metals private limited',
    'Sonai engineering private limited',
    'Gee elevators private limited',
    'Drums and shells mfg. (india) private limited',
    'Mpm-gtp foundry technologies private limited',
    'DUDIGITAL GLOBAL LIMITED',
    'W.T.T. INTERNATIONAL PRIVATE LIMITED',
    'Shakti industrial equipments private limited',
    'Indian expeller works pvt ltd',
    'Safex engineers private limited',
    'Shree ram rubtech private limited',
    'Aerzen machines (india) private limited',
    'P dass forging private limited',
    'Gee dee metal crafts private limited',
    'Sakthi auto component limited',
    'Del-tech instruments private limited',
    'U m engineering private limited',
    'Acquaviva india private limited',
    'Marine container services (india) private limited',
    'Sgi ispat private limited',
    'Surlon durel springs private limited',
    'Waterneer technologies india private limited',
    'Metaltec products private limited',
    'Hanaka tools private limited',
    'Rama property developers private limited',
    'Triologics surface coatings private limited',
    'Manu concast private limited',
    'Sanraj impex private limited',
    'Shri amman steel and alied industries private limited',
    'Wittmann battenfeld india private limited',
    'Shearline process private limited',
    'Shwesai marine private limited',
    'Sapna engineering solutions private limited',
    'Vvdn manufacturing private limited',
    'Flexell engitech private limited',
    'Futuristic steel ltd.',
    'Inovic engineering solutions private limited',
    'Vaish industries private limited',
    'Maheshwari carburising engineering private limited',
    'Indnova technologies private limited',
    'Gold seal engineering products private limited',
    'Igloo dairy services private limited',
    'Dinshaw filtration systems private limited',
    'Orange city metal private limited',
    'Parry enterprises india limited',
    'Rec engineering products private limited',
    'Wolter ventilators india private limited',
    'Dashmesh jacquard & powerloom private limited',
    'AGRASEN ENGINEERING INDUSTRIES Private Limited',
    'Inco mechel pvt limited',
    'Dhiman industry limited',
    'Habil holdings private limited',
    'Applied felts (india) private limited',
    'Tules cad cam technologies private limited',
    'Simpex engineering (india) private limited',
    'Saptasatij industries private limited',
    'Pama machine tools india private limited',
    'Prominent forgings private limited',
    'Anandji haridas and company private limited',
    'Shalimar valves pvt ltd',
    'Sodecia india private limited',
    'Emaar brothers engineering private limited',
    'V.v.iron &steel company private limited',
    'Septu (india) pvt ltd',
    'Algee logistics private limited',
    'Stryker india pvt ltd',
    'A.d. airconditioner private limited',
    'Saraf electric company private limited',
    'Balcos exports pvt ltd',
    'Oriental power electricals private limited',
    'V c overseas private limited',
    'Aatmosfera di vita private limited',
    'Goodie international private limited',
    'Crestt innotech private limited',
    'Abhijat impex private limited',
    'New ambi trading and investments private limited',
    'Jk lifestyle private limited',
    'Jai matadi vanijya pvt ltd',
    'Choudhary industries private limited',
    'K thakorlal trading and investments pvt ltd',
    'Banbros engineering private limited',
    'Shakti arora exports private limited',
    'Shalina trading co pvt ltd',
    'Thirumala precicasts private limited',
    'BASANT LOK TRADING COMPANY (A PRIVATE COMPANY)',
    'Fraco mastclimbers (india) private limited',
    'M and m jobbers private limited',
    'K.k. overseas private limited',
    'ASH & ALAIN INDIA PRIVATE LIMITED',
    'Dari traders private limited',
    'Galiakotwala international private limited',
    'Megavision exports private limited',
    'Eben trade impex private limited',
    'Highclass trading private limited',
    'Metaforge engineering (india) private limited',
    'Immense exim private limited',
    'Challenger tradelink (india) private limited',
    'Solar magic private limited',
    'Shimera lighting private limited',
    'Pheroze kudianavala management and marketing services private limited',
    'Crystaline exports private limited',
    'Shiga energy private limited',
    'Aiyana trading private limited',
    'Houghton india private limited',
    'Advance iron private limited.',
    'Pioneer global enterprises private limited',
    'Allana imports and exports private limited',
    'Pethe industrial marketing company private limited',
    'Sapcom trading private limited',
    'Vikash agencies limited',
    'Vanity enterprises private limited',
    'Magus exim private limited',
    'City fame engineering private limited',
    'Mirchi mart (india) private limited',
    'Skechers south asia private limited',
    'Jaina mobile india private limited',
    'Pacific infosolutions india private limited',
    'A.s.t exim private limited',
    'Dmr enterprises private limited',
    'Golf galaxy private limited',
    'Syndicate overseas private limited',
    'Indaf exports private limited',
    'Seven seas trading and marketing private limited',
    'Art impex india (p) ltd.',
    'Elements exports private limited',
    'Ethnic overseas private limited',
    'Juvenile trading private limited',
    'Metlloy trading services private limited',
    'Vastustar trading private limited',
    'Serendipity enterprises private limited',
    'Ritvya impex private limited',
    'Pagoda enterprises private limited',
    'U a marketing private limited',
    'YAHWEH TRANSPORT PRIVATE LIMITED',
    'Synergy energy solutions private limited',
    'Pbg exim private limited',
    'MANAS TRADES & HOLDINGS PVT LTD',
    'Roxtec india private limited',
    'Sulson overseas private limited',
    'Surbhi body products private limited',
    'Shree viniyog pvt ltd',
    'Tanfac apparels limited',
    'Bullpower vyapar ltd',
    'SHRADDHA DISTRIBUTORS PVT LTD',
    'Sungrowth coke pvt. ltd.',
    'Rana udyog pvt.ltd.',
    'Ortem marketing pvt.ltd.',
    'Concord tie up pvt ltd',
    'Trimudra suppliers pvt ltd',
    'Blaze commercial pvt ltd',
    'TRANSMISSION & DISTRIBUTION (INDIA) LIMITED',
    'Lion picture & frames (india) limited',
    'Essbee networks private limited',
    'Noble aerospace private limited',
    'Sumpoorna comtrade private limited',
    'Beepee enterprise private limited',
    'Gextasia exports private limited',
    'Ncr data voiz comm private limited',
    'Cimmen agencies private limited',
    'Destination tie-up private limited',
    'Exim overseas private limited',
    'B.r. poddar marketing private limited',
    'Shreyans overseas private limited',
    'Global tradz solutions private limited',
    'Eastern star trade private limited',
    'Ethos embassy communications private limited',
    'Flux pumps india private limited',
    'Balaji ferro metal works private limited',
    'Saba metchem private limited',
    'Perfect fmcg private limited',
    'Sp global ventures (india) private limited',
    'Bien mercantile private limited',
    'Starbic business solutions private limited',
    'Scube scientific software solutions private limited',
    'Blm software private limited',
    'Dubeys information pool and solution private limited',
    'Janasis infotech limited',
    'Sunrise embedded solutions private limited',
    'Parnami softech private limited',
    'Hughes systique private limited',
    'Shri ganesh itsoft private limited',
    'Rk infrahome private limited',
    'Golfgreen buildcon private limited',
    'Aarza infratech private limited',
    'Orion fdp technologies private limited',
    'Whisk software private limited',
    'Gateway software solutions private limited',
    'Broadway realty private limited',
    'Shubham propmart private limited',
    'Prinfra limited',
    'Green byte web private limited',
    'Chinmaya agro and rural research and development company pvt. ltd.',
    'ZEBRA BUILDERS & DEVELOPERS PVT LTD',
    'RS & BH CONSTRUCTION & INVESTMENT COMPANY PVT LTD',
    'Summit holdings private limited',
    '4 tech bugs technologies private limited',
    'Exsete consulting private limited',
    'Advika promoters private limited',
    'Amal infraventures private limited',
    'Mini realtors private limited',
    'Fauja singh infrastructure private limited',
    'Kamboj consultancy pvt ltd',
    'BYTE PROPHECY PRIVATE LIMITED',
    'Allot system integration private limited',
    'Krishaweb technologies private limited',
    'Agilent technologies (international) private limited',
    'Spectra technologies (india) private limited',
    'Sst infotech india private limited',
    'Ssdn technologies private limited',
    'Seascape learning co private limited',
    'Baehal software limited',
    'Processware technologies private limited',
    'Prakash business solutions (india) private limited',
    'Sanctum technologies private limited',
    'Neil computer development private limited',
    'Smithdehn india private limited',
    'Indygo software systems private limited',
    'SKANRAY TECHNOLOGIES LIMITED',
    'Lead it solutions private limited',
    'Anandit infotech india private limited',
    'Kuberre high performance computing private limited',
    'Nfotec digital engineering private limited',
    'Saranyu technologies private limited',
    'Ehe innovations private limited',
    'Snyxius technologies private limited',
    'Trawex technologies private limited',
    'Jj bytes private limited',
    'Hexwhale technologies private limited',
    'Esyasoft technologies private limited',
    'Us technology international private limited',
    'Satyasai information technology private limited',
    'Alice technologies private limited',
    'Laptron technology private limited',
    'Oglacs software private limited',
    'Abhirvey projects private limited',
    'Veuz concepts private limited',
    'Mxbit technology innovations private limited',
    'PRESS GANEY ASSOCIATES INDIA PRIVATE LIMITED',
    'Geospice location intelligence private limited',
    'Efficiency equipment private limited',
    'Matrix 3d infocom private limited',
    'Cybage software private limited',
    'Nirvana technologies private limited',
    'Softspin services private limited',
    'Heavens buildwell private limited',
    'Kansara modler ltd.',
    'Macrosoft associates private limited',
    'Orimark technologies private limited',
    'INSCOL ACADEMY PRIVATE LIMITED',
    'Contact bridge it enabled services private limited',
    'Care infoserve private limited',
    'Soft-tech computers pvt ltd',
    'Kool - ex cold chain limited',
    'Capscan computerforms pvt ltd',
    'TRUWORTH INFOTECH PRIVATE LIMITED',
    'Auromeera technometrix private limited',
    'Jsv automation solutions private limited',
    'Imenso software private limited',
    'Consistent infosystems private limited',
    'Brainguru technologies private limited',
    'Hid techs private limited',
    'IET SOLUTIONS (INDIA) PRIVATE LIMITED',
    '4CASTLE MARITIME (OPC) PRIVATE LIMITED',
    'VEINFRA PRIVATE LIMITED',
    'KRI KRI KOFFIEHUISS PRIVATE LIMITED',
    'PIBIT TECHNOLOGIES PRIVATE LIMITED',
    'HPTS CONSULTING INDIA PRIVATE LIMITED',
    'WOPT SOLUTIONS PRIVATE LIMITED',
    'AMPLUS SHAMS PRIVATE LIMITED',
    'FLEXIS INDIA PRIVATE LIMITED',
    'CADESK INFO SERVICES PRIVATE LIMITED',
    'AQUA SEAL TECH PRIVATE LIMITED',
    'DWARKA VAYU 1 PRIVATE LIMITED',
    'RECURR STUDIO PRIVATE LIMITED',
    'IDEAMETRICS AGRO PRIVATE LIMITED',
    '21CC CARE PRIVATE LIMITED',
    'DIGITAL GLYDE INFOTECH PRIVATE LIMITED',
    'BHARAT INDUSTRIAL CORPORATION PRIVATE LIMITED',
    'PACCOUS LOGISTICS PRIVATE LIMITED',
    'AIF & PMS EXPERTS INDIA PRIVATE LIMITED',
    'STORY MINTER MEDIA PRIVATE LIMITED',
    'MARS MEDICAL DEVICES LIMITED',
    'INFINITY TRAINING SERVICES PRIVATE LIMITED',
    'CANNYMINDS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'TATA MOTORS PASSENGER VEHICLES LIMITED',
    'BARRIER BREAKER PRIVATE LIMITED',
    'DIGITALFORCE SOLUTIONS PRIVATE LIMITED',
    'GLOBAL ACCESS HOSPITALITY PRIVATE LIMITED',
    'CRYSTAL FURNITECH PRIVATE LIMITED',
    'MEDPIPER TECHNOLOGIES PRIVATE LIMITED',
    'POWER FIVE TECHNOLOGIES PRIVATE LIMITED',
    'KEVA KAIPO INDUSTRIES PRIVATE LIMITED',
    'AXIOS ACADEMY PRIVATE LIMITED',
    'YELLOW SKY TECHNOLOGIES PRIVATE LIMITED',
    'SIGNALATM PRIVATE LIMITED',
    'BEHLINNOV SOLUTIONS PRIVATE LIMITED',
    'WAYPOINT PORT SERVICES PRIVATE LIMITED',
    'XCOAL INDIA ENERGY AND COMMODITIES PRIVATE LIMITED',
    'TP CENTRAL ODISHA DISTRIBUTION LIMITED',
    'JLSR INFOTECH PRIVATE LIMITED',
    'COVETIT SOFTWARE PRIVATE LIMITED',
    'CODEIAM (INDIA) PRIVATE LIMITED',
    'MANORAMA MEDICARE PRIVATE LIMITED',
    'ICON AUTOCRAFT PRIVATE LIMITED',
    'TSB MEDIA VENTURE PRIVATE LIMITED',
    'AUTOPEEPAL TECHNOLOGIES PRIVATE LIMITED',
    'CHOSUN REFRACTORIES INDIA PRIVATE LIMITED',
    'ONECERT FOUNDATION',
    'M&J EDTECH PRIVATE LIMITED',
    'SMKB ASSOCIATES PRIVATE LIMITED',
    'VALLUVAR INFRA PRIVATE LIMITED',
    'JBM ELECTRIC VEHICLES PRIVATE LIMITED',
    'FLYING SAMURAI SOLUTIONS PRIVATE LIMITED',
    'AMP ENERGY GREEN FOUR PRIVATE LIMITED',
    'GREENKO TS01 IREP PRIVATE LIMITED',
    'EDUPEDIA EDUCATIONAL SERVICES PRIVATE LIMITED',
    'AUREEN MONTEIRO INTERNATIONAL (OPC) PRIVATE LIMITED',
    'PELIQAN DATA SOLUTIONS PRIVATE LIMITED',
    'KAPIL TECHNOLOGIES PRIVATE LIMITED',
    'DEINON RISK SERVICES PRIVATE LIMITED',
    'ADD PLUS PHARMA PRIVATE LIMITED',
    'KNOBS AND KEYS REAL ESTATE SERVICES PRIVATE LIMITED',
    'NOVOMOLDX PRIVATE LIMITED',
    'TOPFRONT PRIVATE LIMITED',
    'NVLIFE PRIVATE LIMITED',
    'ALFANIO INDIA PRIVATE LIMITED',
    'LITSOLAIRE ENERGY PRIVATE LIMITED',
    'NBHC ENTERPRISES PRIVATE LIMITED',
    'AZTECH VISION PRIVATE LIMITED',
    'POWERLOOK APPARELS PRIVATE LIMITED',
    'ENACTIS HEALTHCARE PRIVATE LIMITED',
    'FASTWEL ELECTRONICS INDIA PRIVATE LIMITED',
    'UNIVERSAL TOYS PRIVATE LIMITED',
    'NCUBE PROTECTIVES PRIVATE LIMITED',
    'SRIHARSHA MATERIAL SERVICES PRIVATE LIMITED',
    'SMARTCORP CONSULTANY (OPC) PRIVATE LIMITED',
    'MOTOLOGIC AUTO PRIVATE LIMITED',
    '2020ANALYTICS INSIGHTS PRIVATE LIMITED',
    'JOBSGAAR TECHNOLOGIES PRIVATE LIMITED',
    'CALLXP COMMUNICATIONS PRIVATE LIMITED',
    'WEBBELL SOLUTIONS PRIVATE LIMITED',
    'VEELO MOBILITY PRIVATE LIMITED',
    'TOTALQ INDUSTRIES PRIVATE LIMITED',
    'AMITA TEK PRIVATE LIMITED',
    'QUIN BAY TECHNOLOGIES PRIVATE LIMITED',
    'CREDINTA E-TRADE PRIVATE LIMITED',
    'EIO PLATFORM (OPC) PRIVATE LIMITED',
    'NAVRACHNA FOUNDATION FOR ENTREPRENEURSHIP DEVELOPMENT',
    'HANOVER INTERNATIONAL SUPPORT SERVICES PRIVATE LIMITED',
    'EON9 STUDIO INTERIORS PRIVATE LIMITED',
    'INTELLIGEN SOLUTIONS PRIVATE LIMITED',
    'VIPRAM STEEL PRIVATE LIMITED',
    'LEBA REALTY PRIVATE LIMITED',
    'WEAVINGHANDS RUGS PRIVATE LIMITED',
    'RADIX WEB SERVICES PRIVATE LIMITED',
    'RAJ BIO CARE PRIVATE LIMITED',
    'EAGLE AMRAVATI CHIKHLI NH-6 PKG-II PRIVATE LIMITED',
    'ESVA PUMPS INDIA PRIVATE LIMITED',
    'SPG CONSUMER PRODUCTS PRIVATE LIMITED',
    'JT FINALE PRIVATE LIMITED',
    'CSPACE MANAGEMENT PRIVATE LIMITED',
    'SKYEARTH HYDRO FITUBE PRIVATE LIMITED',
    'RAZOR RISK TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SJLT WOVENS PRIVATE LIMITED',
    'DRNS ESTATES PRIVATE LIMITED',
    'CROPSARO INDIA PRIVATE LIMITED',
    'GAMERS ARENA PRIVATE LIMITED',
    'STUDIO KUUMBA PRIVATE LIMITED',
    'GARNI FOODS PRIVATE LIMITED',
    'RHA TECHNOLOGIES PRIVATE LIMITED',
    'TARAK SAFETY PRODUCTS PRIVATE LIMITED',
    'TCZ DIGITAL PRIVATE LIMITED',
    'EDVANTEST MEASURE TECHNOLOGIES PRIVATE LIMITED',
    'EVOPACK PRIVATE LIMITED',
    'RITESTAR PRODUCTS PRIVATE LIMITED',
    'CARGOSITE VENTURES PRIVATE LIMITED',
    'NEUTRAL DISTRIBUTION INDIA PRIVATE LIMITED',
    '56 AI TECHNOLOGIES PRIVATE LIMITED',
    'PRANSHUL LIFESCIENCES PRIVATE LIMITED',
    'PCIT SOLUTIONS PRIVATE LIMITED',
    'SEARCHIT PRIVATE LIMITED',
    'DCLARIO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'NUTNBOLT BUSINESS SOLUTION PRIVATE LIMITED',
    'ANTILIA CASTLE PRIVATE LIMITED',
    'BIOGRID HEALTHCARE PRIVATE LIMITED',
    'VIYAAN IT SOLUTIONS PRIVATE LIMITED',
    'SHREE KRISHNA ENVIRO VENTURE PRIVATE LIMITED',
    'RECKONS FINANCIAL CONSULTING PRIVATE LIMITED',
    'VBC ENGINEERS PRIVATE LIMITED',
    'RUBICON CONSUMER HEALTHCARE PRIVATE LIMITED',
    'KAVACH FINANCIAL SERVICES PRIVATE LIMITED',
    'TREND RISER INSURANCE MARKETING PRIVATE LIMITED',
    'VISA-SHARQ IMMIGRATION SERVICES PRIVATE LIMITED',
    'NEOVERITAS HEALTHCARE PRIVATE LIMITED',
    'MANGALAM BRANDS PRIVATE LIMITED',
    'AIAB VENTURES PRIVATE LIMITED',
    'KUMAR CONSTRUCTION AND PROPERTIES PRIVATE LIMITED',
    'KHUSHBU HONING PRIVATE LIMITED',
    'CALANDIS RETAIL PRIVATE LIMITED',
    'AQUBE ELEVATORS PRIVATE LIMITED',
    'KAUDILYA ENTERPRISES (OPC) PRIVATE LIMITED',
    'CAPPATERY PRIVATE LIMITED',
    'VENZO WOOD PRIVATE LIMITED',
    'CHEFKART HOSPITALITY PRIVATE LIMITED',
    'SUPREMESPACES & IT PARKS PRIVATE LIMITED',
    'SKYLINK RETAIL PRIVATE LIMITED',
    'FAIRTIQ INDIA PRIVATE LIMITED',
    'HERMS NATURE PRIVATE LIMITED',
    'TRIUMPH AUTO (CV) PRIVATE LIMITED',
    'TECHMEDICO PRIVATE LIMITED',
    'DEVIRATH EXPORTS AND IMPORTS PRIVATE LIMITED',
    'WARAN FINANCIAL SERVICES PRIVATE LIMITED',
    'EDZINO DIGITECH PRIVATE LIMITED',
    'VENAD WASTE MANAGEMENT PRIVATE LIMITED',
    'VALUABLE VIBES (OPC) PRIVATE LIMITED',
    'ATS PRAGATI PRIVATE LIMITED',
    'AONENG MEGLIN SOLUTIONS PRIVATE LIMITED',
    'KALLAM TRANSMISSION LIMITED',
    'TROBETHO INDIA PRIVATE LIMITED',
    'TAXDOOT PRIVATE LIMITED',
    'GEMPERE RENEWABLES PRIVATE LIMITED',
    'BRIGHTER GREEN UNIVERSAL ENGINEERING PRIVATE LIMITED',
    'KANLIFE INDIA PRIVATE LIMITED',
    'VIRAJ PROPERTIES AND REAL ESTATE PRIVATELIMITED',
    '3I CARE FOUNDATION',
    'LEBA FOODS PRIVATE LIMITED',
    'LLOYDS LOGISTICS PRIVATE LIMITED',
    'AMPLEX SOFTECH & SERVICES INDIA PRIVATE LIMITED',
    'BLUEPAL LABS PRIVATE LIMITED',
    'NILKANTH HYDROFLUX PRIVATE LIMITED',
    'TAISHO VENTURES PRIVATE LIMITED',
    '4C SERWINGS PRIVATE LIMITED',
    'ALLURE LIFE SCIENCES PRIVATE LIMITED',
    'OHEALTH PRIVATE LIMITED',
    'SCIGNYTE PRIVATE LIMITED',
    'SIPL SMPL VD JV MINING PRIVATE LIMITED',
    'DYSON BRUSHES PRIVATE LIMITED',
    'FATHERSON BIOTECH PRIVATE LIMITED',
    'KITEWAYS SOLUTIONS PRIVATE LIMITED',
    'PUMPKIN PRODUCTIONS PRIVATE LIMITED',
    'TARALE AND SONS PRIVATE LIMITED',
    'TM MUSIC PRIVATE LIMITED',
    'THRIBE CREATORS PRIVATE LIMITED',
    'TECHTRIO SOLUTIONS PRIVATE LIMITED',
    'VERANTES LIVING PRIVATE LIMITED',
    'EDVEY TECHNOLOGIES PRIVATE LIMITED',
    'EXCEL3D HEALTHCARE SOLUTIONS PRIVATE LIMITED',
    'NEWS NAVIGATION INDIA PRIVATE LIMITED',
    'BLUETRIS TECHNOLOGIES PRIVATE LIMITED',
    'MANISH MEDI INNOVATION PRIVATE LIMITED',
    'QUERY DATA SYSTEMS PRIVATE LIMITED',
    'XPLORE INTELLECTS PRIVATE LIMITED',
    'TN APEX SKILL DEVELOPMENT CENTRE FOR HEALTHCARE',
    'TIRUPATI TRANSPORT INDIA PRIVATE LIMITED',
    'PEPPERTREE.AI PRIVATE LIMITED',
    'REWATHI INNOVATIONS PRIVATE LIMITED',
    'ATVANTIC FINECHEM PRIVATE LIMITED',
    'NODES PRIVATE LIMITED',
    'RADIUM ELEMENTS PRIVATE LIMITED',
    'ELAH MANAGEMENT PRIVATE LIMITED',
    'APPSTRA TECHNOLOGIES PRIVATE LIMITED',
    'DRUCKER & GROVE FINTECH PRIVATE LIMITED',
    'BCKSPACE PRIVATE LIMITED',
    'CARNELIAN ASSET MANAGEMENT & ADVISORS PRIVATE LIMITED',
    'DIGI HIND PRIVATE LIMITED',
    'REMOTEWURX PRIVATE LIMITED',
    'PLANET MARATHI PRIVATE LIMITED',
    'SURABHI LABORATORIES PRIVATE LIMITED',
    'NEXTDAY HOME SOLUTION PRIVATE LIMITED',
    'SAMAY AGRO PRODUCTS PRIVATE LIMITED',
    'MAKE ME TRENDY INTERNET PRIVATE LIMITED',
    'OSRM TECH PACK PRIVATE LIMITED',
    'KRISHIV TEA PRIVATE LIMITED',
    'SNPM CHEMICALS PRIVATE LIMITED',
    'FOOD CRAFT HORECA CONSULTANTS PRIVATE LIMITED',
    'WELCORD COMPONENTS PRIVATE LIMITED',
    'MY-T TECH SOLUTIONS PRIVATE LIMITED',
    'AGRO DEVELOPMENT FEDERATION',
    'MYCLNQ HEALTH INDIA PRIVATE LIMITED',
    '1 AUTH TECHNOLOGIES PRIVATE LIMITED',
    'HAUSTURE LOGISTICS PRIVATE LIMITED',
    'BOOLEAN STAFFING AND RECRUITMENT SOLUTIONS PRIVATE LIMITED',
    'DIGIBLOOM SOLUTIONS PRIVATE LIMITED',
    'SUPERHARD RESEARCH CENTRE PRIVATE LIMITED',
    'MUSEON (OPC) PRIVATE LIMITED',
    'NEELS COSMOPRO PRIVATE LIMITED',
    'INDLOG SERVICES PRIVATE LIMITED',
    'UNISOLAR ENERGY PRIVATE LIMITED',
    'EKAAM SATYA FOUNDATION',
    'BOOKMATIC PRIVATE LIMITED',
    'KALYANI HEALTHCARE SERVICES PRIVATE LIMITED',
    'TIRUPATI IRRIGATION PRIVATE LIMITED',
    'ADMITAS ADVISORY SERVICES PRIVATE LIMITED',
    'NATURES CULT PRIVATE LIMITED',
    'SHAPETODAY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'HUKAM PRIVATE LIMITED',
    'RCS PHD PRIVATE LIMITED',
    'ONELIGN TECHNOLOGIES PRIVATE LIMITED',
    'RAMNATH SOLUTIONS PRIVATE LIMITED',
    'KPADITYACO PRIVATE LIMITED',
    'ADVUTION INDIA PRIVATE LIMITED',
    'WHITELION SYSTEMS PRIVATE LIMITED',
    'LOCALGLOBAL SERVICES PRIVATE LIMITED',
    '5T CORPORATE PRIVATE LIMITED',
    'TRISTEEL ENGINEERING PRIVATE LIMITED',
    'H. R. TOOLS PRIVATE LIMITED',
    'GANTHAM VENTURES PRIVATE LIMITED',
    'UNITERN ADVISORS PRIVATE LIMITED',
    'STOREWIDE ACTIVE INTELLIGENCE (SAI) INDIA PRIVATE LIMITED',
    'CENTREAL MULTITRADE INDIA PRIVATE LIMITED',
    'CLEAN MAX SCORPIUS PRIVATE LIMITED',
    'KIREETI CORPORATE SOLUTIONS PRIVATE LIMITED',
    'NALANDA AUTOCOMP PRIVATE LIMITED',
    'VIAVIZE CONSULTING (OPC) PRIVATE LIMITED',
    'MALANI PROJECTS PRIVATE LIMITED',
    'POWERGRID SIKAR TRANSMISSION LIMITED',
    'TROF SERVICES PRIVATE LIMITED',
    'AKG FOUNDATION FOR INNOVATION & PRODUCT DEVELOPMENT',
    'ASEAR HEALTHCARE PRIVATE LIMITED',
    'SMARTWATER LOGISTICS AND SERVICES PRIVATE LIMITED',
    'SOUTH ATLANTIC PARTNERS INDIA PRIVATE LIMITED',
    'EMPHIRE HR SERVICES (OPC) PRIVATE LIMITED',
    'SUPERDREAM TECHNOLOGIES PRIVATE LIMITED',
    'ACIC RISE ASSOCIATION',
    'ELF LABS PRIVATE LIMITED',
    'KALASANSKRUTI FOODS AND BEVERAGES PRIVATE LIMITED',
    'ULGEBRAZ TECHNOLOGIES PRIVATE LIMITED',
    'PHOENIX ECORP PRIVATE LIMITED',
    'SOLUTIONS CUBICLE PRIVATE LIMITED',
    'WEBARIAN SOFTWARES PRIVATE LIMITED',
    'TERRA MINES AND METALS PRIVATE LIMITED',
    '1 TRADEX PRIVATE LIMITED',
    'STM SOFTWARE ENGINEERING PRIVATE LIMITED',
    'OTPAY INDIA PRIVATE LIMITED',
    'TERRAIN ESTATES AND DEVELOPERS PRIVATE LIMITED',
    'SAMRAAT INDO WORKS PRIVATE LIMITED',
    'TOTAL REALTORS PRIVATE LIMITED',
    'RIGHT SELECTION GLOBAL THOUGHT LEADERSHIP PRIVATE LIMITED',
    'MEMORYTRAIN CREATIVES PRIVATE LIMITED',
    'FLYLAW ADVISERS AND CONSULTANTS PRIVATE LIMITED',
    'HARMONIZER INDIA PRIVATE LIMITED',
    'VALERIUS ENGINEERING PRIVATE LIMITED',
    'FINACC HUB SERVICES PRIVATE LIMITED',
    'MOUNTAINOR WELL BEING PRIVATE LIMITED',
    'MODERN JEWELS PRIVATE LIMITED',
    'ELENCHO TECH PRIVATE LIMITED',
    'HARNS TECHNOLOGIES PRIVATE LIMITED',
    'TRUSTED MAINTENANCE CONTRACTORS PRIVATE LIMITED',
    'Rfs india telecom private limited',
    'Dubai realty private limited',
    'Planet care linkerz private limited',
    'Sunder agromills private limited',
    'Livexpo ventures private limited',
    'U & n enterprises private limited',
    'Webhelp india private limited',
    'Zeppelin systems india private limited',
    'GUJARAT ENVIRO-PROTECTION AND INFRASTRUCTURE PRIVATE LIMITED',
    'ATOTECH INDIA Private Limited',
    'Incredible corporate services private limited',
    'Byadgi cold storage private limited',
    'Mavk engineering solutions private limited',
    'UNIWORLD LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'Dimerco express (india) private limited',
    'Jbeil subsea engineers private limited',
    'Tatulege india private limited',
    'Inspire sourcing private limited',
    'Imageq brand consultants private limited',
    'Landmark business service centre private limited',
    'Shiroli mines private limited',
    'ARPAL ADVISORY SERVICES PRIVATE LIMITED',
    'Classic floorings and interiors private limited',
    'Corrosion technology services india private limited',
    'Fourfront consultants india private limited',
    'Madison retail paradigm private limited',
    'BP INDIA PRIVATE LIMITED',
    'Madison xurpas mobile services private limited',
    'Mmc communications centre private limited',
    'M & P CLEARING & FORWARDING AGENCIES PRIVATE LIMITED',
    'Quadrile management services private limited',
    'Ask financial holdings private limited',
    'Kyoorius communications private limited',
    'Interskale digital marketing and consulting private limited',
    'Sahara q shop unique products range limited',
    'Benu power private limited',
    'Security brigade infosec private limited',
    'Stat media private limited',
    'FUTUREMAHARASHTRA BUSINESS SUPPORT PRIVATE LIMITED',
    'Supriya medi-chem private limited',
    'Forestry innovation consulting india private limited',
    'AKSH COMPOSITES PRIVATE LIMITED',
    'Commodity alpha private limited',
    'Frn engineers and constructors private limited',
    'Partners group (india) private limited',
    'Iec motor services private limited',
    'Nsk india automation private limited',
    'Ideosphere consulting private limited',
    'Niveza india private limited',
    'FINNOVATORS SERVICES PRIVATE LIMITED',
    'Ricom technologies private limited',
    'Talentbeacon hr solutions private limited',
    'Forum business research private limited',
    'Vencap holdings private limited',
    'C.sitaraman & co. private limited',
    'Sisper vending (india) private limited',
    'RAMCO INDUSTRIAL AND TECHNOLOGY SERVICESLIMITED',
    'Enviro care india private limited',
    'Uniq detective and security services (tamilnadu) private limited',
    'Maxires training & consulting private limited',
    'Tricolor marketing solutions private limited',
    'Crystal hr and security solutions private limited',
    'Triplem techno solutions private limited',
    'SASHMA GLOBAL PRIVATE LIMITED',
    'E5 entertainments india private limited',
    'Pio hr solutions private limited',
    'Touche public relations private limited',
    'Glency docmra consultants india private limited',
    'Sanjeevani insurance brokers private limited',
    'Airan entertainments private limited',
    'Sonotel hospitality private limited',
    'Lemon car rentals private limited',
    'Tring infrastructure safety support systems private limited',
    'Lanchestter academy private limited',
    'E-logosoft solutions private limited',
    'Sri guru shishya academy private limited',
    'Drishtee skill development center private limited',
    'Sagar academic consultants private limited',
    'Geetanjali effective realty solutions private limited',
    'APEX KNOWLEDGE CONSORTIUM LIMITED',
    'Greenwoods sparking education private limited',
    'Ebenezer centre for higher education private limited',
    'Arbrit safety and engineering solutions private limited',
    'NET EDUCATION ENTREPRENEURSHIP AND LEADERSHIP LIMITED',
    'Sri guruji art academy private limited',
    'Aliff overseas private limited',
    'Kpc learning india',
    'Indian institute of gems & jewellery delhi',
    'Santamonica study abroad private limited',
    'Tasaa software services private limited',
    'Rais institute of management studies private limited',
    'Multiversity private limited',
    'Career shapers (india) private limited',
    'Svs educational services private limited',
    'Chrysalid outdoor learning centres india private limited',
    'Cryogenic engineers private limited',
    'Gordon woodroffe logistics limited',
    'Tema india limited',
    'Safex fire services limited',
    'Nec fire equipments private limited',
    'Maks automation private limited',
    'Samvardhana motherson virtual analysis limited',
    'Matsui technologies india limited',
    'Eo technics india private limited',
    'Nivelco instruments india private limited',
    'Sai-raj automation & controls private limited',
    'Sales & project engineering co private limited',
    'Wesmec engineering private limited',
    'Spacerak equipments private limited',
    'Apt tools & machinery india private limited',
    'Suntec agri equipments (india) private limited',
    'M.b.farm machinery private limited',
    'Automat industries private limited',
    'Rlard engitech private limited',
    'Bhukhanvala holdings private limited',
    'Edicon pneumatic tool company private limited',
    'Hahn+kolb tools private limited',
    'Ww wire die (india) private limited',
    'Unison machinery private limited',
    'Everex safetech industries private limited',
    'Vermeer laundry innovations india private limited',
    'Dynatek heavy equipment private limited',
    'Ezydrill equipment private limited',
    'NACHI PRECISION TOOL INDIA PRIVATE LIMITED',
    'Ojus power & technologies private limited',
    'Champion abrasives india private limited',
    'Sedemac mechatronics private limited',
    'Shahani entrepreneurs limited',
    'BECK & POLLITZER INDIA PRIVATE LIMITED',
    'Sbsenviro aqua concepts private limited',
    'TIJARE ENGINEERS & CONSULTANTS PRIVATE LIMITED',
    'Airtech machines and tools (india) private limited',
    'Mdl-vishal india private limited',
    'Jeevika food machine private limited',
    'Gmv engineering private limited',
    'Snap-on tools private limited',
    'Ragam metal products private limited',
    'Hydrofiltsep technologies private limited',
    'PRATHISHTA WEAVING AND KNITTING COMPANY PRIVATE LIMITED',
    'Kamdar pumps private limited',
    'Friends engineering industries private limited',
    'Rokade rotek india private limited',
    'Simta clear coats private limited',
    'MITSUBISHI POWER INDIA PRIVATE LIMITED',
    'Flowwell castings private limited',
    'Lnv technology private limited',
    'ANEST IWATA MOTHERSON COATING EQUIPMENT PRIVATE LIMITED',
    'Astri sales and services private limited',
    'Jaysen engineering private limited',
    'Bodygear international private limited',
    'Light logics holography and optics private limited',
    'Clean air projects (india) private limited',
    'Kunal enviro systems private limited',
    'Subtronics (india) private limited',
    'R and s (india) electronics private limited',
    'Techedge air engineering private limited',
    'Motion technique (india) private limited',
    'Chintamani thermal technologies private limited',
    'Ionisation filtration industries private limited',
    'Iqs engineering private limited',
    'Neologic engineers private limited',
    'Cynergy3 auro technologies private limited',
    'ENSOL MULTICLEAN EQUIPMENTS PRIVATE LIMITED',
    'Gotoinc planetarium private limited',
    'Akshara ecotech private limited',
    'Shan solar private limited',
    'M.r.organisation limited',
    'Sun capacitors (pune) private limited',
    'Bagh bahar appliances private limited',
    'Vrv energies india private limited',
    'Medha vision pvt.ltd.',
    'Hi tech software private limited',
    'Aarya technocrats private limited',
    'Three d micro systems private limited',
    'Gorge computers private limited',
    'Mosad infoways private limited',
    'Office shop private limited',
    'Kanasu computers and accessories private limited',
    'Versatile card technology private limited',
    'JKV SOLUTIONS LIMITED',
    'Astron infocomm private limited',
    'Esquare energy equipments private limited',
    'Aarvee infotech private limited',
    'Karan solutions private limited',
    'RANJEET MECHATRONICS LIMITED',
    'Nethra electricals (india) private limited',
    'Lm wind power blades (india) private limited',
    'Excel generators private limited',
    'It power consulting private limited',
    'MARSONS ENERGY PRIVATE LIMITED',
    'NYL ELECTRIC PRIVATE LIMITED',
    'C systems private limited',
    'Multitech components private limited',
    'Ernard enterprises private limited',
    'OM LEISURE HOLIDAYS PRIVATE LIMITED',
    'Srp logistics private limited',
    'Balika tours & travels private limited',
    'Mpm travel xs private limited',
    'J.r.a. travel service private limited',
    'Grand royale enterprises limited',
    'Phoennix freight services private limited',
    'Idrive infoservices private limited',
    'Ultimate travel solutions private limited',
    'Bengal logistics private limited',
    'Tri international limited',
    'Motherson lease solution limited',
    'Excel logisolutions private limited',
    'Empezar clearing agency private limited',
    'Avm logistics private limited',
    'Srv global freight private limited',
    'Unique voyages private limited',
    'Atlas movers private limited',
    'Trans assist india private limited',
    'Freight ag private limited',
    'Cana warehousing and supply solutions private limited',
    'Rajesh clearing and forwarding private limited',
    'Reshamwala ship brokers private limited',
    'Hermes freight private limited',
    'P.v.agencies freight forwarders private limited',
    'Global logistics solutions india private limited',
    'Macy services private limited',
    'Willfield logistics private limited',
    'Protocol marine services private limited',
    'Radar estates private limited',
    'Toga logistics private limited',
    'FLOMIC CARGO PRIVATE LIMITED',
    'GMS SUPPLY CHAIN INDIA PRIVATE LIMITED',
    'Skl shipping and logistics private limited',
    'Trans universal logistics (i) private limited',
    'Indo arabian shipping lines (india) private limited',
    'TRAVEL ELECT INDIA PRIVATE LIMITED',
    'Jesal tours and travels private limited',
    'SKYLINE SHIPPING & LOGISTICS PRIVATE LIMITED',
    'Chakra integrated logistics private limited',
    'Sunbeam logistics private limited',
    'Kaushik global logistics limited',
    'Knowlarity communications private limited',
    'Unique airfreight express and logistics private limited',
    'Arya omnitalk radio trunking services private limited',
    'Reliance natural resources limited',
    'Teleindia networks private limited',
    'Fastway transmissions private limited',
    'Verizon communications india private limited',
    'Objectorb technologies private limited',
    'Northeast dataa network private limited',
    'Datascript solutions india private limited',
    'Intai technology private limited',
    'JINGA DALA SHOPPING PRIVATE LIMITED',
    'Synaptic integrated telecommunication services private limited',
    'Gtpl v & s cable private limited',
    'Video source studios private limited',
    'Aspire capital private limited',
    'Mirae asset trustee company private limited',
    'Diggi multitrade limited',
    'Aishwarya investments and realty private limited',
    'Tattva holdings private limited',
    'Tanti holdings private limited',
    'Home credit india finance private limited',
    'Lotus derivatives and comtrade private limited',
    'Geo vpl finance private limited',
    'Sumu finvest private limited',
    'Navkar finlease private limited',
    'Neelam management consultants private limited',
    'Sirius transport and construction private limited',
    'Thakkar financial services pvt ltd',
    'ALPHA ALTERNATIVES FINANCIAL SERVICES PRIVATE LIMITED',
    'Securia capital advisors private limited',
    'Modipon estates private limited',
    'DATT CAPITAL SERVICES Private Limited',
    'Anoli holdings private limited',
    'Ramgopal investment and trading company private limited',
    'Entermonde investments pvt ltd',
    'Protiz technologies private limited',
    'Duram pharmachem private limited',
    'Chainsons investments and finance private limited',
    'BLUECHIP CORPORATE INVESTMENT CENTRE PRIVATE LIMITED',
    'Kp finserv private limited',
    'Samunnati financial intermediation & services private limited',
    'White collar venture capital fund limited',
    'Iifcl asset management company limited',
    '29k investment advisers private limited',
    'Viswapriya (india) limited',
    'Status mark finvest limited',
    'Highline india kuries private limited',
    'CORNERSTONE INDUSTRIAL PARKS PRIVATE LIMITED',
    'Jrs investments private limited',
    'Mirae asset global investments (india) private limited',
    'Nine east holding private limited',
    'Navia markets limited',
    'MODIMANGAL ESTATES PRIVATE LIMITED',
    'Anr international private limited',
    'Sbp steel company private limited',
    'TRANSOCEANIC AGRO COMM PRIVATE LIMITED',
    'Infotech standards india private limited',
    'Alkali manufacturers association of india(transfer company from maharashtra to',
    'Motherson air travel agencies limited',
    'American express(india) private limited',
    'Naka michi techno private limited',
    'Dolphin business consultants private limited',
    'Niche credit and capital services private limited',
    'Ion software solutions private limited',
    'Bharti hexacom limited',
    'Jfc finance (india) limited',
    'Smr automotive systems india limited',
    'Duggar power products private limited',
    'Jeet associates private limited',
    'Vinpak projects and marketing private limited',
    'Jindal lamps private limited',
    'Bt (india) private limited',
    'VALEO MOTHERSON THERMAL COMMERCIAL VEHICLES INDIA LIMITED',
    'Motherson auto solutions limited',
    'Diamond international inex private limited',
    'SKYHI GLOBAL TRAVELS PRIVATE LIMITED',
    'Tivoli institute of hospitality management private limited',
    'Ikm investors private limited',
    'Cnb finwiz private limited',
    'Paschal form work (india) private limited',
    'Caritas eco systems private limited',
    'Shikha packaging (india) private limited',
    'Kaleidoscope technologies private limited',
    'ROADZEN ASSISTANCE INDIA PRIVATE LIMITED',
    'ICEMAX UNIVERSAL PRIVATE LIMITED',
    'Envoy technosys private limited',
    'SAFRAN ELECTRONICS & DEFENSE SERVICES INDIA PRIVATE LIMITED',
    'Megacare hospimed services private limited',
    'Chariot productions media private limited',
    'Fabrizio industries private limited',
    'VODAFONE IDEA BUSINESS SERVICES LIMITED',
    'Ziptel it solutions private limited',
    'NACHI TECHNOLOGY INDIA PRIVATE LIMITED',
    'Olivetree management consultants private limited',
    'Copyright integrity advisory (india) private limited',
    'Peoplenet access solutions private limited',
    'Redseer management consulting private limited',
    'Vex india securitas private limited',
    'Maruti futuristic pharma private limited',
    'HOST INDIA EVENTS & MARKETING PRIVATE LIMITED',
    'Nova pulse ivf clinic private limited',
    'Yethi medical systems private limited',
    'Nallu outsourcing services private limited',
    'Orchid consultancy services private limited',
    'SPATIUM ENGINEERING & MANAGEMENT SERVICES PRIVATE LIMITED',
    'Tagos design innovations private limited',
    'WORKFORCE TEMP LIMITED',
    'United nanotech innovations private limited',
    'Thermochem corporation private limited',
    'Omix research and diagnostics laboratories private limited',
    'Techmatiks engineering private limited',
    'Indvest ventures private limited',
    'Legatax info private limited',
    'Insync analytics (india) private limited',
    'LUMITIS GREEN TECHNOLOGIES PRIVATE LIMITED',
    'Aqua management consulting group private limited',
    'Orionis automotive private limited',
    'Relogix distribution private limited',
    'Connectcarindia.com private limited',
    'Svm international private limited',
    'Magic special purpose machineries private limited',
    'K. d. supply chain solutions private limited',
    'Maiia commodity management private limited',
    'Immense india holidays private limited',
    'Sotax india private limited',
    'Autocreate wheels private limited',
    'Ather energy private limited',
    'Drake & scull water & energy india private limited',
    'Adora energy private limited',
    'VENA ENERGY MH WIND POWER PRIVATE LIMITED',
    'Roofco power projects private limited',
    'Kalinga power corporation private limited',
    'ULTRA MEGA POWER PRIVATE LIMITED',
    'KGEPL ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'Regen o&m services limited',
    'Star boilers private limited',
    'KRYFS Transformers Private Limited',
    'VENA ENERGY POWER RESOURCES PRIVATE LIMITED',
    'Lanco babandh power limited',
    'Raasi solar energy private limited',
    'Nesco wincon private limited',
    'Dandu energy private limited',
    'Suryachakra energy (chattisgarh) private limited',
    'Suryachakra thermal (madhya pradesh) private limited',
    'Madurai power corporation private limited',
    'Spi power operations private limited',
    'Azure power (gujrat) private limited',
    'Oorja on move infra private limited',
    'BF INDUSTRIAL SOLUTIONS LIMITED',
    'Bhanu solar projects private limited',
    'Contura solar (india) private limited',
    'Raasi green earth energy private limited',
    'SAMTA ENERGY PRIVATE LIMITED',
    'VENA ENERGY PATAN POWER PRIVATE LIMITED',
    'Essel urja private limited',
    'Avv turbines private limited',
    'Three sixty energy private limited',
    'Ananth infra projects limited',
    'National energy trading and services limited',
    'Lanco teesta hydro power limited',
    'Avior power private limited',
    'STARGATE PROJECTS PRIVATE LIMITED',
    'Lanco solar energy private limited',
    'Greatshine holdings private limited',
    'Archer power systems private limited',
    'MACWELL AUTO ENGINEERING PRIVATE LIMITED',
    'Three sixty power products private limited',
    'Rakhvi infracon private limited',
    'Infinium urja private limited',
    'Anushakti vidhyut nigam limited',
    'Sea biscuit energy solutions private limited',
    'Solwin power private limited',
    'Nakshathra wind power private limited',
    'Hero green energy private limited',
    'Oxytona technologies india private limited',
    'A.o.f. filtration systems private limited',
    'Eco protection engineers private limited',
    'Tata industries limited',
    'Construction technique (india) private limited',
    'Mrc infrastructure private limited',
    'Sree vaishnavi infrastructures private limited',
    'Virgin constructions private limited',
    'Premier road service limited',
    'HEAT TRAVELS & TOURS (INDIA) PRIVATE LIMITED',
    'Travenue tour & travels private limited',
    'Attune tour & travel private limited',
    'Arkaaye agrotech & cold storage private limited',
    'Tny holidays private limited',
    'Inlogsys techno private limited',
    'Boston matrix logistics private limited',
    'GAC SHIPPING (INDIA) PRIVATE LIMITED',
    'Davada shipping agencies private limited',
    'Depe global shipping agencies pvt ltd',
    'Saigal seatrade private limited',
    'Rical logistics private limited',
    'Bhoruka logistics private limited',
    'Nagarkot logistics private limited',
    'Prashant cargo forwarders india private limited',
    'Pmp logistics private limited',
    'Speedex freight systems private limited',
    'Atharva freightline private limited',
    'IFX FREIGHT & LOGISTICS PRIVATE LIMITED',
    'ENTIRE TOURS & TRAVELS PRIVATE LIMITED',
    'South carrying logistics private limited',
    'Rpil signalling systems limited',
    'Seaport logistics private limited',
    'Glow freight logistics p ltd',
    'Connect cargo private limited',
    'BLISS LOGISTICS & SHIPPING PRIVATE LIMITED',
    'Usha cabs private limited',
    'Federal distribution and management private limited',
    'Road cargo movers pvt ltd',
    'SHREE NANDAN COURIER LIMITED',
    'Vega cargo and logistics private limited',
    'Advantal technologies private limited',
    'Fidelis telecom private limited',
    'Planet entertainment private limited',
    'Appsdaily solutions private limited',
    'Energicomm wires private limited',
    'Prapoorna enterprise private limited',
    'JISNU COMMUNICATIONS PRIVATE LIMITED',
    'AT&T GLOBAL BUSINESS SERVICES INDIA PRIVATE LIMITED',
    'Kalyx networks private limited',
    'Skylux telelink private limited',
    'Mukand systems and networking private limited',
    'Singapore telecom india private limited',
    'Asergis telecom services private limited',
    'Space cellular private limited',
    'Cbd tower private limited',
    'Citius securities private limited',
    'Kotak mahindra investments limited',
    'BANK OF INDIA INVESTMENT MANAGERS PRIVATE LIMITED',
    'Creditmantri finserve private limited',
    'IKF HOME FINANCE LIMITED',
    'Polad finance ltd',
    'South gujarat shares and sharebrokers limited',
    'Pragya investments pvt ltd',
    'Arvind motors investmentsandleasing private limited',
    'Kerala state power and infrastructure finance corporation limited',
    'KOTAK COMMODITY SERVICES Private Limited',
    'Sbi dfhi limited',
    'Brite coatings private limited',
    'Right treasure finance and leasing (india) private limited',
    'Nms holdings private limited',
    'Glutaric real estates private limited',
    'Double ess estates private limited',
    'Balaji infra projects ltd',
    'Nahar credits private limited',
    'AF FINANCIAL DISTRIBUTION PRIVATE LIMITED',
    'Ameya perfomatt finserv private limited',
    'Hedge finance limited',
    'Birla financial corporation limited',
    'KEDIA CAPITAL SERVICES PRIVATE LIMITED',
    'Modesty finance and investments private limited',
    'Mondalis consulting private limited',
    'Rajesh sanghi auto traders private limited',
    'Anemone management consultancy services private limited',
    'Ushma investments pvt ltd',
    'Fulchand finance private limited',
    'Asit c mehta investment interrmediates ltd',
    'Capstone investment company private limited',
    'ADITMITT CONSULTANTS PRIVATE LIMITED',
    'JARO FINCAP PRIVATE LIMITED',
    'Better equity services private limited',
    'Shirish development and investment private limited',
    'Amber stockinvests private limited',
    'DARTSTOCK BROKING PRIVATE LIMITED',
    'Infinity technology trustee private limited',
    'Pandiyan meena investments private limited',
    'Sincerely your chits private limited',
    'New general kuries (wadakkanchery) private limited',
    'Saraca chit fund pvt ltd',
    'Srivatshava chits private limited',
    'Top light chit funds private limited',
    'Prevail investment casting private limited',
    'Bkhim investments & holdings private limited',
    'STARSHINE COMTRADE PRIVATE LIMITED',
    'G r n finsec private limited',
    'CENTRUM WEALTH LIMITED',
    'Kanika investment limited',
    'J investments private limited',
    'Dugar finance and investments limited',
    'Allied investments and housing private limited',
    'Sai ganga panakeia private limited',
    'CALIN GLOBAL SERVICES INDIA PRIVATE LIMITED',
    'Public affairs foundation',
    'Iimb innovations',
    'First global commodities private limited',
    'Metis financial accounting outsourcing private limited',
    'Maa ambey hospitality private limited',
    'Prime support & services private limited',
    'AHLSTROM FIBERCOMPOSITES INDIA PRIVATE LIMITED',
    'Cliniexperts services private limited',
    'Labh services private limited',
    'Vibrant designs private limited',
    'Purnima enterprises private limited',
    'GUITCOM CONSULTING PRIVATE LIMITED',
    'Greyapple advertising services private limited',
    'Nu special solutions private limited',
    'Trace vfx solutions india private limited',
    'STUDIO BRIO PRIVATE LIMITED',
    'Technovation healthcare private limited',
    'Ngn telecom private limited',
    'Gherzi consulting engineers private limited',
    'Genescience lifecare (india) private limited',
    'Seven hills media private limited',
    'Aeon consulting engineers private limited',
    'Streamon technologies private limited',
    'Delta total facilities private limited',
    'Herbs-n-spices agro food private limited',
    'Stellar marine foods private limited',
    'Pantson pharma private limited',
    'Unitop mav technologies private limited',
    'Surgicare medical center private limited',
    'Pharma access private limited',
    'U3s chemsolutions private limited',
    'Digitales pr medios private limited',
    'Strugence holdings private limited',
    'White mavens media private limited',
    'ZIKZUK TECHNOLOGIES PRIVATE LIMITED',
    'Educare infrastructure services private limited',
    'Ahilia marketing consulting private limited',
    'Ormax consultants private limited',
    'ESRI INDIA TECHNOLOGIES PRIVATE LIMITED',
    'Rj singh advisors private limited',
    'Eshri consultants private limited',
    'Tkw management solutions private limited',
    'ARCONIC OF INDIA PRIVATE LIMITED',
    'Cbb consulting (india) private limited',
    'Redan geomatics private limited',
    'Ddf consultants private limited',
    'Oasis resource management private limited',
    'Ij kakehashi services private limited',
    'Wbm health science private limited',
    'Kiosk infosolutions private limited',
    'Richpurple interactive private limited',
    'Eos capital advisors private limited',
    'E2e research services private limited',
    'Avenir management consulting india private limited',
    'High tide corps private limited',
    'European care india private limited',
    'Hps airconditioning private limited',
    'Lrs services private limited',
    'Sab softech (india) private limited',
    'Possible business solutions private limited',
    'Day star enviro technologies private limited',
    'Progressive corporate services private limited',
    'Akar info-media private limited',
    'Park - well private limited',
    'Rja consulting private limited',
    'Chartered business services private limited',
    'Avasiti design consultancy private limited',
    'Miracle hr solution private limited',
    'Luxury hues consultancy services (india) private limited',
    'Gottlob schuler project and site management private limited',
    'TOSHNIWAL BROTHERS (SR) PRIVATE LIMITED',
    'Tide technocrats private limited',
    'Sanky technical consulting private limited',
    'Mahiti infotech private limited',
    'MANIPAL EDUCATION AND MEDICAL GROUP INDIA PRIVATE LIMITED',
    'Murray culshaw consulting private limited',
    'Organisations and alternatives consulting private limited',
    'Basil communications private limited',
    'Sri. upasana management consultants private limited',
    'Analyticsquotient services india private limited',
    'Mxv consulting private limited',
    'Pharmagenica healthcare private limited',
    'Renalyx health systems private limited',
    'MUZANIA CREATIVE VENTURES PRIVATE LIMITED',
    'Mpowerhunt consulting private limited',
    'Baseindia consultants private limited',
    'Resource hunters hr private limited',
    'ARTIS M&C ADVISORY PRIVATE LIMITED',
    'Asian educational consultancy private limited',
    'ELINA REALTY PRIVATE LIMITED',
    'Equitech knowledgebase private limited',
    'K r corporate consultants private limited',
    'Siddhartha logistics company private limited',
    'Infinity trust investments private limited',
    'Finquest financial solutions private limited',
    'Spencer stuart(india) pvt ltd',
    'GLOBAL POWERSOURCE (INDIA) PRIVATE LIMITED',
    'Sagacious financial services private limited',
    'Limtex (india) ltd',
    'Khyber agro farms private limited',
    'INDIAN TROPICAL AGRO PRODUCTS PRIVATE LIMITED',
    'Jain spices and agro products india private limited',
    'SATIIJA FARMS PRIVATE LIMITED',
    'Taap-maan ice and cold storage private limited',
    'Vileena emu processing private limited',
    'Junga floriculture private limited',
    'Icsa agro private limited',
    'Himani agro industries private limited',
    'Madhuvan space management private limited',
    'Tene agricultural solutions private limited',
    'Centura agro private limited',
    'Noveltech agro private limited',
    'Fame agro private limited',
    'Rocky farms private limited',
    'Shree ramdeoji farms private limited',
    'La trident private limited',
    'SANGUINE GENETICS PRIVATE LIMITED',
    'Eden plantation resort private limited',
    'Genetwister biotech private limited',
    'SUYOG AGRITECH & ENGINEERING LIMITED',
    'Tuberose farms and properties private limited',
    'Univeg seed technologies private limited',
    'MAHINDRA AGRI SOLUTIONS LIMITED',
    'NILGIRIS GARDEN & SERVICES PRIVATE LIMITED',
    'Debgiri agro products private limited',
    'Maheshwari rocks (india) private limited',
    'Bright agrotech private limited',
    'Favorich mark private limited',
    'British nutritions private limited',
    'House of ramapuram - foods private limited',
    'Prakriti green (india) private limited',
    'Shree laxmi teakwood private limited',
    'Pepino farms private limited',
    'Spectro ductile iron private limited',
    'Ultimate alloys private limited',
    'Uni-tech cnc centre private limited',
    'Barna hydro projects pvt.ltd.',
    'Fishmart retail india private limited',
    'Taipan sea foods limited',
    'Kishore kumar and company(exports) private limited',
    'Karunya marine products private limited',
    'Sas precision engineering private limited',
    'BELSTAR MICROFINANCE LIMITED',
    'Divyasree holdings private limited',
    'Tejasri developers private limited',
    'Akshay environce private limited',
    'Global coal ventures private limited',
    'Iris technopark private limited',
    'NAITHANI OIL & GAS SERVICES PRIVATE LIMITED',
    'Coastal andhra power infrastructure limited',
    'Reliance prima limited',
    'Suvira-kms seismics private limited',
    'Atos mercantile private limited',
    'Qa hydrocarbons private limited',
    'Its india private limited',
    'Ashapura mine explore private limited',
    'Sibro steels & minerals private limited',
    'GYPSUM COMMERCE INDIA PRIVATE LIMITED',
    'Bhoruka Mines Private Limited',
    'Indian mining works private limited',
    'Bullows india private limited',
    'DEEPAK MINING SOLUTIONS LIMITED',
    'Shilp marble carvings company private limited',
    'B t mining private limited',
    'Ashirwad marbles private limited',
    'SHREE RISHABH STONES PRIVATE LIMITED',
    'P p granites private limited',
    'BHARATHI ROCK PRODUCTS (INDIA) PRIVATE LIMITED',
    'Sri manjunatha stones private limited',
    'Ei holiday resort private limited',
    'Padam minerals private limited',
    'Thiess minecs india private limited',
    'Naren rocks and mines private limited',
    'Shri bhartia pulverisers private limited',
    'Jkp microminerals (india) private limited',
    'Ashapura overseas private limited',
    'C',
    'S AYURCEUTICALS PRIVATE LIMITED',
    'TOKENFOLIO SERVICES PRIVATE LIMITED',
    'LACHURA SOLAR PRIVATE LIMITED',
    'SOTERIA SOLUTIONS PRIVATE LIMITED',
    'PARAS GREEN OPTICS PRIVATE LIMITED',
    'IABT FOUNDATION',
    'MDV SOFTECH PRIVATE LIMITED',
    'PIXIELANES INDIA PRIVATE LIMITED',
    'LDG SOLUTIONS PRIVATE LIMITED',
    'AGVEST TECHNOLOGIES PRIVATE LIMITED',
    'LOG-TRAN-INN SOLUTIONS PRIVATE LIMITED',
    'RIZEE FOODS PRIVATE LIMITED',
    'AFLEO LEGALTECH PRIVATE LIMITED',
    'ESWN TRAVELS SOLUTIONS PRIVATE LIMITED',
    'KIRIK CAPITAL PRIVATE LIMITED',
    'FLYNANCE SERVICES PRIVATE LIMITED',
    'GVWALA TECH PRIVATE LIMITED',
    'PENSANDO SYSTEMS INDIA PRIVATE LIMITED',
    'ADANI RENEWABLE ENERGY HOLDING SEVENTEEN LIMITED',
    'PARIKATHA DESIGN STUDIO PRIVATE LIMITED',
    'TECHVEDA RESOURCES PRIVATE LIMITED',
    'ACME MEDIA CREATIONS PRIVATE LIMITED',
    '5PAISA CORPORATE SERVICES LIMITED',
    'AAC NATURAL PRODUCTS PRIVATE LIMITED',
    'WOODCREEK INVESTMENT ADVISORS PRIVATE LIMITED',
    'FLOLOGIC AUTOMATION PRIVATE LIMITED',
    'TNGONE SOFTWARE LABS PRIVATE LIMITED',
    'UPBRINGY.AI PRIVATE LIMITED',
    'WELKINRIM TECHNOLOGIES PRIVATE LIMITED',
    'ASHVITA RESTAURANTS PRIVATE LIMITED',
    'CHAINLOGIX INDIA PRIVATE LIMITED',
    'FAMEPILOT INTERNET PRIVATE LIMITED',
    'AMBIANCE AIR HOSTESS INSTITUTE PRIVATE LIMITED',
    'BOLT-ON GLOBAL SOLUTIONS & SERVICES PRIVATE LIMITED',
    'HOMEBRICKS CONSTRUCTION PRIVATE LIMITED',
    'OROGLMR JEWELRY INDIA PRIVATE LIMITED',
    'VYN AUTOMATION PRIVATE LIMITED',
    'INSPIREIT NETWORK SOLUTIONS PRIVATE LIMITED',
    'WESTERN COFFEE CURERS & EXPORTS PRIVATE LIMITED',
    'ESQUIRE EXPRESSECOM PRIVATE LIMITED',
    'HPCL-MITTAL FOUNDATION',
    'SGAG MANUFACTURING PRIVATE LIMITED',
    'UDUPI KASARGODE TRANSMISSION LIMITED',
    'LRK GEOTECH PRIVATE LIMITED',
    'SGAG CONSTRUCTION INDUSTRIES PRIVATE LIMITED',
    'LIGHTSTORM TELECOM VENTURES PRIVATE LIMITED',
    'CAN ENDS PACKAGING PRIVATE LIMITED',
    'LISTENLIGHTS PRIVATE LIMITED',
    'HIGMAN HOLIDAYS PRIVATE LIMITED',
    'TIMES OF MEDIA PRIVATE LIMITED',
    'BULBULSHOP SHOPPING NETWORK PRIVATE LIMITED',
    'COSMOTECH COMMUNICATION PRIVATE LIMITED',
    'AFRITECH IT CONSULTING PRIVATE LIMITED',
    'RIMS BIZZSERVE PRIVATE LIMITED',
    'RIZMET INTERNATIONAL PRIVATE LIMITED',
    'PRIYANK URBAN LIGHTES PRIVATE LIMITED',
    'INSIFE INDIA PRIVATE LIMITED',
    'HARLEYS INDUSTRIES PRIVATE LIMITED',
    'RS COFFEES PRIVATE LIMITED',
    'FUTURESWIFT TECHNOLOGIES PRIVATE LIMITED',
    'NSURETECH SOLUTIONS PRIVATE LIMITED',
    'ZAASNA PROPTECH PRIVATE LIMITED',
    'OPZLAB TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'SABGROUP FOODS PRIVATE LIMITED',
    'SHARP PENCIL PRODUCTIONS PRIVATE LIMITED',
    'PURVRAJ AGRO INDUSTRIES PRIVATE LIMITED',
    'FABRECA INFRA PRIVATE LIMITED',
    'MONASH FINSERVE & TECH PRIVATE LIMITED',
    'DUMPBOX FOOD INDUSTRY PRIVATE LIMITED',
    'UNITHOS BUSINESS ADVISORS PRIVATE LIMITED',
    'ORNELLA ENTERPRISES PRIVATE LIMITED',
    'ANDHRA PRADESH DIGITAL CORPORATION LIMITED',
    'PAMIDIGHANTAM INFRASTRUCTURE PRIVATE LIMITED',
    'COINTRIBE CAPITAL PRIVATE LIMITED',
    'LORHAN IT SERVICES PRIVATE LIMITED',
    'APSIS HEALTHCARE PRIVATE LIMITED',
    'COLOSSAL INTEGRATED FACILITIES SERVICES PRIVATE LIMITED',
    'SGAG SUPERSTRUCTURES PRIVATE LIMITED',
    'PLATINUMCORP REALTY HUB PRIVATE LIMITED',
    'PLATINUMCORP REALTY DEVELOPERS PRIVATE LIMITED',
    'LIKPIN INDIA PRIVATE LIMITED',
    'ROHIT BAL FOUNDATION',
    'VELOURS NIRMAN PRIVATE LIMITED',
    'MYRV SOLUTIONS (OPC) PRIVATE LIMITED',
    'RED MOKI INDIA PRIVATE LIMITED',
    'MILLENNIUM ONCOLOGY INDIA PRIVATE LIMITED',
    'INOVORA INFOSOL PRIVATE LIMITED',
    'WISDOMLOGIX SOLUTIONS PRIVATE LIMITED',
    'CANTONA INDUSTRIES PRIVATE LIMITED',
    'AMANTYA TECHNOLOGIES PRIVATE LIMITED',
    'BEESLEY CONSULTANCY PRIVATE LIMITED',
    'LOOQUS MEDIA PRIVATE LIMITED',
    'HPOIL GAS PRIVATE LIMITED',
    'GAYTRI FLOW SYSTEMS PRIVATE LIMITED',
    'GREENFIELD ADVENTURE SPORTS PRIVATE LIMITED',
    'QAPTIVE TECHNOLOGIES PRIVATE LIMITED',
    'AKRK TECHNOLOGIES PRIVATE LIMITED',
    'FOTIN HIDROFIX INDIA MANUFACTURING PRIVATE LIMITED',
    'INDOSING DISTRIBUTION PRIVATE LIMITED',
    'SHRIBALAJI INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'NCLOSURE & CONTROLS PRIVATE LIMITED',
    'EVINCE TRADING PRIVATE LIMITED',
    'SHERISHA SOLAR SPV TWO PRIVATE LIMITED',
    'VARCAS AUTOMOBILES PRIVATE LIMITED',
    'NETTLE HOTELS PRIVATE LIMITED',
    'HINJEWADI IT PARK PRIVATE LIMITED',
    'ECX SOLUTIONS PRIVATE LIMITED',
    'CHOOZEE LIFE PRIVATE LIMITED',
    'TRUVIC PROJECTS PRIVATE LIMITED',
    'ALETHE AUTOTECH PRIVATE LIMITED',
    'US AQUATREAT PRIVATE LIMITED',
    'NE OILFIELD SERVICES PRIVATE LIMITED',
    'NETON NEXT ERA COMMUNICATIONS PRIVATE LIMITED',
    'MS ATOZ MAKE HOUSE EASY PRIVATE LIMITED',
    'THINKITIVE TECHNOLOGIES PRIVATE LIMITED',
    'SUN&PEARLS IT SOLUTIONS PRIVATE LIMITED',
    'VOLANZO CARS PRIVATE LIMITED',
    'INTEONES MERCADO PRIVATE LIMITED',
    'TORAMBE SANJIVANI TECHNOLOGY LIMITED',
    'FUTURISTIC SKILLVILLE PRIVATE LIMITED',
    'SKANAI LABS PRIVATE LIMITED',
    'DRAKE MED-TECH PRIVATE LIMITED',
    'MULTIPRENE INTERNATIONALS PRIVATE LIMITED',
    'THINK GAS LUDHIANA PRIVATE LIMITED',
    'NOVEL STRUCTURAL DEVELOPERS PRIVATE LIMITED',
    'TECKMOVERS SOLUTIONS PRIVATE LIMITED',
    'INJA ROBOTICS AND AUTOMATION PRIVATE LIMITED',
    'VASHI ELECTRICALS AND AS BEARING PRIVATELIMITED',
    'SBSC INDIA PRIVATE LIMITED',
    'MAIZ HOSPITALITY PRIVATE LIMITED',
    'INDIAXIS PROPERTIES PRIVATE LIMITED',
    'FANMOJO GAMING PRIVATE LIMITED',
    'GWAMBO STUDIOS PRIVATE LIMITED',
    'SARVAGRAM FINCARE PRIVATE LIMITED',
    'FUNLIKE TECH INDIA PRIVATE LIMITED',
    'HUNGRYFI HOSPITALITY PRIVATE LIMITED',
    'BRIDGING MINDS INTERNATIONAL EDUCATION &IMMIGRATION (OPC) PRIVATE LIMITED',
    'BRANDSTREET INTEGRATED COMMUNICATION NETWORK PRIVATE LIMITED',
    'BEASTNUDGE GLOBAL PRIVATE LIMITED',
    'INNOBLES SMART TECHNOLOGIES PRIVATE LIMITED',
    'BLIV SPACES PRIVATE LIMITED',
    'HOTEL AJU PALACE PRIVATE LIMITED',
    'BEREICHERN HELPLINE INDIA PRIVATE LIMITED',
    'BLUEPEN LABORATORIES PRIVATE LIMITED',
    'DAYLAND INFRASTRUCTURE PRIVATE LIMITED',
    'BIZOLUTION TECHNOLOGIES PRIVATE LIMITED',
    'ZORYBOARD SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CORSIS TECHNOLOGIES PRIVATE LIMITED',
    'FORTUM CHARGE & DRIVE INDIA PRIVATE LIMITED',
    'MARASANDRA LOGISTICS AND INDUSTRIAL PARKS PRIVATE LIMITED',
    'INDEEP ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'REVAMP24 EDU PRIVATE LIMITED',
    'SAARA CONFAB PRIVATE LIMITED',
    'GRAHAM INDIA PRIVATE LIMITED',
    'ENS ASSOCIATES PRIVATE LIMITED',
    'DEEPALGO TECHNOLOGIES PRIVATE LIMITED',
    'RIOLOG SHIPPING SERVICES (INDIA) PRIVATELIMITED',
    'ACET MIGRATION SERVICES PRIVATE LIMITED',
    'RAJ PATH INFRACON PN 42 PRIVATE LIMITED',
    'LEFTFIELD CREATIVE PRIVATE LIMITED',
    'VJ ORGANIC FARMS PRIVATE LIMITED',
    'AARPEE FOREIGN MONEY PRIVATE LIMITED',
    'ESR GMR LOGISTICS PARK PRIVATE LIMITED',
    'AIR-DASH EDUCATION NETWORK PRIVATE LIMITED',
    'SATMAX SOLUTIONS PRIVATE LIMITED',
    'STEPNSTONES TECHNOLOGIES PRIVATE LIMITED',
    'SHREEMANJI BESAN PRIVATE LIMITED',
    'STL DIGITAL LIMITED',
    'BENISON GLOBAL EDUCATION PRIVATE LIMITED',
    'WINDFIRE TECHNOLOGIES PRIVATE LIMITED',
    'FLEXFIT HEADWEAR INDIA PRIVATE LIMITED',
    'TARAMS-VENTURES AND SOFTWARE PRIVATE LIMITED',
    'IMMUNEEL THERAPEUTICS PRIVATE LIMITED',
    'TURGAJO TECHNOLOGIES PRIVATE LIMITED',
    'ALTBIRD ROBOTICS PRIVATE LIMITED',
    'MAPLEBEES VENTURES PRIVATE LIMITED',
    'EUROPEAN ADVANCED SECURITY PRIVATE LIMITED',
    'GIGGLES HOSPITALS PRIVATE LIMITED',
    'REPLUS ENGITECH PRIVATE LIMITED',
    'VOX360 WAYS PRIVATE LIMITED',
    'XLURSELF INDIA PRIVATE LIMITED',
    'PC DYE CHEM PRIVATE LIMITED',
    'AZENA LIVEPLAY PRIVATE LIMITED',
    'GARBHA GUDI PHARMA PRIVATE LIMITED',
    'VKAV HOSPITALITY PRIVATE LIMITED',
    'WINONE PRODUCT TECHNOLOGIES PRIVATE LIMITED',
    'FERMIONS AND BOSONS PRIVATE LIMITED',
    'GAJGATI STEEL AND ENERGY PRIVATE LIMITED',
    'EGNI GENERATION PRIVATE LIMITED',
    'LAH MER REALTY PRIVATE LIMITED',
    'TERRAGREENS ORGANIC PRIVATE LIMITED',
    'LIVA NUTRITIONS LIMITED',
    'INNOVISION INFRASOL PRIVATE LIMITED',
    'TEAM CRUNCHES SERVICE (OPC) PRIVATE LIMITED',
    'MARINE INFRALINK LOGISTICS PRIVATE LIMITED',
    'FAKHRI IT SERVICES (INDIA) PRIVATE LIMITED',
    'SRI SAI SIDDHI CONSTRUCTIONS PRIVATE LIMITED',
    'JTAC AIR-CONDITIONING INDIA PRIVATE LIMITED',
    'UNISIS IT SERVICES INDIA PRIVATE LIMITED',
    'AIC-DSU INNOVATION FOUNDATION',
    'EPSL TRIGENERATION PRIVATE LIMITED',
    'SLATWALL COMMERCE PRIVATE LIMITED',
    'INDIDGE SYSTEMS INDIA PRIVATE LIMITED',
    'BENCHMARK ISP PRIVATE LIMITED',
    'SBVJ TRADING PRIVATE LIMITED',
    'HULA GLOBAL FASHIONS PRIVATE LIMITED',
    'TRICONNECT HOLIDAYS PRIVATE LIMITED',
    'UTTARAYAN INVESTMENT PRIVATE LIMITED',
    'GRAND CROWN PARK VACATION PRIVATE LIMITED',
    'WECOLLAB CONSULTING PRIVATE LIMITED',
    'HOPCO INDUSTRIES LIMITED',
    'REAGENS INDIA POLYMER ADDITIVES PRIVATE LIMITED',
    'POPULATIONCOUNCIL CONSULTING PRIVATE LIMITED',
    'SHRI SARYANSH HOLIDAYS PRIVATE LIMITED',
    'RASNA FOUNDATION',
    'DIVINE SPARK PRIVATE LIMITED',
    'NAVYA CONTAINERS PRIVATE LIMITED',
    'AURORAS ENGICON (OPC) PRIVATE LIMITED',
    'REDCRIX TECHNOLOGIES PRIVATE LIMITED',
    'GSC TECHNOLABS PRIVATE LIMITED',
    'BHAMBRI SOLAR PRIVATE LIMITED',
    'BHANDAREE CONSUMER PRODUCTS PRIVATE LIMITED',
    'GSW INFRA PRIVATE LIMITED',
    'CHURDHAR TOURISM PRIVATE LIMITED',
    'UBMATIC TECHNOLOGIES PRIVATE LIMITED',
    'EVOQUA WATER TECHNOLOGIES INDIA PRIVATE LIMITED',
    'APEX REALTY MANAGEMENT PRIVATE LIMITED',
    'WYSETEK INFOSOLUTIONS PRIVATE LIMITED',
    'TALTECH TECHNOLOGIES PRIVATE LIMITED',
    'ILV DISTRIPARK (MAPPEDU) PRIVATE LIMITED',
    'MINDCOMP REGENCY PARK PRIVATE LIMITED',
    'PHARMERIT INDIA PRIVATE LIMITED',
    'INDIGO DAIRY & AGRO INDUSTRIES PRIVATE LIMITED',
    'KALMI TECHNOLOGIES PRIVATE LIMITED',
    'MAHAKALI VEHICLES PRIVATE LIMITED',
    'LEAFBERRY ADS PRIVATE LIMITED',
    'MORESECURE PACK SEALS PRIVATE LIMITED',
    'CIRRUSLABS PRIVATE LIMITED',
    'KRISHNA RENT A CAR PRIVATE LIMITED',
    'FOREVER ASSOCIATES PRIVATE LIMITED',
    'RIMJHIM360 NEWS PRIVATE LIMITED',
    'ZIRCON MARINE SERVICES PRIVATE LIMITED',
    'T4G TECHNOLOGY FOR GOOD FOUNDATION',
    'ASTRIT JEWELS PRIVATE LIMITED',
    'AJIT SALT PRIVATE LIMITED',
    'GREY SPACE COMPUTING PRIVATE LIMITED',
    'IGROSYS GLOBAL IT SOLUTIONS PRIVATE LIMITED',
    'PASADENA RETAIL PRIVATE LIMITED',
    'DYNAMIC CONGLOMERATE PRIVATE LIMITED',
    'IKRANO CONSULTING (OPC) PRIVATE LIMITED',
    'KARORA PRIVATE LIMITED',
    'VOLUNTEERS IN PROGRESS FOUNDATION',
    'SAROJA PHARMA INDUSTRIES INDIA LIMITED',
    'INTELLIO HEALTHCARE PRIVATE LIMITED',
    'UMANO CONSULTING PRIVATE LIMITED',
    'TRAVELFLIX HOLIDAYS PRIVATE LIMITED',
    'VENJUS EVOLUTION PRIVATE LIMITED',
    'TINKERTECH LABORATORIES PRIVATE LIMITED',
    'SKULL SHAVER INDIA PRIVATE LIMITED',
    'DHANSRI AUTO-VENTURES PRIVATE LIMITED',
    'BLU-SMART FLEET PRIVATE LIMITED',
    'NAYANAM FOOD SPECIALTIES PRIVATE LIMITED',
    'MASTLEADERSHIP MARITIME PRIVATE LIMITED',
    'SNEHANJALI AND S.B. DEVELOPERS PRIVATE LIMITED',
    'PLOOGL TECHNOLOGIES PRIVATE LIMITED',
    'LEYAN NUTS AND FOODS PRIVATE LIMITED',
    'MESMARA BOTANICS PRIVATE LIMITED',
    'SRIKAR PRODUCTIONS PRIVATE LIMITED',
    'PYZA LABS INDIA (OPC) PRIVATE LIMITED',
    'GREENOMICS TRADING PRIVATE LIMITED',
    'LEVERAGES CAREER INDIA PRIVATE LIMITED',
    'NISSEI ELECTRIC INDIA PRIVATE LIMITED',
    'THEDAL APP INDIA LIMITED',
    '3HANDSHAKE INNOVATION PRIVATE LIMITED',
    'ICS WELFARE FOUNDATION',
    'BHATIA',
    'S INTEGRATED AND SYNERGISTIC EMPOWERMENT ASSOCIATION',
    'ICARIAN TECHNOLOGIES PRIVATE LIMITED',
    'SUNBLOOM ENERGY PRIVATE LIMITED',
    'VISHWASRAO DEMPO ACADEMY PRIVATE LIMITED',
    'MEDCRISIS HEALTHCARE PRIVATE LIMITED',
    'PROLOCUS PRIVATE LIMITED',
    'ASIAN NAGPUR HOSPITALS AND HEALTHCARE PRIVATE LIMITED',
    'KOC ENTERTAINMENT PRIVATE LIMITED',
    'POLAR GOLD INDIA EXTRACTS PRIVATE LIMITED',
    'PQMS QUALITY SERVICES PRIVATE LIMITED',
    'SIMPOLO FOUNDATION',
    'UNIVERSE SEVA SAMITI FOUNDATION',
    'SWIFT SECURE SOLUTIONS PRIVATE LIMITED',
    'MUKHYA CONSULTING PRIVATE LIMITED',
    'DOCONLINE CONSULTING PRIVATE LIMITED',
    'CULINKS SERVICES PRIVATE LIMITED',
    'MADHUADIT HEALTHCARE PRIVATE LIMITED',
    'UNIFIED LOGISTICS INDIA PRIVATE LIMITED',
    'TORUK MAKTO HEALTHCARE PRIVATE LIMITED',
    'SKYMY PRINTDIGI PRIVATE LIMITED',
    'CLOUDGETA TECHNOLOGIES PRIVATE LIMITED',
    'IMPANIX CAPITAL ADVISORS PRIVATE LIMITED',
    'K4U EXPERIENCES PRIVATE LIMITED',
    'ANGELS INFRATEL PRIVATE LIMITED',
    'PURTI AQUA OWNERS ASSOCIATION',
    'FEDERATION OF SOLAR MANUFACTURERS & INTERMEDIARIES',
    'VERANDA CHILDREN',
    'ASG WIN INDIA PRIVATE LIMITED',
    'H-BOTS ROBOTICS PRIVATE LIMITED',
    'CROWN SAFEGUARD PRIVATE LIMITED',
    'RANGAN QUALITY SERVICES (OPC) PRIVATE LIMITED',
    'MECHATRON UBERLEGEN TECHNOLOGIES PRIVATELIMITED',
    'APPLIED AND NATURAL SCIENCE FOUNDATION',
    'SUPERBOLT TECHNOLOGIES PRIVATE LIMITED',
    'JADEITE SOLUTIONS PRIVATE LIMITED',
    'GRID CUBES PRIVATE LIMITED',
    'ENTYTLE INDIA PRIVATE LIMITED',
    'PATXPERTS PRIVATE LIMITED',
    'REDICAST INDUSTRIES PRIVATE LIMITED',
    'TECHNOCAB INDIA PRIVATE LIMITED',
    '121 EXPERIENCES INTEGRATED MARKETING PRIVATE LIMITED',
    'LIFEFORCE HEALTH SYSTEMS PRIVATE LIMITED',
    'LIMELIGHT FACILITY (OPC) PRIVATE LIMITED',
    'UNHERD PRIVATE LIMITED',
    'GMBT PRIVATE LIMITED',
    'SHUTTLESCRAP INDIA PRIVATE LIMITED',
    'EBN LEARNING PRIVATE LIMITED',
    'TRIDENT COLD CHAIN SOLUTIONS PRIVATE LIMITED',
    'TECHLORRY EVENTS PRIVATE LIMITED',
    'P.I. PRESTIGE INTERNATIONAL INDIA PRIVATE LIMITED',
    'SHOWMEDIA SOLUTION PRIVATE LIMITED',
    'SOCBRIDGE SEMICONDUCTORS PRIVATE LIMITED',
    'KOREA ENGINEERING AND CLEAN TECHNOLOGY CO(INDIA) PRIVATE LIMITED',
    'SYNQ AUDIO RESEARCH INDIA PRIVATE LIMITED',
    'AIMBRIDGE EDUCATION PRIVATE LIMITED',
    'SELA INDUSTRIES PRIVATE LIMITED',
    'DEMETER FOOD PRIVATE LIMITED',
    'AL JADEED EXCHANGE PRIVATE LIMITED',
    'CYNEFIN CONSULTANTS PRIVATE LIMITED',
    'MAPPLE OUTRIGHT SERVICES PRIVATE LIMITED',
    'INDIA SIGNING HANDS PRIVATE LIMITED',
    'RAPTIM BUSINESS SOLUTION PRIVATE LIMITED',
    'FAIR FINANCIAL REPORTING ADVISORS PRIVATE LIMITED',
    'RANIA CASTINGS AND MACHINERY PRIVATE LIMITED',
    'ELECSA LIGHTING & ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'TRUEDIAMOND JEWELS INDIA PRIVATE LIMITED',
    'QUALSTAR PRIVATE LIMITED',
    'BIDYA HEALTH PLUS & DIAGNOSTIC CENTRE PRIVATE LIMITED',
    'PROPWEB REALTY SERVICES PRIVATE LIMITED',
    'FIBERON TECHNOLOGIES PRIVATE LIMITED',
    'VATRO WATER SCIENCE PRIVATE LIMITED',
    'MOIRAI CONSULTANTS PRIVATE LIMITED',
    'LHI DIGITAL PRIVATE LIMITED',
    'AVOCADO LIFESTYLE PRIVATE LIMITED',
    'FIRST FIDDLE HOSPITALITY PRIVATE LIMITED',
    'SELFCOMPLY MANAGEMENT SERVICES PRIVATE LIMITED',
    'EDCLIP CONSULTING PRIVATE LIMITED',
    'KAPALIN MARKETING PRIVATE LIMITED',
    'TETRAQUARK INNOVATIONS INDIA PRIVATE LIMITED',
    'KRENAI SERVICES PRIVATE LIMITED',
    'ARIES ESTRRADO TECHNOLOGIES PRIVATE LIMITED',
    'OPRAAHFX ADTECH PRIVATE LIMITED',
    'ANWESHA HYGIENE PRIVATE LIMITED',
    'AAK HANDLING EQUIPMENTS PRIVATE LIMITED',
    'RM BROTHERS PRIVATE LIMITED',
    'NEOTRONIC ENGINEERING PRIVATE LIMITED',
    'HIPOINT CONNECT PRIVATE LIMITED',
    'EVE PLATFORM PRIVATE LIMITED',
    'RAYLATION CRM SOLUTIONS PRIVATE LIMITED',
    'CHHEDA JEWELLERS PRIVATE LIMITED',
    'NEWSPACE RESEARCH & TECHNOLOGIES PRIVATELIMITED',
    'PANEL REPAIR FACTORY INDIA PRIVATE LIMITED',
    'SPACIFII HOME DECORS PRIVATE LIMITED',
    'Indovision services private limited',
    'Earth engitech private limited',
    'Trikon networks private limited',
    'TWK ENTERPRISES PRIVATE LIMITED',
    'KIGG SYSTEMS INDIA PRIVATE LIMITED',
    'Cygnus micro systems pvt ltd',
    'Access computech pvt ltd',
    'E infotech india private limited',
    'Compro softtech private limited',
    'Attentive technologies private limited',
    'Fci gbs india private limited',
    'Fullorbis technologies private limited',
    'Baanyan softtech services india private limited',
    'Averroes it labs private limited',
    'Lider consultancy services private limited',
    'V j coresoft private limited',
    'Pa gyan kendra private limited',
    'Dams sky private limited',
    'Alpha life sciences private limited',
    'Alpha healthsciences private limited',
    'Indian health organisation private limited',
    'Epsilon healthcare solutions private limited',
    'Arise n shine schools private limited',
    'Jeevan homepharma private limited',
    'Kaifak medicare private limited',
    'Emporium hospitality private limited',
    'Olive hospitals private limited',
    'Cat school of business management private limited',
    'Newage vocational training institute private limited',
    'Clearview healthcare private limited',
    'Premier skills private limited',
    'Sadhana educational and people development services private limited',
    'Techno global alliances private limited',
    'Learning world education solutions private limited',
    'Tolins world school private limited',
    'Vijayanagar industrial credits limited.',
    'Kolkata institute of science and technology',
    'Base educational services private limited',
    'Dnies educational institutions private limited',
    'Masters academy for overseas education and migration private limited',
    'Sunrise academy of medical specialities (india) private limited',
    'Mitera hospitals private limited',
    'School of financial training private limited.',
    'Osianama learning experience private limited',
    'Eram hitech engineering india private limited.',
    'Kamineni health services private limited',
    'Global talent track eduventures private limited',
    'Dm hospitals private limited',
    'Annadeep health services private limited',
    'GENESISEVA PRIVATE LIMITED',
    'Nattika beach ayurveda and yoga centre private limited',
    'Samruddha gram vikas foundation',
    'Axis hospitals private limited',
    'ANAMOL LABORATORIES PRIVATE LIMITED',
    'Molecular pet scans private limited',
    'Action enterprise',
    'Quark benevolent',
    'Doon valley waste management private limited',
    'Chhaya dixit welfare foundation',
    'First connect education and immigration private limited',
    'Workready knowledge solutions private limited',
    'Mastermind institute of education private limited',
    'Act careers private limited',
    'American hospital management company (india) private limited',
    'William j. clinton foundation',
    'Sparklework films private limited',
    'Films private limited.',
    'Suvarna film enterprises private limited',
    'Ideas com india private limited',
    'Nimita productions private limited',
    'OSIAN',
    'L STAFFING SERVICES PRIVATE LIMITED',
    'Lodestar quality india private limited',
    'Iist consulting and marketing private limited',
    'Golden cashew products private limited',
    'G. raj commodity broker private limited',
    'Agarwal furnishers pvt ltd',
    'Lex process outsourcing private limited',
    'Integrated risk insurance brokers limited',
    'Tekni skill resources private limited',
    'Karan cab services private limited',
    'Yors hr services private limited',
    'Moment splicing systems private limited',
    'Ksj engineering and projects private limited',
    'Chartered insurance brokers private limited',
    'Elvis sanitation private limited',
    'Multiplex commodity mercantile private limited',
    'Durga filters private limited',
    'Matangi rubber private limited',
    'Everest manpower solutions private limited',
    'Off shore securities private limited',
    'Bombay security services private limited',
    'Skipper healthcare private limited',
    'Sft syscon private limited',
    'GUIRES SOLUTIONS PRIVATE LIMITED',
    'Manch communications private limited',
    'William e. connor & associates sourcing private limited',
    'Legist intellectual property rights services limited',
    'Provista management consultants private limited',
    'Smr advisors private limited',
    'Rajahrani impex private limited',
    'Foxgloves manpower services private limited',
    'I systems technocrats private limited',
    'SPICE CONNECT PRIVATE LIMITED',
    'Indo gulf pest control private limited',
    'No 1 worldwide express private limited',
    'GLOBAL SUSTAINABLE ENERGY SOLUTIONS INDIA PRIVATE LIMITED',
    'Exclusife technosoft private limited',
    'Fraternity water solutions private limited',
    'GENEX FACILITY MANAGEMENT SOLUTIONS PRIVATE LIMITED',
    'Petheart superstore private limited',
    'Smart talent consulting services private limited',
    'Salem yarn coloring park private limited',
    'Technodata analytics services private limited',
    'Grand polycoats company private limited',
    'KAMAL ENCON INDUSTRIES LIMITED',
    'Scroll mantra private limited',
    'Ghodawat enterprises private limited',
    'Rickshaw caares private limited',
    'Initus hr consulting private limited',
    'Capaleph advisors india private limited',
    'Kreeda design consultants private limited',
    'Wyz games india private limited',
    'Team sustain limited',
    'Ratan batra private limited',
    'Honeywell india private limited',
    'Mugatlal bhagwandas boda and company private limited',
    'Eastin hospitality services private limited',
    'Spanish waterproofing (india) private limited',
    'Officemart india .com limited',
    'Timblo shipyards private limited',
    'Clide management consultancy private limited',
    'Kishor encare global private limited',
    'Cleanroom modular systems private limited',
    'Quadrant property management services private limited',
    'Enterprise data management solutions private limited',
    'Acme handicrafts private limited',
    'A j packaging limited',
    'KEVENTER VENTURES LIMITED',
    'Infosign systems private limited',
    'Lightfx entertainment private limited',
    'Protocol integrated management services private limited',
    'Micro insurance services private limited',
    'Vaata wind energy private limited',
    'Icsa holdings private limited',
    'KAVIN CARBONS PRIVATE LIMITED',
    'Galaxy elegant fashions private limited',
    'Dj signs private limited',
    'Abhi energy private limited',
    '2d entertainment private limited',
    'Sperry techno solutions private limited',
    'UI MANUFACTURING & CONSTRUCTION COMPANY PVT. LTD.',
    'Innovative pet containers limited',
    'Strawberry studio exports pvt ltd',
    'Personal creations private limited',
    'Akps auto accessories private limited',
    'Manwal colonisers private limited',
    'Shrine gallery private limited',
    'Inter ads exhibitions private limited',
    'Michele janezic agency private limited.',
    'Sr engineers enterprise private limited',
    'Dirac business solutions private limited',
    'Impetus research private limited',
    'Primary plus events private limited',
    'Chona property management limited',
    'Adcc academy private limited',
    'South city international school',
    'Oceanic consultants private limited',
    'Pee emm technologies private limited',
    'Ode to earth enterprises private limited',
    'Art point private limited',
    'S.h. home furnishings private limited',
    'Iplon india private limited',
    'Apeejay charter private limited',
    'Prime metalics private limited',
    'Kishan agencies private limited',
    'Manya education private limited',
    'Tirumala balaji alloys private limited',
    'R s sponge iron private limited',
    'Goenka udyog pvt ltd',
    'Mehta formulations private limited',
    'India potteries ltd.',
    'Alfa caps private limited',
    'Anzen exports private limited',
    'Trans metalite (india) limited',
    'A daga steel p. ltd.',
    'New shama laboratories private limited',
    'ASIAN TUBES PRIVATE LIMITED',
    'Girnar ayurvedic pharmacy private limited',
    'Vedic remedies private limited',
    'BHARAT FLOORINGS & TILES (MUMBAI) PRIVATE LIMITED',
    'Purbanchal cement ltd.',
    'KWW ELECTRICALS PRIVATE LIMITED',
    'Ratusaria steels private limited',
    'Triveni iron and steel industries private limited',
    'Igp engineers private limited',
    'Divon gold private limited',
    'Akar motels and holiday resorts private limited',
    'EQUINOVA VYAPAAR PRIVATE LIMITED',
    'Buntrock international private limited',
    'Shri bajarang ispat and plywood limited',
    'Reliable pipes and tubes limited',
    'SWARNSRI GOLD & DIAMONDS PRIVATE LIMITED',
    'Rahul micron private limited',
    'Sidharth automat india private limited',
    'Ilc iron & steel private limited',
    'Gupta foundry works pvt ltd',
    'Noble cast comp private limited',
    'Magna casting and machine works private limited',
    'Bridge & roof co (india) ltd',
    'Howrah forgings ltd',
    'Baroda therm cast pvt ltd',
    'Cast profiles pvt ltd',
    'Opg realtor private limited',
    'Target polymers private limited',
    'WINDMOLLER & HOLSCHER INDIA PRIVATE LIMITED',
    'A g accutech meshes and screens private limited',
    'Shree ganesh poly plast private limited.',
    'Sood plastics pvt ltd',
    'Anant refractory products private limited',
    'The south indian industrials pvt ltd',
    'Monier roofing private limited',
    'Deep packaging private limited',
    'Shivanshu sintered products pvt ltd',
    'Next step engineering private limited',
    'Modern metals india private limited',
    'The sangli forging and metal industries pvt ltd',
    'Ksc forge private limited',
    'Klaus union engineering india private limited',
    'Sipra engineers private limited',
    'Hextech engineers (india) pvt ltd',
    'Pesco beam environmental solutions private limited',
    'Designedge concrete products private limited',
    'Msp metallics limited',
    'ALFEN SYSTEMS PRIVATE LIMITED',
    'Daga gems & jewellery private limited',
    'Indian fasteners limited',
    'Electrilab genetic private limited',
    'Baijnath gupta & sons pvt ltd',
    'Universal cylinders limited',
    'Addison & co. limited',
    'Ramm precision products private limited',
    'Aask precision engineers private limited',
    'INDICON WESTFALIA LIMITED',
    'Setu engineers private limited',
    'Suvarna fibrotech pvt ltd',
    'Indian chain private limited',
    'Mastercraft technology private limited',
    'Lubricare pvt ltd',
    'Super auto india limited',
    'Kasturi foundry private limited',
    'Turbo bearings private limited',
    'Pressurejet systems private limited',
    'Honek metal products private limited',
    'U-foam structures private limited',
    'Himachal shots and metals pvt ltd',
    'San precision alloys private limited',
    'Omega sane foundry machinery private limited',
    'Unique circle automation private limited',
    'Arihant bearing services pvt ltd',
    'Sbpt technologies pvt. ltd.',
    'SSP PLANT SPARES & SERVICES PRIVATE LIMITED',
    'SPRINGWIZ SOLUTIONS PRIVATE LIMITED',
    'FORTUNE PARK RESIDENCY PRIVATE LIMITED',
    'BONLON INDUSTRIES LIMITED',
    'M. g. m springs private limited',
    'Value energy technologies private limited',
    'Sharma security and fire services private limited',
    'Technico(india) pvt ltd',
    'Brite metalloy pvt. ltd.',
    'R.k.transonic engineers private limited',
    'Fiba hardwyn locks limited',
    'Isomet private limited',
    'Superform diatools private limited',
    'MIRAJ MULTISERVICES PRIVATE LIMITED',
    'Rupa enterprises private limited',
    'Manku agrotech private limited',
    'Trans valves (india) private limited',
    'Shanti boilers and pressure vessels private limited',
    'FLOW DIRECT VENTURES & SERVICES PRIVATE LIMITED',
    'Metflow controls private limited',
    'Best one tools private limited',
    'STANDARD GLASS LINING TECHNOLOGY LIMITED',
    'Zenith mechanics (india) private limited',
    'Kiran foreign trade private limited',
    'Floral distributors private limited',
    'Vikram overseas ltd',
    'Nanda brothers (export) private limited',
    'Indo texcrafts pvt ltd',
    'Sathya deep exports private limited',
    'Neptune (india) limited',
    'Jms tradex international private limited',
    'Sumitron exports private limited',
    'Kapil corepacks private limited',
    'Goldman agent pvt.ltd.',
    'Sumitomo corporation india private limited',
    'New era computech and marketiing private limited',
    'Avm exports private limited',
    'Interactive communication services (india) private limited',
    'Vp exim limited',
    'Muka exim private limited',
    'Shree kripa export private limited',
    'Sba commercial traders private limited',
    'Silverlink commodities private limited',
    'Jaiparash trading private limited',
    'Sonal enterprises private limited',
    'Psa impex private limited',
    'Worlds window exim private limited',
    'Avantika interior systems private limited',
    'Krome planet interiors private limited',
    'TECHSURE MEDICAL DEVICES PRIVATE LIMITED',
    'CLEARFIELD TECHNOLOGIES PRIVATE LIMITED',
    'True price travel private limited',
    'Jm entrance automation private limited',
    'Cloudtail india private limited',
    'M r mac-tech private limited',
    'Resplenda expressions private limited',
    'Wexford trading company pvt ltd',
    'Heritage retail india private limited',
    'Crystal tie-up private limited',
    'Gxt green products private limited',
    'Arjan global private limited',
    'Bevy world spirits private limited',
    'Anil bioplus limited',
    'Tapan classics pvt ltd',
    'S.l.exports private limited',
    'Triage overseas private limited',
    'Pine cone hill (india) private limited',
    'Sursadhna commercial pvt ltd',
    'D r brijmohan and sons private limited',
    'Kanefusa india private limited',
    'Nasan garments private limited',
    'Puma sports india private limited',
    'Kalash containers (india) private limited',
    'Wolwyn exports private limited',
    'Global flavours and ingredients private limited',
    'Matin exim private limited',
    'Supreme industrial products private limited',
    'Octagon exim trading private limited',
    'Oriental sales private limited',
    'Sun export private limited',
    'North east distributors private limited',
    'WINDMILL EXPORTS PRIVATE LIMITED',
    'HERMES COMMERCE Private Limited',
    'Karam chand thapar & bros (coal sales ) ltd',
    'India general trading co ltd',
    'Malabar sales private limited',
    'Lantern trading and investments pvt ltd',
    'Jiya overseas private limited',
    'Brahmaputra exports bombay pvt ltd',
    'Florid impex private limited',
    'AVODEN PRIVATE LIMITED',
    'Vyaparavijayam trades and agencies pvt ltd',
    'Rbg trading corporation private limited',
    'Sjss trade links private limited',
    'Gnm enterprises private limited',
    'Sai parkash sourcing private limited',
    'Delight vanijya pvt ltd',
    'Orion tradecom pvt.ltd.',
    'Cloisters trading private limited',
    'Aaradhya international private limited',
    'Pontiac distributors private limited',
    'Mansarovar commercial private limited',
    'Unison packaging private limited',
    'PEEKAY PETROCHEM PRIVATE LIMITED',
    'Irc natural resources private limited',
    'Heritage merchants (india) private limited',
    'Samridhi merchandise private limited',
    'Hnb retails private limited',
    'Khatore earth movers private limited',
    'Creative vanijya private limited',
    'Om equipments private limited',
    'Madhusudhan commotrade private limited',
    'Forum properties holdings private limited',
    'T AND T SOLAR ENERGY PRIVATE LIMITED',
    'Poddar tradelinks private limited',
    'Royal commosale private limited',
    'Universal energy solutions private limited',
    'Pawan suppliers private limited',
    'Trbex impex private limited',
    'Dynamic beneficial accord marketing private limited',
    'Goodwill trades private limited',
    'Zeevstar retails private limited',
    'Rooptara merchandise private limited',
    'Attractive dealcom private limited',
    'HANSRX PRIVATE LIMITED',
    'Sonsil ceramic pvt ltd',
    'TAMBOLI ENTERPRISE LIMITED',
    'Nightangle dealtrade private limited',
    'Parrot vintrade private limited',
    'Noonic software development private limited',
    'Idv technology solutions private limited',
    'Dintex information systems (india) private limited',
    'SANDYFY ENTERPRISES PRIVATE LIMITED (OPC)',
    'Tegra digital private limited',
    'Orgspire info technologies private limited',
    'Rayalaseema digicom private limited',
    'Sevate software services private limited',
    'Cion systems hyderabad private limited',
    'Futuristic simplified computing private limited',
    'Tips data systems private limited',
    'Ninestars information technologies private limited',
    'Jesuma it solutions private limited',
    'Mentis systems private limited',
    'Cram group india private limited',
    'Digital web advisors private limited',
    'Siva systems private limited',
    'SCREENROOT TECHNOLOGIES LIMITED',
    'Siebenberg technologies private limited',
    'CERP SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Encore i.t. services solutions private limited',
    'Proses web technologies private limited',
    'Etymon technologies private limited',
    'Sfour esolutions private limited',
    'Winds business solutions private limited',
    'Sunflower information technologies private limited',
    'U.Y.SOFTECH PRIVATE LIMITED',
    'Bits and bytes compusoft private limited',
    'Yellow box hr services private limited',
    'Majestic technosoft private limited',
    'SAG INFOTECH PRIVATE LIMITED',
    'WEBORBIT SOLUTIONS PRIVATE LIMITED',
    'DR. REDDY',
    'CHAMBER OF COMMERCE & INDUSTRY',
    'I create foundation',
    'YOUNG PRESIDENT',
    'NOOK PRIVATE LIMITED',
    'Step-in forum',
    'Ztek consulting private limited',
    'Platypus consultancy and services private limited',
    'Mak dian training & consulting private limited',
    'JEEVIKA ADVISORS PRIVATE LIMITED',
    'RHI MAGNESITA INDIA LIMITED',
    'O k play india limited',
    'Samrat forgings limited',
    'Polycon international ltd.',
    'Nrb bearings limited (full fledged public co)',
    'Shanthi gears limited',
    'Vst industries limited',
    'Veejay lakshmi engineering works limited',
    'Nrb industrial bearings limited',
    'Keltron component complex ltd',
    'Reil electricals india limited',
    'Jonas woodhead & sons (india) limited',
    'SWARNSARITA JEWELS INDIA LIMITED',
    'Bhagheeratha engineering ltd',
    'Sml isuzu limited',
    'Universal properties ltd',
    'Chokhani international limited',
    'PINCON LIFESTYLE LIMITED',
    'Advance multitech limited',
    'Shirpur gold refinery limited',
    'MACFARLANE & CO. LTD',
    'Ronson traders ltd',
    'Krishna continental limited',
    'PAISALO DIGITAL LIMITED',
    'Dfl infrastructure finance limited',
    'Mahindra and mahindra limited',
    'Park chambers ltd',
    'Decillion finance limited',
    'Ashiana housing limited',
    'Alom extrusions limited',
    'Kothari fermentation and biochem limited',
    'Kalpa commercial limited',
    'Sharda motor industries limited',
    'East buildtech limited',
    'Titan biotech ltd. (transfer from delhi to raj.)',
    'Til limited',
    'SUBH SHREE COMMERCIAL CO LTD',
    'Mangalore refinery and petrochemicals limited',
    'Apar industries limited',
    'Zee entertainment enterprises limited',
    'THE BOMBAY BURMAH TRADING CORPORATION LIMITED',
    'Pci papers limited',
    'Waves aircon private limited',
    'Convergent telecom private limited',
    'Sukriti colonisers private limited',
    'Vinty impex private limited',
    'Murli textiles private limited',
    'Mm aqua technologies limited',
    'Delta orissa private limited',
    'Deccan horticulture private limited',
    'Vks green private limited',
    'JALNA SEEDS PROCESSING AND REFRIGERATION COMPANY PRIVATE LIMITED',
    'HALLMARK AUTO TRIMMINGS PVT LTD',
    'Saggu agro private limited',
    'Darjeeling natural products pvt ltd',
    'Suryavamsi farms private limited',
    'Rasi seeds private limited',
    'Rockfield estates private limited',
    'Astha farms private limited',
    'Pamps exim private limited',
    'Kodai valley orchards private limited',
    'SARVPRIYA PREFAB PRIVATE LIMITED',
    'Ujjawal seeds private limited',
    'Gangotri quality seeds private limited',
    'Mollem plantations and resorts private limited',
    'Kf bioplants private limited',
    'KELZAI ECO RESERVES PRIVATE LIMITED',
    'Pinkcity agro private limited',
    'Vishal udhyan private limited',
    'Ujjwal green farms private limited',
    'Kurmanchal organic ventures private limited',
    'Sri durga tea company private limited',
    'Parisons estates and industries private limited',
    'Kanoi estates pvt ltd',
    'PEERLESS TEA & INDUSTRY LTD',
    'Sannyasithan tea company private limited',
    'KEARTIMAN SKILLS PRIVATE LIMITED',
    'Shaliwahan farms private limited',
    'Doctor feeds private limited',
    'FRESH-O-GREEN FOOD PRIVATE LIMITED',
    'Fresh-o-green exim private limited',
    'Pratap reddy stud & agricultural farm private limited',
    'Well grown spices private limited',
    'Mahratta chamber of commerce industries and agriculture',
    'Pamps farm private limited',
    'Pamps food private limited',
    'Aakansha farms private limited',
    'Reliable shelters private limited',
    'Harasha pharma private limited',
    'Kanpower hoses india private limited',
    'Magtorq private limited',
    'Eros auto private limited',
    'Kasu electricals private limited',
    'U m s services limited',
    'Udhaya semiconductors limited',
    'C. KRISHNIAH CHETTY & C0. PRIVATE LIMITED',
    'Focus medisales private limited',
    'Gomatha sea foods private limited',
    'DROIT STEEL BUILDINGS PRIVATE LIMITED',
    'B r products private limited',
    'Karolia lighting private limited',
    'Maruti elevators private limited',
    'Lipid engineering private limited',
    'Emerge power solutions private limited',
    'Jetha business services pvt ltd',
    'Nagpur infotech private limited',
    'Asim software solutions private limited',
    'Admark digitech private limited',
    'Earthpower equipments private limited',
    'Adec embedded technology and solutions private limited',
    'Chemtrols samil (india) private limited',
    'POLYMATECH ELECTRONICS LIMITED.',
    'M k m technologies private limited',
    'Universal electrowave private limited',
    'L s i systems (india) private limited',
    'Eap electro projects private limited',
    'Eurofab electronics private limited',
    'Avisor india private limited',
    'Erd infotech private limited',
    'Motorola solutions india private limited',
    'Aditya intertrade private limited',
    'Aamsel impex private limited',
    'Mrh sound solutions private limited',
    'Sigma searchlights ltd.',
    'Loginn hospitality limited',
    'V n electronics private limited',
    'Endue rf solutions private limited',
    'Bluechip concepts india private limited',
    'Supreme audiotek private limited',
    'Creative hitech private limited',
    'ZOOM COMMUNICATIONS PRIVATE LIMITED',
    'Neotech systems private limited',
    'Synergy appliances private limited',
    'Hma data systems private limited',
    'Metro intelligent transportation systems private limited',
    'Vinayak electromech private limited',
    'Svs medical devices india private limited',
    'Dyaus med healthcare private limited',
    'MEDX TECHNOLOGIES PRIVATE LIMITED',
    'Consolidated products international private limited',
    'Sky-tech medical devices private limited',
    'B l lifesciences private limited',
    'Bio-med health care products private limited',
    'D m pharma private limited',
    'Positronics control systems private limited',
    'Imperial life sciences private limited',
    'Accusonic controls pvt ltd',
    'Vimoni (india) pvt ltd',
    'Noratel india power components private limited',
    'Sant sahney private limited',
    'Ador powertron limited',
    'D D INDUSTRIAL PRIVATE LIMITED',
    'Skh auto parts private limited',
    'ENDURANCE TECHNOLOGIES LIMITED',
    'Omsai auto world private limited',
    'Varun used cars private limited',
    'Indo texnology private limited',
    'PADAM SINGH AND COMPANY PVT.LTD.(TRANSFERRED FROM NCT OF DELHI)',
    'Aero fasteners private limited',
    'Nrb-ibc bearings private limited',
    'General electronics of haryana private limited',
    'A k surya power magic private limited',
    'HARITASA ELECTRONICS SOLUTIONS PRIVATE LIMITED',
    'Cts india private limited',
    'Faststream electronics private limited',
    'Sudhan electromech private limited',
    'Parana electrotech private limited',
    'Calonix electronics private limited',
    'Lakshmi components private limited',
    'Friends industries private limited',
    'Saraswati auto components private limited',
    'Uaw auto parts pvt ltd',
    'Asa projects private limited',
    'TVS ARGOMM PRIVATE LIMITED',
    'Chloride metals limited',
    'Smp international private limited',
    'Mitco commercial co pvt ltd',
    'Brn ship breakers private limited',
    'Shree ram vessel scrap private limited',
    'S.d. auto engineering works private limited',
    'Eastern track udyog private limited',
    'Jpm tsukada private limited',
    'Jay iber private limited',
    'Vibrant automobiles india private limited',
    'Allied spares and auto parts mfg company pvt ltd',
    'AVON RIMS PRIVATE LIMITED',
    'Shashwat cables private limited',
    'AVAAN INTERNATIONAL LIMITED',
    'SAPPHIRE WIRES & CABLES PRIVATE LIMITED',
    'Emkay automobile industries limited',
    'Ts tech sun rajasthan private limited',
    'HANSVAHINI AUTO INTERIOR PRIVATE LIMITED',
    'Goa auto accessories limited',
    'Chemmanur gold palace international limited',
    'Akshaya gold & diamonds international private limited',
    'Midas touch limited',
    'GOSIL EXPORTS PVT LTD',
    'Pipa bella accessories private limited',
    'Elite decor private limited',
    'Glass palace private limited',
    'COSMOS INTERNATIONAL PRIVATE LIMITED',
    'Amros commercial private limited',
    'Pro enviro recycling private limited',
    'Maa amba forgings private limited',
    'Sew-eurodrive india private limited',
    'Nagendra shipping private limited',
    'Balaji mariline pvt ltd',
    'Om rudrapriya holiday resorts private limited',
    'Hotel chandra towers private limited',
    'A g hospitalities private limited',
    'Air one aviation services private limited',
    'Lasco shipping company private limited',
    'Ava marine services private limited',
    'Air-901 aviation private limited',
    'Madman logistics india private limited',
    'New horizon relocation private limited',
    'Modiline travel service private limited',
    'D d shipping private limited',
    'STARTING TWELVE SPORTS PRIVATE LIMITED',
    'India now journeys private limited',
    'Asian travelco private limited',
    'Valley fliers services private limited',
    'Ezee fly solutions private limited',
    'Thinkstrawberries luxury travel marketing private limited',
    'M s transport services private limited',
    'Shree roadways limited (deemed pub tr co )',
    'International freight logistics india private limited',
    'Ham transport and cargo carrirs private limited',
    'Welgrow line (north india) private limited',
    'Intrepid travel private limited',
    'Breeze travels and tours private limited',
    'Unica logistics limited',
    'Casanova india tours private limited.',
    'Freight net private limited',
    'Legend transport solutions private limited',
    'Travel rhythm india private limited',
    'Southern journeys private limited',
    'Committed logistics (india) private limited',
    'Shree jagannath carriers private limited',
    'Total transport systems delhi private limited',
    'Celestial travel service private limited',
    'Inter line global logistics private limited',
    'Modern freight consolidator private limited',
    'Zeestar limouzines limited',
    'Sgats logistics private limited',
    'Continental logistics private limited',
    'REDEFINE LEISURE PRIVATE LIMITED',
    'Expo trans india limited',
    'Sai shipping company private limited',
    'Rajesh roadlines private limited',
    '24x7 logistics private limited',
    'UNDERGROUND PIPELINE AND NONDESTRUCTIVE TESTING SERVICE PRIVATE LIMITED',
    'Ashoka holidays private limited',
    'Abhinav trans-cargo (mumbai) private limited',
    'Venus container line logistics private limited',
    'Pluto travels (india) private limited',
    'Dial ess shipping private limited',
    'Anil packers and movers india relocation private limited',
    'Grand travel planners pvt ltd',
    'Rubee air freight limited',
    'P m c logistics private limited',
    'C m logistics india private limited',
    'Charms india tours private limited',
    'Holidify travels private limited',
    'M j tele power solutions private limited',
    'M first trading private limited',
    'Vajra telecom private limited',
    'Antariksh communications private limited',
    'Motorcycle expeditions & adventure tour private limited',
    'J.v.travels private limited',
    'Herald travels private limited',
    'Crescent entertainment & tourism limited',
    'Mgm programming service india private limited',
    'RAINBOW VACATIONS PRIVATE LIMITED',
    'Shr digital networks private limited',
    'Tvs srichakra investments limited',
    'Sarthi capital advisors private limited',
    'Expert chits private limited',
    'Pdn automobiles limited',
    'Shree ganesham travelmart private limited',
    'Mithals international (asia) private limited',
    'Ascent pinnacle capital limited',
    'C v mehta pvt ltd',
    'Arbor investments pvt ltd',
    'Aloha investments pvt ltd',
    'ABDHI INVESTMENTS PRIVATE LIMITED',
    'ACORN INVESTMENTS PRIVATE LIMITED',
    'Aaron investments pvt ltd',
    'Aster investments pvt ltd',
    'Adios investments pvt ltd',
    'K p n tours and travels private limited',
    'Lexus motors ltd.',
    'Param storage private limited (old name)',
    'Anar mcat advanced electronic chemicals private limited',
    'S n logistics private limited',
    'Golden safar private limited',
    'Pashupati road carrier private limited',
    'A. v. global corporation private limited',
    'Apollo financial services private limited',
    'Maurin properties private limited',
    'Appex finvest pvt ltd',
    'HERO INNOVATION VENTURES AND ENTERPRISESPRIVATE LIMITED',
    'MOUNTAINWARE EXCLUSIVE RETAIL PRIVATE LIMITED',
    'SILMAGA SECURITY PRIVATE LIMITED',
    'TRIVENI CARGO EXPRESS INDIA PRIVATE LIMITED',
    'VIDARBHA ELECTRONICS FOUNDATION',
    'GROW CROPS AGRICULTURE PRODUCER COMPANY LIMITED',
    'RAANKA AGENCIES PRIVATE LIMITED',
    'DIMPEX ORGANIC FARMS PRIVATE LIMITED',
    'SIBLAL AGROVET PRIVATE LIMITED',
    'HR BAKERS PRIVATE LIMITED',
    'DIY FOOD LABS PRIVATE LIMITED',
    'SAMAIRA ORGANIC PRODUCTS PRIVATE LIMITED',
    'INDOGRACE ECOMMERCE PRIVATE LIMITED',
    'GLOBALSHRIMP PRIVATE LIMITED',
    'SMOKE BITE PRIVATE LIMITED',
    'ANUCCHISTA KRSIKARANA PRIVATE LIMITED',
    'AMBHIJARA FARMERS PRODUCER COMPANY LIMITED',
    'SHAHANE SOLAR POWER PRIVATE LIMITED',
    'EUROBIA IMPEX INDIA PRIVATE LIMITED',
    'SHUBH FOOD INDUSTRIES PRIVATE LIMITED',
    'NATCH PRODUCTS AND SERVICES PRIVATE LIMITED',
    'HIMNAD BEVERAGES PRIVATE LIMITED',
    'LAVEN HOTELS PRIVATE LIMITED',
    'REDPRO F&B PRIVATE LIMITED',
    'JANS BAMBOO METAPHOR (JV) PRIVATE LIMITED',
    'MISHTHEE TEXTILES PRIVATE LIMITED',
    'BHU AGRO FOODS PRIVATE LIMITED',
    'UBO HOTELS AND RESORTS PRIVATE LIMITED',
    'VYANKA INDIA LIMITED',
    'TIBER TABER FASHION PRIVATE LIMITED',
    'SL NUTRITIONS PRIVATE LIMITED',
    'VANCA FASHIONS PRIVATE LIMITED',
    'GALIFE & STILE BRANDS PRIVATE LIMITED',
    'NAMO INDIA FASHIONS PRIVATE LIMITED',
    'PHARMOL (INDIA) PRIVATE LIMITED',
    'STARINDIA FIELDS PRIVATE LIMITED',
    'VEGEX HORTIFRESH PRIVATE LIMITED',
    'FARMOUS FOODS PRIVATE LIMITED',
    'GRAPLE FOODS PRIVATE LIMITED',
    'RUSH BRAND CONSULTING SERVICES PRIVATE LIMITED',
    'SIEBEN CORPORATION PRIVATE LIMITED',
    'MARINE HYDROCOLLOIDS PRIVATE LIMITED',
    'CMR VENTURES PRIVATE LIMITED',
    'UBI',
    'S FOUNDATION',
    'PRAYOJANA GOLDEN YEARS SERVICES PRIVATE LIMITED',
    'IQUIPPO SERVICES LIMITED',
    'PASURI GLOBAL ADVISORS PRIVATE LIMITED',
    'LEADERSHIP FOR SKILLED EDUCATION FOUNDATION',
    'QUASIX SOLUTIONS PRIVATE LIMITED',
    'ZYMIN FITNESS PRIVATE LIMITED',
    'AVITIS INSTITUTE FOR SCIENTIFIC RESEARCHAND APPLICATION PRIVATE LIMITED',
    'HUMANIDAD EVOLREACH PRIVATE LIMITED',
    'AFFIFIX DIGITAL PRIVATE LIMITED',
    'OCEANO TOTAL CARE PRIVATE LIMITED',
    'NAVIN HEALTHCARE PRIVATE LIMITED',
    'GURGAON CONNECTION ASSOCIATION',
    'AVITIS INSTITUTE OF MEDICAL SCIENCES PRIVATE LIMITED',
    'SADANA SECURITY AND INFRASTRUCTURE PRIVATE LIMITED',
    'S.D. RISING FOUNDATION',
    'PARAKRAM SECURITY INDIA PRIVATE LIMITED',
    'VALUESPACE INDIA EDUCATION FOUNDATION',
    'GC ENERGY PRIVATE LIMITED',
    'AASMAN FOUNDATION',
    'KARINI VENTURES PRIVATE LIMITED',
    'VIF DEVELOPMENT AND EDUCATION FORUM',
    'SAMAIKYA EDU SERVICES PRIVATE LIMITED',
    'RITARA APPS SOFTWARE PRIVATE LIMITED',
    'TWOBYTES DEVELOPEMENT PRIVATE LIMITED',
    'MONDAY MORNING PRIVATE LIMITED',
    'MAHAGAURI AUTISM CARE PRIVATE LIMITED',
    'APT TALENT PROVIDERS PRIVATE LIMITED',
    'URBANDOOR IMPORT EXPORT PRIVATE LIMITED',
    'BIT TECHNO PRODUCTS PRIVATE LIMITED',
    'EKASHRUNGI EDU SERVICES PRIVATE LIMITED',
    'LEAPINDIA INSTITUTE PRIVATE LIMITED',
    'CIRCUMPUNKT LEARNING SOLUTIONS PRIVATE LIMITED',
    'RAO SMART ACADEMY PRIVATE LIMITED',
    'ILLIMITABLE CONSULTING PRIVATE LIMITED',
    'BOUJI APPAREL PRIVATE LIMITED',
    'DEVTEK OSBS PRIVATE LIMITED',
    'TRIWAVE TECHNOLOGIES PRIVATE LIMITED',
    'STRESCON WIRE INDUSTRIES PRIVATE LIMITED',
    'PLAYSCHOOL SMARTSHALA EDUCATION PRIVATE LIMITED',
    'NARMIX LABS LIMITED',
    'GANJIMUTT VOCATIONAL TRAINING FORUM',
    'FEDERATION OF DEMOCRATIC VOICES',
    'AAXIS INFOTEL PRIVATE LIMITED',
    'MILATSERVICES PRIVATE LIMITED',
    'TRISHALA LEARNING SYSTEM PRIVATE LIMITED',
    'DIGISHAALA LABS PRIVATE LIMITED',
    'TANISHI HR CONSULTANTS PRIVATE LIMITED',
    'SNND TECHNOLOGIES PRIVATE LIMITED',
    'SANJHITOKRI PRIVATE LIMITED',
    'KALASHGANGA INSTA POWER PRIVATE LIMITED',
    'CERVEAU TECHNOLOGIES PRIVATE LIMITED',
    'GISHCON METALINKS (OPC) PRIVATE LIMITED',
    'SEED ACADEMY CONSULTING (OPC) PRIVATE LIMITED',
    'HSS SECURITY SOLUTIONS PRIVATE LIMITED',
    'PROFESSIONALS DOMAIN PRIVATE LIMITED',
    'TANGO VENTURES PRIVATE LIMITED',
    'FAIRLANDS TECHNOLOGY SERVICES PRIVATE LIMITED',
    'EKKI HOMA PRIVATE LIMITED',
    'PEGASI PRODUCTION STUDIOS PRIVATE LIMITED',
    'AVM GENERAL TRADING INDIA PRIVATE LIMITED',
    'SRPLUS VISION PRIVATE LIMITED',
    'SAHAS GLOBAL SAFETY PRIVATE LIMITED',
    'VERVESEMI MICROELECTRONICS PRIVATE LIMITED',
    'BR RAYSOFT GLOBAL PRIVATE LIMITED',
    'SYNCNETIC DIGITAL PRIVATE LIMITED',
    'INDRADHANUSHI SERVICES PRIVATE LIMITED',
    'VAP IT CONSULTING PRIVATE LIMITED',
    'YELLOWSTONE SOF2TECH PRIVATE LIMITED',
    'GAITONDE TECHNICAL SERVICES PRIVATE LIMITED',
    'S-GEN ENERGY AND INFRA PRIVATE LIMITED',
    'PRIME GLOBAL ACCOMMODATION SERVICES PRIVATE LIMITED',
    'KILN SOLAR ENERGY PRIVATE LIMITED',
    'TAPER SOLAR ENERGY LIMITED',
    'CODESTORE TECHNOLOGIES PRIVATE LIMITED',
    'CANGRA TALENTS PRIVATE LIMITED',
    'BUTCHERS CHENNAI PRIVATE LIMITED',
    'CHAKRA DRUGS PRIVATE LIMITED',
    'GURUNANAK PAINTS INDIA PRIVATE LIMITED',
    'XCUTIVES OUTSOURCING SERVICES (OPC) PRIVATE LIMITED',
    'KREEK E-COMMERCE PRIVATE LIMITED',
    'BHADLA RENEWABLE POWER PRIVATE LIMITED',
    'SENKAR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BLS CORPORATE SERVICES PRIVATE LIMITED',
    'XENESIS DATACORP TECHNOLOGIES PRIVATE LIMITED',
    'MAGNIC TECHNOLOGIES PRIVATE LIMITED',
    'KBMTAX CONSULTANT (OPC) PRIVATE LIMITED',
    'SMIT & ZOON INDIA PRIVATE LIMITED',
    'ALAGAPPAA CAR.E PRIVATE LIMITED',
    'FLYONSKY PRIVATE LIMITED',
    'MY RIGHT ELUCIDATE PRIVATE LIMITED',
    'YUMPTIOUS FOODS PRIVATE LIMITED',
    'HEALERSARK RESOURCES PRIVATE LIMITED',
    'MMR TELESYSTEMS PRIVATE LIMITED',
    'ENAAYAH SOFTWARE DEVELOPMENT AND SERVICES PRIVATE LIMITED',
    'NEXREA PRIVATE LIMITED',
    'GAMEBERRY LABS PRIVATE LIMITED',
    'ZANZERIA FAMILY CONSULTANTS (OPC) PRIVATE LIMITED',
    'BLUE PRISM INDIA PRIVATE LIMITED',
    'FOODNOLOGY INDIA PRIVATE LIMITED',
    'BAREBACK MEDIA PRIVATE LIMITED',
    'BAFFLESOL TECHNOLOGIES PRIVATE LIMITED',
    'MACROSIVE COMPUTER SOLUTIONS PRIVATE LIMITED',
    'STUNNTECH INNOVATIONS PRIVATE LIMITED',
    'SINGULARITY LABS PRIVATE LIMITED',
    'JTM INTERNET PRIVATE LIMITED',
    'UPSQUARE SOLUTIONS PRIVATE LIMITED',
    'JEEN WEB TECHNOLOGISTS PRIVATE LIMITED',
    'UNNATHI IT SERVICES INDIA PRIVATE LIMITED',
    'GRIPLA TECHNOLOGIES PRIVATE LIMITED',
    'SALASAR CYBER SOLUTIONS PRIVATE LIMITED',
    'AASEYA IT SERVICES PRIVATE LIMITED',
    'TEBILLION SYSTEMS PRIVATE LIMITED',
    'CODGREY TECHNOLOGIES PRIVATE LIMITED',
    'SHAIBIG INFOSYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'LIVISION IT PRIVATE LIMITED',
    'IMPLANTAIRE SYSTEMS PRIVATE LIMITED',
    'IVANTAGE ADVANCED SYSTEMS PRIVATE LIMITED',
    'UDVAT TECHNOLOGIES PRIVATE LIMITED',
    'CODIOS WEB SOLUTIONS PRIVATE LIMITED',
    'NOON E-COMMERCE INDIA PRIVATE LIMITED',
    'WEGREN TECHNOLOGIES PRIVATE LIMITED',
    'EKADANTA PRIVATE LIMITED',
    'NAVIKRA TECH SOLUTIONS PRIVATE LIMITED',
    'ROBONOID TECHNOLOGIES PRIVATE LIMITED',
    'FREE STAND SAMPLING SOLUTIONS PRIVATE LIMITED',
    'ADISHAKTI TECHNOLOGY PRIVATE LIMITED',
    'PERDISCOO TECHNOLOGIES PRIVATE LIMITED',
    'HASURA TECHNOLOGIES PRIVATE LIMITED',
    'FELBUKKAN TECHNOLOGIES PRIVATE LIMITED',
    'SHARED LABS INDIA PRIVATE LIMITED',
    'CUSPERA PRIVATE LIMITED',
    'SCOPT ANALYTICS PRIVATE LIMITED',
    'CONEXAO TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'HASHTG SYSTEMS INDIA PRIVATE LIMITED',
    'INNOVARTZ IT SERVICES PRIVATE LIMITED',
    'NETGENESIS TECHNOLOGIES PRIVATE LIMITED',
    'KRAYONS CONVERGENCE PRIVATE LIMITED',
    'IRASYS SOFTTECH PRIVATE LIMITED',
    'APPIOTIC TECHNOLOGIES PRIVATE LIMITED',
    'ASTERITE PRIVATE LIMITED',
    'DQ DATAQAPPS TECHNOLOGIES PRIVATE LIMITED',
    'XENBI WEB TECHNOLOGIES PRIVATE LIMITED',
    'MASSIV BIT PRIVATE LIMITED',
    'LENDINGPARK SOLUTIONS PRIVATE LIMITED',
    'ACUTEWORX TECHNOLOGIES AND SERVICES PRIVATE LIMITED',
    'IMM SALES INDIA PRIVATE LIMITED',
    'GOOGLE INFORMATION SERVICES INDIA PRIVATE LIMITED',
    'YASHVI WEB TECH PRIVATE LIMITED',
    'HAKATE TECHNOLOGIES PRIVATE LIMITED',
    'EDITORIALIST INDIA PRIVATE LIMITED',
    'DIGITIZER ACCESS NETWORK PRIVATE LIMITED',
    'EBIZTRAIT TECHNOLABS PRIVATE LIMITED',
    'DATAVIM ANALYTICS SOLUTIONS PRIVATE LIMITED',
    'MERAQUI VENTURES PRIVATE LIMITED',
    'RAIN INFOTECH PRIVATE LIMITED',
    'XUPER COMPUTECH PRIVATE LIMITED',
    'CIRCUS ELEPHANTS CONTENT MARKETING SOLUTIONS PRIVATE LIMITED',
    'INDO BUSINESS CONTINUITY PRIVATE LIMITED',
    'BEEBOX STUDIOS PRIVATE LIMITED',
    'SAKASH TECHNOLOGY MANAGEMENT PRIVATE LIMITED',
    'DZTRANZ INDIA PRIVATE LIMITED',
    'NETZI BROADBAND SERVICES PRIVATE LIMITED',
    'DIT PROJECTS PRIVATE LIMITED',
    'TANGO IT SOLUTIONS INDIA PRIVATE LIMITED',
    'SAI RAGHAVENDRA DATA LAKE SOLUTIONS PRIVATE LIMITED',
    'ASTRIOVEA INDIA PRIVATE LIMITED',
    'PRIZMA DIGITECH PRIVATE LIMITED',
    'INORBIT ADNET PRIVATE LIMITED',
    'RANPISE DIGITECH SOLUTIONS PRIVATE LIMITED',
    'JUST24 INTELLECTUAL DESIGN PRIVATE LIMITED',
    'IGENIEE CONCEPTS PRIVATE LIMITED',
    'CODEBREW INNOVATIONS PRIVATE LIMITED',
    'ATTALIDS INFOTECH PRIVATE LIMITED',
    'XECTA SOLUTIONS PRIVATE LIMITED',
    'GRCC INFRACON INDIA PRIVATE LIMITED',
    'TRUSTUS INFRALAND DEVELOPERS PRIVATE LIMITED',
    'EQSOFT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'THRIAM REALTY PRIVATE LIMITED',
    'TRUSTWORTH REALTECH PRIVATE LIMITED',
    'MMG INVESTMENT SERVICES PRIVATE LIMITED',
    'VISTASPACES EPC PRIVATE LIMITED',
    'MAYSONS INFRASTRUCTURE PRIVATE LIMITED',
    'IASSIST ADVISORY PRIVATE LIMITED',
    'HOSTCHARLIE PRIVATE LIMITED',
    'SINGULARITY DYNAMICS PRIVATE LIMITED',
    'JODOVA TECHNOLOGIES PRIVATE LIMITED',
    'JPY CONSORTIUM PRIVATE LIMITED',
    'AMAARA RESIDENCES PRIVATE LIMITED',
    'USHUR TECHNOLOGIES PRIVATE LIMITED',
    'CODE FUSION PRIVATE LIMITED',
    'JAMSONS TECH CARE PRIVATE LIMITED',
    'SOFRITEK PRIVATE LIMITED',
    'VARCHAS ANIMATION STUDIOS PRIVATE LIMITED',
    'PARDOS REALTORS PRIVATE LIMITED',
    'KFIN TECHNOLOGIES LIMITED',
    'CAERUS CONSULTANCY PRIVATE LIMITED',
    'PERSONIC E-TECH PRIVATE LIMITED',
    'LAMA ENGINEERS AND CONTRACTORS PRIVATE LIMITED',
    'REVCLERX PRIVATE LIMITED',
    'FERNANDES SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED',
    'IMPRULIFE VENTURE PRIVATE LIMITED',
    'CREOLE CHEMTECH PRIVATE LIMITED',
    'WHYREL WORLD MARKETING PRIVATE LIMITED',
    'MAGIKOS CLOUD PRIVATE LIMITED',
    'JAMMU GYMKHANA CLUB LIMITED',
    'WIDMANS LABORATORY PRIVATE LIMITED',
    'SHREEMULTI STICKS & LABELS PRIVATE LIMITED',
    'AGROSIRI PRIVATE LIMITED',
    'IGNOXLABS PRIVATE LIMITED',
    'EXEMPLAR GLOBAL RESOURCES PRIVATE LIMITED',
    'WELSPUN FINANCIAL SERVICES LIMITED',
    'UMIRO RESOURCES PRIVATE LIMITED',
    'THEMATCHBOX.CO MEDIA PRIVATE LIMITED',
    'MANTHANA INDUSTRIES PRIVATE LIMITED',
    'PHYGICART E-COMMERCE PRIVATE LIMITED',
    'QUAINTEC IT PRIVATE LIMITED',
    'ABIT CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'CLOUDSTICK TECHNOLOGIES PRIVATE LIMITED',
    'EKAMRA REALTOR PRIVATE LIMITED',
    'ALDEE WATER PRIVATE LIMITED',
    'TRAVEL VILLA PRIVATE LIMITED',
    'CHINA CONSTRUCTION EIGHTH ENGINEERING DIVISION INDIA PRIVATE LIMITED',
    'BULLS QUANT AMRO PRIVATE LIMITED',
    'ECOREN CARDEA POWER PRIVATE LIMITED',
    'STYLE PLUS HOME FASHIONS PRIVATE LIMITED',
    'SALIGO CONPRO PRIVATE LIMITED',
    'HAISUI INNOVATION PRIVATE LIMITED',
    'IDEX EVENTS PRIVATE LIMITED',
    'VISTARAN TECHTRONIX PRIVATE LIMITED',
    'HIGHTECH BROADBAND SERVICES PRIVATE LIMITED',
    'IGNITE LPG TRACK PRIVATE LIMITED',
    'VCSDATA ONLINE SERVICES PRIVATE LIMITED',
    'L&K WELLNESS SERVICES PRIVATE LIMITED',
    'JAMSHEDPUR FOOTBALL AND SPORTING PRIVATELIMITED',
    'BJK DESIGNS PRIVATE LIMITED',
    'MANIMENON PROJECTS PRIVATE LIMITED',
    'MEDICOM INTERNATIONAL EYETECH PRIVATE LIMITED',
    'RENEES HOLIDAYS PRIVATE LIMITED',
    'PRP REALTY PRIVATE LIMITED',
    'CLINICAL NUTRITION PRIVATE LIMITED',
    'DAY WALKER ENTERTAINMENT PRIVATE LIMITED',
    'KLASS INSOLVENCY RESOLUTION PROFESSIONALS PRIVATE LIMITED',
    'MASTUL INFOTECH PRIVATE LIMITED',
    'NOVOLUTIONS FOOD & BEVERAGE PRIVATE LIMITED',
    'GREENER RURAL INITIATIVES PRIVATE LIMITED',
    'VIRTUTRONIX TECHNOLOGIES PRIVATE LIMITED',
    'TREKSCOM DISTRIBUTION (INDIA) PRIVATE LIMITED',
    'GLAMLOOKS STUDIO PRIVATE LIMITED',
    'RAMSYN PRIVATE LIMITED',
    'ECOREN POSEIDON POWER PRIVATE LIMITED',
    'AERROW ELECTRICALS PRIVATE LIMITED',
    'ERDE EXPORTS PRIVATE LIMITED',
    'SMC HEART INSTITUTE AND IVF RESEARCH CENTRE PRIVATE LIMITED',
    'SHOOLPANI ENTERPRISES PRIVATE LIMITED',
    'MINIONLABS INDIA PRIVATE LIMITED',
    'CONBOX LOGISTICS PRIVATE LIMITED',
    'GAR LAXMI INFOBAHN PRIVATE LIMITED',
    'GRIHALAYA BUILDERS PRIVATE LIMITED',
    'NEXTWIN SYSTEMS PRIVATE LIMITED',
    'CHORAL ADVENTURE AND AMUSEMENT PARK PRIVATE LIMITED',
    'DIGIFY ENGINEERING PRIVATE LIMITED',
    'ORPHIC DESIGN STUDIO PRIVATE LIMITED',
    'TECHIES TIME TO TEA PRIVATE LIMITED',
    'MITRATULYA SAMADHAN SEVA PRIVATE LIMITED',
    'KSJ RECRUITMENT PRIVATE LIMITED',
    'SICCION LABS PRIVATE LIMITED',
    'RAHGUN TECHNOLOGIES PRIVATE LIMITED',
    'INDOASIA REAL ESTATE PRIVATE LIMITED',
    'ALFRESCO EVENTS PRIVATE LIMITED',
    'NIMBLEOPUS INTELLIGENT SOLUTIONS PRIVATELIMITED',
    'DEGATECH ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED',
    'ATI ELECTRONICS INDIA PRIVATE LIMITED',
    'GAROH POWERSYS PRIVATE LIMITED',
    'ARWAH HOSPITALITY AND TRADING PRIVATE LIMITED',
    'GRAVITAS GLOBAL SOLUTIONS PRIVATE LIMITED',
    'GLOCAL TRAVEL EXPERIENCES PRIVATE LIMITED',
    'COMPUBRAIN INTERNETICS PRIVATE LIMITED',
    'AGRUM FOODS INDIA PRIVATE LIMITED',
    'PRAMODA RETAIL PRIVATE LIMITED',
    'WATERING CAN FOUNDATION',
    'SYKASYS TECHNOLOGIES PRIVATE LIMITED',
    'STEALTH ANALYTICS & BUSINESS SOLUTIONS PRIVATE LIMITED',
    'INVESTADVISE ITHEMBA INDIA PRIVATE LIMITED',
    'AUCTOREM SOLUTIONS PRIVATE LIMITED',
    'FEDERATION OF SPORTS GAMING',
    'GUSTO CHOCOLATIER PRIVATE LIMITED',
    'HNA TELESYSTEMS INDIA PRIVATE LIMITED',
    'ASIAN CONVENTIONS & EXPOSITIONS PRIVATE LIMITED',
    'GARZZO PRIVATE LIMITED',
    'SHOPAT1 SHOPPING AND SERVICES PRIVATE LIMITED',
    'AAKASHRAJ PARADISE PRIVATE LIMITED',
    'BLUEBETELS PRIVATE LIMITED',
    'BITRA TECH (OPC) PRIVATE LIMITED',
    'SCHOOLGOERS EDUCATION FOUNDATION INDIA',
    'EZE INTELLIGENCE PRIVATE LIMITED',
    'HOPCLICK HOSPITALITY PRIVATE LIMITED',
    'CODEBREAK PRIVATE LIMITED',
    'ECW CONSULTANTS PRIVATE LIMITED',
    'IAMPS AND HZ TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ELSCINT INDIA PRIVATE LIMITED',
    'NUTRIOS FOODS PRIVATE LIMITED',
    'PIIRITU INNOVATIONS PRIVATE LIMITED',
    'DAWES INFRASTRUCTURE DEVELOPMENT INTERNATIONAL PRIVATE LIMITED',
    'EXELLAR SOLUTIONS PRIVATE LIMITED',
    'RAPHE MPHIBR PRIVATE LIMITED',
    'TRANSINTERFACE DIGISERV PRIVATE LIMITED',
    'GOODWORKS INFRA PRIVATE LIMITED',
    'SUGAR MONEY FINANCIAL SERVICES PRIVATE LIMITED',
    'RREGULUS TECHNOLOGIES SOLUTIONS PRIVATE LIMITED',
    'URBASER INDIA PRIVATE LIMITED',
    'CONFER GLOBAL PRIVATE LIMITED',
    'HYPHENOS SOFTWARE LABS PRIVATE LIMITED',
    'PRAKRITI HANDICRAFTS (OPC) PRIVATE LIMITED',
    'SCREENMAX MEDIA PRIVATE LIMITED',
    'IBSB TECHNOLOGIES PRIVATE LIMITED',
    'BB TOUR AND TRAVELS PRIVATE LIMITED',
    'AYURMITRA HERBOMINERALS PRIVATE LIMITED',
    'KUBOT FINTECH PRIVATE LIMITED',
    'ENPHASE SOLAR ENERGY PRIVATE LIMITED',
    'CPG AQUA PRIVATE LIMITED',
    'RESHIP MART PRIVATE LIMITED',
    'DRAYMAN TECHNOLOGIES PRIVATE LIMITED',
    'DREAMVU INDIA PRIVATE LIMITED',
    'BEVERLY HILLS BUILDTECH PRIVATE LIMITED',
    'ALLISWELL BIOHEALTH PRIVATE LIMITED',
    'MAKEMYINFRA PRIVATE LIMITED',
    'FORTRESS WELFARE FOUNDATION',
    'ASHWINI VENTURES PRIVATE LIMITED',
    'PETPEDIA PRIVATE LIMITED',
    'INTHINKS GADGETS PRIVATE LIMITED',
    'IGM SOLUTIONS PRIVATE LIMITED',
    'TNC AVIATION PRIVATE LIMITED',
    'SURDEEP INFRA PROJECTS PRIVATE LIMITED',
    'BLANDCODE LABS PRIVATE LIMITED',
    'RAJHANS DIGITAL PRIVATE LIMITED',
    'CONVENIENCE RESTAURANTS PRIVATE LIMITED',
    'URBANLEAD INDIA PRIVATE LIMITED',
    'HARAREI INDIA PRIVATE LIMITED',
    'BRICK EAGLE AFFORDABLE HOUSING FINANCE LIMITED',
    'VCM TRANS SOLUTION PRIVATE LIMITED',
    'BRIGHTSANDZ CLEAN TECH PRIVATE LIMITED',
    'CATH PHARMACY RETAIL PRIVATE LIMITED',
    'ENTHUSIONZ DIGITAL PRIVATE LIMITED',
    'RICHCOM STUDIO PRIVATE LIMITED',
    'ULTRA DECOR PRIVATE LIMITED',
    'IMAPLETREE CONSTRUCTIONS PRIVATE LIMITED',
    'FYNAMICS ADVISORY PRIVATE LIMITED',
    'PHOVOEZOLAR ENERGY PRIVATE LIMITED',
    'VARASHAKTI HOUSING FINANCE PRIVATE LIMITED',
    'CALORIE KITCHEN CORPORATE FOODTECH PRIVATE LIMITED',
    'BREAKMARK EDUCATION PRIVATE LIMITED',
    'SRIUNHAT METALIKS PRIVATE LIMITED',
    'JYACAD SOLUTIONS PRIVATE LIMITED',
    'LIGHTRON INDUSTRIES PRIVATE LIMITED',
    'AJV REALITY BUILDERS PRIVATE LIMITED',
    'ARCWHALES INNOVATIVE TECHNOLOGIES PRIVATE LIMITED',
    'SOL RESOURCES PRIVATE LIMITED',
    'PROFICIENT SECURITY & FACILITY MANAGEMENT PRIVATE LIMITED',
    'BANGGOOD ECOMMERCE PRIVATE LIMITED',
    'ANGELS FORCE SECURITAS PRIVATE LIMITED',
    'COLLIGATE INDIA PRIVATE LIMITED',
    'I MONEY WALLET PRIVATE LIMITED',
    'NAVVANDIT INFRACON PRIVATE LIMITED',
    'YUGAN INFO INDIA PRIVATE LIMITED',
    'NYK MEDICAL TOURISM PRIVATE LIMITED',
    'IMPERIAL FLEXIPACK PRIVATE LIMITED',
    'KRISHIVRAM LOGISTICS PRIVATE LIMITED',
    'MIH THEMATIC TRAILS PRIVATE LIMITED',
    'PJ VENTURES (INDIA) PRIVATE LIMITED',
    'JARDENS CAPABILITY DEVELOPERS (OPC) PRIVATE LIMITED',
    'YS TRAVEL SPHERE PRIVATE LIMITED',
    'ORION DATA COMPLIANCE SOLUTIONS INDIA PRIVATE LIMITED',
    'INNOVEDS TECH SOLUTIONS PRIVATE LIMITED',
    'TORSA EQUIPMENTS PRIVATE LIMITED',
    'JAYTH MARKETING PRIVATE LIMITED',
    'ATHACHI COSMECEUTICALS PRIVATE LIMITED',
    'INTERCONTINENTAL SPORTS EDUCATION AND RESEARCH FOUNDATION',
    'MANZEEL MERCHANT PRIVATE LIMITED',
    'AUTOBOT INFOSEC PRIVATE LIMITED',
    'KSHIPRA VENTURES PRIVATE LIMITED',
    'ANASHWAR TECHNOLOGIES PRIVATE LIMITED',
    'SUMANTHI TECHNOLOGY PRIVATE LIMITED',
    'PARSHU TECHNOCRATS PRIVATE LIMITED',
    'DIVYERA ENGINEERS PRIVATE LIMITED',
    'KONTIKI INNOVATION LABS PRIVATE LIMITED',
    'HECATE STRATEGIC CONSULTANCY (OPC) PRIVATE LIMITED',
    'ESCALATE GLOBAL IT SOLUTIONS PRIVATE LIMITED',
    'VAP MEDCARE PRIVATE LIMITED',
    'GLOBAL PEO SERVICE INDIA PRIVATE LIMITED',
    'JSM HEALTHCARE PRIVATE LIMITED',
    'QUANTIKA INFRA PRIVATE LIMITED',
    'TECHPARTNER ALLIANCE PRIVATE LIMITED',
    'ERLENDIS SOLUTIONS INDIA PRIVATE LIMITED',
    'CUBIT BUSINESS CENTRE PRIVATE LIMITED',
    'TECKXPERT KNOWLEDGE SERVICES PRIVATE LIMITED',
    'INSTANT TECHLABS INTERNET PRIVATE LIMITED',
    'GHAGANE AVIATION PRIVATE LIMITED',
    'NEPTUNE UBICOM PRIVATE LIMITED',
    'CROSSWAY HOTELS AND RESORTS PRIVATE LIMITED',
    'PONTUS PAPER PRODUCTS PRIVATE LIMITED',
    'DISCIDIUM INTERNET LABS PRIVATE LIMITED',
    'FAMEORIES BUSINESS SERVICES PRIVATE LIMITED',
    'SEA CARE SHIPPING PRIVATE LIMITED',
    'SOLIEL RESTAURANT PRIVATE LIMITED',
    'AZURE RESTAURANTS PUNE PRIVATE LIMITED',
    'WHITE HAT WINE & HOSPITALITY PRIVATE LIMITED',
    'SNS HOTELS PRIVATE LIMITED',
    'UDAAN HOTELS & RESORTS PRIVATE LIMITED',
    'ASHTAK BIO TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'AZIONI HEALTHCARE PRIVATE LIMITED',
    'IMOPTIMUS AUTOMATION SYSTEMS PRIVATE LIMITED',
    'CIBUS FACTORY INDIA PRIVATE LIMITED',
    'TAKSH LIFESCIENCES PRIVATE LIMITED',
    'LIFE OF RILEY PRIVATE LIMITED',
    'VEURINSE INTERNATIONAL PRIVATE LIMITED',
    'VIDARBHA AMUSEMENT PARK PRIVATE LIMITED',
    'AYUWELEX PRIVATE LIMITED',
    'MEJORHUB RESTAURANT AND HOTELS PRIVATE LIMITED',
    'SKY LOGITRANS PRIVATE LIMITED',
    'ARTQUBE RETAIL PRIVATE LIMITED',
    'JOHN HUCKLEBERRY RETAIL PRIVATE LIMITED',
    'TRIFECTA AUTOMOTIVE PRIVATE LIMITED',
    'TOUCHTWICE VENTURES PRIVATE LIMITED',
    'QUIRQSTATION RETAIL PRIVATE LIMITED',
    'BUCKETLIST TRADING PRIVATE LIMITED',
    'VITHARANA DISTRIBUTORS PRIVATE LIMITED',
    'PRIYANKA TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'SAKET TRANSCARE PRIVATE LIMITED',
    'PALIKANDY MARTS PRIVATE LIMITED',
    'QEXCLUSIVE ONLINE SHOP PRIVATE LIMITED',
    'DULICHAND CONSTRUCTION EQUIPMENT PRIVATELIMITED',
    'CELOX SHIPPING PRIVATE LIMITED',
    'MAPU TRADE LINKS PRIVATE LIMITED',
    'IIIEM GLOBAL EDUTECH PRIVATE LIMITED',
    'ACHIEVERS UNIFIE PRIVATE LIMITED',
    'VARUN INAMDAR HOSPITALITY PRIVATE LIMITED',
    'SVIZZERA HOSPITALITY PRIVATE LIMITED',
    'REVOLT CLUBS PRIVATE LIMITED',
    'INCREDIBLE CATERERS PRIVATE LIMITED',
    'SPLENOR HOSPITALITY PRIVATE LIMITED',
    'KALANAURIA FOODS PRIVATE LIMITED',
    'AGK HOTELS INTERNATIONAL PRIVATE LIMITED',
    'PAX HOTELS AND RESORTS PRIVATE LIMITED',
    'WINGLINE FREIGHT INDIA PRIVATE LIMITED',
    'S3 FUEL PRIVATE LIMITED',
    'DEVI FREIGHTAGE PRIVATE LIMITED',
    'LUMAX ITURAN TELEMATICS PRIVATE LIMITED',
    'PAROTRAVEL INFOSOLUTIONS PRIVATE LIMITED',
    'STS BUSINESS PRIVATE LIMITED',
    'VFLY WORLDWIDE PRIVATE LIMITED',
    'AMITH INTEGRATED FREIGHT SERVICES PRIVATE LIMITED',
    'KARUNADU SERVICES PRIVATE LIMITED',
    'CGL PROJECTS PRIVATE LIMITED',
    'ZODIAC HOLIDAYS INDIA PRIVATE LIMITED',
    'SE FINANCE PRIVATE LIMITED',
    'KIRANA KING RETAIL PRIVATE LIMITED',
    'HI-PICK PRODUCTS PRIVATE LIMITED',
    'CARE CLEARING HOUSE PRIVATE LIMITED',
    'RIANA INVESTMENTS PRIVATE LIMITED',
    'CAPITAL INDIA HOME LOANS LIMITED',
    'INAAYA FOREX PRIVATE LIMITED',
    'TOURMALINE HOTEL ADVISERS PRIVATE LIMITED',
    'INCREDIBLE RESTAURANTS PRIVATE LIMITED',
    'CAPTIVICAL TECH SOLUTIONS PRIVATE LIMITED',
    'VG JOURNEY PRIVATE LIMITED',
    'DIAMOND ROADLINES PRIVATE LIMITED',
    'CAPITAL INDIA WEALTH MANAGEMENT PRIVATE LIMITED',
    'EGATE SHIPPING SERVICES PRIVATE LIMITED',
    'QUALITY HOLIDAYS AND CARS PRIVATE LIMITED',
    'GOLDCASH LIMITED',
    'ASTERN SHIPPING & LOGISTICS PRIVATE LIMITED',
    'SEWA VISION NIDHI LIMITED',
    'KGS EXPO PRIVATE LIMITED',
    'TRAYDO LOGISTICS PRIVATE LIMITED',
    'DEXPRO LOGISTICS PRIVATE LIMITED',
    'OSPREY LOGISTICS PRIVATE LIMITED',
    'BISWAKARMA TRANSMIT PRIVATE LIMITED',
    'TORTUGA WEALTH MANAGERS PRIVATE LIMITED',
    'SVOJAS INSURANCE BROKING AND RISK MANAGEMENT SERVICES PRIVATE LIMITED',
    'STAR PROFESSIONAL MANAGEMENT CONSULTANCYPRIVATE LIMITED',
    'MARINE TO ALPINE PRIVATE LIMITED',
    'CROSS POST NETWORK PRIVATE LIMITED',
    'PRIMUS INSOLVENCY RESOLUTION & VALUATIONPRIVATE LIMITED',
    'REIJIRO NETWORKS PRIVATE LIMITED',
    'MONTAJES EIS INSTALACIONES SULTANA PRIVATE LIMITED',
    'CAMILA REALTY VENTURES PRIVATE LIMITED',
    'SIKKA DIGITAL PRIVATE LIMITED',
    'JAKKUR PROMOTERS PRIVATE LIMITED',
    'VEE ESS TRADING PRIVATE LIMITED',
    'NITYA NIDHI INDIA LIMITED',
    'VERITE VALUE HOMES PROJECTS PRIVATE LIMITED',
    'KRIPRA REAL ESTATE PRIVATE LIMITED',
    'HARITA TWO WHEELER MALL PRIVATE LIMITED',
    'DOLAT FINSERV PRIVATE LIMITED',
    'HEYTIGER HOUSING FINANCE PRIVATE LIMITED',
    'SRINIVASAN TRADING PRIVATE LIMITED',
    'INVOR BUILDTECH PRIVATE LIMITED',
    'MOGAN DEVELOPERS PRIVATE LIMITED',
    'SUNDARAM-CLAYTON LIMITED',
    'ARAM INTERNATIONAL LOGISTICS PRIVATE LIMITED',
    'MOBIKWIK FINANCE PRIVATE LIMITED',
    'BITS MONEY (INDIA) LIMITED',
    'VTA ENGINEERING SERVICES PRIVATE LIMITED',
    'VMS MEDIA PRIVATE LIMITED',
    'MOHIT FREIGHT FORWARDERS PRIVATE LIMITED',
    'VIRAG MADHUMALATI ENTERTAINMENT PRIVATE LIMITED',
    'ANT LIFESTYLE PRIVATE LIMITED',
    'AKTRO TECHNOLOGIES PRIVATE LIMITED',
    'VOX POPULI RESEARCH AND CONSULTANCY PRIVATE LIMITED',
    'DGLEADS TECHNOLOGIES PRIVATE LIMITED',
    'DIVY ENFORCEMENT AND SECURITY PRIVATE LIMITED',
    'EDUCATIONISTA EXPOSITIONS PRIVATE LIMITED',
    'JPW HOMEWARE CREATIONS PRIVATE LIMITED',
    'BCHAMP SPORTS & FITNESS PRIVATE LIMITED',
    'TALENT THRILL CONSULTING (OPC) PRIVATE LIMITED',
    'ORONE 10 MEDIA SERVICES PRIVATE LIMITED',
    'WESTBRIDGE BESPOKE PRIVATE LIMITED',
    'ACUMEN PACKAGING PRIVATE LIMITED',
    'THETABETA ANALGORITHMS PRIVATE LIMITED',
    'MDJ TRADING PRIVATE LIMITED',
    'SUSHANKU REALTY PRIVATE LIMITED',
    'BORN2ACT MEDIA ENTERTAINMENT PRIVATE LIMITED',
    'CONEX CONTAINER LINES PRIVATE LIMITED',
    'MAECENAS CONSULTING PRIVATE LIMITED',
    'CRESTONE AVIATION PRIVATE LIMITED',
    'INOVEX SOLUTIONS PRIVATE LIMITED',
    'SIDR SOLUTIONS AND TECHNOLOGIES PRIVATE LIMITED',
    'SINGLESPOON SPICES PRIVATE LIMITED',
    'SKFF PRIVATE LIMITED',
    'GLOBAL GYPSUM PRIVATE LIMITED',
    'BLUMEN BIOVITALS HEALTHKARE PRIVATE LIMITED',
    'APARAA AGRO TRADE AND CREATION PRIVATE LIMITED',
    'HALYCON ADVISORY PRIVATE LIMITED',
    'VIONA INTERIORS (OPC) PRIVATE LIMITED',
    'ZEROJHANJHAT ACCOMODATION SERVICES PRIVATE LIMITED',
    'BHAD ENGINEERS PRIVATE LIMITED',
    'FEELTECH TRADING AND RETAIL PRIVATE LIMITED',
    'ZION CONCEPTS PRIVATE LIMITED',
    'SILO SQUARE LABS PRIVATE LIMITED',
    'CLEAN MAX PHOTOVOLTAIC PRIVATE LIMITED',
    'MAHARISHI VEDIC HEALTH PRIVATE LIMITED',
    'WASSERTEK MACHINERY INDIA PRIVATE LIMITED',
    'SAVEARTH PEOPLE SOLUTIONS PRIVATE LIMITED',
    'CLEAN MAX MERCURY POWER PRIVATE LIMITED',
    'MEERUT BIO-ENERGY SYSTEMS PRIVATE LIMITED',
    'INTO23 CONTENT SOLUTIONS PRIVATE LIMITED',
    'MAHARASHTRA RAIL INFRASTRUCTURE DEVELOPMENT CORPORATION LIMITED',
    'MITTAL CRAFTWORKS PRIVATE LIMITED',
    'QIROSOFT ENGINEERING PRIVATE LIMITED',
    'EOSCAR IMMIGRATION SERVICES PRIVATE LIMITED',
    'UNFOLDU GLOBAL MARKETING PRIVATE LIMITED',
    'BOSHION SERVICES PRIVATE LIMITED',
    'LMS CRICKET PRIVATE LIMITED',
    'SASMITA BUSSINESS SOLUTIONS PRIVATE LIMITED',
    'INFIVERSE TECH PRIVATE LIMITED',
    'NEXTON FOODS PRIVATE LIMITED',
    'PUNE CHILDREN',
    'S BRANDS PRIVATE LIMITED',
    'CHENNAI SHERPA ADVENTURES (OPC) PRIVATE LIMITED',
    'SUPER FINSERV PRIVATE LIMITED',
    'PARU INTECHSOL PRIVATE LIMITED',
    'DR. JOY',
    'CLOCK RETAILS PRIVATE LIMITED',
    'SKYHIGH INFRAPROJECTS PRIVATE LIMITED',
    'SAISWAROOP REALTY PRIVATE LIMITED',
    'VRISHADA INFRAHEIGHTS PRIVATE LIMITED',
    'D.S. INFRAHEIGHTS PRIVATE LIMITED',
    'SIKKA INFRATECH PRIVATE LIMITED',
    'SRB INFRADEVELOPERS PRIVATE LIMITED',
    'Shalimar Malls Private Limited',
    'RISHITA REALINFRA PRIVATE LIMITED',
    'Prime Assetz World Private Limited',
    'TERRAZONE ESTABLISHMENT PRIVATE LIMITED',
    'HAJARIA INFRA & HIGHWAY SOLUTIONS PRIVATE LIMITED',
    'SAINATH INFRAESTATES PRIVATE LIMITED',
    'RISHITA REALTECH PRIVATE LIMITED',
    'R G INFRACITY PRIVATE LIMITED',
    'LANDMARK BOOKS PRIVATE LIMITED',
    'IMPULSE MICROELECTRONICS PRIVATE LIMITED',
    'E. SOFT TECHNOLOGIES PRIVATE LIMITED',
    'MAYA MACHINERY PRIVATE LIMITED',
    'PEER PAPERMACHINES PRIVATE LIMITED',
    'PANCHVATI HERBALS PRIVATE LIMITED',
    'BAWA AUTO DEALERS PRIVATE LIMITED',
    'TALWAR MARKETING PRIVATE LIMITED',
    'CO-OPERATIVE COMPANY LIMITED',
    'KAKKAR IMPEX PRIVATE LIMITED',
    'A L M DEVELOPERS PRIVATE LIMITED',
    'ODISI SOFTWARE PRIVATE LIMITED',
    'DIRO TECH PRIVATE LIMITED',
    'AARSUN TECHNOLOGIES PRIVATE LIMITED',
    'NORTHERN RIDGE GEOTECH PRIVATE LIMITED',
    'SAHYOG ASSURANCE CONSULTANTS PRIVATE LIMITED.',
    'HEALTHSTAR SOLUTIONS PRIVATE LIMITED',
    'INDUS SHANTI CARPETS INDIA PRIVATE LIMITED',
    'SHREEDHAR CARPETS PRIVATE LIMITED',
    'EASTERN MILLS PRIVATE LIMITED',
    'CHAMPA DYEING PRIVATE LIMITED',
    'ABBAS WAZIR PRIVATE LIMITED',
    'TULSI RAM GAYA PRASAD PRIVATE LIMITED',
    'MABOOD INTERNATIONAL PRIVATE LIMITED',
    'MYHOME COLLECTIONS PRIVATE LIMITED',
    'AGNI CARPET PRIVATE LIMITED',
    'DIGNITY RUGS PRIVATE LIMITED',
    'SAMARA CARPETS PRIVATE LIMITED',
    'SHOBHA WOOLLENS PRIVATE LIMITED',
    'TEXTILE RUBBER AND CHEMICAL COMPANY (INDIA) PRIVATE LIMITED',
    'CARPET INTERNATIONAL PRIVATE LIMITED',
    'BHADOHI SPINNERS PRIVATE LIMITED',
    'BEEKAY WOOLENS PRIVATE LIMITED',
    'PATODIA CONTRACT PRIVATE LIMITED',
    'DESIGN FLOORING PRIVATE LIMITED',
    'RAINBOW WOOLLENS PRIVATE LIMITED',
    'KAY FLAMES PRIVATE LIMITED',
    'SAMARA FLOORING & FABRICS PRIVATE LIMITED',
    'SAS CARPETS PRIVATE LIMITED',
    'WATSON LOGISTICS PRIVATE LIMITED',
    'ARTPALACE EXPORT PRIVATE LIMITED',
    'RAVI RUGS PRIVATE LIMITED',
    'RIZZY ENTERPRISES PRIVATE LIMITED',
    'PARASHU AGRO BIO TECH PRIVATE LIMITED',
    'AKC AUTO PRIVATE LIMITED',
    'KC TANGIBLES PRIVATE LIMITED',
    'VINOD PRAKASH LIFECARE PRIVATE LIMITED',
    'AFREEN FATMA MEDICARE PRIVATE LIMITED',
    'QABILA INFO VENTURE PRIVATE LIMITED',
    'MAGADH SUGAR & ENERGY LIMITED',
    'CINNATOLLIAH TEA LIMITED',
    'AVADH SUGAR & ENERGY LIMITED',
    'MORTON FOODS LIMITED',
    'THE OUDH TRADING CO PRIVATE LIMITED',
    'SINGHANIA YARNS PRIVATE LIMITED',
    'THE LAKSHMIJI ORGANICS PRIVATE LIMITED',
    'MOON CORPORATION LIMITED',
    'Aasan Exports India Private Limited',
    'PALASH SECURITIES LIMITED',
    'GANGES SECURITIES LIMITED',
    'HAFIZIA ART AND CRAFTS PRIVATE LIMITED',
    'RENUKESHWAR INVESTMENTS AND FINANCE LIMITED',
    'RENUKA INVESTMENTS AND FINANCE LIMITED',
    'LUCKNOW FINANCE COMPANY LIMITED',
    'RECENSI INTERNATIONAL PRIVATE LIMITED',
    'Salva Agro Hatcheries Private Limited',
    'GAURAV FLOUR AND RICE MILL PRIVATE LIMITED',
    'SHREE TIRUPATTI DISTRIBUTORS PRIVATE LIMITED',
    'AVADH TRANSFORMERS PRIVATE LIMITED',
    'ANAND DIESELS PRIVATE LIMITED',
    'HI-Q-PAAR EXPORTS PRIVATE LIMITED',
    'KOOSHMANDA COMMUNICATIONS PRIVATE LIMITED',
    'SH INFRATECH PRIVATE LIMITED',
    'U K TECHNOINFRA PRIVATE LIMITED',
    'MRI PUBLICATION PRIVATE LIMITED',
    'OM PACKERS & MOVERS PRIVATE LIMITED',
    'M.B. RICE MILLS PRIVATE LIMITED',
    'MOHAN STEELS LIMITED',
    'ASHRAFI FROZEN FOODS EXPORTS PRIVATE LIMITED',
    'MAYFAIR GLOBAL INDUSTRIES LIMITED',
    'BANARAS BEADS LIMITED',
    'SHRI BHOLANATH CARPETS LIMITED',
    'BENARES HOTELS LIMITED',
    'SURYANSH MERCHANDISE INDIA LIMITED',
    'BANARAS FLAVOURS PRIVATE LIMITED',
    'SURABHI ELECTRICAL PRODUCTS PRIVATE LIMITED',
    'GANESH PRESERVATION PRIVATE LIMITED',
    'MILKLEY FOOD & BEVERAGES INDIA PRIVATE LIMITED',
    'SHREYANSH AGROTECH PRIVATE LIMITED',
    'DIVINE MANTRA PRIVATE LIMITED',
    'BROWN BREAD BAKERY AND ORGANIC FOOD PRIVATE LIMITED',
    'TITICO EXPORTS PRIVATE LIMITED',
    'KARWA SPINNERS PRIVATE LIMITED',
    'KNOTS INDIA CARPETS PRIVATE LIMITED',
    'KAANDLA RUGS PRIVATE LIMITED',
    'MANGLAM FAB PROCESSORS PRIVATE LIMITED',
    'BANARAS HOUSE (VARANASI) LIMITED',
    'BANARAS BEADS EXPORTS PRIVATE LIMITED',
    'MANGLAM INTERTEX LIMITED',
    'SHRI ONKAR PAPER AND BOARD MILLS PRIVATE LIMITED',
    'TALWAR COMMERCIAL PRIVATE LIMITED',
    'J.J. PLASTALLOY PRIVATE LIMITED',
    'GOYAL HERBALS PRIVATE LIMITED',
    'AVANTIKA PHARMA (DISTRIBUTORS) PRIVATE LIMITED',
    'SUKHEN HOSPITALITIES PRIVATE LIMITED',
    'BI BIOTECH INDIA PRIVATE LIMITED',
    'HEM GANGA POLYTEX PVT.LTD.',
    'SABAL ENTERPRISES PRIVATE LIMITED',
    'TRILOCHAN STEELS AND ALLOYS PVT.LTD.',
    'iNative Tech Solutions Private Limited',
    'QUALMINDS TECHNOLOGIES PRIVATE LIMITED',
    'INSTIGATE SOFTWARE PRIVATE LIMITED',
    'VOLTEO TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'MYTHRI TECHNO SOLUTIONS PRIVATE LIMITED',
    'Pyrus IT Solutions Private Limited',
    'Prufer Logic Technologies Private Limited',
    'HIRING IDEAS AND SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ESPERANZA TECH PRIVATE LIMITED',
    'SREE SATYA INTERMEDIATES PRIVATE LIMITED',
    'NADSOL TECHNO LABS PRIVATE LIMITED',
    'EXTENDIME SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'ITFormula1 IT Solutions Private Limited',
    'CARBYNETECH (INDIA) PRIVATE LIMITED',
    'Tectoro Consulting Private Limited',
    'DAYSMART SOFTWARE INDIA PRIVATE LIMITED',
    'BIO SOFT RESEARCH PRIVATE LIMITED',
    'PREVENCURE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'MYVALUEDESK SOFTWARE PRIVATE LIMITED',
    'Toshiba transmission & distribution systems (india) private limited',
    'Windcare india private limited',
    'Star eco energy private limited',
    'Gajaananda green energy private limited',
    'New vision wind power private limited',
    'Krl - sil green energy private limited',
    'Megapower transmission limited',
    'Devi energies private limited',
    'India japan lighting private limited',
    'Wadhawan green energy (gujarat) private limited',
    'Astone energy private limited',
    'VAYU (PROJECT 1) PRIVATE LIMITED',
    'ENEL VAYU (PROJECT 2) PRIVATE LIMITED',
    'Wadhawan green energy (maharashtra) private limited',
    'Taqa india power ventures private limited',
    'Lumbini power private limited',
    'Luxor energy private limited',
    'Perpetual power private limited',
    'Ocean watertech india private limited',
    'Aquasafi purification systems private limited',
    'Environmental purifiers limited',
    'Agravarti process engineers private limited',
    'Hyflux engineering (india) private limited.',
    'R k urja private limited',
    'Delta galil textiles (india) private limited',
    'Spark town planners private limited.',
    'Kohinoor planet constructions private limited',
    'VARSHA BUILDERS PRIVATE LIMITED',
    'Asip private limited',
    'Fortune infra developers private limited',
    'Raheja homes limited',
    'PRIUS COMMERCIAL PROJECTS PRIVATE LIMITED',
    'Sohna infrastructures private limited',
    'Sohna developers private limited',
    'Umang co-developers private limited',
    'Ecc raheja private limited',
    'LMD ESTATE PRIVATE LIMITED',
    'Nimbus infrabuilt private limited',
    'Sach infraprojects private limited',
    'Pankaj m patel consultants private limited',
    'Consort builders private limited',
    'Shivani developers private limited',
    'Boyance infrastructure private limited',
    'Mythri housing private limited',
    'BASELINE PROJECTS & CONSTRUCTIONS PRIVATE LIMITED',
    'Calicut finest projects private limited',
    'Health colonies and construction private limited',
    'Forest development corporation of maharashtra limited',
    'Espeejay builders private limited',
    'Sharad constructions private limited',
    'Gaurav overseas private limited',
    'JASMINE FIBRES PRIVATE LIMITED',
    'Accord land developers private limited',
    'Dhanesh engineering private limited',
    'Vishnupriya buildcons (india) private limited',
    'Glowshine builders and developers private limited',
    'Taldhvaj properties private limited',
    'Jalgaon constructions private limited',
    'Khandesh energy projects limited',
    'Act infraport limited',
    'White castle interiors private limited',
    'Landmark city developers private limited',
    'Reliance asset reconstruction company limited',
    'MUMBAI INTERNATIONAL AIRPORT LIMITED',
    'Tirumala construction private limited',
    'Murli infrastructures limited',
    'Svi realtors private limited',
    'Dheeraj township developers private limited',
    'Kaustubh construction private limited',
    'Prakash and daga infraprojects private limited',
    'Adishakti bhoomi vikas (india) private limited',
    'Nextgen buildcon private limited',
    'Alag property constructions private limited',
    'Scp developers private limited',
    'Mrunmai properties limited',
    'Exim infrastructure india private limited',
    'Tricon infra buildtech private limited',
    'Marvel landmarks private limited',
    'Khed wind energy and infra projects private limited',
    'Synergyone infrastructure & projects private limited',
    'Vistacore lifespace developers (india) private limited',
    'Green fortune promoters & developers private limited',
    'Kelegent metaplast india private limited',
    'Dharatal promoters & infradevelopers private limited',
    'Brightview projects & estates private limited',
    'Devshri infrahomes private limited',
    'Nishant finance and trading p ltd',
    'Hindlever trust limited',
    'HITECH SPECIALITIES SOLUTIONS LIMITED',
    'Wadhawan consolidated holdings private limited',
    'Gannon dunkerley finance limited',
    'Maryland leasing and investment company private limited',
    'Subham viniyog private limited',
    'COMFORTS VIAGGI PRIVATE LIMITED',
    'Mature trading and investments private limited',
    'Canny investments and trade private limited',
    'Rachna holdings private limited',
    'Asuda holdings pvt ltd',
    'Rohan developers private limited',
    'Mahlaqa investments p ltd',
    'Orion capital services limited',
    'Image securities limited',
    'Labh varsha securities and finanz private limited',
    'Chalukya investments private limited',
    'Opulent trading and investment private limited',
    'Flawless finvest private limited',
    'Disha securities services private limited',
    'Skay finvest private limited',
    'Nalanda securities private limited',
    'Natwest investments limited',
    'Basan financial services limited',
    'Forum viniyog private limited',
    'Manipal sowbhagya nidhi limited',
    'Uti trustee company private limited',
    'Sundram fasteners investments limited',
    'S.r.m.benefit fund limited',
    'Navashakthi chits private limited',
    'Venad chit funds (india) private limited',
    'Association of investment bankers of india',
    'Nitin investment and trading private limited',
    'Gulmarg investment and trading private limited',
    'Jaypatri investments pvt ltd',
    'Mahaparashu vastu consultants private limited',
    'Infin properties private limited',
    'EMPIRE EXCELLENCE PROPERTIES PRIVATE LIMITED',
    'Padmaja agencies private limited',
    'BOOPATHY INVESTMENTS PRIVATE LIMITED',
    'Recordsguru information management private limited',
    'Dbfs securities limited',
    'Ushkav investment private limited',
    'Spi properties private limited',
    'Avery investment co pvt ltd',
    'NICAP PRIVATE LIMITED',
    'Nexzone fiscal services private limited',
    'Capitalsquare advisors private limited',
    'Allegro insurance brokers private limited',
    'HITECH INSURANCE BROKING SERVICES LIMITED',
    'LIMTEX ADVISORY PRIVATE LIMITED',
    'Karvy realty (india) limited',
    'Uti retirement solutions limited',
    'ARUNIKA SERVICES PRIVATE LIMITED',
    'ANDROMEDA REALTY ADVISORS PRIVATE LIMITED',
    'Pug securities private limited',
    'Indra security and allied services private limited',
    'Ans private limited',
    'Bhat investments private limited',
    'ALLEGRO SECURITIES PRIVATE LIMITED',
    'Ashimaglobus holdings private limited',
    'Anmol como broking private limited',
    'Levindra trust limited',
    'M r holdings limited',
    'Varnilam investments and trading company limited',
    'Flaire apparel industries private limited',
    'Manori investment and trading company pvt ltd',
    'Upaasi investment and finance pvt ltd',
    'Legend investments and holdings private limited',
    'Vinotak investment pvt ltd',
    'Dilesh roadlines private limited',
    'Abg capital limited',
    'Synfab sefinvest private limited',
    'Laxmi ramuna investments private limited',
    'MAGNUM FINMART PRIVATE LIMITED',
    'Om mahalaxmi finance private limited',
    'Indira securities private limited (trf.)',
    'Hrs insight financial intermediaries private limited',
    'Hts securities private limited',
    'First overseas capital limited',
    'Great fintrade private limited',
    'Shilpa stock broker private limited',
    'Grebal capital services private limited',
    'Mittal share shoppe private limited',
    'Axis clinicals limited',
    'Altius securities trading private limited',
    'Allsec stocks private limited',
    'Mount intra finance pvt ltd',
    'Varshna investments p ltd.',
    'Dalmia securities pvt ltd',
    'B. n. securities limited',
    'LANSDOWNE INVESTMENTS PRIVATE LIMITED',
    'Derby securities private limited',
    'Pavandham investments and finance company private limited',
    'Myadvisor finserv private limited',
    'Finbud financial services private limited',
    'Celebrus commodities limited',
    'T7 wealth creators private limited',
    'Hirani properties and investments private limited',
    'Sensex consultants private limited',
    'Link intime india private limited',
    'Intergest south asia private limited',
    'Abeinsa business development private limited',
    'Eci systems private limited',
    'Cmj engineering private limited',
    'Numerica quantitative services private limited',
    'Kokban automation private limited',
    'Qadit systems and solutions private limited',
    'Access healthcare services private limited',
    'Paul writer strategic services private limited',
    'Dcam production studios private limited',
    'Lazaro advertising private limited',
    'Popular entertainment network private limited',
    'Ajcon communications private limited',
    'Kaustubh ad-com private limited',
    'Spatial access private limited',
    'Street- neon (india) private limited',
    'Paragon digital services private limited',
    'DCM CONTAINERS & ENGINEERING PRIVATE LIMITED',
    'Sriyansh knitters private ltd',
    'Radicura pharmaceuticals private limited',
    'Chemproject consulting private limited',
    'Graviss catering private limited',
    'Hari chand mela ram pvt ltd',
    'Brindavan agencies private limited',
    'Kanin india limited',
    'Hymatic agro equipment private limited',
    'Pug stock brokers private limited',
    'Intelligent communication systems india limited',
    'Ghaziabad precision products private limited',
    'Uppal hospitality private limited',
    'Standard farms private limited',
    'Kundeshwari agriculture and investments private limited',
    'Aay gee textiles private limited',
    'Ghaziabad containers private limited',
    'Ravels apparels private limited',
    'Srj and associates private limited',
    'Caparo maruti limited',
    'Dolphin freight movers private limited',
    'Shangrila technologies private limited',
    'Three sixty degrees marketing support private limited',
    'Wild life conservation resorts limited',
    'Laurel labs private limited',
    'Vimrita holdings private limited',
    'Berger becker coatings private limited',
    'Shivalik prints limited',
    'Kurele pan products private limited',
    'Shield autoglass limited',
    'Smc power generation limited',
    'London fashion house private limited.',
    'Dsc pipes and tubes private limited',
    'Arogyam surgical and trauma hospital (opc) private limited',
    'ZIP ENTERPRISES PRIVATE LIMITED',
    'Axis insurance broker india private limited',
    'Ics freight system private limited',
    'Tech observer india private limited',
    'Lunar biopharma private limited',
    'Star purotech filters private limited',
    'Coldwire technologies private limited',
    'Itms india private limited',
    'Sanac india private limited',
    'Em3 agriservices private limited',
    'BRIGHTMOON CAPITAL PRIVATE LIMITED',
    'Langly lifestyle private limited',
    'Coroney technologies private limited',
    'Sunborne energy gujarat one private limited',
    'Sri hastimalji ghamandiramji bokadia charitable foundation',
    'ABHYUDAY BHARAT PROJECTS PRIVATE LIMITED',
    'Easy pay private limited',
    'Sai extrumech private limited',
    'Jagdish loomtex private limited',
    'Indian institute of skill development private limited',
    'Retailinsights consultancy services private limited',
    'Ecoforge advisors private limited',
    'Asha wellness services private limited',
    'Impel exports private limited',
    'Sieg tech products private limited',
    'Laureate learning craft private limited',
    'Engrav aviation services & systems private limited',
    'ARMSTRONG CAPITAL AND FINANCIAL SERVICES PRIVATE LIMITED',
    'Greendzine technologies private limited',
    'Ace enviro tech private limited',
    'Kk eateries private limited',
    'Gaining ground investment services private limited',
    'Radical business services private limited',
    'Exotic innovations private limited',
    'Gps renewables private limited',
    'Blue hat solutions private limited',
    'Mavenhasten consulting private limited',
    'Bulldog consultancy services india private limited',
    'Superseva global services private limited',
    'LEGEND ARTISTS PRIVATE LIMITED',
    'Armor india coding and imaging supplies private limited',
    'Agricart online services private limited',
    'Bioreclamationivt india private limited',
    'Eventra media private limited',
    'MANIPAL WEALTH MANAGEMENT PRIVATE LIMITED',
    'GREENERIA RENEWABLE TECHNOLOGIES PRIVATE LIMITED',
    'Kaprito technologies private limited',
    'Donna penta enterprises private limited',
    'Mediapro audio visual private limited',
    'Da vinci jacquard fabrics (india) private limited',
    'K. R. COMPOSITES PRIVATE LIMITED',
    'Twilight prints private limited',
    'Mahavir silk mills pvt ltd',
    'Arun mantex limited',
    'Vivim fabline private limited',
    'M. a. fabrics private limited',
    'Tex-styles international private limited',
    'R s b cottex limited',
    'Rukshmani syntex private limited',
    'J. c. spinning mills private limited',
    'Sai saranu textiles private limited',
    'Associated textile industries private limited',
    'Encot fabrics private limited',
    'Aakash textiles exports private limited',
    'Travancore cocotuft private limited',
    'Caleffi bed and bath (india) private limited',
    'Adora carpet splendor private limited',
    'Autade spinners private limited',
    'Pure - source clothing private limited',
    'HERRINGBONE & SUI PRIVATE LIMITED',
    'Oro decor private limited',
    'Belle wears pvt ltd',
    'Stretchway clothing india private limited',
    'Knits and weaves private limited',
    'Chida spinning mills pvt ltd',
    'Ravali spinners private limited',
    'B d r haberdashery (india) private limited',
    'Hope apparels private limited',
    'Acacia fashions private limited',
    'J.s. fashions (international) private limited',
    'Primetex clothing private limited',
    'Ashpriya apparels private limited',
    'Welspun zucchi textiles limited',
    'Vedanta creations limited',
    'CREATIVE GLOBAL TEXTILE MILLS PRIVATE LIMITED',
    'Prime overseas garments private limited',
    'Cobalt creations private limited',
    'Anurup exim pvt ltd',
    'Tenstar infratech private limited',
    'Augustan knitwear private limited',
    'Mirth garment private limited',
    'Klassik lamitex private limited',
    'Paradise knitwear private limited',
    'Clarovista leisure private limited',
    'Corp one promotional clothing and accessories private limited',
    'K. d. garments private limited',
    'Raadhika shoecrafts private limited',
    'Mochiko shoes private limited',
    'Baron leather private limited',
    'Ravi das industries limited',
    'Sico udyog private limited',
    'Kittens shoes and allied products private limited',
    'Lotus veneers private limited',
    'Shiromani agrowood products pvt ltd',
    'Amulya mica (india) private limited',
    'Logs india private limited',
    'Magnifico crafts private limited',
    'OREO INTERIORS PRIVATE LIMITED',
    'Indo laminates private limited',
    'Camerich papers private limited',
    'Baddi print packs private limited',
    'B.m.m.paper board private limited',
    'Advantage exports private limited',
    'Dukraft paper distributor private limited',
    'Hollingsworth & vose (india) private limited',
    'Orchid packaging private limited',
    'Global business solutions limited',
    'Adroit biomed limited',
    'Voith paper technology (india) private limited',
    'TRIDENT SEEDS & OIL PRIVATE LIMITED',
    'Tarun bharat multigraphics private limited',
    'Janet publishers private limited',
    'Prudent media (goa) private limited',
    'Star ooh communications private limited',
    'Narosa publishing house private limited.',
    'Vandana printing works private limited',
    'Vimala offset and printing press private limited',
    'Onland graphics (india) private limited',
    'Parksons computor forms limited',
    'Abound infomedia private limited',
    'Sel jegat printers private limited',
    'Saniya printers & packers private limited',
    'Forever books private limited',
    'Krishna multi print (india) private limited',
    'Vinayak offset print private limited',
    'STENCIL BRAND SOLUTIONS PRIVATE LIMITED',
    'Decal print (india) private limited',
    'PDA VENTURES PRIVATE LIMITED',
    'Hi - tech pneumatics and heattreaters private limited',
    'Hydraulics india services private limited',
    'Count fabri-fluidomatics ltd',
    'Oswal valves private limited',
    'Panam engineers limited',
    'Unijet pneumatics private limited',
    'Omt bearings private limited',
    'Shri sabhari smelters private limited',
    'Chitra elevators private limited',
    'Trishul machine tools private limited',
    'Ozark engineering private limited',
    'PRABHAT HITECH EQUIPMENT PRIVATE LIMITED',
    'Air control and compressor equipment (india) private limited',
    'Kirloskar chillers private limited',
    'Shree refrigerations private limited',
    'Alfa next gen tech india private limited',
    'Smith and sharks projects (india) pvt ltd',
    'Cmr control systems india private limited',
    'SANSUI ELECTRONICS PRIVATE LIMITED',
    'Inspecs metrology (india) private limited',
    'Aaf india private limited',
    'Hrs process systems limited',
    'Prime energy private limited',
    'Schurter electronics (india) private limited',
    'Multirole transport aircraft limited',
    'SANMAR CONSOLIDATIONS PRIVATE LIMITED',
    'Suresquare trading and consultancy private limited',
    'V tech technologies private limited',
    'Hindustan field services private limited',
    'Swamohn agri exims private limited',
    'Gulf solutions private limited',
    'Utility exim pvt ltd',
    'GLADIOLUS MERCANTILE PRIVATE LIMITED',
    'Lcgc chromatography solutions private limited',
    'Avk lubcon private limited',
    'Standard tradecom private limited',
    'All seasons marketing private limited',
    'Max standard stores private limited',
    'Inis marketing services private limited',
    'Craft route merchandize private limited',
    'U v exports private limited',
    'Fortune exim private limited',
    'Ibis offshore private limited',
    'Abhidev automotives private limited',
    'Legacy impex private limited',
    'Zest arena private limited',
    'Chempack industries private limited',
    'Metro cash and carry india private limited',
    'Flexspeed machining solutions private limited',
    'Fuzhio health and business services private limited',
    'WEBSTEM SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'B&W BUILDER',
    'MAS STEELS PRIVATE LIMITED',
    'Rikhav securities limited',
    'Vestern vivian jewels limited',
    'Acma computers limited',
    'Raigad chamber of commerce and industry',
    'KAVERI SEED COMPANY LTD.',
    'REFEX RENEWABLES & INFRASTRUCTURE LIMITED',
    'AMOL MINECHEM LIMITED',
    'The united provinces sugar company limited',
    'DEEPAK SPINNERS LIMITED',
    'Nutech global limited',
    'Supra trends limited',
    'Lincoln pharmaceuticals ltd',
    'Rajasthan cylinders and containers ltd',
    'Bharat bijlee limited',
    'UCAL LIMITED',
    'Naina semi conductor limited',
    'Reed relays & electronics india limited',
    'Twenty first century marketing limited',
    'Best industrial electricals india private limited',
    'Powerlite generator systems private limited',
    'Incon automation private limited',
    'Kontact consortium india private limited',
    'Brite engineering control switchgears private limited',
    'Sastra robotics india private limited',
    'Delta electro mechanical private limited',
    'Fcg power industries private limited',
    'A. r. e. enterprises private limited',
    'Sinusoidal test equipments private limited',
    'R r electronics private limited',
    'Pba (india) engineering services and supplies private limited',
    'Paramount office systems private limited',
    'Teles computer systems india private limited',
    'Neel industrial systems private limited',
    'Electronet process automation private limited',
    'SURBHI ELECTRONET PRIVATE LIMITED',
    'Sri amman wind systems private limited',
    'Arihant engergy capacitors private limited',
    'High bits av solutions private limited',
    'Visiontech automation private limited',
    'Capronics private limited',
    'Ads sensor technik private limited',
    'Radix electrosystems pvt ltd',
    'Plexus tele- solutions private limited',
    'FASTECH TELECOMMUNICATIONS (INDIA) PRIVATE LIMITED',
    'Wham infocom private limited',
    'Daccess security systems private limited',
    'Aftab electronics pvt ltd',
    'Winater infotech private limited',
    'Terumo india private limited',
    'Supreme global health care private limited',
    'Jeevtronics private limited',
    'Teletherm instrument co private limited',
    'Cardiac design labs private limited',
    'S4 healthcare private limited',
    'Neogen labs private limited',
    'Swc engineering services private limited',
    'Optiline eyewear private limited',
    'Dataflow display systems private limited',
    'Asian reprographics private limited',
    'Dia precious jewellery private limited',
    'Mabel engineers private limited',
    'Nissan motor india private limited',
    'Auto feed (india) private limited',
    'Stanley works (india) private limited',
    'Aglow engineers private limited',
    'Rage motorsport performance private limited',
    'Wings automobile products pvt. ltd.',
    'U & ME COMMUNICATION (INDIA) PRIVATE LIMITED',
    'TURVO INDIA PRIVATE LIMITED',
    'REPORTGARDEN TECHNOLOGIES PRIVATE LIMITED',
    'INFINIANCE INDIA PRIVATE LIMITED',
    'EzeSoftware India Private Limited',
    'APPLAUSE APP QUALITY INDIA PRIVATE LIMITED',
    'Arcesium India Private Limited',
    'PRAGMATIC DESIGN SOLUTIONS INDIA PRIVATE LIMITED',
    'NEWTACT LAB PRIVATE LIMITED (OPC)',
    'YMR CONSULTANCY SERVICES INDIA PRIVATE LIMITED',
    'ADYNT TECH LABS PRIVATE LIMITED',
    'PI SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'S HOTELIERS AND CONSULTANTS PRIVATE LIMITED',
    'PHONIC ONLINE PRIVATE LIMITED',
    'Magnus india consulting services private limited',
    'Valuemax advisors consulting private limited',
    'Penta consulting private limited',
    'Pegasus west hrd private limited',
    'Soham b - sols private limited',
    'Proficient exim consultants private limited',
    'India e hub services private limited',
    'Wishmore investsmart consultancy private limited',
    'Frangipani artisans support private limited',
    'Clayground communications private limited',
    'Aquarius freight solutions private limited',
    'Grand lokin school private limited',
    'Metafab engineers (india) private limited',
    'Dih project management private limited',
    'Db secure solution private limited',
    'Panache personal analytics private limited',
    'BRIDGE INVESTMENT SERVICES PRIVATE LIMITED',
    'Iangel services private limited',
    'Jks infratech engineers private limited',
    'Saffron cubic solutions india private limited',
    'Antariksh consultants private limited',
    'Potential cleantech ventures private limited',
    'Quality architectural solutions private limited',
    'Scriptech info systems private limited',
    'Evoma facilities (india) private limited',
    'Sesa india private limited',
    'Spg facility management private limited',
    'Maruthi quality management services private limited',
    'Rb one source private limited',
    'Ventura immigration consultants private limited',
    'Perimeters media private limited',
    'U s advertising agency private limited',
    'Moneyplant estates private limited',
    'Autocomp india private limited',
    'Aakar abhinav consultants private limited',
    'Precimax engtech private limited',
    'Nikul engineering private limited',
    'Enpro industries private limited',
    'Consultech combines private limited',
    'Domus pondicherry private limited',
    'THEME ENGINEERING SERVICES PRIVATE LIMITED',
    'Usui susira international private limited',
    'Aser centre',
    'Ancient healing wellness private limited',
    'THE FEDERATION OF TELANGANA CHAMBERS OF COMMERCE AND INDUSTRY',
    'Asb telisolutions private limited',
    'Integrated resources staffing private limited',
    'Spring fragrance private limited',
    'FEDERATION OF KUTCH INDUSTRIES ASSOCIATIONS',
    'Namaste america - indo american association for art & culture',
    'Kool solutions india private limited',
    'Blu planet ecotech private limited',
    'Narotam sekhsaria foundation',
    'Nashik engineering cluster',
    'Indian heritage hotels association',
    'ZINKID PARTNERS PRIVATE LIMITED',
    'Indo-gulf diagnostics and research centre private limited',
    'Eventkraft marketing solutions private limited',
    'Pradarshak pvt ltd',
    'It voice media private limited',
    'Gulmohar comforts private limited',
    'Sri lakshmi malleables private limited',
    'Accor advantage plus marketing (india) private limited',
    'Deep services private limited',
    'Integrated learning solution private limited',
    'M and w associates private limited',
    'Thousandconcept financial services private limited',
    'Mohammdi healthcare systems private limited',
    'Asian hospitals and healthcare private limited',
    'VRINDAVAN ORTHOPAEDIC INSTITUTE PRIVATE LIMITED',
    'Chennai hospitals private limited',
    'Professional visa services private limited',
    'Swarovski india private limited.',
    'Danddeli ferro private limited',
    'Amba alluminium private limited',
    'Sona blw precision forgings limited',
    'Santragachi rubber and chemical works private limited',
    'Pgm ferro steels private limited',
    'Cottage eng.pvt ltd',
    'Scorpion containers private limited',
    'Samir castings private limited',
    'Marcegaglia india private limited',
    'R k k r steels private limited',
    'Mekaul construction technologies private limited',
    'Viraaj concrete india private limited',
    'Lrg steel concept private limited',
    'SATYAM AUTO COMPONENTS Private Limited',
    'Pawan steel tubes private limited',
    'Nexo structures private limited',
    'JVL STEEL PRIVATE LIMITED',
    'Emson tools manufacturing corporation limited',
    'Namdhari industrial traders private limited',
    'Vishwakarma innovative engineers private limited',
    'Crecim industries private limited',
    'Crp-tcdc die castings india private limited',
    'Stainlay ispaat private limited',
    'Carbon brush company private limited',
    'Creatique esporre private limited',
    'Zed fabs india private limited',
    'Rama cylinders private limited',
    'M a e rolltech p ltd',
    'Trans organics (india) private limited',
    'Arya mines & metals private limited',
    'HIMTEJ INDIA PRIVATE LIMITED',
    'Excel metal processors private limited',
    'Spal electricals private limited',
    'Lahliwala steels pvt ltd',
    'Alumi profiles private limited',
    'RATHI STEEL AND METAL PRIVATE LIMITED',
    'Plasmaweld process equipments private limited',
    'Oxide (india) private ltd',
    'Bright hardware industries pvt ltd',
    'Mahalasa acoustic private limited',
    'Accu sharp cutting tools private limited',
    'Mita fasteners pvt ltd',
    'Kaloti engineering company private limited',
    'India safety vaults private limited',
    'Ecokrin hygiene private limited',
    'Silverline galvanizers private limited',
    'Asahi safety industries private limited',
    'Vikas steel & castings private limited',
    'Innovatec india private limited',
    'Tidan forging private limited',
    'KROSS LIMITED',
    'Plus-one machinefabrik private limited',
    'Yashmun engineers limited',
    'Indian valve private limited',
    'Pavitra belting private limited',
    'Karnataka conveyors and systems private limited',
    'Baimish techno systems private limited',
    'Rg marine tech private limited',
    'Sai sheet stampings private limited',
    'Gasman cylinders private limited',
    'GAUTAM INDUSTRIAL CORPORATION PRIVATE LIMITED',
    'Shivshakti ispat private limited',
    'Shree ram metallics private limited',
    'Ambika non-ferrous & product private limited',
    'Samir metal processors private limited',
    'Stainlay india private limited',
    'Metters private limited',
    'Spiral tools pvt ltd',
    'Copper semis private limited',
    'Nirman stelco private limited',
    'Shresth multi metal industries pvt ltd',
    'Ankit equipments private limited',
    'Ishar hoist and cranes private limited',
    'Shree magnets private limited',
    'PATKAR EXTRUSIONS PRIVATE LIMITED',
    'J n j machines private limited',
    'Castech foundries pvt ltd',
    'Aman technocast private limited',
    'Hiross india private limited',
    'Vijay airconditioning private limited',
    'ROVEMA INDIA PRIVATE LIMITED',
    'Iron build systems pvt ltd',
    'Indrayani ferrocast private limited',
    'Bundy india limited',
    'Anjani machines private limited',
    'Sharp designers and engineers india private limited',
    'Consolidated eutectics (kolhapur) private limited',
    'Zenith erectors private limited',
    'Outotec india private limited',
    'INDIA IRRIGATION LIMITED',
    'ROLLWELL CONVEYOR PRIVATE LIMITED',
    'Indo farm equipment limited',
    'Dolphin aqua cure private limited',
    'HYDRODYNE TEIKOKU (INDIA) PRIVATE LIMITED',
    'Sankalp abrasives private limited',
    'Matru fabrics pvt ltd',
    'Gemini power hydraulics private limited',
    'Sehgal technologies (india) private limited',
    'Excel instruments private limited',
    'Darling pumps private limited',
    'Efficient envirotech private limited',
    'Indi-tech valves private limited',
    'Psp pumps private limited',
    'Summits hygronics private limited',
    'Magaldi power india private limited',
    'ATMASTCO LTD',
    'Arvee electricals and engineers pvt ltd',
    'RAI & RAI IMPEX PRIVATE LIMITED',
    'SKIN AND TEX PRIVATE LIMITED',
    'Indo international commercial co pvt ltd',
    'Rivoli watches private limited',
    'Awb india private limited',
    'B s g exports private limited',
    'Almighty exports private limited',
    'Saima impex pvt ltd',
    'Pioneer com-trade private limited',
    'Cerana beverages private limited',
    'Ratroi maa marketing private limited',
    'Srithai superware india limited',
    'High tension erectors limited',
    'Maharaja features private limited',
    'Home couture private limited',
    'Rivergrove trading pvt ltd',
    'Alsa apollo kitchens international (india) private limited',
    'Best polychem limited',
    'AURA SECURITIES PRIVATE LIMITED',
    'Vandeep trade links p ltd',
    'Padmini aromatics private limited',
    'ALLUCENT (INDIA) PRIVATE LIMITED',
    'Unistar resources and trades pvt ltd',
    'Zenith semi conductors private limited',
    'Thames technologies private limited',
    'Penguine hospitality private limited',
    'Kriyas unipro private limited',
    'Leeway technosolution private limited',
    'Rex international private limited',
    'V g impex private limited',
    'Hansali imports private limited',
    'Le creuset india trading private limited',
    'Cashmin exports private limited',
    'Sbt marketing private limited',
    'Ajar enterprises private limited',
    'Amit sales corporation private limited',
    'Rock and storm distillaries private limited',
    'Oval impex private limited',
    'Mirari international private limited',
    'Toshniwal exports private limited',
    'Ans impex private limited',
    'Vagatora traders private limited',
    'Bandra merchandisers private limited',
    'Nilesh impex india private limited',
    'National commerce house pvt ltd',
    'Law & law pvt ltd',
    'Mitra s k pvt ltd',
    'Deepshikha trading co pvt ltd',
    'Duncans tea ltd',
    'Levcon controls pvt ltd',
    'SUREKA REALTY LIMITED',
    'WINMARK INFRA SERVICES PRIVATE LIMITED',
    'Cci intertrade private limited',
    'Arrow mercantile private limited',
    'Sahil mercantile private limited',
    'Pratiti trading private limited',
    'V can export private limited',
    'Apex vanijya pvt ltd',
    'KUBER CREATIONS PRIVATE LIMITED',
    'Alpha commodity private limited',
    'Kavee impex private limited',
    'S s b grace impex private limited',
    'Hedge commodities limited',
    'Newport tradelink and logistic private limited',
    'Newline mercantile private limited',
    'Bhumi geosynthetics private limited',
    'Goodwill tradecom private limited',
    'Sonalika pvt ltd',
    'KAYRPEE VANIJYA PRIVATE LIMITED',
    'Daulat vanijya private limited',
    'Creatrix mercantile private limited',
    'Aristo suppliers private limited',
    'Synergy overseas limited',
    'Veb robomak private limited',
    'Eloquent steel private limited',
    'PUNTA INDIA PRIVATE LIMITED',
    'Foremost agents private limited',
    'Kotiratan merchants private limited',
    'Overgrow mercantile private limited',
    'BALIGA EXPORTS PRIVATE LIMITED,',
    'Cears exports pvt ltd',
    'Dipco extraction export house private limited',
    'Winsher commercial pvt.ltd.',
    'Tarush marketing private limited',
    'Yashoda inn private limited',
    'Tresor systems private limited',
    'Versatile mega mart private limited',
    'Harpar dailykart retail private limited',
    'Pch corporation limited',
    'H4u exports private limited',
    'Alexia dealers private limited.',
    'Sydney agencies private limited',
    'Rishikesh commosales private limited',
    'Topstar dealers private limited',
    'Jai mata international private limited',
    'Upasi commodities exchange limited',
    'VENKATAVARADHAA AGENCIES PRIVATE LIMITED',
    'VOYLLA FASHIONS PRIVATE LIMITED',
    'Krysh retail private limited',
    'Suraksha tech services private limited',
    'Kirtan distributors private limited',
    'Supreme lifestyle private limited',
    'Delsey india private limited',
    'Microline electronics private limited',
    'Insilco merchants pvt ltd',
    'BINAYAK HI-TECH ENGINEERING PRIVATE LIMITED',
    'Bin ali granites and buildware exim private limited',
    'Ace developer india private limited',
    'BHUMIRAJ BUILDERS PRIVATE LIMITED',
    'Ranjan real estate developers pvt.ltd.',
    'Saradha villa private limited',
    'Saradha heights private limited',
    'Saradha castle private limited',
    'Saradha tower private limited',
    'WELTEC REALTY PRIVATE LIMITED',
    'Positive lifestyle developers private limited',
    'Pragati dwellers private limited',
    'N j construction private limited',
    'Krilax developers private limited',
    'Sunview nirman private limited',
    'Vedic green farms private limited',
    'Ssco synergies (india) private limited',
    'Dadimata promoters private limited',
    'Darpad promoters private limited',
    'Vetali developers private limited',
    'Rukmani promoters private limited',
    'Adishakti infraprojects private limited',
    'Dhriti realtors private limited',
    'Mahabala infrastructure private limited',
    'Dristi infradevelopers private limited',
    'Luxury housing private limited',
    'Shivohum infrastructure and projects private limited',
    'Anulekha real estate private limited',
    'Anulekha nirman private limited',
    'Anulekha developers private limited',
    'Anulekha complex private limited',
    'Country farms private limited',
    'Mahajans buildcon private limited',
    'Cloud 9 projects private limited',
    'Apex acreages private limited',
    'Seven seas projects private limited',
    'Selene estate limited',
    'Avonmore developers private limited',
    'SUMERU TEXTILES PVT LTD',
    'Fairwealth housing private limited',
    'Selene constructions limited',
    'Redshift business services private limited',
    'Vaijnath enterprises private limited',
    'K.p.r. developers limited',
    'Asar shelters india private limited',
    'Adsa realty private limited',
    'Rsar shelters india private limited',
    'Ashiana landcraft realty private limited',
    'Panshul projects private limited',
    'Aashray investors pvt.ltd.',
    'Pagoda constructions pvt.ltd.',
    'Vijaypath combine private limited',
    'Bpr properties private limited',
    'Mukut house developers private limited',
    'PONGUBALA MEDIA CORPORATION PRIVATE LIMITED',
    'Mukul shelter private limited',
    'Sisl infotech private limited',
    'Karman infotech private limited',
    'Urvi computers private limited',
    'Amkette integral solutions private limited',
    'Exotic realcon private limited',
    'Brij behari realty private limited',
    'Fastspeed infrahomes private limited',
    'Divya buildwell india private limited',
    'Baba multimedia private limited',
    'Tsl defence technologies private limited',
    'Secure synergy private limited',
    'Venera technologies private limited',
    'Mlogica matchtek solutions private limited',
    'Du data rack systems private limited',
    'Adore infotech private limited',
    'Integrated office equipment and solutions private limited',
    'Infovalue computing india private limited',
    'Sonet microsystems private limited',
    'Ultra softsys private limited',
    'Sarv realtors private limited',
    'AMETEK HOMES PRIVATE LIMITED',
    'Exemplar e solutions private limited',
    'Sdl multilingual solutions private limited',
    'Khusi building solution private limited',
    'Serpentes constructions limited',
    'Kubera estates pvt ltd',
    'Aries agri properties private limited',
    'System 3 net managed services private limited',
    'Ommune it solutions private limited',
    'Vcareall solution private limited',
    'Arora it solution private limited',
    'Csi engineering software private limited',
    'Jatia proprietory company limited',
    'SUCCESSIVE TECHNOLOGIES PRIVATE LIMITED',
    'Digiswitch infotech private limited',
    'Thinq green computech private limited',
    'ACROKX REALTY PRIVATE LIMITED',
    'Texspand technologies private limited',
    'Visible infotech private limited',
    'Spectramedix india private limited',
    'Euiux solutions private limited',
    'Evergreen builders & traders private limited',
    'KOOMBER PROPERTIES & LEASING COMPANY PVT LTD',
    'Tallypower it solutions private limited',
    'Oriental software private limited',
    'Epiance software private limited',
    'Binary semantics limited',
    'Unisys infosolutions private limited',
    'Honeycomb eservices private limited',
    'Raritan international india private limited',
    'Adorable trading private limited',
    'Tirupati containers private limited',
    'SYSTEM CERAMICS INDIA PRIVATE LIMITED',
    'Delhi waste management limited',
    'Sruk advisory projects services limited',
    'Indian trails sourcing services private limited',
    'Airvoice aviations private limited',
    'WINSON PERFUMES & COSMETICS Private Limited',
    'Shipova concrete products private limited',
    'Ppd packagings private limited',
    'Future liquor agencies private limited',
    'Panacea facilities private limited',
    'Sophisticated business services (india) private limited',
    'ASTUTE ONETOUCH INDIA PRIVATE LIMITED',
    'Best & less travel india private limited',
    'Royal asia quality control services private limited',
    'Royal castor products limited',
    'National process pvt ltd',
    'Bhagwan precision private limited',
    'Proform designs private limited',
    'Lockey estates private limited',
    'Narv consultants private limited',
    'Netscape india private limited',
    'Amp digital solutions private limited',
    'Kpd packagings private limited',
    'Gate consulting private limited',
    'Keerthi (bangalore) private limited',
    'Rainforest retreats private limited',
    'Rex corporate services private limited',
    'Cleanpro services private limited',
    'Allan lloyds events private limited',
    'GROSSE INDUSTRIES INTERNATIONAL LIMITED',
    'Ahoora blocks pvt ltd',
    'East india electronics private limited',
    'JACOB BALLAS INDIA PRIVATE LIMITED',
    'NORD ANGLIA EDUCATION INDIA PRIVATE LIMITED',
    'Aether engineering solutions private limited',
    'Dyotis technologies private limited',
    'Chemilines healthcare india private limited',
    'C somabhai intellectual property private limited',
    'R s envirolink technologies private limited',
    'Himalayan consultancy and management services private limited',
    'Broadvision perspectives india private limited',
    'Linkage india training and consulting private limited',
    'J b dairy farms private limited',
    'Aceic design technologies private limited',
    'Ship it 2 india services private limited',
    'SWAJYOT PRIVATE LIMITED',
    'Meraki communications private limited',
    'Empro plant supervision services private limited',
    'Ipexcel services private limited',
    'C4DT CENTRE FOR DIGITAL TRANSFORMATION PRIVATE LIMITED',
    'Pramuk health services private limited',
    'Getupforchange services private limited',
    'BOX2JOY PRIVATE LIMITED',
    'GHODAWAT INVESTMENTS PRIVATE LIMITED',
    'VODAFONE IDEA COMMUNICATION SYSTEMS LIMITED',
    'Power track system private limited',
    'Container solutions (india) private limited',
    'Wisecor services private limited',
    'Medulla communications private limited',
    'Panacean energy solution private limited',
    'WONDERKIDS INDUSTRIES PRIVATE LIMITED',
    'Apex marine services private limited',
    'Hospitality marketing concepts private limited',
    'Kahuna systems private limited',
    'Hygen healthcare private limited',
    'MIVISION OPTICAL & SCIENTIFIC INSTRUMENTS PRIVATE LIMITED',
    'Aatiq power solutions india private limited',
    'GRAPHISADS LIMITED',
    'Viral industries private limited',
    'Nar furniture private limited',
    'MODUFURN ENTERPRISE PRIVATE LIMITED',
    'Krueger international furniture systems private limited',
    'Leaf furniture private limited',
    'Vector joinery works private limited',
    'Drs design private limited',
    'Vans gypsum private limited',
    'Disha retail fixtures private limited',
    'V3 TRASTA WORKS PRIVATE LIMITED',
    'Diatrends jewellery private limited',
    'Stones and jewellery (india) private limited',
    'Agni jewels private limited',
    'Grace jewels private limited',
    'Ivy jewellery private limited',
    'A - one cut diamonds private limited',
    'Shantivijay adornments private limited',
    'Riddisiddhi bullions limited',
    'Binnys jewellery private limited',
    'Eurosteel office furniture systems private limited',
    'Addvalue international private limited',
    'HUBBLE CONNECTED INDIA PRIVATE LIMITED',
    'COSMOS HANDICRAFTS PRIVATE LIMITED',
    'Sheth multi-link private limited',
    'Easun - mr tapchangers private limited',
    'Reddonatura india private limited',
    'Indhan plastochem private limited',
    'Shapoorji pallonji energy (gujarat) private limited',
    'Power nucleus india private limited',
    'GMR Warora Energy Limited',
    'A A ENERGY PRIVATE LIMITED',
    'Plr power private limited',
    'Grass energies private limited',
    'Vaayu renewable energy (indus) private limited',
    'Vaayu renewable energy (narmada) private limited',
    'Indira power private limited',
    'Opg business centre private limited',
    'Paschim gujarat vij company limited',
    'Acciona wind energy private limited',
    'Patan solar private limited',
    'Surya energy photo voltaic india private limited',
    'Vaayu renewable energy (godavari) private limited',
    'Indowind power private limited',
    'Vaayu renewable energy private limited',
    'Vartaman wind energy private limited',
    'Vaayu renewable energy (saraswati) private limited',
    'Vaayu renewable energy (tapi) private limited',
    'Vaayu renewable energy (yamuna) private limited',
    'Vaayu renewable energy (kaveri) private limited',
    'Vaayu renewable energy (tungabhadra) private limited',
    'Kudgi transmission limited',
    'WAA CABLES PRIVATE LIMITED',
    'WALWHAN SOLAR TN LIMITED',
    'Shrem light private limited',
    'WAAREE RENEWABLES PRIVATE LIMITED',
    'Blue rays solar private limited',
    'Lavancha renewable energy private limited',
    'Vaayu renewable energy (krishna) private limited',
    'Bhavana power private limited',
    'Sei solar power private limited',
    'CHINT INDIA ENERGY SOLUTION PRIVATE LIMITED',
    'AMPLUS SOLAR POWER MH PRIVATE LIMITED',
    'Surya green power private limited',
    'Sei solar power gujarat private limited',
    'Southern power distribution company of andhra pradesh ltd',
    'Elektrika solutions private limited',
    'Vaayu renewable energy (ganga) private limited',
    'Ogni esco private limited',
    'Millenium synergy (gujrat) private limited',
    'Om power shakti india private limited',
    'Tirupati power infra projects private limited',
    'Apeiron renewable energy private limited',
    'Waaneep solar private limited',
    'Mkp power private limited',
    'Harko techno solutions india private limited',
    'Water freedom revolution industries private limited',
    'Shri bajrang devcon private limited',
    'Arihant dream projects private limited',
    'Rajkamal structures gravity private limited',
    'Flagship realty private limited',
    'GOKUL INFRATECH PRIVATE LIMITED',
    'Power equations india private limited',
    'Asten properties and developers private limited',
    'Himax builders india private limited',
    'ASTEN MALLS PRIVATE LIMITED',
    'Tabarine builders and developers private limited',
    'Lameez builders and developers (india) private limited',
    'Chuchum properties private limited',
    'Neelyog construction private limited',
    'Vaikuntam realty private limited',
    'Simulterra synergies private limited',
    'Ea document filing resources private limited',
    'Aouse technologies private limited',
    'Secugen india private limited',
    'Vnnogile solutions private limited',
    'Tonic media digital private limited',
    'Halo media works private limited',
    'Everrtech software private limited',
    'Digits experts private limited',
    'Conflate it solutions private limited',
    'Wise men erp solutions india private limited',
    'Design desk (india) private limited',
    'Hi-tech company software solutions (chennai) private limited',
    'PRELUDESYS INDIA PRIVATE LIMITED',
    'Global analytics india private limited',
    'Cams cargo accounting management services private limited',
    'Gateway nintec private limited',
    'Soft polynomials (india) private limited',
    'Haware ventures private limited',
    'Skillsource learning and technologies private limited',
    'Solutions enterprise private limited',
    'Koyo sms (india) private limited',
    'Mobitrail (india) private limited',
    'Nemo technologies private limited',
    'Leadinvent technologies private limited',
    'Spaul complete it solution private limited',
    'Neotech photoelectric private limited',
    'San wireless systems limited',
    'Niche solutions gujarat private limited',
    'Indusface telecom private limited',
    'Plumslice labs private limited',
    'Alchimia partners private limited',
    'Panther studio private limited',
    'Imriel technology solutions private limited',
    'Maxtra technologies private limited',
    'BLUE YONDER INDIA PRIVATE LIMITED',
    'Barracuda networks (india) private limited',
    'Hid india private limited',
    'Plackal techno systems private limited',
    'Avin networks private limited',
    'Enterprise blueprints india private limited',
    'Viroka technology private limited',
    'Webtechiez software india private limited',
    'Shippable india private limited',
    'GREENTREAT MACHINES PRIVATE LIMITED',
    'Ringz info solutions private limited',
    'Pigtail pundits web solutions private limited',
    'E city publishing and distributing india private limited',
    'Exor india private limited',
    'Call 2 connect india private limited',
    'Bedrock capital private limited',
    'SM NETWORKS & SOLUTIONS PRIVATE LIMITED',
    'Primetech printer solution private limited',
    'Graymatrix solutions private limited',
    'DIGICONICS ENTERPRISE SOLUTIONS PRIVATE LIMITED',
    'Highbar technologies limited',
    'VISER TECHNO LIFESTYLE PRIVATE LIMITED',
    'Lighthouse info systems private limited',
    'Netgains technologies private limited',
    'Gravitia solutions private limited',
    'Niva technologies private limited',
    'Sujay softtech private limited',
    'Wci consultancy private limited',
    'Zuneeue technologies private limited',
    'Cloud 9 infosystems private limited',
    'VAMS SAFEGUARD PRIVATE LIMITED',
    'Starting blocks media ventures private limited',
    'Indtrack technology private limited',
    'Intellischool technology private limited',
    'Thin computing solutions private limited',
    'Shivaami cloud services private limited',
    'Indo global soft solutions and technologies private limited',
    'Equal experts india private limited',
    'Idmission solutions private limited',
    'Strategic content transformation labs private limited',
    'Buffer techsolutions private limited',
    'Chalaki systems private limited',
    'Autonetic software technologies private limited',
    'Sprv technologies private limited',
    'Coe software technologies private limited',
    'PEONYSOFT SOLUTIONS PRIVATE LIMITED',
    'SMARTDOCS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Crimson innovative technologies private limited',
    'Snr edatas private limited',
    'Kaypro technologies private limited',
    'Tas digital media private limited',
    'Geovista systems private limited',
    'A-team infomedia private limited',
    'Prag itech private limited',
    'Mobius365 data services private limited',
    'Soffront software private limited',
    'Forever biotech private limited',
    'Beloorbayir biotech limited',
    'Abexome biosciences private limited',
    'Race dynamics india private limited',
    'Christian pfeiffer india private limited',
    'Wuerth india private limited',
    'Spraytech systems (india) private limited',
    'Mustang engineering india private limited',
    'PERFECT BELTS PRIVATE LIMITED',
    'Protech engineering and controls private limited',
    'Tesna tech private limited',
    'Adarsh machinery movers p ltd',
    'Linamar india private limited',
    'Halton india private limited',
    'EPHYSX TECHNOLOGIES PRIVATE LIMITED',
    'Mp filtri india private limited',
    'Shenhang machinery (india) private limited',
    'Iva bulk handling equipments private limited',
    'S MOTORS PRIVATE LIMITED',
    'Lead hr services private limited',
    'Aventus talent acquisition solutions private limited',
    'BRANDSTER DIGITAL PRIVATE LIMITED',
    'Lead corporate management consultants private limited',
    'Brentford services private limited',
    'Nucon industries private limited',
    'Cyber infodev private limited',
    'GARDEN CITY ENTERPRISES PRIVATE LIMITED',
    'INDIAN TEXTILE ACCESSORIES AND MACHINERY MANUFACTURERS',
    'S NATURAL FOOD PRIVATE LIMITED',
    'LEVATIO RESTRUCTURING AND TURNAROUND PRIVATE LIMITED',
    'Rawabi properties private limited',
    'Jvls infrastructure private limited',
    'Orange developers private limited',
    'Sprinter builders private limited',
    'Greenfields @ nalanda private limited',
    'Diamond landcons private limited',
    'Weldon projects private limited',
    'Premium infratech private limited',
    'Gurkul buildtech private limited',
    'Best international projects private limited',
    'Radhe infrastructure and projects(india)limited',
    'N g realty private limited',
    'CYGNET ACE FINTECH PRIVATE LIMITED',
    'CIPL INDIA PRIVATE LIMITED',
    'Sakariya developers private limited',
    'Ratna infraestates private limited',
    'Shriprop estates private limited',
    'Shrivision projects private limited',
    'Neelanchal griha nirman private limited',
    'Seguro foundations and structures private limited',
    'Naga apartments private limited',
    'Manara properties private limited',
    'Mandva estate development and investment company private limited',
    'Raheja universal (pvt) limited',
    'QUIKR RED PRIVATE LIMITED',
    'Shantivan developers private limited',
    'Rb agarwal developers private limited',
    'Special situation advisors (india) private limited',
    'International institute of financial markets limited',
    'Jain metal components private limited',
    'Q-railing india private limited',
    'Sterlite iron and steel company limited',
    'Harsco india metals private limited',
    'Vaibhav fitting india private limited',
    'Miki wire works private limited',
    'Trichy amman steels private limited',
    'Stanzen techno private limited',
    'M k precision metal parts private limited',
    'Basar steel private limited',
    'STANDARD STRIPS INDIA LIMITED',
    'RAV',
    'S SMART LEARNING SOLUTIONS PRIVATE LIMITED',
    'Phoren kampus private limited',
    'Navitus education private limited',
    'Kedia pipes private limited',
    'Bhakarh steel private limited',
    'Malnad alloy castings private limited',
    'Sungwoo stamping private limited',
    'RIDDHI STEEL AND TUBE Limited',
    'SIYARAM RECYCLING INDUSTRIES LIMITED',
    'Alwaye metals and alloys private limited',
    'Edubooks solutions private limited',
    'Siddhi robo plasma cuts private limited',
    'Aishu castings limited',
    'Sukh steels private limited',
    'Gujarat alloys cast private limited',
    'Nyalkaran steel private limited',
    'Schweissen metal industries private limited',
    'Navkar ispat private limited',
    'Advance metal corporation private limited',
    'Paragon steels private limited',
    'Subh lakshya metal exim private limited',
    'Bimaldeep infra-structure private limited',
    'Huawei technologies india private limited',
    'Nahar sheetmet private limited',
    'Metcraft engineering private limited',
    'Jumbo finance ltd',
    'Prayas metal (india) private limited',
    'PACIFIC ALLOYS PRIVATE LIMITED',
    'AGARVANSHI ALUMINIUM AND INFRA LIMITED',
    'Sunkkalp creation private limited',
    'Yash jewellery private limited',
    'Lava cast private limited',
    'Adhir technocast private limited',
    'Invent cast private limited',
    'Umw metal private limited',
    'Wall colmonoy india private limited',
    'Mahendra strips private limited',
    'SHREEPRIYA STAMPING AND TOOLING PRIVATE LIMITED',
    'Gannon dunkerley infrastructure private limited',
    'Uhp technologies private limited',
    'Lcp building products private limited',
    'Arvs equipments private limited',
    'Artur schade steel products india private limited',
    'Continental thermal engineers private limited',
    'Temple packaging private limited',
    'Prarthna manufacturing private limited',
    'Teekay flowflex private limited',
    'Nima enterprises private limited',
    'Tecknoweld alloys (overseas) private limited',
    'Pune heat treat private limited',
    'Veeyes steelcast private limited',
    'Megamet engineers private limited',
    'S.m.systems private limited',
    'Globecom infotech private limited',
    'Stelle design private limited',
    'MALGRAT PROCUREMENT SERVICES PRIVATE LIMITED',
    'Shreenathji holidays private limited',
    'Simply green innovations private limited',
    'Sun impex clearing and shipping agency private limited',
    'Pyramid entek private limited',
    'Group edge brand and media managers (i) private limited',
    'Flop films private limited',
    'Deepraj software services private limited',
    'Advantage leadership solutions private limited',
    'VIVIDH FINVEST PRIVATE LIMITED',
    'Mitra s k coal inspection private limited',
    'MANIPAL EDUCATION AND HEALTHCARE INITIATIVE',
    'Precrete technologies private limited',
    'Select synergies and services private limited',
    'Excedo market services (india) private limited',
    'GRAM TARANG EMPLOYABILITY TRAINING SERVICES PRIVATE LIMITED',
    'FINITE HR & IT SOLUTIONS PRIVATE LIMITED',
    'Asian esprits private limited',
    'Caper logistics & warehousing private limited',
    'Green environex technology private limited',
    'Shyam indus power solutions private limited',
    'S r info solution private limited',
    'APAVE ASSESSMENTS INDIA PRIVATE LIMITED',
    'Ar crystal tech-solutions private limited',
    'Objectum capital advisors private limited',
    'Keshri & agarwal management consultancy services private limited',
    'Accredited consultants private limited',
    'MENTOR TRADING & CAPITAL CONSULTANTS PRIVATE LIMITED',
    'Advance mechanical services private limited',
    'Grand brand solutions private limited',
    'Hi destination management private limited',
    'Enhanced consultancy services private limited',
    'Yes integrated solutions private limited',
    'Zepo technologies private limited',
    'Indian export private limited',
    'Samridhi car rental private limited',
    'Aabmatica technologies private limited',
    'Bksb india private limited',
    'Tekies india private limited',
    'ACHANTA INFRA PROJECTS PRIVATE LIMITED',
    'K-FAM MICRO PRODUCTS PRIVATE LIMITED',
    'Promantec consultants private limited',
    'Abg engineering & constructions limited',
    'People in centre consulting services private limited',
    'Alma mater biz. solutions private limited',
    'Jain wealth managers private limited',
    'Cleanmax corporation private limited',
    'Planet group e private limited',
    'Amrop india consultants private limited',
    'R-tech facilities management private limited',
    'Staywell hospitality management private limited',
    'SHINING STAR OUTSOURCE SERVICES PRIVATE LIMITED',
    'Mishras corporate advisory private limited',
    'Gopichand rohra and associates private limited',
    'Simplex tmc private limited',
    'Bacc health care private limited',
    'Means 2 end consulting private limited',
    'Gill instruments private limited',
    'Mayflower language services private limited',
    'Innovare management india private limited',
    'Dream and magic media private limited',
    'Mothi consultancy services private limited',
    'Abhilekha information private limited',
    'Anklesaria consulting private limited',
    'Refonte technology & consulting private limited',
    'Capitaland retail property management india private limited',
    'V-ENCOMPASS PEOPLE ALIGNMENT SOLUTIONS PRIVATE LIMITED',
    'Kpk faserv india private limited',
    'PRESTIGE MALL MANAGEMENT PRIVATE LIMITED',
    'Inditrade business consultants limited',
    'Sumamba consultancy private limited',
    'Unarv telemedicine and healthcare services private limited',
    'Water melon consulting private limited',
    'FIRSTFOCUS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Safety supports systems p ltd',
    'Kedar spices limited',
    'Farsite reality pvt ltd',
    'BIGUL AGRO FOODS PRIVATE LIMITED',
    'Prakash inter national limited',
    'Vision drugs private limited',
    'Mascot industries private limited',
    'Mrm marketing pvt. ltd.',
    'United agro exports private limited',
    'Precise hydrodynamics india private limited',
    'DURGA AVENUE PRIVATE LIMITED',
    'Glaze paints limited',
    'Ranchi techno solutions private limited',
    'Tek advertising and management private limited',
    'Gyan plantations private limited',
    'Sahapur plantations and orchard pvt ltd',
    'Maldunge farming and agro produce p ltd',
    'Rahul agrotech (india) private limited',
    'Maldunge retreat and farming private limited',
    'Schon farms private limited',
    'Star land developers and investments private limited',
    'Svb enterprise private limited',
    'Mushroom impex india limited',
    'R.k. bio technologies private limited',
    'Daggubati farms and estates pvt ltd',
    'Green agrevolution private limited',
    'D k floriculture pvt ltd',
    'ISHKA RENEWABLE FARMS PRIVATE LIMITED',
    'Sunglow plantations private limited',
    'Shanthi feeds private limited',
    'Sunglow green fields private limited',
    'Samsing organic tea private limited',
    'Yangtong organic tea private limited',
    'Ideal horti agro private limited',
    'Baani milk producer company limited',
    'Kedia greenfields private limited',
    'Bamandanga tea estates private limited',
    'Fishfa agri world limited',
    'Sona coffee plantations private limited',
    'Ranjita scapes and designs private limited',
    'Kinger agrico private limited',
    'Jalan farms private limited',
    'Ashirwad agrotech private limited',
    'Chitale agro industries private limited',
    'Ultimate care products private limited',
    'SRI KAMALAGANAPATHY STEEL ROLLING MILLS PRIVATE LIMITED',
    'LG SPORTS PRIVATE LIMITED',
    'Petals innovative machines private limited',
    'Keartiman agro industries private limited',
    'Shrikishan and company private limited',
    'Primavera projects-n-constructions limited',
    'Shalimar corp limited',
    'Seco controls private limited',
    'Bmr industries private limited',
    'Oceanic bio-harvests limited',
    'GUNVOR TRADING LIMITED',
    'INDO NISSIN FOODS Private Limited',
    'Veejay sales and services limited',
    'Canopus trade links private limited',
    'Frontier aviation private limited',
    'HOME STORES (INDIA) Private Limited',
    'Anamallaiars ropeways company limited',
    'Comfort mines & minerals private limited',
    'Elveety industries private limited',
    'MERCATOR OFFSHORE LOGISTICS PRIVATE LIMITED',
    'Zoom mineral development private limited',
    'Tirupati Structures (India) Private Limited',
    'LEGACY GLOBAL CITYSPACES PRIVATE LIMITED',
    'Sagun copper conductors private limited',
    'Saipro biotech private limited',
    'Wardoli agro farms private limited',
    'Agriplast protected cultivation private limited',
    'Sanctity projects and developments private limited',
    'Raja ram marbles and minerals private limited',
    'Agave industries (india) private limited',
    'Verdanta harvests private limited',
    'Evershine recreations private limited',
    'Brothers minerals private limited',
    'Baba super minerals private limited',
    'Shah stone exports pvt ltd',
    'Alpha agrofarms and resorts india private limited',
    'Sunflower plantations private limited',
    'Opulent projects united (opu) limited',
    'A to z plants private limited',
    'Vasudhaika agritech private limited',
    'Shuban agro farm products private limited',
    'International creative foods limited',
    'Rushil agrotec private limited',
    'Good drop wine cellars private limited',
    'Earthen agro & infrastructure private limited',
    'Nakoda dairy private limited',
    'Shree salasarhanumanji grains private limited',
    'Basanna enterprises private limited',
    'Aqua food concepts limited',
    'Unicorn pickles private limited',
    'Vasant gourmet private limited',
    'JADLI FOODS (INDIA) PRIVATE LIMITED',
    'Gk corporation private limited',
    'Ahaan healthcare private limited',
    'L s r speciality oils private limited',
    'Globus industries and services limited',
    'South india edible private limited',
    'Kandla agro & chemicals private limited',
    'Chemmanur extracts private limited',
    'Sm autovision private limited',
    'R and d therm (india) private limited',
    'Sapphire kitchenware private limited',
    'Euro clean vacuum systems private limited',
    'Anulekh agrotech private limited',
    'Tressa electronics pvt ltd',
    'Aarambh (india) private limited',
    'LEINE & LINDE INDIA PRIVATE LIMITED',
    'Sameet trading and investment pvt ltd',
    'M b k textile engineers pvt ltd',
    'Microspin machine works private limited',
    'Real time controls private limited',
    'Sahajanand laser technology limited',
    'Pacer automation private limited',
    'Nispaara solutions india private limited',
    'Saraogi pile shoe private limited',
    'Actfive cleaning machines (india) private limited',
    'Himalaya machinery private limited',
    'ONLOAD GEARS PRIVATE LIMITED',
    'Sypram technology private limited',
    'Blue zone systems private limited',
    'WELEX SOFTWARE AND EDUCATION PRIVATE LIMITED',
    'Madras saf- holland manufacturing (india) private limited',
    'Vijay flexible containers private limited',
    'Cube power care private limited',
    'Jds transformers industries private limited',
    'Egston electronics (india) private limited',
    'Kmis engineering private limited',
    'MARATHON BATTERIES PRIVATE LIMITED',
    'Priya autocomponents private limited',
    'Deepsea technologies (india) private limited',
    'Malu electrodes private limited',
    'Penta designers and engineers private limited',
    'Vidyut agni sales and services private limited',
    'Nps driveautomation private limited',
    'Jumac manufacturing pvt ltd',
    'Vaupel textile machinery india private limited',
    'Pakona engineers (india)pvt ltd',
    'TECHNITHON TECHNOLOGIES PRIVATE LIMITED',
    'Yeshshree press comps private limited',
    'DBH HOLDINGS (INDIA) PRIVATE LIMITED',
    'Alba powerspack tooling india private limited',
    'Aesseal india private limited',
    'Zeutech engineers private limited',
    'Mextech technologies india private limited',
    'G.i. exports private limited',
    'Microft (india) pvt ltd',
    'Lalita electricals private limited',
    'Merit bmh engineering private limited',
    'Regency electricals private limited.',
    'Integrated electric co private limited',
    'Minco (india) pvt ltd',
    'Konark fixtures limited',
    'Accord power conversion private limited',
    'Shivamy technologies private limited',
    'J r power gen private limited',
    'Sabr controls private limited',
    'Venlite (india) private limited',
    'R. s. electro products private limited',
    'SHIVALIK ENGINEERED PRODUCTS PRIVATE LIMITED',
    'Arrow industrial electronics private limited',
    'Kirloskar technologies private limited',
    'Micron electricals private limited',
    'Rushe safe tek private limited',
    'Dauphin cables private limited',
    'Laurel wires limited',
    'Kjv alloy conductors private limited',
    'Minilec protective relay pvt ltd',
    'Racold Thermo Private Limited',
    'Schaltech systems (india) private limited',
    'Sam cables and conductors private limited',
    'Simandhar electro private limited',
    'JA-COMMODITIES PRIVATE LIMITED',
    'Teknic switchgear private limited',
    'C2C INNOVATIONS PRIVATE LIMITED',
    'Gajanand business private limited',
    'Teknic euchner electronics private limited',
    'Indic ems electronics private limited',
    'Surekha electronics services private limited',
    'Ulautomation systems private limited',
    'Transfix (india) private limited',
    'Sol engitech private limited',
    'Anixter india private limited',
    'Adisons precision instruments manufacturing company limited',
    'Pacific electronics private limited',
    'Wel-lite electricals and electronics private limited',
    'Saga enviro private limited',
    'COMMSCOPE INDIA PRIVATE LIMITED',
    'Motorola mobility india private limited',
    'Voicegate technologies india private limited',
    'Relemac technologies private limited',
    'Viking container terminals private limited',
    'Alert electro security devices private limited',
    'Indian products trading company private limited',
    'Semiconic devices private limited',
    'Prosperity lighting india private limited',
    'Electrotherm renewables private limited',
    'Arth diagnostic private limited',
    'Sundaram health protection private limited',
    'Micro flow devices india private limited',
    'Omnisic engineering & controls private limited',
    'Car-mel engineering india private limited',
    'Icl international limited',
    'Fairmacs trading company private limited',
    'D-espat private limited',
    'Green power solar systems private limited',
    'Jaaz textile systems private limited',
    'Shree adinath commercial company pvt. ltd',
    'Skylight trading company ltd.',
    'Kripa commodities private limited',
    'Preeticon commercial pvt. ltd.',
    'Multipack suppliers pvt ltd',
    'Larika tradecom private limited',
    'Skb enterprises private limited',
    'Sterlite deal-com private limited',
    'SETHIA KRISHI INDUSTRIES PRIVATE LIMITED',
    'Performance marketing ltd',
    'Admire vanijya private limited',
    'Sterlite tie - up private limited',
    'Sraddah vyapaar private limited',
    'Debdeep commercial private limited',
    'Miracle vintrade private limited',
    'Ankit commodeal private limited',
    'Harshit trexim private limited',
    'Gangamaa vintrade private limited',
    'Confirm merchandise private limited',
    'Newera barter private limited',
    'Heramb vinimay private limited',
    'Panchshree dealer private limited',
    'Hemang distributors private limited',
    'Bangbhumi agency private limited',
    'Fastspeed tie-up private limited',
    'Topflow commodities private limited',
    'Bluemotion trading private limited',
    'Viewmore tradelink private limited',
    'Vetali vintrade private limited',
    'Naidhura vyapaar private limited',
    'Rosco vinimay private limited',
    'Navotech exim private limited',
    'Shew merchandise private limited',
    'Maurya tradex private limited',
    'Scope trading company private limited',
    'Tnbt retail services private limited',
    'Elite cellular private limited',
    'R g b broadcasting equipments private limited',
    'Giacoklima systems private limited',
    'Bongio india private limited',
    'POLARIS INDCOMM PRIVATE LIMITED',
    '21 trends private limited',
    'Homestyle merchandise private limited',
    'Shree shyam vyapar private limited',
    'Utsav tracom private limited',
    'Resource vincom private limited',
    'Sublime distributors private limited',
    'Bhagwatkripa commercials private limited',
    'Satguru rojana retail private limited',
    'Ashtek dealcom private limited',
    'India forms centre pvt ltd',
    'Ronak mercantile private limited',
    'Intralead trade private limited',
    'Amruta fabrics private limited',
    'Corrtech energy limited',
    'Harsh electro systems private limited',
    'Debbas prime solutions private limited',
    'Miltex retail private limited',
    'Valerian goods private limited',
    'Cheerful suppliers private limited',
    'Golden time watches (india) private limited',
    'CLIFFORD CHANCE BUSINESS SERVICES PRIVATE LIMITED',
    'Nextenders (india) private limited',
    'DATAWAVE INFOTECH LIMITED',
    'Epari sadashiv private limited',
    'The ktm jewellery limited',
    'Yuvastyle retail private limited',
    'Farmachem private limited',
    'Buddy (mumbai) retail private limited',
    'C. c. patel distributors private limited',
    'Cel marketing pvt ltd',
    'Essasoft information technologies private limited',
    'Tecknoweld alloys (india) private limited',
    'SUNGRID ELECTRIC PRIVATE LIMITED',
    'Am pm electronics private limited',
    'Tf air systems private limited',
    'ROZEUS AIRPORT RETAIL LIMITED',
    'Shriv hospitality private limited',
    'Chanch palace resorts private limited',
    'Estrela hotels & resorts private limited',
    'Kumar city club limited',
    'AVYA HOTELS AND RESORTS PRIVATE LIMITED',
    'AAA GLOBAL ORGANISER PRIVATE LIMITED',
    'G and s hospitality private limited',
    'Maximus hotel catering services private limited',
    'Vinnamr hospitality private limited',
    'Cosmos hospitality & estates private limited',
    'Ramada hospitality private limited',
    'Great indian hospitality company private limited',
    'Supertech hotels private limited',
    'Le grand hospitality private limited',
    'Simpson resorts private limited',
    'Vmsalgaocar hotels and resorts private limited',
    'HOTEL SHILPIS INTERNATIONAL PRIVATE LIMITED',
    'Gaurav hotels pvt ltd',
    'Hot holidays private limited',
    'White sands resorts and hotels private limited',
    'Sangam motels private limited',
    'Indra hotels (mysore) private limited',
    '9 pax restaurant consultants private limited',
    'Narbheram realty private limited',
    'Gyaneshwar residency private limited',
    'Gyaneshwar complex private limited',
    'Aadi estate private limited',
    'Spa properties private limited',
    'NUEVO CONSULTANCY SERVICES PRIVATE LIMITED',
    'EKA LIFE LIMITED',
    'GODREJ GREEN HOMES PRIVATE LIMITED',
    'Gyaneshwar properties private limited',
    'Gyaneshwar infrabuild private limited',
    'Adhiraj infra estates private limited',
    'Mihira estate and reality private limited',
    'Precia estates private limited',
    'ANS DEVELOPERS PRIVATE LIMITED',
    'Arjun govin estate private limited',
    'Pancham international limited',
    'Ultimate promoters private limited',
    'Navyug apartment private limited',
    'Navyug griha private limited',
    'Navyug prodev private limited',
    'Magnum opus property private limited',
    'XINTHE TECHNOLOGIES PRIVATE LIMITED',
    'Sooryaasai services private limited',
    'Multywave technologies private limited',
    'Fabergent consulting services private limited',
    'Ark infotech spectrum india private limited',
    'Nunc systems private limited',
    'Prism land developments private limited',
    'Samah estates and hospitality private limited',
    'Samatma estates private limited',
    'Enabling dimensions india private limited',
    'Karmatech media works private limited',
    'Rajvi enterprise private limited',
    'Arivunidhi real estates and property developers private limited',
    'PARCELHERO TECHNOLOGIES PRIVATE LIMITED',
    'Agnity technologies private limited',
    'Svahgraha constructions and holdings private limited',
    'Gjr tech solutions private limited',
    'Exzeo software private limited',
    'Rhapsody application solutions private limited',
    'Crayon software experts india private limited',
    'Life time buildwell private limited.',
    'NB VISA WORLD PRIVATE LIMITED',
    'S S M INFOTECH SOLUTIONS PRIVATE LIMITED',
    'Elegant microweb technologies private limited',
    'Vr software systems private limited',
    'Softsense technologies private limited',
    'W s atkins (india) private limited',
    'Sai data systems private limited',
    'Syniverse technologies services (india) private limited',
    'Kohinoor technologies private limited',
    'Anum techno solutions private limited',
    'POWER RESEARCH AND DEVELOPMENT CONSULTANTS PRIVATE LIMITED',
    'TRIGENT SOFTWARE PRIVATE LIMITED',
    'Vays infotech private limited',
    'Mistral solutions private limited',
    'Darode jog homes private limited',
    'Jhum infrahome private limited',
    'Divyasree developers private limited',
    'Karm projects private limited',
    'Equis (india) real estate private limited',
    'Sunsip agro private limited',
    'Cisco systems capital (india) private limited',
    'Embedded software development systems private limited',
    'Micronova infotex private limited',
    'Eskay home stay private limited',
    'Dazzle projects private limited',
    'Xencia technology solutions private limited',
    'Keshava estate and reality private limited',
    'Sarah reality and finance private limited',
    'Zuriel leasing and development private limited',
    'Rebar design & detail private limited',
    'Florida builders private limited',
    'MCKINSEY GLOBAL CAPABILITIES & SERVICES PRIVATE LIMITED',
    'SANRIA ENGINEERING AND CONSULTING PRIVATE LIMITED',
    'E-tech services private limited',
    'Kramah software india private limited',
    'Couchbase india private limited',
    'Nittio solutions private limited',
    'Range consultants private limited',
    'Sevitech systems private limited',
    'Zenstark technologies private limited',
    'Amazecodes solutions private limited',
    'Info base india development centre private limited',
    'Cybercure technologies private limited',
    'Kandla finance limited',
    'Advanced millenium technologies private limited',
    'Fomax information technologies private limited',
    'Greypath infotech private limited',
    'Artoo it solutions private limited',
    'Triton systems private limited',
    'Soft systems limited',
    'Logic software solutions private limited',
    'Linknet solutions private limited',
    'Itnet infocom private limited',
    'Bigleap solutions private limited',
    'Vepsun technologies private limited',
    'Senaissance software private limited',
    'Planet blue marketing private limited',
    'Sa softech private limited',
    'Fergus software technologies private limited',
    'PYOME INFRA SOLUTIONS PRIVATE LIMITED',
    'Guru goutam infotech private limited',
    'Talent search services (india) private limited',
    'Ramee recruitment private limited',
    'Avon appliances private limited',
    'Membrane system specialists india private limited',
    'SURVIVAL TECHNOLOGIES LIMITED',
    'Association of indian cleaning industry',
    'Live connections placements private limited',
    'Bayswater trading private limited',
    'Wow solutions & systems private limited',
    'Moving trumpet communications private limited',
    'Designcore interiors private limited',
    'ROADPOINT LIMITED',
    'Essi integrated technologies private limited',
    'LX HAUSYS INDIA PRIVATE LIMITED',
    'Indian energy skill development private limited',
    'Intox private limited',
    'KNAUF CEILING SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Gadgil holdings private limited',
    'TRIPLE CROWN ASSET SERVICES PRIVATE LIMITED',
    'Spectra technoinfra private limited',
    'United hydrothane india private limited',
    'Candid technologies private limited',
    'Sinogate sourcing india private limited',
    'Inspace projects private limited',
    'Navneeti consultants private limited',
    'Intek security systems private limited',
    'Barefoot inns and leisure private limited',
    'Barefoot retreats and leisure private limited',
    'Itian infolabs private limited',
    'Bizaugmentor global services private limited',
    'JRS CREATIONS AND EVENT SOLUTIONS PRIVATE LIMITED',
    'Tekflair systems private limited',
    'Vtc lifts & escalators private limited',
    'Aventura amusement project private limited',
    'Vishva exim private limited',
    'Integrated public safety systems private limited',
    'Marvel conferences and events private limited',
    'Chanel (india) private limited',
    'V.j. home private limited',
    'Cherrytin online private limited',
    'COROMANDEL CHEMICALS LIMITED',
    'Air borne recruiting private limited',
    'Pristine care products private limited',
    'E-cube energy trading private limited',
    'Apropos consultant & service private limited',
    'Lorch welding products private limited',
    'Onspot solutions private limited',
    'Inora biotech private limited',
    'Twf studios private limited',
    'Prime exhibitions private limited',
    'Gowthami educational academy pvt ltd',
    'MALIBU MOTHER',
    'SQUARE REALTY PRIVATE LIMITED',
    'Shanders properties private limited',
    'Ravi and sanjay realties private limited',
    'Silver mist properties private limited',
    'Valuable destinations private limited',
    'Ultra promoters & developers private limited',
    'Govind kripa real homes private limited',
    'Libra infratech private limited',
    'Skylink infratech private limited',
    'Subala developments p ltd',
    'Stamford properties india private limited',
    'Transperent heights real estate limited',
    'Red apple realtor india private limited',
    'Livewell apartments pvt ltd',
    'Redbrix infratech private limited',
    'Saradha contech private limited',
    'Saradha buildtech private limited',
    'Saradha highcon private limited',
    'Saradha spacetown private limited',
    'Saradha infrabhawan private limited',
    'Wealth property managers private limited',
    'Ahuja royal constructions private limited',
    'Fine view concept properties private limited',
    'Vadan infra private limited',
    'Perspire builders & developers private limited',
    'LAXSONS BHARAT PRIVATE LIMITED',
    'Krutikumar realty holdings private limited',
    'Kumar sinew developers private limited',
    'ICONSTRUCT PRIVATE LIMITED',
    'Patel knr heavy infrastructures limited',
    'Swarnim gujarat fluorspar private limited',
    'Shirdi chemicals private limited',
    'Sapana overseas private limited',
    'Trimurti plant sciences private limited',
    'Charak healthcare private limited',
    'Baroda agro chemicals limited',
    'Schering-plough (india) private limited',
    'Jaypee organics private limited',
    'Tineta pharma private limited',
    'Premier nutraceuticals private limited',
    'Adlife healthcare private limited',
    'Forefront medtech private limited',
    'Watson pharma private limited',
    'Saibaba surfactants private limited',
    'Organon (india) private limited',
    'Pace pharmatech private limited',
    'Nasense labs private limited',
    'Coach nutrachem india private limited',
    'Epione labs private limited',
    'GE HEALTHCARE GLOBAL PRIVATE LIMITED',
    'Ellsworth adhesives india private limited',
    'Phyto life sciences private limited',
    'Avance polytech private limited',
    'Vibrant global salt private limited',
    'Scope chemicals private limited',
    'Fx pigments private limited',
    'Dev chemindustries mfg private limited',
    'R&m rasayana private limited',
    'Aspen biopharma labs private limited',
    'Par biosciences private limited',
    'Virocan therapeutics private limited',
    'Sheel biotech limited',
    'Eugene biosciences private limited',
    'Meenaxy pharma private limited',
    'Vivin laboratories private limited',
    'Flower valley perfumes private limited',
    'Patron industries private limited',
    'Perfecto textil chemicals private limited',
    'Anmol additives private limited',
    'Southern chemicals india private limited',
    'Lifesource pharmaceuticals private limited',
    'Ami polymer private limited',
    'SCHONESHAUS INDIA PRIVATE LIMITED',
    'Kandui industries private limited',
    'Urban plast pvt ltd',
    'Amity thermosets private limited',
    'Jollytech plastics private limited.',
    'Kac fibres private limited',
    'Unicon accessories private limited',
    'Rahsil plastic private limited',
    'Kloeckner pentaplast india private limited',
    'Pvn fabrics private limited',
    'ITALIA CERAMICS Limited',
    'Windsor refractories ltd',
    'Hipro ceraamics private limited',
    'SHRI HINDUSTAN CONCRETE BLOCKS PRIVATE LIMITED',
    'SURJA CONSTRUCTIONS PRIVATE LIMITED',
    'Interfer - vibrant steel private limited',
    'Rdc steels and allied service pvt ltd',
    'Shah brothers ispat private limited',
    'Topco tubes private limited',
    'M.b. smelters pvt ltd',
    'Asmi nickeco pvt ltd',
    'Hyderabad gems sez limited',
    'Ec metals (india) private limited',
    'Madhavratna stainless private limited',
    'Chennai ferrous industries limited',
    'Weldon steels private limited',
    'BENSON LASERTECH PRIVATE LIMITED',
    'First consulting engineers & services private limited',
    'Ems projects private limited',
    'Hi-can industries private limited',
    'Atn fabricators private limited',
    'WEE HUANG FOREX LIMITED',
    'Kundan industries limited',
    'SAKTHI HI-TECH FABRICATIONS PRIVATE LIMITED',
    'Thermal fabricators private limited',
    'GESTAMP PUNE AUTOMOTIVE PRIVATE LIMITED',
    'Lepretflo engineers pvt ltd',
    'Apollo fbc crushing equipments limited',
    'ADITYA INDUSTECH LIMITED',
    'Deva fabricators ltd.',
    'M.m.hydro pneumatics private limited',
    'Zener engineering private limited',
    'Sunrise engitech private limited',
    'Rockwell industries limited',
    'Sai deepa rock drills private limited',
    'Mechmaark engineers private limited',
    'Isotherm puf panel private limited',
    'Jainex (fire and safety) system private limited',
    'Modern flowtech india private limited',
    'Vasan engineering industries private limited',
    'IPANN MACHINERIES (INDIA) PRIVATE LIMITED',
    'Patricia engineering services private limited',
    'Prudent controls private limited',
    'E-emphasys solutions private limited',
    'Systech solutions private limited',
    'Agnie consulting (india) private limited',
    'Swift prosys private limited',
    'Ezdc automation private limited',
    'Sharp networking private limited',
    'Noroc solutions private limited',
    'Rnr datalex private limited',
    'Curogens software solutions private limited',
    'Software solution infocus it education private limited',
    'Trigma solutions private limited',
    'Actis global services private limited',
    'Nethues technologies private limited',
    'CRESCERANCE INDIA PRIVATE LIMITED',
    'Simform solutions private limited',
    'Synergy medsol private limited',
    'Baroda informatics private limited',
    'Euphoria technologies private limited',
    'Centramation systems private limited',
    'Whizzminds technologies private limited',
    'Space-o infoweb private limited',
    'Logic skill consulting private limited',
    'Nexxen solutions private limited',
    'PathPartner Technology Private Limited',
    'Scancafe digital solutions private limited',
    'Exsodel technologies private limited',
    'Actouch technologies private limited',
    'Niveus solutions private limited',
    'Bigonet technologies private limited',
    'Unitac energy solutions (india) private limited',
    'Pmam it services private limited',
    'Icicle technologies private limited',
    'Redon solutions private limited',
    'Webiq domains solutions private limited',
    'Mars synergies private limited',
    'Geetha systems private limited',
    'SOFSCRIPT HEALTHCARE SYSTEMS & SERVICES PRIVATE LIMITED',
    'Silcom solutions private limited',
    'Millennium consulting (india) private limited',
    'Turbonet systems private limited',
    'Applied cloud computing private limited',
    'INFOGAIN SOLUTIONS PRIVATE LIMITED',
    'Palash healthcare systems private limited',
    'Flightcase it services private limited',
    'Microlucid technology private limited',
    'Ascent it solutions private limited',
    'Edel tech private limited',
    'Ct info private limited',
    'Swayam infologic private limited',
    'Camelot integrated solutions private limited',
    'Ntech it solutions private limited',
    'Lumesse india private limited',
    'Riskspan india private limited',
    'Sybrant technologies private limited',
    'Sim technologies private limted',
    'Xenovex technologies private limited',
    'Rgs construction technologies private limited',
    'Reframe soft tech private limited',
    'LYCATECH SERVICES PRIVATE LIMITED',
    'Elait it technology services private limited',
    'Impactiva manufacturing systems india private limited',
    'Santriya technologies private limited',
    'Social technik digital private limited',
    'Onwardpath technology solutions private limited',
    'Plan b consulting private limited',
    'Carantas technologies private limited',
    'Roonaa technologies india private limited',
    'Research now india private limited',
    'Sunrise computer and management consultancy pvt ltd',
    'Remidio innovative solutions private limited',
    'Veol medical technologies private limited',
    'Loudcloud systems private limited',
    'Ishaan bio private limited',
    'Singhi wealth advisors private limited',
    'Ongc teri biotech limited',
    'Pune solapur expressways private limited',
    'Gp prohair private limited',
    'Simple ideas brand consultants private limited',
    'Suyog corporate solutions private limited',
    'U2L LEARNING SOLUTIONS LIMITED',
    'Legatax online info private limited',
    'Inventure merchant banker services private limited',
    'Indian art projects private limited',
    'Heinkel engineering private limited',
    'Asterix infotech private limited',
    'Aicon affordable real estate private limited',
    'Inzik ventures private limited',
    'Smick laboratories private limited',
    'SAB MEDIA NETWORKS PRIVATE LIMITED',
    'Frank lloyd tech management services limited',
    'Apar global private limited',
    'Access livelihoods consulting india limited',
    'Gs bussiness managers & marketing private limited',
    'Thakare consultancy services private limited',
    'Fa geocadsystems private limited',
    'Vivan infrastructure private limited',
    'Sancube infra projects private limited',
    'Avs project and constructions private limited',
    'Platinum superstructures private limited',
    'Amit bhosale developers pvt ltd',
    'Multi space developers private limited',
    'Shiva realtors suburban private limited',
    'Abhyudaya homes private limited',
    'Pune rehabilitation projects private limited',
    'ASHDAN TOWNSHIP VENTURES PRIVATE LIMITED',
    'New cyberabad city projects private limited',
    'Rattha holding company private limited',
    'Baby builders private limited',
    'Killick exports limited',
    'Optima homes private limited',
    'Neesa infrastructure limited',
    'POWERGRID RAMGARH TRANSMISSION LIMITED',
    'R-VIZON INFOTECH PRIVATE LIMITED',
    'VIRAJITHA TECHNOLOGIES PRIVATE LIMITED',
    'GREENITY MOTORS PRIVATE LIMITED',
    'BILLIONBLOCKS FINSERV PRIVATE LIMITED',
    'SIJA LOGISTICS PRIVATE LIMITED',
    'INTEGRATED CARGO MOVERS PRIVATE LIMITED',
    'SABARMATI EXPRESS INDIA PRIVATE LIMITED',
    'SPICEPOT FOOD VENTURES PRIVATE LIMITED',
    'ALPHAMECH ENGINEERING PRIVATE LIMITED',
    'ENVECOLOGIC PRIVATE LIMITED',
    'HAVISH ENTERPRISES PRIVATE LIMITED',
    'SPRING GROCERY PRIVATE LIMITED',
    'VG RETAIL BRANDS PRIVATE LIMITED',
    'MATRU BHOOMI REALTY DEVELOPERS PRIVATE LIMITED',
    'SPAZEVISION PRIVATE LIMITED',
    'RAB EDUTECH PRIVATE LIMITED',
    'DATALYNX PRIVATE LIMITED',
    'IMPERISH INFOTECH PRIVATE LIMITED',
    'PRAJNAKALPITA HEALTHTECH PRIVATE LIMITED',
    'CHARZERA TECH PRIVATE LIMITED',
    'DICELYTICS PRIVATE LIMITED',
    'HUTESKLAB PRIVATE LIMITED',
    'GIANT FILMS PRIVATE LIMITED',
    'BHADRA ENTERTAINMENTS LIMITED',
    'NAMMYOHO DAAN FOUNDATION',
    'TANIM PHARMA PRIVATE LIMITED',
    'DIGINFLUENZ PRIVATE LIMITED',
    'FEEDFRONT AI TECHNOLOGIES PRIVATE LIMITED',
    'INFINEXA SOLUTIONS PRIVATE LIMITED',
    'SHAMBHU TECHNOLOGY SERVICES PRIVATE LIMITED',
    'WOODLOY ENTERPRISE PRIVATE LIMITED',
    'MYPPE WELLNESS SERVICES PRIVATE LIMITED',
    'ANJEL BRAND PRIVATE LIMITED',
    'SAMUDAAY RETAIL PRIVATE LIMITED',
    'TRIVENI FOUNDATION',
    'URIEL PROCESS TECHNOLOGY PRIVATE LIMITED',
    'STL RUBBER PRIVATE LIMITED',
    'IMPKO PAINTS INDIA PRIVATE LIMITED',
    'SHOBHAGLOBS REWATT ENERGY PRIVATE LIMITED',
    'INMAKE PANEL INDUSTRIES PRIVATE LIMITED',
    'MICROBIAL RESEARCH LAB PRIVATE LIMITED',
    'KIANNA MEDIA VENTURES PRIVATE LIMITED',
    'VC TECHNOSOLUTIONS PRIVATE LIMITED',
    'CRAVERS BERG TECHNOLOGIES PRIVATE LIMITED',
    'KAIZEN FABRITECH PRIVATE LIMITED',
    'GALENA METALS PRIVATE LIMITED',
    'TECHSPIAN SERVICES PRIVATE LIMITED',
    'AFFILIATE HUB PRIVATE LIMITED',
    'WETC INTELLIGENT SOLUTIONS PRIVATE LIMITED',
    'IRM OFFSHORE AND MARINE ENGINEERS PRIVATE LIMITED',
    'BLUMERQ HEALTHCARE PRIVATE LIMITED',
    'PHARMANOVIA INDIA PRIVATE LIMITED',
    'NYMPHA LABORATORIES PRIVATE LIMITED',
    'DYUTHI LABS PRIVATE LIMITED',
    'DISHA LIFESTYLE BRANDS PRIVATE LIMITED',
    'IMAGINOVATION DIGITAL PRIVATE LIMITED',
    'GK PRODUCTION SOLUTIONS PRIVATE LIMITED',
    'STR8BAT SOLUTIONS INDIA PRIVATE LIMITED',
    'SUSTAINABLE SANITATION INDUSTRY ASSOCIATION',
    'RUDHRAN HEALTHCARE SUPPLIES PRIVATE LIMITED',
    'E2W STUDY OVERSEAS PRIVATE LIMITED',
    'SUPER LOGI-TECH PRIVATE LIMITED',
    'NAVA REALTY (OPC) PRIVATE LIMITED',
    'ZPROPERTIES PRIVATE LIMITED',
    'AKSHI ENGINEERS PRIVATE LIMITED',
    'MILKOR DEFENCE PRIVATE LIMITED',
    'RESKALED TECHNOLOGIES PRIVATE LIMITED',
    'RELOADLY TECHNOLOGIES PRIVATE LIMITED',
    'HINDUJA ROOFTOP PRIVATE LIMITED',
    'ABC RENEWABLE ENERGY (RJ-02) PRIVATE LIMITED',
    'BLACKPACK INDUSTRIES PRIVATE LIMITED',
    'TERMINALX GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'CLASSIC HEALTHCARE LABS PRIVATE LIMITED',
    'OMNICURE HEALTHCARE PRIVATE LIMITED',
    'COVID SAFE PRIVATE LIMITED',
    'AIVOT AI PRIVATE LIMITED',
    'COSMOVEND AUTOMATIONS PRIVATE LIMITED',
    'ELSASPEAK INDIA PRIVATE LIMITED',
    'TEACHMINT TECHNOLOGIES PRIVATE LIMITED',
    'GREENSAT INNOVATION LABS PRIVATE LIMITED',
    'KURISINKAL MERCANTILE PRIVATE LIMITED',
    'CLOUDBC LABS PRIVATE LIMITED',
    'SACHIT ELITES FACILITY SERVICES (OPC) PRIVATE LIMITED',
    'ETURNTI BUSINESS DESIGN (OPC) PRIVATE LIMITED',
    'FITTO PATIENT MANAGEMENT PRIVATE LIMITED',
    'ASHVAM TECHNOLOGY SERVICES PRIVATE LIMITED',
    'SOLITUDE BEACON TECHNOLOGIES PRIVATE LIMITED',
    'SARKINS PRIVATE LIMITED',
    'TRIEDATUM TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BSM ELECTRONICS (INDIA) PRIVATE LIMITED',
    'MICRONSURE CONSULTANCY PRIVATE LIMITED',
    'GEETH INFOTECH PRIVATE LIMITED',
    'CYBERNAUTS TECHNOLOGIES PRIVATE LIMITED',
    'NAGLA CONSULTING SERVICES PRIVATE LIMITED',
    'LEARN CLUE EDTECH PRIVATE LIMITED',
    'CE-N DIGITAL PRIVATE LIMITED',
    'KALPKRITI PRIVATE LIMITED',
    'BUSINESS DESIGN LAB PRIVATE LIMITED',
    'KTIRO INDIA PRIVATE LIMITED',
    'ZYDUS STRATEGIC INVESTMENTS LIMITED',
    'HOLYCO HEALTH PRIVATE LIMITED',
    'NEXT PACKAGING MACHINERY PRIVATE LIMITED',
    'EPLATFORM SOLUTIONS PRIVATE LIMITED',
    'CELCIUS LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'EX & EX PRIVATE LIMITED',
    'SOFTSKIRL INFOTECH PRIVATE LIMITED',
    'ENVIRO RECYCLEAN PRIVATE LIMITED',
    'COUNCIL OF INDIAN EXHIBITION ORGANISERS',
    'RD PETKONNECT PRIVATE LIMITED',
    'NAITYA INNOVATIONS PRIVATE LIMITED',
    'BIDFAIR GLOBAL (OPC) PRIVATE LIMITED',
    'BARUZOTECH PRIVATE LIMITED',
    'SUNEDISON ROOFTOP SOLAR SPV 6 PRIVATE LIMITED',
    'INCOMPRESSIBLE FLUID CONTROL SYSTEM PRIVATE LIMITED',
    'NEW VERTICAL SOLUTIONS PRIVATE LIMITED',
    'LEAF CAPER INDIA PRIVATE LIMITED',
    'ORA LOGISTICS PRIVATE LIMITED',
    'BASEFORCE PRIVATE LIMITED',
    'ASY TECH SOLUTIONS PRIVATE LIMITED',
    'BEAUTIFY SERVICES PRIVATE LIMITED',
    'SOFTCLAIN TECHNOLOGIES PRIVATE LIMITED',
    'LEAP247 FINNOVATIONS PRIVATE LIMITED',
    'FLY OSTRICH INDIA PRIVATE LIMITED',
    'PERSISTO ENERGY PRIVATE LIMITED',
    'DAVAEE WALA RETAIL PRIVATE LIMITED',
    'PUREPRANA SERVICES PRIVATE LIMITED',
    'DIVYARC (OPC) PRIVATE LIMITED',
    'VERVE ADVISORY PRIVATE LIMITED',
    'STRATESPHERE GLOBAL SERVICES PRIVATE LIMITED',
    'BANKAKSTOGOODS INDIA PRIVATE LIMITED',
    'ATTNIC TERTIARY SOLUTIONS PRIVATE LIMITED',
    'COINBIT CHARITABLE FOUNDATION',
    'ARPRAG TRADEMART PRIVATE LIMITED',
    'ASHDAN BUILDCON PRIVATE LIMITED',
    'ZIRCON INTERIORS PRIVATE LIMITED',
    'PREV. INDIA PRIVATE LIMITED',
    'MQS TECHNOLOGIES PRIVATE LIMITED',
    'ON TIME SERVICE ABROAD (OPC) PRIVATE LIMITED',
    'TRINITYMATERIAL MARKET PLACE PRIVATE LIMITED',
    'VESTIAL CAPITAL PRIVATE LIMITED',
    'TIRUPATI IRON COMMERCIAL PRIVATE LIMITED',
    'ALL INDIA AI AND IOT RESEARCH ASSOCIATION',
    'PANACEA ENVIRO PRIVATE LIMITED',
    'BRANDMAN DECA PRIVATE LIMITED',
    'MIST N CLEAN PRODUCTS PRIVATE LIMITED',
    'INNOSEER PRIVATE LIMITED',
    'RIGIL-GENY INDIA PRIVATE LIMITED',
    'GLAMATE E-RETAIL PRIVATE LIMITED',
    'MACWALA DOT COM PRIVATE LIMITED',
    'MULTIPLES GOOD FAITH FOUNDATION',
    'RIOTECH INDUSTRIES PRIVATE LIMITED',
    'SPARTAN GAMES PRIVATE LIMITED',
    'SM SPORTS AND LIFESTYLE PRIVATE LIMITED',
    'TOPMODULE INTERIORS PRIVATE LIMITED',
    'ZIPPOLIGHTERS INDIA PRIVATE LIMITED',
    'JAINSONS FITWELL PRIVATE LIMITED',
    'GREENFINITY SYSTEMS PRIVATE LIMITED',
    'KAWAII GAMING PRIVATE LIMITED',
    'INCUBUS GAMING PRIVATE LIMITED',
    'HOME JUNCTION PRIVATE LIMITED',
    'WALKIFY TECHNOLOGY PRIVATE LIMITED',
    'SAARTH HOLIDAYS VENTURES PRIVATE LIMITED',
    'INTEGRATED EXIM LOGISTICS PRIVATE LIMITED',
    'CAMPUSLIFE PRIVATE LIMITED',
    'PLAY CENT TECHNOLOGIES PRIVATE LIMITED',
    'FIRST FUEL PRIVATE LIMITED',
    'PRESTIGEOUS PEST CONTROL PRIVATE LIMITED',
    'OMNI AGRO CHEMICALS PRIVATE LIMITED',
    'STROFES TECHNOLOGIES PRIVATE LIMITED',
    'HEALTHONIFY PRIVATE LIMITED',
    'GOELECTRONIX TECHNOLOGIES PRIVATE LIMITED',
    'ASSOCIATION OF INDIAN INVITS',
    'JAGDAMBA MEDICITY PRIVATE LIMITED',
    'ANABH GEMS PRIVATE LIMITED',
    'ILIPS INFOTECH PRIVATE LIMITED',
    'MECHMAARK INDUSTRIES PRIVATE LIMITED',
    'WAYDELTA FINANCIAL SERVICES PRIVATE LIMITED',
    'APPLET PROJECTS & ENGINEERING PRIVATE LIMITED',
    'TELCOPAY BPO PRIVATE LIMITED',
    'GIESEL HEALTHNET PRIVATE LIMITED',
    'XANDR INDIA PRIVATE LIMITED',
    'DANFOSS FLUID POWER PRIVATE LIMITED',
    'TRAFFICMOBS (OPC) PRIVATE LIMITED',
    'TALUPULA FARMERS PRODUCER COMPANY LIMITED',
    'SHIVALIK SMALL FINANCE BANK LIMITED',
    'REPHRASE TECHNOLOGIES PRIVATE LIMITED',
    'FACILITTO TECHNOLOGIES PRIVATE LIMITED',
    'RADIANCE KA SUNRISE ONE PRIVATE LIMITED',
    'MOVE ON INFOTECH SOLUTIONS PRIVATE LIMITED',
    'GLOBAL ECOPACK PRIVATE LIMITED',
    'LEGRO OVERSEAS PRIVATE LIMITED',
    'KIAISH SOURCING PRIVATE LIMITED',
    'MALLINA LIFE SCIENCES PRIVATE LIMITED',
    'REXSQUARE PRIVATE LIMITED',
    'VJC INFRA PROJECTS PRIVATE LIMITED',
    'AMARE GOUDA DESIGN & BUILD PRIVATE LIMITED',
    'MAHAT LABS PRIVATE LIMITED',
    'COW ELEPHANT CONSULTANCY (OPC) PRIVATE LIMITED',
    'CAPTAIN & BELLS PRIVATE LIMITED',
    'AUTONETICS EQUIPMENT PRIVATE LIMITED',
    'HARBOUR AMC PRIVATE LIMITED',
    'VALUE RCM SOLUTIONS PRIVATE LIMITED',
    'XIOM HEALTH PRIVATE LIMITED',
    'TRAFINSERVE PRIVATE LIMITED',
    'DIGITAL360SHOP PRIVATE LIMITED',
    'ANJALI FLOORING PRIVATE LIMITED',
    'DECOINDIA FABRICS PRIVATE LIMITED',
    'H S TAX ADVISORY PRIVATE LIMITED',
    'GOLDTRUST INNOVATIONS PRIVATE LIMITED',
    'TKG VENTURES PRIVATE LIMITED',
    'BANJARAN VILLAGE GIRL ECOMM PRIVATE LIMITED',
    'MY WORLD FULL OF POSSIBILITIES PRIVATE LIMITED',
    'PRODEGE INDIA PRIVATE LIMITED',
    'VEDVIDYA CHARITABLE FOUNDATION',
    'PESTSAN SERVICES PRIVATE LIMITED',
    'MADHUMA GLOBAL VENTURES PRIVATE LIMITED',
    'YELOWSOFT SERVICES PRIVATE LIMITED',
    'SNDIGITECH PRIVATE LIMITED',
    'TECHAVIOM FINANCE PRIVATE LIMITED',
    'TIMBERTRUSS DESIGN PRIVATE LIMITED',
    'COVERMATCH PRIVATE LIMITED',
    'CREDENCE TAX ADVISORS (OPC) PRIVATE LIMITED',
    'DIGICARE HEALTH SOLUTIONS PRIVATE LIMITED',
    'AYURHEMP PRIVATE LIMITED',
    'RATIONALYTICS (OPC) PRIVATE LIMITED',
    'EKGRAM PRODUCTS PRIVATE LIMITED',
    'URAAN CARES FOUNDATION',
    'FINO CAST PRIVATE LIMITED',
    'VERK TECHNOLOGIES PRIVATE LIMITED',
    'SILVERGENIE PRIVATE LIMITED',
    'SOCIAL CONTRACT RESEARCH AND INITIATIVE FOUNDATION',
    'AGARWAL MINING PRIVATE LIMITED',
    'FOREST X INDIA PRIVATE LIMITED',
    'PROCLOUDERS CONSULTING PRIVATE LIMITED',
    'ZEROCIRCLE ALTERNATIVES PRIVATE LIMITED',
    'APPLYBOARD INDIA PRIVATE LIMITED',
    'NETPIX ENTERTAINMENT PRIVATE LIMITED',
    'NK SECURITIES RESEARCH PRIVATE LIMITED',
    'UNIVERSE INSPECTION SERVICES PRIVATE LIMITED',
    'EMPLIANCE TECHNOLOGIES PRIVATE LIMITED',
    'LABNEAR TECHNOLOGY PRIVATE LIMITED',
    'PRATT & WHITNEY AGROW POWER PRIVATE LIMITED',
    'PRISCON TECHNOLOGIES PRIVATE LIMITED',
    'DESIGN NICELY TECHNOLOGIES PRIVATE LIMITED',
    'AGEM SPECIALITY GASES INDIA PRIVATE LIMITED',
    'RAGY TECHNOMART PRIVATE LIMITED',
    'BISWAKARMA KRAFT & ENGG. SERVICES PRIVATE LIMITED',
    'MALL OF RANCHI PRIVATE LIMITED',
    'SAKHI UDAAN FACILITIES PRIVATE LIMITED',
    'TALENTICA TREE FOUNDATION',
    'CUBIC MODULAR SYSTEM INDIA PRIVATE LIMITED',
    'FEYNMAN SOLUTIONS PRIVATE LIMITED',
    'FALLEN RECORDS PRIVATE LIMITED',
    'TRADINGBELLS SECURITIES PRIVATE LIMITED',
    'CLEAN EARTH ENERGY SOLUTION INDIA PRIVATE LIMITED',
    'DACRA TECH INDIA PRIVATE LIMITED',
    'EOOY TECHNOLOGIES PRIVATE LIMITED',
    'FRESH-N-FUSION AGRO FOOD INDIA PRIVATE LIMITED',
    'JAANKI PADMA OIL PRIVATE LIMITED',
    'HEAL ON WHEEL HEALTH CARE SOLUTIONS PRIVATE LIMITED',
    'MEDSHAKTI TECHNOLOGIES PRIVATE LIMITED',
    'CARE VISION FIBER PRIVATE LIMITED',
    'SRI HARSHA CARS PRIVATE LIMITED',
    'CURIOSEARCH LABS INDIA PRIVATE LIMITED',
    'GAMADIA ROAD VENTURES PRIVATE LIMITED',
    'Y-HAT ANALYTICS INDIA PRIVATE LIMITED',
    'DHOOT PROPERTIES MAINTENANCE PRIVATE LIMITED',
    'HARBOR PARTNERS PRIVATE LIMITED',
    'RAMANEELA LOGI EXPRESS PRIVATE LIMITED',
    'BAETTR INDIA PRIVATE LIMITED',
    'SAIBABA EDUTECH PRIVATE LIMITED',
    'RS DYAL AGRO PRIVATE LIMITED',
    'GREAT FOODCOMPANY PRIVATE LIMITED',
    'ZAAA INFRASTRUCTURE PRIVATE LIMITED',
    'ISM INFRASTRUCTURE PRIVATE LIMITED',
    'FINCHARTS FINANCIAL SERVICES PRIVATE LIMITED',
    'GREEN SPACES FARMS PRODUCER COMPANY LIMITED',
    'BOWERGROUPASIA INDIA PRIVATE LIMITED',
    'OM SHIVAY INDUSTRIES PRIVATE LIMITED',
    'CHIRAG WATERPROOFING AND COATINGS PRIVATE LIMITED',
    'R S COALMINES PRIVATE LIMITED',
    'UKIYOTECH TRADING PRIVATE LIMITED',
    'BOLD CARROT TRADING INDIA PRIVATE LIMITED',
    'CHILDREN',
    'S BUILD BRANDS MEDIA PRIVATE LIMITED',
    'ACME RENEWABLE SOLUTIONS PRIVATE LIMITED',
    'RENEW GREEN SHAKTI PRIVATE LIMITED',
    'ACME URJA PRIVATE LIMITED',
    'AMBITREE HEALTHCARE PRIVATE LIMITED',
    'ACME SURYA MODULES PRIVATE LIMITED',
    'PAXAL STAINLESS PRIVATE LIMITED',
    'MASTER SOLUTIONS INDUSTRY PRIVATE LIMITED',
    'RS HR STAFFING PRIVATE LIMITED',
    'PAVNI (DEL) RENEWABLE ENERGY PRIVATE LIMITED',
    'ZREJA INTERNATIONAL (OPC) PRIVATE LIMITED',
    'THIRU GNANASAMBANDAR FOUNDATION',
    'BITHUB TECHNOLOGIES PRIVATE LIMITED',
    'MPREX HEALTHCARE PRIVATE LIMITED',
    'BADRI ECO INDUSTRIES PRIVATE LIMITED',
    'BINDUSARA INDUSTRY PRIVATE LIMITED',
    'ARCVERA RENEWABLES INDIA PRIVATE LIMITED',
    'BETH SOFT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PROPCOOL REALTY PRIVATE LIMITED',
    'JOIN AND DONE SPACE SOLUTIONS PRIVATE LIMITED',
    'KIBI SPORTS PRIVATE LIMITED',
    'KIRTI TECHNOLOGIES PRIVATE LIMITED',
    'SURENDERS CENTRE FOR LEARNING ACCOUNTANCY PRIVATE LIMITED',
    'SHRI BHAGAVAAN GARDEN PRIVATE LIMITED',
    'NORDEX INDIA MANUFACTURING PRIVATE LIMITED',
    'KAMA JETS PRIVATE LIMITED',
    'APTON WORKS PRIVATE LIMITED',
    'VELNIK COLORS PRIVATE LIMITED',
    'HOUSEDECK FURNISHING PRIVATE LIMITED',
    'SHLOK TRANSCON PRIVATE LIMITED',
    'SSESASC NAGPUR INNOVATION FOUNDATION',
    'NEERTEK FUELCELLS PRIVATE LIMITED',
    'LEARNERO ACADEMY PRIVATE LIMITED',
    'ROIDEC PRIVATE LIMITED',
    'SAMAKSH VEDIC FLAVORS PRIVATE LIMITED',
    'TARUCHAYA COLONIZERS PRIVATE LIMITED',
    'ISHITA ENGINEERING SERVICES PRIVATE LIMITED',
    'MAGIK BUKET PRIVATE LIMITED',
    'SWARATNADEEP PRIVATE LIMITED',
    'DUCAB EW INDIA PRIVATE LIMITED',
    'GRAM TARANG TECHNICAL VOCATIONAL EDUCATION & TRAINING PRIVATE LIMITED',
    'ENDURANCE CONSULTANTS PRIVATE LIMITED',
    '9 PINN DIGITAL MEDIA PRIVATE LIMITED',
    'LEX RIKAI CONSULTANTS PRIVATE LIMITED',
    'BIOGREENIC POLYMERS PRIVATE LIMITED',
    'ABERDEEN FOODS PRIVATE LIMITED',
    'INSURESENSE TECHNOLOGIES PRIVATE LIMITED',
    'AMBAXO PROJECTS MANAGEMENT PRIVATE LIMITED',
    'RECREATOR INFOTECH PRIVATE LIMITED',
    'APLUSPLUS COWORKS PRIVATE LIMITED',
    'PLASTVISION INDIA PRIVATE LIMITED',
    'BLACKCOMB INDIA PRIVATE LIMITED',
    'JACSGREEN RECYCLING PRIVATE LIMITED',
    'SNP CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'ACCELIFY INDIA PRIVATE LIMITED',
    'REWARDBIG LOYALTY SOLUTIONS PRIVATE LIMITED',
    'ACIC SGTU COMMUNITY INNOVATION CENTRE',
    'TRUESPACE LEASING SOLUTIONS PRIVATE LIMITED',
    'PRIVACY4CARS PRIVATE LIMITED',
    'ABBEY EDGE INDIA PRIVATE LIMITED',
    'COSME DREAM INTERNATIONAL PRIVATE LIMITED',
    'ASIANCIP INDUSTRIES PRIVATE LIMITED',
    'SINECYCLE TECHNOLOGIES PRIVATE LIMITED',
    'BRAINSHARE CAPITAL PRIVATE LIMITED',
    'KLT CONSTRUCTIONS PRIVATE LIMITED',
    'ETHNIC MELA INDIA PRIVATE LIMITED',
    'M M GROUP HOLDINGS PRIVATE LIMITED',
    'WINSIL EVOLUTION PRIVATE LIMITED',
    'KERALA LIFESCIENCES INDUSTRIES PARKS PRIVATE LIMITED',
    'DEF-SAT INTERCONNECT SOLUTIONS PRIVATE LIMITED',
    'YBN GELATO CAFE PRIVATE LIMITED',
    'INDICA PHARMACEUTICALS PRIVATE LIMITED',
    'ALBRIGHT ELECTROMECHANICAL INDIA PRIVATE LIMITED',
    'MAKSPAY FINTECH SOLUTIONS PRIVATE LIMITED',
    'VILLAIN LIFESTYLE PRIVATE LIMITED',
    'FAST RETAILING (INDIA) MANAGEMENT CONSULTING PRIVATE LIMITED',
    'GOOD BUBBLE PRIVATE LIMITED',
    'VDESI MEDIA PRIVATE LIMITED',
    'PIOTEX VENTURES PRIVATE LIMITED',
    'HOMEXCHANGE PRIVATE LIMITED',
    'ADIPET INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'SJOZZY (OPC) PRIVATE LIMITED',
    'SUNRAYS PACKAGING PRIVATE LIMITED',
    'GROWTHSQAPES CONSULTING PRIVATE LIMITED',
    'EMBRYONIX PRIVATE LIMITED',
    'ASHIRWAD PLASTINDIA PRIVATE LIMITED',
    'HOPES FLEET MOVERS PRIVATE LIMITED',
    'CLANIFY MEDIA PRIVATE LIMITED',
    'AHIR FUELS PRIVATE LIMITED',
    'AMP ENERGY GREEN EIGHT PRIVATE LIMITED',
    'CILA INCUBATOR PRIVATE LIMITED',
    'REIMAGINING INDIA EDUINNOVATIONS PRIVATE LIMITED',
    'PRIYAL REALTY PRIVATE LIMITED',
    'HANRON TECH INNOVATIONS PRIVATE LIMITED',
    'DIGIMARTECH SOLUTIONS (OPC) PRIVATE LIMITED',
    'RABRIGID PRIVATE LIMITED',
    'GANGAMONI SHREE SHREE RAMKRISHNA PRIVATE LIMITED',
    'ELIXIR LABORATORIES PRIVATE LIMITED',
    'PLANTME AGRO SOLUTIONS PRIVATE LIMITED',
    'STAR NOVA INTELLIGENT LOGISTICS EQUIPMENT PRIVATE LIMITED',
    'MEEDAAS PROTEK PRIVATE LIMITED',
    'TECHARMY CONSULTING INDIA PRIVATE LIMITED',
    'OPTIFIN SERVICES PRIVATE LIMITED',
    'B K KHOSE PRIVATE LIMITED',
    'TASKEY HOME SERVICES PRIVATE LIMITED',
    'YOSAN SPICES AND FOODS PRIVATE LIMITED',
    'HACKUP TECHNOLOGY PRIVATE LIMITED',
    'MECOSON PHARMACEUTICALS PRIVATE LIMITED',
    'OSOZNANIE PRIVATE LIMITED',
    'CAPITAL RETAIL PRIVATE LIMITED',
    'SUPERCAST HYBRID STRUCTURES PRIVATE LIMITED',
    'CANNTECH SERVICES PRIVATE LIMITED',
    'INOVEX CAREERLINK PRIVATE LIMITED',
    'HOFFENTECH SOLUTIONS LIMITED',
    'KIMMANE GOLF TERRAIN PRIVATE LIMITED',
    'ADHOOK MEDIA PRIVATE LIMITED',
    'FOOTIE FIRST PRIVATE LIMITED',
    'EDENCE LIFE SCIENCES PRIVATE LIMITED',
    'SWARNA ADITYA BULLION AND COMMODITIES RESOURCES PRIVATE LIMITED',
    'SALICE INDIA PRIVATE LIMITED',
    'SYSCORT TECH LABS PRIVATE LIMITED',
    'CAPWISE INVESTMENT ADVISORS PRIVATE LIMITED',
    'ZUBATT TECHNOLOGIES PRIVATE LIMITED',
    'QBYTECH SOLUTIONS PRIVATE LIMITED',
    'MITTWOCH RESEARCH AND TESTING LABORATORY PRIVATE LIMITED',
    'CREATING SMILES CHANGING LIVES FOUNDATION',
    'AKSHAYA AGRI EQUIPMENT & SERVICES PRIVATE LIMITED',
    'SKILLPETE EDUCATIONAL SERVICES PRIVATE LIMITED',
    'BHAGAWATI PRESTIGE MOTORS PRIVATE LIMITED',
    'ALEXA FILTRATION AND CLEANING SOLUTIONS PRIVATE LIMITED',
    'THEIA ENTERPRISE INDIA PRIVATE LIMITED',
    'SHIVVARDHAN KNOWLEDGE FOUNDATION',
    'INFOSEC CONSULTANT INDIA (OPC) PRIVATE LIMITED',
    'VIBHUPRADA SERVICES PRIVATE LIMITED',
    'FISH IN THE SKY PICTURES PRIVATE LIMITED',
    'TBO CARGO PRIVATE LIMITED',
    'DEGOLYER AND MACNAUGHTON INDIA PRIVATE LIMITED',
    'XIRIFY SYSTEMS PRIVATE LIMITED',
    'JAYS SPM PRIVATE LIMITED',
    'SERENSA HEALTHTECH AND HEALTHCARE PRIVATE LIMITED',
    'LIVESPACEBAR TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'TREMPLIN IMPEX PRIVATE LIMITED',
    'KIMMANE GOLF RESORT PRIVATE LIMITED',
    'ARCHITISING PRIVATE LIMITED',
    'TECHINTELLI SOLUTIONS PRIVATE LIMITED',
    'SAVIR PLATFORMS PRIVATE LIMITED',
    'MINERGY PRIVATE LIMITED',
    'PUNYA MASTERBATCHES PRIVATE LIMITED',
    'RBIL BANDHAN NIDHI LIMITED',
    'PRINCETON DIGITAL GROUP (INDIA) MANAGEMENT PRIVATE LIMITED',
    'STEADFAST MANUFACTURING PRIVATE LIMITED',
    'KAVANUR NIDHI LIMITED',
    'SKETCHBOAT PRIVATE LIMITED',
    'NEWGEN TECHNOVATIONS PRIVATE LIMITED',
    'EVOLUTICS INTERNATIONAL PRIVATE LIMITED',
    'SANMAT FOUNDATION',
    'TRISARGA NATURALS PRIVATE LIMITED',
    'GAURI KOHLI PRIVATE LIMITED',
    'EICKHOFF WIND ASIA PRIVATE LIMITED',
    'ATHMIN TECHNOLOGIES PRIVATE LIMITED',
    'PRANAMOJO PRIVATE LIMITED',
    'VISHAKHA GLASS PRIVATE LIMITED',
    'ASSETTRUST CONSULTING PRIVATE LIMITED',
    'CHAMBER OF COMMERCE & INDUSTRY FOR FACILITY MANAGEMENT & SMB',
    'ARABOTH FOODS PRIVATE LIMITED',
    'KOFFEETECH ACADEMY PRIVATE LIMITED',
    'RED QUBE IDEAS PRIVATE LIMITED',
    'CNH INDUSTRIAL TECHNOLOGY SERVICES (INDIA) PRIVATE LIMITED',
    'SHETH HOUSES PRIVATE LIMITED',
    'FURMS BUSINESS SOLUTIONS PRIVATE LIMITED',
    'RYKKA CORPORATION PRIVATE LIMITED',
    'KALUNKA AGRO PRODUCER COMPANY LIMITED',
    'TECHBHARAT RESEARCH FOUNDATION',
    'NOMOCO MASCHINEN INDIA PRIVATE LIMITED',
    'JEWEL CASA PRIVATE LIMITED',
    'GIRL EFFECT ENTERPRISE INDIA PRIVATE LIMITED',
    'KPR SUGAR AND APPARELS LIMITED',
    'RENAISSANCE ITES PRIVATE LIMITED',
    'SMART POWERTECH PRIVATE LIMITED',
    'ASPEN CLINICS PRIVATE LIMITED',
    'LEAP ENVIRO PRIVATE LIMITED',
    'SAN SOFTWARES PRIVATE LIMITED',
    'AESTHETIC RETAIL PRIVATE LIMITED',
    'BUY BRAND PRIVATE LIMITED',
    'GREENISIN PRIVATE LIMITED',
    'SOCIAL WHISPER PRIVATE LIMITED',
    'FORTUNE5 POWER PROJECTS PRIVATE LIMITED',
    'FORTUNE5 ENERGYTECH PRIVATE LIMITED',
    'JYESHTHA HEALTHCARE PRIVATE LIMITED',
    'BESPHARMA PRIVATE LIMITED',
    'TEPSOL SUN SPARKLE PRIVATE LIMITED',
    '4 IN FUTURE PRIVATE LIMITED',
    'YAJUR COMTRADE PRIVATE LIMITED',
    'DAMODAR IT SOLUTIONS PRIVATE LIMITED',
    'DAILYCUTTING TECHNOLOGY PRIVATE LIMITED',
    'BRAND BALANCE PRIVATE LIMITED',
    'PAN ASIAN HEALTH SYSTEM PRIVATE LIMITED',
    'LVE INNOVATIONS PRIVATE LIMITED',
    'ACEWARE FINTECH SERVICES PRIVATE LIMITED',
    'AYON AUTOMOBILES PRIVATE LIMITED',
    'NESTRUCTIVE BUILDERS PRIVATE LIMITED',
    'VINUTHANA PHARMA TECH PRIVATE LIMITED',
    'NAMASTRADE INDIA PRIVATE LIMITED',
    'SNEHBANDH AGRO FARMERS PRODUCER COMPANY LIMITED',
    'GUSTUS MARKET PRIVATE LIMITED',
    'MARUTI DELIVERY EXPRESS PRIVATE LIMITED',
    'ANKUSAM ENGINEERING PRIVATE LIMITED',
    'QUALTOP TECHNOLOGIES PRIVATE LIMITED',
    'ATUL NATURAL FOODS LIMITED',
    'ABUNDANCE RETAIL PRIVATE LIMITED',
    'SHAZMART INDIA PRIVATE LIMITED',
    'AKASHIC SANCTUARIES PRIVATE LIMITED',
    'SRI VIBHAVE AGENCIES PRIVATE LIMITED',
    'JOBE INFOSOL PRIVATE LIMITED',
    'OPTIMOR PRIVATE LIMITED',
    'SAHASRARA CONSTRUCTIONS PRIVATE LIMITED',
    'EDREV INDIA PRIVATE LIMITED',
    'NEXMONT INDUSTRIES PRIVATE LIMITED',
    'IVBI PRIVATE LIMITED',
    'TESTKONNECT SOLUTIONS PRIVATE LIMITED',
    'ESTHANA DESIGNS (OPC) PRIVATE LIMITED',
    'CADARRAY ENGINEERING PRIVATE LIMITED',
    'IKD TECHNOLOGIES PRIVATE LIMITED',
    'GOODWORKER TECHNOLOGIES PRIVATE LIMITED',
    'BURAKIA INDUSTRIES LIMITED',
    'TECHVZERO PRIVATE LIMITED',
    'AEC POWER SOLUTIONS PRIVATE LIMITED',
    'STAINLESS BAZAAR INDIA PRIVATE LIMITED',
    'SAVAGE RECHORDS PRIVATE LIMITED',
    'CONSULTFULL EMEDIA & BUSINESS PRIVATE LIMITED',
    'MATRIXONICS MARKETING PRIVATE LIMITED',
    'CREATIVE RAYS STUDIOS PRIVATE LIMITED',
    'ARDIAN GLOBAL EXPRESS PRIVATE LIMITED',
    'GOTBIGGER TECHNOLOGY PRIVATE LIMITED',
    'ADDRESS MAKER LOGISTICS PRIVATE LIMITED',
    'OPAL FINANCIAL VENTURE PRIVATE LIMITED',
    'RIVERSIDE AZO PIGMENTS INDIA PRIVATE LIMITED',
    'ALTIUS AEROSPACE PRIVATE LIMITED',
    'AMAL SPECIALITY CHEMICALS LIMITED',
    'D KART OFFICE SUPPLIES PRIVATE LIMITED',
    'CAPITAL BRIDGE PRIVATE LIMITED',
    'SHORTJOBS CONSULTANTS PRIVATE LIMITED',
    'ATHVA BEAUTY EXPORT PRIVATE LIMITED',
    'SPACE ALITY PRIVATE LIMITED',
    'MADHUSUDAN AGRAWAL PROJECT PRIVATE LIMITED',
    'INTELLOGER SOFTWARE PRIVATE LIMITED',
    'BOSON AUTO LIMITED',
    'JAMSFY TECHNOLOGIES PRIVATE LIMITED',
    'KEYUR ANIMAL HEALTHCARE PRIVATE LIMITED',
    'BULASIKKU TECHNOLOGIES PRIVATE LIMITED',
    'ONE69 MM TECHNOLOGIES PRIVATE LIMITED',
    'GOPAL AROMATIC PRIVATE LIMITED',
    'DHRUVI INFRABUILD PRIVATE LIMITED',
    'PROBOS ADVISORY PRIVATE LIMITED',
    'SEVEN - 11 INDUSTRIES PRIVATE LIMITED',
    'AUTOHOMATION PRODUCTS PRIVATE LIMITED',
    'ETHAN ENGINEERING PRIVATE LIMITED',
    'ZOCONUT PRIVATE LIMITED',
    'FIVE D HOMES PRIVATE LIMITED',
    'BITCOL ELRICH BITUMINOUS SYSTEMS PRIVATE LIMITED',
    'BHABHA HEALTHCARE AND MEDISCIENCE PRIVATE LIMITED',
    'VINIT MACHINES PRIVATE LIMITED',
    'CPM DIGITAL PRIVATE LIMITED',
    'PHOENIX EFS IFM SERVICES PRIVATE LIMITED',
    'S D SUPPLY CHAIN MANAGEMENTS PRIVATE LIMITED',
    'COGNIUS.AI (INDIA) PRIVATE LIMITED',
    'SHIVRAM FORGING & FABRICATION WORKS PRIVATE LIMITED',
    'KALA SPAN DEFENCE PRIVATE LIMITED',
    'KAILASH SUPER-SPECIALITY HOSPITAL PRIVATE LIMITED',
    'PANTEN PRODUCTS PRIVATE LIMITED',
    'WIZARU LEARNING PRIVATE LIMITED',
    'GLOBAL KASHMIRI PANDIT BUSINESS FOUNDATION',
    'UNMESH INDUSTRIES PRIVATE LIMITED',
    'KMCC Q CARE FOUNDATION',
    'SYROHCHEM LABORATORIES PRIVATE LIMITED',
    'FINOIT DIGITAL TECHNOLOGY PRIVATE LIMITED',
    'LOGICEYE RESOURCES MANAGEMENT PRIVATE LIMITED',
    'ECOWRAP IMPACT PRIVATE LIMITED',
    'AGRIKNIT PRIVATE LIMITED',
    'MAHAGAURI STONE CRUSHER PRIVATE LIMITED',
    'ARDAAS AIROCEAN LOGISTICS PRIVATE LIMITED',
    'CARCARE AUTOMOTIVES PRIVATE LIMITED',
    'F5 EDUCATIONAL VENTURES PRIVATE LIMITED',
    'VENISHA COLORS & CHEMICALS PRIVATE LIMITED',
    'BECOMING PRIVATE LIMITED',
    'ESTORIFI SOLUTIONS PRIVATE LIMITED',
    'YELLOWBOXPAY NIDHI LIMITED',
    'INOVITIVI IDEAAZ PRIVATE LIMITED',
    'FRESHWAY LAGOON PRIVATE LIMITED',
    'BUMI HOME (INDIA) PRIVATE LIMITED',
    'DEXGREEN INDIA PRIVATE LIMITED',
    'PUHARI MOTORS PRIVATE LIMITED',
    'HI SECURE TECHNOVISION PRIVATE LIMITED',
    'EVOLVE GREEN PROJECTS PRIVATE LIMITED',
    'CLOMOTECH PRIVATE LIMITED',
    'VNR AGRI RESEARCH PRIVATE LIMITED',
    'TACHYONBYTE TECHNOLOGIES PRIVATE LIMITED',
    'SOURCE BREAK PRIVATE LIMITED',
    'ISGS CERTIFICATION PRIVATE LIMITED',
    'WILLOW & BANYAN PRIVATE LIMITED',
    'KHADE MICRO SERVICES FOUNDATION',
    'YBI FOUNDATION',
    'MEIL-ICOMM-TONBO TECH PRIVATE LIMITED',
    'CODE PARTNER IT SOLUTIONS PRIVATE LIMITED',
    'SJM CAPSOL PRIVATE LIMITED',
    'IME EDUCATION SOLUTIONS PRIVATE LIMITED',
    'GS COMPUTECH PRIVATE LIMITED',
    'OXELIZ GAMES PRIVATE LIMITED',
    'G2CS FACILITIES PRIVATE LIMITED',
    'BREAKOUT SOCIAL PRIVATE LIMITED',
    'VASWANI STEEL PRIVATE LIMITED',
    'WHOLE ORGANIC FOODS LIMITED',
    'MYBUILDIFY SOLUTIONS PRIVATE LIMITED',
    'RAIPUR AGRIGENETICS PRIVATE LIMITED',
    'PRAXIS STUDIO PRIVATE LIMITED',
    'PROSRENT TECHNOLOGIES PRIVATE LIMITED',
    'CHEMLIN ACP PUMPS PRIVATE LIMITED',
    'WIPRO GE MEDICAL DEVICE MANUFACTURING PRIVATE LIMITED',
    'ANANTAA ENGINEERING AND INFRASTRUCTURES PRIVATE LIMITED',
    'QUINLAN HOLDINGS PRIVATE LIMITED',
    'ITHIEL CONSTRUCTIONS PRIVATE LIMITED',
    'ACUTIS DIGITAL PRIVATE LIMITED',
    'SCATTO OVERSEAS ENTERPRISE PRIVATE LIMITED',
    'MODO TECHNOLOGIES PRIVATE LIMITED',
    'RX PROPELLANT PRIVATE LIMITED',
    'EMBRACE SYSTEMS PRIVATE LIMITED',
    'ZEDENTECH SOLUTIONS PRIVATE LIMITED',
    'MOHARIR MOTORS PRIVATE LIMITED',
    'PLUTO CESSNA BUSINESS PARKS PRIVATE LIMITED',
    'CREDAS TRUSTEESHIP SERVICE PRIVATE LIMITED',
    'ALAKART BIO PHARMA PRIVATE LIMITED',
    'ALLFIVE INDIA PRIVATE LIMITED',
    'SATOL CHEMICALS PRIVATE LIMITED',
    'CIS COMMODITY INSPECTION SERVICES (INDIA) PRIVATE LIMITED',
    'DAHLIA TECHNOLOGIES PRIVATE LIMITED',
    'COGNITIVE NAVIGATION PRIVATE LIMITED',
    '1PHI618 TECHNOLOGY SERVICES PRIVATE LIMITED',
    'TNYS GLOBAL PRIVATE LIMITED',
    'RANGEELA PICTURES PRIVATE LIMITED',
    'MACRO WEBBER (OPC) PRIVATE LIMITED',
    'ONEGLOBALUNI PRIVATE LIMITED',
    'SIMARTHAN FOUNDATION',
    'MY MOTOCARE SERVICES PRIVATE LIMITED',
    'SANDALWOOD INFOTECH PRIVATE LIMITED',
    'VS LT PARKING INFRASTRUCTURE PRIVATE LIMITED',
    'ONECONNECT SOCIAL VENTURES PRIVATE LIMITED',
    'VISITING HUMAN INDIA PRIVATE LIMITED',
    'PROJECTUM ACTIFS PRIVATE LIMITED',
    'MADEFROMGOOD LIFESTYLE (OPC) PRIVATE LIMITED',
    'LAXMIJANARDAN AGRO PRODUCTS PRIVATE LIMITED',
    'AJRITH TECH PRIVATE LIMITED',
    'THINK ZENITH PRIVATE LIMITED',
    'TRANS BORDER CHEMICALS PRIVATE LIMITED',
    'DAMANI RESEARCH FOUNDATION OF MEDICAL SCIENCES',
    'DANKUNI INDUSTRIAL PARKS PRIVATE LIMITED',
    'ALPHANIO NEXGEN PRIVATE LIMITED',
    'DR. KPC BIOINNOVATIONS & DIAGNOSTICS PRIVATE LIMITED',
    'PROV-NOVA BIO TECHNOLOGIES PRIVATE LIMITED',
    'MANJUSHREE FINTUBE PRIVATE LIMITED',
    'FINE AROMA SPECIALITIES PRIVATE LIMITED',
    'EMBRACE GAS GRID MANAGEMENT SERVICES PRIVATE LIMITED',
    'MIRAKIA SOLUTIONS PRIVATE LIMITED',
    'PROMFGMEDIA PRIVATE LIMITED',
    'KAUSTUBH MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'CNGAS INDUSTRIES PRIVATE LIMITED',
    'SUUMAYA RETAIL LIMITED',
    'DREAM DESIGN CONSTRUCTIONS PRIVATE LIMITED',
    'WHITE LUMINAIRE PRIVATE LIMITED',
    'PROMEN MANAGEMENT PRIVATE LIMITED',
    'CLERGO TECHNOLOGIES PRIVATE LIMITED',
    'HEMEE INTERNATIONAL PRIVATE LIMITED',
    'TRISUKA PROJECT PRIVATE LIMITED',
    'AIRDESIGN ENGINEERED SOLUTIONS PRIVATE LIMITED',
    'TLP CONSULTING PRIVATE LIMITED',
    'DOCTOR SHRIMP BLUE AQUA INT PRIVATE LIMITED',
    'MITHILA PICKLES AND CHUTNEYS PRIVATE LIMITED',
    'BHAGAT AUTO WORLD PRIVATE LIMITED',
    'SRIYON CONTROLS PRIVATE LIMITED',
    'SEVENSKYZ GLOBAL LOGISTICS PRIVATE LIMITED',
    'DREAM SIGNATURE TRAINING ACADEMY PRIVATE LIMITED',
    'HEXA PLAST INDUSTRIES PRIVATE LIMITED',
    'STAR ALPHA TECHNOLOGIES PRIVATE LIMITED',
    'REVANZA SENGUNDRAM INDUSTRIAL PARKS PRIVATE LIMITED',
    'CORDIAL CARE MEDICAL SERVICES PRIVATE LIMITED',
    'GRAVITYZIP BUSINESS SOLUTIONS PRIVATE LIMITED',
    'THILLAIS ANALYTICAL SOLUTIONS PRIVATE LIMITED',
    'PNW IT SERVICES PRIVATE LIMITED',
    'HAPPY DOG & PET SHOP PRIVATE LIMITED',
    'HYBRID ADTECH PRIVATE LIMITED',
    'BLACK SHORT INDIA LIMITED',
    'HL GLOBAL MARKETING PRIVATE LIMITED',
    'LOVEN PORTER LIFESTYLE PRIVATE LIMITED',
    'EVAAN SOFTTECH PRIVATE LIMITED',
    'PATIL RAIL FASTENING SYSTEMS PRIVATE LIMITED',
    'SBTECH SYSTEMS PRIVATE LIMITED',
    'OROCORP FINANCE PRIVATE LIMITED',
    'V2WEB SOLUTIONS PRIVATE LIMITED',
    'SHISH JEWELS PRIVATE LIMITED',
    'GR SHIRSAD MASVAN EXPRESSWAY PRIVATE LIMITED',
    'AYURQUEST EDUCATION PRIVATE LIMITED',
    'FINTOVATE TECHNOLOGIES PRIVATE LIMITED',
    'SEVAI VOLUNTARY ASSOCIATION',
    'LOGICMO SYSTEMS PRIVATE LIMITED',
    'NUTRAKIN PRIVATE LIMITED',
    'NAEMD EDUCATION AND WELFARE FOUNDATION',
    'REVANZA ECHANKARANAI INDUSTRIAL PARKS PRIVATE LIMITED',
    'MGRS METAL PROCESSORS PRIVATE LIMITED',
    'AINAL HEALTH CARE (OPC) PRIVATE LIMITED',
    'SHYAM STEEL WORKS PRIVATE LIMITED',
    'KAILASHMURLI & SON',
    'EAII ADVISORS PRIVATE LIMITED',
    'SHRI SIMHACHAL MINERALS PRIVATE LIMITED',
    'SNTG IT SERVICES PRIVATE LIMITED',
    'B N PANDEY FOUNDATION',
    'GRAVITY GLOBAL TECHNOX PRIVATE LIMITED',
    'HEYNCY ROYALSAGRO PRIVATE LIMITED',
    'EMBARKINGONVOYAGE DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PATELMECH PREQUASINE PRIVATE LIMITED',
    'CVDRAGON PRIVATE LIMITED',
    'KANISHK AUTOMATION PRIVATE LIMITED',
    'GRANULES LIFE SCIENCES PRIVATE LIMITED',
    'GALAXY MAGNUM PROJECTS PRIVATE LIMITED',
    'GENUZ TEK SERVICES PRIVATE LIMITED',
    'MYETERNALCARE PRIVATE LIMITED',
    'NEXT MOVE FLEET MANAGEMENT PRIVATE LIMITED',
    'INDICIUS TECHNOLOGIES PRIVATE LIMITED',
    'MSPL INDUSTRIAL SOLUTIONS PRIVATE LIMITED',
    'SCHWIHAG INDIA PRIVATE LIMITED',
    'ZAAKI FOODS PRIVATE LIMITED',
    'TEXSOURCE INTERNATIONAL PRIVATE LIMITED',
    'DOFIN TECH PRIVATE LIMITED',
    'SAMARITAN SOLAR ENERGY PRIVATE LIMITED',
    'IMNA VENTURE (OPC) PRIVATE LIMITED',
    'RICHREEF MINERALS PRIVATE LIMITED',
    'SOLUTUS GLOBAL EDUCATION PRIVATE LIMITED',
    'JAYAM PROLIFE PRIVATE LIMITED',
    'EURO TBA PROTECTIVE TECHNOLOGY SOLUTIONSINDIA PRIVATE LIMITED',
    'WEST LAKE PROPERTIES PRIVATE LIMITED',
    'MUNDHRA INFRA PROJECTS PRIVATE LIMITED',
    'LS DEVICES PRIVATE LIMITED',
    'AVISISH BUSINESS (OPC) PRIVATE LIMITED',
    '5CENTSCDN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'COVOLVE ENABLERS PRIVATE LIMITED',
    'PENTACLE DESIGNING SOLUTIONS PRIVATE LIMITED',
    'SHARE INDIA SMILE FOUNDATION',
    'PRESSHUB ENGINEERING PRIVATE LIMITED',
    'GABLER INDIA PRIVATE LIMITED',
    'MYFUNDBAZAAR INDIA PRIVATE LIMITED',
    'VEDICON VATSALYAM FOUNDATION',
    'EAGLE MARINE ENGINEERING CONSULTANCY PRIVATE LIMITED',
    'NAVA FOOD AND BEVERAGE PRIVATE LIMITED',
    'FAST TRACK CONSTRUCTION PROJECT PRIVATE LIMITED',
    'SOUTHERN HILLS INDUSTRIES PRIVATE LIMITED',
    'HAYAGREEV URJA PRIVATE LIMITED',
    'MERAKI APPAREL PRIVATE LIMITED',
    'TOOLSTR PRIVATE LIMITED',
    'ENOLA SOLUTIONS INDIA PRIVATE LIMITED',
    'ZAKVARI INDIA (OPC) PRIVATE LIMITED',
    'KIRITRA PRIVATE LIMITED',
    'DEORIENS HOSPITALITY PRIVATE LIMITED',
    'ARDENT PRIVACY PRIVATE LIMITED',
    'DAIMEN PHARMA PRIVATE LIMITED',
    'SMARTGRID IT SOLUTIONS PRIVATE LIMITED',
    'DCIPHER TALENTS PRIVATE LIMITED',
    'SYROLINK NETWORKS PRIVATE LIMITED',
    'ENVIROBOTICS PRIVATE LIMITED',
    'TALENTASSESS PRIVATE LIMITED',
    'S PATEL INFRA PRIVATE LIMITED',
    'ARLIGA INDIA OFFICE PARKS PRIVATE LIMITED',
    'RLC QUIZ PRIVATE LIMITED',
    'FABULICIOUS PRIVATE LIMITED',
    'VISHWA BUSES AND COACHES LIMITED',
    'SHANTIBARTA FOUNDATION',
    'MANTRA SANJEEVNI SOCIAL WELFARE ASSOCIATION',
    'WE3FOLKS CONSULTANTS PRIVATE LIMITED',
    'TECHIGAI PRIVATE LIMITED',
    'NOVIGI AI SOLUTIONS PRIVATE LIMITED',
    'POLYLOOP INDIA PRIVATE LIMITED',
    'EMINENT FOOD & DAIRIES PRIVATE LIMITED',
    'JD CONCORD DESIGN SOLUTION PRIVATE LIMITED',
    'ALENTRO BUSINESS SERVICES PRIVATE LIMITED',
    'SCRIPT PITCHERS PRIVATE LIMITED',
    'MIRROR AND MIME WELLNESS PRIVATE LIMITED',
    'MATRIONE MATRIMONIAL SERVICES PRIVATE LIMITED',
    'BIRCHFORD SOLUTIONS PRIVATE LIMITED',
    'MAYPOP BEAUTY PRIVATE LIMITED',
    'ELROI SPICE WORLD PRIVATE LIMITED',
    'SYSCODES INFOSYSTEMS PRIVATE LIMITED',
    'FORMAN TECHNOLOGY PRIVATE LIMITED',
    'ADACHI SVIPEGREEN PRIVATE LIMITED',
    'SUMERU AGRO VENTURES PRIVATE LIMITED',
    'JAIHIND TUBES PRIVATE LIMITED',
    'KEROSPACE SOLUTIONS PRIVATE LIMITED',
    'FRACTOPROP ONE PRIVATE LIMITED',
    'WESTZONE DEVELOPERS PRIVATE LIMITED',
    'GOLD SACHS VENTURES PRIVATE LIMITED',
    'FITWELL TECH INDIA PRIVATE LIMITED',
    'CAMPUS GYANI PRIVATE LIMITED',
    'ROHA WEALTH MANAGERS PRIVATE LIMITED',
    'GRAFAX GARMENTS PRIVATE LIMITED',
    'SMARTVEST WEALTH PRIVATE LIMITED',
    'SHRIKARNI ECOMMERCE SERVICES PRIVATE LIMITED',
    'WCM INNOVATIVE CONSULTING SERVICES PRIVATE LIMITED',
    'WENEXA INFRAVENTURE PRIVATE LIMITED',
    'NARMADAANCHAL WELFARE FOUNDATION',
    'JSI INVESTMENTS PRIVATE LIMITED',
    'ODINS BEARD PRIVATE LIMITED',
    'KANISH PLASTER PRIVATE LIMITED',
    'OSIYA PETROCHEM PRIVATE LIMITED',
    'HALLMARK IT HEALTHCARE SOLUTIONS PRIVATELIMITED',
    'DEEPWOODS GREEN INITIATIVES PRIVATE LIMITED',
    'PROTRADE APPLIED MATERIALS PRIVATE LIMITED',
    'SETUP & HOLD TIME CAPITAL MANAGEMENT PRIVATE LIMITED',
    'FELTHAM RESOURCES PRIVATE LIMITED',
    'ABHYUDAY BHARAT FARMER PRODUCER COMPANY LIMITED',
    'SKILLPROLEARN PRIVATE LIMITED',
    'VINYAS MECHANICAL ENGINEERING PRIVATE LIMITED',
    'KINGMEN INDUSTRIES PRIVATE LIMITED',
    'SIRUVAPURI MURUGAN INDUSTRIAL AND LOGISTICS PRIVATE LIMITED',
    'LEHRY INDUSTRIES PRIVATE LIMITED',
    'MORDOR INTELLIGENCE PRIVATE LIMITED',
    'FIBROSA TEXTILES PRIVATE LIMITED',
    'SAVENSA FINPRO SOLUTIONS PRIVATE LIMITED',
    'MARCS E-COMMERCE SERVICES (OPC) PRIVATE LIMITED',
    'ATLANTA TRANSFORMERS PRIVATE LIMITED',
    'DIGISPIN TECH PRIVATE LIMITED',
    'KALPY MARKETING PRIVATE LIMITED',
    'BLUMENOTICS INDUSTRIES PRIVATE LIMITED',
    'MONOKROM LASER PRIVATE LIMITED',
    'AGRIBEE SEEDS PRIVATE LIMITED',
    'CAPIZAL FINSERV PRIVATE LIMITED',
    'GRATEFUL GIVING FOUNDATION',
    'OYSTER MURAL PRIVATE LIMITED',
    'STATPRO TECH PRIVATE LIMITED',
    'PROVALIDATE SERVICES PRIVATE LIMITED',
    'THIRAM INDUSTRIES PRIVATE LIMITED',
    'WADI SURGICALS PRIVATE LIMITED',
    'IMEDICALWORKS INDIA PRIVATE LIMITED',
    'KAIVALE TECHNOLOGIES PRIVATE LIMITED',
    'GCCTPS PRIVATE LIMITED',
    'INSYSTY SOLUTIONS PRIVATE LIMITED',
    'RABI FRAGRANCE PRIVATE LIMITED',
    'FLORA INTERNATIONAL GREENSCAPES PRIVATE LIMITED',
    'PROPACK SOLUTIONS PRIVATE LIMITED',
    'LANDSCAPE AND URBANISM STUDIO PRIVATE LIMITED',
    'FLUX AUTO INDIA PRIVATE LIMITED',
    'DIVINE MAISON REALTY PRIVATE LIMITED',
    'UNIVASTU CHARITABLE FOUNDATION',
    'KSR FOODS AND BEVERAGES PRIVATE LIMITED',
    'TRADITIONAL WELLNESS INDIA PRIVATE LIMITED',
    'KONSULIT CONSULTANT (OPC) PRIVATE LIMITED',
    'AMAZEIP SOLUTIONS PRIVATE LIMITED',
    'NORLANKA MANUFACTURING INDIA PRIVATE LIMITED',
    'MOTHER-OCEAN PRIVATE LIMITED',
    'ADANI GOODHOMES PRIVATE LIMITED',
    'HARRA POLYTECH PRIVATE LIMITED',
    'MARQUANT CONSTRUCTIONS PRIVATE LIMITED',
    'ZEMHIVE PRIVATE LIMITED',
    'INTERNATIONAL ESHA TECHNOLOGIES PRIVATE LIMITED',
    'SILVER CONDOS HOLDINGS PRIVATE LIMITED',
    'HOMESCAPES CONSTRUCTIONS PRIVATE LIMITED',
    'AVIDA INCENSE PRIVATE LIMITED',
    'ARRIRISE HEALTHCARE PRIVATE LIMITED',
    'JAGTAP ENGINEERING PRIVATE LIMITED',
    'PLUTUS BIZZ ADVISORS PRIVATE LIMITED',
    'TECHCLOUDVERKS IT SOLUTIONS PRIVATE LIMITED',
    'NIBIAA DEVICES PRIVATE LIMITED',
    'LUNI FOODS PRIVATE LIMITED',
    'INTUILY INDIA PRIVATE LIMITED',
    'KAPI CHEM-HOUSE PRIVATE LIMITED',
    'SSCRAP CONSULTING PRIVATE LIMITED',
    'WENEXA REAL ESTATE PRIVATE LIMITED',
    'ALFAONE MEDICALS PRIVATE LIMITED',
    'B N PAPER AND BOARD PRIVATE LIMITED',
    'TRUSTSIGNAL VENTURES PRIVATE LIMITED',
    'ENVIRO GREEN RECYCLING PRIVATE LIMITED',
    'TRM CHITFUND PRIVATE LIMITED',
    'NIRAMAYA NUTS PRIVATE LIMITED',
    'VOXPRO TECHNOLOGIES PRIVATE LIMITED',
    'CHENGALPATTU WAREHOUSING PARKS PRIVATE LIMITED',
    'MARUDHAMALAI INDUSTRIAL & LOGISTICS PARKS PRIVATE LIMITED',
    'AVANT FERT PRIVATE LIMITED',
    'MARAGATHAMMBAL INDUSTRIAL AND LOGISTICS PARK PRIVATE LIMITED',
    'MACLEAR GLOBAL RISK MANAGEMENT PRIVATE LIMITED',
    'CHERRYCAPITAL FINSERV PRIVATE LIMITED',
    'KNASP EDU-ALLY PRIVATE LIMITED',
    'ORBI HEALTH PRIVATE LIMITED',
    'NMTB DEVELOPERS PRIVATE LIMITED',
    'L & M SERVICES PRIVATE LIMITED',
    'IBON INTERNATIONAL RESEARCH FEDERATION FOR HERPETOLOGY & ORNITHOLOGY',
    'CHENNAI ENVIRO SOLUTIONS PRIVATE LIMITED',
    'AVIOSE TECHNOLOGIES PRIVATE LIMITED',
    'COSTART TECHNOLOGIES PRIVATE LIMITED',
    'M BAZZAR PRIVATE LIMITED',
    'URBANE PLACERS PRIVATE LIMITED',
    'CONCLAVE LEARNING SOLUTIONS PRIVATE LIMITED',
    'BIOALLY ANIMAL FACILITY AND RESEARCH PRIVATE LIMITED',
    'NIKHIL BHARAT SHIKSHA PARISAD FOUNDATION',
    'DIGIZAI INDIA PRIVATE LIMITED',
    'ENTHUDES DESIGN PRIVATE LIMITED',
    'ARCTURUS FOAM INDUSTRIES PRIVATE LIMITED',
    'WADHWA & ASSOCIATES PROJECT DEVELOPERS PRIVATE LIMITED',
    'RAYDS SERVICES LIMITED',
    'INVICTA HOMES PRIVATE LIMITED',
    'APPCRAVE TECHNOVATIONS PRIVATE LIMITED',
    'MASTER MOVERS GLOBAL PRIVATE LIMITED',
    'TSM PROJECT LOGISTICS PRIVATE LIMITED',
    'GRAHAMCODE TECHNOLOGIES AND SOLUTIONS PRIVATE LIMITED',
    'R.P WORLD ACCOMMODATION PRIVATE LIMITED',
    'DYNEGY POWER SYSTEMS PRIVATE LIMITED',
    'ANALYSTT AI TECHNOLOGY PRIVATE LIMITED',
    'TARINIKA PRIVATE LIMITED',
    'M K SOIL TESTING LABORATORY PRIVATE LIMITED',
    'SANY HOMES PRIVATE LIMITED',
    'SOLICIS LEX PRIVATE LIMITED',
    'KATAR TECHNOLOGIES PRIVATE LIMITED',
    'FUTURE TECH EMBEDDED SOLUTIONS (OPC) PRIVATE LIMITED',
    'TASS & HAMJIT GLOBAL PRIVATE LIMITED',
    'BELLURY PRIVATE LIMITED',
    'FRESHLOTUS PRIVATE LIMITED',
    'SUBLIME DATA SYSTEMS PRIVATE LIMITED',
    'MOSHSOFT ENTERTAINMENT INDIA PRIVATE LIMITED',
    'S R NATIVE PRODUCTS INDIA PRIVATE LIMITED',
    'AJT TECHNOLOGIES PRIVATE LIMITED',
    'ARISE O TECH ELECTRONICS I PRIVATE LIMITED',
    'KALIKA STEEL JALNA PRIVATE LIMITED',
    'BABACLICK TRADING PRIVATE LIMITED',
    'NARENDRA PLASTOCHEM PRIVATE LIMITED',
    'SDMA DESIGN CONSULTANTS (OPC) PRIVATE LIMITED',
    'ENVIRO FIBERS PRIVATE LIMITED',
    'TECHNOLOGY INNOVATION FOUNDATION OF IIT PALAKKAD',
    'SAMGRAH ENTERPRISES PRIVATE LIMITED',
    'NUEVO WISDOMLAND INFOTECH PRIVATE LIMITED',
    'PHOCKET FINANCE PRIVATE LIMITED',
    'SKILLIT EDUTECH PRIVATE LIMITED',
    'USPF VENTURES PRIVATE LIMITED',
    'NNPI PLASTIC PRIVATE LIMITED',
    'SHREE GANGAMAIYA SILK MILLS PRIVATE LIMITED',
    'HEALTHIZA LIFESCIENCE PRIVATE LIMITED',
    'MAA SHARDA EDUVENTURES PRIVATE LIMITED',
    'SAVITAI AGRO PRODUCER COMPANY LIMITED',
    'MYSOCIALCAPITAL PRIVATE LIMITED',
    'EDUSTEDY ENTIER PRIVATE LIMITED',
    'RUBIO WELLNESS PRIVATE LIMITED',
    'TOLARAM CONSULTANCY SERVICES PRIVATE LIMITED',
    'UGROW AGRITECH FOUNDATION',
    'FORECH FARMS PRIVATE LIMITED',
    'GLOBAL WIND ENERGY COUNCIL INDIA',
    'INTERNATIONAL MANAGEMENT ASSISTANTS ASSOCIATION OF INDIA',
    'VITHOBA HEALTHCARE AND RESEARCH PRIVATE LIMITED',
    'DN BHARNE INFRASTRUCTURE (INDIA) PRIVATE LIMITED',
    'ABIINNOVATIONS PRIVATE LIMITED',
    'SUPER SHAKTI ENTERPRISES PRIVATE LIMITED',
    'MULTANI INFRA & AGRO PRIVATE LIMITED',
    'ANRAX INFRA PRIVATE LIMITED',
    'WEALTHISLE FUTURE PRIVATE LIMITED',
    'RENEW SUN RENEWABLES PRIVATE LIMITED',
    'VOLEKTRA INDIA PRIVATE LIMITED',
    'DIRECT WHOLESALE PRIVATE LIMITED',
    'POLITECHNO SUPPORT SERVICES PRIVATE LIMITED',
    'EVERYONDR CAPITAL ADVISORS PRIVATE LIMITED',
    'K.H. EDUCATIONAL FOUNDATION',
    'MGFL MAHARANA GUILD OF FASHION AND LIFESTYLE PRIVATE LIMITED',
    'COCO CONTENTS PRIVATE LIMITED',
    'STUDYTONIGHT TECHNOLOGIES PRIVATE LIMITED',
    'THAMARAPPALLY BROTHERS TRADING PRIVATE LIMITED',
    'THAKRAL SERVICES INDIA LIMTED',
    'TELETEXT INDIA LIMITED',
    'TIC INTEGRATED MARKETING SERVICES PVT LTD',
    'THEA TEX HEALTHCARE INDIA PRIVATE LIMITED',
    'THERACHEM RESEARCH MEDILAB INDIA PRIVATE LIMITED',
    'TIDAL HEALTHCARE PVT LTD',
    'TEXTRONICS DESIGN SYSTEMS INDIA PVT',
    'THOMAS SCOTT INDIA LIMITED',
    'Tetra India Pvt Ltd',
    'The deal india pvt ltd',
    'THINCI SEMICONDUCTOR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'TELE ACCESS ESERVICES PRIVATE LIMITED',
    'TGC EXPORTS PVT. LTD',
    'Tenax india stone products private limited',
    'the circus entertainment pvt ltd',
    'TELE DNA COMMUNICATIONS PRIVATE LIMITED',
    'THE INDO ITALIAN CHAMBER OF COMMERCE AND INDUSTRY',
    'TICKTO SOLUTIONS INDIA PRIVATE LIMITED',
    'THOMAS HOTELS AND RESORTS INDIA PRIVATE LIMITED',
    'THE LESS PACKAGING COMPANY INDIA PVT LTD',
    'THAKAR SOFTWARE PRIVATE LIMITED',
    'THINK BIM Technical Services Pvt Ltd',
    'THREE P CONSULTAINTS PVT LTD',
    'THEME WEAVERS INTERNATIONAL PVT LTD',
    'THE CHOCOLATEROOM INDIA PRIVATE LIMITED',
    'TIARA TRADITIONS HOTEL PRIVATE LIMITED',
    'TENNY JOSE LIMITED',
    'TFB EXIM INDIA PRIVATE LIMITED',
    'TPT PRODUCTIONS PVT LTD',
    'TOWER INSURANCE AND REINSURANCE BROKERS INDIA PRIVATE LIMITED',
    'TIRUPATI CORPORATION PVT LTD',
    'TIMES CONFERENCES LIMITED',
    'TIRUPATI PLACEMENT ASSOCIATES PVT LTD',
    'TONGLIT AUTOGISTIC PVT LTD',
    'TIP AND TOE NAIL ART PRIVATE LIMITED',
    'Touchwood Entertainment Ltd',
    'TRACTION DIGITAL PRIVATE LIMITED',
    'TRACKPOINT GPS PRIVATE LIMITED',
    'TILDA HAIN INDIA PRIVATE LIMITED',
    'TOTAL SPORTING AND FITNESS SOLUTION PVT.LTD.',
    'TIKONA INFINET LIMITED',
    'TOWN ESSENTIALS PVT LTD',
    'TINY ERP PRIVATE LIMITED',
    'TOPPER and ROUTER LOGISTICS PVT LTD',
    'TIMES A AND M INDIA LIMITED',
    'Titan antony Aviation India Pvt Ltd',
    'TRANSGENE BIOTEK LTD',
    'TOSHNIWAL INSTRUMENTS MANUFACTURING PVT LTD',
    'TJSV STEEL FABRICATIONS & GALVANIZING (I) LTD',
    'TRANSTEEL SEATING TECHNOLOGIES PRIVATE LIMITED',
    'TMS INFONET PVT LTD',
    'TNS NETWORKING SOLUTIONS PRIVATE LIMITED',
    'TRACOM CONSULTANCY PRIVATE LIMITED',
    'TRANSFORM SOLUTION PRIVATE LIMITED',
    'TNET MESSAGING SERVICES PVT LTD',
    'TRADENEXT SECURITIES LTD',
    'tourkraft travel services pvt ltd',
    'TOTIENT BUSINESS SOLUTIONS PVT LTD',
    'TOPSHIELD SECURITY SERVICES PVT LTD',
    'TMERCHANDISING SERVICES PRIVATE LIMITED',
    'TOPS SECURITY LIMITED',
    'TIKI TAR DANOSA ( INDIA ) PVT LTD',
    'TRANSSYS SOLUTIONS PVT LTD',
    'TRANSOCEAN DRILLING SERVICES INDIA PRIVATE LIMITED',
    'TRADE AND TECHNOLOGY EXPOSITION I PVT LTD',
    'TNBT MARKETING SERVICES PVT LTD',
    'TILARA POLYPLAST PVT LTD',
    'TRANSTREASURE SERVICES INDIA PRIVATE LIMITED',
    'TRANSACT BPO SERVICES INDIA PRIVATE LTD',
    'TRANSORION LOGISTICS INDIA PVT LTD',
    'TOUCHSTONE EQUITIES LIMITED',
    'TOMOE SPECIALTY GAS AND CHEMICALS INDIAPRIVATE LIMITED',
    'TLT BABCOCK INDIA PVT LTD',
    'TRADEON TECHNOLOGIES PRIVATE LIMITED',
    'TKL KNITS INDIA PRIVATE LIMITED',
    'total facility management private limited',
    'TRACTEBEL CONSULTING ENGINEERS PRIVATE LIMITED',
    'TITANIC OCEAN SERVICES PVT LTD',
    'TRANSORG SOLUTIONS and SERVICES PRIVATE LIMITED',
    'TOTAL ENVIRONMENT PROJECTS INDIA PRIVATE LIMITED',
    'TIS INFOCOM PVT LTD',
    'TIONALE IMPEX PRIVATE LIMITED',
    'TRADE NET WEALTH MANAGERS PRIVATELIMITED',
    'TINETA PHARMA PVT LTD',
    'TSI SOFTECH INDIA PVT LTD',
    'TRUESEED INVESTMENT CONSULTANTS PRIVATELIMITED',
    'TRYST INDUSTRIES PRIVATE LIMITED',
    'TRAVELVOYAGES INDIA PRIVATE LIMITED',
    'TRAVEL OYTSER INDIA PVT LTD',
    'TRIDENT TECHLABS PRIVATE LIMITED',
    'TRIMURTI CARS PVT LTD',
    'U Solar Clean Energy Solutions Pvt Ltd',
    'TRUCUT TOOLS (INDIA) P LTD',
    'TRAVEL BULLZ INDIA PVT LTD',
    'TRAVEL INN INDIA PRIVATE LIMITED',
    'TWINSTAR INDUSTRIES LTD',
    'Trust systems and software (india) private limited',
    'TVS TWG WARRANTY SOLUTIONS LIMITED',
    'TTI ELECTRONICS ASIA INDIA PRIVATE LIMITED',
    'Trend Arrest Clothing Pvt Ltd',
    'TSEPAK TECHNOLOGIES PVT LTD',
    'TRAVANLEO INFO SOLUTIONS ( INDIA)PRIVATE LIMITED',
    'TRULY CREATIVE DEVELOPERS PVT LTD',
    'TRIWALL PAK PVT LTD',
    'Tropical transport systems india private limited',
    'TRUE COAT PAINTS PRIVATE LIMITED',
    'TRIVENI AERONAUTICS PRIVATE LIMITED',
    'TULIP STAR HOTELS LTD',
    'Two55am Studio Pvt Ltd',
    'TRIVITRON MEDICAL SYSTEMS PRIVATE LIMITED',
    'TRX LOGISTICS AND SUPPORT SERVICES PVT LTD',
    'TRIVERSE ADVERTISING PVT LTD',
    'TRINITY INSURANCE BROKERS PRIVATE LIMITED',
    'TRIGMA Solutions Pvt Ltd',
    'TRIMBLE SOLUTIONS INDIA PVT LTD',
    'TRIPHASE TECHNOLOGIES PVT LTD',
    'TRANSZONE LOGISTICS INDIA PRIVATE LIMITED',
    'TRICHEM LIFE SCIENCES LTD',
    'TWENTY FOUR SYSTEMS PVT LTD',
    'TRUE BLUE VOICE INDIA PRIVATE LIMITED',
    'TRIYAMA SOFTWARE PVT LTD',
    'TROPICOOL CAR GADGETS PVT LTD',
    'TUMMALA TEKNOSOFT SOLUTION PVT LTD',
    'U AND ME COMMUNICATION INDIA PRIVATE LIMITED',
    'TUBACEX PRAKASH INDIA PRIVATE LIMITED',
    'TS INFOTECH INDIA PVT LTD',
    'TWENTY FIRST CENTURY TECHNOPRODUCTS PVTLTD',
    'TVS CAPITAL FUNDS LIMITED',
    'TRIF REAL ESTATE AND DEVELOPMENT LIMITED',
    'TRUE WALL SPECIALITIES PVT LTD',
    'TRANSVISION SOFTWARE & DATA SOLUTIONSPRIVATE LIMITED',
    'Tring detectives and security solution private limited',
    'TULIP CREATIONS PVT LTD',
    'TRAVELTIME CAR RENTAL PRIVATE LIMITED',
    'TRIVAND TECHNOLOGIES PVT LTD',
    'Treezec E Solutions Private limited',
    'TYRE GRIP PVT LTD',
    'TRUMEN TECHNOLOGIES PVT LTD',
    'umkal health care pvt ltd',
    'UNITED EXIM PVT LTD',
    'UDAY MANAGEMENT SERVICES PVT LTD',
    'UDAY TOURS AND TRAVELS PVT LTD',
    'UDYOG SERVICES LIMITED',
    'UNISYS INFOSOLUTIONS PVT LTD',
    'Ubique systems Pvt Ltd',
    'UNI AUTOMATION INDIA PRIVATE LIMITED',
    'ULTRASEAL INDIA PRIVATE LIMITED',
    'UNIVERSAL CHEMICALS AND INDUSTRIES PVT LTD',
    'UNICON TECHNOLOGY INTERNATONAL PVT LTD',
    'UNICORN PICKLES PVT LTD',
    'UNIMARCK HEALTHCARE LTD',
    'UNIVERSAL FACILITY MANAGEMENT PRIVATE LIMITED',
    'ULTRA MEDIA & ENTERTAINMENT PVT LTD',
    'UNIVERSAL JOURNEYS INDIA PVT LTD.',
    'ULTRA RAYS 3D TECHNOLOGY PRIVATE LIMITED',
    'UNITED RACING AND BLOODSTOCK BREEDERS LIMITED',
    'UNIQUE AIRFREIGHT EXPRESS AND LOGISTICSPRIVATE LIMITED',
    'UIB INSURANCE BROKERS (INDIA) PRIVATELIMITED',
    'UNIVERSAL PHARMACEUTICALS LTD',
    'UNIBERA DEVELOPERS PVT LTD',
    'UNIVERSAL ENERGY SOLUTIONS PRIVATELIMITED',
    'UNITFORCE TECHNOLOGIES CONSULTING PRIVATE LTD',
    'ULYSESS SYSTEMS INDIA PVT LTD',
    'UNICORN UPTIME POWER PRIVATE LTD,',
    'UNISON ENGINEERING & CONSTRUCTION PRIVATE LIMITED',
    'ULT SUPPORT SERVICES INDIA PRIVATELIMITED',
    'UNITED ARAB SHIPPING AGENCY COMPANY INDIA PRIVATE LIMITED',
    'U V EXPORTS PVT LTD',
    'UKN PROJECTS PVT LTD',
    'UNIEXCEL AGENCIES AND SERVICES PRIVATE LIMITED',
    'UNIFY FACILITY MANAGEMENT PRIVATELIMITED',
    'ULLATTIL HOTELS AND SPA PRIVATE LIMITED',
    'UNITED RAIL-ROAD CONULTANTS PVT LTD',
    'UNISON INSURANCE BROKING SERVICESPRIVATE LIMITED',
    'uniciti solutions pvt ltd',
    'unicom finance pvt ltd',
    'UNISTANZ SOFTWAREPRIVATE LIMITED',
    'UNIQUE EYE LUXURY APPARELS PVT LTD',
    'UNIQUE VASTUSHILP AND PROJECTS PRIVATE LIMITED',
    'UNIFY SEARCH SOLUTIONS PVT LTD',
    'UM LOHIA TWO WHEELERS PRIVATE LIMITED',
    'Uniprogen Biotech Pvt Ltd',
    'UMANG PHARMATECH Private Limited',
    'VAISHALI PUBLICITY PRIVATE LIMITED',
    'usp trading and manufacturing pvt ltd',
    'URC INFOTEC PRIVATE LIMITED',
    'V CON INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'VALAYA CLOTHING PRIVATE LIMITED',
    'URBTECH INDIA DEVELOPERS PVT LTD',
    'UV AND W PRODUCTS LIMITED',
    'UTSAV SAFETY SYSTEMS Private limited ALTERATION',
    'VAIPAN SECURITIES PVT LTD',
    'V R FILMS and STUDIOS PRIVATE LIMITED',
    'VALUEPLUS INVESTMENT ADVISORS PVT LTD',
    'VAID ELASTOMER PROCESSORS PVT LTD',
    'VALUE SERVICES INTERNATIONAL PRIVATE LIMITED',
    'V EMPOWER SOLUTIONS PRIVATE LIMITED',
    'V ENSURE PHARMA TECHNOLOGIES PRIVATE LIMITED',
    'vakils premedia pvt ltd',
    'VALUEMOVES COMPUTING PRIVATE LIMITED',
    'VAIDEHI MOTORS PVT LTD',
    'v4 security service pvt ltd',
    'V V CORPORATE FINANCIAL SERVICES PVT LTD',
    'VALUE INSOURCE INDIA PRIVATE LIMITED',
    'UNOTECH SOFTWARE PVT LTD',
    'VALUEPRO INTERNATIONAL PVT LTD',
    'universities press india private limited',
    'URBAN SCIENCE APPLICATIONS PRIVATELIMITED',
    'UNIVERSAL SOMPO GENERAL INSURANCECOMPANY LIMITED',
    'VALUABLE DIGITAL SCREENS PRIVATE LIMITED',
    'URBAN HAWK SECURITY SERVICES PVT. LTD.',
    'Uptodate plastics and packaging private limited',
    'VANDERLANDE INDUSTRIES SOFTWARE PRIVATELIMITED',
    'URENOK SOFTWARE SOLUTIONS PVT. LTD.',
    'VAAS INDUSTRIES PRIVATE LIMITED',
    'UT BIKES LIMITED',
    'V V DYE CHEM PVT LTD',
    'UPAYAS INFOTECH PVT LTD',
    'VALVAYA TECHNOLOGIES PRIVATE LIMITED',
    'V R TECHNICHE CONSULTANTS PVT LTD',
    'VAISHNAVI MANAGEMENT PVT LTD',
    'V CARE SUPPORT SERVICES PVT LTD',
    'V AND M TOOLINGS PVT LTD',
    'VALUABLE TECHNOLOGIES LIMITED',
    'Upm - kymmene india private limited',
    'VERTICAL VYAPAAR PVT LTD',
    'VELIMALAI RUBBER CO LTD',
    'VCARE CALL CENTERS INDIA (P) LTD',
    'VEDIC BROADCASTING LTD',
    'VEDA INFORMATICS PVT LTD',
    'VERMILLION COMMUNICATION PRIVATE LIMITED',
    'VERONIK MICRONUTRIENTS PRIVATE LIMITED',
    'VEDIC NATURAL CARE PVT LTD',
    'VEN PETRO CHEM AND PHARMAINDIA PVT LTD',
    'VELOCITY TECH SOL INDIA PRIVATE LIMITED',
    'VEEPRHO LABORATORIES PVT LTD',
    'VASUDHA ORGANICS LIMITED',
    'VERTEBRAND MAAGEMENT CONSULTING PVT LTD',
    'VERITAS INDUSTRIES PVT LTD',
    'vibrant academy india pvt ltd',
    'VASWANI ESTATES DEVELOPERS PRIVATE LIMITED',
    'VEENUS MAINTENANCE SERVICES PVT LTD',
    'VIBRANT REALTY and INFRASTRUCTURE LIMITED',
    'VERNDALE SOFTWARE DEVELOPMENT INDIA PRIVATE LIMITED',
    'varuna d jani fine jewellery pvt ltd',
    'VATSA SOLUTION PVT LTD',
    'VASAV ENTERPRISES PVT LTD',
    'VIBRANT HOLIDAY DESTINATIONS PVT LTD',
    'VICHARA TECHNOLOGY INDIA PRIVATE LIMITED',
    'Vete associates tax and investments consultants private limited',
    'VEEYEM INTERIORS (I) PVT.LTD',
    'VENUS SAFETY AND HEALTH PRIVATE LIMITED',
    'VCLIENT WEALTH ADVISORY SERVICES PRIVATE LIMITED',
    'VERACITIZ SOLUTIONS PVT LTD',
    'viaan industries ltd',
    'VERTICAL DISCOVERY DATA SCIENCES PVT LTD',
    'vertisystem global pvt ltd',
    'Vicasa global technology services private limited',
    'VEDANG FOREX SOLUTIONS LIMITED',
    'VELAN IT SOLUTIONS PVT LTD',
    'VICOAST TECH SOLUTIONS PRIVATE LIMITED',
    'VEXXA LIFESCIENCES PVT LTD',
    'VIAROMANAA FASHIONS INDIA PRIVATE LIMITED',
    'VICTOR LOGISTICS PVT LTD',
    'VENSAI TECHNOLOGIES INDIA PRIVATE LIMITED',
    'VC ERP CONSULTING PVT LTD',
    'VECTOR NDT TECHNOLOGIES PVT LTD',
    'VECTONE INDIA MOBILE SERVICES PRIVATE LIMITED',
    'VIMAL MOULDERS (I) PVT LTD',
    'VINNY OVERSEAS PRIVATE LIMITED',
    'VIRTUOUS SECURITY AND FACILITY MANAGEMENT PRIVATE LIMITED',
    'VINAYAK INGREDIENTS INDIA PVT LTD',
    'Vipul Medcorp Insurance TPA Private Limited',
    'VIE SUPPORT LANGUAGE SERVICES PVT LTD',
    'VINDHYACHAL HYDRO POWER PVT LTD',
    'VIDHATA INDUSTRIES PVT LTD',
    'VINCOTTE INTERNATIONAL INDIA ASSESSMENT SERVICES PRIVATE LIMITED',
    'VISHAL PRECISION PRODUCTS PRIVATELIMITED',
    'VIKRAM THERMO INDIA LIMITED',
    'VISHAL FURNISHING LIMITED',
    'Vistra corporate services india pvt ltd',
    'VIRTUOS SOLUTIONS PRIVATE LIMITED',
    'VINCI TECHNOLOGIES LTD',
    'Vishwas Fincap Services Pvt Ltd',
    'VINDHYA E INFO MEDIA PRIVATE LIMITED',
    'Vishwas deshpande advisory services private limited',
    'VIRGO HOME DEZINER PVT. LTD.',
    'Vinshek marketing pvt ltd',
    'VIKARSH STAMPINGS INDIA PRIVATE IMITED',
    'Viking Resorts Pvt Ltd',
    'VIIKING MEDIA AND ENTERTAINMENT PRIVATELIMITED',
    'VISAGE IMPEX INDIA PRIVATE LIMITED',
    'Vishal structural pvt ltd',
    'VINDHYANCHAL FINLEASE PVT LTD',
    'VIJAY INFRATECH INDIA PVT LTD',
    'Vispro Megatrades LTD',
    'vipul medcare private limited',
    'VIRGO COMMUNICATIONS AND EXHIBITIONS PRIVATE LIMITED',
    'VINDECA LIFE SCIENCES PVT LIMITED',
    'VIRTUOUS ENERGY PVT LTD',
    'VIRAAT TECHNOLOGY LABS PVT LTD',
    'VIDUSHI INFOTECH SOFTWARE SOLUTIONS PROVIDER PVT LTD',
    'VISHVA PROTECH PVT LTD',
    'VISTAMIND EDUCATION PVT LTD',
    'WEBASTO ROOFSYSTEMS INDIA PVT LTD',
    'WAVE MEGACITY CENTRE PVT. LTD.',
    'VOVISTO DESTINATION MANAGEMENT SERVICES PRIVATE LIMITED',
    'VITREOSHEALTH (INDIA) PRIVATE LIMITED',
    'VRIDHI SOFTECH SERVICES PRIVATE LTD',
    'VV ECO GUM MANUFACTURING PRIVATE LIMITED',
    'WASAN MOTORS PVT LTD',
    'VOLLKRAFT ENGINEERS & CONSULTANTS PVTLTD',
    'Viva Total Facility and Management Services Private Limited',
    'VT CORP PRIVATE LIMITED',
    'VIVO LIFE SCIENCES P LTD',
    'W e excel softwares private limited',
    'VUCLIP INDIA PRIVATE LIMITED',
    'VULCAN COLD FORM PVT LTD',
    'WEBTOGO MOBILES INTERNET PRIVATE LIMITED',
    'VISWARUPA AUTOMOTIVES PRIVATE LIMITED',
    'VRG INFORMATION TECHNOLOGIES PRIVATE LIMITED',
    'VRAHEJA DESIGN CONSTRUCTION PRIVATE LIMITED',
    'WEAVEWELL EXPORTS PVT LTD',
    'WELD TECH ENGINEERS INDIA PRIVATE LIMITED',
    'vivaan flexi pack pvt ltd',
    'VMS ENGINEERING AND DESIGN SERVICES PVT LTD',
    'VIVOG COMMERCIAL LTD',
    'WALNUT ADVERTISING I PVT LTD',
    'WATSON MARLOW INDIA PRIVATE LIMITED',
    'VIVACITY INFOTECH Pvt LTD',
    'Weizmann impex service Enterprise limited',
    'WAAREE SOLAR ENERGY PRIVATE LIMITED',
    'WEB SYNERGIES INDIA PRIVATE LIMITED',
    'VIVID INFRASOLUTIONS PVT LTD',
    'VIT CONSULTANCY PRIVATE LIMITED',
    'webonise lab pvt ltd',
    'Way2online interactive india private limited',
    'VRISHA PHARMACEUTICALS PVT LTD',
    'VVIDIA COMMUNICATIONS PVT LTD',
    'W2BI MOBILE TECHNOLOGIES PRIVATE LIMITED',
    'WEALTH ADVISORS (INDIA) PRIVATE LIMITED',
    'VIVO COMMUNICATION DEVICE PRIVATE LIMITED',
    'VSKB Consultants Pvt Ltd',
    'WACOAL INDIA PRIVATE LIMITED LIMITED',
    'WARDHA SOLAR MAHARASHTRA PRIVATE LIMITED',
    'WB21 SOFTWARES PRIVATE LIMITED',
    'VJ CORESOFT PRIVATE LIMITED',
    'VYSHALI ENERGY PVT LTD',
    'VREP Construction and Consultants Pvt Ltd',
    'VPAC CARTONS INDIA PRIVATE LIMITED',
    'Web spidders (india) private limited',
    'VISVAS VOYAGES INDIA PRIVATE LIMITED',
    'VOXVALLEY TECHNOLOGIES PVT LTD',
    'Webaffinity Technologies Pvt ltd',
    'XENOLITH TECHNOLOGIES PRIVATE LIMITED',
    'WISH ENERGY SOLUTIONS PVT LTD',
    'WILLOW POLYMERS PRIVATE LIMITED',
    'XICOM TECHNOLOGIES LTD',
    'WINDMOLLER & HOLSCHER INDIA PRIVATELIMITED',
    'WORLD ONE SOLUTIONS PRIVATE LIMITED',
    'WOMENS CENTRE AND HOSPITALS PRIVATE LIMITED',
    'Wizard E Marketing Pvt Ltd',
    'XPEDIANT SOFTWARES PRIVATE LIMITED',
    'WELLMED INTERNATIONAL INDUSTRIES PRIVATE LTD',
    'WM LOGISTICS INDIA PRIVATE LIMITED',
    'XPRESSIONS PIXEL WORKS PVT LTD',
    'XPRT ENGINEERED PacKaging SOLUTIONS Private Limited',
    'XPO LOGISTICS WORLDWIDE INDIA PRIVATE LIMITED',
    'XS REAL PROPERTIES PRIVATE LIMITED',
    'WIRINTCO TECHNOLOGIES PVT LTD',
    'WONDER WASH PVT LTD',
    'WHITE CLOVE SERVICES PRIVATE LIMITED',
    'YAGACHI TECHNOLOGIES PVT LTD',
    'WORLD DESTINATION MANAGEMENT SERVICES PVT.LTD',
    'WISE TRAVEL INDIA PRIVATE LIMITED',
    'XSYSYS TECHNOLOGIES PVT LTD',
    'WINDCHIMES COMMUNICATIONS PVT LTD',
    'XECUTE HR SOLUTIONS PRIVATE LIMITED',
    'y axis solutions pvt ltd',
    'XCINO TECHNOLOGIES PRIVATE LIMITED',
    'WELLDONE OFFSHORE SERVICES PRIVATE LIMITED',
    'XRS LOGISTICS PVT LIMITED',
    'WEST COAST FINE FOODS (INDIA) PVT. LTD',
    'WIFI SOFT SOLUTIONS PRIVATE LIMITED',
    'WINDSOR PETROCHEMICALS PRIVATE LIMITED',
    'WILLIAM O NEIL INDIA PRIVATE LIMITED',
    'WINDFORCE MANAGEMENT SERVICES PVT LTD',
    'XERTZ BUSINESS SOLUTIONS PVT LTD.',
    'WIZE COMMERCE INDIA PRIVATE LIMITED',
    'WORLD EXPEDITIONS (INDIA)PVT LTD',
    'WHITE WARBLER COMMUNICATIONS PVT LTD',
    'XANGARS SOLUTIONS PRIVATE LIMITED',
    'WONDERBIZ TECHNOLOGIES PVT LTD',
    'WINDOORS INTERNATIONAL LTD',
    'WINNERS LIFE TRAINING PRIVATE LIMITED',
    'WONDERKIDS METRICS PRIVATE LIMITED',
    'WEST INDIA RECREATION PROJECTS PRIVATELIMITED',
    'WORLD KITCHEN INDIA PRIVATE LIMITED',
    'WORLDWIDE IMMIGRATION CONSULTANCY SERVICES PRIVATE LIMITED',
    'Zuari Finserv Limited',
    'YOUNG WOMENS CHRISTIAN ASSOCIATION OFINDIA.',
    'Zeus management services private limited',
    'ZENITH ROLLERS LIMITED',
    'zeniya electech pvt ltd',
    'YASH WEAVERS LIMITED',
    'YUDO HOT RUNNER INDIA PRIVATE LIMITED,',
    'YASH LASERTEK INDIA PVT LTD',
    'YASH METALICS PRIVATE LIMITED',
    'ZAPI TECHNOLOGIES INDIA PVT',
    'ZN RETAIL PRIVATE LIMITED',
    'ZODIAC MARITIME AGENCIES india pvt ltd',
    'Z AND H CONSULTANCY SERVICES PRIVATE LIMITED',
    'YOGI HI TECH PVT LTD',
    'zyeta interiors pvt ltd',
    'YAMUNA REALTY PVT LTD',
    'ZENITH TINS PVT LTD',
    'ZENTEK INFOSOFT INDIA PRIVATE LIMITED',
    'ZENTECH INDIA OFFSHORE AND MARINE ENGINEERS PRIVATE LIMITED',
    'ZENIUM CABLES LTD',
    'ZENSOL FASHION PRIVATE LIMITED',
    'YELLOW STAGE EVENTS AND EXHIBITIONS P L',
    'ZOLON TECH LIMITED',
    'ZIBIKA INFOTECH PVT LTD',
    'ADITI INTEGRATED SERVICE SOLUTIONSPRIVATE LIMITED',
    'AD ASTRA STAFFING SOLUTIONS PRIVATELIMITED',
    'ZUELLIG PHARMA SPECIALTY SOLUTIONS INDIA PRIVATE LIMITED',
    'ADITI STAFFING INDIA PRIVATE LIMITED',
    'ZENDESK TECHNOLOGIES PRIVATE LTD',
    'ACCORD GLOBAL TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Zinios Information Technologies Pvt Ltd',
    'ACENDRE INDIA PRIVATE LIMITED',
    '4DXFITNESS TECHNOLOGY INDIA PRIVATELIMITED',
    'ZENITH SYSTEM SOLUTION PVT LTD',
    'ZEN HOSPITALITY SERVICES PVT LTD',
    'zolt info solutions pvt ltd',
    'ZTC INTERNATIONAL LANDSCAPE SOLUTIONSPRIVATE LIMITED',
    'ZENSTAR COMPUTER SOLUTIONS PRIVATE LIMITED',
    'ZIA SEMICONDUCTORS PVT LTD',
    'ZOOMCAR INDIA PVT LTD',
    'Zerodha securities private limited',
    'ZYFIN RESEARCH PRIVATE LIMITED',
    '22ND AVENUE TALENT MANAGEMENT PRIVATELIMITED',
    'ABHIYANTA INDIA SOLUTIONS PRIVATELIMITED',
    'ZEN BUILDING SOLUTION PVT LTD',
    'BLICKX TECHNOLOGIES PRIVATE LIMITED',
    'aquagenics research and development india pvt ltd',
    'CLOUDACTION TECHNOLOGY SERVICES PRIVATELIMITED',
    'Auxo technology labs private limited',
    'CENTRAPRISE IT SOLUTIONS PRIVATE LIMITED',
    'Awan Infotech Pvt Ltd',
    'CODECLOUDS IT SERVICES PRIVATE LIMITED',
    'DIGITAL GUARDIAN TECHNOLOGIES INDIAPRIVATE LIMITED',
    'CHATOUS TECHNOLOGIES INDIA PRIVATELIMITED',
    'AMERITAS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ARCCORE TECHNOLOGIES INDIA PRIVATELIMITED',
    'BABELSYS TECHNOLOGY INDIA PRIVATELIMITED',
    'AMALTAS APPAREL AND ACCESSORIES PRIVATELIMITED',
    'ALPHA INTEGRATED MANAGEMENT SERVICES PVT LTD',
    'ANUPTECH SKILL DEVELOPMENT CENTREPRIVATE LIMITED',
    'AURUS SHIP MANAGEMENT PRIVATE LIMITED',
    'BESTLA INDUSTRIES PRIVATE LIMITED',
    'BJS DISTRIBUTION & STORAGE & COURIERSPRIVATE LIMITED',
    'Cubelogic Software India Pvt ltd',
    'CITCO SHARED SERVICES (INDIA) PRIVATELIMITED',
    'EDUSPACE TECHNOLOGIES PRIVATE LIMITED',
    'ELEMENTIAL LABS PRIVATE LIMITED',
    'Datopic Technologies Pvt Ltd',
    'COMRADE APPLIANCES PRIVATE LIMITED',
    'APPSIERRA SOLUTIONS PRIVATE LIMITED',
    'BENCHMARK BILLING SOLUTIONS PRIVATELIMITED',
    'DIGITAL OBSESSION COMMUNICATION PRIVATELIMITED',
    'MORGAN ADVANCED MATERIALS INDIA PRIVATELIMITED',
    'KNOWARTH TECHNOLOGIES PRIVATE LIMITED',
    'IOTAP TECHNOLOGY & SOLUTIONS PRIVATELIMITED',
    'LEXICONN CONTENT SERVICES PRIVATELIMITED',
    'KEERTI TUTORIALS INDIA PRIVATE LIMITED',
    'Instarem India Private Limited',
    'Hypsim Systems Private Limited',
    'LEXCARE GLOBAL CONSULTANTS PRIVATELIMITED',
    'INVENTIVE GLOBAL SOLUTIONS PRIVATELIMITED',
    'FACADE ONE SYSTEMS PRIVATE LIMITED',
    'MY TRAVEL YOGI PRIVATE LIMITED',
    'HOMETECH DIGITAL PRIVATE LIMITED',
    'HANSEN CUSTOMER SUPPORT INDIA PRIVATELIMITED',
    'IDEA SPARK SOLUTIONS PRIVATE LIMITED',
    'MAILKOOT COMMUNICATIONS PRIVATE LIMITED',
    'KNOWLEDGE MARINE & ENGINEERING WORKS PRIVATE LIMITED',
    'FLAT WORLD DESIGN & DEVELOPMENT PRIVATELIMITED',
    'KIFS HOUSING FINANCE PRIVATE LIMITED',
    'MOBIFY TECHNOLOGY SOLUTIONS PRIVATELIMITED',
    'EX2 SOLUTIONS INDIA PRIVATE LIMITED',
    'G P GLOBAL SOFT TECH PRIVATE LIMITED',
    'MATRIXCARE INDIA PRIVATE LIMITED',
    'FIELDGLOBAL MARKET RESEARCH PRIVATELIMITED',
    'HOCKEYCURVE GROWTH SOLUTIONS PRIVATELIMITED',
    'INFOCON SERVICES PRIVATE LIMITED',
    'HELLA INFRA MARKET LIMITED',
    'IMMOVABLE PROPERTY & SAFETY AGENCYPRIVATE LIMITED',
    'IBL FINANCE PRIVATE LIMITED',
    'KINOLVE SOFTWARE INDIA PRIVATE LIMITED',
    'MILESTONE GROUP INTERIOR SOLUTIONS PRIVATE LIMITED',
    'IOMARKET SOFTWARE SERVICES PRIVATELIMITED',
    'Infinios Business Solutions India Pvt Ltd',
    'INNOVISION INTEGRATED SOLUTIONS PRIVATELIMITED',
    'MEDIVISION EYE & HEALTH CARE CENTREPRIVATE LIMITED',
    'GLOBALAXIS ENGINEERING SERVICES PRIVATELIMITED',
    'GREEN CUBES TECHNOLOGY ( POWERSOLUTIONS) PRIVATE LIMITED',
    'Signitech it solutions private limited',
    'RSI RETAIL SOLUTIONS INDIA PRIVATELIMITED',
    'ROLLPRO TECHNOLOGIES PRIVATE LIMITED',
    'PHOENIX ROBOTIX PVT LTD',
    'PLATINUM INFRADEVELOPMENT PRIVATELIMITED',
    'PIXITREE DIGITAL CREATIVES PRIVATE LIMITED',
    'PACTERA TECHNOLOGIES INDIA PRIVATE LIMITED',
    'OKINAWA AUTOTECH PRIVATE LIMITED',
    'NEP BROADCAST SOLUTIONS (INDIA) PRIVATELIMITED',
    'NATURES TREAT FOODS PRIVATE LIMITED',
    'SADAGATI CLEARING SERVICES PRIVATELIMITED',
    'PEEL TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'SEMANTICS3 TECHNOLOGIES INDIA PRIVATE LIMITED',
    'PERIGORD PREMEDIA (INDIA) PRIVATELIMITED',
    'SOARES ENTERPRISES (INDIA) PRIVATELIMITED',
    'REVATURE CONSULTANCY SERVICES PRIVATELIMITED',
    'OUTSOURCE IMAGES INDIA PRIVATE LIMITED',
    'SENTINI GEOSOL PRIVATE LIMITED',
    'ROBERTET GOLDFIELD (INDIA) PRIVATE LIMITED',
    'PROPEL DEVELOPERS PRIVATE LIMITED',
    'RABHAV TECHNOLOGIES LIMITED',
    'SIMPLICITY FIRST SOFTWARE PRIVATE LIMITED',
    'PFSWEB GLOBAL SERVICES PRIVATE LIMITED',
    'NEYO INDIA PRIVATE LIMITED',
    'SHIN-ETSU CHEMICAL TYLOSE INDIA PRIVATELIMITED',
    'NETSURION TECHNOLOGIES PVT LTD',
    'PROZIOD ANALYTICS (OPC) PRIVATE LIMITED',
    'PROTUNE KS AIYAR CONSULTANTS PRIVATE LIMITED',
    'NICOFI TECHNOLOGIES PRIVATE LIMITED',
    'SAHAVE INDIA PRIVATE LIMITED',
    'PRAGMATICPLAY INDIA PRIVATE LIMITED',
    'SMEDC SERVICES PRIVATE LIMITED',
    'SEMANTICS TRANS PVT LTD',
    'thinkthrough consulting pvt ltd',
    'SOFTBORNE TECHNOLOGY SOLUTIONS PRIVATELIMITED',
    'VOCERA COMMUNICATIONS INDIA PVT LTD',
    'THOUGHTWAVE INFO SYSTEMS INDIA PRIVATELIMITED',
    'VISIBLE ALPHA SOLUTIONS INDIA PRIVATELIMITED',
    'Vlocity Cloud Applications India Private Limited',
    'TRANWAY TECHNOLOGIES PRIVATE LIMITED',
    'VIRTUOSO OFFSHORE IT AND MANAGEMENT SERVICES INDIA PRIVATE LIMITED',
    'TEKION INDIA PVT LTD',
    'SURAKSHA ASSET RECONSTRUCTION PRIVATE LIMITED',
    'TAKSYKRAFT INFO TECHNOLOGIES PRIVATE LIMITED',
    'VANDEU INTERNATIONAL PVT LTD',
    'WURFEL KUCHE PRIVATE LIMITED',
    'TECH WIZARD IT SERVICES PRIVATE LIMITED',
    'TANGAR INFOTECH PRIVATE LIMITED',
    'WEBTECH MEDIA SYNERGY PRIVATE LIMITED',
    'Y POINT ANALYTICS (INDIA) PRIVATELIMITED',
    'UNITED AIRLINES BUSINESS SERVICESPRIVATE LIMITED',
    'VITALIC HEALTH PRIVATE LIMITED',
    'UNEECOPS WORKPLACE SOLUTIONS PRIVATELIMITED',
    'SUPREME LOGISTICS SOLUTIONS PRIVATE LIMITED',
    'TURNITINDIA EDUCATION PRIVATE LIMITED',
    'TRUETECH VISION INDUSTRY PRIVATE LIMITED',
    'VIKRANT STUDIO PRIVATE LIMITED',
    'VELNIK INDIA PRIVATE LIMITED',
    'TEAM WORK GLASS SOLUTIONS PRIVATELIMITED',
    'SSG Business Services Pvt Ltd',
    'TUSKER SECURITY PRIVATE LIMITED',
    'SRIV TESTING CONSULTANTS HUB PRIVATELIMITED',
    'SWITZER PROCESS INSTRUMENTS PRIVATELIMITED',
    'TECHNEXA SYSTEM PRIVATE LIMITED',
    'Chayagraphics (india) private limited',
    'Fisher & paykel healthcare india private limited',
    'Miki industries and companies private limited',
    'Abc resource traders private limited',
    'A i s enterprises limited',
    'Beeline broking limited',
    'Dwarkadas and sons pvt ltd',
    'Sushila agencies private limited',
    'Sanghvi exports pvt ltd',
    'Phulchand exports private ltd',
    'Kaveri impex pvt ltd',
    'Select marketing pvt ltd',
    'Shrinathji dye-chem export private limited',
    'Hariyana international private limited',
    'Mod comfina private limited',
    'Sahaji trading and investment private limited',
    'Devansh marketing private limited',
    'Shree kamnath realtors private limited',
    'Midas developers private limited',
    'Gujarat nippon international private limited',
    'Abn impex private limited',
    'Wama electroappliances (i) private limited',
    'SUJAN CONTITECH AVS PRIVATE LIMITED',
    'Audio-one private limited',
    'Sealink impex private limited',
    'Acme commodities private limited',
    'Jcee manufacturing and services private limited',
    'Maiden distributors limited',
    'SEASKY PRIVATE LIMITED',
    'N p p commercial private limited',
    'R b commodities private limited',
    'Abc tradex private limited',
    'Brand eyes distributors private limited',
    'Magix online services private limited',
    'Hi-tech elastomers limited',
    'TROIKAA PHARMACEUTICALS LIMITED',
    'Leo sign composite (sd) private limited',
    'Plenum impex private limited',
    'Maditbox services private limited',
    'Mialo technologies private limited',
    'STALLION ONEBYTE PRIVATE LIMITED',
    'Infocalix technologies private limited',
    'Pathfinder systems private limited',
    'Indo cosmo systems private limited',
    'Virtual training company india private limited',
    'Devicedriven (india) private limited',
    'Alignminds technologies private limited',
    'Celswa digitals private limited',
    'Spaniac corporate solutions private limited',
    'Mvs glob soft solutions private limited',
    'Apps team technologies private limited',
    'Tool softwares private limited',
    'Arita solutions private limited',
    'Hashint technologies private limited',
    'Hotbiz.com (india) private limited',
    'Trendsmith (india) limited',
    'Dhamm steel services private limited',
    'E-xpress interactive software private limited',
    'Soba infosec private limited',
    'Vernalis india private limited',
    'Movietalkies (india) private limited',
    'Gajshield infotech (india) private limited',
    'Arion system private limited',
    'Orosoft solutions private limited',
    'Sensys technologies private limited',
    'Excelize software private limited',
    'Vakils premedia private limited',
    'Supersoft consultants private limited',
    'Rajesh patkar institute of software engineering private limited',
    'Silverbyte software consultants (india) private limited',
    'Xcaliber infotech private limited',
    'Thoughti india private limited',
    'ZON INVESTMENT ADVISORS PRIVATE LIMITED',
    'At it (india) private limited',
    'Mikros advanced technologies private limited',
    'Techvertica technologies private limited',
    'Bloochip infoline private limited',
    'Nexus technoware solution private limited',
    'Konark telecom netwoks private limited',
    'Tata technologies limited',
    'Clover infotech private limited',
    'Prosys infotech private limited',
    'Excel informatics private limited',
    'Hsbc software development (india) private limited',
    'PATSEER TECHNOLOGIES PRIVATE LIMITED',
    'Gudel india private limited',
    'Emtech solutions private limited',
    'Ivision software private limited',
    'Quantum infotrainers and consultants private limited',
    'Allied softech private limited',
    'Bk work methods data technologies private limited',
    'STANTEC RESOURCENET (INDIA) PRIVATE LIMITED',
    'Analyzer cae solutions private limited',
    'Maxxton india technologies private limited',
    'I-blue solutions private limited',
    'Posit source technologies private limited',
    'Senix infotech private limited',
    'Inboxops systems private limited',
    'Impressive star softwares private limited',
    'ZNET TECHNOLOGIES PRIVATE LIMITED',
    'Vanshaj infotech private limited',
    'INTELLECT APX PRIVATE LIMITED',
    'YOUNGSOFT INDIA PRIVATE LIMITED',
    'Valuemomentum software services private limited',
    'Vedic systems private limited',
    'Jolt technologies private limited',
    'BLUEDROP ENVIRO PRIVATE LIMITED',
    'Trax e-services private limited',
    'Supreme netsoft private limited',
    'Srisys technologies private limited',
    'Eretail cybertech private limited',
    'Abacus staffing & services private limited',
    'Sreejayam it technologies private limited',
    'Core carbonx solutions private limited',
    'SAJJA',
    'INFOTECH PRIVATE LIMITED',
    'Narayana hospitals private limited',
    'Community empowerment research association',
    'Ashtavinayak nursing home private limited',
    'Sri sai balaji health care india private limited',
    'Hyderabad institute of oncology private limited',
    'Anshul health care private limited',
    'Lifetime wellness rx international limited',
    'Sughavazhvu healthcare',
    'Densure clinics private limited',
    'Patientclick healthcare solutions private limited',
    'Ibsc india wellness limited',
    'ALINEA HEALTHCARE PRIVATE LIMITED',
    'MEDVANTAGE INSURANCE TPA PRIVATE LIMITED',
    'Zen life sciences private limited',
    'Medisol lifescience private limited',
    'Prosport fitness and services private limited',
    'Saince healthtech private limited',
    'Heal wellness solutions (india) private limited',
    'CONCEPT BIOSCIENCES INDIA PRIVATE LIMITED',
    'Impact healthcare private limited',
    'Prime air ambulance private limited',
    'RITIKA MUCHHALA EDUCATION AND RESEARCH FOUNDATION',
    'Nesting hope foundation',
    'Sat kaival medical research foundation',
    'Telediagnosys services private limited',
    'Qmed services private limited',
    'Ayugen biosciences private limited',
    'Rvs educational & charitable foundation',
    'Ability unlimited global foundation',
    'Inner challenges private limited',
    'A2z waste management (varanasi) limited',
    'A2z waste management (moradabad) limited',
    'Otto waste systems (india) private limited',
    'LA MCLEAN INDIA LIMITED',
    'PITHAMPUR INDUSTRIAL WASTE MANAGEMENT PRIVATE LIMITED',
    'Saidpura envirotech private limited',
    'Bangalore incinerators private limited',
    'Delhi msw solutions limited',
    'RE SUSTAINABILITY SOLUTIONS PRIVATE LIMITED',
    'MARIDI BIO INDUSTRIES PRIVATE LIMITED',
    'Chennai msw private limited',
    'RE SUSTAINABILITY AND RECYCLING PRIVATE LIMITED',
    'Bangalore industrial waste management (karnataka) private limited',
    'DEHRADUN WASTE MANAGEMENT PRIVATE LIMITED',
    'THE ALL INDIA STARCH MANUFACTURERS',
    'S FITNESS (INDIA) PRIVATE LIMITED',
    'Nirvana creative telesoftware solutions private limited',
    'Media pro enterprise india private limited',
    'Wadhawan sports private limited',
    'Super car club of india private limited',
    'Rr motorsports management private limited',
    'Raheja mall management private limited',
    'Breakthrough entertainment private limited',
    'Aavishkar online lottery agency private limited',
    'Udaya fm private limited',
    'Mykind vacations private limited',
    'Varya vega info services private limited',
    'Meta career & education services private limited',
    'SWADES SOURCING SOLUTIONS PRIVATE LIMITED',
    'Wisdom professionals private limited',
    'SHREE SHIVAM SERVICES PRIVATE LIMITED',
    'Scoop brand holdings private limited',
    'Crimson concepts private limited',
    'Anmol swarn (india) private limited',
    'Nubicus consultancy services private limited',
    'Ergo consulting services (india) private limited',
    'Triangle ventures private limited',
    'Nyassa retail private limited',
    'Famous innovations digital creative private limited',
    'MIND ASSETS FOUNDATION',
    'Dolphin guardss & allied services private limited',
    'Gils private limited',
    'Mirth solutions private limited',
    'Enterprise security solutions private limited',
    'Pierian resource square corporate services private limited',
    'Basix consulting and technology services limited',
    'Prosper education private limited',
    'Noble king purchase solutions private limited',
    'Billion honour accounting services private limited',
    'Englishcoach services private limited',
    'RUDRANI GLOBAL AUTOSPRING PRIVATE LIMITED',
    'Calcutta angels network',
    'NOVA FERTILITY EAST PRIVATE LIMITED',
    'One-on-one links private limited',
    'Ace uplift foundation',
    'TERMINUS KG VENTURES PRIVATE LIMITED',
    'Nexify business solutions private limited',
    'Techyuga structural solutions private limited',
    'Shri nagai trading company private limited',
    'KAVERY MOBILITY AND MEDIA PRIVATE LIMITED',
    'Phoenix customer care private limited',
    'Alcove hospitality private limited',
    'Transpecific logistics private limited',
    'Pan oceanic maritime private limited',
    'Hindustan unilever foundation',
    'Ssg advisors (india) private limited',
    'Sealpac seals private limited',
    'Hitech concrete solutions chennai private limited',
    'Memco associates (i) private limited',
    'AAKASH EDUTECH PRIVATE LIMITED',
    'Swarnadhara holdings private limited',
    'Nivo controls private limited',
    'Centre for monitoring indian economy private limited',
    'Indo-saudi services (travel) pvt ltd',
    'Cfl securities limited',
    'M J INSTITUTE OF RESEARCH PRIVATE LIMITED',
    'Mafel home textiles pvt ltd',
    'Dembla valves ltd',
    'Ruchira consultants and capital services private limited',
    'Institute for technology and management',
    'Fuchs lubricants (india) private limited',
    'Vinar overseas private limited',
    'Goenka switchgears private limited',
    'Manidhari credit capital private limited',
    'Shivalik agro poly products ltd',
    'Rajvir industries limited',
    'Shekhawati poly-yarn limited',
    'Konark synthetic limited',
    'Sun tv network limited',
    'ASIAN ENERGY SERVICES LIMITED',
    'SINTERCOM INDIA LIMITED',
    'Kohnle heat treating systems private limited',
    'Bonito surfaces private limited',
    'TAYLORMADE RENEWABLES LIMITED',
    'Sigplex solutions private limited',
    'Ets lindgren engineering india private limited',
    'NYS CHEMTRADE PRIVATE LIMITED',
    'Metal link systems (madras) private limited',
    'Devsen software and exports private limited',
    'DB HEALTHCARE (WORLDWIDE) PRIVATE LIMITED',
    'Deltafull enterprises private limited',
    'Universal telecom india private limited',
    'Roop technology private limited',
    'ICON MICRO CIRCUITS & SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'PSL MANAGEMENT AND SOFTWARE TECHNOLOGY Private Limited',
    'Alpha engineering and trading company private limited',
    'Peacock home appliances private limited',
    'Viji power transformers private limited',
    'Abg motors limited',
    'I4 solutions private limited',
    'Spc electrotech private limited',
    'Sysco-tech systems (india) private limited',
    'Rational engineers limited',
    'Accurate industrial controls private limited',
    'Sai-lee electrotekniks private limited',
    'Sterling switchgears controls private limited',
    'Quasar industries private limited',
    'Sterling and wilson co-gen solutions private limited',
    'AI OPTICS PRIVATE LIMITED',
    'Prosem technology india private limited',
    'Wellman power private limited',
    'Vasuki switchgears private limited',
    'Kanekar consulting engineers private limited',
    'Ziehl-abegg india private limited',
    'Coopro safety india private limited',
    'Tri electric private limited',
    'Annai appliances manufacturing private limited',
    'Adande refrigeration private limited',
    'Secure centerics private limited',
    'ADVANCED SWITCHING CONVERTERS PRIVATE LIMITED',
    'Genesis electricals private limited',
    'Nr energy solutions india private limited',
    'Armour electronics pvt.ltd.',
    'Prima transformers private limited',
    'Powernet solutions private limited',
    'Weg industries (india) private limited',
    'J d v automotive engineering pvt ltd',
    'Penta electromec private limited',
    'Adtron technologies private limited',
    'Roos electrical works pvt ltd',
    'Ece technologies india limited',
    'Orca radio systems private limited',
    'Samudra electronic system private limited',
    'IEEC POWER ELECTRONICS PRIVATE LIMITED',
    'Elcotek india private limited',
    'Helicon trading house private limited',
    'Ultima switchgears limited',
    'Arraycom (india) limited',
    'Dexcel electronics designs private limited',
    'Specvin technologies private limited',
    'Melux control gears private limited',
    'Naman electronic systems private limited',
    'AXIS INTEGRATED SYSTEMS PRIVATE LIMITED',
    'Narain pro audio lighting private limited',
    'Uzmi laboratories india private limited',
    'Aria telecom solutions private limited',
    'INDO TELEPORTS LIMITED',
    'MARELLI UM ELECTRONIC SYSTEMS PRIVATE LIMITED',
    'R3 mobile phones private limited',
    'Net connect technology private limited',
    'Indisc technologies private limited',
    'ITW INDIA Private Limited',
    'Litaski electricals private limited',
    'Traab engg india private limited',
    'Vyome biosciences private limited',
    'Biomedicon services (india) private limited',
    'Freedom bio pharma private limited',
    'Freedom microsurgical instruments private limited',
    'GUJARAT AIRCONNECT PRIVATE LIMITED',
    'K.c.g. infotech private limited',
    'Cole-parmer india private limited',
    'Dynamic techno medicals private limited',
    'Indi lens manufacturing private limited',
    'Medox biotech india private limited',
    'MEDICAL & CONTROL INSTRUMENTS HOUSE (INDIA) PRIVATE LIMITED',
    'Caribou precision private limited',
    'Texanlab laboratories private limited',
    'Inel gas controls private limited',
    'Prisms india pvt.ltd.',
    'Audiorama private limited',
    'Drupe engineering private limited',
    'Kasi trishul motors private limited',
    'Owari precision products (india) private limited',
    'Orange automobiles private limited',
    'MARELLI (INDIA) PRIVATE LIMITED',
    'Paramount logistics private limited',
    'S.s.s.clearing & forwarding private limited',
    'CT.S ESTATES AND INFRA PRIVATE LIMITED',
    'Wavanna logistics private limited',
    'Ife global logistics (india) private limited',
    'Macoline shipping private limited',
    'DESKMATE GLOBAL EXPRESS INDIA PRIVATE LIMITED',
    'K and d communication limited',
    'Velocity express private limited',
    'Jmj logistics private limited',
    'Pranami broadcasting limited',
    'INTRADO EC INDIA PRIVATE LIMITED',
    'Nu tek cellulars private limited',
    'Huawei telecommunications (india) company private limited',
    'Ideaventures.com (india) private limited',
    'C s comsoft private limited',
    'Kings broadband private limited',
    'NIHA TECHNOLOGIES PRIVATE LIMITED',
    'Montel communications private limited',
    'Somfy india private limited',
    'Sahyadri finstock private limited',
    'RADICAL FINCAP PRIVATE LIMITED',
    'Artiman capital india private limited',
    'Centre for bhartiya masses development and micro enterprises',
    'Nd fintrans services private limited',
    'ASTORIA NIDHI LIMITED',
    'Bhuvana consultancy private limited',
    'Vamshadhara finance company ltd',
    'Padma sai finance private limited',
    'Sudarshan auto and general finance private limited',
    'Raviraj safe vaults and leasing private limited',
    'Lake end investment and finance pvt ltd',
    'Envy capital trust pvt ltd',
    'Vishal capital trust pvt ltd',
    'Lv finance private limited',
    'Yashasvi communications private limited',
    'Sowjenvee finance limited',
    'Federal capital markets limited',
    'Appu amusement parks private limited',
    'Veljan investments limited',
    'Seenaiah constructions private limited',
    'Academy of financial services pvt ltd',
    'San-neel industries limited',
    'Eyestar finance and leasing private limited',
    'Bmw india financial services private limited',
    'Haish holding and trading company private limited',
    'Nagarjuna credits and capitals limited',
    'Ahmednagar finance ltd',
    'Bharti (sbm) holdings private limited',
    'Bharti (rbm) holdings private limited',
    'Bharti (rm) holdings private limited',
    'Sihl fincap limited',
    'Manba finance limited',
    'SATTVA HOLDING AND TRADING PRIVATE LIMITED',
    'Rayirth holding and trading company private limited',
    'Quad management services private limited',
    'Complete fincon private limited',
    'Iris merchantile private limited',
    'M manifold private limited',
    'North west investments company private limited',
    'Oceanic investments limited',
    'Om-kailash finance and investments pvt ltd',
    'Applied tek and management consultancy private limited',
    'Meridian finance and consultancy co pvt ltd',
    'Arlington investment and trading company pvt ltd',
    'Ashmin minerals private limited',
    'Kuntinandan contractors and developers private limited',
    'Chimanlal purshottamdas investment and financial consultancy private limited',
    'Ecstasy realty private limited',
    'Mipl investments private limited',
    'Purvaja projects limited',
    'Chiranjilalji finance limited',
    'Systematix finvest private limited',
    'Opel holdings private limited',
    'VAIBBHAV ASHOK GOEL FOUNDATION',
    'Interactive financial & trading services private limited',
    'Krishnaiah projects private limited',
    'Uti venture funds management company private limited.',
    'MUTHOOT GOLD NIDHI LIMITED',
    'Margadarsi chits (karnataka) private limited',
    'Aeppyem chits and kuries private limited',
    'M j t chit funds private limited',
    'Rng finvest private limited',
    'Kissandhan agri financial services private limited',
    'Vishal profin pvt. ltd.',
    'Htc finance pvt ltd',
    'Asset reconstruction company (india) limited',
    'ARTHANOMICS ANALYTICS PRIVATE LIMITED',
    'G s vidyut financial services private limited',
    'Raheja qbe general insurance company limited',
    'Dorupo financial services private limited',
    'Pragnya advisors private limited',
    'SSPL WEALTH PRIVATE LIMITED',
    'CONSULTING MANAGEMENT INCORPORATE PRIVATE LIMITED',
    'BALAJI EQUITIES LIMITED',
    'Endeavour securities private limited',
    'Javis estate holding private limited.',
    'Vimal stocks private limited',
    'Danone (india) private limited',
    'Hundwara finance and investment co private limited',
    'Wood group kenny india private limited',
    'Kpmg global services private limited',
    'Odgers berndtson india private limited',
    'BLACK & WHITE ENGINEERING SERVICES PRIVATE LIMITED',
    'Spectrum safety solutions private limited',
    'Indoempower services private limited',
    'Akasandra consultants private limited',
    'Hurits consulting private limited',
    'KARTHIKA INVESTZONE CAPITAL PRIVATE LIMITED',
    'SERVITUS CORPORATE SERVICES PRIVATE LIMITED',
    'Maverik facility management private limited',
    'SGS SECRETARIAL SERVICES PRIVATE LIMITED',
    'Vandalay business solutions private limited',
    'Cirakas consulting private limited',
    'Fastflow consultants private limited',
    'Meridien business consultants private limited',
    'Tropical enterprises private limited',
    'ARIANA ADVISORS PRIVATE LIMITED',
    'Formula one promotions and entertainment private limited',
    'Integron project solutions private limited',
    'I2m management services private limited',
    'Pramex international consulting private limited',
    'INDIANIVESH FINANCIAL ADVISORS LIMITED',
    'Artelia (india) private limited',
    'Neterwala consulting and corporate services limited',
    'Whitecity advisors private limited',
    'Centre of excellence techno-consult private limited',
    'Moneytree advisors private limited',
    'PATHAK INDIA PRIVATE LIMITED',
    'Xs brands consultancy private limited',
    'Phenom services private limited',
    'Tcr - givi management services india private limited',
    'Realization technologies india private limited',
    'PDCOR LIMITED',
    'Chir-amrit corporate solutions private limited',
    'Inmate consultants pvt ltd',
    'Ascent leadership and management consultants private limited',
    'Inferdata software india private limited',
    'Datawise management services india private limited',
    'Citadel management consulting private limited',
    'Powerpay advisory services private limited',
    'Profluence business services private limited',
    'L&t infrastructure engineering limited',
    'K square india technologies private limited',
    'Drp consultants private limited',
    'Grandstand consultancy private limited',
    'Everonn educational resources solutions limited',
    'Vmacs consulting private limited',
    'Wilgro consultancy private limited',
    'Aws pollution and project construction pvt ltd',
    'Wise mens consultancy co pvt ltd',
    'Vinod kothari consultants pvt. ltd.',
    'Kpc strategic india management co. private limited',
    'Devanshi consultants private limited',
    'Srivari management services (p) ltd',
    'Design integrated services private limited',
    'Magic tree technologies private limited',
    'Strategic marketing solutions and research centre private limited',
    'Accurate power utility private limited',
    'Unilink engineering corporation private limited',
    'Kateel engineering industry private limited',
    'Zyeta interiors private limited',
    'Pebblestone advisors private limited',
    'Krayons interior systems private limited',
    'Dsr tech solutions india private limited',
    'Hi in concepts private limited',
    'Aeg skill update private limited',
    'Ocrim international technologies private limited',
    'Global synergies limited',
    'DURIT HARDMETAL (INDIA) PRIVATE LIMITED',
    'Tecpro infra-projects limited',
    'Tecpro engineers limited',
    'Rsms architects private limited',
    'Sap control systems and engineers private limited',
    'Shree laxmi electricals and consultants private limited',
    'P-mech consultant private limited',
    'PENTA INDIA TECHNICAL CONSULTANTS PRIVATE LIMITED',
    'Encompass design india private limited',
    'Stresstech engineers private limited',
    'Tao architecture private limited',
    'Ahuja engineering services pvt ltd',
    'Enertech engineering pvt ltd.',
    'Tricad design consultants pvt ltd',
    'Hanrag engineering private limited',
    'Smart business consultancy services private limited',
    'Design core form private limited',
    'Dayaram chemicals private limited',
    'Textile testing laboratories india private limited',
    'Prezens advertising private limited',
    'Aspiration advertising private limited',
    'Exito media concepts private limited',
    'Playads advertisement spaces private limited',
    'HAKUHODO.SYNC PRIVATE LIMITED',
    'Out-of-home media (india) private limited',
    'Kyoorius digital private limited',
    'Vision time india private limited',
    'Aapl infra private limited',
    'Fullarton distilleries private limited',
    'Creamy foods limited',
    'Surya fresh foods limited',
    'Fanar foods private limited',
    'Surya processed food private limited',
    'Meso private limited',
    'Shalimar global oils private limited',
    'Kanaga aromatics private limited',
    'Kshema beverages and foods private limited',
    'Surja bhivson milk private limited',
    'Hillsfood agro beverages private limited',
    'Sri vekkaliamman bewerages & food products private limited',
    'AWSUM PROTEINS LIMITED',
    'Krimani foods india private limited',
    'Rling foods private limited',
    'Hr food processing private limited',
    'B & m hotbreads private limited',
    'Lokmangal mauli industries limited',
    'C.czarnikow sugar (india) private limited',
    'Southern bakeries private limited',
    'Sally foods international private limited',
    'Putharjhora tea garden private limited',
    'Bos natural flavors private limited',
    'Elite foods pvt limited',
    'Tafe access limited',
    'Alliance breweries company private limited',
    'Hotwine winery private limited',
    'Snj breweries private limited',
    'Pratham catering services private limited',
    'Sp caring products india private limited',
    'Elora tobacco company limited',
    'East west textile private limited',
    'Rajkiran textiles private limited',
    'HAMI ENTERPRISES PRIVATE LIMITED',
    'Priyanka developers pvt ltd',
    'Strands textile mills private limited',
    'Wellknown textile industries private limited',
    'SAFE ENTERPRISES SHOPFITTINGS PRIVATE LIMITED',
    'Pvr spinning and weaving limited',
    'Arvind universal textiles private limited',
    'Sundharams p ltd',
    'Geethanjaly mills limited',
    'Royal yarns coimbatore private limited',
    'Singhal spintex private limited',
    'Rose marie knitwears private limited',
    'Rototon poly pack pvt ltd',
    'Jade blue lifestyle india limited',
    'Divine fibres private limited',
    'General texfab private limited',
    'Golden falcon trendz private limited',
    'Intertex pvt ltd',
    'Iss support services private limited',
    'Banbury exports private limited',
    'Elan fashions private limited',
    'SHIVAM TRADERS & ENTERPRISES PRIVATE LIMITED',
    'Dinaaz garments private limited',
    'Samosaran yarns private limited',
    'Paragon textile mills private limited',
    'RELIANCE CLOTHING INDIA LIMITED',
    'Dsgn fashions private limited',
    'Magnet fashion private limited',
    'Olympia dyehouse (india) private limited',
    'Ksr handlooms private limited',
    'Merex geogrid private limited',
    'Mas fabric park (india) private limited',
    'Lmf home textiles private limited',
    'KAMAL RAYON PRIVATE LIMITED',
    'Nature alley enterprises private limited',
    'Geetanjali industries private limited',
    'Shree narayan yarns industries private limited',
    'Unicolour textiles private limited',
    'GLOBAL WASTE RECYCLERS PRIVATE LIMITED',
    'Sivanthi joe substrates private limited',
    'Alliance technocrats private limited',
    'Colart camlin canvas private limited',
    'Sinecera textiles private limited',
    'GENEXX RESIDENCIES PRIVATE LIMITED',
    'Sri karuna varalakshmi polythreads private limited',
    'B.j.expo private limited',
    'Sri dhanalakshmi cotton and rice mills private limited',
    'Seven seas fashions private limited',
    'Manushree creations private limited',
    'Flair garments private limited',
    'Creative casual india private limited',
    'Mirage clothing company private limited',
    'Sushitex exports (india) limited',
    'R.k. creative designers private limited',
    'Zenisha creation private limited',
    'Creative lifestyles private limited',
    'Future garments (india) private limited',
    'Ricky garments private limited',
    'East west garments private limited',
    'Magnum casuals international private limited',
    'FAHEEM LEATHER & FASHION PRIVATE LIMITED',
    'Apt design private limited',
    'Warewell india corporation private limited',
    'Sopan design and creations private limited',
    'Shalibhadra creations private limited',
    'Sergio leathers private limited',
    'Emerald acres private limited',
    'Tawakkal infraprojects private limited',
    'Apollo buildwell private limited',
    'Krishna land infrastructure private limited',
    'Azure tree lands private limited',
    'Kalpataru constructions (poona) private limited',
    'Costal vincom pvt ltd',
    'Labyrinth cinematic solutions private limited',
    'Giacomini india private limited',
    'Mbm trade-link private limited',
    'Igc materials private limited',
    'Deepstambh infrastructure private limited',
    'Taksonz developers & infrastructor limited',
    'Viva eco homes private limited',
    'Mridul commodities pvt ltd',
    'Orbit ispat private limited',
    'Emery distributors private limited',
    'Bagmane traders pvt.ltd.',
    'Bharosa distributors pvt ltd',
    'Everblue barter pvt ltd',
    'Eastern bakeries private limited',
    'Wintech commercial pvt ltd',
    'Eximcorp india private limited',
    'UDYOGI AGRI SCIENCE PRIVATE LIMITED',
    'Sitara conductors & cables private limited',
    'Premco rail engineers limited',
    'Kota merchants & traders private limited',
    'DHRUV-TRANSPORTS INDIA PRIVATE LIMITED',
    'Zodiac dealers pvt ltd',
    'Golden sparrow realty private limited',
    'Shivangan properties pvt ltd',
    'Sagun commodities private limited',
    'Bhagyalaxmi vyapaar private limited',
    'Siddha properties private limited',
    'Classic tracom private limited',
    'Bright vyapaar private limited',
    'Orchid developers private limited',
    'MAHANSARIA ENTERPRISES PRIVATE LIMITED',
    'Suparna exports private limited',
    'Fox realtors private limited',
    'Amar cars private limited',
    'Sparsh baldev exports private limited',
    'Marudhara automobiles private limited',
    'Rahee infratech limited',
    'Rishivansh viniyog pvt ltd',
    'Nandini impex pvt. ltd.',
    'Sadafuli finstock private limited',
    'Garron shares and stock brokers private limited',
    'One-up financial consultants pvt ltd',
    'Earnest builders private limited',
    'Rockfort developers private limited',
    'Primrose infratech privte limited',
    'Eminence developers india private limited',
    'Omnipotent infrastructure private limited',
    'Irvin landcon private limited',
    'Equiknox ventures private limited',
    'ASHOKA METCAST LIMITED',
    'Red & yellow realty private limited',
    'Gyro realtors private limited',
    'Unity realtors private limited',
    'Divine properties and investments private limited',
    'Jai bhuvan builders private limited',
    'Dighi agencies pvt ltd',
    'Manikchand promoters and developers private limited',
    'Niknim estates private limited',
    'Haveli estates private limited',
    'Blue heaven estates private limited',
    'Regency property investments private limited',
    'Bhavishya homes private limited',
    'RAJGHARANA REALTY PRIVATE LIMITED',
    'Metro buildestate private limited',
    'CEEDEEYES INFRASTRUCTURE SOLUTIONS PRIVATE LIMITED',
    'PRAGNYA SOUTH CITY PROJECTS PRIVATE LIMITED',
    'Abode real estate developers private limited',
    'Fauna realtors private limited',
    'Porpoise realtors private limited',
    'Camel shelters private limited',
    'Daffodil shelters private limited',
    'Seastar realtors private limited',
    'Doon vally apartments private limited',
    'P.r. properties pvt. ltd.',
    'Vikas projects pvt ltd',
    'Dalmia real estates dealers pvt ltd',
    'Swagat infrarealty private limited',
    'Bengal peerless housing development company ltd',
    'Mekhala builders pvt ltd',
    'Nihar promoters pvt ltd',
    'Wave developers pvt ltd',
    'Srinit estates pvt ltd',
    'Banktesh properties private limited',
    'Jupiter enclave private limited',
    'Swastika mansion pvt ltd',
    'RMB DEVELOPER & PROJECTS PRIVATE LIMITED',
    'Pioneer niwas private limited',
    'Shankar projects private limited',
    'ETON PROJECTS PRIVATE LIMITED',
    'Avinash infra projects private limited',
    'Shri gajanan dream land private limited',
    'Tejaswani buildwell private limited',
    'Solutions unlimited buildtech private limited',
    'Sure advisory private limited',
    'Exalter buildtech private limited',
    '5G CELL TOWER PRIVATE LIMITED',
    'Riverfront properties pvt. ltd',
    'Eminence promoters india private limited',
    'Amitronics builders private limited',
    'H.grace property holdings limited.',
    'BIEVEN TECHNOLOGY PRIVATE LIMITED',
    'Opto infrastructure limited',
    'Fortunis ventures (india) private limited',
    'Manyata builders private limited',
    'Shiny realty private limited',
    'Balsam properties private limited',
    'Abhi developers private limited',
    'Bentley properties private limited',
    'Sathya realty private limited',
    'Riconia estates private limited',
    'Gdc buildcon private limited',
    'Kcd and triveni builders private limited',
    'Gdc habitat private limited',
    'Lake city golf course private limited',
    'Great view real estates private limited',
    'Sylvan acres realty private limited',
    'Futura promoters and developers private limited',
    'Guru nanak futuristic condominium private limited.',
    'Pgm real estates private limited',
    'Sri sradha realtors private limited',
    'Aries shelters private limited',
    'Cancer estates private limited',
    'DECCAN MUDRA AGRI PRIVATE LIMITED',
    'Gaateway prime spaces india private limited',
    'Bajaj realties private limited',
    'Spd constructions limited',
    'Ritu housing limited',
    'Mas infrastructure private limited',
    'Rmg developers private limited',
    'As infrabuild private limited',
    'Ahuja and anand buildwell private limited',
    'White diamond construction and equipments private limited',
    'Corporate land developers private limited',
    'Znr builders & developers private limited',
    'SRM INFRACITY (INDIA) PRIVATE LIMITED',
    'Xnine buildcon private limited',
    'Whiteinc space private limited',
    'Exalter infrahome private limited',
    'Mastermind real estate private limited',
    'Comsa pcms infra private limited',
    'Creative ext-int solutions private limited',
    'Dreamzwell technical services private limited',
    'Electro diagno systems private limited',
    'Seaes consortium private limited',
    'Septalyst lifesciences private limited',
    'Aim star network enterprise private limited',
    'Alm capital advisors private limited',
    'HANNON DIGITAL INDIA PRIVATE LIMITED',
    'TRACKPOINT GPS LIMITED',
    'Krish intratrade private limited',
    'Tazetta advisory services private limited',
    'Hcapital business consulting private limited',
    'MOBILE VOYAGE PRIVATE LIMITED',
    'Wonder grain exports private limited',
    'Vuclip (india) private limited',
    'ACUFIRE SYSTEMS (INDIA) PRIVATE LIMITED',
    'Sanghvi fitness private limited',
    'Btsl automotive india private limited',
    'Sanghvi beauty & salon private limited',
    'Confluxsys private limited',
    'Anugrah arts private limited',
    'Central dogma private limited',
    'Ramesh watch company private limited',
    'Ladder careers private limited',
    'KAPIL FOODS AND BEVERAGES PRIVATE LIMITED',
    'Spi ports private limited',
    'Criss cross logistics private limited',
    'Bells n rings event planners private limited',
    'Verto mobility management services private limited',
    'Sastha spy detective bureau investigation private limited',
    'Quad fitness private limited',
    'RADRAM QUALITY SERVICES PRIVATE LIMITED',
    'ASSURANT AUTOMOTIVE WARRANTY SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Isearch consulting services private limited',
    'Image creative education private limited',
    'Qoppa trading private limited',
    'ETRE VOUS INVESTMENTS PRIVATE LIMITED',
    'Vensimal leisure holidays private limited',
    'Fundscoop advisors private limited',
    'Global force management services private limited',
    'MEDIGUIDE INDIA SERVICES PRIVATE LIMITED',
    'SAFETY CERT PRIVATE LIMITED',
    'Spectro shyam labs private limited',
    'Dhruv corporate (hr) solutions private limited',
    'Classic search private limited',
    'Integrated allied services private limited',
    'Hi-tek investigation services private limited',
    '24sure security private limited',
    'Network detective agency private limited',
    'SINGH INTELLIGENT SECURITY PRIVATE LIMITED',
    'Sentinel integrated security solutions private limited',
    'S.ram manpower services private limited',
    'Kr facility & security management services private limited',
    'Innovative search consultancy services private limited',
    'Ninex warehousing private limited',
    'Gnt media private limited',
    'Ahmedabad packaging industries limited',
    'Vista packaging private limited',
    'Eagle peak intel private limited',
    'Rayavira (india) marketing private limited',
    'Mahajan processors private limited',
    'Muskaan hospitality and management private limited',
    'Arunachal pradesh infrastructural development corporation limited',
    'Dilysmadoc enterprises private limited',
    'Aiwa ventures india private limited',
    'Vishvaraj waste water management private limited',
    'Design culture consultants private limited',
    'JUSTINFO TICKETS PRIVATE LIMITED',
    'Song- e enterprises private limited',
    'Bliss management services private limited',
    'Gs rewards & loyalty solutions private limited',
    'P & n business ventures private limited',
    'Excellent hi-care private limited',
    'Royal school of fashion private limited',
    'Raghbir interiors pvt ltd',
    'Rustic crafts private limited',
    'ROHIN IMPEX PRIVATE LIMITED',
    'Orchid (interior decorators) pvt ltd',
    'Albatross student education private limited',
    'Luxmi associates private limited',
    'SHRI SUBHASH PARASRAM ELECTRONIC PARK PRIVATE LIMITED',
    'Radiant personalised services private limited.',
    'Pins to planes india private limited',
    'Linkedge software solutions private limited',
    'Eco water solutions technologies private limited',
    'Devshi earthmovers private limited',
    'PRECISELY SOFTWARE AND DATA INDIA PRIVATE LIMITED',
    'Dreamer web private limited',
    'Spectrum printing press private limited',
    'Multi max engineering works private limited',
    'Visual merchandise solutions private limited',
    'Adizes institute new delhi private limited',
    'Shanghai electric india private limited',
    'Lanzatech private limited',
    'Vision control products private limited',
    'Ivy facility services private limited',
    'EBRO TILDA PRIVATE LIMITED',
    'Hazoorilal jewellers rn private limited',
    'Intellio consulting private limited',
    'Vishad edutech private limited',
    'Suvira utility services private limited',
    'Irbaz leather private limited',
    'Ghanshyam forwarder private limited',
    'Asia timber products private limited',
    'Sleepzone mattresses private limited',
    'Endurance composites private limited',
    'Desai enterprises pvt ltd',
    'Mclube asia private limited',
    'Penetron india private limited',
    'Rettenmaier india private limited',
    'Petrochem epc infra private limited',
    'Univenture industries private limited',
    'Akira analytical solutions private limited',
    'ELECTROTHERM SERVICES LIMITED',
    'Echon industries limited',
    'Sapala organics private limited',
    'Angot chemicals pvt ltd',
    'Meck pharmaceuticals and chemicals private limited',
    'Colorant limited',
    'Satyam salt and chemicals private limited',
    'Orjet intermediates private limited',
    'Vasudha chemicals pvt ltd',
    'Jsmp garments private limited',
    'Vasant chemicals private ltd.',
    'SARNAV CHEMTECH PRIVATE LIMITED',
    'Sams southern chemicals private limited',
    'Ishika fertilizers limited',
    'Petro carbon and chemicals private limited',
    'CHEMSPEC CHEMICALS PRIVATE LIMITED',
    'Deepthy labs private limited',
    'Shahapur distileries pvt ltd',
    'Spechem cellulose private limited',
    'JAI TEX UNIT PRIVATE LIMITED',
    'TRIMCO GROUP (DELHI) PRIVATE LIMITED',
    'Abra cotton creations private limited',
    'Utssav garments private limited',
    'Savita fabrics private limited',
    'Highgrow floris chemicals private limited',
    'LAXAI LIFE SCIENCES PRIVATE LIMITED',
    'Excelex biopolymers private limited',
    'Sika india private limited',
    'Sai sulphonates pvt ltd',
    'Ankush marketing private limited',
    'Reliance ventures limited',
    'Gkr garments private limited',
    'Capitol nonwovens private limited',
    'Natesh impex private limited',
    'Vishakha petrochemicals private limited',
    'Simrone pharmaceutical industries limited',
    'Shubhada polymers products private limited',
    'Deesan cotex private limited',
    'ICHIBAN CROP SCIENCE LIMITED',
    'Eagle plant protect private limited',
    'MINSAN CHEMTEK INDIA PRIVATE LIMITED',
    'S.k.n marketing private limited',
    'Aansav surface solutions private limited',
    'Valspar (india) coatings corporation private limited',
    'SICER INDIA PRIVATE LIMITED',
    'Krishna conchem products private limited',
    'Todays architects private limited',
    'The statesman net private limited',
    'Max meditech private limited',
    'Vovantis laboratories private limited',
    'Celest pharma labs private limited',
    'Kaushal aromatic chemicals private limited',
    'Entod pharmaceuticals limited',
    'Gepach pharma private limited',
    'Creme-de-la-creme private limited',
    'Bakul pharma private limited',
    'Oxford laboratories private limited',
    'Oxford lifesciences private limited',
    'G.m. chemie private limited',
    'Genesis labs limited',
    'S.r. drugs and intermediates pvt.ltd.',
    'Rakshit drugs private limited',
    'Goa medicare devices private limited',
    'Ramon publications private limited',
    'Arham print-o-pack private limited',
    'Finebiotics pharma limited',
    'Orion biotech private limited',
    'Vibrant pharmachem private limited',
    'Vopec pharmaceuticals private limited',
    'Kaushal pharmaceuticals private limited',
    'Base metal chemicals pvt ltd',
    'MARUTI FERTOCHEM PRIVATE LIMITED',
    'Laser speciality chemicals private limited',
    'Total agri care concern private limited',
    'Ruby polyplast private limited',
    'Omori india private limited',
    'BODHI TREE MULTIMEDIA LIMITED',
    'Arpitha associates private limited',
    'SVR DRUGS PRIVATE LIMITED',
    'Sumangal press pvt ltd',
    'Rain cements limited',
    'Rescuers life sciences limited',
    'Fahrenheit chemoleums private limited',
    'Breeze intermediates private limited',
    'Vidya herbs private limited',
    'Pharma serv ventures private limited',
    'AXIA PLASTICS PRIVATE LIMITED',
    'KAMLA LIFESCIENCES LIMITED',
    'VALTRIS SPECIALTY CHEMICALS INDIA PRIVATE LIMITED',
    'Wallace pharmaceuticals private limited',
    'Global medisciences limited',
    'Triveni interchem private limited',
    'Oxide and chemical industries private limited',
    'Fauna shelters private limited',
    'Hilton shelters private limited',
    'Gulls shelters private limited',
    'Kabini shelters private limited',
    'Majestic shelters private limited',
    'Navigator shelters private limited',
    'Salim associates builders and developers private limited',
    'Bawa gourmet private limited',
    'Cr developments private limited',
    'Sumer housing private limited',
    'Sattadhar constructions private limited',
    'Shubhchintak properties private limited',
    'Konark water infraprojects private limited',
    'T m printers private limited',
    'Jval-tech engineers private limited',
    'Sun shrushti private limited',
    'Ashiana estates private limited',
    'Orbit developers private limited',
    'Shree padmavati engineers (india) private limited',
    'Krypton construction private limited',
    'Hira infracon private limited',
    'Magenta re asset private limited',
    'Real value ventures private limited',
    'Fortune estate developers private limited',
    'Chinaberry builders private limited',
    'Rajshree housing & land developers private limited',
    'Lotus estates private limited',
    'Pavan buildcon private limited',
    'Moonlight housing schemes private limited',
    'UTKRUSSHTA INFRACON PRIVATE LIMITED',
    'Nellai shelters private limited',
    'Niagara shelters private limited',
    'Nightingale shelters private limited',
    'Nile shelters private limited',
    'Notus shelters private limited',
    'Pallavan shelters private limited',
    'Florida constructions private limited',
    'Eclat designs & infrastructure private limited',
    'Rrs builders private limited',
    'Bhakti enterprises limited',
    'Rajul land infrastructure private limited',
    'TRINITY HOUSING AND CONSTRUCTION COMPANY',
    'Astral associates private limited',
    'SHOWMAN CONSTRUCTION & IMPEX LIMITED',
    'B r kohli build tech private limited',
    'Osian townships and resorts private limited',
    'Garrya developers private limited',
    'Heera projects and developers private limited',
    'Blueberry builders private limited',
    'Gallberry developers private limited',
    'Genistra realtors private limited',
    'Madrono developers private limited',
    'Intouch construction and infrastructure private limited',
    'Riverview shelters private limited',
    'Skyview shelters private limited',
    'Pearlcity shelters private limited',
    'Thamarai shelters private limited',
    'Robinson shelters private limited',
    'Tristar shelters private limited',
    'G.j.f. construction co. private limited',
    'I-city infrastructure (india) private limited',
    'NORTHROOF VENTURES PRIVATE LIMITED',
    'MARATHALLI VENTURES PRIVATE LIMITED',
    'Prestige projects private limited',
    'Trisea shelters private limited',
    'Binary apparel park private limited',
    'Alfa technologies private limited',
    'Ihita engineering services private limited',
    'Propin india developers private limited',
    'Mtc infra private limited',
    'Sd realty private limited',
    'Freesia builders private limited',
    'Cornflower promoters private limited',
    'Tritoma promoters private limited',
    'Cottonwood realtors private limited',
    'Dollarbird realtors private limited',
    'Halimium promoters private limited',
    'Redtopaz real estate private limited',
    'Chowgule maintenance services private limited',
    'Sami realty & infrastructure private limited',
    'Bhargavi buildtech private limited',
    'Bansal propbuild private limited',
    'Noble buildestate private limited',
    'Varaha infra limited',
    'Sez developers association of india',
    'Varuni infrastructure private limited',
    'Vanya developers private limited',
    'Ramkuti real estates private limited',
    'The go green build tech private limited',
    'Girraj marut real estate private limited',
    'GANDHI REALTY (INDIA) PRIVATE LIMITED',
    'Pandupole developers private limited',
    'Bansal square private limited',
    'Bansal landmark private limited',
    'Adinath infrastructure private limited',
    'Bips infrastructure private limited',
    'Suparva construction private limited',
    'Shivangi realties private limited',
    'Flamingo builders private limited',
    'Amrut home stead private limited',
    'Alankrit estates limited',
    'Toben logistics solutions private limited',
    'Sennaar logistics private limited',
    'Sumangla investments private limited',
    'Agarwal fiscal pvt ltd',
    'Palani samy investment private limited',
    'Winman software private limited',
    'Rajah coffee private limited',
    'NITSTONE FINSERV PRIVATE LIMITED',
    'Reliance industrial investments and holdings limited',
    'Suraj sanghi finance limited',
    'Eldorado investments company pvt ltd',
    'Sharone development and leasing private limited',
    'Dua motors finance private limited',
    'Abhishek finlease private limited',
    'Atl textile processors limited',
    'Sundhya chhaya finvest private limited',
    'Hdfc sales private limited',
    'J.W. INFRACON PRIVATE LIMITED',
    'Badri auto services private limited',
    'Sumer leasing and finance private limited',
    'Jiwan metafins limited',
    'Dehu trading company private limited',
    'Adenine real estates private limited',
    'LOOKAD FINANCE & LEASING PRIVATE LIMITED',
    'Rainbow ventures private limited',
    'Intellect financial services private limited',
    'V g p housing private limited',
    'Sree rajamahendri chitfunds private limited',
    '4m finance limited',
    'Jade investments private limited',
    'Western arya finlease private limited',
    'Frenzy finance private limited',
    'Jayine financial advisory services private limited',
    'Al-hamd enterprises chit fund private limited',
    'Nangalia traders private limited',
    'Prabodh artha-sanchay private limited',
    'Saral finmart corporation private limited',
    'Intelligent money managers private limited',
    'Chanakya technologies (india) private limited',
    'Sadbhav finstock private limited',
    'Sonpriya investment private limited',
    'Tcrc investments private limited',
    'Olympic leasing pvt ltd',
    'Fabulous holdings pvt ltd',
    'Seagold enterprises private limited',
    'Jamwadi investment and trading private limited',
    'Rajur ganapati investment and trading private limited',
    'Dudhna investment and trading private limited',
    'Govind vallabh financial services private limited',
    'Cardigen investment and trading private limited',
    'DYNAMIX SECURITIES & HOLDINGS PRIVATE LIMITED',
    'AFFLE (INDIA) LIMITED',
    'Maheshwari equity brokers private limited',
    'Bang securities private limited',
    'Ashlesha finvest private limited',
    'Unity portfolio private limited',
    'Gangabishan bhikulal investment and trading limited',
    'Prabhata vaartha private limited',
    'SWASRAYA NIDHI LIMITED',
    'SAVOIR TRUSTEE LIMITED',
    'PROTEVISTA BUSINESS ADVISORS LIMITED',
    'Metexim (sourcing) private limited',
    'Arkay holdings limited',
    'WC SECURITIES PRIVATE LIMITED',
    'Valdel investments private limited',
    '315 WORK AVENUE SPACES PRIVATE LIMITED',
    'DESAI HOMES PROPERTIES PRIVATE LIMITED',
    'Shri tulja bhavani investment pvt ltd',
    'Palani andavar holdings pvt ltd',
    'Surendra investigation services (bombay) private limited',
    'Patodia co pvt ltd',
    'VWPL RETAIL AND MERCHANDISE LIMITED',
    'Maruti finance pvt ltd',
    'Bijay finance and investment pvt.ltd.',
    'Jubilee commercial and trading private limited',
    'Vns risk management services private limited',
    'Frankfinn holdings private limited',
    'Namra finance limited',
    'Ibc holdings and investments private limited',
    'Pruthvi brokers and share holdings private limited',
    'Attractive investment & developers pvt.ltd.',
    'Adishakti industries private limited',
    'Sunrise investments pvt.ltd.',
    'Cd finvest private limited',
    'Fund tree insurance brokers private limited',
    'Globeop financial services (india) private limited',
    'Ksk investment advisor private limited',
    'Aastha fincorp advisor private limited',
    'Aroha capital private limited',
    'Smart economics consultancy private limited',
    'Shri parasram holdings private limited',
    'Micro venture holdings private limited',
    'GTM INVESTMENT & ASSOCIATES PRIVATE LIMITED',
    'Amar alliance securities private limited',
    'Sg investments private limited',
    'Sanguine holdings private limited(transfer from maha to guj)',
    'Vidhi financial consultancy services private limited',
    'Sic stocks and services private limited',
    'Ginza finance private limited',
    'Nitapo holdings private limited',
    'Unicom finance private limited',
    'Harbhajan investment and trading private limited',
    'Core mind technologies private limited',
    'Wow assets holding private limited',
    'Mec consulting private limited',
    'Constroworld private limited',
    'Cybermine integrated services private limited',
    'Avhan technologies private limited',
    'Ids e solutions private limited',
    'Prospero software solutions private limited',
    'Blue ocean technologies private limited',
    'Gem3s technologies private limited',
    'Rsn infotech private limited',
    'Mediavak india private limited',
    'Travelport holidays (india) private limited',
    'Transtec overseas private limited',
    'Health prime services (india) private limited',
    'Busisol sourcing (india) private limited',
    'Ryussi technologies private limited',
    'Sikraft infotech (india) private limited',
    'Qrio technologies private limited',
    'Skisen labs private limited',
    'Energos technologies private limited',
    'Sigma toolings research and developers centre private limited',
    'Giant leap systems private limited',
    'Techno heaven consultancy private limited',
    'COPA-DATA INDIA PRIVATE LIMITED',
    'Prime channel software communications private limited',
    'YASHO INDUSTRIES LIMITED',
    'Maven media private limited',
    'Awari technologies private limited',
    'Mountain apollo capital advisors private limited',
    'Insight certifications private limited',
    'Mbh design studio private limited',
    'Antic insurance brokers & risk management services private limited',
    'Esecurity audit private limited',
    'Sartha advisors private limited',
    'Aisumi india private limited',
    'LANTANA PROPERTIES PRIVATE LIMITED',
    'Neha system services private limited',
    'Orchidseven infosec private limited',
    'Cirrius technologies private limited',
    'Automation engineering solutions private limited',
    'Juliet infotech private limited',
    'Techxellance solutions private limited',
    'Basil resources private limited',
    'FIVE SHIPS REALTY PRIVATE LIMITED',
    'Trimiti technologies private limited',
    'Histogenetics (india) private limited',
    'E-merge tech global services private limited',
    'Theseus global research private limited',
    'Alliance corporate advisors private limited',
    'Kilobyte technologies private limited',
    'Nrs investment consultants private limited',
    'St aanalyticsiq consulting services private limited',
    'Kurtosys systems india private limited',
    'Saint honore consulting private limited',
    'Atlas entertainment private limited',
    'Concepts & solutions event services private limited',
    'Consign it private limited',
    'Inswit software private limited',
    'Cloud kinetics technology solutions private limited',
    'Bunrick fashions private limited',
    'Suyog projects private limited',
    'Edlar business services private limited',
    'Rjbs consultants private limited',
    'Jun academy private limited',
    'Multicoreware india private limited',
    'Symmetrical global search private limited',
    'MINDFORCE RESEARCH PRIVATE LIMITED',
    'Qadir infotech private limited',
    'Comnet resources pvt ltd',
    'Objectsol technologies private limited',
    'Dr. ramesh cardiac and multispeciality hospital private limited',
    'Apt biotech private limited',
    'Bhat metal research private limited',
    'Pnb vesper life science private limited',
    'Raptor research and conservation foundation',
    'Wearcheck laboratories india private limited',
    'International research institute for manufacturing private limited',
    'Euphoria consulting private limited',
    'Jnd mantech services private limited',
    'Tacit india management services private limited',
    'M&R ADVISORY SERVICES PRIVATE LIMITED',
    'Batar it solutions private limited',
    'White sky labs software solutions private limited',
    'Bodhaguru learning private limited',
    'Evolve bizcon services private limited',
    'Fsl consultants private limited',
    'PACE RESOURCES PRIVATE LIMITED',
    'Invicta design technologies private limited',
    'Our comp solutions private limited',
    'Finalytics financial advisors private limited',
    'Econ one research india private limited',
    'Urtechmate india private limited',
    'Palaash ventures private limited',
    'Manipal global education services private limited',
    'Celtycs management services private limited',
    'Han digital solution private limited',
    'Purys enterprises private limited',
    'Family first advisory private limited',
    'Millennium propinvest private limited',
    'Performmatrix solutions (india) private limited',
    'Mendons consultancy services private limited',
    'Xinoe systems private limited',
    'Saj autotech pvt ltd',
    'Kifs financial services limited',
    'Alphageo (india) limited',
    'Vishranti trading enterprises limited',
    'Pearl global industries limited',
    'V2 retail limited',
    'Subex limited',
    'Advani hotels and resorts (india) limited',
    'Jet airways (india) limited',
    'Gsb finance limited',
    'GIANT SECURITIES PRIVATE LIMITED',
    'Eagle hunter solutions limited',
    'Prima multitrade and exim private limited',
    'Hydrolines (bangalore) private limited',
    'MAPLE PC & PERIPHERALS PRIVATE LIMITED',
    'Shitvan farms private limited',
    'Aroma agrotech private limited',
    'Deccan plantations private limited',
    'Kumar fields limited',
    'Trimode properties private limited',
    'Satvikk speciality foods private limited',
    'Neori agro private limited',
    'Orissa biodiesel jatropha private limited',
    'GAJJAN MAJRA FEED LIMITED',
    'Invision projects private limited',
    'Pancom marketing private limited',
    'Petrel farms private limited',
    'Sn agro farms and products india private limited',
    'Lords polymer (india) private limited',
    'Sujali tea & industries limited',
    'National institute of dairy farming',
    'Sentini bioproducts private limited',
    'Legacy global agri products private limited',
    'Sourcewell agro foods private limited',
    'Tams global private limited',
    'Superior dairy farms private limited',
    'NEXT MILLION FOUNDATION',
    'Acropolis agro private limited',
    'Indigrozit agricultural services private limited',
    'Ikp centre for advancement in agricultural practice',
    'Jasmine agroforestry private limited',
    'Sanjay vegoil products private limited',
    'Harish coconut products private limited',
    'Cc food network private limited',
    'Jolly wood industries private limited',
    'Icon petroleum corporation limited',
    'KENZOE PRIVATE LIMITED',
    'Restolex rubber products private limited',
    'Jsw realty & infrastructure private limited',
    'Bnazrum agro exports private limited',
    'Meerams overseas private limited',
    'Knnd associates private limited',
    'Teknoturf info services private limited',
    'Divyasree real estate developers private limited',
    'CUSHMAN & WAKEFIELD PROPERTY ADVISERS PRIVATE LIMITED',
    'Hitze equipments (india) private limited',
    'M v agro engineers private limited',
    'Swathi aqua culture private limited',
    'Brahm mines and minerals private limited',
    'Marudhar stones international private limited',
    'Delta aggregates and sand private limited',
    'First milk private limited',
    'Sri ramji spices and oils private limited',
    'Natural harvest india private limited',
    'Kalpataru grani marma pvt ltd.',
    'Navayuga exports ltd',
    'Jatin stones private limited',
    'NTC INFRASTRUCTURE AND ENGINEERING PRIVATE LIMITED',
    'Ashapura perfoclay limited',
    'Syndak tea tech ltd',
    'Mangal tea marketing ltd',
    'Neer horticulture solutions private limited',
    'The blue mining company private limited',
    'Rising rock private limited',
    'Cosmo granites private limited',
    'Indo roses and floriculture limited',
    'Pickwick hygienic products private limited',
    'Mysore fruit products private limited',
    'Poona pulses private limited',
    'Arkaaye builders & developers private limited',
    'Ash ganges farms private limited',
    'Kridhan petrochemicals private limited',
    'Sanyasihat tea processing private limited',
    'Anoushka gourmet private limited',
    'Solitaire Energies Limited',
    'Huntervalley coal private limited',
    'Quantum coal energy private limited',
    'Scanet trading private limited',
    'Regent biochem india private limited',
    'Ikon labels private limited',
    'Johars private limited',
    'RONIL OIL & FOODS PRIVATE LIMITED',
    'Adani wilmar limited',
    'Devi fisheries limited',
    'SIWACH GREEN ENERGY PRIVATE LIMITED',
    'Karnal milk foods ltd.',
    'Novartis healthcare private limited',
    'Zirkon riceland and foods products private limited',
    'AL-GYAS INFRASTRUCTURE PRIVATE LIMITED',
    'SRI VENKATESWARA SHRIMP HATCHERIES PRIVATE LIMITED',
    'Chisel architects private limited',
    'Udhay-vj realty private limited',
    'Vandan hydrocarbon private limited',
    'Rpk estates (india) private limited',
    'ELECTRONIC RELAY (INDIA) PRIVATE LIMITED',
    'Digital electronics limited',
    'Lantec controls private limited',
    'Sarto electro equipments private limited',
    'Puthur infotech private limited',
    'Sutra computers private limited',
    'Sas computers private limited',
    'Universal space infonet ltd',
    'V-tech integrahomes private limited',
    'India cable connect private limited',
    'Dasmesh airconditioning engineers private limited',
    'Nair business machines private limited',
    'SHARADA PICTURES & INFRASTRUCTURE PRIVATE LIMITED',
    'Delta energy systems (india) private limited',
    'Jakap metind pvt ltd',
    'Ankita electronics private limited',
    'Universal power transformer private limited',
    'CDDEP INDIA PRIVATE LIMITED',
    'Progressive meters private limited',
    'Ykm holdings pvt ltd',
    'EUROFINS AMAR IMMUNODIAGNOSTICS PRIVATE LIMITED',
    'Arya electronics and controls private limited',
    'Noble energy solar technologies limited',
    'Penguin solar private limited',
    'Osl electronics private limited',
    'Omcam power systems private limited',
    'PEPPERL & FUCHS MANUFACTURING (INDIA) PRIVATE LIMITED',
    'I - sense technologies private limited',
    'Vka powermaster private limited',
    'Sharppoint motors and automobiles private limited',
    'Vardenchi motorcycles private limited',
    'J m wheels private limited',
    'A.p. automotives pvt. ltd.',
    'AES INDUSTRIAL PRIVATE LIMITED',
    'Abc apptech private limited',
    'Radhakamal engineers private limited',
    'YANTRANSH GLOBAL PRIVATE LIMITED',
    'Mitsui kinzoku components india private limited',
    'Veer visions pvt ltd',
    'KAILASH VAHN PRIVATE LIMITED',
    'Transprecision gears private limited',
    'Yachiyo india manufacturing private limited',
    'Sanchar engineers private limited',
    'Select bhunirmaan private limited',
    'Novasys labs private limited',
    'Innovative systems and solutions private limited',
    'De diamond electric india private limited',
    'Pace electronics private limited',
    'Axis solutions private limited',
    'Zeal medical private limited',
    'Phoenix cardiac devices private limited',
    'Global life care private limited',
    'Radhe instrumentation private limited',
    'Shah eye care private limited',
    'G.s.t.corporation limited',
    'Fine medicare private limited',
    'Zplus woodplast private limited',
    'Mahavas precision controls private limited',
    'Aster comfort designs private limited',
    'Suashish diamonds limited',
    'Scientific apparatus mfg co pvt ltd',
    'Keroy balances pvt ltd',
    'Wega diamond private limited',
    'Diacolor india private limited',
    'Tuf metallurgical private limited',
    'Diamond india limited',
    'Gunjan jewels private limited',
    'Nakshatra jewellers private limited',
    'A himanshu jewelery private limited',
    'Karan jewels private limited',
    'Procell absorbents private limited',
    'Exedy india limited',
    'Kanav motors private limited',
    'Nike india private limited',
    'Allied publishers private limited',
    'Pritam international private limited',
    'Exal pen private limited',
    'Cpm systems private limited',
    'B. ramarao & sons jewellers private limited',
    'Utility imagitech private limited',
    'Vande mataram waste management private limited',
    'Go auto private limited',
    'Maharashtra eastern grid power transmission company limited',
    'Sodhi brothers hydro power private limited',
    'Almi hydro-electric projects limited',
    'Innovative motors private limited',
    'Suchi fasteners private limited',
    'Jbx logistic solutions private limited',
    'Millap cycles private limited',
    'MUKHERJEE & ALLIANCES (INDIA) PVT LTD',
    'Decode aerospace solutions private limited',
    'Karla engine components limited',
    'Agv fenestration private limited',
    'Acd juel private limited',
    'Green electron power private limited',
    'Tara energy limited',
    'Island energy projects limited',
    'Prabhat maritime services private limited',
    'Sunmark energy systems limited',
    'PRECIOUS ENERGY SERVICES Limited',
    'Mimesis power projects private limited',
    'Zinc hospitality india private limited',
    'ICONIC PROPERTY DEVELOPERS PRIVATE LIMITED',
    'Bageecha hotels pvt ltd',
    'Blue ocean hospitality private limited',
    'Inn-venue hospitality management private limited',
    'Fortune park hotels limited',
    'Vd restaurants private limited',
    'Junobo hotels private limited',
    'Kamats restaurants (india) private limited',
    'Goregaon hotel and realty private limited',
    'Park view hospitality and hotel private limited',
    'Pepco resorts private limited',
    'LTG MYSORE GREENS EXPORTS PRIVATE LIMITED',
    'Adhunik transport organisation limited',
    'White feather logistics private limited',
    'Condor properties private limited',
    'Devaragam resorts private limited',
    'Corporate solutions redefined india private limited',
    'REVATI COMMERCIAL LIMITED',
    'New age restaurants private limited',
    'Ghosh brothers hotels private limited',
    'Agarwal relocators private limited',
    'Ennore logistics park private limited',
    'Geekeyes logistics private limited',
    'Darshana logistics solutions private limited',
    'Dillan shipping private limited',
    'Adani murmugao port terminal private limited',
    'Nautilus shipping (india) private limited',
    'Ilsa shipping & logistics private limited',
    'West coast marine yacht services private limited',
    'Adani international container terminal private limited',
    'Adani cma mundra terminal private limited',
    'Eknath resorts & township projects private limited',
    'S.i. property (karnataka) private limited',
    'Mundra international airport private limited',
    'Barefoot resorts and leisure india private limited',
    'Larica resorts pvt ltd',
    'Punya lakshmi hotel private limited',
    'Virtual voyageworld private limited',
    'WINWIN MARITIME LIMITED',
    'SANGKAJ AUTO PARTS PRIVATE LIMITED',
    'Svs shipping logistics private limited',
    'Mangalam vincom private limited',
    'UNICORN FUR TRADE PRIVATE LIMITED',
    'Blink hotels pvt ltd',
    'Mood foods (india) private limited',
    'Hotel annamalai international private limited',
    'Hotel n.s.r. private limited',
    'Girnar hotels pvt ltd',
    'Fuego foods private limited',
    'Modena waftage freight carriers private limited',
    'Sams trans logistic private limited',
    'Embassy logistics delhi private limited',
    'Spice logistics private limited',
    'Lord krishna container leasing private limited',
    'Meridian cargo lines private limited',
    'Ar shipping agency private limited',
    'Cmandhar logistics private limited',
    'Navbharat shipping (india) limited',
    'Blueline logistics private limited',
    'MARUDHARA SPORTS AND RECREATION PRIVATE LIMITED',
    'Essence of india tours private limited',
    'Vics industries private limited',
    'Kolaghat cold storage pvt ltd',
    'Drs resorts private limited',
    'Sarvottam logistics and warehousing (india) private limited',
    'Trishul mountain hotels private limited',
    'Penguin logistics india private limited',
    'Indian nature travel private limited',
    'Gsec aviation limited.',
    'Onboard logistics private limited',
    'Active internationals travel network private limited',
    'I.n.d.i. tour services private limited',
    'MONDEE TECH PRIVATE LIMITED',
    'Bhargava logistics private limited',
    'Pacific cars private limited',
    'St. joseph shipping agencies private limited',
    'SHA',
    'S-FOOTBALL CHAMPIONSHIP PRIVATE LIMITED',
    'Lokmat media private limited',
    'HY-TECH ENGINEERS LIMITED',
    'S4 franchisees private limited',
    'Veera teleservices private limited',
    'Advitiya fabrics private limited',
    'Dhhara corporate consulting private limited',
    'Mhatre engineering private limited.',
    'Offshore welders and fabricators private limited',
    'Agani apparels limited',
    'Coltivare consultancy services private limited',
    'Egb advanced security systems private limited',
    'SSA CREDLAB PRIVATE LIMITED',
    'Ashden india renewable energy collective',
    'SIDDH FITNESS PRIVATE LIMITED',
    'Headrush ventures private limited',
    'WARDWIZARD FOODS AND BEVERAGES LIMITED',
    'Manabarrie tea co limited',
    'Barak valley cements limited',
    'Ratna sila granites limited',
    'Freshtrop fruits limited',
    'Eastern sugar & industries limited',
    'Sudha apparels ltd',
    'Jindal hotels limited',
    'ARROW GREENTECH LIMITED',
    'Kalptaru papers limited',
    'Hindustan petroleum corporation limited',
    'Chembond chemicals limited',
    'Kriptol industries limited',
    'Kopran limited',
    'Source natural foods and herbal supplements limited',
    'Pondy oxides and chemicals limited',
    'Sanjivani paranteral limited',
    'Techtran polylenses ltd',
    'Anjani portland cement limited',
    'Pennar industries limited',
    'KUMAR',
    'S PRINT SOLUTIONS PRIVATE LIMITED',
    'Infinity print pack private limited',
    'Sab global entertainment media private limited',
    'Sudarshan srilakshminarasimha printers private limited',
    'SB LASER & COMPUGRAPHICS PRIVATE LIMITED',
    'PRAGATI GRAPHICS AND PACKAGING PRIVATE LIMITED',
    'Sia publishers & distributors private limited',
    'Stag print private limited',
    'Miles publications private limited',
    'Peacock imaging private limited',
    '3i publishing private limited',
    'Quebec petroleum resources limited',
    'Sahay additives private limited',
    'Venus petrochemicals (bombay) private limited',
    'Andhra fuels private limited',
    'Kluber lubrication india private limited',
    'Taurus petroleums private limited',
    'Ds toll road limited',
    'Hi-rel tech private limited',
    'SREE RAM ENTERPRISES PVT LTD',
    'Mahavir colchem private limited',
    'Acorrphen coating private limited',
    'Viva energy fertilizers private limited',
    'INDUSTRIAL MINERALS AND CHEMICAL COMPANY PRIVATE LIMITED',
    'Hipari chemicals private limited',
    'Retort chemicals private limited',
    'Mahavir minerals limited',
    'Anchrom analytical private limited',
    'Vinay sil-cos private limited',
    'Oceanic pharmachem private limited',
    'Nandkrishna chemicals private limited',
    'Recochem (india) private limited',
    'Soujanya color private limited',
    'Anupam ingredients private limited',
    'MADHUKAR HORMONES & STEROIDS PRIVATE LIMITED',
    'Delta biopharma private limited',
    'Uni eco india private limited',
    'Divya phyto extracts private limited',
    'Chamak polymers private limited',
    'Galaxy colchem private limited',
    'Shandilya chemicals private limited',
    'Silvo liacal chemicals pvt ltd',
    'Devdip dyechem industries private limited',
    'Rolex lanolin products limited',
    'Mehta extractions pvt ltd',
    'Imaginationworks production company private limited',
    'MVS ENTERPRISES PRIVATE LIMITED,',
    'O. b. fluoro chems private limited',
    'KANEX FIRE SOLUTIONS PRIVATE LIMITED',
    'Sentini infras private limited',
    'Abhiraami chemicals limited',
    'Gupta chemicals pvt ltd',
    'RAMCIDES CROPSCIENCE PRIVATE LIMITED',
    'Vinisan dyechem pvt ltd',
    'Beau monde infra projects private limited',
    'Marina india infrastructure private limited',
    'Chekam properties private limited',
    'Trunil properties private limited',
    'Barkat properties private limited',
    'Ornate spaces private limited',
    'Akshar realty assets private limited',
    'Cvnd realty private limited',
    'Taamra engineering consultants india private limited',
    'Rohan towers private limited',
    'Mangalmurti shelters private limited',
    'Akanksha townscape private limited',
    'INDOSPACE PARK CHAKAN 1 PHASE 2B PRIVATE LIMITED',
    'Rohan landscape private limited',
    'Meena estates private limited',
    'Ranjeet property developers india private limited',
    'Mittal mega projects private limited',
    'Space mekk designers private limited',
    'Bull rock drills private limited',
    'Vishwa infrastructures and services private limited',
    'GREENMARK DEVELOPERS PRIVATE LIMITED',
    'Scorpio shelters private limited',
    'Bianca properties private limited',
    'Tvr constructions private limited',
    'Aparna mansions private limited',
    'Nile developers private limited',
    'Vaigai developers private limited',
    'Temple city realtors private limited',
    'Nourindia engineers private limited',
    'Bhoomi and buildings private limited',
    'Azvi construction private limited',
    'Society of green makers private limited',
    'Avigna properties private limited',
    '3 force guarding private limited',
    'WINMEEN ENGINEERS PRIVATE LIMITED',
    'Ssbm realty and hospitality private limited',
    'Vanashree properties private limited',
    'J g realcon private limited',
    'ASIAN MEDICAL AND RESEARCH PRIVATE LIMITED',
    'Lemons infrastructure corporation limited',
    'Super property maintenance private limited',
    'Eldeco townships and housing limited',
    'Omway buildestate private limited',
    'Galaxy buildtech private limited',
    'Savana builders company limited',
    'Shri ajitnath buildcon limited',
    'DIVINE F AND B SERVICES PRIVATE LIMITED',
    'Vatika one india next private limited',
    'Khatushyam buildcon private limited',
    'Mera baba real estate private limited',
    'Pigeon infrastructure limited',
    'ELDECO GREEN PARK INFRASTRUCTURE LIMITED',
    'Empire buildcon private limited',
    'Vijay m. mistry construction private limited',
    'SHILPKRUTI ORGANISING CO PVT LTD',
    'Motihira land deveopers pvt ltd',
    'Ayojan property developers private limited',
    'K b mehta construction private limited',
    'Bapashree infrastructure private limited',
    'S g organisers private limited',
    'Synthesis spacelinks private limited',
    'Nuway infrastructure private limited',
    'Shefali organisers private limited',
    'Maharashtra border check post network limited',
    'Tiong woon project and contracting (india) private limited',
    'Raajratna nirman private limited',
    'Solar sewage basic infrastructure private limited',
    'Ujagar estates limited',
    'Kumar creations private limited',
    'Richmond builders private limited',
    'Kinetix solutions private limited',
    'Dnr corporation private limited',
    'EI CONSTRUCTION & MANAGEMENT PRIVATE LIMITED',
    'Sun projects india private limited',
    'Abad constructions private limited',
    'Ganga housing pvt ltd',
    'Man realtors and holdings private limited',
    'ICROTONE PRIVATE LIMITED',
    'Mz properties and exports private limited',
    'Vanguard realty private limited',
    'Shandar constructions private limited',
    'Ames developers private limited',
    'Honeywell properties private limited',
    'Chandak realtors private limited',
    'Mittal m. g. real estate private limited',
    'Darsh buildwell private limited',
    'Ab realtech services limited',
    'Sunshine landmarks private limited',
    'Suner constructions private limited',
    'K k green buildcon priavte limited',
    'K k square builders private limited',
    'Motherland engineering company private limited',
    'South india shelters private limited',
    'Ten square property developers private limited',
    'Megapolis developers private limited',
    'Hruday infra and resource solutions private limited',
    'Sita buildcon pvt. ltd',
    'Golden edge engineering private limited',
    'Satya sankalp villa (ellis-bridge) private limited',
    'Aura estate management private limited',
    'Monoplan securities private limited',
    'Urja investment private limited',
    'Harisharan developers private limited',
    'Suhrid investments private limited',
    'Aishwarya shares and securities private limited',
    'Matsyagandha investment and finance private limited',
    'Alag finance and investment private limited',
    'WAGAD FINCAP LIMITED',
    'Konkan capfin limited',
    'Essel finance business loans limited',
    'Sms financial services private limited',
    'Aha holdings private limited',
    'Kapnox forex private limited',
    'Maintec financial advisory services private limited',
    'CHENNAPURI NIDHI LIMITED',
    'Jmj plus kuries limited',
    'TAMASI INFRACON PRIVATE LIMITED',
    'CENTILLION CAPITAL PRIVATE LIMITED',
    'Air liquide india holding pvt ltd',
    'Dlf universal limited..',
    'Hi fidelity solutions private limited',
    'Shri rangam properties limited',
    'Hooghly holdings private limited',
    'SRVS(INDIA-2020) SECURITIES & INFRASTRUCTURE LIMITED',
    'Baba gangaram investment services private limited',
    'Sb capital consultants private limited',
    'ZEAL INSURANCE BROKERS PRIVATE LIMITED',
    'Traditional bharat kala arts and crafts',
    'Anindita toy company private limited',
    'Dev shyam distributors private limited',
    'Bessar diamond manufacturing company private limited',
    'Hem packwell enterprise private limited',
    'Iclarify software india private limited',
    'Nitya kalyanee investment limited',
    'LCC INVESTMENTS PRIVATE LIMITED',
    'Indermohan investments & finance co pvt ltd',
    'Lal wani capital markets ltd.',
    'VARDHMAN TRUSTEESHIP PRIVATE LIMITED',
    'GNRL OIL & GAS (I) PRIVATE LIMITED',
    'Altavista capital advisory services private limited',
    'Saraogi viniyog pvt.ltd.',
    'Athena insurance and re-insurance brokers private limited',
    'New era insurance broking services private limited',
    'Sbi payment services private limited',
    'Pine tree capital markets private limited',
    'MOTHERSON TECHNOLOGY SERVICES LIMITED',
    'Xeraphin finvest private limited',
    'Jindal holidays pvt ltd',
    'Netacross holdings and investments private limited',
    'PURE BROKING PRIVATE LIMITED',
    'Indraprastha stocks private limited',
    'Pentad securities private limited',
    'Hawk trading and investment company private limited',
    'Sha investco (india) private limited',
    'Trigandh investment and finance private limited',
    'Ace realties private limited',
    'Athena holdings (india) private limited',
    'Phonosonic india private limited',
    'Peregrine securities (india) private limited',
    'Ensearch securities private limited',
    'Recon agro oils trading private limited',
    'Quadratic financial services private limited',
    'Vaibhav stock & derivatives broking private limited',
    'Abhigam shares and securities private limited',
    'Barclays securities (india) private limited',
    'Sambandh finserve private limited',
    'Ashoka portfolio management pvt. ltd.',
    'DIGAMBER CAPFIN LTD',
    'Mvr securities private limited',
    'Unifi capital private limited',
    'Vamika securities services private limited',
    'SHANTA PROJECTS PRIVATE LIMITED',
    'Meera mohan investment pvt ltd',
    'Shigan telematics private limited',
    'Sfs logistics private limited',
    'Mpt logistics private limited',
    'Shepards shipping services ( india ) private limited',
    'Vls global logistics private limited',
    'Combine clearing and forwarding private limited',
    'Fei cargo ltd.',
    'Sreetrans logistics (india) private limited',
    'Trilokya cold storage private limited',
    'Wci(madras) private ltd',
    'Ocean glidde logistics private limited',
    'Ept exim services private limited',
    'Andhra pradesh expressway limited',
    'Seatrade maritime private limited',
    'Vistaar shipping services (india) private limited',
    'Aviation cargo systems private limited',
    'National flying training institute private limited',
    'Kv travels private limited',
    'Incredible indian moments private limited',
    'Trans indus destination management pvt. ltd.',
    'A. T. SEASONS & VACATIONS TRAVEL PRIVATE LIMITED',
    'S e travels private limited',
    'Panjari travels private limited',
    'Olive tours pack private limited',
    'Hyatt travels private limited',
    'MMG HOLIDAYS PRIVATE LIMITED',
    'KABANI COMMUNITY TOURISM & SERVICES PRIVATE LIMITED',
    'River journeys and bungalows of india private limited',
    'YATRA HOTEL SOLUTIONS PRIVATE LIMITED',
    'Neelkanth manasarovar developers private limited',
    'TRAVELTIME MOBILITY INDIA PRIVATE LIMITED',
    'Tempest advertising private limited',
    'Take a break holidays india private limited',
    'Ott travels private limited',
    'Ots ltd',
    'K. shipping solutions private limited',
    'Ept global logistics private limited',
    'Dia infralog limited',
    'Siccar cargo console services india private limited',
    'Ntc engineering services private limited',
    'Transline maritime services private limited',
    'Dr amin controllers private limited c/n',
    'Divya shipping and clearing services pvt ltd',
    'Orient box movers private limited',
    'Parulekars shipping private limited',
    'Damani air cargo & travel agency private limited',
    'Groversons shipping services private limited',
    'Freight express international private limited',
    'Pranjivandas clearing and forwarding private limited',
    'Om clearing and forwarding private limited',
    'Premier clearing agency private limited',
    'Cargosol shipping agency private limited',
    'Aqua specialized transport private limited',
    'Gvp forwarder private limited',
    'Brunel logistics (india) private limited',
    'Lans projects logistics private limited',
    'Alacrity shipping services india private limited',
    'K.s.r.freight forwarders private limited',
    'Surface shipping & transport systems private limited',
    'Uniworld logistics private limited',
    'CMA CGM GLOBAL BUSINESS SERVICES (INDIA) PRIVATE LIMITED',
    'Nectar portman private limited',
    'G b transport (india) pvt ltd',
    'Splendid escape trips private limited',
    'Shankar roadways private limited',
    'Allot communications india private limited',
    'Interactive marketing private limited',
    'Amtel telecommunications private limited',
    'Bt telecom india private limited',
    'SONAR TELE TECHNOLOGIES PRIVATE LIMITED',
    'E valueshops.com private limited',
    'Professional esolutions (india) private limited',
    'Dotname communications private limited',
    'Hitech cellphone private limited',
    'Deepija telecom private limited',
    'Gtpl vvc network private limited',
    'Devdhar trading and consultants private limited',
    'M m visa-aid consultancy private limited',
    'Pierian services private limited',
    'Applied materials india private limited',
    'Impact management needs private limited',
    'Allied worldwide business solutions private limited',
    'Novastar fund advisors private limited',
    'Convate consultancy services private limited',
    'Ascent capital advisors india private limited',
    'Lead consultancy and engineering services (india) private limited',
    'Sfs equipments private limited',
    'Lavenir consultancy private limited',
    'Adr advisory services private limited',
    'Infoactiv sustainability solutions private limited',
    'Elado consulting private limited',
    'CEHTRA CHEMICAL CONSULTANTS PRIVATE LIMITED',
    'IXIAN INFORMATICS PRIVATE LIMITED',
    'EVIDEN INDIA PRIVATE LIMITED',
    'Sun consul-tech private limited',
    'Inter-horizons financial consultants private limited',
    'Advanced investment mechanics india private limited',
    'Petroleum consulting engineers (mumbai ) private limited',
    'Deevoir consulting services private limited',
    'INGA ADVISORS PRIVATE LIMITED',
    'OASIS COUNSEL & ADVISORY PRIVATE LIMITED',
    'Giltedge corporate advisory private limited',
    'Menon pharmaceuticals private limited',
    'SKYFLYERS AIRHOSTESS TRAINING ACADEMY PRIVATE LIMITED',
    'Innovative synthetic cordage private limited',
    'Corporate legal consulting private limited',
    'Star powerz human resources private limited',
    'Nawa engineers and consultants private limited',
    'Sumathi satakam technologies private limited',
    'Roots career solutions private limited',
    'Brandprix consultants private limited',
    'Sukhvarsha management services private limited',
    'Toras solutions private limited',
    'Bridge point solutions private limited',
    'Kanzen institute asia pacific private limited',
    'Assesspeople services (india) private limited',
    'Shakambari resources private limited',
    'Udara consulting pvt ltd',
    'Andwill management consultant private limited',
    'Medisys project consultants private limited',
    'Ecumene habitat solutions private limited',
    'Sq engineering contractors private limited',
    'Navios automation private limited',
    'Shoft industries private limited',
    'Dar al-handasah consultants (shair & partners) india private limited',
    'Glance designers and interiors private limited',
    'LK INDIA CONSTRUCTION & ENGINEERING PRIVATE LIMITED',
    'Industrial forge and engineering company limited',
    'Clearwater technology services private limited',
    'Batliboi environmental engineering limited',
    'Murzello engineering services private limited',
    'Supreme hydro engineering private limited',
    'Fluro engineering private limited',
    'DNYANTECH ENGINEERING SERVICES PRIVATE LIMITED',
    'Soneji engineering private limited',
    'Spantech engineers private limited',
    'Relcon foundations p ltd',
    'Advantage media consultants private limited',
    'Marinemantra enterprises india private limited',
    'Maa group holdings private limited',
    'Storybox communications private limited',
    'Techoms consulting private limited',
    'Purma infotainment pvt ltd',
    'Sidwal refrigeration industries private limited',
    'BHURJI ELECTRONIKS PRIVATE LIMITED',
    'G s developers and contractors pvt ltd',
    'Penta travels (india) private limited',
    'Nittu creations private limited',
    'Graphic systems private limited',
    'Chogori distribution private limited.',
    'Siora surgicals pvt.ltd.',
    'Fec engineering projects private limited',
    'Raj kalam mfg co private limited',
    'Moongipa industries limited',
    'Beacon sales private limited',
    'K r pulp and papers limited',
    'Tendom engineers private limited',
    'Niki mahima finvest and consultancy private limited',
    'H r travels private limited',
    'Moongipa finvest limited',
    'Accordis health care private limited',
    'Shree keshav agro private limited',
    'A s h holdings private limited',
    'Modern info technology private limited',
    'AHEER STEELS PRIVATE LIMITED',
    'DAMODHARTECH INTERNATIONAL PRIVATE LIMITED',
    'Shri chandra bulk cargo services private limited',
    'Willy india private limited',
    'Legstrong products india private limited',
    'Croissance consulting private limited',
    'Archer art private limited',
    'RAJPUTANA BRIGHT BARS PRIVATE LIMITED',
    'Gibson Innovations India Private Limited',
    'Stratix hospitality private limited',
    'Cosmo shuoqi impex india private limited',
    'Kovai polymers private limited',
    'VATSON INDUSTRIES PRIVATE LIMITED',
    'Mj lab private limited',
    'Empee syndichem private limited',
    'Clarke environmental technologies (india) private limited',
    'Agl industries limited',
    'Paladin paints & chemicals private limited',
    'BAXTER PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'Sucheta laboratories private limited',
    'Beluga biozymes private limited',
    'Megha healthcare private limited',
    'Thea-tex healthcare (india) private limited',
    'VALIANT ORGANICS Limited',
    'Bosco chemtex private limited',
    'Choksi organics private limited',
    'MEVADA VAPROTEC (INDIA) PRIVATE LIMITED',
    'Ved pharmaceuticals private limited',
    'Vaishali lifecare private limited',
    'ANUGRAHA PHARMA PRIVATE LIMITED',
    'Zydus takeda healthcare private limited',
    'Premier distributors (calcutta) pvt ltd',
    'Acuro organics limited',
    'Gomti life sciences india private limited',
    'MEDILEXICON PHARMACEUTICALS PRIVATE LIMITED',
    'SLB PHARMA PRIVATE LIMITED',
    'Raichur laboratories private limited',
    'Nikir healthcare private limited',
    'Globentis international private limited',
    'Biogenero labs private limited',
    'AMANYS PHARMA INDIA PRIVATE LIMITED',
    'Genphex life sciences private limited',
    'A.m.v. pharmacy (india) private limited',
    'Bonita pharmaceuticals private limited',
    'Sevantilal kantilal private limited',
    'Solumiks laboratories private limited',
    'Genom biotech private limited',
    'Manvar products limited',
    'Quest healthcare private limited',
    'RIGHT HERBAL PRIVATE LIMITED',
    'SAMI-SABINSA GROUP LIMITED',
    'The rajapalayam industrial and commercial syndicate limited',
    'Wetwo matches private limited',
    'Maruti clean coal and power limited',
    'Marudhar tanchem private limited',
    'Gekatex india private limited',
    'Rado tyres ltd',
    'Parth rubber tech private limited',
    'Deep additives private limited',
    'Plasto4ge india private limited',
    'RAJVI EXTRUSION PRIVATE LIMITED',
    'Aquazen polytech private limited',
    'Saraf poly synthetics private limited',
    'Rigidor plastics pvt ltd',
    'Gopal extrusions private limited',
    'Ideal chemi plast private limited',
    'Indo - japan polymers private limited',
    'Modi pipes private limited',
    'M h packaging (india) limited',
    'Sarat chatterjee & co (visakhapatnam) pvt ltd',
    'KAMAL TECHNOPLAST PRIVATE LIMITED',
    'Datwyler pharma packaging india private limited',
    'Narmada polyweave pvt ltd',
    'Visu poly products private limited',
    'Dwd pharmaceuticals limited',
    'Ronch polymers private limited',
    'Basell polyolefins india private limited',
    'Microfiber corp private limited',
    'Milman thin film systems private limited',
    'Springfeel polyurethane foams private limited',
    'Mak fiber tech private limited',
    'Gujarat credo mineral industries limited',
    'Karam bricks & flour industries private limited',
    'NOVA-TECH REFRACTORIES PRIVATE LIMITED',
    'Tecnografica india private limited',
    'Vennar ceramics limited',
    'Sree mugambigai glazing private limited',
    'Dongyue brick engineering private limited',
    'Flyric concrete creations private limited',
    'IRB PS HIGHWAY PRIVATE LIMITED',
    'Gulbarga cement limited',
    'Amrutha bose cement industries private limited',
    'Navbharat potteries private limited',
    'Gupta glass ideas india private limited',
    'Arrow ceramics private limited',
    'Petra exim private limited',
    'Trademin international private limited',
    'Pel industries limited',
    'WESTERN INDIA INFRA PROJECTS PRIVATE LIMITED',
    'Geecy engineering private limited',
    'Matrix grating private limited',
    'Rv alloys india private limited',
    'Kobelco plate processing india private limited',
    'Maestro steel detailing private limited',
    'Shree banke bihari ispat private limited',
    'Gwasf quality castings private limited',
    'Kanoria diesets private limited',
    'Bisco metal & power private limited',
    'Balbir alloys private limited',
    'Anappadikkal trading company private limited',
    'Adhiraj distributors limited',
    'Ashavari trading private limited',
    'Nirvana apparels private ltd',
    'Sathya agencies private limited',
    'KISHA TELELINKS PRIVATE LIMITED',
    'Arraytech technologies private limited',
    'AL-MELA INTERNATIONAL PRIVATE LIMITED',
    'Kutir material suppliers private limited',
    'Ijpn technologies (india) private limited',
    'Earlybird security systems and automations private limited',
    'Dmp healthcare private limited',
    'Indsys hitech solutions private limited',
    'Alappat traders private limited',
    'Stern trading private limited',
    'N & t engitech private limited',
    'Swen agencies private limited',
    'Stonecolour exim private limited',
    'SPILCARE O-METACLEN PRIVATE LIMITED',
    'Rajkumar impex private limited',
    'Ramcharan trade & distributions private limited',
    'MY BIOTECH PRIVATE LIMITED',
    'Aria and leya fashions private limited',
    'Akash residency and hospitality private limited',
    'NEOTEL HOTELS & RESORTS PRIVATE LIMITED',
    'Suchirindia hotels and resorts private limited',
    'Moonland hotels private limited',
    'Breeze hospitality private limited',
    'Interesting foods private limited',
    'Bigway hospitality private limited',
    'Balix resorts private limited',
    'Maruti resorts and hotels private limited',
    'Rajhans hospitality private limited',
    'Maruti comforts & inn private limited',
    'Caribbean hospitality private limited',
    'DASS REGENCY PRIVATE LIMITED',
    'Msc hotels and resorts private limited',
    'AFRAD INTERNATIONAL HOTELS PRIVATE LIMITED',
    'Greendale hospitalities private limited',
    'Reyna technology services private limited',
    'Shree priya pritam (india) limited',
    'Hotel tunga regency private limited',
    'Shree naman hospitality private limited',
    'Melaila resorts private limited',
    'Imk hotels private limited',
    'Imk hospitality private limited',
    'Ijb hotels private limited',
    'Uns foods private limited',
    'SANKALP HOLIDAY RESORTS PRIVATE LIMITED',
    'Neelkanth heritage hotels private limited',
    'Kreative hosts atria private limited',
    'Bvm energy and residency private limited',
    'KESINENI HORECA PRIVATE LIMITED',
    'Chandrakala pinnacle resorts limited',
    'Saravana bhavan private limited',
    'Balchandra hotels private limited',
    'Panorama country club resorts private limited',
    'Hanglaatherium foods private limited',
    'Juscooked eateries private limited',
    'Anjali gold packers and movers private limited',
    'Ssk smart move logistics private limited',
    'Ots logistics private limited',
    'Auto carriage pvt ltd',
    'Scope amra logistics (india) private limited',
    'Acm cargo movers private limited',
    'Anand transport logistics private limited',
    'Tropicana house boats and hospitality india private limited',
    'Vital shipping & logistics private limited',
    'Zen line shipping private limited',
    'MAGELLAN AEROSPACE (BANGALORE) PRIVATE LIMITED',
    'Gmr aviation private limited',
    'Kris aero services private limited',
    'Asg logistik private limited',
    'Gbt india private limited',
    'Sumeet trans logistics private limited',
    'Trigon transit private limited',
    'Vikas translines private limited',
    'Nhava sheva (india) gateway terminal private limited',
    'Iti logistics (india) private limited',
    'Arabian tour services india private limited',
    'Jass integrators private limited',
    'Crest container lines private limited',
    'Hindustan ports private limited',
    'Scorpio marine management (india) private limited',
    'Far n par (india) private limited',
    'USHA SHIPPING & LOGISTICS PRIVATE LIMITED',
    'Trans-maritime services private limited',
    'Galaxy seair logistics private limited',
    'United shipping services private limited',
    'Unitrans lines india private limited',
    'Professional impex private limited.',
    'Aroscan cargo trade pvt ltd',
    'Freight management india private limited',
    'Aamro freight services private limited',
    'Srivari cold storage private limited',
    'DP WORLD MULTIMODAL LOGISTICS HYDERABAD PRIVATE LIMITED',
    'Baba bhutnath heemghar private limited',
    'Marathwada cold storage private limited',
    'BYTE DATA TECHNOLOGY SERVICES INDIA PRIVATE LIMITED',
    'BANDMA EQUIPCORP LIMITED',
    'COODEIT SOLUTIONS PRIVATE LIMITED',
    'COMES MACHINE INDIA PRIVATE LIMITED',
    'PAGESUITE (INDIA) PRIVATE LIMITED',
    'SRI ARUNA GLOBAL EXIM PRIVATE LIMITED',
    'XLM SERVICES INDIA PRIVATE LIMITED',
    'MANDOT KIDNEY HEALTH SOLUTIONS PRIVATE LIMITED',
    'BUSINESSGENICS PRIVATE LIMITED',
    'TRAVANDRE ADVENTURE AND EXPERIENCE PRIVATE LIMITED',
    'ZOBANAA BRANDS PRIVATE LIMITED',
    'MEGHWIS SOLUTIONS PRIVATE LIMITED',
    'NANOGENCE MATERIALS TECHNOLOGY INDIA PRIVATE LIMITED',
    'CDC DATA CENTRE PRIVATE LIMITED',
    'POLMANN EXTRUSIONS AND COMPOUNDS PRIVATELIMITED',
    'IVCM STAR INDIA PRIVATE LIMITED',
    'MCCIA FOUNDATION',
    'NIHAR COURIER CARGO PRIVATE LIMITED',
    'UDAYSHIVAKUMAR INFRA LIMITED',
    'EMWI MARKETING (OPC) PRIVATE LIMITED',
    'PUSHPAK AEROSPACE INDIA PRIVATE LIMITED',
    'MEGARA ROBOTICS PRIVATE LIMITED',
    'MICROTECH GLOBAL TALENT PRIVATE LIMITED',
    'TATVAMASI BOOKEEPER PRIVATE LIMITED',
    'SPOWDI PRIVATE LIMITED',
    'GYPMART INDIA PRIVATE LIMITED',
    'WEIMA KIRON INDIA PRIVATE LIMITED',
    'HASS VENTURES INDIA PRIVATE LIMITED',
    'FUWEI TECHNOLOGY PRIVATE LIMITED',
    'GEEKYGIANTS INFOTECH SOLUTIONS PRIVATE LIMITED',
    'LIVERMORE INVESTMENTS PRIVATE LIMITED',
    'TRANQUIL CONSTRUCTIONS PRIVATE LIMITED',
    'SINARMAS DIGITAL PRIVATE LIMITED',
    'PRAKALPA SANIKA INFOTECH PRIVATE LIMITED',
    'STANDARD MULTIMODAL LOGISTICS PRIVATE LIMITED',
    'VIVIID RENEWABLES PRIVATE LIMITED',
    'MOWGLEE RETAIL PRIVATE LIMITED',
    'ELENTEC POWER INDIA (EPI) PRIVATE LIMITED',
    'CUBATICS GARMENTS PRIVATE LIMITED',
    'NEOMA SERVICES PRIVATE LIMITED',
    'ACE MICROMATIC INTERNATIONAL PRIVATE LIMITED',
    'PRATHAM BROADCAST INDIA PRIVATE LIMITED',
    'TRAMARCHE INTERNET PRIVATE LIMITED',
    'KARANJE EMERALD LOGISTICS PARK PRIVATE LIMITED',
    'ADRIKA LOGISTICS PRIVATE LIMITED',
    'MAPLE HERBS PRIVATE LIMITED',
    'R-SERVE INFO SYSTEMS PRIVATE LIMITED',
    'EASTMAN NEW ENERGY PRIVATE LIMITED',
    'SMILY KIDDOS PRIVATE LIMITED',
    'I-ZYSK SOLUTIONS PRIVATE LIMITED',
    'MODI & MODI REALTY HYDERABAD PRIVATE LIMITED',
    'PALAMAU GREENTECH INFRA PRIVATE LIMITED',
    'SISTEMA FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'AROMA HILLS PRIVATE LIMITED',
    'VSEND GLOBAL PRIVATE LIMITED',
    'DIGITAL METHODS PRIVATE LIMITED',
    'EDEN RENEWABLE PASSY PRIVATE LIMITED',
    'OSRM PLAST INDIA PRIVATE LIMITED',
    'MEGA CLOUD WORKS PRIVATE LIMITED',
    'TERRAINSPOTTER PRIVATE LIMITED',
    'CMR ALUMINIUM PRIVATE LIMITED',
    'SPORTING SYNDICATE INTERNATIONAL PRIVATELIMITED',
    'WEDDING RINGERS PRIVATE LIMITED',
    'KARRY BROADBAND PRIVATE LIMITED',
    'NEXN COMMUNICATIONS PRIVATE LIMITED',
    'ETHNIC FOOD MANUFACTURING PRIVATE LIMITED',
    'BANKSATHI TECHNOLOGIES AND INSURANCE CORPORATE AGENCY PRIVATE LIMITED',
    'TEMET INDIA PRIVATE LIMITED',
    'STAG GLOBAL PRIVATE LIMITED',
    'CARINA SYSTEMS PRIVATE LIMITED',
    'COGENT JTRAK TECHNO SOLUTIONS PRIVATE LIMITED',
    'ASCON SOFTECH INDIA PRIVATE LIMITED',
    'SEZZLE PAYMENTS PRIVATE LIMITED',
    'DIXON ELECTRO APPLIANCES PRIVATE LIMITED',
    'REISZ TRAVELS PRIVATE LIMITED',
    'PERFECT METAL STRUCTURE PRIVATE LIMITED',
    'VIZUALIZE MEDICAL TECHNOLOGIES PRIVATE LIMITED',
    'CEREBRUMX LABS PRIVATE LIMITED',
    'WE UNWASTE PRIVATE LIMITED',
    'HUAYUN MACHINERY INDIA PRIVATE LIMITED',
    'NETWORK FRIENDSHIP MEDIA TECHNOLOGY PRIVATE LIMITED',
    'TATTVAMASSI COACHING & CONSULTANCY (OPC)PRIVATE LIMITED',
    'AUM PAPER PRODUCTS PRIVATE LIMITED',
    'SHANTINATH PLASTICS PRIVATE LIMITED',
    'MANIKA AUTOMOTIVE PRIVATE LIMITED',
    'HOLXO HOLIDAYS PRIVATE LIMITED',
    'AIDEN FOOD AND BEVERAGES PRIVATE LIMITED',
    'HIGHLINE STUDIO PRODUCTIONS PRIVATE LIMITED',
    'HIGH CLASS SECURITY AND HOUSEKEEPING SERVICE PRIVATE LIMITED',
    'TARASH DESIGNS PRIVATE LIMITED',
    'KANVAR PROBIO PRIVATE LIMITED',
    'JMS BUILDWELL REALTY PRIVATE LIMITED',
    'KP TECH INDIA SYSTEMS PRIVATE LIMITED',
    'ISCAPE DESIGNERS PRIVATE LIMITED',
    'CREATIVE INVESTMENTS & FINANCE PRIVATE LIMITED',
    'ZORIWORLD FASHION PRIVATE LIMITED',
    'SHALMANI INDUSTRIES PRIVATE LIMITED',
    'RESTOR LAB PRIVATE LIMITED',
    'BRS TECHNOLOGY PRIVATE LIMITED',
    'KNOXTIK E-MEDIA PRIVATE LIMITED',
    'UDYOGI AGRITECH PRIVATE LIMITED',
    'EASYPLAN FINTECH SOLUTIONS PRIVATE LIMITED',
    'WHAT WORKS STUDIOS PRIVATE LIMITED',
    'BIENCAPS SYSTEMS PRIVATE LIMITED',
    'VIBCARE HEALTHCARE PRIVATE LIMITED',
    'DEEMARK & DIVYARISHI AYURVEDIC PRIVATE LIMITED',
    'IMS INDIA MANPOWER SOLUTIONS PRIVATE LIMITED',
    'NEXTBILLION. AI INDIA PRIVATE LIMITED',
    'UOLO EDTECH PRIVATE LIMITED',
    'SMOKE LAB PRIVATE LIMITED',
    'TASAKA INDUSTRIES PRIVATE LIMITED',
    'ESMM INDIA TECHNOLOGY PRIVATE LIMITED',
    'BANDHOO SOLUTIONS AND SERVICES PRIVATE LIMITED',
    'PRAVIKA INTELLICORP PRIVATE LIMITED',
    'TECHNEPLUS SOFTWARE INDIA PRIVATE LIMITED',
    'TECH INDIA ELECTROSOLUTIONS PRIVATE LIMITED',
    'TITANICOM TECH INDIA PRIVATE LIMITED',
    'FAAZ ELECTRICAL PRIVATE LIMITED',
    'HALFCUTE INTERNET PRIVATE LIMITED',
    'NAGAICH SERVICES PRIVATE LIMITED',
    'VIRTINA INDIA PRIVATE LIMITED',
    'POWERDRIVE SECURITY AND ALLIED SERVICES PRIVATE LIMITED',
    'NEOCORP ENGINEERING PRIVATE LIMITED',
    'HECL TECHNOLOGY PRIVATE LIMITED',
    'BIGBRAND MANUFACTURING INDIA PRIVATE LIMITED',
    'TRS TOTAL CLEANING SOLUTIONS PRIVATE LIMITED',
    'MARWAL PIPING SYSTEMS PRIVATE LIMITED',
    'LEVIGATO EXIM PRIVATE LIMITED',
    'EDUHOC PRIVATE LIMITED',
    'CLOUDILM (OPC) PRIVATE LIMITED',
    'UNILED INDIA PRIVATE LIMITED',
    'ULTRAWIRED TECHNOLOGIES PRIVATE LIMITED',
    'REAL REPEAT BOX PRIVATE LIMITED',
    'QUORA INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'GREENWICH VENTURES PRIVATE LIMITED',
    'EARTHMET RESOURCES PRIVATE LIMITED',
    'LYNCERV PRIVATE LIMITED',
    'PISERVE SOLUTIONS PRIVATE LIMITED',
    'INNOGENIUM PRIVATE LIMITED',
    'SERVTRONICA TECHNOLOGIES PRIVATE LIMITED',
    'RIDE ACCESS PRIVATE LIMITED',
    'GIPL EIEPL SAS JV PRIVATE LIMITED',
    'TELNIUM TECHNOLOGIES PRIVATE LIMITED',
    'NEXRBIT PRIVATE LIMITED',
    'SUPERBAAZI PRIVATE LIMITED',
    'EVEREST FINANCE AND INVESTMENTS PRIVATE LIMITED',
    'EXPLORRA EDUCATION PRIVATE LIMITED',
    'VRG DESIGN DEN PRIVATE LIMITED',
    'VEGAALINE LOGISTICS PRIVATE LIMITED',
    'SIN TRENDS PRIVATE LIMITED',
    'EEE INTERNATIONAL ADVISORS PRIVATE LIMITED',
    'SOI FOUNDATION',
    'SRINIVASA LIFE SCIENCES PRIVATE LIMITED',
    'CROSSBORDER SCHOOLS ORGANISATION',
    'INTEROPERABLE INDIA FOUNDATION',
    'MANTRA DATA CENTERS PRIVATE LIMITED',
    'ELIO ENERGY PRIVATE LIMITED',
    'ONSURITY TECHNOLOGIES PRIVATE LIMITED',
    'MAABHARTI INDUSTRIES PRIVATE LIMITED',
    'VELRUSH BUSINESS NETWORKS PRIVATE LIMITED',
    'NULA TEA PRIVATE LIMITED',
    'CODEMART INFOTECH PRIVATE LIMITED',
    'LIFE AT LAKSHYAM PRIVATE LIMITED',
    'VAISHNOENTERPRISES & CONSTRUCTIONS PRIVATE LIMITED',
    'FITMONK WELLNESS PRIVATE LIMITED',
    'NAAYOS RETAIL PRIVATE LIMITED',
    'CLEAR VIEW AUTOMOTIVE PRIVATE LIMITED',
    'SUNBARN RENEWABLES PRIVATE LIMITED',
    'EXSEGEN GENOMICS RESEARCH PRIVATE LIMITED',
    'AMPLIFIER RESTAURANTS PRIVATE LIMITED',
    'ZARRENSTAR HOSPITALITY PRIVATE LIMITED',
    'BOXOFHEALTH INDIA PRIVATE LIMITED',
    'CAMP INDIA PRIVATE LIMITED',
    'FASHION FAIR APPARELS PRIVATE LIMITED',
    'PRIYAS HUB PRIVATE LIMITED',
    'CORIGAMI TECHNOLOGIES PRIVATE LIMITED',
    'NATURAL PLANT PROTECTION LIMITED',
    'NETSPEED TECHNOLOGIES PRIVATE LIMITED',
    'EJAM INDIA PRIVATE LIMITED',
    'GEOTRICS ENGINEERING SERVICES PRIVATE LIMITED',
    'OL EXPERT PRIVATE LIMITED',
    'GT PROJECTS PRIVATE LIMITED',
    'EOX VANTAGE PRIVATE LIMITED',
    'PRAKUL HEALTH SERVICES PRIVATE LIMITED',
    'FLIGHT SHOPEE PRIVATE LIMITED',
    'DISRUPT CONSULTING PRIVATE LIMITED',
    'GLOBAL INTELLECTUALS VENTURES PRIVATE LIMITED',
    'KREATE ONE MANUFACTURING PRIVATE LIMITED',
    'SKYDDA INSURANCE WEB AGGREGATOR PRIVATE LIMITED',
    '3ES ACCOUNTANTS PRIVATE LIMITED',
    'ELLIS TECHNOLOGY PRIVATE LIMITED',
    'AAGAMAN TOURISM AND HOSPITALITY PRIVATE LIMITED',
    'SMART-AUTOMATION AND LV SYSTEMS PRIVATE LIMITED',
    'ASTROTECH INDIA PRIVATE LIMITED',
    'GPA MEDIWORLD PRIVATE LIMITED',
    'LAMOR INDIA PRIVATE LIMITED',
    'SPACE SHAALA PRIVATE LIMITED',
    'SWADHEEN MEDIA PRIVATE LIMITED',
    'SEVENIMAGINE EDUCATION PRIVATE LIMITED',
    'NAVIN FLUORINE ADVANCED SCIENCES LIMITED',
    'MURANI INFOTECH PRIVATE LIMITED',
    'STAYQRIOUS INDIA PRIVATE LIMITED',
    'LUMEX DIAMOND SERVICES PRIVATE LIMITED',
    'NEELMAHADEV ASSOCIATES PRIVATE LIMITED',
    'INTERACTO DIGITAL PRIVATE LIMITED',
    'MERIGLOBE LINES PRIVATE LIMITED',
    'URBAN MILLERS FOODS PRIVATE LIMITED',
    'NESTIEN SOLUTIONS PRIVATE LIMITED',
    'KISAAN AGRI TRADE PRIVATE LIMITED',
    'SETU NUTRITION PRIVATE LIMITED',
    'SAARATHI CHILD EDUCATION & SOCIAL WELFARE FOUNDATION',
    'RABENIVS INDIA (OPC) PRIVATE LIMITED',
    'PURE ID PRIVATE LIMITED',
    'SHEETAL HYBRID SEEDS AND BIO-TECH PRIVATE LIMITED',
    'ASHVINI RARE EARTH PRIVATE LIMITED',
    'YELLOW FUNDS INDIA PRIVATE LIMITED',
    'BLACK BUCK CAFE INDIA PRIVATE LIMITED',
    'JAI SHRIRAM PROPERTIES PRIVATE LIMITED',
    'HAAS POLYCOMPOUNDS PRIVATE LIMITED',
    'TRISEAS FACILITY AND SERVICES PRIVATE LIMITED',
    'HOUZPARTY SERVICES PRIVATE LIMITED',
    'DECISION DATA TECHNOLOGIES PRIVATE LIMITED',
    'POLYMET TECHNO PRODUCTS PRIVATE LIMITED',
    'EEIO SOLUTIONS PRIVATE LIMITED',
    'NUTRESTA FOODS PRIVATE LIMITED',
    'CELTIS COMMODITIES LIMITED',
    'ESGRAPH PRIVATE LIMITED',
    'ORIGIN RESOURCE MANAGEMENT PRIVATE LIMITED',
    'AYANA RENEWABLE POWER FIVE PRIVATE LIMITED',
    'KOCHIVA PRIVATE LIMITED',
    'TIDE PLATFORM PRIVATE LIMITED',
    'NATURE N CARE DISTRIBUTIONS PRIVATE LIMITED',
    'SQUAREHOUSE TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'BLUE BUGLE VENTURES PRIVATE LIMITED',
    'FOREVER DISTILLERY PRIVATE LIMITED',
    'TRIVISION FACILITIES MANAGEMENT PRIVATE LIMITED',
    'TVAM DEVELOPERS PRIVATE LIMITED',
    'RKN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'PINAK GLOBAL PROTOTYPING PRIVATE LIMITED',
    'MANMECH SMART SOLUTIONS PRIVATE LIMITED',
    'HORIZON FINANCIAL & PROPERTIES ADVISERS PRIVATE LIMITED',
    'VKU CERTIFICATION PRIVATE LIMITED',
    'NEARMEDS TECHNOLOGIES PRIVATE LIMITED',
    'EKAM ADVISORS PRIVATE LIMITED',
    'NATWAR LIQUORS PRIVATE LIMITED',
    'EAGLE YARNS PRIVATE LIMITED',
    'COUNTRYONWHEELS PRIVATE LIMITED',
    'PRATYA AI LABS PRIVATE LIMITED',
    'TIEA CONNECTORS PRIVATE LIMITED',
    'CITYGODDESS INDIA PRIVATE LIMITED',
    'VOYON TECHNOLOGY SERVICES PRIVATE LIMITED',
    'THINKACTGROW PRIVATE LIMITED',
    'CHIFU AGRITECH PRIVATE LIMITED',
    'CONSULTMEN ADVISORS PRIVATE LIMITED',
    'AMAZING KNITS PRIVATE LIMITED',
    'KIYAGI SOLUTIONS PRIVATE LIMITED',
    'SHRI BABA BAIDNATH ISPAT PRIVATE LIMITED',
    'RUBISCAPE PRIVATE LIMITED',
    'GLOBAL UPSIDE SERVICES INDIA PRIVATE LIMITED',
    'ATHINA TRADERS PRIVATE LIMITED',
    'USPI CONSULTING PRIVATE LIMITED',
    'EUROE PRESS INDIA PRIVATE LIMITED',
    'CAPTAIN CASTECH LIMITED',
    'ASSAM RTD PRIVATE LIMITED',
    'FOURDEGREEWATER CAPITAL PRIVATE LIMITED',
    'KUNAL ANSHUMAN SERVICES PRIVATE LIMITED',
    'ZITA TELECOM PRIVATE LIMITED',
    'INNOVATIVE ENGINEERS H.V.A.C. PRIVATE LIMITED',
    'VASIPRIME TECH PRIVATE LIMITED',
    'JWA TECHNOLOGY PRIVATE LIMITED',
    'LORMAN GREENTECH PRIVATE LIMITED',
    'FRSH VENTURES PRIVATE LIMITED',
    'RINAYO KIDZ KLUB PRIVATE LIMITED',
    'MOONPRENEUR INDIA PRIVATE LIMITED',
    'DIGIAEON SERVICES PRIVATE LIMITED',
    'MINDPATH TECH PRIVATE LIMITED',
    'RUPYAAPAISA SOLUTIONS PRIVATE LIMITED',
    'TCPL INNOFILMS PRIVATE LIMITED',
    'DSCAPITALIZE MUTUAL BENEFIT PRIVATE LIMITED',
    'CREATIVE TRADE CONCEPTS PRIVATE LIMITED',
    'ANANTHAM ONLINE PRIVATE LIMITED',
    'ARISU RETAIL PRIVATE LIMITED',
    'ALTISSADVANCE TECH PRIVATE LIMITED',
    'NARAYANANA CITY BUS OPERATIONS PRIVATE LIMITED',
    'DINEX EMISSION SOLUTIONS INDIA PRIVATE LIMITED',
    'FIREBELLY HOLDINGS PRIVATE LIMITED',
    'TOSHNIWAL AUTO PARTS PRIVATE LIMITED',
    'IDEAL LIGHTING & SMART TECHNOLOGIES PRIVATE LIMITED',
    'ALIGNED AUTOMATION SERVICES PRIVATE LIMITED',
    'GEORGE BERNARD INDIA PRIVATE LIMITED',
    'MIADIAMANTE FOODS AND BEVERAGES PRIVATE LIMITED',
    'NANOMATRIX MATERIALS PRIVATE LIMITED',
    'ALPHA MARINE LIMITED',
    'NATUROGANIC TEXTILES PRIVATE LIMITED',
    'ALTO-SHAAM INDIA PRIVATE LIMITED',
    'GREENWIRE EARTH MINERALS PRIVATE LIMITED',
    'ORIENTAL',
    'SVINGIT TECHNOLOGIES PRIVATE LIMITED',
    'CODCOR TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'RENTOKIL INITIAL HYGIENE INDIA PRIVATE LIMITED',
    'ACADIAN SEAPLANTS INDIA PRIVATE LIMITED',
    'GENERIS TEK STAFFING PRIVATE LIMITED',
    'STADE COMMERCE PRIVATE LIMITED',
    'KANISHKA SOFTWARE PRIVATE LIMITED',
    'MOLT WELLSCIENCE PRIVATE LIMITED',
    'STRENGTHFACTORS FITNESS PRIVATE LIMITED',
    'ZARIYA HUMANITY FOUNDATION',
    'ADVONIK BUSINESS MANAGEMENT CONSULTING PRIVATE LIMITED',
    'MAHATHI STORAGE TERMINAL PRIVATE LIMITED',
    'BHUWAL MATA FOOD INDUSTRY PRIVATE LIMITED',
    'CSB DATA CONSULTING PRIVATE LIMITED',
    'ZYPLE SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CRINTELL TECHNOLOGIES PRIVATE LIMITED',
    'PLUCKWALK TECHNOLOGIES PRIVATE LIMITED',
    'INFO FURR TECHNOLOGIES PRIVATE LIMITED',
    'OVHTECH R&D (INDIA) PRIVATE LIMITED',
    'COMMINENT PRIVATE LIMITED',
    'DJPS SOLUTIONS PRIVATE LIMITED',
    'DARSH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'URBAN AIRSHIP INDIA PRIVATE LIMITED',
    'GAN STUDIO PRIVATE LIMITED',
    'COOLSOL SOLUTIONS PRIVATE LIMITED',
    'TRANSWORLD SYSTEMS INDIA PRIVATE LIMITED',
    'ABSOTECH SOLUTIONS PRIVATE LIMITED',
    'UPTRIX CONSULTING PRIVATE LIMITED',
    'AVTAR CALLCONNECT SERVICES INDIA PRIVATELIMITED',
    'JAIBHARON SHELTERS PRIVATE LIMITED',
    'APMOSYS PRODUCTS PRIVATE LIMITED',
    'INDECOMM BUSINESS SERVICES (INDIA) PRIVATE LIMITED',
    'VOXYBER TECHNOLOGY PRIVATE LIMITED',
    'QKOPY ONLINE SERVICES PRIVATE LIMITED',
    'SANRIYA GLOBAL PRIVATE LIMITED',
    'ZAPOJ INDIA PRIVATE LIMITED',
    'MANGATA TECHNOLOGIES PRIVATE LIMITED',
    'SENOS TECH INDIA PRIVATE LIMITED',
    'ELPIS SYSTEMS INDIA PRIVATE LIMITED',
    'CYPHERSHOT TECHNOLOGIES PRIVATE LIMITED',
    'INTELLIGENT HIGHWAY MANAGEMENT SYSTEMS PRIVATE LIMITED',
    'ASCENER FACTORY PRIVATE LIMITED',
    'SPOTEX TECHNOLOGY PRIVATE LIMITED',
    'CONTRACTPOD SOLUTIONS PRIVATE LIMITED',
    'GLOBAL CHANNEL RESOURCES INDIA PRIVATE LIMITED',
    'ALGOSURG TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ANSTICE TECHNOLOGIES PRIVATE LIMITED',
    'THINGSTEL TECH SOLUTIONS INDIA PRIVATE LIMITED',
    'ITD SERVICES PRIVATE LIMITED',
    'THINKFLUX E-SOLUTIONS PRIVATE LIMITED',
    'GCT TECHNOLOGIES PRIVATE LIMITED',
    'AAMAZING IT DESIGN INDIA PRIVATE LIMITED',
    'ELATIV CONSULTING AND SOLUTIONS INDIA PRIVATE LIMITED',
    'ESPRESSIF SYSTEMS (INDIA) PRIVATE LIMITED',
    'AYOPOP TECHNOLOGY INDIA PRIVATE LIMITED',
    'CAMELOT ITLAB PRIVATE LIMITED',
    'SPORDIA SOFTECH PRIVATE LIMITED',
    'SURYALOGIX PRIVATE LIMITED',
    'AALAP TECHNOLOGIES PRIVATE LIMITED',
    'ELLIOT SYSTEMS PRIVATE LIMITED',
    'INFINITYX TECH SYSTEMS PRIVATE LIMITED',
    'CODEVISION TECHNOLOGIES PRIVATE LIMITED',
    'THREATLANDSCAPE CYBER SOLUTIONS PRIVATE LIMITED',
    'S2INFINITUM SOFTECH PRIVATE LIMITED',
    'ASACHS SOFTWARES PRIVATE LIMITED',
    'AILOGIC NEURAL NETWORK PRIVATE LIMITED',
    'AHEADRACE AGRIRETURNS TECHNOLOGY (OPC) PRIVATE LIMITED',
    'DOUX LABS PRIVATE LIMITED',
    'TECHSERA SOFTWARE PRIVATE LIMITED',
    'BILLIONBRAINS GARAGE VENTURES PRIVATE LIMITED',
    'ICTS TECKI INDIA PRIVATE LIMITED',
    'SMARAGDINE TECHNOLOGIES PRIVATE LIMITED',
    'IIOTX TECHNOLOGIES PRIVATE LIMITED',
    'SOLUNUS TECHNOLOGIES PRIVATE LIMITED',
    'GO-ITBUILDERS SOFTWARE SOLUTIONS PRIVATELIMITED',
    'WHITEINDIA INNOVATIVE TECHNOLOGIES PRIVATE LIMITED',
    'VAALI ARTIFICIAL INTELLIGENCE PRIVATE LIMITED',
    'RYNG OUTSOURCING PRIVATE LIMITED',
    'INNSAEI TECHNOLOGIES PRIVATE LIMITED',
    'INDIMONSAFE TECKNOLOGIES PRIVATE LIMITED',
    'BATCH SERVICE PRIVATE LIMITED',
    'GOYAL IT CONSULTANCY PRIVATE LIMITED',
    'VIRINSE NEXGENSERVE PRIVATE LIMITED',
    'EMBRIDGE SOLUTIONS PRIVATE LIMITED',
    'AVIDHCODERS TECHNOLOGIES PRIVATE LIMITED',
    'AIDED RECO MANAGEMENT PRIVATE LIMITED',
    'NIRNAYA SYSTEM AND SOLUTIONS PRIVATE LIMITED',
    'SECURITYHQ INDIA PRIVATE LIMITED',
    'QUANTASTART TECHNOLOGIES PRIVATE LIMITED',
    'ADNYAA PROPERTIES PRIVATE LIMITED',
    'AIKAAN LABS PRIVATE LIMITED',
    'AUGMENTED SCM PRIVATE LIMITED',
    'ASUTOSH RAJ VISHVAGURU FOUNDATION',
    'TURIYA INNOVATIONS PRIVATE LIMITED',
    'RK FIBERGRID INDIA PRIVATE LIMITED',
    'ENVIE SOCIAL PRIVATE LIMITED',
    'FLEETMATICS PRIVATE LIMITED',
    'XEN.AI IT MENTORS PRIVATE LIMITED',
    'BISLEY INSIGHTS PRIVATE LIMITED',
    'ZWECK INFOTECH PRIVATE LIMITED',
    'HIGH FLOWS IT SOLUTIONS PRIVATE LIMITED',
    'NEXT2 DOOR LIVING PRIVATE LIMITED',
    'NIBHU TECHNOLOGIES PRIVATE LIMITED',
    'BLUECLOUD SERVICES PRIVATE LIMITED',
    'KANAKOL TECHNOLOGIES PRIVATE LIMITED',
    'TASDEV AMSOFT INDIA PRIVATE LIMITED',
    'PAVNA SUNWORLD AUTOTECH PRIVATE LIMITED',
    'SECURNYX INDIA PRIVATE LIMITED',
    'SSHRISHTI JAGRITI MAHILA FOUNDATION',
    'MONATO BRANDS LIMITED',
    'TIDYQUANT (OPC) PRIVATE LIMITED',
    'WOLKUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'PROGNOSTICS IN-MED PRIVATE LIMITED',
    'NIRASYS INFOTECH INDIA PRIVATE LIMITED',
    'SUVEGA TECHNOLOGIES PRIVATE LIMITED',
    'GORDIAN KNOT SOLUTIONS PRIVATE LIMITED',
    'COUNTED ONE MEDIA LABS PRIVATE LIMITED',
    'CAMBIUM HEALTHCARE PRIVATE LIMITED',
    'MATRIX GAS AND RENEWABLES LIMITED',
    'NOVA DIGITECH SOLUTIONS PRIVATE LIMITED',
    'ADITADV DIGITAL PRIVATE LIMITED',
    'SIEMSYS SOLUTIONS IT INFRA PRIVATE LIMITED',
    'CENTIMETRE TECHNOLOGIES PRIVATE LIMITED',
    'DIVYANIA INFRASTRUCTURES INDIA PRIVATE LIMITED',
    'PULIAN INDIA ENTERPRISES PRIVATE LIMITED',
    'PHOTOSYNTHESIS RETAIL INDIA PRIVATE LIMITED',
    'GENERAL CROP SCIENCE PRIVATE LIMITED',
    'QUANTUUM RESOLUTION PROFESSIONALS PRIVATE LIMITED',
    'MAGREENS SYNERGY PRIVATE LIMITED',
    'MATERNA IPS INDIA PRIVATE LIMITED',
    'EUROFINS NSC INDIA PRIVATE LIMITED',
    'WDB MEDICAL DATA INDIA PRIVATE LIMITED',
    'CEDRATEC INDIA PRIVATE LIMITED',
    'IOEACCESS COMMUNICATIONS PRIVATE LIMITED',
    'AADIFIDELIS SOLUTIONS PRIVATE LIMITED',
    'PROLOGIC MECHATRONICS PRIVATE LIMITED',
    'ECOSCAPES LANDSCAPING PRIVATE LIMITED',
    'AMYS INDIA TOURS PRIVATE LIMITED',
    'KOOLDAIR SYSTEMS INDIA PRIVATE LIMITED',
    'HARDFORK MEDIA PRIVATE LIMITED',
    'TRANSFIT VENTURE PRIVATE LIMITED',
    'PRANAYA LIFE SCIENCES PRIVATE LIMITED',
    'VAREO TECHNO HEALTH PRIVATE LIMITED',
    'VIHATI TECHNO HEALTH PRIVATE LIMITED',
    'VIRTUS THREE SPORTS INDIA EQUIPMENT PRIVATE LIMITED',
    'GHPULSE SOLUTIONS PRIVATE LIMITED',
    'PAARIS AVIATION WORLD PRIVATE LIMITED',
    'TELRE DESIGN DRAFTING SOLUTION PRIVATE LIMITED',
    'MEDIAMELON DIGITAL PRIVATE LIMITED',
    'ZAB TECHNOLOGIES PRIVATE LIMITED',
    'EMERICH ENERGY PRIVATE LIMITED',
    'WE4BIZ GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SUBLIME SPIRITS PRIVATE LIMITED',
    'HEART AND SOUL MEDIA PRIVATE LIMITED',
    'MANSRI INNOVATIONS PRIVATE LIMITED',
    'ESSENTIAL ADVISORY SERVICES PRIVATE LIMITED',
    'MICROANALYTIK INSTRUMENTS PRIVATE LIMITED',
    'BOUGIE PROJECT PRIVATE LIMITED',
    'HEADSAIL MEDIA SERVICES PRIVATE LIMITED',
    'PRIMEASURE BROADCAST SOLUTIONS PRIVATE LIMITED',
    'FST DIGITAL PRIVATE LIMITED',
    'FINOXE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'OASIS ETHANOL INDUSTRIES PRIVATE LIMITED',
    'CLOUDREACH TECHNOLOGIES INDIA PRIVATE LIMITED',
    'WEBSTORM NETWORKS PRIVATE LIMITED',
    'LIGHTROOT LIGHTING SOLUTIONS PRIVATE LIMITED',
    'COLACACION CONSULTANCY IMF PRIVATE LIMITED',
    'ACUMENTODAY PRIVATE LIMITED',
    'FARARICAMI INDIA PRIVATE LIMITED',
    'SEATREASURE PRIVATE LIMITED',
    'WHITEMONK INTERACTIVE PRIVATE LIMITED',
    'CWT SCHOOL ZONE PRIVATE LIMITED',
    'NKS TECHNOLOGIES PRIVATE LIMITED',
    'EEB CONSULTANTS (OPC) PRIVATE LIMITED',
    'NTT SECURITY (INDIA) PRIVATE LIMITED',
    'SIMPLY VYAPAR APPS PRIVATE LIMITED',
    'QUANTDOT SOLUTIONS PRIVATE LIMITED',
    'SERVNTIRE GLOBAL PRIVATE LIMITED',
    'CROZAINT TECHNOLOGIES PRIVATE LIMITED',
    'JAPTHA PROJECTS AND CONSULTANT PRIVATE LIMITED',
    'ASTHRA DIGIMARK PRIVATE LIMITED',
    'CNH BUSINESS CONSULTANTS PRIVATE LIMITED',
    'PURUMLIN PRIVATE LIMITED',
    'SEARCHINGSOULS ADVENTURE AND GATEWAYS PRIVATE LIMITED',
    'AKVO ATMOSPHERIC WATER SYSTEMS PRIVATE LIMITED',
    'BONDADA ABODES PRIVATE LIMITED',
    'LOKAS AWS TECHNOLOGIES PRIVATE LIMITED',
    'SUJATA ASSOCIATES CONSULTANCY PRIVATE LIMITED',
    'APSS MARKSOL PRIVATE LIMITED',
    'ALWACHSEND TRAINING AND PLACEMENT SERVICES PRIVATE LIMITED',
    'VIDUAL COMMUNICATIONS INDIA PRIVATE LIMITED',
    'WINSURE FOODS MARKETING PRIVATE LIMITED',
    'FORESCOUT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ALCAN LIFE SCIENCES',
    'BERRY FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'AFS INTERNATIONAL PRIVATE LIMITED',
    'SHUBHALAXMI PULSES PRIVATE LIMITED',
    'KMG IT SERVICES PRIVATE LIMITED',
    'ONB TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CHUNGHAE FOOD & BEVERAGES PRIVATE LIMITED',
    'LAASYE EVENTS PRIVATE LIMITED',
    'PANSEIS GEO SERVICES PRIVATE LIMITED',
    'SUMAN WASTE MANAGEMENT (OPC) PRIVATE LIMITED',
    'ALFAZANCE INDIA PRIVATE LIMITED',
    'GREEN SEMICONDUCTORS PRIVATE LIMITED',
    'NERANTI TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'GROWNEX PRIVATE LIMITED',
    'VIAZONE TECHNOLOGIES PRIVATE LIMITED',
    'KOSOFT IT SOLUTIONS PRIVATE LIMITED',
    'MAYILON SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'RDCONS PRIVATE LIMITED',
    'GLOBEMAP ENGINEERS & CONTRACTORS PRIVATELIMITED',
    'AGR LOGISTICS PRIVATE LIMITED',
    'MBC CORPORATE ADVISORS PRIVATE LIMITED',
    'HOLANTA PRIVATE LIMITED',
    'QESCAPADES PRIVATE LIMITED',
    'GK ACOUSTICAL SOUND MASKING SOLUTIONS PRIVATE LIMITED',
    'TAFEL TECHNOLOGIES PRIVATE LIMITED',
    'EJESMAPA TECHNOLOGIES PRIVATE LIMITED',
    'MSENSE DIGITAL MEDIA PRIVATE LIMITED',
    'QTROVEVISTA EXCLUSIVE SERVICES PRIVATE LIMITED',
    'BSE EBIX INSURANCE BROKING PRIVATE LIMITED',
    'UFS DIGITAL LIMITED',
    'GERA WEALTH PRIVATE LIMITED',
    'PAYTM GENERAL INSURANCE LIMITED',
    'PAYTM LIFE INSURANCE LIMITED',
    'RIJKDOM FINSERV PRIVATE LIMITED',
    'NXTDEN TECHNOSERVE PRIVATE LIMITED',
    'KODEAC SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HIPE PROPERTY CONSULTANCY PRIVATE LIMITED',
    'SAFEHOUSE TECHNOLOGIES PRIVATE LIMITED',
    'NEOFRUITION TECHNOSOL PRIVATE LIMITED',
    'C2C ADVANCED SYSTEMS PRIVATE LIMITED',
    'SYNTAGI HEALTHCARE PRIVATE LIMITED',
    'BAYONE TECHNO ADVISORS PRIVATE LIMITED',
    'GRANTWOOD TECHNOLOGIES PRIVATE LIMITED',
    'ORITATECH COMMUNICATION PRIVATE LIMITED',
    'AUSTFONNA INTELLIGENCE PRIVATE LIMITED',
    'NEXTHASH TECHNOLOGIES PRIVATE LIMITED',
    'ASPRA REALTY SOLUTIONS PRIVATE LIMITED',
    'BINATEDIN PRIVATE LIMITED',
    'LOBBER INTERNATIONAL PRIVATE LIMITED',
    'CAPNET TECHNOLOGIES PRIVATE LIMITED',
    'NARYN M&S PRIVATE LIMITED',
    'SANDSQUARE GLOBAL SOLUTIONS PRIVATE LIMITED',
    'N-BRICKS TECHNOLOGIES PRIVATE LIMITED',
    'SARAM INFRACORP PRIVATE LIMITED',
    'MATRIX AGRO SOLUTIONS PRIVATE LIMITED',
    'FINSURGE PRIVATE LIMITED',
    'LIVNSENSE TECHNOLOGIES PRIVATE LIMITED',
    'VENTURISTIC TECHNOLOGIES PRIVATE LIMITED',
    'LAMBDAZEN INDIA PRIVATE LIMITED',
    'CNLABS TEST SERVICES PRIVATE LIMITED',
    'LINKYUN TECHNOLOGY PRIVATE LIMITED',
    'COLIVING STORIES PRIVATE LIMITED',
    'KAS SERVICES INDIA PRIVATE LIMITED',
    'KAWIKA SOLUTIONS PRIVATE LIMITED',
    'INNOVENTIA SYSTEMS PRIVATE LIMITED',
    'CANKADO INDIA PRIVATE LIMITED',
    'HAPPINESS HARMONY PROPERTY DEVELOPERS PRIVATE LIMITED',
    'OCTC DEVELOPERS PRIVATE LIMITED',
    'YASU INFRASTRUCTURE PRIVATE LIMITED',
    'HOPPONWORKS PRIVATE LIMITED',
    'SOURCEMASH TECHNOLOGIES PRIVATE LIMITED',
    'GLANCEWORK PRIVATE LIMITED',
    'VOZIX DIGITAL SOLUTION PRIVATE LIMITED',
    'YALAMANCHILI DIGITAL SOLUTIONS PRIVATE LIMITED',
    'NALANDA IT ZONE PRIVATE LIMITED',
    'LISHASH TECHNOLOGIES PRIVATE LIMITED',
    'SHISHAM DIGITAL MEDIA PRIVATE LIMITED',
    'PERFECT GYM SOFTWARES INDIA PRIVATE LIMITED',
    'ADAPTIVE DATA PROTECTION PRIVATE LIMITED',
    'AMVOTECH SOLUTIONS PRIVATE LIMITED',
    'KNOWTEQ CONSULTANCY PRIVATE LIMITED',
    'BIZZAPPDEV SYSTEMS PRIVATE LIMITED',
    'MNTECH ENTERPRISES PRIVATE LIMITED',
    'CIRKLED IN INDIA PRIVATE LIMITED',
    'BOUTIQAAT SERVICES PRIVATE LIMITED',
    'ALMO DIGITAL PRIVATE LIMITED',
    'GOALSR INDIA PRIVATE LIMITED',
    'PERSONACE INNOCOMMION (OPC) PRIVATE LIMITED',
    'PURPLEFIRE INDIA PRIVATE LIMITED',
    'CURNEU MEDTECH INNOVATIONS PRIVATE LIMITED',
    'PLANET EV SOLUTIONS PRIVATE LIMITED',
    'BS INVENTIONS PRIVATE LIMITED',
    'SHIVATMIKA TECHNOSOFT PRIVATE LIMITED',
    'PNEUMATICS AUTOMATION E.MC INDIA PRIVATELIMITED',
    'LANDLINE IMPORTS & EXPORTS PRIVATE LIMITED',
    'PURELEARN EDUINFRA JAKKASANDRA PRIVATE LIMITED',
    'URBAN MEX FOOD AND BEVERAGE PRIVATE LIMITED',
    'GREEN SOUL ERGONOMICS PRIVATE LIMITED',
    'DEEPSIGHT AI LABS PRIVATE LIMITED',
    'ZEROEK SERVICES PRIVATE LIMITED',
    'EVOLUTIVE EONICSLABS PRIVATE LIMITED',
    'ACAUSAL AUTOMATION PRIVATE LIMITED',
    'ACRISOFT TECHNOLOGIES PRIVATE LIMITED',
    'BLOCKSERA TECHNOLOGIES PRIVATE LIMITED',
    'SURREAL ENTERTAINMENT PRIVATE LIMITED',
    'DEMARSCUBE PRIVATE LIMITED',
    'WEBSULTANATE SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'BORNMONKIE PRIVATE LIMITED',
    'FOUNDATION FOR INNOVATION & RESEARCH IN SCIENCE & TECHNOLOGY',
    'TRIYAAKSH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SCORPIO MARITIME INDIA PRIVATE LIMITED',
    'STEFRONT TECHNOLOGIES PRIVATE LIMITED',
    'ENCOSYM SOLUTIONS PRIVATE LIMITED',
    'TOLA BROADBAND (OPC) PRIVATE LIMITED',
    'AROVENT TECHNOLOGIES PRIVATE LIMITED',
    'LIWHEELY PRIVATE LIMITED',
    'FACILE INFO-SERV PRIVATE LIMITED',
    'LIVELIKE SPORTS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DNVCS SOLUTIONS PRIVATE LIMITED',
    'EQVOUS IT SOLUTIONS PRIVATE LIMITED',
    'LOGISHIELD SOFTWARE PRIVATE LIMITED',
    'SINQ BEVERAGES PRIVATE LIMITED',
    'COUNTRY HOLIDAYS WORLD PRIVATE LIMITED',
    'CHANDER IMPEX PRIVATE LIMITED',
    'ROBOTHING GADGETS PRIVATE LIMITED',
    'TAPPS SHOES PRIVATE LIMITED',
    'AIV DIGITAL MEDIA PRIVATE LIMITED',
    'KOMPANION RESEARCH PRIVATE LIMITED',
    'BIGEDGE CONSULTANT PRIVATE LIMITED',
    'NETPULSE SERVICES INDIA PRIVATE LIMITED',
    'HANSAMUKH SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'REVFIN SERVICES PRIVATE LIMITED',
    'SSANG MA PLANT & TECH PRIVATE LIMITED',
    'AXON PUBLICSAFETY INDIA PRIVATE LIMITED',
    'DHIMAHI TECHNOLOGIES PRIVATE LIMITED',
    'TRUEHOST IT SERVICES PRIVATE LIMITED',
    'SURYASAGAR COMMUNICATION PRIVATE LIMITED',
    'MMN ADVISORY PRIVATE LIMITED',
    'GIEBIZ INTERNATIONAL PRIVATE LIMITED',
    'DAILYWATZ MOBILE AND MEDIA PRIVATE LIMITED',
    'OCEAN LEASEDLINE WALA PRIVATE LIMITED',
    'EVEROC TECH INDIA PRIVATE LIMITED',
    'TALANTIC SHIPS INDIA PRIVATE LIMITED',
    'SIDDHI WIND ENERGY PRIVATE LIMITED',
    'AEGON SHIPPING INDIA PRIVATE LIMITED',
    'TAAS ADVERTISING AND DEVELOPERS PRIVATE LIMITED',
    'DIGSEOTECH SOLUTIONS PRIVATE LIMITED',
    'SATTRIX SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'KSS PROGRESSIVE CAPITAL PRIVATE LIMITED',
    'XSHIP DESIGN AND ANALYTICS PRIVATE LIMITED',
    'FIELDKART FARMER PRODUCER COMPANY LIMITED',
    'WHITE KNIGHT FOREX SERVICES PRIVATE LIMITED',
    'CLOUDHEDGE TECHNOLOGIES PRIVATE LIMITED',
    'ARTILIGENT SOLUTIONS PRIVATE LIMITED',
    'EDYPHANT PRIVATE LIMITED',
    'HARVESTING INDIA PRIVATE LIMITED',
    'AMDM SKILLS SERVICES (OPC) PRIVATE LIMITED',
    'AADIYAR INFOTECH PRIVATE LIMITED',
    'BALXIC BUSINESS SOLUTIONS PRIVATE LIMITED',
    'JAYAPRADA FOUNDATION',
    'BLACKSTONE ECOSYSTEMS & PROCESSES PRIVATE LIMITED',
    'RABBLE TECHNOLOGIES PRIVATE LIMITED',
    'CENEX TECHNOLOGIES PRIVATE LIMITED',
    'PREMLEADS MEDIA PRIVATE LIMITED',
    'ADANI SOLAR ENERGY AP SEVEN PRIVATE LIMITED',
    'KRYTECH TECHNOLOGIST PRIVATE LIMITED',
    'PMS AUTOMATIONS PRIVATE LIMITED',
    'PROBABILITY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GRADESDONTMATTER PRIVATE LIMITED',
    'REDLETTER HOLIDAYS PRIVATE LIMITED',
    'JAANIK CONSULTING PRIVATE LIMITED',
    'STRIDE CAPITAL CONSULTANTS PRIVATE LIMITED',
    'TROUNCE LIFE SCIENCES PRIVATE LIMITED',
    'BHOJPUR CONSULTING PRIVATE LIMITED',
    'MSC MARINE TRAINING INSTITUTE',
    'YASH FANS PRIVATE LIMITED',
    'FRESH AIR EDUCATION PRIVATE LIMITED',
    'LIGMAN INDIA ILLUMINATION SYSTEMS PRIVATE LIMITED',
    'THOT LIFESTYLE PRIVATE LIMITED',
    'NFN INTERNATIONAL PRIVATE LIMITED',
    'DBL ANANDAPURAM ANAKAPALLI HIGHWAYS LIMITED',
    'JAMMU AUTOWHEELS PRIVATE LIMITED',
    'ROGERTHAT PRODUCTION PRIVATE LIMITED',
    'WILDFLOWER BUSINESS SERVICES PRIVATE LIMITED',
    'BLUECOIN IOT SOLUTIONS PRIVATE LIMITED',
    'EXIMIUS LIFE CARE PRIVATE LIMITED',
    'DEARLIFE EMPOWER INDIA PRIVATE LIMITED',
    'RIGHTPOINT INDIA DIGITAL PRIVATE LIMITED',
    'IDBOOK TRADE & E-COMMERCE PRIVATE LIMITED',
    'EUPHOTIC LABS PRIVATE LIMITED',
    'COMETT STAFFING SOLUTIONS PRIVATE LIMITED',
    'ROOPANTARAN EDUCATION PRIVATE LIMITED',
    'CLAUSION INDIA PRIVATE LIMITED',
    'HOME ECSTASSY RETAIL PRIVATE LIMITED',
    'JCB LITERATURE FOUNDATION',
    'YAP INDIA DEVELOPERS PRIVATE LIMITED',
    'CANBMINE PRIVATE LIMITED',
    'INTRO INTERNET SERVICES PRIVATE LIMITED',
    'DELSQUARE SIGMA TECHNOLOGIES PRIVATE LIMITED',
    'DIGISMART INFOTECH PRIVATE LIMITED',
    'STRONGER EVERYDAY MERCHANDISE PRIVATE LIMITED',
    'ACOBLOOM INTERNATIONAL PRIVATE LIMITED',
    'THWN WELLNESS PRIVATE LIMITED',
    'SEIDO PLASTIC ENGINEERING PRIVATE LIMITED',
    'EVERESTDX (INDIA) PRIVATE LIMITED',
    'O.R INDIA INNOVATIONS PRIVATE LIMITED',
    'HORSEMEN MOTORS PRIVATE LIMITED',
    'EDGETENSOR TECHNOLOGIES PRIVATE LIMITED',
    'MAKE ME BUILDER (OPC) PRIVATE LIMITED',
    'LUXERATI RETAIL PRIVATE LIMITED',
    'SWASTIK SEEDS PRIVATE LIMITED',
    'WHITE VENTURES ONLINE PRIVATE LIMITED',
    'KOINDO HOTEL PRIVATE LIMITED',
    'MANDAR TRANSMISSION LIMITED',
    'VISILEAN INDIA PRIVATE LIMITED',
    'KABA LOGISTIC PRIVATE LIMITED',
    'JAYMATAJI BATTERY PRIVATE LIMITED',
    'CADMILE HITECH SERVICES PRIVATE LIMITED',
    'INVENTASK PRIVATE LIMITED',
    'VINCOGNIS TECHCRAFT PRIVATE LIMITED',
    'MAHAPATRA REAL ESTATE PRIVATE LIMITED',
    'CAPRI CATERING & HOSPITALITY SERVICES PRIVATE LIMITED',
    'CHIPSPIRIT TECHNOLOGIES PRIVATE LIMITED',
    'GESTALTI KPO SERVICES PRIVATE LIMITED',
    'CONTEXTINE SOFTWARE PRIVATE LIMITED',
    'ZZZ INNOVATIONS PRIVATE LIMITED',
    'PATEL UNIVERSAL WORKS STUDIO PRIVATE LIMITED',
    'HIBROW HEALTHCARE PRIVATE LIMITED',
    'USHA ELECTRIC POWER PRIVATE LIMITED',
    'T.S.RAJAM RUBBERS PRIVATE LIMITED',
    'GLS METALLICS INDIA LIMITED',
    'SERVSOFT ITES PRIVATE LIMITED',
    'TRIVCART ELECTRONIC COMMERCE PRIVATE LIMITED',
    'TSKEI INDIA PRIVATE LIMITED',
    'APPLYIT KNOWLEDGE & TECHNOLOGY PRIVATE LIMITED',
    'GHM MESSTECHNIK INDIA PRIVATE LIMITED',
    'OCEO WATER PRIVATE LIMITED',
    'REVACON TECHNOLOGIES PRIVATE LIMITED',
    'COGNITENSOR TECHNOLOGY PRIVATE LIMITED',
    'VEEGIAN INDUSTRIES PRIVATE LIMITED',
    'FTTX BROADBAND PRIVATE LIMITED',
    'GRC PROPERTIES INDIA PRIVATE LIMITED',
    'GRINDKING UNIVERSAL PRIVATE LIMITED',
    'TIZZY CLOUD COMPUTING PRIVATE LIMITED',
    'AYURPOWER PRODUCTS PRIVATE LIMITED',
    'ZPPOZ PRIVATE LIMITED',
    'FIXLIFE DIGITAL (OPC) PRIVATE LIMITED',
    'ASTAKYUTA PRIVATE LIMITED',
    'SUNA FOODS AND SERVICES PRIVATE LIMITED',
    'SSDC TECHNOLOGIES INDIA PRIVATE LIMITED',
    'INNOVENTIVE AUTOWAY INDUSTRIES PRIVATE LIMITED',
    'INSTITUT FRANCAIS PRIVATE LIMITED',
    'COLLECTIVE HEADS EDUCATION AND TRAINING VENTURES PRIVATE LIMITED',
    'VP TECHLABS PRIVATE LIMITED',
    'DO RIGHT FOUNDATION FOR PERFORMING ARTISTS',
    'AEROMED INNOVATIVE PRIVATE LIMITED',
    'MR PROCESSED & FRESH FRUITS PRIVATE LIMITED',
    'LINGSAA TECHNOLOGIES PRIVATE LIMITED',
    'RAVELUST TOURISM AND TRAVEL MANAGEMENT PRIVATE LIMITED',
    'ANKOSOFT TECHNOLOGIES PRIVATE LIMITED',
    'BORGAON WATAMBARE HIGHWAYS PRIVATE LIMITED',
    'KABOOM SOCIAL IMPACT PRIVATE LIMITED',
    'REYAAN FRAGRANCES PRIVATE LIMITED',
    'DBL SANGLI BORGAON HIGHWAYS LIMITED',
    'DIGIVAL SOLUTIONS PRIVATE LIMITED',
    'FRAGRANCES SOFTWARE PRIVATE LIMITED',
    'LUGSTO SERVICES PRIVATE LIMITED',
    'OXAIR GAS SYSTEMS INDIA PRIVATE LIMITED',
    'CBA SERVICES PRIVATE LIMITED',
    'LAZY DOOR LOGISTICS PRIVATE LIMITED',
    'NOVABORO INDUSTRIAL PARTS CLEANING PRIVATE LIMITED',
    'QTT ADVENTURE SPORTS ACADEMY PRIVATE LIMITED',
    'BIAC AND VISTAR (JV) INFRA INDIA PRIVATELIMITED',
    'CIPHERCODE TECH SOLUTIONS PRIVATE LIMITED',
    'PERFECTION BUSINESS VENTURES PRIVATE LIMITED',
    'AMITEK SMART TECHNOLOGY PRIVATE LIMITED',
    'MULTIPRO MACHINES PRIVATE LIMITED',
    'COUNTRYARD IMPERIAL INN & SUITES PRIVATELIMITED',
    'HINDUSTAN TRAVEL CORPORATION PRIVATE LIMITED',
    'OCTATECH ENTERPRISES PRIVATE LIMITED',
    'ASHOKA ANKLESHWAR MANUBAR EXPRESSWAY PRIVATE LIMITED',
    'METEX PROJECTS PRIVATE LIMITED',
    'PRECISION AGRICULTURE FOR DEVELOPMENT INDIA FOUNDATION',
    'ARIPRA PROJECTS PRIVATE LIMITED',
    'SADBHAV INFRA SOLUTIONS PRIVATE LIMITED',
    'CBD IT SOLUTIONS PRIVATE LIMITED',
    'NUMENTICA TECHNOLOGIES PRIVATE LIMITED',
    'JHQ NET INDIA PRIVATE LIMITED',
    'ORDNC 2022 000160 U74999KA2018PTC112266 PRIVATE LIMITED',
    'BIOLOGICO GREENMOTIVE VENTURES PRIVATE LIMITED',
    'NATTURZ BIO KONTROL PRIVATE LIMITED',
    'BEDIKA FILMS PRIVATE LIMITED',
    'ARIMA ANALYTICS PRIVATE LIMITED',
    'NETWIN FINTECH PRIVATE LIMITED',
    'NAMMACHITRA FILM TECHNICAL CENTER PRIVATE LIMITED',
    'TGG RESEARCH PRIVATE LIMITED',
    'UNIKUE KITCHEN AND HOSPITALITY SERVICES PRIVATE LIMITED',
    'CUBEFAB INDIA PRIVATE LIMITED',
    'TESTCORE IT SOLUTIONS PRIVATE LIMITED',
    'VEESHINE FACILITY SOLUTIONS PRIVATE LIMITED',
    'GETBASIS SECURITIES AND TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BLURUT SOLUTIONS PRIVATE LIMITED',
    'FINBOT PRIVATE LIMITED',
    'NEMINATH WOOD INDUSTRY PRIVATE LIMITED',
    'PEOPLE PEAK HR SERVICES PRIVATE LIMITED',
    'HIIMMAGYA COLD STORAGE AND FROZEN FOODS PRIVATE LIMITED',
    'THEA ENERGY PRIVATE LIMITED',
    'ARTHUR GRAND TECHNOLOGIES PRIVATE LIMITED',
    'SUNDARBELLA (OPC) PRIVATE LIMITED',
    'BLUEPILL TECHNOLOGIES PRIVATE LIMITED',
    'SADBHAV KIM EXPRESSWAY PRIVATE LIMITED',
    'PATEL VADODARA-KIM EXPRESSWAY PRIVATE LIMITED',
    'KNR TIRUMALA INFRA PRIVATE LIMITED',
    'CANDIDROOT SOLUTIONS PRIVATE LIMITED',
    'YSA ENTERTAINMENT PRIVATE LIMITED',
    'ABEONA TOURS PRIVATE LIMITED',
    'SUMYAG DATA SCIENCES PRIVATE LIMITED',
    'SUHWAN TRADE & SERVICES PRIVATE LIMITED',
    'KSWF EDUCON PRIVATE LIMITED',
    'INHABIT PRO REALTIES (OPC) PRIVATE LIMITED',
    'SEGUROPAC PRODUCTS PRIVATE LIMITED',
    'ABM ADVERTISING PRIVATE LIMITED',
    'KNR SHANKARAMPET PROJECTS PRIVATE LIMITED',
    'HEART AND STROKE FOUNDATION OF INDIA',
    'PRAKRITIK POWER PRIVATE LIMITED',
    'AUDINTEL INDIA PRIVATE LIMITED',
    'DUNYA LABS (INDIA) PRIVATE LIMITED',
    'CPPANDEY ENTERPRISES LIMITED',
    'MEA AME PRIVATE LIMITED',
    'YANTRANG CNC AUTOMATION PRIVATE LIMITED',
    'INDIGI CONSULTING & SOLUTIONS PRIVATE LIMITED',
    'ZAVI DESIGNS PRIVATE LIMITED',
    'BASS INFRATEL PRIVATE LIMITED',
    'BRANDYOU ENTERPRISE LIMITED',
    'KOKO NETWORKS PRIVATE LIMITED',
    'PSGFER E&C PRIVATE LIMITED',
    'HERCULES STRUCTURAL ENGINEERING PRIVATE LIMITED',
    '4I MANAGEMENT CONSULTING PRIVATE LIMITED',
    'GREAT WESTERN PROJECTS PRIVATE LIMITED',
    'RENEWMAX ENERGY PRIVATE LIMITED',
    'DRYSTAR INDIA PRIVATE LIMITED',
    'ADANI WIND ENERGY KUTCHH TWO LIMITED',
    'JIVANTA MEDICITY PRIVATE LIMITED',
    'INVRECO PRIVATE LIMITED',
    'B. U. BHANDARI LANDMARKS PRIVATE LIMITED',
    'RRSENIORLY TECHNOLOGIES INDIA PRIVATE LIMITED',
    'CANCER AID FOUNDATION',
    'ONJECTION LABS PRIVATE LIMITED',
    'ACTSFOLIO INTERNATIONAL PRIVATE LIMITED',
    'MORPHOSES LEARNING PRIVATE LIMITED',
    'DEVLATA TECHNOLOGIES PRIVATE LIMITED',
    'JSS DIGITAL CONSULTING PRIVATE LIMITED',
    'ZILLIOBIT INTERACTIVE PRIVATE LIMITED',
    'CAPILT SERVICES PRIVATE LIMITED',
    'PECTEN LABS PRIVATE LIMITED',
    'PRR SCRIBE SOLUTIONS PRIVATE LIMITED',
    'INRAIN CONSTRUCTION PRIVATE LIMITED',
    'EXPERDITER PRIVATE LIMITED',
    'MAGIC WAND MEDIA PRIVATE LIMITED',
    'EML MANAGEMENT PRIVATE LIMITED',
    'MAHADYUT PROJECTS AND SERVICES PRIVATE LIMITED',
    'SATVED FOOD & BEVERAGES PRIVATE LIMITED',
    'CRAZZYPIXEL PRIVATE LIMITED',
    'AYANSH INFOTECH PRIVATE LIMITED',
    'TCI COLD CHAIN SOLUTIONS LIMITED',
    'ADANI RENEWABLE ENERGY (KA) LIMITED',
    'POINT TECHNOVATION PRIVATE LIMITED',
    'RUPYZ FINTECH PRIVATE LIMITED',
    'SKO SYSTEMS PRIVATE LIMITED',
    'SELFWING DIGITAL MEDIA PRIVATE LIMITED',
    'FROSHEIN ADVISORS PRIVATE LIMITED',
    'INDOSYKI RESOURCES (OPC) PRIVATE LIMITED',
    'HSN INTERIORS PRIVATE LIMITED',
    'GLOPLAX SOLUTIONS PRIVATE LIMITED',
    'THINK GAS DISTRIBUTION PRIVATE LIMITED',
    'SHAMBHAVI INTELLECT PRIVATE LIMITED',
    'JHKP TECHNOLOGIES PRIVATE LIMITED',
    'TMSV EDUTECH PRIVATE LIMITED',
    'COMPREHEND INDIA FOUNDATION',
    'STRATIWIDE SOLUTIONS PRIVATE LIMITED',
    'ORALIUM LIMITED',
    'DIUS FOODS & FLIPS PRIVATE LIMITED',
    'ULOG INDIA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CENTURY VEHICLELOANS PRIVATE LIMITED',
    'SENQUIRE ANALYTICS PRIVATE LIMITED',
    'CUBEVO INSIGHTS PRIVATE LIMITED',
    'UIPATH BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'LENDOVATION PRIVATE LIMITED',
    'COUNFREEDISE RETAIL SERVICES LIMITED',
    'DIAI INDIA PRIVATE LIMITED',
    'UPRISING SCIENCE PRIVATE LIMITED',
    'EAGANSOFT PRIVATE LIMITED',
    'UOS INDIA PRIVATE LIMITED',
    'WESIGN TECHNOLOGIES PRIVATE LIMITED',
    'OBASIX INDUSTRIES PRIVATE LIMITED',
    'BY HANNA BRAND SOLUTIONS PRIVATE LIMITED',
    'TECHEXE IT SOLUTIONS PRIVATE LIMITED',
    'SWAG FASHIONS HUB PRIVATE LIMITED',
    'IS DESIGN PRIVATE LIMITED',
    'DATAR PICK & MOVE PRIVATE LIMITED',
    'BTOS TALENT MANAGEMENT PRIVATE LIMITED',
    'ADISHWAR AUTO RIDE INDIA PRIVATE LIMITED',
    'WECARE LIFESCIENCE PRIVATE LIMITED',
    'SCIENTIMENTAL EDUCATIONAL SERVICES (OPC)PRIVATE LIMITED',
    'CY COSMETICS PRIVATE LIMITED',
    'GATII SOLAR PRIVATE LIMITED',
    'HYPERION MATERIALS & TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DAMENSCH APPAREL PRIVATE LIMITED',
    'AVAADA NON-CONVENTIONAL UPPROJECT PRIVATE LIMITED',
    'SPROUTE NETWORKS INDIA PRIVATE LIMITED',
    'KOKAASH INDIA PRIVATE LIMITED',
    'SKYFIRM PROJECTS PRIVATE LIMITED',
    'YUVAA ORIGINALS PRIVATE LIMITED',
    'PERFECT LEATHER TANNING INTERNATIONAL PRIVATE LIMITED',
    'SHREEM DIGITAL MEDIA PRODUCTION PRIVATE LIMITED',
    'ISHWAR VALLEY (OPC) PRIVATE LIMITED',
    'AARSONIC GLOBAL PRIVATE LIMITED',
    'ALADIAN HOME STYLES PRIVATE LIMITED',
    'SVAAS INFRAMAX SOLUTIONS (OPC) PRIVATE LIMITED',
    'VISIT HEALTH PRIVATE LIMITED',
    'FLOS PRECISION PRIVATE LIMITED',
    'ADESHARA OUTSOURCING SOLUTIONS PRIVATE LIMITED',
    'EMPOWER SWISS INDIA PRIVATE LIMITED',
    'EINTEC PMG PRIVATE LIMITED',
    '4BASECARE GENOMICS PRIVATE LIMITED',
    'CVI SOFTWARE PRIVATE LIMITED',
    'NRTU FOUNDATION',
    'AADHAR GLOBAL SOFTWARES PRIVATE LIMITED',
    'AKRIDATA INDIA PRIVATE LIMITED',
    'YRJ TECHNICAL SERVICES PRIVATE LIMITED',
    'ECOFUGE TRADES AND SERVICES PRIVATE LIMITED',
    'UPREALITY INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'UNIDAWN PRIVATE LIMITED',
    'PARIMAA HEALTHCARE PRIVATE LIMITED',
    'CARPL.AI PRIVATE LIMITED',
    'LOVES CLOUD PRIVATE LIMITED',
    'SGIPL STUDY GROUP INDIA PRIVATE LIMITED',
    'OCHRON IMPEX PRIVATE LIMITED',
    'KMN INVESTMENTS PRIVATE LIMITED',
    'HEXAMECH TECHNOLOGY PRIVATE LIMITED',
    'TRANSINT ENDEAVOURS PRIVATE LIMITED',
    'VIROHAN PRIVATE LIMITED',
    'INNXT INTERGLOBE INFRA ENGINEERING PRIVATE LIMITED',
    'SAMHATI AUTO INDIA PRIVATE LIMITED',
    'VGC BEENA PRIVATE LIMITED',
    'ESPI FARMS PRIVATE LIMITED',
    'SHELTERA CONSTRUCTION INTL LIMITED',
    'UDGAMA SOFTWARES AND SYSTEMS PRIVATE LIMITED',
    'AUFAIT IMPEX PRIVATE LIMITED',
    'MAZE EVENTS AND EXHIBIT SOLUTIONS PRIVATE LIMITED',
    'APE SISMICO PRIVATE LIMITED',
    'ILLINOIS INSTITUTE OF TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'UNITED OXYGEN COMPANY PRIVATE LIMITED',
    'JCK INFRASTRUCTURE DEVELOPMENT LIMITED',
    'SMITHS & FOUNDERS (INDIA) LIMITED',
    'NARANG PLASTICS PRIVATE LIMITED',
    'SPRAYING SYSTEMS (INDIA) PRIVATE LIMITED',
    'SOLITON TECHNOLOGIES PRIVATE LIMITED',
    'JUPITER TECHNOLOGIES PRIVATE LIMITED',
    'BHAWANI INTERNATIONAL PRIVATE LIMITED',
    'BT SOLDERS PRIVATE LIMITED',
    'STEER ENGINEERING PRIVATE LIMITED',
    'TRANE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ABBVIE THERAPEUTICS INDIA PRIVATE LIMITED',
    'GRUHINI INDHAN PRIVATE LIMITED',
    'ZESS AERODEF PRIVATE LIMITED',
    'UTHAAN BREEDING PRIVATE LIMITED',
    'HASHVATECH GLOBAL PRIVATE LIMITED',
    'JUNKET FOODS PRIVATE LIMITED',
    'ZEREFLEX CORPORATE ADVISORS PRIVATE LIMITED',
    'TCCO INDIA PROJECTS PRIVATE LIMITED',
    'ARRIKA FIBRES PRIVATE LIMITED',
    'CGK DECOR PRIVATE LIMITED',
    'EDUNIAL INFOTECH PRIVATE LIMITED',
    'KANO PRECITECH PRIVATE LIMITED',
    'JITENDRA CARGO MOVERS PRIVATE LIMITED',
    'RESURGE BEVERAGES PRIVATE LIMITED',
    'THUCKALAY NIDHI LIMITED',
    'SKARA TECHNOLOGIES LIMITED',
    'ADITYA BIRLA STRESSED ASSET AMC PRIVATE LIMITED',
    'CONSCISCO PRIVATE LIMITED',
    'ALPHA INTERNATIONAL MEDIA PLANET LIMITED',
    'MAXIMAX WAREHOUSING SOLUTIONS PRIVATE LIMITED',
    'FORM B DESIGN AND RESEARCH (OPC) PRIVATELIMITED',
    'THREE282 TECHNOLOGIES PRIVATE LIMITED',
    'BA CYBER MANAGEMENT ALLIANCE PRIVATE LIMITED',
    'CALISTA CHATEAUX PRIVATE LIMITED',
    'AREYA PACKAGING PRIVATE LIMITED',
    'NFERENCE LABS PRIVATE LIMITED',
    'BOT ORGANIC PRIVATE LIMITED',
    'PRENTITY SOLUTIONS PRIVATE LIMITED',
    'PRANAVA SCIENTIFIC VASTU SOLUTIONS PRIVATE LIMITED',
    'DURGMEDICARE MANAGEMENT PRIVATE LIMITED',
    'ENERGEC CHEM SPECIALITIES PRIVATE LIMITED',
    'PROTECHMANIZE SOLUTIONS PRIVATE LIMITED',
    'REFINITIV INDIA SHARED SERVICES PRIVATE LIMITED',
    'GALACTUS FUNWARE TECHNOLOGY PRIVATE LIMITED',
    'ANAGAT PROCESS AND SYSTEMS PRIVATE LIMITED',
    'MULAMOOTTIL HEALTHCARE PRIVATE LIMITED',
    'S. SOOD BUSINESS SUPPORT SERVICES PRIVATE LIMITED',
    'CENORBIT PRIVATE LIMITED',
    'APISOD TECHNOLOGIES PRIVATE LIMITED',
    'CASA BILLTRIM INDIA PRIVATE LIMITED',
    'EMTRANS SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'BLACK RHINO RECRUITMENT (OPC) PRIVATE LIMITED',
    'QYJO PRIVATE LIMITED',
    'VEMME VERTICALS PRIVATE LIMITED',
    'GOSUPER11 FANTASY SPORTS PRIVATE LIMITED',
    'ACCRUALIFY INDIA PRIVATE LIMITED',
    'CRIXFEED INFO SERVICES PRIVATE LIMITED',
    'UNPLANNED JOURNEYS PRIVATE LIMITED',
    'TRANSGATE LOGISTICS PRIVATE LIMITED',
    'PERCIPERE CONSULTING INDIA PRIVATE LIMITED',
    'WHATNOT INDIA PRIVATE LIMITED',
    'JHBB ENGINEERING AND MECHANICAL PRIVATE LIMITED',
    'TOP OFFICE PROS BUSINESS SERVICES PRIVATE LIMITED',
    'ABOX PAPERPACK PRIVATE LIMITED',
    'PIANOSA PRIVATE LIMITED',
    'NEEV BIOCHEM PRIVATE LIMITED',
    'MOTOROYALE KINETIC PRIVATE LIMITED',
    'CLAIRVOYANCE CHEMTECH PRIVATE LIMITED',
    'AEOLUS ENGINEERING AND TECHNOLOGIES PRIVATE LIMITED',
    'AAI ASHAPURA REALTORS PRIVATE LIMITED',
    'TECHNOGRAM PRIVATE LIMITED',
    'TALKIETIVE CONTENT CREATORS PRIVATE LIMITED',
    'CREATORBOX SOFTWARES PRIVATE LIMITED',
    'MEGASPOT INNOVATIONS PRIVATE LIMITED',
    'COFIGURE INDIA PRIVATE LIMITED',
    'INNOVANT PXXL PRIVATE LIMITED',
    'ARCIS TOURS PRIVATE LIMITED',
    'NDS HOSPITALITY SERVICES PRIVATE LIMITED',
    'POLESTAR GLOBAL DEBT RECOVERY & ADVISORYPRIVATE LIMITED',
    'ZELIOT CONNECTED SERVICES PRIVATE LIMITED',
    'LIL',
    'S PLAY SPORTS MANAGEMENT COMPANY PRIVATE LIMITED',
    'RANK ALLOYS AND METALS PRIVATE LIMITED',
    'Thorat filtration private limited',
    'Raha engineers private limited',
    'Lvmh watch and jewellery india private limited',
    'Kiah life style private limited',
    'Arihant gold and silver private limited',
    'PODDAR DIAMOND PRIVATE LIMITED',
    'ORO PRECIOUS METALS PRIVATE LIMITED',
    'Cool diamond private limited',
    'Tks products private limited',
    'Globose systems and solution private limited',
    'Jaya sail loft and upholstery works private limited',
    'Source 1 luminaries private limited',
    'Itan jewels private limited',
    'Dukes infra india private limited',
    'Abhijeet agencies private limited',
    'Gaatha handicrafts private limited',
    'ZENSE HOSPITALITY PRIVATE LIMITED',
    'Pondymania creation and exports private limited',
    'Carbonzero eco projects private limited',
    'SHRAVANA POWER PROJECTS PRIVATE LIMITED',
    'United sustainable energy india private limited',
    'Hetero wind power limited',
    'SEI L',
    'S OWN TOUCH HEALTH TRAVELS PRIVATE LIMITED',
    'ENERGY ASSET SOLUTIONS PRIVATE LIMITED',
    'WATCHDOG MONITORING SERVICES PRIVATE LIMITED',
    'COSMETICS CONCEPT RESEARCH PRIVATE LIMITED',
    'INTERNATIONAL AND DOMESTIC ARBITRATION CENTRE INDIA',
    'GPI PROJECTS PRIVATE LIMITED',
    'THRIVENI SAINIK MINING PRIVATE LIMITED',
    'BIOCIPHER TECHNOLOGIES PRIVATE LIMITED',
    'ANISHYA LIFECARE PRIVATE LIMITED',
    'WILDLIFE LUXURIES (INDIA) PRIVATE LIMITED',
    'ICONNECT BUSINESS PRIVATE LIMITED',
    'BEST AUTOMATIVE TECHNOLOGY PRIVATE LIMITED',
    'CORE STAFFING SOLUTIONS PRIVATE LIMITED',
    'STREO TECHNOLOGIES PRIVATE LIMITED',
    'ADBY VENTURES PRIVATE LIMITED',
    'TURV CONSULTING PRIVATE LIMITED',
    'NIAM GUSTO KITCHEN PRIVATE LIMITED',
    'ZUELIA FASHIONS PRIVATE LIMITED',
    'NNINJAS MODEL MANAGEMENT PRIVATE LIMITED',
    'JAYPEE CONTAINER LINE PRIVATE LIMITED',
    'MSTARLEX MANAGED SOLUTIONS PRIVATE LIMITED',
    'WATSOO TECHNOLABS PRIVATE LIMITED',
    'EFILING PORTAL PRIVATE LIMITED',
    'FLUME INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'CONRAN MEDIA PRIVATE LIMITED',
    'SAMVITEE FOODS PRIVATE LIMITED',
    'JINDAGI LIVE DIGITAL PRIVATE LIMITED',
    'WILLBETHECHANGE TECHNOLOGIES PRIVATE LIMITED',
    'TABONO SPORTS & EVENTS PRIVATE LIMITED',
    'SANRO MEDIA PRIVATE LIMITED',
    'ELSKER LIFESCIENCE PRIVATE LIMITED',
    'WORLD CLASS GIFTS PRIVATE LIMITED',
    'PROGRAMIC ASIA PRIVATE LIMITED',
    'BROENGINEERS SALES AND SERVICE PRIVATE LIMITED',
    'TRIOS RETAIL PRIVATE LIMITED',
    'DERMATO STUDY INDIA PRIVATE LIMITED',
    'ROYALRAHI GLOBAL LOGISTICS PRIVATE LIMITED',
    'PRIMERO VENTURES PRIVATE LIMITED',
    'ORANGE GATE HOSPITALITY & EVENTS INDIA PRIVATE LIMITED',
    'INDIANIC INFOCOM PRIVATE LIMITED',
    'IMPERIAL RESORTS PRIVATE LIMITED',
    'SANELITE EQUIPMENTS PRIVATE LIMITED',
    'UPAYA SOCIAL VENTURES INDIA PRIVATE LIMITED',
    'HEMMERSBACH INDIA PRIVATE LIMITED',
    'VENDAVO TECHNOLOGY PRIVATE LIMITED',
    'AERX LABS INDIA PRIVATE LIMITED',
    'GST PARTNERS PRIVATE LIMITED',
    'GURUGYAAN FOUNDATION',
    'ENTREPRENEURS ORGANISATION GURGAON',
    'MSUPPLY ECOMMERCE INDIA PRIVATE LIMITED',
    'BLUEBIRD INDIA R&D CENTER PRIVATE LIMITED',
    'LIGHTWARE VISUAL ENGINEERING INDIA PRIVATE LIMITED',
    'G2 INTEGRITY MANAGEMENT SOLUTIONS INDIA PRIVATE LIMITED',
    'APAR PEOPLEWORLD SOFTWARE SERVICES PRIVATE LIMITED',
    'GETIXHEALTH INDIA PRIVATE LIMITED',
    'RAITH INDIA PRIVATE LIMITED',
    'HUMANETICS INNOVATIVE SOLUTIONS INDIA PRIVATE LIMITED',
    'CANDOR VIEW INDIA PRIVATE LIMITED',
    'MERKLE INSPIRE PRIVATE LIMITED',
    'TELNET INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'EUROFINS CLINICAL DIAGNOSTICS BANGALORE PRIVATE LIMITED',
    'ABIZCON CONTRACT SERVICES AND CONSULTING PRIVATE LIMITED',
    'INFOHUB SOFTWARE DEVELOPERS INDIA PRIVATE LIMITED',
    'DKMS BMST FOUNDATION INDIA',
    'FOUNDATION FOR INNOVATION AND SOCIAL ENTREPRENEURSHIP',
    'RANG DE HABBA FAIR PRICE MARKET PLACE FOUNDATION',
    'GREEN DREAMS FOR THE PLANET FOUNDATION',
    'SURI FAMILY CHARITABLE FOUNDATION',
    'BURONEED SUPPLIES PRIVATE LIMITED',
    'WHITE MEDIAMARKETING PRIVATE LIMITED',
    'FACTORSHUB SOLUTIONS PRIVATE LIMITED',
    'FILMOTION MULTIMEDIA OPC PRIVATE LIMITED',
    'INAUTICAL SOFTWARE PRIVATE LIMITED',
    'SOCIAL CURRY INFORMATION SERVICES PRIVATE LIMITED',
    'OVUNQUE INNOVATIONS PRIVATE LIMITED',
    'REELIABLE COURIER & CARGO PRIVATE LIMITED',
    'JIA LEARNING PRIVATE LIMITED',
    'IPSTAR (INDIA) PRIVATE LIMITED',
    'GURUPRIYAM INNOVATION LABS PRIVATE LIMITED',
    'VITADE SERVICES PRIVATE LIMITED',
    'ARAMCO ASIA INDIA PRIVATE LIMITED',
    'DESANCO SOLUTIONS PRIVATE LIMITED',
    'NDP ADVISORY SERVICES (OPC) PRIVATE LIMITED',
    'NEWBEGINNING TECH SOLUTIONS PRIVATE LIMITED',
    'TANIESH POWER SOLUTIONS PRIVATE LIMITED',
    'TOWNLABOUR TECHNOLOGIES PRIVATE LIMITED',
    'INDVIA BIOTECHNOLOGIES PRIVATE LIMITED',
    'MAKERY LABS PRIVATE LIMITED',
    'B2K ANALYTICS PRIVATE LIMITED',
    'TASK INFRACON PRIVATE LIMITED',
    'VICEROY STUDIOS PRIVATE LIMITED',
    'ETERNITE ELEMENTS PRIVATE LIMITED',
    'ADWAGONS ADVERTISING PRIVATE LIMITED',
    'CONNUCT LIFESCIENCES PRIVATE LIMITED',
    'SHARP VENTURES PRIVATE LIMITED',
    'WITTYGAMES INDIA PRIVATE LIMITED',
    'INDIAN GIRL PRODUCTS AND DOLLS PRIVATE LIMITED',
    'SWORDFISH INTEGRATED ADVERTISING PRIVATE LIMITED',
    'BYNDR TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SYNERGY RAIL ENGINEERING PRIVATE LIMITED',
    'THINKWIDE SOLUTIONS & SERVICES PRIVATE LIMITED',
    'DARWINBOX DIGITAL SOLUTIONS PRIVATE LIMITED',
    'DR PRADEEP REDDY',
    'S PHARMACEUTICALS PRIVATE LIMITED',
    'I sat network engineers private limited',
    'Cikautxo india private limited',
    'Astha polymers private limited',
    'The vacuum forming company private limited',
    'A and r healthcare private limited',
    'Elan bio-ethicals private limited',
    'EVERGREEN FOODS AND SNACKS PRIVATE LIMITED',
    'Navratan polymers private limited',
    'Game plan sports private limited',
    'GRAHAM BLOWPACK SOLUTION PRIVATE LIMITED',
    'Kaushik polymers private limited',
    'Panexcell clinical lab private limited',
    'Savera mouldings private limited',
    'Creative components private limited',
    'Cello household appliances private limited',
    'Assorted plastics private limited',
    'Ams medical systems private limited',
    'Hps laboratories private limited',
    'Verve health care limited',
    'Kronokare cosmetics private limited',
    'Adhere bonds coats private limited',
    'Patel plastic bags private limited',
    'Emerald plastomers private limited',
    'Radiant plastic industries private limited',
    'Easyflo polymer engineers pvt ltd',
    'Jayfil polymers private limited',
    'Thilagarathinam match works private limited',
    'Mittal technopack private limited',
    'Arihant safe glass private limited',
    'HNTI LIMITED',
    'Astinum india private limited',
    'Icmc corporation limited',
    'Dokania overseas private limited',
    'R.d. clay mines private limited',
    'Subarnarekha port private limited',
    'Vensar projects private limited',
    'Bharat road network limited',
    'Red power private limited',
    'Shanivi moore drilling private limited',
    'Navkar infraprojects private limited',
    'Apostle buildcon private limited',
    'VIVEKANAND YOGASHRAM PRIVATE LIMITED',
    'Grass field fire capital developers private limited',
    'Navjeevan wires and cables private limited',
    'Gehra hydro power private limited',
    'Mourya realty venture india private limited',
    'Finetech parkcon india private limited',
    'Jainsons buildcon private limited',
    'Eros retail private limited',
    'DDAMOT PRIVATE LIMITED',
    'Vision2020 arcade private limited',
    'Monte carlo developers private limited',
    'Bajrang engineers pvt ltd',
    'KARVEER NIVASINI MAHALAXMI BUILDERS & DEVELOPERS LIMITED',
    'S V SANGHVI TRANSTRADE TECHNO PRIVATE LIMITED',
    'Carcanet infra projects private limited',
    'Cri infrastructures (india) private limited',
    'Kripalu projects private limited',
    'Nigadi land development company private limited',
    'Green assets mahadevapura private limited',
    'Nurture projects private limited',
    'WHIZ INVESTMENTS PRIVATE LIMITED',
    'Om infraconstruction limited',
    'Enki retail solutions private limited',
    'NAMBI BUILDWELL LIMITED',
    'Urvasi infratech private limited',
    'ATHEROL BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Ras infra projects private limited',
    'E.B.I. CREMICA INDUSTRIES PRIVATE LIMITED',
    'Krisha shelter private limited',
    'Prg infrastructure private limited',
    'Ai development & management company private limited',
    'PATE DEVELOPERS PRIVATE LIMITED',
    'Brahma commercial ltd',
    'Skav developers private limited',
    'Om shanti infrastructure private limited',
    'Sixth dimension infrastructure limited',
    'Sanya property private limited',
    'Star erectors construction private limited',
    'H m k realties private limited',
    'Viva palghar realtors private limited',
    'Viva saarrthi infratech private limited',
    'Mks acme-build private limited',
    'Sureka merlin promoters private limited',
    'Grace colonizers private limited',
    'Agarsen buildcon private limited',
    'Navkar buildestates private limited',
    'Navkar promoters private limited',
    'Navkar buildwell private limited',
    'Navkar buildhome private limited',
    'Shubham samrudhi infra private limited',
    'Vgn infrastructure private limited',
    'Ncs estates private limited',
    'Amit realty private limited',
    'Orchid infracon private limited',
    'Emerald heights private limited',
    'Sha-san nirman private limited',
    'City mall vikash private limited',
    'Kmv realtors private limited',
    'Briddhi realcon limited',
    'Moonlike construction private limited',
    'Ayanna builders private limited',
    'Hayagreeva promoters private limited',
    'Epitome infrastructure private limited',
    'Sarra motors private limited',
    'Concept motors (india) private limited.',
    'St antony s motors india limited',
    'Ramani cars private limited',
    'Varun commercial vehicles private limited',
    'Singhal ventures private limited',
    'B v c security transportation private limited',
    'Lpf auto private limited',
    'Pit stop exclusive private limited',
    'Suparshwa constructions private limited',
    'Ilpa infrastructure development foundation',
    'Adani estates private limited',
    'Mitsui chemicals india private limited',
    'Tara machines and tech services private limited',
    'Cn homes private limited',
    'Easy builders private limited',
    'Value infrabuild india private limited',
    'Kamat construction private limited',
    'Transwind infrastructures limited',
    'Soma jabalpur rewa tollway private limited',
    'Frontier shelters private limited',
    'Lpf motors private limited',
    'Three t plus technologies private limited',
    'SHILLONG EXPRESSWAY PRIVATE LIMITED',
    'Sunrise assets private limited',
    'W r talwalker techno agencies pvt ltd',
    'Jai dada infrastructure private limited',
    'Yps developers private limited',
    'Cape engineers private limited',
    'Cargo motors (gujrat) private limited',
    'Maanav motors private limited',
    'For u services private limited',
    'Promega biotech india private limited',
    'Sumangal commodities private limited',
    'INDUS RAWMETALS PRIVATE LIMITED',
    'Maars infra developers private limited',
    'C r i amalgamations private limited',
    'Sakthi land holdings private limited',
    'Gaurav rose real estate pvt ltd',
    'Rujuta infrastructure private limited',
    'Rae real estate private limited',
    'Mrara real estate private limited',
    'Thane property management private limited',
    'DEOGHAR PROPERTIES & FINANCE PRIVATE LIMITED',
    'Ushasri estate developers private limited',
    'Tej bahadur properties private limited',
    'SREENIDHI SERENE SPACES INDIA PRIVATE LIMITED',
    'P s enclave private limited',
    'Sattva developers private limited',
    'Navrag plaza private limited',
    'Lagan nirman private limited',
    'AMEYA RESORTS & ESTATES PRIVATE LIMITED',
    'Vyas realties private limited',
    'Tridev buildmart private limited',
    'DECCAN ESTATES PRIVATE LIMITED',
    'Doshi developers and builders private limited',
    'Brahmaputra property hub private limited',
    'Triveni apartments private limited',
    'Valley view infrastructure private limited',
    'Dalhousie villa private limited',
    'Amon estates private limited',
    'Ubico developers private limited',
    'Barmalt infrastructure private limited',
    'Centurion real estate developers private limited',
    'Pyrite builders & constructions private limited',
    'Jingle builders & developers private limited',
    'Desine properties and consultancy private limited',
    'Createum serenity estates private limited',
    'Cardus projects private limited',
    'Deesan infrastructure private limited',
    'Prudential builders pvt ltd',
    'Siddhartha real estate private limited',
    'Hill top arcade private limited',
    'Khiranagar development private limited',
    'Trimudra real estates private limited',
    'Kolte-patil projects (mumbai) private limited',
    'Bajrang mansion private limited',
    'Moonview residency private limited',
    'Viewmore commodities private limited',
    'Navashakti realty developers private limited',
    'Blaize enclave private limited',
    'Baron promoters private limited',
    'Victory infraprojects private limited',
    'Homewell developers private limited',
    'Brahmaputra property care services private limited',
    'Supremus developers private limited',
    'Lifespace india private limited',
    'Unibera infraprojects private limited',
    'CA CIRCUIT TECHNOLOGIES PRIVATE LIMITED',
    'Prithvi developers private limited',
    'Value designbuild private limited',
    'Newton developers private limited',
    'Good time properties private limited',
    'Muktha foundations private limited',
    'Lookline distributors private limited',
    'RAILTRACK EQUIPMENTS SERVICES PRIVATE LIMITED',
    'Ramika construction private limited',
    'Aradhana housing private limited',
    'SEKOU CONSULTING PRIVATE LIMITED',
    'Open mind cadcam technologies india private limited',
    'Pelatro solutions private limited',
    'Icis computers (india) private limited',
    'Wellspring software labs private limited',
    'Maa devi shakumbhari solutions private limited',
    'Adirish heights private limited',
    'Thakur realty private limited',
    'MESMERIC REAL INFRA PRIVATE LIMITED',
    'Mgm infra development solutions private limited',
    'Maspar holdings private limited',
    'Sukarma technologies private limited',
    'Gharpure engineering and constructions private limited',
    'First opinions online solutions private limited',
    'RISING JAPAN TECHNOLOGIES PRIVATE LIMITED',
    'Ambojini property developers private limited',
    'Vishal softech private limited.',
    'Ameyatel computech private limited',
    'Piterion india private limited',
    'Vibes communications private limited',
    'Pearl beach promoters private limited',
    'Digitech media products private limited',
    'LARIKA FACILITY MANAGEMENT & SERVICES PRIVATE LIMITED',
    'Everstrong suppliers private limited',
    'Minica property holdings private limited',
    'Wardhman enclave ltd.',
    'Mural bulldozing pvt ltd',
    'Aspen material handling private limited',
    'Tied systems limited',
    'C-metric solutions private limited',
    'Acute informatics private limited',
    'Ors infotech private limited',
    'Navyug concrete foundation private limited',
    'Aequitas information technology private limited',
    'Natrix software private limited',
    'Varite india private limited',
    'Gerson lehrman group india private limited',
    'Vashisht infratech private limited',
    'Embassy real estate properties and holdings private limited',
    'Aakash systems private limited.',
    'Vanguard hr associates private limited',
    'Industrial techno man power supply & services private limited',
    'Emgee valuehomes (india) private limited',
    'Lotus refineries private limited',
    'Startrek holdings private ltd.',
    'Siddheshwari industries private limited',
    'Windsor infrastructure limited',
    'Sarv tech private limited',
    'Aasiana aerotech private limited',
    'Insight (india) private limited',
    'Sungrace security services private limited',
    'Tarini humanitarian demining & rehabilitation works',
    'Bala security services private limited',
    'Samvaad e-solutions private limited',
    'Konexions back office services private limited',
    'Jagsumi perspectives private limited',
    'Inter leaves private limited',
    'Indranagari conclave private limited',
    'Capital infoart private limited',
    'Greenport fashion export private limited',
    'Mikkymegha hospital private limited',
    'Stesso technology private limited',
    'CLIXTER PREPRESS PRIVATE LIMITED',
    'Monetic corp consultants private limited',
    'Iops business solutions private limited',
    'Lastmile solutions india private limited',
    'Wollaque projects private limited',
    '7 steps consultores private limited',
    'YASH KASH CAPITAL SERVICES PRIVATE LIMITED',
    'Rising star elevator private limited',
    'LOTUS ADVANCE TECHNOLOGIES PRIVATE LIMITED',
    'Vikramgeet investments and holdings private limited',
    'Ambu india private limited',
    'Indicraft communications india private limited',
    'Irp agri tech private limited',
    'Avicenna global enterprise (india) private limited',
    'Media moments insight private limited',
    'Acquity labs private limited',
    'STORK SYSTEMS & PROJECTS PRIVATE LIMITED',
    'Vrm energy consultancy services private limited',
    'Ticketgenie solutions private limited',
    'Ahalia alternate energy private limited',
    'Ecgc limited',
    'Meenul metallizing private limited',
    'Ansh infotech pvt.ltd.',
    'Rishraj filaments limited',
    'Telmark marketing private limited',
    'Shree chaitanya enterprises private limited',
    'Adsorbtech engineers private limited',
    'A2z applications.com private limited',
    'Primetex brands private limited',
    'Alemac electrical private limited',
    'Supreme bituchem india private limited',
    'Red fox protection services private limited',
    'Ve service private limited',
    'Miki pulley (india) private limited',
    'Early man film private limited',
    'Task masters advisors private limited',
    'Zenith vertical mobility solutions private limited',
    'STRADDLE INDUSTRIES PRIVATE LIMITED',
    'Kayenn integrated solutions private limited',
    'Fej facilities management private limited',
    'Maharashtra fastners private limited',
    'HITACHI ASTEMO FIE PRIVATE LIMITED',
    'Raay global investments private limited',
    'Tridiagonal solutions private limited',
    'Mansa facility management solutions private limited',
    'General repairs and maintenance company india private limited',
    'Chaitanya packagings pvt ltd',
    'Superfine print & pack private limited',
    'D. d. shah flavours private limited',
    'Av inventure labs private limited',
    'Nine star broking private limited',
    'RANGSONS MARKETING SERVICES PRIVATE LIMITED',
    'Blue jade texink private limited',
    'S v equipments private limited',
    'Violet event marketing (india) private limited',
    'W design studio private limited',
    'Gayatri global contracts private limited',
    'Murthy immigration services private limited',
    'DAY `N',
    'S FARMS AND RESORTS PRIVATE LIMITED',
    'Hotel jyotdeep palace private limited',
    'OPUS INFINITI SERVICES PRIVATE LIMITED',
    'Cognitive platform solutions private limited',
    'DELTAF TECHCOMM INDIA PRIVATE LIMITED',
    'CLOUDFOCUS SYSTEMS PRIVATE LIMITED',
    'Payoda technologies private limited',
    'Ecstasoft solutions tn private limited',
    'Vaagai technologies private limited',
    'Ero wide comm private limited',
    'Merrill financials ltd',
    'Ica edu skills private limited',
    'Dps technologies india private limited',
    'Happy informedia private limited',
    'Happy technology private limited',
    'Skymax information technologies private limited',
    'Allied infocom private limited',
    'Happy solutions private limited',
    'Neenomega intelligent solutions private limited',
    'Unix infosoft private limited',
    'Metalogic circuits (india) private limited',
    'Modern e-village limited',
    'Proficient infosoft private limited',
    'Innoraft solutions private limited',
    'A p art printers private limited',
    'Elixir computech private limited',
    'CONTINENTAL ADVANCE SYSTEM (INDIA) PRIVATE LIMITED',
    'Yantra technologies private limited',
    'Stowe software private limited',
    'Comptaax e software private limited',
    'Cumin infotech private limited',
    'Sukrit technologies private limited',
    'Nexus business solutions private limited',
    'Mechatech info systems private limited',
    'Netgen soft solutions private limited',
    'Dataformatics consultancy private limited',
    'Incalus technology solutions private limited',
    'Dysmech consultancy services private limited',
    'Inficare solutions private limited',
    'Trata e systems private limited',
    'D.s.m.soft private limited',
    'Allzone management solutions private limited',
    'Ccg technologies india private limited',
    'Naethra technologies private limited',
    'Saf imaging and solutions private limited',
    'Integrated netsoft systems private limited',
    'Noran soft private limited',
    'Accordians infocom private limited',
    'Amor luggage industries private limited',
    'Instyle solutions private limited',
    'Freeman i.t services private limited',
    'Decipher health solutions private limited',
    'Zinios engineering consultancy & training solutions private limited',
    'CLINIPACE CLINICAL RESEARCH PRIVATE LIMITED',
    'Enthralltech private limited',
    'DL TRAINING PRIVATE LIMITED',
    'Acute soft solutions india private limited',
    'CODENATIVES INDIA PRIVATE LIMITED',
    'Icfe skills solutions private limited',
    'Elita it solutions private limited',
    'Micronix infosolutions limited',
    'Dell soft technologies private limited',
    'Mts infonet media private limited',
    'Basawa technologies limited',
    'Multisoft infocom private limited',
    'Aditraj business solutions private limited',
    'Rr it solutions private limited',
    'Ajal business solutions private limited',
    'Shashwat web technologies private limited',
    'Gcell technologies private limited',
    'Periculum technology and consulting services private limited',
    'A k c webtech private limited',
    'Jnt technosoft private limited',
    'Creative business labs private limited',
    'Gromax technologies private limited',
    'Devarya infotech private limited',
    'Espy technologies private limited',
    'Menteso technologies private limited',
    'VIVO COLLABORATION SOLUTIONS LIMITED',
    'Brisk infonet private limited',
    'NR TECHNOSERVE PRIVATE LIMITED',
    'Fotografik enterprises private limited',
    'Words worth elt private limited',
    'A m infoweb private limited',
    'Unilex legal solution private limited',
    'Micro hard it solutions private limited',
    'Levons technologies private limited',
    'Intellial solutions private limited',
    'REBOOT SYSTEMS INDIA PRIVATE LIMITED',
    'Nimble informatics private limited',
    'Valiance solutions private limited',
    'Signage technology private limited',
    'Cues simplify it services private limited',
    'Swigcom technologies private limited',
    'Shooting star eservices private limited',
    'Westgate eservices private limited',
    'Whitepearl eservices private limited',
    'Yippster technologies private limited',
    'Rudravatar technology and devices private limited',
    'Foresee multi media private limited',
    'Ittiam media labs private limited',
    'Neil computech private limited',
    'Clarity information technologies private limited',
    'Mycomp infosolutions private limited',
    'Chie media private limited',
    'STHIRA TECHNOVATIONS PRIVATE LIMITED',
    'Kks tech solutions private limited',
    'GENEXT STUDENTS PRIVATE LIMITED',
    'Jai educity private limited',
    'International institute of media and entertainment private limited',
    'Apim educations private limited',
    'ST.MARY',
    'S EDUCATION AND RESEARCH NETWORK PRIVATE LIMITED',
    'ISUZU ENGINEERING BUSINESS CENTRE INDIA PRIVATE LIMITED',
    'CAPREFINDIA PRIVATE LIMITED',
    'WTP COST ADVISORY SERVICES INDIA PRIVATE LIMITED',
    'RAJAPUSHPA CORPORATE PRIVATE LIMITED',
    'MYKA GIFTING PRIVATE LIMITED',
    'ABOV HR PRIVATE LIMITED (OPC)',
    'SICAL SAUMYA MINING LIMITED',
    'MSC SERVICE CENTER INDIA PRIVATE LIMITED',
    'AFFERENT TECHNOLOGIES PRIVATE LIMITED',
    'BIOTEKNIX PRIVATE LIMITED',
    'MAGIC THRILLS & ADVENTURES PRIVATE LIMITED',
    'C&D TECH POWER SOLUTIONS (INDIA) PRIVATE LIMITED',
    'WELLGO LIFE FARMS PRIVATE LIMITED',
    'HELIX TECHNICAL SERVICES PRIVATE LIMITED',
    'BARANI DATA SOLUTIONS PRIVATE LIMITED',
    'WARRIOR MANAGEMENT SERVICES PRIVATE LIMITED',
    'INTEGRATED REGISTRY MANAGEMENT SERVICES PRIVATE LIMITED',
    'ARNAV MARITIME PRIVATE LIMITED',
    'CASA GRANDE MILESTONE PRIVATE LIMITED',
    'AEROX DIGITAL CINEMAS PRIVATE LIMITED',
    'CASAGRAND STAYLOGY PRIVATE LIMITED',
    'CVR AIRCON PRIVATE LIMITED',
    'RANGA ELECTRICALS PRIVATE LIMITED',
    'BERRY N BLOSSOM THE PASTRY LAND PRIVATE LIMITED',
    'DISCOVER IMPORT AND EXPORT PRIVATE LIMITED',
    'PUDUKOTTAI GREEN POWER PRIVATE LIMITED',
    'BELL NETWORKS PRIVATE LIMITED',
    'ADROIT CLINICALS PRIVATE LIMITED',
    'KALLAL PICKFORD MARKETING PRIVATE LIMITED',
    'TRESARA HEALTH LIMITED',
    'PRESIDIO ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'GALILEO SHIP MANAGEMENT & TRAVELS PRIVATE LIMITED',
    'TECHNOPUNDITS KNOWLEDGE SOLUTIONS PRIVATE LIMITED',
    'JAI SAKTHI IT GROUP PRIVATE LIMITED',
    'DEVESH MOTORS PRIVATE LIMITED',
    'ANSIKA TRADING PRIVATE LIMITED',
    'GYSO ECOM SERVICES PRIVATE LIMITED',
    'V R DELLA IT SERVICES PRIVATE LIMITED',
    'DADHA PHARMA DISTRIBUTION LIMITED',
    'SHOPHOLIX MARKETING SERVICES PRIVATE LIMITED',
    'SEAFIX MARINE PRIVATE LIMITED',
    'SVA COUTURE PRIVATE LIMITED',
    'PATARA COLLECTIONS PRIVATE LIMITED',
    'ALL INDIA SOLAR INDUSTRIES ASSOCIATION',
    'SHARP INSTITUTE OF INDIVIDUAL AND ORGANISATIONAL DEVELOPMENT OPC PRIVATE LIMITED',
    'ROADPIPER TECHNOLOGIES PRIVATE LIMITED',
    'VIRTUAL VEDA PRIVATE LIMITED',
    'KAUSHALYA BRAND COMMUNICATIONS OPC PRIVATE LIMITED',
    'URBAN POD PRIVATE LIMITED',
    'BLACK WHITE ORANGE BRANDS PRIVATE LIMITED',
    'LIGHTHOUSE TECHNOLOGIES PRIVATE LIMITED',
    'CONTAGIOUS ONLINE MEDIA NETWORK PRIVATE LIMITED',
    'GROWBY EXX RESEARCH FOUNDATION',
    'INNOFIN SOLUTIONS PRIVATE LIMITED',
    'VCS GLOBAL CONSULTANTS PRIVATE LIMITED',
    'BLUE RIBBON BAGS (INDIA) PRIVATE LIMITED',
    'PASSION PLAY INDIA PRIVATE LIMITED',
    'IBJA GOLD PRIVATE LIMITED',
    'PLAYERZPOT MEDIA PRIVATE LIMITED',
    'TECHMERCH INNOVATIONS PRIVATE LIMITED',
    'IBJA JEWELS PRIVATE LIMITED',
    'PROTECH GLOBAL SERVICES PRIVATE LIMITED',
    'INSPIRE CLEAN ENERGY PRIVATE LIMITED',
    'ELEGANT MARK ENGINEERING PRIVATE LIMITED',
    'STRABOAPP TECHNOLOGIES PRIVATE LIMITED',
    'LTH MILCOM PRIVATE LIMITED',
    'INVESTDIRECT CAPITAL SERVICES PRIVATE LIMITED',
    'TRI ACE SOLUTIONS & SERVICES PRIVATE LIMITED',
    'SPRNG SURYODAY ENERGY PRIVATE LIMITED',
    'MEDEVICE MANUFACTURING INDIA PRIVATE LIMITED',
    'RISOLVE IT SOLUTIONS PRIVATE LIMITED',
    'EASYLINK TRAVEL SERVICES PRIVATE LIMITED',
    'JSR LEGAL TIPSTER PRIVATE LIMITED',
    'POWERFLEX ELECTRO PRIVATE LIMITED',
    'VC- SPECIALIZED TECHNOLOGY SERVICES PRIVATE LIMITED',
    'VERSALLIES BIOTECH PRIVATE LIMITED',
    'ACORN FUND CONSULTANTS PRIVATE LIMITED',
    'LIBERIUM RESOURCES PRIVATE LIMITED',
    'JNM FOREX PRIVATE LIMITED',
    'FORZA LOGISTICS TECHLABS PRIVATE LIMITED',
    'ANUPTECH SKILL DEVELOPMENT CENTRE PRIVATE LIMITED',
    'CAT MARKETING SOLUTIONS PRIVATE LIMITED',
    'I M WAY DIRECT MARKETING PRIVATE LIMITED',
    'ACROSS GLOBE HOLIDAYS PRIVATE LIMITED',
    'ADOROI TECH VENTURES PRIVATE LIMITED',
    'QUICKSOFTPRO IT SOLUTIONS PRIVATE LIMITED',
    'WRITER GALAXY FILM PRODUCTIONS PRIVATE LIMITED',
    'ECLICK VENTURES PRIVATE LIMITED',
    'CANVAS TALENT PRIVATE LIMITED',
    'FAIRTECH ENGINEERS INDIA PRIVATE LIMITED',
    'SAMAAJSCOPE FILMS PRIVATE LIMITED',
    'EXICON HOLDING PRIVATE LIMITED',
    'HAPPY GAANA ENTERTAINMENT PRIVATE LIMITED',
    'NEUROBYTE VENTURES PRIVATE LIMITED',
    'RUMI ECO PRODUCTS PRIVATE LIMITED',
    'AMBERG INFOCON PRIVATE LIMITED',
    'RAYON ILLUMINATIONS AND ENERGY SOLUTIONS PRIVATE LIMITED',
    'DMA PROJECTS PRIVATE LIMITED',
    'NS TECHNICAL CONSULTANCY PRIVATE LIMITED',
    'AIRAWORLD SERVICES PRIVATE LIMITED',
    'G G MARINE CONTAINERS PRIVATE LIMITED',
    'VIRTUOSO OPTOELECTRONICS LIMITED',
    'AAVI MEDICARE PRIVATE LIMITED',
    'VIDHARBHA MULTIDIMENSIONAL BUSINESS VENTURE PRIVATE LIMITED',
    'PEP TECHNOLOGIES PRIVATE LIMITED',
    'EASY ROADS TECHNOLOGIES PRIVATE LIMITED',
    'SVATANTRA ONLINE SERVICES PRIVATE LIMITED',
    'JMBAXI INCUBATORS PRIVATE LIMITED',
    'NANODX HEALTHCARE PRIVATE LIMITED',
    'MYGENNIE SERVICES PRIVATE LIMITED',
    'TOUCH MEDICAR SERVICES PRIVATE LIMITED',
    'MENTERRA VENTURE ADVISORS PRIVATE LIMITED',
    'ZAP INFOLABS PRIVATE LIMITED',
    'PANOPTIC SOLUTIONS PRIVATE LIMITED',
    'MR FIELDWORK AND RESEARCH PRIVATE LIMITED',
    'EUREKAMAKERS WELLNESS PRIVATE LIMITED',
    'AGRO ENERGY AND COMMODITIES PRIVATE LIMITED',
    'PINEWORLD LEARNING SOLUTIONS PRIVATE LIMITED',
    'DSQUARE TECHNOLOGIES PRIVATE LIMITED',
    'VENTURE CATALYSTS PRIVATE LIMITED',
    'VERSALLIES LIFE SCIENCES PRIVATE LIMITED',
    'PENTACLE TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'SOULVIGOUR WELLNESS PRIVATE LIMITED',
    'OCEALAND LOGISTICS INDIA PRIVATE LIMITED',
    'OPUS MARINE SERVICES PRIVATE LIMITED',
    'MYRNA INFOTECH PRIVATE LIMITED',
    'SFA SPORTING SERVICES PRIVATE LIMITED',
    'SUPERSHEET STEEL PROFILE PRIVATE LIMITED',
    'SYMLUX PHARMACEUTICALS PRIVATE LIMITED',
    'AHIL MANUFACTURES PRIVATE LIMITED',
    'SHASHANK MEHENDALE ENGINEERS PRIVATE LIMITED',
    'DIVYASHAKTI VENTURE PARTNERS PRIVATE LIMITED',
    'BQ DIGITAL LEARNING PRIVATE LIMITED',
    'PARSHVA MEDICARE PRIVATE LIMITED',
    'COMMUNITY TRIPVER PRIVATE LIMITED',
    'SHOUT NETWORKING PRIVATE LIMITED',
    'DRIVEON CAR RENTALS PRIVATE LIMITED',
    'ONE WALLET SOLUTIONS PRIVATE LIMITED',
    'PCGEEKSQUAD GLOBAL SERVICES PRIVATE LIMITED',
    'MRUNALINI B. KOTAK SERVICES PRIVATE LIMITED',
    'FFS INNOVATION PRIVATE LIMITED',
    'KLA MANAGEMENT CONSULTANTS PRIVATE LIMITED',
    'BERRY',
    'S ENDO INFERTILITY AND HOSPITAL PRIVATE LIMITED',
    'Qed clinical services india private limited',
    'Retina foundation hospitals private limited',
    'Devi super speciality eye hospital private limited',
    'Centralab healthcare services private limited',
    'HOTEL LALAJI',
    'Ucil synchem private limited',
    'Ajinkya chemtech private limited',
    'Sai quest syn private limited',
    'Wafe auxiliary chemicals private limited',
    'E-corp advisors (india) private limited',
    'Electron industries limited',
    'New heaven chemicals limited',
    'Rank additives private limited',
    'A j organica private limited',
    'Sarweshwar polymer pvt ltd',
    'Secure industries private limited',
    'Ital plastic compounds private limited',
    'Daulat financial services pvt ltd',
    'LYVEX MEDICAL DEVICES PRIVATE LIMITED',
    'Emarson chemicals private limited',
    'Zsivira chemie merk private limited',
    'Voisin consulting private limited',
    'Haoma health care private limited',
    'Clinnovo research labs private limited',
    'Saarum sciences private limited',
    'Supreme surfactants private limited',
    'N.r. colours limited',
    'Standard ganpati manufacturing company private limited',
    'Isha natural & herbal products private limited',
    'T a majeed s fair pharma private limited',
    'Airier natura private limited',
    'SYNERGY HEALTH SCIENCES PRIVATE LIMITED',
    'JADE NATURALS PRIVATE LIMITED',
    'Sai aromas pvt ltd',
    'Spinco biotech private limited',
    'High performance products industries private limited',
    'Sudhakar pvc products private limited',
    'Ashutosh rubber private limited',
    'ARIHANT POLYPLAST PRIVATE LIMITED',
    'STRECKEN INDIA MANUFACTURING PRIVATE LIMITED',
    'Arihant gold plast private limited',
    'Indu thermoformers private limited',
    'UMG SOLUTIONS PRIVATE LIMITED',
    'Aristoplast products private limited',
    'Veka india private limited.',
    'EXXARO TILES LIMITED',
    'Revok ceramic private limited',
    'Mahajeet bentosil private limited',
    'Sandip cements private limited',
    'Dubond silicon private limited',
    'SVG INTERNATIONAL PRIVATE LIMITED',
    'Miraj drymix private limited',
    'Satyay technocast private limited',
    'Ramkorp steel tech private limited',
    'Ima-pg india private limited',
    'Sarda pipes and fittings private limited',
    'New savera projects private limited',
    'Hanwa india private limited',
    'Shri sharma steeltech (india) private limited',
    'Hampson industries private limited',
    'RADHA SMELTERS PRIVATE LIMITED',
    'Fortune foundries private limited',
    'Superproof seals engineering private limited',
    'Wahl india grooming products private limited',
    'Jsp aluminium private limited',
    'Unifab engineering project private limited',
    'Oakens engineering services private limited',
    'Devgiri forgings private limited',
    'Liquipack systems private limited',
    'Akarsh steel enterprises private limited',
    'Hitesh steel syndicate (india) private limited',
    'JSW MI CHENNAI STEEL SERVICE CENTER PRIVATE LIMITED',
    'Forgepro india private limited',
    'Transit geo system integrators private limited',
    'Prg agitators private limited',
    'Enereco engineering private limited',
    'Makson sheet metal fabrication private limited',
    'Aquascape engineers private limited',
    'Our web studio software solutions private limited',
    'Adroit infrastructure services private limited',
    'IBUILD INNOVATIONS INDIA PRIVATE LIMITED',
    'Novellsys technologies private limited',
    'Nsight solutions private limited',
    'Velcom erp it sourcing private limited',
    'Gboom software private limited',
    'Mego technologies private limited',
    'Sentinel technologies private limited',
    'Eumaxindia private limited',
    'Duluth software services private limited',
    'Primetech communications private limited',
    'Bio-vision secure solutions private limited',
    'ROXTON ELECTRONICS PRIVATE LIMITED',
    'Insforia technologies private limited',
    'Icbio clinical research private limited',
    'Sci - molecules india private limited',
    'Intellibridge consulting private limited',
    'Sapien biosciences private limited',
    'Resilience advisory services private limited',
    'Nlp labs private limited',
    'Zoyaksa consultants private limited',
    'JBG ORGANISATION PRIVATE LIMITED',
    'Boston financial advisory group private limited',
    'Jwr logistics private limited',
    'Magicrot industrial services private limited',
    'Octave project management private limited',
    'Yukon capital services private limited',
    'Aparna infraenergy india private limited',
    'Omshilpi jewels and gems private limited',
    'Dayal hosiery private limited',
    'One network entertainment private limited',
    'Teamswift projects private limited',
    'Jkw chemicals private limited',
    'Ensepatec india private limited',
    'Euro diesel trading private limited',
    'Iris reps india private limited',
    'Scentiments beauty private limited',
    'ARG REALTY SOLUTIONS PRIVATE LIMITED',
    'Kanav retail solutions private limited',
    'Fire fighting force (india) private limited',
    'Genuus brand advisory private limited',
    'Beti association - charity for women',
    'The euroindia centre (india)',
    'Hoture media private limited',
    'Lovechildren films private limited',
    'Old monk entertainment private limited',
    'Castle studio private limited',
    'Tyre grip private limited',
    'Bsn corporate advisory services private limited',
    'Crossborders eie services private limited',
    'Innovative retail concepts private limited',
    'Bci management systems private limited',
    'Utrust india advisors private limited',
    'Fermion business solution private limited',
    'Uniserve solutions private limited',
    'SAUMYA ORTHOCARE PRIVATE LIMITED',
    'Ad professionals private limited',
    'Smart grid private limited',
    'Defy manpower management private limited',
    'Pearlpro consultancy private limited',
    'Venu consultants private limited',
    'HOLISTIC HR &SECURITY PRIVATE LIMITED',
    'Indus scholastic and management services private limited',
    'S j company consultants private limited',
    'Yukthi consulting services private limited',
    'Hireatease consulting private limited',
    'STELIS BIOPHARMA LIMITED',
    'Arrow devices private limited',
    'Boston financial advisory services private limited',
    'Floraison india strategic consulting private limited',
    'Peoplelogic business solutions private limited',
    'Aneja management consultants pvt ltd',
    'Astute consulting private limited',
    'DELTA GLOBAL ALLIED LIMITED',
    'Antique entertainment private limited',
    'Principal consulting (india) private limited',
    'Cyber active technologies (india) private limited',
    'Anz capital private limited',
    'Scan gerencia private limited',
    'Ruchika investment consultancy private limited',
    'V3 management consultant private limited',
    'Ayuvardhan project consultants private limited',
    'Techsource services private limited',
    'Rsm astute consulting (chennai) private limited',
    'Csi esecure consulting private limited',
    'Rsm astute consulting plus private limited',
    'Eight Roads Investment Advisors Private Limited',
    'Morpheus human consulting private limited',
    'SYNERGY FINMART PRIVATE LIMITED',
    'Prima nexus relationship management private limited',
    'Oman india joint investment fund - management company private limited',
    'Primove infrastructure development consultants private limited',
    'C.v. kand consultants private limited',
    'Crux ora representation & advisory services private limited',
    'Trans india business solutions private limited',
    'Wind world wind farms (chitradurga) private limited',
    'Ample technologies private limited',
    'Abhinav systech private limited',
    'Udgam solutions private limited',
    'Unique creations imex private limited',
    'Bunts exports pvt ltd',
    'Girilon exports private limited',
    'SATELLITE GAZEBO DEVELOPERS Private Limited',
    'Yap marketing private limited',
    'Blau-i merchandising private limited',
    'Magpie global limited',
    'Ge power services (india) private limited',
    'Kamran exports private limited',
    'Dimic technologies private limited',
    'Vedant industrial systems and automation private limited',
    'Wild dreams trading company private limited',
    'SUPERSONIC IT MERCANTILE PRIVATE LIMITED',
    'Deserve exim private limited',
    'Inventure wealth management limited',
    'Precious orthopedics private limited',
    'Gospell digital technology private limited',
    'Vilsons distributors private limited',
    'Euchner (india) private limited',
    'Fire trix engineering & systems private limited',
    'Professional copier services india private limited',
    'Sma creations private limited',
    'Techflow enterprises private limited',
    'Earth loaf artisan and raw private limited',
    'Market men - consumer connect & events private limited',
    'World kitchen (india) private limited',
    'Hibiscus retail private limited',
    'Aietos exim private limited',
    'Hitachi india private limited',
    'Candy enterprises private limited',
    'Nimble ventures private limited',
    'Unique garments exports private limited',
    'KENNY',
    'S TRENDZ PRIVATE LIMITED',
    'Finfoot lifestyle private limited',
    'Brg industries private limited',
    'Kundali jewels (india) private limited',
    'Graviss retail private limited',
    'Delhi duty free services private limited',
    'Hannover milano fairs india private limited',
    'Daffy deals private limited',
    'Leon hospitality private limited',
    'Marijay resorts private limited',
    'Country retreat confernce private limited',
    'Good living plaza private limited',
    'Nirwana hotels and resorts private limited',
    'ECOSERVE FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'Kalinga hotels private limited',
    'Highway king hotels private limited',
    'Tanvi properties and developers private limited',
    'Graviss restaurants private limited',
    'Drl cargo carriers private limited',
    'Se freight and logistics india private limited',
    'Apple marine management private limited',
    'Skyteam logistic private limited',
    'Superb travel desire private limited',
    'Chipsan aviation private limited',
    'Afco logistics private limited',
    'Saicon marine services private limited',
    'Vacations imperus private limited',
    'Falcon container freight station private limited',
    'Sagar logistics (india) private limited',
    'D. r. kulkarni logistics private limited',
    'Brown bull logistics private limited.',
    'Airogo logistics private limited',
    'Shubasree logistics private limited',
    'Omega shipping agencies private limited',
    'Success shipping services (chennai) private limited',
    'Impero stores private limited',
    'Acfa logistics private limited',
    'Celebi nas airport services india private limited',
    'Bengal tiger line (india) private limited',
    'R. k. vacations private limited',
    'Fiesta vacations private limited',
    'ALLIED EXPRESS PRIVATE LIMITED',
    'Kabir travels private limited',
    'Leading edge - travel management private limited',
    'I p integrated services private limited',
    'Al-azam tours and travels india private limited',
    'SRI VARUN LOGISTICS PARK PRIVATE LIMITED',
    'Moonstar shipping and forwarding private limited',
    'Omega shipping pvt ltd',
    'Tapashvi freight forwarders pvt ltd',
    'Triton logistics and maritime private limited',
    'ASP SHIPS INDIA PRIVATE LIMITED',
    'Oasis shipping private limited',
    'Fendercare marine omega india private limited',
    'Maruti terminals private limited',
    'Poseidon shipping agency private limited',
    'Sagarship logistics private limited',
    'Image global travels private limited',
    'Arka aerosail logistics private limited',
    'SATELLITE DEVELOPERS Private Limited',
    'Kawaken sterling surfactants private limited',
    'Ssrs trading & manufacturing private limited',
    'Stanrose envirotech india private limited',
    'Bal endura building products private limited',
    'Ajanta foams private limited',
    'Saimahalakshmi rubber products private limited',
    'Deepak poly-plast private limited',
    'Sarovar polymers private limited',
    'Parkesine impex private limited',
    'Polyplastics marketing (india) private limited',
    'Vivid plastics private limited',
    'NARAYANI PLASTICS PRIVATE LIMITED',
    'Torrecid india private limited',
    'Itaca ceramic private limited',
    'Veruno india private limited',
    'Apidor abrasive products private limited',
    'Ronak rocks private limited',
    'Arihant technocast india private limited',
    'Sunmet holdings india private limited',
    'Surabhi shelters private limited',
    'Trident architectural aluminium products private limited',
    'Waterfront geo-solutions private limited',
    'Arya metacast private limited',
    'BRIJWASI PLASTIC PRIVATE LIMITED',
    'HENSEL INDIA PRIVATE LIMITED',
    'Samrat irons private limited',
    'Alutech foundry india private limited',
    'Mero asia pacific engineering private limited',
    'Sathyam steel roof structures limited',
    'Umicore india private limited',
    'Evergreen seamless pipes & tubes private limited',
    'Dins technologies private limited',
    'Intermetal engineers ( india ) private limited',
    'R.c. das engineering private limited',
    'Shayona industries private limited',
    'Hermes chem impex private limited',
    'Avon pharma machines private limited',
    'Fluid controls pvt ltd',
    'Daksh in-situ machining private limited',
    'Narmada rings private limited',
    'Krishna grain systems private limited',
    'Silwin winches india private limited',
    'Prakhyath machines & machine tools private limited',
    'Autonum controls private limited',
    'Microcool systems private limited',
    'Vasu infosec private limited',
    'Kew engineering and manufacturing private limited',
    'Hydroma india private limited',
    'Saimach pharmatech private limited',
    'Unity controls private limited',
    'Yg cutting tools corporation private limited',
    'X limitz adventure world private limited',
    'Excel die casters private limited',
    'Supreme polytech private limited',
    'THERMAX BABCOCK & WILCOX ENERGY SOLUTIONS LIMITED',
    'Broachcutter drilling machines private limited',
    'Fabmax pipe fabrication machines private limited',
    'Kyowa castec india private limited',
    'Mmd heavy machinery (india) private limited',
    'Wipro kawasaki precision machinery private limited',
    'Aguapuro equipments private limited',
    'Kristron controls & systems private limited',
    'Pioneer intertrade private limited',
    'V-max plate fabrication machines private limited',
    'Nictech engineering private limited',
    'Kp tech machine (india) private limited',
    'Olaer fawcett christie hydraulics (india) private limited',
    'GARRETT MOTION TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'Anand machinery (india) private limited',
    'Htl aircon private limited',
    'Ren-en-gen solutions private limited',
    'Pacific citi fone deals private limited',
    'Turnkey infotech solutions private limited',
    'Infoton systems and services pvt ltd',
    'Klassic softtech private limited',
    'Alan electronic systems private limited',
    'Snyder energo private limited',
    'Associated cables private limited',
    'Helukabel india private limited',
    'Astron plastic industries private limited',
    'Jmd heating ventilation and air conditioning private limited',
    'Everlight electronics india private limited',
    'Scaletec mechatronics private limited',
    'THINK METIME PRIVATE LIMITED',
    'V.n.distributions private limited',
    'Sterling electro enterprises private limited',
    'Laser sos (india) private limited',
    'Nuflux electromagnetics private limited',
    'Origin hak communications private limited',
    'Hari krushna machinetech private limited',
    'Global ophthalmic private limited',
    'Ambre watches india private limited',
    'LEGALJINI CORPORATE SERVICES PRIVATE LIMITED',
    'B h services (india) private limited',
    'Nepa production india private limited',
    'Ccl consultants (india) private limited',
    'Anderson business solutions private limited',
    'Satellite technologies private limited',
    'Infobip india private limited',
    'Gs engineering & construction mumbai private limited',
    'Lloyds luxuries limited',
    'Mhatre spices india private limited',
    'CONSTELLATION BLU ADVISORY PRIVATE LIMITED',
    'Crystal hiring private limited',
    'Thinkpoint brand solutions private limited',
    'Aneya foundries private limited',
    'Antardhrishti consulting private limited',
    'Gulmohar pack-tech india private limited',
    'Sensa core medical instrumentation private limited',
    'Fortuna port services private limited',
    'APLUS SEARCH TEAM PRIVATE LIMITED',
    'Y-axis business services india private limited',
    'Lean back concierge services private limited',
    'KYOKUTO BOEKI INDIA PRIVATE LIMITED',
    'Freight works india private limited',
    'Servernet services private limited',
    'Quest container line private limited',
    'C. s. n. enterprise private limited',
    'Gateway institute & recruitment services private limited',
    'Saraf gurukul private limited',
    'Vawe institutes private limited',
    'Clood on learning private limited',
    'ANIRUDDHA TELEMETRY SYSTEMS PRIVATE LIMITED',
    'TEAMLEASE EDTECH LIMITED',
    'Peterkins educational solution private limited',
    'S.g.r.s academic private limited',
    'H r d diamond institute private limited',
    'Saraswati educare foundation',
    'RUSSELL',
    'S HABIB HOSPITAL PRIVATE LIMITED',
    'Kidney care lab private limited',
    'Rt-medibus technologies private limited',
    'Akshaya scientifics private limited',
    'Somatheeram health resort india private limited',
    'Somatheeram hill valley resort private limited',
    'Banyan sustainable waste management private limited',
    'Satellite foundation',
    'The association of planters of kerala',
    'Sandeep sekhar films private limited',
    'Shakuntalam telefilms private limited',
    'Famous digital studios private limited',
    'Origin picture studioz private limited',
    'Hobitute art and media services private limited',
    'Em publishing private limited',
    'Abundantia entertainment private limited',
    'Nevanta media technologies private limited',
    'Three d entertainment private limited',
    'Mumbai music institute private limited',
    'Play arena sports and adventure private limited',
    'Yeshwant entertainment and investment pvt ltd',
    'Prizm club limited',
    'Om reels bioscope private limited',
    'Lordcultural resources private limited',
    'Film heritage foundation',
    'Foundation for promotion of sports and games',
    'Opulence business solutions private limited',
    'Skc environ lab private limited',
    'Stresstech bharat private limited',
    'Clean max energy ventures private limited',
    'Dynacom tankers management private limited',
    'Sandhya consultancy services private limited',
    'Neo quant solutions private limited',
    'Healthquarters india private limited',
    'Mirage retails private limited',
    'Talentmetrix & consulting private limited',
    'Lord gautam charitable foundation',
    'Hr chambers outsourcing private limited',
    'Indus uth hf mixing systems private limited',
    'Kalpana struct con private limited',
    'Omega ag seeds punjab limited',
    'Olympia industries limited',
    'Control print limited',
    'Global e-business operations private limited',
    'Fusionstor technologies private limited',
    'Tech worldwide support private limited',
    'Inginit technology private limited',
    'Vega solutions private limited',
    'Strugence business platforms private limited',
    'CLOUD ENERGY SOFTWARE PRIVATE LIMITED',
    'Saturo technologies private limited',
    'Rxindia remedies private limited',
    'M.m.imagine technologies private limited',
    'Verizon data services india private limited',
    'Advantage strategic consulting private limited',
    'Pride technologies consulting (india) private limited',
    'Sms country networks private limited',
    'Kosuri softlabs private limited',
    'Dreamland innovative solutions private limited',
    'Raygain technologies private limited',
    'Easyway 3e solutions private limited',
    'Eximius infotech private limited',
    'Ni systems (india) private limited',
    'Cahead info technologies india private limited',
    'C7 infotech private limited',
    'Toolagen technology services private limited',
    'Iglulabs software private limited',
    'Omniscient perspectives private limited',
    'PROTEAN EGOV TECHNOLOGIES LIMITED',
    'RWS MORAVIA INDIA PRIVATE LIMITED',
    'Aveva information technology india private limited',
    'BLUE LOTUS COMMUNICATIONS (EAST) PRIVATELIMITED',
    'Dcpl compuwiz private limited',
    'Crux digital private limited',
    'PLADA INFOTECH SERVICES LIMITED',
    'Nevpro business solutions private limited',
    'Aakash innovations and designs private limited',
    'Converged data technologies private limited',
    'Krawler information systems private limited',
    'Sublime information technologies limited',
    'Indotech industrial solutions private limited',
    'Xena technologies private limited',
    'Sparc cybertech private limited',
    'Tabcaps softtech private limited',
    'Zanec soft tech private limited',
    'Geotech informatics private limited',
    'Palsana enviro protection limited',
    'Silis labs private limited',
    'Mathatech private limited',
    'MEDTRONIC ENGINEERING AND INNOVATION CENTER PRIVATE LIMITED',
    'D code research services private limited',
    'Vel research & analytics private limited',
    'Satvam consulting private limited',
    'Innovar consultancy private limited',
    'THINKWEB SOLUTIONS PRIVATE LIMITED',
    'Ist oldham instruments india private limited',
    'Cru analysis and consulting (india) private limited',
    'Perpetuuiti technosoft services private limited',
    'Buffer logistics (india) private limited',
    'Brandenburg (india) private limited',
    'Interactive avenues digital marketing private limited',
    'R.c.advertising co private limited',
    'Sai krishna employment bureau private limited',
    'Thinktub digital media private limited',
    'Liebherr appliances india private limited',
    'Emnet lighting solutions private limited',
    'Mount nathan advisors private limited',
    'Flogis supply chain solutions private limited',
    'CKP LEISURE LIMITED',
    'Spm consultants private limited',
    'Fertinvest services private limited',
    'The ultra outdoors private limited',
    'Sub zero insulation technologies private limited',
    'North star marine (india) private limited',
    'Gurukul sports international private limited',
    'ALBACORE ACCOUNTING SERVICES PRIVATE LIMITED',
    'NEVA INNOVATION LABS PRIVATE LIMITED',
    'Mgr consultancy services private limited',
    'Laurent and benon management consultants limited',
    'LI Consulting Private Limited',
    'Kai manufacturing india private limited',
    'LI ENTERPRISES PRIVATE LIMITED',
    'Vpersist corporate solutions private limited',
    'SNAP OFFICES PRIVATE LIMITED',
    'Algorithm investments services private limited',
    'Businesshubs consulting india private limited',
    'Vilangat xavier jose consulting private limited',
    'Sanjwin consulting solutions private limited',
    'Ajwin consulting solutions private limited',
    'CUBKINS PRODUCTS PRIVATE LIMITED',
    'Exemplar systems private limited',
    'Broadcast consultancy services (india) private limited',
    'Dialog (india) services private limited',
    'Iiml asset advisors limited',
    'Affluence advisory private limited',
    'Il&fs portfolio management services limited',
    'Turmeric advisory private limited',
    'Exalio consulting private limited',
    'Crew republica retail limited',
    'Vm retail private limited',
    'Brg international private limited',
    'Bik maark international marketing private limited',
    'Kothamangalam aggregates private limited',
    'Twamev export private limited',
    'Meridian tracking private limited',
    'Ishaan gems private limited',
    'Xpeedas industrial automation technologies private limited',
    'Ecomantra nature adventures private limited',
    'Falcon resort (india) private limited',
    'Kss koncept living private limited',
    'Chartered hotels pvt ltd',
    'IRIS HEIGHTS PRIVATE LIMITED',
    'Bombay duck dining company private limited',
    'Parampara constructions private limited',
    'Ahs hospitality india private limited',
    'Aruma hotels private limited',
    'Yamuna trans logistics private limited',
    'Ifc universal express private limited',
    'Gaf global logistics private limited',
    'Alstom transport india limited',
    'Icf shipping private limited',
    'Drs marine services private limited',
    'SUNTECH CREW MANAGEMENT PRIVATE LIMITED',
    'Shanti clearing agency private limited',
    'Priyablue shipping private limited',
    'Rafat logistics private limited',
    'Mars movers private limited',
    'Flyjac logistics private limited',
    'Mwf logistics limited',
    'EASTERN SUPPLYCHAIN AND LOGISTICS LIMITED',
    'Premier people logistic solutions private limited',
    'Renuka logistics (india) private limited',
    'SHRI SAI SHRADDHA CARGO PRIVATE LIMITED',
    'Pan asia logistics india private limited',
    'Welspun logistics limited',
    'Airlift freight forwarders private limited',
    'Kriji marine logistics private limited',
    'Triton cold chain & logistics services private limited',
    'Durai shipping and services private limited',
    'Trusted corporate solutions private limited',
    'Shree shyam travels private limited',
    'Assured hospitality services private limited',
    'Shree kala tours & travels private limited',
    'Jasmine logistics private limited',
    'Yes kay world tours bangalore private limited',
    'Kerala tourism development corporation limited',
    'ROYAL OMANIA TOURS & TRAVELS PRIVATE LIMITED',
    'Velogic india private limited',
    'Bindya cargo private limited',
    'Wallem shipmanagement (india) private limited',
    'Le mill private limited',
    'Aura offshore private limited',
    'Tradewell cargo private limited',
    'Native route private limited',
    'F2 fun and fitness (india) private limited',
    'Mihir mobile solutions private limited',
    'Royal wellfit health club private limited',
    'L.m.b. finance private limited',
    'Global collect india private limited',
    'N.c.trading company private limited',
    'ZEN FINCORP PRIVATE LIMITED',
    'Kamachi investments pvt ltd',
    'Booh finance company pvt ltd',
    'Pure gold finance private limited',
    'Equity link research (india) limited',
    'Avendus pe investment advisors private limited',
    'Narayani investment consultancy private limited',
    'AMBADI INVESTMENTS LIMITED',
    'SBI CARDS AND PAYMENT SERVICES LIMITED',
    'Vision forex private limited',
    'Jai shri karnee mata investments consultancy services private limited',
    'Yash group insurance services private limited',
    'SAKASH FINANCIAL SERVICES PRIVATE LIMITED',
    'Alsuma investments pvt ltd',
    'Gold rock share shoppe private limited',
    'ALGOL CHEMICALS INDIA PRIVATE LIMITED',
    'Rev india private limited',
    'Ekling ji industries private limited',
    'Uttam finvest pvt. ltd.',
    'S b m investments private limited',
    'Narayani shares & securities pvt ltd',
    'Poonia associates private limited',
    'Sai point finance corporation limited',
    '3a capital services limited',
    'FRANKLIN TEMPLETON ALTERNATIVE INVESTMENTS (INDIA) PRIVATE LIMITED',
    'Mizuho securities india private limited',
    'CRESCENT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CHANAKYA WEALTH CREATION PRIVATE LIMITED (OPC)',
    'Dreamcart realty services private limited',
    'One touch relocation services private limited',
    'H. s. jogani & sons private limited',
    'Baosteel india company private limited',
    'Bapalal keshavlal jewels private limited',
    'Shree ramkrishna exports private limited',
    'Metalarch porta cabins private limited',
    'Corpak packaging private limited',
    'Coates signco (india) private limited',
    'Mayur renergy solutions private limited',
    'Optima power solutions india private limited',
    'INSPIRA ENTERPRISE INDIA LIMITED',
    'Darwin platform power limited',
    'Rayon realty private limited',
    'Kanishka buildwell private limited',
    'Svg properties private limited',
    'Emmay international properties and developers private limited',
    'Historic homes private limited',
    'Vicon infrastructures private limited',
    'Evershine castles private limited',
    'Shweta infrastructure and housing (india) private limited',
    'M k shelters private limited',
    'Asj developers private limited',
    'Ashar developers private limited',
    'Puneproperties and realties private limited',
    'Vedshree infrastructure and developers private limited',
    'Accentia oak technologies private limited',
    'Strategic impex private limited',
    'Vbhc mumbai value homes private limited',
    'Samraat infratech limited',
    'Avlon developers private limited',
    'Shrushti realtors private limited',
    'Maruti projects private limited',
    'Star agriinfrastructure private limited',
    'Nithyananda shelters private limited',
    'Rose valley real estates constructions limited',
    'Darmai infrastructures (india) private limited',
    'Bremer india engineering private limited',
    'Sonu infrastructures private limited',
    'Ranag infrastructure limited',
    'Mbl (mp) toll road company limited',
    'Ms hydro solutions private limited',
    'Blu waters construct private limited',
    'Usm infrastructures private limited',
    'Blue ridge infrastructure private limited',
    'Greenspace housing and engineers private limited',
    'Mbl highway development company limited',
    'Ankur realty private limited',
    'Srinagar sonamarg tunnelway limited',
    'Kolkata-one excelton private limited',
    'Cygnus negri investments private limited',
    'Jai ganesh autocorp private limited',
    'SHEKAR INDUSTRIES PRIVATE LIMITED',
    'Ace gas conversions private limited',
    'Ace car tech private limited',
    'Secure power india private limited',
    'GOPANI PRODUCT SYSTEMS PRIVATE LIMITED',
    'Poscho steels private limited',
    'OBERU RETAIL PRIVATE LIMITED',
    'G square international private limited',
    'Foresight bullion india private limited',
    'Merjan impex private limited',
    'A. international private limited',
    'Remotestar trading company private limited',
    'Gaffney-kroese supply india private limited',
    'AELITE LOGISTICS & MARKETING PRIVATE LIMITED',
    'Pearl hygienic products private limited',
    'Talin modular office furniture systems private limited',
    'Fidelis retail india private limited',
    'The refrigeration and air conditioning trades association limited',
    'Vijaydeep mould accessories private limited',
    'Decolab (india) private limited',
    'Vescom wallcoverings india private limited',
    'Narbheram agencies private limited',
    'United auto service private limited',
    'Dayal seeds private limited',
    'Spheretech packaging india private limited',
    'D and m building products private limited',
    'Sky fibreglass solutions private limited',
    'Art-yarn exports (india) private limited',
    'Aim worldwide private limited',
    'Enviro serve private limited',
    'Keysight technologies india private limited',
    'Draeger India Private Limited',
    'Gurbarga trading co pvt ltd',
    'Hem prabha trading co pvt ltd',
    'Vini export private limited',
    'Magnificent Mercantile Private Limited',
    'Dian star diamonds private limited',
    'Balatek services private limited',
    'Deepkamal exports private limited',
    'Osmosis trading and leasing private limited',
    'Visudira impex private limited',
    'Cyberwalk tech park private limited',
    'M and v marketing and sales private limited',
    'Par techno-heat pvt ltd',
    'Altech alloys india private limited',
    'DURGA MECHATRONICS PRIVATE LIMITED',
    'Raison bio-tech private limited',
    'VORA DWELLING AND PROPERTIES PRIVATE LIMITED',
    'KOMOX STEEL & TOOLS PRIVATE LIMITED',
    'Paranjape autocast private limited',
    'Surya innovative building materials private limited',
    'Nilkanth fasteners private limited',
    'Echjay forgings private limited',
    'Bsbk projects pvt ltd',
    'Master fire fighters private limited',
    'Vanson engineering private limited',
    'Veritek engineering private limited',
    'Sri durga lakshmi engineering private limited',
    'S&s horeca products private limited',
    'Pos-hyundai steel manufacturing india private limited',
    'Morrill and greenwood india private limited',
    'Embross systems private limited',
    'Arista automation private limited',
    'Alm engineering and instrumentation private limited',
    'Ozat pumps private limited',
    'Price pumps pvt ltd',
    'MICROTACT INDIA PRIVATE LIMITED',
    'Circor flow technologies india private limited',
    'Ep hitech imaging private limited',
    'Coldwave air techniques private limited',
    'Blue birds instruments private limited',
    'REEL INDIA SERVICES PRIVATE LIMITED',
    'Rajni engineers and services private limited',
    'Pavan machine tools & services india private limited',
    'Nesstech instruments private limited',
    'KISANKRAFT LIMITED',
    'Swastik technopack private limited',
    'Lg patsons engineering private limited',
    'Tyrolit india superabrasive tools private limited',
    'PRECISION GEARS AND TRANSMISSIONS PRIVATE LIMITED',
    'Sepco1 engineering (india) private limited',
    'Mfab tech private limited',
    'Cogito cranes private limited',
    'Hindustan vibrotech private limited',
    'Contrive moulds private limited',
    'R b technocrats & reclaimers private limited',
    'Ener engineering services private limited',
    'Xng automation solutions private limited',
    'Haimer india private limited',
    'Emerge automation india private limited',
    'Kaivalya technologies private limited',
    'Sukrut electric company private limited',
    'Sal technologies & solutions limited',
    'Neoteric infomatique limited',
    'JOISTER INFOSERVE PRIVATE LIMITED',
    'Macro tech private limited',
    'Quantum power conversions private limited',
    'TELIT COMMUNICATIONS INDIA PRIVATE LIMITED',
    'Avasarala communications private limited',
    'Simulation designs (india) private limited',
    'Svg control systems private limited',
    'MICROPNEUMATIC ENGINEERING & CONSTRUCTION PRIVATE LIMITED',
    'Finpower aircon systems private limited',
    'M.r.power tech private limited',
    'Brilliant electricals & electronics private limited',
    'Novateur electrical & digital systems private limited',
    'Priya technologies private limited',
    'Simoco telecommunications (south asia) limited',
    'Adair dutt electronics pvt ltd',
    'Embrace india',
    'Greiner bio-one india private limited',
    'Generic healthcare private limited',
    'Cambindia biotech kits private limited',
    'Unique instruments and manufacturers private limited',
    'Automann india private limited',
    'Amw commercial vehicle applications limited',
    'R.p.metal sections private limited',
    'Applied auto parts private limited',
    'Auto land india private limited',
    'Varmora furnitures private limited',
    'Hinshitsu manufacturing private limited',
    'Amore jewels private limited',
    'Laxmi diamond private limited',
    'Jewel craft private limited',
    'Famous foam & mattresses private limited',
    'Shankar jewels limited',
    'Regal remedies limited',
    'Bhavani gems private limited',
    'Karan kothari aabhushan private limited',
    'Edrock engineering private limited',
    'E - r3 solutions private limited',
    'Dj digital power systems private limited',
    'Eshaan energy private limited',
    'Simplex renewable resources private limited',
    'Daiki apparel private limited',
    'Rex comfort products india private limited',
    'JAKHARIA FABRIC LIMITED',
    'Basant texfab private limited',
    'Indian leather artisans private limited',
    'Globe cotyarn private limited',
    'Fresno and bakersfield india limited',
    'Bestkarma designs private limited',
    'Shivasaa apparels private limited',
    'METROPOLITAN EXIMCHEM Private Limited',
    'Euro decor private limited',
    'Elwin decor private limited',
    'New bombay paper mills private limited',
    'Rushikesh paper mills private limited',
    'Kay kay art private limited',
    'Midnapore creative arts private limited',
    'Tree advertising private limited',
    'Xquisite print solutions private limited',
    'Elementis coke private limited',
    'Yogi intermediates private limited',
    'Melog speciality chemicals private limited',
    'Ihsedu itoh green chemicals marketing private limited',
    'Anglo-indian pharmaceuticals private limited',
    'Perstorp chemicals india private limited',
    'Sunbeam monochem private limited',
    'Sai life sciences limited',
    'Nexus crop science private limited',
    'Sai elastomers and plastic private limited',
    'Star polymers private limited',
    'Sunrise auxichem private limited',
    'Crosfield textile chemicals (india) private limited',
    'Nabros pharma private limited',
    'M.R. SPECIALITY CHEMICALS PRIVATE LIMITED',
    'Apple lifecare (india) private limited',
    'Porus laboratories private limited',
    'Impel health care private limited',
    'EISAI PHARMACEUTICALS INDIA PRIVATE LIMITED',
    'Vinic lifesciences private limited',
    'Natural remedies private limited',
    'APARNA ORGANICS LIMITED',
    'Vv labs private limited',
    'Nano sciences and ozone technologies private limited',
    'Eastman chemical india private limited',
    'Desano pharmaceuticals private limited',
    'CAPRICORN DISTILLERY PRIVATE LIMITED',
    'Dow chemical international private limited',
    'WELLNESS FOREVER MEDICARE LIMITED',
    'Qualitron bio medica private limited',
    'Aruna chemicals & farms private limited',
    'Asean aromatics private limited',
    'Vithal castor polyols private limited',
    'Unived healthcare products private limited',
    'Herbs (india) private limited',
    'Quadragen vethealth private limited',
    'Innovet remedies (india) private limited',
    'Meenakshi moldings private limited',
    'LAMBERTI INDIA PRIVATE LIMITED',
    'Desco engineering plastics india private limited',
    'Sanidad plastic products private limited',
    'Bullion flexipack private limited',
    'Cmp euro technoplast private limited',
    'Agru plastic technology private limited',
    'Treadway investments (india) private limited',
    'MACRO MOULDS & PLASTICS PRIVATE LIMITED',
    'Chamundi extrusions private limited',
    'Yugal concrete floors private limited',
    'Brahmaputra eco products private limited',
    'Simero vitrified private limited',
    'BRAHMAPUTRA AASHIANA LIMITED',
    'Brahmaputra tubulars private limited',
    'Brahmaputra rolling mills private limited',
    'Brahmaputra iron and steel company private limited',
    'Biscon steels private limited',
    'Le-con seals private limited',
    'Brahmaputra galvochem pvt ltd',
    'Cosmos techno cast private limited',
    'Jupiter fittings (india) private limited',
    'Shalini steels pvt.ltd.',
    'Paras fittings private limited',
    'Johnson lifts private limited',
    'Premier press parts private limited',
    'Brahmaputra tmt bars private limited',
    'Rrk hitech industries private limited',
    'Shree matangi investmentcasting private limited',
    'Naarayani metalics & engineers private limited',
    'Oil field services(india) private limited',
    'WITTUR GLOBAL TECHNOLOGY AND BUSINESS CENTRE INDIA PRIVATE LIMITED',
    'Efficient laser technology private limited',
    'Eastern metallizing co pvt ltd',
    'Deep pneumatics private limited',
    'Avesta solar private limited',
    'White motors private limited',
    'Bently fabrics private limited',
    'New horizon knits private limited',
    'Venus attire private limited',
    'Opera clothing private limited',
    'United bazaar private limited',
    'Cortica manufacturing (india ) private limited',
    'Diy furnitures private limited',
    'Sharp ply (india) private limited',
    'Zen building solutions private limited',
    'Saif furniture industries private limited',
    'Indus eco green products private limited',
    'Garnett nuevo papers private limited',
    'APRN ENTERPRISES PRIVATE LIMITED',
    'Vital paper products private limited',
    'Crescendo paper processing private limited',
    'Sevak publications private limited',
    'Maniram coke private limited',
    'KRISBAL ENGINEERING PRIVATE LIMITED',
    'INDIANOIL ADANI VENTURES LIMITED',
    'Kim petroleum specialities limited',
    'Satyesh brinechem private limited',
    'AKOLA CHEMICALS (INDIA) PRIVATE LIMITED',
    'JAI LARA DRUGS PRIVATE LIMITED',
    'Vasu chemicals (india) private limited',
    'Fluorolined equipment private limited',
    'Elementto life styles private limited',
    'SAPTAGIR CAMPHOR PRIVATE LIMITED',
    'Mahalaxmi dyes and chemicals limited',
    'Solutia chemicals india private limited',
    'Pan synthetics private limited',
    'Aoc india private limited',
    'Olive lifesciences private limited',
    'Sun bulkactives private limited',
    'AGILEMED INVESTMENTS PRIVATE LIMITED',
    'FIXATTI INDIA PRIVATE LIMITED',
    'Corbion india private limited',
    'Mhs pharmaceuticals private limited',
    'Midas care pharmaceuticals pvt ltd',
    'Ideal cures private limited',
    'Taurian pharma pvt. ltd.',
    'Synergene active ingredients private limited',
    'Entor bio-oils private limited',
    'Optima life sciences private limited',
    'Vighnesh industries private limited',
    'Kumaram rubber goods manufacturing co pvt ltd',
    'Hwaseung materials (india) private limited',
    'R1 international (india) private limited',
    'Billion flex (india) private limited',
    'Kunal plastics private limited',
    'Mangalam plastic components private limited',
    'Sara plast private limited',
    'Ansa decoglass private limited',
    'Soham buildmat private limited',
    'Super decorative floorings private limited',
    'Govind extrusion private limited',
    'Utkarsh bars private limited',
    'Virat ispat private limited',
    'ISINOX LIMITED',
    'Gci castings (india) private limited',
    'Planet power tools private limited',
    'Radashir jewelry company private limited',
    'Puran sons alloys private limited',
    'ARROWSTEEL PARTS PRIVATE LIMITED',
    'Hybrid metals private limited',
    'Spplicetek india private limited',
    'TIRUPATI FORGE LIMITED',
    'Nirman fabricators and engineers private limited',
    'Exotic fabtech private limited',
    'IORN & METAL TRADERS PRIVATE LIMITED',
    'R r plast extrusions private limited',
    'Meenakshi associates private ltd.',
    'Consite engineering company limited',
    'KONGSBERG MARITIME CM INDIA PRIVATE LIMITED',
    'Ecospec india private limited',
    'Legends equipments private limited',
    'Evgreen machine tool and automation private limited',
    'KLASSIC WHEELS LIMITED',
    'Prime forklifters private limited',
    'Maruti machines private limited',
    'Picson construction equipments private limited',
    'Apt controls and appliances private limited',
    'Hse engineers private limited',
    'Sanket packseal machines private limited',
    'Ametek instruments india private limited',
    'Renen power technologies private limited',
    'Svenska technologies private limited',
    'Wirtz manufacturing india private limited',
    'ENERPAC INDIA PRIVATE LIMITED',
    'Fluidfit engineers private limited',
    'Asr machine tools private limited',
    'Radford global limited',
    'Joindre capital services limited',
    'The byke hospitality limited',
    'Pavna agro farms private limited',
    'Godvet agrochem limited',
    'Sedhyam agri farms limited',
    'Selandia crew management (india) private limited',
    'Alssun oilfield private limited',
    'Vp petro6 engineers and consultants private limited',
    'Anand granite exports pvt ltd',
    'Bhadresh natural resources private limited',
    'SATVIKI MILKOTRONICS PRIVATE LIMITED',
    'Maha agricultural products private limited',
    'Mother india organics and naturals private limited',
    'Symco sales private limited',
    'Mealite foods private limited',
    'YOURS ETHNIC FOODS PRIVATE LIMITED',
    'Evolution sports nutrition private limited',
    'Suxes hospitality solutions private limited',
    'Deccans park limited',
    'Modtech machines private limited',
    'KONTOOR BRANDS INDIA PRIVATE LIMITED',
    'Suchi industries limited',
    'Ananthi developers limited',
    'Shri teyem processors limited',
    'Alpha craft private limited',
    'Space textiles private limited',
    'VIVAA TRADECOM LIMITED',
    'Dhanshree syntex private limited',
    'Sammaan fabrics private limited',
    'Domtex india private limited',
    'Omo textiles creation private limited',
    'Guganram textiles limited',
    'Zoey creation private limited',
    'TOPSACK PACKAGING PRIVATE LIMITED',
    'Shree poddar texport private limited',
    'Hansel textile systems private limited',
    'Sap apparels private limited',
    'Inc.5 shoes private limited',
    'Signature laminates private limited',
    'Dgpack avoni private limited',
    'Commit industries private limited',
    'Diligent media corporation limited',
    'Triaangle print service solutions private limited',
    'Indigo press (india) private limited',
    'Vision labels (india) private limited',
    'Shree pushkar chemicals & fertilisers limited',
    'Lok chemicals private limited',
    'Rossari biotech limited',
    'Doshion private limited',
    'Kolorjet chemicals private limited',
    'Shree sidhambika pharma private limited',
    'ROSSARI CONSUMER PRODUCTS PRIVATE LIMITED',
    'ORDNC 2023 000003 U24200MH2013PTC240127 PRIVATE LIMITED',
    'E p industrial & agro products private limited',
    'Liveon healthcare private limited',
    'Kilitch company (pharma) limited',
    'DASALDHAN CHEMICALS PRIVATE LIMITED',
    'Synergy agro chemicals hyderabad private limited',
    'Olax pharma labs private limited',
    'Indian herbs concentrates private limited',
    'Crescent specialty chemicals private limited',
    'Vama healthcare private limited',
    'Yash pharma laboratories private limited',
    'Taj active pharmaceuticals ingredients limited',
    'Somu chemicals and pharmaceuticals private limited',
    'REVOCOAT INDIA PRIVATE LIMITED',
    'Shreebhagwan tubesandcontainers pvt ltd',
    'Horiaki india private limited',
    'Jagruti conveyor belts private limited',
    'Flowkem poly plast private limited',
    'Thermolite packaging (india) private limited',
    'Thermo products private limited',
    'B. d. industries (pune) private limited',
    'WAAREE TECHNOLOGIES LIMITED',
    'Starwing plastic and chemicals private limited',
    'BALAJI BUILDING TECHNOLOGIES LIMITED',
    'Thanor pottery private limited',
    'S.v. diecast private limited',
    'Ashvini magnets private limited',
    'Accurate springs private limited',
    'Bharat wire ropes limited',
    'Icon insulations private limited',
    'Top metals limited',
    'Hindustan inox limited',
    'Aakar foundry private limited',
    'Pacific pipe systems private limited',
    'Grorich horivert private limited',
    'Vishal engineers & galvanizers private limited',
    'Jsw structural metal decking limited',
    'Dharni sampda private limited',
    'Aac mining executors india private limited',
    'Anantharock minerals private limited',
    'Viiking beverages private limited',
    'Vertex lifesciences private limited',
    'Sower of seeds foods international private limited',
    'Arumuga fabrics private limited',
    'United fiber composites private limited',
    'Shanti spincot private limited',
    'Libra fabric designs private limited',
    'AXITA COTTON LIMITED',
    'Texplas textiles india private limited',
    'Milaaya embroidery private limited',
    'JMHOME DESIGN PRIVATE LIMITED',
    'Jamna syntex private limited',
    'Trinity worldwide exports private limited',
    'Unitex synthetics (india) p ltd',
    'Nandini clothing private limited',
    'Rasim exports private limited',
    'Chaitra exports private limited',
    'Mothercare sourcing india private limited',
    'Vishal hosieries private limited',
    'Pioneer calicos products private limited',
    'Vijayalakshmi fibres private limited',
    'Comfy shoemakers private limited',
    'Nobleexchange environment solutions private limited',
    'Prakash corrugated products pvt ltd',
    'Tube-india container private limited',
    'Wall street journal india publishing private limited',
    'Antares publishing services private limited',
    'Brillio technologies private limited',
    'Rane prakashan private limited',
    'Print plus private limited',
    'Checkpoint apparel labeling solutions india private limited',
    'Akshar gravures private limited',
    'DOTT BRANDING PRIVATE LIMITED',
    'Healus india private limited',
    'MICHELMAN PRIVATE LIMITED',
    'Sahiti laboratories private limited',
    'Fluorocarbons india private limited',
    'Strategic engineering private limited',
    'A-1 ACID LIMITED',
    'Colourtech products private limited',
    'Axson india private limited',
    'DASHRATH PRASAD INDUSTRIES PRIVATE LIMITED',
    'Calyx chemicals and pharmaceuticals limited',
    'Genomelabs india private limited',
    'Anil dye-chem industries private limited',
    'Airis pharma private limited',
    'Galaxy lube (india) private limited',
    'Accord chemcorp private limited',
    'Bioera life sciences private limited',
    'Dr.jcr bio-sciences private limited',
    'Chemosyn limited',
    'Reliance life sciences private limited',
    'Nifty labs private limited',
    'Jai aravali industrial products private limited.',
    'S. P. KHETIWADI UTPAN BAZAR PRIVATE LIMITED',
    'Prince synthetics pvt ltd',
    'Softurf india private limited',
    'Karam multipack private limited',
    'Sunrise glass industries private limited',
    'Schott glass india private limited',
    'Magicrete building solutions private limited',
    'Alone valves private limited',
    'Labelle body care private limited',
    'Bilva moulds private limited',
    'Arbuda metal fab india private limited',
    'Kalisma transmission international private limited',
    'Nico extrusions limited',
    'Kalisma galvanizers private limited',
    'Rathi dye chem private limited',
    'Mungi engineers private limited',
    'Magnetic solutions private limited',
    'Abloy high security locks private limited',
    'Pelican bathware private limited',
    'Assa abloy india private limited',
    'Pokma automobile services private limited',
    'Karmen international private limited',
    'Magma machining private limited',
    'Bgi engitech private limited',
    'Deeyem cnc machining private limited',
    'Tr technical resources india private limited',
    'Yoganand energy private limited',
    'Opera elevators private limited',
    'Safe air engineers private limited',
    'Agrolandia equipments private limited',
    'Vaxom packaging private limited',
    'Hephzi elevators international company private limited',
    'Aerocomp precision engineering private limited',
    'Jagmohan pla-mach private limited',
    'Ecotech environmental and petro marine engineering private limited',
    'Schlumberger india technology centre private limited',
    'Nova instruments pvt ltd',
    'Eta general private limited',
    'Insilica semiconductors india private limited',
    'Chuan shun electric company india private limited',
    'ELEGAR KERPEN KABEL INDIA PRIVATE LIMITED',
    'Knf pumps+systems (india) private limited',
    'Vayucon systems private limited',
    'Martand luminaries private limited',
    'Sorfin yoshimura (india) private limited',
    'Neev electronics private limited',
    'Campus component private limited',
    'Sy-tech engineering private limited',
    'Yantra harvest energy private limited',
    'Vedang advanced radio electronic systems private limited',
    'Peak telecom india private limited',
    'Bhavyabhanu electronics private limited',
    'Peak mobiles india private limited',
    'Triumph manufacturing (india) private limited',
    'GETINGE MEDICAL INDIA PRIVATE LIMITED',
    'Anvay pharma systems private limited',
    'Toyota kirloskar motor private limited',
    'Aditya moto (gujarat) private limited',
    'Gamma engineering private limited',
    'TRANSWORLD SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'Scania commercial vehicles india private limited',
    'Niemann india furniture components private limited',
    'Supergems (india) pvt ltd',
    'Nakshatra brands limited',
    'Kgk entice (india) private limited',
    'Bhaskar devji gold private limited',
    'Brua hydrowatt private limited',
    'Prakruthi wind energy private limited',
    'Siva kesav power projects private limited',
    'Devaraya power projects private limited',
    'Tata power renewable energy limited',
    'Surmount energy solutions private limited',
    'Abacus holdings private limited',
    'Praj hipurity systems limited',
    'Sicoma mixers india private limited',
    'Mighty constructions private limited',
    'Aristo realty developers limited',
    'Mobile constructions private limited',
    'JIWANI CONSTRUMA PRIVATE LIMITED',
    'Bigben properties private limited',
    'Romell properties private limited',
    'Montreal developers private limited',
    'Sadguru bhawan nirman pvt ltd',
    'Accord flower valley buildwell private limited',
    'Milestone lotus valley buildwell private limited',
    'PRANAVA CITY COMPLEX PRIVATE LIMITED',
    'Terrafirm nest private limited',
    'Rel-vit engineers private limited',
    'SITAC TUNGABHADRA RENEWABLES PRIVATE LIMITED',
    'JUNE IT SOLUTIONS PRIVATE LIMITED',
    'NANGLI INTERNET PRIVATE LIMITED',
    'COMPETITIVE EDGE ACADEMY PRIVATE LIMITED',
    'CREATIVE SIGNPLUS PRIVATE LIMITED',
    'MUSCLEPRO NUTRITION PRIVATE LIMITED',
    'H. R. HYGIENE PRODUCTS PRIVATE LIMITED',
    'VAISHVIK INSTITUTE OF VOCATIONAL EDUCATION AND TRAINING PRIVATE LIMITED',
    'ZUPATECH WEB SERVICES PRIVATE LIMITED',
    'YIPIN INDIA PRIVATE LIMITED',
    'TECHFLEES SOLUTIONS PRIVATE LIMITED',
    'VERNAL INDUSTRIES PRIVATE LIMITED',
    'LIVEPONICS INDIA PRIVATE LIMITED',
    'DELMAR OFFSHORE SERVICES PRIVATE LIMITED',
    'BOTANIX RESORT PRIVATE LIMITED',
    'RIDHI FAB DESIGNS PRIVATE LIMITED',
    'WILDOILS PRIVATE LIMITED',
    'C-NET DIGITAL PRIVATE LIMITED',
    'BOUTIQUE SPIRIT BRANDS PRIVATE LIMITED',
    'NYUCT DESIGN LABS PRIVATE LIMITED',
    'SHIVA BIOGENETIC LABORATORIES PRIVATE LIMITED',
    'BDS STZ TECHNOSYSTEMS PRIVATE LIMITED',
    'CHEMICEA PHARMACEUTICALS PRIVATE LIMITED',
    'NEXUG INDUSTRIES PRIVATE LIMITED',
    'ZEUX INNOVATION PRIVATE LIMITED',
    'PAN MACMILLAN PUBLISHING INDIA PRIVATE LIMITED',
    'CELLUS TECH INDIA PRIVATE LIMITED',
    'AI LABS PRIVATE LIMITED',
    'SITAC KRISHNA RENEWABLES PRIVATE LIMITED',
    'ACTERO PHARMA PRIVATE LIMITED',
    'ALCEDO PHARMACHEM PRIVATE LIMITED',
    'BODHISATTVA LEARNING PRIVATE LIMITED',
    'CTSI GLOBAL INDIA PRIVATE LIMITED',
    'PADAMSHREE NEWS (INDIA) PRIVATE LIMITED',
    'SS PET BOTTLING PRIVATE LIMITED',
    'ARAD VENTURES PRIVATE LIMITED',
    'HRVS INDIA PRIVATE LIMITED',
    'HOWDY VENTURES PRIVATE LIMITED',
    'HORUS INTELLISYS PRIVATE LIMITED',
    'ALS INDIAN SCHOOL OF GENERAL STUDIES PRIVATE LIMITED',
    'GOLE ELECTRICAL TECHNOLOGIES PRIVATE LIMITED',
    'EARTHLINGS INFOTECH PRIVATE LIMITED',
    'KOPI DESA PRIVATE LIMITED',
    'NEXTWEB TECHNOLOGIES PRIVATE LIMITED',
    'BELCH FOODS PRIVATE LIMITED',
    'BESPOKE HR SERVICES PRIVATE LIMITED',
    'MIRAAYA VENTURES PRIVATE LIMITED',
    'FROTELS PRIVATE LIMITED',
    'VANA SAFARIS PRIVATE LIMITED',
    'LIGHT BOX RESTAURANTS PRIVATE LIMITED',
    'QUINTES GLOBAL PRIVATE LIMITED',
    'SOCIAL CARE FOUNDATION',
    'NAGA COFFEE PRIVATE LIMITED',
    'V3V TOURS & TRAVELS PRIVATE LIMITED',
    'MYIND MEDTECH INNOVATIONS PRIVATE LIMITED',
    'NARAYANA SOLAR PRIVATE LIMITED',
    'YDESIGN SERVICES PRIVATE LIMITED',
    'HYOSEC SOLUTIONS PRIVATE LIMITED',
    'SIMANDHAR FINLEASE PRIVATE LIMITED',
    'REVITECH BUILDING SERVICES PRIVATE LIMITED',
    'ODILIVE DIGITAL MEDIA (OPC) PRIVATE LIMITED',
    'NARAYAN INSURANCE BROKERS PRIVATE LIMITED',
    'AZKKA PHARMACEUTICALS PRIVATE LIMITED',
    'PALMROW FEDERATION INDIA',
    'CAREINDIA HEALTH PRIVATE LIMITED',
    'GADGEON LIFESTYLE PRIVATE LIMITED',
    'SLS MINING PRIVATE LIMITED',
    'MTD MARKETING PRIVATE LIMITED',
    'FEDERATION',
    'BOHO HOLDINGS PRIVATE LIMITED',
    'Bhawani exports private limited',
    'Raasi enterprise solutions limited',
    'Gfk nielsen india private limited',
    'Amazon seller services private limited',
    'Velhari trading company private limited',
    'Innisfree cosmetics india private limited',
    'Raj laxmi marketing pvt.ltd.',
    'NATTY DESIGN CONCEPTS PRIVATE LIMITED',
    'Alpine ventures private limited',
    'Pastel commerce private limited',
    'Intercraft trading private limited',
    'Fashion exim (india) private limited',
    'Saubhagya impex private limited',
    'Sasha coir products private limited',
    'Pashupati commerce private limited',
    'Model sales agency private limited',
    'Sujan impex private limited',
    'Champion agency private limited',
    'Madan transmissions private limited',
    'Linient trading private limited',
    'Reliance-vision express private limited',
    'Bhavik enterprises limited',
    'Pen books private limited',
    'Subham holdings private limited',
    'Technosys services private limited',
    'Global excellence enterprise private limited',
    'Tehelka com private limited',
    'Instant cable network private limited',
    'WUNDERMAN THOMPSON COMMERCE PRIVATE LIMITED',
    'Pagetraffic web-tech private limited',
    'Synergy it solutions private limited',
    'Transaction solutions international (india) private limited',
    'Daphne systems private limited',
    'Clearpath technology private limited',
    'Beldam realters private limited',
    'Classic nirman pvt ltd.',
    'Excellent evista infologic private limited.',
    'Samsung data systems india private limited',
    'RAPIPAY FINTECH PRIVATE LIMITED',
    'Tathastu information technology private limited',
    'Perfect web softtech private limited',
    'Blueant digital intelligence private limited',
    'Hivemind intelligence solutions private limited',
    'Nile technologies private limited',
    'Graebert india software private limited',
    'Adstuck consulting private limited',
    'Yv ingenious designs private limited',
    'GMO-Z.COM RESEARCH PRIVATE LIMITED',
    'Ipp estate private limited',
    'Velocity developers india limited',
    'Beckon properties private limited',
    'Panamax infotech limited',
    'Shah audio info tech private limited',
    'Rigel networks private limited',
    'Strategix solutions private limited',
    'Sunrise producers private limited',
    'Allenby real estate private limited',
    'Lohgaon trading company private limited',
    'Akkhrutha technocrats limited',
    'Forgeahead Solutions Private Limited',
    'Kriyatec it systems private limited',
    'Asb bearings private limited',
    'Kyal developers pvt ltd',
    'Silver touch technologies limited',
    'Ace infoworld private limited',
    'Intouch systems private limited',
    'Integra micro software services private limited',
    'Wep peripherals limited',
    'WHAT DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'Foresight automation products private limited',
    'Invensis technologies private limited',
    'MASPRO TECHNOLOGIES PRIVATE LIMITED',
    'ENCORA INNOVATION LABS INDIA PRIVATE LIMITED',
    'Takshana technologies private limited',
    'Altivo information technologies private limited',
    'Nurture software solutions private limited',
    'DISH NETWORK TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Vtiger systems (india) private limited',
    'Talent mobile solutions india private limited',
    'Yindusoft technologies india private limited',
    'I code technologies private limited',
    'Ict service management solutions (india) private limited',
    'PAYCHEX IT SOLUTIONS INDIA PRIVATE LIMITED',
    'Synowledge it services india private limited',
    'QINECSA SOLUTIONS INDIA PRIVATE LIMITED',
    'Logix buildwell private limited',
    'Viceroy realtors private limited',
    'Asrah technologies india limited',
    'RICT INDIA PRIVATE LIMITED',
    'Octaunitech solutions private limited',
    'Finonyx software solutions private limited',
    'Oxytech solutions private limited',
    'Citrin technologies india private limited',
    'Shiv prakruti real estates private limited',
    'Nishikaanta estate and reality private limited',
    'Nripa estate and reality private limited',
    'Supersonic infrastructure private limited',
    'Ip core solutions (india) private limited',
    'Imeco infrastructures private limited',
    'Tulsiberia project private limited',
    'Enter technologies private limited',
    'Wave online infoway private limited',
    'D+h solutions india private limited',
    'Focuz innovations private limited',
    'Tech27 systems private limited',
    'Spiderworks technologies private limited',
    'Comnet vision (india) private limited',
    'Team liftss-it systems and solutions private limited',
    'Vofox solutions private limited',
    'Prominere software solutions private limited',
    'Logix infrastructure private limited',
    'Elucit software services private limited',
    'Myscon technologies private limited',
    'Infotura technologies private limited',
    'Xpetize technology solutions private limited',
    'Aries e-solutions private limited',
    'Agbs network private limited',
    'T coffee business solutions private limited',
    'Us services group private limited',
    'V i point solutions private limited',
    'Petro infotech private limited',
    'Syama dynamic it services private limited',
    'Adstock business network international private limited',
    'Unvired software india private limited',
    'Telcave computing private limited',
    'Washroom hygiene concepts private limited',
    'Vast digital publishing private limited',
    'Pronext hr consultants private limited',
    'Gs3 services india private limited',
    'Aspire medical services private limited',
    'ADANI FORWARDING AGENT PRIVATE LIMITED',
    'Sns engineering private limited',
    'Janacare solutions private limited',
    'Mercator ventures private limited',
    'Amx detectives private limited',
    'First india incubation foundation',
    'Autotek cables private limited',
    'BOPARAI',
    'S DESIGNO PRIVATE LIMITED',
    'Orosilber joaillerie private limited',
    'KIROS CREATIONS PRIVATE LIMITED',
    'PATDIAM JEWELLERY Limited',
    'Kaprisa international pvt ltd',
    'Amadena jewels private limited',
    'Derewala industries limited',
    'Snowtex udyog ltd',
    'PERIPHERAL STEEL & WOOD INDIA PRIVATE LIMITED',
    'Sargam musical instruments limited',
    'SRI MJR 92 PRIVATE LIMITED',
    'Krish business and consulting service private limited',
    'PURSANG ENTERPRISES PRIVATE LIMITED',
    'LEETHA TECHCRAFTS PRIVATE LIMITED',
    'Vitrag writing instruments private limited',
    'Lexi private limited',
    'Aggarwal buttons private limited',
    'Frigoglass india private limited',
    'Acros pvt ltd',
    'Uni recyclers pvt ltd',
    'Sri chakra poly plast (india) private limited',
    'Galaxy surfactants ltd',
    'Twin hickory power private limited',
    'APRAAVA ENERGY PRIVATE LIMITED',
    'VINDHYACHAL HYDRO POWER Private Limited',
    'Pawan wind farms private limited',
    'Raajratna energy holdings private limited',
    'Gactel turnkey projects limited',
    'Belij hydro power private limited',
    'Panyor hydro power private limited',
    'Ujvn limited',
    'Vaayu (india) power corporation private limited',
    'Vaayu renewable energy (mevasa) private limited',
    'Su-pra energy private limited',
    'Sgurrenergy india private limited',
    'Rajasthan rajya vidyut utpadan nigam limited',
    'Rayalaseema wind energy company private limited',
    'PPP GLOBAL PRIVATE LIMITED',
    'Zemag india private limited',
    'Empergy power and infrastructure private limited',
    'Sun switch india private limited',
    'MYTRAH N4ELECTRIC PRIVATE LIMITED',
    'Phocos india solar private limited',
    'ONEBEE TECHNOLOGY PRIVATE LIMITED',
    'Berry energy private limited',
    'Cira renewable energy private limited',
    'Vaayu renewable energy (arabian sea) private limited',
    'Vaayu renewable energy (kalakudi) private limited',
    'Vaayu renewable energy (vagaikulam) private limited',
    'Vaayu renewable energy (mandvi) private limited',
    'Vaayu renewable energy (parner) private limited',
    'Venture energy and technologies limited',
    'Guruji power private limited',
    'Abp induction systems private limited',
    'Exergy heating solutions private limited',
    'Ets power india private limited',
    'Pel power limited',
    'Guttaseema wind energy company private limited',
    'Belum wind infrastructure private limited',
    'Animala wind power private limited',
    'GREENKO RAYALA WIND POWER PRIVATE LIMITED',
    'Dollar energy private limited',
    'Prakti design private limited',
    'Ksk energy company private limited',
    'Anakampoil power private limited',
    'ABAN INFRASTRUCTURE PRIVATE LIMITED',
    'Rl clean power private limited',
    'Shirala carbondioxide private limited',
    'ADHWAAPATI TOUR & TRAVELS PRIVATE LIMITED',
    'POWERGRID JABALPUR TRANSMISSION LIMITED',
    'Highground energy private limited',
    'Spectro testing private limited',
    'Banas thermal power private limited',
    'Chennai industrial water utility company limited',
    'Sadoday builders private limited',
    'Shyamsundar ventures private limited',
    'K.b. telenet infra private limited',
    'Morgan builders & developers private limited',
    'Hoshi builders & developers private limited',
    'Morina builders & developers private limited',
    'Morven builders & developers private limited',
    'Samridhi townships private limited',
    'Celina projects private limited',
    'Jesen builders & developers private limited',
    'Keyna builders & constructions private limited',
    'Daffodil builders private limited',
    'Gavel builders & constructions private limited',
    'Uncial builders & constructions private limited',
    'Career launcher infrastructure private limited',
    'Big projects private limited',
    'IFFCO EBAZAR LIMITED',
    'WELSPUN PROJECTS (HIMMATNAGAR BYPASS) PRIVATE LIMITED',
    'Aaran realties private limited',
    'Ozone devcon private limited',
    'Gcorp spaces private limited',
    'LAHANTI HOMES & INFRASTRUCTURE PRIVATE LIMITED',
    'Aicl builders and developers limited',
    'Tele tourism and travels private limited',
    'MABELLA TRUSTEE SERVICES PRIVATE LIMITED',
    'Khurana communications private limited',
    'Clintus packers and movers private limited',
    'Kangaroo visa services private limited',
    'Metalfab hightech private limited',
    'Ralco finance and investments private limited',
    'Lucas financial services pvt ltd',
    'Josan deposits and advances limited',
    'Saffron financial services pvt.ltd.',
    'Jaishanker housing and finance private limited',
    'Mahindra rural housing finance limited',
    'Ocean king shipping services private limited',
    'Carmel india tours private limited',
    'Viva home finance limited',
    'Julius Baer Wealth Advisors (India) Private Limited',
    'Maina ore transport private limited',
    'Hiren brothers investment company private limited',
    'Tanda shipping private limited',
    'Gautam freight pvt ltd',
    'Intelliverse telecom private limited',
    'Scorpio engineering bmh private limited',
    'Cargo placement services and agencies private limited',
    'Clearfast service private limited',
    'Shriram commercial limited',
    'Bulls and bears finance limited',
    'J m assets management private limited',
    'Kamvan construction private limited',
    'Nautical marine management services private limited',
    'New bal logistics private limited',
    'Icfs private limited',
    'Reclamation realty (india) private limited',
    'Shree emati investment private limited',
    'Ecl finance limited',
    'InnoVen Capital India Private Limited',
    'SUYOG INVESTMENT DISTRIBUTION SERVICES PRIVATE LIMITED',
    'Gpt sons private limited',
    'MUTHOOTTU URBAN NIDHI LIMITED',
    'MUTHOOT M GEORGE NIDHI LIMITED',
    'TATA TRUSTEE COMPANY PRIVATE LIMITED',
    'Twentyfour x seven holidays private limited',
    'Ppfas trustee company private limited',
    'Asda network private limited',
    'Amd telecom private limited',
    'Hire purchase investment private limited',
    'V t velu investments private limited',
    'Braganza investmentsandfinancial consultants private limited',
    'Nuance india private limited',
    'Sunidhi capital private limited',
    'M a patel and sons pvt.ltd.',
    'Highsky finance and investments private limited',
    'Midland corporate advisory services private limited',
    'Lavender investments private limited',
    'Synapse information services private limited',
    'Nawal finance private limited',
    'Edel finance company limited',
    'Fomento finance and investments private limited',
    'Vishesh fiscal management private limited',
    'Finance doctor private limited',
    'TUBE INVESTMENTS OF INDIA LIMITED',
    'Dhamayanthi venkatapathy farm house private limited',
    'Saravana finance private limited',
    'Gvfl limited',
    'Toyota tsusho insurance broker india private limited',
    'The lucky trading co ltd',
    'Goldenlife financial services private limited',
    'Gosree finance limited',
    'Haria investments pvt ltd',
    'Velvet investments and finance pvt ltd',
    'Dsp hmk holdings private limited',
    'Dsp adiko holdings private limited',
    'Somnath securities solutions private limited',
    'Interlink securities private limited',
    'Dsp investment private limited',
    'Sagarkanya investments and finance private limited',
    'Fusion investments and financial services private limited',
    'Catalyst finance private limited',
    'Simto investment co ltd',
    'Chance investments and trading company private limited',
    'K r financial and management service pvt ltd',
    'EQL FINANCIAL TECHNOLOGIES PRIVATE LIMITED',
    'Annakrish investment and trading private limited',
    'Palmar investment and trading company pvt ltd',
    'Cyrus investments private limited',
    'WORTHY INVESTMENT & SERVICES PRIVATE LIMITED',
    'Rodessa holdings pvt ltd',
    'Sofet investments pvt ltd',
    'Tarang advisory private limited',
    'SN BUILT PRIVATE LIMITED',
    'Narayana equity broking and advisory services private limited',
    'SUIYAS INDUSTRIES PRIVATE LIMITED',
    'India actuators private limited',
    'KANDAN MUTUAL BENEFIT SASWATHA NIDHI LIMITED',
    'Geo chits private limited',
    'Usha mutual benefit society ltd',
    'Revati buildcon private limited',
    'Kalani investments and consultants pvt ltd',
    'Unifi financial private limited',
    'Gedee investments private limited',
    'Leaders healthcare limited',
    'Stark communications bangalore private limited',
    'Indianet marketing services private limited',
    'Initiative media (india) private limited',
    'I p verma media marketing pvt ltd',
    'Mx advertising private limited',
    'Madison communications private limited',
    'Sap media worldwide limited',
    '4AM WORLDWIDE ADVERTISING PRIVATE LIMITED',
    'Vishi advertising private limited',
    'BIGBRANDTHEORY CONSULTING PRIVATE LIMITED',
    'Kesari ads private limited',
    'Jack in the box productions private limited',
    'Pixelkraft media solutions private limited',
    'SAGAR OIL & GAS EQUIPMENT PRIVATE LIMITED',
    'Saharsh holdings pvt ltd',
    'Ajay enterprises private limited.',
    'Mohta cotton mills private limited',
    'Marvel engineers and traders private limited',
    'Jetair private limited',
    'Ess pee electro components ltd',
    'Raj builders private ltd',
    'Qutab apartments private limited',
    'Vishwa properties pvt ltd',
    'Northern india leather cloth manufaceturing co pvt ltd',
    'Appcon consultants pvt ltd',
    'J.v. services private limited',
    'Special cables pvt ltd',
    'Saria investments and consultants pvt ltd',
    'PETROLE SERVICE INDIA PRIVATE LIMITED',
    'Botil oil tools india private limited',
    'Kafila linkers private ltd.',
    'Osna electronics pprivate ltd.',
    'Anupam synthetics private ltd.',
    'Arpita financial services private limited',
    'Vyana advisory private limited',
    'Resor tech private limited',
    'Excelair engineering private limited',
    'Technomark engineers india private limited',
    'S squared architects private limited',
    'Surajkund properties private limited',
    'Ncj marketing private limited',
    'Spectrum management services private limited',
    'Gewis engineering india private limited',
    'ALTIUS ADVISORY & MANAGEMENT SERVICES PRIVATE LIMITED',
    'Red orange technologies private limited',
    '3I INFOTECH DIGITAL BPS LIMITED',
    'Hero fincorp limited',
    'Theme weavers international private limited',
    'Eez pack private limited',
    'Supreme global services private limited',
    'K 2 communications private limited',
    'Happy creative services (india) private limited',
    'Eden consultancy services private limited',
    'R c sood and co private ltd',
    'Sainty financial services private limited',
    'Bacfo pharmaceuticals (india ) limited',
    'Two brothers holding limited',
    'Sentiss pharma private limited',
    'Overseas courier service (india) private limited',
    'Madhuban enterprises private limited',
    'Adelco consultancy services private limited',
    'Vija consultants private limited',
    'Trust commodities private limited',
    'Eros properties private limited',
    'Medicamen organics limited.',
    'Maharaja heritage resorts limited',
    'AROMATIC RASAYAN PRIVATE LIMITED',
    'Circle cargo private limited',
    'Nupont exports and traders private limited',
    'Weltech industries private limited',
    'Deshmukh electrical consultants private limited',
    'R.p.engineers and project consultants private limited',
    'APICES STUDIO PRIVATE LIMITED',
    'GAC ENERGY & AUTOMATION PRIVATE LIMITED',
    'Jakson limited',
    'Hans publicity private limited',
    'Kmf solutions limited.',
    'Insync consultants private limited.',
    'Vasant associates private limited',
    'Net-dot solutions private limited',
    'Siddhant advertising private limited',
    'Onixx communication private limited',
    'Glue design private limited',
    'Ark planners private limited',
    'Multivac laraon india private limited',
    'Timetooth technologies private limited',
    'Barahi marketing private limited',
    'Iten media private limited',
    'Vayam consulting services private limited',
    'Aditi computers private limited',
    'Ocean thermoplastic elastomers private limited',
    'Aqua baths private limited',
    'Sancha builders private limited',
    'Bistro hospitality private limited',
    'Lotus garments private limited',
    'Moxie devices private limited',
    'Seba projects private limited',
    'KLBS SOFTECH PRIVATE LIMITED',
    'Epoch insurance brokers private limited',
    'Ukpi plantations private ltd',
    'Milton exhibits (india) private limited',
    'Soorya prabha hotels private limited',
    'Minaxi multi-product (india) private limited',
    'Gujarat livelihood promotion company limited',
    'Bhagat general products comapny private ltd.',
    'Palm beach estates private limited',
    'Sama meditex private limited',
    'Richards & cooke consulting private limited',
    'Rathi cottex private limited.',
    'Theni ananda krishna textile mills private limited',
    'Bendochy agro products pvt ltd',
    'Ipso foods private limited',
    'Baruki agro and oils private limited',
    'Mayur chem tech pvt ltd',
    'Luxra enterprises private limited',
    'S.p.s.a. silks private limited',
    'Shyam indospin limited',
    'Badri vishal cottex private limited',
    'Varthamana food products private limited',
    'Vandhara resorts private limited',
    'Modern milk producer company limited (under part ixa of the companies act 1956',
    'Manyata agro industries private limited',
    'MEGASTAR FOODS LIMITED',
    'Dugar polymers limited',
    'Koncherry weavers private limited',
    'Nandivalley winery private limited',
    'Goyal corporation private limited',
    'GOODWILL IMPEX LIMITED',
    'SALONA BICHONA FABTEX INDIA PRIVATE LIMITED',
    'Moonak distillers and bottlers private limited',
    'Bommidala enterprises private limited',
    'POLISETTY SOMASUNDARAM TOBACCO THRESHERS PRIVATE LIMITED',
    'Sarvoday textile industries private limited',
    'SHREE RAGHUKUL TEXPRINTS PRIVATE LIMITED',
    'Maharashtra fibres and syntex limited',
    'Vijaylene textile industries private limited',
    'Rahul synthetics pvt ltd',
    'Chhajer synthetics private limited',
    'Srivinayagaa textiles private limited',
    'Abhi spins india private limited',
    'Pavanraj fabs india private limited',
    'Jai shiv shankar spinners (india) private limited',
    'Prem fibres pvt ltd',
    'Arunoday fibre to fabric development services private limited',
    'Arun textile engineers private limited',
    'Mawandia clothing private limited',
    'Arihant texolene pvt ltd',
    'Hindesa yarns private limited',
    'A1 confectioneries company private limited',
    'Mecgale agro products private limited',
    'Golecha traders private limited',
    'Mayank global finance limited',
    'KUTE SONS FRESH DAIRY PRIVATE LIMITED',
    'Deccan star distilleries india private limited',
    'KANWAL FOODS AND SPICES PRIVATE LIMITED',
    'Priya home furnishings private limited',
    'Vardhman yarns and threads limited',
    'Vtl investments limited',
    'Indifabs overseas private limited',
    'Arunima agro exim private limited',
    'Dhara foods private limited',
    'GENERAL POLYTEX PRIVATE LIMITED',
    'VARDHMAN METALLIC PRIVATE LIMITED',
    'Nazco foods private limited',
    'Kottex industries private limited',
    'Laxmisagar processors private limited',
    'Alltex exim private limited',
    'Sanghvi denim junction private limited',
    'Gretex industries limited',
    'Twills clothing private limited',
    'Jain cord industries private limited',
    'Maroo carpets private limited',
    'Abhijit fabrics private limited',
    'S r nangalia and sons (syntex) pvt ltd',
    'Narain labels (india) p ltd',
    'Kaushal silk mills private limited',
    'Rishabh indotex limited',
    'Connect textile & processing industries private limited',
    'Fabstract clothing india private limited',
    'Rohit ginning and pressing mills private limited',
    'Satya designs private limited',
    'GOYAL KNITFAB PRIVATE LIMITED',
    'Aph garments private limited',
    'Hss apparel private limited',
    'Shp apparel private limited',
    'Ssh garments private limited',
    'Ap apparel private limited',
    'JAGDAMBA PRINTS PVT LTD',
    'Dc aj textures private limited',
    'Himson engineering private limited',
    'Stori fashions private limited',
    'Finesse fashions private limited',
    'Abacus textiles private limited',
    'Nagarwala cotton processors private limited',
    'Pondy dyeing pvt.ltd.',
    'Panache fashions private limited',
    'House of wandering silk private limited',
    'Hasasi india private limited',
    'Fruit of the loom india private limited',
    'Gatsby collection private limited',
    'Pam apparels private limited',
    'Pancon knits private limited',
    'Quantum knits private limited',
    'Instyle apparels pvt ltd',
    'Numero exports pvt ltd',
    'Radhamani apparels private limited',
    'Webtex integrated textile park infra limited',
    'Salona bichona home furnishing private limited',
    'Arhs clothing private limited',
    'Just jacquard texfab private limited',
    'Planet clothing private limited',
    'SRI LAKSHMI SARASWATHI HOLDINGS LIMITED',
    'Lgw industries limited',
    'Norsting textiles private limited',
    'Western alfa leather private limited',
    'Live cube designs workshop private limited',
    'Theme international limited',
    'Solargise grapp energies private limited',
    'Shaswath energy private limited',
    'PRATAP ENERGY SOLUTIONS PRIVATE LIMITED',
    'Jai mangal infrapowers private limited',
    'Sudan solar energy private limited',
    'Kohinoor power private limited',
    'ASL INDUSTRIES LIMITED',
    'SHRADDHA JEWELS PRIVATE LIMITED',
    'Sarda eco power limited',
    'MOURYA AQUEX PRIVATE LIMITED',
    'ASSETMINE CAPITAL PRIVATE LIMITED',
    'Gammon power limited',
    'Smtc power and industries private limited',
    'TURTLE TURBINES PRIVATE LIMITED',
    'GREENKO SRI SAI KRISHNA HYDRO ENERGIES PRIVATE LIMITED',
    'Ravindra heraeus private limited',
    'Gemco designers private limited',
    'SIKKIM POWER TRANSMISSION LIMITED',
    'Naba power private limited',
    'Rajiv enterprise pvt ltd',
    'Sajjan singh and company enterprise private limited',
    'B v l power systems private limited',
    'GREENKO ANUBHAV HYDEL POWER PRIVATE LIMITED',
    'Tamilnadu generation and distribution corporation limited',
    'Lohit urja private limited',
    'Surana mercantiles private limited',
    'Greenway building materials india private limited',
    'Azure surya private limited',
    'Azure photovoltaic private limited',
    'Powergrid unchahar transmission limited',
    'Bsl energy limited',
    'Shubodh electricals private limited',
    'Pnm katyani packagings private limited',
    'Green practices private limited',
    'Tpr autoparts mfg. india private limited',
    'Leakless gasket india private limited',
    'JAY VIJAY PROPERTY MANAGEMENT PRIVATE LIMITED',
    'Lotus powergrid private limited',
    'VAPOUR DESAL TECHNOLOGIES PRIVATE LIMITED',
    'Azure power infrastructure private limited',
    'Shatrunjaya energy private limited',
    'Haryana biomass power limited',
    'Krishna hi-end projects private limited',
    'Nupur heights private limited',
    'Kec power india private limited',
    'Ved power ventures private limited',
    'Musetta builders & developers private limited',
    'Niobe builders & developers private limited',
    'Ophira builders & developers private limited',
    'Pegeen builders & developers private limited',
    'Ojas buildmart private limited',
    'Shri rishabhnath buildwell private limited',
    'Darbari green energy systems limited',
    'Dlf residential developers limited',
    'Azure solar private limited',
    'Shanti niketan infratech private limited',
    'Navratna infrastructure limited',
    'Kohinoor hydro energy private limited',
    'Agni bio-power energy private limited',
    'Swire tech-park projects private limited',
    'Hyderabad jabilli properties private limited',
    'Larkspur properties private limited',
    'Tanot wind power ventures private limited',
    'Mina builders and developers limited',
    'Southern wind farms limited',
    'Varuna energy & water private limited',
    'Lightmotif automation sensors and systems private limited',
    'Azure urja private limited',
    'Sky build pvt ltd',
    'B s r grihnirman pvt ltd',
    'Hastiraj premises pvt ltd',
    'Rt renewable energy india private limited',
    'Galilei solar india private limited',
    'Jaitech power house private limited',
    'Mitul flats private limited',
    'Bright warehousing and leasing private limited',
    'Precision infomatic (madras ) private limited',
    'Nahar builders and developers limited',
    'Km developers private limited',
    'Harsh infrastructure private limited',
    'Nampa steel & power (india) private limited',
    'Vedansh water solutions private limited',
    'Recoll projects private limited',
    'Shreelaxmi housing private limited',
    'Jailara udyog private limited',
    'Samman properties private limited',
    'Fhl landbase private limited',
    'Dorato infrastructure private limited',
    'ORIEL COMMERCIAL PRIVATE LIMITED',
    'Flora facilities private limited',
    'ROHIT ASSOCIATES CITIES AND RAILS PRIVATE LIMITED',
    'Shanta kumar engineering hydro project private limited',
    'Tefilah infrastructure private limited',
    'Relatyr developers & engineers private limited',
    'Globus engineering and technical solutions private limited',
    'Vinod shashank chakor private limited',
    'Kanumuru infrastructure company limited',
    'Annapurna construction private limited',
    'Parveen holidays private limited',
    'Garhwal himalayan explorations private limited',
    'Elleys industries (india) private limited',
    'Procam worldwide logistics private limited',
    '7eleven shipping private limited',
    'Vision enterprise private limited',
    'Zion express cargo private limited',
    'Ahmedabad bengal roadways private limited',
    'Well-trans logistics (india) private limited',
    'EASY TRIP PLANNERS LIMITED',
    'Zuari bulk carriers private limited',
    'Shrinath travel agency private limited',
    'Transbulk shipping & trading private limited',
    'Unilog logistics and warehousing private limited',
    'DGS LOGISTICS & SHIPPING (INDIA) PRIVATE LIMITED',
    'Apexsea logistics private limited',
    'JAYSHREE CLEARING, FORWARDING AND SHIPPING AGENTS PRIVATE LIMITED',
    'Priyadarshini forwarders private limited',
    'Msc agency (india) private limited',
    'Deugro freight forwarding (india) private limited',
    'Tour on wings private limited',
    'Masseys enterprises private limited',
    'Adani agri fresh limited',
    'Supply chain logistics private limited',
    'Elite shipping synergies private limited',
    'Mesco aerospace limited',
    'Nissin abc logistics private limited',
    'Sohom shipping private limited',
    'Snca channel management private limited',
    'Safexpress private limited',
    'Dhun radio private limited',
    'Cosmo shipping services private limited',
    'G m s worldwide express private limited',
    'Wen-parker logistics (india) private limited',
    'Bhartiya integrated cargo solutions private limited',
    'Getway india holidays private limited',
    'Jmsg communications private limited',
    'Business communications (guj) pvt ltd',
    'Curacy telecom limited',
    'Klover tel private limited',
    'Travel geeks private limited',
    'Gujarat holidays (india) private limited',
    'RADIANT LIFE CARE PRIVATE LIMITED',
    'Kamadhenu travels private limited',
    'Valsala travels private limited',
    'Cosima travel and trade links private limited',
    'Indigo island leisure private limited',
    'Tri marine pvt ltd',
    'Hopco travels private limited',
    'Griffon tours and travel private limited',
    'Pedestal finance and trading private limited',
    'BARGANZA TRAVEL & CARGO P LTD.',
    'Suman airfreight private limited',
    'TRAMIN RESEARCH & CONSULTING PRIVATE LIMITED',
    'MEXMON FINANCIALS PRIVATE LIMITED',
    'Sanatan financers and real estates private limited',
    'International freight systems company private limited',
    'Ulike infinlease private limited',
    'Muthoot fincorp limited',
    'Lokesh secfin pvt ltd',
    'JAYBHARAT FINSTOCK PRIVATE LIMITED',
    'Ria deco-range private limited',
    'Remi finance and investment private limited',
    'Hasnain investments private limited',
    'GANGOLY FOODS PROCESSING PRIVATE LIMITED',
    'Vapkon finance and investment private limited',
    'Okasa investment and finance company pvt ltd',
    'Bhagwati shipping private limited',
    'Taurus lines private limited',
    'Mercury couriers pvt.ltd.',
    'Bakshi tours and travels private limited',
    'Prj logistics india private limited',
    'Loyal tours and travels private limited',
    'Punarnava capital private limited',
    'Disari india savings & credit corporation limited',
    'Marengo investment & trading company private limited',
    'EFGEE TRADING PRIVATE LIMITED',
    'Nirankar investments private limited',
    'Motrik investments pvt ltd',
    'MUTHOOT MONEY LIMITED',
    'Shankara holdings private limited',
    'Jv holding private limited',
    'DOULOS JEWELS LIMITED',
    'Sharp financial services private limited',
    'Prograssive holdings private limited',
    'Ikon financial servicesltd',
    'Raghvi finance limited',
    'GROW ',
    'GROW INVESTMENTS & HOLDINGS PVT LTD',
    'Polmann india limited',
    'Saptrishi consultancy services limited',
    'Capital auto marketing private limited',
    'Mi india capital & investment private limited',
    'Corporate scrips private limited',
    'SHRIRAM VALUE SERVICES Limited',
    'Mohandas k kurup private limited',
    'Dpj viniyog pvt ltd',
    'Mec netcomm private limited',
    'Genband telecommunications private limited',
    'FIRST MOBITAL PRIVATE LIMITED',
    'Shree karni finance private limited',
    'Pld securities private limited',
    'Bhadra electronics private limited',
    'Sriyah insurance brokers private limited',
    'Elite insurance brokers private limited',
    'Galaxy finsec private limited',
    'Idol capital market services private limited',
    'Sara investment services private limited',
    'Chitturi asset holdings private limited',
    'Parshvanath finvest private limited',
    'YSRV BUSINESS CONSULTING PRIVATE LIMITED',
    'Bizmentor consultancy services private limited',
    'Promo tec india private limited',
    'Ramaya imaging & technologies private limited',
    'Ankar industries pvt ltd',
    'Sun cruiser lubricants limited',
    'Shah laminates private limited',
    'Coral pharmaceuticals private limited',
    'Dwarkesh pharmaceutical pvt ltd',
    'Shree ramanand industries private limited',
    'Valley fibres and tissues limited',
    'Theon pharmaceuticals limited',
    'Sreedhary ayurvedic resorts private limited',
    'Zeal resorts private limited',
    'Sago hotels private limited',
    'Alcon hotels (goa) private limited',
    'Keso trans (india) private limited',
    'Arti truck line pvt ltd',
    'Meghalaya road carriers pvt ltd',
    'Lakhanpur coal carriers private limited',
    'LCC CARGO HOLDINGS PRIVATE LIMITED',
    'Ajanta aero-handling private limited',
    'Sangam logistics private limited',
    'Sweet home projects private limited',
    'Swraj resorts private limited',
    'Peerless hotels ltd.',
    'West fort hotels private limited',
    'Fragrant nature retreat and resort private limited',
    'Carex cargo forwarders private limited.',
    'Shine logistics private limited',
    'Thyssenkrupp aerospace india private limited',
    'Viking container freight station private limited',
    'Mahindra infrastructure developers limited',
    'Shambhunath agro tech private limited',
    'Ild warehouse private limited',
    'Tt logistics and cargo private limited',
    'Agrawal handling private limited',
    'Cardinal air transport company private limited',
    'Chowgule and company private limited.',
    'Milestone infraventures private limited',
    'Dragonfly resorts private limited',
    'Hotel pal regency private limited',
    'Sandy resort private limited',
    'KALYANI RESORTS PRIVATE LIMITED',
    'Southall travel private limited',
    'City vacations private limited',
    'Chime tours private limited',
    'Royal western (india) hotels private limited',
    'Kabir infra private limited',
    'Prasanna termitels limited',
    'KARGAINDIA ROADWAYS PRIVATE LIMITED',
    'First flight air freight private limited',
    'RAJASTHAN ROUTES TRAILS PRIVATE LIMITED',
    'GUJARAT TRAILS PRIVATE LIMITED',
    'Star destination management company private limited',
    'Victoria travels pvt ltd',
    'Bhajjanka transport private limited',
    'Royal connexions private limited',
    'Sagami shine logistics india private limited',
    'Advantage india logistics private limited',
    'SASH REFKART SOLUTIONS PRIVATE LIMITED',
    'Rangoli tours private limited',
    'Er tours private limited',
    'Mec infocomm private limited',
    'CROWN WORLDWIDE PRIVATE LIMITED',
    'CREST DIGITEL PRIVATE LIMITED',
    'De travelscapes private limited',
    'Metro skynet ltd',
    'Greatech telecom technologies private limited',
    'Kasal india private limited',
    'Msp enterprises private limited',
    'Kovalam resort private limited',
    'Nightingale finance and leasing limited',
    'GENINS INDIA INSURANCE TPA LIMITED',
    'Grand holidays travel private limited',
    'Pasl windtech private limited',
    'Ritual holidays private limited',
    'SPICE ROUTE TOURS & TRAVELS PRIVATE LIMITED',
    'Kailashpati forest pvt ltd',
    'Alpha air travels private limited',
    'Kalypso adventures private limited',
    'SWOSTI TRAVELS & EXPORTS PRIVATE LIMITED',
    'A.l. logistics private limited',
    'Vishnupriya business private limited',
    'Bhagyoday investments pvt ltd',
    'Punjab reliable investments pvt ltd',
    'Rajat travellers pvt ltd',
    'Savitri techno industries limited',
    'Sudhir credit pvt. ltd.',
    'STEWART ENCLAVE & FINVEST PVT LTD',
    'Incredible vacations (india) private limited',
    'Travelz holidays private limited',
    'Ten to ten cable t v network private limited',
    'Alm global finlease limited',
    'Tingli finvest private limited',
    'Eastern auto investo pvt ltd',
    'Alokik finance and investment pvt ltd',
    'RAIZING GLOBAL PRIVATE LIMITED',
    'Ns family investments p ltd',
    'Acumen stock broking private limited',
    'Alliance share broking private limited',
    'KINSFOLK MARKETING PRIVATE LIMITED',
    'Sodder leasing and holdings private limited',
    'Rajdhani trade & finance pvt ltd',
    'Ektavihar finance and investment pvt ltd',
    'GAURAIYA PROPERTIES MANAGEMENT PRIVATE LIMITED',
    'Narcissus investments private limited',
    'I-NOK ENTERTAINMENT PRIVATE LIMITED',
    'Ashiana fincap private limited',
    'Trustline finvest limited',
    'Harsharatna finance and investments private limited',
    'Annandale leasing private limited',
    'Sanmar holdings limited',
    'Sudharsanam investments limited',
    'Karnani investments pvt ltd',
    'Dinesh viniyog private limited',
    'Rajnigandha promotions pvt ltd',
    'Mercurius corporate advisory services private limited',
    'Rajasthan traders and financiers pvt ltd',
    'Concept castings private limited',
    'Liberty investments private limited vt ltd',
    'Comet finvest pvt ltd',
    'Sadashiv holdings private limited',
    'Sms interiors private limited',
    'MAGAL SECURITY SYSTEMS (INDIA) LIMITED',
    'Vidyagyan foundation',
    'Iiss india organisation',
    'Kalyani skills private limited',
    'KALYANI SCHOOL ALUMNI ASSOCIATION',
    'Delhi advanced dermatology private limited',
    'Asr consulting services private limited',
    'Tdi healthcare limited',
    'Nanogen healthcare private limited',
    'Focus dental services private limited',
    'Manna healthcare private limited',
    'OYETEL TELECOMMUNICATIONS PRIVATE LIMITED',
    'Dmc healthcare private limited',
    'Rameshchand investments and leasing private limited',
    'Ndps computers private limited',
    'SKS INDIA PRIVATE LIMITED',
    'Pn memorial neuro centre & research institute limited',
    'Nanocare health services private limited',
    'Vedant agro private limited',
    'KAILASH HEALTH SOLUTIONS PRIVATE LIMITED',
    'Satya industries private limited',
    'Deccan chronicle secunderabad private limited',
    'Ccl products (india) limited',
    'MILKFOOD LIMITED',
    'Sri chamundeswari sugars limited',
    'TATA CONSUMER PRODUCTS LIMITED',
    'Vardhman textiles limited',
    'Loyal textile mills limited',
    'Sun paper mill limited',
    'Polymer papers limited',
    'Deepak nitrite limited',
    'Dic india limited',
    'Ttk healthcare limited',
    'Indraprastha medical corporation limited',
    'Nitta gelatin india limited',
    'Sen pet (india) limited',
    'Bharat forge ltd',
    'F g p limited',
    'Steel products ltd.',
    'Carnation industries ltd.',
    'The tinplate company of india ltd',
    'TEGA MCNALLY MINERALS LIMITED',
    'Kirloskar industries limited',
    'Spm engineers ltd',
    'Sparkwater productions (india) private limited',
    'ODDJOINT ART PRIVATE LIMITED',
    'Capricorn group private limited',
    'Likhami trading & mfg. co ltd',
    'ELITECON INTERNATIONAL LIMITED',
    'Amit commercial co ltd',
    'Champion commercial co. ltd',
    'OLYMPIC COMMERCIAL ENTERPRISES PRIVATE LIMITED',
    'Trade wings limited',
    'Premier road carriers ltd',
    'Rtl logistics limited',
    'Premier auto finance ltd',
    'Prime music private limited',
    'Compucom software limited',
    'ESS VEE HOLDINGS PRIVATE LIMITED',
    'Isf limited',
    'Ifci limited',
    'Aidias consulting private limited',
    'Doabz solutions private limited',
    'Peregrine security private limited',
    'Cyber astro limited',
    'S. d. brand seller private limited',
    'Woollen and textile industries limited',
    'Macrame infrastructure private limited',
    'Richa global exports private limited',
    'Vulcan lubricants (india) limited',
    'Kadimi tool manufacturing company private limited',
    'Kirti gaurav builders and developers p ltd',
    'Eastwell industries private limited',
    'Indo-pacific poly-fibres private limited',
    'Northern motorsport',
    'Sindhu farms pvt ltd',
    'Nisco agri tech(bangalore) private limited',
    'Kejriwal bee care india private limited',
    'Tangerine farms private limited.',
    'Vishla agro tech private limited',
    'Kbb nuts private limited',
    'Calcutta cricket & football club',
    'Fame solutions private limited',
    'Amalgamated plantations private limited',
    'D n m computers pvt ltd',
    'DEVICEBOOK INNOVATION PRIVATE LIMITED',
    'Shaba visa facilitation services private limited',
    'Sgp cultivation farms limited',
    'Green guardians organic farms and exports private limited',
    'Arunodyan farms private limited',
    'Nutrilite foods private limited',
    'Brandmovers interactive india private limited',
    'Freelancer online india private limited',
    'Jk lakshmi cement limited',
    'Shri amarsinhji stationery industries limited',
    'Haryana forest development corporation limited',
    'Agarwalla timbers private limited',
    'VEDARI ENGINEERING PRIVATE LIMITED',
    'United vander horst ltd',
    'Aqua marine private limited',
    'Shree tulsi online com- limited',
    'ECHO BUILDTECH LIMITED',
    'GRAND BUILDTECH LIMITED',
    'Katras jherriah coal co ltd',
    'Dolphin mining services private limited',
    'Timblo private limited',
    'Klick international private limited',
    'Lmd machines technologies private limited',
    'Udit enterprises & infrastructure private limited',
    'ENTRAK HERITAGE PRODUCTS PRIVATE LIMITED',
    'CELICA COMMERCE PRIVATE LIMITED',
    'Swastik auto agencies private limited',
    'Jaws manufacturing company private limited',
    'Salasar motors private limited',
    'Manjula exports private ltd',
    'Sion shipping private limited',
    'Paras auto wheels private limited',
    'Android motors private limited',
    'Quality exim private limited',
    'Zupitex (india) private limited',
    'Karica containers and sales private limited',
    'Cygnus vyapar private limited',
    'Radiance fluid handling equipments private limited',
    'Strange impex private limited',
    'Marche retail private limited',
    'Ritika mercantiles private limited',
    'V. n. cranes private limited',
    'Happily unmarried marketing private limited',
    'Arvind impex (india) private limited',
    'Shri govindam traders private limited',
    'Dwarka tradex private limited',
    'Grs enterprise private limited',
    'ANDY HOME PRIVATE LIMITED',
    'Indygreen technologies private limited',
    'Maharashtra steels rolling mills private limited',
    'Sheromani traders private limited',
    'J.perrot enterprises private limited',
    'European machinery private limited',
    'Fimosys online solutions private limited',
    'Iceberg cold chain private limited',
    'Ninth avenue industries private limited',
    'Multi speciality products india private limited',
    'Sunshine exports pvt ltd',
    'Palit equipment sales private limited',
    'Jc retail india private limited',
    'Singhal business private limited',
    'Auto distributors ltd',
    'Opi export ltd.',
    'P.g. machine fabriks private limited',
    'Fylfot impex private limited',
    'Adarsh tradeventures private limited',
    'N r trading co pvt ltd',
    'MATANGI TRADERS & INVESTORS PVT LTD',
    'Jindal futures private limited',
    'Tara sales limited',
    'Lahoti terra knitfab limited',
    'EMINENCE POINT EXPO & DEVELOPER PVT. LTD.',
    'Nityanand merchantile ltd',
    'SAVITRI WELLNESS PRIVATE LIMITED',
    'G.d. dealcom private limited',
    'Al maha foods international private limited',
    'Nihon commercial pvt ltd',
    'Lotus tea packers private limited',
    'PDB VENTURE PRIVATE LIMITED',
    'Bucha exports private limited',
    'He traders private limited',
    'Ace detergents private limited',
    'Isgec exports limited.',
    'Macsar mercantile private limited',
    'Dap impex private limited',
    'Sky innovation tech labs private limited',
    'Mannschaft ingenieure (india) private limited',
    'JEKSON HYDRAULIC PRIVATE LIMITED',
    'Multi cartons pvt ltd',
    'Khushi commotrade private limited',
    'Sungold suppliers private limited',
    'Blueberry sales private limited',
    'Accent barter private limited',
    'VINNY OVERSEAS LIMITED',
    'Speed-a-way private limited',
    'Beatle trading private limited',
    'Intimate dealcom private limited',
    'Sonata exim private limited',
    'Pushpkala merchants private limited',
    'Afi enterprises private limited',
    'Carbon finance limited',
    'Bajoria enterprises limited',
    'Evanti retail solution private limited',
    'Codamark pvt ltd',
    'SITCH CURATION PRIVATE LIMITED',
    'Quality nz imports private limited',
    'Aryansh trading private limited',
    'Surendra multitrade private limited',
    'Bangur exim private limited',
    'Logicfab semiconductors private limited',
    'Bakratunda vincom private limited',
    'Aarohi solar private limited',
    'Anukaran suppliers private limited',
    'SONA WINES PRIVATE LIMITED',
    'Kerala state civil supplies corpn ltd',
    'ANJIL STABILIZERS PRIVATE LIMITED',
    'Fiori creations private limited',
    'Growel impex pvt. ltd.',
    'P.k. overseas merchandising private limited',
    'Swift impex pvt. ltd.',
    'Kanwar enterprises private limited',
    'Shree rani sati tradecorp private limited',
    'M3 CREATOR PRIVATE LIMITED',
    'Rossco international private limited',
    'Sohrab impex limited',
    'SUPREME TRADE & INVESTMENT PVT. LTD.',
    'Universal traders and investors pvt. ltd.',
    'Inspec oils limited',
    'Alp retail private limited',
    'Hts exim private limited',
    'Ideal hi tech engineering equipment private limited',
    'N. chirag travels private limited',
    'Lady-dona infra projects limited',
    'Airline management services india private limited',
    'Viridian capital and financial services private limited',
    'Universal erectors private limited',
    'Cdl financial services private limited',
    'SHINE FUTURE WORLDWIDE CONSULTANTS PRIVATE LIMITED',
    'Ghibellines security solutions limited',
    'Aps security services private limited',
    'Twenty four secure india private limited',
    'C s portfolio private limited',
    'Appletree building maintenance private limited',
    'Maxpro natural resources private limited',
    'Osb agencies private limited',
    'Omega designs private limited',
    'Princeton investments private limited',
    'North megatech sales private limited',
    'Amkar furnishers pvt ltd',
    'Can-asia immigration consultancy services limited',
    'Softpro application systems private limited',
    'Star dimensions goa private limited',
    'The india thermit corporation limited',
    'Securipax packaging private limited',
    'Sribir industries limited',
    'Hexagon jobintex consultants private limited',
    'Metier enterprises (india) private limited',
    'Base art philosophy ecology india private limited',
    'Seahorse marketing private limited',
    'Future abroad education consultants private limited',
    'Acquisory india consulting private limited',
    'Navitas green power (fuel management) private limited',
    'Applied life private limited',
    'Jwala energy resources private limited',
    'Stamps of india private limited',
    'Indimedics healthcare private limited',
    'WINNAGE ENTERPRISES PRIVATE LIMITED',
    'Cas weighing india private limited',
    'Jagriti impex consultants private limited',
    'Bombay burmah trading employees welfare compny limited',
    'ROHIT TECHSERVE LIMITED',
    'MAN ENERGY SOLUTIONS INDIA PRIVATE LIMITED',
    'Minar heat transfer private limited',
    'Trac eco&safari park private limited',
    'Madras race club',
    'Ccd technical solutions private limited',
    'V n c a holdings private limited',
    'Elixir services india private limited',
    'Smart proforce private limited',
    'Creative design consultants & engineers private limited',
    'Infra equip private limited',
    'Ils network private limited',
    'Livgreen cleantech private limited',
    'Heritage health knowledge services private limited',
    'Radco marketing private limited',
    'Oscorp industries private limited',
    'Tarway associates private limited',
    'Bst security and labour services private limited',
    'Trinetra services private limited',
    'Valuence training and research private limited',
    'INDIAVIDUAL LEARNING LIMITED',
    'Vidya edutech pvt ltd',
    'VIRTUOUS INDIA PRIVATE LIMITED',
    'PIONEER HOSE AND HYDRAULICS PRIVATE LIMITED',
    'GLOBUS WAREHOUSING AND TRADING PRIVATE LIMITED',
    'Akg india private limited',
    'Retro crafts private limited',
    'Karol bagh vaults private limited',
    'Vardhman business ventures limited',
    'Vivial synergies private limited',
    'Kgc proeducation private limited',
    'Leap skills academy private limited',
    'Pathshaala coaching classes private limited',
    'Mahavir eco projects private limited',
    'Chaman shakuntla projects private limited',
    'Harley nirafon (india) pvt ltd',
    'Latest capital services private limited',
    'AADISHAKTI METAL RECYCLING PRIVATE LIMITED',
    'Lumis consulting partners india private limited',
    'WELFARE ASSOCIATION LIMITED',
    'International center for research on women',
    'Airshield envirotech private limited',
    'Spic officers and staff welfare foundation',
    'Altop industries ltd',
    'The ecumenical christian centre',
    'Calcutta club ltd',
    'Tejaswani developers private limited',
    'Alcon constructions (goa) private limited',
    'Dristi construction private limited',
    'Salwan buildkraft private limited',
    'Brg construction private limited',
    'Kishan infrastructure private limited',
    'Crescent projects private limited',
    'Shpra developers private limited',
    'Hi span builders private limited',
    'Tarangan leisure private limited',
    'Konark habitas private limited',
    'Terra realcon private limited',
    'LOGSHIP AVIATION PRIVATE LIMITED',
    'Swastik acres private limited',
    'B. g. shirke construction technology private limited',
    'JOHARI DIGITAL HEALTHCARE LIMITED',
    'Ocean housing and constructions private limited',
    'Delta propcon private limited',
    'J l f foundation private limited',
    'Mepro pharmaceuticals private limited',
    'Salasar balaji propcon private limited',
    'Anuradha landcon private limited',
    'Salarpuria griha nirman private limited',
    'Sequence properties private limited',
    'Patcorp construction private limited',
    'Avani projects and infrastructure limited',
    'Dev sidh assim nirmiti private limited',
    'Planet herbs lifesciences private limited',
    'Two square ecotechnologies private limited',
    'Vrundali constructions private limited',
    'Tarangan infraventures private limited',
    'Jalan properties pvt ltd',
    'Jayshree vyapar limited',
    'Delta protech private limited',
    'MOSH VARAYA INFRASTRUCTURE LIMITED',
    'R.K.TRANSPORT AND CONSTRUCTIONS LIMITED',
    'Omaxe power private limited',
    'Gautam chand builders private limited',
    'KARUR TEXTILE PARK PRIVATE LIMITED',
    'Suchita millenium projects private limited',
    'Ashray realty management private limited.',
    'Unicon home solutions private limited',
    'Wave megacity centre private limited',
    'Asia (chennai) engineering company private limited',
    'Well water services pvt ltd',
    'Smarika infrastructure private limited',
    'Euro enterprises limited',
    'Orizon resources private limited',
    'Chandra hi.tech engineers private limited',
    'Epsa india projects private limited',
    'Duville estates private limited',
    'Amrut infra concepts private limited',
    'Mega hydel engineers private limited',
    'Maa highways private limited',
    'Shri kanchi kamakshi infraventures private limited',
    'Octagon nirman private limited',
    'Ifci infrastructure development limited',
    'ENSOL INDUSTRIES PRIVATE LIMITED',
    'Sagun premises private limited',
    'Kyalie developers private limited',
    'Sag real estates private limited',
    'HILARIOUS INFRAPROJECTS PRIVATE LIMITED',
    'Everest railway construction private limited',
    'Suntrek electricals private limited',
    'Prateek buildhome private limited',
    'Siddheshwari griha nirman private limited',
    'ACUITY PROFESSIONAL PRIVATE LIMITED',
    'Abhinandan infrastructure private limited',
    'Gomti power infrastructure private limited',
    'GCS INVESTMENTS AND FINANCIAL SERVICES PRIVATE LIMITED',
    'Civil engineers enterprises pvt ltd',
    'Infra 13 private limited',
    'Tricon infrastructures private limited',
    'Unique realprojects private limited',
    'R v towers private limited',
    'Asia-pacific construction private limited',
    'Camelia griha nirman private limited',
    'Odisha construction corporation limited',
    'Mayances construction & engineering services private limited',
    'SUBHKIRAN BUILDERS & FINANCE PVT LTD',
    'SWASTIC PRANITI PRIVATE LIMITED',
    'Ethical constructions private limited',
    'Powertec infrastructure holdings private limited',
    'POWERHF INDIA PRIVATE LIMITED',
    'Foresight construction private limited',
    'A n b infrastructure projects private limited',
    'Shakti realtech private limited.',
    'Kissan bio energies private limited.',
    'Spacekon constructions private limited',
    'I. zone infrastructure & developers private limited',
    'Singhal propbuild private limited',
    'Prerit infra developers private limited',
    'Myna real estates private limited',
    'Overtop realcon private limited',
    'Sigma-c infrastructure private limited',
    'North east warehousing private limited',
    'Ridhi sidhi apartments private limited',
    'Paramount infrabuild private limited',
    'Shriji luxury homes private limited',
    'Ambience home developers private limited',
    'Auto kashyap india private limited',
    'Sanghi cars (india) private limited',
    'Gurudev motors private limited',
    'M g t motors (automobiles) private limited',
    'Alankar gems and jewellery private limited',
    'Sushant buildcon private limited',
    'Kashyap motors private limited',
    'Century auto services private limited',
    'Dreamland buildshoppe private limited',
    'V.S.T.AUTO ANCILLARIES PRIVATE LIMITED',
    'Netx communications private limited',
    'Jalan telecom private limited',
    'Patni infotech limited',
    'Gravity computech private limited',
    'Glitter software private limited',
    'Ghoomla technologies private limited',
    'Feida india private limited',
    'Nirmal agricultural research and development foundation',
    'Nce research labs private limited',
    'Kishangarh environmental development action private limited',
    'Sm lawdigest com limited',
    'Geotrans technologies private limited',
    'Asc outsourcing private limited',
    'Tcg media limited',
    'Rajgul creditnvest private limited',
    'Wave finserve private limited',
    'Golden lotus investments private limited',
    'Softnet technoware private limited',
    'Aks technoconsultants private limited',
    'Hcl corporation private limited',
    'Zeus numerix private limited',
    'Bonus info private limited',
    'Binary solutions private limited',
    'E gramin infotech private limited',
    'Interstar financial services limited.',
    'Anthem global technology services private limited',
    'Apinet solutions private limited',
    'Pristine ventures private limited',
    'Convergence consultants private limited',
    'Gemini inter services private limited',
    'Agatsa software private limited',
    'Precious money- changer and export private limited',
    'Sparxsys solutions private limited',
    'Moti mahal delux management services private limited',
    'Powertec engineering private limited',
    'Ava infotech private limited',
    'Tiburon media group india private limited',
    'Nreach online services private limited',
    'Inventra technologies private limited',
    'Sepia advertising private limited',
    'Vsh financial consultants private limited',
    'Accurate comsec solutions private limited',
    'Netcreativemind solutions private limited',
    'Numero infotech private limited',
    'Eml consultancy services private limited',
    'Raviraj securities pvt ltd',
    'SN GLOBAL INFRA RESEARCH SOLUTIONS PRIVATE LIMITED',
    'Althea hr solutions private limited',
    'H.g.s.machines private limited',
    'Magna capital advisors private limited',
    'Kettle communications private limited',
    'Kasvu Consulting Private Limited',
    'Grey fox project management company private limited',
    'Customised technologies private limited',
    'Sparrow buildwell private limited',
    'Anandi tradex limited',
    'Cathexis consulting private limited',
    'Ardent alloys private limited',
    'Team results corporate solutions private limited',
    'Samurai technoweigh (india) private limited',
    'Learnzippy e-learning services private limited',
    'Henu studio private limited',
    'Splash films private limited',
    'Digital doctor private limited',
    'Maps-n-grow consulting private limited',
    'Integrated wireless solutions private limited',
    'Syne india private limited',
    'GAIAGEN TECHNOLOGIES PRIVATE LIMITED',
    'Innovative corporate services private limited',
    'INTEGRITY PROJECTS & TECHNOLOGIES INDIA PRIVATE LIMITED',
    'FINESSE FACILITY SERVICES PRIVATE LIMITED',
    'Tripuramultinational india private limited',
    'TALENT FINDER CONSULTANTS PRIVATE LIMITED (OPC)',
    'Hungover enterprises private limited',
    'Enoch ventures private limited',
    'Inimitable solutions private limited',
    'Jmn infotech private limited',
    'International trade expo centre limited',
    'Stratcon consultancy private limited',
    'Mancer consulting services private limited.',
    'Osgan consultants pvt ltd',
    'Intelivisto consulting india private limited',
    'Jobline consultants india private limited',
    'Psk resorts & hotels private limited',
    'Sandalwood mall management private limited',
    'White spaces consulting private limited',
    'Techno9 industrial engineering private limited',
    'Vij engineers and consultants private limited',
    'S m industrial consultants private limited',
    'Tapasya town planners private limited',
    'Zak advisors private limited',
    'Aicon gallery new delhi private limited',
    'ORBITAL INFRASTRUCTURE CONSULTANCY AND RESEARCH PRIVATE LIMITED',
    'DUM DUM FOUNDRY & ENGINEERS PVT LTD',
    'Archtech consultants pvt ltd',
    'Cams (india) pvt. ltd.',
    'Arty ad-n-design private limited',
    'Conquest communications pvt ltd',
    'Singhma insurance broker limited',
    'Emerging edges consultants private limited',
    'Pendulum consultants private limited',
    'Besiva lifestyle private limited',
    'MULLEN LINTAS PRIVATE LIMITED',
    'SHADOW ADVERTISING & COMMUNICATIONS PRIVATE LIMITED',
    'Chakra partners consulting services private limited',
    'Sigma wear-resist products private limited',
    'Asv management services private limited',
    'Chandernagar chemicals and minerals private limited',
    'Esjay consultants pvt ltd',
    'Dayanidhi mangement pvt ltd',
    'International cars and motors limited',
    'Subh laxmi syntex limited',
    'Rajsha chemicals private limited',
    'Tyresoles goa private limited',
    'Eco polypack private limited',
    'Ttga private limited',
    'Belmont rubber private limited',
    'Prem shoes private limited',
    'Premier comtrade pvt ltd',
    'JAGANNATH POLYMERS PVT LTD',
    'Ramdoot polyvinyls private limited',
    'Interplex mazzucchelli private limited',
    'NEXTURE TECHNOLOGIES PRIVATE LIMITED',
    'Rukmini polytubes private limited',
    'Aims oxygen private limited',
    'Nippon plastics pvt ltd',
    'Swiss military lifestyle products private limited',
    'India timber trading company private limited',
    'Egi leather exports limited',
    'Sunshine tissues private limited',
    'Rohini paints private limited',
    'Amrit remedies private limited',
    'Reliance health care pvt ltd',
    'Dronn chemplast private limited',
    'Arambagh hatcheries exports ltd',
    'Rashi holdings pvt ltd.',
    'Tbk florance ceramics private limited',
    'Magadh ecobrick private limited',
    'PANARIAGROUP INDIA INDUSTRIE CERAMICHE PRIVATE LIMITED',
    'Rajvir concrete private limited',
    'Sance parenterals private limited',
    'Bonjour pharmaceuticals private limited',
    'Mark-tech composites private limited',
    'Jain electroplast private limited',
    'ARCELORMITTAL NIPPON STEEL INDIA LIMITED',
    'BHAGWAT STEEL LIMITED',
    'Cyro healthcare private limited',
    'Mabs biotech private limited',
    'Pankaja kasthuri herbals india private limited',
    'Fimakem india limited',
    'Levcon valves pvt ltd',
    'Makson machines pvt ltd',
    'Radiant moulds and compounds pvt ltd',
    'Milestone tubes private limited',
    'Athena chem-tech private limited',
    'Akross coatings private limited',
    'M gill alloys pvt ltd',
    'Pengg usha martin wires private limited',
    'A r k health care pvt ltd',
    'Chemical systems technologies (india) private limited',
    'Mehta tubes limited',
    'Primate engineers pvt ltd',
    'Stc movers private limited',
    'Shiv kripa pipes private limited',
    'Matelli tea company private limited',
    'Shree ram gum chemicals private limited',
    'Kanchan vanijya pvt ltd',
    'Overseas mercandise inspection co (india) pvt ltd',
    'Rexon industries limited',
    'Aegis wire private limited',
    'Emars steel private limited',
    'Ruia composites pvt. ltd.',
    'Ananta cement and allied products pvt ltd',
    'Apex piping systems private limited',
    'Keaa international private limited',
    'Sunita global limited',
    'Angola diamond private limited',
    'Steel & tube field india private limited',
    'A.I. SPRING & ENGG. CO. PVT. LTD.',
    'Harish tex-mach private limited',
    'Raunak polymers private limited',
    'Aditya makua engineers ltd',
    'Shiva chill rolls private limited',
    'Tega industries limited',
    'Decorative sleeves private limited',
    'Sahil plastic private limited',
    'Specialty polyfilms (india) private limited',
    'Indian steel and infrastructure private limited',
    'Punjab laminates pvt ltd',
    'Vby chem private limited',
    'Mehek forging industries private limited',
    'Asa retail solutions private limited',
    'Prime gold -sail jvc limited',
    'Camaro projects pvt ltd',
    'Schiffer and menezes india private limited',
    'Jai parvati forge limited',
    'Rd steeltech private limited',
    'Wiresys auto components private limited',
    'Lip fasteners private limited',
    'Aggarwal forgings pvt ltd',
    'MECHANO INTERNATIONAL PVT LTD',
    'Quba kitchens private limited',
    'Pmt machines limited',
    'Kepro tools and equipments private limited',
    'Nextgen plasma private limited',
    'Luman industries limited',
    'Kay jay chill rolls pvt ltd',
    'R s confab pvt ltd',
    'RQS MINING PRIVATE LIMITED',
    'C.LAL BRIGHT STEELS PRIVATE LIMITED',
    'Mohta forgings pvt ltd',
    'A s t pipes private limited',
    'PERUN INDUSTRIES PRIVATE LIMITED',
    'Amar trades ltd',
    'Kat 6 systems private limited',
    'Ashay machines private limited',
    'L&T - MHI POWER BOILERS PRIVATE LIMITED',
    'Sumangal technocast private limited',
    'Sri kirthika pipes private limited',
    'Cartonbox retail private limited',
    'Indo asia hotels private limited.',
    'Pench jungle resorts private limited',
    'Elevate entertainments private limited',
    'Seasons catering services private limited',
    'Cna enterprises private limited',
    'Vasant transport private limited',
    'Sky blue cargo private limited',
    'Nava sakthi vinayaga logistics private limited',
    'C & C HOSPITALITY (KERALA) PRIVATE LIMITED',
    'BHARAT ROADWAYS TRANSPORT LTD.',
    'Kartar bus service ltd',
    'Excel movers pvt ltd',
    'Aec transolutions private limited',
    'Manakin resorts private limited',
    'Ahuja and anand hotels private limited',
    'KANDARP TRADELINKS AND SERVICES PRIVATE LIMITED',
    'C & C HOSPITALITY PRIVATE LIMITED',
    'C & C PRIME HOTELS PRIVATE LIMITED',
    'Raydens trading private limited',
    'ALSISAR HOTELS AND RESORTS PRIVATE LIMITED',
    'Gcm aviation private limited',
    'SVL SOURCING PRIVATE LIMITED',
    'KKRISH WORLDWIDE LOGISTIC PRIVATE LIMITED',
    'Traviz solutions private limited',
    'Nexxus freight logistics systems private limited',
    'Gaurav raj carriers private limited',
    'Sreyaas cargo private limited',
    'Dossier courier private limited',
    'Tranzfreight logistics solutions private limited',
    'Sanchal fort and resort private limited',
    'Araliayas resorts private limited',
    'J M SAHA HOTELS & RESORTS PRIVATE LIMITED',
    'Swarnabhumi leisure and holidays limited',
    'Kps commodities private limited',
    'Garden retreat hotels & resorts private limited',
    'GUJARAT JHM HOTELS PRIVATE LIMITED',
    'Space circle clubs & resorts private limited',
    'Red fox hotel company private limited.',
    'Indo tours private limited',
    'K t holidays private limited',
    'India for you holidays private limited',
    'Stalwart logistics (delhi) private limited',
    'Itravels private limited',
    'M k mehendale tpt private limited',
    'Addmarc hospitality marketing services private limited',
    'Nidra hospitality private limited',
    'Lead hotels private limited',
    'Natraj and siddharth metacare private limited',
    'Atul hospitality limited',
    'Welcome resorts private limited',
    'Snr forwarders private limited',
    'Samudra alloys private limited',
    'Chrysalis holidays private limited',
    'The liberty marine syndicate private limited',
    'Vyona logistics private limited',
    'Skyland transport ltd',
    'Union roadways ltd.',
    'Main stream shipping and trading pvt ltd',
    'Sen shipping services pvt ltd',
    'Transolutions private limited',
    'Pwt logistics (india) private limited',
    'Aryaglobal agencies private limited',
    'Vivaa print & warehousing limited',
    'Refrige pvt ltd',
    'Shreemal tele services private limited',
    'Odyssey advanced telematics systems private limited',
    'Shakun communication infrastructure private limited',
    'South city communication pvt ltd',
    'Techorigin e-services private limited',
    'Audiocodes india private limited',
    'Swastic promoters pvt ltd',
    'Hemshila properties limited',
    'The india ice acrated water & cold storage co pvt ltd',
    'Vikalpa financial and management services pvt ltd',
    'S kumar associates pvt ltd',
    'Abhay transformers private limited',
    'Golden photo and warehousing private limited',
    'Prabha logistics private limited',
    'M pallonji shipping pvt ltd',
    'Indo asia leisure services limited',
    'Easy transport private limited',
    'Atoz cargo movers private limited',
    'Gosalia ventures private limited',
    'New vision group holding private limited',
    'ASSOCIATED DELTAWAY LOGISTICS PRIVATE LIMITED',
    'Jai shree nath carriers private limited',
    'SRI JORA SOURCING INDIA PRIVATE LIMITED',
    'Flywell aviation private limited',
    'Mittal portfolios private limited',
    'Wishbox communications private limited',
    'Tarasvi capital private limited',
    'Sharath investments private limited',
    'VNV TRAVEL PLAN PRIVATE LIMITED',
    'Saija finance private limited',
    'Provincial investment corpn pvt ltd',
    'Orissa bengal carrier ltd',
    'Vardhman transport pvt ltd',
    'Anamallais agencies private limited',
    'Escorts consumer credit limited',
    'Oakwood interior decor private limited',
    'Sunrays shipping services private limited',
    'Sea shine logistics private limited',
    'Safeways cargo private limited',
    'Vdopia media and software solutions private limited',
    'Dipland investments pvt ltd',
    'East india investment co pvt ltd',
    'Brabourne investments ltd',
    'Bhutoria investments pvt ltd',
    'Rpg industries private limited',
    'Stalwart shipping agencies private limited',
    'Esi performance improvement private limited',
    'Shree riddhi siddhi edutech private limited',
    'Nath research foundation',
    'N kagliwal education & research foundation',
    'Sansrisk credit solutions private limited',
    'Iti international india private limited',
    'ADVANCED MICRODEVICES PRIVATE LIMITED',
    'Collectcent digital media private limited',
    'V3 healthcare private limited',
    'YATHARTH HOSPITAL & TRAUMA CARE SERVICES LIMITED',
    'Dr. khunger eye care and research centre private limited',
    'IVY PRODUCT INTERMEDIARIES LIMITED',
    'Vijay halocoils private limited',
    'Subhash kabini power corporation limited',
    'KOSMODERMA HEALTHCARE PRIVATE LIMITED',
    'Nayyar medical centre pvt ltd',
    'K k g exports pvt ltd',
    'S & ib services private limited',
    'Clinirx research private limited',
    'HOSCO PRIVATE LIMITED',
    'Grand slam fitness private limited',
    'Dimension mechanix private limited',
    'Zedconn systems private limited',
    'Epoch integrated security solutions (india) private limited',
    'Bluebricks technologies private limited',
    'Artha yantra corporation private limited',
    'Suvera fluid power private limited',
    'AUTOMOTIVE ROBOTICS (INDIA) PRIVATE LIMITED',
    'Kv environ n energy consultants private limited',
    'Team-works creative solutions private limited',
    'Pioneer hi-bred private limited',
    'PPMS FIELD MARKETING PRIVATE LIMITED',
    'Brighterside renewable energy ventures private limited',
    'Ctpl industrial services private limited',
    'Enviromental protection service company (india) private limited',
    'Optics india equipments private limited',
    'Egana india private limited',
    'ADVICS INDIA PRIVATE LIMITED',
    'Simran motors private limited',
    'Entech kunststoffe solutions private limited',
    'Nemak aluminium castings india private limited',
    'Freight connection india private limited',
    'Jalan shipping agencies private limited',
    'Ocean blue boating private limited',
    'Allied shipping agencies private limited',
    'Building bricks (india) private limited',
    'VERDE JEWELS PRIVATE LIMITED',
    'Tranz mannequins private limited',
    'Sparsh designs private limited',
    'Azure jouel private limited',
    'Geeken office solutions private limited',
    'PARADISE GEMS PRIVATE LIMITED',
    'Miltha enterprises private limited',
    'Wondercuts jewels private limited',
    'Cosmeticpack (india) private limited',
    'Bharat technoplast private limited',
    'Monalisa ceramics india private limited',
    'STEPIN DIAMOND PRIVATE LIMITED',
    'Pigeon india private limited',
    'Greenolite (india) technologies private limited',
    'Prakash flexibles private limited',
    'Hydromet (india) limited',
    'Sep energy private limited',
    'AMPLUS SUN SOLUTIONS PRIVATE LIMITED',
    'Shruti power projects private limited',
    'Advitiya power ventures private limited',
    'Bajaj power ventures private limited',
    'PENNALUR PROPERTIES PRIVATE LIMITED',
    'Acciona energy india private limited',
    'Vayuraj power ventures private limited',
    'Ananth solar power maharashtra private limited',
    'Sri vasuki power systems private limited',
    'Rpa engineering and projects private limited',
    'Emeral energy solutions private limited',
    'Inspeed power private limited',
    'Sei solar energy private limited',
    'Millenium solar power rajasthan private limited',
    'REL CLEANTECH PRIVATE LIMITED',
    'AMPLUS SUPERIOR SOLAR PRIVATE LIMITED',
    'Fortune energy private limited',
    'INCOR LAKE CITY PROJECTS PRIVATE LIMITED',
    'Nsl wind power company (satara) private limited',
    'Nsl orissa power company private limited',
    'Aeolus wind parks private limited',
    'Sei solartech private limited',
    'PRATHYUSHA POWER GEN PRIVATE LIMITED',
    'Phadnis power projects limited',
    'Adept mining private limited',
    'KREON INFOTECH PRIVATE LIMITED',
    'Enerparc energy private limited',
    'K RAHEJA CORP REAL ESTATE PRIVATE LIMITED',
    'Komal watertech private limited',
    'KSP HYDRO ENGINEERS PRIVATE LIMITED',
    'Inhabitat developments private limited',
    'Ardent properties private limited',
    'Panch tatva promoters private limited',
    'Birmitrapur barkote highway private limited',
    'Abhinav assets private limited',
    'Mars properties pvt ltd',
    'Peculiar estates private limited',
    'Ajcon infra projects private limited',
    'Touchstone properties and hotels private limited',
    'Aqua alliances (india) private limited',
    'Dhanraj estate developers private limited',
    'Purabi developers private limited',
    'Victoria projects private limited',
    'Sycamore properties private limited',
    'Structwel constructions private limited',
    'Treasure realties private limited',
    'Goodluck malls private limited',
    'Ks city nirmal lifestyle realty private limited',
    'Alfa infraprop private limited',
    'Shrem construction private limited',
    'Sheth universal private limited',
    'Asmi buildcon private limited',
    'Agi infra limited',
    'Marvel sigma homes private limited',
    'Marvel omega builders private limited',
    'Marvel zeta developers private limited',
    'Camron infrastructure india limited',
    'Ta infra projects limited',
    'Rithwik projects private limited',
    'Ijm (india) geotechniques private limited',
    'Incor infrastructure private limited',
    'Intime properties limited',
    'Celestial avenues private limited',
    'K2k infrastructure india private limited',
    'Aga infra projects private limited',
    'Kilai builders private limited',
    'Sk formulations india private limited',
    'Akshar precision tubes private limited',
    'Parkman shivdurga rubber roll private limited',
    'S s rubbers private limited',
    'Toyoda Gosei South India Private Limited',
    'Dew lite rubber products private limited',
    'Fairdeal jumbo packaging private limited',
    'Rajat vinyls private limited',
    'Siddhi elasto private limited',
    'Evershine rubbers private limited',
    'Green pack foils private limited',
    'SYSCO INDUSTRIES Limited',
    'Ruler plastics private limited',
    'S.r.i marbo india private limited',
    'S.r.i gotec india private limited',
    'SVD PINECHEM PRIVATE LIMITED',
    'Power additives (india) private limited',
    'Kns lined products private limited',
    'Sinecera import export private limited',
    'Auto window india private limited',
    'Paradise ceramica india private limited',
    'Vts ventus india private limited',
    'NUVOCO VISTAS CORPORATION LIMITED',
    'Sks cements limited',
    'Varsha tubes private limited',
    'CLASSIC RMC AND INFRASTRUCTURE INDIA PRIVATE LIMITED',
    'Siddhi steels private limited',
    'Vivan steels private limited',
    'Shrem hallmark alloys private limited',
    'Smtc steel and power private limited',
    'RHODIUM STEELS AND ALLOYS PRIVATE LIMITED',
    'A B C METALS & TRADING CONSULTANCY PRIVATE LIMITED',
    'Kali m.h.s. private limited',
    'Basf catalysts india private limited',
    'Soni steel and appliances private limited',
    'KANAIYA ENGINEERING & FINANCE LTD',
    'Nova technocast private limited',
    'Suresh steel tubes private limited',
    'Garg casteels private limited',
    'Sun mark stainless private limited',
    'Patancheru steels private limited',
    'Colour roof (india) limited',
    'N R GOLD LIMITED',
    'ARABO IMPEX PRIVATE LIMITED',
    'Kanishk metal recycling private limited',
    'Ajnara mega structure private limited',
    'KWALITY COIL PRODUCTS PRIVATE LIMITED',
    'Precision weldarc limited',
    'Vimax technocast private limited',
    'Sandori castings private limited',
    'EUREKA FORBES LIMITED',
    'Darshan extrusions private limited',
    'Texelq engineering india private limited',
    'Revat metforms private limited',
    'Metal impex private limited',
    'Astra corporation private limited',
    'Mouldtech ferro-cast private limited',
    'Aegis punching systems private limited',
    'Shaily laserfab private limited',
    'Morfi concrete systems private limited',
    'Jsr autocomps private limited',
    'Magic corporation private limited',
    'INDIGRID INVESTMENT MANAGERS LIMITED',
    'USBS INFRA PRIVATE LIMITED',
    'Metalex steel strips private limited',
    'Inox wares private limited',
    'Arham hi-tech design and solutions private limited',
    'Ma extrusion india private limited',
    'Abhi-ani manufacturing company private limited',
    'Altech aluminium private limited',
    'Svl glazing systems private limited',
    'Geeco enercon private limited',
    'Sang fasteners private limited',
    'Sns pro-pack equipments private limited',
    'Acquitech engineers pvt ltd',
    'Aerocaliph components private limited',
    'Vertimo elevator engineering private limited',
    'Witzenmann (india) private limited',
    'Neoseal enginneering private limited',
    'Harshganapati infracon private limited',
    'Rollex machinery private limited',
    'Dl valve private limited',
    'Futuristic diagnostic imaging centre private limited',
    'Clumax diagnostic and research centre private limited',
    'Living longer life care private limited',
    'Arav healthcare infra private limited',
    'Nt diagnostic centre private limited',
    'Assist america medical emergency services (india) private limited',
    'Eta constructions(india) limited',
    'ALKHALEEJ SUPER SPECIALITY HOSPITAL PRIVATE LIMITED',
    'Mumbai smiles foundation',
    'Encore healthcare international private limited',
    'Affordable acres private limited',
    'Shugham labs private limited',
    'Aarthi scans private limited',
    'Panchsheel care foundation',
    'Remondis aqua (india) private limited',
    'Indian institute of banking and finance',
    'Gulabchand foundation',
    'Highpowerv wedding services and network limited',
    'Athashri foundation',
    'Vijay electric power (india) private limited',
    'Saffron shades private limited',
    'Searock international private limited',
    'Neon multitrade private limited',
    'Unisha enterprises private limited',
    'Genesis sourcing and solution private limited',
    'Pergola systems private limited',
    'Gourisut vanijya private limited',
    'Euro fruits pvt ltd',
    'Eleganza furnishings private limited',
    'Kryolan cosmetics (india) private limited',
    'I b pharma private limited',
    'Melenco india private limited',
    'PROFITMART COMMODITIES BROKING PRIVATE LIMITED',
    'A.p. gems and jewellary park private limited',
    'Bizmode trading house private limited',
    'Parko commerz pvt. ltd.',
    'Nagase india private limited',
    'Survi exports private limited',
    'Rus-med exports private limited',
    'Saudi indo mercantile services pvt ltd',
    'Kesma impex pvt ltd',
    'Nouveaw exports private limited',
    'SAHYADRI STRUCTWEL PRIVATE LIMITED',
    'Angel financial advisors private limited',
    'Kaycee commodity services private limited',
    'Indigo multitrade private limited',
    'Ntb international pvt ltd',
    'Prime info solutions private limited',
    'INDOCORP ENTERPRISES (INDIA) PRIVATE LIMITED',
    'Letra graphix private limited',
    'Siddeshwari tradex private limited',
    'SUNONIX INDIA PRIVATE LIMITED',
    'Global audiology services private limited',
    'Mm activ sci-tech communications private limited',
    'Skc trading private limited',
    'Fontasey exports private limited',
    'CLASSIC BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Khatu naresh dealers private limited',
    'Parshwanath overseas private limited',
    'Red bull india private limited',
    'Quest consolidated services private limited',
    'Maido enterprises private limited',
    'Krisho hygiene private limited',
    'Ausland energy private limited',
    'GNA DRIVELINES LIMITED',
    'Radium merchandise private limited',
    'Usk electronics private limited',
    'Ucal exports private limited',
    'Purna commercials pvt ltd',
    'Garodia traxim pvt ltd',
    'B.p.poddar hospital and medical research limited',
    'Kunj behari tie-up private limited',
    'New ways consumer goods private limited',
    'Win pens private limited',
    'Growth vanijya private limited',
    'Acropetal trading & services private limited',
    'Dharitree multitrade private limited',
    'Muktidaya traders private limited',
    'Comma books india private limited',
    'Rajveer trading private limited',
    'G s kids private limited',
    'Highpowerv import and exports private limited',
    'One extra degree marketing private limited',
    'Howell energy systems private limited',
    'Innovative surgicaa private limited',
    'Second dimension exports private limited',
    'Delyver retail network private limited',
    'Setu overseas private limited',
    'Lorange design and retail private limited',
    'Intact fit private limited',
    'P. & sons export private limited',
    'Ahura marketing private limited',
    'Bookmywish e-commerce private limited',
    'Fashion identity private limited',
    'Pras pharma private limited',
    'Jaypore e-commerce private limited',
    'Fairmont polymers (india) private limited',
    'Prm hospitality private limited',
    'Sunhouse resorts private limited',
    'Zebrano facility management services private limited',
    'Raveena hotels private limited',
    'Sycon hospitality services private limited',
    'FENNY',
    'S METAL FORM OFFSHORE PRIVATE LIMITED',
    'GOOD LIFESTYLE PRODUCTS PRIVATE LIMITED',
    'WHOLE LEAF ORGANICS PRIVATE LIMITED',
    'IIT TIRUPATI NAVAVISHKAR I-HUB FOUNDATION',
    'RBST SERVICE AND MAINTENANCE (OPC) PRIVATE LIMITED',
    'SSRC TRUCKING PRIVATE LIMITED',
    'SPECAIDE INTERIORS PRIVATE LIMITED',
    'MERAKI LAMINATES INDUSTRIES PRIVATE LIMITED',
    'GLEN REALTY PRIVATE LIMITED',
    'MAK FLEXIBLE PACKAGING PRIVATE LIMITED',
    'MAISON GRAMOLI DESIGN CONSULTING PRIVATELIMITED',
    'DOHNA GLOBAL PRIVATE LIMITED',
    'HOGOCO PRIVATE LIMITED',
    'PRAYSHA POWERS PRIVATE LIMITED',
    'FRONTCREW TECHNOLOGIES PRIVATE LIMITED',
    'MSPL UNIT 1 LIMITED',
    'HIGHTOSS IT SOLUTIONS PRIVATE LIMITED',
    'SHERIN AGRO FOODS INDIA PRIVATE LIMITED',
    'DATAPATTERN CONSULTING SERVICES PRIVATE LIMITED',
    'STRESZA SYSTEMS GLOBAL TECH PRIVATE LIMITED',
    'HAPS DIGITAL MEDIA PRIVATE LIMITED',
    'HAPPYTECH SERVICES PRIVATE LIMITED',
    'V7 LIFE EDU PRIVATE LIMITED',
    'HIREKARO GLOBAL SERVICES PRIVATE LIMITED',
    'BIGSHORT TAILS PRIVATE LIMITED',
    'DIKVENSRI PRIVATE LIMITED',
    'SHRI SITARAM GLASS WORKS PRIVATE LIMITED',
    'ULKASEMI INDIA PRIVATE LIMITED',
    'NORTHVIEW CARS PRIVATE LIMITED',
    'JAINSONS INDIA PRIVATE LIMITED',
    'BTB DIGITAL PRIVATE LIMITED',
    'NIRMAL STEELS PRIVATE LIMITED',
    'ASSOCIATION OF INDIAN EDUCACY SCHOOLS',
    'TOBIAS INFRA PRIVATE LIMITED',
    'WEDNESDAYMART (OPC) PRIVATE LIMITED',
    'SWATI CAMPHOR & SPECIALITY CHEMICALS PRIVATE LIMITED',
    'AFFINITY ARISE PRIVATE LIMITED',
    'MILETIAGUIDE SOLUTIONS PRIVATE LIMITED',
    'GLOBAL STUDY LINK PRIVATE LIMITED',
    'SADASHIVA FINANCIAL SERVICES HOLDINGS PRIVATE LIMITED',
    'KIVAAN ENERGY PRIVATE LIMITED',
    'EMIRATES ASSET HOLDING PRIVATE LIMITED',
    'CALIBO INDIA PRIVATE LIMITED',
    'INNORASOFT PRIVATE LIMITED',
    'CURIZO MEDITECH PRIVATE LIMITED',
    'ENTREATY MANAGEMENT SERVICES PRIVATE LIMITED',
    'MERGEASY.COM PRIVATE LIMITED',
    'LAKHI STUDIO PRIVATE LIMITED',
    'SILKROOT TRADERS PRIVATE LIMITED',
    'NOOVIK CONSUMER PRIVATE LIMITED',
    'MYSKINTAILOR PRIVATE LIMITED',
    'CODINGAL TECHNOLOGIES PRIVATE LIMITED',
    'TESLA INDIA MOTORS AND ENERGY PRIVATE LIMITED',
    'GLOBAL OCEAN LOGISTICS INDIA PRIVATE LIMITED',
    'MORSMILES WELLNESS SERVICES PRIVATE LIMITED',
    'INDIANWALA SOLUTIONS PRIVATE LIMITED',
    'SOFTRONICS SYSTEMS PRIVATE LIMITED',
    'FINTANTRA SOLUTIONS PRIVATE LIMITED',
    'PARC IMPEX SOLUTIONS PRIVATE LIMITED',
    'ALPHAROCK VENTURES PRIVATE LIMITED',
    'IMPAQTIVE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'LIDEX INDIA PRIVATE LIMITED',
    'TDD HOME PRIVATE LIMITED',
    'SRI SHYAM DENIM PRIVATE LIMITED',
    'BAGHBAN ENERGY PRIVATE LIMITED',
    'PROSPEKS PRIVATE LIMITED',
    'GREENERY CROPS AND CULTIVATION PRIVATE LIMITED',
    'VINAYAKA EXPO PLAZA PRIVATE LIMITED',
    'INGENIOUS ENTERPRISES PRIVATE LIMITED',
    '9TH LEMON HOLDINGS PRIVATE LIMITED',
    'PUSHPAKTA FOUNDATION',
    'GO BOUNDLESS PRIVATE LIMITED',
    'H1 LIFE SCIENCES PRIVATE LIMITED',
    'ABIA SOURCING PRIVATE LIMITED',
    'TERRITORY29 FOODS PRIVATE LIMITED',
    'ECAP GREENTECH PRIVATE LIMITED',
    'NEOMERCURY INNOVATIONS PRIVATE LIMITED',
    'VRSOFT TECHNOLOGIES PRIVATE LIMITED',
    'C H CHARITABLE FOUNDATION',
    'TECHNODUNE PRIVATE LIMITED',
    'SEVEN LEAF INDIA BUILDERS PRIVATE LIMITED',
    'MANIKARNIKA DESIGN (OPC) PRIVATE LIMITED',
    'CREDENCE DIGISEC SOLUTIONS PRIVATE LIMITED',
    'FARMING V2 FARMS PRIVATE LIMITED',
    'JLV INNOVATIONS PRIVATE LIMITED',
    'QOOT FOOD LIMITED',
    'PRASUK PROMOTERS PRIVATE LIMITED',
    'LEXDEXTER ADVISORY PRIVATE LIMITED',
    'SIROHI FURNITURE PRIVATE LIMITED',
    'NATUREAEGIS PRIVATE LIMITED',
    'CAR O',
    'FARMER PRODUCER COMPANY LIMITED',
    'ZEROPAY PRIVATE LIMITED',
    'AMENITY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'OVERLEAP NETWORKS PRIVATE LIMITED',
    'AZHIYUR VENGALAM ROAD PRIVATE LIMITED',
    'GET CAPITAL AND FINANCE PRIVATE LIMITED',
    'VISHVESH AGROMED PRIVATE LIMITED',
    'ALVEONIC MEDICAL SYSTEMS PRIVATE LIMITED',
    'MUDHOMES PRIVATE LIMITED',
    'SRIHM ALUMNI ASSOCIATION',
    'HOP ON ROUES PRIVATE LIMITED',
    'PANCHAMRUT ORGOCHEM PRIVATE LIMITED',
    'TECHEA AUTOMATION PRIVATE LIMITED',
    'REONTECH CONSULTING PRIVATE LIMITED',
    'ORACULAR ADVISORY PRIVATE LIMITED',
    'EMPL CONNECT PRIVATE LIMITED',
    'KARMAN PROPERTIES PRIVATE LIMITED',
    'BIGMANTRA (OPC) PRIVATE LIMITED',
    'SMART HUSBANDRY PRIVATE LIMITED',
    'SECONDMOM CHILD CARE PRIVATE LIMITED',
    'AVRN INTELLITECH PRIVATE LIMITED',
    'TECHNOHIRES CONSULTANCY SERVICES PRIVATELIMITED',
    'UNIT OF MEASURE PRIVATE LIMITED',
    'SUSTAINABLE BIOSOLUTIONS PRIVATE LIMITED',
    'ALCHEMIE INTERMEDIATES PRIVATE LIMITED',
    'SAAN RENEWABLE PRIVATE LIMITED',
    'MULTIPLIER LEARNING PRIVATE LIMITED',
    'TEJSAR SYSTEMS PRIVATE LIMITED',
    'SAMAN RENEWABLE PRIVATE LIMITED',
    'THINK9 CONSUMER TECHNOLOGIES PRIVATE LIMITED',
    'AMARHANS REALTY PRIVATE LIMITED',
    'SHEMAAK SYSTEMS PRIVATE LIMITED',
    'STRONGWILL FOODS PRIVATE LIMITED',
    'DESMI INDIA PRIVATE LIMITED',
    'MARK RENEWABLES PRIVATE LIMITED',
    'NIKHIL BHARAT COUNCIL FOR SCIENCE & TECHNOLOGY CONFERENCE',
    'ANSELL STERILE SOLUTIONS PRIVATE LIMITED',
    'AMCARE MEDICAL SERVICES INDIA (OPC) PRIVATE LIMITED',
    'ARATHIL TRADING PRIVATE LIMITED',
    'MACH CHARTERS PRIVATE LIMITED',
    'TECHVISE TECHNOLOGIES PRIVATE LIMITED',
    'CODERVALUE SOLUTIONS PRIVATE LIMITED',
    'APPLESUTRA (OPC) PRIVATE LIMITED',
    'CLINFOUND DIAGNOSTICS PRIVATE LIMITED',
    'SEVEN HASTAR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MEMOYO ANIMATION PRIVATE LIMITED',
    'ALGOMET EDTECH PRIVATE LIMITED',
    'PERVYUKT AGRINNOVATERS PRIVATE LIMITED',
    'ABHIMANYU PROJECTS PRIVATE LIMITED',
    'BLOCK STACK PRIVATE LIMITED',
    'AMSTECH TRAINING ASSOCIATES PRIVATE LIMITED',
    'EARLYVENTIONS EDUCATION PRIVATE LIMITED',
    'SERLEX TECHNOLOGIES PRIVATE LIMITED',
    'APPORT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'FUTURISTIC VISIONARIES PRIVATE LIMITED',
    'CONSOLIDATED PRIVATE LIMITED',
    'GREENHOME FURNISHINGS PRIVATE LIMITED',
    'ZULIOT PRIVATE LIMITED',
    'BRK BUSICORP PRIVATE LIMITED',
    'SANGOD TRANSMISSION SERVICE LIMITED',
    'VERDANT CARGO SOLUTIONS PRIVATE LIMITED',
    'SPERAR INNOTECH PRIVATE LIMITED',
    'LALSTREETAGRI TECH AND SOFTWARE SERVICESPRIVATE LIMITED',
    'NAAGARA EXPORTS PRIVATE LIMITED',
    'DYGTONE SOLUTIONS PRIVATE LIMITED',
    'HONEST TOWNSHIP PRIVATE LIMITED',
    'IRAMA GLOBAL SERVICES PRIVATE LIMITED',
    'SICH ENTERPRISES PRIVATE LIMITED',
    'VIRTUATAINMENT PRIVATE LIMITED',
    'FOREVER DIARY INDIA PRIVATE LIMITED',
    'TOPHEXA INFOTECH PRIVATE LIMITED',
    'INDO FARM INDUSTRIES LIMITED',
    'AMS ENVIRONMENTAL SOLUTIONS PRRIVATE LIMITED',
    'SCOM INFOTECH PRIVATE LIMITED',
    'BVISTIC MINERALS PRIVATE LIMITED',
    'SUMIT HILLS PRIVATE LIMITED',
    'GDKN INFRA PRIVATE LIMITED',
    'ASTROFORME INDIA PRIVATE LIMITED',
    'HARISA INFORMATION TECHNOLOGY SERVICES PRIVATE LIMITED',
    'MLA VATIKA REALESTATE PRIVATE LIMITED',
    'RARR TECHNOLOGIES PRIVATE LIMITED',
    'SERENITA CONSULTANCY PRIVATE LIMITED',
    'ELITETECH SOCCER SHOWCASE INDIA PRIVATE LIMITED',
    'PRINT WITH ME PRIVATE LIMITED',
    'RAY GLOBAL CONSUMER ENTERPRISE LIMITED',
    'HONEST LIFESPACES PRIVATE LIMITED',
    'KUSH INDO BIO FUELS PRIVATE LIMITED',
    'YK RETAILS PRIVATE LIMITED',
    'SAASTAA PRODUCTS & SERVICES PRIVATE LIMITED',
    'GLOBALSANKARA VENTURES PRIVATE LIMITED',
    'DOCSTIME IT SOLUTIONS PRIVATE LIMITED',
    'FONEBOX RETAIL LIMITED',
    'MARKET CART PRIVATE LIMITED',
    'NOCAGILE SERVICES PRIVATE LIMITED',
    'SLANTCO INTERNATIONAL PRIVATE LIMITED',
    'SUN-MAV STAINLESS PRIVATE LIMITED',
    'IITK FOUNDATION FOR MEDICAL RESEARCH ANDTECHNOLOGY',
    'NAVIKENZ INDIA PRIVATE LIMITED',
    'TRIVENI RENEWABLES PRIVATE LIMITED',
    'TFC FANATICCODERS PRIVATE LIMITED',
    'LATINUM HR SOLUTIONS PRIVATE LIMITED',
    'RACCON UTILITY SERVICES PRIVATE LIMITED',
    'AGRI BUSINESS INCUBATION FOUNDATION IIT KHARAGPUR',
    'ASSEMBLY PAYMENTS INDIA PRIVATE LIMITED',
    'AYAN HOTELS AND RESORTS PRIVATE LIMITED',
    'TRANSOURCE FREIGHTWAYS PRIVATE LIMITED',
    'SANVI INFRASTRUCTURE COLLABORATIONS PRIVATE LIMITED',
    'ADCLOCK SERVICES PRIVATE LIMITED',
    'VENTEST SOLUTIONS PRIVATE LIMITED',
    'HEAL TELEMEDICINE PRIVATE LIMITED',
    'VILLAGEMINDS PRIVATE LIMITED',
    'EROBO SOFTWARE PRIVATE LIMITED',
    'KWIK MORTGAGE PRIVATE LIMITED',
    'EMERCION INTEGRATORS PRIVATE LIMITED',
    'YOSHIN SOLUTIONS INDIA PRIVATE LIMITED',
    'PIZZA MECHANICS PRIVATE LIMITED',
    'SITEVELA WEB SOLUTIONS & SERVICES PRIVATE LIMITED',
    'EDU-EXPLORE EDUCATION PRIVATE LIMITED',
    'S&S INDUSTRIAL PRODUCTS PRIVATE LIMITED',
    'TELESOFT TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ADVANCE VALVES AND TECHNOLOGIES PRIVATE LIMITED',
    'PLANT ESSENTIALS PRIVATE LIMITED',
    'BHARANI TOURS & TRAVELS PRIVATE LIMITED',
    'ELFONZE TECHNOLOGIES PRIVATE LIMITED',
    'KARS99 PRIVATE LIMITED',
    'WFH TECH LABS (OPC) PRIVATE LIMITED',
    'PALVIT INFRASTRUCTURE PRIVATE LIMITED',
    'LCL LOGISTICS (SOUTH) PRIVATE LIMITED',
    '3 GENIUS DIGIMINDS TECHNOLOGIES PRIVATE LIMITED',
    'JOPINC PRIVATE LIMITED',
    'SEE JAY KHURAAK PRIVATE LIMITED',
    'INFITRUST INTERNATIONAL PRIVATE LIMITED',
    'ACADEMIC CITY EDU SERVICES PRIVATE LIMITED',
    'ABBSIN INDUSTRIES PRIVATE LIMITED',
    'JINDAL REAL INFRA VENTURE PRIVATE LIMITED',
    'KLIMFINITY PRIVATE LIMITED',
    'JODIDAR',
    'S NETWORK PRIVATE LIMITED',
    'AMPLUS IIFA SOLAR PRIVATE LIMITED',
    'TRUALT BIOENERGY LIMITED',
    'NIDWAIT RETAIL PRIVATE LIMITED',
    'TIER2 DIGITAL PRIVATE LIMITED',
    'PROZORP TECHNOLOGIES PRIVATE LIMITED',
    'S25DIGITAL STUDIO (OPC) PRIVATE LIMITED',
    'NESARA BIOTECH PRIVATE LIMITED',
    'INTELLIGENT EDGE TECHNOLOGIES PRIVATE LIMITED',
    'ULTIMAMAC SERVICES PRIVATE LIMITED',
    'JUMPINGMINDS AI LABS PRIVATE LIMITED',
    'DESI RECORDS MUSIC PRIVATE LIMITED',
    'HEALTHEC INDIA PRIVATE LIMITED',
    'IIV HEALTH SOLUTIONS PRIVATE LIMITED',
    'PUDUKUDI PRIVATE LIMITED',
    'HEALTHILIEIOUS SERVICES PRIVATE LIMITED',
    'NEXT LEVEL NETWORKS AND IT SOLUTIONS PRIVATE LIMITED',
    'MENSA BRAND TECHNOLOGIES PRIVATE LIMITED',
    'INFIZIUS PRIVATE LIMITED',
    'GEFO TELESERVICES INDIA PRIVATE LIMITED',
    'WAVEGROOVE CONNECT SOLUTION PRIVATE LIMITED',
    'THRIVA GLOBAL PRIVATE LIMITED',
    'DARLING PETS PRIVATE LIMITED',
    'LUXE BATH AND DECOR SOLUTIONS PRIVATE LIMITED',
    'VMAD SERVICES INDIA PRIVATE LIMITED',
    'VCNR AGROTECH PRIVATE LIMITED',
    'ARFLU VALVES INDIA PRIVATE LIMITED',
    'CARIGAR POWER TOOLS PRIVATE LIMITED',
    'SILVERCAST CREATIONS (OPC) PRIVATE LIMITED',
    'RCH SERVICE INDIA PRIVATE LIMITED',
    'DOJO PANDA TECHNOLOGIES PRIVATE LIMITED',
    'OJAS FOOTWEAR INDIA PRIVATE LIMITED',
    'ANAIYAN TECHNOLOGIES PRIVATE LIMITED',
    'DHIWISE PRIVATE LIMITED',
    'SCL ELECTRONICS (INDIA) PRIVATE LIMITED',
    'CHENNAI ESECURITY SOLUTIONS PRIVATE LIMITED',
    'CNA SPORTS WORLD PRIVATE LIMITED',
    'SPECTRUM INSURANCE BROKING PRIVATE LIMITED',
    'VEDAVAAG FINANCIAL SERVICES PRIVATE LIMITED',
    'SPACEFLUX CONSTRUCTIONS PRIVATE LIMITED',
    'MUNDRA PETROCHEM LIMITED',
    'KNP MED SOLUTIONS PRIVATE LIMITED',
    'ATFIRSTPAGE EDUSERVICES PRIVATE LIMITED',
    'QUANT NXT PRIVATE LIMITED',
    'KFLY PLANNERS INDIA PRIVATE LIMITED',
    'CLEOME INNOVATIONS PRIVATE LIMITED',
    'GV SAFETY ASSESSMENT PLATFORM PRIVATE LIMITED',
    'LORAM RAIL MAINTENANCE INDIA PRIVATE LIMITED',
    'FITBUDD SOFTWARE PRIVATE LIMITED',
    'STEMZTECH INDUSTRIES PRIVATE LIMITED',
    'FP SOLWAVE ENERGY PRIVATE LIMITED',
    'FLYVHEEL DIGITAL SOLUTIONS PRIVATE LIMITED',
    'SHRISAI ECO SOLUTIONS PRIVATE LIMITED',
    'MASTER WORKS SOFTWARE PRIVATE LIMITED',
    'SPOTIFY FASHIONS PRIVATE LIMITED',
    'KARAM SAFETY PRIVATE LIMITED',
    'KUBEIFIER SOLUTIONS PRIVATE LIMITED',
    'ESSENKO INDIA CONSUMERS PRIVATE LIMITED',
    'SAFETYNET INSURANCE SERVICES PRIVATE LIMITED',
    'VAISHALI AGRO PROCESSING PRIVATE LIMITED',
    'EDEN SMART AGROTECH PRIVATE LIMITED',
    'SVN OPTO ELECTRONICS PRIVATE LIMITED',
    'TECHNOCHILL INNOVATIONS PRIVATE LIMITED',
    'TECH ROUTE LOGISTICS PRIVATE LIMITED',
    'SURYA INTERNATIONAL ENTERPRISE PRIVATE LIMITED',
    'SELOWARE TECHNOLOGIES PRIVATE LIMITED',
    'VSBIC PRIVATE LIMITED',
    'APPSUCCESSOR MEDIA PRIVATE LIMITED',
    'SEUNGHYUN PACKAGING PRIVATE LIMITED',
    'SCR ELEKTRONIKS PRIVATE LIMITED',
    'HIZIE DESIGN BUILD PRIVATE LIMITED',
    'SHRIGOVIND GLOBAL BUSINESS ADVISORY PRIVATE LIMITED',
    'BLUESPARK MEDITECH PRIVATE LIMITED',
    'LEADING LIFE INSTITUTE PRIVATE LIMITED',
    'AGRAMUS WORLD COMMUNICATIONS PRIVATE LIMITED',
    'NKC KK EXPRESSWAY PRIVATE LIMITED',
    'INSERVIA BIOCHEM PRIVATE LIMITED',
    'MAPCI GLOBAL PRIVATE LIMITED',
    'SPARKCENT TECHNOLOGIES PRIVATE LIMITED',
    'STARSHIP ENGINEERS (OPC) PRIVATE LIMITED',
    'KAAFI SERVICES PRIVATE LIMITED',
    'DRBR HEALTHCARE PRIVATE LIMITED',
    'ESSROY PRIVATE LIMITED',
    'KEEDAY MAKAUDAY FOUNDATION',
    'ERMOFILEX-RHYTHM ENGINEERING PRIVATE LIMITED',
    'XVENTURES PRIVATE LIMITED',
    'ANTON IMPEX PRIVATE LIMITED',
    'SUNDIAL SYSTEMS PRIVATE LIMITED',
    'CURE AND CARE PRIMARY CARE PRIVATE LIMITED',
    'MAIRA HEALTH & FITNESS PRIVATE LIMITED',
    'AGRI NATURAL PRODUCTS PRIVATE LIMITED',
    'BELLOM LOGISTICS PRIVATE LIMITED',
    'SASA ENGGTECH PRIVATE LIMITED',
    'POLYHOSE SATO-SHOJI METAL WORKS PRIVATE LIMITED',
    'POWER & SUN SOLAR SYSTEMS PRIVATE LIMITED',
    'NAVIS SOFTWARE INDIA PRIVATE LIMITED',
    'VALID8.COM INDIA PRIVATE LIMITED',
    'MORAABH VENTURES PRIVATE LIMITED',
    'KALBHAIRAV PRINT PRIVATE LIMITED',
    'MADSAPIENS PRIVATE LIMITED',
    'OXENGINE PRIVATE LIMITED',
    'APPLIED TECHNO ENGINEERS PRIVATE LIMITED',
    'SEAMEC NIRMAN INFRA LIMITED',
    'BUILTAB (OPC) PRIVATE LIMITED',
    'SPEDITION INDIA LOGISTICS PRIVATE LIMITED',
    'YES SYSTEMS PRIVATE LIMITED',
    'REERA HOLDINGS PRIVATE LIMITED',
    'LAS GOLDAIR HANDLING (BAGDOGRA) PRIVATE LIMITED',
    'V R ENVIRO CARE PRIVATE LIMITED',
    'SANAR LABS PRIVATE LIMITED',
    'GT VALUATION ADVISORS PRIVATE LIMITED',
    'BITFLYER SOLUTIONS PRIVATE LIMITED',
    'TEAM VELOCITY CONSULTING PRIVATE LIMITED',
    'CTOTALK FOUNDATION',
    'WOWTECH SOLUTIONS PRIVATE LIMITED',
    'HIVEDIN TECHNOLOGIES PRIVATE LIMITED',
    'VILMARES TRADERS PRIVATE LIMITED',
    'SNOWFLAKE CONSULTING PRIVATE LIMITED',
    'SCHE GLOBAL PRIVATE LIMITED',
    'AJKM BUILDERS PRIVATE LIMITED',
    'SSC CONTROL PRIVATE LIMITED',
    'MODVISOR BUSINESS CONSULTANTS PRIVATE LIMITED',
    'EQUITOR VALUE ADVISORY CONSULTING PRIVATE LIMITED',
    'DIGIMINDS CAREER SOLUTIONS LIMITED',
    'MSTN PRIVATE LIMITED',
    'SEASONTWO HEALTHY FOODS PRIVATE LIMITED',
    '100PILLARS CONSTRUCTIONS PRIVATE LIMITED',
    'VIKRANT ENGINEERING WORKS PRIVATE LIMITED',
    'POLYRAW ENTERPRISES INDIA PRIVATE LIMITED',
    'CY5 PRIVATE LIMITED',
    'BUILTIFUL HOMES AND BUILDINGS PRIVATE LIMITED',
    'VGN GAVLE PROJECTS PRIVATE LIMITED',
    'BETAMONKS INNOVATIONS (OPC) PRIVATE LIMITED',
    'SOFTMAJI INFOTECH PRIVATE LIMITED',
    'GURWAY SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'NINTRIVA TECHNOLABS PRIVATE LIMITED',
    'C2C GLOBAL EDUCATION INDIA PRIVATE LIMITED',
    'MYAIRBOOK TECHNOLOGIES PRIVATE LIMITED',
    'BESTKON ENERGY SYSTEMS PRIVATE LIMITED',
    'ASSOCIATION OF TECHNICAL SKILL EDUCATIONAND EXCELLENCE DEVELOPMENT',
    'SATSANG PROJECTS PRIVATE LIMITED',
    'VALUECENT FOUNDATION',
    'INDOTHAI VARANASI PRIVATE LIMITED',
    'FERTILITY JUNCTION PRIVATE LIMITED',
    'TRRULIV EARTH PRIVATE LIMITED',
    'SMART MERCHANT SERVICES LIMITED',
    'APPUXEY TECHNOLOGIES PRIVATE LIMITED',
    'CULINARY CLUB PRIVATE LIMITED',
    'CORERX PHARMA INDIA PRIVATE LIMITED',
    'YATILABS INFORMATION TECHNOLOGY PRIVATE LIMITED',
    'ONEUT BUILDCON PRIVATE LIMITED',
    'VDSI TENNIS FOUNDATION',
    'ELDER LABORATORIES LIMITED',
    '64 SQUARES GAMING PRIVATE LIMITED',
    'JAMES DOUGLAS PROFESSIONAL SEARCH INDIA PRIVATE LIMITED',
    'VOTEC TECHNOLOGY INNOVATION PRIVATE LIMITED',
    'T ENGINEERING CONSULTANTS PRIVATE LIMITED',
    'SRI JAISHANTHI PROJECTS PRIVATE LIMITED',
    'OKAS RESORTS PRIVATE LIMITED',
    'K2 RECYCLERS PRIVATE LIMITED',
    'MYKATES PRIVATE LIMITED',
    'CUSTOMER SHASTRA PRIVATE LIMITED',
    'A2Z PLANT NUTRIENT PRIVATE LIMITED',
    'NEWWAVE HEALTHCARE SOLUTION PRIVATE LIMITED',
    'JERUEL CONSULTING PRIVATE LIMITED',
    'GDN FARMS PRIVATE LIMITED',
    'TAXAJ FOUNDATION',
    'WYRIDIAN ADVISORS PRIVATE LIMITED',
    'MSGN INDIA PRIVATE LIMITED',
    'INDOAI TECHNOLOGIES PRIVATE LIMITED',
    'RVF ETHNICS PRIVATE LIMITED',
    'BUYOH PRIVATE LIMITED',
    'MARYJANE VENTURES PRIVATE LIMITED',
    'BLISS FLOW INVESTMENTS PRIVATE LIMITED',
    'IQUBYTE TECHNOLOGIES PRIVATE LIMITED',
    'CONTROLYTICS AI PRIVATE LIMITED',
    'NAMGRE FARMERS PRODUCER COMPANY LIMITED',
    'PHAZE REWARDS PRIVATE LIMITED',
    'AGRIZONE IMPLEMENTS PRIVATE LIMITED',
    'WINTECH IT SOLUTIONS PRIVATE LIMITED',
    'CASEGOODS PRIVATE LIMITED',
    'NOTIFIED DM INDIA PRIVATE LIMITED',
    'CLOSE APP PRIVATE LIMITED',
    'PARTH MANUFACTURING PRIVATE LIMITED',
    'MITS SOLUTION PRIVATE LIMITED',
    'CUSTOMER SUCCESS TECHNOLOGY PRIVATE LIMITED',
    'ELIXIR FLAT OWNERS ASSOCIATION',
    'SHAKTIMARINE ELECTRIC CORPORATION PRIVATE LIMITED',
    'QORBITAL INDIA PRIVATE LIMITED',
    'HEMPLIFE PRIVATE LIMITED',
    'FINACULAR FINTECH PRIVATE LIMITED',
    'STEELDALAL PRIVATE LIMITED',
    'SWARMBEE PRIVATE LIMITED',
    'RENUKA BROTHERS PRIVATE LIMITED',
    'MIRACLE ECO WATER SOLUTIONS PRIVATE LIMITED',
    'LIVEFURNISH PRIVATE LIMITED',
    'MOHANI INDUSTRIES PRIVATE LIMITED',
    'PA TEAM INDIA PRIVATE LIMITED',
    'SKAD BUSINESS SOLUTIONS PRIVATE LIMITED',
    'NKC DH EXPRESSWAY PRIVATE LIMITED',
    'ZIPTEL FIBERNET PRIVATE LIMITED',
    'KVF NIDHI LIMITED',
    'AGRANI DESIGNS PRIVATE LIMITED',
    'ARRCUS SOFTWARE PRIVATE LIMITED',
    'NEVER SAY NO FORUM',
    'ALRC PRIVATE LIMITED',
    'BARE RITUALS HOLISTIC WELLNESS PRIVATE LIMITED',
    'MXKHS TECHNOLOGIES PRIVATE LIMITED',
    'AMBALE INDUSTRIAL AND LOGISTICS PARKS PRIVATE LIMITED',
    'CHAMPAK INFOSOLUTION PRIVATE LIMITED',
    'ESG VALUE CONSULTANT PRIVATE LIMITED',
    'SBD APPAREL INDIA PRIVATE LIMITED',
    'PRISCON INFRASPACE PRIVATE LIMITED',
    'RAJWANI CONSULTING SERVICES PRIVATE LIMITED',
    'PLUVIAGO PRIVATE LIMITED',
    'MAX LAB LIMITED',
    'APPSCMS TECHNOLOGIES PRIVATE LIMITED',
    'NISARGIKA INVESTMENTS PRIVATE LIMITED',
    'MEDILIA LIMITED',
    'INDULGENT BLENDS PRIVATE LIMITED',
    'JONAS COLLECTIONS AND RECOVERY INDIA PRIVATE LIMITED',
    'COMPILERAI LABS PRIVATE LIMITED',
    'BIGSTACK TECHNOLOGIES PRIVATE LIMITED',
    'AARAM AWAKEN PRIVATE LIMITED',
    'CINEMAGUS',
    'BEE HOSPITALITY PRIVATE LIMITED',
    'Xllent corporate services private limited',
    'Moms supplies private limited',
    'MAX SERVE INDUSTRIES PRIVATE LIMITED',
    'Sf sleevings private limited',
    'Ideal workforce staffing solutions private limited',
    'Yoptima media solutions private limited',
    'Manyhands consultants private limited',
    'Neorems services private limited',
    'Doux dentistry private limited',
    'Hse solutions private limited',
    'Jess ideas private limited',
    'Sky screen private limited',
    'Malabar hill entertainment private limited',
    'Sukho thai india private limited',
    'Sayonara tradeimpex private limited',
    'Sanjeevani advertising private limited',
    'Vats and vessels (i) private limited',
    'Aikyam strategic solutions private limited',
    'OSIRIS LOGISTICS & WAREHOUSING PRIVATE LIMITED',
    'Aanya impex private limited',
    'Akanksha infracom private limited',
    'Jalaram scaffolding & engg. private limited',
    'A n enterprises infrastructure services private limited',
    'Siddhivinayak transport and logistics private limited',
    'Vapex ecigs private limited',
    'Pharmadeep turnkey consultants and engineers private limited',
    'Association of minority educational institutions',
    'Dhiraj heavy equipments private limited',
    'Dva engineering and testing private limited',
    'Sun polyurethane private limited',
    'Changediya outdoor advertising private limited',
    'CRAFFITI GRAPHICS INDIA PRIVATE LIMITED',
    'Nucleus insights private limited',
    'Patil kurduwadi barshi tollways private limited',
    'Mic india private limited',
    'Toss sports lounge private limited',
    'Stayfit enterprize private limited',
    'SWITCHR TECHNOLOGIES PRIVATE LIMITED',
    '2e knowledge ventures private limited',
    'Essence automation engineers india private limited',
    'Early den arts private limited',
    'Radiant protection force private limited',
    'Valcon management consultants private limited',
    'LEON INSPECTION & TESTING INDIA PRIVATE LIMITED',
    'Trident wings corporate services private limited',
    'KYVOR GENOMICS PRIVATE LIMITED',
    'Proeza corp private limited',
    'Yalmaa consulting & technologies private limited',
    'Firstlogic automation private limited',
    'Comp crafts private limited',
    'Abc defines private limited',
    'Asquare water engineering private limited',
    'Spectrum investments private limited',
    'Neerava hygiene products india private limited',
    'Get connected consultancy private limited',
    'Ase corp private limited',
    'Erda illumine low carbon solutions private limited',
    'Rangamaati handicrafts private limited',
    'Corpwis advisors private limited',
    'Asia carbon emission management india private limited',
    'Fortune human capital private limited',
    'Kaizen executive search private limited',
    'Image hr solutions private limited',
    'Zyoin web private limited',
    'Tristar consultants private limited',
    'Career drivers india private limited',
    'Career tree hr solutions private limited',
    'Visa 2 work consultants private limited',
    'Lakson technology private limited',
    'Maratha force private limited',
    'Harris brushes india private limited',
    'Vinay packaging (india) pvt ltd',
    'Av techno systems private limited',
    'Avanta offices business centre private limited',
    'Schaltbau india private limited',
    'Tridhara sugar limited',
    'Apex subscription private limited',
    'MOS UTILITY LIMITED',
    'Aim machintechnik private limited',
    'Marvex pipe tech private limited',
    'Zippe glass industries india private limited',
    'Teryair equipment private limited',
    'CHETAS STEAM SOLUTIONS PRIVATE LIMITED',
    'NOCEE ELEVATORS LIMITED',
    'Anvin aircon private limited.',
    'Bhutoria refrigeration private limited',
    'Prashanth projects limited',
    'Crossfire safety systems private limited',
    'Integrated pacline india private limited',
    'HOLOGRAPHIC ORIGINATION & MACHINERIES LIMITED',
    'Pilani envirotech private limited',
    'Flex-clean systems private limited',
    'G.k.power transmission company private limited',
    'Engicon airtech private limited',
    'Techno karats engineering private limited',
    'Tolins technologies private limited',
    'Nandan ground support equipment private limited',
    'Manasi technoforge private limited',
    'Grain & pulses engineers private limited',
    'Mangalore robautonics private limited',
    'PMEA SOLAR TECH SOLUTIONS PRIVATE LIMITED',
    'Kalsi engineers private limited',
    'Wingfan india private limited',
    'Deccan construction equipments & machinery private limited',
    'Goodluck techno mech private limited',
    'Velan valves india private limited',
    'Koshyma engineering private limited',
    'Petra toolsand equipments private limited',
    'Indra hydro tech pumps private limited',
    'Seko bec private limited',
    'Genesis super abrasives (india) private limited',
    'Prudent automation private limited',
    'Dynatech industries private limited',
    'Radius synergies (india) private limited',
    'Binyas printing technology private limited',
    'United office systems private limited',
    'Acmas technologies private limited',
    'Asharfi engineers private limited',
    'Advantec materials india private limited',
    'Visat tools private limited',
    'Lvd-strippit india private limited',
    'Zen tools & dies private limited',
    'Shandong heavy industry india private limited',
    'Mtandt rentals limited',
    'Kemppi india private limited',
    'Apex industrial products private limited',
    'Harish nickel-screens private limited',
    'Yantra kaushalya engineers private limited',
    'Radius procon private limited',
    'Lkc moulding solutions private limited',
    'Jmc paper tech private limited',
    'Devu tools private limited',
    'Traxit engineers private limited',
    'Ramashary pharma machinery private limited',
    'Pimco machines pvt ltd',
    'Kitten enterprises private limited',
    'Sinmag bakery machine india private limited',
    'Micron semiconductor india private limited',
    'Stratycon business solutions private limited',
    'Teclever solutions private limited',
    'Meteonic innovation private limited',
    'Saankhya labs private limited',
    'Google payment india private limited',
    'Chayowo technology solutions private limited',
    'Gestalt technologies private limited',
    'Capco technologies private limited',
    'Aplopio technology private limited',
    'Chihealth wellness solutions (bangalore) private limited',
    'Profuse engineering excellence private limited',
    'Kenscio digital marketing private limited',
    'Flink solutions private limited',
    'Valuvox business solutions private limited',
    'Belakur innovitec solutions private limited',
    'Tp vision india private limited',
    'ARCHLYNK INDIA PRIVATE LIMITED',
    'Xenarmor global security solutions private limited',
    'Nfaktor solutions private limited',
    'EMUDHRA TECHNOLOGIES LIMITED',
    'Winfoglobal technologies private limited',
    'Datamagnet transtech private limited',
    'Whodat tech private limited',
    'TURNTIDE TECHNOLOGIES PRIVATE LIMITED',
    'SMARTERHOMES TECHNOLOGIES PRIVATE LIMITED',
    'INSEMI TECH SOLUTIONS PRIVATE LIMITED',
    'Cyberprism limited',
    'Trivand technologies private limited',
    'Pumex infotech private limited',
    'Orell software solutions private limited',
    'Acube innovations private limited',
    'Fospe software private limited',
    'Ruby on rails private limited',
    'Cinch business solutions private limited',
    'Greenrose computer services private limited',
    'Comtek software technologies private limited',
    'Abcom information systems private limited',
    'Cpower consultancy (india) pvt ltd',
    'Coconut softwares private limited',
    'Covacsis technologies private limited',
    'Smartmonkey software private limited',
    'Doyen infosolutions private limited',
    'Welkin infotech private limited',
    'Techatalyst infoserve private limited',
    'Media nucleus india private limited',
    'Octashop eretail services private limited',
    'Galaxy i. t. services private limited',
    'Sanver e-solutions private limited',
    'Microlink infrastructure management private limited',
    'Techsa services private limited.',
    'Oriole technical solutions private limited',
    'Janki mirra resorts private limited',
    'South asia hotels limited',
    'Della Adventure & Resorts Private Limited',
    'Proland realty private limited',
    'Federation of safety glass',
    'Serviceplan india private limited',
    'Mindpower finsource services private limited',
    'Global incubation services',
    'As visas and permits.com private limited',
    'Blue ocean catalyst private limited',
    'Fragrance shop private limited',
    'Ameya hospitality services & hostels private limited',
    'Aanya real estate private limited',
    'ROOTS AGROTECH PRIVATE LIMITED',
    'Pgk enterprises private limited',
    'Juris metrics consulting private limited',
    'Shamrao peje kokan itar magasvarg aarthik vikas mahamandal limited',
    'Shreyas shipping agencies private limited',
    'H t parekh foundation',
    'Globetrot resource management private limited',
    'V-GOLDENAGE HEALTH & MEDIECARE (INDIA) PRIVATE LIMITED',
    'Live life love life charity foundation',
    'American institute of pathology and laboratory sciences private limited',
    'Birbal consulting private limited',
    'Peepul capital advisors private limited',
    'Conquest energy solutions india private limited',
    'Vinodhini hospitality private limited',
    'Skylark initiatives india private limited',
    'Sigma outsourcing services private limited',
    'Absee peninsular private limited',
    'Juice hair marketing private limited',
    'Finchrome advisors private limited',
    'Skyclara enterprise solutions private limited',
    'Total search solutions private limited',
    'Seejay management consultants private limited',
    'Den new broad communication private limited',
    'Ocean sea and air logistics private limited',
    'ELIXI HITEC PRIVATE LIMITED',
    'Tejgyan global foundation',
    'Body and soul health and beautycare (india) private limited',
    'Consultants india land mapping private limited',
    'India exposition mart ltd',
    'Soltex petro products ltd.',
    'Seven-s banking management consultancy services private limited',
    'Ecil-rapiscan limited',
    'Terruzzi fercalx india limited',
    'The bisra stone lime company limited',
    'Milk partners india limited',
    'Ramgopal polytex limited',
    'OPERATIONAL ENERGY GROUP INDIA LIMITED',
    'Mavens biotech limited',
    'Provogue (india) limited',
    'Thomas scott (india) limited',
    'Morepen laboratories limited',
    'Unick fix-a-form and printers ltd',
    'Datre corporation limited',
    'Arshiya limited',
    'Spenta international limited',
    'KRISHANVEER FORGE LIMITED',
    'G. g. automotive gears limited',
    'Electronica industries limited',
    'Netlink solutions (india) limited',
    'Signet industries limited',
    'RR METALMAKERS INDIA LIMITED',
    'Sakuma exports limited',
    'Seamec limited',
    'Coastal corporation limited',
    'The swastik safe deposit and investments ltd',
    'Indus finance limited',
    'Hb leasing and finance company limited',
    'Capri global capital limited',
    'Kreon finnancial services limited',
    'Hb stock holdings limited',
    'Rrb securities limited tfr. co. from delhi to haryana',
    'Hb portfolio limited',
    'Shree precoated steels limited',
    'XTGLOBAL INFOTECH LIMITED',
    'Baron infotech limited',
    'ACCELYA SOLUTIONS INDIA LIMITED',
    'Mpil corporation ltd',
    'Healthcaps india limited',
    'AYM Syntex Limited',
    'Best eastern hotels limited',
    'Sonarika hotels private limited',
    'Arush metal casting limited',
    'Pathak telecom company private limited',
    'Eilisys technologies private limited',
    'Pagoda forests limited',
    'Star grain and shipping private limited',
    'Prudent natural products private limited',
    'Majjigowri agro farms private limited',
    'Sandor animal biogenics private limited',
    'Systematix commodities services private limited',
    'Lotus stem farms private limited',
    'Jai agro industries ltd',
    'Magene research foundation',
    'NCR RAIL INFRASTRUCTURE LIMITED',
    'Manubhai properties private limited',
    'Highway concessions one private limited',
    'Yash skyscrapers private limited',
    'Knoll realty private limited',
    'Sri kubera constructions private limited',
    'Ashoka developers & builders limited',
    'Chitturi projects private limited',
    'Magadh projects private limited',
    'Malaxmi infra ventures (india) private limited',
    'Golden tower infratech private limited',
    'Belcosys infra tech private limited',
    'Accolade builders and services private limited',
    'Jkb housing private limited',
    'Maa harsiddhi infra developers private limited',
    'Indrama buildwell private limited',
    'INDRAMA INFRASTRUCTURE MANAGEMENT SERVICES PRIVATE LIMITED',
    'Ferragamo retail india private limited',
    'Breezewell developers private limited',
    'Sahyog rcc (structures) private limited',
    'Svm realty private limited',
    'MANAV NESVI TRENDZ PRIVATE LIMITED',
    'Moistclay infracon private limited',
    'Ratnadeep infrastructure private limited',
    'Saptak buildcon private limited',
    'Pavan technocon private limited',
    'Shreenathji-udaipur tollway private limited',
    'IBC MANAGED OFFICE SPACE SERVICES PRIVATE LIMITED',
    'COWRKS INDIA PRIVATE LIMITED',
    'Krishna lila heritage theme park private limited',
    'Meritra homes private limited',
    'Konkan homes private limited',
    'Sanran international private limited',
    'Dariyalal developers private limited',
    'Vishaka properties private limited',
    'Gurukul constructions private limited',
    'Arens infratech private limited',
    'Sudarshan mega structure private limited',
    'Tata steel special economic zone limited',
    'SANJAY INFRASTRUCTURE DEVELOPMENT PRIVATE LIMITED',
    'Just and fair estate private limited',
    'Shruti constructions private limited',
    'Sumangalam builders pvt ltd',
    'PRAGATI LAND DEVELOPERS PRIVATE LIMITED',
    'Prestige buildhome private limited',
    'Pearl infracreation private limited',
    'Malles constructions private limited',
    'Sarvaga housing private limited',
    'Gerb vibration control systems private limited',
    'Gigaplex estate private limited',
    'Ashish interbuild private limited',
    'Rohak infraprojects private limited',
    'Excellion realty private limited',
    'Soham developers private limited',
    'Groundworkz projects private limited',
    'NAGPUR - SEONI EXPRESS WAY PRIVATE LIMITED',
    'Uniquepark constructions private limited',
    'Chakiat infrastructure and investments private limited',
    'Kasturi infracon private limited',
    'Trip guard engineering india private limited',
    'Gvr ashoka chennai orr limited',
    'Ajnara realtech limited',
    'Tapsi infra & power private limited',
    'Vidur infrastructure private limited',
    'Parshavnath power projects private limited',
    'Sunflower realcon private limited',
    'B. n. rathi industries private limited',
    'Abhishek organizers private limited',
    'P g setty construction technology private limited',
    'Rmz infotech (pune) private limited',
    'CICIL ENGINEERS PRIVATE LIMITED',
    'Imp energy limited',
    'Kites infracon private limited',
    'Rmk infrastructure private limited',
    'Excelsior projects private limited',
    'Vyshnavi infrabuild (india) private limited',
    'Anuska homes private limited',
    'ARUNACHALA PROJECTS PRIVATE LIMITED',
    'Rkm - acpl rail infra private limited',
    'Acacia projects private limited',
    'PROFICIENT AUTOMATION AND CONTROLS LIMITED',
    'Eakcon systems private limited',
    'Experion reality private limited',
    'Experion nirman private limited',
    'Experion real estate developers private limited',
    'Gemini hitech distribution india private limited',
    'Maconns infra private limited',
    'Kumar powertech private limited',
    'Sunside buildwell private limited',
    'Varij builders private limited',
    'Yamaha music india private limited',
    'Neelanchal lifestyle homes private limited',
    'Jobby infrastructure private limited',
    'Utopia constructions private limited',
    'Continental infracon private limited',
    'Aqube infrastructures and developers private limited',
    'Protechsoft systems private limited',
    'E-animedia solutions private limited',
    'Redim technologies private limited',
    'PDSVISION (INDIA) PRIVATE LIMITED',
    'Redim software technologies private limited',
    'Marc software private limited',
    'Esk software services private limited',
    'Paypal india private limited',
    'Async systems private limited',
    'Microsense networks private limited',
    'Senelda consultants private limited',
    'Ahsan consulting private limited',
    'AGRIYA INFOSYSTEMS PRIVATE LIMITED',
    'Abr systems private limited',
    'Chain-sys netpartners technologies private limited',
    'Maan sarovar tech solutions private limited',
    'Vivid edge software solutions private limited',
    'Visual bi solutions (india) private limited',
    'Playfiks softwares private limited',
    'Black and white multimedia india private limited',
    'Easy design systems private limited',
    'Aksious technologies india private limited',
    'Tkm infotech private limited',
    'MEGA DESIGNS PRIVATE LIMITED',
    'Bmpc infotech services private limited',
    'Va tech ventures private limited',
    'Chahat technology private limited',
    'System infra solutions private limited',
    'RAMANATHAN SOFTWARE PRIVATE LIMITED',
    'Ornet technologies private limited',
    'Cex webuy entertainment private limited',
    'Everest it services private limited',
    'Mafatlal cipherspace private limited',
    'Consendev services private limited',
    'Chotustore ecommerce private limited',
    'Harvest software solutions private limited',
    'CHEMIASOFT PRIVATE LIMITED',
    'Allsec technosoft limited',
    'Wpa world class services (india) private limited',
    'Hibiscus technology solutions private limited',
    'CHRYSOS UNIFIED PRIVATE LIMITED',
    'Wanclouds software solutions private limited',
    'Logicserve digital private limited',
    'Dynamic corporate solutions private limited',
    'Markace marketing private limited',
    'Money shine infocom private limited',
    'Yamaha motor solutions (india) private limited',
    'Adon system and solutions private limited.',
    'Ipacesetters solutions private limited',
    'Implevista it india private limited',
    'Rooliums technology private limited',
    'Srsg technologies private limited',
    'Intent search innovative private limited',
    'KSOLVES INDIA LIMITED',
    'Interface e-expert private limited',
    'Sns soft tech private limited',
    'Pushpam tradelink private limited',
    'Radix analytics private limited',
    'Intelligent it hub private limited',
    'Pointcross .com private limited',
    'Mind speed integrated solutions private limited',
    'Arcadix infotech private limited',
    'Carmatec it solutions private limited',
    'Toadfly technical services private limited',
    'Emudhra limited',
    '99games online private limited',
    'ACADINNET SCIENTIFIC PRIVATE LIMITED',
    'Vnv business solutions private limited',
    'Jiem india private limited',
    'Digitaminds private limited',
    'Caddycode solutions private limited',
    'Angada software ventures private limited',
    'Raos technology solutions private limited',
    'Tallenge india private limited',
    'East consultancy services private limited',
    'Steadyground technologies private limited',
    'Trichur techno park private limited',
    'Effects-media design and training private limited',
    'B4u broadband (india) private limited',
    'SPINNERZ GLOBE PRIVATE LIMITED',
    'Enrita s solutions private limited',
    '3 di systems (india) private limited',
    'GEKOM LOGISTICS PRIVATE LIMITED',
    'Medsphere india private limited',
    'SNA FABRICS AND SILHOUETTE PRIVATE LIMITED',
    'Nam technologies private limited',
    'Tantrasoft solutions (india) private limited',
    'Z and a infotek private limited',
    'Faxonics technologies private limited',
    'Etrends technologies private limited',
    'Ambab infotech private limited',
    'Oss software solutions labs private limited',
    'Ican bpo private limited',
    'Solsynch technologies private limited',
    'Suninfy technologies private limited',
    'Cognitio communications private limited',
    'Mane tech private limited',
    'Mahaonline limited',
    'Granite (india) private limited',
    'A.p. coastal sands and metals private limited',
    'Titan metals and minerals limited',
    'Trimex sands private limited',
    'Tubeline fabricators and engineers (india) private limited',
    'REPS PACK PRIVATE LIMITED',
    'Samvene foods private limited',
    'Mng overseas private limited',
    'Vrindavan restaurant private limited',
    'Gaiya dairy foods private limited',
    'Vadilal international private limited',
    'S HOMOEOPATHIC HEALTHCARE PRIVATE LIMITED',
    'Western ahmedabad effluent conveyance company private limited',
    'Jetserve aviation private limited',
    'Parisudh eco concepts private limited',
    'M.g.r. tv private limited',
    'Polyplastics uttar bharat private limited',
    'Minda international limited',
    'Shri ram sharanam consultants private limited',
    'Pure natural products private limited',
    'BELLA MADONNA SALONS PRIVATE LIMITED',
    'Lansdowne towers owners association',
    'Eastern international hotels limited',
    'Kay kay holdings pvt ltd',
    'Exclusive vision broadcast private limited',
    'Rock and raaga entertainment private limited',
    'Exotica entertainment private limited',
    'R r sen & bros private limited',
    'B & a limited',
    'THE TELOIJAN TEA CO LTD',
    'Complex trading co ltd',
    'Uniroyal marine exports ltd',
    'Superior industrial enterprises limited',
    'Indian sucrose limited',
    'Tyford tea limited',
    'Teesta valley tea co ltd',
    'Balmer lawrie and company limited',
    'Winsome holdings & investments limited',
    'THE INDIAN WOOD PRODUCTS CO LTD',
    'DUROPLY INDUSTRIES LIMITED',
    'Shree krishna paper mills & industries ltd',
    'Coal india ltd govt of india undertaking',
    'Fertilisers and chemicals travancore ltd',
    'Upl limited',
    'Samrat pharmachem limited',
    'Kemp and company limited',
    'THE MIDLAND RUBBER AND PRODUCE COMPANY LTD',
    'Anuradha investments ltd',
    'Ankit metal & power limited',
    'Goan carnival and leisure private limited',
    'Vertigo facility management india private limited',
    'Transgalaxia services private limited',
    'Mm physi-health care',
    'Anu ashish medical services private limited',
    'Eri-tech limited',
    'United drilling tools limited',
    'Bedmutha industries limited',
    'Sar auto products limiteed',
    'Vaibhav heavy vehicles ltd',
    'Western india shipyard limited',
    'Chennai petroleum corporation limited',
    'Expo gas containers limited',
    'LALIT GREAT EASTERN KOLKATA HOTEL LIMITED',
    'Richi-rich construction & developers private limited',
    'Nischaya infrabuild private limited',
    'Shubham infra organisers private limited',
    'SAMKEET BUILDSPACE PRIVATE LIMITED',
    'Imperial suits private limited',
    'Narsaria construction private limited',
    'Bhavani renewable energy private limited',
    'ENEL WIND PROJECT (AMBERI) PRIVATE LIMITED',
    'Azure renewable energy private limited',
    'Azure sunlight private limited',
    'Azure sunrise private limited',
    'Azure solar solutions private limited',
    'Azure sunshine private limited',
    'Orient body shop solutions india private limited',
    'Shri ram laminators private limited',
    'Vividha ventures private limited',
    'Abhijay superprojects private limited',
    'Uniwide projects private limited',
    'Azure green tech private limited',
    'Refex solar power private limited',
    'Assotech bebl infrastructure private limited',
    'Asian gateway ltd.',
    'Guiding infradevelopers private limited',
    'Akshya infrastructure private limited',
    'Dolphin infradevelopers private limited',
    'Archana infradevelopers private limited',
    'Advent real estates private limited',
    'DIALOMATIC PRIVATE LIMITED',
    'Misal developers private limited',
    'Sunlight buildcon private limited',
    'Ratyal constructions private limited',
    'Apex infradevelopers private limited',
    'Ninty five infratech private limited',
    'Reign o space interiors private limited',
    'Akarshak realty private limited',
    'Galfar engineering & contracting (india) private limited',
    'Jain space infra venture limited',
    'Alekhya property developments private limited',
    'Earnest constructions private limited',
    'Varin infra projects private limited',
    'Rockland realty private limited',
    'Navaratna infrastructure private limited',
    'Vismaya infrastructure private limited',
    'Navaratna superprojects private limited',
    'Avindra estate developers private limited',
    'Rama shelters private limited',
    'Manashi interiors pvt ltd',
    'Optimum buildtech and infrastructure private limited',
    'Kalpak developers private limited',
    'Shreshta infra projects private limited',
    'Refex wind power private limited',
    'Heera construction company private limited',
    'Kutch gases private limited',
    'Sagar gases private limited',
    'Gem township private limited',
    'Sheetal environs (india) private limited',
    'Advance infradevelopers private limited',
    'Agni infradevelopers private limited',
    'Comex infrastructure private limited',
    'Shikha infrastructure private limited',
    'Shriram builcons infraventures private limited',
    'Balan infrastructure private limited',
    'Stylog infrastructure private limited',
    'SHRI KRSNA URJA PROJECT PRIVATE LIMITED',
    'Mpm mall and arcades private limited',
    'Fomra housing and infrastructure private limited',
    'Global scape infrastructure private limited',
    'Patala realty private limited',
    'Hacienda properties private limited',
    'Sita realty private limited',
    'Crs towers private limited',
    'Atya contracts private limited',
    'Unitech real estate builders limited',
    'Star realcon private limited',
    'Thirty six capital private limited',
    'Visionary construction solutions private limited',
    'Global trailors (india) private limited',
    'Gomtesh builders private limited',
    'Reira constructions private limited',
    'Meenar merchants private limited',
    'Hameed and company engineers pvt ltd',
    'Rds buildcon private limited',
    'Kalindee infratech india private limited',
    'Cherian varkey construction company private limited',
    'Gulf asia contracting company private limited',
    'Shreenath construction material private limited',
    'Deepaangan buildtech private limited',
    'Life buildestate private limited',
    'H v developers private limited',
    'Ravi surya builders private limited',
    'Seaview constructions private limited',
    'Vedic realty private limited',
    'N. k. realtors private limited',
    'Mas manors development limited',
    'Royal retreat construction private limited',
    'Krishna eastern builders (india) private limited',
    'Mgm estate & properties private limited',
    'Housing builders and developers private limited',
    'Vividha properties private limited',
    'Konark builders and developers private limited',
    'Supra homes private limited',
    'Amcd infratech private limited',
    'Abs holdings private limited',
    'Jumbo properties (alpha) private limited',
    'Swastik constructions private limited',
    'Panchratna builders private limited',
    'Elegant premises private limited',
    'Era informatics private limited',
    'Luxor infotech private limited',
    'ALL E TECHNOLOGIES LIMITED',
    'Palash technologies private limited',
    'Rensol systems private limited',
    'Softdot technologies private limited',
    'New era system private limited',
    'Ivision systech private limited',
    'Grail consulting and project management services private limited',
    'Laxmiwan infrastructures private limited',
    'Nishdin buildcon private limited',
    'Goldengreen properties private limited',
    'Daima properties and investments private limited',
    'Lifetime infotech private limited',
    'Commdel consulting services private limited',
    'Aarcee builders pvt ltd',
    'Patton enterprises private limited',
    'New cyber valley private limited.',
    'Brainwave software private limited',
    'Franciscan solutions private limited',
    'Tibrewala infratech private limited',
    'Sravanaa properties limited',
    'Qtriangle infotech private limited',
    'Pragiti internet technologies private limited',
    'Rar ventures private limited',
    'Par computer sciences (international) ltd',
    'Mycom imaging supplies private limited',
    'Delta information services limited',
    'Nupas-cadmatic india private limited',
    'RIO HOME SOLUTIONS PRIVATE LIMITED',
    'Riddhi technologies private limited',
    'Zeta cyber solutions private limited',
    'Cynere infotech private limited',
    'Elw technologics private limited',
    'TIMESWORLD MEDIA AND TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'Angel infrarealcon private limited',
    'Adhunik properties pvt ltd',
    'Zillious solutions private limited',
    'Select source international private limited',
    'Sureka resources private limited',
    'Sumitra info tech private limited',
    'High performance computing links private limited',
    'Nyx software design private limited',
    'Maven wave partners (india) private limited',
    'Suma soft private limited',
    'Q2aconsulting services private limited',
    'Panipuri soft limited',
    'Green apple solutions private limited',
    'RISENSOFT TECHNOLOGY PRIVATE LIMITED',
    'Diligent softtech india private limited',
    'V SOLVE HR & IT SOLUTIONS PRIVATE LIMITED',
    'The zigma technologies india private limited',
    'Rubixis technologies private limited',
    'New technology research software services private limited',
    'C.a. tcg software private limited',
    'Truserv enterprises priavte limited',
    'Learningyogi education solutions private limited',
    'Momentum techsys private limited',
    'Rosmerta technologies limited',
    'Xeam ventures private limited',
    'Stellar information technology private limited',
    'Vmc technologies private limited',
    'Blueshield protection network private limited',
    'Voxbay solutions private limited',
    'Zookapp technolabs private limited',
    'VENUS INTERLININGS PRIVATE LIMITED',
    'Pivot bits technologies private limited',
    'New vision e-publishing solutions private limited',
    'SUGGESTIV SOLUTIONS PRIVATE LIMITED',
    'Preemptive technofield private limited',
    'V.s. infotech. private. limited',
    'T-chowk labs private limited',
    'Greedygame media private limited',
    'Murgee softwares private limited',
    'Metclouds technologies private limited',
    'Mindhelix technosol private limited',
    'Muthoot pappachan technologies limited',
    'Bizsol technologies private limited',
    'Pvr systems private limited',
    'Logimax technologies private limited',
    'Indus internet limited',
    'South asian computers limited',
    'Amtronic systems private limited',
    'Acs infotech private limited.',
    'Virtual xport gateway private limited',
    'Brill infosystems private limited',
    'Inspiring digital solutions private limited',
    'Saran softwares private limited',
    'Eco-rel computer systems private limited',
    'Saurabh infratech private limited',
    'Adways vc india private limited',
    'S a it enabled services private limited',
    'Netscape infosol private limited',
    'Replica disk computers private limited',
    'Ip access india private limited',
    'NETSURE IT SOLUTION PRIVATE LIMITED',
    'Creative appography research labs private limited',
    'Sysmind tech private limited',
    'Sarvatra it services private limited',
    'Tpg software private limited',
    'Cue learn private limited',
    'Telesole technologies private limited',
    'C.s. soft solutions private limited',
    'TELEPERFORMANCE BPO HOLDINGS PRIVATE LIMITED',
    'Cyberlinks technologies private limited',
    'Ajanta pack mart private limited.',
    'Xpwallet technologies private limited',
    'Sicher technology private limited',
    'Avaal technologies india private limited',
    'Nextgen digital imaging services (india) private limited',
    'BANNARI AMMAN FOOD PRODUCTS PRIVATE LIMITED',
    'Studio thorn hospitalities private limited',
    'Kedarnath agro products (p) ltd',
    'Sarada cereals private limited',
    'ODISHA PREFAB ENGINEERING PRIVATE LIMITED',
    'Aqua montana india private limited',
    'Perfect bread private limited',
    'Deja vu farms private limited',
    'Dnp foods limited',
    'KEWAL FASHIONS PRIVATE LIMITED',
    'Top textiles private limited',
    'Venus jewel.private limited',
    'Mangalam ventures limited',
    'Rana polycot limited',
    'T s home fashions private limited',
    'Citystar foods private limited',
    'Sagar lentils private limited',
    'Global refinery private limited',
    'The malt company (india) private limited',
    'G b land developers and colonisers private limited',
    'Mansi pipes private limited',
    'Sara osmosis private limited',
    'Regale basmati india limited',
    'Global fibres and fabrics private limited',
    'Moustache international pvt. ltd.',
    'Kals beverages private limited',
    'Khemani distilleries private limited',
    'Hasu synthetics pvt ltd',
    'Narayan fabrics pvt ltd',
    'Residency foods and beverages ltd',
    'Blue kettle ventures private limited',
    'COT FAB (INDIA) PRIVATE LIMITED',
    'Kandhari beverages private limited',
    'Raunak mattress private limited',
    'MAHA GANAPATHI MANUFACTURERS & INDUSTRIES PRIVATE LIMITED',
    'Swami textiles private limited',
    'Ncc cj cotton private limited',
    'Ncc santosh fibers private limited',
    'Ncc jay laxmi fibers private limited',
    'Ncc matoshri cotton private limited',
    'Ncc narsinh cotton private limited',
    'MAHASREE MANUFACTURERS & INDUSTRIES PRIVATE LIMITED',
    'Silverline corporation limited',
    'Vaishno international private limited',
    'Sri v.n.s. spinning mills india private limited',
    'Atease fashions pvt. ltd.',
    'M m kothari exim private limited',
    'JUTIFY LIFESTYLE PRIVATE LIMITED',
    'Shriram filaments and ropes private limited',
    'Morgan walker infrastructure limited',
    'Raksha supreme camouflage private limited',
    'Turner & townsend private limited',
    'Auckland jute co limited',
    'Jivraj commerce private limited',
    'RADHAKRISHNA MANUFACTURING & INDUSTRIES PRIVATE LIMITED',
    'Sanghi threads pvt ltd',
    'Vcare call centers india private limited',
    'Bay fashions private limited',
    'Mansha textiles pvt ltd',
    'Rajsin syntex private limited',
    'ARTLIFE GLOBAL INDIA PRIVATE LIMITED',
    'Pure kashmir exposition private limited',
    'Nirmala process (bombay) pvt ltd',
    'Ncc abhinandan cotton private limited',
    'Knitwell apparels private limited',
    'Ryan casa home collections private limited',
    'Bmd private limited',
    'RATAN TEXPROCESS PRIVATE LIMITED',
    'Sabu trade private limited',
    'INDRANI YARNS PRIVATE LIMITED',
    'Karni textile mills private limited',
    'Hillman hosiery mills private limited',
    'Seven seas mattress private limited',
    'Varshneya agrotech private limited',
    'Rahul mishra designs private limited',
    'Galaxy garments industries private limited',
    'Last inch apparel private limited',
    'Puregreen agro private limited',
    'Maharaja arts limited',
    'Chhabra home concepts private limited',
    'Freeset fabrics private limited',
    'The prem chand jute mills ltd',
    'Sel textiles limited',
    'Deez creations private limited',
    'Macsam clothing private limited',
    'Dona doni fashion private limited',
    'Yeo fah tannery pvt ltd',
    'Shivmani exports private limited',
    'Crish creations private limited',
    'WALKAROO INTERNATIONAL PRIVATE LIMITED',
    'B S ENGINEERING TOOLS PRIVATE LIMITED',
    'Kitex childrenswear limited',
    'BEEKALENE FABRICS PRIVATE LIMITED',
    'Lekhapani tea company pvt ltd',
    'Keshava plantations private limited',
    'Threesixty garments private limited',
    'Miraaya apparel & trading private limited',
    'Code of designs private limited',
    'Rajhans agrofresh private limited',
    'Tapovan paper and board mills limited',
    'Epicomm technologies limited',
    'Saber paper boards private limited',
    'Isoe printpack industries private limited',
    'Vimala paper company private limited',
    'Silvia apparel limited',
    'Loguss fashions private limited',
    'Jagdamba fashion private limited',
    'Sbf commercial private limited',
    'EXCEL GROUP PRIVATE LIMITED',
    'Lustre press private limited',
    'Jayram niryat private limited',
    'Business media private limited',
    'Pragati tracom pvt ltd',
    'R- desai paper marketing private limited',
    'Itm trading private limited',
    'Tag healthcare private limited',
    'Plaza bijli udhyog pvt ltd',
    'Topsel pvt ltd',
    'Adina exports(india) pvt ltd',
    'Shivsakti commercial private limited',
    'LENSKART SOLUTIONS PRIVATE LIMITED',
    'Silicon tradecomm private limited',
    'Intech surface coating private limited',
    'Sunrise vincom private limited',
    'Singhvahini vinimay private limited.',
    'HRISIKESH CONSTROWELL PRIVATE LIMITED',
    'Palpit vinimoy pvt ltd',
    'Real tie-up private limited',
    'Gurukul homes private limited',
    'Narsingh marketing private limited',
    'Snowfall commotrade private limited',
    'Agni dealcom private limited',
    'Adepts exim private limited',
    'Jwala dealcom private limited',
    'Soltex trade private limited',
    'Bharat nursery pvt ltd',
    'Hi-tech air systems private limited',
    'Alecon commercial private limited',
    'Agro max agencies private limited',
    'Rameswara leasing pvt ltd',
    'Citicap spectrum limited',
    'Blue apple traders private limited',
    'Pace exim private limited',
    'Mousumi marketing pvt ltd',
    'ENGINEERS AND ENGINEERS (ELECTRICALS) PRIVATE LIMITED',
    'B. k. kapurchand private limited',
    'Bioaide technologies private limited',
    'STOCKFLOW EXPRESS PRIVATE LIMITED',
    'Religare capital markets limited',
    'SNNR PRIVATE LIMITED',
    'Rosewood trexim private limited',
    'Jinwani construction private limited',
    'Ganpati fasteners private limited',
    'Indian trading bureau pvt ltd',
    'Freda arts and signs private limited',
    'Agnetta international private limited',
    'Sach exports pvt ltd',
    'Finepac structures private limited',
    'Piyush overseas private limited',
    'Blue apple tradelinks private limited',
    'UNIGLOBAL DISTRIBUTORS PRIVATE LIMITED',
    'Eurotex wood private limited',
    'Precision techserve private limited',
    'SVTL VANIJYA LIMITED',
    'Creative dealers private limited',
    'PREFERRED PARTNERS INSURANCE BROKERS PRIVATE LIMITED',
    'Mahalaxmi associates private limited',
    'S.B. DISTRIBUTORS LIMITED',
    'Takiar overseas private limited',
    'Bhadra international (india) private limited',
    'Jhalani forge private limited',
    'Melco sales pvt ltd',
    'Kasyap commercials pvt. ltd.',
    'Rama overseas ltd',
    'M.a. fashions private limited',
    'Ashoka selections private limited',
    'COMMITTED ISPAT PRIVATE LIMITED',
    'Jindatt exports pvt ltd',
    'Chatterjee petrochem (india) private limited',
    'Lakhanpal enterprises private limited',
    'Pride india fmcg private limited',
    'Vinayak ingredients (india) private limited',
    'Thacker overseas private limited',
    'Karisma goods private limited',
    'Four aces mercantile private limited',
    'Zen marketing limited',
    'Spey medical private limited',
    'Benzer department stores private limited',
    'Radhey radhey overseas private limited',
    'Captivate commercials private limited',
    'Maser india private limited',
    'P. d. shah & sons traders private limited',
    'Jumbo commercial private limited',
    'Zetatek technologies private limited',
    'Suchirindia impex private limited',
    'Omaxe housing and commercial projects limited',
    'Cherry distributors private limited',
    'Civil lines properties private limited',
    'Ud marketing pvt ltd',
    'Top apparels pvt ltd',
    'Murli impex pvt ltd',
    'Inland power limited',
    'Manubhawan distributors pvt ltd',
    'Pansari organochem private limited',
    'Pennar vanijya pvt ltd',
    'Kamayani commodities private limited',
    'Jeeva nursing home private limited',
    'Dayavant tradelink private limited',
    'Vanaspati vintrade private limited',
    'Narayani dealtrade private limited',
    'Sabhyata vintrade private limited',
    'Crystal comfeed private limited',
    'Wonder care private limited',
    'Inspiring vinimay private limited',
    'Sidhidata exim private limited',
    'Shs merchants private limited',
    'Sunayana commercial pvt ltd',
    'Arrowspace commercial limited',
    'Ritudhan mercantile private limited',
    'Shivangan goods private limited',
    'Rashidhan exports private limited',
    'Arch tradecomm private limited',
    'Regnant financial process & tax advisors private limited',
    'Safomasi enterprises private limited',
    'ZIVAH FOUNDATION',
    'Nilorn india private limited',
    'JAS PROFESSIONAL PRIVATE LIMITED',
    'Kaushalya consultants private limited',
    'Movex services private limited',
    'Oasis industries private limited',
    'Mms (india) private limited',
    'Bird information systems private limited',
    'Ons services private limited',
    'Integrated techno systems private limited',
    'CREDIBLE INVESTMENT SERVICES PRIVATE LIMITED',
    'Vedant corporate services private limited',
    'San holistic fitness solutions private limited',
    'Indus valley incubators private limited',
    'Harikripa management consultants private limited',
    'Bworld corporate solutions private limited',
    'Blue consulting private limited',
    'Versatile infosecurity private limited',
    'V t palresha and company private limited',
    'Precision e-technologies private limited',
    'Sun shares trading & consultancy private limited',
    'Torrence capital advisors private limited',
    'Virtual kpo consultants private limited',
    'First policy insurance brokers private limited',
    'Ganesh consultants private limited',
    'Spaaj techno solutions private limited',
    'Domotics automation private limited',
    'Arasa tree entertainment private limited',
    'Effective development & consultancy services pvt ltd',
    'Suvarna commercial pvt ltd',
    'Sagarmal ramesh kumar pvt ltd',
    'Sun utility management private limited',
    'JASUMAL & CO (OPC) PRIVATE LIMITED',
    'West bengal infrastructure development finance corpn ltd (wbgovt company)',
    'P n s business private limited',
    'Sunrise point maintenance & services private limited',
    'Gyron consultancy services private limited',
    'Daga damani developers pvt ltd',
    'Jars services private limited',
    'Vikrama architecture and design private limited',
    'Tekpath consultants and engineers private limited',
    'Riki estates pvt ltd',
    'CITI PROPERTIES & FINANCE PVT LTD',
    'BUSINESS ESTATES & COMMUNICATIONS PVT.LTD.',
    'Sepratech solutions private limited',
    'Rubicon learning systems private limited',
    'Pathfinders media private limited',
    'KARABI ART COMMUNITY PRIVATE LIMITED',
    'Anmoul infomatics private limited',
    'Polinsys immigration consultants private limited',
    'Atees infomedia private limited',
    'Jyoti sugar engineering private limited',
    'SHREE GARUDA PLANT PRODUCTS PRIVATE LIMITED',
    'Smps engineers and consultants. (bombay) pvt ltd',
    'L&t-sargent & lundy limited',
    'Bhogal management services private limited',
    'Raavela interiors private limited',
    'Merchbay products private limited',
    'Devante consulting private limited',
    'Tyco (india)pvt ltd',
    'Online productivity solutions private limited',
    'Sutra quality management private limited',
    'Baroda water management consultants private limited',
    'Jagaran microfin private limited',
    'Marketing management group consultants private limited',
    'Urban infratech services private limited',
    'Emerald residency solutions private limited',
    'Fidere engineers & services private limited',
    'Land mark out door media services private limited',
    'Red packing solutions private limited',
    'Excel project consultants private limited',
    'Konark engicon private limited',
    'Divya industries ltd.',
    'Maunsell harris consulting engineers private limited',
    'Studio u plus a (india) private limited',
    'Navsurya systems pvt. ltd.',
    'Gensol consultants private limited',
    'MANIT HEALTHCARE AND LIFE SCIENCE PRIVATE LIMITED',
    'Foster geotech private limited',
    'Classic publicity private limited',
    'Central office mewar palace organisation private limited',
    'Srishti sanchar advertising private limited',
    'Swirl engineering private limited',
    'Sita devi industries private limited',
    'PRANNATH KAPUR & SONS PRIVATE LIMITED',
    'VERTEBRAND CONSULTING AND SOLUTIONS PRIVATE LIMITED',
    'Secon private limited',
    'Trump trainers and consultants private limited',
    'Mape advisory group private limited',
    'Nalapad suraksha private limited',
    'Cks consulting private limited',
    'ARCADIS INDIA PRIVATE LIMITED',
    'Techwarren nifty information solutions private limited',
    'E s d management and consultancy private limited',
    'Arista consulting services private limited',
    'Neomagic integrated systems private limited',
    'Bangalore education guide line private limited',
    'Stratforward marketing consulting private limited',
    'HONAVAR PORT PRIVATE LIMITED',
    'Consumer cloud technology services private limited',
    'Anu projects consultants and engineers pvt ltd',
    'Better management services pvt ltd',
    'Fuji technical services pvt ltd',
    'Lamcon finance and management services private limited',
    'Sharda consultancy private limited',
    'Swastik disa developers private limited',
    'Telepoint services (india) private limited',
    'Business access (india) pvt ltd',
    'R-rolls consultants private limited',
    'Drizzle tax consultants private limited',
    'Big management consultants private limited',
    'Valmax corporate services private limited',
    'Integrated design associates india private limited',
    'Awa lighting designers private limited',
    'Oaks management consultancy private limited',
    'New horizon wealth management private limited',
    'Avenues corporate advisors private limited',
    'Centre for excellence in management training and development',
    'Illustrious consulting services private limited',
    'Transerve advisors private limited',
    'ENSEMBLE PROPERTIES LIMITED',
    'Faering capital private limited',
    'Ziqitza brand management private limited',
    'Iap hr consultants private limited',
    'Uvimac engineering solutions private limited',
    'Crescendo infotech services private limited',
    'SUMEET FACILITIES LIMITED',
    'Cinque consulting consortium private limited',
    'Sg analytics private limited',
    'Ecmat limited',
    'MY HOME POWER CONSULTANCY SERVICES PRIVATE LIMITED',
    'Sai supersand minerals private limited',
    'Kan talent associates private limited',
    'Cholamandalam ms risk services limited',
    'Surana and surana international consultants private limited',
    'Digiterati consultancy private limited',
    'Surana & surana international accountants private limited',
    'PROFIZIO IT SOLUTIONS PRIVATE LIMITED',
    'Q-pro consultancy services private limited',
    'Rasika advisory services private limited',
    'Express advisory services private limited',
    'Delphi management services private limited',
    'Saira asia interiors private limited',
    'TECHNIQUE CONTROL FACILITY MANAGEMENT PRIVATE LIMITED',
    'Dolphin electro magnetic technologies private limited',
    'Advac heat treaters private limited',
    'Kriya design technologies private limited',
    'SURI ENGINEERS PRIVATE LIMITED',
    'Ifocus comtech private limited',
    'Sabs architects and engineers private limited',
    'C.j. design and solutions private limited',
    'Rotarex engineering private limited',
    'Vac design engineers private limited',
    'Sagarmal suresh kumar pvt ltd',
    'Ncgb engineering co. private limited',
    'Fabricon engineering private limited',
    'Vistas ad media communications private limited',
    'ORMAX EVOLVE PRIVATE LIMITED',
    'STREETBUZZ MEDIA PRIVATE LIMITED',
    'Design temple private limited',
    'Design den media private limited',
    'Magnum designs pvt ltd',
    'Zenith media india private limited',
    'Hindustan shipyard limited',
    'The eastern economist ltd',
    'Deena paints limited',
    'FABINDIA LIMITED',
    'Paradise tour co.(india) pvt.ltd.',
    'Anup kothari pvt ltd',
    'Sapphire ( india ) private limited',
    'NARMADEY E-BEAMED POLYMER PRODUCTS PRIVATE LIMITED',
    'Sgb engineering private limited',
    'Shahnaz ayurveda private limited',
    'Ralcon systems pvt ltd',
    'Sas braketech limited',
    'Metenere (global) limited',
    'Super mix india private limited',
    'Ruck sack tours private ltd.',
    'Nag investment private limited',
    'Adinfix advertising private limited',
    'Janrise advertising private limited',
    'EGITA NETWORK AND MEDIA PRIVATE LIMITED',
    'Fantasy travels and tours private limited',
    'Eternal ganges press private limited',
    'Khaitan rice mill private limited',
    'Rnp agro industries private limited',
    'Shreearihant logistics pvt ltd',
    'Premier minerals exploration private limited',
    'Knk corp private limited',
    'KAPPA MINES AND MINERALS PRIVATE LIMITED',
    'Mineral wealth of india private limited.',
    'Zeba agro private limited',
    'Naturefresh industries limited',
    'Jainson granite and marmo-real private limited',
    'Jayant marbles private limited',
    'Jaypeem granites private limited',
    'HEMP PHARMA AMRO PRIVATE LIMITED',
    'Farinex india private limited',
    'Vpa foods private limited',
    'Aabad food pvt ltd',
    'Mothi bakeries and foods private limited',
    'Dhanalakshmi srinivasan sugars private limited',
    'Satish sugars limited',
    'Prasad sugar & allied agro products limited',
    'Rajasthan state ganganagar sugar mills ltd',
    'Horizon agrochem ltd',
    'Shree hanuman sugar & industries ltd',
    'Bakemen foods private limited',
    'KN AGRI RESOURCES LIMITED',
    'Golden virgin coconut oil private limited',
    'LASENOR INDIA PRIVATE LIMITED',
    'Aromatic ingredients private limited',
    'Komal exotic spices private limited',
    'Ritika vegetable oil private limited',
    'Bikaji foods international limited',
    'Shyam dhani industries private limited',
    'Synthokem labs private limited',
    'Mermaid cream packs private limited',
    'Vanraj foods private limited',
    'Ambicon brewpub private limited',
    'Mason and summers alcobev private limited',
    'Rsb distilleries (india) private limited',
    'Sushma snacks private limited',
    'Bansal flour mills private limited',
    'Jay baba bakreswar rice mill private limited',
    'S l industries p. ltd.',
    'Noble agro vet private limited',
    'Maya pet food & accessories private limited',
    'Selective minerals and color industries private limited',
    'Jani clays private limited',
    'Nathurmal eco minerals private limited',
    'Aakansha fabrics private limited',
    'Bandhan calchem private limited',
    'Citoc ventures private limited',
    'JIO FINANCE LIMITED',
    'SHREE GAYATRI COTTEX ENGINEERS LIMITED',
    'Fine spinners private limited',
    'Asia minerals india private limited',
    'Kaspar resources private limited',
    'Meenakshi sundaram mica mines private limited',
    'Shri vasudeva weaving mills private limited',
    'Sahara india infrastructural development limited',
    'Karinos weave private limited',
    'Ayurvedant pvt ltd',
    'Bite me foods private limited',
    'OCTAVIUS INDUSTRIES LIMITED',
    'Sonthalia snax foods private limited',
    'Acme safety wears limited',
    'Amar universal private limited',
    'Vanheal food private limited',
    'Sipping spirits private limited',
    'Gra international bizkom limited',
    'Guru kripa polyfabs private limited',
    'Scorpios beverages private limited',
    'Authenticity tex india private limited',
    'Moksha foods and beverages private limited',
    'Huligamma devi agro farms private limited',
    'GBTL LIMITED',
    'Green leaf tobacco threshers limited',
    'Chavi enterprises private limited',
    'Himdoot mercantile private limited',
    'Prayosha food services private limited',
    'Thermo care rockwool india private limited',
    'Ferozepur foods energy private limited',
    'Pokarna engineered stone limited',
    '3F OIL PALM PRIVATE LIMITED',
    'Expresso foods private limited',
    'Abeer textile private limited',
    'Oswal polycot (india) private limited',
    'Dove fashions private limited',
    'S. kumars limited',
    'Habitaat textildecors private limited',
    'GO FASHION (INDIA) LIMITED',
    'Vic bags private limited',
    'Uni tex products private limited',
    'Vrijesh overseas private limited',
    'Mahacot fabrics private limited',
    'Prag jyoti syntex limited',
    'UTSAV FABRICS PRIVATE LIMITED',
    'Tower overseas limited',
    'Sahiba limited',
    'Shriji textile private limited',
    'Sunita fashion private limited',
    'Universal texturisers private limited',
    'C mohanlal private limited',
    'Kankariya techno-screens private limited',
    'N J TEXTURISERS PRIVATE LIMITED',
    'Arena realty private limited',
    'Dbs internet services private limited',
    'FLUENTECH TECHNOLOGIES PRIVATE LIMITED',
    'Basil powertek private limited',
    'Arctic telecommunications private limited',
    'Gemini traze rfid private limited',
    'Sanchar telesystems limited',
    'Abbey infraprojects private limited',
    'Macro vision telenet private limited',
    'Cirrus media research private limited',
    'Living audio private limited',
    'Swarp films private limited',
    'Megafoods products madras private limited',
    'Elsons garments private limited',
    'Dr optical disc india private limited',
    'Sai music house private limited',
    'Euro-asian interventional technologies private limited',
    'TARAX TECH PRIVATE LIMITED',
    'Hemant surgical industries limited',
    'Mini med laboratories pvt ltd',
    'Ands lite private limited',
    'Deltech engineering private limited',
    'Avinash cables (india) private limited',
    'Complete instrumentation solutions private limited',
    'Star biomed private limited',
    'Bio-tech vision care private limited',
    'Essess amalgamates private limited',
    'Neural controls private limited.',
    'Citizen watches (india) private limited',
    'Universal automotives private limited',
    'Avk automall private limited',
    'Ns instruments india private limited',
    'Tanu motors private limited',
    'Sai service agency (bombay) private limited',
    'Kar motors private limited',
    'Autologue motor designs private limited',
    'PRICOL LIMITED',
    'Emmbros automotives private limited',
    'Masu brakes private limited',
    'Cjr precision products private limited',
    'Srv automotives private limited',
    'Zem auto parts private limited',
    'Oriental-at auto & engg. private limited',
    'Mitsubishi electric automotive india private limited',
    'Surin automotive private limited',
    'VOSS AUTOMOTIVE INDIA PRIVATE LIMITED',
    'Laxmi agni components and forgings private limited',
    'SFS GROUP INDIA PRIVATE LIMITED',
    'Premdan hotels pvt ltd',
    'Prachay auto parts private limited',
    'Micro supreme auto industries (india) private limited',
    'Sas autocom engineers india private limited',
    'Micro cnc technologis private limited',
    'Ats elgi limited',
    'Sandhar technologies limited',
    'Hoguva steel private limited',
    'Arico marine consultants p.ltd.',
    'Sonar marine consultant private limited',
    'Pinky shipyard private limited',
    'Prayati shipping private limited',
    'Sunny logistics private limited',
    'Poddar transport corporation private limited',
    'Avon fitness machines private limited',
    'BRAKES INDIA Private Limited',
    'Luxeron private limited',
    'D r modular furniture private limited',
    'Nakoda mirrors private limited',
    'Opus indigo designs private limited',
    'Natasha engineers private limited',
    'Tee and vee furniture system private limited',
    'ROKA INTERNATIONAL LIMITED',
    'Beverly hills polo club fragrances private limited',
    'Craftred designs private limited',
    'BURGEON VERTICLES PRIVATE LIMITED',
    'Egwood private limited',
    'Anand make furnitures private limited',
    'Apace apparels and equipments private limited',
    'Kribha handicrafts private limited',
    'Sangkaj auto components private limited',
    'Unique ergonomic furniture private limited',
    'Amazing homes furnishings private limited',
    'Musou micro flash foams private limited',
    'Kalyaneswari udyog private limited',
    'Diastar jewellery private limited',
    'Sairus gems private limited',
    'Gen x jewels private limited',
    'Sanghavi jewel private limited',
    'VISION GEMS PRIVATE LIMITED',
    'Diabu diamond tools (india) private limited',
    'Tristar jewellery exports pvt ltd',
    'Worldwide diamond manufacturers private limited',
    'Aska jewels private limited',
    'Gl diamond sourcing private limited',
    'Dwarka gems limited',
    'AKASH GEMS PRIVATE LIMITED',
    'Belle diamond jewelry private limited',
    'RACQUETHUB INDIA PRIVATE LIMITED',
    'Unigifts novelties private limited',
    'Rasi colour inks private limited',
    'Add pens private limited',
    'Bengal handicrafts development private limited',
    'Ecotech machinery private limited',
    'Chelsea blocks and pipes private limited',
    'Roots multi clean limited',
    'Adi staffing and consulting private limited',
    'Driftwood holidays private limited',
    'Ivory guest house private limited',
    'La-klassic restaurants and banquests pvt.ltd.',
    'Plaza resorts pvt ltd',
    'Double aa restaurants private limited',
    'Oak cafe private limited',
    'Nandanavana hotels & resorts private limited',
    'Oriental cuisines private limited',
    'Green globe tourism private limited',
    'Govinda no one entertainment private limited',
    'Park nest hotels private limited',
    'Kamakhya hospitality services private limited',
    'Jaysham hotels private limited',
    'Samartha leisures & restaurants private limited',
    'Bhooteshwar sales private limited',
    'Smish hospitality private limited',
    'Isharkmart private limited',
    'OPTIMISTIC GREEN ENERGY PRIVATE LIMITED',
    'Masseys audio visuals private limited',
    'New haven enterprise private limited',
    'Utsav resort pvt ltd',
    'Adab hospitality services private limited',
    'Juhu beach resorts limited',
    'R p resorts private limited',
    'Sri ganesh hospitality services private limited',
    'Olive beach properties private limited',
    'Arihant hospitality (chennai) private limited',
    'Pegasus clubs and resorts private limited',
    'Lush green island resorts and trade private limited',
    'Movers international private limited.',
    'Renown forwarders private limited',
    'Hind musafir agency limited',
    'Chamong chiabadi resorts private limited',
    'Marc dining software private limited',
    'Kata-kali resorts private limited.',
    'Apeejay logistics park private limited',
    'U s warehousing & logistics private limited',
    'VIAGGINDIA TOURS & TRAVELS PRIVATE LIMITED',
    'Maini materials movement private limited',
    'S COFFEE COMPANY PRIVATE LIMITED',
    'Go green beverages private limited',
    'Zeal holdings private limited',
    'Aps holding private limited',
    'Daksh capital private limited',
    'Akm enterprises private limited',
    'Vishwas wealthcare private limited',
    'The cambay investment corporation limited',
    'Deltoid services private limited',
    'Aravali conclave private limited',
    'S h finance & credit pvt ltd',
    'BIKHAM PRIVATE LIMITED',
    'CHATSWORTH INFRA & DEVELOPMENT PRIVATE LIMITED.',
    'ICE JEWELLERY PRIVATE LIMITED',
    'Pristine mansions private limited',
    'Pentex leasing and financial services pvt.ltd.',
    'Omy finance investments pvt ltd',
    'Pious propbuild private limited',
    'Upturn propbuild private limited',
    'Duo township projects private limited',
    'Tulsi highrise pvt ltd',
    'OPEN FUTURES & DERIVATIVES PRIVATE LIMITED',
    'Aga infrastructure private limited',
    'Vishav real estates private limited',
    'PREMASHRAM PROPERTIES PRIVATE LIMITED',
    'JAINCO BUILDCON PRIVATE LIMITED',
    'Granite infrastructure private limited',
    'Aa walker estates private limited',
    'Knk holding pvt ltd',
    'Achal holdings pvt ltd',
    'Tirupati balaji securities pvt ltd',
    'FORTUNE CAPITAL CITY & TOWERS PVT LTD',
    'R d housing pvt ltd',
    'R.a.estates private limited',
    'Abg projects private limited',
    'Siddha projects private limited',
    'Artistery house private limited',
    'Baunt finance & investment pvt ltd',
    'Dayco securities pvt ltd',
    'Sfs finance ltd.',
    'Panditiya developers pvt ltd',
    'Ambay forex private limited',
    'Sapthagiri buildwell privte limited',
    'Neeru landcon private limited',
    'Aadinath megabuilders private limited',
    'Mohnot holdings private limited',
    'TURTLE IN MOTION PRIVATE LIMITED',
    'Westgate infra private limited',
    'Realisstic infracon private limited',
    'Ratanagar estate & investment private limited',
    'Vision one infrastructure management services private limited',
    'Skh real estate private limited',
    'D c properties private limited',
    'A d exports pvt ltd',
    'Heritage resources pvt. ltd.',
    'Chatrapati real estate and projects private limited',
    'P c developers services pvt ltd',
    'Nortex real estate private limited',
    'Sadbhaav niketan private limited',
    'Park town projects private limited',
    'PODDAR POLYKRAFT PRIVATE LIMITED',
    'Sarvaga infra developers private limited',
    'Viewline nivas private limited',
    'Roxy realtors private limited',
    'Vidyut property & power developers private limited',
    'Lossy estates and investments pvt ltd',
    'Tdi buildcon private limited',
    'Gandharv buildcon private limited.',
    'Taurus combines private limited',
    'LSUP REAL ESTATE PRIVATE LIMITED',
    'Rising residential galaxy private limited',
    'Murlidhar corporate homz private limited',
    'Park town developers private limited',
    'Nimbus buildcon private limited',
    'BLUE JAY FACILITIES SOLUTIONS PRIVATE LIMITED',
    'ESPEEA PROMOTERS & DEVELOPERS PRIVATE LIMITED',
    'Regent services pvt ltd',
    'Ragini holdings pvt.ltd.',
    'RATHI ELECTROMECH & MOTORS PRIVATE LIMITED',
    'Rangoli enclave private limited',
    'Celica developers private limited',
    'Srijan bhumi limited',
    'Lifelong hirise private limited',
    'Rajarhat promoters pvt ltd',
    'Crystal realtech private limited',
    'Chirimar and singh developers private limited',
    'Jatashiv plazza private limited',
    'Samyak towers private limited',
    'Zumma developers private limited',
    'Darvell estates india pvt ltd',
    'J. j. rashtriya infrastructure development limited',
    'Shaila realty management private limited',
    'Liberty highrise private limited',
    'Mahadeo projects pvt ltd',
    'Zygote infratech private limited',
    'Murlidhar infraprojects private limited',
    'Gms joint ventures private limited',
    'Mahadeo infrastructure pvt ltd',
    'Rajarhat housing pvt ltd',
    'Logiciel information systems private limited',
    'Cognizione consulting & solutions private limited',
    'R v netsoft private limited',
    'Trantor software private limited',
    'Rajarhat builders pvt ltd',
    'Rajarhat towers pvt ltd',
    'Vcare technologies private limited',
    'Rajarhat enclave pvt ltd',
    'Orchid towers pvt ltd',
    'Tirupati infracon private limited',
    'Skh buildcon private limited',
    'Hilltop housing private limited',
    'Bhooteswar infracon private limited',
    'Bhujadhari buildcon private limited',
    'Bliss cottage private limited',
    'Gurumukh minerals private limited',
    'Riju cement ltd',
    'Vip pharmaceuticals private limited',
    'Balaji laminator private limited',
    'Sunny detergent pvt ltd',
    'Mancure drugs private limited',
    'Stilton designs pvt ltd',
    'Usaka industrial components private limited',
    'Satya shyam steels private limited',
    'Slm technology private limited',
    'Natraj aluminium products private limited',
    'Ganesh sponge private limited',
    'Univabs concrete products private limited',
    'SELVA STONE EXPORT PRIVATE LIMITED',
    'Ajinkya electromelt private limited',
    'Grow ever steel (india) private limited',
    'Daga rubber works private limited',
    'Mayadevi polycot limited',
    'Strescon industries ltd',
    'Asn polymers private limited',
    'Jaju plastics pvt ltd',
    'Lily india private limited',
    'Nashik insulations private limited',
    'Kweng alloys private limited',
    'S.R.BEADINGS LIMITED',
    'Kvs ispat private limited',
    'Suyash castings private limited',
    'Nickelwala enterprises private limited',
    'SANVIJAY VENTURES PRIVATE LIMITED',
    'B m meters private limited',
    'Kisco castings private limited',
    'URMIL TECHNOFAB PRIVATE LIMITED',
    'Pes stainless equipments private limited',
    'Shree hanuman jute mills private limited',
    'Purva alloys limited',
    'Baker gauges india private limited',
    'Jayant fabrications private limited',
    'Omega pressings private limited',
    'P s raj steels private limited',
    'Raj kesari metals pvt. ltd.',
    'Priya tools private ltd',
    'Esgi tools private limited',
    'Assam bearing private limited',
    'Vidarbha nickel private limited',
    'Global structure & infra limited',
    'Ras foils & packaging private limited',
    'Aditya fastners private limited',
    'Didar steel complex private limited',
    'ATAM VALVES LIMITED',
    'Needle industries (india) private limited',
    'Machino finance pvt ltd',
    'Vividh welding mesh private limited',
    'Max precision bearings private limited',
    'Gibraltar airsprings private limited',
    'Patiala pipes private limited',
    'Weldor engineering pvt ltd',
    'Sunflex industries private limited',
    'Prakash traders private limited',
    'Ima star cooling systems private limited',
    'Rasandik auto components private limited',
    'Micro hydrotechnic private limited',
    'Suprabha protective products pvt ltd',
    'FAIVELEY TRANSPORT RAIL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Onkar farms private limited',
    'Sansap technology private limited',
    'Jenoptik india private limited',
    'Microvision engineering private limited',
    'Flour tech engineers private limited',
    'Catalis packaging technologies private limited',
    'SHREE BALAJEE INFRAEQUIPMENT PRIVATE LIMITED',
    'SIMEM INDIA PRIVATE LIMITED',
    'Senbo engineering limited',
    'Hansa leder private limited',
    'Creative ltd',
    'Creative tannery limited',
    'Geeta pumps private limited',
    'MICRO WIREMESH & FILTERS PRIVATE LIMITED',
    'Anand printers pvt. ltd.',
    'Adamas press private limited',
    'Presmech engineering private limited',
    'Sunrise steel industries private limited',
    'Prachi forge private limited',
    'Nach engineering private limited',
    'Raj kesari electrodes private limited',
    'Mojj engineering systems limited',
    'Enar weld-braze private limited',
    'Shubham flexible packaging machines private limited',
    'Yash systems manufacturing company private limited',
    'SENVION INDIA PRIVATE LIMITED',
    'MAGNUM MACHINE & TOOLS PRIVATE LIMITED',
    'S j s cylindrs private limited',
    'Econ electro pvt ltd',
    'Chandra electronic appliances pvt ltd',
    'Shroff envirotral private limited',
    'Ghalsasi smelting private limited',
    'Synergic impressions private limited',
    'Techpro solutions private limited',
    'Alpha foam limited',
    'Ngda air conditioning and refrigeration private limited',
    'Texel global private limited',
    'Rotycan turbotech private limited',
    'Fitech engineers pvt ltd',
    'C r auluck and sons private limited',
    'Blb cables & conductors pvt ltd',
    'Chetna electronics private limited',
    'Smith therm private limited',
    'Jindal electro systems private limited',
    'CONTINENTAL CARBON INDIA PRIVATE LIMITED (TFR.CO. FROM W.B. TO DELHI)',
    'Electrofab innovations (india) private limited',
    'Devi powers private limited',
    'Kishor pumps private limited',
    'Safcon seals private limited',
    'Technicom chemie (india) limited',
    'Rolls makers equipment private limited',
    'YAYA PLAY ZONE PRIVATE LIMITED',
    'Ici india research and technology centre',
    'Iit madras research park',
    'Excellone technologies and solutions private limited',
    'Swatantar associates private limited',
    'Squad software private limited',
    'Development tracks in research training and consultancy private limited',
    'Saroja global services private limited',
    'Biotap info solutions pvt.ltd.',
    'Nayi disha studios private limited',
    'Mintlogix solutions private limited',
    'Empire infocom solutions private limited',
    'Malhaar business teknologies private limited',
    'R b webtel private limited',
    'Ola display india private limited',
    'Creating values private limited',
    'Ecove solutions private limited',
    'Yatharthriti it services private limited',
    'Everrise infosolution private limited',
    'Walmor infotech private limited',
    'Weekend creations private limited',
    'Rra project management private limited',
    'Ourvisions technologies private limited',
    'Venkatesh it solutions private limited',
    'Sanghi consulting engineers india private limited',
    'Great circle consultancy private limited',
    'Saluja consultancy services private limited',
    'Akasha group ventures and management private limited',
    'Voxapp private limited',
    'Elegant management solutions private limited',
    'Daksh investhub private limited',
    'Mohini international private limited',
    'Oaknorth global private limited',
    'Rnr consulting private limited',
    'Scenic hospitality private limited',
    'Authbridge research services private limited',
    'Authbridge consulting services private limited',
    'Affinity consultants private limited',
    'Hydro-comp enterprises (india) private limited',
    'Regulus infrastructure management consultancy private limited',
    'Suman project consultants private limited',
    'Baring private equity partners (india) private limited',
    'Netsmith info solutions private limited',
    'VIKRAN ENGINEERING & EXIM PRIVATE LIMITED',
    'Dfic management consultants private limited',
    'Paropkar management consultants private limited',
    'Accomplished facility management private limited',
    'Pfh capital advisors india private limited',
    'Sap advisory services private limited',
    'Srd management company private limited',
    'Quest venture co-ordinators private limited',
    'Optimal consultancy services private limited',
    'Kanetkar school of embedded technology private limited',
    'ZADGAONKARS',
    'S RESEARCH FOUNDATION',
    'Escientia lifesciences private limited',
    'Quality plus services private limited',
    'Cb management services private limited',
    'Chr global hr services private limited',
    'Chanakya ashok financial management services private limited',
    'Ammtys interior (india) projects private limited',
    'M l image perfect concepts private limited',
    'Cyber q consulting private limited',
    'Adp building consultancy private limited',
    'Gulf engineering and technical services private limited',
    'Aristo engineers private limited',
    'MSTT LIFESTYLE PRIVATE LIMITED',
    'Lemon square designs private limited',
    'Smile online sales services private limited',
    'JSR FOILS INDIA PRIVATE LIMITED',
    'New model impex private limited',
    'Cdcs eventspecific private limited',
    'SADHNA BUSINESS HUB PRIVATE LIMITED',
    'Prkhya technology solutions private limited',
    'Bharat steel tubes limited',
    'Siya ram sons private limited',
    'Premier chit fund and finance private ltd',
    'AGSM ADVISORY PRIVATE LIMITED',
    'Powerparts private limited',
    'Diljeet exports (india) private limited',
    'Empire sales private limited',
    'Geet soft technologies private limited',
    'Gl it solutions private limited',
    'Smoconnect clinical research services private limited',
    'Ibex expeditions private limited',
    'KMK SAMRA PRIVATE LIMITED',
    'Juan biotechnology private limited',
    'V k associates private limited',
    'Super chemfab engineers and consultants private limited',
    'Ashok tandon and associates pvt ltd',
    'Kwality threads private limited',
    'Envee engineering private limited',
    'Paliwal overseas private limited',
    'Superex steel products private ltd',
    'Consolidated communication limited',
    'Neeta india private ltd',
    'Bright star hotels private limited',
    'Ringtone jewellery private limited',
    'Palsons services pvt ltd',
    'Basu and associates private limited',
    'Security engineers private limited',
    'Woodlands instruments private limited',
    'Arch tech projects pvt ltd',
    'Six sigma entertainment private limited',
    'Sanauto engineers (india) private limited',
    'Fibroplast marine private limited',
    'Hitkari automobiles private limited',
    'R s products private limited',
    'Oswal motors private limited',
    'Growmore estates private limited',
    'Vishaka communications private limited',
    'Ganpati rollings private limited',
    'Shraman estates private limited',
    'Karam packaging private limited',
    'B m v fragrances private limited',
    'Shreevriddhi ispat private limited',
    'Rangoli resorts private limited',
    'Manju products private limited',
    'Unik techno systems private limited',
    'URJATECH PRIVATE LIMITED',
    'SALUMBER ENERGIE TECHNIK PRIVATE LIMITED',
    'Steelux furniture (calcutta) pvt ltd',
    'Maze system furniture private limited',
    'Noida home decor private limited',
    'Manraj jewellers private limited',
    'Chikhali industrial gases private limited',
    'Nature2nature ecosystem private limited',
    'Saimeg infrastructure (mahbubnagar) private limited',
    'Sjn energy infrastructure private limited',
    'Kota oxygen private limited',
    'Tdi builders private limited',
    'Tdi realtors and land developers private limited',
    'Vv housing private limited',
    'Srj mansion private limited',
    'Aryaman promoters private limited',
    'R. l. jewels private limited',
    'Valvet green villas private limited',
    'Habitat realty private limited',
    'Krishna sahil constructions private limited',
    'Dakshya infratech private limited',
    'Veer infra private limited',
    'C & c realtors limited',
    'Fiza developers & infrastructure private limited',
    'Autocity services pvt.ltd.',
    'Glix autocare private limited',
    'Sadhavi auto limited',
    'Anishka developers private limited',
    'Capricorn developers and homes private limited',
    'G.m. shetty constructions private limited',
    'AVAAN SHAKTI LIMITED',
    'Emerald haven realty limited',
    'Velmuruga enterprises private limited',
    'Jpk enclave private limited',
    'TECH STAIR DATA SOLUTION PRIVATE LIMITED',
    'Sk aashray private limited',
    'A. energys private limited',
    'Rishab synchro private limited',
    'Arham mangal ltd',
    'Norma machine tools private limited',
    'TFK PROJECTS PRIVATE LIMITED',
    'Alpha renewable energy private limited',
    'Engineering specialities pvt ltd',
    'Arisha vidyut pariyojna private limited',
    'Vee jay buildwell private limited',
    'Skyvalley buildcon private limited',
    'Narang infrastructure private limited',
    'Anand rural superbuilt private limited',
    'Toolman engineers private limited',
    'Suryauday solaire prakash private limited',
    'AGNI GREEN POWER LIMITED',
    'Baani landbase private limited',
    'Fort projects pvt ltd',
    'Emc overseas limited',
    'Punam energy private limited',
    'Santuka homes private limited',
    'Acme solar technologies (gujarat) private limited',
    'Dalmia tea plantation & industries limited',
    'Pcm power trading corporation limited',
    'Horizon buildwell private limited',
    'Gem apartments pvt ltd',
    'Sukhsagar premises private limited',
    'Skyline construction and housing private limited',
    'Purva good earth properties private limited',
    'Shreshta construction pvt ltd',
    'Grammy properties pvt. ltd.',
    'Purva sapphire land private limited',
    'Purva star properties private limited',
    'Hll infra tech services limited',
    'Abhijeet ashoka infrastructure private limited',
    'Janta land promoters private limited',
    'Cherry nirman private limited',
    'Kohinoor cultivations private limited',
    'Haryana tourism corporation limited',
    'Will information technologies private limited',
    'Okpet construction & services private limited',
    'Triumph infrastructure private limited',
    'Silverlake realtors private limited',
    'Aditya infradevelopers private limited',
    'North bihar highway limited.',
    'Purva ruby properties private limited',
    'Grand hills developments private limited',
    'Pawas port limited',
    'Global assets & infrastructure alliance private limited',
    'Columbia buildtech private limited',
    'S r gardens private limited',
    'Axis techconstructions private limited',
    'Safe towers private limited',
    'Secura infraservices private limited',
    'Allied matcon private limited',
    'Ozone urbana infra developers private limited',
    'Cama infra limited',
    'Shubhkamna complex private limited',
    'Dvm realtors private limited',
    'Green heights projects private limited',
    'Tumhare liye realty private limited',
    'Jainex developers private limited',
    'Shearling skins private limited',
    'Skylark technobuild private limited',
    'Ashtvinayak promoters limited',
    'KEPPEL LAND INDIA PRIVATE LIMITED',
    'Jas toll road company limited',
    'Shri niketan private limited',
    'Scc hitech infrastructure private limited',
    'Tra engineers and contractors private limited',
    'Chokhi dhani developers private limited',
    'Gee vee developers private limited',
    'N-ONE SERVICE PRIVATE LIMITED',
    'Accrete consulting engineers private limited',
    'Shivakriti international limited',
    'Shah corporate consultants private limited',
    'Intellect fincap advisors pvt ltd',
    'Y media labs private limited',
    'Rainbow facility management services private limited',
    'Feecounter online services private limited',
    'Aetius outsourcing & consulting private limited',
    'SHADE CAPITAL PRIVATE LIMITED',
    'Spec engineers and consultants private limited',
    'Sunstone advisors private limited',
    'BERI BUILTSPACE DESIGNS PRIVATE LIMITED',
    'Maliwal engineers and projects private limited',
    'K c mitra construction pvt ltd',
    'D r m r infra structure private limited',
    'Rose technocrats limited',
    'Hazra electrical services private limited',
    'CQRA PRIVATE LIMITED',
    'Today advertising private limited',
    'Ideas creative services private limited',
    'Confluence integrated services private limited',
    'Arham corporate solutions private limited',
    'Blessings hospitality services private limited',
    'White pixelz private limited',
    'Nass energy solutions private limited',
    'Shah and talati consultants private limited',
    'Strucon consulting private limited',
    'Sagar management services private limited',
    'GPC REGULATORY INDIA PRIVATE LIMITED',
    'Preeminent financial services private limited',
    'Vcc consultants private limited',
    'Monk consulting private limited',
    'Itag business solutions limited',
    'Emerald haven projects private limited',
    'Tvs staffing solutions private limited',
    'Mehar rubber foam private limited',
    'Suri overseas private limited',
    'D C GHOSE & CO (AGENTS) PVT LTD',
    'Mars associates private limited',
    'Tenacious services private limited',
    'G.k. winding wires limited',
    'Planners group private ltd',
    'Motorcraft automobiles private limited',
    'SIDDARTH AND GAUTAM ENGINEERS PRIVATE LIMITED',
    'Avr consultancy & projects private limited',
    'Pasari architects and consultants pvt ltd.',
    'Mate consultants pvt ltd',
    'Karan trading enterprises private limited',
    'Aditya properties private limited',
    'Indo link computers private ltd.',
    'Metcon technocrats private limited.',
    'Associated technocrats private ltd',
    'Intra ware housing and consult private limited',
    'Boutique international private limited',
    'ALASKA TECHNOVISION PRIVATE LIMITED (OPC)',
    'Saras advisory pvt ltd',
    'Indo design ventures private limited',
    'L and m consultants pvt ltd',
    'Amarsons overseas private limited',
    'Wadhwa endowment management private limited',
    'Jerambhai management services private limited',
    'VISTAS DESIGNERS PRIVATE LIMITED',
    'CHANDRA ENTREPRENEURS PRIVATE LIMITED',
    'Sasi advertising private limited',
    'Response india pvt ltd',
    'East west linkers pvt ltd',
    'Syntech informatics private limited',
    'Manashi construction and properties private limited',
    'APOLLO VOYAGES PRIVATE LIMITED',
    'Hindustan power products private limited',
    'Cornell overseas private limited',
    'J r m properties private limited',
    'Green land builders private limited',
    'Carlton overseas private limited',
    'Adhar credits private limited',
    'Dhingra polymers private limited',
    'Ajay impex private limited',
    'Sunvisors (india) private limited',
    'Mns advisory services limited',
    'Geoenpro petroleum limited',
    'Minda investments limited',
    'Finite energy limited',
    'Sai sahiba private limited',
    'Oxford cut private limited',
    'Apcolite polymers private limited',
    'Canny overseas private limited',
    'Jagat associates private limited',
    'Trans tours and travels international private limited',
    'Pars auto private limited',
    'Chadha sales private limited',
    'J j consultants private limited',
    'Woodland promoters private limited',
    'Jindal polytubes private limited',
    'GROWHIGH LEASING AND FINANCE PRIVATE LIMITED',
    'Ganapati polymers limited',
    'Praja securities limited',
    'Homemade bakers (india) limited',
    'Aneja constructions (india) limited',
    'Venus industries private limited',
    'Charls exports and securities private limited',
    'Vacation experts private limited',
    'Tryshoera(india) private limited',
    'Mns global finance private limited',
    'Comm-it india private limited',
    'Himalaya construction co.pvt.ltd.',
    'Preston engineering company delhi private limited',
    'Sentinels security private limited',
    'Wiegand india pvt ltd',
    'Avco traders private limited',
    'Ranoson springs private limited',
    'Tywel steel private limited',
    'R k clearing private limited',
    'Reynold india private limited',
    'Polo amusement park limited',
    'Vsd real estate management private limited',
    'Jaya hind montupet private limited',
    'Tata AutoComp Katcon Exhaust Systems Private Limited',
    'Energia systems private limited',
    'S k electrods private limited',
    'CIE ALUMINIUM CASTING INDIA LIMITED',
    'Cooper automotives limited',
    'Galaxy houseware products private limited',
    'Space wood furnishers private limited.',
    'Bharat battery mfg. co pvt ltd',
    'Free india dry accumulators ltd',
    'K. sambhav powertronics private limited',
    'Somnath industries private limited',
    'Trilinga safety glass pvt ltd',
    'Creative pelt pvt ltd',
    'APRANJE JEWELLERS PRIVATE LIMITED',
    'AU SMALL FINANCE BANK LIMITED',
    'Talisman jewels private limited',
    'Ethan power private limited',
    'Sunblaze appliances private limited',
    'Comfort creations private limited',
    'AIMTRON ELECTRONICS LIMITED',
    'Magpie elecchem pvt ltd',
    'Shivanshi electrical & electronics private limited',
    'RISHI KIRAN TERMINALS PRIVATE LIMITED',
    'KSL CLEANTECH LIMITED',
    'Ngbps limited',
    'Sarju valley hydel projects company private limited',
    'Eps green energy private limited',
    'TULSYAN POWER PRIVATE LIMITED',
    'Agrawal renewable energy private limited',
    'Eastern ramganga valley hydel projects company private limited',
    'Acme jaisalmer solar power private limited',
    'AMPLUS ENERGY SOLUTIONS PRIVATE LIMITED',
    'Pramatha power private limited',
    'Agrawal solar power ventures (rajasthan) private limited',
    'Jai ambey power systems private limited',
    'KESSLEC SMART LIGHTING TECHNOLOGIES PRIVATE LIMITED',
    'Jaycee auto components private limited',
    'EDEN MUMBAI SOLAR PRIVATE LIMITED',
    'Niranjana solar energy private limited',
    'Dayanidhi solar power private limited',
    'Vishwatma solar energy private limited',
    'KARUNA SOLAR CLEAN TECH PRIVATE LIMITED',
    'P & R GURDITTIWALA HYDRO POWER PRIVATE LIMITED',
    'EDEN SOLAR ENERGY GURGAON PRIVATE LIMITED',
    'Acme odisha solar power private limited',
    'Wonder tech wind power private limited',
    'EMC GREENCO. LIMITED',
    'Unitech industries limited',
    'Atlas cycles (malanpur) limited',
    'Atlas cycles (sahibabad) limited',
    'Wave energy and power distribution private limited',
    'Rajendra oil mills pvt ltd',
    'Acme jodhpur solar power private limited',
    'Acme solar energy (madhya pradesh) private limited',
    'EDEN SOLAR RAJDHANI PRIVATE LIMITED',
    'Tirupati space solutions private limited',
    'Bluebell ergonomics private limited',
    'Cromelite industries (india) pvt ltd',
    'Wecare products private limited',
    'R k jewellers private limited',
    'India jewellers ltd',
    'Masoom playmates private limited',
    'Paras pen pvt ltd',
    'Centpro engineering private limited',
    'Rjv constructions private limited',
    'Golden peace infrastructure private limited',
    'ALTRET CHEMICALS PRIVATE LIMITED',
    'Marvel buildwell private limited',
    'Shivtec builders private limited',
    'Mashiv shakti constructions private limited',
    'Neeladhri realtors private limited',
    'J.d.m gears & engineers(p) limited',
    'Elkos pens limited',
    'Stem cells care (india) private limited',
    'Megh meditech private limited',
    'Grindlays engine parts private limited',
    'Baroda developers private limited',
    'Pioneer infrastructures company private limited',
    'Jagdamba infrastructure private limited',
    'Fire arcor infrastructure private limited',
    'Arwade infrastructure limited',
    'Cipro estates private limited',
    'Thipparthi constructions and housing private limited',
    'Rraam shhyam infraventures private limited',
    'Jak promoters private limited',
    'Keshari nandan projects private limited',
    'Unicast autotech private limited',
    'Dawn motors private limited',
    'Progressive constructions private limited',
    'Sankush builders (p) ltd',
    'Delco infrastructure projects limited',
    'B.r. apartments private limited',
    'Standardgold constructions pvt ltd',
    'Wave solar systems private limited',
    'Unitech developers and hotels private limited',
    'CONFIDENCE ADVERTISEMENT PRIVATE LIMITED',
    'S k translines private limited',
    'Logwin air & ocean india private limited',
    'Fifth avenue hotels & resorts private limited',
    '9090MEDICALS PRIVATE LIMITED',
    'Clarewhite foods private limited',
    'Gaura logistics private limited',
    'Sai dutta clearing agency private limited',
    'Quark logistics private limited',
    'SANSHAWN FREIGHT SYSTEMS (INDIA) PRIVATE LIMITED',
    'Akshay cargo movers private limited',
    'V r infralogistics private limited',
    'Shivshakti cargomovers private limited',
    'Yuno packaging private limited',
    'Ma om parivahan private limited',
    'Cosmo carrying pvt ltd',
    'Pawan cargo forwards private limited',
    'Contrans shipping private limited',
    'Passage cargo private limited',
    'Alba asia private limited',
    'Kyc cargo services pvt ltd',
    'RAVI CHAND BOTHRA SONS PRIVATE LIMITED',
    'Olc shipping line private limited',
    'Dynamic air and sea cargo private limited',
    'LIONHEART CONSTRUCTIONS PRIVATE LIMITED',
    'Om telecom logistics private limited',
    'Satguru shipping and transport logistics private limited',
    'Ncs storage systems private limited',
    'Mangalmay express private limited',
    'Siesta logistics corporation limited',
    'Netsys network private limited',
    'Amisoft technologies private limited',
    'Techferry infotech private limited',
    'S2quare infotech private limited',
    'Ample designing and development solutions private limited',
    'Anvayin systems private limited',
    'Effitrac solutions india private limited',
    'Indix internet india private limited',
    'Tulyasys technologies private limited',
    'Wi-bro solutions private limited',
    'Kutir technologies private limited',
    'Coelho systems private limited',
    'Entersoft it solutions labs private limited',
    'Smart ict services private limited',
    'Add pearlinfo private limited',
    'Webplanex infotech private limited',
    'Logicladder technologies private limited',
    'Cenit technologies (india) private limited',
    'Ducere technologies private limited',
    'Dataformix enterprise solutions private limited',
    'Naia software solutions india private limited',
    'Reachwell software services private limited',
    'Renaissance technologies private limited',
    'Think media private limited',
    'Otto hofstetter india private limited',
    'Animika studios private limited',
    'DEVASTHALI INFOTECH PRIVATE LIMITED',
    'ADVENT GLOBAL SOLUTIONS Private Limited',
    'Abjayon technologies private limited',
    'India hq solutions private limited',
    'Saraswati accountants software private limited',
    'VCARVE TECHNOLOGIES PRIVATE LIMITED',
    'Mab elv systems private limited',
    'Zumi solutions private limited',
    'Itiha retail private limited',
    'Soft scribe private limited',
    'Aa software & networking private limited',
    'Vishwa technologies private limited',
    'Data world information systems private limited',
    'Syscon infotech private limited',
    'Divyam computech private limited',
    'Novatech software private limited',
    'Foresight information technology private limited',
    'Allied solutions (india) private limited',
    'ALPHA PLUS CONSULTING AND RESEARCH CENTRE PRIVATE LIMITED',
    'Nexus system private limited',
    'K and z infotech private limited',
    'Techprotean solutions private limited',
    'C2l biz solutions private limited',
    'Riit infotech private limited',
    'E-whiz solutions private limited',
    'Agate business services private limited',
    'Techmatrix infotech private limited',
    'Zeki software solutions private limited',
    'Secure e-solutions private limited',
    'Unified learning platforms private limited',
    'Kavita software private limited',
    'CDM TECHNOLOGIES & SOLUTIONS PRIVATE LIMITED',
    'Magnus edesign systems private limited',
    'Kerala communicators cable limited.',
    'Timesol facility management private limited',
    'Ascon moneyraksha private limited',
    'Xpasoft technologies private limited',
    'Halliburton technology india private limited',
    'SCYSOFT SYSTEMS PRIVATE LIMITED',
    'Ravish technology private limited',
    'Virtual simutech private limited',
    'Perscitus solutions private limited',
    'Sysweave technocraft private limited',
    'Doshaheen solutions private limited',
    'Wonderworks technologies private limited',
    'Balaji biometric identification technologies private limited',
    'YAGI TECHNOLOGY LABS PRIVATE LIMITED',
    'Technomile software solutions private limited',
    'Vigyanix technologies private limited',
    'Easy solution infosystems private limited',
    'Begapt infotech private limited',
    'VERACITY SYSTEMS SURVEILLANCE PRIVATE LIMITED',
    'Korcomptenz consultancy private limited',
    'Aisomex consultancy services private limited',
    'Holbiz private limited',
    'Tree line business solutions private limited',
    'Pranion technology ventures private limited',
    'Postlor interactive india private limited',
    'Vuram technology solutions private limited',
    'Eventus software services private limited',
    'Robosys automation and robotics private limited',
    'Live bridge private limited',
    'Watchy technology private limited',
    'Grootstech solutions private limited',
    'Pepper designs private limited',
    'Systhink technologies private limited',
    'Engee datasoft pvt. ltd.',
    'Viratech software & communications limited',
    'Twopiradian infotech private limited',
    'Cax software private limited',
    'ZIVTRIX CORPORATE SERVICES PRIVATE LIMITED',
    'Wrig nanosystems private limited',
    'Myko tech private limited',
    'Jrf research private limited',
    'Thakshashila r&d private limited',
    'ZENTECH INDIA OFFSHORE AND MARINE ENGINEERING PRIVATE LIMITED',
    'Lead mantra it solutions private limited',
    'Icruxsystem private limited',
    'Xrevol technologies private limited',
    'Bicnet infoservices private limited',
    'Easy med services private limited',
    'Maple communications private limited',
    'Ela green buildings and infrastructure consultants private limited',
    'Hom records and tapes private limited',
    'Delta me engineering services private limited',
    'Kala vikas pictures pvt ltd',
    'Rhombus media and animations private limited',
    'Indo - asian news channel private limited',
    'S.s.i media india private limited',
    'Mm tv limited',
    'Gr8 entertainment limited',
    'Aheadzen media private limited',
    'Agos aviation pvt ltd',
    'Kaviraj capital management private limited',
    'Astro blessings international private limited',
    'Aarsree apartments private limited',
    'Vigil security bureau private limited',
    'FLYLINK',
    'S PRECAST CONCRETE PRIVATE LIMITED',
    'HELEA TECHNOLOGY PRIVATE LIMITED',
    'SPICECITI FOOD NETWORK PRIVATE LIMITED',
    'EKATA EARTH PRIVATE LIMITED',
    'RISEMATICS INDUSTRIES (OPC) PRIVATE LIMITED',
    'EVIGO CHARGE PRIVATE LIMITED',
    'VIZAMICS DIGITAL INDIA PRIVATE LIMITED',
    'BIZLYZER INDIA PRIVATE LIMITED',
    'KEA CASTLE TECHNOLOGIES PRIVATE LIMITED',
    'RAJYOG STONES PRIVATE LIMITED',
    'GINKAD TECH ART PRIVATE LIMITED',
    'KEN LIFESTYLES PRIVATE LIMITED',
    'PHPL OPTOELECTRONICS PRIVATE LIMITED',
    'NOTCHUP TOOLING PRIVATE LIMITED',
    'UNISHARP PRECISION PRIVATE LIMITED',
    'DIGIROBE AUGMENTS PRIVATE LIMITED',
    'ADVARGO PROPERTIES PRIVATE LIMITED',
    'PRISTINENOTE PRIVATE LIMITED',
    'DMS CONMIX (INDIA) PRIVATE LIMITED',
    'DUSKYAPPY MEDIA PRIVATE LIMITED',
    'SAFESONA PRIVATE LIMITED',
    'VYAKTA CONSULTING SERVICES PRIVATE LIMITED',
    'AUTORELLI CARS PRIVATE LIMITED',
    'VKAPS IT SOLUTIONS PRIVATE LIMITED',
    'TENGIO SOFTWARE CONSULTANCY PRIVATE LIMITED',
    'NOVANYAM CORPORATE SERVICES PRIVATE LIMITED',
    'HAND ERP SOLUTIONS (INDIA) PRIVATE LIMITED',
    'SAINFOIN GLOBAL SERVICES PRIVATE LIMITED',
    'SIGNITIVE TOWERS PRIVATE LIMITED',
    'EARTHY TALES ORGANICS PRIVATE LIMITED',
    'NXTWATER PRIVATE LIMITED',
    'YUTIKA NATURAL PRIVATE LIMITED',
    'DRILLING RESOURCES INDIA PRIVATE LIMITED',
    'ASNC GEAR PRIVATE LIMITED',
    'URBAN RETAIL PRIVATE LIMITED',
    'HSF INTERNATIONAL TRADING PRIVATE LIMITED',
    'INKASSIE DIGITAL EDUCATION PRIVATE LIMITED',
    'ABCUBE INDUSTRIES PRIVATE LIMITED',
    'DESKFROG COMMUNICATIONS PRIVATE LIMITED',
    'ZOMATO ENTERTAINMENT PRIVATE LIMITED',
    'NAGRIK STORES PRIVATE LIMITED',
    'FYNALLIANCE ADVISORS PRIVATE LIMITED',
    'SUNDARAVIJAYAM AUTOMOBILE SERVICES PRIVATE LIMITED',
    'DRUZINA KRUMPAK INDIA PRIVATE LIMITED',
    'RESERVEFREE PRIVATE LIMITED',
    'SYSCOM VENTURES PRIVATE LIMITED',
    'Pvr industries limited',
    'Singan projects limited',
    'Pyramid shelters private limited',
    'Swift homes private limited',
    'Goyal and Co.(Const.) Private Limited',
    'HN SAFAL GOYAL INFRA REALTY PRIVATE LIMITED',
    'CORNERSTONE BAY CITY DEVELOPMENTS PRIVATE LIMITED',
    'Hi-line developers and projects private limited',
    'Team distributors private limited',
    'Toscano infracon private limited',
    'APEX INFRA & REALTY INDIA PRIVATE LIMITED',
    'Sree subhiksha housing and enterprises p ltd',
    'Megaview tvisha construction private limited',
    'Kargwal developers private limited',
    'Generation evershine star castles private limited',
    'SHREE YASHOLAXMI CONSTRUCTIONS PRIVATE LIMITED',
    'Vizag seaport private limited',
    'Green noida infratech private limited',
    'Aesthetic arc infratech private limited',
    'Marigold constructions private limited',
    'Toscano infrastructure private limited',
    'Kargwal constructions private limited',
    'Maxworth infra projects private limited',
    'Proz constructions private limited',
    'Asta infra projects private limited',
    'Watenva solution private limited',
    'Thandon infrastructure private limited',
    'Milestone dwellers private limited',
    'Megaview nest company private limited',
    'Megaview manshila private limited',
    'SVJ INOVABUILD PRIVATE LIMITED',
    'Runwal residency private limited',
    'Horizon projects private limited',
    'Wisteria buildcon private limited',
    'Aakaash dhanista infrastructure private limited',
    'Saishakti infrastructure pvt ltd',
    'C p r constructions private limited',
    'Navin buildcon private limited',
    'Vistar properties private limited',
    'Dee jay promoters private limited',
    'Shwas homes private limited',
    'Concept homes india private limited',
    'Ambuja realty development limited',
    'Tipl infra private limited',
    'Sanaya realties private limited',
    'Chourangi infrastructure private limited',
    'Tridhaatu realty and infra private limited',
    'Institution builders hr solutions private limited',
    'Shivmalhar technologies private limited',
    'Gajalakshmi it park developers limited',
    'Strong walls realty limited',
    'Mpil steel structures limited',
    'Vee go infra private limited',
    'Juniper constructions private limited',
    'Stride infracon private limited',
    'Ict infrastructure private limited',
    'Maharashtra eco-green private limited',
    'Tridhaatu constructions private limited',
    'Team universal infratech private limited',
    'Eagle autoking private limited',
    'Tusker pam private limited',
    'Peraj insurance brokers private limited',
    'Dolphin bikes private limited',
    'Pramukh automobiles private limited',
    'Eagle autopearl private limited',
    'Pramukh automotive private limited',
    'Himavasini motors private limited',
    'Shako flexi pack pvt ltd',
    'Ingredion india private limited',
    'Hallmark logistics private limited',
    'Darshan diatech private limited',
    'Translink commercial agencies private limited',
    'Arya collateral warehousing services private limited',
    'Inter commerce india pvt ltd',
    'Interfer - steel and commodities private limited',
    'Sovereign nutriment private limited',
    'Raghuvir vanijya pvt ltd',
    'Panachwati greenfield realty development private limited',
    'Daylight distributors private limited',
    'Nitya modular private limited',
    'Sani audiotek marketing private limited',
    'Luxurience brand promotions india private limited',
    'Bodyline impex private limited',
    'BK & K CHEMICALS PRIVATE LIMITED',
    'Tirumala overseas private limited',
    'Unified data- tech solutions private limited',
    'Wct container trading private limited',
    'Tescar equipments private limited',
    'VALENCIA NUTRITION LIMITED',
    'Kludirak india private limited',
    'Multisorb technologies india private limited',
    'Beekeyen freight services private limited',
    'Memphis vision care private limited',
    'Hodek innovations private limited',
    'Fatak retail limited',
    'Shopdunia sales private limited',
    'RAYVISION TECH PRIVATE LIMITED',
    'Mack soft tech private limited',
    'Prolific retail solutions private limited',
    'Brewsky hospitality private limited',
    'Shivraj hotels and resorts private limited',
    'Lotus pond hotel private limited.',
    'Murud holiday resorts private limited',
    'Pms hospitality private limited',
    'Quinn lodgings india private limited',
    'Liberty hotels private limited',
    'Shalimar residency private limited',
    'Elite service apartments private limited',
    'Clean-n-clear hospitality services private limited',
    'EATCLUB BRANDS PRIVATE LIMITED',
    'Vakratunda leisure resorts private limited',
    'Liftshift transport company (bombay) pvt ltd',
    'Coral freight systems private limited',
    'Liquified gas transport (bombay) private limited',
    'Arya offshore services private limited',
    'Avanti shipping enterprises pvt ltd',
    'Diverse destination travel private limited',
    'Hubner interface systems (india) private limited',
    'Macro logistics & exim private limited',
    'Christ logistics private limited',
    'Privia logistics private limited',
    'Transorion logistics india private limited',
    'Professional ship management private limited',
    'Memorable vacations & holidays private limited',
    'B v c tours and travels private limited',
    'Ics mobile private limited',
    'Utegration india private limited',
    'Telestratum networks private limited',
    'Tetherfi technologies private limited',
    'Arrowhead professional services private limited',
    'Designstring solutions private limited',
    'UTV SOFTWARE COMMUNICATIONS PRIVATE LIMITED',
    'Rsm communications private limited',
    'Chenoa information and software services private limited',
    'OSOURCE GLOBAL PRIVATE LIMITED',
    'Eclinicalworks india private limited',
    'Exodus information technology private limited',
    'Powershell technologies private limited',
    'Info dynamic software systems private limited',
    'Synechron technologies private limited',
    'Kleverklik technologies private limited',
    'Giftease technologies private limited',
    'Koonk technologies private limited',
    'AMD INDIA PRIVATE LIMITED',
    'Ebiz technix.com private limited',
    'Info raise technologies private limited',
    'Camp systems private limited',
    'Meera fibretek private limited',
    'Signy technologies private limited',
    'Winwire technologies india private limited',
    'Pixacore multimedia private limited',
    'SRUSHTI CREATIVE STUDIO PRIVATE LIMITED',
    'Esmob technologies private limited',
    'Pinnacle technosolutions private limited',
    'Process point technologies india private limited',
    'Parnandi technology solutions private limited',
    'Spritle software private limited',
    'Vidusys infosystem private limited',
    'Adweb technologies private limited',
    'Dsm shared services india private limited',
    'Hih7 webtech private limited',
    'Nexsus business solutions private limited',
    'Concevoir web services private limited',
    'Nlytn learning systems private limited',
    'Playpower labs private limited',
    'Sabre travel technologies private limited',
    'Ide-pro engineering asia private limited',
    'Liferay india private limited',
    'Techverve solutions private limited',
    'Rinkush it solutions private limited',
    'Scan infotech private limited',
    'Udhyam technologies private limited',
    '3i infotech consultancy services limited',
    'Roosh interactive private limited',
    'Rib itwo software private limited',
    'Tk interactive private limited',
    'DE-CIX INTERWIRE INTERNET SERVICES PRIVATE LIMITED',
    'One web werks datacenter private limited',
    'Blissful infotech solutions private limited',
    'Hostpaedia technologies private limited',
    'Indiasoft technologies private limited',
    'Nityaobject software services private limited',
    'AMERI100 CONSULTING PRIVATE LIMITED',
    'Intellify solutions private limited',
    'Zimbra technology india private limited',
    'THINKSCRIPT TECHNOLOGIES PRIVATE LIMITED',
    'Questionpro private limited',
    'Lan expert it services private limited',
    'Siri it innovations private limited',
    'Avakai games private limited',
    'Cml media softwares private limited',
    'Ntt data fa insurance systems (india) private limited',
    'Vizag international private limited',
    'Marinating films private limited',
    'True quality certifications private limited',
    'National securities depository limited',
    'Deming certification services private limited',
    'Rnm moving pictures private limited',
    'Eclean spectron environment private limited',
    'Financial agency consultants india private limited',
    'Advaita wellness private limited',
    'Pantomath capital advisors private limited',
    'SATVERA INDIA PRIVATE LIMITED',
    'Brand planet consultants india private limited',
    'Idaac solutions private limited',
    'Leaflet technologies private limited',
    'Sai consulting engineers private limited',
    'SCOPE T&M PRIVATE LIMITED',
    'Maraekat infotech limited',
    'Reliance corporate it park limited',
    'Western union services india private limited',
    'Hannover re consulting services india private limited',
    'Universal business solutions private limited',
    'Indusminds consulting service private limited',
    'Spass consultants private limited',
    'Shashi sumeet productions private limited',
    'New motion multimedia private limited',
    'Ogilvy and mather private limited',
    'Santram engineers pvt ltd',
    'Gp offset private limited',
    'Shashi sumeet motion pictures private limited',
    'DR. YAJNIK',
    'KERAMICS INDIA PRIVATE LIMITED',
    'Perivinc pharmaceuticals private limited',
    'Omniactive health technologies limited',
    'Orient fabrics pvt ltd',
    'Greentech laboratories private limited',
    'Asle technologies private limited',
    'Big labs private limited',
    'Labguard india private limited',
    'Assurica life sciences private limited',
    'Asia match company private limited',
    'Naveen gaskets private limited',
    'SETHI & SETHI COMFORT PRODUCTS PRIVATE LIMITED',
    'GLUTAPE INDIA PRIVATE LIMITED',
    'Anantha polyproducts private limited',
    'Shyama packart private limited',
    'Hare krishna packaging private limited',
    'Essentra (india) private limited',
    'VEERAL ADDITIVES PRIVATE LIMITED',
    'Ralco steels private limited',
    'Bhagwati ferro metal private limited',
    'H s m steels private limited',
    'Maika metals private limited',
    'Bhagwati steel cast private limited',
    'JAGDISH ALUMINIUM PRIVATE LIMITED',
    'Kapil metal processing industries private limited',
    'Grupo wisco india private limited',
    'Jeevanlakshmi packaging solutions private limited',
    'Vaishnavi hydraulics private limited',
    'Netmech engineering private limited',
    'Pioneer extruders private limited',
    'Technocrats security systems private limited',
    'Laser solution india private limited',
    'Heavy metal engineering private limited',
    'Armstrong machine builders private limited',
    'Kulkarni transpower private limited',
    'Case new holland construction equipment (india) private limited',
    'B.d. industries (india) private limited',
    'S. v. m. wrappings private limited',
    'Paras engineering works (mumbai) private limited',
    'Srk processes and controls private limited',
    'Starurja equipments private limited',
    'Surfin coating systems private limited',
    'Dia friction private limited',
    'Kalyani mould base private limited',
    'Ark machtek private limited',
    'Diligence envirotech private limited',
    'Prism cybersoft private limited',
    'Dreams bio-tech private limited',
    'Brother international (india) private limited',
    'PILLER POWER INDIA PRIVATE LIMITED',
    'Oman transformers india private limited',
    'Quadralumen private limited',
    'Jef techno solutions private limited',
    'L3HARRIS MARITIME & AERO PRIVATE LIMITED',
    'Power stores e-commerce private limited',
    'Sabo hema automotive private limited',
    'ADVIK AUTO PRIVATE LIMITED',
    'Ds connectors and cables india private limited',
    'HMM SHIPPING INDIA PRIVATE LIMITED',
    'Ross controls india private limited',
    'Tic retail accessories india private limited',
    'Tangramme furnishing solutions private limited',
    'Aim solder (india) private limited',
    'We alliance packaging india private limited',
    'Standard pencils private limited',
    'Chilliez modular designers private limited',
    'Super hydro electric private limited',
    'Ghrian renewables private limited',
    'Npcc engineering private limited',
    'Pr clean energy private limited',
    'RAJU BUSINESS ADVISORS PRIVATE LIMITED',
    'RAAJHANS SOLAR PRIVATE LIMITED',
    'HINDUJA RENEWABLES ENERGY PRIVATE LIMITED',
    'Pr vayu energy private limited',
    'PR CLIMATE STUDIO PRIVATE LIMITED',
    'Fenix systems and projects private limited',
    'TAKSHASHILA PROJECTS PRIVATE LIMITED',
    'Omdaya builders and developers private limited',
    'Greenscape developers private limited',
    'Gulf automation technologies private limited',
    'Baryons software solutions private limited',
    'App systems (india) private limited',
    'GLOW NETWORKS PRIVATE LIMITED',
    'Li2-technologies private limited',
    'Blueprint technologies private limited',
    'Ihcs technologies india private limited',
    'Nutanix technologies india private limited',
    'IKYAM SOLUTIONS PRIVATE LIMITED',
    'Bidgely technologies private limited',
    'Valuecom infosolutions private limited',
    'Dots info systems (india) private limited',
    'Axiom solutions private limited',
    'Mol information technology india private limited',
    'Bombayworks software solutions private limited',
    'Pineapple technologies private limited',
    'E-bizindia private limited',
    'Hyperion systems engineering (india) private limited',
    'Paexskin solutions private limited',
    'Gaps technologies private limited',
    'Wissen infotech private limited',
    'Kavayah it solutions private limited',
    'Ineda systems private limited',
    'Talent enterprises private limited',
    'Cloudio india private limited',
    'Broadgate technical services (india) private limited',
    'Bened software private limited',
    'Daemon software and services private limited',
    'Labvantage solutions private limited',
    'Appsquare technologies private limited',
    'Cae simulation technologies private limited',
    'Voto technologies private limited',
    'Bloomberg data services (india) private limited',
    'L a boot camps private limited',
    'DROID136 ROBOTICS & INTELLIGENT AUTOMATION PRIVATE LIMITED',
    'CLOUDSTRATS INFRASTRUCTURE PRIVATE LIMITED',
    'Cloudstrats technologies private limited',
    'APPSTEK SOLUTIONS PRIVATE LIMITED',
    'STG LABS INDIA PRIVATE LIMITED',
    'Biztime it solutions private limited',
    'Wenzins technologies (india) private limited',
    'Powersoft it private limited',
    'Webklipper technologies private limited',
    'L a technologies private limited',
    'Syx services private limited',
    'Mindstix software labs private limited',
    'Signifikant infotech private limited',
    'Syntel solutions (india) private limited',
    'Ecs infosolutions private limited',
    'Excal technologies private limited',
    'Enlightened it developers private limited',
    'Bcforward india technologies private limited',
    'Fix flyer information technologies private limited',
    'Sysintelli software and services private limited',
    'Brassy technologies private limited',
    'Nomura research institute financial technologies india private limited',
    'Mundra corporate services private limited',
    'Infor (india) private limited',
    'Promatic solutions (india) private limited',
    'Arrowhead global logistics india private limited',
    'S (VARANASI) LIMITED.',
    'HOTEL JAWAHAR INTERNATIONAL PVT LTD',
    'R.L. HOTELS & HOSPITALITY PRIVATE LIMITED',
    'MANGALAM HOSPITALITY INDIA PRIVATE LIMITED',
    'SKYLINE INDIA TRAVELS PRIVATE LIMITED',
    'TRI TOURS PRIVATE LIMITED',
    'PRIMEVALUE TOURS PRIVATE LIMITED',
    'RECREATION HOLIDAYS PRIVATE LIMITED',
    'ANURAG DESTINATION & EVENT MANAGEMENT PRIVATE LIMITED',
    'INN TRAVELETHICS PRIVATE LIMITED',
    'HATHWAY ICE TELEVISION PRIVATE LIMITED',
    'IKON BROADBAND PRIVATE LIMITED',
    'UTKARSH COREINVEST LIMITED',
    'CASHPOR MICRO CREDIT',
    'SUNSHINE FINMART PRIVATE LIMITED',
    'STRAIGHTACE MUTUAL BENIFITS NIDHI LIMITED',
    'CASHPOR FINANCIAL AND TECHNICAL SERVICES Private LIMITED',
    'VATIKA INVESTMENT AND FINANCE PRIVATE LIMITED',
    'RAISON FINANCIAL SOLUTIONS PRIVATE LIMITED',
    'CHITRAGUPTA REALTY LIMITED',
    'AMOLSHAKTI INFRA DEVELOPERS PRIVATE LIMITED',
    'MANGAL ESTATE WEALTH PRIVATE LIMITED',
    'KAP INFRATECH SOLUTION PRIVATE LIMITED',
    'PMG COMMERCE EDGE LIMITED',
    'ASG INFRAPROJECTS PRIVATE LIMITED',
    'GOENKA AUTOSALES PRIVATE LIMITED',
    'J M D Infraheight Private Limited',
    'OZONE INFRASERVICES PRIVATE LIMITED',
    'MANTRA PROPERTIES AND DEVELOPERS PRIVATE LIMITED',
    'MAGICAL INFRAESTATE PRIVATE LIMITED',
    'GYAN VISHNU DEVELOPERS PRIVATE LIMITED',
    'S S SOFTWARE AND CONSULTANCIES PRIVATE LIMITED',
    'YOUNG TECH SOFTWARE PRIVATE LIMITED',
    'ZED SOFTWARE PRIVATE LIMITED',
    'SWASTIK NILAYAM PRIVATE LIMITED',
    'VARANASI INNOVATIVE SW AND HW COMPANY PRIVATE LIMITED',
    'NIRMAN INFORMATION TECHNOLOGY RENOVATION PRIVATE LIMITED',
    'AP ITECHNOSOFT SYSTEMS PRIVATE LIMITED',
    'XTREMELOGIC SOLUTIONS PRIVATE LIMITED',
    'Naffa innovations private limited',
    'IPJacket Technology India Private Limited',
    'RED BROOK INTER TRADE PRIVATE LIMITED',
    'NEOIST TECHNO SOFT PRIVATE LIMITED',
    'I P VIJAYA MULTIPLEX PRIVATE LIMITED',
    'LOKO SPARES AGENCIES PRIVATE LIMITED',
    'TRS VENTURE EDUCATION PRIVATE LIMITED',
    'SHREE BALAJI PROPERTIES PRIVATE LIMITED',
    'DALIMSS SUNBEAM EDUCOMP LIMITED',
    'AVANTIKA MOTORS PRIVATE LIMITED',
    'SURYA INDIA PALACE PRIVATE LIMITED',
    'INDUS VACATIONS PRIVATE LIMITED',
    'COMPUTER SHOPPE PRIVATE LIMITED',
    'SRN AGRO PRIVATE LIMITED',
    'SHRESTH PACKWELL PRIVATE LIMITED',
    'RAJENDRA TRUCKING PRIVATE LIMITED',
    'VARANASI LOOM TO LUXURY PRIVATE LIMITED',
    'SYCNOSIS INDIA LIMITED',
    'AIMCAD BIOTECH PRIVATE LIMITED',
    'KCGS ENTERPRISES PRIVATE LIMITED',
    'SURYANSH LOGISTICS PRIVATE LIMITED',
    'BANARAS CULTURAL FOUNDATION',
    'SOFTWAY INFOCARE PRIVATE LIMITED (OPC)',
    'CITIGUIDE MULTISERVICES PRIVATE LIMITED',
    'GROWTH POINT CONSULTING PRIVATE LIMITED',
    'MEGHA HOLDINGS PRIVATE LTD.',
    'G.S.R. MOTORS PRIVATE LIMITED',
    'PRAYAG CLAY PRODUCTS LIMITED',
    'RKD ENTERPRISES PRIVATE LIMITED',
    'TITICO ENTERTAINMENTS PRIVATE LIMITED',
    'UTKARSH WELFARE FOUNDATION',
    'KANODIA INFRATECH LIMITED',
    'UDAY AUTOSALES PRIVATE LIMITED',
    'RANGOLI IT SOLUTIONS PRIVATE LIMITED',
    'RAISON CONSULTANCY SERVICES PRIVATE LIMITED',
    'IVY Software Development Services Private Limited',
    'SMART CLOUD COMPUTING PRIVATE LIMITED',
    'CONFORMIQ SOFTWARE INDIA PRIVATE LIMITED',
    'E-ICON ONLINE SERVICES PRIVATE LIMITED',
    'Helius Computech India Private Limited',
    'HIRE IT PEOPLE PRIVATE LIMITED',
    'SKILLEXPRESS LEARNING SOLUTIONS PRIVATE LIMITED',
    'QUALLENT TECHNOLOGIES PRIVATE LIMITED',
    'YK INNOSOFT TECHNOLOGIES PRIVATE LIMITED',
    'Pratyaya E-Commerce Private Limited',
    'STARK PHARMA PRIVATE LIMITED',
    'K-SOURCE PRIVATE LIMITED',
    'ATOM NETWORKS PRIVATE LIMITED',
    'GlobalSign.In (India) Private Limited',
    'ARMOUR INFOCOM PRIVATE LIMITED',
    'GAME BEANS PRIVATE LIMITED',
    'DINOOSYS TECHNOLOGIES PRIVATE LIMITED',
    'CREST VISUALS PRIVATE LIMITED',
    'AurumInfo Digital Solutions Private Limited',
    'PARADIGM IT TECHNOLOGIES PRIVATE LIMITED',
    'EVAM TECH LABS PRIVATE LIMITED',
    'Controture e-Commerce Private Limited',
    'Rachamalla Intelligence Technologies Research & Development Labs Private Limited',
    'KARVY INSIGHTS LIMITED',
    'LA GLOBAL EDU CONSULTANTS PRIVATE LIMITED (OPC)',
    'Protheon IT Solutions Private Limited',
    'ADBHUT NATURE',
    'S HOLDINGS PRIVATE LIMITED',
    'PHOTON ROOFTOPS PRIVATE LIMITED',
    'SCH COATING SOLUTIONS PRIVATE LIMITED',
    'RESEARCH WALLET SERVICES PRIVATE LIMITED',
    'SATRA EQUITIES PRIVATE LIMITED',
    'McLanahan India Private Limited',
    'Indian Financial Technology and Allied Services',
    'Y-AXIS FOUNDATION',
    'GO CLEAN FOUNDATION',
    'VR4 MARKETING INDIA PRIVATE LIMITED (OPC)',
    'PANOS MANAGEMENT SERVICES PRIVATE LIMITED (OPC)',
    'GREENKO SOLAR POWER (MEDAK) LIMITED',
    'Karvy Analytics Limited',
    'CallHealth Online Services Private Limited',
    'INNOVIN IT SOLUTIONS PRIVATE LIMITED',
    'QUA GAMIFICATION PRIVATE LIMITED',
    'Lore Corporate Advisory Private Limited',
    'BRG Workplace Management Solutions (India) Private Limited',
    'SAV I SAATHI BPO PRIVATE LIMITED',
    'TIGER TALES ENTERTAINMENT PRIVATE LIMITED',
    'ALAW PRODUCTS PRIVATE LIMITED',
    'TRANS GLOBAL FIN SERVICES PRIVATE LIMITED',
    'VIVA INTERIORS PRIVATE LIMITED',
    'HiR CORP SOLUTIONS PRIVATE LIMITED',
    'MAVEN TECHSOL GLOBAL PRIVATE LIMITED',
    'HealthMine Techsource Private Limited',
    '9ACTS CLOUD SOLUTIONS PRIVATE LIMITED',
    'Integrated Cooltech private limited',
    'TRAIGUNA SOLUTIONS PRIVATE LIMITED',
    'TVS TOYOTA TSUSHO SUPPLY CHAIN SOLUTIONS LIMITED',
    'VGN INTELLECTUAL PROPERTY SERVICES PRIVATE LIMITED',
    'Imprimatur Printing Services Private Limited',
    'AIROMECH SYSTEMS PRIVATE LIMITED',
    'EASE STAY PRIVATE LIMITED',
    'MECELP PROJECTS PRIVATE LIMITED',
    'CHAKRATH CAREER CONSULTANTS PRIVATE LIMITED',
    'Indian Solar Association',
    'SANS CFS LIMITED',
    'TAMILNADU POLYMER INDUSTRIES PARK LIMITED',
    'RITEPICK HR SOLUTIONS PRIVATE LIMITED',
    'CLARUS RCM INFOTECH (INDIA) PRIVATE LIMITED',
    'Mizpah Gateway Abroad Private Limited',
    'PRG SHIPPING PRIVATE LIMITED',
    'Skandasashti Holdings Private Limited',
    'GritToWin Knowledge Services Private Limited',
    'ENJAY TECHNOLOGIES PRIVATE LIMITED',
    'MAXX HOSPITALITIES & CATERING SERVICES PRIVATE LIMITED',
    'RECAP VENTURES PRIVATE LIMITED',
    'GSH FACILITIES MANAGEMENT SERVICES PRIVATE LIMITED',
    'RL API PRIVATE LIMITED',
    'Ilaiyaraaja Music n Management Private Limited',
    'Galaxy Global Eye Private Limited',
    'Frontier Champion Enterprises Private Limited',
    'MIST VFX STUDIO PRIVATE LIMITED',
    'RAD PROCESS SYSTEMS PRIVATE LIMITED',
    'ARCH9 EDUCATION PRIVATE LIMITED',
    'HSM MARINE SERVICES PRIVATE LIMITED',
    'TAMILNADU SUSTAINABLE INDUSTRIAL WATER CORPORATION LIMITED',
    'GOTHI SURANA EDUCATIONAL INSTITUTE PRIVATE LIMITED',
    'ACADEMY FOR GERMAN BUSINESS MANAGEMENT PRIVATE LIMITED',
    'ONSPEC TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'KINGS LEARNING SOUTH PRIVATE LIMITED',
    'KCL INNOVATIONS PRIVATE LIMITED',
    'BLINK FOUNDATION',
    'CENTRE FOR TECHNOLOGY ASSISSTED RECONSTRUTIVE SURGERY PRIVATE LIMITED',
    'Shriram Seva Sankalp Foundation',
    'iData India Medical Documentation Private Limited',
    'WESTMINSTER HEALTHCARE PRIVATE LIMITED',
    'KALAIGNAR TV PRIVATE LIMITED',
    'TROPICAL TRENDS PRIVATE LIMITED.',
    'CAPITAL FILM WORKS (INDIA) PRIVATE LIMITED',
    '360 DEGREE STUDIOS PRIVATE LIMITED',
    'TRUE FRIEND MANAGEMENT SUPPORT SERVICE PRIVATE LIMITED',
    'NAVODAYA FILMS PRIVATE LIMITED',
    'TAP BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ONE MIND GENERATION RESEARCH FOUNDATION',
    'PURPLEPOND FINANCIAL PLANNERS PRIVATE LIMITED',
    'CRAZY HIPPOS ADVERTISING PRIVATE LIMITED',
    'BIDSOPT MEDIA PRIVATE LIMITED',
    'Metis Foundation',
    'EXPERT COMPANION PRIVATE LIMITED',
    'BHAGWANDAS GOENKA EDUCATIONAL INSTITUTION',
    'FABRIQUE LAUNDROMAT SERVICES PRIVATE LIMITED',
    'MILLTEX AGRO PRIVATE LIMITED',
    'MATHUR CORR TECH PRIVATE LIMITED',
    'CHLOROPLAST FOODS PRIVATE LIMITED',
    'SREE AMBAL PROCESSORS PRIVATE LIMITED',
    'RAAJCO SPINNERS PRIVATE LIMITED',
    'NORTHGATE GLOBAL IMPEX PRIVATE LIMITED',
    'AVISH FASHION PRIVATE LIMITED',
    'LAKSHMI CAIPO INDUSTRIES LIMITED',
    'COIMBATORE COTTON CONCEPTS & DESIGNS PRIVATE LIMITED',
    'ORFEO SPINNING MILLS PRIVATE LIMITED',
    'GREENWAY CLOTHINGS INDIA PRIVATE LIMITED',
    'SHRI GANGAI TEXTECH INDIA PRIVATE LIMITED',
    'OASIS TEXTECH EXPORTS COIMBATORE PRIVATE LIMITED',
    'SPIC FASHIONS PRIVATE LIMITED',
    'PRANAVA WOVEN WEAR PRIVATE LIMITED',
    'INDIAN HOME OUTFITTERS PRIVATE LIMITED',
    'ASSISI GARMENTS PRIVATE LIMITED',
    'OHMS FUSION KNITWEAR INDIA PRIVATE LIMITED',
    'SIIMKA KNITEX CLUSTER SERVICES PRIVATE LIMITED',
    'REDCUBIX PRIVATE LIMITED',
    'AIRDESIGN BROADCAST MEDIA PRIVATE LIMITED',
    'MAAX AEROSOL TECHNOLOGY PRIVATE LIMITED',
    'S & D TEXTILL INDIA PRIVATE LIMITED',
    'MEDEVIS RUBPLAST INDIA PRIVATE LIMITED',
    'S.S.A.CASTINGS INDIA PRIVATE LIMITED',
    'KEROMIYONS ENTERPRISES INDIA PRIVATE LIMITED',
    'ISPT INDIA PRIVATE LIMITED',
    'RECOMAX VALVES (INDIA) PRIVATE LIMITED',
    'GE OIL & GAS INDIA PRIVATE LIMITED',
    'FLOSYS PUMPS PRIVATE LIMITED',
    'FRANK TECHNOLOGIES PRIVATE LIMITED',
    'SP AUTOMATION AND PACKAGIING MACHINE INDIA PRIVATE LIMITED',
    'PARTHASARATHY CNC TECHNOLOGY PRIVATE LIMITED',
    'KEYSTONE INSTRUMENTS INDIA PRIVATE LIMITED',
    'FLAMEX INDIA GROOVED FITTINGS PRIVATE LIMITED',
    'S and T Plastic Machines Private Limited',
    'S and T Machinery Private Limited',
    'K J SOLAR SYSTEMS PRIVATE LIMITED',
    'ARIHANT SYSTEMS PRIVATE LIMITED',
    'JANGADI TECHNOLOGIES PRIVATE LIMITED',
    'TIRUPATHII GREEN ENERGY PRIVATE LIMITED',
    'HARIYA SOLAR DEVELOPER PRIVATE LIMITED (OPC)',
    'AMD GREEN ENERGY (INDIA) PRIVATE LIMITED',
    'SREE SAKTHI RENEWABLE POWERS PRIVATE LIMITED',
    'SOMANUR WATER SCHEMES PRIVATE LIMITED',
    'SIS CONSTRUCTIONS INDIA PRIVATE LIMITED',
    'SP TECHNOBUILD INDIA PRIVATE LIMITED',
    'C.P.YADAV AND SONS CONSTRUCTION PRIVATE LIMITED',
    'NEST HABITATION DEVELOPERS PRIVATE LIMITED',
    'SAMRIDDHI AROGYAM PRIVATE LIMITED',
    'HARI MARINE PRIVATE LIMITED',
    'SUDHANJALI VENTURES PRIVATE LIMITED',
    'ALL INDIA ON-LINE PRIVATE LIMITED',
    'AptoCoiner Technologies Private Limited',
    'LTN FOODS PRIVATE LIMITED',
    'ASICZEN TECHNOLOGIES INDIA PRIVATE LIMITED',
    'METRO GARDEN ESTATE PRIVATE LIMITED',
    'SKD RICE INDUSTRIES PRIVATE LIMITED',
    'EASTERNZONE INDUSTRIES PRIVATE LIMITED',
    'ANANYA NUTS AND BOLTS PVT LTD',
    'AADIPOWER TECH PRIVATE LIMITED',
    'SEMIOTIC PHARMACEUTICAL PRIVATE LIMITED',
    'BSDS DISTRIBUTORS (ODISHA) PRIVATE LIMITED',
    'AVANTI RETAIL PRIVATE LIMITED',
    'BHUBANESWAR FOOD CITY PRIVATE LIMITED',
    'U3S AGRI COLD STORAGE PRIVATE LIMITED',
    'ASSYSTANT TECHNOLOGIES PRIVATE LIMITED',
    'GROWVY TECHNOLOGY PRIVATE LIMITED',
    'SUPRIT ITINFOWAYS PRIVATE LIMITED',
    'ADIFSER ENTERPRISE SERVICES PRIVATE LIMITED',
    'Goutam&Co Consulting Private Limited',
    'Playbook Consultancy Private Limited',
    'SEAHANS MARINE SERVICES PRIVATE LIMITED',
    'TEAM ALBATROSS EVENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'SEAM AND TRIM FASHION PRIVATE LIMITED',
    'RAASS MULTI-SPECIALITY HOSPITAL PRIVATE LIMITED',
    'SIMPLEEKARE HEALTH PRIVATE LIMITED',
    'PURUSOTTAMPUR WOMEN AGRO PRODUCER COMPANY LIMITED',
    'SERAGADA WOMEN AGRO PRODUCER COMPANY LIMITED',
    'SHRESHANK PROPERTIES PRIVATE LIMITED',
    'GO WIFI NETWORKING SOLUTIONS PRIVATE LIMITED',
    'SAFFRON RESOURCES PRIVATE LIMITED',
    'JAISAINATH REAL ESTATE DEVELOPERS PRIVATE LIMITED',
    'PABITRA ELECTRICAL WORKS PRIVATE LIMITED',
    'BENAZIR INFRASTRUCTURE PRIVATE LIMITED',
    'SKM INFRAVENTURE PRIVATE LIMITED',
    'METRO AGROTECH PRIVATE LIMITED',
    'PACT FOR RURAL LIVELIHOODS PRIVATE LIMITED',
    'Areia Agrotech Private Limited',
    'VISARGHA AGRI SCIENCES PRIVATE LIMITED',
    'UTKAL SEAFOOD PARK LIMITED',
    'RIYARCHITA AGRO VENTURES PRIVATE LIMITED',
    'Odisha Coal and Power Limited',
    'ST MINERALS PRIVATE LIMITED',
    'GEON AGRO PRIVATE LIMITED',
    'NUPROTIN FEEDS PRIVATE LIMITED',
    'NECTAROUS FOODS PRIVATE LIMITED',
    'ANANTA AGRO FOODS & BEVERAGES PRIVATE LIMITED',
    'KALINGA MEDIA & ENTERTAINMENT PRIVATE LIMITED',
    'MUVI ENTERTAINMENT PRIVATE LIMITED',
    'INNOCULE MATERIALS AND ADDITIVES PRIVATE LIMITED',
    'PHARMAZONE LAB LIMITED',
    'HempCann Solutions Private Limited',
    'Kalinganagar Special Steel Private Limited',
    'Kalinganagar Chrome Private Limited',
    'QUALICOM INDUSTRIES PRIVATE LIMITED',
    'VISA Ferro Chrome Limited',
    'MIDAL CABLES PRIVATE LIMITED',
    'FORTUNE POWERNIC SOLUTIONS PRIVATE LIMITED',
    'POSITRIX POWER PRIVATE LIMITED',
    'MAIESTAS LUMINARIES PRIVATE LIMITED',
    'NAIVEDYA POWER CONSTRUCTION PRIVATE LIMITED',
    'SK ENGINEERS INDIA PRIVATE LIMITED',
    'Pioneer Mobile Private Limited',
    'Scolarian Bicycles Private Limited',
    'KARTAVYA POWER & DISTRIBUTIONS PRIVATE LIMITED',
    'GREEN ENERGY DEVELOPMENT CORPORATION OF ODISHA LIMITED',
    'CRUX POWER PRIVATE LIMITED',
    'SMART SOLAR BIDGELY SOLUTION PRIVATE LIMITED',
    'NAMRATHA POWER PRIVATE LIMITED',
    'ICARUS INFRASTRUCTURE PRIVATE LIMITED',
    'UDAYSHREE REALINFRA PRIVATE LIMITED',
    'ULLAS INFRATECH PRIVATE LIMITED',
    'NEWLEAF ESTATES PRIVATE LIMITED',
    'PRECASTERS INDIA PRIVATE LIMITED',
    'MAIESTAS INFRASTRUCTURES PRIVATE LIMITED',
    'RIYARCHITA CONSTRUCTION PRIVATE LIMITED',
    'IDAX ENGINEERING AND CONSTRUCTIONS PRIVATE LIMITED',
    'KKRISHNA VAAHAN PRIVATE LIMITED',
    'IDEAFACTORI TRADING AND SERVICES PRIVATE LIMITED',
    'KYAL AGENCIES PRIVATE LIMITED',
    'SREASTHA MINES & MINERALS PRIVATE LIMITED',
    'IRONIDE MINERALS PRIVATE LIMITED',
    'Maa Youshoda Equipments Private Limited',
    'SIGUR GREEN TECH PRIVATE LIMITED',
    'TECHLAND SYSTEMS PRIVATE LIMITED',
    'HARIMAL CORPORATION PRIVATE LIMITED',
    'MAIESTAS TECHNOLOGIES PRIVATE LIMITED',
    'KIIT HOSPITALITY PRIVATE LIMITED',
    'YATRI CORPORATE SERVICES PRIVATE LIMITED',
    'LANDSCAPE VENTURES PRIVATE LIMITED',
    'JAIN ROAD CARRIERS PRIVATE LIMITED',
    'SMILEY TRIP PRIVATE LIMITED',
    'ODISHA VACATIONS SERVICES PRIVATE LIMITED',
    'HBS TELESOFT PRIVATE LIMITED',
    'ADHIKAR ASSIGNMENT AND DEVELOPMENT SERVICES PRIVATE LIMITED',
    'RAJWADI DEVELOPERS PRIVATE LIMITED',
    'DRUBUS TECHNOLOGIES PRIVATE LIMITED',
    'SCALEDGE INDIA PRIVATE LIMITED',
    'CANVASKITE SOLUTION PRIVATE LIMITED',
    'ODITEK SOLUTIONS PRIVATE LIMITED',
    'SANFONY TECHNOLOGIES PRIVATE LIMITED',
    'ACHYUT SYSTEM AND SERVICES PRIVATE LIMITED',
    'Clarks india services private limited',
    'Vramath investment consultancy private limited',
    'Green link analytical and research laboratory (india) private limited',
    'Digital web avenue (india) private limited',
    'Aspam education foundation',
    'Wallem education and welfare foundation',
    'DESTINATION YOUR',
    'S EDVANTAGE EDUCATION PRIVATE LIMITED',
    'Ideal education private limited',
    'GRPL HOUSING PRIVATE LIMITED',
    'EVERGGREEN JATAVEDA PRIVATE LIMITED',
    'GITZ RETAIL PRIVATE LIMITED',
    'TEDSHARK LABS (OPC) PRIVATE LIMITED',
    'ALEXANDRITE ITP DEVELOPMENT PRIVATE LIMITED',
    'CRODA PIGMENTS PRIVATE LIMITED',
    'REPURPOSE (INDIA) PRIVATE LIMITED',
    'SANIKA PLAST PRIVATE LIMITED',
    'MERIDIAN GLOBAL SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'NETBYTES INFOCOMM PRIVATE LIMITED',
    'LAVINIA LIFE SCIENCES PRIVATE LIMITED',
    'EDMT PRIVATE LIMITED',
    'RAWTEK ENGINEERING PRIVATE LIMITED',
    'MINAS LOGISTICS PRIVATE LIMITED',
    'FIXODUDE WORKS PRIVATE LIMITED',
    'SHOVITHA PROJECTS PRIVATE LIMITED',
    'SEVOTEX CHEMICALS INDIA PRIVATE LIMITED',
    'EXPRESSWAY ADDA PRIVATE LIMITED',
    'XANGARS INFRATECH SOLUTIONS PRIVATE LIMITED',
    'SMASH FACTOR SPORTS PRIVATE LIMITED',
    'FUTUREMARK VENTURES PRIVATE LIMITED',
    'GV PHARMA TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'STALLIONS FUTURX LIMITED',
    'WIZPLEX PRIVATE LIMITED',
    'BEWGLE TECHNOLOGIES PRIVATE LIMITED',
    'EXONCORP PRIVATE LIMITED',
    'ORINO MARKETING PRIVATE LIMITED',
    'INVENTLAND RESEARCH LABORATORIES PRIVATELIMITED',
    'WALROW PRIVATE LIMITED',
    'AVISIRAH TECHNOLOGIES PRIVATE LIMITED',
    'GUJARAT FLUOROCHEMICALS LIMITED',
    'SIGHTPLAN INDIA PRIVATE LIMITED',
    'TRITON DYNAMIC SOLUTIONS PRIVATE LIMITED',
    'AMVI SOFT TECH PRIVATE LIMITED',
    'MUSCLESTADT SPORTERNAEHRUNG INDIA PRIVATE LIMITED',
    'HANBOO INDIA PRIVATE LIMITED',
    'OPEXEFI SERVICES PRIVATE LIMITED',
    'IMTF CANOO SOFTWARE PRIVATE LIMITED',
    'SEEDEER (INDIA) E-COMMERCE PRIVATE LIMITED',
    'MECOTEC EQUIPMENTS INDIA (OPC) PRIVATE LIMITED',
    'PLACEBO FABTECH PRIVATE LIMITED',
    'CENTER FOR URBAN INNOVATION PRIVATE LIMITED',
    'SMARTOVATIONS PRIVATE LIMITED',
    'MOTOSHELL AUTOMOTIVES INDIA PRIVATE LIMITED',
    'SRILAB NEO-PACKS PRIVATE LIMITED',
    'BUOYANCY PLASTICS FOR CHANGE RECYCLING PRIVATE LIMITED',
    'SSKINNOVATIVE POWER SOLUTIONS PRIVATE LIMITED',
    'RIDDHI AUTOWORLD PRIVATE LIMITED',
    'ALFAZ LIFESTYLE SOLUTIONS PRIVATE LIMITED',
    'ADANI WATER LIMITED',
    'YES SHIPPING & LOGISTICS PRIVATE LIMITED',
    'FORTBELL GADGETS PRIVATE LIMITED',
    'SIUJ INDUSTRIES PRIVATE LIMITED',
    'ANGAROS ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'JAKIN TECHNOLOGIES PRIVATE LIMITED',
    'VR99 CLOUD DESIGN PRIVATE LIMITED',
    'RIHAND FLOATING SOLAR PRIVATE LIMITED',
    'ADSCOMPUTE INTERNET SOLUTIONS PRIVATE LIMITED',
    'RPS PROFESSIONAL SERVICES PRIVATE LIMITED',
    'INDELOX GLOBAL DISTRIBUTION PRIVATE LIMITED',
    'POINTHAI INDIA PRIVATE LIMITED',
    'MISSION OF MERCY FOUNDATION',
    'UMANG SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'CAREERBASKET SERVICES PRIVATE LIMITED',
    'RACON BIDDING AND SOURCING PRIVATE LIMITED',
    'BENFY COMMUNICATIONS PRIVATE LIMITED',
    'VRUNDARAK ENGINEERING PRIVATE LIMITED',
    'PAVES BITUMEN PRIVATE LIMITED',
    'KISH HR SKILLS TRAINING FOUNDATION',
    'CRYSTREE SOLUTIONS PRIVATE LIMITED',
    'OPSFUND SERVICES (IFSC) PRIVATE LIMITED',
    'VENDEDOR ENTERPRISES PRIVATE LIMITED',
    'ACTIVORK SOLUTIONS PRIVATE LIMITED',
    'TENNECO CLEAN AIR INDIA PRIVATE LIMITED',
    'HUMMEL INDIA PRIVATE LIMITED',
    'RCON PRECAST PRIVATE LIMITED',
    'FCL TRADEVEST PRIVATE LIMITED',
    'TIAAN WHEELS PRIVATE LIMITED',
    'MRKC VENTURES PRIVATE LIMITED',
    'CONCEPT MOTOR GARAGE PRIVATE LIMITED',
    'TROID PARKING SOLUTIONS PRIVATE LIMITED',
    'HAOSEN AUTOMATION INDIA PRIVATE LIMITED',
    'SINGHSOFT TECHNOLOGY PRIVATE LIMITED',
    'WEGAUGE PIPELINE INSPECTION & SERVICES PRIVATE LIMITED',
    'DITI AUTOMOBILES PRIVATE LIMITED',
    'EURO SAFETY EQUIPMENTS PRIVATE LIMITED',
    'LIVA INVESTMENT LIMITED',
    'MEGEVE TRADING PRIVATE LIMITED',
    'A3GATE SECURITY SOLUTIONS PRIVATE LIMITED',
    'TALENTNAKSHA AI TECH PRIVATE LIMITED',
    'DAWNTECH ELECTRONICS PRIVATE LIMITED',
    'SHIVI FOREX PRIVATE LIMITED',
    'AATMA CAPITAL PRIVATE LIMITED',
    'MIRRORLOOPS LABS AND STUDIOS (OPC) PRIVATE LIMITED',
    'RUPACARGO GLOBAL LOGISTICS PRIVATE LIMITED',
    'UNICLOUD LABS PRIVATE LIMITED',
    'TUTICORIN GOLDEN SAND PRIVATE LIMITED',
    'SLOKI TECHNOLOGIES PRIVATE LIMITED',
    'MONTEK SYSTEMS PRIVATE LIMITED',
    'PRAYAGRAJ WATER PRIVATE LIMITED',
    'ANDRO SPERM 360 LABS PRIVATE LIMITED',
    'BAGWAN PETROLEUM LIMITED',
    'DOIDO TECHNOLOGIES PRIVATE LIMITED',
    'STICON CONSTRUCTION PRIVATE LIMITED',
    'REDELVE INTERNATIONAL PUBLICATIONS PRIVATE LIMITED',
    'ASUUKI PRIVATE LIMITED',
    'ADJUKINES APPLIED SOLUTIONS PRIVATE LIMITED',
    'RUBITECH GLOBAL SOLUTIONS PRIVATE LIMITED',
    'NICHEHIRES STAFFING INDIA PRIVATE LIMITED',
    'NNOWETA ALLIED PRODUCTS PRIVATE LIMITED',
    'GALLENT PHARMACEUTICALS PRIVATE LIMITED',
    'TOPLINA HOSPITALITY PRIVATE LIMITED',
    'PPMS RESOURCES PRIVATE LIMITED',
    'DORA MEDICAL TRADING(INDIA) PRIVATE LIMITED',
    'NEON DESIGN & POWER SOLUTIONS PRIVATE LIMITED',
    'KRISHANSAR AUTO PRIVATE LIMITED',
    'ASSTATIC ENERGY PRIVATE LIMITED',
    'SVF INVESTMENT ADVISERS (INDIA) PRIVATE LIMITED',
    'CW VENTURES PRIVATE LIMITED',
    'SURE INDIA MACHINERY PRIVATE LIMITED',
    'PAXMORE PRIVATE LIMITED',
    'VEDIC INTERNATIONAL ASSETS PRIVATE LIMITED',
    'ETERNAL ROBOTICS PRIVATE LIMITED',
    'TVU NETWORKS INDIA PRIVATE LIMITED',
    'THEREMIN AI SOLUTIONS PRIVATE LIMITED',
    'ITZ4U CONSULTANTS PRIVATE LIMITED',
    'IKIGAI PHARMATECH PRIVATE LIMITED',
    'LEEHWA INDIA PRIVATE LIMITED',
    'EMBLAZON HEALTH AND SOCIAL ECARE INDIA PRIVATE LIMITED',
    'FLAISHNERGY RENEWABLES PRIVATE LIMITED',
    'ARONEG TECHNOLOGY PRIVATE LIMITED',
    'VSYNC MARKETING CONSULTANTS PRIVATE LIMITED',
    'LINXON INDIA PRIVATE LIMITED',
    'JSR DYNAMICS PRIVATE LIMITED',
    'CITY CAR CARE PRIVATE LIMITED',
    'HRIKIN AYURVEDIC PRIVATE LIMITED',
    'HABITRO LABS PRIVATE LIMITED',
    'IRUSHH COURIERS PRIVATE LIMITED',
    'AABASOFT BUSINESS SERVICES PRIVATE LIMITED',
    'DC INFOTECH AND COMMUNICATION LIMITED',
    'AIC RAISE BUSINESS INCUBATOR',
    'SAAJHAA HEALTHCARE PRIVATE LIMITED',
    'SURBHI AGRITECH PRIVATE LIMITED',
    'AVENU INSIGHTS INDIA PRIVATE LIMITED',
    'HELI AIRPARTS AND SERVICES PRIVATE LIMITED',
    'GOCOMET INDIA PRIVATE LIMITED',
    'SUJAG TEXTILE PRIVATE LIMITED',
    'TURMERIQ INTEGRATED MARKETING SOLUTIONS PRIVATE LIMITED',
    'PRATHAMA SOLARCONNECT ENERGY PRIVATE LIMITED',
    'LOTUSSUTRA INDIA SERVICES PRIVATE LIMITED',
    'CPRP INTERNATIONAL PRIVATE LIMITED',
    'FINDULGENCE CAPITAL SERVICES PRIVATE LIMITED',
    'RICHWAY555 SOCIAL WELFARE FOUNDATION',
    'TAGG DIGITAL STRATEGIES PRIVATE LIMITED',
    'YOURDIGITALLIFT PRIVATE LIMITED',
    'SLEEPIZ (INDIA) PRIVATE LIMITED',
    'PFN TOOLS PRIVATE LIMITED',
    'OUTCUE MEDIA PRIVATE LIMITED',
    'SKYISLIMIT TECHNOLOGIES PRIVATE LIMITED',
    'GALIPOGLU HIDROMAS TRADING PRIVATE LIMITED',
    'ZEN LIFE PHARMACIA PRIVATE LIMITED',
    'GBI HOLIDAYS PRIVATE LIMITED',
    'AUTUS ENVIRONMENT PROTECTION TECHNOLOGIES PRIVATE LIMITED',
    'QTEX CONSUMER PRODUCTS SERVICES INDIA PRIVATE LIMITED',
    'INNOBINS DECISION SCIENCE PRIVATE LIMITED',
    'SILA REAL ESTATE PRIVATE LIMITED',
    'MIHIR INFINITE SERVICES PRIVATE LIMITED',
    'KI AGRIBUSINESS PRIVATE LIMITED',
    'ABANS CAPITAL PRIVATE LIMITED',
    'AIC IIT DELHI SONIPAT INNOVATION FOUNDATION',
    'TECHNIAIDS HYDRAULICS PRIVATE LIMITED',
    'SUNSTONE EDUCATION TECHNOLOGY PRIVATE LIMITED',
    'AIRATTIX STORAGE PRIVATE LIMITED',
    'CINEEMA KITE MEDIA WORKS PRIVATE LIMITED',
    'IT8 INDIA PRIVATE LIMITED',
    'BLOCKCIENT PRIVATE LIMITED',
    'ZEAL ELECTROMECH PRIVATE LIMITED',
    'CREKK INGENIOUS SOLUTIONS PRIVATE LIMITED',
    'UNTERWEGS DIGITAL PRIVATE LIMITED',
    'BRISAM RETAIL PRIVATE LIMITED',
    'RAYMAX STUDIO PRIVATE LIMITED',
    'NIRAM APPARELS PRIVATE LIMITED',
    'SANSIA DIGITAL TECHNOLOGY INDIA PRIVATE LIMITED',
    'SAMSWEK EVENTS & MARKETING PRIVATE LIMITED',
    'SONACAD DESIGN INDIA PRIVATE LIMITED',
    'SEPIO HEALTH PRIVATE LIMITED',
    'CELLEBRITE DIGITAL INTELLIGENCE SOLUTIONS PRIVATE LIMITED',
    'MIRRA HEALTH CARE SERVICES INDIA PRIVATELIMITED',
    'CANRIUS VISION PRIVATE LIMITED',
    'SIDDHRANS INFOTECH PRIVATE LIMITED',
    'INVESTX ALTERNATE SOLUTIONS PRIVATE LIMITED',
    'VEIA LUXURY PRIVATE LIMITED',
    'TRANSOCEAN CARGO SERVICES PRIVATE LIMITED',
    'PIKUSPORTS ENTERTAINMENT PRIVATE LIMITED',
    'BRAHMSAR SOLUTIONS PRIVATE LIMITED',
    'STGC UNIFORMITY PRIVATE LIMITED',
    'TURTLEMINT MUTUAL FUNDS DISTRIBUTORS PRIVATE LIMITED',
    'NAADAN CORPORATE PRIVATE LIMITED',
    'INDIABULLS PHARMACARE LIMITED',
    'HEXAGON GRAPHITE PRIVATE LIMITED',
    'ROSEFIELD ENERGY TECH PRIVATE LIMITED',
    'RBGJ ADVISORS PRIVATE LIMITED',
    'FIDUCIVE TECH PRIVATE LIMITED',
    'LEEMA MOBILES INDIA PRIVATE LIMITED',
    'CENTAIR PRIVATE LIMITED',
    'VHT EQUIPMENTS PRIVATE LIMITED',
    'EMPORIUM INDUSTRIAL PARKS (INDIA) PRIVATE LIMITED',
    'V2C BAZAAR PRIVATE LIMITED',
    'ONK FOREX PRIVATE LIMITED',
    'RIGHTSTEPS COMMUNICATION PRIVATE LIMITED',
    'SATYAJYOT EXIM PRIVATE LIMITED',
    'GCS DILIGENCE SERVICES PRIVATE LIMITED',
    'CASTORGIRNAR INDUSTRIES PRIVATE LIMITED',
    'GEKLO NUTRICARE PRIVATE LIMITED',
    'OPENDIGI TECHNOLOGIES PRIVATE LIMITED',
    'KANZAEM SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'QUANTOWER TECHNOLOGIES PRIVATE LIMITED',
    'MANDIT SOLUTIONS PRIVATE LIMITED',
    '3E RENEWABLE ENERGY SOFTWARE AND SERVICES PRIVATE LIMITED',
    'MILLORA BUSINESS CONSULTING PRIVATE LIMITED',
    'CUSTOM ENGINEERING PRIVATE LIMITED',
    'NEMCON INFRA PRIVATE LIMITED',
    'ARUMS PHARMACEUTICALS PRIVATE LIMITED',
    'AUNOA SOLUTIONS PRIVATE LIMITED',
    'EMINENT CHEMTECH PRIVATE LIMITED',
    'ICUNET CONSULTING INDIA PRIVATE LIMITED',
    'SIDNEM TECH PRIVATE LIMITED',
    'MAYUSH IT SERVICES PRIVATE LIMITED',
    'ROI MINDS PRIVATE LIMITED',
    'AFFIDABILE SOLUTIONS PRIVATE LIMITED',
    'BRANCH ENERGIA POWER INDIA PRIVATE LIMITED',
    'HVR VISUALISATIONS GLOBAL PRIVATE LIMITED',
    'INNOVATIVE CASHFLOW ADVISORY PRIVATE LIMITED',
    'RAJHANSH TRANSPORT SERVICE PRIVATE LIMITED',
    'DION AUTOMOTIVES PRIVATE LIMITED',
    'ENVEETECH BIM SOLUTIONS PRIVATE LIMITED',
    'WALNUT BUILDCON PRIVATE LIMITED',
    'TRGT DIGITAL INDIA PRIVATE LIMITED',
    'MANDLI TECHNOLOGIES PRIVATE LIMITED',
    'HIRABA ENGINEERS PRIVATE LIMITED',
    'ASPL NATURE PURE PRIVATE LIMITED',
    'MAILUN TEXTILE PRIVATE LIMITED',
    'UNIQUEDEAL CONSULTANT PRIVATE LIMITED',
    'SSII SHIPCONSTRUCTOR SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'RIFOF CONSTRUCTION PRIVATE LIMITED',
    'CPL MACHINERY INDIA PRIVATE LIMITED',
    'TAC SECURITY PRIVATE LIMITED',
    'WHITE WIZARD TECHNOLOGIES PRIVATE LIMITED',
    'EVAGE VENTURES PRIVATE LIMITED',
    'TAGMANGO PRIVATE LIMITED',
    'IMA PACKAGING TECHNOLOGY INDIA PRIVATE LIMITED',
    'DEEMARK ORGANIC WORLD PRIVATE LIMITED',
    'SHIVA INFOTECH INNOVATIONS PRIVATE LIMITED',
    'DYNAMINDS MARKETING INDIA PRIVATE LIMITED',
    'PRR AGRO N FARMS PRIVATE LIMITED',
    'COGNOS INFRA PRIVATE LIMITED',
    'UTKRISHT TRADE SOLUTIONS PRIVATE LIMITED',
    'PROTEIN CRAFTERS PRIVATE LIMITED',
    'FIDUS INDIA AUTOMATION PRIVATE LIMITED',
    'KID APTIVITY TECHNOLOGIES PRIVATE LIMITED',
    'NESTASSIST SERVICES PRIVATE LIMITED',
    'DEBREX PAINTS AND COATINGS PRIVATE LIMITED',
    'NAVO LIFESTYLE PRIVATE LIMITED',
    'TBKK BROTHERS PRIVATE LIMITED',
    'NATURANT INDUSTRIES PRIVATE LIMITED',
    'AYATANA OOTY PRIVATE LIMITED',
    'TRULEARN SPACES PRIVATE LIMITED',
    'RSIN FLEXIRENTALS PRIVATE LIMITED',
    'PLANET KOLTE-PATIL SMART ADVISORY PRIVATE LIMITED',
    'ATHRIDATTA SERVICES PRIVATE LIMITED',
    'CARGOLINE GLOBAL LOGISTICS PRIVATE LIMITED',
    'RUSK MEDIA PRIVATE LIMITED',
    'SONA MACHINERY LIMITED',
    'AMBAB IOT PRIVATE LIMITED',
    'PRINCE MFG INDUSTRIES PRIVATE LIMITED',
    'KMORDANI REAL ESTATES PRIVATE LIMITED',
    'UPDAPT CSR PRIVATE LIMITED',
    'TNS PRECISION INDUSTRIES PRIVATE LIMITED',
    'LEAF STUDIOS PRIVATE LIMITED',
    'PHOENICIAN MEDICAL CENTER INDIA PRIVATE LIMITED',
    'AFROSIA EXPORTS PRIVATE LIMITED',
    'THERM TECHNOLOGY AND HEAT TRANSFER PRIVATE LIMITED',
    'PROP VESTORS PRIVATE LIMITED',
    'NEOLYNC ELECTRONICS PRIVATE LIMITED',
    'COSTA POWER INDUSTRIES PRIVATE LIMITED',
    'BLINK TRAVEL INNOVATIONS PRIVATE LIMITED',
    'REELS ',
    'DICE INTERACTIVE PRIVATE LIMITED',
    'ASSETVAULT INDIA PRIVATE LIMITED',
    'GREATKEEPER TECH INDIA PRIVATE LIMITED',
    'GHACK TECHNOLOGIES PRIVATE LIMITED',
    'GUTURI PHARMA PRIVATE LIMITED',
    'PADMAMSRIVARI IMPORTS AND EXPORTS PRIVATE LIMITED',
    'JISHU INDIA ELECTRONICS PRIVATE LIMITED',
    'PRANAVA INNOVATIVE TECHNOLOGIES PRIVATE LIMITED',
    'NAVATIO PHARMA SOLUTIONS PRIVATE LIMITED',
    'FLUJO TECHNOLOGIES PRIVATE LIMITED',
    'SNAPMINT FINANCIAL SERVICES PRIVATE LIMITED',
    'YENDIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'FRVAT INDIA PRIVATE LIMITED',
    'INTELLIGENT RETAIL PRIVATE LIMITED',
    'STEULER INDUSTRIAL SOLUTION (INDIA) PRIVATE LIMITED',
    'SKICORP TRINITY PRIVATE LIMITED',
    'INGENIOUS TECHNOCRAT PRIVATE LIMITED',
    'DIVIDANT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'FELLOWAPP HR SOLUTIONS (OPC) PRIVATE LIMITED',
    'EARTHROUTES MARKETING SOLUTIONS PRIVATE LIMITED',
    'AAPNIK RETAIL PRIVATE LIMITED',
    'TECHBIZ MENTORS (OPC) PRIVATE LIMITED',
    'MEDUSIND SOLUTIONS INDIA PRIVATE LIMITED',
    'ARTISANAL DRINKS PRIVATE LIMITED',
    'UTRYAN ENERGY AGRA PRIVATE LIMITED',
    'LEADERSEDGE CONSULTING PRIVATE LIMITED',
    'PARAS AEROSPACE PRIVATE LIMITED',
    'CREDSURE FINANCIAL SERVICES PRIVATE LIMITED',
    'MADITSSIA TRADE & CONVENTION CENTER',
    'EXCELLEDIA DIGITAL INNOVATIONS PRIVATE LIMITED',
    'MEIKO ELECTRONICS INDIA PRIVATE LIMITED',
    'HIND HYDRAULICS & ENGINEERS PRIVATE LIMITED',
    'HERIOS INFOSEC PRIVATE LIMITED',
    'INVIDI TECHNOLOGIES INDIA PRIVATE LIMITED',
    'BRAINSHARE IDEAS PRIVATE LIMITED',
    'FAMFAKTREE PRIVATE LIMITED',
    'V4ACE SECURITY SYSTEMS PRIVATE LIMITED',
    'PRASTYLE INTERNET PRIVATE LIMITED',
    'JSV TECHNOLOGIES & CONSULTING PRIVATE LIMITED',
    'AMRAYS BIOINNOVATION PRIVATE LIMITED',
    'ISHITTVA DHARMA SANSTHAPAN FOUNDATION',
    'QCLYNX CONSULTING PRIVATE LIMITED',
    'DOCKUP TECH PRIVATE LIMITED',
    'EKAM CONVERGENCE PRIVATE LIMITED',
    'LAGORI INDIA PRIVATE LIMITED',
    'INGENIOUS INNOVATIONS (OPC) PRIVATE LIMITED',
    'EFFIYA TECHNOLOGIES PRIVATE LIMITED',
    'WHISTLER FOODS PRIVATE LIMITED',
    'IEGG INDIA PRIVATE LIMITED',
    'LOSERADDA MARKETING PRIVATE LIMITED',
    'UI SOLUTIONS INDIA PRIVATE LIMITED',
    'ALS EDUVENTURES PRIVATE LIMITED',
    'RCL AGENCIES EAST INDIA PRIVATE LIMITED',
    'ZECK POWER AND RAIL PRIVATE LIMITED',
    'MOVEON DELIVERY INTIME PRIVATE LIMITED',
    'REMUNANCE SERVICES PRIVATE LIMITED',
    'ICL SYSTEMS INDIA PRIVATE LIMITED',
    'LUXSHARE INDIA PRIVATE LIMITED',
    'ECKSTEIN ENGINEERING BUSINESS SOLUTIONS PRIVATE LIMITED',
    'PADMINI DIESEL EMISSION CONTROL PRIVATE LIMITED',
    'JELLYFISH DIGITAL INDIA PRIVATE LIMITED',
    'JMDITHUB SOLUTIONS PRIVATE LIMITED',
    'IMPRESSIONS PRINTING & PACKAGING LIMITED',
    'PROPSHARE OFFICE PROJECTS PRIVATE LIMITED',
    'H2O POOLS PRIVATE LIMITED',
    'CITYZONE TELECOM SERVICES PRIVATE LIMITED',
    'WHR EXPORTS PRIVATE LIMITED',
    'SLNS SREE GANESHA TRAVELS PRIVATE LIMITED',
    'ARSHIYA PANVEL LOGISTICS SERVICES PRIVATE LIMITED',
    'STELIOS ASSET MANAGEMENT PRIVATE LIMITED',
    'SLS LOGISTIK ACADEMY PRIVATE LIMITED',
    'SHAKTI SHASWATI PRIVATE LIMITED',
    'AUTOMOTIVE TECHNICAL SERVICE INDIA PRIVATE LIMITED',
    'DURODESIGNS HOME DECORS PRIVATE LIMITED',
    'FREIGHTOS INDIA PRIVATE LIMITED',
    '50K SAAS VENTURES PRIVATE LIMITED',
    'ADVANCE MEDICARE & RESEARCH INSTITUTE (BHUBANESWAR) PRIVATE LIMITED',
    'DREAMZIOT TECHNOLOGIES PRIVATE LIMITED',
    'ARPROSOFT PRIVATE LIMITED',
    'SHATARCHI AGRO INDIA PRIVATE LIMITED',
    'ALIF SEMICONDUCTOR INDIA PRIVATE LIMITED',
    'INVINCIBLE OCEAN PRIVATE LIMITED',
    'HUMAN-RECOGNITION SYSTEMS PRIVATE LIMITED',
    'ACE ROBOTICS PRIVATE LIMITED',
    'ANBRONICA TECHNOLOGIES PRIVATE LIMITED',
    'RV ENVIRONMENT INFRASTRUCTURE PRIVATE LIMITED',
    'MENTIS DATA INDIA PRIVATE LIMITED',
    'PUNE IT CITY METRO RAIL LIMITED',
    'ASSA POLYURETHANES PRIVATE LIMITED',
    'FRUTUNES FOOD PRODUCTS PRIVATE LIMITED',
    'REXSATRONIX MYS PRIVATE LIMITED',
    'TECHREACH INFORMATICS PRIVATE LIMITED',
    'ASPIRE HEALTHCARE PHARMA (INDIA) PRIVATE LIMITED',
    'AYANA RENEWABLE POWER TWO PRIVATE LIMITED',
    'SPRM TECHNO INFIRMIERE PRIVATE LIMITED',
    'NOAH LOGISTICS PRIVATE LIMITED',
    'MICELIO LABS PRIVATE LIMITED',
    'CERTUS APAC CONSULTING PRIVATE LIMITED',
    '1BALANCE WELLNESS PRIVATE LIMITED',
    'PIN PERIPHERAL PRIVATE LIMITED',
    'SWQA SOLUTIONS PRIVATE LIMITED',
    'JRK INFOTECH PRIVATE LIMITED',
    'NEXUS NUTRI SCIENCE LIMITED',
    'STERP SOFTWARE PRIVATE LIMITED',
    'GAMMASTACK SERVICES PRIVATE LIMITED',
    'WORXSTAX SOLUTIONS PRIVATE LIMITED',
    'QUICKSPACE ONLINE PRIVATE LIMITED',
    'MAARUTH CONSULTANTS PRIVATE LIMITED',
    'AARTAS CARE PRIVATE LIMITED',
    'GEOSIEBEN CONSULTING PRIVATE LIMITED',
    'SHOW BUDDY ENTERTAINMENT PRIVATE LIMITED',
    'NEXTCOWORKS SERVICES PRIVATE LIMITED',
    'C.K.E.E.ENGINEERING PRIVATE LIMITED',
    'MASTERKEY CAPITAL INVESTMENTS PRIVATE LIMITED',
    'VEDEQTA GLOBAL SOLUTIONS PRIVATE LIMITED',
    'DB DIXON BATTERY PRIVATE LIMITED',
    'CLEAR EDGE EXPORTS PRIVATE LIMITED',
    'METEC ELECTRONICS PRIVATE LIMITED',
    'ESPERER ONCO NUTRITION PRIVATE LIMITED',
    'ECR PLOTS PRIVATE LIMITED',
    'ECR HOUSING PRIVATE LIMITED',
    'STRIDELY SOLUTIONS INDIA PRIVATE LIMITED',
    'ACTONICS INDIA PRIVATE LIMITED',
    'ALOGREEN WATER TECH PRIVATE LIMITED',
    'TURBOHIRE TECHNOLOGIES PRIVATE LIMITED',
    'REAL TIME SKILLS PRIVATE LIMITED',
    'SCHLOSS GANDHINAGAR PRIVATE LIMITED',
    '102 MOTHER CHILD SERVICES (UP)',
    'CITYFURNISH INDIA PRIVATE LIMITED',
    'SOLIS HEALTH PRIVATE LIMITED',
    'GRAFITECTS SOLUTIONS PRIVATE LIMITED',
    'FULLNESS WEB SOLUTIONS PRIVATE LIMITED',
    'ANIMUS PROJECT PRIVATE LIMITED',
    'SRM INTERNATIONAL SCHOOLS',
    'REDKIWI VEHICLES PRIVATE LIMITED',
    'CLOUDAI PRIVATE LIMITED',
    'ASL MEDICAL PRIVATE LIMITED',
    'SIMPLINITY SOLUTIONS PRIVATE LIMITED',
    'ASEL ARS SPORTS PRIVATE LIMITED',
    'SANONEST PRIVATE LIMITED',
    'SIGMACHEMIE SPECIALITY PRIVATE LIMITED',
    'UTRACON ENGINEERING SERVICES PRIVATE LIMITED',
    'STRATEGIC SYSTEMS IT SOLUTIONS PRIVATE LIMITED',
    'A.RUSHABH TRADE LINK PRIVATE LIMITED',
    'CREATIVES AROUND THE WORLD PRIVATE LIMITED',
    'KUNDUZ TECHNOLOGIES PRIVATE LIMITED',
    'WORTGAGE FINANCE PRIVATE LIMITED',
    'MADHUR CONFECTIONERS PRIVATE LIMITED',
    'LUCENTS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'EMMDEE BIOGAS PRIVATE LIMITED',
    'RAGHUVANSH TECHNOLOGY SERVICES PRIVATE LIMITED',
    'STACKNEXUS TECHNOLOGIES PRIVATE LIMITED',
    'SIT PTC INDIA PRIVATE LIMITED',
    'GRAU INDIA BRAKE PRODUCTS PRIVATE LIMITED',
    'ENSUREDIT TECHNOLOGIES PRIVATE LIMITED',
    'GROOTS SOFTWARE TECHNOLOGIES PRIVATE LIMITED',
    'CEF RETAIL UP PRIVATE LIMITED',
    'RENEW SUN WAVES PRIVATE LIMITED',
    'YANTRILABS INDIA PRIVATE LIMITED',
    'MOBISOFTINFO TELECOMMUNICATION LIMITED',
    'SIA ENGINEERING PROJECTS INDIA PRIVATE LIMITED',
    'IMPACTOXGEN PRIVATE LIMITED',
    'BESTFLEX BELTING MANUFACTURERS PRIVATE LIMITED',
    'LONGCHENG COMPOSITES INDIA PRIVATE LIMITED',
    'MS LOGISTICS PRIVATE LIMITED',
    'CREDIBLE INFOTECH SOLUTIONS PRIVATE LIMITED',
    'OLA CAPITAL SERVICES PRIVATE LIMITED',
    'EMPHATIC VANS & TESTING LABS PRIVATE LIMITED',
    'UCCHVAS HEALTHCARE PRIVATE LIMITED',
    'PMT VALVES PRIVATE LIMITED',
    'BLUE AVIS TRAVELUM EXPEDITIONS PRIVATE LIMITED',
    'CODLEO CONSULTING PRIVATE LIMITED',
    'NORDIC KOLEKTIVE VENTURES PRIVATE LIMITED',
    'PAGAC ADVISORS INDIA PRIVATE LIMITED',
    'ADHOC SPORTS PRIVATE LIMITED',
    'EYESTOPPER INDUSTRIES PRIVATE LIMITED',
    'BHARUWA SOLUTIONS PRIVATE LIMITED',
    'YEZMAN TECHNOLOGIES PRIVATE LIMITED',
    'HIPLA TECHNOLOGIES PRIVATE LIMITED',
    'CATCHUP TECHNOLOGIES PRIVATE LIMITED',
    'SRINIVAS PAPERS PRIVATE LIMITED',
    'MOSIWO TECHNOLOGIES PRIVATE LIMITED',
    'ORGPRO SOFTWARES PRIVATE LIMITED',
    'INDOVATION EXPORTS PRIVATE LIMITED',
    'FIBOVIL PHARMACEUTICALS PRIVATE LIMITED',
    'TEG GLOBAL INFRASTRUCTURES PRIVATE LIMITED',
    'SDTRONICS PRIVATE LIMITED',
    'NEOGEOINFO TECHNOLOGIES PRIVATE LIMITED',
    'ANTONAL TECHNOLOGIES PRIVATE LIMITED',
    'CHEMYZOLAB PRIVATE LIMITED',
    'AVEER FOODS LIMITED',
    'EKA CAPITAL PRIVATE LIMITED',
    'DURASIGN BRAND SOLUTIONS PRIVATE LIMITED',
    'KUMAR PROPERTIES INFRATECH DEVELOPERS PRIVATE LIMITED',
    'JKM AGENCIES PRIVATE LIMITED',
    'SKFF(INDIA) PRIVATE LIMITED',
    'SWIRE DIGITAL CENTRE PRIVATE LIMITED',
    'DOTC TECHNOLOGIES PRIVATE LIMITED',
    'HAKKE INDUSTRIES PRIVATE LIMITED',
    'ZTEK CONTROL SYSTEMS PRIVATE LIMITED',
    'SAMUDRA CARGO HANDLING PRIVATE LIMITED',
    'ISAS BEAUTY SCHOOL PRIVATE LIMITED',
    'FINPROV LEARNING PRIVATE LIMITED',
    'SAMWOO PACKING SYSTEM INDIA PRIVATE LIMITED',
    'SREE VARAMAHALAKSHMI LOGISTICS PRIVATE LIMITED',
    'QUENTEK DESIGNS PRIVATE LIMITED',
    'MOTHERHOUSE (INDIA) PRIVATE LIMITED',
    'REDSHIFT INNOVATIONS PRIVATE LIMITED',
    'ONGC VIDESH ROVUMA LIMITED',
    'KARAKUN SOFTWARE PRIVATE LIMITED',
    'YPL INFO-TECH PRIVATE LIMITED',
    'LABOURNET LIVELIHOOD FOUNDATION',
    'MOSHINE ELECTRONICS PRIVATE LIMITED',
    'INTEUTION TECHNOLOGIES PRIVATE LIMITED',
    'SPEYSIDE CORPORATE RELATIONS PRIVATE LIMITED',
    'RIDENEXT SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'STUDIO SHAKTHI PICTURES PRIVATE LIMITED',
    'MARVEL ERA PRIVATE LIMITED',
    'SHINSEGAE ITS INDIA PRIVATE LIMITED',
    'PARAKH KNOWLEDGE ACADEMY PRIVATE LIMITED',
    'GENOMETOHEALTH PRIVATE LIMITED',
    'SANJAY TECHNOLOGIES PRIVATE LIMITED',
    'SURYAPET KHAMMAM ROAD PRIVATE LIMITED',
    'SHRING CONSULTING PRIVATE LIMITED',
    'MAKSE SERVICES PRIVATE LIMITED',
    'LAUNCHTECHPAD APPLICATIONS INDIA PRIVATELIMITED',
    'CREDBERG ADVISORS INDIA PRIVATE LIMITED',
    'EXORA LABS PRIVATE LIMITED',
    'TRANSASIA DIAGNOSTICS SOLUTIONS LIMITED',
    'HYPERBLOX INDIA PRIVATE LIMITED',
    'YESSSWORKS SPACES PRIVATE LIMITED',
    'XEXAGON SOLUTIONS PRIVATE LIMITED',
    'KINGSMEN COFFEE PRIVATE LIMITED',
    'IMMUCARE DIAGNOSTICS PRIVATE LIMITED',
    'DECORIO HARDWARE WORLD PRIVATE LIMITED',
    'COLORPIK TEXTILES PRIVATE LIMITED',
    'BIOSUN ASIAPACIFIC PRIVATE LIMITED',
    'ADANI HYBRID ENERGY JAISALMER TWO LIMITED',
    'MONKWISH TECHNOLOGIES PRIVATE LIMITED',
    'INFYNIX DATA SERVICES PRIVATE LIMITED',
    'REAL SECURITY AND FACILITY MANAGEMENT INDIA PRIVATE LIMITED',
    'WHARF STREET STUDIOS PRIVATE LIMITED',
    'LASA TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'INFINITYQS INDIA PRIVATE LIMITED',
    'IBG CONSULTANTS PRIVATE LIMITED',
    'ADANI HYBRID ENERGY JAISALMER THREE LIMITED',
    'SPARKK LIFE SCIENCES PRIVATE LIMITED',
    'KRITILABS TECHNOLOGIES PRIVATE LIMITED',
    'ASCARIT SOLUTIONS PRIVATE LIMITED',
    'SURYAKAMAL TECHNOLOGIES PRIVATE LIMITED',
    'BITPAD TECHNOLOGIES PRIVATE LIMITED',
    'WEBORITY TECHNOLOGIES PRIVATE LIMITED',
    'UPMINT FINSERV PRIVATE LIMITED',
    'ZUME INDIA PRIVATE LIMITED',
    'PRAAJ BUSINESS SOLUTIONS INDIA PRIVATE LIMITED',
    'INNOKRIT INVENTIONS PRIVATE LIMITED',
    'SARVATANTRA DEVICEAMC PRIVATE LIMITED',
    'SAISRUSHTI LAKSHMIPURA-1 DEVELOPMENTS PRIVATE LIMITED',
    'AIRLIFE GASES PRIVATE LIMITED',
    'HRS HOSPITALITY SOFTWARE PRIVATE LIMITED',
    'INSIGNIAN HOME PRIVATE LIMITED',
    'UNITED CONTROL ENGINEERS INDIA PRIVATE LIMITED',
    'ARTIBRAINO PRIVATE LIMITED',
    'TRANSASIA PAPERS INDIA PRIVATE LIMITED',
    'LAMBDOS TECHNOLOGIES PRIVATE LIMITED',
    'VAISHNO SAI QUALITY CONSULTANTS PRIVATE LIMITED',
    'ANS OUTSOURCING PRIVATE LIMITED',
    'BLISSON MEDICA PRIVATE LIMITED',
    'XPLUSD EVENTS PRIVATE LIMITED',
    'FLIVE CONSULTING PRIVATE LIMITED',
    'SUBUDHI TECHNOENGINEERS PRIVATE LIMITED',
    'VERSETAL TECH SOLUTIONS PRIVATE LIMITED',
    'ROUNDGLASS WELLBEING PRIVATE LIMITED',
    'YBM TRAVELS PRIVATE LIMITED',
    'NUMANN PRECISION PRODUCTS PRIVATE LIMITED',
    'SUNDARAM ALTERNATE ASSETS LIMITED',
    'LIZA CLOTHING AND APPARELS PRIVATE LIMITED',
    'GOOSE SUPPORT SERVICES PRIVATE LIMITED',
    'SAXO GROUP INDIA PRIVATE LIMITED',
    'PHAZR INDIA PRIVATE LIMITED',
    'SOCURE INDIA PRIVATE LIMITED',
    'N-TIER DEVELOPMENT STUDIO INDIA PRIVATE LIMITED',
    'LCUBED INDIA PRIVATE LIMITED',
    'MEDIBRICKS PRIVATE LIMITED',
    'FINZLY INDIA (R &D) PRIVATE LIMITED',
    'MOUNT SHIVALIK HOSPITALITY PRIVATE LIMITED',
    'CRM LOANMONEY SERVICES PRIVATE LIMITED',
    'JAGANMAYI HI-RISE PRIVATE LIMITED',
    'SAINYAM INDUSTRIES PRIVATE LIMITED',
    'MEDILUX CHEMICALS PRIVATE LIMITED',
    'GOKEN TECHNOLOGY INDIA PRIVATE LIMITED',
    'SENSIO ENTERPRISES PRIVATE LIMITED',
    'AIOT FOUNDRY PRIVATE LIMITED',
    'STELLEN INFOTECH PRIVATE LIMITED',
    'BELLEGIRL LIFESTYLE PRIVATE LIMITED',
    'YENEPOYA FOUNDATION FOR TECHNOLOGY INCUBATION',
    'AJAPRO AI TECHNOLOGIES PRIVATE LIMITED',
    'PLAN-B SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'CAPIUM SMART ACCOUNTING SOLUTIONS PRIVATE LIMITED',
    'FORT CAPITAL INVESTMENT ADVISORY PRIVATE LIMITED',
    'SHREE BALKRISHNA COMMERCIAL CO LTD',
    'NAKSH PRECIOUS METALS LIMITED',
    'WALWHAN SOLAR PB LIMITED',
    'SPECTRUM RENEWABLE ENERGY PRIVATE LIMITED',
    'SCORE INFORMATION TECHNOLOGIES LIMITED',
    'KANDULA HOLDINGS PRIVATE LIMITED',
    'SILVERHILLS KNIT WEAR PRIVATE LIMITED',
    'MWW GACHIBOWLI PRIVATE LIMITED',
    'LIFECRAFT HEALTHCARE PRIVATE LIMITED',
    'EPIKINDIFI SOFTWARE & SOLUTIONS PRIVATE LIMITED',
    'OMNISOURCE SERVICES PRIVATE LIMITED',
    'WALWHAN WIND RJ LIMITED',
    'ANR DESIGNER TILES LIMITED',
    'SOLVEN INDIA TECHNOLOGIES & CONSULTING PRIVATE LIMITED',
    'MONARCH AUTOMOBILES PRIVATE LIMITED',
    'SAPHIRE STITCHING WORKS PRIVATE LIMITED',
    'LOHMANN BREEDERS INDIA PRIVATE LIMITED',
    'OMKARM CAPITAL PRIVATE LIMITED',
    'INCRED WEALTH PRIVATE LIMITED',
    'SRAN SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'DIYAR UNITED PRIVATE LIMITED',
    'INDRA MARSHAL POWER PRIVATE LIMITED',
    'SMARTPRATYA TECHNOLOGIES PRIVATE LIMITED',
    'UNOX INDIA PRIVATE LIMITED',
    'DIGI OSMOSIS PRIVATE LIMITED',
    'ESTACHA INNOVATION INCUBATOR PRIVATE LIMITED',
    'AVIRUDDHA PRODUCTIVITY PRIVATE LIMITED',
    'SHREM INFRA INVEST PRIVATE LIMITED',
    'AVENTUS BUILDCON LIMITED',
    'BHIM SINGH YADAV LOGISTICS & INFRASTRUCTURE PRIVATE LIMITED',
    'ADITYA BIRLA NEW AGE HOSPITALITY PRIVATE LIMITED',
    'DESHPAL LOGISTICS & INFRASTRUCTURE PRIVATE LIMITED',
    'THINKINK PICTUREZ LIMITED',
    'CONTINENTAL PROJECTS LIMITED',
    'BHALCHANDRAM CLOTHING LIMITED',
    'MEDICO INTERCONTINENTAL LIMITED',
    'HERO FINANCIAL SERVICES PRIVATE LIMITED',
    'NAVAYUGA ROAD PROJECTS PRIVATE LIMITED',
    'PICK MY SOLAR INDIA PRIVATE LIMITED',
    'INNOVIS TELECOM SERVICES INDIA PRIVATE LIMITED',
    'ENERMAN TECHNOLOGIES PRIVATE LIMITED',
    'AMPYR RENEWABLE ENERGY RESOURCES ONE PRIVATE LIMITED',
    'SF LOGISTICS PRIVATE LIMITED',
    'NICORE INDIA PRIVATE LIMITED',
    'DILEEP ESSENTIALS PRIVATE LIMITED',
    'SRIRANGAM MILK PRODUCTS PRIVATE LIMITED',
    'MCF FOODS INDIA PRIVATE LIMITED',
    'MEA DIVA FASHION AND APPAREL PRIVATE LIMITED',
    'CKR IMPEX PRIVATE LIMITED',
    'GORUPEE INFINTECH SERVICES PRIVATE LIMITED',
    'VAGT SECURITY SERVICES PRIVATE LIMITED',
    'CE DESIGNS PRIVATE LIMITED',
    'REVELO BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ENTERPRISE BLUEPRINTS CONSULTING INDIA PRIVATE LIMITED',
    'SHARAF PROCESSING SERVICES PRIVATE LIMITED',
    'DOTPE PRIVATE LIMITED',
    'EDHACK TECHNOLOGIES PRIVATE LIMITED',
    'AUSUM FOOD AND BEVERAGES PRIVATE LIMITED',
    'RAJKAR GLOBAL CONSULTANCY PRIVATE LIMITED',
    'MIBO WELLCARE INDIA PRIVATE LIMITED',
    'MPS DEY INTERNATIONAL PRIVATE LIMITED',
    'EET FUTURE ENERGY LIMITED',
    'HILD DEFENCE AND AEROSPACE PRIVATE LIMITED',
    'ABNO SOFTWARES INTERNATIONAL PRIVATE LIMITED',
    'DEBUTANTE SYSTEMS PRIVATE LIMITED',
    'CONSTRUERE SOLUTIONS PRIVATE LIMITED',
    'ACSZ TECH PRIVATE LIMITED',
    'SOMS SYSTEMS PRIVATE LIMITED',
    'TEALFEED PRIVATE LIMITED',
    'ATOMIC ENGINEERS PRIVATE LIMITED',
    'JS JEWELS PRIVATE LIMITED',
    'SKILLINABOX LEARNING SOLUTIONS PRIVATE LIMITED',
    'DIMA BUSINESS SOLUTIONS PRIVATE LIMITED',
    'GARDENLY BIONATURE SOLUTIONS PRIVATE LIMITED',
    'YANTRA AI TECH PRIVATE LIMITED',
    'RNFI MONEY PRIVATE LIMITED',
    'INVOQ HEALTHCARE INDIA PRIVATE LIMITED',
    'SKADOOSH MEDIA PRIVATE LIMITED',
    'RAZMAZ FASHION PRIVATE LIMITED',
    'SRI MAHALAKSHMI DAIRY PRIVATE LIMITED',
    'JAI BHUVANESWARI SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'SKANDA INTEGRATED SERVICES PRIVATE LIMITED',
    'AVIRAJ TECHNO SOLUTIONS PRIVATE LIMITED',
    'ICAP AUTOMATION PRIVATE LIMITED',
    'TEALORCA WEB AGENCY PRIVATE LIMITED',
    'RELIANCE ETHANE PIPELINE LIMITED',
    'ASM CAREER SOLUTIONS PRIVATE LIMITED',
    'TRACELAY NETWORKS PRIVATE LIMITED',
    'TAK EXPO PRIVATE LIMITED',
    'CIPIND SOLUTIONS PRIVATE LIMITED',
    'INODAY EDU SKILL PRIVATE LIMITED',
    'LAUDCO MEDIA PRIVATE LIMITED',
    'RELIANCE POLYESTER LIMITED',
    'LYCEUM LIFE SCIENCES PRIVATE LIMITED',
    'WURZEL INTERNO PRIVATE LIMITED',
    'MARYLAND CAST AND FORGE PRIVATE LIMITED',
    'ESENPRO POWER TRANSMISSION PRIVATE LIMITED',
    'ZITIN TECHNOLOGIES PRIVATE LIMITED',
    'FRESHBUS PRIVATE LIMITED',
    'APPEXERT LABS (OPC) PRIVATE LIMITED',
    'KAKA INDUSTRIES LIMITED',
    'TIMS SOLUTIONS PRIVATE LIMITED',
    'AQFIT SMART TECHNOLOGY PRIVATE LIMITED',
    '4PEL MEGA URJA PRIVATE LIMITED',
    'EXTOL IMPEX INDIA PRIVATE LIMITED',
    'PPLCOM TECHNOLOGIES PRIVATE LIMITED',
    'UPANAL CNC PRIVATE LIMITED',
    'IBFS CONSULTING INDIA PRIVATE LIMITED',
    'AUGEO ASSET MANAGEMENT PRIVATE LIMITED',
    'HARISHMANE INFRATECH PRIVATE LIMITED',
    'ENERTICS INDIA PRIVATE LIMITED',
    'MAX SQUARE LIMITED',
    'BETRODD SOLUTIONS PRIVATE LIMITED',
    'WALRUS LABS PRIVATE LIMITED',
    'VASUDHAIKA SOLUTIONS PRIVATE LIMITED',
    'TRESBU DIGITAL INDIA PRIVATE LIMITED',
    'TWINS IDEAS AND INNOVATIONS PRIVATE LIMITED',
    'EUPHORIC THOUGHT TECHNOLOGIES PRIVATE LIMITED',
    'RELIANCE STRATEGIC BUSINESS VENTURES LIMITED',
    'TRADEREBOOT FINTECH PRIVATE LIMITED',
    'HG METALS & ALLOYS PRIVATE LIMITED',
    'POTENTIAM OFFSHORE SERVICES PRIVATE LIMITED',
    'NEWFANGLED CONCEPT PRIVATE LIMITED',
    'CPD PHARMA PRIVATE LIMITED',
    'SHANTI FOUMACH PRIVATE LIMITED',
    'IVTEC AUTOMATION INDIA PRIVATE LIMITED',
    'DGTRONIX TECHNOLOGIES PRIVATE LIMITED',
    'BIRD AERO SERVICES PRIVATE LIMITED',
    'AGAMAHIL NATURAL PRODUCTS PRIVATE LIMITED',
    'PROSHISHA CONSULTANCY SERVICES PRIVATE LIMITED',
    'GAWVS PET CARE PRIVATE LIMITED',
    'FARMWORLD AGROTECH PRIVATE LIMITED',
    'HERAMBA SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'HMGR MEDIA PRIVATE LIMITED',
    'NEO HEALTHCARE SERVICES PRIVATE LIMITED',
    'LAMBA AUTOMOTIVE PRIVATE LIMITED',
    'FARMERS CITY INTERNATIONAL PRIVATE LIMITED',
    'SINAR INDAH PULP AND PAPER PRIVATE LIMITED',
    'KEQUIP GLOBAL LAB SOLUTIONS PRIVATE LIMITED',
    'LD IMPEX PRIVATE LIMITED',
    'DOUBLE ARROW CONSULTANCY PRIVATE LIMITED',
    'MAXIN INDIA MACHINERY MANUFACTURERS PRIVATE LIMITED',
    'MDS GLOBAL IT INDIA PRIVATE LIMITED',
    'SCRATCHNEST PRIVATE LIMITED',
    'LIVAAH INNOVATIONS PRIVATE LIMITED',
    'HEUGOR TECHNOLOGIES PRIVATE LIMITED',
    'LWV ENGINEERS PRIVATE LIMITED',
    'TRY MARINE SERVICES PRIVATE LIMITED',
    'PAYMARK PAYMENT TECHNOLOGIES & SERVICES PRIVATE LIMITED',
    'SVITCH ENERGY PRIVATE LIMITED',
    'SASMA ETHANOL INDIA PRIVATE LIMITED',
    'AYCON GRAPH CONNECT PRIVATE LIMITED',
    'STIBO SYSTEMS INDIA PRIVATE LIMITED',
    'VIGALIFE BIOPHARMA PRIVATE LIMITED',
    'URMI SURFACE COATING PRIVATE LIMITED',
    'RDVAULT INDIA PRIVATE LIMITED',
    'MARUCART BUSINESS SERVICES PRIVATE LIMITED',
    'MUNCHBOX FROZEN FOODS PRIVATE LIMITED',
    'RAMTON TECHNOLOGIES PRIVATE LIMITED',
    'THRIVETRIBE WELLNESS SOLUTIONS PRIVATE LIMITED',
    'ITW MEDIAMARKET PLACE INDIA PRIVATE LIMITED',
    'QUERENCIA MEDITECH INDIA PRIVATE LIMITED',
    'RAPIDION WATER PRIVATE LIMITED',
    'ZAGRO PREMIER INDIA PRIVATE LIMITED',
    'JMGI ABRASIVES INDIA PRIVATE LIMITED',
    'TOWER360 INDIA PRIVATE LIMITED',
    'BEYONDID MANAGED SERVICES INDIA PRIVATE LIMITED',
    'BIO CRAFT INNOVATION PRIVATE LIMITED',
    'CODEVOLUTION IT SERVICES PRIVATE LIMITED',
    'HYDROSPEAR TECHNOLOGIES PRIVATE LIMITED',
    'OCELL SOLUTION PRIVATE LIMITED',
    'EMOBI MANUFACTURY PRIVATE LIMITED',
    'PADMAJA MOTORS PRIVATE LIMITED',
    'AMARDEEP LIFE SCIENCES PRIVATE LIMITED',
    'AGNIT SEMICONDUCTORS PRIVATE LIMITED',
    'JALEBE INDIA PRIVATE LIMITED',
    'WORTHYNETWORK (OPC) PRIVATE LIMITED',
    'FAMN PHARMA PRIVATE LIMITED',
    'PRAELLA PRIVATE LIMITED',
    'ALICO INDIA SOLUTIONS PRIVATE LIMITED',
    'INTERACTIVE LABS PRIVATE LIMITED',
    'PIXBROADCAST TECHNOLOGY PRIVATE LIMITED',
    'QUANSCENDENCE TECHNOLOGIES PRIVATE LIMITED',
    'CONFLUENT INDIA PRIVATE LIMITED',
    'AMZSYS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'ACCOUNTRUST BUSINESS ADVISORS PRIVATE LIMITED',
    'JUNTRAX SOLUTIONS PRIVATE LIMITED',
    'ECO ANIMAL HEALTH INDIA PRIVATE LIMITED',
    'VEEPHOENIX COMPLIANCE PRIVATE LIMITED',
    'KARNATAKA TUFFTRIDERS TECHNIQUES SURFACES PRIVATE LIMITED',
    'GLOBEWEL HOLIDAYS INDIA PRIVATE LIMITED',
    'MKURIZON HEALTHCARE PRIVATE LIMITED',
    'ELEVAR TECHNOLOGIES PRIVATE LIMITED',
    'HAPPYFEST SOLUTIONS PRIVATE LIMITED',
    'SHREEMIX CONCRETE INDIA PRIVATE LIMITED',
    'OUTSIZED INDIA PRIVATE LIMITED',
    'GROUP247 WORLDWIDE (INDIA) PRIVATE LIMITED',
    'PROSPEROWARE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SHARP GLOBAL FREIGHT PRIVATE LIMITED',
    'ENTERSPACE DESIGNLAB PRIVATE LIMITED',
    'MODEL RETAIL INDIA PRIVATE LIMITED',
    'GIVEBACK FOUNDATION',
    'ISHWARBHAI & BHOGIBHAI AJMERA FOUNDATION',
    'DREAMCRAFT EVENTS AND ENTERTAINMENT PRIVATE LIMITED',
    'AZDA PROPERTIES PRIVATE LIMITED',
    'CH DIGITAL HR PRIVATE LIMITED',
    'FIRSTCRED ADVISORY PRIVATE LIMITED',
    'DOS TO CLOUD SOLUTIONS PRIVATE LIMITED',
    'LIMITZONE MICRO EXHIBITIONS PRIVATE LIMITED',
    'PADMAKARMA PRIVATE LIMITED',
    'CANDOUR AUTOMATION TECHNIK PRIVATE LIMITED',
    'COCKETT MARINE OIL TRADING PRIVATE LIMITED',
    'GELATO PRINT SERVICES INDIA PRIVATE LIMITED',
    'MCANVAS ADVERTISING PRIVATE LIMITED',
    'MARQUE ARTISANS PRIVATE LIMITED',
    'BQS INDIA PRIVATE LIMITED',
    'DAYTONA SYSTEMS (INDIA) PRIVATE LIMITED',
    'CG ENTERTAINMENT AND PARKS PRIVATE LIMITED',
    'AIMSTOTAL FACILITY MANAGEMENT SERVICES PRIVATE LIMITED',
    'BNSE DESIGN SOLUTIONS PRIVATE LIMITED',
    'COLOP STAMPS INDIA PRIVATE LIMITED',
    'RCOEM TECHNOLOGY BUSINESS INCUBATORS FOUNDATION',
    'JNPT ANTWERP PORT TRAINING AND CONSULTANCY FOUNDATION',
    'FOSS UNITED FOUNDATION',
    'GREEN HOUSE ENGINEERING SERVICES PRIVATELIMITED',
    'INTULLECT SPRINTATHON INCUBATIONS PRIVATE LIMITED',
    'IMW THE AGENCY WORLDWIDE PRIVATE LIMITED',
    'ITRAVELEO PRIVATE LIMITED',
    'PRICING INNOVATIONS SOLUTIONS PRIVATE LIMITED',
    'JARS FOOD NETWORK PRIVATE LIMITED',
    'Taurus logistics and transport private limited',
    'Thank you logistics limited',
    'ABHINAV LOGISTICS PRIVATE LIMITED',
    'Sweety logistics private limited',
    'Moon light shipping services private limited',
    'Pearl integrated logistics private limited',
    'Baapni global logistics private limited',
    'Sakthifinance holdings limited',
    'Moongipa roadways pvt ltd',
    'Abhiyan logistics private limited',
    'Greyhound movers private limited',
    'Seaship logistics private limited',
    'Speed air logistic private limited',
    'Vishal courier services private limited',
    'VODAFONE IDEA TELECOM INFRASTRUCTURE LIMITED',
    'Eurostar (india) private limited',
    'Scope telecom private limited',
    'TATA TELE NXTGEN SOLUTIONS LIMITED',
    'Afforda technology private limited',
    'Laburnum finance limited',
    'Trimble navigation india private limited',
    'Bangalore datacom private limited',
    'Vas com tech limited',
    'PROCALL INFRA & UTILITIES PRIVATE LIMITED',
    'Voicecloud technologies private limited',
    'Lantro technologies india private limited',
    'Cristaline tele services private limited',
    'Nextgen telesolutions private limited',
    'Good media news private limited',
    'Reachnet cable services private limited',
    'MSN CHANDAR HOLDINGS & INVESTMENTS PRIVATE LIMITED',
    'Fahrenheit financial services private limited',
    'Acme (india) marketing & services private limited',
    'Sage capital funds management private limited',
    'Duruva finance private limited',
    'Sridhar finvest limited',
    'Trust team investors limited',
    'M a g k s financial consultants private limited',
    'UTTAM SUCROTECH INTERNATIONAL PRIVATE LIMITED',
    'Halan properties private limited',
    'PACIFIC PEARL FINANCE AND LEASING PRIVATE LIMITED',
    'JAGMOHAN MOTORS PRIVATE LIMITED',
    'Vij investments private limited',
    'Maiden tradefin private limited',
    'NJT FINANCE PRIVATE LIMITED',
    'Vishant leasing private limited',
    'Shree shyamkamal finance and leasing company private limited',
    'Prr finance pvt ltd',
    'Kapur leafin pvt. ltd',
    'AJMER FINLEASE AND INSURANCE AGENCIES PRIVATE LIMITED',
    'Sushil leafin private limited',
    'Bharat trade & finance private limited',
    'Damani estates and finance pvt ltd',
    'Beyant holding & finance limited',
    'Zyfax systems (bangalore) private limited',
    'ART FINANCE (INDIA) PRIVATE LIMITED',
    'Commercial motors (dehradun) private limited',
    'Grace (india) ltd',
    'Ranks fiscals pvt ltd',
    'Prempushp estate pvt. ltd.',
    'Natasha housing and urban development limited',
    'Mega housing & finance private limited',
    'Sanmati corporate investments private limited',
    'Amin motors private limited',
    'Finbiz crossborder consulting private limited',
    'Levoc finance private limited',
    'Abhik finance private limited',
    'Yamuna portfolio private limited',
    'Poonam realtors limited',
    'Pioneer fundinvest private limited',
    'Bhagmal investments pvt ltd',
    'Silvassa fibres private limited',
    'Benjo holdings pvt ltd',
    'Pankaj k mehta investment pvt ltd',
    'Time capital limited',
    'Neelhari holdings private limited',
    'India capitol resource services private limited',
    'Primus investments and finance private limited',
    'Gada marketing private limited',
    'Imperial finvest services (india) private limited',
    'Kavita stockbrokers private limited',
    'Singular finance and investment private limited',
    'Sas chits private limited',
    'PARK LLOYD MARKETING PRIVATE LIMITED',
    'Bgr investment holdings company limited',
    'Itc infotech india limited',
    'Digital hub india private limited',
    'Sevak chits private limited',
    'Steel strips holdings private limited',
    'Lumax finance private limited',
    'PEGASUS ASSOCIATES (I) PRIVATE LIMITED',
    'H d investment company (a private company with unlimited liability).',
    'Mahendra fin-stock limited',
    'Ajshah enterprise private limited',
    'L&T MUTUAL FUND TRUSTEE LIMITED',
    'Suyog investors pvt ltd',
    'Sujala investments private limited',
    'Yield 4 finance private limited',
    'Link fintech private limited',
    'Virmani consultants private limited',
    'Stellar search and selection private limited',
    'Mis outsourcing private limited',
    'Spenta process management services private limited',
    'G s computer consultancy private limited',
    'Roedl & partner india private limited',
    'One 97 communications india limited',
    'Sundeep electricals private limited',
    'Blackbelt smartphone security private limited',
    'Evergreen house keeping services private limited',
    'Xbrl services private limited',
    'Taxbulls india private limited',
    'Decisive solutions consulting private limited',
    'Pas consultants private limited',
    'Risalas sentinals private limited',
    'Xroad solutions private limited',
    'APEX SUPPLY CHAIN PRIVATE LIMITED',
    'Id insight india private limited',
    'Almondz global infra-consultant limited',
    'Leonine talent management private limited',
    'DR CABLE DIAGNOSTICS PRIVATE LIMITED',
    'Relisec consultancy services private limited',
    'DARSH OPTIMA PRIVATE LIMITED',
    'Dsfs advisory services private limited',
    'Ace testing solutions private limited',
    'Turning point studies consultants private limited',
    'Equitrax corporate ventures private limited',
    'Pragya solutions for sustainable development private limited',
    'Saicon systems private limited',
    'Go parties india private limited',
    'P d s logistics international private limited',
    'Meher enterprises private limited',
    'Integrated quality certification private limited',
    'SCULPTOR MANAGEMENT INDIA PRIVATE LIMITED',
    'Adventure recruitment india private limited',
    'Talent mappers consulting india private limited',
    'Anzy careers private limited',
    'Modarchs consultants india pvt ltd',
    'Mycard consultancy and bpo solutions private limited',
    'Leap tax and management consultants private limited',
    'J p mukherjiand associates private limited',
    'Sijcon consultants private limited',
    'R j consultants private limited',
    'Forbaco systems and computer services pvt ltd',
    'Strategic capital corporation private limited',
    'Jmd corporate services private limited',
    'Dun & bradstreet information services india private limited',
    'Growell consultants private limited',
    'Bric designs private limited',
    'Thirdwave realty advisors private limited',
    'Capnine funds management private limited',
    'Consult sams private limited',
    'Vishwakarma global education services private limited',
    'AIPL SYSTEMS PRIVATE LIMITED',
    'Vision education and management services private limited',
    'ODIS WATER PURIFICATION INDIA PRIVATE LIMITED',
    'Rajasthan technoconsultants private limited',
    'LEARNNOVATORS PRIVATE LIMITED',
    'I-manage consulting india private limited',
    'Felicity solutions private limited',
    'Eurostar consultants private limited',
    'MXQ INDIA PRIVATE LIMITED',
    'Dwarakha consulting services private limited',
    'Irmat consulting private limited',
    'DRS SPHERE PRIVATE LIMITED',
    'RKP FINANCE PRIVATE LIMITED',
    'Nischinta advisory services pvt. ltd.',
    'Mpa financial services private limited',
    'Tarush management private limited',
    'Inflexion management services pvt ltd',
    'Choudhary advisory services private limited',
    'Kredent capital private limited',
    'Manikaran finvest consultancy services limited',
    'Tewari warehousing company private limited',
    'MOORE SINGHI CONSULTANTS PRIVATE LIMITED',
    'Barasat management private limited',
    'Ips engineering consultants private limited',
    'Techworks engineering private limited',
    'Titanium engineering private limited',
    'Helifix (india) private limited',
    'Universal pride interiors private limited',
    'Och-ziff real estate india private limited',
    'International register of shipping services private limited',
    'THYSSENKRUPP UHDE INDIA PRIVATE LIMITED',
    'Kraftwerk engineers private limited',
    'Mecpro heavy engineering limited',
    'Uop india private limited',
    'Uni-tech engineering private limited',
    'VAPI GREEN ENVIRO LIMITED',
    'Manglam engineers (india) private limited',
    'PRIMUS LIVING SPACE PRIVATE LIMITED',
    'Vastushilpalaya consultancy private limited',
    'Sona construction and metal industries private limited',
    'Occidental engineering private limited',
    'Chempro expertise private limited',
    'ARROWHEAD SEPERATION ENGINEERING LIMITED',
    'Trishul structurals private limited',
    'Beckett rankine india private limited',
    'Bobby mukherji architects private limited',
    'Ong & ong designs (india) private limited',
    'Dimensions architects private limited',
    'PLANTECH CONSULTANTS PRIVATE LIMITED',
    'Ashok biscuits and bakery products private limited',
    'Pan foods limited',
    'Goodrich carbohydrates limited',
    'Binsar farms private limited',
    'Soufflet malt india private limited',
    'S INDAGE RESTAURANTS PRIVATE LIMITED',
    'Pandyan automobiles private limited',
    'Anugrah commodities private limited',
    'Seatrans freight carriers private limited',
    'Apeetha enterprises private limited',
    'Gar pariwahan private limited',
    'Express roadmovers private limited',
    'Viking lighterage and cargo handlers private limited',
    'Transmart (india) private limited',
    'WOOD STORY PRIVATE LIMITED',
    'Rakhi transports private limited',
    'Damodar logistics private limited',
    'MARINE LOGISTICS & ENGINEERING PRIVATE LIMITED',
    'Atc logistics private limited',
    'Dasaprakash restaurant and ice cream parlour private limited',
    'Uvk caargo movers private limited',
    'VLINK INDIA PRIVATE LIMITED',
    'Rfid solutions & academy private limited',
    'Ampcus tech private limited',
    'Apn it experts private limited',
    'Softgains tech solutions private limited',
    'Ultimate infotech private limited',
    'Shivit technologies private limited',
    'Esign web services private limited',
    'Gtac solutions private limited',
    'Ans affiliate solutions private limited',
    'Worth studios private limited',
    'Grapta technologies private limited',
    'Dv pro technologies private limited',
    'Addabol infocom private limited',
    'Cognoscente invnted private limited',
    '3D SYSTEMS INDIA PRIVATE LIMITED',
    'Mekhia solutions private limited',
    'Fulcrum biometrics india private limited',
    'Excelsoft technologies private limited',
    'Datascribe infotech private limited',
    'Appistoki consulting services private limited',
    'Crosscode technologies private limited',
    'Cape comorian technologies private limited',
    'Suni systems private limited',
    'Solutionsinfoway support services private limited',
    'Netstager technologies private limited',
    'Sarvakala india private limited.',
    'Cyber peripherals private limited',
    'Expert global solutions private limited',
    'Suvidh commodities e com private limited',
    'Planetsaffron .com india private limited',
    'Computer etcetera india private limited',
    'Satcom info tech private limited',
    'Netsol network consultancy private limited',
    'D-vois ssv broadband private limited',
    'Trans continental e services private limited',
    'Westside it solutions private limited',
    'Rik technologies india private limited',
    'Rtcamp solutions private limited',
    'Kratee shopping solution private limited',
    'Orion esolutions private limited',
    'Cadtech engineering solutions private limited',
    'Teknovance solutions private limited',
    'New balance it services india private limited',
    'Spheregen software india private limited',
    'Vrhythms software private limited',
    'Opentech software systems private limited',
    'Sensible softwares private limited',
    'Iauro systems private limited',
    'CHANDRAPRABHU ENTERPRISE PRIVATE LIMITED',
    'ESALES TECHNOLOGIES PRIVATE LIMITED',
    'Yellow objects solutions private limited',
    'Plus 91 web solutions private limited',
    '7i systems private limited',
    'Nimble solutions private limited',
    'Kanwat infotech private limited',
    'Iservesoft geospatial private limited',
    'SPRETNOST SERVICES PRIVATE LIMITED',
    'Anna it services private limited',
    'General developers technologies private limited',
    'PARIPOORNA SOFTWARE PRIVATE LIMITED',
    'Microsense wireless private limited',
    'Footprint leisure private limited',
    'Terraspace eservices private limited',
    'Pojo software private limited',
    'NOMADIA INDIA PRIVATE LIMITED',
    'Tams technologies private limited',
    'Bs teknology private limited',
    'Roamsoft technologies private limited',
    'Buildingblocks software services private limited',
    'Tespa infotech private limited',
    'Akira consultancy private limited',
    'Purplecube technologies private limited',
    'Weuphoria technologies private limited',
    'Amsys solutions india private limited',
    'Mcc resources pvt. ltd.',
    'Knowledge infratech private limited',
    'Dynamic computronics private limited',
    'Mapps it services private limited',
    'Techwyse it solutions private limited',
    'Thought arbitrage research institute',
    'Ipe global centre for knowledge and development',
    'ENVIRO TECH VENTURES LIMITED',
    'Avesthagen limited',
    'Avesthagen research private limited',
    'Avesta nordic research private limited',
    'Avestagenome project international private limited',
    'Thanal conservation action information and trading network private limited',
    'Castalia research labs private limited',
    'Dwarikesh agriculture research institute',
    'Conquer research private limited',
    'Janatics research and development private limited',
    'Vantage research private limited',
    'Vin management consultants pvt ltd',
    'Dynamic it park developers private limited',
    'Teleone consumers product private limited',
    'Scan packaging private limited',
    'Blacksmith interiors private limited',
    'Smart bookkeeping services private limited',
    'Soochna technologies private limited',
    'ACG CARES FOUNDATION',
    'Hia exports limited',
    'Oxygen entertainment & media solutions private limited',
    'Genesis exports ltd',
    'Niraj cement structurals limited',
    'DECCAN CEMENTS LIMITED',
    'Mangalam cement ltd',
    'Vidarbha iron and steel corporation limited',
    'Remi process plant and machinery limited',
    'Jain irrigation systems limited',
    'Brady and morris engineering company limited',
    'Virat industries limited',
    'Vogue commercial company limited',
    'The indian card clothing company limited',
    'Webfil ltd',
    'Ushdev international limited',
    'HONDA INDIA POWER PRODUCTS LIMITED',
    'Ras resorts and apart hotels ltd',
    'Manor floatel ltd',
    'GMR AIRPORTS INFRASTRUCTURE LIMITED',
    'Simplex infrastructures limited',
    'Utkarsh trading and holdings limited',
    'Authum investment & infrastructure limited',
    'Raunaq EPC International Limited',
    'Akshat gases ltd',
    'Rane brake lining limited',
    'V l s finance limited',
    'Photon capital advisors limited',
    'Contil india limited',
    'B p investments ltd',
    'Aar shyam india investment company limited',
    'Ginni international ltd. (transfer from delhi to raj.)',
    'Aishwarya technologies and telecom limited',
    'The indian hotels company limited',
    'Solar industries india limited',
    'Lamina foundries limited',
    'Infosys limited',
    'Kanoria plaschem limited',
    'Ashima limited',
    'DEE DEE STEEL CASTINGS PRIVATE LIMITED',
    'Swetha engineering limited',
    'Shalini fertilisers ltd',
    'Natco pharma limited',
    'Pan drugs limited',
    'Electronic enamels and glasses pvt ltd',
    '20 microns limited',
    'Patel engineering limited',
    'Sme business services limited',
    'Cotton city plantations private limited',
    'Ananya agro tech private limited',
    'Promis industries limited',
    'Madhuraj marketing & technologies private limited',
    'GAURAV AWAS & ENGINEER PRIVATE LIMITED',
    'RATANAKAR WIRE PRIVATE LIMITED',
    'Deivam agro private limited',
    'Vanarai-vile plantation private limited',
    'Jainam agro and finance pvt ltd',
    'Kalyani agro corporation ltd',
    'Sakarwadi trading company private limited',
    'Cemax plants pvt ltd',
    'BIODEGRADABLE PRODUCTS INDIA LIMITED',
    'Walchand botanicals private limited',
    'Classic synergy india private limited',
    'Kpc plantations private limited',
    'G c l estates private limited',
    'Narayani hotels and resorts limited',
    'Oasis agritech limited',
    'Aroma spices pvt ltd',
    'PHOENIX SPACETECH DEVELOPERS PRIVATE LIMITED',
    'Poonawalla astonish stud private limited',
    'Aayna agrifarms private limited',
    'Deccan hybrid cultivations private limited',
    'Aviagen india poultry breeding company private limited',
    'Byul agriserve private limited',
    'Css grower systems private limited',
    'Kollam agro development private limited',
    'LIXIL INDIA SANITARYWARE PRIVATE LIMITED',
    'Green agro pack private limited',
    'BAIDYANATH HORTI.AGRO AND PLANTATIONS PRIVATE LIMITED',
    'Synergy agri products private limited',
    'Hira global marketing private limited',
    'VANDEWIELE-SAVIO INDIA PRIVATE LIMITED',
    'Ocean sparkle limited',
    'SONAL VYAPAR Private Limited',
    'Sundar ram enterprise private limited',
    'Matcon hicoats private limited',
    'Pfyl holdings private limited',
    'TRIPADA LEARNING SOLUTIONS PRIVATE LIMITED',
    'Siddheswari coal trading private limited',
    'Cape refineries private limited',
    'P K MININGS PRIVATE LIMITED',
    'Isha ores and exports private limited',
    'Solitaire minerals (india) private limited',
    'Vasundhara metal mining private limited',
    'Contrex private limited',
    'Trident mineral resources private limited',
    'Sunanda infra limited',
    'Max minerals private limited',
    'Bhoomi resources private limited',
    'RPK AGRO AND MINING PRIVATE LIMITED',
    'Kishore granites private limited',
    'Klhl mining & trading private limited',
    'Haritsons mintech private limited',
    'GODAWARI MINES AND MINERALS PRIVATE LIMITED',
    'Terra mine developers private limited',
    'Zen equip india private limited',
    'VISAGAN FINANCE & INVESTMENTS COMPANY PRIVATE LIMITED',
    'Euro gold mining india private limited',
    'Nandi mineral enterprises private limited',
    'Unimin claytech private limited',
    'Mod-tech electronics private limited',
    'Base electrical and electronic solutions private limited',
    'Modern electropower private limited',
    'OCELLI SYSTEMS PRIVATE LIMITED',
    'Gilbert and maxwell electricals pvt ltd',
    'SHIKARGAH PRIVATE LIMITED',
    'Parsram and company private limited',
    'Dol electric company pvt ltd',
    'LYCOS INDIA LIMITED',
    'Simply electrifying private limited',
    'Smruti cables private limited',
    'Variturn electro products pvt ltd',
    'Suvire electric private limited',
    'Nirmal insulations private limited',
    'MV ELECTROSYSTEMS LIMITED',
    'Orion accumulators private limited',
    'Indiana drives & engineering private limited',
    'Makaio equipment private limited',
    'Syscon metering solutions private limited',
    'Admire power engineers private limited',
    'ANUSIKA INDUSTRIES LIMITED',
    'Alliance controls private limited',
    'Isolant industrial insulation private limited',
    'Eps worldwide private limited',
    'Obara india private limited',
    'Alps electric (india) private limited',
    'JAY AIR COOLING PRIVATE LIMITED',
    'Eei india energy private limited',
    'Storm energy solutions private limited',
    'Samwha india energy savings private limited',
    'Leo electrods private limited',
    'OMEN ELECTRICAL & GAS APPLIANCES PRIVATE LIMITED',
    'Hydrotec solutions private limited',
    'CAPACITOR CONTROL PRIVATE LIMITED',
    'Systems tek india private limited',
    'Team infovision private limited',
    'Print electronics equipments pvt ltd',
    'Online micro controls private limited',
    'Jai balaji controlgears private limited',
    'Bloom competech pvt. ltd.',
    'Solid state electronics company private limited',
    'S n electronics private limited',
    'Powercap capacitors private limited',
    'Planet electronics private limited',
    'Span compressors private ltd',
    'Entraco power systems pvt. ltd.',
    'Connectwell impex private limited',
    'Aj fibertek india private limited',
    'Monalisa electronic design centre private limited',
    'Telenet systems private limited',
    'Sierra mobile communications private limited',
    'P n communication p. ltd.',
    'Wep solutions india limited',
    'Mobatime india private limited',
    'STEPHAN DESIGN & ENGINEERING LIMITED',
    'Arsanik healthcare private limited',
    'Hindustan chamber of commerce',
    'Hermes technologies private limited',
    'Manatec automations private limited',
    'Rolex watch company private limited',
    'Italica motors private limited',
    'Lele auto private limited',
    'Avk autolinks private limited',
    'Siddharth pressings (india) private limited',
    'Osl motocorp private limited',
    'Carenow medical private limited',
    'Lab links bio-tech private limited',
    'Boston scientific india private limited',
    'Hevea engineers private limited',
    'Munjal kiriu industries private limited',
    'Sunder cranes private limited',
    'Track components limited',
    'Ntn nei manufacturing india private limited',
    'MARELLI TALBROS CHASSIS SYSTEMS PRIVATE LIMITED',
    'At india auto parts private limited',
    'JAYA HIND MECHANICS LIMITED',
    'Nitesh auto engineering private limited',
    'Mahabal auto ancillaries private limited',
    'Alandi forge private limited',
    'Shirodkar preci comp private limited',
    'Highlight automotive products private limited',
    'Karison profiles private limited',
    'Mudhra fine blanc private limited',
    'The gounder and company auto limited',
    'Bandekar brothers private limited',
    'Amona shipyard private limited',
    'Hero transmission private limited',
    'New world power technology private limited',
    'ROWTH TECH LIMITED',
    'Amalgamations repco limited',
    'Laxmi freight carriers private limited',
    'Ashoka brothers sanitation india private limited',
    'Newel packaging private limited',
    'Work space solutions india private limited',
    'Craft modular system private limited',
    'Ntl lemnis india private limited',
    'Sensazione leisure pvt ltd',
    'Oma living private limited',
    'Carbon rotofluid private limited',
    'Creative home craft network private limited',
    'Scorpia india medicare private limited',
    'Magal healthcare private limited',
    'Vetril electronics private limited',
    'Mg mobiles india private limited',
    'Ybr music publishing private limited',
    'Booster distributors private limited',
    'DYNAMICS FINER INFOSOLUTION PRIVATE LIMITED',
    'Magnum dealcomm pvt ltd',
    'Joy syndicate & enclave private limited',
    'Jagmata barter private limited',
    'Sipra suppliers private limited',
    'Naitik vinimay private limited',
    'Stewart & mackertich commodities limited',
    'Manor dealcom private limited',
    'Fetlock traders private limited',
    'Sea hawk overseas private limited',
    'Auraine botanicals private limited',
    'PROFSERV BPO AND CONSULTANCY PRIVATE LIMITED',
    'Tulsidas khimji multitrade private limited',
    'Vantage commercials private limited',
    'Parvati merchandise private limited',
    'Ratnapriya tracom private limited',
    'ROCKPECKER PRIVATE LIMITED',
    'House of laptops (india) private limited',
    'Strapsandstrings.com fashions private limited',
    'Retail junction private limited',
    'Lulu convention and exhibition center private limited',
    'Surchem mv chemicals private limited',
    'LERICA INTERNATIONAL PRIVATE LIMITED',
    'MARRI RETAIL PRIVATE LIMITED',
    'Lakshman sruthi musicals private limited',
    'Hera impex private limited',
    'Reliance sales pvt ltd',
    'Express dealtrade private limited',
    'Jagdish commotrade private limited',
    'Nageshwar vintrade private limited',
    'Petel dealers limited',
    'Aiglet suppliers private limited',
    'S p meditech private limited',
    'D. r. products private limited',
    'Vijayalaxmi sarees private limited',
    'Rmkv silks private limited',
    'Sree vijayalakshmi silks india private limited',
    'Glass & wall expressions india private limited',
    'BIO BEAUTY PRIVATE LIMITED',
    'Cs trade link private limited',
    'Premio commercial limited',
    'Aster dealcom private limited',
    'Paramahansa technologies limited',
    'CREATIVE NEWTECH LIMITED',
    'Tempus gems private limited',
    'OVEL IMPEX PRIVATE LIMITED',
    'Danin enterprises private limited',
    'Gopaisa netventures private limited',
    'R.g. merchants private limited',
    'New winco impex private limited',
    'Shivasakthi marketing private limited',
    'Harmuny entertainment private limited',
    'Avi additives private limited',
    'Renee enterprises private limited',
    'Puresouth hospitality private limited',
    'Link commercial private limited',
    'Swaad mantra hotels and restaurants private limited',
    'Prism vincom private limited',
    'G2 rams india private limited',
    'Parampara hospitality private limited',
    'Sakura hotels and resorts private limited',
    'Dakshaa hospitality private limited',
    'Dakshaa suits and inn private limited',
    'Vb hospitality private limited',
    'Subhbijay tradelink private limited',
    'Arpan vintrade private limited',
    'Best pumps india private limited',
    'Ganganpati mercantiles private limited',
    'Dhanlaxmi dealtrade private limited',
    'Rmkv fabrics private limited',
    'Ansh vinimay private limited',
    'Narita hotels private limited',
    'Kronos pharmaceutical private limited',
    'Bakshi hotels pvt ltd',
    'Sri raghavendra hotel enterprises private limited',
    'Premier max supermarkets private limited',
    'Benair airconditioning company private limited',
    'Hitech dealmark private limited',
    'Basant coal and coke private limited',
    'Vd lifestyle private limited',
    'Prodecorhomes solutions private limited',
    'Switrus holidays private limited',
    'Talera hoteliers pvt ltd',
    'Evershine hotels pvt ltd',
    'Golden falcon hotels (india) private limited',
    'Velvett hotels private limited',
    'Grand eyewear marketing private limited',
    'CHARMS RESTAURANTS PRIVATE LIMITED',
    'A and a hotels private limited',
    'Accauto marketing pvt. ltd.',
    'Mukundah commosales private limited',
    'Benjamin commercial private limited',
    'Hamsa bar and restaurant private limited',
    'Shor sharaba food inn private limited',
    'GREENEARTH ORGANIC PRODUCTS PRIVATE LIMITED',
    'Shanthi woodland hotel and beach resort pvt ltd',
    'Lulu flight kitchen private limited',
    'Grafikon hospitality private limited',
    'Jhankar motels private limited',
    'Pristine residency private limited',
    'Sentini hotels and resorts private limited',
    'TINKAS INDUSTRIES PRIVATE LIMITED',
    'Emgee realty & hospitality private limited',
    'Satyaratan hospitality private limited',
    'G b j hotels private limited',
    'Apport buildwell private limited',
    'Alokin software private limited',
    'Chakra consultancy private limited',
    'Intsemi technologies private limited',
    'Versa networks india private limited',
    'Enterprise application framework solutions private limited',
    'I base software solutions (india) private limited',
    'Neo prism analtical solutions india private limited',
    'Credibase technologies private limited',
    'APEX ENGINEERS (INDIA) PRIVATE LIMITED',
    'Sysvine technologies private limited',
    'Adhi software private limited',
    'Exim alert software solutions private limited',
    'Interlace india private limited',
    'Sapotech solutions private limited',
    'Sree harshi infoway private limited',
    'Inspire infosol private limited',
    'VIDCENTUM TECHNOLOGIES PRIVATE LIMITED',
    'Soltek software private limited',
    'Zeazonz technologies private limited',
    'Trinitymascot consultancy services private limited',
    'Modallogic it systems private limited',
    'Entellisoft technologies india private limited',
    'Grover infotech private limited',
    'Adhar technologies private limited',
    'Qubesys technologies private limited',
    'Ultimate digital solutions private limited',
    'Katcom international private limited',
    'Mounthill designs private limited',
    'KOSMIC REALTORS PRIVATE LIMITED',
    'KOSMIC ESTATE PRIVATE LIMITED',
    'Insec technologies private limited',
    'Np2 technologies & software solutions private limited',
    'Starent networks (india) private limited',
    'Symphony technologies private limited',
    'Virinchi learning private limited',
    'Tns networking solutions private limited.',
    'Aurum infotech private limited',
    'Surya jyoti software private limited',
    'Kaiinos geospatial technologies private limited',
    'Net net biz private limited',
    'Alkof marketing private limited',
    'Curian software services private limited',
    'Saberpoint e-services private limited',
    'Com- 1 communication technologies private limited',
    'Techmonist software private limited',
    'Aayathi software private limited',
    'Smart reports technologies private limited',
    'Lakshith consulting private limited',
    'E care india private limited',
    'Agate infotek private limited',
    'J technologies india limited',
    'Hirotec india private limited',
    'Systel energy solutions private limited',
    'D j software consultancy private limited',
    'OODU IMPLEMENTERS PRIVATE LIMITED',
    'Innervex technologies private limited',
    'Atlas software technologies (india) private limited',
    'Conacent consulting private limited',
    'Suryanarayan hitech private limited',
    'Creative mediapulse technologies private limited',
    'Etutorworld learning solutions private limited',
    'Snk software services private limited',
    'S2net infotech solutions private limited',
    'Damco soft private limited',
    'Grafica design solutions private limited',
    'Mantas india private limited',
    'Cyber webtown private limited',
    'Jeevansathi internet services private limited',
    'Arcis e services private limited.',
    'Fujisawa software technologies private limited',
    'Samyak metals private limited',
    'Iscent e-services private limited',
    'Sterling infoways private limited',
    'Saxo india private limited',
    'Plus91 technologies private limited',
    'Microtech software private limited',
    'Alakananda information technology private limited',
    'Rapido infotech private limited',
    'Spectra outsource solutions private limited',
    'Volition infotech private limited',
    'Adnet infotech private limited',
    'Ivory solutions private limited',
    'Md synergy india private limited.',
    'Avid web solutions private limited',
    'Atlas outsourcing private limited',
    'BRAINYBATCH INTERNET PRIVATE LIMITED',
    'Tag on digital private limited',
    'Concept infoway private limited',
    'Team tranquil software solutions private limited',
    'True sparrow systems private limited',
    'Peach technovations private limited',
    'Celtic systems private limited',
    'TECHROUTES NETWORK PRIVATE LIMITED',
    'Novelvox softwares india private limited',
    'Digione technologies private limited',
    'Krea eknowledge private limited',
    'NATOBOTICS TECHNOLOGIES PRIVATE LIMITED',
    'Psiog digital private limited',
    'Tiramisu new media solutions private limited',
    'Evora it solutions private limited',
    'Niranta solutions and services private limited',
    'Usam cadsoft (india) private limited',
    'FRISCHMANN PRABHU INDIA DESIGN SERVICES PRIVATE LIMITED',
    'Last peak solutions private limited',
    'SHODHARAMBH RESEARCH AND DEVELOPMENT FOUNDATION',
    'Hnn broadcasting private limited',
    'PRAKASH ROADLINES PRIVATE LIMITED',
    'Bpl techno vision private limited',
    'Aashka infocom private limited',
    'Concepts iconnect private limited',
    'Navratna ahmedabad golf infrastructure private limited',
    'Karishma media creations private limited',
    'Rvr presents event services private limited',
    'GALAXY CARE MULTISPECIALITY HOSPITAL PRIVATE LIMITED',
    'Vsv printographics private limited',
    'Enable technologies private limited',
    'Samikaran learning private limited',
    'Happy science india association',
    'Apollo hospitals international limited',
    'Tci institute of logistics',
    'Huma specialists hospital & research centre private limited',
    'BLITCO IT SOLUTIONS PRIVATE LIMITED',
    'Spas of india association',
    'Dp hydrocarbon services private limited',
    'Shreeji welfare association',
    'Jupiter welfare association',
    'Loksahay welfare association',
    'Organic link association',
    'Senscape architects private limited',
    'Virinchi media and entertainment private limited',
    'Sukhi traders private limited',
    'Mahesh graphic productions private limited',
    'Traditions event management & marketing private limited',
    'XEME PROPERTIES AND DEVELOPERS PRIVATE LIMITED',
    'IKIGAI ENTERPRISES PRIVATE LIMITED',
    'Sonodyne television co limited',
    'Benchmark professional services private limited',
    'Aarthik no-middleman online welfare foundation',
    'Zenith dance institute private limited',
    'JDJ BUILDERS & DEVELOPERS PRIVATE LIMITED',
    'Karne hospitals pvt ltd',
    'Novel spent acid management',
    'Texzone information services private limited',
    'Montana shipping and chartering private limited',
    'Aquasail distribution company private limited',
    'Frontline hr solutions limited',
    'Ntrust insurance broking services private limited',
    'Madras christian college',
    'Tvs motor harita employees welfare foundation private limited',
    'Super transports private limited',
    'Energy plus power services private limited',
    'Aftaab solar private limited',
    'Crown hospital private limited',
    'The andragogy consulting house private limited',
    'Serona health private limited',
    'Global road safety academy private limited',
    'Umasree texplast private limited',
    'Elliot waud and hill private limited',
    'Apex clinic private limited',
    'DR. CHIRANJIV CHHABRA SKIN & WELLNESS CENTRE PRIVATE LIMITED',
    'Redwoods hospitality private limited',
    'Gila laboratories private limited',
    'Headhuntersinc consultancy private limited',
    'Altios consulting private limited',
    'Motorsports association of india',
    'Nicco parks leisure projects private limited',
    'Original entertainment private limited',
    'New avenue workforce private limited',
    'Saksham fabrication private limited',
    'West coast engineering works private limited',
    'Nevitad distillers private limited',
    'Onion insights private limited',
    'Acknit industries limited',
    'Stanes amalgamated estates limited',
    'Avt natural products limited',
    'Mount shivalik industries limited',
    'Patspin india ltd',
    'Jk paper limited',
    'Orient paper and industries ltd.',
    'Agio paper & industries limited',
    'Tata consultancy services limited',
    'Orient press limited',
    'Bodal chemicals limited',
    'Aksharchem (india ) limited',
    'DMCC SPECIALITY CHEMICALS LIMITED',
    'Kothari industrial corporation limited',
    'Daikaffil chemicals india limited',
    'Kesar enterprises limited',
    'Jenburkt pharmaceuticals ltd',
    'Bdh industries limited',
    'Triochem products limited',
    'Apollo tyres limited.',
    'Andhra cements limited',
    'Ramco industries limited',
    'Bhagwati autocast limited',
    'Welspun corp limited',
    'Tata steel limited',
    'Gandhi special tubes limited',
    'Century extrusions ltd',
    'Castron technologies ltd',
    'SEMAC CONSULTANTS LIMITED',
    'Bharat gears limited',
    'JOHNSON CONTROLS-HITACHI AIR CONDITIONING INDIA LIMITED',
    'Autopal industries limited',
    'Ipf security solutions private limited',
    'Accurate analysers pvt ltd',
    'Guddi plastcon private limited',
    'Mokalsar stone private limited',
    'New era india consultancy private limited',
    'Dolly farms and resorts private limited',
    'R k control instruments private limited',
    'Electronica hitech engineering private limited',
    'Gee ess precision engineering private limited',
    'Ring forgings private limited',
    'Scoda tubes limited',
    'E & h precision india private limited',
    'Shakunt enterprises private limited',
    'Dymes engineers pvt. ltd.',
    'CAPITAL POWER INFRASTRUCTURE PRIVATE LIMITED',
    'Mge graphic systems india private limited',
    'Glidepath india private limited',
    'Shivam precitech toolrooms private limited',
    'Traverse infra private limited',
    'Jcf fluid flow india private limited',
    'Fabtool india private limited',
    'Sgs frangible towers private limited',
    'Ts transalt private limited',
    'Shanirajeshwar die casting private limited',
    'Sri ambay equipments private limited',
    'Kanhaiya lal tandoor private limited',
    'MECHMAARK FILTECH INDIA PRIVATE LIMITED',
    'TEMSONN VESELEX INDIA PRIVATE LIMITED',
    'Millenium packaging machines private limited',
    'Torishima pumps (india) private limited',
    'Bhagya components private limited',
    'Lalit seven seas private limited',
    'Lalit rohr fittings private limited',
    'Spirax-sarco india private limited',
    'Dharmik steels private limited',
    'EJOT-OCTAQON FASTENING SYSTEMS PRIVATE LIMITED',
    'Precise technofab india private limited',
    'Saisidha sugar equipments and engineering company private limited',
    'P & b manufacturing private limited',
    'Av wires private limited',
    'Taurus value steel & pipes private limited',
    'C p fluid systems private limited',
    'Bioworth india pvt ltd',
    'Tatsuno india private limited',
    'Abf engineering international private limited',
    'HINDUSTAN RADIATORS AND HEAT EXCHANGERS PRIVATE LIMITED',
    'Feather flow control systems private limited',
    'Whitefield equipments private limited',
    'Everest and sant engineers private limited',
    'Efe engineers pvt ltd',
    'Simply 23 aircon private limited',
    'Standuel pvt ltd',
    'Hero motors limited',
    'Rosendahl nextrom india private limited',
    'Xenocor pharmalab private limited',
    'Spiromag gear systems private limited',
    'Krupa oil field supplies and services private limited',
    'Whalburg fire detection private limited',
    'Swelect electronics private limited',
    'Pulse solar systems private limited',
    'El-o-matic (india) private limited',
    'Lubin engineering (india) private limited',
    'Pretech automation private limited',
    'Ultra corpotech private limited',
    'Orion drives & machines private limited',
    'Konzert technologies private limited',
    'Ab micro machines pvt ltd',
    'Goldtech scales and systems private limited',
    'Wei-pack engineering private limited',
    'AALIDHRA INFRA PRIVATE LIMITED',
    'Oxeeco technologies private limited',
    'G. s. agrotech private limited',
    'Kubota agricultural machinery india private limited',
    'Hetran india private limited',
    'Abr cooling towers private limited',
    'Equinox solar private limited',
    'Clover solar private limited',
    'U s g energy private limited',
    'Agharia electricals private limited',
    'Senapathy whiteley private limited',
    'Superior machining solutions private limited',
    'Epsilon electronic equipment and components private limited',
    'Speck systems ltd',
    'Sb ecommerce solutions private limited',
    'Multilink systems private limited',
    'Hiral tektronix private limited',
    'Hasti india ltd.',
    'CLEAR EDGE FILTRATION INDIA PRIVATE LIMITED',
    'Fabrimech engineers private limited',
    'Simpletec equipments private limited',
    'Arshan systech private limited',
    'Nimbus computer private limited',
    'Datacon systems pvt ltd',
    'INFOCON INTERNATIONAL PRIVATE LIMITED',
    'HARTEK POWER PRIVATE LIMITED',
    'Anil pumps private limited',
    'Posco-poggenamp electrical steel private limited',
    'Powertel india private limited',
    'Awt technologies private limited',
    'Aahan engineers private limited',
    'Patil electric works private limited',
    'Ingenium electronics private limited',
    'AIR CONTROL AND CHEMICAL ENGINEERING COMPANY LIMITED',
    'LA DIVA INTERNATIONAL LIGHTING PRIVATE LIMITED',
    'Reckers control (india) private limited',
    'Gmr energy trading limited',
    'Ess ess kay engineering company private limited',
    'Udey pyrocables private limited',
    'Polaris cables and wires pvt ltd',
    'Goodluck wire and resins private limited',
    'Ziva impex private limited',
    'TRANSPORT ENGINEERING SOLUTIONS INDIA PRIVATE LIMITED',
    'S i sales promotions private limited',
    'Vaj exports p ltd',
    'Jerry varghese international limited',
    'Itochu india private limited',
    'G.jawahar enterprises private limited',
    'The waxpol industries ltd',
    'NIPHA EXPORTS PRIVATE LIMITED',
    'B m a trade & holdings pvt ltd',
    'Walchand great achievers private limited',
    'Purotech sales pvt ltd',
    'Sun tan trading company limited',
    'Compete tools private limited',
    'Ykiki tradvest private limited',
    'Vishwas techsol private limited',
    'SKYFILL CONSULTANTS PRIVATE LIMITED',
    'Poojit commercial pvt ltd',
    'Senapathy-symons insulations private limited',
    'Pasari marketing private limited',
    'Snowgold mercantile company private limited',
    'Morries trading private limited',
    'GOLDEN SANDS INVESTMENT PRIVATE LIMITED',
    'SILVER TURF INVESTMENT PRIVATE LIMITED',
    'Hotbrands india private limited',
    'Swissline intertrade private limited',
    'FLOWERS & FRAGRANCES PRIVATE LIMITED',
    'Rnmn techno steels trading private limited',
    'B r vyapaar private limited',
    'Ip-commercial private limited',
    'CORPWORLD VENTURES PRIVATE LIMITED',
    'SRSA RETAIL PRIVATE LIMITED',
    'Success suppliers private limited',
    'Wonga traders private limited',
    'Goodwill dealcomm private limited',
    'Laxmidhan mercantile private limited',
    'Sarvottam vincom private limited',
    'Onnet global private limited',
    'Panchmukhi dealtrade private limited',
    'MILI MAINTENANCE AND CARE PRIVATE LIMITED',
    'Psa tradeconnect private limited',
    'FORTIVE INDIA PRIVATE LIMITED',
    'AVIS TIE-UP PRIVATE LIMITED',
    'Aryadeep commotrade private limited',
    'RATNASAGAR ESTATES PRIVATE LIMITED',
    'Primus intertea trade private limited',
    'Ventron fincom pvt ltd',
    'Albright tracom private limited',
    'Ag infrastructure private limited',
    'A & S CONSTRUCTION EQUIPMENT PRIVATE LIMITED',
    'Effective marketing private limited',
    'SR ASSET ADVISORY PRIVATE LIMITED',
    'Hng retail private limited',
    'Tirukuta marketing services private limited',
    'Lsb jute traders private limited',
    'Anamika commercial private limited',
    'Kerneos india aluminate private limited',
    'Tiger vanijya private limited',
    'Magnesita refractories private limited',
    'Subhvani tradelinks private limited',
    'Splendid hi-technologies private limited',
    'Vlcc personal care limited',
    'Elan professional appliances private limited',
    'Bishak pharma private limited',
    'Saigrace trading private limited',
    'Slk progressive veneer private limited',
    'Mayur tie-up private limited',
    'Chandrima trexim pvt. ltd.',
    'Sahasradhara energy private limited',
    'Splen mercantiles pvt. ltd.',
    'Vantage brands private limited',
    'Essence technology automation india private limited',
    'Gadgetwood eservices private limited',
    'Viksit tie-up private limited',
    'Adya-o-ananta enterprise pvt ltd',
    'Sreenex machines private limited',
    'Kinerk direct marketing solutions private limited',
    'Live line marketing services pvt ltd',
    'Hermes financers private limited',
    'Jb emporium india private limited',
    'Trisa retail limited',
    'Mandhan automobiles company pvt ltd',
    'Siriyari tradecom pvt.ltd.',
    'Synergy electro trade private limited',
    'MY PHYGITAL CAFE PRIVATE LIMITED',
    'MANAS INNOVATIONS PRIVATE LIMITED',
    'Id gourmet india private limited',
    'Jdm commercial private limited',
    'Fosbel india private limited',
    'Discount tadkaa (india) limited',
    'Prakruti commosale private limited',
    'City tea junction private limited',
    'Express hospitality private limited',
    'Suryansh motels private limted',
    'V.e.f. hotels and resorts private limited',
    'Windsor manor hospitality private limited',
    'Wave hospitality private limited',
    'Xperience india hotels & resorts private limited',
    'Shreyansh luxury stores private limited',
    'Leefong exim private limited',
    'Go digital marketing private limited',
    'Metro hotel equipments and supplies private limited',
    'Saglani enterprises private limited',
    'Mayur vinimay private limited',
    'Treasure island holidays private limited',
    'Metafore info systems private limited',
    'Arka information systems private limited',
    'CLOUD WORK SOLUTIONS PRIVATE LIMITED(OPC)',
    'Convolutions infrasys private limited',
    'AZIMETRY CONSULTING PRIVATE LIMITED',
    'Super sarees pvt ltd',
    'Elogix software private limited',
    'Maple auto motion private limited',
    'Netconsulate software private limited',
    'Topsource infotech solutions private limited',
    'Max secure software india private limited',
    'Technorealistic it solutions private limited',
    'Trogon soft private limited',
    'Sumedha softech private limited',
    'Drishti infosolutions private limited',
    'Om trax packaging solutions limited',
    'Empire eparks private limited',
    'Eagateway services india private limited',
    'Scmooth (india) private limited',
    'Enterpi software solutions private limited',
    'Spectrum callnet private limited',
    'Tekfriday processing solutions private limited',
    'Jns systech private limited',
    '3rd eye techno solutions private limited',
    'Tech blue software private limited',
    'Sobis teksoft private limited',
    'Convergytics solutions private limited',
    'Flamingo technologies private limited',
    'Tcs e-serve international limited',
    'Cloud computing techsolutions private limited',
    'Courseon technologies private limited',
    'Channelsale software services private limited',
    'HANSEATIC CONNECT INDIA PRIVATE LIMITED',
    'Cerebrate infolytics private limited',
    'Crisium technologies private limited',
    'Integrated dynamic solutions india private limited',
    'Vbis india private limited',
    'Reserway technologies private limited',
    'Info career private limited',
    'Smartpoint technologies private limited',
    'Collar solutions private limited',
    'Brandwizz communications private limited',
    'Bluemotion technologies (india) private limited',
    'Forerun technologies india private limited',
    'Zerokelvin technologies private limited',
    'PROPHARMA GROUP INDIA PRIVATE LIMITED',
    'TRUNDL LABS PRIVATE LIMITED',
    'Pp creatnlrn private limited',
    'Hpr technosoft private limited',
    'TOPPAN MERRILL TECHNOLOGY SERVICES PRIVATE LIMITED',
    'Aacharana business services private limited',
    'Mangalam data management pvt ltd',
    'Brevity softtech private limited',
    'Elite computers and communications private limited',
    'Anusuya w3 solutions private limited',
    'Trikut info services private limited',
    'Impact standard business reporting private limited',
    'Casper power controls private limited',
    'Maxworth vision info limited.',
    'Pragmatic data solution private limited',
    'Skytel tele - services private limited',
    'Ns soft india private limited',
    'Elets technomedia private limited',
    'K.g. data forms private limited',
    'Techplus media private limited',
    'Track eye technologies private limited',
    'Global infozone private limited',
    'Rekha technologies private limited',
    'Gantech e technologies private limited',
    'Radha raj it city & parks private limited',
    'Kalkasoft infotech private limited',
    'Sumiko mediasoft private limited',
    'Truechip solutions private limited',
    'Webreach technologies private limited',
    'A s software services private limited',
    'Mezocliq technology india private limited',
    'Tekshapers software solutions private limited',
    'CLOUDWAY CONSULTING PRIVATE LIMITED',
    'Innotion technologies private limited',
    'Usb softlabs privte limited',
    'Alpha analytics services private limited',
    'Globus eight india private limited',
    'Mansha software india private limited',
    'Vns it solutions private limited',
    'Dowell technologies private limited',
    'Sistemos information technology private limited',
    'H g s infotech private limited',
    'Tristar softech private limited',
    'Winculum services private limited',
    'Btp infoserve private limited',
    'Babbler marketing private limited',
    'TIER 1 AGRI TECH PRIVATE LIMITED',
    'Twelve77 software studios private limited',
    'Xitadel cae technologies india private limited',
    'Adaptive securetech private limited',
    'Appcom technologies private limited',
    'First rite it services private limited',
    'Alan infoways web and multimedia solutions private limited',
    'Geosense systems and technologies private limited',
    'Next screen infotech private limited',
    'JST IT&S PRIVATE LIMITED',
    'Allways infotech private limited',
    'ARDENTIA TECHNOLOGIES PRIVATE LIMITED',
    'Warrior fms (india) private limited',
    'Malar stars medicare limited',
    'Power technoprom private limited',
    'The indian film combine pvt ltd',
    'Eden critical care hospital limited',
    'Ramanand maxlife infrastructure private limited',
    'Studio 9 media services private limited',
    'Oc & c strategy consultants india private limited',
    'Nirvana television limited',
    'Shiwalik cable network private limited',
    'Abhiruchi fun & food village private limited',
    'Bhavitha foundation',
    'DRA CONSULTANTS LIMITED',
    'MURGENCY GLOBAL SERVICES PRIVATE LIMITED',
    'Monarch studios private limited',
    'Radiowalla network private limited',
    'Ariston trusteeship services private limited',
    'Ryder facility management group private limited',
    'Van-bent minerals private limited',
    'Healthy protein (india) limited',
    'Vjsons textiles private limited',
    'Samtex exports private limited',
    'MADHAV KRG TRADE LINK PRIVATE LIMITED',
    'DANDONA INDUSTRIES PRIVATE LIMITED',
    'First flavour (india) private limited',
    'Electrowater technologies private limited',
    'Vivante foods private limited',
    'Mathewsons food specialities private limited',
    'Best corporation private limited',
    'Midway textiles india private limited',
    'Satvika bio-foods india private limited',
    'Zone8 tea world private limited',
    'Irani foods and investment company private limited',
    'Rozen tex private limited',
    'Nirav cotton private limited',
    'Bedekar spices private limited',
    'Pandian foods p ltd',
    'DAVE',
    'S GOODS CARRIERS PRIVATE LIMITED',
    'Concorde air logistics limited',
    'Vishal scm private limited',
    'Ganesh roadlines private limited',
    'Integrated logistics private limited',
    'Savaari car rentals private limited',
    'Makinfra transport logistics private limited',
    'Vijay logistics private limited',
    'Sawant transport private limited',
    'Icm logistics private limited',
    'Jkg logistics private limited',
    'Multiform logistics private limited',
    'Sysnet associates (india) private limited',
    'Unique digitek global services private limited',
    'Flair network systems private limited',
    'EIGERTECH KNOWLEDGE SERVICES PRIVATE LIMITED',
    'Basware india private limited',
    'Webtel electro soft private limited',
    'Ats services private limited',
    'Greensoft solutions private limited',
    'Sim solutions private limited',
    'Citixsys tech solutions private limited',
    'Cross section interactive private limited',
    'Complitech solutions private limited',
    'Integra systems private limited',
    'Shree info solutions private limited',
    'I-verve infoweb private limited',
    'Ishaan prem infosoft private limited',
    'Msp it concepts private limited',
    'Aavitech solutions private limited',
    'Esparkbiz technologies private limited',
    'Oz telefield services private limited',
    'Ssp india private limited',
    'Zimong software private limited',
    'Unosis it solutions private limited',
    'Mangalore infotech solutions private limited',
    'Rolex logistics private limited',
    'Kgln technologies private limited',
    'Geneva software technologies limited',
    'Support cell private limited',
    'Kavach networks private limited',
    'Knowledge learning solutions (india) private limited',
    'Toccss datacom private limited',
    'Vsocialize solutions private limited',
    'Iqgateway private limited',
    'CELLIBER TECHNOLOGIES PRIVATE LIMITED',
    'Aakeeo technologies private limited',
    'Grab data technologies private limited',
    'Iqh medicare private limited',
    'Interland technology services private limited',
    'Telious technologies private limited',
    'Neovibe innovative technologies private limited',
    'Falcon infotech private limited',
    'NSE DATA & ANALYTICS LIMITED',
    'Walchand netsoft private limited',
    'Ugam solutions private limited',
    'TINY EPIC SOLUTIONS PRIVATE LIMITED',
    'Exegesis infotech india private limited',
    'TELEPERFORMANCE GLOBAL SERVICES PRIVATE LIMITED',
    'Qdnet technologies private limited',
    'Interface business solutions (india) private limited',
    'Paras cadd private limited',
    'IBIC ENGINEERING PRIVATE LIMITED',
    'Radius infosource private limited',
    'SAMAAGE TECHNOLOGIES PRIVATE LIMITED',
    'Gng electronics private limited',
    'Vunya infotech private limited',
    'Newel infotech private limited',
    'Bernstein infotech private limited',
    'FINCLUSION SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'Firefish networks private limited',
    'Seamless private limited',
    'My mobile payments limited',
    'Bluecom infotech private limited',
    'Eden infosol private limited',
    'Xact data discovery india private limited',
    'Realtime it concepts private limited',
    'INP TECHNOLOGIES PRIVATE LIMITED',
    'Nividous software solutions private limited',
    'Airpay payment services private limited',
    'Thalia technologies private limited',
    'James & monroe technologies services private limited',
    'Enterops technologies private limited',
    'U and d square solutions private limited',
    'Pragmatic techsoft private limited',
    'Siddhatech software services private limited',
    'LIFENITY HEALTH LIMITED',
    'Light information systems private limited',
    'Rachit technology private limited',
    'Deutsche telekom clinical solutions india private limited',
    'Sears global technologies india private limited',
    'Ln software solutions private limited',
    'Envoysys software solution private limited',
    'Plasma nitration technologies private limited',
    'Auspice soft-tech private limited',
    'INCREDIBLE WEBTECHNOLOGIES PRIVATE LIMITED',
    'Softserv solutions private limited',
    'ADVANCED TECHNOLOGY CONSULTING SERVICE PRIVATE LIMITED',
    'Yusata infotech private limited',
    'Coruscant systems private limited',
    'S r digital imaging private limited',
    'Aarvee software technologies private limited',
    'Ebus software technologies private limited',
    'LEARNING GEMS TECHNOLOGIES PRIVATE LIMITED',
    'DGZ INTERNET PRIVATE LIMITED',
    'WE BROS MEDIA PRIVATE LIMITED',
    'SOURUS MARKETPLACE PRIVATE LIMITED',
    'INGENIOUS MEDTECH PRIVATE LIMITED',
    'MATSTAR LOGISTICS & FREIGHTS PRIVATE LIMITED',
    'MUMBAI ETHANOL & MOLASSES INDIA PRIVATE LIMITED',
    'LYFRESH PRIVATE LIMITED',
    'PACIFIC CLEARING AND FORWARDING PRIVATE LIMITED',
    'AGLIGHT LOGISTICS ASIA PRIVATE LIMITED',
    'WASH DRY BYE PRIVATE LIMITED',
    'VENTUGROW CONSULTANTS PRIVATE LIMITED',
    'EURO INFRA SOLUTIONS PRIVATE LIMITED',
    'RUGGEDIAN LIFESTYLE PRIVATE LIMITED',
    'PRNAM BUSINESS STARTUP CONSULTANTS PRIVATE LIMITED',
    'MARKETING SPACE PRIVATE LIMITED',
    'ANANTYA BPO PRIVATE LIMITED',
    'REZO TECHNOLOGIES PRIVATE LIMITED',
    'DUSKLINE HEALTHCARE PRIVATE LIMITED',
    'UNI P2P PLATFORM PRIVATE LIMITED',
    'TRUSTRITE EXIM PRIVATE LIMITED',
    'KRIIS PORTFOLIO PRIVATE LIMITED',
    'UNISTRAT BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MOJOSTAR BRAND MANAGEMENT& MERCHANDISINGSOLUTIONS PRIVATE LIMITED',
    'MULTIPLIER BRAND SOLUTIONS PRIVATE LIMITED',
    'ASIAN ONCOLOGY PRIVATE LIMITED',
    'HEALTH WHEELS PRIVATE LIMITED',
    'CREANTUM SECURITY SOLUTIONS PRIVATE LIMITED',
    'UPWARD SPIRAL CONSULTING PRIVATE LIMITED',
    'UNPAC RESEARCH (OPC) PRIVATE LIMITED',
    'AUGMONT INTERNATIONAL LIMITED',
    'STAR AGRIBAZAAR TECHNOLOGY PRIVATE LIMITED',
    'BRICKELL LUXURY FIT-OUT PRIVATE LIMITED',
    'NOVO TEXCOM PRIVATE LIMITED',
    'DESYNOVA DIGITAL PRIVATE LIMITED',
    'A2B GIFTING SOLUTIONS PRIVATE LIMITED',
    'PLAYGROUND DIGITAL CINEMA PRIVATE LIMITED',
    'BLOOMSERVE PRIVATE LIMITED',
    'TECHYTYPE SERVICES PRIVATE LIMITED',
    'PYMNTS TECH SOLUTION PRIVATE LIMITED',
    'FILMQUEST ENTERTAINMENT PRIVATE LIMITED',
    'TUSHVI TRADEX PRIVATE LIMITED',
    'SPICA FACILITY CONSULTANTS PRIVATE LIMITED',
    'SYSCRAFT SOLUTIONS PRIVATE LIMITED',
    'CODESIRE PRIVATE LIMITED',
    'ALERTLABS INDIA PRIVATE LIMITED',
    'KRISHNAS DIGITAL TECHNOLOGIES AND SOFTLABS PRIVATE LIMITED',
    'ARASHI FUTURES PRIVATE LIMITED',
    'PRIMENET WEB TECHNOLOGIES PRIVATE LIMITED',
    'HOSTMUD CLOUD SOLUTIONS PRIVATE LIMITED',
    'SOFOCLE TECHNOLOGIES PRIVATE LIMITED',
    'AASIP TECHNOLOGIES PRIVATE LIMITED',
    'AKIK SEABRINE PRIVATE LIMITED',
    'PITCHERS INTERNET PRIVATE LIMITED',
    'CHOUPARI SYSTEMS INDIA PRIVATE LIMITED',
    'PUSHYAM HERBALS PRIVATE LIMITED',
    'STRIDE.AI R&D PRIVATE LIMITED',
    'BAAZI GAMES PRIVATE LIMITED',
    'COMMONBEE BROADBAND PRIVATE LIMITED',
    'TRUE CRYSTAL BIZ SOLUTIONS PRIVATE LIMITED',
    'SASA INFOTECH PRIVATE LIMITED',
    'CORUSCATE VENTURES PRIVATE LIMITED',
    'SHARADA TECHCONSOL PRIVATE LIMITED',
    'INNERCIRCLE SOFTECH PRIVATE LIMITED',
    'GLOBALE CAPO INDIA PRIVATE LIMITED',
    '3D EDTECH PRIVATE LIMITED',
    'COUNTAKE TECHNOLOGIES PRIVATE LIMITED',
    'ROCKEDGE SOLUTIONS PRIVATE LIMITED',
    'PHOENIX INTERNET PRIVATE LIMITED',
    'URBAN STONE INFRA PRIVATE LIMITED',
    'FRANK ESTATE CONSULTANCY PRIVATE LIMITED',
    'ACCESS MANAGED OFFICE SOLUTIONS PRIVATE LIMITED',
    'PARKNSECURE INDIA PRIVATE LIMITED',
    'CHORUS TECHNOLOGIES PRIVATE LIMITED',
    'NM PLANNED CITY PRIME HOUSING PRIVATE LIMITED',
    'SRICITY ELECTRONICS MANUFACTURING CLUSTER PRIVATE LIMITED',
    'AIRCAM MEDIA PRIVATE LIMITED',
    'AS TECHNOLUTIONS PRIVATE LIMITED',
    'MINDORKS NEXTGEN PRIVATE LIMITED',
    'DECISIONSLAB INFOTECH PRIVATE LIMITED',
    'GAMELORE INDIA PRIVATE LIMITED',
    'VIABLE WEBLOG (OPC) PRIVATE LIMITED',
    'SURDEEP BUILDERS PRIVATE LIMITED',
    'SUBINFRA PROJECT MANAGEMENT PRIVATE LIMITED',
    'LIMIT INFINITY PRIVATE LIMITED',
    'HASH CODE PROGRAMMERS PRIVATE LIMITED',
    'DATAMON IT SERVICES PRIVATE LIMITED',
    'JGDTECH PRIVATE LIMITED',
    'QSYNC SOFTWARE PRIVATE LIMITED',
    'DREAMRECKON TECH SYSTEMS PRIVATE LIMITED',
    'TECHROVER TECHNOLOGIES PRIVATE LIMITED',
    'BPN INFOTECH PRIVATE LIMITED',
    'REVENTUS TECHNOLOGIES PRIVATE LIMITED',
    'LUKE INFOTECH PRIVATE LIMITED',
    'LIFELIKE STUDIOS PRIVATE LIMITED',
    'PREDIFAST TECHNOLOGIES PRIVATE LIMITED',
    'ACCESS PAYTECH PRIVATE LIMITED',
    'DIGIPANDA CONSULTING PRIVATE LIMITED',
    'EPIKSO INDIA PRIVATE LIMITED',
    'SENJA TECHNOLOGIES PRIVATE LIMITED',
    'HITECHERS ONLINE INDIA (OPC) PRIVATE LIMITED',
    'MESHI WEBTECH CONSULTANTS (OPC) PRIVATE LIMITED',
    'KAARWA INFOTECH PRIVATE LIMITED',
    'MEDISHA TECHNOLOGIES PRIVATE LIMITED',
    'ARITRON TECHNOLOGIES PRIVATE LIMITED',
    'SODIO TECHNOLOGIES PRIVATE LIMITED',
    'AADIT TECHNOLOGIES PRIVATE LIMITED',
    'IMMERGRO TECHNOLOGIES PRIVATE LIMITED',
    'PALC NETWORKS PRIVATE LIMITED',
    'MULTIICON IDEOTECHNOLOGY PRIVATE LIMITED',
    'NEO SENSE VECTOR TECHNOLOGY PRIVATE LIMITED',
    'SKYONLINE TECHNOSYSTEM PRIVATE LIMITED',
    'YELLOWRAYS SOLUTIONS PRIVATE LIMITED',
    'ONEVIEW TRAINING AND DEVELOPMENT PRIVATELIMITED',
    'TECHDEFENCE LABS SOLUTIONS PRIVATE LIMITED',
    'ALIPAY (INDIA) PRIVATE LIMITED',
    'NOOVOCOM ADVANTAGES PRIVATE LIMITED',
    'INFINIVALUE PRIVATE LIMITED',
    'AQUAGIRAFFE TECHNOLOGIES PRIVATE LIMITED',
    'HAIDA TECHNOLOGIES PRIVATE LIMITED',
    'AZUCANE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'REVOSAUTO TECH PRIVATE LIMITED',
    'DATAGRIDZIT PRIVATE LIMITED',
    'FORTHRIGHT GLOBAL PRIVATE LIMITED',
    'LIRCTEK TECHNOLOGIES PRIVATE LIMITED',
    'MYNDLOOP TECH PRIVATE LIMITED',
    'BITIBE TECHNOLOGIES PRIVATE LIMITED',
    'TANGO NETWORKS PRIVATE LIMITED',
    'FACTRSYSTEMS PRIVATE LIMITED',
    'SUMEDHAS TECH SOLUTIONS PRIVATE LIMITED',
    'LAWPOC SYSTEMS PRIVATE LIMITED',
    'AIMONK LABS PRIVATE LIMITED',
    'SARCON TECHNOLOGIES PRIVATE LIMITED',
    'HERMOSO TECHNOLOGIES (OPC) PRIVATE LIMITED',
    'BRAINIZEN TECHNOLOGIES PRIVATE LIMITED',
    'STRIDEUP NOW (OPC) PRIVATE LIMITED',
    'SIPPAI LAB PRIVATE LIMITED',
    'EXCEL VLSI TECHNOLOGIES PRIVATE LIMITED',
    'PROFECTUS ANALYTICS PRIVATE LIMITED',
    'ALEAIT SOLUTIONS PRIVATE LIMITED',
    'MALAK STAR SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'EKAM IT SOLUTIONS INDIA PRIVATE LIMITED',
    'DESYFER INTELISYS PRIVATE LIMITED',
    'INOVAANTAGE SYSTEMS PRIVATE LIMITED',
    'ZEKELABS TECHNOLOGIES PRIVATE LIMITED',
    'EVRIM DIGITAL SERVICES PRIVATE LIMITED',
    'ORION DIGITAL PRIVATE LIMITED',
    'ENERGY HOLISTIC HEALING STUDIO PRIVATE LIMITED',
    'TRISHULYA TRI INDUSTRIES PRIVATE LIMITED',
    'RISUN (INDIA) ELECTRONICS PRIVATE LIMITED',
    'EKANSHI ENGINEERING PRIVATE LIMITED',
    'TECHNETIX PRIVATE LIMITED',
    'ITW TRAVEL AND LEISURE PRIVATE LIMITED',
    'INFRRD PRIVATE LIMITED',
    'RYBLUE LOGISTICS PRIVATE LIMITED',
    'VIIKING PAYMASTER PRIVATE LIMITED',
    'EZ REPAIR SERVICES PRIVATE LIMITED',
    'ITILITE TECHNOLOGIES PRIVATE LIMITED',
    'RIYAN GLOBAL SOLUTIONS PRIVATE LIMITED',
    'SENSESKILLS WORLDWIDE PRIVATE LIMITED',
    'BARCODE LOGISTICS PRIVATE LIMITED',
    'SAN DYNAMICS TECHNOVA PRIVATE LIMITED',
    'GEW (INDIA) PRIVATE LIMITED',
    'GKM TAX ADVISORS PRIVATE LIMITED',
    'UNISOFT GLOBAL SERVICES PRIVATE LIMITED',
    'NEMITIRU ADVISORS PRIVATE LIMITED',
    'FLEXI SAFE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'SAHYAN VALLEY INDUSTRIES PRIVATE LIMITED',
    'MEHFIL MASTEE EVENTS PRIVATE LIMITED',
    'CHRIS LAND HOLDINGS PRIVATE LIMITED',
    'ECOFAV SERVICES PRIVATE LIMITED',
    'CONSISTENT AIRCON PRIVATE LIMITED',
    'BMW INDIA FOUNDATION',
    'EVOTECH TECHNOLOGIES PRIVATE LIMITED',
    'AMKE PROJECTS INDIA PRIVATE LIMITED',
    'GRC GREEN E-COM INDIA PRIVATE LIMITED',
    'WISENET AUTOMATION PRIVATE LIMITED',
    'MALPANI PIPES AND FITTINGS PRIVATE LIMITED',
    'USHA BRECO BIJLI MAHADEV ROPEWAY PRIVATELIMITED',
    'SOLADEV PRIVATE LIMITED',
    'INFINITE GLOBAL LOGISTICS PRIVATE LIMITED',
    'OMNIPRO GLOBAL SERVICES PRIVATE LIMITED',
    'SHIPSKART MARINE PRIVATE LIMITED',
    'BARMAX GLOBAL SOLUTIONS PRIVATE LIMITED',
    'ZETTA INTERNATIONAL PRIVATE LIMITED',
    'RIGHTARM SOCIAL CONNECT PRIVATE LIMITED',
    'COG DIGITAL PRIVATE LIMITED',
    'FERGUSON DIALS PRIVATE LIMITED',
    'TAMA SYSTEMS INDIA PRIVATE LIMITED',
    'VENTUREVAULT INNOVATIONS PRIVATE LIMITED',
    'V-MAYUKH ENGINEERING SOLUTIONS AND SERVICES (OPC) PRIVATE LIMITED',
    'CARDINAL CARGO SOLUTIONS PRIVATE LIMITED',
    'AALAM VENTURES PRIVATE LIMITED',
    'CALCULUS SEARCH PRIVATE LIMITED',
    'ECOSATTVA ENVIRONMENTAL SOLUTIONS PRIVATE LIMITED',
    'WEBCABLE MEDIA PRIVATE LIMITED',
    'VVSOFTTECH SOLUTIONS PRIVATE LIMITED',
    'REVIVEANALYTICS PRIVATE LIMITED',
    'FARADAY ENERGY SYSTEMS PRIVATE LIMITED',
    'PRANAB OVERSEAS PRIVATE LIMITED',
    'PROMMADA ENGINEERING PRIVATE LIMITED',
    'AUDTECH SOLUTIONS PRIVATE LIMITED',
    'LYVERY ECOMMERCE PRIVATE LIMITED',
    'E&A ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'TRAVELSPICE NOW PRIVATE LIMITED',
    'CLOUDKICKERS INDIA PRIVATE LIMITED',
    'IPERCEPTS CREATIVE SOFT TECH PRIVATE LIMITED',
    'DYNEMIC VIBRATION CONTROL SOLUTIONS PRIVATE LIMITED',
    'PARIVARTAN PREMIUM FACILITY SERVICES PRIVATE LIMITED',
    'TROOTECH BUSINESS SOLUTIONS PRIVATE LIMITED',
    'MESCO GJD AEROSPACE PRIVATE LIMITED',
    'ADVENTURIA THRILL INDIA PRIVATE LIMITED',
    'LNJP EDUCATIONAL FOUNDATION',
    'VESUNA BRAND SOLUTIONS PRIVATE LIMITED',
    'NCML MKTYARD PRIVATE LIMITED',
    'PACKT LEARNING SOLUTIONS PRIVATE LIMITED',
    'MS AMLIN (INDIA) PRIVATE LIMITED',
    'WAYUSAKA INNOVATIONS PRIVATE LIMITED',
    'PRABHAT GLOBAL COLOURCOATED PRIVATE LIMITED',
    'DISCOY CONSTRUCTION PRIVATE LIMITED',
    'ANGULARITY ANALYTICS PRIVATE LIMITED',
    'VAIJASI CONSULTANCY PRIVATE LIMITED',
    'ENGAGED PROFESSIONAL SERVICE PRIVATE LIMITED',
    'JHSEC ELEVATOR PRIVATE LIMITED',
    'VERIFEED TECHNOLOGIES PRIVATE LIMITED',
    'ADGUNT MEDIA PRIVATE LIMITED',
    'SKYDIVE MEDIA PRIVATE LIMITED',
    'SINGAPORE FOREX PRIVATE LIMITED',
    'PYPE TECHNOLOGIES PRIVATE LIMITED',
    'AMWIN SYSTEMS PRIVATE LIMITED',
    'GUJARAT UNIVERSITY STARTUP AND ENTREPRENEURSHIP COUNCIL (GUSEC)',
    'SANCTUS GLOBAL LIFESCIENCES PRIVATE LIMITED',
    'SANIYA METAL CRAFT PRIVATE LIMITED',
    'ZOPRENT TECHNOLOGIES PRIVATE LIMITED',
    'MISTER POLICY INSURANCE MARKETING PRIVATE LIMITED',
    'PARTICLES STUDIO PRIVATE LIMITED',
    'DELFINGEN INDIA FOUNDATION',
    'COSTA EXPORTS & IMPORTS PRIVATE LIMITED',
    'MANMACHINE CAR CARE PRIVATE LIMITED',
    'NEYOCHEM INDUSTRIES PRIVATE LIMITED',
    'DIVYASREE R.O.W.PROJECTS PRIVATE LIMITED',
    'NET ZERO BEVERAGES PRIVATE LIMITED',
    'CAREERFORSURE HIRING PRIVATE LIMITED',
    'ECLATIAN TECHNOLOGIES PRIVATE LIMITED',
    'TRAFO-TECH INSPECTION SERVICES PRIVATE LIMITED',
    'EDERNITY INITIATIVES PRIVATE LIMITED',
    'POSO SERVICES PRIVATE LIMITED',
    'ELEASEE PRIVATE LIMITED',
    'ORIGAMI BUSINESS MANAGEMENT PRIVATE LIMITED',
    'STG PHARMAGENERICS PRIVATE LIMITED',
    'ZYMA PROPERTIES PRIVATE LIMITED',
    'PINGME TOURS AND TRAVELS PRIVATE LIMITED',
    'APPIER INDIA PRIVATE LIMITED',
    'USIN TECHNOLOGIES PRIVATE LIMITED',
    'CASHPUNDIT TECHNOLOGIES PRIVATE LIMITED',
    'BROMPTON PRIVATE LIMITED',
    'PPROM AGRO AND FOODS INDUSTRIES PRIVATE LIMITED',
    'FRANCIUM TECHNOLOGIES PRIVATE LIMITED',
    'CORELIFE WHOLEFOODS PRIVATE LIMITED',
    'MYCAR MIDDLE EAST PRIVATE LIMITED',
    'REWA MSW HOLDING LIMITED',
    'UTOPUS INSIGHTS INDIA PRIVATE LIMITED',
    'CHIJ AGRO INDUSTRIES PRIVATE LIMITED',
    'BLUE DREAMZ FOODS ',
    'FLIPS PRIVATE LIMITED',
    'CONDUCIVE DESIGN CONSULTANTS PRIVATE LIMITED',
    'YOUNG TEA PRIVATE LIMITED',
    'STOCKHOLM JAIPUR SOULFUL SOURCING PRIVATE LIMITED',
    'NERIDIO SYSTEMS PRIVATE LIMITED',
    'BIPIN BIHARI SINGH CONSULTANTS PRIVATE LIMITED',
    'SAMRUD ENERGY PRIVATE LIMITED',
    'AARLEO TECHNOLOGIES PRIVATE LIMITED',
    'RANG STUDIO PRIVATE LIMITED',
    'GREEN LENS VERIFICATION PRIVATE LIMITED',
    'GREENTAPE PRIVATE LIMITED',
    'PARTHIV CORPORATE ADVISORY PRIVATE LIMITED',
    'SYNAPPTRA TECHNOLOGIES PRIVATE LIMITED',
    'SM MARITIME ACADEMY',
    'PIOUS LABORATORIES PRIVATE LIMITED',
    'KAPEESHIV GREENTECH INDIA PRIVATE LIMITED',
    'MINDBRIDGE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'VPIS CONSULTANTS PRIVATE LIMITED',
    'GELO TECHNOLOGIES PRIVATE LIMITED',
    'AVYA LABS PRIVATE LIMITED',
    'SUSHEELA AVENUES PRIVATE LIMITED',
    'VERUMQUE RESEARCH AND CONSULTING PRIVATELIMITED',
    'PERONEIRA PRIVATE LIMITED',
    'JG CAPITAL PRIVATE LIMITED',
    'INDORSE TRADE FAIR SERVICES PRIVATE LIMITED',
    'GAD WORLD FREIGHTS PRIVATE LIMITED',
    'INSANE HOSPITALITY PRIVATE LIMITED',
    'BOOKOSMIA PRIVATE LIMITED',
    'GLANZ WINDOWS PRIVATE LIMITED',
    'CONTEGRATE ENTREPOT PRIVATE LIMITED',
    'SWENLABS PRIVATE LIMITED',
    'KEY BUSINESS COMMUNICATION SERVICES PRIVATE LIMITED',
    'VAHMINE TECHNOLOGIES PRIVATE LIMITED',
    'ANVIS MERCANTILE PRIVATE LIMITED',
    'DISCOVER HERITAGE TOURS PRIVATE LIMITED',
    'ADWAY PRINT CONCEPT PRIVATE LIMITED',
    'KWH RENEWABLES PRIVATE LIMITED',
    'SAROVAR LOGISTICS INDIA PRIVATE LIMITED',
    'KMEW OFFSHORE PRIVATE LIMITED',
    'ARAVY TECHNOLOGIES PRIVATE LIMITED',
    'TN-EXCELUS PRIVATE LIMITED',
    'SEQURO TECHNOLOGIES PRIVATE LIMITED',
    'REX CARS PRIVATE LIMITED',
    'YOCTOTTA SOFTWARES PRIVATE LIMITED',
    'DEEPTEC INSTRUMENTS AND INFRASTRUCTURE CONSULTANTS PRIVATE LIMITED',
    'CANOPUS WET WIPES PRIVATE LIMITED',
    'EMMERSIVE INFOTECH PRIVATE LIMITED',
    'ORIENT SPECTRA CONSULTING PRIVATE LIMITED',
    'LOANZEN FINANCE PRIVATE LIMITED',
    'SEP RESTAURANTS PRIVATE LIMITED',
    'CUBE FITNESS PRIVATE LIMITED',
    'IAW FOREX PRIVATE LIMITED',
    'NAMI THAI TRAVELS PRIVATE LIMITED',
    'HIJAZI TRAVELS (OPC) PRIVATE LIMITED',
    'KIRTI CREATIONS PRIVATE LIMITED',
    'INNOX GLOBAL MULTIVENTURES PRIVATE LIMITED',
    'BURGEON FOUNDATION',
    'DATAVIV TECHNOLOGIES PRIVATE LIMITED',
    'QUICKCORE TECHNOLOGIES PRIVATE LIMITED',
    'BOOLMENT SOFTWARE DEVELOPMENT PRIVATE LIMITED',
    'VERTICAL DISCOVERY DATA SCIENCES PRIVATELIMITED',
    'BLUE WATER EXPOTRADE INDIA PRIVATE LIMITED',
    'AROME CONSULTING SERVICES PRIVATE LIMITED',
    'GUJARAT SEED VALLEY FEDERATION',
    'GDS STERLING GAS AND EQUIPMENTS PRIVATE LIMITED',
    'TUNGSTEN NETWORK PRIVATE LIMITED',
    'MEDLAB MEDIA INDIA PRIVATE LIMITED',
    'ENSONIC COMPUTECH PRIVATE LIMITED',
    'ORPHIUS TECHNOLOGIES PRIVATE LIMITED',
    'ASR WATER SOLUTIONS PRIVATE LIMITED',
    'PUGALUR RENEWABLE PRIVATE LIMITED',
    'BELUR ENGINEERING PRIVATE LIMITED',
    'GREYFRIARS MANAGEMENT PRIVATE LIMITED',
    'MALBEL TECHNOLOGIES PRIVATE LIMITED',
    'JONSBO INDIA PRIVATE LIMITED',
    'CLOUDATIX E-HEALTH MONITORING PRIVATE LIMITED',
    'HEADWAYS CORPORATE SOLUTIONS PRIVATE LIMITED',
    'ADIAMISHAN INDIA PRIVATE LIMITED',
    'STRIDES ALATHUR PRIVATE LIMITED',
    'SUNCUPID TECHNOLOGY INDIA PRIVATE LIMITED',
    'CIK PARAMETRICS PRIVATE LIMITED',
    'MERAKI MANUFACTURING AND FINVEST ADVISORS PRIVATE LIMITED',
    'ALKOSENS INDIA PRIVATE LIMITED',
    'MILLENNIUM AUTOMATION PRIVATE LIMITED',
    'VG DEFENCE SYSTEMS PRIVATE LIMITED',
    'JANGRA CHEMICALS PRIVATE LIMITED',
    'PANILA CHEM LIMITED',
    'ISHVARA MANUFACTURING AND FINVEST ADVISORS PRIVATE LIMITED',
    'SEEBA LIFE-STYLES PRIVATE LIMITED',
    'DURANOVA INDUSTRIES PRIVATE LIMITED',
    'MIDEA INDIA PRIVATE LIMITED',
    'TANTI AUTOMATICS PRIVATE LIMITED',
    'MITARSH ENERGY PRIVATE LIMITED',
    'EVON FITNESS PRIVATE LIMITED',
    'HORNERXPRESS INDIA PRIVATE LIMITED',
    'TIRTH AGRO MACHINERY PRIVATE LIMITED',
    'ELEMENTS MANUFACTURING SOLUTIONS PRIVATELIMITED',
    'TECHNIPORT SYSTEM PRIVATE LIMITED',
    'GHIYA TECHNOLOGIES PRIVATE LIMITED',
    'ANNAIR DRYCHILL TECH INDIA PRIVATE LIMITED',
    'JALPA DEVI ENGINEERING PRIVATE LIMITED',
    'IRIS POLYMERS INDUSTRIES PRIVATE LIMITED',
    'PRATIK CABLETRAY SYSTEM PRIVATE LIMITED',
    'STELLEX EQUIPMENTS PRIVATE LIMITED',
    'CUCKOS PHARMACEUTICAL PRIVATE LIMITED',
    'JAGUAREQUIPMENTS PRIVATE LIMITED',
    'OKUMURA EIFUKU INDIA PRIVATE LIMITED',
    'ADWIK INTELLIMECH PRIVATE LIMITED',
    'NAACHI FARM EQUIPMENTS PRIVATE LIMITED',
    'NIMBLE TECHNOPLAST ELECTRICALS PRIVATE LIMITED',
    'SAVEGEO ENERGY PRIVATE LIMITED',
    'ARUSHII (MORE DESIGN) PRIVATE LIMITED',
    'LE DIMORA INDIA PRIVATE LIMITED',
    'LIANCHUANG HONGSHENG INDIA PRIVATE LIMITED',
    'VEDI HERBALS PRIVATE LIMITED',
    'LIANMING TECHNOLOGY (INDIA) PRIVATE LIMITED',
    'LONGMAN RENEWABLES PRIVATE LIMITED',
    'EKIN TECHPRUDENT PRIVATE LIMITED',
    'INTELUX EMS PRIVATE LIMITED',
    'HIMALAYAN ROCKET STOVE PRIVATE LIMITED',
    'PROFISOLUTIONS PRIVATE LIMITED',
    'TRUCON POWER ENGINEERS PRIVATE LIMITED',
    'RELIV HEALTHCARE PRIVATE LIMITED',
    'AKSHAY EMBEDDED SYSTEMS PRIVATE LIMITED',
    'TIKDUMM SOLUTIONS PRIVATE LIMITED',
    'EIRFID SOLUTIONS PRIVATE LIMITED',
    'ZENITH TELECOMMUNICATIONS PRIVATE LIMITED',
    'R&S ELECTRONICS SYSTEMS INDIA PRIVATE LIMITED',
    'LUMIFORD PRIVATE LIMITED',
    'AAHAN COMMUNICATION PRIVATE LIMITED',
    'KANAK RENEWABLES LIMITED',
    'POROUS MATERIALS SCIENTIFIC PRIVATE LIMITED',
    'SWAYAMACARE PRIVATE LIMITED',
    'AMPLUS RJ SOLAR PRIVATE LIMITED',
    'IMPEL RENEWABLE POWER PRIVATE LIMITED',
    'IMPEL POWER SOLUTIONS PRIVATE LIMITED',
    'RAJAT RENEWABLES LIMITED',
    'SKRE RENEWABLE ENERGY (INDIA) PRIVATE LIMITED',
    'SKEIRON RENEWABLE ENERGY MANGROL PRIVATELIMITED',
    'IND-INFRA DEVELOPERS PRIVATE LIMITED',
    'LOCORUM WIND ENERGY PRIVATE LIMITED',
    'CORYLUS WIND ENERGY PRIVATE LIMITED',
    'ECOGREEN ENERGY LUCKNOW PRIVATE LIMITED',
    'AYANA RENEWABLE POWER PRIVATE LIMITED',
    'ONTEX MEDICAL DEVICES MANUFACTURING PRIVATE LIMITED',
    'SHRI BARSANA E-VEHICLES PRIVATE LIMITED',
    'SOLARIO TUFF',
    'MARRS PAINTS INDIA PRIVATE LIMITED',
    'MBS INDIA PRIVATE LIMITED',
    'ZEALON CONSULTING PRIVATE LIMITED',
    'JISUKA IMPEX PRIVATE LIMITED',
    'MBS ALUMINIUM INDUSTRIES PRIVATE LIMITED',
    'GURMAN CREDIT CONSULTANCY PRIVATE LIMITED',
    'RIVER WILD RESORTS PRIVATE LIMITED',
    'LKO TECHNOLOGIES INDIA PRIVATE LIMITED',
    'DEEPAK',
    'S MARKETHACKS PRIVATE LIMITED',
    'ARCHIMEDES HEALTHCARE MANAGEMENT SERVICES PRIVATE LIMITED',
    'FENCING TRAINING AND RESEARCH INSTITUTE PRIVATE LIMITED',
    'BJ AIMS GRANITES PRIVATE LIMITED',
    'SUNDOWNER TRAVELTRAILZ PRIVATE LIMITED',
    'CONCEPT CORPORATION INDIA PRIVATE LIMITED',
    'INFRA DESIGN STUDIO PRIVATE LIMITED',
    'SANKEY BUSINESS SOLUTIONS PRIVATE LIMITED',
    'WORKLIFE HR LABS PRIVATE LIMITED',
    'UNGRAMMARY CREATIVES PRIVATE LIMITED',
    'RENODO CONSULTING PRIVATE LIMITED',
    'VK CAPITAL ADVISORS PRIVATE LIMITED',
    'VLR FACILITATORS PRIVATE LIMITED',
    'KASTHURI INTERLINKS PRIVATE LIMITED',
    'REFEARN DIGITAL PRIVATE LIMITED',
    'MUMBAI FORUM FOR YOUNG PEOPLE',
    'NAKEDLY YOURS HANDCRAFTED COSMETICS PRIVATE LIMITED',
    'AUGMENTER BIZ CONSULTING PRIVATE LIMITED',
    'EVOLET PRIVATE LIMITED',
    'VAISHALI EXPRESS DELIVERY PRIVATE LIMITED',
    'STAYCONNECT INFO SOLUTIONS PRIVATE LIMITED',
    'REINHEIT ORGANIC FOODS PRIVATE LIMITED',
    'ARHAM TECHNOSOFT PRIVATE LIMITED',
    'CHART TECHNO SOLUTIONS PRIVATE LIMITED',
    'SVAYTECNO DIGITAL MEDIA PRIVATE LIMITED',
    'TRIGUNATMAK FACILITIES PRIVATE LIMITED',
    'ADVITER CONSULTING PRIVATE LIMITED',
    'NUGDS.COM PRIVATE LIMITED',
    'SAPF INDIA PRIVATE LIMITED',
    'JPNR CORPORATE CONSULTANTS PRIVATE LIMITED',
    'CENTRE FOR HEALTH RESEARCH AND INNOVATION',
    'GRC ACCELERATOR & INCUBATOR FOUNDATION',
    'VI INNOVATIONS PRIVATE LIMITED',
    'KRAFTLAND CONSULTS PRIVATE LIMITED',
    'VNIR BIOTECHNOLOGIES PRIVATE LIMITED',
    'MIDHAS WONDERHOOD PRIVATE LIMITED',
    'HNG INNOVATION PRIVATE LIMITED',
    'CEYONE LIFE SCIENCES PRIVATE LIMITED',
    'GREEN NATURAL EXTRACTS PRIVATE LIMITED',
    'RAJMANAS DESIGN FOUNDATION',
    'TEMPLE WELLNESS VENTURES INDIA PRIVATE LIMITED',
    'WAY AHEAD MARITIME PRIVATE LIMITED',
    'VISUALEFFECT FOODS PRIVATE LIMITED',
    'ACCELERATED LEARNING EDUTECH PRIVATE LIMITED',
    'FLEET MANAGEMENT MARITIME EDUCATION ACADEMY',
    'FPI INDIA PRIVATE LIMITED',
    'AVILS INFRA PRIVATE LIMITED',
    'GTU INNOVATION & START-UP CENTER',
    'BEATEST EDUMOCK PRIVATE LIMITED',
    'VISHWASHANTI SANGEET FOUNDATION',
    'PRADHAN GUARDS AND SAFETY PRIVATE LIMITED',
    'CHECKTHAT HEALTH CARE PRIVATE LIMITED',
    'KONGO EDUCATIONAL SERVICES PRIVATE LIMITED',
    'GREY MATTER RESOURCES PRIVATE LIMITED',
    'VIAVETA HEALTHCARE PRIVATE LIMITED',
    'KUKDO CHEMICAL INDIA PRIVATE LIMITED',
    'ADAMS VALVES INDIA PRIVATE LIMITED',
    'PHARMADULE ENGINEERING INDIA PRIVATE LIMITED',
    'AW HUIZHONG INSTRUMENTATION PRIVATE LIMITED',
    'BVM DIGITAL MEDIA PRIVATE LIMITED',
    'POLYMATH WORKS PRIVATE LIMITED',
    'EVG ENGICON AIRTECH PRIVATE LIMITED',
    'ENDURANCE MATERIAL HANDLERS PRIVATE LIMITED',
    'WINTECH ECO SOLUTIONS PRIVATE LIMITED',
    'AUTOEDGE ENGINEERING PRODUCTS AND SERVICES PRIVATE LIMITED',
    'BIOASPIRE PROCESS SOLUTIONS PRIVATE LIMITED',
    'MEDIANT ENERGY PRIVATE LIMITED',
    'KABY PRECISION MACHINING PRIVATE LIMITED',
    'BRT ELECTRIC PRIVATE LIMITED',
    'EXPEDIENT MATERIAL HANDLING INDIA PRIVATE LIMITED',
    'CRENZA PHARMACEUTICALS PRIVATE LIMITED',
    'ENSHU INDIA PRIVATE LIMITED',
    'NIRMITEE SOLAR PRIVATE LIMITED',
    'GIAMITI METAL FORMERS PRIVATE LIMITED',
    'SAHAL PROCESS PACK PRIVATE LIMITED',
    'PSA AVTEC POWERTRAIN PRIVATE LIMITED',
    'SHINE CONCEPTS PRIVATE LIMITED',
    'FLAMERING (INDIA) PRIVATE LIMITED',
    'KESTREL RENEWABLE ENERGY SOLUTIONS PRIVATE LIMITED',
    'JAIN LABORATORY INSTRUMENTS PRIVATE LIMITED',
    'PROBUS SMART THINGS PRIVATE LIMITED',
    'ACE PATHLABS PRIVATE LIMITED',
    'ALTONA DIAGNOSTICS INDIA PRIVATE LIMITED',
    'PARVATI POLYEXTRUSION (I) PRIVATE LIMITED',
    'OMNICALS PHARMA PRIVATE LIMITED',
    'VITABOLIK PHARMACEUTICALS PRIVATE LIMITED',
    'DYNAPAC ROAD CONSTRUCTION EQUIPMENT (INDIA) PRIVATE LIMITED',
    'ZUBIYA ENGINEERING INDIA PRIVATE LIMITED',
    'PHD FERRO ALLOYS LIMITED',
    'CROWNTECH SURFACE TREATMENT PRIVATE LIMITED',
    'JWL DAKO-CZ (INDIA) LIMITED',
    'DHANERA DIAMONDS INDIA PRIVATE LIMITED',
    'PERI WERK (INDIA) PRIVATE LIMITED',
    'FORSER INDUSTRIES PRIVATE LIMITED',
    'IGR ELECTRONICS PRIVATE LIMITED',
    'SKYRA VENTURES PRIVATE LIMITED',
    'PRIMA HI-TENSILE PRIVATE LIMITED',
    'DIAMARK JEWELRY PRIVATE LIMITED',
    'ZIGYASAW CREATIONS PRIVATE LIMITED',
    'HANMAC EXPORT PRIVATE LIMITED',
    'SIYONA GLOBAL CORPORATION PRIVATE LIMITED',
    'SANDHU WHEELS AND ALLOYS PRIVATE LIMITED',
    'METAL FORMS AEGIS PRIVATE LIMITED',
    'AMPLUS KN ONE POWER PRIVATE LIMITED',
    'MYTRAH VAYU (MAANSI) PRIVATE LIMITED',
    'AZURE POWER ROOFTOP THREE PRIVATE LIMITED',
    'AZURE POWER ROOFTOP FIVE PRIVATE LIMITED',
    'AZURE POWER ROOFTOP SIX PRIVATE LIMITED',
    'AZURE POWER ROOFTOP FOUR PRIVATE LIMITED',
    'DTEK INNOVATIVE PRIVATE LIMITED',
    'LALBABA PROJECTS PRIVATE LIMITED',
    'NYQUEST INNOVATION LABS PRIVATE LIMITED',
    'HATTARWAT WIND ENERGY PRIVATE LIMITED',
    'AZURE POWER ROOFTOP SEVEN PRIVATE LIMITED',
    'ASPEN INFRA PADUBIDRI PRIVATE LIMITED',
    'SMART MAGNUM POWER SOLUTIONS PRIVATE LIMITED',
    'LVH ENERGY PRIVATE LIMITED',
    'AJ SIMPLY PURIFY TECHNOLOGIES PRIVATE LIMITED',
    'COSMOS RENEWABLE ENERGY PRIVATE LIMITED',
    'MYTRAH VAYU (VEDAVATI) PRIVATE LIMITED',
    'NOBLE ELEVATORS (GUJARAT) PRIVATE LIMITED',
    'STRAWDUINO ELECTRONICS PRIVATE LIMITED',
    'KOTECH INDUSTRIES PRIVATE LIMITED',
    'AVION DIGITEK PRIVATE LIMITED',
    'IPCL TECHNOLOGY PRIVATE LIMITED',
    'ATL DIGICOM INDIA PRIVATE LIMITED',
    'AUTOEDGE ADVANCED AUTOMATION TECHNOLOGIES PRIVATE LIMITED',
    'RIOTECH ENGINEERING SOLUTIONS PRIVATE LIMITED',
    'FUTURE ELEVATORS PRIVATE LIMITED',
    'CORAM CHROMEWELL INDIA PRIVATE LIMITED',
    'NEBULLUS BUILDCON PRIVATE LIMITED',
    'SADBHAV UDAIPUR HIGHWAY LIMITED',
    'VKC INFRA PROJECTS PRIVATE LIMITED',
    'INDIAN DIAGNOSTICS & HEALTHCARE SERVICESPRIVATE LIMITED',
    'NAGPUR MUMBAI SUPER COMMUNICATION EXPRESSWAY LIMITED',
    'JCNT BUILDING SOLUTIONS PRIVATE LIMITED',
    'GWALIOR PATHWAYS PRIVATE LIMITED',
    'KOVEE PHARMA PRIVATE LIMITED',
    'P.B.KHOSE INFRASTRUCTURES PRIVATE LIMITED',
    'PISHON INFRA PRIVATE LIMITED',
    'MANEXPIMP SURGICARE INDIA PRIVATE LIMITED',
    'JITEEN AUTOMOBILES PRIVATE LIMITED',
    'FAA INDUSTRIES PRIVATE LIMITED',
    'IQUBX PRIVATE LIMITED',
    'JT CONSTRUCTIONS PRIVATE LIMITED',
    'ACCESS CONTEC PRIVATE LIMITED',
    'RLG SYSTEMS INDIA PRIVATE LIMITED',
    'EKIALDE SOLAR PRIVATE LIMITED',
    'PRASINUS WIND ENERGY PRIVATE LIMITED',
    'ASPENPARK INFRA VADODARA PRIVATE LIMITED',
    'ASPENPARK INFRA COIMBATORE PRIVATE LIMITED',
    'LAMBENT INFRA PRIVATE LIMITED',
    'ALSHIFA CONSTRUCTION PRIVATE LIMITED',
    'ENBOLT LABS PRIVATE LIMITED',
    'WELLCODE INDIA PRIVATE LIMITED',
    'WECKERLE COSMETICS INDIA PRIVATE LIMITED',
    'ECOMRETAIL SELLER SERVICES PRIVATE LIMITED',
    'TERRALIVE ENVIROTECH PRIVATE LIMITED',
    'VALUTEK TECHNOLOGIES PRIVATE LIMITED',
    'LEANOVATE INFO-SOLUTIONS PRIVATE LIMITED',
    'FABGRAD ONLINE PRIVATE LIMITED',
    'UBERRY INTERNATIONAL PRIVATE LIMITED',
    'TRILLDATA TECHNOLOGIES PRIVATE LIMITED',
    'RADOME TECHNOLOGIES AND SERVICES PRIVATELIMITED',
    'SLINGLOFT TECHNOLOGIES PRIVATE LIMITED',
    'INDOFIT SOLUTIONS PRIVATE LIMITED',
    'EC INSULATORS (INDIA) PRIVATE LIMITED',
    'ATRIA SOLAR POWER (RYAPTE) PRIVATE LIMITED',
    'SWBUDDY SERVICES INDIA PRIVATE LIMITED',
    'MANTRA E-VENTURES PRIVATE LIMITED',
    'ADA DIGITAL ANALYTICS PRIVATE LIMITED',
    'CINTRA CONSULTING PRIVATE LIMITED',
    'TRINETRAMILAN PRODUCT PROTECTION SOLUTIONS PRIVATE LIMITED',
    'TORRID SOLAR POWER PRIVATE LIMITED',
    'SEKAI SOLUTIONS PRIVATE LIMITED',
    'SL4 TECHNOLOGY INDIA PRIVATE LIMITED',
    'GOJENTHA INDIA PRIVATE LIMITED',
    'SUMUKHAM CONSULTANCY AND TRAINING SERVICES PRIVATE LIMITED',
    'VCG SERVICES PRIVATE LIMITED',
    'PATTERN EFFECTS LABS PRIVATE LIMITED',
    'BOOTMINDS SYSTEMS PRIVATE LIMITED',
    'TRENDWARE SOLUTIONS PRIVATE LIMITED',
    'TERCEPT TECHNOLOGIES PRIVATE LIMITED',
    'SHOPCLIENTS CONSULTANCY SERVICES PRIVATELIMITED',
    'OZIA TECHMATIQ PRIVATE LIMITED',
    'APRIDE SOLUTIONS PRIVATE LIMITED',
    'CERTEZA SOLUTIONS PRIVATE LIMITED',
    'MONTAGU MARITIME PRIVATE LIMITED',
    'SBCS INDIA PRIVATE LIMITED',
    'TOTAL ALLIANCE HEALTH PARTNERS INTERNATIONAL PRIVATE LIMITED',
    'ENKEPOWER SOLAR SYSTEMS PRIVATE LIMITED',
    'PATH TRAILS INDIA PRIVATE LIMITED',
    'PEOPLE ORGANICTREE PRODUCTS PRIVATE LIMITED',
    'CTS TANK SYSTEMS INDIA PRIVATE LIMITED',
    'RADTEL INDIA PRIVATE LIMITED',
    'ARENA INTERIORS PRIVATE LIMITED',
    'MOMS HEART JUNIOR WORLD PRIVATE LIMITED',
    'ROYALMOBI MEDIA PRIVATE LIMITED',
    'RAJARAJESWARI HEALTH TOURISM PRIVATE LIMITED',
    'THIRD ROCK VACATIONS PRIVATE LIMITED',
    'GENDER INITIATIVES FOR TRUE SUSTAINABILITY FOUNDATION',
    'VAZIRANI FOUNDATION',
    'KARTA INITIATIVE INDIA FOUNDATION',
    'NVINCY SOLUTIONS PRIVATE LIMITED',
    'JIVA ADVENTURES PRIVATE LIMITED',
    'SQUAREBOX EXHIBITION SOLUTIONS (OPC) PRIVATE LIMITED',
    'TECSTAR INDIA LIMITED',
    'GRAVITY SANDS CRUSHER PRIVATE LIMITED',
    'M-CORE TECHNOLOGIES PRIVATE LIMITED',
    'POT FUL INDIA PRIVATE LIMITED',
    'UNITYOOH MEDIA SOLUTIONS PRIVATE LIMITED',
    'CHAITHANYA INTERIORS PRIVATE LIMITED',
    'BOATRIDER SPORTS PRIVATE LIMITED',
    'PRADJNA INTELLISYS PRIVATE LIMITED',
    'QUICKSPACE TECHNOLOGIES PRIVATE LIMITED',
    'GOGLIO FLEX PACK SYSTEM INDIA PRIVATE LIMITED',
    'MUGABU SPORTS PRIVATE LIMITED',
    'TRANSFUNNEL CONSULTING PRIVATE LIMITED',
    'OPTIX GLOBAL SERVICES PRIVATE LIMITED',
    'PRIEDEMANN FACADE- LAB INDIA PRIVATE LIMITED',
    'MAPILATE TECHNOLOGIES PRIVATE LIMITED',
    'VERTICAL FARMING TECHNOLOGIES PRIVATE LIMITED',
    'CNR SECURITY SOLUTION PRIVATE LIMITED',
    'MANSA SALON PRIVATE LIMITED',
    'CAPRITECH GLOBAL SERVICES PRIVATE LIMITED',
    'DEDICATED AGRI SERVICES PRIVATE LIMITED',
    'UTOPIATECH PRIVATE LIMITED',
    'LAMPPOST MEDIA PRIVATE LIMITED',
    'SINCH CLOUD COMMUNICATION SERVICES INDIAPRIVATE LIMITED',
    'IPOA MUMBAI PRIVATE LIMITED',
    'ACOTS PHARMACEUTICALS PRIVATE LIMITED',
    '23 TWISTS & EXPERIENCES PRIVATE LIMITED',
    'IPLANSYS ECOM PRIVATE LIMITED',
    'PURELIVING EXPERIENCES INDIA PRIVATE LIMITED',
    'VITAL GLOBAL FOUNDATION',
    'AB GENERAL ELECTORAL TRUST',
    'IMPETIS BIOSCIENCES LIMITED',
    'INVESTERIA INSURANCE SERVICES PRIVATE LIMITED',
    'MERILENT INDIA PRIVATE LIMITED',
    'GRROWWIDE BUSINESS ADVISORS PRIVATE LIMITED',
    'ZENMARC SURVEYS PRIVATE LIMITED',
    'SABCOPOWER HEAVY ENGINEERING PRIVATE LIMITED',
    'SEAGULL STAFFING SOLUTIONS PRIVATE LIMITED',
    'PERSONIGO INDIA PRIVATE LIMITED',
    'UV CHEM (INDIA) PRIVATE LIMITED',
    'STARTEASE ONLINE FILINGS PRIVATE LIMITED',
    'YOKRAZY VIRTUAL PRIVATE LIMITED',
    'AVELINE INDUSTRIES PRIVATE LIMITED',
    'EVER RISE AIR CONDITIONING PRIVATE LIMITED',
    'CROZET INDIA PRIVATE LIMITED',
    'ABCBACKGROUND SCREENING SERVICES PRIVATELIMITED',
    'KAIZEN SECURE VOIZ PRIVATE LIMITED',
    'TRANSGNX HR SOLUTIONS PRIVATE LIMITED',
    'CPJTECHNOSOLUTIONS PRIVATE LIMITED',
    'TECHNOMICAL ENGINEERING PRIVATE LIMITED',
    'DIGITIVY SOFTWARE AND SERVICES INDIA PRIVATE LIMITED',
    'MARITIME TRADE AND CONTAINER AGENCIES PRIVATE LIMITED',
    'ZANDAS PHARMA PRIVATE LIMITED',
    'ALLASTIR PRIVATE LIMITED',
    'WESTLAND EPC PRIVATE LIMITED',
    'DELFERS 3PL PRIVATE LIMITED',
    'LOCUSELITE PRIVATE LIMITED',
    'FADEL SOFTWARE SOLUTIONS PRIVATE LIMITED',
    'SYNERGYELECTRICAL CONTRACTING PRIVATE LIMITED',
    'WITHER SOLAR ENERGY PRIVATE LIMITED',
    'IHOMEO SOFTWARE PRIVATE LIMITED',
    'DESAUT TECHNOLOGIES PRIVATE LIMITED',
    'LITTLE ELEPHANT IDEAS PRIVATE LIMITED',
    'AKELA GLOBAL SERVICES & SOLUTIONS PRIVATE LIMITED',
    'PARAMOUNT STEEL STRUCTURES PRIVATE LIMITED',
    'KSP CORPORATION PRIVATE LIMITED',
    'INNOSYN LIFE SCIENCES PRIVATE LIMITED',
    'KATZUNG PHARMACEUTICALS PRIVATE LIMITED',
    'SAMPATH VENKATESWARA CLOUD24 PRIVATE LIMITED',
    'NAAVIGO CAMPAIGNS AND EVENTS PRIVATE LIMITED',
    'KAYA CONSULTING SERVICES PRIVATE LIMITED',
    'FA EVENTS AND MEDIA PRIVATE LIMITED',
    'MYALTERNATES FINANCIAL SERVICES PRIVATE LIMITED',
    'GNS EFFICIENCY ENHANCERS PRIVATE LIMITED',
    'NDR FACTOR PRIVATE LIMITED',
    'ATPIY TECHNOLOGIES PRIVATE LIMITED',
    'CUTTING EDGE DESIGN STUDIO PRIVATE LIMITED',
    'THI HOSPITALITY CONSULTANTS PRIVATE LIMITED',
    'GREEN LEAF STRATEGIC HR SOLUTIONS PRIVATE LIMITED',
    'NDR STORE HOUSE PRIVATE LIMITED',
    'EDGELYTICS SOLUTIONS PRIVATE LIMITED',
    'VSHARP POWER SYSTEMS PRIVATE LIMITED',
    'IKIONE FITNESS TECHNOLOGIES PRIVATE LIMITED',
    'CAPTURE LIFE PRIVATE LIMITED',
    'PROWORKTREE PROFESSIONAL SERVICES PRIVATE LIMITED',
    'PROACTIVE TECHNICAL ORTHOPAEDICS PRIVATELIMITED',
    'OSILTEC CONSULTING PRIVATE LIMITED',
    'ADBUCONS ADVERTISING AND BUSINESS SOLUTIONS (OPC) PRIVATE LIMITED',
    'RESCUE AND REHABILITATION ENDEAVOUR',
    'EPHEMERAL SPACES PRIVATE LIMITED',
    'LOVEORGANICS PRIVATE LIMITED',
    'VENKATRAMAN HOLDINGS PRIVATE LIMITED',
    'AUTO-MATE INNOVENTIONS PRIVATE LIMITED',
    'KOKOS VCO PRIVATE LIMITED',
    'RUDRANSHE WELLNESS INDIA PRIVATE LIMITED',
    'HARSHA FILMS PRIVATE LIMITED',
    'JSV ASSOCIATES ENGINEERS AND CONSULTANTSPRIVATE LIMITED',
    'MARRAKESH HOSPITALITY PRIVATE LIMITED',
    'BOW BOW PRODUCTS AND SERVICES PRIVATE LIMITED',
    'AMPLIFYREACH SOLUTIONS PRIVATE LIMITED',
    'GAR LAXMI SUDHAKAR PRIVATE LIMITED',
    'SHARRUR BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CYBROTECHS SOLUTIONS PRIVATE LIMITED',
    'XNESA SOLUTIONS PRIVATE LIMITED',
    'GREEN-ECOMES SOLUTIONS PRIVATE LIMITED',
    'KALPTECH SOLUTIONS PRIVATE LIMITED',
    'VANADIUM PHARMACEUTICALS PRIVATE LIMITED',
    'CMCEE MEGA SKILLS PRIVATE LIMITED',
    'MISFITS HOSPITALITY (OPC) PRIVATE LIMITED',
    'RESOP SOLAR GLOBAL (OPC) PRIVATE LIMITED',
    'VARSHAM EVENTS AND ENTERTAINMENT PRIVATELIMITED',
    'UNBOUND MARKETING PRIVATE LIMITED',
    'MILLION INSIGHTS PRIVATE LIMITED',
    'WHITE PAPER SUMMITS PRIVATE LIMITED',
    'BULDANA URBAN MANAGEMENT SERVICES PRIVATE LIMITED',
    'STRATAENVIRO PRIVATE LIMITED',
    'SYSKA MITERR PRIVATE LIMITED',
    'DAYDREAM WORLDWIDE CONSULTANTS PRIVATE LIMITED',
    'MARCIA METS INDIA PRIVATE LIMITED',
    'TESTING LIFELINE PRIVATE LIMITED',
    'VERTSCEND AUTOMATION PRIVATE LIMITED',
    'PERDURABLE UTILITY SERVICES PRIVATE LIMITED',
    'XOR BIT INFOTECH PRIVATE LIMITED',
    'KLEOS INTERNATIONAL PRIVATE LIMITED',
    'COGTEK SOLUTIONS PRIVATE LIMITED',
    'OM SHRI SHUBH LABH AGRITECH PRIVATE LIMITED',
    'INVENTIVE INTELTECH PRIVATE LIMITED',
    'BG DESIGN INDIA PRIVATE LIMITED',
    'TOGG AGRO INDIA PRIVATE LIMITED',
    'VAVS SUPPORT SERVICES PRIVATE LIMITED',
    'BRILLEXCE IT HUB PRIVATE LIMITED',
    'FIVEFOLD RENEWABLE PRIVATE LIMITED',
    'REPOS ENERGY INDIA PRIVATE LIMITED',
    'TRUSTING SOCIAL PRIVATE LIMITED',
    'VDA KPO SERVICES PRIVATE LIMITED',
    'EDGECRAFT SOLUTIONS PRIVATE LIMITED',
    'APARUP AND JIJO MEDIA PRODUCTIONS PRIVATE LIMITED',
    'GOTARNE FARM SOLUTIONS (OPC) PRIVATE LIMITED',
    'ADESHA ADVISORY SERVICES PRIVATE LIMITED',
    'ALTERNATE TI PRIVATE LIMITED',
    'RANGASHILA FOUNDATION',
    'PARVATI MOHITE FOUNDATION',
    'TELENETWORKS TECHNOLOGIES PRIVATE LIMITED',
    'FAR LEFT RETAIL PRIVATE LIMITED',
    'FOUNDATION FOR RURAL ENTREPRENEURSHIP DEVELOPMENT',
    'DOLPHIN MONEY PRIVATE LIMITED',
    'QUAY INTECH PRIVATE LIMITED',
    'ALLIGATE IT SOLUTION PRIVATE LIMITED',
    'ADVAY CAPITAL ADVISORS PRIVATE LIMITED',
    'SASVITHA HOME FINANCE LIMITED',
    'PROFECTUS CAPITAL PRIVATE LIMITED',
    'MAXVALUE CHITS PRIVATE LIMITED',
    'PARAKKAL INDIA NIDHI LIMITED',
    'JUBILANCE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'YELLOWFISH DIGITAL INNOVATIONS PRIVATE LIMITED',
    'GOLD KNIGHT EXIM PRIVATE LIMITED',
    'SL RESIDENTIAL LAYOUT PRIVATE LIMITED',
    'VIVRITI CAPITAL LIMITED',
    'BANYAN VENTURES & INVESTMENT PRIVATE LIMITED',
    'SOMAYA HOMES PRIVATE LIMITED',
    'BRANCH INTERNATIONAL FINANCIAL SERVICES PRIVATE LIMITED',
    'PINAK INSURANCE MARKETING PRIVATE LIMITED',
    'MAHIRA BUILDWELL PRIVATE LIMITED',
    'OLD FIR ADVISORS INDIA PRIVATE LIMITED',
    'DORAL REAL ESTATES PRIVATE LIMITED',
    'FOURD BUILDSPACE PRIVATE LIMITED',
    'ECLECTIC HARBOUR CREATORS PRIVATE LIMITED',
    'PSV URBANA PRIVATE LIMITED',
    'SKILLATHON TECHNOLOGIES PRIVATE LIMITED',
    'TRACK LINE COURIER SERVICES PRIVATE LIMITED',
    'SSTS INFRAMANTRA PRIVATE LIMITED',
    'OVO TRIP INDIA PRIVATE LIMITED',
    'JULEH EXPERIENTIAL TRAVELS PRIVATE LIMITED',
    'FAIRFREIGHT LINES PRIVATE LIMITED',
    'ADITYA TRADING SOLUTIONS IFSC PRIVATE LIMITED',
    'ZYMIN INDIA PRIVATE LIMITED',
    'WEALTH DISCOVERY FINANCE PRIVATE LIMITED',
    'AIRBEAS ONLINE TRAVEL PRIVATE LIMITED',
    'SVOJAS ENTERPRISES PRIVATE LIMITED',
    'ST NETWORK SOLUTIONS PRIVATE LIMITED',
    'ANUBHAV SOUTH INDIA HOLIDAYS PRIVATE LIMITED',
    'DIVYAM EXPRESS & LOGISTICS PRIVATE LIMITED',
    'OPTIMISTIC EXPRESS & CARGO PRIVATE LIMITED',
    'SUREMAN FINANCIAL SERVICES PRIVATE LIMITED',
    'KSBL CONSULTANCY SERVICES PRIVATE LIMITED',
    'JM FINANCIAL INSTITUTIONAL SECURITIES LIMITED',
    'WUXEL FINANCIAL SERVICES PRIVATE LIMITED',
    'FACTOR FINANCIAL PRIVATE LIMITED',
    'SOMRAS INVESTMENTS PRIVATE LIMITED',
    'STO EXPRESS LOGISTICS (INDIA) PRIVATE LIMITED',
    'SUTAMBRI FINANCE PRIVATE LIMITED',
    'SHRYNAX INFOTECH PRIVATE LIMITED',
    'ASY TRAVEL SOLUTIONS PRIVATE LIMITED',
    'INDSPRINT LOGISTICS PRIVATE LIMITED',
    'AEROBONIX SOLUTIONS PRIVATE LIMITED',
    'ASHER SHIPPING AND LOGISTICS PRIVATE LIMITED',
    'GLOTTIS SHIPPING PRIVATE LIMITED',
    'XCELL SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'NOSTALGIC TOURISMS PRIVATE LIMITED',
    'PORISEVA WELLNESS & MEDITOUR PRIVATE LIMITED',
    'JUSTA EXPERT TRAVEL SOLUTION PRIVATE LIMITED',
    'OCEAN 2 DOOR INDIA PRIVATE LIMITED',
    'MAHINDRA SUSTAINABLE ENERGY PRIVATE LIMITED',
    'KONNEXIONS BROADCAST PRIVATE LIMITED',
    'PROMINOUS INNOVATIONS PRIVATE LIMITED',
    'RELISERVE ENTERPRISES PRIVATE LIMITED',
    'INDIA ASSIST INSIGHTS PRIVATE LIMITED',
    'TRUREV MED CONSULTANCY PRIVATE LIMITED',
    'STERLITE CONVERGENCE LIMITED',
    'DEPARTURE SOLUTIONS INDIA PRIVATE LIMITED',
    'MAILERPORT PRIVATE LIMITED',
    'PROPEL APPS PRIVATE LIMITED',
    'INNOVEST HOSPITALITY MANAGEMENT SERVICESPRIVATE LIMITED',
    'MATCHLESS RESTAURANT PRIVATE LIMITED',
    'KAVV FOODS PRIVATE LIMITED',
    'WHEELS TRANSLOG PRIVATE LIMITED',
    'BTL LOGISTICS PRIVATE LIMITED',
    'SHIFT SUPPLY CHAIN SOLUTIONS PRIVATE LIMITED',
    'MORTAR & PESTLE HOSPITALITY PRIVATE LIMITED',
    'SOMETHING SAUCY PRIVATE LIMITED',
    'WINTUS SALES PRIVATE LIMITED',
    'GODSMATTHEW TRADING INDIA PRIVATE LIMITED',
    'NUTRIMENT RETAIL PRIVATE LIMITED',
    'CHENZIRA LOGISTICS PRIVATE LIMITED',
    'ROH VRR TRANSLOGISTICS PRIVATE LIMITED',
    'GR TRANSPORT SOLUTION PRIVATE LIMITED',
    'MACHE PRIVATE LIMITED',
    'NICOBAR DESIGN PRIVATE LIMITED',
    'KEFA SHIPPING PRIVATE LIMITED',
    'SMILING TRIPS & HOLIDAYS PRIVATE LIMITED',
    'RAS TECHSERV INDIA PRIVATE LIMITED',
    'MAK VEE WATER EQUIPMENTS PRIVATE LIMITED',
    'KLEZMER HOSPITALITY PRIVATE LIMITED',
    'VISION FOODWORKS PRIVATE LIMITED',
    'SINERGIA SQUARE PRIVATE LIMITED',
    'AACE JOURNEYS PRIVATE LIMITED',
    'TOPVIEW INFOLABS PRIVATE LIMITED',
    'METHAL VENTURES PRIVATE LIMITED',
    'AMBATTUR HOTELS PRIVATE LIMITED',
    'FAN HOSPITALITY SERVICES PRIVATE LIMITED',
    'ETRIO AUTOMOBILES PRIVATE LIMITED',
    'GOODEARTH DESIGN STUDIO PRIVATE LIMITED',
    'WORKFORCE ARABIA PRIVATE LIMITED',
    'SMARTFLY VACATIONS PRIVATE LIMITED',
    'GREAT EXPERIENCES TRAVEL PRIVATE LIMITED',
    'REJUVENATING WELLNESS HIDEAWAYS PRIVATE LIMITED',
    'GENERATION INFINITE MACHINES PRIVATE LIMITED',
    'RK DUGGAL STUDIOS PRIVATE LIMITED',
    'REFRATECHNIK (INDIA) PRIVATE LIMITED',
    'SHRI SAHIB JI FAB MART PRIVATE LIMITED',
    'RELATIONAL FIELD PRIVATE LIMITED',
    'NEUROEDUCATION AND RESEARCH FOUNDATION',
    'NEXTIA SOLUTIONS PRIVATE LIMITED',
    'AMANAT IMPEX PRIVATE LIMITED',
    'E3I SKILLS PRIVATE LIMITED',
    'AADHAR SALES AND SERVICES PRIVATE LIMITED',
    'BLACKBIRD LABS PRIVATE LIMITED',
    'ARISTA INTERIOR INDIA PRIVATE LIMITED',
    'AADIVEDA RETAILS PRIVATE LIMITED',
    'ANIYAM BPO SERVICES PRIVATE LIMITED',
    'BASAVASHAKTI INTEGRATED FOOD PARK PRIVATE LIMITED',
    'PROBUS ADVISORS PRIVATE LIMITED',
    'NBCC ENVIRONMENT ENGINEERING LIMITED',
    'ZEST SMART SOLUTIONS PRIVATE LIMITED',
    'GUJJU TOURS PRIVATE LIMITED',
    'ASIA INFRAPROJECTS INTERNATIONAL LIMITED',
    'CARE TECHNICAL AND FACILITY SERVICES PRIVATE LIMITED',
    'INNER METALWARE PRIVATE LIMITED',
    'GRAPH CONSULTANTS AND MARKETING PRIVATE LIMITED',
    'NOESIS BROADCOM PRIVATE LIMITED',
    'CUKNOX PRIVATE LIMITED',
    'RV PARADISE PRIVATE LIMITED',
    'MICRA CLOUD SERVICES PRIVATE LIMITED',
    'FACMED PHARMACEUTICALS PRIVATE LIMITED',
    'NEW YORK TECHNOLOGY INDIA PRIVATE LIMITED',
    'BELIV STUDIOS PRIVATE LIMITED',
    'PROBEPLUS INNOVATIVE SOLUTIONS PRIVATE LIMITED',
    'SRAVENCO CONSULTING SERVICES PRIVATE LIMITED',
    'AVTOW PRIVATE LIMITED',
    'GOVISORY SERVICES PRIVATE LIMITED',
    'EXPEDISE TRAVEL PRIVATE LIMITED',
    'WELLRAY SOLAR INDUSTRIES PRIVATE LIMITED',
    'PARAMAHAMSA SUSTAINABLE LIVELIHOODS FOUNDATION',
    'OVERCOW SOFTWARE INDIA PRIVATE LIMITED',
    'DIVED HITECH PRIVATE LIMITED',
    'BLANK SLATE ENTERTAINMENT PRIVATE LIMITED',
    'VEDBIZ TECHNOLOGIES PRIVATE LIMITED',
    'WOWHOOD SHOPPING PRIVATE LIMITED',
    'RAG SHIPPING PRIVATE LIMITED',
    'LILKIS RESOURCES PRIVATE LIMITED',
    'RUBAROO BREAKING SILENCES FOUNDATION',
    'OASISSERVE DESIGN SERVICES PRIVATE LIMITED',
    'ZAWFT SOLUTIONS PRIVATE LIMITED',
    'MCI GETS INDIA PRIVATE LIMITED',
    'RELCUBE INDIA PRIVATE LIMITED',
    'GGC MEDIA INTERNET PRIVATE LIMITED',
    'ASTATHON TECHNOLOGIES PRIVATE LIMITED',
    'OGENUS GLOBAL SOLUTIONS PRIVATE LIMITED',
    'FLUTRON PROPERTIES PRIVATE LIMITED',
    'SALUTO WELLNESS PRIVATE LIMITED',
    'PARIKH FLEXIBLES PRIVATE LIMITED',
    'VIBHAV ENERGY PRIVATE LIMITED',
    'FUNN DYNAMIX PRIVATE LIMITED',
    'OATH TECH INDIA PRIVATE LIMITED',
    'STARRUBY.IN PRIVATE LIMITED',
    'OLALIAN ESTATE PRIVATE LIMITED',
    'TECH9 APPLICATION AND SOLUTIONS PRIVATE LIMITED',
    'FEDORAS FACILITY SERVICES PRIVATE LIMITED',
    'ASH AMAIRA RETAIL PRIVATE LIMITED',
    'CARECRES SERVICES INDIA PRIVATE LIMITED',
    'AIC-NIFT TEA INCUBATION CENTRE FOR TEXTILES AND APPARELS',
    'CREATIIVE ENGINEERING SPECIAL MACHINES PRIVATE LIMITED',
    'STREY PRIVATE LIMITED',
    'GLOBO SWISS PRIVATE LIMITED',
    'VOLERY TECHNOLOGIES PRIVATE LIMITED',
    'MAYASHANTI NATURALS PRIVATE LIMITED',
    'CAIRS TECHNOLOGY INDIA PRIVATE LIMITED',
    'DESOCON TECHNOLOGIES PRIVATE LIMITED',
    'ECO FUNGO PRIVATE LIMITED',
    'SHEEVOOT INTERNATIONAL PRIVATE LIMITED',
    'ALTUM BUSINESS SOLUTIONS PRIVATE LIMITED',
    'CONTENU WRITING SERVICES PRIVATE LIMITED',
    'FYRA INSIGHTS PRIVATE LIMITED',
    'URBAN TEA CAFES PRIVATE LIMITED',
    'KARMATECH IT SERVICES PRIVATE LIMITED',
    'NOESIS PUBLISHING SERVICES PRIVATE LIMITED',
    'SHRUTINA FOUNDATION',
    'WILDLIFE VINTAGE RESORTS PRIVATE LIMITED',
    'ORATREE SOLUTIONS PRIVATE LIMITED',
    'RNGALLA FAMILY PRIVATE LIMITED',
    'APRA AMUSEMENT PRIVATE LIMITED',
    'BRIVONA ADVISORS PRIVATE LIMITED',
    'KND REALTY24 PRIVATE LIMITED',
    'RUSIYA HEALTHCARE PRIVATE LIMITED',
    'ORANTIQ TECHNOLOGIES PRIVATE LIMITED',
    'GERABAA TECH PRIVATE LIMITED',
    'CURE INGREDIENTS PRIVATE LIMITED',
    'BRIGHT BROADCASTING PRIVATE LIMITED',
    'KANJALOCHANA FINSERVE PRIVATE LIMITED',
    'AUTHLINQ LABS PRIVATE LIMITED',
    'GIFTOLEXIA SOLUTIONS PRIVATE LIMITED',
    'VEYRON TECHNOLOGIES PRIVATE LIMITED',
    'INDSPIRATION FOODS PRIVATE LIMITED',
    'DST OVERSEAS PRIVATE LIMITED',
    'DATATERRAIN INDIA PRIVATE LIMITED',
    'AKSHARDHVANI LEARNING FOUNDATION',
    'SMARTTERRA URBAN WATER MANAGEMENT PRIVATE LIMITED',
    'FLOW MATICS PRIVATE LIMITED',
    'TAGEALTH ADVISORY SERVICES PRIVATE LIMITED',
    'THEORETIC SOFTNET PRIVATE LIMITED',
    'GRL CARGO MOVERS PRIVATE LIMITED',
    'KANJ PRODUCTS PRIVATE LIMITED',
    'COSAIA PRIVATE LIMITED',
    'EMILENCE PRIVATE LIMITED',
    'EARTHLY JOY GLOBAL PRIVATE LIMITED',
    'ANCIENT RUG WEAVERS PRIVATE LIMITED',
    'AURELIA CONSULTANCY SERVICES PRIVATE LIMITED',
    'INRABO HOSPITALITIES PRIVATE LIMITED',
    'WEST INN BANGALORE PRIVATE LIMITED',
    'XECUTELAB TECHNOLOGIES PRIVATE LIMITED',
    'EASY HOME FINANCE LIMITED',
    'LEARNFREAKOUT DIGITAL SOLUTIONS PRIVATE LIMITED',
    'PINKROCK ENTERPRISES PRIVATE LIMITED',
    'EQUATION CALIBRATION SERVICES PRIVATE LIMITED',
    'PROLOGGING-IN IT PRIVATE LIMITED',
    'ENTIGRITY PRIVATE LIMITED',
    'GUNNO ENTERTAINMENT PRIVATE LIMITED',
    'RHEWUM INDIA PRIVATE LIMITED',
    'PARIDHI UDYOG PRIVATE LIMITED',
    'SPAECARE PRIVATE LIMITED',
    'FARSIGHT TECHNOLOGIES PRIVATE LIMITED',
    'LI-IONS ELEKTRIK SOLUTIONS PRIVATE LIMITED',
    'PAYTM ENTERTAINMENT LIMITED',
    'HEELIUM SPORTS PRIVATE LIMITED',
    'VNS KAYAKALPA HERBAL FORMULATIONS PRIVATE LIMITED',
    'YAMS VENTURES PRIVATE LIMITED',
    'ADMIRE BUSINESS SOLUTIONS PRIVATE LIMITED',
    'ALEXANDERWERK INDIA PRIVATE LIMITED',
    'TRIZIN INFOTECH PRIVATE LIMITED',
    'ELECTRODRIVE POWERTRAIN SOLUTIONS PRIVATE LIMITED',
    'IMON CONSULTANTS PRIVATE LIMITED',
    'BIDWARRIORS ONLINE SMART SOLUTIONS PRIVATE LIMITED',
    'HENGMEI ETRADE PRIVATE LIMITED',
    'YOUKESHU TRADING PRIVATE LIMITED',
    'ECODEW PURE WATER SOLUTIONS PRIVATE LIMITED',
    'TOFFCOVER CORE TECHNOLOGIES PRIVATE LIMITED',
    'UIV FINANCIAL DISTRIBUTION PRIVATE LIMITED',
    'ORMID INDIA PRIVATE LIMITED',
    'TRINODO HR SERVICES PRIVATE LIMITED',
    'SMRITHI RENEWABLE ENERGY PRIVATE LIMITED',
    'EXBORDER ONLINE TRADING PRIVATE LIMITED',
    'SKS ENVIRO SOLUTIONS PRIVATE LIMITED',
    'BIZ IURIS CONSULTING INDIA LIMITED',
    'AAYANSH GERMINATE PRIVATE LIMITED',
    'OCHIRA DEVELOPERS PRIVATE LIMITED',
    'MONGERBOX TRADE PRIVATE LIMITED',
    'MATICS INDIA PRIVATE LIMITED',
    'SHRIMAHAVEER HOME FURNISH EXPO PRIVATE LIMITED',
    'SECURE INDIAN PRIVATE LIMITED',
    'MAIA SETHNA DIGITAL (OPC) PRIVATE LIMITED',
    'ITUMM INDIA PRIVATE LIMITED',
    'ALGORIS DIGITAL PRIVATE LIMITED',
    'OPTIMUM MEASURES PRIVATE LIMITED',
    'NINIGINO TRADING PRIVATE LIMITED',
    'MEMORIES INTERIOR DESIGNS E-COMMERCE PRIVATE LIMITED',
    'CELERITIO SOFTWARE PRIVATE LIMITED',
    'LOGIMETRIX INFRA PRIVATE LIMITED',
    'NEXTLEVEL TOUCH SOLUTIONS PRIVATE LIMITED',
    'WEIGHING EQUIPMENT MANUFACTURERS ASSOCIATION',
    'TNM ONLINE SOLUTIONS PRIVATE LIMITED',
    'YASH MULTIVENTURE PRIVATE LIMITED',
    'FLYERTECH AUTOMOTIVE OPERATIONS PRIVATE LIMITED',
    'GOOD SOAP PRIVATE LIMITED',
    'REJOICE EVENT AND PRODUCTION MANAGEMENT PRIVATE LIMITED',
    'SKYWIN VALVE PRIVATE LIMITED',
    'RPR AGRO PROCESSING PRIVATE LIMITED',
    'AJV DEVELOPERS PRIVATE LIMITED',
    'LOOPBELL TECH (INDIA) PRIVATE LIMITED',
    'AVS RIVERLINE PRIVATE LIMITED',
    'V&S AIR TECHNIQUE PRIVATE LIMITED',
    'YADADRI FURNITURE INDUSTRIES PRIVATE LIMITED',
    'MULTIYILEGO EKART PRIVATE LIMITED',
    'DSG VENTURES PRIVATE LIMITED',
    'NAVITEK LOGISTICS PRIVATE LIMITED',
    'ARCHITHA RENEWABLE ENERGY PRIVATE LIMITED',
    'ZESTY INNOVENTURES PRIVATE LIMITED',
    'XEMOTIVE ENERGY PRIVATE LIMITED',
    'NISSAN AGRO TECH INDIA PRIVATE LIMITED',
    'CONSOLIDATED DESIGN SERVICES PRIVATE LIMITED',
    'SUPPLYCOMPASS MANUFACTURER SOURCING PRIVATE LIMITED',
    'OPSMAINT (INDIA) BRIDGE DC PLATFORM PRIVATE LIMITED',
    'ENERFRA GRID SOLUTIONS PRIVATE LIMITED',
    'THINKSHIELD INDIA PRIVATE LIMITED',
    'AVSOM OVERSEAS PRIVATE LIMITED',
    'MUNILEK ELECTRIC PRIVATE LIMITED',
    'HACTAH EXPERIENCE ENTERTAINMENTS PRIVATELIMITED',
    'JAIAMBEY ENTERPRISES PRIVATE LIMITED',
    'WAF GARAGE VENTURES PRIVATE LIMITED',
    'AUTO SHIELD HD COATINGS PRIVATE LIMITED',
    'NVTPHYBRIDGE INDIA PRIVATE LIMITED',
    'TWOWAITS TECHNOLOGIES PRIVATE LIMITED',
    'LITEHIRES GLOBAL PRIVATE LIMITED',
    'DCUBE CONSULTANTS PRIVATE LIMITED',
    'MODERN FNB PRIVATE LIMITED',
    'VOILET SOLUTIONS PRIVATE LIMITED',
    'MECVEL TECHNOLOGIES PRIVATE LIMITED',
    'ZAM CARRIERS PRIVATE LIMITED',
    'JTPM METAL TRADERS PRIVATE LIMITED',
    'HEXAWATA INTERNATIONAL TRADE PRIVATE LIMITED',
    'NYASAA HUMAN DEVELOPMENT AND RESEARCH CENTER',
    'IBL FINANCE LIMITED',
    'TATKAL LOAN INDIA PRIVATE LIMITED',
    'HARITA ARC PRIVATE LIMITED',
    'SHS FINVEST PRIVATE LIMITED',
    'WISHFIN INSURANCE WEB AGGREGATOR PRIVATELIMITED',
    'RADIUS DESIGN STUDIO PRIVATE LIMITED',
    'AD INSURANCE MARKETING PRIVATE LIMITED',
    'OCARE HEALTH INSURANCE LIMITED',
    'GCORP RESIDENCES PRIVATE LIMITED',
    'CLAYWORKS SPACES TECHNOLOGIES PRIVATE LIMITED',
    'YOTTOL FINANCIAL SERVICES PRIVATE LIMITED',
    'ZREYA WEALTH SOLUTIONS PRIVATE LIMITED',
    'PHFL HOME LOANS AND SERVICES LIMITED',
    'VIRAL INFRAPROJECTS PRIVATE LIMITED',
    'GREEN SCAPES DEVELOPERS PRIVATE LIMITED',
    'VERITE SMART HOMES PRIVATE LIMITED',
    'YELLOW SAPPHIRE FINANCIAL SERVICES PRIVATE LIMITED',
    'SUJA CHIT FUND PRIVATE LIMITED',
    'EBIX CAPITAL EXCHANGE PRIVATE LIMITED',
    'SPARKLE ONE MALL DEVELOPERS PRIVATE LIMITED',
    'TURFCON INFRA PROJECTS LIMITED',
    'AJV COLONY BUILDERS PRIVATE LIMITED',
    'L.H. INFRATECH PRIVATE LIMITED',
    'ZESTARD TECHNOLOGIES PRIVATE LIMITED',
    'AASHINI SOFTWARE CONSULTING PRIVATE LIMITED',
    'AJV HOMES PRIVATE LIMITED',
    'REALDECK ADVISORY SERVICES PRIVATE LIMITED',
    'ALLUREVIEW REAL ZONE PRIVATE LIMITED',
    'GROBEY DEVELOPERS PRIVATE LIMITED',
    'CSA INFRATECH PRIVATE LIMITED',
    'DPL CONSTRUCTION PRIVATE LIMITED',
    'NEST ZONE INDIA PRIVATE LIMITED',
    'HIGH MERITT PROPEX PRIVATE LIMITED',
    'AEROVATIVE TECHNOLOGIES PRIVATE LIMITED',
    'ULTRON VENTURES PRIVATE LIMITED',
    'PROIASYS IT SERVICES PRIVATE LIMITED',
    'MOBLOGIC SOFTNET PRIVATE LIMITED',
    'WISSENSCHAFT TECHNOLOGIES PRIVATE LIMITED',
    'LURK ESTATE PRIVATE LIMITED',
    'NGP DEVELOPER PRIVATE LIMITED',
    'ZUHAUSE REALTY PRIVATE LIMITED',
    'SUNLY DEVELOPERS PRIVATE LIMITED',
    'DOM REALITY PRIVATE LIMITED',
    'DEZNCON INTERIORS PRIVATE LIMITED',
    'MAGURE SOFTWARES PRIVATE LIMITED',
    'YESTE PROPERTIES PRIVATE LIMITED',
    'DIGNITECH MEDIA WORKS PRIVATE LIMITED',
    'JBS TECH-SOLUTIONS PRIVATE LIMITED',
    'BAGAI INNOVATIONS PRIVATE LIMITED',
    'EKNOUS TECHNOLOGY SOLUTIONS PRIVATE LIMITED',
    'EUDEMONIC TECHNOLOGIES PRIVATE LIMITED',
    '4P DIGITAL TECHNOLOGIES PRIVATE LIMITED',
    'ECHOAPPS360 SOLUTIONS PRIVATE LIMITED',
    'STEALTH GUARD PRIVATE LIMITED',
    'INDBYTES TECHNOLOGIES PRIVATE LIMITED',
    'ORIS TECHNOLOGIES INDIA PRIVATE LIMITED',
    'ZN NETWORK SOLUTIONS INDIA PRIVATE LIMITED',
    'IOTICS TECHNOLOGY PRIVATE LIMITED',
    'OPINE INFOTECH PRIVATE LIMITED',
    'TURINGS XYZ PRIVATE LIMITED',
    'DEVNEEL INFRASTRUCTURE PRIVATE LIMITED',
    'AAIS SQUARE SOLUTION PRIVATE LIMITED',
    'WEBIXUN INFOWAYS PRIVATE LIMITED',
    'NEW BOMBAY BUILD TECH PRIVATE LIMITED',
    'AUTO-QED SOFTWARE SERVICES PRIVATE LIMITED',
    'MODEZ TECH INGENIOUS PRIVATE LIMITED',
    'DIGAMBAR TECHNOLOGIES PRIVATE LIMITED',
    'QURX MHEALTH SOLUTIONS PRIVATE LIMITED',
    'ASHWINI INFOCOM PRIVATE LIMITED',
    'VIRTUOUS ASSISTANT AND CLOUD TECHNOLOGIES PRIVATE LIMITED',
    'OCCIPITAL LABS PRIVATE LIMITED',
    'SRITSAV IT SOLUTIONS PRIVATE LIMITED',
    'FINEXCORE INDIA PRIVATE LIMITED',
    'CODEPRO INTEGRATED SOLUTIONS PRIVATE LIMITED',
    'ONEDIGITALS SOFT SOLUTION INDIA PRIVATE LIMITED',
    'INGENIUM AUTOMATION INDIA PRIVATE LIMITED',
    'IGROW INFO SOURCE PRIVATE LIMITED',
    'DECKORAMA VENTURES PRIVATE LIMITED',
    'REFERRALYOGI TECHNOLOGIES PRIVATE LIMITED',
    'SHAIVI INFOTECH SERVICES PRIVATE LIMITED',
    'SALZER COLLABORATION PRIVATE LIMITED',
    'ROMENTO TECHNOLOGY PRIVATE LIMITED',
    'VERAVALONLINE PRIVATE LIMITED',
    'GLEAM ONE LABS PRIVATE LIMITED',
    'DAALCHINI TECHNOLOGIES PRIVATE LIMITED',
    'INCUBXPERTS TECHNOCONSULTING PRIVATE LIMITED',
    'INCREMENTAL APPLICATIONS PRIVATE LIMITED',
    'CYBERSCRIPT IT SOLUTIONS PRIVATE LIMITED',
    'WORKSPOT PRIVATE LIMITED',
    'RAMACHANDRA RAO YERNENI (OPC) PRIVATE LIMITED',
    'KENTECH INFORMATICS (OPC) PRIVATE LIMITED',
    'AIRBRILS PRIVATE LIMITED',
    'CLEAREDGE INFOSOLUTION PRIVATE LIMITED',
    'TECHMOLOGICS INNOVATIONS PRIVATE LIMITED',
    'HIFERK TECHNOLOGIES PRIVATE LIMITED',
    'FORESIGHTCFO PRIVATE LIMITED',
    'RIOT GAMES PRIVATE LIMITED',
    'AFFISE TECHNOLOGIES INDIA PRIVATE LIMITED',
    'AAHOSTAF PRIVATE LIMITED',
    'KUZA TECHNOLOGIES PRIVATE LIMITED',
    'UPAYAN TECH SOFTWARE PRIVATE LIMITED',
    'IQI SOLUTIONS PRIVATE LIMITED',
    'VARENYA NETSHIELD SECURITY SOLUTIONS PRIVATE LIMITED',
    'RINSE N.PURE SURFACTANTS PRIVATE LIMITED',
    'PAVEHOUSE EXPORTS OVERSEAS PRIVATE LIMITED',
    'COGNORE (INDIA) PRIVATE LIMITED',
    'OZARK INNOVATIONS PRIVATE LIMITED',
    'GORAKSTAR TECHNOLOGIES PRIVATE LIMITED',
    'NAK TRANSCRIPTION & LEGAL TECHNOLOGIES PRIVATE LIMITED',
    'NAAVA FREIGHT SERVICES PRIVATE LIMITED',
    'IRISSTAR TECHNOLOGIES PRIVATE LIMITED',
    'TOPRUN AUTOMOTIVE INDIA PRIVATE LIMITED',
    'ROCKWELL ADVERTISING PRIVATE LIMITED',
    'SKYLUXE WELLNESS BRANDS PRIVATE LIMITED',
    'ASNA HIREXTRA PRIVATE LIMITED',
    'HINDUSTAN BIKE RESCUE PRIVATE LIMITED',
    'PEPPRO COLLECTIVE PRIVATE LIMITED',
    'FINACPLUS GLOBAL SERVICES PRIVATE LIMITED',
    'JHINK ZMED DISTRIBUTORS PRIVATE LIMITED',
    'RECVUE INDIA PRIVATE LIMITED',
    'SUCCESS METRIC PRIVATE LIMITED',
    'IGLOO FROYO & ISCREAMS PRIVATE LIMITED',
    'ATASNIYA ENTERPRISES PRIVATE LIMITED',
    'KUWY TECHNOLOGY SERVICE PRIVATE LIMITED',
    'TIVONA GLOBAL TECHNOLOGIES PRIVATE LIMITED',
    'D4E NETWORK INDIA PRIVATE LIMITED',
    'TALODYN NETWORKS PRIVATE LIMITED',
    'QBNOX SYSTEMS PRIVATE LIMITED',
    'COLLOSSUS BPO PRIVATE LIMITED',
    'Manomayy technologies private limited',
    'Shivamtech engineering design private limited',
    'Vidya online services (pune) private limited',
    'Infovity india private limited',
    'Vrushali infotech private limited',
    'YJINUS TECHNOLOGIES PRIVATE LIMITED',
    'KONSTANT INFOSOLUTIONS PRIVATE LIMITED',
    'Octans technologies private limited',
    'Regency infotech private limited',
    'SYENA INFOSOFT PRIVATE LIMITED',
    'PALTECH CONSULTING PRIVATE LIMITED',
    'Boss consulting private limited',
    'Advanced computer solutions private limited',
    'Shanta software solutions private limited',
    'I axis limited',
    'Ektha.com private limited',
    'Dela soft private limited',
    'Renata technologies private limited',
    'Mithril telecommunications private limited',
    'Palette interactive india private limited',
    'ABHIPRAY SEVA PRIVATE LIMITED',
    'Saru soft technologies private limited',
    'Avenir it private limited',
    'DIVAMI DESIGN LABS PRIVATE LIMITED',
    'Cartel software private limited',
    'Rsg information systems private limited',
    'Naava info solutions private limited',
    'Gmp infosystems private limited',
    'KLR INFOTECH PRIVATE LIMITED',
    'Softnice india private limited',
    'Virtus it india private limited',
    'YANA MOBILITY INDIA PRIVATE LIMITED',
    'Elbrit digital private limited',
    'Arose technosoft private limited',
    'Virile it solutions private limited',
    'THRYLOS IT SERVICES PRIVATE LIMITED',
    'Paralok information security private limited',
    'Idea entity research labs private limited',
    'MYTECH GLOBAL PRIVATE LIMITED',
    'Zeesoft solutions private limited',
    'Grindwell norton limited',
    'Shri keshav cements and infra limited',
    'Indsil hydro power and manganese limited',
    'Jhagadia copper limited',
    'Entegra limited',
    'Marsons limited',
    'Easun reyrolle limited',
    'MOSCHIP TECHNOLOGIES LIMITED',
    'Vst tillers tractors limited',
    'Poddar bhumi holdings limited',
    'Spectacle ventures limited',
    'COLORCHIPS NEW MEDIA LIMITED',
    'U g hotels and resorts limited',
    'Aftek limited',
    'ZENLABS ETHICA LIMITED',
    'Saven technologies limited',
    'Ccs infotech limited',
    'Pcs technology limited',
    'Gaylord ceramics limited',
    'Paul merchants limited',
    'Ashram online com limited',
    'Can fin homes limited',
    'Vishnu chemicals limited',
    'Superspace Infrastructure Limited',
    'Parenteral drugs (india) limited',
    'Oxford suites private limited',
    'Modi orchards limited',
    'Indikos trading private limited',
    'Unnati manz biotec dairy farms private limited',
    'R.n.k. agro and chemicals private limited',
    'Scorpio biosolutions private limited',
    'S.r. corporate consultant private limited',
    'Narasimha agri farms private limited',
    'Genera agri refineries limited',
    'Koeleman india private limited',
    'PARADIGM AGRI RESEARCH & DEVELOPMENT PRIVATE LIMITED',
    'Green earth shety farms private limited',
    'Expat agro farm private limited',
    'Associate plantations private limited',
    'GARAPATI AGROTECH PRIVATE LIMITED',
    'Sahiti farms private limited',
    'Dev agri farms private limited',
    'Rapid organic private limited',
    'Ace corporate agri ventures private limited',
    'Expat haven estate private limited',
    'Kanai-bijoli rice mills private limited',
    'Criyagen agri & biotech private limited',
    'Petrof agro impex private limited',
    'Msg exports private limited',
    'Saujesh chemicals private limited',
    'AMBOLI RUBBER & PLANTATIONS PRIVATE LIMITED',
    'RANGANA RUBBER & PLANTATIONS PRIVATE LIMITED',
    'MANERI RUBBER & PLANTATIONS PRIVATE LIMITED',
    'Nerur rubber & plantations private limited',
    'Halaval rubber & plantations private limited',
    'Tarkali rubber & plantations private limited',
    'Vijayadurg rubber & plantations private limited',
    'Shirgav rubber & plantations private limited',
    'Talera rubber & plantations private limited',
    'Kasal rubber & plantations private limited',
    'HITRON HERBAL SEED COAT PRIVATE LIMITED',
    'SHIMOGA PRECISION CASTINGS PRIVATE LIMITED',
    'Nanchil infrastructure private limited',
    'Vijay sea foods and exports private limited',
    'Ramanagaram aqua farms private limited',
    'Powerjac systems private limited',
    'Aarjay international private limited',
    'Chathur realtors private limited',
    'Xtreme zone sports and services private limited',
    'Bcc enterprises (india) limited',
    'Ceramin india private limited',
    'Classic oilfield supplies and services private limited',
    'Naaraayani minerals private limited',
    'Emco goa private limited',
    'Sri lakshmi narasamma minerals private limited',
    'Trident marbles private limited',
    'KALINGA CRUSHERS & CONSTRUCTION PRIVATE LIMITED',
    'Shree dwarkadhis marble mining private limited',
    'Gelda marbles private limited',
    'Legend stone private limited',
    'Galaxy rockmin private limited',
    'Mansarowar mining private limited',
    'Joy international india private limited',
    'Samruddhi proteins private limited',
    'Zelos food products ( i ) private limited',
    'CHAROEN POKPHAND TRADING (INDIA) PRIVATELIMITED',
    'S s r b food processing private limited',
    'Inocorp marketing private limited',
    'Prime oleochem private limited',
    'Velagapudi foundation',
    'Anmol healthcare private limited',
    'Rpa foods private limited',
    'Aurofood private limited',
    'DOSANI FROZEN FOODS PRIVATE LIMITED',
    'Sree kara foods private limited',
    'Chitra dairy private limited',
    'Windor india private limited',
    'Receta pharmaceuticals india private limited',
    'Delastream solutions private limited',
    'S s c shoes private limited',
    'Kanna chemie private limited',
    'Crosimn agencies private limited',
    'Acr engineering sales and services private limited',
    'Centerprise tech (i) private limited',
    'Chennai hydro maatics private limited',
    'Genex india bioscience private limited',
    'Sahyadri agencies limited',
    'Sagacious technologies limited',
    'Amber multi trading private limited',
    'Asda trading company private limited',
    'Magnusarc international private limited',
    'New rain papers private limited',
    'Liberson agencies pvt. ltd.',
    'Novoflex marketing private limited',
    'Basukinath vincom private limited',
    'Stand21 exports (india) private limited',
    'Lynx synergy and solutions private limited',
    'Multivac india private limited',
    'Miyas life sciences private limited',
    'Ayushakti health care private limited',
    'Cook india medical devices private limited',
    'Mts pipes and tubes private limited',
    'Jp essentials exports india private limited',
    'Ever best lumber private limited',
    'Kriztle bath & wellness private limited',
    'Sree comtrade private limited',
    'Cbc corporation (india) private limited',
    'Hirahvac tradelinks private limited',
    'Jmdvfm cars india private limited',
    'Katban lighting solution private limited',
    'Marwadi impex private limited',
    'J b advani and company private limited',
    'Nensey logistics india private limited',
    'Soujanya enterprises pvt ltd',
    'Senator financial services private limited',
    'Tripuri traders private limited',
    'Pohoomal worldwide exports private limited',
    'Reverse logistics & warehousing private limited',
    'Omni impex private limited',
    'Growmore investments and developers private limited',
    'Salona trade-invest private limited',
    'Vibha agencies private limited',
    'Chemie alliance (india) private limited',
    'Silicon exports private limited',
    'Santoor impex private limited',
    'Shell trading private limited',
    'Marchesini group india private limited',
    'Imr resources india private limited',
    'VANNA INFORMATION TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Mrp traders private limited',
    'Comfort vanijya pvt ltd',
    'Vinay impex private limited',
    'Ml international private limited',
    'Dreymoor trading private limited',
    'Royer india private limited',
    'Tipsons commodities private limited',
    'Goldcoin foam private limited',
    'Giriraj instruments private limited',
    'Me mach international private limited',
    'Agco trading (india) private limited',
    'JUST SHOPPING PRIVATE LIMITED',
    'AMBACO CHEMICALS AND LIFE SCIENCES PRIVATE LIMITED',
    'Fourcee infrastructure equipments private limited',
    'Suresh rathi commodities private limited',
    'Uniprogen biotech private limited',
    'Tanaria apparel private limited',
    'Kaybee natural resources private limited',
    'Allnew business private limited',
    'BLOCKCUBE TECHNOLOGY LIMITED',
    'DALMIA BIZ TRAVEL AND HOSPITALITY PRIVATE LIMITED',
    'A l r trading private limited',
    'Niche retail private limited',
    'Nirmal supermarkets private limited',
    'DHIRAJ SONS MEGASTORE PRIVATE LIMITED',
    'Khera marketings private limited',
    'Vblaze exports private limited',
    'MOITER WORKZ PRIVATE LIMITED',
    'BUKALO INDIA PRIVATE LIMITED',
    'Madurai tara traders private limited',
    'Enviro home solutions private limited',
    'Corona technologies india private limited',
    'NOVOFLEX INDUSTRIES PRIVATE LIMITED',
    'Jibandeep financial marketing limited',
    'Diamour jewels private limited.',
    'Goldking biogene private limited',
    'Brawn globus turnkey solutions private limited',
    'Rex-rotary (india) private limited',
    'Gazebo restaurants and department stores private limited',
    'Gl hospitality private limited',
    'Kanwal holiday resorts private limited',
    'KINGDOM HOTEL & RESORTS PRIVATE LIMITED',
    'VHIVE COLIVING PRIVATE LIMITED',
    'Raysons residency private limited',
    'Dragon i resorts private limited',
    'Ukn hospitality private limited',
    'Irv engineering india private limited',
    'Kevin power solutions limited',
    'Ultraspan precast products private limited',
    'Site concepts private limited',
    'Rapid global business solutions india private limited',
    'Rwdi consulting engineers (india) private limited',
    'ENCAD TECHNOLOGIES PRIVATE LIMITED',
    'FOURESS ENGINEERING(INDIA) PRIVATE LIMITED',
    'Ibi chematur (engineering and consultancy) limited',
    'Equip enviro-engineers private limited',
    'Tru care consultants private limited',
    'Matrix landscape architecture private limited',
    'Smv projects private limited',
    'ORGANO ECO HABITATS PRIVATE LIMITED',
    'Technicaliya consultants private limited',
    'Quadra architects private limited',
    'Gs gem scan laboratories private limited',
    'Standup communications private limited',
    'Malayalam communications limited',
    'Media creative consultants private limited',
    'JAY ',
    'JAY HOARDING COMPANY PRIVATE LIMITED',
    'Arun art printers private limited',
    'Inoways display services private limited',
    'Convergence events private limited',
    'Point blank advertising private limited',
    'Cityscape advertising (mumbai) private limited',
    'Gestione ministration private limited',
    'Khemchand vijaykumar metal industries pvt ltd',
    'Nahar retail trading services limited',
    'Vigasa industries private limited',
    'Shakti borax private limited',
    'Skyline engineering contracts (india) pvt limited',
    'Rainbow petrochem industries private limited',
    'Adidas india marketing private limited',
    'REFOP INDIA COMPANY',
    'Denso haryana private limited',
    'Bsi group india private limited',
    'Drinksrus beverages private limited',
    'Abbscissa hr consulting private limited',
    'Prosper consulting solutions private limited',
    'SANMARG FACILITY & ASSETS MANAGEMENT ENTERPRISES INDIA PRIVATE LIMITED',
    'Seela infratech private limited',
    'Hdi xs cam electronics private limited',
    'Knowcraft analytics private limited',
    'BHARATI TRADING ENTERPRISES PRIVATE LIMITED',
    'Element8 transformation solutions private limited',
    'Phoenix accounting & taxation service private limited',
    'Jagruti dmec artisanat private limited',
    'Anritsu india private limited',
    'Magic ecommerce private limited',
    'Medverve healthcare private limited',
    'Julabo temperature control systems india private limited',
    'Synastus multiconsulting private limited',
    'Mindcom services private limited',
    'Continental cryogenics private limited',
    'Preflex solutions private limited',
    'Kevalin spirit private limited',
    'Secure parking private limited',
    'PHARMASOFTTECH AWACS PRIVATE LIMITED',
    'KONICA MINOLTA MARKETING SERVICES INDIA PRIVATE LIMITED',
    'Transocean drilling services (india) private limited',
    'Karia infraprojects private limited',
    'Camp card solutions private limited',
    '360 ONE ASSET MANAGEMENT LIMITED',
    'ASSURED ADVERTISING & MEDIA PRIVATE LIMITED',
    'Integrity logistic solution (india) private limited',
    'Marwar consultancy private limited',
    'Samyag commodities private limited',
    'Vvaleti management solutions private limited',
    'Modern engineering contracting company private limited',
    'Ariell productions private limited',
    'Evolution infra agro farms and tourism private limited',
    'SDG LABS PRIVATE LIMITED',
    '123 rpo hr services private limited',
    'Fox domotics private limited',
    'Rickshaw communique services private limited',
    'Merisis consultants private limited',
    'Shina automotive india private limited',
    'Creations engineers private limited',
    'Diva bellydance academy private limited',
    'Dap consultants private limited',
    'Raforce security services private limited',
    'Njoy learning processes private limited',
    'IBG FINCON PRIVATE LIMITED',
    'Digilant solutions private limited',
    'Technoace systems private limited',
    'Revathi engineering private limited',
    'Amptronics systems private limited',
    'Idle ants media private limited',
    'Domain clinical data sciences private limited',
    'Global advantage solutions private limited',
    'Vetsante ( india ) private limited',
    'Ingegno transmedia private limited',
    'Iota automation private limited',
    'Acengage infoservices private limited',
    'Value c consulting services private limited',
    'Texol engineering private limited',
    'Frech india machinery private limited',
    'Aeropact precision machining private limited',
    'Cam industries private limited',
    'Dynavac india private limited',
    'Arco therm private limited',
    'V-smart thermotech private limited',
    'Energe capacitors private limited',
    'PLG PHOTOVOLTAIC PRIVATE LIMITED',
    'Stellent systems private limited',
    'Prolific systems and technologies private limited',
    'Laurus software technologies private limited',
    'SUN BRANDING SOLUTIONS (INDIA) PRIVATE LIMITED',
    'Indian transformers company limited',
    'RAHUL BROTHERS ELECTRICALS PRIVATE LIMITED',
    'Flow bangalore waterjet private limited',
    'Sun sine solution private limited',
    'Chery tech (india) private limited',
    'Ditap- v automation private limited',
    'Genn controls india private limited',
    'Rampra steel industries private limited',
    'Metalmeccanica fracasso india private limited',
    'Kanchan power system private limited',
    'Bush electromech and engineering private limited',
    'Innomatec india test and special equipment private limited',
    'Gayatri elecmech private limited',
    'REM ELECTROMACH PRIVATE LIMITED',
    'Shreelight power private limited',
    'Ecorea & kuroda electric india private limited',
    'ASHE CONTROLS PRIVATE LIMITED',
    'Regent rich capacitors private limited',
    'Weigh control systems private limited',
    'Excel micron (poona) pvt ltd',
    'Power matrix solutions private limited',
    'Kyoritsu automation india private limited',
    'Airvision technologies private limited',
    'Dn wind systems india private limited',
    'Gr power switchgear limited',
    'Asmaitha wireless technologies private limited',
    'Semikron electronics private limited',
    'Revmax telecom infrastructures private limited',
    'Saket industries private limited',
    'AEGIS SMART LOGIX INDIA PRIVATE LIMITED',
    'Sargam india electronics private limited',
    'Tagit (india) private limited',
    'Concept asset reconstruction company private limited',
    'Badve helmets india private limited',
    'Jingletoons aniskool private limited',
    'OCEAN DRINKS PRIVATE LIMITED',
    'Kfc shoemaker private limited',
    'Ssa techknowlogies private limited',
    'Reliable analytical laboratories private limited',
    'Print on demand services private limited',
    'Leo marine inspections private limited',
    'Shoolin shipping services (india) private limited',
    'Koppersmith ventures private limited',
    'Compel consultancy private limited',
    'Eco remarketing private limited',
    'Gz financial advisors private limited',
    'FINSTER CARBON PRIVATE LIMITED',
    'PROJKIN ONLINE SERVICES PRIVATE LIMITED',
    'Omni-id india private limited',
    'Dealmytime services private limited',
    'Transocean services (india) private limited',
    'Spintronics itec software india private limited',
    'Fluid motion softwares private limited',
    'Gusto utility products private limited',
    'Happy hippo films private limited',
    'Jaitly haag productions & solutions private limited',
    'Quick mail solutions private limited',
    'Frenz greenearth technologies private limited',
    'Ad home products private limited',
    'Otter controls india private limited',
    'Emerald telcominfra private limited',
    'Procient engineering private limited',
    'Qualcon laboratories private limited',
    'Manisha compositek private limited',
    'Sodexis india private limited',
    'Pittie alcast private limited',
    'SRI SHIRDI SECURITIES PRIVATE LIMITED',
    'Kapil property management private limited',
    'Four-p international private limited',
    'Rultosh edufun private limited',
    'Truven health analytics india private limited',
    'Metec design and construction engineers (india) private limited',
    'Vittena analytics private limited',
    'Young united voluntary action foundation',
    'Goldmoon stock broking private limited',
    'Academy of carver aviation private limited',
    'Dholakia education foundation',
    '40k plus education private limited',
    'MUDBIDRI EDUCATION & CONSULTANTS PRIVATE LIMITED',
    'Srishti holistic life private limited',
    'Skills gurukul private limited',
    'Smart laboratories private limited',
    'Endoc lifecare private limited',
    'Peas healthcare private limited',
    'Anaveom healthcare private limited',
    'Foundation for vital healing',
    'Happy body beautiful private limited',
    'Capitano health care private limited',
    'Athenese-dx private limited',
    'Medifine healthcare private limited',
    'NILGIRI',
    'Syntron controls private limited',
    'Cem electromech private limited',
    'Securezone india private limited',
    'NANDIKA PAPER PRODUCTS PRIVATE LIMITED',
    'Makita power tools india private limited',
    'Biax electric and controls private limited',
    'Advansys (india) private limited',
    'Navicom technology international private limited',
    'Sudhir electricals pvt ltd',
    'Hi-q electronics private limited',
    'Tellus telecom private limited',
    'Kaptronics private limited',
    'Visa consolidated support services (india) private limited',
    'Siae microelettronica india private limited',
    'Altiostar networks india private limited',
    'Bs technotronics private limited',
    'Prama instruments private limited',
    'Ajosha bioteknik private limited',
    'Nirav biosolutions private limited',
    'Tri county dental supply (india) private limited',
    'D4 surgicals (india) private limited',
    'Edgetech scientific private limited',
    'NEXTGEN CLEANTECH SOLUTIONS PRIVATE LIMITED',
    'Arm infra projects private limited',
    'Pushti hill residency private limited',
    'Anand constrotech india private limited',
    'Sundew properties limited',
    'Sushila devi kochar infracon private limited',
    'Sachit estates private limited',
    'AADIDEVA INFRATECH PRIVATE LIMITED',
    'Rmp real estates private limited',
    'VAIHUTI INFOTECH PRIVATE LIMITED',
    'Sea crest builders private limited',
    'Thirubalaa realtors private limited',
    'Santoshi infraprojects private limited',
    'Eclectic developers private limited',
    'Sanchay residency private limited',
    'Rezcom realty private limited',
    'S s j power projects and infrastructures private limited',
    'Light and grips equipments hirers (india) private limited',
    'Infinite computing systems private limited',
    'Kabir infosolution india private limited',
    'Prumatech infosystems private limited',
    'SRI ANANTHA LAKSHMI COTTON MILLS PRIVATE LIMITED',
    'Techmerits software solutions private limited',
    'Akl outsourcing private limited',
    'Luminous e-soft solutions private limited',
    'C i network technologies private limited',
    'New media guru india private limited',
    'Ganesha technosystems private limited',
    'Gujarat infotech limited',
    'Sls industries private limited',
    'Analytix business solutions (india) private limited',
    'Magic systems private limited',
    'Alakmalak technologies private limited',
    'Capacity web solutions private limited',
    'Automation anywhere software private limited',
    'Multidots solutions private limited',
    'Aldiablos infotech private limited',
    'DEVSTREE I.T. SERVICES PRIVATE LIMITED',
    'Shakunsoft it solutions private limited',
    'Crest data systems private limited',
    'Codal systems private limited',
    'Genotypic technology private limited',
    'Naavinya cad soft private limited',
    'Mobile aspects india private limited',
    'Tulasi technologies private limited',
    'Sybor solutions private limited',
    'Intech solutions private limited',
    'Aviohelitronics infosystems private limited',
    'Ktwo technology solutions private limited',
    'Dvr softek india private limited',
    'Inncrewin technologies private limited',
    'Trio it services private limited',
    'Prakat solutions private limited',
    'Intact green services (india) private limited',
    'ANEXSECURE SECURITY SOLUTIONS PRIVATE LIMITED',
    'Translanteck nesting & automation india private limited',
    'Lucini & lucini communications asia pacific private limited',
    'Apponix technologies private limited',
    'A plus intellisoft solutions private limited',
    'Evisco systems private limited',
    'AIMSPRE EDUCATION PRIVATE LIMITED',
    'PIVOTREE SOLUTIONS INDIA PRIVATE LIMITED',
    'Integration wizards solutions private limited',
    'Pivotsys technologies private limited',
    'Litmus7 systems consulting private limited',
    'Techions software labs private limited',
    'R p techsoft international private limited',
    'Nat infotech solutions private limited',
    'Icelab solutions private limited',
    'Blue ripples technologies private limited',
    'Vismaya infotech solutions private limited',
    'Eastgate infotech private limited',
    'Leading edge infotech limited',
    'TRULY PROMPTIT PRIVATE LIMITED',
    'Gallant infotech private limited',
    'Buildbyte.com. (india) private limited',
    'Idream advisory services private limited',
    'Log soft solution private limited',
    'Softaculous limited',
    'Raj infotech-total network solutions private limited',
    'Codigami technologies private limited',
    'List india private limited',
    'Code domain solutions private limited',
    'Xpanxion international private limited',
    'Emtec technologies private limited',
    'Agranee solutions private limited',
    'Dvs technosoft private limited',
    'E-maximus solutions india private limited',
    'Sureline systems india private limited',
    'CYFUTURE INDIA PRIVATE LIMITED',
    'Jp informatics private limited',
    'Saras india systems private limited',
    'Canny technologies (hyderabad) private limited',
    'Kensium solutions private limted',
    'Pmr softtech private limited',
    'Ctrl s datacenters limited',
    'JEEVIDAM LIMITED',
    'Stratus foods private limited',
    'Piyo juice india private limited',
    'Tara coffee (india) private limited',
    'Funky kitchen company private limited',
    'Vignette food specialities private limited',
    'Hybrid agricultural limited',
    'Best sugar private limited',
    'Shivratna sugars limited',
    'Kakinada foods private limited',
    'H2o resources private limited',
    'Ghanta rajendraprasad tobacco company private limited',
    'United polyfab private limited',
    'Aquarius tex fab private limited',
    'Zenith apex private limited',
    'Derik monofil private limited',
    'Texspun industries private limited',
    'MARUTI NOUVEAUKNITS PRIVATE LIMITED',
    'Dhaval fabrics private limited',
    'NUPUR FINSERVE PRIVATE LIMITED',
    'Sudarshan exports limited',
    'Kapotex industries private limited',
    'KOHA DECOR PRIVATE LIMITED',
    'SPL ECR HIGHWAY PRIVATE LIMITED',
    'METER MALL PRIVATE LIMITED',
    'NEWS MECHANICS PRIVATE LIMITED',
    'ACORNIA INVESTMENT SERVICES PRIVATE LIMITED',
    'BOOTSTRAPPERS RESEARCH COUNCIL',
    'SHATAYU CONSULTING ENGINEERS (OPC) PRIVATE LIMITED',
    'M-TECH GARDENS PRIVATE LIMITED',
    'GENIUNE FACILITIES MANAGEMENT PRIVATE LIMITED',
    'COCOBLU RETAIL LIMITED',
    'WEBLEDGER SOLUTIONS PRIVATE LIMITED',
    'MEDCOR SWASTHYA SERVICE PRIVATE LIMITED',
    'JAGITRO SOLUTIONS PRIVATE LIMITED',
    'SIMAV NATURALS PRIVATE LIMITED',
    'KADAM HAAT PRODUCER COMPANY LIMITED',
    'KBS WORLD PRIVATE LIMITED',
    'TIKET INTERNATIONAL NETWORK PRIVATE LIMITED',
    'UTKAL LNG PRIVATE LIMITED',
    'NISITA INDUSTRIES PRIVATE LIMITED',
    'ENVOSAFE AQUA SOLUTIONS PRIVATE LIMITED',
    'BHIWANI BUILDTECH PRIVATE LIMITED',
    'UNIEXPERTS HIGHERED PRIVATE LIMITED',
    'MADELIN ENTERPRISES PRIVATE LIMITED',
    'BLUEORBIT TECHNOLOGIES PRIVATE LIMITED',
    'BISWA GAMES PRIVATE LIMITED',
    'NEW EDGE INFOTECH PRIVATE LIMITED',
    'THE POWER ACADEMY PRIVATE LIMITED',
    'CYNSAR FOUNDATION',
    'PICKMYAD SOLUTIONS PRIVATE LIMITED',
    'SUTECH IT PRIVATE LIMITED',
    'AAKESH CLOTHING PRIVATE LIMITED',
    'DREAM METPLAST PRIVATE LIMITED',
    'SPINNY INSURANCE BROKER PRIVATE LIMITED',
    'FRIENDBASE INDIA PRIVATE LIMITED',
    'VANADURGA ENTERPRISE PRIVATE LIMITED',
    'BIOWAX ORGANIC INDIA PRIVATE LIMITED',
    'B AWARE PRIVATE LIMITED',
    'MARKETUS INDIA PRIVATE LIMITED',
    'AIP PRODUCTS AND SOLUTIONS PRIVATE LIMITED',
    'BALLY IMPERIA OWNERS ASSOCIATION',
    'LOST FERRY INTERACTIVE PRIVATE LIMITED',
    'CAMOTEC INDIA PRIVATE LIMITED',
    'VIDESH E VIDHYA PRIVATE LIMITED',
    'HW NEWS PRIVATE LIMITED',
    'FUTURE CHOICE CLUB PRIVATE LIMITED',
    'SHRI SHUBHAM ADVISORS PRIVATE LIMITED',
    'BITROCKET LABS PRIVATE LIMITED',
    'AIVG INDUSTRIES PRIVATE LIMITED',
    'SVADESHI TECHNOLOGIES PRIVATE LIMITED',
    'ODPL EV PRIVATE LIMITED',
    'URBANRISE CONDOMINIUMS PRIVATE LIMITED',
    'ONFIELD TECHNOLOGIES PRIVATE LIMITED',
    'SIDHYATI FOODS PRIVATE LIMITED',
    'SHOOT JUNCTION PRIVATE LIMITED',
    'LITTLE PROMISE ORGANISATION',
    'GREEN ENERGY RESOURCES PORTS PRIVATE LIMITED',
    'TUTORSADDA PRIVATE LIMITED',
    'INDOTHAI GAYA PRIVATE LIMITED',
    'JOBME.ONLINE PRIVATE LIMITED',
    'AMOR ORGANICS PRIVATE LIMITED',
    'ABS QE ASSURANCE SERVICES PRIVATE LIMITED',
    'PHARMOCEAN HEALTHCARE PRIVATE LIMITED',
    'PITTIE ANTARIKSH GRL PRIVATE LIMITED',
    'PEACHCODE REALTY PRIVATE LIMITED',
    'KYOMI LIFESTYLE PRIVATE LIMITED',
    'TEAM ENERGY ELECTRIC VENTURE PRIVATE LIMITED',
    'CRE OFFICE SPACE PRIVATE LIMITED',
    'GAMECHANGE SOLAR SERVICES INDIA PRIVATE LIMITED',
    'KW LIGHTING TECHNOLOGY PRIVATE LIMITED',
    'ZETA TECH SOLUTIONS PRIVATE LIMITED',
    'YOSHIDA INDIA PRIVATE LIMITED',
    'ACTIA AUTOMOTIVE INDIA PRIVATE LIMITED',
    'SHEARWATER GEOSERVICES INDIA PRIVATE LIMITED',
    'FRUITSVALLEY FARMERS PRODUCER COMPANY LIMITED',
    'PRISM AUTOMATION AND ROBOTICS PRIVATE LIMITED',
    'VJSAR INFO TECH PRIVATE LIMITED',
    'ARISINFRA TRADING PRIVATE LIMITED',
    'WILL INKS AND PAINTS PRIVATE LIMITED',
    'EVION ENERGY LIMITED',
    'ROOFOODS PRIVATE LIMITED',
    'BURAQ INDUSTRIES PRIVATE LIMITED',
    'VARPRAD TOOLING SERVICES PRIVATE LIMITED',
    'SEEDSAVERS AGRITECH PRIVATE LIMITED',
    'VCB-VIBE CUSTOMIZED BEAUTY PRIVATE LIMITED',
    'CINNAMON VENTURES PRIVATE LIMITED',
    'ARSONS PHARMACEUTICALS PRIVATE LIMITED',
    'PRAYANA ROADWAYS PRIVATE LIMITED',
    'JANAK DULARI MEGACORP PRIVATE LIMITED',
    'MK CAB SERVICES PRIVATE LIMITED',
    'CYBERNET BROADBAND PRIVATE LIMITED',
    'AIRAWAT INDICES PRIVATE LIMITED',
    'LUNIO FOUNDATION',
    'KINOSPHERE PRIVATE LIMITED',
    'NOVALARK INFRA PRIVATE LIMITED',
    'MOHANJI BHARAT WELFARE FOUNDATION',
    'DIFFERENTIATE INTERNATIONAL PRIVATE LIMITED',
    'SOLTECH TECHSERVICES PRIVATE LIMITED',
    'M&A ADVISORS BHARAT PRIVATE LIMITED',
    'MEGHMANI LIFESCIENCES LIMITED',
    'GRADWINS CONSULTING SERVICES PRIVATE LIMITED',
    'CEPHUS BRAND TECHNOLOGIES PRIVATE LIMITED',
    'PLANTSTRONG MARKETING PRIVATE LIMITED',
    'INTELLIENERGY ELECTRIC PRIVATE LIMITED',
    'JEHSOM FOOD PRODUCTS PRIVATE LIMITED',
    'NAGRALL FOODS PRIVATE LIMITED',
    'SOC CIRCUITS TECHNOLOGIES PRIVATE LIMITED',
    'AIRTICS EDUCATION PRIVATE LIMITED',
    'JMR HEALTHCARE INDIA PRIVATE LIMITED',
    'CELEBRATIONS PRIVATE LIMITED',
    'BELOW2 IMPACT SOLUTIONS INDIA PRIVATE LIMITED',
    'SOHARWA BAZAAR PRIVATE LIMITED',
    'AURO VACCINES PRIVATE LIMITED',
    'TECHDATA NETWORKS PRIVATE LIMITED',
    'KADUKAR ENPRO ENTERPRISES PRIVATE LIMITED',
    'ESPANGLE CONSULTING PRIVATE LIMITED',
    'ELMECO ASIA PACIFIC PRIVATE LIMITED',
    'BINARYQ GLOBAL SOLUTIONS PRIVATE LIMITED',
    'WAVICLE DATA SOLUTIONS INDIA PRIVATE LIMITED',
    'KEN INFOSYSTEMS PRIVATE LIMITED',
    'CRYPTOTAX (OPC) PRIVATE LIMITED',
    'NEW SIVA AGENCIES PRIVATE LIMITED',
    'CHAO CHAO FOODS PRIVATE LIMITED',
    'PRISHAA JMD PRIVATE LIMITED',
    'INGRECONNECT PRIVATE LIMITED',
    'ALLES IT SOLUTIONS PRIVATE LIMITED',
    'MEDTECH IT AND HEALTHCARE INNOVATION COUNCIL',
    'SRCL BUILDWELL PRIVATE LIMITED',
    'AVANT GARDE INDUSTRIES PRIVATE LIMITED',
    'HORA FINANCE PRIVATE LIMITED',
    'SAVIOM DIGITAL SOLUTIONS PRIVATE LIMITED',
    'HOUSR PROPCO PRIVATE LIMITED',
    'PRAKRITI MYTHRI FARMER PRODUCER COMPANY LIMITED',
    'WAY FORWARD CONSULTANCY PRIVATE LIMITED',
    'NETWALK TECHNOLOGIES (INDIA) PRIVATE LIMITED',
    'OTTATHINGAL D-ZAIN PRIVATE LIMITED',
    'STARK INSURANCE BROKING PRIVATE LIMITED',
    'BLACK NERVE PRIVATE LIMITED',
    'ELITEMARK INFRA PRIVATE LIMITED',
    'SUMMIT FOOTWEAR INDIA PRIVATE LIMITED',
    'SAFARI MANUFACTURING LIMITED',
    'GOWITH GREEN E-VEHICLES PRIVATE LIMITED',
    'BLUE HAWK LIFE SCIENCES PRIVATE LIMITED',
    'SRK CAPITAL PRIVATE LIMITED',
    'BHANOT FOODS PRIVATE LIMITED',
    'IRELIA SPORTS INDIA PRIVATE LIMITED',
    'LIVESLOKA INTERNATIONAL PRIVATE LIMITED',
    'HRJ ENGINEERING PRIVATE LIMITED',
    'ESWARR MANUFACTURING INDUSTRIES PRIVATE LIMITED',
    'LASER SECURE SOLUTIONS PRIVATE LIMITED',
    'KMS GLOBAL METALIKS PRIVATE LIMITED',
    'MAGIC PENCILS CONSULTING PRIVATE LIMITED',
    'PRADHAR DESIGNS PRIVATE LIMITED',
    'TEEMER TECH PRIVATE LIMITED',
    'RCGM FOODS PRIVATE LIMITED',
    'MUNDRA SOLAR TECHNOLOGY LIMITED',
    'PROXIMASIDE TECHNOLOGY PRIVATE LIMITED',
    'Z23 STARTUP DIGITAL STUDIO PRIVATE LIMITED',
    'UDYAM AVIATION AND AEROSPACE PRIVATE LIMITED',
    'JINDAL INDIA RE LIMITED',
    'NKDP DATA PARKS PRIVATE LIMITED',
    'MAKE MY FLIGHT (OPC) PRIVATE LIMITED',
    'GREEN TODAY FARMING PRIVATE LIMITED',
    'PLATING PRODUCTS IND PRIVATE LIMITED',
    'CASAGRAND EVERTA PRIVATE LIMITED',
    'PINTAR INDIA SOFTWARE PRIVATE LIMITED',
    'LUKAHEALTHCARE PRIVATE LIMITED',
    'MYFILMMAKER PRIVATE LIMITED',
    'M P JOSEPH',
    'S BAKASURA MACHINES AND SOLUTIONS PRIVATE LIMITED',
    'ODAVAAS LIFESTYLE PRIVATE LIMITED',
    'BIRUDO3 PRIVATE LIMITED',
    'INAGARCO PRIVATE LIMITED',
    'SEAM STORIES PRIVATE LIMITED',
    'CONTARCTICA MARKETING SERVICES PRIVATE LIMITED',
    'PENCILBRICKS FOUNDATION',
    'MARSWELL FOODS PRIVATE LIMITED',
    'ABBTAS BOILERS PRIVATE LIMITED',
    'STARITY TECH SOLUTIONS PRIVATE LIMITED',
    'SVAJIVA HERBALS PRIVATE LIMITED',
    'SUNWAY RNS TJ PRIVATE LIMITED',
    'TAX MIND CONSULTING PRIVATE LIMITED',
    'LEATHERSZONE PRIVATE LIMITED',
    'LENETEC PRIVATE LIMITED',
    'NS SHIP MANAGEMENT (INDIA) PRIVATE LIMITED',
    'RELIB TECHNOLOGY PRIVATE LIMITED',
    'AIRBUY INDIA PRIVATE LIMITED',
    'AEGISCOVENANT PRIVATE LIMITED',
    'SOLINVO PRIVATE LIMITED',
    'CHOCIZ PRIVATE LIMITED',
    'VEYA TECHNOLOGIES PRIVATE LIMITED',
    'MOVEFWD SOLUTIONS PRIVATE LIMITED',
    'OYIOY INTERNATIONAL PRIVATE LIMITED',
    'MAHIYOO TECHNOLOGIES AND CONSULTING PRIVATE LIMITED',
    'GARZOO TECHNOLOGIES & SOLUTION PRIVATE LIMITED',
    'WIZGLE TECHNOLOGY CONSULTING PRIVATE LIMITED',
    'NCS AUTO HUB PRIVATE LIMITED',
    'PASSIONFRUIT MEDIA PRIVATE LIMITED',
    'AMHAR MEDICARE PRIVATE LIMITED',
    'RAPIDCLOUD SYSTEMS AND SOLUTIONS PRIVATE LIMITED',
    'LECTRONIC SOLUTIONS PRIVATE LIMITED',
    'MAGICTEXT TECHNOLOGIES PRIVATE LIMITED',
    'OAFGLOBAL PRIVATE LIMITED',
    'RAPDFLY PRIVATE LIMITED',
    'INVITAS CONSULTING INDIA PRIVATE LIMITED',
    'SHARIATIL EDUCATION PRIVATE LIMITED',
    'JAGUAR BYTE TECHNOLOGY PRIVATE LIMITED',
    'Finisar technology india private limited',
    'Gramercy soft technologies private limited',
    'Nacre software services private limited',
    'Allvy software solutions private limited',
    'Nakshatra it solutions india private limited',
    'Sivshanth computers services private limited',
    'Primavera management solutions private limited',
    'Vijayant facility services private limited',
    'Chd hospitality private limited',
    'Ares advisory private limited',
    'Gsrb foundation',
    'Stigan staffing solutions private limited',
    'Success pact consulting private limited',
    'Joyam engineers & consultants private limited',
    'Kaapro management solutions private limited',
    'Rgf select india private limited',
    'Iet services (india) private limited',
    'VALUEADDS FACILITIES MANAGEMENT SERVICESPRIVATE LIMITED',
    'ZEVEN SPORTS PRIVATE LIMITED',
    'Baron integrated services private limited',
    'Royal seas merchants private limited',
    'Inpath logistics india private limited',
    'Psa integrated solutions private limited',
    'Pure botanical care private limited',
    'Chitrarth films & studio private limited',
    'Namaste financial services private limited',
    'Muziclub music services private limited',
    'Sri infra consultants private limited',
    'Canter technologies private limited',
    'B & g solar private limited',
    'Ask trade and exhibitions private limited',
    'Brand era space management services private limited',
    'Great stays private limited',
    'Oijo media private limited',
    'Motor education and training association private limited',
    'KCM CONSULTING PRIVATE LIMITED',
    'Gujarat road safety technology development council',
    'I2i telesolutions and telemedicine private limited',
    'Nikseem minerals private limited',
    'Innovative cleaning systems private limited',
    'Cdsl ventures limited',
    'Comart one pre-media private limited',
    'Agaadh coolsol private limited',
    'Sppc advisors private limited',
    'Moneyserve financial services private limited',
    'Fori automation india private limited',
    'Pgsv traders private limited',
    'Auto sales india limited',
    'C m automobiles private limited',
    'Sainath associates private limited',
    'Scandia exim private limited',
    'T.krishna patra and company private limited',
    'Jaipur carestate motors private limited',
    'Frr shares and securities limited',
    'Sanria golf view private limited',
    'Vinra estates & infrastructure private limited',
    'Bombay real estate development company private limited',
    'Da cunha properties and investments private limited',
    'Bombay patliputra construction private limited',
    'Paramount financial management services private limited',
    'Kausar leasing limited',
    'MUTHOOTTU FINANCE AND SERVICES PRIVATE LIMITED',
    'Banaji investments private limited',
    'Balwas investments private limited',
    'Aayushi capital and management services private limited',
    'Gcl commodities private limited',
    'WEALTHSTRATZ CAPITAL PRIVATE LIMITED',
    'Harsh infradevelopers private limited',
    'Verdia consultancy services private limited',
    'Johal forex private limited',
    'Shor shot india private limited',
    'Wrangler builders private limited',
    'Chaque jour outsourcing solutions private limited',
    'R m k estates private limited',
    'Sameer builtaid private limited',
    'Nishtha realtors private limited',
    'Sanya realtors private limited',
    'Ozone builders and developers private limited',
    'Basan commodities limited',
    'Tradehifi stock broking private limited',
    'Supertech expressway projects private limited',
    'Prospect buildtech private limited',
    'Home & soul infrastructure private limited',
    'Ken properties private limited',
    'Safe and sound holdings private limited',
    'Indigo capital india private limited',
    'Elel hotels and investments limited',
    'Ashoke international pvt ltd',
    'Online confin private limited',
    'Vardhaman capital pvt.ltd.',
    'Avani financial and real estate developers private limited',
    'White knight estates private limited',
    'Chryssa real-estate private limited',
    'Dhruvam realtors private limited',
    'Cd equisearch pvt ltd',
    'Malgudi investments private limited',
    'Shyama securities private limited',
    'Meru real estates pvt ltd',
    'DOOGAR AND ASSOCIATES SECURITIES PRIVATELIMITED',
    'Quarkcity india private limited',
    'Sreevatsa real estates private limited',
    'Asha properties pvt ltd',
    'Exim service& surveillance co pvt ltd',
    'Vividha infrastructure private limited',
    'Trishan developers private limited',
    'Seabird complex private limited',
    'Altius estates private limited',
    'General insurance corporation of india',
    'Govind niket pvt ltd',
    'Sunlight infraprojects private limited',
    'Indiavision realty and infrastructure private limited',
    'Greenback constructions private limited',
    'Sahara properties private limited',
    'Sdm agriculture private limited',
    'CALCON FOUNDRY LIMITED',
    'Jsm developers private limited',
    'Umesh properties private limited',
    'Trishul projects private limited',
    'Srei equipment finance limited',
    'J . r. roadlines private limited',
    'Sea star habitat private limited',
    'Bcco realtors private limited',
    'Avasan property developers private limited',
    'Shadow box realty private limited',
    'Signu homes private limited',
    'Prapti developers private limited',
    'Supertech infrastructure private limited',
    'Sms design consultants private limited',
    'Emirates infraprojects private limited',
    'Akashganga projects private limited',
    'Jps reinforced pipes private limited',
    'PROSPURTS CONSULCO PRIVATE LIMITED',
    'Srk residency private limited',
    'Sears real estates private limited',
    'Amrapali silicon city private limited',
    'Cears properties pvt ltd',
    'Ascot heights private limited',
    'Zest dwelltech private limited',
    'Zest heights private limited',
    'Woodlands associates private limited',
    'Corporate infrastructure services private limited',
    'Advaitha ventures private limited',
    'Laukik real estates pvt ltd',
    'Amitabh properties and holdings pvt ltd',
    'Mims infrastructure and properties private limited',
    'Etco properties private limited',
    'Bec minerals private limited',
    'Neelkanth realty private limited',
    'GYANA REALESTATE PRIVATE LIMITED',
    'RAPTURES CORPORATE ADVISORS PRIVATE LIMITED',
    'Odisha infra-tech private limited',
    'Kamyab properties private limited',
    'Veritas habitats private limited',
    'Chamundi estates pvt ltd',
    'James long properties pvt ltd',
    'Rrl spaces ventures private limited',
    'Prime living properties private limited',
    'Ontario construction & investment pvt ltd',
    'Skdj dream home private limited',
    'Shree sai nath documentation india private limited',
    'Sannam s4 management services india private limited',
    'Megabucks financial services private limited',
    'Impact search (india) private limited',
    'Trak online net india private limited',
    'Pgsv consultants private limited',
    'Scan stocks private limited',
    'L.p hospitality private limited',
    'Hermitage estates private limited',
    'Ce serviced offices private limited',
    'Kanika worldwide private limited',
    'Multi form industries india private limited',
    'Jay advisors and structures private limited',
    'Novotree minds consulting private limited',
    'Altendorf india private limited',
    'Dexler energy private limited',
    'Good luck agrotech private limited',
    'J k consultancy and services private limited',
    'Unistal systems private limited',
    'Ansh events activations & promotions private limited',
    'Kundli agro private limited',
    'Link information technology private limited',
    'North india top company private limited',
    'D p woodtech private limited',
    'Igd services private limited',
    'Kannu aditya (india) limited',
    'G & S VINYL LIMITED',
    'Onemed crew private limited',
    'Case cold roll forming limited.',
    'E-quire technologies private limited',
    'Sona meta chem private limited',
    'COMFORTLINE AIRCONDITIONING & REFRIGERATION PRIVATE LIMITED',
    'Ctv networks private limited',
    'Gujarat cropchem private limited',
    'Arun tech industrial services private limited',
    'Sasa estates private limited',
    'Fidelity contracts & services private limited',
    'Devraj jethmal holdings private limited',
    'Bina infomedia private limited',
    'K p r holdings private limited',
    'Fly express logistics private limited',
    'Abhinandan goods private limited',
    'Wital see marketing limited',
    'Ayush estates private limited',
    'Kre8iveminds technologies private limited',
    'CONFLATE FOODS & BEVERAGES PRIVATE LIMITED',
    'Regal tech services private limited',
    'Uda securities private limited',
    'CRC INFRASTRUCTURE PRIVATE LIMITED',
    'Utmost vyapaar private limited',
    'Totalstart entrepreneurship ecosystem developers',
    'Kreeti foundation',
    'Continental automotive brake systems (i) private limited',
    'Competent personnel and allied services private limited',
    'Gi staffing services private limited',
    'Inditex trent retail india private limited',
    'Sanatan logistics private limited',
    'Aditel communications private limited',
    'Aeroeuro engineering india private limited',
    'LIVGUARD MOBILE ACCESSORIES PRIVATE LIMITED',
    'Neo learnings private limited',
    'Firstgen distribution private limited',
    'Senses electronics private limited',
    'Perceptron non contact metrology solutions private limited',
    'Geekay security services private limited',
    'Varsed detectives and securities private limited',
    'Bhagyanagar securities private limited',
    'C. e. testing company pvt. ltd.',
    'Sai working solutions pvt ltd',
    'Miraacle net movies private limited',
    'A b pulp packagings private limited',
    'Confirm marketing private limited',
    'Ratch technologies private limited',
    'HOUSSERS PRIVATE LIMITED',
    'CONCORD HYGIENE INDIA PRIVATE LIMITED',
    'Foundation of independent financial advisors',
    'Rebcor security systems private limited',
    'Fyers investment advisors private limited',
    'Mark vista gateway of services private limited',
    'D.s. design sense limited',
    'AAVIZA ELECTRONICS PRIVATE LIMITED',
    'Ink bling designs private limited',
    'Visweswaraiah technical services private limited',
    'Pinkcity jewelhouse private limited',
    'Radiant business solutions private limited',
    'Ikon retail private limited',
    'Pyridion international private limited',
    'Charms education & immigration services private limited',
    'Hindustan closures private limited',
    'RECKITT BENCKISER (INDIA) Private Limited',
    'Grover international limited',
    'Argus integrated systems private limited',
    'Nikom infrasolutions private limited',
    'Fauna ranch and hospitality private limited',
    'TSM EDUCATION PRIVATE LIMITED',
    'Keva aromatics private limited',
    'Igg services private limited',
    'Second innings india private limited',
    'United hitech private limited',
    'Kalisma impo expo private limited',
    'The chopras i tech private limited',
    'Kalisma fasteners private limited',
    'Proderna biotech private limited',
    'Rockfort it solutions private limited',
    'DOUBLETCH INDIA PRIVATE LIMITED',
    'Vav lipids private limited',
    'Space matrix media private limited',
    'Sri bajrang textile private limited',
    'Srr fashions private limited',
    'Seema fashion pvt ltd',
    'Grace garments ltd',
    'R.S. PRINTFAB PRIVATE LIMITED',
    'SETHNESS-ROQUETTE INDIA PRIVATE LIMITED',
    'KEVA FRAGRANCES PRIVATE LIMITED',
    'Modicon private limited',
    'Concorde fragrances private limited',
    'Ultratech india limited',
    'Maharashtra calcium carbides limited',
    'Johnson matthey chemicals india private limited',
    'Aurangabad carbon products private limited',
    'Arjun food colorants manufacturing private limited',
    'Chemgems (india) private limited',
    'Safe a&t technology private limited',
    'Sapphire (india) publishers private limited',
    'Apt printers and publishers private limited',
    'Shakti bio science limited',
    'Lachemi chemorgs private limited',
    'SHREE SUNSPARK ENERGY PRIVATE LIMITED',
    'SARADHA PRINTING & PUBLICATION PRIVATE LIMITED',
    'Shree shyam inorganics private limited',
    'Knm chemicals private limited',
    'Associated dyestuff private limited',
    'Ivy traders (india) private limited',
    'Nilefos orient fertiliser private limited',
    'Brup-chem (india) private limited',
    'Ananya fibrochem private limited',
    'Ad process (printers) private limited',
    'ADVANCE AGROLIFE PRIVATE LIMITED',
    'Gujarat bio organics private limited',
    'Prism motion pictures private limited',
    'Himanshu paper private limited',
    'STERLING NEW HORIZONS PRIVATE LIMITED',
    'SIDHA HYGIENE PRIVATE LIMITED',
    'B.l.a.polymers private limited',
    'JAISWAL PLASTIC TUBES LTD',
    'Main frame entertainment private limited',
    'Sterling educational stores private limited',
    'A p coated papers pvt ltd',
    'Yash packaging pvt ltd',
    'Shivhari films private limited',
    'Sun petrochemicals private limited',
    'Zoom texmach private limited',
    'Integrated pesticides private limited',
    'Rajeshwari dye-chem private limited',
    'Dhichada cargo weighers and petroleums private limited',
    'Solvate laboratories private limited',
    'Lark laboratories (india) ltd',
    'Vardhman life sciences private limited',
    'Richter themis medicare (india) private limited',
    'Medimpex pharmaceuticals private limited',
    'Synit drugs pvt ltd',
    'Alvaetra laboratories pvt ltd',
    'Mds lubricant private limited',
    'Harsh petrochem private limited',
    'Natco drug discovery private limited',
    'Neospark drugs and chemicals private limited.',
    'Anaga specialities private limited',
    'HISSARIA HYDROCOLLOIDS PRIVATE LIMITED',
    'HINDPRAKASH CHEMICALS PRIVATE LIMITED',
    'Heal crop care private limited',
    'NINAI AGRO BIOTECH PRIVATE LIMITED',
    'Noki technologies private limited',
    'SHREE RAM INDIA GUMS LIMITED',
    'Jaswant rasayan pvt ltd',
    'Express colour scan pvt ltd',
    'Sm crop care bio-tech private limited',
    'Cinnabaris spagyrics (herbals) private limited',
    'Medisales (india) private limited',
    'Phal-jig fine chemicals private limited',
    'KHATRI HEALTHCARE PRIVATE LIMITED',
    'Shivalik remedies private limited',
    'Vallabh dye-chem private limited',
    'Vihita bio-chem private limited',
    'Variety formulations pvt ltd',
    'Ellora paints private limited',
    'Rainbow human care private limited',
    'Canixa life sciences private limited.',
    'Shree balaji plaster private limited',
    'Agrim healthcare private limited',
    'Syglak laboratories private limited',
    'N9 world technologies private limited',
    'Rajasthan medical services corporation limited',
    'Akshay colour dyeings private limited',
    'K.c. manufacturers(india )pvt.ltd.',
    'Ronuplate private limited.',
    'Dhupar sales organisation india pvt ltd',
    'Joy beauty care private limited',
    'Vapi care pharma private limited',
    'Tribhuvanlal kalya and company (india) private limited',
    'Lazor color prints private limited',
    'VASPAL SALT & CHEMICALS PRIVATE LIMITED',
    'P and g ahuja biotech limited',
    'Neotech engineering company pvt ltd.',
    'Meridian medicare limited',
    'Estro pharmaceuticals private limited',
    'Mark tech polymers private limited',
    'Sunbeam elastomers private limited',
    'Trans composites private limited',
    'Bajaj masterbatches private limited',
    'Masiha medica pvt ltd',
    'Pulsar rubber manufacturing company pvt ltd',
    'Miracle facility services private limited',
    'Xrbia abode developers private limited',
    'Goodland properties private limited',
    'Lokhandwala housing & infrastructure private limited',
    'S r infra project private limited',
    'Vibrant infrastructure private limited',
    'Bengal ambuja housing development ltd.',
    'Advantage bengal infrastructure limited',
    'Nano infrastructures private limited',
    'Soma highways private limited',
    'Salil infrastructure private limited',
    'BGR MINING & INFRA LIMITED',
    'Sentia real estate limited',
    'Sophia real estate limited',
    'Sepset real estate limited',
    'Aruna buildwell private limited',
    'Sovereign buildwell private limited',
    'MASTERLINE TELEBIZ LIMITED',
    'Corner office advisors private limited',
    'Anushria realtors private limited',
    'S. n. engitech developers private limited',
    'Crossworld equipments company private limited',
    'Chasha lands private limited',
    'RSS CREATIONS PRIVATE LIMITED',
    'Ved real estate developers private limited',
    'Kewal real estate developers private limited',
    'Devidas constructions private limited',
    'Vm infracon private limited',
    'Supernova arena private limited',
    'Labdhi lifestyle limited',
    'H j realtech private limited',
    'Glistening properties private limited',
    'Blue rock materials private limited',
    'Poojary prefab private limited',
    'Moda living spaces private limited',
    'Kooloday projects private limited',
    'Maa ambe warehousing pvt ltd',
    'Sylvan infrastructure private limited',
    'Shriv buildmat private limited',
    'Savitrimata realtors pvt ltd',
    'Rudra realtech private limited',
    'Ambe properties private limited',
    'ASL WEST ENCLAVE PRIVATE LIMITED',
    'Grand canyon sez private limited',
    'Black canyon sez private limited',
    'Parrot grove private limited',
    'Grassland tower private limited',
    'Blue diamond constructions ltd',
    'Raj ready concrete works private limited',
    'Dediyasan industrial infrastructure development',
    'Woodfield interiors private limited',
    'Bnr infrastructure projects private limited',
    'Inno infra private limited',
    'Pataka infracorp private limited',
    'Srivarsha realtors private limited',
    'Celebrity real estate private limited',
    'S.n.d. properties pvt ltd',
    'Mukund estates private limited',
    'Cosmos landmark private limited',
    'Moonlight niketan pvt ltd',
    'S b realcon private limited',
    'Hi-tech eco estcon private limited',
    'Capricorn lifestyle private limited',
    'Vaikund estates private limited',
    'Raj waterscape properties private limited',
    'Dreamland vintrade private limited',
    'Golden commosales private limited',
    'Euthoria developers private limited',
    'Maxell builders private limited',
    'Suneja infrastructure private limited',
    'Select office suites privat limited',
    'Corona realtors private limited',
    'CYBERISMA TECHNOLOGIES PRIVATE LIMITED',
    'S r e l properties holding (covai) private limited',
    'Nest hi-tek park private limited',
    'Apurti properties private limited',
    'ICONIC METAL SURFACE COATINGS PRIVATE LIMITED',
    'Mallika estates pvt ltd',
    'Basant properties ltd.',
    'Prabha and associates pvt ltd',
    'Saral vinimay private limited',
    'Marut developers pvt ltd',
    'Coppola holdings pvt ltd',
    'Ibiza hotels pvt ltd',
    'Nathco infra project private limited',
    'Vksj realty private limited',
    'P.S.JIVRAJ INFRA PROJECTS PRIVATE LIMITED',
    'Eclipse trades pvt.ltd.',
    'Danke dealers pvt.ltd.',
    'Gopika infrarealty private limited',
    'Gopika realtors private limited',
    'Woodburn plaza private limited',
    'Horizon plaza private limited',
    'Kaamya realtors pvt ltd',
    'Om sai lovely infra group private limited',
    'Evergreen infrastructure (india) private limited',
    'Yashoda promoters private limited',
    'Ild millennium private limited',
    'Mega proptech private limited',
    'Kaanha infrastructure private limited',
    'Camelot estates private limited',
    'Upperland property & power developers private limited',
    'Softmax buildtech private limited',
    'Flanking townships private limited',
    'Kbs smart homes private limited',
    'Ats realworth private limited',
    'Shreebanke bihari buildhome private limited',
    'Ilc land base private limited',
    'SBP TOWNSHIP PRIVATE LIMITED',
    'Quick buildwell private limited',
    'S. PAL IT & ESTATES PRIVATE LIMITED',
    'New wave builders private limited',
    'Palash projects private limited',
    'S r b consortium (realcon) private limited',
    'Shanmughavadivel holdings private limited',
    'James glendye & co pvt ltd',
    'Greencard developers pvt ltd',
    'Abp holdings private limited',
    'Nightingale apartments private limited',
    'Sita devi projects private limited',
    'Sky zoom builders pvt ltd',
    'Trishna niketan pvt ltd',
    'Space-rice projects private limited',
    'Casual infracon private limited',
    'Fluke buildtech private limited',
    'Malwa educom private limited',
    'Usha enclave pvt. ltd.',
    'Falcon abasan pvt. ltd.',
    'Akarsha realty private limited',
    'Nannilam property private limited',
    'P.venkatraman properties private limited',
    'Greatvalue buildtech private limited',
    'Gomteshwar real estate private limited',
    'Sam residency private limited',
    'Gopika enclave private limited',
    'SACHEEROME ADVANCE TECHNOLOGIES PRIVATE LIMITED',
    'Panipat projects private limited',
    'Gopika heights private limited',
    'Avenue homes private limited',
    '4a realty private limited',
    'EXTREME COVET PRIVATE LIMITED',
    'Sonex builders pvt ltd',
    'Natural constructions pvt.ltd.',
    'Jai jasoda nirman private limited',
    'Opus exhibitors private limited',
    'Balram manpower development private limited',
    'Innovations solutions and events private limited',
    'Overdose films private limited',
    'Impact films private limited',
    'Mcura healthcare solutions private limited',
    'Taxila welcure private limited',
    'Yogeshwar healthcare limited',
    'Rana informatics private limited',
    'In-n-out highway motel pvt. ltd.',
    'S k finvest limited',
    'Anand i-power limited',
    'Jyoti audio visual private limited',
    'Showhouse event marketing pvt.ltd.',
    'Asian vision private limited',
    'YAGNA INFRA PRIVATE LIMITED',
    'P k pharmatech private limited',
    'KILKOTAGIRI AND THIRUMBADI PLANTATIONS LIMITED',
    'The puthutotam estates (1943) limited',
    'Darjeeling dooars plantations (tea) ltd.',
    'Britannia industries ltd',
    'Jagatjit industries limited',
    'Vtm limited',
    'Kitex garments limited',
    'Crestchem limited',
    'Lords chemicals ltd',
    'Lords chloro alkali limited',
    'K g petro chem ltd',
    'Elantas beck india limited',
    'Zenith exports limited',
    'V i p industries limited',
    'KKALPANA PLASTICK LIMITED',
    'Panyam cements and mineral industrties limited',
    'Modern malleables ltd',
    'Orient steel & industries ltd',
    'Kabra steel products ltd',
    'Rapicut carbides limited',
    'Vaswani industries limited',
    'Carborundum universal limited',
    'Stone india ltd',
    'Taj gvk hotels and resorts limited',
    'Somany ceramics limited',
    'Lloyds metals and energy limited',
    'Mayukh dealtrade limited',
    'Gaylord impex limited.',
    'POONAWALLA FINCORP LIMITED',
    'REGENT ENTERPRISES LIMITED',
    'Asian hotels (north) limited',
    'Black pagoda art gallery private limited',
    'Lathia rubber manufacfacturing co private limited',
    'Chirag ice factory private limited',
    'Fine packaging private limited',
    'Xin entertainment private limited',
    'Delta step learning private limited',
    'Jharkhand cricket league',
    'Ramakrishna race performance management private limited',
    'Udaipur beverages limited',
    'PRISTINE FACILITY & MANAGEMENT SERVICES PRIVATE LIMITED',
    'Zenith global services private limited',
    'Welldone security services private limited',
    'Mahalakshmi grand infra private limited',
    'Grassroot entertainment private limited',
    'Heatly & gresham (india) private limited',
    'Repair world & life',
    'Medecins sans frontieres india',
    'PAUL SWIFT CREDIT PRIVATE LIMITED',
    'Paul entertainments private limited',
    'DELHI SOCCER PRIVATE LIMITED',
    'Ruffles pharma private limited',
    'Future speciality medicare private limited',
    'Nfs maintenance services private limited',
    'Neogi technologies and research private limited',
    'GLOSTER LIMITED',
    'Kaasee investments limited',
    'Kaushal investments ltd',
    'Flower trading & investment co ltd',
    'Galaxy commercials ltd',
    'Marudhar food & credit ltd',
    'Ratlam industrial ltd',
    'Eider infotech limited',
    'Healthfore technologies limited',
    'Mitcon consultancy & engineering services limited',
    'R r financial consultants ltd',
    'Nu tek india limited',
    'A k capital services limited',
    'Dion global solutions limited',
    'GRM OVERSEAS LIMITED',
    'ESCORTS KUBOTA LIMITED',
    'Enchante jewellery limited',
    'Pasupati spinning and weaving mills limited',
    'EPL LIMITED',
    'Apollo hospitals enterprise limited',
    'Sayaji industries limited',
    'Pae limited',
    'Hindustan organic chemicals limited',
    'Amcan logistics private limited.',
    'Studio one consultants private limited',
    'Dz card (india) private limited',
    'Highway industries limited',
    'Sharu industries private limited',
    'Winner pharmaceuticals private limited',
    'Sandesh infocomm private limited',
    'Suraj horticulture private limited',
    'Sunshine agri private limited',
    'Govardhan farm produce market private limited',
    'Ankur seeds pvt ltd',
    'Association of seed industry',
    'Indo european agro private limited',
    'Marcuras water treatment (india) private limited',
    'Vishal design private limited',
    'Jaipur silver jewels private limited',
    'Uem builders - ansalapi contracts private limited.',
    'Udaa developers private limited',
    'Red fort shahjahan properties private limited',
    'Technosphere developers private limited',
    'Yaadgaar estates private limited',
    'Rajratan jewellers private limited',
    'Essem tecnopinz private limited',
    'Ingenium infrastructure private limited',
    'Ekdant infrabuild private limited',
    'Mgm realtech private limited',
    'Thirani securities private limited',
    'R.b.vanijya private limited',
    'Auto brass private limited',
    'Dillano luxurious jewels limited',
    'Pallonji shapoorji and company private limited',
    'Genext precision auto tech private limited',
    'Ubc engineers private limited',
    'Skyscape developers private limited',
    'Starlit power systems limited',
    'Southern energy development corporation limited',
    'Narne constructions pvt ltd',
    'Apollo educational infrastructure services limited',
    'Bajrang automobiles private limited',
    'TM TRADE & IMPEX PVT LTD',
    'Medica hospitals private limited',
    'Sai shree balajee homes private limited',
    'Harness india private limited',
    'Manomay interiors private limited',
    'Supertech estate private limited',
    'Greatvalue builders private limited',
    'Shakun buildwell private limited',
    'Solid projects private limited',
    'Freedom buildcon private limited',
    'Trimurti projects and developers private limited',
    'Ashaina buildcon private limited',
    'Total interiors solutions private limited',
    'BML ADVERTISING LIMITED',
    'P&r agri energy private limited',
    'Mohiniradha infra private limited',
    'Sivaji builders private limited',
    'Kallat builders private limited',
    'Palash enterprises private limited',
    'Britesky buildcon private limited',
    'Mgps ventures (india) private limited',
    'Lashkari developers pvt. ltd',
    'Abhiman buildtech private limited',
    'Advantium infrastructure private limited',
    'Arp developers private limited',
    'Deepprabha developers private limited',
    'Divyam infradevelopers private limited',
    'Landmark buildprop private limited',
    'S.s.projects limited',
    'Magnum foundations private limited',
    'Rkr hotels private limited',
    'KAHM INDUSTRIES PRIVATE LIMITED',
    'Aac construction company pvt. ltd.',
    'J g properties pvt ltd',
    'Phelps housing finance limited',
    'Subarnarekha properties private limited',
    'Shivakar infra private limited',
    'Vismaya superprojects private limited',
    'Savithur enterprises private limited',
    'ADUKIA INDUSTRIES PRIVATE LIMITED',
    'Flovel energy private limited',
    'Neeshe infrastructure private limited',
    'MALEGAON POWER SUPPLY LIMITED',
    'BLP INDUSTRY.AI PRIVATE LIMITED',
    'Parth projects and construction pvt ltd',
    'Heaven city developers limited',
    'Jaikapeesh projects private limited',
    'Parwan constructions private limited',
    'Satya infrastructures limited',
    'SATYAM ALUMINIUM PRIVATE LIMITED',
    'D j infraprojects private limited',
    'Jharkhand accelerated road development company limited',
    'Odisha bridge & construction corporation limited',
    'Construction portal private limited',
    'Butte patil builders private ltd',
    'DHANUKA COLONISER AND BUILDERS PRIVATE LIMITED',
    'Sevana medineeds private limited',
    'PRIMARC INFRASTRUCTURE DEVELOPERS PRIVATE LIMITED',
    'Bhawani tower private limited',
    'Shulter tower private limited',
    'Karl storz endoscopy india private limited',
    'Namokar buildcon private limited',
    'Shree renuka tunaport private limited',
    'Creations infra india private limited',
    'Pandit javdekar constructions private limited',
    'GORBANDH MARBLES PRIVATE LIMITED',
    'Sl commercial private limited',
    'Brijbhumi construction private limited',
    'Hotel cozy pvt ltd',
    'Hari kripa buildcon private limited',
    'Shyam kripa constructions private limited',
    'Aanchal infrabuild private limited',
    'Mmr construction company private limited',
    'Oasis grace engineering projects private limited',
    'PRIMARC PROJECTS REALTY PRIVATE LIMITED',
    'Ranjit singh malik estates (pvt) ltd',
    'Mr interiors india private limited',
    'Pioneer infradeveloper private limited.',
    'Navratna organisers and developers pvt ltd',
    'Amarpura estates private limited',
    'Centrica india offshore private limited',
    'Kashish buildtech private limited',
    'Zakir real estates private limited',
    'Cityview estate private limited',
    'Gangadhar infrastructure private limited',
    'Peddar property private limited',
    'Shan property private limited',
    'Moon farms and resorts private limited',
    'Rajasthan mega developers private limited',
    'Ananya real estate holdings private limited',
    'Sgc capital private limited',
    'Rr insurance brokers private limited',
    'One Marketing Solutions Private Limited',
    'Pearl insurance investigation consultancies private limited',
    'Rvg awaas private limited',
    'Bhagwati niketan private limited',
    'Bandhan hirise private limited',
    'Rishi complex pvt ltd',
    'Anurag hirise pvt ltd',
    'Bengal merlin housing ltd',
    'Bhagirathi abasan pvt. ltd.',
    'Jalore finvest pvt ltd',
    'J d s holdings private limited',
    'Pragati residencies service private limited',
    'Metrocorp housing corporation private limited',
    'Arihant flats private limited',
    'Nilek developers pvt ltd',
    'Amisha buildcon private limited',
    'Raaviar holdings private limited',
    'Bright star estates private limited',
    'Premio developers private limited',
    'Sukhari apartments private limited',
    'Bhairavkripa developers private limited',
    'Topstar devcon private limited',
    'Topstar plaza private limited',
    'Adhrit towers private limited',
    'Om divine developers and infrastructures private limited',
    'Rajdeep & co. buildtech private limited',
    'Varesha infrahousing private limited',
    'Surasa buildhomes private limited',
    'Satviki buildinfra private limited',
    'Greatvalue realtech private limited',
    'Melange realcon private limited',
    'Prg real estate private limited',
    'Optus realty private limited',
    'Sarvome developers private limited',
    'Shiva krishan estates private limited',
    'YUVA UNITY FARMS PRIVATE LIMITED',
    'Satkriti buildtech private limited',
    'Nishtha shelters private limited',
    'SUPREME CONSULTING AND ADVISORY SERVICES LIMITED',
    'Atiksh buildhomes private limited',
    'Atreya infraheight private limited',
    'Alma assets consultancy private limited',
    'Dhanvin buildsquare private limited',
    'Naksha enclave private limited',
    'ALLIED PROPERTIES & DEVELOPERS PVT LTD',
    'Ganga hightech private limited',
    'Udyogi international private limited',
    'Victoria builders ltd',
    'Vegi buildrise private limited',
    'Vigala buildinfra private limited',
    'Suniti cityhomes private limited',
    'Kanha propmart private limited',
    'Shri dwarkapati builders private limited',
    'Sharanam corporate housing private limited',
    'Rizon developers and infrastructure private limited',
    'Mventure international private limited',
    'Rfk greens food park private limited',
    'Raga developers private limited',
    'Tosha infratech private limited',
    'Shantimay buildcon private limited',
    'Rar sons realtors india private limited',
    'Archana construction pvt ltd',
    'Mayfair garden pvt ltd',
    'Erawat estate private limited',
    'Tdi promoters private limited',
    'Solution beyond software development private limited.',
    'Supersonic technobuild private limited',
    'Asto estate private limited',
    'Jagathi infracon private limited',
    'M n computech private limited.',
    'Angel india cad cam private limited',
    'YUG SECURITIES PRIVATE LIMITED',
    'United software engineering services private limited',
    'Sarvarupa infraheight private limited',
    'Sthira nirman private limited',
    'Croyant software technologies private limited',
    'HARINI SMART PROJECTS AND SERVICES PRIVATE LIMITED',
    'Ornate software solutions private limited',
    'Sadhika buildpro private limited',
    'Viresh navnirman private limited',
    'Vagisha conclave private limited',
    'Sentro max heritage properties private limited',
    'Shree maruti nandan estates private limited',
    'Suchanna estates private limited',
    'Birla buildings limited',
    'Kanta bhan properties pvt ltd',
    'Pranjivan jaitha properties pvt ltd',
    'Eventure softsol private limited',
    'Commerce velocity (india) private limited',
    'One e infosystems pvt ltd',
    'Ocean freight enterprises pvt ltd',
    'Genx info technologies private limited',
    'Amtier infotech limited',
    'Omnia technologies private limited',
    'Arunoday constructions pvt ltd',
    'Merlin recreation private limited',
    'Acme estates pvt ltd',
    'Dallas towers pvt.ltd.',
    'Gawade infra ventures private limited',
    'Anumaa computer software and services private limited',
    'Mpower softcomm private limited',
    'Baba sewanand exports private limited.',
    'G.p. medicos centre private limited',
    'INDO- JAPAN BUSINESS COUNCIL',
    'Park wellness services private limited',
    'Switch n control gears pvt ltd',
    'Skoch development foundation',
    'KARAIKUDI MEDICAL CENTRE AND HOSPITAL LIMITED',
    'Dr. p. bhasin pathlabs private limited',
    'Tata coffee limited',
    'The peria karamalai tea and produce company limited',
    'Western conglomerate limited',
    'Gol offshore limited',
    'The methoni tea company limited',
    'MH INFRAPROJECTS LIMITED',
    'Padmanabh alloys and polymers limited',
    'J j exporters ltd',
    'Modern threads (india) limited',
    'Siyaram silk mills limited',
    'B & A PACKAGING INDIA LIMITED',
    'Sea lord containers limited',
    'Saurashtra paper and board mills ltd',
    'Kesar petroproducts limited',
    'Bharat petroleum corporation limited',
    'Saboo sodium chloro limited',
    'Shentracon chemicals ltd',
    'Kakatiya cement sugar and industries limited',
    'Impex ferro tech ltd',
    'Sika interplant systems limited',
    'S r industries ltd',
    'SMARTLINK HOLDINGS LIMITED',
    'Modern insulators limited',
    'D s kulkarni developers ltd',
    'Mcnally bharat engg co ltd',
    'Tunkai india ltd',
    'Surprise traders ltd',
    'Prix india ltd',
    'Sir shadi lal enterprises limited',
    'Sophia exports limited',
    'NOVOPAN INDUSTRIES PRIVATE LIMITED',
    'Velan hotels limited',
    'Inventive hospitality private limited',
    'Nexton services private limited',
    'Leeway fleet management services private limited',
    'Crowdera ventures private limited',
    'Saks management advisory services private limited',
    'Rar corporate services private limited',
    'Next zen pest control private limited',
    'Sukrt retail private limited',
    'Vcon services private limited',
    'Oche sports private limited',
    'The a team sports & events private limited',
    'Sai interior solutions private limited',
    'Apex fluidomatics private limited',
    'Starflex sealing india private limited',
    'REDLOTUS PHARMTECH PRIVATE LIMITED',
    'Yonyx infomedia private limited',
    'Association of senior living india',
    'Hurdi agro farms private limited',
    'Genuine verification services private limited',
    'INNOVATIVE TECH TEAM MEDIA ENTERPRISES PRIVATE LIMITED',
    'Shreerag engineering and auto private limited',
    'Intuition intelligence india private limited',
    'Emerge vocational skills private limited',
    'Zigma green power private limited',
    'Sinclairs hotels limited',
    'Emami limited',
    'Optiemus infracom limited',
    'OPTIMUS FINANCE LIMITED',
    'AYUSHMAN INFRATECH LIMITED',
    'Exim finance ltd',
    'Jk tyre & industries limited',
    'Sujata investments ltd',
    'Aradhana investments ltd',
    'International data management limited',
    'Hcl technologies limited',
    'Technofab engineering limited',
    'Religare enterprises limited',
    'CLC INDUSTRIES LIMITED',
    'Naraingarh sugar mills limited',
    'Tci industries limited',
    'Laffans petrochemicals limited',
    'Nova industries private limited',
    'Sbt textiles private limited',
    'Jyoti apparels private limited',
    'S.g. enterprises private limited',
    'Gem overseas consultants private limited',
    'Paresh farms pvt ltd',
    'Autumn farms private limited',
    'Gopalkrishna agrofarm pvt ltd',
    'Jazira plantations private limited',
    'Herbicure private limited',
    'Reddy seeds private limited',
    'Edakkal plantations and resorts private limited',
    'Blue ridge farms private limited',
    'Eco planners private limited',
    'Ds agri estates private limited',
    'Synersap botanics private limited',
    'Amgoorie india ltd',
    'Briar susex tea estates private limited',
    'Stanmore estates private limited',
    'Kurangumudi estates private limited',
    'Gillapukri tea co. limited',
    'The poona stud farm private limited',
    'Quantum green private limited',
    'Vaidehi feeds private limited',
    'Sansar green technologies private limited',
    'AMOLIKA AGRO INDIA PRIVATE LIMITED',
    'Hence agro development limited',
    'VENTO POWER PRIVATE LIMITED',
    'Sundial projects private limited',
    'Orange powergen private limited',
    'Chhattisgarh state power transmission company limited',
    'Chhattisgarh state power generation company limited',
    'Chhattisgarh state power distribution company limited',
    'G k green power private limited',
    'Dongfang electric (india) private limited',
    'Entraco-bks busducts private limited',
    'Jitendra automobiles private limited',
    'Dalmia power limited',
    'Tenneco automotive india private limited',
    'Marcons shipping (konkan) private limited',
    'Leela ship recycling private limited',
    'P rajesh ship breaking pvt ltd',
    'DIGIPRO LABS PRIVATE LIMITED',
    'Seo yeong dietech private limited',
    'Pine & peak developers limited',
    'Th estate private limited',
    'I m realtors private limited',
    'Optima development private limited',
    'Canterbury real tech private limited',
    'Pks developers private limited',
    'Safari bikes limited',
    'Atlas cycles sonepat limited',
    'Rubco huat woods private limited',
    'Antony furnitures private limited',
    'Xindo window private limited',
    'Manik chand jewellers private limited',
    'JEWELLERY FOREST PRIVATE LIMITED',
    'Glorious jewellery (india) private ltd.',
    'Vinayak jewels private limited',
    'Easy lifestyle private limited',
    'Netaya jewels private limited',
    'Herbal and natural products india limited',
    'Dayal marketing private limited',
    'BIRLA FURUKAWA FIBRE OPTICS Private Limited',
    'G.g. photo limited',
    'Torrent power services private limited',
    'Aumni transmission industry pvt. ltd.',
    'Goenka power and infra limited',
    'Express projects private limited',
    'Dwaraka plaza construction private limited',
    'MERA PLOT & HOMES PRIVATE LIMITED',
    'Kobelco construction equipment india private limited',
    'Torrent power grid limited',
    'Heidelberg solar private limited',
    'Tuareg marketing private limited',
    'Broadways inn holidays (india) private limited',
    'Discover destinations & holidays private limited',
    'Sree varsha horticulture private limited',
    'Vikas rolls private limited',
    'Avdhoot finance and investment private limited',
    'EV SERVICES INDIA PRIVATE LIMITED',
    'North shore technologies private limited',
    'India news communications limited',
    'R n seth and associates private limited',
    'Automobile corporation of goa limited',
    'Himatsingka motor works limited',
    'Baid commercial enterprises limited',
    'G.n. ispat private limited',
    'ZUARI IAV PRIVATE LIMITED',
    'Luhit tea company pvt ltd',
    'MODI KNITS AND LACES PRIVATE LIMITED',
    'Ebenezer press private limited',
    'Trinity plastics private limited',
    'ESME CONSUMER PRIVATE LIMITED',
    'Advent polycoats private limited',
    'Arati marketing pvt ltd',
    'Malhar offset private limited',
    'Chevella farms limited',
    'Instrumentation limited',
    'Plaza cable electric private limited',
    'Plaza wires and electricals private limited',
    'Action cables india private limited',
    'PLAZA WIRES LIMITED',
    'Kali dyechem private limited',
    'RASU TOOLS PRIVATE LTD',
    'JAIKISHANDASS MALL JUTE PRODUCTS PRIVATELIMITED',
    'SANJOO PRINTS PVT LTD',
    'Crozier s agency pvt ltd',
    'Capital tours (india) pvt ltd',
    'Plaza netcom private limited',
    'Blue ribbon finance and investment pvt ltd',
    'C & c investment ltd',
    'Mira leasing ltd',
    'Dadi griha nirman private limited',
    'Brahmaputra real estate & property developer private limited',
    'PLAZA POWER SOLUTIONS PRIVATE LIMITED',
    'Ahuja kashyap private limited',
    'Whitex metals private limited',
    'K l steels private limited',
    'Hansi trading and investment company private limited',
    'Umang appliances and equipments private limited',
    'Kel industries private limited',
    'Globus securities and finance private limited',
    'Crex media and events private limited',
    'Vs saurya enertech private limited',
    'M r s filmcraft and advertising private limited',
    'Hyderabad race club',
    'Plaza cable industries limited',
    'Plaza lamp and tubes limited',
    'The travancore cements ltd',
    'TATA STEEL LONG PRODUCTS LIMITED',
    'Cummins india limited',
    'Madras fertilizers limited',
    'Crops india biotech private limited',
    'Tarajan tea co pvt ltd',
    'Manisha housing and finance limited',
    'Sondhi polyamide pvt ltd',
    'Assam forest products pvt ltd',
    'Bright enterprises private limited',
    'Core fab projects private limited',
    'Divar chemicals private limited',
    'Annapurna printing inks pvt. ltd',
    'Saraswati plastotech india private limited',
    'Kaydee camco pvt ltd',
    'Santec dynamics private limited',
    'Rajindra machines private limited',
    'Sahai cables international pvt ltd',
    'Feltron industries private limited',
    'Noorveer creations private limited',
    'Cosme costa construction private limited',
    'S.b. reshellers private limited',
    'Bhagat singh motor company private limited',
    'J.s.four wheel motors private limited',
    'Greenbird distributors pvt ltd',
    'SAS EXPORTS PRIVATE LIMITED',
    'Kikar lodge nature resort private limited',
    'Cosme costa hospitality private limited',
    'Ms certification services pvt ltd',
    'Graffiti signgraphics pvt ltd',
    'Anand events pvt ltd',
    'Tvp investments private limited',
    'G.k. financial services private limited',
    'PRECISION KALPURJA UDYOG PRIVATE LIMITED',
    'Windows consultants private limited',
    'Sangram polyplast pvt ltd',
    'Kld associates private limited',
    'Sara universal private limited',
    'Zues shipping limited',
    'Delta division securitas india private limited',
    'COSCO POLYMER INDURSTRIES PRIVATE LIMITED',
    'LN MANAGMENT SERVICES PRIVATE LIMITED',
    'Nihongo center pvt. ltd.',
    'Indo world infrastructure private limited',
    'K a j infrastructure private limited',
    'K.m.realcon private limited',
    'Bajaj finance limited',
    '3P LAND HOLDINGS LIMITED',
    'Therapeutic india private limited',
    'Dpg energy limited',
    'Rajit milk private limited',
    'DKJ PROJECTS & SERVICES LIMITED',
    'Savannah surfactants limited',
    'Kumkum pashuaahar private limited',
    'Green field tea company pvt ltd',
    'Konark jute limited',
    'Bodycare creations limited',
    'Siddh lamifab private limited.',
    'Greenlam industries limited',
    'Ashahi chemical industries private limited',
    'Kundan developers private limited',
    'Rolex products private limited',
    'T.r. sawhney motors private limited',
    'Samara enteprises pvt ltd',
    'AXIOM GLOBAL TECHNOLOGIES INDIA PRIVATE LIMITED',
    'Rainbow livings private limited',
    'Empower manpower solutions private limited',
    'Blue whale advisory services private limited',
    'Abhay financial consultancy private limited',
    'A g engineers private limited',
    'Vila estates private limited',
    'East west medical center private limited',
    'M r warerkar and associates private limited',
    'SUMANGLAM IMPEX PRIVATE LIMITED',
    'INVERT SUGAR INDIA LIMITED',
    'Cadet investment private limited',
    'Thukral time centre private limited',
    'Shabros fin-vest private limited',
    'Sss properties private limited',
    'Heritage promotors private limited',
    'Maven workforce private limited',
    'Pvl tag factory (india) private limited',
    'Ooh advt services private limited',
    'First prize investment private limited',
    'Nagesh dempo company private limited',
    'Soiru dempo management holding private limited',
    'Scg industries pvt ltd',
    'Scrm property private limited',
    'Gauba sons holdings private limited',
    'Ruby and reeve pottery designs private limited',
    'Sjr real estate private limited',
    'Grid india power cables private limited',
    'Taurus global travel management services private limited',
    'ARCLIGHTS EVENTZ NETWORK PRIVATE LIMITED',
    'P c training institute limited',
    'Hemco garments private limited',
    'Emax engineering india private limited',
    'Purshotam co pvt ltd',
    'Earl infotech private limited',
    'Lakshya overseas private limited',
    'Abrs engineering private limited',
    'Kota sari niketan private limited',
    'Skan consultancy private limited',
    'Dinar tarcar industrial projects private limited',
    'Patel hospital pvt ltd',
    'Mittal hospitals limited',
    'Devanshi hospital private limited',
    'Uni meditrek private limited',
    'Buddy care foundation',
    'Narendra kumar cineplex private limited',
    'North east cashews pvt ltd',
    'Saturn tampon druck india private limited',
    'IBI GROUP INDIA PRIVATE LIMITED',
    'Ardee finvest pvt. ltd.',
    'Neco ceramics limited',
    'Goodyear south asia tyres private limited',
    'Choice agros private limited',
    'KANORIA ENERGY & INFRASTRUCTURE LIMITED',
    'Shree cement limited',
    'Texmaco rail & engineering limited',
    'Paushak limited',
    'Kalyani investment company limited',
    'Db (international) stock brokers limited',
    'Texmaco infrastructure & holdings limited',
    'Cmi limited',
    'Apex system private limited',
    'Ruhatiya cotton and metal private limited',
    'Kotak thaker farm private limited',
    'Golden farming private limited',
    'Anjani technoplast limited',
    'Sona golden greens private limited',
    'Jass agri products private limited',
    'Dream job services private limited',
    'Desai packaging private limited',
    'Hira tech solutions private limited',
    'Storeji private limited',
    'Xpert internet services private limited',
    'Lovish dairies private limited',
    'North cott ginning and trading company private limited',
    'Madhav clothing private limited',
    'Trident global corp limited',
    'Delphique fabrics private limited',
    'A k goenka and sons private limited',
    'Sara textiles limited',
    'Karnal agricultural industries limited',
    'Deco pride india private limited',
    'Valiant infrastructure limited',
    'Cine images entertainments private limited',
    'Navyaa apparels private limited',
    'Rm clothing private limited',
    'Divyansh estates private limited',
    'Stark packmate private limited',
    'Shree swastic sales corporation private limited',
    'SARASWATY PRESS LIMITED',
    'Creative offset printers private limited',
    'Aesthetic imprints private limited',
    'Krishna coke (india) private limited',
    'Fertichem ltd',
    'Signature coatings private limited',
    'Hema pharmaceuticals pvt ltd',
    'Srm life science private limited',
    'A d corporate solutions private limited',
    'Mehta pharmaceuticals private limited',
    'Cotec healthcare private limited',
    'Mayansh biotech private limited',
    'Messina food products private limited',
    'Suncol adhesives private limited',
    'Consolidators express private limited',
    'Embee plast private limited',
    'Sawan k motors private limited',
    'Avon tubetech private limited',
    'RND STEELS LIMITED',
    'Vision kota educare private limited',
    'Laureate schools private limited',
    'Swastik pet products private limited',
    'Buildworth pvt ltd',
    'Sportify sports education and management services private limited',
    'Ak health quotient india private limited',
    'Precise teleradiology365 private limited',
    'Jindal agrifoods private limited',
    'Sushil printers private limited',
    'A s graphics private limited',
    'Hachette book publishing india private limited',
    'Pure palm limited',
    'Peekay air filters private limited',
    'Goan mineral resources private limited',
    'Tripura natural gas co ltd',
    'Sooraj umbrella pvt ltd',
    'Uttam air products pvt.ltd.',
    'Ecp industries limited',
    'G.n.a. transmissions private limited',
    'Regi india cosmetics private limited',
    'Mpg stone private limited',
    'MALSTERS AND BLENDERS (INDIA) PRIVATE LIMITED',
    'Dempo industries private limited',
    'Uttam medical concierge private limited',
    'Shri ram sons wax private limited',
    'Metallic fabricators private limited',
    'Salecha pulses private limited',
    'Marvel industries & services private limited',
    'Shree ganesh metalloy limited',
    'Anipra chemicals private limited',
    'Mmc carbon private limited',
    'Neelkanth aqua private limited',
    'Jhajharia exports private limited',
    'Maharshi manufacturer and distributor private limited',
    'Natraj wooltex limited',
    'Iaso pharmaceuticals private limited',
    'Dotsy pharmaceuticals private limited',
    'India fibre pvt ltd',
    'Graf impex private limited',
    'Purandar fine chemicals private limited',
    'Garnett specialty paper limited',
    'Atl overseas limited',
    'Kiran polyvinayel private limited',
    'Vikas stainless private limited',
    'Rangoli garments private limited',
    'Jsis iron & steel india pvt ltd',
    'Vimal organics ltd',
    'MOHAN LOGISTICS PRIVATE LIMITED',
    'D s woodtech ltd',
    'Welding specialities (india) pvt ltd',
    'Growdiesel ventures limited',
    'Apex valves pvt ltd',
    'Sonalika farm equipment private limited',
    'A s mechanical systems private limited',
    'Future oils and lubricants private limited',
    'Rangoli laminate private limited',
    'Chemtotal labs private limited',
    'Aru organics private limited',
    'Multiplex appliances private limited',
    'Jainson equipments private limited',
    'Ubitech private limited',
    'Agnee transmissions (india) private limited',
    'Myco telecom limited',
    'MINDA CAPITAL PRIVATE LIMITED',
    'New age alloys private limited',
    'Quality nickel wires private limited',
    'Magmet alloys private limited',
    'Glowtech wires private limited',
    'Smarten power systems private limited',
    'Genetech biotech private limited.',
    'Montage laboratories private limited',
    'Drp malleables private limited',
    'M t printpack private limited',
    'Swastik ispat private limited',
    'Precision auto engineers private limited',
    'Adarsh noble corporation limited',
    'Mangal machines private limited',
    'Illban remedies pvt ltd',
    'LARISA ENTERPRISES PRIVATE LIMITED',
    'Systa pharma labs private limited',
    'Chakra gems art private limited',
    'Ashirwad hygiene private limited',
    'Rajasthan aluminium house private limited',
    'Helplab healthcare private limited',
    'Foodmac engineers pvt ltd',
    'Induspro auto engineers private limited',
    'Galaxy indicators india private limited',
    'S.k.g. buildcon private limited',
    'Prithvi homes and habitats private limited',
    'Mahavir ashok enterprises private limited',
    'Welplan builders private limited',
    'Signea engineering pvt ltd',
    'Mishra refrigeration engineers private limited',
    'Brahmaputra promotors and planners private limited',
    'BHAVANI COMMUNICATIONS PRIVATE LIMITED',
    'Codas innovations private limited',
    'Ayana medicare private limited.',
    'Dwarkadhis projects private limited',
    'Tooltech india priuvate limited',
    'Exotic buildcon private limited',
    'Jatan constructions private limited',
    'Boss gears limited',
    'Omsons marines ltd',
    'Maizon interiors private limited',
    'Precisonics inspection systems private limited',
    'Atea energy private limited',
    'TRINITY HYDRO POWER PRIVATE LIMITED',
    'Dde renewable energy private limited',
    'Isaac boilers private limited',
    'Gajanand constructions private limited',
    'BEIL INFRASTRUCTURE LIMITED',
    'Shree bharat builders private limited',
    'Pastile infracon limited',
    'Aroma infrabuild private limited',
    'Rajat papmart private limited',
    'Mewar industrial corporation limited',
    'Rajtech infrastructure private limited',
    'Prominent builders and investors private limited',
    'Nks real estates private limited',
    'Knk infraprojects private limited',
    'Imperial infin private limited',
    'Gale worldwide movers private limited',
    'Synapses adventures private limited',
    'WEATHER RISK MANAGEMENT SERVICES PRIVATE LIMITED',
    'Skyhigh infraland private limited',
    'Kewal ram international private limited.',
    'Gujral estates private limited',
    'Prem ratan cnstruction private limited',
    'Richa buildcon private limited',
    'Unicorn real estate developers private limited',
    'Starcity buildcon private limited',
    'Gulshan homes and infrastructure private limited',
    'Logix heights private limited',
    'Cogent ventures private limited',
    'Paradise isle beach resort private limited',
    'Grihnirman properties private limited',
    'Janta builders private limited',
    'Himansu multipurpose cold storage pvt ltd',
    'Sri karni ambey developers private limited',
    'Narula infrastructure private limited',
    'Four pl logistics and aviation private limited',
    'Castmaster thoreb telematics private limited',
    'Dunhil realtors private limited',
    'Krishay properties private limited',
    'Sobhit nirman private limited',
    'Gulshan homz private limited',
    'Kalinga airways private limited',
    'Prosource associates (india) private limited',
    'Star vacations private limited',
    'Kbg infrastructures private limited',
    'WK LIFESTYLE INDIA PRIVATE LIMITED',
    'Ez housing private limited',
    'Adisan real estate management private limited',
    'Bts tours (india) private limited',
    'CRISCOR CONTRAPTIONS PRIVATE LIMITED',
    'Sharma translogistics private limited',
    'Moulavi travel and recruiting agents pvt ltd',
    'Raun harman technologies private limited',
    'Nirnidhi tradelink pvt ltd',
    'Selene pvt ltd',
    'Suncity niketan private limited',
    'Sasmal highrise private limited',
    'Vb infracon private limited',
    'REAN INFRACON PRIVATE LIMITED',
    'Classic tradexim private limited',
    'Sarthi finlease private limited',
    'Achal niketan pvt ltd',
    'CHANAKYA ASHOK TAX MANAGEMENT PRIVATE LIMITED',
    'Antaeus information private limited',
    'Penta software pvt. ltd.',
    'Primordial systems private limited',
    'Amphion software services private limited',
    'Horizon bpo private limited',
    'Tsi softech india private limited',
    'Vinove software and services private limited',
    'Outline systems india private limited.',
    'Konark infocomm private limited',
    'Arteva consulting private limited',
    'Grand finance and estates private limited',
    'Jatia investments pvt ltd',
    'Innocent traders ltd',
    'Tripmedia private limited',
    'Pinnacle infotech private limited',
    'Soft solution information technology private limited',
    'Allayurveda.com private limited',
    'Alpha digital graphics private limited',
    'Cs datamation research services private limited',
    'Divakar merchandise pvt ltd',
    'Sursuns infotech private limited',
    'Ank infotech private limited',
    'Sana mount ville private limited',
    'Inside sales and services private limited',
    'Achievers land crafts private limited',
    'Cyrus-xp health information technology private limited',
    'BOOKS DATABASE PRIVATE LIMITED',
    'Cengage learning india private limited',
    'Vrinda infotech private limited',
    'Geospatial media and communications private limited',
    'Micro max media private limited',
    'PBC INDIA SERVICES PRIVATE LIMITED',
    'Pacnet global communications (india) private limited',
    'Kopal computers private limited',
    'Jato garments private limited',
    'Seaview lifespace private limited',
    'Dhanya promoters private limited',
    'Xaprio solutions private limited',
    'TC ENERGY PRIVATE LIMITED',
    'E2E NETWORKS LIMITED',
    'Adcc infocom private limited',
    'Baan estates private limited.',
    'Bunny properties private limited.',
    'Hamilton research & technology private limited',
    'PROIND BUSINESS SOLUTIONS PRIVATE LIMITED',
    'Vidya infrabuilt private limited',
    'NMG DIGITAL PRIVATE LIMITED',
    'Ab realty private limited.',
    'Rmc (india) infrastructure limited',
    'Livia spaces (india) private limited',
    'Angamuthu holdings india private limited',
    'Davix managaement services private limited',
    'Globalhunt india private limited',
    'Watermelon management services private limited',
    'Futuresafe service private limited',
    'Provouge consultants private limited',
    'Big y enablers consulting private limited',
    'Shakuntalam softwares private limited',
    'Books cybertech private limited',
    'Outgrow consulting private limited',
    'Yorker holidays services private limited',
    'BOOKS INFOBOWLS PRIVATE LIMITED',
    'Sreechem finance pvt. ltd.',
    'PNC CAPITAL MARKETS PRIVATE LIMITED',
    'Richcap finance pvt ltd',
    'Dufflaghur investment ltd',
    'P D G D INVESTMENTS & TRADING PVT LTD',
    'Balaji grahnirman pvt.ltd.',
    'Konark hirise private limited',
    'Trance infrastructure private limited',
    'Credence realcon private limited',
    'Baidyanath finance and leasing ltd',
    'Sukhsamridhi estates private limited',
    'INITIA REALTORS PRIVATE LIMITED',
    'Upsurge realty private limited',
    'Vipra realtors private limited',
    'Urja estates private limited',
    'Anandam properties private limited',
    'Wild flower developers private limited',
    'M m realtech private limited',
    'P.g. buildmart private limited',
    'EAGE DIGITECH PRIVATE LIMITED',
    'Realm reality private limited',
    'Risenglow financial advisory private limited',
    'Woodside parks ltd',
    'Kamayani viniyog pvt ltd',
    'Parag nivesh pvt. ltd.',
    'Sukriti nivesh pvt. ltd.',
    'Manjula finvest pvt ltd',
    'Amity nirman private limited',
    'Trueline realtors private limited',
    'Swarnim hirise private limited',
    'Pasa infrastructure private limited',
    'Kharti infrastructure private limited',
    'Wild flower promoters private limited',
    'H & h real estate and infrastructure private limited',
    'Mgi infra private limited',
    'S.m. propcon private limited',
    'Anandmuni buildcon private limited',
    'Value agro gold private limited',
    'General investment and commercial corporation limited',
    'Dozco infratech private limited',
    'Infonox software private limited',
    'Vertex systems limited',
    'Sai namah estates private limited',
    'Oberoi investments pvt ltd',
    'PLANETRONIX CONSULTING PRIVATE LIMITED',
    'Oberoi buildings & investments pvt ltd',
    'Oberoi holdings pvt. ltd.',
    'Roman printers pvt ltd',
    'VH OVERSEAS PRIVATE LIMITED',
    'Sona info systems private limited',
    'A. l. softweb private limited',
    'A. l. d. info-technologies private limited',
    'Mudrika fiscal services pvt ltd',
    'Seven days construction private limited',
    'Ssa infosystems private limited',
    'VIRTUZO INFOSYSTEMS PRIVATE LIMITED',
    'Thoughtsol infotech private limited',
    'Spontey computer systems private limited',
    'Nexgen infracon private limited',
    'Bhagwati town planners private limited',
    'Frontline realtors private limited',
    'Nm india properties pvt ltd',
    'Miran promoters and developers private limited',
    'Hartik estate private limited',
    'Iniquus it services private limited',
    'NICKELFOX TECHNOLOGIES PRIVATE LIMITED',
    'Vaishakh solutions private limited',
    'Ever bright computers pvt ltd',
    'Legal outsourcing private limited',
    'Gilman software private limited',
    'Saraswati infotech private limited',
    'Spectross digital systems private limited',
    'Axtria india private limited',
    'Three pillar technologies private limited.',
    'Stylex industries private limited',
    'Mh consultancy private limited',
    'Pythhos technology private limited',
    'CEINSYS TECH LIMITED',
    'Meti web-it solution private limited',
    'BRAIN EX INFRA PRIVATE LIMITED',
    'Rustle realty private limited',
    'Saxsons it solutions private limited',
    'Oxford softech private limited',
    'Confidign solutions private limited',
    'Enablizer backoffice technologies private limited',
    'Cicada mediasoutions private limited',
    'Naina components private limited',
    'MICROWARE COMPUTING & CONSULTING PRIVATE LIMITED',
    'Akumentis healthcare limited',
    'Entab infosystem private limited',
    'Jsimple technosoft private limited',
    'Get info systems private limited',
    'Zykoon technologies private limited',
    'Mega telematics private limited',
    '360 degree cloud technologies private limited',
    'Think n code private limited',
    'Somish solutions limited',
    'Inter-ed faculty of clinical research india (ifcr) private limited',
    'Brawn laboratories limited',
    'Jdm scientific research organisation private limited',
    'CAPITAL BUSINESS SYSTEMS Private Limited',
    'Infinity optimal solutions private limited',
    'The jorehaut group limited',
    'L. d. infotech private limited',
    'Edcons fashions private limited',
    'T.el systems limited.',
    'Siempelkamp india private limited',
    'Optimize it systems private limited',
    'Hospitality consultants india private limited',
    'Total synergy consulting private limited',
    'Indus management consultants private limited',
    'Igep foundation',
    'MAPTECH POLY PRODUCTS PRIVATE LIMITED',
    'Dignity business private limited',
    'Hemang agency private limited',
    'Megapix commotrade private limited',
    'Super (india) paper private limited',
    'Lenbitz worldwide private limited',
    'Mittal tradex private limited',
    'Norma (india) limited',
    'FITCO ORINGS PRIVATE LIMITED',
    'Ihdp home interiors export parks private limited',
    'Heritage india exports private limited',
    'K m exim private limited',
    'Pangaea stone international private limited',
    'Aampg foods private limited',
    'Hanaaz international private limited',
    'Swaika supply corpn. pvt ltd',
    'Sadana motels pvt ltd',
    'Vijayluxmi ltd',
    'Vedang hospitality private limited',
    'Gurukul vyapaar private limited',
    'Confetti exports pvt ltd',
    'Pasari multiprojects pvt. ltd.',
    'Aanya resort and spa private limited',
    'Cocoberry restaurants and distributors private limited',
    'SAMHI HOTELS LIMITED',
    'Samhi jv business hotels private limited',
    'Suriba hospitality private limited',
    'Gunjan suppliers private limited',
    'Probal merchants private limited',
    'Magus sales and services private limited',
    'Purplemagic international trade consulting limited',
    'Ashutosh retail private limited',
    'Ashima hotels private limited',
    'ONAZI INFRASTRUCTURE PRIVATE LIMITED',
    'Shirdi country-inns private limited',
    'Lakhawali hotels private limited',
    'Raghavish hotels and resorts private limited',
    'MANOJ VAIBHAV GEMS ',
    'JEWELLERS LIMITED',
    'Poppys park hotel limited',
    'Pee pee appliances private limited',
    'Technocity digital electronics private limited',
    'Prudent vinimay private limited',
    'Clips office solutions private limited',
    'Omaxe housing and developers limited',
    'Ahuja residency private limited',
    'Ess warehousing private limited',
    'Upward merchants private limited',
    'Gappu mahendra hotels private limited',
    'A b l hospitech private limited',
    'Sanya hospitality private limited',
    'Sanya resorts and hospitality private limited',
    'West coast hotels private limited',
    'Vayudoot ltd',
    'Indo copters private limited',
    'Flaps aviation private limited',
    'Goa tourism development corporation limited',
    'Artlibori resorts private limited',
    'Hotel horizon private limited',
    'SUMMAS TRADERS & ENGINEERS PVT LTD.',
    'Mumtaz hotels limited',
    'Kedia sarees pvt ltd',
    'Riverdale retirement resorts and research centre pvt ltd',
    'Narendra polychem private limited',
    'Pratap cold storage private limited',
    'Leela realty ltd',
    'Chilli-ka foods private limited',
    'Epicurean hospitality services private limited',
    'Cordia hotels private limited.',
    'Kalpaka transport co private ltd',
    'Vensimal world travel agents private limited',
    'Patna road carriers pvt.ltd.',
    'Pahargoomiah tea industries private limited',
    'Vayu seva tours & travels private limited',
    'Chandni forex-tour private limited',
    'Nylon vintrade private limited',
    'Mystique mantras holidays india private limited',
    'AVIS INDIA MOBILITY SOLUTIONS PRIVATE LIMITED',
    'Aspark holidays private limited',
    'Asra tours and travels private limited',
    'Reisen tours india private limited',
    'AAGMAN INDIA TRAVEL & LIVING PRIVATE LIMITED',
    'Vtc transport private limited',
    'Bansal cargo movers private limited',
    'India land and space warehousing private limited',
    'Dhillon aviation private limited',
    'Spaze hub logistics private limited',
    'Amity capital ventures private limited',
    'Arka capital services private limited',
    'Locus india financial advisors private limited',
    'Priyankanupur finance and leasing private limited',
    'KOOKABURRA TOURS PRIVATE LIMITED',
    'Top ocean cargo movements private limited',
    'Trans secure logistics private limited',
    'Ex cell home fashions (india) private limited',
    'RMVM SOLUTIONS PRIVATE LIMITED',
    'Designer indya voyages private limited',
    'Anchit chits private limited',
    'Mark view fabrication private limited',
    'Prasanna travels private limited',
    'Good investments(india)ltd.',
    'Prasanna tours private limited',
    'Lark logistics private limited',
    'Thakurdevi investnents pvt ltd',
    'Veda logistics private limited',
    'NAVABHARAT MARKETING & TRADE LTD',
    'Oswal finvest pvt.ltd.',
    'Milestone finstock pvt ltd',
    'Royal insurance broking (india) private limited',
    'Castrol credit private limited',
    'Swiss india financial services company private limited',
    'Magma hdi general insurance company limited',
    'Hiralal and company ( shipping ) private limited',
    'Tatkal couriers private limited',
    'Gulmohar accessories private limited',
    'Fahrenheit clothing india private limited',
    'Kohinoor apparels private limited',
    'Sesame foods private limited',
    'Nand composites private limited',
    'Gahoi chemicals private limited',
    'Sarveshwar creations private limited',
    'SHIVOM RUBBER PRODUCTS PRIVATE LIMITED',
    'Material management projects india private limited',
    'Steriware plastics products private limited',
    'Zf anand nvh products private limited',
    'Inkbird packaging private limited',
    'Rapol saniplast private limited',
    'Rainbow deco plas private limited',
    'Colorplast systems private limited',
    'Next gen industries private limited',
    'Winwood international limited',
    'Saber papers limited',
    'Smart newspapers private limited',
    'Duflon industries private limited',
    'Vishal moulds manufacturing p ltd',
    'Slide-o-chart ready reckoner private limited',
    'The kuljian corporation (india) private limited',
    'Onward plastic private limited',
    'Rama polyfil pvt ltd',
    'Sakal papers private limited',
    'Midas print pack private limited',
    'Sureka ventures private limited',
    'Mod ceramic industries limited',
    'CROWN CRAFT (INDIA) PRIVATE LIMITED',
    'Jagdishpur co ltd',
    'Cincorp international limited',
    'Savita paints private limited',
    'Utkal alumina international limited.',
    'Jaiswal industrial pipes ltd.',
    'Impex metal & ferro alloys ltd',
    'P c alloys private limited',
    'Sunlord steels private limited',
    'S a a stainless steel private limited',
    'SHANKAR LAL RAMPAL DYE-CHEM LIMITED',
    'Vivo apparels private limited',
    'Apeejay tea limited',
    'B.l.g. fabrications private limited',
    'Nitin fastners private limited',
    'Aarti international limited',
    'Agility biotech private limited',
    'GREEN WAVES PRIVATE LIMITED',
    'Vilkhu life sciences private limited',
    'Nitson and amitsu building systems private limited',
    'Nasik photo-tech private limited',
    'Shri coimbatore jewellers india private limited',
    'R r metal private limited',
    'Aif engineering private limited',
    'A k p foundries private limited',
    'PURANLALJI AGRAWAL FOUNDATION',
    'Accumetric silicones private limited',
    'Navneet synthetics limited',
    'Kirat plastics private limited',
    'Ska automotive private limited',
    'Wisdom exim private limited',
    'Vee tee cement private limited',
    'Sr fibreglass auto private limited',
    'Viren glass private limited',
    'Xpertz ankur lights private limited',
    'Sensewell instruments private limited',
    'Venus fittings and valves pvt ltd',
    'Kay therm boilers private limited',
    'Shree girnar cement co pvt ltd',
    'Kondapally forgings private limited',
    'Se aircon private limited',
    'Ladam steels limited',
    'Dynamic ferrotech private limited',
    'Vishal strips private limited',
    'Standard corporation india limited',
    'Arm weld automation private limited',
    'Khare agro mech industries private limited',
    'Precitech enclosures systems private limited',
    'Skh sila india private limited',
    'SIDDHI PRECISION TOOLING PRIVATE LIMITED',
    'Arvind autotech private limited',
    'Fmi limited',
    'Vishwarupa rolling mill pvt ltd',
    'Kanpur pesticides & chemicals ltd',
    'P.s.earthmovers private limited',
    'Star frost asia private limited',
    'Voltron electronic equipments private limited',
    'Skh cabs manufacturing private limited',
    'Siac skh india cabs manufacturing private limited',
    'S.m.graphotronic private limited',
    'Kambill systems private limited',
    'Fitwel gasket company (india) private limited',
    'Propaktech india private limited',
    'Mehala machines india limited',
    'Highsky automation private limited',
    'Forbes marshall arca private limited',
    'Vaccum impregnations india private limited',
    'Emt megatherm private limited',
    'Dynamic engineering company private limited',
    'Divya electricals limited',
    'V r opto electronics marketing private limited',
    'A v engineers private limited',
    'Ezentech (india) private limited',
    'Corporate service plan india pvt ltd',
    'I j infotech private limited',
    'Nipa international private limited',
    'SOMU STEEL & POWER LIMITED',
    'TRIUMPHANT SPECIAL ALLOYS PRIVATE LIMITED',
    'Samir tech-chem private limited',
    'Scientech international pvt. ltd.',
    'Prohealth vitamins private limited',
    'Hennell medi pharma private limited',
    'Olympus lifesciences private limited',
    'Vishwa rupa steel private limited',
    'Drk metallurgical private limited',
    'Tri o tech solutions private limited',
    'Right advisors private limited',
    'Anri solutions hr services private limited',
    'Fidere facilities management private limited',
    'Synergy promotions & marketing services private limited',
    'Ra hydrogeo engitech india private limited',
    'Racs it consulting india private limited',
    'Connoisseur consulting solutions private limited',
    'Digital web solutions private limited',
    'Novojuris services india private limited',
    'Sum yantra private limited',
    'Diverse infotech private limited',
    'ENERGIZED MIMER CLEANTECH PRIVATE LIMITED',
    'Amity global schools private limited',
    'Spearhead corporate services private limited',
    'Dbms consulting india private limited',
    'Willow & boots brand solutions private limited',
    'Kapil channa consultants private limited',
    'Si viridian india management private limited',
    'Elyzium technologies private limited',
    'MYITY SERVICES PRIVATE LIMITED',
    'Eigen consulting private limited',
    'Gs catalogue products private limited',
    'Crimson oil tools private limited',
    'Iaxn telecom private limited',
    'Kitex limited',
    'SAMARPIT CONSULTANTS AND SERVICES PRIVATE LIMITED',
    'Intronics power appliances private limited',
    'Silkroute indchem limited',
    'Thefra technopark private limited',
    'Jaseir technologies private limited',
    'Indev intermodal carriers pvt ltd',
    'Famous projects advisory private limited',
    'Akraya solutions private limited',
    'Teamget consulting private limited',
    'Quantum design india private limited',
    'Usha international limited',
    'MVS ENGINEERING PRIVATE LIMITED',
    'Crystal and driscol consulting limited',
    'Prastut consulting pvt. ltd.',
    'Redbooks consulting private limited',
    'India strategy group advisors private limited',
    'Multicon builders limited',
    'Sanon sen & associates pvt ltd',
    'Apextend advisors private limited',
    'Softlink international private limited',
    'Legalmd global consulting services private limited',
    'Kappa internet services private limited',
    'Sibsa digital private limited',
    'Exergy automation & control private limited',
    'Cubastion consulting private limited',
    'Salient hr management private limited',
    'Qualtouch bpo solutions private limited',
    'Ksr sportseed private limited',
    'Swbi architects private limited',
    'Two hmp communications private limited',
    'S s business strategies private limited',
    'Kapur estates pvt ltd',
    'Consolidated aerials pvt ltd',
    'Standard wiring systems limited',
    'Strapon plastics private limited',
    'Sudtrac linkages private limited',
    'Pawan dynamics pvt ltd',
    'Usha plast packaging private limited',
    'Amit himanshu private limited',
    'Beckcem drug international private limited',
    'BIO NOVA PHARMACEUTICALS PVT LTD',
    'Peerless consultancy services pvt ltd',
    'Gajanand developments ltd',
    'Mangalsidhi projects advisory private limited',
    'Om krishan properties private limited',
    'Decor india pvt ltd',
    'Ocean plastics and fibres pvt ltd',
    'Skymates (india) pvt ltd',
    'Pfeda synthetics private limited',
    'Libsys limited',
    'Kapco electric private limited',
    'W b m systems private limited',
    'Gulshan estate agents pvt ltd',
    'Uni agencies chemicals private ltd',
    'DOUBLE ',
    'MARKETING PRIVATE LIMITED',
    'M.design india private ltd.',
    'Karamjeet singh and company limited',
    'Quasar media private limited',
    'Jvi interiors private limited',
    'Anh engineering services private limited',
    'Amberg engineering india private limited',
    'Emcipi electronics pvt ltd',
    'SUPERCIRCLE PRIVATE LIMITED',
    'Rajasthan trunk facrory private limited',
    'Nippon audiotronix private limited',
    'Surbhaee advertising private limited',
    'The saraswati marketing company limited',
    'GEM AGROFOODS PRIVATE LIMITED',
    'S p j consultants private limited',
    'Utsav exim limited',
    'Trak services pvt ltd',
    'Instapower limited',
    'Premium mouldings and pressings pvt ltd',
    'Technomed ( india ) private limited',
    'Wavene infotech private limited',
    'Him tours private limited',
    'Viscair auto industries private limited',
    'Preci turn private limited',
    'Elegent estates pvt ltd',
    'N b marketing private limited',
    'Vichitra estates private limited',
    'Amity tv network private limited',
    'ALLIED MARITIME & INFRA ENGINEERING PRIVATE LIMITED',
    'Sai nath developers & builders private limited',
    'Sunbeam real ventures private limited',
    'Jaskeerat infrasolutions private limited',
    'Development architects private limited',
    'Millennium construction private limited',
    'Msb constructions private limited',
    'Park mansion services pvt.ltd.',
    'Ray assets pvt.ltd.',
    'Kailash pati developers india private limited',
    'Dss properties private limited',
    'Bhoruka park private limited',
    'Parsec infrastructure development private limited',
    'Skyline builders and developers india private limited',
    'Eternity developers private limited',
    'Skyline meadows private limited',
    'Bhartiya developers consortium private limited',
    'Shailja park private limited',
    'N k concrete creation private limited',
    'Grecefull buildcon private limited',
    'Perfect green villas private limited',
    'Orbit realty infrastructure limited',
    'Vasavi infrastructure projects limited',
    'RAJDARBAR HERITAGE VENTURE LIMITED',
    'Nirmala goenka estates private limited',
    'Aj arkidesigns private limited',
    'Vibrant buildmart private limited',
    'Sartaj developers and promoters private limited',
    'Cosmic grace construction private limited',
    'North east infratech private limited',
    'Aurum infratech private limited',
    'A. m. infraprojects private limited',
    'K&L COMMUNICATIONS INDIA PRIVATE LIMITED',
    'Craie n craft construction private limited',
    'Charishma builders private limited',
    'Cinamon constructions private limited',
    'Creative infraheights private limited',
    'Intertouch building products private limited',
    'Dss buildcon private limited',
    'Jaskaran infrastructures private limited',
    'Balmatta developers private limited',
    'Kalmane constructions private limted',
    'Shree girish associates private limited',
    'Ojesh enclave private limited',
    'Swarn enclave private limited',
    'Jai guru abhasan private limited',
    'Module properties private limited.',
    'Sanskar homes and interiors private limited',
    'Crv properties private limited',
    'Aic realtors private limited',
    'Bg estates private limited',
    'Trishe energy infrastructure services private limited',
    'HOME & SOUL INFRATECH PRIVATE LIMITED',
    'Oilex enginers (india) pvt ltd',
    'Sukhmanjot builders & developers private limited',
    'Green fingers landscapers private limited',
    'MYERS TYRE SUPPLY (INDIA) LIMITED',
    'Dev bhoomi cars private limited',
    'Mangalore integrated township private limited',
    'Signature motors kasargod private limited',
    'Willis consulting services private limited',
    'Intex developers private limited',
    'Bhatter construction private limited',
    'ANDRITZ O&M PRIVATE LIMITED',
    'S.a.n. impex private limited',
    'Sys green environment management private limited',
    'Asa garment designs private limited',
    'Lhg metals private limited',
    'ADVANCE METAL POWDER PRIVATE LIMITED',
    'Advance commodeal private limited',
    'Manya projects private limited',
    'Choate developers private limited',
    'Kingston realtors private limited',
    'Trehan infrabuild private limited',
    'Paroo sales private limited',
    'Elite infraservices private limited',
    'Edam builders private limited',
    'Gbc infrastructure private limited',
    'Oishi machine india private limited',
    'Innovative lighting designs limited',
    'MARELLI SKH EXHAUST SYSTEMS PRIVATE LIMITED',
    'Blossom merchant trading private limited',
    'Ashiana dwellings private limited',
    'Sprint cars private limited',
    'Hyva (india) private limited',
    'Unique auto sourcing private limited',
    'Raghavendra motors private limited',
    'Avg vehicle sales and services private limited',
    'Warden exports private limited',
    'Sree shyam procon private limited',
    'Bishal inn private limited',
    'SUMRIDDHI BUSINESS SOLUTIONS PRIVATE LIMITED',
    'SHIVA COMPUTING SOLUTIONS PRIVATE LIMITED',
    'Vmd realty private limited',
    'Calcutta chamber of commerce',
    'T P ROY CHOWDHURY & CO PRIVATE LIMITED',
    'Goel roadways pvt ltd',
    'Consummate builders private limited',
    'Chinar land developers pvt ltd',
    'Kalangutkar developers private limited',
    'LAXMI MANGAL INFRASTRUCTURE PRIVATE LIMITED',
    'Source developers private limited',
    'Complete real estate solutions private limited',
    'Mangalam homes and resorts private limited',
    'Shyam estates private limited',
    'Jamnomal premises pvt ltd',
    'Dhayvat properties p ltd',
    'Linker shelter private limited',
    'Ganesh agri properties private ltd',
    'Ksr capital services ltd',
    'Indus portfolio private limited',
    'Fairwealth securities limited',
    'Merigold real estate private limited',
    'Rkrd realty private limited',
    'Green hills developers and builders private limited',
    'Oracle real estates private limited',
    'Medini real estates private limited',
    'Sandstone real estates private limited',
    'Eden estates and leisure private limited',
    'Nelu estates and movers pvt ltd',
    'Shri sainath estates pvt ltd',
    'Best apartments private limited',
    'ANNAMALLAI INFRASTRUCTURES PRIVATE LIMITED',
    'Dreamhouse constructions private limited',
    'Matraco properties private limited',
    'Krishna meadows private limited',
    'Dipti home makers private limited',
    'Sanghvi gruha nirman private limited',
    'Techno property developers private limited',
    'Zeus housing & construction limited',
    'U s realty private limited',
    'Saket towers private limited',
    'Mahabir hirise private limited',
    'Elita garden vista project private limited',
    'Daiwik hotels private limited',
    'Propkar enclave private limited',
    'Metro city nirman private limited',
    'Rocky nirman private limited',
    'Riverbank developers private limited',
    'Nikhileswari constructions private limited',
    'Brahmaputra real estate & developer private limited',
    'Sis group enterprises limited',
    'CYBERIMMERSIONS FORENSICS SOLUTIONS PRIVATE LIMITED',
    'Prime landmarks private limited',
    'Apport infrastructure private limited',
    'Ksj realtors private limited',
    'Gracious real estates private limited',
    'Parshwajit developers pvt ltd',
    'Sarovar properties private limited',
    'DELHI SHELTERS PRIVATE LIMITED',
    'Triyug projects private limited.',
    'Gagan i-land township private limited',
    'Extreme infraprojects private limited',
    'Glowview properties private limited',
    'Mahima real estate private limited',
    'Galaxy landcon private limited',
    'Unnati vihar premises private limited',
    'Spark realtors private limited',
    'Prajay velocity developers private limited',
    'Adithya malar holdings private limited',
    'Manor dwellings private limited',
    'United credit and development co limited',
    'Growmax realtors private limited',
    'Argus vatika properties private limited',
    'Sky heights property dealers private limited',
    'PANDA INFRATECH LIMITED',
    'Neeru township private limited',
    'Sidhiratan complex private limited',
    'Deepshika enclave private limited',
    'VKA PHARMA PRIVATE LIMITED',
    'Vidhika niwas private limited',
    'Anushria properties private limited',
    'M a alagappan holdings private limited',
    'ARIHANT DREAM INFRA PROJECTS LIMITED',
    'Ashiana homes private limited',
    'Madhur estates & agencies pvt ltd',
    'Spbp holdings pvt ltd',
    'Tdi estates private limited',
    'Shivalya developers and promoters private limited',
    'Anushria builders private limited',
    'Anushria developers private limited',
    'Anushria constructions private limited',
    'Swastic projects pvt ltd',
    'Revata tower and estates private limited',
    'Shreehari realtech private limited',
    'Uday homz private limited',
    'Auspicious promoters private limited',
    'Paratus real estates private limited',
    'Martina developers & fincon pvt ltd',
    'Cross world real estate private limited',
    'Renault developers private limited',
    'Unistar estates private limited',
    'Bigtown properties private limited',
    'Krs consultants private limited',
    'Swastic heights private limited',
    'Chandrakala homes india private limited',
    'POOMPUHAR REAL ESTATE PRIVATE LIMITED',
    'Sarvpriya awas and developments private limited',
    'Sukumar township development pvt.ltd.',
    'Yug infrastructures private limited',
    'ABHISHEK HOUSING & ELECTRONICS LTD',
    'Impulse buildtech india private limited',
    'CURECOMPANION PRIVATE LIMITED',
    'Manturam infrastructure private limited',
    'Anirudh electrotech private limited',
    'Mehta offset private limited',
    'Circon research and consultancy services pvt ltd',
    'Zonac knitting machines pvt ltd',
    'Slotco steel products private limited',
    'ANAND MEDIPRODUCTS PRIVATE LIMITED',
    'Sanskar homes private limited',
    'Avitech nutrition private limited',
    'Kapil constructions private limited',
    'IJCP PUBLICATIONS PRIVATE LIMITED',
    'Chamundi agricu lture and investment private limited',
    'Decent consultancy and management services pvt. ltd.',
    'Bachhen electronics private limited',
    'Lpj holdings private limited',
    'Nav bharat engineering works private limited',
    'Dj softech private limited',
    'Rns infrastructure limited',
    'Ozone propex private limited',
    'Reliability management consultant private limited',
    'KASVIK HOME PRIVATE LIMITED',
    'Mankind pharma limited',
    'Trusine electronics private limited',
    'K.h. steel casting private limited',
    'Automatic instruments private limited',
    'Ila creative technologies private limited',
    'Paragon vinyls private limited',
    'Shine travels and cargo private limited',
    'Kvtek power systems private limited',
    'HITACHI SYSTEMS INDIA PRIVATE LIMITED',
    'Finwiz capital services private limited',
    'National minorities development and finance corporation',
    'Smc exports private limited',
    'Surpal publicity private ltd.',
    'Dwarka das and sons chit fund pvt ltd',
    'Spinzer pharmaceuticals private limited',
    'Deepsons (india) private limited',
    'Jumax foam private limited',
    'Fusebase eltoro private limited',
    'Deluxe cold storage and food processors limited',
    'Uneecops technologies limited',
    'Datatec methodex private limited',
    'Sdm electric products private limited',
    'Himalayan hotels private ltd.',
    'C.E. INFO SYSTEMS LIMITED',
    'Sheela overseas private limited',
    'Monarch farms private limited',
    'Southern travels private limited',
    'SONA PAPERS PRIVATE LIMITED',
    'Indian polyproducts private limited',
    'Vantage integrated security solutions private limited',
    'App-tech machines private limited',
    'Mongaz sales and exports pvt ltd',
    'Radhika (india) private limited',
    'Keith telecom systems private limited',
    'Edison agni electric company private limited',
    'Bliss anand private limited',
    'Sietz technologies india private limited',
    'Gravs appliances private limited',
    'H s balbir and brothers pvt ltd',
    'Canon india private limited',
    'Hindustan coca-cola beverages private limited',
    'Koreth consulting private limited',
    'Rising structures private limited',
    'Acg infotech limited',
    'Vap tube bends pvt ltd',
    'Roz-ka-meo components private limited',
    'RHOMBUS SPORTS SERVICES PRIVATE LIMITED',
    'Flair exports pvt ltd',
    'Magnificient oveseas private limited',
    'Gebr.pfeiffer (india) private limited.',
    'ADVANCE TECHNICAL SYSTEMS PRIVATE LIMITED',
    'SIGNATUREGLOBAL COMTRADE PRIVATE LIMITED',
    'Aakash nirman udyog private limited',
    'PANALFA ENTERPRISES PRIVATE LIMITED',
    'Uni style images private limited',
    'Spurt capital services private limited',
    'Procall private limited',
    'Klg power limited',
    'Rite equipment private limited',
    'Secure meters limited',
    'K.p.r. infraprojects private limited',
    'Kortech batteries and electronics private limited',
    'Om corrugated pack private limited',
    'Mks international trade private limited',
    'Ids-argus healthcare services private limited',
    'Zywie ventures private limited',
    'SYNFONIA TRADELINKS PRIVATE LIMITED',
    'B e office automation products private limited',
    'Nandni electrical works private limited',
    'Kap laminates limited',
    'Ma-ganga fincap lease private limited',
    'Sagar technologies private limited',
    'State express tours private limited',
    'Samir biotech pvt ltd',
    'VANIK INFRA PRIVATE LIMITED',
    'S c j polythene private limited',
    'Manglam developers private limited',
    'S s towers private limited',
    'Glorious electronics india private limited',
    'Shree vishnu apparels private limited',
    'Doranda business solutions private limited',
    'Easytech services private limited',
    'Asme india private limited',
    'Hoshruba repertory private limited',
    'Sbt consulting services private limited',
    'Bodhi health education private limited',
    'Iriis fiber india private limited',
    'Adworth media private limited',
    'Sri mahalingeshwara beverages private limited',
    'Trichy distilleries & chemicals limited',
    'Rajwadi beverages private limited',
    'Black berry distilleries private limited',
    'S kantilal and company private limited',
    'Shantilal khushaldas and brothers private limited',
    'Sumangal silk mills pvt ltd',
    'Salgaocar mining industries private limited',
    'Marzook & cadar private limited',
    'Salitho ores private limited',
    'Atlas synthetics private limited',
    'JMS MINING PRIVATE LIMITED',
    'Gvk coal (tokisud) company private limited',
    'Soundararaja mills limited',
    'SHRINI SOFTEX INDIA PRIVATE LIMITED',
    'Sree lakshmi venkateswara spinning mills private limited',
    'Premier marine fishing and chartering pvt ltd',
    'Sukhmani finvest limited',
    'Ace decor private limited',
    'Genagro foods (india) private limited',
    'Imperial dyeing limited',
    'Ranga weaves india private limited',
    'Berry cotts pvt ltd',
    'Warner exports private limited',
    'Mahavir synthetics pvt ltd',
    'Desi foods (india) private limited',
    'Spinning king (india) limited',
    'Rathi brothers private limited',
    'Super soft care products private limited',
    'Saikrupa fabrics private limited',
    'Svs tex o fab private limited',
    'Singhal fabrics private limited',
    'Intersource garments private limited',
    'Handfab elegance private limited',
    'Induro lifestyle resources private limited',
    'Fancy nets private limited',
    'Chola oil refineries private limited',
    'Adhikar grameen products private limited',
    'Chandigarh flour mills pvt ltd',
    'Yamuna roller flour mills private limited',
    'Shri varalakshmi sago products private limited',
    'RUCHITA FILAMENTS PRIVATE LIMITED',
    'JUS',
    'S LIVING SPACE PRIVATE LIMITED',
    'Sabari constructions technologies private limited',
    'T. g. estates private limited',
    'T. g. realtors private limited',
    'Pahadi properties private limited',
    'Patliputra hytech infra private limited',
    'Swift tech engineers (india) private limited',
    'Mohan dwellings private limited',
    'Ramprastha housing private limited',
    'Jindal promoters private limited.',
    'P S BEDI GLOBAL SERVICES PRIVATE LIMITED',
    'Collage group infrastructure private limited.',
    'Mnt buildwell private limited',
    'Raunak developers private limited',
    'Bav associates private limited',
    'Pratham towers private limited',
    'Mangalam enclaves private limited',
    'Supreme construction and developers private limited',
    'Kasprs build mate private limited',
    'PRECISION INFRATECH PRIVATE LIMITED',
    'Ramprastha promoters private limited',
    'V a s properties private limited',
    'ONEZERO GLOBAL PRIVATE LIMITED',
    'Apexa infraproject private limited',
    'Sherin hifab contracts india private limited',
    'Dalhousie buildtech private limited',
    'Rak realty private limited',
    'Wellbuild realtors private limited',
    'Jasubhai business services private limited',
    'EDWELL PARK PROPERTIES AND NETWORKS PRIVATE LIMITED',
    'Dhoot infrastructure projects limited',
    'AGARA TECHZONE PRIVATE LIMITED',
    'Inesh realtors private limited',
    'Deeta constructions private limited',
    'Maverick properties private limited',
    'Smarthomes developers (india) private limited',
    'Xylon developers private limited',
    'Enkay castles private limited',
    'Kuntal properties private limited',
    'Mrigashish properties private limited',
    'Apache sez development india private limited',
    'Nav nirman formwork systems private limited',
    'Namo infra private limited',
    'Raico infrastructure private limited',
    'Simran builders private limited',
    'Arcop associates private ltd.',
    'Park land properties private limited',
    'Zeal housing and constructions private limited',
    'RSB INFRASTRUCTURE PRIVATE LIMITED.',
    'REMUS FOODS AND MILK PRODUCTS PRIVATE LIMITED',
    'Grip constructions private limited',
    'Subhadra project private limited',
    'Karnavati infrastructure projects limited',
    'Mns corporation private limited',
    'Chaitanya infrastructure private limited',
    'SANSKRUTI MEGA STRUCTURE PRIVATE LIMITED',
    'Shri salasar realtech private limited',
    'Pinkcity realsquare private limited',
    'Sand worth real estates private limited',
    'Pacific buildcon private limited',
    'Gain properties private limited',
    'Satya buildwell private limited',
    'Tulip buildtech private limited',
    'KING SPACES AND BUILDERS PRIVATE LIMITED',
    'H s realtors india private limited',
    'Turnwell engineers pvt ltd',
    'Vinita griha nirman private limited',
    'Saket promoters limited',
    'Jks infrastructure private limited',
    'Rosedale developers private limited',
    'Mayank nirman private limited',
    'Kalsi construction company limited',
    'Uni-chand builders private limited',
    'Jnp road infraastructure projects private limited',
    'Sare saamag realty private limited',
    'Vision infra engineering services private limited',
    'Tridev buildwell private limited',
    'Snow cool buildcon private limited',
    'Ariisto realtors development private limited',
    'Magic space private limited',
    'Pyramid city scape private limited',
    'Bramha bazaz land developers private limited',
    'Marigold premises private limited',
    'GREENWOODS ORGANISER & ENGINEERS PRIVATE LIMITED',
    'Genuine infrastructure private limited',
    'Navnirman highway projects private limited',
    'Maple leaf constructions private limited',
    'Biance costructions pvt ltd',
    'NAGMETRO INFRAPROJECTS PRIVATE LIMITED',
    'Suchita infrastructures private limited',
    'Crg infratech private limited',
    'Soma tollways private limited',
    'SHRERIT AUTO PRIVATE LIMITED',
    'Chona investments p ltd.',
    'PAISABUDDY FINANCE PRIVATE LIMITED',
    'Jadko finance private limited',
    'Guru-dev springs pvt ltd',
    'Anushna chits private limited',
    'Chiramel kuries private limited',
    'Savannah chits private limited',
    'New auto finance chit fund private limited',
    'Speed india . com holdings private limited',
    'Ranee holdings private limited',
    'Futuristic capital private limited',
    'Rajani trading and investments private limited',
    'M3 investment private limited',
    'Mini muthoottu credit india private limited',
    'Cees investments and consultants private limited',
    'Tanay leasing and finance pvt.ltd.',
    'Eccl investments and finance limited',
    'OPTACREDIT FINTECH PRIVATE LIMITED',
    'Lorven management services private limited',
    'K & Y ENTERPRISES PRIVATE LIMITED',
    'Anterior financial consultants private limited',
    'Kanod investments pvt ltd',
    'Chirag viniyog & commercial pvt ltd',
    'Adventz finance private limited',
    'Bengal commercial & credit private limited',
    'Reward portfolio private limited',
    'Balkrishna rathi finance pvt ltd',
    'Munshi holdings pvt ltd',
    'Hii insurance broking services private limited',
    'Bimagenie insurance broking private limited',
    'L n p financial investments private limited',
    'Rushay commodities private limited',
    'Merfin advisors private limited',
    'SC INDIA MANAGER PRIVATE LIMITED',
    'Eclipse invofin india private limited',
    'Jiya securities private limited',
    'Steel strips mercantile private limited',
    'Nirpan securities private limited',
    'NIRSHILP COMMODITIES AND TRADING PRIVATELIMITED',
    'Nellys securities private limited',
    'BHARTIYA GLOBAL VENTURES PRIVATE LIMITED',
    'Dpk investments private limited',
    'Infrastructure finance company gujarat limited',
    'Asian thai foods & investment private limited',
    'DIVYA CAPITAL ONE PRIVATE LIMITED',
    'Ameva securities private limited',
    'Mhm holdings private limited',
    'Royal indian holdings limited',
    'Prov venture investments private limited',
    'Taparia investments private limited',
    'Aml exports private limited',
    'Zodiac holdings and trading company private limited',
    'Nambiar international investment co pvt ltd',
    'Ahco investments pvt ltd',
    'Splendour investments pvt. ltd.',
    'Jsb securities limited',
    'Sandhills holdings limited',
    'Jamnadas virji securities pvt ltd',
    'Aimco investments p ltd',
    'Veemax investments private limited',
    'Matraco finvest limited',
    'Kunal fin-cap limited',
    'Ventura securities limited',
    'Kemo holdings private ltd',
    'Sathyasai credit and capital private limited',
    'Mimansa software systems pvt ltd',
    'ENAM INVESTMENT & SERVICES PRIVATE LIMITED',
    'Zip telecom holdings limited',
    'Bhandari finvest ltd',
    'SUBHLAKSHMI FINANCE PRIVATE LIMITED',
    'Innovative commodities private limited',
    'First point finance ltd',
    'Kamal fincap private limited',
    'Nagarjuna investors services ltd.',
    'Sukhlal chandanmull pvt ltd',
    'Hindusthan financial services ltd.',
    'Murshidabad home appliances private limited',
    'Sidhant credit capital ltd',
    'Hail leasing & finance pvt. ltd.',
    'Bonanza enterprises pvt ltd',
    'Sumangal stock brokers limited',
    'Kna share brokers private limited',
    'Amol financial services private limited',
    'Yashaswini consultants private limited',
    'Equity capital advisors (india) private limited',
    'Instanex capital consultants private limited',
    'Hempoint financial services private limited',
    'Sbicap ventures limited',
    'B l a power holding private limited',
    'Capital pundits financial services private limited',
    'Indusind marketing and financial services private limited',
    'HEALTHINDIA INSURANCE TPA SERVICES PRIVATE LIMITED',
    'Instanex insurance brokers private limited',
    'Reliant infrastructure private limited',
    'Aadrash infraventure private limited',
    'Vsr infratech private limited',
    'Balaram infracon private limited',
    'Lakeview development corporation private limited',
    'Lonestar infrastructure india private limited',
    'Bcil realty private limited',
    'Shilpa builders private limited',
    'Parasaria properties private limited',
    'RADHA MADHAV INVESTMENTS PRIVATE LIMITED',
    'Lokhandwala estates and development company private limited',
    'Amber apartment makers private limited',
    'Jakari builders private limited',
    'CHANDRA LAKSHMI FRATERNITY FUND PRIVATE LIMITED',
    'Wonder polymers private limited',
    'Indovax private limited',
    'Nova travel private limited',
    'Sj leasing and investments private limited',
    'Vikas builders and contractors private limited',
    'Ceeco technologies private limited',
    'Chandigarh finance private ltd',
    'Model footwears private limited',
    'Chandhok textile exports (p) ltd',
    'Premier printpack industries private limited',
    'Standard ring private ltd.',
    'Bhartiya infrastructure private limited',
    'Builtech engineers and consultants private limited',
    'Gurusons communications private limited',
    'Dehradun automobiles private limited',
    'ETERNITY FOOTWEAR PRIVATE LIMITED',
    'Gurgaon info parks limited.',
    'Archer resorts and recreation ltd',
    'Genius electricals and electronics private limited',
    'D.d. properties private limited',
    'All management services private limited',
    'Simka hotels and resorts private limited',
    'Helicon constructions private limited',
    'SHILPI COMPUTERS PRIVATE LIMITED',
    'Spans envirotech private limited',
    'Snowhite stores private limited',
    'Gagan financial resources private limited',
    'ARETE SECURITIES LIMITED',
    'Zee laboratories limited',
    'Sangat printers private limited',
    'Coronet holdings private limited',
    'V a g holdings private limited',
    'Parker electronics private limited',
    'Rakesh press private limited',
    'Rakhi garments private limited',
    'Zest systems private limited',
    'Nisha cable co. private limited',
    'Futech consultants pvt ltd',
    'Ptc mouldings private limited',
    'Sam associates private limited',
    'SKG STOCK AND SHARE BROKERS PRIVATE LIMITED',
    'New age hotels and resorts limited',
    'Ifci factors limited',
    'Prestige enterprises private limited',
    'SANVIH INFO GROUP PRIVATE LIMITED',
    'Gallant marketing private limited',
    'Isoft technologies private limited',
    'Panasonic avc networks india company limited',
    'Collage teleimages private limited',
    'Triumph properties limited',
    'AGAAR INFRA TRADE PRIVATE LIMITED',
    'Consortium component technologies pvt ltd',
    'Nvr and associates limited.',
    'Inspired technologies private limited',
    'THOR SOLUTIONS PRIVATE LIMITED',
    'Daikin airconditioning india private limited',
    'Decibels india private limited',
    'Rama tech india private limited',
    'Convergys india services private limited',
    'Mahalakshmi road carriers private limited',
    'Abacus management consultants private limited',
    'Mahalakshmi logistics private limited',
    'Third eye media private limited',
    'Eda rural artha vikas',
    'Benetton india private limited',
    'Satisfying overseas private limited',
    'Opg securities private limited',
    'KINARA CAPITAL PRIVATE LIMITED',
    'Kwang jin india autosystems private limited',
    'Panchwati prayogshala private limited',
    'Green ripples private limited',
    'Watchood properties private limited',
    'Durant (india) limited',
    'India business advisory services private limited',
    'BLACKFOX ADVISORS PRIVATE LIMITED',
    'D r l pharma private limited',
    'SNVA EDUTECH PRIVATE LIMITED',
    'Blue digital media private limited',
    'Colleagues consultants private limited',
    'First india projects private limited',
    'Applied promotions and publicity private limited',
    'ALTEM ENERGY PRIVATE LIMITED',
    'D.light energy private limited',
    'Competent syntel private limited',
    'Keen associates private limited',
    'Corevalues consulting private limited',
    'Xlnc fashion sources private limited',
    'Realty club private limited',
    'STONEHENGE GROUP PRIVATE LIMITED',
    'CLICKLEARN INDIA PRIVATE LIMITED',
    'Aditya metalcoat private limited',
    'Power engineering spares and services (india) private limited',
    'Starcrest services private limited',
    'Oilmec drilling equipments private limited',
    'Infinity eservices private limited.',
    'Mtekpro engineering private limited',
    'ARNAV EMBROIDERIES PRIVATE LIMITED',
    'Jai bhoomi projects limited',
    'Marshal properties private limited',
    'Beehive systems private limited',
    'Connexons travel (india) private limited',
    'Paruthi engineers private limited',
    'Smart care electro services private limited',
    'Sanjha properties private limited',
    'Vt enterprises india private limited',
    'Sewman fashions private limited',
    'Ap golden apparels private limited',
    'Sneha cottons private limited',
    'Sidhanmol fashions private limited',
    'Ovion lifestyle private limited',
    'Farida shoes private limited',
    'CREATEURSPACE PRIVATE LIMITED',
    'Trishakti leather enterprises private limited',
    'Weatherite private limited',
    'Samrat plywood limited',
    'Acoster exim private limited',
    'IRUS INTERNATIONAL PRIVATE LIMITED',
    'Cats eye collections private limited',
    'Tiger button (india) private limited',
    'Baby shower apparels & accessories private limited',
    'Jeans east (international) limited',
    'Sabnam exports private limited',
    'DUKE FABRICS (INDIA) LIMITED',
    'Jackson paper products private limited',
    'Unity papers private limited',
    'KERALA PAPER PRODUCTS LIMITED',
    'Priknit retails limited',
    'INDIA COVERS TEXTILES PRIVATE LIMITED',
    'DAIFUKU INTRALOGISTICS INDIA PRIVATE LIMITED',
    'Ratnagiri paper printing and packaging private limited',
    'SRIMAN WEAVING INDUSTRIES PRIVATE LIMITED',
    'Annex fashions private limited',
    'ARMSTRONG PRODUCTS PRIVATE LIMITED',
    'ARIHANT EVERGREEN AGRO PLAST AND TEXTILES PRIVATE LIMITED',
    'Solo knit process private limited',
    'Srikamal fashions private limited',
    'Jasraj kalianji infosystems private limited',
    'Tusker textiles private limited',
    'Vaishnavi garments private limited',
    'Kasturi & sons limited',
    'Patliputra shoppers plaza private limited',
    'The book centre limited',
    'Chandekar business media private limited',
    'Apocalypso filmworks private limited',
    'Images multimedia private limited',
    'Brandnew associates private limited',
    'Om 360 degrees advertising and entertainment private limited',
    'Hatter innovations media & communications private limited',
    'Eastman garments private limited',
    'Indian stitches private limited',
    'River advertising private limited',
    'MODWAY SUITING PRIVATE LIMITED',
    'Goa publications private limited',
    'Borkar colorpacks private limited',
    'Sakshi lingeries private limited',
    'Asis living in style private limited',
    'Modern living solutions private limited',
    'Jalori tablewares private limited',
    'A.b. furnishings private limited',
    'Max polyplast private limited',
    'Srs box private limited',
    'GONAUR CHOUDHARY FOODS PRIVATE LIMITED',
    'Mh containers private limited',
    'Arg packplast private limited',
    'Astron packaging limited',
    'Officenow india private limited',
    'Astha foils private ltd.',
    'Srv fashions india private limited',
    'Myriad apparell private limited',
    'Marvin lifestyle india private limited',
    'Smart fincon private limited',
    'Krab media and marketing private limited',
    'Diamond pocket books private limited',
    'Pnc digital limited',
    'Kothari medical subscription services private limited',
    'Srinidhi comprint private limited',
    'Arihant colour scans private limited',
    'Creative communications private limited',
    'Kayen print process private limited',
    'Colour publications private limited',
    'Jaishree tie-up private limited',
    'SANSKRITI COMPOSITES PRIVATE LIMITED',
    'Shashvata distributors private limited',
    'Variety commercial private limited',
    'Lifeline vyapaar private limited',
    'Jasmine barter private limited',
    'Prashant distributors private limited',
    'Bajrangbali commodeal private limited',
    'Silicon global marketing private limited',
    'Mihir gems private limited',
    'Aristo vinimay private limited',
    'Fantastic vinimay private limited',
    'OTHER',
];
